/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 500);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(507);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(517)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(118));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(119));

var _contextTypes = _interopRequireDefault(__webpack_require__(540));

var _jss = __webpack_require__(315);

var ns = _interopRequireWildcard(__webpack_require__(314));

var _jssPreset = _interopRequireDefault(__webpack_require__(321));

var _mergeClasses = _interopRequireDefault(__webpack_require__(322));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(215));

var _themeListener = _interopRequireDefault(__webpack_require__(216));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(324));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(588));

var _getDisplayName = _interopRequireDefault(__webpack_require__(323));

var _getThemeProps = _interopRequireDefault(__webpack_require__(325));

// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any childs styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.


var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStyles).call(this, props, context));
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;
        _this.state = {};
        _this.jss = context[ns.jss] || jss;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends2.default)({
          generateClassName: generateClassName
        }, context[ns.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || getDefaultTheme() : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.
          var generate = false;

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);

            if (sheetsManagerTheme.sheet.classes !== this.cacheClasses.lastJSS) {
              this.cacheClasses.lastJSS = sheetsManagerTheme.sheet.classes;
              generate = true;
            }
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component,
              noBase: this.disableStylesGeneration
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new Map();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName.default)(Component);
              process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _extends2.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));
            sheetManagerTheme.sheet = sheet;
            sheet.attach();
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);
          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name,
            props: other
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme && !more.theme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends2.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithStyles.contextTypes = (0, _extends2.default)({
      muiThemeProviderOptions: _propTypes.default.object
    }, _contextTypes.default, listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

var _default = withStyles;
exports.default = _default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(53);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(630));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react.default.createElement(_SvgIcon.default, props, path);
  };

  Icon.displayName = "".concat(displayName, "Icon");
  Icon = (0, _pure.default)(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

;
var _default = createSvgIcon;
exports.default = _default;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return drawerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return drawerMiniWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return containerFluid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boxShadow; });
/* unused harmony export card */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return primaryColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return warningColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dangerColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return successColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return infoColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return roseColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return grayColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return primaryBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return infoBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return successBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return warningBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dangerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return roseBoxShadow; });
/* unused harmony export orangeCardHeader */
/* unused harmony export greenCardHeader */
/* unused harmony export redCardHeader */
/* unused harmony export blueCardHeader */
/* unused harmony export purpleCardHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return roseCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return warningCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return successCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dangerCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return infoCardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return primaryCardHeader; });
/* unused harmony export cardActions */
/* unused harmony export cardHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return defaultBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return tooltip; });
/* unused harmony export title */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cardTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cardSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cardLink; });
/*!

 =========================================================
 * Material Dashboard PRO React - v1.4.0 based on Material Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2018 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */// ##############################
// // // Variables - Styles that are used on more than one component
// #############################
var drawerWidth=260;var drawerMiniWidth=80;var transition={transition:"all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"};var containerFluid={paddingRight:"15px",paddingLeft:"15px",marginRight:"auto",marginLeft:"auto","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}};var container={paddingRight:"15px",paddingLeft:"15px",marginRight:"auto",marginLeft:"auto","@media (min-width: 768px)":{width:"750px"},"@media (min-width: 992px)":{width:"970px"},"@media (min-width: 1200px)":{width:"1170px"},"&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}};var boxShadow={boxShadow:"0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"};var card={display:"inline-block",position:"relative",width:"100%",margin:"25px 0",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff"};var defaultFont={fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',fontWeight:"300",lineHeight:"1.5em"};var primaryColor="#9c27b0";var warningColor="#ff9800";var dangerColor="#f44336";var successColor="#4caf50";var infoColor="#00acc1";var roseColor="#e91e63";var grayColor="#999999";var primaryBoxShadow={boxShadow:"0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2)"};var infoBoxShadow={boxShadow:"0 12px 20px -10px rgba(0, 188, 212, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2)"};var successBoxShadow={boxShadow:"0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2)"};var warningBoxShadow={boxShadow:"0 12px 20px -10px rgba(255, 152, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 152, 0, 0.2)"};var dangerBoxShadow={boxShadow:"0 12px 20px -10px rgba(244, 67, 54, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(244, 67, 54, 0.2)"};var roseBoxShadow={boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)"};// old card headers
var orangeCardHeader=Object.assign({background:"linear-gradient(60deg, #ffa726, #fb8c00)"},warningBoxShadow);var greenCardHeader=Object.assign({background:"linear-gradient(60deg, #66bb6a, #43a047)"},successBoxShadow);var redCardHeader=Object.assign({background:"linear-gradient(60deg, #ef5350, #e53935)"},dangerBoxShadow);var blueCardHeader=Object.assign({background:"linear-gradient(60deg, #26c6da, #00acc1)"},infoBoxShadow);var purpleCardHeader=Object.assign({background:"linear-gradient(60deg, #ab47bc, #8e24aa)"},primaryBoxShadow);// new card headers
var warningCardHeader=Object.assign({background:"linear-gradient(60deg, #ffa726, #fb8c00)"},warningBoxShadow);var successCardHeader=Object.assign({background:"linear-gradient(60deg, #66bb6a, #43a047)"},successBoxShadow);var dangerCardHeader=Object.assign({background:"linear-gradient(60deg, #ef5350, #e53935)"},dangerBoxShadow);var infoCardHeader=Object.assign({background:"linear-gradient(60deg, #26c6da, #00acc1)"},infoBoxShadow);var primaryCardHeader=Object.assign({background:"linear-gradient(60deg, #ab47bc, #8e24aa)"},primaryBoxShadow);var roseCardHeader=Object.assign({background:"linear-gradient(60deg, #ec407a, #d81b60)"},roseBoxShadow);var cardActions=Object.assign({margin:"0 20px 10px",paddingTop:"10px",borderTop:"1px solid #eeeeee",height:"auto"},defaultFont);var cardHeader={margin:"-20px 15px 0",borderRadius:"3px",padding:"15px"};var defaultBoxShadow={border:"0",borderRadius:"3px",boxShadow:"0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",padding:"10px 0",transition:"all 150ms ease 0s"};var tooltip={padding:"10px 15px",minWidth:"130px",color:"#FFFFFF",lineHeight:"1.7em",background:"rgba(85,85,85,0.9)",border:"none",borderRadius:"3px",opacity:"1!important",boxShadow:"0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",maxWidth:"200px",textAlign:"center",fontFamily:'"Helvetica Neue",Helvetica,Arial,sans-serif',fontSize:"12px",fontStyle:"normal",fontWeight:"400",textShadow:"none",textTransform:"none",letterSpacing:"normal",wordBreak:"normal",wordSpacing:"normal",wordWrap:"normal",whiteSpace:"normal",lineBreak:"auto"};var title={color:"#3C4858",textDecoration:"none",fontWeight:"300",marginTop:"30px",marginBottom:"25px",minHeight:"32px",fontFamily:"'Roboto', 'Helvetica', 'Arial', sans-serif","& small":{color:"#777",fontSize:"65%",fontWeight:"400",lineHeight:"1"}};var cardTitle=Object.assign({},title,{marginTop:"0",marginBottom:"3px",minHeight:"auto","& a":Object.assign({},title,{marginTop:".625rem",marginBottom:"0.75rem",minHeight:"auto"})});var cardSubtitle={marginTop:"-.375rem"};var cardLink={"& + $cardLink":{marginLeft:"1.25rem"}};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var style={grid:{margin:"0 -15px",width:"calc(100% + 30px)"// '&:before,&:after':{
//   display: 'table',
//   content: '" "',
// },
// '&:after':{
//   clear: 'both',
// }
}};function GridContainer(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,rest=_objectWithoutProperties(props,["classes","children","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,Object.assign({container:true},rest,{className:classes.grid+" "+className}),children);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridContainer));

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
var style={grid:{padding:"0 15px !important"}};function GridItem(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,rest=_objectWithoutProperties(props,["classes","children","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,Object.assign({item:true},rest,{className:classes.grid+" "+className}),children);}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(GridItem));

/***/ }),
/* 13 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(152);

var assertThisInitialized = __webpack_require__(63);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(538);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardStyle_jsx__ = __webpack_require__(651);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function Card(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,plain=props.plain,profile=props.profile,blog=props.blog,raised=props.raised,background=props.background,pricing=props.pricing,color=props.color,product=props.product,testimonial=props.testimonial,chart=props.chart,login=props.login,rest=_objectWithoutProperties(props,["classes","className","children","plain","profile","blog","raised","background","pricing","color","product","testimonial","chart","login"]);var cardClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.card,true),_defineProperty(_classNames,classes.cardPlain,plain),_defineProperty(_classNames,classes.cardProfile,profile||testimonial),_defineProperty(_classNames,classes.cardBlog,blog),_defineProperty(_classNames,classes.cardRaised,raised),_defineProperty(_classNames,classes.cardBackground,background),_defineProperty(_classNames,classes.cardPricingColor,pricing&&color!==undefined||pricing&&background!==undefined),_defineProperty(_classNames,classes[color],color),_defineProperty(_classNames,classes.cardPricing,pricing),_defineProperty(_classNames,classes.cardProduct,product),_defineProperty(_classNames,classes.cardChart,chart),_defineProperty(_classNames,classes.cardLogin,login),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardClasses},rest),children);}Card.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,blog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,raised:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger","rose"]),product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,chart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,login:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardStyle_jsx__["a" /* default */])(Card));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardBodyStyle_jsx__ = __webpack_require__(652);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardBody(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,background=props.background,plain=props.plain,formHorizontal=props.formHorizontal,pricing=props.pricing,signup=props.signup,color=props.color,profile=props.profile,calendar=props.calendar,rest=_objectWithoutProperties(props,["classes","className","children","background","plain","formHorizontal","pricing","signup","color","profile","calendar"]);var cardBodyClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardBody,true),_defineProperty(_classNames,classes.cardBodyBackground,background),_defineProperty(_classNames,classes.cardBodyPlain,plain),_defineProperty(_classNames,classes.cardBodyFormHorizontal,formHorizontal),_defineProperty(_classNames,classes.cardPricing,pricing),_defineProperty(_classNames,classes.cardSignup,signup),_defineProperty(_classNames,classes.cardBodyColor,color),_defineProperty(_classNames,classes.cardBodyProfile,profile),_defineProperty(_classNames,classes.cardBodyCalendar,calendar),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardBodyClasses},rest),children);}CardBody.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,background:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,formHorizontal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,signup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,calendar:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardBodyStyle_jsx__["a" /* default */])(CardBody));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(162);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// material-ui components
function RegularButton(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,color=props.color,round=props.round,children=props.children,fullWidth=props.fullWidth,disabled=props.disabled,simple=props.simple,size=props.size,block=props.block,link=props.link,justIcon=props.justIcon,className=props.className,muiClasses=props.muiClasses,rest=_objectWithoutProperties(props,["classes","color","round","children","fullWidth","disabled","simple","size","block","link","justIcon","className","muiClasses"]);var btnClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.button,true),_defineProperty(_classNames,classes[size],size),_defineProperty(_classNames,classes[color],color),_defineProperty(_classNames,classes.round,round),_defineProperty(_classNames,classes.fullWidth,fullWidth),_defineProperty(_classNames,classes.disabled,disabled),_defineProperty(_classNames,classes.simple,simple),_defineProperty(_classNames,classes.block,block),_defineProperty(_classNames,classes.link,link),_defineProperty(_classNames,classes.justIcon,justIcon),_defineProperty(_classNames,className,className),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,Object.assign({},rest,{classes:muiClasses,className:btnClasses}),children);}RegularButton.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger","rose","white","twitter","facebook","google","linkedin","pinterest","youtube","tumblr","github","behance","dribbble","reddit","transparent"]),size:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["sm","lg"]),simple:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,round:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fullWidth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,block:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,link:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,justIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,muiClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */])(RegularButton));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(508);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 22 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(152));

var _warning = _interopRequireDefault(__webpack_require__(17));

function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardHeaderStyle_jsx__ = __webpack_require__(653);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardHeader(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,plain=props.plain,image=props.image,contact=props.contact,signup=props.signup,stats=props.stats,icon=props.icon,text=props.text,rest=_objectWithoutProperties(props,["classes","className","children","color","plain","image","contact","signup","stats","icon","text"]);var cardHeaderClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardHeader,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,classes.cardHeaderPlain,plain),_defineProperty(_classNames,classes.cardHeaderImage,image),_defineProperty(_classNames,classes.cardHeaderContact,contact),_defineProperty(_classNames,classes.cardHeaderSignup,signup),_defineProperty(_classNames,classes.cardHeaderStats,stats),_defineProperty(_classNames,classes.cardHeaderIcon,icon),_defineProperty(_classNames,classes.cardHeaderText,text),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardHeaderClasses},rest),children);}CardHeader.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"]),plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,contact:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,signup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,stats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardHeaderStyle_jsx__["a" /* default */])(CardHeader));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(917), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(419);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(420);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(945);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(949);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(420);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _dateArithmetic = _interopRequireDefault(__webpack_require__(1110));

/* eslint no-fallthrough: off */
var MILLI = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
  day: 1000 * 60 * 60 * 24
};
var MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
var dates = (0, _extends2.default)({}, _dateArithmetic.default, {
  monthsInYear: function monthsInYear(year) {
    var date = new Date(year, 0, 1);
    return MONTHS.map(function (i) {
      return dates.month(date, i);
    });
  },
  firstVisibleDay: function firstVisibleDay(date, localizer) {
    var firstOfMonth = dates.startOf(date, 'month');
    return dates.startOf(firstOfMonth, 'week', localizer.startOfWeek());
  },
  lastVisibleDay: function lastVisibleDay(date, localizer) {
    var endOfMonth = dates.endOf(date, 'month');
    return dates.endOf(endOfMonth, 'week', localizer.startOfWeek());
  },
  visibleDays: function visibleDays(date, localizer) {
    var current = dates.firstVisibleDay(date, localizer),
        last = dates.lastVisibleDay(date, localizer),
        days = [];

    while (dates.lte(current, last, 'day')) {
      days.push(current);
      current = dates.add(current, 1, 'day');
    }

    return days;
  },
  ceil: function ceil(date, unit) {
    var floor = dates.startOf(date, unit);
    return dates.eq(floor, date) ? floor : dates.add(floor, 1, unit);
  },
  range: function range(start, end, unit) {
    if (unit === void 0) {
      unit = 'day';
    }

    var current = start,
        days = [];

    while (dates.lte(current, end, unit)) {
      days.push(current);
      current = dates.add(current, 1, unit);
    }

    return days;
  },
  merge: function merge(date, time) {
    if (time == null && date == null) return null;
    if (time == null) time = new Date();
    if (date == null) date = new Date();
    date = dates.startOf(date, 'day');
    date = dates.hours(date, dates.hours(time));
    date = dates.minutes(date, dates.minutes(time));
    date = dates.seconds(date, dates.seconds(time));
    return dates.milliseconds(date, dates.milliseconds(time));
  },
  eqTime: function eqTime(dateA, dateB) {
    return dates.hours(dateA) === dates.hours(dateB) && dates.minutes(dateA) === dates.minutes(dateB) && dates.seconds(dateA) === dates.seconds(dateB);
  },
  isJustDate: function isJustDate(date) {
    return dates.hours(date) === 0 && dates.minutes(date) === 0 && dates.seconds(date) === 0 && dates.milliseconds(date) === 0;
  },
  duration: function duration(start, end, unit, firstOfWeek) {
    if (unit === 'day') unit = 'date';
    return Math.abs(dates[unit](start, undefined, firstOfWeek) - dates[unit](end, undefined, firstOfWeek));
  },
  diff: function diff(dateA, dateB, unit) {
    if (!unit || unit === 'milliseconds') return Math.abs(+dateA - +dateB); // the .round() handles an edge case
    // with DST where the total won't be exact
    // since one day in the range may be shorter/longer by an hour

    return Math.round(Math.abs(+dates.startOf(dateA, unit) / MILLI[unit] - +dates.startOf(dateB, unit) / MILLI[unit]));
  },
  total: function total(date, unit) {
    var ms = date.getTime(),
        div = 1;

    switch (unit) {
      case 'week':
        div *= 7;

      case 'day':
        div *= 24;

      case 'hours':
        div *= 60;

      case 'minutes':
        div *= 60;

      case 'seconds':
        div *= 1000;
    }

    return ms / div;
  },
  week: function week(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    return Math.ceil(((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
  },
  today: function today() {
    return dates.startOf(new Date(), 'day');
  },
  yesterday: function yesterday() {
    return dates.add(dates.startOf(new Date(), 'day'), -1, 'day');
  },
  tomorrow: function tomorrow() {
    return dates.add(dates.startOf(new Date(), 'day'), 1, 'day');
  }
});
var _default = dates;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });






/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(419);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_components_customInputStyle_jsx__ = __webpack_require__(650);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library to set properties for components
// nodejs library that concatenates classes
// @material-ui/core components
function CustomInput(_ref){var _classNames,_classNames2,_classNames4,_classNames5;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,formControlProps=props.formControlProps,labelText=props.labelText,id=props.id,labelProps=props.labelProps,inputProps=props.inputProps,error=props.error,white=props.white,inputRootCustomClasses=props.inputRootCustomClasses,success=props.success,helpText=props.helpText;var labelClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames={},_defineProperty(_classNames," "+classes.labelRootError,error),_defineProperty(_classNames," "+classes.labelRootSuccess,success&&!error),_classNames));var underlineClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames2={},_defineProperty(_classNames2,classes.underlineError,error),_defineProperty(_classNames2,classes.underlineSuccess,success&&!error),_defineProperty(_classNames2,classes.underline,true),_defineProperty(_classNames2,classes.whiteUnderline,white),_classNames2));var marginTop=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},inputRootCustomClasses,inputRootCustomClasses!==undefined));var inputClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames4={},_defineProperty(_classNames4,classes.input,true),_defineProperty(_classNames4,classes.whiteInput,white),_classNames4));var formControlClasses;if(formControlProps!==undefined){formControlClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(formControlProps.className,classes.formControl);}else{formControlClasses=classes.formControl;}var helpTextClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames5={},_defineProperty(_classNames5,classes.labelRootError,error),_defineProperty(_classNames5,classes.labelRootSuccess,success&&!error),_classNames5));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,Object.assign({},formControlProps,{className:formControlClasses}),labelText!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputLabel___default.a,Object.assign({className:classes.labelRoot+" "+labelClasses,htmlFor:id},labelProps),labelText):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input___default.a,Object.assign({classes:{input:inputClasses,root:marginTop,disabled:classes.disabled,underline:underlineClasses},id:id},inputProps)),helpText!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormHelperText___default.a,{id:id+"-text",className:helpTextClasses},helpText):null);}CustomInput.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,labelText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,labelProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,inputProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,formControlProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,inputRootCustomClasses:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,white:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,helpText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_8_assets_jss_material_dashboard_pro_react_components_customInputStyle_jsx__["a" /* default */])(CustomInput));

/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(187)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(139)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(996)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(1058)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(1060)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(1066)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(431);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(366);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(228)('wks');
var uid = __webpack_require__(131);
var Symbol = __webpack_require__(59).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardIconStyle_jsx__ = __webpack_require__(762);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardIcon(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,rest=_objectWithoutProperties(props,["classes","className","children","color"]);var cardIconClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardIcon,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardIconClasses},rest),children);}CardIcon.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardIconStyle_jsx__["a" /* default */])(CardIcon));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Close');

exports.default = _default;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Email');

exports.default = _default;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSmtp */
/* unused harmony export getApiKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getInitialData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setApiKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addCampaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removeCampaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setSMTP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeSMTP; });
/* unused harmony export getEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return logoutUser; });
/* unused harmony export addLead */
/* unused harmony export addGrade */
/* unused harmony export removeGrade */
/* unused harmony export addChapter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addLeadsToCampaign; });
/* unused harmony export setGoal */
/* unused harmony export addError */
/* unused harmony export removeError */
/* unused harmony export clearSuggestions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSuggestions; });
/* unused harmony export geoCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return stopSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return searchLeads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearLeads; });
/* unused harmony export randomGoals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(169);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// const API_KEY = process.env.REACT_APP_api_key;
var BASE_URL=// "https://pushbuttonbusinesslist.com/api";
// "http://localhost/projects/Gus/bussinesslistdirect_api";
"http://api.trivajleads.com";var getCampaigns=function getCampaigns(email){return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/getCampaigns.php",{params:{email:email}});};var deleteCampaign=function deleteCampaign(id,email){return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/deleteCampaign.php",{params:{id:id,email:email}});};var getLeads=function getLeads(email){return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/getLeads.php",{params:{email:email}});};var getSmtp=function getSmtp(){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/getSmtp.php",{params:{email:email}});};var getApiKey=function getApiKey(){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/getApiKey.php",{params:{email:email}});};var getInitialData=function getInitialData(){return function(dispatch){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;getCampaigns(email).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_CAMPAIGN,payload:response.data.campaigns});}).then(getLeads(email).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_LEADS,payload:response.data.leads});})).then(getSmtp().then(function(response){if(response.data.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_SMTP,payload:response.data.config});}})).then(getApiKey().then(function(response){if(response.data.success){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_API_KEY,payload:response.data.key});}}));};};var setApiKey=function setApiKey(key){return function(dispatch){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/setApiKey.php",{params:{user_email:email,key:key}}).then(function(response){console.log(response.data);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_API_KEY,payload:key});}).catch(function(error){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_ERROR,payload:error.message});});};};var addCampaign=function addCampaign(name){return function(dispatch){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/addCampaign.php",{params:{name:name,email:email}}).then(function(response){console.log(response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_CAMPAIGN,payload:response.data.campaigns});}).catch(function(error){return console.error(error);});};};var removeCampaign=function removeCampaign(id){return function(dispatch){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;deleteCampaign(id,email).then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_CAMPAIGN,payload:id});getLeads(email).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_LEADS,payload:response.data.leads});});});};};var setSMTP=function setSMTP(email,host,port,username,password,encryption){return function(dispatch){var user_email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL+"/setSmtp.php",{params:{email:email,host:host,port:port,username:username,password:password,encryption:encryption,user_email:user_email}}).then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_SMTP,payload:{email:email,host:host,port:port,username:username,password:password,encryption:encryption}});});};};var removeSMTP=function removeSMTP(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_SMTP};};var searchEmail=function searchEmail(website,id){return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("http://localhost/Trivaj-Business-Data-BE/searchEmail.php",{params:{website:website,id:id}}).then(function(response){console.log("website",response.data.website,"email",response.data.email);return response.data;}).catch(function(error){return error;});};var getEmail=function getEmail(){return function(dispatch,getState){var promises=[];getState().tempLeads.forEach(function(lead){promises.push(searchEmail(lead.website,lead.id));});Promise.all(promises).then(function(){});};};var loginUser=function loginUser(user){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].LOGIN_USER,payload:user});};};var logoutUser=function logoutUser(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().signOut().then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].LOGOUT_USER});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].USER_LOGOUT});});};};var addLead=function addLead(name,email){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_LEAD,payload:{name:name,email:email}};};var addGrade=function addGrade(img,title,description){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_GRADE,payload:{img:img,title:title,description:description}};};var removeGrade=function removeGrade(index){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_GRADE,payload:index};};var addChapter=function addChapter(grade,subject,name,value){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_CHAPTER,payload:{grade:grade,subject:subject,name:name,value:value}};};var addLeadsToCampaign=function addLeadsToCampaign(campaignId){return function(dispatch,getState){var email=__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email;var tempLeads=getState().tempLeads;__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(BASE_URL+"/insertLeads.php",{tempLeads:tempLeads,campaignId:campaignId,email:email}).then(function(){getLeads(email).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_LEADS,payload:response.data.leads});});});};};var setGoal=function setGoal(goal){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_GOAL,payload:goal};};var addError=function addError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_ERROR,payload:error};};var removeError=function removeError(errorIndex){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_ERROR,payload:errorIndex};};var clearSuggestions=function clearSuggestions(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_SUGGESTIONS};};var changeSuggestions=function changeSuggestions(keyword){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://us-central1-friendly-chat-66468.cloudfunctions.net/api/autocomplete",{params:{query:keyword}}).then(function(response){var suggestionArray=[];response.data.forEach(function(element){suggestionArray=[].concat(_toConsumableArray(suggestionArray),[element]);});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CHANGE_SUGGESTIONS,payload:suggestionArray});}).catch(function(error){addError(error.message);});};};var geoCode=function geoCode(address,apiKey){return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://maps.googleapis.com/maps/api/geocode/json?",{params:{address:address,key:apiKey}}).then(function(response){return response.data.results;}).catch(function(error){return error;});};var stopSearch=function stopSearch(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CANCEL_FETCHING};};var searchLeads=function searchLeads(keyword,place){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].FETCH_LEADS});geoCode(place,getState().apiKey).then(function(results){console.log(place);console.log(results);var location=results[0].geometry.location;return location.lat+","+location.lng;}).then(function(location){if(getState().fetching===false){throw new Error("I meant to blow up here.");}__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(//"http://localhost/businesslistdirect/search.php",
BASE_URL+"/search.php",{params:{location:location,radius:"20000",keyword:keyword,key:getState().apiKey}}).then(function(response){console.log(response);if(getState().fetching===false){throw new Error("I meant to blow up here.");}var promises=[];response.data.results.forEach(function(data){promises.push(searchEmail(data.result.website,data.result.id));});Promise.all(promises).then(function(results){response.data.results.forEach(function(data){var r=results.find(function(element){return element.website===data.result.website;});var email="";if(r!==undefined){email=r.email;}var payload=data.result;payload=Object.assign({},payload,{email:email});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_TEMP_LEAD,payload:payload});});dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CANCEL_FETCHING});}).catch(function(error){console.log(error);addError(error.message);}).catch(function(error){console.log(error);addError(error.message);});}).catch(function(error){console.log(error);addError(error.message);});}).catch(function(error){console.log(error);addError(error.message);});};};var clearLeads=function clearLeads(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_TEMP_LEADS};};var randomGoals=function randomGoals(){return function(dispatch,getState){if(!getState().resortNames.fetching){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].FETCH_RESORT_NAMES});setTimeout(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CANCEL_FETCHING});},1500);}};};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(260)('wks');
var uid = __webpack_require__(184);
var Symbol = __webpack_require__(71).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.views = exports.navigate = void 0;
var navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};
exports.navigate = navigate;
var views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda'
};
exports.views = views;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports.default = _default;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(635));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(__webpack_require__(638));

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardFooterStyle_jsx__ = __webpack_require__(654);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardFooter(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,plain=props.plain,profile=props.profile,pricing=props.pricing,testimonial=props.testimonial,stats=props.stats,chart=props.chart,product=props.product,rest=_objectWithoutProperties(props,["classes","className","children","plain","profile","pricing","testimonial","stats","chart","product"]);var cardFooterClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardFooter,true),_defineProperty(_classNames,classes.cardFooterPlain,plain),_defineProperty(_classNames,classes.cardFooterProfile,profile||testimonial),_defineProperty(_classNames,classes.cardFooterPricing,pricing),_defineProperty(_classNames,classes.cardFooterTestimonial,testimonial),_defineProperty(_classNames,classes.cardFooterStats,stats),_defineProperty(_classNames,classes.cardFooterChart,chart||product),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardFooterClasses},rest),children);}CardFooter.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,pricing:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,stats:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,chart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardFooterStyle_jsx__["a" /* default */])(CardFooter));

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = {
	overlay: {
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		position: 'fixed',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		zIndex: 5000
	},
	sweetAlert: {
		backgroundColor: '#fff',
		outline: 'none',
		width: 478,
		padding: 17,
		borderRadius: 5,
		textAlign: 'center',
		position: 'fixed',
		left: '50%',
		top: '50%',
		marginLeft: -256,
		marginTop: -200,
		overflow: 'hidden',
		zIndex: 5500,
		animation: 'showSweetAlert 0.3s'
	},
	sweetAlertMobile: {
		width: 'auto',
		marginLeft: 0,
		marginRight: 0,
		left: 15,
		right: 15
	},
	icon: {
		width: 80,
		height: 80,
		borderWidth: 4,
		borderStyle: 'solid',
		borderColor: 'gray',
		borderRadius: '50%',
		margin: '20px auto',
		position: 'relative',
		boxSizing: 'content-box'
	},
	iconError: {
		borderColor: '#d43f3a',
		animation: 'animateErrorIcon 0.5s'
	},
	iconErrorX: {
		position: 'relative',
		display: 'block',
		animation: 'animateXMark 0.5s'
	},
	iconErrorLine: {
		position: 'absolute',
		height: 5,
		width: 47,
		backgroundColor: '#d9534f',
		display: 'block',
		top: 37,
		borderRadius: 2
	},
	iconErrorLineLeft: {
		transform: 'rotate(45deg)',
		left: 17
	},
	iconErrorLineRight: {
		transform: 'rotate(-45deg)',
		right: 16
	},
	iconWarning: {
		borderColor: '#eea236',
		animation: 'pulseWarning 0.75s infinite alternate'
	},
	iconWarningBody: {
		position: 'absolute',
		width: 5,
		height: 47,
		left: '50%',
		top: 10,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconWarningDot: {
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		bottom: 10,
		backgroundColor: '#f0ad4e',
		animation: 'pulseWarningIns 0.75s infinite alternate'
	},
	iconInfo: {
		borderColor: '#46b8da'
	},
	iconInfoBefore: {
		content: "",
		position: 'absolute',
		width: 5,
		height: 29,
		left: '50%',
		bottom: 17,
		borderRadius: 2,
		marginLeft: -2,
		backgroundColor: '#5bc0de'
	},
	iconInfoAfter: {
		content: "",
		position: 'absolute',
		width: 7,
		height: 7,
		borderRadius: '50%',
		marginLeft: -3,
		left: '50%',
		top: 19,
		backgroundColor: '#5bc0de'
	},
	iconSuccess: {
		borderColor: '#4cae4c'
	},
	iconSuccessBeforeAfter: {
		content: '',
		borderRadius: '50%',
		position: 'absolute',
		width: 60,
		height: 120,
		background: 'white',
		transform: 'rotate(45deg)'
	},
	iconSuccessBefore: {
		borderRadius: '120px 0 0 120px',
		height: 100,
		top: -7,
		left: -33,
		transform: 'rotate(-45deg)',
		transformOrigin: '60px 60px'
	},
	iconSuccessAfter: {
		borderRadius: '0 120px 120px 0',
		top: -11,
		left: 30,
		transform: 'rotate(-45deg)',
		transformOrigin: '0px 60px',
		animation: 'rotatePlaceholder 4.25s ease-in'
	},
	iconSuccessPlaceholder: {
		width: 80,
		height: 80,
		border: '4px solid rgba(92, 184, 92, 0.2)',
		borderRadius: '50%',
		boxSizing: 'content-box',
		position: 'absolute',
		left: -4,
		top: -4,
		zIndex: 2
	},
	iconSuccessFix: {
		width: 5,
		height: 90,
		backgroundColor: '#fff',
		position: 'absolute',
		left: 28,
		top: 8,
		zIndex: 1,
		transform: 'rotate(-45deg)'
	},
	iconSuccessLine: {
		height: 5,
		backgroundColor: '#5cb85c',
		display: 'block',
		borderRadius: 2,
		position: 'absolute',
		zIndex: 2
	},
	iconSuccessLineTip: {
		width: 25,
		left: 14,
		top: 46,
		transform: 'rotate(45deg)',
		animation: 'animateSuccessTip 0.75s'
	},
	iconSuccessLineLong: {
		width: 47,
		right: 8,
		top: 38,
		transform: 'rotate(-45deg)',
		animation: 'animateSuccessLong 0.75s'
	},
	iconCustom: {
		backgroundSize: 'contain',
		borderRadius: 0,
		border: 'none',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat'
	},
	button: {
		marginRight: 8
	},
	validationMessage: {
		display: 'block',
		backgroundColor: '#f1f1f1',
	    marginLeft: -17,
	    marginRight: -17,
	    marginTop: 20,
	    overflow: 'hidden',
	    padding: 10,
	    maxHeight: 100,
	    transition: 'padding 0.25s, max-height 0.25s',
	    color: '#797979',
	    fontSize: 16,
	    textAlign: 'center',
	    fontWeight: 300
	},
	exclamationIcon: {
		display: 'inline-block',
	    width: 24,
	    height: 24,
	    borderRadius: '50%',
	    backgroundColor: '#ea7d7d',
	    color: 'white',
	    lineHeight: '24px',
	    textAlign: 'center',
	    marginRight: 5
	},
	inputErrorIcon: {
		position: 'absolute',
	    top: 8,
	    right: 8,
	    width: 20,
	    height: 20,
	    opacity: 0,
	    transform: 'scale(0.5)',
	    transformOrigin: '50% 50%',
	    transition: 'all 0.1s',
	    opacity: 1,
	    transform: 'scale(1)'
	},
	inputErrorIconBeforeAfter: {
		content: "",
	    width: 20,
	    height: 6,
	    backgroundColor: '#f06e57',
	    borderRadius: 3,
	    position: 'absolute',
	    top: '50%',
	    marginTop: -4,
	    left: '50%',
	    marginLeft: -9
	},
	inputErrorIconBefore: {
		transform: 'rotate(-45deg)'
	},
	inputErrorIconAfter: {
		transform: 'rotate(45deg)'
	}
};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(516);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(519);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(520);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(524);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(310);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(528);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(532);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(533);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(534);
/* unused harmony reexport withRouter */





























/***/ }),
/* 63 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(591));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(13));
var _createClass = _interopDefault(__webpack_require__(10));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(14));
var _getPrototypeOf = _interopDefault(__webpack_require__(15));
var _inherits = _interopDefault(__webpack_require__(16));
var _typeof = _interopDefault(__webpack_require__(152));
var _objectWithoutProperties = _interopDefault(__webpack_require__(6));
var _extends = _interopDefault(__webpack_require__(5));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(2));
var warning = _interopDefault(__webpack_require__(17));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.setRef = setRef;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(4));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(639));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(794));

var _shallowEqual = _interopRequireDefault(__webpack_require__(796));

var _setDisplayName = _interopRequireDefault(__webpack_require__(395));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(119));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_headingStyle_jsx__ = __webpack_require__(810);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Heading(_ref){var props=_objectWithoutProperties(_ref,[]);var textAlign=props.textAlign,category=props.category,title=props.title,classes=props.classes;var heading=classes.heading+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({},classes[textAlign+"TextAlign"],textAlign!==undefined));if(title!==undefined||category!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:heading},title!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.title},title):null,category!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.category},category):null);}return null;}Heading.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,category:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,textAlign:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["right","left","center"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_headingStyle_jsx__["a" /* default */])(Heading));

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var core = __webpack_require__(44);
var ctx = __webpack_require__(261);
var hide = __webpack_require__(105);
var has = __webpack_require__(85);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(106);
var IE8_DOM_DEFINE = __webpack_require__(417);
var toPrimitive = __webpack_require__(262);
var dP = Object.defineProperty;

exports.f = __webpack_require__(86) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(117);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(17));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(17));

/* eslint-disable no-param-reassign */

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
     false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(__webpack_require__(643));

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var core = __webpack_require__(60);
var hide = __webpack_require__(79);
var redefine = __webpack_require__(130);
var ctx = __webpack_require__(350);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(97);
var createDesc = __webpack_require__(165);
module.exports = __webpack_require__(98) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(__webpack_require__(747));

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Typography styles
// #############################
var typographyStyle={defaultFontStyle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{fontSize:"14px"}),defaultHeaderMargins:{marginTop:"20px",marginBottom:"10px"},quote:{padding:"10px 20px",margin:"0 0 20px",fontSize:"17.5px",borderLeft:"5px solid #eee"},quoteText:{margin:"0 0 10px",fontStyle:"italic"},quoteAuthor:{display:"block",fontSize:"80%",lineHeight:"1.42857143",color:"#777"},mutedText:{color:"#777"},primaryText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},infoText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]},successText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},warningText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]},dangerText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]}};/* harmony default export */ __webpack_exports__["a"] = (typographyStyle);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var customCheckboxRadioSwitch={checkRoot:{padding:"14px"},radioRoot:{padding:"16px"},checkboxAndRadio:{position:"relative",display:"block",marginTop:"10px",marginBottom:"10px"},checkboxAndRadioHorizontal:{position:"relative",display:"block","&:first-child":{marginTop:"10px"},"&:not(:first-child)":{marginTop:"-14px"},marginTop:"0",marginBottom:"0"},checked:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]+"!important"},checkedIcon:{width:"20px",height:"20px",border:"1px solid rgba(0, 0, 0, .54)",borderRadius:"3px"},uncheckedIcon:{width:"0px",height:"0px",padding:"9px",border:"1px solid rgba(0, 0, 0, .54)",borderRadius:"3px"},disabledCheckboxAndRadio:{"& $checkedIcon,& $uncheckedIcon,& $radioChecked,& $radioUnchecked":{borderColor:"#000000",opacity:"0.26",color:"#000000"}},label:{cursor:"pointer",paddingLeft:"0",color:"#AAAAAA",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",display:"inline-flex",transition:"0.3s ease all"},labelHorizontal:{color:"rgba(0, 0, 0, 0.26)",cursor:"pointer",display:"inline-flex",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",paddingTop:"39px",marginRight:"0","@media (min-width: 992px)":{float:"right"}},labelHorizontalRadioCheckbox:{paddingTop:"22px"},labelLeftHorizontal:{color:"rgba(0, 0, 0, 0.26)",cursor:"pointer",display:"inline-flex",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",paddingTop:"22px",marginRight:"0"},labelError:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]},radio:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]+"!important"},radioChecked:{width:"16px",height:"16px",border:"1px solid "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],borderRadius:"50%"},radioUnchecked:{width:"0px",height:"0px",padding:"7px",border:"1px solid rgba(0, 0, 0, .54)",borderRadius:"50%"},inlineChecks:{marginTop:"8px"},iconCheckbox:{height:"116px",width:"116px",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],padding:"0",margin:"0 auto 20px","& > span:first-child":{borderWidth:"4px",borderStyle:"solid",borderColor:"#CCCCCC",textAlign:"center",verticalAlign:"middle",borderRadius:"50%",color:"inherit",transition:"all 0.2s"},"&:hover":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],"& > span:first-child":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]}}},iconCheckboxChecked:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],"& > span:first-child":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]}},iconCheckboxIcon:{fontSize:"40px",lineHeight:"111px"},switchBase:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]+"!important"},switchIcon:{boxShadow:"0 1px 3px 1px rgba(0, 0, 0, 0.4)",color:"#FFFFFF !important",border:"1px solid rgba(0, 0, 0, .54)",transform:"translateX(-4px)!important"},switchIconChecked:{borderColor:"#9c27b0",transform:"translateX(0px)!important"},switchBar:{width:"30px",height:"15px",backgroundColor:"rgb(80, 80, 80)",borderRadius:"15px",opacity:"0.7!important"},switchChecked:{"& + $switchBar":{backgroundColor:"rgba(156, 39, 176, 1) !important"}}};/* harmony default export */ __webpack_exports__["a"] = (customCheckboxRadioSwitch);

/***/ }),
/* 85 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(108)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(954),
    getValue = __webpack_require__(959);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(88);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(211);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(153);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(118));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(119));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(215));

var _themeListener = _interopRequireDefault(__webpack_require__(216));

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
        _this.unsubscribeId = null;
        _this.state = {};
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

    WithTheme.propTypes =  false ? {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

var _default = withTheme;
exports.default = _default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(__webpack_require__(617));

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(__webpack_require__(642));

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formControlState = formControlState;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _reactHelpers = __webpack_require__(66);

var _Textarea = _interopRequireDefault(__webpack_require__(645));

var _utils = __webpack_require__(221);

/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    /* Styles applied to the root element. */
    root: {
      // Mimics the default input display property used by browsers for an input.
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px")
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE11 width issue
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {}
  };
};

exports.styles = styles;

function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      context = _ref.context;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (context && context.muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = context.muiFormControl[state];
      }
    }

    return acc;
  }, {});
}
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */


var InputBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(InputBase, _React$Component);

  // Holds the input reference
  function InputBase(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, InputBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InputBase).call(this, props, context));
    _this.isControlled = null;
    _this.input = null;
    _this.state = {
      focused: false
    };

    _this.handleFocus = function (event) {
      // Fix a bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState({
        props: _this.props,
        context: _this.context,
        states: ['disabled']
      }).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleChange = function () {
      if (!_this.isControlled) {
        _this.checkDirty(_this.inputRef);
      } // Perform in the willUpdate


      if (_this.props.onChange) {
        var _this$props;

        (_this$props = _this.props).onChange.apply(_this$props, arguments);
      }
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      var refProp;

      if (_this.props.inputRef) {
        refProp = _this.props.inputRef;
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        refProp = _this.props.inputProps.ref;
      }

      (0, _reactHelpers.setRef)(refProp, ref);
    };

    _this.handleClick = function (event) {
      if (_this.inputRef && event.currentTarget === event.target) {
        _this.inputRef.focus();
      }

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    };

    _this.isControlled = props.value != null;

    if (_this.isControlled) {
      _this.checkDirty(props);
    }

    var componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState({
        props: _this.props,
        context: _this.context,
        states: ['disabled']
      }).disabled && formControlState({
        props: nextProps,
        context: nextContext,
        states: ['disabled']
      }).disabled) {
        _this.setState({
          focused: false
        });
      }
    };

    var componentWillUpdate = function componentWillUpdate(nextProps, nextState, nextContext) {
      // Book keep the focused state.
      if (!formControlState({
        props: _this.props,
        context: _this.context,
        states: ['disabled']
      }).disabled && formControlState({
        props: nextProps,
        context: nextContext,
        states: ['disabled']
      }).disabled) {
        var muiFormControl = _this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    };
    /* eslint-disable no-underscore-dangle */


    _this.componentWillReceiveProps = componentWillReceiveProps;
    _this.componentWillReceiveProps.__suppressDeprecationWarning = true;
    _this.componentWillUpdate = componentWillUpdate;
    _this.componentWillUpdate.__suppressDeprecationWarning = true;
    /* eslint-enable no-underscore-dangle */

    return _this;
  }

  (0, _createClass2.default)(InputBase, [{
    key: "getChildContext",
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.isControlled) {
        this.checkDirty(this.props);
      } // else performed in the onChange

    }
  }, {
    key: "checkDirty",
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;

      if ((0, _utils.isFilled)(obj)) {
        if (muiFormControl && muiFormControl.onFilled) {
          muiFormControl.onFilled();
        }

        if (this.props.onFilled) {
          this.props.onFilled();
        }

        return;
      }

      if (muiFormControl && muiFormControl.onEmpty) {
        muiFormControl.onEmpty();
      }

      if (this.props.onEmpty) {
        this.props.onEmpty();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props2 = this.props,
          autoComplete = _this$props2.autoComplete,
          autoFocus = _this$props2.autoFocus,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          defaultValue = _this$props2.defaultValue,
          disabled = _this$props2.disabled,
          endAdornment = _this$props2.endAdornment,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          id = _this$props2.id,
          inputComponent = _this$props2.inputComponent,
          _this$props2$inputPro = _this$props2.inputProps;
      _this$props2$inputPro = _this$props2$inputPro === void 0 ? {} : _this$props2$inputPro;
      var inputPropsClassName = _this$props2$inputPro.className,
          inputPropsProp = (0, _objectWithoutProperties2.default)(_this$props2$inputPro, ["className"]),
          inputRef = _this$props2.inputRef,
          margin = _this$props2.margin,
          multiline = _this$props2.multiline,
          name = _this$props2.name,
          onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          onEmpty = _this$props2.onEmpty,
          onFilled = _this$props2.onFilled,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          placeholder = _this$props2.placeholder,
          readOnly = _this$props2.readOnly,
          renderPrefix = _this$props2.renderPrefix,
          rows = _this$props2.rows,
          rowsMax = _this$props2.rowsMax,
          startAdornment = _this$props2.startAdornment,
          type = _this$props2.type,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderPrefix", "rows", "rowsMax", "startAdornment", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;
      var fcs = formControlState({
        props: this.props,
        context: this.context,
        states: ['disabled', 'error', 'margin', 'required', 'filled']
      });
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.adornedStart, startAdornment), (0, _defineProperty2.default)(_classNames, classes.adornedEnd, endAdornment), _classNames), classNameProp);
      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedStart, startAdornment), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedEnd, endAdornment), _classNames2), inputPropsClassName);
      var InputComponent = inputComponent;
      var inputProps = (0, _extends2.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (typeof InputComponent !== 'string') {
        inputProps = (0, _extends2.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput,
          type: type
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends2.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea.default;
        }
      } else {
        inputProps = (0, _extends2.default)({
          type: type
        }, inputProps);
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className,
        onClick: this.handleClick
      }, other), renderPrefix ? renderPrefix((0, _extends2.default)({}, fcs, {
        startAdornment: startAdornment,
        focused: this.state.focused
      })) : null, startAdornment, _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-invalid": fcs.error,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: inputClassName,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value
      }, inputProps)), endAdornment);
    }
  }]);
  return InputBase;
}(_react.default.Component);

InputBase.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onEmpty: _propTypes.default.func,

  /**
   * @ignore
   */
  onFilled: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * @ignore
   */
  renderPrefix: _propTypes.default.func,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
InputBase.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
InputBase.contextTypes = {
  muiFormControl: _propTypes.default.object
};
InputBase.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputBase'
})(InputBase);

exports.default = _default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(655);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(164);
var IE8_DOM_DEFINE = __webpack_require__(348);
var toPrimitive = __webpack_require__(224);
var dP = Object.defineProperty;

exports.f = __webpack_require__(98) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(129)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(225);
var defined = __webpack_require__(132);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
})), 'Check');

exports.default = _default;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});

var _Checkbox = _interopRequireDefault(__webpack_require__(842));

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(852);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var customSelectStyle={select:{padding:"12px 0 7px",fontSize:".75rem",fontWeight:"400",lineHeight:"1.42857",textDecoration:"none",textTransform:"uppercase",color:"#3C4858",letterSpacing:"0","&:focus":{backgroundColor:"transparent"},"&[aria-owns] + input + svg":{transform:"rotate(180deg)"},"& + input + svg":{transition:"all 300ms linear"}},selectFormControl:{margin:"10px 1px 10px 0px !important","& > div":{"&:before":{borderBottomWidth:"1px !important",borderBottomColor:"#D2D2D2 !important"},"&:after":{borderBottomColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]+"!important"}}},selectLabel:{fontSize:"12px",textTransform:"uppercase",color:"#3C4858 !important",top:"8px"},selectMenu:{"& > div > ul":{border:"0",padding:"5px 0",margin:"0",boxShadow:"none",minWidth:"100%",borderRadius:"4px",boxSizing:"border-box",display:"block",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"#fff",backgroundClip:"padding-box"},"& $selectPaper $selectMenuItemSelectedMultiple":{backgroundColor:"inherit"},"& > div + div":{maxHeight:"266px !important"}},selectMenuItem:{fontSize:"13px",padding:"10px 20px",margin:"0 5px",borderRadius:"2px",transition:"all 150ms linear",display:"block",clear:"both",fontWeight:"400",lineHeight:"2",whiteSpace:"nowrap",color:"#333",paddingRight:"30px","&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */])},selectMenuItemSelected:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]+"!important",color:"#FFFFFF"},selectMenuItemSelectedMultiple:{backgroundColor:"transparent !important","&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]+"!important",color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */],{"&:after":{color:"#FFFFFF"}}),"&:after":{top:"16px",right:"12px",width:"12px",height:"5px",borderLeft:"2px solid currentColor",transform:"rotate(-45deg)",opacity:"1",color:"#3c4858",position:"absolute",content:"''",borderBottom:"2px solid currentColor",transition:"opacity 90ms cubic-bezier(0,0,.2,.1)"}},selectPaper:{boxSizing:"borderBox",borderRadius:"4px",padding:"0",minWidth:"100%",display:"block",border:"0",boxShadow:"0 2px 5px 0 rgba(0, 0, 0, 0.26)",backgroundClip:"padding-box",margin:"2px 0 0",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"transparent",maxHeight:"266px"}};/* harmony default export */ __webpack_exports__["a"] = (customSelectStyle);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return csvHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return events; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rtlStories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return widgetStories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return stories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bugs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return website; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return server; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return rtlBugs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rtlWebsite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rtlServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dataTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CardTravel__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CardTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CardTravel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Extension__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_FlightLand__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_FlightLand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_FlightLand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Build__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Build__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomDropdown_CustomDropdown_jsx__ = __webpack_require__(404);
// @material-ui/icons
// core components
// ##############################
// // // stories for RTLSupport view
// #############################
var rtlStories=[{// First story
inverted:true,badgeColor:"danger",badgeIcon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CardTravel___default.a,title:"جهة أي",titleColor:"danger",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0642\u0627\u0645 \u0643\u0644 \u0645\u0627\u0630\u0627 \u0627\u0644\u0639\u0635\u0628\u0629 \u0627\u0648\u0631\u0648\u0628\u0627. \u0623\u064A \u062C\u0648\u0631\u062C \u0627\u0644\u0639\u0627\u0644\u0645\u064A \u0623\u062E\u0631, \u0643\u0627\u0646 \u062A\u0645 \u0623\u0637\u0631\u0627\u0641 \u0627\u0644\u0642\u0648\u0649 \u0627\u0633\u062A\u0628\u062F\u0627\u0644. \u0623\u0633\u0631 \u0645\u064A\u0646\u0627\u0621 \u062A\u0643\u062A\u064A\u0643\u0627\u064B \u0627\u0644\u062C\u062F\u064A\u062F\u0629\u060C \u0643\u0644. \u062C\u064F\u0644 \u0627\u0644\u0644\u0627 \u0627\u0644\u062A\u0643\u0627\u0644\u064A\u0641 \u0628\u0640, \u0639\u0631\u0641\u0647\u0627 \u0627\u0644\u0646\u0632\u0627\u0639 \u0644\u0644\u064A\u0627\u0628\u0627\u0646 \u0628\u0640 \u0623\u0636\u0641. \u0627\u0646\u062A\u0647\u062A \u0627\u0644\u0645\u062F\u0646 \u0627\u0644\u062B\u0627\u0644\u062B \u0645\u0646 \u0648\u0642\u062F.\u0648\u0642\u0628\u0644 \u0642\u0627\u062F\u0629 \u0625\u062D\u062A\u0627\u0631 \u0639\u0646 \u0623\u062E\u0631. \u062D\u064A\u0646 \u0648\u0646\u062A\u062C \u0623\u062E\u0631\u0649 \u0642\u062F. \u0628\u0627\u0644\u0639\u0645\u0644 \u0628\u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0629 \u0641\u0642\u062F \u0642\u062F. \u0639\u0646 \u062C\u0646\u0648\u0628 \u0648\u0645\u0636\u0649 \u0627\u0644\u0634\u062A\u0627\u0621."),footerTitle:"مدن أن هُزم سكان, مكن."},{// Second story
inverted:true,badgeColor:"success",badgeIcon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Extension___default.a,title:"جُل حكومة",titleColor:"success",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0639\u0644 \u0641\u0643\u0627\u0646\u062A \u0627\u0644\u062B\u0642\u064A\u0644\u0629 \u0628\u0644\u0627. \u0634\u064A\u0621 \u0628\u062E\u0637\u0648\u0637 \u0628\u0627\u0644\u0631\u0651\u063A\u0645 \u0627\u0644\u062A\u0628\u0631\u0639\u0627\u062A \u0639\u0646, \u064A\u0637\u0648\u0644 \u0628\u0623\u064A\u062F\u064A \u0644\u0645 \u0643\u0644\u0651. \u0645\u0639\u0642\u0644 \u0627\u0644\u063A\u0627\u0644\u064A \u0648\u0627\u062A\u0651\u062C\u0647 \u0644\u0645 \u0648\u062A\u0645, \u0623\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 \u0628\u0627\u0644\u0645\u062D\u0648\u0631 \u062D\u0648\u0644, \u0628\u0627\u0644 \u0645\u0631\u0645\u0649 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0642\u064F\u062F\u064F\u0645\u0627\u064B \u0648. \u0627\u0644\u0623\u062E\u0630 \u0633\u0628\u062A\u0645\u0628\u0631 \u0627\u0644\u0639\u0627\u0644\u0645 \u0645\u0646 \u0630\u0644\u0643. \u0627\u0646 \u064A\u0628\u0642 \u0634\u062F\u0651\u062A \u0627\u0644\u0623\u0628\u0631\u064A\u0627\u0621, \u0627\u0644\u0649 \u0627\u0644\u0631\u0628\u064A\u0639\u060C \u0648\u0627\u0644\u0645\u0627\u0646\u064A\u0627 \u0643\u0644. \u0648\u062F\u0648\u0644 \u0627\u0644\u0623\u0647\u062F\u0627\u0641 \u0627\u0644\u062A\u0642\u0644\u064A\u062F\u064A \u0639\u0644 \u0623\u0636\u0641, \u0643\u0644\u0627 \u064A\u0642\u0648\u0645 \u0627\u0644\u0623\u062E\u0630 \u0627\u0644\u0622\u0644\u0627\u0641 \u0628\u0644.")},{// Third story
inverted:true,badgeColor:"info",badgeIcon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint___default.a,title:"هذا غينيا",titleColor:"info",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u062C\u0647\u0629 \u0627\u0644\u0645\u0627\u0631\u0642 \u0648\u0627\u0644\u062F\u064A\u0648\u0646 \u0627\u0644\u062A\u0642\u0644\u064A\u062F\u064A\u0629 \u0641\u064A, \u0647\u0648 \u0648\u062A\u0631\u0643 \u0627\u0644\u0645\u062C\u062A\u0645\u0639 \u0628\u0631\u064A\u0637\u0627\u0646\u064A\u0627 \u0630\u0644\u0643, \u0644\u0645\u0651 \u0645\u0627 \u0627\u0644\u0639\u0627\u0644\u0645\u060C \u0627\u0644\u064A\u0627\u0628\u0627\u0646\u060C. \u0663\u0660 \u0641\u0642\u0627\u0645\u062A \u0623\u0648\u0631\u0648\u0628\u0627 \u0645\u0634\u0627\u0631\u0643\u0629 \u0628\u0639\u062F, \u0662\u0660\u0660\u0664 \u0627\u0644\u062C\u0648 \u0645\u0633\u0627\u0639\u062F\u0629 \u0645\u0627 \u062D\u062F\u0649. \u0641\u064A \u0639\u0644\u064A\u0647\u0627 \u0648\u0628\u062D\u0644\u0648\u0644 \u0645\u0639\u0627\u0631\u0636\u0629 \u0628\u0639\u0636. \u0639\u0646 \u0627\u0644\u0623\u0631\u0636 \u0648\u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u0648\u0644\u0645. \u0627\u0644\u062C\u0648 \u062C\u062F\u064A\u062F\u0627\u064B \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A\u0651\u0648\u0646 \u0623\u0645 \u0628\u0647\u060C. \u062B\u0645 \u0627\u0644\u062A\u064A \u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u0622\u0644\u0627\u0641 \u062C\u0639\u0644, \u0639\u0646 \u0627\u0644\u0645\u0627\u0631\u0642 \u0627\u0644\u0633\u0627\u062F\u0633 \u0642\u0627\u0645. \u0645\u0627 \u0623\u062E\u0631 \u0641\u0642\u0627\u0645\u062A \u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u0634\u0631\u0642\u060C, \u0641\u0635\u0644 \u0643\u0644 \u0648\u0633\u0648\u0621 \u0627\u0644\u0623\u0631\u0648\u0627\u062D. \u062B\u0645 \u0628\u0639\u062F \u0648\u0634\u0639\u0627\u0631 \u0628\u0623\u064A\u062F\u064A. \u0642\u0628\u0644 \u0648\u0643\u0633\u0628\u062A \u0627\u0644\u063A\u0627\u0644\u064A \u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0628\u0644, \u0663\u0660 \u0623\u0645\u0651\u0627 \u0623\u062E\u0631\u0649 \u0644\u0623\u062F\u0627\u0621 \u0623\u0636\u0641. \u0647\u0648 \u0645\u0646\u062A\u0635\u0641 \u0645\u0639\u0632\u0651\u0632\u0629 \u0639\u0644\u0649. \u0628\u0640 \u0623\u0641\u0631\u064A\u0642\u064A\u0627 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A \u0645\u0645\u0627, \u0623\u062B\u0631\u0647\u060C."),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{rtlActive:true,buttonIcon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Build___default.a,buttonProps:{round:true,style:{marginBottom:"0"},color:"info"},dropdownList:["ان","إجلاء لفرنسا","أواخر الأرض بل",{divider:true},"عل اليها"]})}];// ##############################
// // // stories for Widgets view
// #############################
var widgetStories=[{// First story
inverted:true,badgeColor:"danger",badgeIcon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CardTravel___default.a,title:"Some Title",titleColor:"danger",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the \u201Cfuture\u201D theme !!! It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown."),footerTitle:"11 hours ago via Twitter"},{// Second story
inverted:true,badgeColor:"success",badgeIcon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Extension___default.a,title:"Another One",titleColor:"success",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Thank God for the support of my wife and real friends. I also wanted to point out that it\u2019s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")},{// Third story
inverted:true,badgeColor:"info",badgeIcon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint___default.a,title:"Another Title",titleColor:"info",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Called I Miss the Old Kanye That\u2019s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"What if Kanye made a song about Kanye Roy\xE8re doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn\u2019t any Kanyes Set on his goals Kanye")),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{buttonIcon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Build___default.a,buttonProps:{round:true,style:{marginBottom:"0"},color:"info"},dropdownList:["Action","Another action","Something else here",{divider:true},"Separated link"]})}];// ##############################
// // // stories for Timeline view
// #############################
var stories=[{// First story
inverted:true,badgeColor:"danger",badgeIcon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_CardTravel___default.a,title:"Some Title",titleColor:"danger",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the \u201Cfuture\u201D theme !!! It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown."),footerTitle:"11 hours ago via Twitter"},{// Second story
badgeColor:"success",badgeIcon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Extension___default.a,title:"Another One",titleColor:"success",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Thank God for the support of my wife and real friends. I also wanted to point out that it\u2019s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")},{// Third story
inverted:true,badgeColor:"info",badgeIcon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint___default.a,title:"Another Title",titleColor:"info",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Called I Miss the Old Kanye That\u2019s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"What if Kanye made a song about Kanye Roy\xE8re doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn\u2019t any Kanyes Set on his goals Kanye")),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{buttonIcon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Build___default.a,buttonProps:{round:true,style:{marginBottom:"0"},color:"info"},dropdownList:["Action","Another action","Something else here",{divider:true},"Separated link"]})},{// Fourth story
badgeColor:"warning",badgeIcon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_FlightLand___default.a,title:"Another One",titleColor:"warning",body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim\u2019s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team")}];// ##############################
// // // data for populating the calendar in Calendar view
// #############################
var today=new Date();var y=today.getFullYear();var m=today.getMonth();var d=today.getDate();var events=[{title:"All Day Event",allDay:true,start:new Date(y,m,1),end:new Date(y,m,1),color:"default"},{title:"Meeting",start:new Date(y,m,d-1,10,30),end:new Date(y,m,d-1,11,30),allDay:false,color:"green"},{title:"Lunch",start:new Date(y,m,d+7,12,0),end:new Date(y,m,d+7,14,0),allDay:false,color:"red"},{title:"Nud-pro Launch",start:new Date(y,m,d-2),end:new Date(y,m,d-2),allDay:true,color:"azure"},{title:"Birthday Party",start:new Date(y,m,d+1,19,0),end:new Date(y,m,d+1,22,30),allDay:false,color:"azure"},{title:"Click for Creative Tim",start:new Date(y,m,21),end:new Date(y,m,22),color:"orange"},{title:"Click for Google",start:new Date(y,m,21),end:new Date(y,m,22),color:"rose"}];// ##############################
// // // Tasks for TasksCard - see Widget view
// #############################
var bugs=['Sign contract for "What are conference organizers afraid of?"',"Lines From Great Russian Literature? Or E-mails From My Boss?","Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit","Create 4 Invisible User Experiences you Never Knew About"];var website=["Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",'Sign contract for "What are conference organizers afraid of?"'];var server=["Lines From Great Russian Literature? Or E-mails From My Boss?","Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit",'Sign contract for "What are conference organizers afraid of?"'];// ##############################
// // // Tasks for TasksCard - see RTLSupport view
// #############################
var rtlBugs=["فقد لمحاكم الاندونيسية, بلاده بالتوقيع تم يبق. جعل السبب وفرنسا الصينية أي.","بحث. كل مما ٢٠٠٤ شاسعة العسكري جعل السبب وفرنسا الصينية أي.","تسبب أفريقيا ضرب عن, عن إنطلاق جعل السبب وفرنسا الصينية أي.","قدما مليون بين عن, مرجع منتصف الأمريكية جعل السبب وفرنسا الصينية أي."];var rtlWebsite=["قدما مليون بين عن, مرجع منتصف الأمريكية جعل السبب وفرنسا الصينية أي.","قدما مليون بين عن, مرجع منتصف الأمريكية جعل السبب وفرنسا الصينية أي."];var rtlServer=["قدما مليون بين عن, مرجع منتصف الأمريكية جعل السبب وفرنسا الصينية أي.","قدما مليون بين عن, مرجع منتصف الأمريكية جعل السبب وفرنسا الصينية أي.","قدما مليون بين عن, مرجع منتصف الأمريكية جعل السبب وفرنسا الصينية أي."];// ##############################
// // // data for datatables.net in DataTables view
// #############################
var dataTable={headerRow:["Name","Position","Office","Age","Actions"],footerRow:["Name","Position","Office","Age","Actions"],dataRows:[["Tiger Nixon","System Architect","Edinburgh","61"],["Garrett Winters","Accountant","Tokyo","63"],["Ashton Cox","Junior Technical Author","San Francisco","66"],["Cedric Kelly","Senior Javascript Developer","Edinburgh","22"],["Airi Satou","Accountant","Tokyo","33"],["Brielle Williamson","Integration Specialist","New York","61"],["Herrod Chandler","Sales Assistant","San Francisco","59"],["Rhona Davidson","Integration Specialist","Tokyo","55"],["Colleen Hurst","Javascript Developer","San Francisco","39"],["Sonya Frost","Software Engineer","Edinburgh","23"],["Jena Gaines","Office Manager","London","30"],["Quinn Flynn","Support Lead","Edinburgh","22"],["Charde Marshall","Regional Director","San Francisco","36"],["Haley Kennedy","Senior Marketing Designer","London","43"],["Tatyana Fitzpatrick","Regional Director","London","19"],["Michael Silva","Marketing Designer","London","66"],["Paul Byrd","Chief Financial Officer (CFO)","New York","64"],["Gloria Little","Systems Administrator","New York","59"],["Bradley Greer","Software Engineer","London","41"],["Dai Rios","Personnel Lead","Edinburgh","35"],["Jenette Caldwell","Development Lead","New York","30"],["Yuri Berry","Chief Marketing Officer (CMO)","New York","40"],["Caesar Vance","Pre-Sales Support","New York","21"],["Doris Wilder","Sales Assistant","Sidney","23"],["Angelica Ramos","Chief Executive Officer (CEO)","London","47"],["Gavin Joyce","Developer","Edinburgh","42"],["Jennifer Chang","Regional Director","Singapore","28"],["Brenden Wagner","Software Engineer","San Francisco","28"],["Fiona Green","Chief Operating Officer (COO)","San Francisco","48"],["Shou Itou","Regional Marketing","Tokyo","20"],["Michelle House","Integration Specialist","Sidney","37"],["Suki Burks","Developer","London","53"],["Prescott Bartlett","Technical Author","London","27"],["Gavin Cortez","Team Leader","San Francisco","22"],["Martena Mccray","Post-Sales support","Edinburgh","46"],["Unity Butler","Marketing Designer","San Francisco","47"],["Howard Hatfield","Office Manager","San Francisco","51"],["Hope Fuentes","Secretary","San Francisco","41"],["Vivian Harrell","Financial Controller","San Francisco","62"],["Timothy Mooney","Office Manager","London","37"],["Jackson Bradshaw","Director","New York","65"],["Olivia Liang","Support Engineer","Singapore","64"]]};var csvHeaders=[{label:"Name",key:"name"},{label:"Address",key:"formatted_address"},{label:"Phone Number",key:"formatted_phone_number"},{label:"Rating",key:"rating"},{label:"URL",key:"url"},{label:"Website",key:"website"}];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(73);
var createDesc = __webpack_require__(136);
module.exports = __webpack_require__(86) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(107);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(425);
var defined = __webpack_require__(258);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    getRawTag = __webpack_require__(955),
    objectToString = __webpack_require__(956);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(451),
    baseKeys = __webpack_require__(1004),
    isArrayLike = __webpack_require__(114);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(139),
    isLength = __webpack_require__(282);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(292),
    baseAssignValue = __webpack_require__(293);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.notify = notify;
exports.instanceId = instanceId;
exports.isFirstFocusedRender = isFirstFocusedRender;
var idCount = 0;

function uniqueId(prefix) {
  return '' + ((prefix == null ? '' : prefix) + ++idCount);
}

function notify(handler, args) {
  handler && handler.apply(null, [].concat(args));
}

function instanceId(component, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }

  component.__id || (component.__id = uniqueId('rw_'));
  return (component.props.id || component.__id) + suffix;
}

function isFirstFocusedRender(component) {
  return component._firstFocus || component.state.focused && (component._firstFocus = true);
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(539));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(154);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(318);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(89);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(547);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(__webpack_require__(593));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(5));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _reactLifecyclesCompat = __webpack_require__(335);

var _PropTypes = __webpack_require__(613);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__(614));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__(629));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

__webpack_require__(666);
var firebase = _interopDefault(__webpack_require__(238));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var hide = __webpack_require__(79);
var has = __webpack_require__(81);
var SRC = __webpack_require__(131)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(60).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 131 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(353);
var enumBugKeys = __webpack_require__(231);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(__webpack_require__(804));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(__webpack_require__(862));

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(110),
    overRest = __webpack_require__(429),
    setToString = __webpack_require__(272);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObject = __webpack_require__(51);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(51);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1007),
    baseMatchesProperty = __webpack_require__(1046),
    identity = __webpack_require__(110),
    isArray = __webpack_require__(37),
    property = __webpack_require__(1054);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(141);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(143),
    isArrayLike = __webpack_require__(114),
    isIndex = __webpack_require__(190),
    isObject = __webpack_require__(51);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(203));

var _isWindow = _interopRequireDefault(__webpack_require__(92));

var _ownerDocument = _interopRequireDefault(__webpack_require__(296));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isSelected = isSelected;
exports.slotWidth = slotWidth;
exports.getSlotAtX = getSlotAtX;
exports.pointInBox = pointInBox;
exports.dateCellSelection = dateCellSelection;

function isSelected(event, selected) {
  if (!event || selected == null) return false;
  return [].concat(selected).indexOf(event) !== -1;
}

function slotWidth(rowBox, slots) {
  var rowWidth = rowBox.right - rowBox.left;
  var cellWidth = rowWidth / slots;
  return cellWidth;
}

function getSlotAtX(rowBox, x, rtl, slots) {
  var cellWidth = slotWidth(rowBox, slots);
  return rtl ? slots - 1 - Math.floor((x - rowBox.left) / cellWidth) : Math.floor((x - rowBox.left) / cellWidth);
}

function pointInBox(box, _ref) {
  var x = _ref.x,
      y = _ref.y;
  return y >= box.top && y <= box.bottom && x >= box.left && x <= box.right;
}

function dateCellSelection(start, rowBox, box, slots, rtl) {
  var startIdx = -1;
  var endIdx = -1;
  var lastSlotIdx = slots - 1;
  var cellWidth = slotWidth(rowBox, slots); // cell under the mouse

  var currentSlot = getSlotAtX(rowBox, box.x, rtl, slots); // Identify row as either the initial row
  // or the row under the current mouse point

  var isCurrentRow = rowBox.top < box.y && rowBox.bottom > box.y;
  var isStartRow = rowBox.top < start.y && rowBox.bottom > start.y; // this row's position relative to the start point

  var isAboveStart = start.y > rowBox.bottom;
  var isBelowStart = rowBox.top > start.y;
  var isBetween = box.top < rowBox.top && box.bottom > rowBox.bottom; // this row is between the current and start rows, so entirely selected

  if (isBetween) {
    startIdx = 0;
    endIdx = lastSlotIdx;
  }

  if (isCurrentRow) {
    if (isBelowStart) {
      startIdx = 0;
      endIdx = currentSlot;
    } else if (isAboveStart) {
      startIdx = currentSlot;
      endIdx = lastSlotIdx;
    }
  }

  if (isStartRow) {
    // select the cell under the initial point
    startIdx = endIdx = rtl ? lastSlotIdx - Math.floor((start.x - rowBox.left) / cellWidth) : Math.floor((start.x - rowBox.left) / cellWidth);

    if (isCurrentRow) {
      if (currentSlot < startIdx) startIdx = currentSlot;else endIdx = currentSlot; //select current range
    } else if (start.y < box.y) {
      // the current row is below start row
      // select cells to the right of the start cell
      endIdx = lastSlotIdx;
    } else {
      // select cells to the left of the start cell
      startIdx = 0;
    }
  }

  return {
    startIdx: startIdx,
    endIdx: endIdx
  };
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(296);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.endOfRange = endOfRange;
exports.eventSegments = eventSegments;
exports.eventLevels = eventLevels;
exports.inRange = inRange;
exports.segsOverlap = segsOverlap;
exports.sortEvents = sortEvents;

var _findIndex = _interopRequireDefault(__webpack_require__(1131));

var _dates = _interopRequireDefault(__webpack_require__(32));

function endOfRange(dateRange, unit) {
  if (unit === void 0) {
    unit = 'day';
  }

  return {
    first: dateRange[0],
    last: _dates.default.add(dateRange[dateRange.length - 1], 1, unit)
  };
}

function eventSegments(event, range, accessors) {
  var _endOfRange = endOfRange(range),
      first = _endOfRange.first,
      last = _endOfRange.last;

  var slots = _dates.default.diff(first, last, 'day');

  var start = _dates.default.max(_dates.default.startOf(accessors.start(event), 'day'), first);

  var end = _dates.default.min(_dates.default.ceil(accessors.end(event), 'day'), last);

  var padding = (0, _findIndex.default)(range, function (x) {
    return _dates.default.eq(x, start, 'day');
  });

  var span = _dates.default.diff(start, end, 'day');

  span = Math.min(span, slots);
  span = Math.max(span, 1);
  return {
    event: event,
    span: span,
    left: padding + 1,
    right: Math.max(padding + span, 1)
  };
}

function eventLevels(rowSegments, limit) {
  if (limit === void 0) {
    limit = Infinity;
  }

  var i,
      j,
      seg,
      levels = [],
      extra = [];

  for (i = 0; i < rowSegments.length; i++) {
    seg = rowSegments[i];

    for (j = 0; j < levels.length; j++) {
      if (!segsOverlap(seg, levels[j])) break;
    }

    if (j >= limit) {
      extra.push(seg);
    } else {
      ;
      (levels[j] || (levels[j] = [])).push(seg);
    }
  }

  for (i = 0; i < levels.length; i++) {
    levels[i].sort(function (a, b) {
      return a.left - b.left;
    }); //eslint-disable-line
  }

  return {
    levels: levels,
    extra: extra
  };
}

function inRange(e, start, end, accessors) {
  var eStart = _dates.default.startOf(accessors.start(e), 'day');

  var eEnd = accessors.end(e);

  var startsBeforeEnd = _dates.default.lte(eStart, end, 'day'); // when the event is zero duration we need to handle a bit differently


  var endsAfterStart = !_dates.default.eq(eStart, eEnd, 'minutes') ? _dates.default.gt(eEnd, start, 'minutes') : _dates.default.gte(eEnd, start, 'minutes');
  return startsBeforeEnd && endsAfterStart;
}

function segsOverlap(seg, otherSegs) {
  return otherSegs.some(function (otherSeg) {
    return otherSeg.left <= seg.right && otherSeg.right >= seg.left;
  });
}

function sortEvents(evtA, evtB, accessors) {
  var startSort = +_dates.default.startOf(accessors.start(evtA), 'day') - +_dates.default.startOf(accessors.start(evtB), 'day');

  var durA = _dates.default.diff(accessors.start(evtA), _dates.default.ceil(accessors.end(evtA), 'day'), 'day');

  var durB = _dates.default.diff(accessors.start(evtB), _dates.default.ceil(accessors.end(evtB), 'day'), 'day');

  return startSort || // sort by start Day first
  Math.max(durB, 1) - Math.max(durA, 1) || // events spanning multiple days go first
  !!accessors.allDay(evtB) - !!accessors.allDay(evtA) || // then allDay single day events
  +accessors.start(evtA) - +accessors.start(evtB); // then sort by start time
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(117);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 152 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(88);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(89);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(544);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__(615));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});

var _ListItem = _interopRequireDefault(__webpack_require__(616));

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Button styles
// #############################
var buttonStyle={button:{minHeight:"auto",minWidth:"auto",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],color:"#FFFFFF",boxShadow:"0 2px 2px 0 rgba(153, 153, 153, 0.14), 0 3px 1px -2px rgba(153, 153, 153, 0.2), 0 1px 5px 0 rgba(153, 153, 153, 0.12)",border:"none",borderRadius:"3px",position:"relative",padding:"12px 30px",margin:".3125rem 1px",fontSize:"12px",fontWeight:"400",textTransform:"uppercase",letterSpacing:"0",willChange:"box-shadow, transform",transition:"box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",lineHeight:"1.42857143",textAlign:"center",whiteSpace:"nowrap",verticalAlign:"middle",touchAction:"manipulation",cursor:"pointer","&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],boxShadow:"0 14px 26px -12px rgba(153, 153, 153, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(153, 153, 153, 0.2)"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{position:"relative",display:"inline-block",top:"0",marginTop:"-1em",marginBottom:"-1em",fontSize:"1.1rem",marginRight:"4px",verticalAlign:"middle"},"& svg":{position:"relative",display:"inline-block",top:"0",width:"18px",height:"18px",marginRight:"4px",verticalAlign:"middle"},"&$justIcon":{"& .fab,& .fas,& .far,& .fal,& .material-icons":{marginTop:"0px",position:"absolute",width:"100%",transform:"none",left:"0px",top:"0px",height:"100%",lineHeight:"41px",fontSize:"20px"}}},fullWidth:{width:"100%"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 14px 26px -12px rgba(156, 39, 176, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(156, 39, 176, 0.2)"}},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 14px 26px -12px rgba(0, 188, 212, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 188, 212, 0.2)"}},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],boxShadow:"0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],boxShadow:"0 14px 26px -12px rgba(76, 175, 80, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(76, 175, 80, 0.2)"}},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],boxShadow:"0 2px 2px 0 rgba(255, 152, 0, 0.14), 0 3px 1px -2px rgba(255, 152, 0, 0.2), 0 1px 5px 0 rgba(255, 152, 0, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],boxShadow:"0 14px 26px -12px rgba(255, 152, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 152, 0, 0.2)"}},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"0 2px 2px 0 rgba(244, 67, 54, 0.14), 0 3px 1px -2px rgba(244, 67, 54, 0.2), 0 1px 5px 0 rgba(244, 67, 54, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"0 14px 26px -12px rgba(244, 67, 54, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(244, 67, 54, 0.2)"}},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 2px 2px 0 rgba(233, 30, 99, 0.14), 0 3px 1px -2px rgba(233, 30, 99, 0.2), 0 1px 5px 0 rgba(233, 30, 99, 0.12)","&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 14px 26px -12px rgba(233, 30, 99, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(233, 30, 99, 0.2)"}},white:{"&,&:focus,&:hover":{backgroundColor:"#FFFFFF",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]}},twitter:{backgroundColor:"#55acee",color:"#fff",boxShadow:"0 2px 2px 0 rgba(85, 172, 238, 0.14), 0 3px 1px -2px rgba(85, 172, 238, 0.2), 0 1px 5px 0 rgba(85, 172, 238, 0.12)","&:hover,&:focus,&:visited":{backgroundColor:"#55acee",color:"#fff",boxShadow:"0 14px 26px -12px rgba(85, 172, 238, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(85, 172, 238, 0.2)"}},facebook:{backgroundColor:"#3b5998",color:"#fff",boxShadow:"0 2px 2px 0 rgba(59, 89, 152, 0.14), 0 3px 1px -2px rgba(59, 89, 152, 0.2), 0 1px 5px 0 rgba(59, 89, 152, 0.12)","&:hover,&:focus":{backgroundColor:"#3b5998",color:"#fff",boxShadow:"0 14px 26px -12px rgba(59, 89, 152, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2)"}},google:{backgroundColor:"#dd4b39",color:"#fff",boxShadow:"0 2px 2px 0 rgba(221, 75, 57, 0.14), 0 3px 1px -2px rgba(221, 75, 57, 0.2), 0 1px 5px 0 rgba(221, 75, 57, 0.12)","&:hover,&:focus":{backgroundColor:"#dd4b39",color:"#fff",boxShadow:"0 14px 26px -12px rgba(221, 75, 57, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(221, 75, 57, 0.2)"}},linkedin:{backgroundColor:"#0976b4",color:"#fff",boxShadow:"0 2px 2px 0 rgba(9, 118, 180, 0.14), 0 3px 1px -2px rgba(9, 118, 180, 0.2), 0 1px 5px 0 rgba(9, 118, 180, 0.12)","&:hover,&:focus":{backgroundColor:"#0976b4",color:"#fff",boxShadow:"0 14px 26px -12px rgba(9, 118, 180, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(9, 118, 180, 0.2)"}},pinterest:{backgroundColor:"#cc2127",color:"#fff",boxShadow:"0 2px 2px 0 rgba(204, 33, 39, 0.14), 0 3px 1px -2px rgba(204, 33, 39, 0.2), 0 1px 5px 0 rgba(204, 33, 39, 0.12)","&:hover,&:focus":{backgroundColor:"#cc2127",color:"#fff",boxShadow:"0 14px 26px -12px rgba(204, 33, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(204, 33, 39, 0.2)"}},youtube:{backgroundColor:"#e52d27",color:"#fff",boxShadow:"0 2px 2px 0 rgba(229, 45, 39, 0.14), 0 3px 1px -2px rgba(229, 45, 39, 0.2), 0 1px 5px 0 rgba(229, 45, 39, 0.12)","&:hover,&:focus":{backgroundColor:"#e52d27",color:"#fff",boxShadow:"0 14px 26px -12px rgba(229, 45, 39, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(229, 45, 39, 0.2)"}},tumblr:{backgroundColor:"#35465c",color:"#fff",boxShadow:"0 2px 2px 0 rgba(53, 70, 92, 0.14), 0 3px 1px -2px rgba(53, 70, 92, 0.2), 0 1px 5px 0 rgba(53, 70, 92, 0.12)","&:hover,&:focus":{backgroundColor:"#35465c",color:"#fff",boxShadow:"0 14px 26px -12px rgba(53, 70, 92, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(53, 70, 92, 0.2)"}},github:{backgroundColor:"#333333",color:"#fff",boxShadow:"0 2px 2px 0 rgba(51, 51, 51, 0.14), 0 3px 1px -2px rgba(51, 51, 51, 0.2), 0 1px 5px 0 rgba(51, 51, 51, 0.12)","&:hover,&:focus":{backgroundColor:"#333333",color:"#fff",boxShadow:"0 14px 26px -12px rgba(51, 51, 51, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(51, 51, 51, 0.2)"}},behance:{backgroundColor:"#1769ff",color:"#fff",boxShadow:"0 2px 2px 0 rgba(23, 105, 255, 0.14), 0 3px 1px -2px rgba(23, 105, 255, 0.2), 0 1px 5px 0 rgba(23, 105, 255, 0.12)","&:hover,&:focus":{backgroundColor:"#1769ff",color:"#fff",boxShadow:"0 14px 26px -12px rgba(23, 105, 255, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(23, 105, 255, 0.2)"}},dribbble:{backgroundColor:"#ea4c89",color:"#fff",boxShadow:"0 2px 2px 0 rgba(234, 76, 137, 0.14), 0 3px 1px -2px rgba(234, 76, 137, 0.2), 0 1px 5px 0 rgba(234, 76, 137, 0.12)","&:hover,&:focus":{backgroundColor:"#ea4c89",color:"#fff",boxShadow:"0 14px 26px -12px rgba(234, 76, 137, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(234, 76, 137, 0.2)"}},reddit:{backgroundColor:"#ff4500",color:" #fff",boxShadow:"0 2px 2px 0 rgba(255, 69, 0, 0.14), 0 3px 1px -2px rgba(255, 69, 0, 0.2), 0 1px 5px 0 rgba(255, 69, 0, 0.12)","&:hover,&:focus":{backgroundColor:"#ff4500",color:" #fff",boxShadow:"0 14px 26px -12px rgba(255, 69, 0, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(255, 69, 0, 0.2)"}},simple:{"&,&:focus,&:hover":{color:"#FFFFFF",background:"transparent",boxShadow:"none"},"&$primary":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]}},"&$info":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]}},"&$success":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]}},"&$warning":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]}},"&$rose":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]}},"&$danger":{"&,&:focus,&:hover,&:visited":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]}},"&$twitter":{"&,&:focus,&:hover,&:visited":{color:"#55acee"}},"&$facebook":{"&,&:focus,&:hover,&:visited":{color:"#3b5998"}},"&$google":{"&,&:focus,&:hover,&:visited":{color:"#dd4b39"}},"&$linkedin":{"&,&:focus,&:hover,&:visited":{color:"#0976b4"}},"&$pinterest":{"&,&:focus,&:hover,&:visited":{color:"#cc2127"}},"&$youtube":{"&,&:focus,&:hover,&:visited":{color:"#e52d27"}},"&$tumblr":{"&,&:focus,&:hover,&:visited":{color:"#35465c"}},"&$github":{"&,&:focus,&:hover,&:visited":{color:"#333333"}},"&$behance":{"&,&:focus,&:hover,&:visited":{color:"#1769ff"}},"&$dribbble":{"&,&:focus,&:hover,&:visited":{color:"#ea4c89"}},"&$reddit":{"&,&:focus,&:hover,&:visited":{color:"#ff4500"}}},transparent:{"&,&:focus,&:hover":{color:"inherit",background:"transparent",boxShadow:"none"}},disabled:{opacity:"0.65",pointerEvents:"none"},lg:{padding:"1.125rem 2.25rem",fontSize:"0.875rem",lineHeight:"1.333333",borderRadius:"0.2rem"},sm:{padding:"0.40625rem 1.25rem",fontSize:"0.6875rem",lineHeight:"1.5",borderRadius:"0.2rem"},round:{borderRadius:"30px"},block:{width:"100% !important"},link:{"&,&:hover,&:focus":{backgroundColor:"transparent",color:"#999999",boxShadow:"none"}},justIcon:{paddingLeft:"12px",paddingRight:"12px",fontSize:"20px",height:"41px",minWidth:"41px",width:"41px","& .fab,& .fas,& .far,& .fal,& svg,& .material-icons":{marginRight:"0px"},"&$lg":{height:"57px",minWidth:"57px",width:"57px",lineHeight:"56px","& .fab,& .fas,& .far,& .fal,& .material-icons":{fontSize:"32px",lineHeight:"56px"},"& svg":{width:"32px",height:"32px"}},"&$sm":{height:"30px",minWidth:"30px",width:"30px","& .fab,& .fas,& .far,& .fal,& .material-icons":{fontSize:"17px",lineHeight:"29px"},"& svg":{width:"17px",height:"17px"}}}};/* harmony default export */ __webpack_exports__["a"] = (buttonStyle);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(162);
// ##############################
// // // SweetAlert view styles
// #############################
var sweetAlertStyle=Object.assign({cardTitle:{marginTop:"0",marginBottom:"3px",color:"#3C4858",fontSize:"18px"},center:{textAlign:"center"},right:{textAlign:"right"},left:{textAlign:"left"}},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (sweetAlertStyle);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_auth__ = __webpack_require__(711);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__(750));

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog.default;
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(812));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(__webpack_require__(813));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__(814));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(__webpack_require__(815));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControlLabel.default;
  }
});

var _FormControlLabel = _interopRequireDefault(__webpack_require__(837));

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardTextStyle_jsx__ = __webpack_require__(848);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardText(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,className=props.className,children=props.children,color=props.color,rest=_objectWithoutProperties(props,["classes","className","children","color"]);var cardTextClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardText,true),_defineProperty(_classNames,classes[color+"CardHeader"],color),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardTextClasses},rest),children);}CardText.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardTextStyle_jsx__["a" /* default */])(CardText));

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_tableStyle__ = __webpack_require__(898);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function CustomTable(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,tableHead=props.tableHead,tableData=props.tableData,tableHeaderColor=props.tableHeaderColor,hover=props.hover,colorsColls=props.colorsColls,coloredColls=props.coloredColls,customCellClasses=props.customCellClasses,customClassesForCells=props.customClassesForCells,striped=props.striped,tableShopping=props.tableShopping,customHeadCellClasses=props.customHeadCellClasses,customHeadClassesForCells=props.customHeadClassesForCells;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.tableResponsive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table___default.a,{className:classes.table},tableHead!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default.a,{className:classes[tableHeaderColor]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{className:classes.tableRow},tableHead.map(function(prop,key){var _cx;var tableCellClasses=classes.tableHeadCell+" "+classes.tableCell+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx={},_defineProperty(_cx,customHeadCellClasses[customHeadClassesForCells.indexOf(key)],customHeadClassesForCells.indexOf(key)!==-1),_defineProperty(_cx,classes.tableShoppingHead,tableShopping),_defineProperty(_cx,classes.tableHeadFontSize,!tableShopping),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:tableCellClasses,key:key},prop);}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default.a,null,tableData.map(function(prop,key){var _cx2;var rowColor="";var rowColored=false;if(prop.color!==undefined){rowColor=prop.color;rowColored=true;prop=prop.data;}var tableRowClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx2={},_defineProperty(_cx2,classes.tableRowHover,hover),_defineProperty(_cx2,classes[rowColor+"Row"],rowColored),_defineProperty(_cx2,classes.tableStripedRow,striped&&key%2===0),_cx2));if(prop.total){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{key:key,hover:hover,className:tableRowClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell,colSpan:prop.colspan}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell+" "+classes.tableCellTotal},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell+" "+classes.tableCellAmount},prop.amount),tableHead.length-(prop.colspan-0+2)>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell,colSpan:tableHead.length-(prop.colspan-0+2)}):null);}if(prop.purchase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{key:key,hover:hover,className:tableRowClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell,colSpan:prop.colspan}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:classes.tableCell+" "+classes.right,colSpan:prop.col.colspan},prop.col.text));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TableRow___default.a,{key:key,hover:hover,className:classes.tableRow+" "+tableRowClasses},prop.map(function(prop,key){var _cx3;var tableCellClasses=classes.tableCell+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx3={},_defineProperty(_cx3,classes[colorsColls[coloredColls.indexOf(key)]],coloredColls.indexOf(key)!==-1),_defineProperty(_cx3,customCellClasses[customClassesForCells.indexOf(key)],customClassesForCells.indexOf(key)!==-1),_cx3));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{className:tableCellClasses,key:key},prop);}));}))));}CustomTable.defaultProps={tableHeaderColor:"gray",hover:false,colorsColls:[],coloredColls:[],striped:false,customCellClasses:[],customClassesForCells:[],customHeadCellClasses:[],customHeadClassesForCells:[]};CustomTable.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,tableHeaderColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","primary","danger","success","info","rose","gray"]),tableHead:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),// Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
tableData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,hover:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,coloredColls:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),// Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
colorsColls:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,customCellClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),customClassesForCells:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),customHeadCellClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),customHeadClassesForCells:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),striped:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// this will cause some changes in font
tableShopping:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_tableStyle__["a" /* default */])(CustomTable));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(258);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(424);
var enumBugKeys = __webpack_require__(266);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(138),
    createWrap = __webpack_require__(960),
    getHolder = __webpack_require__(276),
    replaceHolders = __webpack_require__(191);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(140),
    isObject = __webpack_require__(51);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
    stubFalse = __webpack_require__(1002);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)(module)))

/***/ }),
/* 193 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1009),
    listCacheDelete = __webpack_require__(1010),
    listCacheGet = __webpack_require__(1011),
    listCacheHas = __webpack_require__(1012),
    listCacheSet = __webpack_require__(1013);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(143);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1027);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1042),
    Map = __webpack_require__(285),
    Promise = __webpack_require__(1043),
    Set = __webpack_require__(1044),
    WeakMap = __webpack_require__(436),
    baseGetTag = __webpack_require__(111),
    toSource = __webpack_require__(432);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(201),
    toKey = __webpack_require__(144);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(37),
    isKey = __webpack_require__(289),
    stringToPath = __webpack_require__(1048),
    toString = __webpack_require__(461);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.mergeWithDefaults = mergeWithDefaults;
exports.DateLocalizer = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _invariant = _interopRequireDefault(__webpack_require__(23));

var localePropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]);

function _format(localizer, formatter, value, format, culture) {
  var result = typeof format === 'function' ? format(value, culture, localizer) : formatter.call(localizer, value, format, culture);
  !(result == null || typeof result === 'string') ?  false ? (0, _invariant.default)(false, '`localizer format(..)` must return a string, null, or undefined') : invariant(false) : void 0;
  return result;
}

var DateLocalizer = function DateLocalizer(spec) {
  var _this = this;

  !(typeof spec.format === 'function') ?  false ? (0, _invariant.default)(false, 'date localizer `format(..)` must be a function') : invariant(false) : void 0;
  !(typeof spec.firstOfWeek === 'function') ?  false ? (0, _invariant.default)(false, 'date localizer `firstOfWeek(..)` must be a function') : invariant(false) : void 0;
  this.propType = spec.propType || localePropType;
  this.startOfWeek = spec.firstOfWeek;
  this.formats = spec.formats;

  this.format = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _format.apply(void 0, [_this, spec.format].concat(args));
  };
};

exports.DateLocalizer = DateLocalizer;

function mergeWithDefaults(localizer, culture, formatOverrides, messages) {
  var formats = (0, _extends2.default)({}, localizer.formats, formatOverrides);
  return (0, _extends2.default)({}, localizer, {
    messages: messages,
    startOfWeek: function startOfWeek() {
      return localizer.startOfWeek(culture);
    },
    format: function format(value, _format2) {
      return localizer.format(value, formats[_format2] || _format2, culture);
    }
  });
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(451),
    baseKeysIn = __webpack_require__(1162),
    isArrayLike = __webpack_require__(114);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(452);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardAvatarStyle_jsx__ = __webpack_require__(1201);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// @material-ui/icons
// core components
function CardAvatar(_ref){var _classNames;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children,className=props.className,plain=props.plain,profile=props.profile,testimonial=props.testimonial,testimonialFooter=props.testimonialFooter,rest=_objectWithoutProperties(props,["classes","children","className","plain","profile","testimonial","testimonialFooter"]);var cardAvatarClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardAvatar,true),_defineProperty(_classNames,classes.cardAvatarProfile,profile),_defineProperty(_classNames,classes.cardAvatarPlain,plain),_defineProperty(_classNames,classes.cardAvatarTestimonial,testimonial),_defineProperty(_classNames,classes.cardAvatarTestimonialFooter,testimonialFooter),_defineProperty(_classNames,className,className!==undefined),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({className:cardAvatarClasses},rest),children);}CardAvatar.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,profile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,plain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonial:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,testimonialFooter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_cardAvatarStyle_jsx__["a" /* default */])(CardAvatar));

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(209);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(153);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(546);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41), __webpack_require__(545)(module)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(316);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _deepmerge = _interopRequireDefault(__webpack_require__(156));

var _isPlainObject = _interopRequireDefault(__webpack_require__(574));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(121));

var _createMixins = _interopRequireDefault(__webpack_require__(576));

var _createPalette = _interopRequireDefault(__webpack_require__(577));

var _createTypography = _interopRequireDefault(__webpack_require__(583));

var _shadows = _interopRequireDefault(__webpack_require__(584));

var _shape = _interopRequireDefault(__webpack_require__(585));

var _spacing = _interopRequireDefault(__webpack_require__(586));

var _transitions = _interopRequireDefault(__webpack_require__(76));

var _zIndex = _interopRequireDefault(__webpack_require__(587));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var muiTheme = (0, _extends2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, _spacing.default, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: _spacing.default,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));
   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, _propTypes.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(599));

var _ModalManager = _interopRequireDefault(__webpack_require__(331));

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(332));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(603));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(605));

var _removeStyle = _interopRequireDefault(__webpack_require__(606));

var _properties = __webpack_require__(333);

var _isTransform = _interopRequireDefault(__webpack_require__(607));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(__webpack_require__(636));

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.isFilled = isFilled;
exports.isAdornedStart = isAdornedStart;

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.


function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.


function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(__webpack_require__(644));

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(__webpack_require__(648));

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(80);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(166);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(132);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(167);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(43)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(79)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(228)('keys');
var uid = __webpack_require__(131);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 232 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(97).f;
var has = __webpack_require__(81);
var TAG = __webpack_require__(43)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(43);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var core = __webpack_require__(60);
var LIBRARY = __webpack_require__(236);
var wksExt = __webpack_require__(234);
var defineProperty = __webpack_require__(97).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var util = __webpack_require__(357);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this._automaticDataCollectionEnabled;
        },
        set: function (val) {
            this.checkDestroyed_();
            this._automaticDataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '5.8.1',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: util.createSubscribe,
            ErrorFactory: util.ErrorFactory,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: util.deepExtend
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    util.patchProperty(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    util.patchProperty(app, 'App', FirebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error('bad-app-name', { name: name + '' });
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, config, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) { return apps_[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function (appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
        'account is only allowed in a Node.js environment. On client ' +
        'devices, you should instead initialize the SDK with an api key and ' +
        'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.'
};
var appErrors = new util.ErrorFactory('app', 'Firebase', errors);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firebase = createFirebaseNamespace();

exports.firebase = firebase;
exports.default = firebase;


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(715);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(212);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["default"]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);
  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(40);
var normalizeHeaderName = __webpack_require__(729);
var enhanceError = __webpack_require__(368);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(369);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(369);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(347)))

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Fingerprint');

exports.default = _default;

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * perfect-scrollbar v1.4.0
 * (c) 2018 Hyunje Jun
 * @license MIT
 */
function get(element) {
  return getComputedStyle(element);
}

function set(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}

function div(className) {
  var div = document.createElement('div');
  div.className = className;
  return div;
}

var elMatches =
  typeof Element !== 'undefined' &&
  (Element.prototype.matches ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector);

function matches(element, query) {
  if (!elMatches) {
    throw new Error('No element matching method supported');
  }

  return elMatches.call(element, query);
}

function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}

function queryChildren(element, selector) {
  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
  );
}

var cls = {
  main: 'ps',
  element: {
    thumb: function (x) { return ("ps__thumb-" + x); },
    rail: function (x) { return ("ps__rail-" + x); },
    consuming: 'ps__child--consume',
  },
  state: {
    focus: 'ps--focus',
    clicking: 'ps--clicking',
    active: function (x) { return ("ps--active-" + x); },
    scrolling: function (x) { return ("ps--scrolling-" + x); },
  },
};

/*
 * Helper methods
 */
var scrollingClassTimeout = { x: null, y: null };

function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);

  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}

function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
    i.settings.scrollingThreshold
  );
}

function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}

var EventElement = function EventElement(element) {
  this.element = element;
  this.handlers = {};
};

var prototypeAccessors = { isEmpty: { configurable: true } };

EventElement.prototype.bind = function bind (eventName, handler) {
  if (typeof this.handlers[eventName] === 'undefined') {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function unbind (eventName, target) {
    var this$1 = this;

  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};

EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

  for (var name in this$1.handlers) {
    this$1.unbind(name);
  }
};

prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;

  return Object.keys(this.handlers).every(
    function (key) { return this$1.handlers[key].length === 0; }
  );
};

Object.defineProperties( EventElement.prototype, prototypeAccessors );

var EventManager = function EventManager() {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function eventElement (element) {
  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function bind (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function unbind (element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);

  if (ee.isEmpty) {
    // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};

EventManager.prototype.unbindAll = function unbindAll () {
  this.eventElements.forEach(function (e) { return e.unbindAll(); });
  this.eventElements = [];
};

EventManager.prototype.once = function once (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};

function createEvent(name) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
  }
}

var processScrollDiff = function(
  i,
  axis,
  diff,
  useScrollingClass,
  forceFireReachEvent
) {
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var fields;
  if (axis === 'top') {
    fields = [
      'contentHeight',
      'containerHeight',
      'scrollTop',
      'y',
      'up',
      'down' ];
  } else if (axis === 'left') {
    fields = [
      'contentWidth',
      'containerWidth',
      'scrollLeft',
      'x',
      'left',
      'right' ];
  } else {
    throw new Error('A proper axis should be provided');
  }

  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
};

function processScrollDiff$1(
  i,
  diff,
  ref,
  useScrollingClass,
  forceFireReachEvent
) {
  var contentHeight = ref[0];
  var containerHeight = ref[1];
  var scrollTop = ref[2];
  var y = ref[3];
  var up = ref[4];
  var down = ref[5];
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var element = i.element;

  // reset reach
  i.reach[y] = null;

  // 1 for subpixel rounding
  if (element[scrollTop] < 1) {
    i.reach[y] = 'start';
  }

  // 1 for subpixel rounding
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = 'end';
  }

  if (diff) {
    element.dispatchEvent(createEvent(("ps-scroll-" + y)));

    if (diff < 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
    }

    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }

  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
  }
}

function toInt(x) {
  return parseInt(x, 10) || 0;
}

function isEditable(el) {
  return (
    matches(el, 'input,[contenteditable]') ||
    matches(el, 'select,[contenteditable]') ||
    matches(el, 'textarea,[contenteditable]') ||
    matches(el, 'button,[contenteditable]')
  );
}

function outerWidth(element) {
  var styles = get(element);
  return (
    toInt(styles.width) +
    toInt(styles.paddingLeft) +
    toInt(styles.paddingRight) +
    toInt(styles.borderLeftWidth) +
    toInt(styles.borderRightWidth)
  );
}

var env = {
  isWebKit:
    typeof document !== 'undefined' &&
    'WebkitAppearance' in document.documentElement.style,
  supportsTouch:
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)),
  supportsIePointer:
    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
  isChrome:
    typeof navigator !== 'undefined' &&
    /Chrome/i.test(navigator && navigator.userAgent),
};

var updateGeometry = function(i) {
  var element = i.element;
  var roundedScrollTop = Math.floor(element.scrollTop);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  if (!element.contains(i.scrollbarXRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarYRail);
  }

  if (
    !i.settings.suppressScrollX &&
    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
  ) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) *
        (i.railXWidth - i.scrollbarXWidth) /
        (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }

  if (
    !i.settings.suppressScrollY &&
    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
  ) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      roundedScrollTop *
        (i.railYHeight - i.scrollbarYHeight) /
        (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active('x'));
  } else {
    element.classList.remove(cls.state.active('x'));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active('y'));
  } else {
    element.classList.remove(cls.state.active('y'));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
};

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  var roundedScrollTop = Math.floor(element.scrollTop);

  if (i.isRtl) {
    xRailOffset.left =
      i.negativeScrollAdjustment +
      element.scrollLeft +
      i.containerWidth -
      i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
  }
  set(i.scrollbarXRail, xRailOffset);

  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right =
        i.contentWidth -
        (i.negativeScrollAdjustment + element.scrollLeft) -
        i.scrollbarYRight -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth * 2 -
        i.contentWidth -
        i.scrollbarYLeft -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set(i.scrollbarYRail, yRailOffset);

  set(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth,
  });
  set(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth,
  });
}

var clickRail = function(i) {
  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
    var positionTop =
      e.pageY -
      window.pageYOffset -
      i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
    var positionLeft =
      e.pageX -
      window.pageXOffset -
      i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);

    e.stopPropagation();
  });
};

var dragThumb = function(i) {
  bindMouseScrollHandler(i, [
    'containerWidth',
    'contentWidth',
    'pageX',
    'railXWidth',
    'scrollbarX',
    'scrollbarXWidth',
    'scrollLeft',
    'x',
    'scrollbarXRail' ]);
  bindMouseScrollHandler(i, [
    'containerHeight',
    'contentHeight',
    'pageY',
    'railYHeight',
    'scrollbarY',
    'scrollbarYHeight',
    'scrollTop',
    'y',
    'scrollbarYRail' ]);
};

function bindMouseScrollHandler(
  i,
  ref
) {
  var containerHeight = ref[0];
  var contentHeight = ref[1];
  var pageY = ref[2];
  var railYHeight = ref[3];
  var scrollbarY = ref[4];
  var scrollbarYHeight = ref[5];
  var scrollTop = ref[6];
  var y = ref[7];
  var scrollbarYRail = ref[8];

  var element = i.element;

  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;

  function mouseMoveHandler(e) {
    element[scrollTop] =
      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);

    e.stopPropagation();
    e.preventDefault();
  }

  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i[scrollbarYRail].classList.remove(cls.state.clicking);
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  }

  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
    startingScrollTop = element[scrollTop];
    startingMousePageY = e[pageY];
    scrollBy =
      (i[contentHeight] - i[containerHeight]) /
      (i[railYHeight] - i[scrollbarYHeight]);

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    i[scrollbarYRail].classList.add(cls.state.clicking);

    e.stopPropagation();
    e.preventDefault();
  });
}

var keyboard = function(i) {
  var element = i.element;

  var elementHovered = function () { return matches(element, ':hover'); };
  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (
        (scrollTop === 0 && deltaY > 0) ||
        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (
        (scrollLeft === 0 && deltaX < 0) ||
        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (
      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
      e.defaultPrevented
    ) {
      return;
    }

    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }

    var activeElement = document.activeElement
      ? document.activeElement
      : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
      case 37: // left
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38: // up
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39: // right
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40: // down
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32: // space bar
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33: // page up
        deltaY = i.containerHeight;
        break;
      case 34: // page down
        deltaY = -i.containerHeight;
        break;
      case 36: // home
        deltaY = i.contentHeight;
        break;
      case 35: // end
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }

    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }

    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);

    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
};

var wheel = function(i) {
  var element = i.element;

  function shouldPreventDefault(deltaX, deltaY) {
    var roundedScrollTop = Math.floor(element.scrollTop);
    var isTop = element.scrollTop === 0;
    var isBottom =
      roundedScrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight =
      element.scrollLeft + element.offsetWidth === element.scrollWidth;

    var hitsBound;

    // pick axis with primary direction
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }

    return hitsBound ? !i.settings.wheelPropagation : true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector('select:focus')) {
      return true;
    }

    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function mousewheelHandler(e) {
    var ref = getDeltaFromEvent(e);
    var deltaX = ref[0];
    var deltaY = ref[1];

    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }

    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }

    updateGeometry(i);

    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== 'undefined') {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== 'undefined') {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
};

var touch = function(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }

  var element = i.element;

  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (
        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
        (deltaY > 0 && scrollTop === 0)
      ) {
        // set prevent for mobile Chrome refresh
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (
        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
        (deltaX > 0 && scrollLeft === 0)
      ) {
        return true;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;

    updateGeometry(i);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }

  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (
      e.pointerType &&
      e.pointerType !== 'mouse' &&
      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
    ) {
      return true;
    }
    return false;
  }

  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }

    var touch = getTouch(e);

    startOffset.pageX = touch.pageX;
    startOffset.pageY = touch.pageY;

    startTime = new Date().getTime();

    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = new Date().getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (env.supportsTouch) {
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
};

var defaultSettings = function () { return ({
  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollingThreshold: 1000,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: true,
  wheelSpeed: 1,
}); };

var handlers = {
  'click-rail': clickRail,
  'drag-thumb': dragThumb,
  keyboard: keyboard,
  wheel: wheel,
  touch: touch,
};

var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
  var this$1 = this;
  if ( userSettings === void 0 ) userSettings = {};

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element || !element.nodeName) {
    throw new Error('no element is specified to initialize PerfectScrollbar');
  }

  this.element = element;

  element.classList.add(cls.main);

  this.settings = defaultSettings();
  for (var key in userSettings) {
    this$1.settings[key] = userSettings[key];
  }

  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;

  var focus = function () { return element.classList.add(cls.state.focus); };
  var blur = function () { return element.classList.remove(cls.state.focus); };

  this.isRtl = get(element).direction === 'rtl';
  this.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? element.scrollWidth - element.clientWidth
    : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;

  this.scrollbarXRail = div(cls.element.rail('x'));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb('x'));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarX, 'focus', focus);
  this.event.bind(this.scrollbarX, 'blur', blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }
  this.railBorderXWidth =
    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  // Set rail to display:block to calculate margins
  set(this.scrollbarXRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set(this.scrollbarXRail, { display: '' });
  this.railXWidth = null;
  this.railXRatio = null;

  this.scrollbarYRail = div(cls.element.rail('y'));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb('y'));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarY, 'focus', focus);
  this.event.bind(this.scrollbarY, 'blur', blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth =
    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set(this.scrollbarYRail, { display: 'block' });
  this.railYMarginHeight =
    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set(this.scrollbarYRail, { display: '' });
  this.railYHeight = null;
  this.railYRatio = null;

  this.reach = {
    x:
      element.scrollLeft <= 0
        ? 'start'
        : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
    y:
      element.scrollTop <= 0
        ? 'start'
        : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
  };

  this.isAlive = true;

  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

  this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
  this.lastScrollLeft = element.scrollLeft; // for onScroll only
  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
  updateGeometry(this);
};

PerfectScrollbar.prototype.update = function update () {
  if (!this.isAlive) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? this.element.scrollWidth - this.element.clientWidth
    : 0;

  // Recalculate rail margins
  set(this.scrollbarXRail, { display: 'block' });
  set(this.scrollbarYRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(get(this.scrollbarXRail).marginLeft) +
    toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight =
    toInt(get(this.scrollbarYRail).marginTop) +
    toInt(get(this.scrollbarYRail).marginBottom);

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  set(this.scrollbarXRail, { display: 'none' });
  set(this.scrollbarYRail, { display: 'none' });

  updateGeometry(this);

  processScrollDiff(this, 'top', 0, false, true);
  processScrollDiff(this, 'left', 0, false, true);

  set(this.scrollbarXRail, { display: '' });
  set(this.scrollbarYRail, { display: '' });
};

PerfectScrollbar.prototype.onScroll = function onScroll (e) {
  if (!this.isAlive) {
    return;
  }

  updateGeometry(this);
  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    'left',
    this.element.scrollLeft - this.lastScrollLeft
  );

  this.lastScrollTop = Math.floor(this.element.scrollTop);
  this.lastScrollLeft = this.element.scrollLeft;
};

PerfectScrollbar.prototype.destroy = function destroy () {
  if (!this.isAlive) {
    return;
  }

  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();

  // unset elements
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;

  this.isAlive = false;
};

PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
  this.element.className = this.element.className
    .split(' ')
    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
    .join(' ');
};

/* harmony default export */ __webpack_exports__["a"] = (PerfectScrollbar);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__(748));

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(749));

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popper.default;
  }
});

var _Popper = _interopRequireDefault(__webpack_require__(751));

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_hoverCardStyle_jsx__ = __webpack_require__(763);
// ##############################
// // // Dashboard View styles
// #############################
var dashboardStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_hoverCardStyle_jsx__["a" /* default */],{tooltip:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["A" /* tooltip */],cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"0px",marginBottom:"3px"}),cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),cardProductTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"0px",marginBottom:"3px",textAlign:"center"}),cardCategory:{color:"#999999",fontSize:"14px",paddingTop:"10px",marginBottom:"0",marginTop:"0",margin:"0"},cardProductDesciprion:{textAlign:"center",color:"#999999"},stats:{color:"#999999",fontSize:"12px",lineHeight:"22px",display:"inline-flex","& svg":{position:"relative",top:"4px",width:"16px",height:"16px",marginRight:"3px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{position:"relative",top:"4px",fontSize:"16px",marginRight:"3px"}},productStats:{paddingTop:"7px",paddingBottom:"7px",margin:"0"},successText:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},upArrowCardCategory:{width:14,height:14},underChartIcons:{width:"17px",height:"17px"},price:{color:"inherit","& h4":{marginBottom:"0px",marginTop:"0px"}}});/* harmony default export */ __webpack_exports__["a"] = (dashboardStyle);

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
})), 'Dashboard');

exports.default = _default;

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(162);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Modal component styles
// #############################
var modalStyle=function modalStyle(theme){var _modal;return Object.assign({modalRoot:{overflow:"auto",alignItems:"unset",justifyContent:"unset"},modal:(_modal={},_defineProperty(_modal,theme.breakpoints.up("sm"),{maxWidth:"800px",margin:"1.75rem auto"}),_defineProperty(_modal,"borderRadius","6px"),_defineProperty(_modal,"marginTop","100px !important"),_defineProperty(_modal,"overflow","visible"),_defineProperty(_modal,"maxHeight","unset"),_defineProperty(_modal,"position","relative"),_defineProperty(_modal,"height","fit-content"),_modal),modalHeader:{borderBottom:"none",paddingTop:"24px",paddingRight:"24px",paddingBottom:"0",paddingLeft:"24px",minHeight:"16.43px"},modalTitle:{margin:"0",lineHeight:"1.42857143"},modalCloseButton:{color:"#999999",marginTop:"-12px",WebkitAppearance:"none",padding:"0",cursor:"pointer",background:"0 0",border:"0",fontSize:"inherit",opacity:".9",textShadow:"none",fontWeight:"700",lineHeight:"1",float:"right"},modalClose:{width:"16px",height:"16px"},modalBody:{paddingTop:"24px",paddingRight:"24px",paddingBottom:"16px",paddingLeft:"24px",position:"relative",overflow:"visible"},modalFooter:{padding:"15px",textAlign:"right",paddingTop:"0",margin:"0"},modalFooterCenter:{marginLeft:"auto",marginRight:"auto"},instructionNoticeModal:{marginBottom:"25px"},imageNoticeModal:{maxWidth:"150px"},modalSmall:{width:"300px"},modalSmallBody:{paddingTop:"0"},modalSmallFooterFirstButton:{margin:"0",paddingLeft:"16px",paddingRight:"16px",width:"auto"},modalSmallFooterSecondButton:{marginBottom:"0",marginLeft:"5px"}},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */]);};/* harmony default export */ __webpack_exports__["a"] = (modalStyle);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _IconButton = _interopRequireDefault(__webpack_require__(134));

// @inheritedComponent IconButton
var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none',
    '&:hover': {
      // Disable the hover effect for the IconButton.
      backgroundColor: 'transparent'
    }
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var SwitchBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwitchBase, _React$Component);

  function SwitchBase(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwitchBase).call(this));
    _this.input = null;
    _this.isControlled = null;
    _this.state = {};

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({
          checked: checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    };

    _this.isControlled = props.checked != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }

    return _this;
  }

  (0, _createClass2.default)(SwitchBase, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          checkedProp = _this$props.checked,
          checkedIcon = _this$props.checkedIcon,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          disabledProp = _this$props.disabled,
          icon = _this$props.icon,
          id = _this$props.id,
          inputProps = _this$props.inputProps,
          inputRef = _this$props.inputRef,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          readOnly = _this$props.readOnly,
          required = _this$props.required,
          tabIndex = _this$props.tabIndex,
          type = _this$props.type,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;
      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var hasLabelFor = type === 'checkbox' || type === 'radio';
      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        component: "span",
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
        autoFocus: autoFocus,
        checked: checked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: this.handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
      }, inputProps)));
    }
  }]);
  return SwitchBase;
}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string.isRequired,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
SwitchBase.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitchBase'
})(SwitchBase);

exports.default = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)(module)))

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_LinearProgress__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_customLinearProgressStyle_jsx__ = __webpack_require__(875);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function CustomLinearProgress(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,color=props.color,rest=_objectWithoutProperties(props,["classes","color"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_LinearProgress___default.a,Object.assign({},rest,{classes:{root:classes.root+" "+classes[color+"Background"],bar:classes.bar+" "+classes[color]}}));}CustomLinearProgress.defaultProps={color:"gray"};CustomLinearProgress.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose","gray"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_4_assets_jss_material_dashboard_pro_react_components_customLinearProgressStyle_jsx__["a" /* default */])(CustomLinearProgress));

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
})), 'Assignment');

exports.default = _default;

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



//
/* harmony default export */ __webpack_exports__["a"] = ({
  get: get,
  set: set,
  takeRight: takeRight,
  last: last,
  orderBy: orderBy,
  range: range,
  remove: remove,
  clone: clone,
  getFirstDefined: getFirstDefined,
  sum: sum,
  makeTemplateComponent: makeTemplateComponent,
  groupBy: groupBy,
  isArray: isArray,
  splitProps: splitProps,
  compactObject: compactObject,
  isSortingDesc: isSortingDesc,
  normalizeComponent: normalizeComponent,
  asPx: asPx
});

function get(obj, path, def) {
  if (!path) {
    return obj;
  }
  var pathObj = makePathArray(path);
  var val = void 0;
  try {
    val = pathObj.reduce(function (current, pathPart) {
      return current[pathPart];
    }, obj);
  } catch (e) {
    // continue regardless of error
  }
  return typeof val !== 'undefined' ? val : def;
}

function set() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments[1];
  var value = arguments[2];

  var keys = makePathArray(path);
  var keyPart = void 0;
  var cursor = obj;
  while ((keyPart = keys.shift()) && keys.length) {
    if (!cursor[keyPart]) {
      cursor[keyPart] = {};
    }
    cursor = cursor[keyPart];
  }
  cursor[keyPart] = value;
  return obj;
}

function takeRight(arr, n) {
  var start = n > arr.length ? 0 : arr.length - n;
  return arr.slice(start);
}

function last(arr) {
  return arr[arr.length - 1];
}

function range(n) {
  var arr = [];
  for (var i = 0; i < n; i += 1) {
    arr.push(n);
  }
  return arr;
}

function orderBy(arr, funcs, dirs, indexKey) {
  return arr.sort(function (rowA, rowB) {
    for (var i = 0; i < funcs.length; i += 1) {
      var comp = funcs[i];
      var desc = dirs[i] === false || dirs[i] === 'desc';
      var sortInt = comp(rowA, rowB);
      if (sortInt) {
        return desc ? -sortInt : sortInt;
      }
    }
    // Use the row index for tie breakers
    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
  });
}

function remove(a, b) {
  return a.filter(function (o, i) {
    var r = b(o);
    if (r) {
      a.splice(i, 1);
      return true;
    }
    return false;
  });
}

function clone(a) {
  try {
    return JSON.parse(JSON.stringify(a, function (key, value) {
      if (typeof value === 'function') {
        return value.toString();
      }
      return value;
    }));
  } catch (e) {
    return a;
  }
}

function getFirstDefined() {
  for (var i = 0; i < arguments.length; i += 1) {
    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
      return arguments.length <= i ? undefined : arguments[i];
    }
  }
}

function sum(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}

function makeTemplateComponent(compClass, displayName) {
  if (!displayName) {
    throw new Error('No displayName found for template component:', compClass);
  }
  var cmp = function cmp(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(compClass, className) }, rest),
      children
    );
  };
  cmp.displayName = displayName;
  return cmp;
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x, i) {
    var resKey = typeof key === 'function' ? key(x, i) : x[key];
    rv[resKey] = isArray(rv[resKey]) ? rv[resKey] : [];
    rv[resKey].push(x);
    return rv;
  }, {});
}

function asPx(value) {
  value = Number(value);
  return Number.isNaN(value) ? null : value + 'px';
}

function isArray(a) {
  return Array.isArray(a);
}

// ########################################################################
// Non-exported Helpers
// ########################################################################

function makePathArray(obj) {
  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
}

function flattenDeep(arr) {
  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!isArray(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i += 1) {
      flattenDeep(arr[i], newArr);
    }
  }
  return newArr;
}

function splitProps(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      rest = _objectWithoutProperties(_ref2, ['className', 'style']);

  return {
    className: className,
    style: style,
    rest: rest || {}
  };
}

function compactObject(obj) {
  var newObj = {};
  if (obj) {
    Object.keys(obj).map(function (key) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
        newObj[key] = obj[key];
      }
      return true;
    });
  }
  return newObj;
}

function isSortingDesc(d) {
  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
}

function normalizeComponent(Comp) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;

  return typeof Comp === 'function' ? Object.getPrototypeOf(Comp).isReactComponent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Comp, params) : Comp(params) : fallback;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(260)('keys');
var uid = __webpack_require__(184);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(44);
var global = __webpack_require__(71);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(183) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(920);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(107);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 263 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(106);
var dPs = __webpack_require__(927);
var enumBugKeys = __webpack_require__(266);
var IE_PROTO = __webpack_require__(259)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(418)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(930).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 265 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 266 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(73).f;
var has = __webpack_require__(85);
var TAG = __webpack_require__(50)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(50);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var core = __webpack_require__(44);
var LIBRARY = __webpack_require__(183);
var wksExt = __webpack_require__(268);
var defineProperty = __webpack_require__(73).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(952),
    shortOut = __webpack_require__(433);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(140),
    baseLodash = __webpack_require__(274);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(446);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(279),
    createBaseEach = __webpack_require__(1006);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(998),
    keys = __webpack_require__(113);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1001),
    isObjectLike = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1003),
    baseUnary = __webpack_require__(193),
    nodeUtil = __webpack_require__(283);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(431);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)(module)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(195),
    stackClear = __webpack_require__(1014),
    stackDelete = __webpack_require__(1015),
    stackGet = __webpack_require__(1016),
    stackHas = __webpack_require__(1017),
    stackSet = __webpack_require__(1018);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1019),
    mapCacheDelete = __webpack_require__(1026),
    mapCacheGet = __webpack_require__(1028),
    mapCacheHas = __webpack_require__(1029),
    mapCacheSet = __webpack_require__(1030);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1041),
    stubArray = __webpack_require__(458);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(37),
    isSymbol = __webpack_require__(141);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(293),
    eq = __webpack_require__(143);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(430);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), _react.default.createElement("path", {
  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
})), 'Timeline');

exports.default = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(92));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(295);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(471));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(21);

var _dates = _interopRequireDefault(__webpack_require__(32));

var _DayColumn = _interopRequireDefault(__webpack_require__(1139));

var _TimeGutter = _interopRequireDefault(__webpack_require__(1149));

var _width = _interopRequireDefault(__webpack_require__(481));

var _TimeGridHeader = _interopRequireDefault(__webpack_require__(1150));

var _helpers = __webpack_require__(116);

var _eventLevels = __webpack_require__(149);

var _Resources = _interopRequireDefault(__webpack_require__(1151));

var TimeGrid =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TimeGrid, _Component);

  function TimeGrid(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleScroll = function (e) {
      if (_this.scrollRef.current) {
        _this.scrollRef.current.scrollLeft = e.target.scrollLeft;
      }
    };

    _this.handleResize = function () {
      _requestAnimationFrame.default.cancel(_this.rafHandle);

      _this.rafHandle = (0, _requestAnimationFrame.default)(_this.checkOverflow);
    };

    _this.gutterRef = function (ref) {
      _this.gutter = ref && (0, _reactDom.findDOMNode)(ref);
    };

    _this.handleSelectAlldayEvent = function () {
      //cancel any pending selections so only the event click goes through.
      _this.clearSelection();

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (0, _helpers.notify)(_this.props.onSelectEvent, args);
    };

    _this.handleSelectAllDaySlot = function (slots, slotInfo) {
      var onSelectSlot = _this.props.onSelectSlot;
      (0, _helpers.notify)(onSelectSlot, {
        slots: slots,
        start: slots[0],
        end: slots[slots.length - 1],
        action: slotInfo.action
      });
    };

    _this.checkOverflow = function () {
      if (_this._updatingOverflow) return;
      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;

      if (_this.state.isOverflowing !== isOverflowing) {
        _this._updatingOverflow = true;

        _this.setState({
          isOverflowing: isOverflowing
        }, function () {
          _this._updatingOverflow = false;
        });
      }
    };

    _this.state = {
      gutterWidth: undefined,
      isOverflowing: null
    };
    _this.scrollRef = _react.default.createRef();
    _this.resources = (0, _Resources.default)(props.resources, props.accessors);
    return _this;
  }

  var _proto = TimeGrid.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this.calculateScroll();
  };

  _proto.componentDidMount = function componentDidMount() {
    this.checkOverflow();

    if (this.props.width == null) {
      this.measureGutter();
    }

    this.applyScroll();
    window.addEventListener('resize', this.handleResize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);

    _requestAnimationFrame.default.cancel(this.rafHandle);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.width == null) {
      this.measureGutter();
    }

    this.applyScroll(); //this.checkOverflow()
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        range = _this$props.range,
        scrollToTime = _this$props.scrollToTime; // When paginating, reset scroll

    if (!_dates.default.eq(nextProps.range[0], range[0], 'minute') || !_dates.default.eq(nextProps.scrollToTime, scrollToTime, 'minute')) {
      this.calculateScroll(nextProps);
    }
  };

  _proto.renderEvents = function renderEvents(range, events, now) {
    var _this2 = this;

    var _this$props2 = this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        components = _this$props2.components,
        accessors = _this$props2.accessors,
        localizer = _this$props2.localizer;
    var groupedEvents = this.resources.groupEvents(events);
    return this.resources.map(function (_ref, i) {
      var id = _ref[0],
          resource = _ref[1];
      return range.map(function (date, jj) {
        var daysEvents = (groupedEvents.get(id) || []).filter(function (event) {
          return _dates.default.inRange(date, accessors.start(event), accessors.end(event), 'day');
        });
        return _react.default.createElement(_DayColumn.default, (0, _extends2.default)({}, _this2.props, {
          localizer: localizer,
          min: _dates.default.merge(date, min),
          max: _dates.default.merge(date, max),
          resource: resource && id,
          components: components,
          isNow: _dates.default.eq(date, now, 'day'),
          key: i + '-' + jj,
          date: date,
          events: daysEvents
        }));
      });
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        events = _this$props3.events,
        range = _this$props3.range,
        width = _this$props3.width,
        selected = _this$props3.selected,
        getNow = _this$props3.getNow,
        resources = _this$props3.resources,
        components = _this$props3.components,
        accessors = _this$props3.accessors,
        getters = _this$props3.getters,
        localizer = _this$props3.localizer,
        min = _this$props3.min,
        max = _this$props3.max,
        showMultiDayTimes = _this$props3.showMultiDayTimes,
        longPressThreshold = _this$props3.longPressThreshold;
    width = width || this.state.gutterWidth;
    var start = range[0],
        end = range[range.length - 1];
    this.slots = range.length;
    var allDayEvents = [],
        rangeEvents = [];
    events.forEach(function (event) {
      if ((0, _eventLevels.inRange)(event, start, end, accessors)) {
        var eStart = accessors.start(event),
            eEnd = accessors.end(event);

        if (accessors.allDay(event) || _dates.default.isJustDate(eStart) && _dates.default.isJustDate(eEnd) || !showMultiDayTimes && !_dates.default.eq(eStart, eEnd, 'day')) {
          allDayEvents.push(event);
        } else {
          rangeEvents.push(event);
        }
      }
    });
    allDayEvents.sort(function (a, b) {
      return (0, _eventLevels.sortEvents)(a, b, accessors);
    });
    return _react.default.createElement("div", {
      className: (0, _classnames.default)('rbc-time-view', resources && 'rbc-time-view-resources')
    }, _react.default.createElement(_TimeGridHeader.default, {
      range: range,
      events: allDayEvents,
      width: width,
      getNow: getNow,
      localizer: localizer,
      selected: selected,
      resources: this.resources,
      selectable: this.props.selectable,
      accessors: accessors,
      getters: getters,
      components: components,
      scrollRef: this.scrollRef,
      isOverflowing: this.state.isOverflowing,
      longPressThreshold: longPressThreshold,
      onSelectSlot: this.handleSelectAllDaySlot,
      onSelectEvent: this.handleSelectAlldayEvent,
      onDoubleClickEvent: this.props.onDoubleClickEvent,
      onDrillDown: this.props.onDrillDown,
      getDrilldownView: this.props.getDrilldownView
    }), _react.default.createElement("div", {
      ref: "content",
      className: "rbc-time-content",
      onScroll: this.handleScroll
    }, _react.default.createElement(_TimeGutter.default, {
      date: start,
      ref: this.gutterRef,
      localizer: localizer,
      min: _dates.default.merge(start, min),
      max: _dates.default.merge(start, max),
      step: this.props.step,
      getNow: this.props.getNow,
      timeslots: this.props.timeslots,
      components: components,
      className: "rbc-time-gutter"
    }), this.renderEvents(range, rangeEvents, getNow())));
  };

  _proto.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  _proto.measureGutter = function measureGutter() {
    var width = (0, _width.default)(this.gutter);

    if (width && this.state.gutterWidth !== width) {
      this.setState({
        gutterWidth: width
      });
    }
  };

  _proto.applyScroll = function applyScroll() {
    if (this._scrollRatio) {
      var content = this.refs.content;
      content.scrollTop = content.scrollHeight * this._scrollRatio; // Only do this once

      this._scrollRatio = null;
    }
  };

  _proto.calculateScroll = function calculateScroll(props) {
    if (props === void 0) {
      props = this.props;
    }

    var _props = props,
        min = _props.min,
        max = _props.max,
        scrollToTime = _props.scrollToTime;

    var diffMillis = scrollToTime - _dates.default.startOf(scrollToTime, 'day');

    var totalMillis = _dates.default.diff(max, min);

    this._scrollRatio = diffMillis / totalMillis;
  };

  return TimeGrid;
}(_react.Component);

exports.default = TimeGrid;
TimeGrid.propTypes = {
  events: _propTypes.default.array.isRequired,
  resources: _propTypes.default.array,
  step: _propTypes.default.number,
  timeslots: _propTypes.default.number,
  range: _propTypes.default.arrayOf(_propTypes.default.instanceOf(Date)),
  min: _propTypes.default.instanceOf(Date),
  max: _propTypes.default.instanceOf(Date),
  getNow: _propTypes.default.func.isRequired,
  scrollToTime: _propTypes.default.instanceOf(Date),
  showMultiDayTimes: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  width: _propTypes.default.number,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  selected: _propTypes.default.object,
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes.default.number,
  onNavigate: _propTypes.default.func,
  onSelectSlot: _propTypes.default.func,
  onSelectEnd: _propTypes.default.func,
  onSelectStart: _propTypes.default.func,
  onSelectEvent: _propTypes.default.func,
  onDoubleClickEvent: _propTypes.default.func,
  onDrillDown: _propTypes.default.func,
  getDrilldownView: _propTypes.default.func.isRequired
};
TimeGrid.defaultProps = {
  step: 30,
  timeslots: 2,
  min: _dates.default.startOf(new Date(), 'day'),
  max: _dates.default.endOf(new Date(), 'day'),
  scrollToTime: _dates.default.startOf(new Date(), 'day')
};
module.exports = exports["default"];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

function NoopWrapper(props) {
  return props.children;
}

var _default = NoopWrapper;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(455);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Home');

exports.default = _default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
})), 'Code');

exports.default = _default;

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Badge_Badge_jsx__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_timelineStyle_jsx__ = __webpack_require__(1196);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// core components
function Timeline(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,stories=props.stories,simple=props.simple;var timelineClass=classes.timeline+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({},classes.timelineSimple,simple));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:timelineClass},stories.map(function(prop,key){var _cx2;var panelClasses=classes.timelinePanel+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx2={},_defineProperty(_cx2,classes.timelinePanelInverted,prop.inverted),_defineProperty(_cx2,classes.timelineSimplePanel,simple),_cx2));var timelineBadgeClasses=classes.timelineBadge+" "+classes[prop.badgeColor]+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({},classes.timelineSimpleBadge,simple));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:classes.item,key:key},prop.badgeIcon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:timelineBadgeClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.badgeIcon,{className:classes.badgeIcon})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:panelClasses},prop.title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.timelineHeading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Badge_Badge_jsx__["a" /* default */],{color:prop.titleColor},prop.title)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.timelineBody},prop.body),prop.footerTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.footerTitle},prop.footerTitle):null,prop.footer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:classes.footerLine}):null,prop.footer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.timelineFooter},prop.footer):null));}));}Timeline.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,stories:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object).isRequired,simple:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_timelineStyle_jsx__["a" /* default */])(Timeline));

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(503);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(311);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(210);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(523)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(542);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(153);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(316);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(543);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(120);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(213);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(319);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(549);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(212);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(88);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(320);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(548);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(318);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(120);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(561));

var _jssNested = _interopRequireDefault(__webpack_require__(562));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(564));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(566));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(568));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(573));

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _getDisplayName = _interopRequireDefault(__webpack_require__(323));

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component,
      _options$noBase = options.noBase,
      noBase = _options$noBase === void 0 ? false : _options$noBase;

  if (!newClasses) {
    return baseClasses;
  }

  return (0, _extends2.default)({}, baseClasses, Object.keys(newClasses).reduce(function (accumulator, key) {
     false ? (0, _warning.default)(baseClasses[key] || noBase || !newClasses[key], ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _getDisplayName.default)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','))].join('\n')) : void 0;
     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _getDisplayName.default)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      accumulator[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }

    return accumulator;
  }, {}));
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionName = getFunctionName;
exports.default = void 0;
// Fork of recompose/getDisplayName with added IE11 support
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || getFunctionName(Component) || 'Component';
}

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(17));

/* eslint-disable no-underscore-dangle */
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0; // Code branch the whole block at the expense of more code.

    if (dangerouslyUseGlobalCSS) {
      if (styleSheet) {
        if (styleSheet.options.name) {
          return "".concat(styleSheet.options.name, "-").concat(rule.key);
        }

        if (styleSheet.options.classNamePrefix && "production" !== 'production') {
          var prefix = safePrefix(styleSheet.options.classNamePrefix);
          return "".concat(prefix, "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
        }
      }

      if (true) {
        return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
      }

      return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    if (true) {
      return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = safePrefix(styleSheet.options.classNamePrefix);

      return "".concat(_prefix, "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
  };
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!name || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});

var _AppBar = _interopRequireDefault(__webpack_require__(590));

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbar.default;
  }
});

var _Toolbar = _interopRequireDefault(__webpack_require__(592));

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(__webpack_require__(598));

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(600));

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(601));

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _style = _interopRequireDefault(__webpack_require__(218));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(157));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var _isOverflowing = _interopRequireDefault(__webpack_require__(608));

var _manageAriaHidden = __webpack_require__(609);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = {
    overflow: 'hidden'
  }; // We are only interested in the actual `style` here because we will override it.

  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  Object.keys(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });
  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.containers[containerIdx] = container

    this.containers = []; // this.data[containerIdx] = {
    //   modals: [],
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      var containerIdx = this.containers.indexOf(container);

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.containers.push(container);
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }

        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screan reader.
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(602));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(612));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(620);

var iterableToArray = __webpack_require__(621);

var nonIterableSpread = __webpack_require__(622);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(__webpack_require__(627));

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemText.default;
  }
});

var _ListItemText = _interopRequireDefault(__webpack_require__(628));

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
})), 'Menu');

exports.default = _default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(632));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(633));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_Pages_LoginPage_jsx__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_Pages_SignUpPage_jsx__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_PersonAdd__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_PersonAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_PersonAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint__);
//import PricingPage from "views/Pages/PricingPage.jsx";
//import LockScreenPage from "views/Pages/LockScreenPage.jsx";
// @material-ui/icons
//import MonetizationOn from "@material-ui/icons/MonetizationOn";
//import LockOpen from "@material-ui/icons/LockOpen";
var pagesRoutes=[{path:"/pages/register-page",name:"Register Page",short:"Register",mini:"RP",icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_PersonAdd___default.a,component:__WEBPACK_IMPORTED_MODULE_1_views_Pages_SignUpPage_jsx__["a" /* default */]},{path:"/pages/login-page",name:"Login Page",short:"Login",mini:"LP",icon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Fingerprint___default.a,component:__WEBPACK_IMPORTED_MODULE_0_containers_Pages_LoginPage_jsx__["a" /* default */]},// {
//   path: "/pages/pricing-page",
//   name: "Pricing Page",
//   short: "Pricing",
//   mini: "PP",
//   icon: MonetizationOn,
//   component: PricingPage
// },
// {
//   path: "/pages/lock-screen-page",
//   name: "Lock Screen Page",
//   short: "Lock",
//   mini: "LSP",
//   icon: LockOpen,
//   component: LockScreenPage
// },
{redirect:true,path:"/pages",pathTo:"/pages/login-page",name:"Login Page"}];/* harmony default export */ __webpack_exports__["a"] = (pagesRoutes);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__LoginAlert_jsx__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase_app__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_firebase_auth__ = __webpack_require__(169);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
//import Face from "@material-ui/icons/Face";
// import LockOutline from "@material-ui/icons/LockOutline";
// core components
//Firebase
var LoginPage=function(_React$Component){_inherits(LoginPage,_React$Component);function LoginPage(props){_classCallCheck(this,LoginPage);// we use this to make the card to appear after the page has been rendered
var _this=_possibleConstructorReturn(this,(LoginPage.__proto__||Object.getPrototypeOf(LoginPage)).call(this,props));_this.state={cardAnimaton:"cardHidden",alert:null,show:false,username:"",password:"",user:null};_this.handleLogin=_this.handleLogin.bind(_this);_this.loginFailedMessage=_this.loginFailedMessage.bind(_this);_this.hideAlert=_this.hideAlert.bind(_this);return _this;}_createClass(LoginPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;// we add a hidden class to the card and after 700 ms we delete it and the transition appears
this.timeOutFunction=setTimeout(function(){this.setState({cardAnimaton:""});}.bind(this),700);this.unsubscribe=__WEBPACK_IMPORTED_MODULE_17_firebase_app___default.a.auth().onAuthStateChanged(function(user){if(user){_this2.props.getInitialData();_this2.props.loginUser(user);}else{console.log("user is signed out");}});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timeOutFunction);this.timeOutFunction=null;this.unsubscribe();}},{key:"handleLogin",value:function handleLogin(){var _this3=this;__WEBPACK_IMPORTED_MODULE_17_firebase_app___default.a.auth().signInWithEmailAndPassword(this.state.username,this.state.password).catch(function(error){_this3.loginFailedMessage(error.message);});}},{key:"change",value:function change(event,type){switch(type){case"username":this.setState({username:event.target.value});break;case"password":this.setState({password:event.target.value});break;default:break;}}},{key:"loginFailedMessage",value:function loginFailedMessage(message){this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__LoginAlert_jsx__["a" /* default */],{message:message,hideAlert:this.hideAlert})});}},{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,classes=_props.classes,user=_props.user;if(user!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:"/dashboard"}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],{login:true,className:classes[this.state.cardAnimaton]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],{className:classes.cardHeader+" "+classes.textCenter,color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Log in"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.socialLine},["fab fa-facebook-square","fab fa-twitter","fab fa-google-plus"].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__["a" /* default */],{color:"transparent",justIcon:true,key:key,className:classes.customButtonClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:prop}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Email",id:"email",value:this.state.username,formControlProps:{fullWidth:true},inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon})),onChange:function onChange(event){return _this4.change(event,"username");}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Password",id:"password",value:this.state.password,formControlProps:{fullWidth:true,type:"password"},inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Icon___default.a,{className:classes.inputAdornmentIcon},"lock_outline")),onChange:function onChange(event){return _this4.change(event,"password");},type:"password",onKeyPress:function onKeyPress(event){if(event.key==="Enter")_this4.handleLogin();}}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__["a" /* default */],{className:classes.justifyContentCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",simple:true,size:"lg",block:true,onClick:this.handleLogin},"Let's Go")))))));}}]);return LoginPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);LoginPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loginUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__["a" /* default */])(LoginPage));

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(640));

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // LoginPage view styles
// #############################
var loginPageStyle=function loginPageStyle(theme){return{container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* container */],_defineProperty({zIndex:"4"},theme.breakpoints.down("sm"),{paddingBottom:"100px"})),cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{color:"#FFFFFF"}),textCenter:{textAlign:"center"},justifyContentCenter:{justifyContent:"center !important"},customButtonClass:{"&,&:focus,&:hover":{color:"#FFFFFF"},marginLeft:"5px",marginRight:"5px"},inputAdornment:{marginRight:"18px"},inputAdornmentIcon:{color:"#555"},cardHidden:{opacity:"0",transform:"translate3d(0, -60px, 0)"},cardHeader:{marginBottom:"20px"},socialLine:{padding:"0.9375rem 0"}};};/* harmony default export */ __webpack_exports__["a"] = (loginPageStyle);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_sweetalert__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginAlert=function(_Component){_inherits(LoginAlert,_Component);function LoginAlert(){_classCallCheck(this,LoginAlert);return _possibleConstructorReturn(this,(LoginAlert.__proto__||Object.getPrototypeOf(LoginAlert)).apply(this,arguments));}_createClass(LoginAlert,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap_sweetalert___default.a,{danger:true,style:{display:"block",marginTop:"-100px",color:"black"},title:this.props.message,onConfirm:function onConfirm(){return _this2.props.hideAlert();},onCancel:function onCancel(){return _this2.props.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success}));}}]);return LoginAlert;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LoginAlert.propTypes={message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hideAlert:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(LoginAlert));

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(98) && !__webpack_require__(129)(function () {
  return Object.defineProperty(__webpack_require__(349)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var document = __webpack_require__(59).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(673);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(350);
var IObject = __webpack_require__(225);
var toObject = __webpack_require__(226);
var toLength = __webpack_require__(227);
var asc = __webpack_require__(674);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(166);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(81);
var toIObject = __webpack_require__(99);
var arrayIndexOf = __webpack_require__(681)(false);
var IE_PROTO = __webpack_require__(230)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(164);
var dPs = __webpack_require__(695);
var enumBugKeys = __webpack_require__(231);
var IE_PROTO = __webpack_require__(230)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(349)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(696).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(353);
var hiddenKeys = __webpack_require__(231).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(236);
var $export = __webpack_require__(78);
var redefine = __webpack_require__(130);
var hide = __webpack_require__(79);
var Iterators = __webpack_require__(237);
var $iterCreate = __webpack_require__(706);
var setToStringTag = __webpack_require__(233);
var getPrototypeOf = __webpack_require__(707);
var ITERATOR = __webpack_require__(43)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(358);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = function () {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
};

var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            try {
                // In case of IE11, stack will be set only after error is raised.
                // https://docs.microsoft.com/en-us/scripting/javascript/reference/stack-property-error-javascript
                throw Error.apply(this, arguments);
            }
            catch (err) {
                this.name = ERROR_NAME;
                // Make non-enumerable getter for the property.
                Object.defineProperty(this, 'stack', {
                    get: function () {
                        return err.stack;
                    }
                });
            }
        }
    }
    return FirebaseError;
}());
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    tslib_1.__extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(Hash));

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.assert = assert;
exports.assertionError = assertionError;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.CONSTANTS = CONSTANTS;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
exports.Deferred = Deferred;
exports.getUA = getUA;
exports.isMobileCordova = isMobileCordova;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.patchCapture = patchCapture;
exports.jsonEval = jsonEval;
exports.stringify = stringify;
exports.decode = decode;
exports.isAdmin = isAdmin;
exports.issuedAtTime = issuedAtTime;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.clone = clone;
exports.contains = contains;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getValues = getValues;
exports.isEmpty = isEmpty;
exports.isNonNullObject = isNonNullObject;
exports.map = map;
exports.safeGet = safeGet;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.Sha1 = Sha1;
exports.async = async;
exports.createSubscribe = createSubscribe;
exports.errorPrefix = errorPrefix;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Context__ = __webpack_require__(239);









function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_8__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components,  create a custom React context with ' + "React.createContext(), and pass the context object to React-Redux's Provider and specific components" + ' like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      invariant(isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;
    var OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_6_react__["Component"];
    var FinalWrappedComponent = WrappedComponent;

    if (pure) {
      OuterBaseComponent = __WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"];
    }

    function makeDerivedPropsSelector() {
      var lastProps;
      var lastState;
      var lastDerivedProps;
      var lastStore;
      var sourceSelector;
      return function selectDerivedProps(state, props, store) {
        if (pure && lastProps === props && lastState === state) {
          return lastDerivedProps;
        }

        if (store !== lastStore) {
          lastStore = store;
          sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
        }

        lastProps = props;
        lastState = state;
        var nextProps = sourceSelector(state, props);

        if (lastDerivedProps === nextProps) {
          return lastDerivedProps;
        }

        lastDerivedProps = nextProps;
        return lastDerivedProps;
      };
    }

    function makeChildElementSelector() {
      var lastChildProps, lastForwardRef, lastChildElement;
      return function selectChildElement(childProps, forwardRef) {
        if (childProps !== lastChildProps || forwardRef !== lastForwardRef) {
          lastChildProps = childProps;
          lastForwardRef = forwardRef;
          lastChildElement = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FinalWrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, childProps, {
            ref: forwardRef
          }));
        }

        return lastChildElement;
      };
    }

    var Connect =
    /*#__PURE__*/
    function (_OuterBaseComponent) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _OuterBaseComponent);

      function Connect(props) {
        var _this;

        _this = _OuterBaseComponent.call(this, props) || this;
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
        _this.selectDerivedProps = makeDerivedPropsSelector();
        _this.selectChildElement = makeChildElementSelector();
        _this.renderWrappedComponent = _this.renderWrappedComponent.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        return _this;
      }

      var _proto = Connect.prototype;

      _proto.renderWrappedComponent = function renderWrappedComponent(value) {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
        var storeState = value.storeState,
            store = value.store;
        var wrapperProps = this.props;
        var forwardedRef;

        if (forwardRef) {
          wrapperProps = this.props.wrapperProps;
          forwardedRef = this.props.forwardedRef;
        }

        var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store);
        return this.selectChildElement(derivedProps, forwardedRef);
      };

      _proto.render = function render() {
        var ContextToUse = this.props.context || Context;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContextToUse.Consumer, null, this.renderWrappedComponent);
      };

      return Connect;
    }(OuterBaseComponent);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Connect, {
          wrapperProps: props,
          forwardedRef: ref
        });
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(362);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(363);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants={USER_LOGOUT:"USER_LOGOUT",SET_API_KEY:"SET_API_KEY",CLEAR_API_KEY:"CLEAR_API_KEY",SET_SMTP:"SET_SMTP",REMOVE_SMTP:"SET_SMTP",ADD_TEMP_LEAD:"ADD_TEMP_LEAD",CLEAR_TEMP_LEADS:"CLEAR_TEMP_LEADS",REMOVE_TEMP_LEAD:"ADD_TEMP_LEAD",SET_LEADS:"SET_LEADS",ADD_LEAD:"ADD_LEAD",REMOVE_LEAD:"REMOVE_LEAD",CLEAR_LEADS:"CLEAR_LEADS",ADD_CAMPAIGN:"ADD_CAMPAIGN",REMOVE_CAMPAIGN:"REMOVE_CAMPAIGN",SET_CAMPAIGN:"SET_CAMPAIGN",LOGIN_USER:"LOGIN_USER",LOGOUT_USER:"LOGOUT_USER",ADD_ERROR:"ADD_ERROR",CLEAR_ERROR:"CLEAR_ERROR",FETCH_LEADS:"FETCH_LEADS",CANCEL_FETCHING:"CANCEL_FETCHING",CHANGE_SUGGESTIONS:"CHANGE_SUGGESTIONS",CLEAR_SUGGESTIONS:"CLEAR_SUGGESTIONS"};/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(724);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var settle = __webpack_require__(730);
var cookies = __webpack_require__(731);
var buildURL = __webpack_require__(367);
var buildFullPath = __webpack_require__(732);
var parseHeaders = __webpack_require__(735);
var isURLSameOrigin = __webpack_require__(736);
var createError = __webpack_require__(370);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(368);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
})), 'PersonAdd');

exports.default = _default;

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Menu__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_MoreVert__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_MoreVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_MoreVert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ViewList__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ViewList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ViewList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HeaderLinks__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_components_headerStyle_jsx__ = __webpack_require__(754);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// material-ui icons
// core components
function Header(_ref){var props=_objectWithoutProperties(_ref,[]);function makeBrand(){var name;props.routes.map(function(prop,key){if(prop.collapse){prop.views.map(function(prop,key){if(prop.path===props.location.pathname){name=prop.name;}return null;});}if(prop.path===props.location.pathname){name=prop.name;}return null;});if(name){return name;}else{return"";}}var classes=props.classes,color=props.color,rtlActive=props.rtlActive;var appBarClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}," "+classes[color],color));var sidebarMinimize=classes.sidebarMinimize+" "+__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},classes.sidebarMinimizeRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar___default.a,{className:classes.appBar+appBarClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Toolbar___default.a,{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden___default.a,{smDown:true,implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:sidebarMinimize},props.miniActive?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"white",onClick:props.sidebarMinimize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ViewList___default.a,{className:classes.sidebarMiniIcon})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"white",onClick:props.sidebarMinimize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_MoreVert___default.a,{className:classes.sidebarMiniIcon})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.flex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{href:"#",className:classes.title,color:"transparent"},makeBrand())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden___default.a,{smDown:true,implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__HeaderLinks__["a" /* default */],{rtlActive:rtlActive})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Hidden___default.a,{mdUp:true,implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.appResponsive,color:"transparent",justIcon:true,"aria-label":"open drawer",onClick:props.handleDrawerToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Menu___default.a,null)))));}Header.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","info","success","warning","danger"]),rtlActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_components_headerStyle_jsx__["a" /* default */])(Header));

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ViewList');

exports.default = _default;

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_Actions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_MenuList__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_MenuList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ClickAwayListener__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ClickAwayListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grow__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Popper__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Person__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_components_headerLinksStyle__ = __webpack_require__(753);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Manager, Target, Popper } from "react-popper";
// @material-ui/core components
// @material-ui/icons
// import Notifications from "@material-ui/icons/Notifications";
// import Dashboard from "@material-ui/icons/Dashboard";
// import Search from "@material-ui/icons/Search";
// // core components
// import CustomInput from "components/CustomInput/CustomInput.jsx";
var HeaderLinks=function(_React$Component){_inherits(HeaderLinks,_React$Component);function HeaderLinks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderLinks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderLinks.__proto__||Object.getPrototypeOf(HeaderLinks)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.handleClick=function(){_this.setState({open:!_this.state.open});},_this.handleClose=function(){_this.setState({open:false});},_this.handleLogout=function(){_this.props.logoutUser();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderLinks,[{key:"render",value:function render(){var _this2=this,_classNames4;var _props=this.props,classes=_props.classes,rtlActive=_props.rtlActive;var open=this.state.open;// const searchButton =
//   classes.top +
//   " " +
//   classes.searchButton +
//   " " +
//   classNames({
//     [classes.searchRTL]: rtlActive
//   });
var dropdownItem=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes.dropdownItem,classes.primaryHover,_defineProperty({},classes.dropdownItemRTL,rtlActive));var wrapper=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({},classes.wrapperRTL,rtlActive));var managerClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({},classes.managerClasses,true));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:managerClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"transparent",justIcon:true,"aria-label":"Person","aria-owns":open?"menu-list":null,"aria-haspopup":"true",onClick:this.handleClick,className:rtlActive?classes.buttonLinkRTL:classes.buttonLink,muiClasses:{label:rtlActive?classes.labelRTL:""},buttonRef:function buttonRef(node){_this2.anchorEl=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Person___default.a,{className:classes.headerLinksSvg+" "+(rtlActive?classes.links+" "+classes.linksRTL:classes.links)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{mdUp:true,implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:this.handleClick,className:classes.linkText},"Profile"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Popper___default.a,{open:open,anchorEl:this.anchorEl,transition:true,disablePortal:true,placement:"bottom",className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames4={},_defineProperty(_classNames4,classes.popperClose,!open),_defineProperty(_classNames4,classes.pooperResponsive,true),_defineProperty(_classNames4,classes.pooperNav,true),_classNames4))},function(_ref2){var TransitionProps=_ref2.TransitionProps,placement=_ref2.placement;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grow___default.a,Object.assign({},TransitionProps,{id:"menu-list",style:{transformOrigin:"0 0 0"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:classes.dropdown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ClickAwayListener___default.a,{onClickAway:_this2.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_MenuList___default.a,{role:"menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{onClick:_this2.handleLogout,className:dropdownItem},"Logout")))));})));}}]);return HeaderLinks;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);HeaderLinks.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,rtlActive:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,logoutUser:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};//export default withStyles(headerLinksStyle)(HeaderLinks);
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{logoutUser:function logoutUser(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_Actions__["g" /* logoutUser */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_components_headerLinksStyle__["a" /* default */])(HeaderLinks)));

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Person');

exports.default = _default;

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var customDropdownStyle=function customDropdownStyle(theme){return{popperClose:{pointerEvents:"none",display:"none !important"},pooperNav:_defineProperty({},theme.breakpoints.down("sm"),{position:"static !important",left:"unset !important",top:"unset !important",transform:"none !important",willChange:"none !important","& > div":{boxShadow:"none !important",marginLeft:"1.5rem",marginRight:"1.5rem",transition:"none !important",marginTop:"0px !important",marginBottom:"5px !important",padding:"0px !important"}}),manager:{"& > div > button:first-child > span:first-child, & > div > a:first-child > span:first-child":{width:"100%"}},innerManager:{"& > div > button,& > div > a":{margin:"0px !important",color:"inherit !important",padding:"10px 20px !important","& > span:first-child":{width:"100%",justifyContent:"flex-start"}}},target:{"& > button:first-child > span:first-child, & > a:first-child > span:first-child":{display:"inline-block"},"& $caret":{marginLeft:"0px"}},dropdown:{borderRadius:"3px",border:"0",boxShadow:"0 2px 5px 0 rgba(0, 0, 0, 0.26)",top:"100%",zIndex:"1000",minWidth:"160px",padding:"5px 0",margin:"2px 0 0",fontSize:"14px",textAlign:"left",listStyle:"none",backgroundColor:"#fff",backgroundClip:"padding-box"},menuList:{padding:"0"},pooperResponsive:_defineProperty({zIndex:"1200"},theme.breakpoints.down("sm"),{zIndex:"1640",position:"static",float:"none",width:"auto",marginTop:"0",backgroundColor:"transparent",border:"0",boxShadow:"none",color:"black"}),dropdownItem:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{fontSize:"13px",padding:"10px 20px",margin:"0 5px",borderRadius:"2px",position:"relative",transition:"all 150ms linear",display:"block",clear:"both",fontWeight:"400",height:"100%",color:"#333",whiteSpace:"nowrap"}),darkHover:{"&:hover":{boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(33, 33, 33, 0.4)",backgroundColor:"#212121",color:"#fff"}},primaryHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */])},infoHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoBoxShadow */])},successHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successBoxShadow */])},warningHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["C" /* warningBoxShadow */])},dangerHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerBoxShadow */])},roseHover:{"&:hover":Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseBoxShadow */])},dropdownItemRTL:{textAlign:"right"},dropdownDividerItem:{margin:"5px 0",backgroundColor:"rgba(0, 0, 0, 0.12)",height:"1px",overflow:"hidden"},buttonIcon:{width:"20px",height:"20px"},caret:{transition:"all 150ms ease-in",display:"inline-block",width:"0",height:"0",marginLeft:"4px",verticalAlign:"middle",borderTop:"4px solid",borderRight:"4px solid transparent",borderLeft:"4px solid transparent"},caretActive:{transform:"rotate(180deg)"},caretDropup:{transform:"rotate(180deg)"},caretRTL:{marginRight:"4px"},dropdownHeader:{display:"block",padding:"0.1875rem 1.25rem",fontSize:"0.75rem",lineHeight:"1.428571",color:"#777",whiteSpace:"nowrap",fontWeight:"inherit",marginTop:"10px","&:hover,&:focus":{backgroundColor:"transparent",cursor:"auto"}},noLiPadding:{padding:"0"}};};/* harmony default export */ __webpack_exports__["a"] = (customDropdownStyle);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_List__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Header_HeaderLinks_jsx__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_components_sidebarStyle_jsx__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_img_faces_avatar_jpg__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_img_faces_avatar_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_assets_img_faces_avatar_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// javascript plugin used to create scrollbars on windows
// @material-ui/core components
// core components
var ps;// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
var SidebarWrapper=function(_React$Component){_inherits(SidebarWrapper,_React$Component);function SidebarWrapper(){_classCallCheck(this,SidebarWrapper);return _possibleConstructorReturn(this,(SidebarWrapper.__proto__||Object.getPrototypeOf(SidebarWrapper)).apply(this,arguments));}_createClass(SidebarWrapper,[{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){ps=new __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__["a" /* default */](this.refs.sidebarWrapper,{suppressScrollX:true,suppressScrollY:false});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(navigator.platform.indexOf("Win")>-1){ps.destroy();}}},{key:"render",value:function render(){var _props=this.props,className=_props.className,user=_props.user,headerLinks=_props.headerLinks,links=_props.links;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:className,ref:"sidebarWrapper"},user,headerLinks,links);}}]);return SidebarWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Sidebar=function(_React$Component2){_inherits(Sidebar,_React$Component2);function Sidebar(props){_classCallCheck(this,Sidebar);var _this2=_possibleConstructorReturn(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call(this,props));_this2.state={openAvatar:false,openComponents:_this2.activeRoute("/components"),openForms:_this2.activeRoute("/forms"),openTables:_this2.activeRoute("/tables"),openMaps:_this2.activeRoute("/maps"),openPages:_this2.activeRoute("-page"),miniActive:true};_this2.activeRoute.bind(_this2);return _this2;}// verifies if routeName is the one active (in browser input)
_createClass(Sidebar,[{key:"activeRoute",value:function activeRoute(routeName){return this.props.location.pathname.indexOf(routeName)>-1?true:false;}},{key:"openCollapse",value:function openCollapse(collapse){var st={};st[collapse]=!this.state[collapse];this.setState(st);}},{key:"render",value:function render(){var _cx,_cx2,_this3=this,_cx17,_cx20,_cx21;var _props2=this.props,classes=_props2.classes,color=_props2.color,logo=_props2.logo,image=_props2.image,logoText=_props2.logoText,routes=_props2.routes,bgColor=_props2.bgColor,rtlActive=_props2.rtlActive;var itemText=classes.itemText+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx={},_defineProperty(_cx,classes.itemTextMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx,classes.itemTextMiniRTL,rtlActive&&this.props.miniActive&&this.state.miniActive),_defineProperty(_cx,classes.itemTextRTL,rtlActive),_cx));var collapseItemText=classes.collapseItemText+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx2={},_defineProperty(_cx2,classes.collapseItemTextMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx2,classes.collapseItemTextMiniRTL,rtlActive&&this.props.miniActive&&this.state.miniActive),_defineProperty(_cx2,classes.collapseItemTextRTL,rtlActive),_cx2));var userWrapperClass=classes.user+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.whiteAfter,bgColor==="white"));var caret=classes.caret+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.caretRTL,rtlActive));var collapseItemMini=classes.collapseItemMini+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.collapseItemMiniRTL,rtlActive));var photo=classes.photo+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.photoRTL,rtlActive));var user=this.props.user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:userWrapperClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:photo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_16_assets_img_faces_avatar_jpg___default.a,className:classes.avatarImg,alt:"..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.item+" "+classes.userItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:"#",className:classes.itemLink+" "+classes.userCollapseButton,onClick:function onClick(){return _this3.openCollapse("openAvatar");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:rtlActive?"تانيا أندرو":"Tania Andrew",secondary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{className:caret+" "+classes.userCaret+" "+(this.state.openAvatar?classes.caretActive:"")}),disableTypography:true,className:itemText+" "+classes.userItemText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default.a,{"in":this.state.openAvatar,unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list+" "+classes.collapseList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.collapseItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:"#",className:classes.itemLink+" "+classes.userCollapseLinks},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:collapseItemMini},rtlActive?"مع":"MP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:rtlActive?"ملفي":"My Profile",disableTypography:true,className:collapseItemText}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.collapseItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:"#",className:classes.itemLink+" "+classes.userCollapseLinks},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:collapseItemMini},rtlActive?"هوع":"EP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:rtlActive?"تعديل الملف الشخصي":"Edit Profile",disableTypography:true,className:collapseItemText}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{className:classes.collapseItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:"#",className:classes.itemLink+" "+classes.userCollapseLinks},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:collapseItemMini},rtlActive?"و":"S"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:rtlActive?"إعدادات":"Settings",disableTypography:true,className:collapseItemText})))))))):null;var links=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list},routes.map(function(prop,key){var _cx15;if(prop.redirect){return null;}if(prop.hidden){return null;}if(prop.collapse){var _cx8,_cx9;var _navLinkClasses=classes.itemLink+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({}," "+classes.collapseActive,_this3.activeRoute(prop.path)));var _itemText=classes.itemText+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx8={},_defineProperty(_cx8,classes.itemTextMini,_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx8,classes.itemTextMiniRTL,rtlActive&&_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx8,classes.itemTextRTL,rtlActive),_cx8));var _collapseItemText=classes.collapseItemText+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx9={},_defineProperty(_cx9,classes.collapseItemTextMini,_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx9,classes.collapseItemTextMiniRTL,rtlActive&&_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx9,classes.collapseItemTextRTL,rtlActive),_cx9));var _itemIcon=classes.itemIcon+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.itemIconRTL,rtlActive));var _caret=classes.caret+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.caretRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{key:key,className:classes.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:"#",className:_navLinkClasses,onClick:function onClick(){return _this3.openCollapse(prop.state);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default.a,{className:_itemIcon},typeof prop.icon==="string"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon___default.a,null,prop.icon):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,secondary:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{className:_caret+" "+(_this3.state[prop.state]?classes.caretActive:"")}),disableTypography:true,className:_itemText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Collapse___default.a,{"in":_this3.state[prop.state],unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_List___default.a,{className:classes.list+" "+classes.collapseList},prop.views.map(function(prop,key){if(prop.redirect){return null;}var navLinkClasses=classes.collapseItemLink+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({}," "+classes[color],_this3.activeRoute(prop.path)));var collapseItemMini=classes.collapseItemMini+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.collapseItemMiniRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{key:key,className:classes.collapseItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:prop.path,className:navLinkClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:collapseItemMini},prop.mini),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,disableTypography:true,className:_collapseItemText})));}))));}var navLinkClasses=classes.itemLink+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({}," "+classes[color],_this3.activeRoute(prop.path)));var itemText=classes.itemText+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx15={},_defineProperty(_cx15,classes.itemTextMini,_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx15,classes.itemTextMiniRTL,rtlActive&&_this3.props.miniActive&&_this3.state.miniActive),_defineProperty(_cx15,classes.itemTextRTL,rtlActive),_cx15));var itemIcon=classes.itemIcon+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.itemIconRTL,rtlActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItem___default.a,{key:key,className:classes.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:prop.path,className:navLinkClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemIcon___default.a,{className:itemIcon},typeof prop.icon==="string"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon___default.a,null,prop.icon):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:prop.name,disableTypography:true,className:itemText})));}));var logoNormal=classes.logoNormal+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx17={},_defineProperty(_cx17,classes.logoNormalSidebarMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx17,classes.logoNormalSidebarMiniRTL,rtlActive&&this.props.miniActive&&this.state.miniActive),_defineProperty(_cx17,classes.logoNormalRTL,rtlActive),_cx17));var logoMini=classes.logoMini+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.logoMiniRTL,rtlActive));var logoClasses=classes.logo+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()(_defineProperty({},classes.whiteAfter,bgColor==="white"));var brand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:logoClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:"/dashboard",className:logoMini},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:logo,alt:"logo",className:classes.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:"/dashboard",className:logoNormal},logoText));var drawerPaper=classes.drawerPaper+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx20={},_defineProperty(_cx20,classes.drawerPaperMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx20,classes.drawerPaperRTL,rtlActive),_cx20));var sidebarWrapper=classes.sidebarWrapper+" "+__WEBPACK_IMPORTED_MODULE_4_classnames___default()((_cx21={},_defineProperty(_cx21,classes.drawerPaperMini,this.props.miniActive&&this.state.miniActive),_defineProperty(_cx21,classes.sidebarWrapperWithPerfectScrollbar,navigator.platform.indexOf("Win")>-1),_cx21));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:"mainPanel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{mdUp:true,implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default.a,{variant:"temporary",anchor:rtlActive?"left":"right",open:this.props.open,classes:{paper:drawerPaper+" "+classes[bgColor+"Background"]},onClose:this.props.handleDrawerToggle,ModalProps:{keepMounted:true// Better open performance on mobile.
}},brand,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SidebarWrapper,{className:sidebarWrapper,user:user,headerLinks:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Header_HeaderLinks_jsx__["a" /* default */],{rtlActive:rtlActive}),links:links}),image!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.background,style:{backgroundImage:"url("+image+")"}}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Hidden___default.a,{smDown:true,implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Drawer___default.a,{onMouseOver:function onMouseOver(){return _this3.setState({miniActive:false});},onMouseOut:function onMouseOut(){return _this3.setState({miniActive:true});},anchor:rtlActive?"right":"left",variant:"permanent",open:true,classes:{paper:drawerPaper+" "+classes[bgColor+"Background"]}},brand,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SidebarWrapper,{className:sidebarWrapper,user:user,links:links}),image!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.background,style:{backgroundImage:"url("+image+")"}}):null)));}}]);return Sidebar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Sidebar.defaultProps={bgColor:"blue",user:false};Sidebar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["white","black","blue"]),rtlActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["white","red","orange","green","blue","purple","rose"]),logo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,logoText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,routes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_components_sidebarStyle_jsx__["a" /* default */])(Sidebar));

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(__webpack_require__(757));

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar.7a6bc100.jpg";

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sidebarLinks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_Components_Buttons_jsx__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_views_Components_GridSystem_jsx__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_Components_Panels_jsx__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Components_SweetAlert_jsx__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Components_Notifications_jsx__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Components_Icons_jsx__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_Components_Typography_jsx__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Forms_RegularForms_jsx__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Forms_ExtendedForms_jsx__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Forms_ValidationForms_jsx__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_Forms_Wizard_jsx__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_Tables_RegularTables_jsx__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_Tables_ExtendedTables_jsx__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_Tables_ReactTables_jsx__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_Maps_GoogleMaps_jsx__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_Maps_FullScreenMap_jsx__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_Maps_VectorMap_jsx__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_Charts_Charts_jsx__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_Calendar_Calendar_jsx__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_Widgets_Widgets_jsx__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_Pages_UserProfile_jsx__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_Pages_Timeline_jsx__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_Pages_RTLSupport_jsx__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_Pages_PricingPage_jsx__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_Pages_LoginPage_jsx__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_views_Pages_RegisterPage_jsx__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_views_Pages_LockScreenPage_jsx__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_icons_Dashboard__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_icons_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__material_ui_icons_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_icons_Image__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_icons_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__material_ui_icons_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__material_ui_icons_Apps__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__material_ui_icons_Apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__material_ui_icons_Apps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__material_ui_icons_GridOn__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__material_ui_icons_GridOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__material_ui_icons_GridOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_icons_Place__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_icons_Place___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__material_ui_icons_Place__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_icons_Widgets__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_icons_Widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__material_ui_icons_Widgets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_icons_Timeline__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_icons_DateRange__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_icons_DateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__material_ui_icons_DateRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__material_ui_icons_PersonAdd__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__material_ui_icons_PersonAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__material_ui_icons_PersonAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__material_ui_icons_Fingerprint__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__material_ui_icons_Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__material_ui_icons_Fingerprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__material_ui_icons_MonetizationOn__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__material_ui_icons_MonetizationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__material_ui_icons_MonetizationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__material_ui_icons_LockOpen__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__material_ui_icons_LockOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__material_ui_icons_LockOpen__);
// @material-ui/icons
// import ContentPaste from "@material-ui/icons/ContentPaste";
var rtlRoutes=[{path:"/rtl/rtl-support-page",name:"دعم رتل",mini:"ص",component:__WEBPACK_IMPORTED_MODULE_23_views_Pages_RTLSupport_jsx__["a" /* default */]},{redirect:true,path:"/rtl",pathTo:"/rtl/rtl-support-page",name:"RTL Support"}];var sidebarLinks=[{path:"/dashboard",name:"لوحة القيادة ة",icon:__WEBPACK_IMPORTED_MODULE_28__material_ui_icons_Dashboard___default.a,component:__WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__["a" /* default */]},{collapse:true,path:"-page",name:"صفحات",state:"openPages",icon:__WEBPACK_IMPORTED_MODULE_29__material_ui_icons_Image___default.a,views:[{path:"/timeline-page",name:"الجدول الزمني",mini:"ر",component:__WEBPACK_IMPORTED_MODULE_22_views_Pages_Timeline_jsx__["a" /* default */]},{path:"/user-page",name:"ملف تعريفي للمستخدم",mini:"شع",component:__WEBPACK_IMPORTED_MODULE_21_views_Pages_UserProfile_jsx__["a" /* default */]},{path:"/rtl/rtl-support-page",name:"دعم رتل",mini:"ص",component:__WEBPACK_IMPORTED_MODULE_23_views_Pages_RTLSupport_jsx__["a" /* default */]},{path:"/pages/register-page",name:"سجل الصفحة",short:"سجل الصفحة",mini:"صع",icon:__WEBPACK_IMPORTED_MODULE_36__material_ui_icons_PersonAdd___default.a,component:__WEBPACK_IMPORTED_MODULE_26_views_Pages_RegisterPage_jsx__["a" /* default */]},{path:"/pages/login-page",name:"صفحة تسجيل الدخول",short:"صفحة تسجيل الدخول",mini:"هعذا",icon:__WEBPACK_IMPORTED_MODULE_37__material_ui_icons_Fingerprint___default.a,component:__WEBPACK_IMPORTED_MODULE_25_views_Pages_LoginPage_jsx__["a" /* default */]},{path:"/pages/pricing-page",name:"التسعير",short:"التسعير",mini:"ع",icon:__WEBPACK_IMPORTED_MODULE_38__material_ui_icons_MonetizationOn___default.a,component:__WEBPACK_IMPORTED_MODULE_24_views_Pages_PricingPage_jsx__["a" /* default */]},{path:"/pages/lock-screen-page",name:"قفل صفحة الشاشة",short:"قفل صفحة الشاشة",mini:"هذاع",icon:__WEBPACK_IMPORTED_MODULE_39__material_ui_icons_LockOpen___default.a,component:__WEBPACK_IMPORTED_MODULE_27_views_Pages_LockScreenPage_jsx__["a" /* default */]},{redirect:true,path:"/pages",pathTo:"/pages/register-page",name:"Register Page"}]},{collapse:true,path:"/components",name:"المكونات",state:"openComponents",icon:__WEBPACK_IMPORTED_MODULE_30__material_ui_icons_Apps___default.a,views:[{path:"/components/buttons",name:"وصفتت",mini:"بت",component:__WEBPACK_IMPORTED_MODULE_1_views_Components_Buttons_jsx__["a" /* default */]},{path:"/components/grid-system",name:"نظام الشبكةو",mini:"زو",component:__WEBPACK_IMPORTED_MODULE_2_views_Components_GridSystem_jsx__["a" /* default */]},{path:"/components/panels",name:"لوحات",mini:"ع",component:__WEBPACK_IMPORTED_MODULE_3_views_Components_Panels_jsx__["a" /* default */]},{path:"/components/sweet-alert",name:"التنبيه الحلو",mini:"ومن",component:__WEBPACK_IMPORTED_MODULE_4_views_Components_SweetAlert_jsx__["a" /* default */]},{path:"/components/notifications",name:"إخطارات",mini:"ن",component:__WEBPACK_IMPORTED_MODULE_5_views_Components_Notifications_jsx__["a" /* default */]},{path:"/components/icons",name:"الرموز",mini:"و",component:__WEBPACK_IMPORTED_MODULE_6_views_Components_Icons_jsx__["a" /* default */]},{path:"/components/typography",name:"طباعة",mini:"ر",component:__WEBPACK_IMPORTED_MODULE_7_views_Components_Typography_jsx__["a" /* default */]}]},{collapse:true,path:"/forms",name:"إستمارات",state:"openForms",icon:"content_paste",views:[{path:"/forms/regular-forms",name:"أشكال منتظمة",mini:"صو",component:__WEBPACK_IMPORTED_MODULE_8_views_Forms_RegularForms_jsx__["a" /* default */]},{path:"/forms/extended-forms",name:"أشكال موسعة",mini:"هوو",component:__WEBPACK_IMPORTED_MODULE_9_views_Forms_ExtendedForms_jsx__["a" /* default */]},{path:"/forms/validation-forms",name:"نماذج التحقق",mini:"تو",component:__WEBPACK_IMPORTED_MODULE_10_views_Forms_ValidationForms_jsx__["a" /* default */]},{path:"/forms/wizard",name:"ساحر",mini:"ث",component:__WEBPACK_IMPORTED_MODULE_11_views_Forms_Wizard_jsx__["a" /* default */]}]},{collapse:true,path:"/tables",name:"الجداول",state:"openTables",icon:__WEBPACK_IMPORTED_MODULE_31__material_ui_icons_GridOn___default.a,views:[{path:"/tables/regular-tables",name:"الجداول العادية",mini:"صر",component:__WEBPACK_IMPORTED_MODULE_12_views_Tables_RegularTables_jsx__["a" /* default */]},{path:"/tables/extended-tables",name:"الجداول الموسعة",mini:"هور",component:__WEBPACK_IMPORTED_MODULE_13_views_Tables_ExtendedTables_jsx__["a" /* default */]},{path:"/tables/react-tables",name:"رد فعل الجداول",mini:"غ",component:__WEBPACK_IMPORTED_MODULE_14_views_Tables_ReactTables_jsx__["a" /* default */]}]},{collapse:true,path:"/maps",name:"خرائط",state:"openMaps",icon:__WEBPACK_IMPORTED_MODULE_32__material_ui_icons_Place___default.a,views:[{path:"/maps/google-maps",name:"خرائط جوجل",mini:"زم",component:__WEBPACK_IMPORTED_MODULE_15_views_Maps_GoogleMaps_jsx__["a" /* default */]},{path:"/maps/full-screen-maps",name:"خريطة كاملة الشاشة",mini:"ووم",component:__WEBPACK_IMPORTED_MODULE_16_views_Maps_FullScreenMap_jsx__["a" /* default */]},{path:"/maps/vector-maps",name:"سهم التوجيه، الخريطة",mini:"تم",component:__WEBPACK_IMPORTED_MODULE_17_views_Maps_VectorMap_jsx__["a" /* default */]}]},{path:"/widgets",name:"الحاجيات",icon:__WEBPACK_IMPORTED_MODULE_33__material_ui_icons_Widgets___default.a,component:__WEBPACK_IMPORTED_MODULE_20_views_Widgets_Widgets_jsx__["a" /* default */]},{path:"/charts",name:"الرسوم البيانية",icon:__WEBPACK_IMPORTED_MODULE_34__material_ui_icons_Timeline___default.a,component:__WEBPACK_IMPORTED_MODULE_18_views_Charts_Charts_jsx__["a" /* default */]},{path:"/calendar",name:"التقويم",icon:__WEBPACK_IMPORTED_MODULE_35__material_ui_icons_DateRange___default.a,component:__WEBPACK_IMPORTED_MODULE_19_views_Calendar_Calendar_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (rtlRoutes);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Store__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Send__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Send___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Send__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Business__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Update__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_views_dashboardStyle__ = __webpack_require__(250);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
// import InfoOutline from "@material-ui/icons/InfoOutline";
//import Warning from "@material-ui/icons/Warning";
// core components
//import Danger from "components/Typography/Danger.jsx";
var Dashboard=function(_React$Component){_inherits(Dashboard,_React$Component);function Dashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:0},_this.handleChange=function(event,value){_this.setState({value:value});},_this.handleChangeIndex=function(index){_this.setState({value:index});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardHeader_jsx__["a" /* default */],{color:"warning",stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardIcon_jsx__["a" /* default */],{color:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon___default.a,null,"content_copy")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Total Leads"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle},this.props.leads," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Leads"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.stats},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Business___default.a,null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardHeader_jsx__["a" /* default */],{color:"success",stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardIcon_jsx__["a" /* default */],{color:"success"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Email___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Email Sent"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle},"0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.stats},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Send___default.a,null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardHeader_jsx__["a" /* default */],{color:"danger",stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardIcon_jsx__["a" /* default */],{color:"danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Email___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Emails Opened"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle},"0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.stats},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Email___default.a,null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardHeader_jsx__["a" /* default */],{color:"info",stats:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardIcon_jsx__["a" /* default */],{color:"info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Store___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Active Campaigns"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle},this.props.campaigns)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardFooter_jsx__["a" /* default */],{stats:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.stats},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Update___default.a,null)))))));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Dashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,leads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,campaigns:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_views_dashboardStyle__["a" /* default */])(Dashboard));

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
})), 'Business');

exports.default = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
})), 'KeyboardArrowRight');

exports.default = _default;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
})), 'Favorite');

exports.default = _default;

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_buttonGroupStyle_jsx__ = __webpack_require__(390);
// ##############################
// // // Buttons view styles
// #############################
var buttonsStyle=Object.assign({cardTitle:{marginTop:"0",marginBottom:"3px",color:"#3C4858",fontSize:"18px"},cardHeader:{zIndex:"3"},cardContentLeft:{padding:"15px 20px 15px 0px",position:"relative"},cardContentRight:{padding:"15px 20px 15px 0px",position:"relative"},cardContentBottom:{padding:"15px 0px 0px 0px",position:"relative"},marginRight:{marginRight:"5px"},icons:{width:"17px",height:"17px"}},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_buttonGroupStyle_jsx__["a" /* default */],{socialButtonsIcons:{fontSize:"18px",marginTop:"-2px",position:"relative"}});/* harmony default export */ __webpack_exports__["a"] = (buttonsStyle);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ##############################
// // // Button Group styles
// #############################
var buttonGroupStyle={buttonGroup:{position:"relative",margin:"10px 1px",display:"inline-block",verticalAlign:"middle"},firstButton:{borderTopRightRadius:"0",borderBottomRightRadius:"0",margin:"0",position:"relative",float:"left","&:hover":{zIndex:"2"}},middleButton:{borderRadius:"0",margin:"0",position:"relative",float:"left","&:hover":{zIndex:"2"}},lastButton:{borderTopLeftRadius:"0",borderBottomLeftRadius:"0",margin:"0","&:hover":{zIndex:"2"}}};/* harmony default export */ __webpack_exports__["a"] = (buttonGroupStyle);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_swipeable_views__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_swipeable_views___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_swipeable_views__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tabs__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_navPillsStyle_jsx__ = __webpack_require__(798);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// material-ui components
// core components
var NavPills=function(_React$Component){_inherits(NavPills,_React$Component);function NavPills(props){_classCallCheck(this,NavPills);var _this=_possibleConstructorReturn(this,(NavPills.__proto__||Object.getPrototypeOf(NavPills)).call(this,props));_this.handleChange=function(event,active){_this.setState({active:active});};_this.handleChangeIndex=function(index){_this.setState({active:index});};_this.state={active:props.active};return _this;}_createClass(NavPills,[{key:"render",value:function render(){var _classNames;var _props=this.props,classes=_props.classes,tabs=_props.tabs,direction=_props.direction,color=_props.color,horizontal=_props.horizontal,alignCenter=_props.alignCenter;var flexContainerClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.flexContainer,true),_defineProperty(_classNames,classes.horizontalDisplay,horizontal!==undefined),_classNames));var tabButtons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tabs___default.a,{classes:{root:classes.root,fixed:classes.fixed,flexContainer:flexContainerClasses,indicator:classes.displayNone},value:this.state.active,onChange:this.handleChange,centered:alignCenter},tabs.map(function(prop,key){var _classNames2;var icon={};if(prop.tabIcon!==undefined){icon["icon"]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.tabIcon,{className:classes.tabIcon});}var pillsClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames2={},_defineProperty(_classNames2,classes.pills,true),_defineProperty(_classNames2,classes.horizontalPills,horizontal!==undefined),_defineProperty(_classNames2,classes.pillsWithIcons,prop.tabIcon!==undefined),_classNames2));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab___default.a,Object.assign({label:prop.tabButton,key:key},icon,{classes:{root:pillsClasses,labelContainer:classes.labelContainer,label:classes.label,selected:classes[color]}}));}));var tabContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.contentWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_swipeable_views___default.a,{axis:direction==="rtl"?"x-reverse":"x",index:this.state.active,onChangeIndex:this.handleChangeIndex},tabs.map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.tabContent,key:key},prop.tabContent);})));return horizontal!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],horizontal.tabsGrid,tabButtons),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],horizontal.contentGrid,tabContent)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,tabButtons,tabContent);}}]);return NavPills;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);NavPills.defaultProps={active:0,color:"primary"};NavPills.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,// index of the default active pill
active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,tabs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({tabButton:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,tabIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,tabContent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node})).isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose"]),direction:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,horizontal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({tabsGrid:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,contentGrid:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object}),alignCenter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_navPillsStyle_jsx__["a" /* default */])(NavPills));

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
exports.default = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});

var _Tab = _interopRequireDefault(__webpack_require__(785));

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});

var _Tabs = _interopRequireDefault(__webpack_require__(787));

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(795));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(__webpack_require__(818));

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // SnackbarContent styles
// #############################
var snackbarContentStyle={root:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{flexWrap:"unset",position:"relative",padding:"20px 15px",lineHeight:"20px",marginBottom:"20px",fontSize:"14px",backgroundColor:"white",color:"#555555",borderRadius:"3px",boxShadow:"0 12px 20px -10px rgba(255, 255, 255, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(255, 255, 255, 0.2)"}),top20:{top:"20px"},top40:{top:"40px"},info:Object.assign({backgroundColor:"#00d3ee",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["o" /* infoBoxShadow */]),success:Object.assign({backgroundColor:"#5cb860",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["x" /* successBoxShadow */]),warning:Object.assign({backgroundColor:"#ffa21a",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["C" /* warningBoxShadow */]),danger:Object.assign({backgroundColor:"#f55a4e",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["g" /* dangerBoxShadow */]),primary:Object.assign({backgroundColor:"#af2cc5",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */]),rose:Object.assign({backgroundColor:"#eb3573",color:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["u" /* roseBoxShadow */]),message:{padding:"0",display:"block",maxWidth:"89%"},close:{width:"11px",height:"11px"},iconButton:{width:"24px",height:"24px",padding:"0"},icon:{width:"38px",height:"38px",display:"block",left:"15px",position:"absolute",marginTop:"-39px",fontSize:"20px",backgroundColor:"#FFFFFF",padding:"9px",borderRadius:"50%",maxWidth:"38px",boxShadow:"0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},infoIcon:{color:"#00d3ee"},successIcon:{color:"#5cb860"},warningIcon:{color:"#ffa21a"},dangerIcon:{color:"#f55a4e"},primaryIcon:{color:"#af2cc5"},roseIcon:{color:"#eb3573"},iconMessage:{paddingLeft:"50px",display:"block"}};/* harmony default export */ __webpack_exports__["a"] = (snackbarContentStyle);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_components_instructionStyle_jsx__ = __webpack_require__(822);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// core components
function Instruction(_ref){var _cx,_cx2;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,title=props.title,text=props.text,image=props.image,className=props.className,imageClassName=props.imageClassName,imageAlt=props.imageAlt;var instructionClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx={},_defineProperty(_cx,classes.instruction,true),_defineProperty(_cx,className,className!==undefined),_cx));var pictureClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx2={},_defineProperty(_cx2,classes.picture,true),_defineProperty(_cx2,imageClassName,imageClassName!==undefined),_cx2));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:instructionClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem__["a" /* default */],{xs:12,sm:12,md:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:pictureClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:image,alt:imageAlt,className:classes.image})))));}Instruction.defaultProps={imageAlt:"..."};Instruction.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,imageAlt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_components_instructionStyle_jsx__["a" /* default */])(Instruction));

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
})), 'MailOutline');

exports.default = _default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
})), 'Contacts');

exports.default = _default;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

/**
 * @ignore - internal component.
 */
var ArrowDropDown = function ArrowDropDown(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDropDown = (0, _pure.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';
var _default = ArrowDropDown;
exports.default = _default;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

/**
 * @ignore - internal component.
 */
function NativeSelectInput(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "IconComponent", "inputRef", "name", "onChange", "value", "variant"]);
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("select", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.select, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    name: name,
    disabled: disabled,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, other), children), _react.default.createElement(IconComponent, {
    className: classes.icon
  }));
}

NativeSelectInput.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
var _default = NativeSelectInput;
exports.default = _default;

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ClickAwayListener__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ClickAwayListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grow__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Popper__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_components_customDropdownStyle_jsx__ = __webpack_require__(380);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// @material-ui/core components
// core components
var CustomDropdown=function(_React$Component){_inherits(CustomDropdown,_React$Component);function CustomDropdown(props){_classCallCheck(this,CustomDropdown);var _this=_possibleConstructorReturn(this,(CustomDropdown.__proto__||Object.getPrototypeOf(CustomDropdown)).call(this,props));_this.handleClick=function(){_this.setState(function(state){return{open:!state.open};});};_this.handleClose=function(event){if(_this.anchorEl.contains(event.target)){return;}_this.setState({open:false});};_this.state={open:false};_this.handleClick=_this.handleClick.bind(_this);_this.handleClose=_this.handleClose.bind(_this);_this.handleCloseMenu=_this.handleCloseMenu.bind(_this);return _this;}_createClass(CustomDropdown,[{key:"handleCloseMenu",value:function handleCloseMenu(param){this.setState({open:false});if(this.props&&this.props.onClick){this.props.onClick(param);}}},{key:"render",value:function render(){var _classNames,_classNames2,_this2=this,_classNames3;var open=this.state.open;var _props=this.props,classes=_props.classes,buttonText=_props.buttonText,buttonIcon=_props.buttonIcon,dropdownList=_props.dropdownList,buttonProps=_props.buttonProps,dropup=_props.dropup,dropdownHeader=_props.dropdownHeader,caret=_props.caret,hoverColor=_props.hoverColor,dropPlacement=_props.dropPlacement,rtlActive=_props.rtlActive,noLiPadding=_props.noLiPadding,innerDropDown=_props.innerDropDown,navDropdown=_props.navDropdown;var caretClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.caret,true),_defineProperty(_classNames,classes.caretDropup,dropup&&!open),_defineProperty(_classNames,classes.caretActive,open&&!dropup),_defineProperty(_classNames,classes.caretRTL,rtlActive),_classNames));var dropdownItem=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames2={},_defineProperty(_classNames2,classes.dropdownItem,true),_defineProperty(_classNames2,classes[hoverColor+"Hover"],true),_defineProperty(_classNames2,classes.noLiPadding,noLiPadding),_defineProperty(_classNames2,classes.dropdownItemRTL,rtlActive),_classNames2));var dropDownMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuList___default.a,{role:"menu",className:classes.menuList},dropdownHeader!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem___default.a,{onClick:function onClick(){return _this2.handleCloseMenu(dropdownHeader);},className:classes.dropdownHeader},dropdownHeader):null,dropdownList.map(function(prop,key){if(prop.divider){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{key:key,onClick:function onClick(){return _this2.handleCloseMenu("divider");},className:classes.dropdownDividerItem});}else if(prop.ref==="multi"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem___default.a,{key:key,className:dropdownItem,style:{overflow:"visible",padding:0}},prop);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_MenuItem___default.a,{key:key,onClick:function onClick(){return _this2.handleCloseMenu(prop);},className:dropdownItem},prop);}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:innerDropDown?classes.innerManager:classes.manager},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:buttonText!==undefined?"":classes.target},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],Object.assign({"aria-label":"Notifications","aria-owns":open?"menu-list":null,"aria-haspopup":"true",buttonRef:function buttonRef(node){_this2.anchorEl=node;}},buttonProps,{onClick:this.handleClick}),buttonIcon!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.buttonIcon,{className:classes.buttonIcon}):null,buttonText!==undefined?buttonText:null,caret?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{className:caretClasses}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Popper___default.a,{open:open,anchorEl:this.anchorEl,transition:true,disablePortal:true,placement:dropPlacement,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames3={},_defineProperty(_classNames3,classes.popperClose,!open),_defineProperty(_classNames3,classes.pooperResponsive,true),_defineProperty(_classNames3,classes.pooperNav,open&&navDropdown),_classNames3))},function(_ref){var TransitionProps=_ref.TransitionProps,placement=_ref.placement;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grow___default.a,{"in":open,id:"menu-list",style:dropup?{transformOrigin:"0 100% 0"}:{transformOrigin:"0 0 0"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.dropdown},innerDropDown?dropDownMenu:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ClickAwayListener___default.a,{onClickAway:_this2.handleClose,ref:"cacat"},dropDownMenu)));}));}}]);return CustomDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CustomDropdown.defaultProps={caret:true,dropup:false,hoverColor:"primary"};CustomDropdown.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,hoverColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["dark","primary","info","success","warning","danger","rose"]),buttonText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,buttonIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,dropdownList:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,buttonProps:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,dropup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,dropdownHeader:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,rtlActive:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,caret:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,dropPlacement:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["bottom","top","right","left","bottom-start","bottom-end","top-start","top-end","right-start","right-end","left-start","left-end"]),noLiPadding:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,innerDropDown:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,navDropdown:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,// This is a function that returns the clicked menu item
onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_components_customDropdownStyle_jsx__["a" /* default */])(CustomDropdown));

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Face');

exports.default = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});

var _Table = _interopRequireDefault(__webpack_require__(892));

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableBody.default;
  }
});

var _TableBody = _interopRequireDefault(__webpack_require__(893));

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableCell.default;
  }
});

var _TableCell = _interopRequireDefault(__webpack_require__(894));

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableRow.default;
  }
});

var _TableRow = _interopRequireDefault(__webpack_require__(897));

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Edit');

exports.default = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Add');

exports.default = _default;

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReactTableDefaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lifecycle__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__methods__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultProps__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propTypes__ = __webpack_require__(910);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



//






var ReactTableDefaults = __WEBPACK_IMPORTED_MODULE_5__defaultProps__["a" /* default */];

var ReactTable = function (_Methods) {
  _inherits(ReactTable, _Methods);

  function ReactTable(props) {
    _classCallCheck(this, ReactTable);

    var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));

    _this.getResolvedState = _this.getResolvedState.bind(_this);
    _this.getDataModel = _this.getDataModel.bind(_this);
    _this.getSortedData = _this.getSortedData.bind(_this);
    _this.fireFetchData = _this.fireFetchData.bind(_this);
    _this.getPropOrState = _this.getPropOrState.bind(_this);
    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
    _this.filterData = _this.filterData.bind(_this);
    _this.sortData = _this.sortData.bind(_this);
    _this.getMinRows = _this.getMinRows.bind(_this);
    _this.onPageChange = _this.onPageChange.bind(_this);
    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
    _this.sortColumn = _this.sortColumn.bind(_this);
    _this.filterColumn = _this.filterColumn.bind(_this);
    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);

    _this.state = {
      page: 0,
      pageSize: props.defaultPageSize,
      sorted: props.defaultSorted,
      expanded: props.defaultExpanded,
      filtered: props.defaultFiltered,
      resized: props.defaultResized,
      currentlyResizing: false,
      skipNextSort: false
    };
    return _this;
  }

  _createClass(ReactTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resolvedState = this.getResolvedState();
      var children = resolvedState.children,
          className = resolvedState.className,
          style = resolvedState.style,
          getProps = resolvedState.getProps,
          getTableProps = resolvedState.getTableProps,
          getTheadGroupProps = resolvedState.getTheadGroupProps,
          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
          getTheadProps = resolvedState.getTheadProps,
          getTheadTrProps = resolvedState.getTheadTrProps,
          getTheadThProps = resolvedState.getTheadThProps,
          getTheadFilterProps = resolvedState.getTheadFilterProps,
          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
          getTbodyProps = resolvedState.getTbodyProps,
          getTrGroupProps = resolvedState.getTrGroupProps,
          getTrProps = resolvedState.getTrProps,
          getTdProps = resolvedState.getTdProps,
          getTfootProps = resolvedState.getTfootProps,
          getTfootTrProps = resolvedState.getTfootTrProps,
          getTfootTdProps = resolvedState.getTfootTdProps,
          getPaginationProps = resolvedState.getPaginationProps,
          getLoadingProps = resolvedState.getLoadingProps,
          getNoDataProps = resolvedState.getNoDataProps,
          getResizerProps = resolvedState.getResizerProps,
          showPagination = resolvedState.showPagination,
          showPaginationTop = resolvedState.showPaginationTop,
          showPaginationBottom = resolvedState.showPaginationBottom,
          manual = resolvedState.manual,
          loadingText = resolvedState.loadingText,
          noDataText = resolvedState.noDataText,
          sortable = resolvedState.sortable,
          multiSort = resolvedState.multiSort,
          resizable = resolvedState.resizable,
          filterable = resolvedState.filterable,
          pivotIDKey = resolvedState.pivotIDKey,
          pivotValKey = resolvedState.pivotValKey,
          pivotBy = resolvedState.pivotBy,
          subRowsKey = resolvedState.subRowsKey,
          aggregatedKey = resolvedState.aggregatedKey,
          originalKey = resolvedState.originalKey,
          indexKey = resolvedState.indexKey,
          groupedByPivotKey = resolvedState.groupedByPivotKey,
          loading = resolvedState.loading,
          pageSize = resolvedState.pageSize,
          page = resolvedState.page,
          sorted = resolvedState.sorted,
          filtered = resolvedState.filtered,
          resized = resolvedState.resized,
          expanded = resolvedState.expanded,
          pages = resolvedState.pages,
          onExpandedChange = resolvedState.onExpandedChange,
          TableComponent = resolvedState.TableComponent,
          TheadComponent = resolvedState.TheadComponent,
          TbodyComponent = resolvedState.TbodyComponent,
          TrGroupComponent = resolvedState.TrGroupComponent,
          TrComponent = resolvedState.TrComponent,
          ThComponent = resolvedState.ThComponent,
          TdComponent = resolvedState.TdComponent,
          TfootComponent = resolvedState.TfootComponent,
          PaginationComponent = resolvedState.PaginationComponent,
          LoadingComponent = resolvedState.LoadingComponent,
          SubComponent = resolvedState.SubComponent,
          NoDataComponent = resolvedState.NoDataComponent,
          ResizerComponent = resolvedState.ResizerComponent,
          ExpanderComponent = resolvedState.ExpanderComponent,
          PivotValueComponent = resolvedState.PivotValueComponent,
          PivotComponent = resolvedState.PivotComponent,
          AggregatedComponent = resolvedState.AggregatedComponent,
          FilterComponent = resolvedState.FilterComponent,
          PadRowComponent = resolvedState.PadRowComponent,
          resolvedData = resolvedState.resolvedData,
          allVisibleColumns = resolvedState.allVisibleColumns,
          headerGroups = resolvedState.headerGroups,
          hasHeaderGroups = resolvedState.hasHeaderGroups,
          sortedData = resolvedState.sortedData,
          currentlyResizing = resolvedState.currentlyResizing;

      // Pagination

      var startRow = pageSize * page;
      var endRow = startRow + pageSize;
      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
      var minRows = this.getMinRows();
      var padRows = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].range(Math.max(minRows - pageRows.length, 0));

      var hasColumnFooter = allVisibleColumns.some(function (d) {
        return d.Footer;
      });
      var hasFilters = filterable || allVisibleColumns.some(function (d) {
        return d.filterable;
      });

      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        return [rows.map(function (row, i) {
          index += 1;
          var rowWithViewIndex = _extends({}, row, {
            _viewIndex: index
          });
          var newPath = path.concat([i]);
          if (rowWithViewIndex[subRowsKey] && __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].get(expanded, newPath)) {
            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);

            var _recurseRowsViewIndex2 = _slicedToArray(_recurseRowsViewIndex, 2);

            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
            index = _recurseRowsViewIndex2[1];
          }
          return rowWithViewIndex;
        }), index];
      };

      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);

      var _recurseRowsViewIndex4 = _slicedToArray(_recurseRowsViewIndex3, 1);

      pageRows = _recurseRowsViewIndex4[0];


      var canPrevious = page > 0;
      var canNext = page + 1 < pages;

      var rowMinWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(allVisibleColumns.map(function (d) {
        var resizedColumn = resized.find(function (x) {
          return x.id === d.id;
        }) || {};
        return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedColumn.value, d.width, d.minWidth);
      }));

      var rowIndex = -1;

      var finalState = _extends({}, resolvedState, {
        startRow: startRow,
        endRow: endRow,
        pageRows: pageRows,
        minRows: minRows,
        padRows: padRows,
        hasColumnFooter: hasColumnFooter,
        canPrevious: canPrevious,
        canNext: canNext,
        rowMinWidth: rowMinWidth
      });

      var rootProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getProps(finalState, undefined, undefined, this));
      var tableProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTableProps(finalState, undefined, undefined, this));
      var tBodyProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTbodyProps(finalState, undefined, undefined, this));
      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
      var noDataProps = getNoDataProps(finalState, undefined, undefined, this);

      // Visual Components

      var makeHeaderGroup = function makeHeaderGroup(column, i) {
        var resizedValue = function resizedValue(col) {
          return (resized.find(function (x) {
            return x.id === col.id;
          }) || {}).value;
        };
        var flex = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(column.columns.map(function (col) {
          return col.width || resizedValue(col) ? 0 : col.minWidth;
        }));
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(column.columns.map(function (col) {
          return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedValue(col), col.width, col.minWidth);
        }));
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].sum(column.columns.map(function (col) {
          return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedValue(col), col.width, col.maxWidth);
        }));

        var theadGroupThProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadGroupThProps.rest, columnHeaderProps.rest);

        var flexStyles = {
          flex: flex + ' 0 auto',
          width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
          maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes),
            style: _extends({}, styles, flexStyles)
          }, rest),
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Header, {
            data: sortedData,
            column: column
          })
        );
      };

      var makeHeaderGroups = function makeHeaderGroups() {
        var theadGroupProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
        var theadGroupTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TheadComponent,
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-headerGroups', theadGroupProps.className),
            style: _extends({}, theadGroupProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadGroupProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: theadGroupTrProps.className,
              style: theadGroupTrProps.style
            }, theadGroupTrProps.rest),
            headerGroups.map(makeHeaderGroup)
          )
        );
      };

      var makeHeader = function makeHeader(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var sort = sorted.find(function (d) {
          return d.id === column.id;
        });
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadThProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadThProps.rest, columnHeaderProps.rest);

        var isResizable = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(column.resizable, resizable, false);
        var resizer = isResizable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResizerComponent, _extends({
          onMouseDown: function onMouseDown(e) {
            return _this2.resizeColumnStart(e, column, false);
          },
          onTouchStart: function onTouchStart(e) {
            return _this2.resizeColumnStart(e, column, true);
          }
        }, getResizerProps('finalState', undefined, column, _this2))) : null;

        var isSortable = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(column.sortable, sortable, false);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            }),
            toggleSort: function toggleSort(e) {
              if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
            }
          }, rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(isResizable && 'rt-resizable-header-content') },
            __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Header, {
              data: sortedData,
              column: column
            })
          ),
          resizer
        );
      };

      var makeHeaders = function makeHeaders() {
        var theadProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadProps(finalState, undefined, undefined, _this2));
        var theadTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TheadComponent,
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-header', theadProps.className),
            style: _extends({}, theadProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: theadTrProps.className,
              style: theadTrProps.style
            }, theadTrProps.rest),
            allVisibleColumns.map(makeHeader)
          )
        );
      };

      var makeFilter = function makeFilter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var theadFilterThProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
        var columnHeaderProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];

        var styles = _extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);

        var rest = _extends({}, theadFilterThProps.rest, columnHeaderProps.rest);

        var filter = filtered.find(function (filter) {
          return filter.id === column.id;
        });

        var ResolvedFilterComponent = column.Filter || FilterComponent;

        var isFilterable = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(column.filterable, filterable, false);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          ThComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            })
          }, rest),
          isFilterable ? __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedFilterComponent, {
            column: column,
            filter: filter,
            onChange: function onChange(value) {
              return _this2.filterColumn(column, value);
            }
          }, __WEBPACK_IMPORTED_MODULE_5__defaultProps__["a" /* default */].column.Filter) : null
        );
      };

      var makeFilters = function makeFilters() {
        var theadFilterProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
        var theadFilterTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TheadComponent,
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-filters', theadFilterProps.className),
            style: _extends({}, theadFilterProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, theadFilterProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: theadFilterTrProps.className,
              style: theadFilterTrProps.style
            }, theadFilterTrProps.rest),
            allVisibleColumns.map(makeFilter)
          )
        );
      };

      var makePageRow = function makePageRow(row, i) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var rowInfo = {
          original: row[originalKey],
          row: row,
          index: row[indexKey],
          viewIndex: rowIndex += 1,
          pageSize: pageSize,
          page: page,
          level: path.length,
          nestingPath: path.concat([i]),
          aggregated: row[aggregatedKey],
          groupedByPivot: row[groupedByPivotKey],
          subRows: row[subRowsKey]
        };
        var isExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].get(expanded, rowInfo.nestingPath);
        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
        var trProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TrGroupComponent,
          _extends({ key: rowInfo.nestingPath.join('_') }, trGroupProps),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
              style: trProps.style
            }, trProps.rest),
            allVisibleColumns.map(function (column, i2) {
              var resizedCol = resized.find(function (x) {
                return x.id === column.id;
              }) || {};
              var show = typeof column.show === 'function' ? column.show() : column.show;
              var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
              var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
              var tdProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTdProps(finalState, rowInfo, column, _this2));
              var columnProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getProps(finalState, rowInfo, column, _this2));

              var classes = [tdProps.className, column.className, columnProps.className];

              var styles = _extends({}, tdProps.style, column.style, columnProps.style);

              var cellInfo = _extends({}, rowInfo, {
                isExpanded: isExpanded,
                column: _extends({}, column),
                value: rowInfo.row[column.id],
                pivoted: column.pivoted,
                expander: column.expander,
                resized: resized,
                show: show,
                width: width,
                maxWidth: maxWidth,
                tdProps: tdProps,
                columnProps: columnProps,
                classes: classes,
                styles: styles
              });

              var value = cellInfo.value;

              var useOnExpanderClick = void 0;
              var isBranch = void 0;
              var isPreview = void 0;

              var onExpanderClick = function onExpanderClick(e) {
                var newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].clone(expanded);
                if (isExpanded) {
                  newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].set(newExpanded, cellInfo.nestingPath, false);
                } else {
                  newExpanded = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].set(newExpanded, cellInfo.nestingPath, {});
                }

                return _this2.setStateWithData({
                  expanded: newExpanded
                }, function () {
                  return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e);
                });
              };

              // Default to a standard cell
              var resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Cell, cellInfo, value);

              // Resolve Renderers
              var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
              var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
              var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
              var DefaultResolvedPivotComponent = PivotComponent || function (props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResolvedExpanderComponent, props),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResolvedPivotValueComponent, props)
                );
              };
              var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;

              // Is this cell expandable?
              if (cellInfo.pivoted || cellInfo.expander) {
                // Make it expandable by defualt
                cellInfo.expandable = true;
                useOnExpanderClick = true;
                // If pivoted, has no subRows, and does not have a subComponent,
                // do not make expandable
                if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
                  cellInfo.expandable = false;
                }
              }

              if (cellInfo.pivoted) {
                // Is this column a branch?
                isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
                // Should this column be blank?
                isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
                // Pivot Cell Render Override
                if (isBranch) {
                  // isPivot
                  resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedPivotComponent, _extends({}, cellInfo, {
                    value: row[pivotValKey]
                  }), row[pivotValKey]);
                } else if (isPreview) {
                  // Show the pivot preview
                  resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                } else {
                  resolvedCell = null;
                }
              } else if (cellInfo.aggregated) {
                resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
              }

              if (cellInfo.expander) {
                resolvedCell = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
                if (pivotBy) {
                  if (cellInfo.groupedByPivot) {
                    resolvedCell = null;
                  }
                  if (!cellInfo.subRows && !SubComponent) {
                    resolvedCell = null;
                  }
                }
              }

              var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {};

              // If there are multiple onClick events, make sure they don't
              // override eachother. This should maybe be expanded to handle all
              // function attributes
              var interactionProps = {
                onClick: resolvedOnExpanderClick
              };

              if (tdProps.rest.onClick) {
                interactionProps.onClick = function (e) {
                  tdProps.rest.onClick(e, function () {
                    return resolvedOnExpanderClick(e);
                  });
                };
              }

              if (columnProps.rest.onClick) {
                interactionProps.onClick = function (e) {
                  columnProps.rest.onClick(e, function () {
                    return resolvedOnExpanderClick(e);
                  });
                };
              }

              // Return the cell
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                TdComponent
                // eslint-disable-next-line react/no-array-index-key
                ,
                _extends({ key: i2 + '-' + column.id,
                  className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
                  style: _extends({}, styles, {
                    flex: width + ' 0 auto',
                    width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
                    maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
                  })
                }, tdProps.rest, columnProps.rest, interactionProps),
                resolvedCell
              );
            })
          ),
          rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
            return makePageRow(d, i, rowInfo.nestingPath);
          }),
          SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo)
        );
      };

      var makePadColumn = function makePadColumn(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var flex = width;
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tdProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTdProps(finalState, undefined, column, _this2));
        var columnProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getProps(finalState, undefined, column, _this2));

        var classes = [tdProps.className, column.className, columnProps.className];

        var styles = _extends({}, tdProps.style, column.style, columnProps.style);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TdComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, !show && 'hidden'),
            style: _extends({}, styles, {
              flex: flex + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            })
          }, tdProps.rest),
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(PadRowComponent)
        );
      };

      var makePadRow = function makePadRow(row, i) {
        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
        var trProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TrGroupComponent,
          _extends({ key: i }, trGroupProps),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
              style: trProps.style || {}
            },
            allVisibleColumns.map(makePadColumn)
          )
        );
      };

      var makeColumnFooter = function makeColumnFooter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;
        var width = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.minWidth);
        var maxWidth = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getFirstDefined(resizedCol.value, column.width, column.maxWidth);
        var tFootTdProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTfootTdProps(finalState, undefined, undefined, _this2));
        var columnProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getProps(finalState, undefined, column, _this2));
        var columnFooterProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(column.getFooterProps(finalState, undefined, column, _this2));

        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];

        var styles = _extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TdComponent,
          _extends({
            key: i + '-' + column.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes, !show && 'hidden'),
            style: _extends({}, styles, {
              flex: width + ' 0 auto',
              width: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(width),
              maxWidth: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].asPx(maxWidth)
            })
          }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest),
          __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(column.Footer, {
            data: sortedData,
            column: column
          })
        );
      };

      var makeColumnFooters = function makeColumnFooters() {
        var tFootProps = getTfootProps(finalState, undefined, undefined, _this2);
        var tFootTrProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TfootComponent,
          _extends({
            className: tFootProps.className,
            style: _extends({}, tFootProps.style, {
              minWidth: rowMinWidth + 'px'
            })
          }, tFootProps.rest),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TrComponent,
            _extends({
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(tFootTrProps.className),
              style: tFootTrProps.style
            }, tFootTrProps.rest),
            allVisibleColumns.map(makeColumnFooter)
          )
        );
      };

      var makePagination = function makePagination() {
        var paginationProps = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PaginationComponent, _extends({}, resolvedState, {
          pages: pages,
          canPrevious: canPrevious,
          canNext: canNext,
          onPageChange: _this2.onPageChange,
          onPageSizeChange: _this2.onPageSizeChange,
          className: paginationProps.className,
          style: paginationProps.style
        }, paginationProps.rest));
      };

      var makeTable = function makeTable() {
        var pagination = makePagination();
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          _extends({
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ReactTable', className, rootProps.className),
            style: _extends({}, style, rootProps.style)
          }, rootProps.rest),
          showPagination && showPaginationTop ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pagination-top' },
            pagination
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TableComponent,
            _extends({
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
              style: tableProps.style
            }, tableProps.rest),
            hasHeaderGroups ? makeHeaderGroups() : null,
            makeHeaders(),
            hasFilters ? makeFilters() : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              TbodyComponent,
              _extends({
                className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(tBodyProps.className),
                style: _extends({}, tBodyProps.style, {
                  minWidth: rowMinWidth + 'px'
                })
              }, tBodyProps.rest),
              pageRows.map(function (d, i) {
                return makePageRow(d, i);
              }),
              padRows.map(makePadRow)
            ),
            hasColumnFooter ? makeColumnFooters() : null
          ),
          showPagination && showPaginationBottom ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pagination-bottom' },
            pagination
          ) : null,
          !pageRows.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            NoDataComponent,
            noDataProps,
            __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].normalizeComponent(noDataText)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingComponent, _extends({ loading: loading, loadingText: loadingText }, loadingProps))
        );
      };

      // childProps are optionally passed to a function-as-a-child
      return children ? children(finalState, makeTable, this) : makeTable();
    }
  }]);

  return ReactTable;
}(Object(__WEBPACK_IMPORTED_MODULE_4__methods__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__lifecycle__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react__["Component"])));

ReactTable.propTypes = __WEBPACK_IMPORTED_MODULE_6__propTypes__["a" /* default */];
ReactTable.defaultProps = __WEBPACK_IMPORTED_MODULE_5__defaultProps__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (ReactTable);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
})), 'Dvr');

exports.default = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(916)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(984)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(985)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(1068)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(1069)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(1070)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(1071)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(1072)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(1073)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(1074)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(1085)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(1086)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(1087)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(1088)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(1089)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(1090)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(1091)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(85);
var toObject = __webpack_require__(182);
var IE_PROTO = __webpack_require__(259)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(86) && !__webpack_require__(108)(function () {
  return Object.defineProperty(__webpack_require__(418)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(107);
var document = __webpack_require__(71).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(921), __esModule: true };

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(923);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(935);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(925)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(422)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(183);
var $export = __webpack_require__(72);
var redefine = __webpack_require__(423);
var hide = __webpack_require__(105);
var Iterators = __webpack_require__(137);
var $iterCreate = __webpack_require__(926);
var setToStringTag = __webpack_require__(267);
var getPrototypeOf = __webpack_require__(416);
var ITERATOR = __webpack_require__(50)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(105);


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(85);
var toIObject = __webpack_require__(109);
var arrayIndexOf = __webpack_require__(928)(false);
var IE_PROTO = __webpack_require__(259)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(265);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(263);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(424);
var hiddenKeys = __webpack_require__(266).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(186);
var createDesc = __webpack_require__(136);
var toIObject = __webpack_require__(109);
var toPrimitive = __webpack_require__(262);
var has = __webpack_require__(85);
var IE8_DOM_DEFINE = __webpack_require__(417);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(86) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(271);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 432 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(110),
    metaMap = __webpack_require__(435);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(436);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(438),
    composeArgsRight = __webpack_require__(439),
    countHolders = __webpack_require__(963),
    createCtor = __webpack_require__(188),
    createRecurry = __webpack_require__(440),
    getHolder = __webpack_require__(276),
    reorder = __webpack_require__(977),
    replaceHolders = __webpack_require__(191),
    root = __webpack_require__(39);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(964),
    setData = __webpack_require__(443),
    setWrapToString = __webpack_require__(444);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(435),
    noop = __webpack_require__(965);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(140),
    baseLodash = __webpack_require__(274);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(434),
    shortOut = __webpack_require__(433);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(970),
    insertWrapDetails = __webpack_require__(971),
    setToString = __webpack_require__(272),
    updateWrapDetails = __webpack_require__(972);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(447);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(980),
    isObject = __webpack_require__(51),
    isSymbol = __webpack_require__(141);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(212);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1000),
    isArguments = __webpack_require__(280),
    isArray = __webpack_require__(37),
    isBuffer = __webpack_require__(192),
    isIndex = __webpack_require__(190),
    isTypedArray = __webpack_require__(281);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 452 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1031),
    isObjectLike = __webpack_require__(61);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1032),
    arraySome = __webpack_require__(1035),
    cacheHas = __webpack_require__(1036);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(457),
    getSymbols = __webpack_require__(288),
    keys = __webpack_require__(113);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(287),
    isArray = __webpack_require__(37);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(51);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1051);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(201),
    isArguments = __webpack_require__(280),
    isArray = __webpack_require__(37),
    isIndex = __webpack_require__(190),
    isLength = __webpack_require__(282),
    toKey = __webpack_require__(144);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Place');

exports.default = _default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return (root['Chartist'] = factory());
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    root['Chartist'] = factory();
  }
}(this, function () {

/* Chartist.js 0.10.0
 * Copyright © 2016 Gion Kunz
 * Free to use under either the WTFPL license or the MIT license.
 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-WTFPL
 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-MIT
 */
/**
 * The core module of Chartist that is mainly providing static functions and higher level functions for chart modules.
 *
 * @module Chartist.Core
 */
var Chartist = {
  version: '0.10.0'
};

(function (window, document, Chartist) {
  'use strict';

  /**
   * This object contains all namespaces used within Chartist.
   *
   * @memberof Chartist.Core
   * @type {{svg: string, xmlns: string, xhtml: string, xlink: string, ct: string}}
   */
  Chartist.namespaces = {
    svg: 'http://www.w3.org/2000/svg',
    xmlns: 'http://www.w3.org/2000/xmlns/',
    xhtml: 'http://www.w3.org/1999/xhtml',
    xlink: 'http://www.w3.org/1999/xlink',
    ct: 'http://gionkunz.github.com/chartist-js/ct'
  };

  /**
   * Helps to simplify functional style code
   *
   * @memberof Chartist.Core
   * @param {*} n This exact value will be returned by the noop function
   * @return {*} The same value that was provided to the n parameter
   */
  Chartist.noop = function (n) {
    return n;
  };

  /**
   * Generates a-z from a number 0 to 26
   *
   * @memberof Chartist.Core
   * @param {Number} n A number from 0 to 26 that will result in a letter a-z
   * @return {String} A character from a-z based on the input number n
   */
  Chartist.alphaNumerate = function (n) {
    // Limit to a-z
    return String.fromCharCode(97 + n % 26);
  };

  /**
   * Simple recursive object extend
   *
   * @memberof Chartist.Core
   * @param {Object} target Target object where the source will be merged into
   * @param {Object...} sources This object (objects) will be merged into target and then target is returned
   * @return {Object} An object that has the same reference as target but is extended and merged with the properties of source
   */
  Chartist.extend = function (target) {
    var i, source, sourceProp;
    target = target || {};

    for (i = 1; i < arguments.length; i++) {
      source = arguments[i];
      for (var prop in source) {
        sourceProp = source[prop];
        if (typeof sourceProp === 'object' && sourceProp !== null && !(sourceProp instanceof Array)) {
          target[prop] = Chartist.extend(target[prop], sourceProp);
        } else {
          target[prop] = sourceProp;
        }
      }
    }

    return target;
  };

  /**
   * Replaces all occurrences of subStr in str with newSubStr and returns a new string.
   *
   * @memberof Chartist.Core
   * @param {String} str
   * @param {String} subStr
   * @param {String} newSubStr
   * @return {String}
   */
  Chartist.replaceAll = function(str, subStr, newSubStr) {
    return str.replace(new RegExp(subStr, 'g'), newSubStr);
  };

  /**
   * Converts a number to a string with a unit. If a string is passed then this will be returned unmodified.
   *
   * @memberof Chartist.Core
   * @param {Number} value
   * @param {String} unit
   * @return {String} Returns the passed number value with unit.
   */
  Chartist.ensureUnit = function(value, unit) {
    if(typeof value === 'number') {
      value = value + unit;
    }

    return value;
  };

  /**
   * Converts a number or string to a quantity object.
   *
   * @memberof Chartist.Core
   * @param {String|Number} input
   * @return {Object} Returns an object containing the value as number and the unit as string.
   */
  Chartist.quantity = function(input) {
    if (typeof input === 'string') {
      var match = (/^(\d+)\s*(.*)$/g).exec(input);
      return {
        value : +match[1],
        unit: match[2] || undefined
      };
    }
    return { value: input };
  };

  /**
   * This is a wrapper around document.querySelector that will return the query if it's already of type Node
   *
   * @memberof Chartist.Core
   * @param {String|Node} query The query to use for selecting a Node or a DOM node that will be returned directly
   * @return {Node}
   */
  Chartist.querySelector = function(query) {
    return query instanceof Node ? query : document.querySelector(query);
  };

  /**
   * Functional style helper to produce array with given length initialized with undefined values
   *
   * @memberof Chartist.Core
   * @param length
   * @return {Array}
   */
  Chartist.times = function(length) {
    return Array.apply(null, new Array(length));
  };

  /**
   * Sum helper to be used in reduce functions
   *
   * @memberof Chartist.Core
   * @param previous
   * @param current
   * @return {*}
   */
  Chartist.sum = function(previous, current) {
    return previous + (current ? current : 0);
  };

  /**
   * Multiply helper to be used in `Array.map` for multiplying each value of an array with a factor.
   *
   * @memberof Chartist.Core
   * @param {Number} factor
   * @returns {Function} Function that can be used in `Array.map` to multiply each value in an array
   */
  Chartist.mapMultiply = function(factor) {
    return function(num) {
      return num * factor;
    };
  };

  /**
   * Add helper to be used in `Array.map` for adding a addend to each value of an array.
   *
   * @memberof Chartist.Core
   * @param {Number} addend
   * @returns {Function} Function that can be used in `Array.map` to add a addend to each value in an array
   */
  Chartist.mapAdd = function(addend) {
    return function(num) {
      return num + addend;
    };
  };

  /**
   * Map for multi dimensional arrays where their nested arrays will be mapped in serial. The output array will have the length of the largest nested array. The callback function is called with variable arguments where each argument is the nested array value (or undefined if there are no more values).
   *
   * @memberof Chartist.Core
   * @param arr
   * @param cb
   * @return {Array}
   */
  Chartist.serialMap = function(arr, cb) {
    var result = [],
        length = Math.max.apply(null, arr.map(function(e) {
          return e.length;
        }));

    Chartist.times(length).forEach(function(e, index) {
      var args = arr.map(function(e) {
        return e[index];
      });

      result[index] = cb.apply(null, args);
    });

    return result;
  };

  /**
   * This helper function can be used to round values with certain precision level after decimal. This is used to prevent rounding errors near float point precision limit.
   *
   * @memberof Chartist.Core
   * @param {Number} value The value that should be rounded with precision
   * @param {Number} [digits] The number of digits after decimal used to do the rounding
   * @returns {number} Rounded value
   */
  Chartist.roundWithPrecision = function(value, digits) {
    var precision = Math.pow(10, digits || Chartist.precision);
    return Math.round(value * precision) / precision;
  };

  /**
   * Precision level used internally in Chartist for rounding. If you require more decimal places you can increase this number.
   *
   * @memberof Chartist.Core
   * @type {number}
   */
  Chartist.precision = 8;

  /**
   * A map with characters to escape for strings to be safely used as attribute values.
   *
   * @memberof Chartist.Core
   * @type {Object}
   */
  Chartist.escapingMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  };

  /**
   * This function serializes arbitrary data to a string. In case of data that can't be easily converted to a string, this function will create a wrapper object and serialize the data using JSON.stringify. The outcoming string will always be escaped using Chartist.escapingMap.
   * If called with null or undefined the function will return immediately with null or undefined.
   *
   * @memberof Chartist.Core
   * @param {Number|String|Object} data
   * @return {String}
   */
  Chartist.serialize = function(data) {
    if(data === null || data === undefined) {
      return data;
    } else if(typeof data === 'number') {
      data = ''+data;
    } else if(typeof data === 'object') {
      data = JSON.stringify({data: data});
    }

    return Object.keys(Chartist.escapingMap).reduce(function(result, key) {
      return Chartist.replaceAll(result, key, Chartist.escapingMap[key]);
    }, data);
  };

  /**
   * This function de-serializes a string previously serialized with Chartist.serialize. The string will always be unescaped using Chartist.escapingMap before it's returned. Based on the input value the return type can be Number, String or Object. JSON.parse is used with try / catch to see if the unescaped string can be parsed into an Object and this Object will be returned on success.
   *
   * @memberof Chartist.Core
   * @param {String} data
   * @return {String|Number|Object}
   */
  Chartist.deserialize = function(data) {
    if(typeof data !== 'string') {
      return data;
    }

    data = Object.keys(Chartist.escapingMap).reduce(function(result, key) {
      return Chartist.replaceAll(result, Chartist.escapingMap[key], key);
    }, data);

    try {
      data = JSON.parse(data);
      data = data.data !== undefined ? data.data : data;
    } catch(e) {}

    return data;
  };

  /**
   * Create or reinitialize the SVG element for the chart
   *
   * @memberof Chartist.Core
   * @param {Node} container The containing DOM Node object that will be used to plant the SVG element
   * @param {String} width Set the width of the SVG element. Default is 100%
   * @param {String} height Set the height of the SVG element. Default is 100%
   * @param {String} className Specify a class to be added to the SVG element
   * @return {Object} The created/reinitialized SVG element
   */
  Chartist.createSvg = function (container, width, height, className) {
    var svg;

    width = width || '100%';
    height = height || '100%';

    // Check if there is a previous SVG element in the container that contains the Chartist XML namespace and remove it
    // Since the DOM API does not support namespaces we need to manually search the returned list http://www.w3.org/TR/selectors-api/
    Array.prototype.slice.call(container.querySelectorAll('svg')).filter(function filterChartistSvgObjects(svg) {
      return svg.getAttributeNS(Chartist.namespaces.xmlns, 'ct');
    }).forEach(function removePreviousElement(svg) {
      container.removeChild(svg);
    });

    // Create svg object with width and height or use 100% as default
    svg = new Chartist.Svg('svg').attr({
      width: width,
      height: height
    }).addClass(className).attr({
      style: 'width: ' + width + '; height: ' + height + ';'
    });

    // Add the DOM node to our container
    container.appendChild(svg._node);

    return svg;
  };

  /**
   * Ensures that the data object passed as second argument to the charts is present and correctly initialized.
   *
   * @param  {Object} data The data object that is passed as second argument to the charts
   * @return {Object} The normalized data object
   */
  Chartist.normalizeData = function(data, reverse, multi) {
    var labelCount;
    var output = {
      raw: data,
      normalized: {}
    };

    // Check if we should generate some labels based on existing series data
    output.normalized.series = Chartist.getDataArray({
      series: data.series || []
    }, reverse, multi);

    // If all elements of the normalized data array are arrays we're dealing with
    // multi series data and we need to find the largest series if they are un-even
    if (output.normalized.series.every(function(value) {
        return value instanceof Array;
      })) {
      // Getting the series with the the most elements
      labelCount = Math.max.apply(null, output.normalized.series.map(function(series) {
        return series.length;
      }));
    } else {
      // We're dealing with Pie data so we just take the normalized array length
      labelCount = output.normalized.series.length;
    }

    output.normalized.labels = (data.labels || []).slice();
    // Padding the labels to labelCount with empty strings
    Array.prototype.push.apply(
      output.normalized.labels,
      Chartist.times(Math.max(0, labelCount - output.normalized.labels.length)).map(function() {
        return '';
      })
    );

    if(reverse) {
      Chartist.reverseData(output.normalized);
    }

    return output;
  };

  /**
   * This function safely checks if an objects has an owned property.
   *
   * @param {Object} object The object where to check for a property
   * @param {string} property The property name
   * @returns {boolean} Returns true if the object owns the specified property
   */
  Chartist.safeHasProperty = function(object, property) {
    return object !== null &&
      typeof object === 'object' &&
      object.hasOwnProperty(property);
  };

  /**
   * Checks if a value is considered a hole in the data series.
   *
   * @param {*} value
   * @returns {boolean} True if the value is considered a data hole
   */
  Chartist.isDataHoleValue = function(value) {
    return value === null ||
      value === undefined ||
      (typeof value === 'number' && isNaN(value));
  };

  /**
   * Reverses the series, labels and series data arrays.
   *
   * @memberof Chartist.Core
   * @param data
   */
  Chartist.reverseData = function(data) {
    data.labels.reverse();
    data.series.reverse();
    for (var i = 0; i < data.series.length; i++) {
      if(typeof(data.series[i]) === 'object' && data.series[i].data !== undefined) {
        data.series[i].data.reverse();
      } else if(data.series[i] instanceof Array) {
        data.series[i].reverse();
      }
    }
  };

  /**
   * Convert data series into plain array
   *
   * @memberof Chartist.Core
   * @param {Object} data The series object that contains the data to be visualized in the chart
   * @param {Boolean} [reverse] If true the whole data is reversed by the getDataArray call. This will modify the data object passed as first parameter. The labels as well as the series order is reversed. The whole series data arrays are reversed too.
   * @param {Boolean} [multi] Create a multi dimensional array from a series data array where a value object with `x` and `y` values will be created.
   * @return {Array} A plain array that contains the data to be visualized in the chart
   */
  Chartist.getDataArray = function(data, reverse, multi) {
    // Recursively walks through nested arrays and convert string values to numbers and objects with value properties
    // to values. Check the tests in data core -> data normalization for a detailed specification of expected values
    function recursiveConvert(value) {
      if(Chartist.safeHasProperty(value, 'value')) {
        // We are dealing with value object notation so we need to recurse on value property
        return recursiveConvert(value.value);
      } else if(Chartist.safeHasProperty(value, 'data')) {
        // We are dealing with series object notation so we need to recurse on data property
        return recursiveConvert(value.data);
      } else if(value instanceof Array) {
        // Data is of type array so we need to recurse on the series
        return value.map(recursiveConvert);
      } else if(Chartist.isDataHoleValue(value)) {
        // We're dealing with a hole in the data and therefore need to return undefined
        // We're also returning undefined for multi value output
        return undefined;
      } else {
        // We need to prepare multi value output (x and y data)
        if(multi) {
          var multiValue = {};

          // Single series value arrays are assumed to specify the Y-Axis value
          // For example: [1, 2] => [{x: undefined, y: 1}, {x: undefined, y: 2}]
          // If multi is a string then it's assumed that it specified which dimension should be filled as default
          if(typeof multi === 'string') {
            multiValue[multi] = Chartist.getNumberOrUndefined(value);
          } else {
            multiValue.y = Chartist.getNumberOrUndefined(value);
          }

          multiValue.x = value.hasOwnProperty('x') ? Chartist.getNumberOrUndefined(value.x) : multiValue.x;
          multiValue.y = value.hasOwnProperty('y') ? Chartist.getNumberOrUndefined(value.y) : multiValue.y;

          return multiValue;

        } else {
          // We can return simple data
          return Chartist.getNumberOrUndefined(value);
        }
      }
    }

    return data.series.map(recursiveConvert);
  };

  /**
   * Converts a number into a padding object.
   *
   * @memberof Chartist.Core
   * @param {Object|Number} padding
   * @param {Number} [fallback] This value is used to fill missing values if a incomplete padding object was passed
   * @returns {Object} Returns a padding object containing top, right, bottom, left properties filled with the padding number passed in as argument. If the argument is something else than a number (presumably already a correct padding object) then this argument is directly returned.
   */
  Chartist.normalizePadding = function(padding, fallback) {
    fallback = fallback || 0;

    return typeof padding === 'number' ? {
      top: padding,
      right: padding,
      bottom: padding,
      left: padding
    } : {
      top: typeof padding.top === 'number' ? padding.top : fallback,
      right: typeof padding.right === 'number' ? padding.right : fallback,
      bottom: typeof padding.bottom === 'number' ? padding.bottom : fallback,
      left: typeof padding.left === 'number' ? padding.left : fallback
    };
  };

  Chartist.getMetaData = function(series, index) {
    var value = series.data ? series.data[index] : series[index];
    return value ? value.meta : undefined;
  };

  /**
   * Calculate the order of magnitude for the chart scale
   *
   * @memberof Chartist.Core
   * @param {Number} value The value Range of the chart
   * @return {Number} The order of magnitude
   */
  Chartist.orderOfMagnitude = function (value) {
    return Math.floor(Math.log(Math.abs(value)) / Math.LN10);
  };

  /**
   * Project a data length into screen coordinates (pixels)
   *
   * @memberof Chartist.Core
   * @param {Object} axisLength The svg element for the chart
   * @param {Number} length Single data value from a series array
   * @param {Object} bounds All the values to set the bounds of the chart
   * @return {Number} The projected data length in pixels
   */
  Chartist.projectLength = function (axisLength, length, bounds) {
    return length / bounds.range * axisLength;
  };

  /**
   * Get the height of the area in the chart for the data series
   *
   * @memberof Chartist.Core
   * @param {Object} svg The svg element for the chart
   * @param {Object} options The Object that contains all the optional values for the chart
   * @return {Number} The height of the area in the chart for the data series
   */
  Chartist.getAvailableHeight = function (svg, options) {
    return Math.max((Chartist.quantity(options.height).value || svg.height()) - (options.chartPadding.top +  options.chartPadding.bottom) - options.axisX.offset, 0);
  };

  /**
   * Get highest and lowest value of data array. This Array contains the data that will be visualized in the chart.
   *
   * @memberof Chartist.Core
   * @param {Array} data The array that contains the data to be visualized in the chart
   * @param {Object} options The Object that contains the chart options
   * @param {String} dimension Axis dimension 'x' or 'y' used to access the correct value and high / low configuration
   * @return {Object} An object that contains the highest and lowest value that will be visualized on the chart.
   */
  Chartist.getHighLow = function (data, options, dimension) {
    // TODO: Remove workaround for deprecated global high / low config. Axis high / low configuration is preferred
    options = Chartist.extend({}, options, dimension ? options['axis' + dimension.toUpperCase()] : {});

    var highLow = {
        high: options.high === undefined ? -Number.MAX_VALUE : +options.high,
        low: options.low === undefined ? Number.MAX_VALUE : +options.low
      };
    var findHigh = options.high === undefined;
    var findLow = options.low === undefined;

    // Function to recursively walk through arrays and find highest and lowest number
    function recursiveHighLow(data) {
      if(data === undefined) {
        return undefined;
      } else if(data instanceof Array) {
        for (var i = 0; i < data.length; i++) {
          recursiveHighLow(data[i]);
        }
      } else {
        var value = dimension ? +data[dimension] : +data;

        if (findHigh && value > highLow.high) {
          highLow.high = value;
        }

        if (findLow && value < highLow.low) {
          highLow.low = value;
        }
      }
    }

    // Start to find highest and lowest number recursively
    if(findHigh || findLow) {
      recursiveHighLow(data);
    }

    // Overrides of high / low based on reference value, it will make sure that the invisible reference value is
    // used to generate the chart. This is useful when the chart always needs to contain the position of the
    // invisible reference value in the view i.e. for bipolar scales.
    if (options.referenceValue || options.referenceValue === 0) {
      highLow.high = Math.max(options.referenceValue, highLow.high);
      highLow.low = Math.min(options.referenceValue, highLow.low);
    }

    // If high and low are the same because of misconfiguration or flat data (only the same value) we need
    // to set the high or low to 0 depending on the polarity
    if (highLow.high <= highLow.low) {
      // If both values are 0 we set high to 1
      if (highLow.low === 0) {
        highLow.high = 1;
      } else if (highLow.low < 0) {
        // If we have the same negative value for the bounds we set bounds.high to 0
        highLow.high = 0;
      } else if (highLow.high > 0) {
        // If we have the same positive value for the bounds we set bounds.low to 0
        highLow.low = 0;
      } else {
        // If data array was empty, values are Number.MAX_VALUE and -Number.MAX_VALUE. Set bounds to prevent errors
        highLow.high = 1;
        highLow.low = 0;
      }
    }

    return highLow;
  };

  /**
   * Checks if a value can be safely coerced to a number. This includes all values except null which result in finite numbers when coerced. This excludes NaN, since it's not finite.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {Boolean}
   */
  Chartist.isNumeric = function(value) {
    return value === null ? false : isFinite(value);
  };

  /**
   * Returns true on all falsey values except the numeric value 0.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {boolean}
   */
  Chartist.isFalseyButZero = function(value) {
    return !value && value !== 0;
  };

  /**
   * Returns a number if the passed parameter is a valid number or the function will return undefined. On all other values than a valid number, this function will return undefined.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {*}
   */
  Chartist.getNumberOrUndefined = function(value) {
    return Chartist.isNumeric(value) ? +value : undefined;
  };

  /**
   * Checks if provided value object is multi value (contains x or y properties)
   *
   * @memberof Chartist.Core
   * @param value
   */
  Chartist.isMultiValue = function(value) {
    return typeof value === 'object' && ('x' in value || 'y' in value);
  };

  /**
   * Gets a value from a dimension `value.x` or `value.y` while returning value directly if it's a valid numeric value. If the value is not numeric and it's falsey this function will return `defaultValue`.
   *
   * @memberof Chartist.Core
   * @param value
   * @param dimension
   * @param defaultValue
   * @returns {*}
   */
  Chartist.getMultiValue = function(value, dimension) {
    if(Chartist.isMultiValue(value)) {
      return Chartist.getNumberOrUndefined(value[dimension || 'y']);
    } else {
      return Chartist.getNumberOrUndefined(value);
    }
  };

  /**
   * Pollard Rho Algorithm to find smallest factor of an integer value. There are more efficient algorithms for factorization, but this one is quite efficient and not so complex.
   *
   * @memberof Chartist.Core
   * @param {Number} num An integer number where the smallest factor should be searched for
   * @returns {Number} The smallest integer factor of the parameter num.
   */
  Chartist.rho = function(num) {
    if(num === 1) {
      return num;
    }

    function gcd(p, q) {
      if (p % q === 0) {
        return q;
      } else {
        return gcd(q, p % q);
      }
    }

    function f(x) {
      return x * x + 1;
    }

    var x1 = 2, x2 = 2, divisor;
    if (num % 2 === 0) {
      return 2;
    }

    do {
      x1 = f(x1) % num;
      x2 = f(f(x2)) % num;
      divisor = gcd(Math.abs(x1 - x2), num);
    } while (divisor === 1);

    return divisor;
  };

  /**
   * Calculate and retrieve all the bounds for the chart and return them in one array
   *
   * @memberof Chartist.Core
   * @param {Number} axisLength The length of the Axis used for
   * @param {Object} highLow An object containing a high and low property indicating the value range of the chart.
   * @param {Number} scaleMinSpace The minimum projected length a step should result in
   * @param {Boolean} onlyInteger
   * @return {Object} All the values to set the bounds of the chart
   */
  Chartist.getBounds = function (axisLength, highLow, scaleMinSpace, onlyInteger) {
    var i,
      optimizationCounter = 0,
      newMin,
      newMax,
      bounds = {
        high: highLow.high,
        low: highLow.low
      };

    bounds.valueRange = bounds.high - bounds.low;
    bounds.oom = Chartist.orderOfMagnitude(bounds.valueRange);
    bounds.step = Math.pow(10, bounds.oom);
    bounds.min = Math.floor(bounds.low / bounds.step) * bounds.step;
    bounds.max = Math.ceil(bounds.high / bounds.step) * bounds.step;
    bounds.range = bounds.max - bounds.min;
    bounds.numberOfSteps = Math.round(bounds.range / bounds.step);

    // Optimize scale step by checking if subdivision is possible based on horizontalGridMinSpace
    // If we are already below the scaleMinSpace value we will scale up
    var length = Chartist.projectLength(axisLength, bounds.step, bounds);
    var scaleUp = length < scaleMinSpace;
    var smallestFactor = onlyInteger ? Chartist.rho(bounds.range) : 0;

    // First check if we should only use integer steps and if step 1 is still larger than scaleMinSpace so we can use 1
    if(onlyInteger && Chartist.projectLength(axisLength, 1, bounds) >= scaleMinSpace) {
      bounds.step = 1;
    } else if(onlyInteger && smallestFactor < bounds.step && Chartist.projectLength(axisLength, smallestFactor, bounds) >= scaleMinSpace) {
      // If step 1 was too small, we can try the smallest factor of range
      // If the smallest factor is smaller than the current bounds.step and the projected length of smallest factor
      // is larger than the scaleMinSpace we should go for it.
      bounds.step = smallestFactor;
    } else {
      // Trying to divide or multiply by 2 and find the best step value
      while (true) {
        if (scaleUp && Chartist.projectLength(axisLength, bounds.step, bounds) <= scaleMinSpace) {
          bounds.step *= 2;
        } else if (!scaleUp && Chartist.projectLength(axisLength, bounds.step / 2, bounds) >= scaleMinSpace) {
          bounds.step /= 2;
          if(onlyInteger && bounds.step % 1 !== 0) {
            bounds.step *= 2;
            break;
          }
        } else {
          break;
        }

        if(optimizationCounter++ > 1000) {
          throw new Error('Exceeded maximum number of iterations while optimizing scale step!');
        }
      }
    }

    var EPSILON = 2.221E-16;
    bounds.step = Math.max(bounds.step, EPSILON);
    function safeIncrement(value, increment) {
      // If increment is too small use *= (1+EPSILON) as a simple nextafter
      if (value === (value += increment)) {
      	value *= (1 + (increment > 0 ? EPSILON : -EPSILON));
      }
      return value;
    }

    // Narrow min and max based on new step
    newMin = bounds.min;
    newMax = bounds.max;
    while (newMin + bounds.step <= bounds.low) {
    	newMin = safeIncrement(newMin, bounds.step);
    }
    while (newMax - bounds.step >= bounds.high) {
    	newMax = safeIncrement(newMax, -bounds.step);
    }
    bounds.min = newMin;
    bounds.max = newMax;
    bounds.range = bounds.max - bounds.min;

    var values = [];
    for (i = bounds.min; i <= bounds.max; i = safeIncrement(i, bounds.step)) {
      var value = Chartist.roundWithPrecision(i);
      if (value !== values[values.length - 1]) {
        values.push(value);
      }
    }
    bounds.values = values;
    return bounds;
  };

  /**
   * Calculate cartesian coordinates of polar coordinates
   *
   * @memberof Chartist.Core
   * @param {Number} centerX X-axis coordinates of center point of circle segment
   * @param {Number} centerY X-axis coordinates of center point of circle segment
   * @param {Number} radius Radius of circle segment
   * @param {Number} angleInDegrees Angle of circle segment in degrees
   * @return {{x:Number, y:Number}} Coordinates of point on circumference
   */
  Chartist.polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  };

  /**
   * Initialize chart drawing rectangle (area where chart is drawn) x1,y1 = bottom left / x2,y2 = top right
   *
   * @memberof Chartist.Core
   * @param {Object} svg The svg element for the chart
   * @param {Object} options The Object that contains all the optional values for the chart
   * @param {Number} [fallbackPadding] The fallback padding if partial padding objects are used
   * @return {Object} The chart rectangles coordinates inside the svg element plus the rectangles measurements
   */
  Chartist.createChartRect = function (svg, options, fallbackPadding) {
    var hasAxis = !!(options.axisX || options.axisY);
    var yAxisOffset = hasAxis ? options.axisY.offset : 0;
    var xAxisOffset = hasAxis ? options.axisX.offset : 0;
    // If width or height results in invalid value (including 0) we fallback to the unitless settings or even 0
    var width = svg.width() || Chartist.quantity(options.width).value || 0;
    var height = svg.height() || Chartist.quantity(options.height).value || 0;
    var normalizedPadding = Chartist.normalizePadding(options.chartPadding, fallbackPadding);

    // If settings were to small to cope with offset (legacy) and padding, we'll adjust
    width = Math.max(width, yAxisOffset + normalizedPadding.left + normalizedPadding.right);
    height = Math.max(height, xAxisOffset + normalizedPadding.top + normalizedPadding.bottom);

    var chartRect = {
      padding: normalizedPadding,
      width: function () {
        return this.x2 - this.x1;
      },
      height: function () {
        return this.y1 - this.y2;
      }
    };

    if(hasAxis) {
      if (options.axisX.position === 'start') {
        chartRect.y2 = normalizedPadding.top + xAxisOffset;
        chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
      } else {
        chartRect.y2 = normalizedPadding.top;
        chartRect.y1 = Math.max(height - normalizedPadding.bottom - xAxisOffset, chartRect.y2 + 1);
      }

      if (options.axisY.position === 'start') {
        chartRect.x1 = normalizedPadding.left + yAxisOffset;
        chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
      } else {
        chartRect.x1 = normalizedPadding.left;
        chartRect.x2 = Math.max(width - normalizedPadding.right - yAxisOffset, chartRect.x1 + 1);
      }
    } else {
      chartRect.x1 = normalizedPadding.left;
      chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
      chartRect.y2 = normalizedPadding.top;
      chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
    }

    return chartRect;
  };

  /**
   * Creates a grid line based on a projected value.
   *
   * @memberof Chartist.Core
   * @param position
   * @param index
   * @param axis
   * @param offset
   * @param length
   * @param group
   * @param classes
   * @param eventEmitter
   */
  Chartist.createGrid = function(position, index, axis, offset, length, group, classes, eventEmitter) {
    var positionalData = {};
    positionalData[axis.units.pos + '1'] = position;
    positionalData[axis.units.pos + '2'] = position;
    positionalData[axis.counterUnits.pos + '1'] = offset;
    positionalData[axis.counterUnits.pos + '2'] = offset + length;

    var gridElement = group.elem('line', positionalData, classes.join(' '));

    // Event for grid draw
    eventEmitter.emit('draw',
      Chartist.extend({
        type: 'grid',
        axis: axis,
        index: index,
        group: group,
        element: gridElement
      }, positionalData)
    );
  };

  /**
   * Creates a grid background rect and emits the draw event.
   *
   * @memberof Chartist.Core
   * @param gridGroup
   * @param chartRect
   * @param className
   * @param eventEmitter
   */
  Chartist.createGridBackground = function (gridGroup, chartRect, className, eventEmitter) {
    var gridBackground = gridGroup.elem('rect', {
        x: chartRect.x1,
        y: chartRect.y2,
        width: chartRect.width(),
        height: chartRect.height(),
      }, className, true);

      // Event for grid background draw
      eventEmitter.emit('draw', {
        type: 'gridBackground',
        group: gridGroup,
        element: gridBackground
      });
  };

  /**
   * Creates a label based on a projected value and an axis.
   *
   * @memberof Chartist.Core
   * @param position
   * @param length
   * @param index
   * @param labels
   * @param axis
   * @param axisOffset
   * @param labelOffset
   * @param group
   * @param classes
   * @param useForeignObject
   * @param eventEmitter
   */
  Chartist.createLabel = function(position, length, index, labels, axis, axisOffset, labelOffset, group, classes, useForeignObject, eventEmitter) {
    var labelElement;
    var positionalData = {};

    positionalData[axis.units.pos] = position + labelOffset[axis.units.pos];
    positionalData[axis.counterUnits.pos] = labelOffset[axis.counterUnits.pos];
    positionalData[axis.units.len] = length;
    positionalData[axis.counterUnits.len] = Math.max(0, axisOffset - 10);

    if(useForeignObject) {
      // We need to set width and height explicitly to px as span will not expand with width and height being
      // 100% in all browsers
      var content = '<span class="' + classes.join(' ') + '" style="' +
        axis.units.len + ': ' + Math.round(positionalData[axis.units.len]) + 'px; ' +
        axis.counterUnits.len + ': ' + Math.round(positionalData[axis.counterUnits.len]) + 'px">' +
        labels[index] + '</span>';

      labelElement = group.foreignObject(content, Chartist.extend({
        style: 'overflow: visible;'
      }, positionalData));
    } else {
      labelElement = group.elem('text', positionalData, classes.join(' ')).text(labels[index]);
    }

    eventEmitter.emit('draw', Chartist.extend({
      type: 'label',
      axis: axis,
      index: index,
      group: group,
      element: labelElement,
      text: labels[index]
    }, positionalData));
  };

  /**
   * Helper to read series specific options from options object. It automatically falls back to the global option if
   * there is no option in the series options.
   *
   * @param {Object} series Series object
   * @param {Object} options Chartist options object
   * @param {string} key The options key that should be used to obtain the options
   * @returns {*}
   */
  Chartist.getSeriesOption = function(series, options, key) {
    if(series.name && options.series && options.series[series.name]) {
      var seriesOptions = options.series[series.name];
      return seriesOptions.hasOwnProperty(key) ? seriesOptions[key] : options[key];
    } else {
      return options[key];
    }
  };

  /**
   * Provides options handling functionality with callback for options changes triggered by responsive options and media query matches
   *
   * @memberof Chartist.Core
   * @param {Object} options Options set by user
   * @param {Array} responsiveOptions Optional functions to add responsive behavior to chart
   * @param {Object} eventEmitter The event emitter that will be used to emit the options changed events
   * @return {Object} The consolidated options object from the defaults, base and matching responsive options
   */
  Chartist.optionsProvider = function (options, responsiveOptions, eventEmitter) {
    var baseOptions = Chartist.extend({}, options),
      currentOptions,
      mediaQueryListeners = [],
      i;

    function updateCurrentOptions(mediaEvent) {
      var previousOptions = currentOptions;
      currentOptions = Chartist.extend({}, baseOptions);

      if (responsiveOptions) {
        for (i = 0; i < responsiveOptions.length; i++) {
          var mql = window.matchMedia(responsiveOptions[i][0]);
          if (mql.matches) {
            currentOptions = Chartist.extend(currentOptions, responsiveOptions[i][1]);
          }
        }
      }

      if(eventEmitter && mediaEvent) {
        eventEmitter.emit('optionsChanged', {
          previousOptions: previousOptions,
          currentOptions: currentOptions
        });
      }
    }

    function removeMediaQueryListeners() {
      mediaQueryListeners.forEach(function(mql) {
        mql.removeListener(updateCurrentOptions);
      });
    }

    if (!window.matchMedia) {
      throw 'window.matchMedia not found! Make sure you\'re using a polyfill.';
    } else if (responsiveOptions) {

      for (i = 0; i < responsiveOptions.length; i++) {
        var mql = window.matchMedia(responsiveOptions[i][0]);
        mql.addListener(updateCurrentOptions);
        mediaQueryListeners.push(mql);
      }
    }
    // Execute initially without an event argument so we get the correct options
    updateCurrentOptions();

    return {
      removeMediaQueryListeners: removeMediaQueryListeners,
      getCurrentOptions: function getCurrentOptions() {
        return Chartist.extend({}, currentOptions);
      }
    };
  };


  /**
   * Splits a list of coordinates and associated values into segments. Each returned segment contains a pathCoordinates
   * valueData property describing the segment.
   *
   * With the default options, segments consist of contiguous sets of points that do not have an undefined value. Any
   * points with undefined values are discarded.
   *
   * **Options**
   * The following options are used to determine how segments are formed
   * ```javascript
   * var options = {
   *   // If fillHoles is true, undefined values are simply discarded without creating a new segment. Assuming other options are default, this returns single segment.
   *   fillHoles: false,
   *   // If increasingX is true, the coordinates in all segments have strictly increasing x-values.
   *   increasingX: false
   * };
   * ```
   *
   * @memberof Chartist.Core
   * @param {Array} pathCoordinates List of point coordinates to be split in the form [x1, y1, x2, y2 ... xn, yn]
   * @param {Array} values List of associated point values in the form [v1, v2 .. vn]
   * @param {Object} options Options set by user
   * @return {Array} List of segments, each containing a pathCoordinates and valueData property.
   */
  Chartist.splitIntoSegments = function(pathCoordinates, valueData, options) {
    var defaultOptions = {
      increasingX: false,
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    var segments = [];
    var hole = true;

    for(var i = 0; i < pathCoordinates.length; i += 2) {
      // If this value is a "hole" we set the hole flag
      if(Chartist.getMultiValue(valueData[i / 2].value) === undefined) {
      // if(valueData[i / 2].value === undefined) {
        if(!options.fillHoles) {
          hole = true;
        }
      } else {
        if(options.increasingX && i >= 2 && pathCoordinates[i] <= pathCoordinates[i-2]) {
          // X is not increasing, so we need to make sure we start a new segment
          hole = true;
        }


        // If it's a valid value we need to check if we're coming out of a hole and create a new empty segment
        if(hole) {
          segments.push({
            pathCoordinates: [],
            valueData: []
          });
          // As we have a valid value now, we are not in a "hole" anymore
          hole = false;
        }

        // Add to the segment pathCoordinates and valueData
        segments[segments.length - 1].pathCoordinates.push(pathCoordinates[i], pathCoordinates[i + 1]);
        segments[segments.length - 1].valueData.push(valueData[i / 2]);
      }
    }

    return segments;
  };
}(window, document, Chartist));
;/**
 * Chartist path interpolation functions.
 *
 * @module Chartist.Interpolation
 */
/* global Chartist */
(function(window, document, Chartist) {
  'use strict';

  Chartist.Interpolation = {};

  /**
   * This interpolation function does not smooth the path and the result is only containing lines and no curves.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.none({
   *     fillHoles: false
   *   })
   * });
   *
   *
   * @memberof Chartist.Interpolation
   * @return {Function}
   */
  Chartist.Interpolation.none = function(options) {
    var defaultOptions = {
      fillHoles: false
    };
    options = Chartist.extend({}, defaultOptions, options);
    return function none(pathCoordinates, valueData) {
      var path = new Chartist.Svg.Path();
      var hole = true;

      for(var i = 0; i < pathCoordinates.length; i += 2) {
        var currX = pathCoordinates[i];
        var currY = pathCoordinates[i + 1];
        var currData = valueData[i / 2];

        if(Chartist.getMultiValue(currData.value) !== undefined) {

          if(hole) {
            path.move(currX, currY, false, currData);
          } else {
            path.line(currX, currY, false, currData);
          }

          hole = false;
        } else if(!options.fillHoles) {
          hole = true;
        }
      }

      return path;
    };
  };

  /**
   * Simple smoothing creates horizontal handles that are positioned with a fraction of the length between two data points. You can use the divisor option to specify the amount of smoothing.
   *
   * Simple smoothing can be used instead of `Chartist.Smoothing.cardinal` if you'd like to get rid of the artifacts it produces sometimes. Simple smoothing produces less flowing lines but is accurate by hitting the points and it also doesn't swing below or above the given data point.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The simple interpolation function accepts one configuration parameter `divisor`, between 1 and ∞, which controls the smoothing characteristics.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.simple({
   *     divisor: 2,
   *     fillHoles: false
   *   })
   * });
   *
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the simple interpolation factory function.
   * @return {Function}
   */
  Chartist.Interpolation.simple = function(options) {
    var defaultOptions = {
      divisor: 2,
      fillHoles: false
    };
    options = Chartist.extend({}, defaultOptions, options);

    var d = 1 / Math.max(1, options.divisor);

    return function simple(pathCoordinates, valueData) {
      var path = new Chartist.Svg.Path();
      var prevX, prevY, prevData;

      for(var i = 0; i < pathCoordinates.length; i += 2) {
        var currX = pathCoordinates[i];
        var currY = pathCoordinates[i + 1];
        var length = (currX - prevX) * d;
        var currData = valueData[i / 2];

        if(currData.value !== undefined) {

          if(prevData === undefined) {
            path.move(currX, currY, false, currData);
          } else {
            path.curve(
              prevX + length,
              prevY,
              currX - length,
              currY,
              currX,
              currY,
              false,
              currData
            );
          }

          prevX = currX;
          prevY = currY;
          prevData = currData;
        } else if(!options.fillHoles) {
          prevX = currX = prevData = undefined;
        }
      }

      return path;
    };
  };

  /**
   * Cardinal / Catmull-Rome spline interpolation is the default smoothing function in Chartist. It produces nice results where the splines will always meet the points. It produces some artifacts though when data values are increased or decreased rapidly. The line may not follow a very accurate path and if the line should be accurate this smoothing function does not produce the best results.
   *
   * Cardinal splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The cardinal interpolation function accepts one configuration parameter `tension`, between 0 and 1, which controls the smoothing intensity.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 1,
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the cardinal factory function.
   * @return {Function}
   */
  Chartist.Interpolation.cardinal = function(options) {
    var defaultOptions = {
      tension: 1,
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    var t = Math.min(1, Math.max(0, options.tension)),
      c = 1 - t;

    return function cardinal(pathCoordinates, valueData) {
      // First we try to split the coordinates into segments
      // This is necessary to treat "holes" in line charts
      var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
        fillHoles: options.fillHoles
      });

      if(!segments.length) {
        // If there were no segments return 'Chartist.Interpolation.none'
        return Chartist.Interpolation.none()([]);
      } else if(segments.length > 1) {
        // If the split resulted in more that one segment we need to interpolate each segment individually and join them
        // afterwards together into a single path.
          var paths = [];
        // For each segment we will recurse the cardinal function
        segments.forEach(function(segment) {
          paths.push(cardinal(segment.pathCoordinates, segment.valueData));
        });
        // Join the segment path data into a single path and return
        return Chartist.Svg.Path.join(paths);
      } else {
        // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
        // segment
        pathCoordinates = segments[0].pathCoordinates;
        valueData = segments[0].valueData;

        // If less than two points we need to fallback to no smoothing
        if(pathCoordinates.length <= 4) {
          return Chartist.Interpolation.none()(pathCoordinates, valueData);
        }

        var path = new Chartist.Svg.Path().move(pathCoordinates[0], pathCoordinates[1], false, valueData[0]),
          z;

        for (var i = 0, iLen = pathCoordinates.length; iLen - 2 * !z > i; i += 2) {
          var p = [
            {x: +pathCoordinates[i - 2], y: +pathCoordinates[i - 1]},
            {x: +pathCoordinates[i], y: +pathCoordinates[i + 1]},
            {x: +pathCoordinates[i + 2], y: +pathCoordinates[i + 3]},
            {x: +pathCoordinates[i + 4], y: +pathCoordinates[i + 5]}
          ];
          if (z) {
            if (!i) {
              p[0] = {x: +pathCoordinates[iLen - 2], y: +pathCoordinates[iLen - 1]};
            } else if (iLen - 4 === i) {
              p[3] = {x: +pathCoordinates[0], y: +pathCoordinates[1]};
            } else if (iLen - 2 === i) {
              p[2] = {x: +pathCoordinates[0], y: +pathCoordinates[1]};
              p[3] = {x: +pathCoordinates[2], y: +pathCoordinates[3]};
            }
          } else {
            if (iLen - 4 === i) {
              p[3] = p[2];
            } else if (!i) {
              p[0] = {x: +pathCoordinates[i], y: +pathCoordinates[i + 1]};
            }
          }

          path.curve(
            (t * (-p[0].x + 6 * p[1].x + p[2].x) / 6) + (c * p[2].x),
            (t * (-p[0].y + 6 * p[1].y + p[2].y) / 6) + (c * p[2].y),
            (t * (p[1].x + 6 * p[2].x - p[3].x) / 6) + (c * p[2].x),
            (t * (p[1].y + 6 * p[2].y - p[3].y) / 6) + (c * p[2].y),
            p[2].x,
            p[2].y,
            false,
            valueData[(i + 2) / 2]
          );
        }

        return path;
      }
    };
  };

  /**
   * Monotone Cubic spline interpolation produces a smooth curve which preserves monotonicity. Unlike cardinal splines, the curve will not extend beyond the range of y-values of the original data points.
   *
   * Monotone Cubic splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
   *
   * The x-values of subsequent points must be increasing to fit a Monotone Cubic spline. If this condition is not met for a pair of adjacent points, then there will be a break in the curve between those data points.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.monotoneCubic({
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the monotoneCubic factory function.
   * @return {Function}
   */
  Chartist.Interpolation.monotoneCubic = function(options) {
    var defaultOptions = {
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    return function monotoneCubic(pathCoordinates, valueData) {
      // First we try to split the coordinates into segments
      // This is necessary to treat "holes" in line charts
      var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
        fillHoles: options.fillHoles,
        increasingX: true
      });

      if(!segments.length) {
        // If there were no segments return 'Chartist.Interpolation.none'
        return Chartist.Interpolation.none()([]);
      } else if(segments.length > 1) {
        // If the split resulted in more that one segment we need to interpolate each segment individually and join them
        // afterwards together into a single path.
          var paths = [];
        // For each segment we will recurse the monotoneCubic fn function
        segments.forEach(function(segment) {
          paths.push(monotoneCubic(segment.pathCoordinates, segment.valueData));
        });
        // Join the segment path data into a single path and return
        return Chartist.Svg.Path.join(paths);
      } else {
        // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
        // segment
        pathCoordinates = segments[0].pathCoordinates;
        valueData = segments[0].valueData;

        // If less than three points we need to fallback to no smoothing
        if(pathCoordinates.length <= 4) {
          return Chartist.Interpolation.none()(pathCoordinates, valueData);
        }

        var xs = [],
          ys = [],
          i,
          n = pathCoordinates.length / 2,
          ms = [],
          ds = [], dys = [], dxs = [],
          path;

        // Populate x and y coordinates into separate arrays, for readability

        for(i = 0; i < n; i++) {
          xs[i] = pathCoordinates[i * 2];
          ys[i] = pathCoordinates[i * 2 + 1];
        }

        // Calculate deltas and derivative

        for(i = 0; i < n - 1; i++) {
          dys[i] = ys[i + 1] - ys[i];
          dxs[i] = xs[i + 1] - xs[i];
          ds[i] = dys[i] / dxs[i];
        }

        // Determine desired slope (m) at each point using Fritsch-Carlson method
        // See: http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation

        ms[0] = ds[0];
        ms[n - 1] = ds[n - 2];

        for(i = 1; i < n - 1; i++) {
          if(ds[i] === 0 || ds[i - 1] === 0 || (ds[i - 1] > 0) !== (ds[i] > 0)) {
            ms[i] = 0;
          } else {
            ms[i] = 3 * (dxs[i - 1] + dxs[i]) / (
              (2 * dxs[i] + dxs[i - 1]) / ds[i - 1] +
              (dxs[i] + 2 * dxs[i - 1]) / ds[i]);

            if(!isFinite(ms[i])) {
              ms[i] = 0;
            }
          }
        }

        // Now build a path from the slopes

        path = new Chartist.Svg.Path().move(xs[0], ys[0], false, valueData[0]);

        for(i = 0; i < n - 1; i++) {
          path.curve(
            // First control point
            xs[i] + dxs[i] / 3,
            ys[i] + ms[i] * dxs[i] / 3,
            // Second control point
            xs[i + 1] - dxs[i] / 3,
            ys[i + 1] - ms[i + 1] * dxs[i] / 3,
            // End point
            xs[i + 1],
            ys[i + 1],

            false,
            valueData[i + 1]
          );
        }

        return path;
      }
    };
  };

  /**
   * Step interpolation will cause the line chart to move in steps rather than diagonal or smoothed lines. This interpolation will create additional points that will also be drawn when the `showPoint` option is enabled.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The step interpolation function accepts one configuration parameter `postpone`, that can be `true` or `false`. The default value is `true` and will cause the step to occur where the value actually changes. If a different behaviour is needed where the step is shifted to the left and happens before the actual value, this option can be set to `false`.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.step({
   *     postpone: true,
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param options
   * @returns {Function}
   */
  Chartist.Interpolation.step = function(options) {
    var defaultOptions = {
      postpone: true,
      fillHoles: false
    };

    options = Chartist.extend({}, defaultOptions, options);

    return function step(pathCoordinates, valueData) {
      var path = new Chartist.Svg.Path();

      var prevX, prevY, prevData;

      for (var i = 0; i < pathCoordinates.length; i += 2) {
        var currX = pathCoordinates[i];
        var currY = pathCoordinates[i + 1];
        var currData = valueData[i / 2];

        // If the current point is also not a hole we can draw the step lines
        if(currData.value !== undefined) {
          if(prevData === undefined) {
            path.move(currX, currY, false, currData);
          } else {
            if(options.postpone) {
              // If postponed we should draw the step line with the value of the previous value
              path.line(currX, prevY, false, prevData);
            } else {
              // If not postponed we should draw the step line with the value of the current value
              path.line(prevX, currY, false, currData);
            }
            // Line to the actual point (this should only be a Y-Axis movement
            path.line(currX, currY, false, currData);
          }

          prevX = currX;
          prevY = currY;
          prevData = currData;
        } else if(!options.fillHoles) {
          prevX = prevY = prevData = undefined;
        }
      }

      return path;
    };
  };

}(window, document, Chartist));
;/**
 * A very basic event module that helps to generate and catch events.
 *
 * @module Chartist.Event
 */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  Chartist.EventEmitter = function () {
    var handlers = [];

    /**
     * Add an event handler for a specific event
     *
     * @memberof Chartist.Event
     * @param {String} event The event name
     * @param {Function} handler A event handler function
     */
    function addEventHandler(event, handler) {
      handlers[event] = handlers[event] || [];
      handlers[event].push(handler);
    }

    /**
     * Remove an event handler of a specific event name or remove all event handlers for a specific event.
     *
     * @memberof Chartist.Event
     * @param {String} event The event name where a specific or all handlers should be removed
     * @param {Function} [handler] An optional event handler function. If specified only this specific handler will be removed and otherwise all handlers are removed.
     */
    function removeEventHandler(event, handler) {
      // Only do something if there are event handlers with this name existing
      if(handlers[event]) {
        // If handler is set we will look for a specific handler and only remove this
        if(handler) {
          handlers[event].splice(handlers[event].indexOf(handler), 1);
          if(handlers[event].length === 0) {
            delete handlers[event];
          }
        } else {
          // If no handler is specified we remove all handlers for this event
          delete handlers[event];
        }
      }
    }

    /**
     * Use this function to emit an event. All handlers that are listening for this event will be triggered with the data parameter.
     *
     * @memberof Chartist.Event
     * @param {String} event The event name that should be triggered
     * @param {*} data Arbitrary data that will be passed to the event handler callback functions
     */
    function emit(event, data) {
      // Only do something if there are event handlers with this name existing
      if(handlers[event]) {
        handlers[event].forEach(function(handler) {
          handler(data);
        });
      }

      // Emit event to star event handlers
      if(handlers['*']) {
        handlers['*'].forEach(function(starHandler) {
          starHandler(event, data);
        });
      }
    }

    return {
      addEventHandler: addEventHandler,
      removeEventHandler: removeEventHandler,
      emit: emit
    };
  };

}(window, document, Chartist));
;/**
 * This module provides some basic prototype inheritance utilities.
 *
 * @module Chartist.Class
 */
/* global Chartist */
(function(window, document, Chartist) {
  'use strict';

  function listToArray(list) {
    var arr = [];
    if (list.length) {
      for (var i = 0; i < list.length; i++) {
        arr.push(list[i]);
      }
    }
    return arr;
  }

  /**
   * Method to extend from current prototype.
   *
   * @memberof Chartist.Class
   * @param {Object} properties The object that serves as definition for the prototype that gets created for the new class. This object should always contain a constructor property that is the desired constructor for the newly created class.
   * @param {Object} [superProtoOverride] By default extens will use the current class prototype or Chartist.class. With this parameter you can specify any super prototype that will be used.
   * @return {Function} Constructor function of the new class
   *
   * @example
   * var Fruit = Class.extend({
     * color: undefined,
     *   sugar: undefined,
     *
     *   constructor: function(color, sugar) {
     *     this.color = color;
     *     this.sugar = sugar;
     *   },
     *
     *   eat: function() {
     *     this.sugar = 0;
     *     return this;
     *   }
     * });
   *
   * var Banana = Fruit.extend({
     *   length: undefined,
     *
     *   constructor: function(length, sugar) {
     *     Banana.super.constructor.call(this, 'Yellow', sugar);
     *     this.length = length;
     *   }
     * });
   *
   * var banana = new Banana(20, 40);
   * console.log('banana instanceof Fruit', banana instanceof Fruit);
   * console.log('Fruit is prototype of banana', Fruit.prototype.isPrototypeOf(banana));
   * console.log('bananas prototype is Fruit', Object.getPrototypeOf(banana) === Fruit.prototype);
   * console.log(banana.sugar);
   * console.log(banana.eat().sugar);
   * console.log(banana.color);
   */
  function extend(properties, superProtoOverride) {
    var superProto = superProtoOverride || this.prototype || Chartist.Class;
    var proto = Object.create(superProto);

    Chartist.Class.cloneDefinitions(proto, properties);

    var constr = function() {
      var fn = proto.constructor || function () {},
        instance;

      // If this is linked to the Chartist namespace the constructor was not called with new
      // To provide a fallback we will instantiate here and return the instance
      instance = this === Chartist ? Object.create(proto) : this;
      fn.apply(instance, Array.prototype.slice.call(arguments, 0));

      // If this constructor was not called with new we need to return the instance
      // This will not harm when the constructor has been called with new as the returned value is ignored
      return instance;
    };

    constr.prototype = proto;
    constr.super = superProto;
    constr.extend = this.extend;

    return constr;
  }

  // Variable argument list clones args > 0 into args[0] and retruns modified args[0]
  function cloneDefinitions() {
    var args = listToArray(arguments);
    var target = args[0];

    args.splice(1, args.length - 1).forEach(function (source) {
      Object.getOwnPropertyNames(source).forEach(function (propName) {
        // If this property already exist in target we delete it first
        delete target[propName];
        // Define the property with the descriptor from source
        Object.defineProperty(target, propName,
          Object.getOwnPropertyDescriptor(source, propName));
      });
    });

    return target;
  }

  Chartist.Class = {
    extend: extend,
    cloneDefinitions: cloneDefinitions
  };

}(window, document, Chartist));
;/**
 * Base for all chart types. The methods in Chartist.Base are inherited to all chart types.
 *
 * @module Chartist.Base
 */
/* global Chartist */
(function(window, document, Chartist) {
  'use strict';

  // TODO: Currently we need to re-draw the chart on window resize. This is usually very bad and will affect performance.
  // This is done because we can't work with relative coordinates when drawing the chart because SVG Path does not
  // work with relative positions yet. We need to check if we can do a viewBox hack to switch to percentage.
  // See http://mozilla.6506.n7.nabble.com/Specyfing-paths-with-percentages-unit-td247474.html
  // Update: can be done using the above method tested here: http://codepen.io/gionkunz/pen/KDvLj
  // The problem is with the label offsets that can't be converted into percentage and affecting the chart container
  /**
   * Updates the chart which currently does a full reconstruction of the SVG DOM
   *
   * @param {Object} [data] Optional data you'd like to set for the chart before it will update. If not specified the update method will use the data that is already configured with the chart.
   * @param {Object} [options] Optional options you'd like to add to the previous options for the chart before it will update. If not specified the update method will use the options that have been already configured with the chart.
   * @param {Boolean} [override] If set to true, the passed options will be used to extend the options that have been configured already. Otherwise the chart default options will be used as the base
   * @memberof Chartist.Base
   */
  function update(data, options, override) {
    if(data) {
      this.data = data || {};
      this.data.labels = this.data.labels || [];
      this.data.series = this.data.series || [];
      // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
      this.eventEmitter.emit('data', {
        type: 'update',
        data: this.data
      });
    }

    if(options) {
      this.options = Chartist.extend({}, override ? this.options : this.defaultOptions, options);

      // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
      // Otherwise we re-create the optionsProvider at this point
      if(!this.initializeTimeoutId) {
        this.optionsProvider.removeMediaQueryListeners();
        this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
      }
    }

    // Only re-created the chart if it has been initialized yet
    if(!this.initializeTimeoutId) {
      this.createChart(this.optionsProvider.getCurrentOptions());
    }

    // Return a reference to the chart object to chain up calls
    return this;
  }

  /**
   * This method can be called on the API object of each chart and will un-register all event listeners that were added to other components. This currently includes a window.resize listener as well as media query listeners if any responsive options have been provided. Use this function if you need to destroy and recreate Chartist charts dynamically.
   *
   * @memberof Chartist.Base
   */
  function detach() {
    // Only detach if initialization already occurred on this chart. If this chart still hasn't initialized (therefore
    // the initializationTimeoutId is still a valid timeout reference, we will clear the timeout
    if(!this.initializeTimeoutId) {
      window.removeEventListener('resize', this.resizeListener);
      this.optionsProvider.removeMediaQueryListeners();
    } else {
      window.clearTimeout(this.initializeTimeoutId);
    }

    return this;
  }

  /**
   * Use this function to register event handlers. The handler callbacks are synchronous and will run in the main thread rather than the event loop.
   *
   * @memberof Chartist.Base
   * @param {String} event Name of the event. Check the examples for supported events.
   * @param {Function} handler The handler function that will be called when an event with the given name was emitted. This function will receive a data argument which contains event data. See the example for more details.
   */
  function on(event, handler) {
    this.eventEmitter.addEventHandler(event, handler);
    return this;
  }

  /**
   * Use this function to un-register event handlers. If the handler function parameter is omitted all handlers for the given event will be un-registered.
   *
   * @memberof Chartist.Base
   * @param {String} event Name of the event for which a handler should be removed
   * @param {Function} [handler] The handler function that that was previously used to register a new event handler. This handler will be removed from the event handler list. If this parameter is omitted then all event handlers for the given event are removed from the list.
   */
  function off(event, handler) {
    this.eventEmitter.removeEventHandler(event, handler);
    return this;
  }

  function initialize() {
    // Add window resize listener that re-creates the chart
    window.addEventListener('resize', this.resizeListener);

    // Obtain current options based on matching media queries (if responsive options are given)
    // This will also register a listener that is re-creating the chart based on media changes
    this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
    // Register options change listener that will trigger a chart update
    this.eventEmitter.addEventHandler('optionsChanged', function() {
      this.update();
    }.bind(this));

    // Before the first chart creation we need to register us with all plugins that are configured
    // Initialize all relevant plugins with our chart object and the plugin options specified in the config
    if(this.options.plugins) {
      this.options.plugins.forEach(function(plugin) {
        if(plugin instanceof Array) {
          plugin[0](this, plugin[1]);
        } else {
          plugin(this);
        }
      }.bind(this));
    }

    // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
    this.eventEmitter.emit('data', {
      type: 'initial',
      data: this.data
    });

    // Create the first chart
    this.createChart(this.optionsProvider.getCurrentOptions());

    // As chart is initialized from the event loop now we can reset our timeout reference
    // This is important if the chart gets initialized on the same element twice
    this.initializeTimeoutId = undefined;
  }

  /**
   * Constructor of chart base class.
   *
   * @param query
   * @param data
   * @param defaultOptions
   * @param options
   * @param responsiveOptions
   * @constructor
   */
  function Base(query, data, defaultOptions, options, responsiveOptions) {
    this.container = Chartist.querySelector(query);
    this.data = data || {};
    this.data.labels = this.data.labels || [];
    this.data.series = this.data.series || [];
    this.defaultOptions = defaultOptions;
    this.options = options;
    this.responsiveOptions = responsiveOptions;
    this.eventEmitter = Chartist.EventEmitter();
    this.supportsForeignObject = Chartist.Svg.isSupported('Extensibility');
    this.supportsAnimations = Chartist.Svg.isSupported('AnimationEventsAttribute');
    this.resizeListener = function resizeListener(){
      this.update();
    }.bind(this);

    if(this.container) {
      // If chartist was already initialized in this container we are detaching all event listeners first
      if(this.container.__chartist__) {
        this.container.__chartist__.detach();
      }

      this.container.__chartist__ = this;
    }

    // Using event loop for first draw to make it possible to register event listeners in the same call stack where
    // the chart was created.
    this.initializeTimeoutId = setTimeout(initialize.bind(this), 0);
  }

  // Creating the chart base class
  Chartist.Base = Chartist.Class.extend({
    constructor: Base,
    optionsProvider: undefined,
    container: undefined,
    svg: undefined,
    eventEmitter: undefined,
    createChart: function() {
      throw new Error('Base chart type can\'t be instantiated!');
    },
    update: update,
    detach: detach,
    on: on,
    off: off,
    version: Chartist.version,
    supportsForeignObject: false
  });

}(window, document, Chartist));
;/**
 * Chartist SVG module for simple SVG DOM abstraction
 *
 * @module Chartist.Svg
 */
/* global Chartist */
(function(window, document, Chartist) {
  'use strict';

  /**
   * Chartist.Svg creates a new SVG object wrapper with a starting element. You can use the wrapper to fluently create sub-elements and modify them.
   *
   * @memberof Chartist.Svg
   * @constructor
   * @param {String|Element} name The name of the SVG element to create or an SVG dom element which should be wrapped into Chartist.Svg
   * @param {Object} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param {String} className This class or class list will be added to the SVG element
   * @param {Object} parent The parent SVG wrapper object where this newly created wrapper and it's element will be attached to as child
   * @param {Boolean} insertFirst If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   */
  function Svg(name, attributes, className, parent, insertFirst) {
    // If Svg is getting called with an SVG element we just return the wrapper
    if(name instanceof Element) {
      this._node = name;
    } else {
      this._node = document.createElementNS(Chartist.namespaces.svg, name);

      // If this is an SVG element created then custom namespace
      if(name === 'svg') {
        this.attr({
          'xmlns:ct': Chartist.namespaces.ct
        });
      }
    }

    if(attributes) {
      this.attr(attributes);
    }

    if(className) {
      this.addClass(className);
    }

    if(parent) {
      if (insertFirst && parent._node.firstChild) {
        parent._node.insertBefore(this._node, parent._node.firstChild);
      } else {
        parent._node.appendChild(this._node);
      }
    }
  }

  /**
   * Set attributes on the current SVG element of the wrapper you're currently working on.
   *
   * @memberof Chartist.Svg
   * @param {Object|String} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added. If this parameter is a String then the function is used as a getter and will return the attribute value.
   * @param {String} [ns] If specified, the attribute will be obtained using getAttributeNs. In order to write namepsaced attributes you can use the namespace:attribute notation within the attributes object.
   * @return {Object|String} The current wrapper object will be returned so it can be used for chaining or the attribute value if used as getter function.
   */
  function attr(attributes, ns) {
    if(typeof attributes === 'string') {
      if(ns) {
        return this._node.getAttributeNS(ns, attributes);
      } else {
        return this._node.getAttribute(attributes);
      }
    }

    Object.keys(attributes).forEach(function(key) {
      // If the attribute value is undefined we can skip this one
      if(attributes[key] === undefined) {
        return;
      }

      if (key.indexOf(':') !== -1) {
        var namespacedAttribute = key.split(':');
        this._node.setAttributeNS(Chartist.namespaces[namespacedAttribute[0]], key, attributes[key]);
      } else {
        this._node.setAttribute(key, attributes[key]);
      }
    }.bind(this));

    return this;
  }

  /**
   * Create a new SVG element whose wrapper object will be selected for further operations. This way you can also create nested groups easily.
   *
   * @memberof Chartist.Svg
   * @param {String} name The name of the SVG element that should be created as child element of the currently selected element wrapper
   * @param {Object} [attributes] An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param {String} [className] This class or class list will be added to the SVG element
   * @param {Boolean} [insertFirst] If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper object that can be used to modify the containing SVG data
   */
  function elem(name, attributes, className, insertFirst) {
    return new Chartist.Svg(name, attributes, className, this, insertFirst);
  }

  /**
   * Returns the parent Chartist.SVG wrapper object
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper around the parent node of the current node. If the parent node is not existing or it's not an SVG node then this function will return null.
   */
  function parent() {
    return this._node.parentNode instanceof SVGElement ? new Chartist.Svg(this._node.parentNode) : null;
  }

  /**
   * This method returns a Chartist.Svg wrapper around the root SVG element of the current tree.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The root SVG element wrapped in a Chartist.Svg element
   */
  function root() {
    var node = this._node;
    while(node.nodeName !== 'svg') {
      node = node.parentNode;
    }
    return new Chartist.Svg(node);
  }

  /**
   * Find the first child SVG element of the current element that matches a CSS selector. The returned object is a Chartist.Svg wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} selector A CSS selector that is used to query for child SVG elements
   * @return {Chartist.Svg} The SVG wrapper for the element found or null if no element was found
   */
  function querySelector(selector) {
    var foundNode = this._node.querySelector(selector);
    return foundNode ? new Chartist.Svg(foundNode) : null;
  }

  /**
   * Find the all child SVG elements of the current element that match a CSS selector. The returned object is a Chartist.Svg.List wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} selector A CSS selector that is used to query for child SVG elements
   * @return {Chartist.Svg.List} The SVG wrapper list for the element found or null if no element was found
   */
  function querySelectorAll(selector) {
    var foundNodes = this._node.querySelectorAll(selector);
    return foundNodes.length ? new Chartist.Svg.List(foundNodes) : null;
  }

  /**
   * Returns the underlying SVG node for the current element.
   *
   * @memberof Chartist.Svg
   * @returns {Node}
   */
  function getNode() {
    return this._node;
  }

  /**
   * This method creates a foreignObject (see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/foreignObject) that allows to embed HTML content into a SVG graphic. With the help of foreignObjects you can enable the usage of regular HTML elements inside of SVG where they are subject for SVG positioning and transformation but the Browser will use the HTML rendering capabilities for the containing DOM.
   *
   * @memberof Chartist.Svg
   * @param {Node|String} content The DOM Node, or HTML string that will be converted to a DOM Node, that is then placed into and wrapped by the foreignObject
   * @param {String} [attributes] An object with properties that will be added as attributes to the foreignObject element that is created. Attributes with undefined values will not be added.
   * @param {String} [className] This class or class list will be added to the SVG element
   * @param {Boolean} [insertFirst] Specifies if the foreignObject should be inserted as first child
   * @return {Chartist.Svg} New wrapper object that wraps the foreignObject element
   */
  function foreignObject(content, attributes, className, insertFirst) {
    // If content is string then we convert it to DOM
    // TODO: Handle case where content is not a string nor a DOM Node
    if(typeof content === 'string') {
      var container = document.createElement('div');
      container.innerHTML = content;
      content = container.firstChild;
    }

    // Adding namespace to content element
    content.setAttribute('xmlns', Chartist.namespaces.xmlns);

    // Creating the foreignObject without required extension attribute (as described here
    // http://www.w3.org/TR/SVG/extend.html#ForeignObjectElement)
    var fnObj = this.elem('foreignObject', attributes, className, insertFirst);

    // Add content to foreignObjectElement
    fnObj._node.appendChild(content);

    return fnObj;
  }

  /**
   * This method adds a new text element to the current Chartist.Svg wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} t The text that should be added to the text element that is created
   * @return {Chartist.Svg} The same wrapper object that was used to add the newly created element
   */
  function text(t) {
    this._node.appendChild(document.createTextNode(t));
    return this;
  }

  /**
   * This method will clear all child nodes of the current wrapper object.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The same wrapper object that got emptied
   */
  function empty() {
    while (this._node.firstChild) {
      this._node.removeChild(this._node.firstChild);
    }

    return this;
  }

  /**
   * This method will cause the current wrapper to remove itself from its parent wrapper. Use this method if you'd like to get rid of an element in a given DOM structure.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The parent wrapper object of the element that got removed
   */
  function remove() {
    this._node.parentNode.removeChild(this._node);
    return this.parent();
  }

  /**
   * This method will replace the element with a new element that can be created outside of the current DOM.
   *
   * @memberof Chartist.Svg
   * @param {Chartist.Svg} newElement The new Chartist.Svg object that will be used to replace the current wrapper object
   * @return {Chartist.Svg} The wrapper of the new element
   */
  function replace(newElement) {
    this._node.parentNode.replaceChild(newElement._node, this._node);
    return newElement;
  }

  /**
   * This method will append an element to the current element as a child.
   *
   * @memberof Chartist.Svg
   * @param {Chartist.Svg} element The Chartist.Svg element that should be added as a child
   * @param {Boolean} [insertFirst] Specifies if the element should be inserted as first child
   * @return {Chartist.Svg} The wrapper of the appended object
   */
  function append(element, insertFirst) {
    if(insertFirst && this._node.firstChild) {
      this._node.insertBefore(element._node, this._node.firstChild);
    } else {
      this._node.appendChild(element._node);
    }

    return this;
  }

  /**
   * Returns an array of class names that are attached to the current wrapper element. This method can not be chained further.
   *
   * @memberof Chartist.Svg
   * @return {Array} A list of classes or an empty array if there are no classes on the current element
   */
  function classes() {
    return this._node.getAttribute('class') ? this._node.getAttribute('class').trim().split(/\s+/) : [];
  }

  /**
   * Adds one or a space separated list of classes to the current element and ensures the classes are only existing once.
   *
   * @memberof Chartist.Svg
   * @param {String} names A white space separated list of class names
   * @return {Chartist.Svg} The wrapper of the current element
   */
  function addClass(names) {
    this._node.setAttribute('class',
      this.classes(this._node)
        .concat(names.trim().split(/\s+/))
        .filter(function(elem, pos, self) {
          return self.indexOf(elem) === pos;
        }).join(' ')
    );

    return this;
  }

  /**
   * Removes one or a space separated list of classes from the current element.
   *
   * @memberof Chartist.Svg
   * @param {String} names A white space separated list of class names
   * @return {Chartist.Svg} The wrapper of the current element
   */
  function removeClass(names) {
    var removedClasses = names.trim().split(/\s+/);

    this._node.setAttribute('class', this.classes(this._node).filter(function(name) {
      return removedClasses.indexOf(name) === -1;
    }).join(' '));

    return this;
  }

  /**
   * Removes all classes from the current element.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The wrapper of the current element
   */
  function removeAllClasses() {
    this._node.setAttribute('class', '');

    return this;
  }

  /**
   * Get element height using `getBoundingClientRect`
   *
   * @memberof Chartist.Svg
   * @return {Number} The elements height in pixels
   */
  function height() {
    return this._node.getBoundingClientRect().height;
  }

  /**
   * Get element width using `getBoundingClientRect`
   *
   * @memberof Chartist.Core
   * @return {Number} The elements width in pixels
   */
  function width() {
    return this._node.getBoundingClientRect().width;
  }

  /**
   * The animate function lets you animate the current element with SMIL animations. You can add animations for multiple attributes at the same time by using an animation definition object. This object should contain SMIL animation attributes. Please refer to http://www.w3.org/TR/SVG/animate.html for a detailed specification about the available animation attributes. Additionally an easing property can be passed in the animation definition object. This can be a string with a name of an easing function in `Chartist.Svg.Easing` or an array with four numbers specifying a cubic Bézier curve.
   * **An animations object could look like this:**
   * ```javascript
   * element.animate({
   *   opacity: {
   *     dur: 1000,
   *     from: 0,
   *     to: 1
   *   },
   *   x1: {
   *     dur: '1000ms',
   *     from: 100,
   *     to: 200,
   *     easing: 'easeOutQuart'
   *   },
   *   y1: {
   *     dur: '2s',
   *     from: 0,
   *     to: 100
   *   }
   * });
   * ```
   * **Automatic unit conversion**
   * For the `dur` and the `begin` animate attribute you can also omit a unit by passing a number. The number will automatically be converted to milli seconds.
   * **Guided mode**
   * The default behavior of SMIL animations with offset using the `begin` attribute is that the attribute will keep it's original value until the animation starts. Mostly this behavior is not desired as you'd like to have your element attributes already initialized with the animation `from` value even before the animation starts. Also if you don't specify `fill="freeze"` on an animate element or if you delete the animation after it's done (which is done in guided mode) the attribute will switch back to the initial value. This behavior is also not desired when performing simple one-time animations. For one-time animations you'd want to trigger animations immediately instead of relative to the document begin time. That's why in guided mode Chartist.Svg will also use the `begin` property to schedule a timeout and manually start the animation after the timeout. If you're using multiple SMIL definition objects for an attribute (in an array), guided mode will be disabled for this attribute, even if you explicitly enabled it.
   * If guided mode is enabled the following behavior is added:
   * - Before the animation starts (even when delayed with `begin`) the animated attribute will be set already to the `from` value of the animation
   * - `begin` is explicitly set to `indefinite` so it can be started manually without relying on document begin time (creation)
   * - The animate element will be forced to use `fill="freeze"`
   * - The animation will be triggered with `beginElement()` in a timeout where `begin` of the definition object is interpreted in milli seconds. If no `begin` was specified the timeout is triggered immediately.
   * - After the animation the element attribute value will be set to the `to` value of the animation
   * - The animate element is deleted from the DOM
   *
   * @memberof Chartist.Svg
   * @param {Object} animations An animations object where the property keys are the attributes you'd like to animate. The properties should be objects again that contain the SMIL animation attributes (usually begin, dur, from, and to). The property begin and dur is auto converted (see Automatic unit conversion). You can also schedule multiple animations for the same attribute by passing an Array of SMIL definition objects. Attributes that contain an array of SMIL definition objects will not be executed in guided mode.
   * @param {Boolean} guided Specify if guided mode should be activated for this animation (see Guided mode). If not otherwise specified, guided mode will be activated.
   * @param {Object} eventEmitter If specified, this event emitter will be notified when an animation starts or ends.
   * @return {Chartist.Svg} The current element where the animation was added
   */
  function animate(animations, guided, eventEmitter) {
    if(guided === undefined) {
      guided = true;
    }

    Object.keys(animations).forEach(function createAnimateForAttributes(attribute) {

      function createAnimate(animationDefinition, guided) {
        var attributeProperties = {},
          animate,
          timeout,
          easing;

        // Check if an easing is specified in the definition object and delete it from the object as it will not
        // be part of the animate element attributes.
        if(animationDefinition.easing) {
          // If already an easing Bézier curve array we take it or we lookup a easing array in the Easing object
          easing = animationDefinition.easing instanceof Array ?
            animationDefinition.easing :
            Chartist.Svg.Easing[animationDefinition.easing];
          delete animationDefinition.easing;
        }

        // If numeric dur or begin was provided we assume milli seconds
        animationDefinition.begin = Chartist.ensureUnit(animationDefinition.begin, 'ms');
        animationDefinition.dur = Chartist.ensureUnit(animationDefinition.dur, 'ms');

        if(easing) {
          animationDefinition.calcMode = 'spline';
          animationDefinition.keySplines = easing.join(' ');
          animationDefinition.keyTimes = '0;1';
        }

        // Adding "fill: freeze" if we are in guided mode and set initial attribute values
        if(guided) {
          animationDefinition.fill = 'freeze';
          // Animated property on our element should already be set to the animation from value in guided mode
          attributeProperties[attribute] = animationDefinition.from;
          this.attr(attributeProperties);

          // In guided mode we also set begin to indefinite so we can trigger the start manually and put the begin
          // which needs to be in ms aside
          timeout = Chartist.quantity(animationDefinition.begin || 0).value;
          animationDefinition.begin = 'indefinite';
        }

        animate = this.elem('animate', Chartist.extend({
          attributeName: attribute
        }, animationDefinition));

        if(guided) {
          // If guided we take the value that was put aside in timeout and trigger the animation manually with a timeout
          setTimeout(function() {
            // If beginElement fails we set the animated attribute to the end position and remove the animate element
            // This happens if the SMIL ElementTimeControl interface is not supported or any other problems occured in
            // the browser. (Currently FF 34 does not support animate elements in foreignObjects)
            try {
              animate._node.beginElement();
            } catch(err) {
              // Set animated attribute to current animated value
              attributeProperties[attribute] = animationDefinition.to;
              this.attr(attributeProperties);
              // Remove the animate element as it's no longer required
              animate.remove();
            }
          }.bind(this), timeout);
        }

        if(eventEmitter) {
          animate._node.addEventListener('beginEvent', function handleBeginEvent() {
            eventEmitter.emit('animationBegin', {
              element: this,
              animate: animate._node,
              params: animationDefinition
            });
          }.bind(this));
        }

        animate._node.addEventListener('endEvent', function handleEndEvent() {
          if(eventEmitter) {
            eventEmitter.emit('animationEnd', {
              element: this,
              animate: animate._node,
              params: animationDefinition
            });
          }

          if(guided) {
            // Set animated attribute to current animated value
            attributeProperties[attribute] = animationDefinition.to;
            this.attr(attributeProperties);
            // Remove the animate element as it's no longer required
            animate.remove();
          }
        }.bind(this));
      }

      // If current attribute is an array of definition objects we create an animate for each and disable guided mode
      if(animations[attribute] instanceof Array) {
        animations[attribute].forEach(function(animationDefinition) {
          createAnimate.bind(this)(animationDefinition, false);
        }.bind(this));
      } else {
        createAnimate.bind(this)(animations[attribute], guided);
      }

    }.bind(this));

    return this;
  }

  Chartist.Svg = Chartist.Class.extend({
    constructor: Svg,
    attr: attr,
    elem: elem,
    parent: parent,
    root: root,
    querySelector: querySelector,
    querySelectorAll: querySelectorAll,
    getNode: getNode,
    foreignObject: foreignObject,
    text: text,
    empty: empty,
    remove: remove,
    replace: replace,
    append: append,
    classes: classes,
    addClass: addClass,
    removeClass: removeClass,
    removeAllClasses: removeAllClasses,
    height: height,
    width: width,
    animate: animate
  });

  /**
   * This method checks for support of a given SVG feature like Extensibility, SVG-animation or the like. Check http://www.w3.org/TR/SVG11/feature for a detailed list.
   *
   * @memberof Chartist.Svg
   * @param {String} feature The SVG 1.1 feature that should be checked for support.
   * @return {Boolean} True of false if the feature is supported or not
   */
  Chartist.Svg.isSupported = function(feature) {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#' + feature, '1.1');
  };

  /**
   * This Object contains some standard easing cubic bezier curves. Then can be used with their name in the `Chartist.Svg.animate`. You can also extend the list and use your own name in the `animate` function. Click the show code button to see the available bezier functions.
   *
   * @memberof Chartist.Svg
   */
  var easingCubicBeziers = {
    easeInSine: [0.47, 0, 0.745, 0.715],
    easeOutSine: [0.39, 0.575, 0.565, 1],
    easeInOutSine: [0.445, 0.05, 0.55, 0.95],
    easeInQuad: [0.55, 0.085, 0.68, 0.53],
    easeOutQuad: [0.25, 0.46, 0.45, 0.94],
    easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
    easeInCubic: [0.55, 0.055, 0.675, 0.19],
    easeOutCubic: [0.215, 0.61, 0.355, 1],
    easeInOutCubic: [0.645, 0.045, 0.355, 1],
    easeInQuart: [0.895, 0.03, 0.685, 0.22],
    easeOutQuart: [0.165, 0.84, 0.44, 1],
    easeInOutQuart: [0.77, 0, 0.175, 1],
    easeInQuint: [0.755, 0.05, 0.855, 0.06],
    easeOutQuint: [0.23, 1, 0.32, 1],
    easeInOutQuint: [0.86, 0, 0.07, 1],
    easeInExpo: [0.95, 0.05, 0.795, 0.035],
    easeOutExpo: [0.19, 1, 0.22, 1],
    easeInOutExpo: [1, 0, 0, 1],
    easeInCirc: [0.6, 0.04, 0.98, 0.335],
    easeOutCirc: [0.075, 0.82, 0.165, 1],
    easeInOutCirc: [0.785, 0.135, 0.15, 0.86],
    easeInBack: [0.6, -0.28, 0.735, 0.045],
    easeOutBack: [0.175, 0.885, 0.32, 1.275],
    easeInOutBack: [0.68, -0.55, 0.265, 1.55]
  };

  Chartist.Svg.Easing = easingCubicBeziers;

  /**
   * This helper class is to wrap multiple `Chartist.Svg` elements into a list where you can call the `Chartist.Svg` functions on all elements in the list with one call. This is helpful when you'd like to perform calls with `Chartist.Svg` on multiple elements.
   * An instance of this class is also returned by `Chartist.Svg.querySelectorAll`.
   *
   * @memberof Chartist.Svg
   * @param {Array<Node>|NodeList} nodeList An Array of SVG DOM nodes or a SVG DOM NodeList (as returned by document.querySelectorAll)
   * @constructor
   */
  function SvgList(nodeList) {
    var list = this;

    this.svgElements = [];
    for(var i = 0; i < nodeList.length; i++) {
      this.svgElements.push(new Chartist.Svg(nodeList[i]));
    }

    // Add delegation methods for Chartist.Svg
    Object.keys(Chartist.Svg.prototype).filter(function(prototypeProperty) {
      return ['constructor',
          'parent',
          'querySelector',
          'querySelectorAll',
          'replace',
          'append',
          'classes',
          'height',
          'width'].indexOf(prototypeProperty) === -1;
    }).forEach(function(prototypeProperty) {
      list[prototypeProperty] = function() {
        var args = Array.prototype.slice.call(arguments, 0);
        list.svgElements.forEach(function(element) {
          Chartist.Svg.prototype[prototypeProperty].apply(element, args);
        });
        return list;
      };
    });
  }

  Chartist.Svg.List = Chartist.Class.extend({
    constructor: SvgList
  });
}(window, document, Chartist));
;/**
 * Chartist SVG path module for SVG path description creation and modification.
 *
 * @module Chartist.Svg.Path
 */
/* global Chartist */
(function(window, document, Chartist) {
  'use strict';

  /**
   * Contains the descriptors of supported element types in a SVG path. Currently only move, line and curve are supported.
   *
   * @memberof Chartist.Svg.Path
   * @type {Object}
   */
  var elementDescriptions = {
    m: ['x', 'y'],
    l: ['x', 'y'],
    c: ['x1', 'y1', 'x2', 'y2', 'x', 'y'],
    a: ['rx', 'ry', 'xAr', 'lAf', 'sf', 'x', 'y']
  };

  /**
   * Default options for newly created SVG path objects.
   *
   * @memberof Chartist.Svg.Path
   * @type {Object}
   */
  var defaultOptions = {
    // The accuracy in digit count after the decimal point. This will be used to round numbers in the SVG path. If this option is set to false then no rounding will be performed.
    accuracy: 3
  };

  function element(command, params, pathElements, pos, relative, data) {
    var pathElement = Chartist.extend({
      command: relative ? command.toLowerCase() : command.toUpperCase()
    }, params, data ? { data: data } : {} );

    pathElements.splice(pos, 0, pathElement);
  }

  function forEachParam(pathElements, cb) {
    pathElements.forEach(function(pathElement, pathElementIndex) {
      elementDescriptions[pathElement.command.toLowerCase()].forEach(function(paramName, paramIndex) {
        cb(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
      });
    });
  }

  /**
   * Used to construct a new path object.
   *
   * @memberof Chartist.Svg.Path
   * @param {Boolean} close If set to true then this path will be closed when stringified (with a Z at the end)
   * @param {Object} options Options object that overrides the default objects. See default options for more details.
   * @constructor
   */
  function SvgPath(close, options) {
    this.pathElements = [];
    this.pos = 0;
    this.close = close;
    this.options = Chartist.extend({}, defaultOptions, options);
  }

  /**
   * Gets or sets the current position (cursor) inside of the path. You can move around the cursor freely but limited to 0 or the count of existing elements. All modifications with element functions will insert new elements at the position of this cursor.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} [pos] If a number is passed then the cursor is set to this position in the path element array.
   * @return {Chartist.Svg.Path|Number} If the position parameter was passed then the return value will be the path object for easy call chaining. If no position parameter was passed then the current position is returned.
   */
  function position(pos) {
    if(pos !== undefined) {
      this.pos = Math.max(0, Math.min(this.pathElements.length, pos));
      return this;
    } else {
      return this.pos;
    }
  }

  /**
   * Removes elements from the path starting at the current position.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} count Number of path elements that should be removed from the current position.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function remove(count) {
    this.pathElements.splice(this.pos, count);
    return this;
  }

  /**
   * Use this function to add a new move SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The x coordinate for the move element.
   * @param {Number} y The y coordinate for the move element.
   * @param {Boolean} [relative] If set to true the move element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function move(x, y, relative, data) {
    element('M', {
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Use this function to add a new line SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The x coordinate for the line element.
   * @param {Number} y The y coordinate for the line element.
   * @param {Boolean} [relative] If set to true the line element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function line(x, y, relative, data) {
    element('L', {
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Use this function to add a new curve SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x1 The x coordinate for the first control point of the bezier curve.
   * @param {Number} y1 The y coordinate for the first control point of the bezier curve.
   * @param {Number} x2 The x coordinate for the second control point of the bezier curve.
   * @param {Number} y2 The y coordinate for the second control point of the bezier curve.
   * @param {Number} x The x coordinate for the target point of the curve element.
   * @param {Number} y The y coordinate for the target point of the curve element.
   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function curve(x1, y1, x2, y2, x, y, relative, data) {
    element('C', {
      x1: +x1,
      y1: +y1,
      x2: +x2,
      y2: +y2,
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Use this function to add a new non-bezier curve SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} rx The radius to be used for the x-axis of the arc.
   * @param {Number} ry The radius to be used for the y-axis of the arc.
   * @param {Number} xAr Defines the orientation of the arc
   * @param {Number} lAf Large arc flag
   * @param {Number} sf Sweep flag
   * @param {Number} x The x coordinate for the target point of the curve element.
   * @param {Number} y The y coordinate for the target point of the curve element.
   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function arc(rx, ry, xAr, lAf, sf, x, y, relative, data) {
    element('A', {
      rx: +rx,
      ry: +ry,
      xAr: +xAr,
      lAf: +lAf,
      sf: +sf,
      x: +x,
      y: +y
    }, this.pathElements, this.pos++, relative, data);
    return this;
  }

  /**
   * Parses an SVG path seen in the d attribute of path elements, and inserts the parsed elements into the existing path object at the current cursor position. Any closing path indicators (Z at the end of the path) will be ignored by the parser as this is provided by the close option in the options of the path object.
   *
   * @memberof Chartist.Svg.Path
   * @param {String} path Any SVG path that contains move (m), line (l) or curve (c) components.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function parse(path) {
    // Parsing the SVG path string into an array of arrays [['M', '10', '10'], ['L', '100', '100']]
    var chunks = path.replace(/([A-Za-z])([0-9])/g, '$1 $2')
      .replace(/([0-9])([A-Za-z])/g, '$1 $2')
      .split(/[\s,]+/)
      .reduce(function(result, element) {
        if(element.match(/[A-Za-z]/)) {
          result.push([]);
        }

        result[result.length - 1].push(element);
        return result;
      }, []);

    // If this is a closed path we remove the Z at the end because this is determined by the close option
    if(chunks[chunks.length - 1][0].toUpperCase() === 'Z') {
      chunks.pop();
    }

    // Using svgPathElementDescriptions to map raw path arrays into objects that contain the command and the parameters
    // For example {command: 'M', x: '10', y: '10'}
    var elements = chunks.map(function(chunk) {
        var command = chunk.shift(),
          description = elementDescriptions[command.toLowerCase()];

        return Chartist.extend({
          command: command
        }, description.reduce(function(result, paramName, index) {
          result[paramName] = +chunk[index];
          return result;
        }, {}));
      });

    // Preparing a splice call with the elements array as var arg params and insert the parsed elements at the current position
    var spliceArgs = [this.pos, 0];
    Array.prototype.push.apply(spliceArgs, elements);
    Array.prototype.splice.apply(this.pathElements, spliceArgs);
    // Increase the internal position by the element count
    this.pos += elements.length;

    return this;
  }

  /**
   * This function renders to current SVG path object into a final SVG string that can be used in the d attribute of SVG path elements. It uses the accuracy option to round big decimals. If the close parameter was set in the constructor of this path object then a path closing Z will be appended to the output string.
   *
   * @memberof Chartist.Svg.Path
   * @return {String}
   */
  function stringify() {
    var accuracyMultiplier = Math.pow(10, this.options.accuracy);

    return this.pathElements.reduce(function(path, pathElement) {
        var params = elementDescriptions[pathElement.command.toLowerCase()].map(function(paramName) {
          return this.options.accuracy ?
            (Math.round(pathElement[paramName] * accuracyMultiplier) / accuracyMultiplier) :
            pathElement[paramName];
        }.bind(this));

        return path + pathElement.command + params.join(',');
      }.bind(this), '') + (this.close ? 'Z' : '');
  }

  /**
   * Scales all elements in the current SVG path object. There is an individual parameter for each coordinate. Scaling will also be done for control points of curves, affecting the given coordinate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The number which will be used to scale the x, x1 and x2 of all path elements.
   * @param {Number} y The number which will be used to scale the y, y1 and y2 of all path elements.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function scale(x, y) {
    forEachParam(this.pathElements, function(pathElement, paramName) {
      pathElement[paramName] *= paramName[0] === 'x' ? x : y;
    });
    return this;
  }

  /**
   * Translates all elements in the current SVG path object. The translation is relative and there is an individual parameter for each coordinate. Translation will also be done for control points of curves, affecting the given coordinate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The number which will be used to translate the x, x1 and x2 of all path elements.
   * @param {Number} y The number which will be used to translate the y, y1 and y2 of all path elements.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function translate(x, y) {
    forEachParam(this.pathElements, function(pathElement, paramName) {
      pathElement[paramName] += paramName[0] === 'x' ? x : y;
    });
    return this;
  }

  /**
   * This function will run over all existing path elements and then loop over their attributes. The callback function will be called for every path element attribute that exists in the current path.
   * The method signature of the callback function looks like this:
   * ```javascript
   * function(pathElement, paramName, pathElementIndex, paramIndex, pathElements)
   * ```
   * If something else than undefined is returned by the callback function, this value will be used to replace the old value. This allows you to build custom transformations of path objects that can't be achieved using the basic transformation functions scale and translate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Function} transformFnc The callback function for the transformation. Check the signature in the function description.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */
  function transform(transformFnc) {
    forEachParam(this.pathElements, function(pathElement, paramName, pathElementIndex, paramIndex, pathElements) {
      var transformed = transformFnc(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
      if(transformed || transformed === 0) {
        pathElement[paramName] = transformed;
      }
    });
    return this;
  }

  /**
   * This function clones a whole path object with all its properties. This is a deep clone and path element objects will also be cloned.
   *
   * @memberof Chartist.Svg.Path
   * @param {Boolean} [close] Optional option to set the new cloned path to closed. If not specified or false, the original path close option will be used.
   * @return {Chartist.Svg.Path}
   */
  function clone(close) {
    var c = new Chartist.Svg.Path(close || this.close);
    c.pos = this.pos;
    c.pathElements = this.pathElements.slice().map(function cloneElements(pathElement) {
      return Chartist.extend({}, pathElement);
    });
    c.options = Chartist.extend({}, this.options);
    return c;
  }

  /**
   * Split a Svg.Path object by a specific command in the path chain. The path chain will be split and an array of newly created paths objects will be returned. This is useful if you'd like to split an SVG path by it's move commands, for example, in order to isolate chunks of drawings.
   *
   * @memberof Chartist.Svg.Path
   * @param {String} command The command you'd like to use to split the path
   * @return {Array<Chartist.Svg.Path>}
   */
  function splitByCommand(command) {
    var split = [
      new Chartist.Svg.Path()
    ];

    this.pathElements.forEach(function(pathElement) {
      if(pathElement.command === command.toUpperCase() && split[split.length - 1].pathElements.length !== 0) {
        split.push(new Chartist.Svg.Path());
      }

      split[split.length - 1].pathElements.push(pathElement);
    });

    return split;
  }

  /**
   * This static function on `Chartist.Svg.Path` is joining multiple paths together into one paths.
   *
   * @memberof Chartist.Svg.Path
   * @param {Array<Chartist.Svg.Path>} paths A list of paths to be joined together. The order is important.
   * @param {boolean} close If the newly created path should be a closed path
   * @param {Object} options Path options for the newly created path.
   * @return {Chartist.Svg.Path}
   */

  function join(paths, close, options) {
    var joinedPath = new Chartist.Svg.Path(close, options);
    for(var i = 0; i < paths.length; i++) {
      var path = paths[i];
      for(var j = 0; j < path.pathElements.length; j++) {
        joinedPath.pathElements.push(path.pathElements[j]);
      }
    }
    return joinedPath;
  }

  Chartist.Svg.Path = Chartist.Class.extend({
    constructor: SvgPath,
    position: position,
    remove: remove,
    move: move,
    line: line,
    curve: curve,
    arc: arc,
    scale: scale,
    translate: translate,
    transform: transform,
    parse: parse,
    stringify: stringify,
    clone: clone,
    splitByCommand: splitByCommand
  });

  Chartist.Svg.Path.elementDescriptions = elementDescriptions;
  Chartist.Svg.Path.join = join;
}(window, document, Chartist));
;/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  var axisUnits = {
    x: {
      pos: 'x',
      len: 'width',
      dir: 'horizontal',
      rectStart: 'x1',
      rectEnd: 'x2',
      rectOffset: 'y2'
    },
    y: {
      pos: 'y',
      len: 'height',
      dir: 'vertical',
      rectStart: 'y2',
      rectEnd: 'y1',
      rectOffset: 'x1'
    }
  };

  function Axis(units, chartRect, ticks, options) {
    this.units = units;
    this.counterUnits = units === axisUnits.x ? axisUnits.y : axisUnits.x;
    this.chartRect = chartRect;
    this.axisLength = chartRect[units.rectEnd] - chartRect[units.rectStart];
    this.gridOffset = chartRect[units.rectOffset];
    this.ticks = ticks;
    this.options = options;
  }

  function createGridAndLabels(gridGroup, labelGroup, useForeignObject, chartOptions, eventEmitter) {
    var axisOptions = chartOptions['axis' + this.units.pos.toUpperCase()];
    var projectedValues = this.ticks.map(this.projectValue.bind(this));
    var labelValues = this.ticks.map(axisOptions.labelInterpolationFnc);

    projectedValues.forEach(function(projectedValue, index) {
      var labelOffset = {
        x: 0,
        y: 0
      };

      // TODO: Find better solution for solving this problem
      // Calculate how much space we have available for the label
      var labelLength;
      if(projectedValues[index + 1]) {
        // If we still have one label ahead, we can calculate the distance to the next tick / label
        labelLength = projectedValues[index + 1] - projectedValue;
      } else {
        // If we don't have a label ahead and we have only two labels in total, we just take the remaining distance to
        // on the whole axis length. We limit that to a minimum of 30 pixel, so that labels close to the border will
        // still be visible inside of the chart padding.
        labelLength = Math.max(this.axisLength - projectedValue, 30);
      }

      // Skip grid lines and labels where interpolated label values are falsey (execpt for 0)
      if(Chartist.isFalseyButZero(labelValues[index]) && labelValues[index] !== '') {
        return;
      }

      // Transform to global coordinates using the chartRect
      // We also need to set the label offset for the createLabel function
      if(this.units.pos === 'x') {
        projectedValue = this.chartRect.x1 + projectedValue;
        labelOffset.x = chartOptions.axisX.labelOffset.x;

        // If the labels should be positioned in start position (top side for vertical axis) we need to set a
        // different offset as for positioned with end (bottom)
        if(chartOptions.axisX.position === 'start') {
          labelOffset.y = this.chartRect.padding.top + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
        } else {
          labelOffset.y = this.chartRect.y1 + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
        }
      } else {
        projectedValue = this.chartRect.y1 - projectedValue;
        labelOffset.y = chartOptions.axisY.labelOffset.y - (useForeignObject ? labelLength : 0);

        // If the labels should be positioned in start position (left side for horizontal axis) we need to set a
        // different offset as for positioned with end (right side)
        if(chartOptions.axisY.position === 'start') {
          labelOffset.x = useForeignObject ? this.chartRect.padding.left + chartOptions.axisY.labelOffset.x : this.chartRect.x1 - 10;
        } else {
          labelOffset.x = this.chartRect.x2 + chartOptions.axisY.labelOffset.x + 10;
        }
      }

      if(axisOptions.showGrid) {
        Chartist.createGrid(projectedValue, index, this, this.gridOffset, this.chartRect[this.counterUnits.len](), gridGroup, [
          chartOptions.classNames.grid,
          chartOptions.classNames[this.units.dir]
        ], eventEmitter);
      }

      if(axisOptions.showLabel) {
        Chartist.createLabel(projectedValue, labelLength, index, labelValues, this, axisOptions.offset, labelOffset, labelGroup, [
          chartOptions.classNames.label,
          chartOptions.classNames[this.units.dir],
          (axisOptions.position === 'start' ? chartOptions.classNames[axisOptions.position] : chartOptions.classNames['end'])
        ], useForeignObject, eventEmitter);
      }
    }.bind(this));
  }

  Chartist.Axis = Chartist.Class.extend({
    constructor: Axis,
    createGridAndLabels: createGridAndLabels,
    projectValue: function(value, index, data) {
      throw new Error('Base axis can\'t be instantiated!');
    }
  });

  Chartist.Axis.units = axisUnits;

}(window, document, Chartist));
;/**
 * The auto scale axis uses standard linear scale projection of values along an axis. It uses order of magnitude to find a scale automatically and evaluates the available space in order to find the perfect amount of ticks for your chart.
 * **Options**
 * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
 * ```javascript
 * var options = {
 *   // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
 *   high: 100,
 *   // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
 *   low: 0,
 *   // This option will be used when finding the right scale division settings. The amount of ticks on the scale will be determined so that as many ticks as possible will be displayed, while not violating this minimum required space (in pixel).
 *   scaleMinSpace: 20,
 *   // Can be set to true or false. If set to true, the scale will be generated with whole numbers only.
 *   onlyInteger: true,
 *   // The reference value can be used to make sure that this value will always be on the chart. This is especially useful on bipolar charts where the bipolar center always needs to be part of the chart.
 *   referenceValue: 5
 * };
 * ```
 *
 * @module Chartist.AutoScaleAxis
 */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function AutoScaleAxis(axisUnit, data, chartRect, options) {
    // Usually we calculate highLow based on the data but this can be overriden by a highLow object in the options
    var highLow = options.highLow || Chartist.getHighLow(data, options, axisUnit.pos);
    this.bounds = Chartist.getBounds(chartRect[axisUnit.rectEnd] - chartRect[axisUnit.rectStart], highLow, options.scaleMinSpace || 20, options.onlyInteger);
    this.range = {
      min: this.bounds.min,
      max: this.bounds.max
    };

    Chartist.AutoScaleAxis.super.constructor.call(this,
      axisUnit,
      chartRect,
      this.bounds.values,
      options);
  }

  function projectValue(value) {
    return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.bounds.min) / this.bounds.range;
  }

  Chartist.AutoScaleAxis = Chartist.Axis.extend({
    constructor: AutoScaleAxis,
    projectValue: projectValue
  });

}(window, document, Chartist));
;/**
 * The fixed scale axis uses standard linear projection of values along an axis. It makes use of a divisor option to divide the range provided from the minimum and maximum value or the options high and low that will override the computed minimum and maximum.
 * **Options**
 * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
 * ```javascript
 * var options = {
 *   // If high is specified then the axis will display values explicitly up to this value and the computed maximum from the data is ignored
 *   high: 100,
 *   // If low is specified then the axis will display values explicitly down to this value and the computed minimum from the data is ignored
 *   low: 0,
 *   // If specified then the value range determined from minimum to maximum (or low and high) will be divided by this number and ticks will be generated at those division points. The default divisor is 1.
 *   divisor: 4,
 *   // If ticks is explicitly set, then the axis will not compute the ticks with the divisor, but directly use the data in ticks to determine at what points on the axis a tick need to be generated.
 *   ticks: [1, 10, 20, 30]
 * };
 * ```
 *
 * @module Chartist.FixedScaleAxis
 */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function FixedScaleAxis(axisUnit, data, chartRect, options) {
    var highLow = options.highLow || Chartist.getHighLow(data, options, axisUnit.pos);
    this.divisor = options.divisor || 1;
    this.ticks = options.ticks || Chartist.times(this.divisor).map(function(value, index) {
      return highLow.low + (highLow.high - highLow.low) / this.divisor * index;
    }.bind(this));
    this.ticks.sort(function(a, b) {
      return a - b;
    });
    this.range = {
      min: highLow.low,
      max: highLow.high
    };

    Chartist.FixedScaleAxis.super.constructor.call(this,
      axisUnit,
      chartRect,
      this.ticks,
      options);

    this.stepLength = this.axisLength / this.divisor;
  }

  function projectValue(value) {
    return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.range.min) / (this.range.max - this.range.min);
  }

  Chartist.FixedScaleAxis = Chartist.Axis.extend({
    constructor: FixedScaleAxis,
    projectValue: projectValue
  });

}(window, document, Chartist));
;/**
 * The step axis for step based charts like bar chart or step based line charts. It uses a fixed amount of ticks that will be equally distributed across the whole axis length. The projection is done using the index of the data value rather than the value itself and therefore it's only useful for distribution purpose.
 * **Options**
 * The following options are used by this axis in addition to the default axis options outlined in the axis configuration of the chart default settings.
 * ```javascript
 * var options = {
 *   // Ticks to be used to distribute across the axis length. As this axis type relies on the index of the value rather than the value, arbitrary data that can be converted to a string can be used as ticks.
 *   ticks: ['One', 'Two', 'Three'],
 *   // If set to true the full width will be used to distribute the values where the last value will be at the maximum of the axis length. If false the spaces between the ticks will be evenly distributed instead.
 *   stretch: true
 * };
 * ```
 *
 * @module Chartist.StepAxis
 */
/* global Chartist */
(function (window, document, Chartist) {
  'use strict';

  function StepAxis(axisUnit, data, chartRect, options) {
    Chartist.StepAxis.super.constructor.call(this,
      axisUnit,
      chartRect,
      options.ticks,
      options);

    var calc = Math.max(1, options.ticks.length - (options.stretch ? 1 : 0));
    this.stepLength = this.axisLength / calc;
  }

  function projectValue(value, index) {
    return this.stepLength * index;
  }

  Chartist.StepAxis = Chartist.Axis.extend({
    constructor: StepAxis,
    projectValue: projectValue
  });

}(window, document, Chartist));
;/**
 * The Chartist line chart can be used to draw Line or Scatter charts. If used in the browser you can access the global `Chartist` namespace where you find the `Line` function as a main entry point.
 *
 * For examples on how to use the line chart please check the examples of the `Chartist.Line` method.
 *
 * @module Chartist.Line
 */
/* global Chartist */
(function(window, document, Chartist){
  'use strict';

  /**
   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Line
   */
  var defaultOptions = {
    // Options for X-Axis
    axisX: {
      // The offset of the labels to the chart area
      offset: 30,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'end',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // Set the axis type to be used to project values on this axis. If not defined, Chartist.StepAxis will be used for the X-Axis, where the ticks option will be set to the labels in the data and the stretch option will be set to the global fullWidth option. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
      type: undefined
    },
    // Options for Y-Axis
    axisY: {
      // The offset of the labels to the chart area
      offset: 40,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'start',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // Set the axis type to be used to project values on this axis. If not defined, Chartist.AutoScaleAxis will be used for the Y-Axis, where the high and low options will be set to the global high and low options. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
      type: undefined,
      // This value specifies the minimum height in pixel of the scale steps
      scaleMinSpace: 20,
      // Use only integer values (whole numbers) for the scale steps
      onlyInteger: false
    },
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // If the line should be drawn or not
    showLine: true,
    // If dots should be drawn or not
    showPoint: true,
    // If the line chart should draw an area
    showArea: false,
    // The base for the area chart that will be used to close the area shape (is normally 0)
    areaBase: 0,
    // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
    lineSmooth: true,
    // If the line chart should add a background fill to the .ct-grids group.
    showGridBackground: false,
    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
    low: undefined,
    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
    high: undefined,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: {
      top: 15,
      right: 15,
      bottom: 5,
      left: 10
    },
    // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full available width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
    fullWidth: false,
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // Override the class names that get used to generate the SVG structure of the chart
    classNames: {
      chart: 'ct-chart-line',
      label: 'ct-label',
      labelGroup: 'ct-labels',
      series: 'ct-series',
      line: 'ct-line',
      point: 'ct-point',
      area: 'ct-area',
      grid: 'ct-grid',
      gridGroup: 'ct-grids',
      gridBackground: 'ct-grid-background',
      vertical: 'ct-vertical',
      horizontal: 'ct-horizontal',
      start: 'ct-start',
      end: 'ct-end'
    }
  };

  /**
   * Creates a new chart
   *
   */
  function createChart(options) {
    var data = Chartist.normalizeData(this.data, options.reverseData, true);

    // Create new svg object
    this.svg = Chartist.createSvg(this.container, options.width, options.height, options.classNames.chart);
    // Create groups for labels, grid and series
    var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
    var seriesGroup = this.svg.elem('g');
    var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);

    var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
    var axisX, axisY;

    if(options.axisX.type === undefined) {
      axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data.normalized.series, chartRect, Chartist.extend({}, options.axisX, {
        ticks: data.normalized.labels,
        stretch: options.fullWidth
      }));
    } else {
      axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data.normalized.series, chartRect, options.axisX);
    }

    if(options.axisY.type === undefined) {
      axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data.normalized.series, chartRect, Chartist.extend({}, options.axisY, {
        high: Chartist.isNumeric(options.high) ? options.high : options.axisY.high,
        low: Chartist.isNumeric(options.low) ? options.low : options.axisY.low
      }));
    } else {
      axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data.normalized.series, chartRect, options.axisY);
    }

    axisX.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
    axisY.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);

    if (options.showGridBackground) {
      Chartist.createGridBackground(gridGroup, chartRect, options.classNames.gridBackground, this.eventEmitter);
    }

    // Draw the series
    data.raw.series.forEach(function(series, seriesIndex) {
      var seriesElement = seriesGroup.elem('g');

      // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
      seriesElement.attr({
        'ct:series-name': series.name,
        'ct:meta': Chartist.serialize(series.meta)
      });

      // Use series class from series data or if not set generate one
      seriesElement.addClass([
        options.classNames.series,
        (series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex))
      ].join(' '));

      var pathCoordinates = [],
        pathData = [];

      data.normalized.series[seriesIndex].forEach(function(value, valueIndex) {
        var p = {
          x: chartRect.x1 + axisX.projectValue(value, valueIndex, data.normalized.series[seriesIndex]),
          y: chartRect.y1 - axisY.projectValue(value, valueIndex, data.normalized.series[seriesIndex])
        };
        pathCoordinates.push(p.x, p.y);
        pathData.push({
          value: value,
          valueIndex: valueIndex,
          meta: Chartist.getMetaData(series, valueIndex)
        });
      }.bind(this));

      var seriesOptions = {
        lineSmooth: Chartist.getSeriesOption(series, options, 'lineSmooth'),
        showPoint: Chartist.getSeriesOption(series, options, 'showPoint'),
        showLine: Chartist.getSeriesOption(series, options, 'showLine'),
        showArea: Chartist.getSeriesOption(series, options, 'showArea'),
        areaBase: Chartist.getSeriesOption(series, options, 'areaBase')
      };

      var smoothing = typeof seriesOptions.lineSmooth === 'function' ?
        seriesOptions.lineSmooth : (seriesOptions.lineSmooth ? Chartist.Interpolation.monotoneCubic() : Chartist.Interpolation.none());
      // Interpolating path where pathData will be used to annotate each path element so we can trace back the original
      // index, value and meta data
      var path = smoothing(pathCoordinates, pathData);

      // If we should show points we need to create them now to avoid secondary loop
      // Points are drawn from the pathElements returned by the interpolation function
      // Small offset for Firefox to render squares correctly
      if (seriesOptions.showPoint) {

        path.pathElements.forEach(function(pathElement) {
          var point = seriesElement.elem('line', {
            x1: pathElement.x,
            y1: pathElement.y,
            x2: pathElement.x + 0.01,
            y2: pathElement.y
          }, options.classNames.point).attr({
            'ct:value': [pathElement.data.value.x, pathElement.data.value.y].filter(Chartist.isNumeric).join(','),
            'ct:meta': Chartist.serialize(pathElement.data.meta)
          });

          this.eventEmitter.emit('draw', {
            type: 'point',
            value: pathElement.data.value,
            index: pathElement.data.valueIndex,
            meta: pathElement.data.meta,
            series: series,
            seriesIndex: seriesIndex,
            axisX: axisX,
            axisY: axisY,
            group: seriesElement,
            element: point,
            x: pathElement.x,
            y: pathElement.y
          });
        }.bind(this));
      }

      if(seriesOptions.showLine) {
        var line = seriesElement.elem('path', {
          d: path.stringify()
        }, options.classNames.line, true);

        this.eventEmitter.emit('draw', {
          type: 'line',
          values: data.normalized.series[seriesIndex],
          path: path.clone(),
          chartRect: chartRect,
          index: seriesIndex,
          series: series,
          seriesIndex: seriesIndex,
          seriesMeta: series.meta,
          axisX: axisX,
          axisY: axisY,
          group: seriesElement,
          element: line
        });
      }

      // Area currently only works with axes that support a range!
      if(seriesOptions.showArea && axisY.range) {
        // If areaBase is outside the chart area (< min or > max) we need to set it respectively so that
        // the area is not drawn outside the chart area.
        var areaBase = Math.max(Math.min(seriesOptions.areaBase, axisY.range.max), axisY.range.min);

        // We project the areaBase value into screen coordinates
        var areaBaseProjected = chartRect.y1 - axisY.projectValue(areaBase);

        // In order to form the area we'll first split the path by move commands so we can chunk it up into segments
        path.splitByCommand('M').filter(function onlySolidSegments(pathSegment) {
          // We filter only "solid" segments that contain more than one point. Otherwise there's no need for an area
          return pathSegment.pathElements.length > 1;
        }).map(function convertToArea(solidPathSegments) {
          // Receiving the filtered solid path segments we can now convert those segments into fill areas
          var firstElement = solidPathSegments.pathElements[0];
          var lastElement = solidPathSegments.pathElements[solidPathSegments.pathElements.length - 1];

          // Cloning the solid path segment with closing option and removing the first move command from the clone
          // We then insert a new move that should start at the area base and draw a straight line up or down
          // at the end of the path we add an additional straight line to the projected area base value
          // As the closing option is set our path will be automatically closed
          return solidPathSegments.clone(true)
            .position(0)
            .remove(1)
            .move(firstElement.x, areaBaseProjected)
            .line(firstElement.x, firstElement.y)
            .position(solidPathSegments.pathElements.length + 1)
            .line(lastElement.x, areaBaseProjected);

        }).forEach(function createArea(areaPath) {
          // For each of our newly created area paths, we'll now create path elements by stringifying our path objects
          // and adding the created DOM elements to the correct series group
          var area = seriesElement.elem('path', {
            d: areaPath.stringify()
          }, options.classNames.area, true);

          // Emit an event for each area that was drawn
          this.eventEmitter.emit('draw', {
            type: 'area',
            values: data.normalized.series[seriesIndex],
            path: areaPath.clone(),
            series: series,
            seriesIndex: seriesIndex,
            axisX: axisX,
            axisY: axisY,
            chartRect: chartRect,
            index: seriesIndex,
            group: seriesElement,
            element: area
          });
        }.bind(this));
      }
    }.bind(this));

    this.eventEmitter.emit('created', {
      bounds: axisY.bounds,
      chartRect: chartRect,
      axisX: axisX,
      axisY: axisY,
      svg: this.svg,
      options: options
    });
  }

  /**
   * This method creates a new line chart.
   *
   * @memberof Chartist.Line
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object that needs to consist of a labels and a series array
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object which exposes the API for the created chart
   *
   * @example
   * // Create a simple line chart
   * var data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // As options we currently only set a static size of 300x200 px
   * var options = {
   *   width: '300px',
   *   height: '200px'
   * };
   *
   * // In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
   * new Chartist.Line('.ct-chart', data, options);
   *
   * @example
   * // Use specific interpolation function with configuration from the Chartist.Interpolation module
   *
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [
   *     [1, 1, 8, 1, 7]
   *   ]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 0.2
   *   })
   * });
   *
   * @example
   * // Create a line chart with responsive options
   *
   * var data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In addition to the regular options we specify responsive option overrides that will override the default configutation based on the matching media queries.
   * var responsiveOptions = [
   *   ['screen and (min-width: 641px) and (max-width: 1024px)', {
   *     showPoint: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return Mon, Tue, Wed etc. on medium screens
   *         return value.slice(0, 3);
   *       }
   *     }
   *   }],
   *   ['screen and (max-width: 640px)', {
   *     showLine: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return M, T, W etc. on small screens
   *         return value[0];
   *       }
   *     }
   *   }]
   * ];
   *
   * new Chartist.Line('.ct-chart', data, null, responsiveOptions);
   *
   */
  function Line(query, data, options, responsiveOptions) {
    Chartist.Line.super.constructor.call(this,
      query,
      data,
      defaultOptions,
      Chartist.extend({}, defaultOptions, options),
      responsiveOptions);
  }

  // Creating line chart type in Chartist namespace
  Chartist.Line = Chartist.Base.extend({
    constructor: Line,
    createChart: createChart
  });

}(window, document, Chartist));
;/**
 * The bar chart module of Chartist that can be used to draw unipolar or bipolar bar and grouped bar charts.
 *
 * @module Chartist.Bar
 */
/* global Chartist */
(function(window, document, Chartist){
  'use strict';

  /**
   * Default options in bar charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Bar
   */
  var defaultOptions = {
    // Options for X-Axis
    axisX: {
      // The offset of the chart drawing area to the border of the container
      offset: 30,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'end',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // This value specifies the minimum width in pixel of the scale steps
      scaleMinSpace: 30,
      // Use only integer values (whole numbers) for the scale steps
      onlyInteger: false
    },
    // Options for Y-Axis
    axisY: {
      // The offset of the chart drawing area to the border of the container
      offset: 40,
      // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
      position: 'start',
      // Allows you to correct label positioning on this axis by positive or negative x and y offset.
      labelOffset: {
        x: 0,
        y: 0
      },
      // If labels should be shown or not
      showLabel: true,
      // If the axis grid should be drawn or not
      showGrid: true,
      // Interpolation function that allows you to intercept the value from the axis label
      labelInterpolationFnc: Chartist.noop,
      // This value specifies the minimum height in pixel of the scale steps
      scaleMinSpace: 20,
      // Use only integer values (whole numbers) for the scale steps
      onlyInteger: false
    },
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
    high: undefined,
    // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
    low: undefined,
    // Unless low/high are explicitly set, bar chart will be centered at zero by default. Set referenceValue to null to auto scale.
    referenceValue: 0,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: {
      top: 15,
      right: 15,
      bottom: 5,
      left: 10
    },
    // Specify the distance in pixel of bars in a group
    seriesBarDistance: 15,
    // If set to true this property will cause the series bars to be stacked. Check the `stackMode` option for further stacking options.
    stackBars: false,
    // If set to 'overlap' this property will force the stacked bars to draw from the zero line.
    // If set to 'accumulate' this property will form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
    stackMode: 'accumulate',
    // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
    horizontalBars: false,
    // If set to true then each bar will represent a series and the data array is expected to be a one dimensional array of data values rather than a series array of series. This is useful if the bar chart should represent a profile rather than some data over time.
    distributeSeries: false,
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // If the bar chart should add a background fill to the .ct-grids group.
    showGridBackground: false,
    // Override the class names that get used to generate the SVG structure of the chart
    classNames: {
      chart: 'ct-chart-bar',
      horizontalBars: 'ct-horizontal-bars',
      label: 'ct-label',
      labelGroup: 'ct-labels',
      series: 'ct-series',
      bar: 'ct-bar',
      grid: 'ct-grid',
      gridGroup: 'ct-grids',
      gridBackground: 'ct-grid-background',
      vertical: 'ct-vertical',
      horizontal: 'ct-horizontal',
      start: 'ct-start',
      end: 'ct-end'
    }
  };

  /**
   * Creates a new chart
   *
   */
  function createChart(options) {
    var data;
    var highLow;

    if(options.distributeSeries) {
      data = Chartist.normalizeData(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y');
      data.normalized.series = data.normalized.series.map(function(value) {
        return [value];
      });
    } else {
      data = Chartist.normalizeData(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y');
    }

    // Create new svg element
    this.svg = Chartist.createSvg(
      this.container,
      options.width,
      options.height,
      options.classNames.chart + (options.horizontalBars ? ' ' + options.classNames.horizontalBars : '')
    );

    // Drawing groups in correct order
    var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
    var seriesGroup = this.svg.elem('g');
    var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);

    if(options.stackBars && data.normalized.series.length !== 0) {

      // If stacked bars we need to calculate the high low from stacked values from each series
      var serialSums = Chartist.serialMap(data.normalized.series, function serialSums() {
        return Array.prototype.slice.call(arguments).map(function(value) {
          return value;
        }).reduce(function(prev, curr) {
          return {
            x: prev.x + (curr && curr.x) || 0,
            y: prev.y + (curr && curr.y) || 0
          };
        }, {x: 0, y: 0});
      });

      highLow = Chartist.getHighLow([serialSums], options, options.horizontalBars ? 'x' : 'y');

    } else {

      highLow = Chartist.getHighLow(data.normalized.series, options, options.horizontalBars ? 'x' : 'y');
    }

    // Overrides of high / low from settings
    highLow.high = +options.high || (options.high === 0 ? 0 : highLow.high);
    highLow.low = +options.low || (options.low === 0 ? 0 : highLow.low);

    var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);

    var valueAxis,
      labelAxisTicks,
      labelAxis,
      axisX,
      axisY;

    // We need to set step count based on some options combinations
    if(options.distributeSeries && options.stackBars) {
      // If distributed series are enabled and bars need to be stacked, we'll only have one bar and therefore should
      // use only the first label for the step axis
      labelAxisTicks = data.normalized.labels.slice(0, 1);
    } else {
      // If distributed series are enabled but stacked bars aren't, we should use the series labels
      // If we are drawing a regular bar chart with two dimensional series data, we just use the labels array
      // as the bars are normalized
      labelAxisTicks = data.normalized.labels;
    }

    // Set labelAxis and valueAxis based on the horizontalBars setting. This setting will flip the axes if necessary.
    if(options.horizontalBars) {
      if(options.axisX.type === undefined) {
        valueAxis = axisX = new Chartist.AutoScaleAxis(Chartist.Axis.units.x, data.normalized.series, chartRect, Chartist.extend({}, options.axisX, {
          highLow: highLow,
          referenceValue: 0
        }));
      } else {
        valueAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data.normalized.series, chartRect, Chartist.extend({}, options.axisX, {
          highLow: highLow,
          referenceValue: 0
        }));
      }

      if(options.axisY.type === undefined) {
        labelAxis = axisY = new Chartist.StepAxis(Chartist.Axis.units.y, data.normalized.series, chartRect, {
          ticks: labelAxisTicks
        });
      } else {
        labelAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data.normalized.series, chartRect, options.axisY);
      }
    } else {
      if(options.axisX.type === undefined) {
        labelAxis = axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data.normalized.series, chartRect, {
          ticks: labelAxisTicks
        });
      } else {
        labelAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data.normalized.series, chartRect, options.axisX);
      }

      if(options.axisY.type === undefined) {
        valueAxis = axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data.normalized.series, chartRect, Chartist.extend({}, options.axisY, {
          highLow: highLow,
          referenceValue: 0
        }));
      } else {
        valueAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data.normalized.series, chartRect, Chartist.extend({}, options.axisY, {
          highLow: highLow,
          referenceValue: 0
        }));
      }
    }

    // Projected 0 point
    var zeroPoint = options.horizontalBars ? (chartRect.x1 + valueAxis.projectValue(0)) : (chartRect.y1 - valueAxis.projectValue(0));
    // Used to track the screen coordinates of stacked bars
    var stackedBarValues = [];

    labelAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
    valueAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);

    if (options.showGridBackground) {
      Chartist.createGridBackground(gridGroup, chartRect, options.classNames.gridBackground, this.eventEmitter);
    }

    // Draw the series
    data.raw.series.forEach(function(series, seriesIndex) {
      // Calculating bi-polar value of index for seriesOffset. For i = 0..4 biPol will be -1.5, -0.5, 0.5, 1.5 etc.
      var biPol = seriesIndex - (data.raw.series.length - 1) / 2;
      // Half of the period width between vertical grid lines used to position bars
      var periodHalfLength;
      // Current series SVG element
      var seriesElement;

      // We need to set periodHalfLength based on some options combinations
      if(options.distributeSeries && !options.stackBars) {
        // If distributed series are enabled but stacked bars aren't, we need to use the length of the normaizedData array
        // which is the series count and divide by 2
        periodHalfLength = labelAxis.axisLength / data.normalized.series.length / 2;
      } else if(options.distributeSeries && options.stackBars) {
        // If distributed series and stacked bars are enabled we'll only get one bar so we should just divide the axis
        // length by 2
        periodHalfLength = labelAxis.axisLength / 2;
      } else {
        // On regular bar charts we should just use the series length
        periodHalfLength = labelAxis.axisLength / data.normalized.series[seriesIndex].length / 2;
      }

      // Adding the series group to the series element
      seriesElement = seriesGroup.elem('g');

      // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
      seriesElement.attr({
        'ct:series-name': series.name,
        'ct:meta': Chartist.serialize(series.meta)
      });

      // Use series class from series data or if not set generate one
      seriesElement.addClass([
        options.classNames.series,
        (series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex))
      ].join(' '));

      data.normalized.series[seriesIndex].forEach(function(value, valueIndex) {
        var projected,
          bar,
          previousStack,
          labelAxisValueIndex;

        // We need to set labelAxisValueIndex based on some options combinations
        if(options.distributeSeries && !options.stackBars) {
          // If distributed series are enabled but stacked bars aren't, we can use the seriesIndex for later projection
          // on the step axis for label positioning
          labelAxisValueIndex = seriesIndex;
        } else if(options.distributeSeries && options.stackBars) {
          // If distributed series and stacked bars are enabled, we will only get one bar and therefore always use
          // 0 for projection on the label step axis
          labelAxisValueIndex = 0;
        } else {
          // On regular bar charts we just use the value index to project on the label step axis
          labelAxisValueIndex = valueIndex;
        }

        // We need to transform coordinates differently based on the chart layout
        if(options.horizontalBars) {
          projected = {
            x: chartRect.x1 + valueAxis.projectValue(value && value.x ? value.x : 0, valueIndex, data.normalized.series[seriesIndex]),
            y: chartRect.y1 - labelAxis.projectValue(value && value.y ? value.y : 0, labelAxisValueIndex, data.normalized.series[seriesIndex])
          };
        } else {
          projected = {
            x: chartRect.x1 + labelAxis.projectValue(value && value.x ? value.x : 0, labelAxisValueIndex, data.normalized.series[seriesIndex]),
            y: chartRect.y1 - valueAxis.projectValue(value && value.y ? value.y : 0, valueIndex, data.normalized.series[seriesIndex])
          }
        }

        // If the label axis is a step based axis we will offset the bar into the middle of between two steps using
        // the periodHalfLength value. Also we do arrange the different series so that they align up to each other using
        // the seriesBarDistance. If we don't have a step axis, the bar positions can be chosen freely so we should not
        // add any automated positioning.
        if(labelAxis instanceof Chartist.StepAxis) {
          // Offset to center bar between grid lines, but only if the step axis is not stretched
          if(!labelAxis.options.stretch) {
            projected[labelAxis.units.pos] += periodHalfLength * (options.horizontalBars ? -1 : 1);
          }
          // Using bi-polar offset for multiple series if no stacked bars or series distribution is used
          projected[labelAxis.units.pos] += (options.stackBars || options.distributeSeries) ? 0 : biPol * options.seriesBarDistance * (options.horizontalBars ? -1 : 1);
        }

        // Enter value in stacked bar values used to remember previous screen value for stacking up bars
        previousStack = stackedBarValues[valueIndex] || zeroPoint;
        stackedBarValues[valueIndex] = previousStack - (zeroPoint - projected[labelAxis.counterUnits.pos]);

        // Skip if value is undefined
        if(value === undefined) {
          return;
        }

        var positions = {};
        positions[labelAxis.units.pos + '1'] = projected[labelAxis.units.pos];
        positions[labelAxis.units.pos + '2'] = projected[labelAxis.units.pos];

        if(options.stackBars && (options.stackMode === 'accumulate' || !options.stackMode)) {
          // Stack mode: accumulate (default)
          // If bars are stacked we use the stackedBarValues reference and otherwise base all bars off the zero line
          // We want backwards compatibility, so the expected fallback without the 'stackMode' option
          // to be the original behaviour (accumulate)
          positions[labelAxis.counterUnits.pos + '1'] = previousStack;
          positions[labelAxis.counterUnits.pos + '2'] = stackedBarValues[valueIndex];
        } else {
          // Draw from the zero line normally
          // This is also the same code for Stack mode: overlap
          positions[labelAxis.counterUnits.pos + '1'] = zeroPoint;
          positions[labelAxis.counterUnits.pos + '2'] = projected[labelAxis.counterUnits.pos];
        }

        // Limit x and y so that they are within the chart rect
        positions.x1 = Math.min(Math.max(positions.x1, chartRect.x1), chartRect.x2);
        positions.x2 = Math.min(Math.max(positions.x2, chartRect.x1), chartRect.x2);
        positions.y1 = Math.min(Math.max(positions.y1, chartRect.y2), chartRect.y1);
        positions.y2 = Math.min(Math.max(positions.y2, chartRect.y2), chartRect.y1);

        var metaData = Chartist.getMetaData(series, valueIndex);

        // Create bar element
        bar = seriesElement.elem('line', positions, options.classNames.bar).attr({
          'ct:value': [value.x, value.y].filter(Chartist.isNumeric).join(','),
          'ct:meta': Chartist.serialize(metaData)
        });

        this.eventEmitter.emit('draw', Chartist.extend({
          type: 'bar',
          value: value,
          index: valueIndex,
          meta: metaData,
          series: series,
          seriesIndex: seriesIndex,
          axisX: axisX,
          axisY: axisY,
          chartRect: chartRect,
          group: seriesElement,
          element: bar
        }, positions));
      }.bind(this));
    }.bind(this));

    this.eventEmitter.emit('created', {
      bounds: valueAxis.bounds,
      chartRect: chartRect,
      axisX: axisX,
      axisY: axisY,
      svg: this.svg,
      options: options
    });
  }

  /**
   * This method creates a new bar chart and returns API object that you can use for later changes.
   *
   * @memberof Chartist.Bar
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object that needs to consist of a labels and a series array
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object which exposes the API for the created chart
   *
   * @example
   * // Create a simple bar chart
   * var data = {
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In the global name space Chartist we call the Bar function to initialize a bar chart. As a first parameter we pass in a selector where we would like to get our chart created and as a second parameter we pass our data object.
   * new Chartist.Bar('.ct-chart', data);
   *
   * @example
   * // This example creates a bipolar grouped bar chart where the boundaries are limitted to -10 and 10
   * new Chartist.Bar('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5, 6, 7],
   *   series: [
   *     [1, 3, 2, -5, -3, 1, -6],
   *     [-5, -2, -4, -1, 2, -3, 1]
   *   ]
   * }, {
   *   seriesBarDistance: 12,
   *   low: -10,
   *   high: 10
   * });
   *
   */
  function Bar(query, data, options, responsiveOptions) {
    Chartist.Bar.super.constructor.call(this,
      query,
      data,
      defaultOptions,
      Chartist.extend({}, defaultOptions, options),
      responsiveOptions);
  }

  // Creating bar chart type in Chartist namespace
  Chartist.Bar = Chartist.Base.extend({
    constructor: Bar,
    createChart: createChart
  });

}(window, document, Chartist));
;/**
 * The pie chart module of Chartist that can be used to draw pie, donut or gauge charts
 *
 * @module Chartist.Pie
 */
/* global Chartist */
(function(window, document, Chartist) {
  'use strict';

  /**
   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Pie
   */
  var defaultOptions = {
    // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
    width: undefined,
    // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
    height: undefined,
    // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
    chartPadding: 5,
    // Override the class names that are used to generate the SVG structure of the chart
    classNames: {
      chartPie: 'ct-chart-pie',
      chartDonut: 'ct-chart-donut',
      series: 'ct-series',
      slicePie: 'ct-slice-pie',
      sliceDonut: 'ct-slice-donut',
      label: 'ct-label'
    },
    // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
    startAngle: 0,
    // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
    total: undefined,
    // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
    donut: false,
    // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
    // This option can be set as number or string to specify a relative width (i.e. 100 or '30%').
    donutWidth: 60,
    // If a label should be shown or not
    showLabel: true,
    // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
    labelOffset: 0,
    // This option can be set to 'inside', 'outside' or 'center'. Positioned with 'inside' the labels will be placed on half the distance of the radius to the border of the Pie by respecting the 'labelOffset'. The 'outside' option will place the labels at the border of the pie and 'center' will place the labels in the absolute center point of the chart. The 'center' option only makes sense in conjunction with the 'labelOffset' option.
    labelPosition: 'inside',
    // An interpolation function for the label value
    labelInterpolationFnc: Chartist.noop,
    // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
    labelDirection: 'neutral',
    // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
    reverseData: false,
    // If true empty values will be ignored to avoid drawing unncessary slices and labels
    ignoreEmptyValues: false
  };

  /**
   * Determines SVG anchor position based on direction and center parameter
   *
   * @param center
   * @param label
   * @param direction
   * @return {string}
   */
  function determineAnchorPosition(center, label, direction) {
    var toTheRight = label.x > center.x;

    if(toTheRight && direction === 'explode' ||
      !toTheRight && direction === 'implode') {
      return 'start';
    } else if(toTheRight && direction === 'implode' ||
      !toTheRight && direction === 'explode') {
      return 'end';
    } else {
      return 'middle';
    }
  }

  /**
   * Creates the pie chart
   *
   * @param options
   */
  function createChart(options) {
    var data = Chartist.normalizeData(this.data);
    var seriesGroups = [],
      labelsGroup,
      chartRect,
      radius,
      labelRadius,
      totalDataSum,
      startAngle = options.startAngle;

    // Create SVG.js draw
    this.svg = Chartist.createSvg(this.container, options.width, options.height,options.donut ? options.classNames.chartDonut : options.classNames.chartPie);
    // Calculate charting rect
    chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
    // Get biggest circle radius possible within chartRect
    radius = Math.min(chartRect.width() / 2, chartRect.height() / 2);
    // Calculate total of all series to get reference value or use total reference from optional options
    totalDataSum = options.total || data.normalized.series.reduce(function(previousValue, currentValue) {
      return previousValue + currentValue;
    }, 0);

    var donutWidth = Chartist.quantity(options.donutWidth);
    if (donutWidth.unit === '%') {
      donutWidth.value *= radius / 100;
    }

    // If this is a donut chart we need to adjust our radius to enable strokes to be drawn inside
    // Unfortunately this is not possible with the current SVG Spec
    // See this proposal for more details: http://lists.w3.org/Archives/Public/www-svg/2003Oct/0000.html
    radius -= options.donut ? donutWidth.value / 2  : 0;

    // If labelPosition is set to `outside` or a donut chart is drawn then the label position is at the radius,
    // if regular pie chart it's half of the radius
    if(options.labelPosition === 'outside' || options.donut) {
      labelRadius = radius;
    } else if(options.labelPosition === 'center') {
      // If labelPosition is center we start with 0 and will later wait for the labelOffset
      labelRadius = 0;
    } else {
      // Default option is 'inside' where we use half the radius so the label will be placed in the center of the pie
      // slice
      labelRadius = radius / 2;
    }
    // Add the offset to the labelRadius where a negative offset means closed to the center of the chart
    labelRadius += options.labelOffset;

    // Calculate end angle based on total sum and current data value and offset with padding
    var center = {
      x: chartRect.x1 + chartRect.width() / 2,
      y: chartRect.y2 + chartRect.height() / 2
    };

    // Check if there is only one non-zero value in the series array.
    var hasSingleValInSeries = data.raw.series.filter(function(val) {
      return val.hasOwnProperty('value') ? val.value !== 0 : val !== 0;
    }).length === 1;

    // Creating the series groups
    data.raw.series.forEach(function(series, index) {
      seriesGroups[index] = this.svg.elem('g', null, null);
    }.bind(this));
    //if we need to show labels we create the label group now
    if(options.showLabel) {
      labelsGroup = this.svg.elem('g', null, null);
    }

    // Draw the series
    // initialize series groups
    data.raw.series.forEach(function(series, index) {
      // If current value is zero and we are ignoring empty values then skip to next value
      if (data.normalized.series[index] === 0 && options.ignoreEmptyValues) return;

      // If the series is an object and contains a name or meta data we add a custom attribute
      seriesGroups[index].attr({
        'ct:series-name': series.name
      });

      // Use series class from series data or if not set generate one
      seriesGroups[index].addClass([
        options.classNames.series,
        (series.className || options.classNames.series + '-' + Chartist.alphaNumerate(index))
      ].join(' '));

      // If the whole dataset is 0 endAngle should be zero. Can't divide by 0.
      var endAngle = (totalDataSum > 0 ? startAngle + data.normalized.series[index] / totalDataSum * 360 : 0);

      // Use slight offset so there are no transparent hairline issues
      var overlappigStartAngle = Math.max(0, startAngle - (index === 0 || hasSingleValInSeries ? 0 : 0.2));

      // If we need to draw the arc for all 360 degrees we need to add a hack where we close the circle
      // with Z and use 359.99 degrees
      if(endAngle - overlappigStartAngle >= 359.99) {
        endAngle = overlappigStartAngle + 359.99;
      }

      var start = Chartist.polarToCartesian(center.x, center.y, radius, overlappigStartAngle),
        end = Chartist.polarToCartesian(center.x, center.y, radius, endAngle);

      // Create a new path element for the pie chart. If this isn't a donut chart we should close the path for a correct stroke
      var path = new Chartist.Svg.Path(!options.donut)
        .move(end.x, end.y)
        .arc(radius, radius, 0, endAngle - startAngle > 180, 0, start.x, start.y);

      // If regular pie chart (no donut) we add a line to the center of the circle for completing the pie
      if(!options.donut) {
        path.line(center.x, center.y);
      }

      // Create the SVG path
      // If this is a donut chart we add the donut class, otherwise just a regular slice
      var pathElement = seriesGroups[index].elem('path', {
        d: path.stringify()
      }, options.donut ? options.classNames.sliceDonut : options.classNames.slicePie);

      // Adding the pie series value to the path
      pathElement.attr({
        'ct:value': data.normalized.series[index],
        'ct:meta': Chartist.serialize(series.meta)
      });

      // If this is a donut, we add the stroke-width as style attribute
      if(options.donut) {
        pathElement.attr({
          'style': 'stroke-width: ' + donutWidth.value + 'px'
        });
      }

      // Fire off draw event
      this.eventEmitter.emit('draw', {
        type: 'slice',
        value: data.normalized.series[index],
        totalDataSum: totalDataSum,
        index: index,
        meta: series.meta,
        series: series,
        group: seriesGroups[index],
        element: pathElement,
        path: path.clone(),
        center: center,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
      });

      // If we need to show labels we need to add the label for this slice now
      if(options.showLabel) {
        var labelPosition;
        if(data.raw.series.length === 1) {
          // If we have only 1 series, we can position the label in the center of the pie
          labelPosition = {
            x: center.x,
            y: center.y
          };
        } else {
          // Position at the labelRadius distance from center and between start and end angle
          labelPosition = Chartist.polarToCartesian(
            center.x,
            center.y,
            labelRadius,
            startAngle + (endAngle - startAngle) / 2
          );
        }

        var rawValue;
        if(data.normalized.labels && !Chartist.isFalseyButZero(data.normalized.labels[index])) {
          rawValue = data.normalized.labels[index];
        } else {
          rawValue = data.normalized.series[index];
        }

        var interpolatedValue = options.labelInterpolationFnc(rawValue, index);

        if(interpolatedValue || interpolatedValue === 0) {
          var labelElement = labelsGroup.elem('text', {
            dx: labelPosition.x,
            dy: labelPosition.y,
            'text-anchor': determineAnchorPosition(center, labelPosition, options.labelDirection)
          }, options.classNames.label).text('' + interpolatedValue);

          // Fire off draw event
          this.eventEmitter.emit('draw', {
            type: 'label',
            index: index,
            group: labelsGroup,
            element: labelElement,
            text: '' + interpolatedValue,
            x: labelPosition.x,
            y: labelPosition.y
          });
        }
      }

      // Set next startAngle to current endAngle.
      // (except for last slice)
      startAngle = endAngle;
    }.bind(this));

    this.eventEmitter.emit('created', {
      chartRect: chartRect,
      svg: this.svg,
      options: options
    });
  }

  /**
   * This method creates a new pie chart and returns an object that can be used to redraw the chart.
   *
   * @memberof Chartist.Pie
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object in the pie chart needs to have a series property with a one dimensional data array. The values will be normalized against each other and don't necessarily need to be in percentage. The series property can also be an array of value objects that contain a value property and a className property to override the CSS class name for the series group.
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object with a version and an update method to manually redraw the chart
   *
   * @example
   * // Simple pie chart example with four series
   * new Chartist.Pie('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * });
   *
   * @example
   * // Drawing a donut chart
   * new Chartist.Pie('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * }, {
   *   donut: true
   * });
   *
   * @example
   * // Using donut, startAngle and total to draw a gauge chart
   * new Chartist.Pie('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   donut: true,
   *   donutWidth: 20,
   *   startAngle: 270,
   *   total: 200
   * });
   *
   * @example
   * // Drawing a pie chart with padding and labels that are outside the pie
   * new Chartist.Pie('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   chartPadding: 30,
   *   labelOffset: 50,
   *   labelDirection: 'explode'
   * });
   *
   * @example
   * // Overriding the class names for individual series as well as a name and meta data.
   * // The name will be written as ct:series-name attribute and the meta data will be serialized and written
   * // to a ct:meta attribute.
   * new Chartist.Pie('.ct-chart', {
   *   series: [{
   *     value: 20,
   *     name: 'Series 1',
   *     className: 'my-custom-class-one',
   *     meta: 'Meta One'
   *   }, {
   *     value: 10,
   *     name: 'Series 2',
   *     className: 'my-custom-class-two',
   *     meta: 'Meta Two'
   *   }, {
   *     value: 70,
   *     name: 'Series 3',
   *     className: 'my-custom-class-three',
   *     meta: 'Meta Three'
   *   }]
   * });
   */
  function Pie(query, data, options, responsiveOptions) {
    Chartist.Pie.super.constructor.call(this,
      query,
      data,
      defaultOptions,
      Chartist.extend({}, defaultOptions, options),
      responsiveOptions);
  }

  // Creating pie chart type in Chartist namespace
  Chartist.Pie = Chartist.Base.extend({
    constructor: Pie,
    createChart: createChart,
    determineAnchorPosition: determineAnchorPosition
  });

}(window, document, Chartist));

return Chartist;

}));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(242);

var _createChainableTypeChecker = __webpack_require__(295);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = moveDate;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _invariant = _interopRequireDefault(__webpack_require__(23));

var _constants = __webpack_require__(52);

var _Views = _interopRequireDefault(__webpack_require__(468));

function moveDate(View, _ref) {
  var action = _ref.action,
      date = _ref.date,
      today = _ref.today,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["action", "date", "today"]);
  View = typeof View === 'string' ? _Views.default[View] : View;

  switch (action) {
    case _constants.navigate.TODAY:
      date = today || new Date();
      break;

    case _constants.navigate.DATE:
      break;

    default:
      !(View && typeof View.navigate === 'function') ?  false ? (0, _invariant.default)(false, 'Calendar View components must implement a static `.navigate(date, action)` method.s') : invariant(false) : void 0;
      date = View.navigate(date, action, props);
  }

  return date;
}

module.exports = exports["default"];

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _constants = __webpack_require__(52);

var _Month = _interopRequireDefault(__webpack_require__(1109));

var _Day = _interopRequireDefault(__webpack_require__(1138));

var _Week = _interopRequireDefault(__webpack_require__(482));

var _WorkWeek = _interopRequireDefault(__webpack_require__(1152));

var _Agenda = _interopRequireDefault(__webpack_require__(1153));

var _VIEWS;

var VIEWS = (_VIEWS = {}, _VIEWS[_constants.views.MONTH] = _Month.default, _VIEWS[_constants.views.WEEK] = _Week.default, _VIEWS[_constants.views.WORK_WEEK] = _WorkWeek.default, _VIEWS[_constants.views.DAY] = _Day.default, _VIEWS[_constants.views.AGENDA] = _Agenda.default, _VIEWS);
var _default = VIEWS;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(1112));

var _offset = _interopRequireDefault(__webpack_require__(146));

var _offsetParent = _interopRequireDefault(__webpack_require__(1113));

var _scrollTop = _interopRequireDefault(__webpack_require__(297));

var _scrollLeft = _interopRequireDefault(__webpack_require__(470));

var _style = _interopRequireDefault(__webpack_require__(218));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(92));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _dates = _interopRequireDefault(__webpack_require__(32));

var propTypes = {
  event: _propTypes.default.object.isRequired,
  slotStart: _propTypes.default.instanceOf(Date),
  slotEnd: _propTypes.default.instanceOf(Date),
  selected: _propTypes.default.bool,
  isAllDay: _propTypes.default.bool,
  continuesPrior: _propTypes.default.bool,
  continuesAfter: _propTypes.default.bool,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  onSelect: _propTypes.default.func,
  onDoubleClick: _propTypes.default.func
};

var EventCell =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(EventCell, _React$Component);

  function EventCell() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EventCell.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        style = _this$props.style,
        className = _this$props.className,
        event = _this$props.event,
        selected = _this$props.selected,
        isAllDay = _this$props.isAllDay,
        onSelect = _this$props.onSelect,
        _onDoubleClick = _this$props.onDoubleClick,
        localizer = _this$props.localizer,
        continuesPrior = _this$props.continuesPrior,
        continuesAfter = _this$props.continuesAfter,
        accessors = _this$props.accessors,
        getters = _this$props.getters,
        children = _this$props.children,
        _this$props$component = _this$props.components,
        Event = _this$props$component.event,
        EventWrapper = _this$props$component.eventWrapper,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["style", "className", "event", "selected", "isAllDay", "onSelect", "onDoubleClick", "localizer", "continuesPrior", "continuesAfter", "accessors", "getters", "children", "components"]);
    var title = accessors.title(event);
    var tooltip = accessors.tooltip(event);
    var end = accessors.end(event);
    var start = accessors.start(event);
    var allDay = accessors.allDay(event);
    var showAsAllDay = isAllDay || allDay || _dates.default.diff(start, _dates.default.ceil(end, 'day'), 'day') > 1;
    var userProps = getters.eventProp(event, start, end, selected);

    var content = _react.default.createElement("div", {
      className: "rbc-event-content",
      title: tooltip || undefined
    }, Event ? _react.default.createElement(Event, {
      event: event,
      title: title,
      isAllDay: allDay,
      localizer: localizer
    }) : title);

    return _react.default.createElement(EventWrapper, (0, _extends2.default)({}, this.props, {
      type: "date"
    }), _react.default.createElement("button", (0, _extends2.default)({}, props, {
      style: (0, _extends2.default)({}, userProps.style, style),
      className: (0, _classnames.default)('rbc-event', className, userProps.className, {
        'rbc-selected': selected,
        'rbc-event-allday': showAsAllDay,
        'rbc-event-continues-prior': continuesPrior,
        'rbc-event-continues-after': continuesAfter
      }),
      onClick: function onClick(e) {
        return onSelect && onSelect(event, e);
      },
      onDoubleClick: function onDoubleClick(e) {
        return _onDoubleClick && _onDoubleClick(event, e);
      }
    }), typeof children === 'function' ? children(content) : content));
  };

  return EventCell;
}(_react.default.Component);

EventCell.propTypes = propTypes;
var _default = EventCell;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _height = _interopRequireDefault(__webpack_require__(1122));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(300));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(21);

var _dates = _interopRequireDefault(__webpack_require__(32));

var _BackgroundCells = _interopRequireDefault(__webpack_require__(1123));

var _EventRow = _interopRequireDefault(__webpack_require__(1129));

var _EventEndingRow = _interopRequireDefault(__webpack_require__(1130));

var DateSlotMetrics = _interopRequireWildcard(__webpack_require__(1135));

var propTypes = {
  date: _propTypes.default.instanceOf(Date),
  events: _propTypes.default.array.isRequired,
  range: _propTypes.default.array.isRequired,
  rtl: _propTypes.default.bool,
  resourceId: _propTypes.default.any,
  renderForMeasure: _propTypes.default.bool,
  renderHeader: _propTypes.default.func,
  container: _propTypes.default.func,
  selected: _propTypes.default.object,
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes.default.number,
  onShowMore: _propTypes.default.func,
  onSelectSlot: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  onSelectEnd: _propTypes.default.func,
  onSelectStart: _propTypes.default.func,
  onDoubleClick: _propTypes.default.func,
  dayPropGetter: _propTypes.default.func,
  getNow: _propTypes.default.func.isRequired,
  isAllDay: _propTypes.default.bool,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  minRows: _propTypes.default.number.isRequired,
  maxRows: _propTypes.default.number.isRequired
};
var defaultProps = {
  minRows: 0,
  maxRows: Infinity
};

var DateContentRow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DateContentRow, _React$Component);

  function DateContentRow() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelectSlot = function (slot) {
      var _this$props = _this.props,
          range = _this$props.range,
          onSelectSlot = _this$props.onSelectSlot;
      onSelectSlot(range.slice(slot.start, slot.end + 1), slot);
    };

    _this.handleShowMore = function (slot) {
      var _this$props2 = _this.props,
          range = _this$props2.range,
          onShowMore = _this$props2.onShowMore;

      var metrics = _this.slotMetrics(_this.props);

      var row = (0, _querySelectorAll.default)((0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))), '.rbc-row-bg')[0];
      var cell;
      if (row) cell = row.children[slot - 1];
      var events = metrics.getEventsForSlot(slot);
      onShowMore(events, range[slot - 1], cell, slot);
    };

    _this.createHeadingRef = function (r) {
      _this.headingRow = r;
    };

    _this.createEventRef = function (r) {
      _this.eventRow = r;
    };

    _this.getContainer = function () {
      var container = _this.props.container;
      return container ? container() : (0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    };

    _this.renderHeadingCell = function (date, index) {
      var _this$props3 = _this.props,
          renderHeader = _this$props3.renderHeader,
          getNow = _this$props3.getNow;
      return renderHeader({
        date: date,
        key: "header_" + index,
        className: (0, _classnames.default)('rbc-date-cell', _dates.default.eq(date, getNow(), 'day') && 'rbc-now')
      });
    };

    _this.renderDummy = function () {
      var _this$props4 = _this.props,
          className = _this$props4.className,
          range = _this$props4.range,
          renderHeader = _this$props4.renderHeader;
      return _react.default.createElement("div", {
        className: className
      }, _react.default.createElement("div", {
        className: "rbc-row-content"
      }, renderHeader && _react.default.createElement("div", {
        className: "rbc-row",
        ref: _this.createHeadingRef
      }, range.map(_this.renderHeadingCell)), _react.default.createElement("div", {
        className: "rbc-row",
        ref: _this.createEventRef
      }, _react.default.createElement("div", {
        className: "rbc-row-segment"
      }, _react.default.createElement("div", {
        className: "rbc-event"
      }, _react.default.createElement("div", {
        className: "rbc-event-content"
      }, "\xA0"))))));
    };

    _this.slotMetrics = DateSlotMetrics.getSlotMetrics();
    return _this;
  }

  var _proto = DateContentRow.prototype;

  _proto.getRowLimit = function getRowLimit() {
    var eventHeight = (0, _height.default)(this.eventRow);
    var headingHeight = this.headingRow ? (0, _height.default)(this.headingRow) : 0;
    var eventSpace = (0, _height.default)((0, _reactDom.findDOMNode)(this)) - headingHeight;
    return Math.max(Math.floor(eventSpace / eventHeight), 1);
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        date = _this$props5.date,
        rtl = _this$props5.rtl,
        range = _this$props5.range,
        className = _this$props5.className,
        selected = _this$props5.selected,
        selectable = _this$props5.selectable,
        renderForMeasure = _this$props5.renderForMeasure,
        accessors = _this$props5.accessors,
        getters = _this$props5.getters,
        components = _this$props5.components,
        getNow = _this$props5.getNow,
        renderHeader = _this$props5.renderHeader,
        onSelect = _this$props5.onSelect,
        localizer = _this$props5.localizer,
        onSelectStart = _this$props5.onSelectStart,
        onSelectEnd = _this$props5.onSelectEnd,
        onDoubleClick = _this$props5.onDoubleClick,
        resourceId = _this$props5.resourceId,
        longPressThreshold = _this$props5.longPressThreshold,
        isAllDay = _this$props5.isAllDay;
    if (renderForMeasure) return this.renderDummy();
    var metrics = this.slotMetrics(this.props);
    var levels = metrics.levels,
        extra = metrics.extra;
    var WeekWrapper = components.weekWrapper;
    var eventRowProps = {
      selected: selected,
      accessors: accessors,
      getters: getters,
      localizer: localizer,
      components: components,
      onSelect: onSelect,
      onDoubleClick: onDoubleClick,
      resourceId: resourceId,
      slotMetrics: metrics
    };
    return _react.default.createElement("div", {
      className: className
    }, _react.default.createElement(_BackgroundCells.default, {
      date: date,
      getNow: getNow,
      rtl: rtl,
      range: range,
      selectable: selectable,
      container: this.getContainer,
      getters: getters,
      onSelectStart: onSelectStart,
      onSelectEnd: onSelectEnd,
      onSelectSlot: this.handleSelectSlot,
      components: components,
      longPressThreshold: longPressThreshold
    }), _react.default.createElement("div", {
      className: "rbc-row-content"
    }, renderHeader && _react.default.createElement("div", {
      className: "rbc-row ",
      ref: this.createHeadingRef
    }, range.map(this.renderHeadingCell)), _react.default.createElement(WeekWrapper, (0, _extends2.default)({
      isAllDay: isAllDay
    }, eventRowProps), levels.map(function (segs, idx) {
      return _react.default.createElement(_EventRow.default, (0, _extends2.default)({
        key: idx,
        segments: segs
      }, eventRowProps));
    }), !!extra.length && _react.default.createElement(_EventEndingRow.default, (0, _extends2.default)({
      segments: extra,
      onShowMore: this.handleShowMore
    }, eventRowProps)))));
  };

  return DateContentRow;
}(_react.default.Component);

DateContentRow.propTypes = propTypes;
DateContentRow.defaultProps = defaultProps;
var _default = DateContentRow;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.getEventNodeFromPoint = getEventNodeFromPoint;
exports.isEvent = isEvent;
exports.objectsCollide = objectsCollide;
exports.getBoundsForNode = getBoundsForNode;
exports.default = void 0;

var _contains = _interopRequireDefault(__webpack_require__(203));

var _closest = _interopRequireDefault(__webpack_require__(1124));

var _events = _interopRequireDefault(__webpack_require__(1126));

function addEventListener(type, handler, target) {
  if (target === void 0) {
    target = document;
  }

  _events.default.on(target, type, handler, {
    passive: false
  });

  return {
    remove: function remove() {
      _events.default.off(target, type, handler);
    }
  };
}

function isOverContainer(container, x, y) {
  return !container || (0, _contains.default)(container, document.elementFromPoint(x, y));
}

function getEventNodeFromPoint(node, _ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  var target = document.elementFromPoint(clientX, clientY);
  return (0, _closest.default)(target, '.rbc-event', node);
}

function isEvent(node, bounds) {
  return !!getEventNodeFromPoint(node, bounds);
}

function getEventCoordinates(e) {
  var target = e;

  if (e.touches && e.touches.length) {
    target = e.touches[0];
  }

  return {
    clientX: target.clientX,
    clientY: target.clientY,
    pageX: target.pageX,
    pageY: target.pageY
  };
}

var clickTolerance = 5;
var clickInterval = 250;

var Selection =
/*#__PURE__*/
function () {
  function Selection(node, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$global = _ref2.global,
        global = _ref2$global === void 0 ? false : _ref2$global,
        _ref2$longPressThresh = _ref2.longPressThreshold,
        longPressThreshold = _ref2$longPressThresh === void 0 ? 250 : _ref2$longPressThresh;

    this.container = node;
    this.globalMouse = !node || global;
    this.longPressThreshold = longPressThreshold;
    this._listeners = Object.create(null);
    this._handleInitialEvent = this._handleInitialEvent.bind(this);
    this._handleMoveEvent = this._handleMoveEvent.bind(this);
    this._handleTerminatingEvent = this._handleTerminatingEvent.bind(this);
    this._keyListener = this._keyListener.bind(this); // Fixes an iOS 10 bug where scrolling could not be prevented on the window.
    // https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356

    this._onTouchMoveWindowListener = addEventListener('touchmove', function () {}, window);
    this._onKeyDownListener = addEventListener('keydown', this._keyListener);
    this._onKeyUpListener = addEventListener('keyup', this._keyListener);

    this._addInitialEventListener();
  }

  var _proto = Selection.prototype;

  _proto.on = function on(type, handler) {
    var handlers = this._listeners[type] || (this._listeners[type] = []);
    handlers.push(handler);
    return {
      remove: function remove() {
        var idx = handlers.indexOf(handler);
        if (idx !== -1) handlers.splice(idx, 1);
      }
    };
  };

  _proto.emit = function emit(type) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var result;
    var handlers = this._listeners[type] || [];
    handlers.forEach(function (fn) {
      if (result === undefined) result = fn.apply(void 0, args);
    });
    return result;
  };

  _proto.teardown = function teardown() {
    this.listeners = Object.create(null);
    this._onTouchMoveWindowListener && this._onTouchMoveWindowListener.remove();
    this._onInitialEventListener && this._onInitialEventListener.remove();
    this._onEndListener && this._onEndListener.remove();
    this._onMoveListener && this._onMoveListener.remove();
    this._onKeyUpListener && this._onKeyUpListener.remove();
    this._onKeyDownListener && this._onKeyDownListener.remove();
  };

  _proto.isSelected = function isSelected(node) {
    var box = this._selectRect;
    if (!box || !this.selecting) return false;
    return objectsCollide(box, getBoundsForNode(node));
  };

  _proto.filter = function filter(items) {
    var box = this._selectRect; //not selecting

    if (!box || !this.selecting) return [];
    return items.filter(this.isSelected, this);
  }; // Adds a listener that will call the handler only after the user has pressed on the screen
  // without moving their finger for 250ms.


  _proto._addLongPressListener = function _addLongPressListener(handler, initialEvent) {
    var _this = this;

    var timer = null;
    var touchMoveListener = null;
    var touchEndListener = null;

    var handleTouchStart = function handleTouchStart(initialEvent) {
      timer = setTimeout(function () {
        cleanup();
        handler(initialEvent);
      }, _this.longPressThreshold);
      touchMoveListener = addEventListener('touchmove', function () {
        return cleanup();
      });
      touchEndListener = addEventListener('touchend', function () {
        return cleanup();
      });
    };

    var touchStartListener = addEventListener('touchstart', handleTouchStart);

    var cleanup = function cleanup() {
      if (timer) {
        clearTimeout(timer);
      }

      if (touchMoveListener) {
        touchMoveListener.remove();
      }

      if (touchEndListener) {
        touchEndListener.remove();
      }

      timer = null;
      touchMoveListener = null;
      touchEndListener = null;
    };

    if (initialEvent) {
      handleTouchStart(initialEvent);
    }

    return {
      remove: function remove() {
        cleanup();
        touchStartListener.remove();
      }
    };
  }; // Listen for mousedown and touchstart events. When one is received, disable the other and setup
  // future event handling based on the type of event.


  _proto._addInitialEventListener = function _addInitialEventListener() {
    var _this2 = this;

    var mouseDownListener = addEventListener('mousedown', function (e) {
      _this2._onInitialEventListener.remove();

      _this2._handleInitialEvent(e);

      _this2._onInitialEventListener = addEventListener('mousedown', _this2._handleInitialEvent);
    });
    var touchStartListener = addEventListener('touchstart', function (e) {
      _this2._onInitialEventListener.remove();

      _this2._onInitialEventListener = _this2._addLongPressListener(_this2._handleInitialEvent, e);
    });
    this._onInitialEventListener = {
      remove: function remove() {
        mouseDownListener.remove();
        touchStartListener.remove();
      }
    };
  };

  _proto._handleInitialEvent = function _handleInitialEvent(e) {
    var _getEventCoordinates = getEventCoordinates(e),
        clientX = _getEventCoordinates.clientX,
        clientY = _getEventCoordinates.clientY,
        pageX = _getEventCoordinates.pageX,
        pageY = _getEventCoordinates.pageY;

    var node = this.container(),
        collides,
        offsetData; // Right clicks

    if (e.which === 3 || e.button === 2 || !isOverContainer(node, clientX, clientY)) return;

    if (!this.globalMouse && node && !(0, _contains.default)(node, e.target)) {
      var _normalizeDistance = normalizeDistance(0),
          top = _normalizeDistance.top,
          left = _normalizeDistance.left,
          bottom = _normalizeDistance.bottom,
          right = _normalizeDistance.right;

      offsetData = getBoundsForNode(node);
      collides = objectsCollide({
        top: offsetData.top - top,
        left: offsetData.left - left,
        bottom: offsetData.bottom + bottom,
        right: offsetData.right + right
      }, {
        top: pageY,
        left: pageX
      });
      if (!collides) return;
    }

    var result = this.emit('beforeSelect', this._initialEventData = {
      isTouch: /^touch/.test(e.type),
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
    if (result === false) return;

    switch (e.type) {
      case 'mousedown':
        this._onEndListener = addEventListener('mouseup', this._handleTerminatingEvent);
        this._onMoveListener = addEventListener('mousemove', this._handleMoveEvent);
        break;

      case 'touchstart':
        this._handleMoveEvent(e);

        this._onEndListener = addEventListener('touchend', this._handleTerminatingEvent);
        this._onMoveListener = addEventListener('touchmove', this._handleMoveEvent);
        break;

      default:
        break;
    }
  };

  _proto._handleTerminatingEvent = function _handleTerminatingEvent(e) {
    var _getEventCoordinates2 = getEventCoordinates(e),
        pageX = _getEventCoordinates2.pageX,
        pageY = _getEventCoordinates2.pageY;

    this.selecting = false;
    this._onEndListener && this._onEndListener.remove();
    this._onMoveListener && this._onMoveListener.remove();
    if (!this._initialEventData) return;
    var inRoot = !this.container || (0, _contains.default)(this.container(), e.target);
    var bounds = this._selectRect;
    var click = this.isClick(pageX, pageY);
    this._initialEventData = null;

    if (click && !inRoot) {
      return this.emit('reset');
    }

    if (click && inRoot) {
      return this._handleClickEvent(e);
    } // User drag-clicked in the Selectable area


    if (!click) return this.emit('select', bounds);
  };

  _proto._handleClickEvent = function _handleClickEvent(e) {
    var _getEventCoordinates3 = getEventCoordinates(e),
        pageX = _getEventCoordinates3.pageX,
        pageY = _getEventCoordinates3.pageY,
        clientX = _getEventCoordinates3.clientX,
        clientY = _getEventCoordinates3.clientY;

    var now = new Date().getTime();

    if (this._lastClickData && now - this._lastClickData.timestamp < clickInterval) {
      // Double click event
      this._lastClickData = null;
      return this.emit('doubleClick', {
        x: pageX,
        y: pageY,
        clientX: clientX,
        clientY: clientY
      });
    } // Click event


    this._lastClickData = {
      timestamp: now
    };
    return this.emit('click', {
      x: pageX,
      y: pageY,
      clientX: clientX,
      clientY: clientY
    });
  };

  _proto._handleMoveEvent = function _handleMoveEvent(e) {
    var _this$_initialEventDa = this._initialEventData,
        x = _this$_initialEventDa.x,
        y = _this$_initialEventDa.y;

    var _getEventCoordinates4 = getEventCoordinates(e),
        pageX = _getEventCoordinates4.pageX,
        pageY = _getEventCoordinates4.pageY;

    var w = Math.abs(x - pageX);
    var h = Math.abs(y - pageY);
    var left = Math.min(pageX, x),
        top = Math.min(pageY, y),
        old = this.selecting; // Prevent emitting selectStart event until mouse is moved.
    // in Chrome on Windows, mouseMove event may be fired just after mouseDown event.

    if (!old && !(w || h)) {
      return;
    }

    this.selecting = true;
    this._selectRect = {
      top: top,
      left: left,
      x: pageX,
      y: pageY,
      right: left + w,
      bottom: top + h
    };

    if (!old) {
      this.emit('selectStart', this._initialEventData);
    }

    if (!this.isClick(pageX, pageY)) this.emit('selecting', this._selectRect);
    e.preventDefault();
  };

  _proto._keyListener = function _keyListener(e) {
    this.ctrl = e.metaKey || e.ctrlKey;
  };

  _proto.isClick = function isClick(pageX, pageY) {
    var _this$_initialEventDa2 = this._initialEventData,
        x = _this$_initialEventDa2.x,
        y = _this$_initialEventDa2.y,
        isTouch = _this$_initialEventDa2.isTouch;
    return !isTouch && Math.abs(pageX - x) <= clickTolerance && Math.abs(pageY - y) <= clickTolerance;
  };

  return Selection;
}();
/**
 * Resolve the disance prop from either an Int or an Object
 * @return {Object}
 */


function normalizeDistance(distance) {
  if (distance === void 0) {
    distance = 0;
  }

  if (typeof distance !== 'object') distance = {
    top: distance,
    left: distance,
    right: distance,
    bottom: distance
  };
  return distance;
}
/**
 * Given two objects containing "top", "left", "offsetWidth" and "offsetHeight"
 * properties, determine if they collide.
 * @param  {Object|HTMLElement} a
 * @param  {Object|HTMLElement} b
 * @return {bool}
 */


function objectsCollide(nodeA, nodeB, tolerance) {
  if (tolerance === void 0) {
    tolerance = 0;
  }

  var _getBoundsForNode = getBoundsForNode(nodeA),
      aTop = _getBoundsForNode.top,
      aLeft = _getBoundsForNode.left,
      _getBoundsForNode$rig = _getBoundsForNode.right,
      aRight = _getBoundsForNode$rig === void 0 ? aLeft : _getBoundsForNode$rig,
      _getBoundsForNode$bot = _getBoundsForNode.bottom,
      aBottom = _getBoundsForNode$bot === void 0 ? aTop : _getBoundsForNode$bot;

  var _getBoundsForNode2 = getBoundsForNode(nodeB),
      bTop = _getBoundsForNode2.top,
      bLeft = _getBoundsForNode2.left,
      _getBoundsForNode2$ri = _getBoundsForNode2.right,
      bRight = _getBoundsForNode2$ri === void 0 ? bLeft : _getBoundsForNode2$ri,
      _getBoundsForNode2$bo = _getBoundsForNode2.bottom,
      bBottom = _getBoundsForNode2$bo === void 0 ? bTop : _getBoundsForNode2$bo;

  return !( // 'a' bottom doesn't touch 'b' top
  aBottom - tolerance < bTop || // 'a' top doesn't touch 'b' bottom
  aTop + tolerance > bBottom || // 'a' right doesn't touch 'b' left
  aRight - tolerance < bLeft || // 'a' left doesn't touch 'b' right
  aLeft + tolerance > bRight);
}
/**
 * Given a node, get everything needed to calculate its boundaries
 * @param  {HTMLElement} node
 * @return {Object}
 */


function getBoundsForNode(node) {
  if (!node.getBoundingClientRect) return node;
  var rect = node.getBoundingClientRect(),
      left = rect.left + pageOffset('left'),
      top = rect.top + pageOffset('top');
  return {
    top: top,
    left: left,
    right: (node.offsetWidth || 0) + left,
    bottom: (node.offsetHeight || 0) + top
  };
}

function pageOffset(dir) {
  if (dir === 'left') return window.pageXOffset || document.body.scrollLeft || 0;
  if (dir === 'top') return window.pageYOffset || document.body.scrollTop || 0;
}

var _default = Selection;
exports.default = _default;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _EventCell = _interopRequireDefault(__webpack_require__(472));

var _selection = __webpack_require__(147);

/* eslint-disable react/prop-types */
var _default = {
  propTypes: {
    slotMetrics: _propTypes.default.object.isRequired,
    selected: _propTypes.default.object,
    isAllDay: _propTypes.default.bool,
    accessors: _propTypes.default.object.isRequired,
    localizer: _propTypes.default.object.isRequired,
    components: _propTypes.default.object.isRequired,
    getters: _propTypes.default.object.isRequired,
    onSelect: _propTypes.default.func,
    onDoubleClick: _propTypes.default.func
  },
  defaultProps: {
    segments: [],
    selected: {}
  },
  renderEvent: function renderEvent(props, event) {
    var selected = props.selected,
        _ = props.isAllDay,
        accessors = props.accessors,
        getters = props.getters,
        onSelect = props.onSelect,
        onDoubleClick = props.onDoubleClick,
        localizer = props.localizer,
        slotMetrics = props.slotMetrics,
        components = props.components;
    var continuesPrior = slotMetrics.continuesPrior(event);
    var continuesAfter = slotMetrics.continuesAfter(event);
    return _react.default.createElement(_EventCell.default, {
      event: event,
      getters: getters,
      localizer: localizer,
      accessors: accessors,
      components: components,
      onSelect: onSelect,
      onDoubleClick: onDoubleClick,
      continuesPrior: continuesPrior,
      continuesAfter: continuesAfter,
      selected: (0, _selection.isSelected)(event, selected)
    });
  },
  renderSpan: function renderSpan(slots, len, key, content) {
    if (content === void 0) {
      content = ' ';
    }

    var per = Math.abs(len) / slots * 100 + '%';
    return _react.default.createElement("div", {
      key: key,
      className: "rbc-row-segment" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
      ,
      style: {
        WebkitFlexBasis: per,
        flexBasis: per,
        maxWidth: per
      }
    }, content);
  }
};
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var Header = function Header(_ref) {
  var label = _ref.label;
  return _react.default.createElement("span", null, label);
};

Header.propTypes = {
  label: _propTypes.default.node
};
var _default = Header;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.getSlotMetrics = getSlotMetrics;

var _dates = _interopRequireDefault(__webpack_require__(32));

var getDstOffset = function getDstOffset(start, end) {
  return Math.abs(start.getTimezoneOffset() - end.getTimezoneOffset());
};

var getKey = function getKey(min, max, step, slots) {
  return "" + +_dates.default.startOf(min, 'minutes') + ("" + +_dates.default.startOf(max, 'minutes')) + (step + "-" + slots);
};

function getSlotMetrics(_ref) {
  var start = _ref.min,
      end = _ref.max,
      step = _ref.step,
      timeslots = _ref.timeslots;
  var key = getKey(start, end, step, timeslots);
  var totalMin = 1 + _dates.default.diff(start, end, 'minutes') + getDstOffset(start, end);

  var minutesFromMidnight = _dates.default.diff(_dates.default.startOf(start, 'day'), start, 'minutes');

  var numGroups = Math.ceil(totalMin / (step * timeslots));
  var numSlots = numGroups * timeslots;
  var groups = new Array(numGroups);
  var slots = new Array(numSlots); // Each slot date is created from "zero", instead of adding `step` to
  // the previous one, in order to avoid DST oddities

  for (var grp = 0; grp < numGroups; grp++) {
    groups[grp] = new Array(timeslots);

    for (var slot = 0; slot < timeslots; slot++) {
      var slotIdx = grp * timeslots + slot;
      var minFromStart = slotIdx * step; // A date with total minutes calculated from the start of the day

      slots[slotIdx] = groups[grp][slot] = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + minFromStart, 0, 0);
    }
  } // Necessary to be able to select up until the last timeslot in a day


  var lastSlotMinFromStart = slots.length * step;
  slots.push(new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + lastSlotMinFromStart, 0, 0));

  function positionFromDate(date) {
    var diff = _dates.default.diff(start, date, 'minutes') + getDstOffset(start, date);
    return Math.min(diff, totalMin);
  }

  return {
    groups: groups,
    update: function update(args) {
      if (getKey(args) !== key) return getSlotMetrics(args);
      return this;
    },
    dateIsInGroup: function dateIsInGroup(date, groupIndex) {
      var nextGroup = groups[groupIndex + 1];
      return _dates.default.inRange(date, groups[groupIndex][0], nextGroup ? nextGroup[0] : end, 'minutes');
    },
    nextSlot: function nextSlot(slot) {
      var next = slots[Math.min(slots.indexOf(slot) + 1, slots.length - 1)]; // in the case of the last slot we won't a long enough range so manually get it

      if (next === slot) next = _dates.default.add(slot, step, 'minutes');
      return next;
    },
    closestSlotToPosition: function closestSlotToPosition(percent) {
      var slot = Math.min(slots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
      return slots[slot];
    },
    closestSlotFromPoint: function closestSlotFromPoint(point, boundaryRect) {
      var range = Math.abs(boundaryRect.top - boundaryRect.bottom);
      return this.closestSlotToPosition((point.y - boundaryRect.top) / range);
    },
    closestSlotFromDate: function closestSlotFromDate(date, offset) {
      if (offset === void 0) {
        offset = 0;
      }

      if (_dates.default.lt(date, start, 'minutes')) return slots[0];

      var diffMins = _dates.default.diff(start, date, 'minutes');

      return slots[(diffMins - diffMins % step) / step + offset];
    },
    startsBeforeDay: function startsBeforeDay(date) {
      return _dates.default.lt(date, start, 'day');
    },
    startsAfterDay: function startsAfterDay(date) {
      return _dates.default.gt(date, end, 'day');
    },
    startsBefore: function startsBefore(date) {
      return _dates.default.lt(_dates.default.merge(start, date), start, 'minutes');
    },
    startsAfter: function startsAfter(date) {
      return _dates.default.gt(_dates.default.merge(end, date), end, 'minutes');
    },
    getRange: function getRange(rangeStart, rangeEnd) {
      rangeStart = _dates.default.min(end, _dates.default.max(start, rangeStart));
      rangeEnd = _dates.default.min(end, _dates.default.max(start, rangeEnd));
      var rangeStartMin = positionFromDate(rangeStart);
      var rangeEndMin = positionFromDate(rangeEnd);
      var top = rangeStartMin / totalMin * 100;
      return {
        top: top,
        height: rangeEndMin / totalMin * 100 - top,
        start: positionFromDate(rangeStart),
        startDate: rangeStart,
        end: positionFromDate(rangeEnd),
        endDate: rangeEnd
      };
    }
  };
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(287),
    isFlattenable = __webpack_require__(1142);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _BackgroundWrapper = _interopRequireDefault(__webpack_require__(480));

var TimeSlotGroup =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TimeSlotGroup, _Component);

  function TimeSlotGroup() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TimeSlotGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        renderSlot = _this$props.renderSlot,
        resource = _this$props.resource,
        group = _this$props.group,
        getters = _this$props.getters,
        _this$props$component = _this$props.components;
    _this$props$component = _this$props$component === void 0 ? {} : _this$props$component;
    var _this$props$component2 = _this$props$component.timeSlotWrapper,
        Wrapper = _this$props$component2 === void 0 ? _BackgroundWrapper.default : _this$props$component2;
    return _react.default.createElement("div", {
      className: "rbc-timeslot-group"
    }, group.map(function (value, idx) {
      var slotProps = getters ? getters.slotProp(value) : {};
      return _react.default.createElement(Wrapper, {
        key: idx,
        value: value,
        resource: resource
      }, _react.default.createElement("div", (0, _extends2.default)({}, slotProps, {
        className: (0, _classnames.default)('rbc-time-slot', slotProps.className)
      }), renderSlot && renderSlot(value, idx)));
    }));
  };

  return TimeSlotGroup;
}(_react.Component);

exports.default = TimeSlotGroup;
TimeSlotGroup.propTypes = {
  renderSlot: _propTypes.default.func,
  group: _propTypes.default.array.isRequired,
  resource: _propTypes.default.any,
  components: _propTypes.default.object,
  getters: _propTypes.default.object
};
module.exports = exports["default"];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _NoopWrapper = _interopRequireDefault(__webpack_require__(302));

var _default = _NoopWrapper.default;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = width;

var _offset = _interopRequireDefault(__webpack_require__(146));

var _isWindow = _interopRequireDefault(__webpack_require__(92));

function width(node, client) {
  var win = (0, _isWindow.default)(node);
  return win ? win.innerWidth : client ? node.clientWidth : (0, _offset.default)(node).width;
}

module.exports = exports["default"];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _constants = __webpack_require__(52);

var _TimeGrid = _interopRequireDefault(__webpack_require__(301));

var Week =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Week, _React$Component);

  function Week() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Week.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        date = _this$props.date,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["date"]);
    var range = Week.range(date, this.props);
    return _react.default.createElement(_TimeGrid.default, (0, _extends2.default)({}, props, {
      range: range,
      eventOffset: 15
    }));
  };

  return Week;
}(_react.default.Component);

Week.propTypes = {
  date: _propTypes.default.instanceOf(Date).isRequired
};
Week.defaultProps = _TimeGrid.default.defaultProps;

Week.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates.default.add(date, -1, 'week');

    case _constants.navigate.NEXT:
      return _dates.default.add(date, 1, 'week');

    default:
      return date;
  }
};

Week.range = function (date, _ref) {
  var localizer = _ref.localizer;
  var firstOfWeek = localizer.startOfWeek();

  var start = _dates.default.startOf(date, 'week', firstOfWeek);

  var end = _dates.default.endOf(date, 'week', firstOfWeek);

  return _dates.default.range(start, end);
};

Week.title = function (date, _ref2) {
  var localizer = _ref2.localizer;

  var _Week$range = Week.range(date, {
    localizer: localizer
  }),
      start = _Week$range[0],
      rest = _Week$range.slice(1);

  return localizer.format({
    start: start,
    end: rest.pop()
  }, 'dayRangeHeaderFormat');
};

var _default = Week;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(287),
    getPrototype = __webpack_require__(205),
    getSymbols = __webpack_require__(288),
    stubArray = __webpack_require__(458);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(457),
    getSymbolsIn = __webpack_require__(484),
    keysIn = __webpack_require__(204);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
})), 'BugReport');

exports.default = _default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
})), 'Cloud');

exports.default = _default;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'FormatQuote');

exports.default = _default;

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tabs__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_customTabsStyle_jsx__ = __webpack_require__(1197);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// nodejs library that concatenates classes
// nodejs library to set properties for components
// material-ui components
// core components
var CustomTabs=function(_React$Component){_inherits(CustomTabs,_React$Component);function CustomTabs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CustomTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CustomTabs.__proto__||Object.getPrototypeOf(CustomTabs)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:0},_this.handleChange=function(event,value){_this.setState({value:value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomTabs,[{key:"render",value:function render(){var _classNames,_this2=this;var _props=this.props,classes=_props.classes,headerColor=_props.headerColor,plainTabs=_props.plainTabs,tabs=_props.tabs,title=_props.title,rtlActive=_props.rtlActive;var cardTitle=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames={},_defineProperty(_classNames,classes.cardTitle,true),_defineProperty(_classNames,classes.cardTitleRTL,rtlActive),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],{plain:plainTabs},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:headerColor,plain:plainTabs},title!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cardTitle},title):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Tabs___default.a,{value:this.state.value,onChange:this.handleChange,classes:{root:classes.tabsRoot,indicator:classes.displayNone}},tabs.map(function(prop,key){var icon={};if(prop.tabIcon){icon={icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.tabIcon,null)};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tab___default.a,Object.assign({classes:{root:classes.tabRootButton,labelContainer:classes.tabLabelContainer,label:classes.tabLabel,selected:classes.tabSelected,wrapper:classes.tabWrapper},key:key,label:prop.tabName},icon));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardBody_jsx__["a" /* default */],null,tabs.map(function(prop,key){if(key===_this2.state.value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:key},prop.tabContent);}return null;})));}}]);return CustomTabs;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CustomTabs.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,headerColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["warning","success","danger","info","primary","rose"]),title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,tabs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({tabName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,tabIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,tabContent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired})),rtlActive:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,plainTabs:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_components_customTabsStyle_jsx__["a" /* default */])(CustomTabs));

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Table__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableCell__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_IconButton__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Checkbox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tooltip__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_components_tasksStyle_jsx__ = __webpack_require__(1200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
var Tasks=function(_React$Component){_inherits(Tasks,_React$Component);function Tasks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tasks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tasks.__proto__||Object.getPrototypeOf(Tasks)).call.apply(_ref,[this].concat(args))),_this),_this.state={checked:_this.props.checkedIndexes},_this.handleToggle=function(value){return function(){var checked=_this.state.checked;var currentIndex=checked.indexOf(value);var newChecked=[].concat(_toConsumableArray(checked));if(currentIndex===-1){newChecked.push(value);}else{newChecked.splice(currentIndex,1);}_this.setState({checked:newChecked});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tasks,[{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,tasksIndexes=_props.tasksIndexes,tasks=_props.tasks;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Table___default.a,{className:classes.table},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TableBody___default.a,null,tasksIndexes.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableRow___default.a,{key:value,className:classes.tableRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableCell___default.a,{className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Checkbox___default.a,{checked:_this2.state.checked.indexOf(value)!==-1,tabIndex:-1,onClick:_this2.handleToggle(value),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableCell___default.a,{className:classes.tableCell},tasks[value]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableCell___default.a,{className:classes.tableActions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tooltip___default.a,{id:"tooltip-top",title:"Edit Task",placement:"top",classes:{tooltip:classes.tooltip}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_IconButton___default.a,{"aria-label":"Edit",className:classes.tableActionButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit___default.a,{className:classes.tableActionButtonIcon+" "+classes.edit}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tooltip___default.a,{id:"tooltip-top-start",title:"Remove",placement:"top",classes:{tooltip:classes.tooltip}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_IconButton___default.a,{"aria-label":"Close",className:classes.tableActionButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close___default.a,{className:classes.tableActionButtonIcon+" "+classes.close})))));})));}}]);return Tasks;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Tasks.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,tasksIndexes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),checkedIndexes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),tasks:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_components_tasksStyle_jsx__["a" /* default */])(Tasks));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card-profile1-square.3122abf4.jpg";

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isSafari = exports.isSafari = function isSafari() {
  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
};

var isJsons = exports.isJsons = function isJsons(array) {
  return Array.isArray(array) && array.every(function (row) {
    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
  });
};

var isArrays = exports.isArrays = function isArrays(array) {
  return Array.isArray(array) && array.every(function (row) {
    return Array.isArray(row);
  });
};

var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
  return Array.from(array.map(function (json) {
    return Object.keys(json);
  }).reduce(function (a, b) {
    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
  }, []));
};

var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
  headers = headers || jsonsHeaders(jsons);

  var headerLabels = headers;
  var headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map(function (header) {
      return header.label;
    });
    headerKeys = headers.map(function (header) {
      return header.key;
    });
  }

  var data = jsons.map(function (object) {
    return headerKeys.map(function (header) {
      return getHeaderValue(header, object);
    });
  });
  return [headerLabels].concat(_toConsumableArray(data));
};

var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
    if (o[p] === undefined) {
      arr.splice(1);
    } else {
      return o[p];
    }
  }, obj);

  return foundValue === undefined ? '' : foundValue;
};

var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
  return element || element === 0 ? element : '';
};

var joiner = exports.joiner = function joiner(data) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';

  var filteredData = data.filter(function (e) {
    return e;
  });
  return filteredData.map(function (row, index) {
    return row.map(function (element) {
      return "\"" + elementOrEmpty(element) + "\"";
    }).join(separator);
  }).join("\n");
};

var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator) {
  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator);
};

var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator) {
  return joiner(jsons2arrays(data, headers), separator);
};

var string2csv = exports.string2csv = function string2csv(data, headers, separator) {
  return headers ? headers.join(separator) + "\n" + data : data;
};

var toCSV = exports.toCSV = function toCSV(data, headers, separator) {
  if (isJsons(data)) return jsons2csv(data, headers, separator);
  if (isArrays(data)) return arrays2csv(data, headers, separator);
  if (typeof data === 'string') return string2csv(data, headers, separator);
  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};

var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator) {
  var csv = toCSV(data, headers, separator);
  var type = isSafari() ? 'application/csv' : 'text/csv';
  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;

  var URL = window.URL || window.webkitURL;

  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]).isRequired,
  headers: _propTypes.array,
  target: _propTypes.string,
  separator: _propTypes.string,
  filename: _propTypes.string,
  uFEFF: _propTypes.bool,
  onClick: _propTypes.func,
  asyncOnClick: _propTypes.bool
};

var defaultProps = exports.defaultProps = {
  separator: ',',
  filename: 'generatedBy_react-csv.csv',
  uFEFF: true,
  asyncOnClick: false
};

var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_components_cardListStyle__ = __webpack_require__(1244);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// core components
//import Muted from "components/Typography/Muted.jsx";
//import Icon from "@material-ui/core/Icon";
var CardList=function(_Component){_inherits(CardList,_Component);function CardList(){_classCallCheck(this,CardList);return _possibleConstructorReturn(this,(CardList.__proto__||Object.getPrototypeOf(CardList)).apply(this,arguments));}_createClass(CardList,[{key:"showReview",value:function showReview(lead,reviews){this.props.showReview(lead,reviews);}},{key:"sendEmail",value:function sendEmail(lead){this.props.sendEmail(lead);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,lead=_props.lead;var name=lead.name,website=lead.website,icon=lead.icon,url=lead.url,formatted_address=lead.formatted_address,formatted_phone_number=lead.formatted_phone_number,reviews=lead.reviews,rating=lead.rating,email=lead.email;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardHeader_jsx__["a" /* default */],{icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardIcon_jsx__["a" /* default */],{color:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:icon,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardIconTitle},name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardDetails},"Address: ",formatted_address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardDetails},"Phone Number: ",formatted_phone_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:website,target:"_blank",rel:"noopener noreferrer",className:classes.cardLink},"Website"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:url,target:"_blank",rel:"noopener noreferrer",className:classes.cardLink},"Google Link"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Card_CardBody_jsx__["a" /* default */],null,reviews!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardDetails},"Reviews: ",reviews.length):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardDetails},"Rating: ",rating),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardDetails},"Email: ",email)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardFooter_jsx__["a" /* default */],{product:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],{spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:2,lg:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",size:"sm",disabled:reviews===undefined,onClick:function onClick(){return _this2.showReview(lead,reviews);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Email___default.a,{className:classes.icons})," Show Review")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:2,lg:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",size:"sm",disabled:email===""||email===undefined,onClick:function onClick(){return _this2.sendEmail(lead);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Email___default.a,{className:classes.icons})," Send Email")))));}}]);return CardList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CardList.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,lead:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,showReview:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,sendEmail:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_components_cardListStyle__["a" /* default */])(CardList));

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Slide__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_modalStyle_jsx__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Instruction_Instruction_jsx__ = __webpack_require__(398);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// material-ui components
// @material-ui/icons
// core components
function Transition(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Slide___default.a,Object.assign({direction:"down"},props));}var ReviewsModal=function(_React$Component){_inherits(ReviewsModal,_React$Component);function ReviewsModal(props){_classCallCheck(this,ReviewsModal);var _this=_possibleConstructorReturn(this,(ReviewsModal.__proto__||Object.getPrototypeOf(ReviewsModal)).call(this,props));_this.state={modal:false,noticeModal:false};return _this;}_createClass(ReviewsModal,[{key:"handleClickOpen",value:function handleClickOpen(modal){var x=[];x[modal]=true;this.setState(x);}},{key:"handleClose",value:function handleClose(modal){var x=[];x[modal]=false;this.setState(x);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,noticeModal=_props.noticeModal,reviews=_props.reviews,lead=_props.lead;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog___default.a,{classes:{root:classes.center+" "+classes.modalRoot,paper:classes.modal},open:noticeModal,TransitionComponent:Transition,keepMounted:true,scroll:"paper",onClose:function onClose(){return _this2.props.handleClose("noticeModal");},"aria-labelledby":"notice-modal-slide-title","aria-describedby":"notice-modal-slide-description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default.a,{id:"notice-modal-slide-title",disableTypography:true,className:classes.modalHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,className:classes.modalCloseButton,key:"close","aria-label":"Close",color:"transparent",onClick:function onClick(){return _this2.props.handleClose("noticeModal");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default.a,{className:classes.modalClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.modalTitle},lead.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent___default.a,{id:"notice-modal-slide-description",className:classes.modalBody},reviews!==undefined?reviews.map(function(review,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Instruction_Instruction_jsx__["a" /* default */],{key:key,title:review.author_name,text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,review.text),image:review.profile_photo_url,className:classes.instructionNoticeModal,imageClassName:classes.imageNoticeModal});}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default.a,{className:classes.modalFooter+" "+classes.modalFooterCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this2.props.handleClose("noticeModal");},color:"info",round:true},"Close"))));}}]);return ReviewsModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ReviewsModal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,noticeModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,reviews:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,lead:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_modalStyle_jsx__["a" /* default */])(ReviewsModal));

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Slide__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap_sweetalert__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_modalStyle_jsx__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// material-ui components
// @material-ui/icons
// core components
//import GridContainer from "components/Grid/GridContainer.jsx";
//import GridItem from "components/Grid/GridItem.jsx";
function Transition(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Slide___default.a,Object.assign({direction:"down"},props));}var EmailModal=function(_React$Component){_inherits(EmailModal,_React$Component);function EmailModal(props){_classCallCheck(this,EmailModal);var _this=_possibleConstructorReturn(this,(EmailModal.__proto__||Object.getPrototypeOf(EmailModal)).call(this,props));_this.handleEditorChange=function(e){console.log("Content was updated:",e.target.getContent());_this.setState({content:e.target.getContent()});};_this.sendEmail=function(){console.log(_this.state.content,_this.state.email,_this.state.subject);var _this$props$smtp=_this.props.smtp,host=_this$props$smtp.host,encryption=_this$props$smtp.encryption,email=_this$props$smtp.email,username=_this$props$smtp.username,password=_this$props$smtp.password,port=_this$props$smtp.port;__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("http://api.trivajleads.com/email.php",{params:{host:host,username:username,password:password,sender:email,encryption:encryption,port:port,address:_this.state.email,name:"Recipient",subject:_this.state.subject,body:_this.state.content}}).then(function(response){if(response.data.success){_this.successSent();}else{_this.failAlert(response.data.message);}console.log("data is ",response.data);}).catch(function(error){console.log("error is ",error.message);});};_this.state={modal:false,noticeModal:false,email:"",subject:"",content:"",alert:null,show:false};_this.handleEditorChange=_this.handleEditorChange.bind(_this);_this.successSent=_this.successSent.bind(_this);_this.hideAlert=_this.hideAlert.bind(_this);_this.failAlert=_this.failAlert.bind(_this);return _this;}_createClass(EmailModal,[{key:"change",value:function change(event,stateName){this.setState(_defineProperty({},stateName,event.target.value));}},{key:"componentDidMount",value:function componentDidMount(){this.setState({email:this.props.lead.email});}},{key:"handleClickOpen",value:function handleClickOpen(modal){var x=[];x[modal]=true;this.setState(x);}},{key:"handleClose",value:function handleClose(modal){var x=[];x[modal]=false;this.setState(x);}},{key:"successSent",value:function successSent(){var _this2=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap_sweetalert___default.a,{success:true,style:{display:"block",marginTop:"-100px"},title:"Message Sent!",onConfirm:function onConfirm(){return _this2.hideAlert();},onCancel:function onCancel(){return _this2.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},"Message has been sent.")});}},{key:"failAlert",value:function failAlert(message){var _this3=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_bootstrap_sweetalert___default.a,{danger:true,style:{display:"block",marginTop:"-100px"},title:"Failed",onConfirm:function onConfirm(){return _this3.hideAlert();},onCancel:function onCancel(){return _this3.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},message)});}},{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,classes=_props.classes,emailModal=_props.emailModal,lead=_props.lead;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog___default.a,{classes:{root:classes.center+" "+classes.modalRoot,paper:classes.modal},open:emailModal,TransitionComponent:Transition,keepMounted:true,onClose:function onClose(){return _this4.props.handleClose("noticeModal");},"aria-labelledby":"notice-modal-slide-title","aria-describedby":"notice-modal-slide-description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle___default.a,{id:"notice-modal-slide-title",disableTypography:true,className:classes.modalHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,className:classes.modalCloseButton,key:"close","aria-label":"Close",color:"transparent",onClick:function onClick(){return _this4.props.handleClose();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Close___default.a,{className:classes.modalClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.modalTitle},lead.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent___default.a,{id:"notice-modal-slide-description",className:classes.modalBody},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"email",labelText:"Email Address *",value:this.state.email,formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this4.change(event,"email");},defaultValue:lead.email}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"subject",labelText:"Subject *",value:this.state.subject,formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this4.change(event,"subject");},defaultValue:""}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__["a" /* Editor */],{apiKey:"6kc2t3vryyv7mz4xvjftgatwq3hfc8hzcukid8j1yxdplmat",init:{plugins:"link table",height:"360",width:"640"},value:this.state.content,onChange:this.handleEditorChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default.a,{className:classes.modalFooter+" "+classes.modalFooterCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this4.props.handleClose();},color:"info",round:true},"Close"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this4.sendEmail();},color:"info",round:true},"Send"))));}}]);return EmailModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EmailModal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,emailModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,reviews:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,lead:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,smtp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{smtp:state.smtp};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_modalStyle_jsx__["a" /* default */])(EmailModal)));//export default withStyles(modalStyle)(EmailModal);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isTextarea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mergePlugins; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditorPropTypes__ = __webpack_require__(499);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var isValidKey = function (keys) { return function (key) { return keys.indexOf(key) !== -1; }; };
// tslint:disable-next-line:ban-types
var isFunction = function (x) { return typeof x === 'function'; };
var bindHandlers = function (props, editor, initEvent) {
    Object.keys(props)
        .filter(isValidKey(Object.keys(__WEBPACK_IMPORTED_MODULE_0__components_EditorPropTypes__["b" /* eventPropTypes */])))
        .forEach(function (key) {
        var handler = props[key];
        if (isFunction(handler)) {
            if (key === 'onInit') {
                handler(initEvent, editor);
            }
            else {
                editor.on(key.substring(2), function (e) { return handler(e, editor); });
            }
        }
    });
};
var unique = 0;
var uuid = function (prefix) {
    var date = new Date();
    var time = date.getTime();
    var random = Math.floor(Math.random() * 1000000000);
    unique++;
    return prefix + '_' + random + unique + String(time);
};
var isTextarea = function (element) {
    return element !== null && element.tagName.toLowerCase() === 'textarea';
};
var normalizePluginArray = function (plugins) {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
var mergePlugins = function (initPlugins, inputPlugins) {
    return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
};


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};

var eventPropTypes = {
    onActivate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onAddUndo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeAddUndo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeExecCommand: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeGetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeRenderUI: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeSetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforePaste: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onClearUndos: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onContextMenu: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onCopy: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onCut: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDblclick: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDeactivate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDirty: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDrag: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragDrop: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragGesture: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragOver: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDrop: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onExecCommand: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onFocusIn: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onFocusOut: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onGetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onHide: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onInit: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onKeyPress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onKeyUp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onLoadContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseMove: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseOut: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseUp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onNodeChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onObjectResizeStart: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onObjectResized: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onObjectSelected: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPaste: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPostProcess: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPostRender: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPreProcess: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onProgressState: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onRedo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onRemove: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onReset: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSaveContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSelectionChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSetAttrib: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onShow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSubmit: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onUndo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onVisualAid: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
};
var EditorPropTypes = __assign({ apiKey: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], inline: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"], init: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], initialValue: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], onEditorChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], value: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], tagName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], cloudChannel: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], plugins: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"]]), toolbar: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"]]), disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"], textareaName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }, eventPropTypes);


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(501);
module.exports = __webpack_require__(506);


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(502).enable();
  window.Promise = __webpack_require__(504);
}

// fetch() polyfill for making API calls.
__webpack_require__(505);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(42);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(307);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(307);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 505 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_routes_index_jsx__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_scss_material_dashboard_pro_react_css_v_1_4_0__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_scss_material_dashboard_pro_react_css_v_1_4_0___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_assets_scss_material_dashboard_pro_react_css_v_1_4_0__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_reducers__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__firebase_config__ = __webpack_require__(1266);
//import initialState from "./store/initialState.json";
var initialState={};// if (
//   localStorage["redux-store"] !== null &&
//   localStorage["redux-store"] !== undefined
// ) {
//   initialState = JSON.parse(localStorage["redux-store"]);
// }
// const hist = createBrowserHistory({
//   basename: "/development/build"
// });
//in json  "homepage": "http://35.190.159.138/development/build/",
var hist=Object(__WEBPACK_IMPORTED_MODULE_2_history__["a" /* createBrowserHistory */])();var store=Object(__WEBPACK_IMPORTED_MODULE_7_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_8_redux_thunk__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_6__store_reducers__["a" /* default */],initialState);store.subscribe(function(){var state=JSON.stringify(store.getState());localStorage["redux-store"]=state;});// window.store = store;
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Router */],{history:hist},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_4_routes_index_jsx__["a" /* default */].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:prop.path,component:prop.component,key:key});})))),document.getElementById("root"));

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(42),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(42),r=__webpack_require__(509);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(510);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(308);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(308);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(207);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(208);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(518);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(208);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(521);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(209);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(309);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(525);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(527);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(313);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(529);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(209);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(531);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(210);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(313);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(210);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(535);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(311);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_Pages_jsx__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_layouts_RTL_jsx__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_layouts_Dashboard_jsx__ = __webpack_require__(1228);
var indexRoutes=[{path:"/rtl",name:"RTL",component:__WEBPACK_IMPORTED_MODULE_1_layouts_RTL_jsx__["a" /* default */]},{path:"/pages",name:"Pages",component:__WEBPACK_IMPORTED_MODULE_0_layouts_Pages_jsx__["a" /* default */]},{path:"/",name:"Home",component:__WEBPACK_IMPORTED_MODULE_2_containers_layouts_Dashboard_jsx__["a" /* default */]}];/* harmony default export */ __webpack_exports__["a"] = (indexRoutes);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Header_PagesHeader_jsx__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_routes_pages_jsx__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_layouts_pagesStyle_jsx__ = __webpack_require__(744);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
//import Footer from "components/Footer/Footer.jsx";
// import bgImage from "assets/img/register.jpeg";
var Pages=function(_React$Component){_inherits(Pages,_React$Component);function Pages(){_classCallCheck(this,Pages);return _possibleConstructorReturn(this,(Pages.__proto__||Object.getPrototypeOf(Pages)).apply(this,arguments));}_createClass(Pages,[{key:"componentDidMount",value:function componentDidMount(){document.body.style.overflow="unset";}},{key:"render",value:function render(){var _props=this.props,classes=_props.classes,rest=_objectWithoutProperties(_props,["classes"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Header_PagesHeader_jsx__["a" /* default */],rest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wrapper,ref:"wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.fullPage// style={{ backgroundImage: "url(" + bgImage + ")" }}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_5_routes_pages_jsx__["a" /* default */].map(function(prop,key){if(prop.collapse){return null;}if(prop.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{from:prop.path,to:prop.pathTo,key:key});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:prop.path,component:prop.component,key:key});})))));}}]);return Pages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Pages.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_layouts_pagesStyle_jsx__["a" /* default */])(Pages));

/***/ }),
/* 538 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(2);

var _ns = __webpack_require__(314);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(541);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(88);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(317);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(320);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(550);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(551);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(557);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(558);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(213);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(89);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(319);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(154);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(559);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(560);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(88);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(552);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(553);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(554);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(555);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(556);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(120);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(120);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(211);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(211);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(89);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(154);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(317);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(120);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(89);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(154);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(88);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(213);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(89);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(153);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(315);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(563);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(565);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(567);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(569);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(214);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(570);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(572);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(214);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(571);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(214);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(575);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(5));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _deepmerge = _interopRequireDefault(__webpack_require__(156));

var _indigo = _interopRequireDefault(__webpack_require__(578));

var _pink = _interopRequireDefault(__webpack_require__(579));

var _grey = _interopRequireDefault(__webpack_require__(580));

var _red = _interopRequireDefault(__webpack_require__(581));

var _common = _interopRequireDefault(__webpack_require__(582));

var _colorManipulator = __webpack_require__(75);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _deepmerge = _interopRequireDefault(__webpack_require__(156));

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "allVariants"]);

  var coef = fontSize / 14;

  function pxToRem(value) {
    return "".concat(value / htmlFontSize * coef, "rem");
  }

  return (0, _deepmerge.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: (0, _extends2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  }, other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _typeof2 = _interopRequireDefault(__webpack_require__(152));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _deepmerge = _interopRequireDefault(__webpack_require__(156));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_List__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItem__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemIcon__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_ListItemText__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Menu__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_routes_pages_jsx__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_components_pagesHeaderStyle_jsx__ = __webpack_require__(743);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
//import Dashboard from "@material-ui/icons/Dashboard";
// core components
var PagesHeader=function(_React$Component){_inherits(PagesHeader,_React$Component);function PagesHeader(props){_classCallCheck(this,PagesHeader);var _this=_possibleConstructorReturn(this,(PagesHeader.__proto__||Object.getPrototypeOf(PagesHeader)).call(this,props));_this.handleDrawerToggle=function(){_this.setState({open:!_this.state.open});};_this.state={open:false};return _this;}_createClass(PagesHeader,[{key:"activeRoute",// verifies if routeName is the one active (in browser input)
value:function activeRoute(routeName){return this.props.location.pathname.indexOf(routeName)>-1?true:false;}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(e.history.location.pathname!==e.location.pathname){this.setState({open:false});}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,color=_props.color;var appBarClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}," "+classes[color],color));var list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_List___default.a,{className:classes.list},__WEBPACK_IMPORTED_MODULE_15_routes_pages_jsx__["a" /* default */].map(function(prop,key){if(prop.redirect){return null;}var navLink=classes.navLink+__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}," "+classes.navLinkActive,_this2.activeRoute(prop.path)));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItem___default.a,{key:key,className:classes.listItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* NavLink */],{to:prop.path,className:navLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemIcon___default.a,{className:classes.listItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_ListItemText___default.a,{primary:prop.short,disableTypography:true,className:classes.listItemText})));}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar___default.a,{position:"static",className:classes.appBar+appBarClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar___default.a,{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default.a,{smDown:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.flex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button__["a" /* default */],{href:"#",className:classes.title,color:"transparent"},"Trivaj Leads"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.flex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button__["a" /* default */],{href:"#",className:classes.title,color:"transparent"},"MD Pro React"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default.a,{smDown:true},list),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button__["a" /* default */],{className:classes.sidebarButton,color:"transparent",justIcon:true,"aria-label":"open drawer",onClick:this.handleDrawerToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Menu___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Hidden___default.a,{mdUp:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer___default.a,{variant:"temporary",anchor:"right",open:this.state.open,classes:{paper:classes.drawerPaper},onClose:this.handleDrawerToggle,ModalProps:{keepMounted:true// Better open performance on mobile.
}},list)))));}}]);return PagesHeader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PagesHeader.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","info","success","warning","danger"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_components_pagesHeaderStyle_jsx__["a" /* default */])(PagesHeader));

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var _Paper = _interopRequireDefault(__webpack_require__(64));

// @inheritedComponent Paper
var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

exports.styles = styles;

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    component: "header",
    elevation: 4,
    className: className
  }, other), children);
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),

  /**
   * The positioning type. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static', 'relative'])
} : {};
AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAppBar'
})(AppBar);

exports.default = _default;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};

exports.styles = styles;

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['regular', 'dense'])
} : {};
Toolbar.defaultProps = {
  disableGutters: false,
  variant: 'regular'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiToolbar'
})(Toolbar);

exports.default = _default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _HiddenJs = _interopRequireDefault(__webpack_require__(594));

var _HiddenCss = _interopRequireDefault(__webpack_require__(597));

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties2.default)(props, ["implementation"]);

  if (implementation === 'js') {
    return _react.default.createElement(_HiddenJs.default, other);
  }

  return _react.default.createElement(_HiddenCss.default, other);
}

Hidden.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};
Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};
var _default = Hidden;
exports.default = _default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _createBreakpoints = __webpack_require__(121);

var _withWidth = _interopRequireWildcard(__webpack_require__(595));

var _exactProp = _interopRequireDefault(__webpack_require__(123));

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
};
HiddenJs.propTypes = (0, _exactProp.default)(HiddenJs.propTypes);

var _default = (0, _withWidth.default)()(HiddenJs);

exports.default = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withWidth.default;
  }
});

var _withWidth = _interopRequireWildcard(__webpack_require__(596));

Object.keys(_withWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withWidth[key];
    }
  });
});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isWidthDown = exports.isWidthUp = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _debounce = _interopRequireDefault(__webpack_require__(90));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(119));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(118));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _createBreakpoints = __webpack_require__(121);

var _getThemeProps2 = _interopRequireDefault(__webpack_require__(325));

/* eslint-disable react/no-did-mount-set-state */
// < 1kb payload overhead when lodash/debounce is > 3kb.
// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }

  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.


exports.isWidthUp = isWidthUp;

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }

  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

exports.isWidthDown = isWidthDown;

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth,
        _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === void 0 ? 166 : _options$resizeInterv;

    var WithWidth =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithWidth, _React$Component);

      function WithWidth(props) {
        var _this;

        (0, _classCallCheck2.default)(this, WithWidth);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithWidth).call(this, props));
        _this.handleResize = (0, _debounce.default)(function () {
          var width = _this.getWidth();

          if (width !== _this.state.width) {
            _this.setState({
              width: width
            });
          }
        }, resizeInterval);
        _this.state = {
          width: undefined
        };

        if (noSSR) {
          _this.state.width = _this.getWidth();
        }

        return _this;
      }

      (0, _createClass2.default)(WithWidth, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var width = this.getWidth();

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.handleResize.clear();
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          var innerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.innerWidth;
          var breakpoints = this.props.theme.breakpoints;
          var width = null;
          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */

          var index = 1;

          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index]; // @media are inclusive, so reproduce the behavior here.

            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';
          return width;
        }
      }, {
        key: "render",
        value: function render() {
          var _getThemeProps = (0, _getThemeProps2.default)({
            theme: this.props.theme,
            name: 'MuiWithWidth',
            props: (0, _extends2.default)({}, this.props)
          }),
              initialWidth = _getThemeProps.initialWidth,
              theme = _getThemeProps.theme,
              width = _getThemeProps.width,
              other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "theme", "width"]);

          var more = (0, _extends2.default)({
            width: width || this.state.width || initialWidth || initialWidthOption
          }, other); // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.

          if (more.width === undefined) {
            return null;
          }

          if (withThemeOption) {
            more.theme = theme;
          }

          return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Component, more), _react.default.createElement(_reactEventListener.default, {
            target: "window",
            onResize: this.handleResize
          }));
        }
      }]);
      return WithWidth;
    }(_react.default.Component);

    WithWidth.propTypes =  false ? {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * In some situation, you might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * http://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: _propTypes.default.object.isRequired,

      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : {};

    if (false) {
      WithWidth.displayName = (0, _wrapDisplayName.default)(Component, 'WithWidth');
    }

    (0, _hoistNonReactStatics.default)(WithWidth, Component);
    return (0, _withTheme.default)()(WithWidth);
  };
};

var _default = withWidth;
exports.default = _default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _createBreakpoints = __webpack_require__(121);

var _helpers = __webpack_require__(25);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
   false ? (0, _warning.default)(Object.keys(other).length === 0 || Object.keys(other).length === 1 && other.hasOwnProperty('ref'), "Material-UI: unsupported properties received ".concat(Object.keys(other).join(', '), " by `<Hidden />`.")) : void 0;
  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      classNames.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      classNames.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
    });
  }

  return _react.default.createElement("div", {
    className: classNames.join(' ')
  }, children);
}

HiddenCss.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};

var _default = (0, _withStyles.default)(styles)(HiddenCss);

exports.default = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHorizontal = isHorizontal;
exports.getAnchor = getAnchor;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Modal = _interopRequireDefault(__webpack_require__(217));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Slide = _interopRequireDefault(__webpack_require__(126));

var _Paper = _interopRequireDefault(__webpack_require__(64));

var _helpers = __webpack_require__(25);

var _transitions = __webpack_require__(76);

var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

function isHorizontal(props) {
  return ['left', 'right'].indexOf(props.anchor) !== -1;
}

function getAnchor(props) {
  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
/**
 * The properties of the [Modal](/api/modal) component are available
 * when `variant="temporary"` is set.
 */


exports.styles = styles;

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Drawer, _React$Component);

  function Drawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchorProp = _this$props.anchor,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          elevation = _this$props.elevation,
          _this$props$ModalProp = _this$props.ModalProps;
      _this$props$ModalProp = _this$props$ModalProp === void 0 ? {} : _this$props$ModalProp;
      var BackdropPropsProp = _this$props$ModalProp.BackdropProps,
          ModalProps = (0, _objectWithoutProperties2.default)(_this$props$ModalProp, ["BackdropProps"]),
          onClose = _this$props.onClose,
          open = _this$props.open,
          PaperProps = _this$props.PaperProps,
          SlideProps = _this$props.SlideProps,
          theme = _this$props.theme,
          transitionDuration = _this$props.transitionDuration,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
      var anchor = getAnchor(this.props);

      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true,
        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
      }, PaperProps), children);

      if (variant === 'permanent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), drawer);
      }

      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
        in: open,
        direction: oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: this.mounted
      }, SlideProps), drawer);

      if (variant === 'persistent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), slidingDrawer);
      } // variant === temporary


      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        BackdropProps: (0, _extends2.default)({}, BackdropProps, BackdropPropsProp, {
          transitionDuration: transitionDuration
        }),
        className: (0, _classnames.default)(classes.modal, className),
        open: open,
        onClose: onClose
      }, other, ModalProps), slidingDrawer);
    }
  }]);
  return Drawer;
}(_react.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,

  /**
   * Properties applied to the [`Modal`](/api/modal) element.
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Slide`](/api/slide) element.
   */
  SlideProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDrawer',
  flip: false,
  withTheme: true
})(Drawer);

exports.default = _default;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _keycode = _interopRequireDefault(__webpack_require__(124));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var _RootRef = _interopRequireDefault(__webpack_require__(329));

var _Portal = _interopRequireDefault(__webpack_require__(330));

var _helpers = __webpack_require__(25);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ModalManager = _interopRequireDefault(__webpack_require__(331));

var _Backdrop = _interopRequireDefault(__webpack_require__(610));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
    _this.mountNode = null;
    _this.modalRef = null;
    _this.dialogRef = null;
    _this.mounted = false;

    _this.handleRendered = function () {
      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);

      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
      doc.addEventListener('focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
        return;
      } // Ignore events that have been `event.preventDefault()` marked.


      if (event.defaultPrevented) {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      _this.lastFocus = (0, _ownerDocument.default)(_this.mountNode).activeElement;
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (_this.dialogRef && !_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.checkForFocus();
      }

      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (this.dialogRef && !this.dialogRef.contains(currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        // Not all elements in IE11 have a focus method.
        // Because IE11 market share is low, we accept the restore focus being broken
        // and we silent the issue.
        if (this.lastFocus.focus) {
          this.lastFocus.focus();
        }

        this.lastFocus = null;
      }
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      } // It's a Transition like component


      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: function ref(_ref2) {
          _this2.mountNode = _ref2 ? _ref2.getMountNode() : _ref2;
        },
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: function ref(_ref) {
          _this2.modalRef = _ref;
        },
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: function rootRef(ref) {
          _this2.dialogRef = ref;
        }
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : {};
Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default(),
  BackdropComponent: _Backdrop.default
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _exactProp = _interopRequireDefault(__webpack_require__(123));

var _reactHelpers = __webpack_require__(66);

/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RootRef);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RootRef)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ref = null;
    return _this;
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = _reactDom.default.findDOMNode(this);
      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = _reactDom.default.findDOMNode(this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
        }

        this.ref = ref;
        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      (0, _reactHelpers.setRef)(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

RootRef.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : {};
RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes) : {};
var _default = RootRef;
exports.default = _default;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var _exactProp = _interopRequireDefault(__webpack_require__(123));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(this.props.onRendered);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : {};
Portal.defaultProps = {
  disablePortal: false
};
Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes) : {};
var _default = Portal;
exports.default = _default;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(604));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(332));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(92));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var _ownerWindow = _interopRequireDefault(__webpack_require__(158));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a vertical scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }

  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(611));

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Fade = _interopRequireDefault(__webpack_require__(334));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    in: open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

Backdrop.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(125));

var _transitions = __webpack_require__(76);

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _utils = __webpack_require__(159);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            willChange: 'opacity'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _debounce = _interopRequireDefault(__webpack_require__(90));

var _Transition = _interopRequireDefault(__webpack_require__(125));

var _ownerWindow = _interopRequireDefault(__webpack_require__(158));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _transitions = __webpack_require__(76);

var _utils = __webpack_require__(159);

// @inheritedComponent Transition
// < 1kb payload overhead when lodash/debounce is > 3kb.
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Slide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Slide)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    _this.transition = null;
    _this.handleResize = (0, _debounce.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      if (_this.transitionRef) {
        setTranslateValue(_this.props, _this.transitionRef);
      }
    }, 166);

    _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.transitionRef) {
        this.transitionRef.style.visibility = 'inherit';
        setTranslateValue(this.props, this.transitionRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(_ref) {
          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
  dense: {
    paddingTop: 4,
    paddingBottom: 4
  },

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
exports.styles = styles;

var List =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(List).apply(this, arguments));
  }

  (0, _createClass2.default)(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          Component = _this$props.component,
          dense = _this$props.dense,
          disablePadding = _this$props.disablePadding,
          subheader = _this$props.subheader,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), subheader, children);
    }
  }]);
  return List;
}(_react.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : {};
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};
List.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ButtonBase = _interopRequireDefault(__webpack_require__(93));

var _reactHelpers = __webpack_require__(66);

var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 12,
      paddingBottom: 12,
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },
    // TODO: Sanity check this - why is focusVisibleClassName prop apparently applied to a div?

    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
    focusVisible: {
      backgroundColor: theme.palette.action.hover
    },

    /* Legacy styles applied to the root element. Use `root` instead. */
    default: {},

    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
    dense: {
      paddingTop: 8,
      paddingBottom: 8
    },

    /* Styles applied to the inner `component` element if `disabled={true}`. */
    disabled: {
      opacity: 0.5
    },

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: 32
    },

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};

exports.styles = styles;

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck2.default)(this, ListItem);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListItem).apply(this, arguments));
  }

  (0, _createClass2.default)(ListItem, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          button = _this$props.button,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          componentProp = _this$props.component,
          ContainerComponent = _this$props.ContainerComponent,
          _this$props$Container = _this$props.ContainerProps;
      _this$props$Container = _this$props$Container === void 0 ? {} : _this$props$Container;
      var ContainerClassName = _this$props$Container.className,
          ContainerProps = (0, _objectWithoutProperties2.default)(_this$props$Container, ["className"]),
          dense = _this$props.dense,
          disabled = _this$props.disabled,
          disableGutters = _this$props.disableGutters,
          divider = _this$props.divider,
          focusVisibleClassName = _this$props.focusVisibleClassName,
          selected = _this$props.selected,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
      var isDense = dense || this.context.dense || false;

      var children = _react.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
      var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, isDense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), (0, _defineProperty2.default)(_classNames, classes.selected, selected), _classNames), classNameProp);
      var componentProps = (0, _extends2.default)({
        className: className,
        disabled: disabled
      }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
        Component = _ButtonBase.default;
      }

      if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

        if (ContainerComponent === 'li') {
          if (Component === 'li') {
            Component = 'div';
          } else if (componentProps.component === 'li') {
            componentProps.component = 'div';
          }
        }

        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, ContainerClassName)
        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
      }

      return _react.default.createElement(Component, componentProps, children);
    }
  }]);
  return ListItem;
}(_react.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The container component used when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes.default.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.default.bool
} : {};
ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false,
  selected: false
};
ListItem.contextTypes = {
  dense: _propTypes.default.bool
};
ListItem.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItem'
})(ListItem);

exports.default = _default;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _keycode = _interopRequireDefault(__webpack_require__(124));

var _ownerWindow = _interopRequireDefault(__webpack_require__(158));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _focusVisible = __webpack_require__(618);

var _TouchRipple = _interopRequireDefault(__webpack_require__(619));

var _createRippleHandler = _interopRequireDefault(__webpack_require__(626));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Styles applied to the root element if keyboard focused. */
  focusVisible: {}
};
/* istanbul ignore if */

exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */


var ButtonBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ripple = null;
    _this.keyDown = false;
    _this.button = null;
    _this.focusVisibleTimeout = null;
    _this.focusVisibleCheckTime = 50;
    _this.focusVisibleMaxCheckTimes = 5;
    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    });
    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.state = {};

    _this.onRippleRef = function (node) {
      _this.ripple = node;
    };

    _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;
      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations

      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    };

    _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      } // Fix for https://github.com/facebook/react/issues/7769


      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.button = _reactDom.default.findDOMNode(this);
      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.button.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          action = _this$props2.action,
          buttonRef = _this$props2.buttonRef,
          centerRipple = _this$props2.centerRipple,
          children = _this$props2.children,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          component = _this$props2.component,
          disabled = _this$props2.disabled,
          disableRipple = _this$props2.disableRipple,
          disableTouchRipple = _this$props2.disableTouchRipple,
          focusRipple = _this$props2.focusRipple,
          focusVisibleClassName = _this$props2.focusVisibleClassName,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          onFocusVisible = _this$props2.onFocusVisible,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          onMouseDown = _this$props2.onMouseDown,
          onMouseLeave = _this$props2.onMouseLeave,
          onMouseUp = _this$props2.onMouseUp,
          onTouchEnd = _this$props2.onTouchEnd,
          onTouchMove = _this$props2.onTouchMove,
          onTouchStart = _this$props2.onTouchStart,
          tabIndex = _this$props2.tabIndex,
          TouchRippleProps = _this$props2.TouchRippleProps,
          type = _this$props2.type,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
      var buttonProps = {};
      var ComponentProp = component;

      if (ComponentProp === 'button' && other.href) {
        ComponentProp = 'a';
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        tabIndex: disabled ? '-1' : tabIndex,
        className: className,
        ref: buttonRef
      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
        innerRef: this.onRippleRef,
        center: centerRipple
      }, TouchRippleProps)) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);
  return ButtonBase;
}(_react.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `focusVisible()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes.default.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes.default.bool,

  /**
   * This property can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes.default.object,

  /**
   * Used to control the button's purpose.
   * This property passes the value to the `type` attribute of the native button component.
   * Valid property values include `button`, `submit`, and `reset`.
   */
  type: _propTypes.default.string
} : {};
ButtonBase.defaultProps = {
  centerRipple: false,
  component: 'button',
  disableRipple: false,
  disableTouchRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButtonBase'
})(ButtonBase);

exports.default = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFocusVisible = detectFocusVisible;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = _interopRequireDefault(__webpack_require__(124));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};

function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument.default)(element);

    if (internal.focusKeyPressed && (doc.activeElement === element || element.contains(doc.activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 1e3);
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(336));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(623));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Ripple = _interopRequireDefault(__webpack_require__(625));

var DURATION = 550;
var DELAY_RIPPLE = 80;
exports.DELAY_RIPPLE = DELAY_RIPPLE;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

exports.styles = styles;

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TouchRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ignoringMouseDown = false;
    _this.startTimer = null;
    _this.startTimerCommit = null;
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      nextKey: 0,
      ripples: []
    };

    _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    };

    _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Deplay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          if (_this.startTimerCommit) {
            _this.startTimerCommit();

            _this.startTimerCommit = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    };

    _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      _this.setState(function (state) {
        return {
          nextKey: state.nextKey + 1,
          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
            key: state.nextKey,
            classes: _this.props.classes,
            timeout: {
              exit: DURATION,
              enter: DURATION
            },
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize
          })])
        };
      }, cb);
    };

    _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          center = _this$props.center,
          classes = _this$props.classes,
          className = _this$props.className,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
        component: "span",
        enter: true,
        exit: true,
        className: (0, _classnames.default)(classes.root, className)
      }, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(_react.default.PureComponent);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
TouchRipple.defaultProps = {
  center: false
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(TouchRipple);

exports.default = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(335);

var _ChildMapping = __webpack_require__(624);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Transition = _interopRequireDefault(__webpack_require__(125));

/**
 * @ignore - internal component.
 */
var Ripple =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ripple, _React$Component);

  function Ripple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      visible: false,
      leaving: false
    };

    _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    };

    _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Ripple, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props = this.props,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          pulsate = _this$props.pulsate,
          rippleX = _this$props.rippleX,
          rippleY = _this$props.rippleY,
          rippleSize = _this$props.rippleSize,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
      var _this$state = this.state,
          visible = _this$state.visible,
          leaving = _this$state.leaving;
      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), _react.default.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
      }, _react.default.createElement("span", {
        className: childClassName
      })));
    }
  }]);
  return Ripple;
}(_react.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes.default.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes.default.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes.default.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes.default.number
} : {};
Ripple.defaultProps = {
  pulsate: false
};
var _default = Ripple;
exports.default = _default;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.

    if (event.defaultPrevented) {
      ignore = true;
    }

    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
      ignore = true;
    }

    if (!ignore && instance.ripple) {
      instance.ripple[action](event);
    }

    if (typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
}

var _default = createRippleHandler;
exports.default = _default;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginRight: 16,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */


exports.styles = styles;

function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.cloneElement(children, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon);

exports.default = _default;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Typography = _interopRequireDefault(__webpack_require__(127));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      '&:first-child': {
        paddingLeft: 56
      }
    },

    /* Styles applied to the root element if `context.dense` is `true`. */
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the primary `Typography` component. */
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the secondary `Typography` component. */
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the `Typography` components if `context.dense` is `true`. */
    textDense: {}
  };
};

exports.styles = styles;

function ListItemText(props, context) {
  var _classNames3;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
  var dense = context.dense;
  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
    primary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: "subheading",
      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      component: "span"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
    secondary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: "body1",
      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      color: "textSecondary"
    }, secondaryTypographyProps), secondary);
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
  }, other), primary, secondary);
}

ListItemText.propTypes =  false ? {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.default.bool,

  /**
   * The main content element.
   */
  primary: _propTypes.default.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: _propTypes.default.object,

  /**
   * The secondary content element.
   */
  secondary: _propTypes.default.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: _propTypes.default.object
} : {};
ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};
ListItemText.contextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemText'
})(ListItemText);

exports.default = _default;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      margin: 0
    },

    /* Styles applied to the root element if `variant="display4"`. */
    display4: theme.typography.display4,

    /* Styles applied to the root element if `variant="display3"`. */
    display3: theme.typography.display3,

    /* Styles applied to the root element if `variant="display2"`. */
    display2: theme.typography.display2,

    /* Styles applied to the root element if `variant="display1"`. */
    display1: theme.typography.display1,

    /* Styles applied to the root element if `variant="headline"`. */
    headline: theme.typography.headline,

    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,

    /* Styles applied to the root element if `variant="subheading"`. */
    subheading: theme.typography.subheading,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `align="nowrap"`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    }
  };
};

exports.styles = styles;

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      componentProp = props.component,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "noWrap", "paragraph", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes[variant], variant !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes.default.object,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button', 'srOnly', 'inherit'])
} : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography'
})(Typography);

exports.default = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(631));

var _shallowEqual = _interopRequireDefault(__webpack_require__(634));

var _setDisplayName = _interopRequireDefault(__webpack_require__(340));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(341));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(340));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(341));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(219));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: 24,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 36
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true',
    role: titleAccess ? 'img' : 'presentation'
  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : {};
SvgIcon.defaultProps = {
  color: 'inherit',
  component: 'svg',
  fontSize: 'default',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(75);

var _ButtonBase = _interopRequireDefault(__webpack_require__(93));

var _helpers = __webpack_require__(25);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.button, {
      lineHeight: '1.4em',
      // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: 64,
      minHeight: 36,
      padding: '8px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {},

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flat: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatPrimary: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatSecondary: {},

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main)
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main)
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raised: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedPrimary: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedSecondary: {},
    // legacy

    /* Styles applied to the root element if `variant="[fab | extendedFab]"`. */
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },

    /* Styles applied to the root element if `variant="extendedFab"`. */
    extendedFab: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minWidth: 48,
      height: 48
    },

    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="mini"` & `variant="[fab | extendedFab]"`. */
    mini: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '7px 8px',
      minWidth: 64,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: '8px 24px',
      minWidth: 112,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fullWidth = props.fullWidth,
      focusVisibleClassName = props.focusVisibleClassName,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "focusVisibleClassName", "mini", "size", "variant"]);
  var fab = variant === 'fab' || variant === 'extendedFab';
  var contained = variant === 'contained' || variant === 'raised';
  var text = variant === 'text' || variant === 'flat' || variant === 'outlined';
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.extendedFab, variant === 'extendedFab'), (0, _defineProperty2.default)(_classNames, classes.text, text), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, variant === 'text' || variant === 'flat'), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, (variant === 'text' || variant === 'flat') && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, (variant === 'text' || variant === 'flat') && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.outlinedPrimary, variant === 'outlined' && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.outlinedSecondary, variant === 'outlined' && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['text', 'flat', 'outlined', 'contained', 'raised', 'fab', 'extendedFab'])
} : {};
Button.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButton'
})(Button);

exports.default = _default;

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Pages_LoginPage_jsx__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_Actions__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loginUser:function loginUser(user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_Actions__["f" /* loginUser */])(user));},getInitialData:function getInitialData(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_Actions__["e" /* getInitialData */])());}};};var container=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0_views_Pages_LoginPage_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Typography = _interopRequireDefault(__webpack_require__(127));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `variant="filled"` */
  filled: {
    '&$positionStart': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  }
};
exports.styles = styles;

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "component", "classes", "className", "disableTypography", "position", "variant"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty2.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
    color: "textSecondary"
  }, children) : children);
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes.default.oneOf(['start', 'end']),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment);

exports.default = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 36
    }
  };
};

exports.styles = styles;

function Icon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    "aria-hidden": "true"
  }, other), children);
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
} : {};
Icon.defaultProps = {
  color: 'inherit',
  component: 'span',
  fontSize: 'default'
};
Icon.muiName = 'Icon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIcon'
})(Icon);

exports.default = _default;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _createBreakpoints = __webpack_require__(121);

var _requirePropFactory = _interopRequireDefault(__webpack_require__(641));

// A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var GUTTERS = [0, 8, 16, 24, 32, 40];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    (0, _extends2.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: -spacing / 2,
      width: "calc(100% + ".concat(spacing, "px)"),
      '& > $item': {
        padding: spacing / 2
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return (0, _extends2.default)({
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

exports.styles = styles;

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      zeroMinWidth = props.zeroMinWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.container, container), (0, _defineProperty2.default)(_classNames, classes.item, item), (0, _defineProperty2.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty2.default)(_classNames, classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), (0, _defineProperty2.default)(_classNames, classes["direction-xs-".concat(String(direction))], direction !== Grid.defaultProps.direction), (0, _defineProperty2.default)(_classNames, classes["wrap-xs-".concat(String(wrap))], wrap !== Grid.defaultProps.wrap), (0, _defineProperty2.default)(_classNames, classes["align-items-xs-".concat(String(alignItems))], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty2.default)(_classNames, classes["align-content-xs-".concat(String(alignContent))], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty2.default)(_classNames, classes["justify-xs-".concat(String(justify))], justify !== Grid.defaultProps.justify), (0, _defineProperty2.default)(_classNames, classes["grid-xs-".concat(String(xs))], xs !== false), (0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm !== false), (0, _defineProperty2.default)(_classNames, classes["grid-md-".concat(String(md))], md !== false), (0, _defineProperty2.default)(_classNames, classes["grid-lg-".concat(String(lg))], lg !== false), (0, _defineProperty2.default)(_classNames, classes["grid-xl-".concat(String(xl))], xl !== false), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Grid.propTypes =  false ? {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes.default.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes.default.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes.default.oneOf(GUTTERS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes.default.bool
} : {};
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  wrap: 'wrap',
  xl: false,
  xs: false,
  zeroMinWidth: false
};
var StyledGrid = (0, _withStyles.default)(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = (0, _requirePropFactory.default)('Grid');
  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  });
}

var _default = StyledGrid;
exports.default = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function requirePropFactory(componentNameInError) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The property `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

var _default = requirePropFactory;
exports.default = _default;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(221);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var _reactHelpers = __webpack_require__(66);

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */

exports.styles = styles;

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormControl, _React$Component);

  function FormControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormControl).call(this)); // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.

    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    };

    _this.handleFocus = function () {
      _this.setState(function (state) {
        return !state.focused ? {
          focused: true
        } : null;
      });
    };

    _this.handleBlur = function () {
      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.filled) {
        _this.setState({
          filled: true
        });
      }
    };

    _this.handleClean = function () {
      if (_this.state.filled) {
        _this.setState({
          filled: false
        });
      }
    };

    var children = props.children;

    if (children) {
      _react.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
          return;
        }

        if ((0, _utils.isFilled)(child.props, true)) {
          _this.state.filled = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;

        if (input && (0, _utils.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(FormControl, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          error = _this$props.error,
          required = _this$props.required,
          margin = _this$props.margin,
          variant = _this$props.variant;
      var _this$state = this.state,
          adornedStart = _this$state.adornedStart,
          filled = _this$state.filled,
          focused = _this$state.focused;
      return {
        muiFormControl: {
          adornedStart: adornedStart,
          disabled: disabled,
          error: error,
          filled: filled,
          focused: focused,
          margin: margin,
          onBlur: this.handleBlur,
          onEmpty: this.handleClean,
          onFilled: this.handleDirty,
          onFocus: this.handleFocus,
          required: required,
          variant: variant
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          className = _this$props2.className,
          Component = _this$props2.component,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          margin = _this$props2.margin,
          required = _this$props2.required,
          variant = _this$props2.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required", "variant"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other));
    }
  }]);
  return FormControl;
}(_react.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false,
  variant: 'standard'
};
FormControl.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControl'
})(FormControl);

exports.default = _default;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _FormLabel = _interopRequireDefault(__webpack_require__(222));

var _InputBase = __webpack_require__(95);

// @inheritedComponent FormLabel
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transformOrigin: 'top left'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      transform: 'translate(12px, 22px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 19px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      transform: 'translate(14px, 22px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 17.5px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};

exports.styles = styles;

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      FormLabelClasses = props.FormLabelClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      variantProp = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink", "variant"]);
  var muiFormControl = context.muiFormControl;
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['margin', 'variant']
  });
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, fcs.variant === 'outlined'), _classNames), classNameProp);
  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    "data-shrink": shrink,
    className: className,
    classes: FormLabelClasses
  }, other), children);
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes.default.bool,

  /**
   * `classes` property applied to the [`FormLabel`](/api/form-label) element.
   */
  FormLabelClasses: _propTypes.default.object,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
InputLabel.defaultProps = {
  disableAnimation: false
};
InputLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputLabel'
})(InputLabel);

exports.default = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _InputBase = __webpack_require__(95);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};

exports.styles = styles;

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"]);
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['required', 'focused', 'disabled', 'error', 'filled']
  });
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
  }, other), children, fcs.required && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, fcs.error))
  }, "\u2009*"));
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes.default.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormLabel.defaultProps = {
  component: 'label'
};
FormLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormLabel'
})(FormLabel);

exports.default = _default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _debounce = _interopRequireDefault(__webpack_require__(90));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _reactHelpers = __webpack_require__(66);

// < 1kb payload overhead when lodash/debounce is > 3kb.
var ROWS_HEIGHT = 19;
var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'relative',
    // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var Textarea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Textarea, _React$Component);

  // Corresponds to 10 frames at 60 Hz.
  function Textarea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Textarea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Textarea).call(this));
    _this.isControlled = null;
    _this.shadowRef = null;
    _this.singlelineShadowRef = null;
    _this.inputRef = null;
    _this.value = null;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.syncHeightWithShadow();
    }, 166);
    _this.state = {
      height: null
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      (0, _reactHelpers.setRef)(_this.props.textareaRef, ref);
    };

    _this.handleRefSinglelineShadow = function (ref) {
      _this.singlelineShadowRef = ref;
    };

    _this.handleRefShadow = function (ref) {
      _this.shadowRef = ref;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (!_this.isControlled) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadowRef.value = _this.value;

        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.isControlled = props.value != null; // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are filled.

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };
    return _this;
  }

  (0, _createClass2.default)(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "syncHeightWithShadow",
    value: function syncHeightWithShadow() {
      var props = this.props; // Guarding for **broken** shallow rendering method that call componentDidMount
      // but doesn't handle refs correctly.
      // To remove once the shallow rendering has been fixed.

      if (!this.shadowRef) {
        return;
      }

      if (this.isControlled) {
        // The component is controlled, we need to update the shallow value.
        this.shadowRef.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadowRef.scrollHeight;
      var newHeight = this.shadowRef.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013

      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
      // This prevents infinite rendering loop.

      if (Math.abs(this.state.height - newHeight) > 1) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          textareaRef = _this$props.textareaRef,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "textareaRef", "value"]);
      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        readOnly: true,
        ref: this.handleRefSinglelineShadow,
        rows: "1",
        tabIndex: -1,
        value: ""
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        defaultValue: defaultValue,
        readOnly: true,
        ref: this.handleRefShadow,
        rows: rows,
        tabIndex: -1,
        value: value
      }), _react.default.createElement("textarea", (0, _extends2.default)({
        rows: rows,
        className: (0, _classnames.default)(classes.textarea, className),
        defaultValue: defaultValue,
        value: value,
        onChange: this.handleChange,
        ref: this.handleRefInput,
        style: {
          height: this.state.height
        }
      }, other)));
    }
  }]);
  return Textarea;
}(_react.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
Textarea.defaultProps = {
  rows: 1
};

var _default = (0, _withStyles.default)(styles)(Textarea);

exports.default = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(__webpack_require__(647));

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _InputBase = __webpack_require__(95);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: 8,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$error': {
        color: theme.palette.error.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      margin: '8px 12px 0'
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {}
  };
};

exports.styles = styles;

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.contained, fcs.variant === 'filled' || fcs.variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
  }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes.default.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
FormHelperText.defaultProps = {
  component: 'p'
};
FormHelperText.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText);

exports.default = _default;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _InputBase = _interopRequireDefault(__webpack_require__(649));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};

exports.styles = styles;

function Input(props) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.underline, !disableUnderline)),
      underline: null
    })
  }, other));
}

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
Input.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInput'
})(Input);

exports.default = _default;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputBase.default;
  }
});

var _InputBase = _interopRequireDefault(__webpack_require__(95));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var customInputStyle={disabled:{"&:before":{borderColor:"transparent !important"}},underline:{"&:hover:not($disabled):before,&:before":{borderColor:"#D2D2D2 !important",borderWidth:"1px !important"},"&:after":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]}},underlineError:{"&:after":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]}},underlineSuccess:{"&:after":{borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]}},labelRoot:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{color:"#AAAAAA !important",fontWeight:"400",fontSize:"14px",lineHeight:"1.42857",top:"10px","& + $underline":{marginTop:"0px"}}),labelRootError:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]+" !important"},labelRootSuccess:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]+" !important"},formControl:{margin:"0 0 17px 0",paddingTop:"27px",position:"relative",verticalAlign:"unset","& svg,& .fab,& .far,& .fal,& .fas,& .material-icons":{color:"#495057"}},whiteUnderline:{"&:hover:not($disabled):before,&:before":{backgroundColor:"#FFFFFF"},"&:after":{backgroundColor:"#FFFFFF"}},input:{color:"#495057","&,&::placeholder":{fontSize:"14px",fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',fontWeight:"400",lineHeight:"1.42857",opacity:"1"},"&::placeholder":{color:"#AAAAAA"}},whiteInput:{"&,&::placeholder":{color:"#FFFFFF",opacity:"1"}}};/* harmony default export */ __webpack_exports__["a"] = (customInputStyle);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import {
//
// } from "assets/jss/material-dashboard-pro-react.jsx";
var cardStyle={card:{border:"0",marginBottom:"30px",marginTop:"30px",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff",width:"100%",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",position:"relative",display:"flex",flexDirection:"column",minWidth:"0",wordWrap:"break-word",fontSize:".875rem"},cardPlain:{background:"transparent",boxShadow:"none"},cardProfile:{marginTop:"30px",textAlign:"center"},cardBlog:{marginTop:"60px"},cardRaised:{boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},cardBackground:{backgroundPosition:"center center",backgroundSize:"cover",textAlign:"center","&:after":{position:"absolute",zIndex:"1",width:"100%",height:"100%",display:"block",left:"0",top:"0",content:'""',backgroundColor:"rgba(0, 0, 0, 0.56)",borderRadius:"6px"},"& small":{color:"rgba(255, 255, 255, 0.7) !important"}},cardPricing:{textAlign:"center","&:after":{backgroundColor:"rgba(0, 0, 0, 0.7) !important"},"& ul":{listStyle:"none",padding:0,maxWidth:"240px",margin:"10px auto"},"& ul li":{color:"#999999",textAlign:"center",padding:"12px 0px",borderBottom:"1px solid rgba(153,153,153,0.3)"},"& ul li:last-child":{border:0},"& ul li b":{color:"#3c4858"},"& h1":{marginTop:"30px"},"& h1 small":{display:"inline-flex",height:0,fontSize:"18px"},"& h1 small:first-child":{position:"relative",top:"-17px",fontSize:"26px"},"& ul li svg, & ul li .fab,& ul li .fas,& ul li .far,& ul li .fal,& ul li .material-icons":{position:"relative",top:"7px"}},cardPricingColor:{"& ul li":{color:"#fff",borderColor:"rgba(255,255,255,0.3)","& b, & svg,& .fab,& .fas,& .far,& .fal,& .material-icons":{color:"#fff",fontWeight:"700"}}},cardProduct:{marginTop:"30px"},primary:{background:"linear-gradient(60deg,#ab47bc,#7b1fa2)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},info:{background:"linear-gradient(60deg,#26c6da,#0097a7)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},success:{background:"linear-gradient(60deg,#66bb6a,#388e3c)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},warning:{background:"linear-gradient(60deg,#ffa726,#f57c00)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},danger:{background:"linear-gradient(60deg,#ef5350,#d32f2f)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},rose:{background:"linear-gradient(60deg,#ec407a,#c2185b)","& h1 small":{color:"rgba(255, 255, 255, 0.8)"},color:"#FFFFFF"},cardChart:{"& p":{marginTop:"0px",paddingTop:"0px"}},cardLogin:{transform:"translate3d(0, 0, 0)",transition:"all 300ms linear"}};/* harmony default export */ __webpack_exports__["a"] = (cardStyle);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardBodyStyle={cardBody:{padding:"0.9375rem 20px",flex:"1 1 auto",WebkitBoxFlex:"1",position:"relative"},cardBodyBackground:{position:"relative",zIndex:"2",minHeight:"280px",paddingTop:"40px",paddingBottom:"40px",maxWidth:"440px",margin:"0 auto"},cardBodyPlain:{paddingLeft:"5px",paddingRight:"5px"},cardBodyFormHorizontal:{paddingLeft:"15px",paddingRight:"15px","& form":{margin:"0"}},cardPricing:{padding:"15px!important",margin:"0px!important"},cardSignup:{padding:"0px 30px 0px 30px"},cardBodyColor:{borderRadius:"6px","&":{"h1, h2, h3":{"& small":{color:"rgba(255, 255, 255, 0.8)"}}}},cardBodyProfile:{marginTop:"15px"},cardBodyCalendar:{padding:"0px !important"}};/* harmony default export */ __webpack_exports__["a"] = (cardBodyStyle);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var cardHeaderStyle={cardHeader:{padding:"0.75rem 1.25rem",marginBottom:"0",borderBottom:"none",background:"transparent",zIndex:"3 !important","&$cardHeaderPlain,&$cardHeaderImage,&$cardHeaderContact,&$cardHeaderSignup,&$cardHeaderIcon,&$cardHeaderStats,&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{margin:"0 15px",padding:"0",position:"relative",color:"#FFFFFF"},"&:first-child":{borderRadius:"calc(.25rem - 1px) calc(.25rem - 1px) 0 0"},"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{"&:not($cardHeaderIcon):not($cardHeaderImage):not($cardHeaderText)":{borderRadius:"3px",marginTop:"-20px",padding:"15px"}},"&$cardHeaderStats svg":{fontSize:"36px",lineHeight:"56px",textAlign:"center",width:"36px",height:"36px",margin:"10px 10px 4px"},"&$cardHeaderStats .fab,&$cardHeaderStats .fas,&$cardHeaderStats .far,&$cardHeaderStats .fal,&$cardHeaderStats .material-icons":{fontSize:"36px",lineHeight:"56px",width:"56px",height:"56px",textAlign:"center",overflow:"unset",marginBottom:"1px"},"&$cardHeaderStats$cardHeaderIcon":{textAlign:"right"},"&$cardHeaderImage":{marginLeft:"15px",marginRight:"15px",marginTop:"-30px",borderRadius:"6px"},"&$cardHeaderText":{display:"inline-block"}},cardHeaderPlain:{marginLeft:"0px",marginRight:"0px","&$cardHeaderImage":{margin:"0 !important"}},cardHeaderImage:{position:"relative",padding:"0",zIndex:"1","& img":{width:"100%",borderRadius:"6px",pointerEvents:"none",boxShadow:"0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"},"& a":{display:"block"}},cardHeaderContact:{margin:"0 15px",marginTop:"-20px"},cardHeaderSignup:{marginLeft:"20px",marginRight:"20px",marginTop:"-40px",padding:"20px 0",width:"100%",marginBottom:"15px"},cardHeaderStats:{"& $cardHeaderIcon":{textAlign:"right"},"& h1,& h2,& h3,& h4,& h5,& h6":{margin:"0 !important"}},cardHeaderIcon:{"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{background:"transparent",boxShadow:"none"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"33px",height:"33px",textAlign:"center",lineHeight:"33px"},"& svg":{width:"24px",height:"24px",textAlign:"center",lineHeight:"33px",margin:"5px 4px 0px"}},cardHeaderText:{},warningCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* warningCardHeader */])},successCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["y" /* successCardHeader */])},dangerCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* dangerCardHeader */])},infoCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* infoCardHeader */])},primaryCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["s" /* primaryCardHeader */])},roseCardHeader:{color:"#FFFFFF","&:not($cardHeaderText):not($cardHeaderIcon)":Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["v" /* roseCardHeader */])}};/* harmony default export */ __webpack_exports__["a"] = (cardHeaderStyle);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardFooterStyle={cardFooter:{padding:"0",paddingTop:"10px",margin:"0 15px 10px",borderRadius:"0",justifyContent:"space-between",alignItems:"center",display:"flex",backgroundColor:"transparent",border:"0"},cardFooterProfile:{marginTop:"-15px"},cardFooterPlain:{paddingLeft:"5px",paddingRight:"5px",backgroundColor:"transparent"},cardFooterPricing:{zIndex:"2"},cardFooterTestimonial:{display:"block"},cardFooterStats:{borderTop:"1px solid #eee",marginTop:"20px","& svg":{position:"relative",top:"4px",marginRight:"3px",marginLeft:"3px",width:"16px",height:"16px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{position:"relative",top:"4px",marginRight:"3px",marginLeft:"3px",fontSize:"16px",lineHeight:"16px"}},cardFooterChart:{borderTop:"1px solid #eee"}};/* harmony default export */ __webpack_exports__["a"] = (cardFooterStyle);

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// third-party

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SuccessIcon = __webpack_require__(656);

var _SuccessIcon2 = _interopRequireDefault(_SuccessIcon);

var _ErrorIcon = __webpack_require__(657);

var _ErrorIcon2 = _interopRequireDefault(_ErrorIcon);

var _InfoIcon = __webpack_require__(658);

var _InfoIcon2 = _interopRequireDefault(_InfoIcon);

var _WarningIcon = __webpack_require__(659);

var _WarningIcon2 = _interopRequireDefault(_WarningIcon);

var _CustomIcon = __webpack_require__(660);

var _CustomIcon2 = _interopRequireDefault(_CustomIcon);

var _Buttons = __webpack_require__(661);

var _Buttons2 = _interopRequireDefault(_Buttons);

var _Input = __webpack_require__(662);

var _Input2 = _interopRequireDefault(_Input);

var _ValidationMessage = __webpack_require__(663);

var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);

var _Title = __webpack_require__(664);

var _Title2 = _interopRequireDefault(_Title);

var _Content = __webpack_require__(665);

var _Content2 = _interopRequireDefault(_Content);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// components


// styles


var defaultRegex = /^.+$/;
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var style = _SweetAlertStyles2.default.sweetAlert;

if (typeof window !== 'undefined') {
  if (window && window.innerWidth && window.innerWidth < 767) {
    style = (0, _objectAssign2.default)({}, style, _SweetAlertStyles2.default.sweetAlertMobile);
  }
}

var SweetAlert = function (_React$Component) {
  _inherits(SweetAlert, _React$Component);

  function SweetAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SweetAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SweetAlert.__proto__ || Object.getPrototypeOf(SweetAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      type: 'default',
      focusConfirmBtn: true,
      inputValue: '',
      showValidationMessage: false,
      timer: null
    }, _this.setStateFromProps = function (props) {
      props = props || _this.props;
      var type = _this.getTypeFromProps(props);
      _this.setState({
        type: type,
        focusConfirmBtn: props.focusConfirmBtn && type !== 'input'
      });
    }, _this.getTypeFromProps = function (props) {
      if (props.type) return props.type;
      if (props.info) return 'info';
      if (props.success) return 'success';
      if (props.warning) return 'warning';
      if (props.danger || props.error) return 'danger';
      if (props.input) return 'input';
      if (props.custom) return 'custom';
      return _this.state.type;
    }, _this.unsupportedProp = function (oldProp, message) {
      try {
        console.warn('react-bootstrap-sweetalert: Unsupported prop \'' + oldProp + '\'. Please ' + message);
      } catch (e) {}
    }, _this.getIcon = function () {
      switch (_this.state.type) {
        case 'danger':
        case 'error':
          return _react2.default.createElement(_ErrorIcon2.default, null);
        case 'warning':
          return _react2.default.createElement(_WarningIcon2.default, null);
        case 'info':
          return _react2.default.createElement(_InfoIcon2.default, null);
        case 'success':
          return _react2.default.createElement(_SuccessIcon2.default, null);
        case 'custom':
          if (_this.props.customIcon) {
            if (typeof _this.props.customIcon == 'string') {
              return _react2.default.createElement(_CustomIcon2.default, { iconUrl: _this.props.customIcon });
            } else {
              return _this.props.customIcon;
            }
          }
      }
    }, _this.onChangeInput = function (e) {
      _this.setState({
        inputValue: e.target.value,
        showValidationMessage: false
      });
    }, _this.isValidInput = function () {
      if (!_this.props.required) {
        return true;
      }
      var regex = _this.props.validationRegex || (_this.props.inputType === 'email' ? emailRegex : defaultRegex);
      return regex.test(_this.state.inputValue);
    }, _this.onConfirm = function () {
      if (_this.state.type === 'input') {
        if (_this.isValidInput()) {
          _this.props.onConfirm(_this.state.inputValue);
        } else {
          _this.setState({
            showValidationMessage: true
          });
        }
      } else {
        _this.props.onConfirm();
      }
    }, _this.onInputKeyDown = function (e) {
      if (e.keyCode == 13) {
        if (_this.props.onConfirm) {
          _this.onConfirm();
          e.stopPropagation();
        }
      }
    }, _this.onKeyDown = function (e) {
      if (e.keyCode == 27) {
        if (_this.props.allowEscape && _this.props.onCancel) {
          _this.props.onCancel();
          e.stopPropagation();
        }
      }
    }, _this.onClickOutside = function () {
      if (_this.props.closeOnClickOutside && _this.props.onCancel) {
        _this.props.onCancel();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SweetAlert, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.inputPlaceHolder) {
        this.unsupportedProp('inputPlaceHolder', 'use props.placeholder');
      }
      if (this.props.inputValidationMsg) {
        this.unsupportedProp('inputValidationMsg', 'use props.validationMsg');
      }
      if (this.props.content) {
        this.unsupportedProp('content', 'use props.children <SweetAlert>your content</SweetAlert>');
      }
      if (this.props.defaultValue != null) {
        this.setState({
          inputValue: this.props.defaultValue
        });
      }

      this.setStateFromProps();

      this.props.beforeMount();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.afterMount();
      this.handleTimeout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.getTypeFromProps(this.props) !== this.getTypeFromProps(nextProps)) {
        this.setStateFromProps(nextProps);
        this.handleTimeout(nextProps);
      } else if (this.props.timeout !== nextProps.timeout) {
        this.handleTimeout(nextProps);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.props.beforeUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.props.afterUpdate(prevProps, prevState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.beforeUnmount();
    }
  }, {
    key: 'handleTimeout',
    value: function handleTimeout(props) {
      props = props || this.props;

      if (this.state.timer) {
        clearTimeout(this.state.timer);
      }

      if (props.timeout && props.timeout > 0) {
        var timer = setTimeout(function () {
          return props.onConfirm();
        }, props.timeout);

        this.setState({ timer: timer });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.show) {
        return false;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'style',
          { type: 'text/css', scoped: true },
          '@-webkit-keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @keyframes showSweetAlert {\n                      0% {\n                        transform: scale(0.7);\n                        -webkit-transform: scale(0.7);\n                      }\n                      45% {\n                        transform: scale(1.05);\n                        -webkit-transform: scale(1.05);\n                      }\n                      80% {\n                        transform: scale(0.95);\n                        -webkit-tranform: scale(0.95);\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                    }\n                    @-webkit-keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @keyframes hideSweetAlert {\n                      0% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                      }\n                      100% {\n                        transform: scale(0.5);\n                        -webkit-transform: scale(0.5);\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @keyframes animateSuccessTip {\n                      0% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      54% {\n                        width: 0;\n                        left: 1px;\n                        top: 19px;\n                      }\n                      70% {\n                        width: 50px;\n                        left: -8px;\n                        top: 37px;\n                      }\n                      84% {\n                        width: 17px;\n                        left: 21px;\n                        top: 48px;\n                      }\n                      100% {\n                        width: 25px;\n                        left: 14px;\n                        top: 45px;\n                      }\n                    }\n                    @-webkit-keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @keyframes animateSuccessLong {\n                      0% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      65% {\n                        width: 0;\n                        right: 46px;\n                        top: 54px;\n                      }\n                      84% {\n                        width: 55px;\n                        right: 0px;\n                        top: 35px;\n                      }\n                      100% {\n                        width: 47px;\n                        right: 8px;\n                        top: 38px;\n                      }\n                    }\n                    @-webkit-keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @keyframes rotatePlaceholder {\n                      0% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      5% {\n                        transform: rotate(-45deg);\n                        -webkit-transform: rotate(-45deg);\n                      }\n                      12% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                      100% {\n                        transform: rotate(-405deg);\n                        -webkit-transform: rotate(-405deg);\n                      }\n                    }\n                    @-webkit-keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateErrorIcon {\n                      0% {\n                        transform: rotateX(100deg);\n                        -webkit-transform: rotateX(100deg);\n                        opacity: 0;\n                      }\n                      100% {\n                        transform: rotateX(0deg);\n                        -webkit-transform: rotateX(0deg);\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @keyframes animateXMark {\n                      0% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      50% {\n                        transform: scale(0.4);\n                        -webkit-transform: scale(0.4);\n                        margin-top: 26px;\n                        opacity: 0;\n                      }\n                      80% {\n                        transform: scale(1.15);\n                        -webkit-transform: scale(1.15);\n                        margin-top: -6px;\n                      }\n                      100% {\n                        transform: scale(1);\n                        -webkit-transform: scale(1);\n                        margin-top: 0;\n                        opacity: 1;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarning {\n                      0% {\n                        border-color: #F8D486;\n                      }\n                      100% {\n                        border-color: #F8BB86;\n                      }\n                    }\n                    @-webkit-keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }\n                    @keyframes pulseWarningIns {\n                      0% {\n                        background-color: #F8D486;\n                      }\n                      100% {\n                        background-color: #F8BB86;\n                      }\n                    }'
        ),
        !this.props.hideOverlay && _react2.default.createElement('div', { style: _SweetAlertStyles2.default.overlay, onClick: this.onClickOutside }),
        _react2.default.createElement(
          'div',
          {
            style: (0, _objectAssign2.default)({}, style, this.props.style),
            tabIndex: '0',
            ref: 'container',
            onKeyDown: this.onKeyDown,
            className: 'sweet-alert ' + this.props.customClass
          },
          this.getIcon(),
          _react2.default.createElement(
            _Title2.default,
            null,
            this.props.title
          ),
          _react2.default.createElement(
            _Content2.default,
            null,
            this.props.children
          ),
          this.state.type === 'input' && _react2.default.createElement(_Input2.default, _extends({}, this.props, this.state, {
            type: this.state.type,
            onInputKeyDown: this.onInputKeyDown,
            onChangeInput: this.onChangeInput
          })),
          this.state.showValidationMessage && _react2.default.createElement(_ValidationMessage2.default, this.props),
          _react2.default.createElement(_Buttons2.default, _extends({}, this.props, {
            type: this.state.type,
            onConfirm: this.onConfirm,
            focusConfirmBtn: this.state.focusConfirmBtn
          }))
        )
      );
    }
  }]);

  return SweetAlert;
}(_react2.default.Component);

SweetAlert.propTypes = {
  type: _propTypes2.default.oneOf(['default', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom']),
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
  onCancel: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func.isRequired,
  confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  confirmBtnCssClass: _propTypes2.default.string,
  confirmBtnStyle: _propTypes2.default.object,
  cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
  cancelBtnCssClass: _propTypes2.default.string,
  cancelBtnStyle: _propTypes2.default.object,
  btnSize: _propTypes2.default.string,
  customIcon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  show: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  validationMsg: _propTypes2.default.string,
  validationRegex: _propTypes2.default.object,
  defaultValue: _propTypes2.default.string,
  inputType: _propTypes2.default.string,
  style: _propTypes2.default.object,
  customClass: _propTypes2.default.string,
  showConfirm: _propTypes2.default.bool,
  showCancel: _propTypes2.default.bool,
  allowEscape: _propTypes2.default.bool,
  closeOnClickOutside: _propTypes2.default.bool,
  hideOverlay: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusConfirmBtn: _propTypes2.default.bool,
  beforeMount: _propTypes2.default.func,
  afterMount: _propTypes2.default.func,
  beforeUpdate: _propTypes2.default.func,
  afterUpdate: _propTypes2.default.func,
  beforeUnmount: _propTypes2.default.func,
  timeout: _propTypes2.default.number
};
SweetAlert.defaultProps = {
  allowEscape: true,
  closeOnClickOutside: true,
  validationMsg: null,
  validationRegex: null,
  inputType: 'text',
  customClass: '',
  hideOverlay: false,
  show: true,
  required: true,
  disabled: false,
  focusConfirmBtn: true,
  beforeMount: function beforeMount() {},
  afterMount: function afterMount() {},
  beforeUpdate: function beforeUpdate() {},
  afterUpdate: function afterUpdate() {},
  beforeUnmount: function beforeUnmount() {},
  timeout: 0
};
SweetAlert.SuccessIcon = _SuccessIcon2.default;
SweetAlert.ErrorIcon = _ErrorIcon2.default;
SweetAlert.InfoIcon = _InfoIcon2.default;
SweetAlert.WarningIcon = _WarningIcon2.default;
SweetAlert.CustomIcon = _CustomIcon2.default;
SweetAlert.Buttons = _Buttons2.default;
SweetAlert.Input = _Input2.default;
SweetAlert.ValidationMessage = _ValidationMessage2.default;
SweetAlert.Title = _Title2.default;
SweetAlert.Content = _Content2.default;
exports.default = SweetAlert;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return _react2.default.createElement(
        'div',
        { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconSuccess) },
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessBefore) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineTip) }),
        _react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessLine, _SweetAlertStyles2.default.iconSuccessLineLong) }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessPlaceholder }),
        _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconSuccessFix }),
        _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconSuccessBeforeAfter, _SweetAlertStyles2.default.iconSuccessAfter) })
    );
};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconError) },
		_react2.default.createElement(
			'span',
			{ style: _SweetAlertStyles2.default.iconErrorX },
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineLeft) }),
			_react2.default.createElement('span', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.iconErrorLine, _SweetAlertStyles2.default.iconErrorLineRight) })
		)
	);
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
       return _react2.default.createElement(
              'div',
              { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconInfo) },
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoBefore }),
              _react2.default.createElement('div', { style: _SweetAlertStyles2.default.iconInfoAfter })
       );
};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	return _react2.default.createElement(
		'div',
		{ style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconWarning) },
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningBody }),
		_react2.default.createElement('span', { style: _SweetAlertStyles2.default.iconWarningDot })
	);
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.icon, _SweetAlertStyles2.default.iconCustom);

exports.default = function (_ref) {
    var iconUrl = _ref.iconUrl;
    return _react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, style, { backgroundImage: 'url(' + iconUrl + ')' }) });
};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Buttons = function (_React$Component) {
    _inherits(Buttons, _React$Component);

    function Buttons() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Buttons);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call.apply(_ref, [this].concat(args))), _this), _this.buttonStyles = {}, _this.getButtonStyle = function (bsStyle) {
            if (bsStyle === 'error') bsStyle = 'danger';
            if (_this.buttonStyles[bsStyle] == null) {
                var style = Buttons.styles[bsStyle] || Buttons.styles.default;
                var borderColor = 'borderColor: ' + style.borderColor + ' !important';
                var boxShadow = 'boxShadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px ' + style.shadowColor + ' !important;';
                _this.buttonStyles[bsStyle] = ' ' + borderColor + ' ' + boxShadow;
            }
            return _this.buttonStyles[bsStyle];
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Buttons, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.focusButton();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            // when displaying back to back alerts React will treat this
            // as an update to the same alert. this causes componentDidMount
            // to not be called for the subsequent alerts. i hope to find a better
            // way to handle this in the future, but for now i'm checking if the
            // title, type, or button text has changed
            if (prevProps.type !== this.props.type || prevProps.confirmBtnText !== this.props.confirmBtnText || prevProps.title !== this.props.title) {
                setTimeout(function () {
                    return _this2.focusButton();
                }, 0);
            }
        }
    }, {
        key: 'focusButton',
        value: function focusButton() {
            if (this.props.focusConfirmBtn && this.refs.confirmBtn) {
                try {
                    this.refs.confirmBtn.focus();
                } catch (e) {
                    // whoops
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.showConfirm && !this.props.showCancel) {
                return false;
            }
            var cancelBtnBsStyle = this.props.cancelBtnBsStyle === 'error' ? 'danger' : this.props.cancelBtnBsStyle;
            var confirmBtnBsStyle = this.props.confirmBtnBsStyle === 'error' ? 'danger' : this.props.confirmBtnBsStyle;
            return _react2.default.createElement(
                'p',
                { style: { marginTop: 20 } },
                this.props.showCancel && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(cancelBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.cancelBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + cancelBtnBsStyle + ' ' + this.props.cancelBtnCssClass,
                            onClick: this.props.onCancel,
                            type: 'button' },
                        this.props.cancelBtnText
                    )
                ),
                this.props.showConfirm && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'style',
                        { type: 'text/css', scoped: true },
                        'button { outline: 0 !important; ' + this.getButtonStyle(confirmBtnBsStyle) + '}'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            ref: 'confirmBtn',
                            disabled: this.props.disabled,
                            style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.button, this.props.confirmBtnStyle),
                            className: 'btn btn-' + this.props.btnSize + ' btn-' + confirmBtnBsStyle + ' ' + this.props.confirmBtnCssClass,
                            onClick: this.props.onConfirm,
                            type: 'button' },
                        this.props.confirmBtnText
                    )
                )
            );
        }
    }]);

    return Buttons;
}(_react2.default.Component);

Buttons.propTypes = {
    confirmBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    confirmBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    confirmBtnCssClass: _propTypes2.default.string,
    confirmBtnStyle: _propTypes2.default.object,
    cancelBtnText: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    cancelBtnBsStyle: _propTypes2.default.oneOf(['default', 'primary', 'link', 'info', 'success', 'warning', 'danger']),
    cancelBtnCssClass: _propTypes2.default.string,
    cancelBtnStyle: _propTypes2.default.object,
    btnSize: _propTypes2.default.string,
    onCancel: _propTypes2.default.func,
    onConfirm: _propTypes2.default.func,
    showConfirm: _propTypes2.default.bool,
    showCancel: _propTypes2.default.bool,
    focusConfirmBtn: _propTypes2.default.bool
};
Buttons.defaultProps = {
    confirmBtnText: 'OK',
    confirmBtnBsStyle: 'primary',
    confirmBtnCssClass: '',
    confirmBtnStyle: {},
    cancelBtnText: 'Cancel',
    cancelBtnBsStyle: 'link',
    cancelBtnCssClass: '',
    cancelBtnStyle: {},
    focusConfirmBtn: true,
    showConfirm: true,
    showCancel: false,
    btnSize: 'lg'
};
Buttons.styles = {
    primary: {
        borderColor: '#286090',
        shadowColor: 'rgb(165, 202, 234)'
    },
    success: {
        borderColor: '#4cae4c',
        shadowColor: 'rgba(76, 174, 76, 0.6)'
    },
    info: {
        borderColor: '#46b8da',
        shadowColor: 'rgba(70, 184, 218, 0.6)'
    },
    danger: {
        borderColor: '#d43f3a',
        shadowColor: 'rgba(212, 63, 58, 0.6)'
    },
    warning: {
        borderColor: '#eea236',
        shadowColor: 'rgba(238, 162, 54, 0.6)'
    },
    default: {
        borderColor: '#cccccc',
        shadowColor: 'rgba(204, 204, 204, 0.6)'
    }
};
exports.default = Buttons;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(42);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
	_inherits(Input, _React$Component);

	function Input() {
		_classCallCheck(this, Input);

		return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	}

	_createClass(Input, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.type === 'input') {
				try {
					this.refs.input.focus();
				} catch (e) {
					// whoops
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ style: { position: 'relative' } },
				this.props.inputType === 'textarea' ? _react2.default.createElement('textarea', {
					ref: 'input',
					rows: 4,
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }) : _react2.default.createElement('input', {
					type: this.props.inputType,
					ref: 'input',
					className: 'form-control',
					value: this.props.inputValue || '',
					onChange: this.props.onChangeInput,
					onKeyDown: this.props.onInputKeyDown,
					placeholder: this.props.placeholder }),
				this.props.showValidationMessage && _react2.default.createElement(
					'div',
					{ style: _SweetAlertStyles2.default.inputErrorIcon },
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconBefore) }),
					_react2.default.createElement('div', { style: (0, _objectAssign2.default)({}, _SweetAlertStyles2.default.inputErrorIconBeforeAfter, _SweetAlertStyles2.default.inputErrorIconAfter) })
				)
			);
		}
	}]);

	return Input;
}(_react2.default.Component);

exports.default = Input;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SweetAlertStyles = __webpack_require__(58);

var _SweetAlertStyles2 = _interopRequireDefault(_SweetAlertStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMessage = 'Please enter a response!';
var emailMessage = 'Please enter a valid email!';

exports.default = function (_ref) {
    var validationMsg = _ref.validationMsg,
        inputType = _ref.inputType;

    var message = validationMsg || (inputType === 'email' ? emailMessage : defaultMessage);

    return _react2.default.createElement(
        'div',
        { style: _SweetAlertStyles2.default.validationMessage },
        _react2.default.createElement(
            'div',
            { style: _SweetAlertStyles2.default.exclamationIcon },
            '!'
        ),
        message
    );
};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'h2',
    null,
    children
  );
};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'text-muted lead' },
        children
    );
};

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill_lib_polyfill__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_promise_polyfill_lib_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_promise_polyfill_lib_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_starts_with__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_fn_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_repeat__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_fn_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_symbol__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_fn_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_fn_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_fn_symbol_iterator__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_fn_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_fn_symbol_iterator__);










/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),
/* 667 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, global) {

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = Promise;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(669).setImmediate, __webpack_require__(41)))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(670);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41), __webpack_require__(347)))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(672);
module.exports = __webpack_require__(60).Array.find;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(78);
var $find = __webpack_require__(351)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(229)(KEY);


/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(675);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var isArray = __webpack_require__(352);
var SPECIES = __webpack_require__(43)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(677);
module.exports = __webpack_require__(60).Array.findIndex;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(78);
var $find = __webpack_require__(351)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(229)(KEY);


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(679);
module.exports = __webpack_require__(60).Object.assign;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(78);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(680) });


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(133);
var gOPS = __webpack_require__(232);
var pIE = __webpack_require__(168);
var toObject = __webpack_require__(226);
var IObject = __webpack_require__(225);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(129)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(99);
var toLength = __webpack_require__(227);
var toAbsoluteIndex = __webpack_require__(682);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(167);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(684);
module.exports = __webpack_require__(60).String.startsWith;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(78);
var toLength = __webpack_require__(227);
var context = __webpack_require__(685);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(687)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(686);
var defined = __webpack_require__(132);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(80);
var cof = __webpack_require__(166);
var MATCH = __webpack_require__(43)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(43)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(689);
module.exports = __webpack_require__(60).String.repeat;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(78);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(690)
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(167);
var defined = __webpack_require__(132);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(692);
__webpack_require__(699);
__webpack_require__(701);
__webpack_require__(702);
module.exports = __webpack_require__(60).Symbol;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(59);
var has = __webpack_require__(81);
var DESCRIPTORS = __webpack_require__(98);
var $export = __webpack_require__(78);
var redefine = __webpack_require__(130);
var META = __webpack_require__(693).KEY;
var $fails = __webpack_require__(129);
var shared = __webpack_require__(228);
var setToStringTag = __webpack_require__(233);
var uid = __webpack_require__(131);
var wks = __webpack_require__(43);
var wksExt = __webpack_require__(234);
var wksDefine = __webpack_require__(235);
var enumKeys = __webpack_require__(694);
var isArray = __webpack_require__(352);
var anObject = __webpack_require__(164);
var isObject = __webpack_require__(80);
var toIObject = __webpack_require__(99);
var toPrimitive = __webpack_require__(224);
var createDesc = __webpack_require__(165);
var _create = __webpack_require__(354);
var gOPNExt = __webpack_require__(697);
var $GOPD = __webpack_require__(698);
var $DP = __webpack_require__(97);
var $keys = __webpack_require__(133);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(355).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(168).f = $propertyIsEnumerable;
  __webpack_require__(232).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(236)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(79)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(131)('meta');
var isObject = __webpack_require__(80);
var has = __webpack_require__(81);
var setDesc = __webpack_require__(97).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(129)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(133);
var gOPS = __webpack_require__(232);
var pIE = __webpack_require__(168);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(97);
var anObject = __webpack_require__(164);
var getKeys = __webpack_require__(133);

module.exports = __webpack_require__(98) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(59).document;
module.exports = document && document.documentElement;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(99);
var gOPN = __webpack_require__(355).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(168);
var createDesc = __webpack_require__(165);
var toIObject = __webpack_require__(99);
var toPrimitive = __webpack_require__(224);
var has = __webpack_require__(81);
var IE8_DOM_DEFINE = __webpack_require__(348);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(98) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(700);
var test = {};
test[__webpack_require__(43)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(130)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(166);
var TAG = __webpack_require__(43)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235)('asyncIterator');


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235)('observable');


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(704);
__webpack_require__(708);
module.exports = __webpack_require__(234).f('iterator');


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(705)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(356)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(167);
var defined = __webpack_require__(132);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(354);
var descriptor = __webpack_require__(165);
var setToStringTag = __webpack_require__(233);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(79)(IteratorPrototype, __webpack_require__(43)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(81);
var toObject = __webpack_require__(226);
var IE_PROTO = __webpack_require__(230)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(709);
var getKeys = __webpack_require__(133);
var redefine = __webpack_require__(130);
var global = __webpack_require__(59);
var hide = __webpack_require__(79);
var Iterators = __webpack_require__(237);
var wks = __webpack_require__(43);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(229);
var step = __webpack_require__(710);
var Iterators = __webpack_require__(237);
var toIObject = __webpack_require__(99);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(356)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
(function() {var g,aa=aa||{},k=this;function l(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
function ma(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=ma;return r.apply(null,arguments)}
function na(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var oa=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.ob=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.ed=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function pa(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function qa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function ra(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}t(ra,u);ra.prototype.name="AssertionError";function sa(a,b){throw new ra("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function ta(a,b){this.c=a;this.f=b;this.b=0;this.a=null}ta.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function ua(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function va(){this.b=this.a=null}var xa=new ta(function(){return new wa},function(a){a.reset()});va.prototype.add=function(a,b){var c=xa.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function ya(){var a=za,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function wa(){this.next=this.b=this.a=null}wa.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};wa.prototype.reset=function(){this.next=this.b=this.a=null};var Aa=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},v=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
function Ba(a,b){var c=a.length,d=l(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}
var Ca=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=l(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Da=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
function Ea(a){a:{var b=Fa;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function Ga(a,b){return 0<=Aa(a,b)}function Ha(a,b){b=Aa(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function w(a,b){var c=0;Ba(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ia(a){return Array.prototype.concat.apply([],arguments)}
function Ja(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Ka(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var La=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};
function Ma(a){if(!Na.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(Oa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(Pa,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(Qa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(Ra,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(Sa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(Ta,"&#0;"));return a}var Oa=/&/g,Pa=/</g,Qa=/>/g,Ra=/"/g,Sa=/'/g,Ta=/\x00/g,Na=/[\x00&<>"']/;function y(a,b){return-1!=a.indexOf(b)}function Ua(a,b){return a<b?-1:a>b?1:0};var Va;a:{var Wa=k.navigator;if(Wa){var Xa=Wa.userAgent;if(Xa){Va=Xa;break a}}Va=""}function z(a){return y(Va,a)};function Ya(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Za(a){for(var b in a)return!1;return!0}function $a(a){var b={},c;for(c in a)b[c]=a[c];return b}var ab="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function bb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<ab.length;f++)c=ab[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function cb(a){k.setTimeout(function(){throw a;},0)}var db;
function eb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!z("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!z("Trident")&&!z("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.wb;c.wb=null;a()}};return function(a){d.next={wb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function fb(a,b){hb||ib();jb||(hb(),jb=!0);za.add(a,b)}var hb;function ib(){if(k.Promise&&k.Promise.resolve){var a=k.Promise.resolve(void 0);hb=function(){a.then(kb)}}else hb=function(){var a=kb;!n(k.setImmediate)||k.Window&&k.Window.prototype&&!z("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(db||(db=eb()),db(a)):k.setImmediate(a)}}var jb=!1,za=new va;function kb(){for(var a;a=ya();){try{a.a.call(a.b)}catch(b){cb(b)}ua(xa,a)}jb=!1};function A(a,b){this.a=lb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){mb(c,nb,a)},function(a){if(!(a instanceof ob))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}mb(c,pb,a)})}catch(d){mb(this,pb,d)}}var lb=0,nb=2,pb=3;function qb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}qb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var rb=new ta(function(){return new qb},function(a){a.reset()});
function sb(a,b,c){var d=rb.get();d.g=a;d.b=b;d.f=c;return d}function B(a){if(a instanceof A)return a;var b=new A(ca);mb(b,nb,a);return b}function C(a){return new A(function(b,c){c(a)})}function tb(a,b,c){ub(a,b,c,null)||fb(na(b,a))}function vb(a){return new A(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},h=function(a){c(a)},m=0,p;m<a.length;m++)p=a[m],tb(p,na(f,m),h);else b(e)})}
function wb(a){return new A(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Db:!0,value:f}:{Db:!1,reason:f};0==c&&b(d)},f=0,h;f<a.length;f++)h=a[f],tb(h,na(e,f,!0),na(e,f,!1));else b(d)})}A.prototype.then=function(a,b,c){return xb(this,n(a)?a:null,n(b)?b:null,c)};pa(A);g=A.prototype;g.ia=function(a,b){a=sb(a,a,b);a.c=!0;yb(this,a);return this};g.s=function(a,b){return xb(this,null,a,b)};g.cancel=function(a){this.a==lb&&fb(function(){var b=new ob(a);zb(this,b)},this)};
function zb(a,b){if(a.a==lb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,h=c.b;h&&(h.c||(d++,h.a==a&&(e=h),!(e&&1<d)));h=h.next)e||(f=h);e&&(c.a==lb&&1==d?zb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Ab(c),Bb(c,e,pb,b)))}a.c=null}else mb(a,pb,b)}function yb(a,b){a.b||a.a!=nb&&a.a!=pb||Cb(a);a.f?a.f.next=b:a.b=b;a.f=b}
function xb(a,b,c,d){var e=sb(null,null,null);e.a=new A(function(a,h){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(x){h(x)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof ob?h(b):a(e)}catch(x){h(x)}}:h});e.a.c=a;yb(a,e);return e.a}g.Nc=function(a){this.a=lb;mb(this,nb,a)};g.Oc=function(a){this.a=lb;mb(this,pb,a)};
function mb(a,b,c){a.a==lb&&(a===c&&(b=pb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,ub(c,a.Nc,a.Oc,a)||(a.i=c,a.a=b,a.c=null,Cb(a),b!=pb||c instanceof ob||Db(a,c)))}function ub(a,b,c,d){if(a instanceof A)return yb(a,sb(b||ca,c||null,d)),!0;if(qa(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(n(e))return Eb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Eb(a,b,c,d,e){function f(a){m||(m=!0,d.call(e,a))}function h(a){m||(m=!0,c.call(e,a))}var m=!1;try{b.call(a,h,f)}catch(p){f(p)}}function Cb(a){a.h||(a.h=!0,fb(a.Yb,a))}function Ab(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}g.Yb=function(){for(var a;a=Ab(this);)Bb(this,a,this.a,this.i);this.h=!1};
function Bb(a,b,c,d){if(c==pb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Fb(b,c,d);else try{b.c?b.g.call(b.f):Fb(b,c,d)}catch(e){Gb.call(null,e)}ua(rb,b)}function Fb(a,b,c){b==nb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Db(a,b){a.g=!0;fb(function(){a.g&&Gb.call(null,b)})}var Gb=cb;function ob(a){u.call(this,a)}t(ob,u);ob.prototype.name="cancel";function Hb(){0!=Ib&&(Jb[this[ia]||(this[ia]=++ja)]=this);this.qa=this.qa;this.ja=this.ja}var Ib=0,Jb={};Hb.prototype.qa=!1;function Kb(a){if(!a.qa&&(a.qa=!0,a.va(),0!=Ib)){var b=a[ia]||(a[ia]=++ja);if(0!=Ib&&a.ja&&0<a.ja.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Jb[b]}}Hb.prototype.va=function(){if(this.ja)for(;this.ja.length;)this.ja.shift()()};function Lb(a){Lb[" "](a);return a}Lb[" "]=ca;function Mb(a,b){var c=Nb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Ob=z("Opera"),Pb=z("Trident")||z("MSIE"),Qb=z("Edge"),Rb=Qb||Pb,Sb=z("Gecko")&&!(y(Va.toLowerCase(),"webkit")&&!z("Edge"))&&!(z("Trident")||z("MSIE"))&&!z("Edge"),Tb=y(Va.toLowerCase(),"webkit")&&!z("Edge");function Ub(){var a=k.document;return a?a.documentMode:void 0}var Vb;
a:{var Wb="",Xb=function(){var a=Va;if(Sb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Qb)return/Edge\/([\d\.]+)/.exec(a);if(Pb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Tb)return/WebKit\/(\S+)/.exec(a);if(Ob)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Xb&&(Wb=Xb?Xb[1]:"");if(Pb){var Yb=Ub();if(null!=Yb&&Yb>parseFloat(Wb)){Vb=String(Yb);break a}}Vb=Wb}var Nb={};
function Zb(a){return Mb(a,function(){for(var b=0,c=La(String(Vb)).split("."),d=La(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=Ua(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||Ua(0==h[2].length,0==m[2].length)||Ua(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var $b;var ac=k.document;
$b=ac&&Pb?Ub()||("CSS1Compat"==ac.compatMode?parseInt(Vb,10):5):void 0;var bc=Object.freeze||function(a){return a};var cc=!Pb||9<=Number($b),dc=Pb&&!Zb("9"),ec=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function D(a,b){this.type=a;this.b=this.target=b;this.Kb=!0}D.prototype.preventDefault=function(){this.Kb=!1};function fc(a,b){D.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Sb){a:{try{Lb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:gc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(fc,D);var gc=bc({2:"touch",3:"pen",4:"mouse"});fc.prototype.preventDefault=function(){fc.ob.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,dc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};fc.prototype.f=function(){return this.a};var hc="closure_listenable_"+(1E6*Math.random()|0),ic=0;function jc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++ic;this.oa=this.Ia=!1}function kc(a){a.oa=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null};function lc(a){this.src=a;this.a={};this.b=0}lc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=mc(a,b,d,e);-1<h?(b=a[h],c||(b.Ia=!1)):(b=new jc(b,this.src,f,!!d,e),b.Ia=c,a.push(b));return b};function nc(a,b){var c=b.type;c in a.a&&Ha(a.a[c],b)&&(kc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function mc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.oa&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var oc="closure_lm_"+(1E6*Math.random()|0),pc={},qc=0;function rc(a,b,c,d,e){if(d&&d.once)sc(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)rc(a,b[f],c,d,e);else c=tc(c),a&&a[hc]?uc(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!1,d,e)}
function vc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=q(e)?!!e.capture:!!e,m=wc(a);m||(a[oc]=m=new lc(a));c=m.add(b,c,d,h,f);if(!c.proxy){d=xc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)ec||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(yc(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");qc++}}
function xc(){var a=zc,b=cc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function sc(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)sc(a,b[f],c,d,e);else c=tc(c),a&&a[hc]?Ac(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!0,d,e)}
function E(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)E(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=tc(c),a&&a[hc])?(a=a.l,b=String(b).toString(),b in a.a&&(f=a.a[b],c=mc(f,c,d,e),-1<c&&(kc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=wc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=mc(b,c,d,e)),(c=-1<a?b[a]:null)&&Bc(c))}
function Bc(a){if("number"!=typeof a&&a&&!a.oa){var b=a.src;if(b&&b[hc])nc(b.l,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(yc(c),d):b.addListener&&b.removeListener&&b.removeListener(d);qc--;(c=wc(b))?(nc(c,a),0==c.b&&(c.src=null,b[oc]=null)):kc(a)}}}function yc(a){return a in pc?pc[a]:pc[a]="on"+a}
function Cc(a,b,c,d){var e=!0;if(a=wc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.oa&&(f=Dc(f,d),e=e&&!1!==f)}return e}function Dc(a,b){var c=a.listener,d=a.La||a.src;a.Ia&&Bc(a);return c.call(d,b)}
function zc(a,b){if(a.oa)return!0;if(!cc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new fc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Cc(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Cc(d[e],a,!1,b),c=c&&f}return c}return Dc(a,
new fc(b,this))}function wc(a){a=a[oc];return a instanceof lc?a:null}var Ec="__closure_events_fn_"+(1E9*Math.random()>>>0);function tc(a){if(n(a))return a;a[Ec]||(a[Ec]=function(b){return a.handleEvent(b)});return a[Ec]};function F(){Hb.call(this);this.l=new lc(this);this.Rb=this;this.Va=null}t(F,Hb);F.prototype[hc]=!0;F.prototype.addEventListener=function(a,b,c,d){rc(this,a,b,c,d)};F.prototype.removeEventListener=function(a,b,c,d){E(this,a,b,c,d)};
F.prototype.dispatchEvent=function(a){var b,c=this.Va;if(c)for(b=[];c;c=c.Va)b.push(c);c=this.Rb;var d=a.type||a;if(l(a))a=new D(a,c);else if(a instanceof D)a.target=a.target||c;else{var e=a;a=new D(d,c);bb(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.b=b[f];e=Fc(h,d,!0,a)&&e}h=a.b=c;e=Fc(h,d,!0,a)&&e;e=Fc(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.b=b[f],e=Fc(h,d,!1,a)&&e;return e};
F.prototype.va=function(){F.ob.va.call(this);if(this.l){var a=this.l,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,kc(d[e]);delete a.a[c];a.b--}}this.Va=null};function uc(a,b,c,d,e){a.l.add(String(b),c,!1,d,e)}function Ac(a,b,c,d,e){a.l.add(String(b),c,!0,d,e)}
function Fc(a,b,c,d){b=a.l.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.oa&&h.capture==c){var m=h.listener,p=h.La||h.src;h.Ia&&nc(a.l,h);e=!1!==m.call(p,d)&&e}}return e&&0!=d.Kb};function Gc(a,b,c){if(n(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Hc(a){var b=null;return(new A(function(c,d){b=Gc(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function Ic(a){if(a.S&&"function"==typeof a.S)return a.S();if(l(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Jc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(ha(a)||l(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function Kc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||l(a))v(a,b,void 0);else for(var c=Jc(a),d=Ic(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Lc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Lc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}g=Lc.prototype;g.S=function(){Mc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.U=function(){Mc(this);return this.a.concat()};
g.clear=function(){this.b={};this.c=this.a.length=0};function Mc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Nc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Nc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return Nc(this.b,a)?this.b[a]:b};g.set=function(a,b){Nc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
g.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Nc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Oc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Pc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Qc(a,b){this.b=this.l=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof Qc){this.f=void 0!==b?b:a.f;Rc(this,a.c);this.l=a.l;this.b=a.b;Sc(this,a.i);this.g=a.g;b=a.a;var c=new Tc;c.c=b.c;b.a&&(c.a=new Lc(b.a),c.b=b.b);Uc(this,c);this.h=a.h}else a&&(c=String(a).match(Oc))?(this.f=!!b,Rc(this,c[1]||"",!0),this.l=Vc(c[2]||""),this.b=Vc(c[3]||"",!0),Sc(this,c[4]),this.g=Vc(c[5]||"",!0),Uc(this,c[6]||"",!0),this.h=Vc(c[7]||"")):(this.f=!!b,this.a=new Tc(null,this.f))}
Qc.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Wc(b,Xc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(Wc(b,Xc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Wc(c,"/"==c.charAt(0)?Yc:Zc,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Wc(c,$c));return a.join("")};
function Rc(a,b,c){a.c=c?Vc(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Sc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function Uc(a,b,c){b instanceof Tc?(a.a=b,ad(a.a,a.f)):(c||(b=Wc(b,bd)),a.a=new Tc(b,a.f))}function G(a,b,c){a.a.set(b,c)}function cd(a,b){return a.a.get(b)}function dd(a){return a instanceof Qc?new Qc(a):new Qc(a,void 0)}function ed(a,b){var c=new Qc(null,void 0);Rc(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
function Vc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Wc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,fd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function fd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Xc=/[#\/\?@]/g,Zc=/[#\?:]/g,Yc=/[#\?]/g,bd=/[#\?@]/g,$c=/#/g;function Tc(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}
function gd(a){a.a||(a.a=new Lc,a.b=0,a.c&&Pc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function hd(a){var b=Jc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Tc(null,void 0);a=Ic(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?id(c,e,f):c.add(e,f)}return c}g=Tc.prototype;g.add=function(a,b){gd(this);this.c=null;a=jd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};
function kd(a,b){gd(a);b=jd(a,b);Nc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Nc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Mc(a)))}g.clear=function(){this.a=this.c=null;this.b=0};function ld(a,b){gd(a);b=jd(a,b);return Nc(a.a.b,b)}g.forEach=function(a,b){gd(this);this.a.forEach(function(c,d){v(c,function(c){a.call(b,c,d,this)},this)},this)};g.U=function(){gd(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
g.S=function(a){gd(this);var b=[];if(l(a))ld(this,a)&&(b=Ia(b,this.a.get(jd(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Ia(b,a[c])}return b};g.set=function(a,b){gd(this);this.c=null;a=jd(this,a);ld(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.S(a):[];return 0<a.length?String(a[0]):b};function id(a,b,c){kd(a,b);0<c.length&&(a.c=null,a.a.set(jd(a,b),Ja(c)),a.b+=c.length)}
g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function jd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function ad(a,b){b&&!a.f&&(gd(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(kd(this,b),id(this,c,a))},a));a.f=b};var md=!Pb||9<=Number($b);function nd(){this.a="";this.b=od}nd.prototype.na=!0;nd.prototype.ma=function(){return this.a};nd.prototype.toString=function(){return"Const{"+this.a+"}"};function pd(a){if(a instanceof nd&&a.constructor===nd&&a.b===od)return a.a;sa("expected object of type Const, got '"+a+"'");return"type_error:Const"}var od={};function qd(a){var b=new nd;b.a=a;return b}qd("");function rd(){this.a="";this.b=sd}rd.prototype.na=!0;rd.prototype.ma=function(){return this.a};rd.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function td(a){if(a instanceof rd&&a.constructor===rd&&a.b===sd)return a.a;sa("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}
function ud(a,b){var c=pd(a);if(!vd.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(wd,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof nd?pd(a):encodeURIComponent(String(a))});return xd(a)}var wd=/%{(\w+)}/g,vd=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank#/i,sd={};
function xd(a){var b=new rd;b.a=a;return b};function yd(){this.a="";this.b=zd}yd.prototype.na=!0;yd.prototype.ma=function(){return this.a};yd.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Ad(a){if(a instanceof yd&&a.constructor===yd&&a.b===zd)return a.a;sa("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var Bd=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function Cd(a){if(a instanceof yd)return a;a=a.na?a.ma():String(a);Bd.test(a)||(a="about:invalid#zClosurez");return Dd(a)}var zd={};function Dd(a){var b=new yd;b.a=a;return b}Dd("about:blank");function Ed(){this.a="";this.b=Fd}Ed.prototype.na=!0;Ed.prototype.ma=function(){return this.a};Ed.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Gd(a){if(a instanceof Ed&&a.constructor===Ed&&a.b===Fd)return a.a;sa("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var Fd={};function Hd(a){var b=new Ed;b.a=a;return b}Hd("<!DOCTYPE html>");Hd("");Hd("<br>");function Id(a){var b=document;return l(a)?b.getElementById(a):a}function Jd(a,b){Ya(b,function(b,d){b&&b.na&&(b=b.ma());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Kd.hasOwnProperty(d)?a.setAttribute(Kd[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
var Kd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function Ld(a,b,c){var d=arguments,e=document,f=String(d[0]),h=d[1];if(!md&&h&&(h.name||h.type)){f=["<",f];h.name&&f.push(' name="',Ma(h.name),'"');if(h.type){f.push(' type="',Ma(h.type),'"');var m={};bb(m,h);delete m.type;h=m}f.push(">");f=f.join("")}f=e.createElement(f);h&&(l(h)?f.className=h:fa(h)?f.className=h.join(" "):Jd(f,h));2<d.length&&Md(e,f,d);return f}
function Md(a,b,c){function d(c){c&&b.appendChild(l(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):v(Nd(f)?Ja(f):f,d)}}function Nd(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(n(a))return"function"==typeof a.item}return!1};function Od(a){var b=[];Pd(new Qd,a,b);return b.join("")}function Qd(){}
function Pd(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Pd(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Rd(d,c),c.push(":"),Pd(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Rd(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Sd={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Td=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function Rd(a,b){b.push('"',a.replace(Td,function(a){var b=Sd[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Sd[a]=b);return b}),'"')};function Ud(){var a=H();return Pb&&!!$b&&11==$b||/Edge\/\d+/.test(a)}function Vd(){return k.window&&k.window.location.href||self&&self.location&&self.location.href||""}function Wd(a,b){b=b||k.window;var c="about:blank";a&&(c=Ad(Cd(a)));b.location.href=c}function Xd(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Xd(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function Yd(){var a=H();a=Zd(a)!=$d?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Pb||!$b||9<$b}function ae(a){a=(a||H()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function be(a){a=a||k.window;try{a.close()}catch(b){}}
function ce(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=H().toLowerCase();d&&(b.target=d,y(c,"crios/")&&(b.target="_blank"));Zd(H())==de&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof yd?c:Cd("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
for(h in a)switch(h){case "width":case "height":case "top":case "left":e.push(h+"="+a[h]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(h+"="+(a[h]?1:0))}var h=e.join(",");(z("iPhone")&&!z("iPod")&&!z("iPad")||z("iPad")||z("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(h=d.document.createElement("A"),b instanceof yd||b instanceof yd||(b=b.na?b.ma():String(b),Bd.test(b)||(b="about:invalid#zClosurez"),b=Dd(b)),h.href=Ad(b),h.setAttribute("target",c),a.noreferrer&&
h.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),h.dispatchEvent(a),h={}):a.noreferrer?(h=d.open("",c,h),a=Ad(b),h&&(Rb&&y(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),h.opener=null,qd("b/12014412, meta tag with sanitized URL"),a='<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Ma(a)+'">',a=Hd(a),h.document.write(Gd(a)),h.document.close())):(h=d.open(Ad(b),c,h))&&a.noopener&&(h.opener=null);if(h)try{h.focus()}catch(m){}return h}
function ee(a){return new A(function(b){function c(){Hc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var fe=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ge=/^[^@]+@[^@]+$/;function he(){var a=null;return(new A(function(b){"complete"==k.document.readyState?b():(a=function(){b()},sc(window,"load",a))})).s(function(b){E(window,"load",a);throw b;})}
function ie(){return je(void 0)?he().then(function(){return new A(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):C(Error("Cordova must run in an Android or iOS file scheme."))}function je(a){a=a||H();return!("file:"!==ke()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function le(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function me(){return"object"!==typeof k.window&&"function"===typeof k.importScripts}function ne(){return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("node")?"Node":me()?"Worker":"Browser"}function oe(){var a=ne();return"ReactNative"===a||"Node"===a}function pe(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}var de="Firefox",$d="Chrome";
function Zd(a){var b=a.toLowerCase();if(y(b,"opera/")||y(b,"opr/")||y(b,"opios/"))return"Opera";if(y(b,"iemobile"))return"IEMobile";if(y(b,"msie")||y(b,"trident/"))return"IE";if(y(b,"edge/"))return"Edge";if(y(b,"firefox/"))return de;if(y(b,"silk/"))return"Silk";if(y(b,"blackberry"))return"Blackberry";if(y(b,"webos"))return"Webos";if(!y(b,"safari/")||y(b,"chrome/")||y(b,"crios/")||y(b,"android"))if(!y(b,"chrome/")&&!y(b,"crios/")||y(b,"edge/")){if(y(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return $d;else return"Safari";return"Other"}var qe={Uc:"FirebaseCore-web",Wc:"FirebaseUI-web"};function re(a,b){b=b||[];var c=[],d={},e;for(e in qe)d[qe[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=ne();"Browser"===c?(d=H(),c=Zd(d)):"Worker"===c&&(d=H(),c=Zd(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function H(){return k.navigator&&k.navigator.userAgent||""}
function I(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function se(){try{var a=k.localStorage,b=te();if(a)return a.setItem(b,"1"),a.removeItem(b),Ud()?!!k.indexedDB:!0}catch(c){return me()&&!!k.indexedDB}return!1}function ue(){return(ve()||"chrome-extension:"===ke()||je())&&!oe()&&se()&&!me()}function ve(){return"http:"===ke()||"https:"===ke()}function ke(){return k.location&&k.location.protocol||null}
function we(a){a=a||H();return ae(a)||Zd(a)==de?!1:!0}function xe(a){return"undefined"===typeof a?null:Od(a)}function ye(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function ze(a){if(null!==a)return JSON.parse(a)}function te(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ae(a){a=a||H();return"Safari"==Zd(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Be(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Ce(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=H();b=ne();this.b=ae(a)||"ReactNative"===b}
Ce.prototype.get=function(){var a=k.navigator;return(a&&"boolean"===typeof a.onLine&&(ve()||"chrome-extension:"===ke()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function De(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function Ee(){var a=k.document,b=null;return De()||!a?B():(new A(function(c){b=function(){De()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Fe(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Ge(){return!(!I("fireauth.oauthhelper",k)&&!I("fireauth.iframe",k))}
function He(){var a=k.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function Ie(){var a=k.navigator;return a&&a.serviceWorker?B().then(function(){return a.serviceWorker.ready}).then(function(a){return a.active||null}).s(function(){return null}):B(null)};var Je={};function Ke(a){Je[a]||(Je[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Le;try{var Me={};Object.defineProperty(Me,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Me,"abcd",{configurable:!0,enumerable:!0,value:2});Le=2==Me.abcd}catch(a){Le=!1}function J(a,b,c){Le?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function K(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&J(a,c,b[c])}function Ne(a){var b={};K(b,a);return b}function Oe(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function Pe(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function Qe(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)J(b,c,Qe(a[c]))}return b};function Re(a){var b={},c=a[Se],d=a[Te];a=a[Ue];if(!a||a!=Ve&&!c)throw Error("Invalid provider user info!");b[We]=d||null;b[Xe]=c||null;J(this,Ye,a);J(this,Ze,Qe(b))}var Ve="EMAIL_SIGNIN",Se="email",Te="newEmail",Ue="requestType",Xe="email",We="fromEmail",Ze="data",Ye="operation";function L(a,b){this.code=$e+a;this.message=b||af[a]||""}t(L,Error);L.prototype.C=function(){return{code:this.code,message:this.message}};L.prototype.toJSON=function(){return this.C()};function bf(a){var b=a&&a.code;return b?new L(b.substring($e.length),a.message):null}
var $e="auth/",af={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
"invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.",
"invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
"invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
"wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].","invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.",
"invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
"missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-or-invalid-nonce":"The OIDC ID token requires a valid unhashed nonce.",
"missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
"no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
"rejected-credential":"The request contains malformed or mismatching credentials.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.",
"user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function cf(a){var b=a[df];if("undefined"===typeof b)throw new L("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new L("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[ef];if(c&&"object"===typeof c){b=c[ff];var d=c[gf];c=c[hf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new L("argument-error",gf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new L("argument-error",hf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new L("argument-error",ff+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new L("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new L("argument-error",ef+" property must be a non null object when specified.");this.f=null;if((b=a[jf])&&"object"===
typeof b)if(b=b[kf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new L("argument-error",kf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new L("argument-error",jf+" property must be a non null object when specified.");b=a[lf];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new L("argument-error",lf+" property must be a boolean when specified.");this.c=!!b;a=a[mf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
typeof a&&!a.length))throw new L("argument-error",mf+" property must be a non empty string when specified.");this.i=a||null}var ef="android",mf="dynamicLinkDomain",lf="handleCodeInApp",jf="iOS",df="url",gf="installApp",hf="minimumVersion",ff="packageName",kf="bundleId";
function nf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function of(a){return Ca(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var pf=null,qf=null;function rf(a){var b="";sf(a,function(a){b+=String.fromCharCode(a)});return b}function sf(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=qf[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}tf();for(var d=0;;){var e=c(-1),f=c(0),h=c(64),m=c(64);if(64===m&&-1===e)break;b(e<<2|f>>4);64!=h&&(b(f<<4&240|h>>2),64!=m&&b(h<<6&192|m))}}
function tf(){if(!pf){pf={};qf={};for(var a=0;65>a;a++)pf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),qf[pf[a]]=a,62<=a&&(qf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function uf(a){this.c=a.sub;oa();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}uf.prototype.f=function(){return this.b};function vf(a){return(a=wf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new uf(a):null}function wf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(rf(a))}catch(d){}return null};var xf={$c:{ab:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://securetoken.googleapis.com/v1/token",id:"p"},bd:{ab:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},cd:{ab:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ib:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function yf(a){for(var b in xf)if(xf[b].id===a)return a=xf[b],{firebaseEndpoint:a.ab,secureTokenEndpoint:a.ib};return null}var zf;zf=yf("__EID__")?"__EID__":void 0;var Af="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Bf=["client_id","response_type","scope","redirect_uri","state"],Cf={Vc:{Ma:"locale",Ba:500,Aa:600,Na:"facebook.com",hb:Bf},Xc:{Ma:null,Ba:500,Aa:620,Na:"github.com",hb:Bf},Yc:{Ma:"hl",Ba:515,Aa:680,Na:"google.com",hb:Bf},dd:{Ma:"lang",Ba:485,Aa:705,Na:"twitter.com",hb:Af}};function Df(a){for(var b in Cf)if(Cf[b].Na==a)return Cf[b];return null};function Ef(a){var b={};b["facebook.com"]=Ff;b["google.com"]=Gf;b["github.com"]=Hf;b["twitter.com"]=If;var c=a&&a[Jf];try{if(c)return b[c]?new b[c](a):new Kf(a);if("undefined"!==typeof a[Lf])return new Mf(a)}catch(d){}return null}var Lf="idToken",Jf="providerId";
function Mf(a){var b=a[Jf];if(!b&&a[Lf]){var c=vf(a[Lf]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);J(this,"providerId",b);J(this,"isNewUser",c)}function Kf(a){Mf.call(this,a);a=ze(a.rawUserInfo||"{}");J(this,"profile",Qe(a||{}))}t(Kf,Mf);
function Ff(a){Kf.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Ff,Kf);function Hf(a){Kf.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");J(this,"username",this.profile&&this.profile.login||null)}t(Hf,Kf);function Gf(a){Kf.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Gf,Kf);
function If(a){Kf.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");J(this,"username",a.screenName||null)}t(If,Kf);function Nf(a){this.a=dd(a)};function Of(a){var b=dd(a),c=cd(b,"link"),d=cd(dd(c),"link");b=cd(b,"deep_link_id");return cd(dd(b),"link")||b||d||c||a};function Pf(a,b){return a.then(function(a){if(a[M]){var c=vf(a[M]);if(!c||b!=c.c)throw new L("user-mismatch");return a}throw new L("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==$e+"user-not-found"?new L("user-mismatch"):a;})}function Qf(a,b){if(b)this.a=b;else throw new L("internal-error","failed to construct a credential");J(this,"providerId",a);J(this,"signInMethod",a)}Qf.prototype.la=function(a){return Rf(a,Sf(this))};
Qf.prototype.b=function(a,b){var c=Sf(this);c.idToken=b;return Tf(a,c)};Qf.prototype.f=function(a,b){return Pf(Uf(a,Sf(this)),b)};function Sf(a){return{pendingToken:a.a,requestUri:"http://localhost"}}Qf.prototype.C=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};
function Vf(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&J(this,"idToken",b.idToken),b.accessToken&&J(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&J(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)J(this,"accessToken",b.oauthToken),J(this,"secret",b.oauthTokenSecret);else throw new L("internal-error","failed to construct a credential");J(this,"providerId",a);J(this,"signInMethod",c)}
Vf.prototype.la=function(a){return Rf(a,Wf(this))};Vf.prototype.b=function(a,b){var c=Wf(this);c.idToken=b;return Tf(a,c)};Vf.prototype.f=function(a,b){var c=Wf(this);return Pf(Uf(a,c),b)};
function Wf(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:hd(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
Vf.prototype.C=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};function Xf(a,b){this.Dc=b||[];K(this,{providerId:a,isOAuthProvider:!0});this.yb={};this.cb=(Df(a)||{}).Ma||null;this.$a=null}Xf.prototype.Da=function(a){this.yb=$a(a);return this};
function Yf(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new L("argument-error",'SAML provider IDs must be prefixed with "saml."');Xf.call(this,a,[])}t(Yf,Xf);function N(a){Xf.call(this,a,Bf);this.a=[]}t(N,Xf);N.prototype.ua=function(a){Ga(this.a,a)||this.a.push(a);return this};N.prototype.Eb=function(){return Ja(this.a)};
N.prototype.credential=function(a,b,c){if(!a&&!b)throw new L("argument-error","credential failed: must provide the ID token and/or the access token.");return new Vf(this.providerId,{idToken:a||null,accessToken:b||null,nonce:c||null},this.providerId)};function Zf(){N.call(this,"facebook.com")}t(Zf,N);J(Zf,"PROVIDER_ID","facebook.com");J(Zf,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function $f(a){if(!a)throw new L("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Zf).credential(null,b)}function ag(){N.call(this,"github.com")}t(ag,N);J(ag,"PROVIDER_ID","github.com");J(ag,"GITHUB_SIGN_IN_METHOD","github.com");function bg(a){if(!a)throw new L("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new ag).credential(null,b)}
function cg(){N.call(this,"google.com");this.ua("profile")}t(cg,N);J(cg,"PROVIDER_ID","google.com");J(cg,"GOOGLE_SIGN_IN_METHOD","google.com");function dg(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new cg).credential(c,b)}function eg(){Xf.call(this,"twitter.com",Af)}t(eg,Xf);J(eg,"PROVIDER_ID","twitter.com");J(eg,"TWITTER_SIGN_IN_METHOD","twitter.com");
function fg(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new L("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Vf("twitter.com",c,"twitter.com")}function gg(a,b,c){this.a=a;this.c=b;J(this,"providerId","password");J(this,"signInMethod",c===O.EMAIL_LINK_SIGN_IN_METHOD?O.EMAIL_LINK_SIGN_IN_METHOD:O.EMAIL_PASSWORD_SIGN_IN_METHOD)}
gg.prototype.la=function(a){return this.signInMethod==O.EMAIL_LINK_SIGN_IN_METHOD?P(a,hg,{email:this.a,oobCode:this.c}):P(a,ig,{email:this.a,password:this.c})};gg.prototype.b=function(a,b){return this.signInMethod==O.EMAIL_LINK_SIGN_IN_METHOD?P(a,jg,{idToken:b,email:this.a,oobCode:this.c}):P(a,kg,{idToken:b,email:this.a,password:this.c})};gg.prototype.f=function(a,b){return Pf(this.la(a),b)};gg.prototype.C=function(){return{email:this.a,password:this.c,signInMethod:this.signInMethod}};
function O(){K(this,{providerId:"password",isOAuthProvider:!1})}function lg(a,b){b=mg(b);if(!b)throw new L("argument-error","Invalid email link!");return new gg(a,b,O.EMAIL_LINK_SIGN_IN_METHOD)}function mg(a){a=Of(a);a=new Nf(a);var b=cd(a.a,"oobCode")||null;return"signIn"===(cd(a.a,"mode")||null)&&b?b:null}K(O,{PROVIDER_ID:"password"});K(O,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});K(O,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
function ng(a){if(!(a.Ta&&a.Sa||a.Fa&&a.$))throw new L("internal-error");this.a=a;J(this,"providerId","phone");J(this,"signInMethod","phone")}ng.prototype.la=function(a){return a.Ua(og(this))};ng.prototype.b=function(a,b){var c=og(this);c.idToken=b;return P(a,pg,c)};ng.prototype.f=function(a,b){var c=og(this);c.operation="REAUTH";a=P(a,qg,c);return Pf(a,b)};
ng.prototype.C=function(){var a={providerId:"phone"};this.a.Ta&&(a.verificationId=this.a.Ta);this.a.Sa&&(a.verificationCode=this.a.Sa);this.a.Fa&&(a.temporaryProof=this.a.Fa);this.a.$&&(a.phoneNumber=this.a.$);return a};function og(a){return a.a.Fa&&a.a.$?{temporaryProof:a.a.Fa,phoneNumber:a.a.$}:{sessionInfo:a.a.Ta,code:a.a.Sa}}
function rg(a){try{this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth()}catch(b){throw new L("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}K(this,{providerId:"phone",isOAuthProvider:!1})}
rg.prototype.Ua=function(a,b){var c=this.a.b;return B(b.verify()).then(function(d){if(!l(d))throw new L("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return sg(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new L("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function tg(a,b){if(!a)throw new L("missing-verification-id");if(!b)throw new L("missing-verification-code");return new ng({Ta:a,Sa:b})}K(rg,{PROVIDER_ID:"phone"});K(rg,{PHONE_SIGN_IN_METHOD:"phone"});
function ug(a){if(a.temporaryProof&&a.phoneNumber)return new ng({Fa:a.temporaryProof,$:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,h=a&&a.pendingToken;try{switch(b){case "google.com":return dg(f,c);case "facebook.com":return $f(c);case "github.com":return bg(c);case "twitter.com":return fg(c,d);default:return c||d||f||h?h?0==b.indexOf("saml.")?new Qf(b,h):new Vf(b,{pendingToken:h,idToken:a.oauthIdToken,
accessToken:a.oauthAccessToken},b):(new N(b)).credential(f,c,e):null}}catch(m){return null}}function vg(a){if(!a.isOAuthProvider)throw new L("invalid-oauth-provider");};function wg(a,b,c,d,e,f){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.h=f||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new L("invalid-auth-event");if(this.f&&!this.g)throw new L("invalid-auth-event");}else throw new L("invalid-auth-event");}wg.prototype.C=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,postBody:this.h,error:this.a&&this.a.C()}};
function xg(a){a=a||{};return a.type?new wg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&bf(a.error),a.postBody):null};function yg(){this.b=null;this.a=[]}var zg=null;yg.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(a){for(var c=0;c<b.a.length;c++)b.a[c](a)},a=I("universalLinks.subscribe",k),"function"===typeof a&&a(null,this.b))};yg.prototype.unsubscribe=function(a){w(this.a,function(b){return b==a})};function Ag(a){var b="unauthorized-domain",c=void 0,d=dd(a);a=d.b;d=d.c;"chrome-extension"==d?c=Ka("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Ka("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
L.call(this,b,c)}t(Ag,L);function Bg(a,b,c){L.call(this,a,c);a=b||{};a.zb&&J(this,"email",a.zb);a.$&&J(this,"phoneNumber",a.$);a.credential&&J(this,"credential",a.credential)}t(Bg,L);Bg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.C();b&&bb(a,b);return a};Bg.prototype.toJSON=function(){return this.C()};
function Cg(a){if(a.code){var b=a.code||"";0==b.indexOf($e)&&(b=b.substring($e.length));var c={credential:ug(a)};if(a.email)c.zb=a.email;else if(a.phoneNumber)c.$=a.phoneNumber;else if(!c.credential)return new L(b,a.message||void 0);return new Bg(b,c,a.message)}return null};function Dg(){}Dg.prototype.c=null;function Eg(a){return a.c||(a.c=a.b())};var Fg;function Gg(){}t(Gg,Dg);Gg.prototype.a=function(){var a=Hg(this);return a?new ActiveXObject(a):new XMLHttpRequest};Gg.prototype.b=function(){var a={};Hg(this)&&(a[0]=!0,a[1]=!0);return a};
function Hg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Fg=new Gg;function Ig(){}t(Ig,Dg);Ig.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Jg;throw Error("Unsupported browser");};Ig.prototype.b=function(){return{}};
function Jg(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText="";this.a.onload=r(this.ec,this);this.a.onerror=r(this.Fb,this);this.a.onprogress=r(this.fc,this);this.a.ontimeout=r(this.ic,this)}g=Jg.prototype;g.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
g.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};g.abort=function(){this.a.abort()};g.setRequestHeader=function(){};g.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};g.ec=function(){this.status=200;this.responseText=this.a.responseText;Kg(this,4)};g.Fb=function(){this.status=500;this.responseText="";Kg(this,4)};g.ic=function(){this.Fb()};
g.fc=function(){this.status=200;Kg(this,1)};function Kg(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}g.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Lg(a,b,c){this.reset(a,b,c,void 0,void 0)}Lg.prototype.a=null;var Mg=0;Lg.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Mg++;d||oa();delete this.a};function Ng(a){this.f=a;this.b=this.c=this.a=null}function Og(a,b){this.name=a;this.value=b}Og.prototype.toString=function(){return this.name};var Pg=new Og("SEVERE",1E3),Qg=new Og("WARNING",900),Rg=new Og("CONFIG",700),Sg=new Og("FINE",500);function Tg(a){if(a.c)return a.c;if(a.a)return Tg(a.a);sa("Root logger has no level set.");return null}Ng.prototype.log=function(a,b,c){if(a.value>=Tg(this).value)for(n(b)&&(b=b()),a=new Lg(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Ug={},Vg=null;
function Wg(a){Vg||(Vg=new Ng(""),Ug[""]=Vg,Vg.c=Rg);var b;if(!(b=Ug[a])){b=new Ng(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Wg(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Ug[a]=b}return b};function Xg(a,b){a&&a.log(Sg,b,void 0)};function Yg(a){this.f=a}t(Yg,Dg);Yg.prototype.a=function(){return new Zg(this.f)};Yg.prototype.b=function(a){return function(){return a}}({});function Zg(a){F.call(this);this.i=a;this.readyState=$g;this.status=0;this.responseText=this.statusText="";this.onreadystatechange=null;this.g=new Headers;this.b=null;this.h="GET";this.c="";this.a=!1;this.f=Wg("goog.net.FetchXmlHttp")}t(Zg,F);var $g=0;g=Zg.prototype;
g.open=function(a,b){if(this.readyState!=$g)throw this.abort(),Error("Error reopening a connection");this.h=a;this.c=b;this.readyState=1;ah(this)};g.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.g,method:this.h,credentials:void 0,cache:void 0};a&&(b.body=a);this.i.fetch(new Request(this.c,b)).then(this.hc.bind(this),this.Gb.bind(this))};
g.abort=function(){this.responseText="";this.g=new Headers;this.status=0;1<=this.readyState&&this.a&&4!=this.readyState&&(this.readyState=4,this.a=!1,ah(this));this.readyState=$g};g.hc=function(a){this.a&&(this.b||(this.b=a.headers,this.readyState=2,ah(this)),this.a&&(this.readyState=3,ah(this),this.a&&a.text().then(this.gc.bind(this,a),this.Gb.bind(this))))};g.gc=function(a,b){this.a&&(this.status=a.status,this.statusText=a.statusText,this.responseText=b,this.readyState=4,ah(this))};
g.Gb=function(a){var b=this.f;b&&b.log(Qg,"Failed to fetch url "+this.c,a instanceof Error?a:Error(a));this.a&&(this.readyState=4,ah(this))};g.setRequestHeader=function(a,b){this.g.append(a,b)};g.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.f)&&a.log(Qg,"Attempting to get response header but no headers have been received for url: "+this.c,void 0),"")};
g.getAllResponseHeaders=function(){if(!this.b){var a=this.f;a&&a.log(Qg,"Attempting to get all response headers but no headers have been received for url: "+this.c,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function ah(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function bh(a){F.call(this);this.headers=new Lc;this.D=a||null;this.c=!1;this.w=this.a=null;this.h=this.N=this.m="";this.f=this.I=this.i=this.G=!1;this.g=0;this.u=null;this.o=ch;this.v=this.O=!1}t(bh,F);var ch="";bh.prototype.b=Wg("goog.net.XhrIo");var dh=/^https?$/i,eh=["POST","PUT"];
function fh(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.m+"; newUri="+b);c=c?c.toUpperCase():"GET";a.m=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.D?a.D.a():Fg.a();a.w=a.D?Eg(a.D):Eg(Fg);a.a.onreadystatechange=r(a.Jb,a);try{Xg(a.b,gh(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(h){Xg(a.b,gh(a,"Error opening Xhr: "+h.message));hh(a,h);return}b=d||"";var f=new Lc(a.headers);e&&Kc(e,function(a,b){f.set(b,a)});e=Ea(f.U());d=k.FormData&&b instanceof
k.FormData;!Ga(eh,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.o&&(a.a.responseType=a.o);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{ih(a),0<a.g&&(a.v=jh(a.a),Xg(a.b,gh(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=r(a.Ga,a)):a.u=Gc(a.Ga,a.g,a)),Xg(a.b,gh(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(h){Xg(a.b,
gh(a,"Send error: "+h.message)),hh(a,h)}}function jh(a){return Pb&&Zb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Fa(a){return"content-type"==a.toLowerCase()}g=bh.prototype;g.Ga=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Xg(this.b,gh(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function hh(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;kh(a);lh(a)}
function kh(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}g.abort=function(){this.a&&this.c&&(Xg(this.b,gh(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),lh(this))};g.va=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),lh(this,!0));bh.ob.va.call(this)};g.Jb=function(){this.qa||(this.I||this.i||this.f?mh(this):this.wc())};g.wc=function(){mh(this)};
function mh(a){if(a.c&&"undefined"!=typeof aa)if(a.w[1]&&4==nh(a)&&2==oh(a))Xg(a.b,gh(a,"Local request error detected and ignored"));else if(a.i&&4==nh(a))Gc(a.Jb,0,a);else if(a.dispatchEvent("readystatechange"),4==nh(a)){Xg(a.b,gh(a,"Request complete"));a.c=!1;try{var b=oh(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.m).match(Oc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
f=h.substr(0,h.length-1)}e=!dh.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var m=2<nh(a)?a.a.statusText:""}catch(p){Xg(a.b,"Can not get status: "+p.message),m=""}a.h=m+" ["+oh(a)+"]";kh(a)}}finally{lh(a)}}}function lh(a,b){if(a.a){ih(a);var c=a.a,d=a.w[0]?ca:null;a.a=null;a.w=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Pg,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function ih(a){a.a&&a.v&&(a.a.ontimeout=null);a.u&&(k.clearTimeout(a.u),a.u=null)}function nh(a){return a.a?a.a.readyState:0}function oh(a){try{return 2<nh(a)?a.a.status:-1}catch(b){return-1}}function ph(a){try{return a.a?a.a.responseText:""}catch(b){return Xg(a.b,"Can not get responseText: "+b.message),""}}
g.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.o){case ch:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Pg,"Response type "+this.o+" is not supported on this browser",void 0);return null}catch(b){return Xg(this.b,"Can not get response: "+b.message),null}};function gh(a,b){return b+" ["+a.N+" "+a.m+" "+oh(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function qh(a,b){this.g=[];this.v=a;this.u=b||null;this.f=this.a=!1;this.c=void 0;this.m=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}qh.prototype.cancel=function(a){if(this.a)this.c instanceof qh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.u,this):this.m=!0;this.a||(a=new rh(this),sh(this),th(this,!1,a))}};qh.prototype.o=function(a,b){this.i=!1;th(this,a,b)};function th(a,b,c){a.a=!0;a.c=c;a.f=!b;uh(a)}
function sh(a){if(a.a){if(!a.m)throw new vh(a);a.m=!1}}qh.prototype.D=function(){sh(this);th(this,!0,null)};function wh(a,b){xh(a,null,b,void 0)}function xh(a,b,c,d){a.g.push([b,c,d]);a.a&&uh(a)}qh.prototype.then=function(a,b,c){var d,e,f=new A(function(a,b){d=a;e=b});xh(this,d,function(a){a instanceof rh?f.cancel():e(a)});return f.then(a,b,c)};pa(qh);function yh(a){return Da(a.g,function(a){return n(a[1])})}
function uh(a){if(a.h&&a.a&&yh(a)){var b=a.h,c=zh[b];c&&(k.clearTimeout(c.a),delete zh[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],h=e[1];e=e[2];if(f=a.f?h:f)try{var m=f.call(e||a.u,b);void 0!==m&&(a.f=a.f&&(m==b||m instanceof Error),a.c=b=m);if(qa(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(p){b=p,a.f=!0,yh(a)||(c=!0)}}a.c=b;d&&(m=r(a.o,a,!0),d=r(a.o,a,!1),b instanceof qh?(xh(b,m,d),b.w=!0):b.then(m,d));c&&(b=
new Ah(b),zh[b.a]=b,a.h=b.a)}function vh(){u.call(this)}t(vh,u);vh.prototype.message="Deferred has already fired";vh.prototype.name="AlreadyCalledError";function rh(){u.call(this)}t(rh,u);rh.prototype.message="Deferred was canceled";rh.prototype.name="CanceledError";function Ah(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}Ah.prototype.c=function(){delete zh[this.a];throw this.b;};var zh={};function Bh(a){var b={},c=b.document||document,d=td(a),e=document.createElement("SCRIPT"),f={Lb:e,Ga:void 0},h=new qh(Ch,f),m=null,p=null!=b.timeout?b.timeout:5E3;0<p&&(m=window.setTimeout(function(){Dh(e,!0);var a=new Eh(Fh,"Timeout reached for loading script "+d);sh(h);th(h,!1,a)},p),f.Ga=m);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Dh(e,b.fd||!1,m),h.D())};e.onerror=function(){Dh(e,!0,m);var a=new Eh(Gh,"Error while loading script "+
d);sh(h);th(h,!1,a)};f=b.attributes||{};bb(f,{type:"text/javascript",charset:"UTF-8"});Jd(e,f);e.src=td(a);Hh(c).appendChild(e);return h}function Hh(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function Ch(){if(this&&this.Lb){var a=this.Lb;a&&"SCRIPT"==a.tagName&&Dh(a,!0,this.Ga)}}
function Dh(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Gh=0,Fh=1;function Eh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(Eh,u);function Ih(a){this.f=a}t(Ih,Dg);Ih.prototype.a=function(){return new this.f};Ih.prototype.b=function(){return{}};
function Jh(a,b,c){this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.l=a.secureTokenTimeout||Kh;this.f=$a(a.secureTokenHeaders||Lh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Mh;this.a=$a(a.firebaseHeaders||Nh);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==ne();c=k.XMLHttpRequest||c&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.XMLHttpRequest;if(!c&&
!me())throw new L("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;me()?this.c=new Yg(self):oe()?this.c=new Ih(c):this.c=new Ig}var Oh,M="idToken",Kh=new Ce(3E4,6E4),Lh={"Content-Type":"application/x-www-form-urlencoded"},Mh=new Ce(3E4,6E4),Nh={"Content-Type":"application/json"};function Ph(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function Qh(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function Rh(a,b,c,d,e,f,h){Yd()||me()?a=r(a.o,a):(Oh||(Oh=new A(function(a,b){Sh(a,b)})),a=r(a.m,a));a(b,c,d,e,f,h)}
Jh.prototype.o=function(a,b,c,d,e,f){if(me()&&("undefined"===typeof k.fetch||"undefined"===typeof k.Headers||"undefined"===typeof k.Request))throw new L("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var h=new bh(this.c);if(f){h.g=Math.max(0,f);var m=setTimeout(function(){h.dispatchEvent("timeout")},f)}uc(h,"complete",function(){m&&clearTimeout(m);var a=null;try{a=
JSON.parse(ph(this))||null}catch(x){a=null}b&&b(a)});Ac(h,"ready",function(){m&&clearTimeout(m);Kb(this)});Ac(h,"timeout",function(){m&&clearTimeout(m);Kb(this);b&&b(null)});fh(h,a,c,d,e)};var Th=qd("https://apis.google.com/js/client.js?onload=%{onload}"),Uh="__fcb"+Math.floor(1E6*Math.random()).toString();
function Sh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Uh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=ud(Th,{onload:Uh});wh(Bh(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
Jh.prototype.m=function(a,b,c,d,e){var f=this;Oh.then(function(){window.gapi.client.setApiKey(f.b);var h=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(h);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
function Vh(a,b){return new A(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Rh(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Wh(a)):a.access_token&&a.refresh_token?c(a):d(new L("internal-error")):d(new L("network-request-failed"))},"POST",hd(b).toString(),a.f,a.l.get()):d(new L("internal-error"))})}
function Xh(a,b,c,d,e,f){var h=dd(a.g+b);G(h,"key",a.b);f&&G(h,"cb",oa().toString());var m="GET"==c;if(m)for(var p in d)d.hasOwnProperty(p)&&G(h,p,d[p]);return new A(function(b,f){Rh(a,h.toString(),function(a){a?a.error?f(Wh(a,e||{})):b(a):f(new L("network-request-failed"))},c,m?void 0:Od(ye(d)),a.a,a.h.get())})}function Yh(a){a=a.email;if(!l(a)||!ge.test(a))throw new L("invalid-email");}function Zh(a){"email"in a&&Yh(a)}
function $h(a,b){return P(a,ai,{identifier:b,continueUri:ve()?Vd():"http://localhost"}).then(function(a){return a.allProviders||[]})}function bi(a,b){return P(a,ai,{identifier:b,continueUri:ve()?Vd():"http://localhost"}).then(function(a){return a.signinMethods||[]})}function ci(a){return P(a,di,{}).then(function(a){return a.authorizedDomains||[]})}function ei(a){if(!a[M])throw new L("internal-error");}
function fi(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new L("internal-error");}else{if(!a.sessionInfo)throw new L("missing-verification-id");if(!a.code)throw new L("missing-verification-code");}}Jh.prototype.Qa=function(){return P(this,gi,{})};Jh.prototype.pb=function(a,b){return P(this,hi,{idToken:a,email:b})};Jh.prototype.qb=function(a,b){return P(this,kg,{idToken:a,password:b})};var ii={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};g=Jh.prototype;
g.rb=function(a,b){var c={idToken:a},d=[];Ya(ii,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return P(this,hi,c)};g.kb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};bb(a,b);return P(this,ji,a)};g.lb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};bb(a,b);return P(this,ki,a)};g.jb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};bb(a,b);return P(this,li,a)};function sg(a,b){return P(a,mi,b)}g.Ua=function(a){return P(this,ni,a)};
function oi(a,b,c){return P(a,pi,{idToken:b,deleteProvider:c})}function qi(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new L("internal-error");}function ri(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Tc(a.postBody),ld(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
function si(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Cg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Cg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Cg(a)):a.errorMessage&&(b=ti(a.errorMessage));if(b)throw b;if(!a[M])throw new L("internal-error");}function Rf(a,b){b.returnIdpCredential=!0;return P(a,ui,b)}function Tf(a,b){b.returnIdpCredential=!0;return P(a,vi,b)}
function Uf(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return P(a,wi,b)}function xi(a){if(!a.oobCode)throw new L("invalid-action-code");}g.Za=function(a,b){return P(this,yi,{oobCode:a,newPassword:b})};g.Ja=function(a){return P(this,zi,{oobCode:a})};g.Wa=function(a){return P(this,Ai,{oobCode:a})};
var Ai={endpoint:"setAccountInfo",B:xi,da:"email"},zi={endpoint:"resetPassword",B:xi,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new L("internal-error");}},Bi={endpoint:"signupNewUser",B:function(a){Yh(a);if(!a.password)throw new L("weak-password");},J:ei,R:!0},ai={endpoint:"createAuthUri"},Ci={endpoint:"deleteAccount",T:["idToken"]},pi={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],B:function(a){if(!fa(a.deleteProvider))throw new L("internal-error");}},hg=
{endpoint:"emailLinkSignin",T:["email","oobCode"],B:Yh,J:ei,R:!0},jg={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],B:Yh,J:ei,R:!0},Di={endpoint:"getAccountInfo"},ki={endpoint:"getOobConfirmationCode",T:["requestType"],B:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new L("internal-error");Yh(a)},da:"email"},li={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],B:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new L("internal-error");},da:"email"},ji={endpoint:"getOobConfirmationCode",
T:["requestType"],B:function(a){if("PASSWORD_RESET"!=a.requestType)throw new L("internal-error");Yh(a)},da:"email"},di={ub:!0,endpoint:"getProjectConfig",Ib:"GET"},Ei={ub:!0,endpoint:"getRecaptchaParam",Ib:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new L("internal-error");}},yi={endpoint:"resetPassword",B:xi,da:"email"},mi={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],da:"sessionInfo"},hi={endpoint:"setAccountInfo",T:["idToken"],B:Zh,R:!0},kg={endpoint:"setAccountInfo",
T:["idToken"],B:function(a){Zh(a);if(!a.password)throw new L("weak-password");},J:ei,R:!0},gi={endpoint:"signupNewUser",J:ei,R:!0},ui={endpoint:"verifyAssertion",B:qi,Oa:ri,J:si,R:!0},wi={endpoint:"verifyAssertion",B:qi,Oa:ri,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new L("user-not-found");if(a.errorMessage)throw ti(a.errorMessage);if(!a[M])throw new L("internal-error");},R:!0},vi={endpoint:"verifyAssertion",B:function(a){qi(a);if(!a.idToken)throw new L("internal-error");
},Oa:ri,J:si,R:!0},Fi={endpoint:"verifyCustomToken",B:function(a){if(!a.token)throw new L("invalid-custom-token");},J:ei,R:!0},ig={endpoint:"verifyPassword",B:function(a){Yh(a);if(!a.password)throw new L("wrong-password");},J:ei,R:!0},ni={endpoint:"verifyPhoneNumber",B:fi,J:ei},pg={endpoint:"verifyPhoneNumber",B:function(a){if(!a.idToken)throw new L("internal-error");fi(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Cg(a);ei(a)}},qg={Xb:{USER_NOT_FOUND:"user-not-found"},
endpoint:"verifyPhoneNumber",B:fi,J:ei};function P(a,b,c){if(!Pe(c,b.T))return C(new L("internal-error"));var d=b.Ib||"POST",e;return B(c).then(b.B).then(function(){b.R&&(c.returnSecureToken=!0);return Xh(a,b.endpoint,d,c,b.Xb,b.ub||!1)}).then(function(a){e=a;return b.Oa?b.Oa(c,e):e}).then(b.J).then(function(){if(!b.da)return e;if(!(b.da in e))throw new L("internal-error");return e[b.da]})}function ti(a){return Wh({error:{errors:[{message:a}],code:400,message:a}})}
function Wh(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new L(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};bb(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?
b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new L(d[e],b);!b&&a&&(b=xe(a));return new L("internal-error",b)};function Gi(a){this.b=a;this.a=null;this.fb=Hi(this)}
function Hi(a){return Ii().then(function(){return new A(function(b,c){I("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:I("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ji.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function Ki(a,b){return a.fb.then(function(){return new A(function(c){a.a.send(b.type,b,c,I("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Li(a,b){a.fb.then(function(){a.a.register("authEvent",b,I("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Mi=qd("https://apis.google.com/js/api.js?onload=%{onload}"),Ni=new Ce(3E4,6E4),Ji=new Ce(5E3,15E3),Oi=null;
function Ii(){return Oi?Oi:Oi=(new A(function(a,b){function c(){Be();I("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Be();b(Error("Network Error"))},timeout:Ni.get()})}if(I("gapi.iframes.Iframe"))a();else if(I("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){I("gapi.load")?c():b(Error("Network Error"))};d=ud(Mi,{onload:d});B(Bh(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){Oi=null;throw a;})};function Pi(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=ed(this.i,"/__/auth/iframe");G(this.a,"apiKey",this.g);G(this.a,"appName",this.h);this.b=null;this.c=[]}Pi.prototype.toString=function(){this.f?G(this.a,"v",this.f):kd(this.a.a,"v");this.b?G(this.a,"eid",this.b):kd(this.a.a,"eid");this.c.length?G(this.a,"fw",this.c.join(",")):kd(this.a.a,"fw");return this.a.toString()};function Qi(a,b,c,d,e){this.o=a;this.m=b;this.c=c;this.l=d;this.h=this.g=this.i=null;this.a=e;this.f=null}
Qi.prototype.toString=function(){var a=ed(this.o,"/__/auth/handler");G(a,"apiKey",this.m);G(a,"appName",this.c);G(a,"authType",this.l);if(this.a.isOAuthProvider){var b=this.a;try{var c=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(this.c).auth().ea()}catch(m){c=null}b.$a=c;G(a,"providerId",this.a.providerId);b=this.a;c=ye(b.yb);for(var d in c)c[d]=c[d].toString();d=b.Dc;c=$a(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.cb&&b.$a&&!c[b.cb]&&(c[b.cb]=b.$a);Za(c)||G(a,"customParameters",xe(c))}"function"===typeof this.a.Eb&&
(b=this.a.Eb(),b.length&&G(a,"scopes",b.join(",")));this.i?G(a,"redirectUrl",this.i):kd(a.a,"redirectUrl");this.g?G(a,"eventId",this.g):kd(a.a,"eventId");this.h?G(a,"v",this.h):kd(a.a,"v");if(this.b)for(var h in this.b)this.b.hasOwnProperty(h)&&!cd(a,h)&&G(a,h,this.b[h]);this.f?G(a,"eid",this.f):kd(a.a,"eid");h=Ri(this.c);h.length&&G(a,"fw",h.join(","));return a.toString()};function Ri(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a).auth().ya()}catch(b){return[]}}
function Si(a,b,c,d,e){this.m=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.o=this.u=this.v=null;this.g=[];this.l=this.a=null}
function Ti(a){var b=Vd();return ci(a).then(function(a){a:{var c=dd(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var h=a[f];var m=c;var p=e;0==h.indexOf("chrome-extension://")?m=dd(h).b==m&&"chrome-extension"==p:"http"!=p&&"https"!=p?m=!1:fe.test(h)?m=m==h:(h=h.split(".").join("\\."),m=(new RegExp("^(.+\\."+h+"|"+h+")$","i")).test(m));if(m){a=!0;break a}}a=!1}if(!a)throw new Ag(Vd());})}
function Ui(a){if(a.l)return a.l;a.l=he().then(function(){if(!a.u){var b=a.c,c=a.h,d=Ri(a.b),e=new Pi(a.m,a.f,a.b);e.f=b;e.b=c;e.c=Ja(d||[]);a.u=e.toString()}a.i=new Gi(a.u);Vi(a)});return a.l}g=Si.prototype;g.Ea=function(a,b,c){var d=new L("popup-closed-by-user"),e=new L("web-storage-unsupported"),f=this,h=!1;return this.ga().then(function(){Wi(f).then(function(c){c||(a&&be(a),b(e),h=!0)})}).s(function(){}).then(function(){if(!h)return ee(a)}).then(function(){if(!h)return Hc(c).then(function(){b(d)})})};
g.Mb=function(){var a=H();return!we(a)&&!Ae(a)};g.Hb=function(){return!1};
g.Cb=function(a,b,c,d,e,f,h){if(!a)return C(new L("popup-blocked"));if(h&&!we())return this.ga().s(function(b){be(a);e(b)}),d(),B();this.a||(this.a=Ti(Xi(this)));var m=this;return this.a.then(function(){var b=m.ga().s(function(b){be(a);e(b);throw b;});d();return b}).then(function(){vg(c);if(!h){var d=Yi(m.m,m.f,m.b,b,c,null,f,m.c,void 0,m.h);Wd(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(m.a=null);throw a;})};
function Xi(a){a.o||(a.v=a.c?re(a.c,Ri(a.b)):null,a.o=new Jh(a.f,yf(a.h),a.v));return a.o}g.Ca=function(a,b,c){this.a||(this.a=Ti(Xi(this)));var d=this;return this.a.then(function(){vg(b);var e=Yi(d.m,d.f,d.b,a,b,Vd(),c,d.c,void 0,d.h);Wd(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};g.ga=function(){var a=this;return Ui(this).then(function(){return a.i.fb}).s(function(){a.a=null;throw new L("network-request-failed");})};g.Qb=function(){return!0};
function Yi(a,b,c,d,e,f,h,m,p,x){a=new Qi(a,b,c,d,e);a.i=f;a.g=h;a.h=m;a.b=$a(p||null);a.f=x;return a.toString()}function Vi(a){if(!a.i)throw Error("IfcHandler must be initialized!");Li(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=xg(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return B(c)}c.status="ERROR";return B(c)})}
function Wi(a){var b={type:"webStorageSupport"};return Ui(a).then(function(){return Ki(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}g.wa=function(a){this.g.push(a)};g.Ka=function(a){w(this.g,function(b){return b==a})};function Zi(a){this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new L("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}g=Zi.prototype;g.get=function(a){return B(this.a.getItem(a)).then(function(a){return a&&ze(a)})};g.set=function(a,b){return B(this.a.setItem(a,xe(b)))};g.P=function(a){return B(this.a.removeItem(a))};g.Y=function(){};g.ca=function(){};function $i(a){this.b=a;this.a={};this.c=r(this.f,this)}var aj=[];function bj(){var a=me()?self:null;v(aj,function(c){c.b==a&&(b=c)});if(!b){var b=new $i(a);aj.push(b)}return b}
$i.prototype.f=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];v(d,function(b){e.push(B().then(function(){return b(a.origin,a.data.data)}))});wb(e).then(function(d){var e=[];v(d,function(a){e.push({fulfilled:a.Db,value:a.value,reason:a.reason?a.reason.message:void 0})});v(e,function(a){for(var b in a)"undefined"===typeof a[b]&&delete a[b]});a.ports[0].postMessage({status:"done",eventId:c,
eventType:b,response:e})})}};$i.prototype.subscribe=function(a,b){Za(this.a)&&this.b.addEventListener("message",this.c);"undefined"===typeof this.a[a]&&(this.a[a]=[]);this.a[a].push(b)};$i.prototype.unsubscribe=function(a,b){"undefined"!==typeof this.a[a]&&b?(w(this.a[a],function(a){return a==b}),0==this.a[a].length&&delete this.a[a]):b||delete this.a[a];Za(this.a)&&this.b.removeEventListener("message",this.c)};function cj(a){this.a=a}cj.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function dj(a){this.c=a;this.b=!1;this.a=[]}
function ej(a,b,c,d){var e,f=c||{},h,m,p,x=null;if(a.b)return C(Error("connection_unavailable"));var gb=d?800:50,la="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new A(function(c,d){la?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),la.port1.start(),m=setTimeout(function(){d(Error("unsupported_event"))},gb),h=function(a){a.data.eventId===e&&("ack"===a.data.status?(clearTimeout(m),p=setTimeout(function(){d(Error("timeout"))},3E3)):"done"===a.data.status?(clearTimeout(p),
"undefined"!==typeof a.data.response?c(a.data.response):d(Error("unknown_error"))):(clearTimeout(m),clearTimeout(p),d(Error("invalid_response"))))},x={messageChannel:la,onMessage:h},a.a.push(x),la.port1.addEventListener("message",h),a.c.postMessage({eventType:b,eventId:e,data:f},[la.port2])):d(Error("connection_unavailable"))})).then(function(b){fj(a,x);return b}).s(function(b){fj(a,x);throw b;})}
function fj(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());w(a.a,function(a){return a==b})}}dj.prototype.close=function(){for(;0<this.a.length;)fj(this,this.a[0]);this.b=!0};function gj(){if(!hj())throw new L("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.m=k.indexedDB;this.type="indexedDB";this.g=this.l=this.f=this.i=null;this.u=!1;this.h=null;var a=this;me()&&self?(this.l=bj(),this.l.subscribe("keyChanged",function(b,c){return ij(a).then(function(b){0<b.length&&v(a.a,function(a){a(b)});return{keyProcessed:Ga(b,c.key)}})}),this.l.subscribe("ping",function(){return B(["keyChanged"])})):Ie().then(function(b){if(a.h=b)a.g=new dj(new cj(b)),ej(a.g,"ping",null,
!0).then(function(b){b[0].fulfilled&&Ga(b[0].value,"keyChanged")&&(a.u=!0)}).s(function(){})})}var jj;function kj(a){return new A(function(b,c){var d=a.m.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(a){c(Error(a.target.error))}})}
function lj(a){return new A(function(b,c){var d=a.m.open("firebaseLocalStorageDb",1);d.onerror=function(a){try{a.preventDefault()}catch(f){}c(Error(a.target.error))};d.onupgradeneeded=function(a){a=a.target.result;try{a.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(d){d=d.target.result;d.objectStoreNames.contains("firebaseLocalStorage")?b(d):kj(a).then(function(){return lj(a)}).then(function(a){b(a)}).s(function(a){c(a)})}})}
function mj(a){a.o||(a.o=lj(a));return a.o}function hj(){try{return!!k.indexedDB}catch(a){return!1}}function nj(a){return a.objectStore("firebaseLocalStorage")}function oj(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function pj(a){return new A(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(a.target.error)}})}g=gj.prototype;
g.set=function(a,b){var c=!1,d,e=this;return mj(this).then(function(b){d=b;b=nj(oj(d,!0));return pj(b.get(a))}).then(function(f){var h=nj(oj(d,!0));if(f)return f.value=b,pj(h.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return pj(h.add(f))}).then(function(){e.c[a]=b;return qj(e,a)}).ia(function(){c&&e.b--})};function qj(a,b){return a.g&&a.h&&He()===a.h?ej(a.g,"keyChanged",{key:b},a.u).then(function(){}).s(function(){}):B()}
g.get=function(a){return mj(this).then(function(b){return pj(nj(oj(b,!1)).get(a))}).then(function(a){return a&&a.value})};g.P=function(a){var b=!1,c=this;return mj(this).then(function(d){b=!0;c.b++;return pj(nj(oj(d,!0))["delete"](a))}).then(function(){delete c.c[a];return qj(c,a)}).ia(function(){b&&c.b--})};
function ij(a){return mj(a).then(function(a){var b=nj(oj(a,!1));return b.getAll?pj(b.getAll()):new A(function(a,c){var d=[],e=b.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){c(a.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=Xd(a.c,c);a.c=c}return d})}g.Y=function(a){0==this.a.length&&rj(this);this.a.push(a)};
g.ca=function(a){w(this.a,function(b){return b==a});0==this.a.length&&sj(this)};function rj(a){function b(){a.f=setTimeout(function(){a.i=ij(a).then(function(b){0<b.length&&v(a.a,function(a){a(b)})}).then(function(){b()}).s(function(a){"STOP_EVENT"!=a.message&&b()})},800)}sj(a);b()}function sj(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function tj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=B().then(function(){if(hj()){var a=te(),e="__sak"+a;jj||(jj=new gj);c=jj;return c.set(e,a).then(function(){return c.get(e)}).then(function(b){if(b!==a)throw Error("indexedDB not supported!");return c.P(e)}).then(function(){return c}).s(function(){return b.c})}return b.c}).then(function(a){b.type=a.type;a.Y(function(a){v(b.a,function(b){b(a)})});return a})}g=tj.prototype;g.get=function(a){return this.b.then(function(b){return b.get(a)})};
g.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};g.P=function(a){return this.b.then(function(b){return b.P(a)})};g.Y=function(a){this.a.push(a)};g.ca=function(a){w(this.a,function(b){return b==a})};function uj(){this.a={};this.type="inMemory"}g=uj.prototype;g.get=function(a){return B(this.a[a])};g.set=function(a,b){this.a[a]=b;return B()};g.P=function(a){delete this.a[a];return B()};g.Y=function(){};g.ca=function(){};function vj(){if(!wj()){if("Node"==ne())throw new L("internal-error","The LocalStorage compatibility library was not found.");throw new L("web-storage-unsupported");}this.a=xj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;this.type="localStorage"}function xj(){try{var a=k.localStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function wj(){var a="Node"==ne();a=xj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=vj.prototype;g.get=function(a){var b=this;return B().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return B().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return B().then(function(){b.a.removeItem(a)})};
g.Y=function(a){k.window&&rc(k.window,"storage",a)};g.ca=function(a){k.window&&E(k.window,"storage",a)};function yj(){this.type="nullStorage"}g=yj.prototype;g.get=function(){return B(null)};g.set=function(){return B()};g.P=function(){return B()};g.Y=function(){};g.ca=function(){};function zj(){if(!Aj()){if("Node"==ne())throw new L("internal-error","The SessionStorage compatibility library was not found.");throw new L("web-storage-unsupported");}this.a=Bj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Bj(){try{var a=k.sessionStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Aj(){var a="Node"==ne();a=Bj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=zj.prototype;g.get=function(a){var b=this;return B().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return B().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return B().then(function(){b.a.removeItem(a)})};g.Y=function(){};
g.ca=function(){};function Cj(){var a={};a.Browser=Dj;a.Node=Ej;a.ReactNative=Fj;a.Worker=Gj;this.a=a[ne()]}var Hj,Dj={A:vj,Ra:zj},Ej={A:vj,Ra:zj},Fj={A:Zi,Ra:yj},Gj={A:vj,Ra:yj};var Ij={Zc:"local",NONE:"none",ad:"session"};function Jj(a){var b=new L("invalid-persistence-type"),c=new L("unsupported-persistence-type");a:{for(d in Ij)if(Ij[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(ne()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!se()&&"none"!==a)throw c;}}
function Kj(){var a=!Ae(H())&&le()?!0:!1,b=we(),c=se();this.o=a;this.h=b;this.l=c;this.a={};Hj||(Hj=new Cj);a=Hj;try{this.g=!Ud()&&Ge()||!k.indexedDB?new a.a.A:new tj(me()?new uj:new a.a.A)}catch(d){this.g=new uj,this.h=!0}try{this.i=new a.a.Ra}catch(d){this.i=new uj}this.m=new uj;this.f=r(this.Pb,this);this.b={}}var Lj;function Mj(){Lj||(Lj=new Kj);return Lj}function Nj(a,b){switch(b){case "session":return a.i;case "none":return a.m;default:return a.g}}
function Oj(a,b){return"firebase:"+a.name+(b?":"+b:"")}function Pj(a,b,c){var d=Oj(b,c),e=Nj(a,b.A);return a.get(b,c).then(function(f){var h=null;try{h=ze(k.localStorage.getItem(d))}catch(m){}if(h&&!f)return k.localStorage.removeItem(d),a.set(b,h,c);h&&f&&"localStorage"!=e.type&&k.localStorage.removeItem(d)})}g=Kj.prototype;g.get=function(a,b){return Nj(this,a.A).get(Oj(a,b))};function Qj(a,b,c){c=Oj(b,c);"local"==b.A&&(a.b[c]=null);return Nj(a,b.A).P(c)}
g.set=function(a,b,c){var d=Oj(a,c),e=this,f=Nj(this,a.A);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.A&&(e.b[d]=b)})};g.addListener=function(a,b,c){a=Oj(a,b);this.l&&(this.b[a]=k.localStorage.getItem(a));Za(this.a)&&(Nj(this,"local").Y(this.f),this.h||(Ud()||!Ge())&&k.indexedDB||!this.l||Rj(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
g.removeListener=function(a,b,c){a=Oj(a,b);this.a[a]&&(w(this.a[a],function(a){return a==c}),0==this.a[a].length&&delete this.a[a]);Za(this.a)&&(Nj(this,"local").ca(this.f),Sj(this))};function Rj(a){Sj(a);a.c=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new fc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Pb(c))}},1E3)}function Sj(a){a.c&&(clearInterval(a.c),a.c=null)}
g.Pb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Xa(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?Nj(this,"local").ca(this.f):Sj(this);if(this.o)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.Xa(b)};Pb&&$b&&10==$b&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else v(a,r(this.Xa,this))};g.Xa=function(a){this.a[a]&&v(this.a[a],function(a){a()})};function Tj(a){this.a=a;this.b=Mj()}var Uj={name:"authEvent",A:"local"};function Vj(a){return a.b.get(Uj,a.a).then(function(a){return xg(a)})};function Wj(){this.a=Mj()};function Xj(){this.b=-1};function Yj(a,b){this.b=Zj;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=k.Int32Array?new Int32Array(64):Array(64);void 0!==ak||(k.Int32Array?ak=new Int32Array(bk):ak=bk);this.reset()}var ak;t(Yj,Xj);for(var Zj=64,ck=Zj-1,dk=[],ek=0;ek<ck;ek++)dk[ek]=0;var fk=Ia(128,dk);Yj.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):Ja(this.h)};
function gk(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,h=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+h|0}d=a.a[0]|0;e=a.a[1]|0;var m=a.a[2]|0,p=a.a[3]|0,x=a.a[4]|0,gb=a.a[5]|0,la=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Rl=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&m^e&m)|0;h=x&gb^~x&la;f=f+((x>>>6|x<<26)^(x>>>11|x<<21)^(x>>>
25|x<<7))|0;h=h+(ak[b]|0)|0;h=f+(h+(c[b]|0)|0)|0;f=la;la=gb;gb=x;x=p+h|0;p=m;m=e;e=d;d=h+Rl|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+m|0;a.a[3]=a.a[3]+p|0;a.a[4]=a.a[4]+x|0;a.a[5]=a.a[5]+gb|0;a.a[6]=a.a[6]+la|0;a.a[7]=a.a[7]+f|0}
function hk(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(l(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(gk(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(gk(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var bk=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function ik(){Yj.call(this,8,jk)}t(ik,Yj);var jk=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function kk(a,b,c,d,e){this.m=a;this.i=b;this.l=c;this.o=d||null;this.u=e||null;this.h=b+":"+c;this.v=new Wj;this.g=new Tj(this.h);this.f=null;this.b=[];this.a=this.c=null}function lk(a){return new L("invalid-cordova-configuration",a)}g=kk.prototype;
g.ga=function(){return this.za?this.za:this.za=ie().then(function(){if("function"!==typeof I("universalLinks.subscribe",k))throw lk("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof I("BuildInfo.packageName",k))throw lk("cordova-plugin-buildinfo is not installed");if("function"!==typeof I("cordova.plugins.browsertab.openUrl",k))throw lk("cordova-plugin-browsertab is not installed");if("function"!==typeof I("cordova.InAppBrowser.open",k))throw lk("cordova-plugin-inappbrowser is not installed");
},function(){throw new L("cordova-not-ready");})};function mk(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function nk(a){var b=new ik;hk(b,a);a=[];var c=8*b.g;56>b.c?hk(b,fk,56-b.c):hk(b,fk,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;gk(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return of(a)}
g.Ea=function(a,b){b(new L("operation-not-supported-in-this-environment"));return B()};g.Cb=function(){return C(new L("operation-not-supported-in-this-environment"))};g.Qb=function(){return!1};g.Mb=function(){return!0};g.Hb=function(){return!0};
g.Ca=function(a,b,c){if(this.c)return C(new L("redirect-operation-pending"));var d=this,e=k.document,f=null,h=null,m=null,p=null;return this.c=B().then(function(){vg(b);return ok(d)}).then(function(){return pk(d,a,b,c)}).then(function(){return(new A(function(a,b){h=function(){var b=I("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.wa(h);m=function(){f||(f=Hc(2E3).then(function(){b(new L("redirect-cancelled-by-user"))}))};
p=function(){De()&&m()};e.addEventListener("resume",m,!1);H().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",p,!1)})).s(function(a){return qk(d).then(function(){throw a;})})}).ia(function(){m&&e.removeEventListener("resume",m,!1);p&&e.removeEventListener("visibilitychange",p,!1);f&&f.cancel();h&&d.Ka(h);d.c=null})};
function pk(a,b,c,d){var e=mk(),f=new wg(b,d,null,e,new L("no-auth-event")),h=I("BuildInfo.packageName",k);if("string"!==typeof h)throw new L("invalid-cordova-configuration");var m=I("BuildInfo.displayName",k),p={};if(H().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(H().toLowerCase().match(/android/))p.apn=h;else return C(new L("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);e=nk(e);p.sessionId=e;var x=Yi(a.m,a.i,a.l,b,c,null,d,a.o,p,a.u);return a.ga().then(function(){var b=
a.h;return a.v.a.set(Uj,f.C(),b)}).then(function(){var b=I("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new L("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=I("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new L("invalid-cordova-configuration");c(x)}else{c=I("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new L("invalid-cordova-configuration");b=H();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.a=c(x,b?"_blank":"_system","location=yes")}})})}function rk(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function ok(a){a.f||(a.f=a.ga().then(function(){return new A(function(b){function c(d){b(d);a.Ka(c);return!1}a.wa(c);sk(a)})}));return a.f}function qk(a){var b=null;return Vj(a.g).then(function(c){b=c;c=a.g;return Qj(c.b,Uj,c.a)}).then(function(){return b})}
function sk(a){function b(b){d=!0;e&&e.cancel();qk(a).then(function(d){var e=c;if(d&&b&&b.url){var f=null;e=Of(b.url);-1!=e.indexOf("/__/auth/callback")&&(f=dd(e),f=ze(cd(f,"firebaseError")||null),f=(f="object"===typeof f?bf(f):null)?new wg(d.b,d.c,null,null,f):new wg(d.b,d.c,e,d.g));e=f||c}rk(a,e)})}var c=new wg("unknown",null,null,null,new L("no-auth-event")),d=!1,e=Hc(500).then(function(){return qk(a).then(function(){d||rk(a,c)})}),f=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(I("BuildInfo.packageName",
k).toLowerCase()+"://")&&b({url:a});if("function"===typeof f)try{f(a)}catch(m){console.error(m)}};zg||(zg=new yg);zg.subscribe(b)}g.wa=function(a){this.b.push(a);ok(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new wg("unknown",null,null,null,new L("no-auth-event")),a(b))})};g.Ka=function(a){w(this.b,function(b){return b==a})};function tk(a){this.a=a;this.b=Mj()}var uk={name:"pendingRedirect",A:"session"};function vk(a){return a.b.set(uk,"pending",a.a)}function wk(a){return Qj(a.b,uk,a.a)}function xk(a){return a.b.get(uk,a.a).then(function(a){return"pending"==a})};function yk(a,b,c){this.u=a;this.l=b;this.m=c;this.h=[];this.f=!1;this.i=r(this.bb,this);this.b=new zk;this.o=new Ak;this.g=new tk(this.l+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.o;this.c.linkViaPopup=this.o;this.c.reauthViaPopup=this.o;this.a=Bk(this.u,this.l,this.m,zf)}function Bk(a,b,c,d){var e=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null;return je()?new kk(a,b,c,e,d):new Si(a,b,c,e,d)}g=yk.prototype;
g.reset=function(){this.f=!1;this.a.Ka(this.i);this.a=Bk(this.u,this.l,this.m)};g.Ya=function(){this.b.Ya()};function Ck(a){a.f||(a.f=!0,a.a.wa(a.i));var b=a.a;return a.a.ga().s(function(c){a.a==b&&a.reset();throw c;})}function Dk(a){a.a.Mb()&&Ck(a).s(function(b){var c=new wg("unknown",null,null,null,new L("operation-not-supported-in-this-environment"));Ek(b)&&a.bb(c)});a.a.Hb()||Fk(a.b)}
g.subscribe=function(a){Ga(this.h,a)||this.h.push(a);if(!this.f){var b=this;xk(this.g).then(function(a){a?wk(b.g).then(function(){Ck(b).s(function(a){var c=new wg("unknown",null,null,null,new L("operation-not-supported-in-this-environment"));Ek(a)&&b.bb(c)})}):Dk(b)}).s(function(){Dk(b)})}};g.unsubscribe=function(a){w(this.h,function(b){return b==a})};
g.bb=function(a){if(!a)throw new L("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.vb(a.b,a.c)){(b=this.c[a.b])&&b.h(a,d);b=!0;break}}Fk(this.b);return b};var Gk=new Ce(2E3,1E4),Hk=new Ce(3E4,6E4);yk.prototype.fa=function(){return this.b.fa()};function Ik(a,b,c,d,e,f){return a.a.Cb(b,c,d,function(){a.f||(a.f=!0,a.a.wa(a.i))},function(){a.reset()},e,f)}function Ek(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
yk.prototype.Ca=function(a,b,c){var d=this,e;return vk(this.g).then(function(){return d.a.Ca(a,b,c).s(function(a){if(Ek(a))throw new L("operation-not-supported-in-this-environment");e=a;return wk(d.g).then(function(){throw e;})}).then(function(){return d.a.Qb()?new A(function(){}):wk(d.g).then(function(){return d.fa()}).then(function(){}).s(function(){})})})};yk.prototype.Ea=function(a,b,c,d){return this.a.Ea(c,function(c){a.ha(b,null,c,d)},Gk.get())};var Jk={};
function Kk(a,b,c){var d=b+":"+c;Jk[d]||(Jk[d]=new yk(a,b,c));return Jk[d]}function zk(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}zk.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
zk.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(Lk(this,!0,null,a.a),B()):b.xa(c,d)?Mk(this,a,b):C(new L("invalid-auth-event")):(Lk(this,!1,null,null),B())}else C(new L("invalid-auth-event"))};function Fk(a){a.g||(a.g=!0,Lk(a,!1,null,null))}zk.prototype.Ya=function(){this.g&&!this.i&&Lk(this,!1,null,null)};
function Mk(a,b,c){c=c.xa(b.b,b.c);var d=b.f,e=b.g,f=b.h,h=!!b.b.match(/Redirect$/);c(d,e,f).then(function(b){Lk(a,h,b,null)}).s(function(b){Lk(a,h,null,b)})}function Nk(a,b){a.b=function(){return C(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function Ok(a,b){a.b=function(){return B(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function Lk(a,b,c,d){b?d?Nk(a,d):Ok(a,c):Ok(a,{user:null});a.f=[];a.c=[]}
zk.prototype.fa=function(){var a=this;return new A(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),Pk(a))})};function Pk(a){var b=new L("timeout");a.a&&a.a.cancel();a.a=Hc(Hk.get()).then(function(){a.b||(a.g=!0,Lk(a,!0,null,b))})}function Ak(){}Ak.prototype.h=function(a,b){if(a){var c=a.b,d=a.c;a.a?(b.ha(a.b,null,a.a,a.c),B()):b.xa(c,d)?Qk(a,b):C(new L("invalid-auth-event"))}else C(new L("invalid-auth-event"))};
function Qk(a,b){var c=a.c,d=a.b;b.xa(d,c)(a.f,a.g,a.h).then(function(a){b.ha(d,a,null,c)}).s(function(a){b.ha(d,null,a,c)})};function Rk(){this.sb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.sb},set:function(a){this.sb=a},enumerable:!1})};function Sk(a,b){this.a=b;J(this,"verificationId",a)}Sk.prototype.confirm=function(a){a=tg(this.verificationId,a);return this.a(a)};function Tk(a,b,c,d){return(new rg(a)).Ua(b,c).then(function(a){return new Sk(a,d)})};function Uk(a){var b=wf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new L("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");K(this,{token:a,expirationTime:Fe(1E3*b.exp),authTime:Fe(1E3*b.auth_time),issuedAtTime:Fe(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function Vk(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}Vk.prototype.start=function(){this.a=this.c;Wk(this,!0)};function Xk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Wk(a,b){a.stop();a.b=Hc(Xk(a,b)).then(function(){return Ee()}).then(function(){return a.h()}).then(function(){Wk(a,!0)}).s(function(b){a.i(b)&&Wk(a,!1)})}
Vk.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Yk(a){this.f=a;this.b=this.a=null;this.c=0}Yk.prototype.C=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Zk(a,b){var c=b[M],d=b.refreshToken;b=$k(b.expiresIn);a.b=c;a.c=b;a.a=d}function al(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function $k(a){return oa()+1E3*parseInt(a,10)}
function bl(a,b){return Vh(a.f,b).then(function(b){a.b=b.access_token;a.c=$k(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}Yk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?C(new L("user-token-expired")):a||!this.b||oa()>this.c-3E4?this.a?bl(this,{grant_type:"refresh_token",refresh_token:this.a}):B(null):B({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function cl(a,b){this.a=a||null;this.b=b||null;K(this,{lastSignInTime:Fe(b||null),creationTime:Fe(a||null)})}function dl(a){return new cl(a.a,a.b)}cl.prototype.C=function(){return{lastLoginAt:this.b,createdAt:this.a}};function el(a,b,c,d,e,f){K(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function fl(a,b){D.call(this,a);for(var c in b)this[c]=b[c]}t(fl,D);
function Q(a,b,c){this.G=[];this.m=a.apiKey;this.o=a.appName;this.u=a.authDomain||null;a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null;this.b=new Jh(this.m,yf(zf),a);this.h=new Yk(this.b);gl(this,b[M]);Zk(this.h,b);J(this,"refreshToken",this.h.a);hl(this,c||{});F.call(this);this.I=!1;this.u&&ue()&&(this.a=Kk(this.u,this.m,this.o));this.N=[];this.i=null;this.w=il(this);this.V=r(this.Ha,this);var d=this;this.ka=null;this.ta=function(a){d.pa(a.g)};this.X=null;this.O=[];this.sa=function(a){jl(d,
a.c)};this.W=null}t(Q,F);Q.prototype.pa=function(a){this.ka=a;Ph(this.b,a)};Q.prototype.ea=function(){return this.ka};function kl(a,b){a.X&&E(a.X,"languageCodeChanged",a.ta);(a.X=b)&&rc(b,"languageCodeChanged",a.ta)}function jl(a,b){a.O=b;Qh(a.b,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,a.O):null)}Q.prototype.ya=function(){return Ja(this.O)};function ll(a,b){a.W&&E(a.W,"frameworkChanged",a.sa);(a.W=b)&&rc(b,"frameworkChanged",a.sa)}Q.prototype.Ha=function(){this.w.b&&(this.w.stop(),this.w.start())};
function ml(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a.o).auth()}catch(b){throw new L("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function il(a){return new Vk(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-oa()-3E5;return 0<b?b:0})}function nl(a){a.D||a.w.b||(a.w.start(),E(a,"tokenChanged",a.V),rc(a,"tokenChanged",a.V))}function ol(a){E(a,"tokenChanged",a.V);a.w.stop()}
function gl(a,b){a.ra=b;J(a,"_lat",b)}function pl(a,b){w(a.N,function(a){return a==b})}function ql(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return wb(b).then(function(){return a})}function rl(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
function hl(a,b){K(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new cl(b.createdAt,b.lastLoginAt),providerData:[]})}J(Q.prototype,"providerId","firebase");function sl(){}function tl(a){return B().then(function(){if(a.D)throw new L("app-deleted");})}function ul(a){return Ca(a.providerData,function(a){return a.providerId})}
function vl(a,b){b&&(wl(a,b.providerId),a.providerData.push(b))}function wl(a,b){w(a.providerData,function(a){return a.providerId==b})}function xl(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&J(a,b,c)}
function yl(a,b){a!=b&&(K(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?J(a,"metadata",dl(b.metadata)):J(a,"metadata",new cl),v(b.providerData,function(b){vl(a,b)}),al(a.h,b.h),J(a,"refreshToken",a.h.a))}g=Q.prototype;g.reload=function(){var a=this;return R(this,tl(this).then(function(){return zl(a).then(function(){return ql(a)}).then(sl)}))};
function zl(a){return a.F().then(function(b){var c=a.isAnonymous;return Al(a,b).then(function(){c||xl(a,"isAnonymous",!1);return b})})}g.dc=function(a){return this.F(a).then(function(a){return new Uk(a)})};g.F=function(a){var b=this;return R(this,tl(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new L("internal-error");a.accessToken!=b.ra&&(gl(b,a.accessToken),b.dispatchEvent(new fl("tokenChanged")));xl(b,"refreshToken",a.refreshToken);return a.accessToken}))};
function Bl(a,b){b[M]&&a.ra!=b[M]&&(Zk(a.h,b),a.dispatchEvent(new fl("tokenChanged")),gl(a,b[M]),xl(a,"refreshToken",a.h.a))}function Al(a,b){return P(a.b,Di,{idToken:b}).then(r(a.xc,a))}
g.xc=function(a){a=a.users;if(!a||!a.length)throw new L("internal-error");a=a[0];hl(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=Cl(a),c=0;c<b.length;c++)vl(this,b[c]);xl(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function Cl(a){return(a=a.providerUserInfo)&&a.length?Ca(a,function(a){return new el(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}g.gb=function(a){var b=this,c=null;return R(this,a.f(this.b,this.uid).then(function(a){Bl(b,a);c=Dl(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};
g.yc=function(a){Ke("firebase.User.prototype.reauthenticateWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential instead.");return this.gb(a).then(function(){})};function El(a,b){return zl(a).then(function(){if(Ga(ul(a),b))return ql(a).then(function(){throw new L("provider-already-linked");})})}
g.eb=function(a){var b=this,c=null;return R(this,El(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.b(b.b,c)}).then(function(a){c=Dl(b,a,"link");return Fl(b,a)}).then(function(){return c}))};g.pc=function(a){Ke("firebase.User.prototype.linkWithCredential is deprecated. Please use firebase.User.prototype.linkAndRetrieveDataWithCredential instead.");return this.eb(a).then(function(a){return a.user})};
g.qc=function(a,b){var c=this;return R(this,El(this,"phone").then(function(){return Tk(ml(c),a,b,r(c.eb,c))}))};g.zc=function(a,b){var c=this;return R(this,B().then(function(){return Tk(ml(c),a,b,r(c.gb,c))}),!0)};function Dl(a,b,c){var d=ug(b);b=Ef(b);return Ne({user:a,credential:d,additionalUserInfo:b,operationType:c})}function Fl(a,b){Bl(a,b);return a.reload().then(function(){return a})}
g.pb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.pb(c,a)}).then(function(a){Bl(b,a);return b.reload()}))};g.Rc=function(a){var b=this;return R(this,this.F().then(function(c){return a.b(b.b,c)}).then(function(a){Bl(b,a);return b.reload()}))};g.qb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.qb(c,a)}).then(function(a){Bl(b,a);return b.reload()}))};
g.rb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return tl(this);var b=this;return R(this,this.F().then(function(c){return b.b.rb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){Bl(b,a);xl(b,"displayName",a.displayName||null);xl(b,"photoURL",a.photoUrl||null);v(b.providerData,function(a){"password"===a.providerId&&(J(a,"displayName",b.displayName),J(a,"photoURL",b.photoURL))});return ql(b)}).then(sl))};
g.Pc=function(a){var b=this;return R(this,zl(this).then(function(c){return Ga(ul(b),a)?oi(b.b,c,[a]).then(function(a){var c={};v(a.providerUserInfo||[],function(a){c[a.providerId]=!0});v(ul(b),function(a){c[a]||wl(b,a)});c[rg.PROVIDER_ID]||J(b,"phoneNumber",null);return ql(b)}):ql(b).then(function(){throw new L("no-such-provider");})}))};
g.delete=function(){var a=this;return R(this,this.F().then(function(b){return P(a.b,Ci,{idToken:b})}).then(function(){a.dispatchEvent(new fl("userDeleted"))})).then(function(){for(var b=0;b<a.G.length;b++)a.G[b].cancel("app-deleted");kl(a,null);ll(a,null);a.G=[];a.D=!0;ol(a);J(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
g.vb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.aa||null)==b||"reauthViaRedirect"==a&&(this.aa||null)==b?!0:!1};g.ha=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
g.xa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.Ab,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.Bb,this):"linkViaRedirect"==a&&(this.aa||null)==b?r(this.Ab,this):"reauthViaRedirect"==a&&(this.aa||null)==b?r(this.Bb,this):null};g.rc=function(a){var b=this;return Gl(this,"linkViaPopup",a,function(){return El(b,a.providerId).then(function(){return ql(b)})},!1)};g.Ac=function(a){return Gl(this,"reauthViaPopup",a,function(){return B()},!0)};
function Gl(a,b,c,d,e){if(!ue())return C(new L("operation-not-supported-in-this-environment"));if(a.i&&!e)return C(a.i);var f=Df(c.providerId),h=te(a.uid+":::"),m=null;(!we()||le())&&a.u&&c.isOAuthProvider&&(m=Yi(a.u,a.m,a.o,b,c,null,h,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var p=ce(m,f&&f.Ba,f&&f.Aa);d=d().then(function(){Hl(a);if(!e)return a.F().then(function(){})}).then(function(){return Ik(a.a,p,b,c,h,!!m)}).then(function(){return new A(function(c,d){a.ha(b,null,new L("cancelled-popup-request"),a.g||null);
a.f=c;a.v=d;a.g=h;a.c=a.a.Ea(a,b,p,h)})}).then(function(a){p&&be(p);return a?Ne(a):null}).s(function(a){p&&be(p);throw a;});return R(a,d,e)}g.sc=function(a){var b=this;return Il(this,"linkViaRedirect",a,function(){return El(b,a.providerId)},!1)};g.Bc=function(a){return Il(this,"reauthViaRedirect",a,function(){return B()},!0)};
function Il(a,b,c,d,e){if(!ue())return C(new L("operation-not-supported-in-this-environment"));if(a.i&&!e)return C(a.i);var f=null,h=te(a.uid+":::");d=d().then(function(){Hl(a);if(!e)return a.F().then(function(){})}).then(function(){a.aa=h;return ql(a)}).then(function(b){a.ba&&(b=a.ba,b=b.b.set(Jl,a.C(),b.a));return b}).then(function(){return a.a.Ca(b,c,h)}).s(function(b){f=b;if(a.ba)return Kl(a.ba);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function Hl(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new L("internal-error");throw new L("auth-domain-config-required");}}g.Ab=function(a,b,c){var d=this;this.c&&(this.c.cancel(),this.c=null);var e=null,f=this.F().then(function(e){return Tf(d.b,{requestUri:a,postBody:c,sessionId:b,idToken:e})}).then(function(a){e=Dl(d,a,"link");return Fl(d,a)}).then(function(){return e});return R(this,f)};
g.Bb=function(a,b,c){var d=this;this.c&&(this.c.cancel(),this.c=null);var e=null,f=B().then(function(){return Pf(Uf(d.b,{requestUri:a,sessionId:b,postBody:c}),d.uid)}).then(function(a){e=Dl(d,a,"reauthenticate");Bl(d,a);d.i=null;return d.reload()}).then(function(){return e});return R(this,f,!0)};g.jb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Za(a)?{}:nf(new cf(a))}).then(function(a){return b.b.jb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
function R(a,b,c){var d=Ll(a,b,c);a.G.push(d);d.ia(function(){Ha(a.G,d)});return d}function Ll(a,b,c){return a.i&&!c?(b.cancel(),C(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||a.dispatchEvent(new fl("userInvalidated")),a.i=b);throw b;})}g.toJSON=function(){return this.C()};
g.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.m,appName:this.o,authDomain:this.u,stsTokenManager:this.h.C(),redirectEventId:this.aa||null};this.metadata&&bb(a,this.metadata.C());v(this.providerData,function(b){a.providerData.push(Oe(b))});return a};
function Ml(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[M]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-oa())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&v(a.providerData,function(a){a&&vl(d,Ne(a))});a.redirectEventId&&(d.aa=a.redirectEventId);return d}
function Nl(a,b,c,d){var e=new Q(a,b);c&&(e.ba=c);d&&jl(e,d);return e.reload().then(function(){return e})}function Ol(a,b,c,d){b=b||{apiKey:a.m,authDomain:a.u,appName:a.o};var e=a.h,f={};f[M]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-oa())/1E3;b=new Q(b,f);c&&(b.ba=c);d&&jl(b,d);yl(b,a);return b};function Pl(a){this.a=a;this.b=Mj()}var Jl={name:"redirectUser",A:"session"};function Kl(a){return Qj(a.b,Jl,a.a)}function Ql(a,b){return a.b.get(Jl,a.a).then(function(a){a&&b&&(a.authDomain=b);return Ml(a||{})})};function Sl(a){this.a=a;this.b=Mj();this.c=null;this.f=Tl(this);this.b.addListener(Ul("local"),this.a,r(this.g,this))}Sl.prototype.g=function(){var a=this,b=Ul("local");Vl(this,function(){return B().then(function(){return a.c&&"local"!=a.c.A?a.b.get(b,a.a):null}).then(function(c){if(c)return Wl(a,"local").then(function(){a.c=b})})})};function Wl(a,b){var c=[],d;for(d in Ij)Ij[d]!==b&&c.push(Qj(a.b,Ul(Ij[d]),a.a));c.push(Qj(a.b,Xl,a.a));return vb(c)}
function Tl(a){var b=Ul("local"),c=Ul("session"),d=Ul("none");return Pj(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(Xl,a.a).then(function(a){return a?Ul(a):b})})})}).then(function(b){a.c=b;return Wl(a,b.A)}).s(function(){a.c||(a.c=b)})}var Xl={name:"persistence",A:"session"};function Ul(a){return{name:"authUser",A:a}}
Sl.prototype.mb=function(a){var b=null,c=this;Jj(a);return Vl(this,function(){return a!=c.c.A?c.b.get(c.c,c.a).then(function(d){b=d;return Wl(c,a)}).then(function(){c.c=Ul(a);if(b)return c.b.set(c.c,b,c.a)}):B()})};function Yl(a){return Vl(a,function(){return a.b.set(Xl,a.c.A,a.a)})}function Zl(a,b){return Vl(a,function(){return a.b.set(a.c,b.C(),a.a)})}function $l(a){return Vl(a,function(){return Qj(a.b,a.c,a.a)})}
function am(a,b){return Vl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return Ml(a||{})})})}function Vl(a,b){a.f=a.f.then(b,b);return a.f};function bm(a){this.m=!1;J(this,"settings",new Rk);J(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null,this.b=new Jh(S(this).options&&S(this).options.apiKey,yf(zf),a);else throw new L("invalid-api-key");this.N=[];this.o=[];this.I=[];this.Tb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(r(this.mc,this));this.O=void 0;this.Ub=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(r(this.nc,this));cm(this,null);this.h=new Sl(S(this).options.apiKey+":"+S(this).name);this.w=
new Pl(S(this).options.apiKey+":"+S(this).name);this.V=T(this,dm(this));this.i=T(this,em(this));this.X=!1;this.ka=r(this.Mc,this);this.Ha=r(this.Z,this);this.ra=r(this.bc,this);this.sa=r(this.jc,this);this.ta=r(this.kc,this);fm(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.tc,this);this.u=0;F.call(this);gm(this);this.G=[]}t(bm,F);function hm(a){D.call(this,"languageCodeChanged");this.g=a}t(hm,D);
function im(a){D.call(this,"frameworkChanged");this.c=a}t(im,D);g=bm.prototype;g.mb=function(a){a=this.h.mb(a);return T(this,a)};g.pa=function(a){this.W===a||this.m||(this.W=a,Ph(this.b,this.W),this.dispatchEvent(new hm(this.ea())))};g.ea=function(){return this.W};g.Sc=function(){var a=k.navigator;this.pa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};g.tc=function(a){this.G.push(a);Qh(this.b,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,this.G):null);this.dispatchEvent(new im(this.G))};
g.ya=function(){return Ja(this.G)};function gm(a){Object.defineProperty(a,"lc",{get:function(){return this.ea()},set:function(a){this.pa(a)},enumerable:!1});a.W=null}g.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).C()}};function jm(a){return a.Sb||C(new L("auth-domain-config-required"))}
function fm(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&ue()&&(a.Sb=a.V.then(function(){if(!a.m){a.a=Kk(b,c,S(a).name);a.a.subscribe(a);U(a)&&rl(U(a));if(a.D){rl(a.D);var d=a.D;d.pa(a.ea());kl(d,a);d=a.D;jl(d,a.G);ll(d,a);a.D=null}return a.a}}))}g.vb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
g.ha=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};g.xa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.ac,this):null};
g.ac=function(a,b,c){var d=this;a={requestUri:a,postBody:c,sessionId:b};this.c&&(this.c.cancel(),this.c=null);var e=null,f=null,h=Rf(d.b,a).then(function(a){e=ug(a);f=Ef(a);return a});a=d.V.then(function(){return h}).then(function(a){return km(d,a)}).then(function(){return Ne({user:U(d),credential:e,additionalUserInfo:f,operationType:"signIn"})});return T(this,a)};
g.Kc=function(a){if(!ue())return C(new L("operation-not-supported-in-this-environment"));var b=this,c=Df(a.providerId),d=te(),e=null;(!we()||le())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Yi(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var f=ce(e,c&&c.Ba,c&&c.Aa);c=jm(this).then(function(b){return Ik(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new A(function(a,c){b.ha("signInViaPopup",null,new L("cancelled-popup-request"),
b.g);b.f=a;b.v=c;b.g=d;b.c=b.a.Ea(b,"signInViaPopup",f,d)})}).then(function(a){f&&be(f);return a?Ne(a):null}).s(function(a){f&&be(f);throw a;});return T(this,c)};g.Lc=function(a){if(!ue())return C(new L("operation-not-supported-in-this-environment"));var b=this,c=jm(this).then(function(){return Yl(b.h)}).then(function(){return b.a.Ca("signInViaRedirect",a)});return T(this,c)};
g.fa=function(){if(!ue())return C(new L("operation-not-supported-in-this-environment"));var a=this,b=jm(this).then(function(){return a.a.fa()}).then(function(a){return a?Ne(a):null});return T(this,b)};
g.Qc=function(a){if(!a)return C(new L("null-user"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=Ol(a,c,b.w,b.ya());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.m)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return yl(U(b),a),b.Z(a);cm(b,d);rl(d);return b.Z(d)}).then(function(){lm(b)}))};
function km(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.V.then(function(){return Nl(c,b,a.w,a.ya())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return yl(U(a),b),a.Z(b);cm(a,b);rl(b);return a.Z(b)}).then(function(){lm(a)})}
function cm(a,b){U(a)&&(pl(U(a),a.Ha),E(U(a),"tokenChanged",a.ra),E(U(a),"userDeleted",a.sa),E(U(a),"userInvalidated",a.ta),ol(U(a)));b&&(b.N.push(a.Ha),rc(b,"tokenChanged",a.ra),rc(b,"userDeleted",a.sa),rc(b,"userInvalidated",a.ta),0<a.u&&nl(b));J(a,"currentUser",b);b&&(b.pa(a.ea()),kl(b,a),jl(b,a.G),ll(b,a))}g.nb=function(){var a=this,b=this.i.then(function(){if(!U(a))return B();cm(a,null);return $l(a.h).then(function(){lm(a)})});return T(this,b)};
function mm(a){var b=Ql(a.w,S(a).options.authDomain).then(function(b){if(a.D=b)b.ba=a.w;return Kl(a.w)});return T(a,b)}function dm(a){var b=S(a).options.authDomain,c=mm(a).then(function(){return am(a.h,b)}).then(function(b){return b?(b.ba=a.w,a.D&&(a.D.aa||null)==(b.aa||null)?b:b.reload().then(function(){return Zl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:$l(a.h)})):null}).then(function(b){cm(a,b||null)});return T(a,c)}
function em(a){return a.V.then(function(){return a.fa()}).s(function(){}).then(function(){if(!a.m)return a.ka()}).s(function(){}).then(function(){if(!a.m){a.X=!0;var b=a.h;b.b.addListener(Ul("local"),b.a,a.ka)}})}
g.Mc=function(){var a=this;return am(this.h,S(this).options.authDomain).then(function(b){if(!a.m){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return yl(U(a),b),U(a).F();if(U(a)||b)cm(a,b),b&&(rl(b),b.ba=a.w),a.a&&a.a.subscribe(a),lm(a)}})};g.Z=function(a){return Zl(this.h,a)};g.bc=function(){lm(this);this.Z(U(this))};g.jc=function(){this.nb()};g.kc=function(){this.nb()};
function nm(a,b){var c=null,d=null;return T(a,b.then(function(b){c=ug(b);d=Ef(b);return km(a,b)}).then(function(){return Ne({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}g.mc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};g.nc=function(a){var b=this;om(this,function(){a.next(U(b))})};g.vc=function(a,b,c){var d=this;this.X&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve().then(function(){n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Tb(a,b,c)};
g.uc=function(a,b,c){var d=this;this.X&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve().then(function(){d.O=d.getUid();n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Ub(a,b,c)};g.cc=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};g.Nb=function(a){var b=this;return this.i.then(function(){return nm(b,P(b.b,Fi,{token:a}))}).then(function(a){var c=a.user;xl(c,"isAnonymous",!1);b.Z(c);return a})};
g.Ec=function(a){Ke("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCustomToken is deprecated. Please use firebase.auth.Auth.prototype.signInWithCustomToken instead.");return this.Nb(a)};g.Fc=function(a,b){Ke("firebase.auth.Auth.prototype.signInAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.signInWithEmailAndPassword instead.");return this.Ob(a,b)};g.Ob=function(a,b){var c=this;return this.i.then(function(){return nm(c,P(c.b,ig,{email:a,password:b}))})};
g.xb=function(a,b){var c=this;return this.i.then(function(){return nm(c,P(c.b,Bi,{email:a,password:b}))})};g.Wb=function(a,b){Ke("firebase.auth.Auth.prototype.createUserAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.createUserWithEmailAndPassword instead.");return this.xb(a,b)};g.Hc=function(a){Ke("firebase.auth.Auth.prototype.signInWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential instead.");return this.Pa(a).then(function(a){return a.user})};
g.Pa=function(a){var b=this;return this.i.then(function(){return nm(b,a.la(b.b))})};g.Qa=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=Ne({providerId:null,isNewUser:!1});return Ne({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return nm(a,a.b.Qa()).then(function(b){var c=b.user;xl(c,"isAnonymous",!0);a.Z(c);return b})})};
g.Gc=function(){Ke("firebase.auth.Auth.prototype.signInAnonymouslyAndRetrieveData is deprecated. Please use firebase.auth.Auth.prototype.signInAnonymously instead.");return this.Qa()};function S(a){return a.app}function U(a){return a.currentUser}g.getUid=function(){return U(this)&&U(this).uid||null};function pm(a){return U(a)&&U(a)._lat||null}
function lm(a){if(a.X){for(var b=0;b<a.o.length;b++)if(a.o[b])a.o[b](pm(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](pm(a))}}g.Vb=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&U(this)&&nl(U(this))};g.Cc=function(a){var b=this;v(this.o,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&U(this)&&ol(U(this));this.removeAuthTokenListener(a)};
g.addAuthTokenListener=function(a){var b=this;this.o.push(a);T(this,this.i.then(function(){b.m||Ga(b.o,a)&&a(pm(b))}))};g.removeAuthTokenListener=function(a){w(this.o,function(b){return b==a})};function om(a,b){a.I.push(b);T(a,a.i.then(function(){!a.m&&Ga(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(pm(a)))}))}
g.delete=function(){this.m=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(Ul("local"),a.a,this.ka));this.a&&(this.a.unsubscribe(this),this.a.Ya());return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.Promise.resolve()};function T(a,b){a.N.push(b);b.ia(function(){Ha(a.N,b)});return b}
g.Zb=function(a){Ke("firebase.auth.Auth.prototype.fetchProvidersForEmail is deprecated. Please use firebase.auth.Auth.prototype.fetchSignInMethodsForEmail instead.");return T(this,$h(this.b,a))};g.$b=function(a){return T(this,bi(this.b,a))};g.oc=function(a){return!!mg(a)};g.lb=function(a,b){var c=this;return T(this,B().then(function(){var a=new cf(b);if(!a.c)throw new L("argument-error",lf+" must be true when sending sign in link to email");return nf(a)}).then(function(b){return c.b.lb(a,b)}).then(function(){}))};
g.Tc=function(a){return this.Ja(a).then(function(a){return a.data.email})};g.Za=function(a,b){return T(this,this.b.Za(a,b).then(function(){}))};g.Ja=function(a){return T(this,this.b.Ja(a).then(function(a){return new Re(a)}))};g.Wa=function(a){return T(this,this.b.Wa(a).then(function(){}))};g.kb=function(a,b){var c=this;return T(this,B().then(function(){return"undefined"===typeof b||Za(b)?{}:nf(new cf(b))}).then(function(b){return c.b.kb(a,b)}).then(function(){}))};
g.Jc=function(a,b){return T(this,Tk(this,a,b,r(this.Pa,this)))};g.Ic=function(a,b){var c=this;return T(this,B().then(function(){var d=lg(a,b||Vd());return c.Pa(d)}))};function qm(){}qm.prototype.render=function(){};qm.prototype.reset=function(){};qm.prototype.getResponse=function(){};qm.prototype.execute=function(){};function rm(){this.a={};this.b=1E12}var sm=null;rm.prototype.render=function(a,b){this.a[this.b.toString()]=new tm(a,b);return this.b++};rm.prototype.reset=function(a){var b=um(this,a);a=vm(a);b&&a&&(b.delete(),delete this.a[a])};rm.prototype.getResponse=function(a){return(a=um(this,a))?a.getResponse():null};rm.prototype.execute=function(a){(a=um(this,a))&&a.execute()};function um(a,b){return(b=vm(b))?a.a[b]||null:null}function vm(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
function tm(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Id(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():rc(this.f,"click",this.i)}tm.prototype.getResponse=function(){wm(this);return this.b};
tm.prototype.execute=function(){wm(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=pe();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};tm.prototype.delete=function(){wm(this);this.g=!0;clearTimeout(this.a);this.a=null;E(this.f,"click",this.i)};function wm(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function xm(){}xm.prototype.g=function(){sm||(sm=new rm);return B(sm)};xm.prototype.c=function(){};var ym=null;function zm(){this.b=k.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var Am=qd("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),Bm=new Ce(3E4,6E4);
zm.prototype.g=function(a){var b=this;return new A(function(c,d){var e=setTimeout(function(){d(new L("network-request-failed"))},Bm.get());if(!k.grecaptcha||a!==b.f&&!b.b){k[b.a]=function(){if(k.grecaptcha){b.f=a;var f=k.grecaptcha.render;k.grecaptcha.render=function(a,c){a=f(a,c);b.b++;return a};clearTimeout(e);c(k.grecaptcha)}else clearTimeout(e),d(new L("internal-error"));delete k[b.a]};var f=ud(Am,{onload:b.a,hl:a||""});B(Bh(f)).s(function(){clearTimeout(e);d(new L("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c(k.grecaptcha)})};zm.prototype.c=function(){this.b--};var Cm=null;function Dm(a,b,c,d,e,f,h){J(this,"type","recaptcha");this.c=this.f=null;this.D=!1;this.m=b;this.g=null;h?(ym||(ym=new xm),h=ym):(Cm||(Cm=new zm),h=Cm);this.o=h;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[Em])throw new L("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[Fm];if(!k.document)throw new L("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
if(!Id(b)||!this.i&&Id(b).hasChildNodes())throw new L("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Jh(a,f||null,e||null);this.v=d||function(){return null};var m=this;this.l=[];var p=this.a[Gm];this.a[Gm]=function(a){Hm(m,a);if("function"===typeof p)p(a);else if("string"===typeof p){var b=I(p,k);"function"===typeof b&&b(a)}};var x=this.a[Im];this.a[Im]=function(){Hm(m,null);if("function"===typeof x)x();else if("string"===typeof x){var a=
I(x,k);"function"===typeof a&&a()}}}var Gm="callback",Im="expired-callback",Em="sitekey",Fm="size";function Hm(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function Jm(a,b){w(a.l,function(a){return a==b})}function Km(a,b){a.h.push(b);b.ia(function(){Ha(a.h,b)});return b}g=Dm.prototype;
g.za=function(){var a=this;return this.f?this.f:this.f=Km(this,B().then(function(){if(ve()&&!me())return he();throw new L("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.o.g(a.v())}).then(function(b){a.g=b;return P(a.u,Ei,{})}).then(function(b){a.a[Em]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
g.render=function(){Lm(this);var a=this;return Km(this,this.za().then(function(){if(null===a.c){var b=a.m;if(!a.i){var c=Id(b);b=Ld("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};g.verify=function(){Lm(this);var a=this;return Km(this,this.render().then(function(b){return new A(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(b){b&&(Jm(a,e),c(b))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};g.reset=function(){Lm(this);null!==this.c&&this.g.reset(this.c)};
function Lm(a){if(a.D)throw new L("internal-error","RecaptchaVerifier instance has been destroyed.");}g.clear=function(){Lm(this);this.D=!0;this.o.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Id(this.m);for(var b;b=a.firstChild;)a.removeChild(b)}};
function Mm(a,b,c){var d=!1;try{this.b=c||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app()}catch(h){throw new L("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new L("invalid-api-key");var e=this,f=null;try{f=this.b.auth().ya()}catch(h){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(h){}f=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?re(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,f):null;Dm.call(this,c,a,b,function(){try{var a=e.b.auth().ea()}catch(m){a=
null}return a},f,yf(zf),d)}t(Mm,Dm);function Nm(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,h=0;h<b.length;h++)if(b[h].optional)f=!0;else{if(f)throw new L("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=Om.length)throw new L("internal-error",
"Argument validator received an unsupported number of arguments.");c=Om[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new L("argument-error",a+" failed: "+d);}var Om="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:l}}function Pm(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:ba}}
function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function Qm(a,b){return{name:a||"",K:"a function",optional:!!b,M:n}}function Rm(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Sm(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Tm(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof bm)}}}
function Um(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app.App)}}}function Vm(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.la||!c)}}}
function Wm(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Xm(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&l(a.type)&&n(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=Ym(d,a[c],b[c].j)}}function Zm(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:na(function(a){return this[a]},c),set:na(function(a,b,c,d){Nm(a,[c],[d],!0);this[b]=d},d,c,b[c].tb),enumerable:!0})}}function Z(a,b,c,d){a[b]=Ym(b,c,d)}
function Ym(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);Nm(e,c,a);return b.apply(this,a)}if(!c)return b;var e=$m(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function $m(a){a=a.split(".");return a[a.length-1]};Y(bm.prototype,{Wa:{name:"applyActionCode",j:[V("code")]},Ja:{name:"checkActionCode",j:[V("code")]},Za:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},xb:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Wb:{name:"createUserAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Zb:{name:"fetchProvidersForEmail",j:[V("email")]},$b:{name:"fetchSignInMethodsForEmail",j:[V("email")]},fa:{name:"getRedirectResult",j:[]},oc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},
uc:{name:"onAuthStateChanged",j:[X(W(),Qm(),"nextOrObserver"),Qm("opt_error",!0),Qm("opt_completed",!0)]},vc:{name:"onIdTokenChanged",j:[X(W(),Qm(),"nextOrObserver"),Qm("opt_error",!0),Qm("opt_completed",!0)]},kb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Rm(null,!0),"opt_actionCodeSettings",!0)]},lb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},mb:{name:"setPersistence",j:[V("persistence")]},Pa:{name:"signInAndRetrieveDataWithCredential",
j:[Vm()]},Qa:{name:"signInAnonymously",j:[]},Gc:{name:"signInAnonymouslyAndRetrieveData",j:[]},Hc:{name:"signInWithCredential",j:[Vm()]},Nb:{name:"signInWithCustomToken",j:[V("token")]},Ec:{name:"signInAndRetrieveDataWithCustomToken",j:[V("token")]},Ob:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Ic:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Fc:{name:"signInAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Jc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),
Xm()]},Kc:{name:"signInWithPopup",j:[Wm()]},Lc:{name:"signInWithRedirect",j:[Wm()]},Qc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(a){return!!(a&&a instanceof Q)}}}(),Rm(),"user")]},nb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Sc:{name:"useDeviceLanguage",j:[]},Tc:{name:"verifyPasswordResetCode",j:[V("code")]}});Zm(bm.prototype,{lc:{name:"languageCode",tb:X(V(),Rm(),"languageCode")}});bm.Persistence=Ij;
bm.Persistence.LOCAL="local";bm.Persistence.SESSION="session";bm.Persistence.NONE="none";
Y(Q.prototype,{"delete":{name:"delete",j:[]},dc:{name:"getIdTokenResult",j:[Pm("opt_forceRefresh",!0)]},F:{name:"getIdToken",j:[Pm("opt_forceRefresh",!0)]},eb:{name:"linkAndRetrieveDataWithCredential",j:[Vm()]},pc:{name:"linkWithCredential",j:[Vm()]},qc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Xm()]},rc:{name:"linkWithPopup",j:[Wm()]},sc:{name:"linkWithRedirect",j:[Wm()]},gb:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Vm()]},yc:{name:"reauthenticateWithCredential",j:[Vm()]},zc:{name:"reauthenticateWithPhoneNumber",
j:[V("phoneNumber"),Xm()]},Ac:{name:"reauthenticateWithPopup",j:[Wm()]},Bc:{name:"reauthenticateWithRedirect",j:[Wm()]},reload:{name:"reload",j:[]},jb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Rm(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Pc:{name:"unlink",j:[V("provider")]},pb:{name:"updateEmail",j:[V("email")]},qb:{name:"updatePassword",j:[V("password")]},Rc:{name:"updatePhoneNumber",j:[Vm("phone")]},rb:{name:"updateProfile",j:[W("profile")]}});
Y(rm.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(qm.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(A.prototype,{ia:{name:"finally"},s:{name:"catch"},then:{name:"then"}});Zm(Rk.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",tb:Pm("appVerificationDisabledForTesting")}});Y(Sk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
Z(O,"credential",function(a,b){return new gg(a,b)},[V("email"),V("password")]);Y(Zf.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Zf,"credential",$f,[X(V(),W(),"token")]);Z(O,"credentialWithLink",lg,[V("email"),V("emailLink")]);Y(ag.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(ag,"credential",bg,[X(V(),W(),"token")]);
Y(cg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(cg,"credential",dg,[X(V(),X(W(),Rm()),"idToken"),X(V(),Rm(),"accessToken",!0)]);Y(eg.prototype,{Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(eg,"credential",fg,[X(V(),W(),"token"),V("secret",!0)]);
Y(N.prototype,{ua:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Rm(),"idToken",!0),X(V(),Rm(),"accessToken",!0),X(V(),Rm(),"nonce",!0)]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(rg,"credential",tg,[V("verificationId"),V("verificationCode")]);Y(rg.prototype,{Ua:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Xm()]}});Y(L.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Bg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
Y(Ag.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Mm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
(function(){if("undefined"!==typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService){var a={Auth:bm,Error:L};Z(a,"EmailAuthProvider",O,[]);Z(a,"FacebookAuthProvider",Zf,[]);Z(a,"GithubAuthProvider",ag,[]);Z(a,"GoogleAuthProvider",cg,[]);Z(a,"TwitterAuthProvider",eg,[]);Z(a,"OAuthProvider",N,[V("providerId")]);Z(a,"SAMLAuthProvider",Yf,[V("providerId")]);Z(a,"PhoneAuthProvider",rg,[Tm()]);Z(a,"RecaptchaVerifier",Mm,[X(V(),Sm(),"recaptchaContainer"),W("recaptchaParameters",!0),Um()]);
__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService("auth",function(a,c){a=new bm(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.cc,a),addAuthTokenListener:r(a.Vb,a),removeAuthTokenListener:r(a.Cc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41)))

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Context__ = __webpack_require__(239);





var Provider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

  function Provider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.state = {
      storeState: store.getState(),
      store: store
    };
    return _this;
  }

  var _proto = Provider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.subscribe();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this._isMounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      if (this.unsubscribe) this.unsubscribe();
      this.subscribe();
    }
  };

  _proto.subscribe = function subscribe() {
    var _this2 = this;

    var store = this.props.store;
    this.unsubscribe = store.subscribe(function () {
      var newStoreState = store.getState();

      if (!_this2._isMounted) {
        return;
      }

      _this2.setState(function (providerState) {
        // If the value is the same, skip the unnecessary state update.
        if (providerState.storeState === newStoreState) {
          return null;
        }

        return {
          storeState: newStoreState
        };
      });
    }); // Actions might have been dispatched between render and mount - handle those

    var postMountStoreState = store.getState();

    if (postMountStoreState !== this.state.storeState) {
      this.setState({
        storeState: postMountStoreState
      });
    }
  };

  _proto.render = function render() {
    var Context = this.props.context || __WEBPACK_IMPORTED_MODULE_3__Context__["a" /* ReactReduxContext */];
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(242);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(722);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(361);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(361);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(362);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(723);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(363);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var bind = __webpack_require__(366);
var Axios = __webpack_require__(725);
var mergeConfig = __webpack_require__(372);
var defaults = __webpack_require__(244);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(373);
axios.CancelToken = __webpack_require__(739);
axios.isCancel = __webpack_require__(371);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(740);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(741);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var buildURL = __webpack_require__(367);
var InterceptorManager = __webpack_require__(726);
var dispatchRequest = __webpack_require__(727);
var mergeConfig = __webpack_require__(372);
var validator = __webpack_require__(737);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var transformData = __webpack_require__(728);
var isCancel = __webpack_require__(371);
var defaults = __webpack_require__(244);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);
var defaults = __webpack_require__(244);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(370);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(733);
var combineURLs = __webpack_require__(734);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(40);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(738);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = {"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["#USER","/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@0.21.4","_where":"/www/app.trivajleads.com","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(373);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_Actions__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LoginAlert_jsx__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase_app__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_firebase_auth__ = __webpack_require__(169);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
//import Face from "@material-ui/icons/Face";
// import LockOutline from "@material-ui/icons/LockOutline";
// core components
//Firebase
var SignUpPage=function(_React$Component){_inherits(SignUpPage,_React$Component);function SignUpPage(props){_classCallCheck(this,SignUpPage);// we use this to make the card to appear after the page has been rendered
var _this=_possibleConstructorReturn(this,(SignUpPage.__proto__||Object.getPrototypeOf(SignUpPage)).call(this,props));_this.state={cardAnimaton:"cardHidden",alert:null,show:false,username:"",password:"",user:null};_this.handleRegister=_this.handleRegister.bind(_this);_this.loginFailedMessage=_this.loginFailedMessage.bind(_this);_this.hideAlert=_this.hideAlert.bind(_this);return _this;}_createClass(SignUpPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;// we add a hidden class to the card and after 700 ms we delete it and the transition appears
this.timeOutFunction=setTimeout(function(){this.setState({cardAnimaton:""});}.bind(this),700);this.unsubscribe=__WEBPACK_IMPORTED_MODULE_19_firebase_app___default.a.auth().onAuthStateChanged(function(user){if(user){_this2.props.getInitialData();_this2.props.loginUser(user);}else{console.log("user is signed out");}});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timeOutFunction);this.timeOutFunction=null;this.unsubscribe();}},{key:"handleRegister",value:function handleRegister(){var _this3=this;__WEBPACK_IMPORTED_MODULE_19_firebase_app___default.a.auth().createUserWithEmailAndPassword(this.state.username,this.state.password).catch(function(error){_this3.loginFailedMessage(error.message);});}},{key:"change",value:function change(event,type){switch(type){case"username":this.setState({username:event.target.value});break;case"password":this.setState({password:event.target.value});break;default:break;}}},{key:"loginFailedMessage",value:function loginFailedMessage(message){this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__LoginAlert_jsx__["a" /* default */],{message:message,hideAlert:this.hideAlert})});}},{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,classes=_props.classes,user=_props.user;if(user!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{to:"/dashboard"}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_Card_jsx__["a" /* default */],{login:true,className:classes[this.state.cardAnimaton]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__["a" /* default */],{className:classes.cardHeader+" "+classes.textCenter,color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Register"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.socialLine},["fab fa-facebook-square","fab fa-twitter","fab fa-google-plus"].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{color:"transparent",justIcon:true,key:key,className:classes.customButtonClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:prop}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Email",id:"email",value:this.state.username,formControlProps:{fullWidth:true},inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon})),onChange:function onChange(event){return _this4.change(event,"username");}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Password",id:"password",value:this.state.password,formControlProps:{fullWidth:true,type:"password"},inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Icon___default.a,{className:classes.inputAdornmentIcon},"lock_outline")),onChange:function onChange(event){return _this4.change(event,"password");},type:"password",onKeyPress:function onKeyPress(event){if(event.key==="Enter")_this4.handleRegister();}}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardFooter_jsx__["a" /* default */],{className:classes.justifyContentCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",simple:true,size:"lg",block:true,onClick:this.handleRegister},"Get Started")))))));}}]);return SignUpPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SignUpPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,loginUser:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loginUser:function loginUser(user){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_Actions__["f" /* loginUser */])(user));},getInitialData:function getInitialData(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_Actions__["e" /* getInitialData */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_17_assets_jss_material_dashboard_pro_react_views_loginPageStyle_jsx__["a" /* default */])(SignUpPage)));//export default withStyles(loginPageStyle)(SignUpPage);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Pages Header styles
// #############################
var pagesHeaderStyle=function pagesHeaderStyle(theme){return{appBar:{backgroundColor:"transparent",boxShadow:"none",borderBottom:"0",marginBottom:"0",position:"absolute",width:"100%",paddingTop:"10px",zIndex:"1029",color:"#555555",border:"0",borderRadius:"3px",padding:"10px 0",transition:"all 150ms ease 0s",minHeight:"50px",display:"block"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* container */],{minHeight:"50px"}),flex:{flex:1},title:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{lineHeight:"30px",fontSize:"18px",borderRadius:"3px",textTransform:"none",color:"#FFFFFF","&:hover,&:focus":{background:"transparent",color:"#FFFFFF"}}),appResponsive:{top:"8px"},primary:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),info:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),success:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),warning:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),danger:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),list:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{fontSize:"14px",margin:0,marginRight:"-15px",paddingLeft:"0",listStyle:"none",color:"#FFFFFF",paddingTop:"0",paddingBottom:"0"}),listItem:_defineProperty({float:"left",position:"relative",display:"block",width:"auto",margin:"0",padding:"0"},theme.breakpoints.down("sm"),{zIndex:"999",width:"100%",paddingRight:"15px"}),navLink:{color:"#FFFFFF",margin:"0 5px",paddingTop:"15px",paddingBottom:"15px",fontWeight:"500",fontSize:"12px",textTransform:"uppercase",borderRadius:"3px",lineHeight:"20px",position:"relative",display:"block",padding:"10px 15px",textDecoration:"none","&:hover,&:focus":{color:"#FFFFFF",background:"rgba(200, 200, 200, 0.2)"}},listItemIcon:{marginTop:"-3px",top:"0px",position:"relative",marginRight:"3px",width:"20px",height:"20px",verticalAlign:"middle",color:"inherit",display:"inline-block"},listItemText:{flex:"none",padding:"0",minWidth:"0",margin:0,display:"inline-block",position:"relative",whiteSpace:"nowrap"},navLinkActive:{backgroundColor:"rgba(255, 255, 255, 0.1)"},drawerPaper:Object.assign({border:"none",bottom:"0",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],{position:"fixed",display:"block",top:"0",height:"100vh",right:"0",left:"auto",visibility:"visible",overflowY:"visible",borderTop:"none",textAlign:"left",paddingRight:"0px",paddingLeft:"0"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* transition */],{"&:before,&:after":{position:"absolute",zIndex:"3",width:"100%",height:"100%",content:'""',display:"block",top:"0"},"&:after":{background:"#000",opacity:".8"}}),sidebarButton:{"&,&:hover,&:focus":{color:"#FFFFFF"},top:"-2px"}};};/* harmony default export */ __webpack_exports__["a"] = (pagesHeaderStyle);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var pagesStyle=function pagesStyle(theme){var _fullPage;return{wrapper:{height:"auto",minHeight:"100vh",position:"relative",top:"0"},fullPage:(_fullPage={padding:"120px 0",position:"relative",minHeight:"100vh",display:"flex!important",margin:"0",border:"0",color:"#fff",alignItems:"center",backgroundSize:"cover",backgroundPosition:"center center",height:"100%"},_defineProperty(_fullPage,theme.breakpoints.down("sm"),{minHeight:"fit-content!important"}),_defineProperty(_fullPage,"& footer",{position:"absolute",bottom:"0",width:"100%",border:"none !important"}),_defineProperty(_fullPage,"&:before",{backgroundColor:"rgba(0, 0, 0, 0.65)"}),_defineProperty(_fullPage,"&:before,&:after",{display:"block",content:'""',position:"absolute",width:"100%",height:"100%",top:"0",left:"0",zIndex:"2"}),_fullPage)};};/* harmony default export */ __webpack_exports__["a"] = (pagesStyle);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header_Header_jsx__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Footer_Footer_jsx__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Sidebar_Sidebar_jsx__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_routes_rtl_jsx__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_jss_material_dashboard_pro_react_layouts_rtlStyle_jsx__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_img_sidebar_2_jpg__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_img_sidebar_2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_img_sidebar_2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_img_logo_png__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_img_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/// creates a beautiful scrollbar
// @material-ui/core components
// core components
var switchRoutes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_10_routes_rtl_jsx__["a" /* default */].map(function(prop,key){if(prop.redirect)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{from:prop.path,to:prop.pathTo,key:key});if(prop.collapse)return prop.views.map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:prop.path,component:prop.component,key:key});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:prop.path,component:prop.component,key:key});}));var RTL=function(_React$Component){_inherits(RTL,_React$Component);function RTL(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RTL);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RTL.__proto__||Object.getPrototypeOf(RTL)).call.apply(_ref,[this].concat(args))),_this),_this.state={mobileOpen:false,miniActive:false},_this.handleDrawerToggle=function(){_this.setState({mobileOpen:!_this.state.mobileOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RTL,[{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){var ps=new __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__["a" /* default */](this.refs.mainPanel);}}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(e.history.location.pathname!==e.location.pathname){this.refs.mainPanel.scrollTop=0;if(this.state.mobileOpen){this.setState({mobileOpen:false});}}}},{key:"sidebarMinimize",value:function sidebarMinimize(){this.setState({miniActive:!this.state.miniActive});}},{key:"render",value:function render(){var _props=this.props,classes=_props.classes,rest=_objectWithoutProperties(_props,["classes"]);var mainPanel=classes.mainPanel+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({},classes.mainPanelSidebarMini,this.state.miniActive));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Sidebar_Sidebar_jsx__["a" /* default */],Object.assign({routes:__WEBPACK_IMPORTED_MODULE_10_routes_rtl_jsx__["b" /* sidebarLinks */],logoText:"توقيت الإبداعية",logo:__WEBPACK_IMPORTED_MODULE_13_assets_img_logo_png___default.a,image:__WEBPACK_IMPORTED_MODULE_12_assets_img_sidebar_2_jpg___default.a,handleDrawerToggle:this.handleDrawerToggle,open:this.state.mobileOpen,color:"blue",bgColor:"black",miniActive:this.state.miniActive,rtlActive:true},rest)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:mainPanel,ref:"mainPanel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header_Header_jsx__["a" /* default */],Object.assign({rtlActive:true,sidebarMinimize:this.sidebarMinimize.bind(this),miniActive:this.state.miniActive,routes:__WEBPACK_IMPORTED_MODULE_10_routes_rtl_jsx__["a" /* default */],handleDrawerToggle:this.handleDrawerToggle},rest)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.content},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},switchRoutes)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Footer_Footer_jsx__["a" /* default */],{fluid:true,rtlActive:true})));}}]);return RTL;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);RTL.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_11_assets_jss_material_dashboard_pro_react_layouts_rtlStyle_jsx__["a" /* default */])(RTL));

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'MoreVert');

exports.default = _default;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ListItem = _interopRequireDefault(__webpack_require__(161));

// @inheritedComponent ListItem
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.subheading, {
      height: 24,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingLeft: 16,
      paddingRight: 16,
      '&$selected': {}
    }),

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};

exports.styles = styles;

function MenuItem(props) {
  var classes = props.classes,
      className = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
    button: true,
    role: role,
    tabIndex: -1,
    selected: selected,
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool
} : {};
MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenuItem'
})(MenuItem);

exports.default = _default;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _keycode = _interopRequireDefault(__webpack_require__(124));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var _List = _interopRequireDefault(__webpack_require__(160));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.listRef = null;
    _this.selectedItemRef = null;
    _this.blurTimer = null;
    _this.state = {
      currentTabIndex: null
    };

    _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.listRef) {
          var list = _this.listRef;
          var currentFocus = (0, _ownerDocument.default)(list).activeElement;

          if (!list.contains(currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var list = _this.listRef;
      var key = (0, _keycode.default)(event);
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
        if (_this.selectedItemRef) {
          _this.selectedItemRef.focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    };

    _this.handleItemFocus = function (event) {
      var list = _this.listRef;

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;
      var list = this.listRef;

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = this.listRef;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItemRef) {
        return this.setTabIndex(items.indexOf(this.selectedItemRef));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(_ref) {
          _this2.listRef = _reactDom.default.findDOMNode(_ref);
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (ref) {
            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : {};
var _default = MenuList;
exports.default = _default;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

// @inheritedComponent EventListener

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */
var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.node = null;
    _this.mounted = null;

    _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      } // IE11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      } // The child might render null.


      if (!_this.node) {
        return;
      }

      var doc = (0, _ownerDocument.default)(_this.node);

      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
        _this.props.onClickAway(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Finds the first child when a component returns a fragment.
      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
      this.node = _reactDom.default.findDOMNode(this);
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mouseEvent = _this$props.mouseEvent,
          touchEvent = _this$props.touchEvent,
          onClickAway = _this$props.onClickAway,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
      var listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
      }

      return _react.default.createElement(_react.default.Fragment, null, children, _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
        target: "document"
      }, listenerProps, other)));
    }
  }]);
  return ClickAwayListener;
}(_react.default.Component);

ClickAwayListener.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes.default.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
} : {};
ClickAwayListener.defaultProps = {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
};
var _default = ClickAwayListener;
exports.default = _default;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(125));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _utils = __webpack_require__(159);

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    // Use translateZ to scrolling issue on Chrome.
    transform: "".concat(getScale(1), " translateZ(0)")
  }
};
/**
 * The Grow transition is used by the [Tooltip](/demos/tooltips) and
 * [Popover](/utils/popover) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.autoTimeout = null;
    _this.timer = null;

    _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          onEnter = _this$props3.onEnter,
          onExit = _this$props3.onExit,
          styleProp = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Grow.defaultProps = {
  timeout: 'auto'
};
Grow.muiSupportAuto = true;

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _popper = _interopRequireDefault(__webpack_require__(752));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

var _Portal = _interopRequireDefault(__webpack_require__(330));

function flipPlacement(theme, placement) {
  if (theme.direction !== 'rtl') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
/**
 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
 */


var Popper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popper, _React$Component);

  function Popper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popper).call(this));
    _this.popper = null;

    _this.handleOpen = function () {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          modifiers = _this$props.modifiers,
          open = _this$props.open,
          placement = _this$props.placement,
          _this$props$popperOpt = _this$props.popperOptions,
          popperOptions = _this$props$popperOpt === void 0 ? {} : _this$props$popperOpt,
          theme = _this$props.theme,
          disablePortal = _this$props.disablePortal;

      var popperNode = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      if (!popperNode || !anchorEl || !open) {
        return;
      }

      if (_this.popper) {
        _this.popper.destroy();

        _this.popper = null;
      }

      _this.popper = new _popper.default(getAnchorEl(anchorEl), popperNode, (0, _extends2.default)({
        placement: flipPlacement(theme, placement)
      }, popperOptions, {
        modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: 'window'
          }
        }, modifiers, popperOptions.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: _this.handlePopperUpdate,
        onUpdate: _this.handlePopperUpdate
      }));
    };

    _this.handlePopperUpdate = function (data) {
      if (data.placement !== _this.state.placement) {
        _this.setState({
          placement: data.placement
        });
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleClose = function () {
      if (!_this.popper) {
        return;
      }

      _this.popper.destroy();

      _this.popper = null;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && !this.props.open && !this.props.transition) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } // Let's update the popper position.


      if (prevProps.open !== this.props.open || prevProps.anchorEl !== this.props.anchorEl || prevProps.popperOptions !== this.props.popperOptions || prevProps.modifiers !== this.props.modifiers || prevProps.disablePortal !== this.props.disablePortal || prevProps.placement !== this.props.placement) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          children = _this$props2.children,
          container = _this$props2.container,
          disablePortal = _this$props2.disablePortal,
          keepMounted = _this$props2.keepMounted,
          modifiers = _this$props2.modifiers,
          open = _this$props2.open,
          placementProps = _this$props2.placement,
          popperOptions = _this$props2.popperOptions,
          theme = _this$props2.theme,
          transition = _this$props2.transition,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "theme", "transition"]);
      var _this$state = this.state,
          exited = _this$state.exited,
          placement = _this$state.placement;

      if (!keepMounted && !open && (!transition || exited)) {
        return null;
      }

      var childProps = {
        placement: placement || flipPlacement(theme, placementProps)
      };

      if (transition) {
        childProps.TransitionProps = {
          in: open,
          onExited: this.handleExited
        };
      }

      return _react.default.createElement(_Portal.default, {
        onRendered: this.handleOpen,
        disablePortal: disablePortal,
        container: container
      }, _react.default.createElement("div", (0, _extends2.default)({
        role: "tooltip",
        style: {
          // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
          position: 'absolute'
        }
      }, other), typeof children === 'function' ? children(childProps) : children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!nextProps.transition) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Popper;
}(_react.default.Component);

Popper.propTypes =  false ? {
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Popper render function or node.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: _propTypes.default.object,

  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: _propTypes.default.bool
} : {};
Popper.defaultProps = {
  disablePortal: false,
  placement: 'bottom',
  transition: false
};

var _default = (0, _withTheme.default)()(Popper);

exports.default = _default;

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;


  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthOddness = reference.width % 2 === popper.width % 2;
  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
  var noRound = function noRound(v) {
    return v;
  };

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
  var verticalToInteger = !shouldRound ? noRound : Math.round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41)))

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_components_customDropdownStyle_jsx__ = __webpack_require__(380);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // HeaderLinks styles
// #############################
var headerLinksStyle=function headerLinksStyle(theme){var _searchRTL,_notifications;return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_components_customDropdownStyle_jsx__["a" /* default */])(theme),{search:_defineProperty({margin:"0",paddingTop:"7px",paddingBottom:"7px"},theme.breakpoints.down("sm"),{margin:"10px 15px",float:"none !important",paddingTop:"1px",paddingBottom:"1px",padding:"10px 15px",width:"auto"}),searchInput:{paddingTop:"2px"},searchRTL:(_searchRTL={},_defineProperty(_searchRTL,theme.breakpoints.down("sm"),{marginRight:"18px !important"}),_defineProperty(_searchRTL,theme.breakpoints.up("md"),{marginLeft:"12px"}),_searchRTL),linkText:Object.assign({zIndex:"4"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{fontSize:"14px",margin:"0!important",textTransform:"none"}),buttonLink:_defineProperty({},theme.breakpoints.down("sm"),{display:"flex",margin:"5px 15px 0",width:"auto",height:"auto","& svg":{width:"30px",height:"24px",marginRight:"19px",marginLeft:"3px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"30px",fontSize:"24px",lineHeight:"30px",marginRight:"19px",marginLeft:"3px"}}),searchButton:_defineProperty({},theme.breakpoints.down("sm"),{top:"-50px !important",marginRight:"38px",float:"right"}),top:{zIndex:"4"},searchIcon:{width:"17px",zIndex:"4"},links:_defineProperty({width:"20px",height:"20px",zIndex:"4"},theme.breakpoints.down("sm"),{display:"block",width:"30px",height:"30px",color:"inherit",opacity:"0.8",marginRight:"16px",marginLeft:"-5px"}),notifications:(_notifications={zIndex:"4"},_defineProperty(_notifications,theme.breakpoints.up("md"),{position:"absolute",top:"5px",border:"1px solid #FFF",right:"5px",fontSize:"9px",background:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],color:"#FFFFFF",minWidth:"16px",height:"16px",borderRadius:"10px",textAlign:"center",lineHeight:"14px",verticalAlign:"middle",display:"block"}),_defineProperty(_notifications,theme.breakpoints.down("sm"),Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{fontSize:"14px",marginRight:"8px"})),_notifications),wrapperRTL:_defineProperty({},theme.breakpoints.up("md"),{paddingLeft:"16px"}),buttonLinkRTL:_defineProperty({},theme.breakpoints.down("sm"),{alignItems:"center",justifyContent:"flex-end",width:"-webkit-fill-available",margin:"10px 15px 0",padding:"10px 15px",display:"block",position:"relative"}),labelRTL:_defineProperty({},theme.breakpoints.down("sm"),{flexDirection:"row-reverse",justifyContent:"initial",display:"flex"}),linksRTL:_defineProperty({},theme.breakpoints.down("sm"),{marginRight:"-5px !important",marginLeft:"16px !important"}),managerClasses:_defineProperty({},theme.breakpoints.up("md"),{display:"inline-block"}),headerLinksSvg:{width:"20px !important",height:"20px !important"}});};/* harmony default export */ __webpack_exports__["a"] = (headerLinksStyle);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Header styles
// #############################
var headerStyle=function headerStyle(theme){return{appBar:{backgroundColor:"transparent",boxShadow:"none",borderBottom:"0",marginBottom:"0",position:"absolute",width:"100%",paddingTop:"10px",zIndex:"1029",color:"#555555",border:"0",borderRadius:"3px",padding:"10px 0",transition:"all 150ms ease 0s",minHeight:"50px",display:"block"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* containerFluid */],{minHeight:"50px"}),flex:{flex:1},title:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{lineHeight:"30px",fontSize:"18px",borderRadius:"3px",textTransform:"none",color:"inherit",paddingTop:"0.625rem",paddingBottom:"0.625rem",margin:"0 !important","&:hover,&:focus":{background:"transparent"}}),primary:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),info:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),success:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),warning:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),danger:Object.assign({backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],color:"#FFFFFF"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["j" /* defaultBoxShadow */]),sidebarMinimize:{float:"left",padding:"0 0 0 15px",display:"block",color:"#555555"},sidebarMinimizeRTL:{padding:"0 15px 0 0 !important"},sidebarMiniIcon:{width:"20px",height:"17px"}};};/* harmony default export */ __webpack_exports__["a"] = (headerStyle);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_List__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_components_footerStyle__ = __webpack_require__(756);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Footer(_ref){var _cx,_cx3;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,fluid=props.fluid,white=props.white,rtlActive=props.rtlActive;var container=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx={},_defineProperty(_cx,classes.container,!fluid),_defineProperty(_cx,classes.containerFluid,fluid),_defineProperty(_cx,classes.whiteColor,white),_cx));var anchor=classes.a+__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}," "+classes.whiteColor,white));var block=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx3={},_defineProperty(_cx3,classes.block,true),_defineProperty(_cx3,classes.whiteColor,white),_cx3));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer",{className:classes.footer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.left},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_List___default.a,{className:classes.list},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default.a,{className:classes.inlineBlock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#home",className:block},rtlActive?"الصفحة الرئيسية":"Home")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default.a,{className:classes.inlineBlock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#company",className:block},rtlActive?"شركة":"Company")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default.a,{className:classes.inlineBlock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#portfolio",className:block},rtlActive?"بعدسة":"Portfolio")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default.a,{className:classes.inlineBlock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#blog",className:block},rtlActive?"مدونة":"Blog")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.right},"\xA9 ",1900+new Date().getYear()," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.creative-tim.com",className:anchor},rtlActive?"توقيت الإبداعية":"Creative Tim"),rtlActive?", مصنوعة مع الحب لشبكة الإنترنت أفضل":", made with love for a better web")));}Footer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fluid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,white:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,rtlActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_components_footerStyle__["a" /* default */])(Footer));

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Footer styles
// #############################
var footerStyle={block:{},left:{float:"left!important",display:"block"},right:{margin:"0",fontSize:"14px",float:"right!important",padding:"15px"},footer:Object.assign({bottom:"0",borderTop:"1px solid #e7e7e7",padding:"15px 0"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{zIndex:4}),container:Object.assign({zIndex:3},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* container */],{position:"relative"}),containerFluid:Object.assign({zIndex:3},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* containerFluid */],{position:"relative"}),a:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],textDecoration:"none",backgroundColor:"transparent"},list:{marginBottom:"0",padding:"0",marginTop:"0"},inlineBlock:{display:"inline-block",padding:"0",width:"auto"},whiteColor:{"&,&:hover,&:focus":{color:"#FFFFFF"}}};/* harmony default export */ __webpack_exports__["a"] = (footerStyle);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(125));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _transitions = __webpack_require__(76);

var _utils = __webpack_require__(159);

// @inheritedComponent Transition
var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


exports.styles = styles;

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.wrapper = null;
    _this.autoTransitionDuration = null;
    _this.timer = null;

    _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;
      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          collapsedHeight = _this$props3.collapsedHeight,
          Component = _this$props3.component,
          onEnter = _this$props3.onEnter,
          onEntered = _this$props3.onEntered,
          onEntering = _this$props3.onEntering,
          onExit = _this$props3.onExit,
          onExiting = _this$props3.onExiting,
          style = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntered: this.handleEntered,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.createElement(Component, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
          style: (0, _extends2.default)({}, style, {
            minHeight: collapsedHeight
          })
        }, childProps), _react.default.createElement("div", {
          className: classes.wrapper,
          ref: function ref(_ref) {
            _this2.wrapperRef = _ref;
          }
        }, _react.default.createElement("div", {
          className: classes.wrapperInner
        }, children)));
      });
    }
  }]);
  return Collapse;
}(_react.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntered: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};
Collapse.muiSupportAuto = true;

var _default = (0, _withStyles.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

exports.default = _default;

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Sidebar styles
// #############################
var sidebarStyle=function sidebarStyle(theme){var _drawerPaperRTL,_Object$assign;return{drawerPaperRTL:(_drawerPaperRTL={},_defineProperty(_drawerPaperRTL,theme.breakpoints.up("md"),{left:"auto !important",right:"0 !important"}),_defineProperty(_drawerPaperRTL,theme.breakpoints.down("sm"),{left:"0  !important",right:"auto !important"}),_drawerPaperRTL),drawerPaper:Object.assign({border:"none",position:"fixed",top:"0",bottom:"0",left:"0",zIndex:"1032",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],(_Object$assign={width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */]},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */],position:"fixed",height:"100%"}),_defineProperty(_Object$assign,theme.breakpoints.down("sm"),Object.assign({width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */],{position:"fixed",display:"block",top:"0",height:"100vh",right:"0",left:"auto",zIndex:"1032",visibility:"visible",overflowY:"visible",borderTop:"none",textAlign:"left",paddingRight:"0px",paddingLeft:"0",transform:"translate3d("+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */]+"px, 0, 0)"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* transition */])),_defineProperty(_Object$assign,"&:before,&:after",{position:"absolute",zIndex:"3",width:"100%",height:"100%",content:'""',display:"block",top:"0"}),_Object$assign)),blackBackground:{color:"#FFFFFF","&:after":{background:"#000",opacity:".8"}},blueBackground:{color:"#FFFFFF","&:after":{background:"#00acc1",opacity:".93"}},whiteBackground:{color:"#3C4858","&:after":{background:"#FFFFFF",opacity:".93"}},whiteAfter:{"&:after":{backgroundColor:"hsla(0,0%,71%,.3) !important"}},drawerPaperMini:{width:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerMiniWidth */]+"px!important"},logo:{padding:"15px 0px",margin:"0",display:"block",position:"relative",zIndex:"4","&:after":{content:'""',position:"absolute",bottom:"0",height:"1px",right:"15px",width:"calc(100% - 30px)",backgroundColor:"hsla(0,0%,100%,.3)"}},logoMini:{transition:"all 300ms linear",opacity:1,float:"left",textAlign:"center",width:"18px",display:"inline-block",maxHeight:"30px",marginLeft:"22px",marginRight:"18px",marginTop:"7px",color:"inherit"},logoMiniRTL:{float:"right",marginRight:"30px",marginLeft:"26px"},logoNormal:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{transition:"all 300ms linear",display:"block",opacity:"1",transform:"translate3d(0px, 0, 0)",//textTransform: "uppercase",
padding:"5px 0px",fontSize:"18px",whiteSpace:"nowrap",fontWeight:"400",lineHeight:"30px",overflow:"hidden","&,&:hover,&:focus":{color:"inherit"}}),logoNormalRTL:{textAlign:"right"},logoNormalSidebarMini:{opacity:"0",transform:"translate3d(-25px, 0, 0)"},logoNormalSidebarMiniRTL:{transform:"translate3d(25px, 0, 0)"},img:{width:"26px",verticalAlign:"middle",border:"0"},background:{position:"absolute",zIndex:"1",height:"100%",width:"100%",display:"block",top:"0",left:"0",backgroundSize:"cover",backgroundPosition:"center center",transition:"all 300ms linear"},list:{marginTop:"15px",paddingLeft:"0",paddingTop:"0",paddingBottom:"0",marginBottom:"0",listStyle:"none",color:"inherit","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}},item:{color:"inherit",position:"relative",display:"block",textDecoration:"none",margin:"0",padding:"0"},userItem:{"&:last-child":{paddingBottom:"0px"}},itemLink:Object.assign({paddingLeft:"10px",paddingRight:"10px",transition:"all 300ms linear",margin:"10px 15px 0",borderRadius:"3px",position:"relative",display:"block",padding:"10px 15px",backgroundColor:"transparent"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{width:"auto","&:hover":{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},"&,&:hover,&:focus":{color:"inherit"}}),itemIcon:{color:"inherit",width:"30px",height:"24px",float:"left",position:"inherit",top:"3px",marginRight:"15px",textAlign:"center",verticalAlign:"middle",opacity:"0.8"},itemIconRTL:{float:"right",marginLeft:"15px",marginRight:"1px"},itemText:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{margin:"0",lineHeight:"30px",fontSize:"14px",transform:"translate3d(0px, 0, 0)",opacity:"1",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",position:"relative",display:"block",height:"auto",whiteSpace:"nowrap"}),userItemText:{lineHeight:"22px"},itemTextRTL:{marginRight:"45px",textAlign:"right"},itemTextMini:{transform:"translate3d(-25px, 0, 0)",opacity:"0"},itemTextMiniRTL:{transform:"translate3d(25px, 0, 0) !important"},collapseList:{marginTop:"0"},collapseItem:{position:"relative",display:"block",textDecoration:"none",margin:"10px 0 0 0",padding:"0"},collapseActive:{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},collapseItemLink:Object.assign({transition:"all 300ms linear",margin:"0 15px",borderRadius:"3px",position:"relative",display:"block",padding:"10px",backgroundColor:"transparent"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{width:"auto","&:hover":{outline:"none",backgroundColor:"rgba(200, 200, 200, 0.2)",boxShadow:"none"},"&,&:hover,&:focus":{color:"inherit"}}),collapseItemMini:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{textTransform:"uppercase",width:"30px",marginRight:"15px",textAlign:"center",letterSpacing:"1px",position:"relative",float:"left",display:"inherit",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",fontSize:"14px"}),collapseItemMiniRTL:{float:"right",marginLeft:"30px",marginRight:"1px"},collapseItemText:Object.assign({color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{margin:"0",position:"relative",transform:"translateX(0px)",opacity:"1",whiteSpace:"nowrap",display:"block",transition:"transform 300ms ease 0s, opacity 300ms ease 0s",fontSize:"14px"}),collapseItemTextRTL:{textAlign:"right"},collapseItemTextMiniRTL:{transform:"translate3d(25px, 0, 0) !important"},collapseItemTextMini:{transform:"translate3d(-25px, 0, 0)",opacity:"0"},caret:{marginTop:"13px",position:"absolute",right:"18px",transition:"all 150ms ease-in",display:"inline-block",width:"0",height:"0",marginLeft:"2px",verticalAlign:"middle",borderTop:"4px solid",borderRight:"4px solid transparent",borderLeft:"4px solid transparent"},userCaret:{marginTop:"10px"},caretRTL:{left:"11px",right:"auto"},caretActive:{transform:"rotate(180deg)"},purple:{"&,&:hover,&:focus":Object.assign({color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["r" /* primaryBoxShadow */])},blue:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 12px 20px -10px rgba(0,188,212,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(0,188,212,.2)"}},green:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],boxShadow:"0 12px 20px -10px rgba(76,175,80,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(76,175,80,.2)"}},orange:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],boxShadow:"0 12px 20px -10px rgba(255,152,0,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(255,152,0,.2)"}},red:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"0 12px 20px -10px rgba(244,67,54,.28), 0 4px 20px 0 rgba(0,0,0,.12), 0 7px 8px -5px rgba(244,67,54,.2)"}},white:{"&,&:hover,&:focus":{color:"#3C4858",backgroundColor:"#FFFFFF",boxShadow:"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(60,72,88,.4)"}},rose:{"&,&:hover,&:focus":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 4px 20px 0 rgba(0,0,0,.14), 0 7px 10px -5px rgba(233,30,99,.4)"}},sidebarWrapper:{position:"relative",height:"calc(100vh - 75px)",overflow:"auto",width:"260px",zIndex:"4",overflowScrolling:"touch",transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease",color:"inherit",paddingBottom:"30px"},sidebarWrapperWithPerfectScrollbar:{overflow:"hidden !important"},user:{paddingBottom:"20px",margin:"20px auto 0",position:"relative","&:after":{content:'""',position:"absolute",bottom:"0",right:"15px",height:"1px",width:"calc(100% - 30px)",backgroundColor:"hsla(0,0%,100%,.3)"}},photo:Object.assign({transition:"all 300ms linear",width:"34px",height:"34px",overflow:"hidden",float:"left",zIndex:"5",marginRight:"11px",borderRadius:"50%",marginLeft:"23px"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */]),photoRTL:{float:"right",marginLeft:"12px",marginRight:"24px"},avatarImg:{width:"100%",verticalAlign:"middle",border:"0"},userCollapseButton:{margin:"0",padding:"6px 15px","&:hover":{background:"none"}},userCollapseLinks:{marginTop:"-4px","&:hover,&:focus":{color:"#FFFFFF"}}};};/* harmony default export */ __webpack_exports__["a"] = (sidebarStyle);

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
})), 'Store');

exports.default = _default;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Send');

exports.default = _default;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), _react.default.createElement("path", {
  d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.875 6.875 0 0 0 0 9.79c2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
})), 'Update');

exports.default = _default;

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var cardIconStyle={cardIcon:{"&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader":{borderRadius:"3px",backgroundColor:"#999",padding:"15px",marginTop:"-20px",marginRight:"15px",float:"left"}},warningCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* warningCardHeader */],successCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["y" /* successCardHeader */],dangerCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* dangerCardHeader */],infoCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* infoCardHeader */],primaryCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["s" /* primaryCardHeader */],roseCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["v" /* roseCardHeader */]};/* harmony default export */ __webpack_exports__["a"] = (cardIconStyle);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hoverCardStyle={cardHover:{"&:hover":{"& $cardHeaderHover":{transform:"translate3d(0, -50px, 0)"}}},cardHeaderHover:{transition:"all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)"},cardHoverUnder:{position:"absolute",zIndex:"1",top:"-50px",width:"calc(100% - 30px)",left:"17px",right:"17px",textAlign:"center"}};/* harmony default export */ __webpack_exports__["a"] = (hoverCardStyle);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_KeyboardArrowLeft__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_KeyboardArrowLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_KeyboardArrowLeft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_KeyboardArrowRight__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_KeyboardArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_KeyboardArrowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PriorityHigh__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PriorityHigh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PriorityHigh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Check__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Warning__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Favorite__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Favorite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Favorite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Pagination_Pagination_jsx__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_buttonsStyle_jsx__ = __webpack_require__(389);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// core components
var Buttons=function(_React$Component){_inherits(Buttons,_React$Component);function Buttons(){_classCallCheck(this,Buttons);return _possibleConstructorReturn(this,(Buttons.__proto__||Object.getPrototypeOf(Buttons)).apply(this,arguments));}_createClass(Buttons,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Pick your Color")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentLeft},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.marginRight},"Default"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",className:classes.marginRight},"Primary"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",className:classes.marginRight},"Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"success",className:classes.marginRight},"Success"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"warning",className:classes.marginRight},"Warning"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"danger",className:classes.marginRight},"Danger"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",className:classes.marginRight},"Rose"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Buttons with Label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_KeyboardArrowLeft___default.a,{className:classes.icons})," Left"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.marginRight},"Right ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_KeyboardArrowRight___default.a,{className:classes.icons})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PriorityHigh___default.a,{className:classes.icons})," Info"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"success",className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Check___default.a,{className:classes.icons})," Success"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"warning",className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Warning___default.a,{className:classes.icons})," Warning"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"danger",className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default.a,{className:classes.icons})," Danger")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Pick your Size")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentLeft},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",size:"sm",className:classes.marginRight},"Small"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",className:classes.marginRight},"Regular"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",size:"lg",className:classes.marginRight},"Large"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Pick your Style")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",className:classes.marginRight},"Default"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",round:true,className:classes.marginRight},"round"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",round:true,className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Favorite___default.a,{className:classes.icons})," with icon"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"primary",className:classes.marginRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Favorite___default.a,{className:classes.icons})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",simple:true,className:classes.marginRight},"simple")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Pagination")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentLeft},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Pagination_Pagination_jsx__["a" /* default */],{pages:[{text:1},{text:"..."},{text:5},{text:6},{active:true,text:7},{text:8},{text:9},{text:"..."},{text:12}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Pagination_Pagination_jsx__["a" /* default */],{pages:[{text:"PREV"},{text:1},{text:2},{active:true,text:3},{text:4},{text:5},{text:"NEXT"}],color:"info"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Button Group")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.buttonGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",className:classes.firstButton},"Left"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",className:classes.middleButton},"Middle"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",className:classes.lastButton},"Right")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.buttonGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.firstButton},"1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.middleButton},"2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.middleButton},"3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.lastButton},"4"))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.buttonGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.firstButton},"5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.middleButton},"6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.lastButton},"7"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Social buttons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardContentBottom},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"twitter"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-twitter"})," ","Connect with Twitter")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"twitter"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-twitter"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"twitter"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-twitter"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"twitter",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-twitter"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"twitter",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-twitter"})," ","Connect with Twitter"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"facebook"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-facebook-square"})," ","Share \xB7 2.2k")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"facebook"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-facebook"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"facebook"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-facebook"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"facebook",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-facebook-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"facebook",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-facebook-square"})," ","Share \xB7 2.2k"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"google"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-google-plus-g"})," ","Share on Google+")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"google"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-google"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"google"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-google"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"google",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-google"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"google",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-google-plus-g"})," ","Share on Google+"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"linkedin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-linkedin"})," ","Connect with Linkedin")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"linkedin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-linkedin"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"linkedin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-linkedin"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"linkedin",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-linkedin"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"linkedin",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-linkedin"})," ","Connect with Linkedin"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"pinterest"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-pinterest"})," ","Pint it \xB7 212")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"pinterest"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-pinterest"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"pinterest"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-pinterest"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"pinterest",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-pinterest"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"pinterest",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-pinterest"})," ","Pint it \xB7 212"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"youtube"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-youtube"})," ","View on Youtube")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"youtube"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-youtube-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"youtube"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-youtube-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"youtube",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-youtube-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"youtube",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-youtube"})," ","View on Youtube"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"tumblr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-tumblr-square"})," ","Repost")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"tumblr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-tumblr-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"tumblr"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-tumblr-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"tumblr",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-tumblr-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"tumblr",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-tumblr-square"})," ","Repost"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"github"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-github"})," ","Connect with Github")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"github"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-github"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"github"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-github"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"github",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-github"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"github",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-github"})," ","Connect with Github"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"behance"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-behance-square"})," ","Follow us")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"behance"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-behance"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"behance"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-behance-square"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"behance",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-behance"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"behance",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-behance-square"})," ","Follow us"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"dribbble"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-dribbble"})," ","Find us on Dribble")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"dribbble"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-dribbble"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"dribbble"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-dribbble"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"dribbble",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-dribbble"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"dribbble",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-dribbble"})," ","Find us on Dribble"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"reddit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-reddit"})," ","Repost \xB7 232")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"reddit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-reddit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"reddit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" fab fa-reddit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:1,md:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,color:"reddit",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-reddit"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"reddit",simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:classes.socialButtonsIcons+" "+classes.marginRight+" fab fa-reddit"})," ","Repost \xB7 232"))))))));}}]);return Buttons;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Buttons.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_views_buttonsStyle_jsx__["a" /* default */])(Buttons));

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
})), 'KeyboardArrowLeft');

exports.default = _default;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}), _react.default.createElement("path", {
  d: "M10 3h4v12h-4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'PriorityHigh');

exports.default = _default;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})), 'Warning');

exports.default = _default;

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_paginationStyle_jsx__ = __webpack_require__(769);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Pagination(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,pages=props.pages,color=props.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:classes.pagination},pages.map(function(prop,key){var _cx;var paginationLink=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx={},_defineProperty(_cx,classes.paginationLink,true),_defineProperty(_cx,classes[color],prop.active),_defineProperty(_cx,classes.disabled,prop.disabled),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:classes.paginationItem,key:key},prop.onClick!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:prop.onClick,className:paginationLink},prop.text):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:function onClick(){return console.log("you've clicked "+prop.text);},className:paginationLink},prop.text));}));}Pagination.defaultProps={color:"primary"};Pagination.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,pages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["PREV","NEXT","..."])]).isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func})).isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","info","success","warning","danger"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_5_assets_jss_material_dashboard_pro_react_components_paginationStyle_jsx__["a" /* default */])(Pagination));

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Pagination component styles
// #############################
var paginationStyle={pagination:{display:"inline-block",paddingLeft:"0",margin:"20px 0",borderRadius:"4px"},paginationItem:{display:"inline"},paginationLink:{":first-of-type":{marginleft:"0"},border:"0",borderRadius:"30px !important",transition:"all .3s",padding:"0px 11px",margin:"0 3px",minWidth:"30px",height:"30px",minHeight:"auto",lineHeight:"30px",fontWeight:"400",fontSize:"12px",textTransform:"uppercase",background:"transparent",position:"relative",float:"left",textDecoration:"none",boxSizing:"border-box","&,&:hover,&:focus":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]},"&:hover,&:focus":{zIndex:"3",backgroundColor:"#eee",borderColor:"#ddd"},"&:hover":{cursor:"pointer"}},primary:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(156, 39, 176, 0.14), 0 1px 10px 0 rgba(156, 39, 176, 0.12), 0 2px 4px -1px rgba(156, 39, 176, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},info:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(0, 188, 212, 0.14), 0 1px 10px 0 rgba(0, 188, 212, 0.12), 0 2px 4px -1px rgba(0, 188, 212, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},success:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(76, 175, 80, 0.14), 0 1px 10px 0 rgba(76, 175, 80, 0.12), 0 2px 4px -1px rgba(76, 175, 80, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},warning:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(255, 152, 0, 0.14), 0 1px 10px 0 rgba(255, 152, 0, 0.12), 0 2px 4px -1px rgba(255, 152, 0, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},danger:{"&,&:hover,&:focus":{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],borderColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],color:"#FFFFFF",boxShadow:"0 4px 5px 0 rgba(244, 67, 54, 0.14), 0 1px 10px 0 rgba(244, 67, 54, 0.12), 0 2px 4px -1px rgba(244, 67, 54, 0.2)"},"&:hover,&:focus":{zIndex:"2",cursor:"default"}},disabled:{"&,&:hover,&:focus":{color:"#777",cursor:"not-allowed",backgroundColor:"#fff",borderColor:"#ddd"}}};/* harmony default export */ __webpack_exports__["a"] = (paginationStyle);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_views_gridSystemStyle_jsx__ = __webpack_require__(771);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var GridSystem=function(_React$Component){_inherits(GridSystem,_React$Component);function GridSystem(){_classCallCheck(this,GridSystem);return _possibleConstructorReturn(this,(GridSystem.__proto__||Object.getPrototypeOf(GridSystem)).apply(this,arguments));}_createClass(GridSystem,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"XS Grid ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Always Horizontal")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"xs={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"xs={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"xs={4}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"SM Grid ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Collapsed at 768px")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={4}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"MD Grid ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Collapsed at 992px")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={4}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"LG Grid ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Collapsed at 1200px")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"lg={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"lg={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"lg={4}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"Mixed Grid ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Showing different sizes on different screens")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={6} lg={3}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={6} lg={3}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={6} lg={3}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"sm={6} lg={3}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"Offset Grid ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Adding some space when needed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"space-between",alignItems:"center",direction:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={3}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={3}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={3}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"space-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={4}")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={4}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"md={6}"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},"Paragraphs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Some Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Another Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Some Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Another Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Another Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Some Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Another Title Here"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment."))))));}}]);return GridSystem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);GridSystem.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_views_gridSystemStyle_jsx__["a" /* default */])(GridSystem));

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ##############################
// // // GridSystem view styles
// #############################
var gridSystemStyle={title:{color:"#3C4858",textDecoration:"none"}};/* harmony default export */ __webpack_exports__["a"] = (gridSystemStyle);

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Dashboard__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Schedule__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Schedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_LocationOn__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Gavel__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Gavel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Gavel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_HelpOutline__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_HelpOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_HelpOutline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_NavPills_NavPills_jsx__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Accordion_Accordion_jsx__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// core components
var styles={cardTitle:__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],pageSubcategoriesTitle:{color:"#3C4858",textDecoration:"none",textAlign:"center"},cardCategory:{margin:"0",color:"#999999"}};var Panels=function(_React$Component){_inherits(Panels,_React$Component);function Panels(){_classCallCheck(this,Panels);return _possibleConstructorReturn(this,(Panels.__proto__||Object.getPrototypeOf(Panels)).apply(this,arguments));}_createClass(Panels,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Navigation Pills ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null," - Horizontal Tabs"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_NavPills_NavPills_jsx__["a" /* default */],{color:"warning",tabs:[{tabButton:"Profile",tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically visualize customer directed convergence without revolutionary ROI. Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This is very nice."))},{tabButton:"Settings",tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically maintain clicks-and-mortar solutions without functional solutions."))},{tabButton:"Options",tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate one-to-one customer service with robust ideas."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dynamically innovate resource-leveling customer service for state of the art customer service."))}]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Navigation Pills ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null," - Vertical Tabs"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_NavPills_NavPills_jsx__["a" /* default */],{color:"rose",horizontal:{tabsGrid:{xs:12,sm:12,md:4},contentGrid:{xs:12,sm:12,md:8}},tabs:[{tabButton:"Profile",tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically visualize customer directed convergence without revolutionary ROI. Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This is very nice."))},{tabButton:"Settings",tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically maintain clicks-and-mortar solutions without functional solutions."))},{tabButton:"Options",tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate one-to-one customer service with robust ideas."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dynamically innovate resource-leveling customer service for state of the art customer service."))}]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Collapsible Accordion")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Accordion_Accordion_jsx__["a" /* default */],{active:0,collapses:[{title:"Collapsible group Item #1",content:"Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS."},{title:"Collapsible group Item #2",content:"Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS."},{title:"Collapsible group Item #3",content:"Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS."}]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Navigation Pills Icons ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null," - Vertical Tabs"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_NavPills_NavPills_jsx__["a" /* default */],{color:"rose",horizontal:{tabsGrid:{xs:12,sm:12,md:4},contentGrid:{xs:12,sm:12,md:8}},tabs:[{tabButton:"Dashboard",tabIcon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Dashboard___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically visualize customer directed convergence without revolutionary ROI. Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically visualize customer directed convergence without revolutionary ROI. Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."))},{tabButton:"Schedule",tabIcon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Schedule___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Dramatically maintain clicks-and-mortar solutions without functional solutions. Dramatically visualize customer directed convergence without revolutionary ROI. Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits."))}]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.pageSubcategoriesTitle},"Page Subcategories"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_NavPills_NavPills_jsx__["a" /* default */],{color:"warning",alignCenter:true,tabs:[{tabButton:"Description",tabIcon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Description about product"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"More information here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,"Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Dramatically visualize customer directed convergence without revolutionary ROI."))},{tabButton:"Location",tabIcon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_LocationOn___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Location of the product"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"More information here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,"Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Dramatically maintain clicks-and-mortar solutions without functional solutions."))},{tabButton:"Legal Info",tabIcon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Gavel___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Legal info of the product"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"More information here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,"Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate one-to-one customer service with robust ideas.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Dynamically innovate resource-leveling customer service for state of the art customer service."))},{tabButton:"Help Center",tabIcon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_HelpOutline___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Help center"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"More information here")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_CardBody_jsx__["a" /* default */],null,"From the seamless transition of glass and metal to the streamlined profile, every detail was carefully considered to enhance your experience. So while its display is larger, the phone feels just right.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Another Text. The first thing you notice when you hold the phone is how great it feels in your hand. The cover glass curves down around the sides to meet the anodized aluminum enclosure in a remarkable, simplified design."))}]}))));}}]);return Panels;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(styles)(Panels));

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'Schedule');

exports.default = _default;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
})), 'Info');

exports.default = _default;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'LocationOn');

exports.default = _default;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), _react.default.createElement("path", {
  d: "M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"
})), 'Gavel');

exports.default = _default;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
})), 'HelpOutline');

exports.default = _default;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SwipeableViews = _interopRequireDefault(__webpack_require__(779));

var _default = _SwipeableViews.default;
exports.default = _default;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _properties = _interopRequireDefault(__webpack_require__(333));

var _on = _interopRequireDefault(__webpack_require__(171));

var _off = _interopRequireDefault(__webpack_require__(172));

var _reactSwipeableViewsCore = __webpack_require__(780);

function addEventListenerEnhanced(node, event, handler, options) {
  (0, _on.default)(node, event, handler, options);
  return {
    remove: function remove() {
      (0, _off.default)(node, event, handler, options);
    }
  };
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};
var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return "translate(".concat(-translate, "%, 0)");
    },
    'x-reverse': function xReverse(translate) {
      return "translate(".concat(translate, "%, 0)");
    },
    y: function y(translate) {
      return "translate(0, ".concat(-translate, "%)");
    },
    'y-reverse': function yReverse(translate) {
      return "translate(0, ".concat(translate, "%)");
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;
  return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.


function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];
  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{
    pageX: event.pageX,
    pageY: event.pageY
  }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.


var nodeWhoClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;

    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    }

    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeWhoClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViews =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableViews, _React$Component);

  function SwipeableViews(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwipeableViews);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwipeableViews).call(this, props));
    _this.rootNode = null;
    _this.containerNode = null;
    _this.ignoreNextScrollEvents = false;
    _this.viewLength = 0;
    _this.startX = 0;
    _this.lastX = 0;
    _this.vx = 0;
    _this.startY = 0;
    _this.isSwiping = undefined;
    _this.started = false;
    _this.startIndex = 0;
    _this.transitionListener = null;
    _this.touchMoveListener = null;
    _this.activeSlide = null;
    _this.indexCurrent = null;
    _this.firstRenderTimeout = null;

    _this.setRootNode = function (node) {
      _this.rootNode = node;
    };

    _this.setContainerNode = function (node) {
      _this.containerNode = node;
    };

    _this.setActiveSlide = function (node) {
      _this.activeSlide = node;

      _this.updateHeight();
    };

    _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;
      var touch = applyRotationMatrix(event.touches[0], axis);
      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;
      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);
        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);
        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
      }
    };

    _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);

        return;
      } // We are not supposed to hanlde this touch move.


      if (nodeWhoClaimedTheScroll !== null && nodeWhoClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;
      var touch = applyRotationMatrix(event.touches[0], axis); // We don't know yet.

      if (_this.isSwiping === undefined) {
        var dx = Math.abs(touch.pageX - _this.startX);
        var dy = Math.abs(touch.pageY - _this.startY);
        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.

        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.default.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        } // We are likely to be swiping, let's prevent the scroll event.


        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      } // We are swiping, let's prevent the scroll event.


      event.preventDefault(); // Low Pass filter.

      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX; // Add support for native scroll elements.


      if (nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        }); // We abort the touch move handler.

        if (hasFoundNativeHandler) {
          return;
        }
      } // We are moving toward the edges.


      if (startX) {
        _this.startX = startX;
      } else if (nodeWhoClaimedTheScroll === null) {
        nodeWhoClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    };

    _this.handleSwipeEnd = function () {
      nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
      // Makes sure that a starting point is set.

      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;
      var indexNew; // Quick movement

      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = _react.default.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);

      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        } // Manually calling handleTransitionEnd in that case as isn't otherwise.


        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    };

    _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }

      _this.handleSwipeStart(event);
    };

    _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }

      _this.handleSwipeEnd(event);
    };

    _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }

      event.persist();

      _this.handleSwipeStart(adaptMouse(event));
    };

    _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }

      _this.handleSwipeEnd(adaptMouse(event));
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    };

    _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    };

    _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      } // Ignore events bubbling up.


      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
      _this.ignoreNextScrollEvents = true; // Reset the scroll position.

      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    };

    _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];

        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    };

    if (false) {
      (0, _reactSwipeableViewsCore.checkIndexBounds)(props);
    }

    _this.state = {
      indexLatest: props.index,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      renderOnlyActive: !props.disableLazyLoading,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    };

    _this.setIndexCurrent(props.index);

    return _this;
  }

  (0, _createClass2.default)(SwipeableViews, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        swipeableViews: {
          slideUpdateHeight: function slideUpdateHeight() {
            _this2.updateHeight();
          }
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties.default.end, function (event) {
        if (event.target !== _this3.containerNode) {
          return;
        }

        _this3.handleTransitionEnd();
      }); // Block the thread to handle that event.

      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this3.props.disabled) {
          return;
        }

        _this3.handleSwipeMove(event);
      }, {
        passive: false
      });

      if (!this.props.disableLazyLoading) {
        this.firstRenderTimeout = setTimeout(function () {
          _this3.setState({
            renderOnlyActive: false
          });
        }, 0);
      } // Send all functions in an object if action param is set.


      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var index = nextProps.index;

      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {
          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
        }

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
      clearTimeout(this.firstRenderTimeout);
    }
  }, {
    key: "setIndexCurrent",
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;
        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      } // Filters out when changing the children


      if (this.state.displaySameSlide) {
        return;
      } // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.


      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          action = _this$props2.action,
          animateHeight = _this$props2.animateHeight,
          animateTransitions = _this$props2.animateTransitions,
          axis = _this$props2.axis,
          children = _this$props2.children,
          containerStyleProp = _this$props2.containerStyle,
          disabled = _this$props2.disabled,
          disableLazyLoading = _this$props2.disableLazyLoading,
          enableMouseEvents = _this$props2.enableMouseEvents,
          hysteresis = _this$props2.hysteresis,
          ignoreNativeScroll = _this$props2.ignoreNativeScroll,
          index = _this$props2.index,
          onChangeIndex = _this$props2.onChangeIndex,
          onSwitching = _this$props2.onSwitching,
          onTransitionEnd = _this$props2.onTransitionEnd,
          resistance = _this$props2.resistance,
          slideStyleProp = _this$props2.slideStyle,
          slideClassName = _this$props2.slideClassName,
          springConfig = _this$props2.springConfig,
          style = _this$props2.style,
          threshold = _this$props2.threshold,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"]);
      var _this$state = this.state,
          displaySameSlide = _this$state.displaySameSlide,
          heightLatest = _this$state.heightLatest,
          indexLatest = _this$state.indexLatest,
          isDragging = _this$state.isDragging,
          renderOnlyActive = _this$state.renderOnlyActive;
      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {}; // There is no point to animate if we are already providing a height.

       false ? (0, _warning.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, "react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.") : void 0;
      var slideStyle = (0, _extends2.default)({}, styles.slide, slideStyleProp);
      var transition;
      var WebkitTransition;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ", ".concat(createTransition('height', springConfig));
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      }; // Apply the styles for SSR considerations

      if (!renderOnlyActive) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        ref: this.setRootNode,
        style: (0, _extends2.default)({}, axisProperties.root[axis], style)
      }, other, touchEvents, mouseEvents, {
        onScroll: this.handleScroll
      }), _react.default.createElement("div", {
        ref: this.setContainerNode,
        style: (0, _extends2.default)({}, containerStyle, styles.container, containerStyleProp),
        className: "react-swipeable-view-container"
      }, _react.default.Children.map(children, function (child, indexChild) {
        if (renderOnlyActive && indexChild !== indexLatest) {
          return null;
        }

         false ? (0, _warning.default)(_react.default.isValidElement(child), "react-swipeable-view: one of the children provided is invalid: ".concat(child, ".\nWe are expecting a valid React Element")) : void 0;
        var ref;
        var hidden = true;

        if (indexChild === indexLatest) {
          hidden = false;

          if (animateHeight) {
            ref = _this4.setActiveSlide;
            slideStyle.overflowY = 'hidden';
          }
        }

        return _react.default.createElement("div", {
          ref: ref,
          style: slideStyle,
          className: slideClassName,
          "aria-hidden": hidden,
          "data-swipeable": "true"
        }, child);
      })));
    }
  }]);
  return SwipeableViews;
}(_react.default.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';
SwipeableViews.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updateHeight() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the height of the container will be animated to match the current slide height.
   * Animating another style property has a negative impact regarding performance.
   */
  animateHeight: _propTypes.default.bool,

  /**
   * If `false`, changes to the index prop will not cause an animated transition.
   */
  animateTransitions: _propTypes.default.bool,

  /**
   * The axis on which the slides will slide.
   */
  axis: _propTypes.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),

  /**
   * Use this property to provide your slides.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * This is the inlined style that will be applied
   * to each slide container.
   */
  containerStyle: _propTypes.default.object,

  /**
   * If `true`, it will disable touch events.
   * This is useful when you want to prohibit the user from changing slides.
   */
  disabled: _propTypes.default.bool,

  /**
   * This is the config used to disable lazyloding,
   * if `true` will render all the views in first rendering.
   */
  disableLazyLoading: _propTypes.default.bool,

  /**
   * If `true`, it will enable mouse events.
   * This will allow the user to perform the relevant swipe actions with a mouse.
   */
  enableMouseEvents: _propTypes.default.bool,

  /**
   * Configure hysteresis between slides. This value determines how far
   * should user swipe to switch slide.
   */
  hysteresis: _propTypes.default.number,

  /**
   * If `true`, it will ignore native scroll container.
   * It can be used to filter out false positive that blocks the swipe.
   */
  ignoreNativeScroll: _propTypes.default.bool,

  /**
   * This is the index of the slide to show.
   * This is useful when you want to change the default slide shown.
   * Or when you have tabs linked to each slide.
   */
  index: _propTypes.default.number,

  /**
   * This is callback prop. It's call by the
   * component when the shown slide change after a swipe made by the user.
   * This is useful when you have tabs linked to each slide.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {integer} indexLatest This is the oldest index of the slide.
   * @param {object} meta Meta data containing more information about the event.
   */
  onChangeIndex: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onScroll: _propTypes.default.func,

  /**
   * This is callback prop. It's called by the
   * component when the slide switching.
   * This is useful when you want to implement something corresponding
   * to the current slide position.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {string} type Can be either `move` or `end`.
   */
  onSwitching: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * The callback that fires when the animation comes to a rest.
   * This is useful to defer CPU intensive task.
   */
  onTransitionEnd: _propTypes.default.func,

  /**
   * If `true`, it will add bounds effect on the edges.
   */
  resistance: _propTypes.default.bool,

  /**
   * This is the className that will be applied
   * on the slide component.
   */
  slideClassName: _propTypes.default.string,

  /**
   * This is the inlined style that will be applied
   * on the slide component.
   */
  slideStyle: _propTypes.default.object,

  /**
   * This is the config used to create CSS transitions.
   * This is useful to change the dynamic of the transition.
   */
  springConfig: _propTypes.default.shape({
    delay: _propTypes.default.string,
    duration: _propTypes.default.string,
    easeFunction: _propTypes.default.string
  }),

  /**
   * This is the inlined style that will be applied
   * on the root component.
   */
  style: _propTypes.default.object,

  /**
   * This is the threshold used for detecting a quick swipe.
   * If the computed speed is above this value, the index change.
   */
  threshold: _propTypes.default.number
} : {};
SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};
SwipeableViews.childContextTypes = {
  swipeableViews: _propTypes.default.shape({
    slideUpdateHeight: _propTypes.default.func
  })
};
var _default = SwipeableViews;
exports.default = _default;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkIndexBounds", {
  enumerable: true,
  get: function get() {
    return _checkIndexBounds.default;
  }
});
Object.defineProperty(exports, "computeIndex", {
  enumerable: true,
  get: function get() {
    return _computeIndex.default;
  }
});
Object.defineProperty(exports, "constant", {
  enumerable: true,
  get: function get() {
    return _constant.default;
  }
});
Object.defineProperty(exports, "getDisplaySameSlide", {
  enumerable: true,
  get: function get() {
    return _getDisplaySameSlide.default;
  }
});
Object.defineProperty(exports, "mod", {
  enumerable: true,
  get: function get() {
    return _mod.default;
  }
});

var _checkIndexBounds = _interopRequireDefault(__webpack_require__(781));

var _computeIndex = _interopRequireDefault(__webpack_require__(782));

var _constant = _interopRequireDefault(__webpack_require__(392));

var _getDisplaySameSlide = _interopRequireDefault(__webpack_require__(783));

var _mod = _interopRequireDefault(__webpack_require__(784));

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(17));

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;

  var childrenCount = _react.default.Children.count(children);

   false ? (0, _warning.default)(index >= 0 && index <= childrenCount, "react-swipeable-view: the new index: ".concat(index, " is out of bounds: [0-").concat(childrenCount, "].")) : void 0;
};

var _default = checkIndexBounds;
exports.default = _default;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = _interopRequireDefault(__webpack_require__(0));

var _constant = _interopRequireDefault(__webpack_require__(392));

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;
  var indexMax = _react.default.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  if (props.children.length && nextProps.children.length) {
    var oldChildren = props.children[props.index];
    var oldKey = oldChildren ? oldChildren.key : 'empty';

    if (oldKey !== null) {
      var newChildren = nextProps.children[nextProps.index];
      var newKey = newChildren ? newChildren.key : 'empty';

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

var _default = getDisplaySameSlide;
exports.default = _default;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

var _default = mod;
exports.default = _default;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends3 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ButtonBase = _interopRequireDefault(__webpack_require__(93));

var _helpers = __webpack_require__(25);

var _unsupportedProp = _interopRequireDefault(__webpack_require__(786));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends3.default)({}, theme.typography.button, (0, _defineProperty2.default)({
      maxWidth: 264,
      position: 'relative',
      minWidth: 72,
      padding: 0,
      minHeight: 48,
      flexShrink: 0,
      overflow: 'hidden',
      whiteSpace: 'normal'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(13),
      minWidth: 160
    })),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72
    },

    /* Styles applied to the root element if `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.4
      }
    },

    /* Styles applied to the root element if `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Styles applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      maxWidth: 'none'
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label container element if `label` is provided. */
    labelContainer: (0, _defineProperty2.default)({
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12
    }, theme.breakpoints.up('md'), {
      paddingLeft: 24,
      paddingRight: 24
    }),

    /* Styles applied to the label wrapper element if `label` is provided. */
    label: {},

    /* Styles applied to the label wrapper element if `label` is provided and the text is wrapped. */
    labelWrapped: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(12)
    })
  };
};

exports.styles = styles;

var Tab =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tab, _React$Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.label = null;
    _this.state = {
      labelWrapped: false
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    };

    _this.checkTextWrap = function () {
      if (_this.labelRef) {
        var labelWrapped = _this.labelRef.getClientRects().length > 1;

        if (_this.state.labelWrapped !== labelWrapped) {
          _this.setState({
            labelWrapped: labelWrapped
          });
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkTextWrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.labelWrapped === prevState.labelWrapped) {
        /**
         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
         * font size still only requires one line.  This check will prevent an infinite render loop
         * fron occurring in that scenario.
         */
        this.checkTextWrap();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          disabled = _this$props2.disabled,
          fullWidth = _this$props2.fullWidth,
          icon = _this$props2.icon,
          indicator = _this$props2.indicator,
          labelProp = _this$props2.label,
          onChange = _this$props2.onChange,
          selected = _this$props2.selected,
          textColor = _this$props2.textColor,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "disabled", "fullWidth", "icon", "indicator", "label", "onChange", "selected", "textColor", "value"]);
      var label;

      if (labelProp !== undefined) {
        label = _react.default.createElement("span", {
          className: classes.labelContainer
        }, _react.default.createElement("span", {
          className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.labelWrapped, this.state.labelWrapped)),
          ref: function ref(_ref) {
            _this2.labelRef = _ref;
          }
        }, labelProp));
      }

      var className = (0, _classnames.default)(classes.root, classes["textColor".concat((0, _helpers.capitalize)(textColor))], (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.labelIcon, icon && label), (0, _defineProperty2.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);
      return _react.default.createElement(_ButtonBase.default, (0, _extends3.default)({
        focusRipple: true,
        className: className,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled
      }, other, {
        onClick: this.handleChange
      }), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, label), indicator);
    }
  }]);
  return Tab;
}(_react.default.Component);

Tab.propTypes =  false ? {
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   * For server side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * @ignore
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : {};
Tab.defaultProps = {
  disabled: false,
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTab'
})(Tab);

exports.default = _default;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function unsupportedProp(props, propName, componentName, location, propFullName) {
  /* istanbul ignore if */
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The property `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

var _default = unsupportedProp;
exports.default = _default;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _debounce = _interopRequireDefault(__webpack_require__(90));

var _normalizeScrollLeft = __webpack_require__(788);

var _animate = _interopRequireDefault(__webpack_require__(789));

var _ScrollbarSize = _interopRequireDefault(__webpack_require__(790));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _TabIndicator = _interopRequireDefault(__webpack_require__(791));

var _TabScrollButton = _interopRequireDefault(__webpack_require__(792));

/* eslint-disable no-restricted-globals */
// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `centered={true}` & `scrollable={false}`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `scrollable={false}`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `scrollable={true}`. */
    scrollable: {
      overflowX: 'scroll'
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `sscrollButtons="auto"`. */
    scrollButtonsAuto: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};

exports.styles = styles;

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.tabs = null;
    _this.valueToIndex = new Map();
    _this.handleResize = (0, _debounce.default)(function () {
      _this.updateIndicatorState(_this.props);

      _this.updateScrollButtonState();
    }, 166);
    _this.handleTabsScroll = (0, _debounce.default)(function () {
      _this.updateScrollButtonState();
    }, 166);
    _this.state = {
      indicatorStyle: {},
      scrollerStyle: {
        marginBottom: 0
      },
      showLeftScroll: false,
      showRightScroll: false,
      mounted: false
    };

    _this.getConditionalElements = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          scrollable = _this$props.scrollable,
          ScrollButtonComponent = _this$props.ScrollButtonComponent,
          scrollButtons = _this$props.scrollButtons,
          theme = _this$props.theme;
      var conditionalElements = {};
      conditionalElements.scrollbarSizeListener = scrollable ? _react.default.createElement(_ScrollbarSize.default, {
        onLoad: _this.handleScrollbarSizeChange,
        onChange: _this.handleScrollbarSizeChange
      }) : null;
      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');
      conditionalElements.scrollButtonLeft = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
        onClick: _this.handleLeftScrollClick,
        visible: _this.state.showLeftScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      conditionalElements.scrollButtonRight = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
        onClick: _this.handleRightScrollClick,
        visible: _this.state.showRightScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      return conditionalElements;
    };

    _this.getTabsMeta = function (value, direction) {
      var tabsMeta;

      if (_this.tabsRef) {
        var rect = _this.tabsRef.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft


        tabsMeta = {
          clientWidth: _this.tabsRef.clientWidth,
          scrollLeft: _this.tabsRef.scrollLeft,
          scrollLeftNormalized: (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabsRef, direction),
          scrollWidth: _this.tabsRef.scrollWidth,
          left: rect.left,
          right: rect.right
        };
      }

      var tabMeta;

      if (_this.tabsRef && value !== false) {
        var children = _this.tabsRef.children[0].children;

        if (children.length > 0) {
          var tab = children[_this.valueToIndex.get(value)];

           false ? (0, _warning.default)(tab, "Material-UI: the value provided `".concat(value, "` is invalid")) : void 0;
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }

      return {
        tabsMeta: tabsMeta,
        tabMeta: tabMeta
      };
    };

    _this.handleLeftScrollClick = function () {
      _this.moveTabsScroll(-_this.tabsRef.clientWidth);
    };

    _this.handleRightScrollClick = function () {
      _this.moveTabsScroll(_this.tabsRef.clientWidth);
    };

    _this.handleScrollbarSizeChange = function (_ref) {
      var scrollbarHeight = _ref.scrollbarHeight;

      _this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    };

    _this.moveTabsScroll = function (delta) {
      var theme = _this.props.theme;
      var multiplier = theme.direction === 'rtl' ? -1 : 1;
      var nextScrollLeft = _this.tabsRef.scrollLeft + delta * multiplier; // Fix for Edge

      var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;

      _this.scroll(invert * nextScrollLeft);
    };

    _this.scrollSelectedIntoView = function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          value = _this$props2.value;

      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta.tabsMeta,
          tabMeta = _this$getTabsMeta.tabMeta;

      if (!tabMeta || !tabsMeta) {
        return;
      }

      if (tabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);

        _this.scroll(nextScrollLeft);
      } else if (tabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);

        _this.scroll(_nextScrollLeft);
      }
    };

    _this.scroll = function (value) {
      (0, _animate.default)('scrollLeft', _this.tabsRef, value);
    };

    _this.updateScrollButtonState = function () {
      var _this$props3 = _this.props,
          scrollable = _this$props3.scrollable,
          scrollButtons = _this$props3.scrollButtons,
          theme = _this$props3.theme;

      if (scrollable && scrollButtons !== 'off') {
        var _this$tabsRef = _this.tabsRef,
            scrollWidth = _this$tabsRef.scrollWidth,
            clientWidth = _this$tabsRef.clientWidth;
        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabsRef, theme.direction);
        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;
        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;

        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
          _this.setState({
            showLeftScroll: showLeftScroll,
            showRightScroll: showRightScroll
          });
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        mounted: true
      });
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.props.action) {
        this.props.action({
          updateIndicator: this.handleResize
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // The index might have changed at the same time.
      // We need to check again the right indicator position.
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
      this.handleTabsScroll.clear();
    }
  }, {
    key: "updateIndicatorState",
    value: function updateIndicatorState(props) {
      var theme = props.theme,
          value = props.value;

      var _this$getTabsMeta2 = this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta2.tabsMeta,
          tabMeta = _this$getTabsMeta2.tabMeta;

      var left = 0;

      if (tabMeta && tabsMeta) {
        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        left = Math.round(tabMeta.left - tabsMeta.left + correction);
      }

      var indicatorStyle = {
        left: left,
        // May be wrong until the font is loaded.
        width: tabMeta ? Math.round(tabMeta.width) : 0
      };

      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !isNaN(indicatorStyle.left) && !isNaN(indicatorStyle.width)) {
        this.setState({
          indicatorStyle: indicatorStyle
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames4,
          _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          centered = _this$props4.centered,
          childrenProp = _this$props4.children,
          classes = _this$props4.classes,
          classNameProp = _this$props4.className,
          Component = _this$props4.component,
          fullWidth = _this$props4.fullWidth,
          indicatorColor = _this$props4.indicatorColor,
          onChange = _this$props4.onChange,
          scrollable = _this$props4.scrollable,
          ScrollButtonComponent = _this$props4.ScrollButtonComponent,
          scrollButtons = _this$props4.scrollButtons,
          _this$props4$TabIndic = _this$props4.TabIndicatorProps,
          TabIndicatorProps = _this$props4$TabIndic === void 0 ? {} : _this$props4$TabIndic,
          textColor = _this$props4.textColor,
          theme = _this$props4.theme,
          value = _this$props4.value,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "centered", "children", "classes", "className", "component", "fullWidth", "indicatorColor", "onChange", "scrollable", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "theme", "value"]);
       false ? (0, _warning.default)(!centered || !scrollable, 'Material-UI: you can not use the `centered={true}` and `scrollable={true}` properties ' + 'at the same time on a `Tabs` component.') : void 0;
      var className = (0, _classnames.default)(classes.root, classNameProp);
      var flexContainerClassName = (0, _classnames.default)(classes.flexContainer, (0, _defineProperty2.default)({}, classes.centered, centered && !scrollable));
      var scrollerClassName = (0, _classnames.default)(classes.scroller, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.fixed, !scrollable), (0, _defineProperty2.default)(_classNames4, classes.scrollable, scrollable), _classNames4));

      var indicator = _react.default.createElement(_TabIndicator.default, (0, _extends2.default)({
        className: classes.indicator,
        color: indicatorColor
      }, TabIndicatorProps, {
        style: (0, _extends2.default)({}, this.state.indicatorStyle, TabIndicatorProps.style)
      }));

      this.valueToIndex = new Map();
      var childIndex = 0;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var childValue = child.props.value === undefined ? childIndex : child.props.value;

        _this2.valueToIndex.set(childValue, childIndex);

        var selected = childValue === value;
        childIndex += 1;
        return _react.default.cloneElement(child, {
          fullWidth: fullWidth,
          indicator: selected && !_this2.state.mounted && indicator,
          selected: selected,
          onChange: onChange,
          textColor: textColor,
          value: childValue
        });
      });

      var conditionalElements = this.getConditionalElements();
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), conditionalElements.scrollbarSizeListener, _react.default.createElement("div", {
        className: classes.flexContainer
      }, conditionalElements.scrollButtonLeft, _react.default.createElement("div", {
        className: scrollerClassName,
        style: this.state.scrollerStyle,
        ref: function ref(_ref2) {
          _this2.tabsRef = _ref2;
        },
        role: "tablist",
        onScroll: this.handleTabsScroll
      }, _react.default.createElement("div", {
        className: flexContainerClassName
      }, children), this.state.mounted && indicator), conditionalElements.scrollButtonRight));
    }
  }]);
  return Tabs;
}(_react.default.Component);

Tabs.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * True invokes scrolling properties and allow for horizontally scrolling
   * (or swiping) the tab bar.
   */
  scrollable: _propTypes.default.bool,

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes.default.oneOf(['auto', 'on', 'off']),

  /**
   * Properties applied to the `TabIndicator` element.
   */
  TabIndicatorProps: _propTypes.default.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes.default.any
} : {};
Tabs.defaultProps = {
  centered: false,
  component: 'div',
  fullWidth: false,
  indicatorColor: 'secondary',
  scrollable: false,
  ScrollButtonComponent: _TabScrollButton.default,
  scrollButtons: 'auto',
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabs',
  withTheme: true
})(Tabs);

exports.default = _default;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
exports._setScrollType = _setScrollType;
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
exports.detectScrollType = detectScrollType;
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}
exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(prop, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[prop];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[prop] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

var _default = animate;
exports.default = _default;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _debounce = _interopRequireDefault(__webpack_require__(90));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = {
  width: 100,
  height: 100,
  position: 'absolute',
  top: -10000,
  overflow: 'scroll',
  msOverflowStyle: 'scrollbar'
};
/**
 * @ignore - internal component.
 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

var ScrollbarSize =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ScrollbarSize, _React$Component);

  function ScrollbarSize() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ScrollbarSize);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ScrollbarSize)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleResize = (0, _debounce.default)(function () {
      var onChange = _this.props.onChange;
      var prevHeight = _this.scrollbarHeight;
      var prevWidth = _this.scrollbarWidth;

      _this.setMeasurements();

      if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
        onChange({
          scrollbarHeight: _this.scrollbarHeight,
          scrollbarWidth: _this.scrollbarWidth
        });
      }
    }, 166);

    _this.setMeasurements = function () {
      var nodeRef = _this.nodeRef;

      if (!nodeRef) {
        return;
      }

      _this.scrollbarHeight = nodeRef.offsetHeight - nodeRef.clientHeight;
      _this.scrollbarWidth = nodeRef.offsetWidth - nodeRef.clientWidth;
    };

    return _this;
  }

  (0, _createClass2.default)(ScrollbarSize, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      this.setMeasurements();
      this.props.onLoad({
        scrollbarHeight: this.scrollbarHeight,
        scrollbarWidth: this.scrollbarWidth
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var onChange = this.props.onChange;
      return _react.default.createElement("div", null, onChange ? _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }) : null, _react.default.createElement("div", {
        style: styles,
        ref: function ref(_ref) {
          _this2.nodeRef = _ref;
        }
      }));
    }
  }]);
  return ScrollbarSize;
}(_react.default.Component);

ScrollbarSize.propTypes =  false ? {
  onChange: _propTypes.default.func.isRequired,
  onLoad: _propTypes.default.func.isRequired
} : {};
var _default = ScrollbarSize;
exports.default = _default;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create(),
      willChange: 'left, width'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function TabIndicator(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className)
  }, other));
}

TabIndicator.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary'])
} : {};

var _default = (0, _withStyles.default)(styles)(TabIndicator);

exports.default = _default;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(793));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(797));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _ButtonBase = _interopRequireDefault(__webpack_require__(93));

var styles = {
  /* Styles applied to the root element. */
  root: {
    color: 'inherit',
    flex: '0 0 56px'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var _ref = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);

function TabScrollButton(props) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      onClick = props.onClick,
      visible = props.visible,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "onClick", "visible"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  if (!visible) {
    return _react.default.createElement("div", {
      className: className
    });
  }

  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    onClick: onClick,
    tabIndex: -1
  }, other), direction === 'left' ? _ref : _ref2);
}

TabScrollButton.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes.default.func,

  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes.default.bool
} : {};
TabScrollButton.defaultProps = {
  visible: true
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabScrollButton'
})(TabScrollButton);

exports.default = _default;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowLeft = (0, _pure.default)(KeyboardArrowLeft);
KeyboardArrowLeft.muiName = 'SvgIcon';
var _default = KeyboardArrowLeft;
exports.default = _default;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(395));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(119));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(219));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowRight = (0, _pure.default)(KeyboardArrowRight);
KeyboardArrowRight.muiName = 'SvgIcon';
var _default = KeyboardArrowRight;
exports.default = _default;

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // NavPills component style
// #############################
var navPillsStyle=function navPillsStyle(theme){return{root:{marginTop:"20px",paddingLeft:"0",marginBottom:"0",overflow:"visible !important"},flexContainer:_defineProperty({},theme.breakpoints.down("xs"),{display:"flex",flexWrap:"wrap"}),displayNone:{display:"none !important"},fixed:{overflowX:"visible"},horizontalDisplay:{display:"block"},pills:{float:"left",position:"relative",display:"block",borderRadius:"30px",minWidth:"100px",textAlign:"center",transition:"all .3s",padding:"10px 15px",color:"#555555",height:"auto",opacity:"1",maxWidth:"100%",margin:"0 5px"},pillsWithIcons:{borderRadius:"4px"},tabIcon:{width:"30px",height:"30px",display:"block",margin:"15px 0"},horizontalPills:{width:"100%",float:"none !important","& + button":{margin:"10px 0"}},labelContainer:{padding:"0!important",color:"inherit"},label:{lineHeight:"24px",textTransform:"uppercase",fontSize:"12px",fontWeight:"500",position:"relative",display:"block",color:"inherit"},contentWrapper:{marginTop:"20px"},primary:{"&,&:hover":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(156, 39, 176, 0.4)"}},info:{"&,&:hover":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(76, 175, 80, 0.4)"}},success:{"&,&:hover":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],boxShadow:"0 2px 2px 0 rgba(76, 175, 80, 0.14), 0 3px 1px -2px rgba(76, 175, 80, 0.2), 0 1px 5px 0 rgba(76, 175, 80, 0.12)"}},warning:{"&,&:hover":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(255, 152, 0, 0.4)"}},danger:{"&,&:hover":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(255, 152, 0, 0.4)"}},rose:{"&,&:hover":{color:"#FFFFFF",backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)"}},alignCenter:{alignItems:"center",justifyContent:"center"}};};/* harmony default export */ __webpack_exports__["a"] = (navPillsStyle);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_accordionStyle_jsx__ = __webpack_require__(808);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
var Accordion=function(_React$Component){_inherits(Accordion,_React$Component);function Accordion(props){_classCallCheck(this,Accordion);var _this=_possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).call(this,props));_this.handleChange=function(panel){return function(event,expanded){_this.setState({active:expanded?panel:-1});};};_this.state={active:props.active};return _this;}_createClass(Accordion,[{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,collapses=_props.collapses;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.root},collapses.map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_ExpansionPanel___default.a,{expanded:_this2.state.active===key,onChange:_this2.handleChange(key),key:key,classes:{root:classes.expansionPanel,expanded:classes.expansionPanelExpanded}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_ExpansionPanelSummary___default.a,{expandIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ExpandMore___default.a,null),classes:{root:classes.expansionPanelSummary,expanded:classes.expansionPanelSummaryExpaned,content:classes.expansionPanelSummaryContent,expandIcon:classes.expansionPanelSummaryExpandIcon}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},prop.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ExpansionPanelDetails___default.a,{className:classes.expansionPanelDetails},prop.content));}));}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Accordion.defaultProps={active:-1};Accordion.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,// index of the default active collapse
active:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,collapses:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,content:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node})).isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_accordionStyle_jsx__["a" /* default */])(Accordion));

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(__webpack_require__(801));

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _Collapse = _interopRequireDefault(__webpack_require__(382));

var _Paper = _interopRequireDefault(__webpack_require__(64));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _reactHelpers = __webpack_require__(66);

// @inheritedComponent Paper
// Workaround https://github.com/jsdom/jsdom/issues/2026
var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
  // Fix a rendering issue on Edge
  '@supports (-ms-ime-align: auto)': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
};

var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': (0, _extends2.default)({
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      }, edgeFix),
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {
      margin: '16px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
};

exports.styles = styles;

var ExpansionPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ExpansionPanel).call(this));
    _this.isControlled = null;
    _this.state = {};

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanel, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          CollapsePropsProp = _this$props.CollapseProps,
          defaultExpanded = _this$props.defaultExpanded,
          disabled = _this$props.disabled,
          expandedProp = _this$props.expanded,
          onChange = _this$props.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
      var summary = null;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the ExpansionPanel component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: className,
        elevation: 1,
        square: true
      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
        in: expanded,
        timeout: "auto"
      }, CollapseProps, CollapsePropsProp), children));
    }
  }]);
  return ExpansionPanel;
}(_react.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`Collapse`](/api/collapse) element.
   */
  CollapseProps: _propTypes.default.object,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes.default.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes.default.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes.default.func
} : {};
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel);

exports.default = _default;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(803));

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _ButtonBase = _interopRequireDefault(__webpack_require__(93));

var _IconButton = _interopRequireDefault(__webpack_require__(134));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 24px 0 24px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root and children wrapper elements when focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: 32
      },
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: 8,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'translateY(-50%) rotate(180deg)'
      }
    }
  };
};

exports.styles = styles;

var ExpansionPanelSummary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ExpansionPanelSummary)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      focused: false
    };

    _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanelSummary, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          expanded = _this$props2.expanded,
          expandIcon = _this$props2.expandIcon,
          IconButtonProps = _this$props2.IconButtonProps,
          onChange = _this$props2.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onChange"]);
      var focused = this.state.focused;
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
      }, other, {
        onFocusVisible: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleChange
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
      }, children), expandIcon && _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        disabled: disabled,
        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
        component: "div",
        tabIndex: -1,
        "aria-hidden": "true"
      }, IconButtonProps), expandIcon));
    }
  }]);
  return ExpansionPanelSummary;
}(_react.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes.default.bool,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes.default.node,

  /**
   * Properties applied to the `TouchRipple` element wrapping the expand icon.
   */
  IconButtonProps: _propTypes.default.object,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func
} : {};
ExpansionPanelSummary.defaultProps = {
  disabled: false
};
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary);

exports.default = _default;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(75);

var _ButtonBase = _interopRequireDefault(__webpack_require__(93));

var _helpers = __webpack_require__(25);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */


exports.styles = styles;

function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    centerRipple: true,
    focusRipple: true,
    disabled: disabled
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes.default.bool
} : {};
IconButton.defaultProps = {
  color: 'default',
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIconButton'
})(IconButton);

exports.default = _default;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(806));

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: '8px 24px 24px'
  }
};
exports.styles = styles;

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails);

exports.default = _default;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var accordionStyle=function accordionStyle(theme){var _$expansionPanelSum,_expansionPanelSummar;return{root:{flexGrow:1,marginBottom:"20px"},expansionPanel:{boxShadow:"none","&:before":{display:"none !important"}},expansionPanelExpanded:{margin:"0"},expansionPanelSummary:{minHeight:"auto !important",backgroundColor:"transparent",borderBottom:"1px solid #ddd",padding:"25px 10px 5px 0px",borderTopLeftRadius:"3px",borderTopRightRadius:"3px",color:"#3C4858","&:hover":{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]}},expansionPanelSummaryExpaned:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],"& $expansionPanelSummaryExpandIcon":(_$expansionPanelSum={},_defineProperty(_$expansionPanelSum,theme.breakpoints.up("md"),{top:"auto !important"}),_defineProperty(_$expansionPanelSum,"transform","rotate(180deg)"),_defineProperty(_$expansionPanelSum,theme.breakpoints.down("sm"),{top:"10px !important"}),_$expansionPanelSum)},expansionPanelSummaryContent:{margin:"0 !important"},expansionPanelSummaryExpandIcon:(_expansionPanelSummar={},_defineProperty(_expansionPanelSummar,theme.breakpoints.up("md"),{top:"auto !important"}),_defineProperty(_expansionPanelSummar,"transform","rotate(0deg)"),_defineProperty(_expansionPanelSummar,"color","inherit"),_defineProperty(_expansionPanelSummar,theme.breakpoints.down("sm"),{top:"10px !important"}),_expansionPanelSummar),expansionPanelSummaryExpandIconExpanded:{},title:{fontSize:"15px",fontWeight:"bolder",marginTop:"0",marginBottom:"0",color:"inherit"},expansionPanelDetails:{padding:"15px 0px 5px"}};};/* harmony default export */ __webpack_exports__["a"] = (accordionStyle);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react component used to create sweet alerts
// @material-ui/core components
// core components
var SweetAlertPage=function(_React$Component){_inherits(SweetAlertPage,_React$Component);function SweetAlertPage(props){_classCallCheck(this,SweetAlertPage);var _this=_possibleConstructorReturn(this,(SweetAlertPage.__proto__||Object.getPrototypeOf(SweetAlertPage)).call(this,props));_this.state={alert:null,show:false};_this.hideAlert=_this.hideAlert.bind(_this);_this.successDelete=_this.successDelete.bind(_this);_this.cancelDetele=_this.cancelDetele.bind(_this);_this.inputConfirmAlert=_this.inputConfirmAlert.bind(_this);_this.inputConfirmAlertNext=_this.inputConfirmAlertNext.bind(_this);return _this;}_createClass(SweetAlertPage,[{key:"basicAlert",value:function basicAlert(){var _this2=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{style:{display:"block",marginTop:"-100px"},title:"Here's a message!",onConfirm:function onConfirm(){return _this2.hideAlert();},onCancel:function onCancel(){return _this2.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success})});}},{key:"titleAndTextAlert",value:function titleAndTextAlert(){var _this3=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{style:{display:"block",marginTop:"-100px"},title:"Here's a message!",onConfirm:function onConfirm(){return _this3.hideAlert();},onCancel:function onCancel(){return _this3.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.info},"It's pretty, isn't it?")});}},{key:"successAlert",value:function successAlert(){var _this4=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{success:true,style:{display:"block",marginTop:"-100px"},title:"Good job!",onConfirm:function onConfirm(){return _this4.hideAlert();},onCancel:function onCancel(){return _this4.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},"You clicked the button!")});}},{key:"htmlAlert",value:function htmlAlert(){var _this5=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{style:{display:"block",marginTop:"-100px"},title:"HTML example",onConfirm:function onConfirm(){return _this5.hideAlert();},onCancel:function onCancel(){return _this5.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},"You can use ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"bold")," text,"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.creative-tim.com/"},"links")," and other HTML tags")});}},{key:"warningWithConfirmMessage",value:function warningWithConfirmMessage(){var _this6=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{warning:true,style:{display:"block",marginTop:"-100px"},title:"Are you sure?",onConfirm:function onConfirm(){return _this6.successDelete();},onCancel:function onCancel(){return _this6.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger,confirmBtnText:"Yes, delete it!",cancelBtnText:"Cancel",showCancel:true},"You will not be able to recover this imaginary file!")});}},{key:"warningWithConfirmAndCancelMessage",value:function warningWithConfirmAndCancelMessage(){var _this7=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{warning:true,style:{display:"block",marginTop:"-100px"},title:"Are you sure?",onConfirm:function onConfirm(){return _this7.successDelete();},onCancel:function onCancel(){return _this7.cancelDetele();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger,confirmBtnText:"Yes, delete it!",cancelBtnText:"Cancel",showCancel:true},"You will not be able to recover this imaginary file!")});}},{key:"autoCloseAlert",value:function autoCloseAlert(){var _this8=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{style:{display:"block",marginTop:"-100px"},title:"Auto close alert!",onConfirm:function onConfirm(){return _this8.hideAlert();},showConfirm:false},"I will close in 2 seconds.")});setTimeout(this.hideAlert,2000);}},{key:"inputAlert",value:function inputAlert(){var _this9=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{input:true,showCancel:true,style:{display:"block",marginTop:"-100px"},title:"Input something",onConfirm:function onConfirm(e){return _this9.inputConfirmAlert(e);},onCancel:function onCancel(){return _this9.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.info,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger})});}},{key:"inputConfirmAlert",value:function inputConfirmAlert(e){this.setState({alert:e});setTimeout(this.inputConfirmAlertNext,200);}},{key:"inputConfirmAlertNext",value:function inputConfirmAlertNext(){var _this10=this;var inputValue=this.state.alert;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{style:{display:"block",marginTop:"-100px"},onConfirm:function onConfirm(){return _this10.hideAlert();},onCancel:function onCancel(){return _this10.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.info,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You entered: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,inputValue))})});}},{key:"successDelete",value:function successDelete(){var _this11=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{success:true,style:{display:"block",marginTop:"-100px"},title:"Deleted!",onConfirm:function onConfirm(){return _this11.hideAlert();},onCancel:function onCancel(){return _this11.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},"Your imaginary file has been deleted.")});}},{key:"cancelDetele",value:function cancelDetele(){var _this12=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_sweetalert___default.a,{danger:true,style:{display:"block",marginTop:"-100px"},title:"Cancelled",onConfirm:function onConfirm(){return _this12.hideAlert();},onCancel:function onCancel(){return _this12.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},"Your imaginary file is safe :)")});}},{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Heading_Heading_jsx__["a" /* default */],{textAlign:"center",title:"Sweet Alert",category:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"A beautiful plugin, that replace the classic alert, Handcrafted by our friend"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:"https://github.com/djorg83",rel:"noopener noreferrer"},"Daniel Jorgensen"),". Please check out the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://github.com/djorg83/react-bootstrap-sweetalert",target:"_blank",rel:"noopener noreferrer"},"full documentation."),".")}),this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"Basic example"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.basicAlert.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"A title with a text under"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.titleAndTextAlert.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"A success message"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.successAlert.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"Custom HTML description"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.htmlAlert.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"A warning message, with a function attached to the \"Confirm\" Button..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.warningWithConfirmMessage.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"...and by passing a parameter, you can execute something else for \"Cancel\""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.warningWithConfirmAndCancelMessage.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"A message with auto close timer set to 2 seconds"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.autoCloseAlert.bind(this)},"Try me!"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"Modal window with input field"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.inputAlert.bind(this)},"Try me!")))))));}}]);return SweetAlertPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */])(SweetAlertPage));

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ##############################
// // // Heading component styles
// #############################
var headingStyle={heading:{marginBottom:"30px"},rightTextAlign:{textAlign:"right"},leftTextAlign:{textAlign:"left"},centerTextAlign:{textAlign:"center"},title:{marginTop:"10px",color:"#3C4858",textDecoration:"none"},category:{margin:"0 0 10px"}};/* harmony default export */ __webpack_exports__["a"] = (headingStyle);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Slide__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Instruction_Instruction_jsx__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_jss_material_dashboard_pro_react_views_notificationsStyle_jsx__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_card_1_jpeg__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_img_card_1_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_img_card_1_jpeg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_img_card_2_jpeg__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_img_card_2_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_assets_img_card_2_jpeg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint-disable*/// @material-ui/core components
// @material-ui/icons
// core components
function Transition(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Slide___default.a,Object.assign({direction:"down"},props));}var Notifications=function(_React$Component){_inherits(Notifications,_React$Component);function Notifications(props){_classCallCheck(this,Notifications);var _this=_possibleConstructorReturn(this,(Notifications.__proto__||Object.getPrototypeOf(Notifications)).call(this,props));_this.state={tl:false,tc:false,tr:false,bl:false,bc:false,br:false,classicModal:false,noticeModal:false,smallModal:false};return _this;}// to stop the warning of calling setState of unmounted component
_createClass(Notifications,[{key:"componentWillUnmount",value:function componentWillUnmount(){var id=window.setTimeout(null,0);while(id--){window.clearTimeout(id);}}},{key:"showNotification",value:function showNotification(place){if(!this.state[place]){var x=[];x[place]=true;this.setState(x);setTimeout(function(){x[place]=false;this.setState(x);}.bind(this),6000);}}},{key:"handleClickOpen",value:function handleClickOpen(modal){var x=[];x[modal]=true;this.setState(x);}},{key:"handleClose",value:function handleClose(modal){var x=[];x[modal]=false;this.setState(x);}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Heading_Heading_jsx__["a" /* default */],{title:"Notifications",textAlign:"center",category:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Handcrafted by our friends from"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:"https://material-ui-next.com/"},"Material UI")," ","and styled by"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:"https://www.creative-tim.com/"},"Creative Tim"),". Please checkout the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo",target:"_blank"},"full documentation"),".")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Notifications Style")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:"This is a plain notification",color:"info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:"This is a notification with close button.",close:true,color:"info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:"This is a notification with close button and icon and have many lines. You can see that the icon and the close button are always vertically aligned. This is a beautiful notification. So you don't have to worry about the style.",close:true,icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,color:"info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'This is a notification with close button and icon and is made with color="rose". You can see that the icon and the close button are always vertically aligned. This is a beautiful notification. So you don\'t have to worry about the style.',close:true,icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,color:"rose"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Notification states")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'INFO - This is a regular notification made with color="info"',close:true,color:"info"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'SUCCESS - This is a regular notification made with color="success"',close:true,color:"success"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'WARNING - This is a regular notification made with color="warning"',close:true,color:"warning"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'DANGER - This is a regular notification made with color="danger"',close:true,color:"danger"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'PRIMARY - This is a regular notification made with color="primary"',close:true,color:"primary"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Snackbar_SnackbarContent_jsx__["a" /* default */],{message:'ROSE - This is a regular notification made with color="primary"',close:true,color:"rose"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader+" "+classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Notifications Places"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardSubtitle},"Click to view notifications")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{fullWidth:true,color:"primary",onClick:function onClick(){return _this2.showNotification("tl");}},"Top Left"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"tl",color:"info",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,message:"Welcome to MATERIAL DASHBOARD React - a beautiful freebie for every web developer.",open:this.state.tl,closeNotification:function closeNotification(){return _this2.setState({tl:false});},close:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{fullWidth:true,color:"primary",onClick:function onClick(){return _this2.showNotification("tc");}},"Top Center"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"tc",color:"info",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,message:"Welcome to MATERIAL DASHBOARD React - a beautiful freebie for every web developer.",open:this.state.tc,closeNotification:function closeNotification(){return _this2.setState({tc:false});},close:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{fullWidth:true,color:"primary",onClick:function onClick(){return _this2.showNotification("tr");}},"Top Right"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"tr",color:"info",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,message:"Welcome to MATERIAL DASHBOARD React - a beautiful freebie for every web developer.",open:this.state.tr,closeNotification:function closeNotification(){return _this2.setState({tr:false});},close:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{fullWidth:true,color:"primary",onClick:function onClick(){return _this2.showNotification("bl");}},"Bottom Left"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"bl",color:"info",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,message:"Welcome to MATERIAL DASHBOARD React - a beautiful freebie for every web developer.",open:this.state.bl,closeNotification:function closeNotification(){return _this2.setState({bl:false});},close:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{fullWidth:true,color:"primary",onClick:function onClick(){return _this2.showNotification("bc");}},"Bottom Center"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"bc",color:"info",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,message:"Welcome to MATERIAL DASHBOARD React - a beautiful freebie for every web developer.",open:this.state.bc,closeNotification:function closeNotification(){return _this2.setState({bc:false});},close:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{fullWidth:true,color:"primary",onClick:function onClick(){return _this2.showNotification("br");}},"Bottom Right"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Snackbar_Snackbar_jsx__["a" /* default */],{place:"br",color:"info",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddAlert___default.a,message:"Welcome to MATERIAL DASHBOARD React - a beautiful freebie for every web developer.",open:this.state.br,closeNotification:function closeNotification(){return _this2.setState({br:false});},close:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.cardHeader+" "+classes.center+" "+classes.modalSectionTitle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Modal")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",round:true,className:classes.marginRight,onClick:function onClick(){return _this2.handleClickOpen("classicModal");}},"Classic modal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default.a,{classes:{root:classes.center+" "+classes.modalRoot,paper:classes.modal},open:this.state.classicModal,TransitionComponent:Transition,keepMounted:true,onClose:function onClose(){return _this2.handleClose("classicModal");},"aria-labelledby":"classic-modal-slide-title","aria-describedby":"classic-modal-slide-description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle___default.a,{id:"classic-modal-slide-title",disableTypography:true,className:classes.modalHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,className:classes.modalCloseButton,key:"close","aria-label":"Close",color:"transparent",onClick:function onClick(){return _this2.handleClose("classicModal");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default.a,{className:classes.modalClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.modalTitle},"Modal title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,{id:"classic-modal-slide-description",className:classes.modalBody},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default.a,{className:classes.modalFooter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"transparent"},"Nice Button"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this2.handleClose("classicModal");},color:"danger",simple:true},"Close"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true,className:classes.marginRight,onClick:function onClick(){return _this2.handleClickOpen("noticeModal");}},"Notice Modal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default.a,{classes:{root:classes.center+" "+classes.modalRoot,paper:classes.modal},open:this.state.noticeModal,TransitionComponent:Transition,keepMounted:true,onClose:function onClose(){return _this2.handleClose("noticeModal");},"aria-labelledby":"notice-modal-slide-title","aria-describedby":"notice-modal-slide-description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle___default.a,{id:"notice-modal-slide-title",disableTypography:true,className:classes.modalHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,className:classes.modalCloseButton,key:"close","aria-label":"Close",color:"transparent",onClick:function onClick(){return _this2.handleClose("noticeModal");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default.a,{className:classes.modalClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.modalTitle},"Notice Modal")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,{id:"notice-modal-slide-description",className:classes.modalBody},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Instruction_Instruction_jsx__["a" /* default */],{title:"1. Register",text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"The first step is to create an account at"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.creative-tim.com/"},"Creative Tim"),". You can choose a social network or go for the classic version, whatever works best for you."),image:__WEBPACK_IMPORTED_MODULE_19_assets_img_card_1_jpeg___default.a,className:classes.instructionNoticeModal,imageClassName:classes.imageNoticeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Instruction_Instruction_jsx__["a" /* default */],{title:"2. Apply",text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"The first step is to create an account at"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.creative-tim.com/"},"Creative Tim"),". You can choose a social network or go for the classic version, whatever works best for you."),image:__WEBPACK_IMPORTED_MODULE_20_assets_img_card_2_jpeg___default.a,className:classes.instructionNoticeModal,imageClassName:classes.imageNoticeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you have more questions, don't hesitate to contact us or send us a tweet @creativetim. We're here to help!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default.a,{className:classes.modalFooter+" "+classes.modalFooterCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this2.handleClose("noticeModal");},color:"info",round:true},"Sounds Good"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",round:true,className:classes.marginRight,onClick:function onClick(){return _this2.handleClickOpen("smallModal");}},"Small alert modal"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default.a,{classes:{root:classes.center+" "+classes.modalRoot,paper:classes.modal+" "+classes.modalSmall},open:this.state.smallModal,TransitionComponent:Transition,keepMounted:true,onClose:function onClose(){return _this2.handleClose("noticeModal");},"aria-labelledby":"small-modal-slide-title","aria-describedby":"small-modal-slide-description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogTitle___default.a,{id:"small-modal-slide-title",disableTypography:true,className:classes.modalHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,className:classes.modalCloseButton,key:"close","aria-label":"Close",color:"transparent",onClick:function onClick(){return _this2.handleClose("smallModal");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Close___default.a,{className:classes.modalClose}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,{id:"small-modal-slide-description",className:classes.modalBody+" "+classes.modalSmallBody},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"Are you sure you want to do this?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default.a,{className:classes.modalFooter+" "+classes.modalFooterCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this2.handleClose("smallModal");},color:"transparent",className:classes.modalSmallFooterFirstButton},"Never Mind"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){return _this2.handleClose("smallModal");},color:"success",simple:true,className:classes.modalSmallFooterFirstButton+" "+classes.modalSmallFooterSecondButton},"Yes")))))))))));}}]);return Notifications;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_18_assets_jss_material_dashboard_pro_react_views_notificationsStyle_jsx__["a" /* default */])(Notifications));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var _Modal = _interopRequireDefault(__webpack_require__(217));

var _Fade = _interopRequireDefault(__webpack_require__(334));

var _transitions = __webpack_require__(76);

var _Paper = _interopRequireDefault(__webpack_require__(64));

// @inheritedComponent Modal
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `scroll="bodyr"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      display: 'flex',
      flexDirection: 'column',
      margin: 48,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE11 issue, to remove at some point.
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      flex: '0 1 auto',
      maxHeight: 'calc(100% - 96px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      margin: '48px auto'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360),
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 360) + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: '100%'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0
      }
    }
  };
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */


exports.styles = styles;

function Dialog(props) {
  var _classNames;

  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      fullScreen = props.fullScreen,
      fullWidth = props.fullWidth,
      maxWidth = props.maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      PaperProps = props.PaperProps,
      scroll = props.scroll,
      TransitionComponent = props.TransitionComponent,
      transitionDuration = props.transitionDuration,
      TransitionProps = props.TransitionProps,
      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["scroll".concat((0, _helpers.capitalize)(scroll))], className),
    BackdropProps: (0, _extends2.default)({
      transitionDuration: transitionDuration
    }, BackdropProps),
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onBackdropClick: onBackdropClick,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    role: "dialog"
  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
    elevation: 24,
    className: (0, _classnames.default)(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
  }, PaperProps), children)));
}

Dialog.propTypes =  false ? {
  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes.default.oneOf(['body', 'paper']),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  scroll: 'paper',
  TransitionComponent: _Fade.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialog'
})(Dialog);

exports.default = _default;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Typography = _interopRequireDefault(__webpack_require__(127));

var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '24px 24px 20px',
    flex: '0 0 auto'
  }
};
exports.styles = styles;

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
    variant: "title"
  }, children));
}

DialogTitle.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes.default.bool
} : {};
DialogTitle.defaultProps = {
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle);

exports.default = _default;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    padding: '0 24px 24px',
    '&:first-child': {
      paddingTop: 24
    }
  }
};
exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

DialogContent.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports.default = _default;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _reactHelpers = __webpack_require__(66);

__webpack_require__(220);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    margin: '8px 4px'
  },

  /* Styles applied to the children. */
  action: {
    margin: '0 4px'
  }
};
exports.styles = styles;

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

DialogActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : {};
DialogActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogActions'
})(DialogActions);

exports.default = _default;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
})), 'AddAlert');

exports.default = _default;

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__ = __webpack_require__(397);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// @material-ui/icons
function SnackbarContent(_ref){var _cx2;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,message=props.message,color=props.color,close=props.close,icon=props.icon;var action=[];var messageClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},classes.iconMessage,icon!==undefined));if(close!==undefined){action=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,{className:classes.iconButton,key:"close","aria-label":"Close",color:"inherit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.close}))];}var iconClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx2={},_defineProperty(_cx2,classes.icon,classes.icon),_defineProperty(_cx2,classes.infoIcon,color==="info"),_defineProperty(_cx2,classes.successIcon,color==="success"),_defineProperty(_cx2,classes.warningIcon,color==="warning"),_defineProperty(_cx2,classes.dangerIcon,color==="danger"),_defineProperty(_cx2,classes.primaryIcon,color==="primary"),_defineProperty(_cx2,classes.roseIcon,color==="rose"),_cx2));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_SnackbarContent___default.a,{message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,icon!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.icon,{className:iconClasses}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:messageClasses},message)),classes:{root:classes.root+" "+classes[color],message:classes.message},action:action});}SnackbarContent.defaultProps={color:"info"};SnackbarContent.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["info","success","warning","danger","primary","rose"]),close:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__["a" /* default */])(SnackbarContent));

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Paper = _interopRequireDefault(__webpack_require__(64));

var _Typography = _interopRequireDefault(__webpack_require__(127));

var _colorManipulator = __webpack_require__(75);

// @inheritedComponent Paper
var styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (_root = {
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 24px'
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: theme.shape.borderRadius
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 24,
      marginRight: -8
    }
  };
};

exports.styles = styles;

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    component: _Typography.default,
    headlineMapping: {
      body1: 'div'
    },
    role: "alertdialog",
    square: true,
    elevation: 6,
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("div", {
    className: classes.message
  }, message), action ? _react.default.createElement("div", {
    className: classes.action
  }, action) : null);
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The message to display.
   */
  message: _propTypes.default.node
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

exports.default = _default;

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__ = __webpack_require__(397);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// @material-ui/icons
function Snackbar(_ref){var _cx2;var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,message=props.message,color=props.color,close=props.close,icon=props.icon,place=props.place,open=props.open;var action=[];var messageClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({},classes.iconMessage,icon!==undefined));if(close!==undefined){action=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,{className:classes.iconButton,key:"close","aria-label":"Close",color:"inherit",onClick:function onClick(){return props.closeNotification();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.close}))];}var iconClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_cx2={},_defineProperty(_cx2,classes.icon,classes.icon),_defineProperty(_cx2,classes.infoIcon,color==="info"),_defineProperty(_cx2,classes.successIcon,color==="success"),_defineProperty(_cx2,classes.warningIcon,color==="warning"),_defineProperty(_cx2,classes.dangerIcon,color==="danger"),_defineProperty(_cx2,classes.primaryIcon,color==="primary"),_defineProperty(_cx2,classes.roseIcon,color==="rose"),_cx2));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Snackbar___default.a,{classes:{anchorOriginTopCenter:classes.top20,anchorOriginTopRight:classes.top40,anchorOriginTopLeft:classes.top40},anchorOrigin:{vertical:place.indexOf("t")===-1?"bottom":"top",horizontal:place.indexOf("l")!==-1?"left":place.indexOf("c")!==-1?"center":"right"},open:open,message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,icon!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.icon,{className:iconClasses}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:messageClasses},message)),action:action,ContentProps:{classes:{root:classes.root+" "+classes[color],message:classes.message}}});}Snackbar.defaultProps={color:"info"};Snackbar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["info","success","warning","danger","primary","rose"]),close:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,place:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["tl","tr","tc","br","bl","bc"]),open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7_assets_jss_material_dashboard_pro_react_components_snackbarContentStyle_jsx__["a" /* default */])(Snackbar));

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});

var _Snackbar = _interopRequireDefault(__webpack_require__(821));

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _extends8 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _transitions = __webpack_require__(76);

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(248));

var _helpers = __webpack_require__(25);

var _Slide = _interopRequireDefault(__webpack_require__(126));

var _SnackbarContent = _interopRequireDefault(__webpack_require__(396));

var styles = function styles(theme) {
  var gutter = 24;
  var top = {
    top: 0
  };
  var bottom = {
    bottom: 0
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var topSpace = {
    top: gutter
  };
  var bottomSpace = {
    bottom: gutter
  };
  var rightSpace = {
    right: gutter
  };
  var leftSpace = {
    left: gutter
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: (0, _extends8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: (0, _extends8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, topSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: (0, _extends8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: (0, _extends8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, topSpace, leftSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}

var Snackbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Snackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Snackbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.timerAutoHide = null;
    _this.state = {};

    _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }

      _this.handlePause();
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      _this.handleResume();
    };

    _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    };

    _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    };

    _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration != null) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);

          return;
        }

        _this.setAutoHideTimer(_this.props.autoHideDuration * 0.5);
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    }
  }, {
    key: "setAutoHideTimer",
    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer(autoHideDuration) {
      var _this2 = this;

      var autoHideDurationBefore = autoHideDuration != null ? autoHideDuration : this.props.autoHideDuration;

      if (!this.props.onClose || autoHideDurationBefore == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        var autoHideDurationAfter = autoHideDuration != null ? autoHideDuration : _this2.props.autoHideDuration;

        if (!_this2.props.onClose || autoHideDurationAfter == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDurationBefore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          _this$props$anchorOri = _this$props.anchorOrigin,
          vertical = _this$props$anchorOri.vertical,
          horizontal = _this$props$anchorOri.horizontal,
          autoHideDuration = _this$props.autoHideDuration,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          ClickAwayListenerProps = _this$props.ClickAwayListenerProps,
          ContentProps = _this$props.ContentProps,
          disableWindowBlurListener = _this$props.disableWindowBlurListener,
          message = _this$props.message,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          open = _this$props.open,
          resumeHideDuration = _this$props.resumeHideDuration,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.

      if (!open && this.state.exited) {
        return null;
      }

      return _react.default.createElement(_ClickAwayListener.default, (0, _extends8.default)({
        onClickAway: this.handleClickAway
      }, ClickAwayListenerProps), _react.default.createElement("div", (0, _extends8.default)({
        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
        onBlur: disableWindowBlurListener ? undefined : this.handlePause
      }), _react.default.createElement(TransitionComponent, (0, _extends8.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up'
      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends8.default)({
        message: message,
        action: action
      }, ContentProps)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.exited === 'undefined') {
        return {
          exited: !nextProps.open
        };
      }

      if (nextProps.open) {
        return {
          exited: false
        };
      }

      return null;
    }
  }]);
  return Snackbar;
}(_react.default.Component);

Snackbar.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf(['left', 'center', 'right']).isRequired,
    vertical: _propTypes.default.oneOf(['top', 'center', 'bottom']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * If you wish the take control over the children of the component you can use this property.
   * When used, you replace the `SnackbarContent` component with the children.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: _propTypes.default.object,

  /**
   * Properties applied to the [`SnackbarContent`](/api/snackbar-content) element.
   */
  ContentProps: _propTypes.default.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: _propTypes.default.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes.default.any,

  /**
   * The message to display.
   */
  message: _propTypes.default.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes.default.number,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  disableWindowBlurListener: false,
  TransitionComponent: _Slide.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar);

exports.default = _default;

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ##############################
// // // Instruction component styles
// #############################
var instructionStyle={instruction:{},picture:{},image:{width:"100%",height:"auto",borderRadius:"6px",display:"block",maxWidth:"100%"}};/* harmony default export */ __webpack_exports__["a"] = (instructionStyle);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_modalStyle_jsx__ = __webpack_require__(252);
// ##############################
// // // Notifications view styles
// #############################
var notificationsStyle=function notificationsStyle(theme){return Object.assign({cardTitle:{marginTop:"0",marginBottom:"3px",color:"#3C4858",fontSize:"18px"},cardHeader:{zIndex:"3"},cardSubtitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{color:"#999999",fontSize:"14px",margin:"0 0 10px"}),center:{textAlign:"center"},right:{textAlign:"right"},left:{textAlign:"left"},marginRight:{marginRight:"5px"},modalSectionTitle:{marginTop:"30px"}},Object(__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_modalStyle_jsx__["a" /* default */])(theme));};/* harmony default export */ __webpack_exports__["a"] = (notificationsStyle);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card-1.6ee66b2c.jpeg";

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card-2.ae10829f.jpeg";

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Hidden__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_views_iconsStyle__ = __webpack_require__(827);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/*eslint-disable*/// @material-ui/core components
// core components
function Icons(_ref){var props=_objectWithoutProperties(_ref,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Heading_Heading_jsx__["a" /* default */],{textAlign:"center",title:"Material Design Icons",category:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Handcrafted by our friends from"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:"https://design.google.com/icons/"},"Google"))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardBody_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Hidden___default.a,{only:["sm","xs"],implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe",{className:props.classes.iframe,src:"https://material.io/icons/",title:"Icons iframe"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Your browser does not support iframes."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Hidden___default.a,{only:["lg","md"],implementation:"css"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"The icons are visible on Desktop mode inside an iframe. Since the iframe is not working on Mobile and Tablets please visit the icons on their original page on Google. Check the",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://design.google.com/icons/",target:"_blank",rel:"noopener noreferrer"},"Material Icons"))))))));}Icons.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_views_iconsStyle__["a" /* default */])(Icons));

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Icons styles
// #############################
var iconsStyle={iframe:Object.assign({width:"100%",height:"500px",border:"0"},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["a" /* boxShadow */]),iframeContainer:{margin:"0 -20px 0"}};/* harmony default export */ __webpack_exports__["a"] = (iconsStyle);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Typography_Quote_jsx__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Typography_Muted_jsx__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Typography_Primary_jsx__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Typography_Info_jsx__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Typography_Success_jsx__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Typography_Warning_jsx__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Typography_Danger_jsx__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__ = __webpack_require__(19);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// core components
var style={typo:{paddingLeft:"25%",marginBottom:"40px",position:"relative"},note:{fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',bottom:"10px",color:"#c0c1c2",display:"block",fontWeight:"400",fontSize:"13px",lineHeight:"13px",left:"0",marginLeft:"20px",position:"absolute",width:"260px"}};function Typography(_ref){var props=_objectWithoutProperties(_ref,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Heading_Heading_jsx__["a" /* default */],{textAlign:"center",title:"Material Dashboard Heading",category:"Created using Roboto Font Family"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Header 1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"The Life of Material Dashboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Header 2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"The Life of Material Dashboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Header 3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"The Life of Material Dashboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Header 4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,"The Life of Material Dashboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Header 5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",null,"The Life of Material Dashboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Header 6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"The Life of Material Dashboard")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Paragraph"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that\u2019s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Quote"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Typography_Quote_jsx__["a" /* default */],{text:"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that\u2019s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.",author:" Kanye West, Musician"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Muted Text"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Typography_Muted_jsx__["a" /* default */],null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Primary Text"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Typography_Primary_jsx__["a" /* default */],null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Info Text"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Typography_Info_jsx__["a" /* default */],null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Success Text"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Typography_Success_jsx__["a" /* default */],null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Warning Text"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Typography_Warning_jsx__["a" /* default */],null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Danger Text"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Typography_Danger_jsx__["a" /* default */],null,"I will be the leader of a company that ends up being worth billions of dollars, because I got the answers...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classes.note},"Small Tag"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"Header with small subtitle",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Use \"small\" tag for the headers"))))));}Typography.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(Typography));

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Quote(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,text=props.text,author=props.author;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("blockquote",{className:classes.defaultFontStyle+" "+classes.quote},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.quoteText},text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.quoteAuthor},author));}Quote.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,author:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Quote));

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Muted(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.defaultFontStyle+" "+classes.mutedText},children);}Muted.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Muted));

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Primary(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.defaultFontStyle+" "+classes.primaryText},children);}Primary.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Primary));

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Info(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.defaultFontStyle+" "+classes.infoText},children);}Info.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Info));

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Success(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.defaultFontStyle+" "+classes.successText},children);}Success.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Success));

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Warning(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.defaultFontStyle+" "+classes.warningText},children);}Warning.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Warning));

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__ = __webpack_require__(83);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Danger(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.defaultFontStyle+" "+classes.dangerText},children);}Danger.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_typographyStyle_jsx__["a" /* default */])(Danger));

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_MailOutline__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_MailOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_MailOutline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Clear__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Contacts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_jss_material_dashboard_pro_react_views_regularFormsStyle__ = __webpack_require__(849);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// core components
var RegularForms=function(_React$Component){_inherits(RegularForms,_React$Component);function RegularForms(props){_classCallCheck(this,RegularForms);var _this=_possibleConstructorReturn(this,(RegularForms.__proto__||Object.getPrototypeOf(RegularForms)).call(this,props));_this.state={checked:[24,22],selectedValue:null,selectedEnabled:"b"};_this.handleChange=_this.handleChange.bind(_this);_this.handleChangeEnabled=_this.handleChangeEnabled.bind(_this);return _this;}_createClass(RegularForms,[{key:"handleChange",value:function handleChange(event){this.setState({selectedValue:event.target.value});}},{key:"handleChangeEnabled",value:function handleChangeEnabled(event){this.setState({selectedEnabled:event.target.value});}},{key:"handleToggle",value:function handleToggle(value){var checked=this.state.checked;var currentIndex=checked.indexOf(value);var newChecked=[].concat(_toConsumableArray(checked));if(currentIndex===-1){newChecked.push(value);}else{newChecked.splice(currentIndex,1);}this.setState({checked:newChecked});}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_MailOutline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Stacked Form")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Email adress",id:"email_adress",formControlProps:{fullWidth:true},inputProps:{type:"email"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Password",id:"password",formControlProps:{fullWidth:true},inputProps:{type:"password"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(2);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"Subscribe to newsletter"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose"},"Submit"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Contacts___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Horizontal Form")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Email")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"email_adress2",formControlProps:{fullWidth:true},inputProps:{type:"email"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Password")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"password2",formControlProps:{fullWidth:true},inputProps:{type:"password"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"flex-end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(1);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"Remember me"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"flex-end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose"},"Submit"))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Form Elements"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"With Help")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"help-text",formControlProps:{fullWidth:true},inputProps:{type:"text"},helpText:"A block of help text that breaks onto a new line."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Password")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"pass",formControlProps:{fullWidth:true},inputProps:{type:"password"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Placeholder")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"placeholder",formControlProps:{fullWidth:true},inputProps:{placeholder:"placeholder"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Disabled")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"disabled",formControlProps:{fullWidth:true},inputProps:{placeholder:"Disabled",disabled:true}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Static control")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.staticFormGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.staticFormControl},"hello@creative-tim.com")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal+" "+classes.labelHorizontalRadioCheckbox},"Checkboxes and radios")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(3);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"First Checkbox"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(4);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"Second Checkbox"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default.a,{checked:this.state.selectedValue==="a",onChange:this.handleChange,value:"a",name:"radio button demo","aria-label":"A",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioUnchecked}),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioChecked}),classes:{checked:classes.radio,root:classes.radioRoot}}),classes:{label:classes.label},label:"First Radio"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default.a,{checked:this.state.selectedValue==="b",onChange:this.handleChange,value:"b",name:"radio button demo","aria-label":"B",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioUnchecked}),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioChecked}),classes:{checked:classes.radio,root:classes.radioRoot}}),classes:{label:classes.label},label:"Second Radio"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal+" "+classes.labelHorizontalRadioCheckbox},"Inline checkboxes")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.inlineChecks},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(10);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"a"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(11);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"b"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(12);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"c"})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardHeader_jsx__["a" /* default */],{color:"primary",text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__["a" /* default */],{color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Input Variants"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal+" "+classes.labelHorizontalRadioCheckbox},"Custom Checkboxes & Radios")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(21);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"Unchecked"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(22);},checked:this.state.checked.indexOf(22)!==-1?true:false,checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label},label:"Checked"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{disabled:true,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label,disabled:classes.disabledCheckboxAndRadio},label:"Disabled Unchecked"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{disabled:true,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,checked:this.state.checked.indexOf(24)!==-1?true:false,checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label,disabled:classes.disabledCheckboxAndRadio},label:"Disabled Checked"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default.a,{checked:this.state.selectedEnabled==="a",onChange:this.handleChangeEnabled,value:"a",name:"radio button enabled","aria-label":"A",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioUnchecked}),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioChecked}),classes:{checked:classes.radio,root:classes.radioRoot}}),classes:{label:classes.label},label:"First Radio"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default.a,{checked:this.state.selectedEnabled==="b",onChange:this.handleChangeEnabled,value:"b",name:"radio button enabled","aria-label":"B",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioUnchecked}),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioChecked}),classes:{checked:classes.radio,root:classes.radioRoot}}),classes:{label:classes.label},label:"Second Radio"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{disabled:true,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default.a,{checked:false,value:"a",name:"radio button disabled","aria-label":"B",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioUnchecked}),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioChecked}),classes:{checked:classes.radio,disabled:classes.disabledCheckboxAndRadio,root:classes.radioRoot}}),classes:{label:classes.label},label:"Second Radio"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.checkboxAndRadio+" "+classes.checkboxAndRadioHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControlLabel___default.a,{disabled:true,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Radio___default.a,{checked:true,value:"b",name:"radio button disabled","aria-label":"B",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioUnchecked}),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_FiberManualRecord___default.a,{className:classes.radioChecked}),classes:{checked:classes.radio,disabled:classes.disabledCheckboxAndRadio,root:classes.radioRoot}}),classes:{label:classes.label},label:"Second Radio"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Input with success")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"success",labelText:"Success",formControlProps:{fullWidth:true},inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.inputAdornmentIconSuccess}))},success:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Input with error")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"error",labelText:"Error",formControlProps:{fullWidth:true},inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Clear___default.a,{className:classes.inputAdornmentIconError}))},error:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Column sizing")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"md3",formControlProps:{fullWidth:true},inputProps:{placeholder:"md={3}"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"md4",formControlProps:{fullWidth:true},inputProps:{placeholder:"md={4}"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"md5",formControlProps:{fullWidth:true},inputProps:{placeholder:"md={5}"}}))))))))));}}]);return RegularForms;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_21_assets_jss_material_dashboard_pro_react_views_regularFormsStyle__["a" /* default */])(RegularForms));

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Typography = _interopRequireDefault(__webpack_require__(127));

/* eslint-disable jsx-a11y/label-has-for */
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */


exports.styles = styles;

function FormControlLabel(props, context) {
  var _classNames;

  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      labelPlacement = props.labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return _react.default.createElement("label", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.labelPlacementStart, labelPlacement === 'start'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp)
  }, other), _react.default.cloneElement(control, controlProps), _react.default.createElement(_Typography.default, {
    component: "span",
    className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.disabled, disabled))
  }, label));
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes.default.element,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.node,

  /**
   * The position of the label.
   */
  labelPlacement: _propTypes.default.oneOf(['end', 'start']),

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
FormControlLabel.defaultProps = {
  labelPlacement: 'end'
};
FormControlLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel);

exports.default = _default;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Radio.default;
  }
});

var _Radio = _interopRequireDefault(__webpack_require__(839));

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _SwitchBase = _interopRequireDefault(__webpack_require__(253));

var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(840));

var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(841));

var _helpers = __webpack_require__(25);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

var _ref = _react.default.createElement(_RadioButtonUnchecked.default, null);

var _ref2 = _react.default.createElement(_RadioButtonChecked.default, null);

function Radio(props) {
  var classes = props.classes,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "color"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "radio",
    icon: _ref,
    checkedIcon: _ref2,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    }
  }, other));
}

Radio.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Radio.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiRadio'
})(Radio);

exports.default = _default;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonUnchecked = (0, _pure.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';
var _default = RadioButtonUnchecked;
exports.default = _default;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonChecked = function RadioButtonChecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonChecked = (0, _pure.default)(RadioButtonChecked);
RadioButtonChecked.muiName = 'SvgIcon';
var _default = RadioButtonChecked;
exports.default = _default;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _SwitchBase = _interopRequireDefault(__webpack_require__(253));

var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(843));

var _CheckBox = _interopRequireDefault(__webpack_require__(844));

var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(845));

var _helpers = __webpack_require__(25);

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

function Checkbox(props) {
  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      inputProps = props.inputProps,
      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "className", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.indeterminate, indeterminate), className),
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    inputProps: (0, _extends2.default)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Checkbox.defaultProps = {
  checkedIcon: _react.default.createElement(_CheckBox.default, null),
  color: 'secondary',
  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
  indeterminate: false,
  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCheckbox'
})(Checkbox);

exports.default = _default;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

/**
 * @ignore - internal component.
 */
var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';
var _default = CheckBoxOutlineBlank;
exports.default = _default;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckBox = function CheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBox = (0, _pure.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';
var _default = CheckBox;
exports.default = _default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(69));

var _SvgIcon = _interopRequireDefault(__webpack_require__(55));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
});

/**
 * @ignore - internal component.
 */
var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';
var _default = IndeterminateCheckBox;
exports.default = _default;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Clear');

exports.default = _default;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M24 24H0V0h24v24z"
}), _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
})), 'FiberManualRecord');

exports.default = _default;

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var cardTextStyle={cardText:{float:"none",display:"inline-block",marginRight:"0",borderRadius:"3px",backgroundColor:"#999999",padding:"15px",marginTop:"-20px"},warningCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["D" /* warningCardHeader */],successCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["y" /* successCardHeader */],dangerCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["h" /* dangerCardHeader */],infoCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["p" /* infoCardHeader */],primaryCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["s" /* primaryCardHeader */],roseCardHeader:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["v" /* roseCardHeader */]};/* harmony default export */ __webpack_exports__["a"] = (cardTextStyle);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
// ##############################
// // // RegularForms view styles
// #############################
var regularFormsStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],{cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),staticFormGroup:{marginLeft:"0",marginRight:"0",paddingBottom:"10px",margin:"8px 0 0 0",position:"relative","&:before,&:after":{display:"table",content:'" "'},"&:after":{clear:"both"}},staticFormControl:{marginBottom:"0",paddingTop:"8px",paddingBottom:"8px",minHeight:"34px"},inputAdornment:{marginRight:"8px",position:"relative"},inputAdornmentIconSuccess:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]+"!important"},inputAdornmentIconError:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]+"!important"}});/* harmony default export */ __webpack_exports__["a"] = (regularFormsStyle);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datetime__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tagsinput__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tagsinput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tagsinput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nouislider__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nouislider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nouislider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Switch__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Today__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Today__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_LibraryBooks__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_LibraryBooks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_LibraryBooks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_AvTimer__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_AvTimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_AvTimer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_CustomLinearProgress_CustomLinearProgress_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_CustomUpload_ImageUpload_jsx__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_views_extendedFormsStyle_jsx__ = __webpack_require__(879);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react component plugin for creating a beautiful datetime dropdown picker
// react component plugin for creating beatiful tags on an input
// plugin that creates slider
// @material-ui/core components
// @material-ui/icons
// core components
var ExtendedForms=function(_React$Component){_inherits(ExtendedForms,_React$Component);function ExtendedForms(props){_classCallCheck(this,ExtendedForms);var _this=_possibleConstructorReturn(this,(ExtendedForms.__proto__||Object.getPrototypeOf(ExtendedForms)).call(this,props));_this.handleSimple=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.handleMultiple=function(event){_this.setState({multipleSelect:event.target.value});};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.checked));};};_this.state={checkedA:true,checkedB:false,simpleSelect:"",multipleSelect:[],tags:["pizza","pasta","parmesan"]};_this.handleTags=_this.handleTags.bind(_this);return _this;}_createClass(ExtendedForms,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_nouislider___default.a.create(this.refs.slider1,{start:[40],connect:[true,false],step:1,range:{min:0,max:100}});__WEBPACK_IMPORTED_MODULE_3_nouislider___default.a.create(this.refs.slider2,{start:[20,60],connect:[false,true,false],step:1,range:{min:0,max:100}});}},{key:"handleTags",value:function handleTags(regularTags){this.setState({tags:regularTags});}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Today___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Datetime Picker")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel___default.a,{className:classes.label},"Datetime Picker"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datetime___default.a,{inputProps:{placeholder:"Datetime Picker Here"}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_LibraryBooks___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Date Picker")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel___default.a,{className:classes.label},"Date Picker"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datetime___default.a,{timeFormat:false,inputProps:{placeholder:"Date Picker Here"}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_AvTimer___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Time Picker")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel___default.a,{className:classes.label},"Time Picker"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datetime___default.a,{dateFormat:false,inputProps:{placeholder:"Time Picker Here"}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Switches"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.block},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Switch___default.a,{checked:this.state.checkedA,onChange:this.handleChange("checkedA"),value:"checkedA",classes:{switchBase:classes.switchBase,checked:classes.switchChecked,icon:classes.switchIcon,iconChecked:classes.switchIconChecked,bar:classes.switchBar}}),classes:{label:classes.label},label:"Toggle is on"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.block},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Switch___default.a,{checked:this.state.checkedB,onChange:this.handleChange("checkedB"),value:"checkedB",classes:{switchBase:classes.switchBase,checked:classes.switchChecked,icon:classes.switchIcon,iconChecked:classes.switchIconChecked,bar:classes.switchBar}}),classes:{label:classes.label},label:"Toggle is off"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Customisable Select"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:5,lg:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true,className:classes.selectFormControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel___default.a,{htmlFor:"simple-select",className:classes.selectLabel},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{MenuProps:{className:classes.selectMenu},classes:{select:classes.select},value:this.state.simpleSelect,onChange:this.handleSimple,inputProps:{name:"simpleSelect",id:"simple-select"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{disabled:true,classes:{root:classes.selectMenuItem}},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"2"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"3"},"Bucharest"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"4"},"Rome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"5"},"New York"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"6"},"Miami"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"7"},"Piatra Neamt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"8"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"9"},"Bucharest"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"10"},"Rome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"11"},"New York"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"12"},"Miami"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"13"},"Piatra Neamt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"14"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"15"},"Bucharest"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"16"},"Rome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"17"},"New York"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"18"},"Miami"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"19"},"Piatra Neamt")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:5,lg:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true,className:classes.selectFormControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputLabel___default.a,{htmlFor:"multiple-select",className:classes.selectLabel},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{multiple:true,value:this.state.multipleSelect,onChange:this.handleMultiple,MenuProps:{className:classes.selectMenu},classes:{select:classes.select},inputProps:{name:"multipleSelect",id:"multiple-select"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{disabled:true,classes:{root:classes.selectMenuItem}},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"2"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"3"},"Bucharest"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"4"},"Rome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"5"},"New York"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"6"},"Miami"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"7"},"Piatra Neamt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"8"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"9"},"Bucharest"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"10"},"Rome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"11"},"New York"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"12"},"Miami"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"13"},"Piatra Neamt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"14"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"15"},"Bucharest"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"16"},"Rome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"17"},"New York"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"18"},"Miami"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelectedMultiple},value:"19"},"Piatra Neamt"))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Tags"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tagsinput___default.a,{value:this.state.tags,onChange:this.handleTags,tagProps:{className:"react-tagsinput-tag info"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Dropdown & Dropup"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{buttonText:"Multilevel Dropdown",hoverColor:"info",buttonProps:{round:true,block:true,color:"info"},dropPlacement:"bottom",dropdownList:["Action","Another action",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{ref:"multi",innerDropDown:true,buttonText:"Submenu",hoverColor:"info",buttonProps:{simple:true,block:true},dropPlacement:"right-start",dropdownList:["Submenu action","Submenu action",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{ref:"multi",innerDropDown:true,hoverColor:"info",buttonText:"Subsubmenu",buttonProps:{simple:true},dropPlacement:"right-start",dropdownList:["Subsubmenu action 1","Subsubmenu action 2"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{ref:"multi",innerDropDown:true,hoverColor:"info",buttonText:"Second Subsubmenu",buttonProps:{simple:true},dropPlacement:"right-start",dropdownList:["Second Subsubmenu action 1","Second Subsubmenu action 2"]})]})]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{hoverColor:"info",buttonText:"Dropdown",buttonProps:{round:true,fullWidth:true,style:{marginBottom:"0"},color:"info"},dropdownHeader:"Dropdown header",dropdownList:["Action","Another action","Something else here",{divider:true},"Separated link",{divider:true},"One more separated link"]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6,md:6,lg:6,className:classes.mrAuto+" "+classes.mlAuto},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomDropdown_CustomDropdown_jsx__["a" /* default */],{dropup:true,buttonText:"Dropup",hoverColor:"info",buttonProps:{round:true,fullWidth:true,style:{marginBottom:"0"},color:"info"},dropdownHeader:"Dropdown header",dropdownList:["Action","Another action","Something else here",{divider:true},"Separated link",{divider:true},"One more separated link"]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Progress Bars"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"determinate",color:"primary",value:30}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"determinate",color:"info",value:60}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"determinate",color:"success",value:100,style:{width:"35%",display:"inline-block"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"determinate",color:"warning",value:100,style:{width:"20%",display:"inline-block"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"determinate",color:"danger",value:25,style:{width:"45%",display:"inline-block"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Sliders"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slider-primary",ref:"slider1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slider-info",ref:"slider2"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Regular Image"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_CustomUpload_ImageUpload_jsx__["a" /* default */],{addButtonProps:{color:"rose",round:true},changeButtonProps:{color:"rose",round:true},removeButtonProps:{color:"danger",round:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend",null,"Avatar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_CustomUpload_ImageUpload_jsx__["a" /* default */],{avatar:true,addButtonProps:{color:"rose",round:true},changeButtonProps:{color:"rose",round:true},removeButtonProps:{color:"danger",round:true}}))))))));}}]);return ExtendedForms;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_views_extendedFormsStyle_jsx__["a" /* default */])(ExtendedForms));

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(401),
	PropTypes = __webpack_require__(2),
	createClass = __webpack_require__(102),
	moment = __webpack_require__(254),
	React = __webpack_require__(0),
	CalendarContainer = __webpack_require__(853)
	;

var viewModes = Object.freeze({
	YEARS: 'years',
	MONTHS: 'months',
	DAYS: 'days',
	TIME: 'time',
});

var TYPES = PropTypes;
var Datetime = createClass({
	displayName: 'DateTime',
	propTypes: {
		// value: TYPES.object | TYPES.string,
		// defaultValue: TYPES.object | TYPES.string,
		// viewDate: TYPES.object | TYPES.string,
		onFocus: TYPES.func,
		onBlur: TYPES.func,
		onChange: TYPES.func,
		onViewModeChange: TYPES.func,
		onNavigateBack: TYPES.func,
		onNavigateForward: TYPES.func,
		locale: TYPES.string,
		utc: TYPES.bool,
		input: TYPES.bool,
		// dateFormat: TYPES.string | TYPES.bool,
		// timeFormat: TYPES.string | TYPES.bool,
		inputProps: TYPES.object,
		timeConstraints: TYPES.object,
		viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
		isValidDate: TYPES.func,
		open: TYPES.bool,
		strictParsing: TYPES.bool,
		closeOnSelect: TYPES.bool,
		closeOnTab: TYPES.bool
	},

	getInitialState: function() {
		var state = this.getStateFromProps( this.props );

		if ( state.open === undefined )
			state.open = !this.props.input;

		state.currentView = this.props.dateFormat ?
			(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;

		return state;
	},

	parseDate: function (date, formats) {
		var parsedDate;

		if (date && typeof date === 'string')
			parsedDate = this.localMoment(date, formats.datetime);
		else if (date)
			parsedDate = this.localMoment(date);

		if (parsedDate && !parsedDate.isValid())
			parsedDate = null;

		return parsedDate;
	},

	getStateFromProps: function( props ) {
		var formats = this.getFormats( props ),
			date = props.value || props.defaultValue,
			selectedDate, viewDate, updateOn, inputValue
			;

		selectedDate = this.parseDate(date, formats);

		viewDate = this.parseDate(props.viewDate, formats);

		viewDate = selectedDate ?
			selectedDate.clone().startOf('month') :
			viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');

		updateOn = this.getUpdateOn(formats);

		if ( selectedDate )
			inputValue = selectedDate.format(formats.datetime);
		else if ( date.isValid && !date.isValid() )
			inputValue = '';
		else
			inputValue = date || '';

		return {
			updateOn: updateOn,
			inputFormat: formats.datetime,
			viewDate: viewDate,
			selectedDate: selectedDate,
			inputValue: inputValue,
			open: props.open
		};
	},

	getUpdateOn: function( formats ) {
		if ( formats.date.match(/[lLD]/) ) {
			return viewModes.DAYS;
		} else if ( formats.date.indexOf('M') !== -1 ) {
			return viewModes.MONTHS;
		} else if ( formats.date.indexOf('Y') !== -1 ) {
			return viewModes.YEARS;
		}

		return viewModes.DAYS;
	},

	getFormats: function( props ) {
		var formats = {
				date: props.dateFormat || '',
				time: props.timeFormat || ''
			},
			locale = this.localMoment( props.date, null, props ).localeData()
			;

		if ( formats.date === true ) {
			formats.date = locale.longDateFormat('L');
		}
		else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
			formats.time = '';
		}

		if ( formats.time === true ) {
			formats.time = locale.longDateFormat('LT');
		}

		formats.datetime = formats.date && formats.time ?
			formats.date + ' ' + formats.time :
			formats.date || formats.time
		;

		return formats;
	},

	componentWillReceiveProps: function( nextProps ) {
		var formats = this.getFormats( nextProps ),
			updatedState = {}
		;

		if ( nextProps.value !== this.props.value ||
			formats.datetime !== this.getFormats( this.props ).datetime ) {
			updatedState = this.getStateFromProps( nextProps );
		}

		if ( updatedState.open === undefined ) {
			if ( typeof nextProps.open !== 'undefined' ) {
				updatedState.open = nextProps.open;
			} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
				updatedState.open = false;
			} else {
				updatedState.open = this.state.open;
			}
		}

		if ( nextProps.viewMode !== this.props.viewMode ) {
			updatedState.currentView = nextProps.viewMode;
		}

		if ( nextProps.locale !== this.props.locale ) {
			if ( this.state.viewDate ) {
				var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
				updatedState.viewDate = updatedViewDate;
			}
			if ( this.state.selectedDate ) {
				var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
				updatedState.selectedDate = updatedSelectedDate;
				updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
			}
		}

		if ( nextProps.utc !== this.props.utc ) {
			if ( nextProps.utc ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().utc();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().utc();
					updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
				}
			} else {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().local();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().local();
					updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
				}
			}
		}

		if ( nextProps.viewDate !== this.props.viewDate ) {
			updatedState.viewDate = moment(nextProps.viewDate);
		}
		//we should only show a valid date if we are provided a isValidDate function. Removed in 2.10.3
		/*if (this.props.isValidDate) {
			updatedState.viewDate = updatedState.viewDate || this.state.viewDate;
			while (!this.props.isValidDate(updatedState.viewDate)) {
				updatedState.viewDate = updatedState.viewDate.add(1, 'day');
			}
		}*/
		this.setState( updatedState );
	},

	onInputChange: function( e ) {
		var value = e.target === null ? e : e.target.value,
			localMoment = this.localMoment( value, this.state.inputFormat ),
			update = { inputValue: value }
			;

		if ( localMoment.isValid() && !this.props.value ) {
			update.selectedDate = localMoment;
			update.viewDate = localMoment.clone().startOf('month');
		} else {
			update.selectedDate = null;
		}

		return this.setState( update, function() {
			return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
		});
	},

	onInputKey: function( e ) {
		if ( e.which === 9 && this.props.closeOnTab ) {
			this.closeCalendar();
		}
	},

	showView: function( view ) {
		var me = this;
		return function() {
			me.state.currentView !== view && me.props.onViewModeChange( view );
			me.setState({ currentView: view });
		};
	},

	setDate: function( type ) {
		var me = this,
			nextViews = {
				month: viewModes.DAYS,
				year: viewModes.MONTHS,
			}
		;
		return function( e ) {
			me.setState({
				viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
				currentView: nextViews[ type ]
			});
			me.props.onViewModeChange( nextViews[ type ] );
		};
	},

	subtractTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateBack( amount, type );
			me.updateTime( 'subtract', amount, type, toSelected );
		};
	},

	addTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateForward( amount, type );
			me.updateTime( 'add', amount, type, toSelected );
		};
	},

	updateTime: function( op, amount, type, toSelected ) {
		var update = {},
			date = toSelected ? 'selectedDate' : 'viewDate';

		update[ date ] = this.state[ date ].clone()[ op ]( amount, type );

		this.setState( update );
	},

	allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
	setTime: function( type, value ) {
		var index = this.allowedSetTime.indexOf( type ) + 1,
			state = this.state,
			date = (state.selectedDate || state.viewDate).clone(),
			nextType
			;

		// It is needed to set all the time properties
		// to not to reset the time
		date[ type ]( value );
		for (; index < this.allowedSetTime.length; index++) {
			nextType = this.allowedSetTime[index];
			date[ nextType ]( date[nextType]() );
		}

		if ( !this.props.value ) {
			this.setState({
				selectedDate: date,
				inputValue: date.format( state.inputFormat )
			});
		}
		this.props.onChange( date );
	},

	updateSelectedDate: function( e, close ) {
		var target = e.target,
			modifier = 0,
			viewDate = this.state.viewDate,
			currentDate = this.state.selectedDate || viewDate,
			date
			;

		if (target.className.indexOf('rdtDay') !== -1) {
			if (target.className.indexOf('rdtNew') !== -1)
				modifier = 1;
			else if (target.className.indexOf('rdtOld') !== -1)
				modifier = -1;

			date = viewDate.clone()
				.month( viewDate.month() + modifier )
				.date( parseInt( target.getAttribute('data-value'), 10 ) );
		} else if (target.className.indexOf('rdtMonth') !== -1) {
			date = viewDate.clone()
				.month( parseInt( target.getAttribute('data-value'), 10 ) )
				.date( currentDate.date() );
		} else if (target.className.indexOf('rdtYear') !== -1) {
			date = viewDate.clone()
				.month( currentDate.month() )
				.date( currentDate.date() )
				.year( parseInt( target.getAttribute('data-value'), 10 ) );
		}

		date.hours( currentDate.hours() )
			.minutes( currentDate.minutes() )
			.seconds( currentDate.seconds() )
			.milliseconds( currentDate.milliseconds() );

		if ( !this.props.value ) {
			var open = !( this.props.closeOnSelect && close );
			if ( !open ) {
				this.props.onBlur( date );
			}

			this.setState({
				selectedDate: date,
				viewDate: date.clone().startOf('month'),
				inputValue: date.format( this.state.inputFormat ),
				open: open
			});
		} else {
			if ( this.props.closeOnSelect && close ) {
				this.closeCalendar();
			}
		}

		this.props.onChange( date );
	},

	openCalendar: function( e ) {
		if ( !this.state.open ) {
			this.setState({ open: true }, function() {
				this.props.onFocus( e );
			});
		}
	},

	closeCalendar: function() {
		this.setState({ open: false }, function () {
			this.props.onBlur( this.state.selectedDate || this.state.inputValue );
		});
	},

	handleClickOutside: function() {
		if ( this.props.input && this.state.open && !this.props.open && !this.props.disableOnClickOutside ) {
			this.setState({ open: false }, function() {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		}
	},

	localMoment: function( date, format, props ) {
		props = props || this.props;
		var momentFn = props.utc ? moment.utc : moment;
		var m = momentFn( date, format, props.strictParsing );
		if ( props.locale )
			m.locale( props.locale );
		return m;
	},

	componentProps: {
		fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
		fromState: ['viewDate', 'selectedDate', 'updateOn'],
		fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
	},

	getComponentProps: function() {
		var me = this,
			formats = this.getFormats( this.props ),
			props = {dateFormat: formats.date, timeFormat: formats.time}
			;

		this.componentProps.fromProps.forEach( function( name ) {
			props[ name ] = me.props[ name ];
		});
		this.componentProps.fromState.forEach( function( name ) {
			props[ name ] = me.state[ name ];
		});
		this.componentProps.fromThis.forEach( function( name ) {
			props[ name ] = me[ name ];
		});

		return props;
	},

	render: function() {
		// TODO: Make a function or clean up this code,
		// logic right now is really hard to follow
		var className = 'rdt' + (this.props.className ?
                  ( Array.isArray( this.props.className ) ?
                  ' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
			children = [];

		if ( this.props.input ) {
			var finalInputProps = assign({
				type: 'text',
				className: 'form-control',
				onClick: this.openCalendar,
				onFocus: this.openCalendar,
				onChange: this.onInputChange,
				onKeyDown: this.onInputKey,
				value: this.state.inputValue,
			}, this.props.inputProps);
			if ( this.props.renderInput ) {
				children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
			} else {
				children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
			}
		} else {
			className += ' rdtStatic';
		}

		if ( this.state.open )
			className += ' rdtOpen';

		return React.createElement( 'div', { className: className }, children.concat(
			React.createElement( 'div',
				{ key: 'dt', className: 'rdtPicker' },
				React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps(), onClickOutside: this.handleClickOutside })
			)
		));
	}
});

Datetime.defaultProps = {
	className: '',
	defaultValue: '',
	inputProps: {},
	input: true,
	onFocus: function() {},
	onBlur: function() {},
	onChange: function() {},
	onViewModeChange: function() {},
	onNavigateBack: function() {},
	onNavigateForward: function() {},
	timeFormat: true,
	timeConstraints: {},
	dateFormat: true,
	strictParsing: true,
	closeOnSelect: false,
	closeOnTab: true,
	utc: false
};

// Make moment accessible through the Datetime class
Datetime.moment = moment;

module.exports = Datetime;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(42);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(102),
	DaysView = __webpack_require__(854),
	MonthsView = __webpack_require__(855),
	YearsView = __webpack_require__(856),
	TimeView = __webpack_require__(857)
	;

var CalendarContainer = createClass({
	viewComponents: {
		days: DaysView,
		months: MonthsView,
		years: YearsView,
		time: TimeView
	},

	render: function() {
		return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
	}
});

module.exports = CalendarContainer;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(102),
	moment = __webpack_require__(254),
	onClickOutside = __webpack_require__(180).default
	;

var DateTimePickerDays = onClickOutside( createClass({
	render: function() {
		var footer = this.renderFooter(),
			date = this.props.viewDate,
			locale = date.localeData(),
			tableChildren
			;

		tableChildren = [
			React.createElement('thead', { key: 'th' }, [
				React.createElement('tr', { key: 'h' }, [
					React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
					React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
				]),
				React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
			]),
			React.createElement('tbody', { key: 'tb' }, this.renderDays())
		];

		if ( footer )
			tableChildren.push( footer );

		return React.createElement('div', { className: 'rdtDays' },
			React.createElement('table', {}, tableChildren )
		);
	},

	/**
	 * Get a list of the days of the week
	 * depending on the current locale
	 * @return {array} A list with the shortname of the days
	 */
	getDaysOfWeek: function( locale ) {
		var days = locale._weekdaysMin,
			first = locale.firstDayOfWeek(),
			dow = [],
			i = 0
			;

		days.forEach( function( day ) {
			dow[ (7 + ( i++ ) - first) % 7 ] = day;
		});

		return dow;
	},

	renderDays: function() {
		var date = this.props.viewDate,
			selected = this.props.selectedDate && this.props.selectedDate.clone(),
			prevMonth = date.clone().subtract( 1, 'months' ),
			currentYear = date.year(),
			currentMonth = date.month(),
			weeks = [],
			days = [],
			renderer = this.props.renderDay || this.renderDay,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, isDisabled, dayProps, currentDate
			;

		// Go to the last week of the previous month
		prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
		var lastDay = prevMonth.clone().add( 42, 'd' );

		while ( prevMonth.isBefore( lastDay ) ) {
			classes = 'rdtDay';
			currentDate = prevMonth.clone();

			if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
				classes += ' rdtOld';
			else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
				classes += ' rdtNew';

			if ( selected && prevMonth.isSame( selected, 'day' ) )
				classes += ' rdtActive';

			if ( prevMonth.isSame( moment(), 'day' ) )
				classes += ' rdtToday';

			isDisabled = !isValid( currentDate, selected );
			if ( isDisabled )
				classes += ' rdtDisabled';

			dayProps = {
				key: prevMonth.format( 'M_D' ),
				'data-value': prevMonth.date(),
				className: classes
			};

			if ( !isDisabled )
				dayProps.onClick = this.updateSelectedDate;

			days.push( renderer( dayProps, currentDate, selected ) );

			if ( days.length === 7 ) {
				weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
				days = [];
			}

			prevMonth.add( 1, 'd' );
		}

		return weeks;
	},

	updateSelectedDate: function( event ) {
		this.props.updateSelectedDate( event, true );
	},

	renderDay: function( props, currentDate ) {
		return React.createElement('td',  props, currentDate.date() );
	},

	renderFooter: function() {
		if ( !this.props.timeFormat )
			return '';

		var date = this.props.selectedDate || this.props.viewDate;

		return React.createElement('tfoot', { key: 'tf'},
			React.createElement('tr', {},
				React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
			)
		);
	},

	alwaysValidDate: function() {
		return 1;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

module.exports = DateTimePickerDays;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(102),
	onClickOutside = __webpack_require__(180).default
	;

var DateTimePickerMonths = onClickOutside( createClass({
	render: function() {
		return React.createElement('div', { className: 'rdtMonths' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
		]);
	},

	renderMonths: function() {
		var date = this.props.selectedDate,
			month = this.props.viewDate.month(),
			year = this.props.viewDate.year(),
			rows = [],
			i = 0,
			months = [],
			renderer = this.props.renderMonth || this.renderMonth,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
			// Date is irrelevant because we're only interested in month
			irrelevantDate = 1
			;

		while (i < 12) {
			classes = 'rdtMonth';
			currentMonth =
				this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });

			noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
			daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInMonth.find(function( d ) {
				var day = currentMonth.clone().set( 'date', d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( date && i === date.month() && year === date.year() )
				classes += ' rdtActive';

			props = {
				key: i,
				'data-value': i,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'months' ?
					this.updateSelectedMonth : this.props.setDate( 'month' ) );

			months.push( renderer( props, i, year, date && date.clone() ) );

			if ( months.length === 4 ) {
				rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
				months = [];
			}

			i++;
		}

		return rows;
	},

	updateSelectedMonth: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderMonth: function( props, month ) {
		var localMoment = this.props.viewDate;
		var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
		var strLength = 3;
		// Because some months are up to 5 characters long, we want to
		// use a fixed string length for consistency
		var monthStrFixedLength = monthStr.substring( 0, strLength );
		return React.createElement('td', props, capitalize( monthStrFixedLength ) );
	},

	alwaysValidDate: function() {
		return 1;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

function capitalize( str ) {
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
}

module.exports = DateTimePickerMonths;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(102),
	onClickOutside = __webpack_require__(180).default
	;

var DateTimePickerYears = onClickOutside( createClass({
	render: function() {
		var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;

		return React.createElement('div', { className: 'rdtYears' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
		]);
	},

	renderYears: function( year ) {
		var years = [],
			i = -1,
			rows = [],
			renderer = this.props.renderYear || this.renderYear,
			selectedDate = this.props.selectedDate,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
			// Month and date are irrelevant here because
			// we're only interested in the year
			irrelevantMonth = 0,
			irrelevantDate = 1
			;

		year--;
		while (i < 11) {
			classes = 'rdtYear';
			currentYear = this.props.viewDate.clone().set(
				{ year: year, month: irrelevantMonth, date: irrelevantDate } );

			// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
			// if ( i === -1 | i === 10 )
				// classes += ' rdtOld';

			noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
			daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInYear.find(function( d ) {
				var day = currentYear.clone().dayOfYear( d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( selectedDate && selectedDate.year() === year )
				classes += ' rdtActive';

			props = {
				key: year,
				'data-value': year,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'years' ?
					this.updateSelectedYear : this.props.setDate('year') );

			years.push( renderer( props, year, selectedDate && selectedDate.clone() ));

			if ( years.length === 4 ) {
				rows.push( React.createElement('tr', { key: i }, years ) );
				years = [];
			}

			year++;
			i++;
		}

		return rows;
	},

	updateSelectedYear: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderYear: function( props, year ) {
		return React.createElement('td',  props, year );
	},

	alwaysValidDate: function() {
		return 1;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

module.exports = DateTimePickerYears;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(102),
	assign = __webpack_require__(401),
	onClickOutside = __webpack_require__(180).default
	;

var DateTimePickerTime = onClickOutside( createClass({
	getInitialState: function() {
		return this.calculateState( this.props );
	},

	calculateState: function( props ) {
		var date = props.selectedDate || props.viewDate,
			format = props.timeFormat,
			counters = []
			;

		if ( format.toLowerCase().indexOf('h') !== -1 ) {
			counters.push('hours');
			if ( format.indexOf('m') !== -1 ) {
				counters.push('minutes');
				if ( format.indexOf('s') !== -1 ) {
					counters.push('seconds');
				}
			}
		}

		var hours = date.format( 'H' );
		
		var daypart = false;
		if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
			if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
				daypart = ( hours >= 12 ) ? 'PM' : 'AM';
			} else {
				daypart = ( hours >= 12 ) ? 'pm' : 'am';
			}
		}

		return {
			hours: hours,
			minutes: date.format( 'mm' ),
			seconds: date.format( 'ss' ),
			milliseconds: date.format( 'SSS' ),
			daypart: daypart,
			counters: counters
		};
	},

	renderCounter: function( type ) {
		if ( type !== 'daypart' ) {
			var value = this.state[ type ];
			if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				value = ( value - 1 ) % 12 + 1;

				if ( value === 0 ) {
					value = 12;
				}
			}
			return React.createElement('div', { key: type, className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		}
		return '';
	},

	renderDayPart: function() {
		return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
			React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
			React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
			React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
		]);
	},

	render: function() {
		var me = this,
			counters = []
		;

		this.state.counters.forEach( function( c ) {
			if ( counters.length )
				counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
			counters.push( me.renderCounter( c ) );
		});

		if ( this.state.daypart !== false ) {
			counters.push( me.renderDayPart() );
		}

		if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
			counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
			counters.push(
				React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
					React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
					)
				);
		}

		return React.createElement('div', { className: 'rdtTime' },
			React.createElement('table', {}, [
				this.renderHeader(),
				React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
					React.createElement('div', { className: 'rdtCounters' }, counters )
				)))
			])
		);
	},

	componentWillMount: function() {
		var me = this;
		me.timeConstraints = {
			hours: {
				min: 0,
				max: 23,
				step: 1
			},
			minutes: {
				min: 0,
				max: 59,
				step: 1
			},
			seconds: {
				min: 0,
				max: 59,
				step: 1
			},
			milliseconds: {
				min: 0,
				max: 999,
				step: 1
			}
		};
		['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
			assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
		});
		this.setState( this.calculateState( this.props ) );
	},

	componentWillReceiveProps: function( nextProps ) {
		this.setState( this.calculateState( nextProps ) );
	},

	updateMilli: function( e ) {
		var milli = parseInt( e.target.value, 10 );
		if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
			this.props.setTime( 'milliseconds', milli );
			this.setState( { milliseconds: milli } );
		}
	},

	renderHeader: function() {
		if ( !this.props.dateFormat )
			return null;

		var date = this.props.selectedDate || this.props.viewDate;
		return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
			React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
		));
	},

	onStartClicking: function( action, type ) {
		var me = this;

		return function() {
			var update = {};
			update[ type ] = me[ action ]( type );
			me.setState( update );

			me.timer = setTimeout( function() {
				me.increaseTimer = setInterval( function() {
					update[ type ] = me[ action ]( type );
					me.setState( update );
				}, 70);
			}, 500);

			me.mouseUpListener = function() {
				clearTimeout( me.timer );
				clearInterval( me.increaseTimer );
				me.props.setTime( type, me.state[ type ] );
				document.body.removeEventListener( 'mouseup', me.mouseUpListener );
				document.body.removeEventListener( 'touchend', me.mouseUpListener );
			};

			document.body.addEventListener( 'mouseup', me.mouseUpListener );
			document.body.addEventListener( 'touchend', me.mouseUpListener );
		};
	},

	disableContextMenu: function( event ) {
		event.preventDefault();
		return false;
	},

	padValues: {
		hours: 1,
		minutes: 2,
		seconds: 2,
		milliseconds: 3
	},

	toggleDayPart: function( type ) { // type is always 'hours'
		var value = parseInt( this.state[ type ], 10) + 12;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	increase: function( type ) {
		var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	decrease: function( type ) {
		var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
		if ( value < this.timeConstraints[ type ].min )
			value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
		return this.pad( type, value );
	},

	pad: function( type, value ) {
		var str = value + '';
		while ( str.length < this.padValues[ type ] )
			str = '0' + str;
		return str;
	},

	handleClickOutside: function() {
		this.props.handleClickOutside();
	}
}));

module.exports = DateTimePickerTime;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.React, global.propTypes);
    global.ReactTagsInput = mod.exports;
  }
})(this, function (module, exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function uniq(arr) {
    var out = [];

    for (var i = 0; i < arr.length; i++) {
      if (out.indexOf(arr[i]) === -1) {
        out.push(arr[i]);
      }
    }

    return out;
  }

  /* istanbul ignore next */
  function getClipboardData(e) {
    if (window.clipboardData) {
      return window.clipboardData.getData('Text');
    }

    if (e.clipboardData) {
      return e.clipboardData.getData('text/plain');
    }

    return '';
  }

  function defaultRenderTag(props) {
    var tag = props.tag,
        key = props.key,
        disabled = props.disabled,
        onRemove = props.onRemove,
        classNameRemove = props.classNameRemove,
        getTagDisplayValue = props.getTagDisplayValue,
        other = _objectWithoutProperties(props, ['tag', 'key', 'disabled', 'onRemove', 'classNameRemove', 'getTagDisplayValue']);

    return _react2.default.createElement(
      'span',
      _extends({ key: key }, other),
      getTagDisplayValue(tag),
      !disabled && _react2.default.createElement('a', { className: classNameRemove, onClick: function onClick(e) {
          return onRemove(key);
        } })
    );
  }

  function defaultRenderInput(_ref) {
    var addTag = _ref.addTag,
        props = _objectWithoutProperties(_ref, ['addTag']);

    var onChange = props.onChange,
        value = props.value,
        other = _objectWithoutProperties(props, ['onChange', 'value']);

    return _react2.default.createElement('input', _extends({ type: 'text', onChange: onChange, value: value }, other));
  }

  function defaultRenderLayout(tagComponents, inputComponent) {
    return _react2.default.createElement(
      'span',
      null,
      tagComponents,
      inputComponent
    );
  }

  function defaultPasteSplit(data) {
    return data.split(' ').map(function (d) {
      return d.trim();
    });
  }

  var defaultInputProps = {
    className: 'react-tagsinput-input',
    placeholder: 'Add a tag'
  };

  var TagsInput = function (_React$Component) {
    _inherits(TagsInput, _React$Component);

    /* istanbul ignore next */
    function TagsInput() {
      _classCallCheck(this, TagsInput);

      var _this = _possibleConstructorReturn(this, (TagsInput.__proto__ || Object.getPrototypeOf(TagsInput)).call(this));

      _this.state = { tag: '', isFocused: false };
      _this.focus = _this.focus.bind(_this);
      _this.blur = _this.blur.bind(_this);
      return _this;
    }

    _createClass(TagsInput, [{
      key: '_getTagDisplayValue',
      value: function _getTagDisplayValue(tag) {
        var tagDisplayProp = this.props.tagDisplayProp;


        if (tagDisplayProp) {
          return tag[tagDisplayProp];
        }

        return tag;
      }
    }, {
      key: '_makeTag',
      value: function _makeTag(tag) {
        var tagDisplayProp = this.props.tagDisplayProp;


        if (tagDisplayProp) {
          return _defineProperty({}, tagDisplayProp, tag);
        }

        return tag;
      }
    }, {
      key: '_removeTag',
      value: function _removeTag(index) {
        var value = this.props.value.concat([]);
        if (index > -1 && index < value.length) {
          var changed = value.splice(index, 1);
          this.props.onChange(value, changed, [index]);
        }
      }
    }, {
      key: '_clearInput',
      value: function _clearInput() {
        if (this.hasControlledInput()) {
          this.props.onChangeInput('');
        } else {
          this.setState({ tag: '' });
        }
      }
    }, {
      key: '_tag',
      value: function _tag() {
        if (this.hasControlledInput()) {
          return this.props.inputValue;
        }

        return this.state.tag;
      }
    }, {
      key: '_addTags',
      value: function _addTags(tags) {
        var _this2 = this;

        var _props = this.props,
            validationRegex = _props.validationRegex,
            onChange = _props.onChange,
            onValidationReject = _props.onValidationReject,
            onlyUnique = _props.onlyUnique,
            maxTags = _props.maxTags,
            value = _props.value;


        if (onlyUnique) {
          tags = uniq(tags);
          tags = tags.filter(function (tag) {
            return value.every(function (currentTag) {
              return _this2._getTagDisplayValue(currentTag) !== _this2._getTagDisplayValue(tag);
            });
          });
        }

        var rejectedTags = tags.filter(function (tag) {
          return !validationRegex.test(_this2._getTagDisplayValue(tag));
        });
        tags = tags.filter(function (tag) {
          return validationRegex.test(_this2._getTagDisplayValue(tag));
        });
        tags = tags.filter(function (tag) {
          var tagDisplayValue = _this2._getTagDisplayValue(tag);
          if (typeof tagDisplayValue.trim === 'function') {
            return tagDisplayValue.trim().length > 0;
          } else {
            return tagDisplayValue;
          }
        });

        if (maxTags >= 0) {
          var remainingLimit = Math.max(maxTags - value.length, 0);
          tags = tags.slice(0, remainingLimit);
        }

        if (onValidationReject && rejectedTags.length > 0) {
          onValidationReject(rejectedTags);
        }

        if (tags.length > 0) {
          var newValue = value.concat(tags);
          var indexes = [];
          for (var i = 0; i < tags.length; i++) {
            indexes.push(value.length + i);
          }
          onChange(newValue, tags, indexes);
          this._clearInput();
          return true;
        }

        if (rejectedTags.length > 0) {
          return false;
        }

        this._clearInput();
        return false;
      }
    }, {
      key: '_shouldPreventDefaultEventOnAdd',
      value: function _shouldPreventDefaultEventOnAdd(added, empty, keyCode) {
        if (added) {
          return true;
        }

        if (keyCode === 13) {
          return this.props.preventSubmit || !this.props.preventSubmit && !empty;
        }

        return false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (this.input && typeof this.input.focus === 'function') {
          this.input.focus();
        }

        this.handleOnFocus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        if (this.input && typeof this.input.blur === 'function') {
          this.input.blur();
        }

        this.handleOnBlur();
      }
    }, {
      key: 'accept',
      value: function accept() {
        var tag = this._tag();

        if (tag !== '') {
          tag = this._makeTag(tag);
          return this._addTags([tag]);
        }

        return false;
      }
    }, {
      key: 'addTag',
      value: function addTag(tag) {
        return this._addTags([tag]);
      }
    }, {
      key: 'clearInput',
      value: function clearInput() {
        this._clearInput();
      }
    }, {
      key: 'handlePaste',
      value: function handlePaste(e) {
        var _this3 = this;

        var _props2 = this.props,
            addOnPaste = _props2.addOnPaste,
            pasteSplit = _props2.pasteSplit;


        if (!addOnPaste) {
          return;
        }

        e.preventDefault();

        var data = getClipboardData(e);
        var tags = pasteSplit(data).map(function (tag) {
          return _this3._makeTag(tag);
        });

        this._addTags(tags);
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(e) {
        if (e.defaultPrevented) {
          return;
        }

        var _props3 = this.props,
            value = _props3.value,
            removeKeys = _props3.removeKeys,
            addKeys = _props3.addKeys;

        var tag = this._tag();
        var empty = tag === '';
        var keyCode = e.keyCode;
        var key = e.key;
        var add = addKeys.indexOf(keyCode) !== -1 || addKeys.indexOf(key) !== -1;
        var remove = removeKeys.indexOf(keyCode) !== -1 || removeKeys.indexOf(key) !== -1;

        if (add) {
          var added = this.accept();
          if (this._shouldPreventDefaultEventOnAdd(added, empty, keyCode)) {
            e.preventDefault();
          }
        }

        if (remove && value.length > 0 && empty) {
          e.preventDefault();
          this._removeTag(value.length - 1);
        }
      }
    }, {
      key: 'handleClick',
      value: function handleClick(e) {
        if (e.target === this.div) {
          this.focus();
        }
      }
    }, {
      key: 'handleChange',
      value: function handleChange(e) {
        var onChangeInput = this.props.onChangeInput;
        var onChange = this.props.inputProps.onChange;

        var tag = e.target.value;

        if (onChange) {
          onChange(e);
        }

        if (this.hasControlledInput()) {
          onChangeInput(tag);
        } else {
          this.setState({ tag: tag });
        }
      }
    }, {
      key: 'handleOnFocus',
      value: function handleOnFocus(e) {
        var onFocus = this.props.inputProps.onFocus;


        if (onFocus) {
          onFocus(e);
        }

        this.setState({ isFocused: true });
      }
    }, {
      key: 'handleOnBlur',
      value: function handleOnBlur(e) {
        var onBlur = this.props.inputProps.onBlur;


        this.setState({ isFocused: false });

        if (e == null) {
          return;
        }

        if (onBlur) {
          onBlur(e);
        }

        if (this.props.addOnBlur) {
          var tag = this._makeTag(e.target.value);
          this._addTags([tag]);
        }
      }
    }, {
      key: 'handleRemove',
      value: function handleRemove(tag) {
        this._removeTag(tag);
      }
    }, {
      key: 'inputProps',
      value: function inputProps() {
        var _props$inputProps = this.props.inputProps,
            onChange = _props$inputProps.onChange,
            onFocus = _props$inputProps.onFocus,
            onBlur = _props$inputProps.onBlur,
            otherInputProps = _objectWithoutProperties(_props$inputProps, ['onChange', 'onFocus', 'onBlur']);

        var props = _extends({}, defaultInputProps, otherInputProps);

        if (this.props.disabled) {
          props.disabled = true;
        }

        return props;
      }
    }, {
      key: 'inputValue',
      value: function inputValue(props) {
        return props.currentValue || props.inputValue || '';
      }
    }, {
      key: 'hasControlledInput',
      value: function hasControlledInput() {
        var _props4 = this.props,
            inputValue = _props4.inputValue,
            onChangeInput = _props4.onChangeInput;


        return typeof onChangeInput === 'function' && typeof inputValue === 'string';
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.hasControlledInput()) {
          return;
        }

        this.setState({
          tag: this.inputValue(this.props)
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        /* istanbul ignore next */
        if (this.hasControlledInput()) {
          return;
        }

        if (!this.inputValue(nextProps)) {
          return;
        }

        this.setState({
          tag: this.inputValue(nextProps)
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props5 = this.props,
            value = _props5.value,
            onChange = _props5.onChange,
            tagProps = _props5.tagProps,
            renderLayout = _props5.renderLayout,
            renderTag = _props5.renderTag,
            renderInput = _props5.renderInput,
            addKeys = _props5.addKeys,
            removeKeys = _props5.removeKeys,
            className = _props5.className,
            focusedClassName = _props5.focusedClassName,
            addOnBlur = _props5.addOnBlur,
            addOnPaste = _props5.addOnPaste,
            inputProps = _props5.inputProps,
            pasteSplit = _props5.pasteSplit,
            onlyUnique = _props5.onlyUnique,
            maxTags = _props5.maxTags,
            validationRegex = _props5.validationRegex,
            disabled = _props5.disabled,
            tagDisplayProp = _props5.tagDisplayProp,
            inputValue = _props5.inputValue,
            onChangeInput = _props5.onChangeInput,
            other = _objectWithoutProperties(_props5, ['value', 'onChange', 'tagProps', 'renderLayout', 'renderTag', 'renderInput', 'addKeys', 'removeKeys', 'className', 'focusedClassName', 'addOnBlur', 'addOnPaste', 'inputProps', 'pasteSplit', 'onlyUnique', 'maxTags', 'validationRegex', 'disabled', 'tagDisplayProp', 'inputValue', 'onChangeInput']);

        var isFocused = this.state.isFocused;


        if (isFocused) {
          className += ' ' + focusedClassName;
        }

        var tagComponents = value.map(function (tag, index) {
          return renderTag(_extends({
            key: index,
            tag: tag,
            onRemove: _this4.handleRemove.bind(_this4),
            disabled: disabled,
            getTagDisplayValue: _this4._getTagDisplayValue.bind(_this4)
          }, tagProps));
        });

        var inputComponent = renderInput(_extends({
          ref: function ref(r) {
            _this4.input = r;
          },
          value: this._tag(),
          onPaste: this.handlePaste.bind(this),
          onKeyDown: this.handleKeyDown.bind(this),
          onChange: this.handleChange.bind(this),
          onFocus: this.handleOnFocus.bind(this),
          onBlur: this.handleOnBlur.bind(this),
          addTag: this.addTag.bind(this)
        }, this.inputProps()));

        return _react2.default.createElement(
          'div',
          { ref: function ref(r) {
              _this4.div = r;
            }, onClick: this.handleClick.bind(this), className: className },
          renderLayout(tagComponents, inputComponent)
        );
      }
    }]);

    return TagsInput;
  }(_react2.default.Component);

  TagsInput.defaultProps = {
    className: 'react-tagsinput',
    focusedClassName: 'react-tagsinput--focused',
    addKeys: [9, 13],
    addOnBlur: false,
    addOnPaste: false,
    inputProps: {},
    removeKeys: [8],
    renderInput: defaultRenderInput,
    renderTag: defaultRenderTag,
    renderLayout: defaultRenderLayout,
    pasteSplit: defaultPasteSplit,
    tagProps: { className: 'react-tagsinput-tag', classNameRemove: 'react-tagsinput-remove' },
    onlyUnique: false,
    maxTags: -1,
    validationRegex: /.*/,
    disabled: false,
    tagDisplayProp: null,
    preventSubmit: true
  };
  exports.default = TagsInput;
  module.exports = exports['default'];
});



/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! nouislider - 12.0.0 - 9/14/2018 */
(function(factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === "object") {
        // Node/CommonJS
        module.exports = factory();
    } else {
        // Browser globals
        window.noUiSlider = factory();
    }
})(function() {
    "use strict";

    var VERSION = "12.0.0";

    function isValidFormatter(entry) {
        return typeof entry === "object" && typeof entry.to === "function" && typeof entry.from === "function";
    }

    function removeElement(el) {
        el.parentElement.removeChild(el);
    }

    function isSet(value) {
        return value !== null && value !== undefined;
    }

    // Bindable version
    function preventDefault(e) {
        e.preventDefault();
    }

    // Removes duplicates from an array.
    function unique(array) {
        return array.filter(function(a) {
            return !this[a] ? (this[a] = true) : false;
        }, {});
    }

    // Round a value to the closest 'to'.
    function closest(value, to) {
        return Math.round(value / to) * to;
    }

    // Current position of an element relative to the document.
    function offset(elem, orientation) {
        var rect = elem.getBoundingClientRect();
        var doc = elem.ownerDocument;
        var docElem = doc.documentElement;
        var pageOffset = getPageOffset(doc);

        // getBoundingClientRect contains left scroll in Chrome on Android.
        // I haven't found a feature detection that proves this. Worst case
        // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
        if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) {
            pageOffset.x = 0;
        }

        return orientation
            ? rect.top + pageOffset.y - docElem.clientTop
            : rect.left + pageOffset.x - docElem.clientLeft;
    }

    // Checks whether a value is numerical.
    function isNumeric(a) {
        return typeof a === "number" && !isNaN(a) && isFinite(a);
    }

    // Sets a class and removes it after [duration] ms.
    function addClassFor(element, className, duration) {
        if (duration > 0) {
            addClass(element, className);
            setTimeout(function() {
                removeClass(element, className);
            }, duration);
        }
    }

    // Limits a value to 0 - 100
    function limit(a) {
        return Math.max(Math.min(a, 100), 0);
    }

    // Wraps a variable as an array, if it isn't one yet.
    // Note that an input array is returned by reference!
    function asArray(a) {
        return Array.isArray(a) ? a : [a];
    }

    // Counts decimals
    function countDecimals(numStr) {
        numStr = String(numStr);
        var pieces = numStr.split(".");
        return pieces.length > 1 ? pieces[1].length : 0;
    }

    // http://youmightnotneedjquery.com/#add_class
    function addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += " " + className;
        }
    }

    // http://youmightnotneedjquery.com/#remove_class
    function removeClass(el, className) {
        if (el.classList) {
            el.classList.remove(className);
        } else {
            el.className = el.className.replace(
                new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"),
                " "
            );
        }
    }

    // https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
    function hasClass(el, className) {
        return el.classList
            ? el.classList.contains(className)
            : new RegExp("\\b" + className + "\\b").test(el.className);
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
    function getPageOffset(doc) {
        var supportPageOffset = window.pageXOffset !== undefined;
        var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
        var x = supportPageOffset
            ? window.pageXOffset
            : isCSS1Compat
                ? doc.documentElement.scrollLeft
                : doc.body.scrollLeft;
        var y = supportPageOffset
            ? window.pageYOffset
            : isCSS1Compat
                ? doc.documentElement.scrollTop
                : doc.body.scrollTop;

        return {
            x: x,
            y: y
        };
    }

    // we provide a function to compute constants instead
    // of accessing window.* as soon as the module needs it
    // so that we do not compute anything if not needed
    function getActions() {
        // Determine the events to bind. IE11 implements pointerEvents without
        // a prefix, which breaks compatibility with the IE10 implementation.
        return window.navigator.pointerEnabled
            ? {
                  start: "pointerdown",
                  move: "pointermove",
                  end: "pointerup"
              }
            : window.navigator.msPointerEnabled
                ? {
                      start: "MSPointerDown",
                      move: "MSPointerMove",
                      end: "MSPointerUp"
                  }
                : {
                      start: "mousedown touchstart",
                      move: "mousemove touchmove",
                      end: "mouseup touchend"
                  };
    }

    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
    // Issue #785
    function getSupportsPassive() {
        var supportsPassive = false;

        /* eslint-disable */
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassive = true;
                }
            });

            window.addEventListener("test", null, opts);
        } catch (e) {}
        /* eslint-enable */

        return supportsPassive;
    }

    function getSupportsTouchActionNone() {
        return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }

    // Value calculation

    // Determine the size of a sub-range in relation to a full range.
    function subRangeRatio(pa, pb) {
        return 100 / (pb - pa);
    }

    // (percentage) How many percent is this value of this range?
    function fromPercentage(range, value) {
        return (value * 100) / (range[1] - range[0]);
    }

    // (percentage) Where is this value on this range?
    function toPercentage(range, value) {
        return fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0]);
    }

    // (value) How much is this percentage on this range?
    function isPercentage(range, value) {
        return (value * (range[1] - range[0])) / 100 + range[0];
    }

    // Range conversion

    function getJ(value, arr) {
        var j = 1;

        while (value >= arr[j]) {
            j += 1;
        }

        return j;
    }

    // (percentage) Input a value, find where, on a scale of 0-100, it applies.
    function toStepping(xVal, xPct, value) {
        if (value >= xVal.slice(-1)[0]) {
            return 100;
        }

        var j = getJ(value, xVal);
        var va = xVal[j - 1];
        var vb = xVal[j];
        var pa = xPct[j - 1];
        var pb = xPct[j];

        return pa + toPercentage([va, vb], value) / subRangeRatio(pa, pb);
    }

    // (value) Input a percentage, find where it is on the specified range.
    function fromStepping(xVal, xPct, value) {
        // There is no range group that fits 100
        if (value >= 100) {
            return xVal.slice(-1)[0];
        }

        var j = getJ(value, xPct);
        var va = xVal[j - 1];
        var vb = xVal[j];
        var pa = xPct[j - 1];
        var pb = xPct[j];

        return isPercentage([va, vb], (value - pa) * subRangeRatio(pa, pb));
    }

    // (percentage) Get the step that applies at a certain value.
    function getStep(xPct, xSteps, snap, value) {
        if (value === 100) {
            return value;
        }

        var j = getJ(value, xPct);
        var a = xPct[j - 1];
        var b = xPct[j];

        // If 'snap' is set, steps are used as fixed points on the slider.
        if (snap) {
            // Find the closest position, a or b.
            if (value - a > (b - a) / 2) {
                return b;
            }

            return a;
        }

        if (!xSteps[j - 1]) {
            return value;
        }

        return xPct[j - 1] + closest(value - xPct[j - 1], xSteps[j - 1]);
    }

    // Entry parsing

    function handleEntryPoint(index, value, that) {
        var percentage;

        // Wrap numerical input in an array.
        if (typeof value === "number") {
            value = [value];
        }

        // Reject any invalid input, by testing whether value is an array.
        if (!Array.isArray(value)) {
            throw new Error("noUiSlider (" + VERSION + "): 'range' contains invalid value.");
        }

        // Covert min/max syntax to 0 and 100.
        if (index === "min") {
            percentage = 0;
        } else if (index === "max") {
            percentage = 100;
        } else {
            percentage = parseFloat(index);
        }

        // Check for correct input.
        if (!isNumeric(percentage) || !isNumeric(value[0])) {
            throw new Error("noUiSlider (" + VERSION + "): 'range' value isn't numeric.");
        }

        // Store values.
        that.xPct.push(percentage);
        that.xVal.push(value[0]);

        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value[1])) {
                that.xSteps[0] = value[1];
            }
        } else {
            that.xSteps.push(isNaN(value[1]) ? false : value[1]);
        }

        that.xHighestCompleteStep.push(0);
    }

    function handleStepPoint(i, n, that) {
        // Ignore 'false' stepping.
        if (!n) {
            return true;
        }

        // Factor to range ratio
        that.xSteps[i] =
            fromPercentage([that.xVal[i], that.xVal[i + 1]], n) / subRangeRatio(that.xPct[i], that.xPct[i + 1]);

        var totalSteps = (that.xVal[i + 1] - that.xVal[i]) / that.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = that.xVal[i] + that.xNumSteps[i] * highestStep;

        that.xHighestCompleteStep[i] = step;
    }

    // Interface

    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [singleStep || false];
        this.xNumSteps = [false];
        this.xHighestCompleteStep = [];

        this.snap = snap;

        var index;
        var ordered = []; // [0, 'min'], [1, '50%'], [2, 'max']

        // Map the object keys to an array.
        for (index in entry) {
            if (entry.hasOwnProperty(index)) {
                ordered.push([entry[index], index]);
            }
        }

        // Sort all entries by value (numeric sort).
        if (ordered.length && typeof ordered[0][0] === "object") {
            ordered.sort(function(a, b) {
                return a[0][0] - b[0][0];
            });
        } else {
            ordered.sort(function(a, b) {
                return a[0] - b[0];
            });
        }

        // Convert all entries to subranges.
        for (index = 0; index < ordered.length; index++) {
            handleEntryPoint(ordered[index][1], ordered[index][0], this);
        }

        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);

        // Convert all numeric steps to the percentage of the subrange they represent.
        for (index = 0; index < this.xNumSteps.length; index++) {
            handleStepPoint(index, this.xNumSteps[index], this);
        }
    }

    Spectrum.prototype.getMargin = function(value) {
        var step = this.xNumSteps[0];

        if (step && (value / step) % 1 !== 0) {
            throw new Error("noUiSlider (" + VERSION + "): 'limit', 'margin' and 'padding' must be divisible by step.");
        }

        return this.xPct.length === 2 ? fromPercentage(this.xVal, value) : false;
    };

    Spectrum.prototype.toStepping = function(value) {
        value = toStepping(this.xVal, this.xPct, value);

        return value;
    };

    Spectrum.prototype.fromStepping = function(value) {
        return fromStepping(this.xVal, this.xPct, value);
    };

    Spectrum.prototype.getStep = function(value) {
        value = getStep(this.xPct, this.xSteps, this.snap, value);

        return value;
    };

    Spectrum.prototype.getNearbySteps = function(value) {
        var j = getJ(value, this.xPct);

        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2]
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1]
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j]
            }
        };
    };

    Spectrum.prototype.countStepDecimals = function() {
        var stepDecimals = this.xNumSteps.map(countDecimals);
        return Math.max.apply(null, stepDecimals);
    };

    // Outside testing
    Spectrum.prototype.convert = function(value) {
        return this.getStep(this.toStepping(value));
    };

    /*	Every input option is tested and parsed. This'll prevent
        endless validation in internal methods. These tests are
        structured with an item for every option available. An
        option can be marked as required by setting the 'r' flag.
        The testing function is provided with three arguments:
            - The provided value for the option;
            - A reference to the options object;
            - The name for the option;

        The testing function returns false when an error is detected,
        or true when everything is OK. It can also modify the option
        object, to make sure all values can be correctly looped elsewhere. */

    var defaultFormatter = {
        to: function(value) {
            return value !== undefined && value.toFixed(2);
        },
        from: Number
    };

    function validateFormat(entry) {
        // Any object with a to and from method is supported.
        if (isValidFormatter(entry)) {
            return true;
        }

        throw new Error("noUiSlider (" + VERSION + "): 'format' requires 'to' and 'from' methods.");
    }

    function testStep(parsed, entry) {
        if (!isNumeric(entry)) {
            throw new Error("noUiSlider (" + VERSION + "): 'step' is not numeric.");
        }

        // The step option can still be used to set stepping
        // for linear sliders. Overwritten if set in 'range'.
        parsed.singleStep = entry;
    }

    function testRange(parsed, entry) {
        // Filter incorrect input.
        if (typeof entry !== "object" || Array.isArray(entry)) {
            throw new Error("noUiSlider (" + VERSION + "): 'range' is not an object.");
        }

        // Catch missing start or end.
        if (entry.min === undefined || entry.max === undefined) {
            throw new Error("noUiSlider (" + VERSION + "): Missing 'min' or 'max' in 'range'.");
        }

        // Catch equal start or end.
        if (entry.min === entry.max) {
            throw new Error("noUiSlider (" + VERSION + "): 'range' 'min' and 'max' cannot be equal.");
        }

        parsed.spectrum = new Spectrum(entry, parsed.snap, parsed.singleStep);
    }

    function testStart(parsed, entry) {
        entry = asArray(entry);

        // Validate input. Values aren't tested, as the public .val method
        // will always provide a valid location.
        if (!Array.isArray(entry) || !entry.length) {
            throw new Error("noUiSlider (" + VERSION + "): 'start' option is incorrect.");
        }

        // Store the number of handles.
        parsed.handles = entry.length;

        // When the slider is initialized, the .val method will
        // be called with the start options.
        parsed.start = entry;
    }

    function testSnap(parsed, entry) {
        // Enforce 100% stepping within subranges.
        parsed.snap = entry;

        if (typeof entry !== "boolean") {
            throw new Error("noUiSlider (" + VERSION + "): 'snap' option must be a boolean.");
        }
    }

    function testAnimate(parsed, entry) {
        // Enforce 100% stepping within subranges.
        parsed.animate = entry;

        if (typeof entry !== "boolean") {
            throw new Error("noUiSlider (" + VERSION + "): 'animate' option must be a boolean.");
        }
    }

    function testAnimationDuration(parsed, entry) {
        parsed.animationDuration = entry;

        if (typeof entry !== "number") {
            throw new Error("noUiSlider (" + VERSION + "): 'animationDuration' option must be a number.");
        }
    }

    function testConnect(parsed, entry) {
        var connect = [false];
        var i;

        // Map legacy options
        if (entry === "lower") {
            entry = [true, false];
        } else if (entry === "upper") {
            entry = [false, true];
        }

        // Handle boolean options
        if (entry === true || entry === false) {
            for (i = 1; i < parsed.handles; i++) {
                connect.push(entry);
            }

            connect.push(false);
        }

        // Reject invalid input
        else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) {
            throw new Error("noUiSlider (" + VERSION + "): 'connect' option doesn't match handle count.");
        } else {
            connect = entry;
        }

        parsed.connect = connect;
    }

    function testOrientation(parsed, entry) {
        // Set orientation to an a numerical value for easy
        // array selection.
        switch (entry) {
            case "horizontal":
                parsed.ort = 0;
                break;
            case "vertical":
                parsed.ort = 1;
                break;
            default:
                throw new Error("noUiSlider (" + VERSION + "): 'orientation' option is invalid.");
        }
    }

    function testMargin(parsed, entry) {
        if (!isNumeric(entry)) {
            throw new Error("noUiSlider (" + VERSION + "): 'margin' option must be numeric.");
        }

        // Issue #582
        if (entry === 0) {
            return;
        }

        parsed.margin = parsed.spectrum.getMargin(entry);

        if (!parsed.margin) {
            throw new Error("noUiSlider (" + VERSION + "): 'margin' option is only supported on linear sliders.");
        }
    }

    function testLimit(parsed, entry) {
        if (!isNumeric(entry)) {
            throw new Error("noUiSlider (" + VERSION + "): 'limit' option must be numeric.");
        }

        parsed.limit = parsed.spectrum.getMargin(entry);

        if (!parsed.limit || parsed.handles < 2) {
            throw new Error(
                "noUiSlider (" +
                    VERSION +
                    "): 'limit' option is only supported on linear sliders with 2 or more handles."
            );
        }
    }

    function testPadding(parsed, entry) {
        if (!isNumeric(entry) && !Array.isArray(entry)) {
            throw new Error(
                "noUiSlider (" + VERSION + "): 'padding' option must be numeric or array of exactly 2 numbers."
            );
        }

        if (Array.isArray(entry) && !(entry.length === 2 || isNumeric(entry[0]) || isNumeric(entry[1]))) {
            throw new Error(
                "noUiSlider (" + VERSION + "): 'padding' option must be numeric or array of exactly 2 numbers."
            );
        }

        if (entry === 0) {
            return;
        }

        if (!Array.isArray(entry)) {
            entry = [entry, entry];
        }

        // 'getMargin' returns false for invalid values.
        parsed.padding = [parsed.spectrum.getMargin(entry[0]), parsed.spectrum.getMargin(entry[1])];

        if (parsed.padding[0] === false || parsed.padding[1] === false) {
            throw new Error("noUiSlider (" + VERSION + "): 'padding' option is only supported on linear sliders.");
        }

        if (parsed.padding[0] < 0 || parsed.padding[1] < 0) {
            throw new Error("noUiSlider (" + VERSION + "): 'padding' option must be a positive number(s).");
        }

        if (parsed.padding[0] + parsed.padding[1] >= 100) {
            throw new Error("noUiSlider (" + VERSION + "): 'padding' option must not exceed 100% of the range.");
        }
    }

    function testDirection(parsed, entry) {
        // Set direction as a numerical value for easy parsing.
        // Invert connection for RTL sliders, so that the proper
        // handles get the connect/background classes.
        switch (entry) {
            case "ltr":
                parsed.dir = 0;
                break;
            case "rtl":
                parsed.dir = 1;
                break;
            default:
                throw new Error("noUiSlider (" + VERSION + "): 'direction' option was not recognized.");
        }
    }

    function testBehaviour(parsed, entry) {
        // Make sure the input is a string.
        if (typeof entry !== "string") {
            throw new Error("noUiSlider (" + VERSION + "): 'behaviour' must be a string containing options.");
        }

        // Check if the string contains any keywords.
        // None are required.
        var tap = entry.indexOf("tap") >= 0;
        var drag = entry.indexOf("drag") >= 0;
        var fixed = entry.indexOf("fixed") >= 0;
        var snap = entry.indexOf("snap") >= 0;
        var hover = entry.indexOf("hover") >= 0;

        if (fixed) {
            if (parsed.handles !== 2) {
                throw new Error("noUiSlider (" + VERSION + "): 'fixed' behaviour must be used with 2 handles");
            }

            // Use margin to enforce fixed state
            testMargin(parsed, parsed.start[1] - parsed.start[0]);
        }

        parsed.events = {
            tap: tap || snap,
            drag: drag,
            fixed: fixed,
            snap: snap,
            hover: hover
        };
    }

    function testTooltips(parsed, entry) {
        if (entry === false) {
            return;
        }

        if (entry === true) {
            parsed.tooltips = [];

            for (var i = 0; i < parsed.handles; i++) {
                parsed.tooltips.push(true);
            }
        } else {
            parsed.tooltips = asArray(entry);

            if (parsed.tooltips.length !== parsed.handles) {
                throw new Error("noUiSlider (" + VERSION + "): must pass a formatter for all handles.");
            }

            parsed.tooltips.forEach(function(formatter) {
                if (
                    typeof formatter !== "boolean" &&
                    (typeof formatter !== "object" || typeof formatter.to !== "function")
                ) {
                    throw new Error("noUiSlider (" + VERSION + "): 'tooltips' must be passed a formatter or 'false'.");
                }
            });
        }
    }

    function testAriaFormat(parsed, entry) {
        parsed.ariaFormat = entry;
        validateFormat(entry);
    }

    function testFormat(parsed, entry) {
        parsed.format = entry;
        validateFormat(entry);
    }

    function testKeyboardSupport(parsed, entry) {
        parsed.keyboardSupport = entry;

        if (typeof entry !== "boolean") {
            throw new Error("noUiSlider (" + VERSION + "): 'keyboardSupport' option must be a boolean.");
        }
    }

    function testDocumentElement(parsed, entry) {
        // This is an advanced option. Passed values are used without validation.
        parsed.documentElement = entry;
    }

    function testCssPrefix(parsed, entry) {
        if (typeof entry !== "string" && entry !== false) {
            throw new Error("noUiSlider (" + VERSION + "): 'cssPrefix' must be a string or `false`.");
        }

        parsed.cssPrefix = entry;
    }

    function testCssClasses(parsed, entry) {
        if (typeof entry !== "object") {
            throw new Error("noUiSlider (" + VERSION + "): 'cssClasses' must be an object.");
        }

        if (typeof parsed.cssPrefix === "string") {
            parsed.cssClasses = {};

            for (var key in entry) {
                if (!entry.hasOwnProperty(key)) {
                    continue;
                }

                parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
            }
        } else {
            parsed.cssClasses = entry;
        }
    }

    // Test all developer settings and parse to assumption-safe values.
    function testOptions(options) {
        // To prove a fix for #537, freeze options here.
        // If the object is modified, an error will be thrown.
        // Object.freeze(options);

        var parsed = {
            margin: 0,
            limit: 0,
            padding: 0,
            animate: true,
            animationDuration: 300,
            ariaFormat: defaultFormatter,
            format: defaultFormatter
        };

        // Tests are executed in the order they are presented here.
        var tests = {
            step: { r: false, t: testStep },
            start: { r: true, t: testStart },
            connect: { r: true, t: testConnect },
            direction: { r: true, t: testDirection },
            snap: { r: false, t: testSnap },
            animate: { r: false, t: testAnimate },
            animationDuration: { r: false, t: testAnimationDuration },
            range: { r: true, t: testRange },
            orientation: { r: false, t: testOrientation },
            margin: { r: false, t: testMargin },
            limit: { r: false, t: testLimit },
            padding: { r: false, t: testPadding },
            behaviour: { r: true, t: testBehaviour },
            ariaFormat: { r: false, t: testAriaFormat },
            format: { r: false, t: testFormat },
            tooltips: { r: false, t: testTooltips },
            keyboardSupport: { r: true, t: testKeyboardSupport },
            documentElement: { r: false, t: testDocumentElement },
            cssPrefix: { r: true, t: testCssPrefix },
            cssClasses: { r: true, t: testCssClasses }
        };

        var defaults = {
            connect: false,
            direction: "ltr",
            behaviour: "tap",
            orientation: "horizontal",
            keyboardSupport: true,
            cssPrefix: "noUi-",
            cssClasses: {
                target: "target",
                base: "base",
                origin: "origin",
                handle: "handle",
                handleLower: "handle-lower",
                handleUpper: "handle-upper",
                horizontal: "horizontal",
                vertical: "vertical",
                background: "background",
                connect: "connect",
                connects: "connects",
                ltr: "ltr",
                rtl: "rtl",
                draggable: "draggable",
                drag: "state-drag",
                tap: "state-tap",
                active: "active",
                tooltip: "tooltip",
                pips: "pips",
                pipsHorizontal: "pips-horizontal",
                pipsVertical: "pips-vertical",
                marker: "marker",
                markerHorizontal: "marker-horizontal",
                markerVertical: "marker-vertical",
                markerNormal: "marker-normal",
                markerLarge: "marker-large",
                markerSub: "marker-sub",
                value: "value",
                valueHorizontal: "value-horizontal",
                valueVertical: "value-vertical",
                valueNormal: "value-normal",
                valueLarge: "value-large",
                valueSub: "value-sub"
            }
        };

        // AriaFormat defaults to regular format, if any.
        if (options.format && !options.ariaFormat) {
            options.ariaFormat = options.format;
        }

        // Run all options through a testing mechanism to ensure correct
        // input. It should be noted that options might get modified to
        // be handled properly. E.g. wrapping integers in arrays.
        Object.keys(tests).forEach(function(name) {
            // If the option isn't set, but it is required, throw an error.
            if (!isSet(options[name]) && defaults[name] === undefined) {
                if (tests[name].r) {
                    throw new Error("noUiSlider (" + VERSION + "): '" + name + "' is required.");
                }

                return true;
            }

            tests[name].t(parsed, !isSet(options[name]) ? defaults[name] : options[name]);
        });

        // Forward pips options
        parsed.pips = options.pips;

        // All recent browsers accept unprefixed transform.
        // We need -ms- for IE9 and -webkit- for older Android;
        // Assume use of -webkit- if unprefixed and -ms- are not supported.
        // https://caniuse.com/#feat=transforms2d
        var d = document.createElement("div");
        var msPrefix = d.style.msTransform !== undefined;
        var noPrefix = d.style.transform !== undefined;

        parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";

        // Pips don't move, so we can place them using left/top.
        var styles = [["left", "top"], ["right", "bottom"]];

        parsed.style = styles[parsed.dir][parsed.ort];

        return parsed;
    }

    function scope(target, options, originalOptions) {
        var actions = getActions();
        var supportsTouchActionNone = getSupportsTouchActionNone();
        var supportsPassive = supportsTouchActionNone && getSupportsPassive();

        // All variables local to 'scope' are prefixed with 'scope_'
        var scope_Target = target;
        var scope_Locations = [];
        var scope_Base;
        var scope_Handles;
        var scope_HandleNumbers = [];
        var scope_ActiveHandlesCount = 0;
        var scope_Connects;
        var scope_Spectrum = options.spectrum;
        var scope_Values = [];
        var scope_Events = {};
        var scope_Self;
        var scope_Pips;
        var scope_Document = target.ownerDocument;
        var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
        var scope_Body = scope_Document.body;

        // Pips constants
        var PIPS_NONE = -1;
        var PIPS_NO_VALUE = 0;
        var PIPS_LARGE_VALUE = 1;
        var PIPS_SMALL_VALUE = 2;

        // For horizontal sliders in standard ltr documents,
        // make .noUi-origin overflow to the left so the document doesn't scroll.
        var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;

        // Creates a node, adds it to target, returns the new node.
        function addNodeTo(addTarget, className) {
            var div = scope_Document.createElement("div");

            if (className) {
                addClass(div, className);
            }

            addTarget.appendChild(div);

            return div;
        }

        // Append a origin to the base
        function addOrigin(base, handleNumber) {
            var origin = addNodeTo(base, options.cssClasses.origin);
            var handle = addNodeTo(origin, options.cssClasses.handle);

            handle.setAttribute("data-handle", handleNumber);

            if (options.keyboardSupport) {
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
                // 0 = focusable and reachable
                handle.setAttribute("tabindex", "0");
            }

            handle.setAttribute("role", "slider");
            handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");

            if (handleNumber === 0) {
                addClass(handle, options.cssClasses.handleLower);
            } else if (handleNumber === options.handles - 1) {
                addClass(handle, options.cssClasses.handleUpper);
            }

            return origin;
        }

        // Insert nodes for connect elements
        function addConnect(base, add) {
            if (!add) {
                return false;
            }

            return addNodeTo(base, options.cssClasses.connect);
        }

        // Add handles to the slider base.
        function addElements(connectOptions, base) {
            var connectBase = addNodeTo(base, options.cssClasses.connects);

            scope_Handles = [];
            scope_Connects = [];

            scope_Connects.push(addConnect(connectBase, connectOptions[0]));

            // [::::O====O====O====]
            // connectOptions = [0, 1, 1, 1]

            for (var i = 0; i < options.handles; i++) {
                // Keep a list of all added handles.
                scope_Handles.push(addOrigin(base, i));
                scope_HandleNumbers[i] = i;
                scope_Connects.push(addConnect(connectBase, connectOptions[i + 1]));
            }
        }

        // Initialize a single slider.
        function addSlider(addTarget) {
            // Apply classes and data to the target.
            addClass(addTarget, options.cssClasses.target);

            if (options.dir === 0) {
                addClass(addTarget, options.cssClasses.ltr);
            } else {
                addClass(addTarget, options.cssClasses.rtl);
            }

            if (options.ort === 0) {
                addClass(addTarget, options.cssClasses.horizontal);
            } else {
                addClass(addTarget, options.cssClasses.vertical);
            }

            return addNodeTo(addTarget, options.cssClasses.base);
        }

        function addTooltip(handle, handleNumber) {
            if (!options.tooltips[handleNumber]) {
                return false;
            }

            return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
        }

        // The tooltips option is a shorthand for using the 'update' event.
        function tooltips() {
            // Tooltips are added with options.tooltips in original order.
            var tips = scope_Handles.map(addTooltip);

            bindEvent("update", function(values, handleNumber, unencoded) {
                if (!tips[handleNumber]) {
                    return;
                }

                var formattedValue = values[handleNumber];

                if (options.tooltips[handleNumber] !== true) {
                    formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
                }

                tips[handleNumber].innerHTML = formattedValue;
            });
        }

        function aria() {
            bindEvent("update", function(values, handleNumber, unencoded, tap, positions) {
                // Update Aria Values for all handles, as a change in one changes min and max values for the next.
                scope_HandleNumbers.forEach(function(index) {
                    var handle = scope_Handles[index];

                    var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                    var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);

                    var now = positions[index];

                    // Formatted value for display
                    var text = options.ariaFormat.to(unencoded[index]);

                    // Map to slider range values
                    min = scope_Spectrum.fromStepping(min).toFixed(1);
                    max = scope_Spectrum.fromStepping(max).toFixed(1);
                    now = scope_Spectrum.fromStepping(now).toFixed(1);

                    handle.children[0].setAttribute("aria-valuemin", min);
                    handle.children[0].setAttribute("aria-valuemax", max);
                    handle.children[0].setAttribute("aria-valuenow", now);
                    handle.children[0].setAttribute("aria-valuetext", text);
                });
            });
        }

        function getGroup(mode, values, stepped) {
            // Use the range.
            if (mode === "range" || mode === "steps") {
                return scope_Spectrum.xVal;
            }

            if (mode === "count") {
                if (values < 2) {
                    throw new Error("noUiSlider (" + VERSION + "): 'values' (>= 2) required for mode 'count'.");
                }

                // Divide 0 - 100 in 'count' parts.
                var interval = values - 1;
                var spread = 100 / interval;

                values = [];

                // List these parts and have them handled as 'positions'.
                while (interval--) {
                    values[interval] = interval * spread;
                }

                values.push(100);

                mode = "positions";
            }

            if (mode === "positions") {
                // Map all percentages to on-range values.
                return values.map(function(value) {
                    return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
                });
            }

            if (mode === "values") {
                // If the value must be stepped, it needs to be converted to a percentage first.
                if (stepped) {
                    return values.map(function(value) {
                        // Convert to percentage, apply step, return to value.
                        return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
                    });
                }

                // Otherwise, we can simply use the values.
                return values;
            }
        }

        function generateSpread(density, mode, group) {
            function safeIncrement(value, increment) {
                // Avoid floating point variance by dropping the smallest decimal places.
                return (value + increment).toFixed(7) / 1;
            }

            var indexes = {};
            var firstInRange = scope_Spectrum.xVal[0];
            var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
            var ignoreFirst = false;
            var ignoreLast = false;
            var prevPct = 0;

            // Create a copy of the group, sort it and filter away all duplicates.
            group = unique(
                group.slice().sort(function(a, b) {
                    return a - b;
                })
            );

            // Make sure the range starts with the first element.
            if (group[0] !== firstInRange) {
                group.unshift(firstInRange);
                ignoreFirst = true;
            }

            // Likewise for the last one.
            if (group[group.length - 1] !== lastInRange) {
                group.push(lastInRange);
                ignoreLast = true;
            }

            group.forEach(function(current, index) {
                // Get the current step and the lower + upper positions.
                var step;
                var i;
                var q;
                var low = current;
                var high = group[index + 1];
                var newPct;
                var pctDifference;
                var pctPos;
                var type;
                var steps;
                var realSteps;
                var stepSize;
                var isSteps = mode === "steps";

                // When using 'steps' mode, use the provided steps.
                // Otherwise, we'll step on to the next subrange.
                if (isSteps) {
                    step = scope_Spectrum.xNumSteps[index];
                }

                // Default to a 'full' step.
                if (!step) {
                    step = high - low;
                }

                // Low can be 0, so test for false. If high is undefined,
                // we are at the last subrange. Index 0 is already handled.
                if (low === false || high === undefined) {
                    return;
                }

                // Make sure step isn't 0, which would cause an infinite loop (#654)
                step = Math.max(step, 0.0000001);

                // Find all steps in the subrange.
                for (i = low; i <= high; i = safeIncrement(i, step)) {
                    // Get the percentage value for the current step,
                    // calculate the size for the subrange.
                    newPct = scope_Spectrum.toStepping(i);
                    pctDifference = newPct - prevPct;

                    steps = pctDifference / density;
                    realSteps = Math.round(steps);

                    // This ratio represents the amount of percentage-space a point indicates.
                    // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                    // Round the percentage offset to an even number, then divide by two
                    // to spread the offset on both sides of the range.
                    stepSize = pctDifference / realSteps;

                    // Divide all points evenly, adding the correct number to this subrange.
                    // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                    for (q = 1; q <= realSteps; q += 1) {
                        // The ratio between the rounded value and the actual size might be ~1% off.
                        // Correct the percentage offset by the number of points
                        // per subrange. density = 1 will result in 100 points on the
                        // full range, 2 for 50, 4 for 25, etc.
                        pctPos = prevPct + q * stepSize;
                        indexes[pctPos.toFixed(5)] = [scope_Spectrum.fromStepping(pctPos), 0];
                    }

                    // Determine the point type.
                    type = group.indexOf(i) > -1 ? PIPS_LARGE_VALUE : isSteps ? PIPS_SMALL_VALUE : PIPS_NO_VALUE;

                    // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                    if (!index && ignoreFirst) {
                        type = 0;
                    }

                    if (!(i === high && ignoreLast)) {
                        // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                        indexes[newPct.toFixed(5)] = [i, type];
                    }

                    // Update the percentage count.
                    prevPct = newPct;
                }
            });

            return indexes;
        }

        function addMarking(spread, filterFunc, formatter) {
            var element = scope_Document.createElement("div");

            var valueSizeClasses = [];
            valueSizeClasses[PIPS_NO_VALUE] = options.cssClasses.valueNormal;
            valueSizeClasses[PIPS_LARGE_VALUE] = options.cssClasses.valueLarge;
            valueSizeClasses[PIPS_SMALL_VALUE] = options.cssClasses.valueSub;

            var markerSizeClasses = [];
            markerSizeClasses[PIPS_NO_VALUE] = options.cssClasses.markerNormal;
            markerSizeClasses[PIPS_LARGE_VALUE] = options.cssClasses.markerLarge;
            markerSizeClasses[PIPS_SMALL_VALUE] = options.cssClasses.markerSub;

            var valueOrientationClasses = [options.cssClasses.valueHorizontal, options.cssClasses.valueVertical];
            var markerOrientationClasses = [options.cssClasses.markerHorizontal, options.cssClasses.markerVertical];

            addClass(element, options.cssClasses.pips);
            addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);

            function getClasses(type, source) {
                var a = source === options.cssClasses.value;
                var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
                var sizeClasses = a ? valueSizeClasses : markerSizeClasses;

                return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
            }

            function addSpread(offset, value, type) {
                // Apply the filter function, if it is set.
                type = filterFunc ? filterFunc(value, type) : type;

                if (type === PIPS_NONE) {
                    return;
                }

                // Add a marker for every point
                var node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.marker);
                node.style[options.style] = offset + "%";

                // Values are only appended for points marked '1' or '2'.
                if (type > PIPS_NO_VALUE) {
                    node = addNodeTo(element, false);
                    node.className = getClasses(type, options.cssClasses.value);
                    node.setAttribute("data-value", value);
                    node.style[options.style] = offset + "%";
                    node.innerHTML = formatter.to(value);
                }
            }

            // Append all points.
            Object.keys(spread).forEach(function(offset) {
                addSpread(offset, spread[offset][0], spread[offset][1]);
            });

            return element;
        }

        function removePips() {
            if (scope_Pips) {
                removeElement(scope_Pips);
                scope_Pips = null;
            }
        }

        function pips(grid) {
            // Fix #669
            removePips();

            var mode = grid.mode;
            var density = grid.density || 1;
            var filter = grid.filter || false;
            var values = grid.values || false;
            var stepped = grid.stepped || false;
            var group = getGroup(mode, values, stepped);
            var spread = generateSpread(density, mode, group);
            var format = grid.format || {
                to: Math.round
            };

            scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));

            return scope_Pips;
        }

        // Shorthand for base dimensions.
        function baseSize() {
            var rect = scope_Base.getBoundingClientRect();
            var alt = "offset" + ["Width", "Height"][options.ort];
            return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
        }

        // Handler for attaching events trough a proxy.
        function attachEvent(events, element, callback, data) {
            // This function can be used to 'filter' events to the slider.
            // element is a node, not a nodeList

            var method = function(e) {
                e = fixEvent(e, data.pageOffset, data.target || element);

                // fixEvent returns false if this event has a different target
                // when handling (multi-) touch events;
                if (!e) {
                    return false;
                }

                // doNotReject is passed by all end events to make sure released touches
                // are not rejected, leaving the slider "stuck" to the cursor;
                if (scope_Target.hasAttribute("disabled") && !data.doNotReject) {
                    return false;
                }

                // Stop if an active 'tap' transition is taking place.
                if (hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) {
                    return false;
                }

                // Ignore right or middle clicks on start #454
                if (events === actions.start && e.buttons !== undefined && e.buttons > 1) {
                    return false;
                }

                // Ignore right or middle clicks on start #454
                if (data.hover && e.buttons) {
                    return false;
                }

                // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
                // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
                // touch-action: manipulation, but that allows panning, which breaks
                // sliders after zooming/on non-responsive pages.
                // See: https://bugs.webkit.org/show_bug.cgi?id=133112
                if (!supportsPassive) {
                    e.preventDefault();
                }

                e.calcPoint = e.points[options.ort];

                // Call the event handler with the event [ and additional data ].
                callback(e, data);
            };

            var methods = [];

            // Bind a closure on the target for every event type.
            events.split(" ").forEach(function(eventName) {
                element.addEventListener(eventName, method, supportsPassive ? { passive: true } : false);
                methods.push([eventName, method]);
            });

            return methods;
        }

        // Provide a clean event with standardized offset values.
        function fixEvent(e, pageOffset, eventTarget) {
            // Filter the event to register the type, which can be
            // touch, mouse or pointer. Offset changes need to be
            // made on an event specific basis.
            var touch = e.type.indexOf("touch") === 0;
            var mouse = e.type.indexOf("mouse") === 0;
            var pointer = e.type.indexOf("pointer") === 0;

            var x;
            var y;

            // IE10 implemented pointer events with a prefix;
            if (e.type.indexOf("MSPointer") === 0) {
                pointer = true;
            }

            // In the event that multitouch is activated, the only thing one handle should be concerned
            // about is the touches that originated on top of it.
            if (touch) {
                // Returns true if a touch originated on the target.
                var isTouchOnTarget = function(checkTouch) {
                    return checkTouch.target === eventTarget || eventTarget.contains(checkTouch.target);
                };

                // In the case of touchstart events, we need to make sure there is still no more than one
                // touch on the target so we look amongst all touches.
                if (e.type === "touchstart") {
                    var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);

                    // Do not support more than one touch per handle.
                    if (targetTouches.length > 1) {
                        return false;
                    }

                    x = targetTouches[0].pageX;
                    y = targetTouches[0].pageY;
                } else {
                    // In the other cases, find on changedTouches is enough.
                    var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);

                    // Cancel if the target touch has not moved.
                    if (!targetTouch) {
                        return false;
                    }

                    x = targetTouch.pageX;
                    y = targetTouch.pageY;
                }
            }

            pageOffset = pageOffset || getPageOffset(scope_Document);

            if (mouse || pointer) {
                x = e.clientX + pageOffset.x;
                y = e.clientY + pageOffset.y;
            }

            e.pageOffset = pageOffset;
            e.points = [x, y];
            e.cursor = mouse || pointer; // Fix #435

            return e;
        }

        // Translate a coordinate in the document to a percentage on the slider
        function calcPointToPercentage(calcPoint) {
            var location = calcPoint - offset(scope_Base, options.ort);
            var proposal = (location * 100) / baseSize();

            // Clamp proposal between 0% and 100%
            // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
            // are used (e.g. contained handles feature)
            proposal = limit(proposal);

            return options.dir ? 100 - proposal : proposal;
        }

        // Find handle closest to a certain percentage on the slider
        function getClosestHandle(proposal) {
            var closest = 100;
            var handleNumber = false;

            scope_Handles.forEach(function(handle, index) {
                // Disabled handles are ignored
                if (handle.hasAttribute("disabled")) {
                    return;
                }

                var pos = Math.abs(scope_Locations[index] - proposal);

                if (pos < closest || (pos === 100 && closest === 100)) {
                    handleNumber = index;
                    closest = pos;
                }
            });

            return handleNumber;
        }

        // Fire 'end' when a mouse or pen leaves the document.
        function documentLeave(event, data) {
            if (event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null) {
                eventEnd(event, data);
            }
        }

        // Handle movement on document for handle and range drag.
        function eventMove(event, data) {
            // Fix #498
            // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
            // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
            // IE9 has .buttons and .which zero on mousemove.
            // Firefox breaks the spec MDN defines.
            if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) {
                return eventEnd(event, data);
            }

            // Check if we are moving up or down
            var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);

            // Convert the movement into a percentage of the slider width/height
            var proposal = (movement * 100) / data.baseSize;

            moveHandles(movement > 0, proposal, data.locations, data.handleNumbers);
        }

        // Unbind move events on document, call callbacks.
        function eventEnd(event, data) {
            // The handle is no longer active, so remove the class.
            if (data.handle) {
                removeClass(data.handle, options.cssClasses.active);
                scope_ActiveHandlesCount -= 1;
            }

            // Unbind the move and end events, which are added on 'start'.
            data.listeners.forEach(function(c) {
                scope_DocumentElement.removeEventListener(c[0], c[1]);
            });

            if (scope_ActiveHandlesCount === 0) {
                // Remove dragging class.
                removeClass(scope_Target, options.cssClasses.drag);
                setZindex();

                // Remove cursor styles and text-selection events bound to the body.
                if (event.cursor) {
                    scope_Body.style.cursor = "";
                    scope_Body.removeEventListener("selectstart", preventDefault);
                }
            }

            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("change", handleNumber);
                fireEvent("set", handleNumber);
                fireEvent("end", handleNumber);
            });
        }

        // Bind move events on document.
        function eventStart(event, data) {
            var handle;
            if (data.handleNumbers.length === 1) {
                var handleOrigin = scope_Handles[data.handleNumbers[0]];

                // Ignore 'disabled' handles
                if (handleOrigin.hasAttribute("disabled")) {
                    return false;
                }

                handle = handleOrigin.children[0];
                scope_ActiveHandlesCount += 1;

                // Mark the handle as 'active' so it can be styled.
                addClass(handle, options.cssClasses.active);
            }

            // A drag should never propagate up to the 'tap' event.
            event.stopPropagation();

            // Record the event listeners.
            var listeners = [];

            // Attach the move and end events.
            var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
                // The event target has changed so we need to propagate the original one so that we keep
                // relying on it to extract target touches.
                target: event.target,
                handle: handle,
                listeners: listeners,
                startCalcPoint: event.calcPoint,
                baseSize: baseSize(),
                pageOffset: event.pageOffset,
                handleNumbers: data.handleNumbers,
                buttonsProperty: event.buttons,
                locations: scope_Locations.slice()
            });

            var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
                target: event.target,
                handle: handle,
                listeners: listeners,
                doNotReject: true,
                handleNumbers: data.handleNumbers
            });

            var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
                target: event.target,
                handle: handle,
                listeners: listeners,
                doNotReject: true,
                handleNumbers: data.handleNumbers
            });

            // We want to make sure we pushed the listeners in the listener list rather than creating
            // a new one as it has already been passed to the event handlers.
            listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));

            // Text selection isn't an issue on touch devices,
            // so adding cursor styles can be skipped.
            if (event.cursor) {
                // Prevent the 'I' cursor and extend the range-drag cursor.
                scope_Body.style.cursor = getComputedStyle(event.target).cursor;

                // Mark the target with a dragging state.
                if (scope_Handles.length > 1) {
                    addClass(scope_Target, options.cssClasses.drag);
                }

                // Prevent text selection when dragging the handles.
                // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
                // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
                // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
                // The 'cursor' flag is false.
                // See: http://caniuse.com/#search=selectstart
                scope_Body.addEventListener("selectstart", preventDefault, false);
            }

            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("start", handleNumber);
            });
        }

        // Move closest handle to tapped location.
        function eventTap(event) {
            // The tap event shouldn't propagate up
            event.stopPropagation();

            var proposal = calcPointToPercentage(event.calcPoint);
            var handleNumber = getClosestHandle(proposal);

            // Tackle the case that all handles are 'disabled'.
            if (handleNumber === false) {
                return false;
            }

            // Flag the slider as it is now in a transitional state.
            // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
            if (!options.events.snap) {
                addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
            }

            setHandle(handleNumber, proposal, true, true);

            setZindex();

            fireEvent("slide", handleNumber, true);
            fireEvent("update", handleNumber, true);
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);

            if (options.events.snap) {
                eventStart(event, { handleNumbers: [handleNumber] });
            }
        }

        // Fires a 'hover' event for a hovered mouse/pen position.
        function eventHover(event) {
            var proposal = calcPointToPercentage(event.calcPoint);

            var to = scope_Spectrum.getStep(proposal);
            var value = scope_Spectrum.fromStepping(to);

            Object.keys(scope_Events).forEach(function(targetEvent) {
                if ("hover" === targetEvent.split(".")[0]) {
                    scope_Events[targetEvent].forEach(function(callback) {
                        callback.call(scope_Self, value);
                    });
                }
            });
        }

        // Attach events to several slider parts.
        function bindSliderEvents(behaviour) {
            // Attach the standard drag event to the handles.
            if (!behaviour.fixed) {
                scope_Handles.forEach(function(handle, index) {
                    // These events are only bound to the visual handle
                    // element, not the 'real' origin element.
                    attachEvent(actions.start, handle.children[0], eventStart, {
                        handleNumbers: [index]
                    });
                });
            }

            // Attach the tap event to the slider base.
            if (behaviour.tap) {
                attachEvent(actions.start, scope_Base, eventTap, {});
            }

            // Fire hover events
            if (behaviour.hover) {
                attachEvent(actions.move, scope_Base, eventHover, {
                    hover: true
                });
            }

            // Make the range draggable.
            if (behaviour.drag) {
                scope_Connects.forEach(function(connect, index) {
                    if (connect === false || index === 0 || index === scope_Connects.length - 1) {
                        return;
                    }

                    var handleBefore = scope_Handles[index - 1];
                    var handleAfter = scope_Handles[index];
                    var eventHolders = [connect];

                    addClass(connect, options.cssClasses.draggable);

                    // When the range is fixed, the entire range can
                    // be dragged by the handles. The handle in the first
                    // origin will propagate the start event upward,
                    // but it needs to be bound manually on the other.
                    if (behaviour.fixed) {
                        eventHolders.push(handleBefore.children[0]);
                        eventHolders.push(handleAfter.children[0]);
                    }

                    eventHolders.forEach(function(eventHolder) {
                        attachEvent(actions.start, eventHolder, eventStart, {
                            handles: [handleBefore, handleAfter],
                            handleNumbers: [index - 1, index]
                        });
                    });
                });
            }
        }

        // Attach an event to this slider, possibly including a namespace
        function bindEvent(namespacedEvent, callback) {
            scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
            scope_Events[namespacedEvent].push(callback);

            // If the event bound is 'update,' fire it immediately for all handles.
            if (namespacedEvent.split(".")[0] === "update") {
                scope_Handles.forEach(function(a, index) {
                    fireEvent("update", index);
                });
            }
        }

        // Undo attachment of event
        function removeEvent(namespacedEvent) {
            var event = namespacedEvent && namespacedEvent.split(".")[0];
            var namespace = event && namespacedEvent.substring(event.length);

            Object.keys(scope_Events).forEach(function(bind) {
                var tEvent = bind.split(".")[0];
                var tNamespace = bind.substring(tEvent.length);

                if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) {
                    delete scope_Events[bind];
                }
            });
        }

        // External event handling
        function fireEvent(eventName, handleNumber, tap) {
            Object.keys(scope_Events).forEach(function(targetEvent) {
                var eventType = targetEvent.split(".")[0];

                if (eventName === eventType) {
                    scope_Events[targetEvent].forEach(function(callback) {
                        callback.call(
                            // Use the slider public API as the scope ('this')
                            scope_Self,
                            // Return values as array, so arg_1[arg_2] is always valid.
                            scope_Values.map(options.format.to),
                            // Handle index, 0 or 1
                            handleNumber,
                            // Un-formatted slider values
                            scope_Values.slice(),
                            // Event is fired by tap, true or false
                            tap || false,
                            // Left offset of the handle, in relation to the slider
                            scope_Locations.slice()
                        );
                    });
                }
            });
        }

        function toPct(pct) {
            return pct + "%";
        }

        // Split out the handle positioning logic so the Move event can use it, too
        function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue) {
            // For sliders with multiple handles, limit movement to the other handle.
            // Apply the margin option by adding it to the handle positions.
            if (scope_Handles.length > 1) {
                if (lookBackward && handleNumber > 0) {
                    to = Math.max(to, reference[handleNumber - 1] + options.margin);
                }

                if (lookForward && handleNumber < scope_Handles.length - 1) {
                    to = Math.min(to, reference[handleNumber + 1] - options.margin);
                }
            }

            // The limit option has the opposite effect, limiting handles to a
            // maximum distance from another. Limit must be > 0, as otherwise
            // handles would be unmovable.
            if (scope_Handles.length > 1 && options.limit) {
                if (lookBackward && handleNumber > 0) {
                    to = Math.min(to, reference[handleNumber - 1] + options.limit);
                }

                if (lookForward && handleNumber < scope_Handles.length - 1) {
                    to = Math.max(to, reference[handleNumber + 1] - options.limit);
                }
            }

            // The padding option keeps the handles a certain distance from the
            // edges of the slider. Padding must be > 0.
            if (options.padding) {
                if (handleNumber === 0) {
                    to = Math.max(to, options.padding[0]);
                }

                if (handleNumber === scope_Handles.length - 1) {
                    to = Math.min(to, 100 - options.padding[1]);
                }
            }

            to = scope_Spectrum.getStep(to);

            // Limit percentage to the 0 - 100 range
            to = limit(to);

            // Return false if handle can't move
            if (to === reference[handleNumber] && !getValue) {
                return false;
            }

            return to;
        }

        // Uses slider orientation to create CSS rules. a = base value;
        function inRuleOrder(v, a) {
            var o = options.ort;
            return (o ? a : v) + ", " + (o ? v : a);
        }

        // Moves handle(s) by a percentage
        // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
        function moveHandles(upward, proposal, locations, handleNumbers) {
            var proposals = locations.slice();

            var b = [!upward, upward];
            var f = [upward, !upward];

            // Copy handleNumbers so we don't change the dataset
            handleNumbers = handleNumbers.slice();

            // Check to see which handle is 'leading'.
            // If that one can't move the second can't either.
            if (upward) {
                handleNumbers.reverse();
            }

            // Step 1: get the maximum percentage that any of the handles can move
            if (handleNumbers.length > 1) {
                handleNumbers.forEach(function(handleNumber, o) {
                    var to = checkHandlePosition(
                        proposals,
                        handleNumber,
                        proposals[handleNumber] + proposal,
                        b[o],
                        f[o],
                        false
                    );

                    // Stop if one of the handles can't move.
                    if (to === false) {
                        proposal = 0;
                    } else {
                        proposal = to - proposals[handleNumber];
                        proposals[handleNumber] = to;
                    }
                });
            }

            // If using one handle, check backward AND forward
            else {
                b = f = [true];
            }

            var state = false;

            // Step 2: Try to set the handles with the found percentage
            handleNumbers.forEach(function(handleNumber, o) {
                state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o]) || state;
            });

            // Step 3: If a handle moved, fire events
            if (state) {
                handleNumbers.forEach(function(handleNumber) {
                    fireEvent("update", handleNumber);
                    fireEvent("slide", handleNumber);
                });
            }
        }

        // Takes a base value and an offset. This offset is used for the connect bar size.
        // In the initial design for this feature, the origin element was 1% wide.
        // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
        // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
        function transformDirection(a, b) {
            return options.dir ? 100 - a - b : a;
        }

        // Updates scope_Locations and scope_Values, updates visual state
        function updateHandlePosition(handleNumber, to) {
            // Update locations.
            scope_Locations[handleNumber] = to;

            // Convert the value to the slider stepping/range.
            scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);

            var rule = "translate(" + inRuleOrder(toPct(transformDirection(to, 0) - scope_DirOffset), "0") + ")";
            scope_Handles[handleNumber].style[options.transformRule] = rule;

            updateConnect(handleNumber);
            updateConnect(handleNumber + 1);
        }

        // Handles before the slider middle are stacked later = higher,
        // Handles after the middle later is lower
        // [[7] [8] .......... | .......... [5] [4]
        function setZindex() {
            scope_HandleNumbers.forEach(function(handleNumber) {
                var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
                var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
                scope_Handles[handleNumber].style.zIndex = zIndex;
            });
        }

        // Test suggested values and apply margin, step.
        function setHandle(handleNumber, to, lookBackward, lookForward) {
            to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false);

            if (to === false) {
                return false;
            }

            updateHandlePosition(handleNumber, to);

            return true;
        }

        // Updates style attribute for connect nodes
        function updateConnect(index) {
            // Skip connects set to false
            if (!scope_Connects[index]) {
                return;
            }

            var l = 0;
            var h = 100;

            if (index !== 0) {
                l = scope_Locations[index - 1];
            }

            if (index !== scope_Connects.length - 1) {
                h = scope_Locations[index];
            }

            // We use two rules:
            // 'translate' to change the left/top offset;
            // 'scale' to change the width of the element;
            // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
            var connectWidth = h - l;
            var translateRule = "translate(" + inRuleOrder(toPct(transformDirection(l, connectWidth)), "0") + ")";
            var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";

            scope_Connects[index].style[options.transformRule] = translateRule + " " + scaleRule;
        }

        // Parses value passed to .set method. Returns current value if not parse-able.
        function resolveToValue(to, handleNumber) {
            // Setting with null indicates an 'ignore'.
            // Inputting 'false' is invalid.
            if (to === null || to === false || to === undefined) {
                return scope_Locations[handleNumber];
            }

            // If a formatted number was passed, attempt to decode it.
            if (typeof to === "number") {
                to = String(to);
            }

            to = options.format.from(to);
            to = scope_Spectrum.toStepping(to);

            // If parsing the number failed, use the current value.
            if (to === false || isNaN(to)) {
                return scope_Locations[handleNumber];
            }

            return to;
        }

        // Set the slider value.
        function valueSet(input, fireSetEvent) {
            var values = asArray(input);
            var isInit = scope_Locations[0] === undefined;

            // Event fires by default
            fireSetEvent = fireSetEvent === undefined ? true : !!fireSetEvent;

            // Animation is optional.
            // Make sure the initial values were set before using animated placement.
            if (options.animate && !isInit) {
                addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
            }

            // First pass, without lookAhead but with lookBackward. Values are set from left to right.
            scope_HandleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false);
            });

            // Second pass. Now that all base values are set, apply constraints
            scope_HandleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true);
            });

            setZindex();

            scope_HandleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);

                // Fire the event only for handles that received a new value, as per #579
                if (values[handleNumber] !== null && fireSetEvent) {
                    fireEvent("set", handleNumber);
                }
            });
        }

        // Reset slider to initial values
        function valueReset(fireSetEvent) {
            valueSet(options.start, fireSetEvent);
        }

        // Get the slider value.
        function valueGet() {
            var values = scope_Values.map(options.format.to);

            // If only one handle is used, return a single value.
            if (values.length === 1) {
                return values[0];
            }

            return values;
        }

        // Removes classes from the root and empties it.
        function destroy() {
            for (var key in options.cssClasses) {
                if (!options.cssClasses.hasOwnProperty(key)) {
                    continue;
                }
                removeClass(scope_Target, options.cssClasses[key]);
            }

            while (scope_Target.firstChild) {
                scope_Target.removeChild(scope_Target.firstChild);
            }

            delete scope_Target.noUiSlider;
        }

        // Get the current step size for the slider.
        function getCurrentStep() {
            // Check all locations, map them to their stepping point.
            // Get the step point, then find it in the input list.
            return scope_Locations.map(function(location, index) {
                var nearbySteps = scope_Spectrum.getNearbySteps(location);
                var value = scope_Values[index];
                var increment = nearbySteps.thisStep.step;
                var decrement = null;

                // If the next value in this step moves into the next step,
                // the increment is the start of the next step - the current value
                if (increment !== false) {
                    if (value + increment > nearbySteps.stepAfter.startValue) {
                        increment = nearbySteps.stepAfter.startValue - value;
                    }
                }

                // If the value is beyond the starting point
                if (value > nearbySteps.thisStep.startValue) {
                    decrement = nearbySteps.thisStep.step;
                } else if (nearbySteps.stepBefore.step === false) {
                    decrement = false;
                }

                // If a handle is at the start of a step, it always steps back into the previous step first
                else {
                    decrement = value - nearbySteps.stepBefore.highestStep;
                }

                // Now, if at the slider edges, there is not in/decrement
                if (location === 100) {
                    increment = null;
                } else if (location === 0) {
                    decrement = null;
                }

                // As per #391, the comparison for the decrement step can have some rounding issues.
                var stepDecimals = scope_Spectrum.countStepDecimals();

                // Round per #391
                if (increment !== null && increment !== false) {
                    increment = Number(increment.toFixed(stepDecimals));
                }

                if (decrement !== null && decrement !== false) {
                    decrement = Number(decrement.toFixed(stepDecimals));
                }

                return [decrement, increment];
            });
        }

        // Updateable: margin, limit, padding, step, range, animate, snap
        function updateOptions(optionsToUpdate, fireSetEvent) {
            // Spectrum is created using the range, snap, direction and step options.
            // 'snap' and 'step' can be updated.
            // If 'snap' and 'step' are not passed, they should remain unchanged.
            var v = valueGet();

            var updateAble = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format"];

            // Only change options that we're actually passed to update.
            updateAble.forEach(function(name) {
                if (optionsToUpdate[name] !== undefined) {
                    originalOptions[name] = optionsToUpdate[name];
                }
            });

            var newOptions = testOptions(originalOptions);

            // Load new options into the slider state
            updateAble.forEach(function(name) {
                if (optionsToUpdate[name] !== undefined) {
                    options[name] = newOptions[name];
                }
            });

            scope_Spectrum = newOptions.spectrum;

            // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
            options.margin = newOptions.margin;
            options.limit = newOptions.limit;
            options.padding = newOptions.padding;

            // Update pips, removes existing.
            if (options.pips) {
                pips(options.pips);
            }

            // Invalidate the current positioning so valueSet forces an update.
            scope_Locations = [];
            valueSet(optionsToUpdate.start || v, fireSetEvent);
        }

        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);

        // Attach user events.
        bindSliderEvents(options.events);

        // Use the public value method to set the start values.
        valueSet(options.start);

        // noinspection JSUnusedGlobalSymbols
        scope_Self = {
            destroy: destroy,
            steps: getCurrentStep,
            on: bindEvent,
            off: removeEvent,
            get: valueGet,
            set: valueSet,
            reset: valueReset,
            // Exposed for unit testing, don't use this in your application.
            __moveHandles: function(a, b, c) {
                moveHandles(a, b, scope_Locations, c);
            },
            options: originalOptions, // Issue #600, #678
            updateOptions: updateOptions,
            target: scope_Target, // Issue #597
            removePips: removePips,
            pips: pips // Issue #594
        };

        if (options.pips) {
            pips(options.pips);
        }

        if (options.tooltips) {
            tooltips();
        }

        aria();

        return scope_Self;
    }

    // Run the standard initializer
    function initialize(target, originalOptions) {
        if (!target || !target.nodeName) {
            throw new Error("noUiSlider (" + VERSION + "): create requires a single element, got: " + target);
        }

        // Throw an error if the slider was already initialized.
        if (target.noUiSlider) {
            throw new Error("noUiSlider (" + VERSION + "): Slider was already initialized.");
        }

        // Test the options and create the slider environment;
        var options = testOptions(originalOptions, target);
        var api = scope(target, options, originalOptions);

        target.noUiSlider = api;

        return api;
    }

    // Use an object instead of a function for future expandability;
    return {
        // Exposed for unit testing, don't use this in your application.
        __spectrum: Spectrum,
        version: VERSION,
        create: initialize
    };
});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Switch.default;
  }
});

var _Switch = _interopRequireDefault(__webpack_require__(861));

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var _SwitchBase = _interopRequireDefault(__webpack_require__(253));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },

    /* Styles used to create the `icon` passed to the internal `SwitchBase` component `icon` prop. */
    icon: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied the icon element component if `checked={true}`. */
    iconChecked: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      zIndex: 1,
      padding: 0,
      height: 48,
      width: 48,
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },

    /* Styles applied to the internal `SwitchBase` component's `checked` class. */
    checked: {
      transform: 'translateX(14px)',
      '& + $bar': {
        opacity: 0.5
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '& + $bar': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '& + $bar': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the internal SwitchBase component's disabled class. */
    disabled: {
      '& + $bar': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      },
      '& $icon': {
        boxShadow: theme.shadows[1]
      },
      '&$switchBase': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
        '& + $bar': {
          backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
        }
      }
    },

    /* Styles applied to the bar element. */
    bar: {
      borderRadius: 14 / 2,
      display: 'block',
      position: 'absolute',
      width: 34,
      height: 14,
      top: '50%',
      left: '50%',
      marginTop: -7,
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};

exports.styles = styles;

function Switch(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.root, className)
  }, _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    icon: _react.default.createElement("span", {
      className: classes.icon
    }),
    classes: {
      root: (0, _classnames.default)(classes.switchBase, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    checkedIcon: _react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.iconChecked)
    })
  }, other)), _react.default.createElement("span", {
    className: classes.bar
  }));
}

Switch.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Switch.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitch'
})(Switch);

exports.default = _default;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _SelectInput = _interopRequireDefault(__webpack_require__(863));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _mergeClasses = _interopRequireDefault(__webpack_require__(322));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(402));

var _Input = _interopRequireDefault(__webpack_require__(223));

var _InputBase = __webpack_require__(95);

var _NativeSelect = __webpack_require__(867);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(403));

// @inheritedComponent Input
// To replace with InputBase in v4.0.0
var styles = _NativeSelect.styles;
exports.styles = styles;

function Select(props, context) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['variant']
  });
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: (0, _extends2.default)({
      children: children,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, native ? {} : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps
    }, inputProps, {
      classes: inputProps ? (0, _mergeClasses.default)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {})
  }, other));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Menu`](/api/menu) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes.default.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes.default.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes.default.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null),
  multiple: false,
  native: false
};
Select.contextTypes = {
  muiFormControl: _propTypes.default.object
};
Select.muiName = 'Select';

var _default = (0, _withStyles.default)(_NativeSelect.styles, {
  name: 'MuiSelect'
})(Select);

exports.default = _default;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(336));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _keycode = _interopRequireDefault(__webpack_require__(124));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _Menu = _interopRequireDefault(__webpack_require__(864));

var _utils = __webpack_require__(221);

var _reactHelpers = __webpack_require__(66);

/**
 * @ignore - internal component.
 */
var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ignoreNextBlur = false;
    _this.displayRef = null;
    _this.isOpenControlled = _this.props.open !== undefined;
    _this.state = {
      menuMinWidth: null,
      open: false
    };

    _this.update = function (_ref) {
      var event = _ref.event,
          open = _ref.open;

      if (_this.isOpenControlled) {
        if (open) {
          _this.props.onOpen(event);
        } else {
          _this.props.onClose(event);
        }

        return;
      }

      _this.setState({
        // Perfom the layout computation outside of the render method.
        menuMinWidth: _this.props.autoWidth ? null : _this.displayRef.clientWidth,
        open: open
      });
    };

    _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;

      _this.update({
        open: true,
        event: event
      });
    };

    _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    };

    _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          var value;

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
            var itemIndex = value.indexOf(child.props.value);

            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = {
            value: value,
            name: name
          };
          onChange(event, child);
        }
      };
    };

    _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        var _this$props2 = _this.props,
            value = _this$props2.value,
            name = _this$props2.name;
        event.persist();
        event.target = {
          value: value,
          name: name
        };

        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].indexOf((0, _keycode.default)(event)) !== -1) {
        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.

        _this.ignoreNextBlur = true;

        _this.update({
          open: true,
          event: event
        });
      }
    };

    _this.handleDisplayRef = function (ref) {
      _this.displayRef = ref;
    };

    _this.handleInputRef = function (ref) {
      var inputRef = _this.props.inputRef;

      if (!inputRef) {
        return;
      }

      var nodeProxy = {
        node: ref,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      };
      (0, _reactHelpers.setRef)(inputRef, nodeProxy);
    };

    return _this;
  }

  (0, _createClass2.default)(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpenControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayRef.focus(); // Rerender with the resolve `displayRef` reference.

        this.forceUpdate();
      }

      if (this.props.autoFocus) {
        this.displayRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props3 = this.props,
          autoWidth = _this$props3.autoWidth,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          displayEmpty = _this$props3.displayEmpty,
          IconComponent = _this$props3.IconComponent,
          inputRef = _this$props3.inputRef,
          _this$props3$MenuProp = _this$props3.MenuProps,
          MenuProps = _this$props3$MenuProp === void 0 ? {} : _this$props3$MenuProp,
          multiple = _this$props3.multiple,
          name = _this$props3.name,
          onBlur = _this$props3.onBlur,
          onChange = _this$props3.onChange,
          onClose = _this$props3.onClose,
          onFocus = _this$props3.onFocus,
          onOpen = _this$props3.onOpen,
          openProp = _this$props3.open,
          readOnly = _this$props3.readOnly,
          renderValue = _this$props3.renderValue,
          required = _this$props3.required,
          SelectDisplayProps = _this$props3.SelectDisplayProps,
          tabIndexProp = _this$props3.tabIndex,
          _this$props3$type = _this$props3.type,
          type = _this$props3$type === void 0 ? 'hidden' : _this$props3$type,
          value = _this$props3.value,
          variant = _this$props3.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
      var open = this.isOpenControlled && this.displayRef ? openProp : this.state.open;
      delete other['aria-invalid'];
      var display;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false; // No need to display any value if the field is empty.

      if ((0, _utils.isFilled)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var selected;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;

          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;

          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined,
          // The value is most likely not a valid HTML attribute.
          'data-value': child.props.value // Instead, we provide it as a data attribute.

        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      } // Avoid performing a layout computation in the render method.


      var menuMinWidth = this.state.menuMinWidth;

      if (!autoWidth && this.isOpenControlled && this.displayRef) {
        menuMinWidth = this.displayRef.clientWidth;
      }

      var tabIndex;

      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.select, classes.selectMenu, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), _classNames), className),
        ref: this.handleDisplayRef,
        "aria-pressed": open ? 'true' : 'false',
        tabIndex: tabIndex,
        role: "button",
        "aria-owns": open ? "menu-".concat(name || '') : null,
        "aria-haspopup": "true",
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onClick: disabled || readOnly ? null : this.handleClick,
        onFocus: onFocus
      }, SelectDisplayProps), display || _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      })), _react.default.createElement("input", (0, _extends2.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: this.handleInputRef,
        type: type
      }, other)), _react.default.createElement(IconComponent, {
        className: classes.icon
      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
        id: "menu-".concat(name || ''),
        anchorEl: this.displayRef,
        open: open,
        onClose: this.handleClose
      }, MenuProps, {
        MenuListProps: (0, _extends2.default)({
          role: 'listbox'
        }, MenuProps.MenuListProps),
        PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
          style: (0, _extends2.default)({
            minWidth: menuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
      }), items));
    }
  }]);
  return SelectInput;
}(_react.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * @ignore
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Menu`](/api/menu) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   */
  open: _propTypes.default.bool,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Render the selected value.
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * @ignore
   */
  required: _propTypes.default.bool,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]).isRequired,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
var _default = SelectInput;
exports.default = _default;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(157));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Popover = _interopRequireDefault(__webpack_require__(865));

var _MenuList = _interopRequireDefault(__webpack_require__(247));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.menuListRef = null;

    _this.getContentAnchorEl = function () {
      if (!_this.menuListRef || !_this.menuListRef.selectedItemRef) {
        return _reactDom.default.findDOMNode(_this.menuListRef).firstChild;
      }

      return _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef);
    };

    _this.focus = function () {
      if (_this.menuListRef && _this.menuListRef.selectedItemRef) {
        _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    };

    _this.handleEnter = function (element) {
      var _this$props = _this.props,
          disableAutoFocusItem = _this$props.disableAutoFocusItem,
          theme = _this$props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef); // Focus so the scroll computation of the Popover works as expected.


      if (disableAutoFocusItem !== true) {
        _this.focus();
      } // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    };

    _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open && this.props.disableAutoFocusItem !== true) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          disableAutoFocusItem = _this$props2.disableAutoFocusItem,
          MenuListProps = _this$props2.MenuListProps,
          onEnter = _this$props2.onEnter,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          PopoverClasses = _this$props2.PopoverClasses,
          theme = _this$props2.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "disableAutoFocusItem", "MenuListProps", "onEnter", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEnter: this.handleEnter,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          classes: (0, _extends2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: function ref(_ref) {
          _this2.menuListRef = _ref;
        }
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected / first menu item will not be auto focused.
   */
  disableAutoFocusItem: _propTypes.default.bool,

  /**
   * Properties applied to the [`MenuList`](/api/menu-list) element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the [`Popover`](/api/popover) element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Menu.defaultProps = {
  disableAutoFocusItem: false,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(866));

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(21));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _debounce = _interopRequireDefault(__webpack_require__(90));

var _reactEventListener = _interopRequireDefault(__webpack_require__(65));

var _ownerDocument = _interopRequireDefault(__webpack_require__(54));

var _ownerWindow = _interopRequireDefault(__webpack_require__(158));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _Modal = _interopRequireDefault(__webpack_require__(217));

var _Grow = _interopRequireDefault(__webpack_require__(170));

var _Paper = _interopRequireDefault(__webpack_require__(64));

// @inheritedComponent Modal
// < 1kb payload overhead when lodash/debounce is > 3kb.
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Popover)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.paperRef = null;
    _this.handleGetOffsetTop = getOffsetTop;
    _this.handleGetOffsetLeft = getOffsetLeft;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.setPositioningStyles(_this.paperRef);
    }, 166);

    _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    };

    _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);

        if (positioning.top !== null) {
          element.style.top = positioning.top;
        }

        if (positioning.left !== null) {
          element.style.left = positioning.left;
        }

        element.style.transformOrigin = positioning.transformOrigin;
      }
    };

    _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.offsetWidth,
        height: element.offsetHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    };

    _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    };

    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          anchorOrigin = _this$props2.anchorOrigin,
          anchorReference = _this$props2.anchorReference,
          anchorPosition = _this$props2.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(this.paperRef).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _this$props3 = this.props,
          getContentAnchorEl = _this$props3.getContentAnchorEl,
          anchorReference = _this$props3.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && element.contains(contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          anchorEl = _this$props4.anchorEl,
          anchorOrigin = _this$props4.anchorOrigin,
          anchorPosition = _this$props4.anchorPosition,
          anchorReference = _this$props4.anchorReference,
          children = _this$props4.children,
          classes = _this$props4.classes,
          containerProp = _this$props4.container,
          elevation = _this$props4.elevation,
          getContentAnchorEl = _this$props4.getContentAnchorEl,
          marginThreshold = _this$props4.marginThreshold,
          ModalClasses = _this$props4.ModalClasses,
          onEnter = _this$props4.onEnter,
          onEntered = _this$props4.onEntered,
          onEntering = _this$props4.onEntering,
          onExit = _this$props4.onExit,
          onExited = _this$props4.onExited,
          onExiting = _this$props4.onExiting,
          open = _this$props4.open,
          PaperProps = _this$props4.PaperProps,
          role = _this$props4.role,
          transformOrigin = _this$props4.transformOrigin,
          TransitionComponent = _this$props4.TransitionComponent,
          transitionDurationProp = _this$props4.transitionDuration,
          TransitionProps = _this$props4.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "ModalClasses", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      var transitionDuration = transitionDurationProp;

      if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        transitionDuration = undefined;
      } // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container


      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        classes: ModalClasses,
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        onEnter: this.handleEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        timeout: transitionDuration
      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation,
        ref: function ref(_ref) {
          _this2.paperRef = _reactDom.default.findDOMNode(_ref);
        }
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    left: _propTypes.default.number.isRequired,
    top: _propTypes.default.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * `classes` property applied to the [`Modal`](/api/modal) element.
   */
  ModalClasses: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(403));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _InputBase = __webpack_require__(95);

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(402));

var _Input = _interopRequireDefault(__webpack_require__(223));

// @inheritedComponent Input
var styles = function styles(theme) {
  return {
    /* Styles applied to the `Input` component `root` class. */
    root: {
      position: 'relative',
      width: '100%'
    },

    /* Styles applied to the `Input` component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: 32,
      borderRadius: 0,
      // Reset
      width: 'calc(100% - 32px)',
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the `Input` component if `variant="filled"`. */
    filled: {
      width: 'calc(100% - 44px)'
    },

    /* Styles applied to the `Input` component if `variant="outlined"`. */
    outlined: {
      width: 'calc(100% - 46px)',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the `Input` component `selectMenu` class. */
    selectMenu: {
      width: 'auto',
      // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `Input` component `disabled` class. */
    disabled: {},

    /* Styles applied to the `Input` component `icon` class. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.

    }
  };
};
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */


exports.styles = styles;

function NativeSelect(props, context) {
  var children = props.children,
      classes = props.classes,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
  var fcs = (0, _InputBase.formControlState)({
    props: props,
    context: context,
    states: ['variant']
  });
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput.default,
    inputProps: (0, _extends2.default)({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

NativeSelect.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : {};
NativeSelect.defaultProps = {
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null)
};
NativeSelect.contextTypes = {
  muiFormControl: _propTypes.default.object
};
NativeSelect.muiName = 'Select';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect);

exports.default = _default;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
})), 'Today');

exports.default = _default;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
})), 'LibraryBooks');

exports.default = _default;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
})), 'AvTimer');

exports.default = _default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});

var _Divider = _interopRequireDefault(__webpack_require__(872));

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(75);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    }
  };
};

exports.styles = styles;

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "inset", "light"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.absolute, absolute), (0, _defineProperty2.default)(_classNames, classes.inset, inset), (0, _defineProperty2.default)(_classNames, classes.light, light), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Divider.propTypes =  false ? {
  absolute: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the divider will be indented.
   */
  inset: _propTypes.default.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes.default.bool
} : {};
Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  inset: false,
  light: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDivider'
})(Divider);

exports.default = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _LinearProgress = _interopRequireDefault(__webpack_require__(874));

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _colorManipulator = __webpack_require__(75);

var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },

    /* Styles applied to the root & bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    // eslint-disable-next-line max-len

    /* Styles applied to the root & bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the layered bar1 & bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      willChange: 'transform',
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },

    /* Styles applied to the bar2 element if `variant="determinate"`. */
    bar2Determinate: {},

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className,
    role: "progressbar"
  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
    className: dashedClass
  }) : null, _react.default.createElement("div", {
    className: bar1ClassName,
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : _react.default.createElement("div", {
    className: bar2ClassName,
    style: inlineStyles.bar2
  }));
}

LinearProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};
LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

exports.default = _default;

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // CustomLinearProgress component styles
// #############################
var customLinearProgressStyle={root:{height:"4px",marginBottom:"20px",overflow:"hidden"},bar:{height:"4px"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},gray:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]},primaryBackground:{background:"rgba(156, 39, 176, 0.2)"},warningBackground:{background:"rgba(255, 152, 0, 0.2)"},dangerBackground:{background:"rgba(244, 67, 54, 0.2)"},successBackground:{background:"rgba(76, 175, 80, 0.2)"},infoBackground:{background:"rgba(0, 188, 212, 0.2)"},roseBackground:{background:"rgba(233, 30, 99, 0.2)"},grayBackground:{background:"rgba(221, 221, 221, 0.2)"}};/* harmony default export */ __webpack_exports__["a"] = (customLinearProgressStyle);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_image_placeholder_jpg__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_img_image_placeholder_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assets_img_image_placeholder_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_placeholder_jpg__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_assets_img_placeholder_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_assets_img_placeholder_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// used for making the prop types of this component
// core components
var ImageUpload=function(_React$Component){_inherits(ImageUpload,_React$Component);function ImageUpload(props){_classCallCheck(this,ImageUpload);var _this=_possibleConstructorReturn(this,(ImageUpload.__proto__||Object.getPrototypeOf(ImageUpload)).call(this,props));_this.state={file:null,imagePreviewUrl:_this.props.avatar?__WEBPACK_IMPORTED_MODULE_4_assets_img_placeholder_jpg___default.a:__WEBPACK_IMPORTED_MODULE_3_assets_img_image_placeholder_jpg___default.a};_this.handleImageChange=_this.handleImageChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleClick=_this.handleClick.bind(_this);_this.handleRemove=_this.handleRemove.bind(_this);return _this;}_createClass(ImageUpload,[{key:"handleImageChange",value:function handleImageChange(e){var _this2=this;e.preventDefault();var reader=new FileReader();var file=e.target.files[0];reader.onloadend=function(){_this2.setState({file:file,imagePreviewUrl:reader.result});};reader.readAsDataURL(file);}},{key:"handleSubmit",value:function handleSubmit(e){e.preventDefault();// this.state.file is the file/image uploaded
// in this function you can save the image (this.state.file) on form submit
// you have to call it yourself
}},{key:"handleClick",value:function handleClick(){this.refs.fileInput.click();}},{key:"handleRemove",value:function handleRemove(){this.setState({file:null,imagePreviewUrl:this.props.avatar?__WEBPACK_IMPORTED_MODULE_4_assets_img_placeholder_jpg___default.a:__WEBPACK_IMPORTED_MODULE_3_assets_img_image_placeholder_jpg___default.a});this.refs.fileInput.value=null;}},{key:"render",value:function render(){var _this3=this;var _props=this.props,avatar=_props.avatar,addButtonProps=_props.addButtonProps,changeButtonProps=_props.changeButtonProps,removeButtonProps=_props.removeButtonProps;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fileinput text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",onChange:this.handleImageChange,ref:"fileInput"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"thumbnail"+(avatar?" img-circle":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.imagePreviewUrl,alt:"..."})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.file===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomButtons_Button_jsx__["a" /* default */],Object.assign({},addButtonProps,{onClick:function onClick(){return _this3.handleClick();}}),avatar?"Add Photo":"Select image"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomButtons_Button_jsx__["a" /* default */],Object.assign({},changeButtonProps,{onClick:function onClick(){return _this3.handleClick();}}),"Change"),avatar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomButtons_Button_jsx__["a" /* default */],Object.assign({},removeButtonProps,{onClick:function onClick(){return _this3.handleRemove();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-times"})," Remove"))));}}]);return ImageUpload;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ImageUpload.propTypes={avatar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,addButtonProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,changeButtonProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,removeButtonProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ImageUpload);

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/image_placeholder.ebe9884b.jpg";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/placeholder.1eb7fff2.jpg";

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
// ##############################
// // // ExtendedForms view styles
// #############################
var extendedFormsStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */],{cardTitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),label:{cursor:"pointer",paddingLeft:"0",color:"rgba(0, 0, 0, 0.26)",fontSize:"14px",lineHeight:"1.428571429",fontWeight:"400",display:"inline-flex"},mrAuto:{marginRight:"auto"},mlAuto:{marginLeft:"auto"}});/* harmony default export */ __webpack_exports__["a"] = (extendedFormsStyle);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_MailOutline__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_MailOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_MailOutline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Contacts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_CardText_jsx__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_jss_material_dashboard_pro_react_views_validationFormsStyle_jsx__ = __webpack_require__(881);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// material ui icons
// core components
// style for this view
var ValidationForms=function(_React$Component){_inherits(ValidationForms,_React$Component);function ValidationForms(props){_classCallCheck(this,ValidationForms);var _this=_possibleConstructorReturn(this,(ValidationForms.__proto__||Object.getPrototypeOf(ValidationForms)).call(this,props));_this.state={// register form
registerEmail:"",registerEmailState:"",registerPassword:"",registerPasswordState:"",registerConfirmPassword:"",registerConfirmPasswordState:"",registerCheckbox:false,registerCheckboxState:"",// login form
loginEmail:"",loginEmailState:"",loginPassword:"",loginPasswordState:"",// type validation
required:"",requiredState:"",typeEmail:"",typeEmailState:"",number:"",numberState:"",url:"",urlState:"",equalTo:"",whichEqualTo:"",equalToState:"",// range validation
minLength:"",minLengthState:"",maxLength:"",maxLengthState:"",range:"",rangeState:"",minValue:"",minValueState:"",maxValue:"",maxValueState:""};_this.registerClick=_this.registerClick.bind(_this);_this.loginClick=_this.loginClick.bind(_this);_this.typeClick=_this.typeClick.bind(_this);_this.rangeClick=_this.rangeClick.bind(_this);return _this;}// function that returns true if value is email, false otherwise
_createClass(ValidationForms,[{key:"verifyEmail",value:function verifyEmail(value){var emailRex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;if(emailRex.test(value)){return true;}return false;}// function that verifies if a string has a given length or not
},{key:"verifyLength",value:function verifyLength(value,length){if(value.length>=length){return true;}return false;}// function that verifies if two strings are equal
},{key:"compare",value:function compare(string1,string2){if(string1===string2){return true;}return false;}// function that verifies if value contains only numbers
},{key:"verifyNumber",value:function verifyNumber(value){var numberRex=new RegExp("^[0-9]+$");if(numberRex.test(value)){return true;}return false;}// verifies if value is a valid URL
},{key:"verifyUrl",value:function verifyUrl(value){try{new URL(value);return true;}catch(_){return false;}}},{key:"change",value:function change(event,stateName,type,stateNameEqualTo,maxValue){switch(type){case"email":if(this.verifyEmail(event.target.value)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"password":if(this.verifyLength(event.target.value,1)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"equalTo":if(this.compare(event.target.value,this.state[stateNameEqualTo])){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"checkbox":if(event.target.checked){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"number":if(this.verifyNumber(event.target.value)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"length":if(this.verifyLength(event.target.value,stateNameEqualTo)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"max-length":if(!this.verifyLength(event.target.value,stateNameEqualTo+1)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"url":if(this.verifyUrl(event.target.value)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"min-value":if(this.verifyNumber(event.target.value)&&event.target.value>=stateNameEqualTo){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"max-value":if(this.verifyNumber(event.target.value)&&event.target.value<=stateNameEqualTo){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"range":if(this.verifyNumber(event.target.value)&&event.target.value>=stateNameEqualTo&&event.target.value<=maxValue){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;default:break;}switch(type){case"checkbox":this.setState(_defineProperty({},stateName,event.target.checked));break;default:this.setState(_defineProperty({},stateName,event.target.value));break;}}},{key:"registerClick",value:function registerClick(){if(this.state.registerEmailState===""){this.setState({registerEmailState:"error"});}if(this.state.registerPasswordState===""){this.setState({registerPasswordState:"error"});}if(this.state.registerConfirmPasswordState===""){this.setState({registerConfirmPasswordState:"error"});}if(this.state.registerCheckboxState===""){this.setState({registerCheckboxState:"error"});}}},{key:"loginClick",value:function loginClick(){if(this.state.loginEmailState===""){this.setState({loginEmailState:"error"});}if(this.state.loginPasswordState===""){this.setState({loginPasswordState:"error"});}}},{key:"typeClick",value:function typeClick(){if(this.state.requiredState===""){this.setState({requiredState:"error"});}if(this.state.typeEmailState===""){this.setState({typeEmailState:"error"});}if(this.state.numberState===""){this.setState({numberState:"error"});}if(this.state.urlState===""){this.setState({urlState:"error"});}if(this.state.equalToState===""){this.setState({equalToState:"error"});}}},{key:"rangeClick",value:function rangeClick(){if(this.state.minLengthState===""){this.setState({minLengthState:"error"});}if(this.state.maxLengthState===""){this.setState({maxLengthState:"error"});}if(this.state.rangeState===""){this.setState({rangeState:"error"});}if(this.state.minValueState===""){this.setState({minValueState:"error"});}if(this.state.maxValueState===""){this.setState({maxValueState:"error"});}}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_MailOutline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Register Forms")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.registerEmailState==="success",error:this.state.registerEmailState==="error",labelText:"Email Address *",id:"registeremail",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"registerEmail","email");},type:"email"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.registerPasswordState==="success",error:this.state.registerPasswordState==="error",labelText:"Password *",id:"registerpassword",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"registerPassword","password");},type:"password"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.registerConfirmPasswordState==="success",error:this.state.registerConfirmPasswordState==="error",labelText:"Confirm Password *",id:"registerconfirmpassword",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"registerConfirmPassword","equalTo","registerPassword");},type:"password"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.formCategory},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"*")," Required fields"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(event){return _this2.change(event,"registerCheckbox","checkbox");},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),classes:{label:classes.label+(this.state.registerCheckboxState==="error"?" "+classes.labelError:"")},label:"Subscribe to newsletter"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.registerClick,className:classes.registerButton},"Register"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Contacts___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Login Form")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.loginEmailState==="success",error:this.state.loginEmailState==="error",labelText:"Email Address *",id:"loginemail",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"loginEmail","email");},type:"email"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.loginPasswordState==="success",error:this.state.loginPasswordState==="error",labelText:"Password *",id:"loginpassword",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"loginPassword","password");},type:"password"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.formCategory},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"*")," Required fields"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.loginClick},"Login")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardText_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Type Validation"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Required Text")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.requiredState==="success",error:this.state.requiredState==="error",id:"required",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"required","length",0);},type:"text",endAdornment:this.state.requiredState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"required")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Email")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.typeEmailState==="success",error:this.state.typeEmailState==="error",id:"typeemail",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"typeEmail","email");},type:"email",endAdornment:this.state.typeEmailState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"email")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Number")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.numberState==="success",error:this.state.numberState==="error",id:"number",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"number","number");},type:"number",endAdornment:this.state.numberState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"number")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Url")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.urlState==="success",error:this.state.urlState==="error",id:"url",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"url","url");},type:"text",endAdornment:this.state.urlState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"url")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Equal to")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.equalToState==="success",error:this.state.equalToState==="error",id:"equalto",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"whichEqualTo");},type:"text",endAdornment:this.state.equalToState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.equalToState==="success",error:this.state.equalToState==="error",id:"whichequalto",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"equalTo","equalTo","whichEqualTo");},type:"text",endAdornment:this.state.equalToState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"equalTo")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardFooter_jsx__["a" /* default */],{className:classes.justifyContentCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.typeClick},"Validate Inputs")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardText_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Range Validation"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Min Length")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.minLengthState==="success",error:this.state.minLengthState==="error",id:"minlength",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"minLength","length",5);},type:"text",endAdornment:this.state.minLengthState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"minLength=\"5\""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Max Length")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.maxLengthState==="success",error:this.state.maxLengthState==="error",id:"maxlength",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"maxLength","max-length",5);},type:"text",endAdornment:this.state.maxLengthState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"maxLength=\"5\""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Range")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.rangeState==="success",error:this.state.rangeState==="error",id:"range",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"range","range",6,10);},type:"text",endAdornment:this.state.rangeState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"range=\"[6,10]\""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Min Value")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.minValueState==="success",error:this.state.minValueState==="error",id:"minvalue",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"minValue","min-value",6);},type:"text",endAdornment:this.state.minValueState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"min=\"6\""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelHorizontal},"Max Value")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.maxValueState==="success",error:this.state.maxValueState==="error",id:"maxvalue",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"maxValue","max-value",6);},type:"text",endAdornment:this.state.maxValueState==="error"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Close___default.a,{className:classes.danger})):undefined}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormLabel___default.a,{className:classes.labelLeftHorizontal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("code",null,"max=\"6\"")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardFooter_jsx__["a" /* default */],{className:classes.justifyContentCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.rangeClick},"Validate Inputs")))));}}]);return ValidationForms;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_20_assets_jss_material_dashboard_pro_react_views_validationFormsStyle_jsx__["a" /* default */])(ValidationForms));

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
// ##############################
// // // ValidationForms view styles
// #############################
var validationFormsStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],{cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{color:"#FFFFFF"}),cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),formCategory:{marginBottom:"0",color:"#999999",fontSize:"14px",padding:"10px 0 10px"},center:{textAlign:"center"},justifyContentCenter:{justifyContent:"center"},registerButton:{float:"right"},danger:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]+"!important"}});/* harmony default export */ __webpack_exports__["a"] = (validationFormsStyle);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Wizard_Wizard_jsx__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardSteps_Step1_jsx__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WizardSteps_Step2_jsx__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WizardSteps_Step3_jsx__ = __webpack_require__(890);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// core components
var WizardView=function(_React$Component){_inherits(WizardView,_React$Component);function WizardView(){_classCallCheck(this,WizardView);return _possibleConstructorReturn(this,(WizardView.__proto__||Object.getPrototypeOf(WizardView)).apply(this,arguments));}_createClass(WizardView,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Wizard_Wizard_jsx__["a" /* default */],{validate:true,steps:[{stepName:"About",stepComponent:__WEBPACK_IMPORTED_MODULE_4__WizardSteps_Step1_jsx__["a" /* default */],stepId:"about"},{stepName:"Account",stepComponent:__WEBPACK_IMPORTED_MODULE_5__WizardSteps_Step2_jsx__["a" /* default */],stepId:"account"},{stepName:"Address",stepComponent:__WEBPACK_IMPORTED_MODULE_6__WizardSteps_Step3_jsx__["a" /* default */],stepId:"address"}],title:"Build Your Profile",subtitle:"This information will let us know more about you."})));}}]);return WizardView;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WizardView);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_components_wizardStyle_jsx__ = __webpack_require__(884);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var Wizard=function(_React$Component){_inherits(Wizard,_React$Component);function Wizard(props){_classCallCheck(this,Wizard);var _this=_possibleConstructorReturn(this,(Wizard.__proto__||Object.getPrototypeOf(Wizard)).call(this,props));var width;if(_this.props.steps.length===1){width="100%";}else{if(window.innerWidth<600){if(_this.props.steps.length!==3){width="50%";}else{width=100/3+"%";}}else{if(_this.props.steps.length===2){width="50%";}else{width=100/3+"%";}}}_this.state={currentStep:0,color:_this.props.color,nextButton:_this.props.steps.length>1?true:false,previousButton:false,finishButton:_this.props.steps.length===1?true:false,width:width,movingTabStyle:{transition:"transform 0s"},allStates:{}};_this.navigationStepChange=_this.navigationStepChange.bind(_this);_this.refreshAnimation=_this.refreshAnimation.bind(_this);_this.previousButtonClick=_this.previousButtonClick.bind(_this);_this.previousButtonClick=_this.previousButtonClick.bind(_this);_this.finishButtonClick=_this.finishButtonClick.bind(_this);_this.updateWidth=_this.updateWidth.bind(_this);return _this;}_createClass(Wizard,[{key:"componentDidMount",value:function componentDidMount(){this.refreshAnimation(0);window.addEventListener("resize",this.updateWidth);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("resize",this.updateWidth);}},{key:"updateWidth",value:function updateWidth(){this.refreshAnimation(this.state.currentStep);}},{key:"navigationStepChange",value:function navigationStepChange(key){if(this.props.steps){var validationState=true;if(key>this.state.currentStep){for(var i=this.state.currentStep;i<key;i++){if(this[this.props.steps[i].stepId].sendState!==undefined){this.setState({allStates:[].concat(_toConsumableArray(this.state.allStates),[_defineProperty({},this.props.steps[i].stepId,this[this.props.steps[i].stepId].sendState())])});}if(this[this.props.steps[i].stepId].isValidated!==undefined&&this[this.props.steps[i].stepId].isValidated()===false){validationState=false;break;}}}if(validationState){this.setState({currentStep:key,nextButton:this.props.steps.length>key+1?true:false,previousButton:key>0?true:false,finishButton:this.props.steps.length===key+1?true:false});this.refreshAnimation(key);}}}},{key:"nextButtonClick",value:function nextButtonClick(){if(this.props.validate&&(this[this.props.steps[this.state.currentStep].stepId].isValidated!==undefined&&this[this.props.steps[this.state.currentStep].stepId].isValidated()||this[this.props.steps[this.state.currentStep].stepId].isValidated===undefined)||this.props.validate===undefined){if(this[this.props.steps[this.state.currentStep].stepId].sendState!==undefined){this.setState({allStates:[].concat(_toConsumableArray(this.state.allStates),[_defineProperty({},this.props.steps[this.state.currentStep].stepId,this[this.props.steps[this.state.currentStep].stepId].sendState())])});}var key=this.state.currentStep+1;this.setState({currentStep:key,nextButton:this.props.steps.length>key+1?true:false,previousButton:key>0?true:false,finishButton:this.props.steps.length===key+1?true:false});this.refreshAnimation(key);}}},{key:"previousButtonClick",value:function previousButtonClick(){if(this[this.props.steps[this.state.currentStep].stepId].sendState!==undefined){this.setState({allStates:[].concat(_toConsumableArray(this.state.allStates),[_defineProperty({},this.props.steps[this.state.currentStep].stepId,this[this.props.steps[this.state.currentStep].stepId].sendState())])});}var key=this.state.currentStep-1;if(key>=0){this.setState({currentStep:key,nextButton:this.props.steps.length>key+1?true:false,previousButton:key>0?true:false,finishButton:this.props.steps.length===key+1?true:false});this.refreshAnimation(key);}}},{key:"finishButtonClick",value:function finishButtonClick(){if(this.props.validate&&(this[this.props.steps[this.state.currentStep].stepId].isValidated!==undefined&&this[this.props.steps[this.state.currentStep].stepId].isValidated()||this[this.props.steps[this.state.currentStep].stepId].isValidated===undefined)&&this.props.finishButtonClick!==undefined){this.props.finishButtonClick();}}},{key:"refreshAnimation",value:function refreshAnimation(index){var total=this.props.steps.length;var li_width=100/total;var total_steps=this.props.steps.length;var move_distance=this.refs.wizard.children[0].offsetWidth/total_steps;var index_temp=index;var vertical_level=0;var mobile_device=window.innerWidth<600&&total>3;if(mobile_device){move_distance=this.refs.wizard.children[0].offsetWidth/2;index_temp=index%2;li_width=50;}this.setState({width:li_width+"%"});var step_width=move_distance;move_distance=move_distance*index_temp;var current=index+1;if(current===1||mobile_device===true&&index%2===0){move_distance-=8;}else if(current===total_steps||mobile_device===true&&index%2===1){move_distance+=8;}if(mobile_device){vertical_level=parseInt(index/2,10);vertical_level=vertical_level*38;}var movingTabStyle={width:step_width,transform:"translate3d("+move_distance+"px, "+vertical_level+"px, 0)",transition:"all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)"};this.setState({movingTabStyle:movingTabStyle});}},{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,title=_props.title,subtitle=_props.subtitle,color=_props.color,steps=_props.steps;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wizardContainer,ref:"wizard"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wizardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.title},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:classes.subtitle},subtitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wizardNavigation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:classes.nav},steps.map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:classes.steps,key:key,style:{width:_this2.state.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:classes.stepsAnchor,onClick:function onClick(){return _this2.navigationStepChange(key);}},prop.stepName));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.movingTab+" "+classes[color],style:this.state.movingTabStyle},steps[this.state.currentStep].stepName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.content},steps.map(function(prop,key){var _cx;var stepContentClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx={},_defineProperty(_cx,classes.stepContentActive,_this2.state.currentStep===key),_defineProperty(_cx,classes.stepContent,_this2.state.currentStep!==key),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:stepContentClasses,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.stepComponent,{innerRef:function innerRef(node){return _this2[prop.stepId]=node;},allStates:_this2.state.allStates}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.footer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.left},this.state.previousButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CustomButtons_Button_jsx__["a" /* default */],{className:this.props.previousButtonClasses,onClick:function onClick(){return _this2.previousButtonClick();}},this.props.previousButtonText):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.right},this.state.nextButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",className:this.props.nextButtonClasses,onClick:function onClick(){return _this2.nextButtonClick();}},this.props.nextButtonText):null,this.state.finishButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",className:this.finishButtonClasses,onClick:function onClick(){return _this2.finishButtonClick();}},this.props.finishButtonText):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.clearfix}))));}}]);return Wizard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Wizard.defaultProps={color:"rose",title:"Here should go your title",subtitle:"And this would be your subtitle",previousButtonText:"Previous",previousButtonClasses:"",nextButtonClasses:"",nextButtonText:"Next",finishButtonClasses:"",finishButtonText:"Finish"};Wizard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,steps:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({stepName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,stepComponent:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,stepId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired})).isRequired,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose"]),title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,subtitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,previousButtonClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,previousButtonText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,nextButtonClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,nextButtonText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,finishButtonClasses:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,finishButtonText:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,finishButtonClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,validate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_components_wizardStyle_jsx__["a" /* default */])(Wizard));

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Wizard component styles
// #############################
var wizardStyle={wizardContainer:{},card:{display:"inline-block",position:"relative",width:"100%",margin:"25px 0",boxShadow:"0 1px 4px 0 rgba(0, 0, 0, 0.14)",borderRadius:"6px",color:"rgba(0, 0, 0, 0.87)",background:"#fff",transition:"all 300ms linear",minHeight:"410px"},wizardHeader:{textAlign:"center",padding:"25px 0 35px"},title:{margin:"0"},subtitle:{margin:"5px 0 0"},wizardNavigation:{position:"relative"},nav:{marginTop:"20px",paddingLeft:"0",marginBottom:"0",listStyle:"none",backgroundColor:"rgba(200, 200, 200, 0.2)","&:after,&:before":{display:"table",content:'" "'},"&:after":{boxSizing:"border-box"}},steps:{marginLeft:"0",textAlign:"center",// float: "left",
// display: "block",
position:"relative",display:"inline-block"},stepsAnchor:{cursor:"pointer",position:"relative",display:"block",padding:"10px 15px",textDecoration:"none",transition:"all .3s",border:"0 !important",borderRadius:"30px",lineHeight:"18px",textTransform:"uppercase",fontSize:"12px",fontWeight:"500",minWidth:"100px",textAlign:"center",color:"#555555 !important"},content:{marginTop:"20px",minHeight:"340px",padding:"20px 15px"},stepContent:{display:"none"},stepContentActive:{display:"block"},movingTab:{position:"absolute",textAlign:"center",padding:"12px",fontSize:"12px",textTransform:"uppercase",WebkitFontSmoothing:"subpixel-antialiased",top:"-4px",left:"0px",borderRadius:"4px",color:"#FFFFFF",cursor:"pointer",fontWeight:"500"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(156, 39, 176, 0.4)"},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(255, 152, 0, 0.4)"},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(244, 67, 54, 0.4)"},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(76, 175, 80, 0.4)"},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(0, 188, 212, 0.4)"},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(233, 30, 99, 0.4)"},footer:{padding:"0 15px"},left:{float:"left!important"},right:{float:"right!important"},clearfix:{"&:after,&:before":{display:"table",content:'" "'},clear:"both"}};/* harmony default export */ __webpack_exports__["a"] = (wizardStyle);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Face__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Face___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Face__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_RecordVoiceOver__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_RecordVoiceOver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_RecordVoiceOver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomUpload_PictureUpload_jsx__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/icons
// @material-ui/core components
// core components
var style={infoText:{fontWeight:"300",margin:"10px 0 30px",textAlign:"center"},inputAdornmentIcon:{color:"#555"},inputAdornment:{position:"relative"}};var Step1=function(_React$Component){_inherits(Step1,_React$Component);function Step1(props){_classCallCheck(this,Step1);var _this=_possibleConstructorReturn(this,(Step1.__proto__||Object.getPrototypeOf(Step1)).call(this,props));_this.state={firstname:"",firstnameState:"",lastname:"",lastnameState:"",email:"",emailState:""};return _this;}_createClass(Step1,[{key:"sendState",value:function sendState(){return this.state;}// function that returns true if value is email, false otherwise
},{key:"verifyEmail",value:function verifyEmail(value){var emailRex=/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;if(emailRex.test(value)){return true;}return false;}// function that verifies if a string has a given length or not
},{key:"verifyLength",value:function verifyLength(value,length){if(value.length>=length){return true;}return false;}},{key:"change",value:function change(event,stateName,type,stateNameEqualTo){switch(type){case"email":if(this.verifyEmail(event.target.value)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;case"length":if(this.verifyLength(event.target.value,stateNameEqualTo)){this.setState(_defineProperty({},stateName+"State","success"));}else{this.setState(_defineProperty({},stateName+"State","error"));}break;default:break;}this.setState(_defineProperty({},stateName,event.target.value));}},{key:"isValidated",value:function isValidated(){if(this.state.firstnameState==="success"&&this.state.lastnameState==="success"&&this.state.emailState==="success"){return true;}else{if(this.state.firstnameState!=="success"){this.setState({firstnameState:"error"});}if(this.state.lastnameState!=="success"){this.setState({lastnameState:"error"});}if(this.state.emailState!=="success"){this.setState({emailState:"error"});}}return false;}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.infoText},"Let's start with the basic information (with validation)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomUpload_PictureUpload_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.firstnameState==="success",error:this.state.firstnameState==="error",labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"First Name ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"firstname",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"firstname","length",3);},endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_Face___default.a,{className:classes.inputAdornmentIcon}))}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.lastnameState==="success",error:this.state.lastnameState==="error",labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Last Name ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"lastname",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"lastname","length",3);},endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_RecordVoiceOver___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomInput_CustomInput_jsx__["a" /* default */],{success:this.state.emailState==="success",error:this.state.emailState==="error",labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Email ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"email",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"email","email");},endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})));}}]);return Step1;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(style)(Step1));

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "4"
}), _react.default.createElement("path", {
  d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'RecordVoiceOver');

exports.default = _default;

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_default_avatar_png__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_img_default_avatar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assets_img_default_avatar_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PictureUpload=function(_React$Component){_inherits(PictureUpload,_React$Component);function PictureUpload(props){_classCallCheck(this,PictureUpload);var _this=_possibleConstructorReturn(this,(PictureUpload.__proto__||Object.getPrototypeOf(PictureUpload)).call(this,props));_this.state={file:null,imagePreviewUrl:__WEBPACK_IMPORTED_MODULE_1_assets_img_default_avatar_png___default.a};_this.handleImageChange=_this.handleImageChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);return _this;}_createClass(PictureUpload,[{key:"handleImageChange",value:function handleImageChange(e){var _this2=this;e.preventDefault();var reader=new FileReader();var file=e.target.files[0];reader.onloadend=function(){_this2.setState({file:file,imagePreviewUrl:reader.result});};reader.readAsDataURL(file);}},{key:"handleSubmit",value:function handleSubmit(e){e.preventDefault();// this.state.file is the file/image uploaded
// in this function you can save the image (this.state.file) on form submit
// you have to call it yourself
}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"picture-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"picture"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.imagePreviewUrl,className:"picture-src",alt:"..."}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",onChange:function onChange(e){return _this3.handleImageChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"description"},"Choose Picture"));}}]);return PictureUpload;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PictureUpload);

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var style=Object.assign({infoText:{fontWeight:"300",margin:"10px 0 30px",textAlign:"center"},inputAdornmentIcon:{color:"#555"},choiche:{textAlign:"center",cursor:"pointer",marginTop:"20px"}},__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */],__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */]);var Step2=function(_React$Component){_inherits(Step2,_React$Component);function Step2(props){_classCallCheck(this,Step2);var _this=_possibleConstructorReturn(this,(Step2.__proto__||Object.getPrototypeOf(Step2)).call(this,props));_this.handleSimple=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.checked));};};_this.state={simpleSelect:"",desgin:false,code:false,develop:false};return _this;}_createClass(Step2,[{key:"sendState",value:function sendState(){return this.state;}},{key:"isValidated",value:function isValidated(){return true;}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.infoText},"What are you doing? (checkboxes)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.choiche},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:this.handleChange("desgin"),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-pencil-alt "+classes.iconCheckboxIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-pencil-alt "+classes.iconCheckboxIcon}),classes:{checked:classes.iconCheckboxChecked,root:classes.iconCheckbox}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Design"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.choiche},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:this.handleChange("code"),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-terminal "+classes.iconCheckboxIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-terminal "+classes.iconCheckboxIcon}),classes:{checked:classes.iconCheckboxChecked,root:classes.iconCheckbox}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Code"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.choiche},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:this.handleChange("develop"),checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-laptop "+classes.iconCheckboxIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-laptop "+classes.iconCheckboxIcon}),classes:{checked:classes.iconCheckboxChecked,root:classes.iconCheckbox}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",null,"Develop")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true,className:classes.selectFormControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default.a,{htmlFor:"simple-select",className:classes.selectLabel},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select___default.a,{MenuProps:{className:classes.selectMenu},classes:{select:classes.select},value:this.state.simpleSelect,onChange:this.handleSimple,inputProps:{name:"simpleSelect",id:"simple-select"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{disabled:true,classes:{root:classes.selectMenuItem}},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"2"},"Paris"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"3"},"Bucharest"))))))));}}]);return Step2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(Step2));

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var style=Object.assign({infoText:{fontWeight:"300",margin:"10px 0 30px",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */]);var Step3=function(_React$Component){_inherits(Step3,_React$Component);function Step3(props){_classCallCheck(this,Step3);var _this=_possibleConstructorReturn(this,(Step3.__proto__||Object.getPrototypeOf(Step3)).call(this,props));_this.handleSimple=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.state={simpleSelect:"",desgin:false,code:false,develop:false};return _this;}_createClass(Step3,[{key:"sendState",value:function sendState(){return this.state;}},{key:"isValidated",value:function isValidated(){return true;}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.infoText},"Are you living in a nice area?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Street Name",id:"streetname",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Street No.",id:"streetno",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"City",id:"city",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{fullWidth:true,className:classes.selectFormControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default.a,{htmlFor:"simple-select",className:classes.selectLabel},"Choose City"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Select___default.a,{MenuProps:{className:classes.selectMenu},classes:{select:classes.select},value:this.state.simpleSelect,onChange:this.handleSimple,inputProps:{name:"simpleSelect",id:"simple-select"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{disabled:true,classes:{root:classes.selectMenuItem}},"Country"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"2"},"France"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"3"},"Romania")))));}}]);return Step3;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(Step3));

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Assignment__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Table_Table_jsx__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
// material-ui icons
// core components
var style={customCardContentClass:{paddingLeft:"0",paddingRight:"0"},cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"})};function RegularTables(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Simple Table")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Table_Table_jsx__["a" /* default */],{tableHeaderColor:"primary",tableHead:["Name","Country","City","Salary"],tableData:[["Dakota Rice","Niger","Oud-Turnhout","$36,738"],["Minerva Hooper","Curaçao","Sinaai-Waas","$23,789"],["Sage Rodriguez","Netherlands","Baileux","$56,142"],["Philip Chaney","Korea, South","Overland Park","$38,735"],["Doris Greene","Malawi","Feldkirchen in Kärnten","$63,542"],["Mason Porter","Chile","Gloucester","$78,615"]],coloredColls:[3],colorsColls:["primary"]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Table on Plain Background",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null," - Here is a subtitle for this table"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Table_Table_jsx__["a" /* default */],{hover:true,tableHead:["ID","Name","Salary","Country","City"],tableData:[["1","Dakota Rice","$36,738","Niger","Oud-Turnhout"],["2","Minerva Hooper","$23,789","Curaçao","Sinaai-Waas"],["3","Sage Rodriguez","$56,142","Netherlands","Baileux"],["4","Philip Chaney","$38,735","Korea, South","Overland Park"],["5","Doris Greene","$63,542","Malawi","Feldkirchen in Kärnten"],["6","Mason Porter","$78,615","Chile","Gloucester"]]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Regular Table with Colors")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],{className:classes.customCardContentClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Table_Table_jsx__["a" /* default */],{hover:true,tableHead:["ID","Name","Salary","Country","City"],tableData:[{color:"success",data:["1","Dakota Rice (Success)","$36,738","Niger","Oud-Turnhout"]},["2","Minerva Hooper","$23,789","Curaçao","Sinaai-Waas"],{color:"info",data:["3","Sage Rodriguez (Info)","$56,142","Netherlands","Baileux"]},["4","Philip Chaney","$38,735","Korea, South","Overland Park"],{color:"danger",data:["5","Doris Greene (Danger)","$63,542","Malawi","Feldkirchen in Kärnten"]},["6","Mason Porter","$78,615","Chile","Gloucester"],{color:"warning",data:["7","Mike Chaney (Warning)","$38,735","Romania","Bucharest"]}]})))));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(style)(RegularTables));

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0
    }
  };
};

exports.styles = styles;

var Table =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Table).apply(this, arguments));
  }

  (0, _createClass2.default)(Table, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          padding: this.props.padding
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          padding = _this$props.padding,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component", "padding"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return Table;
}(_react.default.Component);

Table.propTypes =  false ? {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none'])
} : {};
Table.defaultProps = {
  component: 'table',
  padding: 'default'
};
Table.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTable'
})(Table);

exports.default = _default;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
exports.styles = styles;

var TableBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableBody, _React$Component);

  function TableBody() {
    (0, _classCallCheck2.default)(this, TableBody);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableBody).apply(this, arguments));
  }

  (0, _createClass2.default)(TableBody, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        tablelvl2: {
          variant: 'body'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableBody;
}(_react.default.Component);

TableBody.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableBody.defaultProps = {
  component: 'tbody'
};
TableBody.childContextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableBody'
})(TableBody);

exports.default = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var _colorManipulator = __webpack_require__(75);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
      textAlign: 'left',
      padding: '4px 56px 4px 24px',
      '&:last-child': {
        paddingRight: 24
      }
    },

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `numeric={true}`. */
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents

    },

    /* Styles applied to the root element if `padding="dense"`. */
    paddingDense: {
      paddingRight: 24
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      padding: '0 12px',
      '&:last-child': {
        paddingRight: 12
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    }
  };
};

exports.styles = styles;

function TableCell(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      numeric = props.numeric,
      paddingProp = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "sortDirection", "numeric", "padding", "scope", "variant"]);
  var table = context.table,
      tablelvl2 = context.tablelvl2;
  var Component;

  if (component) {
    Component = component;
  } else {
    Component = tablelvl2 && tablelvl2.variant === 'head' ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && tablelvl2 && tablelvl2.variant === 'head') {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, variant ? variant === 'head' : tablelvl2 && tablelvl2.variant === 'head'), (0, _defineProperty2.default)(_classNames, classes.body, variant ? variant === 'body' : tablelvl2 && tablelvl2.variant === 'body'), (0, _defineProperty2.default)(_classNames, classes.footer, variant ? variant === 'footer' : tablelvl2 && tablelvl2.variant === 'footer'), (0, _defineProperty2.default)(_classNames, classes.numeric, numeric), (0, _defineProperty2.default)(_classNames, classes["padding".concat((0, _helpers.capitalize)(padding))], padding !== 'default'), _classNames), classNameProp);
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    "aria-sort": ariaSort,
    scope: scope
  }, other), children);
}

TableCell.propTypes =  false ? {
  /**
   * The table cell contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, content will align to the right.
   */
  numeric: _propTypes.default.bool,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none']),

  /**
   * Set scope attribute.
   */
  scope: _propTypes.default.string,

  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
} : {};
TableCell.defaultProps = {
  numeric: false
};
TableCell.contextTypes = {
  table: _propTypes.default.object,
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableCell'
})(TableCell);

exports.default = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableHead.default;
  }
});

var _TableHead = _interopRequireDefault(__webpack_require__(896));

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
exports.styles = styles;

var TableHead =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableHead, _React$Component);

  function TableHead() {
    (0, _classCallCheck2.default)(this, TableHead);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableHead).apply(this, arguments));
  }

  (0, _createClass2.default)(TableHead, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        tablelvl2: {
          variant: 'head'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableHead;
}(_react.default.Component);

TableHead.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableHead.defaultProps = {
  component: 'thead'
};
TableHead.childContextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableHead'
})(TableHead);

exports.default = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      '&$selected': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
        : 'rgba(255, 255, 255, 0.08)'
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    },

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant = 'head'. */
    head: {
      height: 56
    },

    /* Styles applied to the root element if table variant = 'footer'. */
    footer: {
      height: 56
    }
  };
};
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */


exports.styles = styles;

function TableRow(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
  var tablelvl2 = context.tablelvl2;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, tablelvl2 && tablelvl2.variant === 'head'), (0, _defineProperty2.default)(_classNames, classes.footer, tablelvl2 && tablelvl2.variant === 'footer'), (0, _defineProperty2.default)(_classNames, classes.hover, hover), (0, _defineProperty2.default)(_classNames, classes.selected, selected), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

TableRow.propTypes =  false ? {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes.default.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes.default.bool
} : {};
TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};
TableRow.contextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableRow'
})(TableRow);

exports.default = _default;

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Table styles
// #############################
var tableStyle=function tableStyle(theme){return{warning:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]},primary:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},danger:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]},success:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},info:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]},rose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},gray:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]},right:{textAlign:"right"},table:{marginBottom:"0",width:"100%",maxWidth:"100%",backgroundColor:"transparent",borderSpacing:"0",borderCollapse:"collapse",overflow:"auto"},tableShoppingHead:{fontSize:"0.9em !important",textTransform:"uppercase !important"},tableHeadFontSize:{fontSize:"1.25em !important"},tableHeadCell:{color:"rgba(0, 0, 0, 0.87)",border:"none !important"},tableCell:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],_defineProperty({lineHeight:"1.42857143",padding:"12px 8px!important",verticalAlign:"middle",fontSize:"1em",borderBottom:"none",borderTop:"1px solid #ddd",position:"relative"},theme.breakpoints.down("sm"),{minHeight:"24px",minWidth:"32px"})),tableCellTotal:{fontWeight:"500",fontSize:"1.25em",paddingTop:"14px",textAlign:"right"},tableCellAmount:{fontSize:"26px",fontWeight:"300",marginTop:"5px",textAlign:"right"},tableResponsive:{// width: "100%",
minHeight:"0.1%",overflowX:"auto"},tableStripedRow:{backgroundColor:"#f9f9f9"},tableRowHover:{"&:hover":{backgroundColor:"#f5f5f5"}},warningRow:{backgroundColor:"#fcf8e3","&:hover":{backgroundColor:"#faf2cc"}},dangerRow:{backgroundColor:"#f2dede","&:hover":{backgroundColor:"#ebcccc"}},successRow:{backgroundColor:"#dff0d8","&:hover":{backgroundColor:"#d0e9c6"}},infoRow:{backgroundColor:"#d9edf7","&:hover":{backgroundColor:"#c4e3f3"}}};};/* harmony default export */ __webpack_exports__["a"] = (tableStyle);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Edit__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Remove__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_KeyboardArrowRight__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_KeyboardArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_KeyboardArrowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Table_Table_jsx__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_jss_material_dashboard_pro_react_views_extendedTablesStyle_jsx__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_img_product1_jpg__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_img_product1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_assets_img_product1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_img_product2_jpg__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_img_product2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_assets_img_product2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_img_product3_jpg__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_img_product3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_assets_img_product3_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// material-ui icons
// core components
var ExtendedTables=function(_React$Component){_inherits(ExtendedTables,_React$Component);function ExtendedTables(props){_classCallCheck(this,ExtendedTables);var _this=_possibleConstructorReturn(this,(ExtendedTables.__proto__||Object.getPrototypeOf(ExtendedTables)).call(this,props));_this.state={checked:[]};_this.handleToggle=_this.handleToggle.bind(_this);return _this;}_createClass(ExtendedTables,[{key:"handleToggle",value:function handleToggle(value){var checked=this.state.checked;var currentIndex=checked.indexOf(value);var newChecked=[].concat(_toConsumableArray(checked));if(currentIndex===-1){newChecked.push(value);}else{newChecked.splice(currentIndex,1);}this.setState({checked:newChecked});}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;var fillButtons=[{color:"info",icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person___default.a},{color:"success",icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Edit___default.a},{color:"danger",icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a}].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:prop.color,className:classes.actionButton,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,{className:classes.icon}));});var simpleButtons=[{color:"info",icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person___default.a},{color:"success",icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Edit___default.a},{color:"danger",icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a}].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:prop.color,simple:true,className:classes.actionButton,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,{className:classes.icon}));});var roundButtons=[{color:"info",icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Person___default.a},{color:"success",icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Edit___default.a},{color:"danger",icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a}].map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:prop.color,className:classes.actionButton+" "+classes.actionButtonRound,key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(prop.icon,{className:classes.icon}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Simple Table")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Table_Table_jsx__["a" /* default */],{tableHead:["#","Name","Job Position","Since","Salary","Actions"],tableData:[["1","Andrew Mike","Develop","2013","€ 99,225",fillButtons],["2","John Doe","Design","2012","€ 89,241",roundButtons],["3","Alex Mike","Design","2010","€ 92,144",simpleButtons],["4","Mike Monday","Marketing","2013","€ 49,990",roundButtons],["5","Paul Dickens","Communication","2015","€ 69,201",fillButtons]],customCellClasses:[classes.center,classes.right,classes.right],customClassesForCells:[0,4,5],customHeadCellClasses:[classes.center,classes.right,classes.right],customHeadClassesForCells:[0,4,5]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Striped Table")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Table_Table_jsx__["a" /* default */],{striped:true,tableHead:["#","","Product Name","Type","Qty","Price","Amount"],tableData:[["1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox___default.a,{className:classes.positionAbsolute,tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(1);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),"Moleskine Agenda","Office","25","€ 49","€ 1,225"],["2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox___default.a,{className:classes.positionAbsolute,tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(2);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),"Stabilo Pen","Office","30","€ 10","€ 300"],["3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox___default.a,{className:classes.positionAbsolute,tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(3);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),"A4 Paper Pack","Office","50","€ 10.99","€ 109"],["4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox___default.a,{className:classes.positionAbsolute,tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(4);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),"Apple iPad","Communication","10","€ 499.00","€ 4,990"],["5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Checkbox___default.a,{className:classes.positionAbsolute,tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(5);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),"Apple iPhone","Communication","10","€ 599.00","€ 5,999"],{total:true,colspan:"5",amount:"€12,999"}],customCellClasses:[classes.center,classes.right,classes.right],customClassesForCells:[0,5,6],customHeadCellClasses:[classes.center,classes.right,classes.right],customHeadClassesForCells:[0,5,6]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Shopping Cart Table")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Table_Table_jsx__["a" /* default */],{tableHead:["","PRODUCT","COLOR","SIZE","PRICE","QTY","AMOUNT",""],tableData:[[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.imgContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_20_assets_img_product1_jpg___default.a,alt:"...",className:classes.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#jacket",className:classes.tdNameAnchor},"Spring Jacket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNameSmall},"by Dolce&Gabbana")),"Red","M",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNumberSmall},"\u20AC")," 549"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"1"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.buttonGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",size:"sm",round:true,className:classes.firstButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Remove___default.a,{className:classes.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",size:"sm",round:true,className:classes.lastButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,{className:classes.icon})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNumberSmall},"\u20AC")," 549"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{simple:true,className:classes.actionButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.icon}))],[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.imgContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_21_assets_img_product2_jpg___default.a,alt:"...",className:classes.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#jacket",className:classes.tdNameAnchor},"Short Pants"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNameSmall},"by Pucci")),"Purple","M",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNumberSmall},"\u20AC")," 499"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"2"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.buttonGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",size:"sm",round:true,className:classes.firstButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Remove___default.a,{className:classes.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",size:"sm",round:true,className:classes.lastButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,{className:classes.icon})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNumberSmall},"\u20AC")," 998"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{simple:true,className:classes.actionButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.icon}))],[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.imgContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_22_assets_img_product3_jpg___default.a,alt:"...",className:classes.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#jacket",className:classes.tdNameAnchor},"Pencil Skirt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNameSmall},"by Valentino")),"White","XL",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNumberSmall},"\u20AC")," 799"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"1"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.buttonGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",size:"sm",round:true,className:classes.firstButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Remove___default.a,{className:classes.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",size:"sm",round:true,className:classes.lastButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,{className:classes.icon})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:classes.tdNumberSmall},"\u20AC")," 799"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{simple:true,className:classes.actionButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,{className:classes.icon}))],{total:true,colspan:"5",amount:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u20AC"),"2,346")},{purchase:true,colspan:"6",col:{colspan:2,text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CustomButtons_Button_jsx__["a" /* default */],{color:"info",round:true},"Complete Purchase"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_KeyboardArrowRight___default.a,{className:classes.icon}))}}],tableShopping:true,customHeadCellClasses:[classes.center,classes.description,classes.description,classes.right,classes.right,classes.right],customHeadClassesForCells:[0,2,3,4,5,6],customCellClasses:[classes.tdName,classes.customFont,classes.customFont,classes.tdNumber,classes.tdNumber+" "+classes.tdNumberAndButtonGroup,classes.tdNumber],customClassesForCells:[1,2,3,4,5,6]})))));}}]);return ExtendedTables;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_19_assets_jss_material_dashboard_pro_react_views_extendedTablesStyle_jsx__["a" /* default */])(ExtendedTables));

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Remove');

exports.default = _default;

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_buttonGroupStyle_jsx__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var extendedTablesStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_buttonGroupStyle_jsx__["a" /* default */],{right:{textAlign:"right"},center:{textAlign:"center"},description:{maxWidth:"150px"},actionButton:{margin:"0 0 0 5px",padding:"5px","& svg,& .fab,& .fas,& .far,& .fal,& .material-icons":{marginRight:"0px"}},icon:{verticalAlign:"middle",width:"17px",height:"17px",top:"-1px",position:"relative"},imgContainer:{width:"120px",maxHeight:"160px",overflow:"hidden",display:"block"},img:{width:"100%",height:"auto",verticalAlign:"middle",border:"0"},tdName:{minWidth:"200px",fontWeight:"400",fontSize:"1.5em"},tdNameAnchor:{color:"#3C4858"},tdNameSmall:{color:"#999999",fontSize:"0.75em",fontWeight:"300"},tdNumber:{textAlign:"right",minWidth:"145px",fontWeight:"300",fontSize:"1.3em !important"},tdNumberSmall:{marginRight:"3px"},tdNumberAndButtonGroup:{lineHeight:"1 !important"},positionAbsolute:{position:"absolute",right:"0",top:"0"},customFont:{fontSize:"16px !important"},actionButtonRound:{width:"auto",height:"auto",minWidth:"auto"},cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_2_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"})});/* harmony default export */ __webpack_exports__["a"] = (extendedTablesStyle);

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/product1.081bf019.jpg";

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/product3.a0e40011.jpg";

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_table__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Dvr__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Dvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Dvr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Favorite__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Favorite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Favorite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_variables_general_jsx__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react component for creating dynamic tables
// @material-ui/core components
// @material-ui/icons
// core components
var styles={cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"})};var ReactTables=function(_React$Component){_inherits(ReactTables,_React$Component);function ReactTables(props){_classCallCheck(this,ReactTables);var _this=_possibleConstructorReturn(this,(ReactTables.__proto__||Object.getPrototypeOf(ReactTables)).call(this,props));_this.state={data:__WEBPACK_IMPORTED_MODULE_14_variables_general_jsx__["c" /* dataTable */].dataRows.map(function(prop,key){return{id:key,name:prop[0],position:prop[1],office:prop[2],age:prop[3],actions:// we've added some custom button actions
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,simple:true,onClick:function onClick(){var obj=_this.state.data.find(function(o){return o.id===key;});alert("You've clicked LIKE button on \n{ \nName: "+obj.name+", \nposition: "+obj.position+", \noffice: "+obj.office+", \nage: "+obj.age+"\n}.");},color:"info",className:"like"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Favorite___default.a,null))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,simple:true,onClick:function onClick(){var obj=_this.state.data.find(function(o){return o.id===key;});alert("You've clicked EDIT button on \n{ \nName: "+obj.name+", \nposition: "+obj.position+", \noffice: "+obj.office+", \nage: "+obj.age+"\n}.");},color:"warning",className:"edit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Dvr___default.a,null))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,simple:true,onClick:function onClick(){var data=_this.state.data;data.find(function(o,i){if(o.id===key){// here you should add some custom code so you can delete the data
// from this component and from your server as well
data.splice(i,1);return true;}return false;});_this.setState({data:data});},color:"danger",className:"remove"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Close___default.a,null))," ")};})};return _this;}_createClass(ReactTables,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],{color:"primary",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardIcon_jsx__["a" /* default */],{color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Assignment___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"React Table")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_table__["a" /* default */],{data:this.state.data,filterable:true,columns:[{Header:"Name",accessor:"name"},{Header:"Position",accessor:"position"},{Header:"Office",accessor:"office"},{Header:"Age",accessor:"age"},{Header:"Actions",accessor:"actions",sortable:false,filterable:false}],defaultPageSize:10,showPaginationTop:true,showPaginationBottom:false,className:"-striped -highlight"})))));}}]);return ReactTables;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(styles)(ReactTables));

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* harmony default export */ __webpack_exports__["a"] = (function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fireFetchData();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextState) {
        var oldState = this.getResolvedState();
        var newState = this.getResolvedState(nextProps, nextState);

        // Do a deep compare of new and old `defaultOption` and
        // if they are different reset `option = defaultOption`
        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
        defaultableOptions.forEach(function (x) {
          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
            newState[x] = newState[defaultName];
          }
        });

        // If they change these table options, we need to reset defaults
        // or else we could get into a state where the user has changed the UI
        // and then disabled the ability to change it back.
        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
        var resettableOptions = ['sortable', 'filterable', 'resizable'];
        resettableOptions.forEach(function (x) {
          if (oldState[x] !== newState[x]) {
            var baseName = x.replace('able', '');
            var optionName = baseName + 'ed';
            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
            newState[optionName] = newState[defaultName];
          }
        });

        // Props that trigger a data update
        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
        }
      }
    }, {
      key: 'setStateWithData',
      value: function setStateWithData(newState, cb) {
        var _this2 = this;

        var oldState = this.getResolvedState();
        var newResolvedState = this.getResolvedState({}, newState);
        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;

        // Default to unfrozen state

        newResolvedState.frozen = false;

        // If freezeWhenExpanded is set, check for frozen conditions
        if (freezeWhenExpanded) {
          // if any rows are expanded, freeze the existing data and sorting
          var keys = Object.keys(newResolvedState.expanded);
          for (var i = 0; i < keys.length; i += 1) {
            if (newResolvedState.expanded[keys[i]]) {
              newResolvedState.frozen = true;
              break;
            }
          }
        }

        // If the data isn't frozen and either the data or
        // sorting model has changed, update the data
        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
          // Handle collapseOnsortedChange & collapseOnDataChange
          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
            newResolvedState.expanded = {};
          }

          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
        }

        // Set page to 0 if filters change
        if (oldState.filtered !== newResolvedState.filtered) {
          newResolvedState.page = 0;
        }

        // Calculate pageSize all the time
        if (newResolvedState.sortedData) {
          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
          newResolvedState.page = Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
        }

        return this.setState(newResolvedState, function () {
          if (cb) {
            cb();
          }
          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
            _this2.fireFetchData();
          }
        });
      }
    }]);

    return _class;
  }(Base);
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(257);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/* harmony default export */ __webpack_exports__["a"] = (function (Base) {
  return function (_Base) {
    _inherits(_class, _Base);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'getResolvedState',
      value: function getResolvedState(props, state) {
        var resolvedState = _extends({}, __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(this.state), __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(this.props), __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(state), __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].compactObject(props));
        return resolvedState;
      }
    }, {
      key: 'getDataModel',
      value: function getDataModel(newState, dataChanged) {
        var _this2 = this;

        var columns = newState.columns,
            _newState$pivotBy = newState.pivotBy,
            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
            data = newState.data,
            resolveData = newState.resolveData,
            pivotIDKey = newState.pivotIDKey,
            pivotValKey = newState.pivotValKey,
            subRowsKey = newState.subRowsKey,
            aggregatedKey = newState.aggregatedKey,
            nestingLevelKey = newState.nestingLevelKey,
            originalKey = newState.originalKey,
            indexKey = newState.indexKey,
            groupedByPivotKey = newState.groupedByPivotKey,
            SubComponent = newState.SubComponent;

        // Determine Header Groups

        var hasHeaderGroups = false;
        columns.forEach(function (column) {
          if (column.columns) {
            hasHeaderGroups = true;
          }
        });

        var columnsWithExpander = [].concat(_toConsumableArray(columns));

        var expanderColumn = columns.find(function (col) {
          return col.expander || col.columns && col.columns.some(function (col2) {
            return col2.expander;
          });
        });
        // The actual expander might be in the columns field of a group column
        if (expanderColumn && !expanderColumn.expander) {
          expanderColumn = expanderColumn.columns.find(function (col) {
            return col.expander;
          });
        }

        // If we have SubComponent's we need to make sure we have an expander column
        if (SubComponent && !expanderColumn) {
          expanderColumn = { expander: true };
          columnsWithExpander = [expanderColumn].concat(_toConsumableArray(columnsWithExpander));
        }

        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
          var dcol = void 0;
          if (column.expander) {
            dcol = _extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
          } else {
            dcol = _extends({}, _this2.props.column, column);
          }

          // Ensure minWidth is not greater than maxWidth if set
          if (dcol.maxWidth < dcol.minWidth) {
            dcol.minWidth = dcol.maxWidth;
          }

          if (parentColumn) {
            dcol.parentColumn = parentColumn;
          }

          // First check for string accessor
          if (typeof dcol.accessor === 'string') {
            dcol.id = dcol.id || dcol.accessor;
            var accessorString = dcol.accessor;
            dcol.accessor = function (row) {
              return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].get(row, accessorString);
            };
            return dcol;
          }

          // Fall back to functional accessor (but require an ID)
          if (dcol.accessor && !dcol.id) {
            console.warn(dcol);
            throw new Error('A column id is required if using a non-string accessor for column above.');
          }

          // Fall back to an undefined accessor
          if (!dcol.accessor) {
            dcol.accessor = function () {
              return undefined;
            };
          }

          return dcol;
        };

        var allDecoratedColumns = [];

        // Decorate the columns
        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
          allDecoratedColumns.push(decoratedColumn);
          return decoratedColumn;
        };

        var decoratedColumns = columnsWithExpander.map(function (column) {
          if (column.columns) {
            return _extends({}, column, {
              columns: column.columns.map(function (d) {
                return decorateAndAddToAll(d, column);
              })
            });
          }
          return decorateAndAddToAll(column);
        });

        // Build the visible columns, headers and flat column list
        var visibleColumns = decoratedColumns.slice();
        var allVisibleColumns = [];

        visibleColumns = visibleColumns.map(function (column) {
          if (column.columns) {
            var visibleSubColumns = column.columns.filter(function (d) {
              return pivotBy.indexOf(d.id) > -1 ? false : __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(d.show, true);
            });
            return _extends({}, column, {
              columns: visibleSubColumns
            });
          }
          return column;
        });

        visibleColumns = visibleColumns.filter(function (column) {
          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(column.show, true);
        });

        // Find any custom pivot location
        var pivotIndex = visibleColumns.findIndex(function (col) {
          return col.pivot;
        });

        // Handle Pivot Columns
        if (pivotBy.length) {
          // Retrieve the pivot columns in the correct pivot order
          var pivotColumns = [];
          pivotBy.forEach(function (pivotID) {
            var found = allDecoratedColumns.find(function (d) {
              return d.id === pivotID;
            });
            if (found) {
              pivotColumns.push(found);
            }
          });

          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
            return prev && prev === current.parentColumn && current.parentColumn;
          }, pivotColumns[0].parentColumn);

          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
          PivotGroupHeader = PivotGroupHeader || function () {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Pivoted'
            );
          };

          var pivotColumnGroup = {
            Header: PivotGroupHeader,
            columns: pivotColumns.map(function (col) {
              return _extends({}, _this2.props.pivotDefaults, col, {
                pivoted: true
              });
            })

            // Place the pivotColumns back into the visibleColumns
          };if (pivotIndex >= 0) {
            pivotColumnGroup = _extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
          } else {
            visibleColumns.unshift(pivotColumnGroup);
          }
        }

        // Build Header Groups
        var headerGroups = [];
        var currentSpan = [];

        // A convenience function to add a header and reset the currentSpan
        var addHeader = function addHeader(columns, column) {
          headerGroups.push(_extends({}, _this2.props.column, column, {
            columns: columns
          }));
          currentSpan = [];
        };

        // Build flast list of allVisibleColumns and HeaderGroups
        visibleColumns.forEach(function (column) {
          if (column.columns) {
            allVisibleColumns = allVisibleColumns.concat(column.columns);
            if (currentSpan.length > 0) {
              addHeader(currentSpan);
            }
            addHeader(column.columns, column);
            return;
          }
          allVisibleColumns.push(column);
          currentSpan.push(column);
        });
        if (hasHeaderGroups && currentSpan.length > 0) {
          addHeader(currentSpan);
        }

        // Access the data
        var accessRow = function accessRow(d, i) {
          var _row;

          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

          var row = (_row = {}, _defineProperty(_row, originalKey, d), _defineProperty(_row, indexKey, i), _defineProperty(_row, subRowsKey, d[subRowsKey]), _defineProperty(_row, nestingLevelKey, level), _row);
          allDecoratedColumns.forEach(function (column) {
            if (column.expander) return;
            row[column.id] = column.accessor(d);
          });
          if (row[subRowsKey]) {
            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
              return accessRow(d, i, level + 1);
            });
          }
          return row;
        };

        // // If the data hasn't changed, just use the cached data
        var resolvedData = this.resolvedData;
        // If the data has changed, run the data resolver and cache the result
        if (!this.resolvedData || dataChanged) {
          resolvedData = resolveData(data);
          this.resolvedData = resolvedData;
        }
        // Use the resolved data
        resolvedData = resolvedData.map(function (d, i) {
          return accessRow(d, i);
        });

        // TODO: Make it possible to fabricate nested rows without pivoting
        var aggregatingColumns = allVisibleColumns.filter(function (d) {
          return !d.expander && d.aggregate;
        });

        // If pivoting, recursively group the data
        var aggregate = function aggregate(rows) {
          var aggregationValues = {};
          aggregatingColumns.forEach(function (column) {
            var values = rows.map(function (d) {
              return d[column.id];
            });
            aggregationValues[column.id] = column.aggregate(values, rows);
          });
          return aggregationValues;
        };
        if (pivotBy.length) {
          var groupRecursively = function groupRecursively(rows, keys) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            // This is the last level, just return the rows
            if (i === keys.length) {
              return rows;
            }
            // Group the rows together for this level
            var groupedRows = Object.entries(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].groupBy(rows, keys[i])).map(function (_ref) {
              var _ref3;

              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              return _ref3 = {}, _defineProperty(_ref3, pivotIDKey, keys[i]), _defineProperty(_ref3, pivotValKey, key), _defineProperty(_ref3, keys[i], key), _defineProperty(_ref3, subRowsKey, value), _defineProperty(_ref3, nestingLevelKey, i), _defineProperty(_ref3, groupedByPivotKey, true), _ref3;
            });
            // Recurse into the subRows
            groupedRows = groupedRows.map(function (rowGroup) {
              var _extends2;

              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
              return _extends({}, rowGroup, (_extends2 = {}, _defineProperty(_extends2, subRowsKey, subRows), _defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
            });
            return groupedRows;
          };
          resolvedData = groupRecursively(resolvedData, pivotBy);
        }

        return _extends({}, newState, {
          resolvedData: resolvedData,
          allVisibleColumns: allVisibleColumns,
          headerGroups: headerGroups,
          allDecoratedColumns: allDecoratedColumns,
          hasHeaderGroups: hasHeaderGroups
        });
      }
    }, {
      key: 'getSortedData',
      value: function getSortedData(resolvedState) {
        var manual = resolvedState.manual,
            sorted = resolvedState.sorted,
            filtered = resolvedState.filtered,
            defaultFilterMethod = resolvedState.defaultFilterMethod,
            resolvedData = resolvedState.resolvedData,
            allVisibleColumns = resolvedState.allVisibleColumns,
            allDecoratedColumns = resolvedState.allDecoratedColumns;


        var sortMethodsByColumnID = {};

        allDecoratedColumns.filter(function (col) {
          return col.sortMethod;
        }).forEach(function (col) {
          sortMethodsByColumnID[col.id] = col.sortMethod;
        });

        // Resolve the data from either manual data or sorted data
        return {
          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allVisibleColumns), sorted, sortMethodsByColumnID)
        };
      }
    }, {
      key: 'fireFetchData',
      value: function fireFetchData() {
        this.props.onFetchData(this.getResolvedState(), this);
      }
    }, {
      key: 'getPropOrState',
      value: function getPropOrState(key) {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(this.props[key], this.state[key]);
      }
    }, {
      key: 'getStateOrProp',
      value: function getStateOrProp(key) {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(this.state[key], this.props[key]);
      }
    }, {
      key: 'filterData',
      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
        var _this3 = this;

        var filteredData = data;

        if (filtered.length) {
          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
            var column = allVisibleColumns.find(function (x) {
              return x.id === nextFilter.id;
            });

            // Don't filter hidden columns or columns that have had their filters disabled
            if (!column || column.filterable === false) {
              return filteredSoFar;
            }

            var filterMethod = column.filterMethod || defaultFilterMethod;

            // If 'filterAll' is set to true, pass the entire dataset to the filter method
            if (column.filterAll) {
              return filterMethod(nextFilter, filteredSoFar, column);
            }
            return filteredSoFar.filter(function (row) {
              return filterMethod(nextFilter, row, column);
            });
          }, filteredData);

          // Apply the filter to the subrows if we are pivoting, and then
          // filter any rows without subcolumns because it would be strange to show
          filteredData = filteredData.map(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return row;
            }
            return _extends({}, row, _defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
          }).filter(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return true;
            }
            return row[_this3.props.subRowsKey].length > 0;
          });
        }

        return filteredData;
      }
    }, {
      key: 'sortData',
      value: function sortData(data, sorted) {
        var _this4 = this;

        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (!sorted.length) {
          return data;
        }

        var sortedData = (this.props.orderByMethod || __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].orderBy)(data, sorted.map(function (sort) {
          // Support custom sorting methods for each column
          if (sortMethodsByColumnID[sort.id]) {
            return function (a, b) {
              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
            };
          }
          return function (a, b) {
            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
          };
        }), sorted.map(function (d) {
          return !d.desc;
        }), this.props.indexKey);

        sortedData.forEach(function (row) {
          if (!row[_this4.props.subRowsKey]) {
            return;
          }
          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
        });

        return sortedData;
      }
    }, {
      key: 'getMinRows',
      value: function getMinRows() {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
      }

      // User actions

    }, {
      key: 'onPageChange',
      value: function onPageChange(page) {
        var _props = this.props,
            onPageChange = _props.onPageChange,
            collapseOnPageChange = _props.collapseOnPageChange;


        var newState = { page: page };
        if (collapseOnPageChange) {
          newState.expanded = {};
        }
        this.setStateWithData(newState, function () {
          return onPageChange && onPageChange(page);
        });
      }
    }, {
      key: 'onPageSizeChange',
      value: function onPageSizeChange(newPageSize) {
        var onPageSizeChange = this.props.onPageSizeChange;

        var _getResolvedState = this.getResolvedState(),
            pageSize = _getResolvedState.pageSize,
            page = _getResolvedState.page;

        // Normalize the page to display


        var currentRow = pageSize * page;
        var newPage = Math.floor(currentRow / newPageSize);

        this.setStateWithData({
          pageSize: newPageSize,
          page: newPage
        }, function () {
          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
        });
      }
    }, {
      key: 'sortColumn',
      value: function sortColumn(column, additive) {
        var _getResolvedState2 = this.getResolvedState(),
            sorted = _getResolvedState2.sorted,
            skipNextSort = _getResolvedState2.skipNextSort,
            defaultSortDesc = _getResolvedState2.defaultSortDesc;

        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
        var secondSortDirection = !firstSortDirection;

        // we can't stop event propagation from the column resize move handlers
        // attached to the document because of react's synthetic events
        // so we have to prevent the sort function from actually sorting
        // if we click on the column resize element within a header.
        if (skipNextSort) {
          this.setStateWithData({
            skipNextSort: false
          });
          return;
        }

        var onSortedChange = this.props.onSortedChange;


        var newSorted = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].clone(sorted || []).map(function (d) {
          d.desc = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isSortingDesc(d);
          return d;
        });
        if (!__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].isArray(column)) {
          // Single-Sort
          var existingIndex = newSorted.findIndex(function (d) {
            return d.id === column.id;
          });
          if (existingIndex > -1) {
            var existing = newSorted[existingIndex];
            if (existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(existingIndex, 1);
              } else {
                existing.desc = firstSortDirection;
                newSorted = [existing];
              }
            } else {
              existing.desc = secondSortDirection;
              if (!additive) {
                newSorted = [existing];
              }
            }
          } else if (additive) {
            newSorted.push({
              id: column.id,
              desc: firstSortDirection
            });
          } else {
            newSorted = [{
              id: column.id,
              desc: firstSortDirection
            }];
          }
        } else {
          // Multi-Sort
          var _existingIndex = newSorted.findIndex(function (d) {
            return d.id === column[0].id;
          });
          // Existing Sorted Column
          if (_existingIndex > -1) {
            var _existing = newSorted[_existingIndex];
            if (_existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(_existingIndex, column.length);
              } else {
                column.forEach(function (d, i) {
                  newSorted[_existingIndex + i].desc = firstSortDirection;
                });
              }
            } else {
              column.forEach(function (d, i) {
                newSorted[_existingIndex + i].desc = secondSortDirection;
              });
            }
            if (!additive) {
              newSorted = newSorted.slice(_existingIndex, column.length);
            }
            // New Sort Column
          } else if (additive) {
            newSorted = newSorted.concat(column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            }));
          } else {
            newSorted = column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            });
          }
        }

        this.setStateWithData({
          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
          sorted: newSorted
        }, function () {
          return onSortedChange && onSortedChange(newSorted, column, additive);
        });
      }
    }, {
      key: 'filterColumn',
      value: function filterColumn(column, value) {
        var _getResolvedState3 = this.getResolvedState(),
            filtered = _getResolvedState3.filtered;

        var onFilteredChange = this.props.onFilteredChange;

        // Remove old filter first if it exists

        var newFiltering = (filtered || []).filter(function (x) {
          return x.id !== column.id;
        });

        if (value !== '') {
          newFiltering.push({
            id: column.id,
            value: value
          });
        }

        this.setStateWithData({
          filtered: newFiltering
        }, function () {
          return onFilteredChange && onFilteredChange(newFiltering, column, value);
        });
      }
    }, {
      key: 'resizeColumnStart',
      value: function resizeColumnStart(event, column, isTouch) {
        var _this5 = this;

        event.stopPropagation();
        var parentWidth = event.target.parentElement.getBoundingClientRect().width;

        var pageX = void 0;
        if (isTouch) {
          pageX = event.changedTouches[0].pageX;
        } else {
          pageX = event.pageX;
        }

        this.trapEvents = true;
        this.setStateWithData({
          currentlyResizing: {
            id: column.id,
            startX: pageX,
            parentWidth: parentWidth
          }
        }, function () {
          if (isTouch) {
            document.addEventListener('touchmove', _this5.resizeColumnMoving);
            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
            document.addEventListener('touchend', _this5.resizeColumnEnd);
          } else {
            document.addEventListener('mousemove', _this5.resizeColumnMoving);
            document.addEventListener('mouseup', _this5.resizeColumnEnd);
            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
          }
        });
      }
    }, {
      key: 'resizeColumnMoving',
      value: function resizeColumnMoving(event) {
        event.stopPropagation();
        var onResizedChange = this.props.onResizedChange;

        var _getResolvedState4 = this.getResolvedState(),
            resized = _getResolvedState4.resized,
            currentlyResizing = _getResolvedState4.currentlyResizing;

        // Delete old value


        var newResized = resized.filter(function (x) {
          return x.id !== currentlyResizing.id;
        });

        var pageX = void 0;

        if (event.type === 'touchmove') {
          pageX = event.changedTouches[0].pageX;
        } else if (event.type === 'mousemove') {
          pageX = event.pageX;
        }

        // Set the min size to 10 to account for margin and border or else the
        // group headers don't line up correctly
        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, 11);

        newResized.push({
          id: currentlyResizing.id,
          value: newWidth
        });

        this.setStateWithData({
          resized: newResized
        }, function () {
          return onResizedChange && onResizedChange(newResized, event);
        });
      }
    }, {
      key: 'resizeColumnEnd',
      value: function resizeColumnEnd(event) {
        event.stopPropagation();
        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';

        if (isTouch) {
          document.removeEventListener('touchmove', this.resizeColumnMoving);
          document.removeEventListener('touchcancel', this.resizeColumnEnd);
          document.removeEventListener('touchend', this.resizeColumnEnd);
        }

        // If its a touch event clear the mouse one's as well because sometimes
        // the mouseDown event gets called as well, but the mouseUp event doesn't
        document.removeEventListener('mousemove', this.resizeColumnMoving);
        document.removeEventListener('mouseup', this.resizeColumnEnd);
        document.removeEventListener('mouseleave', this.resizeColumnEnd);

        // The touch events don't propagate up to the sorting's onMouseDown event so
        // no need to prevent it from happening or else the first click after a touch
        // event resize will not sort the column.
        if (!isTouch) {
          this.setStateWithData({
            skipNextSort: true,
            currentlyResizing: false
          });
        }
      }
    }]);

    return _class;
  }(Base);
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination__ = __webpack_require__(909);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



//



var emptyObj = function emptyObj() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // General
  data: [],
  resolveData: function resolveData(data) {
    return data;
  },
  loading: false,
  showPagination: true,
  showPaginationTop: false,
  showPaginationBottom: true,
  showPageSizeOptions: true,
  pageSizeOptions: [5, 10, 20, 25, 50, 100],
  defaultPageSize: 20,
  showPageJump: true,
  collapseOnSortingChange: true,
  collapseOnPageChange: true,
  collapseOnDataChange: true,
  freezeWhenExpanded: false,
  sortable: true,
  multiSort: true,
  resizable: true,
  filterable: false,
  defaultSortDesc: false,
  defaultSorted: [],
  defaultFiltered: [],
  defaultResized: [],
  defaultExpanded: {},
  // eslint-disable-next-line no-unused-vars
  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
  },
  // eslint-disable-next-line no-unused-vars
  defaultSortMethod: function defaultSortMethod(a, b, desc) {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a;
    b = b === null || b === undefined ? '' : b;
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b;
    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or
    // the index as a tiebreaker
    return 0;
  },

  // Controlled State Props
  // page: undefined,
  // pageSize: undefined,
  // sorted: [],
  // filtered: [],
  // resized: [],
  // expanded: {},

  // Controlled State Callbacks
  onPageChange: undefined,
  onPageSizeChange: undefined,
  onSortedChange: undefined,
  onFilteredChange: undefined,
  onResizedChange: undefined,
  onExpandedChange: undefined,

  // Pivoting
  pivotBy: undefined,

  // Key Constants
  pivotValKey: '_pivotVal',
  pivotIDKey: '_pivotID',
  subRowsKey: '_subRows',
  aggregatedKey: '_aggregated',
  nestingLevelKey: '_nestingLevel',
  originalKey: '_original',
  indexKey: '_index',
  groupedByPivotKey: '_groupedByPivot',

  // Server-side Callbacks
  onFetchData: function onFetchData() {
    return null;
  },

  // Classes
  className: '',
  style: {},

  // Component decorators
  getProps: emptyObj,
  getTableProps: emptyObj,
  getTheadGroupProps: emptyObj,
  getTheadGroupTrProps: emptyObj,
  getTheadGroupThProps: emptyObj,
  getTheadProps: emptyObj,
  getTheadTrProps: emptyObj,
  getTheadThProps: emptyObj,
  getTheadFilterProps: emptyObj,
  getTheadFilterTrProps: emptyObj,
  getTheadFilterThProps: emptyObj,
  getTbodyProps: emptyObj,
  getTrGroupProps: emptyObj,
  getTrProps: emptyObj,
  getTdProps: emptyObj,
  getTfootProps: emptyObj,
  getTfootTrProps: emptyObj,
  getTfootTdProps: emptyObj,
  getPaginationProps: emptyObj,
  getLoadingProps: emptyObj,
  getNoDataProps: emptyObj,
  getResizerProps: emptyObj,

  // Global Column Defaults
  column: {
    // Renderers
    Cell: undefined,
    Header: undefined,
    Footer: undefined,
    Aggregated: undefined,
    Pivot: undefined,
    PivotValue: undefined,
    Expander: undefined,
    Filter: undefined,
    // All Columns
    sortable: undefined, // use table default
    resizable: undefined, // use table default
    filterable: undefined, // use table default
    show: true,
    minWidth: 100,
    // Cells only
    className: '',
    style: {},
    getProps: emptyObj,
    // Pivot only
    aggregate: undefined,
    // Headers only
    headerClassName: '',
    headerStyle: {},
    getHeaderProps: emptyObj,
    // Footers only
    footerClassName: '',
    footerStyle: {},
    getFooterProps: emptyObj,
    filterMethod: undefined,
    filterAll: false,
    sortMethod: undefined
  },

  // Global Expander Column Defaults
  expanderDefaults: {
    sortable: false,
    resizable: false,
    filterable: false,
    width: 35
  },

  pivotDefaults: {
    // extend the defaults for pivoted columns here
  },

  // Text
  previousText: 'Previous',
  nextText: 'Next',
  loadingText: 'Loading...',
  noDataText: 'No rows found',
  pageText: 'Page',
  ofText: 'of',
  rowsText: 'rows',

  // Components
  TableComponent: function TableComponent(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties(_ref, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-table', className),
        role: 'grid'
        // tabIndex='0'
      }, rest),
      children
    );
  },
  TheadComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-thead', 'Thead'),
  TbodyComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-tbody', 'Tbody'),
  TrGroupComponent: function TrGroupComponent(_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        rest = _objectWithoutProperties(_ref2, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-tr-group', className), role: 'rowgroup' }, rest),
      children
    );
  },
  TrComponent: function TrComponent(_ref3) {
    var children = _ref3.children,
        className = _ref3.className,
        rest = _objectWithoutProperties(_ref3, ['children', 'className']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-tr', className), role: 'row' }, rest),
      children
    );
  },
  ThComponent: function ThComponent(_ref4) {
    var toggleSort = _ref4.toggleSort,
        className = _ref4.className,
        children = _ref4.children,
        rest = _objectWithoutProperties(_ref4, ['toggleSort', 'className', 'children']);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-th', className),
          onClick: function onClick(e) {
            return toggleSort && toggleSort(e);
          },
          role: 'columnheader',
          tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
        }, rest),
        children
      )
    );
  },
  TdComponent: function TdComponent(_ref5) {
    var toggleSort = _ref5.toggleSort,
        className = _ref5.className,
        children = _ref5.children,
        rest = _objectWithoutProperties(_ref5, ['toggleSort', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-td', className), role: 'gridcell' }, rest),
      children
    );
  },
  TfootComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-tfoot', 'Tfoot'),
  FilterComponent: function FilterComponent(_ref6) {
    var filter = _ref6.filter,
        _onChange = _ref6.onChange;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      style: {
        width: '100%'
      },
      value: filter ? filter.value : '',
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      }
    });
  },
  ExpanderComponent: function ExpanderComponent(_ref7) {
    var isExpanded = _ref7.isExpanded;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('rt-expander', isExpanded && '-open') },
      '\u2022'
    );
  },
  PivotValueComponent: function PivotValueComponent(_ref8) {
    var subRows = _ref8.subRows,
        value = _ref8.value;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      value,
      ' ',
      subRows && '(' + subRows.length + ')'
    );
  },
  AggregatedComponent: function AggregatedComponent(_ref9) {
    var subRows = _ref9.subRows,
        column = _ref9.column;

    var previewValues = subRows.filter(function (d) {
      return typeof d[column.id] !== 'undefined';
    }).map(function (row, i) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { key: i },
          row[column.id],
          i < subRows.length - 1 ? ', ' : ''
        )
      );
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      previewValues
    );
  },
  PivotComponent: undefined, // this is a computed default generated using
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: __WEBPACK_IMPORTED_MODULE_3__pagination__["a" /* default */],
  PreviousComponent: undefined,
  NextComponent: undefined,
  LoadingComponent: function LoadingComponent(_ref10) {
    var className = _ref10.className,
        loading = _ref10.loading,
        loadingText = _ref10.loadingText,
        rest = _objectWithoutProperties(_ref10, ['className', 'loading', 'loadingText']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      _extends({ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-loading', { '-active': loading }, className) }, rest),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '-loading-inner' },
        loadingText
      )
    );
  },
  NoDataComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-noData', 'NoData'),
  ResizerComponent: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].makeTemplateComponent('rt-resizer', 'Resizer'),
  PadRowComponent: function PadRowComponent() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      '\xA0'
    );
  }
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



//
// import _ from './utils'

var defaultButton = function defaultButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    _extends({ type: 'button' }, props, { className: '-btn' }),
    props.children
  );
};

var ReactTablePagination = function (_Component) {
  _inherits(ReactTablePagination, _Component);

  function ReactTablePagination(props) {
    _classCallCheck(this, ReactTablePagination);

    var _this = _possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this));

    _this.getSafePage = _this.getSafePage.bind(_this);
    _this.changePage = _this.changePage.bind(_this);
    _this.applyPage = _this.applyPage.bind(_this);

    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass(ReactTablePagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ page: nextProps.page });
    }
  }, {
    key: 'getSafePage',
    value: function getSafePage(page) {
      if (Number.isNaN(page)) {
        page = this.props.page;
      }
      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({ page: page });
      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: 'applyPage',
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }
      var page = this.state.page;
      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pages = _props.pages,
          page = _props.page,
          showPageSizeOptions = _props.showPageSizeOptions,
          pageSizeOptions = _props.pageSizeOptions,
          pageSize = _props.pageSize,
          showPageJump = _props.showPageJump,
          canPrevious = _props.canPrevious,
          canNext = _props.canNext,
          onPageSizeChange = _props.onPageSizeChange,
          className = _props.className,
          _props$PreviousCompon = _props.PreviousComponent,
          PreviousComponent = _props$PreviousCompon === undefined ? defaultButton : _props$PreviousCompon,
          _props$NextComponent = _props.NextComponent,
          NextComponent = _props$NextComponent === undefined ? defaultButton : _props$NextComponent;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, '-pagination'), style: this.props.style },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-previous' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            PreviousComponent,
            {
              onClick: function onClick() {
                if (!canPrevious) return;
                _this2.changePage(page - 1);
              },
              disabled: !canPrevious
            },
            this.props.previousText
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: '-pageInfo' },
            this.props.pageText,
            ' ',
            showPageJump ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: '-pageJump' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                type: this.state.page === '' ? 'text' : 'number',
                onChange: function onChange(e) {
                  var val = e.target.value;
                  var page = val - 1;
                  if (val === '') {
                    return _this2.setState({ page: val });
                  }
                  _this2.setState({ page: _this2.getSafePage(page) });
                },
                value: this.state.page === '' ? '' : this.state.page + 1,
                onBlur: this.applyPage,
                onKeyPress: function onKeyPress(e) {
                  if (e.which === 13 || e.keyCode === 13) {
                    _this2.applyPage();
                  }
                }
              })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: '-currentPage' },
              page + 1
            ),
            ' ',
            this.props.ofText,
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: '-totalPages' },
              pages || 1
            )
          ),
          showPageSizeOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'select-wrap -pageSizeOptions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              { onChange: function onChange(e) {
                  return onPageSizeChange(Number(e.target.value));
                }, value: pageSize },
              pageSizeOptions.map(function (option, i) {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { key: i, value: option },
                    option,
                    ' ',
                    _this2.props.rowsText
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-next' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            NextComponent,
            {
              onClick: function onClick() {
                if (!canNext) return;
                _this2.changePage(page + 1);
              },
              disabled: !canNext
            },
            this.props.nextText
          )
        )
      );
    }
  }]);

  return ReactTablePagination;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ReactTablePagination);
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


/* harmony default export */ __webpack_exports__["a"] = ({
  // General
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
  loading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPagination: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPaginationTop: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPaginationBottom: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  showPageSizeOptions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  pageSizeOptions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultPageSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  showPageJump: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  collapseOnSortingChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  collapseOnPageChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  collapseOnDataChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  freezeWhenExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  resizable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  filterable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  defaultSortDesc: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  defaultSorted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultFiltered: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultResized: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  defaultExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  defaultFilterMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  defaultSortMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Controlled State Callbacks
  onPageChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPageSizeChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSortedChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onFilteredChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onResizedChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onExpandedChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Pivoting
  pivotBy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,

  // Key Constants
  pivotValKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  pivotIDKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  subRowsKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  aggregatedKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  nestingLevelKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  originalKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  indexKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  groupedByPivotKey: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // Server-side Callbacks
  onFetchData: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Classes
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,

  // Component decorators
  getProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTableProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadGroupProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadGroupTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadGroupThProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadThProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadFilterProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadFilterTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTheadFilterThProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTbodyProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTrGroupProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTdProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTfootProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTfootTrProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getTfootTdProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getPaginationProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getLoadingProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getNoDataProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  getResizerProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

  // Global Column Defaults
  columns: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    // Renderers
    Cell: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Header: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Footer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Aggregated: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Pivot: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    PivotValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Expander: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),
    Filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func]),

    // All Columns
    sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, // use table default
    resizable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, // use table default
    filterable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, // use table default
    show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    minWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,

    // Cells only
    className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    getProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

    // Pivot only
    aggregate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

    // Headers only
    headerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    headerStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    getHeaderProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,

    // Footers only
    footerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    footerStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    getFooterProps: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    filterMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    filterAll: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    sortMethod: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  })),

  // Global Expander Column Defaults
  expanderDefaults: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    sortable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    resizable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    filterable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
  }),

  pivotDefaults: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,

  // Text
  previousText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  nextText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  loadingText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  noDataText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  pageText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  ofText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  rowsText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,

  // Components
  TableComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  TheadComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  TbodyComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  TrGroupComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  TrComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  ThComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  TdComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  TfootComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  FilterComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  ExpanderComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  PivotValueComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  AggregatedComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  // this is a computed default generated using
  PivotComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  PreviousComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  NextComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  LoadingComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  NoDataComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  ResizerComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element]),
  PadRowComponent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element])
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
})), 'CardTravel');

exports.default = _default;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
})), 'Extension');

exports.default = _default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0V0z"
})), _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "c",
  d: "M0 0h24v24H0V0z"
})), _react.default.createElement("path", {
  d: "M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z"
})), 'FlightLand');

exports.default = _default;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  clipRule: "evenodd"
}), _react.default.createElement("path", {
  d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
})), 'Build');

exports.default = _default;

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddLocation__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddLocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Place__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Place___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Place__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react components used to create a google map
// @material-ui/core components
// @material-ui/icons
// core components
var styles={cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"})};var SatelliteMap=Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withScriptjs"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["GoogleMap"],{defaultZoom:3,mapTypeId:"satellite",defaultCenter:{lat:40.748817,lng:-73.985428},defaultOptions:{scrollwheel:false}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"],{position:{lat:40.748817,lng:-73.985428}}));}));var RegularMap=Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withScriptjs"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["GoogleMap"],{defaultZoom:8,defaultCenter:{lat:40.748817,lng:-73.985428},defaultOptions:{scrollwheel:false}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"],{position:{lat:40.748817,lng:-73.985428}}));}));var CustomSkinMap=Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withScriptjs"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["GoogleMap"],{defaultZoom:13,defaultCenter:{lat:40.748817,lng:-73.985428},defaultOptions:{scrollwheel:false,disableDefaultUI:true,zoomControl:true,styles:[{featureType:"water",stylers:[{saturation:43},{lightness:-11},{hue:"#0088ff"}]},{featureType:"road",elementType:"geometry.fill",stylers:[{hue:"#ff0000"},{saturation:-100},{lightness:99}]},{featureType:"road",elementType:"geometry.stroke",stylers:[{color:"#808080"},{lightness:54}]},{featureType:"landscape.man_made",elementType:"geometry.fill",stylers:[{color:"#ece2d9"}]},{featureType:"poi.park",elementType:"geometry.fill",stylers:[{color:"#ccdca1"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#767676"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]},{featureType:"poi",stylers:[{visibility:"off"}]},{featureType:"landscape.natural",elementType:"geometry.fill",stylers:[{visibility:"on"},{color:"#b8cb93"}]},{featureType:"poi.park",stylers:[{visibility:"on"}]},{featureType:"poi.sports_complex",stylers:[{visibility:"on"}]},{featureType:"poi.medical",stylers:[{visibility:"on"}]},{featureType:"poi.business",stylers:[{visibility:"simplified"}]}]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"],{position:{lat:40.748817,lng:-73.985428}}));}));var GoogleMaps=function(_React$Component){_inherits(GoogleMaps,_React$Component);function GoogleMaps(){_classCallCheck(this,GoogleMaps);return _possibleConstructorReturn(this,(GoogleMaps.__proto__||Object.getPrototypeOf(GoogleMaps)).apply(this,arguments));}_createClass(GoogleMaps,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Map___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Satellite Map")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SatelliteMap,{googleMapURL:"https://maps.googleapis.com/maps/api/js?key=YOUR_KEY_HERE",loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}}),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"280px",borderRadius:"6px",overflow:"hidden"}}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}})})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_AddLocation___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Regular Map")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RegularMap,{googleMapURL:"https://maps.googleapis.com/maps/api/js?key=YOUR_KEY_HERE",loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}}),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"280px",borderRadius:"6px",overflow:"hidden"}}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}})})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Place___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Custom Skin & Settings Map")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSkinMap,{googleMapURL:"https://maps.googleapis.com/maps/api/js?key=YOUR_KEY_HERE",loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}}),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"280px",borderRadius:"6px",overflow:"hidden"}}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}})})))));}}]);return GoogleMaps;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(styles)(GoogleMaps));

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(415)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(187)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(23)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(448)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(449)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(983)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(918);
module.exports = __webpack_require__(44).Object.getPrototypeOf;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(182);
var $getPrototypeOf = __webpack_require__(416);

__webpack_require__(919)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(72);
var core = __webpack_require__(44);
var fails = __webpack_require__(108);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(922);
var $Object = __webpack_require__(44).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(72);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(86), 'Object', { defineProperty: __webpack_require__(73).f });


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(924), __esModule: true };

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(421);
__webpack_require__(931);
module.exports = __webpack_require__(268).f('iterator');


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(263);
var defined = __webpack_require__(258);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(264);
var descriptor = __webpack_require__(136);
var setToStringTag = __webpack_require__(267);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(105)(IteratorPrototype, __webpack_require__(50)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(73);
var anObject = __webpack_require__(106);
var getKeys = __webpack_require__(185);

module.exports = __webpack_require__(86) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(109);
var toLength = __webpack_require__(426);
var toAbsoluteIndex = __webpack_require__(929);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(263);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(71).document;
module.exports = document && document.documentElement;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(932);
var global = __webpack_require__(71);
var hide = __webpack_require__(105);
var Iterators = __webpack_require__(137);
var TO_STRING_TAG = __webpack_require__(50)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(933);
var step = __webpack_require__(934);
var Iterators = __webpack_require__(137);
var toIObject = __webpack_require__(109);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(422)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(936), __esModule: true };

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(937);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
module.exports = __webpack_require__(44).Symbol;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(71);
var has = __webpack_require__(85);
var DESCRIPTORS = __webpack_require__(86);
var $export = __webpack_require__(72);
var redefine = __webpack_require__(423);
var META = __webpack_require__(938).KEY;
var $fails = __webpack_require__(108);
var shared = __webpack_require__(260);
var setToStringTag = __webpack_require__(267);
var uid = __webpack_require__(184);
var wks = __webpack_require__(50);
var wksExt = __webpack_require__(268);
var wksDefine = __webpack_require__(269);
var enumKeys = __webpack_require__(939);
var isArray = __webpack_require__(940);
var anObject = __webpack_require__(106);
var isObject = __webpack_require__(107);
var toIObject = __webpack_require__(109);
var toPrimitive = __webpack_require__(262);
var createDesc = __webpack_require__(136);
var _create = __webpack_require__(264);
var gOPNExt = __webpack_require__(941);
var $GOPD = __webpack_require__(428);
var $DP = __webpack_require__(73);
var $keys = __webpack_require__(185);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(427).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(186).f = $propertyIsEnumerable;
  __webpack_require__(270).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(183)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(105)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(184)('meta');
var isObject = __webpack_require__(107);
var has = __webpack_require__(85);
var setDesc = __webpack_require__(73).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(108)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(185);
var gOPS = __webpack_require__(270);
var pIE = __webpack_require__(186);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(265);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(109);
var gOPN = __webpack_require__(427).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 942 */
/***/ (function(module, exports) {



/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(269)('asyncIterator');


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(269)('observable');


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(946), __esModule: true };

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(947);
module.exports = __webpack_require__(44).Object.setPrototypeOf;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(72);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(948).set });


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(107);
var anObject = __webpack_require__(106);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(261)(Function.call, __webpack_require__(428).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(950), __esModule: true };

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(951);
var $Object = __webpack_require__(44).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(72);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(264) });


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(953),
    defineProperty = __webpack_require__(430),
    identity = __webpack_require__(110);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 953 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(139),
    isMasked = __webpack_require__(957),
    isObject = __webpack_require__(51),
    toSource = __webpack_require__(432);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(958);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 959 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(434),
    createBind = __webpack_require__(961),
    createCurry = __webpack_require__(962),
    createHybrid = __webpack_require__(437),
    createPartial = __webpack_require__(978),
    getData = __webpack_require__(441),
    mergeData = __webpack_require__(979),
    setData = __webpack_require__(443),
    setWrapToString = __webpack_require__(444),
    toInteger = __webpack_require__(277);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(188),
    root = __webpack_require__(39);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(271),
    createCtor = __webpack_require__(188),
    createHybrid = __webpack_require__(437),
    createRecurry = __webpack_require__(440),
    getHolder = __webpack_require__(276),
    replaceHolders = __webpack_require__(191),
    root = __webpack_require__(39);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 963 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(273),
    getData = __webpack_require__(441),
    getFuncName = __webpack_require__(966),
    lodash = __webpack_require__(968);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 965 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(967);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(273),
    LodashWrapper = __webpack_require__(442),
    baseLodash = __webpack_require__(274),
    isArray = __webpack_require__(37),
    isObjectLike = __webpack_require__(61),
    wrapperClone = __webpack_require__(969);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(273),
    LodashWrapper = __webpack_require__(442),
    copyArray = __webpack_require__(275);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 970 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 971 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    arrayIncludes = __webpack_require__(973);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(974);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(445),
    baseIsNaN = __webpack_require__(975),
    strictIndexOf = __webpack_require__(976);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 975 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 976 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(275),
    isIndex = __webpack_require__(190);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(271),
    createCtor = __webpack_require__(188),
    root = __webpack_require__(39);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(438),
    composeArgsRight = __webpack_require__(439),
    replaceHolders = __webpack_require__(191);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(981);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 981 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(415)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(187)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(450)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(23)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(449)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(986)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(23)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(987);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(988), __esModule: true };

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(421);
__webpack_require__(989);
module.exports = __webpack_require__(44).Array.from;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(261);
var $export = __webpack_require__(72);
var toObject = __webpack_require__(182);
var call = __webpack_require__(990);
var isArrayIter = __webpack_require__(991);
var toLength = __webpack_require__(426);
var createProperty = __webpack_require__(992);
var getIterFn = __webpack_require__(993);

$export($export.S + $export.F * !__webpack_require__(995)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(106);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(137);
var ITERATOR = __webpack_require__(50)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(73);
var createDesc = __webpack_require__(136);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(994);
var ITERATOR = __webpack_require__(50)('iterator');
var Iterators = __webpack_require__(137);
module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(265);
var TAG = __webpack_require__(50)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(50)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(997),
    baseEach = __webpack_require__(278),
    baseIteratee = __webpack_require__(142),
    baseReduce = __webpack_require__(1057),
    isArray = __webpack_require__(37);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(999);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 999 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1000 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    isLength = __webpack_require__(282),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(194),
    nativeKeys = __webpack_require__(1005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(452);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(114);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1008),
    getMatchData = __webpack_require__(1045),
    matchesStrictComparable = __webpack_require__(460);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(284),
    baseIsEqual = __webpack_require__(453);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(196);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(196);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(196);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(196);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(195);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(195),
    Map = __webpack_require__(285),
    MapCache = __webpack_require__(286);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1020),
    ListCache = __webpack_require__(195),
    Map = __webpack_require__(285);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1021),
    hashDelete = __webpack_require__(1022),
    hashGet = __webpack_require__(1023),
    hashHas = __webpack_require__(1024),
    hashSet = __webpack_require__(1025);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(197);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(197);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(197);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(197);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(198);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(198);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(198);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(198);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(284),
    equalArrays = __webpack_require__(454),
    equalByTag = __webpack_require__(1037),
    equalObjects = __webpack_require__(1040),
    getTag = __webpack_require__(199),
    isArray = __webpack_require__(37),
    isBuffer = __webpack_require__(192),
    isTypedArray = __webpack_require__(281);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(286),
    setCacheAdd = __webpack_require__(1033),
    setCacheHas = __webpack_require__(1034);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    Uint8Array = __webpack_require__(455),
    eq = __webpack_require__(143),
    equalArrays = __webpack_require__(454),
    mapToArray = __webpack_require__(1038),
    setToArray = __webpack_require__(1039);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1039 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(456);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(87),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(459),
    keys = __webpack_require__(113);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(453),
    get = __webpack_require__(1047),
    hasIn = __webpack_require__(1052),
    isKey = __webpack_require__(289),
    isStrictComparable = __webpack_require__(459),
    matchesStrictComparable = __webpack_require__(460),
    toKey = __webpack_require__(144);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(200);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1049);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1050);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(286);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    arrayMap = __webpack_require__(290),
    isArray = __webpack_require__(37),
    isSymbol = __webpack_require__(141);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1053),
    hasPath = __webpack_require__(462);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1055),
    basePropertyDeep = __webpack_require__(1056),
    isKey = __webpack_require__(289),
    toKey = __webpack_require__(144);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(200);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    baseEach = __webpack_require__(278),
    castFunction = __webpack_require__(1059),
    isArray = __webpack_require__(37);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(110);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1061);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(1062),
    hasUnicode = __webpack_require__(463),
    stringToArray = __webpack_require__(1063),
    toString = __webpack_require__(461);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(291);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1064),
    hasUnicode = __webpack_require__(463),
    unicodeToArray = __webpack_require__(1065);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1067),
    hasPath = __webpack_require__(462);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(23)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(448)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(21)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(1075)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(1080)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(1082)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(187)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(23)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(21)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _OverlayViewHelper = __webpack_require__(1084)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1076);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1077), __esModule: true };

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1078);
module.exports = __webpack_require__(44).Object.assign;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(72);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1079) });


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(185);
var gOPS = __webpack_require__(270);
var pIE = __webpack_require__(186);
var toObject = __webpack_require__(182);
var IObject = __webpack_require__(425);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(108)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(1081),
    baseRest = __webpack_require__(138),
    toNumber = __webpack_require__(447);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(292),
    copyObject = __webpack_require__(115),
    createAssigner = __webpack_require__(1083),
    isArrayLike = __webpack_require__(114),
    isPrototype = __webpack_require__(194),
    keys = __webpack_require__(113);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(138),
    isIterateeCall = __webpack_require__(145);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(139)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(450)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(23)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(34)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(27)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(28)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(29)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(30)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(31)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(2)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(38)

var _constants = __webpack_require__(35)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Map');

exports.default = _default;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
})), 'AddLocation');

exports.default = _default;

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CustomSkinMap=Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withScriptjs"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withGoogleMap"])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["GoogleMap"],{defaultZoom:13,defaultCenter:{lat:40.748817,lng:-73.985428},defaultOptions:{scrollwheel:false,zoomControl:true,styles:[{featureType:"water",stylers:[{saturation:43},{lightness:-11},{hue:"#0088ff"}]},{featureType:"road",elementType:"geometry.fill",stylers:[{hue:"#ff0000"},{saturation:-100},{lightness:99}]},{featureType:"road",elementType:"geometry.stroke",stylers:[{color:"#808080"},{lightness:54}]},{featureType:"landscape.man_made",elementType:"geometry.fill",stylers:[{color:"#ece2d9"}]},{featureType:"poi.park",elementType:"geometry.fill",stylers:[{color:"#ccdca1"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#767676"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{color:"#ffffff"}]},{featureType:"poi",stylers:[{visibility:"off"}]},{featureType:"landscape.natural",elementType:"geometry.fill",stylers:[{visibility:"on"},{color:"#b8cb93"}]},{featureType:"poi.park",stylers:[{visibility:"on"}]},{featureType:"poi.sports_complex",stylers:[{visibility:"on"}]},{featureType:"poi.medical",stylers:[{visibility:"on"}]},{featureType:"poi.business",stylers:[{visibility:"simplified"}]}]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"],{position:{lat:40.748817,lng:-73.985428}}));}));function FullScreenMap(_ref){var prop=_objectWithoutProperties(_ref,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSkinMap,{googleMapURL:"https://maps.googleapis.com/maps/api/js?key=YOUR_KEY_HERE",loadingElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}}),containerElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100vh"}}),mapElement:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:"100%"}})});}/* harmony default export */ __webpack_exports__["a"] = (FullScreenMap);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_jvectormap__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_jvectormap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_jvectormap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(19);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/*eslint-disable*/// react plugin for creating vector maps
// core components
var mapData={AU:760,BR:550,CA:120,DE:1300,FR:540,GB:690,GE:200,IN:200,RO:600,RU:300,US:2920};function VectorMaps(_ref){var prop=_objectWithoutProperties(_ref,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Heading_Heading_jsx__["a" /* default */],{textAlign:"center",title:"World Map",category:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.npmjs.com/package/react-jvectormap",target:"_blank"},"React wrapper component")," ","of jQuery"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://jvectormap.com/",target:"_blank"},"jVector Map")," ","pluging.")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_jvectormap__["VectorMap"],{map:"world_mill",backgroundColor:"transparent",zoomOnScroll:false,containerStyle:{width:"100%",height:"420px"},containerClassName:"map",regionStyle:{initial:{fill:"#e4e4e4","fill-opacity":0.9,stroke:"none","stroke-width":0,"stroke-opacity":0}},series:{regions:[{values:mapData,scale:["#AAAAAA","#444444"],normalizeFunction:"polynomial"}]}}))))));}/* harmony default export */ __webpack_exports__["a"] = (VectorMaps);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

!function(l,e){if(true)module.exports=e(__webpack_require__(0));else if("function"===typeof define&&define.amd)define(["react"],e);else{var t=e("object"===typeof exports?require("react"):l.react);for(var a in t)("object"===typeof exports?exports:l)[a]=t[a]}}(this,function(l){return function(l){function e(a){if(t[a])return t[a].exports;var n=t[a]={i:a,l:!1,exports:{}};return l[a].call(n.exports,n,n.exports,e),n.l=!0,n.exports}var t={};return e.m=l,e.c=t,e.d=function(l,t,a){e.o(l,t)||Object.defineProperty(l,t,{configurable:!1,enumerable:!0,get:a})},e.n=function(l){var t=l&&l.__esModule?function(){return l.default}:function(){return l};return e.d(t,"a",t),t},e.o=function(l,e){return Object.prototype.hasOwnProperty.call(l,e)},e.p="",e(e.s=33)}([function(l,e,t){var a,n;!function(e,t){"use strict";"object"===typeof l&&"object"===typeof l.exports?l.exports=e.document?t(e,!0):function(l){if(!l.document)throw new Error("jQuery requires a window with a document");return t(l)}:t(e)}("undefined"!==typeof window?window:this,function(t,i){"use strict";function c(l,e,t){t=t||Ml;var a,n,i=t.createElement("script");if(i.text=l,e)for(a in El)(n=e[a]||e.getAttribute&&e.getAttribute(a))&&i.setAttribute(a,n);t.head.appendChild(i).parentNode.removeChild(i)}function r(l){return null==l?l+"":"object"===typeof l||"function"===typeof l?gl[yl.call(l)]||"object":typeof l}function o(l){var e=!!l&&"length"in l&&l.length,t=r(l);return!wl(l)&&!Cl(l)&&("array"===t||0===e||"number"===typeof e&&e>0&&e-1 in l)}function s(l,e){return l.nodeName&&l.nodeName.toLowerCase()===e.toLowerCase()}function h(l,e,t){return wl(e)?Tl.grep(l,function(l,a){return!!e.call(l,a,l)!==t}):e.nodeType?Tl.grep(l,function(l){return l===e!==t}):"string"!==typeof e?Tl.grep(l,function(l){return fl.call(e,l)>-1!==t}):Tl.filter(e,l,t)}function p(l,e){for(;(l=l[e])&&1!==l.nodeType;);return l}function M(l){var e={};return Tl.each(l.match(Pl)||[],function(l,t){e[t]=!0}),e}function u(l){return l}function Z(l){throw l}function m(l,e,t,a){var n;try{l&&wl(n=l.promise)?n.call(l).done(e).fail(t):l&&wl(n=l.then)?n.call(l,e,t):e.apply(void 0,[l].slice(a))}catch(l){t.apply(void 0,[l])}}function d(){Ml.removeEventListener("DOMContentLoaded",d),t.removeEventListener("load",d),Tl.ready()}function f(l,e){return e.toUpperCase()}function g(l){return l.replace(Bl,"ms-").replace(Gl,f)}function y(){this.expando=Tl.expando+y.uid++}function v(l){return"true"===l||"false"!==l&&("null"===l?null:l===+l+""?+l:ql.test(l)?JSON.parse(l):l)}function b(l,e,t){var a;if(void 0===t&&1===l.nodeType)if(a="data-"+e.replace($l,"-$&").toLowerCase(),"string"===typeof(t=l.getAttribute(a))){try{t=v(t)}catch(l){}Kl.set(l,e,t)}else t=void 0;return t}function S(l,e,t,a){var n,i,c=20,r=a?function(){return a.cur()}:function(){return Tl.css(l,e,"")},o=r(),s=t&&t[3]||(Tl.cssNumber[e]?"":"px"),h=l.nodeType&&(Tl.cssNumber[e]||"px"!==s&&+o)&&Wl.exec(Tl.css(l,e));if(h&&h[3]!==s){for(o/=2,s=s||h[3],h=+o||1;c--;)Tl.style(l,e,h+s),(1-i)*(1-(i=r()/o||.5))<=0&&(c=0),h/=i;h*=2,Tl.style(l,e,h+s),t=t||[]}return t&&(h=+h||+o||0,n=t[1]?h+(t[1]+1)*t[2]:+t[2],a&&(a.unit=s,a.start=h,a.end=n)),n}function x(l){var e,t=l.ownerDocument,a=l.nodeName,n=ae[a];return n||(e=t.body.appendChild(t.createElement(a)),n=Tl.css(e,"display"),e.parentNode.removeChild(e),"none"===n&&(n="block"),ae[a]=n,n)}function w(l,e){for(var t,a,n=[],i=0,c=l.length;i<c;i++)a=l[i],a.style&&(t=a.style.display,e?("none"===t&&(n[i]=_l.get(a,"display")||null,n[i]||(a.style.display="")),""===a.style.display&&ee(a)&&(n[i]=x(a))):"none"!==t&&(n[i]="none",_l.set(a,"display",t)));for(i=0;i<c;i++)null!=n[i]&&(l[i].style.display=n[i]);return l}function C(l,e){var t;return t="undefined"!==typeof l.getElementsByTagName?l.getElementsByTagName(e||"*"):"undefined"!==typeof l.querySelectorAll?l.querySelectorAll(e||"*"):[],void 0===e||e&&s(l,e)?Tl.merge([l],t):t}function E(l,e){for(var t=0,a=l.length;t<a;t++)_l.set(l[t],"globalEval",!e||_l.get(e[t],"globalEval"))}function T(l,e,t,a,n){for(var i,c,o,s,h,p,M=e.createDocumentFragment(),u=[],Z=0,m=l.length;Z<m;Z++)if((i=l[Z])||0===i)if("object"===r(i))Tl.merge(u,i.nodeType?[i]:i);else if(oe.test(i)){for(c=c||M.appendChild(e.createElement("div")),o=(ie.exec(i)||["",""])[1].toLowerCase(),s=re[o]||re._default,c.innerHTML=s[1]+Tl.htmlPrefilter(i)+s[2],p=s[0];p--;)c=c.lastChild;Tl.merge(u,c.childNodes),c=M.firstChild,c.textContent=""}else u.push(e.createTextNode(i));for(M.textContent="",Z=0;i=u[Z++];)if(a&&Tl.inArray(i,a)>-1)n&&n.push(i);else if(h=Ql(i),c=C(M.appendChild(i),"script"),h&&E(c),t)for(p=0;i=c[p++];)ce.test(i.type||"")&&t.push(i);return M}function k(){return!0}function z(){return!1}function A(l,e){return l===R()===("focus"===e)}function R(){try{return Ml.activeElement}catch(l){}}function N(l,e,t,a,n,i){var c,r;if("object"===typeof e){"string"!==typeof t&&(a=a||t,t=void 0);for(r in e)N(l,r,t,a,e[r],i);return l}if(null==a&&null==n?(n=t,a=t=void 0):null==n&&("string"===typeof t?(n=a,a=void 0):(n=a,a=t,t=void 0)),!1===n)n=z;else if(!n)return l;return 1===i&&(c=n,n=function(l){return Tl().off(l),c.apply(this,arguments)},n.guid=c.guid||(c.guid=Tl.guid++)),l.each(function(){Tl.event.add(this,e,n,a,t)})}function L(l,e,t){if(!t)return void Tl.event.add(l,e,k);_l.set(l,e,!1),Tl.event.add(l,e,{namespace:!1,handler:function(l){var a,n,i=_l.get(this,e);if(1&l.isTrigger&&this[e]){if(i)(Tl.event.special[e]||{}).delegateType&&l.stopPropagation();else if(i=Zl.call(arguments),_l.set(this,e,i),a=t(this,e),this[e](),n=_l.get(this,e),i!==n||a?_l.set(this,e,!1):n=void 0,i!==n)return l.stopImmediatePropagation(),l.preventDefault(),n}else i&&(_l.set(this,e,Tl.event.trigger(Tl.extend(i.shift(),Tl.Event.prototype),i,this)),l.stopImmediatePropagation())}})}function j(l,e){return s(l,"table")&&s(11!==e.nodeType?e:e.firstChild,"tr")?Tl(l).children("tbody")[0]||l:l}function D(l){return l.type=(null!==l.getAttribute("type"))+"/"+l.type,l}function O(l){return"true/"===(l.type||"").slice(0,5)?l.type=l.type.slice(5):l.removeAttribute("type"),l}function H(l,e){var t,a,n,i,c,r,o,s;if(1===e.nodeType){if(_l.hasData(l)&&(i=_l.access(l),c=_l.set(e,i),s=i.events)){delete c.handle,c.events={};for(n in s)for(t=0,a=s[n].length;t<a;t++)Tl.event.add(e,n,s[n][t])}Kl.hasData(l)&&(r=Kl.access(l),o=Tl.extend({},r),Kl.set(e,o))}}function P(l,e){var t=e.nodeName.toLowerCase();"input"===t&&ne.test(l.type)?e.checked=l.checked:"input"!==t&&"textarea"!==t||(e.defaultValue=l.defaultValue)}function I(l,e,t,a){e=ml.apply([],e);var n,i,r,o,s,h,p=0,M=l.length,u=M-1,Z=e[0],m=wl(Z);if(m||M>1&&"string"===typeof Z&&!xl.checkClone&&Ze.test(Z))return l.each(function(n){var i=l.eq(n);m&&(e[0]=Z.call(this,n,i.html())),I(i,e,t,a)});if(M&&(n=T(e,l[0].ownerDocument,!1,l,a),i=n.firstChild,1===n.childNodes.length&&(n=i),i||a)){for(r=Tl.map(C(n,"script"),D),o=r.length;p<M;p++)s=n,p!==u&&(s=Tl.clone(s,!0,!0),o&&Tl.merge(r,C(s,"script"))),t.call(l[p],s,p);if(o)for(h=r[r.length-1].ownerDocument,Tl.map(r,O),p=0;p<o;p++)s=r[p],ce.test(s.type||"")&&!_l.access(s,"globalEval")&&Tl.contains(h,s)&&(s.src&&"module"!==(s.type||"").toLowerCase()?Tl._evalUrl&&!s.noModule&&Tl._evalUrl(s.src,{nonce:s.nonce||s.getAttribute("nonce")}):c(s.textContent.replace(me,""),s,h))}return l}function U(l,e,t){for(var a,n=e?Tl.filter(e,l):l,i=0;null!=(a=n[i]);i++)t||1!==a.nodeType||Tl.cleanData(C(a)),a.parentNode&&(t&&Ql(a)&&E(C(a,"script")),a.parentNode.removeChild(a));return l}function V(l,e,t){var a,n,i,c,r=l.style;return t=t||fe(l),t&&(c=t.getPropertyValue(e)||t[e],""!==c||Ql(l)||(c=Tl.style(l,e)),!xl.pixelBoxStyles()&&de.test(c)&&ge.test(e)&&(a=r.width,n=r.minWidth,i=r.maxWidth,r.minWidth=r.maxWidth=r.width=c,c=t.width,r.width=a,r.minWidth=n,r.maxWidth=i)),void 0!==c?c+"":c}function B(l,e){return{get:function(){return l()?void delete this.get:(this.get=e).apply(this,arguments)}}}function G(l){for(var e=l[0].toUpperCase()+l.slice(1),t=ye.length;t--;)if((l=ye[t]+e)in ve)return l}function F(l){var e=Tl.cssProps[l]||be[l];return e||(l in ve?l:be[l]=G(l)||l)}function _(l,e,t){var a=Wl.exec(e);return a?Math.max(0,a[2]-(t||0))+(a[3]||"px"):e}function K(l,e,t,a,n,i){var c="width"===e?1:0,r=0,o=0;if(t===(a?"border":"content"))return 0;for(;c<4;c+=2)"margin"===t&&(o+=Tl.css(l,t+Xl[c],!0,n)),a?("content"===t&&(o-=Tl.css(l,"padding"+Xl[c],!0,n)),"margin"!==t&&(o-=Tl.css(l,"border"+Xl[c]+"Width",!0,n))):(o+=Tl.css(l,"padding"+Xl[c],!0,n),"padding"!==t?o+=Tl.css(l,"border"+Xl[c]+"Width",!0,n):r+=Tl.css(l,"border"+Xl[c]+"Width",!0,n));return!a&&i>=0&&(o+=Math.max(0,Math.ceil(l["offset"+e[0].toUpperCase()+e.slice(1)]-i-o-r-.5))||0),o}function q(l,e,t){var a=fe(l),n=!xl.boxSizingReliable()||t,i=n&&"border-box"===Tl.css(l,"boxSizing",!1,a),c=i,r=V(l,e,a),o="offset"+e[0].toUpperCase()+e.slice(1);if(de.test(r)){if(!t)return r;r="auto"}return(!xl.boxSizingReliable()&&i||"auto"===r||!parseFloat(r)&&"inline"===Tl.css(l,"display",!1,a))&&l.getClientRects().length&&(i="border-box"===Tl.css(l,"boxSizing",!1,a),(c=o in l)&&(r=l[o])),(r=parseFloat(r)||0)+K(l,e,t||(i?"border":"content"),c,a,r)+"px"}function $(l,e,t,a,n){return new $.prototype.init(l,e,t,a,n)}function Y(){Te&&(!1===Ml.hidden&&t.requestAnimationFrame?t.requestAnimationFrame(Y):t.setTimeout(Y,Tl.fx.interval),Tl.fx.tick())}function W(){return t.setTimeout(function(){Ee=void 0}),Ee=Date.now()}function X(l,e){var t,a=0,n={height:l};for(e=e?1:0;a<4;a+=2-e)t=Xl[a],n["margin"+t]=n["padding"+t]=l;return e&&(n.opacity=n.width=l),n}function J(l,e,t){for(var a,n=(el.tweeners[e]||[]).concat(el.tweeners["*"]),i=0,c=n.length;i<c;i++)if(a=n[i].call(t,e,l))return a}function Q(l,e,t){var a,n,i,c,r,o,s,h,p="width"in e||"height"in e,M=this,u={},Z=l.style,m=l.nodeType&&ee(l),d=_l.get(l,"fxshow");t.queue||(c=Tl._queueHooks(l,"fx"),null==c.unqueued&&(c.unqueued=0,r=c.empty.fire,c.empty.fire=function(){c.unqueued||r()}),c.unqueued++,M.always(function(){M.always(function(){c.unqueued--,Tl.queue(l,"fx").length||c.empty.fire()})}));for(a in e)if(n=e[a],ke.test(n)){if(delete e[a],i=i||"toggle"===n,n===(m?"hide":"show")){if("show"!==n||!d||void 0===d[a])continue;m=!0}u[a]=d&&d[a]||Tl.style(l,a)}if((o=!Tl.isEmptyObject(e))||!Tl.isEmptyObject(u)){p&&1===l.nodeType&&(t.overflow=[Z.overflow,Z.overflowX,Z.overflowY],s=d&&d.display,null==s&&(s=_l.get(l,"display")),h=Tl.css(l,"display"),"none"===h&&(s?h=s:(w([l],!0),s=l.style.display||s,h=Tl.css(l,"display"),w([l]))),("inline"===h||"inline-block"===h&&null!=s)&&"none"===Tl.css(l,"float")&&(o||(M.done(function(){Z.display=s}),null==s&&(h=Z.display,s="none"===h?"":h)),Z.display="inline-block")),t.overflow&&(Z.overflow="hidden",M.always(function(){Z.overflow=t.overflow[0],Z.overflowX=t.overflow[1],Z.overflowY=t.overflow[2]})),o=!1;for(a in u)o||(d?"hidden"in d&&(m=d.hidden):d=_l.access(l,"fxshow",{display:s}),i&&(d.hidden=!m),m&&w([l],!0),M.done(function(){m||w([l]),_l.remove(l,"fxshow");for(a in u)Tl.style(l,a,u[a])})),o=J(m?d[a]:0,a,M),a in d||(d[a]=o.start,m&&(o.end=o.start,o.start=0))}}function ll(l,e){var t,a,n,i,c;for(t in l)if(a=g(t),n=e[a],i=l[t],Array.isArray(i)&&(n=i[1],i=l[t]=i[0]),t!==a&&(l[a]=i,delete l[t]),(c=Tl.cssHooks[a])&&"expand"in c){i=c.expand(i),delete l[a];for(t in i)t in l||(l[t]=i[t],e[t]=n)}else e[a]=n}function el(l,e,t){var a,n,i=0,c=el.prefilters.length,r=Tl.Deferred().always(function(){delete o.elem}),o=function(){if(n)return!1;for(var e=Ee||W(),t=Math.max(0,s.startTime+s.duration-e),a=t/s.duration||0,i=1-a,c=0,o=s.tweens.length;c<o;c++)s.tweens[c].run(i);return r.notifyWith(l,[s,i,t]),i<1&&o?t:(o||r.notifyWith(l,[s,1,0]),r.resolveWith(l,[s]),!1)},s=r.promise({elem:l,props:Tl.extend({},e),opts:Tl.extend(!0,{specialEasing:{},easing:Tl.easing._default},t),originalProperties:e,originalOptions:t,startTime:Ee||W(),duration:t.duration,tweens:[],createTween:function(e,t){var a=Tl.Tween(l,s.opts,e,t,s.opts.specialEasing[e]||s.opts.easing);return s.tweens.push(a),a},stop:function(e){var t=0,a=e?s.tweens.length:0;if(n)return this;for(n=!0;t<a;t++)s.tweens[t].run(1);return e?(r.notifyWith(l,[s,1,0]),r.resolveWith(l,[s,e])):r.rejectWith(l,[s,e]),this}}),h=s.props;for(ll(h,s.opts.specialEasing);i<c;i++)if(a=el.prefilters[i].call(s,l,h,s.opts))return wl(a.stop)&&(Tl._queueHooks(s.elem,s.opts.queue).stop=a.stop.bind(a)),a;return Tl.map(h,J,s),wl(s.opts.start)&&s.opts.start.call(l,s),s.progress(s.opts.progress).done(s.opts.done,s.opts.complete).fail(s.opts.fail).always(s.opts.always),Tl.fx.timer(Tl.extend(o,{elem:l,anim:s,queue:s.opts.queue})),s}function tl(l){return(l.match(Pl)||[]).join(" ")}function al(l){return l.getAttribute&&l.getAttribute("class")||""}function nl(l){return Array.isArray(l)?l:"string"===typeof l?l.match(Pl)||[]:[]}function il(l,e,t,a){var n;if(Array.isArray(e))Tl.each(e,function(e,n){t||Ue.test(l)?a(l,n):il(l+"["+("object"===typeof n&&null!=n?e:"")+"]",n,t,a)});else if(t||"object"!==r(e))a(l,e);else for(n in e)il(l+"["+n+"]",e[n],t,a)}function cl(l){return function(e,t){"string"!==typeof e&&(t=e,e="*");var a,n=0,i=e.toLowerCase().match(Pl)||[];if(wl(t))for(;a=i[n++];)"+"===a[0]?(a=a.slice(1)||"*",(l[a]=l[a]||[]).unshift(t)):(l[a]=l[a]||[]).push(t)}}function rl(l,e,t,a){function n(r){var o;return i[r]=!0,Tl.each(l[r]||[],function(l,r){var s=r(e,t,a);return"string"!==typeof s||c||i[s]?c?!(o=s):void 0:(e.dataTypes.unshift(s),n(s),!1)}),o}var i={},c=l===Je;return n(e.dataTypes[0])||!i["*"]&&n("*")}function ol(l,e){var t,a,n=Tl.ajaxSettings.flatOptions||{};for(t in e)void 0!==e[t]&&((n[t]?l:a||(a={}))[t]=e[t]);return a&&Tl.extend(!0,l,a),l}function sl(l,e,t){for(var a,n,i,c,r=l.contents,o=l.dataTypes;"*"===o[0];)o.shift(),void 0===a&&(a=l.mimeType||e.getResponseHeader("Content-Type"));if(a)for(n in r)if(r[n]&&r[n].test(a)){o.unshift(n);break}if(o[0]in t)i=o[0];else{for(n in t){if(!o[0]||l.converters[n+" "+o[0]]){i=n;break}c||(c=n)}i=i||c}if(i)return i!==o[0]&&o.unshift(i),t[i]}function hl(l,e,t,a){var n,i,c,r,o,s={},h=l.dataTypes.slice();if(h[1])for(c in l.converters)s[c.toLowerCase()]=l.converters[c];for(i=h.shift();i;)if(l.responseFields[i]&&(t[l.responseFields[i]]=e),!o&&a&&l.dataFilter&&(e=l.dataFilter(e,l.dataType)),o=i,i=h.shift())if("*"===i)i=o;else if("*"!==o&&o!==i){if(!(c=s[o+" "+i]||s["* "+i]))for(n in s)if(r=n.split(" "),r[1]===i&&(c=s[o+" "+r[0]]||s["* "+r[0]])){!0===c?c=s[n]:!0!==s[n]&&(i=r[0],h.unshift(r[1]));break}if(!0!==c)if(c&&l.throws)e=c(e);else try{e=c(e)}catch(l){return{state:"parsererror",error:c?l:"No conversion from "+o+" to "+i}}}return{state:"success",data:e}}var pl=[],Ml=t.document,ul=Object.getPrototypeOf,Zl=pl.slice,ml=pl.concat,dl=pl.push,fl=pl.indexOf,gl={},yl=gl.toString,vl=gl.hasOwnProperty,bl=vl.toString,Sl=bl.call(Object),xl={},wl=function(l){return"function"===typeof l&&"number"!==typeof l.nodeType},Cl=function(l){return null!=l&&l===l.window},El={type:!0,src:!0,nonce:!0,noModule:!0},Tl=function(l,e){return new Tl.fn.init(l,e)},kl=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;Tl.fn=Tl.prototype={jquery:"3.4.0",constructor:Tl,length:0,toArray:function(){return Zl.call(this)},get:function(l){return null==l?Zl.call(this):l<0?this[l+this.length]:this[l]},pushStack:function(l){var e=Tl.merge(this.constructor(),l);return e.prevObject=this,e},each:function(l){return Tl.each(this,l)},map:function(l){return this.pushStack(Tl.map(this,function(e,t){return l.call(e,t,e)}))},slice:function(){return this.pushStack(Zl.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(l){var e=this.length,t=+l+(l<0?e:0);return this.pushStack(t>=0&&t<e?[this[t]]:[])},end:function(){return this.prevObject||this.constructor()},push:dl,sort:pl.sort,splice:pl.splice},Tl.extend=Tl.fn.extend=function(){var l,e,t,a,n,i,c=arguments[0]||{},r=1,o=arguments.length,s=!1;for("boolean"===typeof c&&(s=c,c=arguments[r]||{},r++),"object"===typeof c||wl(c)||(c={}),r===o&&(c=this,r--);r<o;r++)if(null!=(l=arguments[r]))for(e in l)a=l[e],"__proto__"!==e&&c!==a&&(s&&a&&(Tl.isPlainObject(a)||(n=Array.isArray(a)))?(t=c[e],i=n&&!Array.isArray(t)?[]:n||Tl.isPlainObject(t)?t:{},n=!1,c[e]=Tl.extend(s,i,a)):void 0!==a&&(c[e]=a));return c},Tl.extend({expando:"jQuery"+("3.4.0"+Math.random()).replace(/\D/g,""),isReady:!0,error:function(l){throw new Error(l)},noop:function(){},isPlainObject:function(l){var e,t;return!(!l||"[object Object]"!==yl.call(l))&&(!(e=ul(l))||"function"===typeof(t=vl.call(e,"constructor")&&e.constructor)&&bl.call(t)===Sl)},isEmptyObject:function(l){var e;for(e in l)return!1;return!0},globalEval:function(l,e){c(l,{nonce:e&&e.nonce})},each:function(l,e){var t,a=0;if(o(l))for(t=l.length;a<t&&!1!==e.call(l[a],a,l[a]);a++);else for(a in l)if(!1===e.call(l[a],a,l[a]))break;return l},trim:function(l){return null==l?"":(l+"").replace(kl,"")},makeArray:function(l,e){var t=e||[];return null!=l&&(o(Object(l))?Tl.merge(t,"string"===typeof l?[l]:l):dl.call(t,l)),t},inArray:function(l,e,t){return null==e?-1:fl.call(e,l,t)},merge:function(l,e){for(var t=+e.length,a=0,n=l.length;a<t;a++)l[n++]=e[a];return l.length=n,l},grep:function(l,e,t){for(var a=[],n=0,i=l.length,c=!t;n<i;n++)!e(l[n],n)!==c&&a.push(l[n]);return a},map:function(l,e,t){var a,n,i=0,c=[];if(o(l))for(a=l.length;i<a;i++)null!=(n=e(l[i],i,t))&&c.push(n);else for(i in l)null!=(n=e(l[i],i,t))&&c.push(n);return ml.apply([],c)},guid:1,support:xl}),"function"===typeof Symbol&&(Tl.fn[Symbol.iterator]=pl[Symbol.iterator]),Tl.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(l,e){gl["[object "+e+"]"]=e.toLowerCase()});var zl=function(l){function e(l,e,t,a){var n,i,c,r,o,h,M,u=e&&e.ownerDocument,Z=e?e.nodeType:9;if(t=t||[],"string"!==typeof l||!l||1!==Z&&9!==Z&&11!==Z)return t;if(!a&&((e?e.ownerDocument||e:I)!==R&&A(e),e=e||R,L)){if(11!==Z&&(o=fl.exec(l)))if(n=o[1]){if(9===Z){if(!(c=e.getElementById(n)))return t;if(c.id===n)return t.push(c),t}else if(u&&(c=u.getElementById(n))&&H(e,c)&&c.id===n)return t.push(c),t}else{if(o[2])return X.apply(t,e.getElementsByTagName(l)),t;if((n=o[3])&&v.getElementsByClassName&&e.getElementsByClassName)return X.apply(t,e.getElementsByClassName(n)),t}if(v.qsa&&!_[l+" "]&&(!j||!j.test(l))&&(1!==Z||"object"!==e.nodeName.toLowerCase())){if(M=l,u=e,1===Z&&sl.test(l)){for((r=e.getAttribute("id"))?r=r.replace(bl,Sl):e.setAttribute("id",r=P),h=w(l),i=h.length;i--;)h[i]="#"+r+" "+p(h[i]);M=h.join(","),u=gl.test(l)&&s(e.parentNode)||e}try{return X.apply(t,u.querySelectorAll(M)),t}catch(e){_(l,!0)}finally{r===P&&e.removeAttribute("id")}}}return E(l.replace(cl,"$1"),e,t,a)}function t(){function l(t,a){return e.push(t+" ")>b.cacheLength&&delete l[e.shift()],l[t+" "]=a}var e=[];return l}function a(l){return l[P]=!0,l}function n(l){var e=R.createElement("fieldset");try{return!!l(e)}catch(l){return!1}finally{e.parentNode&&e.parentNode.removeChild(e),e=null}}function i(l,e){for(var t=l.split("|"),a=t.length;a--;)b.attrHandle[t[a]]=e}function c(l,e){var t=e&&l,a=t&&1===l.nodeType&&1===e.nodeType&&l.sourceIndex-e.sourceIndex;if(a)return a;if(t)for(;t=t.nextSibling;)if(t===e)return-1;return l?1:-1}function r(l){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===l:e.disabled===l:e.isDisabled===l||e.isDisabled!==!l&&wl(e)===l:e.disabled===l:"label"in e&&e.disabled===l}}function o(l){return a(function(e){return e=+e,a(function(t,a){for(var n,i=l([],t.length,e),c=i.length;c--;)t[n=i[c]]&&(t[n]=!(a[n]=t[n]))})})}function s(l){return l&&"undefined"!==typeof l.getElementsByTagName&&l}function h(){}function p(l){for(var e=0,t=l.length,a="";e<t;e++)a+=l[e].value;return a}function M(l,e,t){var a=e.dir,n=e.next,i=n||a,c=t&&"parentNode"===i,r=V++;return e.first?function(e,t,n){for(;e=e[a];)if(1===e.nodeType||c)return l(e,t,n);return!1}:function(e,t,o){var s,h,p,M=[U,r];if(o){for(;e=e[a];)if((1===e.nodeType||c)&&l(e,t,o))return!0}else for(;e=e[a];)if(1===e.nodeType||c)if(p=e[P]||(e[P]={}),h=p[e.uniqueID]||(p[e.uniqueID]={}),n&&n===e.nodeName.toLowerCase())e=e[a]||e;else{if((s=h[i])&&s[0]===U&&s[1]===r)return M[2]=s[2];if(h[i]=M,M[2]=l(e,t,o))return!0}return!1}}function u(l){return l.length>1?function(e,t,a){for(var n=l.length;n--;)if(!l[n](e,t,a))return!1;return!0}:l[0]}function Z(l,t,a){for(var n=0,i=t.length;n<i;n++)e(l,t[n],a);return a}function m(l,e,t,a,n){for(var i,c=[],r=0,o=l.length,s=null!=e;r<o;r++)(i=l[r])&&(t&&!t(i,a,n)||(c.push(i),s&&e.push(r)));return c}function d(l,e,t,n,i,c){return n&&!n[P]&&(n=d(n)),i&&!i[P]&&(i=d(i,c)),a(function(a,c,r,o){var s,h,p,M=[],u=[],d=c.length,f=a||Z(e||"*",r.nodeType?[r]:r,[]),g=!l||!a&&e?f:m(f,M,l,r,o),y=t?i||(a?l:d||n)?[]:c:g;if(t&&t(g,y,r,o),n)for(s=m(y,u),n(s,[],r,o),h=s.length;h--;)(p=s[h])&&(y[u[h]]=!(g[u[h]]=p));if(a){if(i||l){if(i){for(s=[],h=y.length;h--;)(p=y[h])&&s.push(g[h]=p);i(null,y=[],s,o)}for(h=y.length;h--;)(p=y[h])&&(s=i?Q(a,p):M[h])>-1&&(a[s]=!(c[s]=p))}}else y=m(y===c?y.splice(d,y.length):y),i?i(null,c,y,o):X.apply(c,y)})}function f(l){for(var e,t,a,n=l.length,i=b.relative[l[0].type],c=i||b.relative[" "],r=i?1:0,o=M(function(l){return l===e},c,!0),s=M(function(l){return Q(e,l)>-1},c,!0),h=[function(l,t,a){var n=!i&&(a||t!==T)||((e=t).nodeType?o(l,t,a):s(l,t,a));return e=null,n}];r<n;r++)if(t=b.relative[l[r].type])h=[M(u(h),t)];else{if(t=b.filter[l[r].type].apply(null,l[r].matches),t[P]){for(a=++r;a<n&&!b.relative[l[a].type];a++);return d(r>1&&u(h),r>1&&p(l.slice(0,r-1).concat({value:" "===l[r-2].type?"*":""})).replace(cl,"$1"),t,r<a&&f(l.slice(r,a)),a<n&&f(l=l.slice(a)),a<n&&p(l))}h.push(t)}return u(h)}function g(l,t){var n=t.length>0,i=l.length>0,c=function(a,c,r,o,s){var h,p,M,u=0,Z="0",d=a&&[],f=[],g=T,y=a||i&&b.find.TAG("*",s),v=U+=null==g?1:Math.random()||.1,S=y.length;for(s&&(T=c===R||c||s);Z!==S&&null!=(h=y[Z]);Z++){if(i&&h){for(p=0,c||h.ownerDocument===R||(A(h),r=!L);M=l[p++];)if(M(h,c||R,r)){o.push(h);break}s&&(U=v)}n&&((h=!M&&h)&&u--,a&&d.push(h))}if(u+=Z,n&&Z!==u){for(p=0;M=t[p++];)M(d,f,c,r);if(a){if(u>0)for(;Z--;)d[Z]||f[Z]||(f[Z]=Y.call(o));f=m(f)}X.apply(o,f),s&&!a&&f.length>0&&u+t.length>1&&e.uniqueSort(o)}return s&&(U=v,T=g),d};return n?a(c):c}var y,v,b,S,x,w,C,E,T,k,z,A,R,N,L,j,D,O,H,P="sizzle"+1*new Date,I=l.document,U=0,V=0,B=t(),G=t(),F=t(),_=t(),K=function(l,e){return l===e&&(z=!0),0},q={}.hasOwnProperty,$=[],Y=$.pop,W=$.push,X=$.push,J=$.slice,Q=function(l,e){for(var t=0,a=l.length;t<a;t++)if(l[t]===e)return t;return-1},ll="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",el="[\\x20\\t\\r\\n\\f]",tl="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",al="\\["+el+"*("+tl+")(?:"+el+"*([*^$|!~]?=)"+el+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+tl+"))|)"+el+"*\\]",nl=":("+tl+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+al+")*)|.*)\\)|)",il=new RegExp(el+"+","g"),cl=new RegExp("^"+el+"+|((?:^|[^\\\\])(?:\\\\.)*)"+el+"+$","g"),rl=new RegExp("^"+el+"*,"+el+"*"),ol=new RegExp("^"+el+"*([>+~]|"+el+")"+el+"*"),sl=new RegExp(el+"|>"),hl=new RegExp(nl),pl=new RegExp("^"+tl+"$"),Ml={ID:new RegExp("^#("+tl+")"),CLASS:new RegExp("^\\.("+tl+")"),TAG:new RegExp("^("+tl+"|[*])"),ATTR:new RegExp("^"+al),PSEUDO:new RegExp("^"+nl),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+el+"*(even|odd|(([+-]|)(\\d*)n|)"+el+"*(?:([+-]|)"+el+"*(\\d+)|))"+el+"*\\)|)","i"),bool:new RegExp("^(?:"+ll+")$","i"),needsContext:new RegExp("^"+el+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+el+"*((?:-\\d)?\\d*)"+el+"*\\)|)(?=[^-]|$)","i")},ul=/HTML$/i,Zl=/^(?:input|select|textarea|button)$/i,ml=/^h\d$/i,dl=/^[^{]+\{\s*\[native \w/,fl=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,gl=/[+~]/,yl=new RegExp("\\\\([\\da-f]{1,6}"+el+"?|("+el+")|.)","ig"),vl=function(l,e,t){var a="0x"+e-65536;return a!==a||t?e:a<0?String.fromCharCode(a+65536):String.fromCharCode(a>>10|55296,1023&a|56320)},bl=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,Sl=function(l,e){return e?"\0"===l?"\ufffd":l.slice(0,-1)+"\\"+l.charCodeAt(l.length-1).toString(16)+" ":"\\"+l},xl=function(){A()},wl=M(function(l){return!0===l.disabled&&"fieldset"===l.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{X.apply($=J.call(I.childNodes),I.childNodes),$[I.childNodes.length].nodeType}catch(l){X={apply:$.length?function(l,e){W.apply(l,J.call(e))}:function(l,e){for(var t=l.length,a=0;l[t++]=e[a++];);l.length=t-1}}}v=e.support={},x=e.isXML=function(l){var e=l.namespaceURI,t=(l.ownerDocument||l).documentElement;return!ul.test(e||t&&t.nodeName||"HTML")},A=e.setDocument=function(l){var e,t,a=l?l.ownerDocument||l:I;return a!==R&&9===a.nodeType&&a.documentElement?(R=a,N=R.documentElement,L=!x(R),I!==R&&(t=R.defaultView)&&t.top!==t&&(t.addEventListener?t.addEventListener("unload",xl,!1):t.attachEvent&&t.attachEvent("onunload",xl)),v.attributes=n(function(l){return l.className="i",!l.getAttribute("className")}),v.getElementsByTagName=n(function(l){return l.appendChild(R.createComment("")),!l.getElementsByTagName("*").length}),v.getElementsByClassName=dl.test(R.getElementsByClassName),v.getById=n(function(l){return N.appendChild(l).id=P,!R.getElementsByName||!R.getElementsByName(P).length}),v.getById?(b.filter.ID=function(l){var e=l.replace(yl,vl);return function(l){return l.getAttribute("id")===e}},b.find.ID=function(l,e){if("undefined"!==typeof e.getElementById&&L){var t=e.getElementById(l);return t?[t]:[]}}):(b.filter.ID=function(l){var e=l.replace(yl,vl);return function(l){var t="undefined"!==typeof l.getAttributeNode&&l.getAttributeNode("id");return t&&t.value===e}},b.find.ID=function(l,e){if("undefined"!==typeof e.getElementById&&L){var t,a,n,i=e.getElementById(l);if(i){if((t=i.getAttributeNode("id"))&&t.value===l)return[i];for(n=e.getElementsByName(l),a=0;i=n[a++];)if((t=i.getAttributeNode("id"))&&t.value===l)return[i]}return[]}}),b.find.TAG=v.getElementsByTagName?function(l,e){return"undefined"!==typeof e.getElementsByTagName?e.getElementsByTagName(l):v.qsa?e.querySelectorAll(l):void 0}:function(l,e){var t,a=[],n=0,i=e.getElementsByTagName(l);if("*"===l){for(;t=i[n++];)1===t.nodeType&&a.push(t);return a}return i},b.find.CLASS=v.getElementsByClassName&&function(l,e){if("undefined"!==typeof e.getElementsByClassName&&L)return e.getElementsByClassName(l)},D=[],j=[],(v.qsa=dl.test(R.querySelectorAll))&&(n(function(l){N.appendChild(l).innerHTML="<a id='"+P+"'></a><select id='"+P+"-\r\\' msallowcapture=''><option selected=''></option></select>",l.querySelectorAll("[msallowcapture^='']").length&&j.push("[*^$]="+el+"*(?:''|\"\")"),l.querySelectorAll("[selected]").length||j.push("\\["+el+"*(?:value|"+ll+")"),l.querySelectorAll("[id~="+P+"-]").length||j.push("~="),l.querySelectorAll(":checked").length||j.push(":checked"),l.querySelectorAll("a#"+P+"+*").length||j.push(".#.+[+~]")}),n(function(l){l.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var e=R.createElement("input");e.setAttribute("type","hidden"),l.appendChild(e).setAttribute("name","D"),l.querySelectorAll("[name=d]").length&&j.push("name"+el+"*[*^$|!~]?="),2!==l.querySelectorAll(":enabled").length&&j.push(":enabled",":disabled"),N.appendChild(l).disabled=!0,2!==l.querySelectorAll(":disabled").length&&j.push(":enabled",":disabled"),l.querySelectorAll("*,:x"),j.push(",.*:")})),(v.matchesSelector=dl.test(O=N.matches||N.webkitMatchesSelector||N.mozMatchesSelector||N.oMatchesSelector||N.msMatchesSelector))&&n(function(l){v.disconnectedMatch=O.call(l,"*"),O.call(l,"[s!='']:x"),D.push("!=",nl)}),j=j.length&&new RegExp(j.join("|")),D=D.length&&new RegExp(D.join("|")),e=dl.test(N.compareDocumentPosition),H=e||dl.test(N.contains)?function(l,e){var t=9===l.nodeType?l.documentElement:l,a=e&&e.parentNode;return l===a||!(!a||1!==a.nodeType||!(t.contains?t.contains(a):l.compareDocumentPosition&&16&l.compareDocumentPosition(a)))}:function(l,e){if(e)for(;e=e.parentNode;)if(e===l)return!0;return!1},K=e?function(l,e){if(l===e)return z=!0,0;var t=!l.compareDocumentPosition-!e.compareDocumentPosition;return t||(t=(l.ownerDocument||l)===(e.ownerDocument||e)?l.compareDocumentPosition(e):1,1&t||!v.sortDetached&&e.compareDocumentPosition(l)===t?l===R||l.ownerDocument===I&&H(I,l)?-1:e===R||e.ownerDocument===I&&H(I,e)?1:k?Q(k,l)-Q(k,e):0:4&t?-1:1)}:function(l,e){if(l===e)return z=!0,0;var t,a=0,n=l.parentNode,i=e.parentNode,r=[l],o=[e];if(!n||!i)return l===R?-1:e===R?1:n?-1:i?1:k?Q(k,l)-Q(k,e):0;if(n===i)return c(l,e);for(t=l;t=t.parentNode;)r.unshift(t);for(t=e;t=t.parentNode;)o.unshift(t);for(;r[a]===o[a];)a++;return a?c(r[a],o[a]):r[a]===I?-1:o[a]===I?1:0},R):R},e.matches=function(l,t){return e(l,null,null,t)},e.matchesSelector=function(l,t){if((l.ownerDocument||l)!==R&&A(l),v.matchesSelector&&L&&!_[t+" "]&&(!D||!D.test(t))&&(!j||!j.test(t)))try{var a=O.call(l,t);if(a||v.disconnectedMatch||l.document&&11!==l.document.nodeType)return a}catch(l){_(t,!0)}return e(t,R,null,[l]).length>0},e.contains=function(l,e){return(l.ownerDocument||l)!==R&&A(l),H(l,e)},e.attr=function(l,e){(l.ownerDocument||l)!==R&&A(l);var t=b.attrHandle[e.toLowerCase()],a=t&&q.call(b.attrHandle,e.toLowerCase())?t(l,e,!L):void 0;return void 0!==a?a:v.attributes||!L?l.getAttribute(e):(a=l.getAttributeNode(e))&&a.specified?a.value:null},e.escape=function(l){return(l+"").replace(bl,Sl)},e.error=function(l){throw new Error("Syntax error, unrecognized expression: "+l)},e.uniqueSort=function(l){var e,t=[],a=0,n=0;if(z=!v.detectDuplicates,k=!v.sortStable&&l.slice(0),l.sort(K),z){for(;e=l[n++];)e===l[n]&&(a=t.push(n));for(;a--;)l.splice(t[a],1)}return k=null,l},S=e.getText=function(l){var e,t="",a=0,n=l.nodeType;if(n){if(1===n||9===n||11===n){if("string"===typeof l.textContent)return l.textContent;for(l=l.firstChild;l;l=l.nextSibling)t+=S(l)}else if(3===n||4===n)return l.nodeValue}else for(;e=l[a++];)t+=S(e);return t},b=e.selectors={cacheLength:50,createPseudo:a,match:Ml,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(l){return l[1]=l[1].replace(yl,vl),l[3]=(l[3]||l[4]||l[5]||"").replace(yl,vl),"~="===l[2]&&(l[3]=" "+l[3]+" "),l.slice(0,4)},CHILD:function(l){return l[1]=l[1].toLowerCase(),"nth"===l[1].slice(0,3)?(l[3]||e.error(l[0]),l[4]=+(l[4]?l[5]+(l[6]||1):2*("even"===l[3]||"odd"===l[3])),l[5]=+(l[7]+l[8]||"odd"===l[3])):l[3]&&e.error(l[0]),l},PSEUDO:function(l){var e,t=!l[6]&&l[2];return Ml.CHILD.test(l[0])?null:(l[3]?l[2]=l[4]||l[5]||"":t&&hl.test(t)&&(e=w(t,!0))&&(e=t.indexOf(")",t.length-e)-t.length)&&(l[0]=l[0].slice(0,e),l[2]=t.slice(0,e)),l.slice(0,3))}},filter:{TAG:function(l){var e=l.replace(yl,vl).toLowerCase();return"*"===l?function(){return!0}:function(l){return l.nodeName&&l.nodeName.toLowerCase()===e}},CLASS:function(l){var e=B[l+" "];return e||(e=new RegExp("(^|"+el+")"+l+"("+el+"|$)"))&&B(l,function(l){return e.test("string"===typeof l.className&&l.className||"undefined"!==typeof l.getAttribute&&l.getAttribute("class")||"")})},ATTR:function(l,t,a){return function(n){var i=e.attr(n,l);return null==i?"!="===t:!t||(i+="","="===t?i===a:"!="===t?i!==a:"^="===t?a&&0===i.indexOf(a):"*="===t?a&&i.indexOf(a)>-1:"$="===t?a&&i.slice(-a.length)===a:"~="===t?(" "+i.replace(il," ")+" ").indexOf(a)>-1:"|="===t&&(i===a||i.slice(0,a.length+1)===a+"-"))}},CHILD:function(l,e,t,a,n){var i="nth"!==l.slice(0,3),c="last"!==l.slice(-4),r="of-type"===e;return 1===a&&0===n?function(l){return!!l.parentNode}:function(e,t,o){var s,h,p,M,u,Z,m=i!==c?"nextSibling":"previousSibling",d=e.parentNode,f=r&&e.nodeName.toLowerCase(),g=!o&&!r,y=!1;if(d){if(i){for(;m;){for(M=e;M=M[m];)if(r?M.nodeName.toLowerCase()===f:1===M.nodeType)return!1;Z=m="only"===l&&!Z&&"nextSibling"}return!0}if(Z=[c?d.firstChild:d.lastChild],c&&g){for(M=d,p=M[P]||(M[P]={}),h=p[M.uniqueID]||(p[M.uniqueID]={}),s=h[l]||[],u=s[0]===U&&s[1],y=u&&s[2],M=u&&d.childNodes[u];M=++u&&M&&M[m]||(y=u=0)||Z.pop();)if(1===M.nodeType&&++y&&M===e){h[l]=[U,u,y];break}}else if(g&&(M=e,p=M[P]||(M[P]={}),h=p[M.uniqueID]||(p[M.uniqueID]={}),s=h[l]||[],u=s[0]===U&&s[1],y=u),!1===y)for(;(M=++u&&M&&M[m]||(y=u=0)||Z.pop())&&((r?M.nodeName.toLowerCase()!==f:1!==M.nodeType)||!++y||(g&&(p=M[P]||(M[P]={}),h=p[M.uniqueID]||(p[M.uniqueID]={}),h[l]=[U,y]),M!==e)););return(y-=n)===a||y%a===0&&y/a>=0}}},PSEUDO:function(l,t){var n,i=b.pseudos[l]||b.setFilters[l.toLowerCase()]||e.error("unsupported pseudo: "+l);return i[P]?i(t):i.length>1?(n=[l,l,"",t],b.setFilters.hasOwnProperty(l.toLowerCase())?a(function(l,e){for(var a,n=i(l,t),c=n.length;c--;)a=Q(l,n[c]),l[a]=!(e[a]=n[c])}):function(l){return i(l,0,n)}):i}},pseudos:{not:a(function(l){var e=[],t=[],n=C(l.replace(cl,"$1"));return n[P]?a(function(l,e,t,a){for(var i,c=n(l,null,a,[]),r=l.length;r--;)(i=c[r])&&(l[r]=!(e[r]=i))}):function(l,a,i){return e[0]=l,n(e,null,i,t),e[0]=null,!t.pop()}}),has:a(function(l){return function(t){return e(l,t).length>0}}),contains:a(function(l){return l=l.replace(yl,vl),function(e){return(e.textContent||S(e)).indexOf(l)>-1}}),lang:a(function(l){return pl.test(l||"")||e.error("unsupported lang: "+l),l=l.replace(yl,vl).toLowerCase(),function(e){var t;do{if(t=L?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===l||0===t.indexOf(l+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=l.location&&l.location.hash;return t&&t.slice(1)===e.id},root:function(l){return l===N},focus:function(l){return l===R.activeElement&&(!R.hasFocus||R.hasFocus())&&!!(l.type||l.href||~l.tabIndex)},enabled:r(!1),disabled:r(!0),checked:function(l){var e=l.nodeName.toLowerCase();return"input"===e&&!!l.checked||"option"===e&&!!l.selected},selected:function(l){return l.parentNode&&l.parentNode.selectedIndex,!0===l.selected},empty:function(l){for(l=l.firstChild;l;l=l.nextSibling)if(l.nodeType<6)return!1;return!0},parent:function(l){return!b.pseudos.empty(l)},header:function(l){return ml.test(l.nodeName)},input:function(l){return Zl.test(l.nodeName)},button:function(l){var e=l.nodeName.toLowerCase();return"input"===e&&"button"===l.type||"button"===e},text:function(l){var e;return"input"===l.nodeName.toLowerCase()&&"text"===l.type&&(null==(e=l.getAttribute("type"))||"text"===e.toLowerCase())},first:o(function(){return[0]}),last:o(function(l,e){return[e-1]}),eq:o(function(l,e,t){return[t<0?t+e:t]}),even:o(function(l,e){for(var t=0;t<e;t+=2)l.push(t);return l}),odd:o(function(l,e){for(var t=1;t<e;t+=2)l.push(t);return l}),lt:o(function(l,e,t){for(var a=t<0?t+e:t>e?e:t;--a>=0;)l.push(a);return l}),gt:o(function(l,e,t){for(var a=t<0?t+e:t;++a<e;)l.push(a);return l})}},b.pseudos.nth=b.pseudos.eq;for(y in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[y]=function(l){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===l}}(y);for(y in{submit:!0,reset:!0})b.pseudos[y]=function(l){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===l}}(y);return h.prototype=b.filters=b.pseudos,b.setFilters=new h,w=e.tokenize=function(l,t){var a,n,i,c,r,o,s,h=G[l+" "];if(h)return t?0:h.slice(0);for(r=l,o=[],s=b.preFilter;r;){a&&!(n=rl.exec(r))||(n&&(r=r.slice(n[0].length)||r),o.push(i=[])),a=!1,(n=ol.exec(r))&&(a=n.shift(),i.push({value:a,type:n[0].replace(cl," ")}),r=r.slice(a.length));for(c in b.filter)!(n=Ml[c].exec(r))||s[c]&&!(n=s[c](n))||(a=n.shift(),i.push({value:a,type:c,matches:n}),r=r.slice(a.length));if(!a)break}return t?r.length:r?e.error(l):G(l,o).slice(0)},C=e.compile=function(l,e){var t,a=[],n=[],i=F[l+" "];if(!i){for(e||(e=w(l)),t=e.length;t--;)i=f(e[t]),i[P]?a.push(i):n.push(i);i=F(l,g(n,a)),i.selector=l}return i},E=e.select=function(l,e,t,a){var n,i,c,r,o,h="function"===typeof l&&l,M=!a&&w(l=h.selector||l);if(t=t||[],1===M.length){if(i=M[0]=M[0].slice(0),i.length>2&&"ID"===(c=i[0]).type&&9===e.nodeType&&L&&b.relative[i[1].type]){if(!(e=(b.find.ID(c.matches[0].replace(yl,vl),e)||[])[0]))return t;h&&(e=e.parentNode),l=l.slice(i.shift().value.length)}for(n=Ml.needsContext.test(l)?0:i.length;n--&&(c=i[n],!b.relative[r=c.type]);)if((o=b.find[r])&&(a=o(c.matches[0].replace(yl,vl),gl.test(i[0].type)&&s(e.parentNode)||e))){if(i.splice(n,1),!(l=a.length&&p(i)))return X.apply(t,a),t;break}}return(h||C(l,M))(a,e,!L,t,!e||gl.test(l)&&s(e.parentNode)||e),t},v.sortStable=P.split("").sort(K).join("")===P,v.detectDuplicates=!!z,A(),v.sortDetached=n(function(l){return 1&l.compareDocumentPosition(R.createElement("fieldset"))}),n(function(l){return l.innerHTML="<a href='#'></a>","#"===l.firstChild.getAttribute("href")})||i("type|href|height|width",function(l,e,t){if(!t)return l.getAttribute(e,"type"===e.toLowerCase()?1:2)}),v.attributes&&n(function(l){return l.innerHTML="<input/>",l.firstChild.setAttribute("value",""),""===l.firstChild.getAttribute("value")})||i("value",function(l,e,t){if(!t&&"input"===l.nodeName.toLowerCase())return l.defaultValue}),n(function(l){return null==l.getAttribute("disabled")})||i(ll,function(l,e,t){var a;if(!t)return!0===l[e]?e.toLowerCase():(a=l.getAttributeNode(e))&&a.specified?a.value:null}),e}(t);Tl.find=zl,Tl.expr=zl.selectors,Tl.expr[":"]=Tl.expr.pseudos,Tl.uniqueSort=Tl.unique=zl.uniqueSort,Tl.text=zl.getText,Tl.isXMLDoc=zl.isXML,Tl.contains=zl.contains,Tl.escapeSelector=zl.escape;var Al=function(l,e,t){for(var a=[],n=void 0!==t;(l=l[e])&&9!==l.nodeType;)if(1===l.nodeType){if(n&&Tl(l).is(t))break;a.push(l)}return a},Rl=function(l,e){for(var t=[];l;l=l.nextSibling)1===l.nodeType&&l!==e&&t.push(l);return t},Nl=Tl.expr.match.needsContext,Ll=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;Tl.filter=function(l,e,t){var a=e[0];return t&&(l=":not("+l+")"),1===e.length&&1===a.nodeType?Tl.find.matchesSelector(a,l)?[a]:[]:Tl.find.matches(l,Tl.grep(e,function(l){return 1===l.nodeType}))},Tl.fn.extend({find:function(l){var e,t,a=this.length,n=this;if("string"!==typeof l)return this.pushStack(Tl(l).filter(function(){for(e=0;e<a;e++)if(Tl.contains(n[e],this))return!0}));for(t=this.pushStack([]),e=0;e<a;e++)Tl.find(l,n[e],t);return a>1?Tl.uniqueSort(t):t},filter:function(l){return this.pushStack(h(this,l||[],!1))},not:function(l){return this.pushStack(h(this,l||[],!0))},is:function(l){return!!h(this,"string"===typeof l&&Nl.test(l)?Tl(l):l||[],!1).length}});var jl,Dl=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(Tl.fn.init=function(l,e,t){var a,n;if(!l)return this;if(t=t||jl,"string"===typeof l){if(!(a="<"===l[0]&&">"===l[l.length-1]&&l.length>=3?[null,l,null]:Dl.exec(l))||!a[1]&&e)return!e||e.jquery?(e||t).find(l):this.constructor(e).find(l);if(a[1]){if(e=e instanceof Tl?e[0]:e,Tl.merge(this,Tl.parseHTML(a[1],e&&e.nodeType?e.ownerDocument||e:Ml,!0)),Ll.test(a[1])&&Tl.isPlainObject(e))for(a in e)wl(this[a])?this[a](e[a]):this.attr(a,e[a]);return this}return n=Ml.getElementById(a[2]),n&&(this[0]=n,this.length=1),this}return l.nodeType?(this[0]=l,this.length=1,this):wl(l)?void 0!==t.ready?t.ready(l):l(Tl):Tl.makeArray(l,this)}).prototype=Tl.fn,jl=Tl(Ml);var Ol=/^(?:parents|prev(?:Until|All))/,Hl={children:!0,contents:!0,next:!0,prev:!0};Tl.fn.extend({has:function(l){var e=Tl(l,this),t=e.length;return this.filter(function(){for(var l=0;l<t;l++)if(Tl.contains(this,e[l]))return!0})},closest:function(l,e){var t,a=0,n=this.length,i=[],c="string"!==typeof l&&Tl(l);if(!Nl.test(l))for(;a<n;a++)for(t=this[a];t&&t!==e;t=t.parentNode)if(t.nodeType<11&&(c?c.index(t)>-1:1===t.nodeType&&Tl.find.matchesSelector(t,l))){i.push(t);break}return this.pushStack(i.length>1?Tl.uniqueSort(i):i)},index:function(l){return l?"string"===typeof l?fl.call(Tl(l),this[0]):fl.call(this,l.jquery?l[0]:l):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(l,e){return this.pushStack(Tl.uniqueSort(Tl.merge(this.get(),Tl(l,e))))},addBack:function(l){return this.add(null==l?this.prevObject:this.prevObject.filter(l))}}),Tl.each({parent:function(l){var e=l.parentNode;return e&&11!==e.nodeType?e:null},parents:function(l){return Al(l,"parentNode")},parentsUntil:function(l,e,t){return Al(l,"parentNode",t)},next:function(l){return p(l,"nextSibling")},prev:function(l){return p(l,"previousSibling")},nextAll:function(l){return Al(l,"nextSibling")},prevAll:function(l){return Al(l,"previousSibling")},nextUntil:function(l,e,t){return Al(l,"nextSibling",t)},prevUntil:function(l,e,t){return Al(l,"previousSibling",t)},siblings:function(l){return Rl((l.parentNode||{}).firstChild,l)},children:function(l){return Rl(l.firstChild)},contents:function(l){return"undefined"!==typeof l.contentDocument?l.contentDocument:(s(l,"template")&&(l=l.content||l),Tl.merge([],l.childNodes))}},function(l,e){Tl.fn[l]=function(t,a){var n=Tl.map(this,e,t);return"Until"!==l.slice(-5)&&(a=t),a&&"string"===typeof a&&(n=Tl.filter(a,n)),this.length>1&&(Hl[l]||Tl.uniqueSort(n),Ol.test(l)&&n.reverse()),this.pushStack(n)}});var Pl=/[^\x20\t\r\n\f]+/g;Tl.Callbacks=function(l){l="string"===typeof l?M(l):Tl.extend({},l);var e,t,a,n,i=[],c=[],o=-1,s=function(){for(n=n||l.once,a=e=!0;c.length;o=-1)for(t=c.shift();++o<i.length;)!1===i[o].apply(t[0],t[1])&&l.stopOnFalse&&(o=i.length,t=!1);l.memory||(t=!1),e=!1,n&&(i=t?[]:"")},h={add:function(){return i&&(t&&!e&&(o=i.length-1,c.push(t)),function e(t){Tl.each(t,function(t,a){wl(a)?l.unique&&h.has(a)||i.push(a):a&&a.length&&"string"!==r(a)&&e(a)})}(arguments),t&&!e&&s()),this},remove:function(){return Tl.each(arguments,function(l,e){for(var t;(t=Tl.inArray(e,i,t))>-1;)i.splice(t,1),t<=o&&o--}),this},has:function(l){return l?Tl.inArray(l,i)>-1:i.length>0},empty:function(){return i&&(i=[]),this},disable:function(){return n=c=[],i=t="",this},disabled:function(){return!i},lock:function(){return n=c=[],t||e||(i=t=""),this},locked:function(){return!!n},fireWith:function(l,t){return n||(t=t||[],t=[l,t.slice?t.slice():t],c.push(t),e||s()),this},fire:function(){return h.fireWith(this,arguments),this},fired:function(){return!!a}};return h},Tl.extend({Deferred:function(l){var e=[["notify","progress",Tl.Callbacks("memory"),Tl.Callbacks("memory"),2],["resolve","done",Tl.Callbacks("once memory"),Tl.Callbacks("once memory"),0,"resolved"],["reject","fail",Tl.Callbacks("once memory"),Tl.Callbacks("once memory"),1,"rejected"]],a="pending",n={state:function(){return a},always:function(){return i.done(arguments).fail(arguments),this},catch:function(l){return n.then(null,l)},pipe:function(){var l=arguments;return Tl.Deferred(function(t){Tl.each(e,function(e,a){var n=wl(l[a[4]])&&l[a[4]];i[a[1]](function(){var l=n&&n.apply(this,arguments);l&&wl(l.promise)?l.promise().progress(t.notify).done(t.resolve).fail(t.reject):t[a[0]+"With"](this,n?[l]:arguments)})}),l=null}).promise()},then:function(l,a,n){function i(l,e,a,n){return function(){var r=this,o=arguments,s=function(){var t,s;if(!(l<c)){if((t=a.apply(r,o))===e.promise())throw new TypeError("Thenable self-resolution");s=t&&("object"===typeof t||"function"===typeof t)&&t.then,wl(s)?n?s.call(t,i(c,e,u,n),i(c,e,Z,n)):(c++,s.call(t,i(c,e,u,n),i(c,e,Z,n),i(c,e,u,e.notifyWith))):(a!==u&&(r=void 0,o=[t]),(n||e.resolveWith)(r,o))}},h=n?s:function(){try{s()}catch(t){Tl.Deferred.exceptionHook&&Tl.Deferred.exceptionHook(t,h.stackTrace),l+1>=c&&(a!==Z&&(r=void 0,o=[t]),e.rejectWith(r,o))}};l?h():(Tl.Deferred.getStackHook&&(h.stackTrace=Tl.Deferred.getStackHook()),t.setTimeout(h))}}var c=0;return Tl.Deferred(function(t){e[0][3].add(i(0,t,wl(n)?n:u,t.notifyWith)),e[1][3].add(i(0,t,wl(l)?l:u)),e[2][3].add(i(0,t,wl(a)?a:Z))}).promise()},promise:function(l){return null!=l?Tl.extend(l,n):n}},i={};return Tl.each(e,function(l,t){var c=t[2],r=t[5];n[t[1]]=c.add,r&&c.add(function(){a=r},e[3-l][2].disable,e[3-l][3].disable,e[0][2].lock,e[0][3].lock),c.add(t[3].fire),i[t[0]]=function(){return i[t[0]+"With"](this===i?void 0:this,arguments),this},i[t[0]+"With"]=c.fireWith}),n.promise(i),l&&l.call(i,i),i},when:function(l){var e=arguments.length,t=e,a=Array(t),n=Zl.call(arguments),i=Tl.Deferred(),c=function(l){return function(t){a[l]=this,n[l]=arguments.length>1?Zl.call(arguments):t,--e||i.resolveWith(a,n)}};if(e<=1&&(m(l,i.done(c(t)).resolve,i.reject,!e),"pending"===i.state()||wl(n[t]&&n[t].then)))return i.then();for(;t--;)m(n[t],c(t),i.reject);return i.promise()}});var Il=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;Tl.Deferred.exceptionHook=function(l,e){t.console&&t.console.warn&&l&&Il.test(l.name)&&t.console.warn("jQuery.Deferred exception: "+l.message,l.stack,e)},Tl.readyException=function(l){t.setTimeout(function(){throw l})};var Ul=Tl.Deferred();Tl.fn.ready=function(l){return Ul.then(l).catch(function(l){Tl.readyException(l)}),this},Tl.extend({isReady:!1,readyWait:1,ready:function(l){(!0===l?--Tl.readyWait:Tl.isReady)||(Tl.isReady=!0,!0!==l&&--Tl.readyWait>0||Ul.resolveWith(Ml,[Tl]))}}),Tl.ready.then=Ul.then,"complete"===Ml.readyState||"loading"!==Ml.readyState&&!Ml.documentElement.doScroll?t.setTimeout(Tl.ready):(Ml.addEventListener("DOMContentLoaded",d),t.addEventListener("load",d));var Vl=function(l,e,t,a,n,i,c){var o=0,s=l.length,h=null==t;if("object"===r(t)){n=!0;for(o in t)Vl(l,e,o,t[o],!0,i,c)}else if(void 0!==a&&(n=!0,wl(a)||(c=!0),h&&(c?(e.call(l,a),e=null):(h=e,e=function(l,e,t){return h.call(Tl(l),t)})),e))for(;o<s;o++)e(l[o],t,c?a:a.call(l[o],o,e(l[o],t)));return n?l:h?e.call(l):s?e(l[0],t):i},Bl=/^-ms-/,Gl=/-([a-z])/g,Fl=function(l){return 1===l.nodeType||9===l.nodeType||!+l.nodeType};y.uid=1,y.prototype={cache:function(l){var e=l[this.expando];return e||(e={},Fl(l)&&(l.nodeType?l[this.expando]=e:Object.defineProperty(l,this.expando,{value:e,configurable:!0}))),e},set:function(l,e,t){var a,n=this.cache(l);if("string"===typeof e)n[g(e)]=t;else for(a in e)n[g(a)]=e[a];return n},get:function(l,e){return void 0===e?this.cache(l):l[this.expando]&&l[this.expando][g(e)]},access:function(l,e,t){return void 0===e||e&&"string"===typeof e&&void 0===t?this.get(l,e):(this.set(l,e,t),void 0!==t?t:e)},remove:function(l,e){var t,a=l[this.expando];if(void 0!==a){if(void 0!==e){Array.isArray(e)?e=e.map(g):(e=g(e),e=e in a?[e]:e.match(Pl)||[]),t=e.length;for(;t--;)delete a[e[t]]}(void 0===e||Tl.isEmptyObject(a))&&(l.nodeType?l[this.expando]=void 0:delete l[this.expando])}},hasData:function(l){var e=l[this.expando];return void 0!==e&&!Tl.isEmptyObject(e)}};var _l=new y,Kl=new y,ql=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,$l=/[A-Z]/g;Tl.extend({hasData:function(l){return Kl.hasData(l)||_l.hasData(l)},data:function(l,e,t){return Kl.access(l,e,t)},removeData:function(l,e){Kl.remove(l,e)},_data:function(l,e,t){return _l.access(l,e,t)},_removeData:function(l,e){_l.remove(l,e)}}),Tl.fn.extend({data:function(l,e){var t,a,n,i=this[0],c=i&&i.attributes;if(void 0===l){if(this.length&&(n=Kl.get(i),1===i.nodeType&&!_l.get(i,"hasDataAttrs"))){for(t=c.length;t--;)c[t]&&(a=c[t].name,0===a.indexOf("data-")&&(a=g(a.slice(5)),b(i,a,n[a])));_l.set(i,"hasDataAttrs",!0)}return n}return"object"===typeof l?this.each(function(){Kl.set(this,l)}):Vl(this,function(e){var t;if(i&&void 0===e){if(void 0!==(t=Kl.get(i,l)))return t;if(void 0!==(t=b(i,l)))return t}else this.each(function(){Kl.set(this,l,e)})},null,e,arguments.length>1,null,!0)},removeData:function(l){return this.each(function(){Kl.remove(this,l)})}}),Tl.extend({queue:function(l,e,t){var a;if(l)return e=(e||"fx")+"queue",a=_l.get(l,e),t&&(!a||Array.isArray(t)?a=_l.access(l,e,Tl.makeArray(t)):a.push(t)),a||[]},dequeue:function(l,e){e=e||"fx";var t=Tl.queue(l,e),a=t.length,n=t.shift(),i=Tl._queueHooks(l,e),c=function(){Tl.dequeue(l,e)};"inprogress"===n&&(n=t.shift(),a--),n&&("fx"===e&&t.unshift("inprogress"),delete i.stop,n.call(l,c,i)),!a&&i&&i.empty.fire()},_queueHooks:function(l,e){var t=e+"queueHooks";return _l.get(l,t)||_l.access(l,t,{empty:Tl.Callbacks("once memory").add(function(){_l.remove(l,[e+"queue",t])})})}}),Tl.fn.extend({queue:function(l,e){var t=2;return"string"!==typeof l&&(e=l,l="fx",t--),arguments.length<t?Tl.queue(this[0],l):void 0===e?this:this.each(function(){var t=Tl.queue(this,l,e);Tl._queueHooks(this,l),"fx"===l&&"inprogress"!==t[0]&&Tl.dequeue(this,l)})},dequeue:function(l){return this.each(function(){Tl.dequeue(this,l)})},clearQueue:function(l){return this.queue(l||"fx",[])},promise:function(l,e){var t,a=1,n=Tl.Deferred(),i=this,c=this.length,r=function(){--a||n.resolveWith(i,[i])};for("string"!==typeof l&&(e=l,l=void 0),l=l||"fx";c--;)(t=_l.get(i[c],l+"queueHooks"))&&t.empty&&(a++,t.empty.add(r));return r(),n.promise(e)}});var Yl=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Wl=new RegExp("^(?:([+-])=|)("+Yl+")([a-z%]*)$","i"),Xl=["Top","Right","Bottom","Left"],Jl=Ml.documentElement,Ql=function(l){return Tl.contains(l.ownerDocument,l)},le={composed:!0};Jl.attachShadow&&(Ql=function(l){return Tl.contains(l.ownerDocument,l)||l.getRootNode(le)===l.ownerDocument});var ee=function(l,e){return l=e||l,"none"===l.style.display||""===l.style.display&&Ql(l)&&"none"===Tl.css(l,"display")},te=function(l,e,t,a){var n,i,c={};for(i in e)c[i]=l.style[i],l.style[i]=e[i];n=t.apply(l,a||[]);for(i in e)l.style[i]=c[i];return n},ae={};Tl.fn.extend({show:function(){return w(this,!0)},hide:function(){return w(this)},toggle:function(l){return"boolean"===typeof l?l?this.show():this.hide():this.each(function(){ee(this)?Tl(this).show():Tl(this).hide()})}});var ne=/^(?:checkbox|radio)$/i,ie=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,ce=/^$|^module$|\/(?:java|ecma)script/i,re={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};re.optgroup=re.option,re.tbody=re.tfoot=re.colgroup=re.caption=re.thead,re.th=re.td;var oe=/<|&#?\w+;/;!function(){var l=Ml.createDocumentFragment(),e=l.appendChild(Ml.createElement("div")),t=Ml.createElement("input");t.setAttribute("type","radio"),t.setAttribute("checked","checked"),t.setAttribute("name","t"),e.appendChild(t),xl.checkClone=e.cloneNode(!0).cloneNode(!0).lastChild.checked,e.innerHTML="<textarea>x</textarea>",xl.noCloneChecked=!!e.cloneNode(!0).lastChild.defaultValue}();var se=/^key/,he=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,pe=/^([^.]*)(?:\.(.+)|)/;Tl.event={global:{},add:function(l,e,t,a,n){var i,c,r,o,s,h,p,M,u,Z,m,d=_l.get(l);if(d)for(t.handler&&(i=t,t=i.handler,n=i.selector),n&&Tl.find.matchesSelector(Jl,n),t.guid||(t.guid=Tl.guid++),(o=d.events)||(o=d.events={}),(c=d.handle)||(c=d.handle=function(e){return"undefined"!==typeof Tl&&Tl.event.triggered!==e.type?Tl.event.dispatch.apply(l,arguments):void 0}),e=(e||"").match(Pl)||[""],s=e.length;s--;)r=pe.exec(e[s])||[],u=m=r[1],Z=(r[2]||"").split(".").sort(),u&&(p=Tl.event.special[u]||{},u=(n?p.delegateType:p.bindType)||u,p=Tl.event.special[u]||{},h=Tl.extend({type:u,origType:m,data:a,handler:t,guid:t.guid,selector:n,needsContext:n&&Tl.expr.match.needsContext.test(n),namespace:Z.join(".")},i),(M=o[u])||(M=o[u]=[],M.delegateCount=0,p.setup&&!1!==p.setup.call(l,a,Z,c)||l.addEventListener&&l.addEventListener(u,c)),p.add&&(p.add.call(l,h),h.handler.guid||(h.handler.guid=t.guid)),n?M.splice(M.delegateCount++,0,h):M.push(h),Tl.event.global[u]=!0)},remove:function(l,e,t,a,n){var i,c,r,o,s,h,p,M,u,Z,m,d=_l.hasData(l)&&_l.get(l);if(d&&(o=d.events)){for(e=(e||"").match(Pl)||[""],s=e.length;s--;)if(r=pe.exec(e[s])||[],u=m=r[1],Z=(r[2]||"").split(".").sort(),u){for(p=Tl.event.special[u]||{},u=(a?p.delegateType:p.bindType)||u,M=o[u]||[],r=r[2]&&new RegExp("(^|\\.)"+Z.join("\\.(?:.*\\.|)")+"(\\.|$)"),c=i=M.length;i--;)h=M[i],!n&&m!==h.origType||t&&t.guid!==h.guid||r&&!r.test(h.namespace)||a&&a!==h.selector&&("**"!==a||!h.selector)||(M.splice(i,1),h.selector&&M.delegateCount--,p.remove&&p.remove.call(l,h));c&&!M.length&&(p.teardown&&!1!==p.teardown.call(l,Z,d.handle)||Tl.removeEvent(l,u,d.handle),delete o[u])}else for(u in o)Tl.event.remove(l,u+e[s],t,a,!0);Tl.isEmptyObject(o)&&_l.remove(l,"handle events")}},dispatch:function(l){var e,t,a,n,i,c,r=Tl.event.fix(l),o=new Array(arguments.length),s=(_l.get(this,"events")||{})[r.type]||[],h=Tl.event.special[r.type]||{};for(o[0]=r,e=1;e<arguments.length;e++)o[e]=arguments[e];if(r.delegateTarget=this,!h.preDispatch||!1!==h.preDispatch.call(this,r)){for(c=Tl.event.handlers.call(this,r,s),e=0;(n=c[e++])&&!r.isPropagationStopped();)for(r.currentTarget=n.elem,t=0;(i=n.handlers[t++])&&!r.isImmediatePropagationStopped();)r.rnamespace&&!1!==i.namespace&&!r.rnamespace.test(i.namespace)||(r.handleObj=i,r.data=i.data,void 0!==(a=((Tl.event.special[i.origType]||{}).handle||i.handler).apply(n.elem,o))&&!1===(r.result=a)&&(r.preventDefault(),r.stopPropagation()));return h.postDispatch&&h.postDispatch.call(this,r),r.result}},handlers:function(l,e){var t,a,n,i,c,r=[],o=e.delegateCount,s=l.target;if(o&&s.nodeType&&!("click"===l.type&&l.button>=1))for(;s!==this;s=s.parentNode||this)if(1===s.nodeType&&("click"!==l.type||!0!==s.disabled)){for(i=[],c={},t=0;t<o;t++)a=e[t],n=a.selector+" ",void 0===c[n]&&(c[n]=a.needsContext?Tl(n,this).index(s)>-1:Tl.find(n,this,null,[s]).length),c[n]&&i.push(a);i.length&&r.push({elem:s,handlers:i})}return s=this,o<e.length&&r.push({elem:s,handlers:e.slice(o)}),r},addProp:function(l,e){Object.defineProperty(Tl.Event.prototype,l,{enumerable:!0,configurable:!0,get:wl(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[l]},set:function(e){Object.defineProperty(this,l,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(l){return l[Tl.expando]?l:new Tl.Event(l)},special:{load:{noBubble:!0},click:{setup:function(l){var e=this||l;return ne.test(e.type)&&e.click&&s(e,"input")&&void 0===_l.get(e,"click")&&L(e,"click",k),!1},trigger:function(l){var e=this||l;return ne.test(e.type)&&e.click&&s(e,"input")&&void 0===_l.get(e,"click")&&L(e,"click"),!0},_default:function(l){var e=l.target;return ne.test(e.type)&&e.click&&s(e,"input")&&_l.get(e,"click")||s(e,"a")}},beforeunload:{postDispatch:function(l){void 0!==l.result&&l.originalEvent&&(l.originalEvent.returnValue=l.result)}}}},Tl.removeEvent=function(l,e,t){l.removeEventListener&&l.removeEventListener(e,t)},Tl.Event=function(l,e){if(!(this instanceof Tl.Event))return new Tl.Event(l,e);l&&l.type?(this.originalEvent=l,this.type=l.type,this.isDefaultPrevented=l.defaultPrevented||void 0===l.defaultPrevented&&!1===l.returnValue?k:z,this.target=l.target&&3===l.target.nodeType?l.target.parentNode:l.target,this.currentTarget=l.currentTarget,this.relatedTarget=l.relatedTarget):this.type=l,e&&Tl.extend(this,e),this.timeStamp=l&&l.timeStamp||Date.now(),this[Tl.expando]=!0},Tl.Event.prototype={constructor:Tl.Event,isDefaultPrevented:z,isPropagationStopped:z,isImmediatePropagationStopped:z,isSimulated:!1,preventDefault:function(){var l=this.originalEvent;this.isDefaultPrevented=k,l&&!this.isSimulated&&l.preventDefault()},stopPropagation:function(){var l=this.originalEvent;this.isPropagationStopped=k,l&&!this.isSimulated&&l.stopPropagation()},stopImmediatePropagation:function(){var l=this.originalEvent;this.isImmediatePropagationStopped=k,l&&!this.isSimulated&&l.stopImmediatePropagation(),this.stopPropagation()}},Tl.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(l){var e=l.button;return null==l.which&&se.test(l.type)?null!=l.charCode?l.charCode:l.keyCode:!l.which&&void 0!==e&&he.test(l.type)?1&e?1:2&e?3:4&e?2:0:l.which}},Tl.event.addProp),Tl.each({focus:"focusin",blur:"focusout"},function(l,e){Tl.event.special[l]={setup:function(){return L(this,l,A),!1},trigger:function(){return L(this,l),!0},delegateType:e}}),Tl.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(l,e){Tl.event.special[l]={delegateType:e,bindType:e,handle:function(l){var t,a=this,n=l.relatedTarget,i=l.handleObj;return n&&(n===a||Tl.contains(a,n))||(l.type=i.origType,t=i.handler.apply(this,arguments),l.type=e),t}}}),Tl.fn.extend({on:function(l,e,t,a){return N(this,l,e,t,a)},one:function(l,e,t,a){return N(this,l,e,t,a,1)},off:function(l,e,t){var a,n;if(l&&l.preventDefault&&l.handleObj)return a=l.handleObj,Tl(l.delegateTarget).off(a.namespace?a.origType+"."+a.namespace:a.origType,a.selector,a.handler),this;if("object"===typeof l){for(n in l)this.off(n,e,l[n]);return this}return!1!==e&&"function"!==typeof e||(t=e,e=void 0),!1===t&&(t=z),this.each(function(){Tl.event.remove(this,l,t,e)})}});var Me=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,ue=/<script|<style|<link/i,Ze=/checked\s*(?:[^=]|=\s*.checked.)/i,me=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;Tl.extend({htmlPrefilter:function(l){return l.replace(Me,"<$1></$2>")},clone:function(l,e,t){var a,n,i,c,r=l.cloneNode(!0),o=Ql(l);if(!xl.noCloneChecked&&(1===l.nodeType||11===l.nodeType)&&!Tl.isXMLDoc(l))for(c=C(r),i=C(l),a=0,n=i.length;a<n;a++)P(i[a],c[a]);if(e)if(t)for(i=i||C(l),c=c||C(r),a=0,n=i.length;a<n;a++)H(i[a],c[a]);else H(l,r);return c=C(r,"script"),c.length>0&&E(c,!o&&C(l,"script")),r},cleanData:function(l){for(var e,t,a,n=Tl.event.special,i=0;void 0!==(t=l[i]);i++)if(Fl(t)){if(e=t[_l.expando]){if(e.events)for(a in e.events)n[a]?Tl.event.remove(t,a):Tl.removeEvent(t,a,e.handle);t[_l.expando]=void 0}t[Kl.expando]&&(t[Kl.expando]=void 0)}}}),Tl.fn.extend({detach:function(l){return U(this,l,!0)},remove:function(l){return U(this,l)},text:function(l){return Vl(this,function(l){return void 0===l?Tl.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=l)})},null,l,arguments.length)},append:function(){return I(this,arguments,function(l){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){j(this,l).appendChild(l)}})},prepend:function(){return I(this,arguments,function(l){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var e=j(this,l);e.insertBefore(l,e.firstChild)}})},before:function(){return I(this,arguments,function(l){this.parentNode&&this.parentNode.insertBefore(l,this)})},after:function(){return I(this,arguments,function(l){this.parentNode&&this.parentNode.insertBefore(l,this.nextSibling)})},empty:function(){for(var l,e=0;null!=(l=this[e]);e++)1===l.nodeType&&(Tl.cleanData(C(l,!1)),l.textContent="");return this},clone:function(l,e){return l=null!=l&&l,e=null==e?l:e,this.map(function(){return Tl.clone(this,l,e)})},html:function(l){return Vl(this,function(l){var e=this[0]||{},t=0,a=this.length;if(void 0===l&&1===e.nodeType)return e.innerHTML;if("string"===typeof l&&!ue.test(l)&&!re[(ie.exec(l)||["",""])[1].toLowerCase()]){l=Tl.htmlPrefilter(l);try{for(;t<a;t++)e=this[t]||{},1===e.nodeType&&(Tl.cleanData(C(e,!1)),e.innerHTML=l);e=0}catch(l){}}e&&this.empty().append(l)},null,l,arguments.length)},replaceWith:function(){var l=[];return I(this,arguments,function(e){var t=this.parentNode;Tl.inArray(this,l)<0&&(Tl.cleanData(C(this)),t&&t.replaceChild(e,this))},l)}}),Tl.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(l,e){Tl.fn[l]=function(l){for(var t,a=[],n=Tl(l),i=n.length-1,c=0;c<=i;c++)t=c===i?this:this.clone(!0),Tl(n[c])[e](t),dl.apply(a,t.get());return this.pushStack(a)}});var de=new RegExp("^("+Yl+")(?!px)[a-z%]+$","i"),fe=function(l){var e=l.ownerDocument.defaultView;return e&&e.opener||(e=t),e.getComputedStyle(l)},ge=new RegExp(Xl.join("|"),"i");!function(){function l(){if(s){o.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",s.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",Jl.appendChild(o).appendChild(s);var l=t.getComputedStyle(s);a="1%"!==l.top,r=12===e(l.marginLeft),s.style.right="60%",c=36===e(l.right),n=36===e(l.width),s.style.position="absolute",i=12===e(s.offsetWidth/3),Jl.removeChild(o),s=null}}function e(l){return Math.round(parseFloat(l))}var a,n,i,c,r,o=Ml.createElement("div"),s=Ml.createElement("div");s.style&&(s.style.backgroundClip="content-box",s.cloneNode(!0).style.backgroundClip="",xl.clearCloneStyle="content-box"===s.style.backgroundClip,Tl.extend(xl,{boxSizingReliable:function(){return l(),n},pixelBoxStyles:function(){return l(),c},pixelPosition:function(){return l(),a},reliableMarginLeft:function(){return l(),r},scrollboxSize:function(){return l(),i}}))}();var ye=["Webkit","Moz","ms"],ve=Ml.createElement("div").style,be={},Se=/^(none|table(?!-c[ea]).+)/,xe=/^--/,we={position:"absolute",visibility:"hidden",display:"block"},Ce={letterSpacing:"0",fontWeight:"400"};Tl.extend({cssHooks:{opacity:{get:function(l,e){if(e){var t=V(l,"opacity");return""===t?"1":t}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(l,e,t,a){if(l&&3!==l.nodeType&&8!==l.nodeType&&l.style){var n,i,c,r=g(e),o=xe.test(e),s=l.style;if(o||(e=F(r)),c=Tl.cssHooks[e]||Tl.cssHooks[r],void 0===t)return c&&"get"in c&&void 0!==(n=c.get(l,!1,a))?n:s[e];i=typeof t,"string"===i&&(n=Wl.exec(t))&&n[1]&&(t=S(l,e,n),i="number"),null!=t&&t===t&&("number"!==i||o||(t+=n&&n[3]||(Tl.cssNumber[r]?"":"px")),xl.clearCloneStyle||""!==t||0!==e.indexOf("background")||(s[e]="inherit"),c&&"set"in c&&void 0===(t=c.set(l,t,a))||(o?s.setProperty(e,t):s[e]=t))}},css:function(l,e,t,a){var n,i,c,r=g(e);return xe.test(e)||(e=F(r)),c=Tl.cssHooks[e]||Tl.cssHooks[r],c&&"get"in c&&(n=c.get(l,!0,t)),void 0===n&&(n=V(l,e,a)),"normal"===n&&e in Ce&&(n=Ce[e]),""===t||t?(i=parseFloat(n),!0===t||isFinite(i)?i||0:n):n}}),Tl.each(["height","width"],function(l,e){Tl.cssHooks[e]={get:function(l,t,a){if(t)return!Se.test(Tl.css(l,"display"))||l.getClientRects().length&&l.getBoundingClientRect().width?q(l,e,a):te(l,we,function(){return q(l,e,a)})},set:function(l,t,a){var n,i=fe(l),c=!xl.scrollboxSize()&&"absolute"===i.position,r=c||a,o=r&&"border-box"===Tl.css(l,"boxSizing",!1,i),s=a?K(l,e,a,o,i):0;return o&&c&&(s-=Math.ceil(l["offset"+e[0].toUpperCase()+e.slice(1)]-parseFloat(i[e])-K(l,e,"border",!1,i)-.5)),s&&(n=Wl.exec(t))&&"px"!==(n[3]||"px")&&(l.style[e]=t,t=Tl.css(l,e)),_(l,t,s)}}}),Tl.cssHooks.marginLeft=B(xl.reliableMarginLeft,function(l,e){if(e)return(parseFloat(V(l,"marginLeft"))||l.getBoundingClientRect().left-te(l,{marginLeft:0},function(){return l.getBoundingClientRect().left}))+"px"}),Tl.each({margin:"",padding:"",border:"Width"},function(l,e){Tl.cssHooks[l+e]={expand:function(t){for(var a=0,n={},i="string"===typeof t?t.split(" "):[t];a<4;a++)n[l+Xl[a]+e]=i[a]||i[a-2]||i[0];return n}},"margin"!==l&&(Tl.cssHooks[l+e].set=_)}),Tl.fn.extend({css:function(l,e){return Vl(this,function(l,e,t){var a,n,i={},c=0;if(Array.isArray(e)){for(a=fe(l),n=e.length;c<n;c++)i[e[c]]=Tl.css(l,e[c],!1,a);return i}return void 0!==t?Tl.style(l,e,t):Tl.css(l,e)},l,e,arguments.length>1)}}),Tl.Tween=$,$.prototype={constructor:$,init:function(l,e,t,a,n,i){this.elem=l,this.prop=t,this.easing=n||Tl.easing._default,this.options=e,this.start=this.now=this.cur(),this.end=a,this.unit=i||(Tl.cssNumber[t]?"":"px")},cur:function(){var l=$.propHooks[this.prop];return l&&l.get?l.get(this):$.propHooks._default.get(this)},run:function(l){var e,t=$.propHooks[this.prop];return this.options.duration?this.pos=e=Tl.easing[this.easing](l,this.options.duration*l,0,1,this.options.duration):this.pos=e=l,this.now=(this.end-this.start)*e+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),t&&t.set?t.set(this):$.propHooks._default.set(this),this}},$.prototype.init.prototype=$.prototype,$.propHooks={_default:{get:function(l){var e;return 1!==l.elem.nodeType||null!=l.elem[l.prop]&&null==l.elem.style[l.prop]?l.elem[l.prop]:(e=Tl.css(l.elem,l.prop,""),e&&"auto"!==e?e:0)},set:function(l){Tl.fx.step[l.prop]?Tl.fx.step[l.prop](l):1!==l.elem.nodeType||!Tl.cssHooks[l.prop]&&null==l.elem.style[F(l.prop)]?l.elem[l.prop]=l.now:Tl.style(l.elem,l.prop,l.now+l.unit)}}},$.propHooks.scrollTop=$.propHooks.scrollLeft={set:function(l){l.elem.nodeType&&l.elem.parentNode&&(l.elem[l.prop]=l.now)}},Tl.easing={linear:function(l){return l},swing:function(l){return.5-Math.cos(l*Math.PI)/2},_default:"swing"},Tl.fx=$.prototype.init,Tl.fx.step={};var Ee,Te,ke=/^(?:toggle|show|hide)$/,ze=/queueHooks$/;Tl.Animation=Tl.extend(el,{tweeners:{"*":[function(l,e){var t=this.createTween(l,e);return S(t.elem,l,Wl.exec(e),t),t}]},tweener:function(l,e){wl(l)?(e=l,l=["*"]):l=l.match(Pl);for(var t,a=0,n=l.length;a<n;a++)t=l[a],el.tweeners[t]=el.tweeners[t]||[],el.tweeners[t].unshift(e)},prefilters:[Q],prefilter:function(l,e){e?el.prefilters.unshift(l):el.prefilters.push(l)}}),Tl.speed=function(l,e,t){var a=l&&"object"===typeof l?Tl.extend({},l):{complete:t||!t&&e||wl(l)&&l,duration:l,easing:t&&e||e&&!wl(e)&&e};return Tl.fx.off?a.duration=0:"number"!==typeof a.duration&&(a.duration in Tl.fx.speeds?a.duration=Tl.fx.speeds[a.duration]:a.duration=Tl.fx.speeds._default),null!=a.queue&&!0!==a.queue||(a.queue="fx"),a.old=a.complete,a.complete=function(){wl(a.old)&&a.old.call(this),a.queue&&Tl.dequeue(this,a.queue)},a},Tl.fn.extend({fadeTo:function(l,e,t,a){return this.filter(ee).css("opacity",0).show().end().animate({opacity:e},l,t,a)},animate:function(l,e,t,a){var n=Tl.isEmptyObject(l),i=Tl.speed(e,t,a),c=function(){var e=el(this,Tl.extend({},l),i);(n||_l.get(this,"finish"))&&e.stop(!0)};return c.finish=c,n||!1===i.queue?this.each(c):this.queue(i.queue,c)},stop:function(l,e,t){var a=function(l){var e=l.stop;delete l.stop,e(t)};return"string"!==typeof l&&(t=e,e=l,l=void 0),e&&!1!==l&&this.queue(l||"fx",[]),this.each(function(){var e=!0,n=null!=l&&l+"queueHooks",i=Tl.timers,c=_l.get(this);if(n)c[n]&&c[n].stop&&a(c[n]);else for(n in c)c[n]&&c[n].stop&&ze.test(n)&&a(c[n]);for(n=i.length;n--;)i[n].elem!==this||null!=l&&i[n].queue!==l||(i[n].anim.stop(t),e=!1,i.splice(n,1));!e&&t||Tl.dequeue(this,l)})},finish:function(l){return!1!==l&&(l=l||"fx"),this.each(function(){var e,t=_l.get(this),a=t[l+"queue"],n=t[l+"queueHooks"],i=Tl.timers,c=a?a.length:0;for(t.finish=!0,Tl.queue(this,l,[]),n&&n.stop&&n.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===l&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<c;e++)a[e]&&a[e].finish&&a[e].finish.call(this);delete t.finish})}}),Tl.each(["toggle","show","hide"],function(l,e){var t=Tl.fn[e];Tl.fn[e]=function(l,a,n){return null==l||"boolean"===typeof l?t.apply(this,arguments):this.animate(X(e,!0),l,a,n)}}),Tl.each({slideDown:X("show"),slideUp:X("hide"),slideToggle:X("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(l,e){Tl.fn[l]=function(l,t,a){return this.animate(e,l,t,a)}}),Tl.timers=[],Tl.fx.tick=function(){var l,e=0,t=Tl.timers;for(Ee=Date.now();e<t.length;e++)(l=t[e])()||t[e]!==l||t.splice(e--,1);t.length||Tl.fx.stop(),Ee=void 0},Tl.fx.timer=function(l){Tl.timers.push(l),Tl.fx.start()},Tl.fx.interval=13,Tl.fx.start=function(){Te||(Te=!0,Y())},Tl.fx.stop=function(){Te=null},Tl.fx.speeds={slow:600,fast:200,_default:400},Tl.fn.delay=function(l,e){return l=Tl.fx?Tl.fx.speeds[l]||l:l,e=e||"fx",this.queue(e,function(e,a){var n=t.setTimeout(e,l);a.stop=function(){t.clearTimeout(n)}})},function(){var l=Ml.createElement("input"),e=Ml.createElement("select"),t=e.appendChild(Ml.createElement("option"));l.type="checkbox",xl.checkOn=""!==l.value,xl.optSelected=t.selected,l=Ml.createElement("input"),l.value="t",l.type="radio",xl.radioValue="t"===l.value}();var Ae,Re=Tl.expr.attrHandle;Tl.fn.extend({attr:function(l,e){return Vl(this,Tl.attr,l,e,arguments.length>1)},removeAttr:function(l){return this.each(function(){Tl.removeAttr(this,l)})}}),Tl.extend({attr:function(l,e,t){var a,n,i=l.nodeType;if(3!==i&&8!==i&&2!==i)return"undefined"===typeof l.getAttribute?Tl.prop(l,e,t):(1===i&&Tl.isXMLDoc(l)||(n=Tl.attrHooks[e.toLowerCase()]||(Tl.expr.match.bool.test(e)?Ae:void 0)),void 0!==t?null===t?void Tl.removeAttr(l,e):n&&"set"in n&&void 0!==(a=n.set(l,t,e))?a:(l.setAttribute(e,t+""),t):n&&"get"in n&&null!==(a=n.get(l,e))?a:(a=Tl.find.attr(l,e),null==a?void 0:a))},attrHooks:{type:{set:function(l,e){if(!xl.radioValue&&"radio"===e&&s(l,"input")){var t=l.value;return l.setAttribute("type",e),t&&(l.value=t),e}}}},removeAttr:function(l,e){var t,a=0,n=e&&e.match(Pl);if(n&&1===l.nodeType)for(;t=n[a++];)l.removeAttribute(t)}}),Ae={set:function(l,e,t){return!1===e?Tl.removeAttr(l,t):l.setAttribute(t,t),t}},Tl.each(Tl.expr.match.bool.source.match(/\w+/g),function(l,e){var t=Re[e]||Tl.find.attr;Re[e]=function(l,e,a){var n,i,c=e.toLowerCase();return a||(i=Re[c],Re[c]=n,n=null!=t(l,e,a)?c:null,Re[c]=i),n}});var Ne=/^(?:input|select|textarea|button)$/i,Le=/^(?:a|area)$/i;Tl.fn.extend({prop:function(l,e){return Vl(this,Tl.prop,l,e,arguments.length>1)},removeProp:function(l){return this.each(function(){delete this[Tl.propFix[l]||l]})}}),Tl.extend({prop:function(l,e,t){var a,n,i=l.nodeType;if(3!==i&&8!==i&&2!==i)return 1===i&&Tl.isXMLDoc(l)||(e=Tl.propFix[e]||e,n=Tl.propHooks[e]),void 0!==t?n&&"set"in n&&void 0!==(a=n.set(l,t,e))?a:l[e]=t:n&&"get"in n&&null!==(a=n.get(l,e))?a:l[e]},propHooks:{tabIndex:{get:function(l){var e=Tl.find.attr(l,"tabindex");return e?parseInt(e,10):Ne.test(l.nodeName)||Le.test(l.nodeName)&&l.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),xl.optSelected||(Tl.propHooks.selected={get:function(l){var e=l.parentNode;return e&&e.parentNode&&e.parentNode.selectedIndex,null},set:function(l){var e=l.parentNode;e&&(e.selectedIndex,e.parentNode&&e.parentNode.selectedIndex)}}),Tl.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){Tl.propFix[this.toLowerCase()]=this}),Tl.fn.extend({addClass:function(l){var e,t,a,n,i,c,r,o=0;if(wl(l))return this.each(function(e){Tl(this).addClass(l.call(this,e,al(this)))});if(e=nl(l),e.length)for(;t=this[o++];)if(n=al(t),a=1===t.nodeType&&" "+tl(n)+" "){for(c=0;i=e[c++];)a.indexOf(" "+i+" ")<0&&(a+=i+" ");r=tl(a),n!==r&&t.setAttribute("class",r)}return this},removeClass:function(l){var e,t,a,n,i,c,r,o=0;if(wl(l))return this.each(function(e){Tl(this).removeClass(l.call(this,e,al(this)))});if(!arguments.length)return this.attr("class","");if(e=nl(l),e.length)for(;t=this[o++];)if(n=al(t),a=1===t.nodeType&&" "+tl(n)+" "){for(c=0;i=e[c++];)for(;a.indexOf(" "+i+" ")>-1;)a=a.replace(" "+i+" "," ");r=tl(a),n!==r&&t.setAttribute("class",r)}return this},toggleClass:function(l,e){var t=typeof l,a="string"===t||Array.isArray(l);return"boolean"===typeof e&&a?e?this.addClass(l):this.removeClass(l):wl(l)?this.each(function(t){Tl(this).toggleClass(l.call(this,t,al(this),e),e)}):this.each(function(){var e,n,i,c;if(a)for(n=0,i=Tl(this),c=nl(l);e=c[n++];)i.hasClass(e)?i.removeClass(e):i.addClass(e);else void 0!==l&&"boolean"!==t||(e=al(this),e&&_l.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===l?"":_l.get(this,"__className__")||""))})},hasClass:function(l){var e,t,a=0;for(e=" "+l+" ";t=this[a++];)if(1===t.nodeType&&(" "+tl(al(t))+" ").indexOf(e)>-1)return!0;return!1}});var je=/\r/g;Tl.fn.extend({val:function(l){var e,t,a,n=this[0];{if(arguments.length)return a=wl(l),this.each(function(t){var n;1===this.nodeType&&(n=a?l.call(this,t,Tl(this).val()):l,null==n?n="":"number"===typeof n?n+="":Array.isArray(n)&&(n=Tl.map(n,function(l){return null==l?"":l+""})),(e=Tl.valHooks[this.type]||Tl.valHooks[this.nodeName.toLowerCase()])&&"set"in e&&void 0!==e.set(this,n,"value")||(this.value=n))});if(n)return(e=Tl.valHooks[n.type]||Tl.valHooks[n.nodeName.toLowerCase()])&&"get"in e&&void 0!==(t=e.get(n,"value"))?t:(t=n.value,"string"===typeof t?t.replace(je,""):null==t?"":t)}}}),Tl.extend({valHooks:{option:{get:function(l){var e=Tl.find.attr(l,"value");return null!=e?e:tl(Tl.text(l))}},select:{get:function(l){var e,t,a,n=l.options,i=l.selectedIndex,c="select-one"===l.type,r=c?null:[],o=c?i+1:n.length;for(a=i<0?o:c?i:0;a<o;a++)if(t=n[a],(t.selected||a===i)&&!t.disabled&&(!t.parentNode.disabled||!s(t.parentNode,"optgroup"))){if(e=Tl(t).val(),c)return e;r.push(e)}return r},set:function(l,e){for(var t,a,n=l.options,i=Tl.makeArray(e),c=n.length;c--;)a=n[c],(a.selected=Tl.inArray(Tl.valHooks.option.get(a),i)>-1)&&(t=!0);return t||(l.selectedIndex=-1),i}}}}),Tl.each(["radio","checkbox"],function(){Tl.valHooks[this]={set:function(l,e){if(Array.isArray(e))return l.checked=Tl.inArray(Tl(l).val(),e)>-1}},xl.checkOn||(Tl.valHooks[this].get=function(l){return null===l.getAttribute("value")?"on":l.value})}),xl.focusin="onfocusin"in t;var De=/^(?:focusinfocus|focusoutblur)$/,Oe=function(l){l.stopPropagation()};Tl.extend(Tl.event,{trigger:function(l,e,a,n){var i,c,r,o,s,h,p,M,u=[a||Ml],Z=vl.call(l,"type")?l.type:l,m=vl.call(l,"namespace")?l.namespace.split("."):[];if(c=M=r=a=a||Ml,3!==a.nodeType&&8!==a.nodeType&&!De.test(Z+Tl.event.triggered)&&(Z.indexOf(".")>-1&&(m=Z.split("."),Z=m.shift(),m.sort()),s=Z.indexOf(":")<0&&"on"+Z,l=l[Tl.expando]?l:new Tl.Event(Z,"object"===typeof l&&l),l.isTrigger=n?2:3,l.namespace=m.join("."),l.rnamespace=l.namespace?new RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,l.result=void 0,l.target||(l.target=a),e=null==e?[l]:Tl.makeArray(e,[l]),p=Tl.event.special[Z]||{},n||!p.trigger||!1!==p.trigger.apply(a,e))){if(!n&&!p.noBubble&&!Cl(a)){for(o=p.delegateType||Z,De.test(o+Z)||(c=c.parentNode);c;c=c.parentNode)u.push(c),r=c;r===(a.ownerDocument||Ml)&&u.push(r.defaultView||r.parentWindow||t)}for(i=0;(c=u[i++])&&!l.isPropagationStopped();)M=c,l.type=i>1?o:p.bindType||Z,h=(_l.get(c,"events")||{})[l.type]&&_l.get(c,"handle"),h&&h.apply(c,e),(h=s&&c[s])&&h.apply&&Fl(c)&&(l.result=h.apply(c,e),!1===l.result&&l.preventDefault());return l.type=Z,n||l.isDefaultPrevented()||p._default&&!1!==p._default.apply(u.pop(),e)||!Fl(a)||s&&wl(a[Z])&&!Cl(a)&&(r=a[s],r&&(a[s]=null),Tl.event.triggered=Z,l.isPropagationStopped()&&M.addEventListener(Z,Oe),a[Z](),l.isPropagationStopped()&&M.removeEventListener(Z,Oe),Tl.event.triggered=void 0,r&&(a[s]=r)),l.result}},simulate:function(l,e,t){var a=Tl.extend(new Tl.Event,t,{type:l,isSimulated:!0});Tl.event.trigger(a,null,e)}}),Tl.fn.extend({trigger:function(l,e){return this.each(function(){Tl.event.trigger(l,e,this)})},triggerHandler:function(l,e){var t=this[0];if(t)return Tl.event.trigger(l,e,t,!0)}}),xl.focusin||Tl.each({focus:"focusin",blur:"focusout"},function(l,e){var t=function(l){Tl.event.simulate(e,l.target,Tl.event.fix(l))};Tl.event.special[e]={setup:function(){var a=this.ownerDocument||this,n=_l.access(a,e);n||a.addEventListener(l,t,!0),_l.access(a,e,(n||0)+1)},teardown:function(){var a=this.ownerDocument||this,n=_l.access(a,e)-1;n?_l.access(a,e,n):(a.removeEventListener(l,t,!0),_l.remove(a,e))}}});var He=t.location,Pe=Date.now(),Ie=/\?/;Tl.parseXML=function(l){var e;if(!l||"string"!==typeof l)return null;try{e=(new t.DOMParser).parseFromString(l,"text/xml")}catch(l){e=void 0}return e&&!e.getElementsByTagName("parsererror").length||Tl.error("Invalid XML: "+l),e};var Ue=/\[\]$/,Ve=/\r?\n/g,Be=/^(?:submit|button|image|reset|file)$/i,Ge=/^(?:input|select|textarea|keygen)/i;Tl.param=function(l,e){var t,a=[],n=function(l,e){var t=wl(e)?e():e;a[a.length]=encodeURIComponent(l)+"="+encodeURIComponent(null==t?"":t)};if(null==l)return"";if(Array.isArray(l)||l.jquery&&!Tl.isPlainObject(l))Tl.each(l,function(){n(this.name,this.value)});else for(t in l)il(t,l[t],e,n);return a.join("&")},Tl.fn.extend({serialize:function(){return Tl.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var l=Tl.prop(this,"elements");return l?Tl.makeArray(l):this}).filter(function(){var l=this.type;return this.name&&!Tl(this).is(":disabled")&&Ge.test(this.nodeName)&&!Be.test(l)&&(this.checked||!ne.test(l))}).map(function(l,e){var t=Tl(this).val();return null==t?null:Array.isArray(t)?Tl.map(t,function(l){return{name:e.name,value:l.replace(Ve,"\r\n")}}):{name:e.name,value:t.replace(Ve,"\r\n")}}).get()}});var Fe=/%20/g,_e=/#.*$/,Ke=/([?&])_=[^&]*/,qe=/^(.*?):[ \t]*([^\r\n]*)$/gm,$e=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Ye=/^(?:GET|HEAD)$/,We=/^\/\//,Xe={},Je={},Qe="*/".concat("*"),lt=Ml.createElement("a");lt.href=He.href,Tl.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:He.href,type:"GET",isLocal:$e.test(He.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Qe,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":Tl.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(l,e){return e?ol(ol(l,Tl.ajaxSettings),e):ol(Tl.ajaxSettings,l)},ajaxPrefilter:cl(Xe),ajaxTransport:cl(Je),ajax:function(l,e){function a(l,e,a,r){var s,M,u,v,b,S=e;h||(h=!0,o&&t.clearTimeout(o),n=void 0,c=r||"",x.readyState=l>0?4:0,s=l>=200&&l<300||304===l,a&&(v=sl(Z,x,a)),v=hl(Z,v,x,s),s?(Z.ifModified&&(b=x.getResponseHeader("Last-Modified"),b&&(Tl.lastModified[i]=b),(b=x.getResponseHeader("etag"))&&(Tl.etag[i]=b)),204===l||"HEAD"===Z.type?S="nocontent":304===l?S="notmodified":(S=v.state,M=v.data,u=v.error,s=!u)):(u=S,!l&&S||(S="error",l<0&&(l=0))),x.status=l,x.statusText=(e||S)+"",s?f.resolveWith(m,[M,S,x]):f.rejectWith(m,[x,S,u]),x.statusCode(y),y=void 0,p&&d.trigger(s?"ajaxSuccess":"ajaxError",[x,Z,s?M:u]),g.fireWith(m,[x,S]),p&&(d.trigger("ajaxComplete",[x,Z]),--Tl.active||Tl.event.trigger("ajaxStop")))}"object"===typeof l&&(e=l,l=void 0),e=e||{};var n,i,c,r,o,s,h,p,M,u,Z=Tl.ajaxSetup({},e),m=Z.context||Z,d=Z.context&&(m.nodeType||m.jquery)?Tl(m):Tl.event,f=Tl.Deferred(),g=Tl.Callbacks("once memory"),y=Z.statusCode||{},v={},b={},S="canceled",x={readyState:0,getResponseHeader:function(l){var e;if(h){if(!r)for(r={};e=qe.exec(c);)r[e[1].toLowerCase()+" "]=(r[e[1].toLowerCase()+" "]||[]).concat(e[2]);e=r[l.toLowerCase()+" "]}return null==e?null:e.join(", ")},getAllResponseHeaders:function(){return h?c:null},setRequestHeader:function(l,e){return null==h&&(l=b[l.toLowerCase()]=b[l.toLowerCase()]||l,v[l]=e),this},overrideMimeType:function(l){return null==h&&(Z.mimeType=l),this},statusCode:function(l){var e;if(l)if(h)x.always(l[x.status]);else for(e in l)y[e]=[y[e],l[e]];return this},abort:function(l){var e=l||S;return n&&n.abort(e),a(0,e),this}};if(f.promise(x),Z.url=((l||Z.url||He.href)+"").replace(We,He.protocol+"//"),Z.type=e.method||e.type||Z.method||Z.type,Z.dataTypes=(Z.dataType||"*").toLowerCase().match(Pl)||[""],null==Z.crossDomain){s=Ml.createElement("a");try{s.href=Z.url,s.href=s.href,Z.crossDomain=lt.protocol+"//"+lt.host!==s.protocol+"//"+s.host}catch(l){Z.crossDomain=!0}}if(Z.data&&Z.processData&&"string"!==typeof Z.data&&(Z.data=Tl.param(Z.data,Z.traditional)),rl(Xe,Z,e,x),h)return x;p=Tl.event&&Z.global,p&&0===Tl.active++&&Tl.event.trigger("ajaxStart"),Z.type=Z.type.toUpperCase(),Z.hasContent=!Ye.test(Z.type),i=Z.url.replace(_e,""),Z.hasContent?Z.data&&Z.processData&&0===(Z.contentType||"").indexOf("application/x-www-form-urlencoded")&&(Z.data=Z.data.replace(Fe,"+")):(u=Z.url.slice(i.length),Z.data&&(Z.processData||"string"===typeof Z.data)&&(i+=(Ie.test(i)?"&":"?")+Z.data,delete Z.data),!1===Z.cache&&(i=i.replace(Ke,"$1"),u=(Ie.test(i)?"&":"?")+"_="+Pe+++u),Z.url=i+u),Z.ifModified&&(Tl.lastModified[i]&&x.setRequestHeader("If-Modified-Since",Tl.lastModified[i]),Tl.etag[i]&&x.setRequestHeader("If-None-Match",Tl.etag[i])),(Z.data&&Z.hasContent&&!1!==Z.contentType||e.contentType)&&x.setRequestHeader("Content-Type",Z.contentType),x.setRequestHeader("Accept",Z.dataTypes[0]&&Z.accepts[Z.dataTypes[0]]?Z.accepts[Z.dataTypes[0]]+("*"!==Z.dataTypes[0]?", "+Qe+"; q=0.01":""):Z.accepts["*"]);for(M in Z.headers)x.setRequestHeader(M,Z.headers[M]);if(Z.beforeSend&&(!1===Z.beforeSend.call(m,x,Z)||h))return x.abort();if(S="abort",g.add(Z.complete),x.done(Z.success),x.fail(Z.error),n=rl(Je,Z,e,x)){if(x.readyState=1,p&&d.trigger("ajaxSend",[x,Z]),h)return x;Z.async&&Z.timeout>0&&(o=t.setTimeout(function(){x.abort("timeout")},Z.timeout));try{h=!1,n.send(v,a)}catch(l){if(h)throw l;a(-1,l)}}else a(-1,"No Transport");return x},getJSON:function(l,e,t){return Tl.get(l,e,t,"json")},getScript:function(l,e){return Tl.get(l,void 0,e,"script")}}),Tl.each(["get","post"],function(l,e){Tl[e]=function(l,t,a,n){return wl(t)&&(n=n||a,a=t,t=void 0),Tl.ajax(Tl.extend({url:l,type:e,dataType:n,data:t,success:a},Tl.isPlainObject(l)&&l))}}),Tl._evalUrl=function(l,e){return Tl.ajax({url:l,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(l){Tl.globalEval(l,e)}})},Tl.fn.extend({wrapAll:function(l){var e;return this[0]&&(wl(l)&&(l=l.call(this[0])),e=Tl(l,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&e.insertBefore(this[0]),e.map(function(){for(var l=this;l.firstElementChild;)l=l.firstElementChild;return l}).append(this)),this},wrapInner:function(l){return wl(l)?this.each(function(e){Tl(this).wrapInner(l.call(this,e))}):this.each(function(){var e=Tl(this),t=e.contents();t.length?t.wrapAll(l):e.append(l)})},wrap:function(l){var e=wl(l);return this.each(function(t){Tl(this).wrapAll(e?l.call(this,t):l)})},unwrap:function(l){return this.parent(l).not("body").each(function(){Tl(this).replaceWith(this.childNodes)}),this}}),Tl.expr.pseudos.hidden=function(l){return!Tl.expr.pseudos.visible(l)},Tl.expr.pseudos.visible=function(l){return!!(l.offsetWidth||l.offsetHeight||l.getClientRects().length)},Tl.ajaxSettings.xhr=function(){try{return new t.XMLHttpRequest}catch(l){}};var et={0:200,1223:204},tt=Tl.ajaxSettings.xhr();xl.cors=!!tt&&"withCredentials"in tt,xl.ajax=tt=!!tt,Tl.ajaxTransport(function(l){var e,a;if(xl.cors||tt&&!l.crossDomain)return{send:function(n,i){var c,r=l.xhr();if(r.open(l.type,l.url,l.async,l.username,l.password),l.xhrFields)for(c in l.xhrFields)r[c]=l.xhrFields[c];l.mimeType&&r.overrideMimeType&&r.overrideMimeType(l.mimeType),l.crossDomain||n["X-Requested-With"]||(n["X-Requested-With"]="XMLHttpRequest");for(c in n)r.setRequestHeader(c,n[c]);e=function(l){return function(){e&&(e=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===l?r.abort():"error"===l?"number"!==typeof r.status?i(0,"error"):i(r.status,r.statusText):i(et[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!==typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=e(),a=r.onerror=r.ontimeout=e("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&t.setTimeout(function(){e&&a()})},e=e("abort");try{r.send(l.hasContent&&l.data||null)}catch(l){if(e)throw l}},abort:function(){e&&e()}}}),Tl.ajaxPrefilter(function(l){l.crossDomain&&(l.contents.script=!1)}),Tl.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(l){return Tl.globalEval(l),l}}}),Tl.ajaxPrefilter("script",function(l){void 0===l.cache&&(l.cache=!1),l.crossDomain&&(l.type="GET")}),Tl.ajaxTransport("script",function(l){if(l.crossDomain||l.scriptAttrs){var e,t;return{send:function(a,n){e=Tl("<script>").attr(l.scriptAttrs||{}).prop({charset:l.scriptCharset,src:l.url}).on("load error",t=function(l){e.remove(),t=null,l&&n("error"===l.type?404:200,l.type)}),Ml.head.appendChild(e[0])},abort:function(){t&&t()}}}});var at=[],nt=/(=)\?(?=&|$)|\?\?/;Tl.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var l=at.pop()||Tl.expando+"_"+Pe++;return this[l]=!0,l}}),Tl.ajaxPrefilter("json jsonp",function(l,e,a){var n,i,c,r=!1!==l.jsonp&&(nt.test(l.url)?"url":"string"===typeof l.data&&0===(l.contentType||"").indexOf("application/x-www-form-urlencoded")&&nt.test(l.data)&&"data");if(r||"jsonp"===l.dataTypes[0])return n=l.jsonpCallback=wl(l.jsonpCallback)?l.jsonpCallback():l.jsonpCallback,r?l[r]=l[r].replace(nt,"$1"+n):!1!==l.jsonp&&(l.url+=(Ie.test(l.url)?"&":"?")+l.jsonp+"="+n),l.converters["script json"]=function(){return c||Tl.error(n+" was not called"),c[0]},l.dataTypes[0]="json",i=t[n],t[n]=function(){c=arguments},a.always(function(){void 0===i?Tl(t).removeProp(n):t[n]=i,l[n]&&(l.jsonpCallback=e.jsonpCallback,at.push(n)),c&&wl(i)&&i(c[0]),c=i=void 0}),"script"}),xl.createHTMLDocument=function(){var l=Ml.implementation.createHTMLDocument("").body;return l.innerHTML="<form></form><form></form>",2===l.childNodes.length}(),Tl.parseHTML=function(l,e,t){if("string"!==typeof l)return[];"boolean"===typeof e&&(t=e,e=!1);var a,n,i;return e||(xl.createHTMLDocument?(e=Ml.implementation.createHTMLDocument(""),a=e.createElement("base"),a.href=Ml.location.href,e.head.appendChild(a)):e=Ml),n=Ll.exec(l),i=!t&&[],n?[e.createElement(n[1])]:(n=T([l],e,i),i&&i.length&&Tl(i).remove(),Tl.merge([],n.childNodes))},Tl.fn.load=function(l,e,t){var a,n,i,c=this,r=l.indexOf(" ");return r>-1&&(a=tl(l.slice(r)),l=l.slice(0,r)),wl(e)?(t=e,e=void 0):e&&"object"===typeof e&&(n="POST"),c.length>0&&Tl.ajax({url:l,type:n||"GET",dataType:"html",data:e}).done(function(l){i=arguments,c.html(a?Tl("<div>").append(Tl.parseHTML(l)).find(a):l)}).always(t&&function(l,e){c.each(function(){t.apply(this,i||[l.responseText,e,l])})}),this},Tl.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(l,e){Tl.fn[e]=function(l){return this.on(e,l)}}),Tl.expr.pseudos.animated=function(l){return Tl.grep(Tl.timers,function(e){return l===e.elem}).length},Tl.offset={setOffset:function(l,e,t){var a,n,i,c,r,o,s,h=Tl.css(l,"position"),p=Tl(l),M={};"static"===h&&(l.style.position="relative"),r=p.offset(),i=Tl.css(l,"top"),o=Tl.css(l,"left"),s=("absolute"===h||"fixed"===h)&&(i+o).indexOf("auto")>-1,s?(a=p.position(),c=a.top,n=a.left):(c=parseFloat(i)||0,n=parseFloat(o)||0),wl(e)&&(e=e.call(l,t,Tl.extend({},r))),null!=e.top&&(M.top=e.top-r.top+c),null!=e.left&&(M.left=e.left-r.left+n),"using"in e?e.using.call(l,M):p.css(M)}},Tl.fn.extend({offset:function(l){if(arguments.length)return void 0===l?this:this.each(function(e){Tl.offset.setOffset(this,l,e)});var e,t,a=this[0];if(a)return a.getClientRects().length?(e=a.getBoundingClientRect(),t=a.ownerDocument.defaultView,{top:e.top+t.pageYOffset,left:e.left+t.pageXOffset}):{top:0,left:0}},position:function(){if(this[0]){var l,e,t,a=this[0],n={top:0,left:0};if("fixed"===Tl.css(a,"position"))e=a.getBoundingClientRect();else{for(e=this.offset(),t=a.ownerDocument,l=a.offsetParent||t.documentElement;l&&(l===t.body||l===t.documentElement)&&"static"===Tl.css(l,"position");)l=l.parentNode;l&&l!==a&&1===l.nodeType&&(n=Tl(l).offset(),n.top+=Tl.css(l,"borderTopWidth",!0),n.left+=Tl.css(l,"borderLeftWidth",!0))}return{top:e.top-n.top-Tl.css(a,"marginTop",!0),left:e.left-n.left-Tl.css(a,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){for(var l=this.offsetParent;l&&"static"===Tl.css(l,"position");)l=l.offsetParent;return l||Jl})}}),Tl.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(l,e){var t="pageYOffset"===e;Tl.fn[l]=function(a){return Vl(this,function(l,a,n){var i;if(Cl(l)?i=l:9===l.nodeType&&(i=l.defaultView),void 0===n)return i?i[e]:l[a];i?i.scrollTo(t?i.pageXOffset:n,t?n:i.pageYOffset):l[a]=n},l,a,arguments.length)}}),Tl.each(["top","left"],function(l,e){Tl.cssHooks[e]=B(xl.pixelPosition,function(l,t){if(t)return t=V(l,e),de.test(t)?Tl(l).position()[e]+"px":t})}),Tl.each({Height:"height",Width:"width"},function(l,e){Tl.each({padding:"inner"+l,content:e,"":"outer"+l},function(t,a){Tl.fn[a]=function(n,i){var c=arguments.length&&(t||"boolean"!==typeof n),r=t||(!0===n||!0===i?"margin":"border");return Vl(this,function(e,t,n){var i;return Cl(e)?0===a.indexOf("outer")?e["inner"+l]:e.document.documentElement["client"+l]:9===e.nodeType?(i=e.documentElement,Math.max(e.body["scroll"+l],i["scroll"+l],e.body["offset"+l],i["offset"+l],i["client"+l])):void 0===n?Tl.css(e,t,r):Tl.style(e,t,n,r)},e,c?n:void 0,c)}})}),Tl.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(l,e){Tl.fn[e]=function(l,t){return arguments.length>0?this.on(e,null,l,t):this.trigger(e)}}),Tl.fn.extend({hover:function(l,e){return this.mouseenter(l).mouseleave(e||l)}}),Tl.fn.extend({bind:function(l,e,t){return this.on(l,null,e,t)},unbind:function(l,e){return this.off(l,null,e)},delegate:function(l,e,t,a){return this.on(e,l,t,a)},undelegate:function(l,e,t){return 1===arguments.length?this.off(l,"**"):this.off(e,l||"**",t)}}),Tl.proxy=function(l,e){var t,a,n;if("string"===typeof e&&(t=l[e],e=l,l=t),wl(l))return a=Zl.call(arguments,2),n=function(){return l.apply(e||this,a.concat(Zl.call(arguments)))},n.guid=l.guid=l.guid||Tl.guid++,n},Tl.holdReady=function(l){l?Tl.readyWait++:Tl.ready(!0)},Tl.isArray=Array.isArray,Tl.parseJSON=JSON.parse,Tl.nodeName=s,Tl.isFunction=wl,Tl.isWindow=Cl,Tl.camelCase=g,Tl.type=r,Tl.now=Date.now,Tl.isNumeric=function(l){var e=Tl.type(l);return("number"===e||"string"===e)&&!isNaN(l-parseFloat(l))},a=[],void 0!==(n=function(){return Tl}.apply(e,a))&&(l.exports=n);var it=t.jQuery,ct=t.$;return Tl.noConflict=function(l){return t.$===Tl&&(t.$=ct),l&&t.jQuery===Tl&&(t.jQuery=it),Tl},i||(t.jQuery=t.$=Tl),Tl})},function(l,e){function t(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function n(l){if(h===setTimeout)return setTimeout(l,0);if((h===t||!h)&&setTimeout)return h=setTimeout,setTimeout(l,0);try{return h(l,0)}catch(e){try{return h.call(null,l,0)}catch(e){return h.call(this,l,0)}}}function i(l){if(p===clearTimeout)return clearTimeout(l);if((p===a||!p)&&clearTimeout)return p=clearTimeout,clearTimeout(l);try{return p(l)}catch(e){try{return p.call(null,l)}catch(e){return p.call(this,l)}}}function c(){m&&u&&(m=!1,u.length?Z=u.concat(Z):d=-1,Z.length&&r())}function r(){if(!m){var l=n(c);m=!0;for(var e=Z.length;e;){for(u=Z,Z=[];++d<e;)u&&u[d].run();d=-1,e=Z.length}u=null,m=!1,i(l)}}function o(l,e){this.fun=l,this.array=e}function s(){}var h,p,M=l.exports={};!function(){try{h="function"===typeof setTimeout?setTimeout:t}catch(l){h=t}try{p="function"===typeof clearTimeout?clearTimeout:a}catch(l){p=a}}();var u,Z=[],m=!1,d=-1;M.nextTick=function(l){var e=new Array(arguments.length-1);if(arguments.length>1)for(var t=1;t<arguments.length;t++)e[t-1]=arguments[t];Z.push(new o(l,e)),1!==Z.length||m||n(r)},o.prototype.run=function(){this.fun.apply(null,this.array)},M.title="browser",M.browser=!0,M.env={},M.argv=[],M.version="",M.versions={},M.on=s,M.addListener=s,M.once=s,M.off=s,M.removeListener=s,M.removeAllListeners=s,M.emit=s,M.prependListener=s,M.prependOnceListener=s,M.listeners=function(l){return[]},M.binding=function(l){throw new Error("process.binding is not supported")},M.cwd=function(){return"/"},M.chdir=function(l){throw new Error("process.chdir is not supported")},M.umask=function(){return 0}},function(l,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=["world_mill","us_aea","europe_mill","continents_mill","ch_mill","oceania_mill","africa_mill","asia_mill","north_america_mill","south_america_mill","ca_lcc","brazil","se_mill","es_mill","ar_mill","vietnam","fr_mill","indonesia","th_mill","de_mill","au_mill","kr_mill","co_mill","in_mill","fr_regions_mill","ru_mill"]},function(l,e,t){"use strict";function a(l){return function(){return l}}var n=function(){};n.thatReturns=a,n.thatReturnsFalse=a(!1),n.thatReturnsTrue=a(!0),n.thatReturnsNull=a(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(l){return l},l.exports=n},function(l,e,t){"use strict";(function(e){function t(l,e,t,n,i,c,r,o){if(a(e),!l){var s;if(void 0===e)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var h=[t,n,i,c,r,o],p=0;s=new Error(e.replace(/%s/g,function(){return h[p++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var a=function(l){};"production"!==e.env.NODE_ENV&&(a=function(l){if(void 0===l)throw new Error("invariant requires an error message argument")}),l.exports=t}).call(e,t(1))},function(l,e,t){"use strict";l.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(l,e,t){"use strict";(function(e){var a=t(3),n=a;if("production"!==e.env.NODE_ENV){var i=function(l){for(var e=arguments.length,t=Array(e>1?e-1:0),a=1;a<e;a++)t[a-1]=arguments[a];var n=0,i="Warning: "+l.replace(/%s/g,function(){return t[n++]});"undefined"!==typeof console&&console.error(i);try{throw new Error(i)}catch(l){}};n=function(l,e){if(void 0===e)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==e.indexOf("Failed Composite propType: ")&&!l){for(var t=arguments.length,a=Array(t>2?t-2:0),n=2;n<t;n++)a[n-2]=arguments[n];i.apply(void 0,[e].concat(a))}}}l.exports=n}).call(e,t(1))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","africa_mill",{insets:[{width:900,top:0,height:1054.4456598737515,bbox:[{y:-4361143.781154416,x:-2822439.5658800667},{y:5651492.432223669,x:5723636.287018039}],left:0}],paths:{BF:{path:"M264.1,336.73l-0.38,0.6l0.64,1.4l-0.24,0.6l0.45,4.56l-0.35,0.78l0.96,2.95l-0.52,0.38l-1.13,-1.12l-1.14,-1.92l-3.05,-2.52l-6.67,-0.25l-5.65,2.08l-0.81,1.11l-1.3,-0.33l-0.81,-0.58l-1.06,0.11l-0.97,-0.44l-2.77,-1.95l-0.31,-1.37l-1.35,-2.42l-2.01,-0.98l-1.43,0.04l-1.31,-1.03l0.73,-3.93l-0.35,-3.1l1.58,-1.01l1.2,-3.07l0.23,-1.91l-0.71,-1.89l0.01,-1.44l1.9,-1.47l3.57,-0.76l1.28,-0.57l1.37,-0.98l1.89,-2.21l0.18,-3.18l-0.55,-0.89l2.84,-1.62l-0.0,-1.17l-1.15,-2.62l1.92,-2.04l1.07,-0.83l1.03,-0.2l4.85,2.6l2.89,-1.19l0.65,-1.69l0.16,-2.87l2.6,0.33l0.84,-0.24l0.52,-0.67l-0.09,-1.24l0.56,-1.81l1.04,-1.38l2.19,-1.78l1.28,-0.48l4.22,1.21l0.87,-0.55l0.92,-2.93l3.12,-0.59l2.38,-1.42l5.16,-2.3l3.42,-2.74l2.42,-0.33l1.68,0.77l1.87,-0.53l4.84,1.61l-0.54,4.66l2.53,3.13l-0.28,1.32l0.93,2.11l2.22,3.21l3.45,1.25l0.77,0.57l0.62,1.12l1.49,0.83l-1.54,-0.34l-0.49,0.28l-0.2,2.42l0.31,1.85l1.36,0.54l5.62,4.39l2.81,0.25l2.58,-1.21l0.76,0.11l0.56,0.66l0.68,2.06l-1.55,0.4l-0.37,0.74l0.45,1.07l3.34,4.38l-1.06,2.14l-3.38,3.04l-1.4,-0.26l-2.79,0.47l-0.58,-0.54l-1.85,0.09l-1.35,1.84l-1.84,0.43l-1.01,2.24l-1.1,0.01l-0.52,0.8l-4.55,0.45l-0.36,-0.43l-9.2,-2.08l-0.8,0.93l-1.17,0.12l-0.64,0.9l-1.44,0.83l-0.73,-0.69l-3.99,-0.25l-21.0,0.14l-0.48,0.5l-0.82,3.01l-0.1,1.69l0.51,1.27l0.95,0.91Z",name:"Burkina Faso"},DJ:{path:"M800.21,310.86l2.49,-0.89l2.06,2.6l1.22,3.04l-0.29,1.0l-1.15,1.3l-2.56,1.63l-2.88,1.05l-1.89,2.09l-1.18,-0.12l-0.43,0.5l0.21,0.81l0.84,0.38l3.96,-1.06l2.72,0.22l0.63,0.5l-3.48,5.46l-1.25,-0.1l-1.52,-0.81l-1.29,-0.06l-7.07,1.65l-1.47,-0.35l-0.35,-6.88l0.5,-1.41l2.1,-2.23l4.78,-6.87l0.41,-0.18l2.18,1.59l0.67,0.03l1.08,-0.76l0.97,-2.11Z",name:"Djibouti"},BI:{path:"M645.42,511.17l-3.4,-6.8l-0.35,-5.31l-0.5,-0.69l-0.91,-0.23l0.15,-3.04l-2.45,-3.14l0.12,-1.27l0.29,-0.52l1.17,0.22l1.0,0.53l0.56,1.26l0.68,0.41l3.89,-0.15l2.23,-1.13l0.73,-4.21l1.87,0.92l1.43,-0.81l1.84,-0.36l1.16,0.82l-1.21,2.39l0.44,0.94l-0.49,1.29l0.1,0.79l1.2,0.8l3.01,0.8l0.04,2.71l-1.83,0.84l-0.27,0.31l0.11,0.7l-2.25,1.87l-0.64,1.8l-1.27,1.37l-1.42,2.74l-2.26,2.52l-2.81,1.65Z",name:"Burundi"},BJ:{path:"M308.12,330.21l0.86,-0.9l0.64,0.14l0.6,-0.3l0.86,-2.1l1.82,-0.46l1.23,-1.76l1.22,-0.03l0.73,0.59l2.95,-0.5l1.71,0.19l3.64,-3.28l0.95,-1.86l0.61,-1.99l-0.56,-2.46l3.11,-0.81l1.69,-0.98l0.63,0.14l3.09,2.89l1.79,2.3l1.82,0.94l1.42,1.5l-1.11,2.16l-0.07,1.39l2.7,3.89l0.46,3.62l0.9,1.82l-0.57,1.92l-0.76,-0.15l-0.67,0.27l-0.97,1.57l0.01,0.66l0.72,1.13l-0.93,2.67l-2.37,1.13l-0.44,0.68l0.04,1.14l-2.2,2.49l0.07,1.73l-1.05,2.47l-2.97,0.39l-0.35,0.34l-0.49,3.14l-0.55,10.76l0.42,3.23l0.74,1.58l-0.4,0.87l0.07,3.84l-0.41,1.09l0.59,3.12l-0.76,3.68l-10.19,1.27l-0.39,-1.8l-1.68,-2.19l-0.17,-0.62l0.25,-0.77l-0.62,-2.49l0.9,-0.43l-0.29,-24.23l-0.51,-1.3l-2.01,-2.49l-0.45,-2.39l-0.22,-5.16l-6.61,-4.58l0.26,-3.59l1.26,-3.12Z",name:"Benin"},ZA:{path:"M740.97,1053.87l-0.3,0.16l-2.08,-0.34l0.77,-0.88l0.95,0.15l0.83,0.6l-0.17,0.3ZM513.38,877.36l-0.7,-2.43l0.21,-1.52l1.33,-0.97l-0.39,-2.31l-2.04,-3.95l-1.28,-0.93l-0.91,-1.89l-0.98,-0.79l-0.44,-1.41l-0.87,-1.03l-0.28,-1.52l0.86,-1.1l1.02,0.73l1.17,-0.42l1.58,-1.41l0.87,-1.92l-0.14,-5.2l-1.18,-4.99l-6.3,-9.48l-3.86,-7.37l-1.84,-4.4l-2.82,-8.97l-2.49,-5.08l-3.19,-4.84l1.71,-1.23l1.58,-0.5l1.51,-4.23l0.55,-0.6l1.17,-0.4l0.86,0.51l0.67,1.49l1.71,0.81l0.27,0.89l-0.5,1.25l0.06,0.63l1.46,2.85l2.93,0.89l3.23,0.54l1.6,0.79l8.58,-0.04l2.15,0.73l1.89,0.12l1.15,-0.62l0.66,-2.0l1.14,-0.28l0.89,-0.67l0.72,-1.13l1.41,-0.82l2.31,-0.66l1.14,0.02l0.41,-0.4l0.0,-45.51l3.59,2.68l0.95,1.39l4.2,9.51l0.27,2.9l-2.22,3.62l0.17,3.82l0.55,1.14l1.12,0.53l1.45,-0.47l2.34,0.53l4.45,-0.24l2.39,0.25l1.22,-0.68l1.03,-1.55l2.03,-0.52l1.07,-0.76l1.54,-2.45l4.44,-3.21l0.59,-0.91l2.77,-7.63l0.78,-1.0l1.09,-0.64l2.32,-0.54l1.33,0.28l3.19,1.73l2.71,2.14l0.99,0.34l2.51,0.09l1.71,1.37l4.87,0.93l1.67,-0.08l1.44,-0.71l2.47,0.03l2.89,-0.6l1.77,-1.52l3.74,-10.56l5.64,-1.65l0.77,-0.5l1.88,-2.25l2.53,-1.91l1.9,-6.79l1.09,-1.48l2.61,-1.84l2.17,-0.7l0.76,-0.54l0.84,-1.24l1.42,-0.32l0.29,-0.74l1.83,-1.35l0.14,-0.7l3.09,-3.46l1.9,-1.17l3.64,-0.71l1.74,-0.69l1.35,-1.12l0.83,-1.45l1.19,-0.7l6.13,-0.81l2.7,0.45l3.43,1.33l3.27,0.47l5.28,-0.47l1.78,0.2l2.22,1.0l2.84,10.65l0.18,2.57l3.01,5.17l2.14,6.91l-0.02,14.51l-0.75,1.88l0.25,2.05l-0.38,0.1l-5.35,-2.92l-1.09,0.12l-1.7,1.23l-1.4,1.72l-0.68,1.53l-2.73,4.04l-0.07,4.73l0.46,0.47l0.66,0.07l2.05,3.86l2.6,1.72l2.49,0.78l3.2,0.18l2.56,-0.05l0.39,-0.43l-0.14,-1.63l0.52,-4.16l3.87,0.62l5.77,-0.15l-0.36,2.4l-2.25,6.66l-1.43,7.49l-1.84,3.72l-1.01,1.51l-2.97,2.73l-1.48,0.86l-1.49,0.43l-5.23,5.67l-1.94,2.72l-1.74,4.0l-1.71,2.2l-4.74,8.26l-2.14,3.28l-3.68,4.5l-2.75,1.91l-2.96,2.65l-7.38,8.08l-4.73,4.27l-2.78,1.91l-4.1,3.69l-5.83,4.03l-3.32,2.09l-7.45,3.08l-5.07,-0.62l-2.27,0.34l-1.99,1.57l-0.29,2.16l-0.44,0.19l-4.58,-0.97l-2.09,0.16l-1.39,1.25l-0.86,1.33l-2.44,0.07l-4.83,-1.48l-5.72,-0.91l-1.5,-0.07l-3.6,1.24l-3.92,-0.23l-2.3,-0.7l-2.13,-0.0l-3.86,0.86l-5.25,3.93l-2.63,0.0l-2.42,0.46l-4.2,-0.54l-1.32,0.26l-1.31,0.71l-2.94,0.34l-5.89,4.21l-4.29,-0.41l-2.76,-1.89l-0.65,-0.02l0.02,-1.4l-1.07,-1.12l-1.17,-0.04l-0.78,-0.87l-2.78,0.16l-0.24,-3.04l-0.95,-0.65l-2.91,0.11l-0.94,1.2l-0.06,1.39ZM623.55,807.58l-1.33,0.56l-5.08,7.29l-2.34,1.04l-0.45,0.34l-0.22,0.76l0.97,2.51l2.58,4.01l-0.03,1.17l0.48,0.94l1.3,0.73l3.08,3.04l3.47,0.6l1.11,-0.88l0.57,-1.81l2.77,-3.68l3.97,-0.58l2.01,-0.85l2.35,-1.56l0.64,-2.92l1.77,-1.76l1.17,-3.92l-1.08,-2.49l-4.17,-2.79l-3.9,-3.86l-2.17,0.4l-2.81,1.09l-3.25,2.21l-1.44,0.43Z",name:"South Africa"},BW:{path:"M592.94,670.5l-0.23,1.26l0.71,1.59l1.23,1.28l2.04,3.62l2.35,2.48l0.65,1.85l1.45,1.67l0.11,1.69l2.56,5.57l6.11,4.47l5.85,2.54l0.78,1.38l0.27,2.94l0.41,0.38l4.41,0.23l0.15,2.87l-0.36,3.84l2.09,2.49l2.0,3.59l0.63,0.38l5.67,0.95l5.59,1.71l-0.22,1.52l0.42,1.17l0.85,0.66l1.53,0.2l0.68,0.71l-1.78,0.15l-1.53,0.86l-0.91,1.53l-1.14,0.97l-1.61,0.64l-3.77,0.75l-2.01,1.24l-2.24,2.32l-1.09,1.4l-0.12,0.65l-1.8,1.31l-0.2,0.62l-1.22,0.19l-1.62,1.81l-2.2,0.71l-2.77,1.97l-1.27,1.76l-1.75,6.53l-2.49,1.88l-2.45,2.61l-3.1,0.72l-2.77,1.1l-3.86,10.72l-1.49,1.23l-2.54,0.49l-2.51,-0.03l-1.61,0.75l-1.29,0.04l-4.76,-0.92l-1.79,-1.39l-3.3,-0.35l-2.6,-2.07l-3.36,-1.81l-1.52,-0.33l-1.57,0.28l-1.61,0.5l-1.77,1.76l-3.29,8.45l-4.38,3.15l-1.55,2.46l-0.82,0.61l-1.99,0.51l-0.68,0.47l-1.05,1.61l-7.08,0.09l-2.33,-0.53l-1.57,0.47l-0.8,-1.03l-0.17,-3.51l2.21,-3.57l-0.28,-3.35l-4.29,-9.69l-1.09,-1.56l-4.12,-3.05l-0.04,-33.77l11.25,0.0l0.39,-0.32l0.05,-44.66l11.82,-1.44l14.08,-2.4l0.71,0.26l1.82,2.37l1.36,2.58l0.7,0.36l1.27,-0.46l2.42,-2.43l3.94,-2.42l1.22,-0.5l2.22,0.81l3.02,-2.24l1.27,-0.49l3.45,-0.39Z",name:"Botswana"},DZ:{path:"M221.33,99.35l5.55,-0.16l6.56,-1.62l1.94,-1.36l1.39,-1.43l2.48,-3.82l2.1,-1.06l5.33,-1.88l3.96,-2.76l3.8,-0.7l0.66,-0.8l-0.08,-1.13l-2.32,-1.51l0.5,-2.08l-0.68,-3.22l0.65,-0.61l3.77,-0.18l5.04,-1.7l0.6,-0.79l0.62,-2.04l0.54,-0.29l4.79,-0.71l13.74,0.53l0.74,-0.27l0.25,-0.37l-0.41,-2.14l0.19,-0.64l1.95,-1.62l0.11,-0.49l-0.64,-1.23l-3.91,-2.98l-0.64,-1.1l-0.52,-2.63l-1.44,-3.04l0.54,-3.16l-0.97,-2.93l0.25,-2.74l-0.17,-2.45l-0.95,-2.48l0.64,-1.41l-1.32,-1.83l0.6,-1.91l-4.07,-3.16l-0.72,-1.01l3.05,0.07l2.93,-1.21l4.11,-2.52l2.84,-2.79l7.62,-3.71l2.73,0.57l1.86,-0.27l1.23,-1.02l1.17,-2.1l1.79,-1.26l7.68,-3.75l3.27,-0.99l12.68,-1.21l2.9,0.13l4.55,-2.47l6.35,-0.14l3.11,-1.36l11.33,-0.0l2.63,1.13l2.44,1.81l1.39,0.39l1.59,-0.39l3.49,-1.65l4.02,-0.89l2.16,-1.0l1.01,-1.47l1.48,-0.43l1.07,1.05l4.12,1.13l3.87,-0.66l0.27,-0.48l-0.26,-1.08l2.04,0.34l1.97,0.77l2.11,1.58l1.54,0.39l2.7,-0.72l4.92,-0.34l0.15,0.75l-1.6,0.85l-1.01,1.82l-1.55,1.12l-0.44,0.7l0.24,0.66l1.01,0.49l0.39,0.87l-1.18,7.58l0.84,2.07l-0.03,3.22l0.88,2.63l-0.87,1.43l-0.46,1.49l-0.37,3.25l-1.33,2.08l-3.26,1.97l-1.16,2.14l-2.75,2.31l-0.25,3.53l2.8,7.65l0.48,0.56l4.0,2.24l1.11,1.61l1.56,5.14l8.2,5.98l5.48,23.47l-2.2,1.33l-0.13,0.55l3.85,6.11l1.91,5.8l0.42,2.6l-0.31,5.2l0.5,6.57l0.66,3.21l-1.96,5.8l0.58,3.71l0.49,1.63l0.65,0.87l-0.12,2.54l-0.23,0.81l-4.32,2.79l-0.68,1.25l-0.17,1.41l0.36,1.12l6.44,9.15l0.31,3.47l1.07,3.25l1.71,2.65l1.86,1.42l0.67,0.05l2.78,-0.85l9.44,2.89l5.07,9.39l-52.31,32.38l-19.32,17.03l-0.94,0.5l-28.22,5.41l-2.21,-1.53l1.57,-2.44l0.16,-0.76l-0.64,-1.89l0.02,-2.73l-1.0,-1.05l-3.24,-1.37l-5.26,-1.26l-1.41,-1.71l-0.82,-0.54l-3.55,-0.36l-1.93,-0.67l-0.68,-0.49l-0.88,-2.15l-3.87,-2.03l-1.27,-1.07l0.08,-1.93l-0.49,-1.74l-66.42,-45.76l-11.74,-7.74l-36.95,-23.29l0.16,-17.66l11.35,-8.01l2.34,-0.55l3.78,-2.8l5.93,0.6l0.75,-0.22l0.97,-1.1l0.25,-1.88Z",name:"Algeria"},ET:{path:"M725.94,291.31l1.59,-0.58l1.43,-0.08l2.7,0.48l0.61,-0.32l0.82,-1.39l1.01,-0.41l0.96,0.83l1.77,2.54l1.16,0.25l3.75,-8.2l1.03,1.12l2.48,0.99l1.79,2.1l0.92,0.64l4.56,-0.65l2.86,-1.74l1.54,1.78l0.99,0.1l2.98,-0.77l2.55,0.43l1.76,0.7l2.77,-0.18l0.84,0.26l3.51,2.43l2.92,1.0l1.85,1.82l2.18,2.98l2.82,2.82l4.68,3.74l2.17,3.56l2.21,1.42l2.63,3.35l-4.31,6.33l-2.45,2.83l-0.34,3.34l0.4,5.17l0.27,0.35l2.11,0.47l7.0,-1.64l0.99,0.03l1.51,0.81l1.06,0.14l-1.56,1.9l-1.21,1.96l-0.07,0.61l1.49,2.73l0.69,2.0l2.69,3.32l1.34,0.64l1.39,3.09l2.16,2.79l1.75,0.62l4.76,4.15l34.61,11.66l10.92,0.04l-17.54,17.0l-17.34,18.6l-10.93,-0.52l-4.87,1.14l-5.48,2.53l-1.37,1.04l-1.78,2.71l-7.25,1.39l-2.4,0.75l-1.75,1.86l-6.41,0.41l-1.94,-0.21l-3.04,-2.61l-1.65,-1.03l-10.87,4.97l-2.27,3.29l-1.66,1.29l-6.08,-0.75l-4.27,-0.94l-5.97,-0.55l-13.9,-8.97l-10.28,-0.64l-2.84,-3.78l-0.07,-1.51l0.51,-2.54l-0.17,-1.57l-0.77,-0.92l-3.24,-0.88l-1.76,0.59l-0.34,-0.26l-0.05,-1.06l-2.16,-2.09l-1.1,-2.08l-0.32,-2.25l-3.0,-7.36l-1.7,-1.38l-1.03,-1.48l-2.35,-1.2l-2.43,-2.53l-0.51,-1.66l-1.49,-1.78l-2.88,-1.96l-5.15,-1.06l-2.36,-1.3l3.05,-5.92l7.75,-0.06l1.97,-1.84l-0.12,-11.17l0.91,-3.93l1.79,-4.02l-0.39,-4.04l1.71,-2.87l1.37,-0.92l2.44,1.52l0.66,-0.22l1.4,-1.3l0.53,-3.71l-0.08,-1.4l1.71,-6.24l1.65,-1.69l4.82,-7.84l1.58,-0.64l3.63,-0.69l0.37,-1.06l0.29,-3.43l0.59,-2.06l2.1,-4.28l0.66,-2.58l-0.02,-1.8l0.85,-2.9Z",name:"Ethiopia"},RW:{path:"M636.22,488.26l1.26,-0.91l1.11,-0.31l3.12,-3.45l0.23,-0.83l-1.49,-3.68l1.28,-1.64l2.53,-1.49l2.72,-0.58l0.72,1.41l1.45,-0.17l1.44,-1.01l2.6,-3.03l0.8,-0.44l0.3,0.02l0.44,1.46l1.5,1.94l1.0,0.44l0.5,0.61l0.54,1.12l0.07,4.67l0.54,0.99l0.12,1.02l-0.7,2.22l-2.66,0.4l-1.82,-1.01l-2.16,0.44l-1.14,0.76l-1.49,-0.87l-0.74,-0.03l-0.38,0.37l-0.64,4.17l-1.74,0.8l-3.47,0.17l-0.99,-1.54l-2.37,-0.94l-0.91,0.27l-0.5,1.03l-0.74,-0.57l-0.32,-1.82Z",name:"Rwanda"},TZ:{path:"M644.97,516.58l0.34,-4.61l0.73,-0.07l2.75,-1.8l2.34,-2.61l1.44,-2.77l1.32,-1.45l0.54,-1.65l2.32,-1.91l0.01,-0.89l1.73,-0.74l0.51,-1.14l-0.4,-2.83l-3.35,-0.98l-0.71,-0.33l-0.07,-0.35l0.54,-1.4l-0.47,-0.77l1.15,-2.31l2.85,-0.57l0.51,-0.36l0.71,-2.54l-0.14,-1.28l-0.54,-0.98l-0.11,-4.79l-1.25,-2.03l-0.99,-0.42l-1.36,-1.75l-0.34,-0.99l2.03,-0.25l1.49,-0.64l11.95,0.24l-0.4,3.55l-0.73,1.55l-1.17,5.25l0.13,4.05l1.26,2.01l-0.54,1.03l0.18,0.62l0.62,0.55l-0.27,0.69l0.26,1.29l0.42,0.3l0.53,-0.25l0.27,-0.85l0.41,-0.17l0.39,0.57l0.66,0.23l0.44,-0.51l-0.24,-2.1l1.79,-0.16l0.18,-0.44l-0.51,-1.29l1.57,-1.06l0.72,1.22l1.06,0.65l0.89,0.12l0.26,0.53l0.53,0.05l0.89,-0.65l0.47,0.59l1.22,0.21l-0.07,1.31l0.5,1.15l-0.97,0.97l-0.19,1.62l0.62,0.4l1.52,-1.4l0.71,-0.13l0.28,-0.57l-0.87,-2.06l0.09,-1.95l0.42,-0.49l1.11,-0.09l1.72,0.93l2.65,0.47l0.49,-0.38l0.02,-0.58l4.25,-3.12l-0.1,-1.24l-0.74,-0.36l-2.13,0.64l-3.59,-0.58l1.78,-0.61l1.16,-0.01l0.39,-0.48l-0.77,-1.09l-1.56,-0.14l0.58,-0.45l1.09,0.08l1.33,-0.78l0.22,-0.91l0.88,-0.93l-0.29,-0.75l0.22,-0.55l2.55,0.33l0.33,-0.73l-1.08,-0.91l0.08,-0.38l1.28,-0.24l0.04,-0.69l-0.44,-0.51l1.47,-1.96l41.71,23.3l0.4,2.07l-0.91,2.38l0.09,0.83l1.23,0.54l1.04,1.59l16.48,11.86l-2.76,9.33l-0.79,1.29l-1.08,2.96l-0.19,2.37l0.91,3.37l1.26,1.46l1.69,1.19l1.16,1.46l0.67,1.48l2.25,0.91l0.72,1.43l-0.25,0.93l-0.99,0.98l-0.94,1.58l-0.81,2.28l-0.02,3.18l0.68,0.29l0.28,-0.26l0.72,0.49l0.13,2.05l-1.16,2.69l-0.42,2.58l0.86,3.27l1.26,1.67l-0.33,1.1l2.14,2.83l-0.14,2.6l1.73,5.01l0.08,0.71l-0.6,0.9l0.27,0.62l1.51,0.24l1.23,1.45l1.38,0.17l3.45,2.23l0.64,0.9l-5.28,4.01l-1.96,1.06l-2.98,0.79l-2.85,1.71l-1.64,0.49l-2.22,0.02l-2.26,0.73l-3.44,2.1l-1.86,-1.09l-1.74,-0.43l-3.31,0.24l-0.55,0.43l-0.66,1.93l-1.1,1.05l-2.05,1.07l-1.85,0.39l-1.7,-0.27l-2.93,-1.43l-1.38,0.08l-2.36,1.34l-1.68,0.35l-2.4,-0.11l-1.08,-0.34l-0.27,-0.73l-1.09,-0.86l-2.25,-1.07l-1.76,0.1l-0.92,0.92l-1.46,0.75l-6.7,-0.3l-0.8,-2.01l-0.72,-0.67l-0.78,-0.14l-1.78,-2.85l0.71,-3.19l-0.06,-1.07l-0.9,-2.23l-0.18,-3.36l-0.59,-2.65l-2.47,-3.64l-2.72,-2.29l-1.18,-0.56l-0.46,0.09l-0.62,0.96l0.06,0.99l-2.57,-0.86l-3.12,0.15l-1.19,-1.08l-2.29,-0.28l-1.74,-1.13l-0.85,0.04l-4.84,-2.19l-0.8,-0.73l-2.44,-0.36l-1.17,-0.63l-1.97,-0.2l-0.31,-1.29l-1.28,-0.52l-1.64,0.09l-1.18,-1.05l-0.39,-1.22l-1.0,-0.7l-1.39,-0.63l-1.67,0.03l-0.42,-1.69l-2.07,-2.49l-0.06,-1.31l-2.75,-5.02l-1.4,-1.85l-0.05,-1.9l-0.96,-2.74l0.48,-0.66l0.06,-1.01l-0.46,-1.02l-0.91,-0.88l-1.81,-2.8l-1.67,-1.67l-1.13,-0.35l-1.39,0.42l-2.51,-2.66l0.27,-2.19l1.84,-0.96l0.58,-1.21l-1.05,-2.93l-1.22,-1.91l0.69,-3.57l-0.3,-1.39l-0.66,-0.88l-1.43,-0.88ZM762.78,552.69l-0.45,-0.03l2.18,-1.95l-0.46,1.08l-0.77,0.24l-0.51,0.66ZM764.47,517.47l-0.18,3.41l-0.94,1.84l-0.66,-0.51l0.6,-2.83l-0.24,-1.79l1.42,-0.13ZM760.15,532.01l0.83,2.31l-0.43,0.34l-0.52,-0.95l-0.74,-0.16l-0.92,-0.93l-0.6,-0.04l-0.52,-0.88l0.25,-1.03l-0.15,-1.61l1.05,-1.58l0.23,1.82l0.76,1.93l0.77,0.77ZM683.58,482.55l0.38,0.28l1.24,-0.06l0.79,1.43l-3.05,-1.0l-0.14,-1.03l0.6,-0.17l0.18,0.55ZM670.5,485.68l0.64,0.7l1.71,-0.3l-0.03,0.36l-1.27,0.27l-0.41,0.62l-0.7,-0.98l0.06,-0.68Z",name:"Tanzania"},GQ:{path:"M410.07,446.64l-1.07,-0.77l-1.18,-0.22l1.11,-3.0l1.66,-1.63l0.99,-2.55l1.02,-1.6l-0.11,-3.49l1.8,0.85l15.42,0.0l0.07,12.9l-14.92,-0.05l-1.36,0.5l-1.02,-0.39l-0.73,-0.94l-1.1,0.01l-0.59,0.36ZM399.74,415.59l1.81,-0.01l0.26,0.34l-0.04,0.66l-1.74,2.58l-0.37,1.17l-0.56,0.76l-0.36,0.05l-1.91,-0.51l-0.27,-0.45l0.22,-1.02l1.41,-0.56l0.73,-2.22l0.81,-0.78Z",name:"Eq. Guinea"},NA:{path:"M466.74,733.07l0.38,0.14l0.53,-0.3l0.29,-1.49l0.06,-1.38l-0.78,-3.22l-1.69,-3.26l-4.06,-5.17l-1.58,-3.62l-4.54,-6.79l-3.29,-8.89l-1.52,-2.0l-6.83,-13.38l-1.6,-2.24l-3.3,-3.31l-1.06,-2.44l-2.01,-3.19l-0.48,-2.93l0.08,-5.67l1.56,-0.23l1.36,-0.7l0.99,-0.04l1.23,0.54l3.93,0.03l6.56,-2.95l4.09,0.79l1.02,1.22l1.56,1.11l2.97,1.93l0.99,0.26l4.73,-0.25l46.65,0.14l0.82,0.42l2.79,3.2l2.87,1.25l5.01,0.28l3.11,0.53l6.52,-0.06l2.21,0.27l2.71,1.31l1.59,0.3l4.32,-0.77l1.91,0.08l1.68,0.45l33.47,-6.28l7.59,0.74l1.71,1.01l1.22,1.2l-3.15,0.36l-1.47,0.55l-2.98,2.19l-1.88,-0.83l-1.58,0.57l-2.92,1.63l-3.54,3.27l-0.86,0.33l-1.39,-2.56l-1.91,-2.5l-1.28,-0.49l-14.2,2.41l-9.11,1.31l-3.01,0.14l-0.38,0.4l0.04,44.55l-11.33,0.0l-0.4,0.4l0.04,80.24l-3.33,0.69l-1.64,0.94l-0.77,1.18l-0.76,0.57l-1.24,0.35l-0.49,0.57l0.02,1.07l-0.29,0.46l-0.78,0.38l-1.43,-0.12l-2.25,-0.75l-2.8,-0.18l-3.43,0.39l-2.32,-0.18l-1.49,-0.76l-6.0,-1.39l-1.09,-2.32l0.46,-1.7l-0.33,-1.21l-0.66,-0.69l-1.17,-0.31l-0.68,-1.49l-1.21,-0.76l-1.78,0.45l-0.85,0.85l-1.42,4.13l-1.43,0.38l-1.94,1.43l-6.19,-5.65l-1.96,-2.31l-5.01,-8.64l-1.8,-6.11l-0.09,-1.33l0.45,-1.04l-0.28,-1.16l-0.62,-1.24l-1.39,-1.25l-0.41,-4.36l-1.0,-2.93l0.21,-2.32l-0.53,-3.62l0.2,-2.77l-0.81,-3.06l-1.66,-3.05l-1.46,-4.23l-0.32,-11.33l-0.81,-3.84l0.15,-0.39Z",name:"Namibia"},NE:{path:"M321.81,313.66l1.53,-0.4l0.4,-0.89l-0.22,-1.1l-1.45,-2.12l-1.95,-0.1l-1.94,1.11l-2.45,-0.24l-5.39,-4.29l-1.15,-0.38l-0.09,-3.16l1.82,0.33l0.68,-0.44l-0.04,-0.61l-2.08,-1.29l-0.5,-1.0l-1.0,-0.75l-3.25,-1.11l-2.12,-3.07l-0.8,-1.8l0.24,-1.49l-2.48,-2.91l0.68,-5.15l5.45,0.19l2.78,-0.35l4.15,-3.46l19.81,-0.82l0.66,-1.03l5.16,0.84l0.46,-0.35l0.17,-1.37l2.04,-1.75l1.66,-0.81l1.31,-3.09l0.79,-2.94l1.26,-2.04l0.73,-2.79l0.23,-4.44l0.38,-0.57l-0.08,-25.67l17.51,-3.48l1.14,-0.59l19.35,-17.05l52.45,-32.47l17.54,4.13l1.29,0.7l7.35,6.23l0.48,-0.02l8.29,-4.41l2.16,12.67l0.17,5.07l1.36,1.45l3.48,5.3l-0.67,1.12l0.55,1.73l4.36,4.66l-2.64,5.31l-3.05,36.2l-12.92,13.89l-6.58,9.41l-1.95,4.04l-2.24,2.94l1.66,7.95l-2.93,0.41l-1.59,1.19l-3.77,1.49l-2.64,1.53l-1.7,1.58l-0.55,1.13l-3.62,0.02l-1.52,-1.2l-3.53,-1.28l-3.33,-0.67l-5.41,-0.22l-5.67,0.49l-3.48,0.73l-1.75,0.81l-1.44,0.91l-3.55,3.74l-4.66,-0.12l-5.18,-1.01l-3.4,-1.78l-4.22,-2.75l-3.26,-0.65l-0.74,0.08l-4.95,2.7l-2.18,0.27l-1.39,1.02l-1.14,-0.09l-1.38,-1.06l-2.54,-3.62l-3.47,-3.04l-1.54,-0.13l-8.22,-2.48l-1.61,0.45l-1.39,0.93l-4.84,-0.04l-3.14,0.7l-1.76,0.72l-2.05,1.71l-1.11,0.52l-0.9,5.04l-0.54,1.37l-1.02,1.82l-3.62,3.17l-0.08,6.6l-0.33,1.1l0.59,1.46l-0.27,0.23l-1.57,-1.62l-1.7,-0.84l-1.78,-2.28l-3.39,-3.09l-1.09,-0.17l-1.79,1.01l-3.36,0.92l-0.28,0.74l0.48,2.67l-3.22,-4.6Z",name:"Niger"},NG:{path:"M338.89,383.6l2.54,-1.3l-0.03,-0.73l-0.68,-0.18l-3.28,0.84l-1.28,1.51l-6.76,0.28l0.76,-3.44l-0.58,-3.21l0.4,-1.07l-0.07,-3.83l0.41,-1.05l-0.77,-1.74l-0.38,-3.03l0.54,-10.63l0.44,-2.81l3.16,-0.57l0.81,-1.34l0.44,-1.57l-0.11,-1.56l2.13,-2.36l0.08,-1.47l2.54,-1.34l0.66,-1.31l0.54,-1.9l-0.79,-1.5l0.27,-0.67l0.61,-0.69l0.99,0.13l0.54,-0.54l0.61,-2.19l-0.92,-2.01l-0.46,-3.61l-2.67,-3.8l0.03,-1.02l0.7,-1.48l1.32,-1.61l-0.59,-1.61l0.33,-1.04l0.07,-6.43l3.4,-2.82l1.15,-2.01l0.62,-1.58l0.68,-4.61l1.0,-0.46l2.05,-1.71l4.52,-1.29l4.94,0.02l1.55,-1.0l1.31,-0.37l8.03,2.47l1.3,0.04l3.27,2.88l2.53,3.62l1.77,1.29l1.51,0.1l1.52,-1.06l2.17,-0.26l5.34,-2.74l2.96,0.57l4.18,2.72l3.58,1.86l5.33,1.04l4.91,0.13l3.94,-3.96l1.29,-0.81l1.58,-0.74l3.34,-0.7l5.62,-0.49l5.27,0.21l3.23,0.65l3.39,1.23l1.67,1.25l2.36,0.2l1.78,-0.24l0.83,-1.36l1.6,-1.49l2.51,-1.44l3.83,-1.51l1.47,-1.12l2.92,-0.36l5.2,7.23l1.55,8.19l1.14,0.62l1.71,0.16l1.06,0.48l1.05,1.56l-0.27,3.59l-0.42,1.35l0.04,2.5l-4.04,2.55l-2.67,0.72l-1.12,0.93l-2.27,3.19l-1.98,3.29l-1.38,5.02l-1.73,1.72l-0.81,5.49l-1.97,0.77l-1.19,0.9l-0.66,1.55l-0.81,4.89l-0.8,1.5l-1.58,1.31l-2.31,0.53l-1.99,3.69l-0.93,4.05l-1.56,2.65l-0.11,1.52l-2.86,3.7l0.97,1.91l-3.18,2.63l-0.57,2.7l-2.25,1.88l-1.77,0.5l-0.54,-0.53l-0.86,-2.8l-3.25,-3.02l-1.62,-0.94l-0.8,0.12l-0.77,1.58l-0.93,0.43l-2.2,-0.14l-0.59,-1.08l-0.57,-0.11l-4.23,2.76l-1.51,2.76l-3.3,2.46l-3.76,3.74l-1.53,2.82l-1.56,6.81l-2.8,5.0l-0.32,0.25l-0.57,-0.15l-0.36,-0.64l-0.74,-0.3l-0.96,-1.07l-0.78,0.16l-0.11,0.44l1.05,2.82l-0.27,0.76l-7.24,0.38l-0.69,-0.32l-0.35,-0.95l-0.61,-0.18l-0.74,1.1l-1.77,0.08l-1.48,-1.46l-0.92,-0.48l-0.55,0.49l0.99,1.21l-0.08,0.83l-1.43,1.19l-0.76,0.06l-0.45,-0.41l-0.92,-3.27l-0.6,-0.23l-0.39,0.5l0.29,2.91l0.54,0.89l-1.76,0.21l-0.6,-1.48l-0.67,0.21l-0.25,1.31l-2.68,0.38l0.1,-1.13l-0.65,-0.28l-0.8,0.82l-0.08,0.87l-1.03,-0.1l-3.13,-1.87l-2.38,-2.16l-1.09,-2.2l-1.1,-2.87l0.83,-0.4l-0.21,-0.65l-0.94,-0.26l-0.02,-1.24l1.51,-0.54l0.61,-1.2l-0.54,-0.51l-1.74,0.77l-1.75,-1.15l2.03,-0.1l0.74,-0.44l-0.08,-0.72l-1.21,-0.16l-0.03,-0.57l-0.61,-0.36l-0.67,0.8l-0.89,0.33l-0.37,-0.24l-0.23,-1.38l-2.79,-3.17l-5.14,-3.88l-3.8,-0.8l-6.74,0.03ZM382.56,407.1l-0.87,0.28l-0.02,-0.0l0.45,-0.68l0.44,0.41Z",name:"Nigeria"},TN:{path:"M393.95,11.16l1.69,-1.28l0.94,-1.75l1.74,-0.94l0.03,-1.47l2.63,-0.77l3.65,-2.61l6.28,-1.93l1.22,0.27l-0.47,1.25l0.54,1.03l0.6,0.12l0.78,-0.63l-0.06,-0.91l1.95,0.05l0.97,0.47l-0.08,2.06l1.65,2.34l-0.39,0.92l0.2,0.52l1.4,0.67l1.63,-0.83l0.68,-1.19l2.26,-0.71l2.09,-1.67l0.72,-0.11l0.65,2.05l-1.66,1.69l-1.96,3.31l-1.73,0.93l-1.45,1.35l-0.7,2.23l0.38,2.14l1.07,2.04l1.15,1.17l1.21,0.45l2.36,1.69l0.47,3.82l0.81,1.23l-4.84,7.19l-1.78,1.72l-4.9,3.52l-1.05,2.18l0.14,1.24l1.29,2.72l1.8,1.72l2.07,0.97l2.54,-0.29l0.17,1.91l0.41,0.33l2.13,-0.26l0.76,-1.06l1.0,0.56l0.72,2.39l1.13,0.83l-0.39,0.32l0.07,0.66l3.32,0.78l-0.51,3.44l-0.06,3.37l0.96,2.13l-0.26,0.57l-7.85,4.28l-0.71,0.81l-1.87,1.17l-1.54,2.48l-1.86,0.38l-0.61,0.42l-1.38,1.86l-0.56,1.34l1.5,5.57l0.14,1.99l-0.42,0.94l-3.67,4.98l-3.88,1.77l-5.51,-23.48l-8.3,-6.14l-0.33,-1.91l-1.09,-3.01l-1.2,-1.77l-4.43,-2.74l-2.68,-7.3l0.14,-3.04l2.61,-2.15l1.12,-2.09l3.28,-2.0l0.93,-1.22l0.67,-1.32l0.75,-4.52l0.94,-1.54l-0.85,-2.92l0.01,-3.35l-0.83,-1.99l1.18,-7.61l-0.6,-1.31l-1.0,-0.53ZM429.08,34.41l0.05,-0.04l-0.0,0.02l-0.05,0.02ZM425.59,47.89l-0.94,0.42l-1.23,-0.47l0.15,-1.38l1.64,-0.05l1.05,0.9l-0.66,0.58Z",name:"Tunisia"},LR:{path:"M182.44,359.46l0.23,0.58l0.47,0.24l0.48,-0.27l1.56,1.32l0.86,5.09l0.9,2.38l-0.16,1.38l-0.9,1.59l0.14,0.72l2.35,0.46l1.98,1.95l1.88,-0.62l0.71,0.07l2.06,-2.86l0.41,-1.94l0.86,-0.18l0.23,0.6l1.41,1.2l1.6,5.06l-0.4,3.01l-3.07,3.32l-0.02,0.55l0.88,0.56l1.08,0.13l1.92,1.64l1.09,0.35l2.5,0.04l0.9,0.5l1.14,3.08l0.99,0.75l2.94,0.87l0.57,3.05l-0.33,0.87l-0.01,1.69l-0.59,0.94l-0.16,1.24l-0.89,0.8l-0.26,3.02l0.23,5.05l-7.51,-2.68l-10.18,-5.43l-2.8,-2.16l-10.57,-9.84l-1.72,-1.1l-2.19,-0.56l-2.02,-1.05l-0.86,-1.9l-5.16,-2.62l-2.18,-2.21l2.51,-3.59l2.12,-1.94l2.46,-1.67l2.6,-2.53l1.07,-3.83l2.4,-1.31l0.98,-3.42l1.53,-0.28l0.28,0.68l0.51,0.25l3.12,-1.1Z",name:"Liberia"},LS:{path:"M634.16,822.85l-4.19,0.68l-2.99,3.91l-0.2,1.11l-0.69,1.14l-3.16,-0.43l-2.91,-2.91l-1.25,-0.68l-0.33,-0.65l-0.02,-1.31l-2.6,-4.03l-0.85,-2.36l2.71,-1.31l5.14,-7.34l2.48,-0.8l3.26,-2.21l4.38,-1.45l3.67,3.7l4.02,2.67l0.94,2.02l-1.08,3.55l-1.82,1.85l-0.49,2.65l-2.12,1.4l-1.88,0.8Z",name:"Lesotho"},ZW:{path:"M619.52,667.32l1.52,-1.13l1.42,-2.83l1.6,-0.75l1.18,-1.13l0.85,0.25l0.79,-0.39l0.36,-0.77l-0.19,-0.61l0.53,-0.97l2.1,-0.57l1.33,0.92l0.84,-1.35l1.5,-0.62l0.21,0.77l0.48,0.37l0.76,0.08l0.76,-0.44l0.55,-1.03l0.84,-0.17l0.52,-0.76l-0.02,-0.65l-0.48,-0.38l-1.81,-0.41l0.65,-1.04l0.29,-3.44l0.54,-1.6l4.29,-2.48l2.29,-0.94l2.77,-0.61l7.38,-0.02l0.15,3.65l0.52,0.52l9.44,0.4l2.95,1.85l2.3,0.42l2.88,2.51l3.74,0.33l4.47,1.65l1.34,1.1l2.08,0.36l-0.79,1.76l0.12,1.98l0.97,2.52l-0.17,9.97l0.44,3.27l-1.23,4.36l-1.91,1.23l-0.31,1.56l0.43,1.1l1.33,0.98l-0.83,3.48l0.65,2.13l2.02,3.74l-0.14,1.15l-3.67,6.34l-1.62,1.14l-0.59,0.8l-0.2,3.53l-1.38,2.2l0.74,2.07l-11.51,12.13l-1.41,1.08l-2.38,-1.05l-1.92,-0.23l-5.39,0.47l-3.06,-0.45l-3.34,-1.3l-2.89,-0.49l-3.45,0.57l-1.32,-1.27l-1.7,-0.28l-0.55,-0.43l-0.24,-0.74l0.24,-1.52l-0.36,-0.6l-5.85,-1.81l-5.67,-0.96l-0.62,-0.64l-1.54,-3.01l-1.98,-2.29l0.4,-3.6l-0.05,-2.82l-0.31,-0.6l-0.94,-0.41l-3.68,-0.07l-0.29,-2.75l-1.0,-1.73l-5.96,-2.62l-5.89,-4.28l-2.44,-5.32l-0.17,-1.82l-1.52,-1.78l-0.65,-1.86l-2.36,-2.5l-2.0,-3.57l-1.22,-1.26l-0.6,-1.32l0.24,-0.97l2.0,0.54l2.22,-0.23l1.01,0.35l1.57,1.18l1.76,0.19l1.59,-0.67l2.12,0.2l2.81,1.11l2.65,0.23l3.66,-1.15l2.42,-3.38l0.75,-0.83l1.22,-0.47l-0.01,-0.38Z",name:"Zimbabwe"},TG:{path:"M297.58,329.02l5.02,1.16l0.41,0.5l4.27,-0.43l-1.21,2.91l-0.23,4.07l6.74,4.89l0.05,4.61l0.5,2.61l0.52,1.0l1.61,1.69l0.34,0.89l0.29,23.77l-0.72,0.04l-0.35,0.56l0.57,1.3l0.2,3.15l1.71,2.23l0.29,1.1l-1.57,0.41l-0.26,0.49l-4.23,1.18l-0.32,-0.43l-1.07,-0.3l-1.32,-1.77l-0.76,-0.09l-1.87,-1.33l-0.36,-1.41l-2.02,-3.08l0.05,-1.2l0.71,-0.89l0.49,-3.74l-1.49,-1.17l-0.09,-1.04l1.24,-2.27l-0.25,-4.87l0.14,-0.58l0.99,-1.08l0.07,-0.86l-0.87,-1.65l-1.64,-1.23l-1.12,-1.56l1.31,-1.36l-0.27,-3.1l0.74,-2.97l-0.15,-0.72l-1.1,-1.08l-1.07,-0.07l-0.96,0.6l0.16,-0.87l0.84,-0.48l-0.21,-0.65l-0.32,-0.08l0.41,-0.48l0.67,-7.15l-5.49,-4.69l0.85,-2.38l0.12,-2.09Z",name:"Togo"},TD:{path:"M578.03,273.18l-3.93,-0.49l-1.78,0.39l-4.06,0.13l-1.4,1.01l-0.94,1.17l0.33,2.92l-0.38,1.56l-2.0,2.01l-0.95,1.7l-0.15,1.58l-2.18,0.91l-1.13,1.08l0.69,3.53l1.01,1.3l-4.1,2.79l-0.9,1.48l0.01,1.14l1.31,3.02l0.08,1.52l-0.7,1.15l-2.02,1.29l-1.81,3.11l-0.18,1.11l0.84,1.32l1.56,0.36l2.71,-0.44l1.16,0.49l0.58,1.09l-0.24,1.06l0.95,4.57l0.28,0.53l0.98,0.47l-0.28,3.72l0.43,1.24l2.34,2.15l0.9,0.19l0.67,0.54l0.13,1.52l-0.79,2.84l-4.16,-0.83l-3.05,1.22l-0.89,0.77l-1.27,0.05l-1.09,1.08l-2.3,1.14l-0.9,1.11l0.23,2.36l-0.43,0.77l-0.48,0.5l-1.29,0.43l-1.57,2.45l-1.53,0.31l-2.98,3.09l-0.36,0.99l-2.37,2.61l-4.93,3.21l-3.03,-0.07l-1.54,0.71l-3.23,0.62l-6.19,0.07l-1.27,0.3l-1.1,0.68l-0.91,0.7l-0.08,0.78l2.5,2.18l-2.17,2.71l-3.17,2.77l-0.67,1.34l-10.77,0.76l-4.72,2.01l-1.56,1.33l-2.55,0.76l-1.02,0.93l-2.07,-2.05l-0.46,-1.29l-0.49,-0.32l-1.81,1.18l-0.37,1.04l-3.88,1.25l-0.93,0.78l-1.16,0.33l-3.54,-0.51l0.55,-1.29l-0.04,-1.55l-1.31,-0.92l-2.2,-5.47l-1.62,-2.83l-3.08,-2.96l-1.52,-0.81l-4.63,-3.94l-3.79,-4.5l-0.24,-0.91l1.76,-2.31l1.06,-0.81l6.79,0.46l3.55,-0.49l2.16,0.34l2.59,-0.07l1.48,-0.59l0.07,-0.7l-1.41,-0.93l-2.93,-3.11l-1.64,-3.35l-0.73,-2.36l-0.44,-3.05l0.29,-2.9l0.77,-2.02l-0.48,-1.41l0.03,-2.37l-2.37,-5.15l-0.43,-2.84l-1.01,-1.83l-1.71,-1.01l-0.8,-0.94l-0.32,-1.79l-0.79,-0.75l-2.69,-0.74l-2.02,-0.03l-5.2,-7.24l-1.79,-7.81l2.17,-2.87l1.95,-4.05l6.54,-9.36l13.06,-14.17l3.05,-36.28l2.66,-5.37l-0.48,-1.05l-3.96,-4.05l-0.45,-1.41l0.67,-1.28l-3.68,-5.61l-1.25,-1.27l-0.11,-4.85l-2.21,-12.95l11.33,-5.34l93.4,48.28l-0.08,45.21Z",name:"Chad"},ER:{path:"M725.98,290.45l-1.08,-9.87l1.07,-1.39l1.84,-5.7l1.57,-3.22l1.19,-3.67l-0.27,-4.02l1.01,-2.0l0.29,-2.92l1.67,0.22l3.06,-0.38l1.52,-3.09l2.72,-1.6l2.69,-0.91l1.01,0.09l1.86,-0.73l1.52,-1.7l0.59,-1.3l1.73,-1.8l3.31,6.53l1.43,4.09l1.26,4.26l0.93,6.42l0.91,3.33l1.48,1.71l0.96,2.98l1.01,0.37l0.48,0.66l1.03,2.81l0.81,1.16l0.69,-0.07l0.4,-0.92l-0.29,-1.59l0.51,-1.27l1.63,1.29l0.51,2.14l1.63,1.88l4.01,0.97l3.0,2.29l4.31,1.43l5.66,7.61l6.8,4.67l1.12,2.14l0.61,2.17l0.41,0.29l1.27,-0.09l2.29,2.23l0.94,1.99l2.03,0.67l0.51,-0.26l0.16,-0.49l0.44,0.4l0.27,0.93l-2.78,1.01l-1.16,2.36l-0.56,0.38l-2.39,-1.59l-0.67,-0.04l-0.58,0.41l-2.59,-3.3l-2.15,-1.36l-2.21,-3.6l-4.73,-3.78l-2.78,-2.78l-3.55,-4.5l-3.59,-1.45l-3.5,-2.43l-1.06,-0.36l-2.94,0.16l-1.53,-0.66l-2.68,-0.47l-3.79,0.7l-0.72,-1.17l-0.72,-0.56l-0.84,-0.08l-2.63,1.77l-4.17,0.63l-2.39,-2.59l-2.53,-1.03l-1.42,-1.39l-0.6,0.17l-3.59,8.22l-2.01,-2.62l-1.44,-1.07l-0.85,0.09l-0.82,0.56l-1.09,1.51l-2.45,-0.51l-1.56,0.09l-1.44,0.51ZM766.22,272.78l0.48,-0.41l0.03,-0.47l0.53,0.36l0.91,2.23l-1.05,-0.03l0.45,-0.33l-0.04,-0.49l-0.64,-0.68l-0.67,-0.19ZM769.17,274.55l0.38,-0.41l1.15,0.55l-0.68,0.02l-0.84,-0.16ZM767.02,269.46l0.02,0.06l-0.07,-0.03l0.04,-0.04Z",name:"Eritrea"},LY:{path:"M432.51,55.96l1.38,0.62l1.77,0.32l5.52,3.09l5.6,0.76l6.2,-1.47l2.92,1.16l3.54,0.43l3.69,1.05l4.24,2.61l7.66,1.54l0.93,0.91l1.01,1.84l0.07,2.47l1.57,4.11l2.63,3.18l4.95,2.13l7.8,0.67l6.6,1.71l5.58,1.96l1.45,1.0l2.76,0.94l5.64,4.66l3.13,1.61l2.32,0.35l2.19,-0.32l5.0,-2.61l3.6,-4.1l1.2,-2.18l0.49,-1.56l-0.1,-1.66l-2.12,-4.73l-0.39,-3.28l0.53,-2.25l1.66,-2.73l2.87,-2.72l2.89,-1.92l5.07,-2.5l4.24,-0.32l2.53,-1.81l2.26,0.38l4.02,-0.12l10.29,3.8l0.39,1.92l-0.1,1.87l2.3,1.61l5.95,0.71l3.97,1.95l4.11,0.17l2.4,-0.25l2.18,0.39l1.51,1.16l1.29,2.64l-3.38,4.27l0.29,3.57l1.12,3.66l-0.13,1.16l-0.95,2.74l-2.09,3.53l3.25,13.05l-0.01,114.09l-11.32,-0.01l-0.4,0.4l0.0,5.43l-93.2,-48.18l-12.16,5.56l-8.69,4.61l-7.05,-6.08l-1.45,-0.8l-17.67,-4.18l-4.98,-9.44l-0.57,-0.48l-9.64,-2.95l-3.37,0.82l-1.45,-1.16l-1.58,-2.44l-1.03,-3.13l-0.39,-3.67l-6.44,-9.16l-0.26,-0.86l0.7,-2.02l4.25,-2.71l0.44,-1.21l0.15,-2.82l-0.71,-1.06l-0.46,-1.54l-0.55,-3.46l1.96,-5.89l-0.67,-3.24l-0.5,-6.52l0.31,-5.16l-0.45,-2.79l-1.96,-5.95l-3.69,-5.86l6.61,-3.36l3.84,-5.21l0.47,-1.05l0.04,-1.2l-1.64,-6.67l1.74,-2.63l2.37,-0.68l0.85,-0.94l0.76,-1.6l1.76,-1.09l0.71,-0.81l8.06,-4.48l0.38,-1.64l-0.94,-1.63l0.06,-3.19l0.47,-3.16Z",name:"Libya"},GW:{path:"M102.75,314.04l2.01,-0.15l3.14,-1.06l3.53,0.23l3.21,-0.63l4.46,-2.25l16.69,0.07l0.02,0.75l0.64,1.26l-0.54,1.98l-1.27,0.14l-1.39,0.92l0.14,0.78l2.35,1.93l0.04,2.71l-2.28,0.75l-3.76,0.09l-2.18,1.22l-2.78,0.61l-1.26,1.37l-2.71,5.05l-0.18,-0.26l0.4,-1.37l-0.4,-0.51l-0.79,0.17l-0.73,0.93l0.04,-0.85l-0.36,-0.42l-1.1,0.02l-0.63,-0.55l-0.0,-1.0l0.43,-0.41l0.03,-0.63l-1.26,-0.26l0.29,-0.52l1.89,-0.81l2.09,-0.29l0.24,-0.64l-0.81,-0.9l-1.27,-0.3l-1.19,0.21l-0.88,0.6l-0.81,-1.0l0.31,-0.99l0.41,-0.23l2.3,0.01l1.58,-0.65l0.36,-1.03l-0.76,-0.31l-1.01,0.5l-2.93,-0.17l-1.03,0.37l-1.56,1.14l-1.82,0.6l-0.9,-0.17l0.34,-1.16l-0.84,-0.93l-2.27,0.43l-1.37,-0.62l-0.48,-0.67l0.08,-0.8l0.87,-1.17l-0.35,-0.52l-0.95,-0.05l-1.3,0.41l-1.74,-0.97ZM112.9,326.69l0.12,-0.11l0.02,0.0l-0.05,0.06l-0.09,0.04ZM110.3,324.02l-0.59,-0.08l0.44,-0.86l0.04,0.01l0.1,0.93ZM108.31,319.69l0.84,-0.06l-0.27,0.64l-0.57,-0.57ZM107.34,328.61l0.47,-0.15l0.65,-0.58l-0.03,0.58l-1.09,0.15Z",name:"Guinea-Bissau"},ZM:{path:"M578.83,587.79l0.57,0.09l0.9,1.63l1.94,0.49l0.41,0.52l0.31,1.3l-0.6,1.66l0.66,0.65l1.04,0.36l0.81,-0.09l1.84,-1.04l6.98,-1.64l-0.32,1.99l0.92,2.81l1.87,1.51l1.5,0.02l4.75,1.72l6.71,0.98l2.85,-0.1l1.64,-0.9l1.15,-3.33l0.93,-0.3l0.75,2.3l2.11,1.86l1.24,2.89l0.6,0.54l1.03,0.56l2.46,0.22l6.31,2.67l1.54,3.66l1.6,0.52l0.56,0.64l2.18,3.35l0.35,1.25l0.84,0.74l2.45,0.45l4.15,-1.77l0.53,0.36l0.42,1.55l1.15,0.51l0.87,-0.41l0.27,-0.68l-0.0,-14.77l-0.48,-0.39l-3.47,0.9l-0.38,0.66l0.12,1.47l-0.48,0.23l-4.08,-0.94l-2.45,-2.65l-4.23,-3.58l-1.39,-3.69l2.15,-7.93l1.13,-1.72l0.08,-1.41l-0.44,-1.86l0.26,-6.68l-0.31,-1.88l-2.38,-5.09l3.16,-2.4l2.27,-2.77l0.64,-1.18l0.2,-1.3l-0.31,-1.03l18.7,-2.93l-1.02,0.9l-0.41,1.25l0.48,1.04l0.86,0.1l-0.31,0.61l0.36,0.26l1.56,-0.81l1.29,0.58l2.05,2.1l1.03,0.63l1.28,-0.7l0.67,-0.01l0.32,-1.43l1.31,-0.02l1.89,1.09l0.32,1.13l1.42,1.26l1.88,0.0l0.84,0.3l0.08,0.89l0.53,0.6l2.13,0.23l1.15,0.62l2.33,0.33l0.66,0.66l4.88,2.21l0.68,1.21l0.2,1.17l1.25,0.47l0.59,-0.42l0.56,0.16l0.61,1.47l1.12,1.15l-0.33,2.25l2.45,2.21l0.31,1.85l1.23,1.86l-2.11,2.29l-1.44,0.39l-1.06,1.03l1.27,3.42l-1.16,2.57l-0.53,0.46l-0.03,1.61l0.71,0.92l0.15,0.78l-0.03,2.25l-0.54,2.88l1.16,2.49l0.58,0.33l1.12,0.01l-1.01,1.15l-4.53,1.8l-0.94,2.18l0.61,1.37l-0.34,3.58l-1.32,2.73l-2.19,1.84l0.25,0.57l1.27,0.75l-0.34,0.47l0.11,0.55l1.17,0.66l1.59,2.48l-17.08,5.92l-10.13,2.9l-5.19,2.06l-0.33,0.44l0.01,0.94l0.35,1.48l1.14,1.98l0.46,2.96l-7.37,0.02l-2.93,0.64l-2.44,1.0l-4.42,2.56l-0.62,0.85l-0.49,4.58l-0.64,0.98l-1.53,-0.37l-2.6,1.01l-1.11,-0.43l-0.51,0.83l-1.06,0.52l-0.31,0.78l-1.33,1.19l-1.56,-0.61l-1.27,0.61l-0.34,0.5l0.37,0.69l-1.24,0.36l-0.34,1.46l-0.84,0.2l-2.09,2.74l-1.07,2.03l0.28,0.56l-2.25,2.1l-1.87,3.23l-2.45,0.87l-2.23,-0.22l-2.92,-1.13l-2.27,-0.21l-1.78,0.69l-1.34,-0.19l-1.34,-1.07l-1.31,-0.48l-2.27,0.23l-2.12,-0.58l-3.08,-2.74l-3.24,-0.64l-5.5,-0.44l-10.3,1.89l-4.83,-4.16l-5.83,-5.69l-3.54,-2.57l-1.25,-3.88l-0.7,-3.64l-0.01,-34.94l21.47,0.0l1.47,-0.15l0.34,-0.33l0.02,-0.63l-0.95,-1.78l0.29,-1.74l0.97,-2.63l-0.38,-3.68l0.15,-5.67l0.87,-2.84l-0.85,-5.77ZM685.33,624.73l0.57,-0.41l0.12,0.17l-0.69,0.24Z",name:"Zambia"},CI:{path:"M196.93,382.8l2.89,-3.19l0.43,-2.32l0.05,-1.25l-1.95,-5.59l2.65,0.26l1.4,-2.46l-0.07,-1.4l1.32,-2.37l-0.2,-1.26l-2.64,-1.14l0.19,-2.03l1.8,-0.25l2.48,0.33l1.19,1.09l0.5,-0.0l0.54,-0.65l-0.08,-1.98l-0.43,-1.18l-0.92,-1.03l-1.72,-0.69l0.14,-1.82l1.69,-1.03l0.15,-0.57l-1.54,-1.29l0.22,-2.44l-0.47,-0.41l-1.42,0.2l-0.94,-0.89l-0.2,-5.46l1.75,-1.9l1.13,-0.28l0.94,-0.66l1.71,-2.17l1.57,-0.14l1.2,1.15l0.49,0.96l2.9,0.63l0.7,0.63l0.7,0.09l0.8,-0.68l-0.24,-1.02l0.28,-0.64l3.14,-0.28l0.32,-0.77l-0.12,-2.48l0.84,0.63l1.75,0.34l0.59,-0.68l-0.25,-0.8l1.38,-0.4l0.08,1.59l0.56,1.82l-0.55,1.65l1.67,1.02l1.39,-0.0l2.13,-2.23l3.13,-0.56l1.92,1.43l1.56,-0.01l1.64,0.79l1.18,2.2l0.43,1.55l4.1,2.6l1.18,-0.07l1.4,0.85l1.01,0.06l1.05,-1.24l5.38,-1.98l6.5,0.29l1.39,1.61l1.16,0.7l2.0,3.06l0.9,0.17l0.48,-0.23l-0.11,1.32l0.27,0.37l-0.75,1.69l-0.05,0.95l1.17,1.19l0.56,1.83l1.07,6.74l-1.2,0.72l0.04,1.01l-2.14,1.56l-1.25,2.9l-0.74,2.72l-0.32,2.93l-2.9,4.63l-0.14,2.06l0.52,3.62l2.38,7.52l0.74,1.08l1.69,0.35l0.4,1.76l-0.53,2.87l-1.4,0.37l-2.08,-0.82l0.17,-1.41l-0.35,-0.44l-0.57,-0.07l-0.86,0.46l-1.04,2.14l-5.87,-1.01l-1.43,-0.87l-1.66,-0.2l-5.1,0.35l-0.86,0.6l-0.13,0.46l0.24,0.16l-3.28,0.45l-0.63,-0.08l-0.81,-0.68l-3.17,-0.06l-0.81,0.35l-0.38,0.48l0.21,0.38l-2.29,0.19l-4.15,0.94l-10.94,4.0l-2.52,1.5l-2.05,0.7l-2.23,1.26l-1.09,0.23l-0.31,-5.08l0.26,-2.79l0.84,-0.77l0.14,-1.18l0.66,-1.17l0.01,-1.71l0.32,-0.84l-0.63,-3.6l-0.32,-0.39l-0.7,0.03l-1.32,-0.71l-1.13,-0.16l-0.56,-0.47l-1.27,-3.21l-1.23,-0.65l-2.59,-0.06l-0.89,-0.3l-1.79,-1.61l-1.47,-0.29Z",name:"C\xf4te d'Ivoire"},EH:{path:"M98.08,205.07l0.08,-0.53l4.61,-0.68l7.72,-0.24l5.41,0.61l5.74,0.12l1.56,-0.12l1.34,-0.77l1.0,-1.33l0.7,-1.83l-0.17,-1.39l3.6,-3.91l1.16,-1.68l0.59,-5.54l0.82,-4.2l0.93,-3.8l1.48,-3.37l1.25,-1.1l5.4,-2.37l3.07,-5.33l0.75,-0.79l4.19,-2.59l2.47,-2.01l1.44,-3.57l1.65,-6.62l1.03,-2.84l-0.07,29.53l-3.82,1.71l-3.02,0.64l-4.82,3.35l-1.56,2.38l-0.19,1.07l0.84,3.16l0.89,13.84l-46.06,0.2ZM157.4,147.05l2.57,-0.61l1.1,-2.54l1.47,-2.19l2.08,-2.13l0.27,-1.55l-0.77,-1.45l5.06,-1.49l1.86,-0.12l2.33,0.36l3.62,1.65l2.5,-0.62l1.43,0.71l1.21,0.04l1.17,-0.23l3.65,-2.79l4.69,-0.01l2.5,-0.39l0.81,-0.78l-0.51,-2.08l0.27,-1.89l-0.47,-2.03l0.74,0.0l0.01,20.13l-37.6,0.0Z",name:"W. Sahara"},CM:{path:"M398.03,403.42l2.82,-5.07l1.56,-6.82l0.7,-1.54l4.33,-4.63l3.33,-2.48l1.48,-2.73l3.85,-2.5l0.77,1.06l3.39,0.0l0.65,-0.58l0.66,-1.41l1.37,0.78l3.12,2.89l1.1,3.23l0.74,0.41l1.2,-0.12l1.18,-0.46l1.88,-1.4l0.92,-1.25l0.3,-2.19l3.23,-2.63l0.05,-0.68l-0.95,-1.47l2.76,-3.48l0.19,-1.76l1.53,-2.56l0.92,-4.0l1.86,-3.45l2.06,-0.36l0.87,-0.57l1.58,-1.83l1.16,-5.86l0.56,-1.3l0.91,-0.64l1.78,-0.59l0.53,-0.56l0.81,-5.49l1.72,-1.7l1.41,-5.1l1.89,-3.12l2.21,-3.11l0.96,-0.78l2.6,-0.68l4.35,-2.85l0.28,-1.28l-0.22,-1.64l0.65,-3.05l0.02,-2.08l-1.41,-2.05l-1.21,-0.55l-2.37,-0.41l-1.43,-7.58l1.58,0.01l2.42,0.63l0.45,0.36l0.4,1.94l1.03,1.17l1.52,0.83l0.92,1.66l0.43,2.83l2.31,4.93l-0.04,2.29l0.48,1.26l-0.74,1.97l-0.31,3.08l0.46,3.19l0.77,2.5l1.76,3.56l3.9,3.8l-3.05,0.31l-2.23,-0.34l-3.5,0.49l-6.96,-0.45l-1.52,1.09l-1.89,2.46l0.35,1.76l3.85,4.57l4.71,4.0l1.55,0.84l2.88,2.74l1.56,2.71l2.23,5.53l1.32,1.21l-0.26,1.38l-1.73,2.8l-1.5,1.07l-0.56,0.78l-2.02,4.94l-2.03,2.73l-1.17,2.86l-0.59,0.61l-2.27,1.1l-0.87,0.92l-0.17,1.0l0.88,1.5l0.99,0.19l0.27,0.34l0.0,4.08l-0.63,2.62l0.93,1.38l0.8,6.0l0.8,1.4l2.94,2.34l0.41,0.75l0.84,2.49l-0.87,0.14l-0.29,0.54l0.34,0.86l0.83,1.49l7.59,8.23l1.64,0.47l1.66,2.0l-0.07,1.5l0.47,1.61l0.09,1.92l0.88,2.36l-0.05,0.45l-1.1,1.19l-0.17,1.15l0.77,3.32l-0.42,0.3l-3.71,-2.71l-1.74,-0.43l-2.99,0.05l-2.09,-1.04l-0.92,0.38l-1.87,-0.13l-0.45,-0.73l-1.33,-0.01l-2.52,-1.41l-1.03,0.48l-13.6,-0.08l-0.34,-0.67l-0.79,-0.44l-4.15,0.11l-5.9,-0.58l-9.45,-0.07l-2.47,0.03l-0.39,0.45l-0.17,1.1l-15.4,-0.0l-1.15,-0.48l-0.6,-1.01l0.96,-6.81l0.72,-1.86l-0.37,-2.11l-2.68,-3.39l0.9,-1.2l-0.4,-0.23l-1.12,0.11l-0.72,-1.57l0.47,-0.59l1.05,0.16l0.46,-0.45l-0.17,-0.57l-0.95,-0.85l0.42,-1.2l-0.75,-0.29l-1.01,0.5l-0.86,-0.44l-0.46,0.49l0.16,0.59l-0.55,0.59l-0.95,-0.14l-0.84,-0.7l-2.75,-1.02l-0.24,-1.42l-0.75,-1.51l-0.12,-2.56l-1.84,-0.35l-1.21,-1.05l-0.58,0.45l0.29,1.2l-0.69,0.03l-0.29,-0.55l0.31,-1.81Z",name:"Cameroon"},EG:{path:"M655.53,78.07l-0.21,0.35l0.36,0.35l1.61,0.17l3.64,-0.77l0.94,-1.8l1.14,0.18l3.97,1.69l1.1,0.01l3.14,-1.05l-1.65,2.54l0.15,0.61l2.72,0.93l0.97,1.48l0.46,0.19l1.43,-0.47l0.88,-1.06l-0.14,-0.7l2.53,2.05l1.11,0.5l5.96,-1.22l1.05,1.0l2.1,-0.59l3.42,-0.0l2.85,-0.68l3.12,-1.55l3.69,10.84l1.5,3.26l2.79,8.89l-1.89,2.68l-1.39,6.51l-1.99,5.07l-0.55,4.32l-1.88,2.86l-1.71,-0.68l-3.26,-2.7l-1.92,-2.6l-2.13,-1.76l-1.9,-2.18l-1.38,-5.22l-0.69,-1.29l-2.37,-2.68l-1.71,-2.94l-0.86,-3.49l-0.98,-2.31l-0.57,-0.19l-1.09,0.62l-0.04,1.2l-0.9,1.26l-0.58,1.8l0.54,1.4l1.92,1.84l0.35,0.72l0.43,1.69l-0.04,2.52l0.38,0.93l1.44,1.76l1.33,2.8l3.63,4.62l2.0,2.0l1.43,0.97l0.51,0.81l0.08,3.75l1.71,3.32l1.28,1.04l0.5,0.94l1.26,6.66l1.12,1.4l3.28,6.61l2.75,4.15l7.37,15.17l3.35,4.03l2.71,1.97l-1.8,0.35l-0.67,2.14l0.22,4.24l0.51,2.18l1.57,4.02l2.67,2.73l3.69,1.38l2.18,2.88l4.79,3.59l0.28,0.58l-62.68,0.01l0.41,-1.64l-0.55,-0.76l-0.75,-0.13l-0.92,0.38l-1.05,2.11l-0.37,0.06l-72.63,-0.01l0.0,-89.62l-3.24,-13.0l2.01,-3.21l1.01,-2.95l0.14,-1.41l-1.12,-3.66l-0.28,-3.32l2.97,-3.67l0.94,1.36l1.84,0.27l6.06,-1.39l15.73,3.12l3.47,2.15l1.06,0.29l2.32,-0.04l1.71,1.26l6.36,0.6l6.65,2.85l2.52,-0.49l1.84,-0.82l5.87,-3.87l1.26,-0.44l2.0,0.08l2.21,-2.6l1.58,-0.15Z",name:"Egypt"},SL:{path:"M165.73,342.66l1.63,1.75l4.17,5.64l-0.74,2.31l0.41,0.45l1.16,0.27l0.13,2.11l1.18,2.05l-1.46,1.62l-0.99,2.31l0.19,0.48l2.24,0.2l1.92,-1.94l0.63,-0.04l-0.81,2.95l-1.78,0.68l-0.74,0.82l-0.86,3.51l-2.61,2.56l-2.42,1.64l-2.15,1.96l-2.54,3.61l-2.43,-1.92l-2.36,-1.16l-6.28,-2.31l0.53,-1.8l-0.81,-1.26l0.29,-0.85l-0.38,-0.53l-1.19,0.6l-1.19,-0.14l-1.72,-1.16l-1.23,-3.82l-0.97,-0.75l-1.27,-0.14l-1.3,-2.27l2.07,0.42l1.94,-1.79l0.37,-1.04l-0.12,-0.31l-0.63,-0.17l-0.45,0.38l-1.42,-0.11l-0.88,0.52l-0.4,-1.02l0.17,-1.3l1.31,-0.13l0.46,-0.52l-0.29,-0.56l-1.01,-0.18l-1.29,-1.17l1.56,0.14l0.69,-0.3l1.03,-1.02l0.45,-1.28l1.3,-0.4l1.04,-0.94l2.42,-4.06l0.62,-1.73l0.66,-0.33l1.59,-0.34l1.71,0.62l2.58,-0.56l0.39,-0.82l7.08,-0.04l0.57,0.16l0.21,0.45ZM150.0,371.51l-0.53,-0.45l-3.08,-0.87l2.81,-0.26l0.92,0.47l-0.12,1.11Z",name:"Sierra Leone"},CG:{path:"M433.42,487.21l1.46,0.55l2.4,-0.56l1.54,0.77l4.48,-0.97l0.31,-0.36l0.38,-2.57l-0.54,-1.98l1.55,-0.98l1.97,1.09l2.51,4.59l4.34,1.09l1.37,-0.11l2.01,-1.45l1.27,-1.44l1.17,1.9l-0.19,0.83l0.33,0.82l1.68,0.45l1.3,-0.4l1.29,-1.29l0.14,-0.92l-0.44,-0.81l0.43,-0.47l0.59,-2.07l1.57,-1.38l0.46,-2.09l-0.23,-1.35l0.52,-0.89l0.1,-1.31l-0.52,-5.19l0.74,-4.75l-1.44,-1.48l-1.88,-0.53l-1.61,-1.82l-2.25,-0.59l0.27,-4.43l0.69,-1.73l1.47,-2.0l1.73,-0.23l1.13,-0.89l1.42,-2.45l-0.06,-1.17l-1.53,-2.72l-0.71,-2.27l-0.98,-0.83l-4.06,-0.56l-6.96,2.03l0.37,-1.14l-0.98,-3.22l0.1,-1.55l1.4,-4.04l13.58,0.08l1.08,-0.46l2.22,1.39l1.15,-0.05l0.48,0.79l2.32,0.12l0.75,-0.36l2.1,1.03l2.95,-0.06l1.54,0.39l4.07,2.79l1.13,-0.93l-0.78,-3.49l0.11,-0.86l1.14,-1.24l0.07,-0.69l3.31,-6.52l0.14,-4.02l1.05,-3.37l0.36,-0.37l7.04,-1.03l2.53,-1.01l4.94,1.51l2.66,0.03l0.86,0.63l1.92,-0.97l1.69,-0.38l0.59,1.03l0.63,0.42l0.12,1.75l-1.5,4.35l-3.29,6.01l-1.64,4.71l-0.18,5.65l-1.83,4.96l-0.19,3.14l0.46,3.7l-0.43,3.46l-1.32,3.31l-0.59,2.7l0.31,3.13l-2.32,2.5l-3.03,2.57l-3.56,1.65l-1.18,1.06l-4.04,7.27l-3.8,3.94l-0.37,1.47l0.3,8.77l-0.81,4.99l-3.1,5.33l-3.04,1.07l-1.0,0.74l-0.6,1.05l-2.47,1.56l-5.69,6.29l-0.7,0.35l-2.98,-0.39l-0.49,-2.66l0.94,-1.72l-1.13,-1.89l-0.38,-0.18l-3.82,1.45l-1.14,0.73l-1.66,-0.57l-1.04,0.27l-0.55,2.93l-2.86,1.5l-1.96,-1.42l-0.96,-1.18l-1.17,0.06l-1.93,-2.01l-1.33,-0.17l-1.86,1.19l-2.92,1.0l-0.99,1.73l-1.36,0.32l-1.79,2.28l-2.02,-2.53l-0.43,-0.88l-0.13,-1.42l-7.43,-7.49l1.06,-2.28l2.93,-1.84l1.95,1.87l1.98,0.18l0.8,-0.71l-0.06,-0.81l-0.48,-0.73l1.17,-2.53l-0.16,-0.38l-2.49,-1.6l-0.19,-0.36l0.72,-1.02l0.09,-0.67l-1.56,-1.76l-0.94,-0.23l0.66,-2.47l-0.31,-2.57Z",name:"Congo"},CF:{path:"M474.14,412.46l0.6,-0.07l0.43,-0.47l-0.9,-3.12l-0.56,-0.97l-2.96,-2.34l-0.6,-1.05l-0.8,-6.02l-0.9,-1.17l0.63,-2.48l0.0,-4.35l-0.53,-0.82l-0.99,-0.17l-0.64,-1.1l0.78,-1.08l2.75,-1.48l1.46,-3.29l2.04,-2.73l2.02,-4.95l2.0,-1.76l1.06,-1.74l4.03,0.55l1.47,-0.39l0.95,-0.79l4.0,-1.29l0.53,-1.2l1.01,-0.76l1.43,2.22l1.74,1.32l0.61,-0.19l0.77,-0.82l2.62,-0.8l1.56,-1.33l4.57,-1.94l3.36,-0.03l7.48,-0.76l0.5,-0.38l0.46,-1.18l1.28,-0.85l1.86,-1.9l2.4,-3.0l-0.52,-1.18l-2.03,-1.58l1.67,-1.11l1.03,-0.22l6.16,-0.06l3.37,-0.65l1.4,-0.67l3.29,0.0l5.12,-3.35l2.49,-2.75l0.34,-0.96l2.79,-2.9l0.85,0.05l0.78,-0.46l1.51,-2.4l1.15,-0.35l0.74,-0.71l0.62,-1.18l-0.05,-2.6l2.63,-1.43l0.97,-1.01l1.33,-0.08l0.94,-0.8l2.84,-1.14l4.0,0.86l1.16,1.87l4.08,4.31l2.7,4.2l1.15,2.37l-0.28,5.52l-0.27,0.81l-1.54,1.91l-0.03,0.99l0.99,1.2l-0.05,1.65l0.7,0.7l1.13,0.39l5.92,0.9l-0.29,2.04l0.44,1.26l0.97,0.92l2.11,0.71l3.26,0.56l1.24,0.58l1.8,2.02l2.21,1.8l0.45,0.8l-0.75,1.98l0.2,0.63l1.04,1.08l1.28,1.18l5.95,3.16l1.64,1.23l1.56,2.04l2.1,1.6l-0.55,1.87l0.19,0.91l1.15,1.54l1.11,2.41l1.06,0.74l1.62,0.27l4.76,3.13l0.89,1.67l0.33,3.21l0.86,1.25l-2.75,-0.64l-2.83,1.59l-15.36,-2.89l-1.64,0.82l-1.65,2.58l-1.96,0.61l-1.09,-0.16l-2.4,0.6l-3.76,-0.92l-1.52,0.18l-10.6,3.89l-1.07,-0.0l-2.37,-0.86l-3.03,0.16l-2.04,1.7l-2.44,4.54l-0.73,0.65l-8.48,-1.69l-1.78,0.41l-2.16,-0.76l-1.52,0.07l-1.03,-0.3l-2.05,-0.97l-4.52,-0.54l-1.89,-2.58l-1.96,-1.69l-2.69,-1.4l-2.21,-1.63l-1.69,-0.5l-2.31,-0.05l-2.19,0.72l-2.99,2.11l-2.86,4.41l-1.45,1.56l-1.4,0.66l-0.3,1.3l0.6,1.61l0.15,1.81l-0.43,3.19l0.1,1.59l-0.6,-0.98l-0.64,-0.29l-1.9,0.52l-1.53,0.88l-0.63,-0.56l-2.75,-0.06l-4.63,-1.55l-3.2,1.05l-6.39,0.73l-1.02,0.47l-0.57,0.66l-1.08,3.45l-0.14,4.01l-2.93,5.77l-0.5,-1.57l-0.59,-5.29l-1.63,-2.02l-1.84,-0.65l-3.64,-3.79l-3.83,-4.31l-0.87,-1.68Z",name:"Central African Rep."},AO:{path:"M441.82,531.2l5.51,-1.02l3.33,-1.64l1.19,-0.09l1.33,0.29l8.0,-0.28l4.95,0.42l22.42,-0.32l1.26,0.37l1.14,0.71l1.79,2.25l0.1,3.42l0.4,1.79l2.1,3.81l0.49,1.37l-0.13,1.2l0.44,1.3l1.98,2.39l4.47,7.24l0.9,0.45l3.78,-0.36l1.27,0.46l2.2,-1.0l4.3,-1.02l4.37,0.77l2.35,0.0l2.39,-0.42l0.33,-0.35l0.36,-3.62l1.27,-2.22l0.05,-2.25l0.46,-1.41l1.39,-1.13l2.4,-0.57l7.93,-0.79l-0.65,2.71l0.29,0.87l0.73,0.59l13.96,0.54l0.34,0.88l-0.09,2.02l-0.63,3.19l0.24,2.91l1.12,2.76l0.11,4.05l-0.88,5.58l-0.2,3.59l0.58,1.73l2.74,3.2l1.23,2.03l0.88,2.52l0.36,5.0l-0.24,0.86l-0.77,0.46l-0.47,0.94l0.61,3.11l0.62,0.86l0.7,0.22l3.01,-1.69l6.04,0.37l4.49,-1.4l4.32,0.52l0.97,-0.4l0.33,-0.83l0.12,0.75l0.66,4.66l-0.87,2.86l-0.15,5.66l0.44,2.8l-1.33,5.29l0.97,1.94l-22.89,0.1l-0.4,0.4l0.01,35.38l0.73,3.82l1.44,4.23l3.58,2.59l3.09,3.14l7.11,6.3l-22.18,4.19l-1.47,-0.46l-2.05,-0.09l-4.31,0.77l-2.64,-0.77l-1.47,-0.82l-2.4,-0.29l-6.44,0.06l-3.08,-0.52l-4.9,-0.26l-2.61,-1.13l-2.74,-3.16l-1.29,-0.6l-46.71,-0.14l-4.64,0.25l-0.75,-0.2l-2.84,-1.86l-1.5,-1.07l-1.11,-1.29l-0.96,-0.42l-3.59,-0.49l-6.59,2.95l-3.74,-0.03l-1.09,-0.51l-1.36,0.01l-1.42,0.71l-1.3,0.19l0.84,-6.11l-0.26,-8.66l-0.49,-1.66l1.62,-1.29l0.85,-1.13l0.57,-1.45l0.68,-3.23l2.42,-7.3l1.16,-7.18l1.47,-3.45l0.53,-3.68l4.0,-4.81l1.03,-3.01l4.94,-2.94l2.29,-2.96l1.06,-2.0l1.17,-3.7l0.01,-3.95l0.74,-5.12l-0.16,-1.58l-1.12,-2.13l-0.27,-1.57l-2.1,-2.5l-0.54,-1.94l-1.88,-3.01l-0.51,-1.98l-0.91,-1.49l-0.63,-3.68l-1.83,-4.02l0.0,-0.28l0.54,0.15l3.67,-3.94l0.21,-4.04l-3.37,-6.95l-2.66,-6.41l-0.54,-3.41l-3.52,-4.26l-2.62,-5.27ZM440.92,526.36l-0.23,0.06l-0.46,-1.04l0.57,-1.98l-0.34,-1.69l-1.72,-3.63l1.89,-2.34l1.27,-0.25l0.93,-1.67l2.84,-0.99l0.98,-0.75l1.21,-0.42l2.01,1.99l-2.43,0.95l-2.71,2.81l-1.66,1.07l-0.15,0.59l0.81,0.81l-0.21,6.12l-2.58,0.35Z",name:"Angola"},CD:{path:"M441.08,527.14l2.62,-0.32l0.5,-0.41l0.31,-6.68l-0.67,-0.81l1.41,-0.9l2.69,-2.79l2.59,-0.98l0.6,-0.53l2.73,2.56l0.9,0.14l3.0,-1.47l0.38,-0.55l0.36,-2.58l2.25,0.5l4.69,-2.15l0.85,1.26l-0.93,1.82l0.66,3.06l0.65,0.43l3.26,0.2l0.95,-0.51l5.66,-6.27l1.52,-0.76l2.34,-2.46l3.17,-1.13l1.55,-2.11l1.91,-3.71l0.83,-5.09l-0.29,-8.85l0.24,-1.04l3.8,-3.95l3.94,-7.14l2.54,-1.79l2.1,-0.82l3.1,-2.63l2.5,-2.68l-0.23,-3.43l0.55,-2.55l1.36,-3.43l0.44,-3.56l-0.46,-3.81l0.19,-2.97l1.83,-4.94l0.17,-5.58l1.6,-4.62l3.26,-5.95l1.57,-4.52l-0.28,-4.52l0.43,-3.28l-0.16,-1.91l-0.59,-1.64l0.22,-0.72l1.21,-0.47l1.55,-1.65l2.78,-4.32l2.88,-2.03l1.96,-0.63l3.32,0.4l2.3,1.68l2.61,1.35l1.88,1.62l2.12,2.74l4.65,0.58l2.01,0.95l1.22,0.35l1.43,-0.1l2.16,0.77l1.91,-0.4l2.5,0.31l6.01,1.39l1.36,-0.97l2.45,-4.55l1.62,-1.41l2.72,-0.14l2.23,0.83l1.38,0.04l10.7,-3.9l1.25,-0.17l3.78,0.92l2.61,-0.6l1.12,0.16l2.34,-0.79l1.75,-2.67l1.24,-0.56l15.09,2.92l0.87,-0.23l1.71,-1.24l0.86,-0.12l3.17,0.98l0.98,1.57l2.08,1.49l1.47,2.37l2.25,1.33l1.15,1.25l1.59,0.98l2.81,0.3l3.57,-2.11l2.31,0.2l2.36,1.11l1.09,0.02l2.08,-1.32l1.01,-1.32l0.71,-0.21l1.26,0.5l1.11,1.15l1.11,1.86l3.78,4.03l3.69,1.75l0.49,1.88l0.43,0.58l2.05,0.06l0.84,1.41l0.67,0.41l-1.38,3.1l-0.32,1.5l1.12,1.86l-0.93,2.39l-0.49,2.71l1.4,1.0l1.6,0.02l1.31,1.27l1.03,0.18l0.8,1.0l-4.36,3.23l-4.04,3.9l-1.68,2.79l0.19,0.89l-0.92,0.36l-0.95,0.97l-0.71,1.55l-2.86,1.9l-0.14,3.81l-1.76,3.74l-0.71,0.84l-0.39,2.38l-2.23,0.93l-2.0,4.12l0.1,0.9l0.81,0.94l1.86,-0.41l0.81,-0.64l-0.85,4.62l0.2,4.56l-2.58,1.52l-1.19,1.5l-1.68,-0.6l-0.86,0.61l-0.61,2.37l-0.9,1.96l0.03,0.96l-0.5,1.34l0.48,1.07l-0.59,0.83l-0.15,1.1l0.89,2.99l1.03,0.51l0.14,0.94l2.33,2.84l-0.15,2.87l-0.81,1.14l0.06,2.46l-0.51,1.94l-0.21,3.61l0.14,1.38l-0.47,1.01l0.32,0.67l0.82,0.31l0.51,-0.15l0.23,-0.44l-0.2,1.74l-0.54,0.38l-0.37,0.91l-0.26,5.62l0.68,2.24l2.36,4.2l-0.32,0.51l-0.0,1.49l-1.69,1.55l0.07,1.66l1.42,1.9l1.32,3.51l0.63,0.46l-0.02,1.12l0.72,1.53l2.59,2.91l3.08,1.78l1.45,1.67l0.68,1.96l-0.04,1.33l0.92,3.24l3.01,2.58l0.46,1.23l-19.43,3.1l-0.27,0.52l0.39,1.15l-0.17,1.13l-0.52,0.92l-2.15,2.63l-3.41,2.77l0.05,0.8l1.63,2.75l0.72,1.93l0.29,1.73l-0.26,6.63l0.44,1.9l-0.07,1.24l-1.11,1.64l-2.18,8.02l0.3,1.25l1.24,3.06l4.33,3.69l2.73,2.83l4.21,0.97l0.89,-0.14l0.54,-0.79l-0.05,-1.58l1.86,-0.25l0.8,-0.42l-0.13,14.47l-0.78,-0.2l-0.33,-1.4l-1.09,-0.72l-4.33,1.77l-1.91,-0.31l-0.68,-0.59l-0.27,-1.11l-2.28,-3.49l-0.67,-0.76l-1.44,-0.37l-0.83,-2.38l-0.86,-1.41l-6.59,-2.81l-2.52,-0.23l-0.73,-0.42l-1.62,-3.2l-2.18,-1.96l-0.46,-2.0l-0.6,-0.54l-1.07,0.11l-0.86,0.5l-1.11,3.3l-1.21,0.61l-2.55,0.07l-6.62,-0.96l-4.76,-1.73l-1.22,0.08l-1.73,-1.38l-0.71,-2.37l0.41,-1.85l-0.74,-0.81l-7.38,1.68l-1.8,1.02l-1.28,-0.22l-0.2,-0.22l0.58,-1.46l-0.43,-1.64l-0.73,-0.83l-1.97,-0.54l-0.92,-1.61l-1.3,-0.23l-0.71,0.27l-0.5,1.17l-0.51,0.23l-4.31,-0.52l-4.53,1.4l-6.0,-0.38l-3.1,1.67l-0.45,-0.63l-0.53,-2.57l1.16,-1.19l0.31,-1.1l-0.28,-2.86l0.24,-0.82l-0.33,-1.63l-0.95,-2.72l-1.27,-2.11l-2.71,-3.15l-0.47,-1.36l0.19,-3.45l0.89,-5.67l-0.11,-4.16l-1.12,-2.79l-0.23,-2.79l0.72,-5.25l-0.44,-1.25l-0.46,-0.37l-13.84,-0.49l-0.57,-0.79l0.72,-2.73l-0.47,-0.7l-8.49,0.79l-2.52,0.6l-1.84,1.53l-0.51,1.59l-0.05,2.25l-1.28,2.29l-0.33,3.35l-4.27,0.35l-4.49,-0.77l-4.42,1.04l-2.03,0.97l-1.18,-0.46l-3.83,0.36l-4.74,-7.36l-1.95,-2.34l-0.33,-1.03l0.13,-1.22l-0.54,-1.51l-2.07,-3.71l-0.38,-1.66l0.1,-2.59l-0.25,-1.07l-1.95,-2.48l-1.44,-0.9l-1.48,-0.42l-22.47,0.32l-7.45,-0.44l-5.46,0.3l-3.52,-0.52l-2.56,0.51l-1.35,0.99l-1.81,0.47l-0.95,-0.16l-1.94,-2.08Z",name:"Dem. Rep. Congo"},GA:{path:"M400.47,467.86l1.76,-0.1l0.68,-0.62l1.11,-0.24l2.58,-3.26l0.57,-3.7l-0.33,-3.99l0.42,1.18l0.79,0.61l1.38,0.19l2.48,1.16l0.62,-0.25l0.14,-0.73l2.0,-0.74l0.26,-0.36l-0.91,-0.67l-2.07,0.27l-2.54,-1.14l-2.4,-2.83l1.62,-0.75l1.0,1.07l0.8,-0.39l0.1,-2.43l-0.51,-2.64l1.44,-0.44l0.67,0.9l1.36,0.46l1.38,-0.51l15.3,0.05l0.4,-0.4l-0.08,-13.67l0.28,-1.19l11.42,0.05l5.92,0.58l4.03,-0.12l0.58,0.78l-0.05,0.66l-1.36,3.55l-0.13,1.73l0.98,3.32l-0.48,0.7l-0.08,0.59l0.31,0.36l1.09,0.21l6.7,-2.07l3.65,0.53l0.52,0.42l0.71,2.25l1.48,2.57l0.06,0.78l-1.25,2.13l-0.89,0.7l-1.58,0.16l-0.5,0.37l-0.52,1.07l-0.91,0.92l-0.8,2.11l-0.18,4.88l0.67,0.58l1.92,0.31l1.46,1.73l1.95,0.58l1.15,1.38l-0.81,4.08l0.52,5.26l-0.09,1.18l-0.53,0.93l0.22,1.4l-0.42,1.89l-1.5,1.25l-0.61,2.11l-0.51,0.67l0.43,1.42l-1.14,1.14l-0.88,0.22l-1.01,-0.24l-0.02,-1.48l-1.06,-1.88l-0.78,-0.48l-0.53,0.16l-1.27,1.54l-1.68,1.28l-1.09,0.1l-4.03,-1.0l-2.35,-4.46l-1.01,-0.78l-1.59,-0.54l-1.71,0.94l-0.58,0.65l0.14,1.47l0.4,0.75l-0.35,2.16l-4.06,0.88l-1.43,-0.77l-2.53,0.56l-1.69,-0.52l-0.5,0.52l0.3,2.78l-0.75,2.72l0.31,0.5l1.08,0.2l1.21,1.31l-0.83,1.39l0.34,0.89l2.49,1.66l-1.15,2.37l0.58,1.2l-0.15,0.27l-1.56,-0.11l-1.67,-1.76l-0.87,-0.13l-3.24,2.06l-1.11,2.25l-0.67,-0.61l-1.03,-1.96l-3.56,-3.08l-0.67,-1.42l-2.79,-3.11l-6.22,-5.17l2.01,0.83l0.83,-0.53l-0.07,-0.64l-2.39,-1.27l-2.18,-0.36l-0.43,-0.4l-1.06,-2.36l-1.88,-2.18l0.78,0.38l0.54,-0.19l0.02,-1.08l-1.87,-1.01l-0.79,-0.07l-0.01,-0.96l-0.87,-1.72l1.17,1.19l1.11,0.03l1.47,-0.44l0.24,-0.57l-0.26,-0.51l-0.71,-0.66l-1.75,0.09l0.66,-1.79l-0.47,-0.54l-1.49,0.64l-1.42,-0.86l-3.38,-6.36Z",name:"Gabon"},GN:{path:"M141.71,352.29l0.24,-1.06l-1.47,-1.71l-0.56,-1.34l-1.55,-1.46l-1.15,-0.05l0.22,-2.42l-0.48,-0.96l0.11,-0.77l-0.48,-0.45l-0.82,0.62l-0.47,-0.12l-1.47,-0.9l-0.67,-0.8l-0.31,-1.14l-1.73,-0.05l-2.82,-1.33l-2.03,-3.39l0.19,-2.52l-0.67,-0.22l-0.51,0.48l-1.17,-2.5l-1.69,-0.42l-0.61,0.48l-0.49,1.4l-0.2,-0.14l0.07,-0.91l1.13,-1.55l1.92,-3.92l0.92,-1.04l2.68,-0.58l2.16,-1.21l3.61,-0.06l2.68,-0.87l0.27,-0.36l-0.07,-3.33l-2.46,-2.14l0.84,-0.42l1.18,-0.05l0.78,-0.82l0.42,-2.05l-0.67,-1.95l7.04,0.45l-0.17,0.92l0.49,0.79l0.87,0.11l0.82,-0.57l1.42,0.91l3.08,0.91l0.88,-0.02l0.75,0.45l1.44,0.12l2.83,-0.81l2.77,0.12l2.7,-0.46l1.39,0.12l-0.92,2.0l0.08,0.69l2.33,2.0l0.68,0.21l0.85,-0.26l1.8,-1.8l1.12,-0.32l2.17,3.28l0.63,0.37l1.27,-0.57l1.83,-2.36l1.99,-0.78l5.18,1.97l1.51,0.01l0.83,-1.29l3.56,-1.41l0.37,-1.11l-0.67,-1.38l1.56,-0.04l1.84,0.87l0.44,0.57l2.07,4.93l0.15,3.21l1.17,0.55l0.65,1.31l2.95,1.51l-1.34,1.23l-1.7,2.4l0.03,0.83l1.07,0.37l1.51,-0.69l1.26,0.55l0.25,0.81l-0.2,1.83l0.74,3.29l0.55,0.69l2.51,1.32l0.17,0.36l-0.05,1.08l-1.58,1.5l-0.35,0.75l0.19,5.81l0.64,0.99l0.8,0.5l1.36,-0.08l-0.23,2.15l1.47,1.18l-1.59,1.07l-0.26,2.57l2.11,1.1l0.65,0.78l0.4,2.48l-1.27,-1.01l-2.66,-0.33l-2.16,0.26l-0.43,0.55l-0.09,2.74l1.44,0.91l1.14,0.2l0.16,0.6l-1.33,2.39l0.09,1.33l-1.0,1.89l-2.23,-0.32l-0.72,0.4l-0.94,-1.27l-1.3,-0.1l-0.73,0.54l-0.38,1.88l-1.6,2.52l-0.9,-0.0l-1.32,0.53l-1.81,-1.85l-1.08,-0.37l-0.95,0.1l0.87,-1.56l0.17,-1.75l-0.89,-2.34l-0.07,-1.39l-0.7,-1.96l-0.08,-1.77l-1.91,-1.88l-0.85,-0.04l-0.63,-0.76l-3.15,1.15l-0.29,-0.57l-0.83,-0.36l-1.2,0.36l-1.56,-0.05l-2.28,2.08l-1.1,-0.15l0.74,-1.76l1.41,-1.48l0.14,-0.56l-1.23,-2.26l-0.12,-2.22l-0.32,-0.34l-1.24,-0.26l0.71,-1.67l-0.05,-0.82l-6.32,-8.12l-0.91,-0.24l-7.48,0.04l-0.49,0.9l-2.19,0.48l-1.71,-0.62l-1.86,0.41l-1.07,0.67l-0.62,1.76l-2.29,3.88l-0.78,0.75l-1.41,0.43l-0.71,1.58l-0.76,0.74l-1.95,0.03Z",name:"Guinea"},GM:{path:"M100.95,304.31l-0.62,-2.32l1.36,-1.21l1.03,1.81l2.06,0.55l2.56,-0.15l0.45,-0.42l0.18,-0.82l6.11,-0.87l1.77,0.01l0.51,-0.12l0.24,-0.62l-0.4,-0.34l-1.65,-0.2l-6.6,0.61l-2.59,1.24l-0.77,-0.09l-0.89,-1.06l-0.24,-0.98l11.84,0.03l1.25,-1.76l1.67,-0.67l1.8,-0.26l1.84,0.29l1.93,1.34l2.32,0.66l2.07,1.38l1.09,0.18l2.1,-0.56l1.82,-0.08l1.23,0.65l0.21,0.58l-0.15,0.52l-4.38,1.11l-2.13,-0.37l-6.84,-2.9l-1.81,-0.49l-0.66,0.46l-0.9,1.43l-6.12,0.84l-0.31,0.35l-0.19,1.66l-9.2,0.03l-1.0,0.59Z",name:"Gambia"},XS:{path:"M870.84,327.12l-0.01,20.86l-11.07,16.91l-11.42,0.0l-34.59,-11.65l-4.62,-4.08l-1.65,-0.54l-0.96,-1.1l-1.04,-1.49l-1.39,-3.12l-1.43,-0.74l-2.61,-3.2l-0.65,-1.9l-1.44,-2.61l6.6,-10.04l1.89,1.5l2.19,3.63l2.7,3.09l5.03,3.72l1.48,0.56l6.71,-0.13l4.61,-2.52l5.45,-2.16l7.45,1.19l1.36,-0.13l4.91,-2.16l3.04,-2.08l1.94,-0.83l3.56,0.74l3.6,-0.32l6.5,-2.15l1.09,-0.02l2.75,0.8Z",name:"Somaliland"},CV:{path:"M28.84,267.68l1.39,0.08l0.47,0.44l-0.15,1.03l-1.06,0.56l-1.06,-0.44l0.41,-1.67ZM28.19,260.4l0.01,0.82l0.07,0.36l-0.26,-1.07l0.19,-0.11ZM25.22,280.01l-0.28,-0.24l0.06,-0.77l0.23,-0.43l0.34,0.03l0.14,1.18l-0.48,0.22ZM19.01,279.11l1.9,1.57l0.86,1.27l-0.44,0.68l-1.23,-0.07l-0.64,-0.36l-0.81,-1.2l0.35,-1.89ZM11.49,262.35l0.91,0.29l-0.49,0.6l-0.43,-0.74l0.02,-0.15ZM11.76,283.5l-1.0,0.16l-0.47,-0.36l-0.06,-0.74l0.96,-0.54l0.38,0.12l0.2,1.37ZM3.48,259.84l1.06,-0.47l0.31,0.54l-0.53,0.16l-0.84,-0.23ZM0.42,257.15l2.3,-1.09l0.63,0.14l0.4,0.61l-1.9,1.44l-0.97,0.21l-0.46,-1.31Z",name:"Cape Verde"},GH:{path:"M262.02,399.49l0.83,0.05l1.7,-0.53l0.77,-3.59l-0.62,-2.21l-1.9,-0.53l-0.37,-0.63l-2.62,-8.49l-0.12,-4.16l2.86,-4.55l0.36,-3.07l0.72,-2.66l1.23,-2.82l1.87,-1.22l0.36,-0.65l-0.17,-0.62l0.83,-0.31l0.47,-0.77l-1.1,-6.96l-0.63,-2.01l-0.48,-0.81l-0.61,-0.32l0.84,-2.44l-0.33,-0.54l0.19,-1.39l-0.24,-1.21l-0.85,-2.35l0.34,-0.69l-0.45,-4.6l0.24,-0.72l-0.63,-1.09l0.35,-1.17l-1.07,-1.04l-0.37,-0.87l0.08,-1.47l0.78,-2.87l20.69,-0.14l3.81,0.23l0.51,0.61l0.57,0.13l1.74,-0.99l0.75,-0.93l1.08,-0.1l0.55,-0.75l2.23,0.5l0.7,0.8l-1.13,3.45l0.09,0.86l3.6,3.42l1.74,1.15l-0.58,6.67l-0.65,0.37l0.23,0.93l-0.64,1.71l0.76,0.7l1.38,-0.72l0.53,0.04l0.76,1.06l-0.73,2.89l-0.07,1.67l0.35,1.29l-1.2,0.93l-0.1,0.83l1.32,1.93l1.55,1.14l0.73,1.31l-1.2,2.26l0.24,4.93l-1.23,2.23l0.19,1.57l1.36,0.89l-0.47,3.5l-0.79,1.08l0.04,1.34l2.13,3.32l0.47,1.52l2.08,1.48l0.77,0.13l0.8,1.32l1.46,0.78l-1.48,1.1l-1.15,2.09l-2.15,0.54l-5.86,0.07l-4.5,2.21l-2.58,0.78l-1.69,1.29l-2.11,0.87l-1.51,1.07l-3.1,0.52l-5.16,1.71l-5.81,3.21l-0.82,-0.02l-3.64,-1.93l-7.18,-1.54Z",name:"Ghana"},SZ:{path:"M658.82,780.66l0.07,-4.13l2.66,-3.92l0.66,-1.48l1.33,-1.64l1.4,-1.03l0.63,-0.09l5.29,2.91l1.03,-0.19l0.99,0.55l-0.24,3.09l0.76,3.04l0.07,3.34l-0.71,-0.14l-0.66,0.4l-0.57,4.53l0.11,1.32l-5.23,-0.14l-2.19,-0.69l-2.35,-1.51l-2.04,-3.9l-1.02,-0.31Z",name:"Swaziland"},MG:{path:"M853.67,633.45l0.24,0.85l-0.77,2.09l0.28,0.45l0.83,0.15l0.76,-0.4l1.68,-2.95l1.01,-1.09l2.0,0.4l0.46,-0.19l-0.09,-0.49l-1.69,-1.44l-0.39,-1.81l2.54,-4.79l-0.06,-0.45l-1.05,-1.16l-0.03,-1.17l0.86,-1.19l0.4,-0.13l1.7,1.27l1.16,0.04l1.77,-2.17l2.52,-1.33l2.05,-1.89l1.44,-4.12l0.13,-1.24l-0.32,-1.57l-1.15,-2.76l0.76,0.15l0.76,-0.37l3.13,-4.13l0.3,0.0l1.01,1.69l2.02,2.3l1.19,2.47l3.46,5.1l0.34,2.28l1.26,3.72l1.17,5.47l0.72,8.28l0.97,2.6l1.46,2.49l0.46,2.67l-0.88,2.8l-2.08,3.7l-0.91,-0.61l-0.8,-1.07l-1.68,-4.3l-0.67,-0.26l-1.29,0.12l-1.28,1.14l-0.18,0.72l0.73,6.08l1.39,2.24l0.09,2.65l-0.29,1.27l-0.94,1.41l0.32,1.27l-1.9,1.26l-1.76,3.88l-0.14,1.39l0.66,3.86l-0.18,2.69l-1.34,5.26l-5.21,14.49l-5.28,16.74l-1.38,5.51l-2.04,6.04l-3.14,7.68l-1.23,6.53l-2.34,7.91l-0.54,2.98l-2.17,4.27l-1.17,4.31l-1.1,2.72l-1.61,2.3l-3.44,2.03l-3.98,0.28l-2.67,0.72l-6.59,3.76l-1.02,0.39l-3.41,0.09l-0.93,-0.3l-3.61,-2.63l-5.34,-1.29l-1.12,-1.39l-2.45,-1.42l-1.45,-4.36l-2.77,-4.12l-0.28,-6.85l0.2,-1.27l0.68,-1.46l-1.81,-5.63l-2.04,-2.46l-0.44,-1.1l-1.07,-4.95l0.29,-5.37l0.61,-1.75l1.12,-1.81l0.72,-3.43l0.79,-0.65l1.47,-0.5l1.23,-1.05l0.68,-1.34l0.63,-2.51l3.85,-5.95l1.29,-2.91l0.68,-2.79l0.52,-6.07l-2.48,-4.42l-0.06,-3.97l-1.49,-3.0l-0.78,-2.52l-0.31,-5.85l-0.8,-2.68l0.38,-2.1l5.14,-8.25l0.12,-5.12l0.35,-0.57l5.08,-0.53l3.57,-2.63l1.47,0.99l1.63,-0.59l1.18,0.08l0.41,-0.2l0.98,-1.95l3.49,-0.38l1.74,-0.51l1.69,1.96l1.37,0.19l0.49,-0.35l0.03,-0.63l-1.21,-1.29l0.62,-1.73l5.66,-4.31l0.79,0.06l0.36,2.17l0.34,0.46l1.09,-0.27l0.6,-1.2l-0.47,-2.39l2.11,-2.4l0.83,-2.09l0.73,-0.54ZM863.67,615.59l0.19,1.33l-0.78,-0.09l-0.12,-0.76l0.72,-0.48Z",name:"Madagascar"},MA:{path:"M111.55,174.08l0.87,-0.82l2.29,-1.53l4.61,-5.0l1.83,-0.96l1.58,-2.13l0.64,-2.12l0.15,-4.31l0.54,-2.21l3.21,-6.6l0.6,-2.92l0.57,-0.97l1.17,-0.55l1.63,-1.44l2.55,-0.94l4.55,-3.25l0.97,-1.81l1.0,-3.42l1.79,-3.61l0.93,-2.75l1.51,-1.38l1.09,-1.81l1.65,-0.74l3.81,-0.4l5.66,-1.52l5.19,-2.35l1.53,-0.99l4.03,-4.16l6.97,-4.48l3.42,-4.1l5.39,-7.44l0.96,-2.1l0.51,-3.13l-0.35,-1.39l-1.47,-2.13l-0.93,-0.57l-0.18,-0.67l0.49,-1.68l0.27,-7.37l1.52,-3.6l3.87,-4.95l0.73,-2.09l0.48,-4.21l4.69,-4.44l3.76,-4.32l2.43,-1.56l8.66,-3.5l4.9,-2.5l2.99,-1.94l1.74,-2.22l4.72,-8.51l4.99,-13.29l3.36,-0.55l2.57,-1.29l0.51,0.13l-0.27,0.42l0.05,1.69l1.04,1.81l1.78,2.01l3.24,2.54l2.53,1.02l3.5,0.6l4.2,-1.08l2.23,-0.02l1.08,-0.42l1.19,0.64l2.3,0.22l2.32,-0.37l2.46,-1.79l1.42,3.08l2.75,0.4l4.57,0.08l1.03,1.67l3.86,2.86l-0.6,1.9l1.29,1.6l-0.64,1.51l0.97,2.48l-0.08,5.17l0.95,2.82l-0.52,3.35l1.5,3.22l0.46,2.49l0.75,1.34l4.0,3.09l0.35,0.73l-1.93,1.71l-0.25,1.1l0.41,1.75l-13.96,-0.43l-4.91,0.72l-1.1,0.68l-0.9,2.5l-4.79,1.63l-3.95,0.23l-0.87,0.56l-0.27,0.68l0.67,3.3l-0.5,2.12l0.31,0.69l2.13,1.25l-0.34,0.84l-3.71,0.64l-3.92,2.74l-5.29,1.87l-2.27,1.14l-2.62,3.95l-3.02,2.58l-6.39,1.58l-5.73,0.19l-0.43,0.39l-0.23,1.86l-0.99,0.91l-6.07,-0.61l-4.01,2.89l-2.44,0.61l-6.8,4.71l-4.58,3.31l-0.43,0.7l-0.06,12.74l-1.18,-0.0l-0.4,0.43l0.5,2.41l-0.32,1.33l0.57,2.17l-0.25,0.45l-2.28,0.36l-4.87,0.03l-3.88,2.88l-0.82,0.12l-0.84,0.0l-1.68,-0.76l-2.46,0.63l-3.43,-1.6l-2.64,-0.4l-2.01,0.14l-5.47,1.59l-0.29,0.51l0.87,1.77l-0.18,1.02l-2.02,2.05l-2.06,3.28l-0.38,1.28l-3.45,0.81l-0.57,0.65l-2.99,11.13l-1.34,3.36l-2.26,1.8l-4.28,2.67l-0.88,0.94l-2.85,5.11l-5.33,2.33l-1.55,1.39l-1.55,3.53l-0.95,3.88l-0.83,4.25l-0.57,5.45l-4.71,5.41l0.11,1.58l-0.65,1.71l-0.85,1.11l-0.91,0.53l-1.42,0.11l-5.7,-0.12l-6.83,-0.61l-8.12,0.37l-2.68,0.51l0.76,-5.27l1.56,-3.09l1.18,-1.3l2.11,-0.87l1.83,-3.22l0.66,-2.98l1.13,-1.29l0.45,-1.2l-0.38,-0.93l4.64,-7.95l0.06,-1.38l-0.73,-0.14Z",name:"Morocco"},KE:{path:"M696.13,456.91l1.2,-1.94l0.9,-2.52l1.23,-0.89l1.69,-2.18l0.87,-2.1l1.3,-1.23l2.39,-1.11l-0.06,-1.76l2.06,-2.98l0.2,-1.72l-0.17,-3.41l-0.94,-4.11l0.23,-0.9l-0.46,-1.29l-0.65,-0.47l-0.86,-2.33l-1.78,-1.27l-0.73,-2.16l-0.9,-0.64l-0.52,-2.66l0.44,-2.85l-0.65,-0.74l-1.55,-0.55l-0.89,-0.7l0.13,-0.45l-0.73,-0.65l-1.64,-3.48l14.24,-14.05l0.92,0.87l1.84,-0.59l3.03,0.82l0.38,0.54l0.09,1.28l-0.5,2.4l0.08,1.75l3.18,4.28l0.95,0.31l9.51,0.42l13.93,8.98l6.14,0.58l7.22,1.42l3.36,0.26l0.68,-0.24l1.44,-1.33l2.14,-3.16l10.47,-4.79l4.37,3.57l2.19,0.25l5.87,-0.41l-5.9,8.46l-4.23,4.19l-0.29,0.61l0.17,43.23l6.42,8.43l0.09,1.09l-1.59,1.87l-1.29,0.85l-1.74,0.4l-1.14,-0.34l-0.49,0.17l-0.43,0.9l-0.24,-0.17l-0.63,0.38l0.36,1.94l-0.21,0.67l-0.83,0.7l-0.2,0.76l-1.77,1.54l-2.85,0.23l-2.23,1.63l-0.61,1.84l0.17,2.25l-0.89,2.57l-1.42,1.19l-1.49,2.6l-0.57,2.6l-1.01,2.38l-2.81,5.67l-1.16,1.5l-1.16,-0.05l-0.72,0.71l-16.23,-11.7l-0.96,-1.51l-1.12,-0.47l0.93,-2.7l-0.34,-2.17l-0.38,-0.57l-41.77,-23.33l0.6,-0.4l0.53,-1.22l-1.1,-2.04l-0.08,-0.78l1.21,-1.79l0.85,-0.2l2.27,0.58l0.47,-0.54l-0.1,-1.15l3.66,-0.65l0.42,-0.81l-1.12,-2.16l-0.47,-0.2l-3.55,1.24l-0.7,0.63l-0.5,1.16l-1.84,-2.03l-0.07,-1.02l-0.85,-0.13l-0.41,-0.45l-0.29,-2.46ZM779.14,483.65l0.05,-0.04l0.01,0.0l-0.07,0.03Z",name:"Kenya"},SS:{path:"M581.04,357.13l1.37,-1.12l2.93,-1.06l0.24,-1.49l1.15,-2.04l0.29,-2.42l1.3,-1.74l0.04,-2.89l2.49,-3.21l0.28,-2.18l0.39,-0.53l8.3,-1.41l0.43,0.1l0.2,0.45l0.08,1.69l0.41,0.58l2.98,2.46l4.44,5.17l1.42,0.61l1.53,-0.19l3.52,-1.32l9.24,0.18l1.18,2.38l0.97,0.82l9.33,0.03l0.39,-0.49l-0.07,-1.29l1.52,-1.48l2.94,-1.39l2.87,-0.69l1.6,-1.89l0.08,-1.72l4.26,-2.24l5.29,3.38l3.41,3.0l4.95,-0.48l0.96,-0.42l5.07,-5.03l2.36,-3.09l0.89,-2.12l5.78,-5.15l0.05,-0.67l-0.97,-2.24l-0.02,-4.76l-2.62,-3.02l6.91,-0.03l0.4,-0.37l-0.19,-2.16l4.79,0.06l-0.71,2.77l-0.16,2.99l-0.58,1.11l1.15,8.97l-0.49,1.2l0.39,0.52l2.63,0.98l0.99,1.18l5.16,4.28l0.53,1.37l0.07,2.18l-0.79,1.64l-0.28,2.62l0.47,0.85l1.95,0.04l0.29,8.87l-0.26,1.32l-1.23,1.06l-8.0,0.16l-0.65,0.61l-2.58,5.22l-0.17,1.0l1.09,1.04l1.77,0.78l5.15,1.06l2.69,1.85l1.26,1.5l0.61,1.81l2.52,2.63l2.42,1.26l0.95,1.41l1.64,1.33l2.86,7.13l0.33,2.27l1.2,2.25l1.92,1.85l-20.42,20.03l-3.67,-0.22l-2.17,-1.21l-1.83,0.94l-5.96,1.12l-1.69,1.2l-0.49,0.91l-1.94,-0.92l-1.73,-2.29l-0.45,-0.03l-2.79,1.41l-3.63,-1.25l-0.95,-0.02l-2.86,1.86l-0.8,1.15l-0.84,-1.09l-0.88,-0.25l-1.11,0.2l-0.72,-2.26l-3.78,-1.85l-3.73,-3.98l-1.03,-1.76l-1.27,-1.32l-1.6,-0.67l-1.23,0.27l-1.16,1.42l-1.73,1.15l-0.63,0.03l-2.46,-1.13l-2.59,-0.23l-2.61,1.61l-1.59,0.57l-1.98,-0.36l-2.41,-2.09l-1.61,-0.77l-1.98,-2.82l-2.06,-1.47l-2.65,-3.66l-0.32,-3.16l-1.07,-2.03l-4.97,-3.31l-1.65,-0.29l-0.78,-0.51l-1.11,-2.4l-1.04,-1.31l-0.15,-0.54l0.59,-2.01l-0.13,-0.42l-2.24,-1.72l-1.59,-2.06l-1.73,-1.29l-5.96,-3.17l-1.15,-1.07l-1.0,-1.17l0.59,-0.94l0.16,-1.06l-0.6,-1.22l-2.34,-1.95l-1.78,-2.01l-1.6,-0.77l-5.07,-1.13l-0.84,-0.79l-0.27,-0.87l0.45,-1.63l-0.67,-1.05Z",name:"S. Sudan"},ML:{path:"M158.55,301.7l-0.54,-1.32l-1.75,-2.1l0.09,-0.89l0.69,-0.68l0.3,-1.15l-0.68,-1.35l-0.07,-2.89l-2.36,-2.87l0.46,-2.09l-0.6,-1.27l1.44,0.3l1.94,-1.71l0.9,-1.49l0.52,-3.0l0.75,-2.02l2.76,-2.33l6.42,5.8l0.97,-0.19l2.15,-3.09l3.15,-0.17l5.53,0.77l2.29,-0.34l3.6,-0.68l0.33,-0.35l0.0,-1.39l0.39,-0.65l0.32,1.53l2.03,0.41l43.0,-0.0l0.39,-0.33l1.79,-9.46l-3.16,-3.69l-11.26,-102.64l20.21,-0.01l69.78,48.0l0.27,3.49l1.54,1.35l3.72,1.92l0.77,2.02l0.93,0.73l2.19,0.78l3.38,0.31l2.16,2.22l5.44,1.34l2.99,1.24l0.68,0.58l-0.02,2.61l0.63,2.09l-0.65,0.69l-1.08,2.33l0.35,0.81l1.56,1.07l1.96,0.38l9.28,-1.79l0.08,25.36l-0.37,0.53l-0.24,4.56l-0.69,2.6l-1.27,2.05l-1.6,5.2l-0.56,0.78l-1.29,0.44l-2.22,1.9l-0.27,1.36l-4.9,-0.79l-0.82,0.33l-0.19,0.72l-19.62,0.81l-4.18,3.48l-2.63,0.33l-5.06,-0.3l-0.79,0.21l-0.32,0.48l-4.9,-1.63l-2.05,0.51l-0.55,-0.52l-0.96,-0.22l-1.71,0.1l-1.25,0.34l-3.34,2.7l-5.19,2.31l-2.34,1.4l-3.22,0.61l-1.21,3.23l-0.36,0.17l-3.89,-1.22l-1.82,0.58l-2.32,1.88l-1.18,1.54l-0.67,2.08l-0.11,1.41l-2.82,-0.31l-0.86,0.46l-0.57,4.31l-2.32,1.06l-3.6,-2.2l-1.4,-0.4l-1.39,0.31l-3.31,3.19l0.13,1.16l0.98,2.02l-0.01,0.7l-2.75,1.34l-0.18,0.54l0.65,1.04l-0.07,2.61l-1.78,2.08l-1.19,0.84l-4.76,1.29l-1.52,0.95l-0.84,0.99l-0.03,1.86l0.71,1.88l-0.23,1.63l-1.03,2.7l-1.62,1.02l-0.16,0.4l0.38,3.12l-0.64,3.57l-1.85,0.07l-1.86,0.57l-2.16,2.23l-1.82,-0.57l0.52,-1.59l-0.54,-1.75l-0.14,-1.95l-0.64,-0.39l-2.03,0.66l-0.25,0.5l0.18,0.76l-1.15,-0.27l-0.99,-0.78l-0.54,0.04l-0.49,1.17l0.1,2.31l-3.13,0.29l-0.54,1.2l0.3,0.79l-0.28,0.19l-0.85,-0.69l-2.82,-0.62l-0.19,-0.71l-1.74,-1.48l-2.16,0.26l-1.82,2.27l-1.24,0.67l-0.36,-1.58l-3.03,-1.94l-0.64,-2.98l0.13,-2.4l-0.34,-0.64l-1.85,-0.87l-1.94,0.69l1.58,-2.24l1.16,-0.87l0.35,-1.13l-0.32,-0.44l-2.85,-1.43l-0.59,-1.25l-1.17,-0.59l-0.0,-2.92l-2.1,-5.0l-0.68,-0.86l-2.2,-1.02l-1.09,-0.08l-1.23,0.34l-0.2,0.66l0.64,1.04l-0.06,0.77l-1.45,0.34l-2.04,1.03l-0.95,1.28l-6.22,-2.14l-2.42,1.0l-1.78,2.32l-0.64,0.39l-1.8,-2.9l-0.67,-0.63l-1.1,-0.14l-0.94,0.49l-1.69,1.73l-0.72,0.09l-2.06,-1.77l1.29,-2.46l0.08,-0.89l-0.8,-0.97l0.61,-4.85l-1.78,-2.61l-0.38,-1.41l-0.67,-1.04l-1.72,-0.47l-0.82,0.85Z",name:"Mali"},KM:{path:"M817.5,603.11l0.61,-0.24l0.5,-0.86l0.49,1.37l-0.0,1.05l-1.59,-1.3ZM809.46,604.09l0.26,0.03l0.6,0.37l-0.69,-0.09l-0.17,-0.31ZM806.8,599.18l-1.42,-0.7l-0.71,-0.87l0.32,-3.55l0.29,-0.43l0.51,0.21l-0.15,2.23l1.15,3.1Z",name:"Comoros"},ST:{path:"M383.99,440.62l-0.33,-0.08l0.53,-0.7l0.05,0.23l-0.25,0.55ZM375.07,457.57l-1.05,0.63l-0.5,-1.61l0.52,-1.0l1.46,-0.64l0.52,0.65l0.0,0.69l-0.94,1.28Z",name:"S\xe3o Tom\xe9 and Principe"},MW:{path:"M681.13,619.76l1.74,-1.46l1.44,-2.96l0.38,-3.9l-0.61,-1.2l0.73,-1.72l4.31,-1.64l1.54,-1.88l-0.35,-0.69l-1.7,-0.22l-0.93,-2.11l0.55,-2.61l0.03,-2.37l-0.19,-1.02l-0.71,-0.92l0.05,-1.02l0.39,-0.27l1.32,-2.96l-1.29,-3.24l0.68,-0.62l1.52,-0.44l2.28,-2.28l0.14,-0.7l-1.31,-2.14l-0.33,-1.91l-2.41,-2.19l0.32,-2.22l-1.17,-1.21l-0.79,-1.69l-1.23,-0.32l-0.55,0.4l-0.41,-0.09l-0.68,-1.96l1.71,1.11l2.38,0.31l1.15,1.07l3.32,-0.1l2.2,0.84l-0.11,1.28l1.3,3.56l2.72,3.57l-0.7,2.02l0.63,6.18l-0.24,0.8l1.15,5.72l-3.03,4.51l-0.36,2.15l0.6,1.96l1.16,0.77l0.18,2.55l0.83,1.15l0.72,2.39l0.16,2.45l-0.26,2.73l1.16,2.0l1.6,0.84l0.58,0.7l0.15,0.79l-0.96,2.74l0.39,1.72l1.87,2.05l0.5,0.06l1.31,-0.89l0.42,-2.09l0.51,1.42l1.09,0.39l2.18,2.65l0.8,0.07l0.45,-0.87l-2.17,-6.4l8.0,10.32l0.46,2.59l-0.56,1.56l-0.41,2.77l0.29,1.92l-0.12,3.09l-0.7,4.33l-1.57,0.66l-3.01,0.52l-0.86,1.14l-1.49,3.84l0.75,1.26l0.57,1.91l0.08,3.32l-1.41,0.08l-0.46,-0.39l-0.14,-0.42l0.52,-0.56l0.21,-0.91l-0.41,-1.04l-1.81,-1.01l-4.7,-5.26l-1.29,-0.85l-0.14,-1.96l-1.78,-2.3l0.32,-0.97l0.94,-0.93l0.91,-2.74l1.26,-2.27l0.2,-3.44l-0.69,-5.22l-1.53,-2.08l-0.87,-0.35l-2.75,0.5l-0.65,0.42l-4.09,0.54l-0.52,0.37l-2.66,-3.09l-1.7,-2.92l-1.14,-1.26l-0.48,-0.13l-1.48,0.93l-1.35,-2.28l-0.96,-0.53l0.3,-0.65l-0.16,-0.35l-1.1,-0.81ZM707.94,620.9l-1.35,-0.14l-0.08,-1.18l1.13,0.99l0.3,0.33ZM704.22,601.65l0.03,-0.32l0.11,-0.2l0.13,0.19l-0.28,0.32ZM703.11,600.89l-0.08,0.18l-0.2,-0.25l0.11,-0.06l0.17,0.12Z",name:"Malawi"},SO:{path:"M784.81,478.05l-6.52,-8.7l-0.07,-43.18l4.26,-4.23l6.72,-9.72l1.17,-1.15l2.26,-0.71l6.71,-1.1l1.31,-0.88l1.43,-2.38l1.21,-0.9l5.27,-2.43l4.69,-1.11l10.76,0.6l0.66,-0.27l17.38,-18.64l18.24,-17.68l11.31,-17.26l0.07,-21.27l4.96,-0.97l3.0,-1.29l5.57,-0.97l4.18,-2.36l2.01,-2.56l1.6,-0.41l4.95,1.72l-0.32,1.61l-1.57,3.84l0.43,3.23l0.12,5.56l-0.39,1.09l-0.71,0.59l0.19,0.58l-1.22,0.58l-0.57,1.2l-0.8,6.56l-0.09,3.22l-1.57,2.11l-0.59,1.6l-2.45,3.14l-1.7,3.98l-2.09,3.57l-3.01,2.94l-1.06,3.55l-1.04,2.2l-3.75,5.6l-1.38,2.6l-1.67,4.35l-0.52,2.76l-4.65,7.91l-4.85,6.35l-3.04,5.37l-12.82,14.18l-9.68,9.49l-2.59,1.91l-10.64,5.88l-6.89,4.92l-10.19,9.06l-10.64,11.06l-4.03,4.91l-2.84,2.8l-2.92,5.38l-1.57,2.2ZM897.88,336.12l0.13,-0.45l1.54,0.9l-0.87,-0.13l-0.8,-0.32Z",name:"Somalia"},SN:{path:"M92.84,285.0l-0.36,0.43l-0.22,-0.26l0.58,-0.18ZM93.02,284.95l3.4,-1.72l3.59,-4.5l3.2,-5.29l0.83,-2.25l0.67,-3.33l0.45,-0.33l1.82,-3.52l0.62,-0.14l2.37,0.65l2.36,0.09l4.53,-1.16l3.09,-0.27l0.35,-0.55l0.8,0.03l0.52,-0.36l0.48,0.3l1.66,0.09l2.93,-0.12l2.61,0.87l3.62,3.07l0.54,1.33l0.83,0.74l0.88,0.21l0.96,-0.38l0.52,0.52l0.72,0.1l1.12,-0.25l1.15,0.85l0.67,0.94l1.01,3.19l0.65,1.11l0.91,0.33l0.76,1.11l1.05,0.13l0.55,0.46l0.73,1.24l0.27,1.4l2.27,1.89l1.38,0.54l0.87,0.69l0.68,1.09l1.46,0.95l0.95,1.66l-0.4,2.43l2.4,2.94l-0.02,2.6l0.68,1.29l-0.2,0.74l-0.77,0.84l-0.04,1.49l1.78,2.16l0.23,0.95l0.62,0.7l0.78,-0.04l0.6,-0.73l0.96,0.19l0.53,0.8l0.41,1.47l1.75,2.61l-0.67,4.5l0.76,1.32l-1.77,-0.18l-2.77,0.46l-2.77,-0.12l-2.95,0.83l-5.72,-1.44l-1.63,-0.97l-1.35,0.55l0.12,-1.1l-0.62,-0.67l-7.61,-0.48l-17.22,-0.07l-4.58,2.28l-3.0,0.6l-3.6,-0.23l-4.38,1.29l-2.05,-0.11l-0.58,-0.98l0.14,-0.31l2.13,-0.82l1.2,0.26l0.48,-0.65l-0.22,-0.52l-1.7,-1.1l-0.53,-0.05l-0.94,1.15l-0.44,0.05l0.09,-4.89l1.05,-0.83l9.43,-0.03l0.4,-0.35l0.2,-1.73l5.87,-0.78l0.8,-0.6l0.79,-1.29l8.18,3.38l2.32,0.41l4.84,-1.19l0.53,-1.39l-0.5,-1.06l-1.46,-0.77l-2.19,0.04l-2.08,0.56l-0.8,-0.15l-1.96,-1.35l-2.24,-0.62l-1.93,-1.35l-1.24,-0.32l-2.96,0.2l-1.94,0.77l-1.05,1.65l-11.81,-0.02l-0.29,-1.04l-1.99,-2.29l1.65,-1.45l-0.38,-0.61l-1.62,0.42l-0.12,-0.88l-2.03,-3.65l-1.29,-1.05l-1.0,-1.81l-1.31,-0.91l-1.89,-0.3Z",name:"Senegal"},MR:{path:"M98.1,207.95l0.48,-2.23l45.99,-0.06l0.4,-0.43l-0.92,-14.29l-0.73,-2.46l0.03,-1.39l1.33,-2.06l4.72,-3.28l2.88,-0.57l3.44,-1.47l0.9,-0.72l0.08,-31.14l38.71,-0.0l0.4,-0.4l-0.01,-15.52l43.54,27.63l-19.44,0.01l-0.4,0.44l11.32,103.21l3.12,3.52l-1.69,8.94l-42.64,0.0l-1.49,-0.2l-0.16,-1.61l-0.51,-0.35l-1.15,0.88l-0.23,1.79l-5.46,0.96l-5.49,-0.77l-3.39,0.19l-0.7,0.5l-2.02,2.76l-5.86,-5.58l-0.75,-0.24l-1.45,0.84l-1.96,1.81l-0.9,2.33l-0.51,2.96l-0.74,1.2l-1.69,1.48l-2.04,-0.76l-1.13,-0.78l-0.65,-1.06l-3.18,-1.85l-1.35,-1.32l-0.05,-0.99l-0.93,-1.58l-0.74,-0.62l-0.99,-0.08l-0.3,-0.72l-1.2,-0.59l-1.54,-4.08l-0.86,-1.2l-1.31,-0.99l-1.93,0.12l-1.04,-0.58l-1.17,0.32l-0.96,-1.08l-0.18,-0.79l-1.34,-1.33l-2.52,-1.94l-2.86,-0.98l-3.09,0.1l-2.42,-0.37l-0.53,0.38l-0.81,-0.1l-0.5,0.66l-2.77,0.2l-4.5,1.16l-2.18,-0.08l-2.44,-0.66l-0.97,0.2l-0.97,1.11l-2.02,4.02l-0.0,-1.73l0.84,-3.76l4.5,-11.36l0.59,-4.22l-0.64,-7.78l-1.51,-5.89l-1.14,-1.95l-2.02,-1.65l-0.27,-0.56l1.52,-0.5l0.77,-1.25l-0.02,-0.45l-0.43,-0.14l-0.76,0.22l1.52,-3.1l0.84,-5.34l-2.7,-5.63l-1.28,-0.76l-0.55,0.34l-0.15,0.78l-0.25,-0.13l-2.9,-5.41l-0.77,-0.52l-0.79,0.35ZM104.46,225.57l-0.06,-0.38l0.55,-0.92l-0.13,0.74l-0.35,0.56Z",name:"Mauritania"},UG:{path:"M644.58,475.13l-0.21,-4.33l0.98,-5.43l2.6,-2.48l0.22,-1.53l-0.22,-0.42l-1.22,-0.6l-0.84,-0.05l0.28,-2.03l0.69,-0.8l1.8,-3.83l0.06,-3.66l1.17,-0.51l1.59,-1.29l0.76,-1.6l0.83,-0.85l1.38,-0.47l0.26,2.06l0.79,0.38l0.73,-0.26l3.63,-4.87l0.83,-0.85l2.25,-0.89l1.27,-1.01l1.68,-2.63l-0.16,-4.31l1.05,-1.66l-0.5,-0.47l-0.7,0.27l-1.73,2.27l-0.78,-0.98l-1.15,-0.25l-1.29,-1.26l-1.7,-0.06l-0.88,-0.48l1.43,-4.87l-0.39,-1.09l-0.71,-0.78l0.79,-2.54l0.91,-1.47l-0.08,-0.92l-0.5,-0.42l0.8,-1.23l2.43,-1.66l4.5,1.27l2.93,-1.38l1.56,2.17l2.34,1.05l0.49,-0.11l0.65,-1.06l1.46,-1.03l5.84,-1.07l1.74,-0.88l1.82,1.17l3.98,0.23l1.21,-0.78l4.38,-4.39l1.59,3.37l0.5,0.31l-0.0,0.73l1.2,0.94l1.86,0.85l-0.46,2.66l0.57,2.95l0.94,0.7l0.9,2.36l1.65,1.11l0.83,2.28l0.67,0.53l0.35,0.97l-0.24,0.79l0.95,4.18l0.14,3.91l-0.34,1.21l-1.85,2.57l0.13,1.65l-2.14,0.88l-1.5,1.41l-0.88,2.11l-1.6,2.07l-1.35,1.04l-0.96,2.65l-1.04,1.69l-1.19,0.34l-1.1,-0.21l-0.21,-0.9l-0.68,-0.4l-0.89,0.33l-0.62,0.82l-0.73,0.02l0.25,-0.52l-0.15,-0.55l-1.55,-0.47l0.27,-1.15l-0.54,-0.3l-1.08,0.11l-1.0,0.4l-0.72,2.09l-0.52,0.11l-0.37,0.73l-1.1,0.83l-1.07,-0.75l-1.5,0.72l-0.04,-0.81l-0.53,-0.67l-0.55,-0.16l-0.84,0.83l-0.52,1.32l-0.47,0.13l-0.78,-0.41l-0.88,0.85l-1.74,0.2l-2.94,1.58l-0.4,0.78l0.76,1.1l-0.05,0.53l-1.46,1.84l-1.71,3.66l0.56,2.24l-10.98,-0.08l-2.43,0.87l-2.24,-0.06l-0.8,0.24l-2.48,2.91l-1.77,1.39l-0.71,0.2l-0.54,-1.28l-0.59,-0.26l-2.39,0.57ZM687.18,457.18l0.12,-0.82l1.06,-0.02l-0.55,0.44l-0.16,0.59l-0.47,-0.19ZM673.83,462.4l0.46,0.01l-0.02,0.46l-0.21,-0.11l-0.24,-0.35ZM675.29,463.38l0.55,-0.04l-0.4,1.17l-0.61,0.23l0.55,-0.77l-0.09,-0.59Z",name:"Uganda"},SD:{path:"M636.92,346.14l-1.71,1.58l-0.17,1.46l-8.66,-0.03l-1.72,-2.99l-0.48,-0.24l-9.48,-0.14l-4.74,1.51l-1.07,-0.42l-4.41,-5.13l-2.98,-2.46l-0.61,-2.66l-1.15,-0.4l-5.95,1.19l-2.18,0.09l-0.69,0.37l-0.58,0.87l-0.22,2.05l-2.53,3.29l-0.06,2.98l-1.28,1.68l-0.28,2.41l-1.15,2.04l-0.13,1.24l-3.63,1.38l-0.82,1.09l-6.16,-1.05l-0.35,-0.38l0.06,-1.63l-0.94,-1.06l0.04,-0.55l1.41,-1.64l0.39,-1.07l0.41,-4.45l-0.15,-1.56l-1.21,-2.49l-2.74,-4.26l-4.11,-4.35l-1.09,-1.77l0.88,-3.16l-0.19,-1.94l-1.0,-0.91l-0.83,-0.15l-2.09,-1.83l-0.35,-0.93l0.26,-3.9l-0.51,-0.76l-0.73,-0.14l-0.95,-4.58l0.22,-1.18l-0.73,-1.36l-1.8,-0.79l-3.43,0.38l-0.89,-0.97l0.9,-2.28l0.9,-1.24l2.0,-1.26l0.88,-1.46l-0.06,-1.96l-1.32,-3.07l-0.01,-0.67l0.67,-1.12l4.31,-3.03l-0.04,-0.84l-0.94,-1.07l-0.7,-2.9l0.77,-0.75l2.42,-1.1l0.24,-1.72l0.92,-1.67l2.02,-2.04l0.46,-1.89l-0.39,-2.6l1.72,-1.74l4.03,-0.14l1.72,-0.38l3.9,0.5l0.75,-0.53l0.12,-51.43l11.17,0.01l0.55,-0.49l0.01,-24.02l72.66,0.01l0.96,-0.31l1.31,-2.23l0.55,0.29l-0.56,1.71l0.38,0.53l63.39,-0.01l0.12,2.49l0.56,2.35l1.81,3.2l1.93,2.41l-0.62,-0.25l-0.55,0.34l-0.11,1.49l0.37,3.13l0.63,2.12l-0.45,1.97l0.06,3.35l0.81,4.03l-0.15,2.62l1.33,5.96l1.31,3.36l0.89,1.02l2.35,0.74l2.16,1.61l3.24,3.67l1.17,-0.15l0.46,0.59l2.73,1.71l0.22,0.43l-1.99,2.04l-0.62,1.36l-1.37,1.52l-5.34,1.43l-2.9,1.71l-0.54,0.6l-0.97,2.46l-2.64,0.23l-1.9,-0.2l-0.36,0.27l-0.38,3.16l-1.06,2.25l0.3,3.86l-1.16,3.57l-1.58,3.23l-1.82,5.63l-1.16,1.66l1.14,10.41l-0.92,3.13l0.02,1.82l-0.64,2.5l-2.08,4.21l-0.63,2.17l-0.4,3.98l-4.35,0.9l-0.91,0.57l-0.91,1.08l-4.01,6.87l-1.69,1.76l-1.79,6.45l-0.37,4.87l-1.41,1.11l-1.86,-1.32l-0.74,-0.18l-1.68,1.12l-1.12,1.63l-0.86,1.83l0.42,3.87l-1.77,3.95l-0.96,4.36l-1.64,-0.19l0.26,-2.3l0.82,-1.84l-0.09,-2.39l-0.66,-1.65l-5.28,-4.41l-1.07,-1.24l-2.59,-0.99l0.4,-1.09l-1.16,-8.77l0.56,-1.07l0.17,-3.01l0.68,-2.33l0.07,-0.98l-0.39,-0.43l-5.6,-0.07l-0.44,0.42l0.22,2.12l-7.41,0.03l-0.3,0.67l3.05,3.42l-0.01,4.63l0.97,2.46l-5.6,4.89l-1.71,3.36l-6.56,6.83l-5.16,0.74l-3.2,-2.87l-5.53,-3.54l-0.42,-0.0l-4.7,2.54l-0.17,1.9l-1.33,1.56l-4.06,1.1l-1.75,1.06Z",name:"Sudan"},MZ:{path:"M682.61,781.45l-5.86,0.15l-2.46,-0.31l-0.07,-3.6l-0.75,-2.96l0.22,-3.37l-1.36,-0.96l-0.28,-2.0l0.75,-1.85l0.01,-14.7l-2.2,-7.12l-2.99,-5.12l-0.14,-2.42l-2.83,-10.56l1.53,-1.18l11.71,-12.29l0.1,-0.46l-0.8,-1.77l1.38,-2.29l0.16,-3.4l2.08,-1.71l3.82,-6.63l0.14,-1.59l-2.06,-3.84l-0.57,-1.9l0.6,-1.72l0.19,-1.93l-0.43,-0.72l-1.15,-0.63l-0.14,-0.51l0.15,-1.01l1.44,-0.73l0.55,-0.64l1.3,-4.59l-0.44,-3.4l0.16,-10.06l-1.0,-2.64l-0.09,-1.68l0.83,-2.1l-0.32,-0.45l-2.3,-0.38l-1.29,-1.07l-4.63,-1.71l-3.52,-0.25l-2.86,-2.5l-2.47,-0.5l-3.08,-1.89l-9.33,-0.38l-0.14,-3.84l-0.54,-3.55l-1.17,-2.06l-0.33,-1.85l5.01,-1.99l10.13,-2.9l19.34,-6.68l1.96,3.1l2.92,3.37l5.14,-0.87l1.93,-0.74l1.62,-0.05l1.4,1.9l0.6,4.86l-0.19,3.24l-1.2,2.08l-0.89,2.71l-1.31,1.51l-0.04,0.93l1.8,2.36l-0.07,1.37l0.34,0.83l1.34,0.92l4.78,5.33l1.68,0.91l0.08,1.13l-0.61,0.86l0.32,0.88l0.99,0.73l1.83,-0.11l0.54,-0.67l-0.11,-3.49l-0.62,-2.13l-0.67,-0.93l1.38,-3.52l0.6,-0.83l4.04,-0.77l0.81,-0.7l0.44,-1.29l0.34,-3.37l0.12,-3.14l-0.29,-1.86l0.39,-2.67l0.61,-1.67l-0.59,-3.02l-7.04,-9.27l-2.76,-3.05l-1.69,-1.39l-0.18,-1.71l-0.42,-0.53l-0.11,-3.29l-0.35,-1.0l0.44,-2.32l-0.22,-1.58l-1.07,-2.47l0.09,-2.62l1.74,-1.65l0.42,-0.79l0.53,-1.44l0.29,-3.15l6.72,0.29l0.99,-0.31l1.75,-1.46l1.22,0.02l2.84,1.67l0.42,0.88l1.44,0.44l2.5,0.12l1.92,-0.39l1.26,-0.92l2.18,-0.46l2.72,1.39l2.04,0.3l2.08,-0.46l2.24,-1.19l1.23,-1.17l0.93,-2.13l2.82,-0.17l1.52,0.36l2.43,1.18l3.51,-2.16l2.16,-0.7l2.09,-0.0l1.88,-0.54l2.84,-1.71l3.04,-0.82l2.06,-1.12l5.19,-3.94l1.31,1.73l-1.13,0.91l0.03,0.67l0.9,0.54l-0.75,1.01l-0.12,0.82l0.41,0.85l-1.61,3.06l0.7,1.57l-0.34,2.52l1.12,4.02l-0.34,1.37l0.24,3.2l-0.39,1.08l0.76,0.81l0.32,1.07l-0.27,1.97l-1.26,1.04l-0.15,1.09l0.39,0.39l1.18,0.01l-0.21,3.2l0.32,1.05l-0.41,1.14l0.59,7.87l0.25,0.8l1.14,0.55l-0.88,1.76l0.07,1.85l0.3,0.34l0.43,-0.17l1.0,-1.23l0.27,0.3l0.32,2.9l-0.08,0.64l-1.51,1.6l-0.21,1.61l-0.78,0.64l0.32,1.89l-1.03,2.43l-5.24,6.03l-0.18,1.13l-1.22,1.74l-2.24,0.85l-0.16,0.48l0.5,1.34l-6.81,4.22l-1.83,2.13l-2.22,0.79l-2.44,0.1l-6.24,2.34l-1.25,0.99l-2.41,0.86l-3.86,2.16l-3.14,2.05l-3.64,3.12l-0.53,1.72l-4.19,4.69l-1.5,2.12l-0.14,0.86l-0.39,0.12l-0.58,-0.69l-0.7,0.19l-0.27,1.45l-1.13,-0.25l-3.22,1.86l-2.46,2.15l-3.33,3.99l-4.78,3.79l-0.8,0.08l-1.65,-1.35l-1.24,0.12l0.06,0.45l1.13,1.31l-0.58,7.87l3.29,4.23l1.55,4.65l0.16,2.57l1.6,3.06l0.72,4.68l-0.16,4.36l0.92,1.04l0.63,-0.13l0.29,-0.64l0.32,-3.09l0.36,1.14l0.13,1.44l-0.6,3.55l0.97,3.72l-0.92,2.66l-1.46,7.65l0.4,0.74l0.99,0.33l0.61,-0.67l-0.58,2.82l-2.69,4.42l-1.11,1.33l-1.85,1.31l-4.46,2.1l-9.03,3.07l-5.76,2.42l-4.59,2.9l-2.05,1.98l-0.89,2.3l-1.54,2.29l0.0,0.41l1.35,1.98l1.8,1.47l0.6,-0.22l0.28,-0.92l-0.58,7.72Z",name:"Mozambique"}},height:1054.4456598737515,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","ar_mill",{insets:[{width:900,top:0,height:1775.5897460258225,bbox:[{y:2464855.8822114565,x:-8195937.5628109295},{y:6843324.315777245,x:-5976606.436896723}],left:0}],paths:{"AR-Z":{path:"M26.08,1409.8l2.05,-1.87l2.03,-0.67l4.35,-0.45l2.16,-0.69l1.78,-1.21l5.62,-5.5l1.23,-1.7l0.53,-1.98l0.19,-2.3l-0.28,-6.15l-1.02,-3.26l-0.35,-2.8l1.61,-3.15l3.46,-2.04l2.95,-0.9l0.82,-0.6l1.94,-2.49l0.93,-0.11l1.51,0.37l0.86,-0.4l0.33,-0.83l-1.35,-2.98l0.72,-4.28l-1.07,-6.95l-0.46,-1.25l-2.15,-0.91l-0.53,-1.74l-0.83,-0.98l-2.72,-0.99l-1.36,-1.13l-1.09,-1.46l-0.34,-1.57l1.93,-3.5l1.92,-5.89l4.24,-6.52l0.87,-1.96l1.13,-5.21l-0.04,-0.91l-0.9,-0.88l-1.28,-0.58l0.32,-1.04l1.29,-1.23l1.73,-0.62l3.55,0.3l0.98,-0.16l0.93,-0.64l5.13,-5.51l0.95,-1.49l0.45,-1.24l-0.7,-3.01l0.39,-0.67l0.69,0.03l2.81,1.64l1.6,0.43l1.72,-0.75l0.96,-1.61l0.06,-1.9l-0.52,-1.5l-0.93,-1.31l-4.18,-2.42l-0.76,-0.86l0.16,-0.75l2.78,-1.5l0.99,-0.98l0.05,-0.5l-0.54,-0.84l-1.9,-1.9l0.75,-3.96l0.79,-1.27l-0.63,-2.17l0.54,-0.62l3.33,-0.25l1.23,-0.43l2.6,-2.84l2.47,-1.25l1.59,-1.52l0.43,-2.09l-0.68,-4.06l0.67,-2.84l-0.22,-1.16l-3.01,-7.12l-0.42,-1.91l0.11,-4.74l-0.27,-1.88l-0.99,-1.22l-5.74,-3.88l0.23,-0.41l3.88,-0.51l2.17,-0.83l2.23,-3.2l3.21,-3.15l182.99,0.03l-1.61,5.14l-0.06,3.81l2.16,8.95l1.54,4.52l5.35,9.49l4.01,3.38l3.67,1.08l1.08,1.55l1.74,1.14l2.78,0.84l0.61,1.53l1.58,1.33l2.14,3.42l1.58,0.47l0.37,0.68l4.89,4.61l2.62,3.55l1.79,1.51l4.03,1.83l1.79,-0.07l1.35,0.82l2.04,-0.51l0.98,0.38l2.72,-0.41l2.88,1.15l2.54,-0.19l1.21,0.52l7.11,1.29l5.29,-0.39l2.65,-0.88l1.99,-0.07l2.65,1.54l1.75,0.19l0.87,0.8l0.59,1.6l4.37,3.5l-0.37,1.07l1.89,6.67l-0.61,3.8l-0.4,5.71l-4.89,13.15l-1.88,0.37l-6.21,-0.64l-1.61,1.16l-1.53,1.68l-5.09,2.31l-2.86,1.77l-0.9,0.22l-3.52,-0.14l-1.03,0.53l0.29,0.4l2.19,0.65l1.93,-0.14l3.58,-1.73l3.64,-0.85l4.29,-2.09l1.23,-1.19l2.01,-0.34l3.06,0.28l0.6,0.62l1.38,5.4l1.31,1.29l2.29,0.6l-0.93,1.08l0.18,0.54l0.51,0.25l-1.96,0.51l-0.6,-1.02l-2.37,-0.69l-1.52,0.53l-1.03,1.36l-0.32,1.18l0.93,0.88l-0.24,1.1l-0.54,1.19l-0.71,0.42l-0.18,0.48l0.34,0.76l1.2,0.85l1.45,0.4l0.13,0.5l-0.66,0.84l-0.81,0.15l-0.46,-0.68l-0.84,-0.31l-1.06,0.42l-3.24,0.19l-2.25,0.82l-1.21,0.98l-0.35,1.31l-0.8,1.3l-3.4,1.3l-1.33,2.0l-1.49,0.48l-0.93,0.87l-0.94,1.35l-0.82,2.02l0.49,1.74l-4.35,-0.3l-1.18,0.92l-0.08,2.11l-1.26,0.68l-1.89,0.55l-4.97,0.49l-1.88,1.37l-2.51,1.15l-2.82,2.27l-2.29,2.29l-0.33,2.14l-1.98,0.76l-3.36,0.5l-2.56,1.87l-3.15,1.7l-1.22,1.4l-0.39,2.75l-1.76,1.78l-0.6,2.59l-2.06,1.46l-3.35,1.27l-3.79,2.15l-6.89,6.56l-0.94,2.04l-0.94,3.33l-1.68,1.55l-0.12,1.49l0.96,0.66l0.12,0.5l-1.71,1.04l-1.15,3.07l-1.06,0.95l-1.26,0.39l-0.2,0.62l0.97,1.11l0.0,0.69l-1.99,1.12l-0.06,0.67l0.41,0.32l-0.01,0.4l-1.06,0.9l-2.44,0.29l-0.34,0.31l0.16,0.8l0.97,0.37l4.3,-0.13l1.35,-1.27l0.68,-2.08l-0.05,-1.53l0.69,-0.89l0.25,-1.57l0.88,-0.9l0.85,0.74l-0.16,3.14l-1.9,3.22l-2.11,9.2l-0.81,8.03l0.24,0.94l-0.86,5.51l-1.78,5.22l-2.72,4.83l-2.72,2.44l-8.12,5.29l-4.16,1.55l-3.9,0.61l-3.56,-0.38l-1.44,-1.88l-1.1,-0.57l-0.94,-1.32l-1.87,-4.23l-2.65,-2.36l-0.87,-1.35l-1.24,-3.35l-3.86,-5.98l-2.03,-1.46l-2.14,-0.51l-0.42,0.28l0.18,0.47l2.77,1.62l0.49,0.57l0.28,0.9l2.79,4.42l0.78,2.51l0.02,1.21l-1.98,1.32l-2.12,0.88l-9.17,-0.29l-3.06,1.63l-1.41,0.08l-1.95,1.29l0.37,0.84l4.5,-0.23l1.68,-1.15l1.63,-0.63l3.25,0.05l4.39,0.74l3.97,-1.42l0.76,0.36l0.49,1.3l1.3,0.8l0.34,2.55l0.91,1.34l1.3,1.24l0.97,0.56l1.86,0.42l0.47,0.62l1.34,0.42l0.38,0.55l-0.39,0.84l-1.49,0.52l-1.83,1.3l-13.37,5.31l-1.58,-0.06l-1.1,0.9l-0.23,0.8l-1.68,0.39l-0.94,-0.15l-0.91,0.5l-0.38,1.42l-0.8,0.53l-3.45,4.04l-4.56,7.74l-0.22,2.76l-3.16,8.17l0.13,1.25l0.65,1.44l0.2,5.45l-0.35,1.33l-2.97,1.81l-2.52,2.34l-3.97,2.67l-1.91,1.78l-1.02,2.25l0.13,0.48l0.5,-0.01l5.48,-4.03l4.04,-2.07l0.93,-0.09l2.74,13.75l0.79,1.32l1.11,5.17l4.46,10.73l0.39,2.35l-0.3,0.85l-0.64,0.5l-1.61,-0.48l-1.46,0.05l-3.12,2.44l-2.17,-0.3l-5.18,-2.4l-4.26,-0.17l-1.93,0.83l-3.68,0.58l-2.14,1.56l-3.22,1.17l-0.2,0.49l0.46,0.26l11.83,-2.2l2.1,0.29l6.26,2.32l-0.19,0.54l-2.34,1.65l-0.17,0.7l0.4,0.4l1.04,-0.03l4.59,-2.03l3.12,-2.32l1.06,-0.14l1.06,0.45l1.58,1.43l2.8,6.74l2.13,2.76l6.39,12.12l14.43,18.24l0.4,0.94l-0.25,0.62l-2.73,2.87l0.1,-1.15l-0.51,-1.1l0.02,-2.11l-0.59,-1.04l-5.31,-1.18l-2.29,-1.03l-8.94,-1.23l-8.44,-3.88l-9.25,-2.49l-12.36,-0.34l-21.18,-7.56l-88.65,-1.05l-1.83,-1.0l0.72,-4.38l-0.45,-1.69l-1.12,-1.53l-4.18,-4.08l-3.19,-2.39l-2.12,-1.16l-4.18,-1.14l-0.74,-0.51l-0.53,-1.04l-0.38,-3.25l-0.48,-1.25l-1.13,-1.07l-3.35,-0.42l-0.7,-1.04l1.07,-1.55l3.3,-2.94l-0.01,-2.2l0.98,-1.74l0.28,-1.18l0.14,-4.69l2.79,-4.1l-0.04,-1.16l-0.74,-0.83l-3.47,-2.02l-1.39,-1.31l-0.88,-1.92l-0.06,-1.04l0.3,-0.68l2.04,-2.67l0.46,-0.48l2.16,-0.61l0.79,-1.43l0.5,-2.78l0.42,-5.14l-0.31,-2.4l-0.98,-1.68l-2.44,-2.97l-0.37,-0.92l0.26,-1.42l1.66,-3.11l-0.12,-1.35l-3.74,-1.74l-5.54,-1.13l-2.31,0.93l-3.0,2.96l-1.74,0.05l-3.13,-2.54l-1.01,-0.47l-1.26,0.16l-5.78,2.85l-6.68,5.4l-1.89,0.72l-1.76,-0.02l-1.5,-1.07l-0.66,-6.38l-2.93,-4.01l-0.17,-4.32l-0.62,-4.29l0.07,-3.64l-1.28,-4.01l-2.13,-3.43l-2.72,-1.61l-5.5,-4.4l-0.42,-1.37l0.41,-1.63l2.26,-3.51l0.14,-1.14l-1.04,-1.92l-3.15,-2.59l1.34,-2.05l0.3,-2.61l2.3,-2.06l0.97,-1.73l-0.16,-1.79l-1.24,-1.89l-2.1,-2.04l-0.25,-0.75l1.22,-2.65l-0.15,-1.53l-2.95,-3.88l1.98,-2.62l-0.33,-2.87l0.4,-0.78l2.43,-1.49l0.97,-1.01l0.22,-0.93l-0.4,-3.13l0.36,-0.33l13.98,-0.23l0.83,-1.49l1.37,-0.33l0.33,-0.72l-0.33,-0.43l-2.79,-0.46l-0.75,-0.9l-0.05,-1.23l0.53,-1.31l2.9,-3.2l0.5,-0.93l0.21,-2.29l0.57,-1.21l2.73,-3.49Z",name:"Santa Cruz"},"AR-X":{path:"M384.38,647.89l-0.01,-52.57l-2.02,-38.28l1.74,-3.25l2.05,-0.63l0.68,-0.86l-0.49,-2.56l1.61,-3.32l-0.32,-2.32l1.85,-3.42l0.38,-3.16l0.87,-1.81l0.07,-1.83l1.29,-1.58l0.45,-2.47l1.04,-2.3l0.41,-3.68l-0.83,-3.27l-1.35,-2.75l0.3,-3.78l-0.17,-2.3l-0.51,-0.86l-1.07,-0.36l-5.67,1.46l-5.21,0.42l-0.32,-0.6l0.05,-2.48l-1.41,-2.7l-0.62,-4.19l-3.0,-3.27l-15.04,-8.5l-1.57,-0.42l-3.59,-0.01l-0.34,-38.96l0.6,-2.99l8.13,-23.02l0.41,-2.26l1.71,-5.42l1.88,-3.38l3.67,-10.09l9.45,-2.58l2.34,-1.21l8.91,-9.21l0.52,-0.91l0.13,-1.2l-1.36,-11.35l0.39,-1.28l2.89,-1.0l26.51,-6.49l1.73,-0.04l9.05,2.33l-0.07,2.5l1.03,1.04l3.36,1.74l1.0,1.31l3.62,0.87l2.09,1.31l3.71,0.2l5.32,-0.8l3.86,1.06l2.56,-0.24l0.12,2.78l2.79,0.76l0.11,1.53l0.74,0.73l49.41,0.27l1.86,1.29l6.93,17.14l-2.1,12.78l0.42,2.23l10.07,10.78l2.01,2.77l-0.37,2.66l-11.53,40.78l-0.71,1.54l-4.47,4.1l-0.02,1.02l0.86,1.6l-0.26,3.15l0.34,3.77l1.41,2.67l-1.26,3.48l-0.29,5.32l3.77,4.01l2.65,1.54l1.48,4.66l1.38,2.45l3.3,2.41l1.21,1.39l0.85,4.65l1.29,1.44l-0.18,1.44l-1.07,1.58l-0.03,0.65l0.6,0.51l2.29,0.62l2.32,4.35l1.58,1.39l0.41,0.91l0.01,1.0l-1.08,3.05l0.04,3.13l-0.34,2.31l-0.6,1.11l-2.21,2.03l-1.04,0.53l-1.77,0.12l-1.3,1.59l-42.06,64.1l-21.73,-0.08l-1.83,1.82l-0.48,8.73l-0.1,21.18l-76.1,-0.02Z",name:"C\xf3rdoba"},"AR-Y":{path:"M286.66,92.42l10.66,-34.74l-8.02,-8.61l2.14,-3.49l1.28,-1.5l3.38,-2.61l0.58,-0.81l0.17,-1.3l-0.34,-4.0l2.12,-0.09l2.09,-2.06l6.76,-2.51l0.2,-0.8l-0.26,-1.38l0.66,-1.0l0.87,-4.63l0.83,-1.87l1.41,-1.01l2.88,0.48l0.57,-0.92l11.13,-3.07l1.23,-0.89l0.83,-1.3l1.35,-0.39l0.51,-1.4l0.43,-4.39l2.08,-7.55l0.47,-0.15l3.67,1.16l1.87,0.92l1.27,1.34l0.84,2.63l4.32,0.83l0.86,0.48l5.74,6.64l1.51,1.03l1.55,0.44l6.29,-0.71l1.1,-0.59l5.55,0.71l11.62,-0.14l-0.22,0.99l-1.05,1.79l-0.72,2.63l-0.19,4.58l-1.5,2.36l-1.7,4.37l-1.06,1.9l-0.52,4.15l0.43,0.82l1.4,-0.01l1.75,1.61l-0.88,2.02l0.0,2.49l0.78,5.33l1.72,4.94l0.92,1.09l1.49,1.01l5.69,0.35l1.57,1.49l0.4,2.04l-1.53,8.8l0.85,1.16l3.23,1.45l2.8,5.7l0.32,2.29l0.56,0.98l2.71,0.52l1.06,-0.09l2.26,-1.72l3.64,-0.58l1.22,1.12l3.43,1.27l1.67,1.45l2.39,3.11l1.25,0.88l0.47,-0.01l1.11,-0.9l0.81,-2.71l1.29,-1.62l6.31,-0.08l1.2,0.24l0.25,1.06l1.0,30.62l-0.79,2.6l-1.55,2.73l-3.82,4.85l-1.05,0.69l-4.19,0.56l-1.47,1.81l-2.54,0.72l-3.15,2.96l-1.63,3.24l-0.32,0.07l-8.54,-7.32l-0.67,-0.24l-0.43,0.13l-1.3,1.86l-2.04,4.72l-1.11,0.1l-4.25,-1.55l-1.42,-0.85l-3.79,-3.01l-0.93,-1.47l-0.72,0.08l-1.82,1.22l-2.57,0.96l-3.75,-1.41l-2.89,-0.51l-2.32,-1.9l-1.11,-0.04l-1.27,0.6l-2.38,-1.35l-1.33,-2.43l-4.55,-5.89l-1.49,-2.48l-0.31,-0.81l0.15,-1.99l-0.31,-2.05l-3.36,-1.89l-2.1,-2.11l-1.07,-0.65l-1.11,-0.04l-0.84,0.69l-0.62,-0.03l-1.67,-2.29l0.34,-1.79l-0.72,-1.87l-0.71,-0.35l-0.04,-0.31l0.21,-3.64l1.55,-2.5l-0.56,-1.55l0.5,-1.14l-0.23,-2.26l0.25,-3.62l-2.02,-2.23l-6.47,-3.8l-1.92,-0.09l-1.91,-1.26l-1.36,-0.08l-2.68,-1.08l-1.06,0.13l-0.94,1.14l-1.35,6.3l0.2,1.94l2.91,7.9l0.18,2.66l-0.81,12.38l-1.12,2.65l-0.44,1.95l-1.36,0.65l-2.32,3.09l-1.35,0.7l-2.73,0.12l-1.54,-0.33l-3.11,-1.54l-4.22,-4.83l-4.7,-2.28l-2.6,-2.94l-0.65,-1.56l-1.88,-0.62l-0.56,-1.44l-3.63,-3.78l-0.72,-0.44l-2.3,-0.47l-1.53,-1.71l-1.83,-0.79l-1.19,-1.21Z",name:"Jujuy"},"AR-V":{path:"M411.27,1762.25l0.32,-0.91l-0.4,-0.4l-1.12,0.17l-1.02,0.81l0.26,0.72l-2.38,1.02l-1.5,2.06l-2.85,0.13l-0.46,-0.3l1.08,-1.39l-0.15,-0.58l-3.81,-2.0l0.14,-0.74l1.9,-1.21l1.05,-1.26l3.52,1.68l3.87,-1.12l0.8,-0.67l0.0,-0.61l-2.43,-2.03l-0.22,-0.47l0.61,-0.2l1.98,2.12l1.8,0.42l1.38,-0.75l0.88,-0.08l0.49,2.14l0.77,0.41l0.53,-0.11l0.39,-0.6l-0.25,-2.82l0.39,-1.32l1.42,0.93l0.87,-0.26l1.77,0.6l1.89,-0.26l1.83,1.51l0.87,-0.22l0.33,-0.91l-0.19,-0.74l0.25,-0.07l1.32,0.85l1.46,-0.86l0.72,1.64l0.8,0.52l1.97,-1.07l4.8,-1.09l0.87,0.28l0.22,0.6l0.91,0.2l1.87,-1.01l0.2,0.3l-1.11,0.88l-1.2,2.13l-1.99,0.49l-2.28,1.56l-0.42,-0.03l1.13,-2.25l-0.22,-0.93l-0.84,-0.41l-2.17,1.56l-2.72,-0.04l-0.87,0.55l-0.37,0.94l-0.9,0.39l-4.16,0.61l-0.92,0.94l-0.71,-0.47l0.02,-0.49l0.82,-2.23l-0.39,-0.55l-1.51,0.35l-0.68,-0.38l-0.74,0.15l-3.41,2.06l-1.87,1.72l-2.21,0.4ZM223.8,1758.43l0.64,-131.33l1.15,0.92l1.27,2.54l2.95,3.59l2.95,4.42l3.91,3.15l1.32,1.54l2.0,4.08l1.79,7.32l-1.88,-5.68l-1.31,-0.57l-2.2,0.64l-2.76,2.01l-2.28,2.32l-2.83,2.21l-1.54,2.84l-0.44,2.26l0.7,2.6l1.95,1.86l2.79,1.89l1.8,0.13l5.16,1.24l4.82,-0.38l3.29,1.73l1.48,2.96l-0.24,2.17l0.73,1.66l0.84,4.08l2.92,4.88l8.66,7.88l4.02,2.84l0.12,0.69l-0.4,0.77l0.38,0.58l2.1,-0.25l4.4,2.12l-0.93,0.49l-0.52,1.3l0.2,1.48l0.7,1.18l12.36,9.03l7.12,4.34l5.17,2.04l2.88,1.55l0.92,1.18l1.61,0.8l6.33,2.3l2.82,2.3l2.21,3.67l4.47,3.57l1.14,1.53l1.61,0.78l0.67,1.62l4.73,1.22l4.04,2.12l15.51,6.28l2.47,0.42l2.17,1.31l3.41,0.19l3.26,0.74l10.84,-1.36l3.5,0.26l3.21,-1.13l7.01,1.02l-2.21,2.4l-1.38,3.34l0.5,1.37l-1.33,1.03l-0.43,0.74l0.34,1.62l-2.7,1.93l-1.24,3.91l-0.99,0.65l-1.1,-0.04l-0.04,-1.0l-0.48,-1.0l-1.4,-0.65l-1.54,0.03l-1.23,0.7l-0.17,0.45l0.3,1.02l-0.73,0.86l-3.45,-0.28l-1.68,0.38l-1.1,1.87l-1.24,0.47l-0.58,-0.13l-0.89,-1.06l0.0,-1.65l-0.71,-1.07l-2.35,-0.22l-1.88,0.59l-2.87,-0.95l-1.32,0.68l-3.03,-0.5l-0.96,0.54l-0.13,0.58l1.44,1.65l-1.57,1.62l-5.45,1.42l-9.09,-0.02l-2.46,0.66l-0.29,0.44l0.04,1.64l-3.27,0.83l-3.94,-0.06l-3.96,-1.23l-1.26,-0.61l-2.49,-2.54l-4.09,-2.41l-1.35,-0.4l-5.12,-0.48l-3.93,-1.48l-13.62,-0.81l-9.38,-1.11l-5.78,0.37l-11.89,-1.13l-6.48,-1.01l-2.2,-1.4l-4.23,-0.33l-3.74,-1.65l-0.99,0.67l0.04,1.68l-0.53,0.78l-8.47,0.6l-1.75,-0.73l-1.39,-1.73l-1.98,-1.75ZM223.36,1764.78l0.41,-1.63l0.01,-2.33l2.4,3.07l0.1,0.59l-0.52,0.26l-2.4,0.04Z",name:"Tierra del Fuego"},"AR-W":{path:"M650.51,343.95l1.86,-3.66l0.54,-3.01l-0.08,-2.13l1.95,-3.92l0.57,-1.94l-0.17,-4.7l1.11,-6.42l-1.11,-3.85l0.4,-2.79l-0.39,-3.52l0.39,-1.57l0.84,-1.2l0.68,-0.31l2.61,-0.08l1.63,-0.44l2.59,-2.09l0.9,-1.52l1.6,-6.2l-0.09,-3.69l1.16,-3.37l0.1,-2.84l-0.85,-3.64l-2.27,-4.51l-0.08,-3.11l10.25,-7.13l6.44,-2.51l12.21,-1.03l4.97,0.61l4.76,-0.48l14.06,3.39l8.83,4.1l1.34,0.13l4.53,-0.63l2.13,0.26l1.43,1.25l3.03,0.93l2.71,1.63l3.2,0.16l1.58,-0.33l4.55,-2.4l1.57,-0.62l1.5,-0.15l1.42,0.56l2.73,2.64l1.99,1.08l1.84,-0.38l2.25,-1.7l3.01,-0.85l2.77,0.39l3.75,4.71l1.51,1.15l1.66,0.58l1.7,-0.47l1.45,-2.71l1.76,-2.18l0.57,-1.1l0.2,-3.27l3.17,-1.24l1.76,-1.89l1.82,-1.15l2.1,0.27l3.85,1.3l-0.77,0.8l-0.68,1.75l-0.13,2.96l6.53,12.97l0.97,3.32l0.56,5.87l0.31,0.71l2.31,2.66l0.8,2.74l1.26,1.89l4.9,3.63l-2.41,2.13l-2.91,0.98l-1.27,1.2l0.42,1.49l3.57,1.6l0.89,1.5l-0.57,2.14l-0.66,1.13l-0.3,0.21l-0.21,-0.93l-0.93,-1.05l-4.87,-0.96l-2.28,0.85l-0.94,0.79l0.27,1.79l-0.11,2.48l-5.01,1.62l-0.51,0.87l-0.02,3.58l-0.74,0.99l-2.84,1.96l-3.65,4.66l-1.4,0.9l-2.13,0.4l-1.13,0.59l-0.44,0.92l-0.27,4.11l-0.9,1.55l-3.17,1.89l-0.87,1.92l-0.23,2.97l-0.46,0.75l-3.66,1.08l-1.66,0.83l-3.21,2.57l-1.61,2.52l-0.32,1.53l0.26,0.68l-1.59,3.59l-3.69,2.46l-0.56,0.97l-0.09,1.31l-1.06,0.97l-0.51,1.46l-3.47,2.93l-0.7,1.14l-2.43,2.12l-0.66,1.73l-1.84,2.35l-4.03,3.98l-4.76,0.59l-1.94,0.7l-1.43,1.18l-0.91,1.92l-0.69,6.33l-3.87,2.89l-4.24,5.13l-1.83,1.21l-3.69,0.63l-0.68,0.62l0.75,3.5l-0.3,1.76l-0.91,1.47l-8.89,7.74l-1.24,1.47l-0.65,1.92l0.21,2.25l2.67,4.92l0.55,1.88l-1.92,-1.43l-5.23,-5.13l-2.18,-3.95l-0.82,-3.98l-0.61,-1.08l-4.76,-4.04l-2.64,-4.38l-1.55,-1.17l-8.77,-2.31l-3.05,-0.05l-2.94,-1.48l-2.16,-0.02l-6.56,2.67l-4.47,1.0l-5.91,-1.11l-4.31,2.33l-3.04,2.75l-3.22,1.77l-4.15,-1.46l-2.41,-0.35l-3.13,0.68l-2.0,-0.52l-3.14,1.16l-3.78,0.19l-0.28,-1.73l0.97,-3.31l0.41,-3.68l1.62,-3.24l0.34,-1.91l-0.19,-1.9l-1.41,-4.08l-1.56,-2.58l-0.32,-1.38l0.32,-1.24l1.71,-3.39l1.63,-6.73l0.1,-10.11l1.85,-7.36l0.63,-1.33l2.04,-1.93l5.71,-2.26l3.81,-3.1l2.77,-1.58l0.87,-1.56l0.15,-4.76Z",name:"Corrientes"},"AR-T":{path:"M387.48,287.37l-0.86,0.2l-0.46,0.53l-1.35,3.98l-0.37,0.72l-0.8,0.47l-2.26,-0.06l-2.5,1.13l-1.19,0.1l-1.52,-0.63l-3.14,-2.25l-1.1,-0.01l-3.78,2.25l-2.98,2.59l-2.81,4.29l-4.12,-4.98l-1.83,-6.33l-2.58,-1.5l-0.91,-0.04l-2.04,0.81l-1.04,-0.98l-1.24,-4.07l-2.31,-2.06l-2.55,-10.74l0.42,-1.24l-0.27,-0.74l-2.12,-0.5l-3.7,-2.03l-2.56,-0.39l-1.15,-0.6l2.02,-3.67l3.32,-3.24l1.62,-3.26l5.71,-5.93l1.28,-2.04l0.75,-2.04l0.0,-3.42l0.79,-3.81l-0.14,-1.63l-0.99,-1.33l-2.04,-0.96l-5.15,-4.26l-2.24,-0.86l-1.86,-0.33l-1.22,-1.28l-0.13,-1.7l2.21,-5.72l0.29,-2.78l1.63,-2.05l0.34,-0.89l12.98,2.17l1.6,0.08l0.8,-0.33l0.82,-1.41l-0.03,-2.88l0.59,-2.06l0.16,-3.54l0.47,-0.72l3.8,1.28l1.71,-0.07l4.48,0.99l1.05,-0.1l2.53,-1.38l2.04,-0.65l1.56,3.45l1.14,1.14l8.69,3.41l1.99,-0.06l2.29,1.34l1.1,0.3l2.15,-0.3l2.38,-1.76l3.52,-0.97l3.16,0.64l9.17,-0.21l0.05,4.33l-1.77,6.18l1.13,8.6l-0.05,2.48l-2.64,-0.41l-0.97,0.31l-1.82,5.56l-1.85,0.33l-0.55,0.38l-2.43,8.88l-0.59,1.16l-0.85,0.58l-0.7,1.09l-1.35,5.26l-1.33,3.29l-1.04,1.46l-0.98,2.76l-0.43,0.54l-1.12,0.22l-1.09,0.88l-5.6,6.21l-0.01,0.52l0.98,0.72l1.59,0.4l1.61,0.84l-1.39,1.89l-2.45,0.45l-0.69,1.71l0.08,1.26l3.04,6.99Z",name:"Tucum\xe1n"},"AR-U":{path:"M74.24,1095.36l0.74,-0.99l-0.19,-1.76l1.28,-1.3l0.36,-2.29l1.6,-0.22l2.51,-0.92l1.92,0.37l0.86,-0.79l0.13,-2.24l-0.36,-1.8l0.64,-2.09l-0.48,-1.17l-0.9,-0.61l-4.23,-1.59l-6.72,-0.72l-1.91,-0.78l-1.8,-1.41l-1.43,-1.9l-0.81,-2.23l1.61,-7.36l-0.39,-7.88l-0.91,-3.43l0.43,-1.87l-0.74,-1.65l0.21,-1.76l0.84,-1.35l1.26,-0.97l2.26,-1.06l0.34,-0.81l-1.63,-2.82l0.64,-3.54l-0.53,-1.18l-2.26,-1.95l-0.46,-1.16l0.34,-1.11l2.95,-3.55l0.86,-2.85l1.16,-0.92l1.11,0.03l1.19,2.06l1.6,0.72l0.82,-0.38l1.06,-1.43l3.67,-0.72l2.43,-1.46l0.75,-1.45l-0.15,-2.82l-0.91,-1.33l299.13,0.03l3.05,0.54l2.15,4.29l1.52,1.9l1.77,1.56l3.53,2.16l2.17,0.15l3.38,1.7l4.11,0.41l2.09,1.31l3.21,-0.76l1.98,0.46l0.51,0.6l-1.91,1.26l-3.8,5.1l-0.41,1.76l0.61,0.94l1.44,0.3l3.54,-0.25l1.92,0.84l3.17,-0.28l2.72,-1.0l8.42,0.52l1.2,-0.28l2.23,-2.35l0.41,-0.98l-0.33,-1.89l0.61,-0.95l-1.09,-3.03l-1.23,-0.56l-2.04,-0.24l-4.94,0.21l-2.31,-0.24l-1.2,-0.68l0.75,-0.36l6.59,-0.84l5.56,-2.82l3.67,-2.39l3.87,-1.59l2.63,-0.7l1.67,0.37l1.53,1.39l0.97,1.51l1.84,5.06l2.23,2.05l0.94,1.83l0.32,2.14l-0.31,5.49l0.81,8.17l-0.55,2.1l-1.86,4.44l0.52,2.04l-2.11,2.54l-2.82,1.18l-9.2,1.89l-3.8,0.15l-2.06,0.9l-1.51,0.25l-2.23,-1.85l-2.36,-3.01l-1.57,-0.86l0.01,-0.99l1.42,-5.08l0.84,-0.5l0.18,-0.58l-0.3,-0.48l-2.59,-2.01l-1.67,-0.81l-1.31,-2.38l-3.01,-1.4l-2.29,-0.58l-4.88,-0.04l-4.46,0.86l-2.25,1.39l-2.18,0.65l-3.08,3.43l-5.24,1.05l-1.3,0.87l-1.56,2.81l-1.38,1.36l-0.4,0.96l0.3,1.56l0.75,0.92l1.96,0.53l1.52,1.04l2.86,0.82l5.48,2.42l4.15,2.96l2.58,0.87l3.95,-0.17l3.26,2.15l1.28,-0.03l3.72,-1.34l0.51,1.24l-0.99,1.24l-5.32,3.18l-5.26,1.92l-9.01,2.37l-8.18,5.1l-2.33,2.43l-1.82,1.05l-0.53,1.39l0.49,3.05l-0.24,0.77l-5.18,4.47l-2.47,3.76l-3.02,2.34l-2.48,4.15l-0.23,0.76l0.09,3.3l1.14,2.59l-0.51,2.89l1.05,1.15l0.9,2.66l0.15,3.58l0.9,0.49l0.88,-0.05l-0.86,0.93l0.43,2.06l1.08,0.86l0.52,0.04l-1.03,1.02l-0.38,1.24l0.18,1.64l0.78,1.05l-2.73,0.8l-0.85,0.74l-0.57,2.06l0.17,2.35l1.6,1.85l0.16,1.59l0.48,0.41l-0.05,0.96l0.54,0.64l1.03,0.16l0.11,1.11l-0.7,0.99l-1.05,0.22l-0.46,0.84l-0.69,0.46l-0.2,0.81l-0.78,-0.01l-0.15,0.98l-0.9,0.66l-0.01,0.83l0.7,0.32l-0.38,0.76l0.11,0.45l0.77,0.39l0.76,-0.2l-0.09,0.68l-0.79,0.15l-0.52,-0.64l-0.53,-0.07l-1.83,0.54l-0.28,0.55l0.38,0.86l-0.5,0.01l-0.68,0.71l0.07,0.81l0.47,0.47l-0.45,0.59l-0.33,-0.65l-0.77,-0.31l-1.77,0.27l-0.49,0.56l-0.03,0.76l-3.26,1.11l-1.55,1.49l-1.03,-0.16l-2.02,1.41l-2.06,2.67l-0.46,1.24l-0.19,3.22l-1.25,1.09l-0.02,2.28l0.58,1.25l2.01,0.69l0.66,0.66l1.4,-0.27l1.36,0.72l1.24,-0.09l1.79,1.32l-1.76,1.49l-0.83,-0.02l-0.79,0.77l0.12,1.11l0.57,0.6l-1.01,-0.23l-0.47,0.46l-0.05,0.5l0.62,0.83l-1.3,0.77l-1.87,-0.13l-0.45,0.72l-2.55,-1.89l-2.3,0.22l-0.72,0.61l-0.1,-1.08l-0.95,-0.89l-2.26,0.29l-0.27,0.36l0.01,1.35l-1.74,0.51l-1.01,-0.3l-0.94,-1.07l-1.66,-1.15l-1.21,0.05l-2.9,-0.86l-2.75,0.42l-1.38,-0.19l-3.78,3.49l-1.36,-0.61l-1.76,-0.05l-6.8,2.6l-1.23,1.15l-0.19,1.55l0.3,0.41l2.65,0.77l-0.33,0.43l-4.98,-1.56l-0.45,0.39l-0.02,1.53l0.32,0.4l1.91,0.39l0.73,0.84l-0.04,0.73l-6.25,-0.06l-8.98,1.17l-2.94,1.26l-3.65,2.69l-2.51,2.58l-7.18,10.04l-2.06,1.77l-1.71,2.27l-1.2,0.81l-1.14,2.74l0.09,2.67l0.79,0.82l-1.22,0.81l-0.26,1.55l0.28,1.08l-1.35,0.16l-2.65,1.91l-0.92,2.16l-1.43,1.01l-1.93,3.08l0.48,1.4l-0.91,0.49l-1.03,1.65l-182.45,-0.03l1.07,-1.33l-1.34,-3.72l-1.28,-1.4l-4.03,-1.91l-0.22,-0.74l0.59,-1.58l0.05,-1.11l-2.2,-2.58l-0.06,-0.96l0.88,-1.62l-0.32,-1.24l0.22,-1.39l1.8,-2.7l-0.18,-0.66l-0.73,-0.71l0.52,-0.97l1.48,-0.82l3.23,-0.71l3.46,0.22l1.71,-0.28l1.82,-1.21l0.66,-1.28l-1.4,-3.8l5.29,-2.11l3.55,-4.04l-0.17,-2.11l-2.16,-3.46l-3.92,-2.85l-1.67,-1.93l-1.23,-3.16l-1.81,-3.35l-1.58,-1.64l-5.26,-0.35l-2.52,-2.28l-1.16,-0.31l-4.87,1.09l-5.37,-2.35l-2.7,-0.08l-0.23,-0.59l0.29,-2.8l-0.63,-2.89l0.43,-0.93l0.98,-0.26l2.67,0.96l6.14,1.03l1.21,-0.22l1.96,-1.68l0.92,-0.14l3.93,1.32l2.0,0.11l4.24,-1.66l1.82,-0.39l1.66,0.47l3.59,2.23l1.94,0.54l1.91,-0.33l1.84,-1.2l1.18,-1.8l0.32,-2.13l-0.43,-2.88l0.23,-0.96l1.85,-2.76l1.8,-0.22l0.88,-0.65l0.54,-1.36l0.01,-1.2l-1.52,-1.95l-0.77,-2.65l-0.79,-0.88l-1.18,-0.62l-3.51,-0.24l-6.86,-1.21l-9.23,0.06l-2.27,-0.5l-2.05,-0.01l-1.99,0.52l-1.67,0.03l-1.51,-1.25l-0.1,-0.62l2.2,-1.24l0.47,-1.28l-1.23,-2.62l0.14,-0.82l0.94,-1.57l0.09,-1.3l-1.77,-3.35l-0.56,-1.75l0.76,-0.53l1.87,-0.52l1.59,-1.29l4.18,-5.76l0.51,-1.19l0.0,-0.91l-2.62,-3.98l-2.01,-1.58l0.42,-1.78l-0.33,-1.56l-0.68,-0.11l-1.35,0.57l-0.5,-0.21l-0.11,-0.6l0.6,-1.49l3.39,-1.51l0.94,-0.94l0.27,-0.87l-0.49,-3.88l-4.09,-3.44l-3.22,-0.3l-0.19,-0.43l0.99,-1.43l-0.04,-1.37l-0.6,-0.95l-1.81,-0.79l-1.46,0.39l-0.35,-0.3ZM360.8,1184.57l-0.53,0.11l-0.08,-0.09l0.14,-0.11l0.47,0.09Z",name:"Chubut"},"AR-R":{path:"M78.12,963.56l5.64,0.33l3.1,0.69l4.93,0.08l8.74,3.09l2.89,0.31l3.81,-0.76l3.17,-1.65l4.88,-5.74l0.82,-2.29l-0.35,-1.4l-1.38,-1.87l-2.53,-1.55l-0.43,-0.7l-0.01,-1.26l2.2,-2.7l2.08,-0.64l0.79,-0.65l0.78,-2.14l1.14,-1.11l2.22,-0.98l2.29,-0.38l2.54,-1.55l4.16,0.66l1.89,-0.42l1.68,-0.8l3.11,-2.82l1.51,-0.51l0.83,0.29l1.59,1.53l1.75,1.1l1.93,-0.04l3.5,-0.97l4.06,0.05l1.28,-0.78l1.41,-3.7l1.64,-0.01l2.23,-1.37l0.62,-1.36l0.34,-5.25l2.96,-6.54l-0.03,-2.4l0.62,-2.25l0.3,-3.12l0.93,-2.4l0.2,-1.84l0.87,-1.18l11.81,-6.53l2.05,-0.25l4.21,0.42l1.22,-0.26l1.14,-0.68l5.84,-4.99l2.44,-3.17l1.27,-2.27l1.59,-1.46l2.7,-1.2l2.8,-1.74l3.12,-0.27l4.21,-2.0l2.86,-4.29l2.91,-1.81l1.65,-4.22l1.31,-0.96l0.94,-1.33l1.87,-0.76l1.55,-1.16l3.04,-4.46l2.68,-1.85l1.5,-0.32l1.49,-0.75l3.0,-3.35l2.22,-0.99l1.76,-1.46l1.21,1.11l1.6,0.68l1.85,-0.69l2.78,0.73l1.64,0.02l4.92,-1.15l0.31,-0.38l-1.06,-0.64l-0.17,-1.98l-0.61,-1.41l-5.85,-8.48l-3.05,-3.21l-0.19,-1.0l0.12,-57.28l17.51,2.19l1.84,0.88l2.55,2.56l1.59,3.27l0.05,2.24l-0.56,1.8l-1.01,1.37l-3.02,1.95l-1.58,1.42l-1.03,1.93l-0.25,2.45l0.18,1.09l0.82,2.27l0.63,0.63l1.61,0.74l1.72,-0.38l1.59,0.61l1.2,1.19l2.47,4.77l1.2,1.61l1.54,1.37l2.0,0.87l3.45,-0.2l1.21,-0.56l3.46,0.43l1.24,-0.33l2.0,-1.19l3.7,-0.68l1.71,0.41l0.35,0.51l0.31,2.55l1.08,2.82l3.1,3.89l5.33,2.6l2.06,0.41l1.41,0.97l3.19,0.63l3.09,2.01l2.49,0.54l1.53,0.69l1.32,1.09l0.99,1.38l0.86,3.96l0.81,1.2l7.79,1.73l2.07,0.03l5.92,-0.95l11.44,1.34l4.07,1.42l2.49,0.36l1.74,1.09l2.52,0.15l1.49,0.98l1.97,-0.45l2.62,-1.68l1.09,-0.08l2.24,0.4l3.89,1.44l2.78,1.45l2.43,-0.74l2.35,0.07l6.62,-1.15l6.35,0.0l1.38,0.79l3.13,-0.46l1.63,0.39l0.77,-0.35l12.47,2.17l3.19,0.09l14.59,5.01l4.03,2.34l2.13,0.34l4.47,4.77l1.12,0.52l3.05,0.64l1.6,0.82l1.18,1.06l1.93,2.66l1.73,0.78l5.83,3.68l1.4,1.25l1.84,0.69l3.68,0.35l0.05,73.33l0.35,0.4l9.22,1.06l3.43,1.27l3.5,2.92l2.4,2.82l2.28,1.62l2.67,2.48l2.27,4.05l0.25,0.96l-2.54,2.25l-3.11,0.76l-5.38,2.56l-1.98,0.4l-9.78,-0.37l-3.06,0.7l-4.32,-0.36l-6.41,0.36l-7.06,-0.11l-1.94,-0.41l-1.83,-0.88l-4.6,-3.99l-2.01,-0.82l-2.13,-0.09l0.48,-1.39l-0.52,-0.89l-3.53,0.83l-1.68,-0.4l-10.93,-5.26l-6.14,-1.51l-4.24,-1.97l-4.13,-0.87l-2.25,-0.16l-3.13,0.29l-2.23,-0.38l-0.01,-0.31l0.59,-0.39l1.01,-0.29l0.32,0.06l-0.11,0.52l0.43,0.48l1.09,-0.36l3.59,-0.15l0.59,-0.82l-0.39,-1.11l-1.83,-0.88l0.91,-0.85l-0.06,-0.63l-1.24,-0.76l-4.26,-0.93l-2.66,0.28l-1.7,0.67l-0.53,0.4l0.2,0.71l2.49,-0.19l-0.33,0.74l0.51,0.78l-3.66,-0.08l-5.15,3.65l-0.53,0.62l-0.14,1.75l-1.3,2.6l-0.56,2.59l0.03,2.25l1.28,9.16l1.8,6.37l0.11,1.74l1.97,6.38l2.52,2.53l0.61,1.5l-0.46,3.2l-1.6,4.26l0.49,2.19l1.26,2.98l-0.07,1.79l-2.66,6.13l-0.7,2.37l0.21,2.05l0.37,0.79l-2.57,-0.45l-299.79,-0.03l-0.31,-0.44l0.27,-2.53l-0.89,-3.89l-2.83,-4.42l-0.09,-2.02l-0.54,-1.93l-2.49,-3.27l-0.0,-1.33l2.69,-1.93l0.58,-1.33l-1.56,-2.92l0.38,-4.05l-1.09,-3.74l0.07,-1.6l1.3,-4.67l-0.71,-3.66l0.8,-0.74l0.8,-4.82l0.03,-1.31l-0.63,-1.94Z",name:"R\xedo Negro"},"AR-S":{path:"M528.52,529.21l1.07,-1.61l0.24,-1.8l-0.37,-0.81l-0.98,-0.87l-0.88,-4.71l-1.39,-1.62l-3.19,-2.3l-1.27,-2.26l-1.61,-4.88l-2.75,-1.64l-3.46,-3.53l0.28,-5.04l1.27,-3.64l-1.43,-2.79l-0.32,-3.61l0.25,-3.26l-0.91,-1.91l0.54,-0.91l3.8,-3.26l0.88,-1.84l11.55,-40.84l0.4,-2.9l-2.22,-3.25l-9.94,-10.6l-0.34,-1.79l12.12,-73.96l6.97,-44.56l127.65,-0.05l-0.41,1.59l-1.83,2.36l-1.27,0.8l-1.31,0.35l-2.71,0.09l-0.93,0.4l-0.75,0.77l-0.72,1.71l-0.15,1.87l0.38,2.64l-0.4,2.85l1.11,3.81l-1.1,6.31l0.17,4.71l-0.52,1.71l-2.0,4.05l0.07,2.21l-0.52,2.88l-1.89,3.66l-0.12,4.81l-0.64,1.16l-2.68,1.51l-3.77,3.07l-4.37,1.56l-2.63,1.69l-1.7,2.65l-1.62,5.89l-0.29,1.75l-0.09,10.0l-1.6,6.62l-1.68,3.31l-0.4,1.48l0.41,1.85l1.54,2.52l1.38,4.0l0.16,1.72l-0.3,1.61l-1.62,3.25l-0.43,3.76l-0.99,3.43l0.76,4.66l1.7,3.79l-0.45,6.31l-0.95,2.41l-0.64,4.66l-2.64,4.65l-5.49,7.31l-7.19,11.65l-2.83,2.87l-1.37,4.11l-3.15,4.48l-1.8,0.94l-0.87,1.18l-1.39,0.98l-4.42,5.8l-2.74,2.57l-2.55,1.13l-5.88,0.11l-2.16,0.92l-0.39,1.02l0.11,1.76l-1.01,4.22l-2.06,3.46l0.11,2.8l2.3,3.8l0.17,0.91l-2.03,4.32l0.23,4.96l-1.33,5.01l0.09,5.02l-1.64,4.31l-0.04,2.08l2.74,5.02l0.33,4.55l1.06,3.91l2.44,4.83l1.6,1.84l1.55,4.2l2.7,3.23l4.64,2.65l2.0,2.47l2.41,1.65l0.71,0.9l-0.38,1.65l-2.53,1.52l-0.51,3.47l-2.63,2.23l-0.75,3.98l-1.79,3.7l-1.3,0.95l-1.81,0.42l-0.98,-0.12l-1.03,-0.41l-1.54,-1.42l-2.17,-1.37l-4.66,-0.18l-3.07,-1.17l-1.59,0.1l-1.76,0.64l-0.85,0.85l-0.53,1.34l0.35,1.62l-1.46,2.03l-33.62,35.39l-50.72,0.27l41.76,-63.64l1.12,-1.37l1.77,-0.12l1.7,-1.09l1.67,-1.62l0.71,-1.28l0.43,-2.64l-0.04,-3.07l1.06,-2.96l-0.02,-1.4l-0.56,-1.2l-1.53,-1.33l-2.41,-4.45l-0.9,-0.51l-1.81,-0.38Z",name:"Santa Fe"},"AR-P":{path:"M514.39,40.24l-0.21,1.81l0.74,0.7l-0.36,1.2l0.87,0.54l0.67,1.3l1.25,1.36l0.44,1.09l1.46,1.16l2.17,2.91l1.32,2.44l0.05,2.06l2.27,2.69l5.08,3.04l1.37,1.79l2.02,1.43l0.68,0.89l0.35,2.22l0.65,0.62l2.52,1.78l3.27,0.42l2.23,2.29l1.39,0.42l-0.22,1.0l0.79,0.76l0.54,1.19l2.31,0.5l2.41,1.56l1.68,0.23l2.74,1.19l1.27,2.08l1.22,0.4l1.29,1.14l1.6,0.05l1.74,1.62l1.23,0.6l0.13,0.75l-0.46,2.14l1.14,1.63l1.27,0.76l0.66,0.82l1.6,3.02l1.92,1.36l1.9,-0.4l4.46,2.74l4.88,0.02l1.75,1.01l2.62,-0.06l1.43,0.62l0.99,1.84l1.91,0.18l2.33,1.42l2.79,0.53l1.95,-0.01l1.92,1.35l5.47,0.53l3.38,-0.1l3.28,-0.98l1.5,0.08l16.17,10.39l2.84,3.06l3.29,1.0l1.3,1.12l1.99,1.0l0.76,1.4l1.04,0.46l2.07,1.86l1.86,2.73l1.39,0.5l0.69,0.71l1.09,0.26l0.92,0.85l1.95,0.67l4.01,2.31l2.09,0.42l1.7,1.4l1.5,0.39l8.59,6.32l3.94,0.52l1.42,1.25l9.92,1.88l1.4,0.91l4.82,5.84l1.37,0.06l3.09,-2.46l0.58,-0.02l3.89,2.6l0.76,0.84l0.46,-0.02l3.04,1.49l1.83,0.0l0.86,1.46l5.03,0.5l2.6,2.78l2.53,1.68l1.48,3.16l0.98,1.29l1.29,0.86l1.47,4.02l2.77,2.1l0.81,1.1l-0.74,5.51l-1.51,0.91l-0.46,1.35l-1.81,-0.15l-0.42,0.25l-0.44,1.55l-2.77,0.7l-1.56,1.99l0.28,0.85l0.91,0.59l-1.62,1.44l-1.52,0.7l-0.03,1.34l0.62,1.51l-1.17,1.03l-2.07,1.04l-0.0,0.96l1.05,0.67l-0.42,0.72l-1.54,1.22l-0.46,0.87l0.25,0.56l1.8,0.51l-0.47,0.83l-5.15,3.73l-4.51,1.92l-0.56,0.64l-0.81,2.54l-1.14,-0.65l-0.53,0.43l0.23,1.11l1.8,1.46l-2.75,1.39l-0.01,3.33l-2.03,3.99l0.26,1.06l0.91,0.82l-0.85,1.07l-0.53,2.56l0.27,1.0l1.28,1.02l0.65,1.03l-1.08,1.01l0.57,1.74l-2.13,-0.38l-0.36,0.28l-0.47,1.61l-0.12,3.66l-1.52,0.25l-0.23,0.93l0.46,0.81l-0.29,0.3l-1.54,-0.33l-0.99,0.43l-0.52,1.5l1.5,1.73l-1.06,0.29l-0.81,-0.37l0.01,-0.99l-0.57,-0.57l-1.98,0.14l-1.3,-0.64l-0.77,-1.71l-3.1,-2.68l-1.13,-2.32l-3.77,-2.31l-1.75,-2.18l-0.85,-0.39l-1.46,-0.09l-2.28,-2.67l-3.17,-1.63l-3.17,-3.88l-2.26,-1.7l-5.13,-1.95l-2.73,-2.62l-1.24,0.15l-1.47,1.33l-2.49,0.96l-0.7,0.04l-1.56,-0.59l-1.22,0.23l-1.39,-1.61l-0.12,-1.42l-1.09,-1.76l-0.09,-1.93l-0.53,-0.76l-2.23,-1.0l-1.58,-0.03l-1.49,-0.43l-1.44,0.09l-2.41,-1.09l-1.76,0.01l-0.38,-5.51l-0.41,-0.36l-1.03,-0.14l-2.99,-4.16l-1.88,-1.78l-1.96,-0.95l-0.21,-1.68l-0.41,-0.63l-3.39,-1.88l-1.2,-1.58l-2.19,-0.6l-0.97,-1.78l-1.67,-0.4l-3.25,-1.48l-1.34,0.36l-0.55,-1.91l-1.3,-1.75l-0.8,-1.99l0.58,-1.01l-0.6,-1.42l-1.03,-0.52l-1.35,-0.18l-0.63,-1.82l-1.8,-0.99l0.27,-1.01l-1.03,-1.94l-2.93,-2.11l-1.69,-2.28l-1.64,-2.96l-1.38,-0.68l-1.45,0.1l-1.54,-0.95l-2.31,-0.74l-1.29,-1.21l-4.39,-2.61l-1.33,-0.48l-1.71,-1.7l-2.56,-1.59l-6.32,-5.22l-0.74,-0.22l-0.68,0.39l-0.43,-0.26l-1.1,-1.33l0.37,-1.81l-2.22,-3.47l-0.12,-1.51l-1.19,-0.58l-1.69,-2.31l-2.58,-0.99l-3.39,-0.16l-2.5,-0.84l-2.27,-0.09l-4.72,-4.38l-1.09,-2.2l-2.91,-0.37l-0.73,0.25l-2.22,-4.15l-3.34,-2.67l-5.64,-1.14l-3.65,-2.53l-1.12,-1.64l-0.93,-0.72l-4.4,-0.85l-9.46,-3.61l-0.1,-77.84l1.74,0.39l0.18,1.17l0.97,0.34l0.88,1.0l0.28,0.65l-0.87,1.64l0.15,0.9l1.8,1.04l0.87,0.16Z",name:"Formosa"},"AR-Q":{path:"M83.77,924.54l-2.81,-2.84l-0.87,-1.49l0.49,-1.18l-0.18,-1.17l0.61,-2.55l-0.51,-1.15l0.41,-0.48l1.27,-0.12l2.04,0.89l1.72,0.28l0.45,-0.29l0.59,-2.22l-0.46,-2.46l0.83,-0.79l2.07,-4.59l-0.3,-1.19l-2.17,-1.91l-0.59,-1.17l-0.34,-2.31l-0.99,-3.28l0.9,-2.73l-1.0,-1.76l0.08,-2.05l0.9,-1.46l2.83,2.48l0.93,0.22l2.13,-0.35l1.62,0.11l1.12,-1.03l0.22,-2.29l-1.81,-1.53l3.44,-4.98l-0.68,-1.92l0.04,-0.79l2.41,-2.02l0.51,-1.54l0.46,-4.41l-0.48,-7.16l-0.83,-3.95l0.67,-4.61l0.65,-1.19l1.23,-1.11l4.13,-2.02l2.0,-2.03l3.66,-0.64l4.62,-2.71l3.54,0.22l1.31,-0.28l0.8,-0.72l0.79,-1.4l1.76,-1.07l0.01,-0.78l-0.55,-0.95l0.08,-0.72l2.04,-3.04l0.2,-1.2l-0.77,-2.29l-4.56,-3.55l-0.99,-1.71l-2.05,-9.85l0.5,-3.53l-0.67,-3.14l0.7,-1.14l0.03,-0.78l-1.41,-1.97l-1.04,-2.97l-1.19,-2.0l-0.37,-2.3l-1.71,-3.05l-2.31,-6.85l-0.26,-3.26l0.72,-1.14l1.69,-1.18l0.43,-0.65l-0.03,-0.84l-0.59,-1.28l1.07,-4.13l-0.3,-1.35l-2.04,-2.7l-1.16,-2.43l-0.46,-2.43l2.63,-3.95l-0.02,-3.22l0.33,-0.98l2.1,-1.41l0.06,-0.67l-1.66,-1.31l-0.49,-0.7l-0.45,-2.55l-0.48,-0.7l-1.17,-0.68l0.93,-0.05l0.82,-0.52l0.52,-1.17l-0.38,-0.96l-1.1,-0.68l0.4,-2.01l-0.38,-0.66l-1.14,-0.69l-0.09,-0.57l0.82,-1.25l1.16,-2.89l0.25,-3.61l0.46,-0.39l0.63,0.06l1.63,0.92l1.27,-0.79l-0.52,-6.29l0.33,-2.3l0.72,-1.63l1.2,-0.28l1.85,0.39l1.77,-0.72l0.71,-1.09l0.31,-1.87l0.28,-0.53l0.53,-0.16l3.83,1.68l4.0,-0.97l0.75,-0.97l-0.01,-1.35l-1.03,-2.22l0.87,-1.72l0.03,-1.58l2.09,-1.0l1.72,-2.07l0.91,-0.54l1.0,-2.62l1.27,0.02l2.03,1.05l1.47,-0.01l1.87,-1.44l2.28,1.78l0.52,1.24l-0.03,2.59l-0.79,1.03l-0.27,0.98l0.23,1.92l1.03,2.21l0.55,0.57l1.01,0.32l1.61,-1.06l1.21,0.59l2.76,8.16l1.61,2.62l0.9,0.57l3.48,1.07l1.53,1.54l0.86,1.47l2.59,1.81l1.49,3.73l0.72,0.92l1.88,1.5l2.77,1.24l0.54,0.65l0.37,2.76l-0.26,1.98l-1.1,1.42l-0.15,0.79l0.34,0.84l3.24,3.91l1.62,1.39l3.74,2.17l4.23,1.11l2.51,0.15l7.91,-1.38l1.78,0.14l2.84,1.21l1.92,0.35l2.84,1.2l1.13,1.37l0.97,3.89l0.88,1.75l1.73,1.17l2.32,0.69l2.4,0.28l5.74,-0.48l0.75,0.33l1.67,1.8l1.16,0.71l1.9,0.0l1.96,0.73l2.98,0.04l0.71,0.27l1.96,3.29l1.64,1.42l7.85,1.02l-0.12,57.49l0.36,1.42l3.02,3.15l5.81,8.44l0.5,1.13l0.33,2.35l-3.6,0.85l-1.41,0.0l-2.95,-0.75l-1.93,0.68l-1.1,-0.55l-0.93,-1.04l-1.08,-0.11l-1.83,1.52l-2.32,1.07l-2.88,3.26l-1.37,0.69l-1.52,0.32l-2.9,2.0l-3.06,4.48l-1.38,1.02l-1.9,0.76l-1.13,1.49l-1.34,0.99l-0.56,0.87l-1.08,3.33l-2.88,1.78l-2.83,4.26l-3.88,1.81l-3.22,0.3l-2.88,1.78l-2.76,1.24l-1.78,1.64l-1.32,2.33l-2.36,3.07l-2.57,1.92l-3.11,2.92l-2.01,0.81l-4.14,-0.42l-2.28,0.29l-12.07,6.67l-1.11,1.53l-0.21,1.89l-0.94,2.46l-0.3,3.16l-0.63,2.27l0.05,2.28l-1.31,2.41l-1.66,4.17l-0.35,5.29l-0.44,0.98l-1.85,1.12l-1.96,0.18l-0.54,0.79l-0.97,3.03l-0.92,0.51l-3.8,-0.1l-3.63,0.99l-1.65,0.02l-3.02,-2.5l-1.3,-0.42l-1.94,0.66l-3.11,2.82l-1.53,0.71l-1.58,0.36l-4.35,-0.64l-2.66,1.55l-2.23,0.4l-2.43,1.08l-1.38,1.36l-0.71,2.03l-2.84,1.26l-0.73,1.21l-1.33,1.17l-0.43,1.17l0.12,1.19l0.57,0.97l2.6,1.62l1.24,1.68l0.26,0.97l-0.19,1.03l-1.1,1.68l-2.82,2.95l-0.81,1.46l-3.38,1.86l-3.53,0.72l-2.71,-0.28l-8.83,-3.11l-5.02,-0.09l-3.06,-0.68l-5.73,-0.34l0.71,-2.35l0.0,-1.27l-0.91,-2.36l-1.8,-2.46l-1.96,-6.73l3.57,-3.67l0.99,-1.74l0.28,-2.28l-0.61,-1.44l0.92,-1.72l1.9,-5.23l3.04,0.32l0.55,-0.56l1.83,-3.89l0.18,-2.16l-0.63,-1.04l-1.29,-0.45l-1.11,0.82Z",name:"Neuqu\xe9n"},"AR-N":{path:"M796.09,266.4l2.14,-0.18l0.73,0.27l1.8,3.25l4.93,2.04l1.74,-1.34l1.59,-1.81l1.16,-0.86l2.12,-0.74l0.84,-0.92l0.54,-1.35l-0.1,-1.33l0.68,-1.66l-1.35,-3.43l1.73,-0.63l1.02,-2.62l3.36,-0.24l0.53,-0.96l0.36,-3.1l1.18,-1.58l1.53,-0.7l2.22,-0.3l2.11,-1.13l0.91,0.01l2.56,1.01l3.11,-0.17l0.87,-0.84l0.14,-1.24l-0.58,-1.78l0.23,-0.61l2.8,-2.71l2.94,-0.46l1.02,-0.47l1.16,-1.59l1.36,-3.94l0.62,-0.57l0.94,-0.23l1.86,0.0l1.07,0.51l1.24,-1.12l0.62,-2.5l-0.38,-3.31l0.98,-1.46l1.29,-1.03l1.83,-2.25l0.69,-3.83l0.91,-2.18l-0.05,-3.34l1.15,-1.86l-0.13,-0.91l-0.97,-1.57l0.9,-2.99l0.04,-1.19l-0.89,-3.93l0.34,-0.38l1.5,-0.2l0.63,-0.92l-0.34,-3.25l1.11,-2.25l0.12,-1.22l-1.37,-2.03l-1.13,-3.99l0.01,-1.05l1.59,-0.13l0.92,-0.5l0.05,-1.36l-0.66,-1.99l1.81,-0.04l0.56,1.62l1.24,-0.01l1.48,0.82l0.47,0.65l0.31,1.93l0.82,0.56l0.66,-0.39l0.22,-0.66l-0.19,-1.31l1.35,-1.07l0.41,-1.82l1.88,0.14l0.95,-1.08l1.22,-0.34l0.85,0.59l0.85,1.48l0.59,0.03l0.55,-0.94l2.15,0.18l0.36,-0.49l-0.86,-2.0l0.91,0.3l0.91,-0.1l1.97,-1.83l-0.8,2.4l0.18,1.1l1.2,1.35l0.64,0.09l0.54,-0.54l-0.09,-1.62l1.19,0.87l1.09,-0.39l1.19,0.51l0.47,0.58l0.75,3.0l0.44,0.28l1.04,-0.18l1.47,-0.88l0.26,0.24l0.9,2.59l-0.38,1.06l0.13,0.94l1.91,2.61l-0.06,3.65l0.53,2.53l-0.16,2.03l3.13,3.32l1.4,4.67l3.0,4.48l0.21,1.8l-0.48,1.44l-1.89,2.57l-0.45,1.55l0.51,5.94l-1.08,1.25l0.41,1.56l-0.65,2.22l0.13,3.57l-0.24,0.73l-0.96,0.34l-0.36,0.8l0.35,1.0l0.84,0.5l-0.24,1.48l0.93,0.47l0.98,4.4l-0.08,1.39l-2.48,5.67l-1.51,0.82l-0.18,2.65l-1.09,1.14l0.44,0.95l-0.39,0.8l-0.23,0.08l-0.9,-1.52l-0.77,-0.43l-0.83,0.42l-0.72,1.87l-1.5,-0.9l-1.0,0.28l-0.31,0.94l0.22,0.91l-0.5,0.12l-0.78,-0.39l-0.6,0.17l-0.64,1.23l-3.17,3.38l-1.41,0.16l-0.97,-0.33l-0.07,-1.09l-1.0,-0.73l-0.55,0.12l-2.51,5.33l0.03,1.29l-1.35,0.51l-0.95,1.7l-0.63,0.02l-1.69,-1.58l-0.44,-0.07l-0.21,2.25l-0.44,0.57l-0.27,-1.32l-0.67,-0.7l-2.71,-0.11l-0.74,0.18l-0.46,0.79l0.72,1.62l-3.81,1.2l-1.01,-1.38l-1.41,-0.22l-0.8,0.83l-0.92,2.29l-0.5,0.39l-0.36,-0.97l-0.91,-0.02l-0.43,0.48l-0.17,1.51l-0.35,0.24l-1.75,-0.02l-1.89,0.59l-0.4,-0.45l0.2,-0.75l-0.26,-0.54l-0.47,-0.21l-0.72,0.22l-1.16,1.12l-0.73,3.07l-1.84,0.34l-0.64,0.54l0.08,1.8l-0.63,3.38l-0.88,0.36l-2.27,1.95l-0.88,0.12l-2.44,-0.83l-1.02,0.38l-0.18,0.56l0.45,0.79l1.44,1.29l0.51,0.86l-1.24,-0.5l-1.79,0.19l-0.63,0.37l-0.4,1.34l-1.5,-1.01l-0.99,-0.22l-1.08,0.46l-1.18,1.6l-1.53,1.16l-2.51,-0.15l-0.84,0.88l-0.3,1.47l-1.92,0.79l-0.17,1.84l-2.48,2.98l-1.24,0.3l-0.67,-0.55l-0.93,0.22l-0.83,1.5l-0.99,0.79l-0.67,1.04l-0.41,-1.05l-1.33,-0.43l-1.07,1.07l-4.69,-3.45l-1.12,-1.67l-0.21,-1.44l-0.64,-1.39l-2.52,-3.11l-0.57,-5.87l-1.01,-3.47l-6.5,-12.87l0.01,-2.06l0.72,-2.08l1.38,-1.18Z",name:"Misiones"},"AR-L":{path:"M460.47,648.71l-0.2,224.1l-3.55,-0.34l-1.61,-0.62l-1.3,-1.19l-5.89,-3.72l-1.58,-0.68l-1.89,-2.61l-1.37,-1.21l-1.78,-0.9l-3.85,-0.99l-4.61,-4.87l-2.25,-0.39l-4.0,-2.33l-14.69,-5.04l-3.28,-0.11l-12.56,-2.19l-0.98,0.36l-1.46,-0.41l-3.07,0.45l-1.3,-0.77l-6.57,0.01l-6.61,1.15l-2.45,-0.05l-2.27,0.72l-2.44,-1.38l-3.97,-1.47l-2.5,-0.44l-1.37,0.13l-2.66,1.7l-1.55,0.38l-1.34,-0.95l-2.59,-0.16l-1.65,-1.06l-2.5,-0.37l-4.2,-1.45l-11.52,-1.34l-6.05,0.96l-1.92,-0.03l-7.47,-1.66l-0.4,-0.67l-0.32,-2.37l-0.59,-1.72l-1.11,-1.57l-1.48,-1.24l-1.71,-0.79l-2.41,-0.51l-3.1,-2.01l-3.24,-0.66l-1.32,-0.92l-2.14,-0.44l-5.1,-2.45l-2.92,-3.64l-1.19,-3.28l-0.16,-1.98l-0.69,-0.98l-2.23,-0.52l-3.82,0.7l-2.15,1.25l-1.0,0.25l-3.35,-0.44l-1.32,0.57l-3.27,0.19l-1.57,-0.7l-2.55,-2.79l-2.45,-4.74l-1.38,-1.39l-2.05,-0.79l-2.02,0.3l-1.29,-0.88l-0.74,-2.04l0.07,-3.21l0.91,-1.65l4.54,-3.29l1.16,-1.6l0.6,-1.93l-0.06,-2.62l-0.63,-1.77l-1.11,-1.79l-2.7,-2.71l-2.15,-1.02l-17.67,-2.21l0.03,-37.29l-0.36,-28.83l-1.64,-7.67l0.47,-5.34l0.58,-0.6l0.74,-0.31l142.32,0.09l0.66,-0.52l0.05,-50.79l76.1,0.02Z",name:"La Pampa"},"AR-M":{path:"M210.35,500.36l0.89,12.38l0.38,0.58l0.75,0.34l9.06,-0.12l2.35,-1.19l7.96,-5.16l1.53,-1.19l1.46,-1.7l6.4,-0.53l1.76,-0.77l2.13,-1.58l4.9,-1.21l1.43,0.03l1.46,0.89l1.53,1.72l0.52,1.78l2.93,1.79l2.14,2.35l4.37,0.68l6.5,-1.32l3.62,-0.08l0.99,-0.54l0.91,0.17l3.12,2.07l0.14,2.0l1.27,4.64l1.86,1.76l0.01,1.23l0.84,1.5l1.97,8.46l0.63,1.29l1.35,1.31l0.35,1.67l0.59,0.98l-0.71,1.38l-0.41,1.87l0.52,3.23l-0.68,0.58l-0.25,0.87l1.3,3.51l-0.28,1.96l0.54,1.71l0.36,4.49l-0.27,4.09l0.58,1.83l0.04,1.9l1.22,3.14l-0.09,3.29l0.46,1.23l4.32,6.94l1.21,1.34l1.4,4.43l1.07,1.79l1.62,5.02l3.9,3.02l0.48,0.8l0.54,2.44l1.91,1.69l0.65,2.28l0.73,1.2l-0.53,5.82l-0.43,0.51l-0.75,-0.36l-0.61,0.17l-1.04,2.1l0.46,5.93l0.45,0.92l-0.45,1.31l1.14,1.25l0.33,0.83l0.3,4.39l1.58,5.23l2.18,2.26l5.32,9.87l1.15,3.6l-0.19,4.39l0.97,3.49l1.06,2.28l-0.91,3.69l0.9,1.59l-0.61,1.91l0.61,3.94l-0.54,3.2l-0.18,4.55l-1.56,3.94l-0.52,5.16l-1.84,8.12l-0.36,3.74l-0.57,2.4l0.19,2.31l-72.86,-0.03l-1.05,0.4l-0.86,0.84l-0.61,5.85l1.64,7.67l0.36,28.78l-0.03,37.19l-7.51,-0.94l-1.35,-1.19l-1.36,-2.65l-0.86,-0.86l-1.0,-0.35l-2.94,-0.03l-1.92,-0.73l-1.89,-0.01l-2.47,-2.33l-1.05,-0.5l-5.92,0.46l-4.39,-0.87l-1.44,-0.93l-0.78,-1.53l-1.06,-4.09l-1.35,-1.6l-3.04,-1.3l-1.9,-0.34l-2.86,-1.22l-2.02,-0.18l-8.02,1.38l-2.29,-0.14l-4.06,-1.06l-3.54,-2.06l-1.52,-1.29l-3.37,-4.36l1.19,-1.72l0.14,-0.7l0.19,-1.78l-0.47,-3.0l-0.87,-0.96l-2.73,-1.21l-1.73,-1.38l-0.58,-0.73l-1.01,-3.01l-0.56,-0.84l-2.69,-1.92l-0.79,-1.39l-1.61,-1.62l-4.3,-1.56l-1.48,-2.4l-1.26,-3.25l-1.16,-4.39l-0.52,-0.79l-0.95,-0.69l-0.89,-0.12l-1.72,1.03l-1.14,-1.23l-0.7,-2.94l1.04,-1.85l0.03,-2.96l-0.7,-1.58l-2.45,-1.97l0.79,-2.14l1.07,-1.29l0.33,-0.9l-1.46,-3.98l0.3,-1.3l0.85,-0.81l0.16,-0.63l-0.41,-0.69l-1.26,-0.08l0.02,-1.43l2.84,-2.95l-0.25,-1.81l-2.66,-6.23l0.42,-2.6l-0.26,-3.06l0.4,-2.31l-1.68,-2.33l-1.12,-3.85l1.25,-0.51l0.66,-0.94l-0.68,-1.47l-1.6,-0.93l-3.75,-0.78l-0.68,-1.62l1.44,-2.28l7.19,-2.43l0.83,-3.67l-0.18,-3.65l0.83,-3.56l3.46,-7.89l-0.16,-0.88l-1.51,-1.87l1.66,-0.69l1.1,-1.74l0.49,-4.01l0.61,-1.62l2.69,-2.37l0.82,-1.12l1.58,-3.49l2.17,-1.78l0.43,-1.12l-0.26,-4.13l0.27,-0.97l0.61,-0.56l2.15,-0.38l3.73,0.7l0.48,-0.82l2.99,-1.23l0.4,-0.74l-0.38,-1.47l-1.6,-3.44l0.8,-5.46l-0.03,-2.52l-0.74,-1.64l-1.65,0.03l0.54,-3.99l-0.77,-4.96l2.45,-2.42l-0.06,-1.01l-1.53,-2.33l0.99,-3.66l-0.24,-1.52l0.22,-0.43l1.44,-0.77l0.47,-3.73l1.63,-2.18l0.38,-0.96l-0.04,-1.0l-0.82,-1.87l-0.36,-2.71l-1.24,-1.5l-3.15,-1.41l-1.79,0.22l-2.13,2.64l-0.72,0.14l-1.79,-3.5l-1.59,-1.28l-0.95,-1.39l0.78,-3.9l-0.83,-2.62l0.76,-1.16l1.38,-0.33l0.9,-0.66l1.15,-3.84l0.75,-1.36l0.05,-0.82l-0.81,-0.78l-1.8,-0.84l-1.44,-1.34l-2.33,-2.71l-0.67,-1.41l-1.13,-6.44l0.3,-1.38l1.39,-0.21l0.19,-0.6l-0.85,-1.25l-0.12,-2.78l-0.57,-1.16l-2.53,-1.63l-0.71,-1.34l0.13,-3.59l-0.39,-0.66l6.86,-1.03l1.73,-0.02l3.28,0.84l8.79,-2.02l5.65,-0.37l1.0,-0.62l0.64,-0.86l0.26,-1.31l-0.15,-2.83l0.8,-1.34l4.39,-1.58l2.72,-1.74l3.53,-0.08l2.19,0.4l1.35,-0.27l0.89,-0.72l1.01,-2.08l1.56,-0.55l1.38,-1.51l1.48,0.22l0.91,0.73l1.79,2.03l1.09,1.78l1.64,1.23l1.67,0.19l2.77,-0.44Z",name:"Mendoza"},"AR-J":{path:"M309.16,489.83l-10.9,0.57l-1.84,-0.38l-1.45,-0.98l-2.2,-0.47l-2.07,0.5l-3.73,0.24l-4.88,-0.99l-1.29,0.6l-0.92,1.13l-0.26,0.9l0.26,3.51l0.37,1.26l-0.97,3.81l0.15,9.26l-2.75,-1.82l-1.32,-0.28l-1.09,0.57l-3.61,0.07l-6.51,1.31l-4.02,-0.66l-1.85,-2.2l-2.8,-1.67l-0.44,-1.67l-1.7,-1.92l-1.67,-1.03l-1.79,-0.09l-5.11,1.24l-2.34,1.68l-1.53,0.66l-6.49,0.56l-3.12,2.97l-7.93,5.14l-2.21,1.11l-8.7,0.07l-0.42,-0.3l-0.97,-12.59l-0.69,-0.43l-2.78,0.46l-1.9,-0.4l-3.76,-4.62l-1.13,-0.88l-1.53,-0.33l-1.1,0.37l-0.99,1.3l-1.64,0.61l-1.16,2.24l-0.5,0.41l-1.01,0.23l-2.21,-0.4l-3.79,0.11l-2.85,1.79l-4.48,1.62l-1.1,1.6l-0.12,4.27l-1.46,1.11l-5.22,0.24l-8.74,2.01l-3.12,-0.84l-1.84,0.02l-7.33,1.18l-0.57,-0.65l-2.17,-0.82l-0.31,-1.05l0.09,-1.86l-0.8,-2.14l0.42,-1.92l-0.95,-0.95l-0.19,-1.67l-1.11,-1.34l-0.09,-0.58l0.39,-0.34l2.75,0.84l1.42,-0.17l0.52,-0.64l0.36,-1.78l1.14,-1.97l-0.1,-1.17l-0.61,-1.05l-1.92,-1.81l-0.92,-0.49l-5.05,-0.57l-1.96,-2.3l-0.56,-2.17l0.04,-2.31l-1.86,-2.38l-2.76,-5.68l0.49,-6.66l1.09,-3.41l-0.63,-2.91l0.99,-1.98l0.46,-4.49l2.46,-3.67l0.29,-0.2l0.53,0.24l0.5,1.97l0.65,0.81l1.07,-0.07l1.48,-1.57l0.43,-1.56l1.37,-2.33l0.64,-0.3l1.97,0.26l0.82,-0.56l-0.14,-0.85l-2.58,-2.58l-0.55,-1.44l0.88,-6.72l0.62,-1.68l1.31,-1.99l0.03,-2.68l1.82,-3.99l0.83,-3.79l0.82,-1.27l2.05,-1.34l0.44,-1.17l-0.2,-1.24l-1.12,-1.84l0.01,-0.5l0.8,-0.35l3.57,1.67l1.61,0.41l3.31,-1.18l2.48,-2.38l0.46,-0.96l0.52,-4.05l1.77,-1.33l0.72,-2.03l-0.64,-2.0l-1.5,-1.48l-1.86,-0.68l-2.3,0.12l-0.2,-0.51l1.67,-2.7l0.67,-1.96l0.56,-8.57l-0.66,-4.46l-1.57,-1.66l-0.36,-0.79l0.2,-4.09l-1.06,-4.74l-0.83,-1.61l-0.41,-2.45l-1.05,-2.08l0.09,-3.02l0.35,-0.81l2.33,-1.43l0.23,-1.08l-0.57,-0.79l2.89,-2.07l0.5,-1.19l3.9,-1.1l1.05,-1.31l0.38,-2.48l-0.48,-3.5l0.15,-1.82l1.55,-2.63l0.15,-1.33l1.28,-2.21l0.19,-1.03l-1.04,-4.34l0.11,-1.57l1.35,-2.94l0.9,-1.21l1.12,-0.7l0.29,-5.75l0.7,-2.36l2.64,0.67l2.07,1.04l1.26,0.0l1.84,-0.55l1.37,1.81l0.97,0.66l0.96,0.25l2.15,-0.2l0.61,0.27l6.55,5.31l1.21,1.26l1.25,2.83l1.38,4.75l3.79,3.51l2.07,4.82l2.12,1.82l0.59,0.89l0.2,0.83l-0.42,1.06l-1.49,0.65l-0.94,0.82l-1.19,1.98l-0.29,1.74l0.17,4.2l1.56,1.66l1.07,2.11l-1.49,1.48l-0.49,3.68l0.28,1.79l-1.81,3.41l-0.21,3.96l0.6,1.28l1.92,0.82l3.67,-0.85l3.29,0.69l3.22,-1.11l2.29,-0.41l4.23,2.11l4.92,-0.02l7.16,2.05l2.03,2.5l4.96,3.3l1.05,2.15l2.68,1.01l0.91,0.65l2.08,2.08l0.82,1.96l2.28,1.51l2.15,2.73l1.9,1.33l2.23,0.88l2.24,2.88l6.24,4.67l2.28,3.59l0.99,3.18l3.39,2.16l1.93,3.11l4.54,3.75l3.94,5.77l2.88,1.54l2.17,4.65l2.72,4.27l-1.66,5.53l0.3,1.71l2.31,2.01l-1.95,13.36l2.38,5.36l0.16,3.33l0.65,0.93l4.18,3.81l3.93,0.85l0.84,5.62l0.87,0.84l1.62,0.55l2.07,4.48Z",name:"San Juan"},"AR-K":{path:"M232.75,298.33l-0.09,-1.31l0.71,-3.13l-0.84,-2.6l0.93,-4.14l-0.25,-0.96l-0.68,-0.53l-3.22,-0.26l-2.97,1.7l-2.63,-0.95l-1.0,-0.06l-4.43,0.67l-4.29,1.34l-12.32,-0.96l0.54,-1.85l1.53,-0.8l0.4,-0.52l-0.69,-2.83l1.65,-1.84l1.21,-2.49l0.45,-1.4l0.05,-3.01l0.91,-0.91l1.62,-0.84l1.34,-1.4l2.21,-4.96l0.15,-3.57l0.37,-1.03l2.45,-3.67l2.04,-0.67l1.9,0.09l3.09,2.14l1.75,0.7l1.32,-0.11l0.75,-0.82l0.82,-2.04l1.63,-1.36l0.97,-0.36l3.27,-0.33l2.03,-0.85l2.06,0.03l0.44,-0.67l-0.03,-1.83l1.21,-3.54l-0.17,-1.67l-0.7,-1.41l-11.25,-15.44l-0.75,-1.98l-0.35,-2.39l0.06,-3.75l0.81,-3.48l1.24,-1.57l5.66,-4.31l0.64,-2.07l-0.37,-2.49l-3.12,-12.4l-0.56,-3.99l-1.09,-2.45l-1.65,-1.99l-0.01,-2.47l-0.35,-0.95l0.51,-0.99l-2.16,-2.99l-0.21,-0.74l0.1,-2.54l4.03,-12.09l0.68,-0.88l30.99,5.88l56.13,-0.56l0.94,1.78l0.68,4.41l2.26,3.47l-1.14,4.53l-0.0,1.51l-0.68,0.91l-2.51,1.67l-7.4,0.33l-3.05,2.22l-0.69,1.03l-0.22,1.82l0.06,2.09l0.62,2.35l4.67,7.07l3.61,4.41l0.68,2.14l1.5,1.78l1.75,4.02l5.68,6.05l1.36,0.28l1.3,-0.89l2.77,-6.14l1.8,-1.21l0.81,-1.61l0.72,-0.68l1.3,-0.3l1.4,0.26l2.62,2.97l1.72,0.91l-1.97,2.94l-0.3,2.81l-2.23,5.79l0.17,2.15l1.57,1.67l3.14,0.73l1.57,0.84l4.47,3.84l2.19,1.08l0.59,1.11l-0.0,1.39l-0.75,3.43l0.01,3.32l-0.66,1.79l-1.18,1.9l-5.75,5.99l-1.63,3.26l-3.31,3.23l-2.02,3.59l-0.13,0.88l1.65,1.05l2.99,0.58l3.22,1.82l1.81,0.27l-0.33,1.52l2.6,10.96l1.16,1.4l1.22,0.81l1.21,4.02l0.5,0.74l0.98,0.64l2.95,-0.78l2.28,1.3l1.73,6.19l4.43,5.28l1.03,0.05l1.37,-2.78l1.32,-1.7l2.88,-2.51l3.68,-2.19l1.05,0.35l3.51,2.4l1.41,0.25l1.74,-0.55l3.95,17.33l0.31,7.25l-0.26,2.72l-3.27,5.01l-1.23,0.89l-0.09,2.3l0.38,0.74l2.38,1.16l1.03,1.14l0.94,10.27l-0.19,4.1l1.98,14.39l2.01,4.7l4.63,8.08l-2.58,0.9l-0.73,1.82l1.35,11.56l-0.47,1.54l-8.71,9.04l-2.17,1.13l-9.3,2.54l-7.38,-14.39l-1.65,-4.53l-5.59,-12.25l-1.04,-4.78l-0.12,-4.39l-1.72,-3.32l-8.11,-7.72l-1.41,-0.75l-5.48,-5.41l-2.04,-1.35l-7.59,-3.39l-1.15,-0.89l-0.67,-1.18l1.87,-3.0l-0.01,-1.53l-2.79,-1.75l-1.43,-1.33l-1.55,-2.12l-0.37,-0.74l-1.02,-5.69l-1.03,-1.58l-1.5,-1.23l-1.67,-2.03l-8.83,-3.61l-9.02,-3.12l-1.65,0.07l-1.58,0.83l-2.48,2.77l-3.86,0.69l-3.26,0.1l-20.04,-0.93l-3.02,0.73l-2.23,1.35l-0.74,-2.03l-3.15,-4.21l-0.47,-1.61l-0.32,-2.63l0.14,-1.49l-0.31,-0.57l-1.7,-0.32l-5.64,1.75l-2.63,-2.36l-2.51,-0.78l-3.18,-0.17l-3.14,-3.23l-1.65,-0.41l-1.68,-0.01l-0.78,-0.45Z",name:"Catamarca"},"AR-H":{path:"M561.61,140.25l0.03,1.32l2.18,3.41l-0.41,0.74l0.08,1.12l1.37,1.71l0.78,0.42l1.13,-0.29l6.26,5.18l2.54,1.57l1.76,1.75l1.4,0.52l4.33,2.58l1.32,1.22l2.41,0.79l1.6,0.98l1.2,-0.14l1.29,0.49l1.57,2.87l1.74,2.36l2.91,2.09l0.89,1.66l-0.37,0.56l0.29,0.78l1.79,0.99l0.79,1.95l2.09,0.44l0.51,1.0l-0.55,0.69l-0.01,0.51l0.88,2.19l1.3,1.75l0.62,2.02l0.85,0.42l0.96,-0.49l3.12,1.44l1.51,0.32l0.98,1.79l2.21,0.61l1.12,1.53l3.33,1.82l0.18,1.48l0.42,0.82l2.02,1.0l1.76,1.66l3.06,4.24l1.24,0.37l0.17,4.68l0.42,0.97l0.95,0.38l1.15,-0.21l2.44,1.1l1.54,-0.08l1.47,0.43l1.53,0.02l1.92,0.87l0.31,2.27l1.11,1.82l0.14,1.46l1.75,1.99l1.49,-0.15l1.49,0.58l1.04,-0.05l2.69,-1.03l1.26,-1.21l0.92,-0.19l0.79,1.1l1.69,1.43l5.16,1.96l2.07,1.55l3.22,3.93l3.22,1.67l2.33,2.71l2.23,0.43l1.78,2.2l3.68,2.23l1.04,2.21l3.13,2.72l0.91,1.84l1.63,0.79l1.93,-0.12l0.2,1.32l-0.88,1.04l-2.82,0.84l-0.95,0.66l-0.42,0.88l0.09,0.64l0.57,0.63l-1.44,2.07l-0.3,1.47l-0.64,-1.02l-0.88,0.19l-0.84,1.33l-0.15,2.3l-2.21,0.39l-1.16,0.71l-0.65,0.99l-0.29,1.56l0.3,0.85l1.8,1.51l0.47,0.77l-0.1,2.98l-2.22,0.75l-10.56,7.48l0.09,3.58l2.31,4.63l0.8,3.44l-0.09,2.58l-1.18,3.45l0.1,3.61l-0.96,3.71l-127.8,0.05l-0.03,-89.7l-0.53,-19.44l-1.45,-4.11l-0.38,-0.27l-73.45,-0.1l47.55,-59.75l-0.12,-13.18l9.2,3.52l4.33,0.82l1.87,2.25l3.76,2.6l3.39,0.92l2.28,0.23l3.04,2.42l2.32,4.28l0.37,0.23l0.8,-0.26l2.57,0.23l0.94,2.07l4.94,4.56l2.52,0.17l2.45,0.83l3.43,0.16l1.63,0.5l0.94,0.69l1.32,1.95l1.03,0.42Z",name:"Chaco"},"AR-F":{path:"M178.38,317.96l4.15,-3.59l1.96,-2.46l0.94,-3.41l0.34,-0.27l1.66,0.93l1.12,0.06l2.45,-4.11l1.61,-3.73l0.93,-0.97l-0.07,-0.99l0.37,-0.6l1.09,-0.69l2.64,-0.69l1.41,-1.02l0.82,-1.44l1.67,-7.05l12.51,0.98l4.46,-1.36l4.31,-0.66l0.93,0.1l1.46,0.74l1.57,0.14l3.14,-1.77l2.39,0.32l0.38,0.53l-0.91,4.29l0.15,1.17l0.69,1.48l-0.78,3.64l0.34,1.31l1.19,0.72l3.14,0.34l1.34,1.22l0.98,1.43l0.97,0.65l3.3,0.21l2.32,0.72l1.62,1.76l1.09,0.64l1.1,-0.05l2.52,-1.1l1.38,-0.1l1.09,-0.48l0.98,0.16l0.21,4.17l0.53,1.82l3.2,4.3l0.49,1.64l0.82,0.82l0.9,-0.2l1.75,-1.24l2.75,-0.67l20.0,0.93l3.38,-0.1l4.05,-0.74l2.6,-2.83l1.46,-0.76l1.28,-0.01l8.81,3.07l8.71,3.56l1.47,1.86l1.45,1.18l0.94,1.42l0.97,5.55l0.49,1.01l1.59,2.17l1.53,1.43l2.62,1.56l-0.02,0.8l-1.93,3.21l0.12,0.77l0.72,1.02l1.42,1.11l7.59,3.39l1.92,1.28l5.44,5.38l1.4,0.73l7.97,7.57l1.6,3.03l0.11,4.34l1.08,4.95l5.61,12.29l1.66,4.54l7.46,14.55l-3.68,10.1l-1.89,3.42l-1.72,5.44l-0.42,2.27l-8.13,23.01l-0.62,3.11l0.33,39.14l-4.15,0.71l-2.09,-0.01l-2.76,-1.1l-3.92,-0.36l-2.4,0.56l-5.04,2.15l-2.23,0.22l-2.24,-0.21l-2.5,0.4l-2.65,-0.94l-2.95,0.28l-1.9,-0.89l-2.43,0.62l-2.99,-1.31l-2.93,-0.56l-1.08,-2.85l-1.19,-2.1l-1.0,-0.72l-0.94,-0.1l-0.51,-0.5l-0.87,-5.68l-0.68,-0.5l-3.5,-0.58l-4.51,-4.4l-0.11,-3.19l-2.35,-5.16l1.97,-13.47l-2.49,-2.41l-0.14,-1.22l1.65,-5.65l-2.82,-4.54l-2.26,-4.77l-2.93,-1.59l-3.93,-5.76l-4.53,-3.73l-2.01,-3.18l-3.3,-2.08l-0.86,-2.98l-2.44,-3.82l-6.31,-4.73l-2.3,-2.93l-2.31,-0.93l-1.74,-1.21l-2.14,-2.72l-2.21,-1.44l-0.8,-1.94l-2.18,-2.18l-1.17,-0.81l-2.4,-0.83l-1.05,-2.16l-5.0,-3.33l-2.11,-2.56l-7.5,-2.18l-4.84,0.04l-3.23,-1.82l-1.09,-0.31l-2.59,0.44l-3.04,1.08l-3.3,-0.7l-3.59,0.85l-1.42,-0.61l-0.43,-2.1l0.29,-2.42l1.8,-3.39l-0.27,-1.92l0.3,-2.88l0.27,-0.81l0.96,-0.49l0.44,-0.97l-1.17,-2.54l-1.48,-1.49l-0.2,-1.69l0.26,-3.68l1.42,-2.18l2.12,-1.15l0.55,-1.42l-0.27,-1.26l-0.75,-1.13l-2.02,-1.71l-2.11,-4.86l-3.7,-3.38l-1.35,-4.68l-1.27,-2.88l-1.41,-1.52l-6.67,-5.4l-1.0,-0.39l-2.82,0.01l-2.35,-2.48l-3.27,0.5l-1.9,-0.99l-2.5,-0.64Z",name:"La Rioja"},"AR-G":{path:"M385.58,272.81l5.29,-5.87l0.9,-0.74l1.2,-0.26l0.67,-0.82l1.02,-2.85l1.02,-1.42l1.36,-3.36l1.33,-5.23l0.57,-0.88l0.88,-0.59l0.71,-1.43l2.35,-8.68l1.7,-0.19l0.71,-0.55l1.74,-5.42l3.11,0.38l0.6,-0.44l0.15,-2.94l-1.12,-8.51l1.76,-6.1l-0.06,-4.82l0.31,-1.56l2.05,-4.26l0.38,-3.38l9.61,-20.4l0.73,-0.93l1.47,0.2l10.42,3.27l23.75,0.34l74.0,0.1l1.31,3.67l0.53,19.37l0.03,90.06l-16.8,104.57l-6.49,-16.03l-2.42,-1.68l-49.37,-0.25l-0.47,-2.06l-2.73,-0.7l0.13,-2.19l-0.47,-0.77l-0.83,-0.18l-2.04,0.33l-3.93,-1.07l-5.4,0.8l-3.46,-0.18l-1.96,-1.26l-3.52,-0.81l-0.99,-1.31l-3.32,-1.72l-0.74,-0.71l0.16,-2.29l-0.45,-0.59l-9.42,-2.43l-1.9,0.05l-26.33,6.44l-4.75,-8.21l-1.93,-4.47l-1.97,-14.3l0.19,-4.06l-0.8,-9.69l-0.56,-1.51l-3.37,-2.18l0.01,-1.81l1.21,-0.84l3.34,-5.16l0.31,-3.0l-0.32,-7.39l-4.0,-17.56l0.98,-0.37l1.63,0.17l1.57,-0.68l0.66,-1.11l1.28,-3.82l0.4,-0.39l0.83,-0.02l0.26,-0.42l-3.12,-7.57l-0.04,-0.97l0.51,-1.19l1.74,-0.1l1.02,-0.61l1.26,-1.99l-0.16,-0.71l-1.03,-0.69l-2.91,-1.06Z",name:"Santiago del Estero"},"AR-D":{path:"M280.68,494.41l-0.22,-3.66l0.39,-0.79l1.22,-0.83l4.87,0.98l6.27,-0.69l1.48,0.37l1.69,1.06l1.86,0.34l11.45,-0.59l3.03,0.58l3.09,1.33l2.5,-0.61l1.82,0.89l3.0,-0.27l2.71,0.95l2.55,-0.4l2.24,0.21l2.32,-0.23l5.17,-2.18l2.2,-0.52l3.7,0.35l2.9,1.12l2.22,0.01l4.48,-0.77l3.89,0.01l3.56,1.43l12.54,7.27l2.45,2.49l0.55,1.24l0.41,3.39l1.38,2.61l0.06,3.01l0.65,0.66l0.83,0.16l4.85,-0.51l5.34,-1.44l0.9,0.26l0.26,2.42l-0.29,3.96l1.36,2.82l0.81,3.16l-0.39,3.36l-1.01,2.21l-0.43,2.43l-1.32,1.66l-0.09,1.92l-0.86,1.77l-0.35,3.07l-1.87,3.5l0.31,2.36l-1.63,3.39l0.51,2.44l-0.34,0.39l-1.39,0.27l-0.83,0.5l-1.94,3.76l2.02,38.31l-0.04,103.88l-68.59,-0.07l-0.21,-2.17l0.57,-2.44l0.35,-3.69l1.84,-8.12l0.53,-5.16l1.56,-3.96l0.19,-4.61l0.54,-3.27l-0.6,-3.95l0.6,-1.9l-0.88,-1.56l0.87,-3.86l-1.09,-2.39l-0.95,-3.41l0.2,-4.33l-1.19,-3.76l-5.39,-10.02l-2.15,-2.21l-1.51,-5.05l-0.3,-4.42l-0.39,-0.99l-1.04,-1.1l0.46,-1.26l-0.46,-0.85l-0.47,-5.64l0.78,-1.62l1.06,0.33l0.97,-1.05l0.5,-6.4l-0.74,-1.22l-0.67,-2.34l-1.93,-1.72l-0.45,-2.22l-0.59,-1.02l-3.89,-3.02l-1.54,-4.86l-1.06,-1.77l-1.45,-4.55l-1.26,-1.42l-4.27,-6.86l-0.39,-1.07l0.11,-3.16l-1.26,-3.31l0.0,-1.74l-0.59,-1.86l0.28,-3.99l-0.37,-4.58l-0.53,-1.59l0.28,-2.03l-1.29,-3.53l0.92,-1.15l0.0,-1.3l-0.53,-1.98l1.13,-3.55l-0.65,-1.13l-0.4,-1.79l-1.39,-1.36l-0.54,-1.1l-1.1,-5.48l-1.02,-3.39l-0.67,-1.06l-0.01,-1.2l-0.94,-1.25l-0.96,-0.65l-1.22,-4.46l-0.27,-12.0l0.94,-3.5l-0.34,-1.67Z",name:"San Luis"},"AR-E":{path:"M584.61,484.16l0.06,-1.5l0.63,-0.59l1.97,-0.37l5.12,-0.06l2.88,-1.27l2.86,-2.68l4.37,-5.75l1.41,-1.0l0.77,-1.09l1.93,-1.07l3.24,-4.56l1.37,-4.14l2.81,-2.83l7.2,-11.67l5.49,-7.3l2.71,-4.79l0.66,-4.74l1.08,-3.33l0.34,-5.69l-1.73,-3.94l-0.3,-1.84l3.81,-0.2l3.11,-1.16l1.87,0.53l3.09,-0.68l2.22,0.32l4.61,1.48l3.46,-1.9l3.03,-2.73l4.04,-2.21l3.92,0.96l1.93,0.16l3.77,-0.77l7.36,-2.92l1.17,-0.04l1.15,0.21l2.33,1.33l3.12,0.07l8.63,2.28l1.65,1.46l1.22,2.57l1.04,1.35l4.67,3.95l0.66,1.43l0.66,3.43l2.3,4.16l5.33,5.25l2.72,1.96l0.56,5.19l-0.47,2.17l-3.3,0.48l-1.12,0.78l-0.34,1.2l2.16,3.21l0.33,2.11l-1.89,3.2l-0.63,2.32l0.29,3.47l-1.31,2.35l-1.43,1.3l-1.03,4.13l-3.19,2.18l-0.7,1.72l1.18,1.68l1.72,1.27l1.09,1.3l0.3,2.05l-0.39,2.1l-2.7,7.64l-0.37,0.57l-4.19,1.23l-2.01,1.89l-0.39,1.19l0.59,1.31l1.42,1.54l0.57,3.51l-0.58,4.03l-1.01,1.61l-0.23,1.3l0.56,1.14l3.04,3.84l0.42,1.3l-0.2,1.34l-2.84,3.9l-1.62,2.8l-0.91,2.38l-0.12,2.3l0.51,6.19l0.84,3.49l0.61,5.13l1.87,3.61l-0.97,3.92l0.56,3.48l-2.29,1.84l-1.54,0.15l-6.37,-0.99l-1.83,0.67l-0.75,1.02l0.16,0.89l0.62,0.26l-0.92,5.44l0.91,3.23l-2.05,1.73l-1.26,1.76l-0.9,1.95l-1.16,4.54l-0.17,2.11l0.3,2.22l-0.54,1.49l-0.39,3.79l0.43,3.31l0.78,1.73l2.8,4.03l0.95,5.97l-0.31,1.05l-2.15,0.45l-4.05,1.61l-1.98,-0.02l-1.74,-0.82l-4.57,-3.97l-3.17,-0.84l-3.22,-2.49l-4.98,-2.95l-6.02,-0.09l-1.56,-1.65l-1.43,0.14l-0.66,-0.51l-0.22,-2.26l-0.82,-1.11l-1.47,0.28l-0.53,0.6l-3.67,0.0l-2.08,-1.04l-1.67,-1.84l-1.9,-1.31l-3.95,1.06l-1.56,-0.31l-5.85,-3.01l-2.32,-3.04l-1.64,-1.34l-2.21,-1.06l-1.8,-0.44l-7.61,-5.08l-5.76,-5.79l-3.6,-1.91l-3.06,-3.38l-4.61,-2.62l-2.49,-3.0l-1.55,-4.21l-1.61,-1.85l-2.37,-4.69l-1.01,-3.75l-0.34,-4.62l-0.8,-1.92l-1.67,-2.41l-0.38,-1.53l1.8,-5.25l-0.08,-5.06l1.33,-5.05l-0.24,-4.87l1.78,-3.29l0.25,-1.07l-0.24,-1.32l-2.29,-3.76l-0.1,-2.26l2.07,-3.47l1.05,-4.37l-0.1,-0.6Z",name:"Entre R\xedos"},"AR-B":{path:"M487.51,964.44l-0.33,-1.21l-2.38,-4.23l-2.77,-2.57l-2.26,-1.61l-2.4,-2.82l-3.59,-2.99l-3.75,-1.39l-8.91,-1.03l-0.06,-247.83l0.31,-72.01l0.37,-8.31l1.32,-1.45l73.41,-0.19l34.05,-35.66l1.62,-2.24l-0.32,-1.77l0.38,-1.02l0.65,-0.66l1.5,-0.52l1.37,-0.07l2.99,1.16l4.37,0.12l2.1,1.29l1.6,1.46l1.23,0.5l1.3,0.14l2.05,-0.49l1.66,-1.29l1.85,-3.85l0.7,-3.85l2.8,-2.49l0.35,-3.24l1.39,-0.54l1.03,-0.82l0.46,-0.79l0.1,-1.51l0.69,0.35l5.8,5.82l7.69,5.13l1.9,0.48l2.08,1.0l1.49,1.22l2.4,3.1l6.04,3.13l2.0,0.37l3.53,-1.08l1.63,1.12l1.81,1.94l2.41,1.16l3.9,0.0l0.77,-0.68l0.9,-0.21l0.57,3.04l0.94,0.75l0.81,0.21l0.64,-0.33l1.13,1.4l0.75,0.34l5.78,0.03l4.86,2.89l3.31,2.54l3.04,0.76l4.55,3.96l1.96,0.94l2.47,0.03l4.09,-1.63l2.04,-0.42l2.22,1.03l0.42,1.56l-0.35,4.41l0.59,1.63l-1.44,1.5l-0.59,1.37l-1.4,1.2l-0.7,0.18l-1.12,-0.4l-1.74,-0.08l-1.65,1.4l0.21,0.4l2.59,1.38l1.98,1.58l0.39,0.67l-0.7,1.36l-1.81,2.21l0.41,1.52l1.2,1.1l0.07,1.53l-2.88,2.41l-1.0,4.42l0.86,3.1l4.56,3.5l0.59,-0.13l1.67,-2.99l1.07,-0.92l1.75,-0.34l1.15,-1.37l3.16,1.98l2.06,1.74l1.67,0.83l2.79,0.4l1.43,0.79l2.71,0.69l1.67,1.93l1.39,0.49l2.81,-0.21l5.11,4.07l3.2,1.22l3.82,2.78l3.6,1.27l7.72,6.93l4.54,5.05l5.13,8.49l0.21,1.1l-0.7,2.03l-3.52,4.32l-5.89,8.27l-1.83,6.96l1.03,6.13l0.31,0.75l0.75,0.61l1.4,3.39l0.34,1.6l1.84,1.48l0.29,1.19l0.71,1.13l6.38,5.83l4.64,2.65l2.98,0.84l0.18,0.29l-0.55,0.52l0.28,0.91l0.57,0.03l1.67,-1.27l1.89,-0.75l3.88,0.01l0.39,-0.55l-0.38,-1.46l0.92,0.47l0.8,2.67l1.06,1.33l-0.09,6.32l1.23,4.13l0.16,15.09l-0.74,1.63l-4.68,5.73l-4.46,6.45l-5.9,9.66l-1.65,3.39l-4.92,6.36l-6.43,5.69l-1.84,2.82l-1.27,0.84l-5.02,6.18l-1.94,4.41l-0.59,4.51l0.58,1.37l-0.3,1.02l0.13,1.48l-1.08,2.32l-1.52,1.6l-12.07,7.38l-7.01,3.83l-2.18,0.56l-2.39,1.87l-1.65,0.86l-5.39,2.01l-2.47,1.26l-4.01,0.61l-3.42,1.09l-3.26,1.79l-7.31,1.56l-9.53,3.03l-2.6,1.58l-2.94,0.92l-25.67,4.74l-7.45,2.89l-4.15,-0.0l-20.57,3.6l-14.2,1.92l-9.29,1.72l-5.0,-0.07l-1.85,-0.32l-1.65,0.78l-4.04,0.95l-8.71,-1.03l-4.13,0.06l-3.05,0.9l-1.07,0.62l-6.87,-0.9l-2.33,-1.38l-3.08,0.75l-2.1,-0.08l-8.4,-2.26l-1.61,-0.74l-1.22,-1.03l-2.22,-4.36l-0.78,-0.54l-7.39,-0.58l-1.79,-0.69l-1.29,0.63l-0.61,1.01l0.36,0.8l-0.21,1.15l0.77,1.85l-0.06,1.22l0.99,-0.45l0.59,0.18l0.02,2.4l0.31,0.74l0.75,0.39l1.51,-0.2l-0.32,1.77l-1.42,1.01l-1.87,4.41l0.83,1.45l-0.35,2.48l0.38,1.15l3.05,2.6l-1.24,-0.57l-0.46,0.08l-0.65,0.68l-0.03,0.51l0.59,0.69l1.07,0.42l5.66,0.55l3.49,1.6l1.83,1.24l0.91,1.24l-0.12,0.97l-1.0,0.94l-4.16,-3.0l-1.25,-1.94l-0.68,-0.5l-4.17,0.14l-0.36,0.48l0.63,1.69l0.61,0.47l1.41,0.02l0.56,1.46l0.88,1.11l1.91,1.66l1.01,0.53l3.34,0.68l0.18,0.95l-0.97,1.54l-0.12,3.63l-0.52,1.24l-1.13,7.25l-0.12,4.73l-0.14,0.54l-1.89,1.07l-3.09,-0.49l-2.85,-1.94l-0.62,0.21l-0.16,0.81l0.84,1.35l-1.06,0.83l-0.09,3.04l-0.91,3.71l-1.39,3.19l1.21,3.3l-0.91,4.04l-0.34,0.87l-2.83,1.25l-0.9,0.81l-1.5,2.08l-0.31,1.2l0.25,1.06l1.3,2.28l0.68,3.1l1.21,2.1l3.97,1.96l0.05,1.41l1.41,1.72l0.6,0.49l0.9,-0.31l0.45,1.78l-0.01,1.12l-0.46,0.37l-1.87,-0.32l-1.38,-1.43l-0.6,0.31l0.06,1.12l0.69,1.19l-0.4,0.84l0.43,0.81l0.88,0.37l3.5,-1.91l1.65,-0.47l-1.49,1.08l-1.15,4.73l-2.55,5.28l-1.1,1.33l-6.63,3.17l-5.43,3.07l-3.11,1.17l-2.38,1.57l-2.82,0.06ZM689.21,609.29l-0.27,-0.53l0.66,-0.88l-0.08,-1.29l1.18,1.19l0.19,1.3l-0.64,-0.52l-0.56,0.08l-0.49,0.65ZM526.64,864.17l0.56,0.35l0.69,-0.73l1.35,3.43l-0.15,1.09l-1.47,-0.26l-1.44,-1.21l-3.77,-1.47l-2.57,-3.05l-0.46,-1.3l6.4,1.59l0.87,1.56ZM523.08,857.17l1.21,0.9l-0.07,0.69l-1.23,0.27l-0.77,-0.31l-2.49,-1.78l-1.02,0.52l-0.76,-0.38l0.27,-0.52l3.28,0.16l1.58,0.46ZM522.25,925.81l-0.45,-1.18l-3.09,-4.09l-0.92,-1.88l0.54,-2.26l2.97,0.79l1.01,1.32l-0.25,5.1l0.19,2.2ZM521.32,934.72l-3.03,4.06l-1.74,-0.24l0.24,-1.3l-0.54,-1.18l-0.55,-0.16l-1.16,0.65l-0.99,-0.01l-0.33,-0.31l1.52,-2.24l0.3,-2.25l0.83,-2.3l3.11,0.14l1.07,1.02l1.62,2.79l-0.34,1.31Z",name:"Buenos Aires"},"AR-C":{path:"M689.37,630.71l-1.01,1.27l-1.7,0.31l-1.21,1.05l-1.57,2.76l-3.94,-2.94l-0.79,-2.67l0.94,-4.18l2.57,-2.05l4.03,2.43l1.43,1.69l1.24,2.33Z",name:"Ciudad de Buenos Aires"},"AR-A":{path:"M230.92,160.73l3.51,-0.13l1.13,-0.52l0.67,-0.92l-0.12,-1.2l-3.34,-3.82l0.24,-2.28l-1.42,-1.82l0.13,-0.72l-0.36,-0.73l-0.47,-0.55l-1.39,-0.22l-1.67,-1.14l-1.14,-2.72l0.23,-1.64l2.29,-4.5l1.04,-3.35l1.56,1.31l0.57,-0.22l0.63,-2.38l1.73,-3.64l0.57,-0.32l1.55,0.39l1.05,-0.18l2.32,-3.24l0.61,-1.64l0.7,-0.47l37.54,-15.77l2.3,-1.23l1.21,-1.66l3.79,-12.14l1.03,1.01l1.74,0.72l1.63,1.79l2.91,0.83l3.54,3.7l0.56,1.44l1.86,0.6l0.64,1.54l2.66,3.02l4.79,2.36l4.27,4.87l3.26,1.62l1.71,0.37l2.96,-0.12l1.81,-0.94l2.33,-3.1l1.46,-0.78l1.67,-4.91l0.82,-12.47l-0.18,-2.78l-2.95,-8.06l-0.15,-1.69l1.29,-5.99l0.81,-0.82l2.88,1.09l1.23,0.03l2.06,1.31l1.83,0.05l6.34,3.73l1.54,1.53l0.21,0.58l-0.33,2.18l0.22,3.13l-0.49,1.12l0.57,1.53l-1.51,2.35l-0.25,3.86l0.12,0.69l0.77,0.49l0.07,0.74l0.52,0.75l-0.39,1.03l0.15,1.04l2.0,2.61l1.02,0.15l1.03,-0.75l0.59,0.01l2.96,2.65l3.22,1.79l-0.02,3.53l0.41,1.16l1.54,2.57l4.54,5.88l1.35,2.46l2.36,1.49l0.71,0.18l2.05,-0.62l2.29,1.89l2.95,0.53l3.88,1.45l1.98,-0.52l2.97,-1.76l0.65,1.3l3.89,3.09l1.55,0.91l5.01,1.68l1.35,-0.57l2.04,-4.72l1.06,-1.55l8.75,7.4l0.56,0.13l1.0,-0.58l1.44,-3.04l2.99,-2.81l2.5,-0.7l1.4,-1.77l4.05,-0.51l1.4,-0.9l3.95,-5.01l1.61,-2.85l0.84,-2.79l-1.14,-31.66l-0.49,-0.84l-1.54,-0.33l-5.72,-0.1l-1.05,0.25l-1.45,1.67l-0.67,2.47l-0.97,0.99l-0.88,-0.61l-2.37,-3.09l-1.76,-1.54l-3.59,-1.37l-1.33,-1.17l-4.18,0.6l-2.11,1.68l-3.3,-0.43l-0.28,-2.31l-3.06,-6.31l-0.71,-0.64l-2.77,-1.06l-0.54,-0.86l1.01,-4.14l0.6,-4.19l-0.31,-2.19l-1.24,-1.58l-0.93,-0.59l-5.69,-0.35l-1.85,-1.5l-1.79,-4.94l-0.77,-5.29l-0.01,-2.2l0.91,-2.33l-1.92,-2.05l-1.66,-0.24l0.45,-3.85l1.05,-1.89l1.69,-4.34l1.55,-2.48l0.21,-4.64l0.42,-1.8l1.29,-2.45l0.29,-1.33l7.27,-0.08l8.39,1.92l3.22,1.76l1.78,0.42l1.67,-0.47l1.21,0.23l3.09,1.54l1.87,2.77l0.02,0.59l-0.86,1.28l-0.4,1.49l2.09,1.97l-0.33,1.7l1.17,1.16l0.41,1.32l3.06,3.22l-0.92,1.84l-0.21,2.84l1.22,0.96l1.27,2.59l1.44,0.82l0.49,0.87l0.13,1.13l-0.32,1.05l0.55,0.94l0.16,2.09l1.07,0.72l0.57,-0.41l1.36,-4.98l0.06,-3.53l1.92,-7.04l0.6,-1.04l2.29,-2.12l1.15,-1.62l3.37,-8.58l1.58,-1.36l1.45,-3.57l0.7,-2.67l0.33,-0.65l1.21,-0.76l0.88,-2.74l0.53,-0.22l1.12,-0.2l4.09,0.27l3.22,2.22l3.12,-2.21l1.64,-0.28l28.37,0.16l6.68,-0.36l2.32,0.45l0.52,4.84l0.36,0.98l0.84,0.87l3.98,2.32l0.81,1.59l1.6,0.85l0.09,0.77l-0.52,1.21l0.41,0.76l2.87,0.93l1.89,2.04l2.35,0.8l1.44,1.77l3.15,2.12l1.04,0.39l0.31,91.6l-47.85,60.14l-23.5,-0.34l-10.28,-3.24l-2.17,-0.1l-0.94,1.22l-9.64,20.46l-0.42,3.47l-1.95,3.98l-0.37,1.65l-9.17,0.22l-3.26,-0.65l-3.82,1.05l-2.32,1.73l-1.79,0.25l-3.19,-1.59l-0.86,-0.2l-1.22,0.23l-8.48,-3.32l-0.84,-0.84l-1.31,-3.16l-0.81,-0.7l-1.23,0.18l-3.53,1.81l-0.97,0.14l-4.38,-0.97l-1.7,0.07l-4.05,-1.28l-1.04,0.9l-0.26,4.02l-0.6,2.12l0.09,2.54l-0.77,1.29l-1.6,-0.01l-13.23,-2.22l-1.8,-0.92l-2.77,-3.07l-2.62,-0.26l-1.38,0.67l-1.29,2.15l-1.76,1.17l-2.63,5.92l-0.72,0.74l-0.66,0.08l-2.11,-1.77l-3.7,-4.21l-1.71,-3.95l-1.51,-1.79l-0.71,-2.2l-3.63,-4.43l-3.67,-5.28l-0.92,-1.66l-0.56,-2.16l0.23,-3.74l2.73,-2.36l7.79,-0.46l2.79,-1.81l0.92,-1.24l0.04,-1.63l1.15,-4.83l-2.3,-3.63l-0.78,-4.8l-1.21,-1.82l-2.06,-0.22l-54.42,0.68l-30.23,-5.73Z",name:"Salta"}},height:1775.5897460258225,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","asia_mill",{insets:[{width:900,top:0,height:555.5409752358405,bbox:[{y:-6895749.143810256,x:2858903.2260101754},{y:1365383.966806244,x:16242290.106516164}],left:0}],paths:{BD:{path:"M468.23,273.61l0.71,0.28l0.58,-0.17l1.03,-2.27l3.07,-0.06l0.75,-0.99l-1.01,-0.97l-0.42,-1.03l-2.11,-0.48l-1.82,-1.98l-1.04,-0.37l0.36,-1.52l2.2,-2.38l-0.03,-0.74l-0.59,-0.55l1.28,0.98l0.67,1.23l1.03,0.3l1.31,0.04l0.39,-0.56l-0.29,-0.74l1.12,2.32l1.6,0.95l1.55,0.0l0.55,-0.72l0.06,-0.94l0.91,1.84l-0.18,4.52l0.45,0.95l4.71,1.15l12.05,-0.09l2.87,1.64l-1.68,-0.08l-1.11,3.94l-1.09,0.36l-0.53,1.16l-0.92,-0.13l-1.3,0.83l-1.65,0.27l-1.04,1.45l-0.55,2.17l1.25,4.63l0.87,0.36l0.23,-0.76l0.39,0.99l1.03,0.54l1.43,-0.82l0.06,-1.92l1.33,-1.61l-0.02,-1.25l1.1,-0.2l0.56,0.3l0.57,2.45l0.21,3.12l0.98,1.98l0.95,10.27l-1.52,-0.91l-0.91,0.13l-0.83,1.18l0.19,1.46l-0.37,-0.53l-0.38,-4.02l-1.31,-4.1l0.26,-0.9l-0.55,-0.43l-0.24,0.13l-1.76,-2.79l-0.59,-1.56l-2.33,1.96l-1.63,0.27l-1.96,-3.12l-0.37,-4.39l-0.56,-0.29l-0.45,0.36l-0.06,0.92l-1.76,-0.24l-0.44,0.23l0.12,0.48l0.92,0.7l1.01,0.22l0.34,0.42l0.02,0.68l-0.97,0.9l0.32,0.89l-0.51,0.67l-0.05,0.75l0.49,1.55l0.74,1.1l-0.04,1.05l-1.67,1.56l-1.04,1.67l-0.41,-0.63l0.95,-1.34l0.03,-0.48l-0.94,-0.02l-1.11,0.67l-0.25,-1.52l0.63,-1.15l-0.09,-0.5l-0.51,-0.01l-0.91,0.83l-0.49,3.08l-1.12,0.91l-0.6,-3.09l-0.39,-0.32l-0.5,0.81l0.23,2.33l-0.91,1.25l-0.47,0.01l-0.88,-0.99l-0.34,-3.13l-0.94,-2.74l-0.52,-3.11l0.52,-1.04l-0.11,-0.49l-1.5,-0.56l0.17,-1.34l-1.2,-1.65l0.96,-2.52l0.18,-2.32l-0.78,-0.65l-1.19,-0.22l-1.51,-1.02l-0.65,0.08l-0.78,-0.54l-0.29,-0.57l0.77,-1.7ZM492.82,292.48l0.02,0.04l-0.02,-0.03l0.0,-0.01ZM490.12,294.53l0.06,-0.71l0.06,0.24l-0.11,0.47ZM486.34,295.46l0.98,-1.76l-0.25,-1.76l-0.63,-0.69l-0.22,-1.31l1.7,2.68l-0.27,2.27l-0.25,0.35l-1.07,0.23Z",name:"Bangladesh"},MN:{path:"M465.38,65.23l0.89,-0.91l-0.34,-1.28l0.62,-0.06l1.36,-0.89l0.63,-1.89l2.96,-0.29l1.6,0.36l0.59,-0.65l0.58,0.39l1.04,-0.28l0.59,-0.33l0.38,-0.81l1.04,0.09l2.05,-1.05l0.37,-0.57l-0.19,-1.38l2.27,-0.66l0.58,-1.07l4.59,-1.32l0.78,-0.78l1.87,-1.05l2.78,-0.49l3.01,-2.22l2.88,-0.07l1.04,-1.55l2.11,1.67l0.67,-0.01l0.8,-0.92l0.67,0.01l0.42,1.04l1.07,0.72l8.35,0.44l0.71,3.17l2.29,2.08l2.21,-0.2l1.29,1.02l2.11,-0.02l1.12,0.3l2.16,-0.99l1.09,0.49l0.76,-0.36l1.92,0.95l4.87,0.16l1.67,1.45l1.56,-0.13l1.37,-1.0l0.41,-0.68l1.71,-0.25l1.36,-0.75l0.85,-0.75l1.1,-2.2l0.25,-2.54l-1.91,-1.23l-0.53,-1.95l-0.94,-1.28l0.05,-0.46l0.57,-1.2l0.23,-1.64l0.63,-0.95l1.29,-0.51l0.99,-2.1l2.22,-0.91l1.25,-1.62l0.49,-1.34l0.6,0.61l2.94,1.23l2.31,0.52l1.62,1.19l4.13,0.3l6.74,2.7l1.5,-0.12l3.88,1.08l0.63,4.99l0.71,1.02l-0.09,1.5l0.6,0.53l0.85,0.15l1.69,1.38l3.6,0.96l1.12,0.89l2.42,0.6l1.42,-0.35l2.09,0.2l0.92,-0.22l2.0,-1.27l4.65,-0.82l2.11,-0.81l3.62,0.66l2.55,0.98l3.66,-0.08l3.83,3.12l5.14,0.45l-0.06,2.11l0.27,0.58l3.44,2.64l1.66,0.76l4.72,-0.1l7.17,1.59l1.72,-0.47l1.38,0.73l0.9,-0.0l4.66,-2.03l5.53,-0.68l3.09,-1.04l1.45,0.23l1.07,-0.2l1.83,-0.89l0.96,-1.85l2.96,-1.98l5.22,-2.55l3.2,0.36l1.84,0.88l2.02,1.84l1.38,0.6l2.35,0.12l3.03,-1.24l1.43,0.3l1.44,0.54l0.71,0.62l-4.84,9.93l-1.54,2.03l-0.25,2.98l-1.78,1.03l-0.19,0.39l0.24,1.78l0.55,0.9l2.15,1.83l1.08,-0.17l1.76,-1.38l1.99,0.18l1.85,-0.29l2.16,0.57l2.17,1.49l3.44,-3.22l2.57,-0.35l2.54,0.41l1.8,2.03l2.38,0.99l0.65,1.24l0.93,0.52l1.8,2.04l1.36,0.99l0.52,1.52l0.76,1.05l-0.01,1.06l-1.13,0.84l-2.67,-0.08l-3.79,-1.36l-0.93,0.6l-2.89,-0.2l-1.99,0.49l-1.2,0.45l-1.18,0.92l-1.41,-0.65l-1.01,0.08l-0.42,0.37l-0.4,1.72l-3.39,-0.28l-2.33,0.96l-2.4,3.23l-0.39,0.71l-0.06,1.29l-1.88,0.99l-1.87,1.53l-3.74,0.61l-1.74,0.11l-1.43,-0.38l-1.43,0.3l-1.21,1.84l-2.52,2.13l-3.44,1.97l-6.46,-1.24l-2.32,-1.64l-3.93,-0.05l-1.35,1.02l-0.99,1.34l-1.71,4.41l0.96,1.92l2.38,2.38l0.66,1.54l-1.14,0.39l-1.55,1.43l-4.17,1.53l-4.52,5.09l-7.72,2.96l-4.84,0.2l-3.84,-0.28l-10.6,1.44l-11.84,4.97l-1.46,1.22l-0.95,-0.4l-2.3,-0.1l0.0,-1.59l-0.48,-0.39l-5.77,1.1l-4.75,-2.26l-6.83,-1.36l-1.26,-0.48l-2.32,-2.54l-1.39,-0.42l-3.06,-0.12l-8.31,-1.14l-3.92,0.98l-16.87,-2.0l-6.05,0.61l-0.42,-1.63l-3.28,-3.13l-0.15,-1.01l-2.38,-5.24l-1.45,-0.72l0.29,-1.8l-0.2,-0.51l-2.52,0.02l-2.39,-0.79l-2.56,-1.53l-1.19,-1.11l-1.93,-0.36l-2.15,-2.01l-1.23,-0.49l-5.48,-0.85l-2.76,0.24l-2.97,-0.55l-3.26,-0.07l-1.18,-0.45l-0.88,0.06l-1.89,-0.9l-1.14,0.11l-1.48,-2.67l0.33,-1.69l2.14,-2.77l0.03,-0.89l-0.63,-1.57l0.87,-2.78l-0.36,-1.84l-0.87,-1.94l-1.26,-0.64l-1.54,-2.5l-0.52,-2.03l-0.88,-1.72l-1.6,-0.72l-0.81,-1.38l-0.52,-0.08l-1.29,0.57l-1.61,-1.67l-1.89,-0.23l-1.51,0.36l-3.73,-2.07l-0.11,-0.9l-0.63,-0.83l-3.77,-1.57l0.57,-0.74l-0.01,-0.67l-1.71,-0.88l-0.5,-0.67Z",name:"Mongolia"},BN:{path:"M669.68,427.4l0.73,0.87l0.54,2.47l-0.75,-0.21l-0.52,-3.13ZM663.3,429.66l2.55,-1.0l3.15,-2.12l-2.11,1.53l0.21,2.24l0.34,0.55l-0.41,1.43l-0.75,0.81l-1.24,-1.48l-0.84,-0.24l-0.9,-1.73Z",name:"Brunei"},BH:{path:"M186.05,263.08l0.03,-0.01l0.0,0.12l-0.03,-0.12ZM186.08,263.2l0.33,0.5l-0.01,1.54l-0.25,-0.46l-0.07,-1.59Z",name:"Bahrain"},BT:{path:"M479.26,258.41l-0.68,-0.6l-1.59,-0.42l-1.49,0.21l-0.67,-0.33l-1.21,-0.69l-0.18,-0.78l-0.61,-0.7l0.98,-0.78l0.47,-1.27l1.11,-1.01l0.49,-1.02l2.35,-2.77l2.96,-1.79l1.35,-0.05l1.57,0.4l-0.19,0.88l0.51,0.52l2.68,0.07l2.39,0.83l1.8,-0.86l2.35,0.97l-0.39,2.29l0.21,0.81l1.39,1.06l1.61,-0.11l0.49,0.91l-0.62,1.49l0.57,1.2l-0.19,0.44l-2.46,0.43l-0.91,-0.03l-0.85,-0.49l-1.14,0.61l-4.0,0.16l-3.09,-0.93l-1.21,0.46l-0.53,0.64l-3.27,0.27Z",name:"Bhutan"},HK:{path:"M661.58,292.96l0.56,-0.57l0.79,-0.15l0.37,0.12l0.23,0.69l-0.18,0.38l-1.77,-0.47Z",name:"Hong Kong"},JO:{path:"M73.44,221.31l0.32,-1.94l0.71,-1.81l-0.18,-2.7l0.4,-4.54l0.81,-0.34l0.91,0.11l1.09,1.36l1.36,0.46l1.2,0.92l3.65,0.53l14.19,-8.55l1.88,6.47l-0.46,0.56l0.45,1.39l0.49,0.26l1.18,-0.3l0.12,0.32l-2.13,1.8l-14.99,4.17l-0.18,0.66l7.3,7.79l-2.14,1.24l-1.23,2.64l-5.25,1.04l-0.54,0.35l-1.77,2.81l-2.92,2.3l-7.72,-1.2l0.79,-4.67l0.53,-1.3l0.03,-2.42l2.2,-5.75l-0.11,-1.66Z",name:"Jordan"},PS:{path:"M69.37,220.61l0.5,-1.44l1.93,-1.52l-0.75,-0.82l-0.89,-0.22l-0.2,-2.28l0.38,-1.39l0.34,-0.86l0.71,-0.46l1.04,0.19l1.21,0.91l0.0,4.78l-0.74,2.04l-2.36,0.96l-1.18,0.1ZM64.36,221.37l0.26,-0.24l-0.2,0.39l-0.05,-0.15Z",name:"Palestine"},LB:{path:"M71.41,206.16l3.41,-7.3l0.31,-1.87l1.06,-1.44l1.32,-0.97l0.1,-0.56l2.44,-0.29l-0.58,1.07l1.36,0.72l0.51,1.51l-0.27,0.54l-1.73,1.43l-0.21,0.89l-1.1,0.06l-1.03,0.79l-0.41,0.85l0.43,0.87l-1.83,1.74l-1.46,0.66l-0.46,1.19l-0.37,0.22l-1.46,-0.12Z",name:"Lebanon"},LA:{path:"M558.12,308.97l0.8,-2.48l0.9,-0.56l1.21,-0.03l0.58,-0.32l0.14,-0.59l-0.68,-0.32l0.06,-0.31l0.54,-0.46l0.92,-1.8l1.27,-0.46l1.32,-0.98l0.33,1.83l0.41,0.49l2.23,-0.25l1.45,0.64l0.79,-0.52l0.23,-0.51l-0.59,-0.81l0.09,-3.9l-1.05,-1.43l-0.46,-1.67l1.09,-1.67l0.5,0.65l1.96,-0.09l2.85,3.44l0.75,0.49l0.74,1.87l0.55,0.12l0.79,-0.61l0.59,0.27l-0.72,3.25l2.08,3.11l4.25,1.55l3.34,-1.92l3.23,2.09l-1.48,1.18l0.07,0.59l1.87,0.54l0.4,1.12l1.34,0.22l0.42,0.91l-1.29,1.97l-1.05,0.95l-2.28,-0.55l-2.03,0.27l-0.16,0.6l0.32,1.04l-1.08,0.87l-0.12,0.82l6.31,4.01l3.0,0.99l-0.42,1.03l0.28,0.95l1.72,1.75l0.92,0.28l0.85,1.15l0.86,2.02l2.37,2.5l1.98,1.54l1.67,1.97l0.28,2.13l0.96,1.49l0.83,0.4l0.66,-0.34l0.63,1.05l3.36,2.31l-1.56,1.09l-0.2,0.64l0.94,1.54l2.13,1.74l0.53,0.81l-1.24,1.92l0.26,2.05l-0.64,0.9l-0.88,-0.18l-1.3,1.28l-0.72,0.04l-0.59,0.63l-0.63,0.09l-2.18,-1.88l-0.59,0.03l-0.89,0.79l-0.78,-0.14l-0.68,0.79l-1.22,0.15l-0.43,0.59l1.04,2.11l-0.26,0.59l-0.82,-0.02l-1.24,-1.21l-1.56,-0.54l-1.34,0.34l-0.62,-0.55l-0.32,-0.6l1.56,-0.89l0.71,-1.11l0.39,-2.8l-0.42,-2.39l0.93,-1.73l0.17,-1.54l-0.28,-0.5l-1.57,-0.92l-0.05,-1.29l-2.57,-1.25l-0.75,-1.37l-0.96,-0.96l-0.46,-1.25l-0.05,-1.74l0.51,-3.38l-0.65,-1.35l-2.34,-1.84l-3.57,-4.78l-1.35,-0.09l-2.3,-0.79l-1.67,0.07l-0.48,0.38l-0.07,0.74l-1.19,1.15l-0.3,0.82l-1.62,0.51l-1.04,0.72l-0.47,-0.8l-1.53,-0.65l-1.54,-1.23l-0.79,-0.06l-1.18,1.01l-1.29,0.38l-0.67,1.12l-2.05,1.33l-1.8,1.65l-1.16,-0.32l1.6,-4.28l-0.05,-1.21l-0.67,-1.09l0.86,-1.3l0.92,-2.92l-0.66,-2.72l0.1,-1.75l-0.63,-0.53l-1.54,-0.29l-1.85,0.75l-0.71,0.09l-0.67,-0.33l-0.57,-0.57l-0.12,-0.62l1.05,-2.53l-0.19,-0.97l-1.62,-1.77l-0.72,-0.02l-0.52,0.36Z",name:"Lao PDR"},TW:{path:"M709.3,291.82l-1.83,-4.59l0.51,-1.89l-0.08,-2.0l3.67,-6.43l3.03,-4.34l3.7,-1.83l2.14,1.56l0.09,0.35l-0.77,1.26l0.06,2.28l-1.59,3.77l-1.03,5.01l-0.91,2.74l-2.57,3.52l-0.85,1.94l-0.35,3.19l-0.44,-0.46l-0.11,-1.02l-0.74,-1.59l-1.92,-1.47Z",name:"Taiwan"},TR:{path:"M7.99,161.66l1.03,0.22l1.78,-0.37l0.63,-0.86l-1.88,-0.41l-0.87,-1.59l0.93,-0.42l0.78,-0.97l-0.38,-0.84l-1.04,-0.26l0.22,-1.4l-1.11,-1.38l1.53,-1.64l-0.01,-0.66l-0.98,-0.39l-5.01,0.73l0.43,-1.17l0.14,-2.62l0.96,-0.37l3.02,-3.17l1.89,0.03l0.94,-0.5l0.88,-0.02l0.41,0.66l1.26,0.53l2.03,-0.11l0.96,-0.5l0.06,-0.48l0.2,0.52l0.44,0.12l2.4,-0.29l5.37,0.12l0.62,-0.4l-0.05,-0.64l-1.48,-0.65l0.7,-0.47l6.52,-0.93l0.35,-0.33l-0.36,-0.66l-4.21,-0.72l-1.38,-1.17l0.51,-1.42l5.55,0.63l3.22,-0.4l3.54,0.99l3.33,-0.2l1.01,-0.65l0.77,-1.35l4.6,-2.35l1.66,-1.26l7.24,-2.43l10.86,0.44l1.96,-0.93l0.54,0.16l-0.03,1.2l1.48,1.59l2.21,0.87l2.62,-0.69l0.67,0.19l0.96,2.25l1.79,1.43l0.93,0.16l1.2,-0.81l0.79,-0.08l1.41,0.69l0.74,0.89l5.19,0.94l1.14,0.69l3.53,0.69l7.87,-1.6l2.82,1.08l2.54,0.35l1.02,-0.16l6.24,-2.71l2.51,-1.47l0.64,-0.71l2.14,0.68l0.98,-0.56l3.85,0.49l1.25,-1.25l0.91,0.03l0.44,0.73l2.22,1.53l0.02,0.52l0.51,0.51l1.61,0.31l0.22,0.85l1.28,1.16l0.57,2.17l-1.04,1.78l0.93,2.48l-0.04,0.84l2.19,0.95l2.59,-0.14l2.28,1.66l-1.27,0.98l-0.54,2.14l-2.31,0.12l-0.46,0.66l0.51,1.54l0.64,0.58l-0.24,1.25l0.2,0.53l0.71,0.9l0.23,3.83l1.0,0.49l-1.64,3.72l0.43,0.51l0.73,0.06l1.56,1.01l-0.24,0.46l0.21,1.92l1.62,1.39l-0.23,0.51l-0.93,-0.02l-2.34,1.61l-0.2,-2.01l-0.87,-0.72l-0.84,-0.11l-1.42,0.77l-1.09,-0.03l-4.28,-1.2l-1.3,0.34l-1.32,-0.37l-2.72,2.18l-0.63,-1.23l-0.91,-0.31l-1.16,0.82l-3.93,0.97l-6.05,-0.08l-5.27,2.36l-4.83,1.22l-4.33,-0.1l-2.35,-1.43l-1.98,-0.36l-5.77,2.22l-2.57,-0.08l-0.96,-0.89l-2.18,-0.39l-0.64,0.48l-0.7,2.82l0.69,1.64l-1.76,0.56l-0.32,1.45l-0.99,0.56l-0.34,0.73l-1.01,-0.55l0.15,-0.53l-1.01,-2.49l2.77,-3.03l-0.16,-1.54l-1.04,-0.94l-0.43,-0.04l-2.94,1.62l-0.88,1.05l-0.89,0.15l-4.31,-1.91l-1.02,-0.13l-3.12,1.87l-2.57,2.64l-1.88,0.93l-5.61,0.72l-1.03,0.48l-1.75,-0.5l-1.08,-0.65l-2.65,-2.99l-5.1,-2.34l-5.46,-0.6l-0.89,0.96l-0.17,2.23l-0.71,2.0l-1.51,-0.37l-3.86,1.25l-3.28,-1.34l-0.48,-0.5l-0.77,-2.47l-0.76,-0.44l-1.22,0.32l-2.38,-1.06l-1.51,-0.11l-1.53,1.41l0.18,-0.25l-0.34,-0.64l-0.34,0.02l1.78,-1.56l0.13,-0.28l-0.36,-0.57l-7.0,0.23l0.11,-0.26l1.71,-0.35l0.29,-0.44l-0.31,-1.03l-2.07,-1.09l-0.87,-2.1l0.93,-0.51l0.06,-2.34l-2.86,-1.01l-1.45,-1.17l-1.04,0.34l-1.56,-0.72l0.81,-0.68l0.07,-0.85l-0.38,-1.15l0.83,0.48l0.08,1.22l0.49,0.71l0.25,0.15l0.66,-0.5ZM15.22,175.57l-0.41,0.2l-0.33,-0.03l0.31,-0.13l0.43,-0.04ZM16.6,143.61l0.01,-0.05l-0.46,-0.47l0.7,0.08l-0.24,0.44ZM3.34,140.98l2.15,-2.44l-0.15,-2.09l1.72,-0.87l0.46,-0.67l-0.31,-2.04l-1.93,-1.23l1.34,-0.44l0.56,-1.08l2.01,-0.26l1.03,-0.61l1.74,-0.22l1.82,1.43l3.3,-0.46l-0.1,0.85l0.47,1.13l1.24,1.74l1.18,0.83l5.0,2.06l-0.52,1.31l-1.07,0.25l-4.52,-0.94l-1.96,0.79l-1.34,-0.18l-1.86,0.36l-1.98,2.61l-3.22,1.51l0.3,-0.41l-0.33,-0.64l-4.89,0.12l-0.18,-0.41ZM7.44,143.02l-1.73,1.59l-1.03,1.2l0.09,-1.2l1.25,-0.99l1.41,-0.61ZM0.74,145.85l0.89,-0.3l0.19,0.13l-1.08,0.17Z",name:"Turkey"},LK:{path:"M405.27,403.82l0.63,-0.48l0.31,-2.67l0.69,-2.19l-0.1,-1.45l1.26,-2.36l0.05,-2.28l1.32,0.61l0.71,-0.1l0.29,-0.53l1.52,1.26l1.62,2.89l0.68,0.41l1.3,1.94l0.18,1.09l1.12,0.66l0.37,2.11l1.82,2.76l1.26,2.7l0.27,0.91l-0.09,2.77l-1.05,2.78l-2.37,1.92l-4.81,1.92l-1.57,0.21l-1.55,-0.41l-1.15,-0.96l-1.7,-4.93l-1.0,-8.59ZM409.2,391.24l-1.76,-0.39l-0.41,-0.44l1.57,0.08l0.6,0.76Z",name:"Sri Lanka"},TL:{path:"M743.75,531.36l1.77,-2.37l1.4,-0.5l3.12,-0.62l6.11,-0.25l2.56,-1.05l1.81,0.43l-2.38,1.79l-1.88,0.51l-1.38,1.0l-2.37,0.62l-1.6,0.93l-4.02,1.15l-2.18,1.48l-0.65,-1.32l0.98,-0.19l0.44,-1.35l-0.59,-0.65l-1.14,0.38ZM737.32,534.04l0.79,-0.42l1.17,-0.31l-0.74,0.83l-1.22,-0.09Z",name:"Timor-Leste"},TM:{path:"M203.1,134.81l-0.97,-1.38l-0.75,-1.96l2.58,-2.29l1.35,-0.76l-1.16,0.96l-1.2,2.45l0.48,0.84l-0.32,2.14ZM206.04,128.16l3.88,-1.05l3.1,-0.34l5.29,3.23l2.91,4.49l1.91,1.78l0.68,0.13l2.88,-0.54l8.07,0.54l1.16,-1.25l-0.76,-0.98l-0.26,-2.09l0.85,0.12l1.5,1.43l2.63,-0.58l1.07,-0.61l0.51,-0.81l-0.12,-0.87l-1.1,-0.81l-0.57,-1.62l1.36,-0.37l1.43,-2.54l1.56,0.47l0.76,1.14l1.07,0.04l0.16,-0.96l-2.22,-2.29l2.06,-0.02l0.81,-0.77l1.85,1.68l2.07,0.43l0.74,1.24l0.76,0.47l3.79,0.28l0.85,0.67l-0.35,2.11l1.55,0.99l-0.65,0.67l0.44,1.43l-0.5,1.54l0.38,0.61l2.88,1.63l3.07,-0.24l2.91,0.53l0.65,-0.05l1.18,-0.72l1.0,0.29l1.8,1.21l1.39,3.57l2.06,3.05l0.85,3.23l7.75,5.38l1.95,1.91l3.03,1.84l1.19,-0.12l2.24,1.84l7.43,4.52l2.76,-0.01l3.1,1.66l1.36,0.35l0.19,0.22l-0.77,1.34l-0.06,3.42l-2.52,-0.56l-2.87,-1.32l-1.09,1.01l-0.59,1.71l-3.23,0.11l-2.21,0.96l-2.42,6.9l-1.05,0.9l-1.93,0.94l-0.56,0.81l-1.11,0.03l-4.14,1.3l-1.34,0.12l-0.43,0.76l0.37,0.94l-0.74,1.84l-2.56,1.51l-1.65,0.02l-1.01,0.51l-0.49,-0.76l-1.74,-1.33l-2.84,0.04l-1.86,-1.54l-0.71,-0.1l0.1,-1.7l-0.68,-1.07l0.38,-0.89l-0.32,-4.03l-0.44,-0.84l-6.02,-0.15l-1.99,-2.71l-4.53,-2.48l-0.55,-0.59l-0.67,-1.69l-3.71,-1.53l-1.3,0.25l-0.99,-0.27l-1.02,0.41l-0.75,-0.21l-2.17,-1.45l-4.57,-1.19l-0.25,-1.22l-1.0,-0.91l-5.86,-0.35l-1.13,0.6l-0.29,0.89l-5.02,-0.19l-1.6,0.44l-3.74,2.45l-1.46,2.63l-3.62,1.13l-1.71,-0.08l-0.61,-4.69l0.33,-8.95l-1.59,-2.61l-2.68,-1.14l-1.3,0.25l0.55,-1.59l1.9,0.43l0.79,-0.12l0.32,-0.51l-0.29,-0.73l-0.73,-0.5l0.06,-2.12l-0.93,-0.58l-3.08,-0.24l-0.51,0.58l-0.94,-2.3l-0.07,-1.47l1.32,-4.71l1.22,1.25l1.6,0.4l1.86,-0.34l0.99,1.22l1.24,0.3l2.26,-0.61l1.46,0.23l0.32,-0.57l-0.35,-0.92l1.37,0.24l1.14,-0.41l0.37,-0.43l0.06,-1.24l-0.39,-1.08l-0.65,-0.72l-2.36,-1.57l-1.3,-1.27l-1.97,-5.25l-1.88,-0.49l-3.37,0.39Z",name:"Turkmenistan"},TJ:{path:"M312.6,153.86l0.49,-1.67l0.75,-0.73l1.15,-0.49l4.28,0.72l1.47,-0.06l0.98,-0.92l0.43,-1.72l0.68,-0.04l1.02,-0.65l0.05,-0.52l-0.48,-0.67l1.1,-0.28l0.2,-0.47l-0.55,-0.7l2.53,0.2l0.5,-1.43l-0.62,-2.01l0.6,-0.54l0.29,-1.15l0.59,0.04l1.33,0.95l0.68,0.04l4.34,-2.09l0.69,-1.18l1.41,1.4l0.16,0.81l0.48,0.2l-2.49,2.0l-0.24,0.95l0.31,0.46l1.01,0.36l0.69,1.04l0.79,0.09l-0.57,0.34l-0.55,1.08l-0.56,-0.81l-3.63,-1.35l-3.51,0.92l-0.7,0.87l0.01,0.65l-0.71,-0.36l-0.52,0.2l-0.23,0.5l-0.38,1.42l0.51,2.2l0.44,0.36l2.29,-0.43l2.59,0.18l1.71,-0.22l0.58,0.29l1.77,-0.37l0.57,0.13l0.89,1.24l0.85,0.31l1.54,-0.15l0.69,-0.8l2.64,-0.87l0.14,1.01l1.56,0.42l-0.06,0.72l0.58,0.64l0.59,0.04l1.42,-0.63l1.34,1.18l0.41,0.04l0.98,-1.13l1.43,-0.33l4.05,0.14l2.7,-0.86l0.79,0.04l-0.15,1.79l1.41,2.05l-0.78,0.93l0.93,2.59l1.55,0.72l0.72,-0.27l0.58,-0.82l0.9,0.0l3.72,1.57l-0.34,2.11l1.2,3.66l-0.24,1.67l1.57,1.55l-1.23,0.9l-1.56,-1.23l-3.22,-0.24l-0.9,0.78l-2.94,0.8l0.31,-0.94l-0.4,-0.66l-2.66,-0.38l-3.85,1.77l-1.04,0.82l-0.75,1.19l-2.16,0.4l-4.14,2.46l-0.73,-0.02l-0.79,-1.05l-0.7,-2.31l1.11,-6.72l-0.64,-0.61l-1.63,0.26l0.38,-1.82l-0.6,-1.47l-1.67,-1.13l-1.62,-0.38l-1.22,0.38l-0.9,0.77l-1.53,2.3l-1.6,1.44l0.26,2.26l-0.36,0.54l-0.71,0.2l-0.83,-0.46l-0.97,-0.08l-2.56,0.51l-0.8,0.87l-0.03,2.31l-0.63,0.6l-2.15,-1.75l-0.7,-0.14l-0.87,0.62l-0.93,0.03l-2.25,1.1l-0.9,0.97l-1.34,0.56l-0.57,-0.13l-1.25,-1.25l0.38,-2.72l3.53,-4.61l0.49,-1.81l-1.99,-2.39l-0.27,-1.51l0.72,-1.85l-0.39,-1.0l-0.72,-0.35l-2.42,-0.06l-0.36,-1.16l-2.04,-0.68Z",name:"Tajikistan"},TH:{path:"M537.74,324.01l2.04,-0.59l0.45,-0.42l-0.28,-2.76l0.73,-1.57l0.08,-2.38l1.18,-1.35l0.27,-0.79l1.75,0.63l4.69,-0.67l0.85,-0.91l0.34,-1.57l0.78,-0.19l1.13,0.28l1.04,-0.35l0.57,-0.75l-0.14,-0.95l1.52,0.11l1.48,-0.7l0.99,0.61l0.38,0.69l0.44,-0.05l0.96,-0.98l1.39,1.65l-1.06,2.91l0.28,1.07l0.7,0.71l1.17,0.53l1.0,-0.15l1.15,-0.68l1.82,0.3l-0.13,1.56l0.65,2.57l-0.87,2.67l-0.9,1.41l0.67,1.48l0.03,0.9l-1.74,4.23l0.45,0.78l1.2,0.54l0.78,-0.12l4.07,-3.13l0.69,-1.12l1.14,-0.27l1.06,-0.94l1.58,1.2l1.52,0.65l0.32,0.84l0.8,0.31l1.15,-1.0l1.89,-0.68l0.79,-1.54l0.91,-0.51l0.04,-0.84l1.24,-0.05l2.26,0.78l1.17,0.08l2.58,3.67l3.09,2.7l0.49,1.06l-0.52,3.18l0.05,1.82l0.54,1.52l1.05,1.09l0.81,1.45l2.36,1.1l-0.1,0.63l0.34,0.79l1.66,1.09l-0.17,1.07l-0.78,1.05l-0.17,0.77l0.4,2.55l-0.48,2.9l-2.18,1.37l-0.64,0.74l-0.46,-1.02l-1.49,-0.49l-6.07,0.52l-2.88,-0.48l-3.04,0.68l-1.37,0.65l-1.02,0.96l-1.4,2.3l-1.3,1.31l-0.09,0.53l-1.54,0.29l-0.11,2.45l0.98,2.09l0.27,2.51l1.86,1.89l-0.26,1.54l-0.86,-0.06l-0.14,0.32l-1.06,-0.8l-0.59,-1.02l-0.56,0.06l-1.2,-1.2l-2.43,-1.27l-2.27,0.49l-2.58,-0.4l-1.21,0.26l0.58,-5.56l-0.62,-0.66l-2.72,-0.77l-0.4,0.33l-3.09,0.59l-1.02,0.94l-0.2,0.84l0.71,1.59l-0.91,2.64l0.19,3.93l-1.05,1.63l-0.35,1.5l-1.27,2.17l-1.08,4.38l-1.47,2.35l-0.92,2.27l-0.07,4.25l0.92,2.45l-0.22,1.06l0.22,0.41l1.15,0.42l2.57,-0.74l0.54,0.13l1.06,5.07l1.12,1.35l0.69,-0.03l1.1,4.65l-0.71,-0.32l-0.96,0.72l0.38,1.87l1.85,2.56l1.25,0.14l3.14,2.29l2.99,-0.24l1.37,0.96l1.45,2.16l1.99,1.54l-0.2,0.8l-1.73,2.19l-0.57,0.01l-0.62,-0.83l-0.58,-0.14l-2.26,0.9l-0.77,1.07l-0.71,-0.69l0.68,-1.21l-0.18,-2.32l-0.75,-0.38l-0.78,0.05l-0.54,-1.24l-0.66,-0.46l-0.85,0.18l-1.85,-0.67l-0.86,-1.07l-1.03,0.3l-0.26,1.05l-1.38,-1.7l-1.18,-0.89l0.16,-1.5l-1.21,-0.97l0.27,-0.83l-0.53,-0.49l-1.31,-0.03l-0.73,-1.83l-0.6,-0.75l-0.9,-0.15l-0.12,-1.17l-1.94,-1.31l-0.71,-1.5l-1.29,-0.72l-0.59,0.2l-0.76,0.98l-0.68,-1.48l0.03,-2.42l0.63,-1.55l0.33,-2.39l2.81,-8.01l0.09,-2.34l3.14,-3.22l3.28,-5.36l-1.16,-3.29l-0.48,-2.8l-1.36,-1.43l-0.7,-2.18l0.42,-1.38l-0.33,-3.85l-1.57,-2.62l-2.74,-2.39l-2.36,-3.38l-0.3,-1.14l-0.11,-1.46l2.77,-1.37l0.24,-5.08l1.99,-1.43l0.23,-1.3l-0.53,-0.67l-0.48,0.01l-0.77,0.61l-1.26,-2.81l-0.32,-1.92l-5.49,-6.4l0.28,-0.94l-0.82,-2.56l-0.24,-0.48l-0.82,-0.09l-0.57,-0.75ZM559.45,406.63l0.01,0.05l-0.04,-0.01l0.03,-0.04ZM556.62,392.44l0.03,-0.28l0.21,0.01l-0.06,0.19l-0.18,0.08ZM544.21,404.66l-0.1,-0.43l0.18,-0.99l0.21,0.06l-0.29,1.36Z",name:"Thailand"},XC:{path:"M54.11,189.32l0.71,-1.69l3.58,0.38l4.65,-1.22l-1.47,1.07l-0.12,1.43l-1.57,0.62l-1.16,-0.11l-0.33,-0.76l-0.7,-0.35l-1.48,-0.08l-2.13,0.7Z",name:"N. Cyprus"},NP:{path:"M410.28,243.11l-2.55,-1.76l0.5,-1.57l0.84,-0.96l0.17,-1.86l0.43,-1.13l1.67,-2.57l2.53,-2.12l0.36,0.0l0.71,0.97l1.05,0.04l0.69,-0.55l1.13,-1.86l1.45,-0.35l2.74,0.45l1.31,2.1l2.04,1.05l2.81,2.14l1.2,0.53l1.08,0.07l3.06,3.39l1.08,0.07l1.86,-0.7l0.91,0.36l1.07,2.57l4.26,2.86l2.43,-0.32l-0.44,1.39l0.29,0.76l0.99,0.39l3.39,0.13l2.33,2.94l1.09,-0.49l0.13,-1.05l0.41,0.62l1.7,0.81l1.0,-0.37l0.52,-1.03l3.86,2.13l3.7,0.19l1.83,-0.58l1.62,0.11l-1.18,5.52l0.99,1.89l0.33,1.4l-0.85,2.37l-1.11,-0.4l-1.63,0.3l-1.53,-0.18l-1.06,0.47l-1.13,-0.44l-0.63,-1.02l-2.53,0.89l-2.42,-1.08l-2.71,-0.61l-1.59,0.35l-0.56,-1.32l-0.61,-0.49l-0.81,-0.06l-2.2,0.7l-0.76,-0.85l-3.21,-1.41l-0.5,-1.97l-1.16,-0.57l-2.9,-1.14l-1.72,0.42l-0.54,0.41l-2.88,-0.65l-1.06,0.69l-3.82,-1.07l-0.63,-1.31l-1.72,-0.01l-3.45,-1.93l-1.06,0.34l-3.87,-2.4l-1.13,-1.33l-4.32,-2.53l-0.65,-0.19l-0.62,0.45Z",name:"Nepal"},PK:{path:"M269.48,270.83l0.52,-4.2l0.67,-0.75l0.57,-2.85l2.01,-1.0l0.97,-0.08l0.52,-1.04l0.77,-0.46l2.52,-0.65l2.87,-0.06l0.36,-0.47l0.11,-1.17l0.45,-0.39l-0.03,-1.58l0.47,-0.86l-0.52,-0.74l-0.77,-0.41l-2.77,0.13l0.39,-1.76l-0.54,-4.07l0.04,-2.2l-1.6,-0.09l-1.51,-1.37l-3.47,-1.08l-1.91,-1.91l-2.05,-3.71l-0.19,-0.94l-2.65,-2.99l10.89,3.26l8.22,-0.72l3.87,0.84l2.43,-1.24l5.25,-0.12l8.22,-2.31l1.17,-1.25l-0.51,-1.27l0.49,-1.74l-0.13,-2.39l0.42,-1.5l0.32,-0.75l1.44,-0.87l1.7,-1.97l1.13,-0.25l0.74,0.48l1.28,0.21l1.43,-0.15l2.17,-0.92l0.23,-0.41l-0.28,-0.62l-0.84,-0.53l0.92,-0.14l2.08,-1.08l1.11,-1.01l1.85,0.42l1.11,-0.38l1.19,1.17l1.06,0.19l1.7,-0.92l1.54,-1.71l-0.18,-4.32l1.19,-1.99l0.71,-2.75l2.97,-0.66l2.75,-1.73l0.12,-0.99l-1.13,-2.12l-1.89,-2.23l0.09,-0.52l0.46,-0.22l2.4,0.73l2.52,0.08l1.59,-0.27l1.74,-0.77l0.34,-0.78l0.03,-2.08l-0.91,-1.17l2.28,-2.78l1.25,-0.9l1.26,-1.87l-0.52,-1.21l0.4,-0.97l-0.21,-1.16l-1.35,-2.98l-1.47,-1.22l2.92,-2.92l1.05,0.02l3.08,-2.38l3.32,-1.04l8.46,-0.5l2.11,0.54l4.23,-1.81l1.89,0.66l1.45,-0.23l1.96,0.57l0.66,1.53l1.84,-0.02l1.15,0.7l0.89,2.05l-0.04,1.63l-0.48,0.91l0.16,0.54l1.26,0.65l0.79,1.44l0.87,0.06l1.8,-0.54l0.21,0.8l1.45,0.92l1.99,4.42l-0.25,0.7l-1.59,0.77l-1.22,1.27l-1.07,-0.14l-2.06,0.72l-1.13,0.04l-2.35,1.35l-1.72,-0.27l-2.12,-0.88l-1.69,-0.06l-5.08,-0.99l-2.74,1.13l-1.28,2.39l0.11,0.68l1.22,0.82l-0.53,0.92l0.26,0.83l0.45,0.32l1.89,0.13l-1.7,1.09l-0.33,0.76l0.06,0.8l1.21,1.19l-0.19,0.79l-0.96,1.3l0.16,0.78l1.0,1.03l1.2,0.61l0.09,1.56l0.37,0.35l2.14,0.21l0.01,1.64l0.32,0.43l1.07,0.42l1.4,-0.03l1.71,0.69l0.54,0.53l-0.41,0.71l-3.79,1.57l-1.57,1.26l-0.36,1.18l0.6,1.91l-0.55,2.25l0.18,0.66l0.63,0.48l-2.05,1.08l-3.26,3.73l-0.26,0.91l0.35,1.04l-0.24,0.33l-0.5,0.49l-3.35,1.5l-1.12,3.11l-2.36,4.12l-4.24,2.31l-1.61,3.3l-1.4,1.47l-0.56,1.59l-2.17,0.66l-2.71,0.32l-2.75,0.97l-0.54,-0.33l-0.39,-1.18l-0.59,-0.61l-0.85,-0.41l-0.84,0.03l-2.03,1.49l-1.89,3.07l-2.77,2.99l-0.51,2.6l0.37,0.82l1.92,1.06l2.4,0.39l0.41,0.36l-0.14,2.08l-0.42,1.24l0.25,1.53l1.41,1.76l2.65,0.16l0.04,1.91l2.84,5.54l-0.51,1.0l0.38,1.32l-1.88,0.98l-0.72,-0.22l-0.2,-0.99l-0.83,-0.16l-3.03,1.01l-0.66,0.78l-1.39,0.17l-1.84,-0.86l-5.29,0.01l-0.66,-0.31l-0.65,0.61l-0.06,2.13l-3.01,0.31l-1.21,1.0l-0.25,-0.26l-0.77,0.04l-0.58,-0.5l-1.41,0.59l-0.05,-0.45l-0.57,-0.33l-0.36,0.17l-0.45,-0.88l-1.14,-1.08l-1.04,-4.6l-0.84,-0.57l-2.73,-0.5l-0.04,-2.81l-1.28,-2.11l-0.79,-0.73l-0.95,-0.3l-1.12,0.15l-0.56,0.45l-0.14,0.63l-3.17,0.73l-1.97,-0.15l-2.65,0.5l-2.1,0.03l-0.99,0.92l-3.43,-1.07l-0.78,-0.57l-1.09,0.44l-1.53,-0.33l-1.4,0.26l-0.65,0.55l-0.13,0.54l-5.86,-0.39l-2.45,0.99l-1.15,-0.64l-0.84,0.54l-1.21,0.17l-1.92,-0.28Z",name:"Pakistan"},PH:{path:"M728.0,406.82l-0.36,-1.38l-0.85,-0.45l-0.93,0.16l-1.15,1.02l-2.46,5.15l-0.73,-0.16l-0.33,-0.59l0.11,-0.69l0.93,-1.32l0.61,-3.27l0.76,-0.92l0.9,-0.65l4.06,-0.9l0.64,-0.48l0.18,-1.27l0.58,-0.71l1.78,-0.64l0.67,-0.86l1.5,0.51l1.05,1.19l0.18,1.61l-0.78,0.77l0.18,0.69l0.35,0.07l3.3,-1.43l1.49,-2.74l1.27,0.56l1.14,-0.29l0.99,-3.03l1.85,0.74l0.43,-0.17l0.47,-1.0l1.03,0.24l0.92,-0.17l0.58,-1.41l-0.86,-3.85l0.23,-0.35l2.55,1.76l0.99,1.46l0.61,0.45l0.63,0.02l0.02,0.82l0.91,1.89l-1.33,1.93l0.36,0.57l1.35,0.53l0.09,1.0l0.58,1.01l-0.17,2.72l1.02,1.26l0.13,2.5l-1.03,2.12l-1.88,1.25l0.29,1.17l-0.14,1.8l-0.55,-2.81l-1.64,-3.69l-0.84,-0.17l-0.91,0.67l-0.34,1.13l-1.8,2.36l-0.19,0.91l0.45,0.91l1.14,1.03l0.58,1.69l-0.02,1.68l-1.46,2.17l-0.55,0.33l-0.44,-1.09l0.26,-1.7l-0.39,-0.57l-0.86,0.04l-1.06,1.35l-0.53,-0.03l-5.2,-2.61l-0.91,-1.16l-0.67,-4.15l1.48,-1.94l0.23,-0.75l-0.31,-1.0l-1.65,-1.77l-2.44,-1.24l-0.93,-0.12l-0.84,0.47l-0.61,2.56l-1.07,-0.63l-0.58,-1.24l-0.67,0.04l-0.67,0.99l-0.69,0.09ZM751.98,389.95l-0.18,-0.26l0.18,-0.69l0.14,0.94l-0.14,0.0ZM745.51,369.73l0.42,0.49l0.16,1.05l1.39,0.75l-0.5,1.78l0.06,1.37l0.32,1.81l0.73,1.51l-0.22,0.62l0.63,0.5l-2.56,-0.11l-0.47,-0.75l-0.93,-0.6l-0.74,-1.33l0.4,-0.56l0.14,-1.09l-0.98,-0.39l-1.49,-1.79l-1.73,-1.01l-0.94,-2.42l1.55,0.24l4.29,-0.34l0.49,0.25ZM748.54,386.17l-0.11,0.68l0.34,1.55l-0.61,-0.86l0.39,-1.37ZM739.46,377.82l1.66,1.21l0.85,-0.07l0.75,-0.56l0.45,0.12l0.62,1.05l-0.07,3.26l1.13,1.12l0.7,2.2l-0.69,0.15l-0.74,-0.82l-0.65,0.35l0.22,1.71l-0.96,-0.38l0.05,-1.08l-0.37,-0.87l0.42,-1.7l-0.12,-1.02l-0.99,-1.46l-0.64,-0.13l-0.92,0.39l-0.72,-3.46ZM741.83,394.7l0.21,0.21l0.02,0.05l-0.32,-0.14l0.09,-0.12ZM738.84,387.8l1.52,0.83l0.11,1.43l-0.73,0.19l-0.69,0.75l-1.65,0.22l-1.56,-0.43l-0.3,-0.72l0.22,-0.29l1.36,-0.84l0.84,-1.0l0.88,-0.14ZM740.7,376.89l-0.46,0.02l-0.5,-0.74l0.4,0.01l0.56,0.71ZM738.03,358.15l1.13,1.2l-0.08,1.14l-1.32,0.79l-0.56,-0.45l0.53,-0.81l0.29,-1.86ZM705.26,340.87l2.47,2.04l1.41,-0.15l0.67,-0.97l-0.6,-3.01l0.11,-1.65l0.63,-1.44l0.12,-1.17l0.03,-2.73l-0.49,-1.5l1.77,-6.46l1.32,-0.62l2.0,-0.1l3.6,1.82l2.76,0.73l1.03,-0.47l0.93,-1.16l0.42,0.95l-1.01,1.96l-0.19,3.22l0.71,1.92l0.97,0.75l0.23,1.08l0.76,0.5l-2.68,6.69l-2.48,0.82l-1.67,1.35l-0.26,0.82l0.33,1.21l-1.44,2.23l-0.12,1.02l2.1,3.92l-0.4,0.52l0.02,0.84l1.09,3.29l1.19,1.24l2.47,0.77l0.97,-1.01l-0.57,-0.9l1.81,-1.08l0.87,0.03l2.06,0.87l0.92,1.55l-0.08,1.24l0.44,0.57l1.57,-0.04l0.57,-0.88l-0.17,-1.26l0.65,0.61l2.8,0.96l-1.64,0.38l-0.5,0.9l1.98,2.8l-0.23,0.96l0.4,0.54l1.09,0.06l1.14,0.57l-0.03,1.33l-0.44,1.29l-0.68,-0.57l0.47,-1.43l-0.11,-0.49l-0.54,-0.26l-1.98,0.22l-2.2,-0.99l-0.07,-1.15l-1.0,-1.74l-2.27,-1.38l-2.18,-2.32l-0.91,-0.19l-0.54,0.57l0.27,1.97l1.2,2.03l-0.11,0.92l-1.4,-2.27l-2.36,-2.11l-2.3,-1.17l-1.29,0.2l-1.17,0.64l-0.51,1.04l-1.37,0.37l-1.88,-0.91l-0.84,-0.94l-1.27,0.09l-0.06,-1.93l2.25,-2.25l0.18,-1.37l-0.61,-0.85l-1.39,-0.49l-0.76,-0.67l-0.69,0.13l-0.29,1.08l0.3,1.96l-0.52,-0.01l-1.22,-2.35l-1.29,-0.55l-1.08,-4.3l-0.32,-3.15l-0.92,-1.36l0.09,-1.8ZM730.9,372.85l0.47,-2.32l-0.19,-0.94l1.67,0.72l2.65,2.11l0.94,1.95l-1.57,-0.81l-0.13,-0.48l-2.08,-1.69l-0.86,0.3l-0.91,1.16ZM731.8,392.09l0.51,-3.17l2.34,-3.7l1.75,-4.53l0.06,3.43l-0.31,1.27l-2.26,2.03l-1.54,4.05l-0.54,0.62ZM733.28,394.82l0.52,-0.32l0.02,0.02l0.03,0.32l-0.57,-0.03ZM729.86,395.26l-0.73,0.04l-0.95,-1.93l-2.17,-1.16l-1.04,-1.46l-0.07,-0.78l0.39,-0.76l1.78,-0.22l1.23,-0.96l0.09,-1.64l-0.32,-1.54l0.97,-1.36l0.18,-1.36l1.68,-0.66l1.65,0.46l0.3,0.71l-3.01,6.84l-0.11,2.09l1.29,2.24l-0.6,1.16l-0.53,0.31ZM721.54,384.46l0.08,-2.36l0.65,-1.73l0.41,-4.26l-0.36,-0.84l-1.14,-0.42l0.2,-0.25l2.11,0.9l2.44,1.59l1.7,-0.22l0.29,0.21l-0.12,0.52l0.57,0.41l1.39,-0.68l-0.56,1.97l-1.94,1.45l-0.31,1.24l-1.72,0.97l-2.45,0.54l-1.25,0.95ZM725.79,384.74l0.1,-0.57l0.69,-0.72l-0.33,1.11l-0.47,0.17ZM725.34,370.08l0.51,0.0l0.32,0.32l-0.09,0.37l-0.74,-0.68ZM720.66,414.08l1.28,-0.48l1.17,0.52l-0.4,0.68l-1.29,0.41l-0.76,-1.13ZM721.62,371.25l-0.28,-0.34l0.74,-1.88l-0.26,1.6l-0.2,0.62ZM720.72,362.06l1.2,0.4l0.06,0.49l-0.5,0.8l-0.89,-0.63l0.12,-1.06ZM720.92,351.28l-0.31,-0.65l0.56,-0.04l0.08,0.05l-0.33,0.63ZM709.61,362.34l0.4,-0.1l2.09,0.38l1.26,-0.21l1.33,0.83l0.82,-0.23l2.08,2.06l-0.43,1.29l0.47,2.2l-1.03,2.1l-0.97,0.66l-0.4,-0.1l-1.19,-1.44l-0.47,-1.51l-0.77,-0.79l-0.21,-1.61l-0.66,-1.28l-1.3,-1.01l-0.48,-1.08l-0.55,-0.15ZM714.98,418.53l0.26,0.35l-0.6,0.22l-1.1,-0.11l0.83,-0.57l0.6,0.1ZM716.05,419.0l0.09,-0.02l0.4,0.07l-0.27,0.16l-0.22,-0.21ZM705.98,371.66l1.18,0.87l0.96,-0.01l0.47,0.43l-1.79,0.03l-0.83,-1.33ZM705.87,425.31l0.15,-0.09l-0.05,0.07l-0.1,0.02ZM707.64,424.35l0.2,-0.16l0.09,0.18l-0.07,0.15l-0.22,-0.17ZM706.04,374.1l0.59,0.45l-0.2,0.86l-0.04,-0.42l-0.35,-0.89ZM705.7,384.54l-0.46,0.12l-0.04,-0.14l0.31,-0.32l0.42,0.15l-0.23,0.19ZM686.27,399.97l0.72,-1.41l1.79,-1.9l2.11,-1.98l0.99,-0.21l0.79,-0.65l6.81,-7.61l1.57,-1.03l0.72,-1.72l-0.35,-1.29l1.36,-3.0l-0.17,2.33l1.17,3.14l-0.52,0.53l-1.72,0.64l-0.72,0.68l-0.59,1.28l-3.03,1.1l-0.35,0.57l0.08,0.83l-2.38,3.62l-2.22,1.15l-1.14,1.74l-2.96,1.68l-0.61,0.88l-1.33,0.63ZM684.24,404.1l0.0,0.29l-0.02,-0.03l0.01,-0.26Z",name:"Philippines"},"-99":{path:"M383.52,185.67l4.19,1.15l0.92,0.04l-3.62,2.11l-1.48,-3.3Z",name:"Siachen Glacier"},AE:{path:"M194.39,278.76l0.73,0.08l0.22,1.31l1.15,0.87l2.69,-0.08l2.96,-1.26l9.41,0.59l3.95,-1.73l2.56,-4.17l2.65,-1.86l3.18,-3.64l3.09,-2.34l1.07,-2.06l-0.1,2.81l0.48,0.5l1.07,0.36l0.03,1.78l-0.57,-0.2l-0.39,0.23l-0.21,0.84l0.56,0.47l0.63,-0.33l0.03,1.52l-1.79,1.71l-0.31,-0.4l0.09,-0.97l-0.49,-0.37l-1.04,0.15l-0.73,0.82l-0.26,3.17l0.28,1.09l-0.3,0.77l0.18,0.5l1.19,0.25l0.25,0.52l-2.94,0.49l-0.73,0.46l0.14,1.92l-2.3,5.42l-0.13,2.62l-0.3,0.38l-18.8,-2.42l-7.07,-8.89l-0.12,-0.91ZM210.56,279.01l0.06,-0.02l-0.04,0.02l-0.02,-0.0ZM210.81,278.92l0.07,-0.02l0.01,0.01l-0.07,0.02Z",name:"United Arab Emirates"},CN:{path:"M365.41,172.16l1.93,-0.79l0.8,0.45l0.58,-0.03l1.6,-1.06l0.43,-0.78l-0.29,-0.77l-1.35,-1.08l0.27,-1.56l-1.1,-2.86l-0.11,-1.26l0.45,-1.34l-0.29,-0.65l-2.33,-1.28l-1.95,-0.56l-1.36,0.09l-0.9,1.0l-0.98,-0.49l-0.3,-0.68l-0.39,-1.26l0.69,-0.6l0.09,-0.46l-1.45,-2.26l0.19,-1.53l1.3,-0.4l0.68,-0.85l0.11,-0.56l-0.57,-1.51l1.04,-1.95l2.98,-0.74l2.05,-1.55l1.31,-0.33l-0.07,-1.23l1.05,0.36l1.84,-0.28l2.1,-1.29l0.52,2.3l0.55,0.54l1.46,0.02l2.76,-1.01l0.79,0.52l1.36,-1.01l1.34,-2.89l1.67,-2.04l4.86,0.3l1.85,-0.56l2.31,-0.19l1.9,-1.96l0.18,-0.83l2.68,-1.58l4.03,-1.95l3.58,-1.07l0.68,-0.91l2.92,-0.44l0.25,-0.55l-0.22,-0.96l0.32,-0.57l-0.71,-3.75l0.51,-0.97l2.29,-0.97l-0.24,-0.77l-0.99,-0.5l1.46,-0.67l1.2,0.13l0.41,-0.8l-0.89,-1.63l0.26,-0.97l-0.41,-1.27l-2.18,-4.85l-0.02,-3.97l0.89,-1.82l-0.41,-0.45l-1.46,-0.56l-2.01,0.06l-0.52,-0.32l1.06,-0.83l4.21,-1.09l1.68,-0.04l6.15,-1.96l0.53,1.0l1.26,0.66l2.52,-0.51l1.4,0.82l0.8,-0.08l0.85,-1.74l-0.07,-1.41l-2.19,-1.08l-0.03,-0.33l1.78,-5.22l3.14,-7.6l0.39,-1.94l4.63,1.67l2.32,0.49l2.47,-0.24l2.33,0.22l0.45,0.9l0.68,0.43l1.8,-0.78l1.62,-1.17l2.02,-0.37l1.39,-2.04l0.08,-0.98l-0.6,-1.42l-0.45,-3.93l1.19,-3.6l0.77,-0.73l3.25,-0.45l2.36,-0.85l1.29,-1.65l0.29,-3.02l0.79,-0.62l2.36,-0.13l1.58,0.27l2.52,-0.84l0.3,1.27l-0.63,0.38l-0.25,0.6l0.94,1.34l1.39,0.54l-0.65,1.04l0.38,0.7l2.38,0.77l1.49,0.83l0.5,1.57l3.63,2.12l1.18,0.22l2.09,-0.46l2.1,1.87l0.74,0.07l1.12,-0.53l0.57,1.23l1.53,0.67l1.28,3.58l1.64,2.65l1.19,0.55l0.79,1.76l0.33,1.76l-0.89,2.6l0.67,2.13l-2.13,2.76l-0.41,2.07l1.63,3.21l0.63,0.31l0.99,-0.22l1.89,0.9l1.02,-0.03l1.13,0.44l3.3,0.07l3.02,0.55l2.72,-0.24l5.34,0.82l0.96,0.37l2.24,2.07l1.85,0.32l1.15,1.07l2.73,1.63l2.56,0.85l1.99,-0.13l-0.13,2.0l1.51,0.81l2.29,5.05l0.18,1.08l3.31,3.2l0.69,1.92l6.41,-0.51l16.91,2.0l3.94,-0.98l8.21,1.13l3.03,0.12l1.08,0.31l2.26,2.49l1.52,0.61l6.88,1.38l4.74,2.27l5.67,-1.01l0.0,1.47l0.37,0.4l2.66,0.14l1.13,0.41l1.7,-1.31l11.66,-4.91l10.41,-1.41l3.86,0.28l4.94,-0.21l7.99,-3.04l4.65,-5.2l4.07,-1.44l1.61,-1.47l0.83,-0.18l0.58,-0.54l-0.07,-1.24l-0.79,-1.18l-2.28,-2.25l-0.82,-1.48l1.58,-3.99l1.88,-2.0l3.55,0.07l1.21,1.17l1.03,0.45l6.82,1.27l3.8,-2.14l2.62,-2.22l0.93,-1.63l1.11,-0.23l1.42,0.38l1.82,-0.11l4.12,-0.73l1.86,-1.53l2.09,-1.18l0.37,-0.81l-0.17,-0.73l0.97,-1.75l1.14,-1.01l0.39,-0.77l1.9,-0.8l3.64,0.23l0.44,-0.45l0.38,-1.65l2.28,0.62l2.45,-1.39l1.7,-0.45l3.01,0.22l0.98,-0.62l2.2,1.09l1.38,0.27l2.89,0.08l1.36,-0.66l0.42,-0.79l-0.01,-1.52l-0.83,-1.16l-0.58,-1.61l-1.47,-1.11l-1.85,-2.1l-0.88,-0.45l-0.64,-1.25l-2.39,-0.99l-1.95,-2.14l-2.92,-0.51l-2.87,0.4l-3.15,3.15l-1.88,-1.41l-2.46,-0.62l-1.86,0.29l-2.09,-0.18l-2.41,1.59l-1.87,-1.6l-0.37,-0.56l-0.2,-1.43l1.92,-1.29l0.24,-3.01l1.51,-1.96l4.75,-9.76l3.9,1.76l1.78,0.17l3.07,0.94l4.54,-3.28l2.18,-1.11l2.92,-0.5l1.09,-0.71l0.55,-1.02l0.15,-1.22l-0.37,-0.95l-0.7,-0.36l0.55,-1.35l1.21,-1.37l0.54,-1.66l1.7,-2.34l0.5,-1.58l1.13,-1.51l0.76,-1.79l4.55,-3.66l0.6,-1.37l-0.01,-1.26l-0.61,-1.07l0.23,-1.97l-0.32,-0.74l-1.34,-0.73l-2.61,0.11l-0.48,-0.19l-0.1,-0.51l4.76,-4.34l1.99,-1.08l3.13,-0.33l6.78,-1.67l1.46,0.26l1.76,-0.12l3.07,-0.78l3.35,0.02l3.91,1.85l0.58,-0.06l1.7,1.35l1.37,0.23l1.22,0.74l0.7,0.1l0.53,-0.55l0.9,-0.2l3.43,1.55l0.68,0.02l0.53,1.46l1.13,0.28l1.21,1.21l-0.23,1.29l1.31,0.91l1.03,1.41l1.33,4.47l1.4,2.18l0.09,1.43l0.69,0.57l0.23,1.91l0.73,2.23l2.84,3.84l0.26,1.27l-0.31,1.03l0.33,1.29l1.69,1.29l-0.63,2.16l0.49,1.84l1.34,1.43l2.23,1.04l1.9,0.12l3.44,-0.39l0.69,1.23l1.5,0.44l0.48,0.5l2.05,0.2l1.04,-0.33l0.28,0.55l1.11,0.51l2.6,2.84l1.28,0.86l2.66,0.35l0.27,0.48l-0.44,1.57l1.87,2.66l-0.63,1.79l0.12,1.26l0.95,1.05l0.8,2.01l0.48,0.35l2.6,-0.29l1.75,0.43l1.71,0.01l5.1,-0.34l0.97,-0.59l0.99,-1.59l1.3,-0.37l1.9,-1.17l2.51,0.05l2.79,-1.68l3.24,-0.92l1.8,0.44l0.68,0.74l-0.82,1.93l1.31,2.75l-1.38,1.91l-1.77,0.61l-1.07,1.16l0.13,1.79l-0.94,1.69l-0.37,2.24l-1.12,1.92l0.19,1.39l-0.26,1.0l-1.13,0.94l-0.42,1.75l-1.06,0.82l-0.49,2.38l-1.96,1.19l-0.56,1.69l-0.04,1.63l-0.95,0.67l-0.5,-0.19l-0.1,-0.71l-0.73,-0.85l-2.53,-0.96l-1.5,0.01l-1.59,0.8l-1.29,-0.76l-1.5,1.14l-1.57,2.05l-2.71,0.69l-0.86,0.69l-0.15,0.9l0.85,1.78l1.22,4.66l-0.58,3.36l0.06,1.87l0.53,0.57l0.03,0.49l-0.58,2.05l-0.7,1.11l-0.07,0.94l-4.14,1.05l-0.65,0.58l-0.03,0.7l-0.59,-0.73l-0.01,-1.18l-0.31,-0.41l-1.13,-0.73l-1.86,-0.14l-0.96,2.12l-0.46,2.74l-0.99,0.52l-0.82,-0.43l-1.06,0.26l-0.85,1.04l-0.2,0.87l-1.83,1.42l-4.49,0.11l-2.3,0.6l-0.07,1.14l1.87,2.53l-0.82,1.45l-0.79,-0.53l-2.49,0.07l-3.67,-0.8l-0.72,-1.27l-1.0,-0.87l-0.72,-0.04l-1.3,0.54l-1.1,0.89l-0.72,2.33l-3.69,4.02l-2.02,0.41l-2.24,1.77l-2.61,1.03l-0.65,0.71l-0.77,0.09l-3.8,3.18l-0.88,1.57l-1.07,0.65l-2.36,0.15l-0.71,-0.45l-0.52,0.08l-0.5,0.75l-1.65,0.2l-0.91,0.64l-1.3,0.1l-1.6,0.69l-3.78,2.06l-2.63,2.74l-0.86,0.47l-1.56,0.08l-0.33,0.43l0.11,0.72l-2.19,0.42l-0.92,0.53l-0.13,-0.29l-0.07,-0.57l4.01,-1.54l0.22,-0.52l-0.31,-0.79l1.22,-1.18l-0.06,-0.68l-0.47,-0.17l-3.25,0.2l-0.06,-0.93l1.74,-0.99l-0.29,-1.01l0.19,-0.48l2.16,-1.03l2.89,-3.56l0.71,-1.79l-1.18,-1.72l-1.96,-1.27l-0.15,-1.0l-0.5,-0.33l-0.86,1.13l-4.24,-0.41l-3.06,2.81l-2.15,3.11l-6.55,2.87l-1.62,1.4l-1.06,1.8l-0.29,1.35l-1.66,1.8l-2.61,0.05l-2.19,0.87l-0.95,-0.95l-1.18,-0.38l-1.31,0.31l-0.87,0.71l-1.75,3.93l0.04,0.86l0.74,1.75l0.99,1.17l1.99,1.17l3.96,0.77l1.87,-0.27l0.87,0.6l0.96,2.56l-0.66,0.56l-0.29,2.76l1.44,1.5l2.65,0.69l2.41,-0.26l1.17,-0.95l0.09,-0.91l3.1,-2.29l0.03,-0.55l2.97,-1.14l2.03,0.85l1.23,1.04l1.38,0.26l1.86,1.0l2.57,0.17l0.84,-0.7l0.59,0.59l1.26,0.44l1.79,-0.09l-0.29,0.5l0.08,0.95l-0.94,0.91l-0.01,0.5l0.48,0.56l-1.09,0.82l-1.15,-1.08l-1.81,-0.01l-6.7,3.02l-1.68,-0.21l-0.45,0.45l0.75,1.29l-0.79,-0.14l-0.62,0.55l-0.37,2.19l-1.61,0.56l-0.14,-1.17l-0.39,-0.27l-1.33,0.32l-0.74,0.8l0.02,0.46l0.97,1.03l-1.13,0.58l-0.68,1.11l-0.81,0.79l-1.15,0.53l-1.43,1.93l-0.66,0.44l-0.69,1.69l-1.07,1.0l-0.38,1.38l0.27,1.08l0.38,0.28l1.03,-0.01l1.65,1.37l2.88,1.15l2.1,1.34l1.78,5.33l2.69,5.12l0.01,3.15l1.12,0.84l2.52,1.12l0.31,0.31l0.11,1.46l0.69,0.76l1.93,1.05l0.68,1.25l0.04,0.49l-0.31,0.01l-3.09,-1.32l-2.66,-0.06l-1.4,-1.34l-2.11,-0.64l-3.93,1.47l0.15,0.72l1.17,0.25l2.43,-0.92l1.32,0.24l0.62,1.36l2.02,0.84l2.18,1.92l2.25,1.33l0.86,1.19l0.56,1.61l-3.15,0.91l-0.86,0.76l-2.29,1.14l-1.2,1.61l-2.92,-0.2l-1.6,0.91l-0.46,0.83l1.46,0.15l1.0,-0.36l1.22,1.3l2.19,-0.28l1.82,-1.1l1.07,0.13l2.4,2.39l2.18,0.81l-3.43,2.67l-0.11,0.47l0.43,0.23l1.38,-0.22l1.47,-0.89l-0.17,3.07l-1.0,-0.86l-1.54,0.12l-0.7,0.55l-0.3,0.5l0.27,0.6l1.37,0.93l-0.97,0.15l0.14,0.48l0.67,0.48l-1.27,1.36l0.88,2.44l-1.79,0.73l-0.3,-0.73l-1.02,-0.07l-0.61,0.52l-0.97,1.92l-1.31,0.12l-0.34,0.56l0.6,0.64l-1.69,2.36l0.04,1.5l-1.57,1.94l-0.86,0.57l-1.09,1.77l-0.4,1.67l-0.76,0.38l-0.45,-0.81l0.02,-0.72l-0.56,-0.43l-0.78,0.86l-0.61,-0.34l-0.62,0.35l0.39,1.4l1.15,0.72l0.58,1.26l-2.78,2.07l-2.21,-0.53l-0.42,0.18l0.03,0.46l1.09,1.3l1.33,0.19l1.18,-0.41l-0.7,2.87l0.55,1.27l-1.1,-0.57l-2.04,0.21l-0.33,0.69l0.86,1.11l-1.36,-0.12l-0.71,0.28l-0.47,0.66l0.03,1.46l-1.86,0.71l-0.31,0.44l0.55,0.71l-0.3,0.65l-2.35,0.26l-1.61,-0.4l-0.83,0.65l-0.15,0.55l-0.9,0.02l-0.35,0.45l0.13,0.53l0.5,0.44l0.87,0.1l0.09,0.53l-1.42,1.61l-0.81,0.11l-0.79,1.15l-1.32,0.28l-0.25,1.38l-0.67,-0.56l-1.52,1.02l-1.31,-0.48l-0.47,0.3l-0.34,1.39l-1.77,0.94l0.48,0.64l-1.03,0.52l-0.45,1.76l-1.73,-0.15l-0.55,0.62l-2.18,0.65l-1.7,-0.36l-0.59,0.23l-0.53,0.81l-2.2,-0.75l-2.07,1.04l-0.44,0.51l-0.39,-0.04l-0.21,-0.64l-0.71,-0.39l-0.84,0.55l-0.46,1.11l-1.09,-0.4l-0.68,0.36l-1.01,-0.14l-1.26,0.3l-2.13,-2.38l-0.23,-1.15l0.2,-0.62l-0.46,-0.57l-0.87,0.25l-0.56,0.37l-0.12,0.91l-0.62,0.17l-0.28,0.49l1.65,2.52l0.24,1.88l-0.75,0.82l-1.87,0.83l-0.33,-0.77l-0.67,-0.1l-0.7,0.91l-0.26,1.4l-1.03,-0.33l-1.55,1.19l-0.69,-0.45l-0.17,-0.81l-0.8,-0.23l-0.35,0.51l0.19,1.14l-0.28,0.19l-2.61,-0.83l-0.77,1.07l-0.81,0.08l-1.15,1.15l-1.48,0.18l-0.61,0.37l-2.15,-0.19l-0.49,0.72l-1.63,0.37l-1.41,1.26l-0.31,-0.01l-0.52,-0.93l-0.57,0.3l-0.23,1.14l-1.23,0.94l-0.45,1.17l0.53,0.96l1.17,0.14l-0.41,0.45l0.04,0.79l1.36,1.09l-0.39,0.78l-0.62,0.37l-1.52,0.22l-1.17,-0.21l0.5,-0.6l-0.12,-0.35l-0.9,-0.7l-0.38,-0.62l0.04,-0.8l-1.0,-1.46l0.15,-1.56l0.65,-1.38l1.11,-0.59l0.07,-0.82l-0.39,-0.44l-0.58,-0.02l-0.41,-0.47l-0.65,0.09l-0.66,-1.03l-0.75,-0.24l-0.42,0.45l0.13,0.95l-2.47,0.67l0.17,-0.72l-0.39,-0.5l-0.73,-0.33l-1.8,-0.04l-0.98,-0.95l0.02,-0.73l-0.49,-0.43l-0.85,-0.03l-0.41,0.4l0.28,1.81l-1.09,-0.56l-0.72,1.04l-1.76,0.38l-1.62,-1.11l-2.08,0.41l-0.94,-0.16l-0.4,-0.55l-1.64,-0.72l-0.67,-1.01l-2.21,-0.67l-0.05,-1.66l-0.85,-1.11l0.23,-1.03l0.85,-0.53l0.68,-1.22l-0.12,-0.55l-1.84,-1.05l-2.07,0.36l-0.61,-0.73l-1.03,-0.2l-1.55,0.41l-2.03,-1.1l-0.83,-1.24l-1.34,-0.95l-3.55,1.72l-0.4,0.52l-0.2,1.34l-0.59,0.51l-1.18,0.15l-1.14,0.75l-1.15,-0.81l-1.33,0.5l-0.71,1.62l-2.1,-1.83l-0.89,0.42l-0.34,0.84l-0.66,-0.95l-0.63,-0.28l-2.47,2.5l-0.96,-1.02l-2.81,-1.34l-0.72,0.28l-1.91,2.51l-0.8,-0.35l-1.25,0.29l-0.63,-0.68l-0.72,0.09l-1.52,2.27l0.6,2.11l0.99,1.28l-0.12,3.86l0.49,0.66l-0.21,0.19l-1.25,-0.61l-1.95,0.36l-0.72,-3.85l-0.68,-0.58l-2.1,0.82l-1.69,1.42l-1.7,-0.24l-1.38,0.2l-0.21,-1.14l-1.18,-0.84l0.08,-1.61l-0.3,-0.58l-2.69,-0.64l-2.81,-0.24l1.23,-2.56l0.32,-2.41l0.95,-1.33l-0.39,-0.85l-0.53,-0.32l-3.83,-0.86l0.06,-1.37l-0.58,-1.01l0.2,-0.92l-1.13,-2.02l1.18,-1.77l-0.43,-0.41l-1.68,0.35l-0.79,-0.3l-2.18,0.04l-1.61,0.4l-2.81,1.32l0.84,-1.22l0.22,-0.96l-0.41,-1.54l-0.9,-0.73l-0.01,-0.93l0.33,-0.93l1.19,-0.86l-0.14,-1.39l0.61,-1.38l0.71,0.03l0.73,-0.48l0.79,-1.13l0.31,-1.17l1.26,-0.02l1.09,-1.65l1.23,-0.37l0.32,-0.55l-0.67,-1.69l0.86,-0.76l0.43,-4.22l-0.66,-7.13l-1.8,-1.02l-0.57,0.17l-0.4,0.7l-1.44,-4.65l-1.61,-1.77l-0.96,-0.11l-0.91,-1.15l-1.37,0.09l-1.35,2.06l-1.61,-1.06l-0.9,0.21l-1.36,-0.21l-1.36,-0.76l-1.94,0.67l0.2,-0.69l1.76,-1.77l0.1,-0.45l-1.17,-2.46l-1.06,0.09l-1.05,0.71l-0.08,-0.57l1.44,-0.92l0.25,-0.5l-0.29,-0.57l-0.99,-0.04l-1.3,-1.5l-1.5,0.45l-2.8,1.52l-0.86,1.33l-4.2,-1.08l-0.75,-0.94l-0.89,-0.16l-2.52,1.41l-1.3,1.3l-0.57,0.11l-1.02,1.34l-1.01,0.57l-3.9,0.88l-1.06,1.91l-3.46,2.48l0.09,1.15l-1.65,0.89l-1.35,-0.09l-1.97,0.85l-2.08,-0.24l-0.06,-1.23l-2.85,-1.31l-0.73,0.08l-1.25,0.75l-2.26,-0.8l-2.52,-0.06l0.13,-0.91l-0.36,-0.43l-1.9,-0.49l-1.67,0.07l-3.31,1.99l-2.43,2.86l-0.47,0.99l-1.06,0.94l-0.36,0.83l-0.47,-0.95l0.7,-3.01l-0.46,-1.27l-1.45,-0.74l-3.94,1.17l-0.48,0.51l-1.46,-0.05l-1.76,0.57l-3.44,-0.17l-0.89,-0.71l-1.94,-0.74l-0.44,-0.54l-0.79,-0.17l-0.62,0.16l-0.51,1.14l-0.41,0.1l-1.18,-0.63l-0.68,-0.79l-0.42,-0.01l-0.64,0.58l-0.21,0.98l-0.87,-1.65l-1.27,-1.21l-4.14,-0.33l0.41,-1.76l-0.28,-0.52l-0.91,-0.15l-1.8,0.4l-4.06,-2.75l-1.11,-2.6l-1.55,-0.5l-2.33,0.75l-3.12,-3.41l-2.3,-0.61l-2.71,-2.08l-2.01,-1.02l-1.48,-2.22l-3.04,-0.5l-1.83,0.42l-1.42,2.12l-0.6,0.33l-0.93,-1.59l-2.82,-1.74l-2.92,-0.99l0.03,-1.27l-0.49,-0.51l-0.64,-0.03l-2.05,-1.46l-1.84,0.08l-1.16,-0.84l-2.21,-2.86l-0.78,-0.2l-0.62,0.71l-1.06,0.34l-0.1,-1.14l0.46,-0.91l-0.04,-0.48l-0.73,-0.9l0.3,-1.79l-1.83,-2.23l-0.67,-2.27l1.73,-0.24l0.39,0.91l1.42,1.02l1.21,-0.27l1.4,-1.33l-0.13,-3.73l-0.73,-0.85l0.2,-1.15l-2.48,-2.76l-0.55,-4.19l1.72,-1.52l0.09,-0.95l-0.44,-0.7l-1.95,-1.37l-2.81,-1.04l-1.98,-4.96l0.26,-1.64l-0.3,-0.58l-1.28,0.21l-0.77,-0.36l-2.5,0.16l-2.61,-0.64l-3.32,-1.46l-0.35,-0.26l-0.07,-0.79l-0.48,-0.35l-2.59,0.64l-0.62,-1.33l-1.12,-0.49l0.45,-0.83l0.03,-1.94l-0.34,-1.28l-0.81,-1.23l-1.46,-0.87l-1.58,0.1l-0.77,-1.56l-2.25,-0.65l-1.24,0.26l-1.4,-0.66l-1.17,0.05l-0.72,-0.59ZM784.71,123.62l0.4,0.07l0.21,0.23l-0.36,-0.13l-0.25,-0.17ZM723.42,232.07l-1.54,-0.41l-0.17,-0.27l0.52,0.01l1.19,0.67ZM716.28,217.72l0.89,0.27l0.35,0.57l1.35,0.76l-2.09,-1.02l-0.5,-0.58ZM715.46,247.46l0.02,-0.03l0.0,0.02l-0.02,0.01ZM704.67,268.77l-0.0,-0.09l0.08,-0.21l0.02,0.22l-0.1,0.07ZM704.8,268.19l-0.02,-0.24l-0.07,-0.11l0.19,0.14l-0.1,0.2ZM626.1,313.41l0.45,-0.31l1.5,-0.02l0.99,-0.61l1.85,0.16l1.43,-0.24l0.73,-0.47l0.93,0.1l0.73,0.49l0.25,-0.45l0.9,0.43l0.57,-0.36l0.13,-0.8l1.76,1.26l0.46,1.85l-1.34,0.72l-1.36,2.07l-0.57,1.05l-0.86,3.16l-2.89,1.77l-0.1,0.61l-1.5,0.17l-1.06,1.16l-1.01,0.2l-3.6,-1.12l-2.23,-1.17l-0.45,-2.39l0.16,-3.13l4.5,-3.46l0.1,-0.45l-0.47,-0.24Z",name:"China"},AF:{path:"M263.13,194.66l1.33,-0.91l1.1,-1.84l0.56,-2.35l-0.33,-1.15l0.64,-0.51l0.68,-2.24l2.02,1.52l2.71,-0.08l1.58,1.21l0.79,1.07l1.38,-0.62l1.85,-0.09l2.97,-1.9l0.83,-2.18l-0.38,-0.98l1.1,-0.05l4.17,-1.31l1.19,-0.03l0.71,-0.9l1.92,-0.94l1.23,-1.03l2.34,-6.82l1.81,-0.8l3.41,-0.11l1.57,-2.69l2.48,1.27l2.72,0.6l2.73,-0.22l1.64,0.29l0.86,0.78l1.11,0.31l1.4,-0.46l1.44,0.32l0.85,1.3l0.93,0.79l0.99,0.28l1.84,-0.67l0.82,-0.97l2.16,-1.04l1.07,-0.09l0.54,-0.51l2.73,1.92l1.42,-1.18l-0.1,-1.72l0.51,-0.98l2.24,-0.43l2.22,0.57l0.76,-0.4l0.65,-1.03l-0.33,-2.03l1.5,-1.31l1.47,-2.23l0.78,-0.67l0.88,-0.24l1.13,0.29l1.38,0.87l0.46,0.95l-0.35,1.35l0.2,1.16l0.51,0.18l1.53,-0.27l-1.09,6.68l0.76,2.5l0.5,0.96l0.78,0.52l1.31,-0.02l4.09,-2.44l2.19,-0.39l1.93,-2.11l3.52,-1.63l2.11,0.32l-0.71,0.81l0.06,0.5l1.16,0.37l3.23,-0.85l0.78,-0.74l3.04,0.38l-2.53,1.09l-0.19,0.6l0.87,0.8l-3.12,1.43l-1.91,-0.55l-8.59,0.51l-3.63,1.14l-2.93,2.3l-1.2,0.04l-2.87,2.67l-0.48,0.82l0.3,0.78l1.32,1.02l1.26,2.8l0.16,0.92l-0.39,1.09l0.52,0.89l-1.08,1.56l-1.15,0.81l-2.41,2.82l-0.1,0.83l0.86,1.05l-0.03,1.85l-0.18,0.37l-2.73,0.74l-2.35,-0.07l-2.43,-0.75l-1.31,0.69l-0.06,1.27l1.94,2.25l1.04,1.99l-0.09,0.34l-2.33,1.35l-2.61,0.41l-0.64,0.44l-0.88,3.06l-1.19,2.0l0.24,4.16l-0.58,0.69l-0.74,0.79l-1.38,0.76l-1.78,-1.33l-1.45,0.33l-2.07,-0.39l-1.26,1.1l-3.3,1.43l0.0,0.89l0.73,0.66l-0.53,0.31l-2.14,0.46l-1.14,-0.18l-0.79,-0.49l-1.68,0.34l-1.85,2.08l-1.41,0.83l-0.55,1.09l-0.47,1.65l0.12,2.44l-0.5,1.81l0.43,1.28l-0.65,0.55l-7.99,2.23l-4.32,-0.04l-1.96,0.48l-1.27,0.86l-3.88,-0.8l-8.12,0.73l-11.54,-3.48l6.64,-7.54l0.32,-2.24l-0.46,-1.86l-1.04,-1.1l-5.98,-0.83l-0.21,-2.89l0.3,-3.19l-1.99,-7.16l2.65,-3.31l-0.38,-0.57l-2.37,-0.37l-0.45,-0.7l0.29,-1.15l-0.29,-1.99l0.97,-1.49l1.66,-0.09l0.29,-0.64l-0.98,-1.34Z",name:"Afghanistan"},IQ:{path:"M125.37,172.77l1.95,-1.22l0.78,-0.94l1.16,0.37l1.24,-0.35l4.35,1.19l1.2,0.03l1.46,-0.77l0.5,0.07l0.44,0.53l0.09,1.72l0.79,0.56l2.58,-1.7l0.69,0.07l0.9,2.88l1.07,0.96l0.23,1.88l0.57,0.71l0.86,0.33l1.15,3.11l1.42,0.29l1.68,1.36l3.14,0.13l-1.41,0.56l-0.54,1.37l0.08,0.71l0.99,1.29l0.2,1.22l-1.54,0.83l-1.82,1.95l-0.25,1.77l-0.74,-0.06l-0.45,0.37l-0.45,1.3l0.76,1.82l-1.02,2.28l2.56,3.1l1.08,-0.0l-0.11,0.57l0.29,0.52l0.85,0.46l0.87,1.45l-0.48,1.1l0.35,1.36l2.11,0.33l5.49,3.81l1.79,0.29l1.01,2.18l2.3,2.86l-1.06,3.07l-0.02,3.42l0.38,0.4l2.1,0.09l0.03,3.94l1.72,1.49l0.78,0.29l0.81,2.06l-1.95,-0.76l-1.42,0.35l-2.08,-0.8l-2.62,0.13l-0.97,0.37l-0.93,0.76l-1.6,3.52l-2.66,3.43l-1.13,0.23l-12.17,-1.05l-19.68,-15.44l-12.8,-7.12l-8.45,-1.44l0.59,-0.87l-0.34,-0.89l-0.45,-0.25l-1.2,0.28l-0.2,-0.63l0.45,-0.55l-2.04,-7.04l14.03,-7.89l1.79,-0.45l0.56,-0.45l1.68,-3.13l0.16,-4.4l1.03,-3.03l-0.03,-1.6l-0.78,-2.18l0.35,-2.43l0.73,-0.93l2.85,-0.77l4.37,-4.38Z",name:"Iraq"},JP:{path:"M869.1,98.66l1.75,-0.84l3.26,3.32l3.55,4.25l6.71,5.04l2.54,0.27l2.9,1.4l1.9,0.2l1.33,-0.56l3.0,-2.78l-1.69,3.31l-0.21,1.25l1.8,4.23l1.68,0.42l-1.41,0.23l-3.12,1.57l-2.16,0.49l-3.23,-0.24l-1.9,0.92l-2.95,2.59l-1.18,1.68l-1.26,3.56l-5.13,-2.24l-4.91,-2.89l-3.56,0.24l-3.12,1.79l-1.8,-1.77l-2.05,-0.12l-1.27,1.37l-0.29,0.99l0.17,0.69l1.58,1.52l1.6,0.19l2.73,2.36l-1.19,0.22l-2.17,-0.56l-1.32,1.32l-0.75,1.34l-1.78,0.69l-0.46,-0.91l0.82,-3.12l-0.47,-1.54l-1.58,-1.77l0.18,-2.51l0.16,-0.42l2.41,-1.29l1.69,-1.6l0.38,-1.25l-0.63,-1.01l-0.05,-0.81l0.91,0.01l1.81,0.98l2.53,0.25l1.29,-0.2l0.83,-0.99l0.3,-1.08l-0.11,-2.27l1.83,-3.39l0.14,-2.29l0.75,-2.08l0.15,-2.27l-0.5,-2.16l-0.97,-1.91l0.52,-1.84ZM797.15,199.72l-2.57,-1.61l-2.21,0.27l-1.69,0.57l-1.02,-0.53l-1.02,0.12l-0.16,-1.76l0.63,-0.77l2.7,-0.24l1.86,-1.68l1.91,-0.98l3.04,-2.52l2.67,-2.39l0.63,-0.98l1.51,-0.69l2.29,-0.37l1.09,0.82l1.69,-0.43l2.79,0.03l1.83,-0.29l1.79,-0.74l3.12,-0.29l2.19,-0.7l0.26,0.06l-0.18,1.1l0.85,0.68l2.74,0.22l1.11,-0.42l2.39,-1.97l-0.57,-2.1l0.4,-0.94l2.14,-2.04l2.55,-3.28l0.45,-1.95l-0.2,-2.13l0.78,-1.34l3.05,-1.07l-1.26,1.28l-1.65,0.92l-0.36,0.67l0.73,1.13l0.3,1.76l0.95,0.6l1.0,0.19l1.03,-0.3l1.18,-1.46l6.0,-2.29l1.79,-1.56l1.26,-1.52l1.25,-2.38l2.64,-1.4l1.29,-1.28l0.94,-3.21l2.1,-3.3l0.85,-3.08l0.92,-1.59l0.24,-1.99l-0.07,-1.16l-0.49,-1.08l-0.5,-0.42l-0.89,-0.06l0.74,-0.65l0.81,-2.26l-0.66,-2.93l0.62,-0.94l1.24,-0.36l0.75,-0.77l0.52,-1.54l-0.08,-1.59l1.48,0.12l0.32,2.43l0.68,0.84l0.91,-0.09l0.69,-0.8l1.64,0.42l0.94,-1.16l0.28,-1.02l-0.12,-1.08l-0.8,-0.68l-2.52,0.82l0.41,-1.91l0.27,-0.42l2.22,1.27l1.07,-0.21l-0.29,2.18l0.24,3.4l0.32,1.16l1.4,1.26l1.05,1.5l1.42,4.28l-0.1,3.09l-0.56,2.58l-1.66,1.14l-0.97,2.0l-0.54,2.99l-2.66,0.62l-1.2,1.82l-0.27,1.84l0.81,4.19l-0.25,2.97l-0.22,0.85l-1.25,1.25l-0.55,1.12l-0.77,1.97l-0.42,2.39l0.41,1.75l1.51,2.46l-1.28,0.42l-1.4,1.32l-0.76,2.79l-3.37,2.17l0.16,-2.7l1.76,-1.96l0.18,-0.57l-0.98,-1.12l-0.81,-0.07l-0.86,0.22l-0.46,0.57l-0.11,0.87l-0.77,0.64l0.28,2.04l-1.35,-1.19l-1.76,0.18l-0.84,0.66l-0.47,1.16l-0.21,2.14l-1.23,1.57l-0.41,-0.3l0.29,-2.03l0.55,-0.31l0.08,-0.64l-1.53,-0.93l-1.49,0.44l-2.44,3.02l-0.4,0.92l-2.16,-0.39l-4.01,0.1l0.08,-0.5l-0.5,-0.63l-1.57,0.08l-0.59,-0.56l-0.49,0.08l0.01,-1.77l-1.08,-0.14l-1.03,0.73l-1.2,2.64l0.69,1.14l1.89,1.24l-0.11,0.44l-2.17,0.49l-1.78,0.83l-3.03,5.07l-1.4,0.53l-1.55,-0.48l-2.28,-3.54l-0.16,-2.19l1.06,-0.6l0.93,-1.05l0.29,-0.62l-0.14,-0.95l-0.68,-0.38l-2.31,0.19l-2.27,-1.13l-3.88,0.47l-2.11,1.59l-3.9,0.79l-2.17,1.03l-0.97,-0.18l-2.53,0.68l-1.6,-0.83l-1.15,0.19l-0.84,1.15l-0.63,2.77ZM865.75,100.56l-0.16,0.02l-0.34,-0.3l0.21,-0.05l0.29,0.33ZM852.34,128.05l-0.01,-0.06l0.07,-0.12l-0.06,0.17ZM843.87,165.83l0.27,-1.03l-0.54,-0.64l0.99,-1.22l-0.26,1.06l0.73,0.5l-0.33,0.78l-0.86,0.54ZM817.81,195.39l0.11,0.97l-0.91,0.42l-0.18,-0.21l0.98,-1.19ZM799.43,203.31l2.14,-1.59l1.03,-2.45l0.92,-0.71l1.41,1.39l3.48,-0.79l0.56,-0.72l0.01,-1.08l2.1,-0.96l0.82,-0.08l3.06,1.19l0.79,-0.04l0.42,2.93l-2.28,1.59l-1.02,1.44l-0.37,1.1l-1.12,-1.23l-0.91,-0.46l-2.01,-0.15l-2.79,1.49l-1.02,2.25l-0.9,0.74l-0.38,1.27l-0.61,0.55l-0.91,-0.13l0.24,-0.55l-0.3,-0.55l-1.28,-0.14l-0.37,-0.85l0.5,-1.92l-0.78,-0.48l0.04,-0.61l-0.46,-0.44ZM806.3,180.01l-0.4,0.05l-0.11,-0.36l0.22,-0.13l0.29,0.44ZM779.3,207.59l0.61,0.97l1.43,0.4l0.37,-0.57l-0.55,-1.19l-2.44,-2.04l0.11,-0.44l1.3,0.29l0.51,-0.3l-0.03,-0.87l1.56,-0.56l0.61,-0.58l1.53,-0.34l1.02,-1.74l1.24,-0.61l1.69,0.3l0.71,1.52l1.14,0.82l1.52,0.28l1.66,-0.66l0.51,0.26l0.05,0.4l-1.27,1.89l0.29,0.6l2.08,0.18l-0.1,0.69l0.71,0.75l-0.05,0.84l0.5,0.31l-1.93,2.27l-0.62,1.2l-1.5,4.83l-0.01,1.79l-0.79,1.89l-1.25,-0.29l-0.84,0.25l-0.28,0.85l0.34,0.72l-1.19,0.96l-0.58,0.29l0.35,-1.29l-0.62,-2.27l0.59,-0.38l0.08,-0.63l-0.47,-0.69l-1.31,0.06l-0.77,1.34l-0.24,1.11l0.7,1.77l-2.46,-0.77l-0.16,-0.39l0.94,-0.5l0.22,-1.32l-0.96,-1.54l0.01,-2.43l0.83,-0.31l0.6,-0.67l1.88,-3.4l-0.33,-0.56l-0.48,-0.05l0.3,-0.59l-0.17,-0.81l-1.26,-2.24l-1.27,-0.93l-1.28,0.67l0.23,2.45l0.36,0.37l0.9,-0.08l-0.06,0.75l-1.61,-0.78l-1.42,0.81l-1.2,-2.07ZM788.9,226.85l0.01,-0.11l0.07,-0.14l-0.02,0.14l-0.05,0.1ZM785.8,229.65l-0.74,0.03l-0.25,-0.58l0.36,-0.28l0.79,0.45l-0.17,0.38ZM781.9,213.3l-0.19,-0.64l0.25,-1.01l0.49,-0.07l0.06,1.08l-0.6,0.64ZM776.05,246.41l0.46,-0.51l1.07,-0.27l-0.66,0.48l-0.27,0.75l-0.59,-0.45ZM776.4,195.67l0.0,0.07l-0.02,-0.02l0.02,-0.04ZM776.72,194.79l0.02,-0.76l0.3,-0.22l0.03,0.45l-0.35,0.53ZM775.75,197.51l0.11,-0.75l0.18,0.13l-0.28,0.62ZM774.64,207.53l0.05,-0.12l0.05,0.07l-0.1,0.05ZM773.52,250.21l0.09,0.15l-0.02,0.05l-0.05,-0.02l-0.03,-0.18ZM771.75,209.72l0.65,-0.12l0.16,0.27l-0.66,0.42l-0.16,-0.58ZM764.44,262.78l0.09,0.4l-0.31,0.21l0.02,-0.29l0.2,-0.32ZM764.79,261.99l0.01,-0.59l0.25,-0.07l0.06,0.35l-0.31,0.3ZM766.32,260.11l-0.04,-0.54l0.94,0.06l-0.09,0.16l-0.81,0.33ZM767.58,259.28l0.76,-0.83l0.14,-0.26l-0.37,0.82l-0.53,0.27ZM737.71,277.3l0.12,0.01l0.12,-0.02l-0.11,0.13l-0.12,-0.12ZM734.91,277.92l0.11,-0.19l0.44,0.15l-0.29,0.11l-0.26,-0.06Z",name:"Japan"},IR:{path:"M137.98,152.91l1.82,0.03l0.6,-0.28l0.67,-2.32l0.59,-0.59l1.55,0.95l2.35,3.38l2.65,2.25l5.45,1.21l1.03,-0.36l1.99,-0.04l2.17,-2.07l1.11,-0.37l1.44,-1.36l4.32,-2.67l1.33,-0.27l2.06,2.03l-1.19,0.63l-0.3,0.88l0.19,0.73l1.15,0.75l0.06,0.33l-1.67,0.54l-0.47,0.49l0.0,0.74l2.41,2.2l0.82,0.23l1.45,1.6l1.81,-0.16l0.68,4.4l1.03,2.14l2.34,1.36l5.61,0.96l1.48,2.17l4.46,2.95l1.55,0.63l4.82,1.1l3.39,-0.06l10.69,-2.45l0.21,0.44l0.67,0.3l1.71,0.03l0.55,-0.35l0.21,-0.71l-0.72,-3.44l1.67,0.06l3.89,-1.22l0.54,-0.48l1.08,-2.26l3.46,-2.28l1.38,-0.39l4.89,0.22l0.66,-0.25l0.51,-1.1l2.06,-0.24l1.77,0.38l2.05,-0.02l0.63,0.56l0.52,1.51l4.7,1.24l2.54,1.59l3.86,-0.27l3.36,1.38l0.49,1.51l0.66,0.7l4.56,2.51l2.11,2.82l5.87,0.06l0.51,3.54l-0.43,1.67l0.74,1.14l-0.1,1.69l0.31,1.07l-0.64,1.6l-0.71,0.64l0.34,1.44l-0.5,1.97l-0.93,1.56l-1.67,1.22l0.81,1.48l-1.39,0.22l-1.2,1.82l0.15,4.16l1.31,0.92l1.52,0.1l-2.39,2.82l-0.07,0.91l2.0,6.8l-0.31,3.03l0.25,3.24l0.59,0.43l5.89,0.81l0.55,0.62l0.38,2.82l-0.16,0.53l-6.99,7.93l0.0,0.53l3.52,3.93l0.14,0.86l2.14,3.86l2.05,2.06l3.58,1.15l1.47,1.37l1.37,-0.01l-0.16,1.7l0.53,3.99l-0.38,2.1l0.61,0.45l0.9,0.12l1.9,-0.26l0.6,0.48l-0.4,0.47l0.03,1.5l-0.45,0.44l-0.12,1.22l-2.53,-0.02l-2.68,0.69l-1.06,0.62l-0.58,0.96l-0.53,-0.06l-2.39,1.21l-0.42,0.76l-0.4,2.49l-0.69,0.76l-0.48,4.16l-1.09,0.73l-5.32,-1.37l-0.4,-0.8l-0.83,-0.45l-1.11,0.94l-2.58,-0.53l-0.97,0.15l-2.07,-0.31l-1.4,-0.61l-2.88,0.49l-1.9,-1.09l-4.44,-0.29l-1.86,-0.74l-1.13,0.19l-0.55,-0.51l-2.79,-0.5l-0.83,-1.7l-0.06,-1.04l-0.7,-1.65l-0.54,-3.52l-1.01,-1.66l-1.57,-1.19l-2.93,-0.59l-1.84,0.47l-1.36,0.86l-2.28,0.55l-1.54,1.56l-1.04,-0.07l-3.01,1.85l-1.55,0.34l-3.03,-1.5l-1.33,-0.29l-2.66,0.07l-1.33,-0.91l-0.5,-0.81l-3.55,-1.61l-2.09,-1.4l-0.66,-1.36l-1.1,-1.09l-2.08,-0.8l-1.34,-0.91l-2.73,-0.17l-0.9,-0.43l-1.66,-1.66l-0.08,-0.75l-1.31,-2.27l-0.3,-1.86l-1.47,-1.22l-0.02,-1.62l-1.45,-0.7l-0.17,-2.14l-3.57,-4.08l-1.03,-2.45l-0.88,-0.06l-2.97,1.37l-3.63,-2.19l0.69,0.2l0.8,-0.36l0.15,-0.46l-0.39,-0.73l-1.84,-0.31l-0.29,0.69l-0.72,0.48l-0.21,0.77l0.19,1.5l-0.24,0.32l-1.22,0.16l-0.84,0.51l-0.58,-0.43l-0.21,-1.14l-0.59,-0.91l-2.27,-1.56l-0.03,-3.98l-0.38,-0.4l-2.1,-0.09l0.0,-2.84l1.05,-3.56l-2.38,-2.97l-1.03,-2.21l-0.83,-0.6l-1.27,0.02l-5.5,-3.8l-1.96,-0.28l0.44,-1.85l-1.0,-1.8l-0.91,-0.72l-0.27,-1.04l-1.1,-0.07l-2.2,-2.72l0.96,-1.89l-0.74,-1.81l0.4,-0.91l1.01,-0.19l0.31,-1.89l1.71,-1.83l1.74,-1.07l0.13,-0.86l-0.38,-1.15l-0.94,-1.18l0.13,-0.84l0.21,-0.37l1.58,-0.58l0.3,-0.49l-0.2,-0.48l-0.95,-0.45l-3.11,-0.08l-1.23,-1.19l-1.38,-0.31l-0.92,-2.84l-1.37,-0.93l-0.23,-1.89l-1.06,-0.97l-0.82,-2.74l0.21,-1.31l-1.65,-1.47l-0.19,-1.57l0.23,-0.78l-1.97,-1.48l-0.74,-0.13l1.74,-3.57l-0.44,-0.59l-0.74,-0.15l-0.16,-3.61l-0.8,-1.09l0.1,-1.67l-0.76,-0.8l-0.29,-1.01ZM225.11,258.62l0.64,-0.41l0.16,-0.69l0.73,0.1l1.56,-0.62l-1.41,1.46l-0.78,-0.16l-0.9,0.32Z",name:"Iran"},AM:{path:"M133.7,137.72l5.31,-0.87l4.6,0.01l0.35,-0.5l0.62,-0.08l0.81,0.74l-1.29,0.59l0.3,0.87l0.61,0.07l0.36,-0.45l2.27,0.69l1.11,1.07l-1.31,0.9l-0.18,1.02l1.58,2.09l2.78,1.54l-0.52,1.31l-1.74,0.0l-0.63,0.66l4.82,3.73l1.1,-0.1l0.87,0.4l-0.9,0.95l0.15,0.5l1.2,1.02l-0.8,0.03l-0.28,0.45l0.61,0.92l0.05,1.15l-2.11,0.32l-1.07,-2.31l0.02,-0.85l-1.37,-0.97l0.06,-1.45l-0.44,-0.43l-0.76,-0.06l-1.65,0.57l-1.24,-0.74l-0.65,-0.01l-0.29,-0.86l-0.79,-0.69l-1.99,0.45l-1.49,-1.5l-2.11,-1.4l-2.29,0.19l-1.95,-0.72l-0.84,-2.96l0.94,-1.34l0.1,-0.93l-0.76,-2.01l-1.14,-1.0Z",name:"Armenia"},SY:{path:"M76.3,209.24l0.78,-1.3l-0.28,-1.24l0.26,-0.62l-0.51,-1.46l0.2,-0.69l1.24,-1.34l-0.07,-0.47l-0.54,-0.44l0.11,-0.31l0.73,-0.65l2.14,-0.14l0.12,-0.49l-0.59,-0.51l1.79,-1.52l0.45,-1.13l-0.6,-1.78l-1.0,-0.69l0.39,-0.45l-0.39,-0.91l-0.84,-0.28l-0.58,0.38l-1.63,0.02l-0.56,-2.32l0.4,-2.21l-0.29,-1.85l-0.99,-1.32l0.72,-2.42l1.8,0.68l0.65,-1.04l1.15,-0.75l0.19,-1.28l1.65,-0.36l0.34,-0.34l-0.72,-2.03l0.63,-2.49l1.73,0.32l1.19,0.96l2.75,0.08l5.74,-2.21l1.65,0.3l2.47,1.47l4.61,0.11l4.99,-1.25l5.14,-2.33l4.7,0.24l4.18,-0.76l1.3,-0.43l0.93,-0.75l0.49,0.36l0.27,1.06l-1.9,1.93l-2.13,1.89l-2.86,0.78l-1.02,1.32l-0.39,2.74l0.81,2.35l0.01,1.26l-1.03,3.02l-0.16,4.36l-1.75,2.99l-1.84,0.48l-14.35,8.07l-14.53,8.74l-3.06,-0.53l-1.12,-0.87l-1.17,-0.34l-0.76,-1.06l-1.01,-0.56Z",name:"Syria"},VN:{path:"M576.93,298.51l-0.51,-1.64l-0.78,-0.54l-2.47,-2.91l1.98,-2.57l2.48,1.12l1.27,1.17l1.55,-0.8l1.17,-1.62l1.09,1.31l0.65,-0.23l0.5,-1.12l1.92,1.68l0.6,0.06l0.44,-0.27l0.57,-1.49l0.49,-0.28l1.54,0.77l1.39,-0.82l1.27,-0.19l0.96,-0.95l0.37,-1.53l2.86,-1.51l1.3,1.08l0.6,0.99l2.08,1.11l2.44,-0.29l0.92,0.86l2.07,-0.36l1.29,0.73l-0.37,0.74l-0.94,0.61l-0.37,1.51l0.14,0.59l0.74,0.75l0.07,2.04l2.56,0.79l0.53,0.89l0.93,0.65l0.72,0.11l0.48,0.65l1.26,0.24l2.14,-0.43l0.58,0.42l-3.39,1.7l-0.6,1.9l-1.14,0.67l-0.66,-0.37l-1.43,0.37l-1.44,-0.38l-0.4,0.33l0.48,2.03l-1.38,1.48l0.04,1.26l-0.31,0.6l-2.5,2.19l-0.82,0.09l-0.73,0.54l-1.27,2.74l-0.21,2.38l-1.13,1.84l-0.08,0.98l2.05,3.67l4.39,4.08l-0.15,1.1l-0.77,0.02l0.12,0.62l1.13,0.7l1.67,2.29l2.79,2.32l0.58,1.32l2.52,1.78l2.47,2.7l1.33,-0.09l1.66,1.84l2.36,3.76l1.82,1.62l0.84,2.77l1.06,2.16l0.03,1.23l1.48,4.85l-0.3,0.38l0.19,4.34l1.14,2.62l-0.02,1.22l-0.47,-0.11l-0.95,0.87l0.34,1.63l-0.52,0.39l0.13,2.81l-0.5,1.52l0.29,0.85l-0.32,0.62l-0.86,0.38l-0.33,1.65l-1.2,0.23l-3.99,2.79l-1.28,0.28l-0.85,1.36l-1.1,0.17l-4.12,2.16l-1.15,-0.64l-0.46,-1.04l-0.71,-0.02l-0.4,1.85l-1.03,-0.97l-0.51,-0.09l-0.91,0.54l-0.19,0.4l0.3,0.33l0.82,0.08l0.14,0.43l-1.8,-0.07l-0.52,0.39l0.22,0.41l2.1,0.89l-0.78,0.82l-0.25,0.82l-3.09,-2.61l-0.52,-0.02l-0.09,0.51l0.35,0.6l2.45,2.47l0.4,0.99l-0.92,0.37l-3.22,-2.94l-0.84,-0.39l-0.48,0.13l0.02,0.49l2.41,3.01l0.28,0.55l-0.16,0.45l-4.87,2.23l-1.49,2.3l-1.45,1.2l-1.48,0.31l0.36,-0.57l-0.07,-0.58l-0.42,-0.3l0.2,-5.8l0.38,-1.4l1.47,-0.88l-0.07,-0.82l-0.63,-0.81l-1.13,-0.38l-0.44,-0.54l-1.28,0.05l-1.11,-1.3l0.48,-0.48l2.26,-0.26l1.53,-1.37l-0.09,-1.32l1.55,0.42l0.51,-0.11l0.48,-0.65l2.3,-0.3l0.84,0.96l0.69,-0.1l1.72,0.63l0.4,-0.5l-0.03,-1.85l-2.26,-1.96l-0.13,-2.15l0.54,-0.17l0.52,-0.66l2.19,0.55l0.8,-0.12l0.28,-1.97l1.77,-0.16l0.63,-0.58l1.29,-0.26l2.0,-1.65l0.57,-0.1l0.87,0.38l0.99,-0.95l0.4,-1.53l-0.59,-3.65l0.97,-3.21l-2.04,-5.21l0.23,-1.67l0.6,-0.64l0.66,-1.54l-0.36,-2.67l1.06,-1.4l0.15,-0.9l-0.78,-1.17l-2.07,-1.68l-0.7,-1.11l1.52,-0.9l0.14,-1.1l-3.61,-2.58l-0.66,-1.29l-1.33,0.28l-0.77,-1.14l-0.47,-2.49l-1.68,-1.97l-2.01,-1.57l-2.31,-2.43l-0.76,-1.89l-0.98,-1.33l-1.09,-0.41l-1.47,-1.51l0.18,-1.98l-3.34,-1.26l-4.49,-3.01l-1.41,-0.59l1.2,-1.11l-0.22,-1.32l1.3,-0.05l2.58,0.51l1.41,-1.22l1.32,-1.98l0.14,-0.79l-0.44,-0.98l-0.67,-0.44l-0.82,0.04l-0.47,-1.14l-1.38,-0.48l1.04,-0.77l0.02,-0.94l-1.79,-1.39l-1.94,-1.01l-1.95,0.68l-1.62,1.22l-3.75,-1.41l-1.74,-2.66l0.78,-2.71l-0.18,-0.78l-1.48,-1.06l-0.68,1.05ZM612.85,302.64l0.02,-0.06l0.03,0.02l-0.05,0.04ZM586.24,386.06l0.57,-0.22l-0.01,1.11l-0.18,-0.47l-0.38,-0.42Z",name:"Vietnam"},GE:{path:"M119.33,133.54l1.55,-2.34l0.06,-1.52l-2.13,-6.46l-0.7,-0.85l-2.04,-0.77l-0.55,-0.94l-1.69,-1.2l-2.83,-0.77l-3.29,-2.29l0.5,-0.74l2.93,0.42l1.01,-0.17l3.16,1.41l2.05,0.38l1.79,1.06l3.52,0.26l2.68,-0.31l1.23,0.63l1.39,-0.12l1.41,0.57l0.93,1.03l5.02,2.11l-0.32,1.13l0.82,0.54l1.12,0.07l4.19,-1.65l1.05,0.25l0.55,0.78l0.68,-0.05l0.49,-0.97l1.9,0.63l1.55,1.34l2.19,0.09l0.23,0.11l-0.65,2.11l0.22,0.56l2.45,1.57l1.94,0.42l1.21,0.63l-0.59,0.69l-0.95,0.41l-0.11,1.25l1.02,1.29l2.55,1.75l-0.26,0.81l-0.91,0.61l-1.98,-1.08l-1.24,0.22l-1.58,-0.46l-0.45,-0.31l-0.17,-0.72l-3.31,-1.02l-2.5,1.54l-1.15,0.15l-0.35,0.43l-4.03,-0.02l-3.27,0.74l-2.21,0.14l-0.49,-0.52l-1.43,-0.2l-0.32,-0.87l-3.2,-2.55l-1.35,0.05l-0.97,1.16l-3.92,-0.47l-0.86,0.54l-1.57,-0.52Z",name:"Georgia"},IL:{path:"M66.48,219.04l1.37,-2.38l3.17,-9.66l2.15,0.04l0.79,-0.61l0.24,-0.89l0.53,-0.01l1.02,-0.76l0.48,1.35l-0.25,0.5l0.28,1.14l-0.8,1.43l-1.61,0.91l-0.2,1.83l-0.83,-0.82l-1.7,-0.23l-1.12,0.8l-0.83,2.52l0.04,3.07l0.41,0.3l1.09,0.02l-1.48,1.09l-0.64,2.32l0.63,0.44l1.45,-0.12l2.1,-0.83l-0.28,1.47l0.26,0.89l-2.2,5.75l-0.02,2.36l-1.23,4.69l-4.6,-13.31l1.92,-2.46l-0.14,-0.82Z",name:"Israel"},IN:{path:"M322.9,278.6l0.38,0.21l5.32,-0.07l1.27,0.8l1.68,0.01l0.94,-0.3l0.53,-0.69l2.75,-0.92l0.43,1.03l1.13,0.35l2.74,-1.35l0.18,-0.55l-0.52,-0.57l-0.04,-0.58l0.56,-1.05l-1.29,-3.03l-1.64,-2.78l-0.04,-1.94l-0.86,-0.61l-2.16,0.04l-1.11,-1.47l-0.14,-1.05l0.41,-1.17l0.1,-2.48l-0.84,-0.83l-2.48,-0.42l-1.61,-0.88l0.35,-2.6l2.65,-2.76l1.84,-3.01l1.72,-1.27l1.22,0.52l0.56,1.44l1.1,0.59l2.99,-1.0l2.67,-0.31l2.47,-0.76l0.79,-1.89l1.73,-2.0l1.14,-2.58l4.28,-2.34l2.48,-4.31l1.09,-3.03l3.16,-1.31l0.98,-1.11l-0.21,-1.77l3.1,-3.58l2.24,-1.23l-0.01,-1.1l-0.66,-0.51l0.54,-2.18l-0.6,-2.16l0.25,-0.62l1.24,-0.97l3.79,-1.56l0.7,-0.74l0.09,-1.02l-0.92,-0.91l-1.85,-0.75l-2.18,-0.23l-0.22,-2.22l-2.33,-0.13l-0.3,-1.78l-1.32,-0.69l-0.82,-0.85l0.89,-1.3l0.26,-1.1l-1.3,-1.79l0.56,-0.69l1.19,-0.57l0.31,-0.72l-0.28,-0.71l-2.31,-0.44l0.48,-0.63l0.03,-0.68l-1.31,-1.12l1.1,-2.01l2.31,-0.86l4.75,0.99l1.75,0.07l1.98,0.85l2.17,0.26l2.44,-1.38l1.0,-0.01l2.0,-0.7l1.22,0.1l0.88,-0.54l0.56,-0.86l1.6,-0.77l0.5,-1.08l5.25,-3.06l0.64,0.29l0.82,-0.26l-0.18,1.74l2.41,5.55l2.69,0.85l2.04,1.59l-0.17,0.52l-1.42,0.96l-0.24,0.93l0.64,4.48l2.39,2.53l-0.22,1.03l0.75,0.99l0.1,3.18l-0.99,0.98l-0.73,0.16l-0.9,-0.75l-0.54,-1.09l-0.42,-0.13l-2.1,0.32l-0.52,0.68l0.83,2.72l1.35,1.61l-0.09,0.54l0.34,0.47l-0.15,1.2l0.72,1.02l-0.45,1.05l0.16,1.56l0.34,0.35l0.83,0.02l1.28,-0.47l0.37,-0.43l1.67,2.36l1.26,1.02l0.84,0.43l1.54,-0.15l2.02,1.45l0.71,0.09l-0.05,1.4l0.35,0.35l3.03,0.96l2.35,1.5l-2.46,1.88l-1.66,1.96l-1.12,2.54l-0.17,1.84l-1.11,1.66l-0.1,1.64l2.76,1.95l0.62,0.12l0.69,-0.39l4.26,2.5l1.1,1.3l4.1,2.53l1.21,-0.31l3.26,1.89l1.59,-0.04l0.61,1.31l4.11,1.18l1.39,-0.72l2.72,0.69l2.05,-0.86l3.61,1.43l0.49,1.96l3.51,1.64l0.5,0.74l1.03,0.2l2.34,-0.71l0.48,1.29l0.77,0.54l1.62,-0.34l2.57,0.56l2.67,1.13l2.21,-0.87l0.46,0.84l1.56,0.62l1.12,-0.47l1.56,0.17l1.58,-0.3l1.31,0.4l0.67,-0.62l0.82,-2.52l-0.4,-1.75l-0.92,-1.53l0.29,-2.13l0.92,-2.77l0.03,-0.85l-0.34,-0.44l2.12,-0.51l1.16,-0.64l1.2,0.53l0.28,0.95l-0.73,2.81l0.22,0.95l0.65,0.67l-0.76,0.6l-0.14,0.72l1.05,1.87l2.18,1.17l1.5,-0.2l1.71,0.47l0.4,0.55l1.23,0.14l2.71,-0.43l0.77,-0.78l0.82,-0.28l1.5,0.71l1.43,0.22l4.09,-0.15l1.16,-0.6l0.6,0.46l1.15,0.04l2.62,-0.46l0.58,-0.34l0.23,-0.55l-0.59,-1.48l0.63,-1.69l-0.97,-1.51l-1.82,0.06l-0.5,-0.33l-0.44,-0.65l0.28,-0.8l2.3,0.24l1.06,-0.64l2.23,-0.13l1.16,-0.49l1.04,-0.73l0.18,-1.47l2.52,-1.5l0.73,-0.75l0.82,-1.63l3.81,-0.83l1.13,-0.65l0.98,-1.24l0.63,-0.2l1.29,-1.3l2.31,-1.27l0.96,1.07l4.73,1.13l1.16,-0.99l0.17,-0.56l3.46,-1.75l1.52,1.58l-1.24,1.01l0.31,1.59l0.61,0.08l1.68,-1.02l0.74,1.78l-1.74,1.79l-0.44,1.09l0.18,0.4l1.05,0.43l1.61,-0.73l1.24,0.74l1.5,0.23l0.76,-0.22l1.42,0.99l0.16,1.89l-2.66,1.8l-0.78,1.08l0.23,1.55l1.41,2.08l-0.95,-0.48l-0.57,-0.88l-0.78,-0.46l-4.19,0.57l-1.17,0.47l-1.14,1.34l-3.26,2.32l-2.65,1.43l-0.51,0.98l-0.11,1.18l0.58,2.4l-0.76,0.85l-0.54,1.73l-1.12,1.36l-0.94,0.54l-0.72,1.21l-0.19,1.18l1.11,1.09l-0.87,2.1l-2.18,3.55l-1.16,3.34l-2.89,-1.02l-1.55,0.22l-0.79,-0.68l-0.86,0.21l-0.16,0.59l0.79,2.67l-0.36,4.18l-0.29,0.55l-0.89,-0.06l-0.42,0.54l0.05,0.78l-0.61,1.6l0.57,3.58l-0.72,0.29l-0.7,1.4l-1.45,-1.11l-0.57,0.22l-0.23,0.52l-0.5,-4.73l-0.99,-2.06l-0.2,-3.04l-0.66,-2.83l-1.11,-0.62l-1.71,0.29l-0.35,0.4l0.05,1.35l-1.33,1.63l0.0,1.78l-0.68,0.4l-0.43,-0.23l-0.76,-1.47l-0.87,0.09l-0.91,-2.82l0.47,-2.4l0.92,-1.22l1.06,0.04l1.44,-0.89l1.27,0.01l0.59,-1.27l1.19,-0.51l1.03,-3.6l1.2,0.25l0.62,-0.44l-0.19,-1.02l-2.02,-1.36l-1.38,-0.52l-12.03,0.09l-4.39,-1.08l0.12,-4.95l-1.2,-2.28l-0.97,-0.04l-0.36,0.44l-0.14,1.2l-0.96,-0.05l-1.22,-0.71l-0.47,-0.63l-0.34,-1.43l-0.48,-0.42l-1.07,0.08l-0.22,0.73l0.2,0.33l-0.52,0.04l-0.76,-0.22l-0.54,-1.04l-0.89,-0.81l-1.01,-0.48l-0.67,0.31l-0.15,0.89l0.69,0.62l-2.11,2.2l-0.56,2.02l0.59,0.77l0.85,0.23l0.71,0.63l1.1,1.34l0.92,0.42l1.12,0.03l0.31,0.89l0.81,0.56l-1.06,0.32l-2.19,-0.15l-0.38,0.27l-0.89,2.16l-0.8,-0.29l-0.59,0.27l-0.98,2.39l1.18,1.58l1.15,0.1l0.7,0.65l2.25,0.79l-0.21,1.8l-0.98,2.86l1.24,1.83l-0.23,0.96l0.19,0.58l1.36,0.51l-0.45,1.06l0.55,3.31l0.94,2.74l-0.12,2.18l-0.58,0.61l0.67,1.68l-0.38,-0.01l-0.68,-0.76l-0.73,1.06l0.28,-2.83l-1.13,-1.2l-0.38,0.3l-0.56,2.28l0.19,1.14l-0.63,0.22l-1.33,-1.07l-0.47,1.03l-0.53,-0.06l-0.19,-0.18l0.97,-3.34l-2.42,-2.28l-0.28,0.45l0.15,0.94l1.34,1.05l-1.35,2.0l-1.85,1.23l-4.35,1.21l-1.97,2.2l-0.18,1.39l0.89,3.07l-1.45,1.96l-0.07,0.76l-1.77,1.04l-0.81,1.11l-0.9,-0.24l-0.28,0.68l0.35,0.38l-0.41,0.19l-4.39,1.43l-0.28,-1.19l-0.79,-0.25l-1.88,1.14l-0.76,1.19l0.01,0.43l0.52,0.37l-3.38,2.95l-0.65,1.3l-4.35,5.15l-3.35,1.73l-3.41,3.56l-4.46,2.54l-1.82,1.41l-0.7,1.18l0.53,1.54l-0.64,1.44l-3.49,1.65l-2.6,-0.26l-1.0,0.23l-0.64,0.82l-0.76,2.21l-1.11,1.39l-0.62,-0.14l-0.45,-0.67l-1.08,-0.23l-2.16,0.81l-0.81,0.71l-1.53,3.09l-0.39,2.01l0.93,4.64l-0.49,2.1l0.99,3.49l-0.57,-0.03l-0.71,0.82l-0.03,0.48l2.01,1.74l-0.82,4.92l-0.62,1.73l-2.16,3.59l-0.79,3.19l0.26,0.98l-0.61,0.79l-0.06,0.48l0.93,0.07l0.18,0.65l-0.07,6.26l-1.97,-0.13l-1.06,0.18l-0.82,0.53l-0.53,0.87l0.03,0.92l-2.37,3.6l-0.11,1.12l0.64,0.82l-4.13,1.22l-1.23,0.94l-0.76,0.97l-0.5,2.85l-0.41,0.79l-2.04,1.38l-1.79,0.76l-1.36,-0.42l-1.69,-1.23l-3.75,-4.35l-1.66,-4.01l0.77,-0.17l0.23,-0.48l-0.84,-2.92l-1.12,-1.22l-0.01,-0.98l-2.05,-4.35l-1.49,-4.39l-1.57,-2.72l-2.42,-2.65l-1.84,-3.76l-1.3,-3.86l-0.75,-4.53l-1.29,-2.91l-0.9,-3.48l-3.22,-4.41l-0.58,-1.89l0.38,-0.67l-0.96,-1.15l0.25,-0.36l-0.34,-0.63l-0.8,-0.21l-1.49,-2.59l-1.02,-3.05l-1.38,-9.0l-1.2,-3.62l-0.89,-4.27l0.97,-2.9l-0.6,-1.33l-0.85,1.12l-0.06,-0.21l-0.03,-1.21l0.96,0.12l0.44,-0.29l-0.22,-0.47l-1.36,-0.6l0.04,-1.22l-0.43,-0.36l-0.4,-1.77l1.68,-6.59l-0.61,-3.55l-0.95,-0.59l-0.4,-1.19l0.62,-0.56l0.12,-0.49l-0.26,-0.13l2.93,-1.55l0.16,-0.51l-0.5,-0.21l-1.93,0.47l-1.69,-0.06l0.22,-0.85l0.82,-1.06l-1.25,-0.23l0.14,-0.86l1.66,-0.45l0.29,-0.38l-0.29,-0.39l-1.7,-0.37l-1.07,0.22l-2.04,-0.16l-0.39,0.32l0.86,0.84l-0.16,0.52l-1.7,1.97l0.13,0.63l0.93,0.36l0.47,0.66l-0.02,0.8l-1.63,2.72l-7.28,3.2l-2.07,-0.01l-1.67,-0.74l-3.29,-2.58l-2.17,-2.59l-4.15,-3.8l-1.53,-2.11l0.29,-0.67l1.05,0.94l0.71,0.17l1.95,-0.92l0.69,0.03l0.69,-0.46l0.75,0.03l1.32,-0.72l1.25,-0.2l2.15,-3.21l0.45,-0.21l0.23,-0.4l-0.21,-0.79l-0.88,-0.15l-0.75,1.0l-1.63,0.03l-3.3,1.46l-3.07,-0.68l-3.05,-1.58l-1.24,-1.01l-1.52,-2.74l2.46,-1.91l0.13,-0.51l-0.49,-0.2l-1.04,0.36l-2.61,1.58l-0.36,-1.42l1.25,-0.53l2.48,-0.1l0.41,-0.39l0.03,-2.19ZM510.38,409.89l0.46,1.53l-0.26,0.91l-0.96,-1.53l0.07,-0.64l0.69,-0.26ZM502.0,376.41l-0.73,-2.04l0.46,-0.43l0.48,-1.76l0.55,-0.06l-0.74,1.46l0.36,0.73l-0.38,2.09ZM502.93,370.91l-0.34,-0.32l0.01,-1.24l0.16,-1.82l0.51,-0.85l0.37,0.44l0.17,2.11l-0.94,0.92l0.06,0.77ZM503.37,365.59l0.26,-2.41l0.75,-0.98l-0.3,1.27l0.32,0.54l-1.03,1.58ZM500.23,384.16l-0.24,-0.02l-0.13,-1.21l0.57,-0.59l0.25,0.86l-0.45,0.96Z",name:"India"},AZ:{path:"M146.29,137.61l0.31,-0.42l-0.14,-0.46l-1.19,-0.85l1.66,-1.14l2.69,0.83l0.36,0.77l1.56,0.71l0.87,0.19l1.08,-0.25l2.09,1.1l0.96,-0.25l0.8,-0.8l0.28,-1.52l-2.74,-1.99l-0.84,-1.11l0.05,-0.36l0.72,-0.2l0.89,-1.05l0.62,0.68l1.35,-0.09l2.92,2.63l0.77,1.61l0.58,0.49l3.73,0.81l0.9,-0.29l1.4,-2.1l2.48,-1.29l1.21,-1.93l3.16,3.87l1.28,3.05l1.8,2.12l2.06,1.78l3.01,0.66l1.38,1.34l-2.81,-0.15l-3.0,1.27l-0.6,1.06l-1.13,4.18l0.28,2.16l-0.7,0.7l-0.48,1.73l-0.85,-0.64l-0.9,0.58l-0.89,2.3l0.09,3.19l-1.31,0.29l-1.44,-1.56l-0.89,-0.28l-0.7,-0.92l-1.38,-0.93l1.64,-0.6l0.54,-0.51l-0.11,-1.04l-1.24,-1.09l1.48,-1.09l0.08,-0.54l-2.77,-2.68l-1.81,0.33l-2.3,1.36l-2.2,1.41l-1.46,1.36l-1.09,0.35l-2.04,1.96l-0.32,-1.72l0.88,-0.3l0.06,-0.59l-1.44,-1.33l0.73,-0.52l0.03,-0.84l-1.43,-0.86l-0.97,0.13l-3.58,-2.86l1.32,-0.16l0.78,-1.51l0.01,-0.7l-3.09,-1.91l-0.78,-0.93l0.78,-0.43l-0.1,-0.73l-0.66,-0.19l0.95,-0.7l-0.04,-0.82l-1.37,-1.31l-1.8,-0.5ZM148.08,141.25l-0.07,0.14l0.0,-0.02l0.07,-0.12ZM143.77,150.11l1.2,-0.38l0.53,0.63l0.19,0.87l0.88,0.02l1.49,0.8l2.24,-0.57l-0.06,1.5l1.4,1.03l-0.08,0.63l0.93,1.93l-3.87,-0.93l-2.44,-2.08l-2.4,-3.44Z",name:"Azerbaijan"},ID:{path:"M789.33,474.14l1.38,-1.54l0.5,-1.3l-0.0,-0.92l3.92,-1.03l2.44,-1.87l1.87,-0.69l3.25,0.45l4.58,2.3l3.81,0.16l0.65,0.47l-0.17,1.23l1.36,2.55l-1.13,2.76l0.68,4.46l2.0,3.96l0.4,0.23l0.59,-1.18l-0.04,-0.97l0.35,-0.17l0.49,2.77l0.33,0.3l0.81,0.01l0.32,1.91l1.81,1.2l2.12,0.2l1.17,-0.34l2.83,-2.66l1.11,-1.9l1.81,-1.25l0.97,-2.14l3.21,-0.53l1.82,-0.72l0.99,-0.93l-0.34,-1.22l4.78,-2.47l6.06,2.27l1.21,0.95l7.33,3.23l2.8,0.05l0.74,0.46l2.75,0.25l1.04,1.22l1.3,0.02l0.01,27.59l-0.84,2.98l0.84,1.43l0.01,15.75l-2.99,-3.29l-3.59,-3.15l0.9,-1.62l-0.14,-0.51l-0.53,0.08l-1.2,1.2l-3.92,0.65l-1.0,-1.54l-2.46,2.02l0.42,-1.96l0.52,-0.65l0.64,-1.89l-0.34,-0.77l-0.85,-0.46l-1.09,-1.32l1.83,0.12l0.86,-0.28l0.27,-0.48l-2.71,-0.68l-1.41,-1.08l1.45,-0.24l0.25,-0.65l-3.14,-3.8l-1.0,-2.81l0.55,-0.88l-1.13,-0.38l0.86,-0.89l-0.44,-0.28l-1.59,0.29l-0.05,-1.54l-2.46,-1.85l-3.26,-1.75l-0.15,-0.38l-0.61,-0.18l-0.32,0.21l-0.69,-0.41l-3.54,-0.8l-4.86,-2.18l-3.99,-0.66l-1.85,0.06l-3.13,-1.82l-0.43,-0.67l0.08,-0.46l1.09,-0.1l0.36,-0.39l-0.35,-0.4l-1.06,-0.12l-1.47,0.42l-1.05,-0.47l-1.01,0.18l-1.02,-1.07l-1.09,0.17l-1.99,-2.23l0.11,-1.47l1.05,-1.42l-0.28,-0.61l-0.83,-0.02l-0.83,0.78l-0.2,1.78l-0.6,0.13l-0.41,0.49l0.16,0.67l-0.93,1.58l-0.06,1.1l-0.99,1.07l-2.04,0.03l-1.03,-2.27l0.81,-1.34l-0.94,-2.03l-3.11,-2.49l-2.21,-0.48l-0.28,-0.36l1.45,-0.65l3.86,0.73l2.32,-2.25l0.92,-0.29l2.94,0.8l0.71,0.55l0.57,-0.31l0.3,-1.04l1.11,-0.47l0.09,-0.97l-0.4,-0.37l0.57,-1.11l-0.55,-0.38l-1.54,0.64l-3.61,0.19l-1.92,0.42l-3.32,-0.4l-1.43,0.17l-1.92,-1.74l-0.62,-2.99l-0.39,-0.38l-1.41,-0.13l-3.25,-1.1l-1.9,0.36ZM839.2,526.43l1.24,-2.99l1.27,-2.13l1.22,-1.0l2.52,-0.81l1.51,0.07l1.22,1.28l0.14,0.58l-1.4,2.52l-1.81,1.56l-1.64,0.91l-4.26,0.02ZM846.09,526.2l0.98,-0.72l0.56,0.91l-1.54,-0.19ZM825.18,476.4l2.6,0.11l1.48,0.5l2.3,0.09l-3.37,0.37l-3.0,-1.07ZM822.33,469.12l1.47,0.16l0.45,0.26l-0.52,0.3l-1.4,-0.73ZM824.31,469.56l1.05,-0.04l3.09,2.59l-1.2,0.32l-1.42,-0.3l-1.0,-2.39l-0.52,-0.18ZM818.29,471.77l-0.21,-0.04l-0.17,-0.42l0.16,-0.02l0.22,0.48ZM813.05,509.18l0.58,0.0l0.41,-0.43l0.29,-1.17l-0.44,-0.67l1.84,-2.07l0.83,1.72l-0.21,1.93l0.3,1.44l-0.27,0.81l-0.38,0.3l-1.15,-0.18l-1.79,-1.67ZM812.51,512.73l0.68,-0.38l-0.5,-0.69l-0.07,-1.13l2.32,1.74l-1.23,2.35l-0.79,0.47l-0.67,-0.65l0.27,-1.71ZM801.88,507.73l-0.08,-0.13l0.08,-0.65l0.16,0.53l-0.16,0.25ZM791.1,523.43l-0.89,-0.08l-0.19,-0.61l0.31,-1.04l0.85,-1.69l0.66,-0.35l1.27,-1.43l0.18,-0.61l0.39,-0.12l0.2,0.11l-0.55,0.73l0.32,1.17l-0.44,1.23l-1.78,1.74l-0.35,0.94ZM785.68,465.9l-0.54,-0.57l-1.3,-0.15l0.15,-0.41l1.73,-0.18l0.72,0.99l-0.75,0.32ZM787.02,466.29l0.59,0.08l0.14,0.13l-0.57,0.11l-0.15,-0.32ZM787.04,464.3l2.01,0.13l1.67,0.73l0.19,0.68l-0.29,0.25l-0.91,-0.29l-0.96,0.12l-1.72,-1.62ZM789.08,524.99l0.05,-0.05l0.02,0.01l-0.07,0.04ZM786.92,471.18l1.16,-0.36l0.96,0.27l-0.49,2.26l-0.95,-0.47l-0.68,-1.7ZM766.27,488.64l-0.3,-0.69l2.11,-2.36l5.81,-0.26l0.94,0.8l1.35,-0.39l1.07,-0.71l0.68,0.0l3.32,1.4l2.85,0.08l1.28,0.95l0.69,1.82l0.9,0.44l0.47,0.8l-0.29,1.53l-5.37,-2.63l-1.33,-1.11l-2.56,-0.1l-0.53,0.55l0.05,0.41l-3.38,-0.88l-0.29,-0.67l-0.42,-0.11l-1.12,0.34l-1.17,1.21l-0.72,0.09l-0.48,-0.16l-1.4,-1.59l-0.89,-0.41l-0.85,0.41l-0.42,1.23ZM780.17,477.84l3.58,-1.0l0.41,0.54l-0.24,0.82l-1.38,0.56l-2.37,-0.92ZM778.8,522.63l0.94,0.13l-0.18,0.93l-0.79,-0.7l0.03,-0.36ZM763.29,456.66l-0.79,-2.23l0.82,-1.51l0.7,-2.8l2.1,-2.2l-0.75,1.07l-0.18,0.98l0.94,1.15l0.0,2.49l-0.83,1.09l-1.69,1.08l-0.32,0.87ZM763.89,457.48l0.97,0.44l0.99,-0.17l0.68,-1.6l1.34,-0.77l0.14,-1.37l0.36,-0.47l1.41,-0.82l1.5,-0.35l0.03,2.9l-2.85,1.55l-0.49,0.89l0.2,0.84l2.85,1.59l0.21,0.87l-1.41,-0.63l-3.46,-0.6l-0.67,0.3l-0.37,0.77l-0.08,2.61l0.69,2.29l1.8,3.22l-0.66,-0.29l-1.13,-2.05l-1.42,-1.29l0.15,-3.72l-1.16,-1.71l-0.12,-0.79l0.52,-1.65ZM769.72,447.96l-0.89,0.1l-0.34,-1.46l0.71,-1.09l1.54,-0.83l0.41,0.59l-0.43,1.63l-0.48,0.8l-0.53,0.26ZM770.98,517.22l0.07,-0.02l-0.01,0.06l-0.06,-0.04ZM766.39,491.38l0.34,-0.3l0.21,-0.03l-0.29,0.14l-0.26,0.19ZM767.55,490.94l0.67,-0.35l-0.17,0.61l-0.49,-0.27ZM766.43,525.21l0.01,0.0l0.11,-0.0l-0.03,0.03l-0.08,-0.03ZM767.16,475.96l-3.99,0.3l-0.88,-0.4l0.4,-0.99l1.11,-0.75l3.36,1.84ZM761.78,466.79l0.31,0.27l0.62,-0.11l0.26,-0.47l0.61,0.79l-0.45,0.83l0.4,0.98l-0.85,0.24l0.16,-0.66l-1.25,-1.34l0.2,-0.52ZM764.02,469.29l0.79,0.03l0.27,0.36l-0.41,0.22l-0.64,-0.6ZM760.63,469.19l0.05,-0.12l0.05,0.15l-0.09,-0.02ZM760.49,467.14l-0.3,0.09l-0.05,-0.4l0.25,-0.77l0.11,1.08ZM757.75,487.23l1.12,0.53l1.5,1.99l-0.08,0.85l-1.95,0.95l-1.71,0.4l-0.93,-0.35l-2.61,-1.35l-0.99,-1.48l0.06,-1.37l0.81,0.26l2.66,-0.6l2.11,0.14ZM757.21,433.23l0.01,-0.01l-0.0,0.01l-0.01,0.0ZM757.81,431.67l-0.55,-0.64l0.14,-0.88l0.5,1.37l-0.1,0.14ZM750.41,523.01l1.0,-1.32l1.73,0.26l2.79,-0.97l0.69,0.53l-1.13,0.53l-0.7,0.9l-2.53,-0.45l-1.85,0.52ZM747.5,477.65l0.38,-0.04l1.32,0.09l-1.63,0.15l-0.07,-0.2ZM750.49,477.62l1.14,-0.09l0.2,0.02l-0.72,0.12l-0.62,-0.06ZM750.92,479.55l-0.08,-0.27l0.13,-0.24l-0.06,0.52ZM748.22,437.51l0.03,0.04l-0.03,-0.01l0.0,-0.03ZM743.62,476.88l0.82,0.28l0.59,-0.2l0.46,0.47l-1.5,0.42l-1.42,-0.31l-2.24,0.81l-0.5,-0.01l-0.45,-0.75l0.3,-0.99l0.47,-0.16l1.27,-0.06l2.21,0.5ZM745.7,477.42l0.14,-0.02l0.02,0.01l-0.16,0.01ZM704.86,464.54l0.67,-0.32l0.35,-0.64l-0.38,-1.56l0.7,-1.38l0.9,-0.91l0.22,-1.01l1.46,-1.75l0.61,0.71l0.88,0.3l0.92,-0.29l1.28,-1.46l0.85,-1.63l0.55,-0.33l0.65,-0.1l0.97,0.48l1.35,0.12l0.78,1.0l0.7,0.33l2.14,-0.14l4.23,0.52l2.94,1.27l1.84,-0.7l5.9,0.77l3.32,-1.42l1.09,-1.24l1.03,-0.48l0.49,-1.14l1.28,-0.5l1.4,-1.67l0.9,0.27l0.37,0.77l-0.72,0.71l-1.14,2.23l-2.02,1.93l-1.35,1.98l-0.59,0.59l-1.4,0.6l-5.09,0.6l-1.77,-0.16l-1.34,-1.15l-0.84,-0.13l-8.69,0.42l-2.46,-0.46l-3.77,0.42l-3.29,-0.64l-1.86,0.64l-1.29,1.45l-1.42,3.65l0.37,2.87l1.43,2.52l2.03,1.25l0.64,1.6l0.81,1.04l2.66,0.26l1.16,-0.55l1.08,-1.76l1.97,-1.99l1.09,0.7l1.85,0.06l2.35,-1.32l4.52,-0.01l0.37,-0.44l-0.16,-0.5l1.88,-0.43l1.27,0.47l0.28,0.68l-0.26,1.25l-0.33,0.19l-1.76,-1.11l-1.42,0.24l-0.83,0.58l-2.23,2.84l-1.83,1.48l-2.87,1.01l-1.54,1.51l-1.64,-0.44l-0.46,0.1l-0.39,0.56l0.2,0.92l1.67,1.53l1.36,0.61l2.3,3.75l1.54,1.18l0.08,0.97l0.62,0.86l-0.56,0.67l-0.39,2.87l2.47,2.01l0.76,1.42l0.7,0.29l0.61,-0.26l0.18,1.66l-0.74,-0.33l-0.61,0.56l-1.54,0.02l-2.74,0.91l-0.68,0.93l0.08,1.25l-0.69,0.09l-2.23,-0.59l-0.59,-1.03l0.39,-2.11l0.54,-1.02l-0.07,-0.81l-0.6,-0.58l-1.72,-0.75l-3.0,-2.79l1.22,-2.49l-0.1,-3.4l-0.7,-0.76l-0.83,-0.19l-1.98,0.21l-2.36,1.53l-0.78,0.9l-0.02,0.97l1.01,2.13l0.32,2.63l-0.55,2.79l0.43,4.03l-1.05,3.95l1.04,2.72l-3.1,0.14l-1.67,0.86l-1.69,-1.16l-0.56,-0.63l-0.09,-0.63l1.15,-3.15l0.0,-1.13l0.72,-2.42l0.09,-2.92l-1.08,-2.37l0.04,-1.47l-1.22,-0.88l-2.77,0.54l-0.33,-0.25l-0.58,-1.33l0.17,-2.69l-0.53,-1.3l2.28,-1.74l0.6,-2.56l1.14,-1.64l0.2,-0.97l-0.28,-2.97l1.44,-3.6l1.14,-1.35l0.69,1.01l0.45,0.18l0.3,-0.38l-0.89,-5.64ZM736.59,534.43l0.65,0.46l1.5,0.02l1.11,-0.94l0.32,-0.91l2.8,-1.45l0.68,0.57l1.03,-0.38l-0.17,0.55l-0.73,0.03l-0.51,0.53l0.75,2.11l-2.51,2.9l-2.0,1.7l-1.75,0.24l-2.44,1.21l-0.67,0.02l-0.7,-0.31l0.76,-1.13l-0.16,-0.53l-0.73,-0.47l0.54,-1.87l2.23,-2.34ZM739.69,526.62l0.3,-0.38l-0.09,-0.61l0.49,-0.44l0.74,0.46l1.0,-0.28l2.39,0.23l0.02,0.44l-4.84,0.58ZM738.25,526.06l-0.87,1.35l-0.81,-0.7l1.04,0.05l0.63,-0.7ZM731.61,527.45l1.11,-0.79l0.05,-0.48l0.71,0.19l1.02,-0.53l-0.5,0.72l-0.64,0.17l-0.4,0.77l-0.89,0.22l-0.47,-0.27ZM733.01,475.86l0.15,0.17l-0.02,0.09l-0.13,-0.02l0.01,-0.25ZM728.24,475.03l-0.26,-0.63l0.5,-1.4l1.79,-0.17l-2.03,2.2ZM730.66,474.31l0.09,0.01l-0.08,0.05l-0.01,-0.07ZM731.28,474.11l0.47,-0.63l0.45,-0.08l0.46,0.35l-0.47,0.81l-0.91,-0.45ZM728.06,545.35l0.04,-0.38l1.57,-0.49l1.76,-1.46l0.19,0.55l-1.26,1.05l-2.31,0.73ZM729.8,526.35l0.37,-0.31l0.87,0.03l-0.08,0.29l-1.15,-0.01ZM726.57,505.77l-0.28,-0.74l1.35,-2.24l0.65,-4.35l0.9,-1.29l0.76,0.85l0.09,0.81l-1.0,0.33l-0.65,3.17l0.07,0.35l0.84,0.13l0.74,0.68l-0.7,0.43l-0.85,0.03l-0.97,1.82l-0.95,-0.0ZM729.17,494.09l1.2,-0.03l0.04,0.33l-0.68,0.62l-0.57,-0.92ZM705.88,527.5l2.53,-1.18l2.61,-0.3l1.0,0.55l1.9,0.32l3.37,1.63l4.0,-0.89l1.97,1.18l0.65,0.09l1.14,-0.33l0.87,-1.23l2.69,-1.32l-1.25,1.05l0.03,0.87l-2.49,0.92l-0.98,0.08l-1.0,-0.06l-0.77,0.11l-3.09,1.08l-0.63,-0.51l-1.32,-0.05l-0.8,0.74l-0.94,-0.13l-1.11,0.29l-3.54,-1.0l-1.78,0.13l-1.63,-0.31l-1.31,0.48l-0.52,-0.79l0.4,-1.43ZM728.29,525.01l-0.42,-0.09l0.33,0.02l0.09,0.07ZM724.05,503.6l0.27,-1.16l0.54,-0.75l-0.3,-1.92l2.04,-0.94l0.18,1.77l-1.01,1.42l0.03,1.48l-0.38,0.24l-0.79,-0.36l-0.58,0.23ZM720.93,502.15l0.62,0.76l-0.12,1.31l-0.94,-1.15l0.45,-0.92ZM720.23,543.0l0.44,-0.43l0.34,-0.02l-0.55,0.41l-0.23,0.04ZM706.07,534.07l1.84,1.37l0.47,0.99l1.4,0.16l0.62,0.43l1.7,1.8l0.11,0.63l-0.67,0.63l-1.69,0.55l-1.31,-0.32l-1.32,-0.78l-0.92,-1.19l-2.54,-1.52l-3.9,-0.54l-0.69,-0.98l1.35,-0.7l3.1,-0.23l1.3,0.2l1.15,-0.51ZM702.37,528.21l0.22,-0.47l0.21,0.05l-0.06,0.15l-0.36,0.27ZM693.04,526.41l0.72,0.45l1.53,-0.65l0.67,0.05l0.64,0.92l0.65,-0.13l0.38,-0.6l0.71,-0.04l1.18,2.42l-1.95,-0.07l-0.56,0.18l-0.25,0.54l-1.8,0.36l-0.09,-0.98l-0.75,-0.28l-1.32,1.18l-2.33,0.64l-1.08,-0.05l-1.64,0.65l-2.17,0.19l-1.07,0.47l-1.71,-0.58l0.33,-2.98l2.29,-1.13l1.29,0.44l1.51,-0.01l1.57,1.98l1.43,0.27l2.25,-0.78l0.15,-0.9l-1.07,-0.93l-0.98,-0.17l-1.11,-0.8l-0.4,-0.87l0.92,-0.34l1.29,0.22l0.79,1.34ZM624.73,453.92l0.32,-1.2l1.4,-1.48l0.79,-1.6l0.57,-0.24l0.23,0.98l0.47,0.31l0.21,1.21l0.61,0.69l4.36,3.97l1.76,1.11l4.44,-1.41l2.81,0.41l2.57,-0.14l0.92,-0.77l1.34,-0.42l0.81,-2.15l1.88,-0.75l3.35,-0.06l0.1,0.67l0.44,0.33l4.78,1.45l2.12,-1.48l3.43,-0.44l1.13,0.3l1.1,-1.45l0.44,-1.58l0.82,-0.52l0.22,-0.91l-0.41,-1.57l2.94,-2.09l-0.01,-0.9l-0.63,-0.47l0.22,-1.45l0.71,-0.74l1.04,0.04l0.82,-0.43l0.87,-3.2l0.01,-3.59l0.74,-1.77l1.17,-1.05l0.92,0.4l1.13,-0.45l1.83,0.33l0.96,-0.41l4.28,0.22l1.22,0.26l1.37,0.81l-0.09,0.78l2.13,2.46l-0.52,0.13l-0.74,-0.59l-0.66,0.21l-0.19,0.44l-2.01,-0.06l-0.87,0.12l-0.34,0.39l2.26,1.73l-0.23,0.93l0.24,0.77l1.88,0.96l-0.32,0.83l0.66,0.44l0.04,0.65l0.97,0.48l0.77,1.52l1.29,1.56l-0.09,0.39l-1.72,1.31l-0.07,0.72l2.13,2.4l4.18,2.87l2.38,2.1l-1.34,0.78l-1.57,0.18l-2.4,-0.43l-1.29,-1.21l-0.78,-0.45l-0.48,0.07l0.3,1.69l-1.62,1.18l-1.71,3.82l-0.45,4.24l0.8,3.1l-2.33,1.11l-2.24,2.13l-0.51,-0.17l-0.74,-1.17l-0.38,0.3l0.13,2.03l-1.38,0.97l-0.34,0.98l-1.85,1.46l0.38,0.6l0.71,-0.03l0.17,0.7l-0.16,0.71l-0.71,0.57l0.12,0.69l1.44,0.48l0.05,1.1l-0.1,0.51l-0.99,-0.02l-0.65,0.55l-0.07,0.39l0.49,0.41l-0.28,1.72l-0.35,0.31l-0.29,-0.21l-0.62,0.23l-0.07,0.63l0.5,0.77l-1.21,1.63l-0.68,1.71l-9.18,4.19l-0.25,-3.08l-0.6,-2.47l-0.29,-0.35l-0.87,0.73l-0.51,-0.29l0.29,-0.99l-0.2,-0.48l-0.51,0.12l-0.63,0.76l-0.92,-0.59l-1.23,0.91l-1.59,0.4l-0.66,-1.92l-0.54,-0.16l-1.55,0.4l-2.09,-2.12l-0.67,0.19l-0.43,1.75l-1.45,0.92l-1.04,0.52l-2.45,-0.55l-1.19,0.45l-1.71,1.25l-0.04,-3.42l-1.1,-1.47l-0.52,0.04l-0.45,0.52l-1.8,-0.3l-3.15,1.01l-0.34,-0.21l0.41,-0.79l-0.48,-0.19l-1.4,0.72l-0.99,-0.86l-2.02,0.63l-1.1,-7.06l-0.99,-1.09l0.56,-2.28l-0.43,-2.1l-0.89,-1.4l-1.51,-1.24l-2.88,-0.7l-0.03,-0.39l0.77,-0.78l-1.83,-1.67l-0.05,-1.14l0.99,-2.44l-2.34,-2.49l-0.27,-3.07l0.36,-2.36l1.15,-0.76l0.16,-0.42l-0.77,-0.31ZM689.33,432.89l1.07,-0.1l0.09,0.26l-0.8,0.22l-0.36,-0.38ZM688.52,438.39l0.19,-0.01l-0.04,0.25l-0.08,-0.07l-0.06,-0.17ZM688.18,525.84l-0.09,-0.44l0.43,-0.1l-0.34,0.54ZM676.77,529.94l0.76,-0.55l-0.1,-2.16l1.02,-0.92l1.12,-0.58l2.02,0.78l-1.52,3.24l0.09,0.45l-0.76,0.16l-2.62,-0.43ZM677.43,493.41l0.1,-1.05l-0.41,-1.51l0.63,-1.84l0.39,-0.25l0.37,3.12l-0.14,0.7l-0.94,0.84ZM665.5,525.06l3.09,0.52l1.84,-0.9l2.51,0.99l0.95,1.06l-2.63,1.44l-0.74,1.27l-0.04,-0.59l-0.76,-1.07l-1.72,-1.15l-1.67,-0.38l-0.83,-1.18ZM671.74,515.64l-0.41,0.09l-0.2,-0.1l0.96,-0.2l-0.35,0.21ZM596.42,514.63l0.11,-0.17l0.13,-0.12l0.08,0.21l-0.32,0.08ZM598.18,514.76l1.14,-1.95l1.0,-0.35l0.73,-2.71l1.15,-1.24l5.69,1.33l1.0,-0.27l0.85,-1.03l1.75,0.39l0.99,1.02l1.54,0.76l3.59,0.62l1.25,-0.16l1.32,1.32l0.6,1.81l0.87,0.74l4.61,0.57l1.64,-0.38l2.33,0.65l2.82,-0.05l1.94,0.34l1.32,-1.19l1.09,-2.43l1.31,-0.19l1.72,1.9l1.29,0.09l1.34,-0.38l1.51,0.93l1.77,0.23l0.81,0.67l3.18,0.2l0.76,2.06l1.03,0.6l0.02,1.75l1.86,1.11l1.83,0.48l1.96,0.06l4.21,-0.69l2.22,0.99l0.26,1.37l-0.42,3.1l0.54,1.37l0.91,0.84l-1.69,-1.01l-2.59,-0.38l-5.27,-2.14l-4.31,0.92l-4.16,-0.64l-4.53,-0.14l-6.69,-1.16l-4.26,-1.95l-5.75,-1.42l-4.09,-0.29l-1.47,0.35l-0.85,0.62l-3.75,-0.53l-2.7,-1.34l-2.03,-0.56l-6.08,-0.73l-0.14,-0.52l0.74,-1.34l-0.22,-0.54l-4.35,-1.48l-3.17,-0.03ZM654.92,517.5l-2.42,-0.71l0.79,-0.92l1.33,-0.13l6.62,-0.05l0.29,0.26l-0.93,0.28l-0.47,0.51l-1.37,0.03l-1.21,0.72l-2.63,0.02ZM651.59,507.15l0.02,-0.02l-0.0,0.02l-0.01,-0.0ZM629.22,472.23l-1.34,0.69l-0.13,-0.04l0.21,-1.38l1.22,0.14l0.23,0.38l-0.19,0.23ZM618.17,435.89l0.02,-0.02l0.08,-0.01l-0.1,0.03ZM618.38,435.83l0.47,-0.55l-0.28,-0.49l-1.07,-0.29l-0.43,-0.7l1.13,-1.07l1.0,1.28l0.01,0.85l-0.47,0.88l-0.36,0.1ZM613.87,485.59l0.62,-2.31l0.83,-0.17l1.71,0.45l0.91,0.65l0.42,0.73l-0.67,1.89l-0.81,0.66l-1.12,-1.0l-1.46,0.78l-0.43,-1.68ZM601.61,476.32l0.87,1.51l0.39,2.48l1.18,2.07l2.78,0.8l-0.96,2.1l0.31,1.02l-2.53,-1.29l-1.77,-0.49l-0.5,-1.02l0.14,-1.35l-0.58,-0.6l-0.68,-1.84l-1.77,-0.78l-1.76,0.29l-1.15,-0.49l1.64,-1.12l0.11,-1.3l0.47,-0.44l0.59,-0.22l0.69,1.26l0.66,0.02l0.4,-0.54l-0.09,-0.9l0.29,-0.08l0.93,0.17l0.35,0.75ZM530.39,424.92l2.72,-0.33l2.48,0.49l2.53,-0.04l2.62,2.37l0.68,1.61l1.82,1.83l-0.03,1.66l0.5,0.76l2.69,1.32l0.98,1.31l2.78,1.33l4.3,2.95l5.9,7.42l1.3,0.61l1.52,1.27l0.6,-0.39l-0.48,-1.94l0.42,-0.2l0.65,0.22l1.77,1.7l0.75,1.83l0.64,0.64l2.38,0.59l1.69,1.29l0.93,1.25l0.63,2.04l1.23,1.23l0.72,0.54l3.47,0.81l0.66,0.9l-0.25,0.33l-3.29,1.42l-0.26,0.47l0.44,0.31l2.65,-0.48l3.25,-1.74l0.79,0.19l1.35,1.33l0.7,1.44l-2.59,1.79l-0.16,1.25l0.67,0.82l-0.37,0.32l-0.08,0.69l0.83,1.57l1.47,1.03l2.67,1.06l2.12,0.17l1.02,5.6l0.54,0.93l1.88,1.11l-0.1,0.7l-1.34,1.48l0.01,1.56l0.96,0.2l1.38,-1.36l0.89,-0.36l2.6,0.15l1.24,0.75l3.36,4.47l0.08,0.58l-1.14,1.39l-0.45,1.58l0.05,1.0l0.58,0.85l-0.73,2.28l0.4,3.06l0.0,3.37l-0.52,4.94l-0.35,0.75l-0.52,-0.09l-0.7,-0.92l-1.3,-0.93l-0.74,0.12l-1.53,1.25l-3.08,-1.61l-0.57,0.22l-0.16,0.5l0.41,2.14l-3.87,-3.78l-1.82,-2.35l-6.85,-4.58l-2.81,-2.35l-3.04,-4.11l-4.1,-3.23l-1.59,-2.69l-1.88,-1.68l-1.65,-2.44l-0.27,-2.38l-2.75,-4.74l-1.36,-3.58l-3.35,-3.83l-1.51,-2.78l-2.58,-1.27l-1.15,-0.94l-2.67,-8.45l-1.56,-2.88l-3.96,-2.61l-2.73,-1.1l-0.8,-3.58l-1.59,-1.11l-3.15,-4.48l-1.34,-1.07l-2.6,-0.77l-1.59,-1.89l-5.47,-5.13l-2.06,-3.75l0.28,-0.92l-0.16,-0.88l0.93,-0.33l2.34,0.34l2.94,2.12l2.82,0.53ZM599.87,441.75l-0.0,-0.09l-0.01,-0.06l0.07,0.03l-0.06,0.12ZM590.63,465.03l0.37,-0.91l0.85,0.78l-0.91,0.24l-0.31,-0.11ZM593.0,465.4l0.03,-0.01l0.04,0.04l-0.06,-0.03ZM588.93,455.69l0.63,-0.44l1.15,-0.05l0.48,0.5l-0.01,0.7l-0.48,0.59l-0.37,-1.29l-0.46,-0.23l-0.95,0.22ZM589.16,467.04l1.01,-0.3l0.43,0.45l-0.4,0.65l-0.62,-0.01l-0.43,-0.79ZM586.69,455.6l0.28,-0.16l0.2,0.1l-0.19,0.32l-0.3,-0.26ZM583.2,466.09l0.26,-0.26l0.73,0.22l-0.47,0.13l-0.51,-0.09ZM580.69,459.3l0.04,-0.25l0.07,-0.11l0.18,0.35l-0.29,0.01ZM577.43,455.57l0.12,-0.16l1.43,0.67l0.68,0.71l-1.09,-0.85l-1.14,-0.36ZM575.86,455.84l3.0,1.71l0.05,0.24l-3.31,-0.81l0.26,-1.13ZM572.44,452.08l1.35,0.36l-0.78,-0.08l-0.57,-0.28ZM573.94,452.48l0.99,0.27l0.07,0.32l-0.4,-0.32l-0.66,-0.27ZM573.82,453.77l0.81,0.9l-0.12,1.3l-0.51,-0.94l-0.18,-1.26ZM573.27,503.85l0.97,0.44l-0.04,0.13l-0.23,0.01l-0.7,-0.58ZM569.22,448.44l0.36,0.65l-0.35,0.99l-0.59,0.37l-0.51,-0.09l-0.49,-0.96l0.03,-0.67l1.55,-0.3ZM558.51,485.09l1.28,1.34l-0.14,0.64l-1.01,-1.14l-0.13,-0.84ZM556.91,483.15l0.93,0.83l-0.3,0.47l-0.45,-0.01l-0.18,-1.3ZM553.83,479.28l0.22,0.16l0.51,1.03l-0.84,-0.6l0.11,-0.59ZM550.38,476.64l-0.51,0.03l-1.55,-1.07l-1.64,-2.92l0.45,-1.36l1.25,-0.2l1.51,3.63l0.96,1.31l0.02,0.4l-0.48,0.18ZM544.85,467.45l-0.26,0.08l0.72,-1.91l-0.06,0.84l-0.4,0.99ZM537.07,452.74l3.73,3.74l-0.54,2.57l-0.49,-0.11l-0.75,-1.78l-1.43,-0.9l-0.76,-1.62l-1.06,-1.18l0.55,-0.07l0.75,-0.64ZM529.81,445.7l-2.67,-1.77l-1.57,-0.47l-0.46,-0.71l0.65,-0.33l3.82,2.73l0.22,0.54Z",name:"Indonesia"},OM:{path:"M223.78,281.06l3.38,-0.67l0.29,-0.3l-0.45,-1.47l-1.1,-0.27l0.26,-4.83l0.69,-0.3l-0.25,0.67l1.14,1.14l2.12,-1.71l1.76,3.66l2.12,2.65l1.62,1.38l3.75,1.45l3.82,0.7l1.61,0.75l1.8,-0.16l1.27,0.87l1.96,3.07l2.97,3.68l1.01,0.78l1.88,0.47l-0.19,1.8l-3.17,5.6l-2.23,1.61l-1.3,1.38l-3.11,5.43l-1.27,0.02l0.2,-1.11l-0.45,-0.45l-0.63,0.09l-0.72,0.31l-1.78,2.51l-1.2,4.67l0.69,4.92l-4.45,0.72l-2.69,1.19l-1.36,1.35l-0.86,3.35l-1.11,1.22l-5.59,0.74l-1.26,0.47l-1.68,1.99l-0.21,0.8l0.41,1.01l-1.54,2.31l-1.94,0.51l-1.56,-0.49l-3.77,0.2l-3.53,1.9l-3.58,0.74l-1.98,-4.43l-0.59,-0.39l-5.4,-12.58l22.31,-7.89l4.97,-15.7l-3.38,-5.75l0.09,-2.41l2.31,-5.46l0.18,-0.91l-0.28,-0.81ZM247.35,309.88l0.0,-0.41l0.54,-0.61l-0.3,0.79l-0.24,0.24ZM248.53,308.01l0.2,-0.4l0.07,0.18l-0.27,0.22ZM228.41,263.74l0.31,-0.57l0.82,-0.1l0.38,-0.43l-0.33,3.33l-0.56,1.17l-0.36,-0.22l0.15,-2.76l-0.42,-0.43Z",name:"Oman"},KG:{path:"M333.84,133.42l1.81,-1.22l1.29,-1.33l1.2,-0.39l0.51,-0.99l2.75,-1.2l0.24,-0.51l-0.33,-0.57l-1.37,-0.73l-0.83,-0.02l0.93,-1.66l1.6,-1.66l3.59,-0.75l3.76,0.58l3.43,1.04l0.93,0.74l3.01,0.46l1.0,0.76l0.75,0.15l0.44,-0.52l-0.5,-1.57l0.95,-3.48l2.24,-1.01l0.53,-0.54l1.34,-0.0l0.6,-0.3l4.25,2.23l4.21,1.31l2.21,0.17l1.38,-1.08l5.05,0.16l3.55,-0.49l1.82,0.55l5.94,0.5l3.66,-0.07l2.7,0.81l1.83,0.02l0.38,0.88l1.76,1.69l3.68,0.64l1.99,1.86l0.2,0.82l-2.73,0.34l-0.69,0.92l-3.46,1.02l-4.15,2.01l-2.87,1.7l-0.29,0.97l-1.48,1.63l-2.25,0.18l-1.64,0.53l-4.35,-0.4l-0.86,0.18l-0.77,0.51l-1.24,1.84l-0.61,1.77l-1.46,1.67l-0.76,-0.52l-2.82,1.09l-1.14,-0.02l-0.54,-2.38l-0.56,-0.45l-3.42,1.52l-1.94,-0.32l-0.64,0.57l0.07,0.85l-0.9,0.24l-1.97,1.51l-3.29,0.96l-1.18,2.16l0.52,1.92l-0.49,0.68l-2.52,0.22l-2.64,0.86l-4.11,-0.13l-1.78,0.47l-0.72,0.87l-1.36,-1.13l-1.83,0.66l-0.31,-1.25l-1.47,-0.33l-0.05,-0.87l-0.65,-0.43l-3.16,1.0l-0.52,0.7l-1.26,0.12l-1.35,-1.46l-0.85,-0.22l-1.88,0.33l-0.56,-0.29l-1.73,0.26l-2.68,-0.18l-1.89,0.39l-0.45,-1.69l0.33,-1.19l1.21,0.22l0.53,-1.61l3.03,-0.86l0.66,0.22l2.71,1.05l0.49,0.78l-0.25,0.76l0.56,0.68l0.65,0.16l0.89,-0.38l0.19,-0.59l-0.27,-0.32l-1.06,-0.21l0.68,-0.5l0.21,-0.75l1.71,-0.69l0.01,0.93l0.46,0.52l-0.18,0.53l0.29,0.52l1.63,0.02l0.33,-0.32l-0.17,-0.81l0.26,-0.43l-0.29,-0.61l-0.9,-0.2l-0.78,-0.86l2.17,-0.26l1.43,0.63l0.91,0.01l0.78,0.5l1.93,-0.92l1.38,-1.61l1.76,0.26l0.46,-0.69l-0.19,-0.66l1.48,0.32l1.4,-1.17l2.73,-1.47l-0.24,-0.8l-3.56,-0.38l-2.13,-1.51l-1.14,0.14l-0.4,-1.32l-1.91,-0.17l-0.64,-1.78l-0.65,-0.42l-0.48,-0.9l-0.93,0.42l-0.15,1.53l-0.73,-0.17l-0.58,0.33l-0.07,1.45l-1.73,-0.13l-1.82,-0.62l-0.41,-0.24l-0.38,-1.21l-0.54,-0.58l-1.68,0.27l-1.78,-0.81ZM345.71,147.85l0.12,-0.51l-0.43,-0.47l-1.23,0.66l0.09,0.46l0.8,0.44l0.65,-0.58Z",name:"Kyrgyzstan"},UZ:{path:"M235.01,135.19l-0.38,0.4l-7.22,-0.5l-0.01,-32.71l18.68,-5.07l-1.24,2.18l-1.29,3.39l0.43,2.39l-0.39,1.23l0.7,1.14l0.78,0.02l1.18,-0.62l1.48,-2.22l0.55,-0.33l-0.18,-1.56l0.55,-1.23l-0.28,-0.48l-0.7,0.18l0.81,-1.1l-0.46,-0.93l-0.05,-1.12l4.44,2.62l-1.62,3.88l0.88,1.36l2.38,2.12l-0.8,1.35l0.51,0.69l2.08,-0.32l1.06,-0.65l0.04,-0.74l0.85,-0.92l-0.25,-2.44l0.36,-1.11l6.56,3.85l1.11,2.04l6.47,6.3l9.14,-1.24l9.21,0.7l3.4,-1.45l2.55,2.56l1.67,0.98l2.24,3.85l0.51,0.16l1.6,-0.74l-0.63,8.25l0.39,0.41l3.32,0.08l1.24,6.2l0.32,0.86l0.57,0.44l8.82,-0.28l1.03,1.2l-0.43,1.73l0.59,0.83l2.42,1.29l1.4,-0.01l0.52,-0.77l-0.32,-0.99l0.15,-0.68l1.09,-1.4l1.89,-1.48l0.64,-1.48l2.02,-0.94l2.24,-1.63l3.29,-1.36l2.33,-2.27l1.37,0.3l1.01,-1.21l2.11,-0.91l0.93,0.49l-2.53,1.07l-0.44,0.94l-1.23,0.44l-1.34,1.36l-2.01,1.35l-0.2,0.57l0.26,0.52l2.11,0.99l1.62,-0.31l0.55,1.44l0.77,0.57l2.02,0.69l2.03,0.24l0.65,-0.47l0.06,-1.22l1.11,-0.24l0.4,-1.1l0.62,0.37l0.89,2.05l1.85,0.11l0.32,1.36l1.44,-0.1l2.12,1.51l2.97,0.22l-2.11,1.0l-1.2,1.07l-1.66,-0.38l-0.4,0.63l0.2,0.8l-0.82,-0.42l-0.88,0.16l-1.5,1.67l-1.55,0.74l-0.4,-0.41l-0.89,0.03l-1.76,-0.69l-4.82,0.75l-0.78,-1.06l-0.95,-0.31l2.37,-2.04l0.47,-0.8l-0.25,-0.53l-0.5,-0.2l-0.31,-0.85l0.28,-0.59l-0.77,-0.87l-0.64,0.33l-0.71,-0.45l-0.47,0.06l-0.75,1.28l-4.15,1.99l-2.01,-1.2l-0.79,0.29l-0.44,0.45l-0.08,0.91l-0.78,0.89l0.66,1.91l-0.54,0.61l0.12,0.23l-1.83,-0.23l-2.24,0.35l-0.48,0.4l0.13,0.72l1.32,0.17l-0.28,0.55l0.25,0.62l-0.42,0.55l-0.95,0.33l-0.38,1.71l-0.49,0.52l-0.55,0.2l-5.24,-0.78l-1.43,0.63l-0.99,0.99l-0.57,1.96l0.25,0.69l2.09,0.69l0.1,0.82l0.46,0.48l2.06,0.03l0.94,0.36l-0.68,2.1l0.3,1.76l1.99,2.53l-0.76,1.55l-2.87,3.49l-0.41,0.88l-0.12,2.0l-1.76,-0.47l-1.47,0.47l-0.7,-0.17l-1.07,-0.89l-1.91,-0.32l-1.89,0.16l0.06,-3.23l0.78,-1.43l-0.54,-0.95l-1.52,-0.43l-3.17,-1.69l-0.85,-0.21l-1.77,0.28l-7.35,-4.47l-2.31,-1.91l-1.29,0.09l-2.83,-1.72l-1.93,-1.9l-7.31,-4.97l-0.51,-0.65l-0.49,-2.55l-0.61,-1.3l-0.87,-0.74l-0.64,-1.16l-1.1,-3.16l-1.28,-1.31l-2.48,-1.06l-1.9,0.77l-2.81,-0.53l-2.94,0.25l-2.59,-1.5l0.47,-1.53l-0.46,-1.25l0.64,-0.07l0.29,-0.56l-0.78,-1.1l-1.03,-0.46l0.27,-2.1l-1.15,-0.98l-3.9,-0.33l-1.34,-1.62l-2.16,-0.49l-2.12,-1.93l-0.62,0.13l-0.54,0.81l-1.74,-0.18l-0.89,0.6l-0.12,0.44l1.2,1.15l-1.99,-0.33l-0.69,0.68l-0.89,1.97l-1.02,0.19l-0.54,-0.82l-1.18,-0.67l-1.43,0.42l-1.4,3.21l-0.97,1.06l0.41,3.65l0.6,0.81ZM339.66,146.55l0.91,0.56l0.05,0.74l-0.49,-0.01l0.12,-0.53l-0.59,-0.76Z",name:"Uzbekistan"},MM:{path:"M501.87,308.34l-2.26,-2.73l-1.05,-3.71l0.63,-0.77l1.51,1.13l0.9,0.03l0.33,-0.59l-0.38,-5.03l0.64,-0.95l0.86,0.88l1.08,0.06l0.8,-1.56l0.88,-0.54l0.09,-1.09l-0.62,-2.76l0.58,-1.39l-0.03,-0.73l0.87,-0.01l0.58,-0.69l0.33,-2.1l0.18,-2.73l-0.73,-2.47l0.78,0.52l1.48,-0.24l3.04,1.06l0.73,-0.28l1.24,-3.53l2.17,-3.53l0.94,-2.27l-0.28,-1.07l-0.85,-0.49l0.17,-0.6l0.54,-0.94l0.93,-0.53l1.22,-1.47l0.58,-1.77l0.83,-0.97l-0.54,-2.69l0.49,-1.72l2.44,-1.24l3.25,-2.3l1.21,-1.39l0.86,-0.31l3.81,-0.56l1.57,1.55l1.42,0.2l0.31,-0.38l-0.06,-0.62l-1.47,-2.17l-0.16,-0.97l0.5,-0.65l2.83,-1.98l-0.02,-2.36l1.48,-2.18l0.46,0.06l0.7,1.04l1.0,0.12l1.42,1.56l1.51,4.79l0.65,0.32l0.41,-0.14l0.5,-0.79l1.08,0.52l0.63,6.78l-0.41,4.04l-0.56,0.28l-0.34,0.65l0.68,1.61l-1.38,0.54l-0.91,1.5l-0.85,-0.14l-0.57,0.27l-1.0,2.23l-1.52,0.44l-0.83,1.9l0.14,1.26l-1.1,0.7l-0.4,1.14l-0.01,1.25l1.02,1.05l0.29,1.08l-0.09,0.56l-0.85,1.05l-0.12,0.85l0.97,0.6l2.95,-1.43l1.39,-0.34l2.03,-0.04l0.79,0.35l0.91,-0.25l-0.5,0.55l-0.18,1.14l1.11,1.71l-0.19,1.0l0.59,1.0l-0.14,1.34l0.27,0.45l3.62,0.77l0.88,0.49l-0.78,1.01l-0.41,1.19l-0.02,1.49l-1.22,2.41l0.2,0.88l5.52,0.9l0.07,1.97l0.5,0.62l0.65,0.23l0.22,1.16l0.92,0.49l1.14,-0.27l1.21,0.31l0.84,-0.13l1.79,-1.47l1.57,-0.69l0.12,0.86l-0.39,0.69l-2.43,1.24l-0.4,0.48l-0.39,1.03l-0.95,1.18l0.11,1.06l-1.42,0.17l-0.71,0.59l-0.99,2.9l-1.37,-0.61l-1.41,0.77l-2.17,-0.17l-0.16,0.52l0.31,1.19l-0.81,0.38l-1.0,-0.28l-1.17,0.21l-0.5,0.57l-0.59,1.91l-3.95,0.64l-0.85,-0.01l-1.03,-0.56l-0.98,0.16l-0.33,0.86l-1.35,1.68l-0.11,2.5l-0.72,1.6l0.34,2.47l-1.49,0.55l-0.93,-0.17l-0.39,0.51l0.69,1.42l0.55,0.49l0.63,0.07l0.73,1.76l0.01,2.02l5.42,6.28l0.27,1.82l1.46,3.22l0.73,0.21l0.84,-0.59l-0.39,0.92l-1.82,1.25l-0.22,5.02l-0.66,0.03l-2.01,1.22l-0.22,0.78l0.18,1.31l0.4,1.41l2.42,3.46l2.76,2.42l1.43,2.38l0.28,3.46l-0.48,0.95l0.1,0.8l0.73,2.25l1.35,1.44l0.46,2.72l1.12,3.05l-0.96,1.03l-2.14,3.82l-3.26,3.39l0.03,1.89l-0.44,1.56l-0.67,0.72l0.06,-1.69l-0.4,-2.26l1.49,-2.26l0.57,-2.2l-0.01,-2.49l0.82,-0.74l-0.02,-0.69l-0.92,-0.45l-0.71,0.36l0.44,-1.37l0.03,-1.9l-0.53,-0.52l0.37,-0.74l-0.31,-0.53l0.25,-1.66l-0.66,-3.84l-1.23,-2.64l-1.24,-1.8l-0.14,-1.67l-0.29,-0.35l-0.7,0.2l-0.05,0.34l0.04,-1.87l-0.73,-1.27l-0.52,-1.99l0.6,-0.05l0.02,-0.49l-1.47,-1.44l-0.76,-7.75l-0.91,-1.16l0.39,-1.7l-0.05,-1.47l0.64,-1.12l-0.47,-0.2l-2.21,0.33l-1.14,-2.55l-0.24,-1.78l-1.72,-1.71l-0.89,-0.65l-0.49,0.01l-0.12,0.47l0.32,0.63l-0.34,0.87l0.38,1.18l-0.96,2.24l-0.99,1.04l-1.18,0.38l-0.79,-0.51l-0.41,-1.44l-0.79,-0.04l-0.23,0.5l0.87,2.31l-1.72,0.47l-0.36,0.71l-1.73,0.6l-0.85,1.65l-1.91,1.73l-0.12,-0.68l0.43,-0.98l-0.13,-0.86l-0.39,-0.34l-1.43,2.06l-1.33,0.03l-0.25,-2.39l-0.34,-0.35l-0.43,0.25l-0.35,1.13l-0.66,0.53l0.47,-3.19l-0.13,-0.93l-0.38,-0.31l-0.4,0.29l-0.28,1.27l-1.6,1.76l-0.96,0.53l0.36,-3.3l0.61,-0.99l0.91,-3.82l0.66,-1.3l0.21,-2.27l-0.71,-2.01l-0.47,-2.85l-1.68,-3.76l0.29,-0.25l-0.15,-0.42l-1.16,-0.97l-0.18,-2.93l-0.62,-0.3l0.17,-1.18l-1.22,-0.77l-0.64,-1.12l-0.81,-0.55l0.51,-0.72l-0.32,-0.65l-0.8,0.02l-1.26,-0.97l-1.31,-0.28l-0.87,0.25l-0.16,0.86l-0.41,-0.72l0.51,-0.56l-0.36,-0.73l0.26,-0.99l-0.35,-0.61l-0.66,0.19l-0.12,0.44l-0.32,0.57l-0.2,-1.16l-1.2,-1.37l-0.61,0.47l0.15,0.71ZM511.54,317.64l-0.59,1.02l0.13,1.32l-1.21,-0.74l-1.27,-2.11l0.87,0.82l0.88,0.31l1.18,-0.61ZM503.54,309.93l-0.24,0.32l-0.03,-0.02l0.15,-0.21l0.13,-0.09ZM545.29,376.32l-0.21,-0.96l0.34,-0.03l-0.06,1.01l-0.07,-0.02ZM544.52,369.1l0.3,0.29l-0.24,0.63l0.04,-0.45l-0.1,-0.47ZM538.23,340.2l-0.05,-0.68l0.11,-0.08l0.04,0.12l-0.1,0.65ZM509.61,315.91l1.12,0.49l0.2,0.28l-0.64,0.23l-0.68,-1.0ZM509.32,321.7l-0.47,-0.39l-0.2,-0.27l0.82,0.06l-0.15,0.6Z",name:"Myanmar"},SG:{path:"M585.95,453.53l-0.64,0.28l-0.67,-0.24l0.65,-0.28l0.66,0.24Z",name:"Singapore"},KH:{path:"M574.51,361.92l1.66,-0.41l0.12,-0.61l3.37,-4.31l3.71,-1.2l3.21,0.46l5.93,-0.52l1.08,0.34l0.57,1.07l0.57,0.1l0.63,-0.48l1.18,1.3l1.61,-0.24l1.3,0.45l1.26,1.22l1.44,0.1l0.37,-0.24l0.45,-1.27l-0.97,-1.85l1.11,-0.15l0.48,-0.66l0.95,0.03l0.88,-0.67l2.44,1.8l2.36,-0.87l1.16,-1.19l0.89,0.17l-0.8,1.05l-0.24,1.95l2.04,5.15l-0.97,3.16l0.51,2.51l-0.03,1.91l-0.66,0.91l-0.49,-0.33l-1.01,0.13l-2.18,1.73l-1.13,0.17l-0.63,0.58l-2.02,0.22l-0.32,0.43l-0.03,1.57l-2.6,-0.56l-1.56,1.19l0.08,2.96l2.22,1.94l-0.12,1.13l-0.94,-0.53l-0.65,0.09l-0.64,-0.81l-0.81,-0.16l-2.31,0.37l-0.59,0.64l-2.19,-0.27l-0.28,0.53l0.26,1.06l-1.38,1.2l-1.93,0.08l-0.92,0.75l-1.07,-0.86l-2.44,-0.4l-0.61,-0.53l-1.67,1.04l-0.56,-0.58l1.05,-0.75l0.31,-1.0l-0.63,-1.7l-0.96,-0.7l-0.49,0.05l-1.25,1.62l-1.01,0.05l-0.36,-1.87l0.15,-2.16l-0.77,-0.87l-0.14,-1.03l-0.42,-0.48l-0.35,0.04l-1.16,-2.31l-0.2,-1.12l0.28,-1.55l-1.85,-1.81l-0.28,-2.48l-0.98,-2.09l-0.07,-1.62Z",name:"Cambodia"},CY:{path:"M52.44,189.37l1.85,0.77l2.04,-0.71l1.37,0.09l0.52,1.29l1.4,-0.11l-1.77,1.53l-2.23,0.47l-0.92,0.87l-0.57,-0.55l-1.44,0.04l-1.81,-0.89l-0.72,-1.76l2.3,-1.04ZM61.14,190.36l0.36,-0.24l0.39,0.2l-0.02,0.0l-0.74,0.04Z",name:"Cyprus"},QA:{path:"M191.62,275.3l-1.7,0.32l-0.94,-0.72l-0.29,-0.65l0.27,-0.89l-0.68,-3.97l1.8,-4.45l1.49,-1.1l1.85,1.74l0.16,0.7l-0.61,2.21l0.9,3.61l-1.28,2.84l-0.98,0.35Z",name:"Qatar"},KR:{path:"M753.99,193.32l1.41,0.11l0.77,-1.18l-0.16,-0.67l-1.06,0.07l-0.87,-2.37l1.33,-2.74l0.95,-0.67l-0.16,-0.61l-0.43,-0.18l1.23,-0.79l0.46,-1.12l-0.69,-0.79l0.15,-0.9l-1.0,-1.05l0.03,-2.59l-0.46,-1.89l-0.52,-0.32l-0.69,0.31l-1.16,-0.29l-0.06,-0.26l0.32,-0.64l1.87,-1.06l1.8,0.49l0.69,1.02l0.63,-0.26l0.75,-0.88l-0.05,-0.43l-0.86,-0.41l-0.49,-0.88l-0.24,-0.71l0.21,-1.04l-0.97,-1.25l-0.02,-0.95l-0.61,-1.14l0.73,-0.78l0.02,-0.84l2.94,-3.01l7.06,-0.2l1.16,-0.57l1.11,-1.88l1.63,3.45l3.24,4.33l2.09,3.42l0.59,1.76l0.4,2.63l-0.59,3.62l0.08,2.32l0.41,0.65l0.8,-0.05l-1.07,3.98l-1.43,2.52l-1.54,0.6l-3.68,0.07l-0.8,0.84l0.15,1.0l-1.97,-0.42l-0.36,-0.62l-0.82,-0.17l-2.72,1.01l-0.15,0.64l0.66,0.86l-0.22,0.18l-0.9,-1.18l-1.06,0.16l-0.38,0.99l0.54,1.03l-0.65,0.91l-0.63,-0.39l0.57,-0.75l0.01,-0.74l-0.76,-0.42l-1.62,1.25l-0.93,1.29l-0.72,-0.54l-0.43,0.06l-1.2,1.11l-0.35,-0.97l-1.31,-1.11ZM771.49,190.93l0.08,1.06l-0.29,0.22l-0.66,-0.49l0.86,-0.78ZM765.7,192.18l0.1,-0.56l0.61,0.23l0.08,0.65l-0.79,-0.32ZM753.88,205.05l-0.4,0.13l-0.34,-0.44l1.03,-0.9l2.57,-0.72l1.17,0.22l-0.17,0.82l-1.1,0.52l-2.75,0.38ZM754.66,166.8l0.29,0.31l-0.02,0.58l-0.05,-0.07l-0.22,-0.82ZM752.75,195.37l0.75,-0.75l0.33,0.12l-0.79,0.68l-0.29,-0.06Z",name:"Korea"},KP:{path:"M739.6,147.16l0.14,-0.66l3.53,-2.94l0.73,-0.05l0.7,-0.77l2.64,-1.04l1.79,-1.14l0.46,-0.63l2.08,-0.45l3.82,-4.13l0.8,-2.45l0.81,-0.6l1.35,-0.45l1.79,2.16l2.94,0.69l2.65,-0.05l1.43,0.64l0.6,-0.11l1.12,-1.65l0.03,-0.6l-1.93,-3.06l6.28,-0.39l2.31,-1.74l0.26,-0.98l0.6,-0.76l0.46,-0.12l0.94,0.46l1.56,-0.74l1.33,-4.79l1.16,0.23l0.9,0.63l0.05,1.25l0.9,1.09l1.06,0.61l1.01,1.58l0.03,0.25l-1.33,-0.07l-1.59,1.03l-0.54,0.84l-1.29,0.97l-1.02,1.7l-0.93,0.9l-0.57,1.22l-0.03,0.9l0.62,1.68l-0.39,1.55l0.05,2.17l-2.69,1.16l-1.75,2.08l-2.92,1.48l-1.5,1.69l-1.47,0.78l-2.52,0.37l-0.87,0.93l-2.36,1.18l-0.33,0.96l0.16,1.96l-0.92,0.66l-0.24,1.65l3.07,1.36l1.43,1.65l2.59,1.82l-0.83,1.83l-0.7,0.63l-7.56,0.36l-0.78,0.49l-2.53,2.77l-0.15,0.99l-1.95,-0.73l-1.25,0.43l-0.37,0.46l-0.62,-0.84l-0.69,-0.03l-1.57,-0.95l-0.56,0.2l-1.0,1.37l-0.98,0.69l-0.68,-1.04l-1.65,-0.42l1.24,-0.68l0.08,-0.69l-0.74,-0.38l-2.63,-0.13l0.57,-0.37l0.23,-1.18l1.23,-1.65l1.71,-0.89l1.78,-0.17l0.16,-0.72l-1.08,-0.59l-0.97,0.01l-0.74,-0.65l1.87,-3.69l-0.37,-2.17l-0.26,-0.33l-1.97,-0.58l-2.32,-1.41l-0.69,0.12l-0.28,0.95l-0.54,-1.23l-1.46,-0.96l0.07,-0.75Z",name:"Dem. Rep. Korea"},KW:{path:"M167.69,235.06l-0.94,-0.06l-1.81,1.62l-0.16,0.46l0.3,0.43l2.23,0.19l0.93,2.92l1.65,3.04l-4.92,0.07l-1.91,-3.71l-5.99,-0.78l2.32,-3.08l1.56,-3.47l0.65,-0.51l3.13,-0.41l1.92,0.77l1.03,2.52ZM168.51,233.33l0.2,-0.32l0.75,1.05l-0.02,0.41l-0.58,0.53l-0.55,-1.16l0.2,-0.51Z",name:"Kuwait"},KZ:{path:"M172.6,48.91l0.9,0.03l3.88,-2.48l1.29,-2.26l2.33,-0.47l3.78,-1.94l3.63,-3.95l2.37,0.74l0.63,0.42l0.18,0.79l0.68,0.55l2.22,-0.14l2.95,-1.86l1.41,-0.32l0.62,0.21l1.14,1.57l0.7,0.43l1.96,-0.09l1.71,0.31l2.14,-0.2l1.31,0.73l1.23,1.52l2.02,0.91l1.27,1.11l2.02,2.46l0.45,2.04l0.86,0.61l0.55,-0.18l0.52,-0.7l0.01,-2.02l-0.64,-1.53l0.32,-0.24l2.51,1.3l2.63,2.04l2.58,0.87l1.09,-0.23l1.92,-1.12l0.81,-1.36l2.35,-1.56l1.04,0.32l2.77,-0.8l1.08,0.25l2.19,1.49l1.71,-0.39l1.32,-1.6l3.67,0.24l1.29,0.84l2.53,2.74l4.39,0.81l0.18,0.98l0.58,0.27l2.31,-0.95l1.57,-2.53l1.48,1.33l1.19,0.33l1.74,0.16l2.36,-0.33l2.13,-0.78l1.45,-1.06l1.44,-3.61l-0.18,-1.24l-1.75,-1.46l-2.4,-0.46l-0.47,-0.47l-3.68,-1.1l-0.59,-1.19l-2.45,-1.29l2.68,-1.56l1.87,-0.28l2.52,-1.96l-0.1,-1.05l-1.45,-2.62l1.84,-2.62l2.4,-0.21l4.25,0.52l1.19,-0.76l0.08,-0.8l-0.76,-0.88l-2.56,-1.18l-3.42,-0.64l0.2,-0.91l1.93,-0.37l0.51,-0.66l-0.13,-0.57l-0.65,-0.52l-1.74,0.28l-1.53,-0.53l0.84,-0.91l0.25,-2.16l0.51,-0.45l0.58,-0.23l4.51,1.03l0.91,-0.57l3.3,-0.1l1.14,-0.59l3.19,-0.36l0.96,-0.67l3.77,-0.75l1.12,0.06l2.66,-1.15l1.79,-0.35l1.52,0.31l1.98,-0.42l1.43,0.51l0.73,-0.49l0.53,-1.42l1.64,-0.98l1.56,0.04l1.46,-0.68l0.42,0.25l2.01,-0.08l4.05,-0.74l7.0,-1.39l1.13,-0.75l2.4,-0.34l0.91,-0.99l-0.15,-1.07l1.96,-0.31l1.56,-1.14l1.81,-0.78l3.75,0.33l5.15,2.03l1.1,-0.26l1.4,-1.0l1.59,-0.2l1.09,1.6l2.0,5.33l-0.22,2.29l-0.68,0.98l0.51,1.11l1.97,0.57l4.11,-0.64l0.78,0.15l0.73,-0.32l0.6,-0.87l1.2,1.76l0.14,1.58l0.48,0.49l0.43,0.03l1.22,-0.77l-0.04,-1.15l1.95,0.25l1.45,1.23l1.06,0.33l1.3,-0.08l1.86,-1.02l-0.1,0.73l-1.95,1.12l-0.92,1.37l-0.1,1.36l0.6,1.33l0.56,0.4l0.83,-0.3l1.25,-1.06l1.43,-0.39l2.39,0.39l1.44,0.92l0.59,-0.38l0.33,-1.35l2.69,-1.72l1.54,0.01l1.42,-0.75l1.17,-0.78l0.38,-1.17l1.89,-0.27l4.3,-2.03l1.77,-0.27l1.82,-0.97l-0.98,2.17l-1.56,-0.06l-0.41,0.4l0.55,1.55l0.79,0.92l8.43,5.75l1.1,1.06l4.59,6.36l5.04,7.73l6.5,11.03l0.6,0.16l0.5,-0.35l0.09,-0.58l0.86,-0.62l1.5,-0.34l0.42,-0.72l-0.09,-1.71l1.85,-0.96l0.89,0.1l0.79,0.91l0.93,0.01l-0.46,1.28l0.16,0.85l0.65,0.27l1.62,-0.15l0.32,1.74l0.56,0.45l3.42,-0.26l1.35,0.54l3.1,-0.2l0.97,-0.49l0.98,-1.1l1.82,-0.04l1.15,-0.91l1.29,-0.05l2.57,1.01l1.58,1.03l1.67,2.39l0.61,2.25l0.59,0.64l2.26,0.45l1.67,1.05l0.97,0.21l0.07,1.51l1.98,2.96l5.14,0.63l0.59,0.53l1.47,0.0l3.64,-2.68l-0.67,0.96l0.01,0.79l1.47,0.91l1.45,1.98l2.0,1.07l-2.66,0.15l-1.2,0.9l-0.36,3.14l-1.13,1.45l-6.08,1.5l-0.96,1.82l-0.76,2.8l0.45,4.09l0.61,1.53l-0.07,0.57l-1.1,1.62l-1.93,0.31l-2.97,1.82l-0.39,-0.9l-0.63,-0.4l-2.48,-0.23l-2.39,0.24l-2.17,-0.46l-4.68,-1.78l-0.74,0.25l-0.61,2.3l-3.13,7.56l-1.83,5.41l0.31,1.09l1.95,0.76l0.03,0.93l-0.52,1.22l-1.62,-0.86l-2.46,0.52l-0.88,-0.45l-0.34,-0.87l-0.92,-0.39l-6.12,1.99l-1.69,0.04l-4.31,1.11l-1.6,1.24l0.06,0.82l0.97,0.62l2.04,-0.05l1.07,0.43l-0.38,0.34l-0.41,2.18l0.14,3.17l2.24,5.03l0.35,1.1l-0.24,1.1l0.87,1.41l-1.02,-0.13l-1.69,0.77l-0.34,0.96l0.72,0.7l-1.42,0.56l-0.57,0.78l-0.33,1.2l0.71,3.27l-2.01,-1.79l-3.53,-0.57l-2.33,-2.68l-1.92,-0.03l-2.75,-0.82l-3.74,0.06l-5.84,-0.49l-1.92,-0.56l-3.62,0.5l-5.04,-0.17l-0.64,0.18l-0.91,0.93l-1.89,-0.19l-4.02,-1.25l-4.54,-2.38l-0.73,0.39l-1.36,-0.01l-3.25,1.86l-1.12,3.91l0.33,1.19l-0.86,-0.69l-3.16,-0.51l-0.81,-0.69l-3.56,-1.08l-3.49,-0.6l-2.34,0.48l-0.84,-0.12l-1.24,0.45l-1.88,1.87l-1.05,1.86l0.09,0.95l-1.3,0.47l-0.89,1.12l-0.6,-0.38l-0.76,0.09l-2.43,2.34l-3.9,1.67l-1.56,1.26l-2.24,1.13l-0.61,1.47l-1.85,1.44l-1.2,1.53l-0.29,1.22l0.32,0.85l-0.38,0.14l-1.35,-0.38l-1.57,-1.14l0.45,-1.71l-1.39,-1.84l-9.18,0.12l-1.51,-7.1l-0.39,-0.35l-3.27,-0.08l0.67,-8.49l-0.57,-0.39l-1.9,0.88l-2.11,-3.62l-1.8,-1.1l-2.72,-2.7l-1.13,0.14l-2.67,1.26l-9.15,-0.69l-8.97,1.25l-6.08,-6.05l-1.18,-2.1l-7.01,-4.12l0.16,-4.09l-0.32,-2.03l-0.55,-0.81l-1.7,-0.05l0.79,-2.36l4.16,0.6l3.04,-2.59l2.71,-1.03l0.78,-1.31l0.09,-0.76l-0.31,-0.59l-3.08,-0.71l-0.31,-1.74l-0.64,-0.6l-0.91,-0.15l-0.5,0.03l-0.32,0.58l1.13,0.99l-0.33,0.23l-1.16,-0.19l-0.4,0.28l-0.45,-0.86l-0.82,-0.28l-1.65,0.88l-0.66,1.3l0.28,0.84l0.66,0.56l2.26,-0.05l1.37,0.79l1.08,-0.56l0.53,1.15l-0.81,0.93l-4.22,-0.5l-1.77,0.48l-0.37,-2.0l-2.18,-0.48l-0.35,0.74l1.13,1.75l0.17,0.88l-0.58,1.96l-0.93,0.41l-0.51,-0.21l-0.53,0.4l-0.13,-0.6l0.7,-1.38l-0.33,-0.61l-0.63,-0.13l-0.95,0.42l-1.25,-0.14l-2.13,1.31l-0.9,2.61l-19.46,5.2l-0.29,0.39l0.01,32.99l-2.83,0.53l-0.57,-0.2l-1.35,-1.41l-2.96,-4.54l-1.41,-1.09l-4.37,-2.37l-3.36,0.36l-4.75,1.36l-1.5,0.85l-2.33,2.04l-0.09,-2.01l1.15,-2.89l0.17,-1.24l-0.41,-2.16l-0.95,-0.67l-1.69,0.1l-0.71,-0.56l-1.98,0.04l-2.08,-2.59l-2.26,-0.17l0.03,-2.63l-1.79,-2.47l-1.73,-4.01l-1.3,-0.88l-2.65,-0.56l-0.35,-0.85l0.23,-0.83l0.64,-0.3l3.16,-0.04l2.45,1.17l3.15,-0.49l-0.43,-0.87l-1.43,-0.45l-2.03,-1.99l0.08,-0.75l1.54,-1.3l1.11,-2.04l0.9,0.09l1.37,-0.5l5.13,-0.05l3.59,0.79l2.3,-0.12l0.16,-0.7l-2.99,-1.97l1.93,-3.52l0.7,-2.09l-0.18,-2.25l-0.32,-0.62l0.75,-1.88l-0.81,-1.87l-1.25,-1.02l-3.38,-0.4l-2.67,1.51l-1.0,-0.67l-1.73,-0.26l-1.03,-0.92l-3.56,-0.77l-2.01,0.69l-2.49,1.47l-1.33,0.11l-3.84,2.59l-4.01,0.71l-0.31,0.81l-0.94,0.66l-4.0,-1.89l-0.55,-0.56l0.02,-0.42l0.32,-0.14l1.13,0.48l1.1,0.05l0.75,-0.51l0.02,-0.71l-3.06,-5.19l-2.97,-3.78l-0.64,-0.44l-4.69,-0.56l-1.42,0.55l-1.14,-1.56l0.18,-1.65l-0.51,-1.3l-0.62,-0.61l-2.35,-1.11l-0.32,-1.28l0.65,-2.06l1.91,-2.2l0.57,-1.21l-0.2,-0.85l-1.49,-1.44l0.62,-2.97l0.71,-1.41l2.29,-2.06l0.24,-2.1l1.15,-1.1l1.13,0.2l3.84,4.33l0.94,0.79l1.03,0.29l2.46,-0.98l0.83,-1.02l-1.33,-5.63ZM248.32,97.54l1.41,-1.65l0.64,-0.08l0.28,-0.6l1.51,1.9l0.45,2.98l-4.3,-2.54ZM201.9,97.61l0.06,0.13l-0.08,-0.1l0.02,-0.02Z",name:"Kazakhstan"},SA:{path:"M67.56,247.08l1.06,-2.61l1.21,-6.57l8.14,1.18l3.22,-2.48l1.76,-2.79l5.69,-1.31l1.39,-2.79l2.37,-1.31l0.11,-0.62l-7.19,-7.71l14.36,-3.99l1.39,-1.04l8.92,1.5l12.67,7.05l19.68,15.46l12.58,1.15l1.36,-0.26l6.48,0.83l0.99,2.68l0.74,0.93l5.85,0.06l1.24,3.08l1.36,1.9l0.02,1.54l0.92,0.84l1.96,0.85l-0.09,0.58l1.74,2.09l1.07,0.33l1.25,1.48l2.47,1.51l-0.38,0.48l0.15,1.27l1.23,1.15l0.15,0.54l-0.3,1.16l-0.68,-0.02l-0.35,0.56l1.61,4.02l1.62,1.6l0.79,2.71l2.88,4.0l1.44,0.3l1.24,-0.31l0.58,0.29l-0.56,1.24l0.27,0.54l1.64,0.42l0.26,1.52l7.21,9.07l19.35,2.6l0.62,-0.35l3.01,4.88l-4.85,15.33l-22.24,7.7l-22.07,3.25l-6.65,3.39l-4.44,5.48l-1.05,2.59l-1.98,1.12l-0.97,-0.04l-2.04,-2.41l-3.15,0.26l-5.76,-0.54l-2.94,-0.97l-7.47,0.22l-1.72,0.54l-1.36,-0.25l-1.4,-1.05l-1.17,-0.12l-1.94,1.53l0.2,0.75l-0.46,0.41l-0.3,2.08l0.52,1.22l-0.09,0.47l-2.09,2.0l-0.74,-2.32l-2.34,-2.97l-0.72,-2.45l-4.07,-3.48l-1.74,-2.75l-0.63,-1.61l-1.43,-1.65l-0.88,-3.14l-2.67,-5.22l-1.18,-0.68l-1.03,-1.34l-3.01,-2.12l-1.56,-0.27l-1.05,-0.68l-3.32,-4.48l-1.26,-2.42l0.36,-1.64l-1.18,-2.86l0.78,-3.89l-0.25,-1.73l-0.41,-1.31l-0.77,-0.8l0.17,-0.38l-1.0,-1.2l-0.69,-2.03l-1.87,-3.31l-1.37,-1.63l-2.72,-2.14l-0.88,-0.15l-0.94,-0.69l-1.05,-0.1l-2.46,-3.84l0.54,-1.19l-0.93,-2.77l-1.71,-2.8l-1.2,-0.94l-0.59,-2.11l-1.27,-0.76l-1.95,-3.81l-3.0,-3.86l-0.72,-1.58l-1.32,-1.36l-1.19,-2.44l-1.82,-2.44l-1.05,-0.58l-2.95,-0.27ZM121.15,336.6l0.4,-0.33l0.04,0.83l-0.42,-0.42l-0.03,-0.07Z",name:"Saudi Arabia"},MY:{path:"M641.05,446.05l0.71,0.36l0.8,-0.15l0.31,-0.63l-0.05,-1.52l1.13,-1.14l8.26,-1.87l2.45,-1.08l3.07,-4.07l3.61,-3.82l0.56,-2.37l1.04,0.65l0.74,1.61l0.77,0.18l1.45,1.69l0.83,-0.12l1.04,-1.16l0.49,-1.72l-0.65,-2.41l1.27,-0.83l0.6,3.28l1.34,0.6l0.79,-0.16l0.23,-0.69l-1.05,-3.38l1.72,-0.53l1.0,-0.99l0.28,-0.89l-0.2,-0.46l-0.76,-0.4l-0.24,-0.75l0.85,-0.95l1.6,0.28l0.86,-0.69l1.46,-2.15l0.59,-1.82l2.63,-2.91l1.82,-3.25l0.07,1.03l-0.4,1.27l0.42,0.49l1.23,-0.56l1.41,-2.12l0.39,0.11l0.49,1.95l2.54,1.44l0.3,1.12l-0.58,0.84l0.21,1.26l-1.06,1.1l0.45,0.27l2.37,-0.42l1.26,-0.69l0.4,0.75l-1.28,0.7l0.39,0.84l0.8,0.12l1.71,-0.81l0.54,0.09l1.09,0.52l0.73,1.09l2.73,1.23l1.7,0.01l0.25,0.23l-0.17,1.1l-2.14,0.94l-1.73,0.42l-2.17,-0.4l-1.23,0.45l-0.5,1.64l1.11,1.27l1.74,1.22l-0.31,0.37l-3.61,0.82l-2.24,-0.68l-0.65,0.38l-0.47,0.91l-1.98,-0.95l-1.4,-0.29l-4.28,-0.24l-0.9,0.41l-1.26,-0.36l-1.67,0.49l-0.93,-0.39l-0.65,0.17l-1.34,1.23l-0.86,2.06l-0.01,3.59l-0.75,2.89l-1.52,0.08l-1.28,1.48l-0.09,1.78l0.74,0.64l-2.9,2.03l-0.23,0.94l0.5,1.26l-0.87,0.78l-1.12,2.74l-1.0,-0.3l-3.61,0.49l-1.97,1.43l-0.64,-0.42l-3.69,-1.0l-0.07,-0.54l-0.57,-0.44l-3.66,0.03l-2.38,0.96l-0.86,2.2l-1.16,0.28l-0.79,0.7l-2.19,0.08l-3.0,-0.4l-4.31,1.39l-5.53,-4.81l-0.52,-0.59l-0.12,-1.09l-0.67,-0.63l0.15,-0.41l0.53,0.81l2.05,1.09l2.87,0.04l2.35,1.25l1.7,0.14l1.46,0.96l1.09,0.05l0.35,-0.32l-0.2,-0.43l-1.23,-0.89l0.83,-1.07l0.2,-1.39l0.73,-1.77l-0.46,-0.71l0.0,-1.02ZM684.91,409.61l0.41,-0.56l0.41,-0.05l-0.11,0.45l-0.71,0.16ZM560.8,415.59l1.25,-0.03l0.88,1.55l1.37,0.16l0.1,1.64l-0.72,1.49l1.08,1.33l0.76,0.04l0.91,-1.13l1.92,-0.77l0.73,0.88l1.24,0.0l0.78,-0.51l0.47,-1.13l0.82,-0.81l0.26,-0.92l1.31,0.38l1.47,2.32l4.16,3.36l2.32,4.07l0.27,1.27l0.11,2.01l-0.8,4.74l0.67,1.89l-0.05,4.51l0.79,1.27l2.02,1.44l3.01,6.32l0.41,2.01l-0.51,-0.09l-0.34,-0.92l-1.12,-0.76l-0.17,1.27l-1.91,0.01l-1.28,0.88l-0.97,-1.56l-4.68,-2.31l-1.38,-1.41l-2.98,-1.53l-2.64,-2.36l-2.02,-0.89l-1.43,-1.29l0.34,-0.91l-0.49,-2.0l-4.16,-5.01l0.43,-0.68l-1.32,-2.52l-0.02,-2.17l-1.05,-2.92l-0.88,-3.99l-0.08,-3.02l-1.65,-3.37l0.29,-1.42l0.84,0.97l1.64,0.62ZM558.59,423.72l0.04,-0.52l0.15,0.07l-0.19,0.45ZM554.87,416.01l0.61,-0.22l0.15,0.23l-0.64,0.21l-0.12,-0.22Z",name:"Malaysia"},YE:{path:"M210.22,368.93l3.31,-0.15l1.6,0.56l-2.1,0.96l-2.93,0.3l-0.74,-0.15l-1.64,-1.15l1.07,-0.91l1.43,0.54ZM128.17,348.79l0.44,-0.21l0.08,-0.52l-0.6,-2.52l0.88,-2.78l-0.26,-2.55l2.7,-2.53l0.16,-1.06l-0.5,-1.03l0.13,-1.2l0.71,-1.07l-0.29,-0.74l0.95,-0.8l1.11,-0.07l1.35,1.04l1.75,0.31l1.77,-0.56l7.3,-0.22l2.88,0.97l5.8,0.55l2.98,-0.27l1.72,2.26l1.74,0.18l2.31,-1.32l1.14,-2.71l4.35,-5.36l7.46,-3.52l20.53,-2.86l5.51,12.84l0.6,0.39l1.9,4.24l-3.44,1.26l-1.95,1.39l-0.81,1.14l-0.47,1.65l0.32,2.18l-4.38,2.32l-4.33,1.48l-3.64,0.78l-2.72,1.43l-1.96,0.18l-4.21,1.47l-2.35,1.44l-0.94,1.48l-1.79,1.54l-2.77,0.39l-2.36,-0.34l-2.76,1.51l-1.63,1.45l-4.57,1.47l-6.42,0.52l-2.01,0.43l-2.12,2.11l-1.79,0.61l-0.9,1.3l-1.82,0.34l-1.28,-0.34l-2.53,1.26l-1.88,0.27l-2.61,-1.01l-0.88,0.19l-0.1,-0.73l-1.76,-3.14l0.35,-3.27l-0.45,-1.43l-0.97,-1.04l0.01,-1.45l-1.28,-4.7l0.07,-0.99l-0.57,-1.41l-0.93,-0.61Z",name:"Yemen"}},height:555.5409752358405,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","au_mill",{insets:[{width:900,top:0,height:1008.5727398708073,bbox:[{y:1031999.3824222308,x:12576510.61983689},{y:6796690.085079122,x:17720633.028951164}],left:0}],paths:{"AU-ACT":{path:"M700.02,546.47l-0.6,-0.57l-0.39,-1.2l0.19,-1.5l-0.24,-1.9l0.63,-3.32l5.86,-4.14l0.91,0.61l0.17,0.9l0.9,0.43l0.25,0.7l2.66,1.15l-0.45,0.23l-1.51,-0.22l-0.86,0.65l-0.74,-0.1l-1.3,1.53l-0.16,1.07l0.25,0.91l-0.38,1.18l-0.56,0.28l-0.3,0.67l0.36,5.01l-0.89,1.43l-1.91,-0.94l-0.81,-3.14l-0.66,-0.12l-0.42,0.39Z",name:"Australian Capital Territory"},"AU-WA":{path:"M5.97,341.75l0.3,0.05l0.06,0.25l-0.32,-0.27l-0.03,-0.03ZM6.9,342.82l0.44,-0.3l0.15,-1.3l0.21,2.93l0.64,1.44l0.6,0.37l0.49,-0.49l-0.54,-1.55l0.13,-1.41l0.3,-0.9l0.63,-0.33l1.01,4.09l-0.33,2.39l0.61,0.2l0.41,-0.22l0.33,-1.89l0.21,3.52l0.4,0.42l0.61,-0.13l0.51,-1.27l0.0,2.08l0.47,0.1l0.04,0.63l0.69,0.46l0.5,-0.9l1.12,-0.36l0.9,0.11l0.39,-0.9l0.68,-0.4l0.7,-1.14l-0.05,-3.54l-2.11,-2.22l0.38,-0.21l1.48,-2.86l0.06,1.13l0.6,0.46l-0.15,0.83l0.67,2.93l2.4,2.67l0.87,-0.04l1.03,-1.11l0.83,-0.31l0.75,-1.41l-0.76,-2.75l0.7,-2.45l-0.49,-1.28l0.85,-0.15l0.39,-0.55l-0.63,-1.09l0.53,-1.27l-0.08,-0.64l-2.09,-1.32l-0.52,-1.5l-1.56,-1.45l-0.63,-1.55l-1.66,-2.43l-2.46,-5.78l-2.18,-1.44l-0.84,-2.21l0.4,-1.25l-0.27,-0.61l-0.81,-0.46l0.21,-1.69l-0.35,-1.51l-3.26,-4.13l-0.86,-2.27l-0.12,-3.33l0.89,-1.48l-0.33,-2.57l0.79,-1.22l0.07,-1.57l0.81,-1.18l0.48,-1.82l0.65,-0.51l0.81,-2.28l2.6,-2.04l0.69,-1.66l0.26,-2.76l-0.66,-3.32l0.13,-0.67l0.6,-0.46l0.49,-1.06l-0.07,-2.65l-1.03,-3.11l-0.99,-1.04l-0.73,-0.3l0.12,-0.84l-0.47,-1.87l1.61,-1.89l0.31,-1.57l1.1,-1.47l1.83,-5.73l0.94,-1.95l1.62,-2.21l2.04,-0.81l-0.88,2.11l-0.99,5.23l0.89,2.08l-0.27,1.13l0.25,0.4l0.58,0.03l-0.67,1.01l0.12,2.3l0.64,0.53l0.84,0.08l1.07,-1.16l0.99,-0.41l0.35,0.69l0.83,0.27l0.81,-0.58l0.48,-2.44l1.48,-3.62l0.59,-0.4l0.41,-2.28l0.58,-0.1l1.47,-2.56l0.32,-1.34l5.41,-3.03l1.54,-0.01l1.45,-0.74l0.49,0.15l2.29,-1.34l4.98,-2.0l2.93,-3.69l3.75,-1.96l1.24,-2.35l1.04,-1.03l4.27,-1.9l0.51,-0.67l0.31,-1.73l1.54,0.37l1.23,-0.71l2.12,-0.32l1.19,-0.78l0.31,-0.56l1.21,-0.31l2.19,-1.54l1.6,-2.02l-0.55,1.81l1.74,1.35l1.03,-0.12l3.09,-1.71l0.64,0.31l0.8,-0.41l0.89,1.29l3.21,0.96l3.25,-0.44l1.69,-0.97l1.47,0.27l3.39,-1.23l0.69,-0.98l0.88,-0.32l0.39,-1.22l3.92,-2.68l1.58,0.31l1.62,-0.69l0.41,0.47l0.55,0.05l4.67,-1.07l1.52,0.28l1.14,-0.64l1.4,-0.28l3.04,-3.64l0.38,-1.16l1.4,-0.67l0.66,-0.81l0.95,0.7l0.66,-0.31l0.19,-0.58l4.68,1.1l0.56,-0.17l1.06,0.94l1.52,0.29l1.6,-1.12l1.06,-0.21l0.22,-0.77l1.27,0.06l8.46,-1.19l2.64,-0.83l11.43,-4.73l3.45,-2.32l3.67,-3.46l4.07,-5.77l2.45,-5.36l0.14,-0.87l-0.43,-0.71l1.52,-0.31l1.21,-1.11l0.23,-1.09l-0.57,-0.68l1.12,-2.08l0.75,0.31l1.11,-0.21l2.24,-1.66l0.74,-1.24l1.54,-0.82l0.71,-0.89l0.49,-0.09l0.35,-0.68l1.94,-0.92l0.63,-0.78l0.47,-1.34l-0.27,-1.54l-1.7,-0.84l-1.4,0.08l0.23,-0.77l-0.28,-2.14l0.23,-1.82l-1.21,-3.07l0.12,-4.33l0.44,-1.6l1.98,-2.25l-0.05,-1.02l2.61,-2.29l1.04,0.19l0.45,-1.03l0.73,0.66l1.44,0.01l-1.28,-2.44l0.84,-1.22l1.03,0.43l1.39,-0.32l0.67,-0.48l1.27,0.36l0.49,-0.16l-0.08,-0.51l-1.33,-1.36l0.25,-1.79l0.41,-0.54l0.96,-0.06l1.09,-1.16l0.48,-1.67l1.01,-0.46l0.16,0.57l0.57,0.24l-0.66,0.01l-0.4,0.44l0.04,1.06l-0.49,0.83l0.39,1.26l0.86,0.17l0.39,1.24l1.07,0.45l-0.06,1.08l1.14,0.96l-0.26,1.7l0.98,0.67l1.36,1.6l0.2,1.37l1.88,2.87l0.38,1.73l0.99,0.72l1.21,1.58l0.28,0.94l0.76,0.86l0.31,1.52l0.59,0.15l0.51,-0.83l-0.03,-1.32l-0.5,-1.2l0.12,-1.56l0.52,-0.94l0.33,-1.9l0.64,-0.43l0.02,-0.38l-1.27,-1.98l-0.04,-1.1l0.16,-0.31l0.75,-0.06l0.31,1.03l1.18,0.34l0.69,1.16l1.01,0.64l0.71,1.03l1.45,0.25l0.33,-0.36l-0.06,-0.51l-1.22,-0.8l-0.92,-2.57l0.53,0.36l0.63,-0.19l0.06,-0.79l-0.53,-0.66l0.81,-0.97l1.07,-0.65l0.36,-0.91l-0.09,-0.56l-0.53,-0.44l-0.58,0.27l-0.39,0.91l-1.87,0.56l-1.44,-2.87l-1.95,-1.41l-1.08,-0.3l1.82,-2.55l0.07,-0.94l-1.51,-0.78l2.44,0.44l0.38,-0.25l-0.39,-0.73l0.51,-0.81l-0.39,-0.93l-1.02,-0.12l-0.72,-0.66l-0.97,-0.0l0.35,-0.76l-0.27,-0.85l0.59,-0.02l0.14,-0.39l1.35,-0.1l1.46,0.29l-0.34,0.5l0.25,0.51l-0.61,0.12l-0.15,0.72l1.44,1.02l1.04,0.33l-0.44,0.16l-0.18,0.49l0.59,1.32l1.24,-0.13l0.12,-1.43l1.14,0.78l0.62,-0.18l0.08,-0.51l-0.67,-1.17l0.59,-0.45l-0.17,-0.43l0.78,0.37l1.26,0.03l0.98,0.55l0.58,1.49l0.74,0.58l2.45,0.24l0.87,-1.11l1.58,0.82l2.36,0.16l3.27,-0.33l0.74,0.66l0.84,0.16l1.44,-0.54l-0.17,-0.71l-1.25,0.04l-2.78,-1.2l-2.47,-0.38l-1.84,0.38l-1.16,-0.14l-0.32,-2.11l0.18,-0.59l0.63,-0.45l0.11,-1.09l1.0,1.6l0.73,-0.03l0.45,-0.85l0.58,-0.14l0.46,-0.5l-0.2,-2.24l0.57,-0.55l-0.1,-1.29l0.41,-0.41l0.53,0.33l0.49,-0.25l0.4,-1.07l0.38,-0.23l-0.07,-0.72l-0.69,-0.25l-1.74,0.08l-1.46,1.75l-0.6,1.35l-0.81,-2.05l-0.7,-0.48l-0.2,0.32l-0.33,-1.16l-0.06,-1.48l0.69,-0.3l0.19,-0.56l-0.02,-0.72l-0.5,-0.51l0.05,-0.65l0.82,-0.35l0.34,-0.97l2.26,0.83l0.75,-0.13l0.25,-0.62l0.76,0.01l0.4,-0.53l-0.32,-0.67l0.16,-0.61l1.83,-1.7l0.54,1.14l1.45,-0.07l0.9,1.02l0.57,0.19l-0.3,0.91l0.42,0.42l0.53,-0.09l0.73,0.48l0.5,-0.26l0.1,-0.63l1.99,1.26l0.49,-0.11l-0.25,-0.81l-1.84,-1.59l0.27,-1.05l1.11,-0.76l-0.42,-0.52l-0.96,-0.55l-0.36,0.35l-0.82,-0.42l-2.17,1.13l-0.27,-0.71l0.72,-0.84l1.47,-0.09l1.01,-1.24l-0.16,-0.59l-0.83,-0.28l-0.6,0.51l-0.5,-0.15l-1.43,1.23l-0.27,-0.12l0.24,-0.68l-0.33,-0.48l0.65,-0.5l0.99,0.54l0.64,-0.04l0.5,-0.74l0.48,-0.02l0.17,-1.27l0.13,0.39l0.81,0.11l1.03,2.12l0.71,-0.11l0.2,-1.0l-0.26,-0.99l1.0,0.41l0.48,0.46l0.03,0.58l0.82,0.51l1.06,-0.24l1.15,0.24l0.6,-0.33l-0.05,-0.95l-0.95,-0.1l0.26,-0.26l-0.11,-0.58l0.94,-0.8l-0.22,-0.51l-1.09,0.02l-1.05,-0.54l-0.52,0.06l-0.29,-0.56l0.41,-0.24l0.31,-1.08l-0.4,-0.48l-1.8,-0.46l-0.19,-1.22l-0.69,-0.31l0.88,-0.58l0.26,-0.68l0.73,0.09l0.98,-0.82l-0.16,-0.69l-0.96,-0.05l0.38,-0.39l1.04,-0.18l0.08,0.82l1.19,-0.86l0.82,1.52l0.41,-0.2l0.1,-0.85l0.97,-1.23l0.52,0.58l1.13,-0.19l0.53,-1.21l0.26,-1.93l-0.52,-1.14l0.17,-1.99l1.49,1.34l-0.93,-0.01l-0.19,0.78l0.49,2.94l-0.87,1.72l-0.03,0.92l0.66,0.29l0.29,-0.25l1.24,-3.12l1.23,-0.14l0.45,2.42l1.9,1.27l0.49,-0.36l-0.02,-2.03l1.02,0.51l1.35,-0.9l-0.14,-1.24l-0.82,-1.23l1.37,-0.75l0.31,-1.16l-0.26,-1.07l1.41,-0.69l0.21,-1.29l0.27,0.6l0.64,0.39l0.07,0.68l1.56,0.4l0.5,-0.79l0.86,-0.5l-0.78,-1.19l0.56,-1.19l0.83,-0.33l0.67,-0.96l0.92,0.18l-0.82,1.13l0.08,0.52l0.74,0.2l0.59,1.19l0.81,-0.03l0.13,1.13l1.05,0.61l0.31,-1.18l0.76,-0.48l0.04,-0.89l0.8,0.35l0.76,-1.01l0.38,-1.45l-0.19,-0.22l0.63,-0.21l0.76,0.2l0.55,-0.37l0.35,-0.89l-1.05,-0.65l-0.84,-1.94l0.52,-0.15l0.21,0.59l0.44,0.14l1.16,-0.8l-0.53,-0.66l0.98,0.37l0.36,-0.13l0.13,-0.59l1.07,0.85l-0.0,0.72l0.89,0.6l-0.19,0.46l0.41,0.56l0.3,-0.04l0.3,1.1l0.58,0.47l0.49,-0.03l0.49,-0.65l0.76,0.33l0.67,-0.95l1.6,1.22l0.53,-0.6l0.9,0.67l0.4,-0.19l0.24,1.83l0.68,0.56l0.59,-0.13l2.95,2.04l0.67,1.16l1.11,0.98l0.6,1.52l0.68,0.38l0.04,0.98l0.57,0.41l0.02,0.47l0.77,0.15l0.9,0.76l0.27,1.16l0.6,0.16l0.71,-0.28l1.02,1.33l0.83,0.23l1.5,1.12l-0.34,0.75l0.28,1.11l-1.32,0.5l0.14,1.05l-1.25,4.2l0.3,1.49l-0.16,1.9l-0.63,0.53l0.55,2.03l-1.06,1.53l0.25,0.67l0.93,-0.14l1.2,-1.39l0.38,-1.92l-0.14,-2.46l1.66,1.41l0.9,2.4l0.52,0.34l0.4,-0.37l0.04,-2.32l-1.41,-1.76l0.12,-0.84l-0.57,-1.9l1.54,-1.63l0.27,-0.79l0.58,2.29l0.29,0.18l0.58,-0.52l1.07,0.57l0.55,-0.24l0.25,-1.07l-1.04,-2.31l0.62,-0.52l-0.03,-0.35l-0.57,-0.53l2.07,-0.79l1.07,0.48l2.25,0.36l0.62,0.52l3.53,0.37l1.22,0.5l0.0,346.2l-4.24,1.89l-2.27,1.47l-8.46,3.69l-3.88,1.42l-4.93,0.85l-3.93,1.34l-0.69,0.58l-4.63,1.31l-4.58,0.65l-5.23,-0.04l-2.01,0.31l-5.88,-0.72l-3.58,-1.07l-1.17,0.27l-1.09,0.74l-1.5,-0.12l-2.76,1.33l-6.43,4.63l-3.83,1.14l-4.74,2.41l-1.85,0.53l-2.04,2.16l-1.23,0.69l-2.38,0.77l-7.71,1.37l-3.06,2.3l-1.44,2.01l-0.51,2.17l-1.18,2.18l-1.05,4.54l-1.14,0.45l-0.67,1.01l-1.97,1.77l-0.53,1.15l-0.0,0.82l-1.48,0.78l-0.52,0.7l-1.1,0.22l-0.79,1.14l-1.03,-0.85l-1.68,-0.18l-0.93,0.37l-1.47,1.77l-1.72,0.41l-0.72,-2.16l-0.68,-0.66l-1.45,-0.42l-3.52,0.94l-1.28,-0.59l-0.81,0.3l-2.47,0.09l-0.77,0.4l-0.07,0.85l-0.6,-0.42l-0.66,0.26l-2.96,-0.62l-1.58,0.8l-0.36,1.32l-0.7,-0.4l-0.6,0.56l-1.36,-0.03l0.34,-0.75l-0.77,-2.13l-1.39,-1.43l-1.69,0.17l-1.2,0.94l-1.37,0.51l-1.89,-0.86l-1.22,0.42l-2.02,-1.25l-3.88,-0.09l-2.21,0.52l-1.09,0.58l-1.38,-0.5l-2.43,0.55l-1.97,-0.26l-2.45,0.76l-3.58,0.05l-0.79,0.99l-2.28,0.75l-2.36,-0.74l-2.05,-0.16l-1.41,0.45l-1.09,-0.56l-0.93,-0.0l-1.5,0.82l-2.49,0.54l-1.49,1.4l-1.74,0.8l-0.54,0.39l-0.02,0.45l-0.82,0.43l-2.01,3.38l-0.05,1.36l0.87,0.83l-1.0,-0.57l-0.95,-0.03l-0.78,1.13l0.25,1.06l-0.21,0.17l-0.58,-0.74l-1.03,0.16l-0.46,0.45l-0.33,1.22l-0.44,-0.63l-1.13,-0.16l-0.67,-0.48l-3.6,-0.58l-0.77,0.27l-1.09,-0.13l-0.29,0.68l0.54,0.55l-1.35,0.24l-1.36,0.94l-0.2,0.7l0.36,0.78l-0.21,0.24l-2.04,1.02l-2.6,0.69l-0.91,0.64l-1.12,1.97l0.2,1.57l-2.27,0.08l-2.16,0.79l-0.26,0.55l0.77,1.02l-0.91,-0.62l-0.68,-0.02l-1.44,0.55l-1.98,-0.15l-1.57,0.44l-0.49,0.41l-0.01,0.57l-1.28,-0.45l-1.67,-0.05l-0.77,0.44l-0.47,1.3l-1.09,-0.78l-1.47,-0.34l-2.51,-1.32l-0.53,0.29l-2.47,-0.5l-0.58,0.26l-0.45,0.72l-1.48,-0.65l-0.99,0.1l-1.06,-0.33l-1.44,0.9l-2.59,-1.01l-2.22,0.82l-0.83,-0.55l-2.27,-0.46l-0.68,-0.66l1.18,0.27l0.46,-0.31l0.0,-0.57l-2.41,-1.83l-0.69,0.16l-0.12,0.53l0.32,0.57l-5.24,-1.71l-2.01,-0.16l0.03,-0.44l-0.98,-1.82l-3.69,-4.04l-2.69,-2.15l-1.6,-0.65l-0.48,-0.67l-3.35,-1.59l-1.52,-0.38l-1.77,0.11l-0.97,1.06l-1.83,-2.03l-0.01,-1.75l-0.75,-1.76l-0.2,-4.84l0.49,-1.56l-0.58,-2.25l0.89,-1.36l-0.23,-1.73l1.82,1.87l1.62,0.7l1.85,0.15l1.81,-0.46l1.37,-0.83l1.72,-1.92l1.16,-1.91l0.94,-2.51l0.61,0.15l0.72,-0.27l0.37,-0.82l-0.09,-1.88l-0.67,-0.25l0.08,-3.39l-1.42,-7.71l0.99,2.42l0.63,0.39l0.53,-0.19l0.2,-0.63l-0.86,-2.29l1.22,-0.05l0.55,-0.99l-0.13,-0.69l-0.93,-0.88l0.61,-2.5l-0.55,-1.11l0.33,-0.89l-0.52,-0.8l0.54,-0.45l0.42,-1.82l-0.54,-2.49l0.28,-3.12l-0.44,-3.39l-0.83,-2.75l-4.41,-7.46l-2.75,-6.7l-1.47,-2.45l-1.1,-1.1l-0.35,-1.73l-1.97,-4.71l-0.11,-1.57l-0.84,-2.66l0.22,-1.23l-0.92,-1.05l0.25,-1.5l-0.88,-2.36l0.48,-2.78l-0.39,-1.57l-0.03,-3.56l0.64,-3.89l-2.68,-7.98l-3.73,-4.23l-0.92,-1.49l-0.4,-1.09l0.27,-0.66l-0.12,-2.04l-1.21,-2.98l-2.12,-2.59l-2.19,-3.59l-1.31,-0.85l-1.47,-1.74l-1.28,-4.97l0.07,-1.2l0.82,-2.5l-1.36,-5.1l-1.25,-2.87l-4.84,-8.33l-3.39,-5.08l-5.65,-5.75l-0.04,-1.32l-0.83,-1.61ZM16.26,342.17l-0.02,-0.0l-0.26,-0.07l0.17,-0.0l0.11,0.07ZM15.67,342.01l-0.42,-0.12l-0.09,-0.69l-1.37,-1.86l-0.62,-0.23l-0.34,-2.71l-0.71,-0.7l-0.19,-1.3l-1.79,-2.65l0.06,-1.25l1.15,-2.04l0.28,1.38l1.02,0.46l0.89,2.0l1.03,1.07l0.73,0.28l-0.04,1.24l0.71,0.58l-0.46,0.84l-0.59,4.23l0.75,1.46ZM206.78,144.29l-0.27,0.49l-0.48,-0.47l0.25,-0.29l0.51,0.27ZM229.82,120.35l0.05,-0.58l0.38,0.11l-0.24,0.53l-0.19,-0.06ZM240.55,112.7l-0.18,0.08l-0.54,-0.27l0.26,-0.14l0.45,0.32ZM96.98,532.54l0.38,-0.25l0.36,0.29l-0.05,0.01l-0.68,-0.05ZM258.13,96.33l-0.23,-0.54l0.47,0.26l-0.24,0.28ZM257.74,95.57l-0.76,-0.39l-1.87,-0.02l-0.12,-0.23l0.65,0.03l0.28,-0.32l0.85,0.27l0.19,-0.35l0.19,0.19l0.79,-0.39l-0.22,1.23ZM257.01,93.5l-0.57,-0.65l0.06,-0.09l0.68,0.24l-0.16,0.5ZM245.37,104.59l-0.08,-0.35l0.01,-0.16l0.36,0.19l-0.28,0.32ZM236.21,114.46l-0.17,-0.45l0.27,-0.04l-0.07,0.16l-0.03,0.33ZM224.7,135.78l0.01,-0.39l0.02,0.2l-0.02,0.19ZM23.93,261.98l0.03,-0.04l0.03,-0.06l-0.03,0.09l-0.02,0.01ZM18.82,337.55l-0.09,-0.37l-0.11,-0.23l0.25,0.28l-0.05,0.32ZM301.08,112.09l0.41,0.91l0.5,0.75l-0.79,-0.92l-0.12,-0.74ZM296.68,116.02l0.5,0.3l0.14,0.61l-0.55,-0.38l-0.1,-0.53ZM237.6,105.84l0.06,-0.56l0.6,0.2l0.22,-0.4l0.03,-0.9l-0.36,-0.38l0.45,-0.33l0.41,0.26l-0.5,0.87l0.34,0.98l-0.86,0.41l-0.39,-0.15ZM231.75,119.18l0.07,-0.13l0.27,0.06l-0.15,0.17l-0.2,-0.11ZM225.47,120.99l0.06,-0.3l0.49,0.03l0.21,-0.81l0.85,1.04l-0.94,-0.2l-0.67,0.24ZM227.58,121.43l0.18,0.3l-0.83,0.31l0.47,-0.32l0.18,-0.3ZM46.88,231.25l0.41,-0.98l1.76,-1.95l0.24,1.15l-0.58,1.23l-0.87,0.92l-0.95,-0.37ZM0.75,327.35l0.54,0.08l0.93,4.47l1.58,3.32l-0.39,1.32l-0.61,-0.45l-0.62,-1.86l-1.05,-1.31l-0.06,-1.7l-0.68,-1.41l0.01,-2.04l0.34,-0.43ZM3.96,337.26l0.46,0.03l0.78,1.09l0.29,1.64l-0.51,-1.44l-1.02,-1.32Z",name:"Western Australia"},"AU-TAS":{path:"M683.97,652.34l0.14,-0.45l1.06,-0.55l1.09,-0.11l1.38,0.36l0.34,-0.54l1.14,-0.16l0.89,-0.59l2.25,2.21l-1.06,1.08l-0.58,0.09l-0.64,-1.17l-0.82,0.01l-0.93,0.47l-0.78,-0.34l-2.23,0.28l-1.24,-0.59ZM618.08,666.03l0.44,-0.96l-0.27,-0.56l1.19,-0.83l0.31,-0.65l-0.2,-4.58l0.94,1.58l0.68,-0.22l1.84,0.64l1.69,0.0l2.58,1.74l0.61,-0.05l0.42,-0.56l1.79,-0.05l1.63,1.2l2.09,0.57l1.23,-0.35l0.24,0.67l0.87,0.63l2.84,0.57l0.32,0.83l1.38,1.28l2.02,0.34l0.32,0.44l0.97,0.13l1.95,1.13l2.67,0.97l4.25,0.28l2.2,-0.67l0.39,0.79l0.7,0.18l0.28,-0.11l0.02,-0.77l1.16,-1.19l1.52,-0.55l0.63,0.41l0.23,0.55l-0.19,0.55l0.43,0.58l2.78,0.19l0.33,-0.79l-0.81,-0.7l-1.34,-0.35l-0.22,-0.57l0.24,-0.56l1.74,-0.46l1.47,-0.85l3.17,0.59l1.96,-1.29l1.03,-0.06l0.28,0.54l0.61,0.17l0.5,0.6l1.0,0.05l1.55,-1.37l1.43,-2.36l1.06,-0.4l0.77,0.83l0.94,-0.1l1.15,0.77l0.83,-0.07l1.59,-1.06l0.78,-2.26l0.8,-0.03l0.52,0.6l0.72,0.05l0.98,1.35l1.3,0.17l2.19,3.29l-1.05,0.91l0.57,0.72l-0.58,1.27l-0.05,1.93l0.93,1.48l-1.29,1.4l0.07,0.48l0.66,0.24l0.63,-0.55l-0.88,2.67l0.03,2.0l0.65,1.62l-0.56,1.89l0.35,1.39l-0.83,1.36l1.2,2.71l-0.47,3.02l1.14,1.43l-0.98,-0.29l-1.54,-1.08l0.83,-0.5l0.25,-0.93l-0.68,-0.62l-0.3,-0.79l-0.77,0.01l-0.24,0.42l0.17,0.58l-0.83,0.58l0.12,0.83l-0.45,0.55l0.15,0.39l-1.03,0.76l-0.15,1.88l-0.74,0.73l-1.4,2.6l-0.0,0.49l0.47,0.12l0.75,-0.46l-0.5,0.7l0.04,3.3l-0.62,0.57l-0.54,-0.64l-0.85,0.59l-0.21,0.65l0.88,1.01l0.36,1.38l-0.1,1.37l-1.2,0.93l-0.12,1.4l-0.61,0.68l-0.13,0.8l-2.61,-0.01l-1.06,-0.7l-0.42,-0.85l-0.59,-0.17l-1.88,0.89l0.08,1.61l-0.44,-0.41l-0.71,0.3l-0.24,-0.72l-1.05,-0.62l-1.08,-1.8l-0.57,-0.25l-0.69,0.35l-0.1,0.55l1.14,1.31l0.74,1.57l-0.54,1.22l-0.02,1.04l-0.49,-0.44l-0.56,0.03l-0.34,0.38l0.1,0.82l0.65,0.71l-0.98,1.09l0.19,2.93l-0.55,0.44l-0.62,-0.3l-0.26,-0.75l-0.83,-0.08l0.35,-0.72l-0.61,-1.25l-0.82,0.97l-0.41,-0.11l-0.13,-1.54l-0.31,-0.31l-0.59,0.01l-0.65,0.55l-0.31,1.26l0.19,0.9l2.46,2.01l-0.31,0.29l-0.45,-0.29l-0.92,0.1l-0.89,0.71l0.34,0.64l1.21,-0.04l-0.84,1.29l-1.58,0.32l0.69,0.88l-0.42,0.7l0.32,0.7l-1.0,0.2l-0.15,0.61l0.12,0.39l0.81,0.45l-0.14,0.21l-1.26,0.6l-0.87,-0.7l-1.75,0.37l-0.6,-0.88l-1.31,-0.71l-0.33,-1.31l-0.68,-0.77l-0.58,0.18l-0.12,1.0l-0.48,0.31l-2.36,-0.14l-0.59,-0.46l-0.57,0.01l-0.55,0.5l-0.44,-0.89l-0.72,-0.22l-0.75,0.23l-0.27,0.51l-0.8,-0.22l-0.89,0.32l-0.24,0.48l-0.75,0.15l-0.05,-1.92l-0.87,-1.2l0.45,-0.54l-0.11,-0.26l1.62,0.33l0.92,1.19l0.66,-0.17l0.18,-0.83l0.58,0.58l0.69,-0.42l-0.12,-1.83l-1.15,-1.1l-0.61,-0.16l-0.92,1.25l-0.24,-0.79l-0.47,-0.37l-0.66,0.24l-0.24,0.7l-0.7,-0.72l-0.28,-1.4l-0.94,-0.78l-0.68,0.21l-0.0,0.99l-0.71,0.29l-0.11,0.93l-0.63,-2.0l-1.38,-1.65l-0.01,-0.66l-0.58,-0.43l-0.56,0.09l0.32,-0.82l-0.22,-0.46l-0.91,-0.48l-0.8,-1.33l-1.65,-0.3l-0.67,-0.92l-1.41,-3.2l-0.52,-0.48l0.31,-0.77l-0.67,-1.67l-1.51,-1.32l0.38,-0.49l-0.05,-0.54l-0.88,-1.14l-0.21,-0.79l0.14,-0.95l-0.67,-2.11l-0.11,-1.48l1.36,0.63l0.39,0.8l2.03,1.34l0.74,3.15l0.51,0.12l0.36,-0.38l0.06,-1.59l0.72,-0.32l0.74,-1.97l-0.45,-0.51l-0.4,0.11l-0.34,-0.54l-0.81,0.15l-1.76,-2.0l-0.57,-2.24l-0.86,-0.07l-0.86,0.84l0.38,-1.04l-0.29,-1.92l-0.91,-1.87l-2.83,-2.74l-0.16,-0.69l-1.84,-2.51l-0.76,-0.27l-0.08,-1.11l-0.93,-2.49l-1.41,-2.31l-0.74,-0.62l0.54,-0.5l-0.04,-0.75l-1.87,-3.25l0.15,-1.17l-0.44,-1.23l0.09,-0.99l-1.07,-1.63ZM630.11,693.61l-0.0,0.16l-0.05,-0.04l0.05,-0.12ZM673.76,710.77l0.76,1.44l-0.85,0.82l0.23,-0.71l-0.33,-0.65l0.18,-0.9ZM680.86,710.55l0.89,0.06l1.13,-0.54l0.33,0.57l-0.19,0.57l0.37,0.66l-0.69,0.46l-0.42,2.39l0.46,0.65l-0.21,0.52l0.31,0.61l0.38,0.03l-0.46,0.85l-0.86,-0.81l-0.27,-0.93l-0.59,-0.09l-0.6,0.69l-0.06,0.91l-0.78,0.73l-1.49,-1.48l0.85,-0.88l-0.16,-0.65l-1.8,-0.69l-0.4,-0.9l1.01,-0.56l0.32,-1.06l-0.13,1.51l0.96,0.8l1.18,0.41l1.44,-0.35l0.81,-0.99l-1.27,-0.75l0.34,-0.73l-0.53,-0.45l0.13,-0.59ZM681.95,709.53l-0.11,-0.04l0.07,-0.03l0.05,0.07ZM689.93,693.74l0.34,0.28l-0.53,1.1l-0.46,-0.27l0.64,-1.12ZM679.51,640.1l1.54,-0.92l0.53,-1.53l1.08,-0.78l3.85,4.76l2.41,0.72l-0.14,2.16l-1.15,1.06l0.19,0.61l0.42,0.15l1.11,-0.42l0.2,0.56l-0.65,0.2l-0.01,0.8l-1.3,-0.24l-0.41,0.31l-0.2,0.78l-0.95,0.38l-1.15,-0.53l0.13,-0.92l-0.73,-0.72l-0.28,-1.46l-0.97,-0.52l-0.38,-0.97l-0.76,-0.32l0.32,-0.99l-0.56,-1.9l-0.77,-0.26l-0.74,0.39l-0.62,-0.39ZM686.08,655.25l0.22,-0.16l1.39,-0.38l-0.48,1.39l-1.13,-0.85ZM684.59,705.93l0.02,-0.05l0.15,-0.51l0.21,0.49l-0.38,0.07ZM684.73,704.88l-0.5,-0.44l0.15,-0.55l0.9,-0.58l0.63,0.1l0.39,1.06l-1.33,0.02l-0.24,0.38ZM670.41,716.54l0.65,-0.1l0.26,-0.64l-0.43,-0.36l0.07,-0.23l0.52,0.54l0.3,1.22l-1.37,-0.43ZM671.95,717.48l0.22,0.72l-0.87,0.06l0.4,-0.28l0.25,-0.5ZM670.61,630.86l-0.05,0.01l0.06,-0.05l-0.01,0.04ZM666.98,723.8l0.46,0.15l-0.07,0.15l-0.16,0.12l-0.23,-0.43ZM668.02,722.32l-0.05,-0.4l0.24,0.25l0.64,-0.12l0.34,-0.78l-0.2,-0.62l0.92,-1.04l0.9,2.33l-0.9,2.42l-0.9,-0.41l0.2,-0.19l-0.25,-1.15l-0.43,-0.34l-0.53,0.05ZM623.04,659.21l-0.02,-0.88l0.62,-0.64l1.28,0.88l-1.88,0.64ZM622.58,652.99l0.62,-0.96l0.72,0.21l-0.19,0.74l-0.7,0.3l-0.45,-0.29ZM620.03,654.24l0.33,-0.03l0.28,-0.14l-0.41,0.72l-0.2,-0.55ZM603.21,637.29l0.11,-1.01l1.63,-1.11l-0.17,-1.58l0.48,-0.13l1.68,1.1l0.47,0.94l-0.13,1.04l0.4,1.91l-0.4,1.97l0.73,0.7l-0.08,1.25l-0.45,0.96l-1.1,0.93l-2.35,1.13l-0.43,-1.07l0.34,-0.65l-0.14,-1.63l-0.93,-0.83l0.09,-1.37l0.47,-1.13l-0.22,-1.44Z",name:"Tasmania"},"AU-":{path:"M735.23,533.88l0.59,-0.41l1.33,0.11l-0.1,0.39l-0.66,0.26l-0.54,-0.4l-0.63,0.05Z",name:"Jervis Bay Territory"},"AU-VIC":{path:"M546.94,509.12l0.93,0.94l1.87,0.09l1.14,0.56l0.92,-0.29l1.54,1.38l1.43,-0.1l1.2,0.73l0.98,0.09l0.75,1.01l0.84,-0.2l1.2,-1.39l1.34,-0.78l0.7,-0.13l1.81,0.59l3.92,-0.34l1.1,1.22l0.94,-0.26l0.84,0.7l0.63,0.0l0.33,1.52l0.99,1.13l0.88,0.64l0.93,-0.09l-0.6,1.52l0.27,2.46l1.63,1.65l-0.01,0.64l1.05,1.85l0.03,0.75l0.65,0.62l1.44,0.48l0.79,-0.1l0.24,-0.52l-0.25,-0.62l0.93,-0.04l0.29,-0.32l0.53,-2.61l0.92,-0.35l0.98,0.69l0.43,1.16l0.55,0.23l0.74,-0.42l0.84,0.64l0.71,-0.33l0.81,0.43l1.76,0.15l2.23,1.13l0.62,0.93l0.69,-0.19l0.35,0.24l-0.0,1.15l-0.4,0.55l-0.13,1.65l0.67,3.31l1.2,1.95l3.06,1.24l0.14,0.96l-0.29,0.65l0.31,0.76l1.34,0.85l2.42,0.64l3.89,2.27l0.49,0.79l1.87,0.63l1.54,2.01l1.92,1.57l0.98,0.19l0.44,0.41l1.97,3.8l0.84,0.34l2.17,2.37l1.53,0.4l1.34,1.19l1.63,-0.15l1.34,-1.13l1.3,0.48l0.68,-0.24l0.23,-0.69l-0.96,-1.59l0.69,-2.28l0.46,-0.35l3.92,-0.35l2.24,0.55l0.91,-0.06l2.32,-0.97l1.27,0.27l3.31,2.66l0.93,0.39l2.99,-0.28l0.9,1.06l1.49,0.06l3.0,0.85l0.71,-0.43l2.56,0.36l0.49,-0.27l0.85,-1.32l0.61,0.17l0.54,-0.26l0.78,0.41l1.44,0.0l1.15,1.01l1.29,0.12l1.71,1.04l0.89,-0.05l1.01,0.59l0.83,-0.08l0.6,-0.48l0.39,0.19l0.2,1.9l1.55,1.25l1.74,-0.47l0.24,-0.6l-0.39,-0.42l-1.21,-0.21l-0.36,-0.46l-0.25,-1.2l0.74,-1.08l0.79,0.49l1.87,-0.32l1.0,0.49l0.64,-0.1l0.76,-2.07l1.71,-0.6l1.25,1.08l3.14,-1.24l3.6,1.38l0.64,0.84l0.99,0.33l-0.13,1.1l1.0,1.17l-0.24,1.37l0.9,2.45l-0.34,0.85l0.15,0.7l1.26,1.17l0.38,2.31l0.99,0.65l0.23,0.5l-0.15,0.97l-1.58,2.43l0.17,0.68l1.89,0.33l33.65,15.64l-2.51,0.45l0.06,-0.71l-0.45,-0.25l-0.52,0.29l-1.21,-0.01l0.84,1.69l-1.59,2.21l-1.02,0.31l-0.52,0.59l-1.58,0.46l-0.51,0.64l-2.64,0.02l-1.21,0.51l-0.5,-0.44l-2.43,-0.28l-0.77,0.29l-5.91,0.19l-1.24,0.57l-2.33,-0.27l-5.87,0.29l-3.46,0.77l-4.17,1.39l-3.15,1.52l-3.36,2.21l-3.78,3.16l-10.3,9.93l-0.54,-0.16l-2.7,0.56l-1.4,-0.02l-0.92,0.55l-1.34,-0.06l-1.74,0.74l-1.19,-0.88l-1.92,0.17l-0.81,0.41l-0.81,0.94l0.02,0.55l1.46,1.55l0.35,1.66l0.44,0.4l0.83,-0.09l0.84,-0.95l0.98,-0.24l0.67,-1.35l0.17,2.4l-0.55,0.62l-0.38,1.67l0.25,0.55l0.62,0.33l-0.75,0.45l-0.09,0.97l-0.37,0.19l-1.01,-0.63l0.37,-1.01l-1.15,-0.86l-0.75,-2.03l-1.44,-1.71l-2.04,-1.16l-1.45,0.27l-0.46,0.56l-0.13,1.02l-0.93,0.16l-0.4,-1.58l-1.34,-2.36l0.5,-0.57l-0.94,-1.24l-1.86,-0.36l-2.38,0.92l-1.5,-2.17l-1.92,-0.83l0.36,-0.37l-0.0,-1.8l1.17,0.17l1.33,-1.33l-0.12,-0.56l-0.65,-0.6l-0.01,-0.86l-1.25,-1.71l-0.8,-0.21l-3.64,0.39l-0.61,1.54l-0.63,0.7l0.43,1.52l-1.88,-0.06l-0.54,0.72l-0.68,0.29l-0.51,0.97l-1.72,0.24l-2.29,-2.05l1.62,-0.14l2.15,-0.98l0.14,-0.82l2.36,-3.17l0.28,-0.91l-0.44,-2.03l-0.59,-0.73l-1.02,-0.51l-0.91,-2.24l-1.26,-0.83l-0.46,0.04l-0.4,0.62l-1.38,0.05l-0.59,1.07l-1.27,0.53l-1.19,1.09l-2.27,0.74l-0.82,1.27l-0.54,-0.21l-1.57,0.18l-0.81,0.54l-0.2,0.64l0.53,0.71l2.89,0.51l0.94,-0.14l1.71,-1.0l0.73,0.36l0.06,0.91l-0.82,0.62l-0.4,0.98l-1.99,0.03l-0.77,0.29l-0.97,-0.29l-1.0,0.31l-2.88,2.21l-3.91,1.96l-1.11,1.15l-0.15,0.78l-1.02,0.44l-0.69,1.29l-1.07,0.99l-2.67,0.82l-0.87,1.37l-1.01,0.44l-1.21,1.1l-1.47,-1.3l-1.92,-0.93l-2.55,-0.02l-1.98,-2.0l-1.23,-0.75l-4.85,-1.32l-3.0,-2.35l-2.67,-1.55l-0.47,-0.76l-0.69,0.08l-0.33,0.46l-0.92,-0.68l-1.81,-0.03l-1.75,0.87l-0.81,-0.13l-4.4,-2.6l-3.84,-0.51l-1.83,0.53l-0.87,0.6l-0.43,1.12l0.53,0.86l-0.66,-0.11l-0.82,0.81l-0.51,-0.84l-0.72,-0.37l-1.09,-0.03l-0.53,0.64l0.29,-1.52l-0.59,-0.93l-3.17,-2.7l-4.61,-2.46l-0.02,-89.31ZM654.74,614.79l0.37,0.05l0.31,-0.06l-0.1,0.2l-0.58,-0.19ZM631.26,604.7l1.24,0.36l1.13,-0.19l0.48,0.49l-1.05,0.16l-1.1,1.05l-0.92,-0.42l-0.19,-0.67l0.42,-0.79ZM628.46,608.77l0.71,-0.62l1.61,-0.14l0.11,0.81l-0.69,-0.15l-1.09,0.36l-0.66,-0.27Z",name:"Victoria"},"AU-NT":{path:"M313.75,111.76l1.19,0.46l0.59,0.98l1.02,0.48l-0.18,1.34l0.45,1.15l-0.88,2.04l0.41,0.54l0.69,-0.25l0.5,0.52l0.36,-0.31l0.52,-2.25l0.44,-0.42l-0.67,-4.22l0.39,0.23l0.59,-0.52l0.85,0.25l0.47,0.59l1.92,0.54l0.68,1.45l1.03,0.75l0.45,1.1l-0.23,1.0l0.63,0.38l0.96,-0.61l0.11,0.88l0.57,0.38l0.95,-0.11l0.41,-0.6l-0.24,-0.7l-1.23,-1.39l-0.51,-1.28l-0.27,-1.37l0.55,-1.72l2.7,0.42l1.51,-0.52l0.94,-0.89l0.86,0.29l0.59,-0.38l0.2,-1.48l-0.27,-0.62l-0.72,0.13l-0.33,0.64l-2.6,1.01l0.1,-0.43l-0.39,-0.44l-1.34,0.52l-0.8,-0.59l-0.07,-0.7l-1.15,-0.89l-0.25,-0.68l2.16,-0.22l1.59,-1.39l0.08,-0.44l-0.89,-0.2l-1.82,0.83l-2.4,-0.54l-3.23,-2.49l0.24,-1.31l0.68,-0.84l0.23,-1.05l1.27,-1.44l0.2,-1.79l0.45,0.48l1.25,0.02l0.43,-1.01l1.96,-0.38l0.54,-0.61l0.33,-1.52l-0.64,-1.09l1.86,-1.94l-0.54,-1.65l0.85,-2.07l0.15,-1.28l0.62,-0.43l0.37,0.57l1.11,0.4l1.68,-0.52l1.29,-0.99l0.64,0.03l2.24,-2.64l1.27,0.47l0.46,-0.5l-0.46,-0.93l-1.4,-0.61l-1.56,-2.08l-0.72,-0.23l0.22,-3.95l0.56,-0.25l0.98,0.52l2.06,-0.86l0.72,-1.41l0.17,-2.02l-0.26,-0.99l0.64,0.12l0.94,-1.05l1.55,0.38l0.4,0.62l1.4,0.7l1.66,-0.35l0.19,-0.39l-0.27,-0.49l-1.75,-0.31l-0.19,-0.29l0.69,-0.66l-0.24,-0.72l-0.44,-0.15l0.42,-1.18l-0.23,-0.87l0.5,-0.67l-0.36,-0.44l2.66,0.75l0.27,2.92l0.36,0.29l0.55,-0.77l1.33,1.74l0.46,0.08l0.19,-0.73l0.76,0.45l0.47,-0.03l0.12,-0.45l-0.34,-0.73l-1.32,-1.03l1.15,0.51l0.52,-0.51l-0.83,-1.17l-1.37,-0.9l-0.55,0.16l0.06,-0.36l1.18,-1.2l2.56,0.72l0.58,-0.35l-0.48,-1.42l-0.05,-1.45l-0.53,-0.77l0.29,-0.45l0.72,0.37l0.67,-0.25l0.37,0.46l0.66,0.02l1.18,1.09l0.81,0.07l0.28,-0.64l-0.31,-0.41l0.34,-0.45l0.33,-1.86l0.3,2.05l0.41,0.79l2.22,1.58l1.03,0.17l1.58,-0.27l0.8,0.23l3.31,-0.51l1.96,-1.05l0.66,0.85l2.67,0.92l1.36,-0.71l1.01,-1.0l0.82,-0.25l0.49,-0.88l0.21,0.98l0.42,0.3l1.62,-0.41l0.7,1.51l-0.62,0.78l0.27,1.11l0.44,-0.13l1.24,-1.63l-0.46,-1.62l0.24,-1.17l2.15,-1.12l2.17,0.88l1.64,-0.07l0.33,-0.34l-0.23,-0.41l-0.86,-0.16l-1.17,-0.79l-0.28,-0.52l0.48,-3.87l-0.27,-0.71l-0.8,-0.58l1.92,-2.35l-0.25,-0.51l-2.17,-0.78l-0.35,-0.35l0.02,-0.72l-1.2,-1.47l-1.79,-0.9l-1.52,-0.06l-0.75,0.45l-1.3,-0.12l-2.81,1.27l-0.75,-0.7l0.38,-0.31l-0.07,-0.57l-0.68,-0.41l-0.62,0.1l-0.31,-0.38l0.2,-0.44l-0.25,-0.56l-0.79,-0.09l-0.3,-0.56l-1.4,-0.35l-0.04,-0.92l0.72,-0.32l0.98,0.99l1.0,-0.57l0.25,-1.52l1.52,1.6l0.17,2.02l0.68,0.25l0.14,0.74l0.66,0.54l0.57,0.08l0.45,-0.41l-0.07,-0.56l0.44,-0.11l0.26,-0.5l-0.81,-1.17l-0.19,-1.86l0.8,1.37l0.56,0.39l0.59,-0.26l-0.09,-1.94l0.76,-0.03l0.44,0.91l-0.09,1.18l0.45,0.58l0.82,-0.33l0.32,-0.98l0.41,0.14l0.78,1.98l0.68,0.14l1.24,1.27l1.4,2.13l1.44,-0.02l2.09,-2.08l0.71,0.33l0.51,-0.27l0.17,-1.12l2.0,2.68l0.62,0.36l-0.01,1.0l1.84,2.88l2.08,0.62l0.77,-0.36l0.03,0.59l0.4,0.35l1.32,-0.12l1.64,0.72l0.98,-0.47l-0.32,1.28l0.23,0.57l0.63,-0.08l0.69,-1.08l0.53,0.59l1.12,-0.28l0.5,-0.82l1.2,-0.13l1.06,-1.07l1.61,0.48l-1.31,0.76l-0.25,0.81l0.33,0.65l1.98,1.18l1.57,-0.62l0.52,-0.75l0.49,0.59l0.04,0.85l0.65,0.15l0.62,-0.58l0.7,2.11l-0.11,1.09l0.45,0.45l0.42,-0.08l1.24,-1.24l0.21,-0.76l1.82,1.37l2.82,0.45l1.76,-0.17l2.05,-1.94l0.72,-0.18l0.08,0.75l0.67,1.03l0.58,0.07l0.62,1.65l1.96,0.36l0.65,1.11l1.46,1.17l1.49,-0.3l1.07,0.96l0.63,0.13l0.59,-0.71l-0.63,-0.7l0.51,-0.08l0.83,0.65l1.36,-0.52l0.14,-0.49l-1.76,-0.64l1.13,-0.72l-0.06,-0.56l0.78,-0.39l0.88,0.48l0.82,0.0l1.29,-0.68l1.14,0.38l2.68,-1.79l1.37,-0.38l-3.07,2.79l-0.08,1.08l0.37,0.82l1.23,1.48l0.72,-0.01l0.36,-0.75l0.73,-0.27l0.31,-0.75l1.27,-1.12l0.18,0.38l0.43,0.03l0.0,0.58l0.61,1.02l0.58,0.16l0.81,-0.31l-1.09,1.88l0.86,2.1l0.66,0.28l0.56,-0.48l1.38,-0.08l0.63,0.52l1.66,-0.43l0.72,-0.56l1.77,-3.7l-0.59,-1.03l-2.16,-0.05l-0.33,-0.35l1.54,-2.01l0.82,-0.12l1.91,-1.68l0.42,0.84l0.91,-0.23l0.45,1.47l0.44,0.3l0.16,1.59l2.09,2.34l0.99,-0.01l1.01,-0.85l-0.13,-0.72l-0.83,-0.45l0.54,-0.22l0.97,0.82l1.06,0.26l0.51,0.66l0.52,1.7l-1.81,1.75l-0.57,-0.44l-1.23,0.63l-0.27,0.97l0.19,1.02l-0.88,1.0l-0.36,1.5l-1.29,0.27l-0.28,0.81l-0.75,-0.32l-0.52,0.23l-0.23,0.53l-0.27,-0.22l-0.68,0.16l0.28,2.01l1.05,0.73l0.42,0.7l1.2,0.55l-0.5,0.26l-0.79,-0.63l-1.29,0.54l0.08,0.96l1.06,1.06l-0.38,1.06l-0.55,0.09l-0.45,0.52l-0.13,0.9l-0.99,0.32l-0.35,-0.56l0.01,-2.65l-1.1,-0.56l-0.93,1.13l0.12,1.22l-0.6,-0.71l-0.47,0.09l-0.45,0.56l0.16,0.82l-0.62,0.62l-0.5,0.14l-0.07,-0.26l0.33,-0.73l-0.21,-1.12l-0.7,-0.19l-0.9,0.89l-0.39,1.07l-0.52,0.23l-0.68,-0.4l-0.51,0.17l-0.45,0.71l-0.92,0.29l-0.75,1.12l-0.12,1.11l0.81,0.51l-0.09,0.46l-0.52,-0.09l-0.62,0.4l0.15,2.17l-0.34,0.4l-0.09,0.95l0.94,1.44l-0.11,0.83l0.51,0.68l1.55,0.08l0.84,-0.67l-0.6,1.19l-0.3,2.09l-1.35,1.28l-0.32,4.22l-2.8,1.66l-1.79,3.18l-0.84,0.13l-0.32,0.45l-1.53,2.61l-0.25,1.34l-1.11,0.54l-0.42,0.67l-0.82,-0.19l-0.51,0.33l0.62,2.24l1.38,2.81l1.66,1.47l1.33,0.57l0.63,-0.07l1.12,1.22l1.01,0.21l1.92,1.17l1.72,1.72l5.35,2.9l0.9,2.97l1.56,1.16l1.32,0.17l2.15,1.9l0.65,0.17l0.62,-0.23l0.26,0.65l2.06,2.07l-0.29,0.83l0.24,0.7l0.92,0.21l0.79,-0.71l1.51,0.15l0.67,0.51l0.6,0.02l0.39,-0.94l0.69,-0.38l1.04,1.02l2.97,1.25l3.24,2.77l0.88,0.14l1.64,0.96l1.21,-0.1l3.63,1.52l2.3,3.62l2.53,2.08l0.0,192.29l-174.58,0.0l0.0,-225.43ZM368.32,40.44l-0.06,0.03l-0.06,0.02l0.03,-0.07l0.09,0.02ZM461.21,69.3l0.26,0.35l-0.02,0.49l-0.04,-0.22l-0.2,-0.62ZM448.26,82.8l0.0,0.0l-0.0,0.0l-0.0,-0.0ZM444.0,54.19l-1.43,0.26l-0.81,0.57l-0.06,-0.17l0.46,-0.94l0.77,0.24l1.08,-0.7l0.65,0.13l-0.66,0.62ZM445.22,53.35l0.4,-0.26l0.59,-0.51l-0.43,0.56l-0.57,0.21ZM447.88,50.55l-0.05,-0.17l-0.18,-0.37l0.37,0.14l-0.15,0.4ZM397.23,48.81l0.03,-0.12l0.05,0.0l-0.08,0.12ZM375.37,37.82l-0.22,-0.18l-0.06,-0.1l0.14,0.05l0.14,0.22ZM468.43,127.67l0.1,-0.35l0.71,0.08l0.23,-0.8l0.98,0.58l-0.08,1.78l0.5,0.56l-0.35,0.77l-0.27,-0.69l-0.69,-0.31l-0.3,-1.34l-0.82,-0.27ZM458.1,97.49l0.55,-1.23l-0.52,-2.32l0.4,-2.33l-0.36,-0.84l0.35,0.33l1.21,0.0l0.57,-0.47l1.7,-0.47l0.35,-0.43l-0.5,-0.97l0.81,-0.4l-0.11,0.69l0.59,0.6l0.23,1.08l0.82,0.56l1.65,0.04l0.63,-0.72l-0.08,-1.06l0.73,-0.02l0.23,0.48l-0.87,0.96l-0.3,0.83l-1.16,0.18l-0.6,0.65l-0.19,1.36l0.53,0.52l-1.52,0.61l-0.15,1.32l0.65,1.61l1.4,0.02l0.27,-0.52l1.47,0.98l0.75,-0.57l0.25,0.54l-0.23,0.67l-0.5,0.2l-3.05,-0.68l-1.17,0.56l-0.62,-0.08l-4.2,-1.69ZM463.06,88.02l0.23,-0.44l0.18,-0.01l-0.1,0.31l-0.3,0.14ZM464.48,128.23l0.08,-0.28l0.03,-0.23l0.15,0.36l-0.27,0.16ZM459.77,42.86l-0.03,-0.08l0.93,-0.65l-0.68,0.76l-0.23,-0.03ZM461.45,40.94l0.65,-1.42l0.63,-0.85l0.23,-0.06l-1.51,2.34ZM462.63,128.85l-0.47,-0.7l0.51,-0.43l0.51,0.3l-0.56,0.83ZM460.11,126.16l-0.1,-0.48l0.39,-0.78l0.85,-0.31l-0.26,1.5l-0.88,0.07ZM459.73,88.55l0.04,0.12l-0.11,0.54l-0.4,-0.46l0.48,-0.21ZM454.83,46.91l0.2,-0.39l0.11,-0.17l0.13,0.14l-0.44,0.41ZM452.75,55.43l0.69,-0.27l0.14,0.1l-0.33,0.25l-0.5,-0.09ZM452.4,89.34l-0.0,-0.18l0.11,0.05l-0.11,0.13ZM453.35,89.0l0.59,-1.31l1.02,0.71l-0.74,0.37l-0.09,0.3l0.49,0.54l-0.45,0.97l-0.83,-1.59ZM452.64,83.33l0.02,-0.06l0.0,0.05l-0.02,0.02ZM452.93,83.07l-0.24,0.12l0.1,-0.35l0.14,0.22l0.0,0.01ZM449.25,48.29l0.33,-0.25l0.35,-0.17l-0.33,0.43l-0.36,-0.01ZM444.66,111.44l0.04,-0.26l-0.02,-0.11l0.12,0.25l-0.14,0.12ZM428.13,55.93l0.36,0.06l-0.02,0.23l-0.16,0.02l-0.18,-0.32ZM382.93,47.77l0.43,0.07l0.65,-0.04l-0.23,0.49l-0.96,0.15l-0.68,-0.8l0.79,0.13ZM381.87,37.87l0.42,-0.71l-0.39,-1.29l0.94,-0.35l0.49,1.2l-0.58,0.88l0.66,0.58l0.2,1.32l-0.42,1.1l-0.33,-1.29l-1.0,-1.43ZM379.02,56.27l0.45,0.03l-0.01,0.29l-0.44,-0.33ZM340.57,38.26l1.96,2.4l0.6,0.14l0.55,-0.43l0.29,0.18l0.12,0.27l-0.76,1.21l0.46,0.77l0.7,-0.07l0.74,-0.67l0.79,1.26l0.73,0.07l0.46,-0.83l2.16,-0.43l1.4,-1.0l1.38,0.68l0.26,1.1l0.36,0.27l0.5,-0.5l0.37,-1.6l1.45,-0.95l1.12,2.44l0.64,0.26l0.38,-0.53l-0.51,-2.69l0.91,-0.82l0.23,0.49l-0.27,0.63l0.42,0.55l0.59,-0.07l0.39,-0.53l0.61,0.23l0.77,-0.22l0.76,2.51l0.27,0.36l0.9,-0.19l0.09,1.09l-0.77,-0.03l-0.46,0.54l-0.31,1.54l0.18,0.53l-1.42,-0.51l-1.88,2.88l-0.6,0.08l-3.08,1.95l-2.52,2.01l-1.09,-1.04l-3.96,-1.76l-0.21,-0.5l-2.3,-1.84l-1.16,-0.35l-0.21,-1.87l-1.02,-1.23l-0.71,-2.88l0.15,-0.97l-0.62,-0.75l0.15,-1.2ZM333.61,50.06l0.98,-0.47l-0.08,-1.2l1.28,0.44l1.3,-1.06l-0.25,-2.22l0.26,-0.91l-0.68,-0.82l1.88,-2.14l1.0,-0.14l0.91,1.76l-0.29,0.83l0.12,1.0l1.41,1.34l-0.28,2.02l0.53,0.38l0.6,-0.23l1.19,0.29l1.31,0.98l-0.07,0.39l-0.79,0.35l-1.4,0.12l-3.34,-1.3l-4.07,1.12l-1.1,-0.08l-0.43,-0.44Z",name:"Northern Territory"},"AU-QLD":{path:"M789.12,373.33l0.3,-1.54l-0.25,-0.61l0.26,-1.24l-0.25,-1.11l0.61,-1.03l0.05,-0.69l0.6,0.47l0.61,0.04l-1.48,5.64l-0.44,0.06ZM489.12,145.78l2.96,2.35l2.28,1.03l1.57,0.01l2.27,0.95l3.13,-0.31l0.56,0.58l3.12,1.27l3.19,0.47l0.98,1.59l1.58,0.98l-0.18,1.51l0.23,1.15l1.84,3.3l0.8,0.57l3.15,0.54l3.85,3.08l3.31,0.81l2.24,1.01l0.55,0.91l1.12,0.86l2.38,0.19l2.4,-0.27l5.3,-1.35l3.54,-2.27l1.0,-0.22l0.6,-0.92l1.65,-0.71l0.76,-1.95l0.41,-2.41l0.89,-1.82l0.21,-1.3l-0.23,-1.1l1.92,-2.45l0.64,-1.68l0.63,-0.17l1.69,-1.95l0.69,-2.62l0.5,-0.21l0.63,-1.34l0.24,-1.16l-0.28,-0.75l0.55,-0.82l0.65,-2.85l1.54,-3.12l-1.01,-2.69l0.51,-0.7l0.68,-4.89l0.91,-3.34l1.63,-3.84l0.2,-1.33l1.07,-1.45l0.01,-0.78l0.45,-0.51l0.06,-2.02l-1.13,-2.29l-1.59,-7.76l0.21,-1.51l1.33,-3.93l-0.04,-1.92l-0.35,-0.94l-1.88,-2.47l-0.31,-1.51l0.12,-1.68l1.01,-3.99l1.94,-4.08l0.72,-0.17l0.01,-0.8l0.6,-1.45l-0.24,-0.92l-1.12,-1.51l-0.17,-1.66l-0.58,-1.2l0.74,-1.18l2.11,-1.33l1.16,-2.79l0.65,-0.21l0.35,0.42l0.31,2.58l0.83,1.23l0.46,0.19l0.29,-0.4l-0.01,-1.21l-0.47,-1.53l1.31,-0.46l0.5,-0.76l-1.88,-0.34l-1.25,-0.86l1.49,-0.84l0.58,0.02l0.42,-0.32l-0.25,-0.46l-0.98,-0.41l-0.71,0.3l-1.72,0.01l-1.28,-1.29l0.48,-0.39l-0.1,-0.71l-1.87,-0.28l1.31,-3.48l1.16,0.25l0.78,-0.48l-0.99,-1.09l0.79,-2.38l1.13,-1.48l0.71,2.72l0.45,-0.2l0.58,-1.09l0.84,0.56l0.6,-0.2l0.21,-0.61l-0.04,-0.47l-0.8,-0.97l-0.77,-0.33l-0.03,-1.16l0.36,-1.56l0.86,-1.17l0.0,-1.0l2.35,-7.22l0.05,-2.05l0.51,-1.77l-0.19,-3.74l3.54,-1.07l1.34,-1.57l0.74,-1.86l0.87,0.04l0.59,-0.33l1.15,0.7l-1.9,1.84l-0.23,1.79l0.47,0.57l0.41,-0.12l0.96,-1.43l0.49,-0.03l0.21,0.93l0.63,0.37l0.01,1.11l0.73,0.07l0.82,-0.45l0.65,1.42l0.53,2.17l-0.26,0.9l0.16,1.27l0.81,0.71l0.55,1.26l-0.96,1.75l0.7,2.72l0.1,4.61l2.74,2.17l2.31,-0.57l1.51,1.19l-2.21,3.22l-0.18,3.59l0.44,0.55l1.86,0.08l1.26,0.87l0.8,2.86l2.51,1.37l-0.98,2.24l-0.39,2.85l0.21,0.47l0.67,-0.36l2.18,-0.07l-0.38,1.06l0.27,0.57l-0.16,2.37l0.47,2.4l-0.01,2.67l1.31,1.96l-0.25,1.32l0.23,0.66l-0.55,1.21l-0.67,3.2l1.31,2.66l0.31,1.34l1.45,1.31l0.4,3.83l1.52,3.95l1.36,1.4l2.35,0.79l2.3,-1.06l1.97,-1.67l0.47,-0.9l0.05,-1.2l0.43,0.06l0.45,0.65l1.24,0.26l2.76,-1.3l0.96,-1.49l1.13,1.51l0.01,2.1l0.86,0.25l-0.26,0.6l0.14,1.47l1.2,1.59l0.59,0.26l1.11,-0.17l0.84,0.94l1.92,0.24l0.79,2.31l1.64,1.4l0.82,-0.06l1.84,0.84l0.81,-0.0l0.23,0.73l1.11,1.32l0.96,0.12l-1.63,2.51l-0.16,1.88l0.5,1.33l0.73,0.46l-0.41,0.75l0.1,0.94l-0.56,0.39l-0.28,1.01l0.51,0.5l0.17,0.61l-0.25,0.77l0.97,1.04l-0.15,1.16l1.12,2.29l-0.13,1.25l0.26,0.51l-0.32,1.37l1.51,1.92l0.56,1.22l-0.54,2.67l0.66,1.17l-1.01,1.38l-0.3,2.47l0.54,0.85l0.75,0.06l0.32,0.94l1.95,2.87l1.8,1.28l0.31,0.85l0.67,0.44l0.92,1.41l-0.63,0.68l0.91,1.8l0.91,-0.22l-0.13,-1.14l0.71,-0.62l0.68,0.35l0.31,-0.1l0.67,-0.64l0.11,-0.01l-1.2,2.25l-0.19,1.34l1.38,2.07l0.3,1.58l1.25,2.39l0.8,0.76l-0.09,2.38l1.49,2.14l-0.78,1.0l-0.02,1.6l-0.38,0.51l0.45,1.56l-0.24,1.31l-1.78,4.24l0.12,2.14l1.9,2.43l1.46,0.46l0.48,2.43l0.51,0.46l2.0,0.19l-0.14,1.34l-0.77,2.02l-0.42,2.91l0.2,0.68l1.2,1.8l1.47,1.0l1.09,1.36l3.83,2.2l1.0,0.2l0.84,-0.33l0.94,1.17l2.01,1.39l1.43,-0.17l1.35,-1.38l0.04,1.59l1.52,2.01l0.9,-0.07l1.84,0.49l0.63,-0.27l2.54,0.04l0.65,-0.32l1.53,2.32l0.75,2.2l0.08,0.9l-0.61,0.34l2.42,2.83l2.24,0.28l0.38,-0.55l-0.6,-2.2l0.78,0.25l0.83,2.66l1.24,1.05l1.86,0.32l1.11,-0.6l0.88,1.01l2.64,0.65l0.35,0.82l-0.28,0.12l0.01,1.45l2.47,1.77l0.25,0.58l1.25,-0.1l0.46,-0.5l-0.16,-0.51l0.39,-0.73l-0.75,-0.93l0.73,0.43l1.01,-0.26l0.16,1.24l0.76,1.5l0.38,0.17l0.71,-0.27l0.25,1.14l0.56,0.33l1.54,-0.67l0.08,0.79l1.04,1.09l0.03,1.44l-0.8,-0.16l-0.57,0.78l-1.03,-0.66l-0.5,0.45l0.33,1.42l-0.8,0.48l-0.41,0.51l0.1,0.34l0.72,1.25l0.5,0.29l-0.2,0.3l0.54,1.19l1.07,1.15l0.96,0.06l0.15,0.87l-0.46,1.45l0.77,0.14l0.63,-0.65l0.79,0.43l0.75,-0.12l0.97,0.72l-0.05,0.89l0.3,0.53l1.16,-0.12l0.51,0.46l0.64,0.06l1.35,1.66l-0.68,1.72l0.05,0.98l0.8,1.34l0.74,-0.14l0.4,0.26l0.34,1.49l-0.49,0.73l0.56,0.4l-0.52,0.54l-0.01,1.19l0.44,0.32l0.93,-0.46l0.6,0.25l0.09,0.71l0.54,0.74l0.63,0.22l-0.31,0.81l0.68,1.64l-0.7,0.46l-0.12,0.99l0.8,1.35l-0.02,1.59l0.91,1.71l0.14,1.28l0.75,1.47l-0.29,0.63l1.01,1.29l-0.33,0.6l0.14,0.41l1.12,0.5l0.44,0.74l0.55,0.23l-0.06,1.42l-0.68,0.95l0.42,0.58l2.16,-1.07l0.77,-1.17l0.98,1.61l1.57,1.31l1.21,2.06l0.52,0.31l0.58,-0.45l-0.49,-1.94l-1.77,-3.88l0.37,-0.41l-0.46,-0.78l0.93,-2.3l1.04,-0.44l1.08,1.86l0.64,0.46l0.89,2.36l4.09,1.96l0.77,0.8l1.44,0.5l1.77,1.47l0.56,-0.04l0.11,-0.68l-0.54,-0.79l-0.17,-1.21l-0.58,-0.45l-0.17,-0.9l0.38,-1.52l0.78,0.15l0.02,1.05l2.37,1.25l-0.42,0.52l-0.7,-0.3l-0.55,0.67l0.13,0.81l0.46,0.56l0.3,-0.08l0.31,1.3l0.91,-0.16l0.9,1.42l-0.77,4.17l-0.74,0.16l-0.2,0.58l0.66,0.67l0.12,0.99l-0.28,2.83l0.62,0.57l0.2,1.06l0.6,0.29l-0.96,1.24l0.52,2.1l1.2,1.39l-0.81,-0.01l-0.42,0.54l1.01,0.56l0.44,0.91l0.46,0.2l1.05,-0.56l1.12,0.46l0.39,0.72l1.69,1.38l1.22,2.68l1.78,0.55l0.3,0.56l0.63,0.13l2.35,3.01l0.88,-0.3l0.88,0.58l-0.14,0.78l0.45,0.68l0.43,0.19l0.55,-0.31l0.13,-0.56l0.45,-0.05l1.24,0.9l0.58,-0.44l-0.11,-0.48l0.55,0.23l0.52,-0.41l0.71,1.95l0.86,0.66l0.79,-0.03l0.68,0.77l1.32,4.03l1.07,2.14l1.32,1.7l3.63,2.79l1.97,0.54l1.11,1.03l0.52,1.62l0.14,2.29l1.75,2.65l0.73,0.46l-1.13,0.07l0.04,0.77l1.03,0.28l1.51,1.25l2.29,0.66l0.55,-0.26l1.26,0.31l0.24,2.21l-0.77,0.49l-0.38,0.75l0.52,0.51l0.9,-0.45l0.26,0.65l-1.0,1.09l0.06,2.04l-0.42,0.65l0.75,0.73l0.15,0.73l1.11,0.56l0.62,1.07l0.23,1.39l-0.26,1.46l0.4,0.39l0.49,-0.22l0.7,-1.58l0.63,1.04l1.0,0.24l-0.86,1.96l-1.33,5.43l0.36,1.23l0.83,0.36l-0.42,1.32l-0.07,3.96l0.21,0.75l0.55,0.33l-0.05,4.13l1.23,3.7l-1.47,-0.01l-0.82,0.49l-0.8,1.01l-0.24,1.06l0.62,0.55l0.88,0.03l-1.01,1.36l0.12,0.77l1.99,1.12l0.49,1.81l1.3,0.68l0.85,1.83l0.17,1.65l1.81,2.64l0.03,0.82l0.55,0.19l-0.15,1.33l-0.4,0.31l-0.19,1.0l0.24,0.57l0.64,0.1l0.14,1.96l0.93,1.3l-2.48,1.79l-3.14,0.24l-1.74,1.99l-4.64,-0.66l-2.1,0.75l-2.69,-1.37l-0.42,0.11l-0.52,0.74l-0.55,-1.08l-0.64,-0.41l-0.58,0.05l-1.2,0.97l-0.76,1.19l-1.83,0.42l-1.16,1.03l-1.36,0.06l-4.07,2.34l-0.04,0.91l1.99,2.76l-0.91,3.84l-1.43,0.45l-1.43,-0.18l-0.68,1.01l-0.74,-0.19l-0.63,-1.2l-0.57,-0.25l-1.41,0.84l-1.79,0.56l-0.91,1.45l-0.13,1.05l-2.43,2.1l-0.79,-1.25l-0.53,-3.72l-2.67,-1.85l-1.78,-0.3l-0.11,-1.45l-0.41,-0.64l-1.27,-0.24l-0.8,-0.7l-2.86,-1.17l-3.5,0.48l-3.17,-0.24l-2.97,-2.36l-1.37,0.42l-1.57,-0.02l-2.75,0.97l-4.97,0.13l-0.98,0.33l-1.4,-0.23l-0.54,-0.88l-2.48,0.29l-0.6,0.45l-0.95,1.69l-2.73,1.18l-1.85,1.7l-1.62,0.62l-0.74,2.0l-1.61,1.17l-154.77,0.0l0.0,-62.66l-0.4,-0.4l-58.06,0.0l0.0,-191.41ZM559.65,63.8l0.05,1.09l-0.57,0.2l0.01,-0.18l0.51,-1.11ZM700.18,223.45l0.67,0.48l-0.0,0.57l-0.63,-0.41l-0.03,-0.64ZM755.57,296.91l-0.37,-0.5l-0.55,-0.35l0.56,0.16l0.36,0.69ZM788.46,359.89l1.27,-0.55l-0.98,4.19l-0.26,-1.61l-0.04,-2.03ZM781.77,321.14l2.99,-2.23l1.34,-2.08l-0.07,-2.0l-1.55,-2.18l1.67,-1.51l0.02,3.22l0.41,1.23l1.29,1.4l-4.11,9.29l-1.5,4.21l0.33,1.39l-0.38,1.01l-0.82,-1.08l-0.24,-2.1l-0.78,-0.86l0.02,-0.41l0.73,-0.63l0.29,-1.87l1.31,-2.17l-0.02,-2.0l-0.93,-0.62ZM742.33,285.72l0.86,-0.52l0.32,0.47l1.73,0.64l0.14,0.48l0.74,-0.0l0.17,1.9l1.12,1.46l-0.31,0.93l-0.72,0.06l-0.55,-0.61l-0.63,-1.37l-2.89,-3.44ZM732.17,261.03l0.29,-0.46l0.54,0.51l-0.55,0.6l-0.28,-0.65ZM720.62,258.85l-0.24,-0.5l0.17,-0.96l0.23,0.43l-0.16,1.03ZM702.51,219.82l0.32,-0.53l-0.23,-0.45l0.11,-0.53l0.12,0.92l0.73,0.76l-0.24,0.36l-0.42,-0.05l-0.39,-0.48ZM701.46,217.04l-0.24,0.01l0.4,-0.51l0.19,0.62l-0.34,-0.12ZM701.72,216.25l-0.01,-0.14l0.08,0.01l-0.07,0.13ZM660.38,196.89l0.54,-0.18l0.31,0.11l-0.67,0.35l-0.18,-0.28ZM656.34,188.52l0.06,0.08l0.17,0.31l-0.39,0.02l0.16,-0.4ZM646.85,179.28l1.88,0.64l0.49,-0.26l0.11,-0.68l0.57,0.03l-0.26,1.25l1.06,1.23l-0.21,0.4l0.41,0.37l-0.55,1.04l-1.08,-0.26l-0.42,-1.69l-0.56,-0.89l-1.45,-1.18ZM578.86,3.14l0.29,-0.11l1.87,0.0l-0.5,0.27l-1.67,-0.16ZM570.88,18.97l0.35,-0.79l0.42,-0.12l0.89,0.13l0.3,0.45l-0.7,0.91l-1.26,-0.58ZM572.37,27.04l-0.41,-0.02l0.05,-0.33l0.52,0.1l-0.16,0.25ZM569.35,27.94l1.25,-0.84l1.06,1.56l-1.13,0.35l-0.45,0.56l-0.68,-0.84l-0.05,-0.79ZM570.35,0.5l0.33,-0.08l0.61,0.18l-0.27,0.01l-0.66,-0.1ZM569.67,18.08l-0.7,-0.71l0.65,-0.99l0.5,0.5l-0.45,1.2ZM511.4,148.18l-0.13,-0.23l0.14,-0.2l0.02,0.32l-0.02,0.12ZM511.7,146.77l1.18,-2.21l1.45,-1.11l3.46,-0.55l1.78,-0.74l0.98,0.78l0.83,0.15l0.31,0.44l-0.1,0.3l-1.47,0.39l-0.98,-1.07l-1.61,0.69l-0.56,1.12l0.05,0.95l-0.35,0.84l-0.96,-0.37l-0.6,1.0l-1.11,0.57l-1.11,0.0l-1.19,-1.17ZM517.14,155.5l0.97,-1.28l0.57,0.47l0.28,0.9l-1.0,0.23l-0.82,-0.32Z",name:"Queensland"},"AU-SA":{path:"M380.31,464.82l-1.25,-0.05l-1.84,0.49l-1.41,-0.38l-2.22,-2.33l-5.83,-3.94l-4.85,-2.65l-7.11,-2.79l-1.01,-0.03l-2.79,1.72l-3.81,1.12l-4.7,-0.48l-7.61,-0.25l-1.58,0.44l-2.64,-0.1l-3.69,0.56l-4.19,0.14l-1.68,0.45l-4.9,0.28l-1.26,0.46l-2.2,0.19l-0.0,-119.69l233.02,0.0l0.01,169.76l-0.64,0.31l0.02,90.09l-4.93,0.32l-1.71,-0.7l-2.7,-2.15l-1.05,-0.39l-0.71,-0.76l-0.44,-1.46l-1.89,-3.41l-2.29,-1.9l0.21,-0.85l-0.42,-0.64l-1.75,-0.94l-0.76,0.18l-3.68,-4.8l-0.89,-1.72l0.66,-0.59l0.1,-0.87l-0.91,-1.48l-0.22,-1.21l-0.98,-0.8l1.95,-1.03l1.23,-1.43l0.44,-1.84l-0.13,-3.1l-3.88,-8.72l0.28,-0.32l-0.12,-0.98l-1.49,-3.79l-2.35,-2.85l-1.17,-0.6l-3.5,-3.16l1.29,0.11l0.84,-0.65l0.33,-2.23l-2.15,-1.7l0.39,-0.29l1.4,0.25l0.61,-0.48l-0.29,-2.8l-0.96,0.04l-1.0,-1.09l-1.83,-0.37l-0.26,0.77l-1.38,0.88l-1.47,-0.09l-1.39,0.71l-0.32,0.86l0.46,1.12l-1.37,-0.78l-1.63,0.09l-0.44,0.29l-0.04,0.53l0.52,0.53l-2.96,0.51l-1.16,1.19l-1.31,0.72l-1.75,0.25l-3.25,-0.23l-1.31,0.53l-1.46,-0.93l0.49,-1.27l2.3,-1.1l1.94,-2.35l1.72,-1.14l0.14,-1.76l0.54,-0.91l-0.25,-0.97l0.13,-1.49l0.93,-1.75l-0.53,-3.6l0.14,-1.73l0.74,0.53l0.37,-0.88l-0.32,-1.03l-1.81,-1.3l-0.19,-1.0l-1.34,-1.13l-0.7,-1.45l-0.75,-0.45l-1.25,-3.94l-0.56,-0.85l-0.77,-0.47l-0.02,-1.1l-1.64,-1.9l-0.58,0.08l-1.39,2.64l0.04,0.75l0.45,0.71l-2.04,2.35l-0.76,2.46l-0.11,1.68l0.38,0.54l-0.52,1.34l-0.17,1.82l-1.06,1.85l-0.81,2.63l-0.08,1.21l-0.44,0.54l0.05,1.5l-1.13,0.94l-2.12,-1.09l-2.74,-0.28l-1.83,1.18l-1.89,0.03l-1.38,1.53l-2.39,-0.33l-2.51,1.53l-0.49,-0.03l-0.54,-0.69l0.26,-0.62l1.49,-1.26l0.62,-1.24l-0.32,-1.58l0.63,-0.67l0.0,-0.76l0.77,-1.05l2.04,0.51l2.44,-0.46l2.33,1.05l0.8,-0.18l0.71,-0.73l0.73,-4.71l0.65,-2.04l-0.65,-3.53l-0.89,-0.71l0.64,-0.51l0.52,-2.7l-0.18,-1.62l-0.53,-1.09l0.89,0.04l0.88,-1.48l0.14,-0.89l-0.35,-0.89l1.68,-1.67l0.14,-0.72l-0.28,-0.55l1.93,-1.84l1.01,-1.77l0.62,-0.12l1.31,-1.75l0.61,0.32l0.7,-0.54l0.1,-2.16l-1.42,-2.81l0.09,-0.89l-1.09,-1.88l0.67,-1.26l1.72,-0.92l1.85,-0.23l0.26,-0.47l-0.06,-1.14l-0.66,-1.45l-0.97,-0.34l-1.05,-4.61l0.5,-0.36l0.06,-0.66l-1.63,-1.22l-0.01,-0.89l-0.82,-1.07l0.22,-0.8l-0.65,-0.34l-0.25,-0.68l-0.68,-0.01l-0.43,1.33l0.01,2.73l0.76,0.61l0.27,1.27l0.04,1.57l-0.36,0.78l-0.54,0.16l-0.19,0.42l0.4,1.25l-1.44,-0.79l-1.08,0.16l-0.86,0.78l-0.11,0.93l-1.44,1.53l-1.17,0.68l-0.47,1.94l-0.92,1.63l-0.35,2.56l-1.22,1.83l-1.53,3.3l-1.27,1.06l-2.43,0.48l-0.8,-0.91l-0.88,-0.05l-1.37,1.67l0.32,0.8l-1.6,0.26l-1.94,1.29l-1.99,0.8l-0.64,1.09l-1.24,1.0l-1.48,0.58l-1.28,1.06l-0.41,1.27l-2.31,3.93l-1.85,1.05l-0.45,0.64l-0.15,1.0l0.17,1.69l-0.66,-0.7l-2.8,1.28l-0.44,1.27l0.23,0.78l-0.97,0.33l-0.25,0.76l-0.13,1.13l0.48,0.77l-0.86,0.08l-0.82,1.28l0.33,0.47l1.03,0.13l0.92,-0.24l1.0,-0.85l0.66,0.27l0.3,-0.18l-0.9,1.44l0.63,2.58l-0.43,0.19l-0.43,-0.98l-1.18,-0.6l-0.81,-1.14l-0.89,-0.46l-1.24,0.14l-0.73,0.66l-0.45,1.27l-0.49,0.0l-0.39,-1.39l-2.92,-3.36l-2.28,-1.14l0.13,-0.5l0.95,0.38l1.76,-0.44l0.42,-0.51l-0.25,-0.54l-0.97,-0.22l-0.03,-0.97l-0.51,-0.26l-0.55,0.38l0.25,-1.63l-0.67,-1.49l-0.65,-4.13l-0.57,-1.0l-1.1,-0.48l0.55,-0.52l-0.22,-2.89l-1.49,-2.51l-0.98,-0.51l-1.45,-1.63l-4.05,-3.38l0.35,-1.81l-0.15,-1.51l-0.99,-2.9l-2.15,-2.07l0.61,-0.52l-0.53,-1.29l-2.3,-0.83l-0.8,0.22l-0.22,0.89l-2.04,-0.89l-1.12,0.44l-0.38,-0.37l-0.57,0.1l-0.19,0.79l-0.71,-0.62l-0.72,-2.26l-0.86,-0.55l0.34,-0.86l-0.5,-1.05l-0.64,-0.33l-0.6,0.22l-1.14,-0.3l1.02,-0.94l0.29,-0.69l-0.19,-0.94l-0.93,-1.42l1.71,0.14l-0.09,1.39l0.84,0.44l1.84,-2.96l-0.44,-2.26l-0.96,-1.58l-1.59,-1.45l-0.88,-0.21l-0.68,0.35l-1.13,-0.01l-0.68,0.81l-1.1,-0.09l-1.12,1.02l0.24,-1.93l1.39,-0.38l0.16,-0.95l-2.37,-3.1l-0.71,-0.15l-0.46,0.32l-0.15,-0.81l-1.22,-0.52l-0.45,-0.85l0.11,-0.69l-0.8,-0.57l-1.56,0.04l-0.43,1.43l-0.88,-0.48l-0.33,-0.72l-0.55,-0.01l-1.28,0.68l-0.01,0.72l0.43,0.35l-0.23,0.31l-1.84,-0.4l-0.86,0.5l-1.42,-0.66l-0.75,0.21l-1.82,-1.82l-0.59,-0.29l-0.86,0.13l-0.32,-0.61l-3.77,-2.67l-3.78,-0.36l-1.46,0.15l-1.23,0.6l-0.25,1.04ZM504.86,541.95l1.3,0.02l0.24,0.12l-0.69,0.28l-0.84,-0.41ZM436.63,521.5l-0.05,-0.04l0.05,0.02l-0.0,0.02ZM435.87,520.88l-1.19,-0.51l-1.67,0.53l1.01,-1.76l0.49,0.66l1.36,0.34l0.01,0.73ZM512.21,545.41l-2.84,-1.94l0.71,-0.35l0.13,-0.7l0.7,-0.62l1.51,0.91l-0.21,1.4l0.39,0.58l-0.4,0.71ZM460.59,550.41l0.99,-2.94l1.8,-0.25l2.17,-0.82l5.26,-0.81l3.96,-1.2l1.01,-0.73l2.1,0.61l2.71,-0.59l-0.43,0.92l0.24,0.41l0.77,0.17l-0.92,0.99l0.02,0.57l0.41,0.38l1.93,0.41l1.63,-0.32l0.08,1.1l0.78,0.42l1.33,-0.48l0.72,-1.37l0.8,0.04l1.69,0.62l0.27,0.92l0.81,0.36l0.07,0.35l-1.31,1.14l-1.96,-0.95l-2.3,-0.27l-3.83,1.04l-0.73,1.03l0.28,1.15l-0.22,0.42l-2.45,1.15l-1.69,-1.5l-2.93,-0.71l-0.98,0.36l-0.41,0.91l-0.35,0.11l-2.46,-0.42l-1.76,0.58l-1.24,-0.45l-2.58,0.71l-1.03,-1.77l-1.37,-0.48l-0.9,-0.79ZM453.1,531.12l0.17,0.13l0.06,0.2l-0.15,-0.03l-0.07,-0.31ZM420.61,502.43l0.0,-0.12l0.42,-0.11l0.02,0.1l-0.44,0.13ZM402.28,471.35l0.22,-0.29l0.53,-0.38l-0.14,0.45l-0.62,0.22Z",name:"South Australia"},"AU-NSW":{path:"M557.86,512.73l-0.52,-0.94l-1.11,-0.12l-1.24,-0.75l-1.2,0.19l-0.4,-0.61l-1.3,-0.83l-1.09,0.24l-1.12,-0.55l-1.7,-0.05l-0.6,-0.68l0.0,-107.6l154.95,-0.0l2.08,-1.48l0.6,-1.84l1.59,-0.61l1.73,-1.6l2.86,-1.28l1.3,-2.02l1.92,-0.3l0.44,0.8l1.96,0.38l0.9,-0.38l5.1,-0.15l2.75,-0.97l1.46,0.04l1.15,-0.41l2.87,2.32l3.41,0.27l3.31,-0.5l2.61,1.07l0.84,0.73l1.23,0.23l0.41,1.99l1.99,0.42l2.26,1.46l0.54,3.71l0.5,0.48l0.2,0.94l0.95,0.3l0.91,-0.34l2.07,-2.08l0.75,-2.27l1.73,-0.54l1.08,-0.71l0.72,1.22l1.49,0.52l0.7,-1.22l1.29,0.21l1.81,-0.63l1.17,-4.58l-1.29,-1.57l-0.78,-1.53l3.71,-2.04l1.32,-0.04l1.24,-1.06l1.86,-0.44l1.92,-2.14l0.6,1.12l0.68,0.39l0.64,-0.1l0.47,-0.61l2.52,1.24l1.11,-0.12l1.17,-0.63l4.72,0.65l0.72,-0.41l1.15,-1.59l3.1,-0.23l2.74,-1.92l0.89,0.41l0.41,2.56l-0.55,4.02l0.29,1.89l1.0,1.41l-0.54,2.05l0.1,2.12l-1.58,1.52l-1.34,1.99l-0.39,1.22l0.17,1.21l-0.4,0.23l-1.43,2.66l-0.2,1.06l0.54,1.42l-0.13,1.59l-0.72,2.19l-0.06,2.56l-0.65,1.64l0.11,1.18l-0.37,0.56l-0.25,1.79l-1.15,1.82l-0.23,3.15l-1.0,1.73l-0.12,1.44l-1.75,3.68l-1.09,5.18l0.37,2.45l0.65,1.1l0.94,0.3l-0.82,1.72l-0.12,0.99l0.38,0.68l-1.5,1.91l-0.43,1.64l0.28,1.74l-1.1,1.59l0.33,1.83l-1.7,1.84l-0.14,1.75l-0.96,1.15l0.17,0.68l-1.05,1.24l-0.17,1.17l-2.4,2.07l-1.31,2.22l0.07,0.69l-0.45,0.52l-0.38,1.47l0.16,0.56l0.9,0.71l-0.75,1.37l0.02,0.74l0.34,0.35l-0.38,2.25l-3.2,1.44l-1.15,0.97l-0.24,0.61l-0.94,0.44l-1.01,1.42l-0.49,-0.29l-1.74,0.74l-0.13,0.7l0.5,0.39l1.77,0.14l0.09,0.28l-0.54,-0.01l-0.65,0.56l-1.03,-0.17l-1.52,0.31l-2.16,0.96l-1.58,1.19l-0.07,0.7l-1.19,1.08l-0.11,0.87l-1.25,1.19l-0.86,2.77l-1.22,1.59l-0.74,-0.26l-1.29,0.99l-0.32,1.24l0.86,0.72l-0.77,0.99l-0.37,1.93l-2.57,0.64l-0.24,-0.61l-0.66,-0.15l-0.41,0.51l0.18,1.16l-0.29,0.53l0.45,0.4l0.97,-0.49l-0.05,1.07l0.53,0.15l-0.35,1.36l0.25,0.61l-0.22,1.3l-0.68,0.14l-0.48,0.89l0.26,0.65l0.58,0.16l-0.21,1.28l-0.22,0.51l-0.65,-0.68l-0.72,0.03l-0.48,0.84l-0.92,-0.03l-0.53,0.46l0.24,0.63l1.02,0.39l-0.54,0.72l0.58,0.46l-2.52,1.8l-1.22,1.42l-0.91,1.57l-0.47,2.78l0.23,0.7l-0.36,0.47l-0.99,-0.1l-0.77,0.84l0.16,0.79l1.35,0.65l-0.9,3.71l-1.1,0.65l-1.03,1.52l0.65,0.86l-0.23,0.48l0.69,0.49l-0.11,0.86l-1.59,0.59l-0.4,1.21l0.45,0.74l-1.07,0.53l-0.54,0.97l-1.19,0.68l-1.07,1.71l-0.33,0.88l0.1,1.12l-1.5,1.9l-0.08,1.78l-1.44,2.06l-0.73,1.74l-1.06,-0.26l-0.74,0.28l-0.16,0.66l0.45,0.46l0.37,1.51l-0.88,0.44l-0.81,0.92l0.21,1.5l-0.2,1.85l-0.76,-0.12l-0.53,0.82l-0.05,0.46l1.12,0.47l-0.4,1.3l0.46,1.87l-0.24,0.58l0.17,0.8l-1.36,1.82l0.04,1.35l-0.38,0.81l0.22,1.5l-1.33,2.56l-0.33,1.9l-0.87,1.21l0.0,1.02l-0.51,0.85l-0.06,0.82l0.52,0.46l-0.24,1.12l0.42,0.86l-0.91,0.55l-0.36,0.71l0.62,0.74l1.04,0.04l0.79,0.58l0.53,1.76l-1.09,0.25l-0.47,0.71l0.37,1.22l-0.25,1.81l0.43,1.48l-33.78,-15.7l-1.42,-0.16l1.4,-2.18l0.21,-1.49l-0.36,-0.81l-0.92,-0.49l-0.43,-2.4l-1.2,-1.07l0.27,-1.06l-0.91,-2.71l0.22,-1.45l-1.01,-1.21l0.07,-1.3l-1.41,-0.68l-0.52,-0.76l-3.84,-1.47l-3.19,1.22l-0.51,-0.77l-1.04,-0.3l-1.85,0.56l-0.76,1.01l-0.22,1.0l-1.15,-0.3l-1.68,0.33l-0.95,-0.54l-0.56,0.28l-0.96,1.48l-1.06,-0.63l-0.74,0.12l-0.41,0.47l-1.13,-0.61l-0.68,0.11l-0.59,-0.5l-0.77,-0.08l-0.46,-0.49l-1.24,-0.09l-1.22,-1.04l-1.64,-0.05l-0.75,-0.42l-1.73,0.25l-1.07,1.47l-1.96,-0.38l-1.2,0.34l-2.72,-0.73l-1.38,-0.04l-0.47,-0.81l-0.95,-0.34l-2.52,0.36l-4.11,-3.0l-1.7,-0.36l-2.41,0.98l-2.97,-0.49l-4.25,0.4l-0.9,0.76l-0.77,2.57l0.95,1.77l-1.58,-0.46l-1.53,1.21l-1.06,0.07l-1.18,-1.13l-1.41,-0.33l-2.11,-2.32l-0.86,-0.36l-1.88,-3.72l-0.73,-0.61l-0.86,-0.12l-1.81,-1.49l-1.61,-2.07l-1.88,-0.65l-0.44,-0.75l-4.01,-2.35l-2.47,-0.66l-1.1,-0.68l0.19,-1.21l-0.3,-1.09l-0.78,-0.61l-2.44,-0.79l-0.93,-1.61l-0.61,-3.03l0.56,-3.41l-0.79,-0.88l-0.82,0.01l-0.42,-0.73l-2.48,-1.22l-1.8,-0.16l-1.08,-0.51l-0.51,0.31l-0.8,-0.56l-0.88,0.34l-0.4,-1.07l-1.6,-0.93l-1.53,0.68l-0.66,1.97l0.09,0.68l-1.02,0.06l-0.3,0.31l0.03,0.67l-1.07,-0.19l-1.32,-2.66l-0.09,-0.89l-1.54,-1.45l-0.25,-2.2l0.63,-1.4l-0.2,-0.74l-0.56,-0.27l-0.73,0.13l-0.57,-0.44l-0.84,-0.93l-0.47,-1.75l-0.94,-0.17l-0.93,-0.72l-0.99,0.14l-0.99,-1.09l-4.12,0.31l-1.76,-0.59l-0.98,0.15l-1.62,0.92l-1.38,1.43ZM698.61,545.4l0.11,0.88l0.81,0.82l0.5,0.24l0.54,-0.21l0.32,1.9l0.61,1.06l2.14,0.98l0.62,-0.09l1.25,-1.96l0.01,-2.91l-0.35,-2.21l0.74,-0.52l0.48,-1.46l-0.1,-1.85l0.8,-1.1l0.81,0.15l0.53,-0.64l2.02,0.1l0.8,-0.66l0.06,-0.53l-3.06,-1.48l-0.23,-0.73l-0.8,-0.26l-0.24,-0.98l-1.22,-0.84l-0.93,0.15l-5.38,3.69l-0.56,0.73l-0.72,3.85l0.25,1.73l-0.18,1.6l0.36,0.56ZM738.23,530.9l0.5,0.13l-0.39,1.17l-0.18,-0.17l0.07,-1.13ZM665.31,555.27l0.38,1.39l0.8,0.71l-1.05,-0.75l-0.13,-1.35Z",name:"New South Wales"}},height:1008.5727398708073,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","brazil",{width:22e4,height:194010,paths:{ro:{name:"RO",path:"M39760.00 75303.00l129.00 -97.00 0.00 -129.00 -32.00 -32.00 32.00 -32.00 64.00 32.00 64.00 0.00 129.00 0.00 97.00 -64.00 64.00 -64.00 32.00 -97.00 289.00 -161.00 65.00 -64.00 96.00 32.00 32.00 -32.00 129.00 -32.00 64.00 -96.00 193.00 -33.00 0.00 -32.00 0.00 -64.00 32.00 -64.00 129.00 -97.00 129.00 -128.00 64.00 -129.00 161.00 -129.00 0.00 -225.00 -33.00 -96.00 -96.00 -65.00 0.00 -32.00 32.00 -32.00 161.00 64.00 32.00 0.00 64.00 -32.00 97.00 65.00 64.00 -65.00 32.00 32.00 0.00 65.00 32.00 0.00 97.00 0.00 32.00 -32.00 -32.00 -97.00 96.00 0.00 32.00 0.00 97.00 97.00 32.00 0.00 64.00 -33.00 65.00 0.00 161.00 65.00 64.00 -65.00 32.00 0.00 96.00 -64.00 33.00 0.00 32.00 0.00 96.00 32.00 193.00 0.00 64.00 -32.00 0.00 -32.00 33.00 0.00 160.00 0.00 65.00 32.00 96.00 0.00 0.00 64.00 64.00 33.00 33.00 32.00 96.00 64.00 32.00 97.00 32.00 64.00 97.00 32.00 64.00 0.00 97.00 96.00 32.00 0.00 32.00 33.00 0.00 96.00 32.00 0.00 64.00 -32.00 33.00 161.00 32.00 0.00 32.00 32.00 32.00 96.00 32.00 0.00 64.00 -64.00 33.00 -32.00 64.00 0.00 32.00 -64.00 32.00 0.00 64.00 32.00 33.00 0.00 128.00 -258.00 64.00 -32.00 33.00 -257.00 32.00 0.00 64.00 0.00 32.00 0.00 33.00 -64.00 32.00 -32.00 96.00 -33.00 97.00 -32.00 32.00 0.00 96.00 0.00 64.00 32.00 161.00 129.00 32.00 0.00 32.00 0.00 33.00 32.00 0.00 65.00 32.00 32.00 96.00 -32.00 32.00 -65.00 65.00 65.00 64.00 -33.00 32.00 33.00 0.00 -65.00 -64.00 -161.00 -32.00 -64.00 0.00 -32.00 32.00 -161.00 0.00 -128.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 129.00 64.00 96.00 64.00 32.00 0.00 32.00 -32.00 0.00 -32.00 129.00 0.00 32.00 -64.00 225.00 -129.00 65.00 -64.00 160.00 -64.00 33.00 0.00 160.00 96.00 0.00 32.00 0.00 32.00 0.00 33.00 0.00 64.00 97.00 161.00 -32.00 128.00 0.00 32.00 96.00 33.00 0.00 64.00 -64.00 96.00 0.00 65.00 32.00 0.00 32.00 0.00 96.00 32.00 65.00 64.00 128.00 -96.00 65.00 0.00 64.00 -33.00 -32.00 -64.00 32.00 -32.00 32.00 0.00 129.00 0.00 32.00 -32.00 0.00 -32.00 64.00 -65.00 -32.00 -96.00 32.00 0.00 32.00 -32.00 33.00 -32.00 64.00 0.00 -32.00 -65.00 64.00 -64.00 0.00 -64.00 64.00 -65.00 97.00 0.00 64.00 -64.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 33.00 -97.00 32.00 -64.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 -32.00 -64.00 0.00 -32.00 0.00 -129.00 -33.00 -32.00 0.00 -64.00 0.00 -32.00 33.00 -33.00 64.00 -225.00 0.00 -128.00 0.00 -32.00 64.00 32.00 32.00 -32.00 32.00 -65.00 97.00 -64.00 129.00 -97.00 128.00 -32.00 64.00 0.00 65.00 0.00 32.00 32.00 96.00 129.00 33.00 0.00 96.00 -32.00 129.00 -97.00 0.00 -32.00 64.00 0.00 32.00 32.00 64.00 97.00 65.00 -32.00 96.00 0.00 129.00 32.00 64.00 0.00 32.00 -32.00 65.00 -32.00 0.00 -65.00 32.00 0.00 64.00 -32.00 32.00 -32.00 64.00 0.00 193.00 32.00 129.00 -32.00 64.00 0.00 32.00 0.00 65.00 -32.00 128.00 -32.00 129.00 -65.00 257.00 -96.00 64.00 0.00 0.00 32.00 0.00 64.00 -64.00 161.00 0.00 32.00 64.00 32.00 65.00 0.00 161.00 -32.00 160.00 32.00 258.00 -160.00 128.00 0.00 32.00 -32.00 0.00 -65.00 -32.00 -225.00 0.00 -128.00 -32.00 -97.00 0.00 -32.00 0.00 -32.00 96.00 -97.00 33.00 -64.00 -65.00 -129.00 0.00 -160.00 65.00 -97.00 32.00 -32.00 64.00 32.00 64.00 0.00 97.00 -64.00 32.00 0.00 193.00 32.00 -32.00 -129.00 96.00 -128.00 -32.00 -32.00 32.00 -33.00 32.00 -64.00 0.00 -64.00 65.00 -32.00 32.00 -161.00 32.00 -32.00 32.00 0.00 32.00 32.00 0.00 32.00 65.00 64.00 32.00 0.00 96.00 -160.00 0.00 -65.00 -32.00 0.00 -64.00 -64.00 0.00 -96.00 -97.00 -97.00 -32.00 -96.00 0.00 -32.00 161.00 -129.00 0.00 -64.00 -64.00 -65.00 -129.00 -32.00 0.00 -64.00 161.00 -97.00 0.00 -289.00 64.00 -32.00 97.00 32.00 32.00 -32.00 64.00 -97.00 32.00 -64.00 65.00 0.00 32.00 0.00 96.00 32.00 97.00 32.00 160.00 129.00 32.00 0.00 33.00 -32.00 64.00 -97.00 0.00 -64.00 64.00 -96.00 129.00 -97.00 -129.00 -225.00 0.00 -32.00 97.00 -96.00 161.00 -97.00 96.00 -161.00 32.00 -32.00 32.00 -96.00 -32.00 -33.00 0.00 -64.00 97.00 -64.00 32.00 -97.00 64.00 -32.00 32.00 -64.00 -32.00 -64.00 32.00 -225.00 418.00 32.00 161.00 0.00 804.00 0.00 2186.00 0.00 64.00 64.00 33.00 0.00 32.00 32.00 32.00 0.00 64.00 97.00 32.00 64.00 129.00 0.00 193.00 96.00 96.00 97.00 65.00 64.00 96.00 64.00 0.00 33.00 64.00 64.00 -32.00 32.00 32.00 97.00 33.00 32.00 -33.00 64.00 -32.00 32.00 0.00 32.00 0.00 33.00 32.00 64.00 65.00 32.00 64.00 129.00 -32.00 32.00 32.00 32.00 193.00 96.00 32.00 65.00 32.00 32.00 32.00 -32.00 33.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 32.00 96.00 -32.00 65.00 32.00 0.00 0.00 64.00 32.00 64.00 -32.00 65.00 65.00 0.00 32.00 64.00 32.00 32.00 0.00 32.00 32.00 0.00 96.00 -96.00 65.00 -32.00 32.00 -65.00 32.00 0.00 32.00 -32.00 65.00 65.00 32.00 64.00 64.00 32.00 129.00 32.00 64.00 0.00 64.00 32.00 64.00 32.00 33.00 33.00 0.00 64.00 -33.00 64.00 -32.00 129.00 32.00 128.00 0.00 97.00 33.00 64.00 32.00 32.00 64.00 0.00 32.00 65.00 -32.00 96.00 64.00 64.00 -32.00 65.00 -64.00 96.00 0.00 32.00 32.00 32.00 225.00 161.00 32.00 0.00 33.00 -64.00 -97.00 -97.00 0.00 -64.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 128.00 32.00 65.00 64.00 128.00 0.00 64.00 0.00 33.00 97.00 32.00 64.00 0.00 64.00 -97.00 0.00 -32.00 32.00 97.00 65.00 64.00 96.00 -32.00 64.00 32.00 65.00 64.00 32.00 32.00 32.00 -32.00 64.00 0.00 33.00 129.00 321.00 129.00 32.00 128.00 -64.00 97.00 0.00 96.00 0.00 64.00 128.00 65.00 33.00 64.00 96.00 0.00 97.00 32.00 32.00 32.00 -32.00 193.00 64.00 65.00 -32.00 96.00 0.00 0.00 -65.00 96.00 0.00 97.00 -64.00 0.00 -96.00 0.00 -33.00 32.00 -32.00 -32.00 -64.00 32.00 -64.00 64.00 -65.00 0.00 -160.00 32.00 -65.00 33.00 0.00 96.00 65.00 96.00 0.00 65.00 32.00 64.00 -64.00 0.00 -33.00 64.00 -32.00 0.00 -32.00 33.00 -32.00 -33.00 -32.00 33.00 -65.00 64.00 0.00 64.00 -32.00 32.00 97.00 33.00 32.00 128.00 -32.00 97.00 32.00 32.00 32.00 64.00 32.00 32.00 32.00 -32.00 97.00 32.00 32.00 97.00 193.00 64.00 0.00 32.00 0.00 32.00 32.00 32.00 0.00 129.00 64.00 32.00 0.00 65.00 0.00 0.00 32.00 0.00 33.00 32.00 32.00 32.00 128.00 96.00 97.00 32.00 96.00 65.00 65.00 -97.00 128.00 -32.00 32.00 -128.00 258.00 -33.00 96.00 0.00 97.00 -64.00 64.00 0.00 64.00 -32.00 0.00 -32.00 97.00 0.00 64.00 0.00 64.00 0.00 65.00 64.00 96.00 32.00 32.00 32.00 97.00 33.00 32.00 0.00 64.00 0.00 32.00 -33.00 161.00 33.00 64.00 -33.00 33.00 -32.00 -33.00 -96.00 -32.00 -97.00 0.00 -64.00 32.00 -32.00 65.00 -161.00 0.00 0.00 32.00 0.00 64.00 32.00 32.00 64.00 -32.00 0.00 32.00 -32.00 97.00 32.00 64.00 -32.00 32.00 -32.00 64.00 0.00 33.00 0.00 96.00 64.00 -32.00 0.00 32.00 65.00 32.00 96.00 0.00 65.00 65.00 64.00 32.00 -64.00 32.00 64.00 96.00 -32.00 32.00 0.00 65.00 -32.00 0.00 -97.00 96.00 32.00 32.00 0.00 33.00 32.00 32.00 33.00 32.00 193.00 96.00 -129.00 32.00 0.00 33.00 96.00 96.00 65.00 -32.00 0.00 64.00 32.00 0.00 0.00 129.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 161.00 32.00 64.00 32.00 0.00 32.00 -32.00 0.00 32.00 33.00 0.00 -33.00 32.00 -64.00 129.00 -64.00 0.00 32.00 96.00 0.00 65.00 -96.00 32.00 -33.00 64.00 -64.00 0.00 -32.00 -32.00 -129.00 64.00 32.00 33.00 65.00 0.00 128.00 64.00 0.00 96.00 -96.00 129.00 64.00 32.00 65.00 32.00 0.00 32.00 -33.00 65.00 65.00 32.00 0.00 96.00 32.00 97.00 0.00 32.00 0.00 96.00 -64.00 65.00 0.00 128.00 -33.00 32.00 33.00 33.00 0.00 32.00 -33.00 0.00 -32.00 64.00 32.00 32.00 0.00 97.00 -64.00 32.00 0.00 32.00 -64.00 161.00 -97.00 64.00 0.00 32.00 -32.00 32.00 32.00 97.00 -32.00 0.00 0.00 64.00 -32.00 64.00 0.00 65.00 -32.00 160.00 0.00 33.00 96.00 0.00 0.00 32.00 97.00 32.00 0.00 32.00 0.00 64.00 32.00 33.00 -129.00 32.00 0.00 64.00 0.00 32.00 0.00 97.00 32.00 64.00 65.00 96.00 64.00 97.00 -64.00 32.00 32.00 64.00 32.00 0.00 32.00 65.00 65.00 0.00 32.00 0.00 32.00 96.00 32.00 0.00 0.00 129.00 32.00 64.00 32.00 0.00 32.00 32.00 65.00 32.00 -32.00 32.00 0.00 33.00 32.00 0.00 32.00 0.00 -32.00 160.00 -32.00 33.00 32.00 32.00 -65.00 128.00 0.00 193.00 65.00 64.00 0.00 65.00 -65.00 64.00 33.00 97.00 -33.00 32.00 33.00 64.00 -65.00 97.00 32.00 32.00 0.00 32.00 0.00 64.00 0.00 64.00 0.00 33.00 -32.00 0.00 -32.00 32.00 0.00 96.00 64.00 64.00 33.00 0.00 0.00 33.00 -65.00 32.00 0.00 32.00 32.00 64.00 0.00 65.00 33.00 32.00 -33.00 96.00 33.00 65.00 -65.00 0.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 64.00 0.00 96.00 -64.00 33.00 0.00 64.00 0.00 128.00 -33.00 0.00 33.00 33.00 0.00 64.00 32.00 0.00 0.00 64.00 -32.00 97.00 0.00 64.00 -33.00 32.00 0.00 97.00 -32.00 0.00 -64.00 0.00 0.00 32.00 579.00 32.00 2025.00 0.00 2573.00 0.00 32.00 0.00 0.00 96.00 32.00 33.00 32.00 0.00 -32.00 128.00 32.00 0.00 32.00 -32.00 64.00 32.00 33.00 32.00 -33.00 97.00 33.00 0.00 32.00 0.00 0.00 32.00 32.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 0.00 33.00 0.00 96.00 65.00 32.00 -32.00 -32.00 0.00 32.00 -97.00 -32.00 -32.00 64.00 32.00 97.00 -96.00 32.00 0.00 32.00 -33.00 32.00 33.00 32.00 0.00 33.00 0.00 0.00 32.00 0.00 64.00 0.00 32.00 32.00 32.00 32.00 0.00 96.00 0.00 32.00 0.00 65.00 33.00 64.00 32.00 32.00 0.00 65.00 32.00 32.00 -64.00 32.00 0.00 96.00 -33.00 33.00 33.00 32.00 32.00 64.00 -32.00 64.00 32.00 32.00 -32.00 33.00 32.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 -33.00 32.00 33.00 32.00 128.00 129.00 -32.00 32.00 -32.00 32.00 64.00 32.00 0.00 33.00 -64.00 0.00 32.00 64.00 0.00 64.00 0.00 0.00 -32.00 65.00 32.00 -33.00 97.00 -32.00 -33.00 32.00 65.00 -64.00 0.00 0.00 32.00 32.00 32.00 0.00 32.00 32.00 64.00 65.00 0.00 0.00 33.00 32.00 0.00 -32.00 32.00 -32.00 32.00 -33.00 0.00 0.00 64.00 0.00 97.00 65.00 96.00 0.00 64.00 32.00 65.00 0.00 64.00 64.00 64.00 97.00 32.00 32.00 97.00 0.00 64.00 -32.00 32.00 32.00 0.00 -32.00 33.00 32.00 96.00 0.00 64.00 0.00 32.00 -32.00 65.00 0.00 32.00 -33.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -96.00 0.00 -65.00 161.00 -64.00 32.00 -32.00 32.00 -32.00 33.00 -33.00 32.00 -32.00 -32.00 0.00 32.00 0.00 32.00 -64.00 64.00 -64.00 97.00 0.00 32.00 -97.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 32.00 32.00 -32.00 0.00 32.00 33.00 -64.00 0.00 32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 32.00 32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 0.00 0.00 64.00 0.00 33.00 0.00 96.00 -32.00 0.00 32.00 32.00 0.00 65.00 0.00 32.00 -32.00 32.00 64.00 32.00 -32.00 32.00 32.00 97.00 0.00 64.00 33.00 0.00 0.00 32.00 0.00 32.00 -33.00 0.00 0.00 32.00 33.00 0.00 0.00 33.00 -33.00 32.00 65.00 0.00 0.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 0.00 32.00 65.00 -65.00 32.00 33.00 -32.00 32.00 32.00 0.00 32.00 0.00 64.00 0.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 64.00 32.00 65.00 32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 64.00 96.00 32.00 0.00 32.00 33.00 -32.00 64.00 32.00 64.00 0.00 32.00 0.00 32.00 -32.00 0.00 97.00 65.00 -32.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 65.00 32.00 0.00 33.00 -32.00 64.00 -33.00 64.00 65.00 0.00 0.00 64.00 32.00 33.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 97.00 64.00 32.00 97.00 32.00 0.00 64.00 96.00 0.00 193.00 0.00 64.00 0.00 33.00 -32.00 32.00 0.00 64.00 32.00 96.00 0.00 33.00 32.00 64.00 0.00 32.00 0.00 32.00 32.00 0.00 547.00 450.00 -96.00 33.00 -65.00 64.00 0.00 32.00 -64.00 64.00 0.00 65.00 -32.00 0.00 -32.00 32.00 0.00 64.00 -65.00 64.00 32.00 161.00 -32.00 64.00 -32.00 33.00 -64.00 32.00 -64.00 -32.00 -33.00 -33.00 -64.00 33.00 0.00 -33.00 -32.00 33.00 -32.00 0.00 -64.00 0.00 0.00 32.00 -33.00 0.00 0.00 32.00 0.00 32.00 -96.00 32.00 -96.00 129.00 -129.00 32.00 -32.00 32.00 -65.00 64.00 -32.00 33.00 0.00 64.00 -32.00 96.00 -32.00 0.00 -64.00 32.00 -65.00 65.00 32.00 64.00 0.00 64.00 -64.00 97.00 0.00 129.00 -64.00 160.00 0.00 65.00 0.00 32.00 64.00 160.00 0.00 129.00 -32.00 161.00 32.00 225.00 -32.00 96.00 -96.00 97.00 -65.00 193.00 -64.00 0.00 -32.00 64.00 -32.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 -96.00 -32.00 -32.00 32.00 0.00 32.00 -33.00 32.00 -32.00 65.00 -32.00 32.00 0.00 96.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 0.00 65.00 -32.00 64.00 -32.00 0.00 -64.00 97.00 -64.00 0.00 0.00 64.00 -33.00 32.00 33.00 32.00 0.00 32.00 0.00 32.00 32.00 33.00 -32.00 64.00 64.00 32.00 -129.00 161.00 -32.00 0.00 -32.00 0.00 0.00 64.00 0.00 32.00 -64.00 97.00 0.00 64.00 -32.00 0.00 0.00 129.00 -33.00 0.00 -32.00 96.00 -64.00 0.00 0.00 32.00 0.00 65.00 -32.00 32.00 0.00 -32.00 0.00 32.00 0.00 32.00 -32.00 64.00 -33.00 0.00 33.00 65.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 -33.00 0.00 0.00 32.00 -32.00 0.00 0.00 97.00 65.00 64.00 -65.00 32.00 0.00 33.00 0.00 96.00 -32.00 64.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -97.00 97.00 0.00 32.00 -128.00 32.00 -33.00 -32.00 -64.00 32.00 -32.00 32.00 0.00 -32.00 -96.00 32.00 -129.00 97.00 0.00 96.00 -64.00 0.00 0.00 32.00 -33.00 0.00 -32.00 33.00 -96.00 64.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -64.00 -32.00 -96.00 32.00 0.00 32.00 -33.00 32.00 0.00 32.00 0.00 33.00 -32.00 -33.00 -32.00 65.00 -64.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -65.00 32.00 0.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 32.00 -32.00 0.00 0.00 33.00 -32.00 0.00 0.00 32.00 32.00 32.00 -32.00 32.00 -129.00 -64.00 -64.00 32.00 -64.00 -32.00 0.00 -97.00 -33.00 0.00 -64.00 -32.00 -96.00 -32.00 -33.00 -64.00 -64.00 -33.00 -64.00 0.00 -161.00 -64.00 -32.00 -64.00 -129.00 -97.00 -32.00 -64.00 -32.00 -64.00 32.00 -65.00 -32.00 -32.00 -32.00 0.00 -97.00 65.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -97.00 33.00 -32.00 -129.00 32.00 0.00 32.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 -64.00 32.00 -33.00 32.00 33.00 33.00 -33.00 -129.00 -64.00 -64.00 32.00 -65.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 97.00 32.00 -33.00 33.00 -64.00 32.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 0.00 65.00 -32.00 64.00 0.00 32.00 -32.00 32.00 -97.00 -64.00 -64.00 64.00 32.00 -96.00 -32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 -65.00 0.00 0.00 -32.00 -32.00 64.00 32.00 32.00 -64.00 64.00 -64.00 -64.00 -65.00 32.00 -32.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 -32.00 0.00 -65.00 0.00 -64.00 33.00 -32.00 -33.00 0.00 -64.00 -64.00 -32.00 -33.00 0.00 33.00 96.00 -65.00 33.00 -128.00 0.00 0.00 64.00 -65.00 0.00 -160.00 0.00 -97.00 32.00 32.00 64.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -193.00 65.00 -97.00 -65.00 -96.00 0.00 -64.00 -32.00 -65.00 -32.00 0.00 -32.00 -96.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 32.00 -97.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 -64.00 0.00 -65.00 65.00 -32.00 0.00 0.00 -65.00 -32.00 0.00 0.00 65.00 -32.00 0.00 -64.00 -32.00 0.00 64.00 -32.00 0.00 -97.00 -32.00 0.00 -32.00 -64.00 32.00 -64.00 -65.00 32.00 33.00 -65.00 32.00 -96.00 64.00 -32.00 -32.00 0.00 32.00 -65.00 0.00 -32.00 -32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 -32.00 0.00 0.00 -96.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 -96.00 -32.00 -32.00 -32.00 0.00 64.00 -32.00 0.00 0.00 -32.00 -65.00 32.00 -32.00 65.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 64.00 -64.00 -32.00 0.00 -96.00 -65.00 -65.00 0.00 -96.00 0.00 -97.00 -64.00 -128.00 0.00 -32.00 -64.00 32.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 -64.00 -65.00 -32.00 32.00 -32.00 -32.00 -65.00 0.00 33.00 -64.00 -33.00 -32.00 -32.00 0.00 32.00 -65.00 -32.00 -32.00 -96.00 -32.00 0.00 32.00 32.00 0.00 -32.00 32.00 -65.00 -96.00 0.00 -129.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 -64.00 -97.00 -65.00 0.00 0.00 -129.00 -64.00 33.00 -64.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 -65.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 -96.00 -32.00 -32.00 -32.00 -161.00 32.00 -64.00 -32.00 -33.00 -32.00 -32.00 -32.00 0.00 -32.00 65.00 -33.00 0.00 -32.00 -65.00 -32.00 -32.00 -32.00 -32.00 0.00 -97.00 -64.00 0.00 0.00 65.00 0.00 32.00 0.00 32.00 -33.00 64.00 -64.00 -32.00 0.00 -128.00 -64.00 -65.00 -32.00 0.00 -32.00 65.00 -33.00 -33.00 -32.00 0.00 -32.00 129.00 -64.00 0.00 0.00 32.00 -64.00 -32.00 32.00 64.00 -32.00 0.00 -65.00 -64.00 -32.00 32.00 -32.00 -64.00 -64.00 0.00 -33.00 64.00 -32.00 -64.00 -64.00 64.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -32.00 32.00 -64.00 -64.00 -32.00 32.00 -32.00 -32.00 0.00 -65.00 0.00 -32.00 -65.00 97.00 -32.00 -65.00 -64.00 -64.00 0.00 -96.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 -33.00 -32.00 33.00 -65.00 0.00 -32.00 -33.00 0.00 -32.00 65.00 -32.00 0.00 0.00 -97.00 -32.00 0.00 -32.00 32.00 32.00 65.00 -97.00 32.00 -96.00 -97.00 -64.00 32.00 -65.00 0.00 -64.00 -32.00 -257.00 -128.00 0.00 -65.00 64.00 -32.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 -33.00 -32.00 33.00 -64.00 0.00 -32.00 -33.00 0.00 -64.00 0.00 32.00 -97.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 0.00 32.00 -65.00 65.00 -96.00 0.00 0.00 64.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -32.00 64.00 0.00 32.00 0.00 32.00 -64.00 -64.00 0.00 -64.00 -32.00 0.00 -32.00 96.00 -97.00 -32.00 -64.00 -96.00 -64.00 -129.00 0.00 -32.00 0.00 -65.00 0.00 -32.00 -97.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 33.00 -64.00 -65.00 -64.00 -32.00 0.00 -64.00 -129.00 -64.00 -32.00 0.00 -96.00 -65.00 -33.00 -64.00 -64.00 -64.00 0.00 -33.00 32.00 0.00 32.00 -32.00 33.00 0.00 -65.00 -64.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 -129.00 -32.00 -32.00 -64.00 32.00 -97.00 -64.00 0.00 0.00 -96.00 -65.00 -32.00 -64.00 -193.00 -32.00 -65.00 -64.00 0.00 -65.00 -32.00 32.00 -96.00 65.00 -32.00 0.00 -32.00 -32.00 -33.00 -33.00 0.00 -96.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -64.00 0.00 -64.00 0.00 -33.00 0.00 0.00 -65.00 -64.00 33.00 0.00 -33.00 0.00 -32.00 -64.00 0.00 0.00 -96.00 -32.00 0.00 -33.00 32.00 33.00 64.00 -65.00 32.00 -64.00 -64.00 -32.00 -32.00 -32.00 32.00 32.00 64.00 0.00 33.00 -32.00 32.00 -97.00 0.00 -32.00 32.00 -96.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 0.00 33.00 -64.00 0.00 -33.00 -33.00 -32.00 0.00 -160.00 0.00 -161.00 -64.00 -97.00 -64.00 -96.00 32.00 -32.00 -32.00 -129.00 -97.00 -32.00 -128.00 -64.00 -33.00 -33.00 33.00 -32.00 -33.00 -32.00 -32.00 97.00 0.00 -65.00 -64.00 0.00 -96.00 -160.00 0.00 -161.00 0.00 -129.00 -97.00 -96.00 -193.00 -97.00 -32.00 -96.00 -32.00 -97.00 -32.00 -32.00 -65.00 -161.00 -64.00 -96.00 32.00 -64.00 -64.00 -226.00 -64.00 -128.00 0.00 -97.00 -65.00 -32.00 32.00 -64.00 65.00 -32.00 32.00 -32.00 -32.00 -65.00 96.00 -96.00 -32.00 -96.00 -64.00 -65.00 0.00 -32.00 32.00 0.00 64.00 -32.00 97.00 0.00 64.00 0.00 32.00 -32.00 32.00 -65.00 0.00 -96.00 65.00 -97.00 32.00 -32.00 -32.00 -128.00 -97.00 -32.00 0.00 0.00 32.00 -33.00 33.00 -64.00 -65.00 -64.00 65.00 -32.00 0.00 -32.00 -97.00 -65.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 -64.00 -33.00 0.00 -32.00 32.00 -64.00 64.00 -32.00 0.00 0.00 -96.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 128.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -64.00 0.00 -129.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 -64.00 -96.00 129.00 -97.00 32.00 -32.00 64.00 -32.00 32.00 -32.00 -32.00 -32.00 -32.00 32.00 -97.00 0.00 -64.00 -161.00 0.00 -96.00 0.00 -257.00 -32.00 -65.00 -64.00 -32.00 -33.00 -129.00 -128.00 -64.00 -97.00 -64.00 -32.00 -129.00 -64.00 -32.00 -96.00 0.00 -33.00 32.00 -64.00 32.00 -161.00 0.00 -161.00 -32.00 -160.00 -32.00 -32.00 -64.00 32.00 -129.00 64.00 -32.00 0.00 -64.00 -96.00 -32.00 -33.00 -65.00 0.00 -128.00 0.00 -258.00 -96.00 -128.00 -32.00 -65.00 -64.00 -32.00 -161.00 32.00 -97.00 65.00 -96.00 0.00 -32.00 -65.00 -65.00 -32.00 33.00 -96.00 32.00 32.00 96.00 0.00 97.00 -32.00 96.00 -64.00 0.00 -33.00 0.00 -32.00 -64.00 65.00 -161.00 -33.00 -32.00 -32.00 -32.00 -96.00 -65.00 -65.00 0.00 -32.00 65.00 -96.00 128.00 -32.00 0.00 -32.00 -64.00 0.00 -64.00 64.00 -97.00 64.00 -32.00 32.00 -64.00 -32.00 -65.00 -64.00 -128.00 -32.00 -32.00 -65.00 0.00 -32.00 0.00 -128.00 0.00 -161.00 96.00 -64.00 -64.00 -65.00 -97.00 -32.00 -32.00 -64.00 32.00 -32.00 97.00 -33.00 0.00 -32.00 0.00 -64.00 -129.00 -32.00 0.00 -97.00 32.00 -32.00 0.00 0.00 -64.00 32.00 -64.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 64.00 -97.00 65.00 -225.00 -32.00 -32.00 -65.00 -32.00 -128.00 0.00 -65.00 -97.00 0.00 -32.00 65.00 -161.00 0.00 -160.00 -97.00 -290.00 0.00 -64.00 -32.00 -64.00 -64.00 0.00 -129.00 64.00 -257.00 0.00 -32.00 32.00 64.00 64.00 0.00 33.00 0.00 32.00 -64.00 0.00 -193.00 -97.00 -129.00 -96.00 -32.00 -32.00 32.00 -32.00 129.00 -129.00 64.00 -129.00 0.00 -32.00 -64.00 -128.00 0.00 -33.00 32.00 -64.00 -64.00 -64.00 0.00 -65.00 96.00 -96.00 32.00 -96.00 -32.00 -33.00 -32.00 -32.00 -161.00 0.00 -193.00 -64.00 -32.00 0.00 -32.00 -64.00 -64.00 -354.00 0.00 -161.00 -65.00 -161.00 32.00 -64.00 161.00 -32.00 32.00 -32.00 -32.00 -65.00 -193.00 0.00 -32.00 -32.00 -64.00 -257.00 0.00 -161.00 32.00 -32.00 129.00 -32.00 32.00 -32.00 -32.00 -64.00 -33.00 0.00 -64.00 0.00 -32.00 0.00 -64.00 -193.00 0.00 -65.00 64.00 -64.00 96.00 -96.00 226.00 -65.00 32.00 -64.00 -32.00 -64.00 -65.00 -129.00 -32.00 -32.00 161.00 -129.00 96.00 -64.00 0.00 -32.00 -96.00 -97.00 -32.00 -96.00 -32.00 -97.00 0.00 -32.00 96.00 32.00 -64.00 -257.00 -193.00 -257.00 -97.00 -64.00 -64.00 0.00 -64.00 -32.00 0.00 -97.00 64.00 0.00 32.00 -96.00 -32.00 -97.00 32.00 -129.00 0.00 -96.00 -32.00 -96.00 -32.00 -97.00 -97.00 -32.00 -96.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -64.00 64.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 -128.00 -64.00 -97.00 32.00 -128.00 -65.00 -65.00 -32.00 -64.00 32.00 -96.00 97.00 0.00 64.00 -65.00 64.00 -96.00 0.00 -161.00 -64.00 -128.00 64.00 -97.00 65.00 -32.00 96.00 -129.00 97.00 -96.00 64.00 -193.00 32.00 -32.00 32.00 -65.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 -64.00 -129.00 0.00 -96.00 32.00 -129.00 -32.00 -193.00 -64.00 -64.00 -32.00 -129.00 -33.00 -64.00 65.00 -225.00 -32.00 -129.00 -33.00 -64.00 0.00 -96.00 0.00 -65.00 33.00 -128.00 160.00 -161.00 33.00 -129.00 -33.00 -64.00 -128.00 -96.00 -65.00 -161.00 -64.00 -129.00 -32.00 -128.00 -64.00 -65.00 -129.00 -128.00 -257.00 -97.00 0.00 32.00 32.00 32.00 0.00 33.00 -32.00 64.00 -129.00 64.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 32.00 65.00 -96.00 32.00 0.00 160.00 0.00 65.00 0.00 32.00 -65.00 32.00 -96.00 -64.00 -32.00 128.00 -65.00 0.00 -32.00 33.00 0.00 32.00 32.00 96.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -128.00 32.00 0.00 -96.00 -33.00 0.00 -64.00 32.00 -32.00 32.00 -32.00 -32.00 -32.00 -129.00 -32.00 0.00 -33.00 65.00 0.00 -32.00 -32.00 -33.00 65.00 -64.00 -33.00 0.00 -32.00 0.00 -64.00 -64.00 -97.00 96.00 0.00 65.00 -96.00 -33.00 64.00 -96.00 -64.00 -64.00 0.00 -33.00 32.00 0.00 64.00 0.00 32.00 0.00 33.00 -32.00 -33.00 0.00 0.00 -64.00 -64.00 32.00 -32.00 32.00 -64.00 0.00 -65.00 0.00 -32.00 32.00 0.00 65.00 -32.00 0.00 -64.00 -65.00 -64.00 -32.00 32.00 -64.00 0.00 -64.00 -65.00 32.00 0.00 32.00 33.00 96.00 -33.00 33.00 -32.00 64.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -64.00 64.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 64.00 -65.00 0.00 0.00 65.00 -32.00 32.00 0.00 32.00 -96.00 0.00 -65.00 0.00 32.00 -64.00 0.00 -32.00 33.00 -33.00 -33.00 -32.00 -32.00 -32.00 -64.00 0.00 -64.00 32.00 0.00 32.00 -65.00 0.00 0.00 -64.00 -32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -32.00 33.00 0.00 -33.00 -32.00 -32.00 -65.00 32.00 -64.00 33.00 -32.00 128.00 64.00 32.00 -32.00 0.00 -64.00 -32.00 0.00 65.00 -32.00 -33.00 -32.00 0.00 0.00 -64.00 -97.00 97.00 -32.00 0.00 -64.00 -129.00 -161.00 0.00 -65.00 32.00 33.00 32.00 -33.00 0.00 -32.00 65.00 -32.00 -33.00 0.00 -64.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -64.00 0.00 0.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -96.00 32.00 0.00 64.00 -97.00 0.00 0.00 33.00 32.00 64.00 -32.00 -32.00 -32.00 32.00 32.00 0.00 -64.00 32.00 -32.00 0.00 -33.00 -32.00 -96.00 -64.00 0.00 64.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 -33.00 0.00 -64.00 32.00 0.00 -64.00 -32.00 32.00 0.00 64.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -128.00 0.00 -33.00 32.00 0.00 32.00 0.00 65.00 -128.00 32.00 -97.00 -32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 0.00 33.00 64.00 0.00 -64.00 0.00 -32.00 -33.00 32.00 -96.00 -64.00 -32.00 -33.00 32.00 -64.00 0.00 32.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 0.00 0.00 64.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -97.00 -32.00 0.00 64.00 -64.00 -32.00 -32.00 0.00 32.00 32.00 -32.00 33.00 -33.00 -33.00 -32.00 33.00 0.00 32.00 -32.00 -32.00 -161.00 -33.00 -868.00 -385.00z"},ac:{name:"AC",path:"M6610.00 62120.00l290.00 160.00 1961.00 869.00 2186.00 996.00 836.00 418.00 161.00 65.00 2219.00 450.00 64.00 32.00 707.00 225.00 97.00 32.00 96.00 0.00 1962.00 482.00 289.00 65.00 1254.00 289.00 1447.00 354.00 1736.00 353.00 515.00 129.00 450.00 97.00 353.00 225.00 772.00 418.00 1769.00 964.00 964.00 547.00 547.00 289.00 1222.00 643.00 900.00 450.00 965.00 547.00 160.00 64.00 129.00 65.00 514.00 225.00 2058.00 900.00 1158.00 514.00 2893.00 1254.00 772.00 322.00 129.00 96.00 160.00 33.00 193.00 96.00 1222.00 515.00 868.00 385.00 -32.00 33.00 0.00 64.00 -32.00 0.00 32.00 64.00 -32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 65.00 -32.00 -32.00 -32.00 -33.00 0.00 33.00 0.00 -33.00 -65.00 33.00 32.00 32.00 -32.00 64.00 -32.00 -32.00 0.00 64.00 -96.00 0.00 -97.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 33.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 64.00 -32.00 -32.00 -64.00 32.00 0.00 33.00 -65.00 32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -32.00 64.00 -64.00 0.00 0.00 33.00 0.00 64.00 -65.00 32.00 0.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 32.00 64.00 0.00 32.00 -32.00 -32.00 -33.00 64.00 0.00 -32.00 0.00 65.00 -32.00 -33.00 -32.00 33.00 0.00 32.00 0.00 32.00 -64.00 0.00 0.00 32.00 0.00 -32.00 -32.00 32.00 32.00 32.00 0.00 32.00 -65.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 33.00 -32.00 128.00 -32.00 32.00 0.00 -64.00 -32.00 64.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -64.00 65.00 0.00 -32.00 0.00 64.00 -32.00 32.00 64.00 0.00 -32.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -129.00 65.00 -32.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -64.00 32.00 -64.00 0.00 -32.00 32.00 0.00 64.00 32.00 32.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -64.00 33.00 -32.00 32.00 -64.00 0.00 -65.00 -65.00 -96.00 0.00 -32.00 -32.00 -65.00 0.00 -32.00 32.00 -96.00 33.00 -32.00 -33.00 -65.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -64.00 -32.00 -32.00 32.00 -33.00 33.00 65.00 64.00 -32.00 64.00 32.00 65.00 0.00 32.00 -32.00 0.00 -33.00 32.00 -64.00 -32.00 -64.00 0.00 0.00 64.00 -64.00 -64.00 -65.00 32.00 -64.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 96.00 33.00 64.00 0.00 129.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 0.00 64.00 -32.00 33.00 -129.00 32.00 -32.00 32.00 -64.00 32.00 -65.00 -32.00 -64.00 32.00 0.00 64.00 -96.00 0.00 -32.00 0.00 -65.00 32.00 -96.00 33.00 -32.00 32.00 -97.00 160.00 -32.00 97.00 -96.00 96.00 -33.00 65.00 -96.00 96.00 -97.00 -64.00 -128.00 546.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -65.00 -64.00 0.00 0.00 -32.00 -33.00 32.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 -64.00 0.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 -65.00 0.00 -32.00 64.00 -32.00 -32.00 -32.00 32.00 -64.00 0.00 0.00 -32.00 0.00 32.00 -65.00 -32.00 -96.00 64.00 -65.00 -32.00 -64.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 0.00 0.00 64.00 -32.00 0.00 -64.00 0.00 -64.00 33.00 0.00 64.00 -32.00 -32.00 -33.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 65.00 0.00 32.00 0.00 64.00 32.00 0.00 32.00 32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 -32.00 32.00 -64.00 32.00 -33.00 65.00 -64.00 32.00 0.00 32.00 -64.00 32.00 -65.00 96.00 -32.00 0.00 -32.00 97.00 -64.00 0.00 -32.00 96.00 -32.00 0.00 32.00 32.00 -32.00 97.00 -65.00 32.00 -32.00 64.00 0.00 33.00 0.00 64.00 -32.00 64.00 -64.00 32.00 -33.00 33.00 -64.00 32.00 -32.00 64.00 -32.00 0.00 -32.00 0.00 -97.00 0.00 -32.00 32.00 -32.00 64.00 -32.00 33.00 -65.00 -65.00 -32.00 0.00 -160.00 65.00 -33.00 64.00 33.00 32.00 -33.00 32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 -64.00 -64.00 64.00 -193.00 32.00 -96.00 65.00 0.00 64.00 -65.00 64.00 -96.00 65.00 0.00 32.00 -322.00 64.00 -514.00 129.00 32.00 -97.00 -64.00 -64.00 32.00 -64.00 -64.00 -33.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -32.00 32.00 -64.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -65.00 -32.00 0.00 -32.00 33.00 -32.00 -33.00 32.00 0.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 65.00 0.00 -65.00 -65.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 32.00 -64.00 0.00 32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 33.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 -64.00 32.00 0.00 65.00 -32.00 0.00 -33.00 -33.00 -32.00 0.00 -32.00 33.00 32.00 0.00 0.00 -33.00 32.00 65.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 0.00 -64.00 65.00 -65.00 -32.00 -64.00 -65.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 -64.00 0.00 -33.00 0.00 -64.00 32.00 -32.00 0.00 32.00 64.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 -64.00 32.00 -32.00 -97.00 -32.00 65.00 -32.00 -32.00 -65.00 32.00 -64.00 -32.00 -32.00 64.00 -32.00 -64.00 -64.00 0.00 0.00 -33.00 -33.00 33.00 -32.00 0.00 32.00 -33.00 -32.00 0.00 0.00 -32.00 -64.00 32.00 -64.00 -32.00 -33.00 -32.00 -64.00 0.00 -64.00 32.00 -32.00 -32.00 -65.00 -64.00 -32.00 64.00 -64.00 -32.00 32.00 0.00 0.00 -32.00 -96.00 32.00 -33.00 32.00 33.00 0.00 -33.00 32.00 -32.00 -64.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -97.00 -32.00 0.00 -32.00 -32.00 64.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 32.00 -64.00 -64.00 0.00 0.00 32.00 -65.00 -32.00 -32.00 64.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -33.00 -64.00 -32.00 32.00 -32.00 -65.00 -32.00 0.00 -32.00 65.00 -97.00 0.00 0.00 64.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 -65.00 0.00 0.00 -64.00 -32.00 32.00 -64.00 -32.00 -96.00 0.00 0.00 64.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 -161.00 -32.00 0.00 32.00 0.00 32.00 -64.00 -32.00 -64.00 0.00 0.00 64.00 -32.00 -32.00 -65.00 32.00 -128.00 -32.00 -32.00 64.00 -33.00 -32.00 -64.00 32.00 -32.00 33.00 -32.00 -33.00 -64.00 65.00 -33.00 -65.00 -64.00 65.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 -64.00 -32.00 -64.00 -33.00 0.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 -33.00 -65.00 0.00 0.00 33.00 -96.00 0.00 -32.00 0.00 -65.00 -33.00 -32.00 33.00 -32.00 -33.00 -32.00 33.00 -32.00 -33.00 -97.00 -32.00 -64.00 32.00 -32.00 33.00 -32.00 -33.00 -32.00 0.00 -97.00 0.00 0.00 65.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -33.00 -32.00 -32.00 64.00 -32.00 -32.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 -32.00 33.00 -65.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 64.00 -32.00 0.00 32.00 -32.00 -64.00 32.00 0.00 64.00 0.00 -32.00 -33.00 0.00 0.00 32.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 -64.00 32.00 0.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 0.00 32.00 -32.00 32.00 -65.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 -32.00 -97.00 32.00 -32.00 0.00 -32.00 65.00 -32.00 -33.00 -32.00 0.00 -33.00 33.00 -96.00 32.00 -64.00 -32.00 -65.00 32.00 -32.00 -32.00 -32.00 -33.00 -96.00 33.00 -33.00 -33.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 0.00 32.00 -32.00 -64.00 -129.00 -97.00 -64.00 -32.00 -96.00 -64.00 -33.00 -32.00 0.00 -32.00 -64.00 -65.00 0.00 0.00 -32.00 -64.00 -32.00 -418.00 289.00 -32.00 -1383.00 0.00 -1221.00 0.00 -483.00 0.00 -1414.00 32.00 -547.00 0.00 -675.00 0.00 -32.00 32.00 -97.00 65.00 0.00 32.00 32.00 32.00 -96.00 32.00 -32.00 96.00 32.00 65.00 -32.00 32.00 -65.00 0.00 -96.00 32.00 0.00 0.00 -64.00 32.00 -32.00 -32.00 -33.00 32.00 -32.00 -32.00 0.00 -64.00 -161.00 -32.00 0.00 0.00 -64.00 -65.00 0.00 -64.00 -64.00 32.00 -32.00 -64.00 -32.00 -64.00 -161.00 32.00 -32.00 32.00 -65.00 -32.00 0.00 32.00 -32.00 0.00 -64.00 -64.00 -32.00 0.00 -32.00 64.00 -33.00 -32.00 97.00 32.00 0.00 32.00 -32.00 64.00 64.00 32.00 0.00 33.00 -32.00 -33.00 -64.00 -64.00 0.00 0.00 -33.00 32.00 -32.00 -32.00 -64.00 32.00 0.00 32.00 32.00 65.00 0.00 32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -97.00 64.00 33.00 0.00 -65.00 32.00 0.00 65.00 -64.00 32.00 64.00 0.00 -32.00 -65.00 -96.00 -32.00 -65.00 32.00 -32.00 33.00 32.00 32.00 0.00 -32.00 -96.00 32.00 0.00 32.00 0.00 32.00 -97.00 -32.00 33.00 -32.00 -33.00 -65.00 33.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -64.00 32.00 0.00 -32.00 -32.00 -33.00 -32.00 65.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -64.00 32.00 -32.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 0.00 0.00 65.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 -65.00 -32.00 33.00 32.00 -65.00 0.00 0.00 32.00 0.00 33.00 0.00 -33.00 -32.00 33.00 32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -65.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 0.00 32.00 0.00 0.00 32.00 -32.00 32.00 -65.00 -64.00 -32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 65.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -97.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 33.00 -64.00 0.00 -33.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 64.00 -64.00 32.00 0.00 -32.00 -97.00 64.00 -64.00 64.00 0.00 33.00 -32.00 0.00 -32.00 128.00 -32.00 0.00 -32.00 65.00 -33.00 0.00 -32.00 64.00 -128.00 0.00 0.00 32.00 0.00 -32.00 -33.00 64.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 -64.00 161.00 -32.00 -32.00 0.00 96.00 0.00 33.00 0.00 32.00 -129.00 0.00 -64.00 -32.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 0.00 -64.00 64.00 -97.00 64.00 -161.00 65.00 -96.00 64.00 -32.00 32.00 -33.00 32.00 -32.00 129.00 -32.00 32.00 -32.00 64.00 -64.00 65.00 0.00 96.00 -97.00 0.00 -96.00 -32.00 -32.00 0.00 0.00 64.00 -65.00 0.00 -192.00 65.00 -33.00 0.00 -96.00 -97.00 -65.00 32.00 0.00 65.00 -32.00 0.00 -32.00 -33.00 -64.00 97.00 -1318.00 0.00 -2573.00 0.00 0.00 -64.00 97.00 -33.00 32.00 -64.00 0.00 -64.00 0.00 -64.00 -64.00 -33.00 -32.00 -32.00 32.00 -64.00 64.00 -32.00 32.00 -97.00 64.00 -32.00 -32.00 -32.00 -64.00 -64.00 0.00 -129.00 -32.00 -32.00 0.00 -32.00 96.00 -97.00 65.00 -32.00 -129.00 -64.00 -129.00 -64.00 -64.00 0.00 -64.00 -33.00 -32.00 -32.00 -33.00 32.00 -64.00 -64.00 -64.00 0.00 0.00 -32.00 32.00 -96.00 0.00 -65.00 32.00 -96.00 0.00 -97.00 32.00 -64.00 -64.00 -96.00 32.00 -129.00 -32.00 0.00 -32.00 0.00 -97.00 -64.00 33.00 -290.00 -65.00 -32.00 -96.00 32.00 -65.00 -32.00 -64.00 32.00 -32.00 0.00 -64.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -65.00 -33.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -97.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -128.00 32.00 -33.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 -65.00 -33.00 33.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 -32.00 -64.00 0.00 -33.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 0.00 32.00 -64.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -322.00 0.00 -1864.00 0.00 64.00 -64.00 32.00 -129.00 0.00 -32.00 64.00 -32.00 97.00 -32.00 32.00 -65.00 64.00 -32.00 32.00 -96.00 129.00 -32.00 0.00 -32.00 -32.00 -65.00 -32.00 -32.00 96.00 -32.00 97.00 -161.00 96.00 -64.00 32.00 64.00 32.00 0.00 97.00 -64.00 0.00 -32.00 64.00 -32.00 32.00 -33.00 32.00 -32.00 0.00 -32.00 -96.00 -32.00 -32.00 -32.00 96.00 -65.00 129.00 -64.00 64.00 -64.00 64.00 -161.00 0.00 -128.00 33.00 -65.00 -33.00 -64.00 0.00 -129.00 -32.00 -64.00 0.00 -32.00 32.00 -32.00 33.00 -65.00 -129.00 -32.00 -96.00 -289.00 -97.00 -32.00 -64.00 0.00 0.00 -129.00 -32.00 97.00 -32.00 32.00 -65.00 -65.00 -32.00 -128.00 0.00 -65.00 -32.00 -32.00 0.00 -96.00 -64.00 0.00 -65.00 -97.00 0.00 -128.00 -96.00 -97.00 -32.00 -193.00 -33.00 -96.00 -64.00 -32.00 -64.00 -97.00 -64.00 0.00 -97.00 -32.00 -64.00 32.00 -64.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -64.00 -65.00 0.00 -96.00 -32.00 -32.00 -33.00 32.00 0.00 -64.00 -32.00 -32.00 -64.00 32.00 -32.00 -129.00 32.00 -32.00 32.00 -129.00 -64.00 -257.00 -65.00 -161.00 -96.00 0.00 -32.00 -32.00 -65.00 0.00 -96.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 32.00 -65.00 -96.00 -32.00 -129.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -65.00 0.00 -64.00 -64.00 -129.00 -33.00 -32.00 0.00 0.00 -64.00 -64.00 0.00 -64.00 -32.00 -97.00 -129.00 32.00 -160.00 -64.00 -65.00 32.00 -128.00 -64.00 -97.00 -32.00 -32.00 0.00 -32.00 -65.00 -32.00 -32.00 -97.00 -64.00 -32.00 32.00 -96.00 0.00 -65.00 -32.00 -128.00 32.00 -97.00 -32.00 -128.00 -64.00 -65.00 -65.00 -96.00 -64.00 -32.00 32.00 -97.00 0.00 -96.00 -96.00 -97.00 -97.00 33.00 -64.00 0.00 -32.00 -161.00 -65.00 -65.00 -96.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 -33.00 -33.00 -32.00 0.00 -96.00 -32.00 -64.00 -96.00 -97.00 32.00 -32.00 64.00 0.00 -64.00 -129.00 32.00 -64.00 32.00 0.00 65.00 96.00 128.00 0.00 32.00 0.00 65.00 -96.00 32.00 -64.00 0.00 -97.00 32.00 -161.00 -32.00 -96.00 -65.00 -32.00 -160.00 -97.00 -32.00 -32.00 -225.00 -64.00 -129.00 0.00 -32.00 -32.00 -65.00 -97.00 -32.00 -96.00 -96.00 0.00 -97.00 -97.00 -32.00 -128.00 -96.00 -32.00 -97.00 -97.00 -193.00 -193.00 -64.00 0.00 -32.00 -161.00 32.00 0.00 64.00 0.00 97.00 -32.00 96.00 -160.00 0.00 -65.00 65.00 -64.00 -65.00 -64.00 0.00 -161.00 -64.00 -64.00 -96.00 -225.00 0.00 -65.00 32.00 -32.00 32.00 32.00 32.00 65.00 32.00 -33.00 32.00 0.00 97.00 97.00 193.00 32.00 32.00 -64.00 32.00 -97.00 129.00 -64.00 64.00 0.00 96.00 32.00 129.00 -64.00 32.00 0.00 0.00 32.00 0.00 64.00 32.00 0.00 161.00 -96.00 96.00 -129.00 0.00 -32.00 -64.00 -129.00 0.00 -160.00 -64.00 -65.00 -97.00 -64.00 -32.00 -32.00 -32.00 -161.00 -64.00 -64.00 -32.00 -65.00 -65.00 -64.00 0.00 -32.00 -32.00 -64.00z"},am:{name:"AM",path:"M6610.00 62120.00l32.00 -33.00 97.00 -96.00 161.00 -193.00 64.00 -128.00 0.00 -65.00 -64.00 -32.00 0.00 -96.00 0.00 -65.00 -65.00 -128.00 0.00 -33.00 65.00 -128.00 96.00 -97.00 32.00 -96.00 0.00 -32.00 32.00 -97.00 32.00 0.00 33.00 -32.00 64.00 -96.00 64.00 -32.00 97.00 -161.00 32.00 -65.00 129.00 -96.00 32.00 -32.00 96.00 -64.00 32.00 0.00 97.00 0.00 32.00 -97.00 161.00 -128.00 96.00 -33.00 64.00 0.00 33.00 -32.00 96.00 0.00 97.00 -64.00 32.00 0.00 64.00 -32.00 64.00 0.00 97.00 -32.00 0.00 -97.00 32.00 -32.00 64.00 -32.00 32.00 -64.00 65.00 0.00 32.00 32.00 32.00 -32.00 64.00 0.00 65.00 0.00 96.00 -33.00 161.00 0.00 64.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 32.00 33.00 32.00 64.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 0.00 32.00 -32.00 0.00 -64.00 64.00 -32.00 33.00 32.00 32.00 0.00 64.00 -96.00 32.00 -33.00 -32.00 -32.00 32.00 -32.00 32.00 -96.00 32.00 -32.00 0.00 -33.00 33.00 -32.00 -33.00 -96.00 33.00 -32.00 32.00 0.00 0.00 -65.00 -32.00 -64.00 -65.00 -32.00 -32.00 -129.00 -32.00 -32.00 -32.00 -161.00 -32.00 32.00 0.00 -64.00 -32.00 -64.00 0.00 -64.00 0.00 -33.00 0.00 -32.00 -97.00 -96.00 -32.00 0.00 -32.00 -97.00 -64.00 -32.00 -33.00 -32.00 0.00 -64.00 0.00 -33.00 0.00 -128.00 -160.00 -161.00 0.00 -64.00 0.00 -129.00 96.00 -96.00 -32.00 -32.00 32.00 -33.00 -32.00 -192.00 32.00 0.00 64.00 -65.00 0.00 -32.00 33.00 -32.00 32.00 0.00 64.00 -32.00 0.00 -65.00 32.00 -128.00 0.00 -32.00 0.00 -65.00 0.00 -32.00 32.00 -64.00 32.00 32.00 0.00 -64.00 0.00 -32.00 0.00 -65.00 65.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 0.00 97.00 -33.00 0.00 -128.00 32.00 -32.00 64.00 0.00 0.00 -33.00 97.00 -32.00 64.00 -96.00 32.00 0.00 0.00 -97.00 32.00 0.00 32.00 -96.00 33.00 0.00 64.00 -32.00 0.00 -65.00 96.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 0.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 32.00 32.00 32.00 -32.00 -32.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 32.00 -97.00 64.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 -33.00 0.00 -96.00 -32.00 -64.00 0.00 -129.00 0.00 -32.00 32.00 -129.00 32.00 -64.00 -32.00 -32.00 65.00 -32.00 32.00 -97.00 32.00 -32.00 0.00 -32.00 32.00 -64.00 0.00 -65.00 64.00 -32.00 0.00 -32.00 33.00 -96.00 0.00 -65.00 64.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 -32.00 -65.00 32.00 -64.00 0.00 -32.00 0.00 -97.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -64.00 -96.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 32.00 -32.00 32.00 -32.00 32.00 0.00 33.00 -64.00 64.00 0.00 0.00 32.00 96.00 -32.00 32.00 -32.00 33.00 -129.00 64.00 32.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 33.00 32.00 32.00 -32.00 32.00 -65.00 64.00 33.00 0.00 -33.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 65.00 0.00 0.00 -32.00 64.00 0.00 0.00 -32.00 96.00 64.00 65.00 -32.00 32.00 0.00 64.00 32.00 32.00 -64.00 32.00 0.00 0.00 32.00 65.00 -32.00 96.00 -65.00 0.00 -96.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 64.00 -32.00 33.00 -32.00 64.00 0.00 32.00 -32.00 97.00 -96.00 32.00 0.00 64.00 0.00 32.00 -97.00 64.00 0.00 0.00 64.00 33.00 0.00 32.00 -64.00 32.00 32.00 0.00 32.00 32.00 0.00 0.00 -32.00 0.00 -64.00 97.00 -32.00 0.00 -65.00 -33.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 64.00 32.00 -32.00 32.00 64.00 32.00 0.00 0.00 -64.00 64.00 0.00 0.00 -64.00 -32.00 -32.00 32.00 0.00 33.00 32.00 64.00 -64.00 64.00 0.00 0.00 -97.00 0.00 -32.00 0.00 -64.00 32.00 -33.00 33.00 -96.00 96.00 0.00 64.00 -64.00 65.00 0.00 0.00 -32.00 -33.00 -33.00 33.00 0.00 64.00 0.00 32.00 -32.00 129.00 32.00 -32.00 33.00 0.00 64.00 64.00 -32.00 64.00 -129.00 32.00 64.00 65.00 -32.00 96.00 -32.00 0.00 -64.00 32.00 -32.00 65.00 64.00 32.00 -32.00 -32.00 -32.00 128.00 -65.00 32.00 0.00 0.00 -32.00 65.00 -32.00 32.00 -32.00 64.00 32.00 129.00 -96.00 32.00 -65.00 64.00 -32.00 -32.00 -32.00 96.00 -97.00 97.00 -32.00 32.00 -64.00 0.00 -64.00 97.00 32.00 32.00 32.00 32.00 32.00 0.00 -64.00 0.00 -32.00 96.00 0.00 32.00 -65.00 33.00 -32.00 32.00 32.00 96.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 33.00 0.00 0.00 -32.00 -33.00 -64.00 97.00 -32.00 0.00 64.00 32.00 -32.00 0.00 -64.00 32.00 32.00 32.00 -32.00 0.00 -33.00 33.00 -32.00 64.00 32.00 64.00 -64.00 65.00 -32.00 128.00 -32.00 64.00 -32.00 65.00 0.00 32.00 -33.00 32.00 65.00 0.00 32.00 64.00 0.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 33.00 -32.00 32.00 64.00 0.00 65.00 64.00 0.00 64.00 64.00 33.00 0.00 64.00 -32.00 96.00 32.00 65.00 -64.00 32.00 64.00 128.00 -96.00 -32.00 -33.00 32.00 -32.00 33.00 -32.00 0.00 32.00 0.00 32.00 -33.00 97.00 -64.00 32.00 0.00 32.00 64.00 32.00 33.00 33.00 64.00 0.00 96.00 -65.00 65.00 -64.00 64.00 -129.00 64.00 32.00 0.00 -64.00 32.00 -32.00 65.00 32.00 96.00 64.00 32.00 0.00 0.00 -32.00 -64.00 -64.00 0.00 -96.00 64.00 32.00 33.00 32.00 32.00 -32.00 0.00 -32.00 32.00 -33.00 64.00 0.00 64.00 65.00 33.00 0.00 32.00 32.00 0.00 32.00 64.00 0.00 96.00 -129.00 65.00 -64.00 64.00 64.00 64.00 -32.00 32.00 -32.00 33.00 32.00 0.00 65.00 32.00 0.00 96.00 0.00 33.00 32.00 0.00 32.00 32.00 -32.00 0.00 -65.00 -65.00 -32.00 -32.00 -64.00 65.00 0.00 64.00 96.00 64.00 33.00 64.00 -65.00 33.00 -32.00 -33.00 -128.00 -32.00 -65.00 32.00 0.00 97.00 32.00 64.00 -32.00 32.00 0.00 0.00 97.00 32.00 0.00 33.00 -129.00 32.00 0.00 32.00 32.00 -32.00 65.00 32.00 128.00 64.00 -64.00 0.00 -64.00 32.00 -33.00 32.00 0.00 33.00 0.00 32.00 0.00 0.00 65.00 64.00 -32.00 -32.00 -65.00 96.00 0.00 97.00 129.00 32.00 -64.00 0.00 -65.00 32.00 -32.00 65.00 -32.00 32.00 32.00 -32.00 64.00 32.00 33.00 96.00 -65.00 0.00 -64.00 64.00 0.00 -32.00 96.00 65.00 33.00 32.00 0.00 32.00 -65.00 64.00 0.00 32.00 0.00 65.00 0.00 32.00 -64.00 -32.00 -64.00 -33.00 -33.00 0.00 -32.00 65.00 32.00 32.00 33.00 32.00 64.00 97.00 32.00 32.00 32.00 32.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -33.00 33.00 -96.00 64.00 -32.00 96.00 -32.00 -32.00 -97.00 32.00 -32.00 129.00 -64.00 -64.00 -97.00 -33.00 -64.00 65.00 0.00 64.00 32.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 32.00 -96.00 33.00 -32.00 32.00 -65.00 96.00 33.00 65.00 -97.00 32.00 -32.00 32.00 0.00 64.00 0.00 97.00 96.00 96.00 33.00 32.00 0.00 32.00 64.00 65.00 0.00 32.00 -64.00 0.00 -97.00 0.00 -128.00 32.00 32.00 32.00 32.00 32.00 64.00 0.00 -193.00 97.00 0.00 32.00 0.00 0.00 65.00 -64.00 128.00 0.00 64.00 32.00 33.00 32.00 32.00 64.00 -32.00 97.00 -33.00 64.00 -32.00 64.00 -32.00 32.00 -32.00 65.00 -64.00 -32.00 -65.00 160.00 33.00 33.00 96.00 -65.00 129.00 32.00 32.00 65.00 0.00 32.00 -129.00 32.00 -32.00 96.00 64.00 33.00 0.00 0.00 -64.00 96.00 0.00 32.00 -32.00 -64.00 -64.00 64.00 -33.00 65.00 33.00 128.00 0.00 32.00 -33.00 65.00 33.00 64.00 128.00 32.00 64.00 64.00 33.00 33.00 -65.00 32.00 -32.00 -32.00 -64.00 32.00 -32.00 64.00 64.00 64.00 32.00 32.00 32.00 0.00 129.00 33.00 161.00 -33.00 32.00 -96.00 32.00 0.00 64.00 129.00 97.00 -65.00 64.00 65.00 0.00 160.00 -64.00 0.00 32.00 -32.00 32.00 -64.00 32.00 32.00 65.00 64.00 32.00 97.00 0.00 32.00 32.00 32.00 -32.00 32.00 32.00 32.00 161.00 33.00 32.00 32.00 0.00 64.00 -32.00 0.00 -65.00 32.00 -32.00 97.00 -32.00 0.00 -32.00 -97.00 -64.00 65.00 -129.00 32.00 -32.00 64.00 32.00 32.00 32.00 64.00 -32.00 33.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 97.00 32.00 32.00 64.00 0.00 65.00 0.00 -65.00 64.00 32.00 97.00 33.00 0.00 96.00 32.00 32.00 32.00 0.00 64.00 32.00 0.00 129.00 -64.00 128.00 -64.00 97.00 -129.00 32.00 -161.00 0.00 -192.00 64.00 -65.00 33.00 0.00 225.00 -1318.00 225.00 -1254.00 707.00 -3987.00 354.00 -2090.00 450.00 -2669.00 321.00 -1800.00 -32.00 -161.00 32.00 -64.00 65.00 -65.00 0.00 -64.00 0.00 -193.00 32.00 -96.00 0.00 -65.00 64.00 -32.00 97.00 -32.00 0.00 -64.00 -65.00 -129.00 0.00 -193.00 0.00 -32.00 -64.00 -129.00 -32.00 -128.00 32.00 -97.00 64.00 -128.00 0.00 -129.00 65.00 -64.00 0.00 -64.00 0.00 -97.00 -129.00 -161.00 -32.00 -32.00 32.00 -129.00 -32.00 -32.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -64.00 64.00 0.00 -32.00 -65.00 -64.00 -32.00 -65.00 32.00 -64.00 -96.00 0.00 -64.00 -96.00 -97.00 -65.00 -32.00 -32.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -161.00 0.00 -65.00 -64.00 -64.00 -33.00 0.00 -128.00 -96.00 64.00 -97.00 0.00 -64.00 -64.00 -32.00 -32.00 0.00 -33.00 -64.00 -128.00 -97.00 32.00 -32.00 -64.00 -32.00 32.00 -32.00 -65.00 0.00 33.00 -65.00 0.00 -32.00 32.00 -32.00 64.00 0.00 -32.00 -64.00 32.00 -33.00 64.00 -96.00 33.00 -96.00 32.00 -65.00 32.00 -64.00 -32.00 0.00 0.00 -64.00 -32.00 -32.00 -33.00 0.00 -32.00 -65.00 -64.00 -32.00 32.00 -64.00 32.00 -97.00 -64.00 -96.00 -32.00 -32.00 32.00 -129.00 -64.00 -64.00 -65.00 0.00 -32.00 0.00 0.00 -97.00 -128.00 -32.00 -97.00 -32.00 0.00 -32.00 -128.00 -32.00 -65.00 -32.00 -32.00 -33.00 -32.00 -64.00 -32.00 0.00 -65.00 -96.00 -64.00 -33.00 -64.00 0.00 0.00 -64.00 -97.00 -32.00 -64.00 0.00 -96.00 -193.00 -65.00 32.00 -128.00 -32.00 -32.00 32.00 -129.00 -96.00 -64.00 -65.00 -33.00 -64.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 -97.00 -129.00 -32.00 -32.00 -32.00 -64.00 -257.00 -225.00 -32.00 -33.00 0.00 -128.00 32.00 -65.00 32.00 -96.00 -32.00 -547.00 0.00 -385.00 32.00 -901.00 0.00 -1125.00 0.00 -386.00 32.00 0.00 32.00 0.00 33.00 64.00 32.00 33.00 64.00 0.00 32.00 -33.00 32.00 -64.00 -64.00 -64.00 129.00 0.00 32.00 64.00 128.00 32.00 65.00 -64.00 64.00 -96.00 32.00 32.00 65.00 -32.00 32.00 64.00 128.00 -32.00 65.00 -32.00 32.00 0.00 32.00 -33.00 64.00 33.00 32.00 0.00 0.00 64.00 97.00 -64.00 32.00 -65.00 96.00 -32.00 65.00 -97.00 64.00 65.00 64.00 -32.00 33.00 -129.00 64.00 -32.00 64.00 0.00 0.00 -64.00 32.00 -33.00 129.00 33.00 32.00 32.00 64.00 96.00 32.00 0.00 33.00 32.00 64.00 0.00 0.00 -32.00 64.00 0.00 0.00 -96.00 129.00 -65.00 0.00 -64.00 129.00 0.00 32.00 0.00 0.00 -64.00 32.00 -64.00 32.00 0.00 32.00 0.00 32.00 -65.00 32.00 -32.00 97.00 -32.00 32.00 0.00 32.00 32.00 32.00 64.00 65.00 0.00 32.00 33.00 0.00 64.00 32.00 32.00 96.00 64.00 0.00 65.00 193.00 192.00 65.00 65.00 32.00 -32.00 32.00 -33.00 0.00 -64.00 96.00 32.00 65.00 -32.00 32.00 -64.00 64.00 32.00 -32.00 32.00 32.00 97.00 -32.00 64.00 96.00 0.00 33.00 0.00 64.00 0.00 64.00 -32.00 0.00 32.00 129.00 -32.00 64.00 32.00 0.00 -64.00 0.00 -65.00 32.00 -32.00 0.00 -64.00 65.00 -32.00 32.00 32.00 64.00 0.00 64.00 32.00 65.00 0.00 32.00 32.00 32.00 0.00 32.00 -64.00 -161.00 -257.00 -96.00 -65.00 -64.00 -32.00 -33.00 -32.00 0.00 -96.00 65.00 -65.00 64.00 0.00 32.00 0.00 32.00 -96.00 -32.00 -129.00 -32.00 -32.00 -32.00 -64.00 0.00 -97.00 64.00 -32.00 65.00 0.00 0.00 -32.00 32.00 -64.00 -65.00 -65.00 -32.00 0.00 -96.00 -64.00 -65.00 0.00 0.00 -64.00 0.00 -32.00 -32.00 -65.00 32.00 -32.00 97.00 -32.00 -32.00 -64.00 -161.00 -65.00 -64.00 -64.00 96.00 -64.00 -32.00 -65.00 -32.00 -32.00 -257.00 -225.00 -33.00 0.00 -64.00 32.00 -32.00 -64.00 -64.00 0.00 0.00 -32.00 -65.00 -64.00 -128.00 0.00 -64.00 32.00 -65.00 -32.00 -32.00 32.00 -161.00 161.00 -96.00 -33.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 -65.00 32.00 -160.00 -32.00 -129.00 32.00 -225.00 0.00 -97.00 -32.00 -96.00 -97.00 -64.00 0.00 -33.00 65.00 -96.00 0.00 -96.00 32.00 -65.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 -64.00 0.00 -97.00 0.00 -64.00 -97.00 32.00 -32.00 0.00 -96.00 0.00 -129.00 97.00 -64.00 32.00 -33.00 96.00 -32.00 32.00 -96.00 -32.00 -64.00 -64.00 0.00 -1029.00 0.00 -1351.00 0.00 -707.00 96.00 0.00 -32.00 32.00 32.00 32.00 129.00 -32.00 64.00 32.00 0.00 -32.00 32.00 -64.00 32.00 0.00 129.00 -96.00 64.00 0.00 65.00 0.00 32.00 -33.00 32.00 33.00 96.00 0.00 0.00 32.00 65.00 0.00 64.00 0.00 32.00 -32.00 64.00 32.00 32.00 -65.00 33.00 0.00 96.00 -64.00 161.00 -64.00 64.00 -65.00 290.00 129.00 32.00 -32.00 0.00 32.00 32.00 32.00 32.00 -64.00 32.00 32.00 32.00 32.00 32.00 -32.00 129.00 32.00 161.00 97.00 0.00 64.00 32.00 -32.00 965.00 0.00 2282.00 0.00 2541.00 0.00 32.00 0.00 0.00 -64.00 -32.00 -33.00 -97.00 0.00 64.00 -96.00 -96.00 -64.00 -64.00 0.00 -32.00 32.00 -65.00 32.00 -64.00 0.00 -32.00 -129.00 32.00 -161.00 -32.00 0.00 -97.00 0.00 0.00 -64.00 0.00 -96.00 65.00 -65.00 32.00 -257.00 32.00 -32.00 64.00 -64.00 65.00 -65.00 64.00 0.00 64.00 -96.00 64.00 -32.00 65.00 64.00 64.00 -32.00 32.00 0.00 65.00 64.00 32.00 129.00 64.00 32.00 32.00 129.00 32.00 32.00 32.00 0.00 65.00 32.00 96.00 -32.00 97.00 96.00 96.00 97.00 161.00 160.00 161.00 0.00 32.00 -32.00 32.00 -64.00 64.00 -32.00 32.00 -64.00 -32.00 -129.00 129.00 -32.00 128.00 -97.00 97.00 -128.00 32.00 -32.00 64.00 -65.00 161.00 -321.00 65.00 -32.00 96.00 0.00 225.00 96.00 225.00 0.00 161.00 0.00 64.00 -64.00 97.00 -257.00 128.00 -97.00 32.00 -161.00 65.00 -96.00 64.00 -65.00 354.00 -160.00 64.00 -129.00 32.00 -64.00 97.00 0.00 96.00 0.00 97.00 64.00 128.00 129.00 32.00 514.00 32.00 97.00 0.00 257.00 129.00 482.00 64.00 193.00 32.00 64.00 161.00 97.00 65.00 -32.00 257.00 32.00 96.00 32.00 97.00 129.00 64.00 128.00 32.00 129.00 97.00 193.00 -33.00 128.00 33.00 129.00 32.00 96.00 32.00 97.00 32.00 675.00 0.00 129.00 32.00 161.00 -64.00 192.00 -32.00 386.00 0.00 450.00 32.00 129.00 -32.00 193.00 1093.00 -322.00 1222.00 1126.00 1350.00 1190.00 483.00 -129.00 128.00 32.00 32.00 32.00 65.00 65.00 32.00 64.00 32.00 0.00 161.00 -32.00 32.00 -65.00 32.00 0.00 64.00 33.00 65.00 -65.00 0.00 -32.00 32.00 -96.00 0.00 -33.00 64.00 0.00 97.00 -32.00 96.00 32.00 64.00 0.00 65.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 0.00 -64.00 65.00 -64.00 0.00 -97.00 64.00 -32.00 0.00 -96.00 32.00 -33.00 96.00 0.00 33.00 33.00 32.00 -65.00 64.00 -32.00 32.00 -96.00 -32.00 -65.00 97.00 33.00 128.00 -65.00 97.00 -64.00 32.00 32.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 33.00 32.00 32.00 -32.00 32.00 -65.00 32.00 0.00 64.00 -96.00 65.00 0.00 64.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 32.00 32.00 33.00 32.00 32.00 -64.00 96.00 -65.00 129.00 129.00 -32.00 -96.00 64.00 0.00 32.00 -33.00 0.00 33.00 97.00 32.00 32.00 -32.00 32.00 96.00 32.00 -32.00 64.00 0.00 -32.00 32.00 32.00 64.00 65.00 0.00 32.00 65.00 32.00 32.00 -32.00 32.00 64.00 64.00 0.00 33.00 64.00 64.00 -32.00 96.00 0.00 32.00 97.00 0.00 0.00 33.00 -65.00 64.00 33.00 128.00 -33.00 0.00 -32.00 33.00 -32.00 -33.00 -32.00 33.00 32.00 64.00 -32.00 96.00 -64.00 0.00 0.00 33.00 -32.00 96.00 -33.00 0.00 -96.00 64.00 0.00 97.00 -64.00 96.00 32.00 32.00 32.00 33.00 64.00 160.00 32.00 32.00 0.00 65.00 33.00 0.00 32.00 32.00 64.00 -97.00 129.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 97.00 0.00 64.00 -32.00 0.00 -32.00 64.00 -64.00 33.00 -97.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 64.00 32.00 32.00 -32.00 -32.00 -65.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 -64.00 -129.00 64.00 -32.00 32.00 -97.00 32.00 -32.00 32.00 0.00 33.00 -64.00 96.00 -64.00 -32.00 -32.00 64.00 -65.00 64.00 -193.00 33.00 33.00 96.00 -65.00 129.00 0.00 32.00 0.00 32.00 32.00 -32.00 33.00 32.00 32.00 32.00 -32.00 65.00 32.00 96.00 -32.00 64.00 0.00 32.00 64.00 -32.00 32.00 65.00 0.00 64.00 -64.00 64.00 -129.00 32.00 -161.00 32.00 -32.00 33.00 -96.00 -97.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -129.00 0.00 -128.00 33.00 -97.00 -33.00 -96.00 65.00 0.00 96.00 -32.00 0.00 -65.00 97.00 -64.00 64.00 64.00 32.00 0.00 32.00 -32.00 65.00 65.00 -32.00 96.00 32.00 32.00 64.00 -32.00 129.00 32.00 0.00 -64.00 64.00 -32.00 64.00 -97.00 97.00 -96.00 64.00 -97.00 -32.00 -32.00 -32.00 -96.00 64.00 -65.00 32.00 0.00 32.00 33.00 0.00 32.00 32.00 32.00 65.00 -32.00 32.00 -65.00 64.00 -64.00 -32.00 -32.00 64.00 0.00 32.00 0.00 0.00 96.00 65.00 0.00 32.00 0.00 0.00 -64.00 64.00 -96.00 -32.00 -32.00 193.00 -129.00 64.00 -97.00 32.00 33.00 65.00 128.00 -32.00 32.00 0.00 33.00 64.00 64.00 96.00 128.00 33.00 33.00 32.00 0.00 128.00 -65.00 0.00 -64.00 32.00 0.00 33.00 -96.00 0.00 -33.00 0.00 -32.00 32.00 -32.00 64.00 32.00 32.00 0.00 65.00 -32.00 32.00 0.00 64.00 -64.00 64.00 -97.00 32.00 0.00 65.00 -64.00 96.00 0.00 65.00 -96.00 -33.00 0.00 33.00 -65.00 -33.00 -32.00 65.00 -32.00 96.00 -161.00 97.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 32.00 96.00 -32.00 65.00 -65.00 64.00 -64.00 96.00 -64.00 32.00 32.00 33.00 0.00 96.00 -65.00 0.00 -32.00 64.00 -64.00 0.00 -32.00 65.00 -64.00 64.00 32.00 32.00 0.00 97.00 0.00 32.00 96.00 -65.00 97.00 -96.00 96.00 32.00 32.00 -32.00 32.00 -64.00 129.00 0.00 32.00 -32.00 97.00 32.00 32.00 64.00 0.00 96.00 0.00 33.00 32.00 32.00 64.00 32.00 32.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -64.00 0.00 -64.00 32.00 -32.00 32.00 -33.00 0.00 -32.00 33.00 -32.00 32.00 -32.00 96.00 -64.00 0.00 -33.00 65.00 0.00 32.00 -64.00 64.00 -32.00 32.00 -32.00 65.00 32.00 32.00 0.00 96.00 -96.00 32.00 -65.00 65.00 -96.00 0.00 -65.00 32.00 0.00 64.00 0.00 64.00 -32.00 32.00 0.00 65.00 0.00 64.00 -32.00 0.00 -96.00 64.00 -65.00 33.00 -96.00 64.00 -64.00 32.00 -129.00 0.00 -32.00 32.00 -97.00 -32.00 0.00 -32.00 -96.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 0.00 0.00 -32.00 64.00 -161.00 0.00 -64.00 32.00 -32.00 -32.00 -64.00 32.00 0.00 0.00 -97.00 -64.00 0.00 0.00 -32.00 32.00 -161.00 0.00 -64.00 0.00 -96.00 0.00 -65.00 65.00 -32.00 32.00 -32.00 96.00 -32.00 0.00 -65.00 32.00 0.00 65.00 -64.00 32.00 -32.00 32.00 0.00 64.00 -64.00 32.00 32.00 32.00 -32.00 33.00 32.00 64.00 0.00 64.00 32.00 97.00 -64.00 32.00 0.00 32.00 32.00 32.00 32.00 161.00 0.00 32.00 96.00 64.00 -32.00 33.00 -96.00 128.00 0.00 64.00 32.00 33.00 -32.00 32.00 -65.00 32.00 0.00 64.00 33.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 0.00 -32.00 128.00 -97.00 33.00 33.00 32.00 32.00 -32.00 64.00 96.00 0.00 32.00 32.00 32.00 -32.00 0.00 -64.00 -32.00 -129.00 32.00 -32.00 32.00 0.00 33.00 0.00 32.00 0.00 64.00 -96.00 32.00 0.00 0.00 -33.00 0.00 -64.00 64.00 0.00 65.00 -64.00 32.00 0.00 96.00 -32.00 32.00 -33.00 97.00 0.00 129.00 65.00 0.00 32.00 96.00 0.00 64.00 -64.00 33.00 -65.00 32.00 0.00 96.00 65.00 32.00 0.00 32.00 -33.00 33.00 0.00 96.00 -64.00 32.00 0.00 0.00 -64.00 0.00 -32.00 32.00 -97.00 -32.00 0.00 0.00 -64.00 129.00 -64.00 32.00 64.00 257.00 161.00 129.00 64.00 96.00 -32.00 322.00 -97.00 128.00 0.00 33.00 32.00 96.00 0.00 0.00 65.00 0.00 96.00 32.00 97.00 65.00 128.00 64.00 65.00 96.00 96.00 65.00 97.00 225.00 128.00 193.00 -32.00 160.00 -64.00 129.00 32.00 386.00 64.00 64.00 0.00 64.00 97.00 0.00 32.00 322.00 96.00 96.00 65.00 33.00 0.00 64.00 64.00 32.00 161.00 -32.00 160.00 -129.00 290.00 32.00 514.00 -32.00 65.00 -128.00 96.00 -33.00 32.00 -32.00 64.00 -128.00 129.00 -32.00 129.00 0.00 64.00 0.00 32.00 128.00 64.00 97.00 129.00 32.00 64.00 64.00 33.00 32.00 128.00 65.00 64.00 96.00 65.00 96.00 96.00 129.00 65.00 32.00 0.00 32.00 32.00 65.00 160.00 0.00 33.00 -32.00 64.00 32.00 96.00 64.00 33.00 96.00 482.00 161.00 386.00 32.00 257.00 97.00 193.00 32.00 0.00 161.00 0.00 32.00 0.00 32.00 0.00 0.00 32.00 -32.00 96.00 0.00 65.00 32.00 32.00 -32.00 64.00 32.00 64.00 64.00 97.00 65.00 96.00 0.00 65.00 -32.00 128.00 -97.00 97.00 -64.00 225.00 32.00 128.00 64.00 65.00 32.00 32.00 0.00 193.00 -32.00 32.00 -161.00 129.00 -128.00 193.00 -32.00 96.00 -32.00 64.00 96.00 451.00 -32.00 192.00 -32.00 193.00 64.00 97.00 0.00 225.00 64.00 0.00 97.00 -65.00 96.00 129.00 32.00 32.00 33.00 129.00 32.00 64.00 -32.00 32.00 0.00 33.00 -33.00 64.00 -32.00 96.00 32.00 97.00 -32.00 193.00 65.00 160.00 0.00 161.00 64.00 65.00 64.00 128.00 0.00 129.00 0.00 128.00 0.00 129.00 64.00 96.00 97.00 65.00 96.00 32.00 32.00 64.00 97.00 32.00 96.00 290.00 0.00 32.00 0.00 32.00 0.00 96.00 -32.00 0.00 0.00 33.00 32.00 32.00 33.00 64.00 0.00 64.00 96.00 129.00 32.00 64.00 32.00 65.00 65.00 64.00 64.00 0.00 64.00 32.00 0.00 32.00 -32.00 65.00 32.00 96.00 -64.00 32.00 0.00 97.00 32.00 64.00 64.00 0.00 -32.00 64.00 -64.00 32.00 0.00 33.00 64.00 96.00 -32.00 32.00 32.00 32.00 32.00 32.00 33.00 0.00 32.00 -32.00 160.00 97.00 -32.00 32.00 0.00 129.00 -32.00 32.00 -32.00 32.00 32.00 96.00 -64.00 32.00 0.00 33.00 -32.00 0.00 -32.00 96.00 -65.00 32.00 -32.00 32.00 -128.00 65.00 0.00 64.00 32.00 0.00 -32.00 64.00 -33.00 -32.00 -32.00 32.00 0.00 65.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 32.00 97.00 -32.00 32.00 0.00 32.00 -32.00 32.00 32.00 64.00 0.00 65.00 32.00 32.00 64.00 64.00 0.00 64.00 -64.00 0.00 0.00 33.00 32.00 32.00 32.00 64.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 65.00 -64.00 32.00 -32.00 -32.00 0.00 32.00 -97.00 0.00 0.00 32.00 0.00 64.00 32.00 0.00 33.00 32.00 -33.00 33.00 -96.00 -33.00 -32.00 33.00 0.00 32.00 -64.00 32.00 -33.00 -64.00 -32.00 -33.00 -32.00 -32.00 0.00 -32.00 -128.00 0.00 -65.00 -32.00 0.00 32.00 -96.00 -64.00 -32.00 32.00 0.00 96.00 -65.00 33.00 0.00 96.00 32.00 0.00 33.00 97.00 -65.00 32.00 0.00 32.00 32.00 96.00 97.00 65.00 64.00 -32.00 32.00 64.00 33.00 0.00 32.00 32.00 0.00 -32.00 64.00 0.00 32.00 32.00 129.00 32.00 32.00 64.00 64.00 33.00 0.00 32.00 32.00 32.00 0.00 32.00 -32.00 32.00 64.00 32.00 0.00 32.00 33.00 0.00 96.00 129.00 32.00 64.00 65.00 0.00 32.00 65.00 64.00 64.00 0.00 32.00 64.00 -32.00 65.00 64.00 64.00 97.00 129.00 0.00 64.00 32.00 64.00 0.00 0.00 96.00 129.00 33.00 32.00 32.00 64.00 64.00 32.00 0.00 33.00 32.00 64.00 0.00 64.00 129.00 -32.00 64.00 32.00 32.00 32.00 32.00 33.00 33.00 64.00 32.00 64.00 0.00 64.00 0.00 97.00 96.00 96.00 97.00 32.00 64.00 97.00 225.00 0.00 96.00 129.00 129.00 32.00 96.00 32.00 161.00 129.00 161.00 64.00 97.00 32.00 128.00 32.00 97.00 129.00 32.00 128.00 0.00 65.00 0.00 64.00 -32.00 64.00 -65.00 64.00 -32.00 97.00 32.00 129.00 32.00 96.00 97.00 289.00 96.00 97.00 32.00 161.00 65.00 160.00 128.00 65.00 97.00 64.00 161.00 257.00 225.00 32.00 32.00 33.00 0.00 0.00 -129.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 -33.00 -65.00 -160.00 -64.00 -97.00 -193.00 0.00 -96.00 0.00 -33.00 -64.00 -32.00 -129.00 0.00 -32.00 -96.00 -129.00 -32.00 -32.00 0.00 0.00 -32.00 97.00 -129.00 32.00 -32.00 32.00 -64.00 0.00 -65.00 -129.00 -128.00 -96.00 -33.00 32.00 -64.00 64.00 -64.00 33.00 -161.00 32.00 -96.00 32.00 -129.00 32.00 -32.00 32.00 -32.00 -32.00 -97.00 32.00 -64.00 32.00 -64.00 33.00 -32.00 -33.00 -65.00 -32.00 -32.00 0.00 -32.00 65.00 -32.00 -65.00 -65.00 0.00 -32.00 32.00 -32.00 97.00 0.00 32.00 -64.00 0.00 -129.00 -32.00 -64.00 -64.00 -64.00 0.00 -33.00 0.00 -64.00 -65.00 0.00 -32.00 -32.00 32.00 -129.00 -32.00 -96.00 32.00 -32.00 0.00 -97.00 97.00 -64.00 0.00 -161.00 64.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 -129.00 0.00 -96.00 64.00 -161.00 97.00 -65.00 160.00 -128.00 33.00 -65.00 0.00 -96.00 64.00 -96.00 32.00 -33.00 96.00 0.00 33.00 -32.00 0.00 -32.00 0.00 -64.00 96.00 0.00 64.00 -64.00 129.00 -65.00 32.00 -32.00 65.00 -32.00 96.00 32.00 129.00 -129.00 64.00 0.00 32.00 0.00 225.00 -32.00 32.00 -32.00 0.00 -96.00 32.00 -32.00 -32.00 -65.00 0.00 -64.00 32.00 -32.00 33.00 0.00 64.00 32.00 96.00 0.00 97.00 32.00 0.00 -32.00 32.00 -32.00 96.00 -32.00 33.00 32.00 32.00 32.00 96.00 -32.00 32.00 0.00 129.00 64.00 32.00 129.00 32.00 32.00 65.00 0.00 32.00 0.00 128.00 64.00 129.00 0.00 64.00 0.00 32.00 -32.00 33.00 32.00 32.00 0.00 32.00 -32.00 64.00 0.00 32.00 129.00 -32.00 32.00 0.00 128.00 32.00 0.00 0.00 65.00 129.00 128.00 96.00 -64.00 33.00 32.00 32.00 32.00 0.00 65.00 0.00 32.00 32.00 96.00 161.00 0.00 64.00 32.00 0.00 161.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 33.00 32.00 32.00 33.00 -32.00 32.00 64.00 -32.00 64.00 -33.00 32.00 0.00 33.00 97.00 32.00 -32.00 64.00 32.00 32.00 -32.00 64.00 32.00 65.00 32.00 32.00 -32.00 64.00 96.00 -32.00 97.00 64.00 32.00 -32.00 161.00 64.00 32.00 0.00 -32.00 65.00 32.00 32.00 64.00 -64.00 97.00 -33.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 97.00 32.00 0.00 -96.00 160.00 64.00 0.00 32.00 65.00 0.00 32.00 32.00 32.00 0.00 129.00 -128.00 0.00 -32.00 -65.00 -32.00 65.00 -65.00 32.00 0.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 64.00 -64.00 32.00 0.00 65.00 0.00 96.00 0.00 32.00 32.00 32.00 -32.00 32.00 -32.00 65.00 -32.00 96.00 0.00 32.00 -65.00 97.00 0.00 32.00 0.00 32.00 -32.00 129.00 -64.00 32.00 0.00 32.00 -64.00 0.00 -97.00 -32.00 0.00 32.00 -96.00 -64.00 -65.00 0.00 -96.00 -32.00 0.00 -32.00 0.00 -65.00 -64.00 -32.00 -32.00 -32.00 -65.00 -64.00 -32.00 0.00 -64.00 -65.00 32.00 -32.00 -64.00 32.00 -33.00 0.00 -64.00 -64.00 -32.00 0.00 -32.00 -32.00 -193.00 64.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 -64.00 193.00 -129.00 0.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 32.00 -96.00 65.00 -32.00 0.00 -32.00 32.00 -65.00 -32.00 -96.00 0.00 -32.00 96.00 0.00 0.00 -129.00 32.00 -32.00 32.00 -32.00 -96.00 -129.00 32.00 -32.00 32.00 -129.00 -32.00 -96.00 32.00 -32.00 32.00 32.00 65.00 -32.00 32.00 -64.00 0.00 -65.00 32.00 -32.00 64.00 32.00 -32.00 -64.00 97.00 -97.00 32.00 0.00 32.00 -64.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 32.00 -64.00 64.00 -129.00 0.00 -128.00 129.00 -129.00 -32.00 -32.00 64.00 0.00 64.00 -96.00 97.00 -32.00 -32.00 -65.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 64.00 -65.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 96.00 -97.00 0.00 -32.00 161.00 -64.00 64.00 -32.00 65.00 -65.00 32.00 -321.00 64.00 -161.00 2862.00 0.00 1125.00 0.00 1415.00 0.00 0.00 1350.00 0.00 33.00 32.00 64.00 0.00 128.00 32.00 33.00 32.00 0.00 65.00 64.00 -33.00 289.00 33.00 32.00 0.00 65.00 -97.00 193.00 0.00 160.00 32.00 161.00 32.00 0.00 0.00 65.00 0.00 32.00 -32.00 64.00 0.00 225.00 129.00 97.00 129.00 64.00 0.00 32.00 96.00 0.00 0.00 32.00 32.00 -32.00 64.00 32.00 65.00 97.00 96.00 32.00 32.00 96.00 33.00 0.00 32.00 32.00 -32.00 161.00 32.00 129.00 32.00 32.00 32.00 64.00 0.00 97.00 0.00 32.00 -32.00 64.00 -64.00 0.00 0.00 97.00 32.00 32.00 0.00 96.00 -32.00 32.00 0.00 65.00 64.00 64.00 0.00 32.00 32.00 0.00 32.00 129.00 0.00 32.00 97.00 32.00 96.00 96.00 0.00 33.00 32.00 32.00 32.00 -32.00 65.00 32.00 96.00 193.00 64.00 32.00 65.00 0.00 0.00 32.00 64.00 64.00 32.00 0.00 0.00 33.00 32.00 32.00 0.00 32.00 193.00 128.00 0.00 33.00 32.00 0.00 33.00 -33.00 32.00 33.00 32.00 -33.00 0.00 65.00 32.00 64.00 32.00 0.00 32.00 64.00 32.00 0.00 0.00 -32.00 33.00 0.00 128.00 97.00 0.00 32.00 -96.00 32.00 32.00 64.00 -32.00 97.00 128.00 96.00 0.00 65.00 65.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 -33.00 64.00 33.00 33.00 -33.00 96.00 65.00 64.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 32.00 97.00 97.00 0.00 129.00 32.00 32.00 0.00 32.00 32.00 32.00 32.00 -32.00 32.00 96.00 97.00 33.00 -32.00 64.00 257.00 -32.00 0.00 -32.00 64.00 0.00 65.00 128.00 128.00 32.00 97.00 161.00 64.00 32.00 96.00 129.00 33.00 -32.00 128.00 -161.00 32.00 -32.00 0.00 -97.00 129.00 -32.00 64.00 -64.00 -32.00 -32.00 32.00 -65.00 193.00 -128.00 32.00 0.00 65.00 32.00 32.00 64.00 0.00 32.00 32.00 97.00 129.00 32.00 32.00 32.00 0.00 64.00 -32.00 97.00 64.00 64.00 0.00 97.00 -32.00 32.00 -97.00 289.00 0.00 97.00 -32.00 32.00 0.00 64.00 0.00 64.00 64.00 65.00 65.00 0.00 -32.00 32.00 0.00 64.00 96.00 32.00 0.00 97.00 32.00 0.00 64.00 -32.00 97.00 32.00 32.00 32.00 -32.00 64.00 32.00 32.00 32.00 -32.00 32.00 64.00 97.00 -64.00 64.00 0.00 97.00 32.00 0.00 32.00 96.00 33.00 0.00 32.00 32.00 0.00 32.00 96.00 33.00 32.00 32.00 65.00 32.00 0.00 32.00 0.00 0.00 64.00 0.00 32.00 32.00 0.00 64.00 -32.00 65.00 32.00 0.00 -32.00 96.00 32.00 64.00 -32.00 0.00 161.00 33.00 64.00 32.00 64.00 -32.00 65.00 64.00 0.00 64.00 96.00 97.00 -64.00 32.00 32.00 193.00 -32.00 0.00 -32.00 32.00 -32.00 64.00 64.00 -32.00 32.00 32.00 64.00 32.00 -32.00 97.00 64.00 64.00 0.00 32.00 0.00 32.00 97.00 65.00 0.00 -32.00 129.00 96.00 -65.00 32.00 65.00 32.00 32.00 65.00 -32.00 0.00 64.00 32.00 64.00 193.00 -64.00 0.00 32.00 -32.00 64.00 64.00 33.00 64.00 -97.00 65.00 0.00 0.00 64.00 32.00 33.00 32.00 0.00 0.00 64.00 -64.00 32.00 32.00 64.00 96.00 -64.00 97.00 96.00 64.00 -32.00 -32.00 -64.00 96.00 32.00 97.00 64.00 32.00 -96.00 128.00 0.00 0.00 32.00 33.00 0.00 32.00 -64.00 0.00 -32.00 32.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 64.00 32.00 33.00 0.00 32.00 -32.00 64.00 -32.00 32.00 64.00 32.00 0.00 32.00 -32.00 33.00 64.00 64.00 -64.00 0.00 32.00 -32.00 129.00 32.00 32.00 0.00 32.00 64.00 0.00 97.00 0.00 64.00 129.00 96.00 -97.00 65.00 65.00 0.00 32.00 0.00 32.00 64.00 32.00 32.00 32.00 0.00 32.00 -64.00 65.00 32.00 96.00 64.00 65.00 97.00 225.00 32.00 32.00 193.00 -32.00 32.00 64.00 64.00 64.00 33.00 97.00 32.00 32.00 193.00 32.00 32.00 0.00 32.00 32.00 96.00 64.00 97.00 129.00 64.00 32.00 64.00 0.00 193.00 0.00 129.00 -64.00 64.00 0.00 65.00 64.00 32.00 32.00 32.00 97.00 0.00 96.00 0.00 32.00 -32.00 97.00 -97.00 96.00 -96.00 129.00 0.00 129.00 32.00 32.00 64.00 0.00 97.00 32.00 96.00 32.00 32.00 64.00 97.00 65.00 128.00 0.00 97.00 -33.00 64.00 0.00 32.00 33.00 33.00 -33.00 32.00 -128.00 0.00 -32.00 64.00 0.00 32.00 32.00 64.00 -32.00 33.00 -65.00 96.00 -32.00 64.00 -64.00 32.00 0.00 65.00 0.00 128.00 161.00 33.00 -32.00 64.00 -33.00 64.00 -32.00 32.00 32.00 65.00 65.00 64.00 0.00 96.00 -65.00 33.00 -64.00 64.00 -32.00 96.00 32.00 97.00 0.00 64.00 -32.00 32.00 -97.00 32.00 0.00 0.00 -64.00 33.00 -32.00 64.00 -32.00 129.00 -32.00 128.00 -161.00 97.00 32.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 64.00 0.00 65.00 0.00 64.00 0.00 225.00 -65.00 0.00 32.00 -32.00 65.00 -161.00 257.00 -129.00 225.00 -128.00 129.00 -129.00 96.00 -193.00 129.00 -321.00 161.00 -161.00 32.00 -96.00 64.00 -33.00 32.00 -96.00 225.00 -32.00 65.00 0.00 96.00 -32.00 64.00 -193.00 258.00 0.00 32.00 32.00 32.00 96.00 32.00 65.00 32.00 64.00 0.00 32.00 32.00 -128.00 290.00 -258.00 578.00 -257.00 515.00 -161.00 418.00 -353.00 772.00 -547.00 1221.00 -32.00 33.00 -193.00 450.00 -354.00 803.00 -128.00 322.00 -193.00 450.00 -322.00 708.00 -1093.00 2379.00 -1415.00 3087.00 -321.00 771.00 -418.00 901.00 -740.00 1672.00 -1897.00 4212.00 -32.00 64.00 -64.00 32.00 0.00 32.00 -33.00 0.00 -128.00 0.00 -32.00 32.00 -32.00 161.00 -33.00 64.00 -64.00 97.00 -96.00 32.00 -258.00 225.00 -96.00 161.00 -97.00 96.00 -64.00 129.00 0.00 418.00 64.00 96.00 33.00 161.00 128.00 354.00 129.00 161.00 64.00 32.00 32.00 96.00 33.00 0.00 128.00 32.00 64.00 65.00 65.00 64.00 160.00 289.00 97.00 97.00 96.00 32.00 33.00 0.00 64.00 129.00 32.00 64.00 64.00 32.00 33.00 129.00 96.00 96.00 64.00 257.00 -32.00 193.00 32.00 161.00 0.00 64.00 97.00 129.00 64.00 64.00 -32.00 33.00 -161.00 160.00 -161.00 322.00 -32.00 161.00 -32.00 160.00 32.00 129.00 32.00 161.00 33.00 64.00 0.00 96.00 -161.00 161.00 -65.00 129.00 -128.00 128.00 -32.00 33.00 0.00 128.00 0.00 65.00 -65.00 96.00 -160.00 161.00 -193.00 96.00 -32.00 65.00 -33.00 0.00 0.00 64.00 65.00 64.00 0.00 225.00 96.00 161.00 97.00 129.00 32.00 128.00 0.00 65.00 32.00 96.00 128.00 225.00 33.00 64.00 -33.00 97.00 33.00 96.00 -33.00 65.00 -128.00 64.00 -32.00 96.00 64.00 193.00 -64.00 97.00 32.00 193.00 -32.00 64.00 0.00 64.00 32.00 32.00 32.00 97.00 -32.00 32.00 -129.00 64.00 -32.00 65.00 32.00 64.00 -32.00 64.00 0.00 65.00 -128.00 160.00 -33.00 65.00 -64.00 96.00 -32.00 32.00 -64.00 129.00 32.00 96.00 32.00 65.00 0.00 64.00 -32.00 129.00 64.00 64.00 32.00 64.00 0.00 64.00 -32.00 33.00 -32.00 96.00 -32.00 64.00 -129.00 290.00 32.00 32.00 97.00 32.00 128.00 -64.00 33.00 0.00 128.00 -32.00 129.00 64.00 0.00 32.00 -32.00 32.00 -97.00 65.00 -193.00 192.00 -64.00 65.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 32.00 -289.00 32.00 -2830.00 0.00 -128.00 0.00 -3473.00 0.00 -2669.00 -32.00 -1543.00 0.00 -418.00 0.00 -64.00 0.00 -3473.00 0.00 -32.00 0.00 -64.00 0.00 -97.00 -193.00 -32.00 -32.00 32.00 -97.00 -32.00 -32.00 -64.00 -32.00 -32.00 -32.00 -97.00 -32.00 -128.00 32.00 -33.00 -32.00 -32.00 -97.00 -64.00 32.00 -64.00 0.00 -33.00 65.00 33.00 32.00 -33.00 32.00 0.00 32.00 -64.00 32.00 0.00 33.00 -64.00 64.00 -65.00 -32.00 -96.00 0.00 -96.00 -65.00 -33.00 0.00 -32.00 65.00 0.00 160.00 -64.00 65.00 -32.00 64.00 32.00 64.00 -32.00 32.00 0.00 33.00 0.00 96.00 -97.00 64.00 -96.00 0.00 0.00 65.00 -96.00 0.00 -65.00 32.00 -193.00 -64.00 -32.00 32.00 -32.00 -32.00 0.00 -97.00 -64.00 -96.00 -65.00 -33.00 -64.00 -128.00 -96.00 0.00 -97.00 0.00 -128.00 64.00 -129.00 -32.00 -129.00 -321.00 0.00 -33.00 32.00 -64.00 -32.00 -32.00 -64.00 -32.00 -32.00 -65.00 32.00 -64.00 -64.00 -96.00 -97.00 -65.00 32.00 -32.00 97.00 0.00 0.00 -64.00 -32.00 -64.00 -33.00 -97.00 -64.00 0.00 -128.00 0.00 -65.00 -64.00 -128.00 -32.00 -32.00 32.00 -65.00 32.00 -32.00 32.00 0.00 64.00 97.00 97.00 -33.00 64.00 -32.00 0.00 -225.00 -161.00 -32.00 -32.00 0.00 -32.00 64.00 -96.00 32.00 -65.00 -64.00 -64.00 32.00 -96.00 -32.00 -65.00 -64.00 0.00 -32.00 -32.00 -33.00 -64.00 0.00 -97.00 -32.00 -128.00 32.00 -129.00 33.00 -64.00 0.00 -64.00 -33.00 -33.00 -64.00 -32.00 -64.00 -32.00 -64.00 0.00 -129.00 -32.00 -64.00 -32.00 -32.00 -64.00 -65.00 -65.00 -32.00 32.00 -32.00 0.00 -32.00 65.00 -65.00 32.00 -96.00 96.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 -64.00 -65.00 0.00 32.00 -65.00 -32.00 -64.00 0.00 -64.00 -32.00 0.00 32.00 -65.00 -32.00 -96.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -65.00 -193.00 -96.00 -32.00 -32.00 32.00 -32.00 -64.00 -129.00 -65.00 -32.00 -32.00 -64.00 0.00 -33.00 0.00 -32.00 32.00 -32.00 33.00 -64.00 -33.00 -32.00 -32.00 -97.00 32.00 -32.00 -64.00 -64.00 0.00 -33.00 -96.00 -64.00 -65.00 -64.00 -96.00 -97.00 -193.00 -96.00 -129.00 0.00 -32.00 -64.00 -64.00 -97.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -64.00 -64.00 -2186.00 0.00 -804.00 0.00 -161.00 0.00 -418.00 -32.00 -32.00 225.00 32.00 64.00 -32.00 64.00 -64.00 32.00 -32.00 97.00 -97.00 64.00 0.00 64.00 32.00 33.00 -32.00 96.00 -32.00 32.00 -96.00 161.00 -161.00 97.00 -97.00 96.00 0.00 32.00 129.00 225.00 -129.00 97.00 -64.00 96.00 0.00 64.00 -64.00 97.00 -33.00 32.00 -32.00 0.00 -160.00 -129.00 -97.00 -32.00 -96.00 -32.00 -32.00 0.00 -65.00 0.00 -32.00 64.00 -64.00 97.00 -32.00 32.00 -97.00 -32.00 -64.00 32.00 0.00 289.00 -161.00 97.00 0.00 64.00 129.00 32.00 64.00 65.00 0.00 64.00 -161.00 129.00 0.00 32.00 32.00 96.00 97.00 97.00 0.00 96.00 64.00 64.00 32.00 0.00 0.00 65.00 -96.00 160.00 -32.00 0.00 -65.00 -64.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 161.00 -65.00 32.00 0.00 64.00 -32.00 64.00 -32.00 33.00 32.00 32.00 -96.00 128.00 32.00 129.00 -193.00 -32.00 -32.00 0.00 -97.00 64.00 -64.00 0.00 -64.00 -32.00 -32.00 32.00 -65.00 97.00 0.00 160.00 65.00 129.00 -33.00 64.00 -96.00 97.00 0.00 32.00 0.00 32.00 32.00 97.00 0.00 128.00 32.00 225.00 0.00 65.00 -32.00 32.00 -128.00 0.00 -258.00 160.00 -160.00 -32.00 -161.00 32.00 -65.00 0.00 -64.00 -32.00 0.00 -32.00 64.00 -161.00 0.00 -64.00 0.00 -32.00 -64.00 0.00 -257.00 96.00 -129.00 65.00 -128.00 32.00 -65.00 32.00 -32.00 0.00 -64.00 0.00 -129.00 32.00 -193.00 -32.00 -64.00 0.00 -32.00 32.00 -64.00 32.00 -32.00 0.00 0.00 65.00 -65.00 32.00 -32.00 32.00 -64.00 0.00 -129.00 -32.00 -96.00 0.00 -65.00 32.00 -64.00 -97.00 -32.00 -32.00 -64.00 0.00 0.00 32.00 -129.00 97.00 -96.00 32.00 -33.00 0.00 -96.00 -129.00 -32.00 -32.00 -65.00 0.00 -64.00 0.00 -128.00 32.00 -129.00 97.00 -97.00 64.00 -32.00 65.00 -32.00 32.00 -64.00 -32.00 0.00 32.00 0.00 128.00 -64.00 225.00 -33.00 33.00 0.00 32.00 0.00 64.00 33.00 32.00 0.00 129.00 0.00 32.00 32.00 64.00 0.00 32.00 32.00 65.00 -32.00 32.00 -32.00 64.00 -33.00 97.00 0.00 32.00 -64.00 32.00 0.00 32.00 -64.00 64.00 -97.00 0.00 -64.00 65.00 0.00 64.00 -64.00 64.00 32.00 65.00 -64.00 0.00 -33.00 32.00 -32.00 32.00 -32.00 0.00 32.00 96.00 -64.00 65.00 0.00 32.00 -32.00 32.00 -129.00 0.00 -32.00 0.00 -32.00 32.00 32.00 64.00 -64.00 33.00 -65.00 0.00 -128.00 96.00 -65.00 -64.00 -96.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -65.00 64.00 -96.00 0.00 -64.00 -96.00 -33.00 0.00 -32.00 32.00 -128.00 -97.00 -161.00 0.00 -64.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 -160.00 -96.00 -33.00 0.00 -160.00 64.00 -65.00 64.00 -225.00 129.00 -32.00 64.00 -129.00 0.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -96.00 -64.00 -129.00 -64.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 65.00 0.00 128.00 -32.00 161.00 0.00 32.00 32.00 64.00 64.00 161.00 0.00 65.00 -32.00 -33.00 -64.00 33.00 -65.00 -65.00 -32.00 65.00 -96.00 32.00 -32.00 -32.00 0.00 -65.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -161.00 -129.00 -64.00 -32.00 -96.00 0.00 -32.00 0.00 -97.00 32.00 -96.00 33.00 -32.00 32.00 -33.00 64.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 -33.00 257.00 -64.00 32.00 -128.00 258.00 -33.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 64.00 -64.00 0.00 -33.00 32.00 -64.00 64.00 -32.00 0.00 -32.00 -96.00 -32.00 -32.00 -32.00 0.00 -33.00 -161.00 -64.00 32.00 -32.00 0.00 0.00 -96.00 -32.00 -33.00 -32.00 0.00 -97.00 -96.00 -64.00 0.00 -97.00 -32.00 -32.00 -64.00 -32.00 -97.00 -96.00 -64.00 -33.00 -32.00 -64.00 -33.00 0.00 -64.00 -96.00 0.00 -65.00 -32.00 -160.00 0.00 -33.00 0.00 0.00 32.00 -64.00 32.00 -193.00 0.00 -96.00 -32.00 -32.00 0.00 -33.00 0.00 -96.00 64.00 -32.00 0.00 -64.00 65.00 -161.00 -65.00 -65.00 0.00 -64.00 33.00 -32.00 0.00 -97.00 -97.00 -32.00 0.00 -96.00 0.00 32.00 97.00 -32.00 32.00 -97.00 0.00 -32.00 0.00 0.00 -65.00 -32.00 -32.00 -64.00 65.00 -97.00 -65.00 -64.00 32.00 -32.00 0.00 -161.00 -64.00 -32.00 32.00 0.00 32.00 96.00 65.00 33.00 96.00 0.00 225.00 -161.00 129.00 -64.00 129.00 -129.00 128.00 -129.00 97.00 -32.00 64.00 0.00 64.00 0.00 32.00 -193.00 33.00 -64.00 96.00 -129.00 32.00 -32.00 32.00 -96.00 -32.00 -65.00 64.00 -289.00 161.00 -32.00 97.00 -64.00 64.00 -97.00 64.00 -129.00 0.00 -64.00 0.00 -64.00 -32.00 -32.00 32.00 32.00 32.00 0.00 129.00 -129.00 97.00 -1222.00 -515.00 -193.00 -96.00 -160.00 -33.00 -129.00 -96.00 -772.00 -322.00 -2893.00 -1254.00 -1158.00 -514.00 -2058.00 -900.00 -514.00 -225.00 -129.00 -65.00 -160.00 -64.00 -965.00 -547.00 -900.00 -450.00 -1222.00 -643.00 -547.00 -289.00 -964.00 -547.00 -1769.00 -964.00 -772.00 -418.00 -353.00 -225.00 -450.00 -97.00 -515.00 -129.00 -1736.00 -353.00 -1447.00 -354.00 -1254.00 -289.00 -289.00 -65.00 -1962.00 -482.00 -96.00 0.00 -97.00 -32.00 -707.00 -225.00 -64.00 -32.00 -2219.00 -450.00 -161.00 -65.00 -836.00 -418.00 -2186.00 -996.00 -1961.00 -869.00 -290.00 -160.00z"},rr:{name:"RR",path:"M52171.00 10353.00l0.00 -64.00 0.00 -161.00 0.00 -129.00 -96.00 -128.00 -193.00 -193.00 -64.00 -97.00 -97.00 -64.00 0.00 -32.00 -64.00 -161.00 -161.00 -97.00 -64.00 -64.00 -225.00 -128.00 -97.00 -33.00 -96.00 -64.00 -97.00 -32.00 -128.00 32.00 -32.00 -32.00 -97.00 -129.00 -96.00 -160.00 -129.00 -97.00 -96.00 -96.00 -32.00 -225.00 -97.00 -33.00 -96.00 -64.00 -65.00 -128.00 -96.00 -65.00 -97.00 -64.00 0.00 -32.00 -32.00 -32.00 -32.00 -129.00 -96.00 -129.00 -65.00 -193.00 -64.00 -64.00 -96.00 -64.00 -129.00 -97.00 -129.00 -96.00 -64.00 -193.00 0.00 -161.00 32.00 -96.00 97.00 -97.00 64.00 0.00 418.00 193.00 161.00 161.00 160.00 354.00 161.00 128.00 161.00 65.00 64.00 -65.00 97.00 0.00 96.00 32.00 0.00 -32.00 225.00 -32.00 129.00 -64.00 129.00 0.00 64.00 0.00 257.00 32.00 129.00 -32.00 64.00 -32.00 96.00 0.00 0.00 64.00 33.00 0.00 64.00 0.00 96.00 32.00 65.00 32.00 128.00 0.00 97.00 -64.00 32.00 0.00 64.00 96.00 64.00 0.00 97.00 97.00 96.00 161.00 0.00 64.00 -32.00 32.00 32.00 64.00 97.00 97.00 129.00 257.00 64.00 32.00 0.00 32.00 161.00 33.00 0.00 128.00 64.00 32.00 32.00 0.00 64.00 129.00 32.00 0.00 0.00 -64.00 0.00 -33.00 33.00 33.00 32.00 -65.00 32.00 -32.00 32.00 -64.00 32.00 -32.00 65.00 0.00 32.00 -32.00 32.00 -33.00 32.00 33.00 129.00 -65.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 32.00 97.00 0.00 96.00 33.00 129.00 -33.00 64.00 0.00 96.00 33.00 -32.00 32.00 32.00 32.00 65.00 32.00 32.00 32.00 32.00 0.00 0.00 -32.00 65.00 0.00 64.00 32.00 96.00 -96.00 -64.00 0.00 -32.00 -32.00 0.00 -33.00 -64.00 0.00 -33.00 -32.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 32.00 -97.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 64.00 0.00 64.00 32.00 32.00 32.00 65.00 129.00 64.00 32.00 64.00 96.00 97.00 97.00 32.00 64.00 -32.00 64.00 32.00 32.00 -32.00 32.00 0.00 33.00 64.00 0.00 32.00 0.00 97.00 -33.00 0.00 97.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 32.00 0.00 65.00 65.00 32.00 -33.00 32.00 65.00 0.00 -65.00 -32.00 -96.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 0.00 65.00 32.00 32.00 0.00 64.00 32.00 64.00 -32.00 0.00 -64.00 0.00 -32.00 97.00 -97.00 32.00 -32.00 -64.00 -64.00 32.00 -32.00 0.00 -33.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 32.00 -64.00 -64.00 0.00 0.00 -32.00 96.00 -96.00 65.00 0.00 96.00 -33.00 193.00 129.00 97.00 0.00 64.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -65.00 32.00 33.00 33.00 32.00 32.00 0.00 32.00 64.00 128.00 -32.00 33.00 32.00 128.00 32.00 64.00 0.00 -64.00 257.00 -64.00 65.00 0.00 160.00 32.00 33.00 0.00 32.00 96.00 128.00 65.00 0.00 64.00 0.00 64.00 33.00 65.00 0.00 64.00 0.00 64.00 0.00 97.00 64.00 96.00 64.00 0.00 64.00 65.00 65.00 32.00 0.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 129.00 -32.00 64.00 -65.00 0.00 65.00 32.00 192.00 97.00 0.00 96.00 65.00 0.00 64.00 97.00 64.00 64.00 33.00 32.00 64.00 0.00 32.00 0.00 32.00 -32.00 129.00 -129.00 32.00 -64.00 0.00 -96.00 64.00 0.00 97.00 -65.00 64.00 -64.00 96.00 -64.00 97.00 -129.00 64.00 32.00 32.00 0.00 33.00 0.00 32.00 64.00 32.00 0.00 32.00 97.00 32.00 0.00 32.00 64.00 97.00 65.00 32.00 0.00 0.00 -65.00 32.00 0.00 0.00 -64.00 32.00 -32.00 -32.00 -65.00 32.00 -96.00 -32.00 -96.00 0.00 -97.00 -32.00 -32.00 64.00 -64.00 0.00 -32.00 -64.00 0.00 -32.00 -65.00 -97.00 -64.00 0.00 -32.00 97.00 -65.00 -32.00 0.00 0.00 -32.00 -65.00 -32.00 -32.00 -64.00 0.00 -32.00 -64.00 -33.00 32.00 -128.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 96.00 -32.00 65.00 -64.00 32.00 -96.00 -97.00 -33.00 -32.00 -128.00 32.00 0.00 65.00 -65.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 161.00 64.00 64.00 -32.00 64.00 0.00 97.00 0.00 0.00 -32.00 32.00 -32.00 97.00 32.00 96.00 0.00 32.00 32.00 64.00 0.00 33.00 64.00 0.00 33.00 32.00 0.00 96.00 0.00 -32.00 -33.00 0.00 -64.00 64.00 -32.00 33.00 0.00 32.00 -32.00 -32.00 -65.00 0.00 -96.00 -33.00 32.00 -64.00 -32.00 32.00 0.00 32.00 -64.00 -32.00 -65.00 65.00 0.00 96.00 -32.00 0.00 -32.00 -64.00 -64.00 128.00 32.00 0.00 -32.00 32.00 -32.00 33.00 0.00 32.00 32.00 32.00 32.00 32.00 -64.00 32.00 0.00 32.00 0.00 0.00 -65.00 33.00 0.00 -33.00 -32.00 -64.00 0.00 32.00 -64.00 32.00 -32.00 33.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 96.00 0.00 0.00 -32.00 32.00 32.00 33.00 0.00 32.00 32.00 32.00 0.00 0.00 -32.00 96.00 96.00 32.00 0.00 0.00 -32.00 65.00 0.00 0.00 97.00 32.00 0.00 64.00 64.00 32.00 -32.00 33.00 0.00 0.00 32.00 64.00 0.00 64.00 -32.00 32.00 64.00 129.00 0.00 64.00 64.00 32.00 -32.00 33.00 32.00 64.00 32.00 96.00 -32.00 0.00 32.00 0.00 65.00 97.00 32.00 32.00 0.00 32.00 0.00 64.00 32.00 0.00 32.00 33.00 -32.00 32.00 -32.00 96.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 64.00 0.00 33.00 -32.00 0.00 -32.00 32.00 0.00 32.00 32.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 0.00 -33.00 64.00 -32.00 97.00 65.00 32.00 -33.00 32.00 -32.00 0.00 32.00 0.00 33.00 32.00 -33.00 64.00 0.00 33.00 -64.00 32.00 32.00 32.00 -64.00 32.00 -32.00 32.00 0.00 -32.00 32.00 0.00 64.00 32.00 32.00 129.00 129.00 32.00 96.00 64.00 33.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 33.00 -128.00 0.00 -33.00 64.00 0.00 32.00 -32.00 64.00 32.00 32.00 0.00 33.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 0.00 64.00 0.00 0.00 32.00 64.00 32.00 65.00 0.00 0.00 -32.00 32.00 -96.00 -32.00 -65.00 64.00 0.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 64.00 -33.00 0.00 33.00 33.00 0.00 64.00 0.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 129.00 -32.00 32.00 -64.00 32.00 0.00 0.00 32.00 -32.00 32.00 32.00 32.00 96.00 -32.00 65.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 0.00 32.00 65.00 0.00 0.00 64.00 32.00 0.00 32.00 0.00 32.00 -64.00 64.00 -32.00 33.00 64.00 64.00 0.00 96.00 -32.00 33.00 0.00 32.00 -32.00 0.00 -32.00 64.00 -32.00 64.00 -65.00 33.00 0.00 0.00 -32.00 32.00 -96.00 32.00 -32.00 -64.00 -33.00 0.00 -32.00 -33.00 -64.00 33.00 0.00 32.00 -32.00 -32.00 -97.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 128.00 -33.00 65.00 -64.00 32.00 0.00 32.00 -64.00 64.00 0.00 32.00 0.00 32.00 32.00 -32.00 32.00 65.00 0.00 0.00 -32.00 32.00 0.00 64.00 0.00 0.00 32.00 161.00 0.00 96.00 32.00 65.00 0.00 0.00 -64.00 96.00 0.00 -32.00 -64.00 64.00 -33.00 0.00 -32.00 129.00 0.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 -96.00 -32.00 0.00 -65.00 -33.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 32.00 -96.00 96.00 0.00 0.00 -33.00 33.00 33.00 64.00 0.00 32.00 32.00 32.00 0.00 0.00 -65.00 64.00 33.00 33.00 64.00 32.00 -64.00 128.00 64.00 0.00 -64.00 65.00 96.00 32.00 -32.00 32.00 0.00 64.00 64.00 33.00 32.00 32.00 0.00 0.00 32.00 64.00 0.00 0.00 65.00 64.00 -65.00 32.00 0.00 0.00 -32.00 97.00 -32.00 64.00 -64.00 64.00 32.00 33.00 0.00 32.00 -32.00 96.00 0.00 129.00 0.00 0.00 32.00 64.00 0.00 64.00 0.00 0.00 -32.00 33.00 -97.00 96.00 0.00 32.00 -32.00 32.00 -64.00 -32.00 -97.00 97.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 -32.00 64.00 -64.00 -32.00 -33.00 0.00 -64.00 -65.00 -32.00 0.00 -64.00 33.00 0.00 64.00 0.00 0.00 -32.00 64.00 -33.00 32.00 -64.00 0.00 -96.00 65.00 -65.00 96.00 0.00 32.00 33.00 97.00 32.00 96.00 -129.00 32.00 0.00 65.00 -32.00 -33.00 -32.00 33.00 -32.00 96.00 0.00 0.00 -33.00 129.00 -32.00 64.00 32.00 32.00 -32.00 32.00 -64.00 32.00 0.00 33.00 -32.00 -33.00 0.00 33.00 -32.00 -33.00 -33.00 33.00 -32.00 64.00 -64.00 64.00 0.00 32.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 -33.00 64.00 -64.00 32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 -33.00 129.00 -32.00 0.00 -64.00 64.00 -64.00 32.00 -33.00 65.00 0.00 32.00 -160.00 -32.00 -65.00 -33.00 -128.00 -64.00 -32.00 0.00 -65.00 -64.00 -64.00 -32.00 -96.00 -65.00 -33.00 32.00 -128.00 -32.00 -65.00 32.00 -64.00 0.00 -32.00 -32.00 -32.00 -32.00 64.00 0.00 -32.00 -32.00 -96.00 32.00 -65.00 -32.00 -64.00 -96.00 -64.00 0.00 -65.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -96.00 0.00 -65.00 -32.00 65.00 -96.00 64.00 0.00 64.00 -33.00 65.00 -32.00 96.00 32.00 32.00 0.00 64.00 33.00 65.00 32.00 64.00 -32.00 32.00 32.00 32.00 -32.00 33.00 0.00 0.00 64.00 96.00 64.00 129.00 0.00 32.00 -32.00 64.00 -32.00 129.00 32.00 96.00 0.00 32.00 0.00 32.00 0.00 65.00 0.00 32.00 96.00 32.00 0.00 96.00 -64.00 0.00 -64.00 0.00 -32.00 65.00 32.00 96.00 -64.00 65.00 32.00 0.00 32.00 0.00 32.00 64.00 -32.00 32.00 0.00 64.00 0.00 33.00 0.00 64.00 0.00 32.00 -97.00 129.00 0.00 0.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -64.00 96.00 0.00 65.00 -32.00 32.00 -33.00 64.00 -32.00 64.00 32.00 33.00 65.00 0.00 64.00 96.00 64.00 64.00 -32.00 97.00 -64.00 32.00 96.00 129.00 161.00 32.00 225.00 0.00 32.00 96.00 0.00 32.00 33.00 32.00 32.00 0.00 32.00 33.00 64.00 32.00 0.00 96.00 64.00 0.00 33.00 32.00 -33.00 65.00 33.00 32.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 -64.00 64.00 64.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 64.00 129.00 -32.00 32.00 32.00 32.00 -32.00 65.00 32.00 64.00 -32.00 0.00 0.00 64.00 -32.00 65.00 -32.00 64.00 -32.00 321.00 -33.00 33.00 -32.00 32.00 -32.00 64.00 32.00 32.00 -32.00 64.00 -32.00 33.00 64.00 64.00 0.00 64.00 0.00 97.00 -64.00 128.00 64.00 33.00 0.00 32.00 -161.00 160.00 -64.00 97.00 -32.00 32.00 32.00 32.00 0.00 64.00 0.00 65.00 -128.00 64.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 -64.00 32.00 32.00 97.00 -64.00 0.00 32.00 64.00 -64.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 32.00 0.00 64.00 32.00 33.00 -32.00 128.00 32.00 32.00 97.00 0.00 32.00 0.00 129.00 0.00 -33.00 -64.00 97.00 -32.00 0.00 32.00 0.00 32.00 64.00 -32.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 0.00 97.00 0.00 32.00 33.00 64.00 -33.00 33.00 33.00 32.00 -33.00 32.00 0.00 32.00 65.00 64.00 32.00 33.00 -32.00 0.00 32.00 32.00 0.00 -32.00 -32.00 32.00 -97.00 32.00 0.00 0.00 32.00 96.00 33.00 32.00 -33.00 0.00 33.00 65.00 32.00 -32.00 32.00 96.00 32.00 -32.00 32.00 32.00 32.00 64.00 -64.00 65.00 0.00 32.00 -64.00 0.00 32.00 64.00 32.00 -32.00 64.00 32.00 32.00 32.00 0.00 32.00 0.00 65.00 -32.00 32.00 32.00 64.00 33.00 32.00 -33.00 0.00 -64.00 32.00 0.00 33.00 97.00 64.00 0.00 0.00 32.00 64.00 0.00 65.00 96.00 64.00 0.00 64.00 65.00 32.00 32.00 97.00 96.00 64.00 -32.00 64.00 64.00 -64.00 33.00 32.00 96.00 0.00 32.00 -64.00 32.00 -64.00 65.00 0.00 64.00 -33.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 32.00 0.00 32.00 0.00 33.00 64.00 0.00 32.00 32.00 -128.00 160.00 32.00 33.00 0.00 96.00 32.00 97.00 0.00 32.00 64.00 64.00 33.00 32.00 96.00 65.00 193.00 0.00 129.00 64.00 -33.00 96.00 -32.00 32.00 -96.00 193.00 32.00 0.00 64.00 65.00 65.00 0.00 0.00 32.00 0.00 64.00 96.00 32.00 0.00 65.00 -32.00 0.00 -32.00 -33.00 0.00 33.00 32.00 32.00 64.00 -65.00 0.00 65.00 -32.00 32.00 32.00 32.00 32.00 -32.00 33.00 0.00 -33.00 32.00 33.00 32.00 -65.00 65.00 0.00 32.00 65.00 0.00 32.00 32.00 32.00 -64.00 64.00 0.00 0.00 32.00 97.00 0.00 32.00 64.00 0.00 32.00 32.00 32.00 -64.00 32.00 0.00 33.00 0.00 32.00 -33.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 -96.00 0.00 0.00 128.00 -65.00 -64.00 33.00 64.00 -65.00 0.00 -32.00 33.00 0.00 96.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 65.00 32.00 32.00 0.00 64.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 32.00 33.00 0.00 32.00 -32.00 32.00 -32.00 -64.00 -32.00 64.00 -65.00 32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -65.00 32.00 -32.00 64.00 -64.00 33.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 64.00 -64.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -33.00 32.00 -32.00 33.00 -32.00 32.00 0.00 32.00 -96.00 0.00 -32.00 32.00 -33.00 97.00 -64.00 0.00 32.00 32.00 -64.00 0.00 -64.00 64.00 -33.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 64.00 -32.00 -32.00 -65.00 32.00 -64.00 0.00 0.00 64.00 -32.00 65.00 -32.00 32.00 32.00 0.00 0.00 32.00 -64.00 32.00 32.00 32.00 96.00 0.00 0.00 65.00 32.00 64.00 97.00 32.00 64.00 64.00 0.00 97.00 -96.00 32.00 0.00 32.00 64.00 0.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 -33.00 64.00 0.00 32.00 0.00 64.00 33.00 0.00 64.00 -32.00 32.00 0.00 -32.00 97.00 32.00 160.00 32.00 33.00 0.00 64.00 -32.00 32.00 -64.00 -32.00 -32.00 32.00 32.00 97.00 -32.00 32.00 -33.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 129.00 -64.00 0.00 -32.00 96.00 0.00 65.00 -33.00 32.00 65.00 64.00 -65.00 32.00 -96.00 0.00 0.00 32.00 -32.00 129.00 64.00 161.00 -32.00 32.00 -64.00 0.00 32.00 0.00 32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 32.00 0.00 32.00 64.00 0.00 0.00 65.00 -32.00 0.00 -32.00 -33.00 -32.00 65.00 -65.00 32.00 0.00 64.00 -64.00 32.00 0.00 33.00 32.00 96.00 -32.00 64.00 -32.00 65.00 0.00 64.00 64.00 64.00 -32.00 32.00 -32.00 161.00 0.00 32.00 -97.00 129.00 -32.00 96.00 65.00 32.00 0.00 33.00 -65.00 64.00 32.00 64.00 -32.00 32.00 32.00 65.00 -32.00 32.00 0.00 32.00 0.00 161.00 -32.00 96.00 32.00 193.00 -32.00 64.00 32.00 193.00 0.00 33.00 65.00 96.00 32.00 32.00 -32.00 65.00 0.00 32.00 64.00 64.00 0.00 64.00 32.00 32.00 -64.00 0.00 0.00 65.00 32.00 0.00 96.00 64.00 65.00 64.00 -33.00 65.00 97.00 128.00 -32.00 32.00 0.00 65.00 32.00 32.00 0.00 32.00 96.00 64.00 -32.00 65.00 32.00 32.00 0.00 32.00 -32.00 96.00 64.00 65.00 -32.00 0.00 0.00 64.00 -64.00 64.00 0.00 32.00 64.00 129.00 65.00 64.00 32.00 -64.00 32.00 64.00 64.00 65.00 0.00 32.00 32.00 0.00 32.00 64.00 33.00 -32.00 32.00 -32.00 0.00 64.00 96.00 32.00 32.00 65.00 65.00 64.00 32.00 0.00 32.00 -32.00 97.00 0.00 64.00 0.00 0.00 32.00 64.00 32.00 -32.00 64.00 64.00 65.00 0.00 64.00 -64.00 32.00 32.00 129.00 -32.00 0.00 32.00 32.00 -32.00 64.00 -32.00 32.00 0.00 32.00 0.00 33.00 0.00 32.00 0.00 64.00 64.00 64.00 -32.00 33.00 32.00 32.00 0.00 32.00 0.00 64.00 -64.00 32.00 -32.00 97.00 32.00 128.00 32.00 0.00 0.00 33.00 32.00 32.00 -32.00 32.00 64.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 0.00 97.00 -32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 97.00 0.00 96.00 -65.00 32.00 33.00 65.00 -33.00 32.00 65.00 96.00 -32.00 97.00 32.00 64.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 -32.00 97.00 0.00 32.00 64.00 32.00 32.00 64.00 -64.00 -32.00 -64.00 32.00 -32.00 0.00 32.00 65.00 96.00 -32.00 97.00 0.00 32.00 -33.00 32.00 0.00 -32.00 -64.00 32.00 -32.00 64.00 32.00 32.00 -32.00 0.00 -32.00 65.00 32.00 32.00 -32.00 32.00 0.00 32.00 96.00 0.00 32.00 65.00 0.00 32.00 33.00 -32.00 96.00 32.00 32.00 32.00 65.00 64.00 32.00 -32.00 96.00 0.00 32.00 -32.00 65.00 -32.00 64.00 64.00 32.00 -32.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 33.00 32.00 0.00 65.00 64.00 64.00 0.00 64.00 32.00 0.00 0.00 -32.00 32.00 -32.00 32.00 32.00 0.00 129.00 0.00 32.00 32.00 64.00 97.00 32.00 96.00 0.00 33.00 129.00 64.00 32.00 -32.00 97.00 32.00 64.00 64.00 0.00 65.00 -32.00 0.00 32.00 0.00 64.00 64.00 65.00 0.00 32.00 32.00 0.00 -32.00 64.00 64.00 0.00 32.00 0.00 0.00 32.00 32.00 -32.00 0.00 -64.00 97.00 0.00 32.00 32.00 0.00 32.00 32.00 129.00 -32.00 32.00 0.00 64.00 64.00 0.00 32.00 -32.00 33.00 0.00 64.00 64.00 32.00 32.00 -32.00 33.00 32.00 32.00 32.00 96.00 -32.00 32.00 32.00 0.00 32.00 32.00 33.00 33.00 32.00 32.00 96.00 0.00 32.00 64.00 97.00 32.00 0.00 -32.00 64.00 0.00 32.00 0.00 65.00 64.00 32.00 33.00 32.00 0.00 32.00 32.00 32.00 0.00 64.00 0.00 65.00 32.00 64.00 -32.00 32.00 32.00 32.00 -32.00 33.00 64.00 32.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 64.00 129.00 -32.00 64.00 32.00 65.00 0.00 0.00 -32.00 32.00 32.00 32.00 65.00 32.00 32.00 32.00 -32.00 32.00 0.00 225.00 -33.00 0.00 65.00 -32.00 32.00 0.00 32.00 32.00 32.00 65.00 32.00 64.00 97.00 -64.00 32.00 0.00 32.00 -32.00 32.00 64.00 32.00 0.00 4727.00 -1415.00 0.00 -1125.00 0.00 -2862.00 0.00 -64.00 161.00 -32.00 321.00 -65.00 65.00 -64.00 32.00 -161.00 64.00 0.00 32.00 -96.00 97.00 0.00 64.00 32.00 32.00 32.00 32.00 -64.00 65.00 0.00 64.00 0.00 32.00 -32.00 32.00 32.00 65.00 -97.00 32.00 -64.00 96.00 -64.00 0.00 32.00 32.00 -129.00 129.00 0.00 128.00 -64.00 129.00 -32.00 64.00 -32.00 65.00 32.00 32.00 0.00 32.00 32.00 32.00 -32.00 64.00 -32.00 0.00 -97.00 97.00 32.00 64.00 -64.00 -32.00 -32.00 32.00 0.00 65.00 -32.00 64.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 32.00 96.00 -32.00 129.00 -32.00 32.00 96.00 129.00 -32.00 32.00 -32.00 32.00 0.00 129.00 -96.00 0.00 0.00 32.00 32.00 96.00 -32.00 65.00 0.00 32.00 -65.00 32.00 -32.00 96.00 -32.00 33.00 32.00 32.00 -32.00 32.00 32.00 32.00 0.00 64.00 -193.00 129.00 0.00 64.00 -32.00 65.00 0.00 32.00 -64.00 32.00 32.00 193.00 0.00 32.00 64.00 32.00 0.00 64.00 -32.00 33.00 32.00 64.00 65.00 -32.00 0.00 64.00 64.00 32.00 32.00 65.00 32.00 32.00 65.00 64.00 32.00 0.00 32.00 0.00 0.00 96.00 64.00 65.00 -32.00 96.00 32.00 0.00 0.00 97.00 -32.00 64.00 -32.00 0.00 -129.00 64.00 -32.00 32.00 -32.00 0.00 -97.00 0.00 -32.00 65.00 -96.00 0.00 -65.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -96.00 0.00 -65.00 0.00 -32.00 0.00 -64.00 64.00 -32.00 33.00 32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 64.00 -32.00 0.00 -65.00 65.00 65.00 32.00 0.00 32.00 -129.00 128.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 0.00 -32.00 -160.00 -64.00 0.00 96.00 -97.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -97.00 33.00 -64.00 64.00 -32.00 -32.00 32.00 -65.00 -32.00 0.00 -161.00 -64.00 -32.00 32.00 -97.00 -64.00 -96.00 32.00 32.00 -64.00 -32.00 -32.00 -32.00 -65.00 32.00 -64.00 -32.00 -32.00 32.00 -64.00 -97.00 -32.00 0.00 -33.00 33.00 -32.00 32.00 -64.00 -32.00 -64.00 -33.00 32.00 -32.00 -32.00 -32.00 -33.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -161.00 -64.00 -32.00 -161.00 0.00 -32.00 -96.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 -33.00 -32.00 -96.00 64.00 -129.00 -128.00 0.00 -65.00 -32.00 0.00 0.00 -128.00 32.00 -32.00 -32.00 -129.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 32.00 -64.00 0.00 -129.00 0.00 -128.00 -64.00 -32.00 0.00 -65.00 0.00 -32.00 -32.00 -32.00 -129.00 -129.00 -64.00 -32.00 0.00 -96.00 32.00 -32.00 -32.00 -33.00 -32.00 -96.00 32.00 -32.00 32.00 0.00 32.00 -97.00 -32.00 -96.00 0.00 -64.00 -32.00 -33.00 0.00 -32.00 32.00 0.00 64.00 32.00 65.00 -32.00 32.00 0.00 96.00 -32.00 32.00 -225.00 32.00 -32.00 0.00 -64.00 0.00 -129.00 129.00 -96.00 -32.00 -65.00 32.00 -32.00 32.00 -129.00 65.00 -64.00 64.00 -96.00 0.00 0.00 64.00 0.00 32.00 -33.00 32.00 -96.00 0.00 -32.00 33.00 -64.00 96.00 0.00 96.00 -33.00 65.00 -160.00 128.00 -97.00 65.00 -64.00 161.00 0.00 96.00 0.00 129.00 32.00 32.00 0.00 32.00 -64.00 64.00 0.00 161.00 -97.00 64.00 0.00 97.00 -32.00 32.00 32.00 96.00 -32.00 129.00 32.00 32.00 65.00 0.00 0.00 64.00 0.00 33.00 64.00 64.00 32.00 64.00 0.00 129.00 -32.00 64.00 -97.00 0.00 -32.00 32.00 0.00 32.00 65.00 65.00 -65.00 32.00 0.00 32.00 32.00 32.00 33.00 65.00 -33.00 32.00 -32.00 64.00 -32.00 64.00 32.00 97.00 -32.00 32.00 -32.00 32.00 -32.00 129.00 -32.00 96.00 -33.00 161.00 -64.00 64.00 -32.00 64.00 96.00 33.00 129.00 128.00 0.00 65.00 -32.00 64.00 -32.00 32.00 -97.00 129.00 0.00 32.00 32.00 0.00 129.00 32.00 32.00 96.00 129.00 0.00 64.00 32.00 0.00 33.00 0.00 96.00 97.00 193.00 160.00 64.00 33.00 65.00 32.00 32.00 0.00 64.00 -32.00 32.00 0.00 129.00 -33.00 0.00 -32.00 -32.00 -257.00 -225.00 -64.00 -161.00 -65.00 -97.00 -160.00 -128.00 -161.00 -65.00 -97.00 -32.00 -289.00 -96.00 -96.00 -97.00 -129.00 -32.00 -97.00 -32.00 -64.00 32.00 -64.00 65.00 -64.00 32.00 -65.00 0.00 -128.00 0.00 -129.00 -32.00 -32.00 -97.00 -32.00 -128.00 -64.00 -97.00 -129.00 -161.00 -32.00 -161.00 -32.00 -96.00 -129.00 -129.00 0.00 -96.00 -97.00 -225.00 -32.00 -64.00 -96.00 -97.00 -97.00 -96.00 -64.00 0.00 -64.00 0.00 -64.00 -32.00 -33.00 -33.00 -32.00 -32.00 -32.00 -32.00 32.00 -64.00 -64.00 -129.00 -64.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 -64.00 -32.00 -32.00 -129.00 -33.00 0.00 -96.00 -64.00 0.00 -64.00 -32.00 -129.00 0.00 -64.00 -97.00 -65.00 -64.00 -64.00 32.00 0.00 -32.00 -64.00 -64.00 -32.00 -65.00 -65.00 0.00 -32.00 -64.00 -96.00 -129.00 -33.00 0.00 0.00 -32.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -64.00 -33.00 -32.00 -64.00 -129.00 -32.00 -32.00 -32.00 -64.00 0.00 0.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 -64.00 -64.00 32.00 -97.00 -65.00 -32.00 -96.00 0.00 -32.00 65.00 -32.00 -33.00 -97.00 -32.00 0.00 0.00 -96.00 65.00 -33.00 0.00 -96.00 32.00 -32.00 96.00 64.00 0.00 -32.00 65.00 32.00 128.00 0.00 0.00 32.00 32.00 32.00 32.00 33.00 33.00 64.00 64.00 -32.00 0.00 -32.00 32.00 -33.00 96.00 33.00 33.00 -33.00 -33.00 -32.00 -32.00 0.00 0.00 -64.00 0.00 -32.00 97.00 0.00 0.00 -32.00 32.00 32.00 64.00 -32.00 0.00 -65.00 32.00 0.00 33.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -64.00 -32.00 -32.00 0.00 -33.00 64.00 0.00 0.00 -64.00 -64.00 -64.00 -32.00 -32.00 0.00 -65.00 -32.00 -64.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -97.00 32.00 -32.00 32.00 0.00 32.00 -64.00 0.00 -65.00 32.00 -32.00 33.00 32.00 32.00 -64.00 -32.00 0.00 0.00 -64.00 128.00 -65.00 32.00 -32.00 65.00 -32.00 32.00 -96.00 32.00 0.00 0.00 -33.00 64.00 -32.00 -32.00 -96.00 32.00 -32.00 32.00 -32.00 0.00 -129.00 32.00 -32.00 -160.00 -97.00 -32.00 32.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 -32.00 -64.00 -96.00 0.00 -33.00 64.00 -32.00 32.00 -64.00 -64.00 0.00 -32.00 -64.00 0.00 -97.00 64.00 -32.00 -32.00 -96.00 32.00 -65.00 0.00 -32.00 -64.00 -32.00 -64.00 0.00 -65.00 -64.00 -32.00 -65.00 -32.00 -64.00 -96.00 -129.00 0.00 -64.00 -33.00 -64.00 -32.00 -32.00 0.00 -33.00 32.00 0.00 0.00 -96.00 0.00 -32.00 0.00 -32.00 -96.00 -290.00 -97.00 -32.00 -32.00 -64.00 -96.00 -32.00 -97.00 -65.00 -64.00 -96.00 0.00 -129.00 0.00 -128.00 0.00 -129.00 -64.00 -128.00 -64.00 -65.00 0.00 -161.00 -65.00 -160.00 32.00 -193.00 -32.00 -97.00 32.00 -96.00 33.00 -64.00 0.00 -33.00 32.00 -32.00 -32.00 -64.00 -33.00 -129.00 -32.00 -32.00 -96.00 -129.00 -97.00 65.00 -64.00 0.00 0.00 -225.00 -64.00 -97.00 32.00 -193.00 32.00 -192.00 -96.00 -451.00 32.00 -64.00 32.00 -96.00 128.00 -193.00 161.00 -129.00 32.00 -32.00 0.00 -193.00 -32.00 -32.00 -64.00 -65.00 -32.00 -128.00 64.00 -225.00 97.00 -97.00 32.00 -128.00 0.00 -65.00 -65.00 -96.00 -64.00 -97.00 -32.00 -64.00 32.00 -64.00 -32.00 -32.00 0.00 -65.00 32.00 -96.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -161.00 0.00 -32.00 0.00 -97.00 -193.00 -32.00 -257.00 -161.00 -386.00 -96.00 -482.00 -64.00 -33.00 -32.00 -96.00 32.00 -64.00 0.00 -33.00 -65.00 -160.00 -32.00 -32.00 -32.00 0.00 -129.00 -65.00 -96.00 -96.00 -96.00 -65.00 -65.00 -64.00 -32.00 -128.00 -64.00 -33.00 -32.00 -64.00 -97.00 -129.00 -128.00 -64.00 0.00 -32.00 0.00 -64.00 32.00 -129.00 128.00 -129.00 32.00 -64.00 33.00 -32.00 128.00 -96.00 32.00 -65.00 -32.00 -514.00 129.00 -290.00 32.00 -160.00 -32.00 -161.00 -64.00 -64.00 -33.00 0.00 -96.00 -65.00 -322.00 -96.00 0.00 -32.00 -64.00 -97.00 -64.00 0.00 -386.00 -64.00 -129.00 -32.00 -160.00 64.00 -193.00 32.00 -225.00 -128.00 -65.00 -97.00 -96.00 -96.00 -64.00 -65.00 -65.00 -128.00 -32.00 -97.00 0.00 -96.00 0.00 -65.00 -96.00 0.00 -33.00 -32.00 -128.00 0.00 -322.00 97.00 -96.00 32.00 -129.00 -64.00 -257.00 -161.00 -32.00 -64.00 -161.00 -161.00 0.00 -32.00 32.00 -97.00 -32.00 -128.00 -96.00 -322.00 0.00 -64.00 128.00 -161.00 0.00 -96.00 -64.00 -33.00 -161.00 -32.00 -257.00 32.00 -450.00 97.00 -290.00 96.00 -160.00 32.00 -193.00 0.00 -258.00 0.00 -225.00 -96.00 -160.00 -64.00 -129.00 -32.00 -322.00 -129.00 -96.00 -64.00 -32.00 32.00 -64.00 -64.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -33.00 -64.00 -32.00 0.00 -32.00 -65.00 0.00 -32.00 -32.00 32.00 -64.00 33.00 -97.00 0.00 -64.00 32.00 -65.00 0.00 -64.00 0.00 -32.00 32.00 32.00 32.00 0.00 0.00 -96.00 96.00 -65.00 0.00 -64.00 65.00 -64.00 32.00 -64.00 0.00 -65.00 -32.00 -64.00 32.00 0.00 0.00 -64.00 -64.00 -65.00 0.00 -32.00 64.00 -64.00 32.00 0.00 -32.00 -65.00 -64.00 -32.00 0.00 -96.00 32.00 -32.00 0.00 -32.00 -65.00 0.00 0.00 -33.00 0.00 -32.00 -32.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 -160.00 -97.00 -33.00 -64.00 -64.00 -129.00 0.00 -289.00 -161.00 -65.00 -32.00 -64.00 -64.00 -96.00 -32.00 -97.00 -161.00 -161.00 -64.00 -128.00 -193.00 -161.00 -97.00 -96.00 32.00 -65.00 65.00 -128.00 32.00 -97.00 0.00 -64.00 0.00 -193.00 0.00 -96.00 -129.00 -354.00 32.00 -322.00 -96.00 -64.00 -32.00 -64.00 32.00 -97.00 64.00 -64.00 161.00 -161.00 64.00 -96.00 32.00 32.00z"},ap:{name:"AP",path:"M96286.00 15497.00l353.00 -32.00 225.00 -128.00 290.00 96.00 -32.00 418.00 161.00 193.00 257.00 -64.00 804.00 611.00 1157.00 160.00 900.00 -257.00 65.00 -32.00 64.00 32.00 32.00 -64.00 64.00 0.00 33.00 32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -97.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 64.00 0.00 0.00 64.00 65.00 32.00 32.00 -96.00 32.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 -33.00 32.00 -64.00 64.00 0.00 32.00 32.00 33.00 -32.00 32.00 32.00 32.00 0.00 96.00 -32.00 32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 96.00 -33.00 33.00 -64.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 33.00 0.00 64.00 0.00 64.00 0.00 32.00 32.00 -32.00 0.00 -64.00 32.00 64.00 32.00 32.00 -32.00 33.00 64.00 32.00 -32.00 -32.00 64.00 -65.00 33.00 32.00 64.00 -32.00 0.00 -32.00 32.00 0.00 32.00 64.00 0.00 33.00 -32.00 96.00 32.00 64.00 0.00 32.00 65.00 33.00 0.00 0.00 -33.00 96.00 0.00 0.00 33.00 32.00 -33.00 0.00 97.00 97.00 0.00 32.00 0.00 32.00 32.00 32.00 0.00 0.00 -32.00 64.00 0.00 65.00 64.00 32.00 0.00 64.00 0.00 65.00 65.00 96.00 0.00 64.00 -33.00 32.00 0.00 65.00 33.00 64.00 -33.00 64.00 33.00 65.00 -33.00 0.00 -32.00 -33.00 -32.00 -32.00 -64.00 32.00 0.00 129.00 64.00 32.00 -64.00 32.00 0.00 33.00 -32.00 64.00 0.00 32.00 -65.00 64.00 0.00 32.00 -32.00 33.00 -32.00 32.00 -64.00 0.00 -65.00 64.00 -32.00 64.00 0.00 33.00 64.00 32.00 -32.00 32.00 65.00 0.00 64.00 32.00 32.00 64.00 32.00 65.00 0.00 0.00 65.00 96.00 32.00 0.00 64.00 64.00 32.00 65.00 -32.00 32.00 64.00 -129.00 97.00 -32.00 -32.00 0.00 96.00 -32.00 32.00 -64.00 0.00 32.00 32.00 -32.00 65.00 -33.00 32.00 0.00 32.00 33.00 32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 97.00 0.00 64.00 -32.00 161.00 -32.00 193.00 0.00 96.00 0.00 65.00 64.00 0.00 32.00 64.00 64.00 32.00 32.00 161.00 0.00 128.00 65.00 193.00 -32.00 32.00 -97.00 -32.00 -32.00 32.00 0.00 33.00 32.00 0.00 -32.00 64.00 0.00 32.00 32.00 32.00 -32.00 32.00 -96.00 33.00 -33.00 0.00 -64.00 64.00 -32.00 0.00 -96.00 96.00 0.00 0.00 -33.00 -32.00 -64.00 97.00 0.00 0.00 -32.00 32.00 0.00 160.00 -64.00 65.00 -65.00 32.00 32.00 0.00 -64.00 32.00 32.00 32.00 -32.00 97.00 -32.00 32.00 -32.00 32.00 0.00 64.00 -32.00 0.00 -33.00 258.00 -192.00 32.00 -65.00 -32.00 -32.00 96.00 -96.00 0.00 -65.00 32.00 -32.00 32.00 -32.00 65.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 96.00 0.00 0.00 -97.00 97.00 -96.00 64.00 0.00 0.00 -65.00 -32.00 -96.00 64.00 -32.00 32.00 0.00 0.00 -33.00 32.00 -64.00 33.00 0.00 -33.00 -96.00 -96.00 -65.00 32.00 -64.00 -64.00 -64.00 64.00 -64.00 32.00 -33.00 32.00 33.00 65.00 -161.00 32.00 -65.00 64.00 -128.00 65.00 -129.00 0.00 -32.00 32.00 -64.00 -32.00 -65.00 32.00 -64.00 96.00 -161.00 32.00 -96.00 129.00 -193.00 64.00 -64.00 32.00 32.00 32.00 0.00 65.00 -97.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 0.00 -64.00 0.00 -32.00 33.00 0.00 32.00 -65.00 64.00 -128.00 0.00 -65.00 0.00 -32.00 32.00 -96.00 32.00 -32.00 65.00 -129.00 64.00 -129.00 -96.00 -96.00 32.00 -64.00 32.00 -33.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 33.00 -64.00 32.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 32.00 -65.00 64.00 -32.00 65.00 32.00 -32.00 -161.00 64.00 -64.00 0.00 -64.00 64.00 -32.00 64.00 -32.00 0.00 -33.00 33.00 -32.00 32.00 32.00 32.00 65.00 64.00 -32.00 32.00 -33.00 129.00 -193.00 32.00 -32.00 0.00 -64.00 161.00 -193.00 32.00 -96.00 193.00 -386.00 64.00 -65.00 32.00 -128.00 33.00 -32.00 64.00 -65.00 -32.00 -32.00 96.00 -32.00 161.00 -354.00 96.00 -96.00 33.00 -64.00 32.00 -225.00 32.00 -33.00 32.00 -32.00 32.00 -161.00 65.00 -64.00 128.00 32.00 32.00 -96.00 -32.00 -129.00 32.00 -64.00 65.00 -32.00 32.00 -32.00 64.00 0.00 64.00 -32.00 65.00 -97.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 96.00 -33.00 33.00 -64.00 0.00 -32.00 96.00 -64.00 64.00 -97.00 33.00 -96.00 0.00 -97.00 0.00 -64.00 32.00 -64.00 96.00 -97.00 32.00 -32.00 161.00 -32.00 64.00 -32.00 65.00 -65.00 96.00 -32.00 97.00 -64.00 0.00 -97.00 0.00 -64.00 32.00 -64.00 96.00 -257.00 64.00 -129.00 33.00 -128.00 0.00 -161.00 32.00 -33.00 32.00 -128.00 32.00 -418.00 97.00 -354.00 32.00 -32.00 32.00 -32.00 128.00 -32.00 65.00 64.00 64.00 0.00 161.00 161.00 128.00 96.00 386.00 386.00 450.00 483.00 0.00 32.00 97.00 128.00 32.00 97.00 64.00 96.00 97.00 289.00 0.00 33.00 32.00 32.00 0.00 193.00 32.00 96.00 0.00 129.00 0.00 96.00 32.00 32.00 225.00 129.00 129.00 0.00 64.00 64.00 0.00 32.00 32.00 0.00 0.00 193.00 -32.00 97.00 0.00 225.00 0.00 64.00 0.00 65.00 -32.00 32.00 32.00 96.00 -32.00 64.00 0.00 65.00 0.00 128.00 32.00 226.00 65.00 707.00 -65.00 161.00 0.00 -33.00 -32.00 33.00 0.00 32.00 0.00 289.00 32.00 97.00 290.00 803.00 -33.00 97.00 -32.00 64.00 0.00 97.00 0.00 64.00 32.00 129.00 97.00 96.00 0.00 64.00 -32.00 65.00 0.00 96.00 32.00 64.00 32.00 97.00 64.00 64.00 0.00 129.00 0.00 64.00 33.00 129.00 32.00 64.00 32.00 96.00 96.00 97.00 0.00 129.00 0.00 96.00 33.00 97.00 -33.00 64.00 97.00 -32.00 64.00 64.00 32.00 0.00 32.00 64.00 -32.00 65.00 0.00 64.00 65.00 32.00 32.00 64.00 0.00 258.00 64.00 32.00 96.00 96.00 0.00 65.00 33.00 32.00 0.00 193.00 0.00 32.00 0.00 32.00 32.00 64.00 32.00 193.00 -32.00 129.00 -65.00 32.00 -32.00 64.00 32.00 0.00 0.00 -32.00 33.00 0.00 32.00 0.00 96.00 -64.00 65.00 0.00 64.00 32.00 32.00 64.00 0.00 65.00 64.00 96.00 33.00 32.00 0.00 97.00 -33.00 96.00 33.00 64.00 32.00 65.00 -32.00 96.00 64.00 32.00 32.00 64.00 0.00 161.00 32.00 65.00 64.00 96.00 0.00 97.00 0.00 96.00 33.00 0.00 32.00 32.00 64.00 129.00 32.00 64.00 32.00 96.00 0.00 97.00 -32.00 32.00 -64.00 0.00 0.00 32.00 161.00 -64.00 321.00 -129.00 97.00 -32.00 257.00 -96.00 193.00 0.00 128.00 0.00 65.00 32.00 0.00 32.00 32.00 0.00 64.00 64.00 32.00 97.00 129.00 161.00 0.00 32.00 32.00 32.00 32.00 64.00 32.00 0.00 65.00 65.00 32.00 32.00 -32.00 64.00 32.00 32.00 0.00 32.00 64.00 97.00 0.00 64.00 97.00 64.00 0.00 161.00 32.00 32.00 32.00 65.00 128.00 321.00 161.00 418.00 322.00 -64.00 321.00 128.00 65.00 0.00 160.00 65.00 97.00 32.00 161.00 96.00 385.00 225.00 33.00 33.00 0.00 64.00 -33.00 32.00 0.00 32.00 65.00 0.00 32.00 193.00 64.00 450.00 32.00 290.00 0.00 96.00 0.00 64.00 -32.00 225.00 32.00 65.00 -64.00 289.00 -96.00 161.00 32.00 96.00 32.00 225.00 32.00 65.00 0.00 128.00 -96.00 161.00 -33.00 97.00 -64.00 128.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 322.00 32.00 32.00 0.00 129.00 0.00 64.00 -32.00 64.00 -97.00 97.00 -32.00 0.00 -96.00 161.00 -32.00 96.00 -97.00 193.00 -96.00 64.00 0.00 32.00 -32.00 0.00 -33.00 -32.00 0.00 32.00 0.00 32.00 0.00 33.00 -32.00 64.00 32.00 0.00 0.00 64.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 65.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -33.00 386.00 -289.00 0.00 -193.00 0.00 -161.00 32.00 -64.00 32.00 -321.00 64.00 -161.00 65.00 -225.00 160.00 -32.00 32.00 -33.00 0.00 -128.00 129.00 -65.00 129.00 -96.00 193.00 -32.00 257.00 -32.00 96.00 -97.00 129.00 -96.00 289.00 -64.00 129.00 -97.00 193.00 -96.00 193.00 -97.00 96.00 -128.00 97.00 -97.00 96.00 -96.00 129.00 -354.00 257.00 -193.00 96.00 -161.00 33.00 -418.00 128.00 -64.00 0.00 -64.00 32.00 -193.00 161.00 -32.00 32.00 -97.00 129.00 0.00 32.00 -32.00 0.00 -97.00 129.00 -32.00 32.00 -64.00 96.00 -96.00 97.00 -97.00 64.00 -32.00 0.00 -96.00 64.00 -290.00 33.00 -193.00 64.00 -161.00 257.00 -64.00 129.00 -128.00 160.00 -65.00 97.00 -96.00 96.00 -32.00 33.00 -65.00 96.00 -32.00 64.00 0.00 32.00 -32.00 258.00 -225.00 225.00 -64.00 64.00 -65.00 225.00 -96.00 193.00 -161.00 161.00 -129.00 96.00 -64.00 65.00 -193.00 225.00 -128.00 128.00 -322.00 547.00 -32.00 32.00 -32.00 64.00 -32.00 33.00 0.00 32.00 0.00 128.00 -33.00 322.00 0.00 161.00 -32.00 0.00 32.00 353.00 33.00 97.00 0.00 96.00 -33.00 64.00 -64.00 97.00 -353.00 354.00 -129.00 96.00 -386.00 32.00 -32.00 -32.00 -129.00 -128.00 -64.00 32.00 -64.00 128.00 0.00 32.00 -32.00 -32.00 -33.00 0.00 0.00 -32.00 0.00 -128.00 0.00 -33.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 32.00 161.00 -32.00 32.00 0.00 32.00 -97.00 -32.00 -128.00 32.00 -65.00 33.00 -64.00 32.00 0.00 32.00 32.00 32.00 64.00 64.00 0.00 32.00 -32.00 65.00 -96.00 32.00 -129.00 -64.00 -32.00 0.00 -32.00 -33.00 0.00 -64.00 32.00 -96.00 -64.00 -161.00 0.00 -32.00 -129.00 0.00 -64.00 -64.00 -64.00 0.00 -226.00 0.00 -64.00 -33.00 -193.00 0.00 -128.00 -64.00 -129.00 0.00 -96.00 -225.00 -33.00 -32.00 -128.00 -32.00 -65.00 -65.00 -96.00 65.00 -32.00 -33.00 -32.00 -32.00 64.00 -64.00 32.00 -96.00 -32.00 -33.00 0.00 -160.00 -96.00 -97.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 -33.00 64.00 0.00 32.00 0.00 32.00 -128.00 -32.00 -65.00 -64.00 -96.00 -64.00 -32.00 -65.00 -64.00 -32.00 -33.00 -64.00 65.00 -32.00 0.00 -97.00 32.00 -96.00 32.00 -64.00 0.00 -65.00 0.00 32.00 -64.00 129.00 -161.00 -64.00 -32.00 0.00 -64.00 0.00 -65.00 96.00 -161.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -97.00 -32.00 -64.00 -32.00 -64.00 0.00 -33.00 0.00 -96.00 0.00 -96.00 -32.00 -161.00 -65.00 -65.00 -160.00 0.00 -129.00 33.00 -96.00 64.00 -65.00 0.00 -64.00 -32.00 -129.00 -193.00 0.00 -32.00 0.00 -65.00 -64.00 -64.00 -64.00 -96.00 32.00 -97.00 -64.00 -64.00 128.00 -193.00 -32.00 -32.00 -64.00 -129.00 0.00 -96.00 64.00 -129.00 0.00 -129.00 -32.00 -64.00 -64.00 -64.00 -65.00 0.00 -96.00 -64.00 -64.00 -65.00 -33.00 -128.00 -353.00 -258.00 -32.00 -64.00 -33.00 -64.00 -32.00 -32.00 -96.00 -33.00 -129.00 33.00 -128.00 -33.00 -33.00 -32.00 -128.00 -353.00 -32.00 -129.00 -32.00 -161.00 0.00 -160.00 -33.00 -33.00 -96.00 -64.00 -64.00 -64.00 32.00 -193.00 -97.00 -32.00 -32.00 -65.00 0.00 -96.00 -32.00 -32.00 -32.00 -65.00 -97.00 -64.00 -64.00 -96.00 -64.00 -32.00 -32.00 -161.00 32.00 -97.00 32.00 -32.00 -97.00 -161.00 -96.00 -64.00 -32.00 -129.00 -32.00 -96.00 -97.00 -64.00 -32.00 -97.00 64.00 -96.00 0.00 -32.00 0.00 -65.00 -32.00 -128.00 65.00 -161.00 -33.00 -32.00 -64.00 -32.00 64.00 -97.00 -32.00 -32.00 65.00 -64.00 32.00 -32.00 0.00 -65.00 -32.00 -64.00 0.00 -64.00 32.00 -97.00 128.00 -161.00 32.00 -193.00 33.00 -32.00 0.00 -32.00 -97.00 -64.00 -64.00 32.00 -32.00 -32.00 -32.00 -97.00 -33.00 -64.00 -128.00 -96.00 -32.00 -97.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 -193.00 -129.00 -96.00 -64.00 -65.00 -129.00 -64.00 -64.00 -257.00 -129.00 -32.00 -32.00 -225.00 -160.00 -32.00 -97.00 32.00 -32.00 0.00 -129.00 -32.00 -32.00 -33.00 -32.00 -32.00 -97.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -64.00 -32.00 0.00 0.00 -65.00 -64.00 -64.00 -32.00 -32.00 0.00 -161.00 0.00 -64.00 0.00 -64.00 64.00 -65.00 32.00 0.00 64.00 32.00 65.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -96.00 -32.00 -65.00 -64.00 -64.00 -33.00 -96.00 0.00 -97.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -161.00 -32.00 -257.00 129.00 -64.00 0.00 -32.00 -64.00 0.00 -33.00 64.00 -64.00 32.00 -96.00 -32.00 -65.00 -96.00 -32.00 -33.00 0.00 0.00 -128.00 65.00 -33.00 64.00 -32.00 -32.00 -96.00 -32.00 -32.00 -97.00 0.00 0.00 32.00 -32.00 32.00 -96.00 -96.00 -193.00 32.00 -33.00 64.00 -64.00 0.00 -32.00 -64.00 64.00 -32.00 32.00 -33.00 -32.00 -96.00 32.00 -64.00 -32.00 -65.00 -64.00 32.00 -32.00 129.00 -64.00 0.00 0.00 -32.00 -33.00 -32.00 -64.00 64.00 -32.00 -32.00 -32.00 -64.00 96.00 -97.00 0.00 -32.00 -96.00 -64.00 -32.00 32.00 32.00 64.00 0.00 32.00 -64.00 65.00 0.00 32.00 -129.00 -32.00 -32.00 -65.00 -32.00 65.00 -33.00 0.00 -32.00 -33.00 -32.00 -64.00 -64.00 -32.00 -65.00 0.00 -32.00 32.00 65.00 64.00 32.00 33.00 -32.00 32.00 -65.00 0.00 -32.00 -32.00 -96.00 32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 -64.00 32.00 -97.00 -32.00 -32.00 32.00 0.00 -32.00 32.00 -128.00 0.00 -32.00 -64.00 0.00 -32.00 -65.00 -97.00 0.00 0.00 65.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 -64.00 -32.00 0.00 -64.00 -32.00 -33.00 32.00 0.00 -64.00 -64.00 -33.00 -32.00 65.00 -64.00 -32.00 -65.00 32.00 0.00 -65.00 0.00 -96.00 -32.00 -64.00 -64.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 -65.00 -32.00 -64.00 64.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 32.00 32.00 -65.00 0.00 0.00 -32.00 33.00 -64.00 -33.00 -32.00 33.00 -64.00 -65.00 -129.00 -96.00 0.00 0.00 -32.00 32.00 -65.00 32.00 -64.00 0.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 -64.00 -33.00 0.00 0.00 -32.00 33.00 0.00 0.00 -32.00 -65.00 -65.00 32.00 -32.00 -64.00 0.00 0.00 -64.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 0.00 0.00 -65.00 -32.00 0.00 -32.00 65.00 0.00 96.00 -32.00 -32.00 -32.00 -96.00 -65.00 -33.00 -64.00 -32.00 0.00 -64.00 -64.00 0.00 -32.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 32.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 32.00 -32.00 32.00 -32.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 32.00 -32.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -64.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -33.00 -128.00 -64.00 -32.00 97.00 -65.00 -65.00 -64.00 0.00 -32.00 0.00 -64.00 32.00 -129.00 -32.00 -32.00 0.00 0.00 32.00 -64.00 -32.00 0.00 32.00 -65.00 33.00 -32.00 -33.00 -32.00 0.00 -64.00 -32.00 -33.00 -32.00 -32.00 -32.00 -161.00 -32.00 0.00 -32.00 -64.00 32.00 -96.00 -32.00 -32.00 32.00 -65.00 -32.00 -96.00 64.00 -32.00 0.00 -97.00 32.00 -32.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 32.00 -97.00 0.00 -129.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 -32.00 -64.00 97.00 -65.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 -32.00 -32.00 0.00 -129.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -161.00 32.00 0.00 32.00 -64.00 0.00 -33.00 32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -64.00 0.00 32.00 -64.00 -64.00 -33.00 -32.00 -32.00 -33.00 -32.00 -32.00 -64.00 -32.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 32.00 0.00 -32.00 -129.00 64.00 -32.00 -32.00 -64.00 32.00 -65.00 -32.00 -32.00 32.00 0.00 0.00 -64.00 65.00 -32.00 32.00 -32.00 0.00 -33.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -65.00 -32.00 -32.00 -97.00 -96.00 -32.00 -97.00 0.00 -96.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 32.00 0.00 -32.00 -96.00 -32.00 -65.00 -257.00 -289.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 32.00 -33.00z"},to:{name:"TO",path:"M115835.00 83244.00l64.00 -128.00 0.00 -129.00 65.00 -128.00 32.00 -97.00 0.00 -64.00 32.00 -65.00 32.00 -32.00 64.00 -64.00 65.00 -32.00 32.00 -193.00 32.00 -129.00 -32.00 -96.00 0.00 -64.00 -32.00 -129.00 32.00 -96.00 0.00 -65.00 64.00 -32.00 32.00 -96.00 97.00 -65.00 0.00 -32.00 32.00 -64.00 0.00 -129.00 -32.00 -64.00 0.00 -129.00 -32.00 -96.00 32.00 -64.00 -65.00 -161.00 65.00 -97.00 96.00 -96.00 0.00 -65.00 -32.00 -64.00 -64.00 -32.00 0.00 -129.00 0.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -65.00 97.00 -161.00 -32.00 -96.00 0.00 -64.00 -33.00 -65.00 0.00 -96.00 -96.00 -64.00 0.00 -65.00 96.00 -96.00 65.00 -97.00 32.00 -64.00 64.00 0.00 32.00 0.00 33.00 -32.00 32.00 -97.00 64.00 -96.00 -32.00 -97.00 32.00 -96.00 0.00 -96.00 96.00 -33.00 33.00 0.00 32.00 -32.00 -32.00 -96.00 64.00 -322.00 128.00 -64.00 33.00 -64.00 96.00 -65.00 32.00 -32.00 -32.00 -96.00 0.00 -32.00 97.00 -225.00 32.00 -161.00 64.00 -161.00 -32.00 -225.00 -32.00 0.00 0.00 -32.00 32.00 -161.00 64.00 -129.00 65.00 -64.00 32.00 -96.00 64.00 -65.00 129.00 -64.00 64.00 -64.00 32.00 -97.00 0.00 -128.00 64.00 -97.00 0.00 -64.00 65.00 -97.00 0.00 -128.00 96.00 -193.00 97.00 -97.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -96.00 32.00 -97.00 32.00 -161.00 193.00 -225.00 0.00 -64.00 32.00 -32.00 0.00 -97.00 65.00 -96.00 0.00 -129.00 64.00 -32.00 32.00 -64.00 32.00 -65.00 0.00 -96.00 32.00 -64.00 65.00 -65.00 -33.00 -96.00 -64.00 -97.00 0.00 -32.00 32.00 0.00 0.00 -64.00 0.00 -64.00 65.00 -225.00 128.00 -129.00 32.00 -129.00 0.00 -32.00 0.00 -128.00 0.00 -33.00 33.00 -128.00 0.00 -32.00 64.00 -65.00 64.00 -64.00 97.00 -32.00 32.00 -193.00 128.00 0.00 129.00 -161.00 161.00 -128.00 0.00 -33.00 0.00 -64.00 32.00 -32.00 129.00 -193.00 64.00 -128.00 32.00 -97.00 0.00 -64.00 32.00 -97.00 257.00 -225.00 33.00 -96.00 64.00 -129.00 64.00 -64.00 64.00 -97.00 65.00 -32.00 225.00 -193.00 193.00 -64.00 128.00 0.00 97.00 -32.00 32.00 -65.00 96.00 -128.00 129.00 -193.00 225.00 -322.00 64.00 -96.00 33.00 -129.00 64.00 -64.00 32.00 -96.00 193.00 -161.00 64.00 -97.00 0.00 -64.00 32.00 -289.00 33.00 -65.00 32.00 -96.00 128.00 -193.00 33.00 0.00 128.00 -64.00 97.00 -65.00 64.00 -64.00 64.00 -161.00 32.00 -96.00 33.00 -257.00 96.00 -193.00 64.00 -129.00 32.00 -64.00 33.00 -97.00 32.00 -160.00 -32.00 -97.00 32.00 -64.00 0.00 -97.00 32.00 -32.00 0.00 -32.00 64.00 -32.00 32.00 -64.00 0.00 -161.00 0.00 -64.00 -32.00 -161.00 65.00 -97.00 0.00 -128.00 32.00 -129.00 -32.00 -225.00 0.00 -32.00 0.00 -97.00 32.00 -32.00 32.00 -64.00 0.00 -32.00 -32.00 -65.00 -65.00 -32.00 -128.00 -32.00 -97.00 -64.00 -96.00 -129.00 -97.00 -64.00 -160.00 -129.00 -129.00 -64.00 -64.00 -64.00 -32.00 -65.00 -97.00 -225.00 0.00 -32.00 -96.00 -193.00 0.00 -96.00 32.00 -257.00 64.00 -33.00 64.00 -128.00 129.00 -161.00 193.00 -193.00 64.00 -64.00 0.00 -32.00 65.00 -97.00 96.00 -128.00 96.00 -129.00 33.00 -129.00 96.00 -160.00 32.00 -97.00 -32.00 -128.00 -32.00 -290.00 0.00 -289.00 0.00 -32.00 0.00 -129.00 0.00 -64.00 -64.00 -225.00 -33.00 -33.00 0.00 -64.00 0.00 -96.00 33.00 -65.00 96.00 -96.00 32.00 -64.00 32.00 0.00 97.00 -33.00 193.00 -96.00 128.00 -129.00 193.00 -128.00 65.00 -65.00 64.00 -96.00 225.00 0.00 129.00 -64.00 64.00 -33.00 64.00 -32.00 193.00 -32.00 129.00 0.00 32.00 0.00 64.00 0.00 64.00 0.00 161.00 -64.00 32.00 0.00 65.00 -64.00 96.00 -161.00 257.00 -64.00 97.00 -65.00 32.00 -64.00 32.00 -64.00 0.00 -129.00 -64.00 -193.00 0.00 -64.00 32.00 -97.00 64.00 -64.00 0.00 -96.00 65.00 -97.00 32.00 -32.00 64.00 -129.00 225.00 -193.00 64.00 -32.00 97.00 -96.00 32.00 -65.00 64.00 -96.00 32.00 -32.00 258.00 0.00 96.00 32.00 129.00 96.00 64.00 33.00 32.00 -33.00 32.00 -128.00 -32.00 -97.00 -32.00 -32.00 -64.00 -32.00 -64.00 -32.00 -33.00 -64.00 0.00 -32.00 33.00 -33.00 -33.00 -64.00 -32.00 -161.00 -32.00 -96.00 0.00 -97.00 0.00 -96.00 64.00 -64.00 65.00 -65.00 64.00 -32.00 129.00 32.00 160.00 -64.00 129.00 -96.00 64.00 -65.00 32.00 -96.00 0.00 -65.00 -96.00 -128.00 -129.00 -32.00 -32.00 -32.00 0.00 -65.00 32.00 -64.00 65.00 -97.00 64.00 -64.00 64.00 -32.00 193.00 -32.00 97.00 -64.00 0.00 -97.00 0.00 -32.00 -65.00 -97.00 0.00 -32.00 -128.00 -128.00 -65.00 -97.00 -32.00 -32.00 0.00 -32.00 -32.00 -225.00 0.00 -32.00 0.00 -129.00 32.00 -64.00 32.00 -65.00 65.00 -32.00 225.00 32.00 96.00 -32.00 32.00 0.00 33.00 -32.00 64.00 -32.00 64.00 -96.00 97.00 -193.00 32.00 -65.00 0.00 -96.00 0.00 -64.00 -193.00 -129.00 -64.00 -32.00 -33.00 -32.00 -64.00 -65.00 -96.00 0.00 -161.00 -32.00 -64.00 -32.00 -65.00 -32.00 -32.00 -32.00 -96.00 -129.00 -33.00 -32.00 0.00 32.00 0.00 -64.00 -64.00 -97.00 -32.00 -64.00 0.00 -64.00 0.00 -32.00 -64.00 -65.00 -32.00 -32.00 -33.00 -64.00 -64.00 -32.00 -32.00 0.00 -32.00 64.00 -97.00 -32.00 -96.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 -96.00 32.00 -65.00 0.00 -225.00 -32.00 -160.00 0.00 -65.00 0.00 -128.00 -32.00 -65.00 -129.00 -32.00 0.00 -128.00 -32.00 -193.00 0.00 0.00 -32.00 -65.00 0.00 -64.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 97.00 32.00 32.00 -32.00 32.00 -129.00 32.00 -32.00 65.00 -32.00 128.00 32.00 64.00 32.00 33.00 64.00 96.00 32.00 32.00 -32.00 97.00 -96.00 64.00 -161.00 0.00 -96.00 32.00 -97.00 0.00 -64.00 97.00 -129.00 96.00 -64.00 161.00 32.00 96.00 -64.00 483.00 -65.00 64.00 33.00 161.00 128.00 128.00 0.00 97.00 64.00 128.00 65.00 65.00 32.00 32.00 0.00 64.00 64.00 97.00 32.00 64.00 33.00 321.00 32.00 129.00 32.00 161.00 -32.00 161.00 -161.00 32.00 0.00 64.00 0.00 161.00 32.00 96.00 0.00 32.00 0.00 226.00 97.00 32.00 64.00 32.00 96.00 0.00 33.00 0.00 32.00 0.00 160.00 128.00 161.00 65.00 64.00 160.00 0.00 129.00 -32.00 129.00 0.00 257.00 161.00 96.00 32.00 225.00 193.00 193.00 65.00 65.00 -33.00 32.00 0.00 289.00 290.00 65.00 193.00 0.00 160.00 32.00 129.00 0.00 64.00 0.00 129.00 -65.00 225.00 -32.00 96.00 65.00 129.00 64.00 64.00 128.00 290.00 33.00 161.00 32.00 32.00 0.00 321.00 -97.00 290.00 65.00 96.00 32.00 129.00 0.00 32.00 0.00 96.00 -32.00 129.00 32.00 129.00 64.00 289.00 64.00 161.00 65.00 96.00 32.00 97.00 0.00 96.00 0.00 64.00 -129.00 258.00 0.00 32.00 -32.00 160.00 -32.00 129.00 -32.00 129.00 -32.00 32.00 96.00 257.00 -32.00 64.00 -32.00 0.00 -129.00 193.00 0.00 65.00 -32.00 32.00 0.00 128.00 0.00 97.00 0.00 32.00 -64.00 96.00 -97.00 193.00 32.00 97.00 -32.00 32.00 0.00 64.00 0.00 225.00 -96.00 161.00 -65.00 193.00 0.00 32.00 33.00 0.00 0.00 32.00 64.00 161.00 32.00 97.00 -32.00 64.00 -97.00 193.00 0.00 128.00 -32.00 65.00 -32.00 96.00 0.00 32.00 -32.00 65.00 -129.00 128.00 -64.00 32.00 -129.00 161.00 -32.00 129.00 -96.00 128.00 -64.00 33.00 -65.00 -33.00 -96.00 -32.00 -65.00 0.00 -32.00 32.00 -160.00 97.00 0.00 32.00 0.00 97.00 0.00 64.00 64.00 64.00 193.00 97.00 96.00 96.00 97.00 225.00 32.00 0.00 32.00 0.00 64.00 0.00 97.00 -161.00 64.00 -32.00 225.00 0.00 32.00 32.00 193.00 129.00 65.00 129.00 32.00 64.00 -32.00 161.00 -129.00 64.00 0.00 32.00 -257.00 97.00 -65.00 32.00 -64.00 128.00 129.00 32.00 64.00 -32.00 96.00 -32.00 65.00 0.00 64.00 0.00 0.00 64.00 32.00 161.00 65.00 65.00 0.00 160.00 32.00 32.00 32.00 0.00 32.00 -64.00 129.00 0.00 32.00 32.00 32.00 32.00 0.00 33.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 64.00 32.00 32.00 0.00 33.00 32.00 -33.00 65.00 97.00 64.00 0.00 96.00 -32.00 65.00 0.00 32.00 32.00 64.00 64.00 32.00 64.00 -64.00 0.00 -32.00 -64.00 0.00 -32.00 -64.00 0.00 -33.00 64.00 0.00 32.00 0.00 33.00 65.00 64.00 32.00 64.00 64.00 32.00 32.00 -32.00 33.00 -32.00 0.00 -64.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 161.00 32.00 0.00 64.00 -32.00 0.00 -33.00 -32.00 0.00 32.00 33.00 33.00 -33.00 32.00 0.00 64.00 33.00 0.00 32.00 32.00 32.00 -32.00 64.00 32.00 32.00 -32.00 0.00 32.00 0.00 32.00 65.00 0.00 0.00 33.00 -33.00 64.00 33.00 -32.00 32.00 0.00 32.00 0.00 -32.00 32.00 32.00 96.00 32.00 65.00 -32.00 32.00 64.00 0.00 -64.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 0.00 32.00 32.00 32.00 33.00 33.00 64.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 64.00 -32.00 0.00 64.00 32.00 0.00 0.00 32.00 0.00 32.00 65.00 65.00 32.00 32.00 0.00 32.00 64.00 0.00 0.00 96.00 0.00 65.00 64.00 -32.00 33.00 0.00 32.00 96.00 32.00 -32.00 -32.00 96.00 32.00 32.00 32.00 -32.00 0.00 32.00 0.00 33.00 -32.00 0.00 64.00 64.00 -64.00 32.00 129.00 0.00 96.00 97.00 0.00 96.00 64.00 32.00 -32.00 32.00 65.00 32.00 0.00 33.00 96.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 0.00 0.00 32.00 33.00 0.00 32.00 -97.00 32.00 33.00 0.00 -33.00 96.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -64.00 0.00 -32.00 33.00 0.00 32.00 -65.00 64.00 0.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 0.00 33.00 32.00 32.00 0.00 32.00 -64.00 32.00 0.00 0.00 -65.00 64.00 -32.00 0.00 32.00 32.00 33.00 33.00 -33.00 32.00 -32.00 32.00 65.00 32.00 0.00 0.00 -33.00 32.00 0.00 97.00 -32.00 32.00 -32.00 32.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 0.00 32.00 32.00 0.00 32.00 -96.00 32.00 32.00 32.00 -32.00 32.00 0.00 33.00 0.00 32.00 -33.00 32.00 0.00 32.00 -32.00 64.00 32.00 32.00 0.00 65.00 0.00 32.00 -64.00 32.00 0.00 64.00 32.00 33.00 0.00 64.00 -64.00 96.00 0.00 65.00 32.00 0.00 32.00 64.00 0.00 32.00 32.00 64.00 33.00 0.00 32.00 0.00 64.00 65.00 32.00 128.00 64.00 129.00 97.00 32.00 64.00 0.00 32.00 32.00 33.00 0.00 32.00 0.00 128.00 0.00 65.00 65.00 64.00 0.00 64.00 -33.00 32.00 -64.00 0.00 -32.00 65.00 0.00 64.00 -97.00 257.00 0.00 32.00 0.00 33.00 65.00 32.00 64.00 64.00 -32.00 32.00 -64.00 64.00 -33.00 97.00 33.00 161.00 -65.00 96.00 -64.00 64.00 -64.00 65.00 -65.00 32.00 -96.00 0.00 -64.00 32.00 -65.00 0.00 -128.00 -64.00 -129.00 64.00 -64.00 32.00 -65.00 32.00 -96.00 33.00 -32.00 64.00 -32.00 32.00 -32.00 64.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -97.00 -32.00 0.00 32.00 0.00 32.00 -32.00 0.00 32.00 65.00 -64.00 32.00 -32.00 -32.00 32.00 96.00 0.00 32.00 0.00 32.00 -32.00 65.00 32.00 32.00 -96.00 96.00 -33.00 32.00 -32.00 -64.00 -32.00 32.00 0.00 32.00 -64.00 0.00 0.00 65.00 32.00 64.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 33.00 32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 0.00 32.00 -33.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 32.00 33.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 0.00 -32.00 0.00 64.00 -32.00 -32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 32.00 0.00 0.00 32.00 33.00 -32.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 33.00 -32.00 0.00 0.00 32.00 -33.00 0.00 0.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 65.00 32.00 32.00 0.00 -32.00 33.00 64.00 0.00 -32.00 32.00 32.00 32.00 32.00 64.00 -32.00 32.00 -32.00 0.00 -65.00 65.00 0.00 96.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 97.00 32.00 32.00 0.00 64.00 32.00 0.00 0.00 32.00 33.00 0.00 32.00 97.00 -32.00 32.00 0.00 96.00 -33.00 32.00 33.00 33.00 -33.00 32.00 -32.00 0.00 0.00 32.00 32.00 32.00 -32.00 32.00 -96.00 0.00 -65.00 65.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 32.00 64.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 65.00 -64.00 32.00 0.00 32.00 -64.00 32.00 0.00 32.00 -65.00 32.00 -32.00 0.00 -32.00 33.00 32.00 64.00 0.00 32.00 -32.00 32.00 0.00 32.00 -64.00 0.00 0.00 -32.00 0.00 32.00 -32.00 65.00 0.00 32.00 -97.00 0.00 -32.00 32.00 64.00 32.00 32.00 -32.00 0.00 32.00 33.00 0.00 0.00 32.00 -65.00 32.00 0.00 33.00 0.00 32.00 -32.00 0.00 32.00 32.00 -64.00 0.00 0.00 32.00 96.00 64.00 0.00 -32.00 65.00 0.00 64.00 32.00 64.00 -32.00 -32.00 65.00 32.00 0.00 32.00 0.00 0.00 -33.00 65.00 0.00 64.00 33.00 161.00 -65.00 96.00 0.00 32.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 64.00 -32.00 0.00 32.00 65.00 32.00 0.00 65.00 0.00 32.00 -32.00 32.00 -33.00 0.00 33.00 0.00 64.00 32.00 0.00 129.00 32.00 32.00 32.00 32.00 64.00 -32.00 97.00 0.00 32.00 64.00 32.00 64.00 -32.00 0.00 32.00 33.00 65.00 -33.00 64.00 -32.00 64.00 65.00 97.00 -33.00 32.00 -32.00 32.00 0.00 32.00 -64.00 32.00 0.00 32.00 0.00 33.00 32.00 64.00 97.00 -32.00 32.00 0.00 0.00 64.00 64.00 96.00 64.00 65.00 32.00 32.00 33.00 32.00 64.00 97.00 -32.00 96.00 0.00 32.00 96.00 32.00 0.00 -32.00 32.00 -32.00 65.00 -32.00 128.00 0.00 97.00 -32.00 32.00 0.00 64.00 64.00 97.00 32.00 -32.00 32.00 -33.00 65.00 0.00 64.00 33.00 32.00 64.00 64.00 64.00 0.00 64.00 33.00 33.00 64.00 96.00 -32.00 64.00 32.00 0.00 64.00 -64.00 64.00 0.00 33.00 64.00 96.00 0.00 32.00 97.00 32.00 0.00 33.00 -193.00 128.00 -64.00 32.00 0.00 97.00 -65.00 96.00 0.00 129.00 -32.00 64.00 -193.00 129.00 32.00 128.00 0.00 65.00 33.00 32.00 0.00 32.00 64.00 0.00 161.00 0.00 96.00 64.00 32.00 65.00 -32.00 32.00 -32.00 96.00 0.00 32.00 96.00 33.00 97.00 0.00 128.00 -65.00 33.00 65.00 64.00 64.00 -32.00 96.00 32.00 0.00 64.00 65.00 -64.00 32.00 0.00 32.00 96.00 32.00 0.00 97.00 -32.00 32.00 0.00 96.00 65.00 64.00 -65.00 65.00 32.00 128.00 -32.00 65.00 97.00 128.00 0.00 161.00 32.00 32.00 32.00 97.00 96.00 32.00 33.00 0.00 160.00 193.00 65.00 225.00 96.00 32.00 97.00 64.00 64.00 -64.00 64.00 32.00 129.00 0.00 161.00 -32.00 128.00 -32.00 64.00 32.00 33.00 32.00 32.00 32.00 96.00 129.00 129.00 -32.00 193.00 32.00 225.00 -161.00 64.00 -32.00 32.00 0.00 32.00 32.00 33.00 289.00 64.00 97.00 32.00 -32.00 97.00 -32.00 128.00 64.00 97.00 -32.00 225.00 -65.00 193.00 97.00 225.00 32.00 225.00 -129.00 64.00 -64.00 32.00 -96.00 -32.00 -97.00 -32.00 -64.00 64.00 -97.00 32.00 65.00 97.00 0.00 0.00 64.00 -32.00 32.00 32.00 129.00 0.00 128.00 0.00 97.00 0.00 32.00 -32.00 32.00 -32.00 65.00 -65.00 160.00 -64.00 129.00 -64.00 32.00 -193.00 0.00 -65.00 32.00 -64.00 32.00 -32.00 0.00 0.00 33.00 0.00 32.00 -32.00 64.00 64.00 96.00 -32.00 129.00 -32.00 0.00 -161.00 0.00 -96.00 64.00 -65.00 65.00 -32.00 64.00 -193.00 129.00 -64.00 32.00 -32.00 96.00 -65.00 0.00 -64.00 32.00 -96.00 0.00 -33.00 32.00 -32.00 129.00 -128.00 32.00 0.00 97.00 -32.00 32.00 -65.00 32.00 -96.00 -32.00 -97.00 96.00 -96.00 0.00 -97.00 33.00 -32.00 -33.00 -96.00 33.00 0.00 32.00 -65.00 32.00 -64.00 32.00 0.00 32.00 32.00 32.00 65.00 97.00 32.00 32.00 0.00 32.00 -32.00 129.00 -97.00 64.00 -193.00 129.00 32.00 0.00 97.00 32.00 0.00 128.00 -32.00 65.00 -65.00 32.00 -128.00 64.00 -32.00 32.00 -32.00 65.00 -33.00 96.00 0.00 32.00 65.00 129.00 0.00 32.00 -161.00 96.00 -64.00 97.00 -161.00 96.00 -32.00 33.00 -33.00 64.00 -96.00 64.00 -32.00 0.00 0.00 97.00 -97.00 96.00 -96.00 257.00 -32.00 322.00 -97.00 161.00 -64.00 96.00 -64.00 0.00 -386.00 193.00 -129.00 32.00 32.00 64.00 -32.00 97.00 -32.00 0.00 0.00 64.00 32.00 32.00 0.00 65.00 32.00 128.00 65.00 97.00 96.00 32.00 32.00 0.00 65.00 32.00 0.00 129.00 0.00 32.00 96.00 64.00 0.00 32.00 0.00 161.00 32.00 96.00 32.00 33.00 33.00 32.00 96.00 32.00 32.00 64.00 32.00 0.00 65.00 0.00 64.00 0.00 96.00 32.00 33.00 65.00 32.00 32.00 32.00 0.00 64.00 -32.00 32.00 0.00 97.00 0.00 64.00 32.00 161.00 -32.00 129.00 64.00 96.00 32.00 32.00 0.00 64.00 32.00 65.00 0.00 64.00 65.00 0.00 32.00 32.00 64.00 64.00 32.00 65.00 32.00 32.00 -32.00 64.00 -32.00 32.00 64.00 97.00 0.00 64.00 -32.00 32.00 32.00 97.00 33.00 32.00 0.00 32.00 32.00 0.00 64.00 0.00 32.00 -225.00 32.00 -96.00 32.00 -97.00 -32.00 -64.00 32.00 -161.00 -64.00 -161.00 -96.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -65.00 -32.00 -64.00 32.00 0.00 64.00 32.00 64.00 32.00 33.00 32.00 96.00 0.00 64.00 -64.00 33.00 -96.00 160.00 -161.00 65.00 -65.00 32.00 33.00 32.00 96.00 -32.00 64.00 64.00 65.00 32.00 0.00 32.00 -65.00 33.00 0.00 32.00 33.00 32.00 -33.00 64.00 -64.00 32.00 0.00 32.00 0.00 33.00 -32.00 32.00 -64.00 -32.00 -33.00 32.00 33.00 64.00 -33.00 64.00 65.00 97.00 64.00 -32.00 32.00 32.00 65.00 64.00 64.00 0.00 129.00 -64.00 96.00 32.00 64.00 32.00 65.00 32.00 128.00 -32.00 64.00 -64.00 65.00 0.00 32.00 0.00 32.00 64.00 0.00 64.00 -96.00 97.00 -97.00 0.00 -161.00 64.00 -192.00 32.00 -65.00 0.00 -128.00 32.00 -33.00 65.00 -32.00 32.00 -64.00 32.00 -97.00 97.00 0.00 64.00 -32.00 0.00 -64.00 32.00 0.00 64.00 64.00 65.00 0.00 32.00 32.00 32.00 -64.00 32.00 32.00 64.00 0.00 33.00 65.00 32.00 32.00 64.00 -32.00 64.00 0.00 65.00 -33.00 96.00 0.00 32.00 -64.00 32.00 32.00 33.00 0.00 32.00 0.00 32.00 -32.00 32.00 97.00 32.00 0.00 64.00 32.00 33.00 -32.00 96.00 -65.00 32.00 32.00 0.00 65.00 97.00 -32.00 32.00 -33.00 64.00 97.00 32.00 32.00 0.00 97.00 32.00 32.00 0.00 0.00 33.00 -129.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 32.00 32.00 -32.00 32.00 65.00 65.00 32.00 32.00 0.00 96.00 64.00 33.00 64.00 -33.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 32.00 32.00 33.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 64.00 32.00 65.00 0.00 32.00 -32.00 64.00 0.00 161.00 129.00 32.00 225.00 -96.00 96.00 -33.00 33.00 65.00 -33.00 64.00 33.00 64.00 -33.00 97.00 -193.00 0.00 -128.00 32.00 -97.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 97.00 -32.00 32.00 -32.00 32.00 32.00 64.00 -64.00 161.00 64.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 65.00 -64.00 64.00 -64.00 32.00 -65.00 97.00 33.00 0.00 0.00 32.00 64.00 32.00 32.00 32.00 0.00 129.00 -64.00 32.00 32.00 64.00 0.00 64.00 -32.00 33.00 0.00 64.00 0.00 64.00 32.00 32.00 32.00 33.00 32.00 64.00 -64.00 64.00 -97.00 65.00 65.00 96.00 -32.00 64.00 -33.00 65.00 0.00 64.00 -32.00 161.00 97.00 -33.00 32.00 -64.00 32.00 0.00 225.00 32.00 96.00 -64.00 65.00 0.00 225.00 -96.00 64.00 32.00 65.00 32.00 -33.00 32.00 -128.00 64.00 -65.00 -32.00 -96.00 32.00 0.00 32.00 -32.00 33.00 -32.00 32.00 -129.00 0.00 -96.00 32.00 0.00 -32.00 -161.00 64.00 -32.00 -32.00 -32.00 32.00 -97.00 32.00 -129.00 0.00 0.00 32.00 -128.00 33.00 -65.00 -33.00 33.00 -64.00 -33.00 -32.00 33.00 -32.00 0.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 -96.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -64.00 -65.00 -32.00 0.00 -65.00 0.00 32.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 -65.00 546.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 129.00 -129.00 0.00 -739.00 0.00 -547.00 -32.00 -321.00 193.00 -33.00 0.00 33.00 32.00 -65.00 32.00 0.00 64.00 -32.00 0.00 -32.00 65.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 -97.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 64.00 -65.00 32.00 -64.00 65.00 0.00 32.00 -96.00 32.00 -33.00 64.00 -64.00 0.00 -64.00 65.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 32.00 0.00 64.00 -64.00 0.00 -64.00 32.00 -32.00 0.00 -33.00 32.00 -64.00 33.00 -32.00 -33.00 0.00 33.00 -64.00 0.00 0.00 32.00 0.00 32.00 -33.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 0.00 -64.00 -32.00 32.00 -65.00 0.00 -64.00 64.00 32.00 0.00 0.00 64.00 -64.00 33.00 -64.00 -33.00 -32.00 33.00 -65.00 -33.00 32.00 -32.00 -32.00 -32.00 -64.00 32.00 -64.00 -32.00 -32.00 32.00 -33.00 0.00 -32.00 0.00 0.00 32.00 -96.00 33.00 32.00 96.00 -32.00 32.00 -65.00 0.00 0.00 65.00 -32.00 0.00 -32.00 64.00 -64.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -97.00 0.00 -32.00 32.00 -96.00 -32.00 -65.00 0.00 -64.00 -65.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 33.00 0.00 64.00 -97.00 32.00 -32.00 96.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -97.00 -96.00 32.00 -33.00 97.00 -32.00 -32.00 -32.00 -65.00 -32.00 -64.00 32.00 -129.00 -32.00 0.00 -64.00 65.00 -129.00 -65.00 0.00 -64.00 32.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 -64.00 32.00 -96.00 -32.00 -32.00 -161.00 32.00 -128.00 -32.00 -33.00 -97.00 0.00 -129.00 -64.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 33.00 0.00 32.00 -32.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 33.00 -65.00 32.00 97.00 32.00 -32.00 64.00 -33.00 32.00 33.00 0.00 -33.00 32.00 33.00 33.00 -33.00 0.00 0.00 32.00 65.00 32.00 0.00 32.00 -32.00 32.00 64.00 32.00 0.00 33.00 32.00 64.00 -64.00 64.00 -32.00 0.00 0.00 97.00 0.00 32.00 32.00 64.00 -32.00 32.00 32.00 97.00 0.00 64.00 64.00 64.00 64.00 0.00 0.00 97.00 -32.00 32.00 -32.00 0.00 -32.00 64.00 -32.00 32.00 -32.00 65.00 -33.00 32.00 -32.00 64.00 -32.00 97.00 -579.00 -643.00 0.00 -33.00 -96.00 -64.00 -97.00 32.00 -96.00 -32.00 -32.00 32.00 -64.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 -64.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 -33.00 -32.00 97.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -97.00 -64.00 0.00 -97.00 32.00 -32.00 -64.00 -32.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 -96.00 0.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 32.00 32.00 129.00 -32.00 0.00 0.00 32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -32.00 33.00 -33.00 -33.00 -32.00 33.00 -32.00 -33.00 0.00 33.00 -96.00 32.00 -33.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 64.00 -97.00 0.00 -160.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -64.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 33.00 0.00 32.00 -64.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 -33.00 0.00 0.00 32.00 -32.00 32.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -32.00 33.00 0.00 -65.00 0.00 32.00 -33.00 0.00 -32.00 0.00 0.00 65.00 0.00 32.00 -96.00 32.00 32.00 0.00 -32.00 0.00 32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 -64.00 0.00 32.00 32.00 -32.00 32.00 32.00 33.00 -32.00 0.00 -32.00 -33.00 -32.00 0.00 -32.00 33.00 -33.00 0.00 0.00 32.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 33.00 -32.00 -65.00 -65.00 0.00 0.00 -96.00 33.00 0.00 -33.00 -32.00 0.00 -32.00 33.00 0.00 -65.00 -33.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -97.00 0.00 -32.00 -32.00 -32.00 0.00 64.00 -32.00 0.00 -32.00 -32.00 -65.00 -32.00 -64.00 64.00 0.00 129.00 -32.00 64.00 0.00 32.00 -64.00 32.00 -65.00 32.00 0.00 97.00 32.00 32.00 -32.00 32.00 0.00 97.00 -32.00 96.00 32.00 32.00 0.00 97.00 -64.00 64.00 -32.00 0.00 -32.00 0.00 -97.00 -96.00 32.00 -65.00 33.00 -96.00 0.00 -32.00 -33.00 -32.00 -32.00 -65.00 32.00 0.00 65.00 -64.00 0.00 -64.00 0.00 -97.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 -64.00 -32.00 0.00 -65.00 -33.00 -32.00 33.00 0.00 0.00 -32.00 32.00 0.00 0.00 -64.00 32.00 -32.00 -32.00 -97.00 -65.00 0.00 33.00 -32.00 -33.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -33.00 -97.00 0.00 -64.00 0.00 -32.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 -32.00 -64.00 -33.00 0.00 0.00 64.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -64.00 -32.00 0.00 0.00 -97.00 0.00 -64.00 -32.00 -65.00 32.00 -64.00 -32.00 -64.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -33.00 -97.00 -96.00 0.00 32.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 0.00 -65.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -32.00 33.00 -450.00 675.00 -32.00 -65.00 -97.00 -64.00 -32.00 -64.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 0.00 -32.00 -129.00 0.00 -32.00 -65.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 65.00 -64.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 -97.00 0.00 -64.00 -64.00 -32.00 0.00 -64.00 -225.00 -97.00 64.00 -32.00 97.00 -32.00 0.00 -64.00 64.00 -97.00 64.00 -32.00 32.00 0.00 65.00 -64.00 32.00 -33.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -64.00 32.00 0.00 97.00 -32.00 64.00 0.00 32.00 -33.00 0.00 -32.00 32.00 -64.00 129.00 0.00 32.00 32.00 0.00 0.00 65.00 -32.00 0.00 -97.00 160.00 -96.00 129.00 -64.00 64.00 -97.00 193.00 0.00 32.00 65.00 32.00 0.00 65.00 -33.00 64.00 -32.00 64.00 65.00 97.00 -33.00 64.00 33.00 64.00 -33.00 65.00 33.00 96.00 0.00 32.00 0.00 65.00 -129.00 96.00 -450.00 -257.00 -675.00 -386.00 -1415.00 -836.00 -32.00 -32.00 -33.00 0.00 -96.00 -32.00 -64.00 0.00 -129.00 -97.00 -32.00 32.00 -64.00 -64.00 -65.00 -32.00 -96.00 32.00 -32.00 0.00 -32.00 -64.00 -97.00 0.00 -32.00 -64.00 -129.00 0.00 -32.00 32.00 -64.00 -32.00 -129.00 -33.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 -65.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 0.00 32.00 -64.00 -32.00 0.00 -64.00 -33.00 0.00 0.00 -33.00 -32.00 33.00 0.00 -33.00 -64.00 0.00 0.00 -32.00 -64.00 0.00 32.00 0.00 -65.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 -32.00 -32.00 32.00 -64.00 32.00 -32.00 -32.00 -65.00 64.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 64.00 -32.00 0.00 -97.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -65.00 32.00 -32.00 0.00 32.00 0.00 33.00 0.00 -33.00 32.00 0.00 32.00 33.00 0.00 -65.00 32.00 32.00 33.00 0.00 -33.00 -32.00 33.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 32.00 32.00 32.00 -32.00 -32.00 -129.00 32.00 -96.00 32.00 0.00 0.00 32.00 33.00 0.00 96.00 -64.00 0.00 -32.00 64.00 0.00 -32.00 -33.00 -32.00 -32.00 0.00 32.00 -32.00 33.00 0.00 -65.00 -64.00 -32.00 -33.00 -64.00 65.00 -64.00 0.00 -161.00 32.00 0.00 32.00 -32.00 0.00 -65.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 64.00 0.00 0.00 -33.00 32.00 0.00 0.00 -96.00 64.00 -96.00 -128.00 64.00 0.00 64.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 32.00 65.00 32.00 0.00 32.00 -65.00 0.00 -64.00 33.00 -32.00 0.00 64.00 32.00 -96.00 0.00 -33.00 64.00 -96.00 0.00 -32.00 97.00 -32.00 0.00 -97.00 0.00 0.00 32.00 -128.00 64.00 -33.00 32.00 0.00 32.00 33.00 33.00 0.00 32.00 -65.00 -32.00 -32.00 0.00 32.00 64.00 -32.00 32.00 -64.00 -32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -33.00 0.00 33.00 32.00 -33.00 32.00 0.00 65.00 0.00 32.00 -64.00 0.00 -32.00 64.00 -32.00 64.00 32.00 0.00 -32.00 33.00 -65.00 32.00 -32.00 32.00 32.00 96.00 -32.00 33.00 -64.00 -33.00 -64.00 65.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 32.00 -32.00 0.00 -97.00 0.00 0.00 32.00 -64.00 32.00 0.00 32.00 32.00 32.00 32.00 32.00 -32.00 33.00 -64.00 32.00 0.00 32.00 0.00 32.00 64.00 0.00 -32.00 32.00 0.00 64.00 -32.00 0.00 -32.00 65.00 32.00 128.00 -32.00 0.00 -33.00 33.00 33.00 32.00 -33.00 64.00 -64.00 97.00 0.00 -65.00 -32.00 -64.00 -64.00 32.00 -161.00 0.00 -161.00 -64.00 0.00 -32.00 97.00 -65.00 0.00 -32.00 -33.00 0.00 -96.00 0.00 -32.00 97.00 -32.00 0.00 -32.00 -33.00 0.00 -64.00 64.00 -129.00 -97.00 0.00 33.00 -64.00 0.00 -128.00 -65.00 -65.00 32.00 -96.00 -64.00 0.00 -32.00 -129.00 32.00 -64.00 0.00 -64.00 -32.00 -33.00 -225.00 33.00 0.00 -129.00 -32.00 -64.00 32.00 -65.00 32.00 -32.00 96.00 32.00 33.00 0.00 0.00 -64.00 -97.00 -64.00 32.00 -97.00 65.00 -64.00 32.00 -161.00 64.00 -96.00 -32.00 -129.00 64.00 -32.00 65.00 32.00 0.00 -32.00 32.00 -129.00 -65.00 -32.00 33.00 -161.00 -33.00 -96.00 -64.00 -96.00 32.00 -97.00 -32.00 -32.00 0.00 -97.00 0.00 -32.00 64.00 -64.00 0.00 -64.00 -64.00 -97.00 0.00 -128.00 -32.00 -33.00 -129.00 33.00 -32.00 -97.00 32.00 -64.00 0.00 -161.00 32.00 -64.00 0.00 -97.00 33.00 -193.00 0.00 -96.00 -97.00 -97.00 0.00 -32.00 32.00 -96.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 129.00 -128.00 0.00 -97.00 -64.00 -96.00 32.00 -65.00 96.00 -32.00 0.00 -96.00 -96.00 -97.00 -97.00 0.00 -32.00 -32.00 0.00 -161.00 -32.00 -64.00 -32.00 -64.00 -32.00 -161.00 -32.00 -64.00 -33.00 -65.00 0.00 -32.00 129.00 -128.00 32.00 -32.00 64.00 -33.00 33.00 -64.00 32.00 -32.00 0.00 -129.00 -32.00 -96.00 32.00 -64.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 -33.00 0.00 -64.00 0.00 -128.00 -32.00 -33.00 0.00 -96.00 -193.00 32.00 -129.00 -32.00 -64.00 0.00 -129.00 0.00 -64.00 0.00 -97.00z"},mt:{name:"MT",path:"M64261.00 72698.00l0.00 -64.00 0.00 -32.00 161.00 0.00 32.00 -65.00 64.00 -32.00 97.00 0.00 96.00 32.00 32.00 33.00 33.00 -33.00 -33.00 -64.00 33.00 -161.00 0.00 -32.00 0.00 -64.00 -33.00 -32.00 -32.00 -97.00 -32.00 -32.00 -64.00 -96.00 0.00 -65.00 0.00 -64.00 0.00 -64.00 32.00 -97.00 32.00 0.00 0.00 -64.00 64.00 -64.00 0.00 -97.00 33.00 -96.00 128.00 -258.00 32.00 -32.00 97.00 -128.00 -65.00 -65.00 -32.00 -96.00 -96.00 -97.00 -32.00 -128.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 -65.00 0.00 -32.00 0.00 -129.00 -64.00 -32.00 0.00 -32.00 -32.00 3473.00 0.00 64.00 0.00 418.00 0.00 1543.00 0.00 2669.00 32.00 3473.00 0.00 128.00 0.00 2830.00 0.00 289.00 -32.00 64.00 -32.00 33.00 0.00 32.00 0.00 32.00 0.00 64.00 -65.00 193.00 -192.00 97.00 -65.00 32.00 -32.00 0.00 -32.00 -129.00 -64.00 -128.00 32.00 -33.00 0.00 -128.00 64.00 -97.00 -32.00 -32.00 -32.00 129.00 -290.00 32.00 -64.00 32.00 -96.00 32.00 -33.00 0.00 -64.00 -32.00 -64.00 -64.00 -64.00 32.00 -129.00 0.00 -64.00 -32.00 -65.00 -32.00 -96.00 64.00 -129.00 32.00 -32.00 64.00 -96.00 33.00 -65.00 128.00 -160.00 0.00 -65.00 32.00 -64.00 -32.00 -64.00 32.00 -65.00 129.00 -64.00 32.00 -32.00 -32.00 -97.00 -32.00 -32.00 0.00 -64.00 32.00 -64.00 -32.00 -193.00 64.00 -97.00 -64.00 -193.00 32.00 -96.00 128.00 -64.00 33.00 -65.00 -33.00 -96.00 33.00 -97.00 -33.00 -64.00 -128.00 -225.00 -32.00 -96.00 0.00 -65.00 -32.00 -128.00 -97.00 -129.00 -96.00 -161.00 0.00 -225.00 -65.00 -64.00 0.00 -64.00 33.00 0.00 32.00 -65.00 193.00 -96.00 160.00 -161.00 65.00 -96.00 0.00 -65.00 0.00 -128.00 32.00 -33.00 128.00 -128.00 65.00 -129.00 161.00 -161.00 0.00 -96.00 -33.00 -64.00 -32.00 -161.00 -32.00 -129.00 32.00 -160.00 32.00 -161.00 161.00 -322.00 161.00 -160.00 32.00 -33.00 0.00 -32.00 64.00 32.00 257.00 161.00 33.00 64.00 128.00 258.00 161.00 160.00 129.00 225.00 128.00 322.00 0.00 32.00 32.00 225.00 33.00 32.00 64.00 0.00 64.00 33.00 32.00 64.00 65.00 418.00 32.00 193.00 161.00 289.00 32.00 97.00 32.00 353.00 0.00 97.00 129.00 128.00 128.00 258.00 225.00 192.00 32.00 258.00 32.00 64.00 33.00 32.00 128.00 32.00 65.00 33.00 96.00 160.00 0.00 65.00 0.00 32.00 -64.00 160.00 -32.00 161.00 -65.00 97.00 0.00 32.00 0.00 64.00 65.00 129.00 0.00 32.00 0.00 32.00 -97.00 161.00 0.00 32.00 32.00 96.00 129.00 161.00 0.00 65.00 -32.00 64.00 0.00 32.00 96.00 64.00 32.00 32.00 -32.00 97.00 -64.00 64.00 32.00 97.00 0.00 32.00 64.00 32.00 65.00 32.00 -32.00 225.00 32.00 32.00 64.00 97.00 64.00 193.00 -32.00 161.00 32.00 96.00 129.00 0.00 161.00 -64.00 225.00 128.00 96.00 65.00 65.00 0.00 96.00 0.00 64.00 64.00 0.00 128.00 -32.00 129.00 32.00 32.00 65.00 32.00 96.00 97.00 161.00 0.00 161.00 32.00 32.00 97.00 32.00 32.00 64.00 0.00 161.00 -32.00 32.00 -33.00 64.00 33.00 97.00 32.00 64.00 32.00 32.00 32.00 258.00 321.00 192.00 97.00 33.00 96.00 64.00 97.00 64.00 32.00 0.00 97.00 65.00 32.00 32.00 64.00 0.00 64.00 -97.00 129.00 32.00 96.00 -32.00 65.00 0.00 32.00 32.00 32.00 65.00 64.00 32.00 65.00 64.00 32.00 64.00 32.00 65.00 32.00 193.00 -32.00 64.00 32.00 289.00 32.00 33.00 0.00 64.00 -32.00 64.00 32.00 129.00 32.00 64.00 97.00 97.00 257.00 32.00 0.00 0.00 64.00 0.00 161.00 32.00 64.00 0.00 65.00 32.00 64.00 32.00 0.00 97.00 -32.00 96.00 -64.00 0.00 -33.00 32.00 0.00 64.00 0.00 129.00 -32.00 1865.00 161.00 547.00 32.00 1736.00 161.00 3762.00 289.00 1254.00 129.00 579.00 32.00 2379.00 193.00 2476.00 193.00 2154.00 161.00 2154.00 160.00 257.00 0.00 1737.00 129.00 3762.00 257.00 739.00 65.00 1158.00 64.00 1029.00 64.00 2926.00 193.00 0.00 32.00 0.00 32.00 -97.00 97.00 -96.00 193.00 0.00 128.00 -65.00 97.00 0.00 64.00 -64.00 97.00 0.00 128.00 -32.00 97.00 -64.00 64.00 -129.00 64.00 -64.00 65.00 -32.00 96.00 -65.00 64.00 -64.00 129.00 -32.00 161.00 0.00 32.00 32.00 0.00 32.00 225.00 -64.00 161.00 -32.00 161.00 -97.00 225.00 0.00 32.00 32.00 96.00 -32.00 32.00 -96.00 65.00 -33.00 64.00 -128.00 64.00 -64.00 322.00 32.00 96.00 -32.00 32.00 -33.00 0.00 -96.00 33.00 0.00 96.00 -32.00 96.00 32.00 97.00 -64.00 96.00 -32.00 97.00 -33.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 64.00 -65.00 97.00 -96.00 96.00 0.00 65.00 96.00 64.00 0.00 96.00 33.00 65.00 0.00 64.00 32.00 96.00 -97.00 161.00 0.00 65.00 0.00 32.00 -64.00 0.00 -32.00 32.00 0.00 32.00 -32.00 64.00 0.00 32.00 0.00 129.00 64.00 32.00 32.00 64.00 0.00 65.00 -96.00 96.00 -65.00 97.00 65.00 161.00 -32.00 64.00 32.00 96.00 0.00 129.00 32.00 64.00 0.00 129.00 -32.00 64.00 0.00 32.00 -97.00 65.00 -32.00 96.00 -64.00 32.00 0.00 65.00 -32.00 96.00 32.00 129.00 0.00 64.00 32.00 96.00 -32.00 129.00 -32.00 193.00 -65.00 32.00 -64.00 64.00 -32.00 32.00 -32.00 65.00 0.00 64.00 -32.00 97.00 -65.00 128.00 0.00 129.00 -64.00 128.00 0.00 97.00 0.00 64.00 0.00 129.00 32.00 64.00 -32.00 129.00 96.00 193.00 33.00 0.00 128.00 32.00 64.00 0.00 33.00 0.00 32.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 -32.00 64.00 32.00 96.00 0.00 129.00 -32.00 32.00 -33.00 64.00 -64.00 33.00 -32.00 32.00 -129.00 128.00 0.00 32.00 33.00 65.00 32.00 64.00 32.00 161.00 32.00 64.00 32.00 64.00 0.00 161.00 32.00 32.00 97.00 0.00 96.00 97.00 0.00 96.00 -96.00 32.00 -32.00 65.00 64.00 96.00 0.00 97.00 -129.00 128.00 -32.00 65.00 32.00 32.00 0.00 32.00 -32.00 96.00 0.00 32.00 97.00 97.00 0.00 96.00 -33.00 193.00 0.00 97.00 -32.00 64.00 0.00 161.00 -32.00 64.00 32.00 97.00 129.00 -33.00 32.00 33.00 0.00 128.00 64.00 97.00 0.00 64.00 -64.00 64.00 0.00 32.00 0.00 97.00 32.00 32.00 -32.00 97.00 64.00 96.00 33.00 96.00 -33.00 161.00 65.00 32.00 -32.00 129.00 0.00 32.00 -65.00 -32.00 -64.00 32.00 32.00 129.00 -64.00 96.00 -32.00 161.00 -65.00 64.00 -32.00 97.00 97.00 64.00 0.00 64.00 -33.00 0.00 -96.00 -32.00 -32.00 32.00 -32.00 65.00 32.00 64.00 0.00 129.00 225.00 -33.00 32.00 33.00 0.00 64.00 -32.00 64.00 32.00 129.00 64.00 0.00 -32.00 96.00 65.00 65.00 0.00 128.00 -33.00 64.00 97.00 0.00 -64.00 129.00 0.00 64.00 32.00 33.00 32.00 0.00 32.00 -97.00 96.00 0.00 33.00 0.00 0.00 32.00 -97.00 65.00 0.00 32.00 161.00 64.00 161.00 0.00 64.00 -32.00 32.00 64.00 0.00 65.00 32.00 64.00 0.00 64.00 -32.00 64.00 -32.00 97.00 -32.00 96.00 0.00 193.00 -97.00 32.00 -64.00 97.00 -32.00 0.00 -64.00 -32.00 -65.00 32.00 32.00 96.00 65.00 32.00 0.00 33.00 -32.00 64.00 -129.00 32.00 -32.00 32.00 64.00 129.00 32.00 32.00 0.00 64.00 -32.00 161.00 32.00 129.00 -32.00 64.00 -32.00 64.00 32.00 0.00 64.00 65.00 0.00 64.00 0.00 129.00 -64.00 96.00 -32.00 32.00 0.00 161.00 -32.00 32.00 -64.00 97.00 -65.00 64.00 -32.00 64.00 -96.00 64.00 0.00 129.00 32.00 129.00 -32.00 64.00 -65.00 32.00 -64.00 129.00 -96.00 96.00 -129.00 65.00 -96.00 128.00 -33.00 322.00 -64.00 96.00 -32.00 161.00 -64.00 193.00 -97.00 128.00 -64.00 -32.00 -65.00 32.00 -32.00 0.00 -32.00 33.00 -32.00 64.00 96.00 128.00 -32.00 161.00 32.00 65.00 -32.00 96.00 65.00 129.00 0.00 32.00 0.00 96.00 0.00 32.00 0.00 65.00 0.00 128.00 0.00 65.00 -97.00 96.00 0.00 97.00 64.00 96.00 0.00 129.00 97.00 225.00 -32.00 96.00 -32.00 64.00 -129.00 97.00 -96.00 0.00 -65.00 -64.00 -32.00 0.00 -32.00 0.00 0.00 64.00 32.00 128.00 0.00 97.00 -64.00 64.00 -64.00 129.00 -97.00 193.00 -64.00 193.00 -32.00 64.00 32.00 161.00 -32.00 96.00 -65.00 32.00 32.00 129.00 0.00 32.00 -32.00 65.00 -32.00 64.00 64.00 96.00 0.00 65.00 65.00 64.00 32.00 64.00 -32.00 97.00 32.00 128.00 -161.00 258.00 32.00 160.00 -128.00 257.00 -33.00 0.00 -32.00 65.00 32.00 96.00 0.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 64.00 -32.00 32.00 0.00 97.00 64.00 96.00 -32.00 65.00 -96.00 64.00 -97.00 161.00 0.00 96.00 0.00 64.00 -32.00 97.00 64.00 64.00 0.00 32.00 -32.00 0.00 -193.00 129.00 -32.00 0.00 -64.00 96.00 0.00 97.00 -225.00 128.00 -225.00 129.00 -129.00 32.00 -96.00 -32.00 -33.00 -64.00 -32.00 -161.00 -96.00 -64.00 -65.00 0.00 -32.00 64.00 -64.00 64.00 -96.00 65.00 -97.00 -65.00 -129.00 32.00 -64.00 129.00 -64.00 0.00 -32.00 64.00 -65.00 65.00 -193.00 -32.00 -32.00 32.00 -64.00 64.00 -64.00 161.00 -129.00 32.00 -96.00 225.00 -33.00 32.00 -128.00 0.00 -97.00 64.00 0.00 129.00 -64.00 97.00 0.00 96.00 32.00 64.00 65.00 32.00 0.00 33.00 -97.00 64.00 -64.00 32.00 -32.00 97.00 0.00 160.00 64.00 65.00 0.00 64.00 -129.00 193.00 0.00 32.00 32.00 64.00 0.00 32.00 -64.00 97.00 32.00 96.00 0.00 32.00 0.00 33.00 -32.00 32.00 -96.00 32.00 -32.00 64.00 0.00 32.00 32.00 97.00 0.00 64.00 -65.00 0.00 -64.00 0.00 -32.00 -96.00 -64.00 0.00 0.00 32.00 -32.00 0.00 32.00 96.00 96.00 258.00 0.00 64.00 -32.00 96.00 -32.00 32.00 -161.00 290.00 0.00 64.00 -129.00 64.00 -96.00 161.00 -32.00 65.00 -97.00 96.00 -32.00 96.00 -32.00 33.00 -96.00 -97.00 -193.00 0.00 -32.00 64.00 0.00 65.00 0.00 32.00 -65.00 -32.00 -64.00 32.00 -64.00 161.00 -65.00 32.00 -225.00 32.00 -96.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 -32.00 -96.00 64.00 -322.00 -64.00 -64.00 32.00 -129.00 0.00 -96.00 0.00 32.00 96.00 -32.00 129.00 -32.00 0.00 0.00 64.00 -129.00 97.00 0.00 96.00 -32.00 32.00 -64.00 65.00 -33.00 96.00 -32.00 64.00 0.00 33.00 -32.00 96.00 0.00 32.00 -96.00 65.00 -33.00 -33.00 -32.00 33.00 -32.00 32.00 -32.00 32.00 -97.00 -32.00 -192.00 96.00 -97.00 65.00 -64.00 0.00 -64.00 32.00 -33.00 32.00 -32.00 0.00 -64.00 -32.00 -64.00 32.00 0.00 96.00 -97.00 32.00 32.00 65.00 -32.00 64.00 0.00 161.00 -32.00 0.00 -64.00 0.00 0.00 32.00 96.00 129.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 -65.00 -33.00 0.00 -32.00 65.00 0.00 32.00 -96.00 0.00 -65.00 64.00 -64.00 0.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 -97.00 64.00 0.00 65.00 -32.00 0.00 -32.00 64.00 32.00 32.00 0.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 0.00 64.00 64.00 64.00 -64.00 33.00 0.00 32.00 64.00 64.00 129.00 0.00 32.00 0.00 0.00 32.00 0.00 65.00 32.00 32.00 97.00 64.00 -33.00 32.00 0.00 32.00 33.00 -32.00 64.00 32.00 -64.00 33.00 32.00 32.00 0.00 32.00 0.00 32.00 -32.00 64.00 -33.00 0.00 -64.00 0.00 0.00 65.00 32.00 0.00 0.00 32.00 0.00 64.00 -32.00 32.00 0.00 64.00 -64.00 -32.00 0.00 65.00 -64.00 -65.00 -33.00 0.00 0.00 65.00 33.00 32.00 -65.00 0.00 32.00 64.00 -32.00 32.00 -64.00 0.00 -64.00 -64.00 -32.00 0.00 32.00 129.00 -97.00 -65.00 -32.00 0.00 -32.00 0.00 32.00 65.00 -32.00 32.00 0.00 32.00 64.00 0.00 32.00 129.00 -32.00 32.00 -32.00 -65.00 -32.00 -32.00 -32.00 32.00 -32.00 33.00 64.00 96.00 -32.00 -32.00 -65.00 32.00 -64.00 32.00 0.00 32.00 64.00 0.00 -32.00 32.00 0.00 129.00 -64.00 0.00 -32.00 64.00 0.00 32.00 0.00 65.00 -32.00 0.00 -33.00 32.00 -32.00 -32.00 -96.00 96.00 -32.00 0.00 0.00 65.00 -32.00 0.00 0.00 -33.00 -33.00 0.00 -32.00 33.00 -32.00 -33.00 -32.00 65.00 -64.00 0.00 -65.00 32.00 33.00 0.00 -33.00 32.00 -64.00 32.00 0.00 64.00 -32.00 0.00 -32.00 33.00 -32.00 0.00 0.00 -65.00 -33.00 0.00 0.00 32.00 -32.00 0.00 65.00 65.00 -33.00 64.00 33.00 0.00 0.00 32.00 -129.00 0.00 32.00 0.00 32.00 65.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 0.00 33.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 64.00 32.00 32.00 -32.00 0.00 0.00 64.00 -33.00 33.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 64.00 0.00 32.00 0.00 32.00 0.00 33.00 -32.00 32.00 0.00 32.00 -32.00 64.00 0.00 -32.00 -32.00 0.00 0.00 129.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 -32.00 0.00 0.00 33.00 -33.00 0.00 33.00 64.00 -33.00 0.00 0.00 32.00 33.00 0.00 0.00 32.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 -32.00 33.00 -33.00 0.00 0.00 32.00 0.00 -32.00 0.00 64.00 -32.00 -32.00 -32.00 0.00 32.00 32.00 -64.00 0.00 32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 33.00 0.00 32.00 0.00 32.00 -32.00 96.00 -32.00 0.00 0.00 32.00 -32.00 33.00 -32.00 64.00 -32.00 -32.00 -33.00 32.00 0.00 64.00 -32.00 97.00 0.00 32.00 0.00 32.00 -32.00 0.00 0.00 96.00 -32.00 33.00 -32.00 64.00 -65.00 0.00 33.00 96.00 -65.00 33.00 0.00 32.00 -64.00 32.00 0.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 0.00 64.00 33.00 32.00 32.00 -32.00 32.00 32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 65.00 0.00 -33.00 32.00 -32.00 0.00 32.00 0.00 0.00 65.00 -32.00 32.00 0.00 -32.00 0.00 32.00 -32.00 32.00 32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 33.00 -32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 0.00 0.00 64.00 0.00 33.00 0.00 32.00 0.00 -32.00 -32.00 64.00 0.00 32.00 -32.00 64.00 0.00 33.00 0.00 64.00 0.00 -32.00 0.00 32.00 -33.00 64.00 0.00 32.00 33.00 0.00 -33.00 0.00 0.00 65.00 33.00 32.00 -33.00 32.00 33.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 0.00 32.00 0.00 32.00 -33.00 32.00 0.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 65.00 32.00 64.00 0.00 64.00 33.00 0.00 -33.00 33.00 33.00 32.00 0.00 32.00 -33.00 32.00 33.00 0.00 0.00 32.00 32.00 32.00 -32.00 32.00 96.00 65.00 0.00 -32.00 32.00 32.00 64.00 32.00 0.00 32.00 33.00 32.00 32.00 32.00 32.00 0.00 32.00 65.00 32.00 0.00 -32.00 32.00 64.00 64.00 -32.00 32.00 32.00 65.00 65.00 64.00 0.00 32.00 32.00 64.00 -32.00 161.00 32.00 32.00 32.00 32.00 0.00 33.00 32.00 32.00 -32.00 96.00 161.00 97.00 64.00 128.00 32.00 32.00 32.00 65.00 0.00 289.00 -482.00 0.00 -96.00 -32.00 -33.00 -64.00 -32.00 0.00 -64.00 -32.00 -64.00 -33.00 -32.00 0.00 -97.00 -32.00 -193.00 -32.00 -128.00 32.00 -33.00 32.00 -32.00 0.00 -96.00 -32.00 -97.00 32.00 -96.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -33.00 -64.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 0.00 97.00 -33.00 32.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -64.00 -32.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 -64.00 0.00 -64.00 -32.00 -65.00 0.00 0.00 -65.00 -32.00 0.00 -32.00 32.00 -64.00 0.00 0.00 -32.00 -97.00 -32.00 -32.00 -64.00 0.00 -32.00 -64.00 0.00 0.00 32.00 -32.00 -32.00 -129.00 0.00 0.00 32.00 -64.00 32.00 -32.00 32.00 -33.00 32.00 -32.00 65.00 -32.00 -65.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 -161.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 33.00 0.00 -33.00 -32.00 -32.00 -65.00 32.00 0.00 -64.00 -32.00 0.00 32.00 32.00 -32.00 0.00 -32.00 -64.00 -64.00 0.00 -32.00 0.00 0.00 32.00 -33.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -33.00 -32.00 33.00 -64.00 -33.00 0.00 33.00 -32.00 -33.00 -65.00 0.00 -32.00 0.00 -32.00 33.00 -64.00 32.00 -32.00 0.00 -65.00 128.00 -160.00 33.00 -65.00 32.00 -64.00 0.00 -32.00 64.00 -129.00 32.00 -32.00 0.00 -32.00 64.00 -32.00 33.00 -32.00 0.00 -97.00 64.00 -32.00 161.00 -64.00 32.00 -32.00 32.00 0.00 64.00 0.00 32.00 0.00 97.00 0.00 32.00 0.00 64.00 -65.00 65.00 32.00 64.00 -32.00 32.00 0.00 97.00 -1993.00 -65.00 -32.00 0.00 -65.00 -64.00 -32.00 -129.00 32.00 -64.00 65.00 -32.00 0.00 -32.00 0.00 0.00 64.00 -32.00 32.00 -65.00 97.00 -96.00 0.00 -65.00 32.00 -32.00 96.00 -32.00 32.00 -32.00 97.00 32.00 96.00 -193.00 64.00 -32.00 33.00 -32.00 64.00 -129.00 129.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -64.00 64.00 -33.00 32.00 -96.00 33.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 -128.00 32.00 -32.00 64.00 -33.00 65.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 64.00 0.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 65.00 0.00 64.00 0.00 32.00 -96.00 97.00 0.00 32.00 -32.00 64.00 32.00 32.00 -32.00 32.00 -65.00 -32.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 0.00 32.00 -32.00 -32.00 -65.00 32.00 -32.00 -64.00 -32.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 0.00 -32.00 65.00 -65.00 32.00 -32.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 0.00 -32.00 0.00 32.00 -96.00 -64.00 -64.00 -32.00 32.00 -33.00 32.00 -96.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -65.00 32.00 32.00 0.00 -32.00 0.00 -32.00 -97.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -161.00 -32.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 32.00 -65.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -64.00 -32.00 -96.00 0.00 -33.00 -32.00 -32.00 0.00 -96.00 64.00 -32.00 -64.00 -33.00 32.00 0.00 -32.00 -64.00 -32.00 -32.00 32.00 -129.00 64.00 -96.00 32.00 -64.00 -32.00 -32.00 32.00 -65.00 33.00 -32.00 0.00 0.00 32.00 -64.00 -32.00 -32.00 -33.00 0.00 65.00 -65.00 32.00 -32.00 0.00 -32.00 0.00 -97.00 32.00 -32.00 64.00 0.00 32.00 -32.00 65.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -64.00 0.00 -65.00 64.00 -32.00 0.00 -64.00 65.00 -32.00 0.00 0.00 32.00 0.00 32.00 -97.00 32.00 -32.00 0.00 -64.00 32.00 -97.00 -32.00 -64.00 32.00 -32.00 -64.00 -32.00 0.00 -161.00 0.00 -32.00 32.00 -64.00 0.00 0.00 32.00 -33.00 -32.00 -32.00 64.00 -32.00 -32.00 -32.00 65.00 0.00 32.00 -32.00 -32.00 -64.00 -33.00 0.00 33.00 -33.00 -33.00 0.00 33.00 -32.00 0.00 0.00 32.00 0.00 -32.00 -32.00 32.00 -64.00 0.00 0.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -33.00 0.00 33.00 -32.00 -33.00 -32.00 33.00 -32.00 -33.00 0.00 33.00 -33.00 -33.00 -32.00 65.00 -64.00 64.00 -64.00 -32.00 0.00 -32.00 -65.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -96.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 32.00 -32.00 -32.00 32.00 0.00 -65.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 32.00 -32.00 -64.00 -32.00 32.00 -33.00 -32.00 0.00 -96.00 33.00 -33.00 -33.00 -32.00 33.00 32.00 0.00 0.00 32.00 -64.00 -32.00 0.00 -33.00 0.00 33.00 -64.00 0.00 0.00 -97.00 -32.00 0.00 -65.00 -32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 -65.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -33.00 -64.00 -64.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -64.00 -64.00 0.00 -32.00 -32.00 0.00 -33.00 -65.00 -32.00 32.00 0.00 -64.00 -64.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -33.00 -32.00 0.00 -65.00 33.00 0.00 -33.00 -32.00 33.00 0.00 -33.00 -32.00 33.00 -64.00 -33.00 0.00 33.00 -33.00 -65.00 33.00 -32.00 -33.00 -64.00 -64.00 0.00 64.00 -32.00 -32.00 -65.00 -64.00 -32.00 -64.00 0.00 32.00 0.00 32.00 0.00 32.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 -64.00 64.00 -32.00 -64.00 -33.00 64.00 -32.00 -64.00 -64.00 64.00 -32.00 -64.00 -65.00 64.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -33.00 -33.00 0.00 -32.00 33.00 -32.00 -65.00 -32.00 32.00 0.00 33.00 -96.00 -97.00 32.00 -64.00 -32.00 0.00 -65.00 0.00 -32.00 32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 -65.00 -33.00 33.00 -64.00 -97.00 -32.00 32.00 32.00 32.00 -64.00 33.00 -32.00 -33.00 32.00 -32.00 -65.00 32.00 0.00 -32.00 33.00 0.00 32.00 -32.00 -129.00 0.00 -64.00 -32.00 0.00 32.00 0.00 32.00 -65.00 32.00 -64.00 -96.00 32.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -33.00 64.00 0.00 -97.00 -32.00 0.00 -32.00 33.00 0.00 -65.00 -32.00 32.00 0.00 -96.00 0.00 -32.00 -32.00 32.00 0.00 -64.00 64.00 0.00 -64.00 -65.00 -64.00 -32.00 -65.00 -64.00 -32.00 0.00 32.00 64.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -96.00 -32.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 129.00 -64.00 -32.00 -32.00 32.00 -33.00 0.00 33.00 64.00 -65.00 -32.00 0.00 32.00 -64.00 0.00 -32.00 -32.00 -64.00 0.00 0.00 64.00 -33.00 -32.00 0.00 32.00 33.00 65.00 -65.00 -33.00 -32.00 33.00 32.00 0.00 -64.00 0.00 -32.00 0.00 0.00 32.00 32.00 32.00 -32.00 64.00 -32.00 0.00 -33.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 33.00 -64.00 0.00 0.00 32.00 -65.00 -65.00 0.00 -32.00 32.00 32.00 0.00 -32.00 -64.00 -32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -96.00 33.00 0.00 32.00 -33.00 64.00 -64.00 0.00 -32.00 64.00 -32.00 -32.00 -64.00 32.00 -65.00 65.00 -32.00 -33.00 0.00 -64.00 -64.00 32.00 0.00 -64.00 -32.00 0.00 0.00 32.00 -97.00 -64.00 -32.00 0.00 0.00 -64.00 -32.00 64.00 -32.00 -32.00 32.00 64.00 -32.00 0.00 0.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 -32.00 -96.00 64.00 -97.00 -32.00 -32.00 0.00 32.00 65.00 -64.00 0.00 -32.00 0.00 -64.00 0.00 -33.00 0.00 0.00 -33.00 -64.00 0.00 0.00 33.00 -64.00 -33.00 -32.00 -32.00 0.00 32.00 32.00 33.00 -32.00 32.00 -33.00 -65.00 -32.00 0.00 32.00 33.00 -32.00 32.00 -64.00 -32.00 0.00 -33.00 -32.00 -32.00 -65.00 32.00 33.00 -32.00 -129.00 0.00 -32.00 -32.00 -64.00 0.00 0.00 64.00 -33.00 0.00 -64.00 0.00 0.00 65.00 -64.00 32.00 32.00 32.00 0.00 32.00 -96.00 64.00 -33.00 33.00 33.00 64.00 -33.00 0.00 -64.00 -32.00 -129.00 32.00 0.00 96.00 -64.00 33.00 64.00 32.00 33.00 0.00 32.00 32.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 65.00 32.00 0.00 32.00 -33.00 33.00 -64.00 0.00 -32.00 32.00 32.00 64.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 32.00 33.00 -32.00 64.00 -32.00 0.00 -33.00 96.00 -64.00 32.00 -64.00 -32.00 -65.00 32.00 -96.00 33.00 -64.00 96.00 -65.00 0.00 -32.00 64.00 -32.00 0.00 32.00 65.00 -32.00 32.00 0.00 32.00 32.00 32.00 65.00 -32.00 0.00 32.00 -97.00 129.00 -32.00 96.00 -64.00 65.00 -33.00 0.00 -32.00 0.00 -32.00 64.00 0.00 32.00 -64.00 0.00 -32.00 193.00 -32.00 0.00 -33.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 64.00 -65.00 32.00 0.00 97.00 -96.00 0.00 0.00 32.00 -129.00 -64.00 -64.00 64.00 -96.00 0.00 -97.00 32.00 -96.00 0.00 -32.00 0.00 0.00 32.00 -33.00 -32.00 -64.00 64.00 -32.00 -32.00 32.00 65.00 64.00 0.00 0.00 32.00 -96.00 0.00 -64.00 32.00 -97.00 -32.00 0.00 64.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 32.00 0.00 32.00 -64.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 97.00 -64.00 -33.00 0.00 33.00 -33.00 32.00 0.00 32.00 -64.00 -32.00 -64.00 96.00 -64.00 0.00 32.00 97.00 -32.00 64.00 -65.00 -32.00 -64.00 -97.00 0.00 -96.00 -161.00 32.00 -129.00 -64.00 33.00 -65.00 -97.00 -64.00 -32.00 -32.00 -64.00 0.00 -32.00 -97.00 -129.00 33.00 0.00 -33.00 -32.00 -96.00 32.00 0.00 32.00 -32.00 -64.00 -32.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 -32.00 -64.00 -65.00 -64.00 -32.00 0.00 0.00 32.00 -96.00 32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -64.00 -33.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 -33.00 0.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 -32.00 0.00 -32.00 -128.00 0.00 -64.00 0.00 -65.00 -65.00 -32.00 0.00 -129.00 -64.00 -64.00 -64.00 32.00 -64.00 129.00 -611.00 -547.00 -450.00 290.00 -97.00 32.00 0.00 -64.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -33.00 -33.00 -32.00 0.00 -64.00 -32.00 0.00 -128.00 -64.00 -65.00 -65.00 0.00 -64.00 65.00 -161.00 -65.00 0.00 -160.00 -32.00 -33.00 -64.00 33.00 -32.00 -33.00 -32.00 -32.00 32.00 -96.00 -161.00 32.00 -96.00 -32.00 32.00 -65.00 -32.00 -64.00 -97.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -65.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 -64.00 -33.00 0.00 -128.00 -65.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 -64.00 -33.00 0.00 -32.00 -64.00 -32.00 -32.00 -32.00 32.00 -32.00 -97.00 -65.00 0.00 -32.00 -32.00 0.00 -64.00 -96.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 -97.00 -65.00 -32.00 -257.00 64.00 -96.00 -32.00 -33.00 -32.00 0.00 -96.00 33.00 -33.00 0.00 0.00 -33.00 0.00 -96.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 65.00 -64.00 -65.00 0.00 0.00 -32.00 0.00 -32.00 65.00 0.00 0.00 -32.00 -65.00 0.00 0.00 -97.00 32.00 -32.00 33.00 -64.00 -65.00 0.00 -64.00 -65.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -64.00 32.00 -64.00 -32.00 -33.00 -33.00 33.00 -32.00 -33.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 33.00 -65.00 -33.00 0.00 33.00 -128.00 -33.00 0.00 33.00 -32.00 -33.00 -32.00 33.00 -33.00 -33.00 0.00 33.00 -32.00 -65.00 -96.00 0.00 -32.00 0.00 -129.00 65.00 0.00 0.00 -32.00 0.00 -32.00 -33.00 -97.00 -32.00 -64.00 32.00 -129.00 0.00 -64.00 33.00 -193.00 0.00 -64.00 128.00 -290.00 32.00 -32.00 33.00 -64.00 128.00 -64.00 32.00 -97.00 129.00 -64.00 64.00 -64.00 65.00 -129.00 0.00 -64.00 -65.00 -97.00 -64.00 -128.00 64.00 -161.00 0.00 -32.00 32.00 -33.00 33.00 33.00 32.00 -33.00 96.00 -64.00 -32.00 -32.00 32.00 -161.00 0.00 -96.00 -64.00 -97.00 0.00 -128.00 -97.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -97.00 -64.00 -32.00 193.00 -64.00 64.00 -129.00 64.00 -1672.00 -96.00 -3247.00 -129.00 -3312.00 -64.00 -161.00 -1865.00 -161.00 -1994.00 -1543.00 -1800.00 290.00 -32.00 1221.00 0.00 -128.00 -2348.00 -97.00 33.00 -128.00 -65.00 -32.00 -160.00 -33.00 -65.00 33.00 0.00 -33.00 -64.00 0.00 -64.00 -32.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 -96.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -64.00 -97.00 -64.00 32.00 -32.00 -32.00 0.00 0.00 -65.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 33.00 0.00 -33.00 -32.00 33.00 0.00 -33.00 0.00 -32.00 -33.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 32.00 -32.00 -64.00 -32.00 -32.00 -65.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -64.00 -33.00 -32.00 33.00 -33.00 -33.00 -64.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 0.00 -65.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -64.00 64.00 -32.00 -64.00 -64.00 64.00 -32.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 32.00 0.00 65.00 -32.00 96.00 -96.00 0.00 -33.00 32.00 -64.00 65.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 -64.00 32.00 -32.00 0.00 32.00 0.00 -32.00 64.00 0.00 0.00 -32.00 -32.00 -32.00 -129.00 0.00 -64.00 -97.00 32.00 32.00 32.00 -64.00 33.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 -33.00 -32.00 0.00 32.00 33.00 -32.00 0.00 0.00 -161.00 -32.00 -64.00 32.00 -33.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 0.00 33.00 -32.00 -33.00 32.00 -32.00 32.00 -32.00 0.00 -64.00 33.00 -32.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 96.00 -97.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 64.00 0.00 32.00 -32.00 -64.00 -32.00 0.00 -33.00 32.00 0.00 32.00 0.00 -32.00 -32.00 -96.00 0.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 -96.00 0.00 64.00 -64.00 -32.00 -32.00 -32.00 0.00 -64.00 0.00 0.00 64.00 -33.00 0.00 -32.00 -64.00 -64.00 0.00 32.00 -65.00 -64.00 0.00 32.00 -32.00 -64.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 0.00 -64.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -64.00 -65.00 -32.00 65.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 0.00 -32.00 0.00 32.00 -64.00 -32.00 -64.00 -65.00 -33.00 -96.00 -32.00 32.00 0.00 64.00 -64.00 -64.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 64.00 0.00 32.00 -65.00 32.00 33.00 0.00 -33.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 96.00 -32.00 64.00 32.00 33.00 0.00 32.00 -32.00 32.00 0.00 96.00 -64.00 32.00 -33.00 33.00 0.00 0.00 -32.00 64.00 0.00 0.00 -96.00 129.00 -97.00 96.00 -32.00 0.00 32.00 32.00 -32.00 64.00 -32.00 33.00 32.00 128.00 -32.00 0.00 -32.00 97.00 -97.00 32.00 0.00 0.00 -32.00 64.00 0.00 32.00 -64.00 0.00 -96.00 0.00 -33.00 65.00 -32.00 -65.00 -64.00 0.00 -97.00 32.00 0.00 0.00 -32.00 33.00 0.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -33.00 -65.00 33.00 0.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 64.00 0.00 32.00 -96.00 33.00 0.00 0.00 -129.00 32.00 0.00 0.00 -64.00 64.00 -97.00 0.00 -32.00 0.00 -64.00 32.00 0.00 32.00 0.00 129.00 -161.00 -64.00 -32.00 32.00 -64.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 -32.00 0.00 -64.00 64.00 0.00 64.00 -97.00 32.00 0.00 32.00 -64.00 0.00 -65.00 65.00 0.00 32.00 -32.00 32.00 0.00 0.00 -96.00 32.00 -32.00 32.00 -65.00 33.00 -32.00 0.00 -32.00 32.00 -32.00 96.00 32.00 32.00 -32.00 33.00 0.00 32.00 0.00 32.00 32.00 32.00 -64.00 64.00 0.00 65.00 -193.00 96.00 -97.00 32.00 -96.00 -32.00 -225.00 32.00 -161.00 0.00 -129.00 -64.00 -160.00 0.00 -32.00 0.00 -65.00 64.00 -160.00 0.00 -129.00 64.00 -97.00 0.00 -64.00 -32.00 -64.00 65.00 -65.00 64.00 -32.00 32.00 0.00 32.00 -96.00 0.00 -64.00 32.00 -33.00 65.00 -64.00 32.00 -32.00 129.00 -32.00 96.00 -129.00 96.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 0.00 0.00 -32.00 64.00 0.00 32.00 0.00 32.00 -33.00 0.00 33.00 64.00 -33.00 33.00 33.00 64.00 32.00 64.00 -32.00 32.00 -33.00 32.00 -64.00 -32.00 -161.00 65.00 -64.00 0.00 -64.00 32.00 -32.00 32.00 0.00 0.00 -65.00 64.00 -64.00 0.00 -32.00 65.00 -64.00 96.00 -33.00 -547.00 -450.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -33.00 -32.00 -96.00 0.00 -64.00 32.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -193.00 -64.00 -96.00 -32.00 0.00 -32.00 -97.00 -97.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -33.00 0.00 -64.00 -65.00 0.00 33.00 -64.00 32.00 -64.00 0.00 -33.00 -65.00 -32.00 33.00 0.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 -97.00 -65.00 32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -64.00 -32.00 -33.00 -32.00 0.00 -64.00 -96.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 32.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 -33.00 32.00 65.00 -32.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 -65.00 0.00 33.00 -32.00 0.00 -33.00 -33.00 0.00 0.00 -32.00 33.00 0.00 0.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -64.00 -32.00 -97.00 32.00 -32.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 32.00 0.00 0.00 -96.00 0.00 -33.00 0.00 -64.00 32.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 32.00 -32.00 -32.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 33.00 0.00 32.00 0.00 -32.00 -32.00 64.00 0.00 -32.00 -33.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 0.00 0.00 -32.00 97.00 -32.00 0.00 -32.00 64.00 -97.00 64.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 32.00 33.00 -32.00 32.00 -33.00 32.00 -32.00 64.00 -32.00 65.00 -161.00 96.00 0.00 32.00 -32.00 32.00 -32.00 32.00 0.00 33.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -64.00 -32.00 -96.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 -64.00 -32.00 -97.00 -97.00 -32.00 -64.00 -64.00 0.00 -64.00 -32.00 -65.00 0.00 -64.00 -65.00 -96.00 0.00 -97.00 0.00 -64.00 33.00 0.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 -33.00 -65.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 -65.00 32.00 33.00 33.00 -97.00 -65.00 -32.00 0.00 32.00 -64.00 0.00 -64.00 0.00 0.00 -32.00 -33.00 64.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 -129.00 32.00 -32.00 -128.00 -32.00 -33.00 -32.00 33.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 32.00 -64.00 -32.00 -64.00 32.00 -32.00 -32.00 -33.00 -33.00 -96.00 33.00 -32.00 0.00 -32.00 64.00 -65.00 -32.00 -32.00 0.00 -64.00 -32.00 -65.00 -33.00 -32.00 0.00 -96.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 -32.00 0.00 -97.00 96.00 -64.00 -32.00 32.00 32.00 -32.00 97.00 32.00 0.00 -32.00 32.00 -96.00 -65.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 33.00 -97.00 -33.00 -32.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 32.00 -128.00 -32.00 0.00 -32.00 -33.00 0.00 -96.00 -32.00 0.00 -2573.00 0.00 -2025.00 0.00 -579.00 -32.00 0.00 -32.00 64.00 0.00 32.00 0.00 0.00 -97.00 33.00 -32.00 0.00 -64.00 32.00 -97.00 0.00 -64.00 -32.00 0.00 0.00 -64.00 -33.00 -33.00 33.00 0.00 0.00 -128.00 0.00 -64.00 64.00 -33.00 0.00 -96.00 32.00 -64.00 -32.00 -65.00 32.00 -32.00 32.00 -32.00 0.00 32.00 32.00 32.00 0.00 33.00 65.00 0.00 -33.00 -65.00 33.00 -96.00 -33.00 -32.00 0.00 -65.00 -32.00 -64.00 0.00 -32.00 65.00 -32.00 0.00 -33.00 -33.00 0.00 -64.00 -64.00 0.00 -96.00 32.00 -32.00 32.00 0.00 0.00 -33.00 0.00 -64.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 65.00 -97.00 -33.00 -64.00 33.00 -32.00 -33.00 -97.00 65.00 -64.00 0.00 -65.00 -65.00 -64.00 0.00 -193.00 65.00 -128.00 -32.00 -32.00 32.00 -33.00 32.00 -160.00 -32.00 0.00 -32.00 0.00 0.00 -33.00 32.00 -32.00 -65.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -64.00 0.00 -129.00 -32.00 0.00 -32.00 -96.00 -32.00 0.00 -65.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 -64.00 64.00 -32.00 -64.00 -97.00 -65.00 -96.00 -32.00 -64.00 0.00 -97.00 0.00 -32.00 0.00 -64.00 129.00 -32.00 -32.00 -33.00 0.00 -64.00 0.00 -32.00 -97.00 -32.00 0.00 -32.00 -96.00 0.00 0.00 -33.00 32.00 -160.00 0.00 -65.00 32.00 -64.00 0.00 -64.00 32.00 0.00 -32.00 -97.00 32.00 -32.00 0.00 -32.00 97.00 -64.00 64.00 -161.00 0.00 -32.00 64.00 -32.00 0.00 -97.00 -32.00 -32.00 32.00 -64.00 33.00 0.00 0.00 -32.00 -33.00 -33.00 33.00 -32.00 0.00 -128.00 64.00 -65.00 0.00 -96.00 0.00 -32.00 -32.00 -97.00 0.00 -96.00 -65.00 -32.00 33.00 -65.00 0.00 -32.00 -65.00 -32.00 -64.00 -32.00 96.00 -129.00 0.00 -96.00 -128.00 -64.00 -65.00 0.00 -32.00 -33.00 129.00 -64.00 32.00 32.00 64.00 0.00 33.00 -64.00 96.00 -32.00 0.00 -65.00 -32.00 -96.00 64.00 0.00 64.00 -129.00 33.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -64.00 32.00 -161.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -129.00 -32.00 0.00 0.00 -64.00 -65.00 32.00 -96.00 -96.00 0.00 -33.00 129.00 -32.00 -193.00 -96.00 -33.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 97.00 -96.00 32.00 0.00 0.00 -65.00 32.00 -32.00 -64.00 -96.00 64.00 -32.00 -64.00 -32.00 -65.00 -65.00 -96.00 0.00 -65.00 -32.00 0.00 -32.00 -64.00 32.00 0.00 -96.00 0.00 -33.00 32.00 -64.00 32.00 -32.00 -32.00 -64.00 32.00 -97.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00z"},go:{name:"GO",path:"M104003.00 112858.00l0.00 -33.00 32.00 -64.00 0.00 -32.00 32.00 -64.00 0.00 32.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 -65.00 -32.00 0.00 32.00 0.00 33.00 -32.00 -65.00 0.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -64.00 -33.00 32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 65.00 -33.00 -33.00 -96.00 65.00 0.00 32.00 -64.00 32.00 -33.00 0.00 -96.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -97.00 0.00 -64.00 33.00 -32.00 32.00 32.00 32.00 -64.00 32.00 -33.00 0.00 -32.00 32.00 0.00 32.00 -96.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 33.00 0.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 0.00 32.00 32.00 0.00 -64.00 0.00 32.00 0.00 -32.00 33.00 0.00 32.00 -33.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 33.00 0.00 -33.00 -64.00 33.00 0.00 0.00 -33.00 32.00 0.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -129.00 32.00 0.00 0.00 32.00 32.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 0.00 0.00 -32.00 32.00 0.00 33.00 -33.00 0.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 0.00 65.00 0.00 32.00 32.00 32.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -33.00 32.00 0.00 0.00 33.00 32.00 0.00 -32.00 -65.00 -32.00 0.00 129.00 0.00 0.00 -32.00 -33.00 0.00 33.00 -64.00 -65.00 -65.00 32.00 0.00 0.00 -32.00 33.00 0.00 0.00 65.00 32.00 0.00 32.00 -33.00 32.00 0.00 0.00 -64.00 64.00 -32.00 33.00 -32.00 -33.00 0.00 65.00 -32.00 64.00 0.00 32.00 -65.00 32.00 33.00 32.00 -33.00 33.00 0.00 0.00 33.00 32.00 0.00 0.00 -65.00 32.00 0.00 96.00 -96.00 32.00 32.00 33.00 -32.00 32.00 0.00 0.00 -65.00 0.00 -32.00 32.00 -64.00 64.00 0.00 0.00 -129.00 32.00 -32.00 -64.00 0.00 0.00 -32.00 64.00 -32.00 65.00 -32.00 32.00 32.00 -64.00 -96.00 32.00 -33.00 32.00 -32.00 32.00 32.00 32.00 65.00 32.00 -32.00 -32.00 -129.00 -64.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 32.00 0.00 32.00 0.00 97.00 65.00 -32.00 -129.00 32.00 0.00 64.00 64.00 64.00 0.00 32.00 -32.00 -32.00 -64.00 65.00 0.00 -33.00 -32.00 0.00 -65.00 33.00 0.00 64.00 65.00 0.00 -65.00 64.00 32.00 0.00 -64.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 64.00 0.00 33.00 0.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 64.00 -33.00 -64.00 -32.00 -33.00 32.00 0.00 -32.00 33.00 -32.00 -97.00 -64.00 -32.00 -32.00 0.00 -65.00 0.00 -32.00 -32.00 0.00 -129.00 0.00 -64.00 -64.00 0.00 -32.00 64.00 -33.00 -64.00 -64.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 32.00 0.00 0.00 -65.00 97.00 -64.00 32.00 0.00 0.00 32.00 64.00 0.00 64.00 0.00 65.00 -64.00 96.00 0.00 0.00 -32.00 32.00 -65.00 33.00 0.00 64.00 65.00 32.00 0.00 32.00 0.00 0.00 -32.00 -96.00 -129.00 0.00 -32.00 64.00 0.00 32.00 0.00 0.00 -161.00 32.00 -64.00 -32.00 -65.00 97.00 -32.00 0.00 -96.00 64.00 -32.00 64.00 32.00 32.00 0.00 33.00 -32.00 64.00 -32.00 64.00 0.00 97.00 -65.00 192.00 -96.00 97.00 32.00 32.00 -32.00 32.00 -32.00 32.00 -33.00 33.00 33.00 96.00 -65.00 0.00 -32.00 32.00 -96.00 0.00 -33.00 32.00 -64.00 33.00 -96.00 64.00 -65.00 32.00 -32.00 0.00 -96.00 129.00 -97.00 0.00 -64.00 32.00 0.00 32.00 -129.00 -32.00 -96.00 96.00 0.00 129.00 0.00 64.00 -32.00 322.00 64.00 96.00 -64.00 32.00 32.00 32.00 -32.00 65.00 0.00 96.00 32.00 225.00 -32.00 65.00 -32.00 64.00 -161.00 64.00 -32.00 65.00 32.00 0.00 -32.00 0.00 -65.00 32.00 -64.00 193.00 0.00 96.00 97.00 32.00 -33.00 32.00 -96.00 97.00 -96.00 32.00 -65.00 96.00 -161.00 129.00 -64.00 0.00 -64.00 161.00 -290.00 32.00 -32.00 32.00 -96.00 0.00 -64.00 -96.00 -258.00 -32.00 -96.00 32.00 0.00 0.00 -32.00 64.00 0.00 32.00 96.00 64.00 0.00 65.00 0.00 0.00 -64.00 -32.00 -97.00 0.00 -32.00 32.00 -64.00 96.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -96.00 64.00 -97.00 0.00 -32.00 -32.00 -64.00 0.00 -32.00 129.00 -193.00 0.00 -64.00 -64.00 -65.00 0.00 -160.00 32.00 -97.00 64.00 -32.00 97.00 -64.00 0.00 -33.00 -65.00 -32.00 -32.00 -64.00 0.00 -96.00 64.00 -97.00 0.00 -129.00 97.00 -64.00 128.00 0.00 33.00 -32.00 96.00 -225.00 129.00 -32.00 64.00 -161.00 64.00 -64.00 32.00 -32.00 193.00 32.00 65.00 -65.00 32.00 -64.00 64.00 0.00 64.00 -129.00 129.00 -32.00 97.00 65.00 96.00 -65.00 64.00 -64.00 32.00 -64.00 65.00 0.00 96.00 64.00 32.00 161.00 33.00 64.00 96.00 32.00 129.00 -32.00 225.00 -129.00 225.00 -128.00 0.00 -97.00 64.00 -96.00 32.00 0.00 193.00 -129.00 32.00 0.00 0.00 -32.00 -64.00 -64.00 32.00 -97.00 0.00 -64.00 0.00 -96.00 97.00 -161.00 96.00 -64.00 32.00 -65.00 -64.00 -96.00 0.00 -97.00 32.00 -32.00 32.00 -64.00 32.00 -32.00 32.00 -65.00 0.00 -32.00 -32.00 -96.00 32.00 -65.00 33.00 0.00 128.00 -257.00 -32.00 -160.00 161.00 -258.00 -32.00 -128.00 32.00 -97.00 -32.00 -64.00 -65.00 -64.00 0.00 -65.00 -64.00 -96.00 32.00 -64.00 32.00 -65.00 0.00 -32.00 -32.00 -129.00 65.00 -32.00 32.00 -96.00 -32.00 -161.00 32.00 -64.00 64.00 -193.00 97.00 -193.00 64.00 -129.00 64.00 -64.00 0.00 -97.00 -32.00 -128.00 0.00 -64.00 32.00 0.00 32.00 0.00 65.00 64.00 96.00 0.00 129.00 -97.00 32.00 -64.00 32.00 -96.00 -97.00 -225.00 0.00 -129.00 -64.00 -96.00 0.00 -97.00 97.00 -96.00 0.00 -65.00 0.00 -128.00 0.00 -65.00 0.00 -32.00 0.00 -96.00 0.00 -32.00 -65.00 -129.00 32.00 -96.00 -32.00 -65.00 32.00 -161.00 -96.00 -128.00 32.00 -64.00 32.00 -33.00 32.00 0.00 65.00 -32.00 64.00 32.00 97.00 -128.00 64.00 -193.00 32.00 -161.00 64.00 -96.00 33.00 -322.00 96.00 -128.00 129.00 -65.00 96.00 -96.00 64.00 -129.00 65.00 -32.00 32.00 -64.00 -32.00 -129.00 0.00 -129.00 96.00 -64.00 32.00 -64.00 65.00 -64.00 64.00 -97.00 32.00 -32.00 0.00 -161.00 32.00 -32.00 64.00 -96.00 0.00 -129.00 0.00 -64.00 -64.00 -65.00 -32.00 0.00 32.00 -64.00 32.00 -64.00 -32.00 -129.00 32.00 -161.00 0.00 -64.00 -32.00 -32.00 -64.00 -129.00 32.00 -32.00 129.00 -32.00 32.00 -64.00 0.00 -33.00 -65.00 -32.00 -32.00 -96.00 65.00 -32.00 64.00 32.00 32.00 0.00 64.00 -97.00 97.00 -32.00 0.00 -193.00 32.00 -96.00 32.00 -97.00 32.00 -64.00 0.00 -64.00 -32.00 -64.00 64.00 -97.00 33.00 -64.00 -33.00 -32.00 33.00 -33.00 32.00 0.00 -32.00 -128.00 32.00 -65.00 32.00 0.00 0.00 -64.00 32.00 -32.00 -64.00 0.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 32.00 -33.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 97.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 64.00 -65.00 64.00 33.00 32.00 -33.00 -32.00 -96.00 32.00 -32.00 65.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 -64.00 32.00 -64.00 64.00 0.00 0.00 -32.00 0.00 -65.00 33.00 -32.00 -33.00 -32.00 33.00 0.00 64.00 0.00 0.00 -32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 -32.00 -64.00 32.00 0.00 65.00 32.00 0.00 -32.00 -33.00 -33.00 0.00 -32.00 33.00 -32.00 128.00 -64.00 0.00 -32.00 97.00 0.00 32.00 0.00 32.00 -97.00 96.00 0.00 33.00 -64.00 96.00 0.00 -64.00 -32.00 32.00 0.00 64.00 -33.00 65.00 0.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 32.00 0.00 0.00 32.00 33.00 32.00 32.00 0.00 32.00 -32.00 0.00 -64.00 128.00 -64.00 -64.00 96.00 0.00 96.00 -32.00 0.00 0.00 33.00 -64.00 0.00 0.00 32.00 -32.00 32.00 -65.00 32.00 -32.00 32.00 0.00 65.00 -32.00 32.00 -32.00 0.00 0.00 161.00 -65.00 64.00 33.00 64.00 64.00 32.00 0.00 65.00 32.00 -33.00 0.00 -32.00 32.00 32.00 32.00 33.00 -64.00 0.00 0.00 32.00 -96.00 64.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 96.00 32.00 129.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 0.00 32.00 -32.00 65.00 0.00 32.00 -33.00 64.00 33.00 32.00 -33.00 0.00 -32.00 -32.00 0.00 65.00 -32.00 -33.00 -32.00 0.00 0.00 33.00 0.00 -33.00 0.00 -32.00 -32.00 32.00 32.00 65.00 0.00 32.00 -32.00 32.00 64.00 32.00 0.00 97.00 -64.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -64.00 64.00 32.00 65.00 -32.00 32.00 -32.00 64.00 32.00 32.00 0.00 65.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 64.00 32.00 -32.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 -32.00 65.00 32.00 -32.00 0.00 64.00 0.00 0.00 32.00 64.00 0.00 0.00 33.00 32.00 -33.00 0.00 33.00 33.00 0.00 0.00 64.00 64.00 32.00 0.00 -32.00 32.00 64.00 32.00 0.00 0.00 32.00 65.00 32.00 0.00 -32.00 32.00 0.00 32.00 32.00 64.00 -32.00 32.00 32.00 129.00 33.00 64.00 32.00 32.00 -32.00 129.00 0.00 32.00 64.00 97.00 0.00 32.00 64.00 32.00 0.00 96.00 -32.00 65.00 32.00 64.00 64.00 32.00 -32.00 129.00 97.00 64.00 0.00 96.00 32.00 33.00 0.00 32.00 32.00 1415.00 836.00 675.00 386.00 450.00 257.00 129.00 -96.00 0.00 -65.00 0.00 -32.00 -33.00 -96.00 33.00 -65.00 -33.00 -64.00 33.00 -64.00 -65.00 -97.00 32.00 -64.00 33.00 -64.00 0.00 -65.00 -65.00 -32.00 0.00 -32.00 97.00 -193.00 64.00 -64.00 96.00 -129.00 97.00 -160.00 32.00 0.00 0.00 -65.00 -32.00 0.00 0.00 -32.00 64.00 -129.00 32.00 -32.00 33.00 0.00 0.00 -32.00 32.00 -64.00 0.00 -97.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 32.00 33.00 -32.00 64.00 -32.00 0.00 -65.00 32.00 -32.00 97.00 -64.00 64.00 -64.00 32.00 0.00 32.00 -97.00 97.00 -64.00 64.00 225.00 32.00 0.00 64.00 64.00 97.00 0.00 -32.00 32.00 0.00 33.00 0.00 32.00 -65.00 64.00 32.00 32.00 -32.00 0.00 0.00 32.00 32.00 65.00 129.00 0.00 0.00 32.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 32.00 32.00 32.00 32.00 64.00 97.00 64.00 32.00 65.00 450.00 -675.00 32.00 -33.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 32.00 32.00 33.00 0.00 32.00 0.00 0.00 65.00 32.00 32.00 -32.00 64.00 32.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 0.00 0.00 32.00 32.00 33.00 0.00 32.00 33.00 0.00 32.00 32.00 32.00 0.00 0.00 64.00 32.00 0.00 0.00 -32.00 97.00 96.00 32.00 33.00 32.00 0.00 32.00 64.00 32.00 0.00 32.00 64.00 -32.00 64.00 32.00 65.00 0.00 64.00 0.00 97.00 32.00 0.00 33.00 64.00 32.00 -32.00 32.00 32.00 0.00 -32.00 64.00 0.00 0.00 32.00 32.00 0.00 0.00 -64.00 33.00 0.00 32.00 64.00 32.00 -32.00 32.00 32.00 0.00 32.00 32.00 0.00 64.00 0.00 0.00 32.00 0.00 64.00 33.00 97.00 64.00 0.00 32.00 32.00 32.00 0.00 0.00 32.00 0.00 65.00 32.00 0.00 0.00 32.00 33.00 64.00 -33.00 32.00 65.00 0.00 32.00 97.00 -32.00 32.00 0.00 64.00 -32.00 0.00 0.00 32.00 -33.00 0.00 33.00 32.00 0.00 65.00 64.00 32.00 -32.00 32.00 32.00 32.00 -32.00 0.00 0.00 97.00 0.00 64.00 -65.00 64.00 -32.00 0.00 32.00 65.00 33.00 32.00 0.00 32.00 -33.00 96.00 -32.00 65.00 97.00 96.00 32.00 0.00 32.00 0.00 64.00 -64.00 0.00 -97.00 -32.00 -32.00 32.00 -96.00 0.00 -97.00 32.00 -32.00 -32.00 -32.00 0.00 -97.00 65.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -64.00 0.00 -129.00 64.00 -64.00 65.00 32.00 32.00 32.00 32.00 0.00 0.00 -64.00 32.00 32.00 0.00 32.00 32.00 97.00 -32.00 0.00 0.00 32.00 0.00 32.00 0.00 64.00 -32.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 0.00 32.00 0.00 64.00 32.00 0.00 0.00 32.00 65.00 33.00 -33.00 0.00 0.00 32.00 33.00 32.00 -33.00 0.00 0.00 96.00 65.00 0.00 32.00 65.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 -64.00 32.00 0.00 0.00 -32.00 33.00 0.00 32.00 -33.00 32.00 0.00 32.00 33.00 32.00 0.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 64.00 0.00 32.00 0.00 33.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 0.00 96.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 0.00 33.00 0.00 0.00 -32.00 0.00 65.00 32.00 -33.00 32.00 0.00 0.00 -32.00 64.00 0.00 32.00 -32.00 0.00 -32.00 33.00 0.00 32.00 -64.00 32.00 32.00 32.00 -32.00 32.00 32.00 64.00 -32.00 0.00 -32.00 33.00 -33.00 32.00 0.00 32.00 -32.00 64.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 -32.00 33.00 0.00 64.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 32.00 64.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 33.00 32.00 0.00 0.00 160.00 -64.00 97.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 33.00 -32.00 96.00 -32.00 0.00 -33.00 32.00 33.00 32.00 -33.00 33.00 33.00 32.00 -33.00 64.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -129.00 32.00 -32.00 0.00 32.00 65.00 -32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 33.00 0.00 32.00 96.00 0.00 32.00 32.00 -32.00 32.00 0.00 32.00 32.00 -32.00 32.00 64.00 97.00 -32.00 64.00 0.00 32.00 97.00 32.00 32.00 0.00 32.00 33.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -97.00 32.00 33.00 33.00 0.00 32.00 0.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 64.00 32.00 0.00 32.00 -32.00 0.00 32.00 33.00 32.00 64.00 0.00 32.00 -32.00 96.00 32.00 97.00 -32.00 96.00 64.00 0.00 33.00 579.00 643.00 32.00 -97.00 32.00 -64.00 33.00 -32.00 32.00 -65.00 32.00 -32.00 32.00 -64.00 32.00 0.00 32.00 -32.00 0.00 -97.00 -64.00 0.00 -64.00 -64.00 0.00 -64.00 -32.00 -97.00 32.00 -32.00 -32.00 -64.00 0.00 -32.00 0.00 -97.00 32.00 0.00 64.00 -64.00 -32.00 -64.00 0.00 -33.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 33.00 0.00 -33.00 -33.00 33.00 -32.00 -33.00 0.00 33.00 -32.00 32.00 -64.00 -97.00 -32.00 65.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -33.00 32.00 -64.00 32.00 32.00 32.00 -32.00 129.00 64.00 97.00 0.00 32.00 33.00 -32.00 128.00 32.00 161.00 96.00 32.00 64.00 -32.00 33.00 0.00 64.00 32.00 32.00 0.00 64.00 -32.00 65.00 0.00 -65.00 129.00 0.00 64.00 129.00 32.00 64.00 -32.00 65.00 32.00 32.00 32.00 -97.00 32.00 -32.00 33.00 97.00 96.00 0.00 64.00 32.00 32.00 32.00 0.00 32.00 -96.00 97.00 -32.00 0.00 -64.00 32.00 -33.00 32.00 0.00 32.00 -64.00 32.00 32.00 64.00 65.00 65.00 0.00 96.00 32.00 32.00 -32.00 97.00 0.00 0.00 32.00 32.00 0.00 -32.00 32.00 64.00 0.00 32.00 -64.00 32.00 0.00 0.00 -65.00 65.00 0.00 32.00 -32.00 -32.00 -96.00 96.00 -33.00 0.00 -32.00 32.00 0.00 33.00 0.00 32.00 -32.00 64.00 32.00 64.00 -32.00 32.00 32.00 -32.00 32.00 65.00 33.00 32.00 -33.00 64.00 33.00 64.00 -33.00 0.00 -64.00 -32.00 0.00 64.00 -64.00 65.00 0.00 32.00 -32.00 0.00 64.00 32.00 0.00 0.00 -32.00 32.00 -32.00 32.00 32.00 0.00 32.00 33.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 0.00 0.00 -33.00 32.00 33.00 64.00 -33.00 33.00 -32.00 32.00 0.00 64.00 -32.00 64.00 0.00 0.00 -64.00 0.00 -32.00 32.00 0.00 33.00 0.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -32.00 64.00 -65.00 64.00 0.00 33.00 -64.00 96.00 -32.00 0.00 -32.00 64.00 -65.00 65.00 -32.00 32.00 -64.00 64.00 0.00 0.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 32.00 97.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -65.00 32.00 0.00 0.00 -64.00 65.00 -32.00 -33.00 -32.00 33.00 0.00 321.00 -193.00 547.00 32.00 739.00 0.00 129.00 0.00 0.00 -129.00 32.00 -32.00 32.00 -32.00 32.00 0.00 65.00 -546.00 32.00 32.00 0.00 64.00 0.00 32.00 32.00 0.00 32.00 32.00 64.00 -32.00 32.00 32.00 0.00 -32.00 0.00 65.00 65.00 32.00 -32.00 64.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 33.00 0.00 32.00 0.00 96.00 -32.00 32.00 0.00 32.00 0.00 65.00 -33.00 32.00 33.00 32.00 -33.00 64.00 65.00 33.00 128.00 -33.00 0.00 -32.00 129.00 0.00 97.00 -32.00 32.00 -32.00 32.00 32.00 161.00 -64.00 0.00 32.00 96.00 -32.00 129.00 0.00 32.00 -32.00 32.00 -33.00 0.00 -32.00 96.00 -32.00 65.00 32.00 128.00 -64.00 33.00 -32.00 0.00 64.00 -65.00 129.00 -64.00 32.00 -64.00 64.00 -65.00 0.00 -32.00 32.00 -96.00 33.00 -33.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 -96.00 32.00 0.00 64.00 -32.00 32.00 0.00 33.00 0.00 32.00 -32.00 32.00 -33.00 64.00 -32.00 65.00 -96.00 96.00 32.00 64.00 32.00 65.00 32.00 0.00 32.00 32.00 0.00 96.00 -64.00 32.00 32.00 65.00 -64.00 32.00 32.00 32.00 32.00 0.00 0.00 64.00 0.00 32.00 -64.00 33.00 0.00 64.00 -32.00 96.00 -32.00 33.00 0.00 32.00 128.00 0.00 0.00 64.00 0.00 64.00 -64.00 97.00 96.00 64.00 33.00 0.00 0.00 64.00 32.00 97.00 32.00 0.00 32.00 0.00 129.00 -64.00 96.00 -97.00 64.00 32.00 161.00 -32.00 193.00 -129.00 32.00 -32.00 65.00 0.00 64.00 -32.00 161.00 -64.00 64.00 32.00 32.00 32.00 0.00 32.00 -32.00 129.00 -161.00 96.00 -64.00 33.00 -64.00 128.00 -65.00 32.00 -32.00 32.00 -96.00 33.00 -97.00 32.00 -96.00 32.00 -97.00 32.00 -32.00 64.00 -96.00 65.00 0.00 32.00 0.00 32.00 64.00 -32.00 32.00 64.00 64.00 97.00 0.00 32.00 -96.00 32.00 0.00 32.00 32.00 0.00 0.00 64.00 -32.00 65.00 -64.00 64.00 32.00 64.00 -32.00 65.00 32.00 64.00 32.00 32.00 32.00 -32.00 32.00 32.00 129.00 -32.00 96.00 96.00 32.00 32.00 -128.00 129.00 -129.00 64.00 -32.00 65.00 -32.00 0.00 -64.00 64.00 -65.00 129.00 -32.00 32.00 32.00 32.00 65.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 -129.00 97.00 0.00 32.00 64.00 32.00 97.00 -32.00 64.00 129.00 -32.00 32.00 -225.00 64.00 -32.00 32.00 96.00 65.00 -32.00 64.00 0.00 32.00 96.00 0.00 65.00 64.00 0.00 32.00 0.00 33.00 -129.00 225.00 0.00 128.00 -32.00 97.00 161.00 96.00 64.00 32.00 32.00 33.00 -32.00 96.00 64.00 64.00 -32.00 32.00 -64.00 129.00 -97.00 64.00 33.00 0.00 32.00 0.00 32.00 65.00 -64.00 96.00 -33.00 0.00 -32.00 -32.00 -64.00 64.00 64.00 32.00 97.00 0.00 96.00 65.00 64.00 0.00 0.00 32.00 0.00 96.00 65.00 32.00 161.00 33.00 96.00 -33.00 64.00 33.00 33.00 64.00 -33.00 96.00 97.00 0.00 0.00 65.00 32.00 0.00 64.00 -32.00 65.00 -33.00 64.00 65.00 -64.00 128.00 96.00 65.00 64.00 0.00 32.00 64.00 0.00 32.00 33.00 0.00 32.00 -32.00 64.00 0.00 32.00 32.00 -32.00 64.00 97.00 0.00 64.00 33.00 32.00 192.00 32.00 33.00 32.00 64.00 65.00 32.00 64.00 0.00 32.00 32.00 -32.00 65.00 0.00 32.00 -32.00 32.00 -32.00 32.00 0.00 97.00 -32.00 32.00 -65.00 0.00 -64.00 64.00 -32.00 0.00 -32.00 32.00 -97.00 -32.00 -64.00 -96.00 -32.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 0.00 64.00 -32.00 33.00 -32.00 64.00 32.00 32.00 64.00 64.00 0.00 32.00 0.00 33.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 64.00 64.00 33.00 33.00 -33.00 32.00 -64.00 -32.00 32.00 64.00 -32.00 0.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 0.00 32.00 32.00 -32.00 97.00 -64.00 32.00 96.00 96.00 0.00 33.00 -64.00 64.00 32.00 32.00 0.00 64.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 0.00 32.00 -65.00 0.00 0.00 33.00 0.00 32.00 -32.00 32.00 32.00 32.00 65.00 64.00 32.00 0.00 0.00 33.00 0.00 96.00 -32.00 0.00 0.00 64.00 0.00 97.00 0.00 32.00 0.00 32.00 0.00 97.00 -32.00 32.00 -33.00 32.00 0.00 32.00 -64.00 32.00 -64.00 32.00 0.00 32.00 32.00 0.00 64.00 97.00 -32.00 96.00 -32.00 0.00 -32.00 65.00 -64.00 96.00 -65.00 -32.00 -32.00 129.00 -32.00 32.00 -64.00 0.00 -32.00 0.00 -33.00 -65.00 -64.00 0.00 -32.00 33.00 -32.00 0.00 -65.00 -65.00 0.00 -32.00 -32.00 0.00 32.00 97.00 -96.00 96.00 -129.00 -64.00 -32.00 0.00 0.00 32.00 -64.00 0.00 -32.00 -97.00 -65.00 0.00 -64.00 33.00 -128.00 0.00 -33.00 -33.00 0.00 -64.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 -32.00 32.00 -33.00 32.00 -96.00 -64.00 0.00 -32.00 -32.00 0.00 -65.00 0.00 -96.00 -65.00 0.00 0.00 -64.00 -96.00 -32.00 -32.00 0.00 -32.00 -33.00 -33.00 0.00 -128.00 -128.00 -129.00 -64.00 -64.00 -97.00 -96.00 0.00 -33.00 -96.00 0.00 -33.00 -96.00 33.00 -64.00 -33.00 -33.00 65.00 33.00 64.00 -33.00 32.00 -32.00 32.00 -96.00 33.00 -32.00 0.00 0.00 96.00 -97.00 64.00 0.00 65.00 32.00 64.00 0.00 32.00 0.00 32.00 97.00 32.00 32.00 0.00 64.00 97.00 -64.00 161.00 -32.00 64.00 -32.00 161.00 32.00 64.00 0.00 64.00 32.00 32.00 64.00 33.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 96.00 64.00 33.00 0.00 32.00 32.00 32.00 33.00 129.00 -33.00 32.00 -64.00 -32.00 -32.00 0.00 -64.00 64.00 -33.00 0.00 -32.00 32.00 -64.00 64.00 -64.00 -32.00 -65.00 32.00 -32.00 0.00 -96.00 32.00 -64.00 -32.00 -65.00 -32.00 -128.00 -96.00 -97.00 -32.00 -128.00 -65.00 -129.00 -32.00 -129.00 -64.00 -193.00 -32.00 -160.00 -33.00 -33.00 65.00 -257.00 161.00 -32.00 32.00 0.00 64.00 64.00 64.00 65.00 32.00 0.00 65.00 64.00 32.00 -32.00 32.00 -32.00 64.00 -65.00 129.00 -32.00 96.00 -96.00 129.00 32.00 97.00 -32.00 32.00 64.00 128.00 64.00 -64.00 33.00 -32.00 32.00 0.00 32.00 0.00 0.00 225.00 96.00 0.00 161.00 193.00 -32.00 128.00 -64.00 0.00 -65.00 65.00 97.00 32.00 0.00 32.00 -65.00 64.00 -96.00 33.00 -64.00 32.00 -65.00 64.00 -96.00 129.00 0.00 192.00 -64.00 193.00 0.00 161.00 0.00 64.00 128.00 97.00 97.00 32.00 64.00 64.00 32.00 0.00 0.00 33.00 129.00 32.00 0.00 32.00 -32.00 64.00 32.00 64.00 -32.00 161.00 64.00 129.00 96.00 96.00 0.00 97.00 65.00 161.00 -65.00 128.00 33.00 32.00 -33.00 32.00 97.00 161.00 0.00 65.00 -32.00 32.00 0.00 32.00 -65.00 0.00 -643.00 161.00 -450.00 96.00 -128.00 97.00 -33.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -64.00 -65.00 -65.00 32.00 32.00 -64.00 -32.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 65.00 32.00 0.00 -32.00 0.00 0.00 32.00 32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 -32.00 0.00 32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 33.00 -32.00 32.00 0.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 -32.00 -97.00 0.00 0.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 -32.00 0.00 64.00 -65.00 32.00 33.00 0.00 -65.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -65.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 0.00 -32.00 -32.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 -33.00 -64.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 32.00 0.00 0.00 -64.00 33.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -97.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 0.00 -64.00 32.00 0.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 32.00 -64.00 0.00 -65.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 -65.00 -32.00 -64.00 64.00 -161.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -96.00 -32.00 -129.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 0.00 -65.00 -96.00 -64.00 0.00 0.00 -225.00 -386.00 0.00 -321.00 0.00 -450.00 0.00 -547.00 0.00 -1222.00 0.00 -96.00 0.00 -708.00 0.00 0.00 64.00 0.00 515.00 -64.00 0.00 -64.00 96.00 -32.00 97.00 -33.00 128.00 0.00 97.00 65.00 32.00 64.00 -32.00 32.00 64.00 32.00 129.00 -32.00 64.00 -32.00 0.00 -96.00 129.00 -33.00 64.00 -128.00 32.00 -65.00 96.00 0.00 33.00 0.00 64.00 33.00 161.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 64.00 32.00 0.00 0.00 65.00 -32.00 0.00 0.00 32.00 32.00 32.00 32.00 -32.00 64.00 32.00 0.00 32.00 0.00 65.00 -64.00 64.00 32.00 32.00 -32.00 96.00 -32.00 65.00 0.00 96.00 -32.00 97.00 0.00 32.00 900.00 0.00 257.00 0.00 64.00 0.00 386.00 0.00 579.00 0.00 643.00 -32.00 289.00 0.00 1480.00 0.00 0.00 32.00 0.00 32.00 -33.00 32.00 33.00 32.00 0.00 32.00 -33.00 0.00 0.00 33.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 32.00 -32.00 0.00 0.00 33.00 -65.00 32.00 33.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 0.00 32.00 33.00 0.00 32.00 -32.00 32.00 32.00 0.00 32.00 64.00 -32.00 0.00 32.00 32.00 32.00 32.00 -32.00 0.00 32.00 97.00 -32.00 96.00 -32.00 0.00 0.00 33.00 -64.00 32.00 -33.00 64.00 33.00 32.00 -33.00 32.00 0.00 65.00 -32.00 32.00 -32.00 96.00 -32.00 0.00 -32.00 65.00 -97.00 160.00 -64.00 32.00 -32.00 33.00 -32.00 32.00 32.00 128.00 -32.00 97.00 -65.00 32.00 -32.00 64.00 -32.00 33.00 0.00 96.00 0.00 64.00 0.00 32.00 32.00 33.00 32.00 64.00 0.00 64.00 65.00 0.00 -32.00 32.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 -32.00 33.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 64.00 0.00 33.00 0.00 0.00 32.00 32.00 32.00 0.00 -32.00 64.00 0.00 0.00 64.00 0.00 33.00 32.00 0.00 0.00 -33.00 64.00 -32.00 0.00 32.00 65.00 0.00 0.00 33.00 32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 64.00 -64.00 0.00 -32.00 32.00 32.00 -32.00 64.00 32.00 -32.00 33.00 64.00 0.00 32.00 32.00 -32.00 32.00 0.00 0.00 65.00 32.00 -33.00 0.00 33.00 0.00 32.00 32.00 0.00 0.00 64.00 32.00 32.00 32.00 -32.00 33.00 -32.00 32.00 64.00 -32.00 0.00 32.00 0.00 32.00 32.00 -64.00 32.00 32.00 33.00 32.00 -33.00 0.00 97.00 -32.00 32.00 32.00 0.00 32.00 0.00 64.00 32.00 0.00 64.00 0.00 33.00 -32.00 0.00 32.00 32.00 -32.00 32.00 -32.00 64.00 32.00 32.00 32.00 0.00 -32.00 0.00 0.00 65.00 65.00 0.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 64.00 33.00 -32.00 32.00 0.00 32.00 96.00 -32.00 -64.00 64.00 32.00 97.00 0.00 32.00 -64.00 0.00 32.00 64.00 32.00 0.00 0.00 32.00 32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 32.00 32.00 0.00 -32.00 65.00 64.00 -32.00 32.00 0.00 33.00 64.00 32.00 0.00 32.00 32.00 -97.00 32.00 33.00 32.00 0.00 33.00 32.00 -33.00 32.00 33.00 -32.00 32.00 64.00 32.00 -32.00 32.00 32.00 32.00 32.00 -32.00 0.00 32.00 64.00 32.00 33.00 32.00 -33.00 33.00 -96.00 32.00 64.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 64.00 -32.00 0.00 32.00 -64.00 32.00 32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 33.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 -65.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 96.00 32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 32.00 0.00 -32.00 33.00 -32.00 -33.00 -32.00 33.00 32.00 32.00 -97.00 -32.00 0.00 32.00 -32.00 0.00 0.00 32.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 96.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -33.00 -32.00 0.00 97.00 -32.00 -65.00 -32.00 65.00 32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 32.00 64.00 -64.00 -32.00 -64.00 32.00 32.00 32.00 -32.00 33.00 -33.00 -65.00 -64.00 32.00 0.00 -32.00 -32.00 32.00 32.00 33.00 -32.00 32.00 -97.00 0.00 33.00 32.00 -33.00 32.00 65.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 32.00 32.00 33.00 33.00 0.00 32.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 32.00 64.00 -32.00 0.00 32.00 33.00 -32.00 32.00 -32.00 -32.00 -65.00 0.00 0.00 32.00 0.00 32.00 -64.00 0.00 32.00 32.00 0.00 32.00 -96.00 32.00 0.00 33.00 32.00 0.00 32.00 32.00 0.00 32.00 -32.00 32.00 32.00 64.00 0.00 32.00 -64.00 -32.00 -33.00 32.00 -32.00 0.00 0.00 33.00 -32.00 0.00 64.00 64.00 -32.00 32.00 0.00 -32.00 -64.00 0.00 32.00 32.00 -32.00 32.00 -32.00 -64.00 -97.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 0.00 -33.00 0.00 65.00 32.00 0.00 -96.00 64.00 32.00 32.00 0.00 97.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 0.00 32.00 33.00 0.00 0.00 32.00 -65.00 0.00 32.00 33.00 0.00 32.00 33.00 0.00 0.00 32.00 0.00 64.00 -65.00 0.00 -32.00 64.00 32.00 0.00 97.00 33.00 32.00 64.00 32.00 32.00 0.00 64.00 0.00 97.00 0.00 32.00 32.00 0.00 32.00 32.00 65.00 -96.00 32.00 128.00 32.00 0.00 32.00 0.00 32.00 -32.00 161.00 -32.00 64.00 -32.00 65.00 0.00 64.00 32.00 96.00 32.00 97.00 -32.00 64.00 32.00 32.00 64.00 33.00 65.00 96.00 96.00 64.00 97.00 32.00 64.00 0.00 64.00 0.00 97.00 -64.00 0.00 0.00 64.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 33.00 -64.00 64.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -33.00 32.00 0.00 64.00 -32.00 65.00 -64.00 64.00 -32.00 32.00 0.00 32.00 32.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 -65.00 32.00 0.00 32.00 33.00 32.00 -33.00 33.00 -32.00 0.00 65.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 32.00 32.00 32.00 65.00 0.00 32.00 0.00 32.00 32.00 32.00 -32.00 64.00 32.00 33.00 -32.00 0.00 32.00 32.00 33.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 33.00 32.00 0.00 0.00 64.00 96.00 64.00 0.00 65.00 -32.00 0.00 0.00 32.00 0.00 64.00 32.00 0.00 0.00 32.00 65.00 32.00 32.00 33.00 -32.00 32.00 32.00 32.00 -32.00 0.00 32.00 0.00 32.00 64.00 0.00 64.00 -32.00 33.00 -32.00 0.00 -32.00 0.00 32.00 64.00 -65.00 -32.00 -32.00 0.00 -96.00 64.00 -32.00 32.00 -65.00 -32.00 0.00 64.00 32.00 0.00 0.00 32.00 -64.00 33.00 0.00 32.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 64.00 -65.00 32.00 65.00 0.00 0.00 32.00 -65.00 0.00 -32.00 33.00 0.00 -33.00 -64.00 0.00 -32.00 65.00 32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 64.00 -32.00 0.00 0.00 32.00 -64.00 -32.00 0.00 32.00 -33.00 33.00 33.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 -32.00 -64.00 32.00 0.00 64.00 -65.00 32.00 0.00 32.00 0.00 33.00 -32.00 -33.00 0.00 -32.00 0.00 -96.00 0.00 -32.00 -32.00 0.00 -64.00 64.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 -64.00 0.00 64.00 33.00 -32.00 0.00 -32.00 0.00 -64.00 64.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 -65.00 32.00 32.00 64.00 -64.00 33.00 -32.00 32.00 32.00 32.00 32.00 64.00 65.00 32.00 -65.00 65.00 0.00 32.00 -32.00 0.00 -64.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 161.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -64.00 64.00 -33.00 0.00 -32.00 0.00 0.00 -64.00 -128.00 0.00 32.00 64.00 -32.00 0.00 -32.00 32.00 -33.00 64.00 33.00 33.00 0.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 -64.00 32.00 0.00 64.00 -32.00 64.00 32.00 32.00 0.00 33.00 -32.00 0.00 -65.00 -33.00 -32.00 -32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 32.00 -128.00 -64.00 -32.00 32.00 -33.00 97.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 -97.00 -33.00 0.00 -32.00 0.00 0.00 -64.00 0.00 -64.00 0.00 -33.00 -96.00 65.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -65.00 -32.00 -64.00 -32.00 -32.00 -64.00 -32.00 -32.00 -32.00 0.00 -33.00 64.00 -32.00 32.00 -64.00 0.00 -32.00 0.00 -97.00 -32.00 -64.00 -32.00 -97.00 -32.00 0.00 -65.00 -64.00 -64.00 0.00 -64.00 -64.00 0.00 -97.00 -32.00 -128.00 0.00 -32.00 -32.00 0.00 -65.00 -129.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -65.00 64.00 -128.00 97.00 0.00 32.00 64.00 32.00 0.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -161.00 0.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 -33.00 0.00 -64.00 32.00 -64.00 -32.00 -161.00 96.00 -32.00 -32.00 32.00 -64.00 -32.00 -33.00 -32.00 0.00 -97.00 65.00 -64.00 -65.00 -97.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 -96.00 0.00 -32.00 32.00 -33.00 0.00 -193.00 -32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -64.00 0.00 -65.00 0.00 -64.00 32.00 -64.00 -32.00 -97.00 32.00 -96.00 -32.00 -97.00 65.00 -64.00 -33.00 -64.00 33.00 -65.00 96.00 -64.00 0.00 -32.00 -161.00 -32.00 -32.00 -161.00 -32.00 -32.00 -64.00 -129.00 0.00 -32.00 -65.00 -96.00 0.00 -97.00 97.00 -64.00 32.00 -32.00 32.00 -32.00 0.00 0.00 97.00 -32.00 0.00 -33.00 64.00 -32.00 0.00 -96.00 -32.00 -97.00 64.00 0.00 64.00 -32.00 65.00 -129.00 64.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 -64.00 0.00 0.00 -33.00 32.00 -32.00 0.00 -32.00 -97.00 0.00 -128.00 97.00 -32.00 32.00 -129.00 32.00 -96.00 -32.00 -33.00 32.00 0.00 32.00 97.00 64.00 0.00 32.00 0.00 33.00 -32.00 32.00 -65.00 32.00 -64.00 64.00 -64.00 129.00 -32.00 96.00 -97.00 33.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 96.00 -33.00 32.00 -96.00 -32.00 -32.00 0.00 -64.00 161.00 -97.00 96.00 -32.00 97.00 -32.00 32.00 -97.00 32.00 -64.00 -32.00 -32.00 0.00 -64.00 -161.00 -226.00 -225.00 -32.00 -96.00 0.00 -64.00 0.00 -97.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -96.00 -32.00 -65.00 32.00 -32.00 0.00 -32.00 32.00 32.00 129.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 -32.00 -257.00 32.00 -96.00 32.00 0.00 32.00 -33.00 32.00 97.00 97.00 -32.00 64.00 -32.00 0.00 -97.00 -64.00 -32.00 0.00 -64.00 0.00 -65.00 32.00 -96.00 64.00 -64.00 32.00 -33.00 0.00 -64.00 -32.00 -64.00 32.00 -32.00 65.00 -32.00 64.00 -33.00 0.00 -32.00 0.00 -96.00 -32.00 -97.00 0.00 -64.00 -64.00 -64.00 0.00 -32.00 -33.00 -33.00 -32.00 -32.00 0.00 -96.00 65.00 -129.00 0.00 -193.00 -33.00 -32.00 -64.00 -161.00 0.00 -64.00 0.00 -32.00 32.00 -64.00 161.00 -65.00 64.00 -96.00 97.00 -386.00 -64.00 -161.00 96.00 -96.00 0.00 -161.00 -32.00 -97.00 32.00 -64.00 32.00 -32.00 32.00 -64.00 32.00 -65.00 65.00 -160.00 225.00 -97.00 257.00 -32.00 32.00 -64.00 0.00 -97.00 32.00 -32.00 33.00 0.00 32.00 -96.00 257.00 -97.00 129.00 -32.00 0.00 -129.00 64.00 -64.00 32.00 0.00 64.00 64.00 161.00 -32.00 97.00 32.00 32.00 0.00 128.00 -128.00 193.00 -64.00 129.00 -33.00 0.00 0.00 32.00 -128.00 64.00 -65.00 65.00 -289.00 0.00 -64.00 0.00 -65.00 0.00 -32.00 32.00 32.00 96.00 -32.00 64.00 -257.00 65.00 -32.00 64.00 0.00 64.00 0.00 33.00 -32.00 64.00 -97.00 128.00 -96.00 0.00 -129.00 129.00 -64.00 97.00 0.00 32.00 -32.00 64.00 0.00 96.00 -65.00 97.00 -32.00 129.00 -64.00 64.00 0.00 32.00 -32.00 64.00 32.00 32.00 161.00 129.00 64.00 97.00 0.00 32.00 -64.00 64.00 -32.00 0.00 -290.00 -96.00 -160.00 -65.00 0.00 -32.00 -33.00 -32.00 -32.00 -32.00 -64.00 -65.00 -97.00 0.00 0.00 -96.00 -96.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 32.00 -97.00 -32.00 65.00 -32.00 0.00 -33.00 -33.00 -32.00 -32.00 -96.00 -32.00 0.00 0.00 -65.00 -64.00 -64.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -97.00 -64.00 0.00 -32.00 -32.00 0.00 -64.00 0.00 -32.00 -33.00 -65.00 0.00 -64.00 -64.00 -129.00 0.00 -64.00 -32.00 -32.00 -64.00 -64.00 0.00 0.00 -33.00 -33.00 33.00 -32.00 -33.00 -32.00 0.00 -32.00 0.00 0.00 33.00 -64.00 0.00 -33.00 32.00 -32.00 -32.00 -96.00 -33.00 0.00 -64.00 -32.00 32.00 -32.00 -32.00 -33.00 -32.00 -32.00 0.00 0.00 -96.00 -128.00 0.00 -65.00 -33.00 -96.00 33.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 -97.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -33.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -65.00 -64.00 -32.00 32.00 -64.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -97.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 -32.00 -97.00 0.00 0.00 -33.00 -64.00 0.00 -32.00 33.00 -65.00 32.00 0.00 -32.00 -64.00 0.00 -64.00 -33.00 -32.00 0.00 -65.00 33.00 -161.00 -97.00 -32.00 32.00 -64.00 -64.00 32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -64.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 0.00 -32.00 0.00 -64.00 0.00 -64.00 -65.00 -32.00 32.00 -65.00 -32.00 32.00 0.00 -64.00 -32.00 32.00 0.00 -128.00 -64.00 -97.00 0.00 0.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 0.00 0.00 33.00 -32.00 0.00 -65.00 -65.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 -65.00 -64.00 0.00 -33.00 -64.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 -32.00 32.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 0.00 -32.00 -33.00 32.00 -32.00 32.00 -32.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 -33.00 0.00 33.00 0.00 -33.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 -32.00 -33.00 0.00 0.00 -32.00 33.00 0.00 -33.00 0.00 -64.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 32.00 -64.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -65.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -65.00 -32.00 -128.00 0.00 -64.00 -65.00 0.00 33.00 -65.00 -33.00 -96.00 0.00 0.00 65.00 -64.00 0.00 -65.00 -32.00 -64.00 -33.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -65.00 0.00 33.00 0.00 0.00 -64.00 -97.00 0.00 32.00 -32.00 -64.00 0.00 0.00 -33.00 -97.00 -96.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -33.00 -64.00 -32.00 0.00 -32.00 -97.00 -193.00 -128.00 0.00 -129.00 -64.00 -96.00 -32.00 0.00 -32.00 -65.00 -33.00 -96.00 0.00 0.00 33.00 -64.00 32.00 -97.00 64.00 -32.00 32.00 -129.00 0.00 -64.00 32.00 -32.00 -32.00 -161.00 -32.00 -32.00 0.00 -161.00 64.00 -64.00 -32.00 -96.00 0.00 -65.00 -32.00 -96.00 0.00 -129.00 -64.00 -64.00 32.00 -64.00 -32.00 -33.00 0.00 0.00 -32.00 -128.00 -65.00 -193.00 -32.00 0.00 -96.00 -32.00 -33.00 -97.00 0.00 32.00 -64.00 -32.00 -64.00 -64.00 -64.00 0.00 -65.00 -32.00 -64.00 0.00 -32.00 96.00 -129.00 129.00 -32.00 32.00 -96.00 32.00 -65.00 97.00 -64.00 32.00 -129.00 0.00 -32.00 32.00 -32.00 32.00 0.00 97.00 0.00 192.00 -32.00 65.00 -129.00 96.00 -96.00 32.00 -97.00 -32.00 -32.00 0.00 -32.00 -96.00 -64.00 -65.00 -32.00 -96.00 -33.00 -32.00 0.00 -225.00 0.00 -225.00 -64.00 -129.00 0.00 -161.00 32.00 -160.00 97.00 -33.00 128.00 -32.00 0.00 -64.00 -32.00 -129.00 0.00 -160.00 -161.00 0.00 -193.00 -33.00 -128.00 0.00 -129.00 -96.00 -289.00 0.00 -97.00 -32.00 -193.00 -32.00 -96.00 32.00 -64.00 64.00 -32.00 32.00 -33.00 129.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -289.00 -32.00 -65.00 -32.00 -32.00 -64.00 -128.00 -161.00 -97.00 32.00 -96.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 -32.00 -32.00 32.00 -161.00 -32.00 -64.00 0.00 -32.00 -65.00 -64.00 -32.00 -65.00 32.00 -32.00 -64.00 -64.00 32.00 -32.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 -32.00 0.00 32.00 -96.00 -65.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 33.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 -33.00 -33.00 0.00 0.00 -64.00 -32.00 -64.00 0.00 -65.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 -32.00 -33.00 -32.00 0.00 -65.00 33.00 0.00 -33.00 0.00 0.00 -32.00 33.00 -64.00 0.00 -32.00 0.00 32.00 0.00 -64.00z"},ms:{name:"MS",path:"M81302.00 122857.00l708.00 -1479.00 482.00 -1061.00 354.00 0.00 64.00 -96.00 -32.00 0.00 32.00 -65.00 -64.00 -64.00 -33.00 -32.00 -32.00 0.00 0.00 -386.00 -225.00 0.00 997.00 -3215.00 482.00 -32.00 0.00 -33.00 -64.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 0.00 32.00 -353.00 -322.00 -33.00 -128.00 -64.00 -290.00 -579.00 -1093.00 193.00 0.00 0.00 -96.00 -193.00 -161.00 65.00 -193.00 -65.00 -64.00 -32.00 0.00 -64.00 -129.00 -32.00 0.00 -65.00 -161.00 -64.00 -32.00 -32.00 -64.00 32.00 -65.00 0.00 -64.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 32.00 -64.00 -64.00 0.00 32.00 0.00 32.00 -65.00 -64.00 33.00 0.00 -33.00 32.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 161.00 32.00 64.00 -129.00 64.00 -32.00 64.00 64.00 0.00 129.00 65.00 32.00 0.00 65.00 0.00 64.00 32.00 128.00 32.00 0.00 0.00 65.00 32.00 0.00 0.00 32.00 0.00 32.00 0.00 32.00 32.00 32.00 0.00 33.00 33.00 0.00 -33.00 32.00 -32.00 32.00 0.00 32.00 0.00 64.00 -32.00 32.00 64.00 33.00 0.00 32.00 33.00 0.00 0.00 32.00 96.00 -32.00 0.00 -32.00 32.00 0.00 65.00 64.00 32.00 64.00 32.00 32.00 -32.00 0.00 32.00 65.00 64.00 32.00 -32.00 32.00 -32.00 0.00 32.00 96.00 0.00 33.00 129.00 -33.00 32.00 97.00 64.00 0.00 32.00 32.00 97.00 64.00 -33.00 65.00 129.00 64.00 161.00 -32.00 0.00 96.00 64.00 97.00 65.00 32.00 32.00 -64.00 -32.00 -97.00 64.00 0.00 64.00 -96.00 64.00 32.00 0.00 -32.00 33.00 -32.00 0.00 -33.00 64.00 33.00 64.00 -97.00 32.00 0.00 32.00 32.00 33.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 64.00 0.00 0.00 -32.00 65.00 -32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 0.00 -32.00 32.00 32.00 32.00 0.00 -64.00 97.00 32.00 64.00 -32.00 96.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 -65.00 32.00 32.00 64.00 -64.00 33.00 32.00 0.00 -32.00 32.00 0.00 96.00 0.00 97.00 -32.00 96.00 0.00 64.00 -64.00 129.00 64.00 0.00 -32.00 96.00 0.00 0.00 -97.00 65.00 -32.00 32.00 -64.00 64.00 0.00 32.00 -32.00 33.00 32.00 32.00 0.00 32.00 -193.00 64.00 0.00 0.00 -32.00 32.00 -64.00 32.00 0.00 33.00 0.00 64.00 -65.00 32.00 -96.00 97.00 -129.00 0.00 -32.00 -65.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 32.00 0.00 32.00 -64.00 65.00 0.00 64.00 -96.00 96.00 -33.00 65.00 -32.00 64.00 32.00 64.00 -32.00 33.00 -96.00 32.00 0.00 32.00 -64.00 -32.00 -33.00 32.00 -64.00 32.00 32.00 32.00 -32.00 -32.00 -64.00 32.00 -32.00 64.00 0.00 33.00 -33.00 0.00 -32.00 -65.00 -32.00 32.00 -32.00 33.00 0.00 32.00 -32.00 -32.00 -32.00 -33.00 0.00 -64.00 -32.00 64.00 -33.00 0.00 -96.00 129.00 -32.00 64.00 32.00 33.00 0.00 -33.00 -64.00 33.00 -33.00 96.00 -64.00 0.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -65.00 64.00 0.00 33.00 0.00 0.00 -64.00 64.00 0.00 32.00 32.00 129.00 0.00 -33.00 32.00 65.00 -32.00 32.00 32.00 0.00 33.00 64.00 32.00 32.00 -32.00 -32.00 -33.00 32.00 0.00 33.00 65.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 32.00 32.00 64.00 33.00 0.00 -33.00 64.00 0.00 0.00 33.00 33.00 0.00 64.00 0.00 32.00 0.00 64.00 0.00 -32.00 -65.00 32.00 0.00 97.00 32.00 96.00 -64.00 32.00 32.00 32.00 -32.00 33.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -64.00 32.00 32.00 32.00 -64.00 0.00 64.00 32.00 0.00 97.00 64.00 0.00 -32.00 32.00 0.00 0.00 64.00 64.00 -32.00 0.00 64.00 32.00 33.00 65.00 -65.00 64.00 -32.00 32.00 32.00 32.00 -64.00 64.00 0.00 33.00 -64.00 0.00 -32.00 96.00 -33.00 0.00 -32.00 32.00 0.00 0.00 -32.00 64.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 65.00 65.00 0.00 -32.00 64.00 0.00 0.00 -33.00 32.00 -32.00 32.00 0.00 32.00 32.00 33.00 -32.00 32.00 0.00 32.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 64.00 0.00 -32.00 0.00 32.00 -33.00 65.00 33.00 -33.00 -65.00 0.00 -32.00 33.00 32.00 0.00 -64.00 64.00 0.00 32.00 32.00 64.00 0.00 0.00 -32.00 65.00 32.00 -33.00 -64.00 33.00 0.00 32.00 -32.00 64.00 32.00 0.00 -129.00 32.00 32.00 32.00 -32.00 32.00 32.00 65.00 -32.00 32.00 0.00 32.00 32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 32.00 96.00 32.00 65.00 -32.00 32.00 0.00 32.00 0.00 32.00 64.00 32.00 0.00 -32.00 -64.00 32.00 0.00 65.00 64.00 64.00 32.00 64.00 65.00 -64.00 0.00 0.00 64.00 32.00 -32.00 0.00 32.00 0.00 96.00 32.00 -32.00 0.00 65.00 32.00 -33.00 32.00 0.00 0.00 97.00 33.00 -64.00 32.00 32.00 32.00 0.00 32.00 0.00 64.00 0.00 -32.00 32.00 64.00 96.00 65.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 32.00 129.00 0.00 -32.00 32.00 -33.00 0.00 0.00 32.00 65.00 -32.00 -32.00 32.00 32.00 33.00 64.00 -33.00 -32.00 -32.00 32.00 -32.00 64.00 97.00 33.00 -33.00 32.00 65.00 32.00 32.00 32.00 -32.00 32.00 0.00 -32.00 32.00 32.00 32.00 32.00 -32.00 65.00 0.00 32.00 0.00 -32.00 64.00 96.00 97.00 0.00 -33.00 32.00 -32.00 32.00 65.00 32.00 -33.00 33.00 0.00 32.00 33.00 32.00 0.00 32.00 32.00 32.00 0.00 32.00 64.00 65.00 -64.00 32.00 64.00 64.00 -64.00 32.00 64.00 33.00 -64.00 32.00 64.00 64.00 -64.00 0.00 32.00 0.00 32.00 64.00 32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 64.00 65.00 64.00 32.00 32.00 0.00 -64.00 64.00 64.00 32.00 33.00 65.00 -33.00 -33.00 33.00 33.00 0.00 -33.00 64.00 33.00 32.00 -33.00 0.00 33.00 32.00 -33.00 0.00 0.00 65.00 33.00 32.00 0.00 -32.00 32.00 0.00 0.00 32.00 0.00 64.00 32.00 0.00 32.00 32.00 0.00 -32.00 64.00 64.00 -32.00 0.00 65.00 32.00 0.00 33.00 32.00 32.00 64.00 0.00 0.00 64.00 32.00 0.00 32.00 0.00 0.00 32.00 33.00 -32.00 0.00 32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 32.00 64.00 64.00 0.00 33.00 33.00 0.00 0.00 32.00 32.00 0.00 64.00 0.00 32.00 0.00 32.00 32.00 65.00 -32.00 64.00 32.00 0.00 32.00 32.00 0.00 32.00 -32.00 32.00 32.00 65.00 32.00 32.00 0.00 0.00 97.00 64.00 0.00 0.00 -33.00 0.00 33.00 64.00 32.00 0.00 -32.00 -32.00 0.00 32.00 -33.00 33.00 33.00 96.00 -33.00 32.00 0.00 -32.00 33.00 64.00 32.00 -32.00 32.00 32.00 -32.00 0.00 32.00 33.00 0.00 32.00 0.00 0.00 -32.00 32.00 32.00 -32.00 32.00 32.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 65.00 32.00 -32.00 -32.00 32.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 33.00 0.00 0.00 32.00 64.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 96.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 65.00 -32.00 32.00 32.00 0.00 33.00 32.00 0.00 -32.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 0.00 65.00 0.00 0.00 32.00 64.00 32.00 64.00 -64.00 32.00 -65.00 33.00 33.00 0.00 -33.00 32.00 33.00 32.00 -33.00 32.00 33.00 0.00 -33.00 32.00 33.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 0.00 0.00 -32.00 0.00 32.00 64.00 0.00 32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 33.00 33.00 0.00 -33.00 64.00 33.00 32.00 32.00 0.00 -32.00 32.00 -65.00 32.00 32.00 32.00 -64.00 33.00 32.00 0.00 -32.00 64.00 0.00 32.00 -32.00 161.00 0.00 32.00 0.00 32.00 64.00 64.00 -32.00 97.00 32.00 64.00 -32.00 32.00 0.00 97.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 64.00 -65.00 32.00 0.00 65.00 -64.00 64.00 0.00 32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 97.00 -32.00 32.00 0.00 32.00 0.00 65.00 -32.00 0.00 -65.00 32.00 33.00 64.00 32.00 0.00 -32.00 32.00 0.00 65.00 -33.00 32.00 -32.00 64.00 32.00 96.00 -32.00 129.00 -64.00 32.00 -32.00 64.00 32.00 0.00 32.00 33.00 -32.00 32.00 64.00 96.00 -64.00 32.00 0.00 33.00 32.00 96.00 0.00 64.00 32.00 33.00 0.00 0.00 32.00 32.00 0.00 -32.00 65.00 32.00 0.00 0.00 32.00 32.00 64.00 161.00 32.00 32.00 32.00 32.00 -32.00 32.00 32.00 0.00 33.00 32.00 32.00 32.00 32.00 97.00 32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 0.00 65.00 32.00 32.00 -32.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 -32.00 96.00 -32.00 33.00 64.00 32.00 96.00 64.00 0.00 -32.00 0.00 32.00 33.00 0.00 64.00 32.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 0.00 32.00 -32.00 32.00 0.00 64.00 0.00 32.00 -32.00 65.00 -32.00 32.00 -65.00 64.00 0.00 32.00 -32.00 65.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 64.00 -32.00 32.00 32.00 65.00 0.00 32.00 32.00 32.00 -32.00 32.00 64.00 65.00 -32.00 32.00 32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 64.00 0.00 65.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 96.00 -97.00 0.00 -32.00 0.00 -64.00 32.00 -65.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 32.00 0.00 -32.00 32.00 0.00 33.00 -65.00 32.00 -64.00 128.00 -32.00 32.00 0.00 33.00 32.00 32.00 -32.00 32.00 0.00 0.00 -32.00 96.00 -33.00 33.00 -32.00 64.00 -64.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 129.00 -129.00 32.00 -64.00 32.00 -33.00 193.00 -64.00 -32.00 -96.00 32.00 -97.00 32.00 -32.00 32.00 -96.00 65.00 -32.00 96.00 0.00 65.00 -97.00 32.00 -32.00 0.00 -64.00 32.00 0.00 32.00 0.00 64.00 -65.00 129.00 -32.00 64.00 32.00 0.00 65.00 65.00 32.00 -97.00 1993.00 -32.00 0.00 -64.00 32.00 -65.00 -32.00 -64.00 65.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 -161.00 64.00 -64.00 32.00 0.00 97.00 -33.00 32.00 -64.00 32.00 0.00 32.00 -32.00 32.00 -64.00 129.00 0.00 32.00 -32.00 64.00 -33.00 65.00 -128.00 160.00 0.00 65.00 -32.00 32.00 -33.00 64.00 0.00 32.00 0.00 32.00 33.00 65.00 -33.00 32.00 33.00 0.00 -33.00 64.00 33.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 32.00 64.00 0.00 33.00 0.00 0.00 -32.00 32.00 0.00 64.00 0.00 32.00 64.00 32.00 0.00 -32.00 -32.00 32.00 0.00 0.00 64.00 65.00 -32.00 32.00 32.00 0.00 33.00 32.00 -33.00 0.00 33.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 -32.00 33.00 0.00 0.00 32.00 0.00 32.00 32.00 0.00 0.00 33.00 32.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 32.00 32.00 161.00 -32.00 32.00 0.00 33.00 32.00 32.00 -32.00 32.00 0.00 0.00 32.00 64.00 0.00 32.00 65.00 32.00 -65.00 33.00 -32.00 32.00 -32.00 64.00 -32.00 0.00 -32.00 129.00 0.00 32.00 32.00 0.00 -32.00 64.00 0.00 0.00 32.00 32.00 64.00 97.00 32.00 0.00 32.00 64.00 0.00 32.00 -32.00 32.00 0.00 0.00 65.00 65.00 0.00 64.00 32.00 64.00 0.00 32.00 32.00 33.00 0.00 32.00 32.00 64.00 32.00 32.00 -32.00 32.00 0.00 32.00 -64.00 33.00 -32.00 0.00 -97.00 32.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 0.00 -32.00 33.00 64.00 32.00 -32.00 0.00 32.00 32.00 0.00 96.00 64.00 97.00 -32.00 96.00 32.00 32.00 0.00 33.00 -32.00 128.00 -32.00 193.00 32.00 97.00 32.00 32.00 0.00 64.00 33.00 64.00 32.00 32.00 0.00 33.00 64.00 96.00 32.00 482.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -129.00 0.00 -32.00 33.00 -64.00 32.00 -32.00 64.00 32.00 96.00 32.00 193.00 0.00 97.00 96.00 289.00 0.00 129.00 33.00 128.00 0.00 193.00 160.00 161.00 129.00 0.00 64.00 32.00 32.00 0.00 33.00 -128.00 160.00 -97.00 161.00 -32.00 129.00 0.00 225.00 64.00 225.00 0.00 32.00 0.00 96.00 33.00 65.00 32.00 96.00 64.00 0.00 32.00 32.00 32.00 -32.00 97.00 -96.00 96.00 -65.00 129.00 -192.00 32.00 -97.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 129.00 -97.00 64.00 -32.00 65.00 -32.00 96.00 -129.00 32.00 -96.00 129.00 0.00 32.00 32.00 64.00 0.00 65.00 64.00 64.00 32.00 64.00 -32.00 64.00 97.00 0.00 32.00 33.00 0.00 96.00 193.00 32.00 128.00 65.00 0.00 32.00 33.00 0.00 64.00 32.00 64.00 -32.00 129.00 64.00 96.00 0.00 65.00 32.00 96.00 0.00 64.00 32.00 161.00 -64.00 32.00 0.00 161.00 32.00 32.00 32.00 64.00 -32.00 129.00 0.00 32.00 -32.00 97.00 -64.00 64.00 -32.00 0.00 -33.00 96.00 0.00 65.00 33.00 0.00 32.00 96.00 32.00 129.00 64.00 128.00 0.00 97.00 193.00 0.00 32.00 64.00 32.00 0.00 33.00 0.00 32.00 64.00 32.00 0.00 32.00 97.00 96.00 0.00 33.00 64.00 0.00 -32.00 32.00 97.00 0.00 0.00 64.00 -33.00 0.00 65.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 64.00 33.00 65.00 32.00 64.00 0.00 0.00 -65.00 96.00 0.00 65.00 33.00 0.00 -33.00 64.00 65.00 128.00 0.00 65.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 64.00 -32.00 32.00 0.00 0.00 32.00 33.00 0.00 0.00 32.00 32.00 32.00 0.00 65.00 32.00 0.00 32.00 32.00 32.00 32.00 32.00 0.00 33.00 32.00 32.00 0.00 64.00 32.00 0.00 -32.00 32.00 32.00 0.00 65.00 32.00 32.00 -32.00 0.00 64.00 64.00 33.00 0.00 -33.00 0.00 0.00 32.00 33.00 0.00 32.00 32.00 64.00 0.00 32.00 -32.00 32.00 32.00 32.00 0.00 33.00 32.00 0.00 33.00 0.00 -33.00 64.00 33.00 32.00 0.00 32.00 32.00 -32.00 32.00 0.00 32.00 32.00 -32.00 32.00 -32.00 33.00 -32.00 0.00 32.00 64.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 -32.00 -64.00 32.00 32.00 33.00 32.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 32.00 64.00 0.00 0.00 32.00 32.00 0.00 33.00 64.00 64.00 0.00 32.00 65.00 0.00 32.00 32.00 0.00 32.00 64.00 32.00 0.00 0.00 32.00 65.00 65.00 32.00 0.00 0.00 -33.00 32.00 0.00 32.00 0.00 -32.00 33.00 0.00 32.00 97.00 0.00 128.00 64.00 -32.00 0.00 64.00 32.00 -32.00 0.00 65.00 32.00 32.00 -32.00 64.00 65.00 64.00 0.00 32.00 0.00 -32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 33.00 -32.00 32.00 64.00 32.00 0.00 32.00 -32.00 32.00 32.00 -32.00 0.00 64.00 64.00 32.00 -32.00 161.00 97.00 65.00 -33.00 32.00 0.00 64.00 33.00 64.00 0.00 0.00 32.00 65.00 -32.00 32.00 -33.00 64.00 0.00 0.00 33.00 97.00 0.00 32.00 32.00 32.00 0.00 64.00 0.00 97.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 64.00 0.00 32.00 -32.00 65.00 64.00 32.00 -32.00 32.00 0.00 32.00 32.00 64.00 0.00 33.00 0.00 32.00 32.00 32.00 0.00 -32.00 33.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 32.00 97.00 0.00 0.00 32.00 0.00 32.00 32.00 32.00 0.00 33.00 96.00 -33.00 65.00 33.00 128.00 0.00 0.00 96.00 32.00 0.00 33.00 32.00 32.00 32.00 32.00 -32.00 0.00 64.00 96.00 33.00 32.00 32.00 33.00 -32.00 64.00 0.00 0.00 -33.00 32.00 0.00 32.00 0.00 32.00 33.00 33.00 -33.00 0.00 33.00 64.00 0.00 32.00 64.00 64.00 32.00 129.00 0.00 64.00 64.00 65.00 0.00 32.00 33.00 64.00 0.00 32.00 0.00 0.00 32.00 97.00 64.00 0.00 32.00 32.00 -32.00 32.00 32.00 64.00 64.00 0.00 65.00 32.00 0.00 32.00 96.00 33.00 32.00 0.00 33.00 -65.00 32.00 97.00 32.00 32.00 -32.00 32.00 32.00 -32.00 32.00 96.00 0.00 0.00 96.00 97.00 0.00 64.00 65.00 32.00 32.00 33.00 32.00 0.00 32.00 -65.00 32.00 -64.00 65.00 0.00 64.00 161.00 225.00 32.00 64.00 0.00 97.00 0.00 64.00 -64.00 0.00 -33.00 0.00 -96.00 -32.00 -32.00 0.00 -65.00 32.00 -32.00 64.00 -96.00 258.00 -32.00 32.00 -65.00 128.00 -32.00 161.00 -32.00 32.00 0.00 33.00 96.00 96.00 -64.00 96.00 32.00 65.00 0.00 32.00 65.00 64.00 0.00 161.00 0.00 129.00 32.00 64.00 64.00 96.00 0.00 33.00 0.00 32.00 0.00 32.00 -96.00 225.00 64.00 161.00 0.00 128.00 -32.00 97.00 -32.00 32.00 64.00 96.00 32.00 65.00 0.00 64.00 -129.00 257.00 -96.00 225.00 -64.00 193.00 -32.00 65.00 -161.00 128.00 -64.00 32.00 -65.00 65.00 -64.00 32.00 -32.00 0.00 -97.00 32.00 -128.00 32.00 -193.00 0.00 -290.00 64.00 -96.00 65.00 -97.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 129.00 -64.00 32.00 -161.00 289.00 0.00 32.00 -64.00 33.00 -129.00 96.00 -64.00 64.00 -161.00 258.00 -32.00 96.00 -97.00 96.00 -225.00 129.00 -32.00 32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 -32.00 32.00 -161.00 354.00 -32.00 160.00 64.00 97.00 0.00 32.00 0.00 32.00 -32.00 161.00 0.00 161.00 32.00 96.00 64.00 64.00 -32.00 225.00 -32.00 65.00 -193.00 128.00 -32.00 0.00 -193.00 0.00 -64.00 32.00 -129.00 161.00 -32.00 97.00 -64.00 96.00 0.00 97.00 -65.00 160.00 -96.00 33.00 -32.00 64.00 -32.00 0.00 -97.00 32.00 -129.00 0.00 -32.00 32.00 -32.00 64.00 32.00 161.00 -32.00 65.00 32.00 32.00 65.00 96.00 32.00 193.00 32.00 32.00 -32.00 161.00 -32.00 129.00 0.00 32.00 0.00 32.00 0.00 32.00 -33.00 32.00 -192.00 161.00 -33.00 129.00 -32.00 96.00 -32.00 97.00 -96.00 96.00 -65.00 96.00 -32.00 33.00 -128.00 64.00 -97.00 0.00 -193.00 -32.00 -32.00 0.00 -64.00 32.00 -65.00 128.00 -64.00 97.00 32.00 64.00 161.00 129.00 0.00 96.00 64.00 129.00 0.00 96.00 0.00 33.00 -128.00 225.00 -65.00 64.00 -32.00 64.00 -193.00 65.00 -96.00 64.00 -97.00 225.00 0.00 64.00 -32.00 97.00 -225.00 160.00 -64.00 97.00 -64.00 32.00 0.00 32.00 -65.00 0.00 -160.00 193.00 -33.00 97.00 -128.00 418.00 -161.00 225.00 -64.00 64.00 -33.00 32.00 -32.00 97.00 -225.00 160.00 -32.00 33.00 -96.00 96.00 -32.00 64.00 -33.00 0.00 -32.00 32.00 -96.00 33.00 -129.00 64.00 -161.00 32.00 -96.00 97.00 -97.00 64.00 -64.00 32.00 -96.00 64.00 -193.00 65.00 -129.00 96.00 -96.00 32.00 -258.00 161.00 -32.00 64.00 -160.00 129.00 -65.00 129.00 -32.00 0.00 -128.00 64.00 -258.00 64.00 -32.00 32.00 -32.00 0.00 -193.00 97.00 -64.00 96.00 -32.00 32.00 -193.00 65.00 -32.00 32.00 -97.00 96.00 -96.00 129.00 -33.00 64.00 0.00 32.00 0.00 33.00 33.00 32.00 -97.00 160.00 -32.00 0.00 -225.00 290.00 -64.00 64.00 -33.00 32.00 -96.00 0.00 -96.00 0.00 0.00 32.00 -33.00 0.00 -289.00 97.00 -96.00 32.00 -65.00 32.00 -64.00 32.00 -32.00 32.00 -65.00 97.00 -128.00 32.00 -32.00 0.00 0.00 32.00 -97.00 97.00 -96.00 32.00 -161.00 96.00 -161.00 65.00 -64.00 32.00 -64.00 32.00 -65.00 96.00 0.00 33.00 -64.00 64.00 -64.00 32.00 -97.00 64.00 -32.00 129.00 -96.00 129.00 0.00 64.00 0.00 546.00 -129.00 129.00 0.00 64.00 -129.00 193.00 -64.00 225.00 -64.00 161.00 0.00 32.00 -64.00 129.00 -161.00 225.00 -32.00 32.00 -226.00 64.00 -289.00 193.00 -257.00 129.00 -129.00 -32.00 -32.00 32.00 -64.00 32.00 0.00 32.00 -129.00 225.00 0.00 193.00 -64.00 193.00 -32.00 193.00 -32.00 129.00 -33.00 64.00 -32.00 97.00 -32.00 192.00 0.00 33.00 -96.00 160.00 -32.00 193.00 -33.00 97.00 33.00 32.00 -33.00 64.00 33.00 97.00 0.00 128.00 -97.00 290.00 -32.00 64.00 -97.00 96.00 -193.00 97.00 -353.00 257.00 -129.00 32.00 -32.00 0.00 -32.00 32.00 -129.00 -96.00 0.00 -64.00 -32.00 -65.00 0.00 -64.00 -96.00 -32.00 -65.00 32.00 -64.00 -64.00 -64.00 -32.00 -97.00 -97.00 -64.00 -32.00 -64.00 -161.00 0.00 -64.00 -32.00 -32.00 -65.00 -32.00 -160.00 -33.00 -97.00 -96.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 -32.00 -97.00 32.00 0.00 -32.00 33.00 -64.00 -97.00 -33.00 0.00 -64.00 -64.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 -64.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -32.00 -64.00 -65.00 0.00 -32.00 -33.00 -64.00 97.00 -64.00 64.00 0.00 65.00 -33.00 32.00 -193.00 32.00 0.00 -64.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 0.00 32.00 -64.00 32.00 -32.00 32.00 -96.00 -32.00 -65.00 64.00 0.00 65.00 -32.00 -32.00 -96.00 32.00 -33.00 -65.00 -32.00 0.00 -32.00 65.00 -64.00 0.00 0.00 64.00 -64.00 0.00 0.00 32.00 0.00 32.00 -33.00 32.00 33.00 97.00 -65.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 0.00 -65.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 32.00 -65.00 32.00 -64.00 32.00 -64.00 32.00 -32.00 0.00 -33.00 65.00 -64.00 -32.00 0.00 -33.00 -32.00 33.00 -64.00 -33.00 -32.00 -64.00 -33.00 -32.00 -64.00 64.00 -32.00 0.00 0.00 32.00 -64.00 33.00 -33.00 0.00 -32.00 -33.00 -32.00 33.00 -96.00 32.00 0.00 -32.00 -65.00 0.00 -32.00 32.00 0.00 32.00 -193.00 0.00 -96.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 -33.00 -32.00 -96.00 -64.00 -64.00 0.00 -97.00 161.00 -32.00 0.00 -64.00 -32.00 -32.00 -33.00 -65.00 0.00 0.00 -64.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 -64.00 0.00 -33.00 -64.00 0.00 32.00 -64.00 -96.00 -64.00 32.00 -64.00 32.00 -129.00 -32.00 -64.00 0.00 -161.00 0.00 -32.00 -32.00 -32.00 64.00 -129.00 0.00 -97.00 -64.00 -64.00 32.00 0.00 -32.00 -64.00 32.00 -97.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 -32.00 -32.00 32.00 -96.00 -32.00 -33.00 -32.00 0.00 0.00 -128.00 -32.00 -65.00 -32.00 33.00 -32.00 -33.00 -65.00 -32.00 0.00 -32.00 -96.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -129.00 32.00 -64.00 0.00 -32.00 32.00 -32.00 -64.00 -65.00 0.00 -64.00 -32.00 -64.00 0.00 -32.00 -33.00 -97.00 -32.00 -64.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 64.00 0.00 33.00 -97.00 -33.00 -32.00 161.00 -193.00 32.00 -161.00 -32.00 -64.00 -32.00 0.00 0.00 -64.00 -64.00 -97.00 -97.00 -64.00 32.00 -64.00 -32.00 -97.00 0.00 -32.00 97.00 -32.00 64.00 -64.00 -32.00 -33.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -65.00 -96.00 65.00 0.00 32.00 -65.00 32.00 -32.00 -96.00 -96.00 0.00 -97.00 -65.00 -32.00 -64.00 -32.00 -32.00 0.00 -97.00 32.00 0.00 -96.00 0.00 -65.00 -32.00 -64.00 -64.00 -129.00 32.00 0.00 0.00 -96.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 -32.00 -32.00 -65.00 -32.00 33.00 -128.00 -33.00 -33.00 65.00 -32.00 -65.00 -128.00 0.00 -33.00 0.00 -32.00 -64.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 -97.00 0.00 -64.00 -64.00 -32.00 32.00 -65.00 -32.00 -96.00 32.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 64.00 -33.00 0.00 -64.00 33.00 -32.00 64.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 -96.00 -32.00 -96.00 32.00 -33.00 -32.00 -64.00 0.00 -96.00 -32.00 -33.00 0.00 -96.00 -97.00 -96.00 -96.00 -65.00 -32.00 -32.00 -65.00 0.00 -32.00 -64.00 -32.00 -65.00 -129.00 -64.00 -96.00 -257.00 0.00 -64.00 -32.00 -65.00 32.00 -64.00 32.00 0.00 0.00 -32.00 32.00 -97.00 -32.00 -128.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 -97.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -64.00 -32.00 32.00 -64.00 0.00 -32.00 -129.00 -65.00 -32.00 -96.00 -32.00 -129.00 -64.00 -64.00 -193.00 0.00 -97.00 -32.00 -32.00 32.00 -32.00 -32.00 -65.00 32.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 -64.00 -64.00 -97.00 32.00 0.00 64.00 -32.00 0.00 -32.00 -32.00 -129.00 -32.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 -64.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 -32.00 0.00 -32.00 -64.00 0.00 0.00 32.00 -32.00 -64.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 -96.00 -65.00 0.00 -64.00 -32.00 -32.00 -97.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 -65.00 -65.00 -32.00 -32.00 -32.00 -32.00 32.00 -64.00 -64.00 0.00 -32.00 -32.00 0.00 -33.00 -64.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -96.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 -64.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -65.00 -32.00 32.00 -33.00 0.00 -96.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -33.00 64.00 -96.00 0.00 -32.00 33.00 0.00 32.00 -65.00 0.00 0.00 64.00 -32.00 32.00 0.00 32.00 32.00 33.00 -32.00 0.00 0.00 64.00 -64.00 -32.00 0.00 64.00 32.00 0.00 -96.00 64.00 0.00 65.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -33.00 64.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 0.00 33.00 -97.00 64.00 -32.00 0.00 -32.00 0.00 32.00 96.00 -32.00 0.00 -32.00 -32.00 -65.00 -32.00 -64.00 -32.00 -32.00 -64.00 0.00 -33.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 0.00 32.00 32.00 33.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -64.00 64.00 -64.00 -32.00 32.00 -32.00 -32.00 -32.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 33.00 -32.00 -33.00 0.00 -64.00 32.00 0.00 64.00 0.00 33.00 0.00 64.00 -64.00 32.00 -32.00 32.00 -65.00 32.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -64.00 -32.00 -33.00 -32.00 33.00 -65.00 -33.00 -64.00 -32.00 0.00 -64.00 32.00 0.00 32.00 -32.00 33.00 -32.00 -33.00 -33.00 -32.00 33.00 0.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 -32.00 -32.00 -64.00 -65.00 32.00 -64.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 -65.00 65.00 -32.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 -65.00 0.00 32.00 64.00 -32.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -32.00 -32.00 32.00 -97.00 -64.00 33.00 -96.00 -33.00 -65.00 33.00 -32.00 -33.00 -32.00 33.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 -32.00 0.00 32.00 0.00 32.00 32.00 33.00 -64.00 0.00 0.00 32.00 -97.00 64.00 -64.00 -64.00 -97.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 -33.00 -32.00 0.00 0.00 -32.00 -64.00 32.00 0.00 33.00 -65.00 32.00 33.00 32.00 -33.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -33.00 -33.00 33.00 -64.00 0.00 0.00 -33.00 -32.00 0.00 32.00 -64.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -97.00 -32.00 -64.00 32.00 32.00 -32.00 -64.00 0.00 -64.00 -64.00 -33.00 32.00 0.00 32.00 0.00 -64.00 -32.00 32.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 -65.00 0.00 -64.00 -65.00 -32.00 0.00 -32.00 32.00 -65.00 33.00 -128.00 -33.00 -32.00 0.00 -33.00 -64.00 0.00 -96.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -64.00 0.00 -32.00 0.00 -33.00 -129.00 65.00 -128.00 0.00 -33.00 -32.00 -64.00 -65.00 -32.00 32.00 -64.00 0.00 0.00 33.00 -33.00 32.00 0.00 32.00 -64.00 -64.00 -32.00 32.00 -32.00 0.00 0.00 64.00 32.00 0.00 0.00 64.00 -64.00 33.00 -32.00 0.00 -33.00 0.00 -96.00 -65.00 -32.00 32.00 -32.00 97.00 -32.00 0.00 -33.00 -64.00 -32.00 0.00 -32.00 -65.00 -32.00 -32.00 -161.00 64.00 32.00 33.00 -64.00 -33.00 -64.00 0.00 -33.00 -32.00 -64.00 0.00 -128.00 0.00 32.00 -64.00 -32.00 -32.00 -33.00 -97.00 -64.00 0.00 -32.00 -32.00 -32.00 64.00 -64.00 0.00 -33.00 -32.00 -32.00 32.00 32.00 -160.00 -32.00 -33.00 -64.00 0.00 0.00 -64.00 32.00 -64.00 161.00 -97.00 0.00 -32.00 0.00 -96.00 64.00 -64.00 64.00 -226.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 97.00 -64.00 64.00 0.00 32.00 -33.00 -32.00 -32.00 -257.00 -128.00 0.00 -32.00 96.00 -33.00 97.00 -32.00 96.00 -193.00 0.00 -96.00 -64.00 0.00 -65.00 -64.00 -32.00 -33.00 0.00 -32.00 32.00 -64.00 193.00 -129.00 65.00 -64.00 0.00 -32.00 -193.00 -97.00 -32.00 -64.00 -65.00 -128.00 65.00 -97.00 96.00 -32.00 0.00 -32.00 -64.00 -65.00 -161.00 -64.00 -32.00 -96.00 0.00 -97.00 32.00 -96.00 64.00 -32.00 65.00 -97.00 32.00 -64.00 0.00 -64.00 64.00 -161.00 32.00 -97.00 193.00 -225.00 32.00 -64.00 32.00 -97.00 -32.00 -32.00 -193.00 -32.00 -64.00 -64.00 -64.00 -64.00 32.00 -33.00 289.00 -193.00 32.00 -64.00 0.00 -161.00 -64.00 -257.00 0.00 -32.00 97.00 -161.00 -97.00 -161.00 -32.00 -128.00 96.00 -64.00 97.00 -161.00 64.00 -65.00 -32.00 -64.00 0.00 -128.00 0.00 -33.00 -64.00 0.00 -65.00 65.00 -64.00 0.00 -32.00 -32.00 -64.00 -129.00 -33.00 -32.00 -64.00 -32.00 -64.00 32.00 -64.00 -32.00 32.00 -65.00 96.00 -64.00 193.00 -129.00 32.00 -96.00 -32.00 -64.00 -161.00 -129.00 -64.00 0.00 -96.00 64.00 -65.00 0.00 -64.00 -32.00 0.00 -32.00 64.00 -161.00 65.00 -32.00 64.00 -32.00 193.00 32.00 64.00 0.00 0.00 -32.00 -32.00 -64.00 -32.00 -65.00 -129.00 -160.00 -32.00 -65.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 193.00 -161.00 0.00 0.00 -64.00 0.00 -32.00 33.00 -97.00 32.00 -96.00 0.00 -32.00 -97.00 0.00 -96.00 -129.00 0.00 -97.00 64.00 -96.00 -96.00 -289.00 32.00 -129.00 96.00 -161.00 0.00 -64.00 -128.00 -193.00 -193.00 -32.00 -129.00 -97.00 -64.00 -225.00 32.00 -96.00 32.00 -161.00 0.00 -64.00 -32.00 -32.00 -32.00 -32.00 -97.00 0.00 -32.00 32.00 -64.00 64.00 0.00 32.00 -97.00 -64.00 -32.00 -129.00 32.00 -32.00 33.00 -64.00 128.00 -32.00 32.00 -65.00 -32.00 -32.00 -32.00 -32.00 -129.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 33.00 -64.00 96.00 0.00 96.00 -32.00 33.00 -96.00 96.00 -65.00 193.00 -32.00 0.00 -32.00 64.00 -161.00 65.00 -32.00 96.00 0.00 64.00 0.00 65.00 -32.00 64.00 -129.00 64.00 -32.00 32.00 0.00 65.00 32.00 96.00 97.00 64.00 -129.00 129.00 -161.00 32.00 -64.00 -1318.00 -1029.00 482.00 -1029.00z"},mg:{name:"MG",path:"M114452.00 124015.00l-32.00 -65.00 64.00 -96.00 -96.00 -96.00 0.00 -33.00 32.00 -32.00 32.00 -161.00 65.00 -128.00 32.00 -32.00 96.00 -258.00 32.00 -64.00 65.00 -32.00 32.00 0.00 96.00 32.00 33.00 0.00 64.00 0.00 0.00 -64.00 0.00 -97.00 -32.00 -64.00 -161.00 -225.00 0.00 -64.00 64.00 -65.00 65.00 -32.00 160.00 65.00 290.00 96.00 32.00 0.00 64.00 -64.00 0.00 -32.00 -64.00 -97.00 -161.00 -129.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 64.00 -64.00 32.00 -129.00 65.00 -97.00 0.00 -96.00 32.00 -64.00 0.00 -32.00 64.00 -97.00 129.00 -129.00 96.00 0.00 97.00 -128.00 32.00 -64.00 0.00 -33.00 0.00 -64.00 32.00 -64.00 257.00 -65.00 32.00 -64.00 -32.00 -96.00 32.00 -32.00 65.00 0.00 64.00 0.00 289.00 0.00 65.00 -65.00 128.00 -64.00 0.00 -32.00 33.00 0.00 64.00 -129.00 128.00 -193.00 0.00 -128.00 -32.00 -32.00 32.00 -97.00 -64.00 -161.00 0.00 -64.00 64.00 -32.00 129.00 -64.00 32.00 0.00 97.00 -129.00 96.00 -257.00 0.00 -32.00 32.00 -33.00 97.00 -32.00 64.00 0.00 32.00 -32.00 97.00 -257.00 160.00 -225.00 65.00 -65.00 64.00 -32.00 32.00 -32.00 64.00 -32.00 97.00 -32.00 161.00 32.00 96.00 0.00 161.00 -96.00 386.00 64.00 96.00 -97.00 65.00 -64.00 64.00 -161.00 32.00 -32.00 64.00 0.00 161.00 0.00 32.00 64.00 193.00 33.00 129.00 0.00 96.00 -65.00 32.00 0.00 33.00 32.00 32.00 33.00 64.00 0.00 64.00 64.00 97.00 0.00 96.00 32.00 32.00 0.00 33.00 0.00 32.00 -64.00 32.00 -65.00 64.00 -32.00 64.00 32.00 33.00 0.00 64.00 -32.00 96.00 -64.00 65.00 -32.00 64.00 0.00 32.00 0.00 97.00 64.00 32.00 0.00 32.00 -64.00 -97.00 -97.00 33.00 -32.00 0.00 -32.00 96.00 -32.00 257.00 -32.00 65.00 32.00 32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -129.00 32.00 -32.00 32.00 0.00 65.00 -32.00 96.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 97.00 0.00 64.00 32.00 96.00 226.00 225.00 64.00 161.00 32.00 0.00 64.00 32.00 97.00 -32.00 32.00 -32.00 32.00 -97.00 97.00 -96.00 64.00 -161.00 32.00 0.00 96.00 32.00 33.00 -32.00 32.00 -96.00 32.00 -32.00 32.00 -32.00 32.00 0.00 97.00 -33.00 32.00 -96.00 64.00 -129.00 64.00 -64.00 65.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 -97.00 -64.00 0.00 -32.00 33.00 -32.00 96.00 32.00 129.00 -32.00 32.00 -32.00 128.00 -97.00 97.00 0.00 0.00 32.00 -32.00 32.00 0.00 33.00 64.00 0.00 32.00 32.00 64.00 0.00 0.00 32.00 129.00 -64.00 32.00 -65.00 0.00 -64.00 97.00 -64.00 96.00 32.00 32.00 0.00 33.00 -64.00 32.00 0.00 0.00 -97.00 32.00 0.00 32.00 -32.00 64.00 -32.00 97.00 -97.00 96.00 0.00 32.00 65.00 129.00 0.00 32.00 64.00 161.00 32.00 32.00 32.00 32.00 161.00 64.00 0.00 65.00 -96.00 64.00 -33.00 64.00 33.00 97.00 -65.00 96.00 32.00 97.00 -32.00 64.00 32.00 64.00 -32.00 65.00 0.00 64.00 0.00 64.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 193.00 32.00 33.00 0.00 32.00 -32.00 96.00 0.00 32.00 32.00 0.00 64.00 32.00 32.00 97.00 0.00 64.00 65.00 97.00 -65.00 32.00 0.00 32.00 33.00 -32.00 64.00 32.00 32.00 161.00 -96.00 64.00 32.00 64.00 -32.00 33.00 0.00 32.00 0.00 0.00 64.00 32.00 0.00 161.00 0.00 64.00 -32.00 32.00 32.00 32.00 0.00 32.00 0.00 32.00 64.00 65.00 0.00 32.00 0.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 128.00 -97.00 65.00 -64.00 32.00 0.00 32.00 0.00 32.00 64.00 129.00 0.00 0.00 65.00 32.00 32.00 128.00 0.00 97.00 32.00 64.00 0.00 0.00 64.00 64.00 64.00 0.00 65.00 97.00 32.00 64.00 32.00 97.00 32.00 32.00 0.00 64.00 0.00 32.00 -32.00 33.00 -64.00 32.00 0.00 32.00 32.00 32.00 64.00 64.00 32.00 65.00 32.00 0.00 33.00 32.00 32.00 32.00 0.00 96.00 -65.00 0.00 33.00 0.00 64.00 0.00 64.00 32.00 0.00 33.00 0.00 0.00 97.00 32.00 32.00 32.00 -32.00 64.00 -32.00 32.00 0.00 33.00 -97.00 32.00 -32.00 128.00 64.00 33.00 -32.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 32.00 65.00 33.00 32.00 0.00 0.00 -33.00 -32.00 -32.00 32.00 -64.00 0.00 -64.00 64.00 -32.00 32.00 -33.00 32.00 33.00 32.00 0.00 -32.00 32.00 32.00 32.00 33.00 0.00 32.00 32.00 64.00 -32.00 32.00 -32.00 65.00 0.00 0.00 -32.00 -33.00 -33.00 33.00 -64.00 32.00 -32.00 32.00 0.00 -32.00 -64.00 128.00 0.00 0.00 64.00 32.00 0.00 33.00 0.00 64.00 -64.00 0.00 -32.00 32.00 0.00 32.00 0.00 65.00 -161.00 32.00 0.00 32.00 32.00 0.00 32.00 64.00 -32.00 32.00 0.00 0.00 -32.00 65.00 -65.00 -65.00 -32.00 -32.00 -64.00 -32.00 -32.00 32.00 -32.00 64.00 -33.00 -32.00 -64.00 65.00 -32.00 0.00 32.00 32.00 32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -64.00 32.00 0.00 32.00 0.00 -64.00 -33.00 64.00 0.00 33.00 -32.00 32.00 -64.00 32.00 0.00 64.00 -64.00 32.00 0.00 0.00 32.00 0.00 96.00 0.00 32.00 32.00 33.00 0.00 -33.00 0.00 -32.00 65.00 -32.00 0.00 -64.00 64.00 -32.00 32.00 32.00 32.00 -32.00 33.00 0.00 -33.00 -32.00 33.00 -33.00 0.00 -32.00 64.00 32.00 0.00 -32.00 32.00 0.00 64.00 -64.00 32.00 0.00 33.00 32.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 64.00 0.00 0.00 33.00 32.00 -33.00 65.00 0.00 0.00 -32.00 -65.00 0.00 65.00 -32.00 0.00 -64.00 32.00 32.00 32.00 -32.00 64.00 0.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 65.00 32.00 32.00 -32.00 96.00 -64.00 32.00 0.00 65.00 32.00 -32.00 -64.00 32.00 0.00 32.00 0.00 32.00 -33.00 0.00 -64.00 -32.00 -64.00 -32.00 0.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 -65.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 0.00 -32.00 32.00 0.00 0.00 -65.00 -96.00 -64.00 0.00 -64.00 -32.00 0.00 0.00 -33.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 -64.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -65.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 33.00 0.00 -65.00 -32.00 32.00 0.00 33.00 -33.00 -33.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 64.00 -64.00 32.00 -65.00 0.00 -64.00 33.00 -32.00 32.00 0.00 0.00 -32.00 64.00 0.00 64.00 -64.00 0.00 -33.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -64.00 64.00 0.00 0.00 -97.00 0.00 -64.00 -32.00 -64.00 -64.00 -97.00 -96.00 -96.00 -33.00 -65.00 -32.00 -64.00 -64.00 -32.00 -97.00 32.00 -96.00 -32.00 -64.00 -32.00 -65.00 0.00 -64.00 32.00 -161.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -128.00 -65.00 96.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -97.00 0.00 -64.00 -32.00 -32.00 -32.00 -64.00 -97.00 -33.00 -32.00 0.00 32.00 -64.00 65.00 0.00 0.00 -64.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 -33.00 65.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -32.00 33.00 32.00 32.00 -32.00 0.00 -97.00 -32.00 -32.00 96.00 -64.00 -32.00 0.00 0.00 -65.00 0.00 33.00 64.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 97.00 -32.00 32.00 64.00 32.00 -32.00 -32.00 -32.00 64.00 0.00 0.00 32.00 32.00 -32.00 -64.00 -64.00 32.00 0.00 0.00 -33.00 32.00 0.00 33.00 -32.00 64.00 32.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -33.00 96.00 -32.00 0.00 -32.00 -32.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -32.00 65.00 0.00 32.00 32.00 32.00 -32.00 -32.00 -33.00 32.00 0.00 -32.00 -64.00 32.00 -32.00 32.00 0.00 64.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 33.00 0.00 0.00 -32.00 -33.00 -33.00 -32.00 -32.00 32.00 0.00 33.00 0.00 32.00 0.00 -65.00 -32.00 33.00 -32.00 -33.00 -32.00 97.00 0.00 32.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 32.00 64.00 -32.00 33.00 65.00 32.00 -33.00 -32.00 -32.00 64.00 -32.00 64.00 32.00 -32.00 -64.00 32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -65.00 32.00 65.00 0.00 -97.00 33.00 32.00 0.00 -32.00 32.00 32.00 32.00 0.00 0.00 -96.00 0.00 32.00 32.00 -32.00 32.00 32.00 32.00 0.00 -32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 97.00 32.00 -32.00 -32.00 32.00 -33.00 32.00 33.00 32.00 -33.00 -32.00 0.00 0.00 -32.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 -32.00 -32.00 0.00 0.00 -96.00 32.00 0.00 0.00 32.00 65.00 32.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 0.00 32.00 0.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 -64.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -64.00 0.00 96.00 -32.00 33.00 -33.00 -33.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 32.00 -32.00 -64.00 -32.00 32.00 -32.00 -32.00 -33.00 -32.00 33.00 0.00 -33.00 -33.00 -32.00 97.00 -32.00 -32.00 -32.00 -32.00 0.00 -33.00 -64.00 -32.00 0.00 -64.00 32.00 32.00 -65.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 64.00 0.00 0.00 -32.00 -32.00 -97.00 64.00 -64.00 -96.00 32.00 0.00 -32.00 32.00 -32.00 -64.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 0.00 0.00 -65.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -64.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 0.00 -33.00 0.00 -64.00 -64.00 -32.00 -32.00 0.00 -32.00 0.00 32.00 -32.00 0.00 -97.00 -32.00 33.00 -32.00 -33.00 64.00 -32.00 -32.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 -64.00 -33.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 0.00 -33.00 -32.00 33.00 0.00 -65.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 -64.00 -32.00 32.00 32.00 -64.00 -32.00 -32.00 0.00 32.00 -64.00 64.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 0.00 -33.00 -65.00 0.00 0.00 -32.00 -64.00 32.00 0.00 33.00 -32.00 0.00 0.00 -33.00 0.00 -64.00 -64.00 0.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 -64.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -33.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 32.00 -32.00 -65.00 0.00 0.00 -64.00 -32.00 -64.00 -32.00 -33.00 0.00 -32.00 0.00 -64.00 0.00 -96.00 32.00 -33.00 32.00 -64.00 65.00 -32.00 32.00 -97.00 -32.00 -128.00 32.00 -32.00 32.00 -33.00 64.00 -32.00 97.00 -160.00 32.00 -65.00 32.00 0.00 32.00 -96.00 32.00 -32.00 0.00 -65.00 33.00 -32.00 -33.00 -32.00 33.00 -64.00 64.00 -32.00 0.00 -33.00 32.00 0.00 32.00 -96.00 -32.00 -97.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 65.00 -32.00 0.00 -33.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 32.00 32.00 -32.00 0.00 -33.00 33.00 0.00 0.00 -32.00 -33.00 -32.00 33.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 -33.00 0.00 33.00 -32.00 -33.00 0.00 65.00 -32.00 0.00 -64.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 0.00 32.00 97.00 0.00 32.00 32.00 64.00 -32.00 32.00 0.00 32.00 0.00 33.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 32.00 33.00 0.00 32.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 0.00 -32.00 32.00 0.00 -32.00 0.00 32.00 -65.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 0.00 32.00 32.00 -32.00 64.00 65.00 -32.00 64.00 65.00 32.00 32.00 32.00 -32.00 32.00 32.00 33.00 -32.00 128.00 -97.00 450.00 -96.00 643.00 -161.00 65.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 -97.00 -161.00 33.00 -32.00 -33.00 -32.00 65.00 -128.00 -65.00 -161.00 0.00 -97.00 -96.00 -96.00 -64.00 -129.00 32.00 -161.00 -32.00 -64.00 32.00 -64.00 0.00 -32.00 -129.00 -32.00 0.00 -33.00 -32.00 0.00 -64.00 -64.00 -97.00 -32.00 -128.00 -97.00 0.00 -64.00 0.00 -161.00 64.00 -193.00 0.00 -192.00 96.00 -129.00 65.00 -64.00 64.00 -32.00 96.00 -33.00 65.00 -64.00 0.00 -32.00 -97.00 -32.00 65.00 -65.00 64.00 0.00 32.00 -128.00 -161.00 -193.00 -96.00 0.00 0.00 -225.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 -64.00 64.00 -64.00 -128.00 32.00 -32.00 -32.00 -97.00 96.00 -129.00 32.00 -96.00 65.00 -129.00 32.00 -64.00 32.00 -32.00 -64.00 -32.00 0.00 -65.00 -65.00 -32.00 -64.00 -64.00 0.00 -64.00 32.00 -32.00 257.00 -161.00 33.00 -65.00 160.00 33.00 193.00 32.00 129.00 64.00 129.00 32.00 128.00 65.00 97.00 32.00 128.00 96.00 65.00 32.00 64.00 32.00 96.00 -32.00 32.00 0.00 65.00 -32.00 64.00 32.00 64.00 -64.00 32.00 -32.00 33.00 0.00 64.00 -64.00 32.00 0.00 64.00 32.00 33.00 -32.00 -33.00 -129.00 -32.00 -32.00 0.00 -32.00 -64.00 -33.00 32.00 -96.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -64.00 -33.00 -32.00 -32.00 0.00 -64.00 -32.00 -64.00 32.00 -161.00 32.00 -64.00 64.00 -161.00 -64.00 -97.00 -32.00 0.00 -97.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -65.00 97.00 -64.00 0.00 -96.00 32.00 0.00 96.00 -33.00 32.00 -32.00 33.00 -32.00 -33.00 -64.00 33.00 -65.00 64.00 33.00 96.00 -33.00 0.00 33.00 33.00 96.00 96.00 0.00 64.00 97.00 129.00 64.00 128.00 128.00 33.00 0.00 32.00 33.00 32.00 0.00 96.00 32.00 0.00 64.00 65.00 0.00 0.00 96.00 0.00 65.00 32.00 32.00 64.00 0.00 -32.00 96.00 -32.00 33.00 0.00 32.00 -32.00 64.00 32.00 0.00 32.00 32.00 64.00 0.00 0.00 64.00 33.00 33.00 128.00 0.00 64.00 -33.00 65.00 0.00 32.00 97.00 64.00 0.00 0.00 -32.00 32.00 0.00 129.00 64.00 96.00 -96.00 -32.00 -97.00 32.00 0.00 0.00 32.00 65.00 65.00 32.00 0.00 32.00 -33.00 64.00 0.00 33.00 65.00 32.00 0.00 64.00 0.00 32.00 -32.00 32.00 -129.00 65.00 32.00 64.00 -96.00 32.00 -65.00 32.00 0.00 0.00 33.00 64.00 0.00 97.00 96.00 -32.00 129.00 64.00 0.00 32.00 64.00 97.00 32.00 0.00 97.00 0.00 128.00 -32.00 32.00 0.00 32.00 0.00 161.00 -161.00 161.00 -32.00 32.00 0.00 64.00 -65.00 33.00 0.00 64.00 -64.00 32.00 -32.00 64.00 0.00 33.00 32.00 32.00 0.00 64.00 -32.00 32.00 0.00 32.00 -64.00 32.00 -65.00 0.00 0.00 33.00 -64.00 0.00 -32.00 32.00 -97.00 0.00 0.00 64.00 97.00 64.00 0.00 97.00 32.00 64.00 32.00 -32.00 0.00 32.00 32.00 64.00 129.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 97.00 0.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 -97.00 -33.00 -32.00 65.00 0.00 0.00 -96.00 64.00 -64.00 161.00 -33.00 225.00 129.00 32.00 -32.00 32.00 0.00 0.00 -32.00 64.00 0.00 33.00 -32.00 32.00 0.00 0.00 -65.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 -32.00 65.00 32.00 64.00 -32.00 64.00 32.00 64.00 0.00 33.00 0.00 64.00 0.00 32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -33.00 33.00 33.00 0.00 -33.00 64.00 0.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 65.00 -96.00 32.00 -65.00 -32.00 -32.00 32.00 -64.00 32.00 0.00 0.00 32.00 32.00 -96.00 32.00 32.00 0.00 32.00 65.00 -32.00 32.00 -32.00 32.00 -97.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -64.00 32.00 32.00 0.00 -32.00 97.00 -97.00 0.00 -32.00 64.00 0.00 32.00 -32.00 32.00 0.00 33.00 0.00 64.00 64.00 32.00 0.00 64.00 -32.00 65.00 64.00 96.00 -64.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -32.00 33.00 -32.00 -33.00 0.00 65.00 -32.00 32.00 -65.00 32.00 0.00 0.00 33.00 32.00 0.00 97.00 -65.00 96.00 -96.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 32.00 33.00 0.00 0.00 -32.00 0.00 -32.00 96.00 0.00 32.00 -64.00 32.00 32.00 33.00 -64.00 -33.00 -65.00 33.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 64.00 0.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 33.00 -64.00 32.00 32.00 32.00 -65.00 32.00 -32.00 32.00 32.00 64.00 -64.00 0.00 -64.00 65.00 -32.00 32.00 -65.00 96.00 33.00 0.00 -33.00 32.00 0.00 33.00 0.00 0.00 -32.00 64.00 -32.00 -32.00 32.00 64.00 32.00 289.00 33.00 33.00 0.00 32.00 -33.00 64.00 -96.00 64.00 -129.00 33.00 -32.00 0.00 32.00 32.00 -32.00 0.00 -64.00 193.00 -65.00 0.00 -32.00 64.00 32.00 0.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 -32.00 64.00 -64.00 33.00 32.00 32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 96.00 -33.00 0.00 -32.00 33.00 0.00 0.00 -32.00 64.00 0.00 32.00 -32.00 64.00 0.00 0.00 -32.00 0.00 32.00 65.00 -96.00 32.00 0.00 32.00 0.00 32.00 0.00 0.00 -65.00 -32.00 32.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 0.00 65.00 0.00 -33.00 -33.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 33.00 -32.00 -65.00 -32.00 0.00 -32.00 97.00 32.00 32.00 -32.00 -32.00 -33.00 64.00 0.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 -32.00 65.00 0.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 65.00 -32.00 0.00 -65.00 32.00 33.00 32.00 -65.00 0.00 32.00 32.00 0.00 32.00 0.00 0.00 -64.00 33.00 0.00 0.00 -64.00 32.00 0.00 0.00 -32.00 64.00 64.00 0.00 -64.00 32.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 32.00 0.00 33.00 32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 32.00 32.00 -96.00 32.00 0.00 32.00 -32.00 32.00 0.00 33.00 0.00 64.00 -65.00 32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 33.00 0.00 0.00 -32.00 64.00 32.00 0.00 -64.00 64.00 0.00 65.00 0.00 32.00 -33.00 0.00 33.00 32.00 -33.00 32.00 33.00 32.00 0.00 32.00 -33.00 32.00 -32.00 33.00 0.00 0.00 -32.00 32.00 32.00 32.00 -32.00 64.00 -32.00 64.00 -64.00 97.00 -32.00 32.00 -33.00 32.00 0.00 32.00 0.00 0.00 33.00 33.00 -33.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 65.00 0.00 0.00 -32.00 96.00 -32.00 96.00 64.00 33.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 96.00 0.00 33.00 64.00 0.00 -32.00 -33.00 0.00 33.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -32.00 96.00 0.00 0.00 -32.00 0.00 -33.00 32.00 33.00 0.00 64.00 33.00 0.00 0.00 32.00 96.00 0.00 64.00 64.00 33.00 0.00 0.00 -64.00 128.00 32.00 0.00 64.00 -32.00 0.00 32.00 33.00 64.00 -33.00 33.00 -96.00 32.00 0.00 0.00 64.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 32.00 0.00 33.00 33.00 0.00 32.00 0.00 32.00 -33.00 0.00 33.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 33.00 -65.00 64.00 0.00 0.00 -32.00 32.00 0.00 96.00 0.00 -32.00 0.00 65.00 32.00 0.00 33.00 32.00 -33.00 32.00 0.00 32.00 65.00 32.00 0.00 0.00 64.00 0.00 -64.00 32.00 0.00 33.00 64.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 33.00 32.00 0.00 -32.00 0.00 64.00 64.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 65.00 -32.00 0.00 32.00 -33.00 0.00 33.00 32.00 32.00 -32.00 0.00 32.00 32.00 -64.00 64.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 0.00 33.00 32.00 -33.00 33.00 65.00 64.00 0.00 32.00 32.00 -96.00 129.00 0.00 32.00 -65.00 64.00 -64.00 225.00 -32.00 97.00 -32.00 32.00 -129.00 289.00 -32.00 193.00 0.00 32.00 -32.00 97.00 0.00 32.00 0.00 32.00 32.00 -32.00 0.00 96.00 32.00 0.00 0.00 65.00 -64.00 32.00 64.00 32.00 -64.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 64.00 32.00 0.00 32.00 33.00 65.00 0.00 193.00 64.00 96.00 0.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 32.00 128.00 0.00 32.00 32.00 33.00 33.00 0.00 32.00 -33.00 32.00 0.00 32.00 65.00 0.00 32.00 -32.00 64.00 0.00 0.00 32.00 32.00 0.00 33.00 0.00 32.00 32.00 32.00 32.00 161.00 33.00 64.00 32.00 32.00 0.00 64.00 -32.00 65.00 0.00 32.00 64.00 161.00 96.00 32.00 32.00 -32.00 0.00 0.00 65.00 32.00 64.00 32.00 0.00 32.00 -64.00 32.00 32.00 0.00 -64.00 65.00 0.00 32.00 -33.00 32.00 0.00 32.00 0.00 32.00 0.00 0.00 -32.00 -64.00 -64.00 32.00 -32.00 64.00 0.00 32.00 -32.00 -32.00 -65.00 32.00 -32.00 65.00 0.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 32.00 97.00 -64.00 128.00 -65.00 33.00 0.00 64.00 0.00 64.00 -64.00 32.00 -32.00 32.00 0.00 65.00 -32.00 32.00 32.00 64.00 0.00 32.00 -32.00 0.00 -33.00 225.00 -32.00 33.00 0.00 96.00 0.00 32.00 -32.00 32.00 0.00 65.00 32.00 0.00 -32.00 128.00 64.00 97.00 0.00 64.00 65.00 32.00 0.00 0.00 -32.00 32.00 32.00 65.00 32.00 32.00 64.00 32.00 -32.00 32.00 0.00 32.00 -64.00 32.00 64.00 33.00 0.00 64.00 -32.00 32.00 0.00 0.00 32.00 97.00 64.00 32.00 -32.00 96.00 32.00 32.00 -32.00 97.00 65.00 64.00 0.00 32.00 32.00 32.00 96.00 0.00 32.00 33.00 0.00 32.00 33.00 0.00 -33.00 32.00 97.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 32.00 32.00 0.00 33.00 -32.00 32.00 32.00 -32.00 0.00 0.00 32.00 64.00 32.00 32.00 65.00 64.00 0.00 0.00 32.00 32.00 32.00 129.00 96.00 64.00 65.00 161.00 32.00 32.00 64.00 65.00 64.00 64.00 33.00 0.00 32.00 64.00 -32.00 -32.00 0.00 64.00 0.00 0.00 32.00 33.00 0.00 -33.00 32.00 65.00 32.00 32.00 32.00 32.00 -32.00 64.00 64.00 0.00 -32.00 32.00 64.00 33.00 0.00 -33.00 0.00 97.00 65.00 64.00 64.00 32.00 -64.00 65.00 -65.00 64.00 33.00 32.00 32.00 32.00 32.00 65.00 96.00 32.00 0.00 96.00 33.00 0.00 64.00 65.00 0.00 32.00 0.00 96.00 64.00 97.00 129.00 160.00 0.00 0.00 64.00 -32.00 129.00 129.00 32.00 96.00 64.00 97.00 -32.00 32.00 32.00 64.00 97.00 97.00 -97.00 32.00 0.00 32.00 64.00 32.00 33.00 129.00 32.00 32.00 64.00 32.00 -32.00 64.00 64.00 65.00 -64.00 96.00 -64.00 65.00 32.00 64.00 -32.00 32.00 32.00 64.00 -32.00 0.00 -65.00 32.00 0.00 33.00 65.00 64.00 0.00 0.00 64.00 32.00 32.00 32.00 32.00 64.00 32.00 65.00 65.00 32.00 96.00 32.00 0.00 0.00 97.00 32.00 0.00 32.00 0.00 65.00 -33.00 193.00 -64.00 160.00 -32.00 33.00 32.00 64.00 0.00 128.00 64.00 97.00 -32.00 0.00 -64.00 64.00 0.00 32.00 -32.00 65.00 0.00 32.00 -32.00 64.00 -32.00 32.00 -97.00 65.00 0.00 64.00 -32.00 129.00 -32.00 32.00 -32.00 32.00 0.00 1157.00 1061.00 450.00 418.00 354.00 353.00 129.00 97.00 0.00 32.00 96.00 675.00 32.00 515.00 33.00 0.00 96.00 0.00 64.00 -33.00 32.00 0.00 65.00 65.00 96.00 -32.00 65.00 -33.00 96.00 0.00 96.00 65.00 33.00 0.00 96.00 32.00 64.00 32.00 65.00 32.00 32.00 -32.00 32.00 -96.00 32.00 0.00 129.00 -33.00 96.00 -96.00 97.00 32.00 96.00 -64.00 129.00 0.00 96.00 -97.00 32.00 0.00 0.00 -96.00 33.00 -32.00 32.00 -32.00 0.00 -65.00 64.00 65.00 64.00 0.00 32.00 0.00 33.00 0.00 64.00 0.00 32.00 160.00 64.00 0.00 32.00 0.00 129.00 -32.00 32.00 -32.00 32.00 32.00 33.00 -64.00 32.00 0.00 0.00 -97.00 0.00 -32.00 64.00 0.00 0.00 32.00 129.00 65.00 32.00 64.00 -32.00 64.00 32.00 65.00 64.00 32.00 97.00 -32.00 32.00 -32.00 32.00 0.00 -32.00 -65.00 32.00 -64.00 64.00 0.00 64.00 -32.00 33.00 0.00 0.00 32.00 32.00 0.00 64.00 96.00 0.00 33.00 97.00 32.00 64.00 128.00 32.00 0.00 32.00 -64.00 32.00 0.00 65.00 96.00 32.00 0.00 32.00 33.00 0.00 32.00 -32.00 32.00 64.00 32.00 0.00 32.00 129.00 32.00 -32.00 65.00 32.00 64.00 64.00 0.00 64.00 -32.00 97.00 0.00 0.00 -64.00 32.00 -65.00 64.00 -32.00 32.00 32.00 33.00 32.00 32.00 -32.00 64.00 -96.00 32.00 32.00 32.00 0.00 97.00 96.00 32.00 129.00 32.00 32.00 0.00 -32.00 64.00 64.00 0.00 -32.00 33.00 32.00 64.00 0.00 32.00 32.00 32.00 -32.00 64.00 -32.00 33.00 32.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 97.00 0.00 64.00 -32.00 32.00 32.00 33.00 -32.00 32.00 0.00 32.00 0.00 64.00 -32.00 32.00 0.00 32.00 64.00 0.00 32.00 33.00 0.00 0.00 65.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 64.00 32.00 0.00 0.00 32.00 32.00 -32.00 97.00 65.00 32.00 0.00 0.00 128.00 -65.00 32.00 33.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 64.00 33.00 0.00 64.00 -32.00 32.00 32.00 32.00 0.00 32.00 0.00 0.00 -32.00 65.00 -32.00 0.00 32.00 -33.00 65.00 33.00 32.00 32.00 0.00 32.00 -65.00 32.00 0.00 -32.00 97.00 0.00 -32.00 0.00 64.00 -32.00 0.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 32.00 32.00 33.00 -32.00 0.00 0.00 32.00 64.00 0.00 33.00 32.00 -33.00 0.00 33.00 32.00 32.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 64.00 32.00 0.00 0.00 33.00 33.00 0.00 0.00 -33.00 64.00 0.00 0.00 65.00 96.00 0.00 0.00 -65.00 33.00 0.00 128.00 0.00 32.00 33.00 32.00 0.00 -32.00 0.00 -64.00 96.00 0.00 32.00 64.00 0.00 97.00 97.00 0.00 64.00 64.00 32.00 32.00 64.00 0.00 65.00 65.00 0.00 0.00 64.00 32.00 32.00 0.00 65.00 -97.00 64.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 64.00 32.00 0.00 32.00 64.00 -32.00 129.00 -64.00 32.00 0.00 32.00 -65.00 32.00 0.00 33.00 -96.00 128.00 32.00 65.00 32.00 32.00 32.00 96.00 -96.00 0.00 -32.00 32.00 -64.00 33.00 -33.00 128.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 64.00 -65.00 32.00 0.00 33.00 -32.00 32.00 -32.00 32.00 -64.00 161.00 -32.00 64.00 0.00 32.00 -33.00 97.00 -64.00 0.00 0.00 64.00 -32.00 64.00 -64.00 32.00 -33.00 -64.00 -32.00 0.00 32.00 -64.00 -32.00 -65.00 -32.00 65.00 -32.00 96.00 -32.00 65.00 -32.00 0.00 -65.00 128.00 -96.00 97.00 -32.00 32.00 -32.00 0.00 0.00 64.00 -33.00 0.00 33.00 32.00 32.00 0.00 0.00 97.00 32.00 0.00 0.00 64.00 0.00 32.00 -64.00 0.00 -97.00 -32.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 -97.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 0.00 -64.00 129.00 0.00 32.00 -32.00 64.00 -32.00 161.00 -65.00 128.00 0.00 65.00 33.00 32.00 32.00 32.00 -32.00 64.00 0.00 97.00 -65.00 32.00 -64.00 161.00 -64.00 32.00 64.00 32.00 64.00 32.00 129.00 0.00 32.00 32.00 64.00 -32.00 65.00 32.00 0.00 65.00 32.00 32.00 0.00 64.00 32.00 32.00 -32.00 32.00 0.00 33.00 -64.00 0.00 0.00 32.00 -33.00 32.00 0.00 96.00 -32.00 65.00 -64.00 0.00 -32.00 -65.00 -65.00 65.00 -32.00 0.00 -32.00 32.00 -64.00 -65.00 -32.00 0.00 0.00 -32.00 -97.00 -64.00 -32.00 32.00 -96.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 0.00 -32.00 -32.00 0.00 -32.00 -96.00 0.00 -65.00 32.00 0.00 97.00 -64.00 128.00 -64.00 161.00 -97.00 96.00 -32.00 0.00 -32.00 129.00 0.00 32.00 0.00 32.00 -96.00 193.00 0.00 65.00 0.00 32.00 64.00 0.00 0.00 32.00 -32.00 193.00 -65.00 96.00 33.00 161.00 96.00 32.00 0.00 65.00 -64.00 64.00 32.00 96.00 -32.00 32.00 -32.00 0.00 0.00 65.00 32.00 32.00 0.00 64.00 96.00 65.00 -128.00 32.00 -65.00 96.00 -32.00 0.00 0.00 64.00 -64.00 0.00 0.00 65.00 64.00 32.00 -64.00 64.00 32.00 32.00 0.00 65.00 0.00 32.00 0.00 32.00 -129.00 64.00 97.00 65.00 32.00 32.00 96.00 -32.00 65.00 32.00 64.00 64.00 161.00 32.00 0.00 32.00 0.00 32.00 64.00 97.00 32.00 0.00 0.00 64.00 65.00 0.00 0.00 97.00 -33.00 64.00 33.00 32.00 32.00 32.00 64.00 161.00 97.00 64.00 64.00 -64.00 96.00 0.00 -32.00 32.00 32.00 65.00 -32.00 0.00 0.00 32.00 0.00 64.00 64.00 32.00 33.00 64.00 64.00 -64.00 32.00 0.00 64.00 97.00 32.00 64.00 33.00 -97.00 0.00 -64.00 32.00 32.00 32.00 65.00 64.00 32.00 -32.00 64.00 32.00 32.00 65.00 32.00 32.00 33.00 0.00 96.00 32.00 32.00 32.00 0.00 32.00 97.00 32.00 32.00 97.00 -32.00 32.00 64.00 32.00 0.00 64.00 0.00 65.00 96.00 -32.00 65.00 32.00 64.00 -32.00 64.00 64.00 65.00 32.00 64.00 -32.00 64.00 32.00 -32.00 64.00 32.00 32.00 65.00 0.00 32.00 -160.00 225.00 -257.00 128.00 0.00 32.00 32.00 33.00 96.00 64.00 64.00 32.00 0.00 129.00 -128.00 -65.00 -64.00 -32.00 -33.00 0.00 -96.00 -64.00 0.00 -32.00 -64.00 32.00 -33.00 -64.00 -32.00 0.00 -64.00 -65.00 -64.00 0.00 -33.00 32.00 -64.00 -32.00 -32.00 32.00 -64.00 0.00 0.00 -32.00 -129.00 0.00 -64.00 0.00 -129.00 -32.00 -32.00 64.00 -96.00 -96.00 -97.00 0.00 -64.00 -96.00 -32.00 0.00 -97.00 64.00 -96.00 64.00 -97.00 0.00 0.00 97.00 -64.00 0.00 -64.00 0.00 0.00 32.00 0.00 32.00 -32.00 64.00 32.00 32.00 -65.00 33.00 0.00 64.00 -96.00 32.00 -32.00 64.00 -32.00 33.00 -65.00 -33.00 -32.00 33.00 -32.00 -33.00 -97.00 65.00 -32.00 -32.00 0.00 -65.00 -64.00 0.00 -64.00 0.00 -32.00 32.00 -65.00 -32.00 -32.00 0.00 -32.00 0.00 32.00 -96.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 32.00 -65.00 -32.00 -64.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -97.00 129.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -33.00 -65.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 611.00 579.00 32.00 225.00 -128.00 32.00 -33.00 -32.00 -96.00 -32.00 -32.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 -33.00 -32.00 0.00 0.00 -64.00 -64.00 -32.00 -65.00 0.00 0.00 -64.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 64.00 0.00 33.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -65.00 -33.00 -32.00 33.00 -32.00 96.00 -96.00 0.00 0.00 -64.00 -65.00 0.00 -32.00 96.00 -32.00 0.00 32.00 -64.00 -96.00 32.00 0.00 32.00 0.00 32.00 -65.00 0.00 -128.00 65.00 0.00 64.00 -32.00 32.00 0.00 32.00 32.00 32.00 0.00 33.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 32.00 -161.00 129.00 -96.00 96.00 -33.00 32.00 0.00 129.00 33.00 32.00 0.00 97.00 0.00 64.00 0.00 32.00 -65.00 0.00 0.00 64.00 0.00 65.00 97.00 0.00 -65.00 32.00 -64.00 32.00 -64.00 96.00 32.00 32.00 418.00 33.00 129.00 0.00 160.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 -32.00 290.00 0.00 96.00 -32.00 0.00 -32.00 257.00 32.00 32.00 0.00 32.00 -32.00 33.00 -32.00 32.00 -32.00 0.00 0.00 32.00 64.00 32.00 -32.00 32.00 64.00 -32.00 0.00 32.00 32.00 0.00 -32.00 32.00 64.00 0.00 65.00 65.00 64.00 0.00 32.00 32.00 161.00 32.00 32.00 32.00 32.00 193.00 0.00 32.00 0.00 193.00 65.00 64.00 -33.00 33.00 65.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 -33.00 32.00 -32.00 33.00 -32.00 -33.00 -32.00 33.00 -64.00 32.00 -290.00 0.00 -96.00 0.00 -161.00 0.00 -64.00 0.00 -65.00 0.00 -64.00 -97.00 0.00 -32.00 -32.00 -32.00 -32.00 -64.00 -64.00 32.00 -65.00 0.00 -32.00 0.00 -289.00 0.00 -65.00 96.00 33.00 65.00 -33.00 64.00 33.00 0.00 -33.00 32.00 33.00 32.00 32.00 0.00 64.00 97.00 32.00 -33.00 0.00 -32.00 0.00 -64.00 64.00 64.00 33.00 0.00 96.00 -32.00 32.00 32.00 32.00 65.00 0.00 32.00 33.00 0.00 32.00 0.00 64.00 32.00 32.00 64.00 32.00 32.00 0.00 65.00 32.00 0.00 33.00 32.00 96.00 32.00 0.00 32.00 64.00 0.00 0.00 32.00 33.00 65.00 32.00 0.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 32.00 0.00 32.00 -32.00 0.00 -128.00 97.00 -65.00 0.00 0.00 64.00 -32.00 32.00 65.00 64.00 -33.00 65.00 33.00 32.00 32.00 0.00 0.00 64.00 96.00 0.00 32.00 64.00 32.00 -32.00 33.00 0.00 0.00 65.00 32.00 -33.00 0.00 65.00 0.00 32.00 32.00 0.00 64.00 0.00 32.00 32.00 33.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 65.00 64.00 0.00 -32.00 64.00 32.00 32.00 32.00 32.00 0.00 65.00 32.00 0.00 0.00 32.00 33.00 0.00 -33.00 32.00 33.00 32.00 0.00 64.00 -33.00 33.00 -32.00 0.00 0.00 64.00 32.00 32.00 -32.00 32.00 32.00 0.00 65.00 32.00 0.00 97.00 -65.00 0.00 -64.00 32.00 32.00 32.00 65.00 0.00 -33.00 32.00 0.00 32.00 33.00 0.00 32.00 0.00 32.00 0.00 32.00 33.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 96.00 0.00 65.00 65.00 32.00 -33.00 32.00 0.00 32.00 -128.00 97.00 0.00 32.00 0.00 64.00 -32.00 32.00 0.00 32.00 32.00 33.00 0.00 64.00 64.00 32.00 -32.00 32.00 0.00 32.00 -96.00 129.00 0.00 32.00 -161.00 0.00 -97.00 -32.00 -96.00 -32.00 0.00 64.00 32.00 64.00 -32.00 97.00 32.00 64.00 32.00 65.00 0.00 32.00 -96.00 32.00 0.00 32.00 -97.00 0.00 0.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 161.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 -64.00 32.00 -65.00 0.00 -32.00 32.00 -32.00 96.00 32.00 33.00 -32.00 32.00 0.00 64.00 0.00 32.00 -32.00 65.00 32.00 32.00 -64.00 32.00 0.00 64.00 64.00 32.00 32.00 65.00 -32.00 0.00 0.00 32.00 64.00 32.00 -32.00 64.00 -32.00 97.00 -32.00 0.00 32.00 64.00 0.00 32.00 -32.00 0.00 0.00 193.00 -32.00 32.00 -65.00 65.00 -32.00 -33.00 -96.00 33.00 0.00 64.00 -65.00 96.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -129.00 0.00 -32.00 32.00 -32.00 129.00 -32.00 32.00 32.00 64.00 0.00 33.00 32.00 64.00 -64.00 64.00 0.00 97.00 -32.00 32.00 -33.00 32.00 0.00 32.00 -32.00 97.00 -32.00 32.00 0.00 64.00 -32.00 64.00 32.00 33.00 -64.00 64.00 32.00 0.00 -32.00 32.00 -32.00 64.00 -33.00 32.00 0.00 33.00 -32.00 96.00 -96.00 64.00 -32.00 -32.00 -32.00 32.00 0.00 33.00 -193.00 0.00 -997.00 0.00 -450.00 0.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 129.00 -33.00 32.00 -32.00 96.00 32.00 32.00 -32.00 33.00 -96.00 0.00 0.00 32.00 -32.00 32.00 -65.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 65.00 -64.00 32.00 0.00 32.00 -33.00 96.00 65.00 0.00 0.00 33.00 64.00 160.00 161.00 32.00 0.00 65.00 0.00 64.00 0.00 161.00 -32.00 64.00 0.00 97.00 -32.00 32.00 32.00 96.00 0.00 32.00 0.00 33.00 -65.00 0.00 -32.00 32.00 0.00 32.00 -64.00 96.00 0.00 65.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 32.00 96.00 0.00 65.00 0.00 -33.00 65.00 33.00 32.00 0.00 -32.00 32.00 32.00 -32.00 32.00 -33.00 32.00 -32.00 0.00 32.00 32.00 -64.00 32.00 -32.00 65.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -33.00 32.00 33.00 32.00 -33.00 33.00 -32.00 0.00 32.00 32.00 33.00 96.00 -33.00 0.00 0.00 -32.00 -64.00 0.00 0.00 64.00 0.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 0.00 -64.00 0.00 32.00 32.00 -64.00 129.00 64.00 64.00 -32.00 32.00 -32.00 33.00 -65.00 32.00 -32.00 32.00 32.00 32.00 -64.00 32.00 0.00 64.00 -32.00 33.00 32.00 32.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 0.00 64.00 -97.00 -32.00 -32.00 32.00 -96.00 -32.00 -65.00 0.00 -32.00 32.00 -96.00 33.00 -97.00 0.00 -32.00 -33.00 -64.00 65.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 -32.00 -64.00 32.00 -64.00 64.00 0.00 32.00 64.00 33.00 0.00 32.00 64.00 64.00 33.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 64.00 65.00 33.00 32.00 0.00 32.00 -65.00 0.00 -32.00 -32.00 0.00 32.00 0.00 32.00 0.00 32.00 -96.00 97.00 0.00 32.00 -65.00 0.00 0.00 64.00 -32.00 32.00 0.00 32.00 -128.00 0.00 0.00 65.00 0.00 64.00 -33.00 0.00 -32.00 64.00 -32.00 32.00 -32.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 64.00 129.00 -32.00 32.00 0.00 64.00 32.00 32.00 0.00 -32.00 32.00 32.00 -32.00 65.00 32.00 32.00 -32.00 32.00 -32.00 32.00 -64.00 32.00 -33.00 32.00 -32.00 33.00 0.00 128.00 -32.00 64.00 0.00 33.00 32.00 0.00 32.00 32.00 -64.00 32.00 32.00 32.00 -32.00 32.00 32.00 65.00 -64.00 32.00 0.00 32.00 -64.00 32.00 32.00 0.00 64.00 32.00 -32.00 32.00 -32.00 32.00 -65.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 97.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 65.00 96.00 32.00 0.00 32.00 65.00 96.00 -33.00 33.00 -64.00 32.00 -32.00 96.00 -64.00 0.00 -33.00 32.00 0.00 32.00 -32.00 33.00 0.00 32.00 -96.00 32.00 0.00 32.00 32.00 32.00 -96.00 65.00 -33.00 32.00 -96.00 128.00 32.00 33.00 32.00 0.00 -64.00 64.00 32.00 32.00 32.00 0.00 65.00 0.00 0.00 64.00 32.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 65.00 32.00 32.00 33.00 -32.00 0.00 32.00 64.00 32.00 -32.00 32.00 32.00 0.00 64.00 0.00 32.00 0.00 32.00 0.00 33.00 -193.00 64.00 0.00 32.00 -128.00 32.00 -97.00 0.00 -96.00 32.00 -32.00 0.00 -32.00 65.00 -322.00 96.00 -32.00 32.00 -322.00 129.00 -225.00 96.00 0.00 65.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -128.00 32.00 -97.00 32.00 -32.00 32.00 -193.00 65.00 -193.00 96.00 -32.00 32.00 -129.00 65.00 -257.00 64.00 -161.00 64.00 0.00 33.00 -128.00 128.00 -193.00 64.00 -64.00 33.00 -33.00 0.00 -128.00 96.00 -32.00 0.00 -97.00 32.00 -64.00 32.00 0.00 32.00 32.00 33.00 -32.00 32.00 -64.00 96.00 -129.00 32.00 0.00 -32.00 -64.00 0.00 -65.00 0.00 -96.00 32.00 0.00 65.00 -64.00 32.00 -33.00 -64.00 -32.00 -97.00 0.00 -32.00 97.00 -64.00 0.00 -65.00 0.00 -64.00 -65.00 0.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 0.00 -129.00 96.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 33.00 -32.00 -33.00 -32.00 33.00 -65.00 0.00 -96.00 32.00 -64.00 -32.00 -33.00 -33.00 -32.00 33.00 -64.00 0.00 -32.00 -33.00 -32.00 0.00 -65.00 33.00 0.00 32.00 -96.00 64.00 -129.00 96.00 -64.00 0.00 -32.00 33.00 -129.00 64.00 -64.00 0.00 -64.00 0.00 -65.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 -161.00 32.00 -32.00 32.00 -32.00 -32.00 -64.00 -32.00 0.00 -97.00 -33.00 33.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 0.00 32.00 0.00 32.00 -32.00 0.00 0.00 -64.00 -32.00 32.00 -65.00 -64.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -64.00 0.00 0.00 64.00 -32.00 32.00 0.00 -32.00 -33.00 -64.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 0.00 -64.00 97.00 -32.00 -33.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 -128.00 96.00 -33.00 0.00 -32.00 0.00 -64.00 32.00 -64.00 33.00 -65.00 -33.00 -32.00 33.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 64.00 -64.00 0.00 -33.00 32.00 -192.00 64.00 -65.00 33.00 -32.00 0.00 -96.00 32.00 0.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -64.00 -64.00 -97.00 0.00 0.00 32.00 -128.00 32.00 -33.00 0.00 0.00 64.00 -32.00 0.00 -32.00 33.00 0.00 -33.00 -64.00 -32.00 0.00 32.00 0.00 33.00 -64.00 32.00 -33.00 -32.00 0.00 32.00 0.00 32.00 0.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 33.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -64.00 32.00 -33.00 0.00 0.00 -32.00 -64.00 32.00 0.00 32.00 -64.00 32.00 -32.00 33.00 -33.00 -33.00 -32.00 33.00 -32.00 -129.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 64.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -64.00 0.00 -65.00 0.00 -32.00 -32.00 -64.00 64.00 -32.00 33.00 -33.00 0.00 -32.00 0.00 0.00 -65.00 -96.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -129.00 128.00 -96.00 32.00 0.00 33.00 -65.00 32.00 0.00 32.00 -64.00 0.00 0.00 -32.00 -97.00 32.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 -97.00 32.00 -32.00 32.00 0.00 64.00 -96.00 33.00 0.00 32.00 -65.00 64.00 0.00 32.00 -32.00 -32.00 -64.00 0.00 -64.00 -32.00 -65.00 32.00 -96.00 -64.00 -32.00 0.00 -65.00 64.00 -64.00 0.00 -64.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 65.00 0.00 32.00 -64.00 32.00 -65.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 -33.00 32.00 -64.00 32.00 -32.00 97.00 -64.00 0.00 -129.00 0.00 -96.00 64.00 -33.00 32.00 -128.00 -32.00 -32.00 0.00 -65.00 0.00 -64.00 0.00 0.00 -32.00 -64.00 32.00 -97.00 32.00 -96.00 65.00 -65.00 -33.00 -32.00 33.00 -64.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 32.00 -32.00 0.00 -64.00 64.00 -32.00 33.00 0.00 32.00 32.00 32.00 -64.00 64.00 -129.00 32.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 -160.00 97.00 32.00 32.00 -32.00 64.00 0.00 33.00 -32.00 0.00 -33.00 32.00 -96.00 -32.00 -161.00 32.00 -32.00 32.00 -64.00 0.00 -33.00 64.00 -64.00 0.00 -96.00 64.00 -32.00 0.00 -65.00 0.00 32.00 -96.00 -32.00 -32.00 -32.00 -32.00 -64.00 0.00 -32.00 -32.00 -32.00 -33.00 -33.00 0.00 -96.00 -64.00 -32.00 0.00 32.00 32.00 -64.00 161.00 -65.00 -32.00 -128.00 96.00 -32.00 0.00 -33.00 32.00 -32.00 0.00 -128.00 33.00 -33.00 -33.00 0.00 -32.00 33.00 -32.00 96.00 -64.00 -32.00 -64.00 -64.00 0.00 0.00 -65.00 -65.00 65.00 32.00 0.00 -32.00 32.00 -64.00 0.00 -64.00 96.00 -161.00 32.00 -64.00 32.00 -33.00 0.00 -64.00 -64.00 32.00 -32.00 0.00 -32.00 65.00 -64.00 -33.00 0.00 33.00 -65.00 32.00 0.00 -32.00 -64.00 0.00 -32.00 -65.00 -32.00 -96.00 64.00 -97.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 32.00 32.00 33.00 0.00 32.00 64.00 0.00 33.00 96.00 64.00 32.00 0.00 32.00 32.00 0.00 -96.00 33.00 -33.00 32.00 -64.00 -32.00 -64.00 0.00 0.00 32.00 -32.00 32.00 -33.00 0.00 0.00 32.00 -96.00 32.00 -32.00 32.00 -129.00 33.00 -32.00 128.00 64.00 64.00 33.00 0.00 96.00 -32.00 96.00 -32.00 33.00 0.00 96.00 0.00 32.00 0.00 -32.00 0.00 64.00 97.00 0.00 64.00 33.00 0.00 0.00 64.00 -33.00 32.00 -32.00 0.00 -32.00 65.00 0.00 32.00 32.00 32.00 32.00 32.00 33.00 0.00 0.00 32.00 -65.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 -33.00 64.00 -64.00 0.00 32.00 161.00 0.00 32.00 -32.00 32.00 -64.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -65.00 -32.00 0.00 32.00 -64.00 -32.00 0.00 32.00 -64.00 0.00 -33.00 0.00 -32.00 64.00 -32.00 0.00 0.00 64.00 0.00 32.00 -32.00 0.00 -64.00 33.00 -32.00 0.00 0.00 -65.00 0.00 -32.00 -33.00 0.00 0.00 -64.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 32.00 -65.00 -32.00 0.00 -64.00 32.00 0.00 33.00 -64.00 64.00 -65.00 0.00 -32.00 32.00 -32.00 32.00 -64.00 32.00 -65.00 32.00 0.00 33.00 -64.00 32.00 -32.00 32.00 -97.00 -32.00 -96.00 64.00 -129.00 -32.00 -96.00 32.00 -64.00 64.00 -65.00 0.00 -64.00 65.00 -64.00 -32.00 32.00 -33.00 32.00 -96.00 0.00 -32.00 -32.00 -97.00 0.00 -32.00 -32.00 32.00 -161.00 32.00 -32.00 -32.00 -33.00 32.00 -160.00 65.00 -32.00 64.00 -33.00 -32.00 -64.00 0.00 0.00 -64.00 -32.00 0.00 -64.00 0.00 -65.00 96.00 -96.00 -32.00 -97.00 32.00 -32.00 32.00 -96.00 -32.00 -32.00 -64.00 -33.00 -32.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 65.00 0.00 -33.00 -96.00 33.00 -32.00 -33.00 -32.00 0.00 -65.00 65.00 -128.00 64.00 -33.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -96.00 0.00 -32.00 32.00 -65.00 -96.00 -32.00 0.00 0.00 -33.00 -32.00 33.00 -64.00 0.00 -97.00 -65.00 0.00 32.00 -64.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 -96.00 -65.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 65.00 32.00 0.00 -32.00 96.00 -32.00 32.00 -32.00 65.00 32.00 32.00 -32.00 32.00 32.00 -32.00 32.00 32.00 0.00 64.00 -32.00 0.00 -65.00 -32.00 -32.00 -32.00 -32.00 -64.00 0.00 -33.00 -32.00 0.00 -32.00 97.00 -32.00 -97.00 -97.00 65.00 -64.00 -97.00 0.00 0.00 -64.00 97.00 -97.00 0.00 -64.00 -32.00 32.00 -33.00 0.00 -64.00 -32.00 0.00 -32.00 -64.00 0.00 0.00 -65.00 -64.00 0.00 -97.00 0.00 -32.00 -32.00 -64.00 32.00 0.00 -64.00 -161.00 -64.00 32.00 -32.00 0.00 -65.00 -64.00 -32.00 -33.00 0.00 0.00 -32.00 33.00 -32.00 -33.00 -32.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 -64.00 0.00 -33.00 0.00 -64.00 -33.00 0.00 33.00 -96.00 -33.00 -32.00 -32.00 -33.00 0.00 0.00 -32.00 -96.00 -32.00 0.00 -32.00 32.00 -97.00 -32.00 -32.00 32.00 -64.00 -64.00 0.00 -32.00 -64.00 -33.00 0.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -33.00 32.00 0.00 64.00 -64.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 -64.00 32.00 32.00 -32.00 -64.00 97.00 -65.00 -32.00 -32.00 64.00 -160.00 -32.00 -33.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 -96.00 128.00 -32.00 64.00 -64.00 0.00 -33.00 -64.00 0.00 -32.00 -96.00 -64.00 -32.00 -65.00 -65.00 -96.00 33.00 -64.00 -33.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 32.00 64.00 -32.00 65.00 0.00 96.00 -32.00 0.00 -32.00 -64.00 -33.00 -65.00 -64.00 33.00 -64.00 32.00 0.00 0.00 -32.00 64.00 32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 33.00 -33.00 96.00 65.00 32.00 0.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 -65.00 -97.00 0.00 -64.00 -64.00 -32.00 32.00 -65.00 -64.00 -64.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -65.00 -32.00 -32.00 0.00 -32.00 -64.00 -96.00 -32.00 0.00 -32.00 0.00 -33.00 -65.00 33.00 -64.00 64.00 -32.00 0.00 -32.00 96.00 -97.00 -32.00 -64.00 32.00 0.00 33.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 -32.00 32.00 -64.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 193.00 32.00 64.00 -32.00 0.00 -97.00 64.00 -32.00 33.00 0.00 -33.00 -64.00 33.00 -32.00 64.00 0.00 0.00 -65.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 33.00 -32.00 32.00 0.00 0.00 -32.00 -65.00 -65.00 -32.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 -64.00 65.00 -65.00 -33.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -65.00 0.00 -64.00 -32.00 0.00 -32.00 -129.00 64.00 0.00 32.00 -64.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -65.00 -33.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 -64.00 0.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 -64.00 96.00 -32.00 -64.00 -32.00 -32.00 0.00 32.00 -65.00 0.00 -96.00 -64.00 -32.00 -32.00 32.00 -65.00 -32.00 0.00 -65.00 0.00 -32.00 33.00 -32.00 32.00 -128.00 -32.00 -65.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -64.00 0.00 0.00 32.00 -33.00 0.00 0.00 32.00 -96.00 32.00 -32.00 33.00 -32.00 0.00 -32.00 32.00 -65.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 0.00 -33.00 -32.00 -64.00 32.00 0.00 32.00 -64.00 -32.00 -64.00 32.00 -33.00 33.00 -32.00 -33.00 -32.00 -64.00 -32.00 -32.00 -64.00 0.00 -33.00 -32.00 -64.00 -32.00 0.00 32.00 -32.00 -64.00 -64.00 0.00 -32.00 0.00 -65.00 -33.00 -64.00 0.00 -32.00 -32.00 0.00 -32.00 -65.00 -64.00 33.00 0.00 -65.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 0.00 32.00 -32.00 -64.00 -64.00 -97.00 0.00 -32.00 -32.00 -32.00 32.00 -97.00 -97.00 -96.00 65.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 0.00 0.00 -33.00 -97.00 -32.00 -32.00 -32.00 -32.00 0.00 32.00 -96.00 -32.00 -65.00 -32.00 -96.00 -32.00 -97.00 32.00 -32.00 0.00 -64.00 32.00 -97.00 -32.00 -32.00 -64.00 -32.00 -32.00 -64.00 -65.00 0.00 -32.00 -64.00 0.00 -65.00 -96.00 0.00 -65.00 -64.00 -64.00 -129.00 64.00 -160.00 65.00 -129.00 -65.00 -129.00 65.00 -32.00 32.00 -96.00 32.00 0.00 32.00 -32.00 32.00 -129.00 32.00 0.00 -32.00 -64.00 65.00 -65.00 0.00 -32.00 32.00 -32.00 64.00 32.00 161.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -64.00 0.00 -65.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -65.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 -33.00 0.00 -64.00 -128.00 32.00 -32.00 -32.00 -65.00 0.00 -64.00 -32.00 0.00 -32.00 -64.00 -129.00 -32.00 -64.00 -33.00 -64.00 0.00 -97.00 -96.00 -96.00 -32.00 -32.00 -64.00 -65.00 0.00 -96.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -96.00 64.00 -32.00 -32.00 -33.00 32.00 0.00 0.00 -32.00 0.00 -64.00 32.00 0.00 0.00 -96.00 32.00 -65.00 32.00 0.00 65.00 -96.00 32.00 0.00 64.00 -161.00 0.00 -32.00 -64.00 -97.00 -32.00 -64.00 -32.00 0.00 0.00 -96.00 -33.00 -65.00 -32.00 0.00 -96.00 -32.00 -64.00 -128.00 -129.00 -33.00 -64.00 -64.00 -65.00 0.00 -64.00 -96.00 -129.00 0.00 -32.00 0.00 -32.00 -97.00 -129.00 -64.00 0.00 -64.00 0.00 -33.00 65.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 -65.00 -65.00 -96.00 -96.00 0.00 -32.00 -32.00 32.00 -32.00 32.00 -65.00 0.00 -64.00 64.00 -129.00 0.00 -64.00 32.00 0.00 33.00 -129.00 0.00 -64.00 32.00 0.00 96.00 -96.00 97.00 -65.00 0.00 -64.00 32.00 -64.00 -64.00 -32.00 -33.00 -65.00 -64.00 0.00 -32.00 0.00 -32.00 -161.00 -129.00 -32.00 0.00 -96.00 32.00 -64.00 32.00 -97.00 -32.00 -161.00 0.00 -160.00 65.00 -65.00 -33.00 -32.00 0.00 -64.00 97.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 32.00 0.00 32.00 32.00 0.00 32.00 -32.00 64.00 0.00 65.00 0.00 64.00 -32.00 64.00 -97.00 97.00 -32.00 0.00 -129.00 -65.00 -64.00 -96.00 -32.00 -161.00 -129.00 -96.00 -32.00 0.00 -32.00 32.00 0.00 161.00 -32.00 64.00 -32.00 64.00 -65.00 97.00 -96.00 -33.00 -32.00 97.00 -129.00 64.00 -96.00 0.00 -97.00 -32.00 -64.00 -64.00 -97.00 -32.00 -32.00 -97.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -96.00 -97.00 -161.00 -64.00 -32.00 -32.00 -33.00 -97.00 0.00 -32.00 33.00 32.00 32.00 -32.00 161.00 0.00 32.00 161.00 160.00 0.00 33.00 -32.00 64.00 -32.00 0.00 -65.00 32.00 -96.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 -64.00 -64.00 -96.00 -33.00 -97.00 0.00 -64.00 33.00 -32.00 0.00 -65.00 0.00 -32.00 0.00 -128.00 -33.00 -161.00 33.00 -64.00 0.00 -161.00 64.00 -129.00 0.00 -96.00 0.00 -97.00 -32.00 -128.00 0.00 -65.00 32.00 -128.00 128.00 -97.00 33.00 -96.00 0.00 -32.00 -33.00 -97.00 0.00 -161.00 -64.00 -32.00 0.00 -96.00 32.00 -129.00 32.00 -193.00 0.00 -32.00 0.00 -96.00 65.00 -32.00 32.00 -33.00 96.00 33.00 65.00 0.00 32.00 -33.00 32.00 -64.00 64.00 -64.00 129.00 0.00 96.00 0.00 33.00 64.00 96.00 -32.00 161.00 64.00 161.00 0.00 32.00 0.00 64.00 0.00 32.00 -64.00 129.00 -32.00 32.00 -65.00 0.00 -289.00 -193.00 -32.00 -32.00 32.00 -547.00 0.00 -96.00 -32.00 -257.00 -64.00 -161.00 -32.00 -65.00 -129.00 -32.00 -64.00 -32.00 -129.00 0.00 -32.00 32.00 -129.00 258.00 -128.00 289.00 -65.00 64.00 -193.00 129.00 0.00 32.00 -32.00 0.00 -64.00 -32.00 -161.00 -32.00 -32.00 0.00 -129.00 -193.00 0.00 -64.00 -32.00 -97.00 -161.00 -289.00 0.00 -258.00 -32.00 -64.00 0.00 -32.00 0.00 -129.00 65.00 -257.00 64.00 -64.00 96.00 0.00 65.00 -32.00 0.00 -65.00 0.00 -64.00 -32.00 -32.00 -33.00 0.00 -160.00 -32.00 -97.00 32.00 -96.00 64.00 -97.00 32.00 -386.00 -32.00 -96.00 0.00 -129.00 -128.00 -32.00 -33.00 -64.00 -128.00 -97.00 -32.00 -128.00 -32.00 -32.00 32.00 -97.00 0.00 -128.00 32.00 -97.00 32.00 0.00 32.00 -64.00 0.00 -322.00 0.00 -161.00 -32.00 -32.00 0.00 -160.00 0.00 -33.00 0.00 -192.00 32.00 -97.00 64.00 -96.00 0.00 -97.00 0.00 -64.00 -32.00 -257.00 -96.00 -258.00 32.00 -64.00 -32.00 -64.00 0.00 -32.00 -32.00 -129.00 -129.00 -64.00 -32.00 -33.00 -32.00 -32.00 0.00 -160.00 0.00 -97.00 32.00 -32.00 0.00 -32.00 -32.00 -129.00 -32.00 -96.00 0.00 -129.00 64.00 -193.00 -64.00 -128.00 32.00 -33.00 0.00 -64.00 -32.00 -96.00 0.00 0.00 -65.00 -97.00 -32.00 -193.00 -225.00 -96.00 -32.00 -97.00 -32.00 -64.00 -32.00 -64.00 32.00 -65.00 32.00 -96.00 0.00 -64.00 32.00 -65.00 64.00 -96.00 0.00 -64.00 0.00 -33.00 65.00 -96.00 128.00 -64.00 32.00 -65.00 65.00 -96.00 161.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 -225.00 64.00 -257.00 64.00 -64.00 0.00 0.00 32.00 -97.00 65.00 -128.00 32.00 -33.00 32.00 -96.00 96.00 -64.00 0.00 -65.00 0.00 -64.00 0.00 0.00 65.00 -96.00 64.00 -65.00 64.00 -32.00 0.00 -64.00 0.00 0.00 33.00 -161.00 225.00 -32.00 -65.00 -64.00 -96.00 32.00 -32.00 32.00 -97.00 0.00 -128.00 -64.00 -161.00 96.00 -225.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 -64.00 -96.00 -32.00 -64.00 0.00 -129.00 0.00 -161.00 -65.00 -64.00 0.00 -32.00z"},pr:{name:"PR",path:"M97540.00 151634.00l32.00 -32.00 0.00 -64.00 64.00 -129.00 32.00 -64.00 65.00 -96.00 96.00 -65.00 129.00 -161.00 64.00 -96.00 64.00 -129.00 33.00 -192.00 64.00 -97.00 32.00 -96.00 64.00 -97.00 65.00 0.00 32.00 -64.00 -32.00 -129.00 -33.00 -64.00 -64.00 -64.00 -32.00 -65.00 32.00 -64.00 -32.00 -96.00 0.00 -97.00 96.00 -257.00 0.00 -193.00 65.00 -129.00 32.00 -128.00 64.00 -258.00 97.00 -289.00 32.00 -96.00 64.00 -33.00 32.00 -64.00 65.00 -161.00 32.00 -96.00 64.00 -161.00 32.00 -353.00 0.00 -65.00 -64.00 -225.00 -32.00 -129.00 64.00 -225.00 129.00 -128.00 96.00 -129.00 64.00 -161.00 33.00 -64.00 -65.00 -257.00 -64.00 -97.00 -161.00 -160.00 -32.00 -97.00 0.00 -96.00 0.00 -32.00 0.00 -65.00 -64.00 -160.00 0.00 -65.00 -32.00 -32.00 64.00 -129.00 128.00 -96.00 97.00 -129.00 32.00 -32.00 32.00 0.00 129.00 -32.00 353.00 -257.00 193.00 -97.00 97.00 -96.00 32.00 -64.00 97.00 -290.00 0.00 -128.00 -33.00 -97.00 33.00 -64.00 -33.00 -32.00 33.00 -97.00 32.00 -193.00 96.00 -160.00 0.00 -33.00 32.00 -192.00 32.00 -97.00 33.00 -64.00 32.00 -129.00 32.00 -193.00 64.00 -193.00 0.00 -193.00 129.00 -225.00 0.00 -32.00 64.00 -32.00 32.00 -32.00 129.00 32.00 257.00 -129.00 289.00 -193.00 226.00 -64.00 32.00 -32.00 161.00 -225.00 64.00 -129.00 0.00 -32.00 64.00 -161.00 64.00 -225.00 129.00 -193.00 0.00 -64.00 129.00 -129.00 0.00 -546.00 0.00 -64.00 96.00 -129.00 32.00 -129.00 97.00 -64.00 64.00 -32.00 64.00 -64.00 0.00 -33.00 65.00 -96.00 64.00 -32.00 64.00 -32.00 161.00 -65.00 161.00 -96.00 96.00 -32.00 97.00 -97.00 0.00 -32.00 32.00 0.00 128.00 -32.00 65.00 -97.00 32.00 -32.00 64.00 -32.00 65.00 -32.00 96.00 -32.00 289.00 -97.00 33.00 0.00 0.00 -32.00 96.00 0.00 96.00 0.00 33.00 -32.00 64.00 -64.00 225.00 -290.00 32.00 0.00 97.00 -160.00 32.00 96.00 32.00 97.00 64.00 -97.00 129.00 -32.00 64.00 -64.00 64.00 -65.00 65.00 -32.00 0.00 -32.00 64.00 -32.00 64.00 -32.00 33.00 -32.00 225.00 -33.00 96.00 33.00 225.00 160.00 64.00 33.00 161.00 -65.00 97.00 0.00 32.00 0.00 32.00 32.00 129.00 33.00 128.00 64.00 97.00 0.00 193.00 -64.00 289.00 -193.00 64.00 -33.00 32.00 0.00 65.00 97.00 128.00 129.00 32.00 0.00 65.00 32.00 96.00 64.00 32.00 0.00 161.00 -96.00 64.00 0.00 0.00 -33.00 65.00 0.00 32.00 33.00 32.00 0.00 64.00 32.00 161.00 64.00 225.00 0.00 97.00 32.00 64.00 -64.00 64.00 -32.00 129.00 -32.00 32.00 32.00 64.00 96.00 0.00 129.00 0.00 32.00 32.00 0.00 129.00 -64.00 64.00 -33.00 129.00 -32.00 -32.00 -193.00 0.00 -32.00 32.00 -128.00 0.00 -33.00 32.00 -96.00 65.00 -96.00 32.00 -33.00 64.00 -32.00 32.00 0.00 64.00 32.00 161.00 97.00 129.00 0.00 32.00 0.00 129.00 32.00 160.00 96.00 97.00 0.00 193.00 161.00 32.00 32.00 32.00 33.00 64.00 64.00 97.00 32.00 32.00 0.00 354.00 -96.00 64.00 32.00 32.00 0.00 32.00 32.00 65.00 0.00 0.00 32.00 32.00 129.00 32.00 64.00 96.00 0.00 97.00 -64.00 64.00 0.00 161.00 0.00 64.00 32.00 129.00 96.00 96.00 32.00 65.00 33.00 32.00 -33.00 128.00 -32.00 32.00 32.00 65.00 0.00 128.00 -64.00 33.00 0.00 96.00 -129.00 96.00 0.00 129.00 65.00 64.00 0.00 65.00 -32.00 128.00 32.00 65.00 0.00 128.00 32.00 32.00 0.00 97.00 -32.00 64.00 32.00 64.00 64.00 33.00 0.00 32.00 129.00 96.00 64.00 32.00 0.00 97.00 32.00 64.00 32.00 97.00 65.00 193.00 64.00 257.00 0.00 257.00 129.00 64.00 0.00 65.00 -33.00 96.00 0.00 64.00 97.00 33.00 0.00 64.00 -32.00 32.00 0.00 129.00 0.00 32.00 32.00 193.00 129.00 64.00 128.00 32.00 32.00 32.00 97.00 97.00 32.00 0.00 32.00 0.00 32.00 -32.00 193.00 32.00 32.00 96.00 0.00 97.00 0.00 32.00 32.00 32.00 33.00 32.00 0.00 32.00 0.00 97.00 -33.00 128.00 -225.00 32.00 -32.00 33.00 -32.00 32.00 0.00 64.00 0.00 32.00 64.00 97.00 33.00 64.00 32.00 64.00 -32.00 65.00 -65.00 128.00 32.00 65.00 33.00 32.00 32.00 32.00 64.00 32.00 32.00 64.00 32.00 65.00 -64.00 32.00 0.00 96.00 64.00 64.00 -32.00 97.00 32.00 32.00 -64.00 32.00 0.00 0.00 -96.00 32.00 -33.00 65.00 0.00 64.00 -32.00 97.00 65.00 0.00 32.00 64.00 64.00 32.00 64.00 96.00 0.00 65.00 0.00 32.00 -64.00 64.00 0.00 64.00 -32.00 129.00 64.00 32.00 32.00 0.00 32.00 32.00 0.00 65.00 -32.00 64.00 32.00 97.00 0.00 96.00 -32.00 64.00 -64.00 97.00 32.00 64.00 0.00 32.00 0.00 64.00 -96.00 65.00 0.00 64.00 32.00 97.00 -97.00 0.00 -32.00 96.00 32.00 64.00 0.00 33.00 97.00 32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 96.00 64.00 0.00 33.00 33.00 64.00 -33.00 96.00 -32.00 32.00 0.00 33.00 97.00 96.00 96.00 0.00 64.00 32.00 97.00 65.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 64.00 0.00 32.00 0.00 97.00 64.00 0.00 64.00 64.00 32.00 -32.00 33.00 32.00 32.00 32.00 64.00 0.00 97.00 -32.00 32.00 32.00 32.00 32.00 32.00 0.00 0.00 33.00 32.00 32.00 32.00 0.00 32.00 32.00 65.00 0.00 64.00 32.00 64.00 -32.00 65.00 0.00 32.00 32.00 32.00 32.00 -64.00 97.00 32.00 32.00 64.00 32.00 32.00 64.00 32.00 -32.00 0.00 32.00 33.00 32.00 96.00 0.00 -32.00 33.00 32.00 32.00 96.00 160.00 0.00 65.00 0.00 32.00 33.00 32.00 32.00 0.00 -32.00 64.00 32.00 33.00 64.00 128.00 0.00 97.00 32.00 64.00 0.00 64.00 -32.00 65.00 -32.00 -33.00 0.00 65.00 0.00 32.00 96.00 0.00 97.00 64.00 0.00 32.00 32.00 32.00 -32.00 33.00 -32.00 -33.00 -97.00 33.00 0.00 32.00 32.00 0.00 33.00 0.00 32.00 0.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 0.00 64.00 64.00 0.00 -32.00 33.00 32.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 0.00 32.00 -65.00 -32.00 0.00 64.00 -32.00 32.00 32.00 64.00 -32.00 0.00 -32.00 33.00 32.00 32.00 97.00 64.00 -32.00 32.00 32.00 64.00 -32.00 65.00 32.00 32.00 0.00 32.00 -65.00 64.00 -32.00 65.00 32.00 32.00 0.00 32.00 0.00 32.00 33.00 0.00 0.00 32.00 -33.00 32.00 65.00 33.00 0.00 32.00 64.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 33.00 33.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 -32.00 64.00 0.00 32.00 32.00 65.00 -32.00 0.00 -65.00 -32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 65.00 32.00 -33.00 32.00 0.00 33.00 33.00 64.00 0.00 64.00 0.00 32.00 0.00 33.00 -65.00 32.00 -64.00 32.00 -32.00 0.00 0.00 32.00 32.00 32.00 -64.00 -32.00 -32.00 0.00 64.00 32.00 -32.00 32.00 -32.00 0.00 32.00 33.00 0.00 64.00 32.00 32.00 32.00 64.00 64.00 -64.00 0.00 96.00 32.00 33.00 33.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 64.00 32.00 0.00 -32.00 65.00 -32.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 -32.00 0.00 -65.00 0.00 33.00 65.00 32.00 -33.00 32.00 33.00 0.00 32.00 32.00 0.00 0.00 32.00 -64.00 0.00 0.00 32.00 32.00 0.00 64.00 32.00 0.00 32.00 -32.00 33.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 0.00 33.00 0.00 0.00 33.00 32.00 0.00 0.00 64.00 32.00 32.00 32.00 32.00 64.00 32.00 0.00 32.00 33.00 0.00 -33.00 33.00 33.00 32.00 0.00 32.00 32.00 0.00 96.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 96.00 32.00 0.00 33.00 33.00 -33.00 32.00 33.00 32.00 -33.00 32.00 33.00 0.00 32.00 97.00 64.00 32.00 0.00 0.00 32.00 32.00 32.00 -64.00 33.00 0.00 64.00 0.00 96.00 0.00 65.00 -65.00 32.00 32.00 32.00 129.00 96.00 0.00 33.00 64.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 33.00 32.00 -33.00 64.00 33.00 32.00 32.00 33.00 0.00 32.00 0.00 32.00 32.00 32.00 32.00 -32.00 32.00 0.00 65.00 64.00 32.00 0.00 0.00 65.00 96.00 0.00 32.00 32.00 65.00 0.00 32.00 32.00 -97.00 96.00 -32.00 0.00 -64.00 97.00 -64.00 96.00 0.00 32.00 32.00 33.00 32.00 -65.00 32.00 0.00 0.00 32.00 -32.00 65.00 -64.00 64.00 32.00 32.00 -32.00 64.00 32.00 0.00 0.00 33.00 0.00 32.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 0.00 64.00 -96.00 32.00 -32.00 0.00 32.00 65.00 0.00 64.00 32.00 32.00 -32.00 32.00 -32.00 65.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 64.00 0.00 33.00 -32.00 0.00 64.00 32.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 32.00 -32.00 97.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 64.00 32.00 0.00 0.00 32.00 33.00 0.00 96.00 97.00 64.00 0.00 33.00 0.00 64.00 32.00 32.00 0.00 129.00 0.00 0.00 -64.00 64.00 0.00 0.00 -32.00 32.00 -33.00 64.00 0.00 33.00 0.00 32.00 0.00 128.00 0.00 32.00 33.00 65.00 32.00 32.00 -65.00 32.00 0.00 0.00 33.00 64.00 0.00 0.00 -33.00 32.00 0.00 33.00 65.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -65.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 -32.00 -33.00 32.00 -32.00 -32.00 32.00 -32.00 33.00 0.00 64.00 32.00 64.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 96.00 64.00 -32.00 33.00 0.00 0.00 64.00 64.00 0.00 0.00 32.00 64.00 0.00 32.00 65.00 65.00 -65.00 64.00 0.00 32.00 0.00 32.00 33.00 32.00 0.00 0.00 -33.00 32.00 0.00 161.00 -32.00 65.00 32.00 32.00 0.00 -65.00 -64.00 33.00 -32.00 64.00 64.00 64.00 -64.00 32.00 32.00 32.00 64.00 65.00 0.00 64.00 33.00 32.00 96.00 65.00 -32.00 32.00 -64.00 32.00 0.00 0.00 64.00 32.00 0.00 64.00 -32.00 129.00 -32.00 32.00 32.00 32.00 32.00 0.00 -64.00 0.00 -33.00 0.00 -32.00 65.00 32.00 32.00 33.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 64.00 32.00 32.00 -64.00 64.00 -32.00 0.00 -32.00 65.00 0.00 64.00 -65.00 32.00 32.00 32.00 -32.00 32.00 32.00 33.00 33.00 32.00 -33.00 32.00 65.00 32.00 32.00 0.00 32.00 32.00 64.00 64.00 0.00 0.00 33.00 33.00 0.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 64.00 0.00 0.00 -32.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 65.00 -32.00 0.00 0.00 64.00 -64.00 32.00 -32.00 32.00 -97.00 65.00 0.00 64.00 0.00 32.00 -32.00 32.00 -32.00 64.00 32.00 65.00 -32.00 32.00 96.00 0.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 33.00 32.00 0.00 -32.00 64.00 0.00 -32.00 -32.00 0.00 0.00 32.00 0.00 64.00 0.00 32.00 0.00 32.00 32.00 33.00 -32.00 32.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 65.00 -64.00 32.00 0.00 32.00 -33.00 0.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 33.00 0.00 0.00 32.00 32.00 32.00 0.00 64.00 64.00 0.00 0.00 32.00 32.00 33.00 0.00 64.00 32.00 32.00 32.00 32.00 65.00 64.00 32.00 0.00 32.00 -64.00 32.00 -32.00 64.00 -96.00 33.00 -33.00 64.00 0.00 0.00 -64.00 32.00 -129.00 193.00 -128.00 64.00 0.00 33.00 -32.00 96.00 32.00 64.00 32.00 0.00 32.00 32.00 0.00 97.00 97.00 0.00 32.00 0.00 32.00 64.00 0.00 0.00 32.00 32.00 -32.00 32.00 0.00 0.00 96.00 -32.00 0.00 0.00 65.00 65.00 -65.00 32.00 -64.00 64.00 -64.00 0.00 -32.00 32.00 0.00 32.00 64.00 33.00 0.00 0.00 -64.00 0.00 -33.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 64.00 33.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 0.00 33.00 64.00 32.00 32.00 0.00 0.00 32.00 -32.00 32.00 32.00 97.00 -32.00 64.00 32.00 32.00 0.00 32.00 64.00 97.00 0.00 32.00 65.00 64.00 0.00 32.00 64.00 32.00 64.00 33.00 -32.00 32.00 -32.00 0.00 0.00 64.00 -32.00 64.00 -97.00 32.00 33.00 65.00 64.00 32.00 64.00 0.00 32.00 64.00 32.00 32.00 161.00 129.00 65.00 -32.00 64.00 -32.00 32.00 32.00 32.00 -32.00 65.00 0.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 64.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 -32.00 32.00 32.00 33.00 -289.00 257.00 -64.00 64.00 0.00 64.00 32.00 0.00 -32.00 32.00 -161.00 129.00 -97.00 97.00 -128.00 193.00 -97.00 128.00 -32.00 161.00 -32.00 32.00 -64.00 0.00 -129.00 32.00 -129.00 64.00 -128.00 33.00 161.00 96.00 -65.00 161.00 -32.00 0.00 0.00 64.00 0.00 32.00 -32.00 0.00 -32.00 33.00 -32.00 64.00 -193.00 0.00 -97.00 32.00 -160.00 129.00 -129.00 160.00 -161.00 290.00 -257.00 418.00 -32.00 193.00 0.00 64.00 -32.00 -32.00 -33.00 32.00 -64.00 32.00 0.00 32.00 0.00 32.00 -32.00 65.00 32.00 32.00 -64.00 129.00 -64.00 225.00 -33.00 32.00 33.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 -32.00 -33.00 -96.00 65.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -161.00 0.00 -515.00 0.00 -675.00 0.00 64.00 32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 33.00 -32.00 0.00 0.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 -65.00 -33.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 -64.00 -64.00 0.00 -65.00 -33.00 32.00 -64.00 0.00 0.00 33.00 -32.00 0.00 -32.00 -65.00 -32.00 32.00 -65.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -32.00 65.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 -33.00 -33.00 0.00 -32.00 33.00 -64.00 0.00 0.00 32.00 -64.00 0.00 -33.00 32.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 32.00 -64.00 33.00 0.00 32.00 0.00 32.00 0.00 32.00 -65.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 32.00 32.00 33.00 -32.00 0.00 32.00 0.00 0.00 32.00 -65.00 0.00 33.00 32.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -96.00 64.00 -32.00 32.00 -33.00 0.00 0.00 33.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -64.00 0.00 -33.00 0.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 -32.00 64.00 -64.00 -32.00 0.00 64.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 0.00 -64.00 -32.00 0.00 -64.00 0.00 -32.00 64.00 -65.00 65.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 64.00 0.00 -32.00 0.00 32.00 -32.00 33.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 -65.00 -32.00 0.00 0.00 33.00 32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 0.00 -32.00 64.00 -65.00 -32.00 -64.00 -97.00 0.00 65.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 -65.00 -33.00 0.00 0.00 -32.00 0.00 32.00 -32.00 0.00 -64.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 0.00 0.00 64.00 -64.00 32.00 0.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 64.00 -65.00 -64.00 0.00 -32.00 -64.00 -65.00 -32.00 -64.00 64.00 -32.00 0.00 -32.00 -64.00 64.00 -64.00 -64.00 0.00 -65.00 0.00 0.00 -97.00 -64.00 -32.00 -32.00 -64.00 -32.00 0.00 0.00 32.00 32.00 0.00 0.00 64.00 -32.00 0.00 -32.00 -96.00 -33.00 32.00 0.00 32.00 -64.00 -32.00 -32.00 -97.00 -32.00 33.00 -32.00 0.00 -32.00 -65.00 0.00 -64.00 -33.00 32.00 -32.00 0.00 65.00 -32.00 0.00 -64.00 -33.00 -32.00 0.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -33.00 32.00 -32.00 -129.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -32.00 -97.00 32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -64.00 32.00 -32.00 32.00 64.00 32.00 -129.00 129.00 32.00 -65.00 0.00 -96.00 -32.00 -32.00 -96.00 -32.00 0.00 32.00 -64.00 0.00 0.00 32.00 32.00 64.00 -32.00 32.00 -97.00 -64.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 33.00 0.00 -33.00 -32.00 -96.00 -32.00 96.00 -97.00 65.00 -32.00 -32.00 -32.00 64.00 -64.00 -97.00 -65.00 65.00 0.00 -32.00 32.00 -97.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 -64.00 0.00 -65.00 -96.00 -32.00 0.00 32.00 0.00 65.00 -64.00 -33.00 -65.00 33.00 -96.00 32.00 -97.00 64.00 0.00 64.00 -64.00 0.00 32.00 65.00 0.00 32.00 -32.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 0.00 32.00 64.00 0.00 0.00 33.00 -32.00 -33.00 -32.00 33.00 -32.00 -33.00 -64.00 -32.00 -32.00 -32.00 0.00 -32.00 -33.00 32.00 0.00 -32.00 33.00 -64.00 -33.00 -65.00 -160.00 -96.00 0.00 -32.00 -33.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 -64.00 -33.00 -33.00 33.00 -32.00 -65.00 -32.00 0.00 32.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 0.00 64.00 -32.00 -32.00 32.00 0.00 -64.00 0.00 -33.00 -32.00 -32.00 32.00 -32.00 -32.00 -64.00 32.00 -129.00 64.00 0.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -97.00 -32.00 0.00 -97.00 97.00 0.00 96.00 32.00 33.00 33.00 0.00 64.00 -33.00 32.00 0.00 32.00 0.00 0.00 65.00 -32.00 32.00 -32.00 0.00 -97.00 32.00 -64.00 0.00 -128.00 -32.00 -65.00 64.00 -32.00 64.00 -64.00 65.00 64.00 128.00 -32.00 0.00 -32.00 33.00 -65.00 32.00 -32.00 32.00 -32.00 64.00 -64.00 97.00 -32.00 32.00 -129.00 64.00 97.00 193.00 -33.00 32.00 -64.00 0.00 -64.00 0.00 0.00 -96.00 -32.00 -32.00 -193.00 32.00 -32.00 32.00 -33.00 32.00 -64.00 32.00 -32.00 97.00 -32.00 32.00 -32.00 -32.00 -97.00 -129.00 -32.00 0.00 -32.00 96.00 -32.00 97.00 -32.00 32.00 -33.00 0.00 -64.00 0.00 0.00 -161.00 -96.00 -96.00 -32.00 0.00 -33.00 32.00 65.00 129.00 -32.00 64.00 -33.00 0.00 -32.00 -64.00 -96.00 0.00 0.00 -97.00 -97.00 -64.00 -32.00 -32.00 -257.00 96.00 -32.00 -32.00 -97.00 -64.00 -32.00 96.00 -32.00 0.00 0.00 64.00 -32.00 33.00 -32.00 32.00 -65.00 32.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -65.00 32.00 0.00 32.00 -32.00 0.00 -64.00 32.00 -64.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 65.00 -32.00 32.00 -96.00 32.00 0.00 32.00 -33.00 0.00 -32.00 64.00 32.00 0.00 0.00 33.00 -64.00 64.00 32.00 32.00 32.00 32.00 -96.00 32.00 -32.00 32.00 0.00 65.00 -64.00 -32.00 0.00 32.00 32.00 32.00 -65.00 32.00 0.00 32.00 33.00 65.00 96.00 32.00 -32.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 64.00 32.00 -32.00 32.00 32.00 32.00 -64.00 33.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 32.00 32.00 65.00 32.00 0.00 33.00 64.00 32.00 0.00 0.00 32.00 64.00 32.00 -32.00 32.00 0.00 32.00 64.00 33.00 -32.00 32.00 0.00 32.00 0.00 64.00 -64.00 32.00 32.00 65.00 -32.00 32.00 0.00 32.00 -97.00 0.00 -32.00 32.00 -64.00 0.00 0.00 32.00 -32.00 0.00 0.00 65.00 -97.00 0.00 -32.00 -33.00 -64.00 33.00 0.00 -33.00 -32.00 0.00 -97.00 33.00 -64.00 0.00 -64.00 32.00 -65.00 0.00 -64.00 64.00 64.00 64.00 0.00 65.00 -32.00 32.00 -64.00 32.00 32.00 -64.00 -129.00 -65.00 -32.00 -96.00 -64.00 -64.00 0.00 -65.00 -32.00 -64.00 -32.00 -32.00 -33.00 0.00 -64.00 0.00 32.00 -64.00 -32.00 -33.00 -32.00 -64.00 -64.00 -32.00 -97.00 32.00 -257.00 0.00 -64.00 0.00 -97.00 0.00 -64.00 0.00 -64.00 -64.00 -97.00 -65.00 -129.00 97.00 -64.00 0.00 -128.00 -32.00 -258.00 64.00 -64.00 0.00 -96.00 -32.00 -97.00 64.00 -64.00 -32.00 -65.00 64.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -96.00 -32.00 -129.00 0.00 -96.00 -64.00 -32.00 32.00 -65.00 -32.00 -64.00 0.00 0.00 -33.00 -129.00 33.00 -32.00 -65.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 -65.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -32.00 -65.00 -33.00 0.00 -32.00 -32.00 0.00 -96.00 -64.00 -33.00 -64.00 0.00 -32.00 -32.00 -65.00 0.00 -64.00 0.00 -129.00 -128.00 -64.00 64.00 -97.00 32.00 -96.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 0.00 -32.00 -96.00 -96.00 -97.00 0.00 -64.00 32.00 -32.00 -65.00 -32.00 65.00 -65.00 -65.00 -64.00 33.00 -32.00 0.00 -32.00 -33.00 -33.00 -32.00 -32.00 32.00 -64.00 33.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 -97.00 -65.00 0.00 -128.00 -96.00 -97.00 32.00 -64.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -64.00 64.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 -64.00 -33.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 -97.00 -96.00 -96.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 -65.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 33.00 -32.00 0.00 -64.00 -33.00 -64.00 33.00 -33.00 0.00 -32.00 -33.00 -32.00 0.00 -64.00 0.00 -64.00 0.00 -33.00 0.00 -128.00 65.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 -32.00 -64.00 32.00 -33.00 0.00 -64.00 32.00 -193.00 -97.00 -193.00 129.00 -96.00 32.00 -129.00 64.00 -64.00 0.00 -32.00 -32.00 -32.00 -32.00 -33.00 0.00 -64.00 -32.00 -32.00 -32.00 -32.00 -32.00 -32.00 -65.00 -32.00 0.00 -33.00 33.00 -32.00 0.00 -32.00 -33.00 -64.00 0.00 -65.00 -64.00 -32.00 0.00 0.00 -32.00 -128.00 -64.00 -65.00 -65.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -64.00 -97.00 -32.00 0.00 0.00 -64.00 -129.00 64.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 -64.00 -32.00 32.00 -193.00 129.00 -32.00 32.00 -64.00 0.00 -97.00 64.00 -32.00 0.00 -32.00 0.00 -96.00 32.00 -129.00 -32.00 -128.00 0.00 0.00 -32.00 -97.00 -64.00 -32.00 0.00 -32.00 -97.00 -97.00 32.00 -64.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 64.00 -97.00 -64.00 -32.00 0.00 -64.00 -32.00 0.00 -64.00 -97.00 -32.00 -32.00 -97.00 -64.00 -32.00 -64.00 -32.00 -65.00 -32.00 0.00 -97.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 32.00 -96.00 33.00 0.00 0.00 -32.00 0.00 -32.00 -33.00 -65.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 -65.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -64.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -33.00 0.00 0.00 -32.00 0.00 -32.00 -96.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 -32.00 -128.00 32.00 0.00 32.00 0.00 0.00 -64.00 32.00 64.00 32.00 0.00 -32.00 -64.00 32.00 -33.00 -32.00 0.00 -64.00 33.00 32.00 -65.00 32.00 0.00 32.00 -32.00 -32.00 0.00 -64.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 64.00 0.00 0.00 -32.00 32.00 0.00 32.00 -33.00 -64.00 0.00 32.00 -64.00 -64.00 0.00 32.00 0.00 0.00 -32.00 -32.00 -64.00 -32.00 32.00 0.00 -32.00 32.00 -65.00 32.00 0.00 0.00 -32.00 32.00 -32.00 64.00 32.00 0.00 -32.00 -64.00 0.00 32.00 -64.00 0.00 -32.00 -96.00 0.00 64.00 -33.00 0.00 -32.00 -64.00 -32.00 -64.00 -32.00 32.00 -32.00 64.00 0.00 -32.00 -32.00 64.00 0.00 -96.00 -65.00 -65.00 33.00 33.00 -97.00 0.00 -32.00 -65.00 0.00 32.00 -32.00 -64.00 -32.00 64.00 0.00 -32.00 -65.00 65.00 32.00 0.00 33.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 -64.00 -32.00 0.00 -32.00 -33.00 -65.00 -64.00 -32.00 -64.00 32.00 32.00 -64.00 32.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 -97.00 64.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 -33.00 -64.00 33.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 0.00 33.00 -33.00 0.00 33.00 64.00 -33.00 64.00 -32.00 -32.00 0.00 -64.00 -32.00 -65.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 -97.00 -64.00 -32.00 -32.00 -32.00 -65.00 -64.00 -32.00 -32.00 32.00 -65.00 65.00 -32.00 32.00 -64.00 -64.00 -32.00 -65.00 -64.00 0.00 -33.00 97.00 0.00 160.00 -32.00 0.00 0.00 33.00 -64.00 -97.00 -64.00 -161.00 0.00 -64.00 128.00 -161.00 0.00 -96.00 -32.00 -32.00 -32.00 0.00 -161.00 128.00 -96.00 97.00 -33.00 0.00 -96.00 -32.00 -64.00 32.00 -32.00 64.00 32.00 0.00 128.00 64.00 0.00 33.00 32.00 32.00 -32.00 0.00 -96.00 0.00 -129.00 -97.00 -32.00 0.00 -32.00 32.00 0.00 129.00 -64.00 0.00 -65.00 -64.00 -64.00 -129.00 -64.00 0.00 -161.00 97.00 -96.00 160.00 -33.00 0.00 -96.00 -64.00 -64.00 32.00 0.00 32.00 0.00 65.00 -33.00 64.00 -160.00 128.00 32.00 129.00 -32.00 32.00 -32.00 0.00 -65.00 -161.00 -96.00 -128.00 -64.00 -32.00 -97.00 -65.00 -96.00 65.00 -33.00 0.00 -32.00 -65.00 32.00 -64.00 -64.00 -32.00 -64.00 -32.00 -32.00 0.00 -129.00 32.00 0.00 -257.00 -32.00 -97.00 0.00 -193.00 -97.00 -64.00 0.00 -64.00 0.00 -32.00 65.00 -33.00z"},rs:{name:"RS",path:"M84646.00 173756.00l32.00 -193.00 -32.00 -193.00 0.00 -64.00 161.00 -258.00 225.00 -192.00 97.00 -33.00 257.00 0.00 193.00 -64.00 32.00 -32.00 128.00 -96.00 226.00 -193.00 289.00 -386.00 96.00 -129.00 161.00 -128.00 129.00 -193.00 225.00 -129.00 128.00 -64.00 65.00 -65.00 96.00 -64.00 97.00 -129.00 0.00 -96.00 0.00 -64.00 32.00 -161.00 64.00 -32.00 193.00 0.00 64.00 -32.00 225.00 -418.00 33.00 -97.00 -33.00 -128.00 97.00 -193.00 129.00 -161.00 64.00 -193.00 96.00 -32.00 161.00 0.00 129.00 -97.00 64.00 -32.00 322.00 -32.00 64.00 0.00 32.00 -193.00 64.00 -96.00 -96.00 -97.00 32.00 -128.00 64.00 -65.00 65.00 -32.00 225.00 -64.00 64.00 -65.00 96.00 -128.00 33.00 -64.00 0.00 -129.00 -33.00 -225.00 33.00 -97.00 64.00 -32.00 96.00 -64.00 354.00 0.00 129.00 -161.00 64.00 -128.00 96.00 -129.00 386.00 -322.00 129.00 -64.00 64.00 -64.00 32.00 -64.00 -64.00 -65.00 -64.00 -96.00 0.00 -65.00 0.00 -64.00 64.00 -96.00 129.00 -32.00 160.00 -33.00 161.00 -32.00 129.00 -32.00 32.00 -32.00 0.00 -32.00 -97.00 -225.00 0.00 -65.00 0.00 -32.00 129.00 -193.00 129.00 -32.00 128.00 64.00 290.00 0.00 96.00 33.00 32.00 32.00 32.00 96.00 33.00 65.00 32.00 64.00 64.00 0.00 32.00 -64.00 0.00 -97.00 97.00 -257.00 0.00 -64.00 -161.00 -97.00 -129.00 -96.00 -193.00 -65.00 -32.00 -96.00 32.00 -64.00 193.00 -65.00 161.00 -32.00 193.00 -161.00 32.00 -32.00 64.00 -32.00 33.00 0.00 32.00 -32.00 -32.00 -64.00 64.00 -33.00 -32.00 -64.00 32.00 -32.00 32.00 -64.00 64.00 0.00 65.00 32.00 0.00 32.00 -33.00 64.00 0.00 32.00 129.00 65.00 32.00 0.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 65.00 -64.00 96.00 -32.00 65.00 -129.00 32.00 -64.00 64.00 0.00 64.00 96.00 65.00 0.00 32.00 0.00 32.00 -64.00 128.00 -129.00 193.00 -96.00 33.00 -32.00 0.00 -65.00 -65.00 -96.00 -32.00 0.00 0.00 -64.00 64.00 -65.00 129.00 0.00 32.00 -32.00 32.00 -128.00 32.00 -65.00 33.00 0.00 64.00 0.00 129.00 32.00 64.00 0.00 32.00 -64.00 96.00 -161.00 193.00 -160.00 65.00 0.00 64.00 32.00 64.00 96.00 65.00 64.00 32.00 33.00 32.00 -33.00 32.00 -32.00 -32.00 -128.00 32.00 -32.00 64.00 -33.00 129.00 -32.00 129.00 65.00 96.00 32.00 32.00 -65.00 0.00 -64.00 -32.00 -64.00 -225.00 -97.00 -32.00 -64.00 32.00 -32.00 32.00 -32.00 97.00 -32.00 160.00 128.00 33.00 32.00 64.00 -32.00 32.00 -96.00 64.00 0.00 97.00 32.00 32.00 0.00 64.00 -32.00 32.00 -65.00 0.00 -32.00 129.00 -128.00 0.00 -129.00 0.00 -193.00 0.00 -96.00 32.00 -65.00 64.00 0.00 129.00 0.00 32.00 -32.00 32.00 -96.00 33.00 -161.00 96.00 -193.00 32.00 0.00 64.00 32.00 33.00 193.00 64.00 32.00 32.00 0.00 32.00 0.00 32.00 -32.00 65.00 -64.00 96.00 0.00 193.00 64.00 32.00 -32.00 0.00 -64.00 -32.00 -129.00 0.00 -64.00 32.00 -65.00 32.00 0.00 33.00 33.00 64.00 160.00 64.00 0.00 32.00 0.00 32.00 -64.00 33.00 -96.00 96.00 -161.00 0.00 -64.00 32.00 -65.00 32.00 0.00 32.00 32.00 97.00 97.00 64.00 128.00 32.00 0.00 65.00 -32.00 32.00 -64.00 32.00 -32.00 129.00 0.00 96.00 0.00 64.00 -32.00 0.00 -65.00 -32.00 -32.00 -96.00 -64.00 0.00 -64.00 32.00 0.00 129.00 0.00 32.00 -33.00 64.00 -64.00 32.00 0.00 97.00 64.00 0.00 33.00 96.00 128.00 32.00 32.00 65.00 33.00 64.00 -33.00 0.00 -64.00 -32.00 -96.00 0.00 -65.00 0.00 -32.00 32.00 0.00 64.00 32.00 64.00 65.00 65.00 96.00 32.00 0.00 96.00 -32.00 0.00 -129.00 33.00 -64.00 32.00 -32.00 96.00 0.00 64.00 -32.00 33.00 -65.00 0.00 -64.00 0.00 -64.00 32.00 -97.00 64.00 -96.00 0.00 -64.00 32.00 -129.00 64.00 -64.00 33.00 0.00 32.00 32.00 0.00 32.00 0.00 129.00 64.00 32.00 64.00 0.00 97.00 0.00 32.00 0.00 129.00 0.00 32.00 -65.00 64.00 -128.00 129.00 -32.00 64.00 -97.00 0.00 -96.00 32.00 -65.00 97.00 -32.00 64.00 0.00 64.00 0.00 0.00 -64.00 0.00 -97.00 32.00 -32.00 65.00 0.00 64.00 32.00 32.00 65.00 65.00 0.00 64.00 -97.00 32.00 -96.00 32.00 -32.00 97.00 0.00 64.00 160.00 32.00 33.00 32.00 0.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 -32.00 128.00 -97.00 65.00 32.00 64.00 161.00 64.00 0.00 65.00 -32.00 32.00 0.00 32.00 -32.00 64.00 -32.00 32.00 -33.00 65.00 0.00 32.00 0.00 64.00 33.00 0.00 32.00 32.00 32.00 0.00 64.00 0.00 97.00 32.00 32.00 33.00 0.00 64.00 -161.00 32.00 0.00 64.00 0.00 33.00 0.00 128.00 -64.00 65.00 0.00 32.00 0.00 96.00 96.00 64.00 32.00 33.00 0.00 64.00 0.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 -64.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 0.00 32.00 0.00 64.00 0.00 32.00 64.00 65.00 32.00 225.00 -64.00 32.00 -64.00 32.00 -97.00 64.00 -64.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 64.00 32.00 32.00 32.00 0.00 32.00 0.00 33.00 0.00 96.00 0.00 0.00 33.00 32.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 64.00 -96.00 161.00 0.00 32.00 0.00 32.00 0.00 33.00 32.00 0.00 32.00 0.00 64.00 -97.00 193.00 -96.00 65.00 -32.00 32.00 0.00 160.00 96.00 65.00 0.00 32.00 -32.00 32.00 -161.00 0.00 -32.00 32.00 0.00 32.00 -32.00 33.00 32.00 64.00 129.00 0.00 32.00 32.00 0.00 96.00 -32.00 193.00 -65.00 0.00 -64.00 0.00 -32.00 -32.00 -97.00 0.00 -32.00 0.00 -32.00 97.00 -96.00 32.00 0.00 96.00 0.00 32.00 0.00 33.00 32.00 -33.00 64.00 -96.00 129.00 0.00 96.00 32.00 32.00 32.00 0.00 129.00 -96.00 32.00 0.00 32.00 64.00 32.00 0.00 0.00 64.00 -64.00 97.00 -32.00 32.00 0.00 96.00 32.00 0.00 32.00 33.00 65.00 32.00 32.00 -32.00 0.00 -161.00 32.00 -97.00 32.00 0.00 96.00 33.00 0.00 128.00 33.00 32.00 32.00 0.00 96.00 -32.00 65.00 -32.00 0.00 -32.00 128.00 -64.00 32.00 0.00 32.00 32.00 0.00 128.00 0.00 32.00 33.00 0.00 32.00 0.00 64.00 -32.00 32.00 0.00 64.00 0.00 33.00 0.00 32.00 32.00 64.00 0.00 32.00 0.00 0.00 33.00 32.00 0.00 0.00 32.00 -32.00 96.00 0.00 32.00 65.00 33.00 0.00 32.00 32.00 -32.00 64.00 -65.00 32.00 -32.00 32.00 0.00 33.00 64.00 32.00 97.00 0.00 32.00 32.00 32.00 32.00 0.00 64.00 -64.00 0.00 -97.00 32.00 -32.00 33.00 0.00 32.00 0.00 64.00 97.00 64.00 32.00 32.00 0.00 33.00 -32.00 96.00 -32.00 32.00 -33.00 97.00 0.00 32.00 0.00 64.00 -32.00 64.00 97.00 161.00 32.00 97.00 0.00 0.00 -32.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 160.00 -96.00 33.00 0.00 32.00 0.00 0.00 32.00 -32.00 96.00 0.00 32.00 0.00 65.00 96.00 96.00 32.00 32.00 32.00 33.00 32.00 0.00 33.00 -33.00 -33.00 -128.00 0.00 -32.00 33.00 0.00 32.00 0.00 0.00 32.00 32.00 0.00 -32.00 128.00 32.00 97.00 64.00 -32.00 65.00 -65.00 32.00 0.00 64.00 65.00 64.00 32.00 65.00 64.00 32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -64.00 -32.00 -65.00 0.00 -64.00 0.00 -32.00 32.00 0.00 96.00 0.00 65.00 0.00 32.00 -32.00 96.00 64.00 -32.00 32.00 -96.00 32.00 -65.00 65.00 0.00 32.00 129.00 32.00 32.00 0.00 64.00 96.00 32.00 0.00 0.00 32.00 33.00 0.00 32.00 -32.00 32.00 -64.00 32.00 -96.00 64.00 -65.00 33.00 -32.00 32.00 0.00 32.00 32.00 -32.00 161.00 32.00 0.00 32.00 0.00 64.00 -32.00 65.00 0.00 32.00 -32.00 64.00 32.00 0.00 32.00 0.00 64.00 0.00 65.00 32.00 32.00 65.00 0.00 64.00 -32.00 96.00 32.00 32.00 0.00 33.00 0.00 96.00 -65.00 32.00 0.00 0.00 65.00 -64.00 32.00 32.00 32.00 0.00 32.00 64.00 32.00 33.00 32.00 64.00 -32.00 96.00 0.00 65.00 32.00 0.00 65.00 -32.00 0.00 -161.00 0.00 -32.00 0.00 -33.00 0.00 0.00 32.00 0.00 32.00 65.00 32.00 64.00 0.00 97.00 0.00 96.00 97.00 0.00 32.00 0.00 32.00 -129.00 97.00 33.00 32.00 64.00 0.00 64.00 -32.00 64.00 -33.00 33.00 0.00 32.00 33.00 0.00 160.00 64.00 97.00 64.00 0.00 0.00 -32.00 -32.00 -97.00 32.00 -32.00 0.00 -32.00 97.00 0.00 64.00 0.00 0.00 32.00 -64.00 161.00 32.00 32.00 64.00 -32.00 65.00 -32.00 96.00 96.00 32.00 0.00 32.00 0.00 0.00 -32.00 0.00 -32.00 -64.00 -65.00 0.00 -64.00 64.00 0.00 161.00 -32.00 0.00 32.00 64.00 32.00 65.00 65.00 32.00 0.00 32.00 -33.00 32.00 -96.00 32.00 -32.00 65.00 0.00 64.00 32.00 0.00 32.00 -32.00 64.00 32.00 65.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 -32.00 0.00 -97.00 64.00 0.00 32.00 0.00 0.00 32.00 32.00 0.00 -64.00 193.00 32.00 32.00 64.00 0.00 65.00 -96.00 64.00 0.00 32.00 0.00 0.00 32.00 0.00 32.00 -32.00 129.00 32.00 64.00 32.00 32.00 32.00 0.00 33.00 -64.00 0.00 -32.00 32.00 0.00 0.00 -32.00 64.00 32.00 129.00 -32.00 96.00 0.00 32.00 64.00 32.00 0.00 0.00 129.00 33.00 32.00 32.00 32.00 32.00 0.00 0.00 32.00 96.00 97.00 0.00 64.00 0.00 32.00 65.00 0.00 32.00 -64.00 32.00 -32.00 32.00 -33.00 64.00 -32.00 65.00 32.00 0.00 33.00 -32.00 128.00 64.00 32.00 64.00 65.00 97.00 -65.00 64.00 32.00 32.00 0.00 0.00 33.00 0.00 64.00 32.00 32.00 -32.00 32.00 0.00 64.00 97.00 33.00 64.00 -33.00 32.00 65.00 0.00 64.00 96.00 64.00 33.00 65.00 32.00 32.00 32.00 -32.00 32.00 -32.00 64.00 32.00 97.00 0.00 64.00 64.00 97.00 64.00 96.00 0.00 0.00 32.00 32.00 97.00 0.00 32.00 32.00 0.00 97.00 -32.00 32.00 0.00 64.00 32.00 32.00 32.00 -32.00 97.00 32.00 32.00 97.00 0.00 0.00 32.00 0.00 64.00 0.00 65.00 64.00 64.00 97.00 64.00 0.00 97.00 0.00 32.00 32.00 32.00 0.00 32.00 64.00 0.00 32.00 -96.00 32.00 -32.00 33.00 32.00 32.00 64.00 128.00 64.00 65.00 0.00 32.00 32.00 -32.00 65.00 64.00 64.00 -32.00 32.00 161.00 32.00 64.00 65.00 0.00 32.00 0.00 32.00 0.00 64.00 -32.00 65.00 -65.00 32.00 -32.00 32.00 97.00 32.00 32.00 32.00 32.00 64.00 -32.00 97.00 32.00 32.00 32.00 0.00 32.00 0.00 97.00 -96.00 32.00 0.00 64.00 96.00 0.00 32.00 129.00 -32.00 0.00 32.00 32.00 0.00 -32.00 65.00 32.00 96.00 -32.00 64.00 0.00 33.00 64.00 32.00 32.00 -65.00 33.00 33.00 0.00 32.00 32.00 32.00 0.00 96.00 0.00 97.00 32.00 0.00 161.00 96.00 64.00 0.00 32.00 0.00 0.00 97.00 64.00 32.00 32.00 32.00 65.00 96.00 -32.00 97.00 96.00 32.00 97.00 96.00 -33.00 65.00 33.00 64.00 64.00 0.00 64.00 -64.00 32.00 0.00 65.00 64.00 64.00 97.00 64.00 32.00 32.00 32.00 33.00 0.00 32.00 0.00 0.00 -97.00 32.00 0.00 32.00 0.00 96.00 33.00 129.00 0.00 64.00 0.00 65.00 64.00 32.00 32.00 64.00 0.00 129.00 0.00 32.00 64.00 32.00 0.00 32.00 0.00 32.00 -96.00 33.00 -32.00 32.00 0.00 32.00 32.00 0.00 128.00 0.00 65.00 32.00 -32.00 32.00 0.00 -32.00 -97.00 32.00 0.00 32.00 -32.00 65.00 0.00 64.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 64.00 33.00 97.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 96.00 -64.00 0.00 32.00 64.00 129.00 33.00 32.00 32.00 -32.00 64.00 -65.00 32.00 0.00 32.00 32.00 33.00 0.00 32.00 0.00 64.00 97.00 0.00 96.00 32.00 33.00 97.00 -33.00 -33.00 -64.00 -64.00 -96.00 32.00 0.00 32.00 -65.00 65.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 64.00 32.00 0.00 32.00 -32.00 32.00 -32.00 65.00 0.00 32.00 64.00 0.00 64.00 64.00 65.00 -64.00 64.00 32.00 32.00 0.00 129.00 0.00 32.00 -32.00 32.00 -64.00 32.00 -33.00 65.00 33.00 64.00 -33.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 64.00 33.00 0.00 32.00 0.00 32.00 65.00 32.00 64.00 64.00 -32.00 -32.00 -32.00 -32.00 -32.00 32.00 -33.00 32.00 0.00 97.00 65.00 32.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -65.00 0.00 -32.00 64.00 32.00 33.00 -32.00 64.00 32.00 32.00 0.00 -32.00 0.00 -97.00 32.00 65.00 33.00 0.00 64.00 0.00 32.00 0.00 32.00 128.00 0.00 -32.00 32.00 32.00 33.00 65.00 -97.00 64.00 32.00 -32.00 -32.00 0.00 -64.00 32.00 0.00 32.00 96.00 32.00 0.00 32.00 32.00 33.00 33.00 32.00 -33.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 64.00 -32.00 0.00 -32.00 32.00 0.00 0.00 128.00 -32.00 32.00 32.00 33.00 96.00 -33.00 0.00 33.00 33.00 0.00 -33.00 32.00 65.00 64.00 -65.00 64.00 -32.00 65.00 32.00 0.00 65.00 32.00 32.00 96.00 32.00 32.00 32.00 -32.00 0.00 32.00 0.00 33.00 0.00 32.00 0.00 64.00 65.00 0.00 32.00 64.00 -32.00 32.00 -33.00 33.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 -64.00 0.00 -129.00 33.00 0.00 -65.00 -64.00 65.00 -32.00 0.00 -32.00 -33.00 0.00 -64.00 -33.00 32.00 -32.00 0.00 -32.00 65.00 -32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 0.00 -64.00 32.00 -32.00 33.00 -33.00 0.00 0.00 32.00 33.00 0.00 0.00 64.00 32.00 0.00 32.00 32.00 -64.00 0.00 -33.00 32.00 0.00 32.00 0.00 33.00 -32.00 0.00 0.00 -65.00 -96.00 0.00 32.00 0.00 -64.00 0.00 0.00 32.00 0.00 65.00 -33.00 64.00 33.00 32.00 -65.00 32.00 0.00 -32.00 -32.00 0.00 64.00 -96.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 33.00 -65.00 0.00 -32.00 64.00 0.00 64.00 64.00 32.00 -32.00 0.00 0.00 33.00 -32.00 32.00 -64.00 -32.00 0.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 32.00 0.00 0.00 65.00 -64.00 -32.00 0.00 96.00 0.00 32.00 32.00 0.00 -32.00 129.00 64.00 -32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -33.00 32.00 97.00 -32.00 0.00 64.00 32.00 -32.00 64.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 33.00 -32.00 0.00 0.00 32.00 0.00 32.00 -64.00 32.00 32.00 32.00 -65.00 32.00 33.00 32.00 96.00 0.00 -32.00 0.00 0.00 65.00 -32.00 0.00 0.00 96.00 64.00 32.00 32.00 33.00 64.00 32.00 -64.00 32.00 -32.00 -32.00 0.00 32.00 0.00 64.00 -32.00 -32.00 -32.00 32.00 0.00 65.00 -65.00 64.00 97.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 0.00 32.00 -225.00 97.00 96.00 0.00 0.00 32.00 0.00 -32.00 96.00 -32.00 33.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 0.00 32.00 -64.00 0.00 32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 0.00 32.00 -65.00 0.00 0.00 64.00 33.00 0.00 -33.00 33.00 0.00 64.00 33.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 0.00 32.00 64.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -97.00 0.00 33.00 32.00 0.00 65.00 0.00 32.00 -65.00 0.00 0.00 32.00 -32.00 32.00 32.00 32.00 32.00 33.00 -64.00 0.00 -32.00 -33.00 -32.00 33.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 0.00 -65.00 -64.00 65.00 0.00 -32.00 -32.00 -33.00 32.00 0.00 -64.00 0.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 0.00 -64.00 0.00 -65.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 33.00 0.00 0.00 64.00 32.00 0.00 -32.00 0.00 0.00 32.00 0.00 96.00 32.00 -32.00 -32.00 32.00 32.00 33.00 -65.00 32.00 33.00 -65.00 -97.00 65.00 0.00 -32.00 0.00 -33.00 32.00 0.00 32.00 -64.00 -96.00 0.00 0.00 -32.00 -64.00 0.00 32.00 -32.00 -64.00 0.00 0.00 -32.00 -65.00 64.00 65.00 0.00 32.00 32.00 0.00 32.00 -97.00 32.00 32.00 0.00 -32.00 33.00 32.00 0.00 33.00 32.00 -33.00 0.00 -96.00 64.00 32.00 0.00 32.00 0.00 0.00 32.00 65.00 0.00 -33.00 0.00 0.00 97.00 -32.00 32.00 32.00 0.00 0.00 32.00 33.00 32.00 0.00 32.00 32.00 0.00 0.00 -64.00 32.00 -32.00 0.00 32.00 32.00 0.00 0.00 32.00 64.00 32.00 -32.00 0.00 32.00 32.00 65.00 0.00 32.00 33.00 0.00 32.00 32.00 0.00 32.00 0.00 -32.00 32.00 96.00 0.00 0.00 32.00 -32.00 32.00 65.00 0.00 64.00 32.00 -129.00 -193.00 -64.00 0.00 -64.00 -64.00 -65.00 -64.00 -32.00 0.00 -32.00 -129.00 32.00 0.00 32.00 0.00 65.00 0.00 96.00 -32.00 32.00 0.00 0.00 -32.00 97.00 0.00 32.00 -32.00 129.00 -65.00 32.00 33.00 64.00 -33.00 64.00 -32.00 32.00 -64.00 33.00 -32.00 64.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 65.00 0.00 64.00 32.00 96.00 32.00 65.00 0.00 32.00 65.00 0.00 32.00 32.00 0.00 32.00 32.00 -32.00 0.00 0.00 32.00 64.00 32.00 -32.00 32.00 0.00 33.00 32.00 0.00 33.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 64.00 0.00 32.00 0.00 97.00 64.00 32.00 0.00 64.00 -32.00 32.00 32.00 0.00 32.00 33.00 33.00 0.00 -33.00 0.00 33.00 32.00 0.00 -65.00 32.00 0.00 32.00 33.00 0.00 32.00 0.00 96.00 0.00 -96.00 96.00 0.00 65.00 -97.00 96.00 -257.00 289.00 -547.00 804.00 -64.00 97.00 -32.00 64.00 -64.00 64.00 -32.00 65.00 -129.00 257.00 -129.00 257.00 -128.00 225.00 -97.00 225.00 -64.00 97.00 -193.00 450.00 -129.00 289.00 -64.00 161.00 -64.00 161.00 -193.00 514.00 -64.00 161.00 -65.00 161.00 0.00 64.00 -64.00 97.00 -32.00 128.00 -129.00 386.00 -96.00 225.00 -129.00 225.00 -161.00 290.00 -353.00 450.00 -161.00 225.00 -418.00 611.00 -515.00 707.00 -32.00 64.00 -289.00 451.00 -129.00 192.00 -160.00 161.00 -226.00 257.00 -160.00 193.00 -225.00 193.00 -97.00 65.00 -418.00 353.00 -386.00 354.00 -257.00 193.00 -64.00 96.00 -161.00 193.00 -129.00 161.00 -353.00 257.00 -354.00 290.00 -321.00 225.00 -290.00 160.00 -450.00 258.00 -450.00 225.00 -450.00 257.00 -322.00 225.00 -193.00 161.00 -257.00 257.00 -450.00 482.00 -32.00 97.00 0.00 128.00 -97.00 -128.00 -96.00 32.00 -161.00 129.00 -161.00 96.00 -193.00 225.00 -160.00 193.00 -225.00 322.00 -161.00 289.00 -129.00 321.00 -225.00 579.00 -32.00 161.00 -97.00 450.00 -96.00 322.00 -225.00 514.00 -193.00 322.00 -225.00 482.00 -129.00 225.00 -160.00 225.00 -354.00 450.00 -290.00 257.00 -1157.00 933.00 -514.00 450.00 -451.00 354.00 -128.00 96.00 -483.00 322.00 -32.00 0.00 -64.00 32.00 -32.00 -32.00 -64.00 0.00 -33.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 -96.00 0.00 -64.00 -32.00 -32.00 -386.00 -33.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -65.00 32.00 -32.00 32.00 -64.00 -64.00 -64.00 32.00 -65.00 32.00 -32.00 0.00 -321.00 64.00 -354.00 33.00 -514.00 -97.00 -483.00 32.00 -482.00 322.00 -482.00 450.00 -258.00 225.00 33.00 289.00 -354.00 -289.00 -97.00 96.00 -96.00 33.00 64.00 -33.00 0.00 33.00 32.00 32.00 0.00 -65.00 -96.00 483.00 -225.00 128.00 -193.00 -32.00 -32.00 97.00 -97.00 289.00 -64.00 64.00 -161.00 -482.00 -418.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 -161.00 -32.00 -96.00 -64.00 -33.00 -129.00 -128.00 32.00 -32.00 65.00 -33.00 0.00 -32.00 -33.00 -32.00 -32.00 -96.00 -64.00 -65.00 -32.00 -64.00 32.00 -32.00 0.00 -64.00 -97.00 -33.00 0.00 -64.00 65.00 -96.00 -65.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 32.00 -64.00 -128.00 -64.00 -97.00 0.00 -32.00 -33.00 -64.00 0.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 0.00 -128.00 0.00 -65.00 32.00 0.00 -32.00 -32.00 32.00 -96.00 -64.00 0.00 -32.00 -65.00 0.00 -32.00 -64.00 -96.00 -32.00 0.00 -65.00 -65.00 -32.00 -64.00 -64.00 0.00 -65.00 0.00 -32.00 -161.00 -64.00 32.00 -32.00 33.00 -129.00 -33.00 -64.00 0.00 -64.00 -64.00 -33.00 0.00 -32.00 32.00 0.00 32.00 -64.00 -64.00 -32.00 0.00 -64.00 -64.00 -33.00 -32.00 -64.00 0.00 -96.00 -65.00 -97.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -64.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -96.00 -97.00 0.00 33.00 -33.00 0.00 -32.00 -65.00 -128.00 32.00 -32.00 -32.00 -33.00 65.00 33.00 32.00 -33.00 -97.00 -32.00 0.00 -64.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -65.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 0.00 -65.00 -33.00 -32.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 -65.00 -32.00 -32.00 32.00 -96.00 -32.00 -32.00 -64.00 -65.00 -32.00 0.00 -33.00 -96.00 -32.00 -64.00 -32.00 -33.00 0.00 -32.00 0.00 -64.00 -64.00 0.00 -32.00 32.00 0.00 0.00 -33.00 32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -129.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -64.00 64.00 -32.00 -32.00 -65.00 97.00 0.00 -33.00 -64.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 -161.00 -64.00 0.00 -65.00 -64.00 -64.00 -1415.00 -1061.00 32.00 -64.00 -32.00 -32.00 -32.00 -33.00 -32.00 -64.00 64.00 -32.00 0.00 -32.00 0.00 32.00 0.00 -32.00 -32.00 -65.00 -32.00 33.00 -32.00 -97.00 -32.00 -32.00 -65.00 -32.00 32.00 -32.00 -128.00 -193.00 -32.00 -32.00 -33.00 -33.00 -96.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -97.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -33.00 -418.00 0.00 -64.00 -64.00 -32.00 0.00 -32.00 -32.00 -33.00 32.00 -64.00 0.00 -32.00 -64.00 -161.00 -32.00 -128.00 64.00 -65.00 -32.00 -32.00 32.00 -96.00 0.00 -32.00 32.00 -97.00 -128.00 -32.00 0.00 32.00 -33.00 -96.00 -64.00 -65.00 -64.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -96.00 -32.00 -33.00 32.00 -32.00 0.00 0.00 -65.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -96.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 -97.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -64.00 -32.00 32.00 -33.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 32.00 -65.00 -32.00 -64.00 32.00 -32.00 32.00 32.00 0.00 0.00 32.00 0.00 33.00 -64.00 96.00 -32.00 32.00 -33.00 0.00 0.00 32.00 0.00 32.00 -64.00 0.00 -32.00 -32.00 -96.00 -32.00 -33.00 -32.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 -64.00 0.00 -33.00 -32.00 0.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -64.00 0.00 0.00 -32.00 -258.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -161.00 -32.00 -32.00 32.00 -32.00 -64.00 -65.00 -97.00 0.00 0.00 -32.00 65.00 -32.00 -32.00 -32.00 -65.00 -32.00 0.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -64.00 32.00 0.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -64.00 -64.00 0.00 -64.00 -97.00 0.00 33.00 -32.00 -33.00 32.00 -32.00 0.00 -96.00 -32.00 0.00 -65.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 -64.00 0.00 -64.00 -32.00 32.00 -64.00 32.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -64.00 -64.00 0.00 -33.00 -64.00 -96.00 32.00 -32.00 -32.00 0.00 -33.00 0.00 -64.00 -64.00 -32.00 -33.00 -32.00 0.00 -64.00 -96.00 -33.00 -32.00 33.00 0.00 -33.00 -65.00 -32.00 -32.00 -64.00 -32.00 -32.00 0.00 -65.00 -32.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -33.00 32.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 65.00 -32.00 -32.00 -32.00 64.00 64.00 32.00 -32.00 0.00 0.00 64.00 64.00 65.00 -32.00 64.00 -32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 33.00 0.00 32.00 -64.00 0.00 -65.00 0.00 0.00 -32.00 -32.00 -33.00 -32.00 65.00 -32.00 0.00 -32.00 -65.00 -33.00 0.00 33.00 33.00 -33.00 0.00 0.00 96.00 -32.00 32.00 32.00 32.00 -96.00 0.00 0.00 32.00 -32.00 65.00 -97.00 -32.00 32.00 64.00 -64.00 32.00 -128.00 0.00 -33.00 0.00 0.00 32.00 -64.00 97.00 0.00 32.00 -96.00 -32.00 -32.00 32.00 -65.00 129.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -65.00 -65.00 -32.00 33.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 -97.00 -32.00 -96.00 -32.00 -65.00 32.00 0.00 32.00 -96.00 -32.00 0.00 -32.00 -32.00 -129.00 0.00 -225.00 32.00 -97.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 0.00 -32.00 -32.00 0.00 64.00 -129.00 -32.00 -32.00 0.00 -97.00 96.00 -128.00 0.00 -65.00 -32.00 -32.00 -32.00 -32.00 -32.00 -96.00 -32.00 -33.00 0.00 -32.00 32.00 0.00 -64.00 -32.00 0.00 -64.00 0.00 -32.00 -65.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 -33.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 -33.00 0.00 -64.00 64.00 -32.00 0.00 -32.00 -128.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 0.00 -32.00 32.00 -65.00 -32.00 0.00 -32.00 -32.00 -64.00 -32.00 0.00 -64.00 64.00 -33.00 0.00 -32.00 -64.00 0.00 -65.00 -64.00 -32.00 -64.00 32.00 -65.00 -64.00 -32.00 -32.00 -32.00 64.00 -64.00 -96.00 -32.00 -129.00 0.00 -32.00 -33.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -64.00 -32.00 -32.00 0.00 -32.00 64.00 -33.00 0.00 0.00 -64.00 33.00 -32.00 -33.00 -32.00 -32.00 -33.00 -32.00 33.00 -32.00 0.00 0.00 -33.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 -65.00 32.00 -96.00 -32.00 -32.00 0.00 0.00 -65.00 -65.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 -96.00 0.00 -33.00 -32.00 33.00 0.00 0.00 -32.00 -65.00 0.00 0.00 -64.00 -32.00 -33.00 0.00 -32.00 32.00 0.00 0.00 -64.00 -64.00 0.00 -32.00 -97.00 -32.00 33.00 -65.00 0.00 -64.00 -65.00 32.00 -32.00 -32.00 -32.00 -64.00 -129.00 -65.00 33.00 -32.00 64.00 -32.00 0.00 -32.00 -64.00 -32.00 -33.00 0.00 -64.00 -65.00 -32.00 -128.00 0.00 0.00 -32.00 -32.00 -65.00 64.00 -32.00 0.00 -96.00 -32.00 -32.00 -32.00 64.00 -97.00 -96.00 0.00 -65.00 -96.00 32.00 -32.00 0.00 -65.00 33.00 -32.00 -33.00 65.00 -64.00 -33.00 -96.00 -64.00 32.00 -64.00 -65.00 32.00 0.00 32.00 0.00 0.00 -32.00 -64.00 -64.00 -32.00 -64.00 -97.00 0.00 0.00 -32.00 97.00 -33.00 0.00 -32.00 -33.00 32.00 -32.00 -32.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 -65.00 32.00 -64.00 -64.00 0.00 -64.00 -32.00 0.00 -64.00 -33.00 -129.00 -32.00 -96.00 0.00 -32.00 -64.00 32.00 -96.00 0.00 -33.00 -97.00 -32.00 -32.00 -64.00 -64.00 0.00 -32.00 -32.00 -65.00 -32.00 -64.00 0.00 -96.00 0.00 0.00 -32.00 -65.00 0.00 -96.00 128.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -33.00 -32.00 -64.00 -32.00 -96.00 32.00 -97.00 0.00 -32.00 -64.00 -64.00 0.00 -129.00 0.00 -32.00 32.00 0.00 64.00 -64.00 0.00 -65.00 -32.00 -64.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 64.00 -32.00 64.00 32.00 0.00 -32.00 32.00 -33.00 0.00 -96.00 -32.00 0.00 64.00 64.00 0.00 0.00 65.00 -64.00 32.00 -64.00 0.00 -65.00 128.00 -64.00 65.00 0.00 64.00 -64.00 0.00 0.00 64.00 32.00 33.00 -32.00 0.00 32.00 0.00 0.00 32.00 32.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -97.00 65.00 -32.00 96.00 -64.00 32.00 -129.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 -65.00 64.00 -32.00 0.00 -32.00 -64.00 -64.00 -96.00 -32.00 -33.00 -33.00 65.00 -160.00 64.00 -33.00 -64.00 -32.00 32.00 -96.00 64.00 0.00 65.00 -32.00 0.00 -65.00 0.00 -64.00 0.00 0.00 -65.00 32.00 -32.00 -64.00 -32.00 -96.00 0.00 -65.00 -32.00 -96.00 0.00 -32.00 0.00 -33.00 96.00 -128.00 -32.00 -129.00 -32.00 -32.00 -64.00 -32.00 -33.00 32.00 -192.00 -32.00 -33.00 -225.00 -96.00 -97.00 -32.00 -64.00 32.00 64.00 -64.00 225.00 0.00 161.00 -65.00 322.00 -193.00 96.00 -96.00 65.00 -161.00 96.00 -96.00 96.00 -97.00 290.00 -161.00 96.00 -128.00z"},ba:{name:"BA",path:"M135416.00 82601.00l-32.00 -32.00 0.00 -64.00 32.00 0.00 32.00 -97.00 -32.00 -64.00 129.00 -32.00 386.00 -193.00 64.00 0.00 64.00 -96.00 97.00 -161.00 32.00 -322.00 96.00 -257.00 97.00 -96.00 0.00 -97.00 32.00 0.00 96.00 -64.00 33.00 -64.00 32.00 -33.00 161.00 -96.00 64.00 -97.00 161.00 -96.00 0.00 -32.00 -65.00 -129.00 0.00 -32.00 33.00 -96.00 32.00 -65.00 32.00 -32.00 128.00 -64.00 65.00 -32.00 32.00 -65.00 0.00 -128.00 -97.00 -32.00 -32.00 0.00 193.00 -129.00 97.00 -64.00 32.00 -129.00 0.00 -32.00 -32.00 -32.00 -65.00 -97.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 65.00 -32.00 0.00 -32.00 96.00 -33.00 32.00 33.00 97.00 -33.00 96.00 0.00 97.00 -96.00 96.00 32.00 65.00 -32.00 32.00 -32.00 0.00 -97.00 128.00 -32.00 32.00 -129.00 33.00 -32.00 96.00 0.00 64.00 -32.00 65.00 0.00 32.00 -96.00 64.00 -32.00 193.00 -129.00 32.00 -64.00 65.00 -65.00 96.00 -64.00 161.00 0.00 32.00 0.00 32.00 -129.00 -64.00 -96.00 32.00 -64.00 0.00 -32.00 0.00 -33.00 32.00 0.00 64.00 -32.00 65.00 -32.00 193.00 0.00 64.00 -32.00 64.00 -129.00 65.00 -160.00 32.00 -65.00 32.00 -32.00 0.00 -32.00 0.00 -97.00 0.00 -128.00 -32.00 -129.00 32.00 -32.00 0.00 -64.00 -97.00 0.00 -32.00 -65.00 32.00 0.00 65.00 0.00 96.00 0.00 64.00 -32.00 97.00 -96.00 64.00 0.00 161.00 -97.00 32.00 0.00 64.00 65.00 65.00 96.00 0.00 97.00 0.00 128.00 0.00 65.00 64.00 96.00 129.00 96.00 32.00 33.00 0.00 160.00 32.00 33.00 96.00 64.00 33.00 32.00 64.00 32.00 64.00 129.00 129.00 96.00 32.00 65.00 -32.00 160.00 32.00 97.00 129.00 96.00 0.00 65.00 -33.00 32.00 -128.00 128.00 -64.00 97.00 32.00 64.00 0.00 96.00 -32.00 65.00 32.00 96.00 32.00 225.00 0.00 33.00 32.00 32.00 32.00 32.00 32.00 0.00 65.00 32.00 64.00 0.00 32.00 64.00 32.00 32.00 0.00 33.00 64.00 289.00 161.00 129.00 161.00 32.00 97.00 32.00 0.00 32.00 64.00 161.00 32.00 32.00 129.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 257.00 32.00 97.00 0.00 96.00 0.00 32.00 33.00 97.00 -33.00 64.00 0.00 32.00 33.00 64.00 32.00 33.00 32.00 64.00 32.00 64.00 96.00 64.00 0.00 33.00 0.00 96.00 33.00 32.00 0.00 0.00 32.00 193.00 161.00 97.00 -97.00 32.00 0.00 32.00 -32.00 64.00 0.00 97.00 -97.00 32.00 0.00 32.00 65.00 129.00 -97.00 32.00 -32.00 32.00 -32.00 0.00 -96.00 96.00 -193.00 32.00 0.00 97.00 0.00 0.00 -97.00 32.00 -32.00 97.00 -32.00 32.00 -32.00 64.00 -32.00 129.00 32.00 96.00 -32.00 0.00 -33.00 32.00 -96.00 -64.00 -193.00 32.00 0.00 0.00 -32.00 32.00 -32.00 65.00 -32.00 32.00 0.00 64.00 0.00 64.00 -33.00 32.00 -32.00 65.00 -128.00 64.00 -32.00 129.00 0.00 128.00 96.00 33.00 0.00 32.00 0.00 32.00 0.00 96.00 -32.00 65.00 -64.00 32.00 -65.00 32.00 -32.00 32.00 0.00 129.00 32.00 96.00 -32.00 32.00 -32.00 193.00 -225.00 32.00 -32.00 65.00 0.00 64.00 32.00 32.00 32.00 32.00 32.00 97.00 193.00 96.00 64.00 97.00 33.00 32.00 0.00 96.00 -65.00 32.00 0.00 97.00 65.00 64.00 32.00 65.00 32.00 32.00 0.00 32.00 0.00 64.00 -32.00 32.00 0.00 32.00 -65.00 65.00 -128.00 32.00 -32.00 96.00 0.00 32.00 -33.00 33.00 -64.00 96.00 -321.00 32.00 -33.00 65.00 -64.00 0.00 -32.00 -33.00 -161.00 33.00 -128.00 32.00 -65.00 64.00 0.00 64.00 32.00 129.00 65.00 129.00 0.00 96.00 0.00 0.00 -32.00 32.00 -161.00 64.00 -64.00 33.00 -97.00 32.00 -32.00 64.00 -64.00 97.00 -65.00 64.00 -64.00 0.00 -129.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 193.00 -193.00 96.00 -129.00 32.00 -225.00 0.00 -96.00 -32.00 -65.00 65.00 -96.00 32.00 -32.00 128.00 0.00 161.00 0.00 0.00 -65.00 32.00 -96.00 97.00 -64.00 32.00 -129.00 -32.00 -64.00 -65.00 -33.00 -96.00 -96.00 64.00 -129.00 0.00 -32.00 -32.00 -32.00 -64.00 0.00 0.00 -64.00 0.00 -32.00 64.00 0.00 0.00 -65.00 97.00 -32.00 32.00 -64.00 0.00 -64.00 64.00 -65.00 0.00 -32.00 -64.00 -64.00 -65.00 -32.00 -64.00 -65.00 -64.00 0.00 -32.00 0.00 -33.00 -64.00 -192.00 -64.00 -33.00 -32.00 -64.00 -33.00 -64.00 -192.00 0.00 -65.00 0.00 -32.00 0.00 -64.00 -129.00 -225.00 -96.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 0.00 -64.00 -32.00 0.00 -129.00 -32.00 -128.00 0.00 -65.00 160.00 -257.00 97.00 -64.00 64.00 -129.00 64.00 -64.00 97.00 -32.00 289.00 -97.00 97.00 -64.00 193.00 -161.00 64.00 -32.00 96.00 -129.00 97.00 -96.00 32.00 0.00 96.00 -32.00 33.00 0.00 64.00 -64.00 129.00 -129.00 64.00 -32.00 96.00 -32.00 65.00 32.00 32.00 0.00 64.00 32.00 129.00 161.00 32.00 64.00 96.00 161.00 97.00 96.00 96.00 0.00 32.00 0.00 65.00 97.00 64.00 32.00 32.00 0.00 32.00 128.00 32.00 0.00 33.00 0.00 32.00 -64.00 128.00 0.00 65.00 -32.00 32.00 0.00 64.00 0.00 32.00 64.00 32.00 32.00 97.00 -64.00 64.00 -161.00 64.00 0.00 65.00 65.00 0.00 -65.00 32.00 0.00 32.00 -32.00 32.00 32.00 32.00 0.00 0.00 33.00 33.00 0.00 64.00 32.00 0.00 32.00 32.00 0.00 64.00 0.00 32.00 0.00 0.00 96.00 193.00 -32.00 33.00 0.00 96.00 -32.00 64.00 32.00 65.00 64.00 0.00 33.00 32.00 32.00 -32.00 96.00 0.00 65.00 32.00 128.00 32.00 64.00 0.00 33.00 96.00 64.00 97.00 0.00 64.00 32.00 97.00 129.00 32.00 0.00 32.00 0.00 64.00 -65.00 32.00 0.00 32.00 65.00 0.00 96.00 65.00 97.00 0.00 96.00 64.00 0.00 193.00 -32.00 32.00 -32.00 0.00 -97.00 65.00 -32.00 64.00 -64.00 64.00 -64.00 0.00 -97.00 0.00 -32.00 32.00 32.00 97.00 32.00 0.00 32.00 64.00 0.00 96.00 -32.00 65.00 0.00 64.00 -32.00 32.00 32.00 97.00 -128.00 32.00 -65.00 32.00 -32.00 97.00 32.00 96.00 -32.00 129.00 32.00 128.00 -32.00 32.00 -64.00 -32.00 -64.00 32.00 -33.00 65.00 -32.00 96.00 32.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 0.00 -129.00 32.00 -32.00 96.00 -64.00 129.00 -64.00 32.00 -33.00 32.00 0.00 0.00 -128.00 161.00 -97.00 32.00 -64.00 32.00 0.00 97.00 -32.00 96.00 0.00 32.00 -32.00 97.00 -65.00 64.00 -32.00 32.00 0.00 65.00 32.00 64.00 0.00 64.00 -32.00 193.00 0.00 97.00 0.00 96.00 -32.00 161.00 -96.00 64.00 0.00 64.00 0.00 65.00 -32.00 128.00 64.00 129.00 -97.00 64.00 97.00 32.00 0.00 65.00 0.00 64.00 64.00 32.00 0.00 32.00 -32.00 33.00 -64.00 96.00 -32.00 64.00 -65.00 32.00 0.00 65.00 32.00 64.00 0.00 64.00 -289.00 97.00 -97.00 0.00 -96.00 96.00 -96.00 32.00 0.00 65.00 -65.00 128.00 -96.00 0.00 -129.00 0.00 -96.00 33.00 -129.00 0.00 -32.00 225.00 0.00 32.00 -64.00 0.00 -65.00 193.00 -32.00 32.00 0.00 0.00 -64.00 64.00 0.00 32.00 -64.00 32.00 0.00 33.00 0.00 32.00 0.00 64.00 0.00 32.00 64.00 97.00 -32.00 0.00 -129.00 64.00 -32.00 32.00 -129.00 32.00 0.00 32.00 -64.00 0.00 -64.00 33.00 -32.00 0.00 -33.00 32.00 0.00 32.00 -96.00 64.00 0.00 64.00 -64.00 129.00 -161.00 32.00 32.00 65.00 -161.00 64.00 -128.00 32.00 -97.00 64.00 -64.00 0.00 -32.00 65.00 0.00 32.00 0.00 128.00 96.00 97.00 0.00 96.00 65.00 32.00 0.00 65.00 -33.00 64.00 -64.00 97.00 0.00 0.00 -32.00 32.00 -32.00 32.00 0.00 96.00 32.00 32.00 -32.00 33.00 32.00 32.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 225.00 -32.00 -32.00 64.00 0.00 32.00 -32.00 32.00 0.00 33.00 32.00 64.00 32.00 32.00 0.00 32.00 32.00 32.00 33.00 65.00 96.00 0.00 0.00 32.00 32.00 -32.00 32.00 0.00 65.00 0.00 64.00 0.00 32.00 0.00 32.00 128.00 -32.00 129.00 64.00 32.00 97.00 -64.00 32.00 0.00 64.00 -33.00 97.00 33.00 0.00 64.00 64.00 0.00 129.00 -32.00 0.00 64.00 64.00 64.00 32.00 0.00 0.00 33.00 0.00 96.00 64.00 64.00 0.00 65.00 97.00 32.00 0.00 128.00 64.00 0.00 0.00 161.00 32.00 64.00 33.00 65.00 32.00 64.00 0.00 32.00 0.00 32.00 32.00 33.00 0.00 96.00 32.00 32.00 -32.00 65.00 64.00 32.00 32.00 64.00 65.00 0.00 0.00 32.00 64.00 -32.00 64.00 32.00 32.00 0.00 0.00 64.00 33.00 0.00 64.00 33.00 96.00 64.00 32.00 0.00 97.00 0.00 32.00 64.00 64.00 32.00 -32.00 65.00 0.00 64.00 0.00 32.00 -32.00 64.00 0.00 33.00 -64.00 96.00 32.00 64.00 0.00 65.00 32.00 0.00 0.00 64.00 -32.00 32.00 -97.00 32.00 0.00 32.00 0.00 33.00 -64.00 32.00 -96.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 32.00 97.00 128.00 -32.00 33.00 32.00 64.00 -64.00 64.00 32.00 65.00 0.00 64.00 0.00 32.00 -32.00 0.00 -65.00 32.00 0.00 97.00 -32.00 64.00 -32.00 64.00 129.00 -64.00 128.00 0.00 32.00 32.00 161.00 97.00 129.00 32.00 128.00 32.00 161.00 -64.00 64.00 0.00 33.00 0.00 32.00 -33.00 64.00 -64.00 32.00 0.00 32.00 -129.00 32.00 -32.00 97.00 -32.00 32.00 0.00 32.00 0.00 97.00 32.00 32.00 32.00 64.00 -96.00 97.00 -193.00 64.00 -64.00 64.00 0.00 97.00 96.00 96.00 32.00 32.00 0.00 129.00 -128.00 0.00 -97.00 0.00 -32.00 64.00 -193.00 65.00 -64.00 64.00 -354.00 32.00 -96.00 -32.00 -129.00 32.00 -161.00 64.00 -192.00 97.00 -97.00 32.00 -32.00 64.00 0.00 32.00 0.00 33.00 32.00 32.00 0.00 96.00 97.00 97.00 64.00 32.00 64.00 64.00 0.00 97.00 0.00 192.00 -96.00 65.00 -65.00 64.00 -64.00 129.00 0.00 160.00 0.00 33.00 0.00 64.00 -32.00 96.00 -32.00 193.00 -225.00 32.00 -33.00 33.00 -96.00 64.00 -32.00 96.00 -193.00 -32.00 -129.00 -96.00 -193.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 96.00 -33.00 258.00 -64.00 64.00 32.00 64.00 0.00 193.00 -128.00 225.00 32.00 65.00 0.00 32.00 -32.00 32.00 -32.00 32.00 -33.00 -32.00 -96.00 0.00 -64.00 0.00 -32.00 -32.00 -161.00 -65.00 -129.00 33.00 -96.00 128.00 0.00 64.00 0.00 97.00 -33.00 96.00 0.00 193.00 -64.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 128.00 -32.00 32.00 -33.00 193.00 -64.00 97.00 -64.00 0.00 -64.00 32.00 -33.00 64.00 0.00 64.00 0.00 33.00 -96.00 32.00 0.00 128.00 -32.00 33.00 0.00 32.00 0.00 32.00 32.00 32.00 32.00 64.00 64.00 65.00 0.00 128.00 0.00 65.00 0.00 32.00 33.00 32.00 64.00 0.00 32.00 0.00 32.00 32.00 97.00 64.00 32.00 32.00 32.00 33.00 64.00 -33.00 32.00 0.00 161.00 0.00 32.00 33.00 65.00 32.00 32.00 32.00 32.00 32.00 0.00 0.00 -32.00 97.00 32.00 96.00 -32.00 32.00 -32.00 32.00 -33.00 65.00 65.00 0.00 32.00 128.00 32.00 161.00 32.00 129.00 32.00 128.00 33.00 32.00 0.00 65.00 64.00 128.00 64.00 65.00 129.00 64.00 32.00 32.00 32.00 32.00 0.00 32.00 0.00 97.00 -32.00 193.00 -32.00 64.00 -32.00 64.00 0.00 225.00 32.00 33.00 0.00 32.00 32.00 128.00 96.00 129.00 129.00 96.00 32.00 65.00 64.00 32.00 97.00 32.00 161.00 0.00 96.00 32.00 64.00 65.00 129.00 128.00 64.00 64.00 -32.00 33.00 0.00 64.00 -128.00 0.00 -290.00 32.00 -64.00 161.00 -257.00 96.00 -33.00 193.00 33.00 129.00 96.00 64.00 64.00 -32.00 129.00 -32.00 64.00 -129.00 97.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 32.00 65.00 64.00 96.00 97.00 97.00 128.00 96.00 65.00 32.00 64.00 32.00 96.00 33.00 97.00 -97.00 129.00 -129.00 32.00 0.00 64.00 -32.00 97.00 0.00 0.00 65.00 96.00 96.00 32.00 97.00 0.00 32.00 -32.00 32.00 -96.00 64.00 -33.00 65.00 33.00 64.00 64.00 0.00 -97.00 96.00 33.00 129.00 32.00 32.00 32.00 32.00 64.00 97.00 64.00 160.00 -32.00 65.00 161.00 353.00 64.00 193.00 129.00 129.00 32.00 96.00 32.00 33.00 0.00 64.00 -32.00 32.00 0.00 64.00 32.00 32.00 97.00 0.00 96.00 97.00 64.00 -32.00 97.00 32.00 32.00 -32.00 32.00 0.00 129.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 32.00 0.00 65.00 65.00 64.00 0.00 32.00 0.00 64.00 64.00 65.00 64.00 -32.00 97.00 -33.00 64.00 0.00 32.00 -32.00 32.00 -32.00 32.00 32.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 0.00 97.00 32.00 64.00 64.00 32.00 32.00 32.00 33.00 32.00 64.00 33.00 32.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 64.00 -32.00 64.00 -64.00 33.00 0.00 32.00 0.00 32.00 0.00 64.00 0.00 97.00 0.00 96.00 64.00 129.00 32.00 0.00 0.00 32.00 97.00 96.00 96.00 33.00 32.00 0.00 32.00 32.00 -32.00 64.00 -32.00 64.00 32.00 32.00 0.00 33.00 -64.00 64.00 0.00 96.00 -64.00 97.00 0.00 32.00 64.00 32.00 96.00 193.00 33.00 32.00 32.00 0.00 64.00 -32.00 64.00 0.00 0.00 64.00 33.00 0.00 64.00 0.00 96.00 32.00 32.00 -32.00 226.00 129.00 32.00 64.00 0.00 65.00 0.00 32.00 0.00 96.00 128.00 257.00 97.00 129.00 0.00 64.00 -32.00 161.00 0.00 32.00 64.00 32.00 128.00 611.00 0.00 32.00 33.00 33.00 -129.00 64.00 -96.00 0.00 -33.00 32.00 -96.00 64.00 -32.00 0.00 -32.00 33.00 0.00 32.00 -32.00 0.00 -33.00 0.00 0.00 32.00 -32.00 32.00 0.00 32.00 32.00 0.00 -96.00 32.00 32.00 65.00 -32.00 32.00 161.00 289.00 32.00 97.00 0.00 32.00 0.00 32.00 -32.00 64.00 0.00 64.00 0.00 -32.00 -32.00 32.00 0.00 33.00 -65.00 0.00 0.00 32.00 32.00 32.00 0.00 32.00 33.00 32.00 0.00 32.00 64.00 547.00 -579.00 225.00 -161.00 64.00 -128.00 65.00 -129.00 0.00 0.00 -129.00 0.00 -32.00 -64.00 -64.00 -32.00 0.00 -33.00 -65.00 -32.00 0.00 -96.00 32.00 -32.00 -32.00 -32.00 -32.00 -65.00 64.00 -64.00 -32.00 -32.00 65.00 -65.00 0.00 -64.00 -33.00 -32.00 0.00 -64.00 0.00 -32.00 -64.00 -97.00 32.00 -32.00 0.00 -32.00 65.00 0.00 64.00 0.00 64.00 0.00 65.00 -32.00 96.00 -33.00 64.00 -32.00 0.00 -32.00 33.00 32.00 64.00 -32.00 64.00 32.00 0.00 32.00 97.00 -32.00 32.00 -32.00 64.00 0.00 64.00 64.00 97.00 0.00 96.00 65.00 32.00 0.00 33.00 32.00 -33.00 32.00 0.00 0.00 65.00 97.00 32.00 0.00 32.00 -33.00 64.00 33.00 33.00 32.00 64.00 128.00 64.00 32.00 64.00 33.00 33.00 32.00 0.00 0.00 -65.00 64.00 32.00 32.00 33.00 0.00 32.00 32.00 64.00 -32.00 0.00 0.00 32.00 32.00 32.00 33.00 0.00 0.00 32.00 32.00 0.00 0.00 33.00 32.00 0.00 0.00 64.00 -32.00 96.00 -32.00 0.00 0.00 33.00 32.00 64.00 64.00 32.00 32.00 0.00 0.00 32.00 -32.00 65.00 32.00 32.00 -32.00 32.00 64.00 32.00 65.00 64.00 64.00 32.00 32.00 -32.00 97.00 97.00 32.00 -32.00 64.00 32.00 32.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 32.00 65.00 -32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 32.00 32.00 32.00 -32.00 33.00 0.00 32.00 -64.00 32.00 0.00 64.00 64.00 97.00 -32.00 0.00 0.00 32.00 64.00 32.00 -64.00 0.00 0.00 32.00 32.00 32.00 32.00 -32.00 0.00 32.00 32.00 97.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 64.00 0.00 0.00 65.00 33.00 -33.00 32.00 0.00 0.00 33.00 -32.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 0.00 -64.00 32.00 0.00 0.00 -32.00 65.00 0.00 32.00 32.00 32.00 0.00 0.00 64.00 0.00 32.00 32.00 32.00 32.00 -32.00 0.00 32.00 32.00 -64.00 32.00 0.00 65.00 32.00 -65.00 0.00 -32.00 0.00 65.00 32.00 0.00 33.00 96.00 -33.00 0.00 33.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 64.00 32.00 0.00 65.00 33.00 32.00 0.00 32.00 32.00 -32.00 32.00 0.00 64.00 64.00 32.00 32.00 -32.00 32.00 32.00 65.00 0.00 32.00 33.00 32.00 -33.00 64.00 65.00 97.00 0.00 0.00 64.00 32.00 0.00 32.00 0.00 64.00 -32.00 33.00 0.00 -33.00 96.00 65.00 0.00 64.00 32.00 0.00 -32.00 0.00 -32.00 64.00 -64.00 -32.00 -64.00 32.00 0.00 32.00 0.00 0.00 -65.00 33.00 32.00 32.00 -32.00 32.00 0.00 32.00 65.00 32.00 32.00 32.00 0.00 33.00 0.00 64.00 -32.00 32.00 0.00 32.00 0.00 -32.00 64.00 32.00 32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 0.00 33.00 32.00 32.00 0.00 161.00 0.00 0.00 -64.00 64.00 -65.00 64.00 0.00 129.00 0.00 32.00 0.00 64.00 -32.00 129.00 -96.00 96.00 -97.00 97.00 -96.00 32.00 0.00 32.00 -64.00 64.00 0.00 33.00 0.00 -33.00 0.00 33.00 32.00 -33.00 64.00 -193.00 193.00 -128.00 193.00 -354.00 739.00 -128.00 225.00 -226.00 547.00 -257.00 547.00 -32.00 160.00 -129.00 193.00 -96.00 161.00 -64.00 97.00 -32.00 96.00 -33.00 64.00 -289.00 483.00 -96.00 128.00 -258.00 354.00 -193.00 289.00 -32.00 32.00 0.00 33.00 -32.00 64.00 -32.00 0.00 -96.00 161.00 -129.00 160.00 -64.00 97.00 -65.00 129.00 -64.00 128.00 -96.00 161.00 -65.00 32.00 -64.00 64.00 -64.00 65.00 0.00 96.00 0.00 32.00 -65.00 0.00 -32.00 65.00 -64.00 32.00 -64.00 96.00 -161.00 161.00 -225.00 321.00 -97.00 65.00 -96.00 128.00 -97.00 97.00 -64.00 96.00 -64.00 97.00 -65.00 0.00 -96.00 96.00 -96.00 161.00 -129.00 129.00 -64.00 0.00 -33.00 0.00 -64.00 0.00 -64.00 32.00 -161.00 96.00 -129.00 129.00 -96.00 32.00 -64.00 0.00 -65.00 -32.00 0.00 32.00 -160.00 -32.00 -226.00 -32.00 97.00 -225.00 32.00 -97.00 -32.00 -64.00 -257.00 64.00 64.00 129.00 -64.00 96.00 0.00 32.00 -32.00 0.00 -65.00 97.00 -32.00 32.00 -64.00 96.00 -32.00 33.00 -32.00 0.00 -129.00 96.00 -64.00 0.00 -65.00 64.00 -32.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 96.00 0.00 33.00 -96.00 32.00 -64.00 32.00 32.00 0.00 -65.00 32.00 -64.00 32.00 -128.00 65.00 -65.00 32.00 -32.00 64.00 -96.00 32.00 -97.00 64.00 0.00 33.00 -64.00 0.00 -65.00 32.00 -64.00 96.00 -64.00 225.00 0.00 32.00 -32.00 258.00 32.00 128.00 64.00 97.00 32.00 32.00 129.00 -97.00 32.00 33.00 32.00 64.00 -32.00 32.00 32.00 0.00 0.00 64.00 0.00 65.00 32.00 32.00 33.00 64.00 -33.00 32.00 33.00 32.00 -65.00 97.00 -64.00 -32.00 0.00 64.00 32.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 -96.00 65.00 0.00 64.00 -33.00 161.00 0.00 64.00 33.00 32.00 64.00 0.00 0.00 32.00 0.00 32.00 64.00 33.00 -32.00 32.00 0.00 96.00 64.00 0.00 33.00 -32.00 0.00 32.00 0.00 97.00 -33.00 64.00 -96.00 97.00 0.00 -33.00 -32.00 -64.00 -65.00 0.00 -64.00 64.00 -96.00 0.00 32.00 33.00 0.00 64.00 -32.00 32.00 -97.00 96.00 -32.00 129.00 0.00 193.00 64.00 193.00 65.00 96.00 96.00 161.00 0.00 32.00 64.00 32.00 33.00 97.00 0.00 128.00 0.00 33.00 -65.00 289.00 0.00 64.00 -32.00 161.00 -32.00 97.00 0.00 64.00 -96.00 289.00 -33.00 161.00 -32.00 96.00 0.00 97.00 0.00 32.00 -32.00 193.00 32.00 96.00 0.00 -32.00 32.00 32.00 0.00 65.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -64.00 129.00 0.00 129.00 -64.00 257.00 -32.00 257.00 -65.00 129.00 0.00 160.00 -32.00 129.00 -32.00 64.00 -64.00 322.00 0.00 193.00 0.00 128.00 0.00 226.00 64.00 128.00 64.00 32.00 32.00 0.00 33.00 -64.00 0.00 64.00 -33.00 0.00 0.00 97.00 -32.00 32.00 32.00 0.00 0.00 -32.00 33.00 0.00 0.00 193.00 0.00 193.00 32.00 192.00 32.00 97.00 0.00 64.00 64.00 193.00 0.00 482.00 0.00 547.00 0.00 129.00 0.00 96.00 32.00 193.00 -32.00 32.00 32.00 32.00 65.00 418.00 96.00 354.00 0.00 32.00 32.00 32.00 32.00 258.00 0.00 321.00 32.00 322.00 65.00 257.00 32.00 0.00 64.00 225.00 0.00 32.00 32.00 32.00 129.00 257.00 32.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 64.00 32.00 0.00 32.00 -32.00 33.00 -32.00 64.00 -96.00 161.00 -129.00 450.00 -97.00 225.00 -64.00 193.00 -32.00 32.00 0.00 129.00 0.00 64.00 32.00 96.00 -32.00 32.00 -32.00 97.00 -32.00 32.00 -32.00 96.00 -65.00 33.00 -96.00 128.00 0.00 32.00 -32.00 0.00 -32.00 129.00 0.00 32.00 64.00 -96.00 -64.00 161.00 32.00 128.00 32.00 32.00 32.00 0.00 0.00 32.00 -32.00 65.00 0.00 128.00 -64.00 32.00 -65.00 65.00 -96.00 161.00 0.00 96.00 -32.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 65.00 -32.00 32.00 0.00 64.00 -97.00 193.00 0.00 129.00 -32.00 160.00 0.00 65.00 0.00 96.00 -32.00 97.00 32.00 32.00 -64.00 64.00 0.00 129.00 0.00 96.00 -32.00 0.00 -33.00 32.00 -32.00 65.00 0.00 64.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 193.00 32.00 322.00 64.00 96.00 65.00 64.00 -65.00 33.00 -128.00 193.00 0.00 192.00 -97.00 161.00 0.00 193.00 32.00 32.00 -32.00 32.00 -32.00 65.00 0.00 128.00 -32.00 65.00 -64.00 32.00 -33.00 64.00 -32.00 129.00 0.00 353.00 0.00 65.00 -32.00 161.00 32.00 257.00 0.00 96.00 32.00 225.00 65.00 225.00 0.00 322.00 32.00 225.00 -32.00 32.00 0.00 64.00 32.00 193.00 225.00 322.00 32.00 0.00 -32.00 32.00 -225.00 193.00 32.00 96.00 -96.00 65.00 -33.00 64.00 -257.00 257.00 -32.00 65.00 0.00 64.00 32.00 32.00 -32.00 32.00 -257.00 129.00 -65.00 0.00 -32.00 -32.00 -64.00 32.00 -64.00 64.00 -32.00 0.00 -97.00 32.00 -225.00 129.00 -129.00 128.00 -96.00 129.00 -129.00 225.00 -128.00 257.00 -32.00 -32.00 -33.00 0.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 32.00 64.00 64.00 -32.00 -32.00 32.00 32.00 65.00 33.00 -33.00 -161.00 226.00 -225.00 418.00 0.00 64.00 -97.00 193.00 0.00 32.00 -32.00 129.00 32.00 32.00 -64.00 128.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 -64.00 -32.00 -1062.00 -676.00 -32.00 -32.00 -128.00 -96.00 -547.00 -354.00 -772.00 -482.00 0.00 -129.00 -64.00 -32.00 -96.00 -64.00 -32.00 -33.00 0.00 -32.00 257.00 -128.00 160.00 -225.00 0.00 -32.00 -32.00 -65.00 -64.00 -32.00 -32.00 32.00 32.00 -64.00 -32.00 -64.00 -64.00 -65.00 32.00 -64.00 -32.00 -64.00 32.00 -65.00 -65.00 -96.00 -64.00 0.00 -32.00 0.00 -32.00 -64.00 -97.00 32.00 -32.00 -32.00 -32.00 -97.00 -32.00 0.00 -32.00 -32.00 0.00 -96.00 -32.00 -33.00 -65.00 -32.00 -32.00 -32.00 32.00 -64.00 -64.00 -32.00 -32.00 -65.00 -32.00 -32.00 0.00 64.00 -33.00 97.00 -32.00 -64.00 -64.00 -97.00 -32.00 0.00 -64.00 64.00 -33.00 -64.00 -64.00 -32.00 0.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 -65.00 32.00 -32.00 -96.00 0.00 -64.00 64.00 -97.00 -64.00 -64.00 -161.00 -32.00 -32.00 -33.00 -32.00 33.00 -64.00 0.00 -97.00 -65.00 0.00 0.00 -64.00 -32.00 0.00 -64.00 -97.00 0.00 -32.00 0.00 -32.00 -161.00 -32.00 -64.00 -64.00 -65.00 -32.00 -96.00 32.00 -32.00 -32.00 -97.00 -65.00 129.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 64.00 -64.00 -64.00 -32.00 0.00 -65.00 64.00 0.00 0.00 -64.00 32.00 0.00 65.00 -96.00 128.00 -32.00 -96.00 -65.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 32.00 0.00 32.00 -32.00 -32.00 -96.00 64.00 -64.00 0.00 -65.00 -96.00 -32.00 -33.00 -161.00 65.00 -96.00 32.00 -193.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 0.00 -65.00 96.00 -193.00 0.00 -32.00 0.00 -32.00 32.00 -129.00 32.00 0.00 97.00 -96.00 64.00 -161.00 64.00 -128.00 0.00 -97.00 65.00 -32.00 96.00 0.00 0.00 32.00 32.00 32.00 65.00 0.00 32.00 0.00 64.00 32.00 32.00 0.00 32.00 -32.00 33.00 0.00 96.00 -32.00 32.00 -32.00 97.00 64.00 0.00 32.00 32.00 0.00 64.00 65.00 32.00 -32.00 32.00 0.00 65.00 -65.00 32.00 65.00 64.00 0.00 32.00 -65.00 0.00 -96.00 33.00 -32.00 0.00 -32.00 64.00 0.00 0.00 -33.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 -65.00 -32.00 -64.00 32.00 -32.00 -32.00 -129.00 0.00 -64.00 -32.00 -64.00 -32.00 64.00 -32.00 64.00 -161.00 65.00 -32.00 0.00 -97.00 32.00 -64.00 -32.00 -32.00 -33.00 -32.00 0.00 -65.00 65.00 -128.00 32.00 -161.00 32.00 -64.00 0.00 -32.00 64.00 -129.00 65.00 0.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 97.00 64.00 64.00 0.00 0.00 -32.00 32.00 32.00 97.00 32.00 64.00 0.00 0.00 -32.00 0.00 -64.00 -32.00 0.00 0.00 -97.00 -32.00 0.00 -33.00 -32.00 33.00 0.00 0.00 -64.00 32.00 0.00 32.00 -32.00 96.00 -97.00 65.00 -128.00 32.00 0.00 32.00 -65.00 32.00 -96.00 32.00 -65.00 32.00 65.00 -32.00 64.00 32.00 0.00 33.00 64.00 64.00 -32.00 32.00 -64.00 0.00 -64.00 64.00 0.00 33.00 -97.00 0.00 -32.00 32.00 -64.00 64.00 -161.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 65.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 33.00 -128.00 64.00 -33.00 32.00 -32.00 96.00 0.00 -32.00 -96.00 -32.00 -32.00 -32.00 -65.00 96.00 -128.00 0.00 -33.00 65.00 -32.00 0.00 -32.00 64.00 -32.00 32.00 -129.00 -32.00 -64.00 -32.00 0.00 -32.00 -64.00 32.00 0.00 32.00 32.00 32.00 0.00 0.00 -32.00 97.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 -65.00 0.00 0.00 -65.00 -32.00 -64.00 -64.00 -32.00 0.00 -64.00 -97.00 -97.00 -64.00 0.00 0.00 -32.00 64.00 -96.00 32.00 0.00 -32.00 0.00 -32.00 -33.00 -128.00 0.00 -33.00 0.00 0.00 65.00 -96.00 0.00 0.00 -65.00 -64.00 0.00 0.00 33.00 -33.00 0.00 0.00 -33.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -33.00 -32.00 33.00 0.00 -33.00 -32.00 -64.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 32.00 0.00 0.00 -64.00 0.00 32.00 32.00 -97.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 -33.00 -32.00 33.00 -65.00 0.00 -32.00 -65.00 32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -33.00 0.00 0.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 65.00 -32.00 0.00 -128.00 -32.00 0.00 -97.00 -65.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 -33.00 0.00 0.00 -32.00 -32.00 -64.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 -32.00 -64.00 32.00 -97.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 -64.00 32.00 -32.00 32.00 -32.00 -32.00 -64.00 0.00 -33.00 -32.00 0.00 32.00 -64.00 -64.00 0.00 32.00 -32.00 -32.00 -32.00 -129.00 -97.00 -96.00 -32.00 0.00 -32.00 -32.00 -64.00 96.00 -32.00 32.00 -33.00 -32.00 -32.00 -32.00 -64.00 32.00 -32.00 65.00 0.00 64.00 -97.00 0.00 -64.00 32.00 -64.00 0.00 -32.00 -64.00 32.00 -65.00 -129.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 0.00 -65.00 -96.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -64.00 -128.00 -97.00 -32.00 0.00 -33.00 -64.00 -96.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -64.00 32.00 -64.00 0.00 -32.00 64.00 32.00 65.00 -32.00 0.00 -32.00 32.00 -97.00 32.00 -64.00 -32.00 -32.00 -65.00 32.00 -64.00 -32.00 -64.00 -129.00 -65.00 0.00 -32.00 -64.00 0.00 0.00 32.00 0.00 97.00 -32.00 0.00 -33.00 64.00 -32.00 -32.00 -32.00 32.00 -129.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 -160.00 -64.00 0.00 -33.00 0.00 -32.00 0.00 -64.00 0.00 -64.00 -65.00 0.00 65.00 -32.00 32.00 -33.00 32.00 0.00 96.00 -32.00 0.00 -96.00 97.00 -129.00 0.00 -96.00 64.00 -97.00 -32.00 -96.00 96.00 -129.00 33.00 -32.00 0.00 -32.00 96.00 -32.00 32.00 -65.00 -32.00 -64.00 -32.00 -96.00 -32.00 -33.00 0.00 -96.00 -65.00 -96.00 0.00 -65.00 33.00 -96.00 32.00 -65.00 -65.00 -32.00 0.00 -64.00 33.00 -96.00 0.00 -33.00 0.00 -32.00 -515.00 -96.00 -675.00 0.00 -32.00 -129.00 -97.00 -354.00 -353.00 -450.00 -418.00 -1157.00 -1061.00 -32.00 0.00 -32.00 32.00 -129.00 32.00 -64.00 32.00 -65.00 0.00 -32.00 97.00 -64.00 32.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 0.00 0.00 64.00 -97.00 32.00 -128.00 -64.00 -64.00 0.00 -33.00 -32.00 -160.00 32.00 -193.00 64.00 -65.00 33.00 -32.00 0.00 -32.00 0.00 0.00 -97.00 -32.00 0.00 -32.00 -96.00 -65.00 -65.00 -64.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 -64.00 0.00 -33.00 -65.00 -32.00 0.00 0.00 65.00 -64.00 32.00 -32.00 -32.00 -64.00 32.00 -65.00 -32.00 -96.00 64.00 -65.00 64.00 -64.00 -64.00 -32.00 32.00 -32.00 -64.00 -129.00 -32.00 -32.00 -33.00 -32.00 -64.00 -32.00 0.00 -97.00 97.00 -64.00 -97.00 -32.00 -32.00 -97.00 32.00 -96.00 -64.00 -129.00 -32.00 32.00 -129.00 0.00 -64.00 -160.00 0.00 -97.00 -129.00 -96.00 -64.00 -32.00 0.00 -65.00 0.00 0.00 -64.00 -96.00 -33.00 -32.00 0.00 -65.00 -96.00 -32.00 -32.00 -32.00 -32.00 -64.00 -33.00 -65.00 65.00 -32.00 64.00 -64.00 -64.00 -97.00 -65.00 33.00 0.00 -33.00 0.00 -32.00 -64.00 0.00 32.00 -64.00 -64.00 -32.00 32.00 -32.00 -32.00 -65.00 -32.00 33.00 -32.00 -33.00 0.00 0.00 -32.00 -64.00 0.00 32.00 0.00 -64.00 32.00 0.00 -32.00 -64.00 -33.00 -65.00 -64.00 -32.00 -64.00 -161.00 -32.00 -64.00 -65.00 -129.00 -96.00 -32.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 -65.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -97.00 0.00 33.00 -32.00 -33.00 -33.00 0.00 0.00 -32.00 -32.00 -96.00 -32.00 -32.00 -64.00 0.00 -97.00 -65.00 -32.00 32.00 -96.00 -32.00 -32.00 32.00 -97.00 -64.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 -32.00 -64.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 -64.00 -65.00 -32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -64.00 -65.00 -97.00 0.00 -128.00 -64.00 0.00 32.00 -65.00 -32.00 -32.00 0.00 -32.00 32.00 -96.00 0.00 -33.00 0.00 -225.00 32.00 0.00 33.00 -32.00 32.00 -64.00 0.00 -32.00 -32.00 -65.00 32.00 -32.00 0.00 -32.00 32.00 -64.00 64.00 -64.00 0.00 -33.00 0.00 -128.00 65.00 -97.00 64.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -65.00 0.00 -32.00 32.00 32.00 65.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 64.00 64.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 -65.00 0.00 0.00 64.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 -64.00 0.00 -65.00 32.00 0.00 -32.00 -32.00 -161.00 -96.00 -32.00 -64.00 -65.00 0.00 -64.00 32.00 -32.00 0.00 -64.00 -32.00 -161.00 -33.00 -32.00 -32.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 -33.00 -33.00 -32.00 -32.00 -128.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -96.00 0.00 -193.00 -64.00 -65.00 0.00 -32.00 -33.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 64.00 0.00 -64.00 -32.00 64.00 -32.00 0.00 -65.00 -32.00 0.00 0.00 -96.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 32.00 -97.00 0.00 -32.00 32.00 -193.00 129.00 -289.00 32.00 -32.00 32.00 -97.00 64.00 -225.00 65.00 -64.00 0.00 -32.00 96.00 -129.00 -32.00 -32.00 -64.00 0.00 -33.00 -65.00 -32.00 33.00 0.00 -33.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 33.00 0.00 0.00 -32.00 -65.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -64.00 0.00 0.00 -64.00 0.00 32.00 -33.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -64.00 -32.00 0.00 0.00 64.00 0.00 -64.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 33.00 0.00 -33.00 -65.00 -32.00 32.00 0.00 -96.00 0.00 -32.00 0.00 0.00 32.00 -64.00 0.00 -33.00 65.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 33.00 -32.00 0.00 -33.00 0.00 0.00 -33.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 -33.00 96.00 -64.00 33.00 -32.00 -33.00 32.00 0.00 0.00 -64.00 -128.00 -32.00 0.00 64.00 -33.00 0.00 -64.00 -64.00 -96.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -64.00 -32.00 -33.00 0.00 33.00 0.00 32.00 -96.00 0.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -33.00 32.00 33.00 0.00 0.00 32.00 -33.00 -64.00 -96.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 -96.00 -64.00 -96.00 32.00 0.00 32.00 -65.00 0.00 32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -33.00 33.00 0.00 -33.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 -97.00 32.00 -64.00 64.00 -64.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 0.00 -33.00 -32.00 33.00 -65.00 0.00 -64.00 0.00 0.00 64.00 -64.00 -32.00 0.00 32.00 -33.00 0.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 -32.00 -32.00 32.00 -64.00 65.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 96.00 -32.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 65.00 32.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 64.00 -64.00 -64.00 0.00 32.00 -32.00 0.00 0.00 64.00 -33.00 0.00 0.00 64.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 65.00 -32.00 -33.00 0.00 65.00 -65.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -64.00 0.00 32.00 33.00 -32.00 32.00 -97.00 -32.00 0.00 32.00 65.00 32.00 -33.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 33.00 33.00 -65.00 0.00 -32.00 0.00 -32.00 32.00 0.00 64.00 0.00 32.00 -32.00 -32.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 -32.00 0.00 65.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 96.00 0.00 -32.00 0.00 32.00 -64.00 0.00 -32.00 32.00 -64.00 0.00 0.00 32.00 -33.00 0.00 0.00 32.00 -96.00 33.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 -64.00 64.00 32.00 32.00 -64.00 0.00 0.00 32.00 0.00 32.00 -64.00 -32.00 0.00 32.00 -193.00 65.00 0.00 64.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 -64.00 129.00 -64.00 96.00 -32.00 33.00 -33.00 0.00 -289.00 -33.00 -64.00 -32.00 32.00 -32.00 -64.00 32.00 0.00 32.00 -33.00 0.00 -32.00 0.00 0.00 33.00 -96.00 -33.00 -32.00 65.00 -65.00 32.00 0.00 64.00 -64.00 64.00 -32.00 -32.00 -32.00 32.00 -32.00 65.00 -32.00 -32.00 -33.00 64.00 -64.00 32.00 0.00 32.00 32.00 32.00 -64.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -33.00 -32.00 33.00 65.00 -33.00 64.00 -32.00 -32.00 -32.00 64.00 -96.00 0.00 0.00 32.00 0.00 32.00 -33.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 33.00 0.00 32.00 0.00 32.00 -32.00 0.00 -96.00 96.00 -97.00 65.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 -32.00 65.00 -65.00 32.00 33.00 0.00 -33.00 32.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -96.00 64.00 -65.00 -64.00 -64.00 32.00 -32.00 0.00 -64.00 -64.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -64.00 0.00 0.00 32.00 -97.00 97.00 0.00 32.00 -32.00 -32.00 0.00 64.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 97.00 -32.00 32.00 -65.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 96.00 0.00 -32.00 -32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 65.00 -65.00 96.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -64.00 0.00 0.00 33.00 -33.00 -33.00 0.00 33.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 -32.00 -32.00 32.00 -64.00 0.00 -33.00 0.00 -64.00 0.00 -64.00 -32.00 -64.00 32.00 -65.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 65.00 -32.00 0.00 -33.00 32.00 -64.00 0.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -225.00 -129.00 -161.00 33.00 -64.00 64.00 0.00 96.00 -65.00 0.00 33.00 32.00 -33.00 97.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -97.00 0.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 65.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 32.00 32.00 -129.00 32.00 -32.00 -64.00 0.00 -32.00 -32.00 32.00 -32.00 -64.00 0.00 -97.00 -97.00 -64.00 0.00 -64.00 97.00 0.00 32.00 -32.00 64.00 0.00 0.00 -33.00 65.00 0.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -33.00 32.00 -64.00 64.00 -32.00 0.00 -64.00 65.00 -33.00 0.00 -64.00 32.00 -32.00 161.00 -161.00 0.00 -161.00 0.00 -32.00 32.00 -32.00 0.00 -128.00 0.00 -97.00 -97.00 -32.00 -32.00 -64.00 -64.00 0.00 32.00 -129.00 -97.00 -96.00 -64.00 0.00 0.00 -33.00 32.00 -96.00 -64.00 -97.00 -32.00 0.00 0.00 -32.00 64.00 -32.00 64.00 -32.00 0.00 -32.00 33.00 -32.00 32.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 -32.00 0.00 -97.00 0.00 -64.00 32.00 0.00 0.00 -96.00 0.00 -33.00 -32.00 0.00 -65.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 65.00 0.00 0.00 -32.00 0.00 32.00 32.00 0.00 64.00 -32.00 0.00 -64.00 -32.00 -32.00 64.00 -64.00 0.00 -33.00 -96.00 -96.00 64.00 -32.00 32.00 -97.00 -32.00 -32.00 -32.00 0.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 64.00 32.00 33.00 -32.00 -33.00 -33.00 -64.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 -64.00 -64.00 -32.00 -32.00 32.00 -64.00 32.00 -33.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 64.00 96.00 97.00 32.00 32.00 -32.00 32.00 0.00 64.00 -64.00 65.00 0.00 32.00 -32.00 0.00 -97.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 -32.00 -32.00 -64.00 0.00 -65.00 -32.00 -32.00 -64.00 -32.00 -33.00 -32.00 -192.00 -64.00 -33.00 -97.00 0.00 32.00 -64.00 -32.00 -32.00 -64.00 0.00 -32.00 32.00 -33.00 0.00 0.00 -32.00 -32.00 -64.00 -64.00 0.00 -96.00 -65.00 64.00 -128.00 -64.00 -65.00 -65.00 33.00 -64.00 32.00 -32.00 0.00 0.00 -65.00 -97.00 0.00 33.00 -96.00 -33.00 -64.00 -64.00 -33.00 -96.00 33.00 -161.00 -33.00 -65.00 -32.00 0.00 -96.00 0.00 -32.00 -64.00 0.00 -96.00 -65.00 -97.00 0.00 -64.00 -32.00 64.00 -64.00 32.00 32.00 33.00 0.00 64.00 -96.00 -32.00 -65.00 -32.00 0.00 -33.00 0.00 97.00 -64.00 64.00 -129.00 32.00 -32.00 -64.00 -64.00 32.00 -96.00 -32.00 -33.00 -64.00 -32.00 -161.00 -96.00 32.00 -97.00 0.00 -128.00 129.00 -225.00 0.00 -33.00 0.00 -32.00 -65.00 -64.00 -96.00 0.00 0.00 -32.00 32.00 -64.00 -96.00 -65.00 32.00 -32.00 225.00 -64.00 32.00 -32.00 -64.00 -129.00 -97.00 32.00 -64.00 -32.00 0.00 -32.00 129.00 -97.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 -65.00 -32.00 -32.00 -32.00 32.00 -32.00 65.00 -129.00 64.00 -64.00 32.00 0.00 32.00 -65.00 129.00 -64.00 128.00 -129.00 -32.00 -32.00 -96.00 -96.00 -129.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -64.00 32.00 -65.00 -32.00 -64.00 64.00 -64.00 32.00 -65.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 96.00 -32.00 0.00 -32.00 -64.00 -97.00 -32.00 -64.00 -64.00 32.00 0.00 -32.00 0.00 -32.00 96.00 -65.00 32.00 -64.00 97.00 -32.00 96.00 -32.00 97.00 -32.00 96.00 -33.00 32.00 -32.00 65.00 -32.00 64.00 -128.00 64.00 -33.00 161.00 -96.00 32.00 -129.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 -161.00 64.00 -64.00 32.00 -65.00 0.00 -32.00 32.00 -193.00 129.00 -161.00 32.00 -64.00 -32.00 -96.00 97.00 -129.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 -97.00 0.00 -64.00 -33.00 0.00 -96.00 -64.00 64.00 -97.00 0.00 -64.00 0.00 -64.00 -128.00 0.00 0.00 -32.00 32.00 -33.00 32.00 -96.00 0.00 -64.00 64.00 -33.00 0.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 64.00 -32.00 -32.00 -65.00 64.00 -32.00 0.00 -96.00 -32.00 -32.00 -32.00 0.00 -32.00 -65.00 -32.00 -64.00 96.00 -96.00 32.00 -65.00 33.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 0.00 -64.00 96.00 -32.00 32.00 -32.00 33.00 0.00 32.00 0.00 64.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 33.00 -32.00 96.00 -33.00 32.00 -32.00 65.00 0.00 64.00 -64.00 64.00 -32.00 65.00 -129.00 0.00 -64.00 -65.00 -32.00 -64.00 -32.00 -225.00 96.00 -65.00 0.00 -96.00 64.00 -225.00 -32.00 -32.00 0.00 -32.00 64.00 -97.00 33.00 32.00 -161.00 0.00 -64.00 33.00 -65.00 32.00 -64.00 -65.00 -96.00 97.00 -65.00 64.00 -64.00 -32.00 -64.00 -32.00 -33.00 -32.00 -32.00 0.00 -64.00 0.00 -64.00 32.00 -33.00 0.00 -64.00 -32.00 -64.00 64.00 -32.00 0.00 -129.00 -32.00 -32.00 -64.00 -32.00 0.00 -32.00 -33.00 0.00 65.00 -97.00 64.00 -32.00 64.00 -64.00 -32.00 -65.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 64.00 -161.00 -32.00 -64.00 32.00 -32.00 32.00 -32.00 32.00 -97.00 32.00 -32.00 32.00 0.00 97.00 -32.00 128.00 -32.00 193.00 0.00 33.00 -97.00 -33.00 -64.00 33.00 -64.00 -33.00 -65.00 -96.00 33.00 -225.00 96.00 -129.00 -32.00 0.00 -161.00 32.00 -64.00 0.00 -32.00 -32.00 -65.00 -64.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 33.00 -32.00 -33.00 -64.00 -96.00 -64.00 -32.00 0.00 -65.00 -32.00 -32.00 -65.00 -32.00 32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 129.00 -32.00 0.00 -33.00 -32.00 0.00 -97.00 -32.00 -32.00 0.00 -97.00 -32.00 33.00 -64.00 32.00 -32.00 -65.00 -97.00 -32.00 0.00 65.00 -32.00 32.00 -96.00 -32.00 -33.00 0.00 -64.00 -97.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -33.00 64.00 -32.00 0.00 -32.00 33.00 -96.00 0.00 -65.00 32.00 -64.00 -32.00 -64.00 -65.00 -32.00 0.00 -33.00 -32.00 -64.00 64.00 -32.00 -32.00 -32.00 0.00 -32.00 -64.00 -65.00 0.00 -64.00 64.00 -32.00 32.00 0.00 0.00 -64.00 97.00 -97.00 64.00 -32.00 32.00 -32.00 33.00 -65.00 128.00 -32.00 65.00 0.00 192.00 -32.00 161.00 -64.00 97.00 0.00 96.00 -97.00 0.00 -64.00 -32.00 -64.00 -32.00 0.00 -65.00 0.00 -64.00 64.00 -128.00 32.00 -65.00 -32.00 -64.00 -32.00 -96.00 -32.00 -129.00 64.00 -64.00 0.00 -65.00 -64.00 -32.00 -32.00 -64.00 32.00 -65.00 -97.00 33.00 -64.00 -33.00 -64.00 33.00 -32.00 64.00 32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 64.00 -32.00 33.00 -64.00 -33.00 -32.00 0.00 -32.00 65.00 -33.00 0.00 -32.00 -65.00 -32.00 -64.00 -64.00 -96.00 32.00 -33.00 -32.00 65.00 -32.00 161.00 -65.00 96.00 -160.00 64.00 -33.00 0.00 -64.00 -32.00 -96.00 -32.00 -33.00 -32.00 -64.00 0.00 -64.00 64.00 -32.00 65.00 32.00 64.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 161.00 96.00 161.00 64.00 64.00 -32.00 97.00 32.00 96.00 -32.00 225.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 -32.00 0.00 -97.00 -33.00 -32.00 -32.00 -64.00 32.00 -97.00 0.00 -32.00 -64.00 -64.00 32.00 -32.00 32.00 -65.00 -32.00 -64.00 -32.00 -32.00 -64.00 0.00 -32.00 -64.00 -65.00 -65.00 0.00 -64.00 -32.00 -32.00 0.00 -96.00 -32.00 -129.00 -64.00 -161.00 32.00 -64.00 -32.00 -97.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 -65.00 -96.00 -32.00 -64.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 -64.00 -96.00 -32.00 -33.00 -32.00 -32.00 -33.00 -32.00 -96.00 0.00 -161.00 0.00 -32.00 -96.00 -64.00 0.00 -32.00 0.00 -129.00 -65.00 -32.00 -32.00 0.00 -96.00 -32.00 -65.00 -97.00 -32.00 -128.00 0.00 -65.00z"},pi:{name:"PI",path:"M138535.00 77489.00l-32.00 -193.00 32.00 -64.00 0.00 -65.00 65.00 0.00 32.00 0.00 32.00 -96.00 32.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 -96.00 33.00 -96.00 32.00 -33.00 64.00 -192.00 -64.00 -65.00 32.00 0.00 0.00 -64.00 32.00 -129.00 0.00 -32.00 64.00 -64.00 0.00 -65.00 32.00 -96.00 0.00 -32.00 33.00 -64.00 -33.00 -97.00 -32.00 -32.00 -32.00 -32.00 0.00 -129.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 -97.00 0.00 -32.00 32.00 -128.00 0.00 -33.00 33.00 -32.00 64.00 -32.00 32.00 -96.00 0.00 -33.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 -64.00 0.00 -33.00 -32.00 -32.00 32.00 -32.00 -64.00 -32.00 64.00 -97.00 -32.00 -128.00 32.00 -97.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 -64.00 -32.00 -32.00 -32.00 -33.00 32.00 -32.00 -32.00 -64.00 0.00 -64.00 64.00 -65.00 -32.00 -64.00 64.00 -32.00 0.00 -32.00 32.00 -97.00 65.00 -32.00 0.00 -32.00 64.00 -32.00 -32.00 -64.00 32.00 -33.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -65.00 0.00 -32.00 -97.00 -128.00 -32.00 -65.00 -64.00 -64.00 -33.00 -32.00 -64.00 0.00 -64.00 -32.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 33.00 -65.00 -33.00 0.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 -64.00 0.00 -33.00 64.00 0.00 0.00 -64.00 -32.00 -64.00 0.00 -64.00 32.00 -97.00 -32.00 0.00 0.00 -96.00 -32.00 -97.00 32.00 0.00 32.00 -32.00 -64.00 -64.00 -32.00 -33.00 -32.00 -96.00 -32.00 -32.00 0.00 -129.00 0.00 -64.00 32.00 0.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 -33.00 -32.00 33.00 -64.00 -33.00 -65.00 0.00 -64.00 -96.00 -64.00 -32.00 -97.00 -65.00 -64.00 0.00 -32.00 -32.00 -97.00 -32.00 -64.00 64.00 -64.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 65.00 -32.00 -32.00 -32.00 32.00 -33.00 32.00 -64.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 -64.00 -33.00 -32.00 -32.00 32.00 -64.00 64.00 -32.00 33.00 -64.00 0.00 -33.00 32.00 0.00 96.00 -96.00 64.00 32.00 33.00 -128.00 64.00 -33.00 64.00 0.00 -32.00 -64.00 64.00 -32.00 65.00 0.00 96.00 -225.00 32.00 -32.00 -32.00 -33.00 32.00 -96.00 32.00 -64.00 33.00 0.00 0.00 -32.00 96.00 32.00 64.00 -65.00 -128.00 -64.00 0.00 -32.00 128.00 -96.00 32.00 -33.00 0.00 -64.00 33.00 -32.00 -33.00 -64.00 33.00 -33.00 64.00 -96.00 -32.00 -32.00 32.00 -97.00 -32.00 -128.00 32.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 -32.00 -32.00 65.00 -33.00 32.00 0.00 32.00 -32.00 -32.00 -64.00 64.00 -32.00 0.00 -32.00 0.00 -97.00 64.00 -64.00 0.00 -97.00 65.00 -64.00 0.00 -193.00 257.00 -225.00 -32.00 -64.00 32.00 -32.00 32.00 -65.00 64.00 0.00 32.00 -64.00 -32.00 -96.00 32.00 -65.00 33.00 -64.00 -33.00 -64.00 65.00 -129.00 0.00 -96.00 32.00 -33.00 -64.00 -96.00 64.00 -64.00 32.00 0.00 32.00 0.00 0.00 -32.00 -96.00 -65.00 64.00 -96.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 33.00 0.00 64.00 -33.00 0.00 -32.00 -97.00 -64.00 97.00 -32.00 0.00 -32.00 -64.00 -33.00 -33.00 -64.00 33.00 0.00 32.00 -32.00 0.00 -64.00 64.00 -32.00 32.00 -65.00 -32.00 -96.00 64.00 -32.00 0.00 -65.00 32.00 32.00 33.00 -32.00 -33.00 -32.00 33.00 -64.00 -33.00 -64.00 33.00 -33.00 0.00 33.00 32.00 0.00 0.00 -33.00 -32.00 -64.00 32.00 -64.00 64.00 -32.00 0.00 -33.00 0.00 -64.00 32.00 0.00 65.00 -32.00 -65.00 -32.00 0.00 -32.00 32.00 0.00 65.00 32.00 32.00 0.00 -32.00 -64.00 32.00 -33.00 64.00 0.00 32.00 -32.00 0.00 -32.00 32.00 0.00 33.00 -32.00 0.00 -64.00 32.00 -65.00 32.00 0.00 64.00 32.00 129.00 -128.00 32.00 -64.00 64.00 -33.00 97.00 0.00 32.00 0.00 64.00 -32.00 97.00 32.00 64.00 -64.00 32.00 -32.00 32.00 0.00 65.00 32.00 0.00 32.00 32.00 0.00 64.00 -64.00 96.00 -32.00 33.00 -97.00 96.00 -64.00 32.00 32.00 65.00 0.00 32.00 -32.00 193.00 -64.00 96.00 32.00 32.00 0.00 65.00 32.00 128.00 -96.00 64.00 0.00 65.00 -65.00 32.00 0.00 64.00 0.00 65.00 -32.00 96.00 -32.00 32.00 32.00 32.00 -32.00 32.00 -64.00 33.00 -65.00 32.00 -64.00 32.00 -32.00 64.00 32.00 65.00 -32.00 32.00 -64.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 129.00 -64.00 32.00 -64.00 128.00 32.00 32.00 32.00 193.00 -64.00 65.00 128.00 64.00 32.00 32.00 0.00 32.00 0.00 65.00 0.00 32.00 -160.00 32.00 -33.00 32.00 -128.00 32.00 0.00 65.00 -32.00 32.00 -33.00 96.00 -32.00 97.00 -161.00 0.00 -32.00 96.00 -64.00 32.00 -32.00 32.00 -97.00 161.00 -32.00 32.00 0.00 33.00 -128.00 64.00 -65.00 64.00 0.00 0.00 -32.00 129.00 -64.00 128.00 -32.00 97.00 -97.00 64.00 -64.00 97.00 -32.00 64.00 0.00 161.00 -65.00 96.00 65.00 32.00 0.00 97.00 -161.00 64.00 -64.00 0.00 -32.00 -32.00 -97.00 32.00 -64.00 32.00 -64.00 0.00 -97.00 64.00 0.00 65.00 0.00 161.00 -193.00 0.00 -129.00 64.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -96.00 0.00 -32.00 65.00 -97.00 128.00 -64.00 32.00 -97.00 32.00 -32.00 33.00 0.00 0.00 97.00 32.00 0.00 32.00 0.00 32.00 -65.00 -96.00 -128.00 0.00 -32.00 0.00 -33.00 32.00 0.00 96.00 0.00 64.00 97.00 33.00 0.00 32.00 -64.00 0.00 -129.00 32.00 -64.00 64.00 0.00 32.00 -33.00 225.00 -32.00 65.00 -64.00 64.00 0.00 64.00 32.00 0.00 64.00 65.00 33.00 32.00 0.00 32.00 -65.00 32.00 -32.00 161.00 32.00 129.00 -96.00 160.00 -32.00 32.00 -65.00 33.00 -32.00 32.00 -32.00 96.00 64.00 65.00 -64.00 32.00 0.00 128.00 0.00 65.00 -32.00 32.00 0.00 0.00 32.00 32.00 32.00 129.00 -32.00 64.00 32.00 96.00 32.00 97.00 97.00 96.00 32.00 65.00 64.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 97.00 33.00 32.00 160.00 64.00 33.00 33.00 32.00 64.00 32.00 64.00 128.00 65.00 0.00 -33.00 65.00 -32.00 96.00 32.00 64.00 0.00 65.00 -32.00 32.00 0.00 0.00 -96.00 129.00 32.00 64.00 -129.00 193.00 32.00 128.00 -32.00 97.00 -64.00 32.00 -64.00 32.00 0.00 193.00 -33.00 161.00 33.00 96.00 64.00 32.00 0.00 65.00 0.00 128.00 -64.00 97.00 -97.00 96.00 0.00 65.00 64.00 64.00 0.00 129.00 -32.00 32.00 0.00 64.00 -64.00 32.00 -129.00 161.00 -64.00 129.00 -161.00 32.00 -96.00 0.00 -32.00 0.00 -32.00 32.00 -193.00 96.00 -129.00 0.00 -64.00 0.00 -97.00 65.00 -128.00 -65.00 -32.00 0.00 -33.00 32.00 -32.00 65.00 -32.00 -32.00 -96.00 32.00 -97.00 -65.00 -96.00 0.00 -32.00 97.00 -161.00 0.00 -97.00 32.00 -32.00 96.00 -96.00 0.00 -32.00 -32.00 -33.00 -64.00 33.00 -32.00 -33.00 32.00 -96.00 32.00 -129.00 -32.00 -64.00 0.00 -64.00 -32.00 -32.00 -32.00 -65.00 0.00 -32.00 -32.00 0.00 -97.00 -32.00 -96.00 -32.00 -97.00 -129.00 -96.00 0.00 -65.00 -64.00 -32.00 -32.00 -32.00 -193.00 0.00 -32.00 -64.00 -32.00 -64.00 -33.00 -129.00 0.00 -64.00 -64.00 -33.00 -129.00 -96.00 -96.00 0.00 -32.00 32.00 -32.00 64.00 -32.00 0.00 -33.00 33.00 -32.00 0.00 -32.00 0.00 -96.00 -33.00 -33.00 -64.00 -64.00 -64.00 -64.00 0.00 -64.00 -32.00 -129.00 -32.00 -32.00 0.00 -65.00 96.00 -160.00 -96.00 -193.00 32.00 -97.00 -32.00 -64.00 -33.00 -161.00 33.00 -64.00 0.00 -32.00 96.00 0.00 0.00 -65.00 -64.00 -225.00 32.00 -160.00 0.00 -32.00 -32.00 -33.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 -65.00 161.00 -32.00 64.00 0.00 32.00 -64.00 32.00 -97.00 97.00 -64.00 32.00 -193.00 96.00 -96.00 0.00 -32.00 32.00 -129.00 33.00 -32.00 128.00 -32.00 65.00 -65.00 32.00 -128.00 32.00 -32.00 128.00 -33.00 65.00 -32.00 0.00 -64.00 128.00 -64.00 65.00 -32.00 32.00 -65.00 32.00 -160.00 0.00 -65.00 0.00 -32.00 -64.00 -161.00 0.00 -64.00 128.00 -161.00 0.00 -96.00 -32.00 -161.00 -32.00 -96.00 -32.00 -193.00 -65.00 -97.00 -32.00 0.00 0.00 -64.00 0.00 -129.00 -96.00 -225.00 0.00 -64.00 32.00 -161.00 -64.00 -64.00 0.00 -32.00 -129.00 -129.00 0.00 -32.00 0.00 -129.00 -32.00 -96.00 -161.00 -161.00 -32.00 0.00 -32.00 -96.00 0.00 -97.00 96.00 -96.00 33.00 -65.00 0.00 -64.00 -97.00 -64.00 -32.00 -32.00 -32.00 -65.00 32.00 -64.00 64.00 -64.00 65.00 -33.00 0.00 -32.00 32.00 -32.00 160.00 -225.00 33.00 -64.00 32.00 -64.00 0.00 -33.00 -32.00 -128.00 64.00 -97.00 0.00 -96.00 32.00 0.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 -96.00 -64.00 -33.00 -64.00 33.00 -129.00 -65.00 -64.00 -193.00 -129.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -64.00 0.00 0.00 -32.00 0.00 -129.00 0.00 -96.00 -97.00 -161.00 0.00 -64.00 -32.00 -161.00 0.00 -96.00 32.00 -97.00 193.00 -225.00 32.00 -32.00 32.00 -32.00 193.00 0.00 0.00 -32.00 -96.00 -65.00 32.00 -64.00 32.00 -32.00 97.00 -32.00 64.00 -65.00 0.00 -96.00 64.00 -193.00 32.00 -32.00 65.00 -193.00 64.00 0.00 32.00 32.00 32.00 0.00 32.00 -96.00 33.00 -97.00 225.00 -161.00 64.00 -64.00 0.00 -96.00 0.00 -32.00 0.00 -65.00 193.00 -321.00 32.00 -32.00 32.00 -33.00 -32.00 -64.00 -32.00 -96.00 32.00 -32.00 32.00 -65.00 0.00 -64.00 -64.00 -129.00 0.00 -32.00 0.00 -32.00 32.00 -64.00 96.00 -97.00 97.00 -128.00 64.00 0.00 32.00 -65.00 0.00 -32.00 33.00 -96.00 96.00 -65.00 64.00 -32.00 65.00 -64.00 128.00 -161.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -65.00 97.00 -64.00 0.00 -96.00 32.00 -65.00 32.00 32.00 32.00 0.00 0.00 97.00 65.00 64.00 32.00 0.00 32.00 0.00 64.00 -32.00 65.00 -96.00 32.00 0.00 32.00 0.00 0.00 64.00 32.00 32.00 64.00 -32.00 33.00 -64.00 0.00 -65.00 96.00 32.00 64.00 0.00 129.00 -96.00 32.00 32.00 129.00 64.00 32.00 0.00 64.00 -32.00 161.00 -64.00 161.00 32.00 32.00 -32.00 0.00 32.00 32.00 -64.00 -32.00 -97.00 64.00 -32.00 0.00 -32.00 161.00 -32.00 64.00 -129.00 64.00 -32.00 0.00 -32.00 0.00 -64.00 33.00 -65.00 32.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -129.00 0.00 0.00 -65.00 32.00 -32.00 65.00 -64.00 161.00 0.00 64.00 -32.00 161.00 -32.00 96.00 0.00 64.00 -32.00 65.00 -97.00 32.00 0.00 0.00 -32.00 32.00 -97.00 32.00 -64.00 32.00 0.00 65.00 32.00 32.00 0.00 0.00 -161.00 0.00 -32.00 64.00 -64.00 0.00 -96.00 0.00 -33.00 32.00 -32.00 65.00 -32.00 64.00 -32.00 96.00 -129.00 32.00 -64.00 129.00 -96.00 64.00 -32.00 33.00 -161.00 0.00 -32.00 96.00 -97.00 -32.00 -96.00 -32.00 -33.00 -129.00 -96.00 -32.00 -32.00 -64.00 -97.00 -65.00 -64.00 32.00 -128.00 0.00 -97.00 97.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 -160.00 96.00 -97.00 65.00 -64.00 64.00 32.00 64.00 129.00 161.00 128.00 96.00 32.00 33.00 0.00 192.00 193.00 129.00 65.00 0.00 32.00 129.00 96.00 193.00 97.00 32.00 0.00 96.00 -32.00 32.00 0.00 97.00 64.00 128.00 0.00 65.00 -64.00 64.00 0.00 161.00 32.00 32.00 32.00 32.00 -32.00 64.00 32.00 97.00 -32.00 128.00 64.00 33.00 0.00 128.00 64.00 32.00 -32.00 33.00 0.00 0.00 129.00 32.00 0.00 0.00 32.00 96.00 64.00 64.00 0.00 65.00 0.00 0.00 65.00 64.00 96.00 0.00 64.00 32.00 65.00 -32.00 0.00 32.00 32.00 -32.00 64.00 0.00 32.00 -32.00 65.00 32.00 0.00 0.00 96.00 -64.00 32.00 0.00 32.00 -65.00 0.00 0.00 65.00 -64.00 64.00 -96.00 96.00 -32.00 65.00 0.00 96.00 -290.00 515.00 -64.00 160.00 0.00 32.00 -64.00 65.00 0.00 64.00 -33.00 64.00 0.00 33.00 97.00 -33.00 0.00 65.00 0.00 96.00 32.00 0.00 32.00 65.00 161.00 0.00 32.00 0.00 0.00 32.00 0.00 96.00 0.00 64.00 64.00 65.00 33.00 128.00 0.00 32.00 64.00 -32.00 64.00 0.00 -96.00 32.00 -32.00 33.00 0.00 160.00 -65.00 97.00 -128.00 0.00 0.00 32.00 -33.00 32.00 0.00 32.00 65.00 33.00 64.00 32.00 64.00 160.00 -32.00 225.00 -32.00 33.00 32.00 32.00 65.00 32.00 96.00 0.00 64.00 0.00 65.00 64.00 96.00 0.00 97.00 65.00 0.00 32.00 -65.00 0.00 -32.00 32.00 -32.00 161.00 64.00 64.00 -64.00 96.00 -161.00 161.00 0.00 32.00 64.00 -64.00 0.00 32.00 33.00 0.00 32.00 97.00 0.00 32.00 32.00 32.00 32.00 32.00 0.00 32.00 32.00 65.00 32.00 64.00 65.00 64.00 64.00 129.00 -64.00 161.00 -32.00 0.00 0.00 32.00 -33.00 0.00 0.00 32.00 -32.00 32.00 32.00 64.00 33.00 65.00 -97.00 64.00 0.00 32.00 32.00 0.00 65.00 -32.00 64.00 -32.00 64.00 0.00 64.00 -32.00 33.00 32.00 32.00 -32.00 0.00 32.00 64.00 32.00 32.00 0.00 97.00 32.00 96.00 0.00 32.00 32.00 0.00 32.00 -64.00 65.00 32.00 64.00 -64.00 193.00 -32.00 32.00 64.00 97.00 0.00 64.00 64.00 32.00 129.00 32.00 -64.00 64.00 -161.00 258.00 64.00 386.00 0.00 64.00 0.00 32.00 -64.00 32.00 -64.00 129.00 -65.00 64.00 0.00 32.00 0.00 129.00 -64.00 128.00 0.00 33.00 0.00 128.00 -64.00 97.00 0.00 128.00 -65.00 65.00 -32.00 96.00 -32.00 0.00 -32.00 97.00 -64.00 0.00 -33.00 0.00 33.00 32.00 64.00 0.00 0.00 32.00 0.00 32.00 -32.00 96.00 0.00 65.00 128.00 64.00 97.00 129.00 32.00 32.00 -129.00 161.00 -128.00 128.00 -32.00 65.00 0.00 32.00 -65.00 32.00 0.00 32.00 65.00 32.00 128.00 32.00 0.00 32.00 -64.00 33.00 -32.00 96.00 0.00 32.00 -65.00 32.00 33.00 161.00 -65.00 64.00 97.00 129.00 -32.00 64.00 64.00 97.00 0.00 64.00 32.00 0.00 32.00 0.00 0.00 32.00 32.00 32.00 32.00 -64.00 65.00 32.00 161.00 225.00 32.00 -32.00 32.00 0.00 0.00 64.00 64.00 33.00 0.00 96.00 -32.00 129.00 161.00 0.00 0.00 64.00 32.00 0.00 0.00 32.00 32.00 32.00 0.00 65.00 129.00 64.00 64.00 -64.00 32.00 0.00 32.00 96.00 65.00 -32.00 0.00 96.00 128.00 65.00 32.00 96.00 33.00 -32.00 32.00 0.00 64.00 96.00 64.00 0.00 32.00 0.00 33.00 65.00 -33.00 96.00 33.00 129.00 -97.00 64.00 97.00 64.00 32.00 0.00 32.00 65.00 -64.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 64.00 32.00 0.00 64.00 -32.00 96.00 -65.00 33.00 -32.00 96.00 32.00 32.00 65.00 97.00 32.00 64.00 -32.00 32.00 -97.00 0.00 -32.00 32.00 0.00 32.00 32.00 65.00 32.00 32.00 33.00 32.00 32.00 64.00 0.00 33.00 -65.00 64.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 65.00 -32.00 32.00 32.00 64.00 0.00 64.00 97.00 65.00 0.00 128.00 32.00 65.00 32.00 64.00 -32.00 129.00 -32.00 64.00 -97.00 32.00 -32.00 32.00 32.00 64.00 33.00 129.00 64.00 96.00 -32.00 65.00 32.00 128.00 32.00 129.00 -32.00 161.00 32.00 96.00 64.00 161.00 -32.00 96.00 97.00 97.00 0.00 257.00 -33.00 97.00 -32.00 32.00 0.00 32.00 -64.00 64.00 0.00 97.00 0.00 32.00 0.00 32.00 96.00 -32.00 65.00 64.00 64.00 225.00 64.00 129.00 -32.00 96.00 0.00 65.00 0.00 32.00 0.00 32.00 0.00 128.00 0.00 97.00 129.00 161.00 64.00 161.00 32.00 32.00 65.00 32.00 32.00 32.00 0.00 64.00 0.00 65.00 0.00 32.00 -32.00 160.00 -65.00 33.00 0.00 64.00 33.00 161.00 0.00 161.00 0.00 64.00 32.00 128.00 0.00 65.00 0.00 64.00 193.00 193.00 64.00 161.00 0.00 32.00 64.00 64.00 0.00 32.00 -64.00 129.00 32.00 32.00 96.00 97.00 258.00 0.00 96.00 96.00 97.00 64.00 32.00 32.00 193.00 33.00 225.00 32.00 128.00 0.00 65.00 32.00 32.00 32.00 64.00 64.00 0.00 32.00 32.00 97.00 33.00 32.00 32.00 97.00 32.00 32.00 64.00 0.00 64.00 -65.00 65.00 -32.00 96.00 32.00 0.00 33.00 -64.00 64.00 -32.00 32.00 -65.00 64.00 -32.00 65.00 -32.00 0.00 -64.00 32.00 0.00 128.00 -32.00 65.00 64.00 160.00 -32.00 65.00 0.00 225.00 96.00 32.00 0.00 32.00 -96.00 32.00 0.00 33.00 -32.00 -33.00 0.00 65.00 32.00 0.00 0.00 32.00 -64.00 64.00 0.00 32.00 -65.00 129.00 -64.00 32.00 0.00 32.00 -97.00 129.00 33.00 64.00 -65.00 193.00 0.00 64.00 -32.00 33.00 -32.00 160.00 -32.00 257.00 32.00 129.00 -32.00 64.00 -129.00 65.00 32.00 64.00 -64.00 257.00 -482.00 193.00 -32.00 64.00 -65.00 33.00 -161.00 32.00 -32.00 64.00 0.00 64.00 97.00 258.00 32.00 32.00 161.00 193.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 64.00 0.00 97.00 0.00 32.00 -97.00 193.00 -64.00 193.00 32.00 193.00 97.00 96.00 128.00 32.00 258.00 97.00 32.00 0.00 32.00 32.00 64.00 64.00 0.00 33.00 32.00 96.00 0.00 64.00 -32.00 386.00 0.00 32.00 0.00 65.00 -161.00 289.00 -32.00 96.00 -64.00 161.00 -32.00 129.00 32.00 64.00 32.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 -161.00 -64.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -64.00 0.00 -33.00 32.00 0.00 65.00 -32.00 32.00 -64.00 0.00 -32.00 64.00 -32.00 32.00 -33.00 64.00 0.00 33.00 -96.00 0.00 -32.00 32.00 -32.00 32.00 -97.00 32.00 -32.00 32.00 -64.00 32.00 32.00 129.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 0.00 65.00 -129.00 32.00 0.00 32.00 -32.00 32.00 32.00 129.00 -96.00 96.00 -97.00 0.00 0.00 -32.00 -32.00 -64.00 -32.00 -32.00 -97.00 0.00 -32.00 64.00 32.00 0.00 0.00 96.00 -32.00 0.00 -32.00 33.00 0.00 64.00 0.00 64.00 -32.00 64.00 -64.00 65.00 -65.00 -65.00 -96.00 -64.00 -32.00 -32.00 0.00 -32.00 -65.00 -64.00 -64.00 32.00 -32.00 0.00 -32.00 96.00 -161.00 32.00 -32.00 97.00 -32.00 161.00 -129.00 -33.00 0.00 97.00 -32.00 96.00 -32.00 32.00 -32.00 0.00 -33.00 65.00 -64.00 32.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 0.00 64.00 -65.00 129.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 0.00 65.00 32.00 96.00 -64.00 64.00 -64.00 0.00 -32.00 32.00 -65.00 33.00 -161.00 0.00 -96.00 128.00 -32.00 32.00 -129.00 65.00 -96.00 0.00 -32.00 0.00 -65.00 0.00 0.00 32.00 -64.00 64.00 -32.00 97.00 -64.00 128.00 -65.00 161.00 -32.00 -32.00 -129.00 161.00 -64.00 64.00 -64.00 0.00 -32.00 96.00 -32.00 0.00 0.00 33.00 -33.00 32.00 0.00 64.00 -32.00 64.00 -32.00 0.00 -32.00 129.00 -64.00 32.00 0.00 129.00 -97.00 32.00 -32.00 -64.00 -64.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 64.00 -64.00 0.00 0.00 64.00 -32.00 0.00 -193.00 32.00 0.00 65.00 -32.00 64.00 -225.00 0.00 0.00 32.00 -33.00 129.00 0.00 96.00 0.00 129.00 -128.00 96.00 -65.00 65.00 -32.00 0.00 -96.00 96.00 0.00 96.00 -97.00 97.00 -64.00 289.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 65.00 -96.00 32.00 -33.00 64.00 -32.00 32.00 -32.00 0.00 -64.00 -64.00 -65.00 0.00 -32.00 0.00 -64.00 -97.00 -129.00 97.00 -128.00 -64.00 -65.00 32.00 -64.00 0.00 -64.00 0.00 -161.00 96.00 -96.00 32.00 -97.00 0.00 -193.00 0.00 -64.00 32.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 32.00 -97.00 65.00 -32.00 32.00 -96.00 0.00 -97.00 32.00 -32.00 0.00 -32.00 64.00 -161.00 97.00 0.00 128.00 -32.00 0.00 -32.00 33.00 -129.00 64.00 -96.00 64.00 -32.00 32.00 0.00 129.00 -32.00 32.00 -65.00 32.00 -32.00 32.00 -96.00 -32.00 -65.00 32.00 -32.00 33.00 32.00 64.00 -32.00 64.00 -128.00 32.00 -129.00 -32.00 -96.00 32.00 -97.00 -32.00 -32.00 32.00 -32.00 65.00 -97.00 128.00 -32.00 -32.00 -64.00 32.00 -65.00 0.00 -96.00 32.00 -64.00 0.00 0.00 -32.00 -97.00 -32.00 -32.00 -32.00 0.00 32.00 0.00 97.00 -64.00 64.00 -64.00 64.00 -65.00 32.00 0.00 97.00 -32.00 32.00 -193.00 32.00 -64.00 0.00 0.00 -96.00 -65.00 -97.00 0.00 -96.00 -32.00 -65.00 -32.00 0.00 -64.00 65.00 -32.00 0.00 -32.00 0.00 -97.00 -129.00 -64.00 -32.00 -97.00 0.00 -96.00 -64.00 0.00 -33.00 -32.00 -64.00 -32.00 -128.00 0.00 -65.00 32.00 -96.00 -32.00 -32.00 0.00 -33.00 -65.00 -64.00 -64.00 -32.00 -96.00 32.00 -33.00 0.00 -193.00 32.00 0.00 -96.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 -33.00 0.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 65.00 -65.00 -65.00 -64.00 0.00 -64.00 161.00 -97.00 64.00 -32.00 -32.00 -32.00 -64.00 -64.00 0.00 -32.00 0.00 -65.00 32.00 -128.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 0.00 -32.00 -128.00 -32.00 0.00 -64.00 -32.00 -65.00 -97.00 -32.00 0.00 -96.00 0.00 -97.00 -96.00 -96.00 -161.00 -32.00 -64.00 -129.00 -161.00 -64.00 -32.00 -32.00 0.00 -65.00 -32.00 -96.00 32.00 -64.00 32.00 -129.00 129.00 -64.00 64.00 -33.00 0.00 -96.00 32.00 -32.00 0.00 -97.00 96.00 -96.00 129.00 -64.00 32.00 -193.00 161.00 -97.00 64.00 -289.00 97.00 -97.00 32.00 -64.00 64.00 -64.00 129.00 -97.00 64.00 -160.00 257.00 0.00 65.00 32.00 128.00 0.00 129.00 64.00 32.00 -32.00 0.00 0.00 32.00 -32.00 65.00 96.00 32.00 129.00 225.00 0.00 64.00 0.00 32.00 0.00 65.00 64.00 192.00 64.00 33.00 33.00 32.00 192.00 64.00 33.00 64.00 32.00 0.00 64.00 0.00 64.00 65.00 65.00 32.00 64.00 64.00 0.00 32.00 -64.00 65.00 0.00 64.00 -32.00 64.00 -97.00 32.00 0.00 65.00 -64.00 0.00 0.00 32.00 0.00 64.00 64.00 0.00 32.00 32.00 0.00 32.00 -64.00 129.00 96.00 96.00 65.00 33.00 32.00 64.00 -32.00 129.00 -97.00 64.00 -32.00 96.00 0.00 65.00 -161.00 0.00 -128.00 0.00 -32.00 32.00 -65.00 96.00 32.00 65.00 0.00 96.00 -32.00 225.00 -96.00 129.00 -193.00 193.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 0.00 129.00 -64.00 64.00 -97.00 65.00 -64.00 64.00 -32.00 32.00 -33.00 97.00 -64.00 64.00 -32.00 161.00 0.00 32.00 -96.00 0.00 -129.00 0.00 -129.00 -65.00 -64.00 -32.00 -64.00 0.00 -32.00 65.00 -33.00 128.00 33.00 161.00 0.00 32.00 -65.00 64.00 -32.00 33.00 -96.00 321.00 -33.00 64.00 -32.00 33.00 -96.00 0.00 -32.00 32.00 -65.00 128.00 -32.00 65.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 -64.00 -32.00 -97.00 -65.00 -32.00 0.00 -96.00 65.00 -32.00 0.00 -97.00 -33.00 -96.00 -64.00 -97.00 -193.00 -32.00 -32.00 -32.00 -32.00 -64.00 -32.00 -65.00 0.00 -32.00 32.00 -193.00 225.00 -32.00 32.00 -96.00 32.00 -129.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 65.00 -65.00 64.00 -96.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -128.00 -96.00 -129.00 0.00 -64.00 32.00 -65.00 128.00 -32.00 32.00 -64.00 33.00 -64.00 0.00 -32.00 0.00 -65.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 64.00 193.00 -32.00 96.00 0.00 33.00 -96.00 32.00 -129.00 -32.00 -64.00 32.00 -32.00 32.00 -97.00 32.00 -32.00 32.00 0.00 97.00 -97.00 0.00 -32.00 0.00 -96.00 193.00 0.00 96.00 -32.00 32.00 -32.00 32.00 -129.00 97.00 -32.00 -65.00 -32.00 0.00 -97.00 97.00 -64.00 0.00 -32.00 32.00 -32.00 0.00 -97.00 97.00 -193.00 -161.00 0.00 -32.00 -32.00 0.00 -96.00 -33.00 -33.00 0.00 -64.00 0.00 -64.00 -96.00 -64.00 -32.00 -33.00 -32.00 -64.00 -32.00 -32.00 -33.00 -64.00 0.00 -97.00 33.00 -32.00 -33.00 -96.00 0.00 -97.00 0.00 -257.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -129.00 0.00 -32.00 -32.00 -64.00 -161.00 0.00 -32.00 -97.00 -32.00 -161.00 -32.00 -161.00 -129.00 -64.00 -289.00 0.00 -33.00 -32.00 -32.00 -32.00 -64.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 -225.00 -32.00 -96.00 32.00 -65.00 0.00 -96.00 -32.00 -64.00 64.00 -97.00 128.00 -128.00 33.00 -32.00 0.00 -65.00 -129.00 -96.00 -32.00 -97.00 32.00 -160.00 -32.00 -65.00 -129.00 -96.00 -64.00 -129.00 -64.00 -32.00 -33.00 -32.00 -96.00 -64.00 -32.00 -33.00 0.00 -160.00 -32.00 -33.00 -129.00 -96.00 -64.00 -96.00 0.00 -65.00 0.00 -128.00 0.00 -97.00 -65.00 -96.00 -64.00 -65.00 -32.00 0.00 -161.00 97.00 -64.00 0.00 -97.00 96.00 -64.00 32.00 -96.00 0.00 -65.00 0.00 -32.00 0.00 -64.00 97.00 32.00 64.00 32.00 97.00 -32.00 96.00 -64.00 64.00 -225.00 129.00 -225.00 -32.00 -193.00 -97.00 -225.00 65.00 -97.00 32.00z"},ce:{name:"CE",path:"M160014.00 43760.00l0.00 -64.00 64.00 -65.00 0.00 -32.00 64.00 -160.00 290.00 -515.00 0.00 -96.00 32.00 -65.00 96.00 -96.00 64.00 -64.00 0.00 -65.00 65.00 0.00 0.00 -32.00 64.00 -32.00 0.00 -96.00 -32.00 0.00 32.00 -65.00 0.00 -32.00 32.00 -64.00 -32.00 -32.00 32.00 0.00 -32.00 -65.00 0.00 -64.00 -64.00 -96.00 0.00 -65.00 -65.00 0.00 -64.00 0.00 -96.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 -129.00 225.00 -128.00 32.00 -33.00 64.00 -32.00 129.00 32.00 193.00 0.00 64.00 -32.00 257.00 32.00 97.00 33.00 32.00 -33.00 32.00 33.00 129.00 0.00 257.00 -33.00 64.00 -32.00 129.00 -32.00 64.00 -32.00 193.00 0.00 32.00 -64.00 32.00 32.00 97.00 0.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 32.00 0.00 32.00 96.00 65.00 -32.00 64.00 0.00 97.00 -32.00 96.00 -96.00 64.00 0.00 129.00 0.00 225.00 0.00 64.00 -33.00 129.00 33.00 257.00 -33.00 97.00 -32.00 32.00 -32.00 160.00 -64.00 65.00 -65.00 0.00 -64.00 96.00 -32.00 193.00 96.00 97.00 33.00 160.00 0.00 129.00 0.00 225.00 -33.00 193.00 33.00 129.00 0.00 0.00 -33.00 193.00 33.00 160.00 32.00 -32.00 -32.00 161.00 96.00 32.00 32.00 97.00 -32.00 0.00 -32.00 160.00 0.00 97.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 0.00 65.00 0.00 96.00 32.00 32.00 -32.00 -64.00 0.00 32.00 -32.00 161.00 97.00 64.00 0.00 -64.00 -33.00 -65.00 0.00 65.00 0.00 161.00 65.00 -65.00 -32.00 129.00 32.00 32.00 64.00 96.00 32.00 33.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 129.00 97.00 128.00 96.00 65.00 32.00 128.00 97.00 97.00 32.00 128.00 129.00 32.00 0.00 97.00 64.00 129.00 0.00 64.00 32.00 64.00 64.00 32.00 33.00 32.00 0.00 65.00 -33.00 64.00 33.00 64.00 96.00 65.00 96.00 32.00 33.00 64.00 0.00 97.00 64.00 160.00 96.00 161.00 65.00 97.00 128.00 128.00 32.00 97.00 32.00 96.00 97.00 64.00 32.00 97.00 -32.00 96.00 32.00 97.00 97.00 32.00 32.00 32.00 0.00 64.00 32.00 65.00 32.00 96.00 0.00 32.00 0.00 65.00 64.00 64.00 65.00 193.00 225.00 96.00 160.00 32.00 0.00 0.00 33.00 97.00 64.00 64.00 0.00 32.00 0.00 33.00 0.00 32.00 96.00 96.00 129.00 97.00 64.00 0.00 -32.00 64.00 65.00 64.00 0.00 65.00 -33.00 32.00 0.00 32.00 -32.00 64.00 0.00 161.00 97.00 64.00 128.00 64.00 32.00 0.00 65.00 33.00 0.00 32.00 128.00 64.00 65.00 97.00 0.00 96.00 96.00 64.00 64.00 97.00 33.00 64.00 0.00 32.00 0.00 32.00 32.00 161.00 193.00 32.00 64.00 97.00 96.00 64.00 0.00 129.00 65.00 193.00 193.00 32.00 32.00 96.00 32.00 129.00 0.00 64.00 32.00 64.00 0.00 65.00 32.00 64.00 32.00 32.00 33.00 32.00 0.00 65.00 32.00 32.00 0.00 64.00 0.00 32.00 32.00 65.00 -32.00 64.00 0.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 64.00 65.00 161.00 289.00 0.00 32.00 161.00 225.00 160.00 257.00 97.00 129.00 129.00 96.00 64.00 65.00 32.00 32.00 -64.00 -32.00 32.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 64.00 0.00 33.00 32.00 64.00 96.00 128.00 161.00 33.00 32.00 96.00 129.00 32.00 32.00 65.00 97.00 128.00 192.00 32.00 33.00 129.00 225.00 129.00 64.00 225.00 257.00 32.00 32.00 128.00 129.00 97.00 64.00 32.00 32.00 129.00 129.00 193.00 193.00 128.00 96.00 193.00 129.00 64.00 0.00 129.00 97.00 64.00 0.00 32.00 0.00 65.00 32.00 32.00 -32.00 32.00 128.00 -32.00 0.00 64.00 97.00 64.00 128.00 65.00 129.00 96.00 96.00 65.00 32.00 32.00 33.00 96.00 128.00 64.00 65.00 65.00 64.00 225.00 193.00 128.00 64.00 129.00 32.00 64.00 -32.00 129.00 -64.00 32.00 32.00 64.00 64.00 0.00 32.00 65.00 0.00 257.00 129.00 161.00 32.00 64.00 32.00 32.00 32.00 0.00 -32.00 0.00 32.00 65.00 0.00 64.00 33.00 128.00 96.00 65.00 97.00 32.00 64.00 64.00 225.00 65.00 161.00 -33.00 32.00 -450.00 96.00 -450.00 97.00 -96.00 32.00 -804.00 193.00 -65.00 193.00 -32.00 160.00 -96.00 258.00 -161.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 129.00 -161.00 161.00 -32.00 257.00 -65.00 96.00 0.00 65.00 33.00 32.00 0.00 64.00 -33.00 97.00 0.00 64.00 33.00 64.00 0.00 32.00 -33.00 0.00 -32.00 33.00 -64.00 64.00 -129.00 96.00 -64.00 32.00 -32.00 97.00 0.00 32.00 -32.00 32.00 32.00 97.00 -32.00 64.00 -97.00 129.00 0.00 32.00 0.00 32.00 -32.00 161.00 -32.00 32.00 -32.00 64.00 -64.00 32.00 -65.00 0.00 -64.00 129.00 -64.00 32.00 -161.00 96.00 0.00 33.00 -32.00 32.00 0.00 64.00 -65.00 64.00 -96.00 193.00 -97.00 33.00 -96.00 96.00 -32.00 32.00 0.00 129.00 -32.00 96.00 0.00 64.00 64.00 -32.00 64.00 0.00 0.00 32.00 65.00 0.00 -65.00 129.00 -64.00 129.00 -161.00 160.00 0.00 33.00 -64.00 64.00 32.00 64.00 -64.00 193.00 -65.00 64.00 -32.00 65.00 -64.00 64.00 0.00 64.00 0.00 33.00 -64.00 32.00 -32.00 0.00 -33.00 32.00 -64.00 32.00 -193.00 161.00 -32.00 64.00 0.00 161.00 -32.00 32.00 -32.00 0.00 -65.00 64.00 0.00 32.00 -64.00 0.00 -64.00 65.00 -64.00 -32.00 -97.00 0.00 -32.00 -65.00 0.00 65.00 -97.00 64.00 -32.00 -32.00 -32.00 -65.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 -32.00 32.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -96.00 97.00 -64.00 32.00 32.00 64.00 -65.00 64.00 -32.00 0.00 -32.00 97.00 -32.00 64.00 0.00 32.00 -129.00 129.00 0.00 64.00 -128.00 32.00 0.00 97.00 32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 65.00 -65.00 -33.00 -32.00 97.00 -32.00 32.00 -64.00 32.00 0.00 32.00 32.00 0.00 0.00 65.00 0.00 32.00 -65.00 64.00 0.00 64.00 33.00 97.00 64.00 32.00 -32.00 32.00 -32.00 0.00 0.00 64.00 -65.00 0.00 0.00 33.00 -32.00 32.00 -32.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 0.00 32.00 33.00 0.00 128.00 0.00 32.00 0.00 65.00 -32.00 64.00 64.00 -32.00 0.00 -161.00 129.00 0.00 32.00 0.00 32.00 -64.00 32.00 0.00 97.00 -129.00 128.00 -64.00 65.00 -32.00 64.00 32.00 32.00 -64.00 97.00 0.00 32.00 -33.00 32.00 0.00 32.00 -64.00 32.00 64.00 65.00 0.00 64.00 -64.00 64.00 -32.00 32.00 -32.00 32.00 0.00 65.00 64.00 32.00 0.00 64.00 -32.00 32.00 -64.00 33.00 32.00 0.00 -32.00 0.00 -32.00 96.00 0.00 32.00 32.00 97.00 32.00 32.00 0.00 64.00 32.00 32.00 0.00 32.00 0.00 32.00 64.00 0.00 32.00 65.00 65.00 32.00 0.00 64.00 -65.00 -32.00 -64.00 0.00 32.00 32.00 0.00 32.00 -64.00 33.00 -32.00 32.00 -32.00 32.00 -65.00 64.00 33.00 32.00 0.00 33.00 -33.00 32.00 0.00 32.00 -32.00 32.00 -64.00 32.00 -64.00 0.00 0.00 64.00 -65.00 0.00 -32.00 0.00 0.00 33.00 -129.00 32.00 -32.00 32.00 32.00 32.00 0.00 64.00 33.00 65.00 -65.00 32.00 32.00 64.00 65.00 0.00 0.00 32.00 32.00 32.00 -32.00 0.00 -32.00 65.00 -33.00 0.00 -32.00 32.00 32.00 32.00 33.00 0.00 96.00 64.00 64.00 33.00 33.00 0.00 96.00 32.00 0.00 64.00 97.00 32.00 0.00 32.00 -33.00 65.00 33.00 32.00 32.00 32.00 32.00 32.00 0.00 32.00 -32.00 97.00 -32.00 64.00 -33.00 32.00 0.00 129.00 -32.00 32.00 32.00 32.00 -32.00 32.00 0.00 65.00 97.00 -33.00 96.00 0.00 32.00 33.00 65.00 0.00 32.00 32.00 -32.00 64.00 32.00 32.00 0.00 64.00 64.00 33.00 32.00 32.00 64.00 32.00 129.00 -64.00 32.00 32.00 -32.00 32.00 32.00 64.00 32.00 0.00 0.00 64.00 33.00 97.00 -33.00 64.00 -32.00 32.00 0.00 65.00 0.00 32.00 0.00 32.00 -64.00 64.00 -64.00 97.00 -33.00 96.00 -32.00 32.00 -32.00 65.00 64.00 0.00 0.00 96.00 -64.00 0.00 0.00 32.00 -32.00 32.00 0.00 33.00 -193.00 32.00 0.00 32.00 32.00 32.00 32.00 64.00 -64.00 65.00 -32.00 64.00 32.00 32.00 -64.00 0.00 32.00 32.00 0.00 65.00 -32.00 32.00 32.00 32.00 -32.00 32.00 0.00 32.00 -97.00 32.00 -32.00 33.00 -96.00 0.00 -32.00 32.00 0.00 96.00 -33.00 32.00 0.00 32.00 0.00 33.00 -32.00 0.00 -64.00 32.00 32.00 32.00 -32.00 32.00 -32.00 64.00 -32.00 0.00 -33.00 0.00 -64.00 33.00 -32.00 -33.00 0.00 33.00 -32.00 32.00 -64.00 0.00 -65.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 64.00 64.00 32.00 0.00 64.00 -32.00 97.00 -64.00 0.00 -64.00 0.00 -33.00 0.00 -64.00 -32.00 -64.00 64.00 0.00 96.00 -65.00 33.00 -32.00 -33.00 -64.00 0.00 0.00 65.00 -32.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 -32.00 64.00 32.00 65.00 -32.00 64.00 -32.00 64.00 -32.00 32.00 0.00 33.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 -96.00 -32.00 0.00 -32.00 -32.00 -97.00 -32.00 0.00 -32.00 32.00 -129.00 -32.00 -64.00 97.00 -129.00 96.00 -32.00 -32.00 64.00 -64.00 -32.00 -65.00 0.00 -64.00 -32.00 -129.00 -32.00 -64.00 0.00 -64.00 -97.00 -65.00 -32.00 -96.00 -64.00 -32.00 -129.00 0.00 -64.00 -97.00 -97.00 -32.00 -64.00 32.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 -96.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 33.00 -129.00 0.00 0.00 -65.00 32.00 -32.00 0.00 -96.00 32.00 -33.00 65.00 -64.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 -64.00 -97.00 -32.00 -128.00 0.00 -32.00 -64.00 -33.00 -129.00 -128.00 -64.00 -64.00 -129.00 -97.00 -32.00 0.00 -64.00 -32.00 -129.00 -64.00 -32.00 0.00 -129.00 -33.00 -64.00 -64.00 -32.00 -64.00 -65.00 -64.00 -32.00 0.00 -128.00 -97.00 -97.00 -64.00 -64.00 -64.00 -64.00 -97.00 -33.00 0.00 -32.00 -32.00 -96.00 0.00 -97.00 -64.00 -64.00 -65.00 -32.00 0.00 -96.00 32.00 -97.00 0.00 -225.00 33.00 -161.00 32.00 -64.00 0.00 -64.00 0.00 -65.00 0.00 -96.00 -32.00 -32.00 32.00 -161.00 64.00 -64.00 -32.00 -33.00 0.00 -225.00 257.00 -96.00 32.00 -129.00 -32.00 -64.00 64.00 -257.00 0.00 -354.00 65.00 -450.00 96.00 -129.00 -193.00 -32.00 -32.00 -64.00 0.00 -129.00 -64.00 -257.00 64.00 -225.00 0.00 -386.00 0.00 -225.00 32.00 64.00 -257.00 -32.00 -64.00 129.00 -65.00 32.00 -64.00 -32.00 -129.00 32.00 -257.00 32.00 -160.00 32.00 -33.00 0.00 -64.00 65.00 -193.00 -33.00 -64.00 97.00 -129.00 0.00 -32.00 64.00 -32.00 65.00 -129.00 0.00 -32.00 64.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 32.00 33.00 0.00 -33.00 96.00 -32.00 0.00 -32.00 -96.00 -32.00 0.00 -225.00 32.00 -65.00 -64.00 -160.00 32.00 -65.00 0.00 -128.00 64.00 -32.00 32.00 0.00 32.00 -65.00 65.00 -64.00 32.00 -32.00 64.00 -64.00 0.00 -33.00 -96.00 -32.00 -65.00 32.00 -64.00 65.00 -64.00 0.00 -32.00 -32.00 -32.00 -97.00 -33.00 -32.00 -32.00 -97.00 0.00 -32.00 -64.00 -64.00 -32.00 -32.00 -65.00 -32.00 -128.00 0.00 -225.00 -32.00 -193.00 -33.00 -32.00 -32.00 -97.00 -64.00 -96.00 -96.00 -258.00 0.00 -96.00 -97.00 -32.00 -32.00 64.00 -129.00 0.00 -32.00 -64.00 -64.00 0.00 -32.00 -64.00 -161.00 -193.00 -193.00 0.00 -64.00 0.00 -65.00 -32.00 -128.00 0.00 -64.00 0.00 -161.00 -33.00 -161.00 0.00 -64.00 65.00 -33.00 32.00 -160.00 0.00 -32.00 0.00 -65.00 0.00 -64.00 -32.00 -32.00 -65.00 -32.00 -32.00 -32.00 -64.00 -161.00 -129.00 -161.00 0.00 -97.00 0.00 -128.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -96.00 -64.00 -129.00 -64.00 -225.00 -65.00 -64.00 -96.00 32.00 0.00 -32.00 0.00 -32.00 0.00 -97.00 64.00 -64.00 0.00 -32.00 32.00 -32.00 33.00 -97.00 0.00 -257.00 -97.00 -97.00 32.00 -96.00 -64.00 -161.00 -32.00 -96.00 32.00 -161.00 -32.00 -129.00 -32.00 -128.00 32.00 -65.00 -64.00 -96.00 -33.00 -129.00 -32.00 -64.00 32.00 -32.00 97.00 -32.00 32.00 -64.00 32.00 -129.00 -32.00 -64.00 -32.00 -65.00 0.00 -128.00 -97.00 -65.00 0.00 -64.00 -32.00 -64.00 32.00 -32.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 -64.00 0.00 -33.00 -32.00 -64.00 -33.00 -32.00 -32.00 -32.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 97.00 0.00 32.00 -32.00 -32.00 -64.00 -65.00 -97.00 -32.00 -32.00 32.00 -96.00 65.00 -33.00 32.00 -96.00 0.00 -64.00 -64.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 64.00 -32.00 -32.00 -65.00 -32.00 0.00 -97.00 -64.00 97.00 -64.00 -33.00 -129.00 33.00 -96.00 -33.00 -65.00 -32.00 0.00 -64.00 0.00 -64.00 -96.00 -32.00 0.00 -33.00 32.00 -32.00 -96.00 -128.00 -65.00 0.00 -96.00 -65.00 32.00 -32.00 -96.00 -32.00 0.00 -64.00 64.00 -129.00 -64.00 0.00 -65.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 -161.00 0.00 32.00 -129.00 0.00 -96.00 -64.00 -33.00 0.00 -64.00 -32.00 0.00 -32.00 32.00 -161.00 -225.00 -65.00 -32.00 -32.00 64.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -64.00 -64.00 -97.00 32.00 -64.00 -97.00 -129.00 65.00 -64.00 -33.00 -161.00 65.00 -32.00 0.00 -32.00 32.00 -96.00 64.00 -33.00 0.00 -32.00 -128.00 -32.00 -65.00 -32.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 -65.00 128.00 -128.00 129.00 -161.00 -32.00 -32.00 -97.00 -129.00 -128.00 -64.00 0.00 -65.00 32.00 -96.00 0.00 -32.00 0.00 -32.00 -64.00 0.00 -33.00 -32.00 33.00 0.00 64.00 0.00 32.00 -97.00 32.00 0.00 32.00 -96.00 65.00 -65.00 0.00 -128.00 64.00 -97.00 0.00 -128.00 0.00 -33.00 64.00 -128.00 0.00 -129.00 0.00 -32.00 65.00 -64.00 64.00 -129.00 64.00 -32.00 0.00 -32.00 0.00 -64.00 -64.00 -386.00 161.00 -258.00 64.00 -64.00 -129.00 -32.00 -64.00 -32.00 0.00 -64.00 -64.00 -97.00 32.00 -32.00 64.00 -193.00 -32.00 -64.00 64.00 -65.00 0.00 -32.00 -32.00 -32.00 -96.00 0.00 -97.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 -64.00 32.00 -64.00 0.00 -64.00 32.00 -65.00 32.00 -32.00 0.00 0.00 -32.00 97.00 -64.00 -33.00 -65.00 -32.00 -64.00 32.00 -32.00 0.00 -32.00 33.00 0.00 0.00 -32.00 32.00 0.00 64.00 -161.00 -64.00 -129.00 -65.00 -64.00 -32.00 -64.00 -32.00 -65.00 0.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -97.00 -33.00 0.00 0.00 -32.00 -64.00 64.00 0.00 -32.00 161.00 -161.00 64.00 -96.00 -64.00 -64.00 32.00 -161.00 32.00 -32.00 65.00 0.00 0.00 -32.00 -97.00 -65.00 -96.00 0.00 -65.00 -64.00 -64.00 0.00 -96.00 0.00 -65.00 -32.00 -32.00 -32.00 32.00 -33.00 32.00 -225.00 -64.00 -160.00 -64.00 -32.00 -65.00 -33.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 128.00 0.00 65.00 -97.00 0.00 -160.00 32.00 -33.00 96.00 -32.00 -64.00 0.00 -64.00 32.00 0.00 -32.00 -33.00 -128.00 -64.00 -65.00 0.00 -64.00 0.00 -96.00 0.00 -32.00 -32.00 0.00 -161.00 0.00 -32.00 -65.00 -32.00 0.00 0.00 -96.00 0.00 -65.00 -97.00 33.00 0.00 -33.00 33.00 -64.00z"},rn:{name:"RN",path:"M173454.00 58068.00l0.00 -32.00 64.00 -32.00 32.00 -32.00 32.00 -97.00 65.00 33.00 32.00 -65.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -97.00 128.00 -32.00 0.00 -64.00 129.00 -129.00 0.00 -32.00 32.00 -64.00 32.00 -97.00 32.00 0.00 65.00 -64.00 -32.00 -64.00 64.00 -32.00 96.00 -97.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 -32.00 0.00 64.00 32.00 0.00 0.00 32.00 32.00 65.00 32.00 32.00 97.00 -64.00 0.00 -65.00 32.00 65.00 97.00 0.00 64.00 32.00 64.00 -65.00 64.00 0.00 0.00 -32.00 65.00 -64.00 32.00 0.00 32.00 -32.00 0.00 -161.00 32.00 -64.00 193.00 -161.00 64.00 -32.00 33.00 -32.00 32.00 0.00 64.00 -32.00 0.00 -33.00 0.00 -64.00 64.00 -64.00 32.00 -65.00 65.00 -64.00 64.00 -193.00 -32.00 -64.00 64.00 -64.00 0.00 -33.00 161.00 -160.00 64.00 -129.00 65.00 -129.00 -65.00 0.00 0.00 -32.00 -64.00 0.00 -64.00 32.00 0.00 -64.00 32.00 -96.00 0.00 -129.00 32.00 -32.00 96.00 -96.00 97.00 -33.00 96.00 -193.00 65.00 -64.00 0.00 -64.00 32.00 -32.00 0.00 -33.00 161.00 -96.00 64.00 -32.00 64.00 -129.00 65.00 0.00 64.00 -32.00 32.00 -64.00 32.00 -32.00 32.00 -161.00 0.00 -32.00 0.00 -32.00 97.00 -129.00 32.00 -64.00 -32.00 -97.00 32.00 -32.00 0.00 -32.00 32.00 -97.00 64.00 -32.00 129.00 -96.00 64.00 -64.00 32.00 -33.00 33.00 0.00 0.00 -32.00 -33.00 -64.00 0.00 -64.00 33.00 -97.00 0.00 -64.00 -33.00 -32.00 0.00 -65.00 65.00 -96.00 32.00 -257.00 161.00 -161.00 32.00 -129.00 32.00 -32.00 32.00 -32.00 161.00 -64.00 96.00 -258.00 32.00 -160.00 65.00 -193.00 804.00 -193.00 96.00 -32.00 450.00 -97.00 450.00 -96.00 33.00 -32.00 32.00 64.00 96.00 161.00 64.00 64.00 129.00 129.00 96.00 64.00 33.00 0.00 96.00 32.00 64.00 -32.00 65.00 -32.00 64.00 0.00 64.00 32.00 129.00 64.00 64.00 32.00 65.00 -32.00 128.00 -64.00 97.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 193.00 128.00 97.00 32.00 96.00 0.00 96.00 97.00 97.00 128.00 193.00 193.00 161.00 65.00 96.00 64.00 64.00 -32.00 -32.00 32.00 65.00 64.00 32.00 -32.00 32.00 -32.00 32.00 0.00 0.00 96.00 64.00 33.00 97.00 -33.00 193.00 33.00 32.00 -65.00 64.00 32.00 32.00 -32.00 32.00 0.00 33.00 0.00 128.00 32.00 32.00 -32.00 129.00 0.00 96.00 -64.00 97.00 0.00 225.00 32.00 161.00 32.00 160.00 65.00 97.00 0.00 32.00 -33.00 64.00 33.00 97.00 32.00 0.00 32.00 96.00 -64.00 65.00 0.00 160.00 32.00 418.00 0.00 129.00 -32.00 129.00 -65.00 96.00 -64.00 97.00 0.00 96.00 -64.00 129.00 0.00 32.00 -33.00 96.00 0.00 161.00 0.00 193.00 65.00 128.00 64.00 129.00 0.00 129.00 32.00 128.00 -32.00 32.00 32.00 33.00 0.00 64.00 32.00 64.00 33.00 193.00 32.00 32.00 32.00 65.00 0.00 257.00 64.00 32.00 32.00 32.00 -32.00 64.00 0.00 0.00 -32.00 226.00 129.00 160.00 32.00 129.00 64.00 96.00 0.00 97.00 129.00 32.00 64.00 64.00 32.00 129.00 97.00 129.00 160.00 32.00 65.00 32.00 32.00 32.00 96.00 64.00 258.00 32.00 64.00 65.00 64.00 64.00 32.00 64.00 65.00 0.00 64.00 65.00 96.00 32.00 0.00 0.00 161.00 32.00 32.00 64.00 65.00 32.00 32.00 0.00 -32.00 0.00 96.00 33.00 64.00 0.00 33.00 32.00 32.00 0.00 96.00 32.00 64.00 32.00 97.00 32.00 0.00 0.00 32.00 0.00 129.00 32.00 96.00 32.00 0.00 0.00 193.00 0.00 32.00 33.00 65.00 64.00 0.00 0.00 32.00 -32.00 225.00 0.00 64.00 32.00 32.00 0.00 97.00 32.00 64.00 32.00 0.00 0.00 32.00 0.00 322.00 32.00 64.00 33.00 32.00 32.00 -32.00 32.00 0.00 0.00 96.00 0.00 97.00 0.00 32.00 0.00 64.00 32.00 129.00 97.00 0.00 32.00 96.00 32.00 0.00 0.00 33.00 32.00 64.00 -32.00 129.00 32.00 96.00 0.00 32.00 32.00 0.00 0.00 97.00 0.00 257.00 0.00 32.00 32.00 225.00 0.00 -32.00 32.00 32.00 0.00 32.00 33.00 97.00 32.00 64.00 32.00 0.00 32.00 32.00 96.00 0.00 0.00 32.00 33.00 258.00 0.00 96.00 -33.00 32.00 33.00 129.00 32.00 96.00 32.00 32.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 32.00 32.00 129.00 64.00 193.00 0.00 97.00 0.00 64.00 0.00 64.00 -32.00 32.00 -64.00 32.00 -97.00 33.00 -32.00 0.00 -32.00 0.00 -65.00 64.00 -96.00 32.00 -32.00 0.00 -129.00 -129.00 -32.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 128.00 -65.00 0.00 -64.00 97.00 -32.00 0.00 -64.00 32.00 -129.00 -32.00 -32.00 0.00 -32.00 -65.00 -33.00 -96.00 -32.00 0.00 -32.00 64.00 -128.00 0.00 -97.00 64.00 -257.00 0.00 -64.00 -32.00 -97.00 -128.00 -64.00 -32.00 -97.00 -65.00 -32.00 0.00 -96.00 -32.00 -65.00 0.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -64.00 0.00 -32.00 0.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 0.00 -32.00 -97.00 0.00 -32.00 -32.00 0.00 -32.00 -64.00 -64.00 -65.00 0.00 -32.00 0.00 -64.00 -33.00 -96.00 -32.00 -33.00 0.00 0.00 32.00 -32.00 0.00 -64.00 -32.00 -97.00 97.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -225.00 32.00 -32.00 32.00 -354.00 0.00 -418.00 32.00 -96.00 -32.00 -65.00 0.00 -128.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -65.00 -129.00 -32.00 -64.00 -64.00 -65.00 -129.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 -64.00 33.00 -33.00 0.00 -32.00 32.00 -64.00 0.00 -32.00 0.00 -64.00 0.00 -129.00 32.00 -193.00 0.00 -32.00 0.00 -129.00 32.00 -32.00 -161.00 -64.00 -32.00 -97.00 -32.00 -32.00 0.00 0.00 -64.00 0.00 -33.00 0.00 -32.00 64.00 -96.00 0.00 -161.00 0.00 -32.00 -64.00 -64.00 -64.00 -65.00 -161.00 97.00 -96.00 32.00 -161.00 -64.00 -161.00 321.00 -129.00 0.00 -192.00 -32.00 -33.00 161.00 0.00 64.00 -96.00 161.00 -32.00 64.00 0.00 65.00 32.00 96.00 0.00 96.00 32.00 0.00 97.00 65.00 64.00 32.00 32.00 96.00 32.00 32.00 64.00 33.00 33.00 0.00 32.00 32.00 0.00 193.00 32.00 128.00 0.00 32.00 -64.00 -32.00 -33.00 32.00 -64.00 -96.00 -161.00 -64.00 -32.00 -32.00 -64.00 32.00 32.00 64.00 -96.00 193.00 -32.00 225.00 -65.00 64.00 65.00 97.00 64.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 32.00 32.00 32.00 33.00 97.00 -33.00 193.00 -32.00 32.00 -96.00 32.00 -64.00 64.00 -65.00 0.00 -32.00 33.00 -32.00 32.00 32.00 64.00 0.00 32.00 -193.00 289.00 -32.00 0.00 -97.00 0.00 -96.00 -32.00 -161.00 0.00 -96.00 258.00 -32.00 0.00 -129.00 -65.00 -96.00 -161.00 32.00 -96.00 0.00 -64.00 64.00 -97.00 64.00 -225.00 -193.00 32.00 0.00 -257.00 -321.00 -289.00 -161.00 64.00 -161.00 64.00 -32.00 0.00 -128.00 65.00 -97.00 96.00 0.00 -32.00 32.00 -32.00 -64.00 0.00 0.00 -32.00 -32.00 -65.00 0.00 -64.00 -32.00 -96.00 -33.00 -65.00 -64.00 0.00 -161.00 129.00 -32.00 32.00 -96.00 32.00 -64.00 32.00 -226.00 65.00 -32.00 0.00 -96.00 128.00 -193.00 129.00 -193.00 0.00 -96.00 -64.00 0.00 -65.00 -33.00 -32.00 0.00 -32.00 -64.00 -64.00 32.00 -65.00 0.00 -128.00 -64.00 -32.00 -64.00 -65.00 32.00 -64.00 -129.00 -32.00 -128.00 64.00 -258.00 -32.00 -64.00 0.00 -354.00 64.00 65.00 -160.00 -33.00 -33.00 33.00 -64.00 -33.00 -64.00 0.00 -129.00 0.00 -64.00 -32.00 0.00 0.00 -64.00 32.00 -129.00 -32.00 -32.00 0.00 -32.00 65.00 -97.00 32.00 0.00 96.00 0.00 32.00 0.00 97.00 0.00 96.00 -96.00 32.00 -290.00 33.00 -96.00 -33.00 -32.00 -32.00 -65.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 -65.00 0.00 -128.00 32.00 -97.00 32.00 0.00 129.00 -64.00 32.00 -32.00 32.00 -97.00 64.00 -32.00 97.00 32.00 64.00 0.00 0.00 -160.00 97.00 -97.00 64.00 -64.00 32.00 0.00 32.00 -32.00 97.00 -33.00 64.00 -32.00 0.00 -64.00 96.00 -32.00 32.00 -32.00 33.00 -97.00 -33.00 0.00 -64.00 -32.00 64.00 -161.00 -32.00 -64.00 0.00 -64.00 -32.00 -161.00 32.00 -32.00 -96.00 0.00 -64.00 -32.00 -97.00 32.00 -32.00 -64.00 -64.00 -33.00 -32.00 0.00 -33.00 33.00 -32.00 64.00 -32.00 64.00 -64.00 0.00 -65.00 -32.00 -32.00 32.00 -128.00 32.00 -97.00 97.00 -96.00 0.00 -32.00 0.00 -65.00 128.00 -64.00 0.00 -96.00 0.00 -97.00 0.00 -32.00 33.00 0.00 128.00 -129.00 32.00 -32.00 -32.00 -64.00 0.00 0.00 32.00 -97.00 0.00 -64.00 0.00 0.00 65.00 -96.00 0.00 -65.00 -33.00 -64.00 33.00 -64.00 64.00 -97.00 0.00 -96.00 0.00 -32.00 64.00 -161.00 0.00 -97.00 -32.00 -32.00 -32.00 -32.00 0.00 -161.00 96.00 -32.00 32.00 0.00 65.00 -32.00 0.00 -64.00 64.00 64.00 32.00 -64.00 32.00 64.00 65.00 -32.00 32.00 0.00 64.00 32.00 65.00 32.00 0.00 -96.00 0.00 -97.00 0.00 -64.00 0.00 -64.00 96.00 32.00 32.00 -32.00 0.00 -65.00 32.00 -32.00 65.00 32.00 32.00 -32.00 64.00 0.00 32.00 -64.00 32.00 -32.00 32.00 -129.00 -64.00 0.00 129.00 32.00 32.00 -32.00 32.00 -64.00 0.00 -64.00 64.00 -65.00 33.00 -64.00 0.00 -64.00 -65.00 0.00 -32.00 -33.00 32.00 -32.00 65.00 -32.00 32.00 -161.00 0.00 33.00 32.00 -65.00 64.00 32.00 97.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 -64.00 -64.00 -33.00 0.00 -64.00 -33.00 0.00 0.00 64.00 -32.00 0.00 0.00 33.00 -32.00 0.00 -32.00 32.00 -32.00 96.00 -64.00 32.00 -33.00 65.00 -64.00 64.00 -32.00 0.00 -64.00 0.00 -65.00 -129.00 -64.00 32.00 -129.00 0.00 -64.00 -64.00 -129.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 -161.00 97.00 0.00 -97.00 -96.00 0.00 -32.00 -64.00 -65.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -33.00 -33.00 -32.00 0.00 0.00 -64.00 -32.00 -32.00 -32.00 -64.00 -32.00 -33.00 -32.00 -32.00 -33.00 0.00 -96.00 32.00 -96.00 -64.00 -33.00 -32.00 -64.00 0.00 -96.00 32.00 32.00 -96.00 -32.00 -65.00 64.00 -96.00 64.00 -97.00 -64.00 33.00 -64.00 32.00 -32.00 0.00 -65.00 64.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 -32.00 32.00 32.00 32.00 -96.00 0.00 -64.00 -32.00 -33.00 -97.00 0.00 -64.00 65.00 -64.00 0.00 -32.00 0.00 -65.00 -32.00 0.00z"},al:{name:"AL",path:"M175061.00 72955.00l161.00 -160.00 97.00 -33.00 128.00 -128.00 0.00 -64.00 0.00 -33.00 64.00 -128.00 97.00 -97.00 96.00 -96.00 33.00 -32.00 64.00 0.00 64.00 0.00 64.00 -33.00 33.00 0.00 64.00 0.00 32.00 -64.00 64.00 0.00 65.00 0.00 32.00 0.00 64.00 -32.00 32.00 -96.00 65.00 -65.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -64.00 129.00 -129.00 32.00 -64.00 64.00 -33.00 32.00 33.00 32.00 -97.00 0.00 -32.00 65.00 -32.00 64.00 -65.00 32.00 -64.00 32.00 -32.00 33.00 -193.00 -33.00 -32.00 65.00 -64.00 0.00 -65.00 -32.00 -32.00 96.00 -64.00 32.00 0.00 97.00 -97.00 32.00 0.00 32.00 0.00 32.00 -32.00 64.00 65.00 0.00 64.00 32.00 32.00 33.00 0.00 0.00 32.00 32.00 32.00 32.00 65.00 64.00 64.00 0.00 32.00 32.00 64.00 65.00 33.00 0.00 64.00 0.00 32.00 -32.00 32.00 -33.00 32.00 0.00 32.00 65.00 -32.00 0.00 65.00 128.00 -65.00 0.00 32.00 -32.00 33.00 32.00 32.00 65.00 32.00 128.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 65.00 -64.00 64.00 -32.00 96.00 32.00 97.00 -96.00 64.00 32.00 32.00 0.00 65.00 32.00 96.00 0.00 0.00 32.00 0.00 96.00 -32.00 33.00 129.00 128.00 96.00 0.00 64.00 0.00 97.00 65.00 64.00 64.00 322.00 129.00 32.00 64.00 64.00 0.00 0.00 32.00 0.00 32.00 64.00 64.00 97.00 129.00 64.00 64.00 32.00 32.00 65.00 65.00 0.00 32.00 0.00 32.00 32.00 64.00 32.00 0.00 0.00 65.00 0.00 32.00 0.00 32.00 0.00 32.00 96.00 -96.00 65.00 -32.00 193.00 128.00 -65.00 65.00 0.00 64.00 0.00 32.00 32.00 32.00 97.00 -64.00 64.00 -32.00 65.00 -97.00 32.00 0.00 128.00 65.00 33.00 32.00 96.00 128.00 -32.00 97.00 32.00 64.00 0.00 -64.00 32.00 64.00 129.00 0.00 96.00 161.00 129.00 64.00 96.00 97.00 32.00 0.00 33.00 -33.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -64.00 96.00 -65.00 0.00 -32.00 -32.00 -32.00 64.00 -128.00 65.00 -65.00 32.00 0.00 96.00 -32.00 -32.00 0.00 32.00 -32.00 97.00 0.00 32.00 32.00 32.00 64.00 193.00 0.00 193.00 -96.00 289.00 32.00 64.00 32.00 97.00 129.00 64.00 32.00 0.00 -32.00 32.00 32.00 32.00 0.00 0.00 32.00 33.00 32.00 32.00 -32.00 0.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 33.00 64.00 -33.00 33.00 0.00 64.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -129.00 321.00 -96.00 33.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 -32.00 33.00 0.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 64.00 0.00 0.00 64.00 32.00 32.00 33.00 -64.00 32.00 32.00 64.00 0.00 64.00 -32.00 65.00 32.00 32.00 -32.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 64.00 32.00 32.00 0.00 32.00 -32.00 33.00 -64.00 32.00 -32.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 65.00 -33.00 32.00 33.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 97.00 -32.00 0.00 -33.00 -65.00 -32.00 0.00 -64.00 -32.00 -32.00 -64.00 0.00 0.00 -64.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 96.00 0.00 65.00 0.00 64.00 -64.00 0.00 -65.00 32.00 0.00 32.00 -32.00 32.00 -96.00 32.00 0.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 0.00 32.00 0.00 0.00 -33.00 64.00 -32.00 64.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 -64.00 -32.00 -32.00 -64.00 32.00 -64.00 193.00 -65.00 96.00 -128.00 161.00 -32.00 129.00 32.00 64.00 -65.00 64.00 0.00 33.00 0.00 32.00 0.00 0.00 -32.00 64.00 -32.00 32.00 -32.00 64.00 0.00 33.00 0.00 32.00 -64.00 0.00 -33.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 129.00 -32.00 64.00 65.00 32.00 0.00 65.00 0.00 32.00 -65.00 64.00 32.00 64.00 -64.00 33.00 0.00 32.00 64.00 0.00 -32.00 0.00 65.00 -32.00 64.00 32.00 32.00 -32.00 32.00 32.00 0.00 32.00 32.00 64.00 33.00 65.00 32.00 64.00 -32.00 32.00 0.00 32.00 0.00 32.00 -33.00 65.00 33.00 32.00 -65.00 96.00 0.00 65.00 -64.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 64.00 -65.00 97.00 0.00 32.00 -64.00 32.00 -32.00 32.00 0.00 33.00 0.00 32.00 -64.00 64.00 0.00 32.00 -33.00 32.00 -32.00 0.00 65.00 65.00 -65.00 64.00 0.00 0.00 32.00 32.00 -32.00 0.00 32.00 32.00 33.00 0.00 -33.00 65.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 -32.00 65.00 32.00 0.00 0.00 32.00 32.00 32.00 97.00 0.00 0.00 -32.00 64.00 0.00 32.00 0.00 32.00 0.00 32.00 64.00 225.00 64.00 258.00 65.00 32.00 0.00 64.00 0.00 129.00 64.00 64.00 -32.00 64.00 32.00 65.00 0.00 32.00 0.00 128.00 0.00 97.00 64.00 0.00 65.00 0.00 32.00 -64.00 64.00 -33.00 97.00 -32.00 96.00 -32.00 32.00 -96.00 97.00 -65.00 96.00 -32.00 32.00 -32.00 97.00 0.00 64.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -64.00 65.00 0.00 32.00 0.00 32.00 -65.00 64.00 0.00 32.00 -64.00 33.00 0.00 96.00 -32.00 32.00 -32.00 0.00 0.00 97.00 0.00 32.00 -32.00 64.00 -65.00 32.00 -32.00 32.00 0.00 33.00 -32.00 64.00 -64.00 32.00 0.00 32.00 -33.00 97.00 -96.00 96.00 -64.00 32.00 -65.00 97.00 -64.00 32.00 -32.00 32.00 32.00 0.00 -96.00 32.00 -33.00 32.00 0.00 32.00 -96.00 33.00 -32.00 32.00 -97.00 96.00 -32.00 65.00 -32.00 160.00 -64.00 129.00 -65.00 0.00 0.00 64.00 -32.00 0.00 -96.00 97.00 -32.00 64.00 -129.00 96.00 0.00 97.00 -64.00 0.00 -65.00 64.00 0.00 32.00 -64.00 33.00 -64.00 64.00 -32.00 0.00 -65.00 96.00 -64.00 65.00 -32.00 64.00 -64.00 96.00 0.00 65.00 0.00 96.00 -65.00 0.00 -64.00 97.00 -32.00 -33.00 32.00 0.00 0.00 -32.00 -32.00 0.00 -129.00 32.00 -128.00 161.00 -33.00 0.00 -96.00 97.00 -32.00 64.00 32.00 -32.00 -193.00 225.00 -96.00 161.00 -65.00 96.00 -64.00 161.00 -193.00 161.00 -96.00 193.00 -65.00 96.00 -128.00 193.00 -129.00 225.00 -64.00 64.00 0.00 65.00 -64.00 64.00 -65.00 -32.00 -64.00 64.00 -129.00 161.00 -32.00 64.00 -64.00 64.00 0.00 33.00 -64.00 -33.00 -65.00 33.00 -64.00 64.00 -64.00 129.00 -129.00 64.00 -129.00 161.00 -160.00 128.00 -97.00 129.00 -32.00 64.00 0.00 64.00 0.00 97.00 32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -129.00 193.00 -193.00 418.00 -32.00 32.00 -32.00 33.00 -32.00 -33.00 -32.00 -64.00 -97.00 -193.00 -32.00 -96.00 -32.00 0.00 -97.00 -65.00 -32.00 -32.00 -96.00 65.00 0.00 32.00 -32.00 0.00 -97.00 32.00 -32.00 0.00 0.00 -32.00 32.00 0.00 -128.00 0.00 -32.00 32.00 -97.00 -64.00 32.00 -129.00 -32.00 -129.00 0.00 -160.00 -32.00 -65.00 -64.00 -96.00 -33.00 -64.00 -96.00 -65.00 0.00 -32.00 -32.00 -32.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 -64.00 64.00 -96.00 0.00 -33.00 32.00 -64.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 -64.00 -64.00 -32.00 -32.00 0.00 32.00 -33.00 0.00 -32.00 -97.00 -32.00 -32.00 0.00 -161.00 -32.00 -32.00 -32.00 -96.00 -64.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 -65.00 0.00 -64.00 -65.00 -161.00 -32.00 -32.00 -64.00 -64.00 -97.00 -65.00 -64.00 -32.00 -96.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -96.00 0.00 -33.00 0.00 -64.00 -32.00 -64.00 0.00 -32.00 -129.00 -65.00 -32.00 0.00 -32.00 0.00 -96.00 65.00 -33.00 0.00 -64.00 0.00 -128.00 -129.00 -258.00 -225.00 -96.00 -64.00 -225.00 -32.00 -129.00 0.00 -64.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 -64.00 -65.00 -97.00 -96.00 -96.00 -65.00 -32.00 -96.00 -32.00 -129.00 -97.00 -32.00 -32.00 -32.00 -32.00 -64.00 0.00 -97.00 -32.00 -128.00 -65.00 -32.00 -32.00 -193.00 -32.00 -386.00 -64.00 -97.00 0.00 -64.00 -32.00 -354.00 -225.00 0.00 -33.00 -32.00 -64.00 -32.00 -64.00 -64.00 -32.00 -129.00 -65.00 -161.00 -32.00 -32.00 0.00 -128.00 65.00 -33.00 0.00 -32.00 -97.00 -64.00 -64.00 -32.00 -65.00 -32.00 0.00 -65.00 0.00 0.00 -64.00 -32.00 0.00 -193.00 -161.00 -32.00 -32.00 -32.00 0.00 -96.00 32.00 -193.00 -64.00 -161.00 -32.00 -64.00 -64.00 32.00 -97.00 -65.00 -64.00 -64.00 -64.00 -32.00 0.00 -64.00 0.00 -65.00 -65.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -129.00 -32.00 -32.00 0.00 -32.00 32.00 -97.00 -32.00 -64.00 32.00 -96.00 -97.00 -97.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 -64.00 -32.00 -33.00 -32.00 -96.00 -129.00 -129.00z"},se:{name:"SE",path:"M175061.00 80093.00l32.00 0.00 33.00 -64.00 32.00 -96.00 0.00 -65.00 0.00 -64.00 0.00 -64.00 32.00 -65.00 32.00 0.00 97.00 -32.00 32.00 64.00 64.00 0.00 32.00 0.00 64.00 33.00 65.00 0.00 32.00 -65.00 64.00 32.00 65.00 -64.00 32.00 32.00 32.00 32.00 96.00 -32.00 32.00 0.00 33.00 65.00 32.00 0.00 64.00 64.00 0.00 32.00 0.00 129.00 129.00 0.00 128.00 -65.00 161.00 -64.00 579.00 -225.00 -64.00 -547.00 0.00 -32.00 -33.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 65.00 0.00 0.00 -33.00 32.00 -32.00 0.00 32.00 0.00 -64.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 -32.00 -97.00 -161.00 -289.00 32.00 -32.00 -32.00 -65.00 96.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 0.00 32.00 0.00 0.00 -32.00 32.00 -33.00 32.00 0.00 96.00 -64.00 33.00 -32.00 96.00 0.00 129.00 -64.00 -33.00 -33.00 0.00 -32.00 -128.00 -611.00 -64.00 -32.00 0.00 -32.00 32.00 -161.00 0.00 -64.00 -97.00 -129.00 -128.00 -257.00 0.00 -96.00 0.00 -32.00 0.00 -65.00 -32.00 -64.00 -226.00 -129.00 -32.00 32.00 -96.00 -32.00 -64.00 0.00 -33.00 0.00 0.00 -64.00 -64.00 0.00 -64.00 32.00 -32.00 0.00 -33.00 -32.00 -96.00 -193.00 -64.00 -32.00 0.00 -32.00 64.00 -97.00 0.00 -96.00 64.00 -64.00 0.00 -33.00 -32.00 -32.00 32.00 -64.00 32.00 -64.00 -32.00 -32.00 -32.00 0.00 -96.00 -33.00 -97.00 -96.00 0.00 -32.00 -32.00 0.00 -64.00 -129.00 0.00 -96.00 0.00 -97.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 -64.00 65.00 -64.00 32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 -64.00 -33.00 -33.00 -32.00 -32.00 -32.00 -64.00 -32.00 -32.00 -64.00 0.00 -97.00 0.00 -32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 -64.00 64.00 64.00 161.00 32.00 193.00 64.00 96.00 -32.00 32.00 0.00 32.00 32.00 193.00 161.00 32.00 0.00 0.00 64.00 65.00 0.00 32.00 0.00 32.00 65.00 64.00 64.00 32.00 97.00 33.00 0.00 128.00 -65.00 32.00 0.00 161.00 32.00 129.00 65.00 64.00 32.00 32.00 64.00 32.00 64.00 0.00 33.00 354.00 225.00 64.00 32.00 97.00 0.00 386.00 64.00 193.00 32.00 32.00 32.00 128.00 65.00 97.00 32.00 64.00 0.00 32.00 32.00 32.00 32.00 129.00 97.00 96.00 32.00 65.00 32.00 96.00 96.00 65.00 97.00 32.00 64.00 0.00 32.00 32.00 33.00 64.00 0.00 129.00 0.00 225.00 32.00 96.00 64.00 258.00 225.00 128.00 129.00 64.00 0.00 33.00 0.00 96.00 -65.00 32.00 0.00 32.00 0.00 129.00 65.00 0.00 32.00 32.00 64.00 0.00 64.00 0.00 33.00 0.00 96.00 0.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 32.00 96.00 65.00 64.00 64.00 97.00 32.00 64.00 161.00 32.00 64.00 65.00 65.00 0.00 32.00 64.00 0.00 32.00 0.00 32.00 0.00 32.00 32.00 33.00 96.00 64.00 32.00 32.00 161.00 32.00 32.00 0.00 97.00 32.00 0.00 32.00 -32.00 33.00 32.00 0.00 64.00 32.00 65.00 64.00 32.00 0.00 64.00 32.00 32.00 0.00 64.00 0.00 33.00 -32.00 96.00 0.00 64.00 -64.00 32.00 0.00 33.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 96.00 65.00 33.00 64.00 64.00 96.00 32.00 65.00 0.00 160.00 32.00 129.00 -32.00 129.00 97.00 64.00 32.00 -32.00 128.00 0.00 -32.00 0.00 0.00 32.00 32.00 0.00 97.00 -32.00 32.00 0.00 0.00 -32.00 96.00 -65.00 32.00 32.00 97.00 65.00 32.00 0.00 32.00 96.00 97.00 193.00 32.00 64.00 0.00 33.00 0.00 32.00 0.00 64.00 -32.00 -32.00 -161.00 32.00 -289.00 64.00 -386.00 161.00 -193.00 97.00 -161.00 128.00 -129.00 97.00 -225.00 96.00 -386.00 257.00 -160.00 161.00 -32.00 32.00 -418.00 418.00 -129.00 161.00 -129.00 193.00 -160.00 225.00 0.00 64.00 -129.00 161.00 -354.00 515.00 -128.00 257.00 32.00 32.00 -257.00 289.00 -258.00 322.00 -160.00 289.00 -129.00 386.00 -32.00 32.00 0.00 65.00 -64.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 64.00 -32.00 0.00 -97.00 96.00 -96.00 97.00 -129.00 96.00 -64.00 32.00 -32.00 0.00 -129.00 0.00 -64.00 0.00 -64.00 65.00 0.00 64.00 -161.00 0.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -65.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 0.00 65.00 -32.00 0.00 -32.00 0.00 32.00 64.00 -64.00 64.00 0.00 32.00 0.00 32.00 -64.00 -32.00 -65.00 0.00 33.00 -96.00 -33.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 0.00 -64.00 -97.00 0.00 -64.00 -65.00 -32.00 33.00 -32.00 -33.00 -65.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 -64.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 -33.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 0.00 -33.00 -96.00 33.00 0.00 -33.00 -65.00 -32.00 32.00 0.00 65.00 0.00 -65.00 -32.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 0.00 32.00 -32.00 0.00 0.00 64.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 0.00 -33.00 -32.00 0.00 -33.00 33.00 0.00 -65.00 -64.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -97.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 64.00 0.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 -64.00 -97.00 0.00 -64.00 64.00 -32.00 0.00 -32.00 32.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -65.00 32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 32.00 -97.00 -97.00 -32.00 32.00 -64.00 -32.00 -65.00 -64.00 -64.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 -64.00 0.00 -33.00 32.00 0.00 32.00 -96.00 0.00 -64.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 -33.00 -64.00 -32.00 0.00 65.00 -32.00 0.00 -33.00 -33.00 -32.00 -64.00 -128.00 -64.00 -32.00 -64.00 -33.00 -33.00 33.00 -64.00 0.00 -32.00 -97.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 33.00 0.00 -33.00 -65.00 -32.00 0.00 -96.00 -64.00 -97.00 0.00 -64.00 32.00 -64.00 32.00 -32.00 -32.00 -97.00 -32.00 0.00 32.00 -64.00 -32.00 -64.00 32.00 -33.00z"},df:{name:"DF",path:"M127474.00 104691.00l0.00 -33.00 65.00 -96.00 128.00 -32.00 33.00 -64.00 96.00 -129.00 32.00 0.00 32.00 -64.00 -32.00 -129.00 -32.00 -64.00 -64.00 32.00 -65.00 -32.00 0.00 -97.00 33.00 -128.00 32.00 -97.00 64.00 -96.00 64.00 0.00 0.00 -515.00 0.00 -64.00 708.00 0.00 96.00 0.00 1222.00 0.00 547.00 0.00 450.00 0.00 321.00 0.00 386.00 0.00 0.00 225.00 64.00 0.00 65.00 96.00 32.00 0.00 0.00 33.00 32.00 32.00 129.00 0.00 96.00 32.00 32.00 0.00 32.00 32.00 -32.00 32.00 -64.00 161.00 32.00 64.00 0.00 65.00 0.00 64.00 -32.00 32.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 65.00 -32.00 64.00 0.00 64.00 32.00 32.00 0.00 33.00 -32.00 0.00 0.00 64.00 0.00 -32.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 -32.00 97.00 -32.00 32.00 0.00 32.00 -33.00 0.00 0.00 64.00 -32.00 0.00 -32.00 33.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 0.00 0.00 33.00 -32.00 64.00 -32.00 0.00 32.00 0.00 0.00 64.00 32.00 32.00 -32.00 32.00 64.00 0.00 -32.00 33.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 -64.00 0.00 32.00 32.00 0.00 32.00 0.00 33.00 -32.00 0.00 0.00 32.00 0.00 32.00 0.00 64.00 0.00 32.00 0.00 32.00 32.00 0.00 0.00 33.00 32.00 0.00 0.00 32.00 65.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 -32.00 32.00 64.00 32.00 0.00 0.00 32.00 65.00 0.00 -33.00 32.00 33.00 0.00 0.00 33.00 -1480.00 0.00 -289.00 0.00 -643.00 32.00 -579.00 0.00 -386.00 0.00 -64.00 0.00 -257.00 0.00 -900.00 0.00 0.00 -32.00 32.00 -97.00 0.00 -96.00 32.00 -65.00 32.00 -96.00 -32.00 -32.00 64.00 -64.00 0.00 -65.00 0.00 -32.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -65.00 -32.00 0.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 -33.00 -161.00 0.00 -64.00z"},pe:{name:"PE",path:"M160271.00 69901.00l96.00 0.00 129.00 -65.00 32.00 -32.00 96.00 -128.00 161.00 0.00 65.00 -33.00 32.00 -32.00 64.00 0.00 64.00 -64.00 -32.00 -96.00 0.00 -65.00 32.00 0.00 32.00 -32.00 65.00 0.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 65.00 -129.00 0.00 -64.00 64.00 0.00 32.00 32.00 32.00 0.00 64.00 -32.00 33.00 -65.00 32.00 0.00 32.00 -32.00 32.00 -96.00 0.00 -97.00 129.00 33.00 32.00 -161.00 32.00 -97.00 161.00 -32.00 32.00 -96.00 32.00 0.00 64.00 -32.00 65.00 64.00 0.00 32.00 32.00 32.00 96.00 64.00 65.00 65.00 64.00 -65.00 32.00 -64.00 0.00 -64.00 0.00 -64.00 32.00 -33.00 32.00 0.00 0.00 -96.00 -32.00 0.00 32.00 -64.00 97.00 0.00 32.00 32.00 32.00 64.00 0.00 32.00 97.00 0.00 96.00 -96.00 -32.00 -129.00 32.00 -32.00 0.00 -32.00 129.00 -32.00 0.00 -65.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -129.00 64.00 -32.00 32.00 -32.00 97.00 -32.00 32.00 -32.00 32.00 -32.00 96.00 0.00 0.00 -33.00 33.00 -64.00 32.00 -32.00 32.00 -64.00 64.00 0.00 32.00 -32.00 0.00 -65.00 33.00 -32.00 64.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 161.00 64.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 -32.00 -32.00 -32.00 -64.00 32.00 -129.00 64.00 -161.00 32.00 -96.00 161.00 -289.00 0.00 -65.00 0.00 -32.00 32.00 -386.00 0.00 -64.00 -32.00 -96.00 0.00 -33.00 -64.00 -64.00 -32.00 -32.00 -32.00 0.00 -258.00 -97.00 -128.00 -32.00 -97.00 -96.00 -32.00 -193.00 64.00 -193.00 97.00 -193.00 0.00 -32.00 0.00 -97.00 0.00 -64.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -161.00 -193.00 -32.00 -32.00 -97.00 -258.00 0.00 -64.00 32.00 -64.00 161.00 -32.00 65.00 -33.00 32.00 -64.00 482.00 -193.00 225.00 -32.00 386.00 0.00 225.00 0.00 257.00 -64.00 129.00 64.00 64.00 0.00 32.00 32.00 129.00 193.00 450.00 -96.00 354.00 -65.00 257.00 0.00 64.00 -64.00 129.00 32.00 96.00 -32.00 225.00 -257.00 33.00 0.00 64.00 32.00 161.00 -64.00 32.00 -32.00 96.00 32.00 65.00 0.00 64.00 0.00 64.00 0.00 161.00 -32.00 225.00 -33.00 97.00 0.00 96.00 -32.00 32.00 0.00 64.00 65.00 97.00 64.00 96.00 0.00 32.00 32.00 33.00 0.00 64.00 97.00 64.00 64.00 97.00 64.00 128.00 97.00 32.00 0.00 65.00 64.00 32.00 64.00 64.00 64.00 129.00 33.00 32.00 0.00 129.00 64.00 64.00 32.00 32.00 0.00 129.00 97.00 64.00 64.00 129.00 128.00 64.00 33.00 0.00 32.00 32.00 128.00 64.00 97.00 33.00 32.00 32.00 0.00 32.00 32.00 -32.00 0.00 -65.00 64.00 -32.00 33.00 0.00 96.00 -32.00 32.00 0.00 65.00 129.00 0.00 32.00 -33.00 32.00 33.00 0.00 32.00 96.00 32.00 0.00 64.00 0.00 32.00 -32.00 32.00 65.00 0.00 32.00 -32.00 64.00 0.00 64.00 -32.00 97.00 32.00 64.00 97.00 129.00 0.00 64.00 32.00 32.00 96.00 97.00 65.00 0.00 64.00 32.00 64.00 32.00 129.00 0.00 64.00 32.00 65.00 -64.00 64.00 32.00 32.00 129.00 -96.00 64.00 -97.00 129.00 32.00 32.00 -32.00 32.00 0.00 32.00 97.00 0.00 32.00 96.00 32.00 33.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 -64.00 32.00 -64.00 -32.00 -65.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 0.00 33.00 -32.00 32.00 32.00 32.00 0.00 0.00 -65.00 64.00 0.00 32.00 33.00 65.00 -33.00 0.00 -96.00 64.00 -64.00 64.00 32.00 33.00 0.00 64.00 0.00 64.00 0.00 32.00 -97.00 0.00 -64.00 -64.00 -32.00 32.00 -64.00 32.00 0.00 0.00 32.00 65.00 0.00 64.00 0.00 32.00 -32.00 0.00 -33.00 32.00 33.00 64.00 -33.00 33.00 0.00 32.00 0.00 32.00 -64.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 32.00 0.00 0.00 -33.00 65.00 0.00 32.00 65.00 64.00 0.00 65.00 128.00 32.00 0.00 64.00 65.00 0.00 32.00 32.00 0.00 0.00 32.00 97.00 32.00 0.00 97.00 32.00 0.00 32.00 64.00 0.00 64.00 64.00 32.00 0.00 65.00 64.00 0.00 33.00 -65.00 0.00 65.00 32.00 -32.00 32.00 32.00 96.00 -32.00 65.00 32.00 64.00 -32.00 97.00 0.00 0.00 -65.00 32.00 -32.00 96.00 0.00 64.00 -64.00 97.00 0.00 32.00 64.00 64.00 0.00 32.00 0.00 33.00 -64.00 -33.00 -32.00 129.00 -33.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 64.00 96.00 32.00 -32.00 32.00 32.00 32.00 -32.00 33.00 32.00 0.00 65.00 0.00 32.00 32.00 0.00 -32.00 64.00 32.00 32.00 32.00 32.00 -64.00 97.00 96.00 0.00 -32.00 32.00 32.00 32.00 -32.00 64.00 32.00 129.00 64.00 64.00 32.00 33.00 65.00 -33.00 32.00 0.00 96.00 0.00 0.00 -32.00 65.00 0.00 32.00 -32.00 32.00 -32.00 64.00 -32.00 97.00 -65.00 64.00 -64.00 64.00 32.00 32.00 0.00 33.00 65.00 32.00 32.00 32.00 32.00 0.00 32.00 32.00 32.00 193.00 32.00 32.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -65.00 0.00 -64.00 32.00 -32.00 129.00 -96.00 96.00 32.00 65.00 32.00 0.00 64.00 32.00 0.00 32.00 0.00 32.00 -32.00 64.00 32.00 32.00 -32.00 33.00 -32.00 64.00 -32.00 0.00 -65.00 96.00 -64.00 0.00 -96.00 65.00 0.00 64.00 0.00 32.00 0.00 -32.00 -33.00 -32.00 -32.00 32.00 -32.00 64.00 -32.00 97.00 -129.00 32.00 -32.00 64.00 -32.00 161.00 0.00 64.00 -96.00 32.00 0.00 33.00 0.00 32.00 32.00 0.00 64.00 32.00 0.00 0.00 64.00 64.00 65.00 0.00 -32.00 64.00 -33.00 0.00 -64.00 -32.00 -32.00 -64.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 -64.00 33.00 0.00 32.00 -96.00 32.00 0.00 64.00 -33.00 0.00 -64.00 0.00 -32.00 129.00 -32.00 0.00 -65.00 96.00 -64.00 32.00 64.00 33.00 -32.00 64.00 32.00 64.00 -32.00 32.00 -32.00 0.00 -64.00 97.00 -32.00 96.00 -65.00 97.00 -32.00 96.00 -32.00 0.00 -32.00 0.00 -97.00 32.00 -32.00 33.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -97.00 32.00 -32.00 0.00 -64.00 -32.00 -64.00 32.00 -32.00 97.00 -33.00 128.00 33.00 32.00 -33.00 33.00 0.00 64.00 33.00 32.00 -33.00 96.00 0.00 193.00 -96.00 -32.00 -64.00 32.00 -65.00 65.00 -96.00 96.00 0.00 32.00 0.00 97.00 0.00 32.00 -65.00 96.00 0.00 33.00 0.00 96.00 0.00 96.00 65.00 65.00 32.00 96.00 64.00 32.00 65.00 32.00 64.00 33.00 0.00 64.00 0.00 32.00 64.00 32.00 -32.00 32.00 32.00 65.00 32.00 96.00 0.00 65.00 33.00 0.00 32.00 32.00 64.00 64.00 0.00 0.00 -32.00 32.00 0.00 97.00 64.00 64.00 64.00 -64.00 97.00 64.00 0.00 0.00 32.00 -32.00 32.00 32.00 64.00 32.00 33.00 64.00 32.00 0.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 -64.00 65.00 -32.00 -33.00 -96.00 33.00 0.00 32.00 -129.00 32.00 -64.00 64.00 -97.00 0.00 -64.00 64.00 -97.00 0.00 -64.00 97.00 -96.00 64.00 -65.00 65.00 -32.00 96.00 -32.00 96.00 -64.00 33.00 0.00 32.00 0.00 32.00 0.00 64.00 64.00 65.00 32.00 32.00 0.00 32.00 32.00 64.00 32.00 32.00 65.00 65.00 0.00 96.00 64.00 64.00 -96.00 129.00 0.00 32.00 32.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 33.00 0.00 32.00 -32.00 -32.00 -32.00 -33.00 -32.00 0.00 -32.00 33.00 -97.00 64.00 -32.00 -32.00 -32.00 32.00 -64.00 32.00 32.00 32.00 64.00 0.00 0.00 97.00 -96.00 32.00 -32.00 32.00 32.00 32.00 0.00 64.00 -193.00 129.00 -97.00 0.00 0.00 32.00 -64.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 -32.00 33.00 32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -96.00 32.00 -33.00 0.00 0.00 32.00 -32.00 97.00 65.00 0.00 0.00 32.00 96.00 -64.00 64.00 0.00 65.00 0.00 64.00 32.00 64.00 -32.00 97.00 0.00 32.00 32.00 32.00 -32.00 0.00 32.00 64.00 0.00 0.00 -65.00 65.00 -32.00 64.00 32.00 0.00 97.00 32.00 32.00 32.00 0.00 0.00 32.00 64.00 0.00 33.00 32.00 32.00 33.00 0.00 64.00 0.00 64.00 -32.00 97.00 0.00 64.00 64.00 96.00 -32.00 65.00 32.00 96.00 0.00 32.00 -32.00 0.00 -32.00 65.00 32.00 64.00 -65.00 32.00 0.00 32.00 33.00 32.00 64.00 33.00 96.00 -33.00 0.00 65.00 0.00 64.00 0.00 64.00 129.00 129.00 32.00 96.00 193.00 32.00 32.00 0.00 97.00 129.00 128.00 64.00 65.00 -32.00 96.00 0.00 32.00 0.00 32.00 -32.00 0.00 -64.00 97.00 -32.00 96.00 -97.00 33.00 -64.00 96.00 0.00 96.00 -64.00 225.00 -97.00 33.00 -64.00 64.00 0.00 64.00 0.00 65.00 32.00 32.00 -32.00 32.00 -64.00 32.00 -33.00 97.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 64.00 32.00 96.00 0.00 -32.00 -96.00 32.00 -33.00 97.00 -32.00 128.00 -32.00 65.00 -32.00 0.00 -64.00 -33.00 -33.00 -64.00 0.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 97.00 -64.00 0.00 -193.00 0.00 -129.00 32.00 -32.00 0.00 -64.00 32.00 -97.00 129.00 32.00 32.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 -97.00 32.00 -32.00 32.00 -32.00 64.00 -32.00 65.00 32.00 193.00 97.00 64.00 -33.00 32.00 33.00 64.00 -33.00 97.00 0.00 0.00 -32.00 32.00 -64.00 32.00 0.00 0.00 -64.00 -32.00 -33.00 32.00 -32.00 0.00 -160.00 0.00 -65.00 32.00 -32.00 65.00 0.00 64.00 -32.00 96.00 0.00 65.00 -32.00 32.00 32.00 257.00 0.00 32.00 0.00 32.00 32.00 97.00 64.00 32.00 0.00 64.00 0.00 32.00 -64.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 32.00 -33.00 161.00 -128.00 32.00 32.00 32.00 96.00 97.00 -32.00 161.00 0.00 96.00 0.00 32.00 0.00 64.00 -32.00 161.00 32.00 97.00 97.00 32.00 -32.00 32.00 0.00 64.00 64.00 97.00 0.00 32.00 32.00 32.00 -64.00 32.00 0.00 65.00 -65.00 64.00 0.00 64.00 0.00 32.00 -32.00 161.00 32.00 96.00 -64.00 0.00 -64.00 0.00 -32.00 33.00 -32.00 64.00 0.00 96.00 -33.00 65.00 33.00 32.00 0.00 32.00 0.00 96.00 -65.00 65.00 0.00 96.00 -64.00 32.00 0.00 33.00 -32.00 0.00 -32.00 32.00 0.00 96.00 -33.00 32.00 0.00 0.00 -32.00 65.00 -32.00 32.00 32.00 32.00 0.00 32.00 0.00 97.00 0.00 32.00 0.00 64.00 -64.00 32.00 -32.00 64.00 -64.00 0.00 -33.00 33.00 -32.00 64.00 0.00 32.00 0.00 64.00 0.00 65.00 32.00 128.00 -32.00 32.00 -32.00 65.00 0.00 -97.00 -129.00 32.00 -64.00 33.00 0.00 0.00 -32.00 32.00 -64.00 -65.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 33.00 -96.00 0.00 -97.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -64.00 0.00 -65.00 32.00 -160.00 97.00 -33.00 128.00 33.00 64.00 0.00 33.00 64.00 64.00 32.00 32.00 0.00 32.00 -64.00 129.00 -65.00 32.00 -32.00 32.00 0.00 64.00 0.00 0.00 -32.00 0.00 -64.00 33.00 0.00 64.00 0.00 0.00 -32.00 -32.00 -32.00 64.00 0.00 32.00 0.00 32.00 0.00 33.00 0.00 96.00 -97.00 193.00 -64.00 64.00 32.00 129.00 32.00 64.00 32.00 32.00 0.00 65.00 -32.00 64.00 32.00 32.00 0.00 97.00 32.00 32.00 0.00 96.00 33.00 64.00 -33.00 33.00 -32.00 32.00 0.00 32.00 32.00 96.00 65.00 65.00 64.00 128.00 96.00 97.00 65.00 0.00 64.00 -32.00 64.00 32.00 65.00 0.00 32.00 64.00 64.00 64.00 97.00 33.00 0.00 96.00 -65.00 32.00 32.00 32.00 33.00 32.00 0.00 33.00 0.00 0.00 32.00 32.00 0.00 32.00 -65.00 96.00 65.00 65.00 -32.00 64.00 32.00 32.00 0.00 32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 64.00 32.00 65.00 32.00 32.00 0.00 64.00 65.00 64.00 0.00 65.00 -65.00 96.00 -64.00 193.00 -32.00 0.00 -32.00 32.00 32.00 32.00 64.00 0.00 -32.00 65.00 32.00 64.00 32.00 96.00 -64.00 225.00 0.00 97.00 -64.00 0.00 0.00 32.00 32.00 64.00 0.00 33.00 0.00 32.00 32.00 0.00 0.00 160.00 64.00 65.00 0.00 96.00 0.00 32.00 -32.00 225.00 -32.00 129.00 0.00 97.00 -129.00 128.00 0.00 32.00 0.00 32.00 -96.00 225.00 -129.00 354.00 -32.00 97.00 0.00 96.00 -32.00 97.00 32.00 0.00 -96.00 160.00 -32.00 97.00 -32.00 64.00 0.00 32.00 64.00 32.00 -64.00 161.00 0.00 32.00 32.00 0.00 32.00 33.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 65.00 64.00 -129.00 289.00 -32.00 129.00 -32.00 64.00 -33.00 65.00 0.00 32.00 0.00 64.00 -32.00 32.00 0.00 65.00 32.00 64.00 -32.00 32.00 0.00 64.00 0.00 33.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 -32.00 32.00 -33.00 64.00 -32.00 32.00 0.00 64.00 0.00 33.00 -96.00 160.00 -32.00 32.00 32.00 97.00 -64.00 32.00 -33.00 64.00 33.00 65.00 0.00 32.00 -33.00 32.00 -32.00 64.00 32.00 65.00 -96.00 128.00 0.00 65.00 32.00 0.00 -32.00 64.00 -32.00 0.00 -97.00 128.00 0.00 97.00 33.00 96.00 0.00 33.00 -65.00 32.00 -64.00 193.00 0.00 -65.00 -97.00 -64.00 -128.00 0.00 -32.00 0.00 -65.00 0.00 -64.00 -32.00 -64.00 32.00 -129.00 -64.00 -64.00 0.00 -32.00 0.00 -258.00 -65.00 -225.00 -64.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 0.00 32.00 -97.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -65.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -65.00 0.00 0.00 33.00 -32.00 -33.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 0.00 -65.00 65.00 0.00 -65.00 -32.00 32.00 -32.00 33.00 -64.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 64.00 -97.00 0.00 -64.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 64.00 -96.00 0.00 -32.00 65.00 -65.00 -33.00 -32.00 33.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -65.00 -32.00 -64.00 -33.00 -32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 0.00 -65.00 0.00 32.00 -32.00 -64.00 -33.00 0.00 -64.00 64.00 -64.00 -32.00 -32.00 65.00 -65.00 0.00 -32.00 0.00 -64.00 -65.00 -129.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 33.00 -32.00 64.00 -33.00 0.00 -64.00 0.00 -32.00 32.00 -64.00 32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -64.00 65.00 -129.00 -32.00 -161.00 32.00 -96.00 128.00 -193.00 65.00 -32.00 64.00 32.00 64.00 64.00 32.00 32.00 65.00 -32.00 32.00 0.00 32.00 -64.00 64.00 -64.00 32.00 0.00 33.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 96.00 -32.00 32.00 -32.00 0.00 0.00 65.00 -64.00 64.00 -65.00 0.00 -96.00 0.00 0.00 64.00 32.00 32.00 0.00 33.00 0.00 64.00 64.00 0.00 32.00 32.00 0.00 64.00 65.00 32.00 0.00 33.00 -97.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -33.00 -65.00 33.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 32.00 -33.00 64.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 0.00 32.00 32.00 33.00 -32.00 32.00 -32.00 32.00 -65.00 -32.00 -64.00 32.00 -64.00 0.00 -32.00 -32.00 -33.00 64.00 -32.00 -32.00 0.00 -64.00 -64.00 0.00 0.00 32.00 -64.00 32.00 0.00 32.00 -33.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 65.00 0.00 32.00 -32.00 32.00 -33.00 32.00 -321.00 96.00 0.00 129.00 32.00 0.00 0.00 32.00 0.00 32.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 -64.00 33.00 0.00 -33.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 -32.00 -97.00 -129.00 -64.00 -32.00 -289.00 -32.00 -193.00 96.00 -193.00 0.00 -32.00 -64.00 -32.00 -32.00 -97.00 0.00 -32.00 32.00 32.00 0.00 -96.00 32.00 -32.00 0.00 -65.00 65.00 -64.00 128.00 32.00 32.00 0.00 32.00 -96.00 65.00 0.00 64.00 32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 33.00 -32.00 0.00 -96.00 -97.00 -129.00 -64.00 -96.00 -161.00 -129.00 0.00 -32.00 -64.00 0.00 64.00 -32.00 -64.00 32.00 -97.00 -96.00 -128.00 -33.00 -32.00 -128.00 -65.00 -32.00 0.00 -65.00 97.00 -64.00 32.00 -97.00 64.00 -32.00 -32.00 0.00 -32.00 0.00 -64.00 65.00 -65.00 -193.00 -128.00 -65.00 32.00 -96.00 96.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 -65.00 -65.00 -32.00 -32.00 -64.00 -64.00 -97.00 -129.00 -64.00 -64.00 0.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 -64.00 -322.00 -129.00 -64.00 -64.00 -97.00 -65.00 -64.00 0.00 -96.00 0.00 -129.00 -128.00 32.00 -33.00 0.00 -96.00 0.00 -32.00 -96.00 0.00 -65.00 -32.00 -32.00 0.00 -64.00 -32.00 -97.00 96.00 -96.00 -32.00 -64.00 32.00 -65.00 64.00 -32.00 65.00 32.00 32.00 -32.00 32.00 -128.00 0.00 -65.00 -32.00 -32.00 -32.00 32.00 -33.00 0.00 -32.00 -128.00 65.00 0.00 -65.00 -65.00 32.00 0.00 -32.00 33.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 -65.00 -33.00 -32.00 -64.00 0.00 -32.00 -64.00 -64.00 -32.00 -65.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 -64.00 -64.00 -65.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -97.00 97.00 -32.00 0.00 -96.00 64.00 32.00 32.00 0.00 65.00 -65.00 64.00 33.00 32.00 -33.00 193.00 -32.00 32.00 -32.00 64.00 -64.00 65.00 -65.00 32.00 0.00 32.00 -32.00 97.00 -32.00 -33.00 -64.00 33.00 -32.00 64.00 -129.00 129.00 -32.00 64.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -65.00 65.00 -32.00 96.00 -64.00 32.00 -32.00 0.00 -65.00 0.00 -64.00 0.00 -32.00 64.00 -64.00 0.00 -33.00 0.00 -64.00 33.00 -64.00 0.00 -64.00 0.00 -33.00 32.00 -96.00 96.00 -97.00 97.00 -64.00 128.00 0.00 33.00 0.00 64.00 -128.00 128.00 -97.00 33.00 -161.00 160.00 -64.00 -193.00 -161.00 -353.00 32.00 -65.00 -64.00 -160.00 -64.00 -97.00 -32.00 -32.00 -32.00 -32.00 -33.00 -129.00 97.00 -96.00 -64.00 0.00 -33.00 -64.00 33.00 -65.00 96.00 -64.00 32.00 -32.00 0.00 -32.00 -32.00 -97.00 -96.00 -96.00 0.00 -65.00 -97.00 0.00 -64.00 32.00 -32.00 0.00 -129.00 129.00 -97.00 97.00 -96.00 -33.00 -64.00 -32.00 -65.00 -32.00 -128.00 -96.00 -97.00 -97.00 -64.00 -96.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 129.00 -97.00 32.00 -64.00 32.00 -129.00 -64.00 -64.00 -129.00 -96.00 -193.00 -33.00 -96.00 33.00 -161.00 257.00 -32.00 64.00 0.00 290.00 -64.00 128.00 -33.00 0.00 -64.00 32.00 -128.00 -64.00 -65.00 -129.00 -32.00 -64.00 0.00 -96.00 -32.00 -161.00 -32.00 -97.00 -65.00 -64.00 -96.00 -32.00 -129.00 -129.00 -128.00 -96.00 -32.00 -32.00 -33.00 0.00 -225.00 -32.00 -64.00 0.00 -64.00 32.00 -193.00 32.00 -97.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 -32.00 -65.00 -129.00 -128.00 -64.00 -65.00 -64.00 -32.00 0.00 -128.00 -33.00 -129.00 -32.00 -161.00 -32.00 -128.00 -32.00 0.00 -32.00 -65.00 -65.00 -32.00 33.00 -32.00 32.00 -96.00 32.00 -97.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -33.00 -65.00 0.00 -32.00 0.00 -161.00 33.00 -32.00 -33.00 -64.00 -32.00 -32.00 -64.00 -32.00 -32.00 -97.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 -32.00 -33.00 -65.00 0.00 -128.00 0.00 -65.00 0.00 -64.00 -64.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -33.00 0.00 -128.00 32.00 -32.00 0.00 -33.00 96.00 -64.00 0.00 -64.00 0.00 -32.00 33.00 0.00 64.00 -97.00 64.00 -193.00 64.00 -32.00 33.00 -128.00 32.00 -33.00 32.00 -32.00 32.00 0.00 32.00 -193.00 64.00 -96.00 0.00 -97.00 33.00 -64.00 0.00 -128.00 0.00 -33.00 96.00 65.00 129.00 32.00 161.00 0.00 32.00 0.00 64.00 32.00 96.00 -32.00 33.00 -32.00 32.00 -32.00 32.00 -65.00 0.00 -225.00 -32.00 -193.00 128.00 -64.00 0.00 -64.00 -32.00 -258.00 64.00 -96.00 33.00 -32.00 32.00 0.00 64.00 0.00 32.00 0.00 32.00 96.00 193.00 32.00 129.00 -96.00 193.00 -64.00 32.00 -33.00 96.00 -32.00 33.00 -193.00 225.00 -96.00 32.00 -64.00 32.00 -33.00 0.00 -160.00 0.00 -129.00 0.00 -64.00 64.00 -65.00 65.00 -192.00 96.00 -97.00 0.00 -64.00 0.00 -32.00 -64.00 -97.00 -64.00 -96.00 -97.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 0.00 -32.00 32.00 -97.00 97.00 -64.00 192.00 -32.00 161.00 32.00 129.00 -32.00 96.00 -64.00 354.00 -65.00 64.00 -64.00 193.00 0.00 32.00 0.00 97.00 -129.00 128.00 -32.00 0.00 -96.00 -32.00 -97.00 -96.00 -64.00 0.00 -64.00 64.00 -97.00 193.00 -64.00 96.00 -32.00 -32.00 -97.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 32.00 -32.00 32.00 -32.00 129.00 -32.00 0.00 -64.00 64.00 -32.00 33.00 -33.00 0.00 -64.00 0.00 -161.00 64.00 -128.00 -32.00 -129.00 -32.00 -161.00 -97.00 -32.00 -32.00 -128.00 0.00 -129.00 64.00 32.00 -64.00 32.00 -64.00 0.00 -97.00 65.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -64.00 -32.00 -65.00 64.00 -64.00 -32.00 -64.00 32.00 -33.00 -97.00 -128.00 33.00 -32.00 32.00 0.00 0.00 -32.00 96.00 32.00 64.00 -32.00 0.00 -33.00 0.00 -32.00 97.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 0.00 0.00 -65.00 -32.00 -64.00 64.00 -96.00 0.00 -33.00 32.00 -64.00 0.00 -32.00 0.00 -64.00 32.00 -65.00 -64.00 -32.00 -32.00 -64.00 -97.00 0.00 -32.00 0.00 -96.00 -64.00 -64.00 -33.00 -33.00 0.00 0.00 -64.00 -32.00 0.00 -64.00 -32.00 -64.00 32.00 0.00 -32.00 -65.00 0.00 -32.00 -64.00 -64.00 -32.00 32.00 -65.00 -32.00 -32.00 0.00 -96.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -64.00 -33.00 -65.00 -32.00 -64.00 0.00 -161.00 -64.00 0.00 0.00 -128.00 -97.00 -32.00 0.00 -65.00 -64.00 -64.00 0.00 -96.00 0.00 -33.00 -32.00 0.00 -64.00 -64.00 0.00 -64.00 -129.00 32.00 -64.00 0.00 0.00 -64.00 -97.00 -33.00 -64.00 33.00 -32.00 0.00 -97.00 64.00 -64.00 -32.00 32.00 -129.00 -32.00 -128.00 -32.00 0.00 -64.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -96.00 0.00 -33.00 -65.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -64.00 0.00 -33.00 32.00 -32.00 0.00 -32.00 32.00 -64.00 -225.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 32.00 -96.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -97.00 0.00 -64.00 64.00 -65.00 33.00 -32.00 0.00 -96.00 -65.00 -97.00 0.00 -128.00 -96.00z"},ma:{name:"MA",path:"M125256.00 53503.00l932.00 -772.00 450.00 -322.00 33.00 -64.00 96.00 -64.00 -32.00 -65.00 32.00 -32.00 32.00 0.00 32.00 32.00 97.00 -64.00 900.00 -707.00 64.00 -65.00 547.00 -450.00 97.00 -64.00 160.00 -129.00 386.00 -321.00 611.00 -482.00 64.00 -97.00 65.00 -64.00 96.00 32.00 64.00 0.00 33.00 64.00 32.00 -32.00 64.00 32.00 64.00 0.00 65.00 0.00 96.00 32.00 129.00 -96.00 64.00 -96.00 64.00 -33.00 65.00 -32.00 32.00 -32.00 128.00 -161.00 65.00 -193.00 160.00 -160.00 65.00 -97.00 64.00 -96.00 0.00 -65.00 64.00 -64.00 0.00 -64.00 65.00 -65.00 -32.00 0.00 32.00 -64.00 0.00 -64.00 32.00 -32.00 -32.00 -32.00 128.00 -65.00 32.00 -64.00 33.00 0.00 32.00 0.00 0.00 -64.00 64.00 32.00 32.00 -65.00 32.00 0.00 65.00 -96.00 32.00 0.00 32.00 0.00 -32.00 -129.00 32.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 32.00 -32.00 -32.00 -33.00 64.00 -32.00 33.00 32.00 32.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 -65.00 -33.00 -64.00 33.00 -32.00 0.00 -32.00 64.00 -65.00 0.00 -32.00 0.00 -64.00 32.00 0.00 0.00 -64.00 32.00 -33.00 65.00 0.00 -33.00 33.00 33.00 0.00 0.00 -33.00 64.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -32.00 64.00 0.00 0.00 -32.00 97.00 -65.00 32.00 -64.00 64.00 0.00 33.00 0.00 32.00 -64.00 32.00 0.00 32.00 -64.00 32.00 32.00 0.00 -65.00 32.00 0.00 0.00 -32.00 0.00 -64.00 32.00 0.00 33.00 -32.00 0.00 -97.00 64.00 -32.00 64.00 -64.00 32.00 32.00 0.00 -32.00 0.00 -97.00 32.00 0.00 33.00 0.00 32.00 0.00 32.00 0.00 32.00 -96.00 64.00 -32.00 33.00 -65.00 -33.00 -64.00 65.00 -32.00 0.00 -32.00 0.00 -64.00 64.00 -33.00 0.00 -32.00 0.00 -64.00 0.00 -64.00 32.00 -65.00 0.00 -64.00 -32.00 -32.00 64.00 -32.00 0.00 -65.00 -32.00 -128.00 97.00 -65.00 -32.00 -32.00 -33.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 33.00 -32.00 -33.00 -32.00 33.00 0.00 -33.00 0.00 33.00 -32.00 -33.00 -33.00 33.00 -32.00 32.00 -64.00 32.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -64.00 64.00 -32.00 0.00 -33.00 65.00 0.00 32.00 -32.00 64.00 -32.00 -32.00 -32.00 64.00 0.00 -64.00 -97.00 0.00 -32.00 64.00 0.00 0.00 32.00 32.00 0.00 -32.00 -128.00 97.00 32.00 0.00 -64.00 -33.00 0.00 0.00 -32.00 33.00 0.00 -33.00 -33.00 65.00 0.00 -32.00 -64.00 -33.00 0.00 0.00 -64.00 33.00 0.00 0.00 -32.00 0.00 32.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -96.00 32.00 32.00 32.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 0.00 32.00 -32.00 33.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 64.00 -64.00 32.00 -32.00 32.00 32.00 0.00 32.00 64.00 -32.00 0.00 -32.00 -32.00 -33.00 32.00 0.00 33.00 65.00 32.00 0.00 0.00 -32.00 0.00 -65.00 64.00 32.00 32.00 -64.00 32.00 0.00 65.00 0.00 0.00 -64.00 -65.00 -32.00 65.00 -65.00 -65.00 -64.00 33.00 0.00 32.00 0.00 32.00 0.00 0.00 -128.00 32.00 -33.00 32.00 33.00 32.00 0.00 32.00 -65.00 -32.00 -32.00 32.00 -32.00 65.00 0.00 32.00 32.00 0.00 -32.00 0.00 -32.00 -64.00 -32.00 64.00 -33.00 0.00 -32.00 -97.00 -64.00 65.00 0.00 64.00 64.00 32.00 -32.00 -32.00 -96.00 64.00 0.00 33.00 0.00 32.00 -65.00 -32.00 -32.00 0.00 -64.00 -65.00 32.00 -32.00 -64.00 32.00 0.00 32.00 0.00 33.00 0.00 32.00 -65.00 32.00 0.00 0.00 97.00 32.00 0.00 32.00 -32.00 -32.00 -129.00 96.00 -32.00 33.00 32.00 0.00 -96.00 32.00 -32.00 -32.00 -65.00 0.00 -96.00 64.00 -32.00 -32.00 -32.00 64.00 -65.00 -64.00 -32.00 0.00 -32.00 32.00 -32.00 64.00 32.00 32.00 -64.00 -32.00 -33.00 -32.00 0.00 0.00 -32.00 64.00 0.00 0.00 -32.00 -32.00 -32.00 -64.00 0.00 0.00 -64.00 0.00 -33.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -64.00 32.00 0.00 -64.00 -65.00 -32.00 0.00 0.00 -32.00 64.00 -32.00 64.00 0.00 32.00 32.00 33.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 64.00 32.00 64.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 64.00 0.00 65.00 64.00 32.00 -32.00 32.00 0.00 -64.00 -32.00 32.00 0.00 0.00 -32.00 -64.00 32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 -33.00 0.00 0.00 -32.00 0.00 -97.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -64.00 32.00 -32.00 -64.00 0.00 -64.00 0.00 -65.00 0.00 -64.00 -32.00 0.00 -33.00 32.00 -32.00 -96.00 0.00 -32.00 0.00 -32.00 -64.00 32.00 0.00 -32.00 -32.00 -65.00 64.00 -96.00 64.00 -32.00 0.00 -32.00 65.00 32.00 0.00 -32.00 0.00 -33.00 64.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 0.00 65.00 128.00 32.00 -32.00 0.00 -129.00 64.00 -32.00 32.00 0.00 64.00 0.00 65.00 -32.00 161.00 -32.00 -33.00 -129.00 65.00 -32.00 32.00 0.00 32.00 -64.00 -32.00 -32.00 -32.00 -32.00 0.00 -65.00 32.00 -32.00 32.00 0.00 32.00 32.00 65.00 0.00 225.00 -64.00 0.00 -32.00 -65.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -64.00 0.00 -64.00 32.00 -65.00 -32.00 0.00 0.00 -32.00 0.00 -96.00 0.00 -97.00 64.00 -64.00 33.00 -64.00 32.00 -65.00 0.00 -32.00 -65.00 -32.00 -96.00 129.00 -32.00 0.00 -64.00 -33.00 0.00 -32.00 0.00 -64.00 128.00 -96.00 32.00 -33.00 0.00 -64.00 0.00 -96.00 32.00 -33.00 33.00 -160.00 -65.00 -65.00 0.00 -32.00 97.00 -32.00 32.00 64.00 64.00 33.00 64.00 -33.00 33.00 -96.00 64.00 0.00 64.00 -32.00 0.00 -32.00 65.00 -129.00 64.00 -64.00 96.00 -32.00 65.00 -65.00 -65.00 -32.00 0.00 -32.00 97.00 -97.00 32.00 -32.00 0.00 -96.00 -32.00 -64.00 0.00 -97.00 32.00 -64.00 32.00 -32.00 64.00 -97.00 0.00 -96.00 65.00 -161.00 64.00 -289.00 -32.00 -129.00 -64.00 0.00 0.00 -32.00 160.00 -225.00 -32.00 -65.00 -32.00 -32.00 -32.00 -64.00 -161.00 -32.00 -96.00 32.00 -32.00 0.00 -33.00 -32.00 -64.00 64.00 -32.00 -32.00 -32.00 -161.00 32.00 -128.00 32.00 -33.00 32.00 -32.00 65.00 0.00 128.00 0.00 97.00 -32.00 64.00 32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 33.00 0.00 96.00 -32.00 64.00 -65.00 33.00 -64.00 0.00 -64.00 -33.00 -32.00 0.00 -33.00 0.00 -96.00 65.00 -97.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 96.00 -32.00 -64.00 -289.00 0.00 -65.00 -65.00 -64.00 -32.00 -32.00 -64.00 -65.00 193.00 -160.00 0.00 -33.00 -97.00 -64.00 129.00 -96.00 32.00 -129.00 32.00 -32.00 33.00 -96.00 32.00 -65.00 0.00 -32.00 -129.00 32.00 0.00 -32.00 0.00 -96.00 -96.00 0.00 -65.00 -161.00 129.00 -129.00 -64.00 -128.00 96.00 -97.00 97.00 -32.00 32.00 0.00 0.00 32.00 128.00 -32.00 0.00 -193.00 32.00 -32.00 0.00 64.00 33.00 -32.00 0.00 -64.00 32.00 -64.00 32.00 0.00 0.00 32.00 0.00 64.00 64.00 96.00 0.00 -32.00 -32.00 -64.00 0.00 -96.00 0.00 -65.00 32.00 -64.00 32.00 0.00 65.00 -129.00 0.00 32.00 0.00 -64.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 64.00 32.00 0.00 0.00 -128.00 0.00 -32.00 32.00 32.00 0.00 -65.00 129.00 0.00 0.00 65.00 -64.00 0.00 0.00 32.00 32.00 -32.00 32.00 32.00 0.00 64.00 32.00 0.00 0.00 32.00 -64.00 33.00 0.00 -33.00 -65.00 0.00 -32.00 0.00 97.00 0.00 0.00 97.00 -32.00 0.00 -33.00 64.00 33.00 -32.00 64.00 -32.00 32.00 0.00 0.00 -32.00 0.00 32.00 0.00 96.00 0.00 33.00 -96.00 0.00 -65.00 32.00 32.00 32.00 -32.00 32.00 -32.00 32.00 64.00 -32.00 0.00 32.00 0.00 32.00 33.00 -32.00 -33.00 -32.00 33.00 -64.00 64.00 0.00 0.00 32.00 32.00 -32.00 64.00 0.00 -32.00 64.00 0.00 32.00 32.00 0.00 -32.00 64.00 0.00 97.00 -32.00 32.00 32.00 32.00 -32.00 129.00 32.00 32.00 32.00 -32.00 33.00 -161.00 0.00 -32.00 128.00 -257.00 32.00 32.00 -32.00 -32.00 64.00 -129.00 33.00 0.00 0.00 -32.00 64.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 96.00 -97.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 -32.00 96.00 -33.00 -32.00 0.00 32.00 0.00 33.00 0.00 -33.00 0.00 33.00 33.00 32.00 160.00 -32.00 65.00 0.00 -32.00 0.00 32.00 -65.00 64.00 0.00 32.00 0.00 32.00 -128.00 33.00 0.00 32.00 -129.00 128.00 0.00 32.00 -32.00 33.00 32.00 0.00 32.00 0.00 -32.00 64.00 -32.00 0.00 0.00 32.00 64.00 -32.00 0.00 -97.00 65.00 -96.00 64.00 -32.00 32.00 0.00 32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 32.00 0.00 0.00 33.00 -64.00 0.00 0.00 32.00 64.00 -32.00 32.00 -33.00 32.00 -32.00 0.00 32.00 -64.00 97.00 64.00 -32.00 -32.00 64.00 -32.00 32.00 -32.00 32.00 -65.00 65.00 -64.00 0.00 64.00 32.00 0.00 32.00 -64.00 0.00 -32.00 0.00 32.00 0.00 32.00 0.00 -32.00 64.00 32.00 32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 -32.00 96.00 0.00 96.00 -65.00 0.00 32.00 -96.00 65.00 0.00 64.00 32.00 -32.00 64.00 -97.00 0.00 65.00 -160.00 128.00 0.00 32.00 128.00 0.00 -32.00 33.00 -32.00 32.00 32.00 32.00 0.00 -64.00 32.00 -33.00 65.00 -160.00 32.00 -161.00 0.00 -32.00 64.00 64.00 32.00 64.00 -32.00 97.00 -32.00 64.00 64.00 -161.00 -64.00 -192.00 64.00 -65.00 65.00 -32.00 32.00 32.00 0.00 32.00 32.00 -32.00 -32.00 65.00 -32.00 32.00 -33.00 96.00 0.00 32.00 65.00 65.00 -107.00 160.00 10.00 0.00 0.00 25.00 32.00 -25.00 0.00 -32.00 33.00 0.00 32.00 0.00 -32.00 -32.00 32.00 -64.00 32.00 32.00 -32.00 64.00 32.00 0.00 32.00 64.00 -96.00 65.00 -65.00 -32.00 0.00 32.00 32.00 -32.00 65.00 32.00 64.00 -32.00 0.00 32.00 32.00 -32.00 -32.00 0.00 -32.00 -129.00 64.00 -129.00 32.00 -128.00 0.00 -32.00 32.00 0.00 0.00 32.00 0.00 32.00 65.00 -129.00 0.00 -64.00 32.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 -64.00 -32.00 129.00 -33.00 96.00 0.00 32.00 33.00 32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -64.00 65.00 -33.00 64.00 -32.00 32.00 0.00 64.00 -32.00 0.00 32.00 65.00 -64.00 64.00 -32.00 0.00 32.00 0.00 32.00 -32.00 64.00 0.00 33.00 96.00 64.00 97.00 0.00 64.00 -32.00 64.00 32.00 65.00 -97.00 0.00 -32.00 64.00 -32.00 96.00 32.00 33.00 0.00 -33.00 32.00 -64.00 0.00 -64.00 33.00 0.00 32.00 0.00 32.00 -32.00 32.00 32.00 0.00 96.00 64.00 32.00 -128.00 65.00 -32.00 32.00 -33.00 0.00 0.00 64.00 -64.00 0.00 -32.00 32.00 -64.00 -64.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 32.00 32.00 -32.00 64.00 0.00 33.00 -32.00 64.00 -64.00 96.00 -32.00 32.00 -33.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -65.00 0.00 65.00 -32.00 32.00 0.00 -32.00 -32.00 -33.00 0.00 -64.00 32.00 32.00 32.00 0.00 -32.00 -32.00 0.00 -96.00 129.00 -97.00 32.00 97.00 0.00 -33.00 64.00 -96.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -193.00 0.00 -128.00 32.00 -97.00 0.00 -64.00 33.00 -64.00 32.00 32.00 0.00 -32.00 0.00 -33.00 -65.00 0.00 33.00 -32.00 32.00 -32.00 32.00 64.00 32.00 0.00 0.00 65.00 0.00 128.00 0.00 32.00 -32.00 33.00 0.00 -33.00 -64.00 97.00 -33.00 128.00 0.00 65.00 33.00 0.00 0.00 32.00 0.00 64.00 0.00 32.00 -65.00 65.00 0.00 96.00 0.00 32.00 0.00 32.00 0.00 33.00 0.00 32.00 -32.00 -32.00 32.00 96.00 32.00 0.00 0.00 -64.00 0.00 -32.00 0.00 32.00 33.00 32.00 -33.00 64.00 0.00 65.00 -64.00 32.00 32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 0.00 0.00 -28.00 -225.00 28.00 0.00 -32.00 -32.00 160.00 -65.00 65.00 -32.00 64.00 32.00 -64.00 65.00 -32.00 32.00 -33.00 32.00 33.00 32.00 0.00 -64.00 -65.00 0.00 -32.00 32.00 -32.00 96.00 0.00 -32.00 32.00 65.00 -32.00 128.00 0.00 32.00 -32.00 65.00 -97.00 0.00 -64.00 0.00 -32.00 -32.00 -64.00 32.00 -161.00 32.00 -32.00 96.00 -33.00 0.00 33.00 0.00 -33.00 32.00 -32.00 33.00 32.00 -33.00 33.00 33.00 32.00 -65.00 96.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 0.00 161.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 -64.00 32.00 32.00 0.00 32.00 33.00 33.00 -33.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -64.00 32.00 -65.00 65.00 -96.00 64.00 -32.00 0.00 32.00 -32.00 32.00 129.00 -97.00 32.00 0.00 -32.00 129.00 -65.00 -32.00 -32.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 -64.00 33.00 0.00 32.00 -32.00 64.00 -64.00 0.00 0.00 32.00 32.00 -32.00 64.00 0.00 32.00 -96.00 65.00 -33.00 0.00 33.00 0.00 32.00 32.00 0.00 -32.00 32.00 -33.00 32.00 -32.00 -32.00 -64.00 32.00 0.00 64.00 32.00 33.00 -32.00 32.00 -32.00 96.00 32.00 -64.00 64.00 -64.00 -32.00 -65.00 0.00 -32.00 32.00 0.00 32.00 32.00 33.00 0.00 64.00 -64.00 0.00 -64.00 32.00 -65.00 64.00 -32.00 -32.00 64.00 0.00 33.00 0.00 32.00 -32.00 64.00 -32.00 64.00 -32.00 33.00 32.00 -33.00 32.00 -32.00 0.00 65.00 -32.00 32.00 0.00 32.00 -97.00 32.00 97.00 0.00 32.00 -64.00 0.00 32.00 32.00 64.00 -96.00 129.00 32.00 32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 64.00 -33.00 -32.00 0.00 65.00 -128.00 32.00 -32.00 0.00 32.00 64.00 -64.00 0.00 -33.00 -32.00 33.00 -64.00 32.00 0.00 -32.00 64.00 -65.00 32.00 32.00 0.00 -96.00 0.00 -32.00 64.00 0.00 33.00 0.00 0.00 -32.00 32.00 0.00 0.00 -33.00 -32.00 0.00 32.00 -32.00 128.00 -32.00 65.00 97.00 -33.00 96.00 -32.00 64.00 -32.00 33.00 -64.00 -97.00 32.00 64.00 0.00 33.00 -32.00 0.00 0.00 32.00 -64.00 32.00 0.00 -64.00 0.00 64.00 -33.00 0.00 -64.00 32.00 0.00 96.00 -64.00 129.00 32.00 32.00 0.00 64.00 -32.00 0.00 -32.00 -32.00 64.00 97.00 0.00 32.00 -64.00 96.00 64.00 0.00 32.00 65.00 -32.00 64.00 32.00 -32.00 64.00 0.00 0.00 96.00 -32.00 65.00 -64.00 -32.00 -32.00 64.00 -32.00 -32.00 32.00 32.00 0.00 32.00 0.00 -32.00 32.00 -32.00 129.00 64.00 0.00 -32.00 -33.00 0.00 33.00 -64.00 0.00 -97.00 -65.00 -96.00 0.00 -33.00 65.00 -64.00 0.00 -64.00 96.00 -129.00 32.00 0.00 0.00 -32.00 32.00 32.00 -32.00 64.00 0.00 97.00 -32.00 32.00 32.00 32.00 32.00 65.00 32.00 32.00 -96.00 -129.00 64.00 -32.00 0.00 -64.00 32.00 -33.00 33.00 33.00 0.00 32.00 -33.00 0.00 0.00 32.00 33.00 32.00 -33.00 -32.00 0.00 -32.00 33.00 32.00 32.00 -32.00 -65.00 -65.00 33.00 -64.00 32.00 -32.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 -96.00 0.00 -32.00 -64.00 64.00 -64.00 64.00 -33.00 0.00 -32.00 65.00 32.00 -33.00 0.00 0.00 65.00 0.00 -65.00 65.00 0.00 -32.00 -32.00 -65.00 -32.00 -32.00 0.00 32.00 64.00 -32.00 0.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 33.00 -65.00 64.00 33.00 -64.00 0.00 0.00 32.00 64.00 -32.00 32.00 64.00 -32.00 -32.00 32.00 -32.00 -32.00 32.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 -97.00 -64.00 0.00 -32.00 65.00 -32.00 128.00 32.00 33.00 64.00 0.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 97.00 0.00 32.00 0.00 64.00 0.00 65.00 0.00 -129.00 32.00 0.00 32.00 257.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 32.00 0.00 33.00 -65.00 0.00 -128.00 64.00 -129.00 64.00 0.00 32.00 -32.00 33.00 0.00 64.00 32.00 96.00 32.00 0.00 -32.00 0.00 -32.00 -160.00 32.00 0.00 64.00 -65.00 65.00 0.00 32.00 0.00 0.00 97.00 -65.00 32.00 0.00 64.00 -32.00 65.00 0.00 32.00 -32.00 64.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 129.00 -32.00 0.00 0.00 32.00 32.00 -32.00 32.00 -129.00 32.00 0.00 32.00 32.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 65.00 -65.00 0.00 -32.00 32.00 -64.00 32.00 -65.00 32.00 33.00 32.00 32.00 -32.00 64.00 -32.00 0.00 64.00 32.00 0.00 32.00 0.00 -32.00 0.00 -161.00 65.00 33.00 64.00 64.00 -64.00 96.00 0.00 65.00 -33.00 64.00 0.00 64.00 -32.00 32.00 -64.00 129.00 0.00 32.00 -32.00 32.00 32.00 97.00 0.00 32.00 -64.00 -64.00 -33.00 32.00 -32.00 0.00 32.00 32.00 33.00 -64.00 64.00 64.00 -97.00 193.00 0.00 32.00 -64.00 0.00 -32.00 32.00 -64.00 0.00 0.00 65.00 -32.00 0.00 -33.00 64.00 33.00 -64.00 32.00 0.00 32.00 -65.00 32.00 32.00 32.00 -32.00 32.00 -32.00 -64.00 97.00 32.00 32.00 -64.00 64.00 64.00 -64.00 0.00 -65.00 32.00 -32.00 32.00 0.00 -32.00 161.00 32.00 64.00 33.00 65.00 0.00 -33.00 64.00 0.00 0.00 -96.00 0.00 -129.00 32.00 -32.00 64.00 -193.00 0.00 -161.00 33.00 -32.00 96.00 -32.00 64.00 97.00 0.00 32.00 33.00 -32.00 32.00 64.00 64.00 -32.00 0.00 -32.00 -32.00 -97.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -97.00 0.00 -32.00 129.00 -96.00 64.00 -65.00 32.00 0.00 32.00 33.00 33.00 -65.00 32.00 0.00 -32.00 -64.00 32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 32.00 0.00 0.00 32.00 32.00 -32.00 33.00 0.00 0.00 32.00 0.00 32.00 -33.00 0.00 33.00 33.00 0.00 32.00 0.00 32.00 0.00 -32.00 0.00 -32.00 -33.00 32.00 33.00 64.00 32.00 32.00 -97.00 65.00 32.00 0.00 65.00 -65.00 0.00 97.00 0.00 64.00 32.00 32.00 32.00 0.00 32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -64.00 32.00 -65.00 -32.00 -96.00 0.00 -97.00 0.00 -64.00 32.00 -32.00 0.00 -64.00 32.00 -33.00 32.00 -96.00 32.00 -32.00 -32.00 -64.00 0.00 32.00 0.00 -32.00 0.00 -1.00 -32.00 -32.00 16.00 0.00 -16.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 0.00 32.00 32.00 -32.00 64.00 32.00 32.00 -32.00 33.00 -32.00 160.00 64.00 129.00 -32.00 64.00 -32.00 65.00 0.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 0.00 32.00 -32.00 64.00 32.00 0.00 0.00 -64.00 33.00 0.00 -33.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 65.00 33.00 32.00 -33.00 -97.00 -32.00 33.00 -96.00 64.00 64.00 0.00 32.00 0.00 32.00 -32.00 33.00 -65.00 32.00 65.00 -32.00 0.00 32.00 64.00 -65.00 0.00 -96.00 -64.00 -64.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 129.00 32.00 -97.00 32.00 32.00 32.00 65.00 -32.00 -33.00 -32.00 33.00 32.00 0.00 -32.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 161.00 0.00 64.00 -64.00 97.00 64.00 -65.00 32.00 -96.00 -32.00 -32.00 64.00 -33.00 65.00 65.00 0.00 64.00 0.00 -64.00 96.00 0.00 32.00 -32.00 32.00 0.00 33.00 32.00 64.00 64.00 64.00 0.00 32.00 64.00 33.00 0.00 -33.00 -64.00 0.00 -32.00 33.00 -64.00 64.00 -33.00 32.00 65.00 -64.00 0.00 0.00 32.00 0.00 64.00 32.00 32.00 -32.00 -64.00 32.00 -32.00 32.00 64.00 64.00 0.00 -64.00 0.00 -32.00 -64.00 193.00 -32.00 -32.00 0.00 -65.00 0.00 0.00 -32.00 32.00 -33.00 97.00 -128.00 64.00 -32.00 65.00 64.00 -33.00 -97.00 65.00 65.00 -32.00 -65.00 0.00 -32.00 64.00 0.00 -32.00 0.00 -32.00 -32.00 64.00 -32.00 64.00 32.00 0.00 -32.00 -32.00 0.00 96.00 0.00 -32.00 0.00 65.00 0.00 32.00 0.00 32.00 64.00 -64.00 32.00 0.00 -32.00 -65.00 97.00 32.00 193.00 -64.00 -32.00 0.00 -129.00 -32.00 64.00 0.00 97.00 -96.00 -32.00 -97.00 0.00 64.00 0.00 97.00 64.00 32.00 0.00 -32.00 0.00 -64.00 0.00 -33.00 0.00 65.00 32.00 -32.00 32.00 -33.00 32.00 -64.00 33.00 64.00 0.00 -32.00 64.00 0.00 32.00 -64.00 32.00 -64.00 0.00 32.00 64.00 -32.00 65.00 32.00 64.00 0.00 96.00 32.00 33.00 0.00 -33.00 64.00 0.00 65.00 -32.00 64.00 65.00 32.00 64.00 0.00 -32.00 96.00 -129.00 0.00 -96.00 33.00 0.00 96.00 96.00 0.00 64.00 32.00 65.00 -32.00 32.00 32.00 0.00 32.00 -32.00 -64.00 -97.00 32.00 0.00 97.00 129.00 -33.00 64.00 -96.00 97.00 96.00 -32.00 33.00 -97.00 0.00 -64.00 -33.00 -32.00 -32.00 -129.00 0.00 -32.00 65.00 0.00 -33.00 -32.00 33.00 0.00 0.00 32.00 32.00 -32.00 32.00 -65.00 0.00 129.00 -32.00 129.00 32.00 0.00 0.00 64.00 32.00 -32.00 32.00 -32.00 -96.00 -33.00 64.00 -32.00 64.00 65.00 -32.00 -97.00 0.00 -32.00 129.00 -96.00 32.00 -33.00 32.00 0.00 32.00 33.00 0.00 -33.00 0.00 -32.00 0.00 129.00 -96.00 96.00 0.00 65.00 0.00 32.00 -64.00 0.00 64.00 0.00 32.00 -65.00 64.00 -64.00 0.00 -32.00 33.00 0.00 0.00 -32.00 0.00 32.00 0.00 32.00 -33.00 0.00 33.00 32.00 32.00 -128.00 32.00 -65.00 32.00 33.00 32.00 64.00 0.00 32.00 32.00 32.00 32.00 97.00 33.00 64.00 0.00 96.00 -65.00 97.00 -32.00 -32.00 -32.00 -65.00 -32.00 33.00 -32.00 -33.00 0.00 33.00 -65.00 0.00 0.00 -65.00 -32.00 65.00 -161.00 0.00 -32.00 -33.00 -32.00 0.00 32.00 0.00 32.00 65.00 -64.00 96.00 -32.00 0.00 -32.00 32.00 -65.00 -64.00 -64.00 64.00 64.00 -64.00 0.00 64.00 33.00 0.00 0.00 33.00 -33.00 0.00 -64.00 64.00 -32.00 0.00 0.00 32.00 64.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 33.00 32.00 96.00 32.00 -64.00 65.00 -97.00 0.00 0.00 32.00 32.00 -32.00 65.00 32.00 64.00 -32.00 0.00 -65.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 -32.00 96.00 0.00 32.00 32.00 65.00 32.00 96.00 0.00 32.00 -32.00 32.00 0.00 0.00 97.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 0.00 32.00 32.00 -129.00 96.00 -32.00 33.00 -129.00 32.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 32.00 32.00 -32.00 0.00 32.00 -64.00 0.00 -32.00 65.00 -65.00 0.00 -64.00 32.00 129.00 -32.00 32.00 -33.00 64.00 0.00 64.00 -96.00 97.00 0.00 225.00 -64.00 0.00 32.00 -32.00 64.00 -65.00 32.00 -64.00 0.00 -32.00 32.00 64.00 -32.00 32.00 0.00 129.00 -96.00 0.00 64.00 64.00 0.00 -64.00 0.00 32.00 -64.00 32.00 -97.00 65.00 0.00 96.00 -32.00 32.00 -96.00 32.00 32.00 0.00 64.00 -32.00 32.00 -32.00 129.00 -32.00 0.00 -64.00 0.00 0.00 32.00 -32.00 0.00 0.00 97.00 64.00 -129.00 32.00 32.00 32.00 -32.00 32.00 -97.00 65.00 -64.00 0.00 32.00 -33.00 65.00 33.00 32.00 -33.00 -32.00 33.00 -97.00 -33.00 -64.00 0.00 -32.00 33.00 0.00 0.00 -32.00 32.00 0.00 -65.00 -33.00 0.00 -64.00 65.00 32.00 96.00 0.00 129.00 97.00 -32.00 32.00 -33.00 -32.00 -128.00 193.00 -32.00 64.00 64.00 129.00 -32.00 32.00 64.00 -32.00 32.00 -33.00 -32.00 0.00 0.00 -96.00 0.00 -32.00 129.00 -97.00 64.00 32.00 0.00 33.00 -129.00 64.00 33.00 64.00 -33.00 32.00 -32.00 0.00 65.00 97.00 0.00 32.00 0.00 32.00 64.00 65.00 64.00 -33.00 65.00 -64.00 32.00 -64.00 32.00 -32.00 64.00 64.00 0.00 64.00 -96.00 97.00 -97.00 64.00 -32.00 0.00 -64.00 64.00 -32.00 0.00 -33.00 32.00 33.00 -32.00 32.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 0.00 32.00 0.00 33.00 0.00 32.00 32.00 32.00 0.00 -32.00 -32.00 -65.00 129.00 -64.00 0.00 64.00 32.00 -32.00 0.00 32.00 32.00 33.00 0.00 -33.00 0.00 -96.00 32.00 0.00 33.00 32.00 64.00 193.00 32.00 32.00 32.00 32.00 0.00 129.00 -64.00 -32.00 0.00 -65.00 -32.00 33.00 -32.00 -33.00 -33.00 33.00 0.00 32.00 33.00 -32.00 32.00 32.00 96.00 64.00 -32.00 64.00 32.00 -32.00 32.00 0.00 0.00 97.00 -64.00 32.00 64.00 64.00 32.00 0.00 33.00 -32.00 0.00 32.00 -33.00 97.00 -96.00 32.00 -32.00 32.00 0.00 225.00 0.00 193.00 64.00 -32.00 97.00 32.00 32.00 32.00 128.00 97.00 32.00 64.00 -32.00 0.00 -32.00 64.00 32.00 -32.00 32.00 0.00 33.00 0.00 64.00 96.00 64.00 33.00 -64.00 32.00 0.00 32.00 -32.00 0.00 0.00 -32.00 0.00 32.00 0.00 32.00 64.00 -32.00 0.00 -32.00 32.00 32.00 0.00 96.00 65.00 161.00 -33.00 -32.00 -32.00 64.00 32.00 -32.00 65.00 0.00 96.00 225.00 -32.00 32.00 32.00 33.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -97.00 32.00 97.00 0.00 64.00 64.00 0.00 32.00 -32.00 65.00 -65.00 96.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 193.00 225.00 32.00 0.00 193.00 225.00 64.00 -32.00 32.00 -32.00 65.00 -32.00 128.00 0.00 32.00 0.00 161.00 -32.00 32.00 -32.00 129.00 -33.00 64.00 -32.00 65.00 -32.00 64.00 -32.00 64.00 -32.00 -32.00 -32.00 64.00 0.00 0.00 -32.00 97.00 -33.00 0.00 33.00 0.00 -33.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 -32.00 0.00 32.00 33.00 32.00 -33.00 0.00 33.00 32.00 -33.00 -32.00 -32.00 -64.00 0.00 0.00 -32.00 129.00 0.00 193.00 32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 -32.00 32.00 32.00 161.00 0.00 32.00 -32.00 0.00 -33.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 32.00 32.00 0.00 32.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 32.00 65.00 0.00 -32.00 32.00 -129.00 32.00 -32.00 32.00 -64.00 33.00 32.00 0.00 64.00 -33.00 0.00 -32.00 64.00 32.00 97.00 0.00 -65.00 0.00 33.00 33.00 32.00 64.00 32.00 -97.00 96.00 0.00 258.00 33.00 96.00 64.00 -96.00 321.00 -97.00 161.00 97.00 -32.00 96.00 -161.00 161.00 -160.00 128.00 -226.00 33.00 -128.00 128.00 -161.00 32.00 -64.00 161.00 -129.00 161.00 -96.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 32.00 65.00 32.00 32.00 32.00 -64.00 -64.00 160.00 -354.00 65.00 -32.00 225.00 -96.00 160.00 -161.00 97.00 -32.00 129.00 64.00 96.00 64.00 225.00 483.00 64.00 96.00 65.00 32.00 32.00 -64.00 161.00 -96.00 64.00 -33.00 161.00 0.00 96.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 129.00 33.00 32.00 0.00 161.00 0.00 547.00 160.00 96.00 65.00 289.00 128.00 418.00 225.00 129.00 65.00 193.00 64.00 482.00 257.00 257.00 129.00 161.00 0.00 -64.00 32.00 32.00 0.00 64.00 0.00 33.00 -32.00 -33.00 -65.00 -32.00 33.00 0.00 -33.00 32.00 -32.00 65.00 129.00 0.00 32.00 0.00 32.00 64.00 32.00 129.00 0.00 32.00 129.00 -32.00 32.00 -33.00 97.00 65.00 32.00 -32.00 -32.00 64.00 -97.00 -32.00 -161.00 -65.00 -64.00 -64.00 32.00 -32.00 -32.00 0.00 -32.00 64.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 -32.00 32.00 -33.00 32.00 0.00 96.00 33.00 322.00 353.00 225.00 161.00 129.00 97.00 96.00 0.00 0.00 32.00 193.00 -32.00 96.00 128.00 32.00 32.00 -32.00 -96.00 65.00 0.00 193.00 64.00 289.00 32.00 193.00 -96.00 32.00 -32.00 32.00 0.00 64.00 32.00 129.00 0.00 64.00 0.00 129.00 -129.00 32.00 0.00 32.00 0.00 0.00 97.00 33.00 64.00 0.00 -32.00 -33.00 0.00 33.00 -32.00 257.00 32.00 225.00 0.00 128.00 -32.00 97.00 0.00 64.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 129.00 225.00 32.00 64.00 32.00 -64.00 32.00 -64.00 -32.00 -65.00 64.00 -32.00 129.00 32.00 64.00 0.00 32.00 0.00 193.00 0.00 32.00 0.00 65.00 0.00 160.00 0.00 193.00 0.00 0.00 33.00 -32.00 -33.00 65.00 97.00 -65.00 64.00 -96.00 97.00 0.00 160.00 32.00 65.00 0.00 32.00 -97.00 32.00 0.00 97.00 -32.00 128.00 65.00 64.00 64.00 97.00 32.00 32.00 129.00 96.00 32.00 33.00 32.00 96.00 -96.00 97.00 0.00 32.00 -33.00 161.00 -64.00 32.00 -129.00 96.00 -32.00 64.00 -96.00 129.00 -64.00 32.00 -65.00 32.00 -32.00 32.00 0.00 33.00 0.00 96.00 -64.00 64.00 0.00 32.00 0.00 161.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 97.00 0.00 32.00 -32.00 0.00 -65.00 97.00 -64.00 32.00 -96.00 0.00 -161.00 32.00 -64.00 32.00 -161.00 0.00 -65.00 64.00 -32.00 32.00 0.00 65.00 129.00 0.00 32.00 0.00 0.00 32.00 0.00 32.00 0.00 32.00 -64.00 0.00 -32.00 32.00 -33.00 65.00 0.00 64.00 0.00 32.00 -64.00 32.00 -64.00 129.00 -161.00 32.00 0.00 32.00 -64.00 32.00 32.00 97.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 -161.00 -32.00 -161.00 64.00 -64.00 32.00 -32.00 0.00 -129.00 -64.00 -32.00 -32.00 -129.00 96.00 -64.00 0.00 -96.00 -32.00 0.00 65.00 -33.00 64.00 -64.00 32.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 0.00 -65.00 96.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 -64.00 0.00 -97.00 -32.00 0.00 -32.00 -32.00 -32.00 65.00 0.00 96.00 -97.00 64.00 -32.00 65.00 0.00 32.00 0.00 32.00 0.00 32.00 -128.00 161.00 -65.00 64.00 -64.00 32.00 -96.00 65.00 -33.00 96.00 0.00 32.00 -32.00 65.00 -64.00 0.00 -97.00 128.00 -96.00 97.00 -32.00 64.00 0.00 32.00 0.00 32.00 64.00 129.00 0.00 64.00 -32.00 65.00 -32.00 32.00 32.00 96.00 32.00 64.00 -32.00 33.00 -32.00 32.00 -193.00 321.00 0.00 65.00 0.00 32.00 0.00 96.00 -64.00 64.00 -225.00 161.00 -33.00 97.00 -32.00 96.00 -32.00 0.00 -32.00 -32.00 -64.00 0.00 -65.00 193.00 -32.00 32.00 -64.00 193.00 0.00 96.00 -64.00 65.00 -97.00 32.00 -32.00 32.00 -32.00 64.00 96.00 65.00 0.00 32.00 -193.00 0.00 -32.00 32.00 -32.00 32.00 -193.00 225.00 -32.00 97.00 0.00 96.00 32.00 161.00 0.00 64.00 97.00 161.00 0.00 96.00 0.00 129.00 0.00 32.00 64.00 0.00 64.00 -32.00 32.00 0.00 0.00 32.00 193.00 129.00 65.00 64.00 -33.00 129.00 33.00 64.00 96.00 64.00 0.00 32.00 0.00 33.00 0.00 32.00 -32.00 0.00 0.00 96.00 -64.00 97.00 32.00 128.00 0.00 33.00 -32.00 64.00 -33.00 64.00 -160.00 225.00 -32.00 32.00 0.00 32.00 -65.00 33.00 -64.00 64.00 -32.00 64.00 32.00 65.00 32.00 32.00 97.00 64.00 0.00 64.00 -33.00 65.00 -96.00 96.00 0.00 97.00 32.00 96.00 32.00 0.00 161.00 161.00 32.00 96.00 0.00 129.00 0.00 32.00 129.00 129.00 0.00 32.00 64.00 64.00 -32.00 161.00 0.00 64.00 96.00 225.00 0.00 129.00 0.00 64.00 32.00 0.00 65.00 97.00 32.00 193.00 32.00 96.00 32.00 161.00 0.00 96.00 -128.00 161.00 0.00 64.00 64.00 161.00 0.00 32.00 0.00 65.00 -32.00 160.00 -32.00 65.00 -65.00 32.00 -128.00 64.00 0.00 64.00 -65.00 32.00 -128.00 33.00 -32.00 32.00 -32.00 128.00 -65.00 65.00 -128.00 32.00 -33.00 32.00 -32.00 129.00 0.00 32.00 -96.00 96.00 -32.00 193.00 -97.00 64.00 -32.00 97.00 -32.00 64.00 -64.00 0.00 -161.00 32.00 -32.00 65.00 -32.00 32.00 0.00 64.00 32.00 32.00 32.00 33.00 0.00 32.00 -32.00 160.00 64.00 225.00 0.00 65.00 -96.00 0.00 0.00 32.00 -33.00 64.00 33.00 161.00 32.00 64.00 -32.00 97.00 96.00 193.00 -96.00 160.00 0.00 65.00 32.00 32.00 32.00 129.00 0.00 64.00 64.00 64.00 64.00 64.00 33.00 33.00 0.00 96.00 0.00 32.00 -33.00 32.00 0.00 33.00 -64.00 32.00 -32.00 32.00 0.00 32.00 96.00 96.00 33.00 129.00 64.00 64.00 129.00 0.00 64.00 33.00 64.00 32.00 0.00 32.00 32.00 193.00 32.00 32.00 65.00 64.00 96.00 0.00 97.00 129.00 96.00 32.00 97.00 32.00 32.00 0.00 0.00 32.00 32.00 65.00 32.00 32.00 0.00 64.00 32.00 64.00 -32.00 129.00 -32.00 96.00 32.00 33.00 64.00 -33.00 32.00 33.00 0.00 32.00 -96.00 96.00 -32.00 32.00 0.00 97.00 -97.00 161.00 0.00 32.00 65.00 96.00 -32.00 97.00 32.00 96.00 -65.00 32.00 -32.00 32.00 0.00 33.00 65.00 32.00 -65.00 128.00 0.00 97.00 0.00 64.00 -96.00 129.00 -32.00 193.00 0.00 32.00 0.00 32.00 -32.00 96.00 -129.00 161.00 -161.00 64.00 -32.00 129.00 -64.00 64.00 -32.00 0.00 -129.00 32.00 -64.00 0.00 -65.00 -64.00 -96.00 0.00 -97.00 97.00 -128.00 64.00 -65.00 0.00 -32.00 0.00 -96.00 -64.00 -161.00 -33.00 -193.00 33.00 -32.00 0.00 -32.00 64.00 -97.00 64.00 -128.00 32.00 -193.00 -32.00 -64.00 129.00 -129.00 -32.00 0.00 96.00 -32.00 0.00 -65.00 32.00 -64.00 0.00 -96.00 -32.00 -65.00 32.00 0.00 33.00 -128.00 -65.00 -32.00 -64.00 -32.00 -64.00 -33.00 -33.00 -160.00 -64.00 -33.00 -32.00 -32.00 -97.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 -64.00 -96.00 -32.00 -97.00 -97.00 -96.00 -32.00 -64.00 -32.00 -129.00 32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -65.00 32.00 -128.00 0.00 -32.00 0.00 -65.00 64.00 -96.00 -64.00 -32.00 32.00 -33.00 32.00 -32.00 65.00 -160.00 32.00 -129.00 96.00 -161.00 -32.00 -32.00 32.00 -32.00 65.00 -32.00 0.00 -65.00 -33.00 0.00 -64.00 -64.00 -32.00 -64.00 0.00 -65.00 64.00 -225.00 32.00 -32.00 33.00 -64.00 0.00 -32.00 64.00 0.00 129.00 -32.00 64.00 -33.00 0.00 -64.00 -97.00 -96.00 0.00 -32.00 0.00 0.00 33.00 0.00 32.00 96.00 128.00 -32.00 65.00 -32.00 0.00 -32.00 0.00 0.00 -97.00 -33.00 0.00 -32.00 32.00 -32.00 97.00 -128.00 64.00 -65.00 97.00 0.00 32.00 0.00 96.00 0.00 32.00 -64.00 0.00 -64.00 32.00 0.00 129.00 -161.00 193.00 -65.00 0.00 -64.00 0.00 0.00 97.00 -32.00 64.00 -32.00 64.00 32.00 97.00 0.00 32.00 -64.00 64.00 -97.00 161.00 -32.00 0.00 -96.00 -65.00 -161.00 65.00 -64.00 0.00 -97.00 32.00 -64.00 64.00 -97.00 97.00 -128.00 32.00 -129.00 64.00 0.00 32.00 -64.00 0.00 -64.00 65.00 -33.00 128.00 -32.00 0.00 -161.00 32.00 -32.00 97.00 -32.00 32.00 -96.00 64.00 0.00 32.00 -97.00 161.00 -96.00 32.00 -32.00 33.00 -65.00 32.00 -32.00 0.00 -32.00 128.00 -32.00 33.00 -32.00 160.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -65.00 -128.00 -193.00 64.00 -32.00 -32.00 -128.00 -32.00 -32.00 64.00 -129.00 64.00 -32.00 32.00 0.00 32.00 -32.00 33.00 -32.00 64.00 -65.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 64.00 -33.00 65.00 -32.00 64.00 -32.00 32.00 -32.00 -32.00 -96.00 32.00 -65.00 32.00 -64.00 0.00 -32.00 0.00 -65.00 65.00 -64.00 0.00 -128.00 96.00 -65.00 -32.00 -32.00 0.00 -96.00 -32.00 -193.00 64.00 -32.00 32.00 -65.00 0.00 -32.00 -32.00 -96.00 64.00 -33.00 97.00 -96.00 32.00 -64.00 64.00 -32.00 0.00 0.00 -32.00 -65.00 -32.00 -32.00 0.00 -32.00 32.00 -64.00 64.00 -97.00 -32.00 -64.00 32.00 -32.00 0.00 -97.00 0.00 -64.00 33.00 -32.00 64.00 -129.00 128.00 -64.00 -32.00 -32.00 0.00 -32.00 65.00 0.00 64.00 -33.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -64.00 0.00 -32.00 33.00 32.00 64.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 0.00 32.00 65.00 32.00 -65.00 32.00 -32.00 0.00 0.00 64.00 0.00 33.00 -64.00 32.00 -32.00 64.00 32.00 64.00 0.00 33.00 -32.00 0.00 0.00 -33.00 -33.00 33.00 33.00 64.00 -33.00 64.00 33.00 32.00 -33.00 32.00 -32.00 -32.00 0.00 65.00 -64.00 32.00 32.00 96.00 -32.00 65.00 -64.00 32.00 0.00 64.00 -32.00 32.00 -33.00 0.00 33.00 64.00 64.00 33.00 0.00 32.00 -97.00 32.00 97.00 64.00 0.00 32.00 -64.00 33.00 -33.00 0.00 0.00 32.00 0.00 64.00 -32.00 32.00 -32.00 32.00 32.00 32.00 0.00 33.00 -32.00 32.00 -64.00 96.00 96.00 65.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 64.00 64.00 96.00 -32.00 33.00 0.00 96.00 -65.00 129.00 33.00 64.00 -33.00 64.00 -32.00 65.00 32.00 96.00 -32.00 64.00 -64.00 0.00 -32.00 65.00 -32.00 32.00 32.00 64.00 -257.00 225.00 0.00 193.00 -65.00 64.00 0.00 97.00 -64.00 64.00 0.00 97.00 0.00 32.00 -64.00 32.00 32.00 64.00 -32.00 32.00 -32.00 0.00 -65.00 33.00 32.00 32.00 -64.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 -32.00 65.00 -32.00 32.00 32.00 128.00 -32.00 97.00 32.00 32.00 -64.00 96.00 -33.00 33.00 33.00 64.00 -33.00 32.00 0.00 64.00 -32.00 33.00 -128.00 96.00 0.00 32.00 128.00 64.00 -64.00 65.00 -96.00 -32.00 0.00 32.00 -33.00 0.00 -32.00 64.00 -32.00 96.00 32.00 33.00 -32.00 32.00 -96.00 225.00 -65.00 0.00 -64.00 32.00 32.00 64.00 -64.00 0.00 -64.00 33.00 -33.00 128.00 -64.00 -32.00 -96.00 96.00 -32.00 0.00 0.00 33.00 -33.00 64.00 -64.00 32.00 -32.00 64.00 32.00 32.00 64.00 33.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 64.00 -32.00 33.00 32.00 32.00 -65.00 32.00 0.00 32.00 0.00 64.00 0.00 33.00 0.00 32.00 -64.00 64.00 32.00 64.00 32.00 97.00 0.00 32.00 65.00 64.00 32.00 97.00 96.00 64.00 0.00 64.00 33.00 65.00 -33.00 64.00 33.00 32.00 32.00 32.00 0.00 65.00 0.00 32.00 32.00 0.00 0.00 64.00 -32.00 0.00 0.00 64.00 0.00 129.00 32.00 32.00 32.00 96.00 32.00 33.00 64.00 64.00 -32.00 32.00 -32.00 0.00 32.00 97.00 0.00 96.00 32.00 0.00 -32.00 97.00 0.00 64.00 32.00 64.00 0.00 64.00 -64.00 0.00 0.00 33.00 32.00 64.00 0.00 32.00 32.00 0.00 0.00 64.00 33.00 0.00 -33.00 65.00 33.00 32.00 32.00 -32.00 32.00 32.00 64.00 32.00 64.00 0.00 33.00 32.00 64.00 64.00 32.00 65.00 97.00 128.00 0.00 32.00 0.00 65.00 32.00 0.00 -32.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 33.00 32.00 64.00 -64.00 32.00 0.00 32.00 -65.00 32.00 -32.00 97.00 0.00 32.00 -64.00 32.00 32.00 64.00 -64.00 65.00 0.00 64.00 32.00 64.00 -32.00 32.00 32.00 33.00 32.00 32.00 32.00 64.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 97.00 32.00 128.00 -64.00 97.00 64.00 32.00 -32.00 32.00 32.00 32.00 0.00 33.00 32.00 64.00 -32.00 32.00 32.00 64.00 0.00 32.00 0.00 33.00 -32.00 96.00 -64.00 32.00 -33.00 32.00 0.00 33.00 -32.00 128.00 0.00 32.00 -64.00 97.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 129.00 32.00 32.00 32.00 32.00 33.00 97.00 -33.00 64.00 0.00 32.00 -32.00 96.00 0.00 65.00 -64.00 64.00 0.00 32.00 -32.00 129.00 0.00 64.00 -32.00 0.00 64.00 65.00 -64.00 192.00 -32.00 33.00 -33.00 96.00 -32.00 96.00 -64.00 33.00 0.00 32.00 -32.00 32.00 -32.00 96.00 -32.00 0.00 -65.00 0.00 0.00 65.00 -32.00 64.00 32.00 193.00 -128.00 -64.00 -97.00 32.00 -32.00 32.00 -64.00 -97.00 -33.00 -289.00 -32.00 -32.00 -32.00 0.00 -64.00 32.00 -225.00 161.00 -193.00 -32.00 -129.00 32.00 -96.00 -129.00 -32.00 -32.00 -33.00 -32.00 -64.00 -32.00 -128.00 32.00 -161.00 32.00 -129.00 0.00 -64.00 -32.00 -64.00 64.00 -97.00 -64.00 -96.00 -32.00 -65.00 -225.00 -160.00 -193.00 -33.00 0.00 -96.00 -32.00 -32.00 -97.00 -32.00 -32.00 0.00 -161.00 -97.00 -128.00 32.00 -65.00 -32.00 -128.00 65.00 -65.00 -65.00 -64.00 0.00 -96.00 32.00 -32.00 0.00 -97.00 -96.00 -32.00 0.00 -32.00 64.00 -32.00 -64.00 -65.00 -32.00 0.00 32.00 -96.00 -64.00 -64.00 -33.00 -65.00 -128.00 65.00 -97.00 0.00 -96.00 -33.00 0.00 -32.00 32.00 -96.00 32.00 -32.00 -32.00 -65.00 -96.00 -64.00 -161.00 0.00 -64.00 0.00 0.00 -32.00 -33.00 -32.00 0.00 -65.00 -32.00 -128.00 193.00 -129.00 32.00 -64.00 0.00 -129.00 65.00 -96.00 0.00 -97.00 64.00 -32.00 193.00 -128.00 0.00 -33.00 -97.00 -32.00 0.00 -32.00 -64.00 -96.00 0.00 -33.00 64.00 -64.00 0.00 -64.00 -64.00 -32.00 -96.00 32.00 -33.00 -64.00 -64.00 -33.00 -64.00 0.00 -64.00 -64.00 -33.00 -32.00 0.00 -64.00 33.00 -65.00 32.00 -32.00 -97.00 -32.00 -64.00 -64.00 -32.00 0.00 -97.00 32.00 -128.00 0.00 -65.00 32.00 -32.00 32.00 0.00 32.00 -96.00 -32.00 0.00 -32.00 32.00 -96.00 -64.00 -97.00 -33.00 -32.00 -32.00 -32.00 -64.00 -65.00 -64.00 -96.00 0.00 -64.00 -32.00 0.00 -97.00 32.00 -32.00 -64.00 0.00 -33.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 -65.00 -97.00 32.00 -64.00 33.00 -64.00 -33.00 -65.00 0.00 -32.00 -64.00 32.00 -64.00 -32.00 0.00 -32.00 32.00 -97.00 -32.00 -64.00 -32.00 -32.00 -129.00 -32.00 -32.00 0.00 0.00 -64.00 0.00 -33.00 -32.00 33.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 -65.00 32.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -65.00 -96.00 0.00 -161.00 65.00 -64.00 -33.00 -65.00 0.00 0.00 33.00 -32.00 0.00 -32.00 0.00 32.00 -65.00 -64.00 32.00 -64.00 -32.00 -65.00 0.00 0.00 32.00 -96.00 -64.00 0.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -33.00 65.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 32.00 -32.00 97.00 0.00 0.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 32.00 64.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -64.00 32.00 -33.00 32.00 0.00 65.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 64.00 -32.00 -32.00 -65.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -64.00 64.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 32.00 -32.00 65.00 -65.00 96.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 33.00 -32.00 -33.00 -33.00 33.00 -32.00 0.00 -96.00 32.00 -32.00 -32.00 -97.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 -32.00 -32.00 -32.00 -97.00 32.00 0.00 32.00 0.00 32.00 0.00 0.00 -96.00 65.00 -65.00 32.00 0.00 32.00 -32.00 -32.00 -64.00 -32.00 -32.00 32.00 -32.00 -64.00 0.00 32.00 -33.00 -32.00 0.00 -65.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 32.00 0.00 0.00 -32.00 33.00 32.00 32.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 32.00 0.00 -64.00 0.00 32.00 32.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 0.00 0.00 -32.00 32.00 32.00 33.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -64.00 0.00 -65.00 64.00 0.00 0.00 -32.00 32.00 -32.00 32.00 64.00 33.00 -32.00 96.00 -96.00 -32.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 -32.00 -96.00 32.00 32.00 64.00 -32.00 -32.00 -65.00 32.00 0.00 0.00 -32.00 0.00 -32.00 97.00 32.00 64.00 0.00 32.00 0.00 32.00 0.00 33.00 32.00 32.00 -64.00 32.00 -32.00 32.00 -64.00 96.00 -33.00 65.00 -32.00 64.00 -32.00 129.00 -64.00 128.00 64.00 65.00 0.00 64.00 -32.00 96.00 0.00 65.00 -32.00 64.00 -65.00 64.00 -64.00 65.00 -96.00 -33.00 -161.00 33.00 -97.00 64.00 -64.00 32.00 -32.00 -64.00 -64.00 -65.00 -32.00 0.00 -33.00 0.00 -32.00 97.00 -257.00 0.00 -64.00 32.00 -65.00 64.00 0.00 33.00 -32.00 0.00 -64.00 -65.00 -64.00 0.00 -65.00 0.00 -128.00 0.00 -32.00 -32.00 -33.00 0.00 -32.00 -32.00 -64.00 -129.00 -97.00 -128.00 -64.00 -65.00 -32.00 0.00 -64.00 0.00 -32.00 -64.00 -33.00 -32.00 -32.00 -64.00 0.00 0.00 -32.00 -65.00 -32.00 -96.00 0.00 -64.00 64.00 -33.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 64.00 -65.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 96.00 -32.00 0.00 0.00 -32.00 -33.00 32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -97.00 32.00 -32.00 0.00 0.00 33.00 -32.00 0.00 -32.00 -65.00 -32.00 32.00 -33.00 33.00 -32.00 -33.00 0.00 -32.00 -64.00 32.00 0.00 65.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 0.00 32.00 0.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 65.00 -33.00 0.00 0.00 32.00 0.00 64.00 -64.00 32.00 32.00 32.00 -96.00 32.00 0.00 33.00 -32.00 -33.00 -32.00 97.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -96.00 0.00 0.00 -33.00 -65.00 -32.00 32.00 -32.00 -64.00 -32.00 0.00 -96.00 -96.00 -97.00 -129.00 0.00 64.00 -32.00 -64.00 -64.00 32.00 0.00 0.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 32.00 -96.00 -32.00 32.00 -32.00 -96.00 -33.00 0.00 -64.00 32.00 0.00 -65.00 0.00 -96.00 -64.00 0.00 0.00 -32.00 -32.00 -32.00 -65.00 -65.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -64.00 -64.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -33.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 64.00 -32.00 -64.00 0.00 32.00 -32.00 -32.00 -65.00 -32.00 -96.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -33.00 32.00 33.00 -64.00 0.00 -33.00 -65.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 0.00 0.00 -64.00 33.00 -32.00 -33.00 -33.00 0.00 -32.00 33.00 32.00 32.00 0.00 0.00 -64.00 -161.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 64.00 0.00 32.00 0.00 32.00 -33.00 -32.00 -32.00 -64.00 -64.00 -64.00 -32.00 -33.00 -65.00 -32.00 0.00 -64.00 0.00 0.00 33.00 32.00 64.00 64.00 0.00 0.00 32.00 -64.00 64.00 -64.00 -32.00 -32.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 -96.00 -97.00 -64.00 33.00 -65.00 -33.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 -32.00 -32.00 -129.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 -32.00 0.00 -160.00 -65.00 -65.00 -32.00 -161.00 0.00 -64.00 -64.00 0.00 -65.00 0.00 -96.00 32.00 -64.00 32.00 -129.00 -32.00 64.00 -128.00 65.00 -32.00 257.00 -97.00 0.00 -32.00 129.00 -64.00 32.00 -161.00 -32.00 -64.00 -65.00 -129.00 -193.00 -129.00 -32.00 -32.00 -225.00 0.00 -64.00 32.00 -97.00 161.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -97.00 -225.00 -96.00 -96.00 -193.00 -97.00 -64.00 -64.00 0.00 -64.00 0.00 -97.00 0.00 -32.00 160.00 -97.00 32.00 -32.00 65.00 0.00 96.00 32.00 65.00 33.00 64.00 -33.00 96.00 -128.00 32.00 -129.00 129.00 -161.00 64.00 -32.00 129.00 -128.00 32.00 -65.00 0.00 -32.00 32.00 -96.00 32.00 -65.00 0.00 -128.00 97.00 -193.00 32.00 -64.00 -32.00 -97.00 -64.00 -161.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 65.00 -193.00 96.00 -161.00 0.00 -225.00 0.00 -64.00 32.00 -32.00 -32.00 -97.00 97.00 -193.00 64.00 -96.00 0.00 -32.00 0.00 -97.00 0.00 -128.00 32.00 -32.00 0.00 -65.00 129.00 -193.00 32.00 0.00 32.00 -64.00 -96.00 -257.00 32.00 -32.00 32.00 -129.00 32.00 -129.00 32.00 -160.00 0.00 -32.00 129.00 -258.00 0.00 -64.00 0.00 -96.00 -32.00 -97.00 -65.00 -96.00 -64.00 -161.00 -64.00 -289.00 -32.00 -129.00 32.00 -129.00 0.00 -96.00 0.00 -32.00 -32.00 -129.00 -65.00 -96.00 97.00 -290.00 0.00 -321.00 -32.00 -32.00 -33.00 -161.00 -128.00 -290.00 -64.00 -64.00 -65.00 -129.00 32.00 -96.00 65.00 -225.00 0.00 -129.00 0.00 -64.00 -32.00 -129.00 0.00 -160.00 -65.00 -193.00 -289.00 -290.00 -32.00 0.00 -65.00 33.00 -193.00 -65.00 -225.00 -193.00 -96.00 -32.00 -257.00 -161.00 -129.00 0.00 -129.00 32.00 -160.00 0.00 -65.00 -64.00 -128.00 -161.00 0.00 -160.00 0.00 -32.00 0.00 -33.00 -32.00 -96.00 -32.00 -64.00 -226.00 -97.00 -32.00 0.00 -96.00 0.00 -161.00 -32.00 -64.00 0.00 -32.00 0.00 -161.00 161.00 -161.00 32.00 -129.00 -32.00 -321.00 -32.00 -64.00 -33.00 -97.00 -32.00 -64.00 -64.00 -32.00 0.00 -65.00 -32.00 -128.00 -65.00 -97.00 -64.00 -128.00 0.00 -161.00 -128.00 -64.00 -33.00 -483.00 65.00 -96.00 64.00 -161.00 -32.00 -96.00 64.00 -97.00 129.00 0.00 64.00 -32.00 97.00 0.00 96.00 -64.00 161.00 -97.00 96.00 -32.00 32.00 -96.00 -32.00 -33.00 -64.00 -64.00 -32.00 -128.00 -32.00 -65.00 32.00 -32.00 32.00 -32.00 129.00 -32.00 32.00 -97.00 -32.00 -32.00 32.00 -64.00 -32.00zm13890.00 -20450.00l0.00 -32.00 0.00 32.00zm2476.00 1286.00l0.00 -32.00 -32.00 -64.00 -32.00 64.00 -33.00 -32.00 33.00 32.00 32.00 -32.00 0.00 64.00 32.00 0.00zm1157.00 -353.00l0.00 -33.00 0.00 -64.00 33.00 -32.00 0.00 32.00 0.00 32.00 -33.00 32.00 33.00 0.00 64.00 225.00 -32.00 33.00 0.00 -33.00 -32.00 -128.00 0.00 -64.00 -33.00 0.00zm33.00 -33.00l-33.00 0.00 0.00 33.00 33.00 -33.00zm-2862.00 -353.00l32.00 0.00 -32.00 -33.00 0.00 33.00zm32.00 0.00l-32.00 64.00 -32.00 32.00 0.00 32.00 0.00 65.00 32.00 0.00 -32.00 -97.00 64.00 -32.00 32.00 -32.00 -32.00 -32.00zm4244.00 1993.00l32.00 0.00 0.00 22.00 33.00 -22.00 32.00 65.00 -65.00 32.00 -64.00 -32.00 48.00 -33.00 -16.00 0.00 0.00 -32.00zm-32.00 -418.00l-32.00 0.00 32.00 -32.00 0.00 32.00zm-5048.00 -1608.00l-64.00 33.00 -32.00 64.00 32.00 64.00 64.00 0.00 0.00 65.00 32.00 32.00 32.00 -32.00 33.00 64.00 0.00 64.00 0.00 32.00 0.00 -32.00 32.00 -64.00 -65.00 -64.00 -32.00 32.00 -32.00 -32.00 0.00 -65.00 -32.00 -32.00 -64.00 -32.00 32.00 -32.00 86.00 -65.00 -22.00 0.00zm6463.00 4245.00l0.00 -32.00 0.00 32.00 32.00 0.00 0.00 -32.00 0.00 32.00 -32.00 0.00zm-2026.00 -3859.00l0.00 -32.00 -32.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 32.00 96.00 32.00 -129.00 65.00 -32.00 0.00 0.00 -33.00 0.00 -32.00 0.00 65.00 32.00 0.00 97.00 -33.00 32.00 0.00 -32.00 33.00 -129.00 96.00 0.00 32.00 -32.00 0.00 -64.00 0.00 0.00 -32.00 0.00 96.00 -64.00 65.00 -33.00 0.00 0.00 -32.00 -32.00 64.00 -64.00 0.00 -129.00 -97.00 -32.00 -160.00 0.00 32.00 0.00 -32.00 64.00 -65.00 -64.00 0.00 -32.00 -32.00 32.00 -64.00 64.00 -32.00 33.00 32.00 32.00 32.00 96.00 32.00 0.00 -32.00 32.00 -32.00 97.00 96.00 0.00 -32.00 -97.00 -64.00 33.00 -32.00 0.00 -32.00 0.00 32.00 -65.00 0.00 32.00 -65.00 -64.00 33.00 -32.00 -33.00 64.00 -96.00 32.00 -32.00 65.00 0.00 32.00 32.00 64.00 0.00 32.00 64.00 0.00 32.00 32.00 0.00 -32.00 -64.00 0.00 -64.00 97.00 0.00 96.00 32.00 129.00 64.00 32.00 97.00 0.00 32.00 0.00 32.00 32.00 32.00 -96.00 32.00 -65.00 65.00 33.00 -161.00 -33.00 64.00 0.00 32.00 -32.00 0.00zm482.00 1094.00l33.00 -33.00 0.00 33.00 -33.00 0.00zm-5112.00 -1512.00l0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00zm5884.00 2573.00l0.00 -33.00 32.00 0.00 32.00 -32.00 0.00 32.00 -32.00 0.00 0.00 33.00 -32.00 0.00zm-4823.00 -2380.00l-32.00 65.00 32.00 0.00 0.00 -33.00 0.00 -32.00zm322.00 -128.00l32.00 -33.00 32.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 33.00 -32.00 0.00zm3504.00 1414.00l33.00 0.00 -33.00 -96.00 33.00 -32.00 96.00 -64.00 32.00 -97.00 0.00 -32.00 97.00 -64.00 64.00 0.00 -64.00 -65.00 0.00 -32.00 96.00 -32.00 64.00 64.00 0.00 225.00 -32.00 33.00 -96.00 0.00 -65.00 32.00 -32.00 0.00 0.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 64.00 -32.00 33.00 -96.00 -33.00 32.00 33.00 0.00 32.00 -32.00 -32.00 -33.00 -33.00zm3859.00 4148.00l0.00 -64.00 32.00 0.00 32.00 -32.00 0.00 64.00 -32.00 -32.00 -32.00 64.00zm-4759.00 -4951.00l32.00 0.00 65.00 32.00 0.00 32.00 -33.00 0.00 -64.00 -64.00zm-2251.00 -33.00l33.00 -32.00 32.00 -64.00 -65.00 32.00 0.00 64.00zm4084.00 1994.00l0.00 -32.00 32.00 32.00 0.00 96.00 -32.00 -96.00zm836.00 1125.00l32.00 -96.00 32.00 64.00 -32.00 32.00 -32.00 0.00zm-1351.00 -1736.00l33.00 -32.00 64.00 -32.00 0.00 32.00 0.00 64.00 -97.00 -32.00zm-3183.00 -1286.00l32.00 -64.00 33.00 0.00 0.00 64.00 -33.00 32.00 -32.00 -32.00zm4405.00 3247.00l193.00 -96.00 -32.00 64.00 -96.00 32.00 -65.00 0.00zm-32.00 193.00l64.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 32.00 32.00 0.00 -32.00 32.00 0.00 64.00 0.00 33.00 -33.00 0.00 33.00 -33.00 -97.00 -32.00zm-2894.00 -3408.00l65.00 -64.00 32.00 -129.00 0.00 -32.00 64.00 0.00 0.00 32.00 0.00 32.00 -64.00 32.00 0.00 33.00 -65.00 96.00 0.00 64.00 -32.00 -64.00zm-3311.00 -1061.00l32.00 -64.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 64.00 -32.00 65.00 -64.00 -65.00 0.00 -64.00zm-97.00 -354.00l0.00 -32.00 64.00 -32.00 65.00 32.00 0.00 32.00 -32.00 0.00 32.00 65.00 -65.00 64.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -97.00zm5723.00 3441.00l32.00 32.00 33.00 0.00 -33.00 -32.00 -32.00 0.00zm-96.00 109.00l-32.00 19.00 96.00 65.00 64.00 -32.00 33.00 -65.00 -33.00 32.00 -64.00 33.00 -64.00 -33.00 0.00 -19.00zm-579.00 -1363.00l0.00 -97.00 32.00 -32.00 32.00 -64.00 33.00 0.00 64.00 64.00 0.00 32.00 -32.00 32.00 -129.00 97.00 0.00 -32.00zm-1029.00 -1158.00l-32.00 97.00 32.00 -65.00 0.00 -32.00zm-32.00 97.00l-96.00 -65.00 -33.00 0.00 97.00 65.00 64.00 160.00 32.00 0.00 -32.00 -32.00 -32.00 -128.00zm1833.00 2411.00l-32.00 -96.00 32.00 -97.00 32.00 0.00 32.00 0.00 0.00 -64.00 32.00 0.00 32.00 32.00 -32.00 32.00 32.00 97.00 -32.00 64.00 32.00 -32.00 -32.00 64.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00zm-4437.00 -3022.00l-32.00 0.00 -33.00 -32.00 -64.00 0.00 -96.00 32.00 -65.00 64.00 -32.00 0.00 97.00 -96.00 32.00 -65.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 64.00 32.00 0.00 32.00 65.00 32.00 32.00 97.00 -32.00 0.00 0.00 -33.00 0.00 65.00zm-643.00 96.00l-97.00 64.00 -64.00 -96.00 32.00 0.00 -32.00 -64.00 0.00 -65.00 32.00 0.00 -32.00 -32.00 32.00 -64.00 32.00 96.00 32.00 0.00 32.00 65.00 -32.00 -65.00 -32.00 -32.00 0.00 -64.00 32.00 -64.00 65.00 128.00 32.00 32.00 -32.00 97.00 32.00 32.00 -32.00 32.00zm4147.00 1351.00l32.00 -65.00 97.00 -128.00 0.00 -32.00 -161.00 225.00 -64.00 32.00 96.00 -32.00zm-578.00 -997.00l64.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 64.00zm32.00 -64.00l-32.00 0.00 0.00 32.00 32.00 -32.00zm-32.00 0.00l32.00 -33.00 -32.00 0.00 0.00 33.00z"},pa:{name:"PA",path:"M77219.00 21381.00l64.00 0.00 32.00 33.00 32.00 96.00 33.00 0.00 32.00 97.00 32.00 0.00 64.00 -33.00 32.00 33.00 0.00 64.00 33.00 0.00 64.00 -64.00 32.00 32.00 32.00 -65.00 64.00 0.00 33.00 33.00 32.00 -65.00 64.00 -64.00 64.00 64.00 129.00 -193.00 -32.00 -32.00 0.00 -64.00 32.00 -129.00 0.00 -32.00 32.00 -32.00 64.00 0.00 65.00 0.00 0.00 64.00 64.00 32.00 64.00 -64.00 65.00 32.00 32.00 -32.00 64.00 32.00 32.00 32.00 97.00 33.00 0.00 32.00 32.00 0.00 32.00 -65.00 0.00 -32.00 32.00 0.00 32.00 -64.00 0.00 32.00 65.00 0.00 32.00 0.00 32.00 97.00 0.00 32.00 32.00 -32.00 32.00 64.00 0.00 -64.00 32.00 -33.00 65.00 33.00 32.00 0.00 0.00 -129.00 64.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -160.00 65.00 -97.00 -33.00 -32.00 0.00 32.00 -96.00 -64.00 32.00 -32.00 -128.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -64.00 -32.00 -33.00 0.00 -64.00 64.00 -32.00 32.00 32.00 64.00 0.00 65.00 -32.00 64.00 64.00 32.00 -64.00 64.00 0.00 33.00 0.00 160.00 0.00 65.00 -64.00 -32.00 -33.00 -33.00 0.00 -32.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -65.00 129.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -33.00 32.00 -32.00 33.00 -64.00 32.00 -32.00 64.00 32.00 -32.00 129.00 128.00 0.00 0.00 -33.00 97.00 33.00 32.00 -33.00 32.00 33.00 0.00 32.00 65.00 32.00 32.00 32.00 128.00 -96.00 65.00 0.00 0.00 -33.00 64.00 33.00 96.00 32.00 33.00 64.00 0.00 32.00 0.00 65.00 32.00 64.00 0.00 32.00 96.00 32.00 64.00 0.00 65.00 -64.00 64.00 0.00 0.00 32.00 96.00 0.00 0.00 -64.00 33.00 -32.00 96.00 32.00 64.00 64.00 0.00 -32.00 97.00 64.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 64.00 -97.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 33.00 -33.00 -33.00 -64.00 33.00 -64.00 -33.00 -97.00 33.00 0.00 0.00 -64.00 -129.00 -64.00 32.00 -32.00 32.00 0.00 0.00 -33.00 65.00 0.00 32.00 33.00 32.00 -33.00 32.00 33.00 32.00 32.00 129.00 0.00 64.00 0.00 32.00 -65.00 0.00 -32.00 32.00 -32.00 32.00 0.00 33.00 0.00 32.00 0.00 0.00 -32.00 128.00 64.00 0.00 -64.00 33.00 -64.00 0.00 32.00 32.00 0.00 64.00 0.00 64.00 -32.00 33.00 32.00 32.00 -32.00 -32.00 -65.00 32.00 0.00 0.00 -96.00 64.00 32.00 32.00 -64.00 32.00 32.00 32.00 0.00 0.00 32.00 65.00 -32.00 64.00 32.00 64.00 -32.00 32.00 32.00 -32.00 0.00 65.00 0.00 -33.00 -64.00 33.00 0.00 32.00 64.00 0.00 32.00 64.00 32.00 64.00 0.00 0.00 -32.00 33.00 65.00 32.00 32.00 32.00 0.00 0.00 32.00 96.00 -32.00 0.00 -32.00 65.00 0.00 64.00 32.00 32.00 -32.00 64.00 -33.00 33.00 0.00 0.00 65.00 32.00 0.00 32.00 -32.00 64.00 32.00 0.00 -32.00 64.00 0.00 0.00 -65.00 -32.00 -32.00 65.00 -32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -64.00 32.00 -65.00 32.00 0.00 32.00 -32.00 -32.00 -96.00 32.00 -33.00 33.00 0.00 32.00 -32.00 32.00 0.00 129.00 -32.00 0.00 -32.00 32.00 -64.00 32.00 -33.00 -32.00 -64.00 64.00 -64.00 -32.00 -64.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 0.00 -96.00 32.00 0.00 129.00 -32.00 0.00 -33.00 64.00 -32.00 64.00 32.00 32.00 0.00 65.00 -96.00 0.00 -32.00 -65.00 -32.00 65.00 -33.00 0.00 -32.00 32.00 -64.00 32.00 32.00 64.00 -32.00 65.00 32.00 32.00 -96.00 128.00 64.00 65.00 0.00 -33.00 32.00 65.00 64.00 32.00 65.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 -96.00 97.00 -33.00 64.00 -96.00 64.00 0.00 33.00 -32.00 32.00 -32.00 96.00 32.00 32.00 -65.00 129.00 -32.00 0.00 -32.00 0.00 -64.00 32.00 0.00 64.00 32.00 33.00 -32.00 32.00 32.00 0.00 64.00 32.00 32.00 32.00 33.00 0.00 128.00 32.00 65.00 32.00 0.00 33.00 0.00 64.00 32.00 32.00 32.00 32.00 64.00 32.00 65.00 32.00 0.00 33.00 32.00 96.00 0.00 32.00 32.00 32.00 -64.00 33.00 -33.00 32.00 0.00 32.00 0.00 128.00 -32.00 65.00 65.00 0.00 32.00 64.00 32.00 32.00 32.00 97.00 0.00 32.00 0.00 0.00 32.00 64.00 -32.00 32.00 32.00 32.00 0.00 0.00 32.00 33.00 0.00 32.00 32.00 32.00 0.00 64.00 33.00 -32.00 0.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 -32.00 0.00 -32.00 65.00 -32.00 32.00 -33.00 32.00 -64.00 32.00 -32.00 32.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -65.00 96.00 32.00 97.00 33.00 0.00 -33.00 32.00 33.00 129.00 0.00 0.00 -65.00 32.00 0.00 64.00 -64.00 32.00 -32.00 65.00 64.00 32.00 0.00 32.00 32.00 64.00 97.00 97.00 0.00 32.00 -32.00 64.00 0.00 64.00 -33.00 32.00 -64.00 97.00 0.00 64.00 -96.00 65.00 32.00 96.00 -32.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 0.00 0.00 32.00 64.00 64.00 32.00 0.00 32.00 32.00 32.00 0.00 0.00 -64.00 97.00 0.00 64.00 -32.00 64.00 32.00 33.00 0.00 64.00 64.00 64.00 0.00 32.00 65.00 33.00 0.00 32.00 0.00 64.00 64.00 64.00 64.00 97.00 32.00 32.00 -96.00 96.00 -32.00 33.00 32.00 32.00 0.00 96.00 0.00 32.00 -32.00 32.00 64.00 33.00 0.00 32.00 0.00 64.00 64.00 32.00 33.00 0.00 64.00 64.00 0.00 0.00 32.00 33.00 -32.00 64.00 32.00 32.00 -32.00 32.00 0.00 0.00 64.00 32.00 0.00 0.00 -32.00 65.00 0.00 64.00 0.00 32.00 0.00 32.00 0.00 33.00 32.00 32.00 0.00 128.00 64.00 0.00 -32.00 65.00 0.00 32.00 -32.00 32.00 -32.00 64.00 32.00 97.00 -128.00 96.00 -65.00 64.00 -32.00 0.00 -96.00 -96.00 -65.00 0.00 -64.00 -32.00 -32.00 32.00 -32.00 -64.00 -193.00 0.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 -32.00 -33.00 -128.00 -64.00 32.00 -64.00 0.00 -32.00 -32.00 0.00 -65.00 -65.00 -96.00 33.00 -32.00 -97.00 32.00 -32.00 -32.00 0.00 0.00 -64.00 -32.00 -33.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 -64.00 -96.00 -64.00 0.00 -97.00 0.00 -32.00 -65.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 64.00 -32.00 32.00 -64.00 0.00 -33.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 -64.00 -33.00 32.00 -32.00 -64.00 -64.00 32.00 -64.00 0.00 -33.00 -32.00 -32.00 -32.00 -64.00 -33.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 65.00 -64.00 0.00 -65.00 32.00 -32.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 0.00 0.00 32.00 33.00 0.00 32.00 64.00 32.00 64.00 32.00 33.00 97.00 32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -33.00 0.00 0.00 -64.00 65.00 -32.00 0.00 -33.00 32.00 -64.00 32.00 0.00 32.00 -64.00 64.00 -32.00 33.00 -32.00 0.00 -33.00 -33.00 0.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 0.00 -64.00 96.00 -64.00 0.00 -65.00 33.00 -32.00 32.00 -32.00 -65.00 -32.00 0.00 -64.00 33.00 -33.00 32.00 -32.00 32.00 0.00 161.00 -32.00 64.00 32.00 0.00 32.00 64.00 0.00 32.00 33.00 33.00 32.00 32.00 32.00 32.00 64.00 32.00 0.00 32.00 32.00 65.00 0.00 0.00 65.00 96.00 32.00 225.00 32.00 32.00 -32.00 64.00 32.00 33.00 64.00 -33.00 32.00 33.00 33.00 64.00 96.00 129.00 32.00 64.00 0.00 32.00 -96.00 97.00 32.00 96.00 -32.00 64.00 32.00 65.00 0.00 64.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -33.00 32.00 33.00 65.00 -33.00 32.00 65.00 96.00 -32.00 97.00 0.00 0.00 -33.00 129.00 -32.00 96.00 32.00 257.00 0.00 193.00 97.00 193.00 -161.00 -64.00 -128.00 193.00 -193.00 193.00 0.00 192.00 64.00 129.00 -97.00 161.00 -193.00 257.00 -32.00 97.00 193.00 192.00 -128.00 258.00 -193.00 257.00 64.00 64.00 289.00 97.00 97.00 225.00 321.00 -32.00 33.00 0.00 64.00 32.00 32.00 32.00 32.00 257.00 289.00 32.00 65.00 32.00 96.00 -32.00 0.00 -32.00 65.00 32.00 32.00 -32.00 32.00 0.00 96.00 32.00 97.00 97.00 96.00 32.00 32.00 32.00 65.00 32.00 0.00 0.00 64.00 -32.00 32.00 0.00 32.00 -64.00 32.00 0.00 33.00 -32.00 32.00 -65.00 32.00 0.00 64.00 -32.00 0.00 32.00 32.00 -32.00 65.00 32.00 64.00 -64.00 32.00 32.00 129.00 -32.00 0.00 0.00 64.00 32.00 32.00 0.00 65.00 32.00 64.00 32.00 64.00 33.00 32.00 32.00 32.00 64.00 33.00 -32.00 64.00 64.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 0.00 33.00 -32.00 64.00 -32.00 0.00 32.00 161.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 64.00 0.00 129.00 32.00 32.00 33.00 32.00 0.00 32.00 32.00 0.00 -97.00 65.00 32.00 64.00 -32.00 32.00 0.00 32.00 32.00 33.00 0.00 32.00 129.00 32.00 97.00 0.00 0.00 -32.00 32.00 32.00 64.00 0.00 32.00 32.00 97.00 -32.00 32.00 0.00 96.00 -64.00 65.00 32.00 32.00 -32.00 96.00 32.00 64.00 -32.00 0.00 32.00 161.00 32.00 32.00 32.00 33.00 32.00 64.00 32.00 32.00 0.00 32.00 33.00 65.00 -33.00 0.00 -32.00 64.00 32.00 0.00 -32.00 32.00 0.00 129.00 32.00 64.00 -32.00 32.00 0.00 64.00 0.00 65.00 65.00 32.00 -97.00 128.00 64.00 0.00 33.00 33.00 0.00 0.00 32.00 64.00 0.00 32.00 -32.00 0.00 32.00 32.00 0.00 64.00 0.00 -32.00 32.00 32.00 0.00 33.00 32.00 32.00 0.00 0.00 32.00 64.00 -32.00 -32.00 32.00 -32.00 32.00 64.00 32.00 32.00 -32.00 32.00 32.00 -32.00 0.00 32.00 33.00 -32.00 32.00 32.00 32.00 0.00 32.00 65.00 -32.00 32.00 32.00 64.00 0.00 0.00 64.00 64.00 32.00 65.00 33.00 32.00 96.00 32.00 32.00 0.00 -96.00 32.00 -65.00 32.00 0.00 0.00 65.00 32.00 0.00 65.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 64.00 64.00 0.00 -32.00 32.00 65.00 65.00 0.00 32.00 -33.00 0.00 0.00 32.00 33.00 0.00 32.00 64.00 32.00 -32.00 32.00 -32.00 0.00 32.00 -32.00 64.00 -32.00 65.00 0.00 32.00 96.00 0.00 65.00 129.00 -33.00 64.00 33.00 32.00 -33.00 64.00 0.00 32.00 65.00 0.00 -32.00 -32.00 64.00 -32.00 32.00 32.00 32.00 0.00 64.00 -64.00 65.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 64.00 -32.00 32.00 64.00 0.00 96.00 0.00 65.00 65.00 -32.00 64.00 32.00 32.00 -65.00 64.00 33.00 0.00 64.00 33.00 -32.00 64.00 32.00 32.00 0.00 -32.00 64.00 0.00 32.00 -32.00 33.00 0.00 32.00 32.00 0.00 64.00 -32.00 0.00 -65.00 97.00 0.00 32.00 65.00 64.00 0.00 0.00 32.00 -32.00 128.00 0.00 32.00 32.00 -32.00 97.00 32.00 64.00 -32.00 0.00 32.00 -32.00 33.00 0.00 32.00 96.00 -32.00 32.00 32.00 65.00 0.00 32.00 -32.00 -32.00 -33.00 -65.00 -64.00 32.00 -32.00 65.00 0.00 64.00 32.00 32.00 64.00 32.00 33.00 33.00 0.00 32.00 -65.00 32.00 65.00 129.00 32.00 0.00 -32.00 64.00 -65.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 96.00 64.00 0.00 32.00 -96.00 97.00 32.00 64.00 32.00 32.00 64.00 -64.00 33.00 32.00 0.00 32.00 64.00 0.00 32.00 -129.00 64.00 -32.00 32.00 65.00 -32.00 64.00 32.00 96.00 -32.00 33.00 -64.00 32.00 32.00 64.00 64.00 0.00 33.00 -64.00 193.00 -32.00 96.00 96.00 32.00 -32.00 0.00 -32.00 97.00 0.00 32.00 32.00 32.00 96.00 -64.00 32.00 -65.00 33.00 0.00 128.00 33.00 0.00 96.00 32.00 32.00 65.00 -32.00 96.00 -64.00 64.00 0.00 33.00 32.00 64.00 64.00 0.00 257.00 -129.00 161.00 32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 0.00 97.00 33.00 96.00 64.00 64.00 32.00 65.00 -32.00 96.00 0.00 32.00 -32.00 32.00 -65.00 0.00 -64.00 -32.00 -32.00 0.00 -64.00 65.00 0.00 64.00 0.00 64.00 0.00 161.00 32.00 32.00 64.00 64.00 0.00 65.00 32.00 0.00 32.00 64.00 0.00 32.00 -32.00 32.00 0.00 32.00 32.00 97.00 33.00 32.00 32.00 32.00 0.00 129.00 -32.00 32.00 32.00 97.00 225.00 160.00 32.00 32.00 257.00 129.00 64.00 64.00 65.00 129.00 96.00 64.00 193.00 129.00 32.00 32.00 32.00 0.00 33.00 32.00 32.00 97.00 128.00 96.00 33.00 64.00 32.00 97.00 32.00 32.00 64.00 -32.00 97.00 64.00 0.00 32.00 -33.00 32.00 -32.00 193.00 -128.00 161.00 -32.00 97.00 0.00 64.00 32.00 64.00 0.00 65.00 -32.00 32.00 -65.00 64.00 32.00 32.00 -64.00 97.00 64.00 32.00 33.00 32.00 -65.00 161.00 32.00 128.00 0.00 65.00 0.00 32.00 -64.00 96.00 32.00 97.00 97.00 64.00 32.00 96.00 32.00 129.00 96.00 64.00 97.00 161.00 -32.00 32.00 -32.00 97.00 32.00 161.00 64.00 32.00 64.00 96.00 97.00 64.00 32.00 65.00 32.00 32.00 0.00 96.00 32.00 65.00 97.00 32.00 -32.00 193.00 64.00 64.00 96.00 64.00 33.00 33.00 0.00 160.00 32.00 161.00 32.00 129.00 128.00 353.00 33.00 32.00 128.00 33.00 129.00 -33.00 96.00 33.00 32.00 32.00 33.00 64.00 32.00 64.00 353.00 258.00 33.00 128.00 64.00 65.00 96.00 64.00 65.00 0.00 64.00 64.00 32.00 64.00 0.00 129.00 -64.00 129.00 0.00 96.00 64.00 129.00 32.00 32.00 -128.00 193.00 64.00 64.00 -32.00 97.00 64.00 96.00 64.00 64.00 0.00 65.00 0.00 32.00 129.00 193.00 64.00 32.00 65.00 0.00 96.00 -64.00 129.00 -33.00 160.00 0.00 65.00 65.00 32.00 161.00 0.00 96.00 0.00 96.00 0.00 33.00 32.00 64.00 32.00 64.00 0.00 97.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 -96.00 161.00 0.00 65.00 0.00 64.00 64.00 32.00 -129.00 161.00 -32.00 64.00 65.00 0.00 64.00 0.00 96.00 -32.00 97.00 -32.00 32.00 0.00 64.00 -65.00 32.00 33.00 65.00 64.00 64.00 32.00 64.00 96.00 32.00 65.00 -32.00 128.00 -32.00 0.00 -64.00 0.00 -32.00 33.00 -32.00 32.00 0.00 32.00 0.00 64.00 96.00 97.00 0.00 160.00 32.00 33.00 -32.00 96.00 -64.00 64.00 32.00 32.00 32.00 33.00 96.00 -65.00 65.00 65.00 128.00 32.00 33.00 32.00 96.00 225.00 129.00 0.00 128.00 64.00 193.00 0.00 64.00 33.00 226.00 0.00 64.00 0.00 64.00 64.00 129.00 0.00 0.00 32.00 64.00 161.00 -32.00 96.00 0.00 64.00 32.00 33.00 32.00 0.00 129.00 64.00 96.00 -32.00 32.00 -65.00 0.00 -32.00 -64.00 -64.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 65.00 -33.00 128.00 -32.00 97.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 -161.00 32.00 -32.00 32.00 0.00 64.00 32.00 0.00 33.00 0.00 128.00 0.00 32.00 33.00 0.00 32.00 32.00 0.00 -32.00 64.00 -128.00 64.00 -32.00 129.00 128.00 32.00 32.00 386.00 -32.00 129.00 -96.00 353.00 -354.00 64.00 -97.00 33.00 -64.00 0.00 -96.00 -33.00 -97.00 -32.00 -353.00 32.00 0.00 0.00 -161.00 33.00 -322.00 0.00 -128.00 0.00 -32.00 32.00 -33.00 32.00 -64.00 32.00 -32.00 322.00 -547.00 128.00 -128.00 193.00 -225.00 64.00 -65.00 129.00 -96.00 161.00 -161.00 96.00 -193.00 65.00 -225.00 64.00 -64.00 225.00 -225.00 32.00 -258.00 0.00 -32.00 32.00 -64.00 65.00 -96.00 32.00 -33.00 96.00 -96.00 65.00 -97.00 128.00 -160.00 64.00 -129.00 161.00 -257.00 193.00 -64.00 290.00 -33.00 96.00 -64.00 32.00 0.00 97.00 -64.00 96.00 -97.00 64.00 -96.00 32.00 -32.00 97.00 -129.00 32.00 0.00 0.00 -32.00 97.00 -129.00 32.00 -32.00 193.00 -161.00 64.00 -32.00 64.00 0.00 418.00 -128.00 161.00 -33.00 193.00 -96.00 354.00 -257.00 96.00 -129.00 97.00 -96.00 128.00 -97.00 97.00 -96.00 96.00 -193.00 97.00 -193.00 64.00 -129.00 96.00 -289.00 97.00 -129.00 32.00 -96.00 32.00 -257.00 96.00 -193.00 65.00 -129.00 128.00 -129.00 33.00 0.00 32.00 -32.00 225.00 -160.00 161.00 -65.00 321.00 -64.00 64.00 -32.00 161.00 -32.00 193.00 0.00 289.00 0.00 33.00 289.00 160.00 129.00 65.00 225.00 32.00 321.00 -32.00 97.00 -32.00 418.00 0.00 128.00 -65.00 193.00 225.00 0.00 161.00 65.00 32.00 0.00 32.00 0.00 33.00 -33.00 64.00 33.00 64.00 32.00 0.00 -32.00 97.00 32.00 32.00 32.00 289.00 -129.00 32.00 -32.00 65.00 64.00 64.00 -32.00 64.00 0.00 65.00 0.00 96.00 -64.00 64.00 64.00 65.00 65.00 0.00 -33.00 -33.00 -64.00 0.00 -32.00 33.00 -32.00 0.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 161.00 -32.00 32.00 64.00 32.00 0.00 -32.00 64.00 32.00 0.00 32.00 -32.00 33.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 96.00 65.00 65.00 225.00 64.00 96.00 129.00 225.00 193.00 290.00 225.00 321.00 32.00 32.00 32.00 33.00 32.00 -33.00 64.00 33.00 33.00 32.00 64.00 0.00 0.00 32.00 128.00 32.00 0.00 32.00 33.00 32.00 0.00 33.00 -33.00 32.00 -32.00 0.00 0.00 32.00 97.00 0.00 32.00 64.00 1704.00 772.00 64.00 128.00 193.00 97.00 129.00 96.00 64.00 32.00 64.00 0.00 33.00 0.00 0.00 -32.00 96.00 -32.00 129.00 0.00 64.00 32.00 32.00 -32.00 64.00 32.00 33.00 -32.00 64.00 0.00 32.00 32.00 64.00 65.00 33.00 0.00 96.00 64.00 129.00 0.00 64.00 32.00 64.00 0.00 65.00 -32.00 32.00 -32.00 160.00 -65.00 161.00 0.00 32.00 33.00 33.00 -33.00 96.00 33.00 32.00 32.00 32.00 -32.00 97.00 0.00 64.00 0.00 64.00 32.00 161.00 -65.00 161.00 65.00 64.00 64.00 65.00 0.00 32.00 32.00 32.00 32.00 32.00 33.00 32.00 128.00 -32.00 290.00 0.00 32.00 -193.00 160.00 -64.00 97.00 -32.00 257.00 -97.00 129.00 1126.00 386.00 1125.00 418.00 0.00 64.00 0.00 96.00 0.00 32.00 32.00 0.00 32.00 0.00 0.00 -64.00 32.00 0.00 0.00 -32.00 32.00 -64.00 33.00 -32.00 0.00 -65.00 0.00 -64.00 64.00 -64.00 64.00 32.00 65.00 -64.00 32.00 32.00 32.00 -65.00 0.00 -64.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 -33.00 0.00 -32.00 -32.00 32.00 0.00 -64.00 32.00 -32.00 65.00 0.00 96.00 0.00 32.00 96.00 0.00 33.00 0.00 32.00 64.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 32.00 97.00 -32.00 64.00 -32.00 96.00 -32.00 32.00 0.00 33.00 -32.00 64.00 32.00 0.00 32.00 -32.00 32.00 -32.00 32.00 64.00 33.00 0.00 64.00 -64.00 0.00 -97.00 0.00 -32.00 32.00 -32.00 -32.00 -97.00 0.00 -64.00 64.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -64.00 64.00 -64.00 65.00 32.00 0.00 32.00 0.00 32.00 -65.00 65.00 0.00 32.00 32.00 0.00 97.00 -32.00 32.00 32.00 -32.00 32.00 64.00 129.00 -32.00 96.00 32.00 -32.00 32.00 -64.00 0.00 -65.00 33.00 -32.00 0.00 -32.00 -33.00 -64.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 97.00 32.00 32.00 -64.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 64.00 0.00 65.00 32.00 -32.00 32.00 64.00 128.00 -32.00 33.00 -32.00 64.00 64.00 32.00 0.00 -32.00 32.00 0.00 97.00 -64.00 64.00 32.00 32.00 96.00 32.00 65.00 32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 32.00 32.00 0.00 33.00 -32.00 128.00 32.00 0.00 32.00 32.00 32.00 -32.00 33.00 32.00 160.00 -289.00 -32.00 -96.00 32.00 -65.00 -32.00 -64.00 32.00 -32.00 0.00 -32.00 97.00 32.00 0.00 64.00 64.00 32.00 64.00 97.00 -32.00 64.00 0.00 32.00 32.00 32.00 33.00 0.00 -33.00 65.00 33.00 32.00 32.00 32.00 0.00 32.00 32.00 32.00 32.00 32.00 97.00 193.00 0.00 32.00 -33.00 97.00 65.00 -32.00 32.00 32.00 0.00 -64.00 0.00 -97.00 0.00 -129.00 -32.00 -225.00 32.00 -128.00 -64.00 -32.00 0.00 -32.00 64.00 -97.00 -32.00 0.00 160.00 -64.00 97.00 32.00 32.00 32.00 -32.00 129.00 0.00 32.00 -32.00 32.00 0.00 64.00 32.00 -64.00 32.00 64.00 0.00 -32.00 32.00 64.00 32.00 0.00 65.00 -64.00 0.00 -64.00 96.00 0.00 0.00 -32.00 -64.00 -32.00 0.00 -33.00 0.00 -32.00 128.00 0.00 33.00 0.00 96.00 -32.00 32.00 -32.00 97.00 32.00 96.00 32.00 -32.00 32.00 0.00 33.00 -32.00 -65.00 0.00 32.00 32.00 65.00 -32.00 0.00 0.00 64.00 0.00 32.00 64.00 -32.00 32.00 64.00 32.00 -32.00 33.00 32.00 32.00 -32.00 -65.00 -64.00 33.00 -32.00 32.00 32.00 0.00 -32.00 64.00 0.00 129.00 64.00 64.00 129.00 -64.00 64.00 0.00 32.00 -32.00 0.00 -65.00 -32.00 -32.00 32.00 -32.00 96.00 96.00 -32.00 -32.00 32.00 32.00 0.00 33.00 -32.00 0.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 64.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 32.00 65.00 -32.00 32.00 0.00 32.00 32.00 -32.00 0.00 32.00 0.00 -32.00 64.00 -32.00 32.00 32.00 193.00 -32.00 0.00 -33.00 64.00 33.00 129.00 0.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 64.00 0.00 -96.00 -32.00 0.00 0.00 -33.00 64.00 -160.00 32.00 64.00 0.00 32.00 0.00 -32.00 0.00 -64.00 0.00 -33.00 32.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 0.00 32.00 0.00 33.00 0.00 64.00 -32.00 0.00 -32.00 96.00 -32.00 0.00 32.00 0.00 32.00 65.00 32.00 32.00 96.00 -97.00 33.00 33.00 32.00 32.00 32.00 32.00 32.00 -32.00 0.00 32.00 32.00 -97.00 65.00 65.00 -33.00 32.00 33.00 -32.00 32.00 32.00 64.00 0.00 32.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -64.00 32.00 -97.00 -32.00 -129.00 64.00 33.00 -32.00 128.00 0.00 193.00 -32.00 97.00 0.00 32.00 32.00 0.00 32.00 -64.00 65.00 64.00 32.00 0.00 -64.00 -64.00 -33.00 0.00 0.00 -65.00 33.00 -32.00 0.00 -129.00 0.00 -64.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 96.00 -64.00 33.00 32.00 64.00 -65.00 32.00 0.00 64.00 0.00 0.00 33.00 65.00 128.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 0.00 32.00 0.00 33.00 -32.00 32.00 32.00 0.00 -32.00 64.00 -64.00 32.00 0.00 32.00 32.00 33.00 32.00 -65.00 32.00 32.00 0.00 33.00 32.00 0.00 0.00 -33.00 33.00 33.00 0.00 32.00 -33.00 32.00 33.00 32.00 32.00 129.00 32.00 32.00 0.00 64.00 -32.00 0.00 -65.00 0.00 0.00 32.00 97.00 64.00 32.00 0.00 32.00 0.00 0.00 -32.00 0.00 -64.00 32.00 0.00 0.00 32.00 33.00 -32.00 -33.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 0.00 -64.00 65.00 -32.00 64.00 0.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 32.00 -32.00 -65.00 0.00 -32.00 0.00 -32.00 64.00 -64.00 32.00 32.00 0.00 32.00 33.00 0.00 0.00 -96.00 64.00 -33.00 -32.00 0.00 -65.00 0.00 0.00 -32.00 33.00 0.00 64.00 0.00 64.00 65.00 0.00 32.00 -32.00 32.00 0.00 32.00 32.00 -32.00 0.00 129.00 -128.00 0.00 96.00 32.00 32.00 32.00 -32.00 64.00 -32.00 0.00 0.00 32.00 -64.00 65.00 32.00 0.00 64.00 -65.00 32.00 32.00 -32.00 33.00 -64.00 64.00 0.00 64.00 32.00 0.00 0.00 -64.00 32.00 -32.00 0.00 32.00 64.00 -32.00 0.00 -65.00 33.00 0.00 32.00 97.00 -32.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 -65.00 32.00 0.00 65.00 0.00 32.00 33.00 32.00 0.00 -64.00 32.00 -65.00 32.00 -64.00 96.00 97.00 -64.00 32.00 0.00 32.00 32.00 32.00 0.00 -64.00 32.00 -32.00 0.00 -65.00 -32.00 0.00 0.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -96.00 64.00 -32.00 65.00 0.00 32.00 64.00 -32.00 -97.00 32.00 -64.00 32.00 32.00 32.00 32.00 32.00 161.00 32.00 161.00 0.00 32.00 -32.00 64.00 0.00 33.00 0.00 -33.00 65.00 -64.00 32.00 -32.00 0.00 -64.00 -32.00 -97.00 32.00 -161.00 96.00 -32.00 32.00 32.00 32.00 97.00 65.00 32.00 -32.00 32.00 32.00 0.00 0.00 -64.00 32.00 0.00 0.00 32.00 32.00 -32.00 -32.00 -32.00 -64.00 0.00 -33.00 -129.00 0.00 -64.00 65.00 0.00 32.00 64.00 32.00 -32.00 -64.00 -64.00 64.00 -32.00 0.00 -33.00 32.00 0.00 65.00 33.00 0.00 32.00 -33.00 0.00 0.00 32.00 33.00 32.00 96.00 32.00 32.00 32.00 -32.00 32.00 32.00 33.00 32.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -64.00 32.00 -32.00 -64.00 0.00 32.00 32.00 64.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -32.00 -32.00 -33.00 0.00 65.00 97.00 -97.00 32.00 32.00 32.00 33.00 0.00 32.00 64.00 0.00 65.00 -65.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 32.00 -64.00 32.00 -32.00 0.00 -33.00 33.00 65.00 64.00 32.00 0.00 -32.00 -32.00 96.00 0.00 32.00 -65.00 -32.00 65.00 32.00 0.00 65.00 0.00 96.00 -65.00 32.00 0.00 32.00 -32.00 0.00 97.00 33.00 32.00 32.00 0.00 32.00 0.00 64.00 -129.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 0.00 -32.00 32.00 -32.00 65.00 64.00 -32.00 33.00 0.00 32.00 0.00 128.00 32.00 97.00 0.00 32.00 0.00 -32.00 32.00 -97.00 0.00 33.00 0.00 -65.00 32.00 0.00 0.00 32.00 32.00 -64.00 -64.00 -64.00 32.00 -65.00 32.00 33.00 0.00 -97.00 32.00 -32.00 33.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 65.00 -33.00 64.00 0.00 64.00 33.00 0.00 32.00 33.00 32.00 32.00 -97.00 32.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 128.00 -32.00 33.00 64.00 0.00 65.00 -33.00 32.00 -64.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 64.00 0.00 33.00 -32.00 0.00 -32.00 32.00 32.00 32.00 32.00 -32.00 0.00 32.00 0.00 32.00 33.00 0.00 -33.00 32.00 -32.00 -32.00 32.00 64.00 33.00 33.00 -33.00 0.00 -32.00 0.00 32.00 -33.00 -64.00 33.00 -32.00 0.00 -32.00 64.00 128.00 -32.00 33.00 32.00 0.00 128.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 32.00 33.00 0.00 64.00 32.00 -32.00 0.00 32.00 -32.00 64.00 -32.00 0.00 32.00 32.00 32.00 65.00 0.00 -65.00 33.00 -64.00 64.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 32.00 96.00 -32.00 65.00 32.00 0.00 96.00 -32.00 32.00 -33.00 0.00 -32.00 33.00 0.00 64.00 32.00 0.00 0.00 -64.00 65.00 32.00 0.00 -32.00 32.00 -65.00 -32.00 -128.00 -65.00 -32.00 33.00 0.00 0.00 -65.00 32.00 0.00 32.00 -32.00 64.00 0.00 0.00 129.00 32.00 96.00 0.00 64.00 32.00 33.00 33.00 0.00 -33.00 -97.00 0.00 -64.00 33.00 32.00 0.00 -64.00 64.00 -65.00 32.00 -32.00 32.00 0.00 -32.00 32.00 64.00 65.00 0.00 96.00 0.00 64.00 -64.00 65.00 0.00 64.00 32.00 0.00 32.00 0.00 65.00 0.00 64.00 64.00 32.00 -32.00 -64.00 -64.00 -97.00 0.00 0.00 -32.00 65.00 -32.00 0.00 -65.00 0.00 -96.00 32.00 -32.00 64.00 32.00 0.00 32.00 32.00 96.00 -32.00 33.00 32.00 0.00 0.00 -33.00 65.00 0.00 -65.00 -32.00 33.00 -32.00 -33.00 -64.00 -64.00 -64.00 64.00 -65.00 33.00 32.00 64.00 -64.00 32.00 32.00 0.00 -64.00 -32.00 32.00 -64.00 -32.00 64.00 -64.00 0.00 -32.00 32.00 -97.00 32.00 0.00 0.00 -32.00 32.00 64.00 -32.00 -64.00 97.00 -32.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 0.00 -65.00 64.00 -32.00 32.00 32.00 0.00 -32.00 33.00 0.00 64.00 0.00 64.00 -64.00 0.00 -32.00 32.00 0.00 65.00 32.00 32.00 32.00 0.00 161.00 -65.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 64.00 96.00 -32.00 -32.00 97.00 -64.00 32.00 -32.00 -32.00 32.00 64.00 -32.00 32.00 -32.00 -32.00 0.00 64.00 -97.00 0.00 97.00 0.00 64.00 -32.00 0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 32.00 32.00 97.00 -32.00 32.00 32.00 0.00 32.00 96.00 0.00 97.00 -64.00 0.00 -32.00 64.00 -97.00 161.00 -64.00 64.00 0.00 97.00 -64.00 64.00 0.00 64.00 0.00 32.00 32.00 -64.00 64.00 -32.00 32.00 -64.00 33.00 -32.00 0.00 -97.00 64.00 -96.00 161.00 -129.00 32.00 -97.00 0.00 -160.00 32.00 -65.00 32.00 -32.00 64.00 0.00 33.00 32.00 -33.00 65.00 0.00 32.00 0.00 96.00 0.00 32.00 0.00 33.00 0.00 32.00 -64.00 64.00 -64.00 193.00 -97.00 97.00 32.00 0.00 65.00 -33.00 64.00 97.00 0.00 32.00 32.00 0.00 -64.00 -161.00 32.00 -32.00 32.00 -161.00 32.00 0.00 33.00 32.00 32.00 193.00 -32.00 33.00 32.00 0.00 0.00 -65.00 32.00 0.00 -32.00 -32.00 0.00 -96.00 -32.00 -65.00 32.00 -64.00 32.00 -32.00 161.00 -97.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 64.00 32.00 0.00 64.00 -128.00 97.00 0.00 96.00 32.00 64.00 0.00 33.00 32.00 0.00 64.00 64.00 -64.00 129.00 0.00 128.00 -32.00 97.00 -32.00 96.00 -32.00 0.00 -32.00 0.00 -97.00 32.00 -96.00 97.00 64.00 128.00 -129.00 129.00 65.00 161.00 96.00 0.00 0.00 96.00 0.00 32.00 129.00 -32.00 0.00 32.00 -32.00 65.00 -33.00 96.00 -32.00 32.00 -32.00 129.00 -129.00 96.00 97.00 64.00 0.00 33.00 -193.00 160.00 64.00 65.00 32.00 32.00 65.00 64.00 0.00 65.00 64.00 289.00 -96.00 32.00 0.00 32.00 32.00 32.00 0.00 32.00 -65.00 97.00 0.00 96.00 0.00 33.00 33.00 32.00 0.00 64.00 -33.00 64.00 -64.00 65.00 -96.00 32.00 -33.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -97.00 32.00 -128.00 0.00 -65.00 0.00 -32.00 32.00 -32.00 33.00 -32.00 128.00 32.00 161.00 32.00 32.00 64.00 -64.00 33.00 32.00 32.00 0.00 96.00 -32.00 161.00 32.00 32.00 64.00 32.00 32.00 32.00 65.00 -160.00 225.00 0.00 32.00 64.00 0.00 32.00 129.00 -64.00 289.00 -65.00 161.00 0.00 96.00 -64.00 97.00 -32.00 32.00 -32.00 64.00 0.00 97.00 32.00 64.00 0.00 96.00 -32.00 32.00 -97.00 97.00 0.00 32.00 65.00 32.00 -65.00 65.00 -96.00 32.00 -64.00 64.00 -65.00 129.00 0.00 32.00 -64.00 32.00 -64.00 0.00 -33.00 96.00 -64.00 33.00 -64.00 -33.00 -32.00 -64.00 -97.00 32.00 0.00 32.00 65.00 65.00 -33.00 160.00 -32.00 33.00 0.00 96.00 0.00 64.00 -32.00 33.00 -128.00 96.00 0.00 64.00 0.00 32.00 64.00 33.00 32.00 0.00 96.00 -129.00 65.00 32.00 0.00 32.00 -32.00 65.00 -33.00 64.00 -64.00 64.00 0.00 97.00 0.00 96.00 0.00 32.00 32.00 0.00 -32.00 65.00 0.00 64.00 32.00 64.00 -32.00 65.00 32.00 32.00 65.00 32.00 0.00 32.00 -225.00 64.00 -65.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 65.00 32.00 32.00 32.00 32.00 -32.00 64.00 -32.00 0.00 -65.00 32.00 33.00 129.00 -161.00 32.00 -65.00 32.00 -64.00 0.00 -32.00 0.00 -64.00 32.00 0.00 129.00 -32.00 32.00 -65.00 -128.00 -32.00 0.00 -32.00 32.00 0.00 64.00 0.00 32.00 -64.00 32.00 0.00 33.00 0.00 32.00 -65.00 -32.00 0.00 32.00 -64.00 32.00 -64.00 96.00 32.00 65.00 0.00 32.00 64.00 -32.00 0.00 32.00 0.00 32.00 32.00 96.00 33.00 -32.00 32.00 0.00 0.00 64.00 0.00 65.00 0.00 64.00 32.00 64.00 64.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 32.00 0.00 97.00 0.00 32.00 33.00 0.00 32.00 32.00 -32.00 0.00 0.00 32.00 64.00 -32.00 0.00 32.00 -32.00 0.00 64.00 32.00 -32.00 0.00 -32.00 32.00 -65.00 -64.00 -64.00 0.00 -32.00 32.00 32.00 0.00 0.00 32.00 32.00 33.00 -64.00 32.00 -64.00 -32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 -33.00 32.00 -32.00 -32.00 -64.00 0.00 -64.00 32.00 0.00 32.00 32.00 0.00 64.00 65.00 -32.00 0.00 32.00 64.00 32.00 32.00 0.00 32.00 -64.00 32.00 0.00 33.00 0.00 64.00 64.00 0.00 32.00 32.00 0.00 32.00 -64.00 0.00 0.00 32.00 32.00 0.00 32.00 33.00 -32.00 64.00 -64.00 -32.00 -32.00 32.00 0.00 32.00 64.00 32.00 -64.00 65.00 32.00 32.00 -64.00 32.00 0.00 96.00 32.00 65.00 -32.00 32.00 0.00 96.00 -33.00 -32.00 -96.00 32.00 32.00 129.00 -32.00 32.00 -32.00 0.00 0.00 -97.00 -32.00 0.00 -32.00 65.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 32.00 64.00 65.00 -32.00 0.00 64.00 32.00 32.00 -32.00 65.00 -33.00 0.00 -64.00 0.00 32.00 96.00 -32.00 32.00 -64.00 -64.00 -65.00 0.00 97.00 64.00 0.00 32.00 -64.00 33.00 64.00 32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 -65.00 0.00 -32.00 32.00 32.00 32.00 -32.00 65.00 -32.00 0.00 -32.00 -33.00 -32.00 33.00 0.00 128.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 65.00 64.00 -65.00 65.00 65.00 32.00 0.00 64.00 -65.00 0.00 -32.00 0.00 -32.00 64.00 -64.00 -32.00 0.00 65.00 0.00 32.00 -32.00 0.00 -33.00 -65.00 -32.00 0.00 32.00 33.00 0.00 32.00 -64.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 -64.00 64.00 32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 32.00 0.00 -32.00 33.00 -32.00 32.00 -32.00 -32.00 0.00 96.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 65.00 -32.00 32.00 0.00 -32.00 0.00 32.00 -33.00 0.00 0.00 64.00 33.00 0.00 32.00 64.00 -65.00 0.00 33.00 33.00 -33.00 0.00 0.00 32.00 33.00 0.00 0.00 64.00 -97.00 -32.00 32.00 128.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 0.00 32.00 64.00 97.00 -64.00 0.00 32.00 32.00 -64.00 32.00 -32.00 32.00 -65.00 0.00 0.00 33.00 -64.00 32.00 0.00 64.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 33.00 -32.00 32.00 32.00 64.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 33.00 33.00 -33.00 32.00 33.00 0.00 -33.00 0.00 33.00 32.00 -33.00 32.00 -32.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 33.00 -32.00 32.00 32.00 -97.00 65.00 32.00 128.00 0.00 65.00 -64.00 32.00 32.00 32.00 0.00 64.00 -32.00 65.00 0.00 64.00 0.00 64.00 0.00 32.00 -64.00 33.00 0.00 64.00 0.00 32.00 -65.00 32.00 33.00 64.00 -33.00 65.00 -64.00 32.00 -32.00 96.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 97.00 0.00 32.00 -32.00 -32.00 -64.00 64.00 -64.00 32.00 0.00 97.00 -33.00 32.00 -32.00 0.00 0.00 64.00 0.00 32.00 -32.00 0.00 0.00 65.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 64.00 -33.00 0.00 -64.00 0.00 -32.00 64.00 -97.00 65.00 0.00 32.00 -64.00 0.00 -32.00 32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -64.00 0.00 0.00 33.00 -33.00 0.00 33.00 -33.00 -65.00 0.00 -32.00 33.00 0.00 64.00 -32.00 0.00 0.00 64.00 0.00 32.00 -64.00 65.00 0.00 32.00 -33.00 32.00 33.00 64.00 0.00 65.00 32.00 32.00 -32.00 32.00 32.00 64.00 0.00 32.00 -32.00 32.00 -33.00 -32.00 -64.00 32.00 32.00 33.00 -32.00 32.00 0.00 64.00 -32.00 32.00 0.00 32.00 -32.00 0.00 32.00 129.00 -32.00 0.00 -32.00 0.00 -65.00 96.00 -32.00 0.00 -32.00 65.00 -64.00 -32.00 0.00 64.00 -32.00 0.00 -33.00 0.00 -32.00 64.00 -128.00 65.00 32.00 32.00 -32.00 32.00 0.00 64.00 -32.00 64.00 32.00 0.00 -65.00 65.00 0.00 64.00 -64.00 64.00 0.00 65.00 -64.00 96.00 -65.00 97.00 -160.00 160.00 -65.00 193.00 -128.00 161.00 -32.00 32.00 -65.00 32.00 -64.00 33.00 -64.00 96.00 -129.00 96.00 -96.00 -32.00 -65.00 0.00 -64.00 0.00 -64.00 -32.00 -32.00 32.00 -33.00 -64.00 -64.00 0.00 -96.00 -32.00 -65.00 64.00 -64.00 97.00 -611.00 482.00 -386.00 321.00 -160.00 129.00 -97.00 64.00 -547.00 450.00 -64.00 65.00 -900.00 707.00 -97.00 64.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 32.00 65.00 -96.00 64.00 -33.00 64.00 -450.00 322.00 -932.00 772.00 0.00 32.00 0.00 32.00 32.00 32.00 64.00 32.00 65.00 0.00 0.00 32.00 193.00 0.00 128.00 32.00 32.00 0.00 65.00 129.00 128.00 32.00 65.00 0.00 160.00 0.00 225.00 32.00 65.00 0.00 96.00 -32.00 32.00 -32.00 65.00 0.00 32.00 -32.00 32.00 0.00 96.00 -32.00 97.00 32.00 32.00 -64.00 32.00 0.00 64.00 32.00 33.00 64.00 32.00 32.00 64.00 65.00 0.00 32.00 0.00 64.00 32.00 64.00 64.00 97.00 0.00 64.00 0.00 -32.00 33.00 32.00 96.00 129.00 32.00 32.00 65.00 32.00 64.00 32.00 161.00 32.00 96.00 0.00 64.00 65.00 33.00 32.00 64.00 32.00 193.00 129.00 0.00 64.00 0.00 96.00 -32.00 65.00 -97.00 193.00 -64.00 96.00 -64.00 32.00 -33.00 32.00 -32.00 0.00 -96.00 32.00 -225.00 -32.00 -65.00 32.00 -32.00 65.00 -32.00 64.00 0.00 129.00 0.00 32.00 32.00 225.00 0.00 32.00 32.00 32.00 65.00 97.00 128.00 128.00 0.00 32.00 65.00 97.00 0.00 32.00 0.00 97.00 -97.00 64.00 -193.00 32.00 -64.00 32.00 -64.00 64.00 -65.00 97.00 -32.00 64.00 0.00 65.00 32.00 32.00 129.00 32.00 96.00 128.00 0.00 65.00 -32.00 96.00 -64.00 65.00 -129.00 96.00 -160.00 64.00 -129.00 -32.00 -64.00 32.00 -65.00 65.00 -64.00 64.00 0.00 96.00 0.00 97.00 32.00 96.00 32.00 161.00 33.00 64.00 -33.00 33.00 0.00 32.00 33.00 64.00 64.00 32.00 64.00 32.00 32.00 32.00 32.00 97.00 -32.00 128.00 -32.00 33.00 -64.00 -33.00 -129.00 -96.00 -96.00 -32.00 -258.00 0.00 -32.00 32.00 -64.00 96.00 -32.00 65.00 -97.00 96.00 -64.00 32.00 -225.00 193.00 -64.00 129.00 -32.00 32.00 -65.00 97.00 0.00 96.00 -64.00 64.00 -32.00 97.00 0.00 64.00 64.00 193.00 0.00 129.00 -32.00 64.00 -32.00 64.00 -97.00 65.00 -257.00 64.00 -96.00 161.00 -65.00 64.00 -32.00 0.00 -161.00 64.00 -64.00 0.00 -64.00 0.00 -32.00 0.00 -129.00 0.00 -193.00 32.00 -64.00 32.00 -64.00 33.00 -129.00 64.00 -225.00 0.00 -64.00 96.00 -65.00 65.00 -193.00 128.00 -128.00 129.00 -193.00 96.00 -97.00 33.00 -32.00 0.00 -32.00 64.00 -96.00 96.00 -33.00 65.00 0.00 96.00 0.00 64.00 33.00 33.00 64.00 225.00 0.00 64.00 0.00 129.00 0.00 32.00 0.00 289.00 32.00 290.00 32.00 128.00 -32.00 97.00 -96.00 160.00 -33.00 129.00 -96.00 129.00 -96.00 128.00 -65.00 97.00 0.00 32.00 -64.00 64.00 -193.00 193.00 -129.00 161.00 -64.00 128.00 -64.00 33.00 -32.00 257.00 0.00 96.00 96.00 193.00 0.00 32.00 97.00 225.00 32.00 65.00 64.00 64.00 129.00 64.00 160.00 129.00 97.00 64.00 96.00 129.00 97.00 64.00 128.00 32.00 65.00 32.00 32.00 65.00 0.00 32.00 -32.00 64.00 -32.00 32.00 0.00 97.00 0.00 32.00 32.00 225.00 -32.00 129.00 0.00 128.00 -65.00 97.00 32.00 161.00 0.00 64.00 0.00 161.00 -32.00 64.00 -64.00 32.00 0.00 32.00 -32.00 32.00 0.00 97.00 -32.00 64.00 32.00 97.00 -32.00 160.00 -33.00 97.00 -32.00 64.00 -64.00 129.00 -96.00 193.00 -33.00 257.00 -32.00 96.00 -64.00 161.00 -64.00 64.00 -97.00 65.00 -128.00 64.00 -33.00 0.00 -128.00 193.00 -32.00 96.00 -33.00 65.00 -32.00 289.00 0.00 64.00 -64.00 97.00 -193.00 161.00 -32.00 96.00 -64.00 64.00 -33.00 129.00 -64.00 96.00 -225.00 322.00 -129.00 193.00 -96.00 128.00 -32.00 65.00 -97.00 32.00 -128.00 0.00 -193.00 64.00 -225.00 193.00 -65.00 32.00 -64.00 97.00 -64.00 64.00 -64.00 129.00 -33.00 96.00 -257.00 225.00 -32.00 97.00 0.00 64.00 -32.00 97.00 -64.00 128.00 -129.00 193.00 -32.00 32.00 0.00 64.00 0.00 33.00 -161.00 128.00 -129.00 161.00 -128.00 0.00 -32.00 193.00 -97.00 32.00 -64.00 64.00 -64.00 65.00 0.00 32.00 -33.00 128.00 0.00 33.00 0.00 128.00 0.00 32.00 -32.00 129.00 -128.00 129.00 -65.00 225.00 0.00 64.00 0.00 64.00 -32.00 0.00 0.00 32.00 64.00 97.00 33.00 96.00 -65.00 65.00 -32.00 64.00 0.00 96.00 -32.00 65.00 -32.00 64.00 -64.00 32.00 0.00 129.00 -65.00 96.00 0.00 97.00 -32.00 32.00 0.00 64.00 -193.00 225.00 -32.00 161.00 -32.00 97.00 -32.00 96.00 -32.00 32.00 -2926.00 -193.00 -1029.00 -64.00 -1158.00 -64.00 -739.00 -65.00 -3762.00 -257.00 -1737.00 -129.00 -257.00 0.00 -2154.00 -160.00 -2154.00 -161.00 -2476.00 -193.00 -2379.00 -193.00 -579.00 -32.00 -1254.00 -129.00 -3762.00 -289.00 -1736.00 -161.00 -547.00 -32.00 -1865.00 -161.00 -129.00 32.00 -64.00 0.00 -32.00 0.00 0.00 33.00 -96.00 64.00 -97.00 32.00 -32.00 0.00 -32.00 -64.00 0.00 -65.00 -32.00 -64.00 0.00 -161.00 0.00 -64.00 -32.00 0.00 -97.00 -257.00 -64.00 -97.00 -129.00 -32.00 -64.00 -32.00 -64.00 32.00 -33.00 0.00 -289.00 -32.00 -64.00 -32.00 -193.00 32.00 -65.00 -32.00 -64.00 -32.00 -64.00 -32.00 -32.00 -65.00 -65.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 -65.00 -32.00 -96.00 97.00 -129.00 0.00 -64.00 -32.00 -64.00 -65.00 -32.00 0.00 -97.00 -64.00 -32.00 -64.00 -97.00 -33.00 -96.00 -192.00 -97.00 -258.00 -321.00 -32.00 -32.00 -64.00 -32.00 -97.00 -32.00 -64.00 -33.00 -32.00 33.00 -161.00 32.00 -64.00 0.00 -32.00 -32.00 -32.00 -97.00 -161.00 -32.00 -161.00 0.00 -96.00 -97.00 -65.00 -32.00 -32.00 -32.00 32.00 -129.00 0.00 -128.00 -64.00 -64.00 -96.00 0.00 -65.00 0.00 -96.00 -65.00 -225.00 -128.00 -161.00 64.00 -129.00 0.00 -32.00 -96.00 32.00 -161.00 -64.00 -193.00 -64.00 -97.00 -32.00 -32.00 32.00 -225.00 -65.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 -97.00 64.00 -64.00 32.00 -97.00 -32.00 -32.00 -96.00 -64.00 0.00 -32.00 32.00 -64.00 0.00 -65.00 -129.00 -161.00 -32.00 -96.00 0.00 -32.00 97.00 -161.00 0.00 -32.00 0.00 -32.00 -65.00 -129.00 0.00 -64.00 0.00 -32.00 65.00 -97.00 32.00 -161.00 64.00 -160.00 0.00 -32.00 0.00 -65.00 -96.00 -160.00 -65.00 -33.00 -128.00 -32.00 -33.00 -32.00 -32.00 -64.00 -32.00 -258.00 -225.00 -192.00 -128.00 -258.00 -129.00 -128.00 0.00 -97.00 -32.00 -353.00 -32.00 -97.00 -161.00 -289.00 -32.00 -193.00 -65.00 -418.00 -32.00 -64.00 -64.00 -33.00 -64.00 0.00 -33.00 -32.00 -32.00 -225.00 0.00 -32.00 -128.00 -322.00 -129.00 -225.00 -161.00 -160.00 -128.00 -258.00 -33.00 -64.00 -257.00 -161.00 -64.00 -32.00 0.00 32.00 -64.00 -64.00 -97.00 -129.00 0.00 -64.00 -32.00 -161.00 32.00 -193.00 -64.00 -257.00 -96.00 -96.00 -33.00 -129.00 -64.00 -32.00 -32.00 -64.00 -64.00 -129.00 -33.00 0.00 -96.00 -32.00 -97.00 -97.00 -160.00 -289.00 -65.00 -64.00 -64.00 -65.00 -128.00 -32.00 -33.00 0.00 -32.00 -96.00 -64.00 -32.00 -129.00 -161.00 -128.00 -354.00 -33.00 -161.00 -64.00 -96.00 0.00 -418.00 64.00 -129.00 97.00 -96.00 96.00 -161.00 258.00 -225.00 96.00 -32.00 64.00 -97.00 33.00 -64.00 32.00 -161.00 32.00 -32.00 128.00 0.00 33.00 0.00 0.00 -32.00 64.00 -32.00 32.00 -64.00 1897.00 -4212.00 740.00 -1672.00 418.00 -901.00 321.00 -771.00 1415.00 -3087.00 1093.00 -2379.00 322.00 -708.00 193.00 -450.00 128.00 -322.00 354.00 -803.00 193.00 -450.00 32.00 -33.00 547.00 -1221.00 353.00 -772.00 161.00 -418.00 257.00 -515.00 258.00 -578.00 128.00 -290.00 -32.00 -32.00 -64.00 0.00 -65.00 -32.00 -96.00 -32.00 -32.00 -32.00 0.00 -32.00 193.00 -258.00 32.00 -64.00 0.00 -96.00 32.00 -65.00 96.00 -225.00 33.00 -32.00 96.00 -64.00 161.00 -32.00 321.00 -161.00 193.00 -129.00 129.00 -96.00 128.00 -129.00 129.00 -225.00 161.00 -257.00 32.00 -65.00 0.00 -32.00 -225.00 65.00 -64.00 0.00 -65.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -97.00 -32.00 -128.00 161.00 -129.00 32.00 -64.00 32.00 -33.00 32.00 0.00 64.00 -32.00 0.00 -32.00 97.00 -64.00 32.00 -97.00 0.00 -96.00 -32.00 -64.00 32.00 -33.00 64.00 -96.00 65.00 -64.00 0.00 -65.00 -65.00 -32.00 -32.00 -64.00 32.00 -64.00 33.00 -33.00 32.00 -128.00 -161.00 -65.00 0.00 -32.00 0.00 -64.00 64.00 -96.00 32.00 -33.00 65.00 -64.00 32.00 -32.00 -32.00 -64.00 0.00 0.00 32.00 -32.00 128.00 -33.00 33.00 -32.00 -33.00 -64.00 0.00 -97.00 33.00 -128.00 0.00 -97.00 -65.00 -32.00 -64.00 -96.00 -32.00 -97.00 -32.00 -64.00 0.00 -32.00 -32.00 0.00 -129.00 96.00 -129.00 97.00 -96.00 32.00 -97.00 0.00 -32.00 0.00 -96.00 -32.00 -97.00 -32.00 -32.00 -65.00 -64.00 -64.00 0.00 -129.00 64.00 -193.00 0.00 -64.00 0.00 -64.00 -32.00 -97.00 -129.00 -96.00 -64.00 -32.00 -32.00 -32.00 0.00 -193.00 -32.00 -32.00 -32.00 -33.00 -97.00 -64.00 -64.00 -32.00 -64.00 -193.00 32.00 -32.00 -32.00 -97.00 -225.00 -64.00 -65.00 -32.00 -96.00 64.00 -65.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 -65.00 -96.00 97.00 -64.00 -129.00 -97.00 0.00 -64.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 -129.00 0.00 -32.00 -64.00 64.00 -33.00 -64.00 -32.00 32.00 -32.00 0.00 -32.00 -64.00 -64.00 32.00 -32.00 32.00 -33.00 0.00 -64.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 64.00 -33.00 0.00 0.00 -32.00 -128.00 0.00 -32.00 96.00 -97.00 -64.00 -96.00 -32.00 32.00 64.00 -64.00 32.00 -97.00 -96.00 -96.00 64.00 -32.00 -64.00 64.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 -33.00 0.00 -64.00 -65.00 0.00 -64.00 97.00 -64.00 -33.00 32.00 -64.00 0.00 -32.00 -193.00 64.00 -32.00 -64.00 0.00 -64.00 -65.00 32.00 -32.00 -32.00 -32.00 -65.00 -96.00 65.00 32.00 -129.00 -65.00 0.00 -32.00 -97.00 -32.00 0.00 -64.00 0.00 -97.00 -64.00 -32.00 32.00 -32.00 -64.00 32.00 -32.00 -64.00 -64.00 -32.00 32.00 0.00 32.00 -193.00 32.00 -32.00 -32.00 -97.00 64.00 -64.00 -96.00 -64.00 0.00 32.00 -65.00 -32.00 -64.00 -33.00 -64.00 0.00 -161.00 -64.00 32.00 -96.00 -32.00 0.00 32.00 -65.00 -32.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 0.00 -64.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 -33.00 -32.00 -32.00 -96.00 -32.00 0.00 0.00 -32.00 -96.00 -33.00 0.00 -32.00 -97.00 -32.00 -64.00 0.00 -97.00 64.00 -32.00 -64.00 -32.00 32.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 -97.00 -32.00 -64.00 32.00 -32.00 0.00 0.00 -97.00 -96.00 -32.00 0.00 -64.00 32.00 -32.00 -65.00 0.00 -64.00 -65.00 0.00 -64.00 0.00 -64.00 32.00 -32.00 0.00 -97.00 97.00 -289.00 32.00 -32.00 0.00 -97.00 -64.00 -64.00 32.00 -97.00 0.00 -64.00 -32.00 -32.00 -129.00 -32.00 -32.00 -97.00 0.00 -32.00 -32.00 -64.00 -65.00 -32.00 -32.00 0.00 -193.00 128.00 -32.00 65.00 32.00 32.00 -64.00 64.00 -129.00 32.00 0.00 97.00 -32.00 32.00 -128.00 161.00 -33.00 32.00 -96.00 -129.00 -64.00 -32.00 -97.00 -161.00 -128.00 -32.00 -65.00 -128.00 -64.00 0.00 0.00 32.00 -257.00 32.00 32.00 -64.00 -97.00 -33.00 -32.00 -96.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -129.00 -97.00 -97.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 -64.00 33.00 -96.00 -33.00 -33.00 33.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 -32.00 0.00 -65.00 -128.00 -96.00 32.00 -97.00 -32.00 -64.00 96.00 -32.00 0.00 -32.00 -128.00 -97.00 -33.00 0.00 0.00 32.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -64.00 0.00 -65.00 -32.00 33.00 -32.00 -33.00 -33.00 33.00 -32.00 0.00 0.00 -33.00 -193.00 -128.00 0.00 -32.00 -32.00 -32.00 0.00 -33.00 -32.00 0.00 -64.00 -64.00 0.00 -32.00 -65.00 0.00 -64.00 -32.00 -96.00 -193.00 -65.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 -33.00 -96.00 -96.00 -97.00 -32.00 0.00 -32.00 -32.00 -129.00 -32.00 0.00 0.00 -32.00 -64.00 -64.00 0.00 -65.00 32.00 -32.00 0.00 -96.00 -32.00 -32.00 0.00 -97.00 64.00 0.00 32.00 -64.00 0.00 -32.00 0.00 -97.00 -32.00 -64.00 -32.00 -32.00 -32.00 -129.00 32.00 -161.00 -32.00 -32.00 -33.00 0.00 -32.00 -96.00 -96.00 -32.00 -65.00 -97.00 -64.00 -32.00 -32.00 32.00 0.00 -32.00 -96.00 0.00 0.00 -32.00 -129.00 -64.00 -129.00 -97.00 0.00 -225.00 32.00 -64.00 0.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 -161.00 0.00 -160.00 97.00 -193.00 0.00 -65.00 -33.00 -32.00 33.00 -289.00 -65.00 -64.00 -32.00 0.00 -32.00 -33.00 0.00 -128.00 -32.00 -64.00 0.00 -33.00 0.00 -1350.00 0.00 -4727.00zm60641.00 11254.00l0.00 -32.00 0.00 -32.00 32.00 0.00 64.00 0.00 -32.00 32.00 32.00 0.00 33.00 129.00 0.00 64.00 -33.00 -32.00 -64.00 -97.00 -32.00 -32.00zm-4373.00 -1768.00l-32.00 32.00 32.00 -32.00zm3858.00 1093.00l0.00 32.00 -32.00 0.00 0.00 -32.00 32.00 0.00zm-3986.00 -1061.00l32.00 0.00 -32.00 0.00 0.00 32.00 0.00 -32.00zm2057.00 514.00l32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00zm1351.00 643.00l-32.00 -32.00 32.00 -32.00 32.00 32.00 -32.00 0.00 32.00 32.00 -32.00 0.00zm-579.00 258.00l-32.00 0.00 32.00 0.00 0.00 -33.00 32.00 0.00 0.00 33.00 -32.00 0.00zm-6624.00 -1705.00l33.00 -32.00 32.00 32.00 -32.00 0.00 0.00 33.00 -33.00 32.00 0.00 -32.00 0.00 -33.00zm6913.00 1705.00l0.00 -65.00 32.00 -32.00 33.00 0.00 -33.00 32.00 0.00 97.00 -32.00 0.00 0.00 -32.00zm-3086.00 -1544.00l64.00 0.00 0.00 32.00 32.00 -32.00 32.00 32.00 -128.00 32.00 0.00 -64.00zm3022.00 1254.00l-32.00 32.00 -32.00 0.00 0.00 65.00 -129.00 96.00 32.00 -96.00 65.00 -129.00 0.00 -32.00 32.00 -32.00 32.00 32.00 32.00 32.00 0.00 32.00z"},sp:{name:"SP",path:"M104646.00 137841.00l-33.00 -32.00 0.00 -33.00 0.00 -32.00 33.00 -64.00 96.00 -129.00 97.00 -96.00 32.00 -32.00 193.00 -65.00 32.00 -32.00 64.00 -96.00 193.00 -97.00 32.00 0.00 32.00 -32.00 258.00 -64.00 128.00 -64.00 32.00 0.00 65.00 -129.00 160.00 -129.00 32.00 -64.00 258.00 -161.00 96.00 -32.00 129.00 -96.00 193.00 -65.00 96.00 -64.00 64.00 -32.00 97.00 -64.00 96.00 -97.00 161.00 -32.00 129.00 -64.00 96.00 -33.00 32.00 -32.00 33.00 0.00 32.00 -64.00 96.00 -96.00 32.00 -33.00 225.00 -160.00 32.00 -97.00 33.00 -32.00 64.00 -64.00 161.00 -225.00 128.00 -418.00 33.00 -97.00 160.00 -193.00 65.00 0.00 0.00 -32.00 64.00 -32.00 64.00 -97.00 225.00 -160.00 32.00 -97.00 0.00 -64.00 97.00 -225.00 96.00 -64.00 193.00 -65.00 32.00 -64.00 65.00 -64.00 128.00 -225.00 0.00 -33.00 0.00 -96.00 -64.00 -129.00 0.00 -96.00 -161.00 -129.00 -32.00 -64.00 64.00 -97.00 65.00 -128.00 64.00 -32.00 32.00 0.00 193.00 32.00 97.00 0.00 128.00 -64.00 32.00 -33.00 65.00 -96.00 96.00 -96.00 32.00 -97.00 32.00 -96.00 33.00 -129.00 192.00 -161.00 33.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -129.00 32.00 -161.00 -32.00 -32.00 -32.00 -193.00 -65.00 -96.00 -32.00 -32.00 32.00 -65.00 -32.00 -161.00 32.00 -64.00 32.00 -32.00 129.00 0.00 97.00 -32.00 32.00 0.00 32.00 -64.00 96.00 -33.00 65.00 -160.00 0.00 -97.00 64.00 -96.00 32.00 -97.00 129.00 -161.00 64.00 -32.00 193.00 0.00 32.00 0.00 193.00 -128.00 32.00 -65.00 32.00 -225.00 -64.00 -64.00 -32.00 -96.00 0.00 -161.00 32.00 -161.00 0.00 -32.00 0.00 -32.00 -64.00 -97.00 32.00 -160.00 161.00 -354.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 -32.00 225.00 -129.00 97.00 -96.00 32.00 -96.00 161.00 -258.00 64.00 -64.00 129.00 -96.00 64.00 -33.00 0.00 -32.00 161.00 -289.00 64.00 -32.00 32.00 -129.00 32.00 -32.00 32.00 0.00 97.00 -64.00 96.00 -65.00 290.00 -64.00 193.00 0.00 128.00 -32.00 97.00 -32.00 32.00 0.00 64.00 -32.00 65.00 -65.00 64.00 -32.00 161.00 -128.00 32.00 -65.00 64.00 -193.00 96.00 -225.00 129.00 -257.00 0.00 -64.00 161.00 -225.00 0.00 -33.00 64.00 0.00 32.00 0.00 65.00 -64.00 96.00 -64.00 0.00 -65.00 64.00 0.00 65.00 0.00 64.00 0.00 96.00 -96.00 33.00 -32.00 128.00 -32.00 97.00 -65.00 0.00 -32.00 64.00 0.00 257.00 -64.00 225.00 -64.00 32.00 0.00 65.00 -32.00 32.00 0.00 96.00 -161.00 65.00 -65.00 64.00 -32.00 96.00 -128.00 33.00 -65.00 64.00 0.00 96.00 0.00 65.00 -64.00 64.00 -32.00 96.00 0.00 65.00 -32.00 64.00 -32.00 64.00 32.00 97.00 32.00 96.00 32.00 193.00 225.00 97.00 32.00 0.00 65.00 96.00 0.00 64.00 32.00 33.00 0.00 128.00 -32.00 193.00 64.00 129.00 -64.00 96.00 0.00 129.00 32.00 32.00 32.00 32.00 0.00 97.00 -32.00 160.00 0.00 32.00 0.00 33.00 32.00 64.00 32.00 129.00 129.00 32.00 32.00 64.00 0.00 64.00 32.00 258.00 -32.00 257.00 96.00 64.00 32.00 97.00 0.00 96.00 0.00 97.00 -64.00 192.00 -32.00 33.00 0.00 160.00 0.00 32.00 0.00 161.00 32.00 322.00 0.00 64.00 0.00 0.00 -32.00 97.00 -32.00 128.00 -32.00 97.00 0.00 32.00 -32.00 128.00 32.00 97.00 32.00 64.00 128.00 32.00 33.00 129.00 128.00 96.00 0.00 386.00 32.00 97.00 -32.00 96.00 -64.00 97.00 -32.00 160.00 32.00 33.00 0.00 32.00 32.00 0.00 64.00 0.00 65.00 -65.00 32.00 -96.00 0.00 -64.00 64.00 -65.00 257.00 0.00 129.00 0.00 32.00 32.00 64.00 0.00 258.00 161.00 289.00 32.00 97.00 0.00 64.00 129.00 193.00 32.00 0.00 161.00 32.00 64.00 32.00 32.00 0.00 0.00 -32.00 193.00 -129.00 65.00 -64.00 128.00 -289.00 129.00 -258.00 32.00 -32.00 129.00 0.00 64.00 32.00 129.00 32.00 32.00 65.00 64.00 161.00 32.00 257.00 0.00 96.00 -32.00 547.00 32.00 32.00 289.00 193.00 65.00 0.00 32.00 -32.00 64.00 -129.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 -64.00 -161.00 32.00 -161.00 -64.00 -96.00 0.00 -33.00 0.00 -96.00 64.00 -129.00 64.00 -64.00 33.00 -32.00 0.00 -32.00 -33.00 -65.00 33.00 -96.00 32.00 -32.00 96.00 -65.00 32.00 0.00 193.00 0.00 129.00 -32.00 96.00 -32.00 32.00 0.00 161.00 64.00 97.00 0.00 32.00 33.00 96.00 0.00 97.00 -33.00 128.00 -128.00 65.00 -32.00 128.00 0.00 97.00 32.00 96.00 0.00 129.00 0.00 161.00 -64.00 64.00 0.00 161.00 -33.00 128.00 33.00 32.00 0.00 65.00 0.00 32.00 0.00 64.00 -33.00 97.00 0.00 96.00 33.00 64.00 64.00 33.00 32.00 32.00 0.00 32.00 0.00 96.00 0.00 65.00 -32.00 32.00 0.00 32.00 -64.00 0.00 -33.00 -161.00 -160.00 0.00 -32.00 32.00 -161.00 -32.00 -32.00 32.00 -33.00 97.00 0.00 32.00 33.00 64.00 32.00 97.00 161.00 32.00 96.00 32.00 32.00 32.00 0.00 32.00 0.00 32.00 97.00 97.00 32.00 64.00 64.00 97.00 32.00 96.00 0.00 129.00 -64.00 32.00 -97.00 96.00 33.00 65.00 -97.00 32.00 -64.00 32.00 -64.00 0.00 -161.00 32.00 -32.00 32.00 0.00 129.00 96.00 32.00 161.00 64.00 96.00 129.00 65.00 32.00 0.00 97.00 -97.00 32.00 -64.00 0.00 -64.00 0.00 -65.00 32.00 -64.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 64.00 -97.00 32.00 0.00 65.00 33.00 160.00 -65.00 161.00 0.00 97.00 32.00 64.00 -32.00 96.00 -32.00 32.00 0.00 161.00 129.00 0.00 32.00 0.00 32.00 65.00 64.00 32.00 33.00 64.00 64.00 64.00 -32.00 65.00 0.00 96.00 -97.00 0.00 -96.00 64.00 -32.00 129.00 0.00 0.00 -33.00 64.00 -32.00 129.00 0.00 64.00 -64.00 65.00 0.00 32.00 -32.00 32.00 -32.00 0.00 32.00 96.00 96.00 65.00 65.00 32.00 64.00 0.00 32.00 0.00 32.00 -65.00 32.00 0.00 33.00 0.00 64.00 129.00 64.00 32.00 97.00 32.00 0.00 129.00 0.00 64.00 96.00 65.00 0.00 64.00 64.00 129.00 33.00 64.00 128.00 96.00 32.00 32.00 0.00 33.00 65.00 0.00 96.00 32.00 0.00 32.00 64.00 64.00 97.00 0.00 32.00 -64.00 161.00 -32.00 0.00 -65.00 96.00 -32.00 0.00 -32.00 65.00 0.00 96.00 -32.00 0.00 0.00 64.00 0.00 32.00 -32.00 0.00 32.00 33.00 -64.00 32.00 32.00 96.00 0.00 32.00 0.00 33.00 0.00 32.00 32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 33.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 32.00 0.00 32.00 96.00 65.00 65.00 0.00 32.00 64.00 96.00 32.00 97.00 96.00 64.00 0.00 64.00 33.00 129.00 32.00 32.00 64.00 32.00 0.00 0.00 64.00 32.00 65.00 -32.00 32.00 64.00 128.00 33.00 0.00 0.00 33.00 0.00 32.00 0.00 32.00 64.00 32.00 0.00 32.00 0.00 65.00 64.00 32.00 0.00 32.00 0.00 32.00 -32.00 64.00 0.00 65.00 -32.00 64.00 -32.00 32.00 0.00 32.00 -161.00 0.00 -64.00 -32.00 -32.00 32.00 0.00 32.00 -65.00 65.00 32.00 64.00 -32.00 0.00 -32.00 129.00 -32.00 32.00 -32.00 0.00 -32.00 96.00 -65.00 32.00 65.00 129.00 -65.00 129.00 -64.00 160.00 64.00 129.00 65.00 64.00 96.00 0.00 0.00 65.00 32.00 64.00 65.00 0.00 32.00 64.00 64.00 32.00 32.00 32.00 -32.00 97.00 0.00 64.00 -32.00 32.00 32.00 97.00 32.00 96.00 32.00 65.00 -32.00 96.00 32.00 0.00 32.00 32.00 97.00 32.00 0.00 33.00 -64.00 0.00 0.00 32.00 0.00 32.00 -65.00 32.00 97.00 96.00 -32.00 97.00 32.00 32.00 0.00 32.00 64.00 97.00 32.00 64.00 0.00 -32.00 32.00 0.00 97.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 65.00 64.00 -33.00 32.00 65.00 32.00 0.00 0.00 32.00 33.00 64.00 0.00 65.00 0.00 32.00 64.00 64.00 -32.00 32.00 32.00 0.00 32.00 64.00 0.00 33.00 32.00 64.00 64.00 32.00 33.00 32.00 -33.00 32.00 -32.00 33.00 32.00 64.00 -32.00 64.00 -32.00 0.00 32.00 64.00 0.00 33.00 -32.00 0.00 32.00 32.00 32.00 0.00 33.00 32.00 32.00 -32.00 0.00 32.00 64.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 33.00 -32.00 64.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 65.00 0.00 32.00 -32.00 32.00 0.00 32.00 -33.00 96.00 -32.00 0.00 -32.00 33.00 0.00 0.00 -32.00 64.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 65.00 0.00 128.00 32.00 32.00 -32.00 32.00 -33.00 65.00 0.00 32.00 0.00 -32.00 65.00 32.00 32.00 96.00 64.00 65.00 0.00 0.00 -32.00 32.00 32.00 32.00 64.00 64.00 -96.00 32.00 -32.00 33.00 -32.00 32.00 0.00 32.00 -65.00 32.00 0.00 64.00 0.00 0.00 65.00 0.00 32.00 0.00 32.00 0.00 32.00 33.00 32.00 32.00 65.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 64.00 32.00 0.00 -32.00 129.00 -64.00 0.00 32.00 64.00 32.00 65.00 0.00 64.00 32.00 32.00 0.00 32.00 0.00 0.00 33.00 0.00 32.00 32.00 32.00 0.00 64.00 33.00 32.00 -65.00 65.00 0.00 64.00 -32.00 32.00 32.00 64.00 32.00 32.00 65.00 65.00 0.00 32.00 -32.00 0.00 -33.00 32.00 0.00 32.00 -32.00 65.00 0.00 32.00 -32.00 32.00 32.00 32.00 0.00 32.00 -64.00 32.00 0.00 65.00 -64.00 0.00 -33.00 32.00 33.00 64.00 -33.00 0.00 -64.00 32.00 0.00 97.00 -64.00 32.00 -193.00 -32.00 0.00 64.00 -32.00 32.00 0.00 32.00 32.00 65.00 -32.00 64.00 0.00 32.00 0.00 32.00 0.00 97.00 0.00 32.00 -64.00 0.00 -33.00 32.00 -32.00 0.00 32.00 64.00 -96.00 97.00 0.00 32.00 -64.00 32.00 -33.00 64.00 33.00 65.00 32.00 0.00 32.00 0.00 64.00 96.00 0.00 32.00 32.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 64.00 64.00 -32.00 65.00 64.00 32.00 0.00 64.00 65.00 97.00 32.00 32.00 32.00 0.00 32.00 64.00 32.00 32.00 0.00 32.00 0.00 33.00 0.00 32.00 -32.00 0.00 -96.00 -65.00 -33.00 33.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -64.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 64.00 65.00 64.00 64.00 33.00 0.00 32.00 -96.00 32.00 -65.00 0.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 0.00 64.00 33.00 96.00 -33.00 65.00 65.00 64.00 32.00 32.00 96.00 64.00 0.00 0.00 33.00 -64.00 64.00 -128.00 32.00 -33.00 96.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 32.00 33.00 -64.00 160.00 32.00 32.00 -97.00 65.00 32.00 64.00 -32.00 -32.00 -32.00 64.00 -32.00 32.00 0.00 33.00 32.00 32.00 -32.00 32.00 32.00 64.00 -64.00 64.00 -32.00 0.00 32.00 33.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 0.00 0.00 33.00 33.00 0.00 32.00 64.00 64.00 0.00 -32.00 64.00 32.00 32.00 -32.00 97.00 0.00 32.00 96.00 32.00 0.00 32.00 33.00 0.00 32.00 32.00 96.00 33.00 0.00 -33.00 64.00 33.00 33.00 0.00 64.00 0.00 32.00 32.00 0.00 32.00 32.00 -32.00 64.00 0.00 33.00 32.00 -33.00 32.00 0.00 32.00 33.00 0.00 64.00 32.00 0.00 65.00 -32.00 32.00 161.00 64.00 0.00 64.00 64.00 -32.00 32.00 32.00 97.00 0.00 64.00 0.00 0.00 65.00 64.00 0.00 0.00 32.00 64.00 32.00 33.00 0.00 32.00 -32.00 0.00 64.00 -97.00 97.00 0.00 64.00 97.00 0.00 -65.00 64.00 97.00 97.00 -97.00 32.00 0.00 32.00 33.00 32.00 64.00 0.00 32.00 32.00 32.00 32.00 0.00 65.00 -64.00 32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -32.00 32.00 -96.00 32.00 0.00 32.00 -65.00 -32.00 -32.00 32.00 0.00 32.00 32.00 32.00 -32.00 33.00 32.00 32.00 65.00 0.00 32.00 96.00 64.00 0.00 0.00 32.00 64.00 32.00 0.00 -32.00 97.00 65.00 64.00 0.00 32.00 -33.00 0.00 33.00 32.00 0.00 65.00 96.00 32.00 -32.00 96.00 0.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -64.00 33.00 -65.00 128.00 0.00 65.00 33.00 32.00 -33.00 32.00 33.00 96.00 -65.00 0.00 0.00 32.00 32.00 0.00 0.00 33.00 33.00 32.00 32.00 64.00 96.00 32.00 32.00 -32.00 97.00 -32.00 96.00 32.00 65.00 -96.00 64.00 0.00 32.00 0.00 0.00 64.00 64.00 0.00 33.00 32.00 32.00 -64.00 160.00 -65.00 33.00 -32.00 32.00 32.00 161.00 -32.00 32.00 -32.00 0.00 32.00 32.00 97.00 0.00 32.00 -32.00 96.00 -32.00 33.00 64.00 32.00 64.00 -65.00 65.00 0.00 64.00 -64.00 96.00 -32.00 129.00 32.00 96.00 -64.00 97.00 32.00 32.00 -32.00 64.00 -32.00 0.00 -33.00 65.00 -32.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 65.00 0.00 64.00 -64.00 0.00 -33.00 64.00 -32.00 32.00 0.00 -32.00 65.00 0.00 32.00 64.00 0.00 0.00 32.00 0.00 64.00 33.00 0.00 0.00 32.00 0.00 65.00 32.00 0.00 64.00 -33.00 32.00 0.00 0.00 -32.00 0.00 -64.00 32.00 0.00 32.00 -64.00 33.00 0.00 64.00 0.00 0.00 -32.00 64.00 32.00 0.00 -32.00 65.00 32.00 0.00 64.00 32.00 32.00 32.00 0.00 64.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -161.00 64.00 0.00 33.00 -64.00 32.00 32.00 32.00 64.00 32.00 0.00 32.00 32.00 65.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -65.00 32.00 0.00 33.00 -32.00 0.00 -64.00 -33.00 0.00 0.00 -64.00 -64.00 -97.00 32.00 0.00 -32.00 0.00 -96.00 0.00 -33.00 0.00 -96.00 32.00 -96.00 32.00 -33.00 0.00 -64.00 -64.00 32.00 -128.00 129.00 -33.00 32.00 -32.00 96.00 -32.00 0.00 -32.00 33.00 0.00 32.00 -32.00 0.00 -32.00 64.00 0.00 64.00 32.00 33.00 -32.00 96.00 -33.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 -33.00 -96.00 -64.00 0.00 0.00 -32.00 -32.00 -33.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 97.00 32.00 96.00 -64.00 65.00 32.00 0.00 32.00 32.00 64.00 -32.00 0.00 -33.00 65.00 33.00 0.00 -65.00 64.00 0.00 32.00 -32.00 32.00 64.00 64.00 33.00 0.00 64.00 -32.00 161.00 -32.00 64.00 -96.00 64.00 0.00 32.00 -32.00 -32.00 0.00 65.00 -65.00 0.00 65.00 64.00 0.00 32.00 64.00 -96.00 64.00 -33.00 32.00 0.00 32.00 33.00 33.00 128.00 -33.00 32.00 0.00 33.00 -32.00 32.00 0.00 128.00 -96.00 65.00 32.00 64.00 -161.00 -32.00 -32.00 32.00 0.00 96.00 64.00 33.00 0.00 32.00 33.00 32.00 32.00 64.00 0.00 32.00 32.00 32.00 32.00 -32.00 96.00 65.00 0.00 32.00 0.00 96.00 -64.00 64.00 0.00 33.00 -64.00 64.00 0.00 32.00 -32.00 161.00 -32.00 96.00 32.00 33.00 -32.00 32.00 0.00 0.00 -33.00 32.00 -64.00 -32.00 -32.00 160.00 -97.00 33.00 0.00 64.00 -32.00 32.00 0.00 129.00 -32.00 64.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 -33.00 64.00 -64.00 32.00 0.00 65.00 -32.00 32.00 -32.00 32.00 0.00 64.00 -32.00 32.00 -33.00 65.00 33.00 96.00 -65.00 97.00 -32.00 64.00 -32.00 0.00 32.00 64.00 0.00 65.00 0.00 32.00 0.00 128.00 32.00 33.00 -32.00 96.00 -64.00 129.00 0.00 64.00 0.00 32.00 -97.00 64.00 -32.00 33.00 -32.00 32.00 0.00 32.00 32.00 64.00 0.00 32.00 0.00 65.00 -32.00 64.00 -32.00 0.00 -32.00 128.00 0.00 65.00 32.00 64.00 0.00 64.00 64.00 65.00 65.00 32.00 128.00 0.00 32.00 -32.00 65.00 32.00 32.00 32.00 0.00 0.00 32.00 0.00 64.00 64.00 0.00 33.00 32.00 32.00 0.00 32.00 33.00 32.00 64.00 -32.00 32.00 0.00 64.00 96.00 -32.00 32.00 32.00 33.00 -32.00 32.00 32.00 -32.00 97.00 0.00 32.00 0.00 96.00 32.00 0.00 32.00 33.00 32.00 -33.00 64.00 65.00 32.00 -32.00 0.00 -33.00 33.00 33.00 32.00 64.00 32.00 0.00 64.00 -129.00 32.00 65.00 65.00 -33.00 64.00 65.00 32.00 0.00 32.00 0.00 -64.00 64.00 0.00 32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 65.00 0.00 32.00 32.00 32.00 0.00 96.00 -128.00 -32.00 -33.00 32.00 0.00 32.00 33.00 65.00 32.00 32.00 -32.00 32.00 0.00 32.00 -33.00 64.00 -32.00 65.00 0.00 32.00 32.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 0.00 65.00 32.00 32.00 0.00 32.00 0.00 -32.00 64.00 32.00 0.00 0.00 97.00 32.00 0.00 32.00 0.00 -32.00 -65.00 0.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -32.00 33.00 32.00 64.00 -32.00 32.00 64.00 32.00 -32.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 65.00 0.00 -33.00 64.00 -32.00 96.00 65.00 33.00 -33.00 64.00 0.00 32.00 0.00 32.00 65.00 32.00 -32.00 33.00 0.00 0.00 64.00 32.00 32.00 32.00 0.00 32.00 32.00 -32.00 32.00 64.00 65.00 65.00 64.00 0.00 32.00 0.00 32.00 -33.00 32.00 -32.00 0.00 0.00 65.00 -32.00 32.00 -64.00 32.00 -32.00 0.00 0.00 32.00 32.00 0.00 -32.00 32.00 -97.00 0.00 -96.00 97.00 32.00 32.00 -65.00 0.00 -32.00 64.00 0.00 32.00 32.00 32.00 -32.00 33.00 65.00 0.00 0.00 32.00 0.00 32.00 -65.00 0.00 -64.00 129.00 -64.00 32.00 0.00 -32.00 -65.00 0.00 -96.00 64.00 0.00 32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -225.00 96.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 64.00 -32.00 33.00 -32.00 0.00 -96.00 32.00 0.00 -32.00 -33.00 0.00 0.00 -33.00 -32.00 0.00 32.00 -64.00 -32.00 -32.00 -64.00 0.00 -32.00 0.00 -64.00 64.00 -65.00 32.00 -64.00 65.00 -64.00 32.00 -97.00 -64.00 -96.00 64.00 -33.00 0.00 -128.00 64.00 -32.00 32.00 0.00 33.00 -97.00 64.00 -64.00 -64.00 -64.00 96.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -97.00 64.00 -64.00 65.00 32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 32.00 -32.00 33.00 32.00 32.00 -32.00 64.00 32.00 0.00 0.00 32.00 -32.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 33.00 -32.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 -32.00 64.00 32.00 0.00 -32.00 32.00 32.00 32.00 -64.00 33.00 32.00 32.00 -65.00 32.00 33.00 64.00 -33.00 32.00 -64.00 0.00 -32.00 33.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -65.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 65.00 -32.00 32.00 32.00 32.00 32.00 0.00 0.00 96.00 97.00 0.00 96.00 33.00 -32.00 32.00 64.00 32.00 0.00 32.00 33.00 32.00 -33.00 32.00 97.00 -32.00 0.00 32.00 96.00 32.00 0.00 33.00 32.00 64.00 0.00 32.00 33.00 64.00 -33.00 0.00 97.00 33.00 64.00 64.00 32.00 0.00 33.00 32.00 32.00 32.00 -32.00 0.00 -65.00 0.00 -161.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -64.00 0.00 -33.00 33.00 -64.00 0.00 -32.00 0.00 32.00 -33.00 32.00 -64.00 -96.00 -32.00 -64.00 0.00 -97.00 64.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 -96.00 0.00 -33.00 65.00 -32.00 32.00 -96.00 0.00 -32.00 32.00 0.00 64.00 -32.00 32.00 -33.00 0.00 -32.00 33.00 0.00 32.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -65.00 64.00 -32.00 32.00 -96.00 0.00 -64.00 64.00 0.00 -32.00 -33.00 -32.00 -32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 0.00 0.00 33.00 0.00 64.00 32.00 32.00 32.00 32.00 65.00 -64.00 32.00 0.00 0.00 64.00 64.00 0.00 -64.00 0.00 -64.00 0.00 -33.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 97.00 0.00 32.00 32.00 0.00 -64.00 64.00 0.00 65.00 -32.00 -32.00 0.00 -97.00 -65.00 0.00 -32.00 32.00 32.00 -64.00 -32.00 0.00 -32.00 32.00 -64.00 32.00 96.00 32.00 -32.00 33.00 32.00 0.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 -33.00 -33.00 33.00 33.00 -65.00 -65.00 0.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 0.00 32.00 64.00 33.00 -32.00 64.00 32.00 0.00 0.00 64.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -96.00 32.00 -65.00 64.00 0.00 32.00 65.00 32.00 0.00 -32.00 0.00 32.00 0.00 65.00 32.00 0.00 -32.00 0.00 32.00 32.00 0.00 32.00 -32.00 0.00 -97.00 0.00 -32.00 64.00 -64.00 0.00 32.00 0.00 -32.00 -32.00 -32.00 64.00 0.00 -64.00 -65.00 0.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 32.00 -96.00 64.00 -97.00 129.00 0.00 32.00 -64.00 32.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -64.00 32.00 -64.00 97.00 0.00 161.00 32.00 96.00 32.00 96.00 32.00 0.00 65.00 0.00 0.00 65.00 -65.00 64.00 65.00 129.00 0.00 96.00 0.00 64.00 -33.00 -32.00 0.00 32.00 0.00 33.00 -64.00 32.00 -64.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00 -97.00 -32.00 -64.00 64.00 -32.00 0.00 -33.00 32.00 -32.00 0.00 0.00 32.00 -64.00 0.00 0.00 -64.00 -96.00 0.00 0.00 -64.00 -33.00 -33.00 -64.00 0.00 0.00 -64.00 -32.00 -32.00 -129.00 0.00 -32.00 32.00 -96.00 32.00 -32.00 0.00 -33.00 -32.00 33.00 -64.00 -65.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 -65.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -129.00 0.00 0.00 -32.00 -32.00 0.00 -160.00 32.00 0.00 -32.00 -65.00 -32.00 -161.00 0.00 -257.00 32.00 -353.00 97.00 -65.00 32.00 -32.00 64.00 -64.00 -32.00 -97.00 64.00 -32.00 33.00 0.00 32.00 -32.00 32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 -33.00 -97.00 33.00 -193.00 96.00 -64.00 32.00 0.00 65.00 -32.00 0.00 -32.00 32.00 96.00 -32.00 -32.00 32.00 -32.00 64.00 0.00 64.00 -64.00 32.00 0.00 33.00 32.00 0.00 -32.00 32.00 -33.00 0.00 -96.00 64.00 0.00 64.00 32.00 32.00 32.00 -32.00 0.00 32.00 32.00 0.00 -32.00 33.00 -32.00 32.00 -64.00 32.00 0.00 64.00 0.00 65.00 32.00 0.00 -64.00 0.00 -33.00 32.00 0.00 32.00 -32.00 -32.00 32.00 -32.00 -64.00 0.00 -161.00 0.00 -64.00 64.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 65.00 -32.00 64.00 0.00 -32.00 32.00 -64.00 -32.00 -33.00 -33.00 -32.00 -32.00 32.00 -32.00 33.00 0.00 -33.00 -32.00 0.00 -32.00 0.00 0.00 -96.00 64.00 -32.00 -32.00 -65.00 -32.00 -32.00 -97.00 -32.00 -64.00 0.00 -64.00 0.00 0.00 32.00 0.00 32.00 -33.00 -64.00 -32.00 0.00 -32.00 32.00 32.00 0.00 32.00 65.00 0.00 32.00 -64.00 0.00 0.00 32.00 0.00 32.00 32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 65.00 -32.00 0.00 32.00 -65.00 -96.00 -32.00 -193.00 32.00 -193.00 97.00 -515.00 225.00 -482.00 289.00 -386.00 193.00 -64.00 64.00 -97.00 33.00 -321.00 225.00 -225.00 128.00 -290.00 258.00 0.00 32.00 0.00 96.00 -32.00 32.00 -64.00 65.00 32.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 0.00 33.00 -32.00 -33.00 -32.00 33.00 0.00 32.00 -32.00 0.00 -97.00 32.00 -128.00 64.00 -65.00 64.00 -225.00 161.00 -193.00 129.00 -32.00 32.00 0.00 64.00 -64.00 32.00 -129.00 97.00 0.00 32.00 -128.00 32.00 -675.00 418.00 -33.00 0.00 0.00 32.00 -160.00 97.00 -33.00 64.00 -225.00 64.00 -193.00 129.00 -418.00 257.00 -160.00 129.00 -579.00 450.00 -322.00 322.00 -160.00 192.00 -32.00 97.00 -33.00 96.00 -96.00 0.00 0.00 33.00 32.00 96.00 32.00 32.00 0.00 32.00 0.00 65.00 -64.00 64.00 -32.00 129.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 64.00 -129.00 129.00 -257.00 193.00 -321.00 353.00 -32.00 0.00 0.00 -64.00 64.00 -64.00 289.00 -257.00 -32.00 -33.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -64.00 -32.00 0.00 32.00 0.00 33.00 0.00 32.00 -65.00 0.00 -32.00 32.00 -32.00 -32.00 -64.00 32.00 -65.00 32.00 -161.00 -129.00 -32.00 -32.00 -32.00 -64.00 -64.00 0.00 -64.00 -32.00 -33.00 -65.00 97.00 -32.00 32.00 -64.00 0.00 -64.00 32.00 0.00 32.00 -32.00 -64.00 -33.00 -64.00 -32.00 0.00 -32.00 -65.00 -64.00 0.00 -32.00 -64.00 -97.00 0.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 -97.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 -33.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -33.00 -32.00 -32.00 -64.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 33.00 0.00 64.00 -33.00 0.00 -32.00 -64.00 -32.00 0.00 0.00 32.00 -64.00 64.00 -32.00 64.00 -65.00 65.00 0.00 -65.00 32.00 0.00 0.00 -96.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 0.00 -32.00 -97.00 -97.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 -96.00 -32.00 -33.00 32.00 -64.00 0.00 -193.00 128.00 -32.00 129.00 0.00 64.00 -64.00 0.00 -33.00 33.00 -64.00 96.00 -32.00 32.00 -32.00 64.00 -32.00 0.00 -65.00 -64.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 -32.00 -64.00 0.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 0.00 0.00 -32.00 64.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 -32.00 32.00 0.00 0.00 32.00 32.00 -64.00 -32.00 0.00 32.00 -33.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -96.00 0.00 32.00 -32.00 -32.00 -65.00 32.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 -64.00 97.00 -65.00 32.00 -32.00 64.00 -32.00 0.00 -64.00 32.00 0.00 0.00 -65.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -33.00 -64.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 -32.00 -32.00 -65.00 -32.00 33.00 -33.00 -33.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -64.00 65.00 -65.00 0.00 0.00 32.00 -64.00 32.00 -32.00 64.00 -64.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -33.00 -65.00 -32.00 0.00 32.00 0.00 33.00 0.00 64.00 -32.00 -32.00 -32.00 -32.00 -129.00 32.00 -64.00 32.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 -32.00 64.00 -65.00 32.00 -32.00 -96.00 -64.00 -33.00 -65.00 0.00 -32.00 -64.00 -32.00 -32.00 -64.00 64.00 -64.00 -64.00 -33.00 32.00 65.00 64.00 -32.00 0.00 -65.00 -32.00 -161.00 32.00 -32.00 0.00 0.00 33.00 -32.00 0.00 -32.00 -33.00 -32.00 0.00 -64.00 0.00 -65.00 65.00 -32.00 -65.00 -64.00 0.00 0.00 -32.00 -64.00 0.00 0.00 -64.00 -33.00 0.00 -64.00 32.00 32.00 -96.00 32.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -64.00 -32.00 -33.00 0.00 -32.00 32.00 32.00 32.00 33.00 -32.00 -33.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 -65.00 -32.00 0.00 0.00 33.00 -64.00 0.00 0.00 -33.00 -32.00 0.00 -32.00 65.00 -65.00 -32.00 -32.00 -33.00 -128.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 33.00 0.00 32.00 -64.00 0.00 0.00 64.00 -129.00 0.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 -64.00 0.00 -96.00 -97.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -97.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 -64.00 -32.00 32.00 0.00 0.00 -33.00 -32.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 33.00 32.00 32.00 -65.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -65.00 32.00 0.00 96.00 -32.00 0.00 -64.00 32.00 -32.00 33.00 -32.00 32.00 0.00 0.00 -32.00 0.00 -33.00 -32.00 0.00 32.00 -64.00 -32.00 -32.00 64.00 -64.00 32.00 -65.00 0.00 -32.00 -32.00 0.00 -32.00 65.00 -32.00 -33.00 0.00 -32.00 64.00 -96.00 64.00 -97.00 32.00 0.00 97.00 -96.00 -32.00 -32.00 -65.00 0.00 -32.00 -32.00 -96.00 0.00 0.00 -65.00 -32.00 0.00 -65.00 -64.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -33.00 -33.00 -32.00 33.00 -64.00 -33.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 -64.00 0.00 0.00 -33.00 -129.00 -96.00 -32.00 -32.00 65.00 -32.00 0.00 -65.00 0.00 -96.00 0.00 -64.00 64.00 -33.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -97.00 -64.00 0.00 -32.00 -32.00 -33.00 -32.00 33.00 -32.00 -33.00 -33.00 33.00 0.00 -33.00 -96.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 -96.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 33.00 -33.00 -33.00 0.00 0.00 -32.00 -64.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 0.00 0.00 -33.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 -64.00 -32.00 -32.00 0.00 0.00 -32.00 64.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -33.00 -32.00 33.00 -33.00 -65.00 65.00 0.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -65.00 32.00 0.00 32.00 -64.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -33.00 -32.00 -32.00 -33.00 0.00 -96.00 -64.00 64.00 -32.00 -64.00 -32.00 -32.00 0.00 -64.00 -32.00 -33.00 32.00 0.00 32.00 -32.00 -64.00 -32.00 32.00 0.00 64.00 32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 64.00 -32.00 65.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -64.00 -33.00 -64.00 0.00 -33.00 33.00 -32.00 -65.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 32.00 32.00 0.00 -32.00 -65.00 0.00 -32.00 32.00 -64.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 -33.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -65.00 -33.00 33.00 -32.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 65.00 -64.00 0.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -64.00 32.00 -32.00 -97.00 -64.00 -32.00 -32.00 32.00 -33.00 32.00 0.00 -32.00 -64.00 32.00 -32.00 0.00 -64.00 65.00 32.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 32.00 0.00 -32.00 -32.00 32.00 -33.00 -64.00 0.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 97.00 -33.00 32.00 33.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 -97.00 -64.00 -96.00 0.00 0.00 -32.00 0.00 -65.00 32.00 33.00 32.00 -65.00 0.00 -64.00 -32.00 -64.00 0.00 -97.00 -64.00 -128.00 -32.00 -33.00 32.00 -64.00 -32.00 0.00 -33.00 -32.00 0.00 -32.00 0.00 -65.00 -96.00 -160.00 -32.00 -32.00 32.00 -33.00 -96.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -64.00 -64.00 -32.00 -32.00 -32.00 64.00 -97.00 -32.00 -32.00 -32.00 -32.00 -65.00 0.00 -64.00 32.00 -64.00 -32.00 -65.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -97.00 32.00 -64.00 0.00 -32.00 -32.00 -33.00 -32.00 -32.00 32.00 -64.00 -64.00 -64.00 0.00 0.00 -97.00 0.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -97.00 -65.00 -64.00 -32.00 -96.00 0.00 -97.00 -96.00 0.00 -33.00 32.00 -32.00 33.00 -96.00 -33.00 -64.00 0.00 -33.00 -96.00 -64.00 -32.00 32.00 0.00 32.00 32.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -33.00 -97.00 -64.00 0.00 -96.00 -32.00 0.00 32.00 -97.00 97.00 -64.00 -32.00 -65.00 0.00 -64.00 96.00 -32.00 0.00 -64.00 0.00 -97.00 -32.00 -64.00 64.00 -96.00 32.00 -97.00 0.00 -64.00 -32.00 -65.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -129.00 -64.00 -64.00 32.00 -64.00 0.00 -32.00 64.00 -65.00 0.00 -96.00 0.00 -32.00 -64.00 -64.00 -64.00 0.00 -32.00 -97.00 -65.00 -64.00 32.00 -65.00 0.00 -32.00 33.00 0.00 96.00 -32.00 0.00 -32.00 64.00 -97.00 -32.00 -64.00 32.00 -96.00 -64.00 -32.00 0.00 -65.00 64.00 -64.00 -32.00 -32.00 -32.00 -32.00 -64.00 -32.00 -32.00 -65.00 -33.00 -128.00 -32.00 -65.00 65.00 -64.00 32.00 -64.00 -32.00 -97.00 -33.00 -32.00 -64.00 -64.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 32.00 -128.00 225.00 -97.00 33.00 -32.00 0.00 -32.00 0.00 -32.00 -33.00 -32.00 -32.00 -97.00 0.00 -96.00 0.00 -32.00 -32.00 32.00 -193.00 0.00 -32.00 0.00 -32.00 -97.00 -32.00 -32.00 -97.00 -32.00 -32.00 -64.00 -128.00 -193.00 -129.00 -32.00 -32.00 -129.00 0.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 -64.00 -97.00 -96.00 0.00 -65.00 33.00 -64.00 0.00 -257.00 -129.00 -257.00 0.00 -193.00 -64.00 -97.00 -65.00 -64.00 -32.00 -97.00 -32.00 -32.00 0.00 -96.00 -64.00 -32.00 -129.00 -33.00 0.00 -64.00 -64.00 -64.00 -32.00 -97.00 32.00 -32.00 0.00 -128.00 -32.00 -65.00 0.00 -128.00 -32.00 -65.00 32.00 -64.00 0.00 -129.00 -65.00 -96.00 0.00 -96.00 129.00 -33.00 0.00 -128.00 64.00 -65.00 0.00 -32.00 -32.00 -128.00 32.00 -32.00 33.00 -65.00 -33.00 -96.00 -32.00 -129.00 -96.00 -64.00 -32.00 -161.00 0.00 -64.00 0.00 -97.00 64.00 -96.00 0.00 -32.00 -64.00 -32.00 -129.00 0.00 -32.00 -65.00 0.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -354.00 96.00 -32.00 0.00 -97.00 -32.00 -64.00 -64.00 -32.00 -33.00 -32.00 -32.00 -193.00 -161.00 -97.00 0.00 -160.00 -96.00 -129.00 -32.00 -32.00 0.00 -129.00 0.00 -161.00 -97.00 -64.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 33.00 -65.00 96.00 -32.00 96.00 0.00 33.00 -32.00 128.00 0.00 32.00 32.00 193.00 -129.00 32.00 -64.00 33.00 -129.00 64.00 -32.00 0.00 0.00 -32.00 0.00 -129.00 -64.00 -96.00 -32.00 -32.00 -129.00 32.00 -64.00 32.00 -64.00 64.00 -97.00 -32.00 -225.00 0.00 -161.00 -64.00 -64.00 -32.00 -32.00 0.00 -32.00 -33.00 -65.00 0.00 0.00 33.00 -64.00 0.00 -161.00 96.00 -32.00 0.00 -96.00 -64.00 -65.00 -32.00 -32.00 0.00 -128.00 -129.00 -65.00 -97.00 -32.00 0.00 -64.00 33.00 -289.00 193.00 -193.00 64.00 -97.00 0.00 -128.00 -64.00 -129.00 -33.00 -32.00 -32.00 -32.00 0.00 -97.00 0.00 -161.00 65.00 -64.00 -33.00 -225.00 -160.00 -96.00 -33.00 -225.00 33.00 -33.00 32.00 -64.00 32.00 -64.00 32.00 0.00 32.00 -65.00 32.00 -64.00 65.00 -64.00 64.00 -129.00 32.00 -64.00 97.00 -32.00 -97.00 -32.00 -96.00zm39098.00 3826.00l0.00 32.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 32.00m-804.00 1672.00l0.00 -32.00 0.00 32.00 32.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00zm-4727.00 418.00l0.00 -32.00 0.00 32.00zm3827.00 -1447.00l32.00 0.00 -32.00 0.00zm836.00 -64.00l-32.00 0.00 32.00 -32.00 0.00 32.00 -32.00 0.00 32.00 0.00zm643.00 -804.00l0.00 -32.00 0.00 32.00zm-1929.00 1125.00l0.00 -32.00 0.00 32.00zm64.00 1640.00l0.00 -32.00 0.00 32.00zm1833.00 -2444.00l32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00zm-1962.00 2444.00l0.00 -32.00 0.00 32.00zm225.00 -321.00l-32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 97.00 32.00 -33.00 32.00 33.00 32.00 32.00 0.00 64.00 65.00 32.00 -65.00 32.00 32.00 32.00 0.00 33.00 33.00 -33.00 32.00 -32.00 -32.00 0.00 32.00 0.00 64.00 0.00 32.00 0.00 32.00 0.00 32.00 32.00 0.00 -32.00 33.00 0.00 32.00 -64.00 64.00 -96.00 -32.00 -65.00 -97.00 32.00 -64.00 -64.00 -96.00 -64.00 32.00 0.00 -32.00 -32.00 32.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -64.00 -32.00 -33.00 64.00 -192.00 32.00 -33.00 0.00 -96.00 32.00 -96.00 -32.00 -65.00 -96.00 0.00 -129.00 0.00 -32.00 32.00 0.00 65.00 -64.00 32.00 0.00 0.00 -32.00 64.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 0.00 161.00 -160.00 64.00 -33.00 0.00 -128.00 32.00 0.00 0.00 -32.00 33.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -96.00 0.00 -65.00 64.00 -32.00 64.00 32.00 33.00 33.00 96.00 0.00 0.00 32.00 64.00 0.00 33.00 32.00 32.00 0.00 32.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 65.00 32.00 0.00 -32.00 32.00 0.00 64.00 -32.00 64.00 32.00 0.00 0.00 33.00 -64.00 32.00 32.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 0.00 -32.00 32.00 -96.00 -32.00 -64.00 0.00 -65.00 64.00 32.00 0.00 0.00 33.00zm1158.00 -1512.00l32.00 0.00 -32.00 0.00zm-933.00 1319.00l0.00 -33.00 33.00 33.00 -33.00 0.00zm-8295.00 2700.00l32.00 0.00 -32.00 0.00zm9839.00 -4855.00l32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 32.00 0.00zm-193.00 65.00l-32.00 0.00 0.00 -33.00 32.00 0.00 0.00 33.00zm-3666.00 1961.00l33.00 0.00 -33.00 0.00zm901.00 322.00l0.00 -33.00 32.00 0.00 0.00 -32.00 0.00 32.00 0.00 33.00 -32.00 0.00zm-6560.00 2540.00l33.00 0.00 0.00 32.00 -33.00 0.00 0.00 -32.00zm33.00 96.00l0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00zm9678.00 -4759.00l0.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 0.00 32.00 0.00 32.00 -32.00 -32.00zm-4084.00 1865.00l0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00zm2026.00 -997.00l32.00 -32.00 32.00 0.00 0.00 32.00 -64.00 0.00zm-2315.00 1287.00l0.00 -32.00 32.00 0.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 0.00 0.00 -32.00zm2958.00 -1447.00l32.00 -32.00 32.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -32.00zm0.00 1157.00l64.00 -32.00 32.00 -32.00 0.00 32.00 129.00 64.00 -32.00 33.00 -64.00 -33.00 -65.00 65.00 -32.00 -65.00 -32.00 -32.00zm482.00 -1318.00l0.00 -32.00 97.00 32.00 0.00 32.00 -97.00 32.00 -96.00 97.00 0.00 -65.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 32.00 32.00 32.00 32.00 0.00 32.00 -32.00z"},rj:{name:"RJ",path:"M143583.00 140702.00l32.00 -32.00 0.00 -32.00 0.00 -32.00 65.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 32.00 -33.00 64.00 0.00 33.00 -32.00 -33.00 -64.00 65.00 -32.00 -32.00 -32.00 64.00 -33.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -64.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 -32.00 -32.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 0.00 65.00 0.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 -65.00 97.00 -64.00 32.00 -32.00 32.00 32.00 32.00 0.00 33.00 0.00 32.00 0.00 64.00 -96.00 64.00 64.00 97.00 -64.00 0.00 -33.00 32.00 -32.00 128.00 -64.00 33.00 0.00 96.00 -64.00 97.00 64.00 64.00 -32.00 64.00 -65.00 65.00 -32.00 64.00 -64.00 32.00 0.00 64.00 0.00 32.00 32.00 -32.00 64.00 32.00 0.00 0.00 33.00 33.00 0.00 0.00 32.00 96.00 -32.00 32.00 0.00 32.00 -33.00 32.00 -64.00 33.00 -32.00 32.00 0.00 64.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 65.00 0.00 225.00 -96.00 32.00 32.00 -32.00 32.00 32.00 0.00 0.00 -32.00 96.00 -64.00 65.00 0.00 0.00 32.00 64.00 -32.00 64.00 -129.00 65.00 0.00 0.00 -32.00 0.00 -32.00 -65.00 0.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 32.00 -64.00 65.00 0.00 -32.00 -32.00 96.00 -97.00 97.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 32.00 0.00 64.00 -32.00 32.00 -32.00 0.00 -65.00 32.00 0.00 33.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 -64.00 -64.00 -65.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -33.00 0.00 -32.00 32.00 -32.00 -65.00 -32.00 0.00 -64.00 0.00 -33.00 33.00 -96.00 -65.00 -64.00 32.00 0.00 33.00 -32.00 -65.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 -64.00 -64.00 32.00 -33.00 -32.00 0.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 32.00 65.00 -32.00 0.00 -32.00 0.00 0.00 -97.00 -32.00 0.00 32.00 -64.00 -32.00 0.00 -32.00 0.00 -65.00 -32.00 -32.00 0.00 0.00 32.00 -64.00 32.00 0.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 -64.00 32.00 -32.00 33.00 -32.00 0.00 -32.00 32.00 -65.00 -32.00 -32.00 -33.00 -32.00 0.00 32.00 33.00 -96.00 128.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 -32.00 0.00 32.00 32.00 -32.00 0.00 0.00 -32.00 64.00 -64.00 -32.00 0.00 -32.00 0.00 -64.00 -65.00 -65.00 33.00 -32.00 -65.00 -64.00 129.00 -32.00 0.00 -32.00 -64.00 -33.00 -33.00 0.00 33.00 -32.00 32.00 -64.00 -65.00 -32.00 33.00 -32.00 -33.00 -32.00 0.00 0.00 -96.00 0.00 -32.00 32.00 -97.00 -32.00 -32.00 -33.00 32.00 -32.00 -32.00 -96.00 32.00 0.00 -64.00 32.00 -32.00 -32.00 -64.00 -32.00 -33.00 -32.00 0.00 -33.00 -32.00 -64.00 0.00 0.00 -64.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 32.00 -65.00 0.00 -32.00 -32.00 -128.00 -65.00 -65.00 -64.00 -64.00 -64.00 0.00 -65.00 -32.00 -128.00 0.00 32.00 -65.00 32.00 -32.00 32.00 0.00 32.00 -32.00 33.00 0.00 64.00 -32.00 64.00 0.00 65.00 -64.00 32.00 0.00 96.00 64.00 65.00 -32.00 64.00 32.00 64.00 0.00 32.00 32.00 0.00 -32.00 65.00 -64.00 0.00 -32.00 96.00 -33.00 0.00 -64.00 32.00 -32.00 97.00 -32.00 32.00 0.00 32.00 32.00 64.00 -32.00 32.00 32.00 97.00 -32.00 0.00 32.00 64.00 0.00 0.00 -32.00 65.00 -32.00 0.00 -33.00 96.00 -32.00 129.00 -128.00 32.00 32.00 0.00 -32.00 0.00 -32.00 32.00 -65.00 32.00 0.00 32.00 0.00 32.00 -32.00 65.00 32.00 32.00 0.00 96.00 0.00 0.00 65.00 32.00 0.00 33.00 0.00 32.00 -33.00 64.00 -64.00 32.00 32.00 65.00 0.00 64.00 0.00 32.00 32.00 32.00 -32.00 64.00 0.00 33.00 -64.00 0.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 129.00 32.00 -33.00 33.00 33.00 32.00 -33.00 64.00 -32.00 0.00 -32.00 64.00 -32.00 0.00 32.00 33.00 0.00 64.00 -32.00 32.00 -64.00 32.00 0.00 32.00 0.00 33.00 0.00 32.00 -33.00 32.00 -64.00 32.00 32.00 32.00 -32.00 32.00 0.00 32.00 0.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 33.00 32.00 64.00 -32.00 0.00 -33.00 0.00 -32.00 64.00 32.00 0.00 33.00 32.00 -33.00 32.00 0.00 0.00 -64.00 33.00 0.00 128.00 -32.00 0.00 -32.00 97.00 0.00 64.00 64.00 32.00 -32.00 32.00 0.00 32.00 -32.00 33.00 0.00 0.00 -32.00 96.00 -32.00 32.00 0.00 65.00 -33.00 192.00 -64.00 33.00 -32.00 64.00 0.00 0.00 -64.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 -33.00 65.00 33.00 64.00 -33.00 64.00 -32.00 32.00 0.00 33.00 0.00 128.00 -96.00 32.00 0.00 33.00 0.00 0.00 32.00 32.00 32.00 -32.00 0.00 64.00 32.00 0.00 32.00 32.00 0.00 32.00 33.00 64.00 -97.00 65.00 0.00 32.00 0.00 32.00 -32.00 64.00 0.00 33.00 64.00 0.00 32.00 32.00 -32.00 0.00 -64.00 64.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 65.00 64.00 32.00 -32.00 0.00 64.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -64.00 32.00 0.00 33.00 -33.00 0.00 97.00 64.00 32.00 32.00 32.00 32.00 -32.00 161.00 -32.00 32.00 -64.00 32.00 0.00 32.00 32.00 0.00 32.00 65.00 0.00 64.00 0.00 64.00 0.00 129.00 -64.00 32.00 -33.00 64.00 0.00 129.00 -96.00 96.00 -64.00 0.00 -32.00 65.00 -33.00 32.00 0.00 32.00 33.00 64.00 0.00 32.00 -33.00 33.00 33.00 64.00 32.00 96.00 -32.00 65.00 0.00 32.00 -33.00 32.00 33.00 32.00 -33.00 32.00 33.00 0.00 32.00 32.00 32.00 33.00 0.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 32.00 129.00 -96.00 32.00 0.00 0.00 32.00 64.00 32.00 32.00 0.00 65.00 0.00 0.00 64.00 0.00 65.00 -97.00 64.00 0.00 32.00 32.00 97.00 33.00 64.00 64.00 -32.00 0.00 -65.00 96.00 -32.00 65.00 0.00 64.00 0.00 0.00 32.00 129.00 -32.00 64.00 -96.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 64.00 -32.00 97.00 -32.00 32.00 0.00 128.00 -96.00 33.00 0.00 64.00 -33.00 193.00 -64.00 128.00 -128.00 0.00 -33.00 161.00 -64.00 257.00 -64.00 129.00 -65.00 32.00 -32.00 193.00 -96.00 193.00 -65.00 32.00 -32.00 97.00 -32.00 128.00 -32.00 65.00 -32.00 32.00 0.00 32.00 0.00 64.00 -32.00 0.00 -65.00 225.00 -96.00 322.00 -129.00 32.00 -32.00 322.00 -96.00 32.00 -65.00 32.00 0.00 96.00 -32.00 97.00 0.00 128.00 -32.00 0.00 -32.00 193.00 -64.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -32.00 -32.00 32.00 -32.00 -64.00 32.00 0.00 -32.00 -33.00 -65.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -65.00 0.00 -32.00 0.00 -32.00 -32.00 64.00 -64.00 -32.00 0.00 -32.00 -33.00 96.00 -128.00 33.00 -32.00 96.00 -65.00 -32.00 -32.00 0.00 -32.00 96.00 -32.00 0.00 -32.00 32.00 -33.00 0.00 -32.00 33.00 -32.00 64.00 0.00 32.00 -96.00 64.00 -32.00 33.00 -33.00 -65.00 -96.00 0.00 -32.00 -96.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -97.00 32.00 -32.00 32.00 32.00 65.00 0.00 32.00 -32.00 32.00 -32.00 -64.00 -32.00 -32.00 0.00 64.00 -32.00 0.00 -32.00 64.00 -32.00 -32.00 -65.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -33.00 32.00 -64.00 0.00 -128.00 32.00 -33.00 33.00 -32.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -65.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 -64.00 -129.00 32.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -33.00 32.00 -32.00 32.00 -64.00 33.00 0.00 0.00 -64.00 0.00 -65.00 128.00 0.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 65.00 0.00 0.00 -32.00 96.00 -97.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 32.00 65.00 0.00 0.00 -32.00 -33.00 -32.00 -64.00 -65.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -33.00 0.00 -64.00 -64.00 0.00 -32.00 -64.00 -33.00 0.00 -32.00 64.00 -64.00 64.00 -32.00 33.00 32.00 32.00 0.00 0.00 -32.00 32.00 -32.00 64.00 -65.00 32.00 33.00 97.00 0.00 96.00 -33.00 32.00 -32.00 65.00 0.00 96.00 32.00 32.00 -32.00 97.00 32.00 0.00 -64.00 32.00 -32.00 0.00 32.00 32.00 -64.00 -32.00 -32.00 32.00 -33.00 0.00 -64.00 64.00 -32.00 -32.00 -32.00 32.00 -32.00 65.00 -32.00 32.00 -33.00 32.00 -32.00 -64.00 -64.00 64.00 -129.00 -32.00 -32.00 64.00 0.00 32.00 0.00 33.00 0.00 32.00 -32.00 64.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 0.00 65.00 -33.00 32.00 65.00 64.00 32.00 32.00 32.00 0.00 32.00 65.00 32.00 32.00 -32.00 -32.00 65.00 64.00 0.00 32.00 -33.00 96.00 0.00 33.00 0.00 0.00 33.00 64.00 0.00 0.00 64.00 32.00 -32.00 32.00 32.00 0.00 32.00 0.00 32.00 -32.00 97.00 32.00 64.00 0.00 32.00 65.00 -32.00 64.00 32.00 -32.00 0.00 -32.00 96.00 0.00 33.00 32.00 0.00 -32.00 96.00 -33.00 32.00 -32.00 0.00 32.00 97.00 65.00 32.00 0.00 128.00 32.00 0.00 0.00 65.00 -32.00 0.00 0.00 64.00 -32.00 32.00 64.00 32.00 -32.00 33.00 -32.00 0.00 0.00 32.00 32.00 64.00 0.00 64.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 0.00 64.00 33.00 0.00 0.00 33.00 32.00 0.00 -65.00 128.00 0.00 32.00 33.00 0.00 32.00 0.00 64.00 0.00 0.00 33.00 -64.00 32.00 0.00 32.00 64.00 0.00 0.00 -32.00 64.00 0.00 32.00 32.00 33.00 0.00 0.00 32.00 32.00 -32.00 32.00 0.00 0.00 32.00 64.00 32.00 0.00 32.00 32.00 0.00 33.00 0.00 32.00 0.00 96.00 65.00 97.00 -33.00 32.00 65.00 64.00 32.00 0.00 32.00 32.00 32.00 32.00 -64.00 33.00 64.00 96.00 -32.00 64.00 64.00 0.00 -64.00 32.00 0.00 33.00 32.00 64.00 0.00 32.00 0.00 0.00 65.00 64.00 32.00 65.00 32.00 32.00 32.00 64.00 0.00 64.00 -64.00 33.00 0.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00 32.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 32.00 33.00 0.00 128.00 32.00 32.00 0.00 33.00 32.00 32.00 0.00 0.00 32.00 32.00 -32.00 64.00 96.00 32.00 0.00 32.00 0.00 33.00 33.00 0.00 -33.00 32.00 0.00 32.00 0.00 32.00 -64.00 64.00 0.00 33.00 0.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 64.00 0.00 32.00 33.00 32.00 0.00 33.00 0.00 0.00 32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 0.00 33.00 32.00 -33.00 -32.00 33.00 32.00 0.00 64.00 0.00 32.00 0.00 65.00 -33.00 32.00 -32.00 64.00 0.00 97.00 -32.00 32.00 -32.00 32.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 65.00 32.00 64.00 97.00 64.00 -32.00 65.00 0.00 32.00 0.00 32.00 96.00 0.00 65.00 32.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 33.00 0.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 64.00 -32.00 129.00 32.00 96.00 -32.00 0.00 -65.00 161.00 -32.00 0.00 -64.00 32.00 -32.00 97.00 -97.00 128.00 -64.00 65.00 -32.00 32.00 -97.00 96.00 -32.00 129.00 0.00 161.00 97.00 193.00 32.00 64.00 64.00 32.00 64.00 0.00 33.00 32.00 0.00 -32.00 0.00 32.00 -65.00 354.00 0.00 193.00 97.00 354.00 128.00 578.00 33.00 161.00 0.00 129.00 -65.00 128.00 -32.00 65.00 -64.00 32.00 -193.00 96.00 -161.00 97.00 -225.00 160.00 -129.00 97.00 -225.00 96.00 -193.00 65.00 -225.00 96.00 -643.00 161.00 -257.00 64.00 -257.00 97.00 -193.00 96.00 -129.00 32.00 -96.00 65.00 -322.00 160.00 -225.00 193.00 -64.00 0.00 -64.00 65.00 -33.00 32.00 0.00 64.00 33.00 0.00 -33.00 32.00 33.00 32.00 -97.00 65.00 -32.00 0.00 -129.00 64.00 -96.00 96.00 -64.00 65.00 0.00 64.00 -33.00 96.00 -32.00 0.00 -32.00 33.00 -64.00 0.00 -64.00 32.00 -65.00 128.00 -32.00 33.00 -32.00 64.00 -32.00 0.00 -32.00 -64.00 -65.00 32.00 -64.00 64.00 -32.00 64.00 -64.00 193.00 -33.00 65.00 0.00 192.00 0.00 33.00 0.00 32.00 65.00 257.00 32.00 64.00 96.00 0.00 0.00 32.00 65.00 97.00 64.00 64.00 64.00 0.00 32.00 -32.00 -32.00 -32.00 65.00 0.00 0.00 -32.00 64.00 32.00 32.00 -32.00 0.00 -65.00 32.00 33.00 0.00 -33.00 32.00 33.00 -32.00 32.00 64.00 32.00 -32.00 32.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 -32.00 0.00 32.00 64.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -64.00 32.00 -32.00 65.00 0.00 32.00 0.00 32.00 0.00 32.00 -64.00 -32.00 0.00 32.00 -129.00 32.00 -64.00 129.00 0.00 64.00 0.00 32.00 32.00 -32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 -33.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -64.00 64.00 -32.00 32.00 -33.00 97.00 0.00 64.00 33.00 64.00 32.00 0.00 0.00 32.00 32.00 33.00 32.00 -33.00 32.00 -32.00 0.00 32.00 -32.00 33.00 32.00 0.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 0.00 65.00 -32.00 -65.00 -97.00 -32.00 33.00 -32.00 -65.00 -32.00 -160.00 -65.00 -997.00 -64.00 -354.00 -32.00 -289.00 0.00 -258.00 0.00 -64.00 32.00 -96.00 -32.00 -354.00 0.00 -225.00 0.00 -193.00 32.00 -32.00 32.00 0.00 65.00 -32.00 0.00 -32.00 0.00 -97.00 -33.00 -450.00 33.00 -289.00 32.00 -225.00 32.00 -161.00 -32.00 -193.00 0.00 -64.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 32.00 0.00 -65.00 -64.00 -128.00 -33.00 -129.00 0.00 -32.00 -32.00 0.00 -32.00 -96.00 0.00 64.00 -32.00 0.00 -64.00 32.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 0.00 33.00 -32.00 0.00 -64.00 -65.00 0.00 -32.00 -33.00 -32.00 0.00 -32.00 33.00 -32.00 -65.00 64.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 32.00 -65.00 32.00 -64.00 65.00 -64.00 -32.00 -32.00 0.00 -32.00 64.00 -65.00 96.00 -64.00 -64.00 -32.00 -32.00 -32.00 64.00 -65.00 0.00 -32.00 32.00 -32.00 161.00 -96.00 0.00 -65.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 -33.00 -32.00 -32.00 0.00 -96.00 -32.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 32.00 65.00 -32.00 -33.00 -32.00 33.00 0.00 32.00 -32.00 32.00 -32.00 32.00 -65.00 -32.00 -32.00 -32.00 -64.00 32.00 0.00 32.00 -64.00 0.00 -161.00 32.00 0.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -32.00 33.00 -32.00 0.00 32.00 32.00 -64.00 32.00 -32.00 0.00 32.00 0.00 -96.00 64.00 0.00 32.00 -33.00 32.00 33.00 0.00 -65.00 97.00 0.00 32.00 32.00 32.00 33.00 -32.00 0.00 32.00 32.00 32.00 64.00 65.00 32.00 32.00 32.00 96.00 32.00 -32.00 -32.00 -96.00 -32.00 -32.00 0.00 -33.00 -64.00 0.00 -32.00 -64.00 32.00 -32.00 32.00 32.00 32.00 0.00 0.00 -32.00 64.00 -64.00 33.00 -33.00 32.00 0.00 64.00 65.00 64.00 0.00 33.00 0.00 -33.00 -32.00 33.00 -33.00 32.00 0.00 32.00 -32.00 0.00 32.00 32.00 -32.00 32.00 0.00 0.00 32.00 -32.00 33.00 -64.00 64.00 0.00 32.00 32.00 64.00 32.00 0.00 -32.00 33.00 -32.00 -33.00 -32.00 65.00 -33.00 -65.00 -64.00 0.00 -32.00 -32.00 -64.00 32.00 -65.00 65.00 32.00 32.00 33.00 -32.00 0.00 32.00 32.00 32.00 -32.00 -32.00 -33.00 0.00 0.00 32.00 33.00 32.00 96.00 0.00 -64.00 32.00 32.00 32.00 -32.00 0.00 -65.00 0.00 33.00 33.00 32.00 0.00 64.00 -33.00 32.00 33.00 -64.00 64.00 32.00 32.00 64.00 -32.00 65.00 0.00 0.00 32.00 0.00 -32.00 0.00 32.00 32.00 0.00 32.00 0.00 -32.00 0.00 -32.00 0.00 32.00 32.00 64.00 0.00 0.00 65.00 -64.00 0.00 0.00 32.00 0.00 -32.00 32.00 32.00 -32.00 64.00 32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 32.00 32.00 32.00 32.00 -64.00 64.00 0.00 -32.00 0.00 32.00 32.00 -64.00 32.00 32.00 0.00 0.00 33.00 -32.00 0.00 -96.00 64.00 0.00 32.00 32.00 32.00 -32.00 0.00 -33.00 0.00 -128.00 0.00 -129.00 65.00 -128.00 0.00 -65.00 32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -65.00 -33.00 0.00 -32.00 -64.00 0.00 -32.00 -32.00 -96.00 -32.00 -65.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 -32.00 -33.00 32.00 33.00 32.00 -33.00 -32.00 -32.00 32.00 32.00 0.00 0.00 32.00 97.00 -32.00 0.00 32.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 129.00 0.00 64.00 32.00 -64.00 0.00 32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 128.00 0.00 64.00 0.00 0.00 33.00 33.00 0.00 32.00 32.00 64.00 32.00 -64.00 0.00 -225.00 0.00 -418.00 32.00 -97.00 32.00 -32.00 32.00 0.00 32.00 0.00 -32.00 -96.00 0.00 -65.00 32.00 -32.00 33.00 -128.00 32.00 -65.00 32.00 0.00 64.00 0.00 32.00 0.00 -32.00 -64.00 0.00 -32.00 0.00 32.00 0.00 0.00 -32.00 -64.00 -32.00 -65.00 -32.00 -353.00 0.00 -515.00 32.00 -386.00 64.00 -450.00 65.00 -161.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -65.00 -32.00 0.00 32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 0.00 65.00 -64.00 96.00 -33.00 32.00 33.00 65.00 64.00 64.00 0.00 96.00 32.00 65.00 0.00 32.00 -32.00 0.00 -64.00 0.00 -33.00 -64.00 -32.00 -65.00 -32.00 -32.00 -32.00 32.00 32.00 65.00 32.00 128.00 65.00 161.00 64.00 161.00 0.00 418.00 -32.00 193.00 -65.00 257.00 -32.00 32.00 0.00 32.00 32.00 161.00 65.00 0.00 64.00 32.00 -64.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -32.00 -33.00 -32.00 -32.00 -33.00 0.00 -32.00 -64.00 -96.00 -32.00 -32.00 -32.00 -65.00 0.00 0.00 -32.00 -64.00 0.00 -64.00 -65.00 -32.00 -32.00 -65.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 -96.00 -33.00 32.00 0.00 -32.00 -32.00 -65.00 -160.00 -96.00 0.00 -32.00 -33.00 32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 0.00 -65.00 32.00 0.00 -32.00 -32.00 -33.00 32.00 65.00 -64.00 32.00 -64.00 0.00 -32.00 -32.00 64.00 -32.00 32.00 -33.00 -32.00 -32.00 -97.00 0.00 -64.00 32.00 -32.00 33.00 -32.00 32.00 64.00 32.00 -32.00 64.00 0.00 32.00 32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 65.00 -32.00 0.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 64.00 -32.00 33.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 -97.00 32.00 -96.00 0.00 -32.00 0.00 -65.00 0.00 -64.00 32.00 -64.00 0.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 0.00 33.00 -32.00 0.00 -33.00 96.00 -64.00 32.00 -32.00 -32.00 64.00 -96.00 -32.00 -33.00 32.00 -32.00 -32.00 -32.00 -64.00 32.00 -65.00 32.00 -32.00 33.00 0.00 32.00 32.00 32.00 -32.00 96.00 -64.00 0.00 0.00 65.00 -96.00 64.00 -129.00 64.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 -65.00 32.00 32.00 0.00 0.00 33.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 32.00 -65.00 -32.00 0.00 -161.00 65.00 -32.00 32.00 -32.00 -32.00 0.00 -32.00 -33.00 32.00 0.00 -32.00 33.00 0.00 32.00 -97.00 64.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 -64.00 -33.00 0.00 0.00 -33.00 -32.00 65.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 -33.00 0.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 0.00 32.00 -64.00 0.00 0.00 32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 -32.00 -65.00 64.00 0.00 -64.00 -32.00 0.00 0.00 -64.00 32.00 -32.00 32.00 -33.00 97.00 0.00 0.00 -64.00 32.00 32.00 32.00 -32.00 0.00 -32.00 32.00 -64.00 32.00 0.00 0.00 -33.00 -64.00 33.00 -32.00 -33.00 -64.00 33.00 0.00 32.00 0.00 -32.00 -32.00 -33.00 64.00 0.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 32.00 32.00 -32.00 0.00 32.00 32.00 -64.00 0.00 32.00 64.00 0.00 -32.00 96.00 32.00 -64.00 32.00 -32.00 33.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -33.00 -32.00 33.00 -32.00 -65.00 -65.00 -64.00 32.00 -32.00 -64.00 0.00 32.00 -32.00 0.00 0.00 65.00 -33.00 -33.00 0.00 33.00 -32.00 0.00 0.00 64.00 32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 64.00 0.00 0.00 33.00 -64.00 0.00 -32.00 64.00 32.00 32.00 64.00 0.00 -64.00 32.00 -64.00 -64.00 -32.00 32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 32.00 -33.00 -32.00 -32.00 0.00 -32.00 64.00 -64.00 64.00 -32.00 -32.00 -32.00 0.00 -65.00 0.00 -96.00 64.00 -32.00 0.00 -65.00 33.00 -32.00 0.00 0.00 32.00 -32.00 32.00 -64.00 32.00 32.00 -64.00 0.00 -32.00 -32.00 0.00 -65.00 32.00 0.00 -32.00 0.00 32.00 0.00 -32.00 -32.00 0.00 -96.00 32.00 0.00 -32.00 -32.00 0.00 -33.00 64.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -64.00 64.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 33.00 32.00 32.00 -32.00 0.00 -33.00 32.00 0.00 96.00 65.00 32.00 0.00 33.00 0.00 -33.00 -32.00 33.00 -33.00 0.00 0.00 32.00 0.00 32.00 33.00 0.00 -33.00 64.00 -32.00 0.00 0.00 32.00 32.00 33.00 -64.00 32.00 0.00 32.00 -32.00 0.00 32.00 0.00 32.00 0.00 -32.00 32.00 -32.00 0.00 0.00 64.00 32.00 32.00 32.00 33.00 -32.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 0.00 33.00 0.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -33.00 32.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 -96.00 33.00 0.00 0.00 64.00 96.00 0.00 0.00 32.00 32.00 0.00 -32.00 32.00 0.00 65.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -33.00 0.00 33.00 0.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 -65.00 65.00 0.00 -32.00 -64.00 -33.00 32.00 65.00 -32.00 32.00 32.00 -32.00 32.00 0.00 -64.00 64.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 32.00 0.00 -64.00 32.00 64.00 0.00 32.00 -32.00 0.00 32.00 32.00 0.00 32.00 -64.00 32.00 0.00 65.00 0.00 32.00 0.00 96.00 -32.00 -64.00 64.00 -64.00 161.00 -97.00 64.00 0.00 32.00 97.00 33.00 -32.00 -33.00 0.00 -32.00 32.00 0.00 32.00 -32.00 64.00 -128.00 97.00 -65.00 0.00 -32.00 96.00 -32.00 97.00 -32.00 0.00 -32.00 0.00 32.00 -33.00 32.00 -64.00 64.00 0.00 32.00 -32.00 65.00 32.00 32.00 97.00 32.00 32.00 -32.00 0.00 32.00 64.00 -32.00 97.00 64.00 -33.00 0.00 33.00 0.00 32.00 32.00 32.00 0.00 0.00 32.00 -32.00 33.00 -32.00 -65.00 -65.00 0.00 -32.00 0.00 -32.00 65.00 -32.00 32.00 -32.00 -32.00 -33.00 96.00 0.00 32.00 -96.00 129.00 -32.00 32.00 -32.00 0.00 -33.00 32.00 0.00 -96.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 32.00 0.00 -97.00 -32.00 -32.00 -32.00 32.00 -33.00 33.00 -64.00 0.00 32.00 32.00 -64.00 -32.00 -32.00 -33.00 0.00 33.00 0.00 32.00 -32.00 0.00 -65.00 -32.00 -96.00 32.00 0.00 32.00 0.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 -32.00 -33.00 -32.00 -32.00 0.00 -64.00 -64.00 -97.00 -33.00 33.00 0.00 -33.00 -64.00 0.00 -32.00 -32.00 -64.00 0.00 -33.00 -96.00 -32.00 0.00 -32.00 -97.00 32.00 33.00 -32.00 -33.00 -32.00 0.00 -32.00 -64.00 -32.00 32.00 -32.00 -96.00 -33.00 -97.00 0.00 0.00 -96.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -65.00zm15112.00 -3922.00l0.00 -33.00 32.00 0.00 0.00 33.00 -32.00 0.00zm-64.00 32.00l32.00 -32.00 32.00 32.00 -32.00 0.00 32.00 32.00 -64.00 0.00 0.00 -32.00zm-7042.00 3054.00l0.00 -32.00 0.00 32.00zm-1511.00 97.00l32.00 0.00 -32.00 0.00zm-2829.00 -161.00l0.00 32.00 0.00 -32.00zm-2701.00 418.00l0.00 32.00 32.00 0.00 -32.00 0.00 0.00 -32.00zm3858.00 -772.00l0.00 -32.00 0.00 32.00 32.00 0.00 0.00 32.00 -32.00 0.00 32.00 0.00 -32.00 0.00 0.00 -32.00zm-482.00 0.00l0.00 -32.00 32.00 0.00 -32.00 32.00zm3280.00 418.00l-33.00 0.00 0.00 -32.00 33.00 0.00 0.00 32.00zm-6688.00 354.00l0.00 32.00 0.00 -32.00zm96.00 643.00l-32.00 -32.00 -32.00 32.00 32.00 0.00 32.00 0.00zm-96.00 -289.00l32.00 0.00 -32.00 0.00zm546.00 450.00l0.00 -32.00 0.00 32.00zm-128.00 -900.00l32.00 0.00 -32.00 0.00 0.00 32.00 0.00 -32.00zm160.00 -161.00l33.00 0.00 32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 -32.00 0.00 32.00 -33.00 0.00 0.00 -32.00 33.00 0.00 0.00 -32.00 -33.00 0.00zm2894.00 -450.00l32.00 0.00 -32.00 0.00zm-3215.00 482.00l32.00 0.00 32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 -32.00 0.00 -32.00zm5048.00 96.00l32.00 0.00 -32.00 0.00zm-2701.00 -193.00l0.00 33.00 0.00 -33.00 0.00 33.00 0.00 -33.00zm3923.00 0.00l0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00zm-3055.00 -64.00l0.00 -32.00 0.00 32.00zm3537.00 0.00l32.00 0.00 -32.00 0.00zm-6463.00 1608.00l0.00 -32.00 32.00 0.00 -32.00 0.00 0.00 32.00zm-450.00 -933.00l0.00 -32.00 32.00 0.00 -32.00 0.00 0.00 32.00zm3408.00 -707.00l0.00 32.00 0.00 -32.00zm161.00 -129.00l0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00zm3344.00 225.00l32.00 0.00 0.00 -32.00 0.00 32.00 -32.00 0.00zm-6881.00 708.00l0.00 -32.00 0.00 32.00 0.00 32.00 0.00 -32.00zm354.00 64.00l32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -64.00 33.00 -33.00 32.00 -64.00 0.00 64.00 -32.00 65.00 -65.00 32.00 0.00 0.00 -32.00zm-129.00 -643.00l0.00 -32.00 32.00 0.00 0.00 -32.00 33.00 0.00 -33.00 32.00 0.00 32.00 -32.00 0.00zm5209.00 0.00l0.00 -32.00 0.00 32.00zm-5048.00 611.00l0.00 -32.00 32.00 0.00 0.00 32.00 -32.00 0.00zm6752.00 -643.00l32.00 0.00 0.00 32.00 0.00 -32.00 -32.00 0.00zm-3601.00 -386.00l32.00 0.00 -32.00 0.00zm-1029.00 289.00l0.00 -32.00 32.00 32.00 -32.00 0.00zm4405.00 129.00l32.00 0.00 0.00 32.00 -32.00 0.00 0.00 -32.00zm-6848.00 32.00l0.00 -32.00 32.00 0.00 0.00 32.00 0.00 -32.00 0.00 32.00 -32.00 0.00zm7266.00 -1479.00l0.00 -64.00 0.00 -32.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 32.00zm-7491.00 1897.00l32.00 -32.00 32.00 32.00 -64.00 65.00 0.00 -65.00zm3022.00 -739.00l32.00 -32.00 64.00 -33.00 33.00 65.00 -65.00 32.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00zm547.00 0.00l0.00 -32.00 32.00 -33.00 32.00 -32.00 32.00 0.00 0.00 32.00 -32.00 33.00 -32.00 64.00 -32.00 -32.00zm3311.00 -708.00l0.00 32.00 0.00 33.00 32.00 -33.00 0.00 -32.00 -32.00 0.00zm-4791.00 1672.00l-32.00 0.00 32.00 -32.00 -32.00 -32.00 -64.00 32.00 32.00 -64.00 -32.00 -32.00 -64.00 0.00 -97.00 0.00 -64.00 32.00 32.00 32.00 -96.00 96.00 0.00 65.00 -65.00 0.00 33.00 -32.00 -65.00 0.00 0.00 -33.00 32.00 -32.00 33.00 -64.00 0.00 -32.00 -33.00 -32.00 -64.00 64.00 0.00 -64.00 -64.00 32.00 -32.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 0.00 32.00 -32.00 32.00 0.00 33.00 -32.00 64.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 0.00 -33.00 97.00 -64.00 -33.00 97.00 33.00 0.00 0.00 32.00 32.00 0.00 32.00 -65.00 32.00 0.00 -32.00 -32.00 96.00 0.00 0.00 -32.00 32.00 0.00 0.00 -64.00 -32.00 0.00 97.00 -32.00 0.00 -32.00 32.00 0.00 0.00 32.00 96.00 0.00 0.00 32.00 65.00 0.00 0.00 32.00 32.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 0.00 0.00 32.00 32.00 0.00 33.00 -32.00 0.00 64.00 32.00 0.00 96.00 0.00 32.00 0.00 0.00 65.00 0.00 32.00 33.00 0.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -33.00 96.00 -32.00 32.00 32.00 -32.00 33.00 -64.00 32.00 32.00 32.00 -32.00 64.00 32.00 0.00 32.00 0.00 65.00 -64.00 0.00 32.00 32.00 64.00 96.00 0.00 -32.00 65.00 -64.00 0.00 -32.00 32.00 -65.00 0.00 32.00 -32.00 -32.00 -32.00 -32.00 -33.00 -96.00 33.00 -65.00 64.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 32.00 0.00 0.00 32.00 -64.00 32.00 0.00 -32.00 -32.00 -32.00 -97.00 32.00 -32.00 0.00 -64.00 0.00 -33.00 32.00z"},es:{name:"ES",path:"M157827.00 128806.00l0.00 -33.00 0.00 -32.00 0.00 -64.00 64.00 0.00 0.00 32.00 33.00 0.00 -33.00 -96.00 -32.00 -32.00 32.00 0.00 33.00 -33.00 -33.00 -32.00 33.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -65.00 64.00 -32.00 -32.00 -32.00 32.00 0.00 33.00 -32.00 32.00 -32.00 -32.00 -32.00 0.00 32.00 -33.00 -32.00 33.00 -65.00 -65.00 0.00 -96.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -65.00 64.00 -96.00 0.00 -32.00 32.00 -32.00 65.00 0.00 0.00 -33.00 0.00 -32.00 -32.00 -96.00 32.00 -32.00 0.00 -97.00 32.00 -64.00 0.00 -161.00 0.00 -64.00 0.00 -65.00 -161.00 -32.00 -64.00 -160.00 0.00 -33.00 -65.00 0.00 33.00 -96.00 0.00 -32.00 64.00 -32.00 -32.00 -65.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 -32.00 65.00 -32.00 32.00 -32.00 0.00 -32.00 96.00 0.00 32.00 -33.00 -32.00 -32.00 32.00 -96.00 33.00 -32.00 0.00 -129.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 450.00 0.00 997.00 0.00 193.00 0.00 0.00 -33.00 32.00 -32.00 32.00 32.00 96.00 -64.00 32.00 -96.00 0.00 -33.00 33.00 -32.00 32.00 -64.00 32.00 -32.00 -32.00 0.00 64.00 -64.00 -32.00 -33.00 32.00 -64.00 0.00 -64.00 32.00 -32.00 32.00 -97.00 0.00 -32.00 33.00 -32.00 32.00 -32.00 0.00 -97.00 64.00 -64.00 -32.00 -64.00 0.00 -33.00 -32.00 -64.00 32.00 -32.00 32.00 -129.00 32.00 -32.00 129.00 0.00 64.00 -32.00 32.00 32.00 32.00 0.00 65.00 -96.00 0.00 -64.00 96.00 -33.00 32.00 33.00 65.00 -65.00 32.00 -32.00 0.00 -193.00 32.00 0.00 0.00 -32.00 -32.00 -64.00 32.00 0.00 32.00 -97.00 32.00 -64.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -65.00 -64.00 -32.00 0.00 -64.00 64.00 -32.00 -32.00 -32.00 32.00 -65.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 -32.00 -33.00 32.00 -96.00 32.00 -32.00 65.00 0.00 64.00 -32.00 32.00 -65.00 32.00 0.00 32.00 0.00 32.00 -32.00 33.00 -161.00 32.00 0.00 32.00 -32.00 32.00 0.00 32.00 0.00 0.00 -64.00 97.00 0.00 0.00 -32.00 96.00 -32.00 0.00 -32.00 -32.00 -65.00 -32.00 -64.00 32.00 -97.00 -32.00 -64.00 0.00 -64.00 96.00 32.00 97.00 32.00 161.00 0.00 0.00 -32.00 96.00 -129.00 0.00 -32.00 32.00 -32.00 -64.00 -32.00 0.00 -64.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 0.00 -32.00 128.00 -97.00 0.00 -32.00 33.00 -32.00 -65.00 -32.00 0.00 -65.00 32.00 -96.00 33.00 0.00 32.00 -32.00 32.00 0.00 32.00 -64.00 -32.00 -33.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 33.00 -32.00 -65.00 0.00 -32.00 -32.00 64.00 -32.00 65.00 0.00 0.00 -97.00 -65.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 32.00 0.00 33.00 -33.00 0.00 -64.00 -33.00 -32.00 33.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -65.00 -32.00 -32.00 -32.00 -32.00 32.00 -64.00 -64.00 0.00 0.00 -65.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 -32.00 -32.00 -64.00 0.00 -32.00 0.00 0.00 -32.00 0.00 -65.00 -32.00 33.00 0.00 -65.00 -33.00 0.00 -32.00 32.00 -32.00 -64.00 -96.00 0.00 0.00 -64.00 -32.00 0.00 -33.00 -32.00 33.00 -65.00 -65.00 -64.00 32.00 -32.00 0.00 -64.00 65.00 0.00 128.00 -97.00 32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -65.00 0.00 -32.00 -64.00 0.00 0.00 -32.00 -96.00 -32.00 -33.00 -32.00 -32.00 0.00 0.00 -65.00 -32.00 -32.00 -32.00 -64.00 -64.00 -32.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 -32.00 -65.00 -32.00 -32.00 -96.00 32.00 -33.00 0.00 -64.00 -64.00 0.00 64.00 0.00 32.00 -32.00 33.00 -64.00 -97.00 -32.00 0.00 -33.00 -32.00 33.00 -32.00 -33.00 0.00 33.00 -64.00 -33.00 -65.00 65.00 -96.00 289.00 0.00 32.00 0.00 65.00 0.00 64.00 -32.00 32.00 64.00 32.00 32.00 0.00 32.00 64.00 97.00 65.00 0.00 64.00 0.00 161.00 0.00 96.00 0.00 290.00 0.00 64.00 -32.00 32.00 -33.00 32.00 33.00 32.00 -33.00 33.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 -32.00 33.00 -33.00 -65.00 -64.00 0.00 -193.00 0.00 -32.00 -32.00 -193.00 -32.00 -32.00 -161.00 -32.00 -32.00 -32.00 -64.00 0.00 -65.00 -65.00 -64.00 0.00 32.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 32.00 32.00 -32.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -33.00 0.00 -32.00 -32.00 -32.00 32.00 -257.00 32.00 0.00 0.00 -96.00 32.00 -290.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -160.00 -32.00 -129.00 0.00 -418.00 -33.00 -32.00 -32.00 64.00 -96.00 64.00 -32.00 65.00 -32.00 -97.00 0.00 0.00 -65.00 0.00 -64.00 65.00 0.00 0.00 -32.00 0.00 -64.00 0.00 -97.00 -33.00 -32.00 0.00 -129.00 33.00 -32.00 96.00 -96.00 161.00 -129.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -64.00 128.00 -65.00 65.00 0.00 0.00 -32.00 0.00 -32.00 96.00 -32.00 -32.00 64.00 32.00 0.00 32.00 -96.00 65.00 0.00 0.00 64.00 96.00 0.00 32.00 -96.00 32.00 -33.00 65.00 33.00 32.00 32.00 32.00 0.00 0.00 -32.00 0.00 -33.00 0.00 -64.00 32.00 0.00 32.00 32.00 32.00 0.00 65.00 -64.00 32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 64.00 65.00 0.00 64.00 32.00 0.00 64.00 32.00 0.00 32.00 33.00 32.00 0.00 65.00 0.00 32.00 0.00 96.00 32.00 33.00 32.00 128.00 -32.00 -32.00 -225.00 -611.00 -579.00 32.00 -32.00 32.00 0.00 32.00 -65.00 33.00 65.00 32.00 0.00 32.00 32.00 32.00 -32.00 97.00 -129.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 -32.00 32.00 32.00 33.00 0.00 32.00 64.00 -32.00 65.00 64.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 -32.00 96.00 32.00 0.00 32.00 0.00 65.00 32.00 32.00 -32.00 64.00 0.00 64.00 0.00 0.00 65.00 32.00 32.00 97.00 -65.00 32.00 33.00 32.00 -33.00 65.00 33.00 32.00 -33.00 32.00 -64.00 96.00 -32.00 0.00 -64.00 65.00 -33.00 -32.00 -32.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 64.00 0.00 64.00 0.00 0.00 -97.00 97.00 0.00 96.00 -64.00 97.00 -64.00 32.00 0.00 64.00 96.00 97.00 0.00 96.00 96.00 32.00 -64.00 129.00 32.00 64.00 0.00 129.00 0.00 0.00 32.00 64.00 0.00 32.00 -32.00 64.00 32.00 33.00 -32.00 64.00 0.00 64.00 65.00 32.00 0.00 33.00 64.00 64.00 -32.00 0.00 32.00 96.00 64.00 33.00 0.00 64.00 32.00 128.00 65.00 772.00 482.00 547.00 354.00 128.00 96.00 32.00 32.00 1062.00 676.00 64.00 32.00 32.00 32.00 0.00 64.00 0.00 32.00 -161.00 322.00 0.00 32.00 -64.00 225.00 -64.00 161.00 0.00 225.00 0.00 32.00 0.00 161.00 32.00 64.00 -65.00 193.00 -32.00 322.00 -32.00 385.00 0.00 258.00 64.00 546.00 97.00 708.00 32.00 353.00 64.00 354.00 33.00 322.00 -33.00 289.00 -160.00 482.00 -193.00 450.00 -161.00 354.00 0.00 96.00 -64.00 33.00 -33.00 0.00 -64.00 0.00 -161.00 64.00 -193.00 96.00 -96.00 65.00 -225.00 193.00 -193.00 193.00 -129.00 128.00 -32.00 64.00 0.00 65.00 -32.00 96.00 -64.00 97.00 -32.00 64.00 -33.00 32.00 0.00 32.00 -32.00 33.00 0.00 64.00 -96.00 64.00 -64.00 32.00 -33.00 65.00 0.00 32.00 33.00 32.00 -33.00 32.00 -32.00 64.00 0.00 32.00 -32.00 65.00 0.00 32.00 -32.00 129.00 -129.00 32.00 -32.00 64.00 97.00 97.00 0.00 160.00 -65.00 225.00 0.00 97.00 -32.00 32.00 0.00 96.00 -32.00 65.00 -64.00 128.00 -97.00 97.00 -32.00 96.00 0.00 32.00 -64.00 33.00 0.00 -33.00 0.00 -32.00 -32.00 -64.00 -65.00 0.00 -64.00 32.00 -32.00 64.00 32.00 33.00 -32.00 32.00 64.00 0.00 0.00 32.00 -64.00 0.00 32.00 0.00 32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 64.00 -32.00 33.00 0.00 -33.00 0.00 0.00 32.00 33.00 0.00 -33.00 0.00 0.00 32.00 33.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 97.00 -32.00 32.00 -97.00 161.00 -32.00 128.00 0.00 33.00 -128.00 257.00 -65.00 161.00 0.00 32.00 -32.00 0.00 -32.00 96.00 -129.00 193.00 0.00 97.00 -96.00 128.00 -32.00 65.00 32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -65.00 0.00 33.00 -33.00 -33.00 0.00 -64.00 -32.00 0.00 32.00 -32.00 33.00 32.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 -32.00 -32.00 64.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -33.00 32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 64.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 97.00 -64.00 129.00 32.00 32.00 -32.00 0.00 0.00 32.00 -33.00 0.00 0.00 32.00 -32.00 0.00 -64.00 0.00 -96.00 129.00 -33.00 64.00 0.00 32.00 -32.00 64.00 32.00 0.00 -32.00 33.00 -32.00 -33.00 -64.00 33.00 -64.00 128.00 -33.00 0.00 0.00 32.00 -32.00 0.00 0.00 -64.00 32.00 -32.00 -32.00 -32.00 -96.00 -65.00 32.00 -64.00 32.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 32.00 32.00 33.00 -65.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 0.00 32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -65.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 32.00 0.00 -32.00 32.00 32.00 0.00 32.00 -32.00 0.00 32.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 33.00 -65.00 64.00 0.00 32.00 0.00 32.00 0.00 32.00 -64.00 32.00 0.00 65.00 -96.00 96.00 -33.00 65.00 0.00 32.00 -32.00 96.00 0.00 129.00 32.00 64.00 -32.00 0.00 0.00 32.00 -32.00 129.00 -64.00 32.00 -129.00 418.00 -129.00 64.00 -32.00 65.00 -96.00 64.00 -64.00 96.00 -129.00 225.00 -32.00 97.00 0.00 129.00 0.00 96.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 0.00 -65.00 -32.00 -96.00 -32.00 0.00 -65.00 0.00 -64.00 32.00 -64.00 -97.00 -65.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -97.00 32.00 -64.00 0.00 -32.00 32.00 -65.00 33.00 -32.00 0.00 -64.00 0.00 -32.00 0.00 32.00 -33.00 -32.00 33.00 0.00 -33.00 0.00 33.00 -32.00 0.00 0.00 32.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 -33.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -64.00 0.00 -32.00 64.00 -32.00 0.00 -32.00 0.00 0.00 33.00 -33.00 -33.00 -32.00 0.00 -32.00 0.00 -64.00 -96.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -128.00 -32.00 -33.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 0.00 32.00 -33.00 0.00 -64.00 64.00 -64.00 0.00 -32.00 -32.00 -65.00 -32.00 -64.00 -32.00 0.00 -65.00 -32.00 0.00 -64.00 0.00 -33.00 -32.00 -32.00 0.00 0.00 64.00 -64.00 -64.00 -96.00 32.00 -33.00 -64.00 -32.00 64.00 -32.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 -65.00 -97.00 33.00 -96.00 -65.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -33.00 0.00 -32.00 -32.00 -64.00 0.00 0.00 32.00 -64.00 0.00 0.00 -32.00 64.00 -32.00 0.00 -33.00 -64.00 0.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 65.00 -128.00 -32.00 0.00 0.00 -33.00 -33.00 0.00 0.00 -64.00 33.00 0.00 0.00 32.00 32.00 0.00 0.00 -64.00 -32.00 -64.00 0.00 -32.00 32.00 0.00 32.00 -33.00 -64.00 -32.00 32.00 -32.00 0.00 -64.00 32.00 0.00 0.00 -65.00 -32.00 0.00 0.00 -128.00 -65.00 -32.00 -32.00 -97.00 32.00 0.00 33.00 -32.00 32.00 -96.00 -32.00 0.00 0.00 -33.00 32.00 -96.00 32.00 0.00 -64.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 -64.00 32.00 -97.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 32.00 0.00 -64.00 -64.00 0.00 0.00 -33.00 -33.00 0.00 -96.00 0.00 -32.00 33.00 -64.00 0.00 32.00 -65.00 -32.00 32.00 -65.00 -32.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 -32.00 -65.00 -65.00 33.00 -32.00 0.00zm7170.00 -1190.00l32.00 0.00 -32.00 0.00zm-64.00 450.00l0.00 -32.00 0.00 32.00zm-64.00 -96.00l-32.00 0.00 32.00 0.00zm-547.00 321.00l-64.00 0.00 -32.00 0.00 0.00 -32.00 -33.00 96.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 32.00 0.00 32.00 0.00 -32.00 33.00 65.00 32.00 32.00 -32.00 -65.00 0.00 33.00 -65.00 32.00 -32.00 64.00 32.00 0.00 -32.00zm579.00 -225.00l0.00 -32.00 0.00 32.00zm386.00 -1157.00l32.00 0.00 -32.00 0.00z"},sc:{name:"SC",path:"M101205.00 160059.00l0.00 -33.00 -32.00 -32.00 32.00 -32.00 161.00 -32.00 0.00 -32.00 -97.00 32.00 -32.00 -64.00 32.00 0.00 65.00 -32.00 0.00 -33.00 0.00 -32.00 -65.00 -32.00 0.00 -32.00 33.00 0.00 32.00 64.00 32.00 0.00 96.00 -32.00 -128.00 -96.00 0.00 -33.00 32.00 -64.00 64.00 64.00 65.00 0.00 -33.00 -32.00 -32.00 0.00 -64.00 -64.00 -32.00 -64.00 64.00 0.00 64.00 64.00 33.00 64.00 64.00 -32.00 -32.00 -32.00 -65.00 -32.00 -32.00 -129.00 32.00 32.00 65.00 65.00 32.00 -33.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -64.00 64.00 0.00 32.00 64.00 65.00 -64.00 -65.00 -65.00 97.00 0.00 32.00 0.00 0.00 -32.00 -97.00 -64.00 33.00 0.00 0.00 -64.00 64.00 32.00 64.00 -32.00 0.00 -32.00 -32.00 -65.00 0.00 -32.00 129.00 64.00 32.00 0.00 32.00 0.00 -64.00 -32.00 -65.00 -64.00 65.00 -32.00 32.00 -32.00 -32.00 -33.00 32.00 -64.00 -97.00 -32.00 32.00 -32.00 33.00 -64.00 -65.00 0.00 0.00 -33.00 161.00 33.00 0.00 -33.00 -32.00 -32.00 -32.00 -32.00 -97.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 -65.00 -32.00 -32.00 0.00 -32.00 32.00 32.00 32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -64.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 -64.00 0.00 0.00 32.00 -64.00 0.00 -65.00 -64.00 65.00 32.00 32.00 -32.00 32.00 0.00 0.00 -64.00 -32.00 -32.00 -32.00 -65.00 -33.00 65.00 -64.00 0.00 32.00 -65.00 -64.00 -32.00 0.00 -64.00 32.00 64.00 64.00 -32.00 33.00 -64.00 -65.00 -65.00 0.00 -32.00 32.00 0.00 33.00 65.00 64.00 -65.00 -64.00 -32.00 0.00 -32.00 64.00 0.00 -32.00 -64.00 0.00 -33.00 0.00 33.00 -65.00 0.00 0.00 -33.00 -32.00 0.00 -64.00 -32.00 32.00 -32.00 32.00 32.00 0.00 -64.00 32.00 0.00 33.00 -64.00 -33.00 -32.00 33.00 0.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -129.00 64.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -33.00 0.00 65.00 -32.00 -32.00 -32.00 -65.00 -32.00 65.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -64.00 -64.00 0.00 0.00 -97.00 32.00 0.00 0.00 32.00 32.00 -32.00 64.00 32.00 -32.00 -64.00 32.00 -32.00 32.00 0.00 -32.00 -65.00 32.00 0.00 -32.00 -32.00 -32.00 65.00 0.00 -65.00 -32.00 0.00 64.00 -32.00 32.00 32.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 32.00 0.00 0.00 -65.00 -32.00 0.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 -64.00 -32.00 0.00 -65.00 32.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 -32.00 -32.00 -32.00 32.00 0.00 0.00 -65.00 65.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 0.00 -32.00 64.00 -97.00 32.00 -64.00 32.00 -64.00 0.00 -65.00 0.00 -32.00 65.00 32.00 32.00 0.00 64.00 0.00 97.00 -32.00 32.00 97.00 32.00 0.00 97.00 64.00 0.00 32.00 128.00 0.00 129.00 32.00 96.00 -32.00 32.00 0.00 32.00 0.00 97.00 -64.00 64.00 0.00 32.00 -32.00 193.00 -129.00 32.00 -32.00 65.00 64.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 32.00 65.00 0.00 32.00 32.00 32.00 0.00 129.00 -64.00 0.00 64.00 32.00 0.00 64.00 97.00 0.00 32.00 32.00 32.00 0.00 32.00 32.00 0.00 65.00 65.00 128.00 64.00 0.00 32.00 32.00 0.00 65.00 64.00 64.00 0.00 32.00 33.00 32.00 0.00 33.00 -33.00 32.00 0.00 32.00 65.00 32.00 32.00 32.00 32.00 64.00 32.00 33.00 0.00 32.00 32.00 32.00 32.00 64.00 0.00 129.00 -64.00 96.00 -32.00 193.00 -129.00 193.00 97.00 64.00 -32.00 33.00 0.00 64.00 -32.00 32.00 32.00 64.00 0.00 33.00 0.00 32.00 0.00 32.00 0.00 128.00 -65.00 33.00 0.00 64.00 0.00 64.00 0.00 32.00 0.00 32.00 33.00 33.00 0.00 64.00 -33.00 64.00 33.00 32.00 0.00 33.00 -33.00 32.00 0.00 32.00 -32.00 64.00 32.00 32.00 65.00 33.00 -32.00 32.00 32.00 32.00 0.00 96.00 -32.00 97.00 96.00 64.00 32.00 32.00 32.00 0.00 32.00 64.00 33.00 33.00 32.00 0.00 32.00 32.00 0.00 32.00 0.00 32.00 32.00 64.00 -64.00 65.00 32.00 32.00 -32.00 32.00 32.00 64.00 -32.00 97.00 -32.00 128.00 96.00 65.00 0.00 64.00 97.00 32.00 0.00 32.00 0.00 32.00 0.00 97.00 0.00 32.00 0.00 64.00 -33.00 32.00 -32.00 33.00 32.00 32.00 33.00 32.00 0.00 64.00 -33.00 65.00 65.00 32.00 -65.00 32.00 65.00 64.00 -32.00 97.00 0.00 96.00 96.00 0.00 32.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 0.00 32.00 32.00 96.00 0.00 97.00 -32.00 64.00 -64.00 129.00 128.00 64.00 0.00 65.00 0.00 32.00 32.00 64.00 0.00 64.00 33.00 0.00 96.00 32.00 32.00 33.00 0.00 32.00 65.00 64.00 0.00 32.00 32.00 32.00 0.00 32.00 32.00 65.00 32.00 0.00 32.00 64.00 0.00 0.00 32.00 32.00 65.00 129.00 -33.00 0.00 33.00 64.00 0.00 65.00 32.00 32.00 -32.00 96.00 64.00 129.00 0.00 96.00 32.00 0.00 32.00 32.00 32.00 32.00 0.00 65.00 -64.00 64.00 32.00 97.00 -64.00 96.00 32.00 64.00 0.00 258.00 -64.00 128.00 32.00 64.00 0.00 129.00 -97.00 97.00 65.00 64.00 64.00 64.00 0.00 97.00 0.00 64.00 0.00 257.00 0.00 97.00 -32.00 64.00 32.00 32.00 64.00 32.00 33.00 -32.00 64.00 64.00 0.00 33.00 0.00 32.00 32.00 32.00 64.00 0.00 65.00 64.00 64.00 32.00 96.00 129.00 65.00 -32.00 64.00 64.00 -32.00 32.00 -32.00 0.00 -65.00 -64.00 -64.00 64.00 -64.00 65.00 0.00 64.00 -32.00 64.00 0.00 97.00 -33.00 32.00 0.00 0.00 33.00 64.00 -33.00 32.00 33.00 97.00 0.00 0.00 -65.00 32.00 0.00 0.00 -32.00 64.00 0.00 32.00 -32.00 97.00 0.00 0.00 -32.00 32.00 -32.00 -32.00 -65.00 64.00 -32.00 0.00 -64.00 0.00 -32.00 32.00 -32.00 -64.00 -33.00 0.00 -32.00 32.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -64.00 -32.00 0.00 -32.00 -65.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 64.00 -33.00 -32.00 -32.00 32.00 -32.00 -64.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 32.00 -32.00 -96.00 -32.00 -33.00 -65.00 0.00 -32.00 65.00 -32.00 -32.00 -32.00 0.00 -32.00 64.00 32.00 0.00 -65.00 32.00 -32.00 96.00 -32.00 -32.00 -32.00 -32.00 -32.00 64.00 -64.00 0.00 -33.00 -32.00 0.00 32.00 -64.00 33.00 0.00 0.00 -32.00 96.00 -32.00 32.00 -32.00 32.00 -65.00 33.00 0.00 32.00 0.00 64.00 0.00 64.00 -32.00 32.00 0.00 0.00 -32.00 65.00 -32.00 32.00 32.00 32.00 0.00 0.00 -32.00 64.00 0.00 65.00 -32.00 32.00 -32.00 32.00 -33.00 0.00 -64.00 32.00 0.00 32.00 -96.00 97.00 64.00 32.00 32.00 257.00 -96.00 32.00 32.00 97.00 64.00 0.00 97.00 96.00 0.00 32.00 64.00 33.00 0.00 32.00 -64.00 -65.00 -129.00 33.00 -32.00 32.00 0.00 96.00 96.00 0.00 161.00 64.00 0.00 33.00 0.00 32.00 -32.00 32.00 -97.00 32.00 -96.00 32.00 0.00 97.00 129.00 32.00 32.00 32.00 -32.00 32.00 -97.00 64.00 -32.00 33.00 -32.00 32.00 -32.00 193.00 -32.00 32.00 32.00 0.00 96.00 64.00 0.00 64.00 0.00 33.00 -32.00 -97.00 -193.00 129.00 -64.00 32.00 -32.00 64.00 -97.00 32.00 -64.00 32.00 -32.00 65.00 -32.00 32.00 -33.00 32.00 0.00 -64.00 -128.00 64.00 -65.00 32.00 -64.00 65.00 -64.00 128.00 32.00 64.00 0.00 97.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -65.00 -32.00 0.00 -32.00 0.00 -64.00 33.00 -33.00 0.00 -32.00 -33.00 0.00 -96.00 97.00 -97.00 32.00 0.00 32.00 97.00 32.00 0.00 0.00 64.00 0.00 32.00 129.00 -64.00 64.00 -32.00 32.00 32.00 32.00 -32.00 33.00 32.00 64.00 0.00 -32.00 0.00 32.00 32.00 0.00 -64.00 32.00 0.00 0.00 32.00 64.00 0.00 0.00 32.00 0.00 -32.00 65.00 32.00 -33.00 32.00 33.00 33.00 32.00 64.00 64.00 0.00 32.00 0.00 32.00 0.00 33.00 -32.00 0.00 32.00 160.00 96.00 33.00 65.00 -33.00 64.00 0.00 32.00 33.00 -32.00 0.00 32.00 32.00 32.00 64.00 32.00 32.00 33.00 32.00 -33.00 32.00 33.00 0.00 -33.00 -64.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 -32.00 -65.00 64.00 0.00 0.00 -64.00 97.00 -64.00 96.00 -32.00 65.00 -33.00 64.00 33.00 0.00 -65.00 0.00 -32.00 96.00 32.00 0.00 65.00 33.00 64.00 32.00 -32.00 32.00 0.00 32.00 32.00 64.00 0.00 0.00 32.00 33.00 32.00 32.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -65.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 -32.00 32.00 -32.00 32.00 32.00 64.00 -32.00 32.00 32.00 -32.00 97.00 0.00 32.00 65.00 -65.00 64.00 97.00 32.00 -64.00 32.00 32.00 97.00 -65.00 32.00 -96.00 32.00 96.00 0.00 33.00 0.00 -33.00 32.00 -32.00 32.00 0.00 32.00 0.00 65.00 -32.00 32.00 0.00 32.00 0.00 97.00 64.00 32.00 -32.00 -32.00 -64.00 0.00 -32.00 64.00 0.00 0.00 -32.00 96.00 32.00 32.00 32.00 0.00 96.00 -32.00 65.00 129.00 -129.00 -64.00 -32.00 32.00 -32.00 64.00 -32.00 32.00 32.00 -32.00 32.00 32.00 32.00 97.00 -32.00 32.00 32.00 32.00 32.00 32.00 -32.00 129.00 32.00 -32.00 32.00 32.00 33.00 32.00 32.00 32.00 0.00 32.00 32.00 32.00 0.00 0.00 -64.00 33.00 32.00 0.00 64.00 -65.00 32.00 32.00 0.00 33.00 -32.00 0.00 64.00 32.00 65.00 32.00 0.00 32.00 -33.00 32.00 97.00 64.00 32.00 0.00 -32.00 33.00 -32.00 32.00 96.00 32.00 0.00 0.00 -64.00 -32.00 0.00 0.00 -32.00 32.00 0.00 32.00 64.00 64.00 32.00 0.00 97.00 65.00 0.00 64.00 0.00 -64.00 64.00 32.00 64.00 32.00 0.00 64.00 -64.00 65.00 32.00 32.00 64.00 64.00 0.00 -64.00 65.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 32.00 33.00 0.00 0.00 32.00 0.00 32.00 64.00 -32.00 0.00 -64.00 32.00 0.00 0.00 64.00 -32.00 32.00 64.00 32.00 32.00 0.00 0.00 -32.00 0.00 32.00 33.00 0.00 32.00 65.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -65.00 64.00 97.00 65.00 32.00 32.00 -64.00 -32.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 -32.00 -32.00 0.00 -33.00 32.00 0.00 32.00 65.00 0.00 -32.00 33.00 32.00 32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 32.00 -33.00 0.00 -32.00 0.00 32.00 -32.00 -64.00 32.00 0.00 32.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 32.00 32.00 65.00 -65.00 32.00 -64.00 64.00 0.00 32.00 0.00 0.00 64.00 33.00 -32.00 32.00 0.00 32.00 -32.00 0.00 32.00 0.00 -64.00 64.00 32.00 32.00 -64.00 0.00 32.00 32.00 32.00 0.00 -32.00 33.00 0.00 64.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 33.00 0.00 32.00 -32.00 96.00 -64.00 32.00 0.00 32.00 0.00 0.00 32.00 33.00 -32.00 -33.00 -32.00 65.00 0.00 0.00 -32.00 -32.00 0.00 32.00 0.00 -32.00 -33.00 0.00 -32.00 32.00 -32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 -32.00 0.00 65.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 0.00 64.00 -32.00 33.00 -32.00 64.00 0.00 0.00 -32.00 64.00 0.00 32.00 -33.00 33.00 0.00 32.00 33.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 0.00 0.00 32.00 32.00 -65.00 32.00 0.00 -32.00 0.00 32.00 -32.00 65.00 32.00 32.00 -32.00 32.00 65.00 32.00 0.00 0.00 -33.00 64.00 0.00 33.00 -32.00 0.00 65.00 64.00 64.00 32.00 -32.00 32.00 0.00 32.00 -65.00 33.00 0.00 32.00 65.00 32.00 0.00 64.00 0.00 0.00 -32.00 32.00 0.00 33.00 -33.00 32.00 0.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 -64.00 -32.00 675.00 0.00 515.00 0.00 161.00 0.00 0.00 -32.00 32.00 0.00 32.00 0.00 0.00 -32.00 96.00 -65.00 32.00 33.00 33.00 32.00 0.00 32.00 32.00 0.00 0.00 32.00 32.00 0.00 32.00 0.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 96.00 -64.00 290.00 32.00 64.00 32.00 32.00 0.00 225.00 65.00 225.00 64.00 0.00 32.00 0.00 129.00 0.00 32.00 -32.00 32.00 32.00 -32.00 161.00 64.00 97.00 64.00 32.00 0.00 -32.00 33.00 -33.00 0.00 33.00 -33.00 64.00 -32.00 32.00 -128.00 225.00 -97.00 193.00 -32.00 161.00 -128.00 225.00 -33.00 128.00 0.00 97.00 -96.00 128.00 -64.00 161.00 -97.00 193.00 -32.00 97.00 -32.00 32.00 -64.00 193.00 -33.00 257.00 0.00 96.00 33.00 65.00 -33.00 96.00 33.00 161.00 32.00 32.00 32.00 32.00 64.00 32.00 0.00 -64.00 64.00 32.00 33.00 65.00 32.00 32.00 96.00 0.00 32.00 -65.00 0.00 33.00 65.00 0.00 -32.00 64.00 32.00 0.00 -32.00 0.00 -33.00 32.00 -32.00 129.00 -96.00 0.00 -32.00 32.00 -33.00 193.00 -32.00 128.00 32.00 65.00 -32.00 32.00 65.00 64.00 32.00 -32.00 -32.00 64.00 0.00 97.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 -33.00 32.00 65.00 97.00 64.00 32.00 32.00 0.00 0.00 -32.00 32.00 -33.00 33.00 33.00 0.00 -33.00 32.00 0.00 0.00 33.00 32.00 64.00 32.00 0.00 -32.00 32.00 32.00 32.00 -32.00 0.00 0.00 64.00 -32.00 33.00 -32.00 96.00 -33.00 32.00 33.00 65.00 -33.00 0.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 0.00 64.00 32.00 97.00 97.00 96.00 64.00 64.00 64.00 0.00 32.00 0.00 65.00 -32.00 0.00 -32.00 32.00 -64.00 0.00 -32.00 32.00 -33.00 32.00 33.00 32.00 -65.00 32.00 32.00 -64.00 65.00 64.00 96.00 65.00 0.00 32.00 0.00 0.00 -32.00 0.00 -32.00 32.00 64.00 32.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -32.00 33.00 -33.00 64.00 33.00 96.00 32.00 0.00 64.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 -33.00 0.00 -64.00 32.00 0.00 -32.00 64.00 -33.00 0.00 -32.00 -64.00 -64.00 -64.00 -32.00 -97.00 32.00 -32.00 32.00 -64.00 32.00 -64.00 65.00 0.00 -33.00 -65.00 65.00 -32.00 0.00 -32.00 0.00 0.00 128.00 -32.00 33.00 0.00 96.00 64.00 129.00 32.00 64.00 65.00 32.00 0.00 -32.00 32.00 0.00 32.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -32.00 32.00 0.00 33.00 -32.00 0.00 128.00 32.00 32.00 64.00 0.00 -32.00 33.00 0.00 32.00 -32.00 0.00 0.00 32.00 0.00 32.00 32.00 64.00 -32.00 65.00 0.00 -33.00 -32.00 -32.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 129.00 0.00 32.00 32.00 32.00 -64.00 0.00 0.00 32.00 32.00 0.00 -32.00 65.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 -32.00 -32.00 0.00 -96.00 32.00 -32.00 64.00 -33.00 64.00 0.00 97.00 -32.00 32.00 65.00 161.00 0.00 64.00 96.00 64.00 -32.00 65.00 64.00 64.00 129.00 32.00 0.00 32.00 32.00 65.00 -32.00 32.00 32.00 0.00 -32.00 32.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 0.00 -64.00 -32.00 0.00 -64.00 0.00 -64.00 32.00 32.00 0.00 -32.00 64.00 0.00 65.00 -33.00 32.00 -32.00 -32.00 0.00 32.00 32.00 32.00 65.00 32.00 96.00 32.00 0.00 64.00 0.00 33.00 32.00 64.00 0.00 64.00 -32.00 64.00 32.00 65.00 33.00 64.00 -33.00 64.00 0.00 33.00 -32.00 32.00 65.00 64.00 -33.00 96.00 65.00 65.00 32.00 128.00 -32.00 33.00 0.00 -33.00 -32.00 0.00 -33.00 33.00 -32.00 64.00 32.00 64.00 33.00 32.00 0.00 -32.00 64.00 0.00 0.00 64.00 -32.00 65.00 -32.00 0.00 -33.00 64.00 -96.00 64.00 0.00 65.00 -32.00 32.00 0.00 32.00 32.00 32.00 -32.00 32.00 -32.00 97.00 0.00 96.00 64.00 65.00 32.00 -33.00 64.00 65.00 -32.00 32.00 0.00 -32.00 -32.00 32.00 0.00 64.00 0.00 64.00 -32.00 0.00 -32.00 65.00 -32.00 32.00 0.00 32.00 -33.00 64.00 0.00 32.00 33.00 0.00 -33.00 0.00 0.00 33.00 33.00 0.00 0.00 32.00 -33.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 -32.00 32.00 0.00 33.00 -64.00 128.00 0.00 32.00 32.00 0.00 0.00 33.00 -32.00 32.00 0.00 32.00 0.00 32.00 0.00 64.00 64.00 32.00 0.00 -32.00 32.00 32.00 -160.00 97.00 -129.00 225.00 -32.00 129.00 32.00 32.00 32.00 0.00 -32.00 32.00 -97.00 128.00 -64.00 97.00 -32.00 129.00 0.00 32.00 32.00 0.00 -32.00 32.00 -64.00 96.00 -32.00 97.00 0.00 128.00 96.00 0.00 0.00 33.00 32.00 32.00 -32.00 0.00 -64.00 64.00 0.00 32.00 32.00 0.00 -32.00 64.00 -65.00 33.00 -64.00 64.00 32.00 32.00 -32.00 32.00 -32.00 0.00 -97.00 65.00 0.00 64.00 33.00 32.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -64.00 32.00 -258.00 97.00 -418.00 225.00 -386.00 257.00 -514.00 322.00 -482.00 385.00 -129.00 129.00 -64.00 32.00 -225.00 193.00 -225.00 225.00 -386.00 418.00 -32.00 32.00 -611.00 708.00 -322.00 450.00 -96.00 0.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 65.00 -32.00 -32.00 0.00 0.00 -33.00 0.00 33.00 -33.00 -33.00 0.00 -32.00 -32.00 -32.00 -64.00 32.00 -32.00 0.00 -97.00 -64.00 -32.00 0.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 -32.00 0.00 -33.00 0.00 -32.00 0.00 0.00 -33.00 32.00 -32.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 -65.00 -65.00 0.00 -96.00 -32.00 -64.00 -32.00 -65.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -64.00 0.00 -33.00 32.00 -32.00 64.00 -64.00 32.00 -64.00 33.00 -32.00 -33.00 -129.00 65.00 -32.00 32.00 -97.00 0.00 0.00 32.00 -32.00 0.00 -96.00 32.00 -65.00 0.00 -32.00 0.00 -32.00 0.00 32.00 129.00 32.00 0.00 65.00 64.00 64.00 64.00 64.00 0.00 129.00 193.00 -64.00 -32.00 -65.00 0.00 32.00 -32.00 0.00 -32.00 -96.00 0.00 32.00 -32.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 -32.00 -33.00 -65.00 0.00 -32.00 -32.00 32.00 0.00 -64.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 32.00 0.00 64.00 -32.00 0.00 0.00 -32.00 -33.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -97.00 33.00 0.00 -65.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 96.00 -64.00 33.00 0.00 -33.00 -32.00 -32.00 0.00 32.00 -33.00 -32.00 0.00 97.00 -32.00 0.00 -32.00 -32.00 -32.00 -65.00 0.00 65.00 -64.00 0.00 32.00 64.00 0.00 -32.00 32.00 64.00 0.00 0.00 32.00 96.00 0.00 -32.00 64.00 -32.00 0.00 0.00 33.00 0.00 32.00 97.00 -65.00 -33.00 65.00 65.00 -32.00 -32.00 -33.00 32.00 -32.00 -32.00 32.00 0.00 -96.00 0.00 -32.00 32.00 0.00 -32.00 0.00 0.00 -64.00 -33.00 0.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 65.00 -32.00 64.00 0.00 -32.00 0.00 0.00 32.00 -64.00 32.00 0.00 32.00 64.00 0.00 -32.00 0.00 32.00 33.00 0.00 32.00 64.00 -65.00 0.00 65.00 32.00 -32.00 33.00 0.00 32.00 0.00 32.00 -33.00 32.00 33.00 64.00 0.00 -32.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 65.00 0.00 0.00 -32.00 0.00 -65.00 -33.00 -32.00 97.00 0.00 32.00 0.00 0.00 32.00 32.00 -32.00 -32.00 -64.00 32.00 0.00 64.00 0.00 33.00 0.00 -33.00 0.00 0.00 -64.00 33.00 -33.00 -33.00 0.00 0.00 -64.00 65.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 0.00 32.00 0.00 -32.00 -32.00 64.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -33.00 0.00 -96.00 32.00 0.00 32.00 0.00 -32.00 -96.00 0.00 225.00 -97.00 0.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 0.00 -97.00 32.00 65.00 -64.00 0.00 -65.00 32.00 -32.00 32.00 32.00 0.00 -64.00 0.00 -32.00 32.00 32.00 64.00 -32.00 -64.00 -32.00 -32.00 -33.00 -64.00 -32.00 0.00 -96.00 32.00 0.00 0.00 -65.00 32.00 0.00 -96.00 0.00 -33.00 -32.00 65.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -33.00 32.00 0.00 0.00 -32.00 32.00 0.00 -64.00 0.00 -32.00 32.00 0.00 -64.00 -97.00 32.00 33.00 -32.00 32.00 -32.00 0.00 -32.00 32.00 0.00 0.00 -32.00 -64.00 32.00 32.00 -129.00 -32.00 0.00 0.00 -32.00 0.00 -96.00 64.00 32.00 0.00 -65.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 0.00 -33.00 32.00 0.00 -64.00 -32.00 0.00 -64.00 32.00 -64.00 65.00 0.00 32.00 -33.00 0.00 33.00 32.00 32.00 32.00 0.00 32.00 -32.00 32.00 32.00 -64.00 96.00 32.00 0.00 0.00 32.00 65.00 -32.00 -33.00 -32.00 33.00 -64.00 0.00 -65.00 0.00 -32.00 64.00 0.00 -32.00 0.00 96.00 0.00 0.00 65.00 32.00 0.00 0.00 -33.00 0.00 -32.00 33.00 -32.00 64.00 0.00 -32.00 -32.00 -32.00 0.00 0.00 -64.00 -33.00 0.00 0.00 -32.00 33.00 0.00 32.00 -33.00 64.00 -32.00 -32.00 0.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 -65.00 32.00 0.00 33.00 -32.00 0.00 64.00 32.00 33.00 32.00 0.00 64.00 -65.00 0.00 65.00 129.00 -33.00 64.00 0.00 32.00 0.00 0.00 33.00 32.00 0.00 33.00 -33.00 32.00 -32.00 -32.00 -64.00 -65.00 0.00 0.00 -64.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 -96.00 -65.00 -32.00 -32.00 0.00 32.00 -65.00 65.00 -64.00 -65.00 -64.00 33.00 -32.00 -33.00 0.00 0.00 -33.00 -96.00 33.00 -32.00 -33.00 32.00 -32.00 0.00 -128.00 -32.00 0.00 0.00 32.00 -64.00 32.00 32.00 0.00 -32.00 64.00 32.00 32.00 -32.00 33.00 -33.00 -33.00 -32.00 -32.00 -32.00 0.00 -32.00 -96.00 -32.00 0.00 0.00 64.00 32.00 32.00 -64.00 -32.00 -65.00 97.00 -32.00 -33.00 32.00 -32.00 -128.00 0.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 -65.00 -33.00 97.00 -32.00 32.00 0.00 -32.00 0.00 -64.00 -32.00 -33.00 32.00 -64.00 -32.00 0.00 32.00 32.00 65.00 -32.00 0.00 -32.00 32.00 -32.00 0.00 -97.00 -65.00 -32.00 0.00 -32.00 33.00 32.00 32.00 32.00 32.00 -64.00 32.00 -32.00 -64.00 -32.00 -65.00 -32.00 0.00 -33.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -64.00 33.00 -65.00 -33.00 -32.00 33.00 -32.00 64.00 -32.00 32.00 -129.00 0.00 -32.00 0.00 -64.00 -32.00 -65.00 64.00 -64.00 -64.00 -64.00 0.00 0.00 -32.00 32.00 -65.00 32.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -65.00 32.00 -32.00 65.00 -32.00 0.00 64.00 96.00 33.00 64.00 -97.00 33.00 -32.00 -33.00 0.00 -96.00 -64.00 -97.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -32.00 0.00 -64.00 65.00 -32.00 32.00 -33.00 -32.00 -64.00 -129.00 0.00 -32.00 -96.00 64.00 32.00 32.00 32.00 0.00 0.00 32.00 -97.00 33.00 -64.00 -33.00 -32.00 0.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 0.00 32.00 97.00 -32.00 0.00 -32.00 32.00 0.00 -65.00 0.00 -128.00 -32.00 -32.00 -32.00 0.00 -33.00 32.00 -32.00 96.00 -32.00 0.00 -32.00 0.00 -32.00 -64.00 -129.00 0.00 -64.00 0.00 -32.00 -32.00 -65.00 -64.00 -64.00 0.00 -129.00 0.00 -96.00 -33.00 -32.00 0.00 -32.00 0.00 0.00 97.00 -32.00 0.00 -33.00 0.00 -32.00 -32.00 -64.00 -32.00 -64.00 -97.00 -65.00 -64.00 -32.00 0.00 -64.00 64.00 -64.00 0.00 -33.00 -64.00 33.00 -65.00 -97.00 -96.00 -96.00 -32.00 32.00 -97.00 -65.00 -96.00 -32.00 -32.00 -64.00 -32.00 0.00 -97.00 -32.00 0.00 -64.00 0.00 -161.00 -96.00 -32.00 0.00 0.00 -97.00 0.00 -96.00 -32.00 -32.00 0.00 -32.00 -33.00 -33.00 -32.00 65.00 -64.00 -32.00 0.00 -33.00 32.00 -64.00 -32.00 -96.00 32.00 -65.00 -32.00 0.00 0.00 -32.00 -129.00 32.00 0.00 -32.00 -64.00 -96.00 -32.00 0.00 -97.00 96.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 -97.00 -32.00 -64.00 -32.00 -32.00 -97.00 -32.00 32.00 -32.00 65.00 -32.00 32.00 -65.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 -64.00 -65.00 -161.00 -32.00 32.00 -32.00 -64.00 -64.00 32.00 -65.00 -32.00 -32.00 -65.00 0.00 -128.00 -64.00 -32.00 -64.00 -33.00 -32.00 -32.00 32.00 -32.00 96.00 -64.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 -32.00 0.00 -97.00 -97.00 -64.00 -64.00 -64.00 0.00 -65.00 0.00 -64.00 0.00 -32.00 -97.00 0.00 -32.00 -32.00 32.00 -97.00 -32.00 -32.00 -64.00 -32.00 -32.00 0.00 -97.00 32.00 -32.00 0.00 0.00 -32.00 -32.00 -97.00 0.00 -32.00 -96.00 0.00 -97.00 -64.00 -64.00 -64.00 -97.00 0.00 -64.00 -32.00 -32.00 32.00 -32.00 32.00 -32.00 -32.00 -33.00 -65.00 -96.00 -64.00 0.00 -64.00 -32.00 -65.00 -64.00 33.00 -97.00 -33.00 0.00 -64.00 32.00 -32.00 -32.00 -32.00 0.00 -64.00 0.00 -33.00 -32.00 0.00 -64.00 -32.00 -97.00 65.00 -64.00 -65.00 -64.00 -32.00 32.00 -128.00 0.00 -33.00 -65.00 -32.00 -64.00 32.00 -32.00 33.00 -32.00 32.00 -32.00 64.00 -65.00 0.00 0.00 -32.00 0.00 -64.00 -96.00 -97.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 0.00 -129.00 -32.00 0.00 -32.00 -64.00 -96.00 0.00 -129.00 32.00 -64.00 -32.00 0.00 32.00 -32.00 0.00 0.00 32.00 -33.00 64.00 -32.00 0.00 -32.00 -32.00 -32.00 -64.00 32.00 -129.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 0.00 -65.00 96.00 -64.00 0.00 -32.00 -32.00 64.00 -193.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 0.00 0.00 97.00 -33.00 32.00 -32.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -65.00 32.00 -64.00 0.00 -32.00 -64.00 -32.00 -65.00 0.00 -32.00 32.00 -32.00 96.00 -32.00 33.00 -32.00 0.00 -65.00 -65.00 -64.00 -32.00 0.00 -32.00 -161.00 32.00 -64.00 0.00 0.00 64.00 64.00 65.00 0.00 32.00 0.00 32.00 -32.00 0.00 -32.00 0.00 -96.00 -96.00 -65.00 32.00 -64.00 32.00 -32.00 -32.00 64.00 -161.00 0.00 -32.00 -64.00 0.00 -97.00 0.00 0.00 32.00 -32.00 32.00 32.00 97.00 0.00 32.00 -64.00 0.00 -64.00 -97.00 0.00 -160.00 -32.00 -33.00 -33.00 0.00 -64.00 33.00 -64.00 32.00 -64.00 0.00 -33.00 -32.00 129.00 -97.00 0.00 -32.00 0.00 -32.00 -96.00 -97.00 -97.00 0.00 -64.00 0.00 -65.00 -32.00 0.00 -32.00 0.00 -32.00 33.00 0.00 32.00 0.00 161.00 0.00 32.00 0.00 0.00 -65.00 -65.00 -32.00 -96.00 0.00 -64.00 32.00 -33.00 -32.00 -64.00 -32.00 0.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -65.00 -32.00 0.00 -96.00 65.00 -33.00 0.00 -32.00 0.00 -96.00 -32.00 -64.00 32.00 -65.00 0.00 -32.00 -32.00 0.00 -65.00 0.00 -64.00 0.00 -32.00 -64.00 -32.00 -32.00 32.00 -65.00 0.00 -64.00 32.00 -32.00 0.00 -32.00 0.00 32.00 -161.00 -32.00 -32.00 -32.00 0.00 -33.00 32.00 -64.00 65.00 -32.00 96.00 -32.00 64.00 -32.00 32.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 -96.00 -32.00 0.00 -129.00 -32.00 0.00 -32.00 65.00 -65.00 96.00 -32.00 32.00 -32.00 -96.00 -64.00 -32.00 32.00 -65.00 0.00 -96.00 0.00 -32.00 0.00 0.00 32.00 0.00 64.00 32.00 65.00 32.00 64.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -65.00 -64.00 -64.00 -32.00 -64.00 -65.00 -32.00 0.00 -65.00 65.00 -64.00 32.00 -32.00 -97.00 32.00 -128.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 0.00 32.00 33.00 128.00 -33.00 33.00 -32.00 0.00 -32.00 -33.00 -32.00 -32.00 -96.00 -96.00 0.00 -65.00 0.00 -32.00 32.00 -96.00 0.00 -32.00 -32.00 0.00 -33.00 0.00 -160.00 96.00 0.00 32.00 0.00 32.00 0.00 65.00 0.00 32.00 -97.00 0.00 -161.00 -32.00 -64.00 -97.00 -64.00 32.00 -32.00 0.00 -97.00 0.00 -32.00 33.00 -96.00 32.00 -33.00 32.00 -32.00 0.00 -64.00 -32.00 -64.00 -97.00 -32.00 0.00 -33.00 0.00 -32.00 32.00 0.00 97.00 -64.00 64.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 -97.00 -33.00 -64.00 -32.00 0.00 -32.00 32.00 -64.00 65.00 -32.00 32.00 0.00 -32.00 -65.00 -33.00 0.00 -32.00 32.00 -96.00 0.00 -32.00 -32.00 0.00 0.00 -33.00 -32.00 0.00 -64.00 0.00 -32.00 -32.00 -33.00 0.00 -64.00 0.00 -32.00 0.00 -64.00 32.00 -32.00 0.00 -33.00 0.00 0.00 -32.00 0.00 -128.00 -32.00 -32.00 -32.00 0.00 -128.00 64.00 0.00 32.00 -65.00 32.00 -96.00 32.00 -32.00 0.00 -33.00 -32.00 0.00 -128.00 -96.00 -33.00 -32.00 0.00 -32.00 97.00 0.00 161.00 -32.00 32.00 -65.00 -32.00 -32.00 -33.00 -32.00 0.00 0.00 -96.00 32.00 -32.00 64.00 -97.00 0.00 -64.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -129.00 96.00 -32.00 0.00 -32.00 -32.00 0.00 -96.00 96.00 -129.00 33.00 -64.00 -33.00 -32.00 -32.00 0.00 -96.00 0.00 -32.00 0.00 -97.00 96.00 0.00 32.00 0.00 32.00 32.00 97.00 0.00 32.00 0.00 64.00 -193.00 65.00 -96.00 32.00 -32.00 0.00 0.00 -32.00 -64.00 -129.00 -33.00 -32.00 -32.00 32.00 -32.00 0.00 0.00 32.00 -32.00 161.00 -32.00 32.00 -65.00 0.00 -160.00 -96.00 -32.00 0.00 -65.00 32.00 -193.00 96.00 -64.00 97.00 -32.00 0.00 -32.00 0.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 96.00 -161.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -33.00 -96.00 0.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 -64.00 -32.00 -32.00 -33.00 32.00 -32.00 0.00 -64.00 64.00 -32.00 97.00 -32.00 64.00 -225.00 64.00 -65.00 -32.00 -32.00 -64.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 0.00 64.00 0.00 32.00 0.00 32.00 64.00 65.00 0.00 32.00 0.00 64.00 0.00 32.00 -64.00 0.00 -33.00 0.00 -64.00 -32.00 -96.00 -96.00 -32.00 0.00 -65.00 0.00 -128.00 64.00 -33.00 0.00 -64.00 0.00 -32.00 0.00 -64.00 161.00 -33.00 0.00 -32.00 -32.00 0.00 -97.00 0.00 -64.00 -32.00 -32.00 0.00 -32.00 -64.00 -33.00 -32.00 0.00 -65.00 0.00 -32.00 33.00 -64.00 32.00 -32.00 32.00 -32.00 0.00 -65.00 32.00 -64.00 0.00 -64.00 -161.00 -65.00 -32.00 -128.00 97.00 -32.00 32.00 -33.00 0.00 -32.00 0.00 -32.00 -32.00zm24919.00 1607.00l0.00 -32.00 0.00 32.00zm0.00 997.00l0.00 -32.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -33.00 0.00 -32.00 64.00 -96.00 65.00 -32.00 96.00 32.00 -32.00 -161.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 -64.00 -32.00 0.00 -33.00 64.00 -32.00 33.00 -32.00 32.00 -32.00 96.00 32.00 0.00 -32.00 -32.00 -32.00 32.00 -32.00 32.00 -33.00 -64.00 -32.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 64.00 -32.00 0.00 -32.00 -32.00 -33.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -64.00 32.00 -32.00 32.00 0.00 0.00 -32.00 32.00 0.00 0.00 -65.00 -96.00 0.00 -33.00 32.00 33.00 -32.00 64.00 -32.00 32.00 -64.00 96.00 32.00 97.00 0.00 32.00 -32.00 129.00 -32.00 96.00 -33.00 0.00 -64.00 -32.00 -32.00 32.00 64.00 -32.00 -96.00 0.00 -32.00 32.00 32.00 32.00 -32.00 33.00 -33.00 0.00 33.00 0.00 96.00 32.00 0.00 32.00 97.00 32.00 64.00 96.00 32.00 33.00 -64.00 32.00 32.00 0.00 32.00 -65.00 32.00 0.00 65.00 0.00 96.00 -96.00 32.00 -96.00 161.00 -65.00 96.00 0.00 97.00 0.00 32.00 0.00 32.00 32.00 -32.00 33.00 0.00 -33.00 64.00 0.00 32.00 -32.00 33.00 -32.00 64.00 0.00 32.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -97.00 97.00 -32.00 64.00 -32.00 129.00 -97.00 128.00 0.00 32.00 -32.00 65.00 0.00 64.00 32.00 0.00 0.00 32.00 33.00 0.00 32.00 0.00 0.00 32.00 64.00 0.00 0.00 33.00 -32.00 0.00 -32.00 32.00 0.00 32.00 32.00 0.00 -32.00 32.00 -65.00 32.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -64.00 32.00 -32.00 32.00 -32.00 129.00 0.00 32.00 -97.00 64.00 0.00 -32.00 -32.00 0.00 32.00 -64.00 32.00 -32.00 -64.00 -65.00 32.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -33.00 64.00 0.00 32.00 -64.00 32.00 -32.00 -32.00 -129.00 64.00 -96.00 -32.00 0.00 -32.00 0.00 0.00 32.00 -32.00 0.00zm32.00 -1093.00l-32.00 0.00 32.00 0.00 0.00 -32.00 0.00 32.00 0.00 32.00 0.00 -32.00z"},pb:{name:"PB",path:"M172553.00 61123.00l32.00 -32.00 129.00 -32.00 0.00 -33.00 32.00 0.00 65.00 0.00 0.00 -64.00 64.00 0.00 64.00 -32.00 32.00 -32.00 0.00 -32.00 33.00 -32.00 0.00 -33.00 -33.00 -32.00 65.00 -64.00 32.00 -32.00 32.00 -32.00 64.00 -33.00 0.00 -32.00 -32.00 -32.00 64.00 0.00 65.00 32.00 0.00 -64.00 -65.00 -32.00 -32.00 -65.00 -64.00 0.00 0.00 -32.00 0.00 -32.00 -32.00 -32.00 0.00 -64.00 -32.00 -32.00 -32.00 -97.00 0.00 -32.00 32.00 -96.00 32.00 0.00 -32.00 0.00 64.00 -33.00 32.00 -32.00 0.00 -64.00 -64.00 -32.00 0.00 -65.00 32.00 -32.00 32.00 -32.00 64.00 -64.00 0.00 -64.00 -64.00 -65.00 64.00 -32.00 0.00 -32.00 33.00 -32.00 0.00 -32.00 64.00 -97.00 -32.00 -32.00 32.00 -64.00 64.00 -65.00 129.00 -128.00 0.00 -97.00 64.00 -32.00 0.00 -32.00 0.00 -32.00 161.00 -129.00 32.00 0.00 -64.00 -64.00 -65.00 32.00 -32.00 0.00 -128.00 0.00 -33.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 32.00 0.00 32.00 -32.00 0.00 -33.00 65.00 0.00 0.00 -64.00 32.00 0.00 32.00 -32.00 96.00 0.00 -32.00 -32.00 32.00 -32.00 33.00 0.00 64.00 32.00 32.00 0.00 32.00 32.00 65.00 -64.00 32.00 0.00 64.00 -32.00 64.00 -33.00 -64.00 97.00 -64.00 96.00 32.00 65.00 -32.00 96.00 96.00 -32.00 64.00 0.00 33.00 32.00 96.00 64.00 96.00 -32.00 33.00 0.00 32.00 32.00 32.00 33.00 32.00 64.00 32.00 32.00 0.00 64.00 32.00 0.00 33.00 33.00 32.00 0.00 32.00 0.00 32.00 0.00 32.00 0.00 65.00 64.00 32.00 64.00 96.00 0.00 0.00 97.00 161.00 -97.00 32.00 0.00 64.00 -32.00 32.00 32.00 129.00 0.00 64.00 64.00 129.00 0.00 64.00 -32.00 65.00 129.00 64.00 0.00 32.00 0.00 64.00 -64.00 33.00 -65.00 64.00 -32.00 32.00 -96.00 32.00 -32.00 32.00 0.00 0.00 -33.00 32.00 0.00 0.00 -64.00 33.00 0.00 0.00 64.00 64.00 33.00 -32.00 64.00 32.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 -32.00 -97.00 65.00 -64.00 -33.00 -32.00 161.00 0.00 32.00 -32.00 32.00 -65.00 33.00 -32.00 0.00 32.00 64.00 65.00 64.00 0.00 65.00 -33.00 64.00 -64.00 64.00 0.00 32.00 -32.00 -32.00 -32.00 0.00 -129.00 129.00 64.00 32.00 -32.00 64.00 -32.00 0.00 -32.00 32.00 -64.00 -32.00 -32.00 32.00 -65.00 65.00 -32.00 32.00 0.00 -32.00 -32.00 64.00 -96.00 64.00 0.00 97.00 0.00 96.00 0.00 -32.00 0.00 -32.00 -65.00 0.00 -64.00 32.00 -32.00 -64.00 -65.00 64.00 -32.00 -64.00 -32.00 64.00 -64.00 32.00 0.00 0.00 -65.00 32.00 -32.00 161.00 -96.00 32.00 0.00 32.00 32.00 97.00 32.00 161.00 0.00 32.00 -64.00 96.00 0.00 97.00 0.00 64.00 -64.00 64.00 -33.00 65.00 33.00 96.00 0.00 0.00 -65.00 64.00 0.00 97.00 0.00 0.00 -32.00 64.00 0.00 32.00 32.00 129.00 -32.00 0.00 -128.00 32.00 -33.00 97.00 0.00 96.00 0.00 64.00 0.00 65.00 -128.00 32.00 0.00 96.00 0.00 97.00 -97.00 128.00 -32.00 32.00 -32.00 65.00 32.00 64.00 0.00 32.00 -64.00 32.00 -64.00 33.00 -33.00 32.00 0.00 64.00 33.00 32.00 64.00 97.00 -32.00 64.00 32.00 96.00 0.00 -32.00 32.00 32.00 161.00 0.00 64.00 32.00 64.00 -64.00 161.00 64.00 32.00 33.00 0.00 -33.00 97.00 -32.00 32.00 -96.00 32.00 0.00 64.00 -64.00 32.00 -97.00 33.00 -32.00 32.00 -32.00 0.00 -64.00 64.00 -97.00 97.00 0.00 160.00 -64.00 0.00 -97.00 -32.00 -64.00 32.00 -32.00 97.00 -32.00 32.00 -129.00 64.00 -32.00 0.00 -32.00 97.00 0.00 128.00 -65.00 65.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 64.00 32.00 65.00 33.00 32.00 -33.00 96.00 -32.00 290.00 -96.00 96.00 -97.00 0.00 -32.00 0.00 -96.00 0.00 -32.00 0.00 -65.00 97.00 0.00 32.00 32.00 32.00 -32.00 129.00 0.00 64.00 32.00 0.00 0.00 64.00 0.00 129.00 33.00 64.00 -33.00 64.00 33.00 33.00 -65.00 160.00 354.00 -64.00 64.00 0.00 258.00 32.00 128.00 -64.00 129.00 32.00 -32.00 64.00 64.00 65.00 64.00 32.00 0.00 128.00 -32.00 65.00 64.00 64.00 0.00 32.00 33.00 32.00 0.00 65.00 96.00 64.00 193.00 0.00 193.00 -129.00 96.00 -128.00 32.00 0.00 226.00 -65.00 64.00 -32.00 96.00 -32.00 32.00 -32.00 161.00 -129.00 64.00 0.00 33.00 65.00 32.00 96.00 0.00 64.00 32.00 65.00 0.00 32.00 64.00 0.00 -32.00 32.00 0.00 32.00 97.00 -96.00 128.00 -65.00 32.00 0.00 161.00 -64.00 161.00 -64.00 321.00 289.00 0.00 257.00 193.00 -32.00 -64.00 225.00 -64.00 97.00 0.00 64.00 -32.00 96.00 96.00 161.00 129.00 65.00 32.00 0.00 96.00 -258.00 161.00 0.00 96.00 32.00 97.00 0.00 32.00 0.00 193.00 -289.00 0.00 -32.00 -32.00 -64.00 32.00 -32.00 32.00 -33.00 65.00 0.00 64.00 -64.00 96.00 -32.00 32.00 -32.00 33.00 -193.00 -33.00 -97.00 -32.00 -32.00 -32.00 -32.00 -32.00 0.00 0.00 -32.00 -32.00 0.00 -64.00 -32.00 -65.00 -97.00 65.00 -64.00 32.00 -225.00 96.00 -193.00 -32.00 -64.00 64.00 -32.00 32.00 32.00 161.00 64.00 64.00 96.00 33.00 -32.00 64.00 32.00 0.00 -32.00 -32.00 -128.00 0.00 -193.00 -32.00 -32.00 -33.00 0.00 -64.00 -33.00 -32.00 -32.00 -32.00 -96.00 -64.00 -32.00 -97.00 -65.00 -32.00 0.00 0.00 -96.00 -32.00 -96.00 0.00 -65.00 32.00 -64.00 96.00 -161.00 0.00 -64.00 33.00 -161.00 192.00 32.00 129.00 0.00 161.00 -321.00 161.00 64.00 96.00 -32.00 161.00 -97.00 64.00 65.00 64.00 64.00 0.00 32.00 0.00 161.00 -64.00 96.00 0.00 32.00 0.00 33.00 0.00 64.00 32.00 0.00 97.00 32.00 64.00 32.00 32.00 161.00 129.00 -32.00 32.00 0.00 193.00 0.00 129.00 -32.00 64.00 0.00 32.00 0.00 64.00 0.00 32.00 -32.00 33.00 0.00 64.00 -33.00 32.00 -32.00 32.00 0.00 0.00 32.00 32.00 0.00 0.00 -32.00 65.00 129.00 64.00 64.00 129.00 32.00 0.00 65.00 0.00 32.00 32.00 32.00 128.00 32.00 65.00 0.00 96.00 32.00 418.00 -32.00 354.00 0.00 32.00 -32.00 225.00 -32.00 32.00 0.00 32.00 0.00 32.00 -32.00 97.00 -97.00 64.00 32.00 32.00 0.00 0.00 -32.00 33.00 0.00 96.00 32.00 64.00 33.00 32.00 0.00 65.00 0.00 64.00 64.00 0.00 32.00 32.00 32.00 97.00 0.00 0.00 32.00 32.00 0.00 32.00 -64.00 32.00 0.00 32.00 0.00 32.00 0.00 0.00 -32.00 33.00 32.00 32.00 0.00 64.00 0.00 32.00 32.00 0.00 -32.00 32.00 32.00 33.00 0.00 32.00 0.00 32.00 -32.00 32.00 0.00 64.00 32.00 32.00 -32.00 0.00 32.00 65.00 0.00 96.00 32.00 32.00 0.00 97.00 65.00 64.00 32.00 97.00 128.00 64.00 32.00 257.00 0.00 97.00 -64.00 128.00 0.00 32.00 -64.00 32.00 0.00 33.00 96.00 32.00 65.00 32.00 0.00 129.00 32.00 64.00 -32.00 32.00 0.00 64.00 -97.00 65.00 0.00 32.00 -128.00 32.00 0.00 32.00 -33.00 32.00 0.00 129.00 129.00 32.00 0.00 96.00 -32.00 65.00 -64.00 32.00 0.00 32.00 0.00 97.00 -33.00 64.00 -32.00 32.00 -32.00 32.00 32.00 0.00 547.00 0.00 161.00 65.00 160.00 32.00 65.00 64.00 32.00 -32.00 32.00 0.00 64.00 32.00 65.00 -32.00 32.00 32.00 32.00 -32.00 96.00 32.00 0.00 0.00 65.00 -32.00 0.00 64.00 0.00 32.00 0.00 0.00 96.00 0.00 161.00 65.00 161.00 0.00 64.00 96.00 96.00 64.00 33.00 65.00 32.00 -33.00 64.00 -32.00 64.00 0.00 32.00 32.00 97.00 65.00 64.00 -32.00 32.00 -65.00 33.00 32.00 0.00 0.00 32.00 33.00 0.00 0.00 -32.00 32.00 0.00 0.00 32.00 0.00 64.00 0.00 32.00 -32.00 0.00 0.00 32.00 -33.00 0.00 0.00 -32.00 -32.00 -32.00 0.00 32.00 32.00 97.00 33.00 0.00 32.00 -65.00 64.00 -64.00 0.00 -96.00 -32.00 -65.00 64.00 0.00 0.00 193.00 0.00 129.00 -64.00 32.00 0.00 64.00 32.00 65.00 32.00 32.00 -32.00 128.00 64.00 65.00 0.00 96.00 65.00 64.00 64.00 0.00 0.00 33.00 0.00 225.00 -32.00 64.00 -32.00 129.00 32.00 128.00 0.00 97.00 0.00 64.00 32.00 32.00 -32.00 64.00 32.00 65.00 -32.00 128.00 32.00 65.00 -32.00 64.00 -32.00 96.00 0.00 290.00 0.00 32.00 32.00 32.00 -32.00 32.00 -32.00 32.00 32.00 129.00 -65.00 64.00 -32.00 97.00 -32.00 0.00 -32.00 0.00 -64.00 -32.00 -65.00 32.00 -96.00 -65.00 -32.00 65.00 -32.00 0.00 0.00 -32.00 -33.00 0.00 -32.00 0.00 -32.00 -33.00 -32.00 -32.00 -96.00 65.00 -33.00 0.00 -64.00 -97.00 -64.00 -64.00 0.00 -32.00 -32.00 -65.00 32.00 -64.00 0.00 -64.00 -97.00 -65.00 -128.00 -96.00 -65.00 -64.00 -96.00 -65.00 -32.00 -32.00 -32.00 0.00 -33.00 32.00 -64.00 33.00 -96.00 -33.00 -32.00 0.00 -97.00 -32.00 -32.00 0.00 -64.00 -32.00 -65.00 32.00 -32.00 0.00 -64.00 -32.00 -129.00 -32.00 -64.00 -32.00 -193.00 64.00 -96.00 97.00 -33.00 0.00 -32.00 0.00 -32.00 0.00 -64.00 0.00 32.00 32.00 0.00 32.00 -64.00 0.00 -33.00 0.00 0.00 64.00 0.00 32.00 -64.00 0.00 -32.00 0.00 -32.00 32.00 -129.00 65.00 -32.00 64.00 -32.00 0.00 -64.00 -32.00 -33.00 -64.00 -64.00 0.00 -128.00 -33.00 -97.00 33.00 -32.00 160.00 0.00 65.00 32.00 64.00 -32.00 32.00 -32.00 32.00 -32.00 32.00 0.00 97.00 -33.00 96.00 -32.00 33.00 0.00 32.00 32.00 32.00 65.00 -32.00 -32.00 64.00 0.00 32.00 -33.00 0.00 -32.00 64.00 97.00 129.00 -65.00 0.00 -32.00 32.00 -128.00 32.00 -65.00 -32.00 -64.00 0.00 -32.00 0.00 -64.00 0.00 -33.00 32.00 0.00 33.00 -64.00 64.00 -32.00 32.00 -64.00 64.00 -32.00 0.00 -97.00 0.00 -32.00 0.00 -32.00 0.00 -32.00 -32.00 -65.00 32.00 0.00 32.00 -32.00 0.00 -96.00 33.00 -32.00 0.00 0.00 32.00 -33.00 32.00 -32.00 0.00 -96.00 64.00 -65.00 0.00 -96.00 65.00 -32.00 0.00 -32.00 0.00 -65.00 -33.00 -96.00 33.00 -64.00 0.00 -33.00 32.00 0.00 32.00 0.00 64.00 -96.00 64.00 -161.00 -32.00 -32.00 32.00 -64.00 0.00 -64.00 0.00 -65.00 65.00 -32.00 0.00 -32.00 64.00 -32.00 -32.00 -97.00 0.00 -64.00 -64.00 -32.00 0.00 -32.00 32.00 -97.00 -97.00 -161.00 -32.00 -64.00 32.00 -32.00 0.00 -96.00 0.00 -161.00 0.00 -97.00 32.00 -32.00 -96.00 -32.00 -32.00 -161.00 128.00 -32.00 33.00 0.00 32.00 64.00 32.00 0.00 32.00 -32.00 64.00 -64.00 0.00 -32.00 0.00 -97.00 -64.00 -32.00 -32.00 -32.00 0.00 -257.00 0.00 -32.00 -32.00 -65.00 32.00 -96.00 0.00 -64.00 32.00 -65.00 0.00 -32.00 32.00 0.00 65.00 0.00 160.00 -32.00 32.00 32.00 33.00 0.00 64.00 -32.00 0.00 -32.00 64.00 0.00 32.00 -97.00 0.00 -64.00 33.00 -32.00 -33.00 -64.00 33.00 -193.00 -97.00 -65.00 -32.00 -64.00 32.00 -32.00 32.00 -32.00 32.00 32.00 97.00 -32.00 64.00 32.00 32.00 -32.00 32.00 -32.00 -32.00 -129.00 -32.00 -32.00 97.00 0.00 64.00 -32.00 32.00 0.00 129.00 0.00 193.00 -97.00 64.00 -32.00 32.00 0.00 32.00 32.00 0.00 0.00 64.00 64.00 0.00 33.00 33.00 0.00 64.00 -65.00 32.00 -128.00 32.00 -97.00 32.00 -32.00 33.00 32.00 96.00 -96.00 0.00 -64.00 -32.00 0.00 32.00 32.00 32.00 -32.00 0.00 0.00 32.00 -97.00 0.00 -32.00 33.00 -32.00 64.00 -32.00 32.00 -65.00 -32.00 -64.00 0.00 -64.00 0.00 -33.00 64.00 -225.00 97.00 -96.00 64.00 -96.00 0.00 -33.00 64.00 -96.00 97.00 -97.00 32.00 0.00 64.00 -32.00 32.00 -32.00 0.00 -96.00 0.00 -65.00 32.00 -128.00 -64.00 -97.00 -129.00 -32.00 0.00 -193.00 -32.00 -32.00 -96.00 -129.00 -129.00 0.00 -64.00 0.00 -64.00 0.00 -65.00 -96.00 33.00 -64.00 -33.00 -33.00 -32.00 0.00 -32.00 65.00 -32.00 -32.00 -64.00 32.00 -65.00 32.00 0.00 0.00 -32.00 -32.00 -96.00 32.00 -65.00 -64.00 -96.00 0.00 -64.00 32.00 -97.00 0.00 -64.00 0.00 -64.00 -32.00 -33.00 -33.00 -32.00 -64.00 0.00 0.00 -32.00 -32.00 0.00 -32.00 -32.00 0.00 -97.00 -64.00 -32.00 -65.00 32.00 0.00 65.00 -64.00 0.00 0.00 -32.00 -32.00 32.00 -32.00 -32.00 -97.00 0.00 -64.00 32.00 -64.00 -32.00 -65.00 0.00 -64.00 0.00 -96.00 64.00 0.00 -32.00 -65.00 0.00 32.00 -97.00 0.00 -32.00 33.00 0.00 96.00 -32.00 32.00 -32.00 32.00 0.00 0.00 -32.00 -32.00 -32.00 32.00 -33.00 -32.00 0.00 -32.00 0.00 0.00 -32.00 64.00 0.00 0.00 -32.00 97.00 0.00 193.00 -129.00 0.00 -64.00 -32.00 -32.00 32.00 -32.00 96.00 -32.00 0.00 -97.00 -64.00 0.00 -32.00 -32.00 64.00 -32.00 32.00 -32.00 32.00 32.00 97.00 -64.00 32.00 -33.00 32.00 0.00 32.00 33.00 32.00 32.00 0.00 -32.00 32.00 -33.00 33.00 0.00 32.00 -64.00 -32.00 0.00 0.00 -32.00 96.00 -129.00 -64.00 -64.00 0.00 -96.00 -65.00 -65.00 -32.00 -32.00 -32.00 -64.00 0.00 -32.00 -32.00 -32.00 -64.00 -65.00 0.00 -64.00 0.00 -32.00 0.00 -32.00 64.00 -33.00 32.00 -96.00 32.00 -96.00 65.00 -65.00 96.00 -64.00 64.00 -97.00 97.00 0.00 64.00 -64.00 97.00 0.00 64.00 -64.00 129.00 -32.00 0.00 -32.00 96.00 -33.00 32.00 33.00 64.00 -65.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 0.00 -32.00 -64.00 -32.00 -32.00 -33.00 -32.00 -64.00 32.00 -32.00 0.00 -32.00 -64.00 0.00 64.00 -97.00 -64.00 -64.00 -97.00 -64.00 -32.00 0.00 0.00 32.00 -64.00 0.00 -32.00 -64.00 0.00 -32.00 -65.00 -33.00 -96.00 0.00 -65.00 -32.00 -32.00 -32.00 -32.00 32.00 -32.00 -64.00 -64.00 0.00 -33.00 0.00 -32.00 -64.00 -32.00 -65.00 -96.00 -64.00 -65.00 -32.00 -96.00 -65.00 -96.00 0.00 -33.00 0.00 -96.00 0.00 -32.00 65.00 -97.00 0.00 -32.00 0.00 -96.00 0.00 -65.00 96.00 -32.00 65.00 32.00 64.00 -193.00 96.00 -96.00 0.00 -32.00 33.00 -64.00 -33.00 -33.00 0.00 -32.00 33.00 -128.00 -33.00 -97.00 33.00 -32.00 32.00 32.00 64.00 0.00 64.00 -32.00 32.00 -32.00 97.00 -32.00 0.00 -32.00 32.00 0.00 32.00 -33.00 32.00 -32.00 32.00 0.00 97.00 0.00 32.00 -96.00 32.00 -97.00 32.00 -96.00 65.00 -97.00 32.00 0.00 64.00 -32.00 32.00 -64.00 32.00 -64.00 -32.00 -33.00 32.00 -32.00 -64.00 -96.00 64.00 0.00 65.00 -129.00 32.00 0.00 32.00 0.00 64.00 -64.00 33.00 -32.00 0.00 -32.00 96.00 -33.00 0.00 -32.00 64.00 -32.00 32.00 0.00 33.00 -32.00 32.00 64.00 32.00 32.00 32.00 0.00 64.00 -64.00 33.00 0.00 32.00 -64.00 -65.00 0.00 -64.00 -32.00 0.00 0.00 -64.00 -32.00 -32.00 -33.00 0.00 -32.00 0.00 -64.00 96.00 -161.00 0.00 -64.00 32.00 -32.00 32.00 -97.00 129.00 -64.00 32.00 -32.00 32.00 32.00 32.00 32.00 33.00 -32.00 0.00 -64.00 0.00 -65.00 0.00 0.00 96.00 -96.00 64.00 0.00 65.00 -64.00 32.00 -33.00 32.00 -32.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 0.00 -32.00 0.00 0.00 -64.00 -65.00 -32.00 -96.00 -32.00 -129.00 96.00 -32.00 32.00 0.00 64.00 0.00 65.00 32.00 64.00 0.00 32.00 -32.00 32.00 -193.00 -32.00 -32.00 -32.00 0.00 -32.00 -32.00 -32.00 -32.00 -32.00 -33.00 -65.00 -32.00 0.00 -64.00 -32.00 -64.00 64.00 -97.00 65.00 -64.00 32.00 -32.00 32.00 -32.00 32.00 -65.00 0.00 0.00 32.00 -96.00 0.00 -32.00 0.00 -65.00 33.00 -32.00 -33.00 -64.00 -64.00 -32.00 -129.00 32.00 -64.00 -32.00 -32.00 32.00 -32.00 -96.00 0.00 64.00 -97.00 -32.00 -32.00 -32.00 -32.00 32.00 -64.00 -32.00 0.00 0.00 -32.00 0.00 -65.00 -33.00 -32.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -64.00 -96.00 -33.00 32.00 -32.00 32.00 0.00 32.00 -32.00 32.00 -129.00 33.00 33.00 32.00 -33.00 64.00 -32.00 0.00 -64.00 0.00 -32.00 -64.00 -97.00 0.00 -64.00 64.00 -96.00 0.00 -32.00 32.00 0.00 65.00 -97.00 0.00 -64.00 32.00 -65.00 -32.00 -96.00 32.00 -32.00 -32.00 -32.00 32.00 0.00 -65.00 -33.00 65.00 -64.00 0.00 0.00 -65.00 -64.00 -32.00 0.00 -64.00 -32.00 -64.00 -32.00 0.00 0.00 -97.00 -97.00 -32.00 0.00 -32.00 -32.00 0.00 0.00 -32.00 -64.00 -65.00 -32.00 0.00 -65.00 -128.00 -64.00 0.00 -32.00 -65.00 -65.00 0.00 0.00 -32.00 33.00 -32.00 0.00 -96.00 32.00 -32.00 96.00 0.00 32.00 -33.00 97.00 -32.00 0.00 -32.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -65.00 -32.00 -32.00 64.00 0.00 -32.00 -32.00 32.00 -64.00 64.00 -65.00 -32.00 -64.00 -32.00 -32.00 0.00 -32.00 193.00 -32.00 0.00 -33.00 32.00 -32.00 0.00 -32.00 64.00 0.00 0.00 -96.00 -64.00 0.00 32.00 -65.00 32.00 -32.00 33.00 -96.00 64.00 -97.00 64.00 -64.00 0.00 -32.00 0.00 -32.00 0.00 -65.00 32.00 -32.00 33.00 -64.00 -33.00 -97.00 0.00 -64.00 -32.00 0.00 -32.00 -64.00 32.00 -32.00 -32.00 -32.00 -129.00 64.00 -64.00 -32.00 -32.00 -32.00 -64.00 -33.00 0.00 -64.00 -32.00 -32.00 32.00 -64.00 -32.00 -32.00 -65.00 0.00 -32.00 -33.00 -96.00 0.00 -97.00 33.00 0.00 -65.00 32.00 -32.00 -32.00 -32.00 32.00 -32.00 0.00 -129.00 33.00 -32.00 32.00 -64.00 32.00 -97.00 0.00 -32.00 -32.00 -32.00 -32.00 -32.00 -33.00 -32.00 33.00 -65.00 0.00 -32.00 -97.00 -32.00 0.00 -64.00 -96.00 -32.00 -33.00 0.00 -64.00 -33.00 -96.00 -64.00 -33.00 0.00 -32.00 -32.00 32.00 -32.00 33.00 0.00 32.00 -65.00 32.00 0.00 -32.00 -32.00 0.00 -32.00 -65.00 0.00 -32.00 -64.00 65.00 -32.00 -33.00 -65.00 0.00 -64.00 -32.00 -32.00z"}}})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","ca_lcc",{insets:[{width:900,top:0,height:867.2308867877658,bbox:[{y:-10408206.406521406,x:-2874590.5560752787},{y:-4979679.615160914,x:2759058.0911967778}],left:0}],paths:{"CA-NT":{path:"M340.43,125.99l5.05,-2.26l0.92,-0.14l1.84,0.57l2.33,-0.98l0.54,-0.9l1.17,-1.01l2.46,-0.96l1.23,0.01l1.01,1.79l0.53,0.4l-1.93,8.61l-1.55,0.59l-2.09,-1.15l-0.06,-0.73l-1.16,-1.56l-1.32,0.13l-0.23,1.13l-0.75,0.07l-0.24,1.09l-1.34,-0.24l-0.23,-1.68l-1.46,-1.53l-3.25,0.54l-0.46,0.38l-1.74,0.41l-0.1,-1.27l0.65,-0.58l0.17,-0.74ZM104.46,307.55l0.14,-0.94l0.91,-1.34l0.08,-0.7l1.08,-0.38l1.14,-1.29l0.69,-1.67l-0.23,-0.84l1.2,-1.51l0.56,-2.12l-0.07,-0.85l-0.74,-0.92l0.49,-1.16l11.83,-21.1l1.9,1.44l0.78,1.18l0.44,2.04l1.02,1.11l0.02,1.76l1.01,0.5l0.65,0.95l0.67,-0.55l-0.52,-1.74l0.25,-1.06l-0.44,-1.05l1.06,0.36l0.07,-0.5l-1.28,-1.24l0.06,-1.24l-1.48,-0.63l-0.42,-0.86l0.56,-0.17l0.07,-1.17l0.48,1.3l0.75,0.48l1.01,0.1l1.05,-0.56l-0.29,-0.39l-0.98,-0.28l0.02,-0.91l-0.75,-1.17l0.91,-2.19l0.82,3.03l1.3,1.4l0.43,-0.74l-0.92,-1.52l-0.27,-2.64l0.29,-0.58l0.65,0.02l-0.28,2.19l0.81,0.07l0.59,-1.89l0.54,0.43l0.23,1.25l1.1,1.25l0.63,-0.49l-0.11,-0.99l0.85,-2.21l1.62,-0.07l0.43,0.47l0.75,0.05l1.3,0.93l0.72,1.27l0.44,0.09l0.73,-0.37l0.45,-0.82l-0.22,-0.8l1.83,-2.02l0.7,0.3l-0.05,0.59l-1.04,0.83l0.39,1.34l1.04,1.47l0.86,0.25l-2.7,1.23l-1.24,1.17l-1.1,0.22l-1.67,1.68l-0.26,0.8l0.9,0.19l1.58,-1.41l2.09,0.22l0.77,-0.72l1.23,0.52l0.71,-0.84l1.16,0.21l1.48,1.15l1.16,-0.3l0.26,0.24l1.67,-1.31l0.74,-1.04l0.08,-0.68l0.93,-0.64l0.18,0.58l0.47,0.3l0.66,-0.09l0.71,0.91l1.31,0.19l0.55,-0.26l0.39,-0.67l0.78,0.93l0.89,-0.58l2.37,-0.04l1.07,-0.91l1.14,-0.33l1.48,0.09l0.6,-0.85l0.47,0.33l0.04,0.46l-0.7,1.79l0.73,0.45l0.61,-0.9l0.73,-0.09l1.56,-1.89l0.67,-0.18l0.03,-0.74l1.1,-0.2l0.29,0.66l0.93,-0.19l0.39,-0.56l0.33,0.91l1.18,-0.31l-0.38,1.09l0.76,0.43l-0.12,0.41l0.54,0.43l0.58,-0.35l1.12,0.71l1.2,-0.6l1.31,-1.78l0.48,-0.01l-0.43,1.39l0.64,0.69l-0.36,0.67l0.25,0.54l-0.99,0.13l-0.14,0.6l-0.58,0.26l-4.41,0.77l-1.71,-0.24l-0.99,0.6l-1.08,0.04l-1.03,1.21l-1.62,-0.04l-1.6,1.4l-0.18,-0.34l0.28,-0.83l-0.34,-0.45l-1.04,-0.22l-0.59,0.3l-0.57,-0.27l-0.48,0.2l-2.83,-0.93l-1.21,0.17l-0.7,-0.27l-2.29,1.84l-0.29,1.06l-2.52,0.0l-0.5,0.34l-0.53,-0.63l-1.66,0.06l-1.27,0.73l-0.17,0.49l-1.1,0.9l-0.12,0.66l-0.76,0.22l-0.47,-0.62l-1.16,0.22l-1.4,1.59l-0.26,0.73l-0.29,0.05l-0.26,-0.55l-1.06,0.01l-0.96,1.13l-0.25,1.27l0.56,1.44l1.19,1.93l1.0,0.53l0.66,-0.08l0.11,-0.38l-0.23,-0.69l-1.04,-0.58l0.38,-0.94l0.7,0.04l0.57,0.64l0.56,-0.31l0.06,-0.47l0.4,1.43l0.52,0.32l0.5,-0.48l0.99,1.02l1.61,-0.85l0.13,-0.44l-0.58,-1.64l-0.52,-0.17l-1.0,0.36l-0.35,-0.72l0.45,0.44l0.68,-0.28l-0.6,-1.73l0.72,-1.38l1.23,0.44l1.05,-0.46l0.45,0.71l0.75,-0.18l0.71,-0.64l0.65,0.9l1.17,-1.23l1.44,0.08l1.83,-0.69l1.41,-1.24l0.1,-0.41l0.78,-0.23l0.04,-0.44l0.67,0.77l-1.27,1.34l-0.23,0.67l0.81,0.22l-0.39,0.95l0.99,-0.0l1.07,-0.65l0.41,0.07l0.21,0.13l-0.46,0.86l0.88,0.61l-1.32,1.5l-0.51,1.19l0.07,0.7l0.58,0.3l0.61,-0.28l1.03,-2.43l1.66,-0.94l0.16,-0.62l1.48,-0.47l0.48,-0.61l-0.1,-0.43l2.35,-1.13l0.49,-0.85l1.42,-0.99l1.05,0.28l3.79,-0.03l1.01,-0.38l2.58,0.65l-1.07,2.79l1.07,1.23l0.82,0.1l0.27,-1.09l1.23,0.05l2.37,-1.56l2.78,-0.96l1.22,-3.31l1.85,-0.43l0.55,0.37l1.09,-0.16l2.12,0.3l0.7,0.51l0.27,-0.41l-0.24,-0.91l-2.64,-2.29l0.11,-0.52l0.3,0.3l0.53,-0.08l0.77,-1.23l-0.54,-0.44l-1.31,-0.01l1.01,-1.83l1.46,-1.04l1.82,4.77l0.72,3.82l-0.37,5.36l0.33,0.97l-0.74,1.57l-0.33,3.92l1.05,5.2l1.21,3.11l0.72,1.01l0.88,0.26l1.06,2.07l0.85,0.12l0.6,-0.52l0.05,-0.65l1.59,0.69l1.22,-1.47l-0.31,-0.47l0.38,-0.46l-0.67,-1.16l0.72,-1.05l-0.85,-0.79l-0.04,-0.56l0.56,-0.7l0.61,0.38l1.75,-0.43l-0.33,1.7l0.42,0.47l0.37,-0.09l1.3,-1.37l-0.48,-1.18l-1.07,-0.69l0.82,-0.42l0.51,-0.93l1.18,-0.99l2.01,0.05l0.56,-0.74l0.29,0.27l-0.34,0.03l-0.23,0.62l0.44,0.52l-0.71,0.35l0.09,1.35l-0.94,1.01l-0.57,1.34l1.06,1.48l0.76,0.13l0.57,-0.34l0.54,0.45l-0.13,0.38l-1.56,0.75l-0.73,1.21l-1.89,0.99l-0.47,0.95l-0.59,0.04l-0.25,0.44l0.29,1.05l0.86,0.84l1.12,0.58l0.72,0.01l0.23,0.41l0.53,0.01l0.32,-0.52l1.93,1.27l2.46,-0.33l0.26,-1.48l0.87,-0.15l1.02,0.51l0.3,-0.25l0.81,-1.37l0.11,-0.97l0.88,-1.02l0.45,-1.87l1.23,-0.68l0.86,1.2l0.75,-0.28l1.55,0.99l3.12,0.8l3.72,2.51l3.19,4.28l0.37,1.46l-10.78,31.16l10.4,16.31l12.52,18.3l13.34,18.03l12.32,15.52l14.94,3.76l6.82,13.72l2.18,2.36l1.96,1.15l30.79,11.84l26.18,8.95l-10.8,81.07l-27.95,-4.19l-23.5,-4.25l-29.2,-6.22l-23.2,-5.69l-28.76,-8.01l-22.8,-7.12l-28.52,-9.89l-16.81,-6.36l-0.18,-0.73l-0.43,-0.33l-0.96,0.05l0.81,-1.02l-0.28,-4.88l0.73,-2.33l-0.28,-0.79l-1.31,-0.57l0.24,-1.49l-0.61,-2.47l1.97,-1.43l0.22,-3.72l-2.24,-1.11l-1.04,0.62l-0.48,1.05l-2.45,-0.87l-2.01,0.56l-1.21,-1.31l-1.29,-0.74l-0.59,-1.26l-0.72,-0.6l-0.78,0.07l-1.01,1.06l-0.29,-0.29l0.24,-0.75l-0.52,-0.5l-1.06,-0.17l-0.38,0.32l-0.1,0.76l-0.41,0.1l-0.86,-0.35l-0.75,-1.07l-0.52,-0.06l-1.36,0.61l-0.34,-0.8l-0.94,-0.1l1.63,-5.05l-0.31,-0.69l-0.98,-0.18l1.04,-0.41l0.63,-1.24l0.92,-3.44l-0.25,-0.84l0.26,-1.46l-1.07,-1.73l-2.01,-0.66l-0.66,-0.99l-0.05,-0.94l-0.68,-0.72l-0.34,-1.54l-0.44,-0.46l0.4,-1.41l-0.03,-1.72l-0.37,-0.58l-0.73,-0.1l0.25,-1.73l-0.53,-1.26l0.32,-0.68l-0.79,-2.47l-1.51,-0.56l-1.12,0.7l-0.11,-1.18l-0.94,-0.95l-1.25,-0.18l-0.47,-0.89l0.84,-0.58l0.0,-2.28l0.95,-0.43l0.28,-0.54l-0.39,-0.69l0.37,-0.3l0.75,0.06l0.49,-0.54l-0.03,-0.8l-1.6,-2.55l0.39,-1.47l-0.5,-1.07l0.27,-0.98l-0.25,-2.15l0.4,0.06l0.76,-1.19l1.64,-1.3l0.21,-0.71l-0.47,-0.62l-0.8,-0.15l-0.3,-0.58l0.26,-2.13l-0.48,-0.59l-0.05,-1.15l-0.63,-0.54l0.74,-0.4l1.57,-0.07l0.77,-1.24l1.11,-0.59l0.08,-3.19l-0.8,-0.68l0.35,-1.33l-0.42,-0.38l-1.1,0.18l-0.14,-0.44l1.9,-0.06l0.56,-1.03l-1.49,-1.53l-0.71,-2.56l-0.55,-0.3l-0.74,-1.16l0.5,-1.17l-0.6,-0.74l-0.13,-1.41l0.94,-0.65l-0.02,-2.0l-0.29,-0.55l0.6,-0.72l-0.24,-2.3l-1.89,-2.03l-0.92,0.77l-0.7,0.12l-0.75,-0.01l-0.36,-0.61l-0.72,-0.22l1.94,-1.43l0.12,-0.41l-0.28,-0.82l-0.72,-0.5l-0.29,-0.98l-0.01,-2.24l-0.78,-0.71l-0.72,-1.79l-1.02,-0.87l-0.65,-0.13l0.0,-0.66l1.38,-0.32l0.62,-1.63l1.7,-0.39l0.34,-0.37l0.1,-1.36l-1.06,-0.79l0.65,-0.87l-0.01,-0.71l-0.29,-0.49l-0.9,-0.02l0.19,-0.45l0.87,-0.55l0.71,0.18l1.01,-1.21l2.29,-0.75l1.42,-1.78l1.31,-0.69l0.15,-4.09l-0.81,-1.96l0.67,-0.54l1.76,-0.15l0.42,-0.65l0.01,-0.78l-0.56,-0.46l-0.6,0.02l0.1,-0.75l-0.44,-0.59l-1.0,-0.06l-2.28,1.16l-0.4,-0.16l1.28,-1.17l0.11,-0.45l-0.33,-0.59l-1.96,-0.69l-1.63,-0.05l-0.64,0.46l-1.07,-0.82l0.77,-1.25l-0.44,-0.84l1.7,-0.84l1.09,-2.06l0.16,-0.66l-0.32,-0.69l-1.15,-0.51l1.43,-1.81l0.18,0.29l0.73,0.08l0.45,-1.72l0.97,-0.32l0.28,-0.51l-0.44,-0.81l-0.09,-1.21l0.41,-0.5l-0.11,-1.08l0.63,-0.31l0.59,-0.96l-0.12,-2.62l-0.75,-1.25l1.56,0.55l0.46,-0.15l0.06,-0.73l-16.24,-8.77ZM212.99,287.11l-0.0,-0.01l-0.45,-0.39l0.6,0.28l-0.15,0.13ZM212.05,286.55l-0.11,0.01l-0.06,-0.14l0.18,0.13ZM180.17,279.08l0.22,-0.13l-0.03,0.22l-0.19,-0.09ZM142.41,285.87l-0.69,-0.85l0.05,-0.26l0.51,-0.01l0.13,1.12ZM142.96,264.87l0.0,-0.21l0.23,0.0l-0.16,0.1l-0.07,0.11ZM156.61,271.56l-0.26,-0.16l-0.02,-0.28l0.35,0.17l-0.07,0.26ZM155.74,270.75l-0.15,0.03l0.11,-0.14l0.03,0.11ZM160.01,281.13l0.4,-0.64l0.34,-0.13l0.07,0.65l-0.81,0.12ZM202.48,297.51l-0.11,-0.08l0.06,-0.02l0.05,0.1ZM201.89,297.32l-0.66,-0.04l0.07,-0.32l0.01,-0.01l0.59,0.37ZM211.17,288.3l-0.48,-0.11l-0.4,0.32l-0.21,-0.52l1.07,-0.1l0.02,0.4ZM208.14,287.7l-0.36,0.28l-0.26,0.01l0.62,-0.56l-0.0,0.27ZM335.17,145.92l1.0,-0.91l-0.43,-1.22l0.64,-1.86l-0.24,-1.59l1.26,-2.2l0.25,0.64l0.45,0.13l0.76,-0.79l3.51,-1.13l0.74,0.23l1.64,-0.35l0.71,0.43l1.24,-0.7l1.27,-0.2l1.05,0.14l0.29,0.54l0.59,0.26l1.22,-0.62l3.04,0.79l-0.79,3.54l-1.13,0.52l-3.24,-0.04l-0.82,0.7l-0.06,0.82l0.87,1.98l2.92,0.26l-0.45,1.5l-0.01,1.69l-0.82,0.85l0.14,1.08l-0.89,0.91l-1.88,0.72l-1.37,0.04l-0.52,0.59l-1.94,-0.92l-0.98,0.55l-3.89,0.96l-1.46,-1.4l-0.3,-2.44l-0.41,-0.24l-0.64,0.19l-0.54,-0.49l-0.03,-1.17l-0.89,-0.46l0.16,-1.34ZM343.19,180.35l0.39,-0.57l0.14,-1.89l1.48,-0.35l-0.86,3.83l-1.15,-1.03ZM297.77,196.61l-2.26,-1.86l-0.55,-1.22l0.38,-0.82l0.76,-0.32l0.24,-0.76l2.05,-1.76l0.55,-0.25l6.65,1.88l3.36,-1.6l1.84,0.21l0.67,-1.17l1.68,-0.67l0.17,-0.56l-0.66,-0.53l-2.08,0.6l-1.88,-0.19l-1.9,0.31l-1.11,0.5l-5.82,-1.7l0.31,-0.79l2.82,-2.79l6.28,0.76l0.48,-0.28l0.79,0.65l4.2,0.37l0.7,-0.36l0.28,-0.91l-0.5,-0.5l-4.76,-0.77l-0.49,-0.35l-2.68,-0.05l-2.24,-1.68l0.21,-0.61l1.35,0.12l0.37,-0.43l0.07,-1.43l-0.97,-0.43l0.79,-1.37l0.84,-0.74l2.07,-0.37l2.45,1.3l1.29,0.19l3.33,1.91l1.21,-0.14l0.02,-0.84l-1.49,-0.63l-0.23,-0.8l-1.14,-1.05l-2.82,-0.86l-0.3,-0.94l0.64,-0.8l-0.1,-0.61l2.58,-1.59l2.72,0.22l1.32,-0.67l0.16,0.75l1.65,0.26l1.13,1.18l-0.07,1.46l-0.72,0.79l0.44,2.55l-0.57,0.6l0.33,1.25l2.02,0.22l2.23,-0.84l1.08,0.55l0.85,-0.19l0.3,1.16l1.82,1.55l-0.7,1.1l0.22,1.97l0.35,0.65l1.2,0.8l1.56,2.3l-1.85,0.28l-0.97,0.54l-0.56,1.29l0.4,0.38l0.83,-0.16l0.79,0.5l0.52,-0.36l1.19,0.13l-0.09,0.43l0.56,0.69l-0.19,1.08l0.36,0.37l-0.82,2.31l0.43,2.83l1.72,0.27l1.16,-0.38l1.83,0.08l0.43,0.89l2.08,0.36l-3.46,15.46l-0.59,0.13l-1.01,-0.67l-0.79,0.44l-0.17,0.72l-1.49,-0.26l-0.41,0.8l0.12,1.27l-2.4,1.0l-0.25,0.41l-1.6,0.27l-0.55,0.48l-0.67,-0.2l-1.85,1.17l-3.69,0.32l-1.41,0.46l-3.52,-0.48l-1.07,-0.47l-2.46,-1.54l-2.23,-3.46l-0.83,-2.35l0.38,-0.84l2.93,-1.35l0.8,0.07l0.73,-0.33l1.31,0.27l1.04,-0.25l0.62,0.52l0.49,-0.13l0.19,-0.89l0.89,-0.99l1.85,-0.47l4.43,0.55l1.47,0.89l1.64,-0.19l0.99,-1.0l1.23,-0.45l0.51,-0.83l1.59,-0.92l0.09,-0.52l1.0,-0.88l-0.22,-0.82l-0.77,-0.71l-1.12,-0.14l-1.02,1.34l-1.06,0.63l-0.85,-0.15l-0.16,-0.58l-0.45,-0.2l-1.17,0.94l-0.87,-0.44l-1.62,0.22l-0.26,-0.33l1.23,-0.9l-0.09,-0.91l-0.35,-0.68l-0.46,-0.1l-0.62,0.58l-0.13,0.67l-0.26,-0.06l0.48,-1.27l-0.3,-0.89l-0.59,-0.2l-0.98,1.81l-0.08,1.28l-0.92,0.5l-0.8,0.07l-0.1,-1.12l-0.35,-0.31l-0.9,1.31l-3.84,-0.33l0.32,-1.39l1.77,-0.52l0.23,-0.6l-0.46,-0.42l-1.17,0.31l1.46,-2.76l3.51,-1.68l-0.97,-0.99l-2.7,0.74l-0.38,-2.37l-0.69,-0.02l-0.22,0.35l-0.36,2.28l-1.44,2.63l-0.13,-1.23l-1.14,-1.28l-1.05,0.74l-0.08,0.77l0.95,0.5l0.21,1.76l-1.36,2.08l-3.46,1.29l-0.36,-0.05l-0.39,-0.67l0.23,-1.39l0.63,-1.29l-0.11,-1.68l-0.42,-0.25l-1.34,1.5l-0.77,-1.27l-0.59,-0.09l-0.29,0.56l0.11,2.33l-0.93,1.06l-2.19,-2.46l0.89,-0.36l0.57,-0.73l-0.26,-0.63l-1.29,0.17l0.63,-0.76l0.26,-1.45l-2.29,-0.11l-1.24,1.13l-0.81,-1.06l-0.74,-0.14ZM328.08,134.65l1.49,-0.41l0.93,-1.05l1.49,-0.48l-0.42,0.64l0.17,1.23l0.84,0.29l0.26,1.88l1.08,1.0l-0.13,1.05l0.28,0.68l-0.86,0.82l-2.45,0.83l-0.42,-0.22l-0.69,-1.15l0.02,-0.72l-1.13,-2.38l-0.46,-2.01ZM321.15,163.02l0.27,-0.55l1.37,-0.86l1.02,-0.17l0.95,0.34l2.18,0.1l1.23,1.73l-0.05,1.16l-1.23,1.11l-0.66,-0.6l-3.08,-0.94l-2.0,-1.32ZM323.52,255.67l3.92,1.28l-0.95,4.27l-0.31,-0.07l-0.4,-1.5l-1.62,-0.83l-0.69,-2.28l0.06,-0.87ZM325.57,263.35l0.07,-0.72l0.09,0.01l0.37,0.29l-0.13,0.59l-0.39,-0.16ZM261.06,269.52l0.42,-3.04l1.57,-3.05l1.05,-0.92l1.78,-0.91l0.8,-1.49l0.97,-0.67l0.88,0.18l2.34,-0.29l0.56,-0.55l0.36,-1.5l-0.12,-0.87l-0.52,-0.56l-1.2,-0.42l-0.42,-0.6l0.04,-1.02l0.95,-1.39l2.28,-1.24l0.66,-0.77l2.37,-0.69l2.57,-1.65l2.03,-1.97l0.89,0.17l2.38,-0.35l2.61,-1.39l0.63,0.1l5.36,-1.34l1.37,0.01l1.28,-0.38l0.6,-0.51l0.67,0.14l0.85,-0.48l1.59,-0.19l1.66,-0.82l0.38,0.01l1.58,1.5l0.76,4.13l-2.16,5.66l0.16,1.56l-1.74,-0.03l-1.07,0.84l-0.27,1.63l-2.29,1.2l0.2,1.21l1.64,0.68l0.59,-0.7l2.44,-0.63l0.2,0.37l0.74,0.2l-0.08,0.49l0.37,0.37l0.67,-0.09l1.89,-1.23l0.41,-0.92l0.07,-0.89l-0.92,-0.59l2.08,-2.47l1.62,-1.35l0.96,-0.15l2.61,1.86l1.36,1.71l1.28,0.45l2.21,2.46l0.69,0.37l0.24,1.29l1.27,0.82l-0.93,2.75l-1.69,1.01l0.02,0.76l-3.52,1.88l-0.22,0.43l0.3,0.81l0.71,0.42l-0.88,1.61l0.18,0.88l0.68,-0.03l0.87,-1.47l2.69,-1.14l0.94,2.06l0.72,-0.16l0.21,-2.62l0.87,-0.72l0.04,-0.5l0.91,0.33l0.54,-0.43l-0.08,-0.87l0.72,-0.65l0.55,0.58l-0.56,0.44l0.05,0.88l1.35,1.71l0.75,-0.09l0.09,-0.57l-1.02,-1.51l0.87,-0.51l1.37,2.93l-11.47,51.41l-17.46,-4.16l-0.48,0.29l-0.35,1.39l-1.14,0.12l0.0,0.67l1.45,0.6l-1.3,-0.38l-0.5,0.41l-0.91,-0.23l0.76,-2.9l-0.37,-0.69l-29.82,-8.44l-0.5,0.24l-0.86,2.55l1.84,5.57l-0.46,-0.2l-0.66,-1.15l-0.8,-0.68l-0.68,-1.43l0.13,-4.89l0.67,-0.69l1.4,-0.58l1.73,-0.24l3.39,0.25l3.67,-0.18l11.18,1.07l2.11,0.57l0.9,1.01l2.68,1.14l1.35,-0.09l2.98,1.9l0.67,-0.2l2.43,1.71l0.51,-0.14l0.14,-0.67l0.71,0.47l0.77,-0.34l-0.01,-0.27l0.91,0.22l0.56,-0.27l1.17,0.76l3.05,0.53l0.77,-0.31l0.11,-0.56l-0.29,-0.32l0.27,-0.48l-0.57,-0.96l-1.79,-0.31l-0.91,-0.68l-0.84,-3.09l-0.67,-0.2l-1.08,-0.99l-0.79,0.15l-1.03,-1.36l-0.64,-0.28l-0.62,0.15l-0.92,-1.37l-0.63,-0.24l-0.19,-0.8l-1.01,-0.25l-0.69,-0.96l-0.46,-0.05l-0.39,0.5l-0.67,-1.05l-1.73,-1.01l-1.72,0.58l-1.18,-0.69l-1.38,0.56l-2.51,-0.34l-1.32,0.15l-3.15,-0.78l-0.6,0.23l-1.02,-0.84l-2.18,-0.06l-0.63,-0.48l0.18,-0.65l-0.56,-0.52l-2.45,-0.59l-0.91,0.29l-2.02,-0.49l-1.54,-0.86l-0.61,0.03l-0.43,-0.55l-1.39,0.06l-0.5,-1.05l0.38,-0.76l-0.22,-0.93l-2.44,-4.15l-0.27,-2.19l0.33,-0.6l4.75,-1.74l2.29,0.35l2.83,-0.41l1.41,0.46l0.88,-0.42l0.18,-0.46l3.98,-0.43l0.61,0.62l0.81,-0.17l1.81,0.45l0.73,-0.44l-0.03,-0.61l-1.86,-1.16l1.71,-0.55l0.31,0.35l0.7,-0.0l0.31,0.56l1.18,0.74l1.71,-0.3l1.18,-0.56l0.16,-0.64l-0.7,-0.44l-1.42,0.43l-0.78,-0.08l-0.21,-0.12l0.61,-0.47l-0.15,-0.44l-1.08,-0.72l-1.49,-0.27l-2.81,0.29l-2.53,-0.28l-2.19,0.43l-1.56,-0.54l-1.22,0.36l-0.84,-0.12l0.4,-1.13l-1.05,-1.55l-1.28,0.93l0.11,0.7l0.6,0.3l-0.39,0.69l-0.78,-0.88l-0.84,0.41l-0.55,-0.45l-1.68,-0.36l-0.42,-1.04l0.66,-1.04l0.9,-0.41l2.39,0.85l0.28,-0.38l0.75,-0.09l0.25,-0.72l-1.15,-1.3l1.24,-0.2l0.19,-0.81l-2.72,-0.71l-0.79,0.27l-0.68,0.84l-0.48,-0.03l-0.46,-1.51l-0.75,-0.64l-1.98,-0.51l-0.99,0.87l-0.25,-0.31ZM315.48,268.17l-0.79,0.04l-0.04,-0.21l1.17,-0.51l-0.34,0.67ZM272.81,162.81l0.83,-0.98l0.4,0.17l1.08,-0.8l0.89,-1.79l1.46,-0.77l2.3,0.16l0.97,0.64l1.33,0.17l0.56,-0.22l1.24,-1.44l0.32,-0.92l1.48,-1.14l0.49,-1.02l0.58,0.19l1.16,-0.28l0.78,-0.61l1.48,-0.1l1.56,-0.97l0.35,-1.57l1.23,-0.32l0.64,-1.04l0.68,-0.38l0.26,-0.76l0.98,-0.09l1.12,-1.54l1.02,-0.11l0.51,-0.71l1.48,-0.62l1.35,-2.17l0.75,-0.51l1.03,0.44l1.58,-0.55l2.55,0.93l1.07,-0.28l-0.04,0.4l0.84,0.27l0.14,0.7l1.17,0.65l1.07,1.51l1.58,0.18l0.36,-0.74l0.35,0.46l0.67,0.06l0.37,-0.75l1.09,-0.81l-0.22,-0.81l-1.45,-0.48l-0.12,-0.94l0.79,-0.07l1.21,-0.74l0.09,-0.67l1.38,0.07l1.15,1.83l-0.1,0.87l1.46,1.39l1.01,2.22l-0.02,0.53l-0.69,0.76l-1.45,0.12l-0.9,0.65l-1.94,-0.05l-0.62,0.98l-0.64,0.2l0.11,2.98l1.96,2.78l-0.93,0.62l-1.65,-1.71l-0.48,0.02l-0.45,0.49l-0.12,0.76l0.52,1.85l0.62,0.63l-0.08,2.78l-0.62,0.28l-0.74,1.04l-1.46,0.65l-1.07,0.01l-1.18,-0.48l-0.84,0.41l-0.52,-0.36l-0.55,0.11l-0.74,0.87l0.06,1.54l-0.44,2.45l-1.34,0.94l-1.23,0.3l-0.84,-0.49l-0.11,-1.27l-0.95,-0.47l-0.42,-2.07l0.76,-1.8l0.88,-0.73l0.15,-1.62l0.62,-0.74l0.28,-1.2l1.64,-1.76l0.07,-1.13l-0.45,-0.66l-0.59,0.04l-1.03,0.98l-1.49,-0.63l-0.55,0.27l-0.13,1.02l-0.51,-0.31l-0.61,0.32l-0.14,0.98l0.37,1.03l-0.31,1.73l-0.91,0.0l-0.48,0.74l-0.29,-0.17l-0.19,-1.11l-0.79,-0.43l-0.42,0.57l-0.7,0.24l-0.39,1.07l0.58,0.56l0.06,0.56l0.6,0.37l-0.17,2.29l-0.72,0.92l-0.84,-0.26l-0.74,0.3l-0.8,2.2l-0.6,0.78l-0.74,0.29l-0.37,-0.38l0.36,-1.66l-0.29,-1.71l0.52,-2.6l-0.49,-0.23l-0.55,0.61l-0.44,-0.35l-0.66,0.27l0.04,0.99l-0.56,0.72l0.12,2.13l-0.47,-0.14l-0.42,0.38l0.02,0.74l-0.41,-0.17l-0.55,0.41l1.08,2.04l-0.1,0.91l-0.51,-0.34l-0.35,0.13l-0.82,1.1l0.04,0.39l-1.36,1.08l-0.71,0.02l0.1,-0.78l-0.48,-0.68l-2.02,1.61l0.77,-2.24l0.75,-0.9l0.0,-1.44l-0.38,-0.3l-0.92,0.11l0.1,-0.99l0.73,-0.78l0.03,-0.56l-0.3,-0.17l0.66,-0.56l-0.72,-1.92l-0.52,-0.12l-1.12,0.76l-1.06,2.34l-0.03,1.09l-1.31,0.08l-0.93,0.92l-0.14,-1.26l-1.81,-2.34l-1.81,-0.41l-0.67,1.27l-1.44,0.51l-0.88,-0.46l-0.12,-0.41l0.71,-0.41l1.49,-2.04l0.36,-1.31l-0.84,-1.36l-1.28,0.23ZM299.65,310.08l0.53,0.27l0.45,0.46l-0.39,-0.06l-0.6,-0.66ZM287.73,182.36l0.69,-0.85l4.73,-3.33l1.13,-1.26l1.85,-0.54l1.07,0.16l0.92,-1.24l1.31,-0.42l0.79,-0.83l0.46,-0.05l0.46,0.38l0.14,0.3l-1.31,2.19l-2.18,2.12l-0.18,0.62l-1.06,1.07l-0.32,1.05l-2.69,2.15l-0.04,0.48l-2.56,1.32l-0.81,-0.98l0.09,-0.48l-0.29,-0.32l-1.56,-0.66l-0.65,-0.89ZM219.97,246.31l1.41,-1.91l0.11,-1.2l0.58,-0.36l1.1,-0.08l-0.32,-0.78l0.18,-0.7l0.48,0.19l0.98,-0.52l0.27,-1.09l0.89,-0.57l1.76,-2.13l1.99,-0.91l0.69,0.17l0.33,-0.36l0.17,-0.64l-0.47,-0.74l1.39,-1.18l-0.11,-0.61l0.47,-0.8l0.25,-1.52l-0.23,-0.7l0.67,0.55l1.19,-0.31l0.51,0.29l0.98,-0.1l1.04,-0.37l0.42,-1.4l-0.51,-0.63l-0.15,-0.96l-0.68,-0.17l-0.06,-1.13l0.71,-0.76l0.69,0.02l0.56,-0.39l0.08,-0.6l2.32,-2.69l0.8,-0.47l0.23,-1.17l1.24,-0.65l0.8,0.03l0.34,-0.54l0.77,-0.34l0.67,-1.15l0.29,-1.31l1.55,-0.35l1.1,-1.28l0.25,-1.97l-0.31,-0.53l-1.33,-0.8l-0.1,-0.5l0.42,-1.09l-0.23,-3.55l0.64,-1.27l0.5,-3.11l-0.51,-0.66l0.56,-0.75l-0.26,-0.41l2.51,0.32l0.51,0.35l0.43,0.02l0.38,-0.41l3.46,0.81l1.3,-0.08l4.09,1.2l3.23,0.37l3.44,-0.17l2.16,1.86l0.32,0.91l-0.08,1.29l3.74,4.85l1.04,0.62l0.62,1.06l0.81,0.25l-0.47,1.0l-1.5,1.46l-0.24,1.04l0.36,0.8l0.74,-0.05l0.38,-1.36l0.97,-0.5l1.31,-1.55l1.19,0.38l0.28,0.38l-0.47,1.34l0.08,1.01l-0.57,0.34l-0.89,1.63l0.34,0.56l1.91,-0.18l1.59,-1.69l0.28,-0.77l-0.19,-1.06l0.98,-0.4l4.16,-0.06l3.39,2.19l2.27,4.11l1.8,5.75l0.49,0.47l1.16,3.45l1.44,1.82l0.81,3.18l-0.08,1.01l-3.31,1.88l-4.92,0.78l-6.1,2.78l-1.26,-0.07l-5.26,2.35l-1.45,0.23l-1.65,0.71l-0.85,0.83l-1.62,-0.12l-1.32,0.83l-2.03,0.7l-0.96,2.07l-1.6,1.95l-0.47,1.5l-0.93,0.52l-2.88,1.16l-1.62,-0.74l0.17,-0.63l-0.24,-0.33l-0.93,-0.17l-0.55,0.71l0.19,1.09l-0.34,1.5l-3.38,3.51l0.05,1.25l-1.16,2.65l-0.16,1.27l-1.86,2.66l-1.02,0.7l-2.7,0.45l-3.04,-0.02l-0.44,-0.37l0.33,-0.56l-0.21,-1.0l-1.09,-0.53l-4.34,3.08l-3.99,0.69l-1.69,1.33l-1.8,-0.62l-0.51,-1.09l-0.25,-2.74l0.46,-4.89l-0.17,-1.56l-0.39,-0.61l0.01,-2.66l-0.5,-1.41l-2.97,-3.64l-2.15,-3.79l1.11,0.8l0.52,-0.4l-0.02,-0.67l-0.4,-0.56l-1.67,-0.72l-3.23,-0.72ZM278.89,175.73l-0.49,-0.42l1.55,-0.55l-0.56,0.63l-0.51,0.34ZM280.89,173.14l-0.05,-0.52l0.37,-0.4l-0.17,0.44l-0.15,0.48ZM265.98,295.52l0.41,0.33l-0.56,-0.18l0.16,-0.15ZM192.19,266.74l0.3,-0.36l0.16,0.54l-0.24,0.16l-0.22,-0.33ZM134.49,262.69l0.12,-0.19l0.63,-0.37l-0.53,0.46l-0.22,0.1ZM133.01,267.08l0.28,0.07l0.02,0.08l-0.15,0.11l-0.14,-0.25ZM125.45,269.42l0.35,-0.18l0.08,0.44l-0.34,-0.04l-0.09,-0.22Z",name:"Northwest Territories"},"CA-NU":{path:"M694.57,496.77l1.45,-0.41l0.98,0.82l0.52,0.93l-1.78,-0.16l-1.15,-0.84l-0.03,-0.34ZM682.9,477.17l0.06,-0.73l3.09,-1.55l2.28,-0.08l0.16,0.84l0.97,-0.11l-0.26,0.99l0.67,0.87l0.04,0.63l-0.57,0.8l-0.1,1.41l-0.48,-0.03l0.2,-0.37l-0.27,-0.55l-1.47,0.05l0.01,-0.29l-0.54,-0.36l-0.45,0.12l-0.52,-0.72l-1.64,-0.3l-1.18,-0.63ZM458.86,294.89l0.69,-1.03l0.12,-1.87l1.28,-0.97l0.41,0.23l0.46,-0.24l0.63,-1.06l-0.01,-0.62l-0.42,-0.41l-1.24,0.36l-0.49,-0.37l-0.34,-2.89l1.12,-2.11l-0.36,-0.48l0.36,-0.77l0.19,-2.79l0.15,-0.21l0.4,0.29l0.51,-0.11l0.34,-0.95l0.36,-0.14l0.13,-0.53l-0.73,-1.03l0.18,-0.83l1.18,0.54l0.58,-0.22l0.23,-0.85l-0.26,-0.58l-0.78,-0.45l0.74,-1.97l-0.38,-1.61l0.2,-0.36l0.16,0.26l0.43,-0.14l0.13,-0.38l-0.61,-0.85l0.51,-1.54l0.66,-0.7l-0.26,-0.44l0.45,-0.65l1.17,-0.06l0.12,-0.59l-0.94,-0.51l0.61,-0.81l1.41,0.47l0.55,-0.15l-0.1,-0.83l-1.25,-0.66l0.98,-1.74l1.16,-0.95l0.58,-1.42l4.02,-4.37l3.91,-2.04l3.49,-1.3l3.4,-0.13l1.76,0.44l3.97,0.22l1.49,1.34l-0.09,0.41l-0.39,0.92l-3.07,3.29l-0.74,0.43l-2.77,4.99l-1.59,4.49l-0.2,1.53l-2.06,4.52l-0.33,3.11l0.51,1.79l2.87,3.81l0.14,1.36l-1.11,2.75l0.04,3.45l0.38,2.71l0.54,0.48l1.61,4.19l1.24,1.26l0.91,1.49l0.64,0.41l0.25,0.78l1.1,1.03l0.66,1.16l1.93,0.96l0.28,0.43l1.59,0.27l0.08,1.57l0.55,0.31l0.2,0.65l-2.26,-0.26l-0.56,0.35l0.02,0.82l-0.69,-0.12l-0.57,0.29l-0.32,1.27l-1.2,-0.52l-1.85,0.77l-2.42,2.82l-3.42,1.32l-0.38,0.55l0.31,0.43l1.16,0.27l2.86,-0.76l2.85,-2.34l0.68,-0.95l1.5,-0.2l0.49,-0.42l2.28,0.52l0.56,-0.55l1.03,-0.26l-0.01,0.92l-0.51,-0.15l-1.13,0.39l-0.26,0.55l0.37,0.38l0.72,0.05l-0.06,0.67l0.58,0.71l-0.13,1.79l0.47,0.27l1.12,-0.17l0.37,-0.35l0.27,-1.15l-0.68,-2.37l0.1,-2.05l0.82,-0.76l-0.04,-0.5l-0.91,-1.17l0.13,-2.54l1.28,-0.72l0.23,-0.74l-0.35,-1.93l-0.72,-1.15l0.29,-0.96l-0.4,-0.73l-0.68,-0.22l-1.26,0.21l-0.31,0.48l0.13,0.39l-2.62,-0.82l-1.39,-1.79l0.48,-0.3l0.08,-0.55l-1.02,-2.06l-1.5,-1.05l-1.25,-0.46l-0.18,-0.49l1.72,0.19l-0.23,-0.81l1.12,-0.21l0.48,-0.51l-0.02,-1.02l0.65,-0.24l0.14,-0.45l-0.74,-1.32l0.52,-0.49l-0.09,-0.29l0.52,-0.18l0.32,0.44l0.63,-0.18l0.36,0.3l0.76,-0.34l1.93,1.98l1.21,0.53l0.72,1.21l1.02,0.76l0.34,1.5l0.53,0.49l0.54,-0.31l0.08,-1.28l-0.27,-1.08l-1.09,-0.87l-0.64,-1.52l-1.33,-0.47l-0.71,-0.9l-0.0,-0.81l-1.53,-0.76l0.54,-1.17l1.87,-0.1l0.64,-0.59l-0.05,-0.63l-0.67,-0.07l-0.38,0.35l-1.49,-0.13l0.33,-1.4l-0.35,-0.45l-1.12,0.68l-0.92,1.29l-1.61,-0.64l-1.12,-1.0l-0.66,-1.5l0.66,-0.27l0.24,-0.59l-1.19,-0.53l-0.44,-0.77l-0.08,-5.9l0.49,-1.27l2.32,0.46l1.67,1.04l3.06,1.1l1.54,1.13l2.18,0.68l0.2,-0.85l-2.01,-0.88l-2.6,-2.11l-2.93,-1.53l-1.19,-2.97l0.69,0.09l1.09,0.74l2.84,0.74l3.94,0.35l1.4,0.94l0.52,0.05l-0.06,-0.89l-1.15,-1.13l-5.25,-1.25l-2.97,-1.77l-0.82,-0.05l0.2,-2.03l1.57,-1.49l0.77,1.62l0.99,0.68l0.83,1.15l0.84,-0.07l0.18,-0.55l-1.66,-2.02l-0.49,-1.37l2.49,-1.67l2.45,0.71l0.73,2.42l0.51,0.6l0.49,-0.02l0.26,-0.97l-0.7,-3.07l-2.15,-1.0l1.91,-1.63l2.87,-1.83l0.38,0.28l0.57,-0.11l1.13,-1.93l4.82,-0.43l3.3,0.19l0.59,1.49l1.44,2.07l0.89,6.25l0.6,0.57l3.37,1.48l0.54,1.24l-0.42,2.62l0.28,1.36l1.2,2.0l1.25,0.59l0.49,1.29l-0.61,0.42l-1.06,1.94l0.18,1.18l-1.25,1.2l-1.39,2.04l-0.34,1.34l-0.79,1.18l-0.04,1.01l-1.07,1.14l0.38,0.63l1.13,-0.55l2.05,-4.19l1.74,-1.68l0.11,2.17l-1.34,1.85l-0.46,2.25l-0.79,0.26l0.13,0.45l1.94,1.39l-1.92,0.38l-0.11,0.75l-0.36,0.26l-0.03,0.63l0.44,0.31l0.83,0.03l0.58,-0.33l-0.06,1.88l-0.86,1.26l0.58,0.45l1.15,-0.69l0.47,-0.93l-0.06,-0.85l2.28,-1.73l0.25,-0.81l-0.16,-0.79l-0.82,-1.04l0.64,-0.06l0.77,-0.91l-0.47,-1.72l0.91,1.53l1.09,1.07l2.0,0.71l0.49,-0.54l-0.57,-0.78l-1.4,-0.66l-1.82,-2.49l0.53,-1.32l1.11,-0.88l1.33,1.64l-0.92,2.02l0.13,0.74l0.38,0.31l0.78,-0.26l0.43,-1.15l0.58,1.55l0.67,0.07l0.1,-0.87l-0.64,-1.52l0.82,-2.03l1.77,2.05l0.46,0.15l-0.07,0.8l0.33,0.72l-0.27,2.67l-1.03,2.24l0.12,0.44l0.62,0.44l0.84,-0.43l2.21,0.77l1.42,1.23l0.72,-0.44l-0.01,-0.5l-0.63,-0.54l-0.3,-0.94l-1.23,-0.3l-0.95,-0.84l-0.11,-2.89l2.0,1.09l1.2,3.33l1.53,2.41l1.42,0.81l1.14,0.25l0.37,-0.6l-0.59,-0.47l0.48,0.2l0.58,1.0l0.46,0.13l0.31,-2.04l-1.44,-0.54l-1.99,-2.7l-0.61,-0.18l-0.64,0.23l-1.18,-2.89l-1.97,-0.89l-1.13,-0.9l0.56,-1.27l-0.33,-0.73l0.81,-0.64l0.44,2.37l1.08,1.41l0.7,-0.56l-0.73,-1.43l-0.1,-1.29l2.36,0.65l0.59,0.63l0.45,-0.3l0.77,0.27l0.81,0.75l0.4,1.14l-0.15,0.87l0.61,0.29l0.53,-0.9l-0.22,-0.98l1.64,-0.35l2.11,0.9l0.48,-0.21l-0.13,-0.5l-1.12,-0.76l-1.2,-0.4l-1.69,0.17l-2.01,-1.39l-2.94,-1.01l-2.16,-1.59l-0.28,-1.48l0.49,-1.71l1.39,-1.61l1.28,-1.14l1.2,-0.39l1.06,-1.18l4.48,-0.37l1.22,0.71l0.16,0.89l0.52,0.5l3.11,0.45l0.56,2.06l0.61,0.47l0.66,-0.47l-0.32,-1.5l0.42,-0.69l1.2,0.0l1.93,0.9l1.73,0.36l0.53,1.58l1.91,3.11l-0.46,1.49l-0.95,1.37l-1.27,-0.25l-1.24,0.22l-2.91,2.14l-0.33,2.1l-0.75,1.09l-0.57,1.79l0.33,0.81l0.78,-0.31l0.47,-1.7l0.92,-1.46l0.26,-1.54l1.99,-1.69l0.77,-0.14l1.76,0.58l-1.7,1.0l-0.48,0.63l-0.21,3.99l-0.7,2.19l-1.44,0.77l-0.11,0.52l0.48,0.33l1.63,-0.52l0.55,-0.64l0.71,-2.62l0.15,-3.33l0.29,-0.42l1.09,-0.08l0.82,-0.68l0.54,-2.42l0.9,0.32l3.87,-0.17l0.92,0.9l0.57,1.21l-0.42,1.07l0.42,1.07l-0.26,0.8l-0.87,0.45l-1.1,-0.35l-0.33,0.65l0.18,0.36l-0.7,1.29l-1.15,0.73l-0.96,-0.09l-1.97,0.84l-0.39,0.52l-0.05,0.38l0.57,0.42l1.94,-0.92l0.63,0.31l-2.65,3.27l0.23,0.7l0.55,-0.1l1.21,-0.98l0.84,-1.22l1.01,-0.72l0.43,-1.33l0.28,-0.26l0.18,0.33l-0.06,1.06l-0.66,1.24l-1.41,0.53l-0.65,1.37l-0.05,0.52l0.56,0.41l0.74,-1.25l0.85,-0.18l-0.53,1.24l1.43,0.31l0.32,0.72l-1.98,4.49l0.25,0.66l0.85,-0.17l2.17,-4.95l-0.15,-0.96l-1.06,-1.78l-0.01,-0.47l0.68,-0.48l0.26,-2.28l0.65,-0.31l0.66,-1.43l0.52,-0.2l-0.53,2.66l0.36,1.13l0.93,0.59l0.43,-0.58l-0.72,-1.5l0.55,-0.76l0.39,-2.23l0.37,-0.41l0.92,-0.21l0.43,0.98l-0.74,1.09l0.06,0.68l-0.45,0.44l-0.42,3.14l-1.76,1.59l0.33,0.71l1.37,-0.82l0.2,1.52l-0.65,0.95l0.69,0.42l-0.72,1.87l0.74,0.32l1.26,-3.14l-0.2,-1.04l0.42,-1.9l-0.07,-1.72l0.6,-1.12l0.55,0.31l-0.13,2.41l0.61,1.05l-0.18,0.66l0.58,0.46l0.39,-0.16l-0.77,1.79l0.2,3.3l-0.07,0.44l-0.93,0.89l0.27,0.63l0.51,-0.04l1.23,-1.01l-0.01,-3.42l0.96,-2.35l0.28,-0.01l1.43,0.77l-1.0,1.14l0.48,1.6l-0.11,1.13l-0.87,1.71l0.76,1.2l0.46,0.19l0.29,-0.41l-0.38,-1.22l0.66,-0.72l0.42,-2.32l-0.23,-1.02l0.78,-0.18l0.33,-0.81l-0.04,-1.56l-0.52,-1.67l0.81,-0.19l0.58,-0.61l-0.16,-0.92l-0.54,-0.67l1.11,-1.15l-0.11,-2.23l7.09,1.89l0.97,0.79l0.12,0.55l1.23,0.9l1.53,1.97l-1.07,2.38l-0.26,2.06l-2.63,-0.48l-1.51,1.0l-0.44,0.82l0.19,0.87l-0.24,1.05l-0.77,0.74l-0.04,1.35l-2.72,1.93l0.03,0.47l0.46,0.12l2.02,-0.83l1.04,-0.93l0.6,0.28l-0.84,1.94l0.09,1.23l-1.54,1.42l0.08,0.57l0.75,0.44l1.6,-1.56l0.59,-2.29l1.55,-0.85l2.23,-2.28l1.62,-0.61l0.77,0.51l0.62,-0.2l-0.0,-0.67l-0.92,-0.84l0.25,-2.25l1.7,-2.06l0.62,-0.05l0.53,0.36l1.43,3.01l-0.98,1.81l-0.07,2.43l-1.64,1.47l-0.4,2.01l-2.14,-0.37l-0.75,0.42l0.12,1.53l-0.72,1.26l0.05,0.94l-1.08,0.39l-0.32,0.54l0.45,0.64l1.24,-0.56l0.08,1.68l-0.36,0.59l0.22,0.65l0.57,-0.05l0.49,-0.64l0.37,-1.45l-0.25,-2.22l0.65,-1.71l0.81,-0.31l0.9,0.23l-0.19,4.5l0.55,1.12l-0.83,5.47l0.79,0.17l0.98,-2.69l0.33,-2.96l-0.27,-0.77l0.11,-3.1l0.14,-1.62l0.4,-0.4l-0.53,-0.75l0.08,-1.34l0.93,-0.58l2.43,-3.47l1.07,-0.64l1.83,-2.13l0.44,0.09l-0.04,0.76l-0.62,1.81l-1.33,1.96l-1.69,1.01l-0.07,0.82l0.88,1.5l-0.46,1.01l0.42,0.5l0.61,-0.15l0.97,-1.17l-1.02,-1.74l1.0,-0.35l1.13,0.25l0.37,-0.3l0.18,-1.3l0.55,-0.62l1.35,-0.47l0.09,-1.77l0.66,-0.58l0.5,0.19l1.08,-0.36l1.09,1.02l6.27,2.05l0.21,0.76l-0.55,2.69l-0.45,-1.59l-0.83,-0.0l-0.46,1.29l0.45,1.34l-0.14,0.57l-1.12,0.77l-0.93,0.17l-0.42,0.53l-0.79,0.14l-1.61,1.16l-0.33,0.68l-0.72,0.38l-1.14,1.37l-0.3,1.67l-1.25,0.89l-0.46,1.36l0.34,0.34l0.58,-0.1l0.52,-1.07l0.8,0.15l0.37,0.45l-1.04,0.07l-0.98,0.85l-0.5,0.68l0.03,0.85l-1.2,1.16l-0.21,0.6l0.46,0.49l0.96,-0.26l1.65,-2.93l0.65,-0.22l0.65,0.21l0.88,-0.75l0.06,-0.98l-0.74,-1.23l0.4,-1.35l2.94,-1.79l1.3,0.24l0.4,-0.8l1.63,-0.58l0.37,0.72l-0.53,0.89l0.08,1.44l-1.99,1.87l-1.36,3.53l-2.35,0.15l-0.71,1.11l-0.46,3.71l0.27,0.82l0.83,-0.16l0.05,-1.1l0.57,-1.29l0.07,-1.59l0.78,-0.3l0.92,0.36l1.01,-0.3l0.83,-2.49l0.58,-0.83l0.91,-0.9l1.8,0.0l0.48,-0.43l-0.19,-0.89l0.56,-1.42l1.19,-0.79l0.79,-1.54l-0.18,-0.51l-0.74,-0.16l-0.35,-0.46l0.18,-0.37l-0.26,-0.41l0.75,-2.17l0.49,0.45l1.52,0.28l3.74,3.23l0.67,1.14l1.26,1.04l1.76,3.93l-1.12,0.47l-3.27,-0.62l-1.87,0.61l-1.42,1.94l-0.35,1.64l-2.6,0.34l-3.44,3.23l-3.28,-0.02l-0.74,0.27l-1.66,1.03l-0.02,0.7l1.31,0.42l1.62,-1.27l2.97,0.23l1.92,-1.07l0.42,-0.83l1.07,-0.73l1.13,-0.24l4.87,1.63l0.88,-0.06l0.8,-0.75l3.89,-0.64l3.67,1.66l1.14,1.21l0.41,1.1l-0.24,1.15l-1.47,-0.47l-1.54,0.17l-0.56,0.6l-1.08,-0.35l-0.87,0.88l-1.11,-0.02l-4.61,-1.81l-1.08,0.52l-5.37,0.06l-1.45,2.21l0.35,0.67l0.58,-0.07l1.48,-1.85l4.11,0.37l1.46,-0.52l0.8,0.68l-3.61,0.22l-1.14,0.71l-1.28,0.14l-0.3,0.6l0.9,0.45l2.07,-0.62l-0.61,0.96l-2.12,0.83l-0.53,0.55l-0.09,0.5l0.49,0.46l0.8,-0.48l0.07,2.84l0.71,-0.2l0.37,-0.69l0.01,-2.02l2.87,-2.49l1.64,0.27l3.38,1.33l-1.21,0.42l-0.35,0.82l-1.72,-0.31l-1.14,0.25l-1.16,0.76l-0.11,0.8l0.63,0.33l1.37,-0.73l1.95,0.49l0.07,0.67l-2.9,0.05l-0.35,0.3l0.51,0.66l0.61,0.03l-1.58,0.41l-0.14,0.41l0.52,0.48l-0.14,0.2l-0.81,-0.28l-1.59,0.31l-0.85,-0.53l-2.17,-0.21l-0.71,0.41l-0.15,0.52l0.74,1.32l2.91,-0.38l-0.17,0.83l0.48,0.36l0.89,-0.69l1.43,0.15l0.92,-0.36l3.0,0.22l-1.22,1.14l-2.02,-0.24l-1.06,0.51l-0.38,0.94l-0.57,0.4l0.31,0.64l0.92,0.07l0.4,0.37l2.29,-0.4l0.45,-0.89l1.59,0.19l0.47,0.56l1.29,-0.08l0.56,2.64l0.45,-0.14l0.34,-0.74l-0.22,-2.22l1.09,-0.75l0.63,0.18l-0.53,0.96l0.8,2.28l-1.1,0.65l-0.51,0.76l-0.03,0.89l0.34,0.61l0.69,-0.03l0.43,-1.26l0.67,-0.18l0.14,0.43l-0.73,0.86l0.47,0.42l0.32,-0.1l0.96,-0.69l-0.06,-1.12l0.61,-0.89l0.58,0.43l0.56,-0.92l0.88,0.18l-0.89,0.38l-0.58,1.2l0.12,1.99l-1.14,-0.14l-0.59,0.34l0.1,0.64l0.48,0.23l1.36,0.22l0.58,-0.3l0.47,-1.62l-0.32,-0.9l1.34,-1.3l1.77,0.49l-0.19,1.15l0.27,0.98l-0.64,1.3l0.17,1.06l0.41,0.45l0.55,-0.08l0.1,-1.17l0.73,-1.16l0.3,0.93l-0.13,1.2l0.15,0.43l0.45,0.01l0.62,-0.83l-0.17,-2.76l1.41,-0.1l-0.74,0.51l-0.22,0.63l1.11,0.26l0.72,-0.6l0.55,0.95l-0.69,0.91l-0.07,2.22l-1.92,-0.02l-0.56,0.43l0.09,0.64l2.05,0.54l0.72,-0.18l0.32,0.77l0.47,0.14l0.42,-0.47l-0.33,-1.25l0.0,-2.22l1.35,-1.57l-0.2,1.04l1.08,1.38l0.16,3.19l0.5,1.59l0.65,0.46l0.41,-0.68l-0.7,-3.48l0.87,-1.12l0.11,-0.9l-0.49,-1.05l0.62,-0.77l1.07,-0.25l0.15,2.93l-0.33,1.24l0.53,0.72l1.28,0.62l1.09,1.89l0.65,0.25l0.41,-0.64l-0.92,-2.03l-1.79,-1.22l0.3,-2.6l1.38,-1.36l0.02,-1.16l0.51,-0.86l2.04,0.52l-0.69,0.76l-0.86,0.09l-0.59,0.55l0.16,0.62l0.72,0.08l-0.19,0.72l-0.71,0.32l0.09,1.47l0.5,0.36l0.55,-0.57l-0.9,2.0l0.42,1.53l0.37,0.23l0.54,-0.3l-0.09,-1.47l0.59,-0.57l0.05,-0.77l0.46,-0.59l0.38,0.45l-0.09,1.22l0.5,0.27l0.58,-0.27l0.26,-0.7l-0.35,-1.86l0.48,-0.44l1.86,0.93l-1.5,1.87l0.5,0.54l1.95,-1.32l0.24,-0.55l0.64,0.87l-0.19,1.03l0.5,0.16l1.03,-0.39l0.25,1.77l-0.68,0.8l-1.33,0.11l-0.36,0.33l0.23,0.43l1.32,0.31l1.94,-0.85l1.02,1.54l-0.3,0.73l-5.62,0.57l-0.51,0.47l0.32,0.64l3.99,-0.1l-0.41,0.42l-1.21,0.14l-1.79,1.38l-0.28,0.52l0.3,0.55l0.68,0.01l1.27,-1.17l2.68,-1.09l-2.83,2.39l-0.4,0.71l-0.09,1.02l0.38,1.42l0.39,0.36l0.78,-0.41l-0.06,-1.81l0.36,-0.86l1.17,-0.53l1.27,-1.21l1.42,-0.48l0.36,-1.11l0.95,0.13l0.52,-0.56l1.08,-0.44l0.37,0.8l-0.23,1.29l-1.16,1.76l-0.17,1.27l0.52,0.87l0.49,0.08l0.04,-1.63l1.16,-1.2l0.61,-1.4l-0.25,-2.7l0.37,0.19l0.65,-0.46l0.26,-0.66l-0.17,-0.83l0.79,0.36l0.48,1.0l-0.21,1.05l-1.18,1.04l-0.24,0.75l1.15,2.57l-0.16,0.48l-1.81,1.45l0.05,1.54l-1.36,0.35l-0.27,0.35l0.46,0.73l1.96,-0.42l0.72,-0.73l0.3,2.11l0.53,0.34l0.37,-0.19l0.23,-2.4l-0.53,-1.52l2.68,-2.39l1.05,2.86l0.25,3.22l0.61,0.48l0.64,-1.37l-0.29,-0.87l0.22,-1.52l-0.93,-2.78l0.9,-0.23l1.02,1.69l0.75,0.3l1.17,1.39l0.85,-0.11l-0.18,-1.16l-1.5,-1.3l-0.35,-0.7l0.01,-0.4l0.88,-0.85l-0.59,-1.65l0.99,-0.64l0.34,0.06l-0.0,2.25l0.25,0.44l0.75,0.09l0.21,0.46l0.45,0.11l0.51,-0.57l1.97,-0.44l-0.69,0.81l0.27,0.36l0.85,0.23l1.05,-0.23l2.61,2.39l0.07,0.53l-0.74,0.62l-0.1,0.59l-0.67,0.16l-0.62,-0.81l-1.02,-0.6l-1.28,0.03l-1.19,-0.43l-0.45,0.2l-0.05,1.01l-0.88,0.62l-0.15,0.45l0.34,0.4l0.77,0.13l0.56,-0.29l0.29,-0.8l1.16,-0.0l2.51,1.93l-0.79,0.38l-0.26,0.53l-0.94,0.21l-0.77,1.17l0.32,0.4l0.56,0.05l0.67,-0.53l2.09,-0.67l0.46,0.39l-0.13,0.23l-0.45,0.05l-0.34,0.53l-0.95,0.19l-0.36,1.09l-0.33,0.13l-1.31,-0.42l-0.75,0.49l-0.37,-1.07l-0.57,-0.48l-3.33,0.22l-0.77,0.93l0.09,0.59l1.19,0.3l0.67,-0.67l0.31,0.6l1.23,0.69l-0.19,0.37l-1.47,1.5l-0.57,-0.21l-1.12,-1.43l-0.84,0.01l-0.31,0.51l1.33,1.68l1.21,0.78l0.64,-0.08l0.73,-0.72l1.88,0.66l1.22,-0.23l0.27,0.77l0.7,0.14l0.04,0.78l0.47,0.13l-0.85,0.26l-0.63,0.76l-0.72,-0.45l-1.16,-0.01l-0.87,0.35l-0.62,-0.19l-0.59,0.4l-0.99,-1.4l-0.91,-0.43l-1.15,1.0l0.32,0.7l0.94,-0.35l1.44,1.67l2.47,-0.39l0.45,0.44l0.57,-0.05l-0.09,0.93l0.73,0.34l0.7,0.91l-0.79,0.63l-0.35,-0.32l-0.85,0.4l-1.78,-1.23l-0.7,-0.08l-0.18,0.94l0.63,0.72l2.55,1.16l-1.81,-0.21l-0.36,0.52l-0.82,0.15l1.03,2.77l-0.49,-0.42l-1.44,0.23l-2.78,-3.16l-0.84,-1.54l-0.5,-0.23l-0.52,0.4l0.32,1.56l1.97,2.25l0.15,0.61l-2.48,0.81l-0.08,0.55l0.87,0.62l0.76,-0.35l0.71,0.3l0.93,-0.36l0.34,0.34l0.03,0.84l-0.51,0.28l-0.81,-0.86l-0.68,-0.1l-0.31,0.51l0.26,1.11l0.97,0.67l-0.85,0.57l0.22,0.54l1.41,0.54l-0.12,0.47l0.51,0.46l1.03,0.41l-0.42,0.7l0.62,1.36l-0.54,0.45l0.71,1.05l0.88,-0.01l-0.39,0.45l0.28,2.2l-0.28,0.51l-0.72,-0.48l-0.97,0.83l0.81,-0.76l-0.09,-0.71l-0.28,-0.1l-0.91,0.15l-0.35,0.55l-0.37,-0.89l0.29,-1.65l-0.41,-0.45l-0.88,0.34l-0.39,1.72l-0.85,-0.15l-0.04,1.3l-0.79,-0.78l0.87,-1.93l-0.86,-0.2l-1.53,1.14l-0.49,-2.36l0.44,-1.52l-0.09,-0.98l-0.54,-0.34l-0.57,0.35l-0.21,1.79l-0.5,0.64l0.46,3.9l-0.35,-0.23l-0.25,-0.91l-0.71,-0.18l0.32,-0.69l-1.21,-0.53l-0.46,0.34l-0.08,0.5l-0.2,-0.12l-0.13,-0.62l0.76,-0.15l0.51,-0.78l-0.4,-0.58l-0.62,0.07l1.07,-1.21l1.3,-0.26l0.14,-1.53l-0.67,-0.44l-0.45,0.73l-1.47,0.31l-0.2,0.66l-1.39,0.65l-0.79,1.14l-0.68,-0.57l-0.39,-0.92l1.43,-0.95l0.34,-1.28l0.29,-0.01l0.24,-0.63l-0.5,-0.51l0.75,-0.49l0.05,-0.53l-0.45,-0.29l-1.35,0.38l-0.53,2.51l-1.2,0.35l-0.18,-0.92l0.55,-0.48l-0.03,-0.73l0.68,-0.76l1.26,-0.6l-0.05,-0.89l-0.6,-0.08l-1.44,0.68l-0.69,0.69l-0.34,0.97l-1.71,0.12l0.07,-1.83l-0.26,-0.33l-0.64,0.13l0.37,-2.25l2.59,-2.46l1.07,0.37l0.82,-0.31l-0.14,-0.66l-0.98,-0.6l-0.07,-3.39l0.88,-1.88l1.13,-1.23l0.17,-0.62l-0.43,-0.52l-1.04,0.55l-1.7,1.85l-0.54,2.08l0.28,1.6l-0.49,0.74l-0.53,0.21l-1.05,1.26l-0.61,-0.13l-0.68,1.47l-3.63,1.59l-0.61,-1.34l0.16,-0.77l1.74,-2.36l0.51,-2.99l-0.49,-1.87l-0.63,-0.04l-0.19,0.3l-0.42,4.19l-1.06,1.41l-0.79,0.5l-0.92,-0.13l-1.04,-1.14l0.36,-1.37l-0.28,-0.43l-0.47,0.19l-0.44,0.81l-1.47,-0.11l-0.31,-0.53l0.09,-0.6l-0.8,-0.16l0.76,-0.76l-0.28,-0.66l-0.57,-0.04l-1.29,1.36l-0.01,-1.4l-0.56,-0.34l-0.51,0.52l-0.5,-1.59l0.51,-0.99l-0.3,-0.45l-1.13,0.24l-1.9,-0.65l-0.33,0.65l1.6,1.05l-0.31,0.34l-1.32,0.44l-0.96,-0.27l-0.44,-0.62l-1.0,0.37l-0.97,-0.57l-0.35,0.72l-0.41,0.04l-0.88,0.98l0.65,0.65l2.65,-0.4l0.67,0.17l0.43,0.79l0.92,0.48l0.1,0.44l-1.41,-0.44l-0.43,0.14l-0.2,0.59l0.75,0.81l1.79,0.67l-0.75,0.54l-0.54,-0.39l-0.26,0.21l-0.91,-1.3l-1.66,-0.97l-0.49,0.25l-0.72,-0.19l-0.62,-1.05l-1.11,0.17l-0.48,0.54l0.16,0.52l1.09,0.64l0.41,0.86l0.93,0.76l0.75,1.19l-0.05,1.05l3.15,1.69l1.16,0.19l1.0,1.25l-0.47,0.3l-0.05,0.71l0.77,0.63l-0.39,0.18l-0.74,-0.28l-0.37,0.99l-0.95,0.19l-1.16,-0.82l-0.63,0.35l0.43,1.06l-0.27,0.32l-0.63,-0.16l-1.24,-1.61l-0.02,-1.8l-2.32,-0.81l-0.78,-1.44l-0.63,-0.01l-0.45,0.44l-0.58,-1.04l-0.78,-0.51l-0.46,0.21l-0.07,0.49l0.68,1.2l-2.72,1.06l0.31,0.64l1.36,0.11l1.7,-0.77l1.93,1.66l0.6,0.1l0.38,-0.45l-0.28,-0.56l0.87,0.64l0.01,0.33l-0.54,0.04l-0.39,0.57l-0.64,-0.57l-0.57,0.19l-0.0,0.66l0.71,0.87l-0.18,1.0l0.76,0.68l0.89,-0.25l0.01,0.91l0.43,0.29l-0.42,0.73l0.54,0.41l1.6,-0.08l0.54,-0.43l-0.36,0.54l0.05,1.05l0.82,0.33l0.16,0.5l-0.66,0.16l0.09,0.71l-0.45,0.82l0.21,0.56l0.59,0.06l-0.25,1.07l0.52,0.44l0.48,-0.36l0.63,-1.97l0.54,-0.28l0.22,-1.04l1.25,-0.75l0.34,0.18l0.51,-0.36l-0.01,-0.43l1.0,0.28l0.17,0.33l-0.46,0.83l0.21,0.36l-0.75,1.49l1.43,0.98l1.73,-0.66l0.42,0.5l-0.07,0.64l-1.38,0.37l-0.81,0.55l-0.19,0.59l0.48,0.5l0.61,0.1l0.61,-0.72l0.74,0.38l0.35,1.8l0.85,0.37l0.46,-0.4l0.55,0.1l0.19,1.06l-0.71,0.4l-0.23,1.29l0.55,0.26l0.7,-0.62l0.72,0.5l0.95,-0.02l0.51,0.75l-0.6,0.81l1.04,0.41l-0.1,0.9l1.14,2.04l0.78,-0.07l0.29,-0.88l-0.6,-0.62l-0.38,-2.84l-0.48,-0.75l0.52,0.19l0.2,0.82l0.71,0.45l1.39,0.04l0.33,0.84l0.58,-0.07l0.19,-0.62l0.31,0.19l0.21,1.48l-0.91,0.24l-0.16,0.68l1.08,0.23l0.57,1.18l0.44,0.07l0.46,-0.4l-0.13,-1.23l0.04,-0.29l0.53,1.04l0.72,-0.24l1.34,1.16l0.43,0.03l0.32,-0.41l-0.12,-0.55l-1.12,-1.21l0.19,-0.62l-0.72,-0.54l0.08,-0.66l-0.29,-0.39l0.28,-0.12l0.38,1.13l0.64,-0.23l-0.13,1.01l0.57,1.12l0.5,0.15l0.28,-0.49l-0.19,-1.12l0.42,0.49l0.19,1.22l-0.28,0.81l-0.75,0.64l0.96,2.23l0.44,0.16l1.17,-0.56l0.27,0.32l0.64,-0.18l0.3,0.54l0.57,-0.17l0.21,-0.59l0.53,-0.02l0.26,-0.45l0.94,-0.02l0.08,0.44l-1.15,0.7l-0.12,0.55l0.92,0.72l-0.06,0.57l-2.62,0.09l-0.89,0.66l-0.13,0.65l0.51,0.23l1.18,-0.44l-0.61,0.48l0.09,0.63l0.62,0.14l1.03,-0.41l0.67,0.31l-0.54,1.3l0.48,0.28l0.61,-0.22l0.29,-0.59l0.32,0.21l0.6,0.66l-0.19,0.32l0.26,0.52l-0.3,0.64l0.37,0.4l2.23,-0.34l0.04,0.74l0.46,0.02l0.61,-0.53l0.29,-0.81l0.34,0.24l0.56,-0.38l0.18,0.22l-1.53,1.95l0.09,0.7l-0.52,0.44l-0.03,0.88l0.95,0.96l1.69,0.18l0.45,-0.24l1.74,1.04l0.2,0.48l-0.47,0.7l0.53,0.51l1.11,2.71l-0.7,-0.07l-0.27,0.71l0.43,0.55l0.85,0.13l0.2,0.39l-0.88,0.25l0.13,0.61l0.9,0.27l-0.51,0.23l-1.11,-0.91l-1.52,-3.1l-1.23,-1.15l-0.37,-1.05l-1.5,-0.75l-1.36,-1.84l-1.5,-0.2l-0.37,0.51l2.03,1.66l0.73,1.05l1.02,0.59l-0.64,0.99l0.77,1.77l-0.59,0.67l0.78,0.94l0.8,-0.19l0.98,1.22l-0.73,-0.32l-0.46,0.27l0.06,0.47l-0.32,0.02l-0.27,0.66l0.9,0.88l0.37,0.84l0.53,0.26l0.95,-0.38l0.41,0.63l0.73,-0.1l-0.41,0.25l0.02,0.64l0.6,0.27l0.38,0.75l-0.06,1.3l1.26,0.59l-0.07,0.52l-0.77,0.16l-1.95,-0.91l-0.65,-0.89l-0.62,0.28l-0.04,0.62l-0.58,-0.65l-0.66,0.31l0.13,0.75l1.08,0.83l0.25,0.9l2.55,2.45l0.58,1.08l-1.04,1.6l-0.51,-0.36l-1.04,-1.83l-0.26,0.05l0.42,-1.04l-0.23,-0.6l-0.58,-0.02l0.44,-0.38l-0.29,-0.64l-0.56,0.01l-0.36,-1.34l-0.79,0.23l0.01,1.36l-1.22,0.77l-0.71,-1.25l-0.78,-0.08l0.19,-1.27l-0.76,-1.4l-0.61,0.13l-0.18,0.73l-0.45,-0.23l-0.42,0.2l-0.71,1.16l-0.47,-1.12l-0.77,0.16l-0.45,-0.76l-1.37,-0.58l-0.46,0.33l0.1,0.53l0.81,0.59l0.39,0.91l1.11,0.62l-0.01,0.38l-1.22,-0.65l-1.0,0.15l-1.14,-0.99l0.1,-0.36l-0.96,-1.06l-0.25,-1.14l-1.39,-0.99l0.13,-1.28l-0.27,-0.63l-0.71,0.03l-0.26,2.36l-0.41,-0.2l-0.42,0.46l0.11,0.93l0.59,0.94l-1.38,-1.03l0.36,-0.84l-0.65,-0.78l-0.28,-1.63l-0.55,-0.11l-0.39,0.37l0.37,2.04l-0.91,-0.42l-0.28,0.26l-1.34,-1.03l-0.81,-1.45l-0.68,0.04l-0.09,0.29l-0.63,-1.12l-0.82,-0.47l-0.87,-1.14l0.03,-0.36l-0.6,-0.38l-0.47,0.39l-0.36,-0.77l-1.44,-1.18l-0.47,0.04l0.07,0.87l1.36,1.69l0.37,1.43l1.98,3.03l-0.7,-0.34l-1.51,-1.66l-1.45,-0.62l-0.54,-0.85l-0.79,0.11l-1.1,-1.62l-0.52,0.0l-0.2,0.94l-0.57,-0.9l-0.72,-0.44l-0.63,-0.06l-0.22,0.29l-1.62,-0.51l-0.41,0.53l0.22,0.44l-1.37,-0.23l-0.86,0.53l0.28,0.7l1.76,1.39l-0.23,0.39l0.17,0.49l0.68,0.2l0.91,1.08l2.22,1.24l2.37,2.05l0.24,0.75l0.79,0.39l0.03,0.8l1.12,0.68l1.56,-0.11l-0.1,0.91l0.36,0.54l0.7,-0.17l0.29,-0.85l1.0,0.23l-0.45,0.99l0.92,1.52l0.5,-0.1l0.68,0.63l0.75,-1.18l0.81,-0.52l0.2,0.78l0.61,-0.08l0.53,0.41l-0.52,0.84l0.87,0.23l0.76,-0.65l-0.25,1.11l1.32,-0.23l-0.1,0.7l1.05,0.37l-0.12,0.95l0.64,0.13l0.45,0.65l1.61,-0.83l0.0,0.32l0.98,0.54l0.57,-0.07l0.86,0.74l0.78,0.84l0.17,1.5l0.47,0.27l0.64,-0.59l0.44,0.48l-0.91,0.86l0.36,0.76l1.38,0.89l0.73,-0.19l0.97,0.4l1.26,-0.01l0.43,-0.41l0.32,0.26l-0.68,1.24l0.31,0.86l-0.75,-0.65l-0.59,0.21l-0.04,0.81l1.15,0.98l0.1,0.93l0.59,0.08l1.36,1.14l-2.31,1.17l-1.19,-0.02l-1.96,-0.5l-0.18,-0.64l-0.76,0.1l-0.74,-0.72l-0.98,0.11l-0.95,-0.31l-1.0,0.15l-0.36,0.42l-1.57,-0.92l-0.43,0.51l-0.19,-0.76l-0.37,-0.24l-1.45,0.23l-1.14,-0.4l-0.65,0.6l-0.58,0.05l-0.88,-0.71l-0.48,0.37l-1.37,0.08l-0.3,-0.27l-4.39,0.62l-1.38,-0.54l-0.35,-0.62l-0.83,-0.02l-0.59,-0.69l-1.57,0.4l-1.67,-0.82l-0.9,-0.67l-0.37,-0.78l0.01,-1.34l-0.41,-0.53l-0.69,0.38l0.03,0.7l-0.84,-0.79l-0.43,0.1l-0.06,0.34l-0.5,-0.52l0.54,-0.05l0.56,-0.86l-0.33,-0.54l0.56,-0.63l-0.41,-0.62l-1.57,0.32l-0.59,-0.3l-0.84,0.31l-0.99,-0.56l-0.6,0.13l-0.08,0.55l0.4,0.55l-0.43,-0.42l-0.69,0.11l-0.75,1.07l-1.42,0.12l-2.52,-1.63l-2.54,0.01l0.2,-0.45l-0.42,-0.29l-1.26,-0.11l-0.19,-1.13l-0.44,-0.35l0.09,-0.64l0.92,-1.25l-1.32,-0.83l-0.81,0.48l-0.15,1.58l-1.2,-0.09l-0.26,1.25l-1.15,-0.07l-0.18,-1.19l-1.64,0.01l-0.98,-0.46l0.16,-0.38l-0.55,-0.5l0.38,-0.78l-0.43,-0.4l-0.72,0.02l-0.4,-2.19l1.07,-0.27l0.43,-1.0l1.14,-0.67l0.04,-0.69l0.85,-1.06l0.17,-1.27l-1.84,-0.43l-0.49,0.48l-0.77,-0.38l0.15,-1.01l-1.4,-0.33l-0.26,-0.37l-0.69,0.23l-1.64,-1.22l-0.78,0.57l-0.18,1.32l-0.58,0.16l-0.56,-0.73l-0.58,-0.07l0.18,-1.23l0.67,-0.43l0.15,-1.02l-1.09,0.32l-0.3,-0.9l-0.73,0.09l-0.09,1.16l-0.29,0.12l-0.5,1.5l-1.46,-0.6l-0.29,-0.72l0.3,-0.52l-0.12,-1.52l-0.29,-0.44l-0.46,0.04l-0.14,-0.85l-0.61,-0.22l-0.3,0.38l0.07,1.25l-0.64,-0.07l-0.3,-0.49l-0.38,-0.02l0.36,-0.74l-0.74,-1.53l-1.28,-0.25l-0.15,-0.78l-0.54,-0.29l-0.09,-0.5l-0.94,-0.22l-0.64,-0.63l-0.1,-0.62l-1.13,-0.55l0.59,-0.94l-0.47,-0.58l1.2,-2.13l-0.2,-0.61l-0.64,-0.11l-0.19,0.29l-0.44,-0.98l-0.45,-0.19l-0.61,0.96l0.68,1.51l-0.77,-1.17l-0.6,-0.01l-0.38,0.42l-0.59,-0.93l-0.67,-0.23l-0.44,0.46l0.28,1.74l-0.36,0.2l-1.32,-0.94l-0.59,0.55l-0.62,-0.56l-0.09,-1.88l-0.72,-0.6l-0.54,0.23l0.09,1.16l-0.44,0.47l-0.63,-0.22l-0.48,0.18l-0.14,0.48l-0.66,-0.0l0.04,0.68l-0.35,0.24l-0.37,-0.75l-1.23,-1.03l0.67,-1.75l0.44,0.01l0.34,-0.68l-1.19,-1.24l-0.75,0.01l-0.43,0.26l-0.01,0.6l-0.54,0.34l0.21,1.06l-0.35,-0.12l-0.46,0.42l-1.02,-0.08l-0.31,0.63l0.52,0.68l0.87,0.22l0.66,0.94l0.67,0.18l2.29,1.83l-0.87,0.05l-0.38,0.54l0.62,1.27l0.61,0.28l-1.02,1.15l-0.58,-0.18l-0.27,0.34l-0.81,-0.66l-0.63,0.17l-1.87,-1.07l-0.56,0.74l-1.02,-0.83l-1.61,-0.36l-0.69,-0.54l-0.47,0.19l-1.45,-0.83l-0.42,0.13l-0.24,0.53l0.31,1.11l0.3,0.69l0.95,0.49l-1.44,-0.25l-0.25,0.79l0.76,0.38l0.57,0.88l-1.41,-0.29l-0.61,0.68l-0.48,-0.21l-1.39,0.98l-0.7,-0.03l-0.16,0.85l-1.87,0.48l-0.17,0.38l-0.81,-0.01l-0.13,0.84l0.38,1.0l-1.71,-1.01l-0.65,0.23l-1.0,-0.62l-1.67,1.18l-0.35,-1.07l-0.42,-0.32l-0.55,0.21l-0.31,-0.61l-1.4,-0.53l-0.54,0.33l-0.11,0.67l-1.01,-0.4l0.3,-0.51l-0.13,-0.45l-1.38,0.16l0.23,-0.61l-1.02,-0.96l-0.17,-0.72l-0.74,-0.26l0.25,-0.48l-0.71,-1.26l0.18,-0.51l-0.36,-1.21l0.78,-1.48l-0.02,-0.51l-0.63,-0.89l-0.31,-1.18l1.12,-1.37l0.09,-0.51l1.93,-1.4l0.53,-0.81l1.09,-0.13l1.43,-1.19l0.04,-0.68l-1.92,-2.13l0.17,-0.67l0.89,0.2l0.6,-0.67l-0.27,-0.66l-0.98,-0.8l1.41,0.15l1.07,0.66l1.04,-0.06l0.45,-0.49l0.53,-0.05l0.56,0.41l0.84,-0.19l7.68,2.38l0.82,1.41l1.83,0.64l0.68,0.6l0.41,1.5l-0.5,0.55l-1.05,-0.06l-0.33,0.78l0.52,0.45l0.49,1.17l0.99,0.07l-0.49,0.9l0.31,0.61l0.65,0.05l0.66,0.87l0.44,0.03l0.79,-0.44l0.11,-0.67l-0.95,-1.79l-0.05,-1.5l-0.68,-0.39l0.15,-0.29l0.71,0.28l0.39,-0.55l-0.32,-0.58l0.51,-1.52l-0.13,-0.91l-0.6,-0.33l-0.65,0.41l-0.15,1.57l-1.94,-2.57l-1.32,-0.45l-0.48,-0.65l-1.23,-0.36l-0.25,-0.41l1.27,-0.02l0.51,-0.38l0.8,0.76l3.17,0.01l1.07,-0.93l0.1,-1.11l-0.32,-0.89l0.62,0.17l0.8,-0.53l0.54,0.15l0.59,-0.33l0.55,0.78l1.37,0.15l1.54,-1.96l0.16,-1.33l1.1,-0.55l0.05,-0.78l1.06,0.43l0.77,-0.72l0.75,0.05l0.97,1.1l0.83,-0.3l0.89,0.2l0.39,-0.27l-0.26,-1.16l-1.44,-2.04l-0.09,-0.93l-0.73,-0.35l0.12,-0.99l-0.68,-0.93l-1.2,-0.81l-1.56,-0.46l-2.13,-2.36l-1.97,-1.59l-0.53,-0.93l0.68,-1.51l1.82,-1.83l4.2,-6.04l0.47,-2.31l1.53,-1.58l1.19,-0.4l0.14,-0.56l-0.7,-1.39l0.54,-2.21l0.16,-2.48l0.69,-0.74l2.1,-0.9l0.84,-1.86l-0.22,-1.08l0.38,-0.95l-0.16,-0.63l-1.36,-0.67l-1.07,-2.69l-0.58,-0.53l0.34,-0.96l-0.93,-1.74l-0.87,-0.24l-0.62,-0.6l-0.11,-0.45l0.44,-0.66l-0.32,-1.05l-1.63,-1.76l-0.77,0.29l-0.32,-0.47l-0.38,-2.29l-1.67,-4.46l-0.46,-0.24l-0.81,0.54l-0.62,-0.91l-0.94,-0.19l0.26,-0.39l-0.17,-0.72l0.62,-0.33l-0.15,-0.42l-0.7,-0.39l-0.47,0.04l-0.49,0.94l0.06,0.55l-0.73,0.33l-0.21,0.76l-2.05,-0.67l-0.84,-1.08l0.22,-1.54l0.88,-0.77l-0.12,-0.73l-0.36,-0.28l0.16,-1.79l-0.79,-1.05l-3.03,-0.48l-0.5,0.19l-0.27,0.58l2.86,3.0l-0.06,0.55l-0.47,-0.39l-1.3,0.49l-1.25,-0.17l-0.57,-0.73l-0.57,-0.2l-0.41,-1.24l-1.53,-1.09l-0.07,-0.41l0.81,-0.62l0.17,-1.14l-0.42,-0.46l-0.73,-0.12l-0.42,-1.6l-0.71,-0.12l-0.51,0.29l-0.0,-0.54l-0.73,-0.08l0.55,-0.29l0.4,0.27l1.02,-0.53l0.24,-0.48l-0.4,-0.87l-1.32,-0.65l-0.99,0.48l-1.02,1.51l-0.14,2.43l-2.3,-2.24l-0.78,0.0l-0.62,0.99l0.62,1.23l-0.47,0.78l-1.31,1.23l-0.97,0.45l-0.55,1.14l-1.93,1.88l-1.75,0.63l-0.45,-1.23l0.57,-1.24l0.12,-1.44l-0.97,-0.74l-0.22,-1.81l1.19,-0.86l1.8,0.01l0.84,0.62l0.73,-0.12l1.19,-1.21l0.2,-0.69l1.15,-0.16l0.37,-0.54l0.02,-1.27l-0.53,-1.86l-0.96,-1.14l-2.45,-1.54l-1.7,-0.62l-1.39,0.45l-0.59,-1.14l-1.49,-1.35l-0.04,-0.67l0.74,-1.28l1.85,0.5l0.34,-1.26l-0.4,-0.58l-1.22,0.13l-0.53,-0.6l-1.73,0.58l-0.26,0.56l0.46,0.5l0.4,-0.08l-0.69,0.58l-0.11,1.06l-0.82,-0.16l0.33,-0.57l-0.16,-0.5l-0.93,0.3l-0.45,0.57l-0.34,-0.58l-0.92,-0.04l1.0,-0.68l0.53,0.26l0.58,-0.25l0.62,-1.2l-0.21,-0.88l-0.74,-0.19l0.81,-0.68l-0.14,-0.82l-0.48,-0.18l-1.25,0.55l0.09,-0.34l-0.49,-0.48l-0.69,0.29l-0.36,0.55l-0.66,-0.06l1.88,-1.51l0.2,-0.52l-0.5,-0.52l-3.53,2.22l-0.73,0.8l-1.32,-7.62l-0.89,-1.06l-0.81,-0.25l-0.68,0.2l-0.56,0.69l-1.16,-0.49l-0.31,0.65l-0.65,0.39l-1.01,-1.45l0.72,-0.54l-0.2,-0.6l-0.89,-0.28l-0.77,0.25l-1.43,-2.18l-0.46,0.15l-0.16,-0.38l-0.63,-0.11l-0.21,0.51l-0.39,0.0l0.02,-0.94l0.69,-0.19l0.23,-0.7l0.65,0.38l0.67,-0.32l-1.17,-2.05l-0.24,-0.18l-0.69,0.3l-0.48,-1.0l-0.73,0.09l-0.82,1.32l0.23,0.67l0.74,0.04l-0.47,1.38l-0.55,-0.77l-0.72,0.44l0.03,1.14l-0.75,0.13l0.01,0.65l-0.55,0.17l-0.47,0.63l-0.06,0.83l1.16,1.13l0.61,0.2l0.43,-0.39l1.24,1.09l0.8,-0.07l0.41,-0.55l0.33,0.25l1.65,2.55l0.39,2.11l0.69,1.33l-0.08,1.72l-0.52,0.66l-4.35,0.59l-1.6,0.86l-1.74,-2.45l-0.55,-0.05l-0.35,0.45l-0.46,-0.8l-1.34,-0.07l-0.86,0.48l-1.6,-1.01l-1.92,0.03l-0.77,-0.32l-0.65,0.27l-0.31,-0.61l-0.8,0.21l-2.96,-0.16l-1.17,-0.45l-0.6,0.18l-0.19,0.63l0.72,1.13l0.95,0.16l1.16,1.27l0.47,-0.07l0.5,-0.6l0.69,0.48l0.61,1.42l2.84,2.71l-0.04,0.5l-0.53,0.47l-1.01,-0.79l-0.79,-1.21l-0.86,-0.35l-1.72,-1.57l-0.61,-0.06l-0.07,-0.83l-0.56,-0.19l-0.79,0.22l-2.88,-2.78l-3.45,-1.36l-3.58,-2.36l-0.7,0.21l0.08,0.45l2.03,2.2l0.69,-0.04l3.53,1.7l1.43,1.03l1.4,1.69l1.11,0.35l-0.83,1.43l-0.97,-0.26l-0.92,1.2l-1.07,-0.71l-0.99,0.26l-1.64,-1.29l-0.67,0.01l-0.98,-0.6l-1.1,-1.1l-1.17,-0.16l-1.0,0.22l-0.47,0.65l-2.09,0.89l-3.02,-0.68l-2.06,0.14l-1.18,-0.39l-1.18,0.11l-0.91,-0.58l-0.1,-0.31l0.49,-0.65l-0.36,-0.74l-0.5,0.06l-0.78,1.02l-2.79,-0.72l-3.39,0.36l-0.74,0.52l0.03,1.0l-2.42,-1.57l-2.06,-2.53l-0.29,-2.53l0.45,-1.09l0.92,-0.54l0.59,-0.83l-0.18,-0.85l-0.58,-0.55l-0.52,0.04l-0.17,0.59l0.3,0.44l-1.61,1.29l-0.54,1.08l-0.07,-0.35l-0.83,-0.11l-0.42,-0.63l0.14,-0.5l-0.63,-0.54l-0.68,0.08l-0.91,0.67l-0.12,0.72l-0.56,0.29l-0.16,0.74l0.33,0.31l1.43,-0.04l0.14,1.23l-3.28,-0.82l-2.11,-0.01l-0.46,0.4l-3.84,-2.75l-2.22,-0.36l-1.4,-1.55l-0.77,-2.5l-2.1,-2.54l-0.99,-2.59l1.3,-0.38l0.48,-1.01l-2.06,-2.13l1.08,0.15l0.09,0.48l0.89,0.54l1.49,-0.44l0.64,0.29l1.33,-0.38l1.43,0.48l0.66,1.5l3.26,0.51l1.56,-0.59l2.27,0.19l0.39,-0.25l0.31,-1.1l1.65,0.38l0.43,-0.25l-0.01,-0.62l-2.26,-0.87l-3.09,-2.1l-0.64,-0.98l0.1,-1.55l-0.33,-0.37l-0.98,0.11l-0.93,1.12l-2.87,-0.63l-0.8,0.19l-8.42,-2.04l-0.92,-2.4l0.28,-1.64l-0.49,-1.28l1.6,-3.77l-0.7,-0.74l0.04,-0.56l-0.44,-0.27l-0.06,-0.61l-1.0,-1.53ZM474.89,330.28l0.28,0.24l0.75,0.17l-1.05,0.62l-0.53,-0.59l0.54,-0.44ZM473.1,330.1l-0.24,-0.03l-0.02,-0.02l0.2,-0.03l0.05,0.07ZM482.98,328.72l0.11,0.5l-0.87,0.03l-0.03,-0.17l0.79,-0.36ZM489.76,335.68l1.57,-0.65l1.38,0.68l-1.06,-0.2l-1.35,0.52l-0.55,-0.35ZM516.89,338.24l0.08,0.2l-0.05,0.1l-0.02,-0.01l0.0,-0.29ZM550.53,335.08l0.41,-0.09l-0.17,0.82l-0.12,-0.36l-0.11,-0.37ZM574.57,352.21l0.32,0.6l-0.22,0.09l-0.34,-0.24l0.25,-0.45ZM587.4,361.26l-0.15,0.27l-0.05,0.15l0.03,-0.41l0.16,-0.01ZM582.66,432.03l-0.03,0.04l0.02,-0.03l0.02,-0.01ZM595.94,436.99l0.4,0.28l0.14,0.44l-0.7,-0.42l0.16,-0.3ZM596.67,437.96l0.17,0.24l-0.2,0.4l-0.6,0.52l-0.32,-0.49l0.66,0.03l0.28,-0.7ZM596.17,440.05l0.05,1.42l-0.31,0.11l-0.08,-0.87l0.34,-0.66ZM595.8,441.61l-0.03,-0.02l0.04,-0.0l-0.01,0.02ZM601.28,436.5l-0.0,0.18l-0.07,0.04l0.01,-0.01l0.06,-0.21ZM601.6,439.23l-0.21,0.44l-0.21,-0.16l0.05,-0.3l0.37,0.02ZM602.6,440.59l-0.02,0.19l-0.36,0.35l-0.06,-0.15l0.44,-0.39ZM602.33,441.58l0.22,0.2l0.05,0.16l-0.23,-0.16l-0.03,-0.2ZM611.97,449.62l0.04,0.02l-0.04,0.01l0.01,-0.03ZM613.64,450.53l0.12,0.98l-0.1,0.01l-0.22,-0.97l0.21,-0.02ZM615.77,450.38l0.09,-0.01l-0.03,0.11l-0.01,-0.03l-0.04,-0.08ZM616.5,450.11l0.17,-0.03l-0.0,0.12l-0.01,0.01l-0.15,-0.11ZM620.7,451.92l0.0,0.12l-0.28,0.07l-0.0,-0.12l0.28,-0.07ZM662.94,449.05l1.26,0.8l0.05,0.79l0.54,0.66l0.04,0.32l-0.31,-0.09l-0.41,0.59l-0.41,-1.74l-0.76,-1.32ZM672.48,451.57l0.27,0.56l-0.74,0.85l0.19,-0.89l0.28,-0.52ZM677.96,454.27l-0.21,0.16l-0.02,-0.11l0.23,-0.04ZM650.02,390.37l0.52,0.43l0.09,0.2l-0.45,-0.05l-0.16,-0.58ZM680.59,409.03l0.0,0.01l-0.0,0.01l-0.0,-0.02ZM680.54,409.32l0.0,0.21l0.09,0.25l-0.18,-0.29l0.09,-0.18ZM678.47,399.02l0.0,-0.0l0.01,0.0l-0.01,-0.0ZM682.18,392.84l0.95,-0.04l0.73,0.46l-0.59,0.39l-0.21,0.76l-0.88,-1.57ZM630.85,349.97l0.11,-0.9l-0.31,-0.9l0.96,0.08l0.27,-0.33l0.26,0.38l-0.18,0.75l-1.1,0.92ZM634.0,348.94l0.23,-1.09l0.75,0.21l-0.06,0.86l-0.92,0.02ZM635.37,347.66l0.31,-0.27l0.31,-0.07l-0.19,0.29l-0.43,0.04ZM624.08,340.79l0.03,0.01l-0.01,-0.0l-0.02,-0.01ZM522.91,287.92l0.09,0.04l0.15,0.16l-0.08,-0.03l-0.17,-0.18ZM490.83,269.21l-0.1,0.22l-1.54,-0.13l0.29,-1.42l1.36,1.32ZM527.94,279.44l-0.04,-0.23l0.12,0.06l-0.09,0.17ZM541.95,291.93l-1.03,-0.78l-1.11,-1.72l0.33,-0.2l1.8,2.69ZM574.55,296.29l-0.01,-0.14l0.08,0.1l-0.07,0.04ZM622.27,341.79l0.57,-0.05l0.37,0.23l-0.06,0.02l-0.88,-0.2ZM621.25,347.63l0.29,-0.42l0.66,0.04l-0.11,0.11l-0.85,0.26ZM662.77,365.97l0.84,-0.66l-0.06,0.71l-0.78,-0.04ZM681.57,367.03l0.1,-0.68l0.41,0.51l0.69,-0.27l-0.11,0.28l-1.08,0.17ZM663.48,400.23l-0.06,0.03l-0.14,0.26l-0.08,-0.23l0.27,-0.06ZM653.19,413.28l0.02,-0.07l0.01,0.04l-0.03,0.03ZM663.75,417.21l0.03,-0.16l0.0,-0.05l0.04,0.06l-0.07,0.15ZM656.01,454.5l0.2,-0.08l0.01,0.01l-0.0,0.01l-0.21,0.05ZM656.44,456.3l0.17,-0.67l0.69,-0.27l0.05,0.1l-0.91,0.84ZM672.11,466.42l-0.48,-0.52l-0.04,-0.18l0.99,0.26l0.03,0.26l-0.5,0.19ZM626.92,462.69l-0.05,0.04l-0.35,0.13l0.03,-0.16l0.37,-0.02ZM618.61,456.15l-0.06,0.22l-0.83,-0.15l0.45,-0.09l0.44,0.02ZM539.29,319.83l-0.1,-0.03l0.05,-0.09l0.05,0.11l0.0,0.0ZM537.02,321.59l0.12,0.78l-0.07,0.39l-0.29,-0.51l0.24,-0.67ZM685.15,391.57l0.47,0.18l0.41,-0.3l0.22,0.37l1.2,0.21l-1.42,0.29l-0.89,-0.74ZM683.06,459.74l0.95,-0.38l0.19,-0.69l-0.69,-0.33l0.15,-0.41l0.86,0.39l1.28,-0.46l0.26,-0.4l0.66,0.36l-0.47,0.62l0.38,1.23l-0.58,0.69l-2.73,-0.08l-0.27,-0.54ZM683.43,471.03l0.28,-0.59l0.59,0.1l0.69,1.09l0.6,0.06l0.22,0.47l0.7,-0.01l0.58,0.61l-0.16,0.39l-2.13,-0.41l-0.78,-0.57l-0.58,-1.14ZM680.85,436.57l0.47,-0.31l1.46,3.68l-1.98,-3.03l0.04,-0.33ZM683.04,440.33l1.1,0.65l0.41,0.66l-0.53,-0.25l-0.98,-1.06ZM683.89,436.94l0.21,0.16l-0.01,0.29l-0.01,-0.01l-0.19,-0.44ZM681.52,458.42l0.32,-0.72l0.69,-0.02l-0.6,0.62l-0.41,0.12ZM681.24,433.57l-0.29,-1.01l0.41,-0.1l0.22,0.23l-0.35,0.88ZM677.29,433.02l0.03,-0.85l0.54,0.28l-0.04,0.5l0.66,0.32l-0.37,0.59l0.38,0.45l-0.62,-0.42l-0.88,0.54l-0.63,-0.2l-0.22,-0.27l0.18,-0.53l0.98,0.49l-0.01,-0.9ZM678.64,434.4l0.26,0.02l0.11,0.08l-0.11,-0.06l-0.26,-0.04ZM679.82,434.77l0.32,-0.34l0.23,0.91l-0.36,-0.42l-0.19,-0.15ZM677.96,474.7l0.38,-0.71l0.73,0.08l0.13,0.28l-0.56,0.47l-0.68,-0.12ZM674.37,366.72l0.0,-0.0l0.0,0.01l-0.01,-0.0ZM674.51,366.15l-0.12,-0.36l0.97,-1.19l-0.06,-0.72l0.92,-0.55l-1.2,2.63l-0.51,0.19ZM672.23,425.21l0.0,0.0l-0.0,0.01l-0.0,-0.01ZM672.34,425.47l0.06,0.1l-0.03,-0.05l-0.02,-0.05ZM672.48,425.69l0.47,0.19l0.17,0.69l-0.4,-0.49l-0.25,-0.39ZM665.91,422.18l0.01,-0.79l0.82,-1.94l0.42,0.21l0.54,-0.31l0.04,-0.39l0.41,0.37l-1.19,1.04l0.24,0.64l-0.74,0.27l-0.09,0.62l-0.45,0.28ZM665.53,363.97l0.62,-1.05l0.09,0.46l0.55,0.27l-1.26,0.31ZM666.87,363.64l0.66,-0.69l0.48,0.21l-0.28,0.26l-0.87,0.22ZM664.04,502.78l0.64,-0.0l0.65,0.75l1.14,0.57l0.12,0.96l-0.61,1.68l0.07,0.58l-0.8,0.31l-0.8,0.86l-0.19,0.67l-1.13,0.8l-0.48,-0.7l0.33,-6.17l1.05,-0.31ZM662.27,358.38l1.11,0.82l0.23,0.27l-1.19,0.41l-0.15,-1.5ZM639.48,351.75l0.24,-0.63l1.19,-0.11l0.22,0.76l-1.65,-0.02ZM626.89,465.68l0.24,0.01l-0.19,0.0l-0.05,-0.01ZM627.92,465.72l2.0,0.07l2.76,0.84l0.68,0.41l0.97,1.31l0.69,-0.06l0.94,1.07l-1.05,0.85l-1.68,0.11l-0.77,-0.35l-0.48,0.24l-1.03,-0.81l-0.22,-0.97l-0.56,-0.72l0.68,-0.55l-0.2,-0.75l-0.51,-0.21l-0.81,0.28l-1.42,-0.76ZM625.88,343.48l0.72,0.13l-0.17,0.02l-0.55,-0.16ZM624.15,326.73l0.98,-1.23l0.48,-0.09l0.38,0.33l-1.04,0.31l-0.41,0.62l-0.4,0.06ZM619.93,326.41l0.75,-1.58l0.99,0.23l0.78,-0.44l-0.08,-0.26l0.21,0.17l-0.66,1.38l-0.09,0.97l-1.9,-0.45ZM610.78,452.57l0.01,-0.01l0.0,0.02l-0.02,-0.01ZM597.11,474.23l0.51,-0.32l0.72,0.34l0.21,0.46l-0.8,-0.03l-0.64,-0.45ZM598.89,474.9l2.06,-0.45l1.01,0.13l0.33,0.51l-0.8,0.22l-2.61,-0.41ZM599.04,437.65l0.38,-0.55l0.19,-0.09l-0.03,0.69l-0.54,-0.05ZM599.87,438.39l0.12,0.08l0.02,0.12l-0.07,-0.09l-0.06,-0.1ZM599.82,439.43l0.16,1.13l-0.14,0.22l-0.37,-1.33l0.35,-0.02ZM585.61,305.0l0.49,-0.07l0.4,-0.5l-0.14,-2.55l0.52,-0.43l2.67,0.65l0.91,-0.13l-0.02,1.53l-1.36,0.55l-1.7,1.42l-0.5,0.98l-0.28,0.03l-0.2,-0.69l-0.77,-0.8ZM580.19,367.11l0.33,-1.37l0.49,0.37l-0.3,0.82l0.31,0.74l1.17,-0.11l2.88,1.01l0.66,-0.53l1.83,0.03l0.71,2.5l0.42,0.4l-0.04,0.79l-7.4,1.27l-1.1,-0.39l-2.06,-2.68l-0.25,-1.55l0.43,-0.5l1.6,-0.02l0.32,-0.8ZM579.32,359.58l1.96,2.07l-0.27,1.41l-0.22,-0.53l0.31,-0.6l-1.14,-0.8l-0.64,-1.55ZM575.3,680.75l0.71,-0.09l0.76,-0.89l1.39,-0.92l0.34,0.08l-0.66,2.13l-2.24,0.45l-0.3,-0.76ZM578.38,289.95l0.39,0.85l-0.26,1.18l-1.22,-0.22l-0.25,-0.33l0.39,-1.2l0.96,-0.29ZM575.01,293.4l0.88,-0.93l0.29,0.29l-0.34,1.92l-0.83,-1.28ZM575.89,294.88l0.04,0.13l-0.04,-0.01l-0.01,-0.11ZM576.25,295.51l0.29,0.14l0.49,-0.38l-0.04,-0.63l0.52,-1.05l0.6,0.68l-1.02,0.9l0.3,1.54l-1.02,-0.28l-0.11,-0.92ZM577.71,297.2l0.02,0.04l-0.01,0.07l-0.02,-0.0l0.0,-0.1ZM570.15,460.77l0.38,-0.61l-0.43,-0.34l-0.62,0.04l0.31,-0.59l1.82,0.42l0.62,-0.18l3.09,1.4l0.74,0.76l-0.23,0.36l0.17,0.58l0.75,0.13l-0.55,0.43l0.0,0.91l-0.96,-0.13l-0.54,-0.41l-0.77,0.13l-2.65,-2.31l-1.12,-0.6ZM576.82,357.19l-1.38,0.21l-0.52,-0.78l0.33,-0.71l0.51,0.07l0.41,0.98l0.65,0.23ZM560.26,382.27l0.11,-0.65l-1.23,-3.19l0.23,-2.62l1.91,-6.94l1.01,-2.27l2.5,-1.76l0.52,0.49l1.28,-0.04l1.21,-1.15l2.26,0.23l0.93,0.51l2.75,0.49l1.19,1.62l-0.56,4.02l0.68,1.8l0.66,0.84l0.13,1.72l0.65,2.21l-0.39,2.68l-0.44,1.07l-0.71,0.56l-0.35,1.08l-0.91,0.18l-0.45,1.05l-0.76,0.24l-1.47,1.26l-2.69,0.15l-0.82,0.68l-1.27,0.08l-0.77,0.51l-2.57,0.08l-0.66,-0.58l-1.19,-2.69l-0.61,-0.51l-0.18,-1.16ZM571.3,358.81l-0.19,-1.46l0.43,-1.64l0.63,0.35l1.03,-0.0l0.86,2.03l1.45,1.5l-0.81,0.96l0.08,0.44l0.56,0.32l-0.21,0.34l0.32,0.47l-0.51,0.17l-0.44,-0.99l-2.98,-1.7l-0.23,-0.79ZM574.04,604.16l0.73,-2.32l-0.16,-1.61l0.69,-1.52l0.45,2.41l-0.07,1.86l-0.87,0.26l-0.77,0.92ZM570.75,628.39l0.13,-0.06l0.12,-0.02l-0.25,0.08ZM564.25,610.37l-0.85,-0.98l2.24,-4.31l1.24,-1.58l-0.61,1.2l0.3,0.88l-2.31,4.8ZM567.46,604.71l1.4,-1.13l0.64,-4.24l-0.08,-1.98l0.95,0.11l0.62,1.43l1.16,0.56l-0.62,0.83l-0.22,2.21l-0.47,0.0l-0.39,0.59l-1.2,4.58l-1.11,2.0l-1.02,-0.49l1.41,-3.88l-0.43,-0.5l-0.62,-0.09ZM572.72,599.43l-0.23,-0.07l0.17,-0.06l0.06,0.13ZM451.74,52.32l0.69,-2.07l0.87,-1.1l0.71,0.31l1.18,-0.2l0.09,-0.56l-0.42,-0.79l0.2,-0.57l1.49,-0.25l0.44,-0.98l1.27,-0.56l1.13,0.37l0.59,-0.57l1.03,1.9l1.14,0.89l0.97,-2.42l-0.13,-0.8l0.36,0.02l0.47,-0.74l-0.15,-2.05l1.2,-1.41l1.7,-0.66l0.72,-0.65l0.67,0.63l1.12,-0.29l0.59,0.26l0.73,1.43l-0.5,1.08l0.12,0.63l2.5,2.18l0.46,0.04l0.18,-0.43l-0.18,-0.75l-0.41,-0.63l-1.05,-0.65l1.06,-0.68l-0.66,-1.47l1.06,-0.2l1.69,0.29l0.71,0.7l2.7,4.64l0.59,-0.18l0.12,-0.51l-1.58,-3.63l1.35,0.04l0.83,2.15l0.69,0.92l0.49,0.25l0.47,-0.07l0.05,-0.34l0.69,0.11l0.13,-0.43l-1.0,-3.09l-8.1,-3.86l-0.59,-1.77l0.89,-0.61l0.85,0.23l2.74,-0.54l0.65,-1.04l0.68,-0.19l0.14,-0.81l-0.52,-0.77l0.23,-0.71l-0.46,-0.49l0.04,-1.2l-0.21,-0.46l-1.37,-0.5l0.33,-0.48l3.71,-0.62l0.13,0.41l-1.0,0.36l0.04,0.88l1.63,0.69l0.67,1.21l0.65,0.08l0.39,-0.44l1.77,0.48l0.96,1.15l0.51,2.15l1.36,1.64l0.38,1.19l-0.14,0.89l-0.47,0.55l0.41,0.55l4.05,0.0l1.0,0.66l0.49,-0.54l-0.35,-1.06l-0.84,-0.9l-2.02,0.14l-1.84,-3.62l-0.12,-1.14l1.22,0.99l0.75,0.05l1.17,1.49l2.41,1.91l4.1,2.57l0.35,0.62l0.86,-0.19l1.45,0.79l2.48,3.92l1.54,0.16l0.34,-0.63l-2.22,-3.17l-0.22,-0.8l-0.88,-0.55l0.23,-0.64l-0.18,-0.59l-4.63,-1.93l-0.16,-0.54l0.33,-0.73l-0.41,-0.5l-1.54,0.07l-6.03,-5.79l0.48,-3.29l3.63,0.0l0.43,-0.38l-0.14,-0.58l-1.68,-0.41l-1.62,-1.6l-0.39,-1.53l0.72,-0.58l2.38,0.96l2.28,2.63l1.59,-0.26l0.26,-0.49l-0.18,-0.58l-2.24,-3.2l-0.35,-1.25l-1.46,-1.54l-0.34,-1.23l4.14,0.81l0.76,1.61l0.19,1.42l1.43,1.1l0.51,-0.09l0.22,-0.48l-0.81,-1.5l2.82,1.01l2.43,-0.47l0.41,-0.66l-0.27,-0.5l-5.43,-1.64l-0.3,-1.04l0.71,-0.14l0.3,-0.65l-0.29,-0.34l-2.51,-0.68l-0.23,-0.59l0.79,-1.16l2.42,-1.2l1.35,2.63l0.78,-0.03l0.59,-2.17l0.39,0.43l0.27,2.33l0.8,-0.12l1.24,0.61l0.34,-0.45l-0.34,-0.48l0.53,-0.41l-0.43,-1.1l0.49,-0.48l2.57,1.25l0.9,1.59l0.13,0.98l0.81,0.54l1.15,2.21l2.82,2.06l-0.64,1.76l-0.16,2.01l0.28,0.62l0.64,0.14l1.54,-4.56l0.82,-0.53l0.09,-0.91l-3.57,-2.25l-0.47,-1.1l0.86,-0.46l0.21,-0.66l-0.44,-0.52l-1.29,0.2l-1.4,-2.41l-3.04,-2.83l0.09,-0.45l0.51,0.21l3.22,-1.24l0.4,-0.6l2.24,0.0l0.84,0.42l0.87,-0.67l2.99,0.6l2.12,3.85l5.6,4.08l0.5,-0.02l0.35,-1.06l-0.25,-0.5l-2.6,-1.39l-1.16,-1.46l-0.66,-1.55l-0.82,-0.55l0.93,-2.75l0.94,-0.86l0.21,-0.66l-0.31,-0.32l0.66,-0.73l0.33,0.42l0.58,-0.12l0.55,-0.94l1.89,-0.25l-0.21,2.37l1.45,2.23l3.17,1.29l0.44,-0.09l0.08,-0.44l-0.32,-0.67l-2.17,-2.21l-0.72,-0.33l1.07,-2.17l0.76,-0.32l-0.02,-0.64l3.36,-0.89l0.25,0.77l-0.16,0.79l1.08,0.42l-0.26,1.14l0.82,0.44l1.53,-1.47l0.36,1.0l0.44,0.19l1.01,-0.24l0.54,-0.91l0.9,-0.0l0.12,1.19l0.42,0.61l0.63,-0.02l0.36,-0.73l1.05,-0.69l1.62,0.66l0.58,-0.43l0.83,0.39l0.41,-0.76l0.99,-0.16l0.25,0.88l-1.1,2.19l-0.01,0.58l-0.88,0.78l-0.27,0.81l-3.71,3.57l-0.63,1.19l0.04,0.97l0.69,0.28l4.24,-1.92l1.08,-2.01l0.53,-0.42l0.63,0.14l0.48,-0.34l-0.23,-1.32l2.08,-3.05l0.9,-0.26l0.01,0.92l0.38,0.63l0.51,0.26l1.13,-0.08l0.28,-0.66l-0.86,-0.58l0.4,-1.87l-0.55,-0.45l0.07,-0.42l0.32,-0.16l-0.04,0.76l0.89,0.38l0.38,1.03l1.55,1.42l0.62,-0.25l-0.07,-0.8l0.49,-1.52l2.18,-0.33l0.41,1.66l-1.15,1.1l-0.11,0.47l1.02,0.15l0.62,0.95l1.31,0.44l-0.36,0.73l0.51,0.63l1.45,0.06l0.29,3.25l-0.55,0.42l-0.1,0.83l0.64,0.3l1.14,-0.84l0.21,-1.24l0.48,0.03l0.3,-0.55l-0.29,-0.57l0.83,-0.34l0.18,0.89l0.7,0.19l0.38,-0.7l2.02,-0.25l1.13,0.69l1.62,2.11l0.87,2.8l-0.16,1.77l-2.15,2.42l0.02,0.55l0.73,0.42l-0.64,2.61l-0.85,0.33l0.11,1.15l-3.8,6.68l-1.76,-0.44l-0.22,0.57l1.28,1.46l-0.55,1.01l-1.28,0.23l-0.76,-0.54l-0.72,0.36l-1.27,-0.01l-0.3,0.67l0.18,0.31l-2.31,1.76l0.2,0.86l1.88,-0.26l-0.64,0.83l-0.79,-0.44l-0.64,1.01l-5.84,2.51l-1.85,1.28l-5.33,-3.26l-0.5,0.06l-0.04,0.5l0.48,0.66l4.34,2.87l-1.55,0.25l-0.34,0.49l0.3,0.49l1.32,0.48l5.23,-2.85l2.62,0.55l-4.8,5.09l-1.88,2.75l-1.32,1.21l-1.66,-0.02l-0.39,0.31l-0.02,0.82l0.35,0.28l-0.42,0.58l-1.26,0.96l-1.26,0.35l0.08,0.9l0.72,0.36l1.09,-0.38l-0.72,1.2l0.2,0.69l0.44,-0.06l1.45,-1.28l0.41,-1.48l6.21,-5.33l2.03,-2.24l4.49,-3.81l0.72,-1.07l4.02,-2.71l0.76,1.57l-0.35,2.33l-1.26,2.03l-0.71,2.08l-2.19,1.91l-1.19,3.4l-0.3,2.47l-1.61,3.14l-1.55,0.46l0.34,2.05l-0.77,0.57l-0.36,1.83l-0.98,1.24l-1.43,3.84l-0.67,0.72l0.32,1.06l-0.68,1.93l-0.1,3.45l-0.92,1.26l-2.31,0.46l0.03,-1.44l-0.89,-1.49l-2.64,-2.17l-0.38,-0.08l-0.38,0.36l0.14,0.81l1.88,1.85l0.82,1.29l-0.16,0.8l0.3,1.23l2.67,1.65l-0.45,1.72l-2.6,0.08l-1.58,0.99l-1.44,2.04l-0.7,0.21l-1.47,-1.63l-0.86,-0.0l-0.83,-0.69l-0.85,0.3l0.07,0.86l2.62,1.9l-0.48,0.51l-1.19,0.12l-0.35,0.47l0.77,1.03l0.96,-0.01l3.07,-1.02l2.02,-1.9l1.19,-0.7l0.66,0.72l0.23,0.78l-0.54,0.66l-0.02,1.17l-2.68,1.86l-0.36,1.03l0.33,1.04l0.6,0.04l0.84,-0.84l0.83,0.22l-0.4,2.42l-1.3,1.67l-2.93,2.44l-0.9,-0.33l-0.94,0.36l-1.35,-0.56l-0.77,-1.75l0.47,-0.44l-0.2,-0.64l-2.66,-0.1l-1.42,0.59l0.2,-0.41l-0.47,-0.57l-2.3,-0.44l-0.42,0.2l-0.3,0.53l-2.21,1.01l0.32,1.26l0.78,0.8l1.63,-0.58l3.73,0.62l0.69,-0.13l0.33,0.96l1.12,1.3l0.21,1.43l0.41,0.69l-0.5,1.48l-1.61,0.49l-0.93,-1.22l-0.33,-0.19l-0.59,0.3l0.45,2.43l-0.12,0.34l-0.89,0.37l-0.66,-0.18l-1.24,0.25l-1.1,-0.74l-0.31,-0.62l-0.62,0.0l-0.44,1.08l1.15,1.79l-0.21,0.79l-2.15,-0.19l-0.9,-0.82l-0.44,0.2l-0.53,-0.65l-0.64,0.63l-1.33,-1.41l-4.05,-0.14l-0.46,-0.58l-0.51,0.03l-0.28,1.22l0.64,0.86l-0.3,0.42l-0.86,-0.02l-0.22,0.67l1.3,2.66l-3.18,-0.69l-0.6,0.26l-0.39,0.65l0.22,0.47l1.21,0.71l1.1,-0.14l1.12,0.66l-0.49,0.59l0.08,0.44l0.44,0.09l3.25,-1.28l1.45,0.26l1.49,-0.62l1.32,0.83l4.41,-0.55l1.2,-0.53l1.11,0.11l-1.26,0.66l-0.1,0.75l0.31,0.47l0.67,0.07l0.02,0.42l0.59,0.44l0.77,1.4l-1.46,0.01l-1.23,0.59l-2.09,-0.73l-1.12,-0.06l-0.58,-0.48l-0.38,-1.44l-1.52,-0.97l-4.31,1.01l-1.15,-0.07l-4.77,0.77l-0.62,0.97l0.35,0.65l0.46,0.1l0.7,-0.57l6.41,-0.13l2.72,0.21l0.19,0.48l-2.7,0.07l-2.24,0.88l-1.48,1.32l-0.61,-0.12l-0.72,-0.81l-1.56,-0.2l-4.06,0.92l-0.19,0.66l0.5,0.31l4.62,-0.44l0.75,0.49l-0.94,1.6l-1.1,4.15l-0.03,0.51l0.54,0.79l0.8,-0.47l0.39,-2.12l1.23,-2.94l4.43,-2.33l4.73,0.72l-0.13,0.73l-2.01,0.85l-0.9,1.13l-0.08,0.88l0.29,0.32l0.63,-0.12l0.61,-0.84l1.87,-0.31l0.54,-0.49l2.04,-0.04l1.87,0.43l0.48,0.77l-0.26,0.33l0.16,0.57l0.54,0.13l-0.16,0.7l0.43,0.62l-0.38,0.68l0.23,1.43l1.14,0.67l-0.57,0.26l-0.76,1.35l-0.89,0.07l-0.87,0.75l-5.59,0.06l-1.11,0.86l0.08,0.94l2.26,-0.43l0.52,0.16l0.48,0.94l5.31,1.54l0.39,0.75l-0.13,0.36l-1.23,0.14l-0.8,2.86l-2.93,-0.69l-0.95,0.47l-1.44,-0.34l-1.6,1.33l0.25,1.1l1.78,0.65l1.58,0.05l0.82,0.41l2.64,-0.49l0.16,0.51l-0.99,2.88l-1.15,-0.73l-0.79,-0.01l-1.1,0.94l-0.29,1.21l-0.88,0.38l-0.63,0.78l-0.6,-0.06l-0.88,-0.8l-3.65,0.65l-1.84,-1.19l-0.57,0.14l-0.24,0.43l-0.02,0.42l0.34,0.23l-0.73,0.72l-0.18,1.02l0.75,1.01l0.95,0.24l1.04,0.92l0.27,1.05l-0.42,0.63l0.39,0.9l-0.39,0.57l0.16,0.44l1.02,0.12l0.38,0.87l0.56,0.18l-1.13,1.17l0.25,1.39l-0.2,0.81l-1.26,1.22l0.24,1.16l-1.23,0.63l-0.77,1.11l0.11,-1.32l-0.64,-0.26l-0.6,0.36l-1.19,2.16l-2.82,-0.37l-1.05,0.38l-0.61,0.81l-2.98,-0.37l-1.27,-0.5l-1.63,-1.58l-1.3,-0.54l-0.68,-1.26l-1.01,-0.6l-0.31,-1.56l-1.32,-1.07l-0.43,-1.42l-0.29,-0.22l-0.64,0.24l0.24,2.06l0.71,0.66l0.76,1.53l-0.06,2.42l1.63,1.42l1.5,-0.02l0.09,0.52l-3.2,1.07l-1.6,-0.46l-0.46,0.18l-0.12,0.9l1.53,0.94l0.27,1.65l0.43,0.54l1.08,-0.09l3.07,-3.13l5.01,1.29l-1.18,2.84l0.37,0.61l0.48,0.01l1.7,-3.12l1.38,-1.38l1.27,-0.05l1.22,0.52l0.91,0.89l0.32,1.24l-1.49,3.21l-0.19,0.79l0.27,0.89l1.89,-0.04l0.82,-0.37l-0.27,1.92l0.35,0.4l1.41,0.19l0.44,-0.3l-0.08,-1.12l0.68,-0.6l0.01,-1.33l0.73,-0.62l-0.09,-0.72l1.05,-0.56l1.16,1.38l0.04,0.8l0.39,0.52l-0.13,0.77l0.99,0.85l-0.07,2.9l0.31,0.97l-0.24,0.38l-1.04,0.33l-0.69,1.97l0.33,0.71l-0.92,0.7l-0.21,0.86l-0.61,-0.43l0.05,-1.71l-0.45,-0.35l-1.51,0.15l-0.69,3.59l-1.14,0.94l-0.29,2.39l-0.75,-0.32l-0.7,0.12l-2.66,2.3l-0.96,-0.18l-1.13,1.23l-0.98,0.15l-0.3,0.82l-1.1,-0.08l-0.18,-0.54l-0.48,-0.19l1.24,-4.05l-0.16,-1.17l-1.33,-1.41l-1.21,-0.5l-0.2,-1.19l-0.72,-0.08l-0.51,1.42l-0.87,0.76l-2.11,-0.3l-0.59,-0.37l0.35,-1.3l-0.28,-0.78l0.99,-1.03l0.15,-1.15l-0.47,-0.25l-2.08,1.67l-0.32,-0.04l-1.84,-3.27l-0.95,-0.99l-0.75,0.15l0.03,0.65l1.23,1.88l0.4,1.57l0.88,1.07l1.52,0.9l-0.52,1.16l0.66,1.67l-0.1,0.44l-0.44,0.49l-2.56,0.43l-1.64,-1.42l0.12,-0.88l-0.45,-2.08l-1.7,-2.06l-0.03,-2.0l-0.59,-0.34l-0.9,1.19l-0.1,0.63l1.8,3.15l0.5,1.84l-0.26,0.84l0.29,0.94l-2.22,-0.38l-0.42,-0.91l-0.57,-0.29l-1.04,-1.39l-0.45,-2.01l-1.12,-0.83l-0.73,0.15l-0.19,0.33l0.17,0.66l0.59,0.48l-0.19,1.8l0.47,1.2l-0.07,0.66l-1.88,0.31l-0.76,-0.7l-0.82,-2.14l-0.74,-0.65l-0.59,0.24l-0.18,1.75l0.76,2.51l3.36,2.1l-4.05,0.78l-0.17,-0.53l-0.43,-0.17l-0.86,0.21l-1.64,-0.98l-3.61,-0.7l-0.25,-1.66l0.81,-0.57l0.3,-0.93l-0.3,-0.71l-1.67,-1.83l-0.79,-0.43l-0.46,0.74l1.83,2.29l-1.82,1.26l-0.29,2.61l-1.72,-0.52l0.05,-1.03l-0.5,-0.56l-1.19,-0.11l0.11,-1.0l-0.59,-0.78l0.12,-1.27l-0.75,-0.92l-0.57,0.19l-0.14,0.44l-0.02,1.75l0.58,0.84l-0.25,1.32l0.65,0.8l-0.75,1.5l-1.01,-1.89l-0.62,0.25l-0.18,0.98l-2.32,-0.55l0.33,-0.54l-0.25,-0.93l0.28,-1.21l-0.99,-2.63l0.2,-0.93l-0.41,-1.49l0.36,-1.33l-0.23,-1.36l-0.79,0.13l-0.92,2.26l-0.1,0.53l0.67,2.07l-0.79,0.78l-0.49,2.29l0.22,1.08l-0.57,0.84l-0.11,-0.66l-0.58,-0.23l-0.42,0.57l-1.18,-1.48l0.11,-1.05l-0.38,-0.97l-0.57,-0.07l-0.37,0.33l0.17,-1.09l1.01,-1.13l-0.1,-1.25l0.32,-0.56l-0.45,-0.66l-0.35,-2.19l2.79,-2.17l0.25,-0.78l1.25,-0.68l1.04,-1.49l0.61,-0.15l0.32,-0.85l-0.2,-0.17l0.75,-0.3l0.28,0.5l0.43,0.05l1.28,-0.65l0.92,0.02l0.48,0.85l1.2,-0.21l0.63,-0.4l-0.14,-0.62l-0.41,-0.19l0.25,-0.54l1.25,-0.33l0.81,1.11l0.73,0.3l0.53,-0.34l-0.18,-0.78l0.93,-0.14l0.2,-0.7l-0.84,-0.43l-0.64,0.28l-1.51,-0.68l1.15,-0.62l0.08,-0.67l-0.57,-0.43l-1.12,-0.06l0.7,-0.83l0.75,0.04l0.55,-0.36l0.01,-0.73l-1.82,-0.26l-1.32,0.87l-1.48,-0.35l-0.47,-1.74l0.7,-1.17l-0.37,-1.65l-0.66,-0.37l-0.04,-0.64l-2.09,-1.62l0.29,-1.71l-0.14,-1.8l0.3,-0.38l4.54,-2.14l1.61,0.28l0.92,0.79l1.21,0.46l1.2,0.95l1.33,1.91l1.61,5.77l-0.33,1.08l0.42,0.53l1.03,-0.76l0.8,1.14l2.38,0.43l1.44,1.48l1.65,0.4l0.48,-0.5l-0.84,-2.1l1.03,0.34l1.46,-0.41l3.23,1.12l0.52,-0.45l-0.4,-1.35l-1.63,-0.75l-0.14,-0.42l0.98,-0.16l1.27,-1.23l1.88,-4.33l1.83,-6.33l0.09,-1.34l-0.47,-1.28l0.71,-0.25l0.53,-1.09l-0.41,-0.77l-0.98,0.14l-0.92,0.61l-0.61,1.05l-0.12,1.19l0.37,1.62l-0.9,1.02l-0.23,1.38l-0.6,1.09l-0.27,1.99l-0.61,1.04l-0.37,1.56l-1.97,2.55l-2.33,-0.54l-2.31,0.4l-0.26,-0.33l-0.08,-0.66l1.0,-1.0l0.92,-1.92l0.14,-1.11l-0.61,-0.9l-0.49,0.09l-0.15,1.91l-1.62,1.74l-1.72,-1.12l0.15,-0.94l-0.35,-0.58l0.6,-0.59l0.05,-0.81l0.62,-0.08l0.44,-0.46l1.34,-2.16l1.84,0.19l0.09,-0.86l-1.56,-0.74l-3.62,0.66l-0.97,0.87l-0.23,-0.84l-0.7,-0.2l2.79,-2.91l0.61,0.43l1.16,0.11l1.01,-1.06l0.9,0.03l0.58,-0.48l-0.36,-0.64l-1.58,0.15l-1.19,0.65l-1.0,-0.8l0.37,-1.3l0.65,-0.03l0.95,-0.82l2.33,0.9l1.11,-0.92l-0.44,-0.55l-0.9,0.06l-1.19,-0.63l-1.72,-0.03l-0.72,0.5l0.57,-2.56l0.98,-0.44l0.28,-0.54l-0.23,-0.79l-0.52,-0.12l-0.5,0.68l-0.25,-0.33l0.2,-3.37l0.68,-2.02l-0.18,-0.67l-0.66,0.0l-0.89,2.18l-0.59,2.68l0.15,1.9l-0.32,1.44l-1.81,4.32l-3.63,1.45l0.11,-1.87l0.67,-0.4l0.83,-1.75l0.41,-2.83l-0.04,-1.03l-0.37,-0.4l-0.67,0.41l-0.04,0.9l-0.73,1.09l-0.08,1.26l-0.67,1.11l-1.08,-0.3l-0.42,0.23l-1.1,2.26l-3.45,-0.05l0.31,-0.81l1.65,-0.52l0.28,-0.39l-1.13,-0.98l-1.15,0.28l-0.09,-5.02l1.57,-2.69l1.32,-0.03l0.39,-0.42l-0.33,-1.08l-1.04,0.08l0.62,-1.47l0.17,-1.64l1.42,-2.27l0.48,0.12l2.35,-0.99l1.53,-0.01l2.37,-2.21l0.85,-0.16l1.72,1.18l4.75,0.51l0.97,1.03l1.21,0.5l0.89,1.13l1.99,0.73l1.18,2.03l1.53,1.04l0.79,-0.62l0.15,-0.65l-1.92,-2.43l0.37,-0.4l1.19,-0.01l0.16,-0.57l-0.27,-0.62l-0.92,-0.38l-1.93,0.76l-1.58,-1.52l-0.61,-0.09l-0.1,-0.39l0.91,-0.22l2.98,0.45l1.97,-1.17l0.79,-0.05l0.09,0.45l0.67,0.02l0.5,-1.52l-0.55,-0.91l0.17,-1.61l0.84,-1.58l-0.1,-0.59l-0.67,-0.51l-1.85,1.66l-0.92,2.69l-1.66,0.83l-2.17,-1.17l-3.6,0.4l-1.43,-0.61l-1.58,0.21l-1.1,-1.32l-1.26,-0.6l-0.08,-0.74l1.05,-1.47l1.34,0.33l1.16,2.03l2.71,0.4l0.56,-0.33l0.25,-0.68l-0.33,-0.64l-0.61,0.03l-0.26,0.34l-0.56,-0.39l-0.26,-0.71l-1.22,-0.78l-0.23,-0.41l0.4,-1.06l-0.47,-1.01l-0.67,0.16l-0.43,0.84l-0.35,-0.07l-1.21,-5.65l-2.04,-1.92l-0.91,-2.61l-0.03,-0.89l-1.66,-1.68l-1.51,-0.72l-1.23,0.27l-2.7,-1.32l-0.09,-1.12l0.47,-0.6l-0.48,-1.66l0.37,-1.78l1.97,0.75l1.45,0.08l1.1,0.9l0.6,-0.29l0.24,-0.72l-1.65,-1.5l-4.23,-0.93l-0.35,-0.46l-0.61,-2.66l0.47,-4.47l2.35,-0.75l2.91,1.75l3.14,-0.45l2.65,0.1l1.03,0.35l3.45,4.54l4.84,5.13l1.18,2.97l0.03,0.75l0.56,0.75l0.96,0.24l0.19,1.07l-0.32,0.05l-0.22,0.65l0.89,0.78l0.73,-0.24l0.62,-1.11l3.9,1.55l0.52,-0.5l-0.27,-0.54l2.17,-1.37l0.92,-0.09l0.79,-1.85l-0.48,-0.53l-3.05,0.8l-0.37,0.49l-1.68,0.64l-2.12,-1.46l-0.81,0.08l0.02,-0.58l-0.53,-0.6l0.04,-1.36l-0.62,-2.0l0.96,-0.54l0.09,-0.76l-0.49,-0.5l-2.52,-0.73l-0.85,-0.65l-4.01,-5.71l-0.43,-1.05l-0.86,-0.81l5.09,-2.31l1.74,-0.36l5.59,-2.27l0.43,-0.66l-0.13,-0.55l0.89,-0.45l2.37,-0.55l0.44,-0.45l1.58,-0.11l1.62,-0.76l2.99,-0.42l0.23,-1.01l-0.41,-0.5l-3.52,-0.08l-4.6,0.68l1.16,-0.88l0.71,-1.03l1.4,-0.6l0.84,-0.99l1.04,-0.52l0.29,-0.62l0.83,-0.21l0.63,-0.71l2.75,-1.12l4.08,-0.95l0.42,-0.47l-0.0,-1.14l-0.91,-0.71l-1.88,0.69l-1.65,-0.24l-2.68,0.32l-0.66,0.63l-2.82,1.14l-0.11,-0.19l0.15,-1.32l-0.46,-1.97l1.55,-3.08l0.19,-1.3l-0.32,-0.5l1.14,-0.81l0.99,-2.7l0.8,-1.14l0.91,-0.61l0.61,-1.09l0.66,-0.3l1.11,-1.9l-0.06,-0.53l-0.48,-0.43l-0.63,0.05l-5.09,5.04l-1.84,3.71l0.04,2.02l-0.39,0.13l-2.57,-2.19l-0.49,-0.02l-0.14,0.47l0.33,0.8l1.88,2.04l-0.64,0.51l-0.25,1.54l0.06,0.71l0.78,0.53l-0.04,0.27l-0.2,0.65l-0.64,0.52l-0.02,1.11l-0.5,1.46l-1.21,0.92l-0.55,1.08l-1.23,0.78l-2.11,2.37l-1.33,1.04l-1.55,0.35l-3.58,2.05l-2.23,0.67l-0.65,-0.11l0.06,-2.17l0.77,-0.31l0.27,-0.76l2.99,-1.51l0.87,-1.09l0.66,-1.95l-0.54,-0.45l-1.04,-0.18l-2.27,2.07l-0.25,0.82l-2.99,1.38l-0.58,-0.01l-0.11,-0.89l0.76,-0.46l0.95,-1.9l-0.9,-0.83l-0.52,0.12l-1.54,2.61l-0.89,-0.11l0.15,1.78l0.62,2.07l-0.34,2.24l-2.15,0.9l-1.2,-0.45l-1.25,0.08l-0.92,0.72l-2.09,-0.77l-0.76,0.11l1.15,-1.99l-0.12,-0.47l-0.48,-0.02l-0.98,0.69l-1.13,1.77l-2.57,-1.54l0.71,-2.8l3.06,-6.53l0.63,-0.86l1.13,-0.52l0.72,-0.77l4.09,-1.21l0.43,-0.47l5.84,-2.19l1.42,-0.97l0.37,-0.58l-0.12,-0.6l-0.48,-0.14l-7.58,3.06l-4.34,1.05l-0.43,0.42l-0.62,-0.07l-1.71,0.85l-1.49,1.33l-1.05,1.9l-1.09,2.68l-1.81,2.83l-0.77,2.67l-1.52,-0.28l-0.8,-0.73l-1.03,-0.23l-2.28,-2.31l-1.42,-0.85l-1.98,-2.17l-0.26,-0.87l0.64,-0.61l0.91,-0.11l0.88,-0.71l1.83,-0.49l2.43,-0.05l1.09,0.46l2.12,-0.29l0.58,-0.47l1.5,-0.1l1.16,-0.81l0.66,-1.08l1.94,-0.42l-0.13,-1.51l2.72,-2.98l1.56,-0.98l0.47,-0.95l-0.22,-0.57l-1.33,-0.38l-1.3,0.38l-2.72,1.87l-1.35,1.52l-0.41,1.09l-0.82,0.68l-1.81,0.49l-1.83,1.16l-2.07,-0.21l-8.45,1.96l-1.29,-1.35l-0.66,-2.33l0.14,-0.8l1.09,-1.27l0.58,-0.03l0.69,0.86l0.67,0.17l2.71,-1.17l0.19,-0.56l-0.72,-0.69l-1.46,0.36l-2.15,-1.84l1.2,-0.55l0.75,-1.22l0.98,-0.29l0.81,-1.29l0.85,0.04l-0.24,-1.23l3.25,-0.87l0.58,0.55l1.55,-0.19l0.94,0.76l0.75,-0.39l-0.28,-0.99l-3.36,-1.64l-0.6,0.23l-0.4,-0.66l-0.6,-0.13l-1.12,1.08l-1.62,0.45l-2.23,1.52l-3.74,3.32l0.07,-0.73l-1.39,-1.38l2.95,-2.81l0.64,-0.09l0.27,-0.74l1.23,-0.42l0.23,-0.89l-0.39,-0.5l-1.5,0.07l-0.97,-1.81l-0.7,-0.3l-0.36,0.31l-0.09,0.95l-0.78,-0.45l-0.56,0.06l-0.44,1.08l-0.91,0.69l0.02,1.51l-1.09,0.35l-0.29,-1.24l-1.85,-0.94l0.27,-0.49ZM467.33,187.3l-0.02,0.69l0.08,0.54l-0.23,-0.5l0.17,-0.74ZM511.49,194.25l-0.08,0.23l-0.06,0.04l0.07,-0.21l0.07,-0.07ZM521.85,108.29l4.22,-0.05l-0.03,0.87l0.41,0.88l1.07,0.74l-3.95,0.26l-0.99,-1.01l-0.38,-1.53l-0.36,-0.16ZM462.51,44.67l-0.48,-0.1l0.11,-0.42l0.37,0.52ZM480.09,42.55l-0.16,-0.42l0.09,0.02l0.07,0.4ZM553.84,2.1l0.09,-0.04l0.0,0.03l-0.09,0.01ZM486.09,154.14l-1.65,1.09l-0.22,-0.13l0.52,-1.19l1.39,0.02l-0.04,0.21ZM569.87,660.89l-0.05,-0.21l0.07,-0.55l0.68,0.7l-0.69,0.06ZM569.08,481.26l0.24,0.11l-0.12,0.21l-0.05,-0.02l-0.08,-0.31ZM566.15,517.71l0.13,-0.53l1.96,-0.83l-0.06,0.3l-2.04,1.06ZM560.64,465.59l0.03,-1.29l0.44,0.78l0.6,0.12l1.39,-0.87l0.93,0.26l0.4,-0.27l1.43,-0.03l0.32,0.76l1.55,0.15l0.21,0.92l1.3,1.46l-0.31,1.54l-1.35,1.44l-1.17,0.57l-5.6,-4.82l-0.17,-0.72ZM567.82,657.04l0.59,-0.24l0.46,0.97l-0.38,0.0l-0.67,-0.73ZM567.16,481.62l0.8,-0.2l0.12,0.15l-0.37,0.09l-0.54,-0.03ZM563.99,454.06l0.28,-0.52l2.0,-0.55l-0.62,1.38l-1.66,-0.31ZM561.83,604.34l0.36,-1.75l1.39,-0.34l0.4,-0.87l1.27,-0.11l-2.77,2.78l-0.66,0.28ZM562.7,590.99l0.29,-0.1l0.15,0.19l-0.33,-0.12l-0.11,0.03ZM561.98,579.11l0.03,-0.21l0.16,-0.38l0.23,0.82l-0.42,-0.23ZM562.3,593.73l-0.14,-1.09l0.27,-0.29l0.22,0.48l-0.34,0.91ZM546.88,664.64l1.55,-2.5l0.88,0.0l1.25,-0.62l2.53,-0.61l3.06,0.13l4.08,4.11l1.48,3.29l-0.27,0.47l-0.49,-0.29l-2.64,-0.26l-2.99,-1.37l-2.11,-0.14l-5.37,-1.55l-0.96,-0.65ZM555.56,342.89l0.84,0.24l1.8,-0.44l0.34,1.06l-1.68,2.76l0.27,1.37l-1.29,0.66l-0.59,-0.32l-0.89,-1.38l-0.39,-3.32l0.49,-0.73l0.64,-0.27l0.47,0.38ZM551.05,487.28l1.41,0.39l0.98,-0.93l0.84,0.47l0.29,0.72l1.57,1.7l0.16,1.7l-0.27,2.48l-0.46,0.4l-1.52,6.75l-1.08,1.59l-1.24,-1.95l-1.17,-1.08l-1.25,-0.58l-0.94,-2.41l0.21,-4.01l1.63,-3.39l0.33,-1.37l0.54,-0.47ZM554.2,536.67l0.54,-0.67l0.8,0.1l-0.82,1.01l-0.52,-0.44ZM553.29,539.35l0.02,-0.17l0.05,0.01l0.01,0.12l-0.07,0.05ZM518.48,254.45l0.35,-1.71l-0.33,-1.57l1.93,-0.65l2.02,1.4l0.68,-0.02l0.3,-0.5l2.2,0.64l1.61,0.91l3.05,-0.36l0.81,-0.81l0.5,0.18l3.87,-0.8l1.86,1.09l2.86,0.73l0.78,0.87l0.71,0.07l0.33,0.39l0.94,1.57l0.34,1.25l0.99,0.64l1.02,-0.04l0.14,0.78l1.1,1.16l-0.17,0.91l0.28,0.48l1.0,0.89l1.32,0.27l-0.19,0.55l0.09,0.86l0.4,0.53l-0.16,0.98l0.84,0.64l0.74,-0.07l0.16,1.42l-1.02,0.76l-6.43,0.08l-0.92,-0.51l-5.12,0.35l-2.97,1.43l-3.27,2.62l-1.23,0.4l-1.03,-0.23l-2.95,-1.96l-1.55,-3.7l0.17,-1.66l-0.46,-0.82l0.3,-1.05l-0.47,-0.9l-0.74,-0.47l-0.91,0.24l-2.6,-0.56l-0.48,-0.67l-0.23,-3.22l0.77,-0.0l0.12,-0.63l-1.13,-1.22l-0.26,-0.96ZM542.49,343.15l1.11,-1.78l0.59,-1.7l1.13,-0.13l0.28,-0.54l0.91,-0.09l0.19,-0.59l-0.34,-0.9l0.25,-0.24l0.81,0.38l0.67,1.17l-0.8,1.23l-1.28,0.61l-1.46,1.61l-1.05,-0.25l-1.03,1.24ZM539.92,355.26l1.02,-3.29l1.77,-0.72l0.71,-1.13l-0.07,-1.13l0.47,-1.08l0.9,-0.14l0.14,-0.57l-0.89,-1.04l1.48,-1.21l0.9,-0.01l0.67,1.28l-0.6,1.55l-0.94,0.07l0.01,1.35l-0.55,0.73l0.12,0.8l-0.94,1.77l0.0,1.01l-0.47,0.5l-0.2,0.85l-2.02,0.99l-0.53,0.83l-0.81,-0.38l-0.16,-1.02ZM544.47,363.7l0.59,-0.78l0.44,-0.07l0.03,0.55l0.56,0.11l-0.77,0.79l-0.86,-0.6ZM546.32,361.77l-0.26,-0.61l-1.1,-0.61l2.08,0.52l-0.0,0.9l-0.72,-0.19ZM543.1,367.65l1.19,-0.44l0.95,0.97l-0.24,0.84l-0.95,1.27l-0.69,-0.65l-0.26,-1.98ZM491.6,444.1l0.6,-0.54l-0.26,-1.28l0.32,-1.1l-0.63,-1.23l0.66,-2.2l-0.44,-3.51l0.51,-1.23l-0.42,-0.97l0.42,-3.32l0.43,-0.97l-0.05,-1.17l0.6,-1.86l2.47,-2.98l0.48,-0.2l-0.15,1.45l0.49,1.08l0.82,-0.21l0.33,-0.69l1.19,0.7l-0.03,1.27l1.17,1.97l-0.29,0.44l-1.52,0.56l-0.23,0.9l0.81,0.97l1.34,0.7l0.53,0.65l-0.03,1.26l1.03,2.84l0.96,0.12l0.61,-0.39l0.52,-1.62l-0.04,-1.12l1.02,-2.43l0.72,0.33l-0.01,0.75l0.77,0.69l1.56,0.67l-0.42,1.38l1.36,1.37l1.5,0.21l0.63,0.62l0.85,-0.28l2.96,0.46l0.59,1.9l1.5,1.86l2.76,1.13l0.93,1.41l0.67,0.45l0.85,-0.02l0.66,0.61l1.7,-0.47l1.37,1.36l0.75,-0.07l2.34,2.78l0.66,0.36l0.28,3.89l1.81,2.28l-0.08,0.86l-2.81,1.51l-0.34,1.27l0.33,0.67l2.02,-0.2l1.22,-0.66l1.25,-0.19l0.59,-0.32l0.19,-0.61l0.65,-0.12l3.48,1.37l0.51,-0.57l-0.64,-1.28l0.26,-0.65l1.47,1.65l1.47,0.59l0.11,1.01l-1.42,-0.11l0.39,1.02l2.73,0.65l0.87,0.66l0.71,-0.04l0.09,0.37l-2.32,0.89l-0.92,1.85l-1.96,2.17l-0.72,0.34l-0.37,1.42l-0.79,-0.13l-3.55,-1.9l-1.25,0.09l-1.1,-1.13l-1.27,0.12l-1.57,-0.9l-1.68,0.2l-0.83,0.61l-0.91,-0.33l-0.6,-1.02l0.16,-0.59l1.17,-0.74l0.21,-0.8l-0.27,-1.3l-1.9,-1.28l-2.92,-0.04l-1.67,0.69l-0.24,-0.42l1.14,-2.21l0.1,-0.8l-0.5,-0.96l-0.43,-0.25l-0.73,0.12l-0.66,0.48l-0.31,0.78l-0.84,-0.15l-0.73,0.53l-0.52,-0.15l-0.94,0.53l-1.17,2.31l0.77,1.5l-0.29,1.2l0.41,0.83l-0.05,0.66l-0.67,-0.06l-0.56,0.37l-1.21,1.67l-0.65,0.42l-0.51,1.12l-0.85,-0.31l-0.98,0.2l-1.1,1.81l-0.45,3.06l-0.81,1.47l-0.8,0.38l-3.37,2.9l-1.45,0.7l-1.78,0.02l-0.58,-0.67l-0.59,-1.83l-0.22,-3.12l0.33,-1.21l-0.24,-1.47l0.26,-1.16l-0.27,-1.02l-0.84,-0.56l-0.08,-1.26l-0.32,-0.37l-0.44,0.22l-0.66,1.2l-1.18,0.2l-2.19,1.03l-2.41,-0.32l-1.34,0.23l-1.91,2.06l-1.94,0.07l-0.64,-0.91l0.24,-1.85l2.24,-3.9l3.46,-1.99l1.07,-0.94l1.19,-0.37l0.38,-0.61l-0.1,-1.44l-0.99,-1.14l0.06,-0.61l-0.61,-0.96l-0.15,-1.17l0.24,-0.73l-0.5,-0.71l0.07,-2.05l-0.31,-0.97l1.24,-4.08ZM537.12,125.64l0.14,-0.6l1.15,0.28l0.61,0.75l-0.27,0.43l-1.64,-0.85ZM528.13,339.23l0.71,0.43l0.53,-0.06l0.11,0.47l-1.79,0.18l0.44,-1.02ZM530.47,340.7l0.27,-1.09l-0.86,-1.08l0.03,-0.55l0.81,0.3l0.63,-0.45l0.4,0.44l-0.08,0.88l0.61,0.2l0.41,-0.54l0.84,0.27l1.61,-0.81l0.44,-1.19l1.15,0.08l0.29,0.86l0.7,0.66l-1.6,1.72l-1.98,0.49l-0.78,-0.68l-0.76,0.12l-0.17,0.63l1.17,2.24l-1.35,-0.46l-0.17,-1.79l-0.78,0.0l-0.15,0.27l-0.66,-0.53ZM532.8,452.93l0.06,-0.06l0.37,-0.01l-0.25,0.1l-0.18,-0.03ZM516.63,485.78l0.87,-1.45l0.09,-2.41l0.75,-1.27l0.74,-0.59l0.54,0.17l0.88,1.11l0.77,0.19l3.24,-2.28l2.59,0.08l1.19,-1.35l3.08,0.71l-0.52,1.61l0.24,2.58l-1.45,1.72l-1.8,1.19l-0.63,1.91l-1.56,1.53l-1.03,1.81l-2.6,2.52l-0.26,0.11l-0.58,-0.84l-1.09,-0.43l-1.39,0.44l-1.96,1.8l-0.27,-2.41l-1.84,-2.06l-0.26,-0.92l1.85,-2.17l0.41,-1.27ZM224.65,339.19l10.41,-29.67l1.43,2.96l1.64,2.0l1.52,0.57l0.36,0.5l3.12,1.81l3.61,2.71l0.69,2.27l2.5,3.21l4.41,3.07l1.14,1.59l2.02,0.19l0.43,0.79l2.55,1.27l0.89,-0.13l0.67,1.23l1.73,1.08l0.62,-0.07l0.17,-0.63l-0.85,-1.03l0.21,-0.64l-1.13,-1.74l0.59,0.14l1.77,1.79l0.95,0.0l0.47,-0.5l1.0,0.18l2.14,2.28l0.61,1.1l0.35,0.19l0.53,-0.22l0.79,1.3l0.41,1.51l1.35,1.18l0.3,2.21l1.24,1.35l-0.05,0.74l0.46,0.89l-0.07,0.62l-0.6,0.52l0.03,0.54l0.26,0.49l0.71,0.24l-1.13,1.23l-0.01,1.08l-1.03,-0.63l-0.84,0.22l-0.68,-0.89l-1.55,-0.09l-2.39,-1.42l-0.42,0.7l0.81,1.53l-0.59,0.64l-2.27,-1.38l-0.61,0.37l0.19,0.98l-1.03,1.69l0.38,0.97l-2.87,0.38l-0.52,0.95l0.32,0.62l1.43,0.7l1.04,1.98l1.06,0.54l1.96,0.14l0.6,0.93l0.85,0.09l1.0,1.43l1.4,0.13l2.17,1.57l4.2,0.81l1.85,1.27l1.7,0.16l3.18,0.9l0.95,-0.24l0.25,-0.72l0.94,0.49l1.06,-0.09l0.07,1.09l0.81,0.42l0.54,-0.25l0.08,-1.19l2.05,1.3l0.62,-0.31l0.42,0.25l1.94,-1.54l-0.35,0.83l0.24,0.61l0.99,-0.18l0.59,0.43l1.74,-0.54l1.01,-0.94l1.23,-0.17l1.5,-0.92l0.57,0.14l0.31,-0.29l0.65,1.06l0.47,0.09l0.44,-0.66l-0.3,-0.8l0.49,-0.26l0.42,0.71l-0.66,2.38l0.7,0.76l0.69,-0.72l0.52,1.18l-0.55,1.52l0.22,0.56l1.6,1.08l0.63,-0.33l0.33,-0.67l0.76,0.69l0.6,-0.12l1.0,0.42l0.28,0.85l0.0,2.79l-0.84,0.67l-0.12,0.8l0.98,1.49l0.07,1.06l0.49,0.24l0.68,-0.59l1.36,-4.64l0.36,0.04l-0.29,5.31l0.36,0.56l0.58,-0.02l0.67,-1.63l0.27,1.18l1.69,2.4l0.33,2.6l-0.33,0.29l0.04,1.02l-0.6,-0.47l-1.1,-0.12l-0.9,0.77l-1.36,-1.6l-0.54,-1.27l-0.48,-0.27l-0.55,0.44l0.28,2.54l0.33,0.43l0.59,-0.14l0.48,1.31l1.17,0.7l0.19,0.49l-0.23,1.01l-0.74,0.08l-0.16,0.66l1.74,0.69l0.16,3.35l0.73,0.24l0.29,-0.67l0.32,0.86l-0.15,0.65l0.75,2.08l0.66,0.37l0.18,1.47l0.96,2.27l0.74,0.41l0.48,-0.37l0.09,-0.75l-1.28,-2.85l-0.03,-0.89l-0.66,-0.99l-0.31,-2.38l-0.49,-0.66l0.48,-0.61l0.21,-2.19l0.49,0.43l-0.24,0.61l0.34,0.52l1.24,0.59l0.36,-0.6l-0.23,-0.74l0.57,-0.39l0.1,-0.95l0.64,0.96l0.49,1.67l0.49,0.32l0.53,-0.3l-0.3,-1.18l0.18,-0.47l-1.35,-3.35l0.9,-0.19l0.69,-0.85l0.05,-0.56l-1.44,-0.84l-0.69,-1.3l-0.43,-3.54l1.13,-2.31l-0.93,-2.27l-1.45,-2.39l0.26,-1.42l0.68,-1.28l2.24,-0.89l0.39,-1.05l-0.68,-0.64l0.69,-0.93l0.63,-0.21l0.86,0.6l0.74,0.1l1.65,-1.03l0.38,0.48l1.37,0.09l0.35,-0.46l0.93,0.57l0.62,-0.25l0.21,-1.44l0.26,0.42l0.57,-0.05l0.32,-0.89l0.43,1.38l0.69,0.24l0.69,-0.43l0.2,-0.67l-0.81,-1.03l0.71,-1.1l-0.12,-0.76l0.66,0.1l0.79,-0.65l0.8,0.72l1.59,-0.83l1.84,0.07l0.67,-1.61l-0.38,-1.27l1.23,-1.54l-0.22,-0.61l-0.74,-0.11l-0.53,0.38l-0.5,-0.59l-0.62,-0.1l-1.0,0.3l-0.34,0.5l-3.61,0.81l-0.52,0.97l-0.46,0.02l-0.28,0.38l0.2,1.07l0.66,0.53l-0.65,0.65l-0.46,-0.26l-0.34,-1.25l-0.49,-0.21l-0.5,0.58l-1.46,0.06l-1.41,1.66l-0.4,0.01l-0.33,-0.98l-1.25,-0.36l-0.53,-0.78l-1.51,0.09l-0.61,-0.36l-0.61,0.42l-0.6,1.52l0.93,1.49l-0.84,-0.05l-0.45,0.47l-0.33,-0.56l-1.33,-0.27l-1.07,0.49l0.27,-1.24l-0.47,-0.78l0.26,-0.86l-0.41,-0.83l-0.72,0.05l-1.0,0.75l-1.04,-0.05l0.58,-0.56l0.09,-0.69l1.44,-0.98l2.1,-3.01l0.98,-0.9l4.1,0.27l2.59,-0.6l1.16,0.09l3.15,-1.45l1.86,0.02l0.96,-0.62l2.17,-0.6l0.67,-0.76l1.17,1.06l1.42,0.59l1.74,3.52l-0.61,0.66l-0.14,0.69l0.7,3.02l-1.32,0.92l-0.26,0.97l0.52,0.49l1.0,-0.0l0.03,1.25l1.53,2.14l0.88,0.27l0.31,0.77l0.57,0.13l0.53,-0.37l1.16,0.24l-0.79,1.66l1.16,2.86l1.21,0.24l0.46,-0.19l1.07,0.69l1.32,-0.25l1.27,0.71l0.79,-0.27l0.41,-0.52l1.12,0.26l0.39,-0.42l0.19,-1.07l0.57,-0.48l-0.19,3.16l0.81,0.99l0.63,0.16l0.49,0.92l0.95,0.25l1.11,2.33l2.42,1.12l1.52,2.07l0.7,-0.17l-0.01,-0.87l0.36,-0.2l0.59,0.33l0.8,-0.29l0.82,1.22l0.68,0.04l0.28,0.41l1.29,0.55l1.18,-0.11l0.52,-0.62l0.64,0.15l0.55,-0.67l2.28,0.29l0.53,-0.76l1.37,-0.67l0.83,0.87l1.38,-0.92l1.71,0.31l0.54,0.61l1.44,0.15l0.6,0.42l0.77,-0.34l0.56,0.6l0.81,-0.12l1.67,1.07l0.52,0.98l1.97,0.13l0.21,0.38l0.58,0.14l0.45,-1.05l1.12,0.08l0.53,-0.78l0.56,0.3l1.55,0.02l0.61,-0.35l0.04,-0.64l-0.7,-1.42l-0.64,-0.13l-1.2,-1.65l0.07,-1.92l0.73,-0.05l2.04,3.21l1.0,3.57l0.85,0.32l0.5,1.26l0.89,0.26l1.78,2.05l1.65,-0.25l0.72,-0.84l0.28,0.6l0.67,-0.0l0.26,-0.78l0.73,-0.1l0.33,-0.55l-0.93,-1.05l0.67,-1.15l-0.81,-2.97l-0.64,-0.18l-0.52,0.86l-2.33,-3.23l-0.49,0.13l-0.27,0.64l-0.92,0.16l-0.57,0.49l-0.73,-0.22l-0.74,1.82l-0.41,-1.4l-1.23,-1.62l-0.18,-1.05l0.64,-0.33l0.37,-0.68l0.14,-1.19l-1.3,-1.23l0.07,-0.69l-0.36,-0.38l-0.66,-1.26l0.41,0.48l1.06,-0.68l1.19,1.44l0.43,0.11l0.47,-0.36l0.5,0.06l0.4,-0.68l0.79,0.34l0.56,-0.34l0.03,-0.46l0.72,0.42l0.51,-0.4l-0.15,-0.84l-0.96,-0.64l-0.64,-1.74l1.71,0.28l0.32,1.42l0.89,0.92l0.47,-0.05l0.35,-0.56l-0.24,-0.7l-0.5,-0.1l0.11,-0.26l0.79,0.01l0.99,0.7l0.68,1.19l0.03,0.84l1.08,0.66l-0.74,0.93l0.24,0.88l1.23,0.6l1.74,-0.66l-0.22,1.11l0.61,0.85l-0.35,0.88l-1.14,0.69l-0.38,0.64l0.03,0.7l0.42,0.48l1.07,0.06l0.37,-0.73l0.61,0.48l0.73,-0.14l0.31,-0.74l-0.45,-1.02l0.19,-0.25l1.55,-1.15l1.76,-0.78l-0.79,1.52l0.35,0.84l-1.82,5.69l0.01,2.01l-0.25,0.57l-0.9,0.08l-0.14,1.8l-0.91,0.95l-0.32,1.8l0.09,0.3l0.62,0.07l0.44,0.78l0.98,0.47l0.57,-0.12l-1.02,1.79l-0.33,1.54l0.46,0.47l0.47,-0.08l0.23,0.52l0.87,0.02l2.55,-2.56l0.6,0.59l0.53,-0.36l-2.48,3.23l0.46,0.54l1.33,-0.73l0.96,-0.12l-0.02,1.16l0.74,0.27l-0.27,1.34l0.61,1.06l-0.69,0.79l-0.87,0.03l0.12,-0.28l-0.45,-0.53l-2.25,0.7l-0.31,-1.15l0.38,-0.72l-0.29,-0.74l-0.73,0.33l-0.69,1.35l-0.98,-0.04l0.01,-1.45l-0.95,-0.71l-0.57,-0.04l-0.69,0.9l0.38,1.53l0.81,0.62l0.4,1.02l0.7,0.58l0.31,1.37l1.83,1.52l0.46,1.9l-0.39,1.29l0.13,0.48l0.5,-0.01l0.78,-1.17l0.96,-0.63l-0.09,-1.39l-0.49,-0.51l-0.53,0.65l-2.24,-4.1l0.51,-0.24l0.77,0.55l0.55,-0.22l0.47,0.8l1.82,0.12l0.73,-0.39l0.97,0.56l0.65,-0.4l0.57,-1.26l-0.84,-2.43l0.07,-1.43l0.7,-1.15l0.14,-0.87l0.71,-0.58l-0.14,-0.51l-1.05,-1.02l-0.44,-2.43l0.7,-0.87l-0.06,-0.95l-1.04,-2.12l-0.56,-0.29l-1.07,-1.42l1.36,-1.41l0.21,-0.93l-0.27,-1.18l1.24,-2.11l0.03,-0.92l0.63,-0.02l-0.22,0.42l0.57,0.39l1.08,-0.91l0.6,0.73l0.62,-0.1l0.82,0.61l0.65,-0.2l1.99,-2.51l2.93,-2.25l0.13,-2.08l0.63,-0.95l4.43,-2.67l0.26,-0.93l1.2,-0.67l0.06,-0.55l-1.85,0.31l-0.69,-0.28l0.28,-2.13l1.01,-2.08l-0.54,-1.2l0.06,-1.53l-1.1,-0.49l-0.47,0.16l0.2,-0.46l-0.32,-0.34l0.51,-0.56l-0.3,-0.73l-0.68,0.15l-0.7,0.78l-0.1,1.2l-1.12,1.89l-0.02,1.06l0.74,0.43l-0.87,0.88l-1.18,-0.03l-0.94,0.55l-1.22,-0.72l0.65,-2.28l-0.3,-1.43l0.72,0.73l0.33,-0.14l0.85,-1.72l1.24,-0.38l0.29,-0.39l-0.14,-0.89l1.26,-1.02l0.09,-0.46l-0.41,-0.23l-1.1,0.54l-0.6,0.05l-0.26,-0.32l0.56,-2.25l-0.16,-0.9l1.73,-0.7l1.06,0.47l0.5,-0.21l-1.04,1.68l0.19,2.01l0.66,0.2l2.1,-2.7l1.62,-1.46l-0.12,-0.8l-1.22,0.19l0.93,-1.77l0.02,-0.59l-1.2,-1.18l-0.99,0.12l-1.53,0.77l-0.3,1.01l-1.59,-0.04l-1.05,-0.37l-1.24,-2.45l-0.29,-1.53l-0.95,-1.18l-1.12,0.56l0.07,1.25l-0.59,0.55l-0.93,-1.15l-0.89,-0.01l-1.88,-1.41l-1.82,-2.33l-0.83,-0.12l-0.36,-0.39l-1.17,0.24l-0.59,-1.11l0.09,-2.18l-0.52,-0.53l-0.65,-0.09l-1.65,-3.41l-0.15,-2.09l0.34,-2.13l0.71,-1.18l0.85,-0.31l0.59,-2.41l0.75,0.08l0.47,-1.04l1.74,1.3l0.65,-0.46l-0.1,-0.52l-1.67,-1.17l0.04,-0.59l1.59,-1.2l0.19,-0.58l-1.22,-0.06l-2.0,1.53l-0.98,-1.14l-0.42,-1.41l-0.87,-0.86l1.19,-5.03l0.89,-1.31l-0.23,-0.76l-0.55,-0.21l-0.27,0.29l-0.14,-0.24l0.31,-0.26l0.85,0.13l0.12,-0.27l-0.49,-1.01l0.28,-1.34l-0.37,-0.46l1.13,-0.1l1.07,-2.14l0.99,-0.1l1.95,2.72l1.27,0.08l0.33,-1.37l0.76,-0.66l-0.68,-1.12l1.26,-2.02l-0.42,-0.25l-1.02,0.41l-1.72,-0.58l-0.59,-0.77l0.38,-0.56l-0.25,-0.28l1.28,-0.41l1.53,-1.72l1.55,0.02l0.34,-0.47l-0.12,-0.73l0.38,-1.08l0.84,-0.27l1.45,0.12l1.05,0.27l0.34,1.88l0.61,-0.01l0.76,-1.04l-0.31,2.51l0.32,0.45l0.51,-0.17l1.16,-2.14l0.4,0.3l0.63,-0.34l0.72,0.63l1.19,-0.48l0.0,0.99l-0.76,1.43l1.3,1.82l2.72,2.41l0.45,1.94l1.1,0.69l0.25,2.85l0.47,1.29l-0.08,2.48l-0.38,3.5l-0.66,-0.38l-0.44,0.47l0.1,0.49l0.69,1.08l1.05,0.33l0.69,0.64l-0.25,0.89l0.35,0.34l0.1,0.92l1.7,0.3l0.78,0.68l-0.29,0.6l0.79,1.63l-0.37,0.43l0.2,0.64l0.86,0.41l-0.09,0.39l1.05,1.48l-0.12,0.79l-0.65,0.57l0.7,0.38l0.22,0.75l0.7,0.16l0.82,-1.44l-0.19,-0.33l0.6,0.07l-0.26,0.55l0.2,2.13l0.6,0.35l0.28,-0.25l0.44,0.78l-3.08,0.37l-0.52,-0.86l-0.83,-0.4l-0.57,-1.55l-1.17,0.57l0.43,0.71l-1.34,0.59l0.57,0.61l-0.46,0.85l-0.77,0.42l-0.0,0.65l0.72,0.68l0.59,0.01l0.24,-0.49l0.78,-0.38l1.26,0.14l0.86,0.98l-0.74,0.34l-1.66,2.15l0.12,0.41l-2.03,1.16l-0.22,0.56l-0.65,0.01l-0.24,0.73l-1.93,1.83l0.19,0.52l2.03,0.54l0.79,-0.66l1.1,0.04l2.12,2.77l2.21,1.48l2.11,-2.04l0.1,-0.83l0.81,-0.86l1.28,0.51l-0.97,1.2l-1.68,0.68l0.02,0.7l0.44,0.23l1.49,-0.21l1.04,-0.74l0.63,0.96l1.39,-0.16l0.36,0.69l1.02,0.01l0.53,-1.03l1.52,0.89l0.09,0.25l-0.69,0.38l-0.48,-0.53l-0.61,-0.01l-0.41,0.4l0.45,0.62l-1.08,0.99l-0.25,1.61l-0.61,-0.4l0.37,-0.81l-0.42,-0.4l-0.47,0.11l-1.25,1.31l-1.69,-1.37l-0.67,0.29l0.54,1.02l1.59,1.16l3.04,3.5l0.72,0.43l-0.39,1.34l0.27,0.55l0.49,0.15l0.16,0.54l-0.27,0.74l1.3,0.85l-1.1,1.36l0.2,0.58l0.42,0.08l-0.15,0.92l0.34,0.75l-0.48,1.34l0.34,0.89l-0.25,0.79l0.36,0.47l-0.94,1.83l0.26,0.55l1.56,0.97l-0.66,0.52l-0.1,0.51l0.49,0.18l0.7,-0.25l0.29,1.8l0.46,0.61l0.83,-0.07l0.65,-0.63l-0.22,-1.21l1.21,-1.33l0.04,-1.2l0.65,-0.41l0.63,-1.78l-0.72,-0.82l-0.16,-0.8l0.66,-1.17l-0.11,0.74l0.35,0.5l0.54,-0.2l0.31,-0.62l0.2,-3.6l-0.48,-2.78l0.31,-1.38l1.95,-2.78l0.76,-1.95l0.81,-0.47l0.93,0.17l0.54,0.53l0.76,1.96l0.94,1.23l3.7,3.18l1.73,2.49l0.75,2.41l-0.07,2.09l1.18,3.88l0.07,1.43l-0.33,1.43l-0.41,0.53l-1.47,-0.53l0.0,-2.23l-0.28,-0.54l-0.57,0.02l-0.75,1.43l-0.66,0.47l-0.22,0.77l0.64,1.37l0.36,1.85l-0.72,1.8l0.07,1.19l0.8,3.46l0.92,1.49l0.26,1.46l0.61,0.85l1.03,0.56l2.33,3.5l1.5,1.53l0.14,1.62l0.55,0.42l-0.88,0.97l-0.09,1.63l0.52,0.42l0.28,-0.12l0.67,-1.15l0.35,1.43l0.77,-0.01l0.44,-2.43l0.17,0.71l0.65,0.14l0.43,-1.33l0.76,-0.29l-0.28,-1.39l0.74,-1.69l0.46,-0.2l0.65,0.81l1.18,0.53l0.87,-0.85l-0.27,-1.29l0.42,-0.51l0.1,-3.05l-0.63,-1.65l1.23,-3.16l1.2,-1.55l0.47,-1.25l1.64,-1.83l-0.14,-1.24l0.37,-0.46l-0.24,-1.07l0.4,-0.09l0.33,-0.65l-0.43,-0.61l0.05,-1.52l1.03,-2.63l-0.5,-0.76l-0.17,-3.02l0.49,-2.13l0.77,0.12l0.63,-0.55l0.3,0.42l1.19,0.27l0.47,-0.33l0.01,-0.4l1.54,-0.23l1.32,0.5l0.47,-0.39l0.12,-1.02l-0.57,-0.98l-0.96,-0.26l-0.63,0.3l-1.06,-0.4l0.51,0.1l0.69,-0.59l-0.1,-1.13l1.13,0.19l0.47,-0.25l-0.18,-1.05l-0.94,-0.34l0.68,-0.31l1.87,0.46l0.54,-0.81l-0.44,-0.59l-1.29,-0.2l-0.34,-0.92l-1.18,0.19l-0.77,-2.03l-1.4,0.16l-0.45,-0.44l-0.8,-0.13l-0.82,-1.5l0.81,-0.1l0.0,-0.83l-0.73,-0.45l0.12,-0.35l-0.34,-0.42l0.55,-0.16l0.45,-1.01l-0.72,-0.74l-0.72,0.27l0.02,-1.04l0.33,-0.57l0.63,-0.15l-1.18,-2.09l0.63,-0.72l-0.04,-1.08l0.77,-0.79l-0.07,-0.77l1.71,0.98l0.43,-0.68l0.88,-0.22l0.49,-0.61l3.23,-0.54l0.37,0.46l0.88,0.11l1.22,1.29l2.32,1.02l2.79,0.38l0.9,-0.59l1.61,0.41l1.0,-0.32l1.52,0.13l0.48,-0.34l0.15,0.26l-0.65,0.87l0.25,0.5l-0.91,0.6l0.36,0.36l0.88,0.07l0.55,0.68l-5.0,-0.84l-0.65,0.42l0.17,0.76l6.94,1.74l-0.26,0.19l0.21,0.47l1.55,1.36l-0.4,0.23l-0.32,1.25l0.49,0.56l1.98,-0.41l0.2,-0.61l1.62,0.05l2.08,1.18l0.9,-0.0l0.36,1.29l-1.11,0.95l-0.49,1.44l-0.68,0.07l-0.43,1.13l-2.03,1.16l-0.43,1.03l0.48,0.12l1.55,-0.74l0.91,-0.06l0.65,0.54l0.22,0.76l0.47,0.18l0.96,-0.97l1.12,1.62l0.07,2.62l-2.43,2.77l-1.12,-0.34l-0.42,0.56l0.02,0.92l-0.79,0.69l-0.64,-1.43l-1.22,-0.48l-0.47,-0.09l-0.46,0.43l0.73,1.2l-1.29,-0.23l-1.57,-1.04l-0.43,0.26l-0.18,0.63l0.8,0.9l-0.48,-0.02l-0.29,0.73l0.35,0.74l1.0,-0.01l1.03,0.92l-0.87,0.27l-0.13,0.58l0.6,0.71l0.78,0.37l0.54,-0.28l-0.48,2.01l0.5,0.77l1.45,0.33l0.14,0.4l-0.5,1.79l0.93,2.29l2.14,1.89l1.82,2.29l1.57,1.09l1.69,2.53l0.22,0.52l-0.41,1.74l-0.28,5.75l-0.53,0.8l0.05,0.96l-1.02,0.03l-0.28,0.58l-1.06,-0.37l-1.34,0.86l-0.5,1.2l0.16,0.41l-0.46,0.91l0.08,0.5l-0.63,1.14l0.07,0.98l-1.52,0.1l-0.06,0.63l-0.59,0.4l-0.65,1.2l-0.23,1.08l-1.73,0.03l-1.48,0.55l-0.36,1.57l-2.25,2.59l-0.38,0.05l-0.41,-0.12l-0.13,-0.75l-0.94,-1.23l-0.35,-1.01l-1.56,-0.52l-1.22,-1.46l0.84,-0.02l0.3,-0.94l-0.88,-1.37l0.48,-1.38l-0.41,-1.56l-0.42,-0.2l-0.33,0.34l-0.11,1.16l-0.7,0.65l-0.47,1.48l-0.76,-0.18l0.05,-1.01l-0.3,-0.35l0.54,-0.56l-1.46,-1.06l-0.06,-2.04l-3.54,-0.91l-0.73,-0.56l-0.69,0.1l-0.05,1.03l0.57,0.63l-0.96,0.18l-1.62,1.09l-0.24,1.14l0.19,0.5l0.92,0.71l1.52,-0.57l0.86,-1.83l0.42,-0.12l0.25,0.31l-0.33,0.39l0.98,0.58l-0.37,0.78l0.37,0.41l2.33,0.87l-0.55,0.56l-0.01,0.63l1.17,0.78l1.2,-0.25l-0.39,1.76l2.5,2.69l0.45,0.81l0.25,1.95l0.7,0.44l0.56,1.17l-1.31,0.22l-1.3,-0.9l-0.32,-0.92l-0.59,-0.46l-1.33,0.72l-0.35,-1.24l-1.17,-0.96l-0.48,0.19l-0.76,1.63l2.26,2.97l-1.28,-0.84l-1.45,-0.18l-0.77,-0.79l-1.0,0.26l-1.07,-1.4l-0.6,0.07l-0.34,1.21l-0.78,-4.09l-0.84,-1.71l-0.66,-0.37l-0.86,0.23l-1.97,1.36l-0.9,-0.22l-1.74,0.35l-1.03,-0.32l-0.59,-0.68l-0.45,0.07l-0.33,0.62l-1.44,-0.65l-0.35,0.93l-0.6,-0.32l-0.75,0.2l-0.14,0.54l0.61,0.87l-0.56,0.05l-0.22,0.59l1.71,2.75l2.48,0.54l3.71,1.93l-0.76,1.22l-0.06,1.4l-0.48,0.53l-1.03,0.33l-0.22,1.04l-1.73,0.86l-0.59,2.04l0.31,1.26l-0.58,1.19l-1.1,0.64l-1.09,1.77l-1.33,0.59l-0.29,0.88l-0.53,0.25l-0.28,0.57l0.29,1.02l-2.17,1.42l-4.42,0.04l-1.02,-0.44l-1.24,-0.93l-0.92,-1.6l-1.21,-1.3l-1.96,-1.11l1.98,0.37l0.47,-0.37l-0.12,-0.47l-3.93,-1.49l-0.91,0.15l-1.03,-0.58l-0.37,-0.92l-1.22,-0.74l-0.92,-1.12l-0.79,-0.14l-1.45,-1.41l-2.52,-0.27l-0.57,0.23l0.01,0.69l1.88,1.05l0.14,0.7l-2.03,-1.36l-1.24,0.26l0.05,-0.62l-0.46,-0.37l-1.47,0.42l-6.35,-0.91l-1.26,-0.56l-1.67,0.63l0.02,0.64l3.84,2.87l0.66,-0.16l0.12,-0.54l-0.83,-1.67l4.33,0.96l4.62,1.73l1.79,1.3l1.04,1.58l1.15,0.81l0.64,2.1l1.78,1.27l1.28,2.27l1.01,-0.19l0.6,0.41l6.81,0.99l1.16,-0.43l1.53,0.37l0.72,-0.68l1.26,0.62l1.23,-0.17l2.44,0.59l-0.02,0.57l0.92,0.98l-0.42,0.83l0.18,0.8l-1.03,1.03l0.2,0.74l-0.68,0.55l-0.63,1.25l-0.46,2.22l-0.67,0.57l-0.74,-0.22l-0.3,0.43l0.01,2.02l-0.48,1.22l-1.97,1.13l-0.52,3.2l-1.35,1.99l-0.11,0.53l0.4,0.72l-0.74,0.93l-0.94,-0.04l-2.19,1.87l-1.48,0.78l-0.44,0.77l-1.35,-0.65l-0.63,0.19l-1.4,-1.05l-1.02,-2.09l-0.48,0.02l-0.39,0.58l1.13,2.58l-0.8,-0.25l-0.43,-0.5l-0.74,0.08l-0.86,-0.94l-0.48,0.08l-0.22,0.53l-0.47,-0.49l-0.61,-0.01l-0.37,-0.42l0.39,-0.09l0.34,-0.6l-0.14,-1.56l-0.38,-0.69l-0.64,0.01l-0.79,1.51l-0.87,0.09l-1.12,0.66l-0.05,0.72l0.93,0.65l0.44,-0.18l0.48,1.07l-0.19,0.66l-0.41,-0.19l-0.73,0.47l-0.86,-0.9l-0.72,0.05l-0.46,0.46l1.37,1.56l0.33,1.12l1.01,1.2l-0.95,0.21l-0.29,0.68l0.41,0.36l-0.92,1.77l-0.74,-0.24l-0.59,0.62l-0.56,0.01l-0.23,-0.94l-1.65,-0.78l-0.76,0.87l-0.04,0.64l0.69,0.29l0.5,-0.22l0.07,0.37l-1.46,0.62l-1.33,0.1l-1.96,-1.32l-0.77,0.03l-1.06,-1.28l-1.28,-0.65l-1.21,0.15l0.04,-0.54l-0.47,-0.6l-0.51,0.06l-0.35,0.5l-1.27,-0.1l0.67,-0.57l-0.27,-0.54l-1.23,-0.2l-0.67,1.26l-2.38,-0.59l-0.99,-0.97l-1.95,-0.67l-0.56,-0.85l-1.09,-0.11l-0.4,-0.69l-0.98,0.04l-0.68,-0.73l-2.44,-1.09l-1.31,-1.52l-0.1,-1.25l-0.75,-0.16l-0.38,-0.56l-0.65,0.04l-0.08,0.58l0.7,0.89l0.13,1.06l0.71,1.09l-0.06,0.3l-1.2,-0.06l-0.41,0.49l-0.05,0.4l0.61,0.58l0.54,1.53l2.55,1.43l1.53,-0.47l0.27,-0.5l-1.31,-0.78l-0.63,-1.04l0.13,-0.26l2.22,1.83l1.8,0.9l1.13,0.19l1.16,0.98l0.55,0.05l0.82,-0.64l0.64,1.4l1.31,0.07l0.51,0.42l-0.34,1.0l-0.74,-0.38l-0.82,1.21l-1.45,0.8l0.07,0.56l0.82,0.62l1.5,-0.61l0.41,0.38l0.63,-0.18l0.29,-1.37l1.35,-0.48l0.53,-0.63l1.38,-0.66l1.17,1.1l0.19,1.32l1.74,1.14l-0.1,0.55l0.37,0.42l1.93,-0.08l0.94,0.83l0.59,-0.3l0.22,0.25l-0.31,0.34l0.34,0.65l2.0,0.84l-0.34,0.61l0.51,1.75l-0.36,0.9l0.41,0.47l-0.04,1.6l0.25,0.32l-0.84,0.97l-0.23,0.91l-2.1,-0.17l-1.55,1.08l-0.28,0.73l-0.67,0.49l-1.01,0.17l-0.08,0.61l-6.01,-1.84l-0.48,0.42l0.11,0.84l-1.42,-0.68l-1.4,0.44l-0.18,1.01l1.52,1.96l-0.01,0.45l1.0,0.46l2.05,0.27l0.42,0.21l-0.02,0.44l-0.74,0.94l-0.91,-0.27l-0.08,-0.97l-0.79,-0.23l-0.79,0.25l-0.1,0.46l-0.81,0.57l-0.29,-0.1l-0.11,-0.96l-0.66,0.08l-0.71,-0.69l-0.56,0.33l0.62,1.7l-0.15,1.0l-1.28,0.07l-0.16,1.92l-0.88,0.18l-0.01,0.68l1.78,0.63l-0.08,0.63l-0.47,-0.64l-0.62,-0.04l-0.47,-0.48l-3.58,-1.19l-0.51,0.14l0.08,0.53l0.58,0.48l3.52,2.17l-0.17,0.39l-0.49,-0.41l-0.97,-0.02l-0.42,0.2l0.01,0.34l-0.95,0.34l-0.3,0.85l0.81,0.74l-0.33,0.5l-0.6,0.02l-0.24,0.51l-1.17,-0.68l-0.29,0.48l-0.38,-0.11l-0.51,0.37l0.15,0.47l0.91,0.72l-0.58,0.06l-0.12,0.57l-1.72,-0.71l-0.48,0.61l0.55,0.71l-0.52,0.41l0.0,0.75l1.48,0.65l0.15,0.47l-0.35,0.17l-0.06,0.59l0.5,0.75l-0.94,0.27l-2.33,2.14l-0.8,0.09l-1.42,2.04l0.19,1.66l0.96,0.33l0.02,0.67l-0.63,0.23l-1.46,-0.58l-0.43,0.57l0.86,1.7l-0.83,1.09l0.32,1.46l-0.9,0.8l-1.03,2.78l-1.06,0.83l-0.64,1.83l0.06,0.76l-0.95,1.43l-0.28,1.75l-1.44,-0.29l-0.49,0.23l-0.08,0.62l-0.78,0.49l1.17,0.74l0.47,1.38l-1.03,2.38l0.22,1.29l-0.39,0.88l0.08,1.0l-0.53,0.41l-0.4,1.05l-33.99,-2.48l-33.79,-3.8l10.54,-78.34l0.16,-3.27l-1.13,-0.63l-11.88,-3.86l-18.57,-6.61l-25.7,-9.97l-1.81,-1.05l-2.03,-2.19l-7.01,-13.93l-14.83,-3.67l-12.27,-15.45l-13.32,-18.01l-12.5,-18.28l-10.27,-16.15ZM431.55,497.53l0.31,-0.12l0.17,0.01l-0.2,0.26l-0.28,-0.15ZM459.97,461.11l0.41,0.12l0.06,0.53l-0.42,-0.04l-0.04,-0.61ZM466.33,460.55l0.16,0.24l-0.01,0.0l-0.15,-0.24ZM457.44,422.81l-0.21,0.13l-0.28,-0.01l0.49,-0.12ZM510.55,414.28l0.09,0.15l-0.04,0.09l-0.06,-0.23ZM452.71,352.12l0.03,0.15l-0.01,0.1l-0.08,-0.08l0.07,-0.17ZM410.05,384.51l0.12,0.01l-0.05,0.33l-0.07,-0.28l-0.01,-0.06ZM408.32,373.23l-0.03,-0.49l0.36,-0.47l-0.09,0.57l-0.23,0.4ZM318.64,387.32l0.17,-0.15l0.1,-0.2l-0.02,0.64l-0.25,-0.3ZM318.94,386.46l-0.03,-0.21l0.0,-0.15l0.04,0.09l-0.01,0.27ZM321.06,364.45l0.05,-0.18l0.03,-0.08l0.11,0.08l-0.19,0.18ZM329.96,363.12l-0.02,-0.07l0.05,-0.02l-0.02,0.09ZM343.89,363.99l-0.01,-0.29l0.6,-0.07l-0.05,0.13l-0.54,0.22ZM393.29,373.56l-0.08,-0.14l0.13,-0.03l-0.03,0.08l-0.02,0.08ZM393.36,373.34l0.07,-0.35l0.01,-0.02l-0.02,0.16l-0.07,0.2ZM431.18,350.11l0.25,-0.55l0.38,-0.32l-0.44,0.76l-0.19,0.11ZM427.74,295.54l-0.28,-0.5l-1.09,0.54l-2.24,-0.49l-0.57,0.24l-0.05,-0.78l0.27,-0.75l4.16,-0.81l0.19,0.78l0.47,0.35l-0.54,0.32l0.1,1.06l-0.41,0.05ZM524.18,151.95l-0.31,-0.7l1.09,-0.68l0.05,0.73l-0.83,0.65ZM520.3,200.25l0.21,-1.47l1.52,-2.11l0.89,-2.29l0.45,0.01l0.45,0.38l-0.01,0.52l-1.54,2.07l-0.21,0.77l0.31,1.0l0.68,0.66l-1.45,0.22l-0.62,0.7l0.01,0.56l-0.7,-1.0ZM420.43,181.62l0.62,-0.87l-0.12,-0.26l0.61,1.02l0.74,-0.23l0.77,0.53l0.67,-0.11l0.25,-0.84l-0.59,-0.28l0.66,-0.4l-0.11,-0.59l-1.42,-0.84l-0.59,-0.77l-0.57,-0.08l-0.08,-0.91l0.74,-0.14l0.39,-0.81l0.69,0.51l0.79,-0.67l0.42,0.07l0.53,-0.75l-0.33,-0.56l1.43,-0.16l1.18,-0.54l0.61,0.36l1.21,0.1l1.1,1.39l1.08,0.31l0.38,0.43l2.24,0.35l0.31,1.19l0.93,0.15l0.49,0.77l1.0,-0.0l0.77,-1.07l1.13,0.45l0.38,1.24l1.53,1.97l0.6,1.46l-0.84,3.95l-2.07,2.49l0.7,1.8l0.78,-0.03l0.3,-0.47l-0.59,-0.65l1.22,-0.88l1.63,-2.96l-0.03,-0.57l1.81,0.83l1.15,-0.54l0.96,0.52l1.39,-0.57l0.88,-1.01l2.88,-0.6l2.66,1.15l0.56,1.25l1.55,0.93l0.21,1.53l-0.52,0.16l-1.29,-0.61l-0.43,-0.79l-0.69,0.17l-0.29,0.65l-1.37,-0.9l-1.24,0.23l-0.33,0.39l1.0,1.43l2.43,0.35l1.98,0.83l0.76,0.64l0.58,-0.43l6.3,2.56l0.54,1.01l-0.8,1.13l-6.11,0.17l-0.27,0.43l-3.55,-0.91l-0.51,-0.68l-2.16,-1.05l-0.47,0.09l0.11,0.74l1.8,1.17l-0.87,1.04l0.22,0.54l0.63,0.1l0.57,-0.36l2.53,0.82l-0.13,0.53l-0.68,0.38l0.4,0.61l-1.39,-0.03l-0.63,0.45l0.06,0.61l0.45,0.23l-0.04,0.35l0.66,0.74l-1.13,0.97l0.03,1.86l0.32,0.37l0.54,-0.31l0.36,-1.43l1.24,-1.45l0.61,0.3l0.94,-0.69l-0.48,1.34l0.07,0.44l0.69,0.2l1.1,-1.51l0.31,0.54l0.62,0.17l0.44,-0.38l0.16,-0.85l0.75,0.45l0.75,1.32l-0.52,1.8l0.14,0.99l0.86,0.09l1.06,-1.42l0.76,0.96l0.76,0.34l0.09,0.43l-0.48,2.76l-0.64,0.38l-1.29,-0.1l-0.85,1.01l-0.08,0.71l0.79,0.81l0.97,-0.17l0.63,-0.76l0.88,0.04l0.58,2.19l1.33,1.51l1.1,-0.18l0.32,-0.42l0.04,-1.11l-0.83,-2.81l0.71,-0.81l0.06,-0.55l1.86,2.58l0.66,0.4l-0.56,0.98l0.98,0.87l1.65,-1.92l1.04,-0.67l1.11,1.8l-0.58,0.81l0.39,0.39l1.01,-0.17l0.45,-1.42l-0.54,-1.26l0.93,-1.27l0.7,0.48l0.36,1.04l1.75,1.74l1.38,0.04l0.9,0.88l-1.19,1.0l-0.12,0.48l0.43,0.23l1.29,-0.23l1.3,-1.0l1.02,-0.18l2.85,0.31l0.41,-0.42l-0.27,-0.56l-1.61,-0.38l-0.79,-0.85l-1.13,-0.39l0.55,-0.49l1.65,-0.56l0.47,-0.54l0.83,0.38l0.6,-0.27l0.78,0.21l0.5,-0.41l-0.36,-0.56l1.46,-1.38l0.81,-0.05l1.7,0.61l0.43,-0.3l0.0,-0.65l-0.7,-0.24l-0.07,-0.44l1.79,-0.55l0.71,-1.27l1.02,-0.43l0.51,-0.91l0.4,-0.06l0.8,0.56l0.66,-0.16l0.98,1.09l1.24,-0.18l0.48,0.26l2.88,-2.17l1.62,-0.66l6.9,0.84l-0.86,2.39l0.34,0.6l1.83,0.38l2.8,-0.86l0.35,0.42l0.67,0.03l1.39,0.89l-0.02,0.68l0.38,0.41l-1.7,1.15l-0.16,0.44l0.43,0.53l3.83,-0.52l0.4,1.14l0.81,0.46l-0.08,0.99l-0.45,0.8l0.23,0.56l0.68,0.19l-0.62,1.94l-1.15,0.29l-0.61,0.94l-0.12,0.99l-2.38,1.5l-0.22,0.7l1.13,1.01l0.06,0.7l-0.74,0.86l0.17,0.93l1.8,1.16l0.1,0.54l-0.72,0.82l0.74,1.02l-0.36,0.53l0.43,1.62l-0.33,0.76l-1.04,-0.02l-0.56,0.57l-3.59,0.03l-1.4,0.66l-2.42,2.46l-1.63,-0.24l-1.11,-0.67l-0.68,-0.05l-0.22,-1.01l-0.56,-0.28l-0.45,0.28l-0.09,0.71l-0.43,0.48l-0.82,-0.18l-1.04,-0.65l-1.16,-2.26l-0.11,-1.45l0.42,-1.04l-0.51,-1.31l-0.9,-0.15l-0.82,-0.5l-0.89,-1.16l-0.53,-0.06l-0.57,0.68l0.32,1.3l1.36,1.75l-0.71,4.18l-0.5,0.52l-2.57,0.31l-1.28,0.93l-2.03,0.15l-0.77,-0.44l-0.91,0.47l-0.44,-1.19l0.03,-2.55l-0.49,-0.71l-0.63,0.38l-0.32,1.27l0.34,2.55l-0.53,0.71l-0.65,-0.02l-0.94,-3.83l-0.66,-0.63l-0.53,0.61l0.54,3.14l-0.46,0.77l-2.58,0.37l0.09,-1.23l-0.56,-0.82l-0.08,-0.83l-0.51,-0.24l-0.56,0.5l0.04,1.45l-0.61,1.23l-1.4,-0.97l-0.61,-1.79l-0.72,-0.27l-0.32,0.41l0.07,1.69l0.93,1.46l-1.06,0.13l-0.41,-0.89l-0.68,-0.07l-0.22,0.84l-0.85,0.11l-0.38,-0.69l0.36,-0.58l-0.42,-0.53l-0.88,0.34l-0.4,1.26l-0.87,0.51l-0.26,-1.09l-0.49,-0.31l-0.81,0.91l-0.89,0.1l-0.26,-0.49l-0.7,-0.14l-0.33,0.53l-1.38,-0.34l-0.03,-2.5l0.74,-3.07l0.68,-0.64l-0.28,-0.42l-0.88,-0.1l0.12,-1.14l-0.49,-1.32l-0.43,-0.3l-0.59,0.36l0.09,0.81l-0.57,0.3l-0.69,3.45l-0.18,-1.92l-1.09,-1.3l-0.58,-0.11l-0.18,0.41l0.52,1.38l-0.13,0.8l-0.77,-0.66l-0.59,0.1l0.33,1.26l0.65,0.72l-0.25,1.63l-0.31,0.33l-1.04,0.01l-0.32,0.75l-0.91,-0.11l-0.58,0.47l-1.14,0.13l-0.42,-1.29l-0.5,-0.03l-0.45,0.65l-1.0,-0.68l0.06,-0.86l-1.62,0.41l-0.83,-1.03l0.07,-1.6l-0.41,-0.39l-0.98,0.32l-0.43,0.66l1.62,-2.82l-0.06,-1.44l-0.53,-0.32l-0.68,0.4l-1.44,2.73l-0.63,0.11l-0.39,0.88l-0.56,-0.03l-0.27,0.39l0.02,1.25l-0.45,-0.04l-0.69,-0.52l0.31,-0.55l-0.34,-0.72l-0.89,-0.22l-1.44,-1.47l0.36,-2.51l-0.31,-1.34l-0.84,-1.55l0.0,-0.83l0.9,-0.12l0.26,-0.31l-0.42,-0.95l0.21,-0.77l-0.59,-0.3l-0.96,0.39l-0.97,-1.66l0.42,-2.58l0.6,-0.73l-0.15,-0.58l-0.45,-0.11l0.38,-1.33l1.06,-2.19l0.66,-0.34l0.58,-0.83l-0.38,-0.83l0.34,-1.07l-0.84,-1.92l0.44,-1.44l-0.1,-1.55l-0.43,-0.71l-1.28,-0.76l-0.21,-0.78l-0.45,-0.32l-0.48,-1.12l-0.14,-2.73l-0.53,-0.76l-0.27,-1.33l-0.7,-0.59l-0.62,-1.36l-0.06,-1.36l-0.58,-0.68l-0.69,-0.15l-1.98,1.44l-0.45,-0.4l-0.45,0.11l-0.65,1.31l-1.32,0.09l-0.78,-0.57l-2.24,0.12l-0.43,-1.01l-0.43,-0.02l-0.41,-0.61l-2.91,-1.03l-0.33,-0.64l-0.99,0.32l-1.26,-0.4l-0.71,-0.86l-0.49,-1.5l1.28,0.15l0.56,-0.27l1.17,-2.1l-0.46,-0.51l-1.06,1.03l-0.91,0.17l-0.01,-0.56l-0.86,-0.18l-0.62,-1.38l-0.77,-0.19l-0.41,-1.23l-1.13,-0.56l-1.03,0.14l-0.19,-0.33ZM451.64,232.47l0.2,0.49l-0.18,-0.03l-0.02,-0.46ZM519.52,222.67l0.67,0.01l0.3,-0.74l1.12,-1.04l0.93,0.21l0.91,1.92l0.6,0.41l-2.49,1.36l-0.4,0.49l-1.28,-0.76l0.02,-1.18l-0.38,-0.68ZM455.43,199.69l0.61,-0.68l1.56,0.5l-0.2,0.22l-1.97,-0.04ZM431.2,193.09l-1.37,1.01l-1.29,-0.29l0.02,-0.49l1.44,-0.32l0.43,-0.6l0.46,0.03l0.32,0.66ZM521.01,346.84l0.26,0.12l-0.6,-0.0l-0.32,0.78l-0.2,-0.77l0.85,-0.13ZM521.4,347.02l0.93,0.01l0.12,0.67l-0.68,-0.07l-0.37,-0.61ZM519.42,369.27l0.08,-0.17l0.17,0.21l-0.24,-0.04ZM514.49,412.03l0.0,-0.0l0.0,0.0l-0.0,-0.0ZM514.67,412.23l0.25,0.63l0.65,0.04l0.46,0.43l0.54,-0.1l-0.22,0.67l-1.73,-1.07l0.07,-0.61ZM505.16,417.47l-0.03,-0.82l2.73,1.32l0.45,-0.06l0.16,0.55l2.41,1.63l0.11,1.35l-0.63,0.61l-0.0,0.58l-1.02,0.94l-1.01,-0.16l0.22,-0.72l-0.29,-1.85l-0.69,-1.45l-1.07,-0.84l-0.77,-0.06l-0.57,-1.01ZM512.09,423.78l0.53,0.2l-0.02,0.3l-0.57,0.11l-0.35,0.62l-0.41,-0.06l-0.04,-0.46l0.86,-0.71ZM512.96,424.68l0.64,-0.22l1.49,-0.08l-0.08,0.85l-0.44,0.51l-0.87,-0.66l-0.86,0.02l0.12,-0.43ZM512.86,421.59l0.72,-0.05l-0.36,0.47l-0.37,-0.42ZM512.54,339.29l0.85,-0.28l0.88,0.7l-0.13,0.13l-1.6,-0.55ZM509.23,194.49l0.2,-0.25l0.21,-0.1l-0.34,0.37l-0.08,-0.02ZM505.41,340.75l-0.75,-0.57l0.04,-0.62l1.46,0.3l-0.75,0.43l-0.0,0.46ZM499.85,419.2l0.52,0.39l0.5,-0.13l0.35,0.5l-0.05,0.68l1.48,2.0l1.39,3.84l-0.75,1.32l-0.63,-0.38l-0.43,-1.69l-1.54,-0.95l-0.49,-0.74l-0.75,-3.59l0.0,-0.77l0.39,-0.49ZM493.31,188.08l0.28,0.32l-0.08,0.36l-0.23,-0.13l0.04,-0.54ZM483.52,380.65l0.67,-0.83l0.13,-0.81l-0.21,-0.83l-0.81,-0.49l-0.21,-0.47l0.58,-0.94l0.02,-1.25l1.29,-2.23l1.7,1.75l-0.11,2.22l0.6,2.9l-0.21,2.26l-1.11,2.16l-1.73,-1.43l-0.61,-2.01ZM484.26,162.01l0.42,-0.54l1.29,0.04l0.41,1.15l0.59,0.47l-1.04,0.74l-0.12,-1.24l-0.73,-0.56l-0.81,-0.06ZM479.18,334.69l0.76,0.01l0.72,-0.57l1.82,0.89l1.27,-0.58l0.97,2.02l-1.78,0.37l-1.64,-0.88l-0.73,0.52l-0.98,-0.67l-0.41,-1.12ZM427.77,94.98l0.27,-1.04l1.22,0.23l1.58,2.02l1.66,0.75l2.27,0.53l1.49,-0.22l1.8,1.72l0.71,-0.12l-0.07,-1.04l-1.53,-2.32l1.04,-1.26l2.04,-0.47l0.28,-0.54l-0.32,-0.43l-1.53,-0.55l-0.51,-0.62l-0.49,0.02l-0.67,1.12l-1.16,1.05l-1.73,0.26l-0.95,-1.25l1.76,-0.53l0.36,-0.72l-0.13,-0.61l-0.59,-0.16l-0.52,0.52l-0.38,-0.02l-0.17,-0.43l-0.59,-0.06l-1.26,1.09l-1.42,-1.64l-0.89,-0.42l0.39,-1.21l0.99,0.11l0.05,-1.01l0.58,-0.25l1.6,0.63l1.03,0.79l0.57,-0.4l-0.16,-1.39l-0.97,-0.57l-0.46,-1.38l-1.04,-0.82l0.5,-0.41l0.24,-0.89l-0.35,-0.92l2.83,0.12l1.34,-0.35l1.75,1.38l1.46,-0.18l1.09,0.47l0.43,0.81l0.49,0.02l0.68,-0.57l-0.98,-1.99l-1.81,-0.95l-0.65,0.14l-0.37,-0.98l0.08,-0.59l2.29,-0.25l0.33,-0.54l-0.22,-0.59l-0.79,-0.19l-0.09,-0.47l-0.43,-0.24l-0.89,0.57l-0.53,-0.18l-1.14,-0.9l0.69,-0.71l-0.44,-0.87l-1.26,0.54l-1.23,-0.4l0.12,-0.39l1.22,-0.53l0.4,-0.53l-0.3,-0.6l-1.05,-0.2l0.81,-1.06l0.41,-1.84l1.29,-1.0l1.27,1.08l-0.15,1.11l0.69,0.56l0.53,-0.28l0.4,-0.76l1.71,-0.79l-0.15,-1.22l-1.04,-0.57l1.28,-0.11l1.29,0.95l1.89,-0.69l0.35,-0.73l0.17,-1.89l-0.74,-1.46l-1.56,-0.33l-1.47,0.36l-0.94,-0.39l-0.74,-0.85l0.69,-1.58l0.01,-0.89l1.83,0.73l0.57,1.15l0.83,-0.76l-0.19,-1.48l0.65,0.25l4.27,3.47l1.67,2.64l0.03,1.58l-0.54,0.38l0.08,0.45l1.58,2.67l0.05,1.18l1.5,3.26l0.33,2.1l1.72,1.38l0.43,1.3l-0.69,1.44l0.13,1.03l3.34,0.83l1.0,2.0l0.82,-0.11l-0.26,-1.63l1.61,-0.09l1.03,1.58l-0.84,1.74l0.33,0.58l0.36,-0.03l-0.07,1.31l-0.63,0.9l0.51,2.05l0.66,1.22l2.62,2.67l0.66,-0.16l0.3,-0.53l0.72,0.66l0.52,-0.32l0.36,0.98l0.48,0.39l1.0,-0.56l1.79,0.15l0.33,1.45l0.75,1.34l-0.86,0.65l-0.4,1.26l-0.74,0.59l-0.15,0.63l0.41,0.46l0.79,-0.18l1.22,-1.54l-0.58,6.24l-1.43,2.18l-0.05,0.94l0.36,0.77l0.79,0.39l0.5,-0.31l0.55,-1.76l0.49,-0.46l0.36,0.13l0.08,1.12l0.63,0.08l0.72,-0.98l-0.53,-1.25l0.22,-0.34l1.53,-0.13l1.13,1.76l-0.41,1.03l0.43,1.1l-0.44,0.91l0.63,0.75l0.63,-0.04l0.77,-2.0l0.25,-2.81l1.45,4.01l2.55,4.05l-0.0,0.59l-1.1,0.7l-0.56,1.1l-0.88,0.74l-4.99,2.97l-0.41,2.41l-0.29,0.19l-0.82,-2.36l-0.31,-0.23l-0.51,0.23l-0.12,2.12l0.35,1.83l-0.38,1.01l-1.35,1.8l-1.23,3.93l-0.88,-1.19l-0.62,-3.1l-0.01,-3.36l0.86,-1.09l0.2,-2.51l-0.74,-0.07l-0.73,1.99l-1.25,0.49l-0.29,1.37l0.01,3.91l0.52,2.92l-0.6,0.11l-0.47,0.64l0.43,0.7l0.56,-0.32l0.79,0.09l0.54,1.32l0.01,0.98l-0.55,1.68l-0.53,0.24l-1.61,-3.56l-1.26,-0.29l-0.63,0.4l0.24,1.93l1.14,3.26l-1.23,6.18l-0.61,-0.32l-1.0,-1.97l-0.59,-2.02l-2.34,-4.18l-0.79,-2.67l-0.53,-0.43l-0.56,0.18l-0.33,0.62l0.12,2.33l0.44,1.87l1.02,1.16l1.11,3.98l-1.18,-0.05l-0.09,-0.94l-1.2,-1.69l-1.01,-0.29l-1.17,0.31l-1.2,-0.15l-0.27,0.75l0.37,0.58l1.69,0.52l-0.14,0.89l0.49,1.36l-0.15,0.61l-1.23,-0.2l-1.35,0.21l-1.56,-0.79l-2.05,-0.4l-1.24,-1.3l-0.48,-0.07l-0.78,0.58l-0.64,-1.58l0.37,-0.7l-0.22,-0.44l-0.47,-0.21l-0.89,0.54l-0.63,-0.45l-0.1,-0.8l-1.3,-1.2l-0.38,-1.65l0.28,-0.21l1.46,0.33l0.74,-0.73l2.95,-0.62l0.86,0.49l0.55,-0.29l0.05,-1.03l-0.43,-0.4l-0.49,0.13l-4.38,-1.38l-0.81,-0.7l-0.67,0.1l-0.6,0.73l-1.14,0.23l-0.67,-1.1l0.51,-0.55l-0.11,-0.64l-0.97,-0.04l-1.04,-1.94l0.67,-0.03l2.14,1.28l0.87,-0.29l0.09,-1.05l-2.64,-2.05l-1.57,0.05l-0.31,-1.14l-1.48,-2.49l1.63,-1.14l1.69,-0.35l1.33,-2.87l2.16,0.72l0.8,-0.47l2.17,0.38l2.04,-0.23l2.53,-0.78l4.18,-0.63l1.03,-0.73l0.06,-0.6l-0.62,-0.54l-3.01,0.21l-1.66,0.56l-3.52,0.53l-2.43,-1.02l0.26,-0.96l3.07,0.27l1.37,-0.86l2.42,-0.48l0.39,-0.39l-0.05,-1.33l-0.59,-0.13l-2.79,0.77l-0.44,0.49l-3.09,-0.65l1.69,-1.4l-0.35,-0.85l-1.91,-0.0l-1.26,0.94l-0.56,-1.7l-0.52,-0.28l-0.54,0.36l-0.09,0.64l-0.81,0.08l-0.89,2.24l-0.39,-0.2l-0.46,0.22l0.02,1.27l-1.24,1.27l-0.63,-0.47l0.05,-0.83l1.68,-1.95l-0.44,-0.41l-1.11,0.12l-1.74,-0.96l-0.65,0.26l-0.05,1.36l0.28,0.17l-0.39,0.47l-2.34,1.55l-0.47,-0.19l0.35,-1.57l-0.51,-0.45l-0.28,-1.3l-0.7,0.05l-0.3,0.43l-1.03,-0.62l0.5,-0.81l-0.32,-0.72l0.18,-1.43l4.91,-1.61l2.03,-2.07l0.3,-2.61l-0.32,-0.52l-0.56,0.01l-0.34,0.87l-0.87,0.4l-0.19,0.68l-0.74,0.75l-1.95,0.74l-2.78,-0.29l-1.1,-2.17l-0.49,-0.32l-0.01,-1.33l-0.75,-1.13l0.17,-0.75l0.45,-0.45l0.71,-0.08l0.23,-0.63l-0.53,-0.83l-1.52,-0.59l-0.23,-1.34l1.14,-0.5l0.25,-0.41l-0.33,-0.35l-1.22,-0.01l-0.27,-0.93ZM443.8,113.87l0.28,0.85l-0.7,0.52l0.38,-0.96l0.04,-0.42ZM461.48,146.36l0.13,0.3l0.04,0.32l-0.12,-0.23l-0.04,-0.39ZM467.94,95.1l-0.47,-0.95l0.29,-0.52l-0.28,-0.92l-1.08,-0.44l-0.75,-1.59l0.06,-2.29l0.7,-1.35l3.12,0.6l0.09,0.38l0.55,5.34l-0.36,0.49l-1.5,0.62l-0.38,0.64ZM428.65,100.85l-0.38,0.08l-0.0,-0.39l0.24,-0.06l0.14,0.37ZM467.95,144.5l0.1,-1.31l0.38,-0.62l-0.14,0.96l-0.34,0.97ZM468.78,140.89l0.02,-0.58l0.13,-0.05l0.0,0.05l-0.16,0.58ZM453.23,161.28l0.5,-0.07l0.77,-0.83l2.87,0.68l2.74,3.45l0.26,0.55l0.03,2.25l0.38,0.77l-0.72,1.38l-1.41,1.41l-1.23,0.17l-0.11,-0.75l-2.86,-1.81l-0.9,-1.33l-0.47,-0.99l0.15,-4.88ZM459.14,188.77l-0.7,-0.78l-2.16,-5.38l0.28,-0.78l1.01,-0.69l1.58,-0.38l1.42,1.91l0.07,0.95l-0.73,0.85l-0.28,1.43l0.25,1.75l0.62,0.81l-0.54,-0.39l-0.59,0.06l-0.23,0.64ZM457.58,356.16l0.14,0.07l-0.06,0.19l-0.08,-0.25l-0.0,-0.01ZM455.83,351.11l0.05,-0.55l0.96,-0.9l0.46,0.74l0.43,-0.01l-1.07,2.13l-0.1,-0.72l-0.73,-0.7ZM421.83,269.74l0.48,-0.7l-0.15,-1.2l0.22,-0.51l0.89,-0.23l-0.3,-1.11l0.12,-2.99l-0.26,-0.6l0.3,-1.27l-0.42,-1.81l0.32,-0.7l-0.08,-1.33l0.69,-0.26l0.16,-0.47l-0.96,-1.52l0.29,-1.54l1.24,-0.77l0.17,0.34l0.72,-0.1l1.47,2.21l1.38,0.57l1.36,-0.07l0.32,-0.59l-0.37,-0.69l-1.14,-0.38l-1.36,-2.16l0.98,-0.76l-0.17,-0.53l-0.59,-0.51l-0.85,0.35l-0.54,-0.66l-0.12,-0.73l0.47,-1.74l2.55,-0.98l0.77,-0.82l1.73,0.05l0.55,-0.74l2.57,-0.04l0.41,1.09l0.68,0.41l0.56,-0.37l0.06,-1.69l2.47,-0.16l1.5,0.85l1.37,0.29l0.39,1.11l0.71,-0.28l1.18,0.83l0.76,1.32l-0.39,0.98l0.42,0.52l1.3,-0.14l0.39,-0.31l0.08,-0.66l1.43,-0.69l0.46,0.18l1.18,-0.33l3.56,0.65l4.04,2.08l0.38,-0.17l0.33,0.23l-0.07,0.27l-0.72,0.01l-0.29,0.45l-0.0,1.59l-2.62,5.22l-1.34,0.04l0.33,1.6l-1.65,3.1l-0.55,1.82l-1.86,0.4l-0.55,0.4l0.19,0.66l1.32,0.34l-3.2,7.7l-1.06,1.11l-0.52,1.08l-1.63,0.64l-5.37,-1.84l-0.78,-0.76l-0.72,0.49l-1.32,0.19l-3.56,0.14l-0.95,-0.24l-0.56,0.5l-0.05,1.51l0.48,0.21l0.64,-0.4l1.16,0.6l1.13,-0.0l-0.14,1.38l1.23,1.05l0.93,2.98l-0.58,0.61l-0.52,1.41l-1.34,0.93l-1.65,3.59l-0.43,1.79l-0.69,0.16l-0.4,0.84l-0.42,-0.29l-2.74,0.09l-2.11,0.69l-0.62,-0.41l0.13,-0.97l0.67,-0.66l0.02,-0.57l1.89,-0.52l0.29,-0.35l-0.84,-0.59l-1.68,0.45l-0.24,-0.64l0.46,-3.7l-0.36,-1.51l0.5,-0.08l0.15,-1.05l-0.45,-1.57l-0.64,-0.36l0.07,-1.37l-0.3,-0.76l-0.77,-1.19l-0.61,-0.21l0.04,-0.31l0.43,-0.08l0.02,-0.5l-0.22,-1.02l-0.66,-0.35l0.45,-2.58l-0.49,-1.85ZM431.01,292.59l0.04,-0.02l0.01,0.07l-0.05,-0.05ZM454.76,352.74l-0.33,-0.41l0.26,-1.19l0.62,1.43l-0.04,0.91l-0.26,0.07l-0.25,-0.82ZM453.11,471.02l0.19,0.06l0.17,0.16l-0.28,-0.02l-0.08,-0.2ZM447.02,341.38l0.79,-0.49l0.19,0.79l-0.27,0.56l-0.72,-0.86ZM446.66,468.82l0.04,0.02l-0.03,0.04l-0.0,-0.0l-0.01,-0.06ZM446.04,340.0l0.11,-0.11l0.26,-0.0l-0.36,0.11ZM425.5,160.21l0.49,-2.25l1.81,-1.24l1.48,-0.31l0.54,-0.62l0.02,1.13l0.51,0.52l1.76,-0.4l0.66,-0.74l2.7,0.52l0.3,0.41l1.57,-0.09l0.37,0.57l1.03,0.19l0.47,-0.77l0.65,-0.21l1.66,1.12l0.5,1.38l-1.11,0.32l-0.29,0.39l-0.09,1.16l-0.63,1.11l-0.21,2.13l-1.31,-0.35l-0.34,0.35l-0.52,-0.45l-0.63,0.21l-1.22,-0.71l-8.83,-0.54l-1.35,-2.81ZM419.43,222.82l0.2,-1.65l0.75,-1.77l0.4,0.08l0.22,-0.29l-0.03,-0.66l2.31,-0.56l0.07,-0.68l0.55,-0.3l0.08,-0.54l-0.75,-0.37l0.27,-0.52l0.23,0.14l0.84,-0.46l0.24,-0.64l0.7,-0.46l-0.08,-0.71l-0.69,-0.49l0.23,-0.91l1.79,-1.27l0.28,0.25l0.54,-0.2l0.25,-0.76l0.83,0.15l1.57,-1.09l2.61,0.99l2.17,3.93l1.14,1.59l0.64,0.37l0.05,0.47l-0.45,-0.01l-0.44,0.54l1.78,1.21l-0.53,1.41l0.6,1.82l-0.25,0.98l-0.86,0.8l0.17,0.58l0.6,0.02l0.4,1.35l-0.24,4.58l-0.78,0.52l0.6,0.57l-0.13,0.64l-0.56,0.6l-3.39,0.25l-0.81,-0.49l-1.09,0.57l-1.25,-0.11l-0.52,-1.16l-1.47,-0.02l0.15,-1.12l-1.59,-1.93l-2.06,-0.33l-0.25,-0.62l-0.56,-0.15l-0.37,0.45l0.06,-0.28l-1.44,-1.78l0.6,-0.63l-0.38,-0.86l0.3,-0.92l-0.31,-0.32l-0.73,0.08l-0.28,0.41l-0.55,2.09l-0.32,-0.23l0.55,-1.11l-0.12,-0.78l-1.46,-0.23ZM423.67,213.82l-0.12,-0.05l0.05,-0.1l0.03,0.01l0.04,0.14ZM433.58,79.03l2.22,0.14l0.49,1.16l-0.62,0.41l-1.02,-0.43l-0.89,-0.87l-1.79,-0.23l1.6,-0.17ZM416.34,136.36l0.3,-0.35l1.26,0.04l0.49,-0.68l-0.1,-0.97l-0.82,-0.91l-0.38,-1.02l0.11,-2.87l0.9,-0.83l3.13,0.78l0.51,0.65l1.75,1.11l0.41,0.91l0.93,0.51l0.7,-0.02l0.95,1.65l0.71,0.19l-0.63,1.81l0.15,0.41l1.8,1.36l0.6,-0.03l0.79,-0.78l0.94,0.36l2.76,3.08l-0.08,1.03l-2.91,2.52l0.37,0.9l1.07,0.6l0.11,0.78l0.87,1.3l-0.07,0.95l-0.9,2.19l-1.57,-0.19l-0.44,0.55l-1.95,1.05l-2.63,0.71l-0.06,-0.7l-0.92,-0.34l-0.69,0.61l-0.65,0.08l-0.05,1.0l-0.78,0.91l-0.66,-0.34l-0.0,-1.2l0.75,-1.23l-0.18,-0.48l-1.67,-0.96l-0.47,-0.94l-1.21,-0.97l0.27,-0.99l3.77,0.54l0.55,-0.78l-0.01,-1.08l-2.74,-2.31l-0.91,0.02l-0.92,-0.39l-0.2,-1.24l-1.04,-0.99l0.29,-0.59l-0.28,-0.89l0.23,-0.89l-0.93,-0.57l-0.56,-0.87l-0.07,-1.19ZM432.67,201.01l0.19,2.46l0.62,2.14l-1.67,0.27l-0.48,-0.62l-0.05,-2.39l-0.41,-1.08l1.79,-0.78ZM430.12,501.31l0.96,-0.01l0.44,0.57l-0.36,0.42l-0.49,-0.85l-0.56,-0.13ZM423.39,233.69l0.63,-0.4l0.07,-0.68l0.56,-0.1l0.61,0.53l0.83,1.95l-0.18,0.21l-2.0,-0.89l-0.51,-0.62ZM417.6,212.21l-0.01,-0.76l1.61,-1.09l0.76,-0.04l-0.24,0.78l0.18,1.15l-1.18,0.75l0.15,0.81l-0.6,0.23l-0.36,-0.28l-0.31,-1.56ZM421.46,209.34l0.11,-1.05l1.96,1.73l-0.02,0.39l-0.55,0.26l-0.77,1.3l-0.81,-1.09l0.37,-1.08l-0.28,-0.46ZM421.74,297.82l0.27,-0.12l0.0,0.05l-0.27,0.08ZM422.35,296.54l-0.3,-0.28l0.46,-0.16l-0.15,0.44ZM389.32,351.88l0.51,0.4l1.44,0.15l1.01,-0.75l1.02,0.07l0.81,-0.73l0.32,-1.55l0.58,0.4l0.61,-0.56l0.91,-0.16l0.14,-1.27l-1.28,-2.05l0.07,-0.19l0.61,0.31l0.66,-0.29l-0.03,-0.64l-1.01,-0.85l0.13,-0.8l0.88,0.34l0.57,1.52l1.06,0.88l0.08,0.65l0.59,0.28l0.66,-0.31l0.18,-0.77l-2.25,-3.41l0.79,-2.88l0.5,-0.74l0.8,-0.26l0.81,-1.47l0.31,-0.08l1.31,0.89l0.27,1.08l1.42,0.84l0.46,1.11l-0.54,0.13l-0.38,0.69l0.66,1.71l0.24,0.2l0.6,-0.23l0.58,-1.54l0.87,2.19l1.32,1.95l0.85,0.26l0.47,0.8l1.2,0.59l2.15,2.52l0.23,0.86l-0.68,1.93l-0.02,2.57l0.77,0.85l0.75,-0.36l-0.16,-1.17l0.38,-2.07l0.53,2.02l-0.4,1.12l0.81,1.59l0.1,2.03l0.36,0.29l0.71,-0.21l0.18,0.86l0.49,0.36l0.8,-0.15l1.41,-1.22l0.64,0.63l-0.43,0.92l-1.47,1.44l-0.42,-0.7l-0.44,-0.09l-1.61,0.33l-0.77,2.34l-0.47,-0.21l-0.57,0.2l-2.45,2.86l-1.47,0.43l-2.91,-1.81l-1.27,-1.48l-0.32,-0.06l-0.46,0.51l0.24,0.89l-0.23,0.15l-1.46,-0.8l-0.66,0.12l-2.02,-2.6l-2.0,-1.12l-0.64,0.25l-0.51,-0.54l-0.37,-0.76l0.39,-1.34l-1.03,-1.12l-0.32,-0.11l-0.64,0.41l0.01,1.38l-0.33,0.51l-0.47,-0.99l-0.44,-0.24l-0.6,0.16l-0.84,-0.83l0.57,-1.76l-1.34,-1.01l-0.45,0.01l-0.37,0.63l-0.84,0.05l0.3,1.29l-0.62,0.2l-1.39,-1.1l-0.1,-1.13l-0.77,-1.73l1.01,-1.65l0.72,0.14l0.43,-0.42ZM414.79,346.68l0.44,-0.57l0.05,-0.57l0.3,-1.06l1.01,-0.52l0.15,0.42l0.6,0.06l1.43,1.8l-0.36,2.41l-0.8,1.03l-0.84,0.08l0.04,-0.75l0.51,-0.5l0.04,-2.23l-0.18,-0.91l-0.59,-0.67l-0.75,-0.06l-0.43,0.52l0.26,1.87l-0.55,1.17l-0.32,-1.5ZM415.07,348.28l-0.2,0.62l0.01,0.28l-0.08,-0.53l0.28,-0.37ZM411.44,98.32l0.33,-1.33l-0.06,-1.8l0.73,-1.46l1.24,-1.13l0.58,0.21l0.71,0.96l1.52,-0.38l0.76,1.21l0.4,2.99l-0.44,1.72l0.3,3.01l-0.67,1.82l-1.8,-1.46l0.27,-2.18l-1.22,-1.67l-2.43,0.15l-0.23,-0.65ZM374.78,271.19l0.15,-1.85l1.27,-1.98l0.55,-1.94l0.48,-0.66l2.36,-0.71l1.55,1.82l-0.34,0.83l0.39,1.03l0.68,0.99l0.56,0.12l0.22,1.9l0.49,0.66l-0.18,0.65l0.47,0.74l1.29,0.49l0.49,0.52l1.58,0.06l0.68,-0.72l0.01,-0.4l1.14,-0.03l1.2,0.51l1.05,-1.22l0.12,-1.68l1.82,-0.35l0.03,-0.82l0.38,-0.53l-0.5,-1.09l0.18,-0.82l-0.41,-0.96l0.14,-0.49l-0.57,-0.66l0.24,-0.76l-0.97,-0.3l-0.87,0.71l-0.41,-0.77l0.78,-0.72l0.06,-0.81l0.52,-0.73l0.47,0.0l0.27,0.73l1.42,1.47l1.64,-0.08l0.32,-0.32l-0.07,-0.62l-1.04,-0.25l-0.62,-0.65l-1.19,-2.97l-0.71,-0.9l-0.08,-0.74l-0.83,-1.12l0.58,-2.35l-1.21,-1.14l-0.87,0.1l0.29,-0.74l-0.33,-0.49l-0.85,-0.27l0.61,-2.28l0.62,-0.18l0.9,0.24l0.62,-0.74l1.09,0.32l1.89,1.7l0.23,0.85l0.69,0.01l0.58,-1.72l0.83,-0.9l0.31,0.43l1.15,0.47l1.58,2.23l-0.29,0.59l0.71,0.75l0.58,-0.42l0.18,-0.95l1.36,-0.09l0.52,0.63l0.91,-0.84l3.77,-0.59l1.14,-0.84l0.26,-0.54l0.62,0.59l1.21,-0.69l0.81,0.75l1.16,0.18l1.5,2.73l-0.26,1.97l-1.21,0.85l-0.35,0.67l-1.17,-0.78l-0.51,0.4l0.01,0.85l-0.96,-0.32l-0.62,1.66l0.6,1.01l1.15,-0.71l0.5,0.55l0.9,-0.05l-0.5,0.73l0.51,0.57l-0.16,0.49l-0.57,-0.08l-3.06,1.19l-3.76,4.71l-2.05,1.75l0.35,0.67l-0.23,2.58l0.36,0.6l0.59,-0.24l0.22,-0.91l0.95,-1.48l1.76,-1.18l1.87,0.33l2.34,1.76l-0.22,1.33l-0.72,0.08l-0.36,0.52l0.31,0.42l1.02,0.38l0.34,1.35l0.49,0.18l0.18,0.67l-1.14,1.5l-0.13,1.04l0.33,0.62l1.04,-0.04l1.12,-1.36l1.35,-0.67l0.38,-0.02l0.74,1.45l0.17,1.66l-0.21,0.46l0.63,1.16l0.09,1.39l-0.44,0.09l-0.52,0.87l-1.34,0.98l-1.3,-0.26l-0.36,0.62l1.76,1.4l0.5,2.45l-0.19,1.19l-2.27,0.61l-0.18,0.67l1.48,0.8l0.92,-0.26l-0.21,0.9l-0.63,-0.1l-1.17,1.13l0.45,0.76l1.41,-0.51l-0.71,1.85l-0.1,-0.74l-0.63,-0.17l-0.83,0.85l-1.07,0.25l-1.03,2.19l-0.76,0.59l-1.69,0.9l-1.31,-0.13l-0.61,-0.66l-1.31,-0.44l-1.27,0.17l-0.48,-0.37l-0.54,-1.24l1.3,-3.44l-0.79,-0.72l-0.29,0.11l-0.16,0.76l-1.24,1.51l-0.62,1.81l0.09,0.41l0.55,0.21l0.08,1.18l1.9,2.92l-1.02,1.91l-2.48,2.43l-0.91,-0.15l-0.38,0.34l-1.19,-2.37l-0.67,-0.1l-1.09,0.67l-0.7,-3.87l0.18,-1.2l-1.18,-0.97l-0.52,-3.21l-0.82,-1.07l-0.16,-1.16l-1.32,-0.51l-0.32,-0.47l-1.7,-3.7l0.07,-1.02l-0.42,-0.23l-0.03,-0.65l-0.85,-1.42l-1.04,-0.68l-0.87,-0.1l-0.5,0.37l0.07,-1.82l-1.28,-1.57l-0.91,0.21l-0.89,0.94l-0.86,-0.95l-1.09,-0.07l-0.38,-0.95l0.82,-0.69l-0.35,-0.7l-0.46,-0.11l0.0,-1.42l-1.24,-1.46l-1.58,-1.23l-1.76,-3.24ZM390.55,268.8l-0.03,-0.05l0.05,-0.05l0.03,0.02l-0.05,0.08ZM391.26,258.16l-0.13,1.15l-2.76,1.04l-0.5,-0.37l-0.53,-1.17l-1.27,-0.83l-0.04,-0.89l-0.77,-0.56l-0.6,-1.14l0.9,-1.31l1.09,-0.01l0.35,-0.89l1.65,0.33l1.12,3.12l0.65,0.37l0.36,0.93l0.47,0.23ZM395.86,246.94l-1.15,1.05l-0.61,-0.19l-0.16,-0.44l0.27,-0.56l0.84,-0.53l1.19,0.17l-0.38,0.51ZM383.77,205.23l0.5,0.09l0.47,-0.44l-0.1,-1.22l0.74,-0.18l0.18,-0.7l1.21,0.25l1.04,0.8l0.89,-0.46l-1.01,-1.33l0.62,-0.42l0.02,-0.79l-0.44,-0.25l-0.96,0.16l0.59,-1.18l2.2,-0.44l0.19,0.67l1.47,1.59l0.06,1.16l1.11,0.73l0.42,-0.02l0.74,-0.76l1.12,-0.16l0.51,-0.52l0.08,-0.45l-0.4,-0.23l-2.14,0.59l-0.0,-1.51l-0.29,-0.43l-0.65,-0.12l-0.09,-1.13l1.71,-1.64l0.21,-0.41l-0.29,-0.55l-2.37,0.42l-0.43,-0.71l-0.17,-1.33l0.32,-0.87l0.79,-1.06l1.24,-0.51l1.04,-0.92l0.09,-0.48l-0.44,-0.21l-2.22,0.5l-0.43,-0.28l-1.14,0.02l0.38,-0.39l0.29,-1.99l0.64,-0.46l-0.4,-0.93l1.17,-0.93l1.9,0.7l0.46,0.6l1.07,1.88l-0.53,2.31l1.53,1.03l0.93,1.78l-0.66,0.57l-0.02,0.46l2.18,1.08l1.1,2.81l-0.34,0.81l0.87,0.32l0.08,0.68l0.35,0.29l0.91,-0.75l2.34,-1.06l0.37,-0.86l-0.68,-0.41l-1.87,0.53l0.14,-0.38l-1.03,-1.91l-0.27,-1.66l0.3,-0.33l2.01,1.03l1.72,-0.63l0.33,-0.78l-0.43,-0.19l-1.45,0.33l-1.45,-1.62l-1.17,0.14l-1.42,-1.07l0.11,-0.5l3.22,0.42l0.33,-0.21l-0.05,-0.7l-0.36,-0.16l0.13,-0.62l-0.82,-0.32l-0.61,-1.44l-0.45,0.17l-0.51,-0.44l-1.8,-0.04l-1.23,-2.57l1.37,-0.44l0.53,-1.09l2.08,-1.34l2.12,1.16l0.39,0.02l0.59,-0.55l0.16,0.01l-0.2,0.83l0.76,0.32l1.32,2.38l-0.15,1.12l0.46,0.94l0.63,0.43l0.54,-0.33l-0.22,-0.93l0.86,0.61l0.69,-0.38l-0.07,-1.17l-0.76,-1.67l0.23,-1.16l0.36,-0.21l0.41,0.93l0.62,0.04l0.27,-0.55l0.75,-0.03l0.34,-0.33l0.26,1.46l1.67,1.11l1.4,0.51l0.5,0.54l-0.07,1.37l-0.88,2.32l0.33,1.55l0.98,1.91l-0.05,1.08l-1.22,3.87l0.26,2.81l-0.65,1.32l-1.67,1.18l0.25,0.77l2.72,1.22l0.11,0.51l-0.58,3.27l-1.37,-1.71l-2.28,2.1l-0.15,1.14l1.02,0.43l-1.01,0.13l-0.97,2.26l0.38,1.16l1.4,0.73l0.43,0.59l-0.34,0.65l0.12,0.42l0.54,0.28l0.41,0.74l-0.73,0.28l-0.94,-1.01l0.01,-1.37l-0.71,-0.43l-0.87,1.75l0.3,0.88l0.67,0.69l-0.02,1.48l-4.23,0.38l0.0,-0.4l-0.46,-0.22l-0.03,-0.96l-0.5,-0.29l-0.71,0.3l-0.14,1.04l-1.93,0.15l0.86,-2.32l-0.15,-0.74l-0.84,0.16l-1.17,1.92l-0.24,1.09l-4.37,-1.23l-0.14,-0.34l0.29,-2.82l-0.76,-1.01l0.47,-0.31l2.3,0.38l0.55,-0.3l0.08,-0.47l-1.72,-0.92l0.36,-0.69l-0.45,-0.55l-1.4,0.3l-0.45,-0.63l1.35,-0.74l0.01,-0.51l-0.56,-0.86l3.07,-0.16l0.54,-0.85l-0.09,-0.7l-0.56,-0.21l1.3,-0.09l0.3,-0.63l-0.2,-0.21l0.89,-0.23l0.48,-0.64l-0.75,-0.88l4.91,-0.17l0.58,-0.46l-0.25,-0.89l-3.61,0.21l-0.41,-0.32l-5.51,0.71l-0.52,-0.2l-3.1,0.47l-1.04,0.48l-1.31,-0.58l-3.7,0.92l-0.9,-0.24l-1.18,0.17l-1.18,0.6l-0.43,-0.81l0.21,-0.63l-0.24,-0.45ZM414.36,266.83l0.45,0.33l0.47,-0.16l0.16,1.43l-0.9,1.89l-1.18,0.2l-0.67,-1.27l-0.07,-2.15l0.62,-1.15l1.01,-0.67l0.38,0.38l-0.27,1.17ZM414.02,274.95l-0.9,-0.23l-0.15,-0.37l0.49,-0.5l0.1,-0.82l0.81,-0.84l-0.26,0.71l0.39,1.28l-0.49,0.75ZM411.43,235.03l-0.36,-0.31l0.19,-0.46l0.86,-0.66l0.9,-1.59l0.33,0.01l0.4,0.46l-0.71,1.5l-0.64,0.12l-0.97,0.93ZM410.06,345.07l1.51,0.05l0.61,0.71l0.95,-0.39l0.17,1.41l-0.45,1.89l-0.93,-1.78l-1.28,-0.8l-0.58,-1.09ZM382.97,135.74l-0.59,-2.3l0.01,-1.42l0.39,-0.64l0.86,-0.74l0.61,0.01l2.71,2.01l1.67,0.22l0.66,0.66l0.55,0.07l0.67,-0.79l0.05,-1.1l0.58,-0.39l0.01,-1.18l-0.45,-0.41l-2.55,-0.27l0.4,-0.4l2.02,0.24l0.44,-0.45l-0.09,-0.73l0.84,-0.11l0.34,-0.94l-0.42,-1.23l-0.52,-0.32l-0.83,0.28l-0.01,-0.67l-0.5,-0.27l-0.61,-0.22l-0.47,0.23l-0.37,0.97l-0.54,-0.55l2.05,-1.88l0.29,-0.74l-0.83,-1.4l-0.08,-1.1l-0.98,-0.62l-1.67,0.95l-1.01,2.32l-1.24,1.23l-0.45,0.0l0.1,-0.62l0.88,-1.09l1.46,-2.92l-0.0,-0.8l-1.31,-1.09l-2.53,0.6l-0.45,-0.29l0.45,-3.63l0.53,-1.4l0.88,-1.2l-0.07,-0.85l1.1,0.94l6.94,-0.52l1.44,1.75l0.65,0.01l0.49,0.41l0.69,1.58l-0.09,1.48l1.06,2.6l-0.57,2.15l-0.72,1.05l0.33,0.63l0.61,-0.07l-0.36,0.76l0.38,1.11l0.7,-0.12l0.87,-1.41l0.25,-1.95l1.49,-0.62l0.89,-0.97l0.93,0.3l1.44,2.91l1.25,0.73l-1.32,2.83l0.06,0.88l0.78,0.34l0.19,0.56l0.46,0.26l1.07,-0.57l0.72,0.1l1.01,-0.62l0.22,1.34l1.35,1.15l0.29,0.76l-0.77,0.86l-0.14,0.89l0.78,0.56l0.5,-0.14l0.4,0.76l0.72,0.04l-0.64,1.05l0.21,0.33l-0.5,1.14l-1.11,1.04l0.43,1.71l-0.46,1.99l0.47,0.65l0.88,0.07l0.33,1.97l0.66,0.82l1.4,3.18l-0.19,1.25l-0.82,1.09l0.24,1.78l-0.76,0.83l-3.18,0.26l-0.72,0.75l-3.03,-2.19l0.06,-0.78l-0.78,-2.96l0.56,-1.61l-1.09,-1.69l-0.14,-1.87l-0.46,-0.22l-0.92,0.33l-0.96,-1.37l-3.26,-1.74l-2.35,0.82l-0.76,-0.98l0.11,-0.74l0.74,-0.74l-0.29,-1.0l-3.53,0.22l-0.99,0.46l-0.9,0.01l-1.38,0.96l-0.37,0.67l-2.15,-1.04l-1.32,-2.23ZM402.3,245.78l0.83,-0.17l0.64,-0.53l1.52,0.08l2.32,-1.24l2.75,-0.09l-0.31,1.26l-0.78,1.12l-1.31,0.76l-0.9,1.24l-2.94,0.62l-0.22,-0.46l-0.67,-0.08l-0.2,0.26l-0.48,-0.32l-2.29,-0.19l-0.71,-0.52l0.06,-0.4l1.73,-0.52l0.87,0.11l0.12,-0.96ZM404.64,335.96l0.28,0.24l-0.19,0.49l-0.18,-0.17l0.08,-0.57ZM400.12,384.21l0.18,-0.59l0.82,-0.41l-0.03,0.27l-0.97,0.73ZM393.8,182.29l0.81,-0.68l1.53,-0.23l1.01,-0.86l0.46,-0.91l1.76,-0.32l1.38,0.5l-5.02,2.71l-0.88,0.31l-1.05,-0.51ZM393.1,153.37l0.12,-0.43l-0.41,-0.98l0.08,-1.05l0.43,-0.8l3.57,0.04l2.26,1.78l1.09,2.26l-2.23,-0.06l-0.62,-0.32l-1.53,1.08l-1.75,-0.58l-1.01,-0.95ZM390.55,142.8l-0.47,-0.22l0.1,-0.79l1.29,-1.78l0.47,-0.09l0.13,1.23l-1.53,1.65ZM381.06,200.78l0.49,-0.39l0.1,-0.71l1.3,-0.07l-0.34,-0.8l0.48,-0.76l4.85,-1.31l0.73,0.88l-2.31,0.72l-0.98,2.08l-0.55,0.45l-0.5,-0.27l-0.34,0.28l-0.66,-0.1l-0.22,0.31l-2.06,-0.3ZM378.25,196.4l1.13,-0.61l1.41,0.02l2.27,-1.2l3.84,-0.41l0.31,0.33l-0.14,0.8l-7.87,1.78l-0.94,-0.39l-0.01,-0.32ZM376.08,190.42l0.51,-0.09l0.37,-0.74l0.96,0.03l1.65,-0.6l1.35,0.13l5.02,-0.61l0.58,1.84l-0.32,1.29l-0.74,0.97l-0.9,0.66l-2.34,0.44l-3.2,-0.16l-0.2,-0.51l-2.69,-0.94l-0.05,-1.71ZM383.08,318.64l0.75,-0.08l0.69,0.85l-0.37,0.89l0.52,0.79l0.07,0.8l-0.72,-0.23l-1.1,-1.19l0.16,-1.82ZM376.48,180.64l0.14,-0.82l1.71,-1.08l1.59,0.1l0.19,0.43l-0.93,1.4l0.03,0.52l0.66,0.24l0.6,-0.21l0.59,-0.72l0.65,1.08l0.05,1.03l0.98,0.89l0.62,0.1l0.21,0.64l0.85,0.33l0.05,0.64l-1.9,1.61l-2.86,-0.1l-2.5,-0.58l0.38,-0.74l-0.37,-0.87l0.38,-1.61l-0.3,-0.9l-0.57,-0.15l0.14,-0.53l-0.41,-0.71ZM382.87,351.88l0.5,1.7l-0.24,1.27l-0.56,-0.41l-0.39,-0.96l0.19,-1.09l0.5,-0.51ZM378.76,357.87l0.32,-2.26l0.42,-0.71l-0.17,-1.01l0.44,-0.58l0.86,0.43l0.19,1.04l0.98,1.16l-0.5,1.2l0.11,0.66l-0.35,0.55l-0.68,0.19l-0.41,0.77l-0.05,-1.51l-0.61,-0.22l-0.56,0.3ZM380.85,368.37l0.1,-0.05l-0.02,0.19l-0.08,-0.14ZM374.14,155.27l0.21,-2.42l-0.8,-2.01l0.8,-0.65l0.99,0.44l0.58,0.86l1.89,4.93l0.03,1.06l-0.4,0.64l-0.16,1.45l1.37,0.18l1.17,2.66l-0.18,0.71l0.34,0.43l-0.01,0.7l-0.85,1.86l-0.9,0.06l-0.5,0.4l-0.78,-1.62l-1.22,-0.12l0.13,-0.76l-0.71,-1.63l0.21,-0.27l-0.64,-0.77l0.21,-1.55l-0.35,-0.63l0.01,-1.53l-0.33,-0.43l0.58,-1.2l-0.67,-0.8ZM262.47,316.27l0.34,-0.22l1.12,0.46l0.61,-0.39l-1.96,-6.32l0.67,-1.78l29.24,8.27l-0.78,3.03l0.33,0.57l1.6,0.39l0.47,-0.27l1.21,0.25l0.57,-0.32l0.28,-0.67l-0.55,-0.7l0.35,-1.4l17.48,4.16l0.48,-0.3l11.63,-52.12l1.02,0.72l0.45,-0.55l-0.42,-0.8l0.69,-0.71l-0.54,-1.4l-0.24,-1.55l0.18,-0.81l0.81,0.54l0.91,-1.42l-0.36,-0.62l-0.9,-0.56l0.84,-3.76l0.49,0.81l0.68,-0.14l0.16,0.09l-0.66,0.45l-0.02,0.46l1.77,2.72l0.22,0.8l1.31,0.03l-0.22,0.72l0.89,1.23l-0.65,1.01l-0.12,1.31l1.49,0.42l0.49,-0.38l0.61,0.57l-0.0,1.22l-1.19,3.5l0.19,3.2l-0.22,1.41l0.7,0.67l-0.61,2.61l0.7,0.59l-0.36,0.57l0.2,0.65l0.53,-0.06l-0.76,0.93l0.12,1.0l-0.43,0.87l0.57,1.07l-0.58,0.75l0.71,0.62l0.63,-0.14l0.24,1.97l0.89,0.76l0.73,-0.02l0.66,-0.57l-0.5,-1.35l0.11,-0.47l0.57,0.49l0.46,-0.1l0.95,-1.25l2.02,-0.19l0.34,-0.55l-0.93,-1.07l0.96,-0.16l0.34,-0.89l-0.87,-0.81l-0.05,-1.22l-1.01,-0.89l-0.03,-1.0l0.38,-0.81l-0.2,-0.86l-0.61,-0.33l0.22,-2.55l0.4,-0.02l0.4,-0.69l-0.45,-1.3l0.23,-0.62l-0.26,-0.84l0.67,-0.65l-0.92,-1.26l0.65,-0.41l0.21,-1.11l-0.5,-1.17l0.21,-1.86l-0.25,-1.13l0.28,-1.02l-0.12,-1.87l0.37,-0.58l-0.2,-1.1l0.32,-0.72l-0.25,-0.96l0.41,-0.63l-0.51,-1.77l0.88,-1.09l1.54,0.68l0.58,-0.44l-1.25,-2.02l0.07,-0.53l0.29,0.08l0.47,-0.7l0.88,0.63l0.88,0.17l1.07,1.06l1.44,2.45l0.78,0.6l0.86,-0.52l-0.4,-1.36l0.32,-0.64l1.15,-0.22l0.52,1.8l1.16,0.69l1.15,3.08l1.46,1.27l0.95,-0.04l-0.08,0.98l1.0,1.42l0.39,1.62l-0.25,0.32l0.71,0.92l0.14,0.68l-0.45,-0.14l-0.38,0.59l0.3,0.98l-0.17,0.88l0.84,1.07l-0.49,0.76l-0.05,1.17l0.44,1.05l-0.06,0.9l-0.51,0.11l-0.15,0.45l1.27,6.09l-0.75,1.49l-0.03,0.87l0.63,1.99l-0.0,3.18l0.86,1.04l1.18,5.51l-0.52,1.49l0.4,1.04l-0.28,0.91l0.13,0.89l-0.7,-0.16l-0.58,0.46l-0.33,3.04l-1.42,1.39l-0.22,0.73l0.27,1.13l2.57,3.54l0.53,3.8l1.04,0.58l1.58,3.35l1.99,0.55l0.86,1.98l1.46,0.57l0.59,-0.41l1.2,0.86l1.63,1.49l1.31,2.18l0.55,0.1l1.0,1.5l1.19,0.26l0.48,-0.79l0.39,0.02l0.35,0.54l-0.46,0.82l-0.08,1.02l0.58,1.75l1.49,-0.09l0.39,-0.62l0.4,0.54l0.48,0.08l1.21,-0.95l-0.15,1.9l0.29,1.38l-0.44,2.07l0.43,0.9l-0.09,1.65l-0.72,1.31l-0.15,1.26l-1.32,-0.65l-0.67,0.31l-0.66,-3.2l0.48,-1.61l-0.57,-0.42l-0.55,0.52l-1.63,3.9l-0.92,-1.31l-0.6,-0.05l-0.31,-2.12l-0.58,-0.38l-0.43,0.24l-0.04,-1.44l-0.73,-0.32l-0.41,0.42l-0.06,0.89l-0.59,0.26l-0.22,0.59l-1.04,0.38l-0.53,0.69l-0.48,-0.51l-0.55,0.22l0.26,1.51l0.78,0.74l-0.26,1.54l-0.39,0.73l-0.94,-0.2l-0.6,0.2l-2.17,-1.88l-0.77,-1.75l-0.7,-0.11l-0.5,-0.54l-0.75,0.27l-0.57,1.77l0.21,0.51l1.76,1.56l0.29,2.37l0.48,0.31l0.4,-0.29l0.06,0.36l-0.47,1.0l-0.33,2.26l-1.53,1.25l-0.23,1.27l0.19,0.67l0.83,0.07l3.22,-5.13l2.26,-0.4l0.69,-1.2l1.16,-0.27l1.41,0.46l0.57,1.19l-0.6,0.74l-0.6,-0.16l-0.61,0.35l-0.19,0.91l0.88,0.86l-0.73,-0.42l-0.47,0.19l-0.23,1.51l0.79,1.13l0.6,0.1l1.0,-1.4l0.8,1.26l-0.15,1.22l-0.9,1.48l0.22,1.0l-0.75,0.25l-0.33,-0.59l-0.49,-0.14l-0.9,0.89l-0.99,0.11l-0.83,-0.36l-0.29,0.99l-0.81,0.73l-0.57,-0.08l-0.73,-0.79l-0.54,0.06l-0.25,0.47l0.21,0.79l-1.58,0.48l-1.41,-1.13l-1.54,0.16l-0.46,0.75l-0.83,-1.04l-0.68,0.11l-2.23,-1.32l-1.04,-0.01l-0.64,-0.67l-0.13,-1.19l-0.49,-0.23l-0.48,0.33l-1.02,-0.36l-1.12,1.34l-3.67,-1.26l-0.44,-0.87l0.42,-0.51l0.84,0.21l0.39,-0.59l0.89,-0.46l0.07,-1.33l-1.14,-0.77l-0.63,0.07l-0.18,0.42l-1.9,-0.84l-0.64,-1.26l-2.42,-0.91l-0.98,0.41l-0.62,-0.34l-0.85,0.03l-1.13,-0.9l0.18,-0.56l1.13,-0.89l0.18,-2.67l-1.17,-2.34l-0.63,-0.51l-0.57,0.07l-1.24,1.02l-0.36,1.29l-1.64,0.17l-0.44,0.87l0.03,2.26l-1.95,1.24l-1.64,2.04l-1.04,0.42l-3.64,0.38l-1.98,-0.24l-0.74,-0.56l-1.6,-0.22l-0.57,0.31l-0.2,1.17l-3.95,2.3l-2.46,0.08l-2.36,0.7l-4.52,-0.72l-1.13,0.66l-0.42,-0.66l-1.03,-0.4l-0.99,0.46l-0.8,-0.06l-0.15,-0.53l-0.49,-0.28l-1.77,0.25l-2.42,-0.49l-0.27,0.61l0.33,0.46l-0.96,-0.57l-5.64,-0.97l-0.98,0.22l-1.61,-0.49l-1.27,0.6l-1.79,-0.57l0.13,-0.55l-0.32,-0.87l-1.54,-1.6l-0.33,-1.07l0.21,-1.24l-0.95,-2.35l0.51,-0.81l-0.15,-1.07l1.06,-1.01l0.32,-1.61l0.35,-0.3l-0.49,-1.01l0.3,-1.25l-0.2,-0.28l1.27,0.35l-0.11,-0.95l-2.26,-1.51l-0.3,-0.67l-1.49,-0.29l-0.78,-0.94l-1.12,-0.4l-3.35,-0.19l-0.29,-0.58l-0.83,-0.38l-1.01,0.57l-0.4,-0.07l-5.16,-2.72l-0.36,-0.87l-2.9,-2.59l-0.34,-0.9l0.7,-0.64l-0.02,-1.81l-1.35,-0.46l-0.43,-0.47ZM296.56,348.77l0.63,0.22l-0.45,-0.1l-0.19,-0.12ZM366.43,318.73l-0.64,-0.33l-0.41,-0.68l0.04,-1.63l1.15,1.7l-0.13,0.94ZM282.87,346.74l-0.62,-0.06l-0.07,-0.11l0.28,-0.07l0.41,0.24ZM375.09,341.57l0.15,-0.39l0.23,0.67l0.99,0.31l0.56,1.07l-0.52,0.08l-0.53,1.04l-0.26,-0.31l0.57,-0.88l-0.05,-0.43l-1.15,-1.16ZM370.58,212.41l0.63,-0.81l-0.25,-0.62l0.65,-1.25l1.74,-1.62l1.28,0.15l1.48,1.77l-0.02,2.98l0.67,1.48l-1.81,1.97l-2.25,0.64l-1.81,-0.94l-1.43,-1.88l1.13,-1.86ZM372.31,349.42l-0.69,-0.62l0.14,-0.26l0.41,-0.04l0.14,0.92ZM365.73,358.82l1.94,-1.29l0.43,-1.11l1.72,1.01l-0.26,2.28l-0.91,-0.23l-0.19,1.24l-2.73,-1.91ZM369.18,337.84l-0.03,-0.16l0.09,-0.51l-0.05,0.67ZM337.82,214.18l3.33,-14.86l4.92,2.08l0.83,0.69l0.52,-0.53l-0.01,-1.39l0.62,-0.25l-0.09,-0.68l0.49,-0.66l-0.15,-1.21l0.44,-0.26l-0.04,-0.72l-0.58,-0.34l-0.72,-1.28l-1.49,-0.97l0.19,-0.28l-0.28,-0.37l-1.02,-0.32l0.17,-1.39l-0.27,-0.41l-0.58,-0.18l-0.95,0.31l-0.1,-0.24l0.12,-0.51l1.89,-0.36l3.0,-2.09l-0.44,-0.87l0.4,-0.22l0.13,-0.66l-0.81,-1.27l-0.09,-0.89l-0.7,-0.39l0.04,-0.55l-0.83,-0.78l-0.79,0.02l1.18,-5.28l1.03,-0.03l0.84,-0.79l0.07,-0.44l-0.35,-0.41l0.3,-0.53l0.72,-0.25l0.05,-0.45l0.7,-0.4l0.77,-1.99l0.91,-0.57l0.33,-0.78l0.74,-0.49l0.74,0.03l0.54,0.4l0.98,-0.45l-0.22,1.63l1.01,0.5l-0.04,1.06l-0.74,0.83l-0.6,-0.1l-0.57,0.55l0.04,0.99l0.62,1.21l-0.62,0.59l0.16,1.74l-0.64,0.93l0.44,0.66l1.12,0.41l0.69,2.61l-0.87,0.53l-0.03,0.6l0.38,0.45l-1.58,0.69l-0.77,1.54l0.06,0.6l-0.65,0.89l0.43,0.58l3.42,0.05l0.8,1.47l-0.08,0.42l-0.97,0.79l-0.07,0.52l-0.72,0.11l-0.88,1.26l-0.45,0.83l0.12,0.99l0.67,0.27l0.49,-0.25l1.48,-1.92l1.96,-0.34l0.7,0.21l0.47,0.48l-0.35,1.03l0.36,1.12l-0.23,0.63l0.31,0.56l-0.13,2.25l0.32,0.54l0.6,-0.22l0.57,-2.72l1.25,-0.28l0.36,-0.61l-1.34,-0.99l0.58,-2.78l1.65,-1.78l1.33,0.24l2.88,2.18l0.61,1.29l0.46,1.92l-0.43,4.97l-0.94,1.77l-1.11,0.48l-0.57,0.8l-0.04,0.53l0.65,0.45l-0.78,0.99l0.13,1.24l-1.86,2.23l-0.44,0.99l0.28,0.91l-0.23,0.57l-0.69,0.17l-0.65,0.83l0.24,0.93l-4.44,0.4l-1.89,1.54l-1.09,-0.14l-1.52,-0.82l-0.69,-0.88l0.37,-2.12l-0.6,-1.0l-0.56,0.23l-0.2,1.4l-0.41,0.27l-0.57,-0.29l-0.45,0.3l-0.02,1.12l-0.37,0.42l-2.11,0.0l-0.5,-0.85l0.43,-0.31l-0.27,-1.67l-0.39,-0.58l-1.31,-0.64l-0.96,0.5l-0.65,1.08l-2.33,0.72l-1.36,1.53l-2.16,-0.53ZM353.07,252.53l-0.18,-0.64l-1.02,-0.65l-0.84,-1.21l-1.37,-0.46l3.4,-4.11l5.53,0.43l1.12,-0.43l1.11,0.01l1.15,0.48l1.47,2.13l0.1,0.62l1.03,0.62l0.77,1.33l-0.89,2.33l-0.41,2.7l-1.52,2.31l-0.12,0.8l-1.88,1.94l-0.41,1.43l-1.39,1.24l-0.29,-0.36l-0.77,0.15l-0.06,1.2l-0.11,-1.26l-2.04,-4.53l0.12,-0.68l-0.91,-0.66l0.22,-0.81l-0.61,-1.05l0.34,-0.68l-1.54,-2.22ZM356.38,131.25l0.61,-2.73l1.07,-4.77l0.81,1.78l0.66,0.28l0.31,0.67l0.28,1.9l-1.49,3.66l-1.82,0.06l-0.43,-0.84ZM354.22,140.9l0.72,-3.2l0.99,0.25l0.23,0.79l-0.87,1.71l-1.07,0.45ZM344.51,358.33l0.94,-0.21l1.34,0.38l0.66,0.56l0.64,1.22l-0.21,1.16l-1.07,0.09l-0.69,-0.57l-0.82,-0.81l-0.78,-1.83ZM343.45,246.05l0.34,-0.35l0.86,-0.03l1.16,0.72l-2.21,0.24l-0.15,-0.58ZM319.66,383.43l0.58,1.04l0.11,0.1l-0.52,-0.1l-0.16,-1.05ZM317.77,367.13l0.19,-0.56l0.63,-0.35l-0.4,1.1l-0.43,-0.19ZM317.48,374.25l-0.13,-0.78l0.25,-1.06l0.35,1.97l-0.46,-0.13ZM317.12,377.88l0.04,-0.85l0.65,-0.18l-0.58,1.35l-0.12,-0.32ZM314.41,374.19l0.57,0.24l-0.14,0.63l-0.37,0.19l-0.06,-1.06ZM311.1,365.02l0.9,-0.17l0.05,1.27l-0.95,-1.11ZM308.9,362.27l0.31,0.24l0.02,0.64l-0.44,-0.71l0.11,-0.16ZM305.06,360.24l0.09,-0.06l-0.03,0.05l-0.06,0.02ZM299.0,350.45l1.55,-0.48l0.33,0.64l-1.15,0.07l-0.73,-0.23ZM292.58,354.28l-0.15,-0.28l0.45,-0.29l-0.16,0.44l-0.15,0.13Z",name:"Nunavut"},"CA-NS":{path:"M806.14,740.09l0.6,-1.1l-0.19,-1.16l1.53,-2.49l0.42,-2.61l0.6,-1.53l-0.03,-2.56l0.54,-3.5l1.51,-3.01l0.15,-1.97l0.16,-0.35l1.13,0.17l0.58,-0.23l-0.36,1.59l1.07,0.72l1.38,-0.48l0.25,0.69l0.19,1.88l-0.37,0.37l0.03,0.59l0.78,0.69l-0.34,1.48l0.1,1.93l-0.48,4.15l0.66,0.61l-0.35,0.83l-0.42,0.47l-0.53,0.06l-0.41,0.74l-0.44,0.35l-0.86,0.06l-0.71,1.87l-1.26,1.0l-0.2,0.83l0.56,0.34l0.4,-0.18l-0.21,0.92l0.5,0.44l0.95,-0.7l0.24,0.03l-1.43,1.75l0.15,1.53l1.35,0.03l1.28,-1.57l0.61,-0.21l0.72,0.25l-0.26,0.86l-0.98,0.93l-0.57,0.09l-0.98,1.27l-1.15,-0.45l-1.0,1.26l-1.85,-1.48l-1.42,-2.29l-0.27,-1.03l-1.36,-1.87ZM816.61,744.13l1.05,-1.41l-0.51,-1.54l2.33,-3.96l0.31,-1.02l-0.19,-0.41l-0.45,0.02l-2.83,2.93l-0.59,-0.45l2.36,-3.35l0.82,-2.08l0.74,-0.69l-0.04,-0.59l-0.69,-0.2l-1.08,0.73l-0.44,1.08l0.12,-0.58l0.95,-1.72l0.31,-0.23l1.11,0.83l0.0,0.01l-0.5,1.38l0.14,0.46l0.77,-0.36l0.46,0.32l0.48,-0.32l-0.25,-1.23l0.25,-0.6l0.28,-0.06l-0.09,0.39l0.46,0.2l1.39,-0.32l0.44,0.58l0.8,-0.47l0.17,1.41l-0.68,0.84l0.12,0.42l0.59,0.46l1.08,-0.34l0.3,0.34l-1.47,1.09l-0.16,0.62l-1.5,0.75l-0.17,0.84l0.9,0.39l-0.87,0.89l-0.13,0.94l-1.5,1.69l-1.05,0.32l-1.77,1.89l-1.76,0.09ZM816.46,732.7l0.05,-0.34l0.15,-0.22l-0.19,0.56ZM816.79,731.83l0.24,-0.63l0.0,-0.0l-0.04,0.32l-0.2,0.32ZM812.99,739.44l0.88,-1.79l0.6,-0.25l0.0,1.22l-0.51,0.54l-0.97,0.27ZM759.65,789.33l0.16,-4.68l1.0,-2.32l1.2,-1.76l-0.25,-0.79l-0.76,-0.03l0.79,-1.21l0.55,1.16l1.15,-0.48l2.56,-4.02l-0.39,-0.25l-0.53,0.16l-2.38,2.22l8.34,-9.82l1.48,-1.36l2.68,-1.68l0.64,-0.83l0.18,-0.86l0.15,2.95l0.79,0.75l0.56,-0.3l0.09,-0.56l0.83,0.28l1.02,0.66l0.21,0.95l0.41,0.32l0.85,-0.63l-0.2,-1.37l-1.52,-0.96l0.48,-1.27l2.17,-1.72l0.87,-0.31l0.38,-0.71l0.77,-0.16l0.09,-0.31l2.0,-0.77l0.57,0.44l0.62,-0.38l0.08,-0.73l0.87,-0.87l-0.76,-0.39l-2.62,0.32l-2.84,0.85l-0.61,0.66l-0.49,-0.31l-1.16,0.39l-1.2,-0.1l-2.3,0.94l-1.0,0.8l-0.82,-0.25l-1.64,0.19l-1.2,0.97l-0.22,1.24l-1.05,-0.26l-0.99,0.29l0.05,-0.87l0.87,-0.88l-0.09,-0.5l1.3,-1.3l0.28,-0.94l1.72,-2.26l0.02,-1.13l0.39,-0.53l0.26,0.4l0.97,-0.59l0.19,-0.62l-0.26,-0.25l-0.04,-1.31l0.51,-1.57l1.15,-0.65l0.29,-0.58l1.43,0.15l1.08,0.9l0.83,0.12l0.3,0.65l0.75,-0.22l0.73,0.19l0.2,-0.77l1.23,-0.68l-0.11,1.13l1.96,-0.28l-0.19,0.41l0.35,0.35l1.32,0.28l0.39,-0.54l0.8,-0.03l1.26,-0.83l0.38,-0.58l-0.15,-0.29l4.41,-0.24l-0.95,0.78l-0.21,0.93l0.34,0.38l0.28,-0.17l0.75,0.36l0.21,-0.58l0.48,0.15l0.41,-0.34l-0.28,-0.68l0.28,-0.19l1.02,0.2l0.3,0.67l0.82,-0.21l1.04,-1.74l0.93,-0.59l1.93,-2.56l0.71,-1.41l1.1,2.31l0.51,0.48l2.23,0.56l1.34,-0.18l0.72,-1.54l0.48,-0.23l1.15,0.56l1.2,1.12l1.39,0.45l-0.06,0.51l-0.81,0.8l-0.41,0.03l-0.92,1.13l0.04,0.62l0.47,0.31l5.15,-1.32l0.05,1.13l-0.76,-0.45l-0.75,0.77l-1.09,0.18l-0.75,1.02l-0.03,0.9l-1.95,0.93l-1.75,0.09l0.05,0.82l0.49,0.37l-1.67,0.55l-0.41,1.09l-1.6,0.89l-0.18,1.04l-2.05,0.97l-0.63,0.9l-1.1,0.64l-0.16,0.64l-0.47,-0.39l-0.48,0.9l-0.61,0.33l-0.02,0.42l-2.39,1.6l-0.16,1.04l-0.99,0.14l-0.47,0.43l-0.41,-0.68l-1.07,0.28l-0.59,-0.19l-0.35,0.33l0.23,0.92l-0.47,0.47l-0.85,-0.13l0.17,1.15l-0.23,0.62l-0.81,0.12l0.04,-0.31l-0.57,-0.29l-0.81,0.54l0.56,0.97l-2.57,-1.19l-0.58,0.05l-0.2,0.6l0.63,0.75l1.0,0.32l1.01,2.07l-0.36,-0.1l-1.55,0.84l-0.83,-0.89l-1.51,0.95l-0.47,-1.54l0.14,-1.54l-0.33,-0.32l-2.22,1.84l0.21,1.14l0.74,0.7l-0.28,0.68l-0.39,-0.94l-0.88,-0.46l-0.75,0.3l-0.14,0.61l-0.71,-0.17l-0.42,0.24l0.33,1.73l-0.39,0.59l0.87,0.89l-0.35,0.59l0.25,0.46l-1.07,-0.03l0.05,0.5l1.06,0.58l-1.02,2.27l-1.11,0.2l-0.41,0.8l0.37,0.35l0.69,-0.04l-0.01,0.26l-1.54,0.73l-0.15,0.68l0.77,0.39l-0.57,0.78l-1.04,0.65l-0.13,0.86l0.52,0.57l-0.9,-0.21l-0.93,0.87l0.68,1.28l-0.79,-0.83l-0.46,0.02l-0.13,0.45l0.65,1.21l-0.27,-0.23l-1.28,0.61l-0.79,-0.88l-0.66,0.32l0.49,1.99l-0.34,-0.13l-0.39,-1.23l-0.48,0.02l-0.52,0.61l0.82,2.23l-0.19,0.69l-0.61,-0.3l-0.5,0.49l0.27,0.42l-0.09,0.81l-0.81,-0.86l-0.55,0.12l-0.8,1.34l-0.39,0.07l-0.33,-0.88l-0.54,-0.21l-0.38,-1.47l-0.63,-0.19l-0.98,-1.55l-0.47,-0.22l-0.91,-0.14l-0.32,0.25l-0.3,-0.4l-0.66,0.27l0.1,0.85l0.62,0.96l-0.76,-0.45l-0.53,0.1l-0.02,-0.99l-0.93,-0.59l-0.33,-2.18l-1.14,-1.44ZM815.34,751.71l-0.03,0.02l0.02,-0.1l0.01,0.08ZM814.13,746.52l0.43,-0.47l0.76,-0.29l-0.16,0.85l-1.03,-0.09Z",name:"Nova Scotia"},"CA-BC":{path:"M13.63,416.0l18.57,10.78l19.97,10.92l20.25,10.4l20.52,9.86l20.77,9.32l21.0,8.77l21.26,8.24l21.12,7.55l-37.33,108.91l0.0,0.84l0.61,0.53l-0.38,0.97l1.06,0.85l0.3,1.12l-1.39,-0.67l-0.62,0.14l0.03,1.15l-0.43,0.73l0.21,0.59l0.57,0.21l0.19,2.02l0.84,1.3l0.35,0.17l0.53,-0.25l0.98,0.72l0.76,0.05l-0.13,1.32l0.58,2.06l2.09,1.93l0.8,-0.25l0.46,-1.15l0.77,1.04l0.58,1.33l-0.59,0.93l0.97,0.98l-0.37,0.82l0.11,1.89l0.47,0.41l0.99,-0.09l0.34,1.0l-0.39,0.83l0.57,1.04l0.1,1.29l-0.75,0.67l0.47,2.99l-0.56,0.69l0.13,1.58l2.27,0.12l0.46,-0.24l0.44,-0.87l0.64,1.11l1.28,0.79l-0.19,0.8l-1.23,0.79l0.3,1.88l0.88,0.69l0.54,1.17l1.29,0.11l1.2,0.66l0.54,-0.1l-0.09,1.84l1.68,3.03l0.03,3.14l0.31,0.86l1.36,0.39l1.23,-1.23l0.58,0.0l0.08,2.89l0.77,0.86l0.09,0.87l0.49,0.56l-0.05,1.03l0.7,0.9l-0.38,1.12l0.14,1.48l0.93,0.66l0.11,0.73l0.87,0.66l-0.2,1.52l0.36,0.88l0.76,0.81l1.17,0.52l0.03,0.67l1.16,1.63l0.03,0.84l-0.77,0.41l-0.02,0.81l0.62,0.43l0.21,0.75l1.08,1.17l0.17,0.76l0.69,0.1l0.14,0.68l-0.43,0.58l0.68,2.09l0.58,0.31l0.91,-0.51l0.95,0.57l0.82,3.1l0.57,0.99l-0.49,4.19l0.35,1.34l-0.15,1.29l-0.5,0.22l-0.33,1.01l0.11,2.26l-1.05,1.89l-0.99,0.67l-0.26,0.71l0.45,0.95l1.24,0.51l-0.71,1.24l-0.02,1.23l0.9,1.34l0.56,2.72l1.65,0.84l0.45,0.63l-0.19,0.8l0.44,1.02l0.56,0.37l-0.22,0.27l-27.35,-7.82l-27.2,-8.56l-22.07,-7.54l-20.36,-7.43l-0.15,-0.39l-0.8,-0.35l0.21,-1.16l-0.6,-0.44l-1.81,0.1l-0.47,0.32l-0.12,-0.4l1.21,-0.59l0.34,-0.89l-1.81,-0.14l0.27,-0.72l0.53,0.32l0.3,-0.37l-0.62,-1.25l1.53,0.24l0.97,0.62l0.85,-0.09l0.77,-0.61l1.17,-2.04l-0.35,-0.56l-0.52,0.1l-0.39,0.88l-0.95,0.93l-0.73,-0.02l-2.26,-1.49l0.81,-0.83l0.52,-1.68l1.28,-1.89l0.77,-0.45l0.02,-0.73l-0.57,-0.2l-0.96,0.34l-0.64,1.13l-3.29,0.49l-0.35,1.52l-0.4,0.28l-2.22,-2.35l0.35,0.09l0.6,-0.57l0.23,-1.06l2.11,-0.04l1.12,-0.75l0.05,-0.46l-0.41,-0.2l-1.67,0.26l-1.17,-0.27l-0.59,-2.27l0.96,-0.94l0.39,-1.03l-0.25,-1.64l1.82,-0.18l1.09,-0.9l-0.39,-1.65l-1.48,-1.88l-0.67,0.31l0.24,1.15l0.69,0.8l0.18,0.72l-2.3,0.5l-0.61,1.32l-0.59,0.03l-0.7,0.73l-0.05,0.48l-0.99,0.51l-1.16,-0.38l-0.47,0.15l-1.25,-0.65l-0.63,-0.72l0.13,-0.64l-0.32,-1.0l-1.12,-1.86l0.42,0.2l0.32,-0.36l0.74,-1.86l1.0,-0.73l0.78,-1.13l0.03,-1.27l-0.42,-0.72l0.66,-0.64l1.06,0.45l1.62,-0.21l1.19,-0.55l0.37,-0.56l-0.53,-0.58l-1.92,0.55l-2.01,-0.55l-1.36,0.98l-0.8,0.21l-0.86,-0.52l0.32,-0.78l-0.13,-0.94l-0.31,-0.35l-0.54,0.21l0.31,-0.57l1.04,0.0l0.5,-0.55l0.71,-0.01l0.52,-0.47l0.7,-1.52l0.9,-1.07l-0.54,-1.17l1.94,-1.18l-0.12,-1.14l-0.81,-0.31l-1.32,1.2l-0.98,0.31l-0.12,1.24l0.33,0.57l-0.79,1.69l-2.82,1.23l-0.55,0.81l-0.42,0.11l0.16,-1.29l-0.25,-0.42l-0.88,0.25l0.2,-0.94l-0.42,-0.46l-1.2,0.93l-1.01,-0.17l1.36,-2.4l1.52,-0.77l0.06,-0.63l-0.27,-0.25l-2.03,0.51l-1.03,1.83l-0.73,0.39l-0.15,0.67l-0.43,0.25l-0.44,-0.76l0.35,-0.16l0.05,-0.62l-0.51,-0.46l-0.72,-0.2l-1.57,0.34l-1.87,-1.12l0.32,-0.73l2.46,0.25l0.57,-0.43l1.19,0.03l1.37,0.45l0.9,-0.85l0.82,-0.19l0.38,-0.6l-0.05,-1.03l0.94,0.18l1.31,-1.41l0.17,-2.17l-0.49,-1.27l-0.73,0.05l-0.14,0.4l-0.08,2.77l-1.67,0.34l-0.51,0.84l0.1,0.68l-1.26,0.7l-1.22,-0.44l-0.69,0.2l-0.41,-0.77l-2.04,-0.08l2.1,-0.61l0.26,-0.46l-0.72,-0.59l-0.93,-0.03l0.58,-1.2l-0.82,-0.57l0.97,-0.06l0.51,-0.79l-0.42,-0.46l-0.72,0.14l-1.89,-1.2l0.34,-1.92l-0.21,-0.53l-0.53,0.08l-0.59,0.69l-0.43,1.42l-0.53,0.35l-1.09,0.02l-1.26,-1.83l-1.03,0.28l-1.03,-0.44l-1.12,-1.04l-0.63,-0.09l-0.27,0.62l0.24,0.44l-0.35,-0.26l-0.23,-0.92l-0.6,-0.16l-0.73,-0.75l0.18,-0.81l-0.87,-0.64l1.18,-1.24l0.02,-0.47l-0.42,-0.45l-1.61,-0.27l-0.56,-1.45l0.22,-0.72l2.39,-0.07l1.79,1.27l1.94,0.48l1.27,-0.28l0.88,-1.35l-0.14,-0.43l-0.45,-0.02l-0.93,0.7l-1.16,0.1l-1.52,-0.85l-0.02,-0.89l-1.42,-0.1l-1.64,-0.71l1.26,0.01l1.14,-0.71l0.59,0.01l1.02,-0.91l0.43,-1.1l0.48,-0.22l1.69,0.22l2.83,0.98l3.66,2.02l1.21,-0.42l0.57,-0.77l-0.02,-1.8l-0.37,-0.36l-0.42,0.3l-0.36,1.43l-0.61,0.31l-3.57,-2.25l-1.84,-0.45l-0.7,-0.84l-0.79,0.4l0.26,-0.75l0.87,-0.15l0.93,-1.27l0.03,-0.56l-0.63,-0.27l-1.08,1.17l-0.74,0.01l-0.65,0.85l-1.13,-0.6l-0.81,0.22l0.07,0.61l0.78,0.73l-1.19,0.97l-0.01,0.66l-0.42,0.34l-0.3,-0.87l-0.76,-0.34l0.24,-0.89l-0.18,-1.6l1.21,-2.97l0.59,-0.66l0.81,-0.17l1.32,0.33l0.75,-1.05l1.21,-0.43l1.23,0.4l0.58,-0.17l0.26,-1.47l0.99,-0.36l1.17,0.12l1.46,-0.73l1.19,0.83l0.04,2.29l1.36,4.54l0.45,-0.23l0.46,-1.2l-0.26,-1.8l-0.88,-1.68l0.26,-1.89l0.72,-0.2l1.29,0.29l0.56,-0.4l-0.51,-0.96l-2.81,-0.06l-1.1,-0.71l-0.09,-0.5l0.44,-2.15l2.24,-0.84l0.99,-0.04l1.43,-1.41l0.28,-2.14l-0.81,-1.58l-0.65,0.29l-0.22,3.03l-0.98,0.61l-2.77,0.76l-0.68,0.64l-0.16,0.77l-2.05,0.08l-0.99,0.71l-2.28,0.14l0.49,-0.43l-0.46,-0.73l-1.92,1.47l-0.07,-1.06l0.98,-0.32l0.34,-0.46l-0.16,-1.5l0.77,-0.56l0.01,-0.74l0.57,-0.66l-0.35,-0.64l-1.85,-0.06l-1.04,0.34l-1.92,1.56l0.91,-1.04l0.47,-1.59l2.56,-2.56l0.76,-1.92l1.15,-0.09l0.32,-0.53l-0.19,-0.4l-0.77,-0.17l-0.3,-0.38l-2.19,1.52l-1.33,-1.01l-0.09,-1.12l0.94,-3.09l1.01,-1.4l-0.84,-0.43l-0.19,-1.93l-0.43,-0.19l-0.45,0.32l-0.66,-1.45l-0.01,-0.71l0.54,-0.39l0.2,-1.31l0.91,-0.63l-0.08,-0.66l-0.94,-0.13l0.11,-0.47l0.5,0.37l0.78,-0.2l-0.12,1.24l0.4,0.92l0.61,0.23l0.57,1.55l-0.23,0.75l0.41,0.43l0.51,-0.33l0.44,-1.04l1.38,-0.01l1.82,1.11l0.06,0.69l-0.69,0.76l-0.01,0.52l0.94,-0.15l0.34,0.67l-0.3,1.58l0.52,0.74l0.71,-0.13l-0.15,-1.33l0.33,-1.0l-0.62,-1.12l-0.37,-2.46l-1.72,-0.67l-0.55,-0.65l-0.51,-0.03l-0.67,0.57l-0.82,-0.23l-1.33,-3.84l0.95,-1.11l0.29,-1.09l0.41,-0.39l0.68,0.09l0.51,-0.48l1.48,1.12l0.49,-0.05l0.05,-1.0l-0.79,-0.39l-0.62,-0.84l1.48,-1.45l0.1,-0.72l-0.99,-0.1l-3.25,1.95l-0.57,-1.39l-0.8,0.05l-0.29,1.7l-0.47,-0.69l-0.45,0.22l-0.2,0.96l-2.69,1.13l-1.28,1.81l-0.16,1.0l-0.72,0.81l-1.64,-5.17l0.13,-1.57l-1.14,-2.66l-0.13,-0.95l0.31,-0.84l-0.66,-0.17l-0.12,-0.39l-0.02,-0.68l1.08,-2.11l0.75,-0.75l0.41,0.1l0.16,2.49l0.53,1.74l0.59,0.45l0.43,-1.42l-0.45,-1.17l-0.05,-2.35l0.91,0.01l1.75,1.57l1.64,-0.27l0.58,-0.39l-0.37,-0.7l-1.5,0.3l-1.83,-1.67l-3.38,-0.01l-0.21,-0.73l-0.68,-0.52l0.67,0.0l0.5,-0.5l-0.21,-0.46l0.8,-1.92l-0.16,-0.48l-0.5,0.07l-0.51,0.6l-0.69,0.02l-0.64,-0.71l0.52,-0.88l0.82,0.14l0.35,-0.52l-0.08,-1.1l0.72,-0.27l0.81,5.21l0.46,0.67l0.85,0.22l0.24,-0.48l-0.5,-0.59l-0.17,-0.94l0.7,-1.06l0.93,-0.09l0.32,-0.67l-0.55,-0.45l-0.75,0.04l-0.83,0.73l-0.5,-4.19l1.16,-0.05l0.95,1.09l0.34,1.33l1.09,0.78l0.67,-0.06l0.26,-0.34l-0.14,-0.42l-1.06,-0.71l-0.18,-1.2l-0.69,-1.14l0.83,-0.81l1.4,-0.59l0.1,-0.88l0.54,-0.4l0.23,-0.01l-0.41,0.33l0.27,0.72l2.0,-0.48l0.45,0.51l1.69,0.25l0.42,-0.72l-3.37,-1.69l3.35,-2.84l0.88,-0.25l2.11,-1.94l0.79,0.46l1.18,-0.33l0.19,-0.51l-0.4,-0.44l-0.76,0.18l-0.72,-0.46l-0.55,0.02l0.42,-3.12l-0.63,-0.43l-0.38,0.34l-0.63,2.46l-1.19,1.08l-0.25,0.6l0.17,0.34l-0.61,0.89l-4.38,3.54l0.19,-1.23l3.65,-2.46l0.01,-1.21l0.72,-2.25l0.03,-1.69l1.16,-2.12l-0.07,-1.07l3.08,-2.49l-0.27,-0.65l0.46,-1.28l0.06,-1.38l-0.37,-0.78l-1.14,-0.25l-1.35,-1.24l0.24,-1.83l-1.34,-1.53l-0.43,-1.97l-0.62,-0.93l-2.03,-1.66l-2.71,-5.17l-2.36,-1.11l0.5,-1.02l0.09,-1.44l0.61,-0.94l-1.5,-2.18l1.9,-2.25l-0.03,-0.55l-2.03,-1.95l1.76,-1.48l-0.68,-17.44l0.4,-2.73l-0.61,-4.17l0.83,-1.22l-0.82,-3.51l-0.3,-3.87l-2.29,-3.88l-0.25,-1.33l0.41,-1.01l-0.35,-0.6l0.5,-0.87l-0.0,-1.39l-0.96,-1.57l0.08,-2.0l-1.83,-1.91l0.0,-0.97l0.57,-0.96l-0.39,-0.8l0.97,-0.53l0.86,-1.58l-1.69,-5.99l-0.52,-0.45l-4.82,0.06l-3.19,-0.8l-1.16,0.04l-0.33,0.59l0.29,1.15l-0.97,0.61l-0.87,-0.59l-0.65,0.07l-1.58,2.84l-1.77,1.29l-2.42,-0.92l-5.25,0.52l-2.15,0.6l0.9,-1.15l1.29,-4.82l-3.3,-13.32l0.53,-2.9l-1.35,-2.31ZM73.47,652.52l0.29,0.56l-0.5,0.41l0.15,-0.35l0.07,-0.62ZM65.69,639.61l-0.05,0.24l-0.09,0.16l-0.03,0.01l0.17,-0.41ZM47.11,622.29l0.58,0.56l0.35,0.24l-0.42,0.17l-0.51,-0.97ZM45.72,609.76l-0.16,0.0l-0.36,-0.19l0.3,0.13l0.23,0.05ZM50.07,591.83l-0.48,0.83l0.04,0.6l-0.78,0.64l0.16,-1.83l0.64,-0.61l0.4,0.37ZM46.52,592.11l-0.73,0.75l-0.66,0.39l0.64,-1.17l0.75,0.03ZM51.62,599.75l0.12,-0.02l0.32,0.0l-0.13,0.19l-0.3,-0.17ZM56.1,626.07l-1.59,-0.43l-1.14,0.16l-0.32,-0.43l0.61,-0.51l2.44,1.22ZM55.38,630.91l-0.22,-0.02l-0.62,-0.24l0.1,0.01l0.73,0.25ZM72.83,659.99l-0.63,-0.33l-0.52,-1.02l-0.28,-2.05l0.99,-1.2l0.28,0.06l0.38,2.07l-0.22,2.46ZM77.14,661.77l0.07,-0.32l0.41,-0.02l0.04,0.63l-0.52,-0.29ZM76.5,664.01l0.11,-0.16l0.39,-0.19l-0.22,0.27l-0.28,0.08ZM71.52,674.1l-0.21,-0.6l0.4,-0.58l-0.16,-0.8l0.09,-0.03l0.54,1.27l-0.43,-0.06l-0.24,0.8ZM70.39,655.37l-0.06,-0.38l0.7,-0.3l-0.51,0.61l-0.13,0.07ZM32.85,620.93l0.68,-0.17l0.02,-0.64l-0.76,-0.43l0.22,-1.3l2.37,-0.03l0.56,0.28l0.8,-0.21l1.61,0.7l3.39,3.27l-0.22,0.7l0.2,0.9l0.6,-0.15l1.66,2.64l1.83,1.44l0.03,0.48l1.01,0.5l0.02,0.63l1.12,0.19l1.45,1.91l0.75,0.06l0.74,0.68l1.02,0.21l1.66,1.03l1.93,2.25l1.25,0.68l0.78,0.91l1.79,0.49l0.86,0.93l-0.31,3.68l0.62,1.55l-0.05,2.74l1.84,4.7l-0.04,0.28l-0.93,-0.48l-0.43,0.57l0.38,1.07l0.32,3.28l0.82,0.58l1.32,2.19l3.72,2.74l-0.4,0.16l-0.02,0.74l2.04,1.19l-0.28,0.35l0.02,1.26l1.09,0.83l0.1,1.41l-0.7,-0.1l-0.38,0.64l1.57,3.71l-0.33,0.62l-0.81,0.32l0.85,1.83l-0.4,0.62l0.04,0.77l-0.62,0.94l0.44,0.45l1.05,-0.34l0.71,-1.07l-0.07,3.71l-0.4,0.04l-0.51,-0.91l-0.52,-0.17l-2.12,1.49l-0.76,-0.26l-1.02,-1.27l-1.22,-0.57l-4.51,-4.68l0.34,-0.65l-0.2,-0.23l-0.58,-0.29l-0.68,0.18l-1.54,-1.14l-1.15,-1.88l-2.45,-2.57l-0.31,-1.19l1.25,-0.56l0.85,0.03l0.53,-0.84l1.63,-0.27l1.28,-0.98l1.13,-1.58l0.3,-1.62l-0.53,-0.48l-0.6,0.5l-0.62,1.63l-1.35,1.41l-1.99,-0.34l-0.65,-0.59l-1.1,0.36l-0.45,-0.34l0.86,-0.46l-0.95,-1.1l-2.45,1.38l-0.88,-1.16l-0.73,-2.0l-0.55,-0.46l2.18,-0.5l0.91,-0.99l-0.46,-0.57l-1.28,0.35l0.61,-1.06l-0.55,-0.56l0.9,-1.32l-0.21,-0.54l-0.44,-0.0l-1.12,1.18l-0.61,-0.19l-0.84,0.41l-0.13,-0.38l1.04,-0.37l1.26,-1.45l0.06,-0.62l-0.7,-0.23l-1.4,1.27l-0.07,-0.69l0.65,-0.95l-0.29,-0.52l-1.77,0.02l-0.03,-0.74l-0.47,-0.28l-0.8,1.05l-0.81,-2.22l-1.16,0.39l-0.16,0.81l-0.28,-0.45l1.23,-2.55l1.21,-0.2l1.13,0.59l2.92,0.63l0.42,-0.31l-0.06,-0.7l-1.2,-0.58l-1.67,-0.08l-0.98,-0.86l1.24,-1.08l-0.63,-1.0l-0.61,0.12l-0.58,0.93l-0.49,-0.08l0.63,-3.12l-0.28,-0.49l-0.71,0.06l-0.6,-2.02l-0.77,0.21l-0.23,-0.72l-0.45,0.1l-0.81,1.52l-1.65,-0.66l-0.32,-1.71l0.85,-0.49l0.55,-0.81l1.06,-0.3l0.4,-1.05l-0.59,-0.35l-1.01,0.48l-0.47,-1.23l-0.55,-0.1l-0.66,1.5l-0.63,0.06l-0.46,-0.99l0.8,-0.46l-0.23,-0.43l0.38,-0.76l-0.33,-0.31l-2.03,0.4l0.58,-0.85l-0.33,-0.3l-1.14,0.05l-1.37,0.68l-0.68,-0.62l2.5,-1.18l0.04,-0.56l-0.65,-0.37l0.41,-0.24l0.12,-0.65l-0.63,-0.79l-0.87,-0.23l1.07,-1.19l1.81,0.27l1.47,0.66l0.35,2.01l0.36,0.42l0.68,-0.27l-0.22,-2.73l1.49,-0.17l0.6,-0.54l-0.27,-0.6l-1.46,-0.13l-0.39,-0.67l-2.99,-1.74l-0.22,0.68l0.38,0.79l1.9,1.18l-2.18,-0.17l-0.43,-0.36l-1.45,-0.06l-0.38,-0.57l-0.68,0.11l-0.69,-1.33l0.08,-1.33l-0.53,-0.59ZM42.94,638.71l0.18,0.66l-0.39,0.25l0.21,-0.91ZM48.37,658.01l-0.18,-0.13l-0.04,-0.06l0.11,0.01l0.12,0.19ZM65.71,652.19l0.14,-0.21l0.29,0.73l1.84,1.59l0.58,2.49l-1.31,-1.65l-0.19,-1.3l-1.35,-1.65ZM68.25,643.72l-0.05,0.24l-0.39,0.41l0.11,-0.31l0.33,-0.33ZM67.21,657.84l0.25,0.09l0.46,0.37l-0.41,-0.15l-0.3,-0.32ZM65.77,642.5l0.43,-0.25l0.47,0.39l-0.27,0.67l-0.55,-0.11l-0.08,-0.69ZM66.61,644.25l0.09,0.18l-0.5,0.24l-0.01,-0.2l0.41,-0.22ZM64.09,645.3l-0.21,-0.95l0.93,-0.53l-0.29,1.49l-0.43,-0.01ZM63.71,655.75l-0.0,-0.0l0.0,0.0l-0.0,0.0ZM61.57,639.47l0.04,-0.17l0.14,0.12l-0.07,0.05l-0.11,0.0ZM62.7,639.33l0.42,-0.95l0.59,0.96l0.17,3.08l-0.26,-2.27l-0.92,-0.82ZM61.44,643.0l-0.21,-0.5l0.24,-1.24l0.33,-0.58l0.41,-0.02l0.33,1.46l-1.11,0.88ZM60.76,637.89l0.47,-0.38l1.13,-0.03l-0.83,0.65l-0.77,-0.24ZM59.74,636.88l0.18,-0.02l0.48,0.11l-0.61,-0.06l-0.05,-0.04ZM56.9,635.18l0.86,0.09l0.09,0.38l-0.33,-0.07l-0.61,-0.4ZM47.25,600.57l1.72,-2.5l0.8,-0.67l0.72,-0.33l0.86,0.23l1.96,-0.24l1.42,-0.89l1.65,0.05l-0.51,1.31l-4.2,0.56l-1.27,0.61l-1.38,1.32l-0.25,0.68l-1.53,-0.13ZM51.46,628.21l0.59,-0.54l2.0,-0.54l1.2,0.15l0.11,0.27l0.04,0.85l-0.66,0.22l-0.62,0.73l-1.4,-0.87l-0.51,0.21l-0.75,-0.48ZM51.4,630.8l1.84,0.02l0.23,0.32l-0.39,0.14l-1.68,-0.47ZM49.37,624.62l0.01,0.01l0.0,0.06l-0.02,-0.07ZM50.29,625.12l0.07,-0.07l0.64,0.3l-0.56,-0.01l-0.15,-0.22ZM49.87,623.87l0.03,0.01l0.01,0.0l-0.01,0.0l-0.03,-0.01ZM48.61,586.85l0.14,-1.17l0.6,0.19l-0.53,0.81l-0.2,0.17ZM45.49,570.28l0.29,-0.57l0.16,-0.22l-0.2,0.65l-0.25,0.13ZM46.01,569.39l1.12,-1.94l1.14,-0.24l1.27,0.43l-0.72,1.13l-0.97,-0.27l-1.84,0.9ZM48.58,656.68l-0.36,-0.84l0.5,-0.17l0.3,0.29l-0.44,0.72ZM46.18,597.25l0.63,-0.09l0.89,0.46l-0.56,0.43l-0.94,-0.3l-0.02,-0.5ZM46.94,596.03l1.01,-0.32l-0.03,-0.58l-0.46,-0.3l0.72,0.24l-0.14,1.53l-1.1,-0.57ZM44.61,591.15l1.02,-0.72l0.85,-3.1l1.13,-2.06l-0.16,1.5l-1.04,3.3l-0.66,0.74l-1.14,0.33ZM41.34,582.69l0.24,-0.26l-0.19,-1.84l0.67,0.54l0.48,-0.46l-0.11,-0.42l1.76,-1.19l1.07,-0.04l0.41,-0.42l-0.98,-2.79l-0.6,0.02l1.1,-2.33l1.04,0.82l1.06,2.78l0.64,0.6l-0.19,2.48l-0.45,1.43l-2.7,3.9l-0.21,0.8l-0.83,-0.37l0.76,-1.87l2.26,-2.34l0.42,-0.85l-0.14,-0.58l-0.73,-0.14l-0.33,0.74l-0.59,-0.23l-2.15,3.48l-0.91,0.15l-0.83,-1.63ZM44.7,586.19l0.0,0.03l-0.02,-0.02l0.02,-0.01ZM43.79,576.47l0.01,0.55l0.41,0.22l0.25,0.72l-2.45,1.26l-0.46,-0.61l0.42,-1.1l0.58,-0.58l0.33,0.23l0.91,-0.68ZM43.19,586.9l1.52,0.5l-0.57,2.32l-0.91,-1.6l-0.04,-1.22ZM43.67,542.2l-0.02,-0.54l3.49,-1.73l-0.29,0.57l-1.88,1.35l-1.29,0.35ZM47.09,655.52l-0.0,-0.0l0.0,0.0l-0.0,0.0ZM45.06,572.22l0.01,-0.26l1.32,-0.96l0.54,-0.79l-0.02,2.09l-0.45,0.54l-0.48,-0.44l-0.92,-0.18ZM45.54,652.69l0.48,-1.03l0.67,0.05l-0.21,1.74l-0.94,-0.76ZM42.91,600.73l0.86,-0.48l0.0,-0.68l1.03,-0.85l1.62,0.26l-0.41,0.91l-1.8,1.9l-0.26,1.2l-0.45,-0.18l0.48,-1.52l-0.25,-0.39l-0.83,-0.19ZM44.17,597.56l0.09,-1.02l1.12,-0.67l-0.62,1.32l-0.6,0.37ZM42.93,594.98l-0.27,-0.29l0.66,-0.51l1.36,0.6l-0.74,0.66l-1.01,-0.46ZM40.85,642.26l1.08,-0.1l0.35,-0.5l-0.76,-0.86l1.66,-0.07l0.6,0.8l-0.16,1.46l-0.84,2.36l-1.12,-1.08l-0.81,-1.99ZM41.8,608.09l0.21,-2.76l1.49,-0.67l-0.54,4.43l-0.27,0.14l-0.31,-0.88l-0.58,-0.25ZM41.66,575.26l-0.17,-0.45l0.43,-0.95l1.15,-0.67l0.48,-0.66l-0.96,3.17l-0.92,-0.42ZM41.46,591.43l0.36,-2.24l0.32,-0.39l0.56,0.41l-1.24,2.22ZM41.74,542.16l0.92,-0.2l0.04,0.0l-0.38,0.77l-0.43,-0.06l-0.15,-0.52ZM37.53,560.61l0.55,-1.25l-0.44,-0.75l0.81,-0.37l1.97,4.36l0.42,3.01l0.52,1.5l-0.36,-0.15l-0.56,0.32l0.21,0.68l1.21,0.77l0.49,2.16l-1.85,-0.28l-0.47,1.41l-0.33,-0.08l0.08,-2.41l-0.67,-0.3l-0.01,-0.77l-0.39,-0.29l0.51,-1.15l-0.55,-0.61l0.65,-1.04l-0.07,-1.15l0.49,0.07l0.29,-0.54l-0.67,-0.96l-1.34,-0.25l0.25,-1.11l-0.75,-0.82ZM38.34,563.69l-0.21,0.15l-0.18,-0.06l0.16,-0.11l0.23,0.02ZM40.27,619.3l0.43,0.03l0.07,0.55l-0.36,-0.48l-0.14,-0.1ZM40.3,551.24l0.12,-0.25l0.34,-0.21l-0.2,0.34l-0.26,0.12ZM39.08,583.26l0.32,-0.4l-0.37,-1.6l0.38,-0.35l1.34,4.3l-0.73,1.53l0.04,-0.56l-0.52,-0.33l-0.24,-0.74l0.25,-0.48l-0.48,-1.36ZM40.19,553.88l0.01,-0.26l0.12,-0.15l0.17,0.38l-0.3,0.03ZM39.62,574.23l-0.2,-0.65l0.25,-0.22l0.56,2.86l-0.15,0.8l-0.46,-2.8ZM39.02,635.94l0.02,-0.04l0.01,0.01l0.01,0.02l-0.04,0.01ZM36.21,544.7l1.15,-1.7l0.93,0.78l-0.43,0.41l-1.65,0.51ZM33.6,556.26l0.03,-0.04l0.04,0.11l-0.07,-0.07ZM35.18,554.73l1.69,-0.53l1.0,0.03l0.49,1.68l-0.08,0.84l-1.9,1.13l-0.24,-0.64l0.9,-0.73l1.05,-0.05l0.12,-0.89l-1.57,-0.46l-0.97,1.11l-0.49,-1.49ZM37.4,573.38l0.12,0.1l0.17,0.59l-0.22,-0.3l-0.08,-0.39ZM36.87,545.99l0.21,-0.1l0.08,0.57l-0.17,-0.08l-0.13,-0.39ZM33.01,562.11l0.45,-0.71l0.44,0.35l2.97,4.84l0.38,1.23l0.13,3.3l-0.25,0.6l-0.43,-0.49l-0.68,0.22l-0.32,-0.23l-0.16,-1.77l-0.4,-0.51l0.19,-1.05l-0.74,-1.58l-0.88,-0.66l-0.14,-1.69l0.83,0.06l0.05,-0.47l-0.38,-0.48l-0.81,-0.17l-0.26,-0.79ZM35.28,560.82l1.21,-0.39l-0.0,0.61l0.71,0.77l-0.5,1.33l-1.33,-1.39l-0.08,-0.93ZM35.19,550.83l0.11,-0.11l0.25,0.66l0.06,0.42l-0.02,0.03l-0.4,-0.99ZM34.15,557.75l0.07,-0.0l0.18,0.16l-0.1,-0.01l-0.15,-0.16ZM9.84,550.6l0.56,-0.73l-0.34,-1.08l0.55,-0.31l-0.19,-0.75l0.35,-0.76l-0.16,-0.44l-0.84,-0.46l0.61,-0.4l-0.14,-1.49l1.11,-1.19l1.07,-0.61l0.26,-1.37l0.58,-0.41l0.48,0.21l0.85,1.24l1.68,0.51l0.52,0.74l-0.59,1.0l-1.51,0.56l-0.15,0.93l0.45,0.24l1.2,-0.21l0.91,-0.87l1.59,-0.25l0.82,0.23l-0.08,1.47l0.46,0.65l-0.55,1.2l-0.03,0.89l-1.04,0.24l-0.77,0.6l-1.16,-0.38l-1.19,0.26l-1.88,-0.55l-0.69,0.16l-0.22,0.72l0.48,0.25l-0.34,0.68l0.37,0.25l0.64,-0.2l0.41,0.47l-0.58,0.53l0.12,0.66l1.16,-0.18l1.19,0.41l0.59,-0.22l-0.01,-0.33l0.42,0.39l1.12,-0.49l0.42,-0.55l0.03,-0.95l2.06,-1.36l0.52,-2.22l1.91,0.69l2.51,-0.26l-1.47,1.94l-2.71,1.83l-1.05,1.61l-1.12,1.05l-0.97,1.7l-0.98,2.73l-1.3,1.07l-2.45,-0.68l-1.45,0.19l-0.26,0.35l-0.76,-0.09l0.12,-0.64l-0.62,-0.26l-0.03,-1.19l-0.55,-0.7l0.58,-0.16l0.29,0.34l0.67,-0.29l0.49,1.19l0.47,-0.1l0.52,-0.81l-0.54,-1.31l0.03,-0.74l-1.03,-0.96l0.24,-0.95l-0.5,-0.14l-0.15,-0.89l-0.81,0.17l-0.01,-0.71l-0.41,-0.21l0.23,-0.49ZM9.85,555.26l-0.19,-0.06l0.1,-0.07l0.09,0.13ZM9.44,560.12l0.24,-0.21l1.31,0.75l0.85,-0.12l2.31,1.14l2.04,-0.47l1.05,0.28l-0.5,0.93l0.59,1.0l0.25,1.28l-1.54,-1.24l-1.76,-0.62l-0.57,0.44l0.37,0.62l-0.2,0.95l0.68,0.28l0.86,-0.5l1.49,1.66l-0.45,0.79l-0.76,0.28l-0.9,-0.41l-0.18,-1.12l-0.63,-0.6l-0.48,-0.02l-0.27,0.61l-0.8,0.34l0.23,0.56l0.9,0.22l-0.5,0.59l0.23,0.86l-0.5,0.27l0.18,0.46l-0.4,0.34l0.15,0.65l0.73,0.48l-0.01,0.77l-0.39,0.59l0.2,0.99l-0.33,0.71l0.48,0.81l0.85,0.61l0.26,0.91l-0.47,0.44l-0.27,-0.82l-0.63,-0.34l-0.04,-0.94l-1.42,-2.66l0.04,-1.57l-0.69,-1.7l0.25,0.6l0.93,0.52l0.5,-1.36l-0.8,-2.18l-0.42,-0.18l-0.44,1.1l-0.51,0.25l-0.27,-1.27l0.33,-0.73l-0.53,-1.08l0.47,0.02l0.37,0.75l0.75,0.24l1.15,-1.14l0.01,-0.46l-0.77,-0.42l-0.27,-0.67l-1.12,-0.88l-1.25,-0.42l0.01,-0.97ZM13.9,576.84l0.45,1.27l-0.16,1.27l0.48,0.48l-0.35,0.26l-0.21,-0.49l-0.51,0.1l0.0,-1.11l-0.43,-1.2l0.19,-0.51l0.54,-0.07ZM15.24,580.53l0.03,0.01l-0.01,0.03l-0.01,-0.04ZM15.34,580.96l0.09,0.21l-0.08,0.07l0.01,-0.07l-0.02,-0.2ZM16.25,581.78l0.28,0.15l0.16,-0.01l-0.23,0.19l-0.21,-0.33ZM15.76,580.3l0.02,-0.36l0.45,-0.11l0.18,0.59l-0.65,-0.13ZM13.22,576.78l-0.13,-0.08l0.01,-0.05l0.07,0.08l0.04,0.06ZM14.76,571.47l0.03,0.04l0.11,0.01l-0.16,0.04l0.02,-0.08ZM15.47,571.73l0.28,0.02l0.58,-0.26l-0.53,0.92l-0.33,-0.67ZM15.38,583.56l0.03,-0.12l0.17,-0.25l0.1,0.28l-0.3,0.09Z",name:"British Columbia"},"CA-SK":{path:"M225.69,715.55l44.18,-197.52l18.32,3.88l18.79,3.56l18.86,3.14l18.53,2.67l-10.31,77.69l-4.77,62.93l-4.14,60.98l-24.87,-3.43l-25.58,-4.15l-25.48,-4.77l-23.53,-4.98Z",name:"Saskatchewan"},"CA-QC":{path:"M567.62,485.44l0.69,-0.35l1.22,-1.38l0.77,-0.25l0.36,-0.96l0.97,-0.76l0.27,-0.74l0.58,0.53l2.0,-0.0l0.62,0.3l1.01,-0.12l0.29,-0.35l0.52,0.33l1.36,0.02l1.33,0.78l4.43,0.81l0.54,0.69l1.41,-0.28l1.21,0.56l1.62,0.15l-2.04,2.18l-0.04,0.45l0.41,0.2l0.89,-0.29l1.91,-1.82l0.65,-1.14l1.15,-0.5l1.34,0.24l0.05,0.73l0.58,0.36l0.59,-0.85l0.34,-0.05l1.02,0.44l1.5,1.4l2.15,0.56l0.33,-0.61l-1.98,-1.25l0.01,-0.69l2.64,-0.51l0.86,-0.91l0.26,-0.75l0.94,-0.12l1.32,-1.11l0.87,-2.05l1.31,-0.53l1.15,1.47l1.19,0.35l0.52,-0.22l0.64,0.65l0.96,0.14l0.29,0.88l1.68,1.33l1.17,0.26l-0.17,0.57l0.4,0.22l1.41,-0.03l0.47,-0.47l-0.15,-0.37l0.81,0.4l-0.2,0.61l0.51,0.53l0.3,1.1l-0.56,0.47l0.08,1.04l-0.66,1.38l0.44,0.57l0.83,-0.56l0.79,0.64l0.53,-0.47l-0.63,-1.88l3.32,0.52l0.44,0.74l-0.33,0.83l0.18,0.7l0.58,0.3l0.9,-0.37l0.72,0.84l-0.4,1.12l-1.28,-0.01l-0.5,0.49l-0.18,0.9l0.26,0.43l0.87,-0.75l1.25,-0.02l1.04,-0.53l0.24,-1.94l1.99,0.45l0.69,0.44l0.2,0.37l-0.4,0.55l-1.78,0.57l-0.14,0.57l0.97,0.88l-0.76,0.45l-0.18,0.55l0.32,0.31l1.45,0.09l-0.94,0.39l0.28,0.79l1.22,0.1l-0.28,0.74l1.22,0.54l-0.03,0.8l0.66,0.28l0.18,0.79l0.8,-0.09l0.33,-0.64l1.12,0.98l0.99,-0.79l0.6,0.52l1.4,-0.43l0.74,0.15l0.5,0.74l0.71,-0.18l0.81,0.24l0.43,-0.47l0.47,0.74l1.44,0.04l0.35,-0.56l0.58,0.08l0.35,-0.57l-0.15,-0.4l0.41,0.03l0.32,-0.57l0.55,0.26l0.57,-0.38l0.07,1.05l0.81,0.83l0.16,0.92l-0.39,0.69l2.73,1.17l0.45,-0.16l0.4,-0.75l0.08,-0.41l-0.34,-0.21l0.4,-0.68l0.66,0.54l0.86,-0.68l-0.68,-2.21l0.06,-0.99l0.33,-0.34l1.51,2.44l0.52,0.3l0.4,1.74l-1.41,1.11l-1.13,1.65l0.92,2.18l-1.1,0.78l-0.09,0.74l0.87,0.87l0.02,0.89l0.62,0.66l-0.12,1.26l1.77,1.39l-0.18,0.58l0.53,0.46l0.08,1.44l-0.54,0.35l-0.99,-0.08l-0.3,0.57l0.18,0.81l-4.27,0.38l-0.4,0.62l-1.76,0.56l-0.74,-0.34l-3.44,-0.33l-0.61,0.35l-0.13,0.45l5.04,1.01l3.25,-0.87l1.86,0.27l2.59,-0.97l-0.3,0.59l0.22,0.42l1.77,0.38l0.01,1.39l0.52,0.47l-0.55,0.91l0.16,0.57l1.33,0.37l-1.61,2.91l0.06,0.7l1.1,0.62l0.39,1.15l-0.82,0.74l0.18,0.82l0.46,0.28l1.17,-0.26l1.62,-1.44l0.55,0.66l0.56,-0.01l0.34,-0.36l-0.03,0.58l0.45,0.63l-0.8,-0.28l-0.46,0.51l-0.53,0.06l-0.81,1.55l0.26,1.09l0.79,0.46l-0.25,0.37l1.14,2.89l-0.58,0.4l0.05,1.35l-0.49,0.33l-0.49,-0.84l0.22,-0.95l-0.66,-1.13l-0.57,-0.43l-0.48,0.12l-0.91,-1.17l-0.58,0.12l0.06,2.25l0.87,0.28l0.21,0.84l-0.57,-0.02l-0.26,0.58l0.23,0.42l-0.29,0.25l-2.52,1.17l-0.21,0.87l0.94,-0.12l1.69,0.39l0.53,-0.37l0.36,0.88l0.63,0.06l0.18,0.98l1.09,0.56l0.4,-0.44l0.42,-1.7l0.54,-0.43l0.13,-1.06l1.01,-0.85l0.68,-1.61l0.85,-0.69l2.19,-0.57l0.33,0.32l0.95,-0.15l0.89,-0.97l1.52,0.08l1.32,0.78l0.88,0.01l0.51,0.48l0.04,1.21l0.72,0.68l0.12,1.31l0.33,0.36l0.51,-0.0l0.16,0.94l0.7,0.12l0.37,1.11l-0.21,3.72l0.23,2.19l-1.06,1.95l-1.79,0.76l-2.23,1.57l-0.7,1.09l-0.84,0.55l-1.72,2.92l0.14,0.52l0.53,-0.1l2.0,-2.81l1.3,-1.2l4.27,-2.54l0.58,-0.65l0.7,-1.85l-0.28,-1.57l0.36,-0.98l-0.29,-4.95l1.07,-0.41l0.69,0.21l0.1,1.64l1.01,1.56l-0.09,0.85l-1.33,2.38l-0.05,1.72l0.8,0.14l0.86,-1.54l0.16,-1.47l0.76,-0.94l0.25,-1.37l0.18,0.62l0.59,-0.02l0.28,0.44l-0.08,1.85l0.62,1.26l-0.06,2.52l0.55,0.49l0.46,-0.09l0.17,-0.53l-0.29,-0.92l0.35,-1.3l-0.49,-1.15l0.31,-1.98l0.61,-1.14l0.91,-0.3l0.35,-0.94l0.9,-0.54l0.29,-0.59l0.5,0.12l0.47,-0.31l0.04,-1.07l0.39,-0.47l0.2,-1.13l0.04,0.46l1.0,0.7l0.33,-0.34l0.21,-1.22l1.61,-0.49l-0.07,-0.59l-0.37,-0.26l-0.06,-2.48l0.18,-0.83l0.73,-0.52l-0.43,-1.82l0.35,-0.31l2.75,1.46l0.75,1.14l1.4,0.34l-0.27,1.87l0.65,1.73l-0.65,1.08l0.58,0.91l0.6,-0.1l0.1,-1.07l0.51,-0.52l0.2,-1.18l-0.72,-0.62l0.36,-1.47l0.51,-0.25l-0.14,-0.64l-1.71,-1.57l-0.68,-0.02l-0.34,-0.94l-0.56,-0.26l0.14,-0.8l1.69,-0.26l0.57,-0.67l-0.23,-0.75l-1.62,-0.02l0.72,-0.57l0.04,-0.9l1.36,0.75l0.56,-0.32l-0.22,-0.92l-0.88,-0.47l0.13,-0.44l0.74,0.42l1.38,0.14l0.2,-0.65l-1.0,-0.55l1.84,-0.07l0.57,-0.69l-0.61,-0.52l-0.82,0.16l-1.08,-0.38l-0.63,0.1l-0.23,0.69l-0.95,-1.14l-0.01,-0.81l0.84,0.46l0.2,-0.45l-0.24,-0.65l0.85,-0.88l-1.22,-1.3l1.63,1.03l0.55,-0.07l0.1,-0.59l-1.2,-1.2l-0.05,-0.28l0.48,-0.3l-0.16,-0.44l-0.91,-0.42l0.54,-0.42l1.03,-0.08l2.03,1.08l1.18,-0.2l-0.25,-0.68l-0.92,-0.24l-1.33,-0.96l-2.27,-0.15l-2.07,-3.34l1.18,-2.17l2.75,0.77l0.74,-0.15l0.3,-0.5l-0.46,-0.43l-0.62,0.05l-1.47,-0.61l0.56,-0.4l-0.37,-1.02l0.63,-0.24l0.02,-0.27l-0.36,-0.54l0.15,-0.35l-0.71,-0.61l0.57,-0.58l0.06,-0.53l-0.34,-0.44l0.35,-0.19l0.07,-1.44l0.58,-0.41l0.89,0.4l0.89,-0.34l0.39,0.53l-1.02,0.44l0.27,0.84l-0.4,0.38l-0.84,-0.14l-0.37,0.57l1.18,1.74l1.8,0.19l-0.78,0.63l0.2,0.82l-0.36,0.51l0.87,2.23l-0.75,0.93l0.47,2.03l2.65,1.87l0.66,-0.24l1.57,-1.91l0.5,0.0l-1.08,1.6l0.23,0.51l-0.15,0.85l0.38,0.4l-0.08,0.78l0.52,0.83l0.04,1.04l1.29,1.97l1.23,0.09l0.68,0.63l-0.81,0.42l-2.04,-0.22l-0.84,-0.51l-0.77,0.2l-0.59,0.81l-0.17,0.88l0.35,0.78l-0.07,0.91l1.07,0.25l0.82,-0.83l1.66,0.6l2.33,-0.62l0.77,1.65l1.34,0.35l0.65,-0.29l0.91,-1.59l1.27,-0.51l0.48,-1.09l1.59,0.27l1.03,0.92l-0.89,0.81l-2.37,0.8l-1.68,1.44l0.04,1.65l0.55,0.89l0.98,0.39l1.01,-0.96l0.71,0.98l-0.14,0.45l-1.12,0.52l-0.29,1.21l-0.96,0.91l0.08,2.13l-1.14,0.87l-0.33,0.66l0.25,2.27l0.5,0.37l1.8,-0.09l0.3,1.0l2.7,3.39l0.56,-0.0l0.58,-0.81l0.57,0.97l1.02,0.63l0.76,-0.34l0.6,0.55l0.41,-0.14l-0.62,0.77l-0.13,0.97l0.59,1.97l0.91,1.19l-0.87,1.11l0.05,1.7l0.3,1.0l0.42,0.3l0.5,-0.32l0.29,0.98l-0.57,1.26l0.37,1.37l-0.09,1.2l0.45,0.67l-0.83,0.91l0.33,1.16l-0.69,0.61l-0.13,1.26l0.51,0.91l2.2,1.68l0.45,1.27l0.6,0.23l-2.46,0.56l-0.19,0.75l0.85,0.7l0.19,1.47l0.64,0.58l0.6,0.17l0.75,-0.34l0.9,0.25l-0.99,1.19l0.5,1.88l0.58,0.09l0.63,-0.75l1.2,0.69l1.14,-0.35l1.0,0.23l-2.1,2.25l1.47,2.03l0.77,0.2l0.02,2.05l0.99,0.42l0.36,1.7l-0.62,1.08l0.27,0.57l0.66,0.38l1.05,-0.03l2.92,-0.53l-2.12,1.18l0.07,0.69l-0.64,0.99l0.65,0.88l1.04,0.04l-0.05,2.55l0.73,1.52l0.13,1.13l-1.66,-0.28l-0.67,0.59l0.03,1.27l0.42,0.78l-0.49,1.16l2.22,1.59l-0.85,0.47l-0.3,0.56l-1.32,0.31l-0.54,-0.17l-1.23,-1.25l-2.72,-0.77l-1.01,0.33l-0.68,1.32l-1.58,0.36l-0.16,-1.07l-0.49,-0.52l-0.72,-0.12l-1.42,-1.13l-2.0,-0.07l-0.79,0.82l-0.24,1.58l-1.25,0.77l-0.89,-0.08l-0.42,0.43l0.62,1.64l-1.32,0.02l-0.53,0.59l-1.52,-1.14l-0.99,-1.61l-1.43,-0.05l-0.64,0.43l-0.99,-0.62l-1.36,-0.25l-4.27,-3.5l-0.61,-0.23l-0.64,0.17l-0.47,-0.73l-1.18,-0.43l-0.73,0.29l-0.13,0.78l1.96,1.57l-0.33,0.61l0.16,1.5l1.48,1.67l-0.4,0.37l0.0,0.74l1.8,2.02l-0.78,0.36l-0.09,0.75l-2.18,-0.7l-1.04,-1.33l-3.24,-1.24l0.21,-0.69l-0.37,-0.47l-1.37,-0.14l-0.77,0.94l0.53,1.47l2.45,2.55l2.18,1.29l0.17,0.64l-0.33,1.07l-0.93,1.21l0.43,1.21l-2.53,-1.23l-0.58,0.72l0.43,1.34l-1.2,0.47l-0.92,1.29l0.35,1.81l0.81,0.68l0.94,1.62l-1.07,1.38l0.14,2.16l0.93,0.8l1.58,0.7l0.42,0.94l0.89,0.37l-0.55,0.67l0.11,0.46l2.28,1.12l0.45,0.99l1.09,1.0l3.48,0.25l1.45,1.05l-0.51,0.43l-0.26,0.85l0.81,1.19l0.55,3.0l-0.44,-0.3l-0.56,0.14l-0.51,-0.32l-1.25,-0.05l-0.57,0.34l-0.85,1.35l1.34,3.66l0.69,0.73l1.96,0.6l0.65,-1.08l0.53,1.3l1.29,0.57l1.21,1.09l0.65,-0.53l0.66,0.04l0.3,-0.4l-0.32,-1.38l0.47,-0.18l0.52,-0.84l-0.32,-2.27l1.05,-0.72l0.36,-1.36l0.41,0.21l1.24,1.77l-0.61,-0.09l-0.45,0.41l0.02,0.51l1.73,2.71l-0.57,0.1l-0.27,0.72l1.77,4.37l-0.82,0.29l-0.25,1.19l2.25,3.25l1.07,-0.02l0.54,-0.72l-0.7,-1.91l0.45,0.59l1.47,0.59l0.23,1.26l1.38,0.53l1.88,-1.27l1.03,0.07l0.4,-0.31l-0.01,0.83l0.47,0.85l0.72,-0.11l0.22,-0.71l0.47,-0.13l0.38,-0.63l0.96,0.97l0.54,0.12l0.06,1.28l0.97,1.21l0.43,0.14l0.35,-0.88l0.95,0.41l0.4,0.8l1.35,0.12l0.48,-0.26l0.86,0.35l0.68,-0.28l0.41,-0.93l0.77,-0.07l0.95,0.4l1.82,1.61l1.03,0.12l1.75,-2.13l0.33,-1.42l-0.4,-1.03l-0.64,-0.53l-0.98,-2.33l0.8,0.1l0.37,-0.37l-0.72,-2.43l0.81,-0.28l0.1,-0.35l-1.38,-2.34l0.39,-1.72l-0.28,-1.5l1.51,1.38l1.13,0.13l0.97,-0.31l0.05,0.48l1.12,0.98l1.44,2.53l-1.28,-0.17l-0.48,0.73l0.86,0.91l0.81,0.19l35.0,-11.1l35.06,-12.54l3.42,9.02l-0.66,0.13l-0.44,-0.94l-0.67,-0.15l-1.97,1.23l-0.78,1.05l-0.46,-0.27l-0.62,0.77l-0.72,-0.49l-2.68,4.19l-1.64,1.25l-0.33,-0.76l-0.67,0.01l-0.29,0.38l0.18,0.75l-1.43,-0.17l-1.06,1.39l-0.66,-0.03l-0.6,1.15l1.14,1.19l-3.26,3.83l0.13,0.45l0.55,0.21l0.66,1.48l0.15,1.62l-0.21,0.42l-0.41,-1.85l-0.81,-0.1l-0.06,1.92l-0.36,0.95l-0.77,0.21l0.1,0.68l-0.54,1.09l-0.77,0.56l-0.1,1.51l0.82,0.48l-0.9,0.18l-0.48,1.41l-2.17,1.52l-0.5,1.77l0.65,0.77l-1.2,1.54l-0.92,0.48l-0.19,-0.56l-0.52,-0.21l-0.83,0.61l-0.45,-0.29l-0.34,0.3l0.03,0.63l-2.0,0.63l-0.71,0.9l-0.41,-0.49l-0.86,0.79l-1.54,-0.22l-0.9,1.3l-1.2,0.11l-1.38,1.11l-1.59,0.4l-2.2,1.67l-0.63,-0.58l-1.77,1.59l-0.17,-0.43l-1.33,-0.85l-3.94,1.02l-1.36,-0.41l-0.92,0.13l-0.55,0.57l-2.59,0.63l-0.63,-0.4l-2.2,1.18l-1.14,-0.17l-0.36,0.63l-1.34,0.39l-0.01,0.84l-1.47,0.35l-0.61,0.76l-0.93,-0.54l-1.25,0.49l-1.4,-0.41l-1.32,0.12l-2.04,0.78l-1.49,1.15l-2.1,0.27l-1.44,-0.27l-1.88,1.28l-2.61,0.93l-0.5,-0.13l-3.04,0.83l-1.08,-0.29l-4.94,2.56l-1.0,0.22l-1.65,-0.17l-0.78,1.42l-0.61,-0.13l-0.27,0.96l-1.18,-0.13l-1.06,0.6l-0.93,-0.98l-0.82,0.24l-0.65,1.05l0.01,1.01l-0.52,-0.18l-0.47,0.48l0.13,0.41l-0.84,2.13l-1.39,0.87l-0.47,0.69l-0.22,2.67l-0.62,0.01l-0.53,0.64l-0.24,1.65l0.46,1.24l-0.35,2.17l0.49,1.83l-0.9,2.3l-3.83,1.33l-0.72,0.8l-2.58,0.41l-0.47,0.63l-0.65,0.25l-0.13,1.04l-1.18,0.45l-0.43,0.49l0.89,0.68l0.68,-0.07l-0.1,0.23l-1.15,0.54l-0.93,-1.34l-0.63,-0.14l-0.38,0.24l0.64,1.28l-1.75,1.61l-0.34,0.95l0.1,0.8l-0.4,0.33l-0.04,0.54l-0.9,0.37l-1.58,2.08l-0.07,0.56l-0.93,0.62l-0.27,3.11l-1.0,0.53l-0.2,2.46l-1.09,3.18l-1.31,1.32l-0.7,1.78l-1.29,0.07l-2.38,-1.59l-1.96,0.45l-3.06,-1.17l-0.79,0.36l-2.96,0.12l-0.98,-0.53l-2.8,0.0l-1.08,0.61l-0.17,0.52l0.51,0.2l0.91,-0.32l1.95,0.32l-0.74,0.24l-0.2,0.65l0.77,0.75l1.42,-0.87l2.94,-0.67l1.57,0.19l2.55,0.95l0.86,-0.0l0.74,-0.43l0.87,0.13l1.43,1.22l1.11,0.06l-0.84,6.13l-0.83,1.47l-1.18,1.08l-0.46,1.37l-0.01,1.67l-2.8,1.65l-0.56,3.67l-0.87,2.54l-2.49,2.27l-2.19,3.43l-0.38,1.32l-0.97,1.01l-1.31,0.36l-2.8,1.73l-2.2,0.19l-1.25,1.7l-2.41,1.49l-0.16,1.61l-2.13,1.58l-1.37,2.11l-2.7,1.13l-1.71,1.34l-0.11,1.93l-1.55,0.98l-0.71,3.28l-0.88,1.17l-0.56,1.5l-0.69,0.71l-2.07,0.72l-0.98,0.8l-1.49,2.83l-1.29,1.09l-1.0,0.07l-0.96,-0.57l-1.35,0.32l-1.09,-0.65l-3.72,-0.87l-1.32,0.65l-2.06,0.27l-1.33,0.98l-2.82,0.84l-3.47,2.28l-1.13,0.4l-0.89,1.45l-0.7,0.24l-2.82,-1.86l-1.12,-0.09l-1.21,0.37l-0.91,1.01l-1.48,-0.68l-2.37,-0.38l-1.36,-2.43l-0.7,-0.56l-0.56,-1.82l-0.58,-0.48l-0.97,-0.11l-0.77,0.39l-0.17,0.53l0.27,0.96l-0.43,0.18l-2.91,-1.28l-0.7,-0.73l-0.29,-1.03l-1.0,-0.93l-4.14,-1.81l-3.41,-0.5l-1.54,0.14l-0.92,-0.32l-2.43,0.26l-0.44,-0.35l-4.48,-0.36l-0.53,-0.87l-1.89,-1.07l-0.93,-0.91l-0.79,-1.71l-1.17,-1.1l-1.06,-2.0l-1.81,-1.73l-1.98,-2.57l-0.54,-3.25l-1.96,-2.87l0.5,-2.68l-6.88,-58.56l1.67,2.7l0.76,-0.3l-0.21,-1.21l-2.42,-2.91l-1.05,-9.24l-0.4,-0.97l1.8,-2.07l0.51,0.3l-0.23,0.86l0.18,0.89l0.51,0.29l1.45,-0.36l1.17,0.94l1.18,3.03l-0.22,0.62l0.21,0.67l0.85,0.87l1.17,0.02l-0.03,-0.46l-0.89,-0.97l-0.02,-0.97l0.72,-1.43l-0.66,-0.48l0.75,-1.26l0.88,-0.26l0.24,-0.67l-0.67,-0.43l-0.75,0.08l0.06,-1.28l-0.27,-0.56l-1.49,-0.66l-0.25,-0.73l-0.98,-0.95l0.9,-0.11l1.02,-1.09l0.05,-0.63l-0.75,-1.16l1.4,-0.7l0.51,-1.39l0.54,-0.46l-0.09,-0.35l0.52,-0.43l0.47,-1.86l-0.26,-0.68l1.06,0.09l0.47,-0.44l-0.67,-0.78l-0.95,-0.09l0.35,-0.97l-0.4,-0.71l-0.02,-1.5l-0.67,-1.13l-0.57,-0.36l-1.4,-0.03l0.3,-0.73l-0.41,-0.8l-0.52,-0.15l-0.21,-1.16l-0.4,-0.45l0.77,-0.58l-0.29,-0.88l0.45,-0.68l-0.35,-0.62l-1.54,0.32l-0.13,-0.75l0.56,-0.12l0.27,-0.63l-1.0,-0.9l-0.91,0.22l0.28,-0.57l-0.53,-0.64l0.46,-2.68l-0.15,-0.59l-0.61,-0.4l-0.31,-2.06l-0.59,-0.93l-0.48,-0.2l0.67,-0.5l-0.08,-0.59l0.39,-0.84l-1.06,-1.01l-0.2,-1.12l-0.42,-0.26l-0.19,-0.72l0.14,-1.17l1.02,0.28l0.35,-0.65l-0.54,-0.57l-1.21,-0.13l0.54,-0.95l-0.65,-1.0l0.45,0.02l0.34,-0.63l-1.92,-1.3l0.6,-1.33l-0.13,-0.66l-0.87,-0.07l-1.12,0.54l-0.95,-0.41l0.44,-0.49l-0.07,-0.54l-1.53,-0.25l0.1,-0.3l-0.97,-1.33l0.4,-0.7l-0.53,-0.38l-0.9,-1.95l0.19,-0.91l-1.37,-0.81l-0.23,-0.46l1.54,-1.19l5.33,-2.46l0.81,-1.11l4.85,-2.88l2.24,-2.4l3.59,-2.98l0.9,-1.87l4.86,-6.16l0.42,-1.3l-0.39,-0.24l2.32,-4.01l0.23,-1.05l1.12,-1.18l0.75,-4.99l-0.05,-2.28l-0.87,-6.87l-1.23,-4.49l0.01,-1.63l-2.06,-5.25l-2.04,-3.63l-0.28,-1.28l-4.3,-5.9l-1.39,-1.17l-0.78,-0.16l-1.14,-0.88l-0.4,-0.99l-1.54,-1.0l-1.03,-0.16l-3.19,-1.36l-0.2,-0.78l-2.67,-1.45l-1.67,-1.88l-1.36,0.49l-0.0,-0.63l0.73,-0.62l0.04,-0.39l-0.65,-0.92l0.23,-0.9l-0.81,-1.89l0.57,0.26l0.39,-0.48l0.6,0.38l0.49,-0.32l0.62,-1.55l-0.37,-0.94l0.62,-0.27l0.02,-0.5l0.62,-0.7l-0.09,-0.62l0.36,-0.61l-0.21,-0.71l2.29,-1.62l0.54,-1.13l-0.19,-0.69l0.75,-0.42l-0.01,-0.71l-1.56,-0.39l-0.32,-0.57l1.18,-1.28l-0.12,-1.72l-0.72,-0.58l0.21,-0.23l0.57,0.33l0.79,-0.25l0.67,0.46l0.31,0.97l0.49,0.39l1.39,0.04l0.36,-0.45l-0.36,-0.46l-0.94,-0.2l-0.33,-1.13l-0.7,-0.94l0.5,-0.95l1.08,-0.14l0.32,-0.38l-1.09,-2.19l0.03,-0.71l1.09,-1.12l-0.29,-0.33l0.53,-0.69l-0.47,-0.56l-0.98,0.55l-0.62,-0.45l-0.68,0.43l-1.06,-0.02l-0.01,-0.6l1.22,-0.14l0.38,-0.57l-1.31,-0.85l0.4,-0.29l-0.01,-0.58l-0.77,-0.7l-0.01,-0.46l-0.57,-0.12l-0.65,-1.3l-0.95,-0.49l0.22,-0.81l0.9,-0.89l0.26,-0.75l0.98,-0.13l0.22,-0.69l-1.49,-0.49l-1.22,0.52l-1.2,-1.06l1.53,-2.14l0.06,-0.6l-0.31,-0.29l0.94,-0.68l0.15,-0.5l-0.49,-0.33l-0.46,0.11l-2.27,1.59l-0.48,-0.97l-0.38,-0.1l-2.14,0.94l0.57,-1.71l1.68,-2.74l0.64,-0.51l-0.06,-1.78l0.69,-0.82l-1.13,-4.31l0.44,-0.09l0.26,-0.6l1.05,-0.69l-0.19,-0.58l-0.8,-0.32l-0.14,-0.28l1.27,0.24l0.34,-0.62l-1.23,-1.2l-1.15,-0.05l-0.92,-1.42l-0.4,-0.2l-1.2,0.32l-0.39,-0.41l-1.11,-2.83l-0.33,-1.76l-0.47,-0.63l-0.63,-2.88l-0.22,-2.36l0.82,-1.83ZM578.66,653.17l-0.12,0.05l-0.03,-0.04l0.16,-0.0ZM653.23,787.08l0.57,0.5l3.84,0.59l0.65,0.96l-1.84,0.63l-0.63,1.13l-1.28,0.94l-1.51,-1.14l0.21,-3.62ZM655.71,541.57l0.05,-0.09l0.04,0.01l-0.05,0.06l-0.03,0.02ZM627.44,494.8l0.16,-0.06l-0.08,0.05l-0.09,0.01ZM639.87,499.16l-0.07,-0.04l0.04,-0.08l0.0,0.0l0.03,0.12ZM657.55,533.31l0.42,-0.03l0.38,-0.21l-0.29,0.53l-0.52,-0.29ZM677.38,543.7l-0.22,-0.37l-0.25,-1.11l0.12,-0.83l0.33,0.21l0.01,2.1ZM692.95,521.88l-0.28,-0.07l-0.05,-0.23l0.17,0.12l0.17,0.18ZM695.38,499.78l-0.07,-0.73l1.02,0.21l-0.33,0.12l-0.61,0.4ZM696.49,499.23l0.14,-0.3l0.34,0.14l-0.21,0.11l-0.26,0.05ZM721.26,553.36l-0.0,-0.22l-0.06,-0.42l0.12,0.17l-0.05,0.47ZM742.73,637.67l-0.85,-1.13l0.13,-0.56l-0.38,-1.24l0.31,-0.77l3.61,-2.12l0.56,-0.95l0.65,0.74l1.75,0.43l0.64,0.45l-4.79,2.12l-1.11,1.37l-0.52,1.66ZM572.37,551.69l-0.04,-0.14l0.05,-0.08l-0.01,0.22ZM809.57,639.69l0.11,-0.18l0.38,-0.14l-0.2,0.29l-0.28,0.03ZM794.09,718.58l-0.04,-0.31l0.4,-0.4l-0.02,0.55l-0.34,0.16ZM794.11,720.88l0.12,0.06l0.23,0.03l-0.4,0.14l0.05,-0.23ZM752.09,684.41l2.22,-1.3l0.33,-0.48l0.8,-0.2l2.39,0.31l9.66,-0.79l1.99,0.19l0.97,0.49l4.51,0.38l2.02,1.34l1.7,0.1l1.03,0.67l2.25,-0.21l0.97,0.38l0.65,-0.24l3.15,2.43l-0.18,0.63l-0.76,0.74l-0.8,0.01l-3.99,1.56l-3.11,-0.31l-2.11,0.44l-4.99,-0.03l-2.56,-0.78l-3.42,-0.22l-1.45,-1.91l-1.85,-1.13l-2.25,-0.76l-4.73,-0.57l-1.03,-0.61l-0.56,0.46l-0.85,-0.6ZM652.77,796.2l1.34,-1.08l0.39,-1.15l0.65,-0.66l1.25,-0.55l0.72,-0.75l1.87,-0.62l1.13,-1.84l1.23,-1.03l0.36,-0.7l0.42,-0.27l1.68,-0.02l0.58,-0.4l0.23,-0.76l-0.52,-1.46l0.53,-1.33l-0.16,-1.71l2.17,-3.82l0.22,-2.72l1.14,-0.54l1.06,-1.39l1.11,-0.26l1.41,-0.99l0.62,-0.82l-0.01,-0.71l1.62,-2.24l2.48,-1.6l0.65,-2.03l1.89,-1.12l1.43,-2.03l1.02,0.35l0.9,-0.13l4.53,-3.0l1.05,-1.01l0.42,-1.1l1.5,-0.46l1.15,-1.15l0.63,-0.03l0.89,-0.57l0.51,-0.89l2.15,-1.52l1.37,-2.26l1.5,-3.92l1.24,-1.36l0.34,-2.36l1.01,-1.11l2.88,-5.88l-0.06,-1.18l0.74,-1.92l1.24,-0.99l2.35,-4.3l2.12,-2.93l1.07,-0.44l1.94,-2.19l0.49,-1.23l1.02,-0.65l1.4,-1.96l0.8,-0.4l0.61,-0.88l1.14,-0.46l4.04,-3.95l1.4,-0.62l7.96,-6.62l4.17,-2.69l3.7,-1.3l3.37,-1.7l6.91,-1.06l1.71,0.07l1.4,0.5l2.0,0.2l3.47,1.52l1.16,0.82l0.25,0.86l-3.4,-0.34l-0.76,0.51l0.72,0.48l-0.21,0.46l0.39,0.43l1.21,-0.43l0.13,0.75l1.3,0.11l1.86,1.14l-0.66,0.55l-0.03,1.06l1.11,0.79l-0.8,0.71l-0.09,0.96l-2.1,1.13l-1.87,1.54l0.22,0.72l-0.3,1.78l-1.19,0.78l-0.79,0.12l-0.01,1.14l-2.76,2.81l-1.46,0.58l-1.02,-0.61l-3.52,-0.21l-1.24,-0.56l-0.26,-0.76l-0.44,-0.22l-0.88,1.05l-0.73,1.72l-2.23,0.29l-0.47,0.51l-2.04,0.13l-0.59,0.63l-0.03,0.61l-3.97,2.56l-0.27,0.53l0.12,0.86l-1.26,-0.06l-1.13,1.05l-1.76,0.33l-0.23,0.65l-2.65,-0.67l-0.29,-0.8l-0.46,-0.22l-5.82,1.45l-0.29,0.48l0.2,0.82l-2.69,0.66l-0.29,0.48l1.44,6.32l-1.36,2.4l-2.11,1.81l-2.77,1.73l-0.24,-1.66l-0.38,-0.42l-2.14,-0.15l-0.61,0.32l-6.09,15.23l0.29,5.14l-1.15,1.5l-0.55,2.85l0.72,1.19l-0.55,0.98l0.29,1.98l0.87,0.77l-1.38,2.38l0.31,1.46l-1.62,1.31l-1.12,2.01l-0.21,1.82l1.32,1.03l-1.1,-0.43l-0.86,0.3l-0.28,0.85l0.29,1.45l-0.3,0.49l-0.57,-0.85l-0.81,-0.24l-1.42,1.3l-0.39,0.92l-1.68,-0.48l-0.78,0.32l-1.19,1.38l0.52,0.71l-0.6,3.08l-37.01,7.26ZM688.69,755.58l1.98,-2.71l0.28,-0.13l-0.38,1.07l-1.88,1.77ZM678.73,541.82l0.47,0.85l0.01,0.82l-0.46,-0.42l-0.01,-1.24ZM659.52,786.99l0.49,-0.72l1.79,-0.99l0.73,-1.75l0.81,-0.99l-0.31,2.22l0.19,1.04l-0.4,0.6l-2.32,-0.04l-0.98,0.62ZM662.23,534.23l0.01,-0.03l0.04,-0.02l-0.01,0.02l-0.04,0.03ZM659.87,785.06l1.03,-1.6l0.72,-0.51l-0.63,1.6l-1.12,0.51ZM659.17,532.29l1.64,-0.18l0.38,0.44l-1.32,2.15l0.08,-1.38l-0.78,-1.02ZM657.0,790.9l0.16,-0.25l0.88,-0.1l-0.46,0.23l-0.58,0.13Z",name:"Qu\xe9bec"},"CA-PE":{path:"M771.47,732.39l0.78,1.7l-0.78,1.88l0.13,0.82l0.7,0.47l0.77,-0.11l1.39,1.0l0.16,0.9l0.72,0.15l-0.07,0.8l-0.55,0.52l0.16,0.77l0.73,-0.04l0.43,-0.45l0.61,0.64l1.57,-0.16l0.33,-0.53l-0.67,-1.6l0.46,-0.19l1.51,0.13l0.16,0.47l1.06,0.44l0.4,-0.34l0.06,-0.62l0.61,-0.01l0.57,0.69l1.37,0.46l0.37,-0.51l3.75,-1.24l0.36,0.19l0.78,-0.8l2.11,-0.31l0.32,-0.51l-0.27,-0.27l0.62,-0.28l3.82,-1.4l1.87,-0.25l-1.8,2.01l-0.64,-0.34l-0.48,0.1l-0.02,0.49l-0.53,0.01l-0.31,0.51l0.32,0.48l-0.52,0.2l0.22,0.56l-1.05,0.36l0.24,0.7l0.64,0.06l-1.37,0.0l-0.4,0.32l-0.04,0.89l0.32,0.64l0.6,-0.02l0.16,0.53l0.44,0.19l0.71,-0.13l0.01,0.35l-0.58,0.3l-0.49,0.84l1.06,0.39l-2.58,1.13l-0.78,0.02l-0.99,-0.6l0.09,-0.49l-0.46,-0.25l0.36,-1.16l-0.25,-0.3l-0.71,-0.03l-0.92,-0.59l-0.52,0.49l-0.71,-0.1l1.06,-1.86l-0.51,-0.53l-0.94,0.65l-0.69,1.16l-1.06,0.01l0.29,0.75l-0.86,1.0l0.76,0.51l-2.98,-0.56l-1.4,0.5l-0.82,-0.15l-0.7,-0.68l-0.92,-0.25l0.82,-0.41l-0.92,-1.1l-1.18,0.33l-1.26,-0.1l-0.64,0.6l-1.36,0.25l0.2,-0.26l-0.39,-1.49l0.35,-0.94l-0.78,-1.42l-0.79,0.92l-1.22,-0.25l-1.58,0.61l-0.34,-0.51l0.16,-1.21l0.8,-1.45l0.1,-1.5l1.48,-2.6Z",name:"Prince Edward Island"},"CA-MB":{path:"M325.95,732.99l4.14,-61.02l4.77,-62.91l10.31,-77.66l33.82,3.81l33.89,2.47l0.12,3.64l-0.6,2.66l0.36,1.51l-0.19,0.95l0.53,1.44l-0.02,2.2l-0.6,0.92l-0.31,3.26l-1.34,-0.06l-0.7,0.81l0.06,0.47l1.76,-0.06l0.29,0.93l0.76,0.46l0.02,0.76l-0.66,1.78l0.17,0.48l1.42,-0.82l0.96,1.03l0.53,2.0l0.68,0.28l1.11,-0.56l0.27,0.59l-0.57,0.66l-0.54,1.46l0.08,2.65l-0.51,0.99l-0.4,3.24l0.38,0.24l0.36,-0.27l1.44,-3.28l0.06,-3.8l0.85,-1.47l0.24,-1.36l2.39,0.3l1.61,-0.55l1.33,0.57l0.49,-0.15l0.27,1.01l0.73,0.31l1.0,-1.02l0.84,-0.08l0.28,0.31l0.16,4.18l1.69,5.63l0.69,1.0l0.49,1.81l0.25,4.64l0.43,0.18l1.03,2.86l0.47,2.27l0.56,0.64l0.43,1.27l0.27,1.71l-0.38,2.25l-1.47,3.14l-1.12,1.66l-1.62,0.59l-0.12,0.73l0.53,0.19l1.46,-0.36l2.43,-1.98l1.57,-0.33l-1.98,1.87l0.57,0.37l1.28,-0.39l1.33,-1.17l2.64,-0.65l9.39,-3.63l4.27,0.65l1.73,0.78l0.4,0.66l3.05,1.73l1.07,1.04l5.02,1.58l0.98,-0.09l3.56,1.54l-49.25,55.9l-17.57,16.1l-4.09,69.07l-36.0,-2.67l-36.08,-3.9Z",name:"Manitoba"},"CA-YT":{path:"M2.99,403.6l-2.51,-3.38l99.63,-158.54l0.21,0.56l0.59,0.12l2.17,2.22l1.13,0.76l0.8,-0.0l1.33,0.76l0.84,1.67l1.71,1.75l0.18,0.8l0.9,0.66l-0.07,2.09l0.76,2.03l-0.1,2.95l1.12,0.86l0.58,-0.27l-0.01,1.69l0.41,1.39l3.81,6.94l1.36,0.79l1.09,2.36l0.71,0.44l0.6,-0.15l0.59,0.28l-11.85,21.13l-0.58,1.5l0.84,1.37l-0.55,2.17l-1.23,1.62l0.21,0.92l-0.57,1.44l-0.9,1.03l-1.33,0.65l-0.13,0.76l-0.92,1.4l-0.22,1.31l0.22,0.46l14.41,7.82l-0.45,0.78l0.79,1.4l0.09,2.32l-1.18,1.06l0.08,1.17l-0.46,0.61l0.47,1.99l-0.93,0.4l-0.31,1.21l-0.91,0.0l-1.74,2.16l0.11,0.88l1.21,0.53l-0.01,0.56l-0.91,1.75l-0.98,0.23l-0.87,0.83l-0.04,0.65l0.36,0.38l-0.74,1.47l0.3,0.57l1.49,1.0l0.94,-0.39l1.38,-0.03l1.52,0.54l-1.27,1.1l-0.08,0.74l0.43,0.46l1.31,0.21l0.7,-0.73l1.51,-0.49l0.27,1.26l1.01,0.21l-0.11,0.35l-2.02,0.3l-0.77,0.87l0.78,2.27l-0.08,3.66l-1.05,0.38l-1.32,1.63l-2.41,0.94l-0.74,0.99l-0.74,-0.1l-0.75,0.49l-0.62,-0.17l-0.32,0.4l0.05,0.31l-0.45,0.35l0.12,0.71l0.48,0.56l1.11,-0.05l-0.7,1.31l0.47,0.8l0.7,0.35l-0.12,0.55l-1.75,0.48l-0.7,1.7l-1.2,0.2l-0.48,0.64l0.08,1.28l0.92,0.26l0.9,0.76l0.63,1.68l0.7,0.59l-0.01,2.15l0.36,1.15l0.86,0.91l-1.67,1.12l-0.58,0.81l0.17,0.6l1.11,0.22l0.54,0.79l1.97,-0.15l0.59,-0.58l1.23,1.28l0.19,2.0l-0.66,0.42l-0.05,0.59l0.42,0.43l-0.02,1.43l-0.84,0.83l0.15,1.37l-0.3,0.52l0.24,0.53l0.45,0.07l-0.34,1.28l0.97,1.72l0.43,0.17l0.51,2.07l0.96,1.36l0.59,0.27l-1.75,0.01l-0.68,0.79l0.29,1.13l1.16,0.11l-0.17,1.18l0.85,0.52l-0.24,0.43l0.35,0.78l-0.17,1.41l-0.92,0.4l-0.57,1.09l-2.07,0.18l-0.81,0.97l0.09,0.6l0.72,0.23l0.01,1.12l0.49,0.51l-0.28,2.33l0.67,0.92l0.88,0.18l-2.93,2.76l0.2,2.37l-0.35,1.22l0.54,0.92l-0.16,0.9l-0.8,0.25l-0.14,0.66l0.35,0.36l0.86,-0.02l1.19,2.39l-0.76,-0.12l-0.79,0.74l0.13,0.99l-1.0,0.81l-0.09,2.31l-0.77,0.19l-0.34,0.6l1.1,1.56l1.26,0.18l0.72,0.74l-0.12,0.81l0.63,0.7l0.68,-0.03l0.86,-0.64l0.77,0.31l0.61,1.96l-0.31,0.78l0.52,1.18l-0.24,1.87l0.43,0.56l0.66,0.07l0.03,1.48l-0.41,1.6l0.51,0.73l0.33,1.51l0.7,0.77l0.06,0.96l0.76,1.13l1.44,0.78l0.74,0.03l0.74,1.3l-0.3,1.16l0.27,0.71l-0.88,3.32l-0.53,1.02l-0.84,0.25l-0.34,0.51l0.21,1.0l1.01,0.01l-0.47,1.93l-0.85,1.61l0.11,0.5l-0.38,0.94l0.32,0.94l0.58,0.12l0.32,-0.28l0.2,0.69l0.55,0.36l1.68,-0.65l0.57,0.95l1.3,0.52l1.0,-0.29l0.28,-0.9l0.4,0.12l-0.02,1.03l1.01,0.6l1.48,-1.19l0.97,1.64l1.38,0.82l1.51,1.46l2.18,-0.54l2.61,0.89l0.53,-0.31l0.8,-1.34l1.56,0.69l-0.24,3.01l-1.54,0.79l-0.48,0.84l0.61,2.61l-0.27,1.75l1.61,0.99l-0.73,2.35l0.23,4.91l-0.86,1.08l-31.4,-13.07l-24.81,-11.37l-28.47,-14.24l-20.01,-10.81l-23.54,-13.6l-0.23,-1.48l3.03,-3.02l0.42,-0.84l-0.17,-0.52l-5.13,-2.69l-3.74,0.81l-2.48,-3.89l-0.63,-0.21l-1.12,0.73ZM110.73,248.92l1.12,-0.26l0.66,1.18l-0.77,-0.34l-0.9,0.49l-0.12,-1.07Z",name:"Yukon"},"CA-NB":{path:"M711.48,743.21l4.88,-3.44l1.67,-2.57l0.18,-1.28l-1.33,-5.56l2.7,-0.66l0.29,-0.48l-0.2,-0.82l5.1,-1.27l0.53,0.94l2.39,0.41l0.8,0.58l0.47,-0.21l0.15,-0.93l1.52,-0.21l1.16,-1.07l1.52,0.15l0.31,-0.53l-0.28,-0.79l0.29,-0.55l1.78,-0.33l3.5,-2.52l0.93,0.83l6.82,0.46l2.26,2.96l-0.07,0.63l0.62,0.47l0.61,-0.23l0.36,-0.92l1.13,-0.52l0.93,-1.68l1.46,-1.45l1.26,-0.71l-0.15,0.55l0.56,0.45l2.56,-1.38l0.18,0.13l-0.47,0.17l-0.22,0.6l0.36,0.29l0.68,-0.06l0.18,0.35l-0.05,1.32l-0.62,1.42l0.01,0.67l0.32,0.28l-0.22,1.07l0.35,0.36l0.21,-0.13l-0.4,1.59l0.21,0.82l-0.7,0.42l-0.69,1.63l-2.18,2.49l-0.16,0.57l0.45,0.29l1.52,-0.31l0.68,0.45l1.67,-1.33l0.89,0.36l0.53,-0.7l0.76,-0.22l0.54,1.22l-0.66,1.4l0.02,0.78l0.73,1.41l0.99,0.87l-0.1,1.13l0.5,0.3l0.38,-0.48l1.0,0.13l0.34,1.71l0.66,0.61l-0.24,0.5l0.52,0.57l0.52,-0.05l0.45,0.39l0.13,0.89l-0.66,0.54l-0.06,0.5l0.85,0.13l1.11,-0.59l0.23,1.66l0.68,0.13l3.34,-1.09l0.8,0.2l0.6,0.61l2.16,-0.91l2.12,0.21l-0.9,0.93l-2.04,0.58l-0.16,1.18l0.45,0.3l-0.94,0.55l-0.72,2.11l-0.62,-0.3l-0.6,0.17l-0.53,2.15l-1.32,-1.94l-0.41,0.29l-1.5,-1.18l-0.75,-1.2l-0.75,-0.36l-0.5,0.13l0.0,0.7l0.78,0.43l0.31,0.82l2.11,1.76l-1.03,4.22l-0.55,-0.06l-1.15,0.56l-0.78,1.52l-3.32,2.75l-2.08,2.39l-0.16,0.67l-1.49,1.15l-0.37,0.73l-0.76,-0.01l-1.1,1.21l-0.67,-0.03l-0.51,-0.64l-1.07,-0.28l0.9,-1.59l-0.53,-1.41l-0.67,0.26l-0.52,1.78l-1.1,0.95l0.5,0.88l1.02,0.38l-0.32,0.86l-0.25,0.32l-0.66,-0.3l-0.87,0.23l-0.34,0.51l0.4,0.56l-0.93,1.21l-0.64,-0.76l-0.61,0.02l-1.86,1.85l-0.3,-0.18l-0.47,0.38l-0.44,-0.36l-0.7,0.47l0.01,-0.72l-1.71,-0.72l-1.11,0.89l-0.08,0.97l-0.82,-1.35l-0.99,-0.5l-0.4,0.72l-0.82,0.25l-0.21,0.76l-1.91,-1.39l0.1,-1.92l-1.18,-1.54l0.51,-0.73l-0.05,-0.9l-1.13,-2.02l-0.43,-0.24l-0.52,0.42l0.0,0.8l-0.82,0.1l-0.88,-0.24l-0.84,-0.76l-0.33,0.08l-0.57,-0.77l0.12,-0.88l-0.46,-0.63l0.25,-0.98l-0.49,-0.6l-5.26,-19.48l-1.95,-1.12l-0.85,-0.87l-3.83,-1.73l-1.37,0.38l-0.46,1.23l-1.34,0.2l-1.27,1.39l-1.3,0.46l-1.31,1.15l-1.79,-0.77ZM746.76,774.42l-0.04,0.04l-0.08,0.14l-0.05,-0.07l0.17,-0.12ZM759.75,722.25l-0.02,-0.05l-0.0,-0.01l0.06,0.02l-0.04,0.04ZM768.61,745.97l0.01,-0.09l0.03,0.05l-0.05,0.04ZM759.95,720.22l0.52,-0.55l0.13,0.24l0.67,-0.23l-0.55,1.43l-0.78,-0.88ZM760.94,717.95l0.09,-0.3l0.01,-0.4l0.08,0.22l-0.18,0.48ZM748.75,781.92l0.08,-1.46l0.26,-0.59l0.82,1.56l-1.16,0.48Z",name:"New Brunswick"},"CA-NL":{path:"M818.51,688.98l0.02,-0.65l1.55,-2.42l0.25,0.55l0.81,0.32l0.32,0.49l-1.34,0.44l-1.61,1.27ZM822.14,686.92l0.09,-0.28l0.2,0.08l-0.17,0.14l-0.11,0.06ZM824.06,685.7l-0.48,-2.57l0.46,-2.92l-0.33,-2.45l0.29,-1.53l0.64,0.39l1.83,-0.8l1.87,1.03l1.74,-0.31l0.54,-0.42l-0.17,-0.68l-0.33,-0.09l-1.27,0.39l-0.99,-0.34l-0.8,-1.03l2.21,-0.76l0.51,-1.4l-0.15,-0.42l-1.2,0.28l-0.06,-1.04l-0.46,0.04l-0.9,0.85l-1.88,0.14l-0.72,-2.27l0.34,-1.43l0.85,-1.64l0.57,0.11l0.56,1.16l0.85,0.46l0.4,-0.21l-0.55,-1.14l1.54,0.3l0.73,-0.53l-0.21,-0.41l-1.37,-0.41l-0.81,-0.81l-0.39,0.46l-0.48,-0.37l-0.65,-0.73l-0.22,-0.95l0.7,-9.03l-0.38,-4.88l0.34,-3.49l1.45,-0.26l0.59,-0.82l-0.37,-0.63l-0.77,0.32l-1.17,-0.57l1.93,-2.2l0.89,-2.81l-0.04,-0.49l-0.83,-0.7l0.51,-0.65l-0.28,-0.74l0.12,-1.13l0.56,-0.76l-0.31,-0.81l0.31,-0.71l-0.58,-0.44l0.1,-1.04l1.77,-2.59l0.98,-0.65l0.55,-1.03l1.96,-2.1l1.26,-2.08l0.7,1.99l1.55,-0.57l1.29,0.01l0.54,-0.36l-0.19,-0.69l-0.68,0.01l-0.53,-0.64l1.05,-0.21l0.4,-0.84l0.83,0.67l-0.69,0.24l-0.09,0.7l0.95,0.36l0.12,1.05l-0.54,0.02l-0.23,0.43l0.17,0.57l-0.32,0.4l-1.78,0.19l-0.8,0.48l-0.87,-0.17l-0.09,0.38l-0.71,-0.26l-0.76,0.5l-0.18,0.5l0.23,0.79l1.02,0.19l-0.16,0.91l0.29,0.62l1.83,0.78l0.39,-0.72l-0.17,-0.2l0.64,-0.8l0.68,-0.1l0.33,0.14l0.57,1.72l-0.65,0.48l0.44,0.67l-0.13,2.25l-0.35,0.55l-0.42,2.53l-0.34,0.07l-0.49,-2.17l-0.61,-0.28l-0.62,0.97l1.07,2.9l0.9,0.67l-0.65,1.64l0.04,0.86l-0.52,0.2l-0.23,0.52l0.66,0.38l-0.55,1.91l-0.98,0.27l0.0,0.67l0.86,0.21l0.12,0.69l-0.14,2.05l-0.45,1.24l-0.66,0.34l0.38,0.68l-0.47,1.24l0.06,1.84l0.16,0.63l0.56,0.14l0.13,1.13l-0.97,1.75l0.39,0.54l1.22,-0.07l0.47,3.3l0.69,-0.49l1.16,-6.05l0.4,-0.71l0.41,0.36l0.66,-0.23l-0.28,-0.85l0.56,-0.14l-0.01,-0.46l-0.46,-0.58l0.05,-1.26l0.95,-2.77l0.79,0.59l-0.18,3.42l0.93,-0.5l0.35,-1.41l0.27,0.39l0.79,-0.35l-0.0,-1.09l2.77,0.99l0.52,-0.3l0.2,-0.82l1.5,-0.94l0.12,0.59l-0.79,0.7l-0.99,1.9l-1.97,2.24l-0.69,0.29l0.06,0.6l-0.91,2.21l0.11,0.9l0.23,0.31l0.67,-0.13l0.71,-2.13l0.29,-0.41l0.38,0.14l0.48,-0.37l-0.26,1.38l0.59,0.25l-1.46,2.03l-0.14,0.97l0.53,0.67l1.61,-2.04l1.09,-0.82l0.49,0.19l0.28,0.84l0.7,-0.29l0.98,0.89l0.59,-0.38l0.01,-0.84l0.32,0.99l0.71,-0.1l0.19,-1.95l0.14,0.34l0.64,0.15l-0.35,0.84l0.22,0.44l0.59,-0.23l0.39,0.34l0.4,-0.34l0.79,0.24l0.11,-0.88l0.52,1.06l-0.54,0.71l-0.39,1.61l1.03,0.85l-0.38,1.05l0.16,0.44l0.47,-0.01l1.02,-0.97l0.76,-1.31l-0.03,-0.45l-0.62,-0.17l-0.51,0.55l-0.18,-1.15l1.57,-2.16l-0.03,-0.34l0.08,0.26l-0.25,0.67l0.57,0.54l0.48,-0.42l0.22,-1.1l1.67,-0.42l0.54,-1.2l0.62,-3.99l0.28,1.33l0.59,-0.52l0.13,0.21l-0.03,0.91l0.61,0.59l0.21,1.34l0.63,0.12l0.57,-1.64l-0.32,-0.61l0.02,-0.96l0.85,-0.12l0.79,0.7l0.31,-0.71l0.44,-0.22l-0.06,-1.2l0.32,-0.27l0.74,0.28l0.93,-0.73l5.77,0.89l0.22,0.12l-0.4,0.97l0.1,0.98l-0.49,0.24l-0.08,0.56l0.81,0.8l-2.57,1.49l0.26,0.54l-0.46,0.33l0.09,0.67l0.91,0.29l-0.86,0.34l-0.29,0.46l0.16,1.13l-1.86,1.47l0.0,1.05l0.58,0.19l1.41,-1.37l0.14,0.84l1.0,0.06l0.81,1.47l0.56,0.03l-0.39,1.08l0.37,0.5l0.57,-0.21l0.18,-0.47l0.9,-0.32l0.19,0.33l-0.99,0.74l-0.86,1.43l-1.08,0.56l-0.4,0.85l0.24,0.61l0.68,0.47l0.61,-1.3l0.97,-0.42l0.54,-1.1l0.13,0.97l0.7,0.34l0.5,-0.39l-0.16,-0.43l0.31,-1.17l0.25,0.35l0.59,-0.13l0.5,-0.63l0.27,0.58l0.47,-0.2l0.67,-1.31l0.2,-1.29l-0.28,-1.66l0.91,0.0l0.34,0.73l1.22,0.06l0.94,-3.37l0.86,0.75l0.3,2.82l-0.8,1.71l-0.96,-0.15l-1.06,0.49l0.22,1.79l-1.26,1.56l-0.53,1.5l-1.45,0.06l-0.71,0.35l-1.06,-0.39l-0.47,0.35l0.06,0.97l1.35,1.88l2.18,-0.61l-1.93,0.8l-0.05,0.78l0.26,0.14l1.9,-0.22l1.17,-1.04l-0.06,1.61l-0.81,0.3l-0.23,0.53l0.85,0.23l0.02,1.22l-1.26,-0.75l-0.46,0.03l-0.38,0.51l1.88,1.64l0.16,0.78l1.51,0.96l1.58,0.42l0.29,0.84l1.71,-1.1l-0.32,-1.21l0.06,-1.67l-0.57,-0.88l0.05,-2.14l0.64,-0.69l-0.26,-0.35l0.09,-2.07l0.87,-1.15l1.04,-0.21l0.44,-0.84l0.28,-1.77l0.43,0.3l-0.37,0.49l0.02,1.96l-0.43,1.39l0.36,1.31l-0.62,2.4l0.77,1.14l-0.53,1.03l0.11,0.6l0.39,0.29l0.12,0.67l0.88,-0.04l0.12,0.97l0.54,0.75l0.8,-0.16l0.23,0.23l0.42,-0.3l0.19,-1.05l1.35,-2.65l0.07,-1.31l-0.52,-2.42l0.56,0.06l0.51,1.46l0.77,0.05l0.18,1.36l0.28,0.41l0.86,0.2l-0.46,0.7l0.54,0.67l-0.09,1.98l-0.49,0.38l0.6,3.82l-0.59,0.45l0.34,0.65l0.58,-0.04l0.26,0.34l-0.14,0.63l0.45,0.87l0.46,2.59l-0.57,1.29l0.07,1.4l-0.47,0.74l-0.67,-0.01l-0.83,-1.05l-0.69,-0.11l-0.33,0.68l-0.63,-0.3l-0.68,1.86l-0.83,1.01l-0.73,-0.66l-0.37,-1.76l0.15,-1.33l0.5,-0.85l-0.23,-0.4l-0.58,0.22l-0.01,-0.84l-0.4,-0.27l-0.25,0.21l-0.84,-0.22l0.05,-1.36l0.49,-1.07l-1.62,-1.32l-0.34,0.41l0.02,0.96l-0.33,-0.14l-0.27,0.39l-0.02,1.71l-0.56,0.67l-0.05,1.51l-0.38,0.42l-0.36,1.88l-0.68,1.14l-1.16,0.24l-0.47,-0.99l-0.17,-1.61l0.02,-4.34l0.67,-0.26l-0.1,-0.72l-0.82,-0.24l0.6,-0.51l0.23,-1.22l-0.41,-0.34l0.61,-0.71l0.06,-0.57l-0.72,-0.23l-0.68,0.24l-0.13,-1.19l-0.59,-1.2l-0.83,-0.46l-1.16,-1.94l-0.54,-0.14l-0.55,-0.83l-0.47,0.24l-0.91,-0.8l-0.33,0.87l-0.53,-0.45l-1.3,-0.03l-0.4,0.25l0.12,0.46l0.99,0.27l0.23,1.41l-0.06,1.15l-0.64,0.45l0.37,0.72l0.0,0.98l-0.69,0.17l-0.99,4.53l-0.43,-0.07l-0.29,0.77l-0.95,-0.73l-0.76,0.59l-0.92,4.35l-0.55,0.39l-0.21,0.76l0.74,0.35l0.45,0.78l-0.11,0.53l-0.72,-0.18l-0.34,0.36l0.47,1.39l-0.02,1.18l-0.43,0.51l-0.74,0.19l-0.02,0.81l-0.52,-0.04l-0.1,-0.43l-1.25,-0.24l-1.26,2.06l-1.9,0.6l-1.19,-0.1l-0.43,-0.32l0.46,-2.27l0.88,-0.9l0.97,-0.15l2.04,-1.75l0.09,-0.86l1.22,-2.28l-0.44,-2.39l0.42,-1.17l2.27,-1.82l0.82,-1.47l-0.27,-0.9l1.23,-1.84l-0.4,-0.26l-1.19,0.33l-0.89,1.52l-1.26,0.84l0.4,-2.8l-0.47,-0.74l-0.65,1.09l-0.31,2.16l-0.31,-0.33l-0.67,0.71l-1.79,0.09l-0.18,-0.55l-0.78,-0.22l-0.73,0.71l0.13,1.82l1.21,0.81l0.24,1.37l-1.1,0.92l-0.3,-0.1l0.04,-0.89l-1.08,-0.43l-0.8,1.48l-0.02,-0.52l-0.43,-0.31l0.06,-0.78l-0.47,-0.05l1.23,-1.4l0.05,-0.44l-0.83,-0.14l-1.53,1.71l-0.77,-0.1l0.47,-1.23l-0.08,-1.5l-0.38,-0.39l0.25,-1.59l-0.4,-0.79l-0.66,-0.19l-0.47,1.48l0.31,1.95l-1.11,1.09l-0.38,1.01l0.17,-0.88l-0.28,-0.45l-0.54,0.35l-0.79,-0.88l-0.46,-0.04l-0.13,0.71l0.63,0.81l-0.1,0.83l0.37,0.4l-0.54,1.27l-0.84,-1.65l-0.47,-0.24l-0.3,0.44l0.03,1.02l0.55,0.59l0.02,0.54l-3.57,1.08l-0.41,0.46l-0.25,-0.2l-0.62,0.22l0.13,0.75l0.6,0.46l-0.21,0.36l-1.15,0.21l-1.33,-0.26l-1.5,0.92l-0.14,-0.52l-0.61,-0.41l-0.53,0.36l-0.02,0.51l-0.92,0.57l-0.17,-0.69l-0.46,-0.16l-1.88,0.89l-0.5,-0.13l-0.77,1.11l-1.38,-0.43l-0.81,0.72l-0.79,-0.15l-0.02,-0.49l-0.44,-0.12l-0.56,0.26l-0.17,0.46l-0.9,-0.11l-0.81,0.33l-1.22,1.15l-0.87,0.03l0.41,-1.32l-0.5,-0.16l-1.15,0.85l-0.09,1.71l-1.35,0.05l-0.62,1.11l-0.56,0.12l-0.42,0.57l-2.33,0.82l-1.98,1.48l-1.19,0.13l-0.86,-0.32l-0.49,-2.11l-2.24,-2.02l0.77,-0.74l0.91,-2.53l1.76,-2.24l0.33,-1.2l1.47,-2.58l0.19,-1.52l1.72,-1.6l0.36,-1.23l1.28,-0.84l0.14,-0.68l-0.91,-0.21l-2.2,1.29l-0.93,-0.35l-1.05,0.22ZM875.13,662.15l0.01,-0.05l0.03,0.05l-0.03,0.0ZM877.64,662.72l0.01,0.0l-0.0,0.01l-0.0,-0.01ZM877.66,662.95l0.18,0.25l-0.68,1.05l-0.32,0.16l0.81,-1.47ZM877.92,687.46l0.03,0.05l-0.04,0.02l0.01,-0.07ZM861.06,691.62l-0.07,0.12l-0.12,0.06l0.18,-0.18ZM860.09,692.51l-0.48,0.59l-0.29,-0.1l0.05,-0.05l0.72,-0.44ZM879.41,666.37l0.09,-0.58l0.24,-0.6l0.19,0.13l-0.51,1.05ZM875.09,662.02l-0.1,-0.13l0.04,0.02l0.06,0.11ZM856.72,657.08l-0.75,-1.19l0.46,-0.02l0.19,-0.64l0.34,0.61l-0.23,1.24ZM855.6,655.59l-0.04,-0.03l0.02,-0.02l0.02,0.05ZM854.13,657.17l0.0,-0.25l0.09,-0.07l-0.09,0.32ZM880.24,671.96l0.93,-0.43l1.21,0.01l1.03,-1.19l0.17,0.15l0.06,0.96l-1.69,0.33l-1.01,0.54l-0.41,0.04l-0.3,-0.41ZM880.32,686.11l0.4,-1.02l-0.02,0.88l-0.39,0.14ZM880.62,683.25l-0.08,-0.03l0.05,-0.13l0.03,0.15ZM865.39,648.04l0.38,0.42l0.68,-0.29l0.06,-1.23l0.98,0.8l-1.68,1.99l-0.42,-0.78l0.29,-0.24l-0.3,-0.67ZM859.7,652.85l0.19,-0.17l0.32,0.44l-0.25,-0.18l-0.25,-0.09ZM860.59,653.19l0.24,-0.05l0.02,0.23l-0.08,0.03l-0.18,-0.21ZM861.93,651.82l-0.05,-0.37l0.49,-0.4l0.03,0.24l-0.48,0.53ZM862.01,654.42l0.02,0.04l-0.01,0.11l-0.04,-0.08l0.03,-0.06ZM859.28,690.2l0.8,-0.57l0.4,0.51l-0.91,0.12l-0.29,-0.06ZM850.54,655.73l0.16,0.11l-0.16,0.24l-0.04,-0.3l0.04,-0.05ZM850.65,657.07l0.03,-0.01l-0.01,0.06l-0.01,-0.05ZM843.73,636.57l0.01,-0.34l0.77,-0.76l-0.19,0.87l-0.6,0.23ZM838.16,616.02l0.06,-0.8l0.21,-0.21l-0.04,0.83l-0.22,0.19ZM696.03,500.29l-0.19,0.36l0.37,0.59l0.59,-0.17l0.69,-0.86l0.89,0.17l-0.49,0.97l0.49,0.51l0.6,-0.2l0.44,-0.59l0.13,0.27l-0.65,0.85l0.07,0.57l-0.32,0.09l-0.24,-0.83l-0.68,-0.71l-1.19,0.27l-0.74,-0.45l-0.13,-0.43l0.35,-0.4ZM697.84,503.41l-0.02,0.02l-0.01,-0.01l0.03,-0.01ZM697.69,505.53l1.21,-1.47l1.28,-0.58l0.14,0.33l-1.01,0.24l-0.3,0.44l0.4,0.35l1.15,0.15l0.07,0.3l-0.82,0.92l0.28,0.56l0.53,-0.01l1.02,-0.87l0.17,-0.72l0.96,0.23l-0.44,0.91l0.49,0.27l0.45,-0.14l0.19,0.94l-0.7,0.47l0.16,0.63l1.68,1.31l1.17,-0.26l-0.32,2.55l0.34,0.66l0.43,-0.19l0.54,-1.08l-0.12,-1.02l0.48,0.08l-0.4,1.24l0.15,0.56l0.69,0.11l0.53,-1.32l1.06,0.31l-0.12,1.5l-2.03,0.86l-0.29,0.46l0.21,0.67l3.15,-0.37l0.01,1.37l-0.41,0.6l0.59,0.39l0.97,-0.82l0.15,-1.71l0.59,-0.14l0.26,1.19l-0.58,1.28l1.1,0.04l0.62,-0.88l-0.04,0.62l0.48,0.37l0.27,-0.15l-0.12,0.81l-0.67,0.47l-0.28,0.63l-1.18,0.73l-2.49,0.28l-0.46,1.71l0.57,0.27l0.62,-0.56l0.67,1.05l0.66,0.02l0.23,-0.46l-0.46,-0.94l1.05,0.08l0.71,-0.62l1.2,-0.33l0.42,-0.72l0.62,-0.27l0.13,-0.68l0.27,-0.01l0.57,0.35l-0.5,0.14l-0.28,0.5l0.44,0.41l0.58,-0.02l-0.22,0.99l0.25,0.41l0.66,-0.37l0.35,0.16l-0.84,1.07l0.06,0.67l0.65,0.1l0.66,-0.36l0.73,0.45l0.4,-0.35l0.12,-0.76l1.44,0.52l0.21,0.76l-0.92,1.11l0.53,0.58l1.41,-0.58l0.12,0.47l-0.41,0.55l0.04,0.61l-1.06,1.02l-0.67,1.25l-1.48,0.58l-0.62,-0.22l-0.6,0.4l-0.46,1.24l0.53,0.15l1.22,-0.6l-1.46,3.18l-0.05,0.31l0.52,0.44l0.57,-0.34l0.91,-1.39l0.93,-2.23l1.0,-0.4l-0.29,1.33l0.62,0.69l0.61,-1.64l0.69,-0.01l0.43,-0.88l0.55,-0.31l0.96,-0.01l0.21,-0.69l1.05,-0.57l-0.44,1.25l0.84,1.88l-0.67,0.73l-1.34,0.68l-0.14,1.17l0.37,0.5l-1.45,0.73l0.01,0.72l0.31,0.11l-1.25,1.46l0.46,0.55l-1.25,1.18l0.44,0.58l2.18,-1.11l0.09,-1.23l0.86,-0.89l0.16,-0.72l0.77,-0.03l1.16,-0.66l0.72,0.04l0.34,-0.45l0.3,0.01l0.37,1.03l0.55,0.25l0.4,-0.75l0.95,0.44l-0.18,0.32l-1.47,0.33l-0.95,1.54l-0.01,0.73l0.73,-0.07l0.49,-0.71l0.78,-0.42l0.74,1.54l0.56,0.1l1.0,-1.67l0.35,0.37l0.62,-0.39l0.02,-0.85l0.6,0.72l-0.34,1.3l0.43,0.73l0.35,0.27l1.01,-0.06l0.69,0.78l0.0,0.5l1.04,0.58l-1.38,1.23l-0.03,0.93l-1.56,0.45l-0.27,1.54l-2.01,-0.32l-0.25,0.64l0.19,0.24l2.15,0.88l0.91,-0.28l1.09,-1.06l1.22,-0.19l1.37,0.3l0.32,0.13l-0.52,0.68l0.65,0.3l0.26,0.8l-0.99,0.53l-0.19,0.63l0.33,0.32l1.36,0.18l0.3,0.5l0.46,0.19l0.41,-0.24l0.29,0.29l0.55,-0.51l0.62,0.17l1.44,-0.59l1.45,0.33l0.47,1.67l-0.97,0.45l-0.38,0.54l-0.62,1.94l0.28,1.04l-1.07,0.77l-0.71,-0.04l-0.49,0.33l0.61,2.02l-0.36,0.42l-4.73,-0.44l1.24,-0.79l2.21,-0.68l0.25,-0.4l-0.81,-0.5l-2.68,0.68l-0.55,0.44l-1.09,-0.08l-0.49,0.41l-0.22,0.99l0.36,0.64l5.05,0.99l-0.89,0.22l-0.25,0.62l0.41,0.27l2.62,-0.18l1.27,-0.49l0.93,0.2l0.56,-0.25l0.51,0.28l-0.61,0.54l-2.81,0.49l-0.54,0.59l-0.28,1.41l0.28,0.15l3.06,-0.22l-0.02,0.33l0.96,0.46l-1.37,0.94l-1.09,-0.04l-0.34,0.31l0.16,0.76l1.04,0.73l1.03,0.18l0.56,-0.43l1.61,-0.1l0.97,-0.6l0.76,0.2l1.48,-0.96l-0.21,1.32l0.55,0.37l-0.55,0.77l0.19,0.56l-0.32,1.03l1.47,0.69l1.52,-0.61l0.48,0.14l0.6,-0.57l0.58,0.38l-0.9,0.49l-0.01,0.65l1.33,0.47l1.7,-0.86l1.74,-0.31l0.19,0.44l-0.41,0.75l-1.47,0.65l0.21,0.67l0.56,0.25l1.92,-0.77l0.6,-1.24l0.51,0.98l-0.38,0.75l0.46,0.66l-0.14,1.23l0.53,0.45l0.76,-1.77l-0.15,-3.1l0.55,0.28l0.58,-0.15l0.03,1.06l-0.91,0.91l0.04,1.48l0.37,0.32l0.88,-0.92l0.01,1.78l0.23,0.41l0.67,-0.3l-0.55,1.03l0.37,0.82l-0.09,0.75l0.19,0.41l0.45,-0.03l0.38,-0.45l-0.04,0.62l-0.71,1.04l0.03,1.21l-0.46,0.73l0.1,0.53l0.54,-0.05l0.6,-0.86l-0.04,1.0l-1.17,1.98l0.49,1.28l0.46,-0.28l0.75,-1.92l0.56,-0.54l0.07,-1.09l0.71,-0.41l0.51,-1.51l0.42,-0.38l0.23,0.96l0.46,-0.14l0.34,-0.75l-1.12,3.19l0.36,1.06l0.43,-0.19l1.32,-2.78l0.27,-1.92l0.88,-0.36l0.44,-1.72l0.57,0.65l0.15,0.72l-0.78,1.12l-1.06,0.4l0.32,1.13l0.6,0.06l0.26,-0.54l0.49,0.27l0.7,-0.11l0.51,-0.9l1.02,-0.03l0.78,-1.05l0.58,0.28l-0.89,2.37l-0.9,1.04l0.17,0.63l-0.8,1.49l0.45,1.26l-0.65,1.0l0.16,0.62l0.34,0.14l0.59,-0.18l0.88,-1.1l0.11,-0.44l-0.51,-1.33l1.2,-1.77l0.91,-2.17l0.7,0.94l0.65,-0.15l0.89,-1.39l0.02,-0.96l1.26,-0.4l0.1,-0.99l0.4,0.04l-0.18,2.03l0.4,0.39l0.53,-0.33l0.65,0.29l-0.61,1.49l0.48,0.25l0.67,-0.26l0.5,0.69l1.28,-0.46l0.4,0.59l0.5,-0.01l0.19,-0.47l1.24,-0.04l0.63,0.43l0.66,-0.44l0.75,0.44l0.57,-0.32l-0.19,-0.82l1.25,-0.48l0.78,0.67l1.47,-0.42l0.48,0.28l1.19,-0.94l1.0,0.75l0.52,-0.08l0.79,0.49l1.29,-0.43l0.73,-0.65l0.99,0.79l-0.17,0.61l0.69,0.2l-0.04,0.32l-2.3,0.88l-0.54,0.51l0.43,0.75l1.45,-0.47l-0.65,1.12l-2.36,0.59l-2.86,1.73l-0.63,1.34l0.44,0.77l-1.94,1.14l-2.0,2.4l-1.59,0.57l-4.59,3.5l-1.34,0.21l-0.64,0.52l0.02,0.77l1.19,0.5l2.35,-1.12l2.03,-1.52l-0.03,0.33l0.48,0.25l0.63,-0.16l-0.41,0.6l-1.83,1.13l-2.0,2.67l-3.76,0.96l-0.45,0.5l0.12,0.58l-1.41,1.11l-0.58,-0.13l-0.44,0.59l1.0,0.75l0.06,1.7l0.69,1.02l-2.41,-0.59l-0.94,-0.59l-4.79,-0.39l-0.75,-0.8l-0.69,0.12l0.27,1.24l-0.38,0.97l0.35,0.59l3.26,-0.69l2.18,0.3l2.27,0.89l2.17,0.4l-2.62,2.84l-0.04,0.56l0.42,0.43l1.55,-0.45l-1.4,0.94l-0.16,0.6l0.52,0.24l1.28,-0.51l1.07,-0.9l0.83,0.15l0.31,-0.75l-0.36,-0.5l0.63,-0.65l1.03,-2.52l0.66,-0.33l0.1,-0.42l-0.29,-0.31l2.55,-1.52l1.37,-2.76l2.28,-1.07l0.51,-1.11l-0.06,-0.62l-0.83,-0.68l1.21,-2.08l0.03,-0.87l1.65,-1.1l3.13,-2.92l0.65,-0.2l0.71,-0.92l3.25,-0.59l0.5,-0.7l-0.75,-0.57l-1.61,0.39l-0.9,-0.18l-1.58,0.38l-0.92,1.24l-0.95,-0.28l0.12,-0.9l0.83,-0.25l0.42,-0.75l1.74,-0.64l1.03,0.17l3.07,-0.76l0.56,0.29l1.2,-0.93l0.61,0.24l2.07,2.23l1.09,0.59l0.42,1.18l1.26,0.49l0.19,1.3l-2.9,3.24l-0.18,0.91l0.21,0.41l0.46,-0.06l0.59,-0.61l0.22,0.2l0.93,-0.29l-0.02,0.42l0.6,0.43l-0.23,1.53l0.2,0.42l1.35,-0.49l-0.04,-1.08l0.95,-1.53l-0.33,-1.29l0.42,-0.53l0.28,-1.75l1.09,-0.23l1.33,-0.99l0.54,0.16l-0.82,0.48l0.48,0.52l3.41,-0.05l0.69,-0.42l0.14,0.42l0.98,-0.09l0.42,0.67l2.36,0.28l0.81,0.69l-0.23,0.59l0.4,0.5l0.62,-0.17l0.39,-0.76l0.32,0.03l0.39,1.44l0.81,-0.21l-0.26,0.48l0.62,0.6l-0.11,0.35l1.23,0.68l-0.27,0.64l-1.18,0.06l-0.27,0.53l0.93,0.4l-0.08,0.69l-1.31,0.15l-1.04,0.54l-0.19,0.5l0.8,0.26l-0.06,0.62l0.53,0.27l0.46,-0.21l0.28,-0.66l1.23,-0.2l0.16,0.52l0.76,0.12l0.73,0.83l-1.35,1.01l-0.27,0.56l-1.53,0.04l-0.22,0.59l0.6,0.55l1.24,0.16l1.33,0.9l-1.49,0.4l-0.08,0.83l1.44,-0.22l-0.31,0.65l-1.3,1.06l-0.9,-0.23l-1.9,0.25l-0.72,0.58l1.1,0.55l1.07,-0.29l1.16,0.14l1.45,-0.77l1.42,0.1l1.44,-0.55l0.41,0.23l0.54,-0.28l0.55,0.73l0.79,-0.3l0.34,0.7l-0.59,-0.18l-0.89,0.32l-0.04,0.72l-3.99,-0.27l-0.33,0.07l-0.2,0.68l0.76,0.49l1.66,-0.13l3.09,0.67l-0.07,0.54l0.86,0.9l0.62,0.06l0.47,0.89l-0.87,0.56l0.07,0.61l0.36,0.2l-0.14,0.29l-0.46,0.42l-0.96,0.1l-0.08,0.73l0.85,0.4l0.06,0.39l-1.6,1.97l-0.54,1.51l-1.26,0.78l-0.15,0.74l-0.6,0.22l-0.16,0.9l-0.71,1.15l-0.99,0.55l0.07,1.34l-0.68,1.28l0.03,0.76l-1.14,0.3l0.15,1.24l-0.9,0.27l-3.54,-9.36l-0.52,-0.23l-35.41,12.67l-33.8,10.74l0.05,-0.71l-1.71,-2.85l-0.93,-0.79l0.17,-0.44l-0.26,-0.43l-0.57,-0.17l-2.03,0.31l-1.48,-1.45l0.43,-1.47l0.91,-1.14l5.09,-2.36l-0.1,-0.81l-0.51,-0.48l-2.37,-0.8l-0.52,-1.28l-0.71,-0.03l-0.65,1.67l-3.72,2.2l-0.52,1.08l0.25,2.29l0.94,1.3l0.63,1.63l-0.34,2.5l1.11,1.86l-0.71,0.77l0.46,1.83l-0.26,-0.16l-0.61,0.33l-0.03,0.86l1.07,2.64l0.95,1.12l-0.28,1.2l-1.36,1.67l-2.01,-1.64l-1.2,-0.53l-1.37,0.13l-0.6,0.43l-0.11,0.65l-0.7,-0.33l-1.5,0.25l-0.26,-0.68l-1.34,-0.66l-0.91,0.41l-0.65,-2.06l-0.56,-0.04l-1.76,-1.75l-0.47,1.36l-0.62,0.28l-0.14,-1.04l-0.55,-0.3l-0.78,0.57l-1.11,-0.03l-1.48,1.15l-0.74,-0.14l-0.37,-1.35l-1.5,-0.62l-1.48,-1.26l-0.59,0.71l0.97,2.25l-0.39,0.26l-1.9,-2.81l0.14,-0.41l0.65,0.06l0.45,-0.5l-1.85,-4.51l0.79,0.47l0.52,-0.62l-2.23,-3.68l0.93,0.01l0.19,-0.47l-0.3,-0.96l-1.31,-1.69l-0.94,-0.54l-0.71,0.24l-0.33,1.54l-1.2,0.9l0.32,2.45l-0.99,0.76l0.12,0.82l-0.46,-0.14l-0.4,0.68l-1.6,-0.89l-0.58,-1.5l-0.53,-0.23l-0.83,0.6l-0.18,0.61l-1.19,-0.46l-0.46,-0.49l-1.24,-3.1l0.86,-1.04l1.84,0.33l0.27,0.57l0.51,0.13l0.73,-0.59l-0.62,-3.99l-0.75,-0.9l0.86,-1.08l-0.07,-0.6l-1.94,-1.38l-3.37,-0.19l-0.94,-0.86l-0.61,-1.14l-1.84,-0.88l0.38,-0.32l-0.13,-0.89l-0.91,-0.33l-0.67,-1.14l-2.25,-1.26l-0.04,-1.47l1.12,-1.64l-0.29,-0.92l-1.56,-1.71l-0.31,-1.14l0.71,-0.9l1.24,-0.55l0.24,-0.41l-0.29,-1.34l2.27,1.18l0.51,-0.25l0.16,-1.0l-0.42,-0.67l0.84,-0.98l0.41,-1.56l-0.43,-1.17l-2.25,-1.33l-2.3,-2.41l-0.36,-0.8l0.26,-0.35l0.6,0.08l-0.17,0.56l0.35,0.57l3.3,1.27l0.58,0.94l0.85,0.58l2.47,0.67l0.61,-0.26l0.01,-0.8l0.55,-0.25l0.23,-0.92l-1.85,-2.05l0.48,-0.97l-1.58,-1.83l-0.09,-1.14l0.41,-0.65l-0.39,-0.66l0.69,-0.18l4.57,3.66l1.4,0.26l1.2,0.7l0.87,-0.48l0.92,0.0l0.76,1.43l2.24,1.56l0.63,-0.76l0.84,0.15l0.8,-0.4l0.36,-0.71l-0.49,-1.05l1.58,-0.47l0.57,-0.59l0.63,-2.12l1.49,0.03l1.4,1.15l0.66,0.07l0.18,0.96l0.59,0.71l2.31,-0.49l0.85,-1.46l0.41,-0.06l2.36,0.71l1.03,1.13l0.93,0.34l1.77,-0.35l0.82,-0.97l0.55,0.1l0.47,-0.4l-0.12,-0.72l-0.96,-0.96l-1.38,-0.65l0.52,-0.98l-0.48,-0.98l0.04,-0.82l1.45,0.33l0.84,-0.52l-0.13,-1.6l-0.86,-2.36l0.09,-1.19l0.78,-0.5l0.29,-0.69l-0.05,-0.51l-0.56,-0.32l-1.26,0.84l-0.77,-0.14l0.82,-0.63l0.01,-0.71l1.65,-0.79l0.19,-0.89l-0.24,-0.56l-0.47,-0.2l-3.07,0.68l-1.07,-0.12l0.58,-1.08l-0.44,-2.05l-0.27,-0.45l-0.62,-0.18l-0.16,-1.95l-0.87,-0.34l-1.22,-1.39l1.23,-0.85l0.84,-1.18l1.0,-0.54l0.24,-0.48l-0.23,-0.57l-0.51,-0.1l-1.3,0.63l-1.02,-0.23l-1.02,0.35l-0.43,-0.32l0.01,-0.64l-0.54,-0.29l-1.12,1.1l-0.15,-0.79l0.91,-0.83l-0.03,-1.01l-1.08,-0.55l-1.33,0.31l-0.42,-0.42l-0.02,-0.84l-0.5,-0.95l1.38,-0.28l0.91,-1.01l-0.23,-0.5l-0.76,-0.29l-0.48,-1.3l-2.4,-2.03l0.07,-0.83l0.74,-0.66l-0.33,-1.27l0.95,-0.56l0.16,-0.48l-0.74,-0.94l0.17,-1.17l-0.42,-1.05l0.57,-0.95l-0.31,-1.24l0.09,-1.36l-1.39,-1.2l0.94,-1.54l-0.99,-1.39l-0.53,-1.77l0.91,-1.89l0.01,-1.33l-0.65,-0.67l-0.76,0.39l-0.1,0.77l-0.5,-0.48l-1.2,0.29l-0.4,-0.8l-0.56,-0.35l-0.9,-0.04l-0.36,0.57l-2.06,-2.73l-0.44,-1.22l-2.15,-0.07l-0.15,-1.73l1.09,-0.79l0.36,-0.66l-0.1,-2.05l0.86,-0.71l0.29,-1.2l1.13,-0.54l0.26,-0.9l-1.33,-1.84l-0.49,0.02l-0.81,0.98l-0.34,-0.16l-0.39,-0.85l0.05,-0.9l1.24,-0.91l0.82,-0.13l2.45,-1.25l0.42,-0.66l-0.07,-0.7l-1.4,-1.26l-1.94,-0.37l-0.78,0.53l-0.25,0.8l-1.29,0.52l-1.01,1.64l-0.81,-0.16l-0.3,-1.21l-0.89,-0.63l-2.56,0.63l-1.66,-0.61l-0.97,0.85l0.1,-0.63l-0.36,-0.43l0.45,-1.16l0.96,0.46l2.31,0.23l1.22,-0.56l0.29,-0.88l-1.03,-1.09l-1.22,-0.08l-0.99,-1.57l-0.88,-4.18l1.03,-1.31l-0.19,-0.83l-0.59,-0.35l-0.9,0.2l-1.77,2.04l-0.73,-0.95l-1.3,-0.55l-0.36,-1.4l0.81,-1.28l-0.85,-1.96l0.39,-0.6l-0.17,-0.45l0.67,-0.48l-0.02,-0.65l-0.49,-0.78l-1.06,-0.15ZM749.43,644.67l-0.21,0.06l-0.38,-0.16l0.32,0.07l0.27,0.03ZM827.52,605.46l1.17,-0.58l0.2,0.18l-0.04,0.35l-0.71,0.3l-0.62,-0.26ZM813.86,589.78l0.16,-0.56l0.66,-0.26l0.12,0.19l-0.94,0.63ZM742.78,556.73l0.27,-0.15l0.42,0.38l0.74,0.05l-1.11,0.28l-0.32,-0.55ZM743.07,555.94l0.11,-0.16l0.77,-0.06l-0.64,0.05l-0.24,0.16ZM725.03,532.72l0.15,-0.75l1.74,-0.61l-0.23,0.87l-1.66,0.49ZM716.21,518.51l0.26,-0.13l0.06,0.04l-0.32,0.09ZM701.98,503.42l-0.06,0.03l-0.14,-0.01l0.18,-0.05l0.02,0.03ZM746.33,561.6l1.29,-0.12l1.03,-0.44l-0.04,0.65l-2.28,-0.08ZM765.04,574.52l-0.09,-0.09l0.07,-0.12l0.12,0.1l-0.09,0.11ZM766.11,573.29l-0.2,-0.4l-0.0,-0.06l0.04,0.0l0.17,0.45ZM777.44,577.1l0.21,-2.19l0.71,0.01l-0.44,0.65l-0.49,1.53ZM788.01,592.75l1.22,-1.14l0.8,-0.31l1.1,-1.65l0.44,-0.22l-1.08,2.63l-2.49,0.7ZM779.46,607.1l0.03,-0.02l0.01,0.02l-0.04,0.0ZM820.61,590.82l0.0,0.0l-0.0,0.0l-0.0,-0.01ZM701.88,596.17l-0.57,-0.35l-0.42,-0.33l0.73,0.21l0.27,0.47ZM825.79,598.33l0.24,-0.16l0.14,-0.18l-0.36,0.57l-0.02,-0.23ZM821.86,591.85l1.18,-0.3l0.11,0.43l-1.18,0.08l-0.11,-0.21ZM809.43,590.34l0.28,0.04l-0.13,0.1l-0.15,-0.14ZM808.53,593.04l-0.01,-0.07l0.06,-0.23l0.07,0.28l-0.11,0.02ZM801.05,579.04l0.02,-0.15l-0.02,-0.2l0.27,0.24l-0.27,0.12ZM790.5,576.74l1.36,-1.34l0.14,0.95l0.53,0.49l-0.39,0.57l-0.93,0.16l-0.71,-0.82ZM757.4,566.9l0.54,-0.08l0.35,0.26l-0.22,0.16l-0.67,-0.34ZM753.32,565.66l0.39,-0.32l0.08,-0.97l1.15,0.24l-0.22,1.06l-1.41,-0.01ZM748.73,558.73l-0.2,-0.17l0.27,-0.02l-0.08,0.19ZM747.96,558.45l-0.96,0.19l-0.02,-0.12l0.72,-0.16l0.26,0.09ZM750.06,555.65l0.07,-0.3l0.2,-0.06l0.02,0.17l-0.29,0.18ZM744.69,552.98l0.63,-1.08l0.02,-0.72l0.75,0.24l-0.13,0.41l0.44,0.61l-0.83,0.06l-0.16,0.95l-0.37,0.33l-0.35,-0.8ZM745.53,555.04l0.78,-0.94l0.61,-0.02l0.44,1.15l-0.05,0.83l-1.79,-1.02ZM739.57,542.24l0.1,-0.7l0.05,-0.02l0.14,0.64l-0.29,0.08ZM737.12,536.75l0.17,-0.49l0.37,0.18l0.66,1.05l-0.18,0.15l-1.02,-0.9ZM737.02,541.9l0.57,-0.02l0.36,-0.73l0.61,0.38l-0.67,1.26l-0.88,-0.88ZM734.6,536.57l0.49,-1.0l0.84,0.73l-0.23,0.65l-1.11,-0.37ZM704.55,508.2l0.25,-0.58l0.82,0.14l-0.81,0.77l-0.26,-0.33ZM704.52,507.29l-0.04,-0.66l0.08,0.11l-0.04,0.55Z",name:"Newfoundland and Labrador"},"CA-ON":{path:"M399.18,732.97l3.61,-62.03l17.48,-16.01l50.17,-56.68l2.38,2.85l1.41,0.72l2.09,2.16l3.34,1.59l0.32,0.93l2.49,3.6l0.21,0.78l1.14,1.35l-0.34,0.82l0.41,0.83l0.93,-0.9l0.33,0.57l1.19,0.13l-0.12,0.67l0.59,0.42l0.37,-0.21l4.38,0.75l6.3,3.23l3.98,0.98l2.15,0.97l2.94,3.12l3.19,1.18l0.02,0.41l-0.73,0.42l-1.87,3.35l-0.2,2.26l0.59,0.29l0.53,-0.6l0.5,-1.93l1.17,-2.2l0.8,-0.71l1.45,-0.24l3.65,0.71l3.97,-1.2l1.6,0.26l1.47,-0.99l1.54,0.65l0.54,1.07l1.21,-0.17l0.13,1.07l0.43,0.57l0.68,-0.28l-0.38,-1.86l3.24,0.33l0.69,0.35l1.97,-0.84l0.55,0.68l-0.33,1.5l0.67,-0.0l0.48,-0.78l1.18,0.14l1.11,-0.61l0.85,0.4l0.9,-0.04l0.79,0.99l1.11,0.18l0.24,2.22l0.89,1.67l-1.85,8.93l0.53,3.1l0.67,1.51l0.69,0.04l0.76,0.78l1.61,4.42l-0.68,3.75l1.63,5.71l-1.28,1.28l-0.38,3.56l0.34,1.55l2.94,1.95l1.54,2.72l1.27,0.85l1.71,2.1l1.35,0.88l-0.11,0.68l0.43,1.19l-2.0,1.21l-0.77,0.15l-0.57,0.56l-0.12,0.8l0.39,0.6l0.27,-0.03l1.21,-0.98l2.42,-0.18l1.79,2.17l4.33,1.42l0.88,1.65l1.7,0.86l2.17,2.18l1.19,3.1l1.0,0.99l0.31,1.74l-2.02,1.29l-1.13,2.06l-1.21,0.9l-0.45,0.98l-0.86,0.68l-0.29,0.63l0.81,0.81l0.63,0.0l0.95,-2.17l1.62,-0.81l1.32,-2.12l1.59,-1.41l3.03,0.45l0.5,0.44l0.92,0.13l2.89,1.98l0.59,1.04l2.24,1.83l7.01,59.67l-0.5,2.75l0.48,1.12l1.53,1.9l0.61,3.39l2.03,2.63l1.76,1.66l1.07,2.0l1.14,1.05l1.33,2.35l2.44,1.53l0.44,0.79l0.64,0.34l4.21,0.28l0.6,0.39l2.46,-0.27l0.96,0.32l1.48,-0.15l3.27,0.47l2.39,0.86l2.13,1.35l0.58,1.44l0.77,0.72l2.97,1.37l1.25,-0.14l0.4,-0.74l-0.27,-1.02l0.78,-0.05l0.75,1.94l0.75,0.63l1.26,2.41l0.84,0.43l2.11,0.29l1.11,0.66l1.08,-0.1l0.74,-0.95l0.94,-0.29l1.1,0.16l2.36,1.74l1.37,-0.21l1.06,-1.56l1.04,-0.35l3.5,-2.3l2.72,-0.79l1.29,-0.96l2.06,-0.26l1.36,-0.65l1.31,0.6l1.64,0.2l-0.25,4.37l1.74,1.53l-1.12,0.9l-0.49,1.45l-1.92,1.85l-2.34,0.31l-4.21,3.29l-4.61,5.87l-0.78,1.45l-0.74,0.45l-1.02,1.74l-0.62,0.48l-2.83,1.26l-3.3,2.3l-1.55,0.2l-2.37,1.7l-0.49,-0.59l-0.62,-0.03l-0.35,0.38l-0.54,-0.59l-2.13,1.15l-0.76,-0.34l-0.64,0.55l-0.69,-0.07l-2.68,1.44l-0.39,1.13l0.45,0.24l-1.75,0.25l-0.41,0.48l-1.86,0.83l-4.68,1.11l-2.57,1.33l-1.36,-0.07l-3.16,1.34l-1.55,0.25l-1.68,1.0l-0.33,0.71l-2.62,2.68l-1.39,0.28l-0.34,0.81l-1.15,0.96l-0.11,1.25l-1.66,3.08l0.19,1.1l0.59,0.56l2.05,0.62l2.58,-0.18l0.9,0.25l2.09,-1.5l0.99,-0.29l0.21,3.11l0.44,0.35l0.11,0.95l1.64,0.99l-0.31,0.36l-1.64,0.78l-1.28,-0.28l-3.23,0.38l-0.52,0.46l-1.81,0.41l-1.14,-0.22l-1.42,0.76l-4.47,1.21l-1.73,1.55l-0.19,0.66l-0.35,-0.07l-0.52,0.45l-0.51,0.79l0.06,0.86l-6.1,-1.03l-3.85,0.33l-1.74,0.54l-2.51,1.81l-2.89,3.12l-0.52,1.54l-1.15,1.04l-1.8,0.33l-3.66,2.49l-1.43,1.98l-0.09,0.9l-1.16,-0.92l-0.76,-0.11l-2.24,1.16l-0.93,0.09l-2.5,-1.04l0.23,-3.72l1.37,-0.67l2.31,0.39l1.92,-0.15l2.07,-0.47l0.67,-0.49l0.34,-1.28l-0.4,-2.01l-2.62,-0.26l0.8,-0.66l0.5,-1.21l0.33,-2.5l-0.23,-0.88l0.63,-3.06l3.6,-1.93l1.28,-2.02l1.53,-0.91l1.19,-1.36l0.79,-2.06l-0.83,-9.21l-0.61,-2.59l0.88,-1.1l0.46,-1.2l0.15,-2.05l1.0,-1.44l1.1,-0.63l0.26,-1.3l1.06,-1.69l0.17,-0.89l-0.41,-0.98l-0.04,-1.96l-1.18,-1.48l0.03,-1.32l-0.37,-0.69l-0.93,-0.06l-1.97,-2.46l0.08,-0.46l-1.7,-0.54l0.08,-0.2l0.76,0.18l3.63,-0.35l-0.43,1.17l0.89,1.12l0.3,1.84l1.72,0.67l-0.25,0.6l0.56,0.33l0.39,-0.17l0.33,0.24l0.54,-0.36l0.13,0.47l-0.32,0.56l-1.12,1.02l0.07,0.86l0.59,0.2l1.53,-1.22l0.73,0.18l-0.2,3.37l0.73,0.14l1.19,-1.81l1.46,-0.74l1.29,1.87l0.94,0.06l0.86,0.64l4.81,1.08l1.27,-1.37l-0.05,-2.95l-0.3,-0.56l-1.36,-0.75l-0.09,-0.5l0.51,-0.04l0.4,-0.74l0.59,-0.17l-0.15,0.59l0.83,0.32l0.43,0.71l2.82,-0.09l0.24,-0.64l-0.74,-0.45l0.41,-0.84l-0.27,-0.96l-0.6,-0.04l-0.53,0.62l-0.98,-1.51l-0.99,-0.12l-0.32,-0.95l-0.65,-0.11l-0.26,-0.61l-0.79,-0.33l0.6,-0.32l0.2,-0.76l-0.48,-0.81l-1.23,-0.51l0.92,-1.39l-0.63,-1.56l-0.47,-0.33l-0.88,0.01l-0.69,0.43l-0.15,0.59l-0.7,-0.07l-0.23,-1.09l-0.96,-0.31l-0.07,-1.59l-0.5,-1.17l-0.72,-0.28l-0.21,0.75l-0.38,0.04l-0.16,-0.7l-0.64,-0.22l-0.89,-1.17l-0.14,-0.96l-0.88,-1.39l-0.43,-0.07l-0.38,-1.02l-1.01,-0.62l-0.57,0.46l-0.54,-0.33l-2.99,0.52l0.06,-0.75l-0.56,-0.51l-0.86,0.29l-0.36,0.68l-2.42,-0.2l-0.32,-0.34l0.11,-0.32l-0.55,-0.23l-0.27,-0.88l-1.22,-0.45l-0.72,0.76l-0.35,-0.3l-5.57,0.15l-1.54,-0.49l-0.07,-0.38l-0.48,-0.19l-1.21,0.19l-0.29,-0.21l-1.97,0.69l0.13,-0.33l-0.57,-0.46l-0.86,0.46l-3.28,0.67l-6.33,-0.98l-0.68,0.14l-0.73,-0.55l-1.19,0.24l-1.58,-0.28l-0.96,-0.63l-1.61,0.25l-0.66,-0.22l-0.44,-0.69l0.33,-2.01l-0.21,-0.47l-0.62,-0.28l-0.88,0.03l-1.05,0.73l-1.2,-0.16l-1.02,0.74l-0.89,-0.94l1.63,-2.22l0.19,-0.7l-0.71,-1.01l-0.82,0.15l-0.03,-0.84l0.56,-0.31l1.05,0.17l0.62,-1.12l-0.19,-0.53l-1.22,-0.9l-1.71,0.01l-0.56,0.46l-0.37,-0.55l-1.24,-0.32l0.1,-0.97l0.63,-0.88l-0.18,-0.72l0.27,-0.75l1.18,-1.73l0.06,-0.58l-0.65,-1.21l-0.75,-0.24l-0.57,-1.16l-2.32,-1.17l-0.59,-0.99l-0.68,-0.41l0.48,-1.35l-0.17,-0.52l0.99,-1.39l-0.56,-0.9l0.99,-1.16l-0.1,-1.08l-1.36,-0.44l-4.18,0.47l-1.75,0.64l-1.21,0.08l-3.76,-0.81l-2.61,-2.94l-1.38,-3.12l-0.08,-1.08l-0.46,-0.45l-0.69,-2.88l-1.15,-1.48l-0.4,-1.33l-0.8,-0.6l-1.4,0.31l-0.27,0.35l-0.25,-0.04l-0.15,-0.74l-1.25,-0.46l-1.76,1.04l-1.53,-0.93l-1.41,0.65l-1.97,0.21l-0.21,-0.45l-1.66,-0.77l-1.13,0.12l-0.46,-0.75l-0.83,0.19l-0.75,-0.69l-2.8,-0.59l-1.39,-1.42l-1.64,1.0l-1.12,-0.34l-0.29,0.52l0.37,1.13l-0.18,0.81l1.8,1.59l0.03,1.28l-0.74,1.13l-0.76,0.21l-0.6,-0.51l0.42,-1.45l-0.66,-1.82l-1.23,-0.38l-0.78,0.2l-0.8,1.37l-0.0,2.41l-0.88,0.55l-0.15,1.63l-0.55,0.23l-0.51,2.34l-1.08,0.6l0.52,-2.06l0.92,-1.46l-0.04,-0.53l-0.43,-0.37l-5.21,2.26l-0.74,1.43l0.37,1.11l-1.51,3.72l-1.04,0.36l-0.33,0.8l-1.45,0.94l-2.12,-0.31l-1.54,0.55l-0.74,-0.45l-0.91,-1.45l-0.86,-0.4l-5.03,0.53l-0.6,-0.37l-1.81,0.36l-0.87,-1.51l0.09,-0.61l-0.87,-0.58l-2.52,1.18l-2.39,1.81l-1.71,0.43l-1.39,-0.23l-0.36,-0.67l-1.14,-0.19l0.07,-0.57l-0.7,-0.89l-2.68,-1.04l-0.66,-1.62l-0.66,-0.48l-2.73,0.25l-0.49,0.74l0.11,0.94l-0.39,0.19l-0.83,-1.63l-0.03,-1.17l-0.45,-0.95l-0.59,-0.29l-1.87,-0.0l0.82,-0.28l0.26,-0.4l-0.3,-0.8l-2.92,-1.0l-1.16,-0.73l-3.39,-0.36l-1.63,0.22l-0.83,0.29l-0.54,0.96l-3.01,0.33l-0.49,-1.51l-0.59,-0.6l-4.31,-0.55l-0.17,-0.66l-0.57,-0.45l-2.28,0.08l-1.11,-0.46l-1.15,-1.26l0.09,-1.93l-0.93,-4.52l-0.23,-2.72l-1.22,-0.94l-2.44,-0.45ZM472.71,752.99l-0.12,0.04l-0.06,-0.0l0.02,-0.03l0.17,-0.01ZM478.59,747.88l0.15,0.64l-0.47,0.42l-0.49,-0.12l0.81,-0.94ZM477.23,749.43l-0.4,0.46l-0.17,0.72l0.06,-0.73l0.51,-0.46ZM617.39,818.97l1.96,-1.47l0.57,-0.1l0.18,0.8l0.76,0.04l0.5,-0.3l-0.01,-0.69l1.66,-0.66l-0.41,1.69l0.39,0.57l1.51,-0.3l-0.57,1.2l0.09,0.52l0.4,0.19l-1.15,0.86l-0.53,-0.19l0.4,-0.95l-0.17,-0.45l-0.93,0.43l-0.54,-0.54l-0.8,0.06l-1.84,0.67l-0.64,-0.34l-0.07,-0.75l-0.75,-0.29ZM624.98,820.15l0.01,-0.01l0.01,0.0l-0.02,0.01ZM625.55,816.29l-0.88,0.97l-0.46,0.08l0.55,-0.73l0.8,-0.31ZM540.65,627.23l-0.07,-0.12l0.08,-0.1l0.01,0.05l-0.02,0.17ZM631.49,815.38l-0.36,-0.28l0.23,-0.45l0.55,-0.02l-0.42,0.76ZM627.3,816.03l0.76,-0.4l0.07,-0.04l-0.19,0.32l-0.64,0.12ZM581.92,801.51l0.01,-0.5l0.57,0.08l-0.37,0.17l-0.22,0.24ZM582.54,809.21l0.08,-0.02l-0.04,0.08l-0.05,-0.06ZM575.98,691.9l1.12,-1.08l0.85,7.33l-1.08,-0.7l-0.91,-1.5l0.4,-2.7l-0.38,-1.35ZM544.08,793.09l0.64,0.68l0.69,-0.74l0.82,0.42l0.64,-0.7l0.82,-0.2l0.0,1.02l0.75,0.43l0.23,0.62l0.6,0.21l0.7,-0.36l0.45,0.45l0.58,-0.27l0.5,0.81l-1.53,-0.59l-2.46,0.08l-0.84,-0.54l-3.09,-0.53l0.04,-0.61l0.44,-0.17ZM551.8,795.48l0.54,-0.33l0.22,-1.0l-0.92,-0.74l0.51,-0.53l0.2,0.27l0.44,-0.15l0.37,-0.71l1.04,-0.37l0.21,0.71l0.84,0.06l1.09,1.55l0.72,-0.51l0.42,-1.47l1.23,-0.76l0.44,0.27l-0.0,1.0l1.05,0.28l-0.19,1.49l1.03,1.15l-0.71,0.35l-2.15,2.25l-0.45,-0.55l-1.03,-0.07l-0.86,-0.45l-0.34,-0.52l-2.37,-0.45l-1.33,-0.75ZM561.38,795.5l0.14,-1.12l0.31,-0.89l0.37,-0.6l-0.5,1.08l0.43,0.57l1.05,-0.18l-0.09,0.36l-2.12,3.83l-0.58,0.22l-0.22,-0.27l1.92,-2.1l-0.14,-0.72l-0.57,-0.18ZM561.46,799.85l0.39,-0.41l0.14,-0.08l-0.3,0.47l-0.22,0.02ZM559.12,790.23l0.46,-0.13l0.58,0.12l-0.77,0.13l-0.27,-0.12ZM549.83,792.88l0.11,-0.31l0.76,-0.11l-0.14,0.31l-0.72,0.11ZM540.38,793.88l0.61,-1.05l0.4,-0.17l0.82,0.55l-0.62,1.12l-1.21,-0.46ZM532.26,787.83l1.6,-0.01l1.59,1.01l-0.18,0.7l-0.88,0.31l-0.15,0.99l-1.53,-1.95l-0.45,-1.06ZM508.42,762.98l0.75,-0.68l1.29,-0.13l1.11,0.39l-0.97,0.41l-2.18,0.01ZM486.18,744.42l0.13,-0.01l0.53,0.92l-0.33,0.05l-0.33,-0.95ZM482.14,744.75l1.2,-0.66l1.87,0.08l-0.46,1.02l-1.2,-0.05l-1.18,0.8l-0.23,-1.19ZM469.8,755.19l0.19,-0.21l0.18,-0.01l-0.36,0.23Z",name:"Ontario"},"CA-AB":{path:"M139.75,606.41l0.38,-0.39l-0.02,-0.65l1.18,0.57l0.81,-0.56l-0.36,-1.98l-0.93,-0.51l0.38,-1.01l-0.68,-0.55l0.01,-0.33l37.32,-108.88l22.35,7.31l22.92,6.81l23.1,6.18l22.87,5.45l-44.18,197.52l-23.74,-5.6l-21.73,-5.63l0.08,-0.8l-0.96,-1.24l0.17,-0.95l-0.81,-1.03l-1.42,-0.63l0.23,-0.86l-0.52,-0.39l-0.17,-1.26l-0.89,-1.31l0.8,-2.77l-1.36,-0.54l-0.36,-0.46l0.84,-0.39l1.4,-2.48l-0.07,-2.44l0.13,-0.54l0.67,-0.45l0.24,-1.71l-0.41,-1.28l0.52,-4.26l-0.64,-1.2l-0.83,-3.13l-1.24,-1.02l-1.26,0.24l-0.48,-1.21l0.36,-0.7l-0.28,-1.21l-0.72,-0.4l-1.19,-1.57l-0.23,-0.8l-0.55,-0.38l0.84,-0.16l-0.02,-1.71l-1.21,-1.73l-0.1,-0.81l-1.92,-1.32l-0.23,-0.43l0.28,-1.29l-0.17,-0.62l-0.92,-0.74l-0.13,-0.8l-0.83,-0.44l-0.08,-1.12l0.37,-1.35l-0.74,-1.03l0.08,-0.91l-0.53,-0.7l-0.09,-0.87l-0.74,-0.79l0.15,-1.06l-0.35,-2.08l-1.26,-0.33l-1.17,0.69l-0.24,0.56l-0.62,-0.25l-0.14,-3.71l-1.62,-3.01l0.14,-2.56l-0.41,-0.29l-0.84,0.64l-1.09,-0.63l-1.03,-0.0l-0.4,-1.01l-0.81,-0.6l-0.28,-1.09l1.11,-0.63l0.48,-1.28l-0.31,-0.63l-1.56,-1.12l-0.59,-1.12l-0.67,0.05l-0.69,1.15l-1.39,-0.1l-0.07,-0.72l0.77,-0.54l-0.52,-1.06l0.22,-0.72l-0.41,-1.19l0.77,-0.81l-0.14,-1.64l-0.53,-0.78l0.37,-1.01l-0.53,-1.4l-1.3,-0.18l-0.07,-1.34l0.38,-1.17l-0.69,-1.05l0.31,-0.71l-0.69,-1.67l-1.29,-1.58l-0.74,0.2l-0.57,1.02l-1.63,-1.38l-0.38,-1.59l0.04,-1.64l-2.21,-1.16l-0.68,0.12l-0.5,-0.76l-0.25,-2.18l-0.69,-0.43Z",name:"Alberta"}},height:867.2308867877658,projection:{type:"lcc",centralMeridian:-90},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","ch_mill",{insets:[{width:900,top:0,height:497.64536275046987,bbox:[{y:-5769822.077045524,x:663222.5452325371},{y:-5491965.667990425,x:1165730.52956792}],left:0}],paths:{"CH-SO":{path:"M340.89,78.89l8.38,4.47l1.01,1.24l-2.2,3.11l-2.13,1.45l-0.49,0.75l-0.34,4.14l-0.58,1.98l-1.55,1.66l-7.35,1.98l-0.31,0.35l-0.18,2.18l0.53,3.39l1.13,3.25l0.91,0.93l1.21,0.39l6.96,-0.56l4.86,1.01l4.14,1.89l4.83,3.53l5.48,1.59l0.47,-0.24l0.7,-1.7l3.05,-4.49l2.36,-1.34l4.09,-1.01l1.57,-1.01l4.85,-1.89l1.39,-1.98l1.06,-2.54l4.86,-0.28l4.28,-1.02l3.98,-2.49l1.27,-1.62l-0.2,-1.37l-1.23,-1.85l-0.33,-1.26l1.86,-3.99l2.64,0.41l1.59,1.65l0.29,0.68l0.09,3.56l1.39,0.94l0.82,3.32l1.0,1.32l1.87,1.54l2.03,0.97l2.21,0.54l0.2,4.4l-1.39,2.75l-2.28,2.97l-2.67,5.37l-2.8,1.44l-12.57,-1.64l-3.52,-0.8l-8.91,7.03l-5.44,8.94l-1.37,1.49l-6.68,1.41l-2.03,-0.55l-3.81,1.23l-5.34,-0.23l-2.18,-1.2l-6.71,-6.94l-0.43,-0.1l-7.16,2.76l-13.27,1.42l-0.24,0.68l2.78,2.87l0.83,2.64l0.26,2.14l3.71,3.86l3.69,1.49l3.12,3.96l3.81,6.38l0.3,1.28l-0.72,1.37l-2.52,1.41l-1.21,1.59l-1.96,1.73l-1.05,0.15l-9.06,-0.24l-5.26,-3.14l-2.69,0.34l-2.84,2.39l-5.21,6.56l-2.79,2.16l-5.28,2.11l-0.82,0.82l-0.04,1.52l1.29,3.3l-0.13,1.25l-0.58,0.69l-1.16,0.62l-3.32,0.97l-1.54,-3.02l-0.15,-2.2l-0.76,-0.48l-7.44,1.65l-0.55,-0.23l-1.04,-0.75l-2.38,-3.96l0.05,-1.42l3.81,0.2l2.12,0.46l4.52,-0.91l1.61,-0.81l0.37,-1.51l-0.39,-2.43l0.32,-1.05l1.16,-1.5l2.04,-1.46l2.63,0.75l1.69,-0.32l2.33,-1.46l0.64,-1.76l-2.22,-2.17l-0.71,-4.29l-0.46,-0.34l-3.19,0.57l-2.54,1.57l-1.75,0.45l-4.39,4.14l-1.48,0.7l-1.94,0.3l-1.1,-0.23l-0.16,-1.93l-1.88,-3.73l-1.18,-0.78l-3.04,-1.13l-0.52,-0.57l-2.19,-4.23l0.38,-0.88l14.79,-5.72l0.24,-0.49l-0.45,-1.5l3.94,-2.89l4.5,-1.59l4.14,-3.53l2.99,-1.85l6.48,-1.79l1.96,-1.16l1.34,-1.41l1.87,-4.27l1.88,-0.36l0.52,-2.14l-0.51,-2.34l-0.66,-0.87l-0.71,-0.62l-1.44,-0.34l-3.1,-2.22l-1.83,-2.62l-1.78,-1.16l-1.87,-0.54l-5.24,-0.26l-9.06,-1.99l2.63,-3.55l2.5,-0.48l1.29,0.2l3.36,1.66l3.52,0.46l1.89,-0.44l1.55,-0.84l2.32,-3.63l0.62,-0.46l7.43,-0.92l0.53,-0.7l-0.63,-2.04l0.12,-1.12l5.27,-0.61l2.78,-2.41l2.31,-5.82l-0.85,-1.79l-2.69,-1.14l1.02,-2.28l1.38,-0.26l5.34,0.48l1.16,-0.63l0.46,-0.64l0.09,-0.86l1.11,0.07ZM305.81,77.03l2.71,-0.28l5.24,1.51l0.72,1.4l0.12,6.29l-12.28,2.22l-3.0,-0.06l-1.21,-2.89l-0.21,-4.83l1.22,0.64l2.87,0.25l3.11,-2.43l0.72,-1.8ZM292.36,89.43l1.58,1.78l2.81,0.48l2.13,3.04l0.04,1.26l-2.68,1.59l-10.62,0.35l0.68,-4.39l3.56,-1.29l2.51,-2.83Z",name:"Solothurn"},"CH-LU":{path:"M439.6,141.66l-0.79,0.31l-0.42,0.54l1.06,2.39l1.76,1.26l1.42,0.55l1.97,-0.14l3.55,-2.27l4.53,-6.95l0.9,-2.04l3.18,-3.21l3.14,-0.28l3.14,1.12l1.09,0.89l1.03,1.35l1.45,4.57l1.52,2.91l6.65,16.4l2.96,4.27l2.61,2.49l2.57,1.09l5.74,0.23l2.36,3.29l3.72,1.14l0.96,2.29l-5.81,3.03l-1.23,1.03l-0.68,1.05l-0.55,3.09l-2.5,2.53l-0.29,1.04l0.4,1.55l1.22,1.36l2.2,1.03l3.26,-1.17l7.78,1.76l7.54,6.01l1.24,1.87l-1.22,2.9l-6.14,2.81l-0.96,-1.56l-2.75,-2.26l-3.01,-0.59l-2.09,1.57l-0.28,1.17l-1.67,0.46l-6.39,-0.12l-0.44,-1.04l-2.51,-1.12l-3.04,1.32l-4.19,1.25l-4.77,-0.49l-2.55,0.38l-4.9,-0.02l-3.41,0.61l-3.88,1.17l-1.35,0.86l-0.65,1.27l-0.16,1.13l0.73,1.62l-10.49,0.87l-3.5,1.95l-0.62,1.14l0.94,3.35l-0.26,1.04l-3.97,3.19l-4.68,5.14l-0.81,0.04l-0.9,-1.0l-1.85,-0.04l-1.07,0.35l-1.02,0.74l-2.14,3.1l-0.78,1.95l-0.7,3.54l-3.92,8.17l0.64,2.84l1.0,1.86l0.99,3.68l-3.01,4.14l-4.0,-0.21l-6.42,2.66l-1.42,0.23l-1.04,-0.25l-2.53,-2.66l-2.43,-3.23l-13.16,-9.1l-2.96,-2.79l-0.11,-1.92l-1.78,-4.85l0.27,-0.94l1.87,-1.66l0.69,-1.58l0.15,-1.92l-0.43,-3.02l0.31,-2.27l3.76,-1.78l2.02,0.25l1.18,-0.2l1.08,-0.73l1.32,-2.32l1.08,-0.73l0.44,-0.65l0.43,-2.32l1.46,-2.1l1.29,-3.48l1.3,-5.82l-0.32,-0.48l-4.18,-0.75l-1.56,-1.05l-4.95,-0.39l-0.76,-3.97l-4.04,-5.08l-0.44,-1.62l0.0,-1.48l0.63,-5.1l0.0,-5.01l0.36,-2.54l0.59,-1.61l1.64,-2.76l-1.72,-7.59l-0.05,-2.64l-0.65,-2.0l-6.9,-13.49l11.63,-2.04l4.63,-0.02l5.19,-1.62l1.14,-0.87l0.38,-0.91l-0.14,-5.1l0.26,-0.67l0.67,-0.09l4.17,-0.08l2.87,1.03l4.38,7.46l0.47,0.18l13.52,-4.53l2.96,2.63l3.99,1.13l5.45,0.19l1.51,0.53Z",name:"Lucerne"},"CH-SH":{path:"M526.25,35.82l-2.09,-0.73l-2.9,-0.41l-9.69,1.42l-8.73,4.3l-3.37,0.12l-4.01,-1.96l-5.09,-3.33l-3.79,-1.03l1.11,-2.59l-0.49,-2.16l-0.82,-1.83l0.2,-1.62l1.81,-1.78l4.99,-2.35l2.2,-1.75l1.63,-5.24l0.89,-1.78l2.62,-3.31l1.4,-0.71l2.2,0.04l10.74,-1.84l3.1,-1.34l0.2,-0.53l-1.69,-3.65l2.73,-1.34l4.8,0.23l3.42,1.32l0.46,4.93l0.7,3.08l2.13,1.5l0.41,0.01l2.67,-1.67l1.01,-5.4l1.55,-1.39l2.24,0.64l1.82,2.37l1.58,2.96l1.73,2.18l2.06,0.4l2.28,-0.38l1.69,0.28l1.13,2.2l-3.06,4.15l-0.71,2.06l0.85,2.07l1.6,1.73l0.86,3.48l0.39,0.31l10.53,-0.13l0.37,-0.25l-0.09,-0.44l-1.44,-1.39l1.61,-4.46l4.98,0.19l6.4,3.2l4.46,3.62l-2.84,0.57l-0.32,0.4l0.02,1.76l0.8,0.87l-3.48,-1.6l-2.47,0.8l-1.93,-0.72l-0.36,0.23l-2.31,4.79l-1.29,1.25l-0.71,0.44l-2.29,0.34l-2.31,1.64l-1.1,0.36l-8.02,-0.27l-2.95,-1.18l-1.95,-2.88l-0.32,-3.9l0.63,-3.83l-0.39,-0.46l-8.61,-0.2l-1.94,1.55l-1.42,2.3l-3.36,2.72l-2.67,3.04ZM517.99,52.38l1.93,1.73l2.53,-0.73l-2.39,5.43l-1.41,1.79l-0.43,0.04l-0.54,-0.17l-1.64,-1.9l-2.06,-1.54l0.14,-1.46l3.86,-3.2Z",name:"Schaffhausen"},"CH-SG":{path:"M702.16,76.88l4.04,2.88l4.77,-1.25l6.82,-4.75l5.94,7.73l7.54,3.02l5.51,4.17l-0.16,10.42l-1.87,3.71l-7.77,8.48l-2.69,8.38l-6.8,7.06l-9.71,14.17l-3.48,8.59l-0.48,8.78l1.53,4.17l2.18,3.68l1.63,3.94l0.1,5.2l-1.81,3.21l-3.0,2.66l-2.37,2.74l0.16,3.61l1.54,4.35l2.24,4.25l6.94,10.43l-2.26,0.88l-1.02,0.96l-1.33,3.41l-1.78,1.2l-1.14,1.2l-2.44,4.23l-0.62,2.99l-0.12,2.47l-0.53,1.28l-2.53,3.85l-2.64,0.95l-0.53,1.87l-1.59,0.01l-2.2,-1.44l-4.19,-1.81l-26.72,-3.37l-1.92,0.43l-0.55,-0.13l-2.93,-2.98l0.37,-2.15l-0.22,-1.11l-1.56,-3.07l-0.74,-2.9l0.57,-1.45l0.93,-7.36l-0.33,-1.86l-0.87,-2.22l-2.7,-4.77l-1.74,-2.0l-1.86,-1.1l-3.01,0.53l-2.22,0.96l-3.59,0.34l-1.19,-0.29l-3.5,-1.84l7.34,-4.75l1.13,-3.62l0.99,-11.99l-0.33,-0.43l-20.93,-3.53l-2.94,-1.45l-10.43,-8.17l-1.59,-0.09l-2.96,1.38l-5.08,-4.41l-1.21,-1.99l0.68,-4.39l-0.29,-0.48l-6.36,-1.66l-18.73,1.62l-10.32,-1.57l2.48,-5.26l3.47,-2.35l8.06,0.97l2.68,-0.19l11.98,-4.79l1.86,-1.45l1.0,-1.26l-0.06,-2.21l1.03,-1.43l1.44,-1.66l3.87,-3.27l0.66,-1.31l-1.72,-7.35l-5.21,-8.02l1.53,-0.21l1.64,-1.89l2.76,-4.3l1.99,-2.04l2.85,-5.1l0.66,-0.2l1.52,0.23l2.72,-1.01l2.4,-0.35l0.87,-0.45l0.52,-0.78l-0.13,-4.53l-5.63,-3.68l-0.51,-1.74l0.5,-0.86l2.97,-0.81l1.74,-1.55l0.5,-0.12l2.78,0.52l3.93,-0.39l1.3,1.46l0.78,0.23l2.58,-0.24l2.46,0.57l2.58,-0.01l3.36,-0.45l1.81,-0.9l2.5,-3.41l2.76,2.77l6.53,2.69l11.4,1.94l2.75,-1.4l2.83,0.25l1.47,-0.43l1.08,-0.68l0.85,-1.08l1.26,-2.83l-1.29,-4.32l-1.58,-0.2l-2.34,0.58l-1.98,-0.24l-0.49,-0.52l1.26,-0.04l1.88,-1.42l1.16,-0.37l3.4,-0.5l1.07,-0.83l1.77,-0.58l2.57,-0.07l1.65,2.26l-0.08,1.73l-0.62,1.3l0.53,1.64l4.52,5.01l1.73,1.23l1.41,0.48l0.47,-0.18l1.32,-2.27l9.89,-6.41l1.51,0.86l-0.77,2.02l0.61,1.21l2.85,0.99l3.06,-0.8ZM673.5,139.2l2.49,1.56l3.14,1.38l3.21,0.41l5.82,-1.89l3.9,-1.73l2.99,-1.87l2.83,-2.74l3.95,-6.41l3.4,-14.39l-1.34,-3.94l1.0,-6.02l5.13,-1.72l2.39,-0.32l3.06,1.18l8.51,-4.55l0.21,-0.41l-0.33,-2.25l0.31,-1.71l4.92,-4.41l-0.2,-0.7l-8.1,-1.2l-3.03,-1.03l-2.57,-1.65l-2.76,-0.82l-0.8,0.06l-1.3,0.59l-4.14,3.22l-9.93,3.83l-3.97,1.0l-1.34,1.79l-0.98,2.82l-1.05,1.01l-2.23,0.6l-4.41,-0.05l-16.11,2.59l-3.26,-0.91l-8.58,0.91l-2.09,-0.14l-1.75,2.29l-3.43,5.96l-2.82,2.58l2.59,4.83l0.43,0.19l2.65,-0.41l0.6,0.81l-1.41,2.03l-1.27,1.17l-0.48,1.17l-0.14,1.83l1.34,5.45l-2.16,2.22l-0.0,0.56l1.48,1.52l1.02,0.54l1.88,0.47l9.87,1.11l6.05,2.88l2.29,1.41l1.34,0.0l3.19,-0.73Z",name:"Sankt Gallen"},"CH-UR":{path:"M593.4,222.69l2.81,4.54l0.47,1.52l0.03,3.8l-0.74,1.19l-1.23,0.92l-4.18,1.49l-2.23,0.29l-6.68,4.58l-0.52,2.0l0.3,5.85l-2.01,2.29l-2.18,1.04l-1.37,1.26l-2.75,0.74l-0.78,0.74l-0.24,5.17l-1.78,1.94l-1.65,2.46l-0.31,1.06l0.17,2.12l-0.53,0.66l-3.44,0.89l-3.88,-0.98l-3.49,1.06l-2.16,1.93l-4.59,5.17l-1.84,0.9l-2.03,0.39l-3.25,1.25l-1.46,1.09l-0.8,1.14l0.11,1.72l-0.4,2.12l-1.45,2.87l-1.4,3.93l-0.17,1.59l0.27,1.5l1.05,1.9l2.41,1.36l0.42,0.68l1.44,4.93l-0.54,3.1l-7.98,2.99l-17.37,-3.44l-2.47,0.11l-1.64,0.44l-1.23,1.2l-2.81,6.93l-6.27,4.55l-7.58,-3.56l-2.96,-3.99l-2.62,-6.01l-0.06,-2.46l2.1,-6.79l0.54,-5.32l-0.88,-2.0l-1.61,-0.74l-0.58,-3.03l-0.86,-2.07l-0.06,-2.74l0.74,-0.74l1.06,-0.12l3.24,0.73l1.76,0.08l1.45,-0.31l0.92,-1.09l0.6,-4.03l-0.57,-3.51l-2.06,-4.49l0.02,-3.3l1.6,-3.26l6.56,-1.93l0.62,-2.7l-0.69,-2.71l-1.14,-0.86l-0.34,-0.75l0.8,-1.41l1.58,-4.96l1.03,-1.69l2.09,-2.19l0.32,-0.95l-0.51,-1.09l-0.78,-0.62l-2.5,-0.77l-1.74,0.13l-0.76,-4.62l0.38,-1.7l-0.31,-1.81l-1.98,-3.04l0.08,-0.55l3.58,-2.3l10.13,-4.51l3.27,-2.76l0.69,-1.14l2.75,-7.46l0.29,-1.37l-0.22,-1.23l5.3,-0.25l1.5,0.66l1.01,4.28l0.95,2.45l2.71,1.55l5.99,1.7l1.61,0.21l4.46,-0.26l0.81,0.31l0.48,0.58l1.0,2.8l1.45,1.87l1.38,0.49l1.58,-0.46l3.94,-2.35l5.1,-1.75l2.37,1.37l1.89,0.28l5.56,-0.12l1.19,0.42l0.44,0.71l0.05,2.42l1.8,2.04l1.28,0.19l1.03,4.77l0.91,0.68l1.18,-0.18l1.41,-1.17l5.85,-2.24l8.68,-4.27Z",name:"Uri"},"CH-NE":{path:"M178.38,161.36l4.02,1.88l2.17,2.51l1.61,3.43l0.2,0.94l-0.2,1.56l-0.79,3.14l-1.31,1.51l-0.55,1.97l0.08,1.7l0.41,0.38l31.89,-8.38l0.11,2.98l0.31,0.38l2.71,0.62l5.71,2.78l1.48,1.1l0.64,1.06l-1.02,0.7l-0.29,0.59l0.92,3.84l-0.19,2.13l-4.05,2.59l-4.42,1.61l-0.9,0.9l-0.71,1.32l-1.07,4.13l-2.77,6.2l-50.41,35.99l-3.41,-6.87l-0.35,-1.55l-0.07,-3.94l-0.72,-1.45l-1.6,-1.11l-1.0,-1.19l-0.47,-1.36l0.44,-2.46l-0.65,-3.11l-0.58,-0.27l-11.76,6.14l-5.32,3.87l-3.01,1.71l-6.04,1.77l-9.72,4.47l-2.78,1.89l-1.94,0.85l-11.91,0.7l-2.98,0.45l0.45,-1.03l0.33,-3.48l-0.65,-2.91l-2.69,-4.46l-0.76,-2.11l2.87,-8.54l9.49,-4.75l21.42,-5.82l13.42,-8.8l4.65,-5.77l0.04,-0.43l-2.28,-4.46l2.52,-3.76l1.77,-1.51l4.93,-1.53l0.93,-1.7l3.46,-1.63l0.24,-0.39l-0.23,-4.0l5.81,-1.78l12.46,-9.94l2.11,0.69Z",name:"Neuch\xe2tel"},"CH-BS":{path:"M337.13,63.59l-0.03,3.8l-0.95,0.97l-3.22,-1.92l-1.27,-1.23l-1.02,-0.37l-1.39,0.32l-3.28,1.9l-1.73,-1.26l-0.82,-1.07l-3.72,-0.58l-6.54,-3.9l5.25,-2.63l7.09,-2.3l10.13,-2.61l3.83,-0.34l-2.33,5.64l-1.93,1.6l-5.07,-0.04l-0.39,0.31l0.23,0.45l7.18,3.26Z",name:"Basel-Stadt"},"CH-JU":{path:"M176.99,160.06l3.74,-5.32l5.73,-5.09l13.52,-8.55l0.18,-0.39l-0.79,-6.19l1.23,-4.99l3.56,-3.16l3.02,-0.68l2.85,-3.33l1.97,-0.99l2.1,-0.51l1.88,-1.03l1.7,-2.93l-0.04,-0.45l-2.15,-2.63l-5.97,-4.43l-4.0,1.46l-23.08,1.96l0.8,-2.62l2.43,-3.88l2.88,-3.24l5.07,-2.57l0.51,-4.79l5.04,-0.98l3.3,-1.64l3.06,-2.27l1.56,-2.48l-1.01,-3.09l-2.02,-3.44l-0.42,-2.38l3.35,-0.88l1.83,-1.21l1.63,-0.36l1.66,0.36l1.92,1.22l5.17,0.65l9.98,-1.48l4.58,0.82l2.67,1.3l2.75,0.37l4.71,-0.41l-3.3,6.54l1.11,4.42l4.53,2.48l5.87,1.59l2.22,2.4l1.55,0.56l1.55,-0.22l7.58,-2.83l5.2,-0.94l5.31,0.2l1.17,1.14l8.29,3.57l5.29,3.68l1.3,1.8l0.29,1.92l0.9,0.85l0.8,0.34l2.12,0.01l9.65,2.12l5.36,0.27l1.52,0.45l1.55,0.98l1.91,2.71l2.79,2.0l-2.84,2.28l-0.62,2.07l0.16,0.8l0.91,0.67l3.05,0.37l-11.59,2.84l-21.7,-1.51l-1.73,-0.63l-1.06,-2.05l-0.78,-0.36l-0.87,0.53l-0.48,1.19l-1.71,1.67l-1.61,0.61l-5.54,3.59l-5.05,1.57l-3.01,0.55l-3.73,0.19l-16.77,-2.93l-0.46,0.32l-0.49,2.58l0.31,1.16l-0.29,0.73l-2.69,1.92l-0.52,0.93l-0.09,1.64l0.69,2.64l-0.72,0.62l-9.65,1.57l-6.18,-0.49l-1.59,0.3l-0.93,0.89l-0.82,2.32l-3.78,5.12l-2.05,1.77l-5.04,2.6l-2.13,1.85l-1.92,0.33l-4.67,-0.11l-2.37,1.14l-7.13,4.76l-2.16,1.11l-1.36,0.31l-3.36,-2.34l-5.43,-0.36l-1.62,-0.53Z",name:"Jura"},"CH-BL":{path:"M286.35,98.71l10.0,-0.33l3.32,-2.08l-0.04,-1.8l-1.93,-2.94l-0.64,-0.6l-2.73,-0.44l-1.44,-1.7l0.97,-1.15l0.64,-2.56l-0.41,-1.59l-2.55,-3.23l-0.01,-1.13l1.92,-0.48l3.61,1.25l0.26,5.49l0.98,2.64l0.78,0.85l3.33,0.06l12.66,-2.29l0.33,-0.4l-0.12,-6.71l-0.92,-1.87l-5.66,-1.72l-3.02,0.28l-1.88,-2.87l0.16,-0.49l0.88,-0.41l2.12,0.35l1.84,-0.64l0.92,-1.66l-0.06,-2.53l-4.06,-2.42l6.83,-4.81l6.92,4.1l3.8,0.64l0.56,0.89l2.01,1.47l0.44,0.02l4.34,-2.24l0.82,0.29l2.68,2.22l2.06,1.06l0.47,-0.08l1.38,-1.57l0.03,-3.61l2.46,1.09l4.39,0.5l8.71,-1.54l7.85,3.45l0.95,0.15l0.92,0.66l0.04,2.63l0.48,1.54l0.94,1.07l2.89,-0.42l5.02,-3.93l0.64,-0.94l0.25,-2.42l0.2,-0.84l0.35,-0.25l1.03,-0.15l2.64,0.66l1.49,1.77l1.14,0.78l0.92,1.71l5.79,7.57l0.85,2.05l2.0,1.23l5.74,0.53l0.03,3.23l0.43,1.67l2.38,1.46l-1.91,4.18l0.39,1.64l1.26,1.92l0.09,0.89l-1.02,1.14l-3.67,2.31l-4.12,0.98l-4.06,0.06l-1.13,0.3l-2.43,4.53l-4.79,1.87l-1.5,0.98l-4.18,1.04l-2.48,1.42l-3.26,4.73l-0.62,1.49l-5.01,-1.45l-4.76,-3.49l-4.34,-1.97l-5.07,-1.04l-6.94,0.55l-1.41,-0.85l-1.38,-4.53l-0.05,-3.6l7.41,-2.08l1.76,-1.95l0.63,-2.22l0.25,-3.84l0.81,-0.92l1.7,-1.11l2.41,-3.34l0.03,-0.48l-1.41,-1.73l-8.68,-4.58l-1.61,-0.1l-0.42,0.39l-0.03,0.93l-0.96,0.84l-5.26,-0.47l-2.04,0.55l-1.27,2.84l0.21,0.53l2.93,1.24l0.49,1.14l-2.21,5.39l-2.27,2.01l-4.39,0.32l-1.19,0.41l-0.42,1.77l0.53,2.04l-7.38,0.92l-0.98,0.77l-2.1,3.39l-1.33,0.73l-1.76,0.41l-3.11,-0.41l-3.35,-1.66l-1.68,-0.26l-2.97,0.68l-2.97,4.0l-1.87,-0.01l-1.03,-0.66l-0.36,-2.03l-1.39,-1.93l-4.49,-3.15ZM284.82,97.78l-7.82,-3.36l-0.53,-0.38l7.52,0.28l1.45,-0.47l-0.61,3.94Z",name:"Basel-Landschaft"},"CH-SZ":{path:"M604.0,160.14l-3.74,10.38l-0.59,4.25l-1.34,2.27l0.39,3.53l-0.17,1.69l-1.92,3.41l-1.54,2.02l-1.67,1.62l-4.88,2.0l-2.32,1.48l-1.12,3.01l0.13,0.44l2.75,2.18l5.49,6.84l-0.47,0.88l-0.0,0.98l0.93,1.55l1.1,1.0l3.11,1.83l0.68,1.01l0.31,1.42l-1.65,6.09l-13.06,6.21l-5.89,2.25l-1.34,1.14l-0.61,0.16l-0.47,-0.29l-0.43,-1.31l-0.27,-2.9l-0.46,-0.77l-1.41,-0.27l-1.02,-0.98l-0.5,-0.75l-0.02,-2.36l-0.8,-1.12l-1.39,-0.49l-5.74,0.1l-1.7,-0.25l-2.63,-1.4l-5.38,1.82l-3.94,2.34l-1.16,0.4l-0.93,-0.28l-1.33,-1.72l-0.94,-2.69l-0.82,-0.96l-1.16,-0.41l-5.9,0.09l-5.94,-1.68l-2.41,-1.38l-1.82,-6.56l-2.01,-1.03l-6.03,0.26l-14.25,1.63l-4.1,-2.48l6.1,-2.89l1.38,-3.28l-1.46,-2.52l-7.87,-6.23l-7.99,-1.81l-3.14,1.18l-1.96,-0.92l-0.96,-1.12l-0.26,-1.17l0.21,-0.62l2.51,-2.57l0.58,-3.16l0.54,-0.8l1.01,-0.84l10.01,-5.29l3.22,0.57l3.37,6.57l0.39,0.22l10.22,-0.76l0.96,0.18l2.36,1.82l1.98,0.13l9.77,-2.33l2.78,-0.99l2.27,-1.49l5.58,-5.82l1.56,-3.76l3.49,-3.21l-0.07,-0.64l-3.53,-2.11l-0.35,-1.37l-1.27,-1.72l0.38,-1.81l3.03,-2.62l7.69,-4.24l8.51,-1.5l10.93,1.65l18.71,-1.62l5.78,1.53l-0.48,2.09l-0.07,2.43l1.38,2.23l5.11,4.44Z",name:"Schwyz"},"CH-BE":{path:"M285.59,124.12l21.93,1.54l11.29,-2.75l-1.21,3.09l-1.08,1.12l-1.77,1.06l-6.47,1.79l-1.47,0.77l-5.83,4.69l-4.5,1.59l-4.22,3.09l-0.15,0.44l0.42,1.42l-14.6,5.65l-0.75,1.42l2.28,4.74l0.7,0.81l4.13,1.83l1.76,3.52l-0.1,1.66l0.78,0.75l1.38,0.26l2.18,-0.35l1.73,-0.85l4.34,-4.09l1.68,-0.41l2.42,-1.51l2.64,-0.46l0.69,4.06l2.19,2.17l-0.51,1.0l-2.02,1.21l-1.24,0.24l-2.85,-0.75l-2.43,1.65l-1.32,1.69l-0.44,1.34l0.26,3.47l-1.28,0.66l-4.3,0.88l-5.7,-0.76l-0.92,0.46l-0.31,1.1l0.25,1.1l2.44,4.07l2.05,1.31l7.61,-1.62l0.18,2.15l1.73,3.39l0.47,0.2l3.76,-1.11l1.27,-0.68l0.83,-0.94l0.24,-1.8l-1.32,-3.43l-0.02,-0.84l0.51,-0.54l5.25,-2.1l2.97,-2.28l5.28,-6.63l2.66,-2.23l1.97,-0.27l5.42,3.18l9.26,0.24l1.42,-0.27l2.08,-1.84l1.23,-1.6l1.85,-0.87l1.26,-1.45l0.36,-1.09l-0.37,-1.53l-3.89,-6.51l-3.22,-4.09l-3.74,-1.53l-3.55,-3.7l-0.16,-1.9l-0.86,-2.73l-2.39,-2.54l12.5,-1.34l7.06,-2.71l6.57,6.79l2.59,1.39l5.5,0.24l3.9,-1.23l1.97,0.56l6.47,-1.36l0.65,5.17l2.63,3.92l6.06,11.69l1.66,4.09l0.04,2.58l1.69,7.47l-1.56,2.43l-0.64,1.77l-0.37,2.61l-0.0,5.02l-0.63,5.15l0.01,1.66l0.47,1.76l4.13,5.24l0.69,3.95l0.36,0.33l5.15,0.41l1.5,1.03l3.86,0.69l-1.2,5.36l-1.22,3.32l-1.5,2.18l-0.45,2.35l-1.4,1.17l-1.31,2.31l-1.68,0.64l-2.19,-0.22l-4.27,2.17l-0.39,2.67l0.43,3.07l-0.14,1.72l-0.59,1.31l-1.79,1.55l-0.46,1.37l1.81,5.17l0.22,2.17l3.15,2.96l13.13,9.08l2.31,3.1l2.66,2.8l1.43,0.41l1.83,-0.28l6.31,-2.62l10.27,0.53l3.74,0.71l8.73,5.01l3.99,1.34l8.21,-2.15l10.34,1.11l3.81,1.04l2.04,0.07l2.38,-0.79l6.65,-4.0l8.48,-2.88l6.41,4.85l1.72,-0.58l3.5,-0.45l3.46,1.07l-1.5,3.05l-0.26,1.4l0.21,2.45l1.73,3.53l0.72,3.33l0.11,1.99l-0.47,2.52l-0.54,0.75l-1.25,0.27l-4.78,-0.81l-1.4,0.14l-1.19,1.07l-0.06,3.27l0.88,2.17l0.53,2.78l-1.99,0.36l-3.86,4.2l-2.02,4.17l-1.22,3.97l-1.01,5.42l-1.76,2.54l-2.01,1.76l-5.21,3.3l-9.12,4.44l-4.72,1.46l-10.35,1.84l-1.09,0.04l-1.36,-0.54l-0.2,-1.72l-0.48,-0.45l-5.43,-0.54l-4.69,-1.79l-1.83,-1.32l-17.03,-2.82l-5.22,0.23l-6.67,3.54l-1.15,0.96l-0.1,0.82l1.25,2.06l0.27,1.38l-1.21,1.77l-12.73,7.49l-4.13,1.38l-1.74,0.26l-2.95,0.01l-2.58,-0.55l-24.21,15.25l-2.16,0.17l-13.11,-5.46l-4.46,-0.49l-1.66,0.97l-1.02,2.22l-2.68,2.01l-6.65,1.75l-4.67,2.51l-0.11,0.62l1.18,1.34l2.15,1.08l-2.35,1.82l-7.04,2.61l-2.82,0.4l-6.52,-1.76l-8.77,0.08l-3.44,0.81l-2.42,2.41l-4.46,2.68l-7.33,2.12l-2.11,-0.75l-0.14,-4.32l-0.84,-0.67l-1.3,0.02l-7.21,2.27l-0.5,0.67l-0.15,1.52l-1.43,2.09l-6.29,3.23l-0.19,-4.33l1.29,-2.13l-0.07,-1.32l-0.68,-0.82l-1.15,-0.52l-4.56,-3.7l2.18,-6.0l-0.44,-3.39l-1.22,-3.54l0.42,-0.62l3.28,-1.74l1.89,-2.22l0.71,-1.71l0.15,-1.66l-0.35,-4.22l3.05,-4.59l0.66,-2.09l0.26,-6.65l-2.17,-4.21l7.75,-5.93l5.43,-0.36l1.02,-0.42l0.9,-1.08l0.96,-5.89l-0.72,-7.25l2.03,-2.02l0.7,-0.46l5.98,1.21l2.82,-2.63l-0.27,-1.24l1.22,-8.07l-3.56,-2.71l-2.28,-0.3l-1.41,-1.73l-1.77,-1.22l-4.95,-2.09l-1.14,-2.55l-0.42,-3.6l0.12,-6.53l0.46,-3.92l2.34,-8.39l0.08,-3.78l-0.53,-2.58l-0.58,-1.12l0.13,-0.48l1.21,-0.87l0.94,0.15l0.12,0.76l0.42,0.42l0.86,0.41l1.21,0.01l3.27,-1.97l1.12,-2.44l-0.96,-5.65l-0.36,-0.33l-15.9,-1.23l-10.21,-2.54l-2.2,0.33l-1.22,-0.18l1.82,-4.24l0.23,-1.46l-0.84,-5.38l-1.62,-3.07l3.87,-2.1l2.13,-2.27l0.5,-1.03l-1.28,-1.96l-0.42,-2.02l-0.83,-0.82l-2.09,-0.42l-14.53,5.14l-15.89,1.37l-7.76,-2.71l2.68,-5.98l1.07,-4.13l0.57,-1.06l0.64,-0.69l4.43,-1.62l3.91,-2.29l0.47,-0.62l0.28,-2.58l-0.91,-3.74l1.16,-0.87l0.15,-0.69l-0.85,-1.35l-1.71,-1.29l-5.78,-2.81l-2.54,-0.59l-0.11,-3.15l-0.49,-0.38l-31.82,8.45l-0.07,-1.13l0.42,-1.65l1.42,-1.73l1.02,-5.04l-0.69,-2.41l-1.28,-2.36l-2.26,-2.61l-2.33,-1.13l3.25,0.21l3.31,2.33l1.8,-0.33l2.36,-1.2l7.13,-4.75l2.21,-1.05l4.43,0.15l2.15,-0.36l4.14,-3.09l3.26,-1.48l3.58,-3.55l2.46,-3.58l0.87,-2.4l0.62,-0.54l1.14,-0.18l6.27,0.49l10.01,-1.68l1.02,-0.87l0.11,-0.45l-0.75,-2.75l0.05,-1.21l0.3,-0.61l2.88,-2.15l0.37,-0.95l-0.3,-1.27l0.4,-2.1l16.43,2.87l3.89,-0.19l3.16,-0.57l5.18,-1.62l2.33,-1.26l3.26,-2.34l1.69,-0.65l1.91,-1.87l0.67,-1.34l1.43,2.27l1.95,0.7ZM252.79,217.72l-0.26,0.58l0.68,1.29l0.44,0.2l1.7,-0.33l0.97,-1.21l-0.06,-0.9l-0.49,-0.36l-2.97,0.73ZM321.41,121.22l-5.03,-0.3l-0.48,-0.27l-0.11,-0.53l0.41,-1.46l3.0,-2.41l1.22,0.29l0.93,1.06l0.31,0.92l0.14,1.03l-0.37,1.68Z",name:"Bern"},"CH-NW":{path:"M483.42,237.89l0.15,-2.14l-1.14,-1.56l-0.92,-0.33l-1.14,0.54l-0.88,1.39l0.04,1.11l0.69,1.26l0.65,4.1l1.14,3.17l-0.07,2.28l0.64,0.71l1.45,0.8l0.52,1.92l2.54,3.16l0.93,0.69l3.05,1.1l0.69,0.93l-5.59,1.68l-4.52,-3.49l-4.13,-2.14l-3.98,-4.74l-0.48,-5.76l0.55,-7.41l1.24,-4.09l0.0,-6.87l-0.52,-1.21l-0.99,-0.79l-4.76,-1.93l-2.01,-1.88l0.24,-1.42l2.25,-3.7l0.58,-2.7l-1.39,-1.18l-7.72,-2.02l-0.92,0.02l-3.09,1.25l-3.04,0.63l-0.77,-1.53l0.66,-1.91l0.97,-0.57l3.77,-1.14l3.35,-0.6l4.82,0.03l2.53,-0.38l4.9,0.48l4.3,-1.29l2.93,-1.27l1.82,0.93l0.19,0.73l0.64,0.48l6.7,0.11l1.98,-0.54l0.45,-1.36l1.5,-1.27l2.54,0.46l2.62,2.15l1.15,1.84l4.87,2.95l14.28,-1.55l0.22,1.09l-0.26,1.2l-2.73,7.4l-1.34,1.7l-2.26,1.8l-10.11,4.5l-3.91,2.58l-0.14,1.34l1.94,2.89l0.28,1.51l-0.39,1.85l0.76,4.61l-9.1,0.29l-1.88,-1.27l-0.91,-1.63l-1.09,-0.38l-1.08,0.09l-4.29,2.28Z",name:"Nidwalden"},"CH-ZG":{path:"M544.22,161.33l3.1,1.85l-3.16,2.91l-1.59,3.79l-5.49,5.73l-2.12,1.38l-2.61,0.92l-9.56,2.3l-1.55,-0.03l-2.42,-1.83l-1.21,-0.26l-10.12,0.74l-3.35,-6.54l-4.01,-0.8l-3.74,1.96l-1.07,-2.44l-3.74,-1.19l-2.33,-3.26l-1.47,-8.74l-1.02,-10.58l0.26,-2.11l2.12,-3.52l0.92,3.0l0.69,1.18l1.41,0.77l7.98,2.26l4.48,0.33l3.81,-1.14l5.57,-0.94l7.65,1.09l3.59,3.39l3.39,2.53l2.23,2.34l1.31,2.0l1.58,1.08l5.97,2.26l4.51,-0.46Z",name:"Zug"},"CH-FR":{path:"M170.17,307.43l0.07,-3.89l0.64,-0.54l0.13,-0.66l-0.81,-5.46l0.03,-2.9l0.54,-3.41l2.25,-0.24l3.15,-1.91l2.16,-0.41l3.13,-0.1l1.78,-0.64l-0.16,-1.27l1.07,-2.42l12.75,-15.74l0.74,-2.09l-0.13,-0.44l-3.51,-1.06l-0.63,-0.37l-0.31,-0.74l2.43,-0.62l0.99,-0.61l6.18,-7.53l-0.24,-3.68l1.08,-2.41l0.66,-0.9l2.11,-1.39l1.98,-2.1l0.75,-1.26l0.15,-0.81l-0.3,-0.59l-1.44,0.08l-1.0,-1.06l-0.47,-3.19l0.92,-2.31l-0.71,-2.06l-1.0,-0.79l-1.56,0.19l-1.07,0.65l-0.22,1.15l-0.36,0.35l-3.65,-4.13l-1.85,-1.54l-5.86,-7.13l7.03,-5.0l12.25,14.76l0.97,1.67l2.35,1.17l2.73,3.42l0.47,2.41l0.54,0.23l3.49,-1.58l1.86,-1.91l1.14,-1.92l0.89,-3.55l1.22,-1.74l0.76,0.03l0.99,0.8l0.79,-0.16l1.62,-1.54l0.51,-1.07l-0.37,-0.79l-2.28,-1.11l-4.1,-7.35l-0.75,-1.77l-1.31,-7.99l15.6,-1.34l14.58,-5.14l1.62,0.38l0.53,0.68l0.32,1.82l1.14,1.43l-0.3,0.65l-2.0,2.14l-3.54,1.81l-0.64,0.81l0.13,0.87l1.53,2.52l0.81,5.25l-0.7,2.54l-1.38,2.52l0.31,1.2l0.86,0.36l2.98,-0.34l10.23,2.54l15.63,1.21l0.89,5.22l-0.86,1.84l-2.8,1.76l-1.02,-0.01l-0.67,-0.43l-0.13,-0.87l-1.69,-0.45l-1.9,1.34l-0.18,1.06l0.59,1.1l0.51,2.48l-0.09,3.59l-2.33,8.34l-0.47,4.01l-0.12,6.63l0.46,3.78l1.34,2.88l0.77,0.57l4.34,1.64l1.65,1.13l1.5,1.8l2.3,0.32l0.95,0.94l2.26,1.38l-0.48,1.57l-0.77,6.21l0.31,0.91l-0.54,0.66l-1.63,1.49l-6.17,-1.15l-3.12,2.8l0.62,7.63l-0.83,5.5l-0.76,0.92l-0.69,0.25l-5.61,0.42l-8.07,6.18l-5.9,4.07l-11.52,3.06l-2.08,1.53l-4.54,4.91l-3.66,2.39l-5.8,0.6l-2.9,1.23l-3.51,2.59l-1.99,1.96l-1.07,1.56l-0.77,2.1l-4.12,1.74l-0.74,-0.48l-1.66,-2.84l-1.19,-4.82l-1.51,-3.17l-11.07,-7.13l-2.82,-0.95l-2.25,-0.08l-4.56,3.72l-1.62,0.71l-2.8,0.35l-2.15,-0.6l-2.16,-2.62l-1.3,-3.19l1.52,-2.67l4.42,-0.01l3.21,1.46l6.29,-6.18l1.46,-2.04l-0.16,-0.55l-0.56,-0.23l-2.25,0.44l-0.71,-0.19l-3.6,-2.8l-1.91,-0.73l-5.16,0.72l-1.47,-0.91l-1.38,-0.07l-2.46,0.76ZM254.98,218.75l-1.2,0.2l-0.3,-0.56l2.01,-0.49l-0.51,0.86ZM191.92,233.63l-2.42,0.92l-1.11,1.34l0.4,0.67l1.73,0.09l1.09,0.46l2.48,1.97l-0.04,0.55l-2.48,4.18l-1.19,6.9l0.84,1.33l1.79,-0.53l1.11,0.28l-2.21,4.32l-0.92,0.7l-1.46,0.39l-3.72,0.06l-3.78,-1.56l-2.33,0.41l-2.51,1.15l-1.52,0.19l-3.56,-1.13l-2.19,-0.35l-2.45,-1.04l0.96,-1.39l0.1,-0.94l-0.75,-0.8l-1.06,0.06l-0.73,-0.3l-2.13,-1.88l-0.66,-1.69l-0.95,-6.29l21.31,-15.24l8.36,7.17ZM185.23,266.66l-1.43,2.4l-1.39,1.16l-1.29,0.54l-5.87,-2.24l-1.63,0.49l-2.22,1.8l-2.55,0.19l-0.26,-0.55l1.52,-1.19l3.58,-1.43l1.02,-1.81l5.72,-5.95l1.74,2.17l2.8,1.16l0.85,1.6l-0.59,1.67ZM164.23,271.92l-1.13,0.89l-0.6,-0.25l-0.44,-1.48l-1.75,-2.01l0.32,-0.8l1.34,-0.13l2.82,-2.78l1.01,0.0l0.92,0.83l0.15,1.66l-0.3,1.7l-2.35,2.36Z",name:"Fribourg"},"CH-ZH":{path:"M527.06,36.11l2.39,-2.72l3.39,-2.74l1.44,-2.32l1.51,-1.31l7.99,0.18l-0.57,3.52l0.38,4.21l2.22,3.21l3.23,1.3l8.38,0.27l1.29,-0.44l2.3,-1.63l2.29,-0.34l2.16,-1.8l2.79,-1.04l0.67,2.92l2.29,2.38l0.25,0.84l-0.29,1.07l-2.3,3.54l-1.69,1.63l-1.18,1.87l-1.11,-0.11l-1.97,-1.56l-2.89,-1.26l-1.53,-0.22l-1.59,0.45l-1.32,0.91l-0.52,0.63l-0.02,0.84l2.76,3.14l2.39,0.67l12.61,5.33l1.9,2.04l-1.16,2.27l0.87,2.44l1.28,1.25l2.01,0.99l5.9,2.07l1.29,0.89l0.41,0.65l-1.31,6.55l0.21,1.56l-2.0,1.89l-0.22,1.52l0.93,2.28l1.94,1.13l1.06,5.22l1.98,1.67l1.42,0.7l-1.02,1.03l-0.73,3.03l-1.88,2.49l0.03,0.56l8.76,8.27l4.69,7.28l1.67,7.17l-1.68,2.0l-2.54,1.9l-1.55,1.77l-1.15,1.6l0.07,2.19l-0.8,1.03l-1.77,1.38l-11.65,4.66l-2.5,0.19l-8.44,-0.91l-3.82,2.65l-2.66,5.66l-8.56,1.53l-7.82,4.32l-3.2,2.78l-0.41,0.98l-0.1,1.58l1.36,1.92l0.19,0.84l-3.91,0.44l-5.75,-2.17l-1.39,-0.92l-1.29,-1.97l-2.29,-2.41l-3.41,-2.55l-3.88,-3.57l-7.96,-1.12l-5.66,0.96l-3.71,1.12l-1.98,0.01l-2.29,-0.33l-7.86,-2.23l-1.18,-0.66l-0.45,-0.87l-1.2,-3.8l-4.46,-8.16l-0.38,-1.58l2.68,-0.58l3.6,-1.94l3.72,-4.14l1.86,-2.8l0.64,-2.56l-0.49,-0.48l-5.7,1.55l-2.13,-1.99l-0.38,-0.86l0.21,-6.12l-1.02,-0.99l-3.86,-1.7l-1.49,-1.14l0.3,-1.03l5.21,-4.59l0.92,-2.58l-0.55,-1.02l-2.67,-3.04l-1.48,-3.89l-4.38,-8.04l-1.02,-3.41l0.09,-2.49l0.97,-4.68l3.26,-4.5l4.34,-3.79l4.58,-6.37l0.35,-1.42l5.27,-0.76l2.82,-5.64l5.93,-3.37l5.73,-0.5l2.9,2.34l2.5,3.56l-3.94,3.27l-0.33,2.15l2.32,1.92l1.69,1.95l1.04,0.35l0.96,-0.21l1.6,-2.06l2.57,-5.83l-0.01,-0.94l0.86,-1.37l0.37,-5.51l-0.87,-2.97l0.38,-1.16l0.57,-0.42l1.48,-0.32l0.4,1.92l1.3,0.56l0.55,-0.29l1.13,-6.01l-0.36,-0.47l-2.08,-0.26Z",name:"Z\xfcrich"},"CH-VS":{path:"M179.05,431.43l3.47,-4.26l0.14,-2.45l-3.23,-2.65l-15.66,-3.0l-1.6,-3.88l1.8,-8.4l3.44,-8.88l7.05,-11.91l-0.01,-0.43l-4.54,-6.78l-7.1,-6.56l-3.67,-5.5l0.97,-2.62l5.29,-5.44l1.42,-4.19l-0.16,-2.16l3.29,0.17l9.47,1.62l2.34,-1.12l4.1,4.58l1.19,2.0l-0.74,4.66l0.77,2.06l2.64,1.67l2.73,0.53l1.93,1.33l0.85,4.25l0.99,2.41l12.68,19.17l4.47,5.23l1.5,2.48l2.28,2.57l0.48,0.09l7.64,-3.74l6.59,-3.75l4.73,-5.08l2.33,-0.91l3.8,-3.36l2.83,-3.45l2.41,-3.67l0.78,-2.08l-0.28,-3.86l5.71,-5.51l7.03,-3.66l1.55,-2.27l0.21,-1.67l0.72,-0.49l6.37,-1.87l0.96,0.0l0.33,0.33l-0.1,3.59l0.24,0.74l2.87,1.08l7.61,-2.21l4.56,-2.74l2.74,-2.56l2.79,-0.53l8.61,-0.08l6.43,1.75l3.14,-0.42l7.18,-2.65l3.01,-2.31l-0.07,-0.68l-2.53,-1.23l-0.79,-0.91l4.09,-2.21l6.88,-1.86l2.78,-2.1l1.01,-2.2l1.31,-0.76l3.98,0.47l13.14,5.47l2.72,-0.21l24.15,-15.21l2.25,0.58l3.09,-0.01l1.87,-0.29l4.21,-1.41l12.88,-7.57l1.57,-2.35l-0.33,-1.75l-1.23,-2.14l7.28,-4.17l5.0,-0.23l16.89,2.79l1.72,1.27l4.79,1.83l5.35,0.51l0.43,2.01l1.9,0.76l11.63,-1.9l4.82,-1.49l9.24,-4.49l5.26,-3.33l2.14,-1.86l1.94,-2.78l1.06,-5.6l1.19,-3.89l1.94,-3.99l3.67,-3.98l1.91,-0.25l1.43,0.6l0.36,0.51l0.3,0.97l-0.52,5.11l-2.29,8.01l0.82,3.2l2.16,4.66l3.04,4.1l7.56,3.6l-5.46,6.38l-3.19,1.83l-4.55,0.48l-1.76,0.47l-0.81,0.66l-0.22,0.83l0.21,1.44l-1.84,3.45l-0.51,1.67l0.21,2.76l-8.22,1.55l-5.42,2.56l-4.35,3.97l-1.75,3.28l0.79,1.48l1.25,0.86l0.07,2.22l-1.12,2.14l-1.91,1.99l-2.22,1.47l-5.76,2.57l-9.77,11.19l-4.01,2.42l-8.59,1.67l-4.38,1.75l-4.06,3.55l-2.06,2.54l-0.8,2.49l0.78,1.05l4.6,3.48l5.81,9.73l0.54,8.95l-4.23,7.91l-8.59,6.48l-2.06,0.6l-4.09,0.38l-2.31,1.54l-1.47,2.7l-0.43,2.86l-0.02,2.82l-1.03,6.97l-2.43,4.71l-2.4,2.72l-1.33,0.96l-1.83,0.49l-14.28,2.84l-2.99,2.13l-2.17,3.61l-0.56,4.55l-4.09,0.34l-0.91,3.08l0.14,1.31l-0.35,0.61l-2.29,1.09l-4.65,-1.0l-5.42,0.09l-9.52,-3.03l-2.12,0.18l-3.12,0.95l-2.18,-0.65l-4.08,-5.37l-2.99,-2.42l-3.21,-1.62l-20.42,-4.46l-3.76,1.67l-3.99,5.16l-4.13,0.47l-5.94,2.24l-11.82,7.52l-6.26,1.92l-15.06,-1.37l-2.69,0.82l-5.58,3.01l-12.25,4.38l-5.96,0.97l-6.45,0.1l-6.02,-1.08l-4.53,-2.36l-8.88,-8.65l-1.34,-1.94l-1.05,-2.45l-1.41,-4.58l-2.28,-5.15l-0.71,-2.62l-1.11,-0.78l-13.47,-13.23l-4.67,-1.83l-1.95,0.59l-2.91,2.24l-1.66,-0.2l-1.53,-1.01l0.32,-1.6l-0.07,-1.74l0.28,-0.43l-0.07,-2.65l-0.53,-2.57Z",name:"Valais"},"CH-VD":{path:"M166.03,252.52l1.46,0.04l0.28,0.34l-1.13,2.03l0.51,0.76l2.56,1.06l2.22,0.36l3.09,1.12l2.36,-0.17l2.53,-1.16l2.19,-0.38l2.76,1.42l3.79,0.2l2.62,-0.56l1.34,-1.03l2.24,-4.13l0.1,-0.74l-0.69,-0.8l-1.45,-0.14l-1.28,0.54l-0.33,-0.56l1.14,-6.64l2.43,-4.06l0.14,-1.02l-0.79,-1.12l-2.08,-1.44l-1.34,-0.57l-1.35,-0.11l2.39,-1.35l1.48,0.82l0.44,-0.15l0.01,-0.46l-1.38,-1.79l-8.05,-6.85l5.71,-4.09l5.93,7.21l1.85,1.53l3.86,4.31l0.63,0.12l0.54,-0.28l0.45,-1.55l0.66,-0.39l1.08,-0.18l0.6,0.51l0.53,1.59l-0.91,2.22l0.5,3.53l1.46,1.56l1.22,-0.21l-0.1,0.54l-2.5,3.0l-2.09,1.38l-0.84,1.13l-1.18,2.75l0.32,3.33l-5.99,7.31l-3.25,1.09l-0.5,0.65l0.67,1.46l1.48,0.75l2.42,0.54l-0.61,1.71l-12.68,15.62l-1.19,2.7l0.21,1.01l-6.55,0.83l-3.27,1.95l-2.29,0.2l-0.36,0.33l-0.6,3.83l-0.03,3.0l0.8,5.43l-0.78,1.07l-0.06,4.14l0.29,0.56l0.47,0.15l2.53,-0.83l1.02,0.01l1.73,0.98l5.13,-0.73l1.62,0.63l3.74,2.86l1.07,0.23l1.94,-0.42l-7.03,7.36l-2.87,-1.45l-4.32,-0.05l-0.83,0.31l-1.72,3.34l1.45,3.53l2.4,2.85l2.47,0.7l3.15,-0.4l3.21,-1.69l2.85,-2.69l1.91,0.06l2.63,0.87l10.93,7.04l1.28,2.8l1.23,4.93l1.72,2.97l1.35,0.9l4.64,-1.95l1.01,-2.41l0.93,-1.37l1.91,-1.89l3.42,-2.53l2.63,-1.14l5.99,-0.65l3.84,-2.5l4.63,-4.99l1.91,-1.39l11.38,-3.0l5.68,-3.89l2.05,3.86l-0.25,6.31l-0.59,1.93l-3.12,4.78l-0.12,1.03l0.46,3.35l-0.12,1.43l-0.66,1.59l-1.73,2.0l-3.18,1.66l-0.79,1.32l1.27,3.69l0.42,3.14l-2.23,6.07l0.15,0.47l6.39,4.95l0.04,0.6l-1.35,2.4l0.21,4.87l-5.72,5.51l-0.22,1.12l0.34,3.21l-0.7,1.76l-2.32,3.52l-2.75,3.36l-3.72,3.29l-2.38,0.94l-4.66,5.03l-6.5,3.7l-7.35,3.6l-2.05,-2.31l-1.49,-2.47l-4.45,-5.2l-12.64,-19.12l-0.9,-2.2l-1.04,-4.62l-2.13,-1.47l-2.76,-0.54l-2.3,-1.37l-0.65,-1.64l0.7,-3.46l-0.02,-1.5l-1.33,-2.21l-3.77,-4.15l8.64,-0.41l4.56,-4.84l0.02,-0.52l-3.76,-4.71l-9.25,-4.34l-17.32,-4.94l-32.76,-10.25l-4.52,-0.75l-17.52,1.2l-3.27,1.16l-11.78,8.38l-3.25,1.58l-13.14,1.47l-3.85,1.56l-3.3,2.65l-28.11,37.51l-0.26,0.07l-10.65,-7.62l3.39,-6.59l-0.29,-3.16l-2.43,-3.79l-2.99,-2.82l-10.32,-5.51l1.83,-1.52l0.51,-1.87l-0.55,-4.53l-0.9,-2.21l0.0,-1.11l0.71,-1.38l2.28,-2.14l6.93,-10.3l7.03,-7.69l-0.02,-0.56l-4.73,-4.59l-0.56,-2.99l2.53,-2.87l26.76,-21.2l14.25,-6.77l2.09,-1.52l5.21,-5.08l6.55,-3.01l2.23,-1.45l2.25,-2.44l0.87,-2.36l-0.08,-4.24l-2.59,-2.85l-0.49,-1.24l3.36,-9.18l1.68,-2.81l3.44,-0.52l12.13,-0.75l2.08,-0.93l2.72,-1.86l9.66,-4.44l6.09,-1.8l3.11,-1.77l5.26,-3.83l11.27,-5.88l0.53,2.52l-0.43,2.54l0.6,1.65l1.16,1.36l1.55,1.08l0.52,1.13l0.02,3.68l0.38,1.73l3.66,7.4l1.0,6.6l0.82,1.97l2.78,2.31ZM175.95,263.39l-1.88,2.14l-0.81,1.61l-3.49,1.4l-1.93,1.53l-0.09,0.46l0.49,1.04l0.36,0.23l3.02,-0.21l2.45,-1.9l1.27,-0.35l5.96,2.23l1.59,-0.69l1.57,-1.35l1.48,-2.49l0.69,-1.94l-1.01,-2.19l-3.05,-1.39l-0.67,-1.21l-1.15,-1.04l-0.48,-0.04l-0.99,0.62l-2.21,2.75l-1.11,0.8ZM167.52,265.97l-1.29,-1.3l-1.59,-0.1l-3.15,2.91l-1.51,0.25l-0.46,1.61l1.8,2.08l0.69,1.8l1.39,0.36l2.32,-1.88l1.53,-1.7l0.43,-2.07l-0.16,-1.97ZM229.1,227.98l-1.61,1.45l-1.38,-0.9l-1.08,0.23l-1.44,2.03l-0.92,3.62l-1.02,1.7l-1.63,1.71l-3.03,1.37l-0.38,-2.14l-2.86,-3.58l-2.29,-1.11l-0.96,-1.65l-12.23,-14.74l14.49,-10.32l7.82,2.73l1.35,8.23l0.8,1.92l4.17,7.49l2.45,1.31l-0.26,0.65ZM180.58,352.72l-1.15,0.6l-9.36,-1.61l-3.47,-0.18l-0.09,-0.95l14.07,2.13Z",name:"Vaud"},"CH-TI":{path:"M485.32,340.13l-0.22,-2.45l0.46,-1.51l1.87,-3.52l-0.11,-2.01l0.47,-0.42l1.64,-0.44l4.7,-0.53l3.42,-1.99l5.81,-6.8l6.53,-4.74l2.9,-7.05l1.01,-0.98l3.57,-0.44l17.43,3.46l8.37,-3.08l6.62,2.62l15.48,1.22l11.76,-1.78l10.28,-3.57l1.92,-1.23l0.57,-0.98l-0.72,-2.9l0.27,-1.08l1.34,-1.62l2.79,-1.13l1.9,-0.37l1.72,-1.37l0.84,-0.05l0.34,0.25l0.78,2.5l1.32,1.63l6.73,0.58l4.52,1.87l2.95,2.59l0.11,0.56l-1.83,3.27l-1.26,3.35l-1.53,7.7l1.24,5.0l1.17,2.61l4.48,6.01l1.73,0.53l1.24,-0.5l2.7,-0.34l2.1,3.43l-0.43,6.2l0.37,2.19l1.72,3.43l0.13,0.83l-1.94,5.62l0.21,7.48l-0.67,1.62l-3.1,5.09l-0.35,1.8l0.48,3.17l-1.06,2.62l-1.6,1.66l-0.19,1.39l1.94,4.81l2.05,3.55l0.17,2.02l-0.57,3.34l1.08,2.75l1.66,2.32l4.61,3.02l5.9,5.89l4.24,2.73l-14.21,8.38l-3.76,4.96l-0.79,3.35l0.43,5.56l-0.61,2.93l-1.49,2.18l-1.77,0.9l-4.45,1.24l-5.27,3.65l-0.85,3.1l3.43,8.4l-6.4,5.16l-0.64,1.4l0.14,0.81l2.63,2.67l1.61,4.43l1.87,2.45l2.08,1.08l4.39,0.78l1.72,0.95l2.14,3.9l-0.72,4.02l-4.91,8.32l-6.19,6.62l-5.75,-0.94l-6.5,-2.52l-7.53,1.92l0.61,-3.17l1.2,-2.97l0.8,-3.09l-0.32,-4.44l-1.13,-3.35l-1.69,-3.31l-3.47,-5.38l-2.0,-4.03l-1.3,-1.58l-1.48,-1.02l-11.44,-5.34l-3.1,-0.96l-2.91,-0.18l4.3,-8.27l5.67,-6.0l3.01,-5.94l-0.06,-0.44l-5.07,-5.82l-3.32,-1.05l-6.09,0.13l-3.08,-0.37l-1.37,-0.81l-1.41,-2.25l-1.87,-0.7l-1.6,0.57l-3.06,2.36l-1.29,0.63l-3.32,-0.15l-9.22,-4.68l-5.72,-1.99l-12.54,-16.09l-5.72,-5.11l-5.61,-2.48l-5.19,-1.81l-3.55,-2.55l-2.11,-3.87l-0.77,-5.97l0.67,-6.36l3.23,-12.92l0.69,-7.26l-0.1,-7.59l-0.83,-5.7l-3.08,-3.78l-5.73,-0.87l-2.33,0.41Z",name:"Ticino"},"CH-TG":{path:"M567.83,30.76l1.84,0.66l2.15,-0.81l5.87,2.69l5.94,3.84l5.13,1.16l7.81,-0.64l7.33,-2.0l3.28,-3.0l3.61,-1.23l22.16,2.14l10.81,0.0l4.73,5.8l32.78,16.76l1.76,1.6l3.46,7.63l1.02,0.35l9.02,6.86l-1.85,-0.8l-10.17,6.59l-1.34,2.2l-2.58,-1.47l-4.37,-4.86l-0.38,-0.97l0.61,-1.34l0.09,-2.01l-2.27,-2.94l-3.91,0.35l-2.01,1.2l-3.3,0.47l-1.33,0.44l-1.77,1.36l-0.8,-0.19l-0.53,0.21l-0.46,0.63l0.03,0.65l1.09,0.8l2.23,0.26l2.32,-0.58l1.09,0.11l0.93,3.45l-1.12,2.53l-0.68,0.9l-0.97,0.61l-1.21,0.34l-2.84,-0.25l-2.67,1.38l-11.08,-1.88l-6.41,-2.65l-2.92,-2.98l-0.62,0.06l-2.63,3.66l-1.46,0.72l-3.22,0.43l-2.41,0.02l-2.55,-0.58l-2.52,0.24l-0.41,-0.09l-1.32,-1.47l-0.85,-0.2l-3.53,0.46l-2.64,-0.52l-0.92,0.16l-1.78,1.56l-3.05,0.84l-0.92,1.55l0.23,1.41l0.58,0.98l5.34,3.28l0.28,3.25l-0.35,1.19l-3.03,0.68l-1.92,0.83l-2.19,-0.09l-1.09,0.41l-0.79,0.98l-2.2,4.3l-1.96,1.99l-2.74,4.27l-1.51,1.74l-1.68,0.1l-7.54,-6.86l1.75,-2.38l0.67,-2.9l1.08,-1.1l0.12,-0.63l-3.62,-2.66l-0.93,-5.04l-2.06,-1.3l-0.78,-1.95l0.16,-1.0l1.59,-1.2l0.49,-0.93l-0.21,-1.62l1.32,-6.64l-0.58,-1.1l-1.61,-1.13l-7.81,-3.01l-1.06,-1.07l-0.69,-2.03l1.17,-1.92l0.0,-0.51l-2.23,-2.42l-12.82,-5.45l-2.35,-0.67l-2.3,-2.6l0.26,-0.66l1.11,-0.79l1.28,-0.39l1.28,0.17l2.77,1.22l1.98,1.57l1.71,0.2l1.55,-2.12l1.76,-1.71l2.32,-3.58l0.41,-1.61l-0.41,-1.22l-2.18,-2.17l-0.75,-3.26l-0.53,-0.29l-2.35,0.87l1.78,-3.68ZM697.16,73.08l4.21,3.2l-2.26,0.59l-2.41,-0.86l-0.25,-0.45l0.82,-2.15l-0.12,-0.34Z",name:"Thurgau"},"CH-OW":{path:"M482.58,238.26l0.71,0.46l0.91,-0.2l3.82,-2.16l0.72,-0.03l0.7,0.27l0.81,1.54l2.31,1.47l11.68,-0.47l2.71,1.07l0.35,0.69l-0.18,0.42l-2.07,2.17l-1.08,1.77l-1.64,5.09l-0.84,1.44l0.45,1.39l1.24,1.25l0.47,2.03l-0.52,2.12l-6.14,1.63l-3.98,-1.21l-3.75,0.47l-1.25,0.57l-1.02,-0.74l4.89,-1.34l0.73,-1.01l-1.07,-1.52l-3.89,-1.69l-2.4,-2.98l-0.58,-2.01l-1.94,-1.22l0.04,-2.31l-1.14,-3.15l-0.64,-4.08l-0.76,-1.89l0.62,-1.04l0.6,-0.36l0.42,0.12l0.88,1.1l-0.19,2.36ZM474.08,224.43l-0.03,6.6l-1.24,4.04l-0.55,7.44l0.49,6.01l4.21,5.13l3.43,1.8l-7.83,2.66l-6.73,4.04l-2.06,0.7l-1.83,-0.05l-3.86,-1.05l-10.43,-1.12l-2.52,0.43l-5.61,1.72l-3.71,-1.25l-8.9,-5.08l-3.89,-0.73l-5.57,-0.26l2.87,-4.21l-1.05,-3.91l-1.0,-1.85l-0.61,-2.44l3.87,-8.01l0.74,-3.66l1.34,-2.95l1.4,-1.75l1.59,-0.83l1.54,0.02l1.08,1.11l1.35,-0.3l4.74,-5.2l4.01,-3.21l0.45,-1.63l-0.92,-3.36l0.28,-0.42l3.18,-1.81l11.04,-0.92l3.43,-0.72l3.01,-1.23l8.21,1.98l0.9,0.77l-0.26,1.07l-0.86,2.12l-1.7,2.52l-0.23,2.14l2.37,2.21l4.66,1.88l0.86,0.69l0.34,0.87Z",name:"Obwalden"},"CH-AG":{path:"M354.73,63.79l6.77,-1.21l3.86,-1.87l3.32,-3.39l3.44,-4.62l2.65,1.14l12.72,0.66l1.02,0.91l0.99,4.6l0.93,1.41l26.03,-0.01l9.09,-1.78l2.05,-1.23l1.69,-2.38l1.63,-1.61l1.57,-1.05l4.27,-1.98l3.78,-1.02l2.34,-2.46l0.9,-0.5l10.66,-1.54l3.53,-0.01l5.12,1.35l2.23,0.21l0.92,0.94l2.46,4.86l2.22,1.29l7.65,1.74l12.85,0.06l-0.2,0.89l-4.5,6.27l-4.33,3.79l-3.34,4.61l-1.06,4.96l-0.1,2.66l1.1,3.72l4.39,8.05l1.47,3.88l3.15,3.92l-0.73,1.83l-5.23,4.6l-0.41,1.96l1.79,1.41l3.9,1.72l0.72,0.73l-0.49,4.95l0.19,0.94l0.55,1.17l2.35,2.19l5.64,-1.34l-0.41,1.7l-1.77,2.67l-3.65,4.06l-3.34,1.78l-2.94,0.61l-0.32,0.49l0.53,2.14l4.37,8.01l-2.48,4.11l-0.33,2.42l1.02,10.71l1.41,8.39l-5.23,-0.19l-2.36,-0.98l-2.43,-2.32l-2.85,-4.1l-6.65,-16.39l-1.52,-2.9l-1.5,-4.68l-2.35,-2.48l-3.41,-1.24l-3.79,0.4l-3.34,3.37l-0.97,2.14l-4.46,6.85l-3.09,1.99l-1.6,0.15l-2.81,-1.58l-0.84,-1.65l1.46,-0.56l0.1,-0.7l-0.66,-0.45l-1.92,-0.65l-5.36,-0.17l-3.85,-1.1l-3.31,-2.72l-13.43,4.5l-4.29,-7.3l-3.42,-1.3l-4.31,0.08l-0.83,0.11l-0.55,0.45l-0.26,0.96l0.16,4.94l-0.21,0.59l-0.93,0.7l-4.97,1.54l-4.55,0.01l-11.94,2.09l-2.42,-3.57l-0.63,-5.23l1.41,-1.55l5.34,-8.82l8.68,-6.85l3.03,0.84l12.72,1.66l3.29,-1.62l2.86,-5.61l2.23,-2.91l1.49,-2.94l-0.17,-5.0l-0.3,-0.37l-2.46,-0.6l-1.87,-0.9l-1.66,-1.37l-0.85,-1.06l-0.84,-3.41l-1.35,-0.87l-0.07,-3.4l-0.45,-1.06l-1.96,-1.92l-3.02,-0.47l-2.31,-1.32l-0.33,-1.3l-0.03,-3.55l-0.36,-0.39l-6.01,-0.55l-1.63,-1.04l-0.72,-1.89l-5.8,-7.59l-0.91,-1.72l-1.23,-0.87l-1.54,-1.82l-3.05,-0.84l-1.53,0.23l-0.72,0.62l-0.48,3.36l-0.41,0.58l-4.89,3.82l-2.33,0.29l-0.8,-1.97l-0.14,-2.92l-1.26,-0.92l-1.02,-0.18l-6.87,-2.91Z",name:"Aargau"},"CH-GE":{path:"M43.64,378.51l-3.1,7.38l-1.33,9.25l-1.42,1.16l-1.15,1.61l-0.85,1.83l-0.59,2.13l0.17,0.44l0.47,-0.03l10.01,-8.63l7.8,-13.28l0.46,1.84l1.92,4.13l1.04,1.25l2.4,0.95l3.2,-1.27l1.04,0.39l0.95,5.32l-4.96,4.56l-12.81,7.38l-10.13,10.3l-6.25,2.79l-6.79,-2.6l-9.09,0.31l-9.12,1.88l-3.83,1.97l3.63,-6.81l0.66,-2.24l-3.59,-4.2l-1.98,-3.24l0.66,-2.67l4.69,-2.59l11.91,-5.07l3.62,0.5l1.24,-0.12l4.71,-1.4l0.91,-1.88l-0.08,-4.93l1.41,-7.02l0.64,-1.9l2.68,-5.2l10.82,7.69Z",name:"Gen\xe8ve"},"CH-AI":{path:"M726.92,90.17l-3.04,2.62l-0.5,0.77l-0.25,1.37l-5.71,-2.46l-0.19,-0.32l0.0,-0.5l3.42,0.17l3.1,-0.53l3.17,-1.12ZM709.29,96.6l0.45,-1.26l2.37,-1.68l0.52,-0.11l2.0,1.58l0.72,0.89l0.16,0.75l-0.02,0.91l-1.05,1.17l0.35,2.85l-2.39,-0.98l-2.61,0.36l-4.73,1.59l0.41,-1.96l4.24,-1.87l0.59,-0.64l-0.19,-0.96l-0.79,-0.65ZM687.85,139.94l-5.55,1.82l-2.84,-0.34l-3.08,-1.35l-2.48,-1.56l-2.09,-5.62l-2.55,-3.36l-0.66,-1.44l-0.35,-2.07l0.55,-5.8l0.61,-1.33l2.87,-2.03l1.65,-1.66l1.17,-1.83l1.11,-2.59l0.16,-4.84l0.94,-0.78l20.98,8.49l6.05,0.19l-3.27,13.85l-3.84,6.19l-2.7,2.6l-2.82,1.76l-3.85,1.71Z",name:"Appenzell Innerrhoden"},"CH-GL":{path:"M655.12,222.42l-5.42,4.19l-3.42,4.06l-2.51,1.12l-3.7,0.04l-2.95,0.55l-6.88,4.05l-1.82,0.44l-1.42,-0.45l-0.92,-1.08l-1.45,-0.91l-2.1,-0.64l-3.41,-0.25l-3.37,0.95l-0.7,0.9l-0.34,3.6l-2.65,4.78l-1.4,1.6l-2.77,2.25l-4.45,1.81l-10.95,2.93l-1.72,0.04l-0.54,-0.33l-0.46,-1.6l-0.66,-0.87l-3.08,-0.81l-3.78,-0.15l-0.29,-5.66l0.29,-1.37l6.49,-4.45l2.08,-0.24l4.37,-1.58l1.44,-1.11l0.89,-1.54l-0.03,-4.04l-0.51,-1.67l-2.83,-4.62l4.04,-1.92l1.74,-6.42l-0.34,-1.76l-0.96,-1.41l-4.05,-2.66l-0.78,-1.24l0.5,-1.49l-0.12,-0.62l-5.6,-6.97l-2.63,-2.1l0.82,-2.4l2.11,-1.35l4.91,-2.02l1.87,-1.78l1.65,-2.15l1.98,-3.51l0.23,-2.07l-0.44,-3.14l1.34,-2.31l0.62,-4.33l3.75,-10.41l2.96,-1.38l0.95,0.03l10.36,8.12l3.21,1.57l20.63,3.48l-0.96,11.58l-1.05,3.35l-6.78,4.09l-0.68,1.06l0.33,0.73l3.68,1.84l1.38,0.35l3.85,-0.34l2.32,-0.98l2.7,-0.49l1.45,0.94l1.59,1.85l2.6,4.6l1.13,3.84l-0.92,7.15l-0.59,1.55l0.79,3.21l1.55,3.03l0.19,0.83l-0.36,2.12Z",name:"Glarus"},"CH-GR":{path:"M639.97,409.36l-4.3,-2.76l-5.85,-5.85l-4.62,-3.02l-1.52,-2.16l-0.96,-2.44l0.57,-3.12l-0.18,-2.3l-2.11,-3.71l-1.87,-4.59l0.07,-0.81l1.61,-1.7l1.17,-2.91l-0.48,-3.31l0.31,-1.56l3.02,-4.93l0.74,-1.79l-0.18,-7.64l1.94,-5.69l-0.2,-1.16l-1.69,-3.36l-0.32,-1.99l0.4,-2.72l0.03,-3.55l-2.35,-3.93l-0.39,-0.19l-3.0,0.38l-1.3,0.49l-1.13,-0.44l-4.2,-5.73l-1.08,-2.4l-1.21,-4.71l2.04,-9.32l2.56,-4.87l-0.13,-1.01l-0.58,-0.76l-2.8,-2.3l-4.64,-1.91l-6.7,-0.59l-1.38,-2.38l-0.21,-1.27l-1.01,-0.76l-1.35,0.16l-1.56,1.31l-3.42,0.89l-1.57,0.8l-1.45,1.76l-0.39,1.42l0.75,2.75l-0.32,0.62l-1.79,1.15l-10.04,3.48l-11.68,1.77l-15.28,-1.22l-6.29,-2.51l0.53,-3.23l-1.5,-5.15l-0.66,-1.01l-2.32,-1.27l-0.89,-1.61l-0.23,-1.33l0.14,-1.28l1.38,-3.87l1.47,-2.92l0.44,-2.35l-0.18,-1.39l0.6,-0.89l1.26,-0.96l3.16,-1.22l2.08,-0.4l1.96,-0.96l6.65,-7.05l3.29,-1.0l3.75,0.98l3.11,-0.59l0.81,-0.45l0.88,-1.22l-0.18,-2.23l0.23,-0.71l3.47,-4.51l0.29,-2.18l-0.13,-2.81l0.37,-0.4l2.94,-0.85l1.28,-1.2l2.33,-1.15l2.04,-2.32l3.91,0.16l2.85,0.77l0.7,2.08l1.17,0.76l1.98,-0.05l11.07,-2.96l4.63,-1.9l2.85,-2.31l1.5,-1.7l2.77,-4.99l0.36,-3.66l0.34,-0.44l3.06,-0.85l3.21,0.25l1.82,0.56l1.35,0.85l1.04,1.17l1.85,0.53l1.99,-0.48l6.85,-4.04l2.78,-0.52l3.88,-0.07l2.74,-1.23l3.49,-4.12l5.23,-4.05l2.91,2.96l0.9,0.28l1.15,0.0l0.93,-0.41l26.54,3.34l4.0,1.74l2.2,1.44l1.6,0.2l0.81,-0.26l0.77,-2.12l2.52,-0.82l2.63,-4.01l0.62,-1.51l0.13,-2.54l0.6,-2.88l2.32,-3.98l2.92,-2.39l1.3,-3.36l1.89,-1.34l1.47,-0.34l0.26,-0.59l-7.2,-10.89l-2.19,-4.15l-1.5,-4.53l4.02,1.02l12.18,1.75l4.17,-1.11l3.77,0.84l10.41,-1.11l3.27,0.43l37.33,10.16l-0.13,2.9l1.11,0.7l1.05,-0.07l0.52,0.53l0.0,1.25l-0.82,2.44l-0.49,5.88l-0.63,2.68l0.32,2.51l2.71,3.39l5.06,3.33l21.26,5.92l7.72,6.33l4.57,2.28l8.62,2.39l4.33,0.14l5.15,-1.27l8.77,-3.85l2.27,-2.82l0.71,-4.08l0.92,-3.08l2.9,-4.22l2.99,-0.48l3.91,0.87l4.97,-0.2l0.38,-0.39l0.1,-4.59l3.4,-5.64l4.95,-4.9l5.68,-2.81l1.95,-0.0l0.93,0.52l2.04,1.9l4.24,5.85l6.75,4.63l1.67,1.73l1.02,4.04l-2.44,8.44l0.46,5.47l-1.04,8.01l-0.69,2.16l-5.56,6.35l0.37,3.74l1.43,3.72l0.46,3.25l-2.26,2.97l-3.49,2.05l-0.83,2.45l0.18,2.82l-0.42,3.43l-1.83,2.83l-2.23,1.9l-0.95,2.39l1.66,5.08l3.7,3.78l8.63,0.9l3.97,2.89l1.45,4.64l-0.14,6.36l-1.56,6.1l-2.65,3.8l-3.36,0.56l-14.21,-3.24l-7.02,0.56l-2.46,-0.35l-2.13,-0.85l-2.28,-2.39l-1.7,-1.27l-8.02,-2.39l-0.79,-2.42l1.07,-5.04l-0.55,-3.24l-3.41,-2.33l-5.13,0.04l-18.98,4.72l-1.99,0.94l-1.08,2.1l-2.43,8.09l-1.57,1.83l-4.29,3.71l-1.85,2.47l-0.31,7.29l-0.86,2.77l0.25,2.32l0.48,1.88l1.03,1.53l1.49,0.92l-3.29,4.83l0.04,0.5l3.3,3.5l5.86,1.98l8.96,1.51l3.26,1.14l1.32,2.5l-1.44,5.22l-1.36,1.58l-4.15,3.23l-1.6,2.53l-1.05,3.48l-0.14,2.38l0.87,2.35l1.81,2.79l8.25,7.31l2.41,4.2l-2.45,4.48l-5.43,2.97l-8.31,2.74l-6.15,-0.11l-0.15,-5.26l-2.06,-4.41l-7.96,-6.19l-2.84,-3.33l-1.27,-5.34l-0.1,-5.02l-1.32,-4.07l-5.17,-3.07l-4.27,-0.98l-3.96,-0.25l-8.7,1.3l-13.35,5.94l-4.03,1.14l-2.41,-0.45l-4.81,-2.52l-2.61,0.02l-2.28,2.36l-0.39,2.86l0.23,4.71l-2.89,3.48l-3.58,1.26l-22.73,-0.23l-4.54,-1.44l-4.13,-2.43l-2.46,-2.94l-4.09,-9.13l-1.83,-1.3l-4.37,-2.1l-1.31,-1.12l-0.34,-1.22l0.28,-3.79l-1.2,-24.01l-0.67,-1.7l-0.45,-0.24l-1.71,0.36l-3.22,2.06l-1.45,1.68l-1.63,3.21l-1.9,0.66l-1.31,-0.49l-4.9,-4.05l-0.14,-2.92l-0.31,-0.37l-4.09,-0.92l-9.92,1.12l-3.91,3.18l-3.46,6.03l-1.61,6.23l1.96,3.68l2.64,1.65l0.35,2.26l-0.51,3.16l0.02,3.57l2.69,8.94l0.26,3.11l-1.21,5.39l-5.81,10.54l-2.98,8.95l-1.75,2.44l-2.22,1.8l-2.4,0.99l-2.31,1.57l-2.04,5.35l-1.24,2.04Z",name:"Graub\xfcnden"},"CH-AR":{path:"M727.16,89.24l-3.64,1.29l-2.95,0.5l-3.71,-0.19l-0.42,0.4l0.06,1.24l0.5,0.69l6.08,2.62l0.27,1.81l-7.75,4.15l-0.34,-2.76l0.9,-0.8l0.16,-1.42l-0.27,-1.16l-0.8,-0.99l-2.59,-1.87l-0.92,0.22l-2.53,1.79l-0.73,1.94l1.04,1.2l-4.79,2.46l-1.64,9.21l1.18,3.46l-5.75,-0.15l-21.14,-8.56l-1.67,1.12l-0.29,5.22l-1.01,2.31l-1.07,1.7l-1.59,1.6l-2.88,2.03l-0.81,1.65l-0.59,6.05l0.41,2.38l0.77,1.64l2.47,3.23l1.93,5.24l-3.97,0.63l-2.01,-1.31l-6.13,-2.92l-10.04,-1.16l-2.49,-0.83l-1.17,-1.19l2.15,-2.47l-1.38,-5.6l0.11,-1.48l0.32,-0.87l1.95,-2.04l0.94,-1.73l-0.25,-0.86l-0.86,-0.64l-2.85,0.31l-2.33,-3.97l2.65,-2.3l3.47,-6.02l1.52,-2.03l1.7,0.24l8.47,-0.91l3.37,0.91l16.14,-2.59l4.37,0.05l2.49,-0.65l1.38,-1.26l1.07,-2.97l0.94,-1.39l3.92,-1.0l10.01,-3.86l5.23,-3.75l3.14,0.72l2.49,1.61l3.18,1.09l6.61,0.98Z",name:"Appenzell Ausserrhoden"}},height:497.64536275046987,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","co_mill",{insets:[{width:900,top:0,height:1084.910959161064,bbox:[{y:-1521444.2655413484,x:-9102055.303089745},{y:472117.89761349745,x:-7448273.551058428}],left:0}],paths:{"CO-VAC":{path:"M260.34,576.48l2.3,-0.45l2.61,-2.06l0.94,0.03l1.11,0.96l1.12,-0.05l1.05,-1.0l-0.01,-1.11l1.37,-1.36l0.28,2.48l1.59,1.62l0.8,0.12l2.31,-1.04l0.92,0.05l1.83,0.99l3.78,3.84l2.91,0.14l1.24,-0.54l0.74,-0.82l1.64,0.1l1.17,0.88l2.62,3.97l1.49,0.72l2.66,-0.02l1.07,1.0l2.75,1.09l1.24,0.11l1.09,-0.35l4.43,-3.82l3.44,0.77l1.46,-0.36l0.52,-1.58l1.35,-1.83l1.46,-1.54l2.91,-1.18l1.64,-1.59l0.5,-1.3l-1.02,-1.34l-2.45,-1.28l-0.22,-1.27l0.29,-3.55l-2.02,-2.14l-1.01,-1.88l1.1,0.1l2.41,-0.63l1.83,-1.2l0.95,-3.11l-0.49,-2.81l1.32,-3.91l6.71,-5.94l0.83,-1.27l-0.51,-1.88l0.79,-2.0l5.28,-4.74l2.52,-2.85l1.78,-4.97l1.4,-1.7l2.17,-1.9l2.92,5.36l2.13,1.82l-0.02,1.56l0.38,0.79l1.4,0.69l2.14,-0.32l-0.1,1.15l-0.96,1.56l1.34,3.23l1.84,0.68l2.32,-1.0l0.21,1.04l-0.47,1.17l0.44,0.54l1.28,-0.24l2.85,0.79l3.9,0.57l0.3,2.28l-0.22,0.26l-2.33,0.28l-4.06,-0.62l-2.64,3.29l0.02,0.97l-0.98,2.94l0.1,4.61l0.39,0.96l-0.84,0.73l-0.46,1.4l0.22,0.48l1.08,0.48l1.23,0.06l2.48,1.0l1.14,2.52l-0.09,3.67l-2.29,4.72l-0.15,2.25l-0.47,1.28l-0.02,2.01l0.76,1.11l3.97,1.82l0.88,1.67l-2.41,1.25l-0.59,0.82l-0.82,2.41l-1.53,2.63l-1.39,3.38l-4.02,6.06l-0.88,1.92l-1.44,1.67l-0.59,2.09l-1.03,1.81l-0.51,5.36l-1.9,3.38l-1.28,3.72l-0.21,3.5l-0.72,1.93l1.21,2.42l-0.98,1.13l-0.33,4.07l-0.35,0.49l-5.84,-1.59l-3.02,-1.95l-1.78,-0.58l-6.01,-0.46l-2.6,-0.53l-2.29,-1.11l-0.48,0.1l-1.63,2.05l0.16,0.86l1.03,1.25l-0.07,2.01l-0.68,1.66l-0.56,0.54l-3.03,1.01l-2.03,2.96l-1.48,-0.71l-0.93,0.41l-0.77,1.14l-1.6,-1.59l-0.63,0.14l-1.06,0.98l-1.63,-0.58l-5.24,-4.03l-0.63,0.1l-1.94,3.54l-1.02,1.11l-2.2,0.66l-2.68,-0.69l-4.1,-2.11l-1.89,-1.75l-5.8,-1.45l-2.58,0.66l-1.03,0.72l-1.19,-0.01l-3.47,2.85l-0.99,-0.31l-0.88,-0.91l-0.71,-0.09l-0.27,-1.19l-1.5,-0.69l-3.11,0.42l-0.69,-1.12l-0.57,-1.88l-1.48,-2.29l-3.51,-3.28l0.05,-0.94l1.56,-1.51l2.45,-0.27l1.28,-1.0l1.12,2.09l0.95,1.07l1.66,0.68l0.51,-0.53l-2.81,-3.96l0.16,-1.64l1.0,0.78l0.75,-0.39l-0.08,-0.77l-0.63,-0.96l0.99,-2.59l0.78,0.35l0.69,-0.38l0.83,0.07l1.03,0.82l0.61,-0.39l-0.12,-0.72l-0.69,-0.88l0.36,-0.44l-0.73,-0.52l0.35,-0.17l0.18,-0.9l-0.5,-0.55l0.31,-0.22l-0.84,-0.86l0.51,-0.1l0.27,-0.64l-0.2,-0.33l1.46,-0.23l-0.16,0.3l0.36,0.59l2.47,-0.57l0.28,-0.39l-1.02,-0.62l1.26,-1.65l0.81,-2.05l1.15,0.35l1.15,-0.83l2.01,-0.76l-0.1,-0.72l-0.95,-0.3l-1.79,0.39l-0.33,-0.33l2.22,-0.74l0.56,-0.78l-0.37,-0.63l-3.49,0.8l-0.51,-0.25l-0.07,-1.66l0.13,-0.35l2.29,1.27l1.9,-0.04l0.18,-0.57l-0.29,-0.4l-1.77,-0.46l1.45,-0.62l0.56,-0.85l-0.13,-0.54l-1.32,-1.1l0.04,-0.48l0.63,-0.52l0.37,0.34l0.27,1.22l0.44,-0.08l0.99,-1.27l-0.48,-1.98l2.66,-0.96l1.36,-2.11l0.83,-0.75l0.13,-0.67l-0.48,-0.39l-2.53,0.54l0.1,-0.25l-0.39,-0.29l-1.5,0.02l-1.16,-0.42l-0.59,0.38l0.19,2.38l-3.24,1.85l-4.16,0.7l-1.94,-1.0l1.11,-1.13l-0.28,-0.67l-2.13,-1.14l0.7,-3.3l0.69,-0.67l0.7,-0.11l0.25,0.1l-0.65,1.01l0.42,0.22l3.84,-0.81l0.26,-0.79l-0.48,-0.39l-1.38,0.27l2.07,-2.66l0.98,-2.11l-0.38,-0.57l-0.66,0.01l-0.18,-0.52l-0.47,-0.27l-0.75,0.16l-1.31,-1.2l-0.95,-0.61l-0.48,0.03l0.07,2.23l-1.58,-0.07l-0.73,0.63l0.07,0.62l-0.8,-0.14l-0.48,0.46l0.18,1.09l-0.59,2.99l-0.81,1.05l-0.32,1.93l-0.58,0.05l-0.74,-0.91l0.19,-1.19l-3.35,-2.79l-0.05,-1.35l1.07,-0.08l0.29,-0.65l-0.89,-1.23l-0.41,-1.57l-0.24,-3.13ZM266.68,615.49l-0.03,-0.08l0.06,-0.0l-0.03,0.08ZM267.51,613.12l-0.07,0.01l-0.31,0.09l0.01,-0.03l0.36,-0.07l0.02,0.0Z",name:"Valle del Cauca"},"CO-BOY":{path:"M371.62,202.36l0.62,0.62l1.24,-0.29l2.35,-1.46l0.85,-0.9l-0.49,-4.46l-0.4,-0.37l-0.83,0.19l-0.44,-1.6l-0.39,-0.3l-0.75,0.25l2.72,-2.61l-0.6,1.85l0.22,0.44l1.35,0.42l0.96,-0.77l0.39,-1.4l-0.12,-2.85l-0.36,-0.49l-0.85,-0.24l0.38,-0.99l-0.1,-1.31l-0.26,-0.65l-0.86,-0.38l0.13,-0.25l0.49,-0.48l2.84,-1.09l0.66,-0.8l-0.4,-1.0l1.98,-0.59l1.53,-2.34l1.59,-0.72l3.95,-1.0l0.85,-0.66l0.96,-1.41l0.73,0.26l-0.33,0.69l0.38,0.64l-0.44,0.99l0.06,1.38l1.81,1.78l0.34,0.95l-0.15,1.47l-1.44,1.25l-0.78,3.15l0.83,2.37l0.91,0.7l4.03,0.57l-0.15,1.33l0.82,0.48l1.71,2.7l0.42,0.18l3.2,-0.68l2.62,2.55l1.43,0.45l1.49,1.24l3.76,4.38l-1.57,4.84l-0.19,1.4l0.37,1.95l0.69,0.7l2.27,1.25l2.58,0.8l0.8,0.92l0.84,1.94l1.01,0.67l0.03,1.79l-0.31,0.69l-3.46,2.08l-0.53,1.08l-0.13,1.39l0.32,4.23l0.58,1.28l2.63,2.69l0.3,0.81l-0.97,3.7l0.19,1.4l0.64,1.09l2.23,2.34l0.11,0.73l-1.6,7.88l0.36,2.46l0.46,0.33l1.58,-0.24l1.52,1.94l0.52,0.1l1.42,-0.66l0.63,0.02l0.59,0.36l0.97,1.75l1.24,0.12l1.13,0.6l0.92,2.17l3.77,3.2l0.58,1.98l1.13,1.2l1.43,0.15l1.22,-1.32l0.86,-0.42l2.6,0.1l1.11,2.49l1.03,0.33l1.68,-0.71l0.97,0.11l2.36,0.98l0.37,0.5l0.1,1.59l0.5,0.74l2.54,0.23l0.93,0.55l2.46,3.69l3.06,1.87l-0.34,0.27l0.1,0.68l3.98,1.24l1.84,-0.2l1.03,-1.16l1.51,1.42l-0.27,0.75l0.18,0.48l1.94,1.11l5.19,0.28l1.27,0.56l-0.65,1.64l0.18,1.93l1.72,2.97l2.11,1.93l0.68,1.05l0.24,1.57l-0.26,1.2l-1.12,2.19l-0.29,1.37l0.08,4.09l0.39,1.41l1.46,1.97l0.47,4.11l1.78,3.84l0.45,4.2l-0.75,1.97l0.7,1.7l-0.82,1.55l-0.14,2.5l-0.66,1.86l-0.82,1.01l0.64,3.12l-1.74,1.3l-0.87,1.3l-1.41,0.64l-1.25,4.02l0.01,2.38l1.03,3.35l-0.15,0.87l0.86,3.63l0.89,1.14l0.72,3.55l-0.44,4.65l-0.71,1.7l0.74,1.54l-0.45,1.54l0.03,2.13l-0.21,0.67l-0.83,0.51l-3.53,4.73l-0.41,1.03l-0.01,2.61l0.81,2.02l-1.49,4.71l-0.35,2.43l-19.3,18.32l-2.76,-0.04l-2.38,-0.72l-0.51,-0.73l-0.45,-2.65l-2.21,-6.05l-0.4,-1.84l-0.05,-1.38l0.6,-2.11l-0.24,-3.89l0.2,-1.18l2.3,-2.94l0.68,-2.56l-1.04,-3.6l-0.63,-0.2l-2.43,1.91l-0.82,1.26l-0.99,2.56l-2.01,1.97l-1.04,0.18l-0.97,-0.26l-1.16,-1.07l-2.0,-2.48l-1.12,-2.54l-0.29,-3.35l0.79,-4.89l0.72,-1.38l3.69,-2.85l1.02,-1.84l0.2,-1.21l-0.47,-1.14l-1.43,-0.92l-0.65,-1.05l-0.51,-1.7l-0.68,-6.05l-0.62,-1.83l-2.98,-4.39l-14.02,-11.42l0.64,-1.96l1.31,-1.55l-0.16,-1.62l1.26,-0.27l2.25,-1.56l3.6,0.08l1.6,-0.54l2.33,-2.1l0.64,-1.43l0.3,-1.76l1.47,0.25l0.83,-0.99l1.05,-3.22l-0.67,-3.22l-0.07,-3.18l-0.77,-1.05l-0.63,-1.7l-1.02,-6.89l0.47,-1.09l1.49,-1.27l1.62,-2.3l0.04,-0.94l-4.25,-6.08l-2.89,-3.22l-5.87,-4.49l-1.71,-0.69l-2.48,-1.6l-2.22,-4.35l-2.32,-1.77l-0.97,-4.68l-1.08,-2.86l0.26,-1.71l-0.53,-0.95l2.39,-4.78l-0.27,-0.91l-2.69,-2.13l-2.55,0.68l-1.93,-0.56l-0.35,-0.54l1.23,-2.82l-0.27,-0.55l-3.57,-0.53l-6.95,-6.29l-1.02,-0.4l-2.17,0.04l-1.82,-1.28l-2.08,-0.49l-0.99,0.37l-1.39,1.31l-1.05,-0.41l-0.6,0.25l1.86,-7.22l-0.09,-2.49l0.85,-2.79l-0.01,-1.1l-0.37,-0.39l-1.28,-0.1l-0.89,0.46l-0.66,-0.12l-6.07,-2.23l-0.18,-0.76l1.16,-1.98l-0.65,-2.45l-0.06,-2.11l-0.44,-0.39l-2.8,0.41l-0.43,-0.48l3.02,-5.67l-0.06,-0.48l-0.48,-0.07l-5.43,2.92l-0.26,-1.54l1.37,-0.88l1.52,-2.74l0.54,-3.67l-0.47,-0.06l-4.47,2.74l-2.44,2.57l-2.32,1.3l-0.49,-0.08l0.63,-1.46l2.49,-1.52l1.05,-1.32l0.94,-1.61l-0.02,-1.64l1.08,0.04l0.35,-0.61l-0.36,-0.86ZM393.44,172.57l-1.18,0.98l-0.76,-0.43l-0.25,-0.84l0.36,-0.78l1.89,-0.64l0.18,1.22l-0.25,0.49ZM372.02,199.93l-0.19,-1.29l0.85,-1.38l1.92,0.74l-0.32,0.69l-1.03,-0.23l-0.82,0.35l-0.4,1.12Z",name:"Bol\xedvar"},"CO-COR":{path:"M489.67,357.8l-6.07,-0.31l0.06,-1.26l0.62,-1.21l-0.25,-2.5l1.19,-1.49l2.76,-2.15l0.54,-1.21l0.01,-1.27l-0.87,-1.86l-1.3,-1.16l-1.01,-0.25l-0.36,-0.42l-0.1,-1.17l-2.52,-4.34l-0.44,-1.18l-0.34,-4.48l-0.7,-2.39l0.75,-0.86l0.69,-1.94l0.17,-2.57l0.83,-1.64l-0.68,-1.86l0.74,-1.94l-0.46,-4.31l-0.48,-1.55l-1.32,-2.38l-0.5,-4.19l-1.49,-2.04l-0.3,-1.1l-0.09,-3.91l1.68,-4.78l-0.26,-1.87l-0.88,-1.4l-2.88,-2.96l1.51,-4.76l1.25,-2.89l1.42,-2.32l-0.02,-0.45l-1.51,-2.05l-1.84,-1.77l-0.68,-1.22l-0.38,-2.25l-0.38,-0.59l-3.98,-0.52l-0.83,-0.57l-0.21,-0.77l0.7,-1.44l-0.27,-3.25l-0.35,-0.72l-1.43,-1.14l-0.59,-1.12l-0.5,-3.65l-2.36,-1.68l-2.62,-2.51l-2.81,-1.62l1.32,-0.98l2.91,-3.33l1.8,-0.94l1.27,-0.12l2.49,0.41l1.95,0.98l3.34,0.08l3.18,-1.72l0.4,0.05l0.68,0.99l0.63,0.02l1.0,-1.2l-1.89,-6.25l-1.52,-2.75l0.34,-1.02l-0.45,-2.3l-3.21,-2.9l-3.53,-4.78l-2.74,-1.9l-4.03,-6.42l-0.15,-1.38l1.1,-5.43l1.63,-2.65l4.0,-4.87l1.07,-2.66l1.86,-1.75l3.62,-0.94l2.08,0.26l2.45,-0.71l2.24,-1.61l1.78,-0.61l0.91,-1.04l2.19,-0.42l0.61,-0.57l0.52,-1.33l3.49,-1.3l0.58,-0.69l-0.09,-1.14l-1.44,-1.37l0.21,-1.91l-0.37,-2.33l-0.8,-1.93l1.56,-2.79l1.49,-1.93l-0.05,-1.09l-0.75,-0.93l-1.04,-0.56l-3.07,-0.32l2.27,-4.01l8.97,-1.23l3.86,0.15l6.15,0.71l0.63,0.43l0.93,1.84l0.17,2.18l-0.37,1.48l0.51,1.12l3.64,1.7l1.78,0.47l2.36,1.37l2.68,2.63l-1.36,2.98l-0.87,1.05l-0.65,2.02l-0.82,0.54l-1.17,2.1l-0.73,0.44l-0.73,1.37l0.24,0.52l1.04,0.38l0.57,0.68l0.89,2.12l0.82,0.28l3.09,-0.89l1.91,0.66l2.1,0.21l2.15,-0.41l3.26,-1.17l0.02,1.57l-1.21,13.35l-3.16,10.83l-0.01,2.35l-0.55,3.68l1.16,3.83l-0.44,1.45l-1.88,3.84l-3.32,5.15l-2.16,5.24l-4.34,3.44l-1.13,2.68l-4.83,7.11l-2.83,6.44l-3.35,2.62l-0.77,1.38l-0.02,1.33l0.38,0.46l-1.71,0.53l-1.37,2.27l0.19,2.5l-0.76,8.36l0.25,2.9l-0.41,1.86l1.27,4.92l-0.98,1.21l-1.92,1.36l-0.25,1.92l-3.63,3.16l-0.94,1.3l-0.5,1.63l0.0,1.36l0.57,1.59l1.77,2.53l1.15,2.71l0.74,0.87l-0.65,2.35l-1.49,1.78l0.06,0.96l2.02,0.48l1.52,1.05l0.2,1.43l0.75,0.66l0.46,-0.01l3.15,-3.42l-0.38,-2.34l-0.76,-1.92l0.15,-0.29l2.38,0.16l0.83,0.64l0.19,2.51l-0.82,3.69l-2.56,6.4l-0.24,1.38l0.27,4.88l0.91,0.78l0.84,1.9l0.03,2.37l0.34,1.16l1.03,0.96l2.44,0.25l0.7,1.0l1.04,0.5l-0.15,1.97l-1.21,1.52l-2.42,1.53l-0.5,1.88l0.17,2.23l-0.27,1.71l-2.12,3.18l-2.14,2.28l-1.16,0.76l-1.82,0.83l-1.04,0.13l-1.7,-1.2l-1.6,-0.54l-1.75,-1.55l-3.23,-0.74l-0.41,0.26l0.1,0.33Z",name:"Cesar"},"CO-HUI":{path:"M437.8,603.55l-0.24,1.46l-1.32,3.22l-1.3,2.23l-4.49,6.07l-0.74,2.21l-0.84,9.53l-0.58,1.88l-1.74,2.91l-3.92,2.77l-1.53,1.57l-3.24,1.92l-2.74,4.48l-1.71,4.95l-1.44,0.57l-3.28,3.0l-2.69,3.5l-1.24,2.24l-1.08,3.37l0.65,1.7l1.39,0.9l1.26,1.35l0.42,1.57l-0.38,0.85l-1.98,2.25l-5.1,3.93l-1.82,0.57l-2.27,-1.17l-1.01,-0.19l-0.83,0.28l-0.77,0.75l-1.0,1.56l-1.93,6.78l-1.63,2.99l-2.21,2.42l-4.82,3.55l-7.82,12.94l-4.58,4.17l-7.02,10.05l-5.15,5.69l-0.83,1.46l-3.99,3.06l-3.15,3.38l-2.57,0.71l-4.53,-0.3l-3.77,-0.61l-2.33,-1.05l-2.24,-0.08l-3.11,-1.36l-4.51,-1.34l-2.03,-1.17l-1.55,-1.51l-2.66,-4.3l-3.12,-4.06l-4.42,-3.45l-1.18,-2.09l-0.17,-2.44l0.46,-1.61l1.69,-1.66l-0.1,-5.17l0.84,-1.12l0.65,-0.34l1.62,0.61l3.33,0.35l1.79,-0.52l0.82,-0.82l-0.25,-2.0l1.47,-1.31l2.42,-5.34l0.01,-1.15l-2.13,-4.68l0.7,-2.71l1.35,0.3l4.25,3.4l2.9,0.36l4.96,-1.3l6.36,-2.92l4.84,-4.18l3.98,3.16l1.47,0.7l2.33,-0.28l0.76,-1.24l2.07,-1.45l0.16,-0.53l-1.65,-3.28l0.12,-1.58l1.12,-2.38l1.3,-4.29l-1.53,-3.33l-0.92,-1.07l-2.81,-1.85l-1.63,-1.9l-7.9,-6.89l-0.26,-0.68l1.47,-1.0l1.31,0.09l2.44,1.75l4.86,1.73l1.9,0.12l1.11,-0.32l1.88,-3.42l2.24,-2.35l5.9,-4.86l1.17,-1.37l0.49,-2.05l1.56,-1.7l0.21,-2.27l1.29,-2.72l4.64,-6.85l0.77,-0.7l2.36,0.12l3.04,-1.2l1.92,-1.81l2.15,-0.19l3.42,2.25l0.46,0.01l2.0,-2.04l0.47,-0.1l0.82,0.75l1.17,0.5l0.56,-0.36l0.02,-0.87l0.44,-0.5l1.39,-0.88l5.74,-0.11l-0.52,2.17l-0.75,1.55l-0.69,3.26l0.38,0.97l0.66,0.51l2.79,0.69l2.94,0.27l3.58,-0.68l3.45,-3.38l2.32,-3.38l2.5,-2.65l0.39,-0.94l-0.45,-2.24l0.24,-1.31l2.44,-2.72l-0.19,-1.9l0.5,-0.95l1.55,-1.08l1.84,-2.9l2.45,-1.61l3.97,-3.77l1.62,1.99l2.04,1.5Z",name:"Huila"},"CO-VAU":{path:"M719.11,724.31l-0.19,0.23l0.44,2.31l-0.2,36.91l0.36,0.4l1.38,0.13l2.73,-1.66l2.1,-0.35l0.97,0.29l0.08,1.13l0.94,0.51l5.94,-0.85l1.31,0.05l3.29,0.99l3.97,-0.3l0.88,0.26l1.93,1.51l0.75,0.16l3.11,-2.11l1.64,-0.05l3.76,2.09l1.0,1.25l1.43,1.09l0.37,1.79l1.27,0.91l-0.18,2.28l0.98,0.94l2.39,1.32l0.0,0.46l-1.39,0.77l-0.13,1.39l0.59,3.89l-1.48,1.84l0.3,1.04l2.2,1.44l0.6,1.24l0.19,0.91l-0.24,0.49l-0.88,0.29l-2.29,-0.48l-1.68,1.5l-0.83,0.05l-2.86,-0.29l0.09,-1.5l-0.87,-0.8l-1.2,0.03l-2.44,0.87l-4.47,-4.42l-1.23,-0.8l-1.37,-0.3l-1.67,0.23l-3.13,1.77l-2.35,0.68l-1.51,2.27l-3.35,-1.1l-1.12,0.04l-2.5,1.87l-4.28,1.89l-8.83,1.26l-2.83,-0.24l-2.32,0.88l-0.73,-0.67l-0.67,0.28l-1.19,43.22l0.4,2.34l0.76,1.33l2.35,2.71l3.08,2.83l2.05,2.59l3.64,1.05l0.91,0.58l1.38,2.48l2.68,1.58l2.74,2.73l5.9,2.38l1.68,1.83l0.72,2.42l0.16,2.43l1.21,2.23l-0.35,1.28l-1.9,2.89l-0.38,1.39l0.68,1.53l2.65,3.25l-0.01,2.17l0.67,1.07l1.51,1.4l-0.12,1.74l0.44,1.02l2.47,1.46l1.36,1.94l1.51,0.91l0.24,2.45l-0.5,2.65l2.32,3.85l0.6,1.64l-1.03,2.65l-2.38,-3.18l-1.8,-0.48l-4.19,-2.09l-1.27,-0.1l-3.51,1.85l-0.68,-1.21l-0.1,-1.05l0.92,-2.98l-0.29,-1.22l-3.36,-3.36l-1.03,-0.58l-1.12,-0.17l-1.12,0.45l-1.01,2.28l-0.46,0.38l-1.05,0.0l-2.66,-1.07l-1.63,-0.01l-2.94,1.87l-0.95,-0.1l-0.69,-0.55l-0.02,-0.56l0.81,-1.8l0.09,-1.58l1.36,-1.32l0.77,-1.61l-0.74,-1.02l-1.51,0.07l-2.58,1.1l-2.1,-0.83l-1.87,1.53l-2.14,-0.82l-0.93,0.05l-1.0,0.53l-1.6,2.05l-0.02,0.46l0.96,1.47l1.51,1.19l0.57,1.34l-0.42,0.85l-0.87,0.55l-1.08,0.15l-1.0,-0.26l-3.26,-2.7l0.99,-3.04l-0.44,-1.06l-0.5,-0.19l-0.82,0.32l-1.53,1.41l-0.81,0.15l-0.88,-0.7l-1.08,-2.18l0.18,-0.79l0.58,-0.62l1.89,-1.21l1.34,-2.07l0.0,-0.43l-1.29,-1.99l-1.8,-1.89l-0.47,-1.89l2.29,-1.98l0.11,-1.1l-0.8,-2.78l0.37,-4.62l-0.28,-1.12l-1.37,-1.12l-2.23,0.39l-0.05,-0.86l1.16,-1.59l4.36,-4.31l-0.36,-1.29l-2.83,-1.16l-1.38,-0.0l-2.4,1.02l-0.77,0.87l0.05,1.76l-0.28,0.43l-0.91,0.15l-3.19,-0.68l-2.32,0.1l0.05,-2.02l-0.49,-1.31l-1.72,-2.28l-1.18,-0.8l-1.1,-0.23l-2.96,0.22l-0.69,-0.28l-1.13,-1.41l-0.98,-0.59l-2.84,0.16l-2.34,-1.68l-2.63,-1.07l-1.51,0.29l-0.88,1.94l-0.55,0.38l-3.22,0.01l-1.72,-3.52l-1.4,-4.02l-2.32,-2.93l0.59,-2.38l-0.35,-2.17l-3.15,-4.52l-0.75,-0.47l-0.98,-0.08l-1.96,0.69l-5.69,-2.34l-0.49,-0.82l-0.61,-2.61l-1.24,-1.4l-1.36,0.06l-2.45,1.08l-1.82,-0.06l-1.74,-0.72l-3.34,-3.16l-4.2,-1.78l-2.68,0.58l-2.14,-0.47l-2.26,0.72l-2.99,-1.96l-6.0,-2.84l-2.02,-3.01l-2.13,-0.97l-1.96,-3.06l-1.21,-0.14l-1.73,1.24l-0.51,-0.02l-0.18,-0.42l0.49,-2.03l-0.07,-1.2l-5.52,-4.1l0.0,-1.1l0.55,-0.94l0.01,-1.12l-0.37,-0.95l-1.85,-1.71l-0.86,0.24l-0.41,0.6l-0.7,-0.52l-0.79,-3.38l-0.67,-1.34l-0.68,-0.45l11.0,-11.49l3.74,-3.46l1.82,-3.3l0.73,-0.59l0.93,-0.2l2.35,0.5l0.88,-0.25l3.95,-3.73l1.51,-2.52l0.25,-2.36l1.4,-0.3l0.26,-1.95l0.47,1.87l0.55,0.71l1.14,0.4l0.93,-0.46l0.14,-0.81l-0.29,-0.74l-2.74,-4.79l0.03,-2.61l3.39,-7.6l0.81,-3.27l2.0,-4.28l0.54,-2.1l2.18,-3.1l0.63,-3.05l0.25,-4.82l0.48,-0.1l1.69,1.29l1.99,0.71l1.28,1.34l2.1,0.33l6.29,-5.02l4.93,-2.61l3.14,-1.15l3.59,-2.13l3.69,-3.89l9.54,0.05l2.62,0.97l2.94,-0.16l1.95,-1.03l7.62,-1.89l3.27,-2.19l6.29,-0.77l4.86,-1.39l3.61,-0.46l1.14,-0.52l4.09,-3.28l-0.77,4.78l-2.62,6.43l-0.08,1.24l0.44,0.97l6.56,5.5l3.12,1.62l2.01,0.7l2.85,0.21l3.84,1.45Z",name:"Vaup\xe9s"},"CO-NSA":{path:"M491.4,358.3l1.5,0.4l1.61,1.48l1.29,0.38l2.29,1.48l1.5,-0.17l3.15,-1.68l2.27,-2.4l2.27,-3.42l0.32,-1.96l-0.18,-2.18l0.4,-1.57l2.29,-1.37l1.33,-1.66l0.31,-1.08l-0.18,-1.75l-1.12,-0.6l-0.74,-1.06l-2.76,-0.42l-0.61,-0.65l-0.25,-3.3l-0.92,-2.08l-0.8,-0.6l-0.26,-4.55l0.21,-1.22l2.57,-6.43l0.84,-3.79l-0.2,-2.83l-1.42,-1.22l-2.29,-0.22l-0.85,0.25l-0.37,1.01l0.78,1.99l0.32,2.04l-1.61,1.29l-1.07,1.35l-0.46,-1.77l-1.84,-1.24l-1.63,-0.23l1.52,-1.93l0.68,-2.9l-0.84,-1.07l-1.16,-2.69l-1.71,-2.43l-0.51,-1.37l0.13,-1.91l0.71,-1.25l4.06,-3.69l0.24,-1.91l1.82,-1.26l1.22,-1.58l0.0,-0.95l-1.24,-4.32l0.41,-1.7l-0.25,-2.92l0.76,-8.36l-0.23,-2.25l1.06,-1.87l0.38,-0.17l2.62,-0.61l6.61,-0.16l2.69,-0.39l2.28,-1.14l3.04,-2.58l2.96,-1.23l2.6,-2.42l1.04,-0.04l0.91,2.31l-0.2,1.17l0.89,1.07l0.22,1.37l-0.16,2.52l0.34,1.45l1.15,1.63l1.61,0.43l4.43,-2.28l1.61,0.21l0.48,-0.32l1.83,1.41l0.18,0.39l-0.76,1.22l0.04,0.47l0.97,1.12l6.54,24.96l1.26,2.12l12.07,13.06l0.86,0.7l1.69,0.67l0.65,0.65l0.93,1.8l0.15,0.93l-0.71,4.06l0.36,1.45l2.0,3.76l1.28,4.08l0.11,2.16l-0.78,1.11l-2.16,-0.21l-1.44,0.35l-1.38,3.21l-1.5,1.45l-1.9,0.97l-0.36,0.93l0.3,0.83l1.68,2.12l0.39,3.53l-1.35,4.78l-0.56,6.39l1.2,4.83l-1.11,3.71l0.24,1.76l1.66,2.7l2.44,1.78l2.71,0.91l2.97,0.55l5.0,-0.07l1.85,0.52l2.37,2.92l-0.6,2.93l0.62,3.71l4.03,8.25l1.18,1.38l3.15,1.68l0.98,0.83l-0.94,-0.02l-4.02,-1.48l-5.19,-0.11l-1.8,0.93l-0.56,1.54l-1.32,1.26l-0.47,-0.03l-0.66,-1.27l-1.4,-0.34l-0.45,0.21l-2.3,4.68l-2.3,2.31l-0.96,0.57l-2.13,-0.05l-3.41,-1.85l-1.62,-0.34l-1.38,1.57l-0.89,0.21l-0.01,-4.03l-0.45,-2.14l-0.58,-0.74l-1.11,-0.25l-3.21,0.72l-1.39,-0.24l-0.51,0.22l-0.44,0.84l-0.49,-1.21l-0.79,-0.45l-1.71,0.13l-1.6,0.76l-3.31,-2.68l-2.96,-0.62l-1.62,-0.77l-0.27,-0.58l3.33,-5.45l-0.46,-2.9l-1.05,-0.7l-1.5,-2.09l2.13,-2.72l0.13,-3.45l-0.91,-0.65l-2.48,-3.86l-0.45,-3.05l-4.31,-3.38l-0.47,-0.78l-0.66,-2.66l0.22,-1.08l-0.29,-0.52l-2.4,-0.48l-1.74,0.76l-3.45,-0.69l-4.47,-0.2l-1.77,-0.42l-1.13,0.69l-1.02,1.48l-0.69,2.97l-5.71,-0.25l-1.91,-1.41l-4.55,-0.78l-1.65,-0.86l-0.97,-1.27l-0.35,-1.1l-1.5,-1.77l-1.52,-1.34l-2.08,-1.15l-1.07,-1.17Z",name:"Norte de Santander"},"CO-RIS":{path:"M355.15,495.38l0.23,6.87l1.33,0.89l2.21,-0.25l4.94,-1.9l2.8,2.51l0.48,1.67l0.91,1.09l-1.22,1.92l-1.3,0.46l-2.28,-0.58l-1.02,-0.91l-1.25,0.15l-1.46,-0.54l-0.62,0.11l-1.17,0.94l-0.39,0.82l0.08,0.88l0.22,0.66l0.65,0.56l0.1,1.26l-1.53,3.48l-0.39,1.81l-1.13,-0.57l-1.66,0.01l-0.47,0.31l-2.22,4.86l1.25,1.82l0.11,1.41l0.52,1.34l2.48,2.69l2.75,0.72l1.87,-1.84l0.45,-3.21l1.54,-2.39l2.23,5.28l0.86,0.62l2.18,-0.07l1.78,-1.49l1.47,2.31l3.62,0.16l3.42,0.67l2.45,3.16l4.24,3.86l-0.69,4.68l-2.94,1.82l-2.78,0.76l-2.48,-1.66l-2.35,-0.3l-5.35,0.07l-2.19,-1.02l-1.25,0.4l-4.01,-0.58l-2.34,-0.71l-1.37,0.02l0.26,-0.72l-0.16,-1.29l-0.84,-0.64l-1.05,0.2l-0.9,0.77l-1.13,-0.08l-0.73,-0.54l-0.04,-1.07l-0.78,-1.47l0.85,-1.18l0.13,-2.02l-0.4,-0.37l-1.09,0.44l-1.37,0.03l-0.81,-0.37l-0.36,-2.36l-2.13,-1.8l-3.15,-5.61l0.05,-2.79l-0.89,-1.66l0.08,-1.75l-0.58,-2.21l-4.98,-8.15l-0.17,-2.46l1.0,-3.26l4.43,-2.99l0.79,-4.91l1.98,-2.09l1.4,0.71l0.75,1.4l2.59,2.05l2.21,0.82l3.76,0.32Z",name:"Risaralda"},"CO-VID":{path:"M651.23,654.92l-0.33,-0.4l-2.16,-0.43l-1.04,-0.65l-1.19,0.13l0.2,-123.82l1.98,-2.44l4.02,-9.57l0.82,-0.93l3.49,-1.25l10.62,-9.22l1.07,-0.47l0.6,-0.82l0.49,-3.83l0.86,-0.79l2.61,-1.07l2.37,-1.66l4.0,-2.15l3.93,-2.92l2.57,-0.61l3.77,-1.49l6.96,-0.65l2.57,-0.52l3.95,-2.12l3.33,-2.98l2.47,-4.11l2.56,-2.64l1.06,-1.81l4.28,-9.85l3.1,-3.9l1.65,-1.03l1.83,-0.42l12.86,0.48l2.5,-0.5l6.13,-3.65l4.47,-1.79l1.44,-0.26l1.03,0.52l2.6,2.96l1.8,1.05l3.45,-1.94l3.64,-3.51l1.34,-0.8l1.66,-1.58l1.02,-0.45l1.34,-0.05l3.41,1.27l1.24,-0.26l4.03,1.08l5.14,-0.0l3.84,1.17l2.61,0.42l2.6,1.19l1.46,0.17l1.12,-0.46l2.09,-1.61l3.79,-0.21l4.42,-1.31l2.41,0.01l3.95,1.09l2.35,0.01l7.0,-2.49l2.57,-0.35l7.78,0.73l2.49,-0.38l3.33,-1.03l0.71,-0.66l0.67,-1.85l2.15,-0.31l2.33,-1.95l5.67,0.65l9.42,2.2l1.67,1.05l3.3,2.83l1.62,0.21l-1.55,1.47l-0.29,0.97l0.01,2.34l2.3,3.72l1.57,1.15l0.4,1.06l-0.06,2.12l-3.74,2.03l-3.44,4.12l-3.57,3.37l-1.51,2.26l-1.03,2.56l-0.49,2.68l0.0,2.79l0.79,4.81l1.29,1.5l-0.11,0.48l-1.09,1.26l-0.89,2.42l-1.41,0.69l-1.58,1.54l-1.85,0.73l-1.17,1.18l-1.32,0.07l-2.26,1.88l-1.59,2.5l-0.6,2.68l0.59,2.51l1.16,2.91l0.07,1.35l-0.82,2.65l0.03,1.49l0.4,1.34l1.61,2.11l-0.78,1.46l-0.02,3.93l-1.2,4.77l-0.03,1.54l0.81,1.84l-0.56,5.72l-1.02,1.84l-0.35,1.44l-0.57,7.45l-1.03,1.08l-0.18,1.22l0.72,1.43l1.1,0.89l0.34,-0.17l0.72,0.51l0.97,2.94l1.12,0.71l-0.41,1.79l1.22,2.83l-1.23,2.66l-0.31,2.28l0.33,2.13l0.8,3.78l0.54,1.26l2.28,2.18l0.49,1.87l1.04,1.75l-0.12,0.69l-1.92,1.16l-2.87,4.06l-2.36,1.68l-2.13,0.09l-4.35,-2.06l-2.49,1.31l-0.39,-0.05l-0.73,-3.53l-0.72,-0.07l-1.26,2.11l-0.48,0.21l-0.92,-0.69l-0.92,-1.58l-1.0,-0.65l-0.98,0.37l-1.67,2.9l-1.96,1.9l-0.69,-0.31l0.68,-1.64l-0.74,-1.13l-0.43,-0.11l-1.47,0.52l-2.13,1.13l-0.95,-3.44l-1.45,-0.6l-4.0,-0.48l-1.27,0.9l0.16,1.27l0.88,1.28l-0.55,0.69l-0.62,1.87l-4.11,0.51l-0.7,1.23l0.42,1.19l-1.31,0.69l-0.34,0.65l-1.72,0.37l-1.1,0.82l-1.38,2.07l-1.91,-0.68l-2.12,1.44l-1.74,0.15l-3.07,-0.86l-1.23,1.09l-1.68,0.36l-0.3,0.34l-0.21,1.95l-0.49,0.18l-2.39,-0.37l-1.04,0.68l0.17,2.23l-0.8,0.03l-0.65,-0.78l-0.89,-0.44l-2.74,1.23l-0.7,0.04l-0.56,-0.88l-1.5,-0.21l-0.63,0.42l-0.4,0.9l0.05,2.37l-0.43,0.29l-4.9,-0.76l-2.03,2.45l-0.67,0.21l-0.77,-0.85l0.17,-1.48l-0.38,-0.44l-2.21,-1.12l-2.21,1.27l-0.07,-1.03l-0.42,-0.49l-1.12,-0.47l-0.87,-0.87l-1.72,-0.05l-0.77,-1.1l-0.98,-0.55l-1.29,0.28l-0.59,1.45l-1.09,-0.71l-1.23,-0.08l-5.16,1.57l-1.4,-1.35l-1.33,-0.38l-2.96,1.14l-4.79,0.28l-0.73,0.4l-0.39,0.85l0.58,1.23l-0.29,2.15l-0.85,0.68l-0.95,0.18l-0.42,0.59l-0.4,3.49l-2.72,-2.05l-3.56,0.55l-5.2,0.0l-0.93,1.39l-0.91,-1.42l-0.87,-0.42l-1.17,0.17l-1.03,0.6l-2.11,2.92l-1.53,-0.51l-1.14,-0.89l-1.55,-0.16l-2.94,0.36l-0.26,0.59l1.6,2.36l-0.76,3.35l-0.43,0.36l-2.3,-0.06l-0.41,0.38l-0.06,1.38l-1.85,2.85l0.15,1.0l1.92,2.38l-0.9,0.22l-0.59,0.65l-0.13,1.12l1.01,1.84l-0.07,1.19l-0.29,0.13l-0.59,-1.41l-0.96,-0.12l-0.32,0.52l0.04,1.96l-0.42,0.19l-1.07,-0.78l-0.79,-0.03l-0.54,0.76l-2.27,1.53l-2.32,3.43l-1.33,1.16l0.43,0.99l2.25,0.74l-0.07,0.58l-1.36,0.63l-0.3,0.65l0.67,1.63l0.32,2.46l-0.32,0.91l-3.14,1.97l-0.9,2.2l-0.6,0.7l-6.41,2.96l-1.88,1.49l-5.53,-3.38l-2.33,-0.24l-1.05,0.79l-1.34,-1.67l-0.91,-0.56l-0.62,0.0l-0.54,0.59l0.65,2.46l-2.57,2.14l-0.17,-1.08l-0.54,-0.74l-1.3,0.12l-2.54,1.19l-1.14,-1.52l-0.95,-0.63l-1.13,-0.05l-1.22,0.55l-0.16,-1.5l-1.11,-0.82l-0.81,0.23l-0.42,1.4l-0.95,-1.31l-1.04,-0.75l-0.76,-0.04l-0.54,1.06ZM651.36,655.65l0.09,0.99l-0.2,0.32l-0.06,-0.33l0.17,-0.98Z",name:"Vichada"},"CO-BOL":{path:"M458.04,543.53l-0.05,-0.39l0.87,-0.6l0.43,-0.91l1.06,-0.42l1.39,-3.21l1.63,-1.42l0.22,-1.31l2.06,0.29l1.36,0.56l-0.41,2.4l0.3,5.5l-0.91,1.19l-0.13,0.79l0.26,0.67l0.89,0.73l0.88,0.05l-0.93,3.27l-1.3,0.87l-3.2,5.19l-1.55,1.59l-0.23,2.47l0.79,2.03l-0.25,1.62l-2.48,3.89l-0.25,1.0l-0.01,1.06l0.83,2.41l2.19,2.86l0.49,1.55l-2.05,2.1l-0.46,2.53l-0.95,2.61l-2.93,-0.69l-1.23,0.69l-2.09,3.85l-3.21,3.7l-0.05,1.5l-0.47,1.24l-1.16,1.91l-3.94,4.79l-1.52,3.08l-1.77,0.03l-1.39,-1.27l4.19,-5.88l1.58,-2.85l1.92,-4.75l0.18,-1.88l-0.5,-1.85l-0.11,-2.68l1.75,-4.67l0.49,-0.52l1.69,1.1l1.56,0.46l0.84,-0.37l1.04,-3.22l-0.03,-2.6l1.14,-1.36l1.05,-2.26l1.39,-8.53l-0.3,-0.62l-1.02,-0.14l2.04,-5.58l0.14,-2.54l-0.74,-2.73l-2.01,-2.55l3.31,-2.16l0.38,-1.11l-0.7,-0.52Z",name:"Bogota"},"CO-CUN":{path:"M235.21,391.13l-0.13,-0.55l-1.3,-0.69l-1.27,-1.45l4.35,-13.97l1.24,0.25l1.34,-0.21l1.3,-0.74l1.01,-1.22l0.61,-1.69l-0.2,-1.62l-1.35,-2.63l-0.52,-1.81l-0.28,-2.5l0.34,-1.99l1.09,-0.6l3.37,2.75l0.43,0.49l-0.11,1.12l0.84,0.4l2.05,2.95l0.82,3.17l0.98,0.82l1.38,-0.14l4.49,-4.09l8.46,-5.26l1.84,-1.66l-0.27,-1.55l-1.29,-1.29l-0.72,-1.59l1.92,-2.81l1.52,-3.42l1.19,-1.19l3.76,-1.59l1.76,-0.37l2.2,0.02l0.59,-0.33l0.12,-0.5l-0.47,-0.95l-1.85,-1.71l-0.34,-0.75l-0.12,-1.48l-1.3,-4.76l-1.79,-3.45l-2.13,-3.15l-1.79,-3.43l-2.42,-0.76l-0.57,-0.88l-1.03,-6.35l-1.91,-3.89l-0.85,-0.71l-1.02,-0.34l-2.1,-0.02l0.47,-2.79l2.31,-2.46l0.8,-1.62l-0.29,-2.11l3.44,-1.3l0.38,-1.47l0.45,0.28l0.63,2.2l2.56,3.51l1.45,4.77l4.09,2.86l3.9,1.84l5.58,8.86l1.46,1.07l2.56,0.18l1.42,5.02l0.39,4.95l-0.91,2.83l-1.6,1.31l-0.45,1.06l-1.11,6.13l-4.06,3.49l-1.46,-0.29l-0.48,0.39l0.0,2.5l0.33,0.47l-0.47,0.32l-0.18,0.66l0.46,0.83l8.44,7.92l6.3,4.5l6.27,6.78l4.93,6.08l2.83,2.04l2.97,0.58l3.22,2.67l0.75,1.03l1.25,3.69l0.18,6.71l-0.41,1.58l-1.88,3.12l-8.1,-2.11l-5.19,0.28l-3.04,0.83l-1.14,0.78l-0.26,1.07l0.58,1.41l1.19,1.22l0.53,3.11l-0.23,0.75l-1.79,1.84l-3.0,-0.18l-1.86,1.11l-3.49,0.95l-0.26,0.47l0.18,2.88l0.2,0.67l1.03,1.11l-1.15,1.41l0.27,0.66l1.25,0.08l0.32,1.4l0.7,0.49l0.65,0.07l0.81,-1.15l-0.32,1.31l0.45,0.92l2.03,0.55l-0.05,0.31l-0.76,-0.25l-0.4,0.2l-0.53,0.95l-0.17,1.36l0.33,0.95l0.55,0.21l0.59,-0.3l0.62,0.3l0.7,1.19l0.1,1.3l1.64,1.91l0.97,-0.08l1.18,1.47l-0.92,1.89l0.15,0.62l0.8,0.41l-0.73,0.19l-0.31,0.59l1.04,2.09l-0.57,0.82l0.53,0.71l-0.66,1.45l0.07,2.3l0.69,0.72l0.99,0.28l0.36,1.59l1.73,1.92l0.86,2.31l0.63,0.86l0.95,0.65l1.59,0.42l6.46,0.01l13.3,-1.85l4.23,0.28l1.0,0.7l0.47,0.85l0.55,3.71l1.47,3.89l1.88,2.34l1.51,0.59l1.67,0.07l1.3,0.63l0.33,2.45l-1.65,4.07l-0.17,1.7l0.74,3.0l2.18,3.71l0.17,1.4l-0.76,3.79l1.01,1.64l2.14,2.19l-2.13,2.39l-0.74,4.76l-4.28,2.79l-1.2,3.78l0.24,2.81l4.96,8.07l0.55,2.09l-0.04,1.91l0.84,1.46l-0.05,2.68l-2.35,2.07l-1.53,1.87l-1.75,4.91l-2.41,2.73l-5.4,4.88l-0.86,1.79l-0.07,0.71l0.55,1.53l-0.71,1.1l-6.73,5.97l-1.42,4.17l0.46,2.97l-0.76,2.59l-1.02,0.81l-1.65,0.52l-2.8,0.31l0.02,0.99l1.05,1.91l1.94,1.99l-0.33,3.23l0.27,1.65l2.68,1.55l0.71,0.73l-0.28,0.79l-1.52,1.46l-2.96,1.23l-2.95,3.54l-0.61,1.52l-4.41,-0.68l-0.8,0.4l-3.85,3.53l-0.62,0.19l-0.96,-0.07l-2.66,-1.05l-1.04,-1.0l-0.81,-0.25l-1.99,0.21l-1.28,-0.62l-2.42,-3.78l-1.56,-1.17l-2.04,-0.13l-1.93,1.36l-2.69,-0.15l-3.41,-3.68l-2.05,-1.1l-1.39,-0.07l-2.53,0.98l-0.91,-0.77l-0.41,-0.87l0.0,-1.55l-0.35,-0.94l0.91,-1.17l-0.31,-0.65l-5.87,-0.18l-2.81,-4.38l1.6,-2.3l0.85,-3.54l0.5,-0.77l1.48,-0.95l0.0,-0.41l-0.53,-0.38l-0.65,0.22l0.77,-3.99l0.03,-6.78l0.58,0.47l0.6,-0.15l0.47,-1.85l-0.41,-1.2l-1.28,-0.67l-0.26,-1.85l0.71,0.1l0.94,0.65l1.58,2.11l0.38,0.0l0.38,-0.54l-0.78,-2.06l-2.51,-3.03l-0.39,-1.95l-0.55,-0.29l-0.82,0.27l-0.42,-1.99l-0.72,-7.77l-0.38,-1.04l-0.37,-9.03l0.82,-3.93l0.77,-1.74l-0.16,-0.5l-0.69,-0.42l0.06,-2.59l-0.85,-1.18l-0.44,-3.42l-0.52,-0.35l-0.74,0.24l-0.41,-0.59l0.01,-0.41l0.6,0.27l0.91,-0.5l-0.03,-0.65l-0.7,-0.74l-0.41,-2.28l-0.62,-0.76l-1.58,-0.39l-1.54,-1.74l-1.04,-0.37l-1.73,0.18l-0.68,0.71l-0.52,-0.31l-1.53,0.25l-0.23,-0.37l0.4,-0.44l0.95,-0.25l0.53,-0.64l2.08,-3.84l2.35,-0.37l1.89,-1.47l0.71,-0.13l2.88,1.21l1.76,-0.54l0.98,-1.86l-0.02,-0.98l1.0,-0.08l0.45,-0.86l1.93,-1.39l1.07,-2.27l-0.06,-3.46l-0.94,-2.19l-3.05,-4.5l-0.06,-1.26l-2.4,-6.56l-0.83,-0.26l-0.4,0.84l-0.62,-1.65l-1.58,-2.43l-3.7,-4.51l-0.81,-1.78l0.47,-4.52l-0.12,-1.49l1.71,1.42l1.42,1.82l0.55,0.08l0.73,-0.56l0.61,-1.05l0.87,-2.31l0.2,-3.37l-1.23,-2.14l0.9,-0.43l0.74,0.66l0.65,-0.19l0.25,-0.93l-0.22,-1.06l-1.26,-1.33l0.9,-1.54l0.34,-2.19l0.78,-0.98l0.27,-1.35l-0.14,-1.48l-0.61,-1.22l-3.6,-3.23l0.39,-2.59l-0.18,-0.78l-0.62,-0.54l-2.69,-1.35l-1.72,0.3l-1.41,1.06l-0.72,0.94l0.17,0.77l-0.7,0.29l0.34,-2.66l-2.52,-5.42l-1.25,-1.72l-1.83,-1.79l-2.98,-1.45l-1.05,0.18l-0.41,0.5l-0.19,-2.66l0.47,-1.51l1.67,-0.79l0.77,-1.41l-0.77,-2.44l-1.89,-3.59l-0.77,-0.21l-0.27,0.44l-4.52,-4.85l-2.33,-0.86l-0.82,-1.42l-0.55,-0.27ZM260.4,575.65l0.37,-0.94l0.57,-0.48l2.16,-0.18l1.17,-1.7l1.01,0.01l0.74,0.88l-1.4,-0.04l-2.8,2.14l-1.83,0.32ZM266.95,573.64l0.5,0.08l1.25,-0.48l-0.1,0.54l-0.77,0.49l-0.87,-0.62ZM253.41,572.91l0.23,-1.3l1.31,-0.58l1.27,-1.12l0.6,-0.21l3.08,0.41l0.34,-0.6l-1.04,-1.06l1.15,0.0l0.4,-0.35l-0.3,-0.44l-1.04,-0.3l1.91,-1.06l0.22,-0.39l-0.2,-0.26l1.27,0.92l1.98,2.96l1.26,0.68l-2.7,0.73l-5.07,-0.35l-1.04,0.18l-1.52,1.49l-2.1,0.64ZM266.43,570.3l2.24,-0.41l0.52,0.1l-1.33,1.74l-1.44,-1.44ZM260.52,565.23l-0.04,-0.01l0.0,-0.01l0.04,0.02Z",name:"Choc\xf3"},"CO-GUV":{path:"M492.49,683.75l0.12,0.86l0.6,0.54l1.33,-0.13l1.87,-1.11l1.12,1.73l2.25,-0.11l1.3,0.55l0.68,-0.58l0.21,-0.91l0.06,1.77l0.76,0.7l1.13,-0.77l0.76,-0.01l1.2,0.89l0.39,-0.19l0.67,-1.29l0.41,0.04l-0.01,0.93l0.68,0.54l1.48,-1.09l1.62,0.52l2.5,-0.33l0.92,-0.81l-0.37,-1.05l1.57,-0.81l1.05,0.37l1.43,-0.2l1.0,1.36l0.94,0.01l0.78,-0.44l0.37,-1.46l1.37,0.68l2.56,-1.9l1.17,-0.26l1.31,0.35l3.15,-2.01l0.97,-1.13l1.22,-0.23l0.47,-1.08l-0.81,-1.26l0.17,-0.56l1.11,-0.67l0.74,-1.37l5.1,-2.91l1.4,-0.25l1.59,1.97l1.76,0.56l1.21,-1.08l0.57,-1.33l0.56,-0.51l1.75,-0.34l0.47,0.23l0.56,2.39l0.86,0.45l0.88,-0.5l0.43,-2.39l0.56,-0.5l0.91,1.32l-0.04,0.58l0.96,0.46l0.55,-0.37l0.17,-2.83l0.51,-0.51l1.4,-0.02l0.39,-0.4l-0.22,-0.77l-0.96,-0.86l2.5,0.6l2.07,-1.38l3.2,-0.38l3.44,-2.66l0.82,-0.07l2.25,1.32l0.59,-0.23l0.36,-1.21l0.69,-0.65l0.7,0.72l1.03,2.43l0.71,-0.16l0.21,-3.3l1.44,-0.9l1.42,-0.09l0.5,-0.35l-0.23,-3.66l0.22,-0.62l0.51,-0.26l3.48,-0.77l0.6,0.2l0.74,1.32l1.11,0.85l3.68,0.57l1.61,1.1l0.75,0.05l2.56,-0.77l6.21,-1.17l1.42,-0.67l1.33,-1.15l0.45,0.37l0.65,1.96l1.12,0.2l0.57,-0.79l0.25,-1.09l0.02,-1.9l2.29,2.13l1.06,0.36l1.0,-0.38l0.93,-0.98l-0.12,1.53l0.33,0.86l1.57,0.45l2.83,-1.22l1.18,-1.26l2.85,-0.39l2.64,0.63l1.01,-0.39l0.64,-1.05l3.32,1.8l1.26,-0.34l0.62,-1.39l1.59,1.01l0.74,-0.33l0.76,-2.23l0.42,-0.3l1.12,1.98l3.16,1.07l1.47,-0.24l2.05,-1.5l2.29,1.17l1.19,-0.69l1.73,0.71l2.37,-0.52l1.15,0.67l1.93,0.36l-0.05,1.94l0.9,0.62l0.86,-0.88l-0.09,-2.29l0.93,0.62l1.34,1.58l0.84,-0.41l0.08,-0.96l0.35,-0.32l0.56,0.5l0.07,1.73l0.56,0.25l1.51,-0.73l0.69,-0.01l0.76,0.5l0.86,1.42l0.85,0.3l3.46,-1.36l0.35,1.56l0.64,0.38l3.35,-2.63l0.06,-0.97l-0.64,-1.66l0.7,0.31l1.8,1.94l0.78,-0.19l0.56,-0.62l1.94,0.21l4.92,3.03l-23.28,9.62l-1.02,0.95l0.07,0.86l0.74,0.66l3.39,1.11l5.74,2.68l1.26,1.23l2.94,4.18l3.32,6.76l2.09,1.69l5.17,1.48l0.37,0.5l0.1,1.1l0.46,0.36l2.23,-0.35l2.05,-0.81l0.78,0.04l3.97,1.05l2.53,1.15l0.81,-0.54l0.28,-1.35l2.7,-0.43l1.39,0.82l1.57,0.0l3.03,-0.55l0.73,-0.77l2.42,-0.03l1.66,-0.81l1.11,0.48l2.49,3.55l-0.26,0.73l-6.18,4.54l-0.24,1.36l-3.9,3.12l-1.68,0.95l-3.5,0.43l-4.84,1.39l-6.33,0.78l-3.39,2.23l-7.55,1.86l-1.92,1.02l-0.97,0.17l-1.64,-0.03l-2.58,-0.97l-9.96,-0.02l-3.91,4.01l-3.47,2.06l-3.13,1.15l-4.98,2.64l-6.2,4.96l-1.43,-0.31l-1.11,-1.23l-2.18,-0.83l-1.68,-1.3l-1.29,0.13l-0.32,0.37l-0.26,5.07l-0.58,2.86l-2.16,3.08l-0.55,2.14l-2.03,4.35l-0.78,3.2l-3.43,7.75l0.01,3.04l2.77,4.84l0.16,0.78l-0.82,-0.1l-0.34,-0.4l-0.47,-2.05l-0.63,-0.37l-0.6,0.19l-0.45,0.58l-0.01,1.47l-0.8,-0.02l-0.61,0.45l-0.3,2.47l-1.3,2.23l-3.76,3.6l-1.07,0.13l-1.92,-0.45l-1.09,0.24l-1.02,0.77l-1.88,3.36l-3.69,3.4l-11.25,11.75l-2.27,-0.28l-1.14,-2.05l-3.37,-1.48l-5.15,-0.55l-1.48,-2.81l-2.75,-1.61l0.41,-2.81l-0.48,-1.43l-0.8,-0.26l-0.68,0.54l-0.74,-0.06l-0.83,-3.24l-2.5,-0.98l-0.82,-4.59l-0.75,-1.2l-2.88,-2.65l-4.27,-1.13l-4.91,-3.16l-1.76,-1.53l-2.97,-1.39l-2.36,0.37l-1.37,2.46l-1.44,-1.57l-1.82,-0.9l-0.72,0.19l-0.5,0.77l-1.5,0.51l-0.96,1.22l-0.89,2.7l0.1,2.54l-0.5,1.34l-2.69,1.31l-3.49,3.25l-1.43,1.81l-2.4,0.91l-1.12,0.02l-3.07,-1.01l-1.28,-0.75l-1.04,-0.8l-1.48,-2.53l-2.91,-1.16l-1.6,-2.07l-6.08,-5.37l-2.99,-3.37l-0.34,-3.53l-0.76,-2.14l-3.28,-4.82l-4.06,-3.37l-6.06,-8.82l-0.54,-2.22l0.8,-1.14l0.05,-37.05l0.32,-2.29l1.84,-2.93l-0.12,-1.48l1.31,-0.94Z",name:"Guaviare"},"CO-CAU":{path:"M718.66,462.43l-2.29,3.07l-4.28,9.86l-1.0,1.7l-2.52,2.59l-2.44,4.09l-3.2,2.86l-3.68,1.98l-9.5,1.16l-3.84,1.51l-2.65,0.64l-4.01,2.96l-4.0,2.16l-2.35,1.64l-2.71,1.13l-1.12,1.12l-0.53,3.95l-0.36,0.42l-1.0,0.42l-10.63,9.23l-3.33,1.15l-1.13,1.19l-4.1,9.7l-1.25,1.7l-2.27,2.09l-2.55,0.96l-1.71,1.03l-3.46,2.78l-3.56,0.56l-17.61,7.57l-4.8,3.27l-2.51,1.24l-5.36,1.66l-2.23,0.21l-5.37,5.64l-4.58,3.82l-2.26,1.36l-2.11,0.59l-0.99,-0.3l-1.2,-1.72l-2.42,-1.52l-1.56,-0.24l-10.6,2.5l-2.7,4.05l-1.13,0.29l-1.37,-0.19l-1.49,-0.78l-2.83,1.61l-1.13,0.3l-0.99,-1.26l-2.46,-0.7l-0.69,0.48l-1.5,2.41l-1.03,-0.78l-1.21,0.41l-2.89,-0.45l-2.32,1.35l-1.47,-0.75l-0.5,-2.27l-0.68,-0.26l-0.98,0.17l0.13,-0.87l-0.62,-1.61l-1.1,-1.25l-0.29,-0.84l-0.74,-0.39l-0.85,0.04l-5.26,-5.59l-4.1,-7.5l-3.12,-3.33l-0.36,-1.66l0.21,-1.23l-1.16,-3.43l1.15,-3.8l0.18,-2.72l0.92,-3.87l0.76,-0.35l2.19,0.94l0.46,-0.1l2.87,-3.29l1.27,-3.52l-0.55,-0.88l-1.45,-1.15l-0.82,-1.7l0.02,-0.73l0.46,-1.77l0.66,-1.03l-0.2,-1.97l3.77,-5.18l3.74,-3.22l0.93,0.41l4.69,5.72l1.76,0.15l3.48,-3.16l2.65,-1.55l2.14,-3.5l8.05,-8.77l0.98,-0.31l1.54,2.12l2.23,1.59l0.62,0.17l0.79,-0.46l1.11,-4.87l1.16,-1.4l0.97,-3.12l1.7,-1.37l-0.0,-0.61l-1.37,-1.15l-1.45,-2.03l-1.1,-0.85l-0.56,-1.51l-2.48,-1.8l-5.61,-3.0l-0.01,-0.84l0.79,-0.76l2.5,-0.84l1.59,-5.01l0.54,-3.05l0.88,-1.69l0.05,-1.51l-1.78,-1.79l-1.36,-3.85l-1.31,-1.11l1.21,-4.27l2.44,-3.94l0.61,-0.31l-1.04,2.15l0.31,2.31l1.45,2.46l2.33,2.32l1.44,2.89l2.08,1.56l4.33,2.51l1.67,0.36l1.29,-0.05l3.39,-2.47l3.27,-0.8l3.44,-1.6l5.49,-0.29l8.04,-2.75l4.55,-0.01l2.23,-0.61l3.07,1.18l1.97,-0.42l3.94,-0.07l4.23,-1.56l3.05,-0.26l3.69,-1.84l3.47,-0.13l1.06,-0.76l3.77,1.08l4.73,0.13l1.95,0.35l4.42,1.56l5.86,0.43l4.49,-1.05l3.77,1.42l3.36,0.02l4.73,-0.8l5.51,-0.18l7.94,-3.1l1.47,-0.18l4.02,0.79l6.96,-0.1l2.71,1.01l1.67,1.85l2.19,1.45l0.9,2.07l0.91,0.72l5.14,2.12l1.77,1.57l0.26,1.66l1.01,1.22l1.59,0.74Z",name:"Casanare"},"CO-CAS":{path:"M487.53,729.86l0.58,2.33l6.14,8.93l4.11,3.44l3.17,4.67l0.67,1.89l0.45,3.83l3.12,3.51l6.07,5.36l1.61,2.08l2.94,1.18l1.4,2.45l1.23,0.95l1.42,0.82l3.18,1.04l2.28,-0.12l1.0,-0.36l1.44,-1.0l0.97,-1.44l3.43,-3.2l2.87,-1.49l0.63,-1.72l-0.12,-2.44l0.85,-2.56l0.67,-0.87l1.51,-0.51l0.65,-0.81l1.44,0.73l1.77,1.84l0.59,-0.09l1.39,-2.53l1.73,-0.32l1.82,0.72l2.63,2.08l4.98,3.2l4.26,1.12l2.71,2.51l0.57,0.89l0.9,4.76l0.85,0.65l1.67,0.38l0.56,2.72l0.51,0.73l0.93,0.3l1.08,-0.64l0.32,0.88l-0.3,3.21l0.77,0.75l1.63,0.53l0.44,0.43l1.62,2.95l5.37,0.65l3.09,1.32l0.65,1.64l0.66,0.54l2.67,0.37l0.8,0.43l1.55,4.83l1.35,0.77l0.95,-0.86l1.36,1.25l0.32,0.82l-0.03,0.76l-0.56,0.95l0.14,1.73l5.5,4.07l-0.55,2.74l0.35,0.99l1.25,0.28l1.95,-1.29l0.55,0.13l1.74,2.91l2.15,0.98l2.01,3.0l6.17,2.96l3.03,1.99l0.96,0.02l1.66,-0.68l2.16,0.46l2.55,-0.58l3.94,1.71l1.49,1.43l-3.75,3.66l-3.07,1.73l-11.17,4.92l-3.89,2.62l-2.41,2.73l-1.58,4.51l-1.17,1.18l-1.83,0.77l-2.27,0.45l-10.27,0.14l-1.6,0.8l-2.29,2.22l-3.19,1.77l-6.43,8.67l-0.47,2.12l0.15,3.84l-0.31,1.31l-2.08,1.9l-2.45,0.44l-1.96,-1.27l-1.92,-1.95l-2.26,-1.13l-1.61,0.69l-1.93,1.64l-2.95,3.35l-1.32,1.99l-0.61,0.07l-2.94,-1.62l-6.35,-5.16l-1.87,-0.8l-2.16,0.35l-2.13,1.41l-3.97,0.76l-6.69,-4.46l-0.45,0.01l-3.7,2.61l-1.37,1.42l-4.9,0.85l-2.26,-0.21l-6.65,-5.57l-1.27,-0.33l-2.15,1.2l-1.23,0.23l-5.42,0.08l-4.43,-0.71l-0.61,-0.35l-1.08,-2.45l-0.7,-0.67l-2.25,-0.05l-0.57,-0.32l0.06,-1.83l-0.48,-0.55l-4.01,-1.89l-1.23,0.01l-2.42,1.19l-0.93,0.03l-4.68,-0.88l-7.43,-2.58l-1.24,-0.82l-2.0,-2.36l-4.47,-3.08l-2.3,0.72l-0.85,-0.03l-0.75,-1.85l-0.72,-0.42l-1.56,-0.01l-1.43,0.4l-0.49,-0.28l-0.61,-0.91l-0.77,-2.78l-1.05,-1.15l-2.26,-1.18l-1.36,-0.3l-2.97,0.83l-0.66,-2.26l-1.22,-0.7l-1.28,0.34l-0.78,1.91l-0.59,0.29l-1.94,-0.73l-2.18,0.36l-2.26,-0.52l-0.73,-0.43l-1.14,-2.4l-3.12,-0.49l-0.49,-2.23l-0.65,-1.23l1.47,-2.59l-0.01,-0.47l-2.12,-1.2l1.08,-2.02l-0.38,-2.49l-1.57,-2.01l-2.38,-1.31l-6.76,-1.3l-3.85,-2.08l-2.53,-0.84l-0.35,-0.47l-1.25,-5.53l0.35,-4.2l-0.97,-1.92l-2.32,-0.44l-2.13,0.3l-0.46,-1.51l-1.2,-0.63l-4.17,1.14l-1.09,-0.39l-1.64,-3.15l0.2,-4.15l-2.34,-3.62l0.03,-1.78l-0.89,-1.42l-2.21,-1.13l-1.24,-0.28l-3.51,0.43l-5.07,-0.32l-2.25,-0.8l-3.65,-3.87l-2.56,-1.23l-2.94,-0.37l-5.18,0.3l-3.25,-1.63l-2.49,-0.27l-0.92,-0.53l-3.2,-3.81l-0.68,-1.32l-0.38,-2.53l-1.04,-0.9l-1.31,-0.33l-3.28,0.17l-2.47,-0.86l-0.8,0.12l-5.86,-5.26l-0.94,-0.25l-2.26,0.38l-2.71,-0.5l-0.92,-0.51l-1.27,-2.1l0.77,-9.11l1.6,-2.53l0.36,-2.09l1.37,-2.94l3.72,-5.84l0.97,-0.64l8.28,0.91l1.78,-0.25l1.35,-0.64l3.18,-3.41l4.04,-3.11l0.88,-1.51l5.14,-5.69l7.01,-10.05l4.59,-4.19l7.84,-12.96l4.7,-3.42l2.32,-2.55l1.71,-3.13l1.95,-6.82l0.83,-1.3l1.13,-0.78l3.03,1.36l2.26,-0.63l5.31,-4.06l2.1,-2.37l0.55,-1.41l-0.49,-1.81l-1.45,-1.62l-1.39,-0.91l-0.41,-1.25l0.25,-1.03l1.93,-3.98l2.6,-3.39l3.22,-2.95l1.28,-0.46l5.93,1.91l4.07,0.68l0.98,0.57l1.19,1.52l1.76,4.54l0.98,1.4l2.31,1.95l0.65,1.04l0.02,2.01l-3.36,13.39l-0.48,5.07l0.25,2.15l0.64,1.93l1.02,1.58l3.66,4.09l1.46,2.47l0.05,1.07l-0.35,1.0l-3.36,4.18l-0.73,2.06l-0.02,2.19l0.6,2.88l1.38,2.96l2.09,2.64l2.59,1.79l35.94,12.68l4.09,0.26l5.75,-0.45l4.7,0.78Z",name:"Caquet\xe1"},"CO-CAQ":{path:"M368.37,526.29l-1.43,1.23l-1.09,0.18l-0.85,-0.27l-2.46,-5.65l-0.77,-0.23l-2.1,2.98l-0.28,2.61l-0.42,0.99l-1.12,0.97l-1.11,-0.23l-0.93,-0.39l-1.62,-1.53l-0.96,-1.7l-0.24,-1.86l-1.14,-1.46l1.24,-3.14l0.83,-1.29l1.34,0.01l1.29,0.76l0.61,-0.25l0.46,-2.23l1.59,-3.71l-0.18,-1.73l-0.8,-0.97l0.11,-0.99l1.0,-0.8l1.46,0.52l1.05,-0.2l1.09,0.91l2.78,0.63l1.69,-0.68l1.21,-1.8l0.19,-1.05l-0.97,-1.14l-0.2,-1.26l-2.16,-2.37l-1.32,-0.9l-0.66,-0.03l-1.16,0.71l-0.78,0.03l-2.73,1.14l-2.03,0.23l-0.76,-0.59l-0.09,-6.54l2.98,-1.23l3.97,-2.78l0.6,-0.08l2.08,1.68l0.77,0.25l4.02,0.02l1.56,0.46l0.5,-0.31l0.36,-2.77l-1.09,-4.6l0.33,-2.64l-0.26,-0.45l-0.72,-0.25l-0.24,-0.53l0.0,-1.6l2.84,0.83l1.48,1.94l2.9,1.21l1.18,-0.09l2.52,-1.37l2.28,1.13l0.32,0.64l-0.06,2.42l2.31,2.09l1.41,4.15l-0.12,3.1l0.54,0.42l1.24,-0.48l0.78,2.07l0.46,0.25l0.93,-0.39l1.99,-3.14l0.88,-0.75l2.04,-1.18l2.18,-0.39l0.74,-0.42l0.17,-0.63l2.51,-3.18l0.05,-3.67l2.02,-0.2l2.02,-0.84l0.87,-0.69l1.06,-1.6l7.24,-1.75l1.07,0.3l1.06,0.99l3.43,1.97l2.27,-0.8l1.74,-4.39l1.31,-0.23l1.96,1.15l0.17,2.25l0.73,1.04l-1.09,2.3l0.85,1.1l-1.35,4.05l0.26,0.53l0.8,0.24l-1.86,0.51l-0.41,0.88l0.45,0.91l0.59,0.27l-0.34,1.76l0.34,1.79l-0.71,0.3l-0.21,0.65l0.25,1.2l-1.04,0.99l-1.85,4.79l-1.66,1.6l-0.04,0.67l-4.68,-1.54l-3.01,0.75l-3.52,-0.45l-2.3,0.77l-2.21,0.21l-3.26,1.77l-0.3,1.0l-3.27,5.14l-1.13,-0.04l-1.61,-0.57l-1.76,0.78l-1.44,1.12l-1.01,0.34l-2.28,-0.14l-1.13,0.52l-2.73,2.83l-0.65,1.68l0.19,0.5l0.96,0.5l0.66,1.15l-1.8,3.51l-0.36,1.8l1.48,2.89l-0.07,0.72l-2.56,4.24l-4.0,-3.62l-2.61,-3.3l-3.73,-0.78l-3.44,-0.14l-0.97,-2.01l-0.76,-0.41l-0.65,0.38Z",name:"Caldas"},"CO-CES":{path:"M239.15,665.78l0.39,-0.85l-1.18,-0.73l0.26,-0.73l-0.25,-0.59l-0.52,-0.21l0.38,-0.86l-0.26,-0.59l-0.54,-0.27l0.85,0.22l0.84,-0.36l0.81,-0.64l1.79,-0.55l0.45,-0.79l-0.99,-0.6l-1.15,0.45l-0.82,-0.32l0.87,-0.64l3.04,0.2l0.6,0.93l0.83,0.26l0.36,-0.57l-0.59,-1.3l-1.95,-0.65l0.35,-0.52l2.45,-0.74l0.74,-0.75l1.53,1.2l0.36,-0.3l0.34,-1.41l-0.26,-0.47l-1.5,-0.46l-1.85,0.27l-1.01,0.54l-0.2,-1.61l0.29,-1.06l0.6,-0.47l0.54,0.06l1.63,1.5l1.12,0.23l1.62,-2.27l-0.31,-1.31l-0.97,-0.39l0.93,-1.13l0.12,-0.48l-0.42,-0.74l-1.3,-0.29l-0.61,-0.59l-0.74,1.24l-0.74,-0.0l-0.15,-0.51l-0.65,-0.18l-0.74,0.66l3.77,-4.72l4.61,-3.88l1.94,-3.54l0.59,-0.18l0.86,0.36l0.53,-0.25l0.34,-1.48l0.57,0.12l0.75,-0.48l-0.28,-1.1l-1.11,-0.6l-2.2,0.36l2.0,-1.96l2.11,-1.02l2.58,2.41l1.43,2.2l0.55,1.83l0.95,1.45l0.73,0.31l2.6,-0.62l1.18,0.54l0.05,0.97l1.19,0.45l0.86,1.02l1.19,0.25l0.89,-0.21l3.0,-2.69l1.06,0.05l1.19,-0.77l2.18,-0.6l5.59,1.4l1.8,1.71l4.19,2.14l2.92,0.74l1.77,-0.33l1.04,-0.56l1.14,-1.26l1.71,-3.12l4.94,3.73l1.32,0.64l1.05,0.07l1.24,-1.06l0.88,1.27l0.8,0.31l0.58,-0.14l0.68,-1.05l0.66,-0.36l1.19,0.75l0.51,-0.04l1.37,-1.52l0.88,-1.65l2.87,-0.9l1.35,-1.71l0.37,-3.27l-1.21,-1.82l1.25,-1.53l2.15,1.03l2.68,0.55l5.95,0.45l1.55,0.49l3.18,2.02l5.37,1.41l-0.46,0.45l-0.23,1.35l0.2,1.13l-0.37,1.47l-0.8,1.15l-0.1,1.54l1.31,1.26l0.87,0.37l2.02,2.21l0.81,2.24l-0.06,3.95l0.44,1.22l8.06,7.1l2.41,2.6l2.07,1.19l0.72,0.82l1.43,2.89l-1.24,4.09l-1.16,2.51l-0.1,1.97l1.53,3.03l-1.2,0.69l-1.48,1.91l-1.69,0.08l-5.59,-3.88l-0.97,0.39l-1.45,1.68l-2.74,2.23l-6.23,2.87l-4.73,1.25l-2.45,-0.25l-4.39,-3.46l-1.83,-0.41l-0.48,0.29l-0.81,3.49l2.14,4.72l-0.04,0.75l-2.27,5.0l-0.73,0.39l-0.81,1.02l0.19,2.14l-1.94,0.8l-3.04,-0.33l-1.78,-0.64l-1.27,0.6l-1.06,1.56l0.16,4.96l-1.64,1.57l-0.57,2.01l0.18,2.6l1.31,2.41l4.48,3.52l3.08,4.0l2.65,4.29l1.69,1.66l2.28,1.32l4.5,1.33l0.99,0.64l2.2,0.74l2.33,0.1l1.51,0.7l-0.69,0.5l-3.78,5.93l-1.43,3.06l-0.36,2.09l-1.61,2.54l-0.9,8.88l0.88,2.28l0.82,0.99l1.05,0.58l2.97,0.57l2.81,-0.26l5.57,5.0l-1.16,1.62l-3.63,0.25l-2.86,1.86l-0.83,0.24l-8.46,-0.29l-1.77,-0.34l-2.42,-1.15l-4.24,-1.36l-1.1,-0.77l-1.38,-2.12l-0.55,-2.42l0.23,-5.23l1.58,-4.16l-0.27,-1.82l-0.78,-1.78l-1.05,-1.01l-1.26,-2.46l-1.1,-1.33l-3.19,-1.6l-1.22,-0.37l-1.21,0.41l-3.16,4.77l-1.32,1.45l-1.53,0.88l-1.51,0.31l-6.38,-0.29l-0.73,-4.9l-0.27,-5.05l0.2,-0.9l2.78,-1.75l1.44,-1.58l0.72,-2.78l-0.43,-1.19l-0.89,-0.81l-3.64,-5.49l-0.52,-0.37l-0.93,-0.27l-6.28,1.41l-2.36,1.9l-0.87,0.29l-1.55,-0.32l-0.96,-0.77l-0.59,-0.06l-4.97,1.39l-1.0,-0.53l-0.98,0.13l-3.07,-0.99l1.37,-3.26l0.3,-1.82l-0.31,-1.79l0.97,-2.73l2.1,-1.82l0.78,-1.92l1.35,-0.61l0.9,-2.12l-1.06,-2.04l-2.64,-1.34l-4.04,-3.14l0.44,-1.98l0.92,-1.56l0.22,-1.79l-0.94,-1.42l-5.43,-2.52l-2.81,-0.55l-2.27,0.4l-2.07,1.2l-3.35,0.48l-3.19,1.77l-1.94,-0.07l-2.8,1.0l-2.32,-0.11l-5.69,-1.93l-0.65,-0.85l-0.43,-2.69l-4.35,-6.27l-1.01,-2.39l-0.06,-0.97l1.11,-4.06l-1.39,-5.67l-1.95,-1.95l-4.98,-3.31l3.53,-0.09l2.2,-1.28l0.92,0.09l1.8,2.41l1.28,0.27l-0.62,1.59l0.32,1.45l1.31,0.5l2.83,0.37l3.75,-0.72l1.33,-1.05l0.6,-1.28l-0.06,-1.24l-1.08,-1.86l-0.89,-0.89ZM233.12,663.64l0.91,0.43l0.9,-0.7l1.39,1.39l0.78,2.04l2.4,1.88l0.64,0.69l-0.15,0.44l-0.65,0.08l-1.43,-0.71l-2.67,-2.03l-1.61,-2.14l-0.52,-1.36ZM233.19,670.64l-0.13,-0.73l1.09,-1.22l-0.24,-1.11l1.52,1.48l2.61,1.62l-0.86,0.56l-1.74,0.07l-2.25,-0.69ZM233.91,667.58l-2.66,-1.04l-0.17,-1.66l1.13,0.47l1.69,2.23ZM212.82,649.85l0.87,-0.34l0.56,-2.03l1.04,-1.05l-0.1,1.94l-1.38,1.38l-0.99,0.09Z",name:"Cauca"},"CO-SAN":{path:"M477.33,335.89l1.37,-0.65l0.91,-1.35l1.23,-0.77l0.33,3.11l2.98,5.61l0.14,1.25l0.55,0.65l1.09,0.31l1.16,1.04l0.65,1.38l-0.34,1.86l-2.73,2.13l-1.37,1.76l-0.15,0.88l0.33,1.86l-0.61,1.11l-0.08,1.78l0.38,0.42l7.49,0.38l1.31,1.43l2.09,1.17l1.42,1.24l1.4,1.64l0.34,1.08l1.21,1.53l1.89,0.97l4.43,0.74l1.43,1.28l0.67,0.2l6.05,0.29l0.61,-0.67l0.59,-2.75l1.54,-1.76l1.56,0.42l5.05,0.28l2.94,0.64l1.89,-0.8l1.66,0.37l-0.11,1.03l0.75,2.93l0.62,0.98l4.24,3.32l-0.02,1.55l0.4,1.36l2.52,4.0l0.75,0.38l-0.12,3.03l-2.15,2.61l-0.02,0.49l1.73,2.4l0.97,0.62l0.33,2.42l-3.32,5.23l0.37,1.23l2.03,1.11l3.32,0.81l2.9,2.51l0.45,0.06l1.66,-0.82l1.46,-0.1l0.9,1.75l0.84,-0.1l0.67,-1.06l1.39,0.24l2.74,-0.68l1.07,0.11l0.65,2.28l-0.18,2.71l0.25,1.72l0.44,0.34l1.16,-0.12l1.26,-1.15l1.27,3.37l-0.57,2.14l0.65,3.02l-0.25,2.23l-0.99,4.54l-2.69,5.13l-0.03,3.61l-0.38,0.57l-1.83,0.96l-2.1,2.16l-1.44,0.42l-0.76,-0.2l-1.15,-2.97l-1.7,-2.66l-3.27,-2.77l-0.87,-0.11l-1.31,0.42l-0.81,1.09l0.49,1.64l2.97,2.82l0.6,1.59l-0.4,2.35l0.29,2.49l-1.21,3.34l0.76,2.06l-0.27,2.69l-1.2,1.29l-1.93,1.09l-1.05,2.87l-0.94,0.64l-3.66,1.21l-5.98,7.51l-0.94,3.03l-0.41,0.41l-6.39,-0.88l-4.17,-2.17l-1.71,0.55l-1.26,3.23l-2.86,4.45l-1.27,0.12l-2.13,-0.6l-0.61,0.18l-1.13,3.17l-1.18,1.13l-0.81,2.05l-0.36,0.03l-0.65,-0.43l-2.28,-2.87l-0.16,-1.71l1.59,-1.04l0.37,-1.32l1.34,-0.74l0.9,-1.43l0.99,-2.62l0.2,-2.5l-0.99,-1.98l-2.53,-2.37l-2.81,-1.38l-0.89,-0.9l-0.63,0.08l-2.16,3.91l-2.53,2.05l-0.76,1.22l-0.33,2.29l-1.15,1.75l-0.35,1.17l0.27,3.68l-0.58,1.8l-0.7,4.97l-0.36,0.64l-2.62,-2.03l-2.76,-0.61l-6.01,1.35l-2.18,1.33l-0.1,-1.12l-1.21,-0.72l-1.77,0.01l-3.0,0.87l-1.96,-1.09l-2.46,-3.75l-0.78,-0.55l-1.54,-0.16l-0.46,-1.64l-0.93,-1.06l-2.67,-0.78l-1.22,-1.08l-0.48,-0.04l-1.21,0.77l-0.91,1.42l-1.41,1.08l-0.99,-0.09l-0.68,-1.84l0.04,-0.8l1.75,-3.86l0.09,-1.25l-1.94,-4.39l-0.67,-0.93l-0.95,-0.51l-0.91,0.14l-3.08,1.76l-1.44,-0.57l-2.09,-1.42l-1.27,-1.29l-2.29,-3.55l-1.52,-3.96l-0.81,-3.43l1.87,-1.33l1.6,-1.68l2.66,-4.07l0.62,0.17l0.8,-0.31l0.87,-1.4l-0.12,-1.0l-1.35,-1.68l-0.12,-0.67l-0.17,-5.51l1.24,-3.31l3.25,-0.58l2.31,-1.1l11.23,-8.31l2.8,-4.89l2.49,-2.61l0.41,-0.95l5.43,-2.78l1.47,-1.12l0.9,-1.79l-0.3,-2.87l-1.78,-2.68l-0.24,-1.16l-0.62,-7.71l0.77,-5.31l1.51,-4.84l-0.82,-2.21l-0.01,-2.27l0.3,-0.79l3.55,-4.73l0.86,-0.55l0.3,-1.03l-0.04,-2.04l0.47,-1.66l-0.73,-1.52l0.67,-1.59l0.53,-3.45l-0.08,-1.48l-0.74,-3.64l-0.91,-1.22l-0.81,-3.42l0.15,-0.91l-1.11,-4.41l0.49,-2.93l0.63,-1.68Z",name:"Santander"},"CO-ATL":{path:"M392.13,177.0l0.6,-0.17l1.6,-1.65l-0.33,-1.96l0.49,-1.14l-0.36,-1.81l0.56,-0.69l2.59,-0.71l3.86,-2.55l2.24,-0.54l1.34,-0.76l0.93,-1.03l0.03,-1.17l0.73,-2.35l1.19,-0.62l2.33,-0.54l2.35,-2.13l0.23,-0.96l3.45,-0.2l1.2,-0.91l0.13,-0.52l3.6,3.64l0.45,0.81l0.48,2.6l1.8,2.12l0.2,0.96l-1.05,3.7l1.19,4.06l-0.35,11.52l-1.1,1.91l-3.61,2.55l-1.14,2.35l-0.65,4.04l-1.71,2.21l-2.94,5.73l-3.62,-4.2l-1.67,-1.37l-1.3,-0.38l-2.69,-2.62l-3.5,0.56l-1.61,-2.55l-0.68,-0.45l0.32,-0.66l-0.34,-0.75l-4.7,-0.94l-0.87,-2.05l0.76,-2.99l1.39,-1.16l0.22,-1.81l-0.5,-1.41l-1.7,-1.59l0.17,-1.42Z",name:"Atl\xe1ntico"},"CO-AMA":{path:"M443.48,862.43l32.93,-10.22l5.69,0.83l2.62,-1.23l0.71,0.01l2.77,1.53l1.01,0.25l0.23,2.19l1.1,0.63l1.94,-0.06l1.57,2.93l1.06,0.64l4.55,0.73l5.5,-0.08l1.55,-0.3l1.94,-1.14l0.85,0.27l1.97,1.5l2.2,2.21l2.39,1.82l2.64,0.3l5.24,-0.91l1.54,-1.53l3.44,-2.43l6.89,4.46l4.21,-0.81l2.27,-1.47l1.58,-0.28l1.61,0.68l7.89,6.14l1.63,0.75l1.1,-0.07l4.56,-5.52l1.86,-1.59l1.26,-0.53l1.69,0.98l1.82,1.87l2.2,1.44l3.19,-0.52l2.4,-2.28l0.36,-1.53l-0.15,-3.87l0.38,-1.78l6.16,-8.39l3.18,-1.76l2.37,-2.27l1.37,-0.67l10.1,-0.1l2.35,-0.47l2.02,-0.84l1.48,-1.49l0.88,-1.9l0.67,-2.55l2.24,-2.55l3.75,-2.54l11.15,-4.91l3.17,-1.79l3.89,-3.78l2.11,1.59l2.12,0.5l1.21,-0.11l2.44,-1.07l0.92,-0.02l0.74,1.0l0.54,2.44l0.81,1.26l5.99,2.46l2.18,-0.68l1.19,0.4l2.89,4.19l0.28,1.82l-0.64,1.88l0.15,0.94l2.29,2.85l1.4,4.02l2.05,3.9l2.8,0.25l1.06,-0.2l1.03,-0.77l0.76,-1.75l0.89,-0.06l2.25,0.95l2.48,1.74l2.79,-0.17l0.71,0.41l1.15,1.43l1.04,0.47l4.02,-0.01l0.87,0.6l1.59,2.11l0.38,0.97l-0.12,2.01l0.65,0.76l2.53,-0.11l3.11,0.68l1.31,-0.19l0.72,-0.88l-0.08,-1.69l1.61,-1.18l2.05,-0.3l2.47,1.0l0.11,0.35l-0.4,0.53l-3.77,3.53l-1.4,2.05l0.08,1.36l0.38,0.38l2.52,-0.36l0.74,0.63l0.22,0.83l-0.36,4.63l0.81,2.9l-0.09,0.67l-1.63,1.12l-0.71,1.12l0.64,2.36l1.85,1.94l1.08,1.68l-1.15,1.77l-1.73,1.07l-0.87,0.99l-0.22,1.22l1.33,2.63l1.08,0.86l1.43,-0.13l2.04,-1.61l0.18,0.36l-0.92,2.36l0.03,1.11l3.54,2.97l1.31,0.38l1.4,-0.17l1.34,-0.88l0.56,-1.45l-0.68,-1.6l-1.65,-1.37l-0.68,-1.08l1.25,-1.65l1.38,-0.45l1.4,0.71l0.98,0.1l1.97,-1.53l1.92,0.84l2.75,-1.14l1.09,-0.03l-0.5,1.38l-1.45,1.48l-0.09,1.6l-0.82,1.83l0.15,1.31l0.93,0.73l1.63,0.16l2.79,-1.83l1.29,-0.02l2.66,1.07l1.42,0.03l1.05,-0.84l0.84,-2.04l1.46,-0.09l3.86,3.47l0.23,0.85l-0.92,3.06l0.14,1.3l0.57,1.28l0.83,0.5l0.69,-0.12l3.14,-1.78l0.69,0.09l4.19,2.09l1.7,0.43l0.57,1.13l1.96,2.29l0.16,2.53l-0.98,5.55l0.04,2.8l-1.96,8.4l-29.13,160.1l-0.69,1.38l-1.35,-2.7l-2.37,-3.08l-1.89,-1.53l-6.08,-3.1l-1.5,-1.51l-1.76,-6.33l-1.49,-2.12l-1.98,-2.08l-2.33,-1.7l-2.44,-0.87l-1.88,0.16l-1.53,0.89l-2.33,2.13l-1.42,0.61l-1.48,-0.02l-3.12,-0.77l-8.85,-4.74l-2.14,-0.26l41.08,-64.19l-0.2,-0.64l-1.31,-1.21l-1.29,-3.7l-1.1,-0.45l-1.36,0.94l-1.07,1.63l-0.26,-0.15l-0.24,-1.61l-1.34,-1.14l-2.3,0.65l-0.84,-0.32l-1.47,-3.56l-0.91,-1.26l-1.63,-0.68l-2.41,1.14l-1.37,0.28l-0.56,-1.05l1.43,-0.69l0.46,-1.57l-0.91,-0.99l-2.84,-0.21l-2.65,0.82l-0.52,-0.25l-0.83,-1.67l-0.85,-0.76l-4.18,-1.5l-1.58,-1.39l-0.43,0.0l-1.23,0.9l-0.15,1.68l-2.45,0.1l-0.39,-2.32l-0.47,-0.77l-2.0,-1.64l-0.02,-1.63l-0.56,-0.95l-5.03,-1.34l-2.01,-1.32l-3.11,-3.31l-1.92,-1.19l-1.51,0.48l-3.89,-1.34l-1.89,-0.08l-1.05,1.29l0.41,2.8l-1.2,-0.07l-1.67,-0.94l-2.55,0.28l-1.69,0.9l-1.1,2.73l-2.71,1.68l-0.46,0.1l-1.3,-0.73l-0.9,-0.13l-2.94,1.2l-0.33,-0.57l-0.52,-0.16l-4.29,2.09l-1.71,0.36l-0.44,-0.82l1.01,-1.09l0.16,-0.77l-2.96,-4.58l-1.04,-0.12l-0.84,0.86l-0.92,2.76l-0.52,-0.25l-0.33,-0.72l-0.38,-3.68l-0.83,-0.74l-3.59,-0.78l-3.64,-2.28l-1.69,-0.22l-2.8,1.15l-0.34,-0.67l0.09,-2.03l-1.03,-0.71l-5.66,3.07l-2.42,3.87l-3.3,2.69l-0.36,1.42l-0.58,0.58l-0.88,0.22l-3.72,-0.53l-2.18,0.05l-1.81,0.73l-1.73,1.51l-2.6,2.98l-0.69,0.22l-4.58,-0.83l-2.04,0.65l-0.17,1.65l-5.38,0.99l-1.99,-0.75l-1.83,-2.0l-7.23,-1.3l-2.76,-2.22l-1.06,-0.58l-1.24,-0.21l-1.18,1.2l-1.56,3.24l-1.44,0.87l-0.38,-2.09l-0.59,-1.02l-0.5,-0.13l-1.33,0.86l-0.45,0.93l-1.2,-0.83l-1.32,-0.33l-3.19,1.35l-0.81,0.73l-3.61,0.77l-0.83,-1.17l-1.02,-2.77l-1.26,-1.33l-4.18,-2.29l-0.58,0.26l-1.06,2.11l-0.84,-1.39l-2.76,-0.75l-0.82,-0.55l-0.44,-2.22l-1.06,-1.03l-0.81,-1.46l0.11,-1.23l2.68,-2.57l2.43,-4.34l-0.07,-0.5l-0.75,-0.7l-1.18,-3.71l-1.46,-2.36l-0.13,-1.57l0.73,-2.31l-0.42,-1.14l-1.64,-2.3l0.43,-2.14l-0.46,-0.95l-1.72,-1.08l-1.89,-1.92l-1.02,0.34l-0.29,1.45l-1.88,-0.49l-1.08,0.1l-1.83,1.55l-2.34,-1.82l-2.98,-0.09l-0.45,-1.23l-3.86,-2.36l-1.08,-1.33l0.12,-2.13l1.11,-2.71l1.58,-1.14l0.05,-1.28l-0.82,-4.54l-2.65,-2.94l-2.14,-1.0l-0.35,-0.57l1.12,-1.66l-0.2,-0.53l-0.87,-0.4l-0.5,-0.72l-0.5,-2.68l-0.5,-0.28l-0.86,0.09l-0.74,-2.4l-0.55,-0.72l-1.36,-0.39l-1.22,-0.87l-2.05,-0.43l-1.03,-0.58l-1.24,-1.86l-0.5,-0.21l-1.11,0.5l-0.92,1.45l-0.83,0.47l-3.03,-0.75l-1.29,-1.07l-1.05,-1.65l-1.3,-3.0l-1.2,-0.53l-1.97,0.38l-0.52,-0.28l0.52,-1.36l-0.2,-0.75l-0.5,-0.43l-0.75,0.11l-1.54,1.3l-0.95,-0.56l-1.64,-4.61l-0.8,-0.81l-0.62,0.11l-0.83,1.57l-1.34,0.04l-3.62,-1.38l-3.62,-0.67l-1.48,-0.81l-1.26,-1.65l-0.9,-2.8l-2.34,-2.15l0.7,-0.43l1.82,0.16l0.73,-1.23l-1.22,-1.95l0.39,-0.79l-0.2,-0.54l-2.41,-0.63l-2.34,-2.94l0.02,-0.97l1.04,-1.17l0.13,-0.72l-2.91,-6.37Z",name:"Amazonas"},"CO-MET":{path:"M502.84,686.19l0.0,-1.62l-0.68,-1.41l-0.41,-0.22l-0.34,0.32l-0.42,1.97l-1.09,-0.5l-1.91,0.22l-1.37,-1.84l-3.14,1.28l-0.25,-1.07l-0.89,-0.37l-1.84,1.3l0.01,1.77l-1.82,2.86l-0.35,2.51l-0.05,36.93l-0.61,0.77l-4.86,-0.8l-5.74,0.45l-3.86,-0.23l-35.85,-12.65l-2.31,-1.6l-2.02,-2.55l-1.29,-2.79l-0.56,-2.7l0.03,-2.0l0.61,-1.72l3.41,-4.27l0.41,-1.29l-0.06,-1.23l-1.61,-2.83l-3.68,-4.13l-0.93,-1.46l-0.79,-3.75l0.47,-4.88l3.36,-13.37l-0.07,-2.48l-0.75,-1.21l-2.37,-2.01l-0.87,-1.27l-1.75,-4.51l-1.44,-1.8l-1.18,-0.67l-4.1,-0.69l-5.68,-1.84l1.62,-4.61l2.63,-4.31l3.05,-1.77l1.59,-1.62l4.02,-2.86l1.88,-3.1l0.95,-4.15l0.55,-7.48l0.69,-2.04l4.41,-5.93l1.35,-2.31l1.57,-4.45l1.45,1.21l1.74,0.14l0.87,-0.46l1.53,-3.11l3.92,-4.77l1.22,-2.01l0.55,-1.43l-0.02,-1.31l3.17,-3.64l1.97,-3.69l0.68,-0.47l3.17,0.74l2.19,0.01l2.9,-2.87l2.17,-1.44l1.0,-1.05l0.9,-0.48l2.75,-0.51l1.34,-1.99l1.17,-0.63l5.24,-2.07l1.1,-0.92l3.67,0.11l0.37,-0.51l-0.72,-3.5l-0.51,-1.13l-0.93,-0.99l-0.0,-2.25l-0.71,-3.27l-0.78,-0.9l0.09,-1.0l0.9,-1.26l3.18,-1.68l1.37,-2.26l1.03,-0.6l1.03,0.46l1.3,1.36l1.92,0.35l2.4,3.59l0.39,2.47l1.43,3.77l1.61,1.38l2.74,0.91l2.04,-0.59l1.57,-1.24l3.63,-0.38l8.62,2.33l1.31,1.51l2.35,1.5l1.0,0.44l0.75,-0.22l0.51,-0.9l4.28,-28.99l0.63,1.62l2.75,2.68l4.15,7.58l5.42,5.77l1.37,0.15l1.85,3.29l-0.12,1.13l0.33,0.39l1.58,-0.02l0.48,2.25l2.08,0.95l0.83,-0.18l1.49,-1.17l2.86,0.45l1.04,-0.4l1.3,0.79l0.66,-0.38l1.49,-2.5l1.97,0.58l0.87,1.24l0.44,0.17l1.56,-0.43l2.65,-1.51l1.11,0.74l1.54,0.21l1.51,-0.36l2.79,-4.1l10.29,-2.39l1.11,0.18l2.22,1.4l1.36,1.82l1.44,0.37l2.28,-0.63l2.48,-1.49l4.62,-3.86l5.24,-5.55l2.02,-0.13l5.49,-1.7l2.62,-1.29l4.72,-3.23l17.52,-7.53l3.54,-0.54l3.64,-2.87l1.63,-0.98l2.57,-0.97l1.08,-0.96l-0.2,123.26l-0.72,0.17l-1.67,-0.74l-1.18,0.72l-2.36,-1.17l-2.32,1.58l-1.03,0.18l-1.31,-0.6l-1.07,-0.03l-1.09,-1.85l-0.5,-0.47l-0.88,-0.11l-0.68,0.72l-0.79,2.1l-0.96,-0.85l-0.77,-0.14l-0.71,0.57l-0.42,1.12l-0.41,0.08l-3.01,-1.74l-0.72,-0.08l-1.03,1.3l-0.5,0.13l-2.47,-0.63l-3.28,0.46l-1.22,1.29l-2.42,1.1l-0.94,-0.16l-0.29,-2.51l-1.0,-0.06l-1.42,1.24l-0.65,-0.19l-2.18,-2.13l-0.71,-0.18l-0.76,0.81l0.06,1.79l-0.45,1.25l-0.66,-1.84l-0.42,-0.54l-0.74,-0.21l-2.92,1.85l-6.18,1.16l-2.41,0.75l-2.15,-1.13l-3.59,-0.54l-0.74,-0.56l-0.78,-1.39l-1.1,-0.48l-3.81,0.79l-0.82,0.39l-0.5,1.07l0.24,3.36l-1.39,0.17l-1.75,1.08l-0.32,0.81l0.12,1.73l-0.55,-1.43l-1.24,-1.04l-0.97,0.28l-0.79,1.68l-1.92,-1.13l-1.31,0.04l-3.47,2.68l-3.22,0.39l-1.94,1.34l-2.66,-0.62l-0.4,0.3l-0.12,0.89l0.84,0.88l-1.09,0.13l-0.72,0.71l-0.32,2.17l-0.83,-1.34l-1.06,-0.3l-1.0,1.02l-0.62,2.35l-0.6,-2.37l-1.0,-0.66l-2.44,0.46l-0.7,0.65l-1.22,2.1l-1.13,-0.29l-1.89,-2.18l-1.97,0.27l-5.31,3.01l-0.93,1.55l-1.16,0.74l-0.29,0.98l0.8,1.57l-1.3,0.31l-0.95,1.12l-2.99,1.92l-0.88,-0.38l-1.64,0.31l-2.32,1.83l-0.81,-0.56l-0.81,-0.06l-0.52,0.58l-0.17,1.13l-0.4,0.18l-0.56,-0.17l-0.34,-0.89l-0.57,-0.34l-1.64,0.17l-1.25,-0.36l-1.93,1.0l-0.27,0.67l0.4,0.8l-0.29,0.21l-2.39,0.32l-1.69,-0.51l-1.28,1.03l-0.04,-1.05l-0.62,-0.44l-0.71,0.03l-0.94,1.35l-0.99,-0.76l-1.03,0.02l-0.91,0.7Z",name:"Meta"},"CO-MAG":{path:"M417.08,152.38l16.25,6.08l4.95,1.03l-0.99,0.57l-0.14,1.74l-0.5,0.4l-0.24,0.79l1.43,3.49l-1.28,-1.05l-0.87,0.42l-0.47,-0.36l-1.35,0.0l-0.78,-0.37l-0.81,0.2l-1.06,2.57l-0.11,3.7l0.47,0.65l1.28,-0.19l0.82,-2.08l1.04,0.72l0.31,2.87l1.11,0.45l1.19,-0.12l0.93,-0.77l0.26,-1.06l-0.58,-0.45l-0.77,0.24l-0.32,-1.14l1.0,-2.08l0.43,0.08l0.61,0.66l0.65,4.0l0.63,0.92l1.26,0.29l2.45,-0.14l1.11,-0.44l1.62,-1.56l1.86,-3.67l0.05,-2.23l0.77,-1.78l1.22,-1.64l1.03,-3.7l3.99,-6.01l-0.16,-0.97l-1.08,-1.6l0.44,-2.3l-0.8,-2.2l0.77,-0.93l-0.3,-1.46l1.87,-2.41l0.79,-2.0l1.69,0.07l0.61,-0.73l0.7,0.11l0.63,-0.85l0.67,0.17l0.4,-0.67l0.53,0.83l0.98,0.21l0.59,-0.29l0.42,-0.73l0.88,0.26l0.56,-0.72l0.66,-0.15l2.5,0.57l2.12,1.71l3.23,0.78l1.99,1.15l2.48,0.77l7.33,0.52l8.13,-0.54l0.09,1.3l-1.08,3.38l-1.74,1.88l-1.22,0.6l-0.44,0.77l0.2,1.66l-0.25,3.9l-0.77,3.08l1.15,2.53l0.28,2.53l1.3,4.47l-2.38,4.38l0.69,0.74l2.94,0.26l1.33,0.98l0.08,0.53l-1.41,1.82l-1.69,3.01l0.84,2.37l0.34,2.19l-0.21,1.98l1.59,1.99l-1.57,0.95l-2.21,0.72l-1.1,1.89l-2.17,0.41l-0.92,1.05l-1.77,0.6l-2.13,1.56l-2.19,0.65l-2.12,-0.25l-3.05,0.67l-1.79,1.07l-1.26,1.36l-1.06,2.65l-3.94,4.78l-1.71,2.76l-1.2,5.8l0.23,1.76l3.56,5.89l0.75,0.85l2.63,1.81l3.47,4.73l3.17,2.86l0.29,1.79l-0.33,1.27l1.56,2.81l1.88,5.62l-0.53,0.64l-0.58,-0.79l-0.99,-0.15l-3.09,1.71l-3.17,-0.08l-1.39,-0.84l-2.67,-0.51l-1.99,0.12l-2.11,1.13l-2.92,3.34l-1.72,1.25l0.04,0.67l3.3,1.91l2.55,2.45l2.22,1.55l0.41,3.46l0.76,1.38l1.56,1.43l0.26,3.07l-0.69,1.33l0.29,1.28l1.33,0.97l2.34,0.5l1.33,-0.12l0.52,2.46l0.77,1.41l1.89,1.83l1.33,1.8l-1.3,2.13l-1.29,3.0l-1.27,3.99l-0.41,-2.23l0.74,-1.72l-0.21,-0.52l-1.84,-0.78l-4.99,-0.23l-1.57,-0.89l0.17,-1.01l-2.03,-2.0l-0.61,0.04l-0.93,1.25l-1.6,0.18l-3.03,-0.92l0.2,-0.76l-3.36,-2.13l-2.55,-3.78l-1.3,-0.71l-2.16,-0.08l-0.31,-1.86l-0.71,-1.0l-2.68,-1.1l-1.27,-0.11l-1.6,0.69l-0.52,-0.21l-0.67,-1.95l-0.62,-0.63l-2.99,-0.11l-1.26,0.62l-0.9,1.13l-0.86,-0.1l-0.76,-0.86l-0.63,-2.07l-3.41,-2.75l-0.88,-2.23l-0.55,-0.55l-1.14,-0.66l-1.33,-0.14l-0.75,-1.56l-0.88,-0.58l-1.15,-0.07l-1.33,0.57l-1.51,-1.87l-1.75,0.09l-0.29,-1.88l1.6,-7.81l-0.13,-1.09l-2.87,-3.41l-0.17,-1.1l0.97,-3.97l-0.48,-1.16l-2.07,-1.92l-1.01,-1.81l-0.27,-3.94l0.43,-1.91l3.57,-2.22l0.41,-0.99l0.08,-1.74l-0.35,-0.76l-0.93,-0.56l-1.41,-2.67l-0.77,-0.61l-1.9,-0.42l-2.53,-1.35l-0.54,-0.55l-0.23,-1.54l1.4,-5.29l3.58,-6.99l1.77,-2.35l0.68,-4.15l1.02,-2.07l3.59,-2.52l1.18,-2.06l0.22,-1.44l-0.17,-3.98l0.36,-6.49l-1.19,-4.02l1.05,-3.54l-0.23,-1.35l-1.85,-2.24l-0.41,-2.42l-0.55,-1.03l-3.88,-3.94l-0.6,-1.48ZM439.6,159.65l1.58,0.16l-0.77,-0.02l-0.81,-0.14ZM445.73,159.94l0.78,-0.05l-0.32,0.06l-0.45,-0.01Z",name:"Magdalena"},"CO-ARA":{path:"M591.84,403.14l4.65,1.09l2.15,0.17l1.08,-0.21l1.92,-1.33l1.4,0.05l0.57,-0.62l-0.09,-0.63l4.11,-0.36l1.66,0.42l0.49,-0.48l-0.03,-0.98l2.49,-0.02l1.64,1.34l0.59,0.03l1.56,-0.68l0.67,0.75l1.2,0.08l1.17,-0.45l1.16,0.3l1.5,1.02l3.18,-1.11l3.86,0.7l3.32,-0.4l0.33,0.26l0.18,1.43l0.51,0.81l0.96,0.38l2.87,0.07l1.99,0.89l1.19,-0.39l1.7,-1.38l4.14,0.45l3.47,-0.41l3.12,-1.18l2.58,-1.83l1.31,-1.7l9.78,-1.87l1.66,-0.03l1.21,0.9l2.68,0.69l3.64,-0.71l3.31,4.1l0.73,0.46l1.16,0.31l2.49,-0.14l0.84,0.88l7.31,3.36l2.12,0.03l3.37,-1.9l2.11,-0.53l2.16,-0.11l1.58,0.39l1.87,1.62l39.5,49.94l-5.16,3.09l-2.29,0.47l-12.96,-0.47l-2.07,0.5l-2.23,1.59l-1.61,-0.7l-0.87,-1.05l-0.31,-1.72l-1.94,-1.74l-5.27,-2.21l-0.67,-0.55l-0.89,-2.05l-2.29,-1.55l-1.68,-1.87l-3.04,-1.15l-1.63,-0.18l-5.42,0.27l-4.14,-0.79l-1.64,0.21l-7.89,3.09l-5.41,0.17l-4.68,0.8l-3.2,-0.01l-2.69,-1.23l-1.14,-0.19l-4.6,1.05l-5.7,-0.42l-4.36,-1.55l-2.1,-0.37l-4.59,-0.11l-3.96,-1.11l-1.37,0.83l-3.39,0.12l-3.68,1.83l-3.03,0.26l-4.16,1.54l-3.86,0.06l-1.81,0.41l-3.16,-1.18l-2.29,0.62l-4.62,0.02l-8.13,2.77l-4.14,0.01l-1.33,0.27l-3.53,1.63l-3.38,0.85l-3.35,2.44l-2.22,-0.29l-6.11,-3.8l-1.43,-2.87l-2.41,-2.43l-1.28,-2.16l-0.29,-1.91l1.67,-3.08l1.66,-1.59l0.51,-2.26l0.74,-1.0l0.55,-0.28l0.8,0.61l0.83,0.04l2.2,-2.16l2.67,-0.86l1.31,-1.86l0.7,-2.26l1.44,-11.52l0.34,-0.88l1.39,-0.7l1.21,-1.65l0.76,-2.57l1.19,-2.18l3.36,-8.5Z",name:"Arauca"},"CO-GUA":{path:"M692.38,641.02l1.19,-0.97l2.25,-3.34l2.19,-1.44l0.4,-0.65l1.4,0.88l1.02,-0.35l0.38,-0.97l-0.14,-1.3l0.41,1.12l0.51,0.38l1.16,-0.57l0.14,-1.77l-0.98,-1.7l0.09,-0.83l1.43,-0.59l0.12,-0.58l-0.78,-1.35l-0.83,-0.67l-0.48,-1.21l1.72,-2.52l0.15,-1.38l2.05,0.05l1.05,-0.87l0.82,-3.59l-1.46,-2.34l3.61,-0.07l1.49,1.1l1.5,0.34l2.54,-3.17l0.66,-0.39l1.27,0.03l1.09,1.8l0.65,0.03l0.99,-1.6l4.98,0.02l2.54,-0.58l0.79,0.02l2.86,2.13l0.51,-0.16l0.4,-0.76l0.22,-3.08l0.24,-0.34l0.81,-0.09l1.23,-1.12l0.33,-2.39l-0.45,-1.49l5.15,-0.51l2.88,-1.12l0.74,0.22l1.19,1.27l0.91,0.24l4.98,-1.57l1.03,0.06l0.94,0.67l0.73,0.03l0.75,-1.64l0.48,-0.09l0.59,0.29l0.9,1.24l1.92,0.15l0.77,0.82l1.02,0.4l0.21,1.32l0.54,0.42l2.0,-1.16l0.92,0.04l1.27,0.88l-0.0,1.61l0.67,0.83l0.84,0.37l1.1,-0.4l1.85,-2.31l4.89,0.74l0.93,-0.84l-0.09,-2.32l0.56,-0.81l0.74,0.15l0.24,0.7l0.66,0.3l1.1,-0.08l2.48,-1.16l1.34,1.21l1.41,-0.05l0.39,-0.42l-0.3,-2.11l0.43,-0.34l2.33,0.36l0.93,-0.31l0.45,-0.94l0.05,-1.32l1.67,-0.4l1.15,-1.01l2.7,0.92l2.03,-0.2l1.89,-1.38l2.15,0.64l1.61,-2.24l0.85,-0.66l1.83,-0.39l1.02,-1.17l0.98,-0.14l0.34,-0.63l-0.56,-0.79l0.11,-1.02l3.6,-0.23l0.76,-0.47l0.75,-2.07l0.6,-0.72l-0.22,-1.08l-0.73,-0.93l-0.05,-0.66l0.53,-0.29l3.75,0.45l1.13,0.48l0.43,2.6l0.49,0.9l0.54,0.16l3.58,-1.7l0.33,0.37l-0.67,1.63l0.68,1.03l1.13,0.09l0.86,-0.56l1.91,-2.29l0.69,-1.56l0.87,-0.69l1.36,1.99l1.17,0.89l1.21,-0.31l1.07,-1.65l0.12,2.1l0.79,1.12l0.93,0.06l2.08,-1.27l4.46,2.04l2.55,-0.17l2.51,-1.79l2.97,-4.16l1.6,-0.93l0.59,1.32l0.48,5.06l3.0,5.71l0.34,2.95l0.52,1.62l1.07,1.29l1.3,0.69l3.58,-0.23l2.1,0.98l1.63,2.17l4.12,10.69l0.94,1.28l3.17,1.53l1.82,1.89l-0.26,2.26l-1.51,2.44l-3.62,4.52l-0.65,0.5l-2.76,0.89l-23.42,21.69l-1.14,1.99l-0.04,4.15l0.65,0.32l0.89,-0.71l1.06,-1.53l3.03,-0.27l1.15,-0.54l0.98,0.88l2.59,1.25l1.72,0.29l2.13,-0.67l0.89,0.73l0.8,1.28l1.24,5.29l0.96,0.65l2.67,0.04l0.98,0.3l0.79,0.71l0.95,2.18l1.81,1.03l1.42,2.06l1.05,0.52l1.13,1.81l2.4,1.59l1.04,2.27l1.22,0.53l2.34,1.94l2.18,0.72l2.35,1.55l0.19,1.54l0.69,1.69l-2.53,2.95l-0.04,1.53l2.42,6.83l0.66,0.94l2.8,1.27l0.31,0.78l0.2,3.17l-0.19,0.94l-1.18,1.6l0.08,1.09l1.4,2.02l1.36,1.19l6.44,16.5l0.41,5.19l2.47,4.79l0.22,1.23l-0.4,2.42l0.24,1.01l1.94,1.96l1.03,2.53l0.06,1.3l-1.1,2.41l0.34,1.53l1.04,2.13l-10.96,2.9l-0.94,-0.15l-0.41,-1.25l-0.22,-3.08l1.49,-17.51l-0.58,-3.91l-2.07,-6.38l-2.4,-4.86l-6.59,-8.74l-4.58,-9.53l-1.7,-1.68l-3.7,-1.44l-1.15,-0.04l-2.07,1.64l-2.22,0.32l-2.68,2.08l-2.41,1.17l-4.68,4.97l-7.3,9.72l-1.78,1.68l-2.33,1.32l-4.03,1.19l-2.08,0.07l-1.88,-0.55l-1.93,-1.58l-1.58,-2.28l-3.17,-7.63l-1.11,-1.02l-3.01,-0.99l-0.45,-0.63l-0.08,-1.39l-0.29,-0.4l-0.58,-0.08l-0.64,0.59l-3.62,9.03l-1.15,1.71l0.12,0.56l0.4,0.25l1.54,0.23l0.37,0.46l0.02,2.35l0.38,0.35l2.43,0.26l0.08,1.19l0.53,0.72l-70.49,0.06l-2.4,-0.3l-4.54,-1.93l-4.59,-0.96l-2.46,0.19l-4.1,1.87l-2.37,0.2l-2.47,-0.2l-4.72,1.91l-1.87,-0.01l-2.22,-1.17l-2.66,-0.81l-2.93,-0.22l-4.76,-2.18l-6.34,-5.27l-0.36,-0.79l0.09,-0.86l2.6,-6.37l0.66,-3.19l0.3,-3.68l6.07,-4.44l0.5,-1.16l-0.09,-0.74l-2.67,-3.61l-0.85,-0.57l-0.88,-0.1l-1.73,0.83l-2.6,0.07l-0.58,0.73l-2.89,0.53l-1.29,0.02l-1.55,-0.86l-2.84,0.44l-0.8,0.49l-0.0,0.95l-0.4,0.46l-2.02,-1.09l-4.19,-1.11l-1.01,-0.03l-2.13,0.82l-1.71,0.27l-0.15,-1.0l-0.65,-0.79l-5.33,-1.55l-1.75,-1.45l-3.27,-6.69l-2.98,-4.23l-1.37,-1.35l-9.7,-4.29l0.62,-0.65l23.95,-9.9l2.06,-1.64l6.51,-3.01l0.81,-0.92l0.83,-2.11l3.07,-1.9l0.55,-1.33l-0.04,-1.64l-0.9,-2.65l1.51,-0.82l0.16,-1.31l-0.82,-0.75l-1.83,-0.44Z",name:"Guain\xeda"},"CO-SAP":{path:"M21.54,15.34l-0.54,0.15l-0.13,-0.83l0.38,-1.11l0.52,-0.44l0.46,0.26l0.23,0.79l-0.92,1.19ZM0.82,65.83l-0.3,-0.03l0.4,-0.38l-0.1,0.4ZM1.07,64.8l-0.42,-1.04l0.15,-1.05l1.01,-1.24l-0.73,3.33Z",name:"San Andr\xe9s y Providencia"},"CO-CAL":{path:"M589.69,402.64l1.37,0.32l-0.38,1.28l-2.93,7.09l-1.21,2.23l-0.75,2.54l-1.04,1.39l-1.5,0.82l-0.42,1.07l-1.46,11.63l-0.63,2.03l-1.15,1.64l-2.55,0.77l-2.07,2.08l-1.38,-0.7l-1.61,1.1l-0.87,2.92l-1.47,1.34l-2.09,1.15l-2.52,4.08l-1.24,3.95l0.09,1.3l1.3,0.96l1.34,3.81l1.76,1.8l-0.13,0.91l-0.87,1.67l-0.53,3.04l-1.46,4.71l-2.21,0.64l-0.69,0.56l-0.54,0.78l0.02,1.22l6.01,3.44l2.31,1.68l0.54,1.5l1.15,0.89l1.36,1.94l1.12,0.96l-1.5,1.25l-1.0,3.16l-1.19,1.47l-1.01,4.67l-0.41,0.09l-2.03,-1.45l-1.75,-2.29l-1.75,0.36l-8.25,8.94l-2.14,3.49l-2.54,1.45l-3.39,3.07l-0.83,-0.07l-4.68,-5.69l-1.36,-0.64l-3.43,2.42l-4.99,6.72l0.2,1.96l-0.79,1.38l-0.32,2.45l0.95,1.98l1.84,1.77l-1.49,3.55l-2.25,2.3l-2.22,-0.9l-0.84,0.1l-0.63,0.66l-1.0,4.12l-0.19,2.76l-1.0,2.64l-0.16,1.27l1.17,3.58l-0.15,0.69l-0.6,0.01l-0.61,0.5l-0.16,1.11l-1.04,1.95l-1.03,0.73l-2.32,0.18l-2.4,-0.94l-1.23,-0.07l-0.67,-2.72l-1.33,-0.69l-2.84,0.25l-1.82,-3.1l-2.39,-0.96l0.15,-1.25l-2.34,-3.25l-2.53,-1.0l-4.79,-0.09l-1.15,-1.62l0.0,-0.57l1.83,-3.49l-0.13,-1.98l2.19,-1.6l0.27,-1.33l-0.9,-1.66l-0.1,-2.87l-1.51,-2.61l-0.41,-1.51l0.15,-1.77l-1.26,-2.05l-2.59,-2.1l-0.46,-1.36l0.61,-2.03l-0.47,-1.5l-3.13,-2.77l-1.01,-2.04l-1.54,0.09l-0.81,-0.31l-1.32,-1.25l-1.51,0.17l-2.81,-1.37l-0.15,-3.14l-0.65,-0.42l-0.97,0.13l-2.07,1.49l-3.38,3.49l-0.48,2.37l-1.67,0.51l-3.74,3.44l-2.59,-1.44l-0.99,-0.13l-1.43,-0.97l-0.51,-0.78l0.05,-1.11l-0.42,-0.42l-2.92,0.16l-3.57,-1.85l-2.32,-0.23l0.06,-1.85l-0.49,-1.38l-2.65,-2.61l-0.77,-1.57l0.01,-1.11l1.25,-1.89l0.26,-1.08l-0.87,-2.12l0.0,-1.81l-0.56,-1.22l-0.06,-1.64l-0.87,-0.75l-0.83,-1.44l-1.02,-0.09l-4.13,3.13l-1.32,0.39l-5.57,-1.4l-2.72,1.3l-4.02,0.91l-0.67,-0.7l0.74,-1.56l0.57,-3.76l1.08,-1.69l1.42,-1.01l0.45,-0.67l-0.87,-2.77l0.04,-0.87l1.49,-0.74l0.39,-0.89l-0.21,-4.72l-1.62,-2.64l-0.04,-0.75l1.01,-2.09l0.5,-2.7l0.74,-1.43l2.27,-2.05l0.76,3.18l1.58,4.1l2.34,3.63l1.4,1.43l2.21,1.51l1.76,0.67l1.18,-0.29l2.27,-1.53l0.57,-0.08l0.97,1.04l1.82,4.03l-0.04,0.91l-1.41,2.68l-0.39,1.38l-0.02,1.09l1.08,2.38l1.73,0.06l1.61,-1.23l0.85,-1.36l0.88,-0.56l1.22,1.03l2.46,0.66l0.69,0.74l0.52,1.84l0.38,0.29l1.58,0.13l0.49,0.37l1.06,2.0l1.38,1.73l2.25,1.29l1.04,-0.03l2.37,-0.81l1.48,-0.02l0.71,0.41l-0.06,1.37l0.61,0.36l2.65,-1.65l5.72,-1.31l2.41,0.52l2.64,2.13l0.53,0.06l0.62,-0.44l0.35,-0.87l0.7,-4.98l0.6,-1.89l-0.27,-3.66l1.48,-2.84l0.27,-2.15l0.59,-0.98l2.55,-2.07l2.01,-3.61l0.68,0.65l2.71,1.31l2.38,2.21l0.86,1.68l-0.2,2.15l-0.9,2.4l-0.82,1.31l-1.26,0.63l-0.4,1.36l-1.85,1.45l0.28,2.29l2.49,3.1l0.82,0.54l1.0,-0.01l1.11,-2.31l1.26,-1.26l0.93,-2.92l2.25,0.58l1.84,-0.33l2.99,-4.66l1.05,-2.96l0.89,-0.4l0.75,0.13l3.56,2.01l5.59,0.9l1.43,-0.11l0.69,-0.77l0.86,-2.9l5.87,-7.38l3.37,-1.04l1.23,-0.8l1.2,-3.04l2.73,-1.72l0.63,-1.42l0.14,-2.33l-0.76,-1.94l1.18,-3.28l-0.27,-2.71l0.39,-2.45l-0.76,-1.93l-2.98,-2.84l-0.33,-0.87l0.42,-0.64l1.36,-0.33l3.11,2.61l1.58,2.47l1.2,3.11l1.34,0.52l2.04,-0.59l2.13,-2.18l1.93,-1.06l0.56,-0.96l0.0,-3.5l2.65,-5.03l1.05,-4.76l0.26,-2.33l-0.66,-3.03l0.57,-2.29l-1.38,-3.65l4.28,2.04l1.44,0.23l1.23,-0.23l1.13,-0.67l2.42,-2.44l2.24,-4.52l0.88,0.22l0.35,0.94l0.53,0.46l0.89,-0.06l1.75,-1.59l0.5,-1.46l1.39,-0.67l4.83,0.12l4.07,1.49l2.37,0.05Z",name:"Boyac\xe1"},"CO-QUI":{path:"M383.23,542.76l-1.3,2.33l-0.68,2.02l-3.25,1.93l-1.86,2.17l-1.05,2.91l-1.79,2.23l-1.39,2.95l-1.19,7.96l-2.08,3.12l-1.42,1.18l-3.06,5.27l-2.92,3.34l-3.77,-1.75l-0.36,-1.36l0.64,-4.32l2.3,-4.76l0.11,-4.04l-1.5,-3.04l-2.7,-1.08l-1.9,-0.36l0.26,-0.85l0.9,-0.7l0.15,-0.5l-0.46,-1.05l-0.1,-4.47l0.96,-2.79l-0.06,-0.82l2.02,-2.8l3.93,0.6l2.73,-0.38l0.63,-0.9l-0.32,-2.51l0.34,-0.23l2.45,1.03l5.45,-0.06l2.16,0.28l2.06,1.54l0.99,0.17l2.46,-0.71l2.63,-1.57Z",name:"Quind\xedo"},"CO-LAG":{path:"M494.92,142.02l9.44,-0.01l6.87,-1.08l4.75,-3.41l1.23,-2.05l0.97,-0.41l1.99,-2.21l2.08,-0.97l3.42,-3.25l7.34,-3.88l11.59,-9.23l5.9,-1.56l2.69,-1.68l1.35,0.28l3.88,-2.0l4.77,-0.43l2.6,-1.87l2.01,-0.52l2.59,-1.88l3.17,-1.27l2.1,-2.3l1.11,-3.36l2.14,-3.34l0.64,-2.09l1.81,-2.68l-0.42,-6.03l-1.58,-1.53l0.04,-0.26l1.6,-1.09l1.92,0.63l6.14,-1.08l1.67,0.37l-0.13,0.64l-2.44,2.53l0.1,0.63l0.81,0.43l1.05,1.62l1.07,0.49l2.13,-0.83l1.48,-2.27l2.62,-0.26l0.58,-1.13l-0.81,-1.53l0.31,-0.44l-0.08,-0.55l-1.41,-1.39l-1.77,-0.4l-0.86,0.16l-0.96,0.7l-0.14,-0.27l4.74,-3.64l0.49,-1.16l1.52,-0.09l-0.55,1.27l0.99,1.32l0.9,0.32l1.06,-0.29l0.29,-0.85l1.06,-0.06l2.01,-1.27l0.68,-1.96l-0.55,-0.56l0.8,-0.64l0.42,-0.11l-0.13,0.83l0.93,1.04l0.23,0.74l0.38,0.28l0.7,-0.17l0.55,-1.21l-0.33,-0.53l2.81,-1.24l0.78,-1.26l-1.15,-0.12l-1.65,0.68l1.14,-1.29l-0.38,-0.28l-1.6,0.23l0.23,-0.99l-0.3,-0.04l1.71,0.04l3.19,1.12l5.58,0.23l4.39,2.9l2.98,0.19l1.71,1.13l4.01,0.99l1.94,0.98l1.1,0.81l0.88,1.32l0.48,1.65l3.64,6.2l0.45,1.74l2.26,3.35l0.33,1.03l-0.33,1.22l-1.39,2.12l-5.72,3.44l-1.28,1.38l-2.81,1.15l-1.62,4.1l-1.78,0.01l-3.17,2.37l-2.33,1.0l-31.59,8.2l-1.31,0.84l-1.18,1.64l-15.05,28.01l-0.53,0.66l-0.84,0.21l-3.52,-0.69l-4.58,1.5l-3.89,0.31l-1.24,0.78l-0.41,0.71l-0.23,1.77l-2.1,2.6l-2.07,5.09l-1.04,1.43l-3.7,2.87l-1.72,1.96l-1.43,2.77l-2.91,8.32l-1.6,2.6l-3.71,4.31l-1.17,3.29l-2.76,3.36l-0.52,1.39l-3.55,1.23l-3.04,0.33l-2.94,-0.82l-3.12,0.88l-0.99,-2.06l-0.67,-0.8l-0.93,-0.39l0.43,-0.74l0.77,-0.49l1.17,-2.11l0.89,-0.63l0.67,-2.09l0.87,-1.04l1.44,-3.51l-0.69,-1.06l-2.37,-2.04l-2.44,-1.41l-5.14,-1.97l-0.33,-0.61l0.35,-1.37l-0.18,-2.41l-0.39,-1.2l-0.82,-1.12l-1.07,-0.63l-10.09,-0.85l-9.04,1.23l-1.22,-4.18l-0.31,-2.61l-1.1,-2.25l0.77,-3.0l0.25,-4.01l-0.21,-1.5l1.41,-0.93l1.91,-2.09l1.16,-3.59l-0.07,-1.47ZM608.04,69.0l-0.7,0.46l-1.41,1.24l0.93,-1.07l1.19,-0.63Z",name:"La Guajira"},"CO-TOL":{path:"M391.92,622.93l-2.75,-1.85l-1.49,-0.46l-2.16,0.42l-1.62,1.7l-2.34,1.03l-0.99,0.16l-1.39,-0.27l-0.86,0.26l-0.96,0.89l-4.69,6.92l-1.35,2.84l-0.24,2.33l-1.42,1.44l-0.52,2.09l-1.03,1.22l-5.89,4.86l-2.33,2.45l-1.81,3.33l-2.25,0.03l-4.72,-1.68l-2.53,-1.8l-1.72,-0.11l-1.4,0.88l0.05,-3.25l-0.89,-2.55l-2.15,-2.4l-1.97,-1.27l0.06,-1.07l0.79,-1.11l0.42,-1.66l-0.01,-2.28l1.51,-1.47l0.18,-3.5l0.18,-0.65l1.0,-1.14l-0.12,-0.94l-1.06,-1.93l0.7,-1.6l0.2,-3.47l1.24,-3.59l1.95,-3.53l0.47,-5.23l1.03,-1.82l0.57,-2.04l1.38,-1.58l0.88,-1.93l4.02,-6.06l1.42,-3.44l1.56,-2.68l0.78,-2.31l0.41,-0.6l2.71,-1.61l-0.07,-0.85l-0.85,-1.35l2.93,-3.35l3.15,-5.38l1.33,-1.06l2.17,-3.26l1.22,-8.04l1.34,-2.85l1.82,-2.28l1.01,-2.83l1.71,-1.99l3.34,-2.03l0.78,-2.17l1.61,-2.89l0.74,-5.59l2.88,-4.89l0.03,-1.16l-1.42,-2.61l0.29,-1.45l1.88,-3.66l-0.83,-1.82l-0.91,-0.54l0.43,-1.16l2.57,-2.67l0.79,-0.36l2.32,0.13l4.17,-2.22l2.11,0.74l0.88,-0.24l3.56,-5.43l0.32,-1.0l1.86,-1.02l5.27,-1.34l3.41,0.46l3.01,-0.76l4.37,1.57l0.52,-0.05l0.26,0.87l0.41,9.71l-0.86,5.0l1.2,2.42l-1.48,0.73l-0.5,0.71l0.78,2.47l-0.18,1.78l-0.87,0.8l-0.22,0.94l0.47,3.89l-0.21,0.61l-0.75,0.82l-0.45,1.3l-1.95,0.93l-0.53,0.91l0.12,0.93l0.86,1.35l0.09,1.33l1.12,0.82l-1.59,2.5l0.61,0.94l-0.64,0.61l0.79,2.53l-0.06,2.32l-0.62,2.25l-4.29,9.49l-0.26,1.93l1.06,1.09l5.49,-0.82l0.25,0.59l1.52,0.83l0.32,0.77l0.49,0.23l0.81,-0.26l1.82,1.63l1.54,0.49l1.99,-0.01l1.21,-1.27l0.77,-1.53l2.0,-0.88l1.24,0.14l1.82,1.55l2.1,4.26l0.46,2.14l-0.14,1.2l-1.87,2.01l-0.81,2.4l0.39,1.1l-0.65,2.51l1.15,2.03l0.04,0.61l-0.76,2.47l-1.65,3.05l-0.99,5.18l-3.7,3.33l-2.51,1.66l-1.89,2.95l-1.57,1.11l-0.66,1.41l0.24,1.66l-1.96,1.86l-0.5,0.92l-0.26,1.54l0.44,2.17l-0.27,0.56l-2.44,2.57l-2.29,3.34l-3.13,3.15l-3.29,0.64l-2.79,-0.25l-3.02,-0.96l-0.17,-0.38l0.66,-3.11l1.49,-4.14l-0.36,-0.57l-6.55,0.13l-1.77,1.08l-0.59,0.67l-0.11,0.68l-1.13,-0.96l-1.38,0.01l-1.93,1.97Z",name:"Tolima"},"CO-SUC":{path:"M365.61,256.08l1.39,0.23l3.18,-2.64l1.58,-2.99l1.18,-3.88l0.04,-3.86l-0.72,-1.8l-1.82,-2.42l-1.17,-0.2l-1.61,-0.98l-1.92,0.3l2.83,-2.91l1.6,-5.02l-0.03,-1.47l2.06,-6.26l-0.02,-1.3l0.83,-3.5l0.14,-1.97l-0.36,-0.95l4.26,-2.29l-2.11,3.68l-0.31,1.29l0.39,0.84l0.74,0.32l2.56,-0.37l0.18,2.5l0.52,1.56l-1.13,1.79l-0.07,0.87l0.39,0.65l1.62,0.85l4.9,1.66l0.84,0.15l0.95,-0.47l0.8,0.06l-0.86,3.39l0.1,2.45l-0.88,3.01l-0.2,1.94l-0.48,0.81l-0.55,2.71l0.2,0.43l0.47,-0.06l0.92,-0.87l1.46,0.34l2.05,-1.64l1.74,0.42l1.94,1.33l2.24,-0.03l0.8,0.33l6.95,6.3l3.27,0.46l-1.09,2.52l0.12,0.78l0.52,0.58l2.38,0.74l2.4,-0.66l0.58,0.74l1.71,1.09l-2.34,5.12l0.53,0.96l-0.22,1.89l1.1,2.92l1.07,4.91l2.32,1.75l2.37,4.53l2.6,1.68l1.67,0.66l5.74,4.38l2.81,3.12l4.16,5.92l-1.49,2.37l-1.61,1.42l-0.58,1.5l1.04,7.04l0.7,1.91l0.65,0.66l0.12,3.31l0.66,3.13l-1.26,3.37l-1.42,-0.27l-0.5,0.29l-0.42,2.03l-1.44,2.28l-2.49,1.25l-3.67,-0.07l-2.46,1.63l-0.95,0.18l0.05,-2.9l-0.44,-1.21l-2.91,-2.68l-1.78,-2.88l-3.7,-2.83l-2.36,0.09l-5.94,1.95l-6.2,3.02l-2.11,-2.17l-2.07,-1.37l-2.44,-1.1l-1.3,-2.24l-0.36,-5.73l-1.3,-5.13l0.34,-2.6l-1.14,-3.72l0.19,-2.17l3.43,-3.13l4.55,-1.17l0.79,-0.52l0.37,-3.12l0.46,-1.02l-1.42,-2.23l0.5,-0.97l-0.12,-0.51l-2.7,-1.93l-10.44,-4.86l-1.58,-2.41l-0.63,-2.84l-1.18,-0.61l-1.2,-0.09l-0.51,-0.68l-2.13,-0.46l-1.99,-2.31l-3.2,-1.58l-3.74,-1.29l0.04,-3.04Z",name:"Sucre"},"CO-PUT":{path:"M280.52,806.23l1.04,-2.35l-0.71,-2.48l-0.36,-2.75l-1.33,-3.43l0.02,-0.48l0.88,-1.17l-0.17,-1.73l-0.59,-0.67l-2.01,-1.07l-4.89,-4.39l5.82,-7.24l1.23,-0.91l1.76,-3.01l3.72,-8.46l-0.33,-1.54l-3.16,-1.73l-0.36,-3.28l0.2,-3.13l5.07,-1.89l1.61,-1.27l0.35,-0.86l-0.04,-2.28l0.47,0.36l1.1,-0.11l1.95,-1.57l6.72,0.28l1.75,-0.38l1.64,-0.94l1.52,-1.65l3.09,-4.66l0.7,-0.18l3.78,1.75l0.99,1.19l1.29,2.52l0.99,0.91l0.71,1.61l0.24,1.46l-1.59,4.21l-0.22,5.44l0.64,2.68l1.46,2.24l1.32,0.96l4.38,1.43l2.39,1.14l1.95,0.39l8.62,0.3l1.18,-0.34l2.68,-1.79l3.71,-0.26l1.58,-1.96l0.72,-0.15l2.48,0.86l3.38,-0.16l1.62,0.78l0.33,2.37l0.77,1.53l3.33,3.97l1.16,0.7l2.53,0.28l3.47,1.68l5.28,-0.3l2.63,0.33l2.31,1.08l3.66,3.89l2.55,0.96l5.28,0.35l3.42,-0.44l2.48,0.86l1.04,0.9l0.17,2.38l2.31,3.54l-0.38,2.86l0.16,1.22l0.88,2.16l0.97,1.39l1.74,0.63l4.01,-1.14l0.64,0.31l0.3,1.27l0.48,0.5l0.71,0.15l1.7,-0.38l2.02,0.38l0.55,1.38l-0.22,4.94l0.86,2.77l0.27,2.02l0.56,0.84l2.75,0.98l3.99,2.14l6.76,1.3l2.03,1.11l1.37,1.67l0.34,2.25l-1.12,2.1l1.0,0.98l1.15,0.4l-1.45,2.79l1.44,4.09l3.19,0.53l0.97,2.23l2.33,1.07l1.34,0.17l1.97,-0.37l1.07,0.55l1.26,0.16l0.87,-0.42l0.73,-1.87l0.65,-0.23l0.68,0.3l0.35,1.81l0.8,0.84l1.13,-0.01l2.01,-0.81l1.09,0.23l2.6,1.5l1.06,3.2l0.88,1.24l0.95,0.44l2.7,-0.45l0.55,0.44l0.35,1.33l0.66,0.53l1.29,0.0l1.84,-0.7l4.16,2.9l1.95,2.31l1.4,0.95l6.45,2.31l-31.64,9.82l-0.58,-1.32l-1.14,-0.19l-2.06,-2.35l-5.25,-3.45l-2.5,-2.64l-1.69,-2.84l-0.68,-0.57l-0.98,0.05l-1.2,0.72l-0.63,-0.03l-1.86,-1.55l-3.98,-0.75l1.79,-1.54l0.12,-0.5l-2.1,-4.25l-2.19,-2.4l-1.32,0.26l-2.01,2.77l-3.41,-0.75l-1.96,-1.11l-2.89,-3.0l-2.17,-0.41l-3.05,-3.92l-2.57,-1.63l-2.79,-0.75l-2.27,0.08l-0.89,0.94l-0.47,1.81l-1.55,1.49l-0.68,0.24l-4.87,-2.01l-3.37,-0.65l-1.21,-0.85l-1.42,-0.49l-3.46,-2.13l-2.82,-2.52l-1.71,-0.76l-1.87,-1.8l-1.38,-0.41l-5.1,0.86l-3.35,-0.76l-1.66,-0.93l-2.35,-1.74l-0.6,-0.9l-3.65,-2.25l-1.44,-1.33l-0.6,-0.88l-0.63,-2.01l-4.02,-5.09l-0.86,-1.65l-1.75,-0.01l-2.38,0.53l-0.51,-1.86l-0.55,-0.81l-5.34,-0.62l-2.24,-1.22l-1.64,-1.73l-0.73,-0.36l-1.08,0.23l-1.44,1.04l-1.81,2.06l-2.78,0.25l-0.47,0.42l-0.12,4.87l0.59,3.84l-0.78,0.52l-5.92,0.68l-1.64,0.82l-1.7,-0.24l-2.68,-2.21l-5.93,-1.15l-0.99,0.29l-0.26,0.4l0.13,2.0l-3.38,-1.03l-5.09,0.6l-1.72,-0.98l-2.07,-1.85l-1.83,-0.49l-2.42,-0.05l-1.64,-0.55l-2.25,-2.54l-1.07,-0.34Z",name:"Putumayo"},"CO-NAR":{path:"M190.99,681.37l0.45,2.34l0.38,0.29l0.39,-0.28l1.38,-5.66l0.5,-0.91l1.24,0.07l4.45,-5.75l1.31,-0.54l2.33,-2.21l1.43,-0.86l0.35,0.03l1.17,2.86l2.2,3.33l1.69,0.21l0.39,-0.52l-0.97,-3.71l0.05,-1.71l0.93,-1.23l0.79,2.29l-0.32,1.56l1.69,3.46l1.48,1.4l2.21,1.1l1.05,0.32l0.91,-0.1l2.37,-1.26l0.32,-4.25l-1.39,-3.72l0.24,-0.24l1.06,0.22l5.36,3.57l1.76,1.77l1.26,5.22l-1.1,3.91l0.1,1.38l1.08,2.54l4.34,6.25l0.37,2.57l1.0,1.26l5.88,2.0l2.63,0.13l2.9,-1.02l1.98,0.07l1.78,-0.75l1.42,-1.03l3.33,-0.48l1.1,-0.39l1.05,-0.83l1.98,-0.34l2.53,0.5l5.28,2.45l0.56,0.79l-0.19,1.55l-0.84,1.37l-0.67,1.97l0.24,0.78l4.29,3.4l2.6,1.32l0.74,1.28l-0.68,1.67l-1.36,0.64l-0.77,1.91l-2.22,2.0l-1.04,2.95l0.21,2.7l-1.69,4.42l0.25,0.54l3.61,1.17l0.78,-0.19l1.22,0.6l5.14,-1.4l1.19,0.78l1.94,0.36l1.22,-0.42l2.16,-1.8l6.13,-1.36l0.72,0.34l3.64,5.49l0.87,0.78l0.27,0.78l-0.58,2.26l-1.25,1.39l-2.88,1.82l-0.42,1.37l0.27,5.24l0.74,5.05l-1.59,1.37l-0.72,0.07l-0.63,-0.58l-0.51,0.17l-0.37,1.08l0.1,1.94l-0.93,1.12l-6.07,2.65l-0.25,3.51l0.4,3.54l0.44,0.59l0.79,0.12l2.1,1.33l0.14,0.8l-0.54,1.53l-3.12,6.77l-1.69,2.88l-1.19,0.86l-6.07,7.52l0.02,0.55l2.43,2.41l2.84,2.34l2.31,1.4l0.11,1.31l-0.83,0.95l-0.07,0.89l1.36,3.56l0.33,2.66l0.7,2.38l-0.83,1.21l-0.18,0.91l-1.68,0.08l-3.06,1.14l-1.19,0.07l-2.95,-1.14l-6.42,-1.3l-2.03,-0.75l-1.5,-1.15l-0.57,-1.4l-0.81,-3.81l-0.39,-6.33l-0.83,-3.02l-2.79,-0.91l-2.11,0.27l-2.07,-0.82l-3.88,-2.68l-1.19,-1.76l-0.39,-4.26l-1.96,-1.7l-1.89,-0.07l-5.95,2.06l-2.37,-0.3l-1.8,-0.92l-0.31,-1.86l-0.92,-0.88l-1.23,0.11l-4.18,-1.55l-4.21,-0.15l-2.44,-1.19l-7.91,-5.98l-5.98,-2.18l-1.37,-1.04l-5.68,-6.31l-1.16,-0.91l-3.51,-0.85l-1.66,0.38l-1.48,-1.95l-0.57,-1.96l-0.8,-0.17l-1.65,0.4l-1.26,-0.39l-1.09,-0.85l-2.17,-3.62l-1.75,-1.41l-1.34,-1.83l-2.98,-2.04l0.53,-0.66l-0.41,-1.09l-2.1,-1.86l0.08,-3.07l-0.49,-1.1l-0.92,-0.29l-1.69,0.78l-0.96,-0.96l-0.88,-0.19l-3.98,-2.47l-0.83,-0.88l-0.42,-0.7l0.58,-1.21l1.99,-0.6l1.25,-1.11l1.81,-3.0l4.75,-4.77l2.66,-0.6l2.39,0.09l3.69,1.1l5.11,0.65l1.93,1.27l0.78,-0.11l0.32,-0.41l0.24,-2.07l0.83,-0.98l0.43,-1.54l-0.45,-1.17l0.48,-2.44l-0.18,-0.36l-0.64,-0.1l-0.63,0.99l-1.44,0.33l-0.27,-1.49l0.72,-4.35l-0.28,-0.81l-1.17,-1.2l-0.73,-0.28l-0.99,0.4l-0.68,1.01l-0.57,1.77l-0.38,-0.03l-0.3,-2.79l-0.76,-2.12l-1.05,-4.91l-0.15,-2.47l1.8,-4.47l1.68,-0.85l0.5,-1.68l3.52,-6.94ZM213.28,665.51l1.17,0.48l1.15,-0.38l0.97,0.55l0.78,1.58l0.09,1.37l1.46,1.83l0.51,1.19l0.06,1.79l-0.57,1.41l-1.29,0.39l-1.21,-0.72l-2.9,-3.35l-0.5,-1.14l0.13,-0.59l1.11,-1.35l-1.27,-2.54l0.3,-0.52Z",name:"Nari\xf1o"},"CO-CHO":{path:"M320.61,288.94l0.76,-0.85l-0.33,-1.04l0.21,-0.19l3.58,-0.88l1.46,-0.84l1.24,-0.21l1.42,-1.77l2.28,-1.67l0.55,-1.01l-0.5,-2.01l0.55,-1.56l3.18,-3.15l0.98,-1.72l1.02,-5.74l3.2,-1.35l0.39,-2.89l0.77,-1.08l0.98,-0.58l4.38,-1.36l1.8,-1.03l1.49,-1.25l0.55,-2.23l0.96,0.1l0.88,0.64l2.03,-0.12l3.77,-0.86l0.56,0.58l-1.29,-0.26l-1.0,0.22l-0.9,0.73l0.04,0.63l0.95,0.49l0.92,-0.3l0.44,0.78l0.62,0.28l2.92,-1.8l1.26,-0.22l2.08,0.44l-0.05,3.53l0.27,0.38l3.96,1.37l3.08,1.52l2.13,2.39l2.06,0.45l0.55,0.68l1.34,0.13l0.8,0.44l0.47,2.6l1.85,2.71l10.51,4.89l2.32,1.67l-0.44,1.15l1.42,2.26l-0.43,0.69l-0.19,2.75l-5.17,1.56l-3.26,2.76l-0.52,0.88l-0.18,2.5l1.13,3.69l-0.35,1.59l0.14,2.27l1.18,3.92l0.36,5.69l0.95,2.06l0.74,0.74l2.48,1.12l1.94,1.3l2.21,2.3l0.46,0.08l6.36,-3.11l5.9,-1.94l1.96,-0.06l3.33,2.63l1.73,2.83l2.86,2.63l0.27,0.78l-0.05,3.32l0.28,1.65l-1.25,1.44l-0.73,2.15l-1.01,0.33l-2.1,1.83l-3.32,4.85l-4.36,-0.12l-2.66,0.94l-3.25,-0.51l-4.52,0.48l-2.54,0.88l-2.23,3.18l-3.7,3.92l-2.24,2.87l-5.86,4.63l-1.96,4.23l-1.52,0.95l-1.91,2.08l-1.19,5.15l-1.4,2.11l-3.21,1.52l-5.74,1.41l-1.87,1.34l-4.36,6.08l-0.35,1.56l-0.52,0.33l-32.92,-0.82l-1.57,-4.95l-3.79,-8.17l-0.44,-2.66l0.0,-5.75l2.2,-8.07l2.13,-3.39l0.84,-3.02l0.02,-7.3l2.94,-4.71l3.15,-6.3l2.88,-4.09l3.18,-3.75l0.32,-2.89l-1.0,-7.81l-1.95,-2.99l-1.04,-0.98l-3.34,-1.2l-0.78,-0.78l-2.52,-3.83l-1.42,-6.12l-1.7,-1.76Z",name:"C\xf3rdoba"},"CO-":{path:"M7.13,587.28l0.01,-0.01l0.0,-0.0l-0.01,0.01ZM7.7,586.85l0.09,-0.48l0.48,-0.03l0.06,0.22l-0.63,0.29Z",name:""},"CO-DC":{path:"M423.16,506.94l-0.08,-0.51l1.65,-1.62l1.87,-4.83l1.07,-1.05l-0.16,-1.6l0.68,-0.12l0.31,-0.53l-0.46,-1.94l0.45,-1.88l-0.25,-0.54l-0.88,-0.52l2.23,-1.05l-0.18,-0.92l-0.75,-0.33l1.25,-3.9l-0.37,-0.99l-0.44,-0.3l1.13,-2.21l-0.8,-1.01l-0.04,-1.91l4.02,-0.91l2.15,-1.2l6.0,1.34l1.62,-0.51l4.24,-3.04l0.65,1.26l0.74,0.52l0.06,1.62l0.53,1.06l0.01,1.9l0.85,2.0l-1.45,2.58l-0.06,1.61l0.95,1.92l2.54,2.45l0.4,1.08l0.06,2.24l0.7,0.55l1.98,-0.02l3.69,1.88l2.71,-0.12l0.03,1.04l1.35,1.56l1.0,0.59l1.0,0.13l2.77,1.54l0.47,-0.06l3.89,-3.58l1.61,-0.45l0.73,-1.57l0.01,-1.07l4.51,-4.47l1.06,-0.29l0.38,3.37l3.17,1.54l1.34,-0.22l1.22,1.15l1.08,0.45l1.38,-0.1l0.8,1.82l2.99,2.6l0.38,0.98l-0.59,1.58l0.23,1.66l0.45,0.86l2.56,2.06l1.1,1.8l-0.18,1.62l0.49,1.74l1.47,2.52l0.07,2.79l0.92,1.73l-0.1,0.52l-2.25,1.65l0.03,2.22l-1.82,3.47l0.03,1.21l1.34,1.89l5.26,0.27l1.65,0.51l2.53,3.23l-0.2,0.97l0.35,0.68l2.24,0.8l1.97,3.23l0.96,0.2l2.25,-0.32l0.82,0.44l0.23,1.63l0.75,1.34l1.29,0.04l2.6,0.98l2.5,-0.19l1.5,-1.01l1.01,-1.84l-4.33,28.52l-3.13,-1.71l-0.62,-0.99l-0.83,-0.61l-8.84,-2.4l-3.96,0.39l-1.73,1.3l-1.75,0.51l-2.31,-0.82l-1.27,-1.04l-1.37,-3.6l-0.4,-2.53l-2.52,-3.82l-0.8,-0.47l-1.37,-0.11l-1.26,-1.31l-1.57,-0.59l-1.51,0.84l-1.29,2.18l-3.19,1.7l-1.18,1.71l-0.12,1.27l0.84,1.07l0.67,3.1l0.03,2.41l1.41,1.97l0.6,3.11l-3.26,-0.12l-1.36,1.02l-5.18,2.04l-1.34,0.72l-1.17,1.89l-2.65,0.48l-1.11,0.57l-1.05,1.09l-2.22,1.48l-2.8,2.77l-1.17,-0.08l0.91,-2.49l0.19,-1.94l1.72,-1.71l0.68,-1.64l-1.37,-2.64l-1.43,-1.68l-0.78,-2.26l0.2,-1.5l2.54,-4.05l0.29,-1.83l-0.8,-2.09l-0.01,-1.43l0.52,-1.18l1.13,-0.91l3.2,-5.18l1.37,-0.94l1.13,-3.99l-0.41,-0.51l-1.01,0.07l-0.74,-0.81l1.05,-1.76l-0.3,-5.6l0.47,-2.53l-0.23,-0.47l-1.73,-0.72l-2.93,-0.47l-0.36,0.69l0.03,1.21l-1.54,1.27l-1.39,3.18l-0.84,0.23l-0.59,1.04l-0.99,0.68l-0.13,1.21l0.19,0.42l0.54,0.08l-0.15,0.27l-3.48,2.28l-0.1,0.51l0.77,1.37l1.38,1.44l0.66,2.41l-0.11,2.29l-2.23,6.11l0.41,0.54l1.07,0.01l-1.35,8.18l-0.97,2.1l-1.26,1.64l0.04,2.57l-0.74,2.56l-0.27,0.38l-1.31,-0.38l-1.79,-1.19l-0.48,0.0l-0.92,0.91l-1.87,5.05l0.12,2.85l0.49,1.79l-0.49,2.75l-3.07,6.25l-4.13,5.78l-1.87,-1.37l-1.86,-2.31l0.7,-4.22l1.61,-2.95l0.81,-2.64l-0.09,-1.05l-1.11,-1.96l0.67,-2.17l-0.29,-1.81l0.58,-1.37l1.87,-2.01l0.25,-1.61l-0.51,-2.43l-2.17,-4.41l-2.08,-1.81l-0.79,-0.35l-1.03,0.11l-2.4,1.09l-0.86,1.63l-0.98,1.06l-1.48,-0.11l-1.15,-0.34l-1.93,-1.73l-1.07,0.13l-0.37,-0.72l-1.51,-0.84l-0.07,-0.49l-0.47,-0.34l-4.56,0.78l-1.08,0.09l-0.37,-0.37l0.2,-1.57l4.28,-9.46l0.68,-2.48l0.07,-2.44l-0.71,-2.33l0.71,-0.62l-0.71,-0.99l1.25,-1.64l0.28,-1.1l-0.38,-0.68l-0.87,-0.44l0.03,-1.06l-0.99,-1.87l0.27,-0.53l1.94,-0.91l0.6,-1.47l0.82,-0.95l0.28,-0.97l-0.48,-3.75l0.13,-0.66l0.87,-0.58l0.23,-0.57l-0.21,-0.4l0.24,-1.62l-0.73,-2.21l1.6,-0.81l0.4,-0.78l-1.24,-2.38l0.86,-4.94l-0.42,-9.81l-0.39,-1.34ZM524.64,541.62l0.02,-0.23l0.21,-0.19l-0.23,0.42Z",name:"Cundinamarca"},"CO-ANT":{path:"M279.13,355.47l0.71,-0.55l-0.41,-1.01l0.0,-1.73l1.45,0.16l3.63,-2.89l0.89,-1.11l1.1,-6.11l0.34,-0.85l1.72,-1.5l0.94,-2.98l-0.26,-3.55l0.35,1.2l1.74,0.97l1.37,-0.2l0.42,-1.17l2.61,0.0l-0.51,1.28l0.14,0.97l-0.97,0.64l0.33,0.81l-0.36,0.04l-0.24,0.67l0.7,0.67l-1.39,-0.38l-1.56,0.12l-1.21,1.39l0.27,0.69l-0.98,3.04l1.68,2.5l3.44,1.16l3.96,0.11l2.2,-0.8l0.78,-1.24l-0.16,-1.43l0.82,-1.67l0.29,-5.52l-0.78,-1.61l-0.39,-0.22l-0.37,0.34l-0.11,-0.69l-0.01,-1.32l0.69,-2.19l-1.34,-5.27l0.0,-8.48l-0.3,-1.24l-1.74,-1.04l-0.92,-2.82l-1.36,-1.49l-4.17,-2.36l-2.12,-0.12l2.99,-4.17l5.81,-1.82l1.5,-0.13l5.9,-1.67l0.87,-0.46l0.47,-0.64l0.35,-1.93l0.58,-0.61l-0.16,-0.54l4.84,-1.68l3.53,-3.29l3.29,-2.32l1.59,1.57l1.38,6.0l2.62,4.04l1.1,1.06l3.21,1.12l0.88,0.82l1.88,2.88l0.92,7.46l-0.21,2.45l-3.13,3.69l-2.9,4.13l-3.18,6.36l-2.99,4.8l-0.05,7.42l-0.77,2.83l-2.18,3.5l-2.23,8.18l-0.01,5.94l0.46,2.81l3.83,8.29l1.63,5.15l0.37,0.28l32.7,0.99l0.9,-0.25l0.75,-0.47l0.44,-1.73l4.19,-5.88l1.65,-1.21l5.68,-1.39l2.25,-0.86l1.33,-0.91l1.55,-2.37l1.12,-4.99l1.73,-1.88l1.68,-1.12l1.89,-4.15l5.8,-4.57l2.29,-2.92l3.71,-3.93l2.06,-3.02l2.22,-0.76l4.45,-0.47l3.18,0.51l2.74,-0.95l4.46,0.13l2.21,-2.63l1.54,-2.5l1.91,-1.67l0.8,-0.24l14.04,11.44l2.81,4.15l0.56,1.63l0.68,6.04l0.55,1.85l0.77,1.27l1.49,0.99l0.22,0.55l-0.13,0.9l-0.88,1.62l-3.66,2.81l-0.93,1.76l-0.81,4.99l0.04,1.99l0.3,1.73l1.22,2.72l3.35,3.75l1.31,0.4l1.41,-0.21l2.42,-2.28l1.71,-3.7l1.91,-1.51l0.83,2.75l-0.6,2.28l-1.82,2.02l-0.54,1.07l-0.23,1.31l0.24,3.9l-0.58,2.01l0.04,1.61l0.44,2.06l2.2,6.01l0.45,2.66l0.69,1.03l2.89,0.96l3.23,-0.03l18.72,-17.77l-0.25,1.8l0.64,7.84l0.32,1.39l1.76,2.62l0.27,2.31l-0.69,1.45l-1.37,1.04l-5.55,2.87l-0.46,1.02l-2.54,2.68l-2.64,4.7l-11.08,8.21l-2.21,1.05l-2.43,0.3l-1.19,0.53l-1.39,3.78l0.33,6.46l1.07,1.23l0.38,0.99l-0.6,0.97l-1.39,0.03l-2.78,4.27l-1.49,1.58l-3.8,2.71l-1.18,1.31l-0.85,1.62l-0.49,2.67l-1.09,2.39l0.1,1.09l1.2,1.6l0.46,1.69l0.1,3.72l-1.87,1.46l-0.03,1.29l0.86,2.37l-1.65,1.34l-1.24,1.93l-0.61,3.9l-0.71,1.47l-1.12,-0.56l-1.97,0.45l-1.79,4.45l-1.73,0.51l-4.0,-2.85l-1.35,-0.41l-3.83,0.68l-3.92,1.14l-1.94,2.31l-1.85,0.77l-2.21,0.21l-0.36,0.36l-0.03,3.79l-2.44,3.04l-0.13,0.57l-2.57,0.57l-2.22,1.29l-1.0,0.87l-2.16,3.19l-0.8,-2.11l-0.52,-0.23l-0.99,0.38l0.01,-2.77l-1.48,-4.32l-0.58,-0.79l-1.66,-1.15l0.08,-2.31l-0.6,-1.12l-2.65,-1.32l-2.98,1.44l-0.72,0.03l-2.59,-1.08l-1.48,-1.95l-3.72,-0.96l-0.39,0.49l0.03,2.0l0.37,0.93l0.79,0.41l-0.29,2.49l0.96,3.42l-0.12,3.32l-1.32,-0.38l-4.32,-0.11l-2.52,-1.86l-1.04,0.18l-3.93,2.77l-3.14,1.29l-1.2,0.12l-2.7,-0.4l-3.31,-1.58l-1.04,-1.03l-0.71,-1.36l-1.9,-1.04l-2.33,-2.38l-0.86,-1.39l0.79,-3.39l-0.18,-1.71l-2.21,-3.81l-0.69,-2.81l0.14,-1.36l1.67,-4.11l-0.35,-2.98l-1.79,-1.06l-1.71,-0.08l-1.34,-0.53l-1.61,-2.07l-1.38,-3.68l-0.53,-3.65l-0.71,-1.26l-1.33,-0.88l-4.45,-0.3l-13.35,1.86l-6.22,0.0l-2.18,-0.89l-1.36,-3.01l-1.68,-1.84l-0.33,-1.56l-1.68,-0.96l-0.04,-1.87l0.8,-1.44l-0.1,-0.61l-0.4,-0.23l0.43,-0.8l-0.09,-0.69l-0.78,-1.31l0.56,-0.27l0.46,-0.77l-0.28,-0.54l-0.81,-0.4l0.82,-1.24l0.07,-0.77l-1.52,-2.02l-1.04,0.05l-1.35,-1.64l-0.28,-1.87l-0.67,-0.77l-0.98,-0.5l-0.73,0.2l0.0,-1.29l0.36,-0.65l0.61,0.31l0.71,-0.36l0.04,-1.22l-0.54,-0.45l-1.6,-0.23l-0.26,-0.45l0.38,-1.44l-0.36,-0.69l-0.54,-0.08l-1.24,1.24l-0.53,-1.57l-1.04,-0.37l0.81,-1.43l-0.33,-0.77l-0.78,-0.59l-0.25,-3.02l3.23,-0.86l1.82,-1.09l2.92,0.2l0.76,-0.42l1.49,-1.76l0.36,-1.2l-0.57,-3.33l-0.49,-0.88l-0.84,-0.59l-0.42,-1.04l0.18,-0.57l0.73,-0.43l2.81,-0.77l5.04,-0.27l4.96,1.2l1.95,0.8l1.8,-0.06l2.03,-3.37l0.49,-1.83l-0.2,-7.03l-1.29,-3.8l-0.93,-1.29l-3.36,-2.78l-3.02,-0.61l-2.66,-1.92l-4.86,-6.02l-6.3,-6.82l-6.34,-4.54l-7.73,-6.99l-0.87,-1.31ZM289.13,332.02l-0.5,-1.87l0.47,0.26l0.73,-0.19l0.25,0.95l0.48,-0.14l-0.27,0.88l-0.73,-0.23l-0.44,0.34ZM287.77,327.02l0.34,-0.26l0.27,-0.55l0.18,0.66l-0.8,0.15Z",name:"Antioquia"}},height:1084.910959161064,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","continents_mill",{insets:[{width:900,top:0,height:440.7063107441331,bbox:[{y:-12671671.123330014,x:-20004297.151525836},{y:6930392.025135122,x:20026572.394749384}],left:0}],paths:{AF:{path:"M388.36,214.16l1.16,-0.96l2.44,-0.39l1.94,-1.82l1.31,-0.78l2.09,-2.28l-0.51,-3.65l1.24,-3.7l1.5,-1.75l4.46,-2.57l2.37,-4.47l1.44,0.01l1.68,1.21l2.32,-0.19l3.7,0.65l2.57,-1.58l2.63,-0.48l1.7,-1.22l2.31,-0.84l8.24,-0.73l1.49,0.38l2.28,-1.1l2.46,-0.02l1.18,0.67l1.83,-0.2l2.61,-1.12l1.29,0.26l-0.06,1.11l0.58,0.38l1.47,-0.73l-1.0,1.27l-0.02,1.32l0.84,0.88l-0.28,2.09l-1.53,1.32l-0.12,0.42l0.48,1.54l1.42,0.32l0.53,1.11l1.19,0.65l2.94,0.96l1.18,-0.21l1.98,0.44l3.15,1.18l1.37,2.54l5.72,1.67l2.64,1.35l1.61,-0.72l1.29,-1.34l-0.44,-2.34l0.66,-1.13l1.67,-1.21l1.57,-0.35l3.14,0.53l1.08,1.28l3.99,0.78l0.85,0.94l3.27,-0.04l5.97,1.95l2.23,-0.88l1.02,-0.77l2.04,-0.21l1.53,0.3l0.59,1.19l0.69,0.04l0.41,-0.64l1.81,0.58l1.95,0.16l1.04,-0.51l1.42,4.08l-1.8,4.36l-0.23,0.18l-1.66,-1.77l-1.76,-3.85l-0.64,-0.12l-0.36,0.67l1.04,2.88l3.47,7.0l1.75,2.99l2.03,2.65l-0.36,0.53l0.23,2.01l3.25,2.79l0.71,2.25l-0.49,0.66l0.36,2.69l0.93,3.16l2.39,1.75l1.39,2.86l0.8,2.51l4.8,3.68l3.5,3.77l1.71,1.41l-0.05,0.66l-1.2,0.51l-0.06,0.7l1.8,1.11l0.53,1.06l1.13,1.06l1.51,0.12l5.22,-0.97l4.31,-1.4l2.24,-0.15l2.43,-0.62l1.24,-0.86l0.45,-0.0l-0.2,3.0l-1.21,3.62l-2.73,5.97l-2.13,3.65l-5.03,6.16l-8.56,6.4l-2.78,3.08l-1.1,1.86l-1.7,0.97l-0.67,1.03l-1.08,0.46l-0.34,1.67l-0.81,1.07l-0.45,1.55l-1.03,0.92l-1.18,3.28l0.35,1.73l1.43,0.82l-0.6,1.76l-0.01,2.33l1.89,4.03l0.96,0.67l0.33,0.93l0.31,8.69l0.41,1.23l-1.61,3.38l-1.5,1.5l-5.16,2.28l-2.78,2.73l-1.02,0.53l-1.71,1.8l-0.98,0.57l-0.35,2.41l1.16,1.94l0.49,2.17l0.43,0.31l-0.06,2.06l-0.39,1.17l0.5,0.72l-0.25,0.73l-0.92,0.83l-5.03,2.32l-1.19,1.05l0.09,1.5l0.58,0.39l-1.08,5.21l-0.58,1.09l-2.2,1.79l-3.17,4.76l-4.54,4.48l-1.83,1.23l-2.53,1.05l-1.22,0.14l-0.51,0.7l-1.18,-0.32l-1.39,0.5l-2.59,-0.52l-1.61,0.33l-1.18,-0.11l-2.55,1.1l-2.1,0.44l-1.6,1.07l-0.85,0.05l-0.93,-0.89l-0.93,-0.15l-0.97,-1.13l-0.25,0.05l-0.13,-1.96l-0.68,-1.56l0.7,-0.68l-0.13,-2.33l-4.68,-8.43l-1.88,-2.1l-0.93,-1.88l-1.99,-8.56l-0.06,-3.12l-0.33,-1.52l-2.3,-3.34l-1.91,-4.83l-1.96,-2.43l-0.37,-3.45l0.33,-2.16l1.78,-5.68l2.87,-3.95l0.13,-3.41l-0.8,-1.08l-1.21,-2.87l0.87,-1.62l-1.27,-4.12l-1.17,-1.53l0.13,-0.6l-1.01,-2.64l-2.12,-2.77l-4.21,-4.58l-1.44,-2.45l1.72,-5.12l-0.39,-0.62l1.16,-4.58l-1.03,-1.93l-1.19,-0.54l-0.44,-0.97l-0.6,-0.42l0.02,-0.45l-0.53,-0.39l-2.51,0.87l-1.11,-0.07l-0.86,0.5l-1.71,-0.05l-1.19,-1.39l-0.89,-1.89l-1.77,-1.66l-4.36,-0.08l-4.23,0.85l-7.43,3.01l-2.11,-0.67l-4.62,-0.46l-3.02,0.44l-4.2,1.63l-1.01,-0.04l-2.45,-1.13l-4.38,-3.26l-1.66,-1.6l-2.51,-1.23l-1.22,-1.26l-0.76,-2.79l-2.11,-2.53l-1.2,-0.78l-0.67,-1.67l-2.15,-1.57l-1.09,-0.23l-0.54,-1.06l-0.65,-0.46l-0.5,-2.23l0.26,-1.33l-1.03,-1.99l-0.81,-0.64l0.64,-0.35l1.84,-3.18l-0.17,-1.48l0.68,-1.29l0.31,-2.43l-0.57,-3.91l0.2,-1.48l-0.74,-1.36l-1.16,-0.99l0.19,-1.94l0.92,-0.73l0.82,-1.37l-0.09,-1.04l0.79,-1.7l1.31,-1.58l0.96,-0.59l0.66,-1.55l0.09,-1.47l0.81,-1.48l1.72,-1.07l1.55,-2.69ZM508.61,319.02l-0.38,-2.84l0.59,-2.36l-0.82,-1.23l-0.31,-2.78l-1.32,-1.35l-0.67,0.17l-0.22,0.77l0.87,1.86l0.15,2.86l-0.69,1.65l0.71,1.8l0.06,1.28l0.49,0.64l0.07,1.06l0.4,0.55l0.8,-0.23l0.55,0.61l0.69,-0.19l0.04,-0.53l-0.51,-1.36l-0.5,-0.36ZM500.35,287.48l-0.53,3.14l0.76,1.3l0.5,0.12l1.05,-0.53l1.19,-0.12l0.61,0.24l1.43,-0.62l0.1,-0.67l-0.71,-0.62l1.92,-2.15l0.1,-2.1l-0.91,-1.28l-1.64,-0.47l-2.77,1.06l-1.15,1.46l0.04,1.23ZM496.99,305.58l-0.14,0.54l0.29,0.49l1.21,0.63l0.83,-0.05l0.23,-0.55l-1.44,-2.93l-0.18,-1.49l-1.9,-1.74l0.42,-1.05l-0.44,-0.89l0.08,-0.96l-0.46,-0.58l0.08,-1.16l-0.93,-2.42l-0.42,-0.25l-0.35,0.35l-0.45,4.01l0.64,1.47l-0.37,1.22l0.86,1.8l1.53,1.41l0.3,1.26l0.61,0.9ZM545.91,319.14l0.4,3.03l0.62,1.21l-0.21,1.02l-0.57,-0.8l-0.69,-0.01l-0.47,0.76l0.41,2.12l-0.18,0.87l-0.73,0.78l-0.15,2.14l-4.71,15.2l-1.06,2.88l-3.92,1.64l-3.12,-1.49l-0.6,-1.21l-0.19,-2.4l-0.86,-2.05l-0.21,-1.77l0.38,-1.62l1.21,-0.75l0.01,-0.76l1.19,-2.04l0.23,-1.66l-1.06,-2.99l-0.19,-2.21l0.81,-1.33l0.32,-1.46l4.63,-1.22l3.44,-3.0l0.85,-1.4l-0.08,-0.7l0.78,-0.04l1.38,-1.77l0.13,-1.64l0.45,-0.61l1.16,1.69l0.59,1.6Z",name:"Africa"},NA:{path:"M892.72,99.2l1.31,0.53l1.41,-0.37l1.89,0.98l1.89,0.42l-1.32,0.58l-2.9,-1.53l-2.08,0.22l-0.26,-0.15l0.07,-0.67ZM353.02,1.2l14.69,4.67l-3.68,1.89l-22.97,0.86l-0.36,0.27l0.12,0.43l1.55,1.18l8.79,-0.66l7.48,2.07l4.86,-1.77l1.66,1.73l-2.53,3.19l-0.01,0.48l0.46,0.15l6.35,-2.2l12.06,-2.31l7.24,1.13l1.09,1.99l-9.79,4.01l-1.44,1.32l-7.87,0.98l-0.35,0.41l0.38,0.38l5.07,0.24l-2.53,3.58l-2.07,3.81l0.08,6.05l2.57,3.11l-3.22,0.2l-4.12,1.66l-0.05,0.72l4.45,2.65l0.51,3.75l-2.3,0.4l-0.25,0.64l2.79,3.69l-4.82,0.31l-0.36,0.29l0.16,0.44l2.62,1.8l-0.59,1.22l-3.3,0.7l-3.45,0.01l-0.29,0.68l3.03,3.12l0.02,1.34l-4.4,-1.73l-1.72,1.35l0.15,0.66l3.31,1.15l3.13,2.71l0.81,3.16l-3.85,0.75l-4.89,-4.26l-0.47,-0.03l-0.17,0.44l0.79,2.86l-2.71,2.21l-0.13,0.44l0.37,0.27l8.73,0.34l-12.32,6.64l-7.24,1.48l-2.94,0.08l-2.69,1.75l-3.43,4.41l-5.24,2.84l-1.73,0.18l-7.12,2.1l-2.15,2.52l-0.13,2.99l-1.19,2.45l-4.01,3.09l-0.14,0.44l0.97,2.9l-2.28,6.48l-3.1,0.2l-3.83,-3.07l-4.86,-0.02l-2.25,-1.93l-1.7,-3.79l-4.3,-4.84l-1.21,-2.49l-0.44,-3.8l-3.32,-3.63l0.84,-2.86l-1.56,-1.7l2.28,-4.6l3.83,-1.74l1.03,-1.96l0.52,-3.47l-0.59,-0.41l-4.17,2.21l-2.07,0.58l-2.72,-1.28l-0.15,-2.71l0.85,-2.09l2.01,-0.06l5.06,1.2l0.46,-0.23l-0.14,-0.49l-6.54,-4.47l-2.67,0.55l-1.58,-0.86l2.56,-4.01l-0.03,-0.48l-1.5,-1.74l-4.98,-8.5l-3.13,-1.96l0.03,-1.88l-0.24,-0.37l-6.85,-3.02l-5.36,-0.38l-12.7,0.58l-2.78,-1.57l-3.66,-2.77l5.73,-1.45l5.0,-0.28l0.38,-0.38l-0.35,-0.41l-10.67,-1.38l-5.3,-2.06l0.25,-1.54l18.41,-5.26l1.22,-2.27l-0.25,-0.55l-6.14,-1.86l1.68,-1.77l8.55,-4.03l3.59,-0.63l0.3,-0.54l-0.88,-2.27l5.47,-1.47l7.65,-0.95l7.55,-0.05l3.04,1.85l6.48,-3.27l5.81,2.22l3.56,0.5l5.16,1.94l0.5,-0.21l-0.17,-0.52l-5.71,-3.13l0.28,-2.13l8.12,-3.6l8.7,0.28l3.35,-2.34l8.71,-0.6l19.93,0.8ZM280.06,145.6l-1.67,2.88l0.07,0.49l0.5,0.04l1.46,-0.98l1.0,0.42l-0.56,0.72l0.17,0.62l2.22,0.89l1.35,-0.71l1.95,0.78l-0.66,2.01l0.5,0.51l1.32,-0.42l0.98,3.17l-0.91,2.41l-0.8,0.08l-1.23,-0.45l0.47,-2.25l-0.89,-0.83l-0.48,0.06l-2.78,2.63l-0.34,-0.02l1.02,-0.85l-0.14,-0.69l-2.4,-0.77l-7.4,0.08l-0.17,-0.41l1.3,-0.94l0.02,-0.64l-0.73,-0.58l1.85,-1.74l2.57,-5.16l1.47,-1.79l1.99,-1.05l0.46,0.06l-1.53,2.45ZM133.68,213.97l0.68,-0.08l0.93,-1.01l0.08,-1.78l-1.93,-1.94l-1.46,-0.77l-2.94,-5.59l-1.52,-4.04l-1.62,-1.61l-1.14,-0.38l-0.55,-0.88l-1.28,-0.13l-1.01,-0.77l-2.22,-0.27l-0.43,-0.3l-0.36,-1.58l-2.4,-2.83l-2.01,-3.85l-0.06,-0.9l-2.92,-3.26l-0.33,-2.29l-1.3,-1.66l0.52,-2.37l-0.09,-2.57l-0.78,-2.3l0.95,-2.82l0.61,-5.68l-0.47,-4.27l-1.46,-4.08l3.19,0.79l1.26,2.83l0.69,0.08l0.69,-1.14l-0.42,-2.68l-0.85,-2.64l-7.11,-4.81l-4.5,-1.38l-1.26,-2.66l0.33,-1.93l-0.23,-0.43l-3.01,-1.35l-0.55,-2.77l-2.89,-2.38l-0.17,-1.88l-1.47,-1.38l-2.04,-1.03l-0.67,-2.89l-3.28,-3.03l-1.65,-3.57l-6.35,-0.32l-2.82,-1.01l-5.26,-3.85l-6.77,-2.04l-3.53,0.3l-4.81,-1.69l-3.25,-1.63l-2.78,0.8l-0.28,0.46l0.44,2.21l-3.91,0.96l-2.26,1.27l-2.3,0.65l-0.27,-1.65l1.05,-3.42l2.49,-1.09l0.16,-0.6l-0.69,-0.96l-0.55,-0.1l-3.19,2.12l-1.78,2.56l-3.55,2.61l-0.04,0.61l1.56,1.52l-2.07,2.29l-5.11,2.57l-0.77,1.66l-3.76,1.77l-0.92,1.73l-2.69,1.38l-1.81,-0.22l-6.95,3.32l-3.97,0.91l4.85,-2.5l2.59,-1.86l3.26,-0.52l1.19,-1.4l3.42,-2.1l2.59,-2.27l0.42,-2.68l1.23,-2.1l-0.04,-0.46l-0.45,-0.11l-2.68,1.03l-0.63,-0.49l-0.53,0.03l-1.05,1.04l-1.36,-1.54l-0.66,0.08l-0.32,0.62l-0.58,-1.14l-0.56,-0.16l-2.41,1.42l-1.07,-0.0l-0.17,-1.75l0.3,-1.71l-1.61,-1.33l-3.41,0.59l-1.96,-1.63l-1.57,-0.84l-0.15,-2.21l-1.7,-1.43l0.82,-1.88l1.99,-2.12l0.88,-1.92l1.71,-0.24l2.04,0.51l1.87,-1.77l1.91,0.25l1.91,-1.23l0.17,-0.43l-0.47,-1.82l-1.07,-0.7l1.39,-1.17l0.12,-0.45l-0.39,-0.26l-1.65,0.07l-2.66,0.88l-0.75,0.78l-1.92,-0.8l-3.46,0.44l-3.44,-0.91l-1.06,-1.61l-2.65,-1.99l2.91,-1.43l5.5,-2.0l1.52,0.0l-0.26,1.62l0.41,0.46l5.29,-0.16l0.3,-0.65l-2.03,-2.59l-3.14,-1.68l-1.79,-2.12l-2.4,-1.83l-3.09,-1.24l1.04,-1.69l4.43,-0.2l3.16,-2.0l0.73,-2.27l2.39,-1.99l2.42,-0.52l4.65,-1.97l2.46,0.23l3.71,-2.35l3.5,0.89l1.73,1.97l0.55,0.05l0.99,-0.79l3.65,0.24l-0.09,0.62l0.32,0.45l3.83,0.77l2.61,-0.43l5.19,1.4l4.84,0.43l1.89,0.57l3.42,-0.7l3.74,1.32l7.34,1.68l3.89,2.09l2.74,0.45l2.47,-1.89l2.88,-1.31l3.85,0.48l3.71,-1.94l3.82,-1.04l1.56,1.68l0.49,0.08l1.87,-1.04l0.65,-1.98l1.24,0.35l4.16,3.94l0.54,0.01l2.75,-2.49l0.26,2.59l0.49,0.35l3.08,-0.73l1.04,-1.27l2.73,0.23l3.83,1.86l5.86,1.61l3.47,0.75l2.44,-0.26l2.73,1.78l-2.98,1.81l-0.19,0.41l0.31,0.32l4.53,0.92l6.87,-0.5l2.0,-0.69l2.49,2.39l0.53,0.02l2.72,-2.16l-0.02,-0.64l-2.16,-1.54l1.15,-1.06l4.83,-0.61l1.84,0.95l2.48,2.31l3.01,-0.23l4.55,1.92l3.85,-0.67l3.61,0.1l0.41,-0.44l-0.25,-2.36l1.79,-0.61l3.49,1.32l-0.01,3.77l0.31,0.39l0.45,-0.22l1.48,-3.16l1.74,0.1l0.41,-0.3l1.13,-4.37l-2.78,-3.11l-2.8,-1.74l0.19,-4.64l2.71,-3.07l2.98,0.67l2.41,1.95l3.19,4.8l-1.99,1.97l0.21,0.68l4.33,0.84l-0.01,4.15l0.25,0.37l0.44,-0.09l3.07,-3.15l2.54,2.39l-0.61,3.33l2.42,2.88l0.61,0.0l2.61,-3.08l1.88,-3.82l0.17,-4.58l6.72,0.94l3.13,2.04l0.13,1.82l-1.76,2.19l-0.01,0.49l1.66,2.16l-0.26,1.71l-4.68,2.8l-3.28,0.61l-2.47,-1.2l-0.55,0.23l-0.73,2.04l-2.38,3.43l-0.74,1.77l-2.74,2.57l-3.44,0.25l-2.21,1.78l-0.28,2.53l-2.82,0.55l-3.12,3.22l-2.72,4.31l-1.03,3.17l-0.14,4.31l0.33,0.41l3.44,0.57l2.24,5.95l0.45,0.23l3.4,-0.69l4.52,1.51l2.43,1.31l1.91,1.73l3.1,0.96l2.62,1.46l6.6,0.54l-0.35,2.74l0.81,3.53l1.81,3.78l3.83,3.3l0.45,0.04l2.1,-1.28l1.37,-3.69l-1.31,-5.38l-1.45,-1.58l3.57,-1.47l2.84,-2.46l1.52,-2.8l-0.25,-2.55l-1.7,-3.07l-2.85,-2.61l2.8,-3.95l-1.08,-3.37l-0.79,-5.67l1.36,-0.7l6.76,1.41l2.12,-0.96l5.12,3.36l1.05,1.61l4.08,0.26l-0.06,2.87l0.83,4.7l0.3,0.32l2.16,0.54l1.73,2.06l0.5,0.09l3.63,-2.03l2.52,-4.19l1.26,-1.32l7.6,11.72l-0.92,2.04l0.16,0.51l3.3,1.97l2.22,1.98l4.1,0.98l1.43,0.99l0.95,2.79l2.1,0.68l0.84,1.08l0.17,3.45l-3.37,2.26l-4.22,1.24l-3.06,2.63l-4.06,0.51l-5.35,-0.69l-3.8,-0.02l-2.86,0.36l-2.04,2.28l-3.26,1.51l-6.47,7.15l-0.06,0.48l0.44,0.19l2.13,-0.52l4.17,-4.24l5.12,-2.62l3.52,-0.3l1.69,1.21l-2.12,2.21l0.81,3.47l1.02,2.61l3.47,1.6l4.14,-0.45l2.15,-2.8l0.26,1.48l1.14,0.8l-2.56,1.69l-5.5,1.82l-2.54,1.27l-2.74,2.15l-1.4,-0.16l-0.07,-2.01l4.14,-2.44l0.18,-0.45l-0.39,-0.29l-4.01,0.1l-2.83,0.38l-0.31,0.55l0.29,0.68l-2.34,1.31l-5.37,2.09l-1.83,2.72l0.02,1.79l0.83,1.59l0.54,0.23l-6.19,0.94l-2.2,0.89l-0.23,0.48l0.45,0.29l2.99,-0.46l-2.19,0.56l-1.13,0.0l-0.15,-0.32l-0.48,0.08l-0.76,0.82l0.22,0.67l0.32,0.06l-0.41,1.62l-1.27,1.58l-1.48,-1.07l-0.49,-0.04l-0.16,0.46l0.52,1.58l0.61,0.59l0.03,0.79l-0.95,1.38l-1.21,-1.22l-0.27,-2.27l-0.35,-0.35l-0.42,0.25l-0.48,1.27l0.33,1.41l-0.97,-0.27l-0.48,0.24l0.18,0.5l1.52,0.83l0.1,2.52l0.79,0.51l0.52,3.42l-1.42,1.88l-2.47,0.8l-1.71,1.66l-1.31,0.25l-1.27,1.03l-0.43,0.99l-2.69,1.78l-1.46,1.38l-1.25,1.8l-0.39,1.96l0.45,2.08l0.85,2.38l1.09,1.9l0.04,1.2l1.16,3.06l-0.18,2.69l-0.55,1.43l-0.47,0.21l-0.89,-0.23l-0.49,-1.18l-0.87,-0.56l-2.75,-5.16l0.46,-1.96l-0.76,-1.59l-1.95,-2.29l-1.46,-0.52l-2.38,1.17l-1.47,-1.35l-1.78,-0.71l-2.78,0.34l-2.17,-0.3l-2.12,0.22l-1.04,0.43l-0.19,0.58l0.39,0.63l0.14,1.34l-0.84,-0.2l-0.84,0.46l-1.58,-0.07l-2.08,-1.44l-2.09,0.33l-1.91,-0.62l-3.73,0.84l-2.39,2.07l-2.54,1.22l-1.37,1.29l-0.66,1.34l-0.06,2.07l0.37,1.81l-0.74,0.46l0.75,0.34l-1.18,3.72l-0.42,5.04l1.79,4.89l1.62,1.89l0.61,1.52l0.98,1.28l2.77,0.8l1.37,1.1l7.54,-1.89l1.86,-1.3l1.14,-4.3l4.1,-1.21l3.57,-0.11l0.32,0.3l-0.06,0.94l-1.26,1.45l-0.67,1.71l0.38,0.7l-0.72,2.27l-1.01,-0.25l-0.37,0.41l0.46,0.77l-0.4,1.3l0.06,1.78l-0.24,1.06l-0.92,0.74l-0.5,0.89l0.15,0.54l0.82,0.46l0.58,-0.22l0.68,0.29l0.85,-0.43l2.37,0.28l1.27,-0.09l1.1,-0.52l1.3,0.28l1.14,-0.25l1.38,0.37l2.3,1.4l0.36,0.39l-0.2,0.71l0.21,0.95l-0.8,1.86l0.09,2.82l-0.36,0.37l-0.11,1.75l-0.47,0.81l1.24,2.69l2.92,2.88l0.32,0.78l1.26,0.03l0.77,0.49l1.38,-0.23l2.51,-1.11l0.86,-0.72l3.45,0.85l1.4,1.18l0.41,1.74l-0.21,0.34l-0.53,-0.12l-0.47,0.29l-0.16,0.6l-0.68,-1.28l0.45,-0.49l-0.19,-0.66l-2.26,-1.67l-1.35,0.11l-0.75,0.99l-1.62,0.84l-0.18,0.96l0.85,0.97l-0.58,0.45l-0.69,0.08l-0.34,-1.18l-1.27,0.03l-0.71,-1.05l-1.74,-0.47l-1.3,0.2l-1.27,-0.52l-0.28,-1.49l-2.46,-1.42l-0.28,-0.77l-1.11,-0.45l-0.11,1.04l-1.13,-0.66l-0.11,-2.88l-4.27,-4.05l0.33,-0.66l-0.67,-0.99l-0.76,-0.22l-0.64,0.58l-1.14,-0.03l-1.95,-0.75l-1.28,-0.15l-2.02,-0.99l-1.6,-0.07l-2.32,-1.46l-2.88,-2.79l-1.38,-0.88l-2.04,-0.67l-1.58,0.17l-3.19,1.2l-10.55,-3.85l-2.86,-1.96l-3.78,-0.92l-1.08,-1.19l-2.62,-1.43l-1.18,-1.54l-0.38,-0.81l0.66,-0.63l-0.18,-0.53l0.52,-0.76l0.01,-0.91l-2.0,-3.82l-2.21,-2.63l-2.53,-2.09l-1.19,-1.62l-2.2,-1.17l-0.3,-0.43l0.34,-1.48l-0.21,-0.45l-1.23,-0.6l-1.36,-1.2l-0.59,-1.78l-1.54,-0.47l-2.44,-2.55l-0.16,-0.9l-1.33,-2.03l-0.84,-1.99l-0.16,-1.33l-1.81,-1.1l-0.97,0.05l-1.31,-0.7l-0.57,0.22l-0.4,1.12l0.72,3.77l3.51,3.89l0.28,0.78l0.53,0.26l0.41,1.43l1.33,1.73l1.58,1.41l0.8,2.39l1.43,2.41l0.13,1.32l0.37,0.36l1.04,0.08l1.67,2.28l-0.85,0.76l-0.66,-1.51l-1.68,-1.54l-2.91,-1.87l0.06,-1.82l-0.54,-1.68l-2.91,-2.03l-0.55,0.09l-1.95,-1.1l-0.88,-0.94ZM223.23,169.68l1.12,-0.33l4.16,0.31l1.88,-1.01l0.21,-0.4l-0.2,-1.35l-1.0,-0.87l-1.72,0.98l-1.12,-0.48l-2.12,0.42l-2.62,0.84l-0.9,1.17l0.21,0.62l1.0,0.29l1.11,-0.19ZM212.87,172.48l-1.23,1.32l0.17,0.61l1.54,0.62l1.48,0.17l1.92,-0.44l4.63,-2.09l2.25,-1.86l0.09,-0.67l-0.46,-0.33l-2.23,0.39l-1.85,0.81l-2.11,-0.13l-2.95,1.78l-1.25,-0.17ZM196.34,154.17l-2.46,1.01l-1.86,1.32l-1.71,1.34l-0.16,0.77l0.5,0.39l2.33,-0.61l1.77,1.02l5.15,-2.4l-0.31,0.65l0.25,0.56l1.36,0.38l1.71,1.16l4.7,-0.88l0.67,0.85l0.76,0.13l0.46,-0.28l0.67,0.94l-1.34,0.17l-2.18,-0.32l-3.6,0.89l-2.71,3.25l0.35,0.9l0.59,-0.0l0.55,-0.6l-1.36,4.65l0.29,3.09l1.01,1.93l1.12,0.08l0.84,-0.37l1.68,-2.01l0.14,-2.21l-0.82,-1.96l0.11,-1.13l1.19,-2.37l0.44,-0.33l0.48,0.75l0.4,-0.29l0.4,-1.37l0.6,-0.47l0.24,-0.8l1.69,0.49l1.65,1.08l-0.03,2.37l-1.27,1.13l-0.0,1.13l0.87,0.36l1.66,-1.29l0.5,0.17l0.51,2.75l0.61,0.3l1.8,-1.25l0.1,-2.29l1.16,-1.99l0.49,0.53l2.03,0.42l1.2,-1.16l0.02,-0.47l-2.66,-3.51l-2.28,-0.61l-5.64,-0.71l-0.4,-0.57l-0.79,0.13l0.2,-0.41l-0.22,-0.55l-0.68,-0.26l0.19,-1.26l-0.78,-0.73l0.31,-0.64l-0.29,-0.57l-2.6,-0.44l-0.75,-1.63l-0.73,-0.59l-4.53,-0.72l-1.13,1.19l-1.48,0.59l-0.95,1.19ZM266.64,259.32l0.28,-1.16l1.13,-0.22l-0.06,1.2l-1.35,0.18ZM260.37,148.65l3.04,0.76l2.26,1.2l-3.78,-0.95l-1.53,-1.01ZM249.4,3.81l6.68,0.49l5.32,0.79l4.26,1.57l-0.07,1.1l-5.85,2.53l-6.02,1.21l-2.39,1.39l-0.18,0.45l0.39,0.29l4.01,-0.02l-4.65,2.82l-4.2,1.74l-4.19,4.59l-5.03,0.92l-1.67,1.15l-7.47,0.59l-0.37,0.37l0.32,0.42l2.41,0.49l-0.81,0.47l-0.12,0.59l1.83,2.41l-2.02,1.59l-3.81,1.51l-1.32,2.16l-3.38,1.53l-0.22,0.48l0.35,1.19l0.4,0.29l3.88,-0.18l0.03,0.61l-6.33,2.95l-6.41,-1.4l-7.43,0.79l-3.72,-0.62l-4.4,-0.25l-0.23,-1.83l4.29,-1.11l0.28,-0.51l-1.1,-3.45l1.0,-0.25l6.58,2.28l0.47,-0.16l-0.05,-0.49l-3.41,-3.45l-3.58,-0.98l1.48,-1.55l4.34,-1.29l0.97,-2.19l-0.16,-0.48l-3.42,-2.13l-0.81,-2.26l6.2,0.22l2.24,0.58l3.91,-2.1l0.2,-0.43l-0.35,-0.32l-5.64,-0.67l-8.73,0.36l-4.26,-1.9l-2.12,-2.4l-2.78,-1.66l-0.41,-1.52l3.31,-1.03l2.93,-0.2l4.91,-0.99l3.7,-2.27l2.87,0.3l2.62,1.67l0.56,-0.14l1.82,-3.2l3.13,-0.94l4.44,-0.69l7.53,-0.26l1.48,0.67l7.19,-1.06l10.8,0.79ZM203.85,57.54l0.01,0.42l1.97,2.97l0.68,-0.02l2.24,-3.72l5.95,-1.86l4.01,4.64l-0.35,2.91l0.5,0.43l4.95,-1.36l2.32,-1.8l5.31,2.28l3.27,2.11l0.3,1.84l0.48,0.33l4.42,-0.99l2.64,2.87l5.97,1.77l2.06,1.72l2.11,3.71l-4.19,1.86l-0.01,0.73l5.9,2.83l3.94,0.94l3.78,3.95l3.46,0.25l-0.63,2.37l-4.11,4.47l-2.76,-1.56l-3.9,-3.94l-3.59,0.41l-0.33,0.34l-0.19,2.72l2.63,2.38l3.42,1.89l0.94,0.97l1.55,3.75l-0.7,2.29l-2.74,-0.92l-6.25,-3.15l-0.51,0.13l0.05,0.52l6.07,5.69l0.18,0.59l-6.09,-1.39l-5.31,-2.24l-2.63,-1.66l0.6,-0.77l-0.12,-0.6l-7.39,-4.01l-0.59,0.37l0.03,0.79l-6.73,0.6l-1.69,-1.1l1.36,-2.46l4.51,-0.07l5.15,-0.52l0.31,-0.6l-0.74,-1.3l0.78,-1.84l3.21,-4.05l-0.67,-2.35l-1.11,-1.6l-3.84,-2.1l-4.35,-1.28l0.91,-0.63l0.06,-0.61l-2.65,-2.75l-2.34,-0.36l-1.89,-1.46l-0.53,0.03l-1.24,1.23l-4.36,0.55l-9.04,-0.99l-9.26,-1.98l-1.6,-1.22l2.22,-1.77l0.13,-0.44l-0.38,-0.27l-3.22,-0.02l-0.72,-4.25l1.83,-4.04l2.42,-1.85l5.5,-1.1l-1.39,2.35ZM261.19,159.33l2.07,0.61l1.44,-0.04l-1.15,0.63l-2.94,-1.23l-0.4,-0.68l0.36,-0.37l0.61,1.07ZM256.17,238.73l-0.26,0.27l-2.83,0.05l-0.07,-0.55l1.95,-0.1l1.22,0.33ZM237.05,238.38l-1.16,0.43l-0.91,-0.55l0.05,-0.2l2.02,0.31ZM237.53,238.43l1.06,0.12l-0.05,0.01l-1.01,-0.12ZM239.25,238.45l0.79,-0.51l0.06,-0.62l-1.02,-1.0l0.02,-0.82l-0.3,-0.4l-0.93,-0.32l3.44,0.5l0.59,-0.44l1.66,0.01l1.99,0.63l0.33,0.67l1.28,0.19l0.33,0.76l1.0,0.08l0.8,0.62l-0.45,0.51l-1.13,-0.47l-1.88,-0.01l-1.27,0.59l-0.75,-0.55l-1.01,0.54l-0.79,1.4l-0.53,-0.98l-2.25,-0.38ZM221.21,227.25l1.27,1.02l2.19,-0.28l4.43,3.33l2.08,0.43l-0.1,0.38l0.36,0.5l1.75,0.1l1.48,0.84l-3.11,0.51l-4.15,-0.03l0.77,-0.67l-0.04,-0.64l-1.2,-0.74l-1.49,-0.16l-0.7,-0.61l-0.56,-1.4l-0.4,-0.25l-1.34,0.1l-2.2,-0.66l-0.88,-0.58l-3.18,-0.4l-0.27,-0.16l0.58,-0.74l-0.36,-0.29l-2.72,-0.05l-1.7,1.29l-0.91,0.03l-0.61,0.69l-1.01,0.22l1.11,-1.29l1.01,-0.52l3.69,-1.01l3.98,0.21l2.21,0.84ZM230.83,84.39l-2.37,0.18l-0.49,-1.63l0.93,-2.09l1.94,-0.51l1.62,0.99l0.02,1.52l-1.66,1.54ZM229.43,58.25l0.11,0.65l-4.87,-0.21l-2.72,0.62l-3.1,-2.57l0.08,-1.26l0.86,-0.23l5.57,0.51l4.08,2.5ZM228.38,239.28l-0.8,0.4l-2.26,-1.06l0.84,-0.23l2.14,0.3l1.17,0.56l-1.08,0.03ZM226.4,223.87l-0.48,-1.15l-0.84,-0.75l0.36,-1.11l0.95,1.95l0.01,1.06ZM225.56,216.43l-1.87,0.29l-0.04,-0.22l0.74,-0.14l1.17,0.06ZM222.0,105.02l-0.72,1.49l-0.63,-0.19l-0.48,-0.84l0.81,-0.99l0.65,0.05l0.37,0.46ZM183.74,38.32l2.9,1.7l4.79,-0.01l1.84,1.46l-0.49,1.68l0.23,0.48l2.82,1.14l1.76,1.26l7.01,0.65l4.1,-1.1l5.03,-0.43l3.93,0.35l2.48,1.77l0.46,1.7l-1.3,1.1l-3.56,1.01l-3.23,-0.59l-7.17,0.76l-5.09,0.09l-3.99,-0.6l-6.42,-1.54l-0.79,-2.51l-0.3,-2.49l-2.64,-2.5l-5.32,-0.72l-2.52,-1.4l0.68,-1.57l4.78,0.31ZM207.38,91.35l0.4,1.56l0.56,0.26l1.06,-0.52l1.32,0.96l5.42,2.57l0.2,1.68l0.46,0.35l1.68,-0.28l1.15,0.85l-1.55,0.87l-3.61,-0.88l-1.32,-1.69l-0.57,-0.06l-2.45,2.1l-3.12,1.79l-0.7,-1.87l-0.42,-0.26l-2.16,0.24l1.39,-1.39l0.32,-3.14l0.76,-3.35l1.18,0.22ZM215.49,102.6l-2.67,1.95l-1.4,-0.07l-0.3,-0.58l1.53,-1.48l2.84,0.18ZM202.7,24.12l2.53,1.59l-2.87,1.4l-4.53,4.05l-4.25,0.38l-5.03,-0.68l-2.45,-2.04l0.03,-1.62l1.82,-1.37l0.14,-0.45l-0.38,-0.27l-4.45,0.04l-2.59,-1.76l-1.41,-2.29l1.57,-2.32l1.62,-1.66l2.44,-0.39l0.25,-0.65l-0.6,-0.74l4.86,-0.25l3.24,3.11l8.16,2.3l1.9,3.61ZM187.47,59.2l-2.76,3.49l-2.38,-0.15l-1.44,-3.84l0.04,-2.2l1.19,-1.88l2.3,-1.23l5.07,0.17l4.11,1.02l-3.24,3.72l-2.88,0.89ZM186.07,48.79l-1.08,1.53l-3.34,-0.34l-2.56,-1.1l1.03,-1.75l3.25,-1.23l1.95,1.58l0.75,1.3ZM185.71,35.32l-5.3,-0.2l-0.32,-0.71l4.31,0.07l1.3,0.84ZM180.68,32.48l-3.34,1.0l-1.79,-1.1l-0.98,-1.87l-0.15,-1.73l4.1,0.53l2.67,1.7l-0.51,1.47ZM180.9,76.31l-1.1,1.08l-3.13,-1.23l-2.12,0.43l-2.71,-1.57l1.72,-1.09l1.55,-1.72l3.81,1.9l1.98,2.2ZM169.74,54.87l2.96,0.97l4.17,-0.57l0.41,0.88l-2.14,2.11l0.09,0.64l3.55,1.92l-0.4,3.72l-3.79,1.65l-2.17,-0.35l-1.72,-1.74l-6.02,-3.5l0.03,-0.85l4.68,0.54l0.4,-0.21l-0.05,-0.45l-2.48,-2.81l2.46,-1.95ZM174.45,40.74l1.37,1.73l0.07,2.44l-1.05,3.45l-3.79,0.47l-2.32,-0.69l0.05,-2.64l-0.44,-0.41l-3.68,0.35l-0.12,-3.1l2.45,0.1l3.67,-1.73l3.41,0.29l0.37,-0.26ZM170.05,31.55l0.67,1.56l-3.33,-0.49l-4.22,-1.77l-4.35,-0.16l1.4,-0.94l-0.06,-0.7l-2.81,-1.23l-0.12,-1.39l4.39,0.68l6.62,1.98l1.81,2.47ZM134.5,58.13l-1.02,1.82l0.45,0.58l5.4,-1.39l3.33,2.29l0.49,-0.03l2.6,-2.23l1.94,1.32l2.0,4.5l0.7,0.06l1.3,-2.29l-1.63,-4.46l1.69,-0.54l2.31,0.71l2.65,1.81l2.49,7.92l8.48,4.27l-0.19,1.35l-3.79,0.33l-0.26,0.67l1.4,1.49l-0.58,1.1l-4.23,-0.64l-4.43,-1.19l-3.0,0.28l-4.66,1.47l-10.52,1.04l-1.43,-2.02l-3.42,-1.2l-2.21,0.43l-2.51,-2.86l4.84,-1.05l3.6,0.19l3.27,-0.78l0.31,-0.39l-0.31,-0.39l-4.84,-1.06l-8.79,0.27l-0.85,-1.07l5.26,-1.66l0.27,-0.45l-0.4,-0.34l-3.8,0.06l-3.81,-1.06l1.81,-3.01l1.66,-1.79l6.48,-2.81l1.97,0.71ZM158.7,56.61l-1.7,2.44l-3.2,-2.75l0.37,-0.3l3.11,-0.18l1.42,0.79ZM149.61,42.73l1.01,1.89l0.5,0.18l2.14,-0.82l2.23,0.19l0.36,2.04l-1.33,2.09l-8.28,0.76l-6.35,2.15l-3.41,0.1l-0.19,-0.96l4.9,-2.08l0.23,-0.46l-0.41,-0.31l-11.25,0.59l-2.89,-0.74l3.04,-4.44l2.14,-1.32l6.81,1.69l4.58,3.06l4.37,0.39l0.36,-0.63l-3.36,-4.6l1.85,-1.53l2.18,0.51l0.77,2.26ZM144.76,34.41l-4.36,1.44l-3.0,-1.4l1.46,-1.24l3.47,-0.52l2.96,0.71l-0.52,1.01ZM145.13,29.83l-1.9,0.66l-3.67,-0.0l2.27,-1.61l3.3,0.95ZM118.92,65.79l-6.03,2.02l-1.33,-1.9l-5.38,-2.28l2.59,-5.05l2.16,-3.14l-0.02,-0.48l-1.97,-2.41l7.64,-0.7l3.6,1.02l6.3,0.27l4.42,2.95l-2.53,0.98l-6.24,3.43l-3.1,3.28l-0.11,2.01ZM129.54,35.53l-0.28,3.37l-1.72,1.62l-2.33,0.28l-4.61,2.19l-3.86,0.76l-2.64,-0.87l3.72,-3.4l5.01,-3.34l3.72,0.07l3.0,-0.67ZM111.09,152.69l-0.67,0.24l-3.85,-1.37l-0.83,-1.17l-2.12,-1.07l-0.66,-1.02l-2.4,-0.55l-0.74,-1.71l6.02,1.45l2.0,2.55l2.52,1.39l0.73,1.27ZM87.8,134.64l0.89,0.29l1.86,-0.21l-0.65,3.34l1.69,2.33l-1.31,-1.33l-0.99,-1.62l-1.17,-0.98l-0.33,-1.82ZM37.6,123.41l-2.25,1.23l-0.95,-0.69l-0.29,-1.24l3.21,-1.63l1.42,0.21l0.67,0.7l-1.8,1.42ZM31.06,234.03l0.98,0.47l0.74,0.87l-1.77,1.07l-0.44,-1.53l0.49,-0.89ZM29.34,232.07l0.18,0.05l0.08,0.05l-0.16,0.03l-0.11,-0.14ZM25.16,230.17l0.05,-0.03l0.18,0.22l-0.13,-0.01l-0.1,-0.18ZM5.89,113.26l-1.08,0.41l-2.21,-1.12l1.53,-0.4l1.62,0.28l0.14,0.83Z",name:"North America"},OC:{path:"M869.95,326.98l-1.21,0.41l-0.08,-0.23l2.97,-1.21l-0.14,0.42l-1.54,0.61ZM867.58,329.25l0.43,0.37l-0.27,0.88l-1.24,0.28l-1.04,-0.24l-0.14,-0.66l0.63,-0.58l0.92,0.26l0.7,-0.31ZM857.8,379.65l1.86,3.12l0.44,0.18l0.3,-0.38l0.03,-1.23l0.38,0.27l0.57,2.31l2.02,0.94l1.81,0.27l1.57,-1.06l0.7,0.18l-1.15,3.59l-1.98,0.11l-0.74,1.2l0.2,1.11l-2.42,3.98l-1.49,0.92l-1.04,-0.85l1.21,-2.05l-0.81,-2.01l-2.63,-1.25l0.04,-0.57l1.82,-1.19l0.43,-2.34l-0.16,-2.03l-0.95,-1.82l-0.06,-0.72l-3.11,-3.64l-0.79,-1.52l1.56,1.45l1.76,0.66l0.65,2.34ZM853.83,393.59l0.57,1.24l0.59,0.16l1.42,-0.97l0.46,0.79l0.0,1.03l-2.47,3.48l-1.26,1.2l-0.06,0.5l0.55,0.87l-1.41,0.07l-2.33,1.38l-2.03,5.02l-3.02,2.16l-2.06,-0.06l-1.71,-1.04l-2.47,-0.2l-0.27,-0.73l1.22,-2.1l3.05,-2.94l1.62,-0.59l4.02,-2.82l1.57,-1.67l1.07,-2.16l0.88,-0.7l0.48,-1.75l1.24,-0.97l0.35,0.79ZM839.04,322.8l0.22,1.14l-0.44,0.03l-0.2,-1.45l0.42,0.27ZM838.78,341.24l-0.33,0.22l-2.9,-1.75l-3.26,-3.37l1.65,0.83l4.85,4.07ZM826.69,311.6l-0.61,0.09l-0.2,-0.33l0.37,0.15l0.44,0.09ZM824.18,307.38l-0.26,-0.3l-0.31,-0.91l0.03,0.0l0.54,1.21ZM823.04,309.33l-1.66,-0.22l-0.2,-0.52l1.16,0.28l0.69,0.46ZM819.28,304.68l1.14,0.65l0.02,0.03l-0.81,-0.44l-0.35,-0.23ZM808.58,298.86l2.54,2.56l-0.13,0.26l-0.33,0.12l-0.87,-0.78l-1.22,-2.16ZM705.8,353.26l0.26,0.04l0.17,-0.47l-0.48,-1.42l0.92,1.11l0.45,0.15l0.27,-0.39l-0.1,-1.56l-1.98,-3.63l1.09,-3.31l-0.24,-1.57l0.34,-0.62l0.38,1.06l0.43,-0.19l0.99,-1.7l1.91,-0.83l1.29,-1.15l1.81,-0.91l0.96,-0.17l0.92,0.26l1.92,-0.95l1.47,-0.28l1.03,-0.8l1.43,0.04l2.78,-0.84l1.36,-1.15l0.71,-1.45l1.41,-1.26l0.3,-2.58l1.27,-1.59l0.78,1.65l0.54,0.19l1.07,-0.51l0.15,-0.6l-0.73,-1.0l0.45,-0.71l0.78,0.39l0.58,-0.3l0.28,-1.82l1.87,-2.14l1.12,-0.39l0.28,-0.58l0.62,0.17l0.53,-0.73l1.87,-0.57l1.65,1.05l1.35,1.48l3.39,0.38l0.43,-0.54l-0.46,-1.23l1.05,-1.79l1.04,-0.61l0.14,-0.55l-0.25,-0.41l0.88,-1.17l1.31,-0.77l1.3,0.27l2.1,-0.48l0.31,-0.4l-0.05,-1.3l-0.92,-0.77l1.48,0.56l1.41,1.07l2.11,0.65l0.81,-0.2l1.4,0.7l1.69,-0.66l0.8,0.19l0.64,-0.33l0.71,0.77l-1.33,1.94l-0.71,0.07l-0.35,0.51l0.24,0.86l-1.52,2.35l0.12,1.05l2.15,1.65l1.97,0.85l3.04,2.36l1.97,0.65l0.55,0.88l2.72,0.85l1.84,-1.1l2.07,-5.97l-0.42,-3.59l0.3,-1.73l0.47,-0.87l-0.31,-0.68l1.09,-3.28l0.46,-0.47l0.4,0.71l0.16,1.51l0.65,0.52l0.16,1.04l0.85,1.21l0.12,2.38l0.9,2.0l0.57,0.18l1.3,-0.78l1.69,1.7l-0.2,1.08l0.53,2.2l0.39,1.3l0.68,0.48l0.6,1.95l-0.19,1.48l0.81,1.76l6.01,3.69l-0.11,0.76l1.38,1.58l0.95,2.77l0.58,0.22l0.72,-0.41l0.8,0.9l0.61,0.01l0.46,2.41l4.81,4.71l0.66,2.02l-0.07,3.31l1.14,2.2l-0.13,2.24l-1.1,3.68l0.03,1.64l-0.47,1.89l-1.05,2.4l-1.9,1.47l-1.72,3.51l-2.38,6.09l-0.24,2.82l-1.14,0.8l-2.85,0.15l-2.31,1.19l-2.51,2.25l-3.09,-1.57l0.3,-1.15l-0.54,-0.47l-1.5,0.63l-2.01,1.94l-7.12,-2.18l-1.48,-1.63l-1.14,-3.74l-1.45,-1.26l-1.81,-0.26l0.56,-1.18l-0.61,-2.1l-0.72,-0.1l-1.14,1.82l-0.9,0.21l0.63,-0.82l0.36,-1.55l0.92,-1.31l-0.13,-2.34l-0.7,-0.22l-2.0,2.34l-1.51,0.93l-0.94,2.01l-1.35,-0.81l-0.02,-1.52l-1.57,-2.04l-1.09,-0.88l0.24,-0.33l-0.14,-0.59l-3.21,-1.69l-1.83,-0.12l-2.54,-1.35l-4.58,0.28l-6.02,1.9l-2.53,-0.13l-2.62,1.41l-2.13,0.63l-1.49,2.6l-3.49,0.31l-2.29,-0.5l-3.48,0.43l-1.6,1.47l-0.81,-0.04l-2.37,1.63l-3.26,-0.1l-3.72,-2.21l0.04,-1.05l1.19,-0.46l0.49,-0.89l0.21,-2.97l-0.28,-1.64l-1.34,-2.86l-0.38,-1.47l0.05,-1.72l-0.95,-1.7l-0.18,-0.97l-1.01,-0.99l-0.29,-1.98l-1.13,-1.75ZM801.41,293.04l0.5,0.29l0.26,0.27l-0.49,-0.35l-0.27,-0.21ZM803.17,294.58l0.59,0.5l0.08,1.06l-0.29,-0.91l-0.38,-0.65ZM796.68,298.41l0.52,0.75l1.43,-0.19l2.27,-1.81l-0.01,-1.43l1.12,0.16l-0.04,1.1l-0.7,1.28l-1.12,0.18l-0.62,0.79l-2.46,1.11l-1.17,-0.0l-3.08,-1.25l3.41,0.0l0.45,-0.68ZM789.15,303.55l2.31,1.8l1.59,2.61l1.34,0.13l-0.06,0.66l0.31,0.43l1.06,0.24l0.06,0.65l2.25,1.05l-1.22,0.13l-0.72,-0.63l-4.56,-0.65l-3.22,-2.87l-1.49,-2.34l-3.27,-1.1l-2.38,0.72l-1.59,0.86l-0.2,0.42l0.27,1.55l-1.55,0.68l-1.36,-0.4l-2.21,-0.09l-0.08,-15.41l8.39,2.93l2.95,2.4l0.6,1.64l4.02,1.49l0.31,0.68l-1.76,0.21l-0.33,0.52l0.55,1.68ZM784.92,393.44l2.65,1.02l3.23,-0.96l1.09,0.14l0.15,3.06l-0.85,1.13l-0.17,1.63l-0.87,-0.24l-1.57,1.91l-1.68,-0.18l-1.4,-2.36l-0.37,-2.04l-1.39,-2.51l0.04,-0.8l1.15,0.18Z",name:"Oceania"},AS:{path:"M781.12,166.87l1.81,0.68l1.62,-0.97l0.39,2.42l-3.35,0.75l-2.23,2.88l-3.63,-1.9l-0.56,0.2l-1.26,3.05l-2.16,0.03l-0.29,-2.51l1.08,-2.03l2.45,-0.16l0.37,-0.33l1.25,-5.94l2.47,2.71l2.03,1.12ZM773.56,187.34l-0.91,2.22l0.37,1.52l-1.14,1.75l-3.02,1.26l-4.58,0.27l-3.34,3.01l-1.25,-0.8l-0.09,-1.9l-0.46,-0.38l-4.35,0.62l-3.0,1.32l-2.85,0.05l-0.37,0.27l0.13,0.44l2.32,1.89l-1.54,4.34l-1.26,0.9l-0.79,-0.7l0.56,-2.27l-0.21,-0.45l-1.47,-0.75l-0.74,-1.4l2.12,-0.84l1.26,-1.7l2.45,-1.42l1.83,-1.91l4.78,-0.81l2.6,0.57l0.44,-0.21l2.39,-4.66l1.29,1.06l0.5,0.01l5.1,-4.02l1.69,-3.73l-0.38,-3.4l0.9,-1.61l2.14,-0.44l1.23,3.72l-0.07,2.18l-2.23,2.84l-0.04,3.16ZM756.47,287.89l0.69,4.01l2.79,1.78l0.51,-0.1l2.04,-2.59l2.71,-1.43l2.05,-0.0l3.9,1.73l2.46,0.45l0.08,15.12l-1.75,-1.54l-2.54,-0.51l-0.88,0.71l-2.32,0.06l0.69,-1.33l1.45,-0.64l0.23,-0.46l-0.65,-2.74l-1.24,-2.21l-5.04,-2.29l-2.09,-0.23l-3.68,-2.27l-0.55,0.13l-0.65,1.07l-0.52,0.12l-0.55,-1.89l-1.21,-0.78l1.84,-0.62l1.72,0.05l0.39,-0.52l-0.21,-0.66l-0.38,-0.28l-3.45,-0.0l-1.13,-1.48l-2.1,-0.43l-0.52,-0.6l2.69,-0.48l1.28,-0.78l3.66,0.94l0.3,0.71ZM507.76,203.05l2.4,-6.23l1.29,-2.09l-0.18,-2.26l0.53,-1.48l-0.74,-1.04l0.79,-1.3l-0.41,-0.2l-1.43,0.23l-2.0,-0.63l-2.02,1.65l-3.51,0.3l-2.13,-1.53l-2.7,-0.1l-0.86,1.24l-1.38,0.27l-2.29,-1.44l-2.71,-0.01l-1.37,-2.65l-1.68,-1.52l1.07,-1.99l-0.09,-0.49l-1.27,-1.12l2.37,-2.41l3.7,-0.11l1.28,-2.24l4.49,0.37l3.21,-1.97l2.81,-0.82l3.99,-0.06l4.29,2.07l3.64,1.17l3.05,-0.44l2.34,0.22l2.96,-1.56l0.57,-1.75l-0.76,-2.26l-1.45,-1.12l-1.43,-0.39l-0.41,-0.42l5.29,0.89l4.07,2.01l1.41,-0.44l2.07,0.56l0.86,1.26l2.25,0.81l1.84,1.84l1.53,0.01l1.52,-1.61l2.3,3.34l1.43,0.43l-1.26,0.15l-0.35,0.32l-0.8,3.14l-0.99,0.96l0.09,1.56l0.79,2.14l2.56,0.83l1.87,1.48l3.69,0.49l3.91,-0.76l0.54,-0.93l-0.44,-2.2l0.36,-2.98l-0.22,-0.4l-1.65,-0.84l0.54,-1.69l-0.34,-0.52l-1.22,-0.13l0.36,-1.64l2.22,0.59l2.2,-0.95l0.12,-0.65l-1.77,-1.74l-0.69,-1.64l-0.51,-0.22l-2.02,0.77l-0.33,0.96l-0.29,-1.01l0.56,-1.48l-0.48,-1.05l-2.96,-1.19l-1.06,-2.58l-1.37,-0.87l-0.03,-0.3l1.95,0.23l0.45,-0.38l0.08,-1.96l1.75,-0.41l2.1,0.45l0.48,-0.33l0.45,-3.04l-0.45,-2.09l-0.41,-0.31l-2.42,0.15l-2.36,-0.73l-2.87,1.37l-2.17,0.61l-0.85,-0.34l0.13,-1.61l-1.6,-2.12l-2.02,-0.08l-1.78,-1.82l1.29,-2.18l-0.57,-0.95l1.62,-2.91l2.21,1.63l0.63,-0.27l0.29,-2.22l4.92,-3.43l3.71,-0.08l8.4,3.6l2.92,-1.36l3.77,-0.06l3.11,1.66l0.51,-0.11l0.6,-0.81l3.31,0.13l0.39,-0.25l0.63,-1.57l-0.17,-0.5l-3.5,-1.98l1.87,-1.27l-0.13,-1.03l1.98,-0.72l0.18,-0.62l-1.59,-2.06l0.81,-0.82l9.23,-1.18l1.33,-0.88l6.18,-1.26l2.26,-1.42l4.08,0.68l0.73,3.33l0.51,0.3l2.48,-0.8l2.79,1.02l-0.17,1.56l0.43,0.44l2.55,-0.24l4.89,-2.53l0.03,0.32l3.15,2.61l5.56,8.47l0.65,0.02l1.12,-1.46l3.15,1.74l3.76,-0.78l1.15,0.49l1.14,1.8l1.84,0.76l0.99,1.29l3.35,-0.25l1.19,1.78l0.44,0.16l3.72,-0.87l4.75,-2.8l3.62,-1.47l2.18,0.97l2.46,0.05l1.81,1.53l2.46,0.12l3.95,0.71l2.43,-2.28l0.08,-0.48l-0.9,-1.72l2.24,-2.98l2.62,1.27l4.94,1.17l0.68,2.53l3.56,1.38l5.67,-1.0l2.37,0.41l2.34,1.5l1.79,1.75l2.29,-0.03l3.32,0.5l2.27,-0.79l3.41,-0.59l3.53,-2.21l1.25,0.29l1.53,1.13l2.89,-0.26l3.27,1.17l3.53,-2.06l0.18,-1.68l2.16,-3.35l1.34,-1.03l0.13,-2.18l-1.07,-0.85l1.54,-1.26l2.98,-0.59l3.23,-0.09l3.64,0.99l2.04,1.16l3.29,6.71l0.92,3.19l4.57,1.3l2.8,2.17l0.98,2.9l0.38,0.27l3.8,0.0l2.32,-1.28l3.29,-0.75l-0.96,2.09l-1.02,1.28l-0.85,3.4l-1.52,2.73l-2.76,-0.5l-2.4,1.13l-0.21,0.45l0.64,2.57l-0.32,3.2l-0.94,0.06l-0.37,0.4l0.02,1.51l-0.47,0.08l-1.88,2.1l0.01,2.14l-1.06,0.54l-1.41,1.4l-1.7,0.52l-1.25,1.09l-0.14,1.98l2.28,1.66l2.11,3.34l0.58,1.76l0.02,3.12l-0.8,1.32l-2.21,0.55l-1.93,1.13l-1.8,0.19l-0.2,-1.1l0.43,-2.28l-0.95,-2.56l1.43,-0.37l0.23,-0.62l-1.88,-2.61l-1.22,-0.55l-0.88,0.62l-1.21,-0.88l1.12,-1.65l-0.16,-0.38l0.57,-1.43l-0.16,-0.76l-3.12,-1.37l-3.5,0.86l-1.93,1.4l-1.15,0.34l0.33,-0.7l-0.41,-0.89l1.79,-1.79l0.02,-0.54l-1.32,-1.56l-0.48,-0.1l-2.24,1.09l-2.83,2.06l-1.51,1.83l-2.28,0.13l-1.55,1.49l-0.04,0.5l1.32,1.97l2.0,0.58l0.31,1.35l1.98,0.84l3.0,-1.96l2.0,1.02l1.49,0.11l0.22,0.83l-3.37,0.86l-1.12,1.48l-2.5,1.52l-1.29,1.99l0.14,0.56l2.57,1.48l0.97,2.7l3.17,4.63l-0.03,1.66l-1.35,0.65l-0.2,0.51l0.6,1.47l1.4,0.91l-0.33,1.93l-0.56,1.89l-1.43,0.38l-3.85,6.44l-2.27,3.11l-6.78,4.57l-2.73,0.29l-1.45,1.04l-0.62,-0.61l-0.55,-0.01l-1.36,1.25l-3.39,1.27l-2.61,0.4l-1.1,2.79l-0.81,0.09l-0.49,-1.42l0.5,-0.85l-0.25,-0.59l-3.59,-0.83l-1.27,0.47l-3.34,2.24l-2.17,2.54l-0.57,2.29l4.26,6.1l2.32,1.65l1.43,1.94l1.11,4.59l-0.32,4.24l-1.93,1.54l-2.84,1.61l-2.11,2.15l-2.73,2.06l-0.59,-1.05l0.63,-1.53l-0.13,-0.47l-1.86,-1.44l-2.12,-0.42l-2.32,-3.93l-2.25,-1.17l-1.84,-0.01l0.28,-1.52l-0.4,-0.47l-2.21,0.01l-0.4,0.37l-0.19,2.74l-2.15,5.89l0.15,2.0l0.38,0.36l1.38,0.07l0.9,2.04l0.44,2.14l1.5,1.64l1.61,0.38l3.23,2.94l0.98,1.56l-0.12,2.81l0.41,2.29l0.95,0.9l0.88,2.44l-1.27,0.12l-5.1,-3.67l-0.34,-1.29l-1.37,-1.59l-0.33,-1.97l-0.88,-1.4l0.25,-1.68l-0.59,-1.31l-1.0,-1.0l-0.48,-1.3l-2.56,-2.63l-0.73,0.41l0.96,-3.92l-0.21,-1.94l0.71,-2.19l-0.78,-1.4l0.19,-2.65l-1.05,-1.53l-1.24,-6.17l-1.12,-2.26l-0.6,-0.13l-4.34,3.02l-2.39,-0.65l0.77,-2.84l-0.57,-2.74l-1.86,-2.83l0.25,-0.75l-0.29,-0.51l-1.33,-0.3l-1.66,-1.99l-0.66,-1.26l-0.64,-2.62l-1.4,-1.79l-2.31,-0.11l-0.41,0.48l0.2,0.94l-0.53,0.99l-0.72,-0.36l-0.68,0.35l-1.45,-0.43l-0.47,0.25l-0.26,0.69l-4.58,0.52l-0.33,0.42l0.13,1.8l-1.17,1.36l-3.65,1.81l-2.79,3.03l-4.32,3.28l-0.18,1.27l-4.65,1.79l-0.77,2.16l0.64,5.3l-1.06,2.49l-0.01,3.94l-1.24,0.28l-1.14,1.93l0.39,0.84l-1.68,0.53l-1.04,1.83l-0.65,0.47l-2.06,-2.05l-2.1,-6.02l-2.2,-3.64l-1.05,-4.75l-2.29,-3.57l-1.76,-8.2l0.01,-3.11l-0.49,-2.53l-0.55,-0.29l-3.53,1.52l-1.53,-0.27l-2.86,-2.77l0.85,-0.67l0.08,-0.55l-0.74,-1.03l-3.02,-2.33l-1.77,-0.67l-0.76,-1.87l-2.27,-2.15l-12.15,0.92l-9.98,-1.73l-0.99,-3.05l-1.43,-0.73l-2.17,0.46l-2.47,1.26l-2.83,-0.82l-2.46,-2.02l-2.41,-0.8l-3.42,-6.06l-0.48,-0.2l-1.18,0.39l-1.44,-0.82l-0.5,0.08l-0.8,0.92l-1.28,-0.12l-0.4,0.56l0.46,1.06l-0.17,0.76l1.79,4.4l1.29,0.76l0.51,0.99l1.56,1.03l-0.1,1.9l1.78,3.24l0.47,0.18l0.28,-0.42l-0.16,-1.83l0.84,-1.29l0.47,0.52l0.04,1.34l-0.5,1.8l0.98,1.49l0.48,0.34l1.91,-0.41l3.53,0.15l5.66,-5.51l-0.39,0.93l0.34,2.11l1.18,1.96l1.66,1.15l3.15,0.78l1.73,2.29l0.81,0.57l-1.22,2.15l-1.1,0.92l-0.81,1.55l-0.86,-0.1l-0.88,0.76l-0.48,1.46l0.25,1.77l-1.16,0.05l-1.56,0.97l-0.76,1.74l-1.39,-0.02l-1.21,0.72l-0.17,1.15l-0.89,0.52l-1.49,-0.18l-1.61,0.84l-2.99,0.85l-0.78,2.12l-6.23,2.16l-2.29,1.8l-1.93,0.05l-1.41,1.02l-4.24,0.74l-1.72,1.49l-3.28,0.19l-0.52,-1.18l0.02,-1.51l-1.34,-3.29l0.26,-0.42l-0.07,-2.81l-0.32,-1.1l-0.77,-0.85l-0.17,-0.91l-1.39,-1.13l-1.27,-2.06l-0.78,-2.22l-1.73,-1.79l-1.14,-0.48l-1.54,-2.31l-0.21,-3.41l-1.44,-2.93l-1.27,-1.16l-1.33,-0.57l-1.31,-3.37l-0.77,-0.67l-0.97,-1.97l-2.8,-4.03l-1.06,-0.17l0.68,-3.21l-1.67,-4.96l0.59,-0.74l-0.03,-0.41ZM757.78,196.26l0.19,0.56l-1.01,1.21l-1.16,-0.68l-1.28,0.65l-0.69,1.45l-1.02,-0.5l0.01,-0.93l1.14,-1.38l1.57,0.14l0.85,-0.98l1.4,0.46ZM757.91,300.34l-0.62,0.82l-0.1,-0.8l0.59,-1.12l0.13,1.1ZM747.38,292.98l0.34,0.72l-1.22,-0.57l-4.68,-0.1l0.27,-0.62l2.78,-0.09l2.52,0.67ZM741.05,285.25l-0.67,-2.88l0.64,-2.01l0.41,0.86l1.21,0.18l0.16,0.7l-0.1,1.68l-0.84,-0.16l-0.46,0.3l-0.34,1.34ZM739.05,293.5l-0.5,0.44l-1.34,-0.36l-0.17,-0.37l1.73,-0.08l0.27,0.36ZM730.55,310.47l1.11,-1.93l2.37,-0.96l0.42,-0.63l4.5,-0.86l-4.9,2.0l-1.72,1.91l-1.77,0.46ZM737.01,263.84l0.39,2.97l-0.44,1.18l-0.55,-1.53l-0.67,-0.14l-1.17,1.28l0.65,2.09l-0.42,0.69l-2.48,-1.23l-0.57,-1.49l0.65,-1.03l-0.1,-0.54l-1.59,-1.19l-0.56,0.08l-0.65,0.87l-1.23,0.0l-1.58,0.97l0.83,-1.8l2.56,-1.42l0.65,0.84l0.45,0.13l1.9,-0.69l0.56,-1.11l1.5,-0.06l0.38,-0.43l-0.09,-1.19l1.21,0.71l0.36,2.02ZM733.59,256.58l0.05,0.75l0.08,0.26l-0.8,-0.42l-0.18,-0.71l0.85,0.12ZM734.08,256.1l-0.12,-1.12l-1.0,-1.27l1.36,0.03l0.53,0.73l0.51,2.04l-1.27,-0.4ZM733.76,257.68l0.38,0.98l-0.32,0.15l-0.07,-1.13ZM721.45,284.51l-0.19,1.97l2.24,2.23l0.54,0.02l1.27,-1.07l2.75,-0.5l-0.9,1.21l-2.11,0.93l-0.16,0.6l2.22,3.01l-0.3,1.07l1.36,1.74l-2.26,0.85l-0.28,-0.31l0.12,-1.19l-1.64,-1.34l0.17,-2.23l-0.56,-0.39l-1.67,0.76l-0.23,0.39l0.3,6.17l-1.1,0.25l-0.69,-0.47l0.64,-2.21l-0.39,-2.42l-0.39,-0.34l-0.8,-0.01l-0.58,-1.29l0.98,-1.6l0.35,-1.96l1.32,-3.87ZM728.59,296.27l0.38,0.49l-0.02,1.28l-0.88,0.49l-0.53,-0.47l1.04,-1.79ZM729.04,286.98l0.27,-0.05l-0.02,0.13l-0.24,-0.08ZM721.68,284.05l0.16,-0.32l1.89,-1.65l1.83,0.68l3.16,0.35l2.94,-0.1l2.39,-1.66l-1.73,2.13l-1.66,0.43l-2.41,-0.48l-4.17,0.13l-2.39,0.51ZM724.65,238.43l1.46,0.7l0.72,-0.31l-0.32,1.17l0.79,1.71l-0.57,1.84l-1.53,1.04l-0.39,2.25l0.56,2.04l1.63,0.57l1.16,-0.27l2.71,1.23l-0.19,1.08l0.76,0.84l-0.08,0.36l-1.4,-0.9l-0.88,-1.27l-0.66,0.0l-0.38,0.55l-1.6,-1.31l-2.15,0.36l-0.87,-0.39l0.07,-0.61l0.66,-0.55l-0.01,-0.62l-0.75,-0.59l-0.72,0.44l-0.74,-0.87l-0.39,-2.49l0.32,0.27l0.66,-0.28l0.26,-3.97l0.7,-2.02l1.14,0.0ZM731.03,258.87l-0.88,0.85l-1.19,1.94l-1.05,-1.19l0.93,-1.1l0.32,-1.47l0.52,-0.06l-0.27,1.15l0.22,0.45l0.49,-0.12l1.0,-1.32l-0.08,0.85ZM726.83,255.78l0.83,0.38l1.17,-0.0l-0.02,0.48l-2.0,1.4l0.03,-2.26ZM728.12,305.88l-0.1,0.38l-3.46,0.66l-2.91,-0.27l-0.0,-0.25l1.54,-0.41l1.66,0.73l1.67,-0.19l1.61,-0.65ZM724.01,226.68l-0.74,1.48l-0.9,-1.52l-0.25,-1.74l1.38,-2.44l1.73,-1.74l0.64,0.44l-1.85,5.52ZM724.81,252.09l-0.38,1.27l-1.42,-1.95l1.2,0.05l0.6,0.63ZM722.9,310.24l-0.64,0.03l-2.26,-1.2l1.11,-0.24l1.78,1.41ZM716.55,261.82l1.1,-0.95l0.03,-0.03l-0.28,0.36l-0.85,0.61ZM719.22,259.06l0.04,-0.06l0.8,-1.53l0.16,0.75l-1.0,0.84ZM711.66,293.84l-0.38,-0.16l-2.54,1.01l-1.12,-1.44l-1.69,-0.13l-1.16,-0.75l-3.04,0.77l-1.1,-1.15l-3.31,-0.11l-0.35,-3.05l-1.35,-0.95l-1.11,-1.98l-0.33,-2.06l0.27,-2.14l1.21,-1.35l1.83,0.76l1.93,-0.47l0.75,-2.22l4.02,-1.03l3.03,-3.57l5.02,-4.03l1.21,-1.86l0.63,-0.01l1.07,1.05l0.34,1.28l3.44,1.35l-0.06,0.35l-1.37,0.1l-0.35,0.54l0.32,0.88l-1.68,0.85l-1.42,2.26l0.02,0.46l1.7,2.2l-0.23,1.39l2.07,1.71l-2.33,0.42l-0.88,1.9l0.1,2.05l-2.4,1.9l-0.06,2.45l-0.7,2.79ZM716.26,305.77l0.88,0.51l1.28,-0.17l0.2,0.35l-4.65,0.73l0.39,-0.67l1.15,-0.02l0.75,-0.73ZM692.58,302.03l0.35,0.26l4.8,0.25l0.78,-0.97l4.17,1.09l1.13,1.68l3.69,0.45l2.13,1.04l-1.8,0.6l-2.77,-0.99l-4.8,-0.12l-5.24,-1.41l-1.84,-0.25l-1.11,0.3l-4.26,-0.97l-0.7,-1.14l-1.59,-0.13l1.18,-1.65l2.74,0.13l2.87,1.13l0.26,0.68ZM696.92,237.31l-1.87,1.08l-1.63,-0.64l-0.06,-1.79l1.03,-0.98l2.58,-0.69l1.16,0.05l0.3,0.54l-0.98,1.06l-0.53,1.37ZM685.53,299.17l-2.22,0.04l-2.06,-2.03l-3.15,-2.01l-2.93,-3.51l-3.11,-5.33l-2.2,-2.12l-1.64,-4.06l-2.32,-1.69l-1.27,-2.07l-1.96,-1.5l-2.51,-2.65l-0.11,-0.66l4.81,0.53l2.15,2.38l3.31,2.74l2.35,2.66l2.7,0.17l1.95,1.59l1.54,2.17l1.59,0.95l-0.84,1.71l0.15,0.52l1.44,0.87l0.79,0.1l0.4,1.58l0.87,1.4l1.96,0.39l1.0,1.31l-0.6,3.01l-0.09,3.5ZM624.16,268.99l-1.82,0.48l-0.99,-1.67l-0.42,-3.46l0.95,-3.43l1.21,0.98l2.26,4.19l-0.34,2.33l-0.85,0.58ZM505.52,192.81l0.09,0.58l-2.1,0.94l-0.92,-0.28l-0.24,-0.46l0.77,-0.07l0.57,-0.68l1.82,-0.04ZM488.79,176.72l-1.72,1.31l-0.5,-0.88l1.37,-2.57l-0.7,-0.85l1.7,-0.63l1.8,0.34l0.46,1.17l1.76,0.78l-2.87,0.32l-1.3,1.01Z",name:"Asia"},EU:{path:"M402.36,187.15l-1.16,0.7l-1.13,-0.35l-0.91,0.17l0.28,-1.78l-0.24,-1.78l-1.25,-0.56l-0.45,-0.84l0.17,-1.66l1.01,-1.18l0.7,-3.05l-0.66,-3.34l0.12,-2.11l-0.83,-1.23l3.03,-1.88l2.99,0.53l3.32,-0.02l2.73,0.52l6.42,-0.23l1.37,-2.03l0.39,-6.45l-2.58,-3.3l-1.9,-1.66l-3.72,-1.23l-0.19,-1.72l2.81,-0.61l4.12,0.81l0.47,-0.48l-0.6,-2.77l1.94,0.95l5.83,-2.54l0.92,-2.74l3.99,-1.26l1.4,-0.97l2.26,-4.97l3.2,-1.33l1.99,0.09l0.73,-0.74l1.66,-0.15l0.33,0.54l0.62,0.07l1.7,-1.69l0.08,-0.45l-0.54,-1.22l-0.16,-2.06l-0.97,-1.85l-0.07,-3.43l0.96,-1.73l2.02,-0.2l1.09,-1.07l1.33,-0.67l-0.05,1.06l-0.73,1.41l0.3,1.0l1.2,0.64l-0.26,0.57l-0.88,-0.07l-1.85,2.92l0.65,1.63l0.04,1.27l0.28,0.37l2.25,0.71l-0.02,0.92l0.5,0.4l2.55,-0.65l1.34,-0.87l4.18,2.34l1.69,-0.99l6.91,-2.71l2.14,0.5l0.52,0.91l2.41,0.04l0.38,-0.26l0.5,-1.34l3.27,-1.07l0.27,-0.45l-0.52,-2.91l0.08,-2.53l1.13,-2.06l1.95,-1.02l2.12,2.58l2.01,-0.07l0.38,-0.33l0.77,-4.92l-0.58,-0.41l-0.69,0.34l-1.26,-1.03l-0.17,-1.63l2.83,-0.92l3.05,-0.52l2.64,0.6l2.69,-0.1l3.06,-2.14l-0.01,-0.65l-2.87,-1.86l-4.64,0.32l-4.38,1.37l-3.8,0.74l-1.44,-1.96l-2.17,-1.11l0.5,-3.66l-1.16,-3.33l1.09,-2.08l2.21,-2.42l5.67,-4.32l1.64,-0.83l0.21,-0.42l-0.46,-2.02l-3.78,-1.99l-4.51,1.3l-2.43,2.86l0.26,2.57l-8.77,6.64l-1.78,5.79l1.78,2.68l2.22,1.96l-2.07,3.77l-2.72,1.13l-0.95,6.04l-1.29,3.01l-2.74,-0.31l-0.4,0.22l-1.31,2.59l-2.34,0.13l-0.75,-3.09l-2.08,-4.03l-1.9,-5.12l-1.73,-2.37l-0.58,-0.07l-4.87,4.19l-3.1,0.79l-3.16,-1.7l-0.85,-3.77l-0.77,-8.55l2.14,-2.31l6.55,-3.27l5.02,-4.17l10.63,-13.84l10.98,-8.7l5.35,-1.91l4.34,0.12l3.69,-3.64l4.49,0.19l4.37,-0.89l6.8,2.89l-2.29,0.86l-0.15,0.65l2.74,2.81l0.44,0.09l2.42,-1.45l4.06,2.61l6.79,1.04l9.34,4.85l1.78,1.88l0.14,2.46l-2.55,2.02l-3.9,1.06l-11.07,-3.14l-2.06,0.53l-0.13,0.7l3.94,2.94l0.31,5.86l0.26,0.36l5.14,2.24l0.58,-0.29l0.32,-1.94l-1.35,-1.78l1.13,-1.09l6.13,2.42l2.11,-0.98l0.18,-0.56l-1.51,-2.67l5.41,-3.76l2.07,0.22l2.26,1.41l0.57,-0.16l1.46,-2.87l-0.05,-0.44l-1.92,-2.32l1.12,-2.32l-1.32,-2.27l5.87,1.16l1.04,1.75l-2.59,0.43l-0.33,0.4l0.02,2.36l2.46,1.83l3.87,-0.91l0.86,-2.8l13.69,-5.65l0.99,0.11l-1.92,2.06l0.23,0.67l3.11,0.45l2.0,-1.48l4.56,-0.12l3.64,-1.73l2.65,2.44l0.56,-0.01l2.85,-2.88l-0.01,-0.57l-2.35,-2.29l0.9,-1.01l7.14,1.3l3.41,1.36l9.05,4.97l0.51,-0.11l1.67,-2.27l-0.05,-0.53l-2.43,-2.21l-0.06,-0.78l-0.34,-0.36l-2.52,-0.36l0.64,-1.93l-1.32,-3.46l-0.06,-1.21l4.48,-4.06l1.69,-4.29l1.6,-0.81l6.23,1.18l0.44,2.21l-2.29,3.64l0.06,0.5l1.47,1.39l0.76,3.0l-0.56,6.03l2.69,2.82l-0.96,2.57l-4.86,5.95l0.23,0.64l2.86,0.61l0.42,-0.17l0.93,-1.4l2.64,-1.03l0.87,-2.24l2.09,-1.96l0.07,-0.5l-1.36,-2.28l1.09,-2.69l-0.32,-0.55l-2.47,-0.33l-0.5,-2.06l1.94,-4.38l-0.06,-0.42l-2.96,-3.4l4.12,-2.88l0.16,-0.4l-0.51,-2.93l0.54,-0.05l1.13,2.25l-0.96,4.35l0.27,0.47l2.68,0.84l0.5,-0.51l-1.02,-2.99l3.79,-1.66l5.01,-0.24l4.53,2.61l0.48,-0.06l0.07,-0.48l-2.18,-3.82l-0.23,-4.67l3.98,-0.9l5.97,0.21l5.49,-0.64l0.27,-0.65l-1.83,-2.31l2.56,-2.9l2.87,-0.17l4.8,-2.47l6.54,-0.67l1.03,-1.42l6.25,-0.45l2.32,1.11l5.53,-2.7l4.5,0.08l0.39,-0.28l0.66,-2.15l2.26,-2.12l5.69,-2.11l3.21,1.29l-2.46,0.94l-0.25,0.42l0.34,0.35l5.41,0.77l0.61,2.33l0.58,0.25l2.2,-1.22l7.13,0.07l5.51,2.47l1.79,1.72l-0.53,2.24l-9.16,4.15l-1.97,1.52l0.16,0.71l6.77,1.91l2.16,-0.78l1.13,2.74l0.67,0.11l1.01,-1.15l3.81,-0.73l7.7,0.77l0.54,1.99l0.36,0.29l10.47,0.71l0.43,-0.38l0.13,-3.23l4.87,0.78l3.95,-0.02l3.83,2.4l1.03,2.71l-1.35,1.79l0.02,0.5l3.15,3.64l4.07,1.96l0.53,-0.18l2.23,-4.47l3.95,1.93l4.16,-1.21l4.73,1.39l2.05,-1.26l3.94,0.62l0.43,-0.55l-1.68,-4.02l2.89,-1.8l22.31,3.03l2.16,2.75l6.55,3.51l10.29,-0.81l4.82,0.73l1.85,1.66l-0.29,3.08l0.25,0.41l3.08,1.26l3.56,-0.88l4.35,-0.11l4.8,0.87l4.57,-0.47l4.23,3.79l0.43,0.07l3.1,-1.4l0.16,-0.6l-1.88,-2.62l0.85,-1.52l7.71,1.21l5.22,-0.26l7.09,2.09l9.59,5.22l6.35,4.11l-0.2,2.38l1.88,1.41l0.6,-0.42l-0.48,-2.53l6.15,0.57l4.4,3.51l-1.97,1.43l-4.0,0.41l-0.36,0.39l-0.06,3.79l-0.74,0.62l-2.07,-0.11l-1.91,-1.39l-3.14,-1.11l-0.78,-1.85l-2.72,-0.68l-2.63,0.49l-1.04,-1.1l0.46,-1.31l-0.5,-0.51l-3.0,0.98l-0.22,0.58l0.99,1.7l-1.21,1.48l-3.04,1.68l-3.12,-0.28l-0.4,0.23l0.09,0.46l2.2,2.09l1.46,3.2l1.15,1.1l0.24,1.33l-0.42,0.67l-4.63,-0.77l-6.96,2.9l-2.19,0.44l-7.6,5.06l-0.84,1.45l-3.61,-2.37l-6.24,2.82l-0.94,-1.15l-0.53,-0.08l-2.28,1.52l-3.2,-0.49l-0.44,0.27l-0.78,2.37l-3.05,3.78l0.09,1.47l0.29,0.36l2.54,0.72l-0.29,4.53l-1.97,0.11l-0.35,0.26l-1.07,2.94l0.8,1.45l-3.91,1.58l-1.05,3.95l-3.48,0.77l-0.3,0.3l-0.72,3.29l-3.09,2.65l-0.7,-1.74l-2.44,-12.44l1.16,-4.71l2.04,-2.06l0.22,-1.64l3.8,-0.86l4.46,-4.61l4.28,-3.81l4.48,-3.01l2.17,-5.63l-0.42,-0.54l-3.04,0.33l-1.77,3.31l-5.86,3.86l-1.86,-4.25l-0.45,-0.23l-6.46,1.3l-6.47,6.44l-0.01,0.55l1.58,1.74l-8.24,1.17l0.15,-2.2l-0.34,-0.42l-3.89,-0.56l-3.25,1.81l-7.62,-0.62l-8.45,1.19l-17.71,15.41l0.22,0.7l3.74,0.41l1.36,2.17l2.43,0.76l1.88,-1.68l2.4,0.2l3.4,3.54l0.08,2.6l-1.95,3.42l-0.21,3.9l-1.1,5.06l-3.71,4.54l-0.87,2.21l-8.29,8.89l-3.19,1.7l-1.32,0.03l-1.45,-1.36l-0.49,-0.04l-2.27,1.5l0.41,-3.65l-0.59,-2.47l1.75,-0.89l2.91,0.53l0.42,-0.2l1.68,-3.03l0.87,-3.46l0.97,-1.18l1.32,-2.88l-0.45,-0.56l-4.14,0.95l-2.19,1.25l-3.41,-0.0l-1.06,-2.93l-2.97,-2.3l-4.28,-1.06l-1.75,-5.07l-2.66,-5.01l-2.29,-1.29l-3.75,-1.01l-3.44,0.08l-3.18,0.62l-2.24,1.77l0.05,0.66l1.18,0.69l0.02,1.43l-1.33,1.05l-2.26,3.51l-0.04,1.43l-3.16,1.84l-2.82,-1.16l-3.01,0.23l-1.35,-1.07l-1.5,-0.35l-3.9,2.31l-3.22,0.52l-2.27,0.79l-3.05,-0.51l-2.21,0.03l-1.48,-1.6l-2.6,-1.63l-2.63,-0.43l-5.46,1.01l-3.23,-1.25l-0.72,-2.57l-5.2,-1.24l-2.75,-1.36l-0.5,0.12l-2.59,3.45l0.84,2.1l-2.06,1.93l-3.41,-0.77l-2.42,-0.12l-1.83,-1.54l-2.53,-0.05l-2.42,-0.98l-3.86,1.57l-4.72,2.78l-3.3,0.75l-1.55,-1.92l-3.0,0.41l-1.11,-1.33l-1.62,-0.59l-1.31,-1.94l-1.38,-0.6l-3.7,0.79l-3.31,-1.83l-0.51,0.11l-0.99,1.29l-5.29,-8.05l-2.96,-2.48l0.65,-0.77l0.01,-0.51l-0.5,-0.11l-6.2,3.21l-1.84,0.15l0.15,-1.39l-0.26,-0.42l-3.22,-1.17l-2.46,0.7l-0.69,-3.16l-0.32,-0.31l-4.5,-0.75l-2.47,1.47l-6.19,1.27l-1.29,0.86l-9.51,1.3l-1.15,1.17l-0.03,0.53l1.47,1.9l-1.89,0.69l-0.22,0.56l0.31,0.6l-2.11,1.44l0.03,0.68l3.75,2.12l-0.39,0.98l-3.23,-0.13l-0.86,0.86l-3.09,-1.59l-3.97,0.07l-2.66,1.35l-8.32,-3.56l-4.07,0.06l-5.39,3.68l-0.39,2.0l-2.03,-1.5l-0.59,0.13l-2.0,3.59l0.57,0.93l-1.28,2.16l0.06,0.48l2.13,2.17l1.95,0.04l1.37,1.82l-0.23,1.46l0.25,0.43l0.83,0.33l-0.8,1.31l-2.49,0.62l-2.49,3.2l0.0,0.49l2.17,2.78l-0.15,2.18l2.5,3.24l-1.58,1.59l-0.7,-0.13l-1.63,-1.72l-2.29,-0.84l-0.94,-1.31l-2.34,-0.63l-1.48,0.4l-0.43,-0.47l-3.51,-1.48l-5.76,-1.01l-0.45,0.19l-2.89,-2.34l-2.9,-1.2l-1.53,-1.29l1.29,-0.43l2.08,-2.61l-0.05,-0.55l-0.89,-0.79l3.05,-1.06l0.2,-1.11l-0.49,-0.35l-4.21,0.76l-1.74,1.03l-2.41,0.21l-2.16,1.17l-0.21,0.38l0.34,2.26l1.46,0.81l1.89,-0.14l-0.14,0.31l-2.65,0.53l-3.23,1.69l-0.87,-0.39l0.42,-1.1l-0.25,-0.52l-2.21,-0.73l2.35,-1.06l0.12,-0.65l-0.73,-0.72l-3.82,-0.84l-0.13,-0.89l-0.46,-0.34l-2.32,0.39l-3.11,4.17l-0.05,0.83l-0.83,0.45l-0.59,-0.22l-0.54,0.3l-0.68,3.58l-1.3,1.31l-0.91,2.17l0.48,1.34l-1.6,-0.24l-2.55,0.95l-0.08,0.71l0.94,0.61l-0.59,1.43l-0.37,0.21l-2.84,-0.35l-3.03,0.77l-0.18,0.68l1.28,1.23l-1.75,0.23l-1.2,-1.39l-0.63,0.03l-0.47,0.65l0.5,2.12l1.03,1.19l-0.56,0.38l-0.05,0.62l2.52,2.12l0.02,0.87l-1.78,-0.59l-0.48,0.56l0.5,1.0l-1.07,0.2l-0.3,0.53l0.75,2.01l-0.98,0.02l-1.84,-1.12l-1.37,-4.2l-2.21,-2.95l-0.79,-1.85l-1.25,-0.89l-0.18,-1.2l0.45,-3.22l-1.75,-1.77l-3.42,-1.71l-1.51,-1.12l-2.21,-0.87l-1.67,-1.78l0.13,-0.63l-1.05,-1.19l-0.32,-1.27l-1.61,-0.49l-0.46,0.18l-0.46,0.8l-0.26,-1.13l0.66,-0.63l-0.31,-0.34l-1.99,-0.45l-2.32,1.14l-0.21,0.39l0.13,1.45l-0.25,1.12l0.82,1.57l2.39,1.63l1.31,2.54l2.79,2.43l2.05,0.08l0.21,0.23l-0.39,0.33l0.09,0.67l4.05,1.97l2.17,1.76l-0.16,0.36l-1.17,-1.08l-2.18,-0.49l-0.44,0.2l-1.05,1.91l0.14,0.54l1.57,0.95l-0.19,0.98l-1.06,0.33l-1.25,2.34l-0.37,0.08l0.0,-0.33l1.0,-2.45l-1.73,-3.17l-1.12,-0.51l-0.67,-1.15l-1.73,-0.69l-1.01,-1.12l-2.01,-0.31l-1.86,-1.28l-3.88,-3.59l-1.03,-3.19l-3.53,-1.36l-1.3,0.51l-1.36,1.34l-1.08,0.27l-2.13,1.62l-4.77,-0.8l-3.82,1.0l-0.58,2.15l0.11,1.64l-2.14,1.8l-3.11,0.61l-0.31,0.31l-0.2,0.89l-1.54,1.69l-0.97,2.4l0.84,1.74l-1.32,1.27l-0.48,1.68l-1.88,0.65l-1.66,2.07l-5.36,-0.01l-1.79,1.08l-0.89,0.98l-0.88,-0.17l-0.79,-0.82l-0.97,-1.82l-2.34,-0.45ZM749.2,170.72l-0.6,0.4l-0.13,0.16l-0.01,-0.51l0.74,-0.05ZM871.88,65.81l2.17,-0.13l3.19,1.16l-2.39,1.09l-5.63,0.48l-0.26,-0.84l2.92,-1.76ZM797.39,48.49l-2.0,1.36l-3.8,-0.42l-4.25,-1.8l0.35,-0.97l9.69,1.83ZM783.67,46.12l-1.63,3.09l-8.98,-0.13l-4.09,1.14l-4.54,-2.97l1.16,-3.01l3.05,-0.89l6.5,0.22l8.54,2.56ZM778.2,134.98l-0.56,-0.9l0.27,-0.12l0.29,1.01ZM778.34,135.48l0.94,3.53l-0.05,3.38l1.05,3.39l2.18,5.0l-2.89,-0.83l-0.49,0.26l-1.54,4.65l2.42,3.5l-0.04,1.13l-1.24,-1.24l-0.61,0.06l-1.09,1.61l-0.28,-1.61l0.27,-3.1l-0.28,-3.4l0.58,-2.47l0.11,-4.39l-1.46,-3.36l0.21,-4.32l2.15,-1.46l0.07,-0.34ZM771.95,56.61l1.76,-1.42l2.89,-0.42l3.28,1.71l0.14,0.6l-3.27,0.03l-4.81,-0.5ZM683.76,31.09l-13.01,1.93l4.03,-6.35l1.82,-0.56l1.73,0.34l5.99,2.98l-0.56,1.66ZM670.85,27.93l-5.08,0.64l-6.86,-1.57l-3.99,-2.05l-2.1,-4.16l-2.6,-0.87l5.72,-3.5l5.2,-1.28l4.69,2.85l5.59,5.4l-0.56,4.53ZM564.15,68.94l-0.64,0.17l-7.85,-0.57l-0.86,-2.04l-4.28,-1.17l-0.28,-1.94l2.27,-0.89l0.25,-0.39l-0.08,-2.38l4.81,-3.97l-0.15,-0.7l-1.47,-0.38l5.3,-3.81l0.15,-0.44l-0.58,-1.94l5.28,-2.51l8.21,-3.27l8.28,-0.96l4.35,-1.94l4.6,-0.64l1.36,1.61l-1.34,1.28l-16.43,4.94l-7.97,4.88l-7.74,9.63l0.66,4.14l4.16,3.27ZM548.81,18.48l-5.5,1.18l-0.58,1.02l-2.59,0.84l-2.13,-1.07l1.12,-1.42l-0.3,-0.65l-2.33,-0.07l1.68,-0.36l3.47,-0.06l0.42,1.29l0.66,0.16l1.38,-1.34l2.15,-0.88l2.94,1.01l-0.39,0.36ZM484.55,20.04l4.26,1.75l-3.1,2.55l-7.1,0.65l-7.08,-0.9l-0.37,-1.31l-0.37,-0.29l-3.44,-0.1l-2.08,-2.0l6.87,-1.44l3.9,1.31l2.39,-1.64l6.13,1.4ZM480.49,192.16l0.58,0.4l-0.68,-0.12l0.11,-0.28ZM482.52,192.82l2.51,0.06l0.24,0.32l-1.99,0.13l-0.77,-0.51ZM481.69,33.93l-4.45,1.74l-3.54,-0.99l1.12,-0.9l0.05,-0.58l-1.06,-1.22l4.22,-0.89l1.09,1.97l2.57,0.87ZM466.44,24.04l7.43,3.77l-5.41,1.86l-1.58,4.08l-2.26,1.2l-1.12,4.11l-2.61,0.18l-4.79,-2.86l1.84,-1.54l-0.1,-0.68l-3.69,-1.53l-4.77,-4.51l-1.73,-3.89l6.11,-1.82l1.54,1.92l3.57,-0.08l1.2,-1.96l3.32,-0.18l3.05,1.92ZM459.19,184.75l-0.65,1.65l0.32,1.05l-0.31,0.89l-1.5,-0.85l-4.5,-1.67l0.19,-0.82l2.67,0.23l3.78,-0.48ZM452.28,129.07l-1.19,2.24l-2.13,-1.6l-0.23,-0.95l2.98,-0.95l0.57,1.26ZM443.93,176.05l1.18,1.66l-0.3,3.32l-1.06,-0.01l-0.77,0.73l-0.53,-0.44l-0.1,-3.37l-0.39,-1.22l1.04,0.01l0.92,-0.68ZM444.48,172.62l-0.64,1.78l-0.58,-0.31l-0.49,-1.72l0.4,-0.89l1.0,-0.72l0.3,1.85ZM412.61,118.72l-2.19,3.22l-0.0,0.45l5.13,-0.3l-0.53,2.37l-2.2,3.12l0.29,0.63l2.37,0.21l2.33,4.3l1.76,0.69l2.2,5.12l2.94,0.77l-0.23,1.62l-1.15,0.88l-0.1,0.52l0.82,1.42l-1.86,1.43l-3.3,-0.02l-4.12,0.87l-1.04,-0.58l-0.47,0.06l-1.51,1.41l-2.12,-0.34l-1.86,1.18l-0.6,-0.29l3.19,-3.0l2.16,-0.69l0.28,-0.41l-0.34,-0.36l-3.73,-0.53l-0.4,-0.76l2.2,-0.87l0.17,-0.61l-1.26,-1.67l0.36,-1.7l3.38,0.28l0.43,-0.33l0.37,-1.99l-1.79,-2.49l-3.11,-0.72l-0.38,-0.59l0.79,-1.35l-0.04,-0.46l-0.82,-0.97l-0.61,0.01l-0.68,0.84l-0.1,-2.34l-1.23,-1.88l0.85,-3.47l1.77,-2.68l1.85,0.26l2.17,-0.22ZM405.09,134.93l0.34,2.55l-1.75,2.78l-4.22,1.88l-2.84,-0.4l1.73,-3.0l-1.18,-3.53l4.98,-4.07l1.81,-0.12l2.3,1.84l-1.17,2.07ZM384.14,88.06l-0.37,2.61l2.54,2.51l-2.9,2.75l-9.19,3.4l-9.25,-1.66l1.7,-1.22l-0.1,-0.7l-4.05,-1.47l2.96,-0.53l0.33,-0.43l-0.11,-1.2l-0.33,-0.36l-4.67,-0.85l1.28,-2.04l3.45,-0.56l3.77,2.72l0.44,0.02l3.64,-2.16l3.3,1.08l3.98,-2.16l3.58,0.26ZM289.01,278.39l-0.81,0.8l-0.78,0.12l-0.5,-0.66l-0.56,-0.1l-0.91,0.6l-0.46,-0.22l1.09,-2.96l-0.96,-1.77l-0.17,-1.49l1.07,-1.77l2.32,0.75l2.51,2.01l0.3,0.74l-2.14,3.96Z",name:"Europe"},SA:{path:"M249.29,428.94l-2.5,0.04l-3.43,2.03l-0.57,3.16l-0.64,0.05l-2.68,-1.06l-2.82,-2.33l-3.04,-1.89l-0.69,-1.85l0.63,-2.14l-1.21,-2.11l-0.31,-5.37l1.01,-2.91l2.57,-2.38l-0.18,-0.68l-3.16,-0.77l2.05,-2.47l0.77,-4.65l2.32,0.9l0.54,-0.29l1.31,-6.31l-0.22,-0.44l-1.68,-0.8l-0.56,0.28l-0.7,3.36l-0.81,-0.22l1.56,-9.41l1.15,-2.24l-0.71,-2.82l-0.18,-2.84l1.01,-0.33l3.26,-9.14l1.07,-4.22l-0.56,-4.21l0.74,-2.34l-0.29,-3.27l1.46,-3.34l2.04,-16.59l-0.18,-4.34l-0.52,-3.69l-2.55,-1.68l-0.39,-1.16l-4.95,-2.58l-4.46,-2.79l-1.84,-1.51l-0.91,-1.84l0.3,-0.96l-2.11,-3.33l-4.82,-9.68l-1.04,-1.2l-0.87,-1.94l-3.4,-2.48l0.58,-1.18l-1.13,-2.23l0.66,-1.49l1.92,-1.52l1.41,-1.95l-0.51,-1.5l-0.67,-0.08l-0.72,0.87l-0.87,-0.64l0.35,-0.69l-0.36,-1.96l0.81,-0.51l0.45,-1.51l0.92,-1.57l-0.07,-0.97l2.84,-1.44l0.02,-0.83l0.77,-0.52l-0.1,-1.12l0.41,-0.64l1.34,-0.32l2.0,-2.88l-0.11,-0.57l-0.66,-0.43l0.39,-1.38l-0.52,-2.1l0.49,-0.83l-0.4,-2.13l-0.97,-1.35l0.17,-0.66l0.86,-0.08l0.47,-0.75l-0.46,-1.63l1.41,-0.07l1.8,-1.69l0.93,-0.24l0.3,-0.38l0.45,-2.76l1.22,-1.0l1.44,-0.04l0.45,-0.5l1.91,0.12l2.93,-1.84l1.15,-1.14l0.91,0.46l-0.42,1.05l-1.19,0.24l-0.25,0.62l0.74,1.04l-0.02,1.06l-1.07,1.78l0.95,2.0l0.42,0.22l1.4,-0.44l0.56,-1.83l-0.77,-1.17l-0.1,-1.47l2.82,-0.93l0.26,-0.49l-0.28,-0.96l0.3,-0.28l0.66,1.31l1.96,0.26l1.4,1.22l0.08,0.68l0.39,0.35l4.81,-0.22l1.49,1.11l1.92,0.31l1.67,-0.84l0.22,-0.6l3.44,-0.14l-0.17,0.55l0.86,1.19l2.19,0.35l1.67,1.1l0.37,1.86l0.41,0.32l1.18,-0.05l2.48,1.44l1.41,1.49l0.06,1.15l0.37,0.38l0.8,0.05l2.23,2.01l3.2,0.6l0.57,-0.47l1.75,-0.16l2.1,0.53l-1.08,1.95l0.2,1.72l0.93,1.49l-1.19,3.03l0.17,0.57l1.09,0.52l1.06,-0.61l0.84,0.78l1.42,-0.29l1.05,-1.08l2.12,-3.92l0.37,-0.05l1.89,5.45l1.33,0.59l0.05,1.28l-1.77,1.94l0.02,0.56l0.78,0.75l4.32,0.47l0.08,2.16l0.66,0.29l1.74,-1.5l6.97,2.32l1.02,1.22l-0.35,1.18l0.49,0.5l2.81,-0.74l4.77,1.3l3.75,-0.08l3.57,2.0l3.29,2.86l1.93,0.72l2.12,0.12l0.71,0.62l1.21,4.51l-0.95,3.98l-4.72,5.06l-1.64,2.92l-1.72,2.05l-0.8,0.3l-0.72,2.03l0.18,4.75l-0.94,5.53l-0.81,1.13l-0.43,3.36l-2.55,3.5l-0.4,2.51l-1.86,1.04l-0.67,1.53l-2.54,0.01l-3.94,1.01l-1.83,1.2l-2.87,0.82l-3.03,2.19l-2.2,2.83l-0.36,2.0l0.4,1.58l-0.44,2.6l-0.51,1.2l-1.77,1.54l-2.75,4.78l-3.95,3.58l-1.11,2.58l-1.6,1.55l-1.09,1.76l-2.59,1.44l-1.69,-0.52l-1.42,0.26l-2.18,-1.15l-1.72,0.04l-1.4,-1.43l-0.68,0.23l-0.02,1.84l2.99,2.28l-0.16,2.11l1.4,1.11l-0.1,1.09l-2.29,3.52l-3.55,1.49l-4.92,0.6l-2.71,-0.29l-0.43,0.51l0.5,1.65l-0.49,2.1l0.38,1.42l-1.19,0.83l-2.36,0.38l-2.3,-1.04l-1.38,0.83l0.41,3.64l1.69,0.91l1.4,-0.71l0.36,0.76l-2.04,0.86l-2.01,1.89l-0.97,4.63l-2.34,0.1l-2.09,1.78l-0.61,2.75l2.46,2.31l2.17,0.63l-0.7,2.32l-2.83,1.73l-1.73,3.86l-2.17,1.22l-1.16,1.67l0.75,3.76l1.04,1.28ZM274.36,425.85l1.44,1.08l-0.47,0.73l-3.0,0.89l-0.96,-1.0l-0.52,-0.05l-1.83,1.29l-0.73,-0.88l2.46,-1.64l1.93,0.76l1.67,-1.19ZM253.56,437.92l-0.62,0.09l-0.77,1.31l-1.94,0.98l-2.49,-0.37l-1.88,-1.06l-2.55,-0.49l-3.08,-1.89l-2.51,-1.82l-2.38,-2.63l4.1,2.48l3.32,1.23l0.45,-0.12l1.29,-1.57l0.83,-2.32l2.05,-1.24l1.46,0.33l2.25,4.11l3.26,2.07l3.08,0.78l-0.71,1.1l-2.0,0.15l-1.15,-1.11Z",name:"South America"}},height:440.7063107441331,projection:{type:"mill",centralMeridian:11.5},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","de_mill",{insets:[{width:900,top:0,height:1013.8952766123396,bbox:[{y:-6845388.062206638,x:651826.6317576179},{y:-5694876.55460837,x:1673096.1659230748}],left:0}],paths:{"DE-BE":{path:"M710.94,355.66l1.16,-1.31l0.31,-1.0l0.98,-0.97l-0.74,-2.05l0.47,-2.19l1.42,-0.94l2.79,-2.88l-0.08,-0.98l-1.47,-2.18l0.73,-6.66l-0.34,-1.33l0.64,-1.38l4.96,1.6l1.09,-0.07l0.35,-0.78l-0.73,-1.75l1.04,-2.7l2.87,-0.39l1.06,-0.5l1.18,-0.91l1.37,-2.19l0.63,0.01l0.3,2.64l0.85,0.92l1.79,0.65l3.7,0.21l1.86,-0.49l0.87,-1.38l2.02,-1.38l1.68,0.91l0.97,-0.04l0.86,-1.18l2.39,-1.71l0.8,1.09l1.68,1.32l-0.23,3.06l0.52,1.47l6.52,6.23l4.25,2.44l3.3,0.77l0.05,0.57l-2.28,4.44l-0.17,0.98l0.34,0.75l0.38,0.19l3.64,-0.35l1.11,0.49l1.94,1.99l3.86,1.43l1.24,1.07l-1.08,1.15l-0.45,2.45l-2.59,2.1l-0.44,1.05l0.23,1.98l-0.26,1.22l-0.52,0.43l-2.57,0.78l-1.68,2.53l-0.48,-0.04l-0.58,-4.22l-1.2,-1.24l-1.76,0.03l-2.4,-0.66l-5.7,-2.14l-1.45,0.18l-1.06,0.71l-1.67,-0.06l-1.51,-1.94l-1.09,-0.45l-2.61,0.59l-0.84,0.51l-0.39,0.91l0.23,2.67l-2.7,-0.01l-1.66,-0.65l-2.96,-2.75l-3.67,0.8l-1.15,-1.62l-0.5,-0.23l-4.07,1.35l-2.3,-1.43l-1.43,-0.19l-4.21,1.59l-1.43,1.07l-3.65,-0.65l-2.32,-1.38Z",name:"Berlin"},"DE-ST":{path:"M511.75,377.7l-0.19,-1.91l-0.72,-0.39l-1.04,0.12l-2.74,-3.18l1.67,-1.48l0.22,-0.86l-1.19,-2.29l-1.94,-0.96l-0.25,-1.3l1.62,-0.63l4.58,-0.76l0.66,-0.85l0.34,-2.05l-0.72,-1.15l-2.88,-1.99l-1.7,-0.49l-0.89,-0.61l-6.9,-7.59l0.2,-1.63l0.97,-2.19l1.6,-0.58l2.71,0.33l0.63,-0.68l-0.8,-1.54l-3.95,-4.79l-0.65,-2.15l0.15,-3.19l2.52,-2.52l0.37,-0.71l-0.07,-0.65l-0.59,-0.69l-1.69,-0.45l-1.06,0.31l-1.12,0.88l-0.5,-0.05l-4.12,-4.8l-4.69,-7.76l-1.68,-0.93l-1.1,-0.03l-0.74,-0.64l-0.72,-3.4l-1.93,-1.84l-1.63,-3.11l0.32,-1.91l-0.33,-2.2l0.36,-1.11l-0.14,-1.09l3.24,-1.17l4.55,-0.28l4.29,0.17l5.6,-1.61l1.86,-0.81l1.06,-1.12l1.88,-1.23l0.47,-0.71l0.51,-2.5l1.3,-0.62l3.41,-0.05l5.48,1.55l5.8,-0.35l4.62,0.71l1.08,0.85l1.26,0.44l0.9,1.23l0.82,0.36l1.17,-0.2l1.85,-1.0l0.81,0.26l2.14,-0.1l5.95,-2.08l3.49,-0.77l6.06,-4.61l2.59,-0.21l0.65,-0.44l-0.46,-3.58l0.53,-2.9l0.67,-1.42l1.25,-0.47l1.34,0.35l1.48,-0.07l1.14,-0.76l1.83,-4.18l4.01,-0.91l0.66,0.36l0.03,0.89l-0.49,1.1l-0.74,0.63l0.1,0.67l1.49,0.6l3.15,0.11l0.93,0.56l0.82,2.89l0.78,0.98l1.88,0.24l3.52,-1.46l1.24,-0.22l2.83,3.53l1.47,0.99l3.2,0.18l0.8,0.39l-0.39,1.13l-1.2,1.54l0.04,1.04l6.37,3.52l2.86,0.5l3.91,1.7l1.79,0.32l1.6,-0.49l2.44,0.06l7.12,-0.65l1.23,1.43l-0.1,1.4l0.36,0.43l2.52,0.11l3.74,-0.88l2.6,0.83l0.88,1.31l1.94,5.74l-0.37,1.25l-3.08,2.11l-0.33,0.54l0.12,1.74l1.16,1.92l-1.63,1.6l-0.18,0.67l0.35,1.19l1.01,1.4l0.66,2.01l1.7,1.56l-0.22,2.11l-0.95,2.48l-0.99,1.47l-1.64,0.62l-1.93,-0.09l-0.74,0.32l-0.52,2.14l-0.57,5.23l-2.55,3.23l-0.17,0.61l0.33,0.55l0.59,0.18l2.86,-0.07l-1.32,1.38l-0.23,0.64l0.35,1.76l0.9,0.76l1.4,0.29l2.26,-0.57l1.13,-1.04l0.55,-1.93l0.31,-0.22l1.44,0.6l1.93,2.54l0.8,0.55l3.31,-0.37l-0.45,1.01l-0.12,2.75l-2.0,3.63l-1.86,1.68l-0.03,0.56l0.98,1.84l-0.76,2.32l-1.74,3.01l0.16,1.04l-0.4,1.46l0.55,2.31l-1.32,2.13l-1.56,4.21l0.39,3.28l1.16,1.2l1.26,0.31l1.26,1.89l-2.46,2.36l-2.25,5.35l1.74,3.68l2.91,2.5l1.02,2.21l2.48,1.24l1.76,1.58l6.03,6.74l0.45,2.41l1.41,1.2l4.18,2.62l1.15,0.31l1.94,-0.2l1.12,-1.25l0.72,0.02l2.52,2.54l6.33,3.8l4.95,0.78l1.34,-1.09l2.5,-1.17l0.81,-1.47l0.8,0.01l12.49,6.29l4.9,0.63l1.31,0.76l1.17,2.76l0.67,0.48l5.45,0.26l2.91,0.68l2.89,2.9l5.51,3.2l1.89,0.62l6.6,-0.62l2.67,1.69l0.47,-0.13l1.62,-2.09l3.58,0.12l1.37,0.49l-0.61,1.17l-3.36,3.14l-3.61,5.02l0.11,5.5l2.2,4.24l-0.27,1.33l-2.63,2.98l-6.68,4.5l-1.95,2.91l-1.38,-0.29l-2.04,-1.77l-1.47,-0.69l-3.02,1.13l-1.33,-1.29l-2.19,-0.93l-2.66,-0.63l-1.11,-0.64l-1.4,-2.03l-2.85,0.23l-1.12,1.22l-5.05,3.48l-1.7,0.67l-2.83,-1.01l-3.84,-0.38l-1.6,0.82l-1.73,2.63l-1.87,1.34l-0.75,0.06l-0.41,-0.49l-0.79,-0.24l-9.31,1.35l-1.31,-0.74l-7.91,-0.26l-1.23,0.64l-0.39,2.49l-0.58,0.97l-7.21,0.61l-5.74,2.15l-2.88,-0.27l-3.12,-1.14l-0.61,0.23l-0.85,2.22l-2.97,2.3l0.0,6.04l-0.39,1.31l-1.64,1.66l-1.61,1.1l-0.2,0.6l0.24,2.8l0.87,1.54l0.25,5.08l1.44,3.13l-0.02,2.43l-0.59,1.0l-1.79,0.18l-1.27,0.88l-1.0,1.56l-0.47,1.62l0.78,2.41l0.13,2.63l1.93,2.3l0.33,1.19l0.33,3.69l-0.41,1.19l-0.97,1.12l-0.06,1.28l0.27,0.36l2.72,0.71l-0.36,3.43l1.04,1.66l2.05,1.61l0.34,2.07l0.4,0.6l0.69,0.46l3.84,0.63l0.12,0.58l-1.66,2.49l-0.51,2.75l0.48,0.84l2.2,1.1l0.4,1.34l-2.24,3.48l-3.39,3.59l-0.3,1.27l0.3,1.03l-1.41,0.98l-0.47,-0.03l-0.73,-1.06l-2.49,-1.93l-0.83,-0.28l-2.78,1.17l-5.63,-1.52l-6.69,0.89l-0.46,-1.34l-3.15,-1.42l-0.72,-0.72l-0.68,-1.61l-1.48,-1.16l-4.85,-1.85l-2.26,-1.41l-1.28,-0.19l-8.75,0.64l-1.28,0.77l-0.49,-0.17l-1.14,-0.87l-0.49,-1.71l-2.27,-3.62l-0.38,-3.14l-0.61,-0.65l-2.18,-1.18l-4.08,0.63l-4.52,-0.07l-4.62,-0.52l-2.95,1.42l-5.76,-0.36l-1.48,-0.74l-0.67,-1.44l-0.29,-1.31l0.88,-0.48l0.21,-1.0l-0.82,-3.64l-2.1,-3.0l-1.06,-0.99l-2.23,-0.75l-2.12,-1.15l-0.92,-1.2l1.06,-1.26l4.82,-0.76l2.6,-1.21l1.3,-1.0l1.78,-2.78l-0.04,-0.44l-5.62,-6.96l-2.67,-4.19l-5.25,-3.49l-2.66,-0.77l-9.16,-1.13l-4.19,0.07l-15.09,-1.54l-2.43,-1.15l-0.67,-1.06l0.66,-5.07l-2.54,-4.24l0.09,-3.13l-2.01,-2.26l-1.36,-3.22l-0.05,-0.57l0.43,-0.34l2.32,0.5l1.1,-0.74l-0.05,-1.59l-0.9,-1.75l-0.74,-0.44l-1.25,-0.03l-3.13,-1.09l-1.44,-1.06l-2.81,-0.05l-4.44,-1.92l-8.84,0.18l-1.37,-0.72l-2.68,-4.06l-0.08,-3.65l-0.75,-1.81l-1.67,-1.39l-1.38,-2.21l-1.09,-2.65l-1.67,-1.02l-1.66,-1.53l-0.2,-0.68l-0.45,-2.63l0.23,-5.1l0.49,-0.55l1.7,-0.71l1.03,-1.32l1.38,-0.67l1.26,-1.81l0.13,-1.21l-0.61,-2.73l-2.14,-1.55l0.46,-2.26l2.22,-1.17l0.47,-0.99l-0.41,-0.45l-1.4,0.06l-1.36,-1.31l-2.26,-0.93l-0.26,-1.14l-1.7,-2.38l0.64,-0.28l2.89,0.27l1.38,-0.38l2.94,-2.56l0.12,-1.6l0.65,-0.27l5.49,-0.71l13.01,-0.0l2.63,-0.85l1.89,-0.24l5.82,0.07l0.95,-0.32l0.84,-1.41l0.02,-1.82l-0.42,-0.7l-1.69,-1.11l-0.01,-0.35l0.69,-0.48l3.37,-0.88l2.18,-1.02l2.45,-1.72l1.9,-2.44l0.15,-1.3l-0.45,-1.63l-0.96,-0.73l-1.5,-0.32l-0.88,-1.48l0.88,-1.92l0.69,-0.6l3.37,-0.95l1.23,-0.98l0.29,-2.18l-0.33,-1.2l-0.96,-0.68l-0.59,0.22l-0.37,0.6Z",name:"Sachsen-Anhalt"},"DE-RP":{path:"M24.7,661.09l1.01,-4.92l0.64,-1.76l0.83,-0.82l0.38,-1.02l-0.36,-1.07l-0.88,-0.68l0.56,-2.05l0.64,-0.33l1.87,-0.13l0.89,-0.45l0.8,-1.55l0.04,-1.6l-0.55,-1.46l-1.12,-1.1l0.71,-0.78l2.17,-1.29l1.01,-1.26l1.91,-0.76l4.19,-0.99l1.96,-1.44l0.13,-0.46l-0.4,-1.06l0.18,-1.13l1.48,-2.03l1.17,-0.57l3.39,0.63l2.73,-0.4l1.43,-1.19l0.07,-0.88l2.15,-0.04l2.75,-1.22l0.26,-0.53l-0.14,-0.58l-3.3,-4.51l0.21,-0.78l0.67,0.02l0.63,0.43l0.83,1.31l2.25,1.19l0.81,1.92l0.82,0.49l2.38,-0.73l4.61,-2.84l4.25,-0.62l1.26,-0.47l3.26,1.3l-0.47,1.61l0.43,0.48l0.55,0.08l1.22,-0.02l2.7,-1.49l0.56,-0.02l1.58,0.98l1.21,1.29l1.85,0.39l7.79,-1.85l0.63,-0.64l0.18,-0.79l-0.35,-1.34l-1.6,-2.52l-0.39,-4.03l-0.58,-0.71l-1.84,-0.88l0.81,-2.09l-0.08,-1.91l5.26,-1.85l1.3,2.03l1.31,0.92l1.52,0.34l1.44,-0.2l0.96,-0.9l0.76,-1.32l0.23,-2.63l-0.46,-3.09l2.61,-0.83l1.55,-1.58l0.97,-1.64l5.73,-1.48l6.08,-3.37l3.16,0.86l1.4,-0.54l1.08,-1.76l2.26,0.63l1.29,-0.27l2.46,-2.13l0.85,-0.38l1.1,-2.19l1.41,0.53l0.57,1.23l0.52,0.34l5.6,0.33l5.78,-1.33l3.39,-2.17l0.2,-1.77l0.88,-1.5l0.09,-3.33l-0.32,-0.56l0.36,-0.33l2.21,-0.55l3.74,0.25l8.22,-1.92l3.88,-1.81l2.82,0.16l1.83,-2.44l4.31,-1.56l1.43,-1.83l1.04,0.55l1.03,-0.5l0.37,-1.1l-0.11,-1.22l-1.9,-2.05l3.19,-1.64l2.37,-2.16l2.49,0.71l0.86,-0.57l0.06,-2.37l-1.22,-2.58l-0.36,-3.12l0.28,-1.24l2.88,-2.32l1.1,-0.27l5.23,1.22l-1.35,4.44l0.11,1.04l1.47,1.02l2.59,0.75l3.7,3.3l1.88,1.21l2.66,-0.65l1.19,4.08l-0.21,3.99l1.05,1.68l4.13,4.5l1.6,2.36l0.67,2.23l1.11,0.27l2.96,-0.98l3.41,1.51l-0.33,1.81l-1.02,2.5l2.01,4.18l0.37,1.99l0.67,1.17l1.16,0.89l-2.47,5.41l-2.08,1.52l-1.78,0.13l-2.49,-2.33l-1.61,-0.07l-1.86,0.64l-1.53,1.74l-1.72,1.16l-0.43,1.63l-0.09,5.6l0.44,0.71l1.39,0.79l-1.7,1.6l-1.22,3.55l-1.13,0.8l-0.32,0.85l0.96,1.07l4.36,0.93l0.5,1.36l1.78,0.8l2.91,5.16l2.07,1.46l0.59,0.97l1.41,3.87l-0.08,1.13l-2.1,0.73l-5.08,-0.12l-0.86,0.67l-0.57,1.56l0.12,0.66l0.84,0.9l-1.7,2.25l-0.83,-0.2l-1.56,-1.3l-0.62,-0.04l-1.31,1.16l-5.75,2.53l-1.27,1.54l-1.17,2.26l-0.26,1.37l0.16,1.15l0.76,0.85l2.47,1.42l-0.8,3.06l-2.12,-1.58l-3.93,0.35l-1.32,1.69l-0.7,2.73l-6.56,3.92l-0.04,0.64l1.41,0.69l6.26,4.76l0.64,0.92l0.36,1.7l2.08,2.34l4.06,-0.13l4.26,-1.18l4.75,-2.1l3.81,-2.44l12.19,-3.48l3.65,0.15l1.38,0.75l10.44,9.97l1.84,4.14l-1.41,4.58l0.79,1.68l2.23,2.78l0.94,1.72l0.91,3.46l1.88,2.97l0.7,1.92l1.15,1.53l3.75,-0.47l0.94,0.31l-0.18,0.85l-1.21,1.66l-2.02,2.09l-3.21,0.55l-2.81,1.66l-1.73,2.69l-0.17,3.38l1.52,3.21l2.4,3.89l1.58,3.79l-0.74,3.29l1.87,2.64l2.18,5.43l1.29,2.32l0.0,0.5l-1.82,0.77l-0.24,1.24l0.27,0.38l1.67,0.56l3.25,0.62l0.75,1.05l-1.25,2.64l0.73,4.29l-3.48,6.65l-0.23,1.19l0.28,0.45l1.96,0.59l-0.25,1.12l-6.64,6.64l-1.28,0.59l-1.18,1.11l-0.67,2.23l-1.87,12.05l-0.41,1.21l-7.19,12.57l-2.03,2.67l-3.08,2.82l-2.62,0.81l-1.18,-0.88l-9.6,-1.69l-15.64,-7.06l-1.85,-0.17l-5.52,0.49l-8.1,-1.99l-4.7,1.56l-4.03,-0.89l-3.62,0.88l-1.19,-0.23l-0.77,-0.56l-1.82,-2.5l-2.28,-0.99l-4.22,-0.63l-2.02,-1.09l-3.43,-4.36l-1.23,-1.1l1.05,-1.13l-0.91,-2.08l-1.87,-0.57l-3.96,-0.23l-0.7,-1.43l-1.91,-0.14l-1.76,0.43l-0.43,-0.31l-1.83,0.04l-5.12,-4.44l-0.72,-3.11l0.1,-0.97l0.63,-1.08l2.04,-0.24l1.38,-1.65l0.75,-2.82l1.47,-1.42l0.58,-2.29l1.93,-1.43l0.92,-1.29l0.11,-0.76l-0.41,-0.97l0.64,-1.69l-0.53,-1.14l-1.2,-0.68l-2.44,-0.77l-5.36,-0.97l0.23,-0.69l-0.31,-0.68l-3.97,-4.06l-0.52,-1.64l0.26,-0.34l0.94,-0.54l1.88,-2.04l2.63,-1.5l0.44,-1.24l-0.36,-1.78l-1.18,-0.55l-0.24,-3.37l-1.16,-1.98l-0.56,-1.53l-0.01,-1.85l-0.47,-0.49l-0.69,-0.08l-2.81,1.53l-2.73,0.22l-4.63,-2.83l-2.24,-1.82l-7.08,-0.5l-6.52,-3.12l-2.78,1.32l-0.84,-0.58l-2.17,-0.57l-8.19,4.3l-14.41,5.61l-1.73,0.29l-2.48,-0.16l-6.27,2.41l-11.26,-0.46l-13.35,1.03l0.12,-4.73l0.51,-1.28l3.97,-4.55l2.07,-3.33l-0.2,-1.32l-1.19,-0.9l1.32,-1.56l7.15,-3.91l0.14,-0.58l-0.7,-0.78l0.12,-0.23l1.36,-0.0l-1.32,-3.0l0.06,-0.9l0.96,-0.88l-0.21,-1.96l0.73,-4.43l-0.78,-0.59l-3.33,-0.76l-4.76,-0.01l-1.62,-0.37l-1.58,-0.85l-2.85,-2.28l-1.84,-0.93l-1.05,0.02l-1.76,0.67l-1.68,-3.31l-4.74,-2.03l-1.42,-1.21l-3.23,-6.53l-1.68,-2.3l-0.67,0.03l-0.74,1.23l-1.88,-4.14l-1.71,-2.22l-0.36,-0.88l0.25,-1.47l-0.61,-2.68l-0.69,-1.17l-0.84,-0.48l1.01,-1.48l-0.25,-0.66l-0.57,-0.01Z",name:"Rheinland-Pfalz"},"DE-BB":{path:"M532.83,262.93l6.91,0.27l2.22,0.8l1.92,0.23l0.44,-0.36l0.41,-3.06l1.26,-0.51l3.04,0.0l5.26,2.45l2.98,-0.23l1.98,-1.24l0.85,-2.35l-0.99,-4.37l-1.3,-1.51l-0.19,-0.75l0.51,-1.09l4.24,-3.19l1.87,-1.0l5.26,-1.62l3.25,-0.16l1.03,0.3l2.97,2.0l1.17,2.19l0.54,0.17l1.95,-1.02l2.04,-0.6l5.11,0.21l0.42,-0.46l-0.31,-1.87l-1.57,-1.18l0.96,-0.35l2.95,0.42l2.23,-2.22l5.22,-1.82l2.14,0.54l3.55,-2.62l1.44,-0.2l1.23,-2.31l0.17,-1.79l2.41,-1.35l1.44,-2.09l3.01,-1.03l2.53,-0.42l1.88,1.46l0.8,0.19l3.07,-1.7l1.07,-0.25l0.91,0.3l2.34,3.19l6.9,1.55l4.13,1.99l2.89,1.84l1.73,1.54l2.81,1.31l1.58,1.72l1.67,0.3l3.5,-0.21l2.97,-0.63l10.88,2.19l1.22,0.48l2.77,2.25l7.11,1.35l0.38,3.34l1.27,0.92l1.33,0.11l4.27,-0.77l1.3,0.08l1.24,0.36l1.45,0.99l1.62,0.34l3.88,-0.72l2.7,-0.03l1.77,-0.58l0.24,0.59l-1.32,1.13l0.25,1.02l3.0,1.28l2.7,-0.34l4.68,-4.1l2.85,-1.48l2.25,-1.6l0.85,-0.96l0.63,-1.75l2.1,-1.21l0.96,-0.92l0.67,-0.19l1.12,0.29l2.25,2.71l1.35,0.48l2.75,-0.0l0.39,-0.3l0.58,-2.63l1.22,-2.32l1.51,-1.43l1.48,-0.61l2.46,-0.19l1.97,0.33l3.98,1.73l1.99,0.37l1.84,-0.55l5.11,-3.36l1.11,-0.34l2.54,-2.43l3.16,-6.27l0.57,-2.58l0.68,-1.37l1.26,-0.97l1.71,-0.74l3.64,-0.2l2.31,-1.78l1.79,-2.64l5.81,-4.06l3.38,-0.4l3.32,0.21l3.06,-1.06l0.25,-0.48l-0.46,-1.66l-2.44,-3.76l0.14,-1.93l1.1,0.14l2.53,3.13l4.32,1.37l0.21,2.84l2.8,4.16l0.58,1.9l1.86,2.02l6.85,-0.41l5.77,0.34l4.55,1.1l2.26,-2.31l2.19,-0.37l3.58,1.44l4.08,-0.21l1.93,0.35l0.14,3.17l-0.44,2.39l-1.48,2.82l-3.44,4.48l-8.18,4.5l-0.3,2.96l0.35,0.39l7.84,1.28l6.71,0.45l1.55,-1.05l0.55,-1.69l2.56,-1.06l2.7,-2.85l6.15,-3.1l0.53,2.01l0.52,4.87l0.66,0.99l2.96,2.61l-2.35,3.78l-0.64,0.78l-1.1,0.53l-0.97,1.19l-0.76,1.72l-0.3,2.0l1.13,5.86l-3.18,8.56l-1.26,2.29l-2.94,2.52l-5.73,3.73l-5.94,2.54l-4.8,2.91l-0.19,1.17l0.61,1.47l1.4,6.23l-0.38,2.37l-0.93,1.47l-2.54,1.81l-0.11,0.53l1.13,1.86l1.83,1.23l2.18,0.58l2.2,0.14l1.83,0.66l3.26,3.12l2.65,1.16l10.37,6.27l1.45,1.4l3.42,5.49l1.13,0.87l1.78,0.68l2.93,3.21l5.79,1.88l6.19,5.72l2.79,1.89l-2.56,4.42l-0.8,3.17l0.15,0.42l1.72,1.3l0.37,1.13l-1.53,2.92l-2.32,3.03l-5.2,4.02l0.57,5.35l2.33,5.75l2.0,3.74l-0.44,2.64l2.32,2.11l3.33,1.41l2.84,0.55l2.59,0.93l1.38,2.1l-0.03,2.42l-1.92,2.25l0.08,1.06l1.31,1.69l-0.33,1.66l-1.07,2.44l-0.56,3.66l1.13,2.04l5.96,3.68l-2.25,2.67l-0.94,3.67l-2.09,3.13l-0.56,1.34l-0.37,8.09l-0.8,2.46l-1.47,2.29l-1.77,1.96l-5.61,4.73l-1.43,2.62l0.38,2.98l1.61,2.04l1.83,1.09l1.23,1.37l0.39,3.4l1.12,3.5l2.26,2.19l4.69,3.23l1.2,2.14l0.94,3.23l0.16,3.3l-1.1,2.49l-1.94,2.59l-0.8,2.54l0.09,0.64l-3.68,-0.14l-4.14,-1.43l-2.43,-1.19l-2.34,-0.38l-2.13,0.08l-4.25,1.0l-12.98,5.4l-3.61,0.69l-3.27,-1.81l-3.59,-1.09l-4.83,-0.51l-6.2,1.26l-3.95,1.81l-1.29,0.97l-3.89,4.23l-0.68,1.23l-0.17,1.94l-1.45,2.85l-7.14,8.87l-0.65,0.19l-2.27,-0.54l-16.84,1.74l-14.86,-0.95l-5.83,-1.43l-2.12,0.31l-0.98,-0.34l-1.65,-2.02l-2.5,-1.41l-2.15,-1.77l-4.82,-1.95l-2.41,0.23l-1.05,0.89l-1.37,0.6l-10.59,2.94l-1.25,-1.65l-2.07,-0.6l-0.75,0.79l-1.16,0.02l-1.41,1.38l-0.62,-1.08l-0.19,-1.14l1.62,-1.55l0.77,-1.93l0.17,-3.34l-0.18,-1.13l-0.84,-1.12l1.62,-1.1l0.44,-0.88l-0.76,-3.69l-0.72,-1.45l-2.14,-1.14l-0.81,-0.96l0.6,-2.51l-0.62,-1.27l-2.96,-1.84l-1.61,0.4l-0.6,-0.2l-1.27,-0.72l-2.7,-2.76l-0.78,-0.3l1.7,-2.55l6.61,-4.44l2.82,-3.17l0.38,-2.0l-1.67,-2.84l-0.69,-2.27l0.05,-4.22l3.44,-4.71l3.42,-3.22l0.85,-1.63l-0.22,-0.56l-1.97,-0.69l-3.9,-0.1l-0.87,0.57l-0.99,1.56l-1.68,-1.39l-0.92,-0.24l-6.51,0.63l-1.69,-0.55l-5.44,-3.16l-1.64,-1.95l-1.34,-1.0l-3.16,-0.75l-5.2,-0.19l-1.54,-3.01l-1.62,-1.0l-4.91,-0.63l-12.52,-6.31l-1.37,-0.04l-1.02,1.63l-2.4,1.11l-1.29,1.05l-4.29,-0.78l-1.62,-0.78l-4.54,-2.93l-1.94,-2.14l-1.2,-0.68l-1.05,0.26l-0.91,1.14l-1.57,0.16l-0.91,-0.24l-5.29,-3.58l-0.45,-2.39l-6.14,-6.86l-1.83,-1.64l-2.35,-1.12l-1.04,-2.24l-2.57,-2.1l-1.1,-1.78l-0.78,-1.94l0.18,-0.53l0.75,-1.03l1.24,-3.22l2.18,-1.89l0.42,-0.85l-1.58,-2.49l-1.43,-0.44l-0.82,-0.87l-0.22,-3.42l1.41,-3.34l1.39,-2.35l-0.54,-2.49l0.4,-1.41l-0.17,-0.9l1.67,-2.79l0.84,-2.57l-0.06,-0.8l-0.92,-1.47l1.04,-0.59l0.71,-0.89l2.03,-3.68l0.29,-1.11l-0.07,-1.93l0.62,-1.6l-0.69,-0.46l-1.22,0.42l-2.11,0.12l-2.5,-2.97l-0.82,-0.54l-1.17,-0.23l-0.88,0.53l-0.57,1.95l-0.64,0.66l-2.14,0.61l-1.09,-0.25l-0.6,-0.7l-0.12,-0.96l1.52,-1.8l-0.03,-0.65l-1.0,-0.56l-2.71,0.1l2.65,-3.43l1.0,-7.16l2.12,0.06l2.08,-0.84l1.13,-1.67l1.02,-2.67l0.18,-2.6l-1.77,-1.68l-0.61,-1.91l-1.27,-1.95l0.04,-0.55l1.77,-1.93l-0.24,-0.97l-0.97,-1.29l-0.14,-1.2l3.23,-2.38l0.6,-1.83l-0.1,-0.97l-2.51,-6.15l-0.71,-0.68l-2.9,-0.88l-3.81,0.88l-1.98,-0.07l0.04,-1.32l-0.51,-0.97l-0.8,-0.75l-0.87,-0.31l-6.99,0.71l-2.43,-0.07l-1.52,0.49l-1.52,-0.26l-4.0,-1.73l-2.72,-0.45l-6.05,-3.35l1.24,-1.7l0.53,-1.54l-0.2,-0.49l-1.36,-0.62l-2.96,-0.11l-1.23,-0.81l-2.94,-3.67l-1.9,0.13l-3.46,1.45l-1.45,-0.21l-1.37,-3.72l-1.32,-0.74l-3.18,-0.11l-0.68,-0.29l0.99,-1.68l-0.01,-1.39l-1.2,-0.88l-4.52,0.93l-4.71,-1.53l-4.01,-0.79l-2.86,-2.43l-2.42,-0.67l-2.37,0.43l-3.15,1.8l-1.69,0.39l-1.97,-0.29l-1.51,-0.76l-3.52,-3.4l-1.27,-1.94ZM712.51,352.17l-2.13,2.83l-0.24,0.84l0.49,0.59l2.72,1.47l3.86,0.55l1.44,-1.1l3.96,-1.53l1.03,0.13l2.59,1.49l4.07,-1.29l0.78,1.4l0.65,0.35l0.6,0.08l3.06,-0.87l2.86,2.7l1.94,0.73l3.1,0.02l0.39,-0.32l0.19,-1.0l-0.28,-2.36l0.63,-0.46l2.24,-0.55l0.71,0.29l1.11,1.71l0.74,0.37l1.99,0.05l1.22,-0.76l1.06,-0.11l5.52,2.1l2.54,0.69l1.57,-0.07l0.77,0.85l0.5,3.96l0.6,0.76l1.26,-0.25l1.55,-2.46l2.57,-0.77l0.7,-0.63l0.4,-1.04l-0.21,-2.54l0.65,-1.13l2.22,-1.63l0.44,-0.98l0.1,-1.6l0.96,-0.76l0.18,-0.9l-1.61,-1.58l-3.92,-1.47l-1.78,-1.88l-1.41,-0.65l-3.7,0.31l0.05,-0.91l2.27,-4.37l-0.05,-1.23l-0.35,-0.36l-2.02,-0.24l-1.35,-0.5l-4.13,-2.37l-6.4,-6.13l-0.3,-0.98l0.18,-3.28l-3.1,-2.94l-0.74,0.12l-2.3,1.8l-0.69,1.04l-2.54,-0.92l-2.28,1.57l-0.89,1.39l-1.32,0.29l-3.59,-0.21l-1.51,-0.55l-0.47,-0.46l-0.28,-3.06l-1.65,-0.12l-0.75,0.48l-1.01,1.99l-0.99,0.74l-0.78,0.37l-2.79,0.34l-0.59,0.41l-1.16,3.09l0.7,1.81l-5.25,-1.72l-0.67,0.17l-1.1,2.14l0.34,1.33l-0.73,6.75l1.54,2.43l0.01,0.51l-4.11,3.6l-0.55,2.59l0.67,1.81Z",name:"Brandenburg"},"DE-NI":{path:"M115.46,378.55l-1.27,-3.35l0.06,-2.28l2.67,-5.76l0.81,-5.02l-1.43,-3.48l-5.97,-7.99l-1.08,0.11l-1.56,1.6l-2.34,0.56l-2.5,0.14l-2.7,-0.36l-5.11,-1.6l-7.72,-0.9l-2.47,-0.99l-1.81,-1.73l-0.55,-1.82l-0.49,-4.67l-0.94,-1.66l1.11,-0.1l5.45,-2.26l0.07,-0.7l-3.17,-2.2l-0.57,-0.7l0.61,-3.17l-0.67,-1.31l3.07,-1.83l3.18,-0.81l9.21,-0.12l5.15,1.28l4.89,-0.57l4.92,1.39l0.44,-0.17l1.79,-2.83l0.78,-4.85l0.91,-14.28l0.84,-4.36l1.72,-3.95l8.07,-10.41l2.13,-4.45l0.93,-4.33l0.16,-4.89l-0.91,-9.52l-1.22,-2.76l-0.07,-1.46l2.3,-6.28l0.31,-2.15l-0.36,-5.66l1.96,-1.4l1.78,-2.46l0.39,-1.72l-0.65,-1.5l2.25,-2.78l1.17,-0.49l2.15,-0.03l2.03,0.44l3.4,1.75l1.85,0.61l0.46,-0.16l-0.02,-0.48l-2.36,-2.83l-4.08,-1.29l-22.38,-0.66l-3.4,-1.37l-1.35,-3.49l-0.03,-9.79l0.41,-2.17l1.88,-4.01l0.44,-2.0l0.65,-0.98l5.6,0.72l0.43,-0.22l0.46,-0.95l0.99,-0.52l0.71,-1.31l-0.23,-2.15l-1.01,-1.06l-2.81,-1.15l-1.11,-0.93l-0.17,-1.42l1.22,-1.3l3.18,-1.82l3.53,-3.21l1.94,-1.1l3.58,-3.03l7.63,-2.42l14.93,-1.37l2.11,1.74l2.47,0.45l14.46,-2.45l29.37,-3.34l7.48,1.77l-0.59,4.64l2.75,4.86l4.1,4.31l3.18,1.83l-0.79,2.11l0.21,0.55l3.61,1.09l0.91,1.16l-0.27,2.14l-0.82,1.08l-2.03,1.25l-1.68,0.71l-3.8,0.28l-1.88,0.92l-0.19,0.51l1.79,4.46l0.92,1.72l1.42,1.28l2.69,-0.78l1.49,0.05l1.02,0.45l3.3,2.65l1.97,2.6l1.57,0.6l1.65,-0.04l2.49,-0.83l1.28,-1.04l2.07,-2.81l2.26,-4.79l0.53,-4.59l-2.97,-3.03l-4.15,0.72l-1.61,-0.22l0.15,-1.52l0.84,-2.23l0.69,-4.5l0.77,-1.77l1.18,-1.02l1.53,-0.5l3.96,-0.16l1.71,0.64l3.93,4.81l4.05,1.68l8.34,1.33l3.5,1.38l0.0,0.51l-2.23,1.57l-2.16,2.13l-1.7,3.11l-0.6,3.95l0.12,7.57l0.62,3.43l1.33,2.46l0.43,0.2l0.32,-0.36l0.29,-3.39l-1.03,-8.32l0.08,-3.82l1.4,-2.72l4.03,-2.71l1.35,2.04l0.82,0.41l0.67,-0.14l0.87,1.2l0.75,0.15l2.39,-1.76l1.52,-1.93l0.36,-1.37l0.0,-1.94l-0.66,-2.81l-1.46,-3.59l1.02,-1.68l0.0,-0.68l-0.94,-0.41l-3.99,0.14l-2.08,-0.3l-4.64,-1.39l-1.09,-3.47l-1.37,-3.0l-0.3,-2.13l0.21,-2.17l0.58,-1.91l3.68,-7.48l2.6,-8.07l1.65,-3.52l1.35,-1.64l1.85,-1.44l2.09,-1.01l2.12,-0.4l1.94,0.11l1.04,0.37l2.4,2.2l3.55,2.43l3.79,1.59l7.76,1.55l4.28,-0.11l7.08,-1.43l3.88,0.25l2.06,-1.78l7.65,-1.52l7.72,0.06l1.68,-0.91l1.28,0.74l1.61,0.24l3.29,-0.12l2.8,2.62l9.59,13.75l3.95,3.77l2.77,1.85l1.26,1.32l1.39,4.1l6.74,8.07l1.67,1.23l5.35,1.36l5.81,3.25l6.45,1.19l0.53,5.24l0.83,0.75l0.54,1.1l1.04,0.79l1.06,2.44l1.22,1.71l4.04,3.28l1.17,-0.02l1.34,-1.59l1.38,-0.43l0.72,0.77l0.36,2.98l0.47,0.57l1.03,0.08l2.4,-0.92l2.11,1.06l0.92,0.1l3.61,-1.01l1.68,-0.82l0.46,-0.52l0.05,-1.32l4.58,-1.24l2.69,2.2l2.0,0.47l2.17,2.24l1.6,0.94l1.86,0.35l5.4,-0.3l2.63,-2.81l1.7,-0.67l6.27,0.08l3.44,1.07l13.9,6.86l4.11,1.16l3.3,-1.05l7.18,-0.24l3.19,0.68l1.97,2.0l0.29,3.96l0.69,2.03l1.7,0.76l1.8,0.34l3.11,3.24l3.13,2.07l8.94,4.23l10.75,8.24l4.89,2.99l1.4,-0.58l0.98,-0.99l3.25,-2.19l1.04,-0.13l0.63,0.31l3.15,4.06l0.99,-0.04l1.99,-1.5l1.34,1.35l1.51,0.74l3.41,4.98l3.6,3.47l1.72,0.88l2.23,0.35l1.97,-0.42l3.25,-1.84l1.92,-0.36l2.08,0.54l2.99,2.5l4.12,0.82l4.35,1.42l-1.68,3.84l-0.77,0.46l-2.47,-0.34l-1.12,0.2l-1.04,0.89l-0.56,1.38l-0.56,3.09l0.53,3.24l-2.91,0.34l-5.93,4.56l-3.45,0.76l-5.91,2.07l-3.37,-0.06l-1.5,0.92l-0.84,0.15l-1.33,-1.47l-1.3,-0.46l-1.27,-0.93l-4.82,-0.73l-5.72,0.35l-2.46,-0.91l-2.96,-0.63l-3.66,0.05l-1.29,0.44l-0.55,0.51l-0.87,3.09l-1.82,1.17l-0.98,1.06l-1.75,0.76l-5.41,1.56l-4.22,-0.17l-4.63,0.28l-3.37,1.07l-0.53,0.57l0.1,1.29l-0.37,1.23l0.33,2.15l-0.3,2.12l1.73,3.36l1.89,1.78l0.78,3.5l1.13,0.95l1.14,0.05l1.28,0.66l4.69,7.75l4.3,4.98l0.94,0.24l2.18,-1.25l1.53,0.6l-0.19,0.62l-2.61,2.68l-0.2,3.61l0.79,2.52l1.27,1.25l3.25,4.51l-2.52,-0.34l-2.02,0.75l-1.23,2.54l-0.26,2.01l7.18,8.09l1.1,0.74l1.63,0.46l2.76,1.91l0.46,0.76l-0.67,1.99l-5.37,0.98l-1.02,0.57l-0.16,0.6l0.42,1.71l1.99,1.01l0.29,0.99l0.68,0.86l-1.72,1.63l-0.06,1.01l2.97,3.43l1.55,0.07l0.12,1.84l0.44,0.57l0.57,-0.08l0.71,-0.9l0.41,0.68l0.05,1.57l-0.5,0.99l-4.02,1.27l-0.93,0.84l-0.85,1.67l-0.1,1.23l0.83,1.31l2.6,1.13l0.31,1.8l-0.86,1.53l-3.27,2.63l-1.99,0.93l-3.46,0.91l-1.05,0.78l0.03,1.25l1.94,1.35l0.02,1.63l-0.49,0.91l-6.4,0.12l-2.04,0.26l-2.48,0.82l-12.98,0.0l-5.61,0.73l-1.14,0.51l-0.11,1.63l-2.74,2.39l-1.03,0.26l-2.99,-0.26l-1.25,0.79l0.09,0.97l1.68,2.07l0.45,1.4l2.39,0.99l1.4,1.33l0.88,0.11l-1.44,0.6l-0.63,0.61l-0.61,2.7l0.4,0.91l1.85,1.1l0.42,3.24l-1.01,1.48l-1.41,0.7l-0.96,1.26l-2.27,1.25l-0.47,5.79l0.76,3.7l1.88,1.76l1.54,0.91l0.81,2.15l1.56,2.58l1.95,1.85l0.47,1.72l0.05,3.22l2.55,3.87l-4.37,2.1l-1.93,1.89l-0.17,1.13l2.41,2.9l-0.28,1.58l-0.66,-0.13l-1.34,-1.22l-0.91,-0.14l-5.99,2.2l-4.05,0.05l-3.45,-2.38l-4.79,-2.12l-1.12,-0.13l-4.61,0.8l-0.33,0.78l0.52,1.1l-0.13,0.92l-1.26,3.01l-2.25,1.73l-0.56,0.95l-3.3,1.84l-0.96,2.03l-5.65,2.71l-1.08,-0.06l-1.01,-1.16l-2.25,0.27l-0.95,0.96l-0.19,0.79l0.23,0.63l-0.88,1.42l-2.15,0.83l-0.44,0.51l0.07,0.79l-4.27,-0.14l-1.56,0.26l-1.43,1.41l-2.09,-1.47l-0.61,-0.1l-1.18,1.11l-2.01,0.97l-1.17,1.15l-4.75,3.28l-3.87,-2.56l-0.25,-1.82l-1.11,-0.36l-1.26,1.02l-1.8,0.12l-0.56,0.44l0.01,1.23l1.21,2.13l-1.09,1.14l-0.79,-0.44l-1.69,-2.82l-2.48,-1.28l-1.37,-0.18l-0.39,0.67l0.45,1.17l-0.62,0.54l-2.41,0.65l-5.53,3.1l-0.02,0.88l0.65,1.14l3.25,2.63l0.78,0.04l1.49,-1.24l0.85,0.04l-1.09,1.29l-0.31,1.41l-4.09,3.01l-1.1,-0.09l-2.86,-3.04l-1.29,-0.6l-1.4,-0.02l-8.42,-2.95l-2.76,-2.13l1.84,0.52l1.0,-0.1l0.41,-0.79l-0.87,-2.39l1.42,-1.62l1.48,0.17l3.54,-0.51l0.61,-0.48l0.32,-0.8l-0.35,-3.43l0.22,-1.72l-0.67,-1.45l0.79,-1.08l-0.0,-0.55l-2.2,-1.92l-2.03,-4.2l1.15,-0.18l0.53,-0.45l0.52,-3.49l1.48,0.51l1.18,-0.55l-0.94,-1.81l0.05,-0.77l3.23,1.7l0.81,-0.37l0.85,-1.46l-0.08,-0.5l-1.86,-1.65l-1.21,-3.05l-0.5,-0.51l-1.86,-0.75l-0.72,-1.56l-0.56,-0.31l-3.39,0.67l-1.85,-0.52l-0.82,-1.0l-0.88,-0.35l-2.24,1.51l-2.53,-0.16l-0.61,-0.59l-0.1,-1.76l-1.06,-0.89l-1.84,0.04l-1.55,1.24l-0.93,-0.53l-4.49,1.16l-1.27,-0.04l-0.33,-0.6l0.14,-2.05l1.1,-0.82l0.42,-0.92l-0.26,-1.61l0.62,-1.44l-0.35,-2.27l0.09,-1.97l0.97,-1.1l0.45,-1.29l1.54,-0.82l1.19,-1.09l1.83,-4.09l0.1,-3.07l0.87,-1.01l-0.0,-0.49l-2.09,-1.12l1.52,-1.85l0.52,-1.31l-0.12,-0.43l-0.96,-0.45l-2.14,0.73l-2.17,0.28l-4.42,-0.14l-3.68,0.78l1.21,-2.96l0.24,-1.56l-0.82,-2.63l-0.65,-0.77l-2.46,-0.96l-3.71,0.26l1.38,-1.61l1.11,-3.64l-0.01,-1.25l-4.14,-1.68l-1.96,0.4l-0.87,1.33l-4.09,-1.65l0.35,-1.29l1.55,-1.13l0.61,-1.57l-2.17,-5.31l1.26,-2.23l-0.13,-1.54l-1.36,-1.61l-2.66,-0.94l-0.67,-0.58l0.56,-2.1l-0.42,-0.74l-0.99,-0.53l-7.02,-0.81l-3.33,0.12l-2.84,0.49l0.93,-1.56l0.05,-1.05l-1.75,-3.98l2.55,-0.61l2.71,-0.03l0.42,-0.72l-0.88,-2.83l0.24,-0.48l3.03,-2.05l-0.37,-0.75l-2.65,-0.59l-5.42,-1.94l-0.31,-0.92l1.2,-6.89l1.09,-1.98l3.88,-0.02l2.7,-1.32l2.14,-3.59l3.22,-4.3l-1.8,-5.79l1.98,-1.61l0.46,-1.66l-0.36,-0.48l-1.9,-0.68l-1.64,-1.87l-1.76,-0.31l-5.64,2.47l-3.2,2.9l-2.43,5.57l-0.6,0.76l-6.47,1.19l-3.46,1.17l-3.1,0.29l-11.05,-1.16l-0.34,-1.5l0.39,-2.62l-0.58,-1.49l0.25,-2.87l-0.36,-2.11l-2.87,-4.32l-1.71,-1.2l-1.77,-0.58l-1.21,0.05l-4.82,1.94l-1.5,0.25l-4.82,-0.13l-2.27,0.32l-3.29,2.31l-1.15,4.18l-0.92,0.77l-1.62,0.63l-5.46,0.59l-1.93,-0.59l-2.26,-0.0l-2.14,-0.66l-0.49,0.52l1.95,5.39l1.3,1.69l6.51,2.58l2.76,1.65l1.18,1.57l0.83,2.02l1.01,4.38l0.09,11.88l0.43,1.49l3.2,1.97l-0.55,1.26l-1.48,1.81l-4.92,2.75l-0.82,1.03l-1.0,2.34l-0.51,0.29l-0.57,0.12l-12.68,-2.85l-3.2,2.34l-2.29,2.56l-2.84,1.69l-6.78,2.13l-3.58,-1.05l-3.66,0.55l-1.61,0.66l-4.65,3.55l-2.3,-1.12l-3.31,-1.03l-1.95,-4.25l0.09,-0.44l1.01,-0.92l1.66,-1.09l2.38,-0.91l4.44,-0.76l1.34,-3.69l1.36,-2.54l-0.13,-1.03l-2.75,-1.05l-4.25,0.24l-0.58,-0.37l-0.63,-1.57l-2.6,-0.46l-0.47,-0.59l1.57,-1.68l0.83,-1.43l0.02,-0.69l-0.9,-1.99l2.07,-1.89l0.88,-1.35l-0.05,-0.6l-1.31,-1.82l-0.28,-1.23l3.7,-0.71l0.46,-0.33l0.02,-0.85l-3.03,-4.39l-3.79,-4.04l-1.29,-0.17l-6.88,2.01l-1.96,-1.62l-6.64,-3.45l-2.38,-0.72l-0.49,-0.57l-1.06,-5.25l-0.47,-0.81l-0.94,-0.61l-7.02,-1.79l-1.14,0.23l-0.82,1.0l-1.19,4.42l0.45,1.23l1.48,1.15l-1.05,0.79l-1.37,3.44l-1.33,1.45l-2.55,-0.26l-2.1,0.49l-4.64,3.18l-4.97,4.25l-1.66,0.81l-3.05,0.66l-6.57,4.03l-3.97,0.72l-13.48,0.46l-2.82,1.87l-3.94,1.38l-2.32,-0.08ZM267.32,254.66l3.32,0.02l0.42,0.3l1.31,2.15l0.22,2.67l0.49,1.35l1.59,1.98l4.61,4.16l0.05,4.06l0.58,0.68l1.55,0.22l5.01,-0.89l5.07,2.57l2.07,0.29l2.05,-0.57l0.52,-1.0l4.53,2.68l4.27,-2.41l1.66,-1.57l0.62,-3.85l1.06,-1.85l-0.49,-1.03l-2.34,-2.04l-0.27,-0.6l1.56,-1.38l0.07,-0.82l-3.71,-3.45l-0.75,-0.19l-0.77,0.38l-1.49,2.82l-1.38,0.03l-3.32,-1.36l-3.71,-2.54l-4.35,-0.27l-2.53,-1.4l-0.19,-0.99l-0.64,-0.48l-3.51,-0.02l-1.93,0.44l-6.98,-2.15l-2.86,-1.43l-2.49,0.47l-3.4,-1.71l-1.19,-0.2l-2.22,0.28l-0.3,0.59l1.66,3.23l4.26,1.53l2.28,1.29ZM227.51,180.96l-1.99,1.47l-1.87,-0.53l-0.68,0.29l1.08,-1.64l1.72,-0.61l2.03,0.27l0.75,0.44l-1.04,0.33ZM203.67,172.73l0.94,0.46l-4.32,-0.76l-1.77,0.08l-0.38,0.36l-0.09,0.99l-1.02,-0.6l0.18,-0.36l1.55,-0.47l1.98,-0.18l2.93,0.48ZM191.01,174.13l-5.02,2.07l-2.65,0.13l-2.31,-1.24l-0.49,0.09l-1.57,1.43l-0.87,-0.22l2.08,-2.12l3.95,-0.72l7.87,0.44l-1.0,0.13ZM173.77,177.67l-7.37,-0.07l-3.4,0.67l-0.32,0.35l-0.23,2.01l-2.39,0.1l-0.64,-0.46l-0.29,-1.55l0.41,-1.29l0.99,-0.5l11.55,-0.15l1.69,0.9ZM150.2,180.57l2.02,-0.32l1.74,0.31l0.88,0.58l-0.86,0.38l-3.78,-0.95ZM146.19,181.41l-4.62,1.49l-11.88,1.28l-2.78,-0.63l3.4,-1.62l5.2,-0.71l10.68,0.19ZM118.67,186.33l-15.74,1.45l1.05,-0.42l13.24,-1.39l1.45,0.37ZM104.4,192.52l-2.3,2.1l-1.24,-0.42l-1.0,-0.75l0.02,-1.31l0.81,-0.46l1.59,0.01l2.12,0.83ZM86.49,201.05l-1.79,-0.07l-1.97,0.75l-1.55,-0.63l-1.22,-1.42l-0.29,-1.2l0.84,-0.53l7.38,-1.84l3.39,-0.21l0.85,1.36l-1.66,0.21l-5.17,1.55l-0.32,0.39l0.0,0.82l0.28,0.38l1.22,0.43ZM87.0,201.35l0.07,0.04l0.19,0.21l-0.26,-0.25Z",name:"Niedersachsen"},"DE-MV":{path:"M481.88,178.09l1.27,-5.8l-0.83,-3.75l-1.13,-2.45l0.29,-1.56l0.83,-1.66l4.68,-2.26l4.85,-3.67l2.24,-1.2l1.72,0.43l-0.12,1.14l0.99,0.72l3.24,-0.41l1.7,-0.93l0.16,-0.56l-0.33,-0.33l-3.9,-1.01l-0.81,-0.48l-0.52,-0.73l0.03,-3.3l1.59,-0.26l4.11,-3.22l3.45,-0.82l5.17,-2.25l11.79,-1.27l0.68,0.21l0.55,0.62l0.61,1.82l0.75,1.05l3.59,0.9l0.34,0.43l-0.43,2.9l0.44,1.82l1.39,0.62l3.84,-0.01l3.92,-2.68l0.43,0.23l0.95,1.8l0.72,0.58l3.97,0.08l3.88,4.15l1.03,0.52l1.12,0.0l0.4,-0.36l0.12,-1.35l1.74,-4.84l-0.39,-2.18l0.58,-0.78l1.57,-0.67l0.3,-0.51l-0.53,-2.5l3.15,-2.59l0.06,-1.4l2.37,0.48l2.19,-1.25l1.85,-3.64l2.07,-0.97l1.22,-1.54l0.55,-1.83l-0.73,-0.73l0.25,-0.95l3.14,-4.29l2.97,-1.67l3.7,-0.43l8.27,1.17l23.4,-4.06l3.29,-1.69l0.42,3.25l-0.36,3.7l0.21,3.25l2.42,2.44l0.52,0.02l0.1,-0.51l-0.91,-1.57l-0.48,-3.42l-0.47,-1.21l0.85,-1.3l2.72,-1.25l1.04,-2.02l-0.33,-0.57l-1.1,-0.09l-1.94,0.39l3.27,-3.47l2.05,-1.51l2.28,-3.09l9.96,-4.23l3.84,-2.6l1.52,-1.45l3.52,-5.52l1.05,-1.22l-0.59,1.13l0.6,1.49l-0.41,1.37l-1.07,1.02l-1.5,0.28l-0.3,0.53l1.67,4.2l-0.96,0.92l0.08,0.64l4.28,2.4l2.76,0.51l2.1,-1.06l0.21,-0.46l-0.4,-0.3l-1.44,0.05l-1.04,-0.41l-1.72,-1.22l0.5,-1.24l0.86,-1.09l2.41,-1.89l2.2,-1.01l0.58,-2.84l1.52,-1.04l6.33,-2.46l0.06,-0.72l-1.75,-0.91l0.0,-0.3l1.47,-0.44l1.21,0.48l0.61,-0.48l1.52,0.93l3.01,-0.65l5.35,-2.46l0.19,-0.54l-0.53,-1.6l1.75,-0.75l1.13,-0.12l0.84,0.07l0.0,0.31l-1.37,0.36l-1.07,1.21l-0.6,1.63l-0.24,1.69l0.25,0.43l0.47,-0.14l1.82,-3.02l1.44,1.83l1.27,0.53l1.27,-0.9l0.88,0.63l1.3,0.04l1.61,-1.19l1.23,2.28l2.15,2.08l3.54,-0.17l1.13,-0.3l1.19,-0.87l2.71,-4.6l2.43,-1.94l3.83,-2.0l3.76,-1.13l1.58,0.38l-0.75,0.77l-0.02,1.78l0.74,1.72l1.22,1.43l4.35,1.86l0.83,0.64l-1.7,2.66l0.47,2.25l2.74,3.57l0.27,2.86l0.51,1.42l1.24,0.49l3.99,0.0l-2.46,1.08l-0.2,0.46l0.41,0.29l3.11,-0.24l5.03,2.31l3.47,0.68l2.36,1.04l3.17,5.26l2.26,1.65l-2.2,1.58l-0.12,0.44l0.38,0.26l2.45,-0.02l3.67,-1.49l1.35,0.42l-0.96,1.68l-0.73,0.52l0.06,0.68l1.5,0.58l1.28,-0.7l0.58,0.13l3.09,5.62l1.6,1.75l2.0,1.01l2.31,0.03l0.41,-0.4l-0.16,-1.24l-2.58,-2.64l0.0,-0.38l11.86,-1.89l2.96,-1.11l4.97,-2.74l2.47,-0.67l0.11,0.58l-1.67,0.89l0.25,1.2l2.96,1.24l7.58,5.14l0.0,0.58l-1.4,1.99l-0.8,2.57l-1.13,2.22l-2.54,1.27l-0.03,0.7l1.14,0.71l3.92,4.35l3.93,1.64l0.96,2.37l0.13,1.83l0.62,0.29l1.32,-0.1l3.52,1.43l0.11,0.95l-0.54,1.35l-1.02,1.17l-7.11,4.79l-1.03,2.12l1.08,1.82l4.32,1.47l0.64,1.45l1.44,1.69l1.65,1.21l1.2,-0.08l7.09,4.81l3.28,0.64l2.2,1.94l2.93,-0.02l3.77,1.62l7.89,0.48l2.88,-0.69l1.36,-1.95l0.53,-0.3l1.33,0.21l1.2,0.95l0.24,1.85l-0.62,0.81l-4.53,2.63l0.03,0.71l2.74,1.01l2.06,0.16l0.11,3.31l-0.35,2.31l1.47,2.6l2.03,5.14l-0.01,9.18l0.78,2.91l2.34,2.95l1.05,2.83l2.0,2.75l1.02,6.87l1.97,7.47l-6.36,3.2l-2.8,2.92l-2.51,1.0l-0.8,1.97l-1.14,0.69l-6.32,-0.5l-7.49,-1.23l0.07,-1.99l8.07,-4.44l3.64,-4.68l1.56,-2.97l0.5,-2.61l-0.15,-3.62l-0.33,-0.38l-2.38,-0.42l-4.03,0.2l-3.65,-1.45l-2.68,0.55l-1.84,2.12l-4.36,-1.07l-5.89,-0.35l-6.67,0.4l-1.35,-1.65l-0.55,-1.85l-2.78,-4.12l-0.15,-2.8l-0.28,-0.36l-4.46,-1.42l-2.37,-3.03l-1.95,-0.36l-0.45,0.37l-0.11,2.73l2.43,3.71l0.34,1.25l-2.47,0.89l-3.35,-0.2l-3.69,0.49l-5.95,4.16l-1.9,2.75l-2.07,1.57l-3.36,0.12l-2.06,0.87l-1.49,1.2l-0.78,1.6l-0.52,2.46l-3.14,6.23l-2.25,2.12l-1.08,0.32l-5.11,3.37l-1.58,0.46l-1.65,-0.34l-4.03,-1.74l-2.16,-0.35l-2.69,0.23l-1.67,0.7l-1.73,1.64l-1.31,2.48l-0.54,2.42l-2.37,0.0l-1.05,-0.39l-2.24,-2.7l-1.49,-0.38l-0.95,0.24l-3.38,2.33l-0.75,1.93l-0.63,0.7l-5.62,3.47l-3.89,3.57l-2.31,0.33l-2.6,-1.06l1.35,-1.58l-0.23,-0.9l-0.71,-0.49l-2.07,0.58l-2.65,0.02l-3.83,0.71l-1.26,-0.27l-1.45,-0.99l-1.48,-0.42l-1.47,-0.08l-4.28,0.77l-1.03,-0.09l-0.84,-0.76l-0.44,-3.33l-1.02,-0.5l-2.4,-0.1l-3.98,-0.9l-2.57,-2.14l-1.45,-0.6l-11.0,-2.21l-3.17,0.63l-3.42,0.2l-1.36,-0.24l-1.39,-1.6l-2.87,-1.35l-1.69,-1.51l-3.01,-1.91l-4.27,-2.04l-6.72,-1.48l-2.18,-3.07l-1.48,-0.52l-1.36,0.31l-2.9,1.65l-1.67,-1.38l-0.83,-0.27l-2.73,0.44l-3.4,1.19l-1.37,2.07l-2.51,1.41l-0.35,2.12l-0.8,1.81l-1.46,0.23l-3.54,2.59l-1.86,-0.59l-5.53,1.92l-2.27,2.22l-2.68,-0.5l-1.8,0.75l-0.04,0.69l1.83,1.19l0.2,1.19l-4.83,-0.16l-3.84,1.51l-1.16,-2.07l-3.11,-2.09l-1.4,-0.41l-3.47,0.18l-5.42,1.68l-1.98,1.07l-4.34,3.27l-0.73,1.46l0.23,1.27l1.3,1.5l0.92,3.96l-0.59,1.85l-1.78,1.11l-2.39,0.19l-5.25,-2.44l-3.37,-0.04l-1.92,0.94l-0.43,2.95l-1.38,-0.16l-2.38,-0.84l-3.17,0.0l-2.36,-0.41l-1.94,0.19l-1.7,-2.33l-1.63,-0.83l-1.49,-1.47l-0.43,-0.03l-2.56,1.58l-2.84,-3.85l-0.96,-0.51l-1.64,0.19l-5.08,3.67l-4.62,-2.83l-10.76,-8.25l-8.97,-4.25l-3.06,-2.02l-3.18,-3.29l-3.42,-1.07l-0.41,-1.54l-0.3,-4.04l-2.26,-2.41l-3.66,-0.83l-6.36,0.22l1.87,-2.81l0.96,-6.46l0.4,-0.57l2.56,-1.02l2.21,0.2l0.63,-0.57l0.84,-2.19l5.35,-1.32l6.28,-3.89l0.24,-2.17l0.93,-2.22l-0.43,-2.79l0.74,-0.1l1.67,0.49l5.12,-0.46l0.7,0.9l0.38,1.6l0.94,0.58l1.03,-0.62l1.68,-1.92l-0.45,-0.76l0.36,-0.4l-0.03,-1.53l-1.19,-3.64l-0.06,-1.97l1.42,-1.15l0.2,-2.07l-1.01,-2.08l-0.06,-1.48l-0.36,-0.71l-1.78,-1.65l-1.19,-0.66l-2.83,-0.7l-2.05,0.25l-0.63,-0.29l-5.03,-5.16l-4.54,-0.84ZM642.03,96.75l2.68,-3.13l-0.63,2.04l0.39,1.75l-1.9,-0.76l-0.53,0.09ZM646.29,91.77l5.12,-7.49l1.57,-3.56l1.02,-1.06l0.94,-0.38l-0.15,0.3l2.09,2.72l4.42,1.54l22.39,0.02l3.61,1.41l2.46,-1.0l2.55,0.51l0.89,1.08l-2.02,1.51l-2.37,0.42l-10.42,-0.72l-4.15,-1.26l-2.84,-0.27l-0.94,0.39l-1.41,1.42l-4.37,-0.38l-1.18,0.46l-0.54,1.22l-0.68,-0.41l-1.93,0.97l-0.31,0.45l0.18,1.16l0.46,0.67l-0.88,-0.33l-2.27,0.21l-1.77,0.96l-0.78,1.25l-1.36,-1.34l-2.06,-0.82l-3.55,-0.27l-1.75,0.64ZM798.18,135.23l2.91,1.47l17.21,15.3l1.48,0.9l-1.46,3.17l-1.53,0.57l-0.19,0.67l1.65,1.65l0.58,1.53l-10.57,0.99l-2.07,-0.25l-1.58,-0.9l-0.47,0.05l-2.24,2.05l-2.77,1.31l-5.55,1.2l-6.12,0.08l-3.28,-0.8l-1.29,-1.44l2.73,-1.47l3.19,-0.58l3.4,-1.59l1.13,-1.09l0.66,-4.18l-3.57,-5.48l0.22,-2.93l4.5,0.22l1.2,0.4l-0.38,0.56l0.15,0.98l-0.76,2.6l-0.13,2.14l0.27,0.4l0.46,-0.15l1.47,-2.12l1.08,-0.47l2.68,0.0l-0.52,1.44l0.29,0.47l3.34,0.84l0.46,-0.55l-0.72,-1.6l1.22,-3.31l-0.18,-3.59l-1.42,-2.43l-0.47,-0.17l-1.9,0.64l-1.77,-3.7l-1.46,-1.56l-1.7,-1.06l-1.94,-0.38l-2.1,0.34l-1.22,1.15l0.76,2.71l-1.6,1.17l-1.07,2.06l-0.41,0.19l-2.81,0.86l0.13,-1.11l1.42,-1.77l0.37,-1.03l-0.51,-1.88l-1.02,-0.45l-4.22,1.64l-2.77,2.59l-1.39,-0.44l0.66,-2.18l2.64,-4.4l0.59,-3.89l-0.97,-2.23l-3.98,-3.38l-1.02,-1.27l0.73,-1.23l1.4,-1.19l1.62,-0.51l1.59,0.54l2.75,5.55l1.2,1.8l2.68,2.23l6.55,3.11l3.73,1.16ZM717.1,70.94l0.86,-0.33l7.41,-0.88l1.4,0.26l0.65,0.83l2.08,0.95l0.91,2.64l0.59,0.17l0.92,-0.75l0.37,-1.54l-0.73,-2.11l2.98,-2.84l2.59,-1.34l-0.78,1.96l-1.6,2.28l1.38,0.3l0.56,0.55l-1.27,2.45l0.34,0.57l1.55,0.06l1.3,-0.43l0.97,-0.99l0.59,-1.5l-0.15,-0.28l2.04,2.68l-0.5,2.26l1.94,2.26l2.76,0.85l5.06,-0.1l0.32,-0.63l-0.58,-0.81l0.81,-1.53l1.19,-1.21l0.0,-1.0l-0.82,-2.08l-1.25,-1.71l0.0,-0.53l2.07,-1.24l0.0,-0.83l-0.42,-0.4l-1.44,0.13l-2.04,1.73l-4.14,-0.01l-1.71,-2.32l-2.38,-0.69l-2.79,-4.19l-0.59,-0.19l-2.12,1.56l-1.57,1.74l-2.23,1.09l-3.33,2.46l-1.56,-0.4l-0.27,-1.27l0.66,-2.36l1.21,-2.17l1.43,-1.1l0.74,-1.91l0.19,-1.57l-0.73,-0.79l-4.39,0.92l-1.58,0.74l0.04,-1.14l0.47,-0.77l2.06,-1.48l13.37,-3.12l2.61,-0.03l2.27,0.99l0.0,0.36l-5.15,3.06l-0.91,2.1l0.3,2.72l0.9,2.03l1.37,1.57l1.77,1.18l4.26,1.13l12.66,-1.96l4.19,0.74l2.78,2.47l0.59,3.18l-2.4,3.07l-4.28,2.3l-2.21,1.72l-1.07,2.36l0.38,2.35l0.86,2.37l2.2,3.34l2.24,0.98l4.58,0.9l1.91,1.1l2.56,3.78l1.72,1.82l1.71,0.59l-1.88,1.65l-1.04,1.84l-0.61,4.97l-1.03,-0.15l0.56,-0.37l0.42,-1.18l-0.4,-1.44l-0.39,-0.29l-0.93,0.1l-0.94,0.82l-1.37,0.42l-1.45,0.02l-0.87,-0.32l0.0,-0.35l3.37,-1.17l1.59,-1.01l0.95,-1.69l-0.38,-0.59l-4.86,0.27l2.95,-1.26l0.27,-0.38l0.0,-0.92l-0.37,-0.4l-2.64,-0.2l-1.61,0.16l-2.18,1.69l-1.33,-1.1l-1.32,-0.55l-9.78,0.92l-1.95,0.97l-5.19,3.7l-2.26,3.44l-2.3,0.4l-2.4,1.24l-0.38,3.61l0.62,0.37l1.34,-0.92l0.17,-1.07l4.01,-0.37l0.65,2.8l-0.16,1.11l-1.24,0.49l-2.67,-0.34l-3.04,-0.87l-2.94,-1.56l0.47,-0.5l1.52,-3.61l-0.08,-0.46l-0.46,-0.08l-1.52,0.75l-1.29,1.29l0.11,0.63l-2.2,0.09l-1.51,0.81l-2.31,-1.61l-3.15,-0.9l-0.85,-0.92l0.48,-1.51l-0.29,-0.51l-1.67,-0.33l-3.63,1.23l-0.4,-0.62l0.38,-0.57l1.05,-0.32l1.37,0.46l0.53,-0.38l0.0,-0.85l-5.97,-3.92l1.18,-2.54l1.83,-2.27l2.22,-0.81l2.84,1.5l0.51,-0.12l0.43,-0.59l1.12,0.72l1.49,-0.24l2.92,-1.61l0.2,-0.43l-0.36,-0.32l-1.42,-0.13l-0.98,-0.77l-0.39,-1.08l0.43,-2.25l-0.37,-0.4l-1.21,-0.09l-1.21,-1.26l-1.17,-0.47l-3.67,0.72l1.81,-2.6l2.61,-0.53l2.92,-1.24l1.96,-0.29l0.34,-0.4l0.0,-0.64l1.22,-0.93l-0.17,-0.66l-3.75,-1.4l-0.54,-0.84l0.67,-0.9l-0.06,-1.13l-0.52,-0.34l-2.85,0.91l-1.55,0.14l-1.67,-1.29l-0.34,-2.16l-0.75,-0.98ZM739.74,70.67l-2.16,-0.9l0.0,-0.41l0.82,-0.62l1.34,1.93ZM708.19,76.74l0.04,-0.44l3.06,-8.86l0.66,-3.4l0.57,-0.76l1.43,-0.3l2.19,0.07l0.42,1.09l-0.55,0.2l0.0,-0.75l-0.62,-0.33l-2.57,1.82l-0.58,2.3l-0.09,2.57l-0.9,2.68l-2.11,1.75l-0.95,2.35ZM557.96,136.39l-0.46,-2.08l0.42,-0.96l5.48,-2.14l-4.16,3.09l-1.28,2.09ZM553.57,141.62l-2.73,6.57l-0.88,1.07l-0.66,0.02l0.62,-2.98l-0.43,-1.56l-0.38,-0.29l-1.19,0.21l-0.56,1.41l0.38,1.58l-1.1,0.75l-1.36,-0.06l-2.68,-1.57l1.26,-2.66l3.41,-2.37l3.87,-1.03l2.42,0.91Z",name:"Mecklenburg-Vorpommern"},"DE-TH":{path:"M402.19,500.97l-0.34,-2.77l-0.3,-0.79l-0.99,-0.96l-0.56,-2.07l0.55,-1.65l6.77,-4.71l1.13,-1.12l2.04,-0.99l0.85,-0.94l2.62,1.57l0.6,-0.21l1.05,-1.24l1.28,-0.22l4.86,0.16l0.38,-0.56l-0.28,-0.79l1.43,-0.39l1.04,-0.73l0.98,-1.6l-0.07,-1.35l0.65,-0.63l1.64,-0.18l0.79,1.07l1.57,0.18l6.05,-2.87l1.05,-2.11l3.21,-1.76l0.66,-1.04l1.54,-0.93l0.78,-0.87l1.55,-4.04l-0.52,-1.57l4.31,-0.69l0.76,0.13l4.61,2.05l3.63,2.45l4.38,-0.05l5.91,-2.19l0.4,0.03l1.34,1.21l1.03,0.34l0.96,-0.74l0.27,-1.47l-0.34,-0.93l-2.2,-2.53l0.14,-0.48l1.6,-1.55l4.54,-2.19l1.57,0.77l8.78,-0.19l4.35,1.9l2.91,0.08l1.24,1.0l3.26,1.13l1.32,0.05l0.57,0.58l0.58,1.96l-0.87,0.4l-1.43,-0.5l-1.0,0.14l-0.62,0.69l0.01,0.96l1.46,3.53l1.96,2.16l-0.13,3.01l1.55,2.97l1.0,1.28l-0.69,4.97l1.02,1.61l2.73,1.27l15.19,1.55l4.18,-0.07l9.05,1.11l2.46,0.7l5.01,3.28l2.66,4.18l5.47,6.78l-1.54,2.38l-1.08,0.84l-2.39,1.13l-4.99,0.81l-1.09,1.07l-0.46,1.08l1.3,1.73l2.21,1.21l2.1,0.68l2.95,3.75l0.58,1.98l0.11,1.7l-0.76,0.33l-0.32,0.76l0.72,2.5l1.11,1.21l1.82,0.66l5.38,0.23l3.04,-1.43l4.46,0.52l4.62,0.07l3.81,-0.66l2.3,1.43l0.38,3.14l2.26,3.58l0.55,1.81l1.51,1.17l1.05,0.21l1.16,-0.75l8.67,-0.64l1.0,0.16l2.15,1.36l4.75,1.79l1.31,1.02l1.12,2.12l3.5,1.74l0.3,1.17l0.5,0.32l4.04,-0.32l2.76,-0.57l5.71,1.52l2.69,-1.18l2.88,2.04l0.67,1.03l1.11,0.24l2.04,-1.3l-0.04,-2.32l3.36,-3.56l2.39,-3.77l0.0,-1.02l-0.57,-1.06l-2.48,-1.48l0.46,-2.42l1.68,-2.53l-0.08,-0.8l5.81,-0.49l14.88,3.75l0.76,3.76l3.0,4.34l1.01,1.97l1.5,1.27l5.45,2.39l2.27,2.99l2.01,3.61l-0.01,0.58l-1.47,0.71l-1.8,2.03l-1.16,-0.94l-1.6,0.27l-3.12,-0.36l-2.17,0.21l-1.81,-0.61l-0.53,0.3l-0.51,1.26l-3.79,1.75l-3.72,4.11l-1.56,-0.62l-3.6,0.37l-3.95,2.55l-7.1,1.78l-0.3,0.35l0.0,1.64l1.2,1.13l1.63,0.6l0.19,0.36l-1.43,1.5l-1.21,0.18l-1.11,0.78l-1.02,2.57l0.45,0.77l1.65,-0.12l0.77,0.47l-0.39,2.08l0.66,1.89l0.83,1.11l1.25,0.51l2.56,0.08l-1.69,2.45l-1.06,0.98l-3.48,2.13l-2.33,0.11l-1.91,-0.31l-2.41,0.29l-2.8,2.95l0.04,2.82l-0.63,1.84l-0.58,0.56l-2.5,0.69l-1.98,-0.8l-1.73,0.25l-2.42,3.17l-0.87,0.66l-1.37,-0.15l-1.26,-1.39l-0.83,-0.39l-1.1,-0.22l-1.39,0.41l-2.02,2.36l-2.37,1.54l-1.75,2.54l-0.15,1.46l1.69,1.39l0.34,0.72l0.04,0.98l-1.0,1.15l-0.21,1.27l-2.17,0.76l-1.15,0.83l-0.38,1.07l0.56,0.9l-2.8,1.41l-4.3,1.44l0.13,-0.82l-0.29,-0.38l-1.85,-0.74l-0.87,-0.92l-1.28,-0.1l-2.37,0.36l-0.59,0.74l-1.51,0.38l-11.5,2.04l-2.9,-0.97l-2.23,-0.02l-0.59,0.29l-0.89,1.32l-2.68,0.4l-3.61,-2.17l-0.41,-3.07l-0.58,-0.88l-0.89,-0.36l-1.59,0.22l-2.97,-1.89l-0.23,-0.91l0.23,-4.07l1.39,-0.87l0.39,-0.74l-1.2,-2.34l-1.95,-0.62l-6.26,-0.29l-1.14,0.98l-1.37,0.65l-0.75,1.83l-1.9,1.04l-1.91,0.37l-2.72,1.1l-0.23,0.5l0.76,2.05l-0.2,0.97l0.79,2.65l-0.32,3.29l0.49,0.89l0.15,1.3l1.12,1.57l0.29,1.85l-1.11,0.62l0.16,1.51l-1.11,2.58l0.66,2.07l-1.03,2.08l0.1,1.55l-0.77,0.14l-2.12,-0.55l-1.66,-0.95l-0.7,0.37l-0.74,1.15l-4.43,-3.51l-0.53,-0.72l1.74,-1.68l0.17,-1.07l-1.9,-2.81l-0.85,-0.47l-0.79,-0.03l-0.44,-1.11l-0.51,-0.41l-1.68,0.2l-1.36,1.17l-3.38,0.82l-2.23,-1.68l-2.91,-0.35l-0.56,0.27l-0.37,1.38l-4.23,-4.7l-1.66,-0.09l-3.02,0.73l-1.15,-1.23l-1.0,-0.32l-1.56,0.61l-2.29,-0.2l-2.55,1.14l-1.97,-0.51l-1.29,0.82l-2.04,2.91l-2.43,-0.51l-1.13,0.6l-0.51,0.98l-0.29,3.91l0.92,1.07l2.66,1.32l1.94,1.68l2.96,0.17l1.26,1.79l2.78,0.9l0.48,1.34l-0.13,1.2l-0.37,0.4l-0.87,0.11l-2.93,-0.93l-4.01,0.63l-1.94,-0.58l-1.1,1.02l-0.69,4.16l-3.21,-1.63l-2.42,-0.56l-4.35,0.01l-1.01,-1.19l0.26,-1.78l-1.24,-2.29l0.56,-3.11l-0.96,-4.55l-2.51,-1.79l-1.27,-2.36l-0.4,-0.21l-1.63,0.19l-1.03,0.67l-2.44,-0.21l-0.35,-1.35l-2.71,-1.97l-1.63,-2.41l-2.71,0.46l-1.78,-0.14l-0.59,-0.35l-0.4,-0.87l0.92,-1.29l-0.27,-0.77l-2.71,-1.88l-1.71,-1.89l-1.39,-0.95l-0.29,-2.27l-0.56,-1.23l-0.59,-0.48l-9.35,-2.99l-1.01,-2.63l-1.92,-1.77l-1.6,-0.4l-5.19,0.34l-0.36,-0.42l-0.04,-1.3l-0.69,-0.32l-1.69,1.01l-5.23,4.9l-0.39,-0.03l1.12,-4.39l-0.84,-2.13l0.09,-3.09l-0.34,-1.33l1.08,-1.22l1.45,-0.22l0.44,-0.82l-0.26,-3.13l-1.09,-2.35l-0.69,-0.73l-4.95,-1.16l-1.23,0.01l-4.98,2.12l-0.22,1.34l1.26,1.57l-0.67,1.18l-1.42,0.01l-2.79,-1.22l-1.93,0.53l-0.34,-0.26l-0.11,-2.38l0.27,-1.16l1.07,-1.52l2.01,-1.69l0.03,-1.7l2.03,-3.64l0.22,-2.52l-1.38,-1.69l0.34,-0.79l0.93,-0.33l0.62,0.24l0.49,-0.5l-0.35,-2.72l0.73,-2.34l1.94,-0.9l2.0,-0.22l3.05,-0.99l0.51,-0.82l-0.05,-2.64l2.87,-3.0l-0.0,-0.57l-1.08,-1.18l-0.85,-1.76l-1.5,-1.31l-1.4,-0.75l-0.98,-0.04l-0.98,0.49l-1.32,1.37l-0.26,-2.69l-0.89,-0.28l-0.75,0.57l0.01,-1.24l0.99,-0.34l0.99,0.48l3.6,0.32l3.02,-0.64l0.54,-1.23l-0.29,-1.78l-1.9,-2.62l0.22,-1.48l2.22,-1.33l3.94,-0.18l1.16,0.34l1.46,-0.39l0.02,1.12l1.77,0.81l4.9,-0.22l0.64,-0.26l1.77,-3.22l0.11,-0.78l-1.85,-2.88l-2.06,-0.27l-1.26,-0.8l-1.49,-0.22l0.54,-2.9l1.76,-2.79l0.4,-1.79l-0.68,-0.65l-2.26,-0.47l-1.06,-1.66l2.43,-0.68l1.45,0.0l0.97,1.08l0.0,1.01l0.79,0.65l0.29,0.84l0.68,0.13l0.69,-0.82l0.56,-3.98l0.5,-1.2l1.43,-1.46l0.47,-1.12l-0.53,-1.03l-3.17,-1.31l-2.4,-1.49l-2.48,-0.15l-1.5,-0.78l-2.08,-0.34l-3.25,-1.14l-0.67,-2.29l-2.01,-1.77l0.5,-1.75l-0.55,-0.88l-4.8,-1.34l-1.77,0.02l-1.79,-1.79l-1.64,-0.49Z",name:"Th\xfcringen"},"DE-BW":{path:"M174.35,977.77l0.94,-0.09l1.04,-0.87l1.4,-3.28l-0.41,-0.55l-2.22,0.2l-4.37,1.12l0.43,-1.22l-0.29,-1.37l-1.72,-1.74l-2.19,-3.76l-1.37,-1.65l-1.49,-0.71l-0.28,-0.42l-0.55,-3.8l2.54,-3.12l0.04,-2.16l-1.19,-4.29l0.25,-1.61l1.36,-3.94l1.92,-1.37l0.21,-1.54l-0.52,-3.81l1.96,-2.97l0.08,-2.67l0.47,-1.5l2.54,-2.3l1.06,-1.83l-0.28,-4.11l-4.18,-6.31l-0.29,-5.0l0.6,-2.37l0.64,-1.85l1.87,-2.86l0.23,-1.89l0.6,-1.42l6.17,-7.39l1.08,-1.88l1.5,-7.27l3.36,-1.95l1.43,-2.06l0.11,-1.9l-1.14,-3.28l-0.3,-1.43l0.11,-1.57l1.19,-4.65l1.82,-3.25l0.23,-2.45l0.44,-1.0l3.7,-2.92l-0.03,-1.02l-1.12,-2.6l0.01,-4.26l0.81,-3.99l4.04,-5.37l2.73,-1.12l1.5,-1.11l2.7,-2.74l2.48,-1.74l1.1,-1.24l0.5,-1.1l0.15,-2.47l0.41,-0.89l4.58,-0.59l0.7,-0.62l0.42,-1.85l0.96,-1.12l0.81,-0.06l4.36,-2.22l1.26,-1.82l4.44,-10.4l3.02,-4.86l1.91,-1.87l3.04,-0.98l3.22,-2.96l2.09,-2.77l7.22,-12.62l0.48,-1.41l1.87,-12.06l0.61,-2.04l2.24,-1.43l6.88,-6.97l0.35,-1.6l-0.28,-0.47l-1.97,-0.59l3.62,-7.35l0.04,-1.46l-0.71,-3.04l1.32,-2.87l-1.26,-1.62l-4.76,-1.12l0.0,-0.31l1.82,-0.77l0.24,-1.24l-1.36,-2.54l-2.19,-5.45l-1.84,-2.6l0.73,-2.7l2.97,-1.04l2.18,0.3l2.26,1.53l7.02,5.94l4.3,-1.55l0.92,-0.98l0.02,-1.21l-1.85,-6.88l7.12,-1.49l0.11,0.81l1.31,2.01l-0.6,1.53l0.48,1.6l1.45,2.99l1.28,1.26l4.79,2.38l1.73,0.23l2.4,-0.19l1.16,1.97l0.98,0.67l5.86,-0.39l-0.1,1.47l-1.21,1.67l-0.7,-0.17l-0.89,-0.93l-0.58,-0.14l-2.19,1.89l-0.55,1.38l0.33,3.57l-1.88,1.43l-0.23,1.76l0.53,1.07l3.21,0.91l0.87,-0.12l1.04,-0.64l2.98,-3.01l0.87,-2.61l0.41,0.93l0.75,0.22l2.83,-1.41l0.56,-1.31l-0.67,-1.77l-1.09,-1.36l2.51,-2.51l5.29,-0.11l2.5,0.35l1.07,-0.38l2.19,-1.78l0.64,-0.05l2.42,0.05l1.28,1.23l1.37,0.08l0.34,-0.7l-0.27,-0.91l-2.56,-3.92l-2.42,-2.72l1.27,0.87l0.87,0.15l0.51,-0.21l0.65,-0.94l1.08,0.39l5.51,-1.02l1.46,0.22l6.52,-0.22l1.17,-1.17l0.67,-1.78l1.37,-1.24l-0.23,-2.22l0.53,-0.57l2.02,-0.87l3.16,-0.22l2.78,-1.04l1.67,1.25l1.06,0.06l2.01,-1.51l0.12,-0.46l-0.71,-1.51l1.15,-5.53l-0.13,-0.44l-0.7,-0.62l-2.58,-0.69l-0.78,0.55l-0.77,1.84l-0.89,0.17l0.35,-1.91l-0.59,-0.97l-4.04,-0.75l-1.03,-0.49l-0.04,-0.61l0.69,-1.6l-0.71,-1.85l1.35,-1.35l2.12,-0.87l4.72,0.28l3.66,-1.1l5.15,-0.4l5.34,2.11l1.32,0.08l1.6,-0.49l2.78,1.41l2.75,-0.74l1.57,-0.88l0.24,0.13l0.13,0.5l-0.7,1.2l0.32,1.94l-0.55,1.29l0.2,1.35l-0.81,0.71l0.07,1.15l-0.88,2.04l0.69,1.02l1.74,0.8l1.59,0.16l1.24,-0.5l0.55,-2.17l1.24,-0.56l0.76,-1.11l0.29,1.95l0.94,1.81l0.7,0.53l0.88,-0.26l3.12,-2.95l2.71,-1.0l3.42,3.79l-0.03,3.37l0.31,1.69l3.91,3.76l0.64,1.01l-0.31,0.88l-1.67,1.84l-0.28,0.94l0.08,1.66l-1.98,2.03l0.01,0.88l1.23,0.86l0.82,0.05l0.85,-0.38l0.55,-0.64l0.51,-1.5l1.26,-0.44l1.21,-1.44l0.91,-0.32l0.4,0.54l-0.6,1.42l1.68,1.44l0.42,2.72l-0.21,2.83l0.43,3.16l0.42,0.43l1.1,0.21l7.07,-0.13l0.97,-0.4l3.91,-3.5l0.15,-1.23l-0.84,-1.28l0.17,-0.27l2.11,-1.41l1.27,0.67l-0.61,1.34l0.09,0.66l1.04,0.84l1.49,0.2l0.57,0.44l-0.81,2.13l1.08,2.45l-0.68,1.9l-1.08,1.37l-0.03,0.82l2.74,1.19l2.9,5.97l-1.57,-0.51l-1.19,0.15l-2.06,2.16l-0.26,3.55l0.28,0.98l1.14,1.35l2.01,0.94l-0.71,2.21l1.08,2.44l0.14,1.21l-0.42,0.11l-1.89,-0.85l-0.61,0.29l-0.25,0.8l0.37,1.08l1.37,1.29l0.09,2.58l0.53,1.04l0.99,0.99l-1.22,0.55l-0.06,0.68l1.22,1.14l2.14,1.28l2.35,2.75l1.39,1.16l0.78,0.12l1.66,-0.72l1.83,1.44l0.04,2.34l-0.95,1.98l-0.46,0.34l-1.51,0.1l-0.4,0.9l0.69,0.69l2.45,0.87l-0.21,1.54l1.79,1.53l-0.39,1.61l0.15,0.54l2.69,1.1l1.9,0.12l1.91,0.96l1.45,0.05l1.11,2.72l4.69,3.56l0.78,1.3l1.62,1.6l0.61,1.39l1.23,1.13l0.83,2.66l-1.94,0.8l-0.27,0.67l1.04,0.98l-0.28,4.6l-0.48,1.5l1.08,2.33l-0.47,1.99l-1.17,1.07l-0.28,0.72l0.02,3.22l-0.71,1.13l-0.08,1.39l0.26,1.1l0.77,0.88l2.06,0.96l0.86,0.03l0.58,1.51l1.57,2.49l-5.03,3.67l-0.19,-0.91l0.5,-0.96l-0.02,-0.89l0.57,-0.43l0.07,-0.58l-0.7,-0.76l-1.15,-0.1l-5.56,5.04l-1.96,-3.02l-3.03,-0.16l-2.05,-1.63l-0.93,0.08l-2.24,2.61l-0.28,1.89l1.85,3.16l4.41,2.87l-0.26,0.73l-1.5,0.64l-0.4,0.64l0.12,1.11l0.98,1.84l0.19,1.19l-0.14,1.29l-1.13,2.82l0.19,0.81l-4.23,0.38l-1.51,1.42l-0.39,1.58l-9.25,4.8l-0.75,-0.36l-0.51,-1.82l-0.62,-0.49l-0.81,-0.12l-2.79,1.54l-3.46,0.66l-1.4,1.2l-1.01,1.61l0.17,1.69l-6.03,6.88l-0.03,0.47l0.88,1.4l1.4,0.27l1.82,3.45l3.09,4.45l1.54,4.46l3.86,15.17l2.64,5.14l0.29,1.53l-0.17,4.59l-0.71,2.69l-2.83,6.77l-1.22,0.8l-0.36,0.66l0.2,1.44l2.23,3.13l-0.36,4.33l-0.43,0.61l-0.46,2.19l-0.97,0.93l-0.14,0.54l0.45,0.71l1.34,0.14l2.31,5.03l-0.66,0.29l-0.88,1.27l-2.25,0.27l-0.98,1.58l0.2,0.77l1.27,1.05l0.59,1.08l1.44,0.35l0.21,0.37l0.54,6.42l0.83,2.5l-0.49,1.58l-3.29,-0.55l-0.57,1.1l-0.13,1.76l-0.51,0.56l-1.24,-2.81l-1.02,-0.68l-1.91,-0.04l-2.51,0.59l-2.18,1.03l-3.26,0.94l-2.28,0.02l-2.3,-0.48l-4.2,-1.44l-3.11,1.28l-7.24,5.55l-4.24,1.86l-3.56,-0.78l-1.54,0.64l-0.96,1.29l-3.38,0.68l-1.16,0.76l-1.15,-0.49l-4.02,-0.65l-1.38,-0.64l-1.47,-1.59l-1.45,-3.71l-0.9,-0.99l-1.1,-0.57l-3.16,-0.36l-5.3,-2.32l-6.08,-0.37l-1.75,-0.45l-9.28,-5.3l-1.64,-4.39l-0.84,-0.41l-2.61,-0.39l-10.32,-6.38l-3.9,-0.52l-0.39,0.61l0.85,1.29l3.3,2.99l7.36,3.46l1.19,1.48l2.06,5.28l2.2,2.82l0.05,0.63l-7.24,0.21l-10.93,-1.06l-2.02,0.65l-1.63,1.48l-3.44,0.94l-3.75,0.3l-2.28,-0.51l-4.07,-2.89l-0.0,-0.35l1.48,-0.3l0.17,-0.7l-2.61,-2.11l-3.21,-1.6l-2.8,-0.15l-0.39,0.26l-0.88,2.45l0.2,0.52l-3.89,0.05l-0.36,-1.46l-1.15,-1.75l1.81,-2.78l-0.64,-1.64l-1.25,-0.37l-1.94,0.03l-2.36,-3.55l-1.48,-0.5l-1.27,0.89l-0.6,2.77l-0.84,0.47l-0.62,-0.4l-0.8,-4.17l-1.94,-0.73l-2.44,-0.12l-1.76,0.81l-0.19,0.53l0.74,1.6l-1.06,0.46l-6.26,0.86l-1.09,0.55l-1.37,1.75l-1.19,3.35l-3.35,1.88l-1.07,1.02l-0.23,1.16l0.64,1.98l-0.57,1.23l0.24,0.55l2.01,0.55l4.7,2.66l1.89,-0.1l4.23,-2.09l4.66,-0.68l3.36,0.79l-0.35,1.88l-0.15,-0.7l-0.38,-0.23l-1.05,0.2l-0.61,0.52l-0.23,0.92l0.39,1.05l-0.04,2.04l-0.6,1.57l-0.94,0.27l-2.12,-2.69l-1.8,-1.31l-3.1,0.31l-3.0,1.71l-1.41,2.72l-2.72,0.39l-6.21,-0.03l-3.62,-0.83l-0.82,-0.46l-1.14,-2.27l-0.86,-0.78l-3.62,-0.76l-1.88,-0.01l-5.49,0.82l-1.66,1.49l-1.77,0.46l-2.99,1.55l-1.71,2.02l-0.83,0.49l-4.31,0.83l-12.49,0.0l-0.63,-2.57l-0.72,-0.73l-6.5,-0.43l-1.31,-0.58l-0.48,0.13l-3.26,3.92l-1.73,0.85l-8.06,1.44l-2.04,-0.23l-3.3,-1.5Z",name:"Baden-W\xfcrttemberg"},"DE-HH":{path:"M382.17,201.49l1.03,-4.25l1.01,-1.1l0.43,-1.53l1.53,0.25l1.9,1.12l-0.31,2.69l0.56,0.58l0.89,0.21l1.29,-0.59l9.63,-6.45l2.35,-0.59l3.23,0.43l1.08,-0.69l1.02,-2.14l0.79,-0.68l1.76,-0.41l1.82,0.19l1.03,-0.46l0.68,-0.62l1.26,-4.23l0.66,-0.65l5.87,0.76l2.92,-1.83l1.14,0.05l-0.19,0.95l-2.1,2.91l-0.53,1.56l0.61,0.99l3.39,2.06l0.35,2.25l1.08,0.81l0.23,0.58l-0.72,2.55l-0.38,3.79l-3.08,0.95l-0.69,0.69l0.75,3.35l0.24,2.74l0.57,0.79l2.65,0.87l3.34,4.02l2.89,1.46l3.39,3.0l0.77,-0.01l0.52,2.29l-3.7,0.0l-1.1,0.29l-1.09,0.58l-2.35,2.62l-5.14,0.28l-1.52,-0.28l-1.48,-0.87l-2.17,-2.25l-2.1,-0.52l-2.94,-2.3l-5.11,1.36l-0.52,0.74l0.02,1.1l-4.04,1.6l-1.45,0.08l-2.33,-1.12l-3.08,0.96l-0.5,-3.1l-0.71,-0.98l-1.08,-0.39l-0.95,0.26l-1.87,1.9l-0.36,0.03l-3.85,-3.12l-1.12,-1.56l-1.12,-2.55l-1.1,-0.86l-0.5,-1.05l-0.81,-0.75l-0.35,-4.61l4.86,0.88l1.48,-0.45l0.2,-0.61l-1.22,-1.74l-3.84,-1.89l-3.7,-0.37Z",name:"Hamburg"},"DE-SH":{path:"M521.78,88.19l-2.9,0.15l-2.4,-0.32l-0.89,-0.89l0.18,-2.57l-0.74,-1.47l-1.51,-0.44l-2.57,-0.07l-1.16,0.28l-1.07,0.79l-0.94,-1.55l-1.39,0.36l-0.17,-1.2l2.65,-5.28l3.69,-2.91l4.54,-0.62l8.23,2.86l3.15,2.45l6.78,10.31l-11.47,-1.56l-2.02,0.86l0.01,0.81ZM297.93,104.64l0.36,-1.02l-0.4,-0.57l-2.98,0.29l-5.15,1.27l-2.94,0.28l-3.64,-0.47l-1.64,0.55l-3.2,2.49l-0.96,0.26l-2.44,-0.71l-2.68,-1.98l-1.93,-2.83l-0.26,-3.23l1.2,-1.2l2.57,-0.94l2.93,-0.48l2.27,0.09l0.42,-0.4l0.0,-0.92l-0.33,-0.39l-1.67,-0.32l-1.27,-0.98l-1.44,-0.4l-1.58,1.41l-0.5,-0.88l0.25,-1.31l1.64,-2.22l2.06,0.68l7.91,-1.75l10.74,0.0l2.58,-0.55l2.22,-1.11l4.11,-2.93l3.74,-1.49l1.7,-1.04l0.85,-2.54l-0.08,-3.53l-2.55,-3.16l-7.98,-6.94l-1.08,-1.36l-0.61,-1.58l-1.14,-0.7l-2.02,0.05l-3.03,0.96l-0.23,-0.34l2.98,-1.65l0.17,-0.52l-3.43,-7.38l-1.3,-1.95l-2.95,-1.54l-5.28,-3.73l-3.16,-1.27l0.51,-3.29l-1.28,-2.77l-3.21,-5.04l-0.54,-3.45l0.43,-3.06l1.2,-3.56l3.17,0.78l3.62,0.13l6.78,-2.02l2.21,-0.27l7.75,1.07l7.73,2.54l20.73,3.93l1.46,1.04l0.71,3.18l0.72,1.62l2.1,0.8l8.69,-0.2l1.08,-0.82l1.3,-0.29l1.15,-0.79l1.51,-0.28l2.04,1.47l1.66,0.15l3.06,-0.45l5.85,-2.38l1.92,-1.88l2.51,-0.89l1.19,-1.71l0.64,-0.42l0.28,4.22l0.29,0.36l4.85,1.43l5.97,0.25l3.99,1.42l6.45,3.17l1.04,2.34l1.49,1.4l2.63,-0.37l4.47,-1.38l0.28,-0.44l-0.33,-2.4l1.78,-0.1l3.03,1.51l2.13,2.18l1.31,4.55l0.66,1.17l2.4,2.37l-0.68,0.42l-3.25,-0.76l-2.58,1.84l-1.55,0.47l-0.33,0.53l-0.05,1.25l0.38,0.41l1.44,0.08l2.64,-0.63l2.34,-0.11l1.35,1.46l0.52,0.06l0.96,-0.67l0.78,-0.05l0.31,0.47l-0.63,1.72l0.47,2.08l0.06,2.62l-1.04,7.93l-1.55,3.35l-1.19,1.39l-3.09,2.32l-3.88,1.74l-4.19,1.1l-4.08,0.37l-0.36,0.4l0.0,0.93l0.24,0.37l4.47,1.81l23.6,-4.54l1.68,0.48l5.45,3.83l-1.69,1.55l0.03,1.65l1.24,3.65l-0.51,1.63l-1.3,1.58l-1.67,1.14l-1.62,0.4l-0.21,0.65l0.53,0.59l-0.55,0.77l0.06,0.53l0.96,0.84l0.24,0.91l-0.33,1.1l-0.92,1.24l-0.01,0.47l0.44,0.15l2.32,-0.74l1.7,-1.71l2.31,-4.21l1.32,-4.52l0.63,-1.0l0.82,-0.44l3.76,-0.35l1.47,-0.73l1.95,-2.12l0.98,-0.26l4.04,0.29l2.06,0.82l5.99,3.86l15.42,5.52l8.7,6.62l4.2,0.89l4.76,-0.7l3.37,-1.69l5.58,-4.2l3.18,-1.66l3.31,-1.13l3.58,-0.38l0.18,0.51l1.7,0.62l1.78,-0.4l2.53,1.22l6.75,-3.35l2.25,0.69l-3.98,3.91l-1.86,-0.76l-0.43,0.11l-0.06,0.44l1.04,2.16l0.89,5.33l0.74,2.47l-0.7,1.74l0.07,2.35l0.65,3.82l-0.39,2.14l-1.78,1.95l-0.49,1.18l-11.26,5.92l-3.99,4.11l-1.62,0.85l-4.58,1.06l-0.87,0.53l-1.3,-0.92l-0.88,-0.07l-0.99,0.45l-5.4,6.39l0.04,1.02l1.34,2.69l1.43,1.94l1.98,1.36l2.8,0.75l3.85,-0.3l0.74,0.24l0.58,1.17l0.48,2.85l1.69,0.61l0.03,3.92l0.76,0.99l0.95,0.56l3.23,0.85l-0.73,0.48l-2.99,0.39l-0.34,-0.34l0.07,-1.26l-1.81,-0.67l-0.89,0.03l-2.4,1.29l-4.79,3.63l-4.49,2.09l-1.24,1.91l-0.47,1.93l1.17,2.93l0.79,3.5l-1.22,5.47l0.1,0.82l0.48,0.35l4.31,0.71l3.87,4.28l1.12,0.84l0.86,0.41l2.17,-0.23l2.65,0.66l2.18,1.53l0.62,0.86l0.1,1.61l0.97,1.86l-0.24,1.9l-1.39,1.01l0.1,2.43l1.27,4.35l-0.04,0.34l-0.84,0.4l-0.14,0.63l0.84,0.33l-1.79,1.8l-0.86,-2.34l-1.15,-0.78l-5.04,0.52l-1.59,-0.49l-1.38,0.31l-0.31,0.71l0.5,2.57l-0.9,2.1l-0.2,2.0l-5.86,3.54l-5.51,1.41l-1.3,2.66l-1.42,-0.26l-1.38,0.17l-2.21,1.08l-0.64,0.97l-0.81,4.25l-0.01,1.64l-0.43,1.23l-1.94,2.42l-2.9,0.99l-3.88,-1.09l-13.96,-6.88l-3.53,-1.09l-2.0,-0.09l-0.67,-2.82l-1.09,-0.23l-3.27,-2.89l-2.93,-1.5l-3.3,-3.99l-2.68,-0.89l-1.2,-5.99l2.97,-0.89l0.67,-0.51l0.5,-4.11l0.73,-2.63l-0.2,-0.87l-1.19,-0.93l-0.42,-2.39l-3.56,-2.2l-0.3,-0.51l1.39,-2.57l1.34,-1.74l0.2,-0.88l-0.56,-0.81l-1.75,-0.07l-2.78,1.79l-5.89,-0.78l-1.24,1.16l-1.24,4.18l-0.36,0.28l-0.63,0.34l-1.89,-0.17l-2.03,0.49l-1.08,0.92l-0.97,2.08l-0.72,0.45l-3.1,-0.46l-2.63,0.69l-10.73,6.95l-0.54,-0.41l0.41,-2.01l-0.17,-0.77l-2.24,-1.36l-1.88,-0.31l-0.6,0.29l-0.47,1.62l-0.96,0.96l-1.21,4.74l-4.38,-0.41l-3.52,-1.14l-7.0,-3.69l-3.1,-2.85l-1.11,-4.13l-0.67,-5.99l-1.21,-1.03l-6.07,-2.52l-2.27,-1.69l-2.23,-3.93l-1.52,-4.25l-0.14,-2.63l-0.28,-0.36l-3.52,-1.13l-6.15,-4.31l-3.86,-1.9l-3.73,-0.71l-12.4,-0.23l-3.67,-1.38l-2.55,-0.58l-1.41,0.63l-1.0,1.28l-1.96,-0.53l-3.36,-2.08l-3.22,-3.23l-7.84,-12.88l3.27,-1.22l1.73,-0.11l2.24,0.5l3.81,2.07l2.2,0.6l2.4,-0.84l0.96,-1.67l0.83,-2.74l0.55,-2.93l-0.02,-2.16l-1.23,-1.63l-3.04,-2.57l0.25,-2.25l-0.3,-0.39l-2.55,-0.6l-3.43,0.51l-3.28,1.27l-2.08,1.57l-4.26,-6.58l-0.21,-0.51l0.74,-2.51l2.52,-4.46l-0.66,-2.92l0.96,-0.59l5.72,-1.08l1.23,-0.75l3.16,-3.93l1.02,-2.09l-0.42,-0.57l-2.24,0.35l-3.82,2.63l-1.25,0.45ZM505.27,92.96l1.41,-0.15l0.0,0.09l-1.41,0.06ZM297.84,80.79l-4.13,0.26l-1.82,-0.53l-0.72,-1.01l0.85,-0.54l0.14,-1.05l-0.95,-1.26l2.66,-2.06l3.33,-1.23l3.77,-0.18l3.41,0.73l-0.11,1.55l-1.7,1.34l-2.58,3.1l-2.15,0.89ZM276.26,76.33l-2.63,1.21l-1.99,-0.03l-1.07,-0.76l-0.89,-1.73l0.52,-1.88l3.0,-1.63l5.83,-2.0l0.12,0.91l-0.75,3.16l-2.15,2.75ZM278.04,137.9l-0.16,0.39l-0.79,-0.21l-1.19,-1.75l0.24,-1.51l0.94,-0.79l0.28,-0.0l0.13,1.76l0.87,0.87l-0.32,1.25ZM248.66,23.66l4.99,1.03l5.58,-0.23l-3.34,1.97l-1.38,0.32l-6.64,0.0l-1.42,-1.42l-1.93,-0.32l-4.34,2.32l-0.85,4.57l0.33,7.4l-0.75,4.1l-0.46,-1.36l-0.08,-3.51l1.13,-14.71l0.91,-2.83l7.39,-16.61l1.52,-1.52l0.16,0.48l2.49,0.21l0.62,1.29l-0.73,1.57l-4.0,1.85l-1.92,2.34l-1.02,2.74l0.83,2.71l-0.56,4.74l3.48,2.89ZM250.3,1.86l1.38,-1.39l2.81,1.2l-4.19,0.18ZM264.77,24.24l8.78,-0.35l-1.1,0.7l-7.68,-0.34ZM266.78,50.31l-0.69,0.79l-1.15,0.3l-1.55,-0.15l-2.54,-1.02l-2.45,0.75l-3.03,-0.75l-5.27,-2.63l1.64,-2.42l2.11,-1.64l2.57,-0.82l3.21,-0.22l5.36,0.26l2.06,1.01l1.62,2.25l0.0,0.67l-0.78,1.07l-1.09,2.55ZM245.09,48.48l-1.98,1.85l-0.04,0.5l4.9,7.42l1.39,0.69l-0.71,0.49l-3.09,0.9l-2.09,-1.53l-1.81,-2.65l-1.77,-1.95l2.64,-4.0l1.65,-1.46l0.9,-0.27ZM203.59,118.61l-0.73,0.18l-0.01,-0.01l0.73,-0.17ZM200.05,118.64l0.62,0.33l0.13,0.51l-0.19,-0.05l-0.56,-0.79Z",name:"Schleswig-Holstein"},"DE-NW":{path:"M55.93,626.7l-2.43,1.05l-2.02,0.01l-0.12,-0.64l-3.35,-4.89l-0.11,-1.32l1.36,-4.73l0.08,-2.23l-0.47,-0.71l-0.78,-0.22l-0.72,-0.99l-0.76,-2.27l0.19,-0.81l1.12,-1.25l-0.36,-0.27l-5.94,-0.89l-1.95,-0.84l-3.93,1.09l-0.8,-0.03l-2.0,-2.3l0.56,-0.8l-0.3,-0.63l-1.62,-0.26l0.61,-1.03l-0.03,-0.52l-1.4,-1.48l1.56,-2.05l3.02,-2.1l2.17,-1.08l1.97,-2.9l-0.18,-1.09l-0.38,-0.29l-6.7,-0.14l-1.83,-0.8l-0.86,-1.39l0.93,-0.5l0.13,-0.6l-5.97,-7.63l-1.95,-1.64l-1.98,-0.21l-3.82,0.88l-0.98,-0.1l-0.26,-0.73l0.3,-2.6l-1.78,-1.06l0.34,-2.53l-1.65,-1.41l-0.9,-1.92l1.19,0.11l1.54,-1.29l0.53,-1.74l-0.29,-2.13l0.72,-1.09l1.15,-0.55l2.11,0.15l1.49,-1.33l0.63,-1.48l0.01,-1.16l-0.8,-2.56l0.85,-1.92l-0.26,-0.52l-3.17,-0.92l-2.85,-1.74l-0.35,-2.63l0.95,-2.34l-0.63,-0.96l-3.45,0.35l-4.06,-0.85l-4.74,1.51l-0.12,-2.95l-1.5,-3.69l-0.49,-2.68l2.29,-1.01l1.12,0.53l2.47,2.25l2.32,-0.18l1.28,-1.2l1.86,-3.25l1.25,-1.2l9.02,-5.89l5.56,-2.51l1.59,-1.71l-0.05,-0.58l-1.63,-1.26l2.52,-1.57l0.22,-0.39l-0.29,-0.35l-2.56,-0.61l-4.71,2.69l-1.95,-0.9l-0.63,-2.15l0.27,-2.78l0.81,-2.49l3.05,-3.5l5.0,-7.67l3.42,-2.21l1.08,-1.23l0.62,-1.84l0.3,-2.78l0.54,-1.08l-0.08,-0.46l-1.35,-1.34l0.12,-2.18l1.1,-5.36l-1.18,-6.76l-4.06,-4.01l-6.46,-7.37l-0.37,-1.41l1.63,-4.65l-0.24,-0.52l-6.56,-2.39l-2.02,-2.13l1.24,-3.47l-1.09,-1.27l-3.43,-1.89l-3.55,-0.18l0.05,-0.93l2.19,-1.97l0.17,-2.64l-1.35,-2.74l-2.12,-1.41l0.21,-0.73l1.43,-0.84l3.93,-0.58l1.97,-0.69l3.43,-1.87l3.87,-0.86l7.0,1.5l0.42,-0.18l-0.02,-0.46l-1.37,-1.78l-4.3,-3.59l2.5,-1.12l2.97,1.16l3.21,2.14l3.32,1.13l3.85,-0.47l2.11,2.52l3.93,0.58l1.34,0.65l0.26,1.83l0.49,0.33l3.97,-1.12l0.41,-1.53l-0.62,-2.3l5.63,1.38l2.23,-0.01l1.7,-0.65l4.78,-3.04l9.66,-2.73l8.64,-0.23l2.81,-1.22l2.45,-2.4l2.21,-3.32l1.99,-1.19l0.24,-1.89l-0.26,-1.01l-3.26,-3.11l-9.91,-4.28l-0.17,-1.68l0.56,-1.13l3.09,-0.94l0.86,-0.93l1.26,-2.32l1.58,-1.36l1.46,-0.67l6.5,-0.66l1.34,-1.05l2.14,-3.6l1.8,-1.56l4.24,-1.55l2.04,-1.52l3.27,-4.01l4.31,-2.16l0.46,-0.99l2.13,0.05l4.05,-1.42l2.66,-1.82l13.4,-0.46l4.12,-0.75l6.73,-4.09l2.95,-0.61l1.84,-0.9l5.03,-4.3l4.49,-3.08l1.76,-0.41l2.87,0.2l1.62,-1.66l1.44,-3.57l1.19,-0.82l-0.18,-0.83l-1.47,-1.15l-0.31,-0.85l1.14,-4.04l0.83,-0.74l7.55,2.02l0.72,1.36l0.83,4.52l0.4,0.68l2.91,1.13l6.57,3.41l1.49,1.44l1.55,0.32l6.37,-2.07l0.76,0.12l3.51,3.8l2.76,3.96l0.09,0.4l-3.29,0.46l-0.78,0.57l-0.12,0.76l0.36,1.19l1.3,1.98l-2.86,2.97l-0.04,0.87l0.86,1.97l-0.7,1.17l-1.65,1.64l-0.05,0.79l0.94,1.08l2.43,0.39l0.46,1.39l0.97,0.63l4.31,-0.22l2.16,0.72l0.15,0.34l-1.33,2.47l-1.17,3.41l-4.06,0.57l-2.52,0.96l-2.97,2.23l-0.27,0.92l2.18,4.83l6.27,2.39l0.81,-0.34l4.22,-3.35l1.41,-0.56l3.43,-0.5l3.67,1.05l6.98,-2.19l3.06,-1.83l2.3,-2.57l2.98,-2.17l12.26,2.9l0.96,-0.18l0.88,-0.59l1.67,-3.2l4.88,-2.72l1.7,-2.05l0.55,-1.04l0.05,-0.96l-3.34,-2.18l-0.25,-1.08l-0.08,-11.85l-1.04,-4.5l-0.89,-2.15l-1.37,-1.81l-2.9,-1.75l-6.35,-2.47l-1.11,-1.42l-1.66,-4.59l1.55,0.46l2.19,-0.01l2.08,0.6l5.68,-0.63l2.55,-1.25l0.65,-1.03l0.93,-3.65l3.06,-2.06l6.74,-0.07l1.67,-0.29l4.8,-1.93l0.89,-0.01l1.52,0.51l1.54,1.11l2.61,3.94l0.32,1.87l-0.24,2.96l0.57,1.39l-0.38,3.23l0.55,1.42l1.51,0.5l10.16,0.9l3.26,-0.31l3.47,-1.18l6.68,-1.27l0.88,-1.06l1.47,-3.79l1.4,-2.26l2.54,-2.16l5.36,-2.34l1.15,0.22l1.6,1.84l1.89,0.68l-0.64,1.47l-1.45,0.96l-0.33,0.56l0.21,1.35l1.64,4.23l-3.1,4.14l-1.73,3.09l-2.63,1.5l-2.96,-0.18l-1.1,0.27l-0.85,1.0l-0.65,1.5l-1.24,7.23l0.46,1.22l0.86,0.67l7.25,2.04l-2.58,1.61l-0.45,0.82l0.82,3.08l-2.42,-0.06l-3.08,0.73l-0.27,0.55l1.88,4.18l-0.01,0.68l-1.06,2.04l0.64,0.61l6.37,-0.63l6.9,0.79l0.59,0.31l0.09,0.59l-0.49,1.24l0.2,0.95l0.95,0.8l2.63,0.93l0.95,1.12l0.1,0.66l-1.26,2.95l2.16,5.18l-0.45,1.13l-1.6,1.2l-0.52,2.01l1.43,0.94l3.48,1.21l0.64,-0.15l0.73,-1.32l1.1,-0.28l3.87,1.35l-1.17,4.15l-1.82,1.87l0.06,0.61l0.98,0.23l3.76,-0.28l2.16,0.87l0.73,1.16l0.34,1.49l-0.2,1.35l-1.37,3.36l0.29,0.54l1.15,0.2l3.23,-0.87l4.42,0.14l4.48,-0.92l-2.0,3.15l0.49,0.92l1.58,0.46l-0.82,1.1l-0.09,3.0l-1.71,3.84l-2.65,1.82l-0.57,1.45l-0.99,1.14l-0.21,1.53l0.39,3.02l-0.62,1.5l0.26,1.49l-1.42,1.45l-0.29,1.32l0.22,1.73l0.79,0.79l1.58,0.03l3.52,-0.91l-1.46,1.85l-6.96,1.91l-1.4,0.8l0.05,0.8l1.94,1.48l-1.81,4.72l-2.41,2.34l-1.13,2.03l-3.45,2.21l-2.98,1.29l-0.92,0.77l-1.12,3.88l-1.78,0.03l-3.78,2.34l-4.23,-0.58l-1.75,-1.22l-0.39,-0.49l0.21,-1.95l-0.2,-1.25l-0.68,-0.91l-0.54,-0.45l-1.13,-0.09l-1.28,-0.55l-2.82,-1.58l-0.89,-0.15l-1.53,0.67l-4.08,0.89l-5.1,2.13l-0.71,0.78l-0.32,0.99l0.13,0.92l1.31,1.81l0.43,3.76l0.57,0.43l2.07,0.26l0.53,0.46l-0.92,2.1l-4.29,0.32l-3.68,1.96l-4.52,-0.9l-3.64,0.83l-4.4,0.3l-4.62,1.48l-0.91,1.32l-1.85,1.04l-0.61,1.29l-3.19,2.69l-2.19,2.38l-1.57,2.64l-0.29,1.01l0.37,0.76l1.55,1.08l0.72,1.81l1.85,0.58l1.2,-0.27l1.16,-1.42l4.44,-0.76l2.24,-1.35l0.97,-0.06l-0.32,1.61l1.16,0.77l1.92,7.63l0.05,1.51l-0.13,0.47l-3.13,2.91l-2.22,2.6l-0.02,0.84l0.96,1.42l0.08,0.89l-4.12,2.16l-3.3,-0.7l-10.05,0.04l-0.37,0.26l-0.38,1.43l1.62,2.74l-0.25,1.65l0.95,3.65l-1.63,1.87l-1.69,3.16l-1.23,0.36l-0.72,0.72l-2.1,3.88l-0.3,3.39l-1.85,-0.11l-1.89,1.03l-3.03,2.64l-0.16,1.73l-2.81,1.64l-2.63,0.22l-1.48,-0.23l-1.64,-2.29l-2.24,0.01l-5.82,4.69l-0.86,1.01l-1.94,1.17l-1.02,2.04l-5.33,4.17l0.01,0.86l0.82,0.66l0.15,0.95l2.49,1.68l0.6,0.89l-0.77,4.27l-1.87,0.89l-1.11,1.82l-2.37,-1.24l-1.31,-0.31l-3.45,0.99l-0.58,-2.08l-1.67,-2.47l-4.17,-4.54l-0.94,-1.51l0.28,-3.74l-0.72,-3.13l-0.67,-1.41l-0.97,-0.23l-2.0,0.68l-1.67,-1.08l-3.78,-3.35l-2.68,-0.79l-1.08,-0.66l0.12,-1.17l0.94,-2.34l0.32,-1.85l-0.3,-0.46l-5.7,-1.33l-1.46,0.32l-3.2,2.53l-0.33,0.85l-0.16,0.97l0.37,3.2l1.24,2.68l-0.11,1.93l-2.86,-0.64l-2.5,2.24l-3.62,1.85l-0.08,0.66l2.14,2.17l-0.19,1.53l-0.5,0.14l-0.47,-0.49l-0.78,0.01l-1.51,1.89l-4.36,1.59l-1.46,2.23l-2.87,-0.08l-3.94,1.83l-8.12,1.89l-3.63,-0.26l-2.5,0.6l-0.95,1.15l0.41,0.64l-0.09,3.01l-0.85,1.41l-0.16,1.67l-2.95,1.78l-5.57,1.28l-5.38,-0.32l-0.92,-1.54l-1.91,-0.55l-0.55,0.4l-1.0,2.06l-0.69,0.25l-2.29,2.03l-0.86,0.22l-2.56,-0.62l-0.61,0.43l-0.88,1.56l-0.88,0.29l-1.85,-0.75l-1.42,-0.09l-6.19,3.41l-5.82,1.52l-1.24,1.89l-1.38,1.39l-2.22,0.55l-0.62,0.52l0.38,3.52l-0.22,2.44l-1.21,1.62l-1.13,0.16l-1.73,-0.55l-2.11,-2.71l-0.75,-0.03l-3.73,1.23l-1.67,0.82l-0.25,0.48l0.11,1.88l-0.83,2.32l0.33,0.6l2.15,1.22l0.36,3.93l1.67,2.69l0.26,1.05l-0.22,0.56l-7.54,1.84l-1.41,-0.24l-1.2,-1.27l-2.0,-1.16l-0.97,0.09l-2.6,1.46l-0.91,0.0l-0.24,-0.03l0.54,-1.3l-0.35,-0.63l-2.4,-1.2l-1.42,-0.31l-1.39,0.49l-4.43,0.67l-4.67,2.88l-2.0,0.62l-1.1,-2.2l-2.26,-1.19l-0.74,-1.22l-0.82,-0.6l-1.29,-0.14l-0.81,0.92l0.05,0.93l3.4,4.77Z",name:"Nordrhein-Westfalen"},"DE-SN":{path:"M613.55,628.95l-0.88,-1.11l-2.79,-0.68l-2.12,0.03l-5.21,-2.72l-0.56,-2.5l0.23,-1.42l-0.35,-0.59l-2.13,-1.24l-2.07,-2.7l-1.04,-0.33l-2.37,0.21l-0.57,-0.77l1.09,-1.06l2.37,-0.89l0.4,-1.53l1.03,-1.22l-0.26,-2.05l-1.83,-1.59l0.74,-1.97l0.98,-1.16l2.32,-1.5l2.34,-2.48l1.81,0.24l1.6,1.61l1.88,0.2l1.29,-0.93l2.1,-2.93l1.3,-0.22l2.18,0.8l2.82,-0.78l0.93,-0.93l0.69,-2.02l-0.13,-2.55l2.56,-2.72l6.43,0.02l3.7,-2.24l1.2,-1.11l2.03,-2.95l-0.19,-0.6l-1.1,-0.37l-2.13,0.07l-0.86,-0.36l-1.17,-2.45l0.48,-1.71l-0.19,-0.66l-0.87,-0.75l-1.92,-0.08l0.8,-1.92l0.8,-0.57l1.42,-0.29l1.72,-1.87l-0.37,-1.2l-1.73,-0.68l-1.0,-0.94l0.08,-0.84l6.95,-1.75l3.87,-2.52l3.34,-0.33l1.12,0.65l0.76,-0.09l3.91,-4.23l3.73,-1.71l0.52,-0.45l0.24,-0.86l1.56,0.49l2.21,-0.21l3.23,0.36l1.42,-0.28l0.89,0.87l0.5,0.1l1.04,-0.77l1.12,-1.44l1.51,-0.7l0.31,-0.91l-0.06,-0.64l-2.07,-3.72l-2.37,-3.13l-5.65,-2.53l-1.2,-1.0l-3.96,-6.22l-0.75,-3.81l-0.29,-0.31l-15.19,-3.83l-6.4,0.51l-3.97,-0.65l-0.55,-0.56l-0.44,-2.26l-2.18,-1.75l-0.81,-1.35l0.44,-3.4l-0.31,-0.44l-2.72,-0.67l-0.03,-0.55l0.97,-1.14l0.45,-1.13l-0.27,-4.27l-0.46,-1.54l-1.79,-2.02l-0.13,-2.54l-0.78,-2.33l0.4,-1.27l1.39,-1.81l2.24,-0.4l0.73,-0.59l0.54,-2.67l-0.19,-1.2l-1.41,-3.02l-0.25,-5.06l-0.88,-1.57l-0.22,-2.52l3.36,-3.03l0.47,-1.66l0.0,-5.89l2.77,-1.98l0.82,-2.16l2.95,1.1l3.18,0.29l5.79,-2.16l7.22,-0.61l0.73,-0.41l0.85,-3.47l0.61,-0.21l7.64,0.27l1.43,0.76l9.37,-1.36l0.83,0.68l1.29,-0.04l2.24,-1.57l1.73,-2.62l1.25,-0.6l3.46,0.4l3.12,1.02l1.97,-0.78l5.13,-3.55l0.86,-1.06l2.42,-0.19l0.95,1.69l1.4,0.87l2.76,0.67l2.07,0.88l1.63,1.4l1.25,-0.19l1.72,-0.96l0.48,0.16l2.71,2.18l2.92,0.78l2.67,2.73l1.44,0.84l1.07,0.29l1.24,-0.44l2.87,1.9l-0.34,3.35l1.09,1.24l1.96,0.98l1.28,3.93l-0.21,1.01l-1.82,1.38l1.0,2.59l-0.17,3.23l-0.63,1.53l-1.33,1.1l-0.42,0.82l0.24,1.5l0.99,1.5l0.84,0.06l1.39,-1.45l0.88,0.11l0.74,-0.78l1.46,0.43l1.22,1.68l0.42,0.15l10.91,-3.01l1.5,-0.66l0.96,-0.85l2.02,-0.19l4.49,1.83l2.18,1.79l2.41,1.35l1.59,1.98l1.37,0.54l2.21,-0.3l5.81,1.42l14.92,0.95l16.88,-1.74l2.3,0.55l1.01,-0.3l7.43,-9.17l1.51,-2.95l0.22,-2.1l0.51,-0.86l3.79,-4.12l1.15,-0.88l3.86,-1.78l6.0,-1.21l4.61,0.5l3.44,1.06l3.56,1.87l3.87,-0.75l12.93,-5.38l4.18,-0.98l4.02,0.25l2.45,1.2l4.22,1.46l4.07,0.17l0.38,1.3l2.33,1.96l6.36,1.78l4.3,2.3l4.65,1.15l2.16,0.86l3.22,2.48l0.87,1.55l-0.78,1.66l1.39,11.49l0.33,1.01l1.82,2.65l2.23,2.2l1.34,2.38l-0.49,3.64l0.64,0.9l-1.54,2.53l-1.35,3.52l-0.8,3.65l-0.31,4.88l-1.95,2.47l-0.47,5.19l-9.27,18.97l-3.44,3.19l-1.44,1.97l-0.09,2.56l-1.51,3.37l-1.73,2.24l-1.42,0.32l-2.05,-0.06l-3.54,-0.66l-5.13,-3.01l-3.3,-0.79l-0.34,-0.69l0.32,-2.13l2.23,-4.98l-0.53,-1.73l-0.37,-0.26l-1.32,0.0l-5.24,1.82l-0.7,-0.46l2.4,-4.8l0.18,-1.95l-0.31,-1.4l-2.04,-2.41l-1.27,-0.84l-2.72,-0.6l-1.1,-0.64l-0.84,-0.97l-1.1,-2.63l-0.72,0.01l-0.79,1.66l-0.89,0.39l-3.47,-0.16l-2.84,1.01l-1.84,-0.43l-2.03,-2.05l-3.65,-1.0l-3.28,0.4l-2.68,2.26l-1.36,3.67l-1.05,1.27l0.12,0.61l1.3,0.68l3.27,0.36l1.27,0.43l-0.61,0.56l0.05,1.69l2.51,2.07l3.74,0.96l2.31,1.11l-0.5,2.77l-2.63,1.86l-7.56,-0.5l-3.63,0.62l-4.19,4.12l-15.18,5.82l-5.35,-0.28l-2.16,0.4l-3.49,2.82l-3.17,0.05l-1.0,1.08l-0.42,1.26l0.29,2.65l-0.51,0.61l-1.12,0.18l-2.78,1.45l-1.65,0.28l-4.52,-0.42l-2.2,0.2l-5.54,1.45l-8.78,-0.04l-4.64,0.74l-4.02,2.03l-0.17,0.56l1.06,1.85l-0.33,1.49l-1.2,1.3l-1.59,1.01l-0.14,0.53l0.51,0.92l-0.06,0.52l-4.72,3.92l-1.62,0.34l-2.0,-0.82l-2.51,-3.07l-1.67,-0.42l-0.96,1.18l-3.78,2.29l-1.57,3.35l-1.76,0.75l-3.18,-1.51l-1.91,-0.15l-0.4,0.24l-3.25,7.28l-1.34,2.04l-2.23,1.4l-5.05,-0.25l-4.63,1.08l-3.43,-0.9l-1.76,0.69l-1.43,7.74l-4.1,3.6l-3.12,-0.15l-9.01,-4.6l-1.07,-0.24l-2.84,1.1l-3.31,-0.12l-1.7,0.5l-1.46,1.18l-2.14,2.78l-0.96,0.78l-1.11,0.1l-5.28,-0.79l-7.34,0.46l-4.03,0.99l-3.7,2.69l-0.82,1.89l0.06,1.54l-1.51,0.27l-1.2,0.89l-2.84,1.34l-1.14,0.93l-3.09,4.69l-2.22,1.64l-0.8,1.0l-0.33,2.11l-1.85,1.99l-0.63,1.43l-0.3,2.41l0.86,3.81l-1.06,0.65l-1.37,-0.15l-0.85,-1.11l-1.85,-5.77l-2.4,-2.27l1.22,-1.33l0.11,-0.76l-0.4,-0.73l-1.02,-0.5l-2.77,-0.06l-1.31,-0.34l-0.94,-0.69l-0.32,-0.82l0.03,-2.13l-0.62,-1.37l-2.04,-1.29l-4.69,-0.34Z",name:"Sachsen"},"DE-HB":{path:"M265.62,250.29l0.77,0.14l2.23,-0.47l2.69,1.38l7.16,2.2l2.11,-0.44l3.26,0.01l0.47,1.29l2.72,1.52l4.48,0.32l3.54,2.47l4.4,1.6l1.36,-0.49l1.23,-2.55l0.76,-0.22l3.33,3.07l-1.4,1.14l-0.28,0.91l0.47,0.95l2.35,2.05l0.26,0.56l-1.01,1.53l-0.59,3.76l-1.36,1.22l-3.97,2.26l-4.58,-2.93l-0.59,0.2l-0.14,1.16l-1.67,0.47l-1.73,-0.22l-5.32,-2.63l-5.13,0.89l-1.22,-0.18l-0.19,-4.35l-4.75,-4.35l-1.5,-1.88l-0.64,-3.9l-1.4,-2.3l-0.98,-0.62l-3.09,0.05l-2.31,-1.3l-3.92,-1.3l-1.3,-2.58l2.51,-0.02l2.99,1.58ZM261.84,196.51l4.03,1.21l2.2,0.32l4.13,-0.11l-0.95,1.95l0.35,1.49l1.13,2.28l0.64,2.7l-0.11,2.44l-1.57,2.18l-1.95,1.5l-1.06,-1.31l-1.38,-0.15l-1.41,-2.21l0.74,-3.74l-2.97,-5.84l-1.83,-2.72Z",name:"Bremen"},"DE-SL":{path:"M65.93,746.0l-0.23,-1.93l-0.65,-1.16l-1.78,-1.49l-9.11,-3.87l-1.37,-0.17l-2.68,1.35l-1.34,0.11l-0.3,-4.41l0.59,-3.76l13.51,-1.05l11.44,0.43l6.27,-2.41l2.29,0.18l1.97,-0.33l14.47,-5.63l7.96,-4.23l2.89,1.17l0.89,-0.17l1.79,-1.14l7.05,3.24l6.38,0.31l2.11,1.74l4.12,2.71l0.79,0.23l1.21,0.11l1.89,-0.35l2.95,-1.49l0.05,1.82l1.71,3.48l0.25,3.41l0.57,0.68l0.74,0.13l0.16,1.73l-2.72,1.68l-1.93,2.1l-0.92,0.5l-0.54,0.98l0.61,1.93l4.08,4.23l-0.04,1.37l1.09,0.55l4.87,0.7l2.32,0.74l0.81,0.39l0.38,0.81l-0.64,1.56l0.39,1.37l-0.74,1.05l-2.08,1.61l-0.56,2.26l-1.52,1.52l-0.72,2.75l-1.14,1.4l-2.18,0.34l-0.95,1.98l0.91,4.25l5.38,4.66l1.21,0.05l-1.12,0.59l-1.6,3.08l-3.65,0.82l-2.07,2.79l-3.13,-1.11l-8.41,-0.07l-2.96,-1.08l-3.73,-2.3l-0.7,-0.12l-1.33,1.19l0.29,1.69l-2.64,1.41l-1.85,-1.23l-1.07,-3.29l0.05,-4.41l-0.38,-0.4l-2.04,-0.09l-6.05,-2.9l-1.21,-0.17l-2.89,0.23l-4.04,-0.78l-1.14,0.2l-0.86,2.29l1.06,3.9l-1.48,1.66l-1.02,0.2l-3.73,-1.17l-4.42,-0.05l-0.97,-0.35l-1.09,-1.54l0.73,-2.95l-0.62,-2.25l-0.78,-0.28l-1.53,0.75l-1.61,-4.5l-2.21,-1.07l0.12,-1.66l-0.28,-0.74l-6.51,-5.32l-1.57,-1.62l-0.52,-1.25l0.36,-0.78l1.85,-0.31l0.42,-1.34l-0.43,-0.9l-5.19,-4.82Z",name:"Saarland"},"DE-BY":{path:"M307.24,662.75l0.86,-0.85l0.92,0.01l0.77,-0.48l0.41,-3.68l0.81,-1.04l3.72,-0.82l5.12,-2.0l2.55,1.34l1.32,0.36l-0.83,1.47l0.4,0.46l0.46,-0.03l2.16,-1.19l1.78,-1.75l0.49,-2.09l3.29,-0.87l9.69,0.58l4.61,1.99l0.68,0.67l0.77,1.74l1.59,1.62l2.33,0.32l1.62,-0.2l6.17,-2.23l0.81,-0.71l0.31,-0.73l-0.49,-3.2l1.7,-3.26l-0.64,-0.92l-2.32,-0.46l0.95,-3.62l-0.18,-3.43l1.88,0.4l1.07,-0.46l1.62,1.38l2.27,-0.43l1.71,0.66l1.51,-0.04l4.99,-1.4l0.46,-0.63l-0.67,-1.37l0.04,-0.77l0.65,-1.65l0.73,-0.82l0.6,-0.5l4.05,-1.4l1.68,-0.95l1.08,-1.11l0.12,-1.5l-0.59,-4.05l2.29,-6.91l1.08,-1.41l1.88,-0.6l2.59,2.37l1.15,0.36l2.03,-0.12l5.96,-1.94l6.14,-3.03l2.02,-1.47l1.25,-1.69l3.15,-4.7l1.02,-2.47l5.27,-4.94l1.17,-0.69l0.08,1.25l0.81,0.65l5.41,-0.31l1.16,0.29l1.63,1.47l0.74,2.27l0.54,0.65l9.39,3.01l0.77,1.25l0.03,1.8l0.44,0.78l1.44,1.0l1.71,1.89l2.58,1.75l-0.8,1.6l0.11,0.62l0.93,1.11l2.6,0.42l2.27,-0.53l0.56,1.24l0.9,1.03l2.62,1.88l0.23,1.17l0.56,0.48l2.81,0.21l1.06,-0.67l1.25,-0.14l1.25,2.28l2.44,1.7l0.83,4.11l-0.62,2.8l1.31,2.75l-0.33,1.46l0.63,1.21l1.07,0.93l4.39,-0.02l2.31,0.54l3.38,1.67l0.63,-0.1l0.41,-0.53l0.49,-4.06l0.51,-0.49l1.78,0.58l3.89,-0.64l3.02,0.94l1.19,-0.17l0.81,-0.86l0.12,-1.97l-0.74,-1.51l-2.78,-0.9l-0.75,-1.34l-0.65,-0.53l-2.94,-0.17l-1.83,-1.61l-2.67,-1.32l-0.59,-0.61l0.29,-3.55l0.33,-0.63l0.53,-0.32l1.93,0.55l0.91,-0.15l2.26,-3.1l0.7,-0.52l2.07,0.49l2.62,-1.16l2.08,0.23l1.63,-0.61l1.98,1.54l3.25,-0.73l1.24,0.05l3.26,4.0l1.12,0.8l0.76,-0.31l0.41,-1.39l2.52,0.3l1.03,0.66l0.58,0.81l0.94,0.27l3.67,-0.89l1.28,-1.14l1.14,-0.21l0.8,1.45l1.46,0.33l1.75,2.56l-1.95,2.16l-0.04,0.53l0.85,1.12l4.81,3.81l0.59,-0.1l1.09,-1.49l1.27,0.86l2.3,0.6l1.35,-0.24l0.41,-0.8l-0.17,-1.28l1.04,-2.16l-0.67,-2.01l1.11,-2.55l-0.17,-1.39l0.9,-0.32l0.25,-0.59l-0.33,-2.13l-1.14,-1.63l-0.11,-1.2l-0.5,-0.91l0.35,-3.12l-0.78,-2.67l0.16,-1.09l-0.65,-1.75l2.34,-0.94l1.98,-0.4l2.01,-1.11l0.52,-0.59l0.42,-1.4l1.23,-0.51l0.79,-0.82l6.04,0.28l1.44,0.39l0.99,1.7l-1.77,1.46l-0.24,4.31l0.32,1.33l3.45,2.23l1.36,-0.2l0.85,0.2l0.31,0.45l0.24,2.83l0.33,0.58l3.94,2.39l0.86,0.11l2.4,-0.52l1.34,-1.56l1.94,0.02l3.06,0.99l11.65,-2.06l1.71,-0.43l0.59,-0.74l2.05,-0.29l0.95,0.07l0.72,0.83l1.73,0.68l0.04,1.1l0.84,0.31l4.45,-1.52l3.2,-1.58l2.44,-0.21l0.65,0.23l2.01,2.64l1.96,1.08l0.37,4.11l0.46,0.54l5.42,2.83l2.27,0.01l2.57,0.63l0.21,0.31l-1.66,-0.1l-0.39,0.25l0.11,0.45l2.22,1.95l0.72,1.03l0.34,1.69l-0.16,1.44l-1.61,1.1l-1.23,1.55l-0.02,0.47l1.16,1.66l4.8,2.52l3.4,3.53l0.71,1.43l0.26,1.79l-0.67,2.84l0.08,2.18l0.97,2.1l4.34,2.83l0.78,1.13l0.55,3.29l15.17,6.93l1.41,1.16l3.71,0.4l1.43,1.15l0.22,1.61l-0.67,1.74l0.11,1.78l5.34,2.42l0.45,0.69l-0.28,2.29l-0.76,1.87l-2.24,3.49l-0.64,1.71l-1.62,-0.42l-0.48,0.26l-0.62,1.92l-0.34,4.58l-1.39,1.19l-3.99,1.43l-1.4,2.43l1.54,3.06l2.13,2.57l2.95,1.97l4.55,1.89l0.69,1.16l0.06,1.48l-0.78,1.47l0.13,0.52l0.72,0.37l-0.28,1.38l1.12,1.11l2.29,1.06l0.94,0.87l0.63,1.26l0.87,4.35l1.27,2.71l0.81,1.02l1.28,1.08l2.14,0.19l0.44,0.3l0.41,6.2l0.53,2.18l1.12,1.84l2.11,1.51l4.46,1.78l1.87,1.64l3.18,6.03l1.79,1.56l2.02,0.61l5.88,0.72l1.84,-0.21l0.34,-0.5l-0.33,-1.25l0.87,-0.23l3.62,0.84l1.6,0.72l4.11,3.4l1.69,0.63l1.12,3.4l3.2,3.22l1.21,0.59l9.1,10.48l1.3,2.51l1.71,2.25l2.78,1.38l6.04,0.27l1.85,0.61l1.11,0.81l2.99,3.39l4.11,3.55l1.02,2.05l0.06,3.46l1.49,2.17l2.89,2.32l3.15,1.92l2.35,0.96l0.51,-0.2l1.85,-3.44l1.14,-0.44l2.08,0.37l5.02,2.79l1.6,-0.1l0.24,2.12l1.04,2.3l1.58,2.05l1.73,1.48l1.97,0.81l3.69,0.51l1.23,0.58l2.21,2.93l4.73,8.01l1.76,1.57l-2.77,4.98l-0.27,1.32l0.72,0.39l0.98,1.59l1.19,0.69l-0.93,0.88l-0.25,1.51l0.51,4.16l-0.36,3.82l-0.59,1.59l-2.07,3.59l-1.4,0.86l-2.62,0.4l-0.87,1.54l-0.73,2.83l-3.74,-1.44l-1.54,-1.97l-3.43,-1.85l-10.31,-2.43l-3.36,0.39l-3.33,1.09l-0.98,0.8l-0.59,1.14l0.75,3.31l0.93,1.31l0.18,0.93l-0.24,1.09l-1.8,3.62l-0.19,5.97l-0.88,1.53l-0.74,3.27l-1.29,1.84l-9.51,7.1l-3.21,1.53l-13.46,2.01l-10.24,3.47l-1.71,1.03l-3.61,2.97l-3.18,1.52l-1.61,1.35l-5.06,0.84l-1.58,0.71l-4.05,4.56l-3.86,2.32l-1.84,2.3l-1.73,0.34l-0.82,1.06l-0.24,2.03l0.53,1.74l0.9,1.55l0.97,1.3l6.85,6.14l1.41,2.68l0.83,2.85l0.85,1.09l2.44,1.29l4.33,3.43l3.29,6.55l2.39,2.99l-6.14,8.46l-0.58,1.08l-0.38,2.35l-2.42,3.25l0.06,0.54l1.8,1.49l5.47,0.87l1.68,-0.24l2.39,-0.9l1.33,0.18l2.26,1.91l1.88,2.76l0.75,1.73l0.26,1.51l-0.25,2.82l-1.47,3.08l-1.87,1.89l0.16,2.88l-1.16,2.39l0.08,2.98l0.81,2.91l-3.21,3.13l-0.82,0.03l-2.2,-1.25l-1.18,0.06l-1.46,0.57l-5.65,-3.39l-5.34,-4.83l-2.51,-0.56l-2.21,-1.53l-0.47,-2.8l1.09,-2.63l2.53,-1.08l0.1,-0.68l-2.01,-1.66l-2.49,-1.41l-1.31,-1.38l0.9,-1.93l-0.41,-0.57l-1.62,0.18l-5.53,-1.21l-3.58,0.01l-3.5,0.72l-1.94,0.83l-4.41,3.37l-1.44,0.55l-3.9,0.29l-1.27,-0.54l-3.58,-2.72l-1.52,-3.59l-0.76,-0.97l-1.8,-0.26l-3.82,1.26l-1.56,0.22l-5.73,-1.03l-2.14,0.26l-3.1,1.1l-0.75,-0.58l-0.44,-1.13l0.9,-1.48l0.88,-2.83l-0.42,-0.58l-2.65,1.08l-2.36,1.68l-1.5,0.52l-0.26,0.45l0.6,1.9l2.2,2.3l0.16,3.24l-0.39,1.75l-2.66,2.94l-23.2,-0.73l-8.35,1.48l-1.11,0.57l-1.09,2.14l-0.75,0.21l-5.44,-0.96l-8.03,-0.03l-6.12,-0.79l-3.44,2.62l-1.92,5.31l-1.66,1.59l-2.01,0.69l-4.49,0.64l-4.61,-0.88l-2.36,0.46l-4.83,4.69l0.19,0.67l2.05,0.77l0.24,0.6l-0.65,0.95l-1.41,0.52l-4.19,0.09l-1.92,0.52l-2.04,1.59l-2.66,2.76l-1.98,0.78l-1.87,-0.18l0.19,-3.0l-0.27,-0.4l-2.32,-0.75l-2.59,0.63l-6.36,3.79l-1.81,0.48l-10.09,-0.13l-1.18,-0.59l-0.71,-1.19l0.59,-1.65l-0.45,-1.68l-4.9,-4.54l-5.06,-2.05l-0.36,-0.53l2.8,-1.64l0.91,-0.92l-0.07,-0.61l-3.34,-1.99l-1.63,-0.11l-5.35,1.9l-2.77,0.29l-0.65,-0.17l-1.31,-1.65l-12.95,-4.21l-2.49,-0.05l-1.67,0.96l-1.95,2.34l-1.13,0.78l-1.01,0.15l-4.07,-0.53l-1.45,-0.57l-1.12,-0.88l-0.13,-0.83l0.94,-1.84l-0.6,-1.59l-0.7,-0.28l-2.39,0.51l-1.47,0.5l-0.27,0.43l0.2,1.23l1.43,2.63l-1.1,5.97l0.22,0.44l2.06,1.33l0.48,1.0l0.38,1.46l0.02,2.56l-0.86,2.7l-1.39,2.45l-1.56,1.79l-3.99,1.77l-2.78,4.56l-1.72,1.99l-1.86,1.46l-4.33,2.29l-2.07,0.69l-7.6,0.8l1.04,-1.69l1.51,-0.48l0.76,-0.68l0.26,-0.97l-0.25,-1.51l1.75,-4.61l0.07,-2.24l-0.23,-0.38l-2.04,-0.87l-4.31,0.67l-1.64,1.38l-1.84,-0.58l-2.6,1.03l-0.76,-0.64l-0.46,-1.04l-0.36,-2.61l-0.84,-0.94l1.83,-1.22l0.61,-1.51l-0.9,-1.8l-4.86,-6.13l-0.46,-0.12l-2.68,1.35l-0.75,-0.39l-0.18,-1.4l-0.89,-1.68l-2.22,-2.21l-0.26,-1.94l-0.62,-0.28l-1.11,0.77l-1.35,0.23l-2.83,-0.19l-3.12,-0.93l-2.33,0.82l-1.74,-0.77l-0.3,-1.06l0.18,-1.57l-0.44,-1.68l-1.15,-1.08l-1.54,-0.52l-1.76,0.16l-1.54,0.73l-2.14,2.14l-1.14,2.09l-3.79,-0.83l-4.02,-2.5l-2.2,-0.96l4.11,-1.04l1.04,-1.33l1.35,-0.56l3.53,0.8l4.42,-1.94l7.33,-5.6l2.8,-1.14l3.86,1.42l2.37,0.49l2.45,-0.02l3.49,-0.99l2.12,-1.01l2.36,-0.56l1.69,0.03l0.49,0.32l1.53,3.25l0.63,0.05l1.06,-1.28l0.32,-2.33l2.77,0.72l0.95,-0.65l0.45,-1.9l-0.84,-2.57l-0.57,-6.54l-0.51,-0.77l-1.25,-0.17l-0.63,-1.11l-1.28,-1.18l0.73,-1.09l2.32,-0.31l0.78,-1.2l0.87,-0.35l0.19,-0.55l-2.55,-5.48l-0.46,-0.42l-1.19,-0.07l0.99,-0.98l0.52,-2.31l0.43,-0.62l0.41,-4.61l-0.21,-0.8l-1.3,-1.23l-0.94,-2.04l0.15,-0.59l1.32,-0.92l2.91,-6.98l0.74,-2.83l0.16,-4.81l-0.34,-1.72l-2.62,-5.07l-3.85,-15.14l-1.57,-4.54l-3.15,-4.58l-1.91,-3.58l-0.58,-0.34l-0.85,0.02l-0.61,-0.97l5.26,-6.27l0.65,-0.36l0.18,-0.49l-0.29,-1.44l0.86,-1.38l1.22,-1.05l3.32,-0.59l2.26,-1.41l0.64,-0.05l0.52,0.41l0.5,1.82l0.68,0.43l0.85,0.06l9.54,-4.95l0.53,-1.77l1.16,-1.12l5.1,-0.59l-0.07,-0.71l-0.53,-0.48l1.09,-2.68l0.18,-1.6l-0.23,-1.4l-0.9,-1.6l-0.18,-0.94l1.66,-0.87l0.43,-0.45l0.1,-0.83l-0.62,-0.92l-4.02,-2.53l-1.63,-2.66l0.12,-1.36l2.05,-2.42l2.29,1.65l2.94,0.13l1.54,2.66l0.82,0.44l0.86,-0.45l4.95,-4.66l0.73,0.33l-0.54,0.39l-0.02,1.02l-0.58,1.71l0.38,0.92l0.51,0.34l1.7,-0.72l4.25,-3.37l0.09,-0.53l-1.73,-2.74l-0.67,-1.65l-2.99,-1.08l-0.6,-0.67l-0.17,-0.81l0.06,-1.09l0.73,-1.24l-0.03,-3.13l1.39,-1.63l0.55,-2.26l-1.07,-2.44l0.47,-1.36l0.33,-4.38l-0.19,-0.8l-0.75,-0.6l1.86,-0.82l0.18,-1.17l-0.92,-2.48l-1.26,-1.18l-0.71,-1.52l-1.57,-1.53l-0.85,-1.38l-4.06,-2.83l-0.5,-0.58l-1.1,-2.75l-0.54,-0.32l-1.35,-0.01l-2.3,-1.07l-1.55,-0.02l-2.24,-0.82l0.39,-1.87l-1.89,-1.74l0.2,-1.55l-3.01,-1.34l1.83,-0.24l1.04,-1.59l0.6,-2.59l-0.35,-1.51l-2.28,-1.74l-0.95,0.09l-1.23,0.62l-3.67,-3.85l-3.02,-1.98l0.92,-0.35l0.31,-0.87l-1.55,-2.1l-0.17,-2.79l-1.4,-1.31l-0.23,-0.65l0.06,-0.21l2.18,0.83l0.87,-0.6l0.1,-1.15l-1.24,-2.85l0.7,-2.29l-0.29,-0.62l-2.05,-0.88l-0.86,-1.0l-0.22,-0.72l0.25,-3.33l1.56,-1.58l0.84,-0.1l1.86,0.55l0.62,-0.68l-3.12,-6.63l-2.65,-1.08l1.1,-1.43l0.77,-2.15l-1.08,-2.6l0.77,-1.6l-0.13,-1.06l-0.64,-0.52l-1.45,-0.17l-0.84,-0.48l0.52,-1.56l-0.13,-0.62l-1.08,-0.74l-1.14,-0.28l-2.36,1.58l-0.49,0.71l0.01,0.44l0.8,0.92l0.02,0.91l-3.59,3.2l-0.7,0.32l-7.69,0.0l-0.45,-3.4l0.24,-2.35l-0.43,-2.82l-0.44,-0.74l-1.19,-0.83l0.57,-1.19l-0.7,-1.14l-1.22,-0.12l-1.73,1.79l-1.44,0.57l-0.95,2.06l-0.66,0.3l-1.11,-0.51l1.98,-2.18l0.04,-2.29l1.77,-2.05l0.43,-1.48l-0.83,-1.39l-3.8,-3.59l-0.24,-4.98l-3.88,-4.3l-0.65,-0.13l-2.79,1.25l-3.39,3.08l-1.09,-1.87l-0.26,-1.92l-0.37,-0.42l-0.69,-0.04l-0.95,1.22l-1.44,0.77l-0.45,2.03l-0.73,0.27l-1.28,-0.13l-1.86,-1.01l0.85,-1.87l-0.08,-1.09l0.84,-0.79l-0.2,-1.41l0.56,-1.34l-0.32,-1.95l0.7,-1.47l-0.22,-0.68l-0.62,-0.5l-0.52,-0.04l-1.67,0.91l-2.47,0.68l-2.58,-1.4l-1.93,0.5l-1.07,-0.08l-5.23,-2.09l-1.95,-0.07l-3.63,0.46l-3.49,1.08l-4.71,-0.28l-1.32,0.34l-1.28,0.7l-1.63,1.68l0.67,2.26l-0.68,1.36l0.15,1.16l1.52,0.85l3.77,0.63l0.26,0.43l-0.4,1.79l0.49,0.74l0.92,0.08l0.9,-0.42l1.16,-2.18l2.28,0.8l-1.01,5.79l0.66,1.44l-1.49,1.17l-0.6,-0.04l-1.11,-1.02l-0.8,-0.27l-2.96,1.06l-3.2,0.23l-2.21,0.94l-0.91,1.03l0.29,2.08l-1.32,1.17l-0.69,1.82l-0.76,0.83l-6.21,0.17l-1.56,-0.21l-5.51,1.02l-0.81,-0.43l-1.36,-1.97l-1.97,-1.61l-0.28,-0.55l3.13,-2.68l0.61,-0.96l-1.14,-5.85l2.13,-0.38l1.38,-1.37l-0.23,-2.35l1.6,-3.44l-0.49,-0.75l-2.19,-0.91l-0.2,-0.63l1.53,-1.91l0.54,-1.57l-1.04,-1.29l-2.07,0.2l-1.03,-0.66l-0.76,-1.74l0.22,-3.05l-0.25,-0.72l-1.03,-0.1l-1.19,1.58l-0.64,-0.99l-3.46,-8.98l0.19,-8.9l1.56,0.51l0.63,-0.19l0.26,-0.5l-1.22,-2.34l0.03,-1.65l-0.89,-1.16l-0.52,-2.77l-0.62,-0.81l-1.3,-0.26l-1.47,0.54l-1.3,-0.69Z",name:"Bayern"},"DE-HE":{path:"M189.06,662.8l6.22,-3.72l0.46,-0.72l0.37,-2.21l1.03,-1.35l1.72,0.1l1.59,-0.34l1.56,1.35l0.71,0.28l0.56,-0.14l1.0,-3.2l0.01,-0.9l-0.54,-0.58l-2.12,-1.09l-0.61,-0.67l-0.06,-0.76l0.19,-1.05l1.13,-2.19l1.06,-1.29l5.64,-2.46l1.19,-1.1l1.97,1.5l1.1,0.01l2.15,-2.8l-0.16,-0.7l-0.79,-0.83l0.65,-1.58l5.18,0.04l1.71,-0.39l1.12,-1.08l0.01,-1.4l-1.48,-4.04l-0.77,-1.2l-1.95,-1.33l-2.99,-5.25l-1.77,-0.79l-0.33,-1.2l-0.43,-0.34l-4.82,-1.27l1.32,-1.24l1.23,-3.58l1.88,-1.97l-0.26,-0.58l-1.68,-1.09l0.1,-5.36l0.34,-1.28l1.56,-1.0l1.46,-1.69l1.46,-0.49l1.42,0.13l2.34,2.22l1.53,0.16l0.9,-0.33l2.37,-1.77l2.65,-5.78l-0.4,-0.95l-0.99,-0.56l-0.54,-0.95l-0.35,-1.95l-1.97,-4.04l0.97,-2.07l0.42,-2.19l0.87,-1.67l0.55,-0.5l1.34,-0.37l0.43,-0.57l0.8,-4.78l-0.87,-1.26l-2.35,-1.53l-0.08,-0.85l-0.76,-0.58l0.0,-0.35l5.11,-3.82l0.98,-2.01l1.94,-1.17l0.84,-1.0l5.61,-4.56l1.55,-0.06l0.97,1.8l0.86,0.57l1.74,0.25l2.76,-0.24l3.21,-1.88l0.37,-0.79l-0.07,-1.12l2.78,-2.36l1.56,-0.88l2.12,0.06l0.52,-1.07l0.13,-2.84l2.01,-3.69l0.51,-0.49l1.34,-0.46l1.66,-3.08l1.9,-2.43l-0.97,-3.82l0.23,-1.74l-1.61,-2.78l0.25,-0.65l9.73,-0.04l3.41,0.7l4.7,-2.49l0.13,-1.34l-1.08,-1.92l2.08,-2.41l3.15,-2.93l0.33,-0.95l-0.07,-1.74l-1.95,-7.73l-1.12,-0.81l0.39,-1.08l-0.17,-0.64l-0.62,-0.46l-0.83,0.01l-2.71,1.53l-4.44,0.76l-1.35,1.51l-0.75,0.14l-1.38,-0.44l-0.54,-1.6l-1.74,-1.31l0.16,-0.72l1.5,-2.53l2.08,-2.26l3.23,-2.73l0.6,-1.27l1.72,-0.95l1.16,-1.45l4.72,-1.37l3.75,-0.17l3.54,-0.82l4.62,0.89l3.74,-1.97l4.02,-0.17l0.55,-0.29l1.0,-1.67l0.25,-1.18l-1.05,-1.11l-2.21,-0.32l-0.38,-3.62l-1.42,-2.11l0.62,-1.45l5.0,-2.08l4.02,-0.87l1.52,-0.65l3.17,1.66l2.7,0.9l0.5,0.61l0.17,1.06l-0.15,2.25l2.49,2.08l3.82,0.67l1.33,-0.08l3.58,-2.32l1.97,-0.15l0.56,-1.04l0.64,-2.92l7.03,-3.95l1.49,-2.4l2.0,-1.81l0.9,-1.62l1.49,-4.22l-0.27,-0.71l-1.68,-1.12l7.81,-2.32l0.86,-0.74l1.31,-1.93l0.99,0.39l1.68,-1.34l1.57,0.14l0.46,2.42l1.75,0.9l2.24,-0.07l1.99,-1.46l1.18,1.16l1.43,0.54l1.66,0.17l2.57,-0.67l0.82,1.66l2.26,1.14l1.16,2.98l1.77,1.61l-0.91,1.14l-2.57,-1.6l-0.99,0.03l-0.47,0.52l-0.05,0.71l0.99,1.75l-1.64,-0.47l-0.7,0.14l-0.31,0.51l-0.39,3.23l-1.24,0.25l-0.51,0.49l0.18,1.27l1.92,3.63l1.22,1.37l0.91,0.41l-0.82,1.44l0.67,1.4l-0.22,1.74l0.37,3.21l-0.37,0.67l-5.26,0.47l-1.71,1.99l0.1,1.18l0.7,1.56l-3.19,-0.74l-0.45,0.48l0.72,1.25l2.98,2.22l8.44,2.96l1.4,0.03l1.12,0.52l2.78,2.99l1.71,0.24l0.99,-0.41l3.57,-2.85l0.4,-0.61l0.05,-1.02l0.91,-0.92l0.25,-0.83l-0.71,-0.75l-0.63,-0.06l-2.27,1.39l-2.96,-2.41l-0.52,-1.13l5.21,-2.78l2.45,-0.67l0.99,-0.94l-0.43,-1.37l2.91,1.36l1.54,2.67l0.81,0.67l1.3,-0.11l0.91,-0.89l0.29,-0.97l-1.31,-2.87l1.9,-0.18l1.4,-1.02l0.32,1.9l3.81,2.58l-1.46,1.07l-0.75,1.73l0.64,2.78l1.28,1.69l0.21,2.45l0.43,0.75l1.62,0.46l0.82,1.1l1.15,0.78l1.9,0.02l4.46,1.18l0.25,0.35l-0.49,1.09l0.04,0.85l0.56,0.87l1.52,1.05l0.38,1.85l0.52,0.68l3.5,1.25l2.03,0.33l1.52,0.78l2.41,0.13l2.32,1.45l3.23,1.4l-0.24,0.85l-1.43,1.46l-0.63,1.44l-0.64,4.09l-0.9,-1.05l-0.05,-1.06l-1.42,-1.4l-1.74,-0.02l-2.24,0.52l-1.07,0.82l1.54,2.44l2.61,0.65l-0.33,1.29l-1.77,2.83l-0.63,3.16l0.4,0.72l1.69,0.29l1.23,0.8l1.93,0.22l1.12,1.6l0.27,1.05l-1.58,2.94l-5.34,0.22l-0.77,-0.42l0.07,-1.0l-0.63,-0.47l-1.56,0.41l-1.13,-0.34l-4.22,0.2l-2.58,1.51l-0.45,2.05l0.29,0.98l1.64,1.88l0.26,1.48l-0.27,0.7l-2.54,0.46l-3.39,-0.3l-1.58,-0.48l-0.99,0.34l-0.44,0.87l0.21,1.67l0.93,0.27l0.72,-0.49l-0.07,1.56l0.45,1.2l0.86,0.09l1.69,-1.65l1.02,-0.15l2.22,1.43l1.99,3.1l-2.73,2.91l-0.27,0.57l0.31,1.21l-0.24,1.38l-2.81,0.88l-2.01,0.22l-1.52,0.55l-0.92,0.75l-0.79,2.63l0.37,2.31l-1.66,0.35l-0.79,1.45l1.44,1.95l-0.21,2.08l-2.03,3.63l0.06,1.51l-1.9,1.56l-1.21,1.72l-0.4,3.33l0.25,0.99l0.53,0.55l0.64,0.09l1.67,-0.53l2.71,1.2l1.5,0.1l0.86,-0.45l0.74,-1.59l-1.3,-1.8l0.22,-0.79l4.97,-1.71l4.58,0.88l0.84,0.67l1.02,2.21l0.21,2.8l-1.57,0.46l-1.0,0.94l-0.37,0.8l0.33,1.49l-0.08,3.19l0.81,1.99l-1.2,4.17l0.37,0.84l0.48,0.17l-0.79,1.94l-4.23,6.19l-1.88,1.37l-6.08,3.01l-5.77,1.88l-1.85,0.11l-0.86,-0.29l-2.75,-2.43l-2.62,0.79l-1.26,1.68l-2.34,7.08l0.55,5.34l-2.41,1.72l-4.04,1.39l-0.82,0.67l-0.87,1.02l-0.73,1.9l-0.03,1.05l0.51,1.18l-4.68,1.27l-1.31,0.02l-1.71,-0.66l-2.15,0.43l-1.62,-1.37l-1.32,0.45l-1.62,-0.4l-0.79,0.27l-0.3,1.28l0.31,2.57l-0.98,3.73l0.55,0.82l2.43,0.55l-1.67,3.05l-0.14,0.8l0.59,2.64l-0.76,0.76l-5.86,2.1l-1.42,0.19l-2.14,-0.3l-1.19,-1.32l-0.89,-1.92l-0.71,-0.64l-4.87,-2.13l-10.04,-0.61l-3.71,1.06l-0.56,2.17l-1.63,1.62l-1.41,0.86l0.51,-0.78l-0.2,-0.69l-4.5,-1.94l-5.38,2.04l-3.79,0.85l-0.88,0.74l-0.36,0.83l-0.26,3.37l-1.59,0.36l-1.25,1.35l0.13,0.59l1.66,0.94l0.5,0.1l1.48,-0.57l0.77,0.12l0.34,0.4l0.51,2.75l0.93,1.28l-0.09,1.47l1.05,1.97l-1.77,-0.58l-0.52,0.37l-0.2,9.52l3.53,9.26l0.81,1.24l0.73,0.23l1.47,-1.73l-0.18,3.35l0.87,2.03l1.2,0.94l2.28,-0.17l0.56,0.73l-2.08,3.19l0.05,0.77l0.48,0.63l2.33,1.07l-1.56,3.17l-0.13,1.17l0.33,1.26l-0.96,0.79l-1.87,0.26l-0.66,0.5l0.08,1.81l1.07,4.11l-0.39,0.63l-2.41,1.88l-0.97,1.27l0.48,1.19l1.95,1.59l1.21,1.76l-0.66,0.9l-2.0,-1.11l-0.72,0.41l-0.06,0.94l2.49,2.72l2.67,4.35l-0.53,-0.08l-1.27,-1.24l-2.83,-0.14l-1.03,0.15l-2.22,1.81l-0.82,0.27l-2.29,-0.37l-5.77,0.21l-2.88,3.09l1.56,2.62l0.21,0.73l-0.38,0.71l-2.29,1.12l-0.74,-1.11l-0.8,0.1l-1.03,2.77l-3.65,3.39l-3.34,-0.68l-0.21,-0.48l0.2,-1.48l1.57,-0.92l0.38,-0.8l-0.38,-3.0l0.18,-1.13l1.84,-1.85l1.51,1.25l1.11,-0.21l1.61,-2.44l0.13,-1.04l-0.34,-0.85l-0.4,-0.23l-5.94,0.42l-1.96,-2.58l-4.29,-0.09l-4.48,-2.24l-1.09,-1.05l-1.37,-2.83l-0.42,-1.33l0.56,-1.04l-0.1,-1.22l-1.11,-1.39l-0.19,-0.98l-0.45,-0.46l-0.7,-0.06l-7.39,1.79l-0.14,0.84l1.89,7.33l-0.58,0.7l-3.94,1.43l-6.51,-5.73l-2.49,-1.66l-2.58,-0.34l-2.96,1.03l-1.5,-3.6l-3.84,-6.83l0.16,-3.16l1.55,-2.32l2.53,-1.45l3.36,-0.63l3.44,-3.99l0.34,-1.44l-0.27,-0.46l-1.38,-0.46l-3.7,0.45l-1.35,-3.01l-1.84,-2.89l-0.93,-3.51l-1.02,-1.85l-2.22,-2.77l-0.65,-1.41l1.41,-4.57l-1.93,-4.35l-10.62,-10.19l-1.57,-0.86l-1.32,-0.28l-2.83,0.07l-12.29,3.51l-3.89,2.47l-4.64,2.05l-4.18,1.16l-3.72,0.11l-1.57,-1.95l-0.28,-1.51l-0.88,-1.29l-6.36,-4.84l-0.86,-0.31Z",name:"Hessen"}},height:1013.8952766123396,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","es_mill",{insets:[{width:900,top:0,height:738.0097895570743,bbox:[{y:-5213399.331391313,x:-2023392.062741889},{y:-3158091.8374794754,x:483047.242935642}],left:0}],paths:{"ES-NA":{path:"M644.33,66.96l0.33,-0.47l-0.06,-0.57l-1.06,-0.77l-4.56,-0.01l-3.42,-2.25l-2.68,0.3l-2.09,-0.61l0.41,-2.88l-0.35,-1.55l-1.11,-0.54l-1.2,1.07l-1.22,-0.54l-0.1,-0.43l3.06,-2.27l0.65,0.13l0.78,0.88l0.95,0.06l0.99,-0.29l1.52,-1.05l0.06,-0.84l-0.77,-0.62l-0.3,-1.84l1.14,-0.52l0.49,-0.59l0.2,-1.93l1.29,-2.35l0.12,-1.11l-0.51,-1.86l0.76,-1.53l0.86,-0.61l1.15,0.35l2.13,-0.29l1.26,-1.32l1.85,-0.67l0.48,-0.95l-0.04,-1.13l0.94,-1.72l3.01,-1.84l1.13,-1.56l-0.22,-2.6l0.26,-1.09l0.8,0.16l0.52,-0.71l0.94,0.15l0.7,-0.33l2.4,-2.91l3.7,-0.68l0.83,0.39l0.29,1.71l1.01,0.69l1.61,-0.26l1.05,-1.53l1.81,0.33l1.64,0.76l1.38,-0.17l0.92,0.84l0.13,1.56l-0.99,3.29l-2.12,2.14l-0.38,0.83l0.58,1.16l1.71,1.26l2.23,0.36l0.82,-0.21l0.58,-0.85l0.38,-2.22l1.18,-0.76l-0.59,1.16l0.28,0.82l0.68,0.69l0.98,0.52l2.26,0.36l2.57,1.56l1.68,-0.04l1.32,0.71l1.88,0.29l1.87,1.41l1.64,0.49l3.27,0.25l3.08,-0.48l0.81,0.25l0.27,0.63l-2.17,0.86l-0.53,1.38l-1.12,1.36l-0.77,3.72l-3.77,2.8l-2.51,0.76l-0.37,0.45l-0.42,1.76l-4.02,0.43l-0.5,1.1l-0.42,0.14l-0.15,0.69l0.41,0.25l-0.95,0.56l-0.89,1.33l-0.53,0.24l-1.43,-0.09l-0.93,1.14l-0.3,1.02l0.45,1.24l-2.74,3.48l-0.3,1.88l0.7,0.96l-2.06,2.62l-1.33,3.98l0.08,0.95l0.72,1.23l0.23,2.88l1.69,2.33l1.42,0.67l-0.31,1.0l-3.58,5.5l-2.79,-0.62l-2.55,0.54l-3.27,-2.18l-0.96,-0.24l-1.68,0.34l-1.0,-0.41l-1.46,-1.26l-3.45,-0.56l-1.34,-1.01l-0.34,-0.79l0.15,-1.16l2.77,-3.2l1.47,0.33l1.44,-0.35l1.32,0.5l1.26,-0.44l0.11,-2.06l-0.34,-1.72l-1.38,-1.1l-2.75,-1.2l-1.35,-1.02l-1.06,-0.0l-0.29,-1.31l-1.47,-0.96l-2.98,-3.22l-2.46,-0.12l-1.0,-0.59ZM683.47,65.61l-1.86,-0.44l0.31,-0.84l0.41,-0.32l0.27,0.9l0.88,0.7ZM679.34,67.04l-0.19,-0.41l0.68,-0.41l-0.23,0.57l-0.27,0.25Z",name:"Navarra"},"ES-B":{path:"M793.32,86.52l1.15,-1.57l0.06,-2.01l0.9,-0.59l-0.18,-2.03l1.18,-1.52l-0.29,-1.3l-1.59,-1.0l-0.28,-1.88l1.1,-1.25l7.73,-1.42l0.82,0.17l1.52,0.95l2.21,-0.18l0.36,0.79l-0.69,1.02l-0.2,1.34l1.09,1.51l0.18,2.07l0.48,0.92l1.43,0.1l1.54,0.85l1.12,-0.37l1.93,-0.06l0.99,-0.64l1.71,-0.05l0.99,1.35l1.04,0.12l1.41,-0.36l1.51,1.81l0.79,0.44l1.47,-0.01l1.16,1.07l0.17,1.68l-2.39,2.77l0.06,0.56l0.86,0.97l-0.59,1.05l-0.74,0.01l-1.42,0.76l-2.03,-0.78l-1.07,1.33l0.1,1.25l1.17,1.91l0.96,0.6l2.82,-0.21l4.67,4.01l3.58,-0.67l1.83,-0.78l2.33,0.62l0.64,0.55l0.19,0.75l-0.55,0.92l0.59,1.53l-12.75,5.12l-3.15,2.21l-3.03,1.17l-1.26,0.88l-1.08,1.32l-3.06,4.47l-1.24,1.04l-2.73,1.35l-4.31,0.65l-3.84,1.17l-1.43,-0.04l-7.25,1.99l0.02,-0.89l-0.32,-0.41l-1.77,-0.38l1.14,-0.69l0.51,-0.97l-0.13,-0.62l-1.14,-0.97l-0.72,-1.42l-0.28,-1.57l-1.1,-1.11l-1.96,-1.01l-0.39,-0.67l0.33,-1.23l-0.1,-1.43l-1.05,-0.72l-2.0,-0.71l-0.13,-0.31l1.1,-1.37l0.34,-1.08l-0.48,-0.53l-0.76,-0.1l-0.06,-0.63l-1.22,-0.59l0.46,-0.52l2.12,-0.69l0.04,-0.56l-1.23,-2.82l0.1,-3.61l0.29,-0.44l0.66,-0.16l1.39,1.16l1.48,-0.14l0.88,0.71l0.64,0.09l3.38,-3.26l0.23,-1.24l-0.71,-2.09l1.04,-1.52l0.15,-1.58l2.13,-0.42l0.67,-0.91l-0.12,-0.78l-0.43,-0.45l-0.72,-0.15l-0.96,0.35Z",name:"Barcelona"},"ES-CS":{path:"M733.51,147.84l1.65,0.04l0.88,1.17l1.58,0.74l-0.42,1.24l0.8,1.37l5.09,2.02l0.54,0.43l0.59,1.26l2.77,1.2l-0.72,1.61l-1.93,2.36l-0.3,1.23l-1.02,0.96l-2.76,4.85l-2.02,1.75l-1.37,1.75l-2.45,1.9l-2.4,4.32l-1.02,0.99l-2.11,1.23l-2.78,4.74l-3.53,3.95l-3.92,5.93l-2.72,-1.47l-1.61,-1.77l-1.45,-0.47l-1.66,0.71l-1.33,1.85l-1.57,0.91l-0.63,-0.17l-2.11,-3.08l-0.51,-0.13l-1.47,0.75l-1.26,1.38l-0.95,0.1l-0.29,-0.26l0.08,-1.48l-0.65,-2.35l-1.4,-0.78l-0.55,0.17l-0.73,1.4l-0.51,-0.09l-1.38,-2.16l-2.02,-1.76l-0.52,-1.67l0.12,-0.83l0.31,-0.46l2.02,-0.99l0.81,-1.74l2.6,-0.17l2.89,-1.32l0.29,-0.56l-0.21,-1.34l1.88,-2.15l0.74,-2.3l0.07,-1.53l1.88,0.41l2.15,-0.35l1.53,-0.66l0.82,-0.93l-0.03,-1.3l1.27,-1.0l1.0,-1.3l1.88,-1.31l-0.1,-1.3l-1.94,-2.2l2.35,-1.18l0.34,-0.51l-0.36,-1.24l-0.67,-0.56l0.14,-4.33l-0.66,-0.57l-1.0,0.22l-1.62,-0.53l-0.05,-1.53l0.89,-0.44l1.82,0.46l2.82,-1.5l0.41,-0.64l0.21,-1.97l1.29,-1.37l1.0,0.17l3.23,2.13l3.56,0.19l0.28,1.0l0.63,0.44l0.58,-0.03l1.82,-1.06l3.14,-0.52Z",name:"Castell\xf3n"},"ES-ZA":{path:"M447.68,88.37l-0.15,-0.9l0.8,-2.36l-0.65,-0.91l-1.43,-0.24l-0.29,-0.52l1.46,-1.8l1.25,-0.87l0.66,-1.66l1.59,-1.57l1.16,-0.74l2.41,-0.04l0.86,-1.56l3.52,1.77l1.56,-0.14l1.53,0.54l2.29,-0.07l1.25,0.28l1.27,0.76l2.78,-0.8l3.46,0.09l1.02,-0.37l1.13,1.34l3.2,1.51l6.37,-0.43l3.68,1.52l1.69,-0.58l0.59,-0.62l1.08,1.37l1.4,0.16l2.99,-0.79l0.76,1.04l2.65,-0.33l0.31,-0.81l1.39,1.08l0.21,1.47l2.85,0.99l0.52,-0.27l0.38,-1.37l0.23,0.01l0.49,1.72l1.33,2.27l-0.43,0.86l0.2,0.54l1.85,0.82l0.55,-0.28l0.62,-2.82l1.39,-0.39l3.35,2.62l-0.76,1.04l0.28,2.16l-0.44,1.87l1.0,2.65l-4.13,2.32l-0.17,0.51l0.88,1.99l1.66,2.31l0.15,1.81l0.39,0.93l1.34,0.66l-0.55,1.0l0.18,0.77l2.18,1.56l-0.91,0.75l-2.4,0.66l-0.54,0.66l-0.42,1.6l0.11,1.0l0.67,0.99l-0.25,3.16l1.05,1.96l0.28,2.34l-0.09,0.8l-1.61,1.71l-0.05,0.54l0.96,0.92l0.97,-0.13l-0.22,2.09l-0.8,0.14l-1.28,-1.21l-1.41,-0.15l-0.2,-1.54l-0.44,-0.35l-3.42,0.38l-2.18,-1.39l-2.4,-0.09l-1.77,-1.56l-0.76,-0.19l-1.72,0.82l-3.82,0.55l-3.03,-0.87l-0.92,0.1l-0.72,0.87l-0.04,3.16l-0.94,0.24l-0.36,-0.74l-0.52,-0.24l-0.98,0.69l-0.76,-0.53l0.17,-1.15l-0.59,-0.74l-3.21,-0.59l-0.88,0.65l-7.48,-3.84l-5.56,-0.95l1.35,-1.26l1.16,-1.69l0.96,-0.24l0.15,-0.98l1.82,-0.37l0.37,-0.4l1.46,-2.39l0.13,-1.48l2.94,-3.51l-0.02,-0.5l-2.75,-2.86l-1.79,-1.05l-2.03,-0.68l-3.91,-0.64l-1.83,1.14l-1.16,-0.24l-0.43,-0.59l-0.83,-2.9l0.64,-1.2l1.42,-4.78l-0.24,-0.56l-1.75,-0.49l0.29,-2.02l-0.26,-0.99l-0.69,-0.68l-0.97,-0.37l-0.5,0.19l-0.45,0.87l-3.89,0.42l-1.0,-0.27l-1.38,-1.91l-1.48,-0.36l-0.46,0.33l-0.22,1.24l-0.71,0.39l-2.35,0.17l-0.98,-0.18l-1.28,-0.82Z",name:"Zamora"},"ES-O":{path:"M444.89,15.73l0.57,-0.29l0.53,-2.12l0.58,-0.5l0.29,-0.92l2.03,-0.4l6.84,-0.12l2.68,0.53l2.32,-1.04l1.88,0.17l3.41,1.32l2.06,-0.33l0.3,-0.85l1.44,0.54l4.26,-0.36l3.51,-1.31l1.84,0.98l4.54,0.25l1.76,-0.89l4.56,0.0l0.57,-0.67l-0.32,-0.83l0.34,-0.86l1.34,-0.27l0.5,-1.0l0.32,0.02l1.99,1.13l2.88,3.27l0.6,0.16l0.38,-0.29l0.54,0.65l2.15,0.31l8.0,-0.3l0.91,0.21l-0.34,0.86l-0.65,0.55l0.23,0.89l0.5,0.1l1.64,-0.65l0.67,-0.89l1.99,0.07l3.39,1.86l1.44,0.47l3.51,0.17l0.77,0.19l0.34,0.5l0.87,-0.07l2.63,0.71l1.45,-0.61l4.08,1.05l4.15,1.6l8.46,0.66l0.03,0.45l-0.93,1.7l0.71,2.21l-0.5,1.02l-0.67,-0.79l-1.45,-0.25l-1.12,0.45l-0.94,0.82l-1.92,0.01l-1.05,0.39l-0.45,0.55l-0.16,2.09l-0.43,0.85l-3.2,0.19l-1.0,-1.53l-0.88,-0.68l-1.59,-0.14l-3.96,2.14l-2.3,0.76l-2.13,3.33l-1.53,-0.24l-2.15,0.94l-3.71,0.4l-2.74,-0.19l-0.67,0.5l-0.46,1.16l-2.78,0.2l-0.89,1.11l-2.2,0.34l-4.53,-1.32l-2.34,0.17l-0.63,0.37l-1.6,2.85l-0.52,0.3l-2.08,0.03l-2.8,-1.25l-1.4,-0.88l-0.59,-1.55l-0.82,-0.67l-1.37,0.2l-2.61,-0.35l-0.59,0.36l-0.45,1.16l-0.63,0.27l-3.09,-0.63l-0.73,0.22l-0.56,1.06l-5.38,-1.76l-1.29,0.59l-0.97,1.93l-2.49,0.65l-0.15,0.49l0.27,0.56l1.19,0.57l-1.99,1.08l-2.32,0.62l-2.94,-0.51l-2.67,0.14l-1.29,0.5l-1.18,1.0l-1.07,-0.81l-1.12,-0.18l-0.32,-2.07l-1.4,-1.46l-1.86,-0.35l-1.42,-1.5l-0.61,0.11l-0.21,1.28l-0.39,-0.37l-0.1,-0.72l0.88,-0.57l0.67,-1.56l1.13,-0.11l1.81,-0.73l1.56,-1.25l0.22,-0.81l-0.8,-1.65l-1.1,-0.93l-0.75,0.31l-0.67,0.99l-1.64,0.74l-0.35,-0.19l-0.44,-0.73l0.34,-1.4l-0.19,-0.63l-3.33,-1.98l-0.85,-2.97l-1.02,-0.6l-0.89,-1.14l-0.37,-2.09l-1.58,-0.55l0.21,-1.36l1.91,-0.03l2.59,-2.37Z",name:"Asturias"},"ES-OR":{path:"M393.45,63.58l1.32,-0.04l2.09,-1.92l1.46,-0.48l1.33,-1.27l1.12,0.96l3.12,-0.16l1.88,0.47l0.67,-0.33l0.71,-1.07l1.07,0.13l1.08,-0.41l1.14,1.2l-0.11,1.79l0.37,0.44l1.33,0.08l3.08,1.48l1.11,0.97l1.64,0.09l3.83,2.31l1.8,-0.2l2.43,0.57l4.47,-2.2l1.62,1.04l1.76,-0.24l1.88,0.46l2.49,4.12l0.72,-0.04l2.05,-4.85l1.9,-1.47l1.17,-1.99l3.33,0.41l2.4,-0.87l1.08,0.62l2.68,0.67l0.35,0.72l-0.14,1.08l-0.8,1.1l-0.09,0.69l3.85,2.79l0.03,1.88l-1.17,1.87l-1.17,1.13l-0.28,0.88l-2.2,0.03l-1.42,0.88l-1.78,1.77l-0.63,1.61l-1.16,0.78l-1.63,2.01l0.03,1.12l0.74,0.54l1.09,0.06l0.46,0.58l-0.82,1.93l0.11,0.82l-2.31,1.09l-3.57,-2.1l-0.95,0.08l-1.71,1.13l-0.03,3.12l-0.71,0.92l-1.2,0.68l-2.77,0.86l-2.75,0.16l-1.72,1.42l-1.01,-1.78l-1.86,-0.74l-0.85,0.31l-0.38,0.99l-0.48,0.31l-2.09,0.29l-0.37,-0.19l0.58,-1.55l-0.35,-0.55l-2.08,-0.08l-2.44,-1.16l-3.73,1.05l-1.17,-0.04l-0.63,0.28l-0.45,0.69l-0.77,-0.0l-0.31,-2.32l-0.53,-0.34l-1.04,0.52l-0.61,1.71l-1.88,0.18l-2.24,2.27l-1.64,0.42l-2.95,-0.16l-0.04,-1.75l-0.48,-0.51l-1.28,-0.45l-0.28,-1.33l1.82,-2.74l3.0,-2.23l0.5,-0.79l0.06,-1.05l-0.43,-0.85l-1.5,-0.89l-2.43,0.3l0.02,-2.59l-0.53,-1.11l1.37,-1.01l0.15,-1.72l0.57,-1.69l-0.47,-0.52l-2.68,0.64l-1.03,-1.0l-0.21,-0.77l0.52,-1.7l-0.27,-0.5l-0.81,-0.33l-1.16,-1.63l-0.02,-1.32l-0.93,-2.05l0.12,-2.39Z",name:"Orense"},"ES-M":{path:"M545.47,166.41l1.12,1.03l1.33,-0.17l0.69,-0.44l0.72,-1.17l0.39,-1.91l0.39,-0.46l3.66,-0.45l0.61,-2.94l-0.15,-3.5l1.2,-1.37l0.2,-1.0l-0.25,-1.16l0.57,0.73l1.02,0.28l2.9,-1.03l0.63,-3.19l2.78,-3.79l1.0,-0.59l1.63,0.22l1.19,-0.26l0.49,-0.43l1.38,-4.04l0.06,-1.62l1.74,-2.27l4.2,-1.54l2.17,-2.9l2.32,-1.57l2.4,-2.57l1.17,-0.65l1.4,-0.28l0.21,0.66l2.3,2.34l1.85,0.85l1.0,2.88l-0.08,0.87l-1.6,4.01l0.16,1.19l-0.86,0.78l-0.42,1.93l-0.76,1.41l0.3,0.69l1.42,0.5l0.38,0.6l0.25,1.59l-0.72,1.62l1.18,1.11l1.3,-0.06l0.55,-0.34l1.18,1.54l1.25,0.36l-0.15,1.98l0.45,0.79l0.9,0.67l-0.02,1.51l0.51,0.33l1.51,-0.41l1.54,1.2l0.29,3.22l1.64,0.97l0.63,1.19l-0.53,2.58l-1.02,1.21l-0.41,1.87l0.08,1.25l0.38,0.54l0.62,0.13l1.98,-1.55l0.4,0.14l0.73,1.78l0.31,2.8l-0.41,0.37l-0.01,0.69l0.91,2.06l-1.02,0.97l-0.67,0.19l-1.61,0.07l-0.38,-0.61l-1.02,-0.4l-4.04,1.66l-2.05,0.38l-1.32,-0.56l-1.3,0.52l-3.75,-0.14l-0.8,0.51l-0.47,0.76l-4.26,1.53l-0.26,1.09l-3.74,1.31l-2.52,2.03l-0.77,0.0l-1.54,-0.99l3.53,-1.05l0.87,-0.85l1.59,-0.83l1.85,-1.79l1.49,-0.76l1.03,-2.04l0.06,-0.98l-0.3,-0.59l-2.45,-1.25l-3.45,-0.29l-1.43,-1.29l-1.32,0.04l-1.08,-0.88l-5.7,-1.8l-1.1,-1.19l-1.29,-0.57l-0.73,0.01l-1.07,0.56l-1.15,-0.25l-1.86,-1.55l-2.62,0.76l-2.1,2.19l-1.62,-1.16l-0.34,-0.79l0.0,-1.49l-0.87,-0.71l-0.64,0.22l-2.68,3.18l-2.21,1.06l-0.87,0.76l-0.89,-0.07l-0.48,-0.29l1.51,-3.8l-0.31,-1.66ZM555.63,150.36l-1.47,0.1l0.06,-0.53l0.5,-0.43l0.54,0.1l0.37,0.76Z",name:"Madrid"},"ES-L":{path:"M741.11,122.28l-0.06,-0.86l0.95,-1.92l-0.09,-1.07l-0.49,-0.89l-1.42,-0.88l-0.07,-0.51l0.94,-2.05l0.02,-1.91l1.94,-0.94l1.57,-2.13l0.17,-0.67l-0.49,-1.92l-0.44,-0.57l-2.68,-0.5l-0.88,-3.03l2.95,-3.43l2.29,-0.67l1.52,-2.2l1.61,-0.66l2.19,-2.11l0.02,-2.49l-1.06,-1.03l0.53,-0.6l1.0,-0.43l1.86,-1.94l0.15,-1.24l1.91,-4.46l0.1,-2.83l0.55,-2.29l0.97,-2.15l0.32,-2.88l-0.2,-3.01l-0.56,-1.85l-0.74,-0.85l-0.48,-1.78l1.14,-0.76l0.13,-1.22l1.11,-2.02l0.31,-1.91l-0.35,-0.52l-1.58,-0.5l-0.53,-0.52l-1.67,-2.94l-0.26,-1.63l-0.85,-0.82l0.35,-0.33l0.08,-0.58l-0.29,-0.36l0.47,-1.13l0.06,-1.57l1.68,-0.3l2.71,0.68l1.41,0.03l4.32,2.28l1.3,-0.52l1.29,0.74l4.08,0.4l0.58,0.47l1.07,2.06l0.98,0.64l1.88,-0.33l5.32,0.13l0.04,0.68l0.91,0.39l2.51,4.14l-0.36,1.15l0.26,0.43l-0.71,1.48l0.44,0.49l0.74,-0.09l0.52,0.71l-1.4,0.66l-0.17,0.6l1.08,1.5l0.18,0.81l0.63,0.37l2.84,0.25l1.25,-1.02l2.38,-0.28l1.38,-0.51l0.6,-1.34l1.13,0.2l0.66,-0.26l0.77,2.26l0.71,0.6l2.42,0.8l0.08,1.53l0.98,1.5l0.1,1.73l-4.61,0.8l-1.63,1.93l0.35,2.31l1.84,1.52l-0.13,0.6l-1.05,1.12l0.27,1.73l-1.0,0.93l-0.02,1.93l-1.01,0.99l-0.26,0.71l0.52,0.92l1.49,-0.31l0.21,0.61l-0.46,0.3l-1.66,0.11l-0.47,0.42l-0.23,1.7l-1.1,1.7l-0.01,0.74l0.72,1.63l-0.08,0.64l-2.71,2.84l-0.27,0.1l-1.03,-0.77l-1.51,0.13l-1.43,-1.17l-0.79,0.04l-0.94,0.68l-0.32,4.33l1.23,2.91l-1.6,0.33l-0.92,0.75l-0.17,0.78l0.33,0.48l0.96,0.3l-0.26,0.33l-0.67,0.37l-6.97,-0.16l-1.07,1.45l-0.39,2.64l-1.62,0.5l-2.24,-0.38l-1.0,2.74l-0.77,0.85l-1.44,0.46l-1.18,2.0l-2.95,0.56l-1.22,-0.67l-0.77,-0.07l-1.12,1.26l-1.7,0.0l-1.04,0.64l-4.46,0.91l-2.47,-1.18l-0.54,0.23l-1.08,1.43l-0.75,-0.35l-0.85,-1.46l-1.1,-0.35l-0.92,0.81l-0.16,1.93l-1.5,-0.1l-0.9,1.33Z",name:"L\xe9rida"},"ES-J":{path:"M614.53,252.6l1.85,-1.36l3.04,1.41l2.11,-0.47l1.78,0.31l0.07,3.4l0.79,0.76l2.5,0.67l0.44,4.09l0.41,0.61l1.16,0.67l0.27,0.78l-0.74,1.76l0.19,1.38l-3.98,4.84l-2.1,0.82l-0.25,0.4l0.15,2.39l-2.48,1.76l-0.69,-0.42l-0.72,0.08l-3.55,2.88l-4.18,6.48l-0.45,1.33l-0.07,3.58l-2.75,1.41l-0.41,1.3l-2.41,-0.43l-1.61,0.72l-3.66,-1.75l-1.72,-0.18l-1.29,0.37l-2.43,2.48l-3.21,0.6l-0.8,-0.16l-1.79,-1.74l-0.93,-0.47l-0.89,0.11l-4.89,3.9l-2.25,0.54l-4.35,2.39l-2.03,3.66l-4.04,0.34l-1.8,-0.98l-1.41,-2.41l-2.01,-1.47l-0.96,-2.37l-1.8,-1.81l-1.03,-1.58l-1.13,-0.54l1.58,-2.13l0.02,-1.04l-0.74,-0.71l-1.27,-0.47l-0.44,-2.66l-1.57,-1.18l-0.44,-0.71l0.9,-6.53l-0.83,-1.82l0.85,-0.91l0.37,-1.65l2.2,-2.96l1.13,-0.75l0.01,-2.04l-1.7,-2.65l-0.2,-2.56l-1.17,-2.38l-1.23,-0.58l0.22,-1.72l1.68,0.03l1.59,0.5l11.43,0.41l2.25,-0.53l0.79,-1.12l1.52,-0.47l6.94,1.18l0.99,-0.47l0.45,-1.59l0.6,-0.18l1.19,1.65l2.74,0.45l2.59,-1.05l0.91,-0.98l0.5,-1.22l1.34,-0.35l2.44,0.72l4.99,0.65l1.08,-0.25l1.85,-1.13l2.29,2.39l0.63,-0.19l0.4,-1.11l1.29,-0.72l1.3,-0.01l1.62,0.63l2.95,-1.89Z",name:"Ja\xe9n"},"ES-H":{path:"M425.83,295.82l0.68,-1.67l1.61,-1.7l1.07,-4.23l0.64,-0.86l3.63,-2.8l1.2,-1.91l1.58,-4.67l-0.14,-1.23l1.67,-0.53l1.37,0.23l1.27,-0.43l0.82,-0.78l0.59,-1.16l2.66,0.88l1.2,-0.09l0.34,-0.29l3.3,-8.34l5.09,1.58l-0.74,2.12l0.64,0.87l2.32,0.75l2.88,-0.11l2.2,0.38l1.16,1.23l0.24,1.24l0.59,0.49l3.55,0.34l1.66,-1.74l0.65,-0.14l1.85,1.08l0.84,1.54l6.12,2.19l0.56,0.5l0.61,1.31l1.48,0.15l-0.68,2.37l0.76,1.97l-0.44,0.25l-1.58,-0.4l-0.94,0.36l-0.56,0.96l-0.05,2.1l-0.56,-0.12l-0.36,-1.08l-0.67,-0.43l-1.9,-0.02l-5.61,1.45l-0.94,0.58l-1.34,2.13l-0.99,0.93l-0.23,1.41l0.23,0.41l1.02,0.46l2.59,-0.04l1.58,0.72l-0.15,1.35l1.0,1.29l0.79,2.33l1.59,2.61l-0.04,0.42l-1.72,0.72l-0.21,0.65l0.2,1.49l-0.85,1.18l0.2,0.78l1.44,1.53l-0.63,2.37l0.43,2.75l-0.39,1.45l0.04,1.39l-0.87,1.3l-0.27,1.15l1.06,3.54l-0.9,2.21l0.11,0.45l1.24,1.06l-0.34,1.14l0.14,2.86l-0.98,0.01l-0.97,-1.17l-1.3,-3.05l-0.96,-1.52l-1.2,-1.15l-9.81,-6.52l-2.7,-1.05l-1.61,-1.23l-1.57,-0.71l-0.61,-0.88l-0.22,-0.99l2.07,-2.73l0.46,-0.82l-0.11,-0.52l-0.53,0.04l-2.97,2.71l-1.14,0.0l-0.4,0.4l1.31,2.48l-3.42,-1.54l-2.92,-0.88l-1.32,0.45l-0.23,0.4l-7.65,0.18l-2.08,0.99l-1.03,-0.46l-0.72,-2.75l0.24,-0.84l-0.68,-5.11l-0.67,-1.46l-0.3,-2.73l-0.35,-0.98l-1.53,-1.55l-0.52,-1.31Z",name:"Huelva"},"ES-CU":{path:"M603.53,174.95l0.66,-0.42l1.7,0.53l0.52,-0.43l-0.19,-1.57l0.44,-0.39l1.89,1.7l1.37,0.58l0.68,-0.06l0.61,-0.41l0.9,-1.43l1.59,-0.27l0.5,-0.37l0.73,-2.88l-0.56,-2.9l0.28,-3.56l1.1,-0.5l1.7,1.03l0.49,-0.06l1.68,-1.65l1.96,-0.88l1.83,0.22l2.45,1.31l0.5,-0.01l0.46,-0.47l0.06,-1.04l-1.32,-1.34l0.25,-1.19l-0.67,-1.06l-0.02,-0.59l1.25,1.15l0.64,0.19l2.32,-1.05l1.49,0.27l0.64,-0.94l-1.14,-2.0l0.36,-0.92l0.97,0.42l1.41,1.25l0.87,0.11l1.27,-1.23l0.19,-2.18l2.58,1.02l0.82,0.0l1.25,-0.56l0.65,-1.14l2.24,0.83l2.13,1.93l1.63,0.64l0.75,-0.0l1.01,-0.52l0.62,0.18l1.46,2.7l1.39,4.89l3.86,2.56l1.6,1.95l0.26,2.33l1.4,-0.14l0.9,0.43l4.81,4.06l3.88,0.12l-0.47,2.93l1.53,1.16l1.5,4.03l0.88,0.45l4.12,0.77l3.61,-0.58l0.47,1.27l-1.83,0.87l-0.5,0.7l0.36,1.18l-0.24,2.45l-0.87,3.04l-1.69,2.57l-0.06,2.55l-0.97,0.56l-2.02,-0.59l-1.36,0.22l-1.69,1.43l-1.69,2.9l-1.44,1.33l-0.28,0.81l0.13,2.42l-0.69,2.17l0.49,1.25l-9.12,4.53l-1.25,1.84l-2.69,-0.23l-1.84,-0.87l-3.89,0.49l-1.28,-1.69l0.22,-0.44l-0.31,-0.58l-2.79,-0.35l-0.42,0.54l1.42,3.71l-4.35,-0.53l-4.45,2.35l-1.11,-2.3l-0.44,-0.22l-1.41,0.45l-0.76,1.65l-5.08,-4.74l-0.55,-0.0l-0.62,0.57l-1.32,0.03l-2.29,-0.57l-1.64,0.82l-2.85,0.16l-1.76,-3.5l-0.66,-0.08l-1.56,1.87l-1.69,0.16l-0.22,-0.29l0.83,-0.86l0.02,-0.53l-1.47,-1.83l-0.9,-1.8l0.23,-5.96l0.57,-2.26l-3.58,-3.68l-0.6,-1.91l-1.04,-1.17l-0.82,-2.43l-1.47,-1.49l-0.9,-0.37l0.99,-2.37l0.01,-2.52l-0.42,-0.4l-1.55,0.07l-0.95,-2.58l0.14,-0.45l2.6,-0.31l1.23,-1.02l0.29,-1.07l-0.92,-1.93Z",name:"Cuenca"},"ES-T":{path:"M733.72,146.97l2.2,-1.2l1.83,-2.47l-0.82,-3.4l0.4,-1.42l1.02,-1.85l0.17,-1.1l-0.79,-2.12l-1.75,-1.07l-0.84,-2.38l0.12,-0.86l3.31,-1.75l0.83,-2.34l1.84,-1.19l0.97,-2.05l1.62,0.11l0.43,-0.37l0.32,-2.35l0.56,0.1l1.1,1.73l1.15,0.27l0.7,-0.32l0.89,-1.32l1.3,0.95l1.16,0.23l4.63,-0.94l0.93,-0.61l1.73,-0.0l1.21,-1.29l1.68,0.77l3.29,-0.6l0.66,-0.59l0.74,-1.54l1.26,-0.35l1.06,-1.09l0.76,-1.4l0.03,-1.13l2.33,0.43l1.7,-0.72l0.55,-2.93l0.74,-1.04l6.62,0.28l0.97,-0.46l1.18,0.01l-1.41,1.91l0.23,1.1l3.08,1.48l-0.37,2.39l0.7,1.07l2.01,1.04l0.81,0.8l0.24,1.49l0.8,1.58l1.12,1.14l-1.52,1.07l-0.13,0.77l0.6,0.62l1.53,0.24l-0.07,0.79l-3.17,0.22l-10.02,3.38l-2.79,0.55l-1.7,2.14l-1.14,-0.56l-1.95,0.03l-1.76,0.31l-2.73,1.27l-4.52,4.04l-2.21,2.65l-4.32,3.99l-0.85,1.49l0.16,0.55l2.26,0.99l0.93,-0.14l0.24,-0.52l2.39,2.2l1.1,0.17l-0.03,0.58l-0.81,1.27l-2.59,0.72l-1.6,1.55l-0.15,-0.35l-2.11,-0.03l-3.47,1.03l-1.57,1.23l-1.45,2.7l-2.58,-1.07l-0.41,-1.06l-0.87,-0.73l-4.96,-1.93l-0.5,-0.79l0.33,-1.62l-1.84,-0.99l-0.87,-1.2l-1.9,-0.22ZM752.81,155.14l-1.44,0.27l-0.42,-0.61l1.12,-0.13l0.73,0.47Z",name:"Tarragona"},"ES-C":{path:"M355.87,43.07l-0.53,-0.9l1.62,-4.24l-0.87,-1.09l-0.19,-0.75l0.75,-0.22l0.51,-1.31l0.97,-0.84l0.81,0.31l0.73,-0.16l1.51,-1.46l1.18,-0.25l0.36,-0.4l0.0,-0.36l-0.56,-0.37l-1.44,0.44l-0.75,-0.44l-1.4,0.51l-0.16,-0.36l1.64,-1.4l1.08,-0.52l1.49,0.55l1.47,-0.14l1.65,-0.91l0.7,-1.25l0.77,0.49l2.34,-0.48l0.84,-0.93l-1.4,-0.4l-0.91,-1.18l5.28,-2.54l1.68,1.35l3.97,0.93l3.87,-1.46l1.54,0.48l2.21,-0.96l0.79,-1.1l1.04,-0.35l0.59,-0.6l1.72,-0.41l0.56,0.95l0.89,0.7l0.54,-0.04l0.74,-1.14l0.09,-1.47l2.07,0.86l0.57,1.35l1.97,2.25l0.71,-1.19l-0.29,-2.89l1.18,-1.0l-0.05,-0.71l-0.9,-0.37l-2.63,-0.16l-0.98,-0.91l4.33,-0.59l0.7,-0.74l-0.02,-0.63l-0.52,-0.36l-2.65,0.6l-0.58,-0.53l-1.53,0.88l-1.08,0.04l0.32,-1.55l0.5,-0.11l0.52,-0.66l-0.75,-1.47l1.85,0.05l1.15,-0.54l5.42,-3.67l0.69,0.58l1.1,-0.18l0.24,-0.46l-0.26,-0.19l0.1,-0.71l-0.7,-0.72l0.43,-1.18l3.06,-0.41l1.2,-0.64l1.69,-1.65l0.71,0.1l0.76,1.51l-0.64,0.59l-0.22,1.06l-0.9,0.3l-0.27,0.71l0.38,0.4l2.01,0.1l0.67,-0.48l0.05,-0.51l-0.5,-0.72l1.68,0.14l-0.11,-0.86l0.35,-0.34l1.41,-0.88l2.51,-0.92l1.08,-1.25l-1.0,1.62l-0.55,3.44l0.61,1.03l-1.15,1.24l-0.14,1.95l-1.25,1.51l0.03,0.83l0.46,0.75l-1.32,3.45l-1.14,0.72l-0.58,1.32l-1.97,-0.13l-0.46,0.36l-0.28,3.14l-1.9,2.42l0.34,1.79l-1.31,3.38l1.43,4.64l-0.39,1.96l1.14,3.17l-0.01,1.14l-0.19,1.11l-0.88,1.49l-1.52,0.94l-1.02,1.66l-1.69,0.6l-5.15,-0.86l-0.89,0.39l-0.57,0.69l-1.63,-0.28l-1.46,0.75l-0.8,-1.1l-0.91,-0.07l-0.62,0.79l0.25,1.67l-0.21,0.55l-2.05,-0.18l-1.14,1.52l-0.83,0.53l-0.81,0.04l-1.38,-0.62l-3.03,0.49l-0.9,0.52l-0.38,0.79l-1.48,-0.31l-2.84,0.92l-1.09,1.12l-0.62,1.42l-0.91,0.6l-0.52,-0.18l-1.43,-1.74l-0.58,0.11l-0.66,1.15l0.17,1.11l-0.61,0.78l-0.28,0.04l0.0,-0.65l-0.44,-0.08l-1.94,1.2l0.19,0.88l-1.67,0.6l-0.4,1.2l-0.91,0.73l-0.48,-1.81l-1.46,-0.93l0.16,-0.89l1.02,-1.86l0.38,-2.3l0.81,-1.1l1.68,-0.84l1.63,-1.77l1.09,-0.32l0.6,-1.22l-0.09,-0.96l-1.05,-0.71l-0.57,0.3l-0.15,0.99l-0.48,0.52l-0.78,0.31l-3.89,0.01l-0.32,0.46l0.1,0.6l-0.72,0.69l-0.87,0.06l-0.37,-0.29l-0.58,-1.63l0.85,-0.64l0.28,-0.94l-0.46,-0.7l-1.15,-0.56l-0.25,-0.96l0.53,-0.86l-0.15,-1.12l-1.28,-0.42l-0.57,-0.82l-0.68,-0.34l-0.55,0.37l0.01,0.37l-0.69,-0.32l-0.77,0.35l-1.06,1.61ZM358.49,41.69l0.05,0.12l-0.02,0.0l-0.03,-0.12Z",name:"La Coru\xf1a"},"ES-AV":{path:"M506.36,154.87l2.37,-0.19l1.58,-0.71l1.23,-1.13l0.86,-2.46l4.65,-3.04l1.12,-1.58l1.57,-1.06l0.78,-1.35l-0.02,-2.28l1.93,-2.09l-0.48,-2.04l1.14,-1.56l-0.32,-2.24l-0.68,-0.65l-0.99,-0.33l0.05,-2.12l0.75,-1.38l0.56,-0.34l1.95,0.09l2.23,-1.0l5.57,2.98l1.2,-0.39l1.63,-1.46l3.02,-0.74l-0.36,2.73l0.68,1.19l2.23,1.82l1.62,2.9l1.44,0.87l0.7,3.26l-0.56,2.16l0.72,0.62l1.67,-0.36l0.57,0.24l0.45,1.84l1.22,1.52l0.99,5.53l0.48,0.32l3.03,-0.64l0.92,-0.52l2.44,-0.17l0.33,-0.57l-0.54,-1.11l0.19,-0.09l3.38,0.39l-0.31,2.43l-0.31,0.35l-2.11,0.59l-0.66,-0.26l-0.54,-0.8l-0.88,0.1l-0.25,0.48l0.09,2.16l-1.24,1.5l0.14,3.54l-0.52,1.63l0.16,0.76l-1.6,0.27l-1.15,-0.22l-0.86,0.4l-0.61,0.74l-0.38,1.89l-0.96,1.22l-0.9,0.12l-1.19,-1.04l-0.74,0.34l0.14,2.24l-1.5,3.5l-1.94,0.61l-1.6,-0.38l-0.41,-0.57l-0.39,-2.28l-0.52,-0.45l-4.03,0.47l-0.61,0.5l-0.73,1.89l-3.03,2.04l-0.82,1.64l-1.04,0.72l-1.64,0.27l-0.45,-1.56l-1.06,-0.25l-1.56,0.56l-2.88,2.31l-0.86,0.23l-0.79,-0.02l-1.68,-0.8l-3.72,-0.42l-1.17,-2.03l-0.09,-2.3l0.56,-1.39l-0.3,-0.75l-1.04,-0.08l-2.1,0.55l-2.3,1.88l-2.19,0.26l-2.36,-0.95l-2.2,-2.19l-2.38,-1.21l1.83,-2.73l0.03,-0.85l-0.72,-1.6l0.12,-0.54l2.69,-1.95l0.91,-0.24l0.37,1.08l0.96,1.02l0.67,0.45l0.81,0.02l0.7,-0.56l-0.06,-1.23l1.06,-0.15l0.74,-0.59l1.26,-3.85l-0.38,-0.51l-2.66,-0.02l-0.11,-0.82Z",name:"\xc1vila"},"ES-A":{path:"M688.26,275.31l-2.17,-3.18l-0.45,-2.0l0.35,-1.19l1.51,-2.35l0.67,-3.75l-1.15,-2.71l-0.82,-0.53l-2.4,-0.62l-0.22,-2.73l0.29,-1.04l2.02,-1.86l0.39,-0.85l0.46,-4.4l-0.59,-2.71l2.96,-0.35l1.71,-1.36l-1.61,-2.36l-0.33,-1.62l0.41,-0.19l0.92,0.58l1.56,-0.18l1.97,1.53l3.49,-0.53l3.03,1.57l0.74,0.75l1.11,0.39l4.33,-2.29l0.13,-0.6l-0.54,-0.67l-0.85,-0.4l-1.11,0.24l-0.68,-1.06l6.54,-1.03l4.22,-2.85l3.23,1.26l7.81,-1.34l0.86,0.58l4.78,0.91l1.62,0.83l0.85,0.87l-0.08,0.8l2.2,1.31l0.02,0.8l-2.09,0.58l-1.19,1.67l-1.04,0.19l-1.5,1.06l-0.52,1.16l-3.27,0.48l-1.25,0.65l-0.63,1.08l0.04,1.27l-0.68,0.97l-3.98,0.56l-6.18,2.7l-2.75,2.74l-0.49,0.84l-0.17,1.27l-1.71,0.22l-0.78,1.05l-1.08,-0.06l-0.41,0.32l-0.36,1.98l0.57,4.07l-0.76,0.42l-2.4,0.13l-1.55,1.46l-0.89,2.26l-0.38,5.81l-2.13,1.48l-2.11,4.98l-0.54,0.04l-1.97,-1.04l-1.97,-1.83l-1.08,-1.14l-1.94,-3.04Z",name:"Alicante"},"ES-CR":{path:"M525.98,241.75l0.9,-0.1l0.77,-0.74l1.42,-4.3l0.75,-1.33l1.02,-0.68l2.03,-0.08l0.65,-2.09l-0.5,-1.2l-2.96,-0.86l-0.34,-1.51l-0.54,-0.53l-0.35,-1.32l0.51,-0.07l2.2,0.89l2.02,-0.93l0.07,-0.99l-1.25,-0.99l-0.09,-0.89l0.73,-2.56l1.44,-1.43l2.92,0.1l2.86,1.07l0.36,-0.61l-2.27,-2.69l-1.6,-3.66l1.26,-0.65l0.54,-0.64l1.2,-2.7l0.12,-1.03l-0.39,-1.0l2.44,-0.17l0.96,-1.44l1.42,-0.91l0.49,-1.78l0.42,-0.28l0.61,-0.01l0.55,2.02l1.16,0.9l1.21,-0.18l0.82,-0.87l7.3,1.43l2.43,-1.2l1.21,-3.29l1.21,0.47l2.93,-0.49l-0.03,1.02l-1.41,0.95l-0.09,0.82l0.68,1.43l-0.53,0.69l-1.32,-0.21l-0.46,0.33l-1.06,4.43l0.34,0.56l1.5,0.84l1.54,-1.05l3.54,0.54l0.18,2.21l0.27,0.35l2.51,0.83l1.22,0.89l1.7,-0.01l1.05,-1.12l1.02,-0.36l1.65,1.08l0.77,0.05l1.87,-1.2l3.51,-0.57l1.47,0.33l3.17,-2.06l0.4,-1.44l2.6,-1.4l2.14,0.02l0.79,-0.29l1.3,-2.81l4.22,-0.16l0.4,-0.72l1.17,-0.25l3.11,2.09l1.78,-0.31l2.04,0.5l1.49,-1.0l2.08,3.19l-0.83,0.86l-0.03,0.52l0.56,0.74l2.43,-0.04l1.54,-1.67l2.31,5.25l-4.69,6.11l-0.03,0.44l1.28,2.28l0.08,1.17l-2.85,4.99l-0.14,0.81l0.73,1.33l1.07,0.33l1.77,-0.1l1.25,1.07l0.57,3.27l0.91,1.14l1.88,0.57l1.13,1.48l0.18,1.35l-1.21,3.08l-1.96,0.54l-0.98,0.97l-0.63,1.57l0.65,1.4l-0.22,0.38l-1.29,1.12l-3.38,2.08l-1.22,-0.62l-1.63,0.01l-1.67,0.92l-0.42,0.96l-1.64,-1.97l-0.59,-0.3l-3.04,1.38l-1.36,-0.37l-2.75,-0.13l-3.4,-0.87l-1.68,0.46l-1.43,2.22l-2.25,0.93l-2.28,-0.37l-0.63,-1.31l-0.95,-0.42l-1.1,0.37l-0.49,1.59l-0.56,0.29l-6.84,-1.19l-1.96,0.62l-0.74,1.07l-1.91,0.43l-11.26,-0.41l-1.54,-0.49l-1.74,-0.07l-0.93,0.62l-0.17,1.84l-0.56,-0.01l-6.18,-2.29l-3.32,-3.35l-2.67,-1.1l-0.93,-1.26l-2.77,-1.63l-1.06,-1.0l-4.81,-1.61l-0.53,-0.73l-0.15,-1.76l-0.35,-0.62l-0.58,-0.26l-2.44,0.07l-2.85,-1.58ZM532.33,210.85l-0.96,0.48l-2.07,-0.95l1.71,-5.49l1.07,-1.55l3.27,1.6l1.12,1.58l-0.9,1.91l0.38,0.9l-0.3,0.33l-3.34,1.17Z",name:"Ciudad Real"},"ES-CO":{path:"M508.85,252.59l1.27,-0.79l0.78,-1.56l1.37,-1.48l2.17,-0.07l0.91,-1.35l1.24,-0.98l3.08,-1.55l0.61,-1.41l-0.16,-0.78l3.28,-0.15l1.62,-0.4l2.17,1.5l1.42,0.54l2.73,0.05l0.25,2.01l0.82,1.12l1.49,0.74l1.37,0.13l2.02,0.78l0.95,0.94l2.77,1.61l0.95,1.28l2.71,1.13l3.33,3.36l2.25,1.03l6.38,1.83l0.98,2.07l0.23,2.61l1.64,2.48l-0.01,1.64l-0.91,0.45l-2.29,3.08l-0.42,1.75l-0.88,0.85l-0.09,0.48l0.88,1.75l-0.88,6.69l0.69,1.14l1.42,1.02l0.09,1.77l0.37,0.93l1.89,0.93l-0.19,0.86l-1.29,1.43l-0.05,1.05l1.25,0.68l1.03,1.57l1.77,1.77l0.94,2.35l2.01,1.47l1.06,1.81l-2.49,-0.01l-3.09,2.49l-2.65,0.03l-0.8,1.16l-0.11,1.49l-0.99,1.57l0.22,1.48l-1.95,1.48l-0.32,-0.46l-1.6,-0.51l-0.41,-2.62l-0.4,-0.34l-2.77,0.15l-1.38,1.72l-2.15,1.16l-1.94,-0.4l-0.97,-1.6l-1.26,-0.03l-0.64,-1.72l-0.25,-1.86l-0.82,-0.95l-1.14,-0.28l-1.99,1.43l-0.54,-0.05l-1.36,-1.14l-1.07,-2.34l-1.38,-1.29l-0.14,-1.13l-0.83,-1.49l-1.3,-1.11l0.55,-2.75l-0.17,-1.01l-0.95,-0.87l0.03,-1.19l-0.51,-1.26l-1.5,-1.62l-1.11,-0.37l-1.29,0.11l-2.1,0.8l-0.99,1.17l-2.51,-0.15l-3.38,2.05l-2.59,0.64l-1.21,-0.07l-0.66,-0.7l-0.44,-1.68l0.7,-0.8l2.98,-0.01l0.4,-0.39l0.05,-3.49l-1.31,-1.09l-0.29,-1.61l-0.51,-0.73l-1.75,-1.14l-0.66,-3.35l-2.28,-1.94l-0.78,-2.92l-3.3,-3.25l0.02,-0.54l1.83,-1.47l0.73,-2.81l-0.25,-2.36l-1.0,-2.18l-0.75,-0.84l0.28,-1.55l-0.64,-1.17l0.23,-1.12l3.12,-1.7l1.55,-1.67Z",name:"C\xf3rdoba"},"ES-VA":{path:"M523.7,73.91l1.09,0.45l0.52,-0.34l0.09,-0.95l0.61,0.16l-0.58,2.45l0.17,2.24l-0.47,1.4l0.36,0.53l3.63,0.17l0.18,2.4l-0.19,0.79l-0.73,0.94l0.09,1.59l-0.8,0.61l-1.63,3.27l0.74,1.59l0.56,0.12l1.21,-0.8l1.06,0.77l2.08,-0.7l1.04,1.33l1.94,3.83l0.47,0.2l1.39,-0.49l1.99,-2.55l1.53,-0.77l0.55,0.34l0.4,1.2l2.42,2.27l2.39,-0.24l0.68,-0.4l0.17,2.41l2.1,0.85l1.87,-0.83l3.62,0.41l2.76,-1.54l3.49,0.28l1.0,-0.34l1.07,1.48l1.8,0.23l-0.36,1.17l0.95,1.85l0.02,3.22l1.57,1.33l0.4,0.99l-0.4,1.88l-0.78,1.05l-9.35,2.9l-2.81,0.05l-1.67,0.58l-1.83,-0.1l-3.07,1.53l-1.04,-0.03l-0.39,0.53l0.73,2.12l0.05,1.18l0.93,1.54l-1.92,-1.01l-1.17,0.67l-1.33,-0.73l-0.57,0.21l-0.4,1.08l0.89,1.08l-2.54,2.42l-0.11,1.16l-1.85,1.94l-3.59,0.88l-2.41,1.8l-4.5,-2.66l-1.07,-0.31l-1.11,0.15l-1.52,0.87l-1.38,-0.22l-1.12,0.47l-1.91,-1.49l-1.84,-0.21l-1.21,-1.24l-0.77,0.05l-0.99,0.61l-1.15,0.15l-0.22,-0.29l1.53,-1.72l0.16,-1.16l-0.33,-2.6l-1.01,-1.78l0.27,-3.11l-0.73,-1.19l0.03,-1.36l0.62,-1.04l2.52,-0.67l1.14,-1.08l-0.05,-0.62l-2.34,-1.59l0.48,-1.54l-0.39,-0.57l-1.09,-0.4l-0.46,-2.55l-1.7,-2.38l-0.71,-1.61l4.15,-2.33l0.16,-0.53l-1.09,-2.63l0.44,-1.78l-0.29,-2.07l0.85,-1.03l-0.06,-0.57l-3.72,-2.91l-0.4,-1.78l0.41,-2.51l-0.4,-2.85l0.17,-0.71l0.51,-0.31l1.52,0.96l2.3,-0.67l0.45,-0.35l1.08,-2.13l1.35,0.35l0.98,-0.28l2.36,-1.85l0.41,-0.09l1.04,1.5ZM514.07,74.48l-0.74,0.13l-0.28,-0.94l0.89,-0.46l0.13,1.27ZM509.28,85.52l-0.51,2.33l-1.03,-0.46l0.32,-1.06l-1.59,-3.06l2.81,2.25Z",name:"Valladolid"},"ES-TF":{path:"M81.48,697.96l-0.24,0.78l-4.02,2.3l-0.8,1.29l-1.87,1.83l-2.46,1.71l-0.45,0.99l0.29,2.07l-0.85,1.05l-1.53,3.24l-0.39,2.74l-3.63,3.83l-0.87,1.3l-1.32,-0.21l-4.15,1.33l-0.29,-1.1l-0.73,-0.7l-0.31,-1.5l-2.09,-2.12l-0.61,-1.64l-1.59,-1.79l-0.45,-2.39l-1.02,-1.8l-1.56,-1.82l2.64,-1.29l1.61,0.9l1.08,0.14l4.26,-1.48l3.19,-0.03l0.93,-0.63l2.38,-0.45l3.49,-2.9l0.52,-1.27l1.64,-0.92l1.64,-0.46l0.36,-0.66l4.28,0.23l2.43,-0.81l0.5,0.26ZM38.3,721.01l-0.95,0.3l-0.84,-0.2l-1.96,-1.17l-1.21,-1.74l0.16,-2.9l1.01,-1.36l1.78,-0.4l1.71,0.49l3.71,2.46l0.59,1.62l-0.47,0.64l-2.73,2.06l-0.82,0.2ZM11.98,686.49l0.95,0.22l1.7,-0.56l0.59,0.23l0.82,0.8l-0.05,0.85l0.68,1.84l0.75,0.46l0.02,0.4l-1.71,2.25l0.71,2.6l-0.52,1.8l-0.93,1.23l-1.7,3.57l-0.88,-0.5l-0.51,-2.74l-3.35,-5.64l-0.52,-2.42l-1.0,-0.94l0.17,-1.05l2.28,-2.46l0.77,-0.51l1.73,0.57ZM10.92,731.11l-1.62,2.33l-0.13,0.99l-1.48,1.52l-0.41,1.65l-0.98,-0.4l-1.49,-1.62l-3.09,-0.47l-1.08,-0.75l-0.2,-1.1l0.69,-0.31l3.49,0.46l2.2,-1.87l0.51,-1.04l2.07,-1.14l0.58,0.08l0.98,0.77l-0.05,0.9Z",name:"Santa Cruz de Tenerife"},"ES-Z":{path:"M653.06,87.28l2.64,0.38l1.35,1.2l1.26,0.53l0.89,0.06l1.06,-0.38l0.58,0.18l0.9,0.45l1.02,1.06l1.43,0.69l1.7,-0.07l1.06,-0.44l2.7,0.64l0.61,-0.19l1.28,-1.6l0.92,-1.98l1.85,-2.69l-0.04,-1.44l-1.49,-0.65l-1.55,-2.16l-0.14,-2.63l-0.79,-1.92l1.25,-3.72l2.15,-2.84l-0.71,-1.27l0.27,-1.43l2.76,-3.5l-0.42,-1.57l0.2,-0.58l0.61,-0.8l1.11,0.18l1.08,-0.5l0.45,-0.9l1.64,-1.28l-0.1,-0.8l0.37,-0.98l4.02,-0.44l0.82,-2.23l2.36,-0.68l1.7,-1.27l-0.04,1.15l1.15,1.24l-1.33,0.67l-0.45,0.69l0.8,1.95l0.32,5.65l0.32,1.13l-0.5,1.64l0.33,0.54l2.09,1.13l0.24,0.97l-3.43,5.07l-0.02,0.91l0.43,0.52l1.1,0.25l0.59,-0.38l0.76,-1.21l1.34,0.41l0.92,-0.32l1.56,-3.33l-0.35,-2.01l0.63,0.03l0.26,0.45l0.35,3.18l-1.04,2.39l0.39,8.12l-0.98,1.13l-1.35,-1.18l-0.86,0.04l-0.71,0.5l-0.83,2.38l0.54,1.76l3.15,2.03l4.49,0.15l0.48,0.34l1.76,2.7l2.25,1.11l1.0,1.15l0.86,4.0l0.66,1.1l4.38,2.5l1.41,2.51l1.3,0.48l2.15,2.07l0.86,0.23l1.5,-0.91l0.59,0.11l0.6,0.87l0.67,2.08l1.88,2.4l1.32,4.85l0.51,0.28l1.97,-0.48l1.41,1.09l3.48,0.45l0.41,-0.21l0.87,-1.66l1.06,-0.69l0.89,0.47l1.45,-0.43l0.91,-1.12l3.07,0.85l-0.29,0.57l0.12,0.96l1.59,1.04l0.39,1.17l-0.98,2.1l0.28,2.03l-1.73,1.12l-0.79,2.3l-3.23,1.62l-0.41,1.25l0.36,1.26l-1.49,0.2l-1.9,-0.54l-1.87,-0.03l-0.81,0.36l-0.59,0.94l-0.36,-0.13l-1.45,-3.06l-0.89,-0.74l-9.3,-3.88l-1.72,-1.87l-0.52,-0.06l-0.76,0.53l-2.46,-1.32l-1.41,-2.01l-1.14,-0.32l-0.75,-1.52l-2.76,-0.08l-0.69,0.38l-0.23,0.96l1.72,2.9l0.44,1.54l-0.21,0.1l-2.82,-4.21l-0.91,-0.37l-0.66,0.34l-0.25,0.85l0.21,2.71l-0.5,0.34l-0.12,0.53l1.16,1.97l-2.87,3.22l-1.62,-1.81l-1.16,-0.3l-0.73,0.72l-0.99,2.55l-0.5,0.02l-2.34,-1.73l-0.53,0.04l-2.46,2.31l-1.38,-0.68l-0.34,-0.96l-3.59,-2.17l-1.01,0.04l-0.78,1.14l-1.26,0.58l-1.98,-0.68l-1.13,0.01l-0.89,0.49l-0.57,1.09l0.44,1.9l-0.35,0.43l-2.12,-0.02l-1.74,-0.89l-1.58,0.52l-0.83,1.54l-1.03,0.4l-0.45,0.56l0.34,1.8l-0.45,1.02l-1.02,-0.23l-2.5,0.54l-2.42,-0.13l-4.32,-3.68l-1.41,-1.87l-7.25,-4.81l-1.28,-0.26l-3.01,0.86l-1.2,-0.94l-2.13,-0.44l-0.66,-3.94l-0.55,-1.18l0.25,-2.19l1.5,-1.43l0.62,-2.83l2.06,0.3l0.12,1.62l0.77,0.67l3.64,-1.52l-0.13,-2.39l-0.91,-1.66l-0.02,-2.41l-0.53,-2.25l0.64,-0.44l1.69,0.26l2.91,-2.43l1.47,-0.4l1.3,-2.31l0.03,-1.08l-0.85,-0.79l-1.43,-2.37l1.18,-2.56l-1.44,-3.06l-0.23,-2.19l0.4,-1.78ZM684.08,66.17l0.19,-0.78l-1.1,-1.08l-0.18,-0.81l-1.0,-0.26l-0.68,0.54l-0.49,1.06l0.13,0.83l2.05,0.71l1.07,-0.21ZM679.53,67.83l0.67,-0.5l0.39,-0.81l0.03,-0.68l-0.37,-0.5l-1.32,0.42l-0.56,0.62l0.22,1.31l0.93,0.15Z",name:"Zaragoza"},"ES-MA":{path:"M516.44,353.08l-0.61,-1.15l-0.48,-0.19l-1.26,0.41l-0.52,-2.77l-0.84,-1.85l-1.48,-1.54l-1.56,-2.52l-0.78,-0.29l-1.53,0.1l-2.9,1.29l-0.66,-0.01l-0.93,-0.54l-0.05,-0.62l3.58,-1.14l1.12,-0.67l1.46,-1.99l2.44,-0.76l1.12,-0.65l0.76,-0.9l0.79,-2.93l0.75,-0.92l0.22,-1.14l-1.73,-2.57l1.27,-1.5l1.32,-0.32l2.88,2.05l1.46,-0.09l1.33,-0.7l1.03,-1.03l0.81,-1.5l0.12,-1.63l-0.56,-1.52l-1.5,-1.83l8.75,-4.94l0.58,-0.97l-0.15,-0.56l-1.88,-1.16l0.87,-0.18l2.14,0.58l0.98,-1.17l1.67,1.45l1.22,-0.12l2.31,-1.61l0.24,-1.1l-0.6,-1.39l0.31,-0.34l3.82,0.19l0.88,1.55l2.28,0.47l2.62,-1.3l1.43,-1.74l1.92,0.0l0.4,2.52l1.91,0.85l1.49,3.61l0.27,2.93l0.92,1.69l4.59,3.53l10.91,4.39l1.92,-0.07l2.07,2.15l-0.49,1.49l0.09,0.88l-2.04,-0.57l-4.82,1.14l-3.91,-0.95l-1.07,0.26l-1.13,0.77l-4.44,0.59l-7.1,-0.52l-0.82,0.2l-0.75,0.6l-1.88,2.72l-1.67,3.07l-2.33,0.29l-1.34,2.09l-1.29,0.78l-2.75,0.82l-7.27,-0.6l-3.68,2.26l-2.63,0.22l-1.98,1.09l-2.56,0.52l-1.26,1.1l-1.1,1.8l-0.72,2.13Z",name:"M\xe1laga"},"ES-AL":{path:"M647.09,281.89l-0.59,0.92l-0.44,2.46l0.29,2.49l-0.36,1.45l0.21,2.55l7.04,9.72l0.99,0.45l0.62,-0.59l2.23,0.52l3.35,2.45l-0.16,0.33l-0.84,0.06l-0.37,0.41l-0.79,1.8l-1.14,1.52l-3.44,3.6l-1.71,6.04l-2.05,4.18l0.19,2.06l-1.37,0.25l-2.04,1.45l-0.65,0.8l-0.39,1.8l-1.67,1.54l-0.59,1.59l-1.03,0.38l-0.59,0.98l-1.21,0.62l-1.97,-0.3l-3.17,-3.34l-1.49,-0.85l-1.81,-0.43l-2.9,0.93l-2.01,-0.61l-3.3,0.55l-0.82,0.53l-1.59,3.74l-1.55,1.43l-0.9,0.36l-2.12,-0.05l-0.63,0.25l-2.46,-1.46l-1.2,0.57l-1.34,-1.48l-1.3,-0.79l-0.92,-0.05l-2.09,0.64l-3.46,-0.57l-1.83,0.13l-0.32,-1.29l4.19,-2.45l0.17,-0.48l-0.66,-1.73l-1.01,-0.88l2.85,-2.76l0.35,-0.88l-0.71,-2.53l-0.12,-1.93l0.34,-0.3l1.83,-0.28l1.11,-2.69l1.72,-1.03l1.17,-4.01l1.6,0.02l1.86,1.64l1.95,0.17l1.95,0.78l0.55,-0.4l-0.21,-3.28l0.5,-1.21l0.36,-3.13l5.93,-4.78l5.19,-1.5l0.28,-0.45l-0.64,-3.77l2.02,-0.39l0.32,-0.42l-0.22,-3.4l1.54,-3.02l-0.3,-2.75l0.33,-2.25l2.51,-1.68l1.53,0.82l1.78,-0.1l1.94,0.81l3.66,0.46Z",name:"Almer\xeda"},"ES-CE":{path:"M511.18,371.29l0.65,0.05l1.58,0.93l0.98,0.13l-1.63,1.38l-0.96,-1.08l-0.62,-1.41Z",name:"Ceuta"},"ES-PM":{path:"M879.05,181.26l0.56,-1.13l2.54,-0.51l1.03,0.34l5.48,-0.29l1.78,-0.79l1.15,1.1l0.15,1.05l0.67,0.16l0.88,-0.85l2.06,1.74l1.1,0.37l0.32,0.41l0.26,0.97l-0.73,0.54l0.86,0.66l0.95,0.05l0.71,1.88l-0.58,0.34l-0.1,2.76l-1.63,0.2l-2.72,-1.21l-6.46,-3.87l-1.42,-0.52l-1.81,-0.05l-2.78,0.51l-1.08,-0.35l0.55,-2.31l-1.2,-0.58l-0.54,-0.62ZM824.06,203.89l-0.68,-0.47l-1.24,0.47l-0.29,-0.73l-0.74,-0.62l0.06,-2.0l4.3,-2.16l2.0,-1.93l2.09,-0.62l1.96,-1.76l0.51,-0.87l0.85,-0.08l2.26,-2.21l1.53,-0.66l2.53,-1.84l1.24,-0.05l3.58,-1.97l5.63,-1.0l3.94,-1.46l0.3,0.35l-1.89,0.73l-0.89,0.8l-0.7,-0.15l-0.4,0.38l-0.09,1.52l0.34,0.42l1.58,0.22l2.15,-0.55l-0.22,0.89l-1.98,0.62l-0.51,0.5l-0.15,1.2l0.6,1.38l1.13,0.98l2.55,0.95l2.96,-0.02l2.38,-1.58l3.19,1.45l0.97,0.11l0.18,1.17l-0.47,0.66l0.18,0.73l-0.47,1.12l-0.35,0.54l-1.24,0.56l-0.53,0.74l0.08,1.42l-3.18,3.13l-1.26,2.26l-0.33,2.16l-0.61,0.17l-0.62,1.85l-1.16,1.13l-3.67,2.08l-2.37,2.04l-1.06,-1.44l-1.11,-0.63l-0.51,-1.47l-1.4,-0.79l-1.98,0.19l-3.39,-0.22l-1.4,-0.52l-0.85,-0.98l-0.4,-2.45l-0.54,-0.49l0.65,-1.51l-0.45,-1.33l-2.65,-1.84l-1.35,-0.32l-3.51,1.59l-0.74,0.77l-0.4,1.18l-0.82,0.78l-0.72,0.08l-0.73,-1.22l0.31,-0.81l-1.07,-1.0l-0.58,0.04l-0.32,0.36ZM845.43,222.3l-0.61,0.82l-0.79,-0.06l-0.48,-1.09l1.9,-1.13l-0.02,1.47ZM779.43,235.19l-1.44,-0.76l-0.9,0.2l-0.33,0.39l-1.19,-0.89l-0.13,-0.61l0.59,-1.78l-0.23,-0.56l2.77,-0.32l0.4,-0.47l-0.34,-1.93l0.02,-0.9l0.29,-0.3l2.01,-1.52l0.71,0.19l0.58,-0.41l0.68,0.11l1.79,-1.07l1.75,-0.13l1.05,-0.64l2.78,0.97l-0.11,0.44l0.69,2.02l-0.95,0.59l-0.61,1.51l-1.45,0.91l-1.22,1.71l-1.76,1.1l-0.85,-0.28l-1.09,0.95l-0.67,2.69l-0.65,0.01l-0.43,-0.86l-0.69,-0.49l-1.08,0.13ZM782.37,242.36l1.04,-0.32l0.6,-0.75l1.8,2.29l1.61,0.78l1.63,-0.52l0.38,0.44l-0.02,0.55l-1.82,0.1l-2.95,-1.42l-2.32,1.88l-0.04,-1.38l0.41,-1.21l-0.31,-0.43Z",name:"Baleares"},"ES-VI":{path:"M597.76,46.37l-1.97,-2.06l1.98,-2.6l2.03,0.03l0.97,1.28l2.42,0.55l2.3,-0.24l2.27,-1.31l0.13,-0.56l-0.3,-0.71l-2.08,-1.11l1.35,-0.22l0.63,-1.17l-0.5,-0.95l-0.93,-0.4l-0.33,-0.88l-0.77,-0.2l-0.74,0.32l-1.05,1.52l-2.67,-0.47l0.55,-1.04l0.27,-2.58l-0.3,-0.59l-0.89,-0.49l0.38,-1.14l0.39,-0.28l1.59,0.87l2.43,-0.46l0.75,-0.5l0.42,-1.54l0.54,-0.37l0.85,0.44l1.25,2.03l-0.71,1.68l-0.06,0.91l0.43,0.7l2.12,1.76l1.89,0.1l2.81,0.98l1.81,-0.29l1.69,0.59l1.19,-0.3l1.23,0.2l0.51,-0.4l0.12,-0.76l-1.03,-1.6l0.92,-0.37l0.98,0.28l1.8,-0.27l0.41,2.01l-2.39,1.37l-0.37,1.19l0.2,0.46l1.94,0.99l0.92,-0.41l1.28,0.52l5.85,0.5l1.69,0.95l1.14,1.37l1.04,0.1l0.46,1.68l-0.1,0.72l-1.28,2.34l-0.2,1.92l-1.25,0.56l-0.42,0.66l0.34,2.31l0.76,0.74l-1.53,0.9l-0.86,0.06l-0.72,-0.83l-1.25,-0.22l-3.62,2.75l0.27,1.27l1.71,0.8l0.76,-0.26l0.68,-0.8l0.3,0.17l0.22,1.06l-0.41,2.82l-2.79,-0.95l-0.34,-0.73l-0.49,-0.21l-0.85,0.44l-0.48,0.77l-1.51,0.34l-0.81,-0.61l-1.26,0.29l-1.95,-1.22l-0.25,-2.43l-2.5,-1.51l-1.26,0.56l-0.42,0.99l-1.11,0.18l0.46,-1.1l-0.14,-0.44l-0.79,-0.11l-0.32,-1.76l-3.1,-2.46l-1.02,-0.43l-0.95,-1.06l-3.92,-2.39l-2.49,0.72l0.04,-0.62l-0.84,-1.02l1.56,-2.67l0.06,-0.77l-0.6,-0.71l-0.88,0.18l-0.93,1.0l-1.55,0.25l-0.81,1.36ZM621.09,49.14l-3.53,-1.01l-3.75,0.06l-0.88,0.48l-1.37,1.69l-0.16,0.78l2.38,2.18l2.54,1.06l4.88,1.34l3.03,0.07l0.86,0.48l1.05,-0.33l0.25,-1.19l-0.55,-1.37l-0.61,-0.1l-1.16,0.71l-1.12,-1.18l1.12,-0.7l0.59,-1.24l-0.02,-0.72l-1.04,-0.32l-1.05,-0.77l-1.46,0.09Z",name:"\xc1lava"},"ES-S":{path:"M546.44,19.75l0.61,0.53l0.53,-0.0l0.75,-0.66l0.94,-0.16l2.15,0.92l0.86,-0.77l1.83,0.18l4.97,-0.47l1.24,-0.8l2.44,-0.68l2.86,-0.17l0.46,-0.62l1.04,0.61l0.51,-0.08l0.91,-0.54l-0.46,-0.55l1.08,-0.7l2.18,-0.11l2.17,-0.81l1.4,0.39l-2.39,1.45l0.4,1.3l0.91,0.39l1.15,-0.41l0.81,-0.9l0.51,0.52l0.78,-0.01l0.26,-0.54l-0.25,-0.78l0.72,-0.16l0.19,-0.55l1.24,-0.12l1.23,-0.77l2.97,-0.83l0.52,0.03l0.34,0.87l0.58,0.03l1.29,0.92l2.82,0.5l0.08,0.35l-0.29,0.03l-0.92,-0.4l-0.43,0.17l-1.33,1.42l1.82,1.18l0.79,-0.54l0.93,0.31l1.24,-0.31l7.13,1.67l1.18,1.04l0.94,0.32l0.04,1.36l-0.29,0.55l-1.53,0.67l-1.25,-0.32l-3.63,-0.02l-4.37,2.78l-0.73,1.15l0.15,1.9l0.64,1.91l-3.24,-0.17l-5.3,-1.59l-0.81,0.44l-2.34,2.47l-1.75,1.15l-2.1,0.1l-0.81,0.35l-0.3,1.44l-0.37,0.36l-1.6,0.68l-2.38,1.74l-1.31,2.97l-0.08,0.87l0.59,0.98l1.35,0.45l1.97,-0.82l0.88,-1.15l0.79,0.09l0.35,0.71l-1.04,0.59l-1.05,0.06l-0.8,1.4l0.35,1.27l0.63,0.42l0.88,-0.24l0.65,-0.83l0.67,-0.05l0.55,2.56l-2.38,0.39l-1.52,1.2l-1.68,0.46l-0.97,-0.25l-0.06,-2.25l-0.64,-0.42l-0.85,0.54l-1.04,2.07l-1.09,0.24l-0.95,-0.99l-1.96,-0.39l-0.91,-0.75l1.92,-0.83l0.22,-0.68l-0.45,-0.83l-0.74,-0.26l-2.02,0.94l-0.38,-0.18l-0.88,-4.98l-4.7,-1.73l-2.12,-2.56l-2.3,-0.65l-3.69,1.32l-6.56,0.39l-0.43,-1.34l-1.3,-1.54l-2.26,-1.39l-0.28,-1.15l0.14,-2.14l2.06,-0.34l1.14,0.13l0.55,-0.3l0.53,-1.18l0.25,-2.12l2.81,-0.32l1.87,-1.22l0.99,0.17l0.67,0.85l1.15,-0.36l0.53,-1.51l-0.72,-1.97l0.93,-1.96ZM594.81,27.57l0.0,-1.09l0.64,0.83l-0.64,0.26Z",name:"Cantabria"},"ES-TE":{path:"M658.15,167.84l0.2,-1.0l-0.3,-0.93l-1.69,-2.07l-1.47,-1.0l2.29,-2.63l1.74,-1.32l0.1,-2.45l0.73,-1.84l2.95,0.85l1.71,-0.77l0.45,-0.62l-0.06,-1.6l0.68,-1.83l-0.1,-1.58l-0.68,-1.44l0.71,-2.28l-0.1,-1.73l-0.24,-0.58l-1.44,-1.04l-1.04,-1.42l-0.22,-2.98l1.94,0.1l1.28,-0.45l2.07,0.19l0.62,-0.22l0.72,-1.15l-0.35,-2.02l1.34,-0.75l1.02,-1.66l1.04,-0.0l1.34,0.78l2.36,0.02l0.7,-0.39l0.33,-0.94l-0.49,-1.51l0.59,-0.99l1.03,-0.11l2.32,0.71l1.6,-0.71l0.72,-1.11l0.41,0.04l3.21,1.97l0.56,1.13l1.68,0.73l0.91,-0.29l1.94,-2.02l2.24,1.63l1.11,-0.03l0.63,-0.66l1.03,-2.57l2.23,2.21l0.6,0.0l3.36,-3.77l0.05,-0.47l-1.12,-1.9l0.55,-0.62l-0.17,-3.18l0.44,0.09l2.71,4.09l1.01,0.39l0.56,-0.64l0.06,-0.95l-2.16,-4.01l0.27,-0.36l2.1,-0.06l0.72,1.45l1.15,0.33l1.5,2.08l2.74,1.47l1.09,-0.5l1.69,1.77l9.25,3.84l0.65,0.5l1.7,3.33l1.12,0.21l1.14,-1.27l1.71,0.03l1.96,0.54l1.75,-0.22l0.48,1.19l1.76,1.09l0.54,1.52l-0.14,0.92l-0.98,1.73l-0.47,1.7l0.87,3.16l-1.6,2.14l-2.42,1.38l-0.03,0.64l-2.79,0.4l-2.05,1.07l-0.2,-0.87l-0.54,-0.53l-3.66,-0.22l-3.08,-2.08l-1.44,-0.25l-0.72,0.3l-1.2,1.53l-0.35,2.28l-2.64,1.41l-1.63,-0.5l-1.47,0.76l-0.12,1.96l0.31,0.66l1.78,0.67l1.23,-0.17l-0.13,4.18l1.01,1.56l-1.9,0.75l-0.79,1.04l0.27,0.91l1.61,1.48l0.27,0.76l-1.7,1.1l-1.04,1.34l-1.28,0.98l-0.18,1.67l-0.41,0.42l-1.37,0.59l-2.04,0.33l-1.53,-0.47l-0.9,0.37l-0.21,1.89l-0.69,2.12l-1.91,2.23l0.17,1.47l-2.54,1.18l-2.79,0.22l-1.01,1.9l-2.33,1.36l-0.36,1.53l0.27,1.35l1.49,1.7l-1.81,0.85l-1.06,0.12l-0.65,-0.38l-0.37,-1.86l0.26,-1.39l-0.94,-1.22l-3.18,-1.12l-2.26,0.02l-2.9,0.66l-0.38,-0.23l-0.48,-1.29l2.85,-1.27l0.48,-0.79l-0.18,-0.94l-3.02,-2.29l-3.32,-0.6l-2.5,-3.76l-0.59,-0.02l-0.65,0.49l-0.37,0.89l0.03,1.17l-1.35,0.38l-2.75,-0.36l0.24,-1.45l-0.38,-0.76l-1.66,0.01l-1.22,-0.34l-1.11,0.2l-4.74,-4.02l-1.13,-0.52l-1.05,0.09Z",name:"Teruel"},"ES-CC":{path:"M424.96,197.51l7.98,0.35l2.0,-0.54l2.2,-0.12l0.9,0.46l1.25,0.05l6.63,-0.92l0.68,-1.22l-0.11,-1.18l0.79,-1.62l-0.26,-1.4l0.39,-0.59l1.42,-0.67l1.07,-1.49l0.12,-2.65l0.62,-0.68l0.33,-2.13l0.81,-1.8l-3.13,-4.52l-0.98,-0.56l-1.43,-0.24l-0.34,-0.45l-0.54,-2.11l0.88,-1.78l2.33,-1.26l2.4,-0.15l0.94,-0.76l1.63,1.24l2.68,0.08l1.45,-0.64l1.55,0.38l1.29,-0.56l3.4,-0.7l0.95,-1.06l-0.17,-1.32l1.51,-1.24l2.84,-1.07l1.22,-1.03l1.66,-0.4l1.56,-1.71l2.07,-0.65l2.07,-1.12l3.93,2.13l0.58,0.89l1.27,0.5l-0.86,1.55l-0.12,0.56l0.28,0.32l2.76,1.2l1.46,1.19l2.52,1.04l1.28,-0.22l1.08,-1.72l2.65,-0.94l0.48,0.61l-0.4,1.32l0.45,0.66l1.07,0.17l1.42,-0.43l1.46,0.53l2.29,1.69l1.03,1.23l2.62,1.06l2.42,-0.2l2.53,-1.98l2.35,-0.52l-0.53,1.33l0.09,2.55l1.14,2.11l-0.91,0.45l-0.36,0.72l-0.37,4.66l-0.68,3.57l0.21,1.97l0.52,0.26l2.33,-0.3l1.01,0.95l-0.73,1.45l-0.37,2.62l0.68,1.07l2.36,0.19l1.88,-1.85l1.12,-0.08l0.27,0.77l-0.21,1.25l0.95,1.47l-0.64,2.82l-1.62,2.39l0.07,0.83l4.76,4.56l1.61,0.72l3.34,3.69l-1.29,0.67l-2.3,0.31l-1.04,-1.24l-1.07,-0.28l-0.7,0.73l-0.3,2.07l-2.03,1.25l-2.58,-0.01l-2.92,-0.83l-0.95,0.22l-0.62,1.27l-0.28,1.9l0.33,1.53l-1.84,2.5l-1.59,0.5l-2.89,-2.33l-1.16,-0.24l-0.99,0.24l-1.95,1.0l-0.05,0.68l1.23,1.7l-0.41,1.09l-0.72,0.55l-1.37,0.02l-1.52,0.78l-2.91,-2.36l-1.87,-0.45l-0.43,0.18l-0.68,1.12l-1.06,0.68l-2.31,0.8l-0.52,-0.9l-0.65,-0.06l-1.67,1.91l-0.41,0.06l-0.4,-2.65l-0.63,-0.27l-2.73,2.01l-1.85,2.18l-0.95,-1.05l-1.4,-0.08l-0.86,-1.2l-0.86,-0.54l-1.82,-0.12l-0.68,-1.08l-0.11,-2.49l-0.57,-0.34l-1.99,0.96l-6.17,-0.52l-1.09,0.94l-0.44,-0.21l-0.58,-1.04l-3.07,-0.84l-1.11,0.96l-3.17,-0.56l-0.99,-1.86l1.38,-1.62l0.5,-1.51l-0.33,-1.24l-0.88,-0.75l-0.84,-1.71l-0.84,-0.59l-2.89,0.21l-6.36,-2.48l-0.48,0.15l-0.71,1.05l0.15,0.58l1.23,0.63l0.37,0.58l-0.81,2.8l-0.51,-0.06l0.06,-2.67l-0.33,-0.43l-1.96,0.03l-2.05,1.16l-0.34,1.06l0.58,1.01l-1.71,2.1l-1.51,-0.18l-2.85,-3.07l-0.19,-1.84l0.73,-2.47l0.0,-1.0l-0.36,-0.68l-2.67,-0.91l-1.23,-1.8l-2.04,-1.24l-1.86,-2.01l-1.35,-3.37Z",name:"C\xe1ceres"},"ES-P":{path:"M550.26,37.28l1.18,1.91l0.66,0.46l4.54,1.62l0.79,4.86l1.07,0.51l1.26,-0.74l0.95,-0.12l-0.02,0.5l-1.69,0.53l-0.21,1.04l1.2,1.07l1.99,0.41l0.71,0.77l-0.59,0.86l-1.22,-0.71l-0.86,0.17l-1.16,0.69l-1.27,1.47l-0.83,0.47l-1.18,-0.41l-0.64,0.94l-0.14,0.84l0.41,2.53l-0.62,0.44l-0.15,0.45l0.34,1.05l-0.52,0.21l-0.15,0.64l1.58,1.5l0.64,2.01l0.07,1.26l-1.88,-0.16l-0.84,0.25l-0.69,0.99l-0.04,1.75l0.64,1.39l1.57,0.02l1.6,7.1l-0.11,0.63l1.83,1.81l-0.51,1.99l0.35,0.5l3.11,0.29l0.59,2.91l1.16,1.3l3.81,-0.49l0.32,0.25l-2.2,2.68l0.09,1.25l0.39,0.32l0.92,-0.03l3.52,-1.66l0.35,0.2l0.08,0.72l-0.62,0.7l-2.61,0.73l-0.76,2.02l-2.07,0.72l-1.35,-0.04l-0.41,0.39l0.07,2.19l1.94,1.84l-0.05,0.44l-1.74,-0.22l-0.85,-1.41l-0.48,-0.17l-1.06,0.4l-4.25,-0.13l-2.16,1.41l-3.4,-0.44l-1.63,0.8l-0.77,-0.1l-1.0,-0.51l0.06,-2.54l-0.61,-0.35l-1.1,0.7l-1.77,0.3l-2.19,-2.06l-0.59,-1.4l-1.07,-0.46l-1.37,0.5l-2.57,3.02l-0.8,0.25l-1.81,-3.57l-1.28,-1.65l-0.44,-0.13l-2.11,0.71l-0.7,-0.72l-0.51,-0.05l-1.14,0.76l-0.39,-0.63l1.5,-3.03l0.86,-0.71l-0.07,-1.65l0.71,-0.89l0.25,-1.04l-0.21,-2.9l-0.38,-0.37l-3.45,-0.16l0.35,-1.13l-0.18,-2.13l0.6,-2.52l1.63,-0.29l0.32,-0.31l0.5,-2.43l-0.5,-0.47l-0.88,0.25l0.13,-0.85l2.16,-0.31l0.34,-0.42l0.93,-7.47l-1.0,-0.64l0.7,-3.37l-0.1,-2.32l0.68,-1.73l-0.34,-0.62l-1.67,-1.16l1.08,-1.72l0.15,-3.65l1.39,-0.32l0.63,-1.85l1.46,-1.32l0.51,-2.33l1.4,-1.26l2.71,-0.65l5.46,-0.21l3.66,-1.31l2.09,0.74ZM564.08,79.89l-1.08,-0.11l-0.01,-0.8l0.88,0.17l0.21,0.74Z",name:"Palencia"},"ES-PO":{path:"M369.5,64.09l1.85,-0.73l0.43,0.28l-0.34,0.27l-0.0,0.69l0.35,0.21l1.28,0.34l0.86,-0.42l0.08,-1.52l0.47,-0.69l-0.48,-1.63l0.07,-1.33l1.88,-1.67l2.26,-4.75l2.59,-0.84l1.59,0.33l1.22,-1.35l2.83,-0.46l1.22,0.6l1.34,-0.11l1.05,-0.7l1.02,-1.36l1.28,0.37l0.88,-0.34l0.42,-0.99l-0.11,-1.83l0.77,1.0l0.61,0.24l1.59,-0.76l1.75,0.25l1.38,-1.06l4.9,0.88l2.09,-0.67l0.86,0.19l-0.56,1.88l0.21,1.06l1.93,2.06l2.37,1.13l-0.75,1.4l-0.24,2.07l-1.4,2.55l-0.87,0.38l-1.41,-0.06l-1.03,1.32l-1.88,-0.45l-3.0,0.16l-0.96,-0.99l-0.56,-0.01l-1.54,1.48l-1.45,0.47l-2.03,1.87l-1.34,-0.09l-0.42,0.47l-0.05,2.94l0.95,2.11l-0.0,1.27l1.34,1.96l0.8,0.46l-0.42,1.38l0.07,0.88l1.72,1.83l2.4,-0.47l-0.51,2.71l-2.56,1.59l-1.74,0.37l-1.97,1.32l-6.12,0.89l-2.88,1.38l-2.31,0.23l-0.78,0.56l-1.04,1.94l-3.13,1.44l-1.11,1.57l-2.13,1.05l-1.17,1.11l-0.78,-10.39l2.72,-0.55l0.33,-0.84l-0.84,-0.77l0.97,-0.55l0.35,-0.99l1.32,-1.19l5.88,-3.85l0.26,-2.22l-0.33,-0.65l-0.7,0.05l-0.86,0.73l-0.9,1.61l-3.85,1.4l-0.48,0.43l-2.53,-0.03l0.36,-0.93l0.79,0.15l0.23,-0.36l0.02,-2.16l2.06,0.07l1.86,-2.26l2.57,-1.83l0.3,-1.28l-1.86,-0.05l-2.66,1.61l-1.99,0.29l-1.18,-0.13l-0.79,-0.44l-0.77,-1.88l-1.94,-0.62Z",name:"Pontevedra"},"ES-GC":{path:"M172.03,684.1l0.77,-0.51l0.53,-0.92l0.42,-3.36l1.93,-2.66l1.08,-0.61l2.4,-0.44l2.19,-1.59l3.94,-0.48l0.69,-0.74l1.59,-3.71l0.41,-0.08l1.49,1.18l-0.66,1.8l-0.88,0.7l-0.15,0.84l0.41,1.89l-0.54,1.22l0.01,1.38l-1.63,1.82l-3.05,1.08l-1.19,0.99l-3.73,0.67l-1.15,0.88l-1.38,2.15l-1.23,-0.67l-1.88,-0.03l-0.38,-0.79ZM185.57,668.86l0.96,-1.83l0.37,0.09l0.19,0.44l-0.43,0.78l-1.1,0.53ZM146.98,719.21l0.2,-0.75l2.16,0.12l3.83,-1.49l2.89,-1.82l1.29,-1.19l1.14,-1.59l0.47,-3.0l1.21,-2.08l1.16,-3.44l1.72,-2.29l0.92,-2.16l1.62,-2.34l1.4,-5.48l2.33,-1.25l1.33,-0.17l1.18,0.36l1.03,1.1l0.53,3.21l-0.3,3.62l-1.12,3.21l0.0,1.97l0.53,1.12l-0.99,1.15l-0.24,1.22l-2.27,4.43l-1.17,0.62l-6.05,1.19l-1.39,0.9l-1.61,0.42l-0.92,0.52l-3.51,3.95l-1.52,0.68l-0.86,-0.0l-2.38,-0.87l-2.62,0.13ZM99.0,715.68l3.79,0.89l2.98,0.0l2.46,0.57l1.15,-0.3l0.26,-0.39l0.66,4.37l0.46,0.74l0.95,0.65l-0.5,2.12l0.47,0.81l-1.04,1.58l0.55,1.93l-1.1,0.63l-1.74,1.93l-3.34,1.07l-1.45,1.3l-1.01,-0.61l-3.1,-0.55l-2.07,-1.7l-0.59,-0.81l-1.1,-0.66l-1.45,-3.33l0.14,-2.99l2.57,-1.64l1.73,-2.07l-0.11,-1.1l0.58,-1.24l-0.14,-1.19ZM109.66,716.36l-0.11,-1.05l0.61,-0.11l0.11,0.28l-0.61,0.88Z",name:"Las Palmas"},"ES-GI":{path:"M806.16,70.42l2.64,-0.18l2.12,-1.58l0.71,-1.25l0.44,-0.19l1.94,0.19l3.54,-0.79l3.84,1.85l1.75,0.29l0.9,1.4l0.85,0.62l2.66,0.78l1.05,-1.27l3.28,0.69l1.16,-0.05l0.36,-0.64l-0.8,-1.33l1.75,-1.32l1.31,-0.32l2.47,0.09l2.55,-1.76l1.94,-0.13l1.32,-0.87l1.1,0.38l0.88,-0.36l1.51,0.1l0.96,1.3l1.47,0.6l3.43,-0.11l-0.34,1.08l0.15,1.71l0.68,1.01l0.97,0.55l1.57,-0.16l0.72,0.67l0.82,-0.34l0.83,0.38l-1.06,2.57l-0.75,0.78l-1.92,0.1l-1.71,-0.94l-0.74,0.14l-1.06,0.93l-0.58,1.3l-0.09,2.88l0.26,0.98l2.15,1.58l1.5,1.9l-0.71,1.69l0.52,2.16l1.04,1.04l-0.11,0.71l-1.45,2.68l-1.63,1.87l-1.37,-0.02l-1.53,1.0l-0.5,1.38l-4.62,3.06l-0.73,1.01l-3.66,0.86l-2.3,1.82l-0.33,-0.82l0.56,-1.01l-0.38,-1.21l-0.93,-0.77l-1.86,-0.63l-1.55,0.06l-1.3,0.68l-3.32,0.63l-4.29,-3.88l-1.93,-0.17l-1.16,0.28l-1.11,-1.1l-0.42,-0.89l-0.08,-0.71l0.49,-0.79l1.9,0.78l1.65,-0.82l0.97,-0.11l0.78,-1.1l0.02,-0.97l-0.85,-0.95l1.93,-1.96l0.58,-1.83l-0.35,-1.18l-0.7,-0.94l-1.09,-0.61l-1.46,0.01l-1.96,-2.16l-2.47,0.26l-1.28,-1.47l-1.95,0.06l-1.17,0.68l-1.72,0.02l-1.18,0.37l-1.18,-0.82l-1.16,0.03l-0.41,-2.59l-1.06,-1.4l0.18,-0.95l0.7,-1.07l-0.27,-1.35l-0.75,-0.44l-2.16,0.19l-1.31,-0.87l-1.12,-0.26l-2.67,0.51l-0.13,-1.81l-0.99,-1.54l-0.2,-1.78l-2.72,-1.01l-0.77,-0.99l-0.2,-0.83l2.67,0.37l2.97,1.63l2.25,0.46l1.36,3.21l1.43,1.06ZM805.86,65.21l-1.05,-0.3l0.28,-0.93l0.24,0.23l0.53,1.0Z",name:"Gerona"},"ES-TO":{path:"M511.41,187.09l0.97,-9.37l0.17,-0.37l0.98,-0.41l3.74,0.43l1.68,0.81l1.04,0.02l1.18,-0.35l2.83,-2.28l1.59,-0.48l0.53,1.63l0.8,0.29l1.14,-0.2l1.87,-1.13l0.8,-1.62l3.06,-2.07l0.56,-0.75l0.34,-1.37l3.66,-0.48l0.47,2.5l0.71,0.73l1.48,0.49l2.64,-0.66l1.63,0.62l1.02,-0.27l0.63,-0.64l2.27,-1.1l2.77,-3.24l0.61,2.6l2.26,1.59l1.11,-0.64l1.42,-1.67l2.1,-0.69l1.7,1.5l1.61,0.3l1.41,-0.59l1.08,0.47l1.19,1.24l5.82,1.84l1.14,0.9l1.23,-0.07l1.43,1.29l3.46,0.3l2.17,1.08l0.01,0.79l-0.81,1.64l-1.44,0.73l-2.4,2.21l-0.78,0.23l-1.0,0.93l-2.94,0.75l-0.97,0.6l0.17,0.96l1.95,1.23l1.27,-0.03l2.58,-2.07l3.86,-1.37l0.28,-1.12l4.16,-1.46l0.97,-1.17l3.68,0.14l1.34,-0.5l1.36,0.53l2.21,-0.43l3.82,-1.59l0.49,0.26l-0.14,1.34l1.1,2.98l0.39,0.26l1.42,-0.06l-0.01,2.02l-1.09,2.53l0.23,0.53l1.07,0.39l1.34,1.36l0.72,2.27l1.04,1.17l0.7,2.07l3.48,3.56l-0.62,1.79l-0.23,5.92l-1.54,1.03l-1.79,-0.53l-1.72,0.29l-3.13,-2.09l-1.65,0.35l-0.33,0.65l-3.99,0.15l-0.82,0.68l-0.75,2.24l-2.79,0.21l-2.86,1.54l-0.43,1.48l-2.87,1.86l-1.23,-0.36l-3.69,0.6l-1.79,1.18l-1.98,-1.09l-1.01,0.05l-1.82,1.5l-1.06,-0.09l-1.09,-0.84l-2.33,-0.77l-0.18,-2.26l-0.34,-0.36l-4.05,-0.61l-1.41,1.06l-1.02,-0.63l0.9,-3.87l1.51,0.05l0.83,-1.11l0.04,-0.8l-0.7,-1.12l1.3,-1.01l0.25,-0.56l-0.12,-1.55l-0.46,-0.31l-3.19,0.53l-1.26,-0.56l-0.54,0.23l-1.3,3.54l-1.71,0.82l-7.25,-1.42l-0.7,0.18l-0.59,0.79l-0.62,0.1l-0.7,-0.59l-0.5,-2.05l-0.4,-0.3l-1.05,0.02l-0.98,0.65l-0.54,1.84l-1.25,0.72l-0.73,1.23l-2.69,0.19l-2.25,1.38l-0.2,-0.29l0.89,-2.09l-0.53,-1.27l-1.0,-0.95l-3.87,-1.72l-0.6,0.37l-1.03,1.7l-1.66,5.32l-3.37,-3.71l-1.56,-0.67l-3.22,-3.34l-1.39,-1.03l1.59,-2.51l0.7,-3.04l-0.11,-0.69l-0.84,-1.04l0.22,-1.15l-0.39,-1.16l-0.64,-0.4l-1.22,0.11l-1.19,0.78l-0.94,1.15l-1.77,-0.21l0.19,-2.73l0.74,-1.3l-0.04,-0.68l-1.55,-1.4l-2.4,0.18Z",name:"Toledo"},"ES-MU":{path:"M654.09,301.04l-0.76,-0.56l-6.42,-9.09l-0.12,-2.15l0.37,-1.51l-0.3,-2.36l0.42,-2.35l0.64,-0.99l-0.13,-0.6l-0.49,-0.32l-3.71,-0.47l-1.93,-0.81l-1.87,0.08l-2.27,-1.3l-2.55,-3.43l-1.47,-1.05l0.46,-1.33l2.9,-3.36l1.53,-2.75l1.52,-1.19l1.81,-0.59l3.26,-2.86l0.51,-0.03l1.34,0.92l2.8,-0.56l1.67,-0.73l3.62,-2.22l0.32,-0.59l1.35,-0.6l2.08,0.39l0.28,1.71l1.63,1.04l1.01,0.04l2.51,-0.75l2.9,-2.18l0.7,-0.94l-0.18,-4.56l-0.64,-2.32l0.58,-1.09l1.28,-1.31l0.19,-1.84l0.62,-1.21l1.8,-1.8l0.48,-0.18l0.72,0.66l0.84,0.01l2.24,-1.16l1.74,-1.4l2.24,-0.53l1.92,0.58l0.57,1.49l3.23,2.4l0.62,2.8l-0.53,4.44l-2.2,2.17l-0.44,1.48l0.34,3.21l3.35,1.28l0.92,2.3l-0.64,3.31l-1.7,2.83l-0.2,0.98l0.29,1.82l4.17,6.52l1.41,1.59l2.1,1.93l2.06,1.1l0.9,0.04l0.09,0.94l-0.53,-0.6l-0.67,0.12l-0.94,2.34l-1.44,0.71l-0.37,0.88l0.14,0.87l1.9,2.91l2.37,1.24l0.8,0.09l0.53,-0.43l0.35,0.7l-1.01,0.77l-0.81,-0.17l-3.17,1.24l-1.99,0.1l-1.45,0.76l-1.78,-0.83l-1.41,-0.26l-3.45,0.04l-1.31,0.77l-0.24,0.73l0.17,0.56l-1.4,-0.31l-0.68,-0.98l-2.52,-0.7l-1.14,0.97l-2.38,-0.15l-1.86,0.97l-1.81,1.62l-2.32,1.15l-0.85,2.37l-0.86,-0.15l-1.14,0.83l-3.69,1.45l-3.52,-2.55l-2.47,-0.58l-0.85,0.5Z",name:"Murcia"},"ES-GR":{path:"M632.95,274.73l1.44,1.02l1.39,2.16l1.61,1.55l-1.97,1.26l-0.65,0.89l-0.22,2.27l0.31,2.53l-1.53,2.95l0.17,3.33l-2.06,0.39l-0.32,0.46l0.64,3.8l-5.06,1.49l-6.08,4.9l-0.41,0.96l-0.15,2.56l-0.51,1.26l0.17,2.82l-1.54,-0.6l-1.78,-0.12l-1.94,-1.67l-1.34,-0.21l-1.07,0.43l-1.23,4.08l-1.72,1.02l-0.91,2.48l-1.55,0.16l-0.91,0.79l-0.17,0.87l0.26,1.54l0.71,2.19l-0.18,0.53l-2.76,2.5l-0.31,0.74l1.2,1.41l0.44,1.2l-4.16,2.43l-0.19,0.44l0.36,1.44l-3.53,-0.42l-4.07,0.46l-3.48,2.26l-2.26,-0.02l-1.73,-1.14l-1.31,0.35l-1.2,-0.54l-0.86,-0.81l-2.59,0.15l-0.71,0.5l-1.86,0.19l-1.52,-0.44l-0.15,-0.97l0.44,-2.03l-2.36,-2.46l-2.16,-0.02l-10.78,-4.33l-4.84,-3.96l-0.54,-3.72l-1.2,-2.79l2.36,-1.79l-0.14,-1.67l0.96,-1.52l0.12,-1.52l0.55,-0.82l2.49,0.06l3.02,-2.47l2.83,0.06l2.14,1.09l4.38,-0.36l2.24,-3.8l4.2,-2.31l2.34,-0.59l4.73,-3.82l1.14,0.28l1.72,1.7l1.19,0.31l3.66,-0.69l2.5,-2.52l0.98,-0.25l1.31,0.14l3.8,1.81l1.82,-0.74l2.55,0.51l0.5,-0.31l0.25,-1.25l3.01,-1.78l0.07,-3.76l0.39,-1.1l4.07,-6.3l3.32,-2.67l1.23,0.45l2.9,-2.05l0.02,-2.67l1.78,-0.7l3.16,1.4l4.19,1.16l0.94,-0.05Z",name:"Granada"},"ES-GU":{path:"M587.1,144.41l0.66,-1.26l0.37,-1.78l0.89,-0.83l-0.11,-1.38l1.57,-3.91l0.11,-1.2l-1.08,-3.21l-2.04,-1.04l-2.22,-2.41l0.77,-0.15l3.04,-2.07l1.23,-0.35l0.34,-0.7l0.01,-1.37l2.43,0.2l3.56,-0.62l2.05,-1.63l4.55,0.96l4.1,-0.31l1.68,-0.61l0.61,-0.84l0.96,-0.18l0.65,0.44l0.52,1.5l0.88,0.58l1.72,0.42l2.9,-0.63l1.21,1.16l1.76,0.36l1.46,0.98l0.98,-0.08l-0.88,0.92l0.13,0.45l1.05,0.7l-0.23,1.14l1.1,0.44l1.52,-0.44l0.66,1.28l0.99,0.56l0.85,1.61l1.79,0.8l2.34,-0.71l1.45,0.72l1.66,-0.11l2.11,-1.03l2.34,-0.08l1.58,-1.28l2.24,1.74l0.76,0.16l0.52,-0.62l-0.16,-1.27l0.35,-1.67l2.85,-0.82l0.83,0.2l7.06,4.67l1.37,1.84l4.41,3.75l0.37,0.71l-0.14,1.86l0.25,0.91l0.68,1.1l1.99,1.78l0.09,1.42l-0.73,2.49l0.71,1.6l0.07,1.29l-0.67,1.8l0.1,1.4l-0.54,0.54l-1.05,0.31l-1.28,-0.63l-1.42,-0.25l-0.69,0.36l-0.9,2.22l-0.05,2.25l-1.56,1.08l-2.46,2.83l-1.5,-0.99l-1.4,-4.87l-1.53,-2.83l-0.57,-0.44l-0.8,-0.07l-1.45,0.55l-1.37,-0.51l-2.26,-2.01l-2.58,-0.91l-0.79,0.32l-0.42,1.04l-0.78,0.34l-1.83,-0.38l-1.09,-0.63l-0.79,0.05l-0.48,0.78l-0.06,1.82l-0.78,0.79l-2.48,-1.76l-0.88,0.02l-0.64,0.7l-0.16,1.1l1.08,1.99l-1.49,-0.27l-2.13,1.02l-1.21,-1.32l-0.97,0.05l-0.42,0.43l-0.13,0.74l0.77,1.3l-0.24,1.26l1.18,1.17l0.13,0.76l-2.43,-1.28l-2.16,-0.25l-2.26,0.97l-1.63,1.56l-1.62,-0.98l-1.88,0.66l-0.54,4.19l0.56,2.81l-0.56,2.47l-1.89,0.47l-1.07,1.59l-0.49,0.21l-1.2,-0.5l-1.99,-1.82l-0.53,-0.0l-1.0,1.11l0.14,1.17l-1.63,-0.35l-0.4,-3.15l-0.86,-1.69l-1.12,-0.29l-2.0,1.42l0.31,-2.65l0.95,-1.06l0.45,-1.27l0.0,-2.47l-0.7,-1.02l-1.49,-0.8l-0.38,-3.33l-1.87,-1.42l-0.65,-0.07l-0.83,0.4l-0.08,-1.38l-1.29,-1.32l0.3,-2.13l-0.25,-0.47l-1.39,-0.11l-1.59,-1.82l-1.77,0.5l-0.53,-0.45l0.69,-1.38l-0.28,-1.9l-0.64,-1.02l-1.37,-0.47Z",name:"Guadalajara"},"ES-AB":{path:"M629.02,265.35l0.61,-1.09l0.02,-1.5l-1.81,-1.68l-0.44,-4.17l-2.92,-1.0l-0.41,-0.44l-0.04,-3.43l-1.39,-0.62l-1.82,0.03l-1.25,0.39l-2.69,-1.25l0.16,-0.7l-0.64,-1.08l0.49,-1.25l0.72,-0.71l1.89,-0.49l0.66,-0.81l1.0,-2.91l-0.24,-1.79l-1.3,-1.73l-2.07,-0.71l-0.57,-0.8l-0.65,-3.4l-1.48,-1.27l-2.14,0.01l-0.69,-0.23l-0.33,-0.64l2.97,-5.63l-0.1,-1.55l-1.23,-2.22l4.66,-6.08l-0.56,-2.19l2.67,-0.15l1.73,-0.82l2.03,0.58l1.54,-0.03l0.72,-0.53l5.22,4.86l0.64,-0.13l0.9,-1.97l0.62,-0.12l1.16,2.39l0.55,0.18l4.7,-2.48l4.65,0.65l0.43,-0.54l-1.43,-3.72l1.57,0.2l-0.04,0.57l1.93,2.23l3.99,-0.5l1.71,0.85l3.01,0.26l1.53,-1.99l9.31,-4.62l1.51,1.23l0.58,1.34l1.59,-0.17l2.98,1.5l5.96,1.56l-0.17,3.49l-0.87,2.21l-1.02,1.14l-1.14,2.4l-0.32,1.24l0.27,1.32l4.26,4.78l1.34,0.84l3.58,-0.19l1.77,-0.64l1.0,0.41l1.41,2.31l-0.2,1.37l0.54,1.6l-0.29,1.13l-1.12,0.72l-0.21,0.94l0.48,1.55l1.45,1.86l-1.78,0.96l-2.43,0.15l-3.08,-2.29l-0.6,-1.53l-2.4,-0.78l-2.61,0.59l-1.85,1.45l-2.11,1.09l-0.99,-0.67l-1.14,0.24l-2.1,2.1l-0.71,1.43l-0.16,1.72l-1.18,1.15l-0.72,1.4l0.64,2.56l0.31,3.66l-0.53,1.13l-2.82,2.12l-2.56,0.68l-1.38,-0.6l-0.12,-1.48l-0.49,-0.62l-2.7,-0.51l-1.83,0.76l-0.18,0.57l-5.0,2.82l-2.47,0.53l-1.11,-0.85l-1.19,0.02l-3.4,2.94l-1.69,0.52l-1.73,1.34l-1.62,2.85l-2.94,3.43l-0.55,1.56l-4.65,-1.11l-2.77,-1.23l3.78,-4.58l-0.06,-1.7Z",name:"Albacete"},"ES-SO":{path:"M622.78,125.45l0.72,-0.93l-0.57,-0.85l-1.06,0.07l-1.37,-0.94l-1.71,-0.34l-1.29,-1.2l-1.16,-0.02l-1.12,0.59l-2.27,-0.31l-0.59,-0.37l-0.64,-1.69l-1.01,-0.51l-1.5,0.28l-1.19,1.17l-3.43,0.48l-1.33,0.01l-4.48,-0.95l-5.24,-3.55l-0.39,-1.02l0.34,-2.0l-0.22,-0.72l-3.03,-1.17l-0.28,-1.42l-0.7,-0.77l-0.9,-0.31l-1.02,0.35l-1.46,-0.76l-0.38,-0.57l-0.19,-1.8l2.76,0.74l0.47,-0.19l2.55,-4.66l1.19,-0.11l0.36,-0.37l0.14,-1.83l1.16,-0.35l1.74,-1.12l0.18,-0.53l-0.39,-2.96l0.04,-0.81l0.31,-0.26l2.66,1.7l0.89,1.56l0.65,0.07l3.76,-4.23l2.5,-0.4l0.61,-1.72l1.1,-0.37l0.39,-1.55l1.18,-2.46l0.61,-0.18l1.72,0.37l2.45,-1.2l0.74,-0.96l-0.01,-1.15l0.42,-0.99l0.72,-0.64l1.21,-0.0l0.26,0.46l-0.1,0.82l-0.72,0.75l-0.55,1.39l0.2,1.0l3.51,1.28l3.66,-0.03l1.72,-2.64l0.89,-0.84l0.21,-1.84l0.97,0.1l2.76,-1.43l4.39,0.03l0.36,0.21l0.38,1.36l0.96,0.76l2.74,-0.71l1.84,0.1l0.34,0.35l-0.92,0.75l-0.14,1.01l0.43,0.86l1.32,1.27l-0.46,1.04l0.69,1.64l3.38,0.8l2.34,1.1l1.92,-0.37l2.11,-1.16l0.21,1.86l0.59,1.54l0.81,1.07l-1.17,2.92l1.56,2.67l0.8,0.74l-1.04,2.31l-1.47,0.4l-2.77,2.36l-1.55,-0.3l-1.24,0.9l-0.09,0.8l0.57,1.87l0.03,2.51l0.79,1.27l0.35,2.1l-2.85,1.21l-0.13,-1.56l-0.33,-0.53l-1.09,-0.47l-1.5,-0.13l-0.86,0.76l-0.47,2.59l-1.54,1.53l-0.3,2.54l0.57,1.32l0.43,3.67l0.68,0.81l1.83,0.32l1.3,0.94l-0.24,2.85l-2.62,-1.86l-1.91,1.34l-2.25,0.05l-2.09,1.03l-1.33,0.11l-1.52,-0.73l-2.34,0.72l-1.56,-0.82l-0.54,-1.29l-1.04,-0.62l-0.76,-1.37l-0.7,-0.26l-1.66,0.48l0.23,-1.04l-0.95,-0.76Z",name:"Soria"},"ES-ML":{path:"M609.41,400.22l-0.46,0.16l-0.55,-0.55l-0.09,-0.92l0.24,-0.23l0.86,1.55Z",name:"Melilla"},"ES-LU":{path:"M416.6,64.69l-1.08,-0.92l-3.2,-1.54l-1.14,-0.1l0.01,-1.77l-1.31,-1.45l1.36,-2.46l0.13,-1.69l0.82,-1.29l0.09,-0.97l-0.63,-0.73l-2.08,-0.88l-1.73,-1.87l0.57,-2.66l-0.3,-0.51l-0.88,-0.19l0.66,-1.12l1.62,-1.05l0.95,-1.61l0.26,-1.36l-0.01,-1.45l-1.12,-3.05l0.39,-2.0l-1.42,-4.61l1.29,-3.16l-0.34,-1.75l1.86,-2.29l0.29,-2.94l1.42,0.21l0.7,-0.26l0.84,-1.58l1.13,-0.71l1.43,-3.83l-0.54,-1.38l1.22,-1.43l0.11,-1.89l1.26,-1.32l0.03,-0.52l-0.63,-0.85l0.4,-2.11l1.62,-1.06l0.99,1.87l-0.1,0.63l0.53,0.44l0.53,-0.25l0.73,-1.07l0.51,-0.0l1.13,-0.75l1.85,0.27l4.81,2.17l2.44,3.85l1.64,0.79l-0.38,0.82l0.78,0.59l1.78,-0.56l2.41,0.46l2.44,-0.08l0.66,-0.32l1.48,0.54l0.04,0.65l-0.89,1.76l0.21,0.82l-2.32,2.18l-1.3,-0.11l-0.8,0.25l-0.4,0.77l-0.05,1.45l0.36,0.5l1.34,0.29l0.28,1.93l0.61,0.98l1.38,0.94l0.32,1.95l0.53,1.01l3.36,2.06l-0.32,1.63l0.67,1.14l0.82,0.42l0.93,-0.27l1.5,-0.78l0.65,-0.99l1.11,1.46l0.04,0.59l-1.35,1.09l-3.03,0.89l-0.82,1.71l-0.92,0.63l-0.18,0.72l0.56,1.3l0.53,0.34l0.86,-0.3l0.24,-0.79l1.05,1.08l1.73,0.27l1.12,1.1l0.29,2.02l-1.27,2.02l0.26,2.18l-0.31,0.83l-2.49,2.71l-1.37,0.1l-1.02,0.86l-1.18,0.48l-0.74,0.84l-0.31,0.93l0.14,0.8l0.88,1.39l-1.18,1.21l0.03,1.96l-0.69,1.41l-0.09,1.31l-1.54,2.88l-1.34,0.79l-0.59,0.74l-1.8,4.22l-1.73,-3.16l-0.8,-0.61l-2.04,-0.5l-1.74,0.24l-1.56,-1.11l-4.85,2.27l-2.11,-0.57l-1.64,0.24l-3.8,-2.29l-1.6,-0.1Z",name:"Lugo"},"ES-SE":{path:"M478.33,326.02l0.78,-0.94l-0.01,-0.52l-0.51,-0.08l-1.66,0.8l-0.8,0.02l-1.01,-0.57l-2.06,0.85l-1.12,-0.96l0.86,-2.37l-1.07,-3.38l1.12,-2.29l-0.02,-1.55l0.39,-1.53l-0.44,-2.65l0.63,-2.45l-0.31,-0.85l-1.32,-1.39l0.8,-0.96l-0.08,-1.96l1.58,-0.57l0.28,-1.22l-1.66,-2.78l-0.82,-2.39l-0.93,-1.2l0.25,-1.15l-0.23,-0.45l-2.14,-0.92l-2.41,0.08l-0.67,-0.3l0.1,-0.82l0.93,-0.84l1.32,-2.1l0.67,-0.37l5.41,-1.38l1.6,0.02l0.67,1.34l1.52,0.16l0.33,-0.42l0.06,-2.24l0.34,-0.5l2.18,0.25l0.91,-0.51l0.17,-0.51l-0.83,-1.9l0.75,-2.58l-0.56,-0.63l-1.21,-0.07l-0.37,-0.79l2.41,-1.55l5.47,-0.92l1.08,-0.48l1.83,-2.93l-0.45,-1.45l0.24,-0.67l1.88,-1.35l0.82,-1.09l1.38,-0.58l2.57,-0.32l1.38,0.97l0.12,0.26l-1.65,1.15l0.24,1.71l0.36,0.44l1.49,0.06l2.84,-2.11l1.18,0.06l0.1,0.81l3.35,3.29l0.81,2.96l2.2,1.82l0.65,3.33l1.88,1.32l0.72,2.25l1.15,0.83l-0.05,2.87l-2.77,0.01l-1.26,1.23l0.43,2.35l0.93,1.06l1.82,0.2l2.7,-0.67l3.34,-2.01l1.49,0.29l1.03,-0.17l1.16,-1.24l1.94,-0.74l1.73,0.17l1.26,1.36l0.4,0.96l0.02,1.39l0.93,0.79l-0.34,3.94l1.37,1.13l0.75,1.35l0.23,1.3l1.34,1.21l1.18,2.49l1.75,1.37l1.08,0.0l1.93,-1.38l0.91,0.68l0.25,1.8l0.6,1.5l-2.14,-0.14l-0.95,0.81l-0.07,0.45l0.63,1.28l-0.09,0.62l-0.52,0.53l-1.97,0.93l-1.59,-1.4l-0.54,-0.14l-1.11,1.2l-1.84,-0.6l-1.2,0.2l-0.6,0.6l0.04,0.44l1.95,1.4l-0.31,0.53l-8.93,4.98l-1.45,1.56l-1.51,0.87l-0.89,-0.22l-1.78,-2.52l-0.8,-0.38l-5.0,3.12l-0.18,-0.77l0.73,-1.33l0.08,-1.17l-0.89,-0.95l-1.29,-0.2l-1.22,0.69l-0.11,2.82l-0.4,0.84l-1.35,1.14l-1.37,0.19l-2.12,-1.59l-1.52,-0.33l-1.07,0.7l-0.86,1.33l-3.35,-0.04l-1.72,0.51l-1.03,0.78l-0.92,2.24l-1.65,-0.37l-1.38,0.35l-5.12,-0.59l-2.02,-1.26l-2.17,-0.59Z",name:"Sevilla"},"ES-CA":{path:"M475.93,344.23l0.23,0.25l-0.04,0.08l-0.19,-0.34ZM476.86,345.98l0.56,0.32l0.97,-0.45l1.32,-1.54l-0.25,-0.67l-1.57,0.15l0.03,-1.88l-0.35,-0.87l-2.13,-1.89l-3.84,-0.55l-0.44,-0.43l-0.49,-1.79l-1.18,-2.44l0.13,-0.61l0.62,-0.62l2.12,-0.79l0.78,-0.66l0.44,-1.28l-0.33,-1.84l0.18,-0.88l1.12,-0.89l2.72,0.19l2.86,0.75l2.21,1.34l5.28,0.61l1.32,-0.35l1.92,0.43l0.47,-0.28l0.91,-2.36l0.78,-0.56l1.36,-0.4l3.51,0.04l1.27,-1.63l0.71,-0.44l0.83,0.24l2.36,1.7l1.94,-0.28l1.66,-1.44l0.58,-1.65l-0.09,-1.97l0.64,-0.33l0.81,0.1l0.51,0.53l-0.85,2.14l0.14,1.09l0.78,0.58l0.65,-0.16l4.42,-2.98l1.98,2.62l0.68,0.45l0.91,0.04l1.05,-0.43l1.99,-1.84l1.47,1.79l0.44,1.25l-0.12,1.29l-1.57,2.08l-1.09,0.56l-1.06,0.04l-2.9,-2.05l-1.12,0.07l-0.82,0.45l-1.2,1.17l-0.35,0.79l0.42,1.33l1.29,1.47l-0.09,0.64l-0.82,1.06l-0.71,2.78l-1.57,1.27l-2.56,0.83l-1.52,2.04l-4.34,1.57l-0.76,1.06l0.45,1.0l1.37,0.73l1.06,-0.04l2.8,-1.26l1.72,0.11l1.35,2.34l1.4,1.42l0.76,1.65l0.6,3.17l0.52,0.31l1.37,-0.44l0.67,1.27l-1.38,1.02l0.15,0.65l-1.87,3.25l-0.18,1.88l-0.53,-0.94l-0.73,-0.46l-1.06,-0.34l-1.17,0.26l-0.69,1.55l0.53,3.1l-0.47,0.7l-6.23,2.2l-0.74,-1.27l-2.34,-1.36l-1.19,0.23l-3.12,-1.11l-1.39,-1.62l-3.44,-2.86l-2.84,0.26l-1.92,-0.52l-2.61,-4.04l-2.21,-1.15l-0.94,-2.91l-1.4,-1.51l-1.34,-2.91Z",name:"C\xe1diz"},"ES-SG":{path:"M584.62,107.66l0.83,1.55l1.63,0.86l1.29,-0.31l0.48,0.2l0.83,2.08l1.41,0.78l1.56,0.33l-0.29,2.13l0.17,1.14l5.29,3.82l-1.38,1.32l-3.47,0.62l-3.37,-0.36l-0.15,0.6l0.48,0.73l-0.13,1.05l-1.12,0.3l-3.05,2.08l-2.8,0.36l-1.46,0.79l-2.42,2.59l-2.37,1.61l-1.76,2.6l-4.6,1.83l-1.92,2.52l-0.11,1.75l-1.3,3.83l-1.09,0.29l-1.61,-0.22l-1.05,0.46l-3.14,4.05l-3.21,-0.55l-1.31,0.37l-0.79,-0.15l-1.1,0.75l-0.25,1.22l-3.21,0.93l-0.93,-5.19l-1.26,-1.64l-0.48,-1.9l-0.39,-0.44l-0.86,-0.21l-1.64,0.26l0.59,-1.83l-0.77,-3.62l-0.31,-0.48l-1.3,-0.65l-1.57,-2.85l-2.28,-1.88l-0.47,-0.88l0.45,-2.81l1.95,-2.05l0.1,-1.14l2.74,-2.61l-0.02,-0.6l-0.89,-0.73l0.14,-0.38l1.17,0.64l1.18,-0.67l2.27,1.2l0.59,-0.32l0.03,-0.66l-1.0,-1.82l-0.04,-1.14l-0.57,-1.63l0.75,-0.03l3.06,-1.52l1.59,0.14l1.74,-0.58l2.93,-0.07l9.49,-2.95l1.17,-1.45l0.36,-1.66l3.14,1.48l2.27,2.32l1.8,-0.08l0.55,1.71l0.35,0.28l1.63,0.12l0.43,-0.4l0.05,-2.52l1.35,-0.92l0.7,-1.09l1.73,-0.61l1.94,0.38l1.04,-0.4Z",name:"Segovia"},"ES-BU":{path:"M620.91,49.92l1.47,-0.09l0.85,0.71l0.64,0.12l-0.58,1.13l-1.02,0.54l-0.05,0.82l1.63,1.59l0.77,-0.08l0.74,-0.59l0.28,1.2l-4.36,-0.38l-4.69,-1.29l-2.4,-0.99l-2.01,-1.71l1.78,-1.94l3.5,-0.05l3.45,1.0ZM555.27,59.55l0.39,-0.56l-0.36,-1.13l0.72,-0.74l-0.43,-2.87l0.35,-0.73l1.03,0.31l3.4,-2.7l0.71,0.03l0.93,0.6l0.59,-0.15l0.83,-1.2l1.63,-0.51l1.17,-2.2l-0.04,1.98l0.3,0.44l1.55,0.36l2.02,-0.56l1.39,-1.13l2.09,-0.15l0.74,-0.6l0.09,-0.95l-0.85,-2.67l-1.09,-0.22l-1.21,1.1l-0.42,-0.11l-0.15,-0.77l0.33,-0.54l1.02,-0.1l1.57,-1.19l-0.04,-0.62l-0.63,-0.84l-0.78,-0.4l-0.92,0.2l-0.92,1.18l-1.59,0.7l-0.55,-0.1l-0.55,-0.63l1.22,-3.23l2.17,-1.55l1.69,-0.74l0.59,-0.63l0.23,-1.26l2.6,-0.24l1.93,-1.27l2.78,-2.72l4.95,1.58l2.79,0.24l1.23,-0.11l2.45,-0.84l3.73,-2.03l1.39,0.64l3.04,0.26l0.13,0.2l-0.65,0.51l-0.56,1.4l0.38,0.91l0.83,0.46l-0.26,2.4l-0.62,1.06l0.07,0.48l1.92,0.74l1.69,0.13l0.68,-0.35l0.66,-1.29l0.55,-0.17l0.43,0.99l1.02,0.54l-0.23,0.55l-1.42,0.1l-0.42,0.39l0.08,0.7l1.2,1.04l1.1,0.36l0.07,0.34l-1.79,0.92l-2.04,0.2l-2.03,-0.44l-0.37,-0.84l-0.77,-0.52l-2.47,-0.06l-2.15,2.26l-0.39,1.41l1.98,2.21l0.73,0.41l0.74,-0.37l0.5,-1.15l1.43,-0.19l1.28,-1.15l-0.0,0.49l-1.56,2.56l0.02,0.58l0.83,1.03l-0.22,0.57l0.37,0.56l0.77,0.04l2.13,-0.75l3.56,2.19l0.95,1.06l1.12,0.5l2.92,2.37l-2.3,0.71l-4.23,-0.69l-2.51,0.45l-0.31,0.92l0.52,0.92l-2.01,2.28l-0.17,0.6l0.54,0.64l1.22,-0.11l-0.46,2.02l1.33,1.82l-0.36,1.2l0.09,2.1l-0.53,0.84l-1.3,0.41l-0.29,0.54l0.41,0.81l0.44,2.82l-0.54,2.34l-0.63,0.64l-0.13,0.6l1.74,2.94l0.99,0.74l1.11,1.73l0.92,0.44l2.85,-0.08l0.74,2.22l-0.79,0.37l-1.28,2.66l-0.31,1.35l-1.06,0.34l-0.65,1.68l-0.95,-0.08l-1.41,0.42l-3.47,3.91l-0.77,-1.27l-1.38,-0.67l-0.89,-1.04l-1.32,-0.12l-0.71,0.77l0.33,4.02l-2.75,1.26l-0.29,0.35l-0.14,1.77l-1.38,0.31l-2.49,4.56l-2.62,-0.77l-0.74,0.44l-0.15,1.12l-0.88,0.42l-2.03,-0.37l-2.09,0.73l-0.86,1.22l-1.45,1.04l-0.17,2.52l-0.93,-0.07l-0.56,-1.75l-0.41,-0.28l-1.78,0.11l-2.14,-2.23l-3.52,-1.66l-0.58,-1.25l-1.32,-0.92l-0.06,-3.24l-0.93,-1.84l0.67,-2.29l-2.08,-2.19l0.04,-1.31l1.16,0.01l2.34,-0.84l0.61,-0.74l0.24,-1.34l2.33,-0.57l0.67,-0.44l0.5,-1.57l-0.55,-0.98l-0.67,-0.2l-4.12,1.7l-0.08,-0.4l2.22,-2.66l-0.29,-1.14l-0.79,-0.31l-3.52,0.53l-0.67,-0.79l-0.63,-3.1l-0.36,-0.32l-2.93,-0.27l0.46,-1.77l-1.84,-1.86l-1.44,-8.22l-0.41,-0.27l-1.6,0.13l-0.29,-0.74l0.01,-1.48l0.39,-0.57l2.65,0.09l0.43,-0.42l-0.11,-1.87l-0.68,-2.12l-1.17,-1.37ZM562.65,80.51l1.08,0.29l0.92,-0.33l0.24,-0.58l-0.49,-1.35l-1.05,-0.47l-0.94,0.35l-0.37,0.96l0.6,1.13Z",name:"Burgos"},"ES-SA":{path:"M449.85,132.63l0.56,-0.26l3.52,0.08l0.77,-0.59l1.69,-2.27l0.35,-2.31l1.93,-1.71l2.26,-3.32l3.14,-0.12l3.34,-1.52l6.19,1.04l7.67,3.94l1.1,-0.68l1.88,0.18l0.98,0.42l-0.14,1.31l0.94,0.89l0.95,0.14l0.6,-0.57l0.3,0.64l0.69,0.36l0.79,-0.11l0.76,-0.59l0.27,-0.71l-0.14,-2.65l0.73,-0.39l3.2,0.88l3.98,-0.57l1.8,-0.76l1.23,1.31l0.92,0.4l2.37,0.09l2.0,1.34l3.44,-0.28l0.42,1.72l1.6,0.21l0.93,0.99l0.81,0.33l1.34,-0.53l0.38,-2.77l0.96,-0.52l1.03,1.14l2.02,0.3l1.65,1.33l-0.93,2.1l0.16,1.73l0.51,0.7l1.06,0.29l0.48,1.3l-0.26,1.07l-0.99,1.29l0.57,1.65l-1.88,2.04l-0.05,2.48l-0.64,1.07l-1.55,1.03l-1.01,1.47l-4.7,3.07l-1.02,2.69l-0.99,0.85l-1.24,0.56l-2.63,0.17l-0.46,0.45l0.22,1.64l0.39,0.35l2.48,0.02l-1.01,3.11l-1.67,0.47l-0.34,0.47l0.02,1.26l-0.73,-0.26l-0.83,-0.88l-0.34,-1.22l-0.69,-0.22l-1.35,0.35l-2.83,2.04l-0.44,0.89l0.78,2.47l-1.95,2.81l-1.19,0.39l-0.69,-0.1l0.34,-1.48l-0.6,-0.98l-0.62,-0.2l-3.13,1.08l-1.34,1.85l-1.34,-0.36l-1.39,-0.64l-1.43,-1.17l-2.48,-1.07l0.84,-1.82l-0.34,-0.68l-1.39,-0.56l-0.54,-0.92l-1.0,-0.3l-1.08,-0.94l-2.28,-0.97l-0.65,0.09l-2.18,1.29l-1.28,0.28l-1.13,0.8l-0.79,1.11l-1.6,0.38l-1.26,1.04l-2.95,1.14l-1.8,1.57l0.13,1.45l-0.5,0.54l-3.31,0.66l-1.26,0.55l-1.16,-0.42l-1.67,0.65l-2.12,0.03l-2.03,-1.44l0.27,-0.52l2.09,-1.5l0.77,-1.22l-0.08,-0.51l-1.3,-1.11l-0.85,-1.25l-0.2,-1.34l1.76,-3.41l-0.28,-1.11l-1.16,-1.49l-0.06,-0.64l1.44,-3.12l-0.99,-5.26l0.09,-3.6l0.65,-0.39l0.16,-0.83l-0.37,-0.85l-1.22,-0.68l-1.22,-2.96l-2.16,-2.52l0.48,-1.69Z",name:"Salamanca"},"ES-V":{path:"M666.85,205.29l0.14,-2.53l1.36,-1.21l1.45,-2.61l1.07,-1.03l1.18,-0.63l2.53,0.62l1.54,-0.94l0.13,-2.69l1.66,-2.49l0.93,-3.21l0.25,-2.69l-0.37,-0.92l2.06,-1.14l0.71,0.29l2.96,-0.68l2.1,-0.02l2.86,1.03l0.55,0.72l-0.28,1.28l0.39,1.98l0.41,0.56l0.83,0.39l0.94,-0.03l2.65,-1.1l0.43,0.22l1.41,2.22l1.24,0.36l0.43,-0.21l0.68,-1.3l0.88,0.49l0.41,1.87l-0.08,1.57l0.81,0.81l1.64,-0.18l1.28,-1.39l1.07,-0.55l2.0,2.92l1.35,0.4l1.98,-1.12l1.23,-1.77l1.12,-0.56l1.19,0.39l1.52,1.71l2.78,1.5l-0.42,2.05l-1.93,2.23l-0.96,2.2l-1.72,2.63l-0.29,1.77l0.13,2.37l1.05,5.14l3.28,6.34l-0.91,0.96l1.31,4.15l3.64,6.07l3.04,2.67l-7.08,1.22l-3.48,-1.23l-4.16,2.86l-7.06,1.12l-0.27,0.61l1.18,1.84l0.47,0.16l1.11,-0.29l0.49,0.38l-3.72,1.96l-1.24,-1.01l-3.16,-1.63l-0.96,-0.11l-2.63,0.6l-1.85,-1.48l-1.95,0.04l-0.19,-0.18l0.5,-1.7l-0.54,-1.68l0.17,-1.55l-1.68,-2.68l-1.53,-0.58l-1.86,0.65l-3.21,0.22l-1.04,-0.64l-4.07,-4.49l-0.21,-1.03l0.26,-0.96l1.07,-2.27l1.03,-1.15l0.95,-2.41l0.34,-3.34l-0.36,-0.91l-6.31,-1.77l-3.04,-1.51l-1.41,0.16l-0.34,-1.11l-2.42,-2.09l0.76,-2.59l-0.16,-0.3ZM674.54,172.89l0.62,1.34l1.19,1.15l0.55,1.11l1.01,0.44l2.48,0.27l2.63,1.93l-0.11,0.74l-2.05,1.0l-4.09,0.86l-5.02,-1.01l-1.39,-3.88l-1.43,-1.03l0.0,-0.38l3.04,0.4l1.73,-0.48l0.46,-0.67l-0.05,-1.35l0.41,-0.42Z",name:"Valencia"},"ES-LE":{path:"M453.74,67.14l0.59,-0.87l0.31,-1.67l-0.79,-1.49l-2.82,-0.7l-1.22,-0.65l-1.43,0.24l-1.09,0.63l-2.95,-0.39l0.23,-1.66l0.71,-1.52l-0.06,-1.86l1.2,-1.22l-0.12,-0.78l-0.78,-1.06l-0.05,-0.8l0.56,-0.8l2.13,-1.32l1.55,-0.2l2.64,-2.85l0.49,-1.3l-0.28,-1.99l1.08,-1.7l1.03,0.15l1.31,0.88l2.66,-1.53l2.5,-0.13l3.03,0.51l2.55,-0.67l2.1,-1.04l0.35,-0.5l-0.07,-0.8l-1.29,-0.65l2.23,-0.45l1.12,-2.05l0.89,-0.36l5.25,1.77l0.57,-0.19l0.36,-0.95l0.4,-0.14l2.47,0.66l0.79,-0.06l0.95,-0.46l0.66,-1.3l2.43,0.36l1.13,-0.22l1.07,2.0l2.11,1.31l2.47,1.05l2.44,-0.03l0.95,-0.55l1.59,-2.84l0.79,-0.31l1.43,0.02l1.15,0.5l3.95,0.79l2.02,-0.33l0.83,-1.09l2.95,-0.28l0.98,-1.6l2.56,0.22l3.82,-0.41l2.16,-0.94l1.6,0.23l1.18,-1.13l1.19,-2.33l2.14,-0.67l4.22,-2.17l1.26,0.61l0.99,1.51l-0.15,2.57l0.41,1.49l0.73,0.71l1.61,0.78l1.32,1.63l0.22,0.85l-2.36,1.3l-0.49,0.83l-0.5,2.3l-1.34,1.11l-0.68,1.8l-0.86,-0.02l-0.62,0.66l-0.14,3.62l-1.12,1.9l0.59,1.07l1.43,0.85l-0.65,1.49l0.09,2.38l-0.76,3.66l0.26,0.46l0.79,0.29l-0.0,0.6l-0.95,6.27l-2.09,0.3l-0.34,0.33l-0.27,1.75l0.5,0.45l0.85,-0.24l-0.31,1.52l-1.54,0.27l-1.36,-0.36l-0.5,0.35l-0.09,0.92l-1.41,-1.71l-1.15,-0.01l-2.4,1.87l-0.78,0.22l-0.86,-0.36l-0.8,0.11l-0.93,1.12l-0.41,1.23l-1.72,0.71l-1.84,-0.98l-1.14,0.53l-0.42,1.34l0.4,2.87l-0.41,2.55l0.36,1.63l-1.25,0.35l-4.03,-3.14l-0.84,-0.05l-0.41,0.29l-0.35,1.27l-2.13,-0.74l-0.01,-1.07l-0.88,-1.1l-1.65,-0.68l-0.5,0.43l0.06,0.56l-1.96,0.24l-0.36,-0.84l-0.47,-0.23l-3.25,0.85l-0.98,-0.13l-0.9,-1.27l-0.69,-0.15l-0.71,0.7l-1.35,0.5l-3.65,-1.52l-6.59,0.37l-1.2,-0.85l-1.36,-0.45l-0.87,-1.15l-0.66,-0.35l-1.15,0.38l-3.58,-0.07l-2.34,0.8l-1.28,-0.75l-1.36,-0.31l-2.35,0.06l-1.13,-0.47l-2.36,-0.05l-2.55,-1.41l1.38,-2.01l0.2,-2.07l-0.21,-0.7l-3.61,-2.7ZM514.65,75.08l0.26,-1.35l-0.31,-1.1l-0.46,-0.28l-0.84,0.17l-0.89,0.62l-0.16,1.15l0.51,0.91l1.01,0.26l0.87,-0.39Z",name:"Le\xf3n"},"ES-BI":{path:"M600.96,21.65l1.08,0.16l0.98,-0.55l2.99,2.08l0.64,-0.32l0.0,-0.37l-0.82,-2.2l3.24,-1.72l0.3,-0.39l-0.13,-0.5l5.08,-0.3l1.52,-0.51l1.81,1.21l0.88,2.57l0.7,0.2l0.6,-1.96l0.27,-0.06l6.87,1.94l0.86,1.07l1.86,0.78l-1.07,1.6l0.03,0.49l0.65,0.74l-1.38,1.64l-0.61,-0.06l-0.77,0.63l0.06,1.8l-0.72,1.1l0.24,2.67l-0.32,0.31l-3.22,0.53l-0.99,-0.28l-0.74,0.16l-0.92,0.63l-0.09,0.46l1.06,1.88l-0.98,-0.2l-1.22,0.31l-1.53,-0.58l-1.86,0.28l-2.71,-0.96l-1.71,-0.04l-2.17,-2.02l0.82,-2.37l-0.61,-1.48l-0.93,-1.12l-1.29,-0.64l-1.08,0.42l-0.61,1.83l-2.55,0.63l-1.16,-0.76l-0.56,-0.92l-3.19,-0.32l-1.3,-0.71l-6.29,2.8l-0.63,-1.85l-0.14,-1.69l0.41,-0.61l4.13,-2.65l3.39,0.05l1.26,0.32l1.94,-0.78l0.64,-1.03l-0.01,-1.35ZM596.03,27.94l0.19,-0.92l-0.77,-1.1l-0.93,-0.35l-0.51,0.38l-0.0,1.87l0.29,0.5l0.46,0.12l1.27,-0.51Z",name:"Bizkaia"},"ES-HU":{path:"M690.93,65.74l0.49,-1.29l-0.34,-1.46l-0.32,-5.69l-0.79,-1.74l1.39,-0.59l0.39,-0.94l-0.26,-0.67l-0.94,-0.78l0.21,-1.37l0.25,-0.47l1.1,-0.66l0.53,-0.97l0.29,-2.65l1.22,-1.66l0.24,-0.97l1.4,-0.86l0.7,-0.01l-0.13,0.98l0.73,0.92l1.32,0.14l1.94,1.2l1.47,1.75l0.18,0.78l1.01,0.14l0.0,0.54l0.58,0.58l1.65,-0.52l0.33,-1.12l2.65,0.88l1.4,-0.06l2.83,-1.75l0.82,0.07l0.51,-0.58l2.59,1.47l0.73,1.0l1.21,0.1l1.32,-0.34l0.28,1.3l1.34,1.42l0.39,0.84l3.22,1.54l1.64,-0.11l6.79,-1.86l2.51,0.69l0.84,1.31l0.97,0.78l0.86,-0.23l1.1,-1.39l1.07,-0.7l0.86,0.66l0.36,0.77l0.99,0.23l2.35,-0.37l0.7,0.23l6.34,0.04l1.03,-0.33l1.61,3.01l2.03,0.87l-0.35,1.69l-1.17,2.19l0.0,0.81l-0.89,0.3l-0.28,0.63l0.41,1.87l0.87,1.21l0.5,1.63l0.19,2.88l-0.37,3.02l-0.88,1.75l-0.58,2.39l-0.1,2.8l-1.89,4.38l-0.14,1.21l-1.64,1.64l-1.27,0.67l-0.49,0.7l0.13,0.79l0.93,0.77l0.05,1.82l-1.99,1.89l-1.66,0.7l-1.43,2.13l-2.38,0.74l-3.12,3.65l-0.04,1.04l0.96,2.8l0.82,0.58l2.12,0.19l0.54,1.9l-1.55,2.15l-1.33,0.42l-0.66,0.57l-0.41,3.09l-3.53,-0.98l-0.43,0.15l-0.78,1.08l-1.13,0.33l-1.05,-0.47l-1.52,1.05l-0.79,1.51l-3.13,-0.4l-1.5,-1.12l-1.91,0.39l-1.26,-4.57l-0.62,-1.14l-1.34,-1.41l-0.59,-1.92l-0.81,-1.15l-1.29,-0.29l-1.31,0.88l-0.39,-0.06l-2.14,-2.06l-1.27,-0.46l-1.39,-2.49l-4.35,-2.47l-0.45,-0.74l-0.92,-4.17l-1.22,-1.41l-2.13,-1.0l-1.84,-2.78l-0.86,-0.53l-4.3,-0.09l-2.84,-1.78l-0.39,-1.15l0.79,-2.13l0.81,-0.07l0.75,0.9l0.77,0.23l0.72,-0.33l0.85,-1.31l-0.34,-8.36l0.89,-1.5l0.14,-0.98l-0.6,-3.86l-0.58,-0.5l-1.17,-0.05l-0.5,0.55l0.39,2.03l-1.2,2.82l-0.38,0.26l-0.74,-0.38l-0.98,0.01l-0.77,0.52l-0.47,1.02l-0.5,-0.13l-0.13,-0.39l3.27,-4.58l0.24,-0.82l-0.51,-1.63l-2.12,-1.15Z",name:"Huesca"},"ES-LO":{path:"M602.18,77.32l0.69,-0.83l0.59,-2.59l-0.47,-3.12l-0.33,-0.45l1.27,-0.44l0.8,-1.33l-0.09,-2.12l0.34,-1.49l-0.51,-1.05l-0.81,-0.72l0.49,-1.93l-0.67,-0.79l-1.08,0.16l2.09,-2.43l0.01,-0.71l-0.47,-0.8l1.97,-0.31l4.23,0.7l2.44,-0.71l0.12,0.77l0.67,0.47l-0.37,0.81l0.45,0.64l0.61,0.2l1.17,-0.22l0.42,-0.27l0.55,-1.17l0.75,-0.04l1.61,1.12l0.13,2.34l2.91,1.76l0.95,-0.43l0.17,0.63l0.66,0.26l0.87,-0.59l1.27,0.03l0.66,-1.22l0.42,0.71l2.66,1.03l3.51,0.8l2.79,-0.22l2.42,1.92l0.7,0.22l4.54,0.02l0.45,0.36l-0.33,0.83l0.56,0.76l1.25,0.46l2.05,-0.0l2.9,3.13l1.47,0.97l0.06,0.94l0.42,0.5l1.09,0.0l1.29,0.98l3.72,1.82l0.43,3.02l-0.58,0.19l-1.35,-0.5l-1.49,0.35l-1.25,-0.36l-0.69,0.18l-2.91,3.35l-0.32,0.89l0.02,0.98l0.46,1.04l1.54,1.21l0.21,0.6l-0.4,1.1l-2.43,1.32l-1.62,0.31l-2.11,-1.07l-3.15,-0.69l-0.34,-1.01l0.49,-1.07l-1.79,-2.2l1.08,-1.8l-0.92,-0.94l-2.2,-0.13l-2.5,0.7l-0.41,-0.4l-0.44,-1.44l-0.7,-0.45l-2.25,-0.25l-2.61,0.19l-1.08,0.32l-1.7,1.11l-1.38,0.13l-0.32,2.04l-0.79,0.69l-1.37,2.36l-3.36,0.02l-1.38,-0.71l-1.56,-0.31l0.43,-1.43l0.8,-0.93l0.06,-1.51l-0.73,-0.77l-1.62,-0.03l-1.28,1.07l-0.47,1.15l-0.11,1.34l-2.47,1.38l-1.19,-0.32l-0.3,-1.5l-0.89,-1.41l-3.55,-0.19l-1.1,-1.71l-0.89,-0.61l-1.61,-2.66Z",name:"La Rioja"},"ES-SS":{path:"M624.31,40.0l-1.38,-0.74l0.18,-0.64l1.96,-0.89l0.48,-0.56l0.12,-0.97l-0.45,-1.56l1.08,-0.28l0.6,-0.7l-0.19,-2.81l0.68,-1.03l-0.03,-1.77l1.04,-0.14l1.75,-2.04l-0.01,-0.52l-0.68,-0.77l0.98,-1.47l2.94,0.98l1.76,0.17l3.47,-0.54l0.86,0.81l0.79,0.13l0.4,-0.26l0.65,0.61l1.47,-0.82l4.11,-1.16l1.32,-0.69l0.69,0.24l0.66,0.75l0.46,0.02l0.56,-0.36l-0.0,-0.67l-0.29,-0.23l1.12,-0.47l1.46,-1.18l1.2,-0.57l0.28,0.18l-0.08,2.0l1.3,0.82l0.47,1.15l-1.41,0.83l-1.65,2.29l-0.64,0.25l-0.92,-0.16l-0.46,0.67l-0.57,-0.25l-0.55,0.2l-0.46,1.77l0.28,2.3l-0.88,1.25l-3.15,1.97l-0.92,1.56l-0.23,1.98l-0.38,0.33l-1.53,0.43l-1.42,1.34l-3.43,-0.04l-0.79,0.82l-0.73,1.48l-0.77,-0.03l-1.02,-1.29l-2.01,-1.09l-5.88,-0.5l-1.48,-0.61l-0.75,0.5Z",name:"Gipuzkoa"},"ES-BA":{path:"M463.09,220.86l0.38,0.94l0.82,0.35l0.8,-0.25l0.5,-0.68l6.1,0.51l1.75,-0.79l0.27,2.69l0.84,0.92l1.96,0.18l1.58,1.67l1.55,0.16l0.94,1.17l0.62,0.01l2.07,-2.45l2.15,-1.58l0.29,2.08l0.81,0.6l0.92,-0.24l1.4,-1.6l0.41,0.71l0.48,0.18l2.66,-0.93l1.26,-0.79l0.71,-1.08l1.33,0.29l3.04,2.46l0.43,0.05l1.67,-0.85l1.83,-0.21l0.62,-0.62l0.58,-1.71l-1.13,-1.8l1.33,-0.69l1.61,-0.01l2.92,2.35l1.63,-0.2l0.71,-0.42l1.13,-1.21l1.02,-1.75l-0.31,-1.66l0.52,-2.5l0.42,-0.13l2.96,0.83l2.74,0.01l2.58,-1.57l0.4,-2.23l0.28,-0.25l1.67,1.56l2.59,-0.35l1.86,-0.94l2.75,1.08l4.49,-1.76l0.65,-0.68l2.04,-1.03l0.3,0.77l-1.26,3.2l-1.5,0.88l-0.38,0.64l0.16,1.04l1.54,3.11l1.82,1.95l-1.89,-0.89l-3.48,-0.03l-1.72,1.69l-0.85,2.87l0.14,1.35l1.25,1.19l-1.36,0.58l-2.57,-0.93l-0.94,0.76l1.4,3.99l3.2,1.13l-0.24,1.86l-2.09,0.07l-1.09,0.84l-0.89,1.57l-0.97,3.3l-0.65,1.22l-3.38,0.84l-3.7,0.29l-0.31,0.48l0.19,0.82l-0.36,0.94l-1.15,0.34l-1.86,1.17l-1.36,1.08l-0.7,1.17l-2.21,0.1l-1.56,1.66l-0.74,1.51l-1.8,1.25l-0.85,1.08l-2.44,1.11l-0.92,0.81l-0.38,1.52l0.65,1.23l-0.28,1.66l1.8,3.22l0.17,1.42l-0.7,3.16l-1.55,1.15l-1.78,-0.02l-2.75,2.08l-0.54,0.09l-0.33,-0.11l-0.21,-1.2l1.33,-0.71l0.37,-0.71l-1.04,-1.43l-1.34,-0.54l-3.95,0.76l-3.36,2.98l-0.34,1.18l0.48,1.14l-1.5,2.47l-6.4,1.32l-2.6,1.66l-0.53,-0.44l-6.09,-2.19l-0.72,-1.44l-2.15,-1.23l-1.37,0.3l-1.38,1.58l-3.11,-0.36l-0.36,-1.39l-1.39,-1.46l-2.62,-0.51l-2.83,0.11l-2.03,-0.68l-0.16,-0.3l0.79,-1.64l-0.28,-0.87l-5.66,-1.87l-0.8,0.4l-0.56,-0.27l-2.34,0.32l-1.7,1.02l-1.35,0.17l-0.75,-0.65l-1.66,-3.81l-1.13,-0.9l-0.61,-1.19l-4.23,-4.98l-1.29,-0.87l0.66,-0.92l-0.32,-1.19l0.98,-2.7l1.91,-2.92l-0.13,-0.62l-0.69,-0.62l-0.06,-0.69l0.34,-2.55l0.49,-0.99l3.54,-2.43l1.08,-1.27l1.84,-0.38l1.99,-1.32l0.34,-1.63l-0.41,-0.92l1.54,-1.64l2.0,-3.4l-0.03,-0.65l-0.38,-0.42l0.19,-0.76l-0.25,-0.92l-1.32,-1.6l-2.13,-0.93l-1.19,0.1l-1.44,0.69l-0.93,-0.3l-0.28,-0.37l0.5,-1.38l-0.53,-1.16l-3.13,-1.29l-0.46,-0.61l-0.22,-1.61l0.35,-0.56l1.98,0.05l1.92,-2.36l0.04,-0.8l-0.51,-0.74l0.22,-0.52l1.59,-0.81l1.24,-0.07l-0.18,1.75l0.23,1.04l1.07,0.51l0.62,-0.2l0.4,-0.53l0.76,-2.96l-0.4,-0.92l-1.24,-0.77l0.28,-0.41l6.12,2.38l2.94,-0.19l1.19,1.94l0.82,0.66l0.26,0.98l-1.9,3.16l1.3,2.37l3.78,0.76l1.06,-0.95l2.74,0.75Z",name:"Badajoz"}},height:738.0097895570743,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","europe_mill",{insets:[{width:900,top:0,height:790.3360148034734,bbox:[{y:-9690291.808548316,x:-4159652.5301950974},{y:-3201145.6268246872,x:3229902.613642692}],left:0}],paths:{BE:{path:"M400.73,433.08l-0.52,-2.25l-0.56,-0.57l-4.28,-0.9l-0.52,-2.3l-0.72,-1.23l-1.11,-0.96l-1.47,0.14l-2.34,0.95l-0.92,-0.59l-2.1,-2.13l0.06,-1.42l-0.94,-2.11l5.63,-2.88l4.83,-1.89l0.35,1.28l1.0,1.0l0.79,0.0l1.32,-0.72l1.22,0.17l1.92,1.09l1.13,0.14l2.05,-0.73l1.86,-1.11l0.78,-1.23l1.7,0.4l0.63,-0.24l0.21,-0.45l-0.2,-0.84l1.02,-0.55l1.09,0.83l0.82,0.06l1.67,-1.16l0.71,1.31l0.55,0.19l1.3,-0.08l1.17,-1.0l0.54,1.83l1.68,1.4l1.62,0.43l2.18,-0.42l1.56,1.44l2.54,0.82l0.16,0.74l-0.9,1.69l-0.1,0.88l-1.21,1.21l-0.17,0.9l0.73,1.23l0.43,0.19l1.64,-0.55l0.67,0.81l1.43,0.18l1.66,1.17l1.24,1.25l-0.57,0.57l0.11,0.94l0.57,0.56l1.13,0.22l0.42,0.41l0.27,2.03l-2.32,1.34l-0.73,1.47l-2.05,-0.25l-1.48,1.5l-1.78,3.11l-0.26,2.02l2.04,2.91l-0.89,1.46l-3.56,0.48l-3.15,-2.93l-1.99,-0.73l-1.61,-1.01l-1.76,-0.23l-0.27,-1.86l-0.65,-0.86l0.89,-2.91l-0.19,-0.47l-0.91,-0.33l-0.73,0.31l-1.0,0.88l-0.65,1.57l-1.29,0.64l-2.28,0.26l-2.49,-0.26l-0.25,-0.23l0.75,-1.69l-0.73,-1.1l0.42,-1.16l-0.09,-0.82l-1.77,-1.33l-1.44,-0.33l-2.31,-0.2l-1.24,0.59Z",name:"Belgium"},FR:{path:"M467.41,568.7l0.77,-0.77l0.94,-1.92l1.23,-0.85l3.09,-0.88l1.24,-1.13l1.71,0.56l0.82,-0.34l0.45,-1.04l-0.08,-2.97l0.33,-0.92l0.66,0.38l0.24,2.71l-0.35,2.37l0.98,1.89l0.4,6.29l-2.07,3.66l-0.12,3.28l-1.87,4.27l-0.66,0.89l-3.62,-1.94l-0.93,-0.91l0.99,-1.66l-0.25,-0.45l-2.03,-0.85l0.51,-1.36l-0.22,-1.18l-0.41,-0.29l-1.25,-0.03l1.06,-1.23l0.08,-1.13l-1.58,-1.27l-0.2,-0.63l1.2,-0.8l0.16,-0.59l-0.67,-0.97l-0.55,-0.18ZM313.21,482.01l0.65,-0.84l-0.12,-0.59l-0.73,-0.41l-2.58,0.36l-1.17,-0.3l-1.49,-1.3l-1.38,0.14l-0.87,-0.45l-1.52,-0.0l-0.86,-0.67l-5.41,-1.47l-2.3,-0.18l-2.17,0.65l-0.93,-0.18l-1.64,-2.53l-2.86,-1.03l3.52,-0.98l0.83,-0.83l-0.09,-0.62l-1.43,-0.83l-1.1,-0.24l-0.48,-0.52l4.03,0.01l0.24,-0.69l-0.82,-0.75l-1.49,-0.46l-4.19,0.09l-0.42,-1.11l0.47,-1.3l2.39,-1.3l6.29,-1.5l2.69,0.22l2.0,-0.28l2.39,-0.99l1.02,-0.81l3.06,-0.46l2.9,0.82l2.77,3.22l1.41,1.17l0.45,0.04l3.24,-1.89l4.69,0.05l0.91,0.97l0.66,-0.11l1.04,-1.64l1.04,1.03l6.16,-0.4l0.3,-0.33l-0.2,-0.4l-1.32,-0.73l-1.04,-1.7l-0.24,-6.84l-3.16,-5.21l-0.74,-1.78l0.1,-1.05l3.43,0.27l2.91,-0.67l1.05,0.35l-0.06,1.26l0.44,1.82l1.68,2.19l2.38,-0.09l2.65,0.59l3.28,0.09l5.0,1.0l2.17,-0.63l1.94,-1.22l3.74,-0.81l0.55,-0.6l-0.36,-0.63l-2.1,0.17l-1.75,-0.69l-0.18,-0.57l0.93,-2.27l5.65,-2.74l4.18,-0.84l4.36,-1.56l2.29,-1.65l1.52,-2.13l0.98,-0.76l0.11,-0.58l-0.47,-0.63l0.37,-7.74l0.38,-1.32l0.77,-1.06l3.1,-1.8l7.88,-1.69l0.89,1.98l-0.23,0.88l0.24,0.64l2.37,2.44l1.4,0.75l3.42,-1.17l1.46,1.79l0.67,2.53l0.79,0.51l3.63,0.5l1.16,2.95l0.53,0.06l1.11,-0.65l2.15,0.19l1.16,0.24l1.51,1.13l-0.49,1.57l0.74,1.06l-0.73,1.84l0.74,0.77l2.77,0.32l2.61,-0.31l1.51,-0.75l0.83,-1.78l1.17,-0.81l-0.75,2.87l0.69,1.08l0.35,2.16l0.4,0.31l1.75,0.15l1.55,0.99l2.02,0.76l3.1,2.91l3.88,-0.4l0.56,0.58l2.56,1.05l1.01,-0.16l1.41,-0.77l0.66,0.06l1.34,0.7l1.53,0.18l0.9,0.74l0.57,1.33l2.4,2.92l0.83,0.07l1.34,-0.87l1.18,0.37l0.34,0.99l0.66,0.25l0.87,-0.21l1.22,0.23l3.14,-0.67l0.9,1.02l1.32,0.54l5.32,0.9l1.54,0.57l0.05,1.07l-4.07,4.38l-1.79,6.17l-1.23,2.2l-0.44,1.6l0.31,1.21l-0.19,1.55l-0.73,2.24l-0.14,1.82l0.62,1.44l-1.04,0.58l-0.92,1.45l-0.88,0.32l-1.65,0.02l-0.4,-0.65l-0.67,-0.35l-1.31,0.06l-1.26,0.7l-0.98,1.46l0.57,0.78l0.73,0.14l-4.42,4.94l-2.89,1.4l-0.65,3.28l-3.37,2.5l-1.41,3.23l0.82,1.07l-0.3,1.32l-1.75,1.33l0.3,1.45l1.86,0.05l1.53,-0.78l1.1,-1.08l0.06,-0.49l-0.55,-0.89l1.09,-0.96l1.33,-0.57l1.91,-0.11l2.26,0.34l0.17,1.45l0.39,0.63l-0.48,2.05l2.49,2.54l0.73,1.16l-2.84,1.86l-0.18,1.53l0.36,0.71l0.96,0.63l1.82,2.88l1.7,1.48l-0.9,2.31l-1.21,0.37l-1.75,1.24l-1.95,-0.12l-1.05,0.48l-0.22,0.4l0.1,0.84l0.84,0.96l0.72,1.77l0.97,0.7l2.2,0.58l0.6,1.76l-0.88,0.55l-1.6,2.79l0.62,1.54l-0.2,0.75l0.43,1.08l1.01,1.0l4.78,2.37l0.96,0.2l3.03,-0.67l0.61,0.99l-2.55,3.41l0.06,1.58l-1.05,-0.07l-0.48,0.65l-2.48,1.14l-4.33,3.66l-1.97,1.05l-0.96,1.97l-1.06,0.92l-3.53,0.96l-2.42,1.03l-1.16,-0.44l-2.87,0.05l-1.9,-1.3l-3.43,-0.8l-1.08,-1.78l-3.35,-0.43l-0.12,-1.01l-0.5,-0.38l-2.08,0.32l-0.81,0.45l-0.79,-0.06l-0.3,0.4l-0.61,0.05l-6.52,-1.74l-2.24,-1.83l-2.23,0.45l-1.85,1.74l-7.11,4.41l-2.95,4.72l-0.16,1.53l0.65,4.05l1.42,2.15l-2.56,-0.58l-1.25,0.17l-2.71,0.83l-0.83,1.03l-5.69,-1.28l-2.78,1.04l-0.81,-1.08l-2.69,-1.15l0.34,-0.96l-0.7,-0.84l-2.87,-0.64l-0.99,0.54l-0.97,-1.3l-1.99,-0.4l-6.05,-2.05l-1.12,-0.09l-0.58,0.37l-0.39,2.16l-4.75,-0.06l-0.9,-0.43l-3.17,0.48l-3.51,-2.22l-3.8,0.42l-2.47,-2.29l-2.3,-0.16l-4.56,-1.73l-0.58,-0.75l-1.12,1.09l-0.39,-0.03l-0.36,-0.23l0.9,-1.92l-0.24,-1.16l-0.96,-0.5l-3.17,-0.62l-0.85,-0.97l2.08,-0.55l2.09,-2.26l1.89,-7.6l1.35,-8.91l0.9,-1.51l1.14,-0.42l0.17,-0.63l-1.03,-1.24l-0.59,-0.03l-0.43,0.42l0.62,-6.75l1.3,-5.66l2.93,2.19l0.74,1.02l1.11,3.82l1.99,1.61l0.49,-0.04l0.08,-0.49l-1.25,-1.54l-1.22,-4.82l-0.82,-1.5l-1.35,-1.33l-4.12,-2.8l-0.07,-0.37l1.77,0.46l0.54,-0.47l-0.98,-3.09l-0.57,-6.56l-0.32,-0.32l-3.25,-0.63l-5.23,-2.74l-4.03,-5.76l0.93,-3.09l-0.86,-1.27l-1.37,-0.73l0.46,-0.73l0.44,-0.53l0.88,-0.15l3.8,0.98l0.44,-0.27l-0.2,-0.48l-3.38,-1.67l-5.06,0.54l-1.01,-0.19l-0.72,-0.28l-0.23,-0.74l1.26,-1.47l-0.06,-0.51l-0.75,-0.7l-1.25,-0.37l-2.76,0.2ZM332.31,508.2l1.88,1.81l-0.15,0.48l-1.62,-1.85l-0.11,-0.43Z",name:"France"},BG:{path:"M662.06,585.15l0.29,-3.94l0.71,-1.75l-0.05,-0.72l-0.86,-0.68l-1.48,-3.54l-0.69,-0.61l-2.8,-1.24l-2.73,-2.84l0.66,-0.27l1.35,-1.8l0.2,-0.83l-1.28,-2.51l0.35,-1.29l-0.28,-1.38l0.24,-0.54l0.99,-0.47l2.26,-0.25l3.25,-3.58l0.5,-1.6l-1.7,-1.41l-1.32,-1.73l-2.83,-1.63l-0.65,-0.92l-1.73,-4.25l-0.05,-1.22l0.63,-2.11l2.3,-1.11l0.53,-2.08l0.71,-0.5l3.99,2.37l-2.14,1.89l-0.0,1.56l1.15,0.79l4.1,-0.65l4.13,0.33l5.62,1.1l3.78,0.39l2.81,-0.5l9.82,1.78l4.63,0.26l2.69,-0.69l1.88,-0.94l1.63,-1.76l3.74,-2.22l3.65,-1.25l7.88,-1.36l4.53,2.38l3.3,0.38l0.99,0.7l1.96,-0.44l2.27,2.66l4.46,1.3l2.5,0.06l-0.28,3.44l-1.08,1.52l-1.9,-0.54l-2.52,0.52l-1.56,2.22l-1.43,1.35l-0.55,2.99l-0.1,4.22l-1.73,0.67l-3.65,3.91l0.11,0.63l2.91,1.84l3.87,5.45l-1.3,-0.19l-1.15,0.47l-1.76,-0.06l-1.68,0.63l-3.01,-2.44l-0.84,-0.32l-3.33,0.55l-1.81,1.11l-3.72,0.47l-0.64,0.45l-0.8,1.79l-2.11,0.49l-0.68,1.13l-1.29,-0.3l-1.48,0.43l-0.64,1.22l1.04,2.44l-0.05,1.85l-2.58,1.05l-1.96,-0.27l-7.03,1.36l-1.54,-1.11l-1.96,-0.82l-1.99,-0.47l-1.13,0.51l-2.12,-1.23l-0.94,-1.63l-0.73,-0.26l-1.48,0.51l-4.43,-0.06l-0.74,1.11l-1.79,0.08l-3.22,1.09l-2.63,-0.19l-2.7,0.22l-1.27,1.01l-2.52,-0.16Z",name:"Bulgaria"},DK:{path:"M554.98,347.03l-0.27,0.17l-2.03,-0.48l-2.42,-1.16l0.34,-2.19l0.45,-0.72l4.46,2.58l0.04,0.75l-0.57,1.04ZM521.14,336.77l-0.22,-0.59l0.73,-0.83l0.32,0.89l-0.83,0.53ZM520.72,332.89l0.03,1.74l-0.25,0.39l-3.02,1.28l-1.05,0.95l-0.5,1.54l0.9,1.36l1.45,0.59l0.29,1.42l-0.97,0.73l-3.08,0.91l-0.28,0.33l-0.5,6.78l-2.01,0.63l-1.43,-2.33l-0.04,-1.11l-1.16,-4.03l-2.77,-0.74l-2.34,0.21l-1.42,-2.13l0.24,-2.46l-0.86,-1.5l-0.07,-1.09l-0.84,-0.87l-0.75,-0.28l-0.25,-0.91l2.9,-0.04l1.44,-0.44l2.06,-2.53l0.15,-1.11l1.62,-0.2l0.65,0.66l-0.05,3.29l0.25,0.34l1.84,0.62l0.44,-0.26l0.83,-1.98l0.58,-0.6l0.15,-1.49l-0.66,-1.19l4.25,-2.53l1.27,-0.06l3.23,1.02l0.2,0.29l-1.04,2.06l0.58,2.72ZM517.34,347.25l1.62,0.28l1.26,0.71l-1.94,-0.19l-2.4,1.26l-0.36,-0.17l1.82,-1.88ZM504.49,350.08l2.48,1.22l1.72,-0.02l0.86,0.38l0.26,1.85l-0.8,0.33l-1.36,-0.13l-1.59,0.57l-5.33,-2.52l0.22,-2.53l2.27,-0.18l1.27,1.03ZM500.25,304.31l-0.34,0.28l-1.08,-0.37l0.33,-0.36l1.93,-0.37l-0.83,0.82ZM495.95,352.06l-0.81,-1.41l2.94,-3.53l-1.8,4.22l-0.33,0.72ZM468.61,349.15l-0.42,-2.39l-0.69,-1.33l0.85,-0.26l0.28,-0.41l-0.25,-3.27l-0.49,-1.78l-6.52,-3.55l0.92,-7.01l-1.09,-3.15l0.55,-8.59l1.14,-0.12l3.56,1.07l0.64,0.76l1.02,0.47l0.49,-0.15l0.69,-1.1l0.23,-1.47l1.93,-1.94l2.11,-1.0l1.52,1.58l0.43,0.13l0.28,-0.35l0.79,-5.97l-0.27,-0.44l-1.96,-0.62l-1.84,0.54l-1.79,2.66l-1.35,2.98l-2.07,0.26l-1.77,0.83l-2.33,-1.48l0.18,-1.51l1.88,-2.48l2.46,-2.33l2.46,0.02l2.01,-0.79l1.05,-0.09l3.53,0.17l2.07,-0.61l1.73,-1.22l3.52,-4.77l1.89,-1.89l4.04,-0.74l3.41,-2.12l-0.98,1.01l-0.52,1.77l1.23,2.37l-0.16,3.79l-1.14,1.36l-1.29,2.84l-0.65,0.68l-0.18,7.31l1.5,1.58l1.55,0.73l4.81,0.01l0.84,1.17l-0.84,2.52l-2.95,1.65l-0.87,0.03l-1.4,-1.34l-0.5,-0.05l-0.79,0.52l-0.85,0.91l-1.81,6.51l-1.88,-0.35l-1.7,0.66l-0.08,0.69l1.36,1.25l-1.46,0.7l-1.73,1.9l-1.54,1.01l-0.95,1.22l0.98,4.54l-0.31,0.95l-1.8,1.6l-0.79,1.57l0.37,0.57l1.54,-0.02l1.37,0.66l0.38,0.38l-0.27,0.76l0.33,1.37l-1.23,-0.49l-3.7,0.92l-0.99,-0.03l-0.97,-0.68l-3.84,-0.98l-2.88,-0.13ZM494.78,336.56l2.16,5.08l-0.38,0.82l0.26,1.43l-0.26,1.07l-1.97,1.37l-2.27,0.06l-5.9,-2.06l-1.67,-3.44l0.02,-2.6l5.4,-1.72l1.83,0.94l1.1,0.04l1.67,-1.0ZM494.14,332.71l-0.34,-0.12l0.24,-1.95l-0.31,-1.07l1.07,1.5l-0.65,1.64ZM490.96,349.9l0.79,0.15l0.49,0.27l-0.27,0.06l-1.01,-0.48ZM483.63,346.94l2.33,1.33l0.69,1.28l-0.87,0.16l-1.78,-0.57l-0.36,-2.2Z",name:"Denmark"},HR:{path:"M540.52,517.06l1.22,0.46l4.0,-0.1l0.92,-0.53l1.59,-2.35l0.82,1.3l2.12,1.67l1.03,0.14l1.21,-0.48l2.01,0.79l1.9,0.18l1.48,-0.45l0.26,-0.49l-0.74,-1.79l0.98,-1.18l-0.98,-1.19l4.32,-1.54l0.65,-0.75l0.33,-2.14l-0.13,-1.17l-0.95,-1.16l0.13,-0.69l0.25,-0.33l4.9,-1.78l0.95,-1.14l2.19,-0.05l0.5,-0.65l-0.2,-1.45l0.85,-0.55l3.1,0.8l2.36,1.14l1.59,1.24l0.96,1.48l1.26,1.13l2.81,1.85l1.03,1.44l1.3,0.76l2.64,0.6l1.39,1.47l1.44,0.67l7.73,0.66l2.52,-0.79l1.72,-1.78l2.6,-0.25l-0.75,1.25l1.37,2.81l-0.3,1.16l0.68,0.87l0.9,0.34l-0.43,0.82l0.1,1.43l1.31,1.12l3.14,1.15l0.78,0.85l-2.14,0.07l-0.85,-0.44l-0.57,0.26l-0.1,0.53l-0.62,0.17l-0.29,0.46l0.49,2.66l-0.15,0.57l-0.99,0.12l-0.22,0.72l-0.35,0.03l-1.74,-0.65l-0.59,-1.84l-1.46,-1.06l-2.32,-0.14l-2.74,-0.81l-2.1,0.23l-1.83,-0.36l-1.83,1.07l-0.59,-0.01l-1.56,-1.26l-0.68,-0.17l-2.04,0.71l-2.45,-0.72l-2.59,-0.11l-2.75,-1.72l-0.46,0.02l-1.61,1.24l-3.67,-0.22l-3.04,3.34l-1.49,-0.9l-1.72,-1.94l-1.03,-0.46l-1.26,-0.1l-1.52,0.7l-0.82,5.66l0.14,1.89l1.92,1.38l2.27,2.38l0.73,0.32l1.41,4.88l1.26,1.68l3.93,3.5l1.7,2.26l5.03,4.33l2.43,1.02l0.02,1.54l0.34,0.88l1.53,1.81l2.97,2.53l0.33,0.71l-0.53,0.3l-3.22,-2.75l-2.74,-1.61l-3.2,-3.05l-4.08,-1.17l-2.77,-1.3l-3.78,0.58l-1.68,-0.17l-0.41,-0.57l-0.18,-1.66l-5.98,-4.16l-4.2,-4.32l-0.57,-0.94l1.66,-0.36l2.37,0.27l0.45,-0.22l-0.12,-0.48l-2.73,-1.86l-3.85,-3.6l-1.08,-1.61l0.16,-4.25l-0.73,-2.03l-4.37,-3.88l-2.23,-0.75l-1.46,0.24l-0.65,1.06l-0.42,1.98l-3.52,5.22l-0.94,-0.0l-3.02,-4.37l-1.43,-5.94l0.28,-0.2l0.5,0.51l3.57,0.82l1.03,-0.39l0.69,-0.9ZM587.09,559.57l2.86,1.2l-0.65,-0.13l-2.2,-1.07ZM591.3,561.05l-0.27,-0.82l0.24,-0.07l0.56,0.15l0.73,1.02l-1.27,-0.27ZM599.03,565.39l1.29,0.47l0.05,0.42l-0.83,-0.52l-0.5,-0.37ZM574.06,555.07l2.29,0.14l0.72,0.66l0.72,0.07l-0.88,-0.02l-1.68,-0.33l-1.18,-0.53ZM577.19,558.94l1.74,0.32l1.9,-0.2l1.59,0.28l-1.61,-0.19l-1.63,0.5l-1.35,-0.25l-0.64,-0.46ZM578.24,553.5l-2.04,0.04l-2.36,-0.62l0.18,-0.53l1.76,0.07l3.32,0.71l-0.86,0.32ZM552.42,532.01l1.48,1.22l2.64,2.63l-0.28,0.25l-3.01,-2.61l-0.83,-1.49ZM551.01,528.89l-1.01,-0.23l0.11,-0.55l0.35,0.02l0.55,0.76ZM547.01,523.61l0.87,-0.6l0.52,-0.96l2.47,3.21l-0.92,0.2l-1.06,-1.14l-1.25,-0.15l-0.64,-0.56ZM545.04,522.83l0.07,0.67l-0.21,-0.6l0.14,-0.08ZM545.55,524.84l0.91,0.95l-0.18,1.58l0.44,3.22l-1.56,-3.9l0.39,-1.86Z",name:"Croatia"},DE:{path:"M430.54,420.84l0.92,-0.06l2.69,-2.09l-0.09,-0.78l-0.62,-0.26l-0.01,-0.35l1.2,-2.32l0.46,-1.8l-0.14,-0.96l-1.33,-1.91l-0.18,-0.88l-1.75,-2.06l0.0,-0.39l2.55,-1.2l2.73,0.97l0.9,-0.57l1.27,0.05l3.04,-1.03l1.09,-1.59l-1.19,-1.26l0.08,-0.38l3.33,-2.18l0.69,-1.23l0.26,-2.25l-0.57,-1.0l-0.78,-0.57l-1.72,0.03l-0.99,-0.34l-0.56,-0.77l0.32,-0.81l-0.14,-0.63l0.26,-0.15l3.48,0.01l0.58,-0.47l1.2,-4.4l0.87,-1.53l0.25,-5.88l-0.69,-1.09l-1.23,-0.85l0.66,-2.97l1.24,-1.67l0.91,-0.42l4.57,-0.29l4.95,0.12l1.86,2.37l-0.66,1.17l0.16,0.55l1.25,0.65l0.93,-0.22l1.1,-2.84l1.71,1.34l0.03,2.08l0.36,0.39l0.43,-0.32l0.59,-3.01l-0.42,-2.2l0.28,-1.9l0.99,-1.44l3.67,0.69l4.06,-0.37l1.41,0.7l3.63,3.98l1.33,0.69l1.5,0.2l0.44,-0.29l-0.24,-0.47l-1.99,-0.81l-4.4,-4.83l-1.43,-0.63l-1.94,-0.18l-1.77,-1.03l-0.25,-5.57l-0.75,-0.72l-1.14,-0.35l-1.62,0.32l-0.16,-0.68l0.18,-0.5l2.27,-0.51l1.72,-0.78l0.31,-1.67l-3.74,-4.94l-0.12,-1.54l2.65,0.11l3.74,0.96l1.1,0.72l1.31,0.02l3.51,-0.89l1.75,0.87l1.88,0.47l1.57,1.79l0.07,1.44l-2.01,1.88l-0.12,0.46l0.4,0.25l3.46,-0.28l0.85,1.3l0.43,0.15l1.87,-0.51l4.9,2.22l3.72,-1.12l0.53,1.41l-0.65,1.61l-2.59,1.91l-0.12,0.5l0.59,1.22l1.1,0.48l2.61,-0.23l4.21,1.16l0.93,-0.43l3.21,-2.73l1.19,-0.54l4.49,-0.58l0.73,-1.01l1.74,-1.1l3.62,-3.29l5.8,1.01l1.62,2.36l4.08,2.65l3.73,-0.15l1.18,2.22l0.71,3.25l2.21,1.63l3.05,0.68l0.48,2.97l1.56,5.02l-0.04,1.42l-0.54,1.61l-0.94,1.33l-1.28,0.77l-0.85,1.0l-0.23,1.2l1.81,2.09l3.53,2.51l1.27,1.91l-0.81,3.15l0.34,0.97l1.43,1.19l0.26,2.35l0.57,0.56l-0.95,2.89l-1.01,1.59l0.34,1.21l1.36,1.97l-0.22,1.81l0.22,0.65l2.57,1.24l1.33,3.49l-1.29,4.18l-1.87,3.2l-1.46,-0.48l0.11,-0.81l-1.26,-1.82l-3.37,-0.82l-0.7,0.29l-0.4,0.92l1.31,1.41l-5.96,2.33l-2.6,0.78l-2.07,0.25l-1.5,1.77l-0.94,-0.31l-2.04,0.96l-0.67,1.03l-2.06,0.33l-0.98,1.46l-2.31,-0.41l-3.18,0.72l-1.4,0.85l-2.01,2.57l-1.77,-1.93l-0.72,-0.08l-0.44,0.32l-0.04,1.02l1.14,1.65l0.52,1.47l1.03,1.06l2.35,1.46l0.63,0.91l-1.61,2.81l1.52,1.82l2.46,3.98l1.87,1.57l1.49,0.06l2.95,2.95l2.61,1.64l0.92,1.52l0.79,0.46l1.3,-0.06l3.29,3.0l-0.16,2.44l-0.83,1.09l-0.5,0.23l-2.76,-0.87l-0.49,0.51l-0.66,2.87l-0.38,0.46l-6.37,2.67l-1.17,0.77l-0.83,1.02l-0.01,1.03l2.54,3.11l0.01,1.18l-0.74,1.46l0.24,0.51l1.68,0.35l0.18,0.48l-0.4,2.61l-2.26,-1.03l-0.43,-1.57l-1.34,-0.68l-2.77,0.52l-1.62,-0.86l-2.11,-0.53l-0.57,0.25l-0.13,1.46l-6.22,0.61l-4.4,1.66l-1.31,1.07l-1.45,0.0l-1.91,0.52l-0.6,-0.06l-1.66,-2.12l-5.79,-0.52l-0.56,0.34l-0.83,3.01l-0.69,0.81l-1.08,0.46l0.2,-0.9l-0.26,-0.48l-1.5,-0.34l-0.22,-1.01l-1.29,-1.05l-3.11,-1.25l-0.84,0.49l-7.44,-4.01l-0.69,0.18l-0.13,0.52l0.63,1.16l-3.25,0.23l-0.69,-0.77l-0.81,-0.23l-0.59,0.27l-1.41,-1.07l-0.93,-0.24l-2.0,0.82l-0.58,0.89l0.1,0.75l0.97,0.47l-0.22,0.19l-3.28,-0.22l-1.51,0.54l-2.18,0.2l-3.02,-0.1l-1.57,-0.55l-0.38,-0.91l0.11,-1.58l0.74,-2.31l0.21,-1.68l-0.31,-1.12l0.4,-1.44l1.21,-2.16l1.76,-6.1l4.05,-4.32l0.04,-1.82l-0.29,-0.36l-1.85,-0.66l-5.27,-0.89l-1.02,-0.38l-1.24,-1.21l-3.4,0.67l-2.1,-0.1l-0.44,-1.02l-1.73,-0.51l-1.82,0.86l-2.04,-2.62l-0.66,-1.44l-1.19,-0.93l-1.22,-0.27l0.41,-1.96l1.46,-1.99l0.04,-1.7l-3.27,-1.56l-1.51,-1.71l-0.36,-1.88l0.82,-2.22l2.46,-1.42l0.19,-0.42l-0.31,-2.35l-0.75,-0.87l-1.5,-0.57l0.7,-0.84l-0.06,-0.62l-3.08,-2.45l0.64,-2.95l-0.69,-0.92l-1.76,-0.94ZM538.5,364.74l4.43,2.81l-0.02,0.85l-1.71,0.2l-1.36,-0.24l-0.07,-2.1l-1.21,-1.13l-0.06,-0.38ZM536.24,359.59l0.19,1.05l-1.4,-0.89l-1.53,0.01l-1.16,1.66l-0.34,0.03l-2.16,-1.36l-0.36,-1.05l0.29,-2.61l0.72,-0.83l0.1,-0.88l1.09,-0.91l0.75,-0.03l0.89,1.43l2.04,0.8l0.23,0.34l-1.13,1.59l0.47,0.93l1.31,0.71ZM503.18,358.26l-1.43,0.03l-1.18,-0.81l0.48,-0.55l1.69,0.5l0.45,0.83ZM463.5,350.42l0.29,-1.31l0.49,0.91l0.99,0.04l-1.77,0.36ZM466.66,353.0l-0.22,0.19l-1.35,-0.23l0.93,-0.31l0.63,0.36Z",name:"Germany"},BA:{path:"M608.48,527.74l3.07,-0.74l1.2,0.42l-0.79,2.63l-1.93,2.88l-0.46,3.03l0.51,1.08l2.62,1.37l3.17,2.88l-0.23,0.39l-1.2,0.13l-2.07,-0.23l-0.97,0.56l0.15,0.91l3.04,3.85l0.08,0.83l-0.38,0.94l-1.06,-0.49l-0.81,0.03l-0.9,0.24l-0.68,0.71l-1.4,0.25l-1.35,-0.37l-0.66,0.34l-0.25,0.99l1.25,2.21l-0.08,0.64l-0.78,-0.82l-1.48,-0.05l-2.53,2.08l-0.73,1.8l0.01,1.34l-1.64,0.26l-0.76,0.89l0.27,3.36l1.07,2.1l-1.07,0.99l-1.63,-0.59l-2.39,-1.46l-3.77,-2.5l-0.73,-1.04l-2.18,-0.15l0.47,-0.54l-0.1,-0.84l-4.84,-4.93l-0.31,-2.37l-0.52,-0.52l-2.14,-0.74l-4.93,-4.25l-1.71,-2.26l-3.91,-3.48l-1.1,-1.42l-1.51,-5.08l-0.87,-0.45l-2.23,-2.34l-1.83,-1.33l0.67,-6.52l0.28,-0.24l0.73,-0.18l1.63,0.37l1.74,1.95l1.96,1.12l1.37,-0.9l2.12,-2.55l3.36,0.32l1.8,-1.25l2.69,1.66l1.16,0.26l1.55,-0.13l2.52,0.74l2.08,-0.71l2.1,1.42l1.04,-0.04l1.55,-1.0l1.73,0.34l2.04,-0.24l2.68,0.79l2.34,0.15l0.97,0.73l0.49,1.68l0.79,0.76l2.6,0.32Z",name:"Bosnia and Herz."},HU:{path:"M574.1,479.74l1.55,-0.97l2.58,1.22l3.97,-0.49l0.32,-0.51l-0.38,-2.54l0.54,-0.63l0.13,-0.94l0.82,-0.63l1.72,0.33l4.27,3.09l1.92,0.75l5.23,0.12l7.85,-0.41l1.05,-1.32l-0.32,-1.6l0.46,-0.86l1.48,-0.78l4.68,-0.38l2.8,-0.66l1.42,-1.79l0.61,-0.13l3.87,1.55l5.93,-2.86l2.25,-4.04l1.81,-0.35l2.94,0.07l2.8,0.69l5.06,-0.81l1.4,0.91l2.13,2.58l0.79,0.23l6.37,-1.27l1.33,2.56l2.34,0.93l0.97,1.3l1.37,0.54l1.12,-0.08l0.79,0.7l0.31,1.75l-3.23,2.7l-1.51,-0.12l-2.92,0.86l-2.41,2.67l-1.56,1.19l-0.16,1.98l-1.62,1.48l-1.18,2.9l-1.73,1.75l-0.13,1.34l-2.12,2.95l-0.24,0.62l0.18,0.84l-2.28,1.58l-0.95,2.12l0.13,1.13l-0.95,0.47l-0.52,1.42l-1.26,0.86l-2.62,-0.28l-1.17,0.24l-0.9,1.34l-0.99,0.54l-1.52,-0.54l-3.55,0.89l-1.03,-0.47l-3.08,-0.33l-1.29,0.26l-3.03,-0.39l-1.28,0.24l-1.63,1.6l-1.88,1.0l-1.5,0.24l-1.07,-0.47l-1.04,0.98l-1.05,0.42l-2.71,0.54l-0.7,-0.13l-2.05,1.92l-2.19,0.68l-7.36,-0.61l-2.08,-1.2l-0.59,-0.87l-1.18,-0.5l-1.58,-0.16l-1.15,-0.67l-0.95,-1.37l-4.05,-2.96l-0.99,-1.51l-1.75,-1.36l-3.01,-1.38l-1.73,-2.2l-0.02,-0.77l-0.66,-0.74l-0.73,-2.3l-1.88,-0.24l2.28,-1.61l1.33,0.05l0.62,-0.39l0.55,-2.05l-0.16,-0.54l-0.64,-0.29l-0.2,-0.91l0.58,-1.02l-0.33,-1.71l2.32,-0.86l0.87,-1.68l-0.74,-1.83l-2.35,-0.68Z",name:"Hungary"},JE:{path:"M322.87,452.86l-0.06,0.38l-0.56,-0.27l-1.49,0.09l0.08,-0.64l2.02,0.44Z",name:"Jersey"},FI:{path:"M642.77,218.25l1.12,-0.27l0.17,-0.8l-3.01,-6.76l-1.66,-1.51l1.26,-4.66l-0.13,-1.29l-0.44,-1.65l-2.0,-1.41l-0.81,-4.2l0.5,-2.29l0.65,-0.99l3.52,-3.35l0.3,-1.68l2.07,-0.11l0.31,-0.63l-1.08,-1.53l-0.27,-1.43l3.0,-0.62l1.43,0.56l3.05,-0.72l2.8,-1.45l0.17,-1.13l-0.91,-1.85l1.24,0.03l-0.36,-1.06l1.03,0.05l1.76,-1.91l0.16,-1.42l2.91,-0.77l3.47,-2.96l3.21,-1.64l3.23,-2.9l1.63,-0.39l0.7,-1.93l2.7,-2.58l0.99,-0.5l1.28,-2.37l3.5,-2.87l2.18,-3.57l1.19,-1.25l0.4,-1.27l1.07,-0.09l1.37,-1.04l2.49,-0.66l2.47,0.18l1.24,0.48l1.0,-0.15l0.34,-0.43l-0.1,-1.23l-0.59,-0.75l1.83,-1.31l-0.47,-2.07l-1.07,-0.98l1.19,-7.23l-1.66,-1.93l-5.46,-2.54l-2.15,-0.22l-1.08,-1.64l0.59,-2.18l-0.41,-0.44l-0.76,0.14l-0.76,0.77l-1.54,0.82l-2.1,-0.66l-0.96,0.1l-1.35,-3.86l-1.94,-3.6l-2.51,-1.5l-0.6,-3.55l0.1,-1.33l0.2,-0.66l0.88,-0.57l1.4,-1.77l0.39,-2.96l1.27,-2.55l-0.7,-1.67l-3.55,-4.29l-0.46,-1.32l-0.2,-2.19l1.99,-2.12l-0.54,-2.44l-1.32,-0.69l-2.46,-0.23l0.14,-1.03l1.05,-2.32l-0.56,-2.01l0.01,-3.87l1.64,-1.24l0.06,-1.15l-2.2,-1.44l-1.54,-1.59l-0.47,-0.92l-1.92,-0.34l-1.17,-2.76l-3.36,-2.61l-1.06,-0.59l-5.7,-1.72l-2.28,-0.33l-2.6,-0.97l-7.13,-3.97l-0.62,-0.81l-3.28,-2.49l-3.42,-1.76l-0.17,-1.37l-0.37,-0.48l-3.13,-1.15l2.86,-0.25l2.65,0.65l0.68,-0.47l0.33,-0.96l-0.97,-2.39l0.11,-0.4l2.45,-1.26l4.54,0.04l9.08,9.74l1.07,1.8l0.37,1.29l0.39,0.29l8.8,1.06l1.17,0.77l2.44,-0.15l5.27,-1.54l2.05,-2.15l1.69,0.15l4.54,2.05l4.94,1.36l1.47,1.13l2.14,0.27l2.15,-1.3l1.14,-2.92l0.96,-1.23l1.35,-0.9l3.04,-0.64l2.41,-2.51l0.36,-2.25l-0.26,-3.73l0.23,-1.11l1.13,-2.04l1.5,-5.3l0.64,-1.46l0.73,-0.83l3.2,-2.19l2.92,-3.19l2.69,-0.38l5.31,0.64l3.11,-1.34l3.28,-1.98l2.0,-0.52l1.71,0.07l2.06,2.1l4.99,3.64l5.33,2.23l4.51,1.41l2.41,4.42l-1.13,1.66l-2.89,2.52l-2.42,2.65l-0.24,1.85l1.38,1.94l-6.81,2.58l-0.22,0.62l0.84,0.92l3.36,0.16l0.61,0.39l0.04,0.39l-0.3,0.87l-3.67,5.48l-0.16,1.52l2.92,7.03l9.06,3.17l2.4,3.03l4.03,4.07l2.13,1.71l-0.59,2.59l-4.94,5.07l-4.47,5.24l-2.13,2.89l-0.36,2.03l0.45,1.23l2.7,3.48l2.31,3.68l2.8,5.79l3.13,4.14l2.47,6.75l0.12,1.92l-2.63,0.33l-2.15,0.65l-0.35,0.42l0.09,0.48l1.16,1.03l-1.13,2.01l-0.17,2.9l-1.24,1.49l-0.21,0.7l0.62,0.87l2.25,0.39l0.09,0.91l-0.16,0.59l-2.59,1.65l-0.27,1.72l1.38,2.88l1.19,1.01l3.95,0.91l0.37,0.52l0.12,1.59l-1.73,1.8l-0.07,1.16l1.84,3.66l3.8,1.8l1.2,0.91l0.47,1.84l-0.02,1.31l-0.27,1.1l-3.85,4.54l-2.72,1.17l-0.31,0.89l5.84,5.02l7.58,4.38l2.72,1.92l2.09,2.95l2.32,2.38l0.27,1.15l-3.32,6.63l-1.3,1.77l-3.37,3.29l-5.05,4.15l-11.85,12.11l-2.68,2.11l-3.26,3.24l-6.92,4.7l-1.08,1.18l-3.43,2.16l-8.21,7.34l-1.68,0.75l-1.87,0.16l-0.84,0.47l-3.55,-1.54l-1.89,0.43l-1.61,1.04l-3.07,0.33l-2.14,0.65l0.29,-1.94l0.65,-0.96l0.13,-0.85l-0.45,-0.43l-0.5,0.07l-1.28,1.66l-0.55,1.73l-0.89,0.73l-2.1,0.32l-2.16,-1.32l-1.3,-0.04l-0.33,0.63l1.05,2.05l-1.03,-0.03l-2.52,1.57l-0.89,-1.14l-0.5,-0.16l-2.71,1.45l-2.64,0.33l-1.46,1.06l-7.46,1.6l-1.27,1.45l-0.76,0.39l-1.42,-0.39l-8.4,1.55l-3.69,-0.35l-3.8,2.83l-1.98,0.53l2.58,-2.49l0.22,-1.21l-0.2,-0.4l-1.63,-0.55l-1.02,-0.91l-1.36,-2.4l-1.04,0.08l-0.67,2.35l-0.77,0.71l-1.25,0.53l-2.16,-0.02l-0.21,-0.77l0.41,-1.08l-0.13,-0.82l1.1,-0.12l0.67,-0.88l-0.37,-0.93l-0.65,-0.1l0.93,-1.94l-0.28,-0.49l-4.43,-0.42l-4.34,-2.0l-0.96,-0.12l-0.58,-1.58l-0.46,-0.25l-1.2,0.29l-1.32,0.91l-2.1,-1.16l-0.93,-7.31l0.22,-1.74l1.36,-2.29l0.49,-2.36l0.11,-2.75l-0.24,-1.14l0.43,0.0l0.38,-0.53l-0.76,-1.2ZM687.44,144.29l-1.79,0.65l-1.22,-0.34l-0.02,-0.9l0.76,-0.51l1.66,-0.25l1.7,0.47l-1.08,0.89ZM651.46,242.91l1.58,0.43l0.67,-0.11l0.37,0.48l-1.17,0.78l-0.1,0.84l0.63,0.93l-0.71,-0.0l-0.85,-1.35l-1.17,-0.85l0.4,-0.98l0.37,-0.17ZM646.99,242.06l0.23,-0.82l0.48,0.41l-0.15,0.7l0.64,0.51l-1.2,-0.79ZM646.46,246.89l-1.07,0.55l-0.05,-0.02l0.08,-0.67l0.56,-0.37l0.66,-0.03l-0.18,0.54ZM643.72,247.48l-0.79,0.13l-0.32,-0.25l1.18,-0.39l-0.07,0.51ZM641.16,239.43l-0.07,0.33l-1.37,0.07l-0.55,-0.69l-0.31,-1.48l2.3,1.77ZM638.04,182.53l0.17,0.59l0.43,0.26l0.96,-0.17l0.89,-0.6l0.27,0.45l-0.56,-0.04l-1.2,1.04l-1.18,-0.84l-0.53,-1.0l0.8,-0.0l-0.05,0.32Z",name:"Finland"},BY:{path:"M670.47,410.28l-0.13,-0.27l0.06,-1.46l1.09,-1.97l-0.23,-1.17l0.56,-1.59l0.0,-1.53l-0.91,-1.32l-1.93,-1.22l-3.4,-1.52l-0.13,-0.47l3.0,-3.66l5.77,-2.64l0.89,-0.8l0.33,-2.39l-0.79,-5.49l-3.54,-9.02l-1.36,-5.56l2.79,0.28l1.97,-0.44l4.12,-0.26l1.99,1.03l4.06,-1.59l1.9,0.09l0.64,-0.62l0.52,-2.25l0.36,-0.3l2.44,0.18l1.03,-0.51l0.87,-1.04l1.25,-0.61l1.3,-0.06l0.98,-0.62l0.5,0.91l-0.32,0.99l0.36,0.45l1.01,0.4l2.51,-0.34l0.49,-0.81l-0.35,-1.77l-0.8,-0.73l-1.79,-0.35l0.92,-2.21l1.46,-2.06l-0.02,-2.89l0.75,-2.06l0.97,-1.47l2.97,-0.75l1.28,-0.84l1.11,-2.33l0.33,-0.17l4.09,0.17l1.26,-1.87l1.39,-0.94l0.08,-0.49l-0.47,-0.58l-3.74,-0.67l1.4,-3.61l0.38,-2.21l2.87,-0.65l1.83,-1.99l1.15,-0.29l3.4,0.5l3.99,-0.04l0.92,-2.18l3.35,-3.06l1.75,-1.04l1.25,-0.18l1.76,1.58l0.64,0.16l1.24,-0.67l2.07,-0.07l0.81,0.47l1.37,1.98l0.92,0.38l3.4,-1.49l3.19,1.0l1.29,0.81l-0.51,2.56l1.82,1.98l0.47,0.03l2.62,-1.56l1.96,-0.52l1.42,-0.92l3.92,-0.0l2.83,1.04l2.24,2.21l1.47,0.96l2.03,0.41l0.22,0.33l-0.08,3.01l-1.07,1.29l-0.11,1.14l1.99,2.8l0.22,1.35l-1.98,2.56l-0.54,2.11l0.11,0.59l4.8,3.05l-1.06,2.24l0.22,0.44l1.4,0.68l1.5,2.95l1.42,1.79l5.69,3.04l-0.04,1.47l-0.94,2.24l0.22,0.54l1.06,0.37l5.02,0.19l3.1,1.5l-0.32,1.27l0.64,1.39l3.16,2.26l0.01,1.08l-3.01,1.21l-0.7,1.17l-3.65,2.08l-3.72,-0.26l-1.43,-1.43l-1.18,-0.32l-3.43,0.09l-0.75,0.46l-1.71,3.0l0.04,0.52l4.03,4.54l-0.61,1.04l0.17,1.42l0.95,1.23l-0.33,4.38l1.6,1.88l0.82,1.53l-5.16,-0.05l-1.77,0.96l-1.99,-0.42l-1.46,0.63l-3.05,2.73l-1.29,1.6l-1.83,3.95l1.26,4.37l-0.98,1.32l-0.92,-0.12l-1.36,-0.8l-0.44,-1.39l-2.23,-1.49l-8.28,0.78l-2.69,0.89l-2.12,-3.38l-0.52,-0.66l-0.8,-0.34l-0.77,0.12l-1.1,0.93l-1.76,0.6l-0.87,0.66l-0.7,1.15l-0.62,-0.26l-0.83,-1.64l-5.66,-1.19l-2.43,0.84l-2.32,-0.52l-1.82,1.98l0.15,-1.24l-0.24,-0.41l-1.34,-0.56l-4.0,0.09l-2.18,-2.8l-5.0,-0.34l-4.26,-0.76l-0.91,-0.58l-8.26,-1.44l-9.81,-0.12l-2.74,0.57l-6.86,0.57l-0.74,0.64l-0.63,1.19l-2.0,1.92l-1.94,1.27l-1.28,-0.61l-2.2,-0.32l-1.06,0.29l-0.7,0.7Z",name:"Belarus"},GR:{path:"M728.08,670.66l-0.79,0.26l-0.27,-0.39l0.51,-1.56l-0.52,-1.53l2.47,-2.52l3.7,-1.26l-1.12,2.79l-1.0,1.2l0.08,0.93l-1.45,0.33l-1.59,1.75ZM727.96,660.69l0.31,-0.19l-0.05,0.46l-0.26,-0.27ZM717.45,657.54l2.45,-1.2l0.79,0.06l-1.92,1.05l-1.31,0.09ZM718.65,675.52l0.9,2.17l-0.84,0.63l0.1,-1.01l-0.53,-1.15l0.37,-0.64ZM711.88,642.87l1.58,-0.77l0.98,-0.02l2.64,0.58l0.06,0.28l-2.41,0.93l-1.62,-0.93l-1.23,-0.07ZM716.41,654.11l0.54,0.48l-0.03,0.04l-0.63,0.1l0.12,-0.63ZM708.43,617.81l-0.05,1.13l1.83,1.52l0.65,1.19l-0.81,-0.3l-0.49,0.49l0.43,0.99l-0.37,0.12l-3.89,-0.79l-0.36,-0.44l1.99,-1.7l-0.34,-0.63l-1.6,0.18l-1.24,1.38l-1.92,-0.59l-0.59,-0.58l0.65,-1.02l1.36,0.04l0.99,-0.34l1.05,-0.45l0.25,-0.65l1.92,-0.12l0.56,0.56ZM623.87,612.82l0.81,0.1l0.84,-0.47l0.47,-0.56l0.3,-1.23l0.8,-0.02l0.42,-0.51l-0.08,-0.84l-0.89,-1.74l1.18,-1.04l2.5,-0.46l0.86,-0.63l2.04,-5.25l1.85,-0.75l0.87,-1.26l0.46,-1.74l-1.01,-1.95l0.07,-0.75l4.52,-0.26l1.17,-0.64l2.45,0.55l2.71,-1.28l2.13,-2.58l0.71,-0.31l2.57,-0.43l4.21,0.63l3.19,-0.98l0.81,-2.47l4.88,0.17l1.31,-1.02l5.3,-0.03l3.31,-1.11l1.87,-0.11l0.72,-1.05l4.19,0.07l1.53,-0.5l1.02,1.67l2.5,1.47l1.25,-0.53l1.82,0.43l3.69,1.98l7.19,-1.39l1.97,0.27l2.96,-1.23l0.46,-1.18l-0.61,-2.89l-0.57,-0.89l0.35,-0.54l1.04,-0.24l2.68,0.72l2.17,1.52l0.5,2.84l-0.19,0.48l-0.81,0.19l-2.79,1.69l-0.26,1.91l0.38,2.25l-3.16,3.73l-0.56,0.18l-0.34,-0.5l-2.25,-1.26l-4.82,-0.7l-2.28,-0.88l-1.1,0.12l-2.16,-0.96l-1.44,0.48l-2.75,1.7l-1.32,-0.16l-1.58,-1.02l-1.46,-0.22l-1.39,0.65l-1.98,1.99l-1.88,0.91l-1.8,-0.37l-2.49,0.01l-0.39,0.31l-0.22,1.44l1.67,1.98l-0.49,1.12l0.47,1.01l0.99,0.39l-1.39,-0.11l-1.3,0.61l-0.33,1.0l1.52,1.65l1.88,1.38l0.37,1.18l-0.35,0.48l-1.18,-0.71l-2.27,-3.16l-3.48,-0.8l-0.39,0.14l-0.6,1.06l0.63,1.71l0.62,0.86l2.45,1.61l-2.93,-0.93l-0.8,-1.4l-0.43,-2.26l-5.5,-2.86l-0.45,-1.08l0.86,-1.57l-0.43,-0.54l-1.68,0.27l-2.63,1.64l0.16,2.07l-0.97,3.91l0.31,1.49l3.35,3.9l1.1,2.68l0.87,1.13l1.73,1.2l1.71,2.07l0.7,1.04l0.44,1.49l-1.17,0.88l-0.56,0.03l0.43,-1.37l-0.31,-1.06l-2.29,-1.17l-1.38,0.42l-1.12,0.76l-0.14,0.5l1.36,2.35l0.34,1.2l0.45,0.29l-2.36,1.26l-2.76,0.18l-0.61,0.48l0.16,0.67l1.6,0.3l1.19,0.76l3.27,0.91l1.74,1.2l1.38,0.09l1.7,2.15l2.57,0.54l1.7,2.19l2.02,0.42l1.63,0.73l0.65,1.86l0.5,5.06l-0.07,1.48l-0.27,0.28l-0.29,0.01l-1.21,-1.49l-4.01,-3.64l-1.32,-0.49l-1.28,0.69l-3.11,0.54l-1.92,0.86l-0.41,0.62l0.17,0.49l1.31,1.11l0.04,1.25l0.68,1.51l1.09,0.59l1.64,0.17l1.16,1.61l-3.98,1.51l-0.47,-0.26l-0.24,-1.31l-2.13,-1.2l-1.23,-0.26l-0.96,-0.77l-0.53,0.03l-0.67,0.67l0.43,2.7l1.21,1.72l2.8,6.72l0.16,1.11l-0.37,2.26l1.29,2.3l-1.48,-1.02l-1.97,-2.38l-0.69,-1.5l-1.16,-0.35l-1.89,0.44l-1.62,3.29l-0.04,1.39l-0.21,-0.11l-0.53,-0.44l-0.06,-2.98l-1.96,-2.81l-0.93,-0.41l-1.11,-1.88l-0.41,-0.16l-1.04,0.23l-0.97,0.71l-0.56,3.35l-1.68,-1.57l-2.02,-3.26l-0.05,-1.6l1.53,-1.91l-0.24,-1.37l-1.56,-2.52l-2.1,-1.55l-1.1,-0.44l-0.63,-1.66l-2.03,-1.46l2.41,-2.02l1.21,-2.49l1.74,0.55l1.49,-0.17l2.34,-2.4l1.5,0.09l3.86,2.05l4.28,1.21l2.03,1.0l1.29,1.08l1.71,0.38l0.46,-0.42l-0.23,-1.23l2.57,-0.15l0.74,-0.53l0.42,-1.05l-0.47,-0.67l-1.03,-0.49l-1.47,-0.29l-0.73,0.18l-1.18,-0.46l-5.55,-3.19l-0.57,0.13l-0.44,0.74l-0.71,0.36l-1.11,0.06l-3.71,-0.92l-2.15,0.71l-4.25,0.68l-1.88,-2.53l-0.6,0.34l-0.26,1.46l-1.28,0.35l-0.68,-0.45l-1.66,-4.25l-1.61,-1.93l-1.24,-0.53l-0.08,-0.77l0.07,-0.5l1.17,-0.16l2.36,0.85l0.88,-0.23l0.71,-0.78l-0.49,-1.83l-2.98,-0.34l-1.94,0.42l-0.66,-0.31l-3.3,-3.44l-2.27,-1.18l-1.43,-3.35l-1.02,-1.26ZM675.16,600.88l1.34,-0.04l2.3,1.22l1.04,1.37l-1.41,-1.3l-3.27,-1.24ZM707.89,661.28l-0.16,0.18l-0.36,-0.27l0.41,0.1l0.11,-0.02ZM708.79,660.68l0.03,-0.08l0.05,0.06l-0.08,0.03ZM703.69,645.69l0.95,-0.85l2.01,-0.19l-0.72,0.46l-2.24,0.58ZM672.76,675.97l0.47,1.17l1.83,0.46l1.71,-0.13l0.86,-0.89l0.55,-0.01l0.13,0.28l-0.96,0.59l0.02,0.55l1.05,0.63l0.84,-0.04l0.27,0.97l0.84,0.59l1.91,-0.04l3.7,-0.9l3.66,0.22l1.49,0.98l2.58,0.12l2.39,0.5l3.4,-0.62l-0.05,2.83l0.84,0.58l0.89,-0.12l0.88,-0.75l1.68,-0.51l1.84,0.0l1.35,-1.09l-0.21,1.46l-0.45,1.56l-0.8,0.3l-4.51,-0.1l-13.88,1.39l-0.4,-0.13l-0.14,-1.43l-0.43,-0.64l-3.49,-1.22l-7.93,-1.34l-2.54,0.18l-1.23,-0.27l-0.31,-0.42l-0.17,-1.7l0.27,-1.65l0.87,0.49l0.43,-0.08l0.58,-0.56l0.16,-1.18ZM702.17,634.63l0.83,-0.47l0.56,-1.18l-0.51,-1.11l-1.37,-1.35l-0.04,-0.53l1.75,-0.34l1.57,0.89l0.07,3.17l-0.61,0.53l-0.14,0.76l-0.95,0.65l-1.15,-1.03ZM698.48,599.9l-0.88,0.24l-0.94,-0.74l0.76,-0.25l1.05,0.74ZM696.85,654.58l-0.82,0.4l-0.91,-1.59l1.84,-1.64l0.35,0.34l-0.04,1.56l-0.43,0.92ZM695.75,663.45l0.09,0.3l-0.33,0.43l0.19,-0.35l0.05,-0.37ZM695.08,647.43l-0.75,0.06l0.03,-0.54l1.08,0.27l-0.36,0.21ZM690.86,607.38l1.89,-0.07l0.57,0.64l0.49,0.09l1.51,-1.04l-0.9,1.57l-0.18,1.09l-0.59,-0.12l-0.12,-0.89l-0.43,-0.38l-0.69,0.27l-0.36,0.77l-1.05,-0.22l-0.14,-1.72ZM694.65,659.11l-0.68,-0.65l-0.17,-0.27l0.96,0.71l-0.11,0.21ZM693.06,653.23l-0.77,0.86l-0.66,-0.29l0.4,-0.81l0.94,-0.5l0.09,0.74ZM690.94,644.63l1.66,0.25l0.15,0.17l-0.25,0.51l-0.46,-0.08l-1.1,-0.84ZM689.21,642.46l-0.12,0.31l-1.78,-1.57l-1.08,-1.15l-0.1,-0.51l0.59,-0.25l0.74,1.01l1.24,0.26l0.52,1.9ZM686.25,596.85l-1.26,0.42l-1.41,-0.87l0.01,-0.29l1.17,-1.42l0.98,0.08l0.69,0.96l-0.17,1.13ZM685.69,654.47l0.32,0.59l-0.13,0.1l-0.14,-0.27l-0.05,-0.42ZM682.97,623.8l0.52,0.29l0.25,0.92l-0.86,-0.54l0.1,-0.68ZM684.19,625.48l0.31,0.27l-0.27,0.07l-0.04,-0.34ZM661.67,625.04l3.09,-1.8l1.96,-0.47l1.2,1.04l0.73,1.64l0.92,0.78l4.78,2.0l3.0,0.27l1.17,1.85l-0.19,1.13l1.22,3.9l1.43,1.15l2.67,0.25l-0.01,1.43l-0.63,0.53l-1.01,-0.67l-0.75,-0.06l-1.88,-1.44l-0.34,-1.37l-2.27,-3.04l-3.76,-0.18l-1.21,-0.55l-0.6,-1.8l-4.92,-3.91l-3.14,-1.2l-1.46,0.5ZM681.22,658.91l0.47,0.25l-0.55,0.09l0.08,-0.34ZM682.34,659.06l0.37,-0.41l0.36,-0.09l0.0,0.38l-0.73,0.12ZM682.94,652.14l-0.52,-0.06l0.36,-0.53l0.24,0.11l-0.07,0.48ZM681.96,648.45l-0.28,-0.62l0.24,-0.28l0.32,0.46l-0.27,0.44ZM680.69,645.1l-0.29,0.25l0.39,-1.2l0.31,-0.03l-0.41,0.98ZM672.52,621.17l-0.6,-0.11l-0.2,-0.37l0.8,0.47ZM668.93,639.82l0.26,-0.51l0.33,0.09l-0.09,0.46l-0.5,-0.04ZM661.94,664.62l1.47,1.53l-0.51,0.98l-0.83,-0.28l-0.27,-0.48l0.14,-1.75ZM633.7,642.06l0.48,0.52l-1.17,0.88l-1.26,-1.0l-0.97,-1.4l0.5,-0.6l0.61,0.8l1.24,0.33l0.56,0.47ZM627.1,635.32l0.7,-1.67l0.81,0.42l0.52,-0.22l0.62,-1.26l0.25,1.95l1.11,0.64l1.1,1.42l-0.07,0.54l-1.85,-0.68l-0.97,0.24l-0.29,-1.09l-0.71,-0.88l-0.52,0.0l-0.69,0.6ZM630.95,631.66l0.08,0.09l-0.0,0.18l-0.08,-0.27ZM629.87,628.81l0.45,-1.93l0.83,-0.95l0.06,2.57l-0.21,0.26l-1.14,0.06ZM620.81,615.4l-0.15,-0.1l-1.04,-1.97l-2.08,-2.4l2.14,-0.65l0.9,0.56l-1.09,1.26l0.72,1.12l0.59,2.18Z",name:"Greece"},RU:{path:"M726.11,290.03l1.44,0.47l1.4,1.79l1.34,0.66l1.83,0.02l1.0,-1.42l-1.01,-2.65l-1.75,-1.83l-1.79,-0.93l-3.39,0.01l-0.29,-1.23l0.24,-0.8l2.94,-2.83l0.33,-0.93l-0.98,-8.52l-0.89,-1.42l0.98,-1.16l1.86,-4.42l1.6,-0.5l0.55,-0.74l1.26,-0.69l-0.24,-1.11l-1.43,-1.46l0.6,-1.35l-0.65,-3.35l0.42,-0.82l0.57,-0.06l1.12,1.2l2.03,0.6l1.21,-0.84l0.54,-1.72l0.56,-0.46l1.07,0.55l1.95,0.23l2.87,-0.46l2.72,-3.42l6.88,0.87l6.12,1.65l0.89,-0.77l0.29,-1.23l-0.19,-0.42l-2.61,-1.39l-1.44,-1.91l-2.05,-1.51l-2.27,-0.21l-2.75,0.52l-3.91,-0.3l-3.38,-2.77l-2.3,-0.91l-1.57,-2.17l0.85,0.47l0.58,-0.26l0.39,-2.49l-2.07,-1.74l-4.84,2.14l-3.82,0.53l7.28,-6.51l3.44,-2.16l1.07,-1.18l6.97,-4.75l3.26,-3.23l2.7,-2.13l11.86,-12.12l5.03,-4.13l3.4,-3.32l1.38,-1.87l3.45,-6.95l-0.01,-0.97l-0.42,-0.8l-2.34,-2.4l-2.18,-3.05l-2.83,-1.99l-7.52,-4.34l-5.48,-4.63l2.72,-1.22l4.0,-4.72l0.38,-1.46l-0.17,-2.73l-0.38,-0.9l-1.51,-1.2l-3.71,-1.77l-1.54,-3.23l-0.01,-0.49l1.82,-2.02l-0.21,-2.19l-0.75,-0.87l-3.83,-0.84l-0.98,-0.81l-1.23,-2.52l0.19,-1.23l2.4,-1.41l0.44,-1.18l-0.26,-1.49l-2.69,-0.77l1.34,-1.73l0.27,-3.17l1.19,-2.04l-0.08,-0.5l-1.02,-0.91l4.61,-0.92l0.39,-1.34l-0.21,-1.45l-2.56,-6.99l-3.15,-4.16l-2.8,-5.79l-2.34,-3.73l-2.68,-3.45l-0.31,-0.84l0.25,-1.57l2.07,-2.8l4.43,-5.2l5.01,-5.15l0.73,-3.16l-0.28,-0.7l-2.11,-1.5l-3.99,-4.03l-2.62,-3.21l-8.77,-2.94l-2.79,-6.73l0.1,-0.97l3.69,-5.53l0.3,-1.8l-1.15,-0.93l-3.46,-0.31l9.02,-3.32l0.82,-0.57l0.66,-0.76l2.29,-4.62l8.22,-2.29l1.33,-1.04l1.09,-1.73l0.48,-2.01l-0.34,-0.97l5.48,2.43l2.48,0.12l1.09,-0.25l0.77,-0.81l0.37,-1.19l-0.59,-3.81l1.82,0.26l5.43,1.91l1.55,-0.18l1.81,-0.72l1.58,-2.18l0.98,-0.31l1.48,0.49l0.45,-0.15l0.48,-1.01l-0.7,-2.17l5.05,1.88l2.44,1.53l5.02,1.3l0.69,0.55l-0.14,1.85l-0.82,0.45l-2.04,-0.09l-8.15,-1.55l-1.16,1.0l-0.01,0.6l1.05,0.94l2.14,0.95l0.58,1.64l0.41,0.27l3.46,-0.24l3.3,0.68l1.42,-0.18l-0.88,1.41l0.08,0.55l0.89,0.44l3.73,-1.44l1.6,-0.36l0.6,0.25l0.09,0.86l-0.58,1.41l-0.09,1.2l-1.07,2.55l-1.81,0.91l-0.74,1.6l0.43,0.15l2.61,-0.7l1.48,-0.8l2.69,-3.85l0.61,-0.4l7.25,-0.07l8.54,2.02l2.04,0.17l2.33,-0.23l1.51,-1.05l7.57,1.96l10.28,4.47l15.04,7.36l8.43,6.46l1.18,1.5l3.07,0.79l0.85,-0.48l1.46,0.4l10.12,5.95l3.45,0.31l0.41,-0.54l-0.6,-1.55l0.93,0.68l1.87,2.27l2.36,1.76l2.33,2.53l1.51,0.78l0.0,30.64l-5.15,3.01l-10.98,3.76l-8.56,1.41l-3.42,0.1l-6.69,-0.7l-3.63,-0.75l-4.48,-2.13l-4.29,-1.1l-2.98,-0.49l-5.35,-0.2l-11.6,-2.1l-1.97,-0.72l-7.29,-4.12l-3.2,1.13l-1.46,0.18l-0.78,-0.94l0.53,-0.72l-0.24,-0.58l-4.14,-1.18l-3.43,-0.09l-4.02,-1.75l-1.59,0.44l-4.38,-1.76l-1.93,-1.41l-1.89,-2.33l0.92,-1.16l-0.19,-0.68l-7.27,-1.52l-6.84,-0.2l-0.4,0.29l0.18,0.46l1.19,0.72l3.05,0.43l3.73,2.29l-0.44,1.73l0.17,0.43l5.18,3.73l0.29,0.74l4.18,0.93l0.44,1.29l-0.47,0.94l0.67,1.15l5.49,1.86l-0.52,0.8l-1.44,0.78l-1.53,0.38l-0.3,0.36l0.24,0.4l0.93,0.34l1.98,-0.12l7.3,2.13l3.81,2.13l3.89,3.9l1.2,1.84l-0.12,1.89l-2.15,5.68l-0.9,1.09l-1.83,1.32l-0.1,0.55l3.58,5.02l1.76,3.94l0.38,3.98l1.24,0.96l-0.89,1.1l0.25,3.45l2.37,2.71l3.37,1.69l2.28,0.38l2.79,-0.66l1.95,0.87l4.57,3.12l2.06,3.28l1.09,0.86l8.27,2.02l5.37,1.99l1.05,0.1l2.82,-1.76l4.45,-1.19l1.69,-2.08l-0.15,-1.55l-1.13,-2.46l-0.48,-2.68l-2.94,-1.7l-4.41,0.47l-1.79,-0.09l-1.31,-0.61l-1.88,-1.7l-3.66,-4.27l-1.98,-1.45l-0.57,-0.81l-0.62,-1.12l0.06,-1.49l1.44,-0.01l1.8,-1.14l1.41,-4.09l3.11,-0.43l5.13,1.86l6.59,5.08l1.56,0.56l3.82,-0.04l0.42,0.59l1.34,0.79l7.02,1.73l7.13,3.16l2.91,-0.34l1.23,-2.43l2.64,-1.63l1.82,-0.27l2.7,0.62l0.94,-0.91l0.0,400.07l-4.46,-0.79l-1.09,0.42l-1.26,1.88l-5.84,-4.82l-2.57,-2.84l-8.3,-6.49l-7.29,-2.21l-4.42,-4.6l-2.32,0.5l-2.63,-0.52l-1.78,-1.42l-0.9,-1.9l-1.27,-1.31l-3.61,-1.66l-3.84,-0.92l-0.2,-0.37l3.1,-1.0l1.03,-0.69l-0.05,-0.69l-2.45,-1.01l1.22,-0.52l3.01,1.98l1.61,0.58l1.01,-0.66l5.08,-1.09l0.64,-1.13l0.01,-1.14l-0.83,-0.39l0.02,-0.79l0.7,-1.38l2.37,-2.55l1.21,-3.3l0.78,-0.55l0.38,0.25l0.1,1.27l0.32,0.31l0.41,-0.18l1.33,-2.52l3.98,0.07l0.24,-0.67l-2.44,-2.61l-3.22,-2.59l-1.55,0.09l-0.65,-0.3l-1.32,-2.0l-0.39,-1.18l2.35,0.25l3.37,-1.37l3.64,0.63l0.44,-0.46l-0.69,-2.28l4.53,-1.44l4.37,-1.99l2.18,-0.55l0.33,-1.4l-0.68,-1.65l-1.0,-1.4l-2.33,-0.06l-1.52,1.69l-3.33,0.51l-0.55,-0.04l1.8,-0.89l0.38,-0.89l-0.41,-0.19l-2.5,0.39l-1.4,1.14l-3.14,1.23l-0.09,-0.82l0.81,-0.93l0.26,-0.87l-1.06,-0.72l0.72,-1.44l0.38,-2.47l0.91,-0.72l1.93,-0.23l1.85,-0.8l1.15,-0.93l1.32,-2.0l0.85,-0.25l6.6,0.37l4.71,-0.19l0.87,-0.89l0.05,-1.5l1.42,-3.4l0.99,-1.16l0.05,-0.83l-1.49,-0.71l0.56,-0.88l-0.75,-3.25l-1.15,-0.75l-1.32,-0.29l0.66,-2.07l0.97,-0.98l1.32,0.21l1.24,-0.24l0.55,-0.79l-0.46,-0.76l-3.06,-1.05l-0.67,-1.1l2.56,-0.9l2.44,-2.39l0.59,-0.98l0.29,-2.27l-0.93,-1.24l0.0,-0.89l0.48,-1.04l-0.19,-0.6l-1.1,-0.63l-2.1,0.51l-1.12,-0.07l-4.23,-2.7l-2.19,-0.27l-1.68,-1.96l-2.3,0.57l-1.31,-0.1l-3.56,-2.2l-2.76,-0.26l-2.75,-1.58l-0.96,0.15l-0.52,0.67l-0.27,1.26l-1.02,0.25l-4.44,-3.21l-1.26,-1.76l-0.43,-1.51l-2.37,-2.21l-1.25,-0.09l-2.83,1.16l-5.07,1.07l-1.8,1.39l-1.55,-1.19l-1.78,-0.29l-0.86,0.24l-2.57,-2.23l-3.28,-0.48l-2.83,1.54l-0.78,-0.28l-0.55,-1.12l-0.87,-0.5l-0.93,-1.27l-0.22,-1.05l0.59,-1.13l0.05,-1.01l-1.71,-4.09l0.2,-1.4l-0.59,-0.56l-1.82,-0.2l-1.28,-2.54l-1.35,-0.09l-3.1,0.57l-3.49,-1.19l-3.32,-0.13l0.6,-0.53l0.05,-0.87l-0.67,-0.61l-0.34,-3.22l-1.12,-1.88l3.23,-0.64l0.56,-0.61l0.0,-0.97l-3.92,-3.8l-1.29,-3.12l-1.31,-1.82l-1.47,-1.24l-1.22,-0.59l-3.98,0.16l-2.32,-0.36l-1.88,0.24l-3.42,1.53l-1.14,0.06l-3.97,-1.0l-1.1,0.01l-1.27,0.77l-1.12,2.88l-1.96,1.03l-1.84,0.07l-2.57,-0.95l-1.02,-2.05l-1.46,-1.55l0.1,-3.66l0.34,-0.73l-1.14,-1.49l-0.07,-0.9l0.58,-0.74l-0.03,-0.72l-3.97,-4.57l1.74,-2.87l3.23,-0.09l0.87,0.25l1.61,1.49l4.18,0.24l3.9,-2.22l0.67,-1.14l2.96,-1.12l0.33,-0.34l-0.01,-1.77l-0.42,-0.68l-2.85,-1.78l-0.46,-0.98l0.32,-0.71l-0.24,-1.09l-3.52,-1.68l-5.55,-0.36l0.81,-2.04l0.17,-1.22l-0.27,-0.89l-0.58,-0.55l-5.18,-2.56l-1.33,-1.67l-0.71,-1.81l-0.87,-1.24l-1.36,-0.72l0.98,-1.81l-0.1,-0.74l-4.73,-2.94l0.42,-2.01l2.06,-2.77l-0.33,-1.87l-1.9,-2.6l0.05,-0.61l1.13,-1.47l0.09,-3.31l-0.53,-0.83l-2.18,-0.5l-1.26,-0.82l-2.4,-2.34l-3.18,-1.14l-4.12,0.02l-2.58,1.41l-1.63,0.4l-1.8,1.14l-1.34,-1.49l0.57,-1.78l-0.08,-0.77l-0.47,-0.67l-4.06,-1.61l-2.03,0.38l-1.99,1.08l-0.45,-0.15l-1.32,-1.91l-1.12,-0.71l-2.42,0.01l-1.23,0.67l-1.72,-1.43l0.66,-2.19l-1.34,-5.49l-1.34,-1.21l-0.23,-0.86l-1.31,-1.81l-0.13,-1.47l-0.53,-0.78l-0.98,-0.41l-1.57,0.36l0.75,-1.97l0.11,-1.54l0.56,-1.41l0.95,-1.24l0.0,-2.13l-0.62,-0.75l-3.35,-2.1l-0.53,-1.63l-1.92,-0.42l0.57,-2.1l1.17,-1.07l0.68,-1.42l2.7,-0.77l0.62,-0.66l-0.15,-0.75l-1.29,-1.03l-0.25,-1.0ZM899.6,149.08l-0.91,-2.5l-1.31,-2.3l-1.94,-1.53l-3.3,-4.18l-1.3,-2.04l-0.62,-2.02l0.83,-3.04l6.79,-3.36l1.76,-1.43l0.0,22.4ZM836.18,140.74l0.44,1.89l-0.38,0.82l0.1,0.76l-0.3,0.19l-1.12,-1.49l-0.96,-0.18l-0.66,-0.6l-0.26,-0.83l0.79,0.0l1.49,-0.81l0.85,0.25ZM617.41,357.73l1.54,-1.2l1.41,-1.73l1.16,-2.18l0.41,-3.11l1.52,-0.56l4.03,0.06l1.68,-0.82l1.35,-1.25l-0.8,0.85l0.13,0.64l1.12,0.5l1.36,0.19l1.62,0.72l1.47,0.13l2.74,-0.62l0.3,-0.33l0.62,-5.87l1.57,-0.18l2.24,1.46l4.31,1.78l2.75,0.72l6.56,0.09l0.88,1.63l2.49,1.72l-1.93,5.57l-0.04,1.47l0.9,2.13l-41.39,-1.79Z",name:"Russia"},NL:{path:"M408.11,413.92l-2.98,-1.02l-2.63,0.56l-1.62,-0.68l-1.47,-0.1l-1.43,-1.16l0.86,-0.49l2.54,-0.12l1.81,0.37l3.4,2.1l2.12,-0.24l0.2,-0.64l-0.47,-0.58l-2.47,-1.11l1.44,-0.16l0.27,-0.65l-0.68,-1.17l-2.31,-2.26l1.63,-2.96l1.7,-1.22l3.79,-4.66l1.1,-2.5l1.57,-6.68l1.04,-2.07l1.58,0.51l2.03,-0.83l0.61,2.01l1.68,1.87l-0.05,0.7l-2.4,1.06l0.04,3.13l-0.72,1.49l0.08,0.43l0.54,0.48l6.52,1.61l4.07,-3.2l1.17,-1.38l-0.04,-1.42l-0.47,-1.01l-2.62,-0.56l-0.29,-0.33l0.01,-1.58l0.57,-0.88l-0.05,-0.97l-0.42,-0.31l-1.44,0.1l-1.38,-0.36l-0.26,-2.87l-0.67,-0.7l1.23,-2.18l1.06,-0.92l4.54,-1.93l2.49,-0.57l10.02,-0.62l2.06,2.07l2.84,0.79l-0.08,4.83l-1.86,4.59l-0.24,1.67l-3.48,0.08l-0.9,0.62l0.09,0.93l-0.34,0.86l0.88,1.38l1.41,0.52l1.7,-0.01l0.65,0.86l-0.19,1.84l-0.5,0.96l-3.49,2.4l-0.14,0.98l1.13,1.12l-0.6,0.77l-2.87,0.97l-1.44,-0.0l-0.68,0.49l-2.7,-0.95l-2.28,0.91l-0.97,0.89l0.08,0.97l1.84,2.22l0.1,0.74l1.31,1.87l0.06,0.56l-0.41,1.55l-1.26,2.5l0.11,0.92l0.53,0.33l-2.24,1.64l-0.78,-0.07l-0.53,0.48l0.1,0.74l0.47,0.55l1.53,0.64l0.41,0.58l-0.61,2.28l-2.95,-0.15l-0.55,-0.2l-0.58,-0.97l1.24,-1.33l0.21,-1.07l0.9,-1.71l0.16,-0.82l-0.5,-0.82l-2.67,-0.92l-1.82,-1.56l-2.38,0.42l-1.15,-0.3l-1.39,-1.09l-0.5,-1.77l-0.54,-0.52l-0.49,0.01l-1.11,1.02l-1.05,0.07l-0.27,-0.74l-0.84,-0.78l-0.46,0.02l-1.54,1.17l-1.76,-0.94l-1.73,0.91l0.02,1.2l-1.77,-0.51ZM421.28,396.41l4.65,-3.0l1.5,-0.51l0.91,0.09l0.98,0.62l-0.3,0.84l-3.92,2.87l-0.85,0.06l-2.96,-0.97ZM416.5,383.47l-1.03,1.0l-0.51,-0.26l0.29,-0.71l1.25,-1.07l-0.0,1.03ZM407.31,414.89l-2.06,1.54l-1.75,0.66l-0.79,-0.07l-2.0,-1.12l-1.46,-0.21l-1.9,0.74l-0.5,-0.59l-0.29,-1.12l2.71,-0.27l3.99,0.8l1.77,-0.71l1.2,0.56l1.08,-0.22ZM401.26,408.39l0.8,-0.2l1.99,0.12l1.27,0.97l-1.02,0.24l-1.64,-1.11l-1.39,-0.02Z",name:"Netherlands"},PT:{path:"M226.07,631.38l0.09,-1.3l-0.52,-1.53l1.89,-0.52l1.05,-0.88l0.66,-1.19l-0.29,-1.44l0.72,-1.29l1.9,-1.22l0.16,-0.48l-0.45,-0.25l-1.03,0.19l-1.33,0.85l-2.54,4.33l-2.69,0.63l-1.22,-0.39l0.0,-1.58l0.59,-1.75l0.23,-2.35l0.81,-2.11l-0.23,-1.47l1.55,-1.26l1.45,-1.94l4.21,-9.14l-0.16,-0.87l-0.43,-0.47l0.16,-1.05l1.34,-5.47l1.22,-2.52l0.34,-5.43l-1.08,-3.3l-0.9,-4.39l-0.06,-1.28l0.63,-0.63l-0.25,-0.68l-1.03,-0.09l-0.39,-0.67l0.1,-0.85l2.5,-2.7l1.86,-0.94l3.64,-1.08l0.35,0.03l0.97,1.44l-1.22,1.94l0.7,1.49l0.68,0.39l0.93,-0.07l2.18,-1.03l3.06,-0.14l2.4,0.83l1.69,0.04l2.74,-1.05l0.62,-1.31l1.58,0.47l2.24,0.09l0.56,-0.29l1.51,0.44l1.18,-0.08l0.55,0.78l-0.02,2.66l0.26,0.7l3.35,0.69l0.74,0.55l0.28,0.69l-2.34,2.39l-2.17,1.14l-1.76,1.49l-1.17,1.72l-1.44,0.74l-0.73,1.02l1.23,3.94l0.23,1.9l-0.45,3.46l0.52,1.45l-2.57,1.96l-0.37,0.82l0.17,0.84l1.64,1.7l-1.02,3.33l-0.78,1.27l-0.86,0.37l-4.59,0.03l-1.11,0.3l-0.24,0.59l1.23,2.01l1.47,1.18l0.41,1.96l1.81,3.22l1.87,0.6l0.43,0.57l-0.58,2.04l-3.14,2.99l-0.94,4.28l3.28,4.65l1.82,-0.01l-0.66,1.6l-2.21,0.66l-3.59,4.5l-0.83,2.42l1.24,5.98l-0.9,0.16l-4.53,2.49l-1.25,0.0l-2.72,-1.12l-6.2,-0.68l-2.07,0.72l-1.41,-0.02l-1.47,0.83l2.33,-5.99l-0.06,-2.49l0.35,-2.3l-0.42,-2.18l-0.73,-1.34l1.01,-3.52l-0.12,-1.83l-0.72,-1.81l2.21,0.27l0.41,-0.22l-0.07,-0.46l-0.89,-0.92l-1.23,-0.68l-1.65,0.12l-3.48,1.12ZM117.56,718.32l1.56,0.67l1.81,-0.33l2.3,1.05l-1.15,1.04l-2.21,-0.2l-2.57,-1.4l0.26,-0.82ZM10.64,654.82l-1.1,0.02l-0.19,-0.31l0.92,-0.12l0.37,0.41ZM2.49,641.55l1.09,0.17l5.02,-0.12l-0.06,0.57l-0.57,0.32l-2.41,0.29l-3.86,-0.72l-1.16,-0.85l-0.14,-0.53l0.41,-0.13l1.67,1.01Z",name:"Portugal"},NO:{path:"M728.73,12.12l0.23,0.63l1.37,0.34l2.91,-0.91l0.43,0.5l-0.87,2.15l-0.5,5.32l0.03,1.92l0.75,1.21l0.37,-0.28l1.54,-4.63l1.79,-1.59l0.63,-2.84l1.64,-3.37l1.81,-1.92l0.96,-0.48l3.49,0.08l1.42,0.68l1.34,1.62l1.13,0.76l3.32,0.75l1.46,1.46l1.05,0.06l2.14,-1.24l1.18,-0.17l2.0,1.7l-0.39,1.45l0.53,0.75l2.78,-0.09l2.24,0.55l4.31,2.89l0.39,1.18l-0.18,1.34l-6.19,1.79l-2.83,1.78l-4.44,0.67l-15.48,-1.19l-0.42,0.49l0.6,1.58l10.68,2.78l0.42,0.55l-0.32,1.59l0.21,2.36l1.07,1.15l1.47,0.42l2.61,-0.21l1.62,0.37l1.06,-0.95l0.31,-2.12l0.45,-0.29l1.14,0.5l0.61,2.27l0.6,0.49l0.57,-0.18l0.65,-1.49l4.65,0.21l0.66,2.86l-0.33,1.93l-1.15,0.59l-2.23,-0.09l-3.11,-1.22l-2.04,-1.17l-1.03,-0.06l-0.46,0.65l0.46,1.08l-0.11,0.77l-1.24,2.44l-1.18,0.9l-2.11,0.74l-6.01,1.49l-0.74,0.88l-1.92,4.09l-1.08,0.98l-1.79,0.57l-1.49,-1.94l0.15,-1.12l2.32,-2.54l2.91,-2.55l1.33,-1.95l0.02,-0.42l-2.6,-4.77l-10.07,-3.82l-4.86,-3.54l-2.12,-2.17l-2.31,-0.18l-2.22,0.59l-3.29,1.99l-2.88,1.26l-2.52,-0.53l-2.63,-0.12l-3.06,0.46l-3.09,3.3l-3.22,2.21l-0.89,1.04l-0.68,1.54l-1.52,5.34l-1.15,2.08l-0.26,1.33l0.26,3.66l-0.25,1.89l-2.12,2.23l-2.9,0.58l-1.59,1.03l-1.19,1.51l-1.11,2.84l-1.73,0.96l-1.64,-0.27l-1.4,-1.1l-5.01,-1.38l-4.52,-2.05l-2.06,-0.21l-2.25,2.22l-5.05,1.49l-2.23,0.14l-1.05,-0.74l-8.72,-1.08l-1.51,-3.09l-9.21,-9.88l-5.12,-0.19l-1.9,0.71l-1.2,1.0l-0.17,0.91l0.95,2.35l-0.45,0.52l-2.35,-0.67l-2.89,0.05l-0.9,0.78l-6.7,0.37l-0.25,0.69l2.88,2.76l0.13,1.02l-0.37,2.12l-1.03,1.82l-1.19,1.48l-2.37,1.5l0.06,0.71l3.06,1.26l-3.0,2.32l-12.25,-3.18l-3.88,-0.18l-5.25,-1.45l-1.26,0.17l-2.17,0.96l-0.21,1.5l0.39,6.19l-0.64,1.44l-2.61,3.64l-7.75,-3.12l-7.69,4.89l-2.94,6.47l-1.5,1.49l-3.45,1.03l-1.17,2.04l0.05,0.43l3.13,3.96l0.93,2.08l-0.36,2.0l-2.18,1.74l-9.23,9.65l-1.79,1.39l-0.15,0.39l0.78,3.92l-1.25,1.03l-4.43,1.86l-6.68,0.85l-0.35,0.48l1.23,7.36l-1.15,3.32l-0.93,7.54l-4.89,7.78l-6.29,7.98l0.14,0.61l5.66,2.51l0.87,4.15l-0.09,1.74l-1.0,1.6l-1.2,1.56l-10.12,-1.3l-3.0,0.54l-2.79,1.15l-1.83,1.34l-4.9,5.82l-1.7,1.6l0.35,2.44l-2.78,4.15l1.85,4.71l0.95,1.67l-1.39,1.81l0.42,4.16l-0.34,2.72l2.56,6.56l-0.15,2.34l-1.85,9.33l2.03,1.82l4.12,2.33l3.65,3.7l-0.65,2.4l-1.65,3.3l-4.52,0.59l-1.11,0.86l0.31,2.38l3.23,7.09l0.44,1.8l-0.98,2.96l-0.38,3.87l-2.51,2.69l-1.57,1.04l-2.34,0.41l-0.95,0.63l-1.44,3.47l-2.02,2.05l-0.04,1.14l1.51,5.23l-1.14,5.29l-0.86,1.68l-1.08,0.53l-0.66,-0.22l-1.62,-3.96l-7.05,-1.56l-2.46,-3.92l-0.13,-4.22l-0.52,-3.2l-0.31,-0.36l-0.44,0.18l-0.83,1.39l0.39,2.25l-2.28,1.54l0.12,1.28l0.55,0.47l-0.21,2.89l-3.22,5.07l-1.36,-0.24l-1.59,1.15l-1.18,0.14l-0.57,-1.25l-2.24,-1.81l-1.35,0.01l-0.24,0.69l1.66,1.79l-0.34,0.49l-4.57,2.18l-0.1,0.66l0.87,0.76l-0.63,0.74l-1.2,0.24l-0.9,1.31l-3.32,2.06l-5.48,5.29l-2.79,1.48l-1.93,1.51l-1.6,-0.04l-2.35,1.35l-5.42,1.13l-3.62,-0.52l-2.54,0.44l-1.12,-0.74l0.13,-0.99l-0.23,-0.57l-0.48,-0.15l-1.42,0.03l-0.43,0.44l-0.3,1.11l-1.65,-0.49l-0.19,-0.21l0.48,-0.73l1.13,-0.9l0.02,-0.61l-0.66,-0.86l-3.61,-0.1l-4.41,-2.06l-1.12,-1.16l-3.59,-1.77l-1.55,-1.81l-0.87,-1.97l0.49,-4.68l0.5,-0.49l3.02,0.98l3.54,1.8l0.77,-0.24l0.99,-1.33l1.95,-1.08l-0.0,-0.7l-0.92,-0.33l-2.81,1.2l-2.49,-1.9l0.0,-0.39l0.79,-0.82l0.27,-1.01l-0.4,-1.12l0.16,-1.06l4.66,-4.01l1.45,-0.81l0.15,-0.54l-0.62,-0.47l-1.78,0.56l-5.83,3.61l-3.78,1.24l-1.46,1.82l-1.27,0.66l-2.2,0.07l-0.41,-0.93l0.7,-4.41l0.75,-2.16l0.75,-1.38l1.39,-0.37l0.82,-1.01l3.8,1.04l1.57,-1.49l1.65,-0.23l3.06,-1.49l0.15,-0.72l-0.45,-0.3l-5.05,0.73l-0.67,-0.19l-0.29,-0.73l4.44,-4.25l0.62,-1.06l0.39,-2.03l2.7,-2.33l1.96,-0.95l0.44,0.56l-0.61,2.9l0.01,1.23l0.32,0.39l0.45,-0.24l1.8,-4.31l0.74,-0.96l0.8,-0.65l2.32,-0.59l0.69,-1.14l-0.39,-0.22l-2.64,0.24l-6.23,1.67l-2.72,1.52l-3.5,4.09l-0.42,1.66l-0.85,0.74l-1.49,0.42l-1.92,2.07l-0.87,1.66l-3.08,2.3l-1.17,1.31l-0.32,-1.44l0.18,-1.94l0.87,-1.41l0.48,-1.55l-0.55,-1.47l0.23,-0.46l2.09,0.41l1.6,-0.06l2.77,-1.1l0.18,-0.59l-0.72,-0.8l-3.19,-0.01l-1.6,-0.94l-1.3,-1.95l-0.58,-2.58l0.3,-0.56l5.03,-2.8l1.46,-1.36l-0.21,-0.69l-1.12,-0.04l-1.87,1.53l-2.49,0.88l-1.51,-1.18l-0.83,-1.34l-0.5,-2.97l-0.01,-3.47l0.81,-0.47l2.52,0.47l3.01,-0.18l6.47,-1.26l4.11,0.74l1.79,-0.06l2.68,-1.09l2.11,-0.1l1.55,0.76l0.78,0.8l0.21,1.37l0.79,0.85l0.48,0.08l0.53,-0.28l0.19,-0.51l-0.46,-2.11l6.53,-1.69l0.97,-0.77l-0.22,-0.7l-2.49,-0.22l-0.59,-1.22l1.35,-2.63l-0.14,-0.32l-0.63,-0.15l-1.62,1.45l-0.74,1.82l0.08,1.93l-1.16,0.26l-3.03,0.11l-3.76,-0.93l-0.35,-0.26l0.16,-0.79l-0.54,-0.64l-0.52,0.09l-0.77,0.93l-0.68,1.78l-1.2,0.35l-4.09,-0.68l-5.91,0.41l-2.68,0.93l-1.55,-0.11l-2.82,-1.56l-1.03,-1.16l-0.28,-3.28l3.31,-0.44l1.09,-0.62l-0.04,-0.72l-2.18,-1.12l-0.87,-1.51l-1.48,-0.65l-0.81,-1.18l-0.22,-1.9l0.22,-1.2l0.47,-0.29l1.73,0.29l4.65,-0.24l7.55,2.28l6.23,-0.44l3.58,-1.3l0.06,-0.73l-0.93,-0.4l-3.85,0.74l-3.51,-0.03l-8.9,-1.94l-2.82,0.2l-1.23,-0.38l-0.7,-1.19l0.55,-2.45l0.89,-0.41l0.79,0.65l1.21,-0.11l1.76,-1.91l0.61,-1.39l2.32,-1.33l2.5,-0.75l0.72,0.14l1.38,1.17l2.02,-0.0l5.03,-1.15l1.71,-1.38l0.08,-0.46l-0.41,-0.22l-7.2,1.24l-0.09,-0.31l1.55,-1.5l0.43,-1.2l0.86,-0.45l5.24,-0.57l2.87,0.23l4.31,0.51l2.77,1.23l1.27,-0.08l1.2,-0.35l0.66,-0.54l-0.17,-0.69l-1.96,-0.46l0.08,-0.64l3.4,-0.97l3.9,-0.23l0.29,-0.65l-1.05,-0.98l-8.54,1.25l-2.16,-0.82l-1.92,-0.02l-1.28,0.51l-3.32,0.42l0.48,-1.11l2.15,-2.94l0.74,-0.46l5.1,-1.38l2.53,-1.63l3.76,-0.26l3.04,0.43l1.55,2.02l5.55,3.15l0.45,-0.02l-0.16,-1.34l-3.67,-3.44l-1.39,-0.85l-0.91,-1.47l0.3,-1.32l0.99,-0.9l4.06,-0.56l0.95,-0.71l0.22,-1.35l-0.74,-1.02l-2.79,-0.46l-0.24,-0.78l0.35,-0.54l2.3,-1.35l3.43,-0.91l3.72,1.05l-0.85,1.42l0.03,1.1l0.36,0.34l0.97,0.09l2.5,-2.4l2.53,-0.31l2.2,-0.78l1.72,2.01l1.34,0.96l0.53,1.63l0.88,0.37l1.1,-0.94l3.3,-0.73l3.35,0.47l2.32,-0.3l0.39,-0.56l-1.06,-1.99l0.54,-1.1l2.88,-1.45l2.34,-0.5l3.37,-1.82l0.2,-0.52l-0.89,-1.59l-1.46,-0.24l3.35,-1.94l0.12,-0.61l-0.57,-0.59l-1.9,-0.53l-3.2,1.34l-2.23,1.48l0.02,0.68l1.46,1.29l-1.23,1.3l-7.99,4.24l-3.74,1.22l-1.44,-0.16l-2.06,-3.63l-0.37,-0.22l-2.26,0.2l0.56,-1.66l1.17,-1.4l2.19,-1.22l1.06,-1.46l0.91,-2.09l3.05,-2.1l4.41,-5.13l3.56,-1.63l1.42,-1.85l2.14,-0.82l1.74,-1.35l1.46,-0.17l2.61,-1.28l1.59,-1.61l-0.25,-0.68l-0.97,-0.1l-3.2,1.24l0.63,-2.53l1.77,-1.44l8.82,-4.35l2.09,1.98l2.74,-0.3l3.33,-2.63l2.45,-2.81l0.03,-0.49l-0.47,-0.15l-1.3,0.48l-4.18,2.7l-1.12,0.22l-0.44,-0.12l-0.57,-1.09l-0.96,-0.34l-0.9,0.17l-0.6,-0.51l-0.14,-1.58l1.98,-4.43l4.76,-5.24l0.87,-2.16l1.51,-0.99l2.11,0.24l0.9,-0.37l0.18,-0.55l-0.77,-1.41l-2.49,-1.33l7.75,-1.75l3.85,0.06l1.35,-0.96l2.16,-0.63l1.61,-1.13l-0.02,-0.67l-1.14,-0.54l-6.37,1.52l-4.78,0.46l-0.62,-4.09l0.41,-2.05l0.84,0.04l0.41,-0.35l0.25,-2.21l1.17,-1.2l1.9,-0.35l2.23,-1.72l2.18,0.26l2.33,-0.27l0.24,-0.68l-0.58,-0.57l-2.9,-0.8l-0.45,-0.8l1.71,-0.96l1.18,-0.24l2.91,-3.35l1.39,0.1l1.69,-1.01l1.64,0.34l4.23,-1.18l8.65,-0.18l0.38,-0.3l0.26,-1.02l-0.34,-0.5l-8.31,-0.5l-4.78,0.14l4.07,-4.74l2.62,-1.62l1.91,0.39l2.4,1.68l1.53,0.19l0.6,0.42l1.45,2.41l0.56,0.07l0.45,-0.44l-0.23,-2.02l1.45,-1.66l0.01,-0.52l-0.82,-0.63l-2.24,0.61l-1.61,-0.6l-1.3,-1.22l-0.31,-0.94l1.52,-1.58l0.08,-0.57l-0.57,-0.72l-0.5,-0.1l-3.51,1.89l-2.88,0.28l0.42,-1.34l-0.25,-1.37l3.16,-3.18l0.98,-0.33l1.73,0.25l1.89,0.97l3.07,-0.68l0.26,-0.47l-0.56,-1.23l-3.25,-0.35l-0.56,-0.49l0.13,-0.32l2.23,-0.78l2.23,-1.39l2.56,-0.4l2.05,-1.03l0.41,0.39l0.79,4.05l1.9,3.28l0.98,0.31l0.45,-0.5l-0.68,-2.59l1.33,-1.19l0.41,-0.88l-0.28,-0.53l-0.85,-0.21l-0.68,-0.84l-1.07,-2.98l0.28,-0.58l2.33,-1.59l2.94,-0.37l3.25,1.17l1.3,0.04l8.52,-1.9l0.25,-0.5l-0.23,-0.56l-2.0,-0.82l-3.16,0.52l-8.21,-0.17l-0.57,-0.4l-0.1,-0.67l0.77,-1.23l0.88,-0.71l3.04,-1.36l3.48,-0.26l3.52,-2.5l1.5,-2.11l0.74,-2.81l2.0,-2.19l5.55,-1.56l0.2,-0.9l-0.53,-1.14l0.04,-2.02l1.39,-2.44l0.86,-0.79l1.14,0.66l1.52,1.87l2.21,1.03l3.04,0.21l1.02,-0.57l-0.05,-0.7l-2.21,-1.01l-1.53,-1.21l-0.1,-0.98l0.53,-0.47l2.73,-0.08l1.64,-0.97l0.77,-2.5l2.01,-1.97l6.3,-1.3l0.22,0.25l-0.34,3.86l-0.77,2.7l0.02,1.91l0.29,0.38l0.45,-0.16l1.34,-2.01l1.72,-5.22l1.26,-2.39l1.36,-1.31l3.1,-1.38l0.59,1.45l-0.72,4.51l0.06,1.44l-0.77,1.82l-3.14,4.28l0.08,0.89l0.5,0.28l2.12,-1.02l3.78,-3.96l3.22,0.49l0.46,-0.35l-0.06,-0.66l-2.39,-2.32l-0.35,-1.26l0.17,-3.66l0.84,-1.24l4.41,-0.04l0.96,0.67l1.78,-0.05l0.35,-0.24l1.13,-2.54l2.03,-0.2l2.09,1.77l2.52,1.2l2.02,1.73l0.51,0.0l0.58,-0.48l0.13,-0.41l-1.11,-4.11l-1.29,-1.65l-2.78,-0.9l-2.72,-1.79l-0.53,-0.8l2.15,-0.51l3.46,0.62l2.73,-1.45l0.94,0.35l2.03,-0.73l1.6,1.01l1.09,-0.57l0.42,-1.26l3.24,-0.82l2.1,0.78l1.07,0.76l1.38,4.8l1.87,1.95l1.31,0.98l1.7,0.08l0.63,-0.88l-0.06,-0.53l-1.14,-0.99l-0.26,-0.79l0.54,-2.31l0.62,-0.89l3.76,-3.66l3.08,-1.86l2.11,-0.31l3.32,-4.31l0.84,-0.7l0.78,-0.16l0.31,-0.47l-0.22,-1.07l-1.84,-0.88l-0.04,-0.83l2.28,-1.52l2.84,-2.62l1.15,-0.15l0.87,0.7l2.81,1.2l3.03,2.11l1.09,-0.1l1.51,-1.52l1.59,0.24l2.48,1.05l0.09,0.44l-1.4,0.88l-5.34,5.55l-0.92,1.62l-0.88,4.07l-2.09,2.72l-0.04,2.12l1.23,0.95l2.43,-0.75l2.81,-2.41l0.8,-2.66l6.95,-6.9l3.3,-3.87l3.66,-3.14l1.68,-0.53l0.78,1.68l-0.73,2.55l-1.53,1.7l0.07,0.6l0.98,0.67l-0.8,4.29l0.01,1.07l0.5,0.38l5.56,-2.51l2.31,-4.33l0.49,-1.52l1.51,-1.3l3.07,-0.01l0.39,-0.32l-0.08,-1.02l-3.77,-1.98l-0.27,-0.54l4.51,-3.24l1.64,0.23l1.19,0.54l4.36,0.4l3.1,1.53l-0.11,2.24l-0.67,0.96l-0.67,0.6l-4.3,1.96l-0.87,1.1ZM756.8,33.48l-2.19,0.6l-0.05,-0.09l1.06,-2.35l0.65,0.05l1.44,1.11l-0.91,0.68ZM694.5,3.24l3.24,-1.93l3.48,0.91l1.18,-0.0l1.68,1.66l0.73,0.04l-0.05,0.28l-1.54,0.43l-3.26,0.51l-2.15,-0.15l-1.48,-1.46l-1.85,-0.29ZM676.11,14.77l-2.24,0.85l-1.26,-0.71l-0.51,-0.7l-0.08,-1.73l0.28,-0.94l0.87,-0.43l3.59,2.07l-0.64,1.59ZM670.58,15.65l0.31,1.83l-1.11,1.19l-2.87,1.76l-0.12,0.61l-0.64,0.29l-1.35,0.3l-0.41,-0.17l0.09,-1.24l-0.29,-0.67l-0.54,-0.17l-0.94,0.5l-0.82,-0.53l0.24,-1.01l0.99,-0.93l1.66,-0.64l1.41,0.18l3.74,-2.54l0.64,1.25ZM668.13,9.06l-0.57,1.15l-4.23,3.85l-1.79,0.48l-1.29,0.76l-2.24,-0.41l-1.54,1.06l-2.45,0.03l-2.48,-1.12l-1.76,-1.58l2.44,-0.24l1.51,0.21l1.19,-1.09l1.94,0.11l3.8,-0.75l1.7,0.33l3.15,-2.48l1.07,0.02l1.3,-0.61l0.25,0.27ZM632.13,26.52l-1.42,0.6l-1.43,-0.54l-0.88,0.07l-0.57,-0.73l0.06,-0.58l0.93,-1.0l2.01,-0.61l1.59,0.25l-0.3,2.55ZM618.46,23.91l0.85,0.4l1.16,0.04l1.08,1.22l1.16,0.66l-0.83,0.46l-2.68,-0.01l-0.82,-1.9l-1.32,-1.37l-0.11,-0.62l0.52,-0.08l0.99,1.21ZM611.42,27.32l1.31,1.58l1.41,0.0l0.98,-0.71l1.05,0.5l-0.13,0.73l-2.0,1.5l-1.38,2.01l-1.62,0.43l-1.14,-0.16l-1.71,1.26l-2.75,2.91l-0.3,1.36l-6.62,1.0l-1.74,-0.48l-0.67,-0.77l1.82,-0.35l0.35,-0.37l0.05,-0.86l1.11,-0.95l0.41,-1.1l0.5,-0.21l1.67,0.18l1.11,-0.91l0.51,0.57l0.68,-0.15l0.32,-1.04l-0.18,-1.5l1.77,-1.6l0.83,-1.23l0.97,-0.66l0.97,0.11l0.43,-0.29l0.32,-1.16l-0.2,-1.95l0.85,-1.63l0.54,-0.04l0.39,1.32l0.08,2.68ZM588.18,39.31l1.24,1.04l2.37,-0.47l1.73,1.23l1.09,0.15l0.79,2.15l-0.6,0.87l-1.19,0.73l-0.29,1.48l0.32,1.44l-4.59,0.78l-0.96,-0.77l-0.48,-0.01l-2.23,1.59l-2.19,2.45l-0.49,0.13l-0.3,-0.65l-1.59,-0.54l-1.71,-0.05l2.13,-1.1l0.35,-1.26l-0.3,-2.33l0.35,-1.67l0.84,-0.67l3.6,0.4l0.4,-0.21l0.46,-0.84l-0.29,-0.91l-1.77,-0.93l1.26,-0.6l1.26,-0.07l0.78,-1.35ZM564.03,63.2l0.26,0.57l0.6,-0.03l1.78,-2.18l1.94,-0.67l1.19,-1.96l-0.08,-1.16l0.3,-0.74l1.54,-0.58l0.51,-0.13l1.1,0.7l1.51,2.7l-0.32,1.68l-2.27,1.42l-2.05,0.76l-1.97,1.76l-0.98,1.4l-0.62,0.23l-0.99,-0.45l-1.0,-0.0l-1.33,1.3l-3.11,0.95l-0.9,-0.2l-0.04,-0.94l-0.45,-0.38l-0.78,0.1l-1.44,1.55l-1.76,0.57l-1.75,-0.49l-3.97,2.48l-3.63,0.45l-0.87,-0.2l-0.0,-1.04l4.21,-3.17l6.82,-0.95l4.52,-4.21l1.14,-4.61l0.98,-1.56l-0.46,-1.31l-1.13,-0.33l-0.05,-0.99l0.54,-1.38l3.49,-3.01l2.0,-2.51l0.83,-0.49l0.9,0.0l0.78,0.48l-0.15,1.02l-1.58,2.35l-2.55,2.45l0.3,1.51l0.99,1.32l0.28,3.88l-1.79,2.64l-0.46,1.42ZM556.54,54.46l2.5,3.67l-0.58,2.34l-1.51,1.17l-4.24,0.12l-0.93,-0.51l-0.38,-0.83l-0.68,-0.21l-2.02,0.91l-1.06,0.11l-1.33,-0.6l-0.27,-0.72l2.17,-2.25l1.51,0.08l1.57,0.56l0.44,-0.22l0.64,-1.34l0.13,-1.3l1.99,0.41l0.48,-0.39l0.0,-2.2l0.64,-0.04l0.9,1.25ZM538.67,70.65l0.96,0.42l1.95,-0.11l-0.84,0.76l-1.83,0.42l-1.5,1.47l-2.63,0.27l-1.11,0.86l-0.71,-0.54l-0.6,0.13l-0.45,1.35l-1.52,0.4l-0.29,-1.54l1.17,-1.47l1.83,-0.2l1.4,-1.9l1.86,-0.52l2.31,0.17ZM526.33,79.08l-1.04,0.64l1.42,-3.36l1.2,-1.04l0.24,0.17l-0.26,1.89l-1.56,1.71ZM520.21,124.0l-0.58,0.03l0.0,-0.36l1.34,-1.14l2.38,-0.19l-3.14,1.65ZM519.02,120.83l-0.67,0.08l1.06,-1.26l0.6,-1.36l0.56,-0.36l0.86,0.5l0.02,0.92l-0.5,0.9l-1.93,0.59ZM512.64,130.29l-0.68,0.52l-1.32,-0.35l0.37,-0.91l0.78,-0.38l1.19,0.26l-0.35,0.85ZM502.61,147.16l-0.44,0.38l-1.54,-0.44l-3.0,0.37l-0.68,-0.32l0.6,-0.7l2.65,-1.15l1.27,0.05l1.27,1.24l-0.12,0.58ZM465.49,173.05l-1.51,-0.0l4.89,-1.52l0.48,-0.61l0.39,0.44l-0.14,0.94l-4.11,0.75ZM460.35,180.13l-2.56,-0.29l-0.84,-0.71l3.06,-1.01l0.58,0.58l0.05,1.08l-0.3,0.36ZM418.13,241.28l1.08,2.55l0.03,1.89l-0.6,-0.09l-0.57,-1.19l-0.17,-2.75l0.22,-0.42ZM417.53,227.52l-1.35,0.07l0.25,-1.42l0.69,-0.25l0.54,0.73l-0.13,0.88ZM229.04,8.0l-1.2,-0.01l1.39,-1.16l5.98,-2.82l2.44,-2.71l4.12,-0.83l0.21,1.05l-0.27,1.57l-3.83,1.4l-4.49,1.0l-4.36,2.51Z",name:"Norway"},LI:{path:"M479.66,489.8l0.02,-1.42l0.15,-0.43l0.74,1.46l-0.19,0.45l-0.72,-0.06Z",name:"Liechtenstein"},LV:{path:"M693.81,289.47l3.55,1.99l1.99,0.57l1.08,0.9l2.53,0.56l0.49,0.96l3.62,3.6l2.41,1.22l1.17,0.26l5.65,-1.51l2.97,1.36l4.19,0.48l0.5,1.6l3.78,2.51l0.01,1.64l-0.9,1.1l-0.62,1.56l-0.11,1.55l-0.95,2.51l0.51,0.58l2.08,-0.43l0.37,0.17l0.31,0.4l0.24,1.72l1.27,1.73l0.34,1.03l1.18,0.95l1.31,5.24l-0.59,1.84l-1.52,0.28l-1.91,1.15l-3.42,3.12l-0.81,2.06l-7.03,-0.58l-1.55,0.46l-1.71,1.91l-2.96,0.71l-2.36,-0.64l-1.52,-0.83l-2.67,-2.8l-5.8,-4.02l-1.15,-0.52l-6.83,-1.31l-1.59,-2.24l-0.54,-1.35l-1.1,-0.49l-2.14,0.57l-3.02,1.85l-4.67,0.37l-4.2,-1.24l-8.35,-0.73l-1.97,0.8l-1.07,-1.05l-1.26,-0.31l-1.54,0.36l-2.45,0.04l-6.91,-0.6l-5.95,1.81l-7.73,4.37l-0.35,-2.96l0.22,-7.21l0.51,-3.44l2.41,-2.01l1.33,-1.71l0.8,-2.32l0.72,-3.67l3.52,-4.67l2.8,-0.51l7.98,-2.39l1.23,2.38l6.53,5.21l2.21,4.68l4.89,2.3l4.09,-0.69l4.9,-3.24l1.55,-1.77l0.29,-1.57l-0.55,-6.25l-0.82,-2.71l0.2,-1.21l10.32,-3.79l1.64,1.26l0.73,-0.15l0.24,-0.81Z",name:"Latvia"},LT:{path:"M639.02,342.33l-0.39,-1.13l0.47,-2.2l-2.37,-6.79l-0.19,-4.61l7.95,-4.51l5.74,-1.75l6.79,0.61l2.53,-0.04l1.39,-0.36l1.04,0.26l1.27,1.12l1.22,-0.19l0.91,-0.62l8.2,0.71l4.28,1.25l4.86,-0.4l3.12,-1.88l1.75,-0.52l0.54,0.16l0.53,1.3l1.95,2.56l6.96,1.34l0.97,0.45l5.67,3.93l2.72,2.84l1.7,0.92l2.31,0.66l-0.34,1.84l-1.48,3.87l0.12,0.41l0.75,0.57l3.29,0.4l-1.48,1.08l-0.6,1.26l-4.13,-0.12l-0.74,0.49l-0.95,2.16l-0.97,0.67l-1.73,0.29l-1.62,0.68l-1.11,1.7l-0.79,2.17l0.04,2.82l-1.39,1.93l-1.03,2.49l0.51,0.92l1.76,0.29l0.48,0.48l0.08,1.37l-2.03,0.25l-0.64,-0.28l0.32,-0.85l-0.29,-0.93l-0.72,-0.7l-0.47,-0.03l-1.13,0.71l-1.24,0.04l-1.41,0.69l-1.0,1.14l-0.71,0.33l-2.58,-0.13l-0.73,0.71l-0.6,2.36l-1.96,-0.05l-3.92,1.55l-1.77,-1.04l-4.31,0.27l-1.89,0.43l-3.01,-0.41l0.02,-2.29l-0.39,-1.31l-1.24,-1.24l-2.8,-1.58l-1.61,-0.43l-0.45,-0.8l-1.72,-0.82l-1.06,-0.13l-0.74,0.5l-0.85,-1.99l0.06,-1.19l1.96,-5.08l-0.06,-0.83l-1.32,-1.32l-1.45,-0.78l-1.11,-1.78l-6.66,-0.08l-2.63,-0.68l-4.3,-1.77l-2.12,-1.44l-2.03,0.1Z",name:"Lithuania"},LU:{path:"M433.15,437.03l-0.02,1.54l0.46,1.19l0.9,1.05l1.71,1.44l2.06,0.7l-0.04,1.05l-1.43,1.94l-0.47,2.14l-1.81,-0.59l-2.33,0.93l-2.45,-1.16l1.0,-2.17l-2.04,-2.82l0.23,-1.64l1.61,-2.82l1.29,-1.3l1.16,0.19l0.17,0.33Z",name:"Luxembourg"},FO:{path:"M263.24,203.53l-0.39,0.92l-0.69,-0.21l-0.02,-1.73l1.1,1.03ZM260.24,213.24l-2.12,-1.39l-0.34,-0.59l2.22,0.79l0.37,0.54l-0.11,0.65ZM259.07,209.25l-3.26,-2.64l-1.87,-3.49l2.24,-0.5l4.06,1.71l-0.25,2.13l-1.84,-0.94l-0.67,0.61l-0.01,0.73l1.6,2.38ZM257.22,217.52l1.57,0.48l0.55,2.18l-1.8,-1.85l-0.31,-0.8ZM252.95,206.27l1.28,0.96l-1.0,0.36l-0.92,-0.12l-1.48,-0.53l-0.27,-0.64l1.89,-0.23l0.51,0.19Z",name:"Faeroe Is."},PL:{path:"M543.65,368.02l2.24,0.2l4.48,-1.73l7.75,-2.26l8.26,-2.12l3.9,-0.68l5.16,-4.95l4.31,-0.78l5.16,-2.51l7.82,-1.63l3.25,-0.36l3.12,-0.04l2.21,1.0l-0.57,-0.04l-0.39,0.57l2.05,4.35l1.16,1.6l2.4,1.27l2.0,0.42l5.97,-0.69l2.69,-1.31l8.11,0.66l26.59,1.14l7.65,0.18l1.4,-0.84l1.75,0.49l1.01,1.2l3.12,1.15l2.17,1.68l0.33,1.05l-0.04,2.27l1.64,6.67l2.6,6.11l1.31,4.41l0.39,3.77l-0.18,1.9l-0.61,0.58l-4.89,2.03l-1.01,0.69l-2.89,3.33l-0.47,1.1l0.51,0.99l3.51,1.58l1.85,1.18l0.6,0.91l-0.02,1.06l-0.57,1.63l0.2,1.32l-1.03,1.7l-0.08,2.01l1.61,3.05l0.13,2.59l2.67,3.26l1.68,3.35l1.47,1.21l-1.11,0.52l-0.48,0.6l1.52,3.27l-0.05,1.28l-1.46,1.98l-3.57,0.67l-4.09,3.59l-5.08,4.9l-5.28,6.4l1.06,4.51l-0.36,2.22l1.95,1.75l-0.24,0.41l-2.87,-0.93l-1.5,-0.09l-5.93,-2.17l-0.67,-1.45l-1.17,-0.92l-3.61,-1.28l-3.95,-0.3l-3.67,0.18l-1.34,1.47l-1.49,0.35l-1.84,-0.96l-1.53,-0.38l-3.52,0.1l-3.01,1.33l-0.84,0.92l-0.53,1.22l-1.56,-0.57l-1.82,0.42l0.34,-0.9l-0.2,-1.86l-0.8,-0.59l-1.18,-0.23l-2.68,-3.4l-0.49,0.01l-2.67,1.6l-1.25,1.8l-1.91,0.05l-0.36,-1.5l-1.45,-0.45l-0.45,-1.77l-2.8,-2.47l-0.57,-2.25l-0.76,-0.46l-2.28,-0.49l-0.66,0.22l-3.69,-2.09l-0.89,0.68l-1.68,0.28l-1.96,-2.02l-0.78,-0.32l-0.18,-0.17l1.22,-0.48l0.56,-0.84l-0.17,-1.46l-0.42,-0.42l-2.29,0.71l-1.7,0.16l-3.57,-2.18l-3.74,-0.88l-0.39,0.17l-0.17,0.62l1.62,2.71l-1.84,0.82l-1.61,1.27l-0.79,0.19l-3.93,-4.52l-1.56,-0.77l0.71,-0.74l1.08,-0.38l0.91,-1.37l-0.16,-0.72l-1.84,-1.31l-3.84,0.66l-0.82,-0.97l-2.85,-1.21l-5.03,-1.25l-0.92,-1.11l-0.5,-1.57l-3.64,-1.01l-0.61,0.61l0.01,1.78l-1.35,0.36l1.83,-3.66l0.72,-3.12l-1.56,-3.9l-2.48,-1.15l0.28,-1.67l-1.8,-3.51l0.94,-1.3l1.05,-3.2l-0.68,-0.86l0.02,-1.7l-0.35,-0.77l-0.98,-0.65l-0.68,-1.21l0.8,-3.27l-1.53,-2.24l-3.5,-2.48l-1.54,-1.59l0.1,-0.7l0.63,-0.77l1.41,-0.89l1.02,-1.45l0.65,-1.93l0.03,-1.7l-1.56,-5.02l-0.4,-2.5l3.71,1.43l0.56,-0.46l-0.4,-1.21l0.07,-2.13l-0.31,-0.36l-4.44,-0.86l-0.11,-0.47ZM603.71,353.39l0.66,0.35l-0.21,-0.08l-0.46,-0.27Z",name:"Poland"},XK:{path:"M623.28,565.63l0.23,-1.37l-0.65,-1.57l1.63,0.09l0.64,-0.79l3.48,-1.07l0.27,-0.76l-0.2,-0.76l1.93,-1.27l0.5,-0.84l0.09,-0.77l-0.53,-1.12l1.95,-0.93l0.57,1.38l2.88,1.35l2.09,2.07l0.37,0.86l2.01,1.19l-0.14,1.07l0.28,0.43l4.62,1.2l-1.88,4.12l-1.1,0.72l-0.15,0.66l0.36,0.88l-1.97,0.42l-0.92,0.69l-0.55,1.2l-1.4,-1.12l-1.41,-0.04l-3.96,1.67l-0.59,1.07l-0.11,1.91l-0.39,0.51l-1.14,-0.15l0.02,-2.13l-1.26,-3.53l-1.98,-1.52l-1.41,-0.49l-2.18,-3.23Z",name:"Kosovo"},CH:{path:"M474.98,480.14l0.93,1.21l2.74,1.45l1.43,0.09l0.68,0.53l-1.86,4.76l-0.08,1.49l0.52,0.93l1.74,0.08l2.81,0.78l0.54,1.22l3.54,1.51l1.02,-0.27l2.12,-1.93l0.51,0.2l0.41,1.32l-0.75,3.44l0.56,0.97l-0.02,0.65l-1.65,-0.23l-1.29,-0.99l-1.55,0.38l-0.6,1.17l-0.22,1.86l0.55,0.63l0.74,2.52l-0.69,0.02l-1.59,-2.16l-0.91,-0.09l-3.3,1.21l-1.21,-0.13l-0.52,-0.58l-0.68,-2.14l-0.42,-0.32l-1.84,-0.17l-0.8,0.69l-0.12,3.09l-3.34,4.57l-0.07,0.81l0.58,1.67l-0.72,0.36l-0.75,-1.36l-1.21,-1.09l0.49,-0.82l-0.08,-0.63l-2.59,-0.79l-2.33,-2.15l-0.24,-3.0l-0.6,-0.57l-0.93,0.09l-1.91,1.79l-1.9,1.26l-0.23,0.68l0.55,1.27l-1.71,2.33l-2.51,1.44l-3.3,-0.92l-3.01,1.12l-2.56,0.51l-0.83,-0.33l-1.26,-1.8l-2.35,-2.36l0.54,-1.67l-0.64,-1.73l0.1,-0.55l-0.58,-0.62l-2.44,-0.37l-2.11,0.11l-1.59,0.66l-1.5,1.42l0.49,1.3l-0.73,0.74l-1.4,0.72l-1.06,0.03l-0.01,-0.52l1.69,-1.25l0.38,-1.74l-0.82,-1.03l1.23,-2.71l3.31,-2.41l0.66,-3.3l2.81,-1.32l3.99,-4.25l0.72,-1.16l-0.34,-0.8l-0.94,-0.37l0.69,-0.76l1.01,-0.54l0.9,-0.01l0.97,0.98l2.09,-0.03l1.04,-0.38l1.17,-1.66l1.37,-0.65l1.08,0.36l3.11,0.1l2.31,-0.21l1.45,-0.53l3.48,0.18l1.83,-0.89l0.01,-0.53l-0.38,-0.39l-1.8,-0.11l0.3,-0.51l1.54,-0.64l2.09,1.29l1.19,-0.13l0.95,0.88l3.86,-0.25Z",name:"Switzerland"},AD:{path:"M373.44,566.17l-1.46,0.73l-1.49,0.29l-0.26,-1.45l0.13,-0.56l0.71,-0.55l2.52,0.57l0.23,0.31l-0.38,0.67Z",name:"Andorra"},EE:{path:"M681.02,292.17l1.82,-4.13l0.34,-3.01l0.83,-0.92l-0.26,-1.25l-2.11,-0.9l-0.93,0.07l-1.54,1.86l-1.37,0.39l-1.34,-0.75l-3.16,-1.02l-0.72,-1.23l-0.33,-1.62l-1.67,-1.33l-0.63,-1.43l0.21,-0.83l1.41,-0.67l0.61,-0.79l-0.35,-0.63l-2.02,0.06l-0.86,-2.23l1.02,-1.49l-0.57,-0.94l0.62,-1.45l-0.25,-1.46l3.54,-1.43l4.03,-0.33l0.36,-0.5l-0.29,-1.14l1.37,-0.12l2.65,-1.86l2.78,0.31l3.93,-1.31l7.61,0.02l1.28,-0.85l-0.01,-1.46l3.45,0.02l9.0,1.62l2.2,0.01l2.99,1.6l1.75,0.46l4.98,0.02l7.53,0.73l1.76,-1.2l1.2,1.24l0.06,0.35l-0.81,0.25l-0.7,0.83l-0.89,0.08l-0.75,0.46l-2.01,4.63l-1.0,1.16l-1.86,-0.45l-3.15,0.26l-2.71,0.88l-1.96,1.68l-0.01,1.85l2.53,3.07l1.06,3.8l1.27,1.16l1.32,1.87l0.64,1.7l2.36,4.15l0.34,1.32l1.41,1.24l-3.15,1.13l-0.66,1.42l-1.29,1.24l-0.65,2.49l-1.76,-0.23l-3.1,-1.39l-1.03,0.03l-4.85,1.48l-0.81,-0.22l-2.13,-1.06l-3.53,-3.51l-0.79,-1.2l-2.57,-0.57l-0.91,-0.82l-2.12,-0.63l-3.1,-1.88l-0.9,-0.23l-0.43,0.19l-0.22,0.83l-1.92,-1.29l-2.69,1.15l-6.13,1.9l-1.25,0.77ZM666.97,278.74l-0.76,0.14l-2.16,-1.14l0.85,-0.76l1.89,0.49l0.18,1.27ZM647.68,284.33l1.21,-1.0l0.33,-0.88l-1.4,-2.14l1.14,-0.04l1.0,0.59l1.87,-0.79l0.73,0.23l0.47,-0.18l0.75,-1.3l2.77,-0.86l1.92,0.59l1.76,-0.47l1.78,0.29l4.32,2.36l-2.29,0.37l-1.11,1.14l-0.83,0.23l-3.35,2.53l-2.91,-0.1l-1.98,0.46l-1.39,1.11l-0.69,2.3l-0.93,1.54l-0.87,0.51l-0.69,0.06l-0.04,-0.64l2.71,-3.11l-0.23,-0.59l-1.05,-0.32l-2.99,-1.89ZM661.53,273.2l-1.11,0.89l-0.64,-0.61l-0.66,0.02l-1.35,2.09l-1.33,0.31l-0.56,-0.26l0.03,-0.74l-1.12,-2.39l-1.41,-0.64l-2.39,-0.33l4.37,-0.49l1.83,-2.15l0.62,-0.09l0.4,0.14l0.6,1.28l2.34,0.45l0.84,1.22l0.26,1.21l-0.72,0.09Z",name:"Estonia"},IS:{path:"M31.07,119.93l0.78,-1.15l1.61,-0.28l4.07,2.06l0.46,0.86l-0.12,0.97l0.59,0.58l1.15,-0.26l1.6,0.23l1.28,-1.18l0.53,0.18l0.52,0.85l-0.08,2.47l0.67,0.18l0.77,-0.74l1.34,-0.06l0.57,-0.82l-0.3,-3.42l-5.08,-2.02l-1.59,-1.09l2.14,-0.53l3.31,0.02l0.54,-0.25l0.04,-0.67l-0.81,-0.56l-1.45,-0.29l-0.78,-0.84l-1.8,0.29l-3.49,-0.24l2.65,-1.57l2.25,0.17l2.17,-0.28l1.66,0.32l3.37,2.7l2.76,1.16l4.63,3.74l2.86,1.41l-1.29,0.67l-0.13,0.64l1.85,0.74l0.89,0.81l-0.88,3.03l-0.82,0.75l-2.59,-0.54l-0.41,0.17l0.0,0.45l0.8,1.08l1.88,0.98l0.21,1.15l1.01,-0.03l-0.8,1.9l0.1,0.7l1.67,0.26l0.95,0.72l1.35,3.36l0.72,-0.03l0.75,-2.67l0.28,-0.71l0.75,-0.57l0.78,-2.62l1.71,-1.48l1.4,-0.51l1.72,1.83l1.05,0.29l0.7,-0.3l1.38,-3.46l0.17,-2.52l-0.4,-2.63l0.22,-1.76l0.73,-0.96l0.91,-0.28l1.25,0.39l0.94,0.63l2.01,2.62l3.17,2.99l0.89,0.55l1.58,0.24l0.92,-0.75l-0.16,-4.45l0.82,-1.73l2.45,-0.49l2.78,-1.42l1.76,-0.48l1.69,0.98l3.36,3.79l2.41,1.8l1.51,3.25l0.57,0.25l0.7,-0.5l0.28,-0.64l0.06,-1.56l-2.91,-5.85l0.12,-0.95l4.9,0.32l1.06,0.59l2.5,2.56l1.27,0.86l2.2,-1.44l3.52,-3.91l0.88,0.12l1.88,1.21l1.36,0.43l1.36,-0.19l3.5,-1.42l1.05,-2.16l-1.46,-3.81l0.41,-0.5l3.14,-0.9l2.77,-0.07l4.05,3.55l0.28,1.79l2.4,1.38l1.69,0.07l2.54,-0.77l3.73,-2.29l1.42,-0.45l1.92,0.1l-1.26,0.29l-1.68,1.06l-2.97,3.92l0.2,0.85l1.53,0.97l1.58,0.53l1.58,-0.44l0.86,0.67l0.33,1.12l-0.24,1.28l-1.95,2.46l0.08,0.82l1.38,0.42l4.66,-0.73l0.73,2.3l-1.88,1.76l-0.05,0.52l0.51,0.13l2.27,-1.14l1.71,-0.31l3.01,0.56l1.14,0.59l0.7,1.09l0.47,0.16l1.26,-0.35l0.48,0.46l0.02,0.45l-0.66,1.81l-1.5,0.63l-0.34,0.8l1.16,1.48l1.0,0.19l-0.24,0.7l-1.16,0.7l0.08,0.68l2.27,1.05l0.19,0.64l-0.48,1.12l-0.53,0.32l-1.6,0.06l-1.19,0.49l-0.2,0.53l0.29,1.51l-0.28,1.02l-1.26,1.62l-1.18,0.86l-1.1,0.53l-2.03,-0.19l-1.14,-0.44l-0.54,0.41l0.11,1.26l-1.04,0.78l-0.14,0.44l0.6,1.18l-0.67,1.57l-0.9,0.98l-3.26,1.43l-1.83,1.28l-1.16,0.47l-3.2,-0.01l-3.29,0.86l-4.61,1.78l-3.14,1.45l-5.52,4.21l-2.25,1.06l-3.96,0.53l-11.96,2.76l-1.63,1.96l-0.06,0.36l0.49,0.61l-0.73,0.94l-1.63,0.77l-2.27,-0.71l-0.55,0.49l0.36,0.92l-5.26,1.22l-8.0,-0.75l-7.17,-2.03l-5.63,-0.41l-3.77,-2.65l0.22,-0.77l1.52,-0.44l-0.0,-0.49l-0.69,-0.87l-0.47,-0.12l-2.39,1.47l-0.55,-0.03l-0.77,-0.45l-0.38,-0.76l-1.96,-0.22l-3.31,-1.72l0.52,-0.39l0.0,-0.65l-0.33,-0.19l-2.03,0.09l-2.76,1.66l-16.08,0.58l-1.0,-3.65l0.36,-0.95l1.51,1.48l0.97,0.46l6.2,-1.75l2.75,-2.48l1.93,-3.05l1.4,-0.87l1.88,-0.27l0.34,-0.36l-0.28,-0.41l-1.27,-0.41l-1.34,-0.02l-4.72,1.83l1.48,-0.95l0.18,-0.44l-1.34,-0.54l-0.03,-0.6l0.62,-1.17l3.21,-1.73l1.31,-0.36l0.35,-0.36l-0.06,-0.61l-1.56,-0.48l-3.34,1.84l-2.33,0.61l-1.77,-0.77l-0.77,-0.91l1.13,-1.61l-0.17,-0.76l-3.1,-1.61l-3.64,0.07l-8.59,-0.77l-6.31,1.85l-1.28,-0.73l-1.11,-1.62l0.13,-0.38l1.65,-0.52l2.39,0.23l5.12,-0.99l1.5,-0.94l1.31,0.76l2.88,-0.83l1.42,-0.89l2.48,0.42l1.48,-0.31l8.37,-0.29l1.38,-1.45l0.5,-1.5l-0.27,-0.67l-0.47,-0.14l-3.45,1.35l-4.68,-0.73l-1.02,-0.57l2.26,-1.62l5.53,-2.4l0.77,-0.48l0.26,-0.86l-0.23,-0.42l-2.19,-1.02l-4.15,0.23l-1.15,-1.19l-3.44,-0.72l-2.3,0.42l-1.42,-0.69l-2.96,1.01l-6.52,1.47l-3.87,1.32l-4.32,-1.72l-3.0,-0.29l1.48,-1.5l1.08,-0.26l1.12,0.14l2.43,1.18l1.66,0.37l0.45,-0.21l-0.1,-0.48l-1.92,-1.6l-0.12,-1.55l-1.18,-1.48l2.13,0.26l4.18,1.93l1.95,-0.34l2.6,-1.25l0.09,-0.71l-0.41,-0.27l-3.61,-0.1l-1.73,-0.37l-1.39,-1.18l0.81,-0.36l2.86,0.1l0.39,-0.25l-0.11,-0.45l-3.27,-2.81l0.21,-0.7l3.27,0.93l1.13,-0.2l-0.78,-1.08l-1.26,-0.79Z",name:"Iceland"},AL:{path:"M613.48,601.01l0.69,0.32l0.52,-0.18l0.25,-0.48l-0.24,-1.33l-1.36,-2.98l1.67,-4.38l-0.07,-2.75l0.32,-2.07l-0.52,-3.06l0.7,-2.05l1.07,-1.3l0.08,-2.58l-1.64,-1.44l-1.53,-0.24l0.23,-2.82l0.99,0.15l0.61,-0.73l-1.54,-3.11l4.15,-5.4l0.14,1.73l0.81,0.95l1.33,-0.11l2.5,-1.0l2.2,3.21l2.39,1.18l1.42,1.53l0.69,2.49l0.08,1.45l-1.02,3.38l0.14,2.01l-0.9,1.2l0.57,2.04l-0.01,2.05l1.13,2.44l1.16,1.07l0.79,2.19l0.74,0.47l2.32,-0.02l0.26,0.54l-0.07,1.35l0.98,2.21l-0.97,1.82l-2.03,0.9l-1.22,2.51l-0.81,2.73l-0.5,0.4l-2.66,0.53l-1.35,1.13l-0.18,0.98l0.92,1.95l-0.95,0.1l-0.49,1.55l-0.64,0.55l-2.31,-0.88l-0.5,-2.34l-1.56,-2.8l-5.09,-2.79l-1.09,-1.11l-0.61,-1.18Z",name:"Albania"},IT:{path:"M460.72,503.99l1.78,-1.15l1.8,-1.71l0.38,-0.01l0.0,2.36l0.39,0.92l2.52,2.32l2.27,0.58l-0.51,0.85l0.07,0.5l1.37,1.23l0.36,1.05l1.03,0.61l0.95,-0.27l0.54,-0.68l-0.54,-2.47l3.32,-4.52l0.17,-3.17l0.27,-0.16l1.28,0.23l0.67,1.99l0.92,0.97l1.6,0.19l2.15,-0.87l1.7,-0.27l1.26,1.94l0.98,0.35l0.84,-0.3l0.31,-0.66l-0.49,-1.87l-0.93,-1.88l0.56,-1.7l1.03,-0.25l1.08,0.92l1.23,0.3l1.4,-0.33l0.12,-1.32l-0.53,-0.86l0.59,-2.76l2.77,0.16l0.85,0.81l1.18,0.42l2.32,-0.03l0.73,-0.56l1.38,-2.24l1.33,-0.6l3.78,-0.37l3.34,0.19l5.15,-1.58l-0.68,0.99l0.28,1.2l3.4,4.2l1.31,0.54l9.36,1.7l4.38,0.3l2.39,0.51l-0.11,0.38l-3.72,2.46l-0.42,1.14l0.72,1.28l1.07,-0.01l1.62,0.59l-1.85,1.75l-0.19,0.73l0.54,0.98l1.22,0.01l-0.54,1.93l0.36,0.78l-1.48,0.98l-3.63,-0.93l-2.36,2.24l-1.64,0.43l-2.0,1.15l-3.31,1.29l0.8,-1.08l-1.15,-0.24l-1.93,0.95l-1.23,1.0l-0.67,3.49l0.91,0.9l1.39,2.73l1.66,1.19l-0.66,1.62l-0.77,0.57l-0.89,-0.5l-0.92,0.33l-0.41,1.84l0.76,5.04l1.33,3.62l1.28,1.54l2.77,2.32l2.99,1.26l5.23,3.87l2.91,1.25l0.66,0.58l1.71,2.92l1.49,3.41l1.62,5.38l1.23,2.79l2.39,3.05l4.89,4.31l4.41,3.13l4.29,2.0l3.27,0.34l7.54,-0.42l2.4,0.6l0.24,0.98l-0.38,0.67l-3.18,2.21l-0.18,2.39l1.61,1.3l7.31,3.29l7.47,2.74l2.27,1.37l2.76,2.21l6.43,2.94l1.11,1.44l3.92,3.08l1.71,2.29l0.3,1.65l-1.72,4.11l-1.31,-0.39l-1.79,-1.26l-3.15,-5.62l-5.22,-0.55l-1.02,-0.38l-1.68,-0.84l-0.59,-1.34l-0.79,-0.46l-2.02,-0.17l-1.65,0.95l-3.66,5.33l-1.89,4.44l-0.14,1.92l1.31,2.14l3.02,0.95l2.29,1.49l1.42,1.46l0.11,3.72l0.65,2.1l-0.75,0.9l-1.95,-0.28l-2.66,0.79l-2.01,1.48l-0.94,1.69l0.2,3.43l-0.33,1.13l-3.55,2.53l-1.88,2.57l-1.09,2.11l-4.07,0.04l-0.87,-1.22l-0.03,-1.99l0.65,-1.15l1.75,-0.82l1.12,-2.85l-0.3,-2.11l0.54,-0.76l0.52,-0.55l2.91,-0.7l0.32,-0.37l0.18,-2.88l-1.43,-1.55l-1.14,-5.21l-2.28,-4.31l-1.22,-3.85l-0.99,-1.98l-1.82,-1.22l-3.79,-0.25l-4.54,-2.64l-0.17,-0.69l0.76,-1.36l-1.08,-2.88l-1.08,-1.38l-1.28,-0.67l-4.64,0.8l0.89,-1.13l-0.46,-1.01l-1.89,-0.99l-2.76,-0.23l-0.43,0.22l-0.03,-0.73l-2.55,-4.19l-1.92,-1.88l-1.09,-0.32l-1.46,0.34l-4.14,-0.9l-2.16,0.68l-0.35,-0.2l-0.31,-0.6l-2.37,-1.75l-2.99,-1.02l-5.69,-5.49l-1.76,-2.07l-3.66,-2.33l-2.37,-3.39l-1.97,-1.27l-2.74,-0.99l-2.14,0.48l0.88,-0.72l-0.33,-1.49l-3.12,-3.34l-1.85,-1.11l-1.41,-2.23l-2.37,-0.46l0.05,-3.7l-0.99,-2.76l-1.72,-2.37l-1.03,-5.63l-0.93,-1.74l-1.9,-1.2l-4.34,-1.38l-5.95,-3.6l-1.39,-0.12l-3.65,-1.41l-2.23,-0.24l-3.23,1.38l-3.52,3.49l-2.85,3.6l-0.94,0.63l-3.61,1.2l-2.78,0.5l-0.11,-1.05l2.2,-2.66l0.4,-0.9l-0.55,-1.68l-0.96,-0.28l-3.01,0.66l-0.58,-0.14l-4.66,-2.31l-0.81,-0.82l-0.26,-0.71l0.21,-0.75l-0.61,-1.26l1.42,-2.43l1.01,-0.77l-0.46,-2.18l-0.92,-0.77l-1.88,-0.41l-0.68,-0.51l-0.19,-0.83l-1.24,-2.01l0.54,-0.27l2.17,0.07l1.81,-1.29l1.33,-0.43l1.23,-2.96l-0.1,-0.39l-1.86,-1.65l-1.79,-2.85l-1.02,-0.7l-0.03,-1.21l2.63,-1.65l1.53,0.64l2.74,-0.55l2.8,-1.08l3.49,0.9l2.81,-1.61l1.89,-2.55l0.07,-0.89l-0.5,-0.93ZM518.47,542.68l-0.02,0.45l0.8,0.86l1.1,-0.35l0.42,-1.12l-0.15,-0.61l-0.45,-0.3l-1.11,0.28l-0.6,0.79ZM536.34,512.54l1.58,1.41l0.32,0.86l-0.4,0.08l0.05,-0.55l-1.56,-1.8ZM561.64,634.95l-1.42,2.54l-3.32,4.46l-1.83,5.11l0.22,2.17l1.35,1.24l-0.42,0.3l-0.08,0.57l1.5,1.71l0.07,0.48l-0.01,0.44l-2.03,1.93l-0.54,1.75l0.13,1.17l-2.54,-0.51l-1.61,0.18l-3.5,-1.28l-1.85,-2.71l-3.09,-2.07l-3.36,-0.01l-7.24,-3.82l-2.59,-2.04l-1.81,-0.46l-1.69,-1.03l-2.3,0.05l-1.38,-0.37l-1.44,-1.1l-1.12,-2.08l1.41,-3.4l1.55,-0.85l0.7,-0.8l1.23,1.47l1.07,0.59l2.12,-0.82l0.29,-0.86l1.15,-0.77l1.62,-0.02l0.59,0.12l0.56,0.87l1.47,0.38l2.51,1.57l1.64,0.37l3.58,-0.93l3.17,0.37l3.02,-0.45l1.89,-0.64l2.03,-1.27l4.49,0.21l0.95,-0.35l0.59,-0.62l1.54,-0.09l2.07,-1.12l1.04,0.08l-0.37,0.35ZM539.0,595.31l0.02,-0.06l0.31,0.09l-0.19,0.04l-0.15,-0.08ZM512.96,657.33l0.48,0.16l0.18,0.38l-0.64,-0.31l-0.02,-0.24ZM491.6,561.34l-0.16,0.88l-0.71,-0.33l-2.41,0.32l-0.12,-0.3l2.9,-0.24l0.5,-0.33ZM462.39,592.89l0.87,0.72l2.19,0.38l3.34,-1.01l1.8,-0.98l2.33,-2.52l1.52,-0.57l1.25,-1.67l0.83,0.82l0.84,0.09l1.28,0.67l1.77,2.0l-0.54,1.02l0.07,0.46l1.67,1.74l1.62,4.91l-2.19,3.79l0.86,3.95l-1.21,10.52l-0.69,2.78l-0.7,0.28l-2.83,-1.16l-1.72,0.25l-1.03,-0.57l-0.63,0.27l-0.45,3.03l-0.67,1.12l-0.99,0.69l-0.92,0.04l-1.96,-0.27l-0.55,-0.46l-2.33,-3.7l-0.25,-4.19l0.64,-1.31l0.09,-2.38l0.53,0.16l0.66,-0.55l0.1,-1.66l-0.78,-1.22l-1.15,-0.39l0.02,-1.42l0.64,-0.73l0.21,-0.85l0.02,-2.69l-0.87,-1.15l-0.82,-2.45l-2.13,-2.32l-0.11,-1.75l0.39,-1.75ZM464.42,621.63l0.71,0.35l-0.34,0.68l-0.36,-0.48l-0.02,-0.54ZM462.96,589.81l0.1,-0.19l0.15,-0.08l-0.06,0.11l-0.19,0.16Z",name:"Italy"},GG:{path:"M315.47,448.51l0.52,-0.25l-0.15,0.36l-0.37,-0.12Z",name:"Guernsey"},CZ:{path:"M515.02,433.92l1.19,1.02l0.6,1.08l0.65,0.07l2.33,-2.94l1.17,-0.7l2.89,-0.65l2.52,0.38l1.09,-1.49l2.02,-0.32l0.92,-1.17l1.6,-0.76l0.75,0.3l0.81,-0.32l1.06,-1.52l1.96,-0.22l2.67,-0.8l6.38,-2.46l0.37,-0.51l-0.15,-0.48l-1.0,-0.66l-0.25,-0.73l2.98,0.56l0.95,1.48l0.08,1.06l1.76,0.8l0.83,-0.18l0.54,-0.62l2.25,-0.51l0.25,-0.32l0.04,-1.87l2.95,0.83l0.28,1.28l1.19,1.4l5.17,1.32l2.81,1.22l0.78,0.97l3.93,-0.66l0.9,0.52l0.57,0.52l-0.42,0.79l-1.8,1.04l-0.5,1.04l0.46,0.7l1.33,0.49l2.02,2.0l1.45,2.2l0.85,0.53l0.79,0.04l4.42,-2.78l-0.02,-0.68l-1.44,-2.28l3.1,0.77l3.73,2.23l1.99,-0.18l1.8,-0.62l-0.09,1.16l-1.49,0.59l-0.24,0.49l0.61,0.9l0.8,0.34l2.0,2.05l0.71,0.26l1.73,-0.47l0.64,-0.55l0.67,0.66l2.73,1.37l0.83,-0.21l2.07,0.44l0.44,0.29l0.4,2.02l2.9,2.63l0.27,1.24l-2.96,0.35l-2.55,1.84l-0.7,0.94l-2.65,1.33l-0.88,1.57l-0.32,1.96l-2.18,1.02l-2.09,1.93l-1.71,0.77l-1.83,0.23l-3.9,-0.57l-0.98,0.38l-1.15,1.21l-1.28,2.46l-0.71,-1.3l-2.27,-0.52l-2.33,-1.09l-1.21,-0.03l-1.45,1.01l-3.92,-0.26l-3.07,-1.87l-1.85,0.01l-5.24,-1.97l-1.92,0.46l-1.3,-0.85l-1.15,-0.1l-0.71,0.65l-0.56,3.35l-1.36,0.07l-1.6,1.82l-0.23,1.07l-2.5,-0.4l-0.95,0.24l-0.75,0.61l-2.23,-0.04l-1.69,-0.37l-0.86,-1.54l-2.34,-1.31l-3.63,-3.34l-1.58,-0.02l-1.91,-2.37l-2.02,-1.08l-3.04,-3.02l-1.53,-0.08l-1.63,-1.37l-2.41,-3.91l-1.35,-1.5l1.34,-1.87l0.16,-1.15l-0.82,-1.15l-2.46,-1.54l-0.83,-0.87l-1.55,-3.17Z",name:"Czech Rep."},IM:{path:"M286.48,364.63l0.75,-2.12l1.13,-0.81l1.38,-1.97l1.16,-0.38l0.45,1.97l-0.91,1.44l-2.48,2.14l-1.47,-0.27Z",name:"Isle of Man"},GB:{path:"M268.15,314.94l0.76,-0.51l2.22,-0.36l1.99,-1.42l-0.04,-0.68l-1.33,-0.72l1.39,-0.78l1.97,-2.75l0.47,-2.7l-1.51,-2.4l-1.71,-0.79l-0.08,-1.24l3.04,-1.75l-0.26,-0.39l-1.22,-0.45l-0.73,-1.5l0.65,-2.06l1.01,-1.76l3.3,0.06l0.77,-0.52l1.74,0.44l0.45,-0.58l-3.37,-3.5l0.78,-1.43l0.07,-1.57l4.32,-0.43l0.23,-0.54l-1.07,-2.23l0.29,-2.53l0.57,-0.77l0.99,-0.34l1.4,0.28l1.48,1.26l2.81,-1.1l1.07,1.04l3.29,-0.87l9.93,-1.18l2.64,-0.65l2.45,0.26l-0.8,1.82l-0.05,2.13l-1.24,1.58l-10.66,7.29l-0.65,2.2l0.34,0.47l1.91,0.38l-2.81,2.5l-0.76,1.94l0.39,0.55l3.69,-0.45l6.29,-2.1l1.36,-0.03l3.54,0.74l2.46,-0.39l8.29,0.22l2.29,-0.41l1.34,0.44l1.17,1.15l1.11,2.32l-3.2,4.12l-0.97,3.1l-2.28,4.57l-2.22,2.52l-2.23,3.23l-2.32,1.42l-3.73,0.67l-3.51,1.63l-0.28,0.45l0.41,0.33l1.52,-0.05l1.56,-0.45l2.59,-0.15l2.77,1.34l-0.19,0.79l-1.06,0.82l-2.98,0.24l-2.66,2.16l-2.31,0.93l-4.35,-0.66l-1.23,-0.59l-0.51,0.14l0.07,0.52l1.15,1.0l1.42,0.59l7.67,1.25l3.04,-1.42l3.05,-0.02l5.98,2.32l4.24,4.35l2.33,1.89l3.11,10.2l1.78,4.76l0.84,1.39l1.25,1.09l6.45,2.77l4.06,4.18l3.44,2.72l-0.61,0.48l-0.71,1.43l0.53,1.56l3.18,5.0l-1.41,-0.06l-2.86,-1.74l-2.54,0.37l-2.7,-0.14l-0.39,0.36l0.31,0.43l2.37,0.55l2.55,0.05l5.58,4.04l1.86,2.36l1.07,3.01l-0.66,1.22l-3.41,3.22l0.1,0.61l3.4,1.83l1.62,-0.4l2.3,-2.51l1.81,-0.17l4.73,0.34l4.27,1.16l3.61,2.48l0.73,1.26l0.39,3.6l-2.05,6.22l-2.29,2.13l-1.08,0.57l-1.18,-0.21l-0.37,0.34l0.56,2.13l-0.93,0.61l-1.03,0.28l-2.15,-0.35l-2.75,1.41l0.05,0.73l1.83,0.67l0.25,0.48l-0.38,1.04l-1.05,0.51l-3.94,0.66l-1.21,0.68l-0.17,0.49l0.47,0.24l1.3,-0.31l0.71,0.22l0.54,0.99l0.71,0.48l2.88,0.54l6.8,-0.18l-0.22,2.81l-0.29,0.32l-4.28,1.91l-1.27,2.12l-2.49,-0.05l-1.14,0.82l-6.33,2.15l-5.55,-0.91l-3.41,0.08l-4.48,0.79l-4.59,-1.4l-2.08,-0.24l-1.73,-0.69l-0.47,0.14l0.01,0.49l0.8,0.98l-1.99,1.06l-4.61,0.55l-2.19,-0.18l-0.41,0.53l0.75,1.52l-0.44,0.12l-4.2,-0.6l-0.74,0.12l-0.59,0.52l-1.26,-0.25l-3.19,-1.61l-1.68,-0.3l-1.51,0.11l-5.71,1.65l-1.16,1.64l-1.3,3.91l-1.15,1.29l-1.24,0.15l-5.49,-2.9l-1.51,0.61l-2.85,0.32l-3.11,0.94l-3.9,2.36l-1.47,2.12l-1.08,0.22l-1.33,-1.05l-1.51,-0.38l-2.58,0.83l-0.13,-0.77l0.97,-0.96l3.15,-0.92l2.75,-2.3l1.87,-2.16l1.57,-0.78l0.41,-0.8l3.82,-3.57l0.78,-3.42l3.09,-1.03l1.41,-2.79l4.41,-0.65l3.12,0.04l3.18,0.57l3.47,-0.2l1.38,-0.88l2.17,-2.81l3.94,-3.66l2.13,-2.39l0.01,-0.52l-0.51,-0.1l-1.44,0.82l-2.73,2.04l-3.23,0.78l-4.11,2.62l-3.45,-0.4l-2.63,-2.2l-1.94,-1.02l-3.92,0.43l1.54,-1.33l-0.33,-0.33l-2.46,-0.4l-1.59,-1.07l-3.01,0.07l-4.0,1.97l-3.22,-1.79l-0.02,-1.23l-0.45,-0.97l-0.54,-0.33l0.67,-0.79l1.19,-0.77l2.84,-0.84l6.68,-2.81l2.33,-1.5l1.06,-1.03l1.34,-2.7l0.92,-1.18l-0.2,-0.63l-0.75,-0.24l-0.29,-0.65l0.5,-1.83l-1.03,-2.09l0.21,-1.57l-0.4,-0.48l-3.51,0.34l-3.15,1.52l-0.81,0.1l0.49,-0.83l3.19,-2.29l1.77,-2.32l2.07,-1.33l4.53,-1.59l1.66,0.17l4.2,-0.9l3.0,1.55l0.45,-0.06l0.11,-0.44l-0.79,-2.12l0.75,-0.33l1.97,2.14l0.94,0.25l1.56,-0.33l0.31,-0.32l-0.78,-0.79l-1.62,-0.37l-0.67,-0.62l-1.2,-2.13l0.06,-1.14l1.75,-2.6l-0.2,-0.62l-1.2,-0.59l0.05,-1.98l1.75,-1.15l0.72,-3.51l-0.69,-1.04l-1.82,0.15l-2.04,0.77l-1.98,-1.77l-3.27,-4.34l-0.27,-1.6l1.65,-3.73l2.54,-2.39l3.05,-0.85l0.29,-0.39l-0.29,-0.39l-5.5,-0.22l-1.66,0.32l-1.58,1.06l-1.72,0.45l-2.24,1.6l-2.19,0.01l-1.01,-1.05l-0.84,-0.18l-3.47,1.62l-3.9,-1.59l-0.98,0.57l-0.72,2.0l-1.09,-0.89l-1.34,-1.73l-0.45,-2.0l0.37,-0.24l0.61,0.34l0.56,-0.2l1.22,-3.01l3.27,-5.08l0.68,-1.8l-0.1,-1.0l-0.6,-1.02l-2.21,-1.89l0.26,-3.02l0.63,-1.0l2.88,0.03l0.39,-0.31l-0.22,-0.45l-3.28,-1.99l0.55,-1.71l-0.12,-0.45l-0.46,-0.04l-1.82,2.56l-2.04,0.67l-0.55,0.96l-1.04,0.34l0.28,-2.25l0.57,-0.88l2.4,-2.19l0.05,-0.53l-0.52,-0.11l-1.23,0.72l-2.72,2.09l-1.84,1.98l-0.11,1.04l0.59,2.29l-0.16,0.98l-2.29,7.16l-0.67,0.9l-1.14,-0.06l-0.3,-0.73l1.15,-4.26l2.4,-3.66l-0.54,-0.36l-1.04,0.13l0.17,-4.38l0.74,-1.58l0.27,-2.18l1.9,-4.94l0.89,-0.94l0.21,-1.12l1.66,-2.66l-0.05,-0.45l-0.94,0.08l-5.74,4.13l-2.6,-0.52l-0.82,-0.71l-0.4,-1.51l-0.37,-0.3l-1.52,-0.14ZM339.59,233.48l-0.57,2.19l-0.53,-0.03l-0.06,-1.74l0.74,-0.02l0.42,-0.4ZM336.19,239.14l-0.93,-1.46l0.79,-1.92l0.63,0.04l0.08,0.26l-0.75,0.66l0.18,2.42ZM329.81,239.86l0.8,-0.37l1.06,-1.32l0.87,-0.15l0.23,2.57l0.58,0.28l0.4,-0.21l1.17,1.27l0.92,-0.16l-1.6,5.89l-0.26,2.06l-0.62,0.77l-0.43,1.4l-0.23,-0.2l1.02,-3.91l-0.25,-1.08l-0.77,-0.9l-1.96,0.22l-0.43,-1.0l-1.48,-0.05l-0.32,-0.39l2.04,-0.14l1.63,-0.82l0.19,-0.49l-1.02,-2.77l-1.52,-0.49ZM330.39,426.85l1.55,-0.47l0.95,-0.66l2.54,0.99l-0.75,0.49l-0.48,0.83l-0.59,0.15l-0.6,0.0l-2.6,-1.33ZM315.95,265.12l-0.68,0.01l0.29,-0.44l0.71,-0.23l0.87,0.07l-1.2,0.59ZM309.8,263.74l0.37,-0.11l1.34,1.02l-1.51,-0.67l-0.2,-0.25ZM312.26,265.65l1.03,0.29l-0.03,0.18l-0.75,0.32l-0.25,-0.79ZM308.85,269.28l-0.26,0.62l0.38,0.54l3.29,0.45l0.39,0.27l-0.24,0.56l-0.56,0.19l-1.93,-0.96l-2.24,0.39l-0.45,-0.22l-0.26,-1.19l-0.58,-0.1l-0.8,0.43l0.01,-1.32l0.41,-1.08l0.57,-0.18l1.09,0.13l1.3,0.68l0.27,0.34l-0.41,0.45ZM310.59,274.73l-0.03,-0.02l-0.47,-0.75l0.7,-0.11l-0.21,0.88ZM306.77,274.1l-0.45,-0.01l-1.04,-1.0l-0.33,-0.85l1.05,0.15l0.78,1.72ZM293.4,379.3l0.66,0.42l0.9,0.03l-3.55,2.22l-0.41,-0.54l-0.84,-0.13l-0.91,-1.28l-0.16,-1.93l1.09,-0.46l1.73,0.03l1.49,1.64ZM281.03,338.84l-1.32,0.01l-1.07,-0.49l-0.75,-2.35l0.78,-1.35l0.65,-0.11l0.96,0.74l0.71,1.66l0.05,1.88ZM243.78,353.56l2.07,-0.03l2.55,-1.09l1.48,-2.17l0.71,-2.43l2.02,-1.34l0.58,0.54l1.33,0.1l1.08,-0.74l1.04,-1.76l3.18,-0.18l3.04,-0.9l1.25,-0.01l3.21,0.46l1.09,1.18l0.71,2.2l1.58,2.14l2.0,1.81l0.06,0.77l-2.05,1.18l-0.22,1.17l0.55,0.37l1.78,-0.56l1.9,0.16l0.59,0.65l0.71,2.04l-0.07,0.41l-0.62,-0.99l-1.5,-0.75l-0.51,0.48l0.32,1.28l-0.13,1.73l0.21,0.38l0.95,0.23l-0.41,1.14l-3.01,0.79l-1.46,2.65l-0.91,0.58l-3.72,-0.8l-1.47,0.62l-2.99,0.05l0.16,-1.49l-0.39,-0.71l-1.84,-0.6l-0.68,-0.91l-0.33,-1.22l-2.04,-1.58l-0.85,0.07l-2.1,2.02l0.45,1.34l-2.25,1.86l-3.2,-0.35l-1.07,-0.82l-2.16,-0.48l-0.53,-1.29l-3.24,-2.77l1.07,-0.79l3.35,-1.09l0.67,-0.52l0.24,-0.59l-0.22,-0.47l-1.93,-1.02ZM261.43,298.81l2.77,-0.68l0.52,-1.27l0.92,0.27l0.98,1.15l0.26,1.42l-0.24,1.96l0.61,2.1l1.02,0.63l2.54,0.4l2.31,-0.1l0.21,0.31l-3.17,2.99l-0.73,0.23l-0.24,-2.65l-0.48,-0.35l-2.97,0.32l-0.61,-0.28l-1.79,-2.5l-3.04,-0.66l-0.76,-0.83l-0.17,-0.38l0.46,-0.56l0.82,0.18l0.99,-0.58l-0.19,-1.09ZM269.34,332.0l-0.57,-0.07l-0.12,-1.03l1.96,-1.32l-0.03,-0.72l-0.51,-0.21l0.28,-0.48l1.95,-1.22l-2.97,5.06ZM271.87,321.8l-5.06,1.0l-1.54,-0.08l1.84,-0.73l0.62,-2.57l-0.21,-0.45l-2.19,-1.11l0.09,-0.39l2.26,-0.75l1.96,2.01l2.42,0.81l-0.19,2.27ZM263.06,333.89l0.29,-1.39l0.53,-0.68l0.58,-0.27l0.79,0.24l1.95,-1.18l0.87,3.48l-0.29,0.85l-2.16,0.88l0.34,-0.95l-0.39,-0.99l0.18,-0.72l-0.36,-0.57l-0.93,0.13l-1.39,1.16ZM255.41,289.78l0.69,-0.49l-0.15,-0.72l-1.04,-0.51l-0.13,-0.82l0.1,-0.64l0.69,-0.72l1.74,0.87l2.02,-0.12l0.46,-0.5l-0.77,-1.87l6.87,-3.75l0.25,2.18l-1.59,3.18l-0.74,0.23l-0.54,0.78l-1.75,0.9l-0.21,0.45l0.38,0.31l1.48,0.02l-0.0,0.7l-1.99,1.51l-1.52,0.67l-1.42,1.52l-0.92,0.18l-1.21,1.34l-0.95,-0.76l2.62,-1.89l0.17,-0.55l-2.55,-1.49ZM265.16,309.88l-0.49,0.1l-0.68,-0.67l0.84,-0.36l0.47,0.45l-0.13,0.47ZM261.42,316.68l0.29,-0.28l0.09,-0.02l-0.03,0.04l-0.35,0.27ZM249.11,297.53l0.35,-0.38l1.04,0.14l2.36,-0.64l1.01,0.73l-0.88,1.33l-1.56,-0.01l-2.31,-1.17ZM251.9,306.91l-1.08,-0.23l-0.4,-1.03l0.09,-3.19l1.15,0.03l0.25,4.42ZM248.75,309.97l0.68,-0.43l0.37,0.2l-0.96,0.26l-0.09,-0.03Z",name:"United Kingdom"},AX:{path:"M628.45,248.96l0.16,-0.05l0.84,0.08l0.31,0.32l-0.63,0.06l-0.68,-0.41ZM621.7,243.28l1.25,-0.06l2.02,1.49l-0.63,0.99l-0.8,-0.15l-1.25,0.46l-0.31,1.74l-2.69,0.2l-0.49,-0.23l-0.9,-2.45l0.11,-0.4l0.54,-0.21l0.06,1.05l0.47,0.37l0.85,-0.15l0.32,-0.29l0.34,-1.72l-1.05,-1.12l0.26,-0.39l0.48,-0.17l0.58,0.75l0.84,0.28ZM616.9,246.18l-0.55,0.17l-0.39,0.42l0.16,-1.31l0.49,-0.02l0.28,0.74Z",name:"Aland"},IE:{path:"M245.03,355.16l-3.75,1.4l-1.46,1.19l0.42,1.3l3.09,2.41l0.65,1.39l2.3,0.51l1.07,0.82l3.69,0.38l2.79,-2.26l0.09,-0.46l-0.49,-0.95l1.71,-1.63l0.31,0.02l1.52,1.24l0.25,1.06l0.91,1.22l1.92,0.73l-0.18,1.51l0.56,0.74l3.32,-0.04l1.44,-0.63l0.91,0.09l0.42,0.48l-0.42,0.31l-1.28,-0.03l-0.65,0.73l-0.03,0.85l0.37,1.24l0.72,0.86l0.99,3.59l0.72,1.21l0.15,3.22l-0.29,0.63l1.44,5.06l0.23,2.86l-1.89,3.4l-0.67,3.58l-1.65,2.45l-1.46,0.94l-0.11,0.65l1.47,1.41l-0.98,0.51l-1.53,0.23l-1.77,-0.43l-1.27,0.04l-1.49,0.84l-1.01,-1.55l-0.81,1.63l-0.82,0.37l-1.8,-0.09l-4.31,0.86l-1.41,1.96l-3.3,1.03l-1.16,1.3l-1.31,0.67l-0.96,0.18l-1.89,-1.34l-1.79,-0.0l-0.38,0.32l0.85,0.97l-0.0,1.57l-1.61,0.5l-1.42,0.95l-1.89,0.26l-1.2,0.96l-6.42,1.53l-2.25,-0.55l-4.26,0.91l1.21,-1.55l2.33,-1.17l0.24,-0.3l-0.24,-0.64l-0.89,-0.15l-4.33,0.76l-2.09,0.72l3.76,-2.46l0.67,-0.74l1.97,-0.87l0.21,-0.5l-0.49,-0.25l-6.5,1.85l-1.48,-0.2l-0.69,-0.54l-1.03,0.19l-0.29,-0.71l1.78,-1.71l1.09,-0.77l2.7,-1.09l0.66,-0.93l-0.19,-0.58l-0.79,-0.28l-5.41,0.07l0.29,-0.66l1.82,-1.08l0.94,-0.17l2.67,0.8l2.24,-0.23l0.34,-0.28l-0.13,-0.43l-0.81,-0.65l-0.15,-1.37l-0.45,-0.48l1.55,-0.82l1.69,-1.42l7.69,-1.32l3.73,-1.08l0.29,-0.38l-0.28,-0.39l-1.82,-0.57l-0.85,-0.73l-0.56,0.03l-1.42,1.55l-0.93,0.54l-2.82,0.31l-2.45,-0.63l-2.94,1.35l4.74,-3.85l0.97,-1.34l0.03,-0.41l-0.67,-0.88l1.87,-2.34l0.63,-0.41l3.34,-0.71l1.03,-0.9l-0.13,-0.67l-2.92,-0.82l-5.04,0.23l-0.67,-0.44l-0.24,-0.84l-0.5,-0.44l-2.93,0.12l0.68,-0.6l-0.2,-0.69l-3.7,-0.25l0.42,-0.63l-0.05,-0.58l-0.65,-0.76l4.97,-0.87l0.35,-0.37l-0.29,-0.42l-2.29,-0.83l0.06,-0.78l1.91,-0.9l2.21,-0.43l0.31,-0.49l-0.01,-1.2l-0.35,-0.48l-2.29,-0.21l-1.8,0.38l0.68,-2.04l-0.0,-1.8l-0.53,-0.33l-0.58,0.2l-0.57,-1.73l-0.49,-0.19l-1.01,0.38l0.02,-0.42l0.33,-0.58l0.59,-0.24l2.28,0.12l1.54,-0.59l2.01,-0.15l3.2,0.18l2.21,1.59l1.01,-0.26l1.2,-1.12l5.49,1.04l0.81,-0.19l0.26,-0.48l-0.31,-1.17l-0.59,-0.71l1.72,-1.42l3.26,-1.22l1.45,-2.62l-0.38,-0.63l-4.29,0.58l-3.57,-1.16l1.07,-0.91l1.46,-0.4l0.38,-0.61l1.96,-1.47l-0.31,-1.75l0.19,-0.79l0.94,-0.8l0.56,-1.44l3.44,-0.89l2.64,-0.09l0.63,0.24l0.54,-0.43l-0.11,-0.78l0.78,-0.09l1.02,1.41l0.13,0.66l-0.89,1.03l-0.02,0.6l0.31,0.29l-0.67,0.73l-0.03,0.5l0.48,0.14l2.52,-1.47l0.1,-1.18l-0.63,-1.97l0.14,-0.76l0.61,-0.48l2.02,-0.31l0.26,-0.64l-0.46,-0.62l4.01,2.13l-5.21,3.62l-1.07,2.92l-1.25,1.91l-2.31,0.96l-1.79,-0.12l-0.73,0.44l-0.03,0.88l1.98,1.2ZM212.65,366.62l-0.13,-0.02l0.03,-0.02l0.09,0.04ZM213.87,366.77l1.05,0.02l0.27,0.15l0.07,0.94l-0.8,-0.9l-0.59,-0.21Z",name:"Ireland"},ES:{path:"M408.55,609.24l-3.95,-1.75l-1.35,-0.22l-0.04,-0.91l2.43,-0.17l2.05,0.62l1.1,1.67l-0.24,0.75ZM392.9,610.25l0.24,0.47l1.3,0.53l1.55,-0.44l0.59,0.12l0.47,0.17l0.11,0.64l-2.84,4.76l-2.01,1.18l-3.51,-1.26l-0.53,-1.7l-0.91,-0.82l-1.18,-0.19l-1.55,1.01l-0.31,-0.47l-1.13,-0.56l0.01,-0.33l5.42,-3.73l1.57,-0.82l3.07,-0.89l-0.06,0.57l0.37,0.41l-0.66,1.32ZM246.2,546.17l1.24,0.54l1.33,-0.16l1.25,0.65l2.0,1.73l2.73,0.67l2.32,-0.51l11.05,-0.15l3.17,-0.81l2.44,1.01l4.71,0.48l2.86,0.85l7.97,1.43l2.93,0.01l5.69,-1.37l1.66,0.32l2.22,-0.66l0.92,0.12l1.48,0.98l5.05,1.32l1.62,-1.15l0.81,-0.2l3.51,0.67l3.75,1.41l1.98,0.1l2.79,-0.38l2.24,-0.92l0.61,1.08l0.69,0.42l3.9,1.0l-0.15,1.08l-0.77,1.27l0.05,0.44l0.81,0.66l1.09,0.03l0.6,-0.74l0.3,0.36l4.79,1.82l2.22,0.15l2.37,2.24l1.74,0.09l2.29,-0.44l3.47,2.21l3.37,-0.44l0.82,0.42l5.11,0.05l0.53,-0.55l0.4,-1.99l8.53,2.45l0.9,1.31l0.03,2.1l0.64,0.81l1.32,-0.09l2.19,-0.97l2.73,1.14l1.03,1.21l0.88,0.03l2.11,-1.03l6.05,1.3l0.84,-1.12l2.56,-0.78l0.93,-0.16l3.02,0.58l1.09,1.68l-1.81,0.71l-0.22,1.53l1.19,1.45l0.12,2.0l-3.11,2.7l-9.38,4.87l-3.07,2.88l-6.93,1.47l-7.25,2.16l-4.47,3.93l0.14,0.7l1.0,0.28l0.97,0.99l-1.94,1.07l-1.87,0.41l-3.14,4.73l-5.95,7.1l-3.44,5.71l-0.07,1.96l1.73,5.74l1.03,1.55l1.35,1.24l2.56,1.08l0.41,0.67l-3.16,2.45l-4.44,2.36l-1.99,1.94l-0.48,1.83l-1.34,0.98l-0.48,2.47l-1.8,3.57l-0.11,0.91l1.16,1.29l-0.27,0.21l-2.08,0.35l-5.27,0.16l-4.46,2.79l-2.28,2.59l-1.9,4.42l-2.24,2.53l-0.75,0.35l-1.61,-1.09l-2.0,-0.18l-2.05,0.39l-1.14,0.96l-1.39,0.45l-1.52,-0.42l-3.39,-0.24l-1.6,0.06l-2.23,0.71l-1.96,-0.48l-3.38,-0.25l-7.46,0.61l-1.12,0.41l-3.08,2.87l-3.54,0.09l-3.2,1.22l-1.0,0.94l-1.35,2.14l-0.35,1.21l-0.96,-0.07l-0.5,1.3l-1.83,0.61l-2.33,-0.91l-2.03,-1.42l-1.11,-0.16l-2.36,-3.47l-0.56,-2.6l-1.61,-0.81l-0.29,-1.07l1.02,-1.66l1.6,-1.37l-0.41,-0.31l-1.41,0.08l-0.96,0.94l-1.11,-1.59l-5.06,-3.56l0.19,-1.23l-0.7,-0.22l-1.27,1.12l-2.71,-0.15l-2.77,0.4l-1.23,-5.85l0.75,-2.07l2.03,-2.77l1.34,-1.45l2.36,-0.79l0.91,-2.31l-0.45,-0.59l-1.76,0.15l-2.97,-4.04l0.81,-3.79l3.11,-2.96l0.63,-1.46l0.03,-1.41l-0.83,-0.95l-1.59,-0.4l-1.69,-3.02l-0.39,-1.96l-1.57,-1.32l-0.92,-1.49l5.21,-0.2l1.22,-0.59l0.9,-1.43l0.9,-2.28l0.23,-1.44l-0.4,-0.92l-1.43,-1.44l0.17,-0.44l2.07,-1.45l0.76,-1.07l-0.54,-1.45l0.45,-3.48l-0.24,-1.99l-0.33,-1.74l-0.89,-1.96l1.97,-1.35l1.13,-1.68l1.61,-1.38l2.17,-1.14l1.61,-1.34l1.17,-1.66l-0.43,-1.19l-1.01,-0.82l-1.25,-0.44l-1.89,-0.09l-0.11,-3.06l-0.36,-0.8l-0.88,-0.56l-1.06,0.12l-1.76,-0.47l-0.61,0.3l-2.06,-0.08l-1.78,-0.47l-0.82,0.53l-0.24,0.98l-2.34,0.86l-1.37,-0.03l-2.55,-0.85l-3.24,0.12l-2.87,1.11l-0.62,-1.02l1.23,-2.07l-1.13,-1.88l-1.06,-0.33l-4.57,1.41l-2.58,1.82l-0.72,0.16l-0.18,-2.32l2.53,-2.61l-0.12,-0.66l-1.4,-0.22l1.06,-1.45l-0.13,-0.55l-0.92,-0.75l-0.01,-2.74l-0.53,-0.28l-2.47,0.81l-0.02,-0.67l1.45,-2.27l-0.32,-0.5l-1.46,-0.24l-1.05,-0.76l-1.33,-1.66l0.71,-2.85l2.0,-1.02l1.92,-1.48l2.78,0.27l1.74,-0.34l2.56,-1.02l1.67,-1.08l-0.05,-0.95l-0.41,-0.69l0.23,-0.35l3.27,-1.81l2.1,-0.23l1.93,-0.88ZM370.1,623.83l-0.59,0.91l-1.82,-0.41l0.26,-0.64l0.7,-0.46l0.03,-0.65l0.46,-0.58l2.6,-0.57l0.4,0.32l0.08,0.41l-1.53,1.47l-0.58,0.19ZM370.18,627.26l0.43,0.46l-0.55,0.0l0.12,-0.46ZM164.44,776.55l-0.91,0.89l-0.44,-0.15l0.76,-2.18l3.27,-1.23l0.83,-1.23l-0.52,2.64l-2.99,1.26ZM155.44,788.95l2.37,-1.46l2.87,-6.04l0.34,-1.27l0.46,-0.35l0.91,0.01l0.27,0.45l-0.01,1.42l-0.47,2.52l-0.8,2.08l-3.47,1.18l-1.83,1.61l-0.64,-0.14ZM141.28,788.62l0.11,1.32l-4.04,0.0l0.8,-1.44l3.13,0.12ZM128.81,784.44l-1.25,3.48l-1.5,1.58l-1.26,0.29l-1.66,-1.86l-1.25,-2.48l4.27,-0.62l3.26,-2.31l2.13,-0.21l-2.74,2.13ZM117.34,789.64l-0.75,-0.17l-0.52,-0.88l0.58,-0.83l1.31,0.57l0.26,0.48l-0.88,0.82ZM108.62,782.59l-1.69,-3.37l0.7,-0.91l1.39,-0.03l0.72,1.33l-0.36,2.16l-0.76,0.82Z",name:"Spain"},ME:{path:"M601.12,565.85l1.19,-0.97l0.28,-0.68l-0.09,-0.72l-1.0,-1.62l-0.28,-2.93l0.34,-0.41l1.75,-0.24l0.34,-0.4l0.06,-1.92l0.56,-1.18l2.2,-1.75l0.74,0.07l0.92,0.94l0.98,-0.46l0.08,-1.33l-1.22,-2.13l0.14,-0.28l1.2,0.35l1.26,-0.26l0.56,1.35l2.58,1.71l2.74,2.82l2.42,1.12l2.14,0.45l5.15,2.95l0.06,0.52l-1.49,0.41l-0.45,0.68l-1.62,-0.06l-0.66,0.62l0.72,1.91l-0.2,0.93l-3.37,1.17l-0.38,-0.47l-0.16,-1.85l-0.88,-0.44l-0.81,0.44l-3.97,5.49l-0.67,0.29l-2.58,-0.2l-0.31,0.65l1.59,1.94l1.69,0.85l-0.04,2.92l-1.44,-0.88l-0.9,-1.83l-3.09,-3.08l-3.53,-2.11l0.23,-0.58l-0.34,-0.59l-1.53,0.19l-0.92,-1.43Z",name:"Montenegro"},MD:{path:"M712.53,469.1l2.31,-1.33l5.14,0.23l1.53,-1.02l1.05,0.19l1.72,-0.95l3.49,0.95l0.98,0.89l2.03,0.79l0.72,1.12l1.09,0.35l1.68,-0.01l0.39,0.23l-0.18,0.59l0.23,0.62l1.14,0.03l0.57,0.96l0.6,-0.0l0.78,-0.88l2.88,0.47l1.16,1.99l0.96,0.93l0.99,0.32l1.65,-0.6l0.82,1.24l0.21,1.74l-0.32,1.87l-0.84,2.17l0.18,1.06l0.34,0.59l2.44,1.48l0.73,0.86l1.98,0.87l-0.38,2.89l0.67,0.88l0.19,1.52l2.11,1.48l2.08,0.9l0.74,1.53l-0.07,3.43l2.44,1.72l-0.33,0.32l-2.9,0.39l-1.0,-1.27l-0.81,-0.32l-1.41,0.82l-2.03,-0.92l-1.01,0.26l-0.87,-0.4l-0.6,0.12l-0.62,1.15l-0.1,-1.82l-0.5,-0.51l-0.54,-0.05l-2.77,1.21l-0.63,0.95l0.04,1.05l0.21,1.4l0.77,1.72l-0.71,1.95l-1.2,1.09l-1.45,0.68l-0.35,1.64l-3.15,3.06l0.03,2.49l-2.33,0.22l-1.08,0.59l-1.37,-1.89l0.96,-0.86l-0.81,-5.49l0.26,-2.73l1.68,-5.26l-0.27,-1.14l0.22,-2.18l-2.29,-5.93l-3.05,-2.49l-1.16,-1.93l-2.06,-1.92l-2.23,-3.64l-1.53,-1.5l-2.47,-5.46l-2.41,-3.5l-1.17,-1.03l-1.54,-0.78l-1.64,-0.15Z",name:"Moldova"},RO:{path:"M631.66,512.33l-1.62,-2.15l-2.98,-1.78l-1.3,-1.89l3.0,-0.64l1.59,0.53l1.44,-0.77l0.67,-1.16l0.81,-0.18l2.69,0.29l1.42,-0.78l0.52,-0.55l0.45,-1.28l1.09,-0.68l-0.15,-1.22l0.78,-1.78l2.38,-1.66l0.06,-1.57l2.13,-2.96l0.14,-1.37l1.69,-1.68l1.11,-2.8l1.64,-1.49l0.18,-2.0l1.41,-1.04l2.32,-2.6l2.53,-0.74l1.81,0.04l3.7,-3.16l2.29,-0.96l1.16,-1.36l0.58,0.03l2.92,1.64l3.46,-0.04l4.49,0.97l0.86,-0.12l1.63,0.64l4.11,-0.7l1.11,0.24l4.5,3.72l2.52,-0.5l1.41,-1.38l3.87,-1.47l9.43,-1.41l1.84,-2.27l0.38,-1.46l5.19,-0.97l2.33,0.84l0.99,0.89l2.29,3.34l2.51,5.52l1.57,1.55l2.19,3.59l2.1,1.97l1.18,1.95l2.93,2.32l2.21,5.6l-0.22,2.16l0.27,1.0l-1.66,5.2l-0.28,2.9l0.8,5.36l-1.04,0.73l0.01,0.55l1.84,2.47l1.43,1.74l1.94,1.03l4.29,1.01l0.85,-0.41l-0.23,-0.86l1.39,0.33l1.88,-0.54l2.59,-1.35l2.28,-0.26l2.07,0.77l1.65,1.62l-0.91,4.49l-0.93,2.04l-5.84,1.21l-0.37,-2.16l0.52,-0.66l-0.24,-0.64l-1.85,-0.24l-1.32,1.35l0.37,1.96l-0.97,1.47l-0.08,1.37l-0.53,1.29l0.45,0.45l0.39,-0.06l-2.26,2.65l-0.78,1.52l0.18,5.12l-0.96,3.66l-2.42,-0.04l-4.24,-1.23l-2.16,-2.64l-0.42,-0.14l-1.86,0.48l-0.84,-0.66l-3.33,-0.39l-4.73,-2.44l-8.15,1.39l-3.76,1.29l-3.9,2.3l-1.6,1.74l-1.7,0.86l-2.46,0.65l-4.49,-0.25l-9.87,-1.78l-2.85,0.5l-3.67,-0.38l-5.67,-1.11l-4.2,-0.34l-4.08,0.63l-0.45,-0.32l0.03,-0.96l2.02,-1.54l0.02,-1.12l-4.47,-2.72l-0.15,-0.7l-1.44,-0.93l-0.99,-1.35l0.08,-0.66l0.56,-0.68l2.39,-0.47l0.2,-0.47l-0.33,-0.8l-3.36,-1.74l-1.99,0.5l-2.13,1.95l-1.09,0.23l-0.9,-1.21l-1.6,-0.77l-3.63,-0.72l-0.58,-0.76l-1.0,-0.58l-2.03,-0.57l1.83,-0.2l0.48,-0.55l-0.18,-0.85l-2.12,-0.97l0.62,-0.23l0.99,-1.51l0.07,-1.02l-0.99,-0.87l-2.71,-0.8l-1.0,-0.8l-1.74,-0.54l-3.06,-2.42l-0.11,-4.46l-0.37,-0.46l-0.8,0.27Z",name:"Romania"},RS:{path:"M607.42,509.85l1.42,-0.57l0.68,-0.8l0.8,0.44l1.93,-0.29l2.06,-1.11l1.45,-1.49l0.91,-0.19l3.1,0.39l1.26,-0.26l3.53,0.55l2.01,2.55l2.91,1.72l1.76,2.28l0.78,-0.01l-0.05,3.73l0.4,0.78l3.18,2.52l1.76,0.56l1.1,0.84l2.71,0.8l0.59,0.54l-0.89,1.5l-0.59,0.16l-0.38,0.59l0.52,0.87l1.89,0.81l-2.09,0.34l-0.26,0.39l0.32,0.95l2.16,0.6l1.56,1.34l1.5,0.52l2.22,0.24l1.44,0.7l1.25,1.38l1.66,-0.41l1.95,-1.86l1.75,-0.44l2.73,1.51l-2.07,0.47l-0.95,1.17l-0.06,1.13l0.49,0.96l1.72,1.18l0.39,0.86l-0.82,0.68l-0.41,1.88l-2.37,1.2l-0.78,2.48l0.04,1.46l1.83,4.56l0.75,1.06l2.95,1.73l1.3,1.71l1.38,0.92l-0.36,1.07l-3.08,3.35l-1.91,0.1l-1.5,0.81l-0.37,0.83l0.32,0.93l-0.37,2.03l0.49,1.4l0.79,0.91l-1.33,2.11l-0.79,0.18l-1.6,-0.67l-2.39,0.83l-2.13,-0.25l-2.26,0.89l-1.99,0.33l-0.42,-0.94l1.19,-0.89l1.63,-3.37l0.31,-1.03l-0.21,-0.67l-4.66,-1.26l-0.05,-1.37l-2.13,-1.28l-0.24,-0.7l-2.28,-2.26l-2.83,-1.32l-0.6,-1.42l-1.02,-0.04l-2.04,1.13l-0.19,0.7l0.51,1.45l-0.26,0.47l-2.08,1.44l-0.22,0.83l0.25,0.57l-1.01,0.3l-0.25,-0.85l-0.97,-0.7l-4.43,-2.42l-2.27,-0.5l-2.24,-1.04l-2.64,-2.74l-2.6,-1.74l-0.26,-0.89l0.64,-0.67l1.1,-0.11l1.32,0.51l0.77,-0.71l0.28,-1.06l-0.17,-1.2l-3.14,-4.01l3.69,-0.06l0.68,-0.49l0.14,-0.84l-3.45,-3.32l-2.76,-1.62l0.3,-2.93l1.92,-2.86l0.89,-2.97l-0.3,-0.61l-1.61,-0.6l-1.79,0.3l0.22,-0.99l-0.44,-2.38l0.55,-0.15l0.3,-0.53l0.63,0.27l2.51,-0.09l0.48,-0.45l0.05,-0.62l-1.26,-1.31l-3.09,-1.11l-1.01,-0.88l0.03,-0.83l0.71,-1.15l-1.87,-1.28l0.32,-1.03l-1.29,-2.79l0.59,-0.56l0.11,-0.78Z",name:"Serbia"},MK:{path:"M629.75,577.29l1.84,0.12l0.78,-0.95l0.41,-2.59l3.61,-1.54l0.89,-0.05l1.45,1.15l0.65,0.06l0.91,-1.54l0.63,-0.43l3.04,-0.35l3.84,-1.29l2.05,0.27l2.48,-0.84l1.15,0.64l3.21,3.37l3.37,1.74l1.43,3.5l0.79,0.71l-0.73,1.84l-0.29,3.95l-1.62,0.11l-0.61,0.4l-0.51,2.19l-2.82,0.86l-4.13,-0.64l-2.65,0.45l-1.15,0.53l-1.97,2.46l-2.56,1.2l-2.25,-0.57l-1.24,0.65l-4.44,0.26l-0.63,-0.83l-2.8,-0.25l-0.69,-2.05l-1.24,-1.16l-1.01,-2.21l0.03,-1.94l-0.54,-1.92l0.88,-0.94l-0.14,-2.11l0.57,-2.22Z",name:"Macedonia"},SK:{path:"M655.85,455.69l-1.87,2.97l-1.26,3.23l-2.02,2.0l-0.31,2.96l-4.93,0.82l-2.05,-2.5l-1.8,-1.11l-5.19,0.8l-2.74,-0.69l-3.03,-0.07l-2.16,0.4l-2.33,4.11l-5.08,2.53l-0.54,0.2l-3.78,-1.56l-1.02,0.28l-1.32,1.71l-2.52,0.6l-4.73,0.38l-1.81,0.92l-0.78,1.39l0.31,1.5l-0.48,0.75l-7.63,0.4l-5.12,-0.11l-1.62,-0.65l-4.25,-3.08l-2.48,-0.39l-0.57,-0.4l-2.93,-5.87l-0.03,-0.76l1.03,-1.78l0.6,-2.25l1.91,-2.7l0.53,-0.25l3.99,0.56l2.05,-0.28l1.81,-0.81l2.23,-2.01l1.68,-0.56l0.66,-0.61l0.43,-2.19l0.57,-1.15l2.67,-1.34l0.77,-1.01l2.29,-1.67l3.09,-0.34l1.14,0.17l0.33,1.5l0.41,0.33l2.46,-0.07l1.61,-2.02l2.36,-1.35l2.4,3.23l1.74,0.5l0.15,1.45l-0.41,1.13l0.26,0.48l0.62,0.21l1.69,-0.45l1.76,0.65l0.5,-0.22l0.65,-1.5l0.65,-0.68l2.55,-1.15l3.34,-0.11l1.37,0.34l1.03,0.74l2.12,0.22l1.03,-0.56l0.94,-1.22l3.47,-0.19l3.82,0.29l3.33,1.18l0.92,0.68l0.88,1.68l6.68,2.35Z",name:"Slovakia"},MT:{path:"M547.69,672.17l-1.11,0.1l-0.87,-0.6l-0.01,-0.92l0.72,0.18l1.27,1.23ZM543.86,669.2l0.21,-0.04l0.18,0.07l-0.23,0.07l-0.16,-0.09Z",name:"Malta"},SI:{path:"M558.4,514.15l-0.58,0.36l-0.27,0.83l0.66,1.7l-0.87,0.29l-1.65,-0.15l-2.27,-0.83l-1.46,0.52l-0.51,-0.13l-1.82,-1.48l-0.69,-1.19l-0.57,-0.36l-0.96,0.41l-1.36,2.21l-0.59,0.31l-3.71,0.06l-1.44,-0.5l-1.47,1.32l-3.3,-0.75l1.3,-1.09l1.85,-0.21l0.49,-0.85l-0.67,-1.21l-1.48,-1.37l-1.87,-0.9l0.48,-2.4l-0.56,-0.5l-1.19,-0.12l1.78,-1.87l0.27,-0.99l-2.23,-1.02l-1.0,-0.0l-0.2,-0.4l0.21,-0.69l3.61,-2.34l0.41,-0.89l11.45,1.94l2.8,-1.69l1.79,-1.78l4.25,-0.61l3.12,0.21l2.65,-1.17l1.66,-0.2l2.52,0.56l0.72,-0.63l0.04,-1.7l0.63,-0.57l0.61,-0.26l2.29,0.09l0.53,2.01l0.65,0.71l0.07,0.9l1.15,1.33l-1.93,-0.14l-1.22,0.94l0.08,1.71l-2.19,0.06l-1.02,1.18l-0.8,0.41l-4.21,1.44l-0.67,1.31l0.16,0.75l0.85,0.93l-0.17,2.79l-4.89,2.01l-0.16,0.91l0.87,0.78Z",name:"Slovenia"},SM:{path:"M519.71,543.1l-0.45,-0.16l0.66,-0.49l0.03,0.12l-0.25,0.53Z",name:"San Marino"},UA:{path:"M653.07,467.62l-0.48,-1.02l-1.33,-0.03l0.12,-2.22l2.03,-2.04l1.29,-3.29l1.97,-3.29l3.27,0.94l0.74,-0.39l0.29,-0.58l-0.19,-0.78l-1.79,-1.47l0.38,-2.03l-1.1,-4.13l0.67,-1.03l4.45,-5.14l5.01,-4.84l4.05,-3.55l3.41,-0.56l1.93,-2.52l0.04,-1.69l-0.66,-1.89l-0.81,-1.03l1.48,-0.7l0.01,-0.92l-1.58,-1.38l-1.65,-3.31l-2.63,-3.21l0.21,-1.48l-0.93,-2.11l-0.01,-1.46l0.96,-0.36l1.05,0.07l2.34,0.93l2.54,-1.53l2.08,-1.99l1.03,-1.59l6.71,-0.55l2.72,-0.57l11.52,0.31l11.49,2.58l4.85,0.31l2.07,2.74l4.3,0.01l0.86,0.38l-0.14,1.19l0.77,0.66l0.82,-0.23l1.34,-1.79l2.04,0.55l0.94,-0.1l1.34,-0.76l5.35,1.07l0.77,1.59l1.26,0.46l1.86,-1.96l1.65,-0.54l1.52,-0.99l0.71,0.66l1.69,3.01l0.73,0.64l3.15,-0.84l8.03,-0.78l1.78,1.25l0.48,1.45l1.58,0.92l1.44,0.22l1.63,-2.14l-0.44,-2.15l-0.87,-2.05l0.63,-1.52l1.11,-2.22l1.14,-1.4l2.99,-2.68l1.16,-0.48l2.04,0.41l1.65,-0.95l2.97,-0.05l2.74,0.15l2.68,0.97l2.06,-0.07l2.35,-1.21l1.22,-3.0l0.71,-0.46l4.98,0.99l1.41,-0.1l3.32,-1.51l1.76,-0.22l2.24,0.36l3.78,-0.19l2.3,1.56l1.21,1.66l1.4,3.3l3.75,3.5l-0.11,0.61l-3.32,0.63l-0.34,0.35l-0.02,0.88l1.11,1.58l0.4,3.4l0.62,0.53l-0.82,1.11l0.12,0.5l0.5,0.29l3.42,0.12l3.05,1.17l4.64,-0.55l1.25,2.5l0.76,0.36l1.36,0.04l-0.19,1.29l0.94,2.76l0.76,1.25l-0.65,2.08l0.27,1.27l1.11,1.57l0.8,0.42l0.78,1.34l1.47,0.37l2.77,-1.54l2.87,0.47l2.51,2.23l1.11,-0.21l1.55,0.25l0.81,0.78l1.22,0.44l1.88,-1.45l4.96,-1.04l2.8,-1.15l0.83,0.08l2.01,1.97l0.34,1.37l1.43,1.96l4.69,3.37l1.87,-0.44l0.48,-1.59l0.62,-0.26l2.67,1.56l2.59,0.2l3.77,2.27l1.65,0.09l1.78,-0.6l1.55,1.86l2.32,0.35l4.21,2.69l1.5,0.14l2.03,-0.5l0.42,0.22l-0.38,2.28l0.93,1.25l0.02,0.88l-0.71,1.68l-2.33,2.28l-1.74,0.48l-0.99,0.5l-0.2,0.47l0.33,0.98l0.8,0.9l3.08,1.14l-2.66,0.06l-1.31,1.36l-0.82,2.61l0.3,0.5l2.33,0.73l0.65,2.74l-0.56,1.14l0.38,0.56l1.14,0.33l-0.98,1.32l-1.48,3.53l0.0,1.35l-0.38,0.48l-4.48,0.18l-6.63,-0.37l-1.19,0.33l-1.59,2.23l-0.97,0.76l-1.66,0.71l-2.07,0.29l-1.24,1.08l-0.43,2.63l-0.72,1.43l0.07,0.65l0.94,0.53l-1.01,1.32l0.1,1.34l-4.77,-0.22l-3.93,0.37l-2.89,2.7l-1.6,0.01l-2.4,0.74l-1.66,0.94l-1.64,1.67l-1.38,-0.75l-1.76,0.02l-1.92,0.57l-2.01,1.22l-1.01,0.2l-2.4,-0.34l-2.68,0.72l-5.92,4.2l-0.85,1.26l-0.06,-0.98l-0.84,-1.19l-0.64,-0.01l-2.18,2.85l-2.86,1.3l-0.28,2.37l0.9,3.43l1.61,3.06l3.22,4.28l1.58,1.61l1.23,0.7l1.53,0.14l2.77,-1.34l0.99,-0.18l2.36,0.49l1.18,-0.93l1.12,-0.43l1.51,-0.06l3.32,0.89l-1.49,2.39l-0.71,2.57l-1.95,0.58l-2.39,-0.07l-2.35,0.4l-2.62,-1.59l-1.47,-0.29l-1.5,0.36l-1.71,2.08l-2.67,1.33l-0.94,1.5l-2.45,-0.32l-2.42,0.27l-3.46,1.46l-2.67,3.13l-2.71,1.84l-2.1,0.57l-1.96,-0.18l-1.25,-0.53l-2.53,-1.83l1.01,-1.84l1.11,-3.8l-0.15,-1.47l-0.78,-2.16l-2.21,-1.51l-1.96,0.2l-0.87,-0.34l-3.79,-2.62l-2.11,-0.17l-2.05,0.49l-0.9,-0.76l8.2,-5.54l1.9,-0.29l2.58,-1.26l2.69,-1.85l0.16,-0.43l-0.38,-1.45l-0.61,-1.16l-0.44,-0.2l-2.12,0.61l-3.21,-1.95l-3.47,0.87l-2.0,-0.12l-4.23,0.79l-5.91,-2.98l-1.5,-0.45l-1.23,0.07l-0.17,-0.18l0.26,-0.11l2.25,-0.47l0.37,-0.66l-0.06,-0.73l-0.3,-0.35l-2.07,-0.55l-1.91,-0.16l-1.14,-0.62l9.74,1.35l2.9,-2.06l0.45,-0.95l-0.45,-0.17l-2.95,0.84l-2.9,-0.52l-1.01,-0.69l-0.86,-1.03l-0.34,-1.11l0.24,-1.25l-0.37,-2.3l-1.35,-2.95l-1.18,-1.12l-0.51,-0.02l-0.12,0.49l2.04,4.82l-0.14,3.34l-0.31,0.96l-0.98,0.24l-2.85,-0.46l0.34,-1.53l-0.17,-0.42l-0.46,0.01l-1.0,0.76l-1.19,1.74l-0.91,0.23l-2.56,-0.19l-4.62,1.24l-2.15,5.06l-1.92,2.66l-3.91,3.98l-4.21,1.88l-0.96,0.3l-1.74,-0.36l-1.2,0.75l-0.41,0.86l-0.01,1.39l0.97,1.2l0.63,3.62l-1.51,-1.33l-2.41,-0.85l-2.58,0.32l-2.62,1.37l-1.64,0.47l-1.56,-0.31l-0.55,0.61l0.02,0.59l-3.8,-0.88l-1.69,-0.86l-1.12,-1.36l0.85,-0.48l2.64,-0.36l0.43,-1.31l-0.26,-1.46l3.09,-2.98l0.2,-1.44l1.39,-0.67l1.45,-1.41l0.77,-2.41l-0.83,-1.85l-0.2,-2.07l0.28,-0.4l2.58,-1.04l0.09,2.09l0.34,0.39l0.96,-0.28l0.59,-0.99l0.99,0.29l0.82,-0.29l2.2,0.94l1.43,-0.79l1.79,1.6l3.15,-0.45l1.01,-0.9l-0.07,-0.59l-2.61,-1.84l0.21,-3.09l-0.93,-1.9l-4.09,-2.24l-0.11,-1.31l-0.67,-0.88l0.48,-2.47l-0.27,-0.75l-2.11,-0.98l-0.72,-0.85l-2.54,-1.77l-0.12,-0.51l0.82,-2.15l0.35,-2.11l-0.29,-2.08l-1.12,-1.57l-0.78,-0.17l-1.42,0.65l-1.15,-0.9l-1.49,-2.29l-3.33,-0.54l-0.94,0.81l-0.37,-0.7l-0.98,-0.21l-0.04,-0.93l-0.76,-0.44l-2.59,-0.27l-0.22,-0.69l-0.56,-0.44l-1.12,-0.28l-1.94,-1.43l-4.0,-1.06l-1.85,1.0l-1.09,-0.18l-1.37,0.99l-5.24,-0.22l-2.8,1.62l-0.38,0.61l-4.06,0.92l-0.67,1.8l-1.39,1.88l-9.41,1.42l-4.0,1.52l-1.37,1.36l-2.09,0.42l-4.14,-3.56l-1.48,-0.38l-4.17,0.7l-1.51,-0.63l-0.93,0.12l-4.48,-0.97l-3.48,0.03l-2.69,-1.58l-1.04,-0.1l-1.43,1.47l-2.08,0.85l0.02,-1.1l-1.22,-1.43l-1.5,-0.07l-1.1,-0.44l-0.93,-1.27l-2.27,-0.88l-0.94,-1.63Z",name:"Ukraine"},SE:{path:"M520.76,323.75l2.31,0.87l1.42,-0.61l0.14,-0.52l-1.76,-2.91l2.49,-0.3l0.9,-1.54l-0.49,-1.97l-2.39,-1.12l-1.88,-2.97l-2.08,-1.66l-3.6,-6.12l-1.32,-4.24l-0.51,-0.26l-0.86,0.28l-0.98,-4.47l-1.97,-1.01l-0.41,-4.77l-0.3,-0.35l-1.93,-0.51l-1.22,-2.08l-0.43,-4.6l-1.38,-0.8l-0.89,0.07l0.29,-1.68l-0.86,-7.72l-0.81,-2.41l0.49,-1.42l0.99,-0.13l1.05,0.84l1.08,2.44l1.23,0.55l1.65,-0.68l1.12,-2.03l1.2,-5.71l-1.57,-5.83l2.04,-2.13l1.28,-3.25l0.59,-0.43l2.52,-0.49l1.73,-1.15l2.66,-2.86l0.5,-4.2l0.98,-2.97l-0.5,-2.21l-3.21,-7.03l-0.24,-1.94l1.98,-0.63l2.88,-0.11l0.56,-0.37l1.78,-3.52l0.73,-2.76l-1.76,-2.27l-2.22,-2.02l-1.56,-0.72l-4.24,-2.89l1.8,-9.09l0.16,-2.55l-2.56,-6.53l0.33,-2.72l-0.41,-4.04l1.37,-1.57l0.05,-0.47l-2.85,-5.97l2.76,-4.11l-0.39,-2.32l6.46,-7.29l1.66,-1.21l2.57,-1.06l2.85,-0.52l10.18,1.32l0.91,-0.69l0.88,-1.26l1.06,-1.69l0.15,-2.08l-0.38,-2.85l-0.59,-1.74l-5.55,-2.58l6.02,-7.64l5.01,-8.02l0.94,-7.63l1.16,-3.36l-1.16,-7.19l6.39,-0.83l4.58,-1.92l1.56,-1.27l-0.64,-4.3l1.68,-1.31l4.43,-4.91l7.14,-6.7l0.4,-2.56l-1.05,-2.31l-3.01,-3.81l0.7,-1.43l3.43,-1.05l1.77,-1.7l2.84,-6.35l5.14,-3.08l1.96,-1.6l7.81,3.15l0.47,-0.13l2.84,-3.95l0.73,-1.63l-0.2,-7.55l1.64,-0.55l0.91,-0.15l5.22,1.45l3.88,0.18l11.04,3.05l1.69,0.08l3.69,-2.87l-0.1,-0.68l-2.97,-1.22l1.87,-1.21l2.42,-3.65l0.39,-2.24l-0.15,-1.32l-2.42,-2.49l5.83,-0.32l3.49,1.28l0.41,1.76l3.54,1.83l3.19,2.43l0.7,0.87l7.17,3.99l2.75,1.04l2.32,0.34l5.63,1.69l0.91,0.52l3.19,2.48l1.11,2.74l1.96,0.38l2.08,2.53l2.08,1.38l-1.82,1.61l-0.02,4.22l0.55,1.9l-1.01,2.11l-0.15,1.45l0.57,0.6l3.27,0.52l0.47,1.84l-1.41,1.11l-0.54,0.92l0.17,2.66l0.56,1.56l3.57,4.32l0.53,1.22l-1.21,2.31l-0.38,2.92l-1.22,1.48l-0.86,0.53l-0.43,1.07l-0.12,1.6l0.36,2.86l0.77,1.59l2.15,1.04l1.83,3.4l1.28,3.66l-3.01,0.43l-2.89,-1.0l-1.28,0.49l-5.02,0.43l-1.55,1.09l-2.27,-1.04l-2.3,-1.86l-0.51,0.01l-1.64,1.38l-0.76,0.19l-1.06,-1.24l-1.24,-0.12l-1.65,2.67l-0.35,3.09l-1.94,-0.25l-0.44,0.48l0.14,0.6l0.53,0.47l-2.9,0.43l-0.18,0.93l0.46,0.62l-0.61,0.63l-4.41,0.46l-0.55,0.67l-0.09,0.87l0.3,0.61l0.77,0.46l0.08,0.6l-1.88,-1.4l-0.5,0.08l-0.3,0.57l1.85,2.46l0.35,1.44l-1.93,2.38l-3.11,2.99l-0.85,1.59l0.1,0.49l1.82,1.74l1.54,3.9l1.61,1.71l-0.59,1.44l-2.79,1.72l-3.32,2.76l-3.43,6.64l-1.04,0.81l-2.98,1.11l-1.22,1.15l-2.17,1.25l-4.05,1.19l-1.79,1.56l-0.81,1.54l-0.53,0.07l-2.04,-1.05l-0.54,0.31l-0.16,1.14l-1.25,-0.75l-0.51,0.08l-0.97,1.16l-0.67,1.65l-2.53,2.16l-2.77,-0.4l-0.7,0.56l0.41,0.72l-2.6,0.41l-0.39,0.27l-0.94,2.25l-2.29,0.6l-0.72,0.96l0.32,0.59l2.05,0.13l-0.3,1.29l-2.74,0.93l-1.07,1.24l-0.71,-0.02l0.17,-0.42l-0.38,-0.55l-1.69,0.04l-0.49,-0.91l-0.6,-0.13l-0.37,0.29l0.08,1.31l1.02,2.21l-0.79,1.02l-0.03,0.58l1.47,0.79l-0.87,0.37l-1.41,1.48l-1.42,0.04l-1.13,1.05l-0.71,-0.0l-2.16,-1.18l-0.52,0.21l-0.53,1.86l0.78,2.11l2.2,1.98l-1.12,1.3l-1.84,6.3l0.91,3.42l-2.8,-0.75l-0.53,0.45l0.23,1.26l-1.12,1.82l0.44,2.39l-0.34,1.5l0.79,1.46l-0.42,0.9l0.53,6.73l0.99,2.76l-0.36,2.22l1.62,1.58l3.13,0.25l0.85,1.75l0.4,0.25l1.24,-0.12l2.49,-0.95l0.7,1.43l2.09,2.15l1.35,1.02l1.94,0.48l1.89,1.5l-0.11,2.2l1.01,0.75l2.41,0.77l1.86,2.64l0.72,2.14l-0.21,1.13l-3.27,1.95l-1.93,1.86l-3.29,1.82l-0.78,0.74l-0.61,0.26l-0.88,-0.13l-2.7,1.43l-0.19,0.48l0.54,0.87l2.07,0.26l1.22,-0.32l0.88,-0.73l1.45,-0.01l1.59,-0.76l0.43,0.17l0.48,0.84l-2.58,0.83l-0.54,2.14l-1.03,1.23l-2.47,0.91l-3.56,2.1l-1.06,-0.11l-1.26,0.94l-2.84,1.13l-1.56,1.59l-3.24,1.35l-1.66,1.1l-8.84,-0.19l-1.55,0.56l-0.25,0.42l2.6,0.99l1.39,-0.17l4.0,0.51l1.35,1.35l-3.09,0.88l-0.3,0.52l1.51,4.14l-0.88,1.13l-0.06,4.42l-1.32,0.36l-0.56,1.98l0.4,1.19l0.25,3.77l0.62,1.3l-0.25,1.17l-2.12,3.38l0.05,1.51l0.64,2.28l-2.37,6.77l-1.76,2.26l-0.93,1.78l-2.08,5.31l-1.98,1.63l-2.71,-1.1l-1.67,0.06l-2.41,0.6l-3.73,-0.4l-3.83,0.25l-0.92,0.53l-0.18,0.46l0.43,1.51l-0.8,0.15l-1.56,-0.48l-2.19,1.42l-1.9,1.7l-0.71,1.14l-0.17,2.38l1.76,3.55l-2.0,2.18l-1.06,0.07l-3.83,-0.68l-6.49,1.54l-5.29,-1.1l0.53,-1.06l0.42,-5.2l-0.52,-1.24l-1.43,-1.42l-3.24,-4.83l-1.03,-2.15ZM610.35,291.1l-0.44,1.16l-0.16,-0.02l-0.35,-0.5l0.95,-1.01l0.99,0.04l-0.99,0.33ZM608.6,293.08l-0.69,0.4l-0.58,1.21l-1.9,1.01l-0.31,4.36l1.23,1.47l-1.23,0.69l-1.15,2.25l-2.03,0.82l-0.99,0.77l-1.3,1.61l-0.6,1.99l-1.6,0.85l1.52,-2.4l-0.04,-0.53l-0.96,-0.91l-1.29,-2.5l0.57,-1.33l-0.21,-4.03l3.53,-3.79l1.7,-1.37l2.27,-0.59l0.99,0.53l0.56,-0.21l0.42,-1.14l0.49,-0.18l1.6,1.03ZM602.8,260.19l0.1,-0.33l0.6,-0.21l-0.46,0.3l-0.23,0.24ZM600.15,269.23l0.11,-0.28l0.27,-0.3l-0.36,0.57l-0.02,0.01ZM574.47,322.99l-0.65,0.71l-0.32,-0.99l0.14,-4.77l2.86,-5.75l1.39,-0.63l3.64,-8.06l0.2,-0.26l0.38,0.11l-0.59,0.73l0.06,1.24l-2.27,4.27l-0.62,2.77l-0.83,0.77l-3.37,9.86Z",name:"Sweden"},AT:{path:"M481.24,489.9l0.13,-0.58l-1.06,-2.68l1.05,-2.02l0.09,-1.67l1.32,-0.27l0.2,-0.84l3.5,1.6l0.51,1.42l1.54,0.43l-0.16,1.17l0.45,0.42l1.9,-0.64l0.89,-1.0l0.56,-1.07l0.32,-1.9l2.68,-0.0l2.56,0.45l1.56,1.96l1.23,0.23l3.45,-0.54l1.5,-1.13l4.2,-1.6l6.32,-0.62l0.56,-0.68l-0.02,-0.91l1.71,0.39l1.72,0.89l2.72,-0.54l0.93,0.41l0.03,1.0l0.54,0.69l2.21,1.18l0.81,-0.01l0.6,-0.84l0.29,-2.75l-0.54,-1.0l-1.45,-0.25l0.66,-1.25l-0.01,-1.43l-2.62,-3.34l0.61,-1.04l3.51,-1.91l3.25,-0.97l0.81,-0.58l0.62,-0.8l0.73,-2.89l2.33,0.93l1.08,-0.42l0.94,-0.96l0.25,-2.75l1.82,1.08l1.04,1.69l1.99,0.43l2.41,0.04l1.64,-0.85l2.7,0.45l0.45,-0.33l0.19,-1.16l1.34,-1.55l1.2,0.04l0.39,-0.27l0.74,-3.74l0.73,0.04l1.42,0.91l2.0,-0.47l5.16,1.96l1.7,-0.05l3.21,1.91l4.25,0.28l1.59,-1.06l5.12,1.61l0.79,1.59l-1.13,2.46l0.03,1.3l1.48,3.33l1.49,2.65l0.58,0.5l-0.55,0.63l-0.13,0.95l-0.66,1.21l0.38,2.0l-3.35,0.39l-2.64,-1.21l-0.78,0.17l-1.67,1.19l-0.17,0.52l0.4,0.53l2.63,0.76l0.36,0.9l-0.61,1.28l-2.51,1.02l0.22,2.14l-0.57,1.05l0.29,1.33l0.71,0.37l-0.38,1.52l-1.55,0.13l-1.08,0.52l-3.02,2.24l-0.95,1.05l-0.06,1.65l-2.43,-0.52l-1.83,0.22l-2.62,1.17l-3.01,-0.22l-4.42,0.64l-0.86,0.49l-1.18,1.41l-2.58,1.56l-9.66,-1.84l-4.61,-0.75l-4.38,-0.3l-9.29,-1.69l-1.1,-0.46l-3.08,-3.86l-0.22,-0.59l0.9,-1.44l-0.7,-0.65l-5.54,1.63l-3.29,-0.2l-4.01,0.41l-1.66,0.81l-1.47,2.36l-1.02,0.33l-2.05,-0.36l-1.13,-0.95l-2.83,-0.17l-0.56,-1.63l-1.1,-0.55l-3.07,2.23l-3.13,-1.32l-0.64,-1.3l-3.07,-0.87Z",name:"Austria"}},height:790.3360148034734,projection:{type:"mill",centralMeridian:11.5},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","fr_mill",{insets:[{width:100,top:600,height:122.71220181016422,bbox:[{y:-640515.9263248637,x:-6082830.163693012},{y:-235112.28629661424,x:-5752460.702426716}],left:0},{width:50,top:440,height:42.928059423707,bbox:[{y:-1855676.1027106678,x:-6882793.3793751765},{y:-1778355.8860469644,x:-6792735.480530344}],left:0},{width:50,top:510,height:57.21127928831266,bbox:[{y:-1668974.3969949444,x:-6819419.302373176},{y:-1615651.747314515,x:-6772817.783980524}],left:0},{width:50,top:700,height:42.31095479952366,bbox:[{y:2357030.8412201093,x:6150785.273719754},{y:2416319.6251247157,x:6220848.433704593}],left:740},{width:40,top:690,height:55.96611426730096,bbox:[{y:1415975.8044653006,x:5016650.333473452},{y:1454680.1669724442,x:5044313.045465417}],left:640},{width:900,top:0,height:749.2159980728637,bbox:[{y:-6244653.662562441,x:-571670.6975907331},{y:-4882430.695155527,x:1064707.428102987}],left:0}],paths:{"FR-28":{path:"M407.07,246.39l-2.7,-0.64l-6.08,2.98l-1.29,0.33l-1.3,-0.03l-4.61,-1.88l-2.65,0.56l-2.46,-3.3l-2.56,-2.35l-1.46,-1.98l-0.99,-0.54l-2.75,-0.62l-0.56,-2.81l-0.76,-0.98l-0.97,-0.09l-2.55,1.38l-1.99,0.58l-3.85,0.17l-1.75,0.55l4.24,-2.29l0.59,-0.56l0.14,-0.72l-1.12,-1.06l-3.14,-0.41l-2.36,-1.54l1.12,-0.96l0.25,-1.0l-1.86,-3.44l0.03,-2.94l-1.33,-1.67l0.61,-1.35l2.29,-0.4l5.6,-2.3l2.13,-1.95l0.67,-1.64l1.22,-1.8l-0.16,-0.83l-1.74,-2.11l0.08,-3.7l-3.65,-3.73l-2.55,-1.62l-1.61,-2.81l-0.36,-3.23l1.82,-1.67l1.34,-0.77l5.76,-1.41l2.04,-0.07l0.74,-0.36l1.7,-2.02l3.48,-0.35l0.63,-0.53l0.22,-1.53l3.0,1.67l3.49,-0.02l1.93,0.63l4.71,-2.07l1.42,-1.16l0.69,-1.87l0.95,-1.4l1.34,-1.03l2.49,-1.16l1.05,-1.01l0.26,-1.64l-0.52,-1.68l0.12,-0.44l2.22,-1.39l3.12,5.29l1.41,1.78l0.26,1.59l-0.56,2.83l0.31,1.68l0.56,0.67l1.6,0.81l-0.36,1.11l-1.35,1.63l-0.2,0.71l0.26,0.98l1.48,0.99l0.55,1.38l1.5,1.71l3.83,2.4l0.73,2.38l2.38,1.58l0.52,0.67l0.38,1.69l-0.03,2.29l1.38,2.04l1.1,0.79l4.59,1.88l2.43,-0.21l0.24,2.38l2.15,2.42l0.66,2.91l0.56,0.84l1.29,0.92l-1.7,2.02l0.05,0.99l0.8,0.61l-1.24,2.16l0.67,3.68l-0.27,0.93l-0.37,0.49l-2.85,1.06l-1.77,4.01l-0.98,1.3l-1.0,0.81l-1.08,0.27l-1.41,-0.35l-1.39,0.17l-3.64,1.38l-3.25,-0.59l-1.79,0.16l-1.29,0.78l-1.79,2.16l-0.7,0.16l-1.79,-0.73l-1.17,0.14l-1.18,0.96l-0.45,1.05l0.17,2.31Z",name:"Eure-et-Loir"},"FR-29":{path:"M25.63,242.25l0.98,-1.98l0.98,0.49l19.62,-3.77l3.65,0.88l0.91,-0.32l0.5,-0.76l0.62,-2.51l-0.36,-1.04l-0.81,-0.89l-0.58,-2.39l-1.01,-0.81l-2.92,-0.69l-0.66,-1.14l-0.5,-0.27l-1.37,0.44l-3.11,-1.71l-2.01,0.46l-2.96,4.7l-0.73,0.21l0.57,-1.39l-1.14,-2.33l0.91,-1.36l-0.39,-1.22l-1.09,-0.38l-3.21,-0.11l-0.03,-1.0l1.84,0.17l0.95,-0.24l0.41,-0.81l-0.22,-0.93l0.98,-2.21l0.53,-0.43l0.46,0.19l-0.71,2.55l0.23,0.48l1.87,0.72l5.36,-0.32l1.36,0.83l1.04,0.18l3.66,-0.78l2.04,-0.12l0.21,0.35l1.46,0.44l5.01,-0.91l0.33,-0.98l-0.42,-0.4l-1.83,0.11l-0.45,-0.19l-0.2,-0.74l-0.68,-0.16l-1.09,0.67l-1.22,-1.03l-2.07,0.18l0.59,-0.25l0.44,-0.73l1.79,-1.5l0.1,-0.44l-0.38,-0.25l-1.24,0.08l-1.29,0.8l0.0,-0.47l-0.85,-0.4l-0.96,1.04l-0.96,-0.2l-1.87,1.11l-0.5,0.08l-0.43,-0.77l-0.56,-0.05l-1.09,0.68l-1.02,0.2l3.24,-3.36l6.46,-3.39l0.19,-0.5l-0.47,-0.25l-4.22,1.6l-4.19,0.6l-5.77,2.77l-2.94,0.62l-1.85,0.8l-1.08,0.12l-4.35,-1.11l-0.58,0.4l-0.15,1.12l-0.27,0.13l-3.57,-0.23l-0.68,-1.74l0.68,-0.06l0.36,-0.44l-0.1,-1.01l-1.05,-2.18l-0.09,-1.34l0.28,-1.34l0.6,-0.89l1.01,-0.27l0.3,-0.88l-1.49,-1.16l0.52,-1.93l2.34,-3.42l1.07,0.45l0.46,-0.14l-0.19,-0.71l0.54,-0.32l2.86,-0.47l3.08,1.22l1.04,-0.16l0.21,-0.65l-1.67,-2.31l0.37,-0.22l2.65,0.59l1.24,-0.03l0.38,-0.34l-0.26,-0.44l-1.23,-0.43l0.07,-0.55l-0.35,-0.44l4.17,-0.0l3.43,-1.04l1.35,-0.03l0.38,-0.31l-0.2,-0.45l-0.86,-0.45l1.38,-0.23l3.24,-1.36l1.36,0.05l0.84,0.86l-0.39,1.52l0.42,0.5l1.58,-0.18l2.35,-1.07l2.95,0.58l0.4,-0.4l0.0,-0.59l-1.04,-0.57l0.11,-0.28l1.91,-1.43l2.45,-0.6l1.27,0.07l1.03,0.52l0.71,-0.39l0.36,0.69l0.75,0.24l1.01,-1.05l-0.02,-1.18l4.45,-1.51l-0.24,1.62l0.55,0.4l-0.25,0.84l1.04,1.07l-0.07,1.9l0.48,-0.03l1.68,-1.43l0.9,-0.29l-0.28,0.38l0.1,0.75l3.35,2.74l0.61,-0.01l0.45,-0.54l-0.24,-0.79l0.28,-0.74l-0.54,-1.41l0.79,0.35l0.21,-0.4l0.01,-2.72l0.24,-0.43l0.93,0.16l0.45,-0.85l1.48,0.59l2.89,-0.11l2.82,1.61l2.57,-0.38l0.01,5.63l0.41,1.35l3.32,3.92l0.57,1.55l-0.36,1.83l-1.33,2.12l-0.1,1.26l0.52,0.77l1.4,0.36l0.66,0.75l0.01,0.67l-0.6,1.06l-1.9,0.16l-0.76,0.41l-0.39,1.02l0.05,1.22l2.94,1.69l0.6,2.77l2.0,4.19l-0.39,1.62l-1.49,2.95l0.56,2.13l-9.89,3.86l-1.13,1.08l-0.47,1.46l0.1,1.1l3.11,3.22l2.08,5.24l1.33,1.07l3.63,-0.54l1.28,0.09l3.08,1.88l1.56,0.51l3.03,-0.58l0.9,0.18l0.66,0.71l0.41,1.48l-0.28,3.56l-0.88,1.31l-1.5,-0.11l-0.95,0.28l-0.67,0.77l-0.51,1.32l-0.62,0.5l-0.54,0.09l-1.97,-0.83l-1.48,0.68l-0.82,2.17l0.47,2.09l-2.3,-0.46l-2.06,0.0l-1.6,-1.08l-2.25,0.1l-0.95,-0.29l-0.44,-0.91l-0.74,-0.41l-3.29,1.44l-0.96,-0.68l-3.48,0.2l-1.22,-1.97l-0.89,-0.77l0.11,-1.0l-0.37,-0.51l-1.34,-0.44l-0.26,-0.87l-1.15,-1.13l-1.72,-1.0l-1.75,-0.32l-0.44,0.53l0.51,1.46l-0.36,0.96l-0.24,0.22l-0.49,-0.49l-1.37,0.27l-0.79,0.62l-1.44,-1.0l-2.43,-0.67l-0.69,-0.82l-1.04,-2.67l-0.42,0.16l-0.7,1.27l0.43,1.31l1.4,1.55l-1.0,0.23l-0.97,0.66l-0.91,-1.34l-1.28,0.04l-0.48,1.28l0.73,0.75l-0.22,0.89l0.4,0.4l1.27,0.0l-1.81,1.5l-2.27,0.79l-8.52,-0.35l-0.07,-1.48l1.2,-0.18l0.52,-0.76l-0.21,-1.72l-1.54,-4.18l-0.96,-1.47l-2.99,-3.31l-6.1,-3.99l-1.18,0.45l-1.3,1.04l-1.84,-1.46l-3.15,-0.06l-3.8,-0.92ZM1.37,208.95l2.5,-0.92l1.47,0.95l-2.48,1.11l-0.61,-1.01l-0.88,-0.14Z",name:"Finist\xe8re"},"FR-22":{path:"M104.04,181.46l-0.28,0.54l0.32,0.6l2.41,-0.01l1.55,-1.18l5.84,-2.09l1.17,0.0l1.67,-1.78l0.55,0.11l0.3,0.85l-0.03,1.41l-0.4,1.28l-0.83,1.08l0.5,1.21l0.41,0.18l0.97,-1.9l1.78,-1.89l1.89,-1.51l0.81,0.06l1.06,-1.09l0.51,-0.13l0.85,0.83l-0.4,1.97l0.68,0.68l-1.05,2.42l-1.65,2.02l-0.1,0.85l0.4,0.4l0.8,-0.2l3.03,-4.81l0.76,0.15l1.33,-0.56l0.67,0.24l-0.02,0.75l-1.71,1.0l-0.01,1.15l2.48,1.16l4.01,0.41l0.01,1.2l-0.8,0.72l0.21,0.84l1.94,1.27l1.37,1.73l3.87,2.85l0.88,3.1l-0.26,0.69l0.22,0.77l2.78,1.74l3.18,1.32l-1.16,1.99l1.46,0.52l1.88,1.65l0.62,-0.24l0.25,-2.13l2.16,0.1l1.16,-0.4l3.22,-3.61l5.89,-2.95l0.99,-1.12l0.0,-0.53l-0.84,-0.45l1.49,-0.39l1.05,0.13l0.44,0.89l0.49,0.2l3.51,-1.61l2.1,-2.09l0.67,0.82l1.02,0.23l-1.01,1.46l-1.68,1.58l0.05,0.62l1.51,0.76l3.43,-2.2l0.62,2.37l0.78,0.42l0.63,2.14l0.57,0.3l1.25,-1.02l0.75,0.88l1.35,-0.4l0.22,-0.89l-0.64,-0.57l0.93,-0.86l1.16,0.66l0.55,-0.01l0.02,-0.55l-1.01,-1.64l2.26,-0.68l2.61,-0.22l1.31,2.11l0.42,1.64l1.16,0.92l-0.26,1.06l1.54,2.0l0.32,0.9l-0.23,1.64l0.21,0.41l2.88,-1.61l-0.12,-0.77l0.31,-0.32l1.0,3.2l0.07,0.98l-0.5,1.15l-1.56,2.03l-0.55,1.44l1.21,5.85l-0.19,0.43l-1.6,0.61l-0.26,0.89l0.25,2.37l-1.06,1.3l-1.44,-0.16l-1.87,-0.79l-1.86,-0.12l-1.43,0.93l-1.63,1.7l-2.5,0.01l-0.83,0.43l-0.6,0.93l-0.51,1.8l-1.36,0.88l-0.58,0.89l-0.84,2.78l-3.24,2.24l-1.18,0.08l-1.98,1.13l-1.07,-0.2l-1.02,-1.98l-0.71,-0.74l-2.2,-0.9l-5.18,0.18l-1.12,0.38l-0.78,1.34l-0.32,3.61l-0.63,1.03l-3.24,2.8l-1.93,1.02l-0.89,-0.31l0.03,-6.22l-1.02,-0.8l-3.85,1.09l-2.18,1.62l-1.52,-2.73l-1.06,-0.54l-2.3,-0.42l-4.05,-2.12l-1.96,-0.25l-3.07,0.85l-0.87,-2.72l-1.63,-0.71l-3.91,-0.25l-1.45,0.38l-0.67,0.79l-0.52,1.85l-0.51,0.69l-0.75,0.34l-7.76,0.9l-1.49,-0.44l-1.57,-1.45l-4.69,1.36l-0.71,-0.6l-0.17,-1.41l-0.94,-0.58l-6.12,0.21l0.62,-0.67l-0.63,-2.09l1.45,-2.84l0.43,-1.94l-0.2,-0.94l-1.84,-3.43l-0.68,-2.96l-1.07,-0.87l-1.75,-0.64l0.16,-1.46l2.41,-0.37l0.67,-0.68l0.36,-1.88l-0.59,-1.08l-1.99,-0.83l0.03,-0.79l1.74,-3.13l0.01,-1.29l-0.67,-1.83l-3.26,-3.8l-0.36,-1.12l-0.02,-4.22l2.89,0.27l1.04,-0.44l0.21,-0.49l-0.71,-3.08l2.98,-0.46l0.33,-0.33l-3.03,-3.0l-0.19,-0.98l2.29,-1.26l1.58,-2.51l0.68,0.39l1.86,0.1l2.17,1.06Z",name:"C\xf4tes-d'Armor"},"FR-23":{path:"M407.84,404.16l2.43,-1.5l1.15,-1.7l-0.27,-0.62l-1.4,-0.23l-1.46,-5.31l-2.08,-1.27l-0.26,-0.59l0.44,-2.8l-0.54,-1.42l-1.49,-1.67l-3.65,-1.46l-0.95,-1.46l-0.08,-1.94l3.24,-5.87l0.11,-1.78l-1.22,-1.12l1.46,-0.82l3.93,-3.54l0.68,-0.15l2.17,0.53l2.02,-0.06l0.36,1.35l0.7,0.52l1.01,0.19l1.02,-0.2l1.87,-1.33l3.01,0.41l0.9,-0.2l1.03,-0.98l0.25,-2.59l0.71,-0.54l0.76,0.32l1.92,1.93l0.96,0.16l2.07,-1.12l1.08,-0.24l5.41,0.14l2.45,0.84l3.5,0.01l2.22,0.72l3.19,-0.59l5.83,0.29l2.01,2.5l1.67,1.44l0.91,2.78l0.59,0.64l0.74,0.43l2.88,0.63l0.67,0.63l1.08,2.07l0.77,0.02l0.86,-0.61l0.63,0.2l3.01,4.0l1.01,3.07l2.11,3.67l-0.39,3.35l0.22,1.7l2.06,4.03l-0.15,3.39l-1.62,1.78l-1.56,3.24l-2.36,2.46l-2.3,0.1l-4.07,3.26l0.03,1.36l1.66,2.11l0.73,2.07l0.5,0.47l1.47,0.35l0.87,0.8l-1.59,1.22l-1.28,0.53l-4.46,-0.26l-0.54,0.33l-1.09,1.7l-2.01,0.86l-0.63,-0.08l-6.99,-3.85l-4.38,-0.7l-1.8,-1.52l-1.17,-0.47l-1.17,0.08l-1.19,0.61l-1.14,1.13l-1.47,2.58l-3.43,0.58l-1.46,-0.05l-1.05,-0.8l0.64,-1.91l0.16,-2.73l-1.27,-1.93l-4.16,-1.9l-1.02,-0.88l-1.0,-1.64l-0.86,-0.45l-1.58,-0.05l-4.36,1.16l-1.89,-0.21l-0.58,-1.04l0.41,-3.19l-0.67,-1.02l-1.19,-0.57l-3.98,-0.11l-0.45,-0.43l0.14,-1.22Z",name:"Creuse"},"FR-21":{path:"M575.96,257.27l0.42,-2.75l1.05,-2.73l2.12,-1.57l13.22,-1.52l1.29,-0.82l0.21,-1.86l1.09,-0.89l1.41,-0.3l3.05,0.51l2.38,-0.98l2.0,1.2l4.19,1.0l-0.48,1.26l0.41,0.79l2.84,0.99l0.59,0.52l-1.02,1.96l0.47,1.65l1.15,0.43l0.67,-0.37l0.54,-0.83l0.47,-0.03l4.35,5.21l1.1,2.15l0.05,1.03l-2.6,0.55l-0.58,0.46l-0.24,0.88l1.41,1.97l0.59,3.57l0.48,0.95l0.76,0.58l1.41,0.03l1.38,-1.3l0.41,0.07l2.15,2.8l2.67,1.55l2.02,-0.25l1.44,-1.65l0.75,-0.28l0.64,1.53l0.67,0.7l3.65,2.12l0.68,2.08l0.72,0.4l0.98,-0.16l2.08,-1.37l1.56,1.15l0.73,-0.29l0.57,-0.7l2.12,0.66l1.85,-1.62l1.32,0.46l0.47,0.78l-0.15,1.58l0.96,1.46l0.24,1.5l-2.04,2.72l-2.41,0.69l-0.46,0.6l-0.51,2.35l0.56,0.82l2.03,0.82l0.58,3.42l0.55,0.75l1.63,1.12l0.52,4.8l1.07,1.44l-1.39,4.41l-0.25,2.08l-0.45,0.8l-5.64,7.93l-5.33,2.53l-0.45,1.23l0.54,1.75l-0.09,0.77l-3.17,1.8l-1.27,-0.38l-1.39,0.38l-2.65,1.37l-5.08,0.22l-1.89,-1.56l-3.71,0.97l-5.06,0.51l-7.43,2.91l-3.36,0.22l-1.48,1.18l-1.07,0.3l-0.64,-0.34l-1.05,-2.42l-3.56,-1.1l-0.91,-0.86l-1.77,-3.81l-0.5,-0.46l-2.63,0.05l-3.91,-1.17l-2.82,-2.95l-2.6,0.5l-1.77,-2.91l-3.29,-1.19l-2.43,-2.51l-1.01,-0.28l0.09,-1.16l0.73,-1.82l-0.33,-1.87l-0.83,-1.33l-1.12,-0.8l-3.77,-0.35l-0.09,-5.37l-1.07,-1.4l-0.27,-2.24l-0.42,-0.68l-0.93,-0.37l-0.88,-2.41l0.48,-0.93l1.77,-0.82l0.87,-1.18l0.15,-3.95l0.39,-0.79l1.06,-0.69l3.61,-5.79l1.07,-2.54l1.57,-1.87l0.79,-2.55l0.09,-3.43l4.19,-1.97l0.84,-1.26l-0.19,-1.71l-1.61,-4.02l-1.03,-0.48l-1.89,0.05Z",name:"C\xf4te-d'Or"},"FR-26":{path:"M609.51,454.85l0.02,-0.57l3.87,-0.36l5.44,-2.98l1.85,-0.05l0.97,1.55l1.89,0.16l1.14,1.78l0.99,0.77l2.55,0.12l-0.44,2.43l0.54,0.44l2.01,-0.78l0.58,1.1l0.15,2.45l0.87,4.09l-1.17,3.72l0.41,1.63l0.58,0.24l0.72,-0.4l2.23,0.09l0.9,1.68l3.94,0.49l1.79,-0.37l0.3,0.76l0.53,0.35l2.46,0.05l4.23,-2.52l0.98,-0.04l-0.68,1.52l0.16,1.34l1.19,3.22l-0.69,2.72l0.01,2.73l-1.34,7.85l0.13,1.72l1.13,1.08l4.47,1.24l0.51,-0.39l-0.02,-1.07l0.46,0.2l5.46,4.76l7.39,1.17l2.2,-0.2l0.89,0.97l-0.25,1.02l-1.71,1.52l-4.17,1.0l-3.09,-0.29l-1.24,0.51l-0.43,1.87l-2.53,3.81l-0.14,0.94l0.84,1.52l2.0,1.4l0.28,0.97l-0.33,0.33l-3.19,1.81l-4.23,-1.27l-3.35,-0.13l-0.63,0.63l0.07,1.69l0.63,1.09l1.24,0.83l0.0,0.57l-0.98,0.17l-2.3,-0.43l-1.08,0.62l-0.06,0.66l1.42,1.81l0.6,1.94l2.39,1.76l4.27,1.43l3.69,-0.02l-0.41,1.18l0.12,0.71l1.56,1.75l2.09,1.43l-0.14,4.66l-0.66,1.16l0.12,1.87l-0.76,-0.17l-0.63,-1.31l-0.81,-0.55l-1.74,-0.29l-0.98,0.29l-3.26,3.17l-1.73,0.96l-1.95,-0.21l-4.26,-2.77l-0.76,-2.13l-1.01,-1.15l-2.12,-0.25l-4.34,-1.4l-2.82,0.21l-2.6,-0.66l-0.67,-0.77l-0.1,-1.5l0.78,-2.2l-0.29,-0.88l-0.62,-0.28l-2.47,1.42l-4.48,-0.52l-4.27,1.08l-3.5,1.47l-2.77,0.41l-2.98,1.5l-1.01,-0.71l-1.74,-4.11l-1.5,-1.39l-1.0,-0.49l-1.77,-0.25l-3.2,0.13l0.91,-6.09l-0.09,-0.98l1.91,-3.48l1.11,-7.45l1.1,-2.37l3.09,-4.1l0.42,-3.02l-1.45,-3.45l-0.09,-2.65l0.96,-1.96l2.09,-1.76l0.57,-1.55l1.89,-1.85l1.93,-5.75l-0.42,-1.5l-1.76,-2.74l-0.36,-1.32l0.45,-3.31l-1.04,-1.77l0.19,-0.82l-0.19,-0.44l-1.15,-0.66l0.27,-3.41l-0.8,-2.96l-0.1,-4.66l0.26,-1.41l-0.36,-0.43ZM619.51,528.65l1.54,-0.89l1.27,-2.18l1.36,-1.26l0.07,-0.97l-0.77,-1.43l-2.49,-2.28l-2.0,-0.54l-1.01,0.36l-0.89,0.76l-3.05,4.55l-0.55,2.1l0.5,1.33l0.7,0.43l5.31,0.04Z",name:"Dr\xf4me"},"FR-27":{path:"M332.92,132.9l6.85,-1.33l2.9,-1.27l2.43,-2.0l2.13,1.51l2.15,2.4l1.37,0.48l2.33,-0.41l1.96,2.85l2.96,0.4l5.7,-1.35l0.69,0.25l2.91,2.44l2.44,1.07l0.61,0.63l0.04,1.17l-3.24,-0.47l-0.43,0.53l1.04,2.61l1.94,1.1l2.11,0.61l3.9,2.82l1.33,0.19l1.52,-0.46l0.26,-0.51l-0.39,-1.15l0.41,-0.82l0.89,-0.65l4.02,-0.98l0.71,-0.53l0.82,-1.31l1.09,-0.77l1.27,-0.37l4.38,0.27l1.04,-0.64l2.79,-5.08l1.55,-1.8l2.41,-0.87l8.83,1.1l8.42,3.24l2.29,-0.78l0.17,1.85l1.76,5.64l1.98,4.52l-0.91,-0.06l-0.81,-0.99l-1.21,-0.74l-0.85,0.03l-0.88,0.48l-0.92,1.37l0.38,1.6l-1.77,3.08l-2.9,8.4l-2.17,1.01l-7.75,1.57l-0.75,0.55l-0.17,1.05l0.69,1.52l-0.24,2.26l0.57,0.74l1.67,0.42l0.21,2.28l-2.16,1.15l-0.44,0.6l-0.21,0.94l0.52,1.61l-0.14,1.15l-0.79,0.76l-2.47,1.15l-1.51,1.17l-1.09,1.61l-0.67,1.82l-0.53,0.5l-4.94,2.31l-1.82,-0.62l-3.38,0.04l-2.24,-1.49l-1.25,-0.15l-0.48,0.48l-0.06,1.17l-0.31,0.42l-3.47,0.34l-2.42,2.37l-1.92,0.04l-5.91,1.45l-1.53,0.88l-1.84,1.69l-2.56,-0.94l-1.25,-1.56l-1.01,-0.49l1.29,-1.62l0.54,-1.51l-1.16,-2.36l-1.26,-0.82l-2.33,-0.57l-1.49,-0.86l-2.76,-3.3l-0.98,-2.3l-0.73,-0.39l-0.92,0.06l-2.15,0.77l-4.68,-1.11l-2.05,0.04l-1.51,-1.08l-0.27,-0.99l1.87,-3.64l0.25,-4.05l-0.86,-1.45l-2.12,-1.54l-0.49,-1.34l0.35,-0.36l1.57,0.06l0.59,-0.55l-0.39,-2.41l0.87,-2.03l-1.68,-3.19l-0.73,-2.11l-2.48,-2.25l-0.45,-0.94l0.06,-0.6l2.03,-0.96l0.42,-0.91l-0.82,-1.2l-2.45,-0.56l-1.1,-1.77l-0.07,-6.22l-0.51,-3.02Z",name:"Eure"},"FR-24":{path:"M314.48,486.38l2.21,-3.24l-0.09,-0.97l-1.46,-1.8l0.11,-0.89l1.91,-2.6l-0.01,-1.78l1.7,-3.57l-0.17,-1.51l-1.03,-2.19l-1.3,-0.94l-3.17,0.0l1.56,-1.93l0.02,-0.71l-0.65,-1.26l0.58,-0.84l4.32,-2.1l0.99,-0.15l2.1,0.65l1.19,-0.32l1.22,-1.11l0.8,-1.83l2.77,-1.19l1.9,-1.66l0.55,-1.77l-0.03,-3.99l0.77,-2.85l0.66,-1.26l6.52,-4.29l1.11,-0.35l0.88,0.11l0.87,-0.54l4.41,-6.14l0.49,-1.81l0.23,-3.15l0.79,-0.39l1.26,-0.03l0.77,-0.51l2.26,-3.05l1.88,-1.54l1.09,0.73l4.71,0.47l2.19,2.61l-0.7,2.48l0.06,0.82l1.7,1.06l2.04,0.48l1.19,-0.1l0.81,-0.34l1.25,-1.36l1.25,0.8l3.25,-0.49l4.3,0.25l3.95,4.87l1.43,0.54l2.5,0.33l0.6,0.42l-0.17,0.68l-1.67,1.44l-0.1,0.87l0.38,0.6l4.23,2.02l1.93,-0.26l1.79,1.23l1.56,0.22l-0.04,0.74l-1.01,1.7l0.11,1.19l0.83,0.73l2.37,-0.06l-0.41,1.14l-1.53,0.87l-2.43,2.37l-0.63,3.22l0.4,0.65l1.93,1.39l-0.41,0.68l-1.65,1.24l-0.56,1.57l0.46,0.73l2.59,0.41l0.07,0.86l-0.73,1.62l0.87,1.3l2.81,1.17l3.51,-0.14l0.38,0.23l-0.49,2.38l0.26,0.87l1.61,2.88l1.96,2.11l-1.43,0.93l-0.47,1.47l1.31,4.0l-0.03,0.72l-0.72,1.24l0.17,1.64l-2.71,2.63l-1.66,2.62l-2.23,0.65l-0.87,1.1l-0.29,0.94l0.72,1.44l-0.03,0.57l-1.25,1.78l-4.31,2.66l-2.26,0.48l-1.02,0.79l-3.42,5.27l-2.22,1.89l-1.15,-1.69l-2.43,-1.73l-2.96,-1.21l-2.23,0.1l-3.98,2.49l-1.65,0.12l-1.09,-1.41l1.15,-1.09l0.19,-1.6l-0.74,-1.47l-1.44,-1.06l-1.33,-0.13l-3.49,1.12l-2.89,0.24l-1.12,-0.4l-0.76,-1.1l-0.75,-0.43l-2.73,-0.11l-0.98,0.27l-1.66,2.01l-0.66,0.39l-1.74,-0.76l-0.88,-0.04l-4.01,2.01l-1.21,0.29l-2.31,-0.83l-1.43,-2.24l-1.35,-2.99l-2.8,-3.51l-0.48,-1.07l-0.54,-2.25l1.77,-0.61l1.64,-1.81l-0.08,-0.54l-0.82,-0.74l-4.83,-1.21l-0.43,0.55l0.31,0.75l-2.6,2.49l-0.96,0.33l-8.53,-1.0l-2.05,-1.71Z",name:"Dordogne"},"FR-25":{path:"M688.99,356.49l-3.01,-2.44l-0.3,-1.03l2.61,-2.75l-0.18,-0.94l-0.68,-1.03l-0.01,-0.89l6.56,-4.56l0.94,-1.19l-0.07,-0.55l-7.63,-6.19l-3.48,-0.87l-1.8,-2.69l-0.2,-3.0l-0.41,-1.24l-1.38,-2.14l-0.82,-0.72l-2.31,-1.03l-4.64,-0.91l-2.02,-1.7l-1.1,0.17l-1.14,1.02l-0.84,-0.15l-0.19,-0.71l0.21,-0.42l1.01,-0.87l0.65,-1.18l-0.05,-2.0l1.71,-1.85l0.57,-1.45l0.03,-0.97l-2.12,-3.71l-3.5,-2.24l-1.18,-2.95l1.46,-0.01l11.91,-6.07l4.21,0.52l4.83,-1.49l2.98,-2.96l1.96,0.09l1.28,-0.46l1.15,-1.98l0.7,-0.56l2.48,0.3l1.02,-0.19l1.05,-0.99l1.87,-4.02l1.59,-0.97l6.12,-0.77l2.06,1.6l0.7,-0.11l1.02,-0.95l3.1,1.45l1.21,-0.84l1.11,-2.3l0.58,-0.55l2.31,0.4l2.04,-1.31l2.08,-0.58l4.57,1.14l1.75,-1.38l1.11,1.02l2.86,-0.39l1.23,0.06l0.74,0.46l0.78,1.52l-0.56,1.79l0.03,0.89l1.44,4.33l-0.72,0.44l-0.08,1.24l-1.37,0.7l-1.06,1.16l-1.11,2.3l0.42,0.52l7.29,-0.62l1.04,-0.41l2.04,1.73l-0.29,0.52l-1.73,0.73l-0.94,1.05l-0.92,0.22l-1.15,1.02l-0.52,1.79l0.21,1.82l-4.0,2.53l-1.78,1.58l-1.19,1.68l-3.91,3.12l-1.76,0.53l-0.28,0.41l0.06,1.05l-0.9,0.44l-0.31,0.51l-1.37,0.42l-0.72,0.57l-0.9,1.31l0.59,1.61l-1.2,1.49l-3.98,2.62l-6.53,1.77l-3.04,1.51l-1.11,2.94l1.07,2.32l0.08,1.66l-1.81,4.3l0.94,1.51l-0.16,1.55l-1.18,1.03l-2.12,1.0l-2.15,1.96l-4.43,2.12l-8.29,6.58l-0.82,0.93l0.08,1.25Z",name:"Doubs"},"FR-MQ":{path:"M29.58,521.59l2.04,4.09l0.61,0.13l1.69,-1.37l2.35,-1.15l2.71,-0.7l1.66,-0.01l-1.1,1.0l0.15,0.92l-1.99,2.03l-1.17,-1.91l-0.57,-0.12l-1.08,0.91l-0.34,2.42l0.25,2.72l0.56,0.33l1.58,-0.37l0.87,0.65l-2.81,1.51l-0.09,0.63l0.51,0.51l-0.97,0.5l-0.21,0.44l0.48,1.35l1.03,0.35l0.45,-0.14l0.84,-1.13l2.53,1.1l-1.26,0.61l-0.22,0.52l0.83,1.98l1.01,1.02l2.32,1.31l0.92,2.1l2.03,0.78l0.32,0.71l-0.03,1.98l0.6,0.39l0.71,-0.41l-0.25,2.4l0.41,1.46l0.77,1.07l-1.35,1.57l0.15,0.59l1.42,0.69l1.69,5.35l-1.43,0.75l-1.43,3.51l-1.14,1.51l-1.19,0.51l-1.52,0.14l-1.15,-0.51l-0.42,-1.43l0.56,-0.96l1.27,-0.41l1.36,-0.96l0.05,-2.11l-1.15,-1.71l-0.48,-0.15l-3.49,1.8l-1.39,-0.1l0.06,-0.84l-0.32,-0.42l-0.79,-0.15l-3.38,0.55l-6.91,-0.91l-2.07,0.3l-2.92,1.18l-1.59,0.24l-0.81,-0.46l-2.5,-3.48l-0.12,-1.4l-1.35,-0.99l2.86,-2.99l3.07,-1.49l0.78,-0.71l1.21,1.62l2.11,0.55l1.94,-0.83l0.87,-2.13l-2.15,-3.7l-0.25,-2.0l-0.53,-0.33l-3.16,0.87l-5.49,-0.02l-1.6,-2.4l-4.32,-2.94l-2.07,-1.98l-1.24,-3.51l-1.31,-1.93l0.78,-2.27l-0.31,-1.75l-1.64,-2.67l-3.41,-3.56l-0.79,-1.4l-0.29,-1.59l0.29,-1.51l0.74,-1.23l0.98,-0.9l4.61,-2.61l4.02,-0.06l3.94,1.27l5.23,3.33l4.71,2.09l1.84,1.19l1.36,2.81l1.45,0.5Z",name:"Martinique"},"FR-94":{path:"M466.21,178.65l2.11,0.61l2.35,1.33l2.16,1.85l0.38,4.44l-0.29,1.33l-1.36,1.9l-0.03,0.91l-1.22,-0.15l-1.91,-2.76l-1.06,-0.43l-6.59,0.94l-0.95,-0.2l-1.79,-1.39l-1.1,-0.45l-0.05,-2.34l0.67,-2.35l6.74,0.05l1.04,-0.63l0.91,-2.65Z",name:"Val-de-Marne"},"FR-93":{path:"M472.66,181.23l-1.56,-1.32l-2.43,-1.37l-5.3,-1.53l-2.33,-2.22l-1.05,-0.36l-5.61,0.01l2.25,-0.99l0.64,-0.68l0.25,-1.61l-0.47,-0.74l1.16,-0.77l5.85,1.29l2.14,-0.65l3.11,-2.8l1.54,-0.8l0.44,0.13l0.66,0.88l-0.46,1.83l1.31,2.84l0.0,1.04l-1.18,3.47l-0.12,1.34l1.15,3.02Z",name:"Seine-Saint-Denis"},"FR-92":{path:"M453.01,174.53l-2.13,2.61l-0.44,1.64l0.52,1.5l0.5,0.25l1.06,-0.33l4.2,1.5l-0.66,2.43l-0.15,1.7l0.24,1.0l-0.8,1.08l-0.44,-0.05l-1.28,-1.75l-1.79,-0.89l-4.42,-4.05l-0.76,-1.72l-0.05,-3.0l1.83,-2.23l1.79,-0.6l2.49,-1.89l2.33,-0.89l1.22,-0.09l0.43,0.49l-0.12,1.09l-3.59,2.2Z",name:"Hauts-de-Seine"},"FR-91":{path:"M456.79,187.38l2.59,1.71l1.27,0.31l6.54,-0.94l0.61,0.19l1.97,2.81l0.97,0.45l0.87,-0.1l0.16,0.88l-2.22,2.01l-0.87,1.32l-0.24,4.09l-1.52,5.03l0.4,6.02l0.31,0.86l0.95,0.72l-2.17,1.51l-5.68,5.42l-0.27,1.05l-1.4,0.19l-2.83,-1.36l-0.86,0.16l-1.36,1.23l-1.4,0.35l-0.76,-0.38l-0.47,-1.03l-0.68,-0.61l-0.85,-0.52l-0.84,-0.03l-0.66,0.4l-1.38,1.92l-1.99,0.8l-8.7,1.71l-0.72,-0.42l-0.0,-0.42l1.65,-1.87l0.02,-0.74l-1.91,-1.77l-0.62,-2.84l-0.52,-0.9l-1.62,-1.5l-0.13,-3.53l2.05,-7.23l2.71,-0.1l1.11,-0.59l0.78,-1.27l0.5,-2.83l-0.54,-3.08l0.18,-1.2l1.3,-1.52l2.25,-0.6l0.6,-0.93l0.51,-2.22l0.82,-1.31l5.93,-1.53l0.8,0.81l1.61,0.75l1.6,1.97l1.04,0.01l0.7,-0.5l0.4,-0.78Z",name:"Essonne"},"FR-90":{path:"M734.8,260.13l0.14,1.19l0.91,0.99l8.6,4.3l1.49,1.43l0.42,3.57l-0.51,1.44l-1.54,2.09l0.01,1.47l0.98,0.9l2.57,0.38l3.26,3.13l0.91,1.7l-0.38,2.33l-2.02,-0.53l-3.13,0.45l-2.79,-0.68l-2.25,0.79l-0.29,0.46l0.15,0.87l0.88,1.86l-1.14,1.05l-1.28,0.52l-1.43,-4.29l0.53,-2.44l-0.33,-1.39l-0.77,-0.9l-1.08,-0.61l-4.07,0.32l-0.83,-0.9l0.15,-1.25l-1.27,-1.96l-0.19,-3.89l-1.58,-4.63l0.26,-2.81l1.14,-2.01l2.88,-3.16l1.57,0.24Z",name:"Territoire de Belfort"},"FR-17":{path:"M244.25,389.03l0.07,-0.62l-0.38,-0.5l-2.85,-0.2l-0.42,-0.73l1.36,-1.47l0.19,-0.43l-0.29,-1.3l0.52,-0.79l4.3,-2.4l0.54,-1.19l-0.81,-3.17l1.05,-1.33l0.86,-0.51l6.91,-1.45l0.17,0.65l-1.0,1.63l0.99,0.9l1.99,-0.09l4.86,-0.96l1.46,0.21l4.02,2.22l0.83,2.01l-0.02,0.89l-0.54,0.92l0.13,0.54l1.67,1.05l5.25,5.83l1.44,0.93l1.64,0.37l2.47,-0.03l1.07,0.48l2.44,2.27l4.27,-0.1l3.24,2.1l4.08,0.11l2.6,0.81l4.93,3.14l3.23,3.61l1.35,0.53l0.76,1.2l-0.59,0.7l-2.91,0.66l-0.35,0.33l-0.05,0.62l1.66,4.54l0.07,0.94l-0.24,1.04l-0.93,1.34l-1.71,1.68l-1.68,0.97l-1.08,-0.4l-1.42,-1.39l-1.56,-0.29l-5.31,1.39l-3.52,0.2l-1.54,0.5l-1.01,1.01l-0.55,2.06l0.41,0.49l2.22,-0.09l0.28,5.29l-0.58,2.52l0.05,1.06l0.3,0.36l2.01,0.51l5.09,3.43l-1.26,1.89l0.12,0.61l4.33,2.22l-1.19,2.13l1.11,2.92l-0.43,1.28l-0.85,1.14l-2.34,1.67l-0.02,0.63l1.71,1.72l-0.36,1.26l0.14,1.33l0.44,0.68l0.99,0.35l3.23,-0.63l4.16,1.92l1.86,0.07l-0.34,2.71l0.36,0.45l4.73,0.43l1.66,1.08l0.31,2.23l-0.73,1.33l0.67,1.71l-1.85,2.2l-1.43,0.56l-1.58,-0.52l-1.1,0.11l-2.6,1.0l-1.58,0.23l-3.9,-1.19l-2.34,-1.94l-1.85,-0.63l-1.88,-1.13l-2.58,0.24l-0.76,-0.22l-1.52,-2.46l-0.05,-3.59l-1.3,-1.65l-2.79,-1.63l-2.48,-0.15l-1.8,-0.57l-0.72,-2.44l-1.16,-1.24l-1.2,0.22l-0.92,1.41l-0.63,0.41l-4.5,-0.2l-0.74,-2.71l-2.06,-4.83l-2.62,-4.07l-2.88,-2.9l-8.68,-5.52l-0.48,-1.77l-2.47,-1.03l-3.22,-2.81l-4.04,-1.44l-2.76,-2.39l-2.34,0.33l-0.67,-0.24l0.99,-5.73l3.71,-0.99l0.98,0.04l3.79,3.91l1.46,1.04l4.4,1.81l0.48,-0.15l-0.05,-0.5l-1.38,-1.36l-5.52,-3.9l-1.78,-2.15l-0.36,-2.01l-0.73,-1.64l2.03,-1.93l0.85,-0.46l1.49,-0.18l0.47,-1.14l-0.1,-1.07l-0.95,-1.64l0.89,-0.77l-0.02,-0.68l-0.92,-0.54l-1.09,-2.34l1.82,0.24l0.92,-0.76l0.72,-1.95l-0.78,-1.03l-1.49,-0.65l-0.71,-3.23l-1.9,-1.16l0.55,-0.47l-0.04,-0.64l-1.96,-1.09ZM235.41,400.43l1.09,0.41l1.35,-0.28l0.64,0.57l0.15,2.37l0.68,0.73l-0.16,1.32l2.38,1.46l0.35,0.53l-0.41,3.62l-0.61,1.91l-0.67,0.91l-0.62,-0.25l-0.84,-2.53l-1.25,-2.19l-3.59,-3.54l-1.32,-0.83l-2.14,-2.59l0.33,-1.57l-1.72,-3.8l1.1,0.13l1.99,0.91l3.27,2.7ZM219.58,381.29l3.07,-0.67l0.94,0.18l0.51,0.48l-0.09,0.29l-1.95,-0.5l-0.35,0.62l1.41,1.8l1.75,-0.06l1.83,-0.69l0.25,0.77l1.02,0.43l6.19,0.88l1.32,0.74l1.5,1.94l-0.96,0.35l-3.3,-0.75l-5.87,-3.31l-3.6,0.51l-0.76,-0.27l-2.9,-2.73Z",name:"Charente-Maritime"},"FR-16":{path:"M362.89,390.47l0.58,2.28l-0.05,2.42l0.47,1.18l2.26,2.74l0.64,0.29l1.45,-0.41l0.5,0.27l1.86,3.56l-1.18,1.27l-1.48,0.92l-1.24,0.43l-2.32,0.15l-0.58,0.36l-0.39,1.01l0.03,1.69l-1.25,6.55l-0.51,0.55l-1.1,0.02l-1.68,-0.77l-1.19,0.49l-0.97,1.76l-2.34,1.96l-1.37,2.98l-2.13,1.76l-2.19,2.98l-0.47,0.34l-1.88,0.21l-0.55,0.47l-0.33,0.71l-0.08,2.84l-0.44,1.62l-4.25,5.89l-2.66,0.63l-6.76,4.5l-0.78,1.47l-0.8,2.98l-0.04,4.61l-0.94,1.41l-1.05,0.85l-2.57,1.0l-0.63,0.64l-0.63,1.62l-0.92,0.86l-0.88,0.24l-2.68,-0.62l-4.63,2.09l-0.46,-2.32l-1.9,-1.24l-4.6,-0.47l0.35,-2.74l-0.39,-0.45l-2.07,-0.04l-4.41,-1.97l-3.64,0.52l-0.36,-1.43l0.32,-1.55l-0.46,-0.82l-1.1,-0.91l1.97,-1.41l1.07,-1.44l0.49,-1.76l-1.1,-2.64l1.3,-2.17l-0.15,-0.57l-4.28,-2.2l1.22,-1.86l-0.09,-0.59l-5.52,-3.72l-1.92,-0.51l0.55,-3.24l-0.25,-5.68l-0.42,-0.42l-2.13,0.09l0.3,-1.25l0.86,-0.86l1.22,-0.36l3.51,-0.2l5.08,-1.38l1.34,0.25l1.18,1.25l1.5,0.6l2.31,-1.18l1.82,-1.8l0.99,-1.44l0.34,-1.31l-0.1,-1.28l-1.64,-4.51l3.05,-0.82l0.85,-1.01l0.03,-0.47l-0.7,-1.1l2.14,-1.0l3.16,-5.24l2.77,-2.14l3.15,-1.37l2.74,-0.38l2.49,1.27l1.37,-0.59l1.27,0.36l2.69,1.78l1.37,0.37l7.15,-0.07l2.62,0.71l1.14,-0.58l0.82,-1.73l-0.13,-0.5l-1.38,-0.98l1.45,-2.09l1.35,-0.14l3.32,3.2l3.03,0.6l3.05,-0.72l3.64,-3.43l4.95,0.29Z",name:"Charente"},"FR-15":{path:"M458.84,445.76l1.95,-0.35l3.03,1.58l1.95,0.27l0.86,-0.25l0.6,-0.61l0.62,-1.58l1.16,-4.44l0.73,-0.04l3.18,1.89l3.22,0.73l1.42,0.74l2.43,3.63l2.81,0.16l5.14,-0.78l3.9,1.73l0.89,0.93l1.96,3.79l3.01,1.68l2.83,-0.95l3.8,-3.67l0.38,1.88l-0.06,2.68l0.45,0.41l3.22,-0.38l1.54,0.27l1.42,0.66l0.39,0.49l0.46,2.74l1.75,2.34l0.32,0.9l0.47,4.09l1.0,1.32l2.22,0.5l0.12,0.72l-2.16,2.18l-0.27,1.3l0.38,1.24l3.69,3.59l0.61,1.24l0.11,1.01l-1.67,0.38l-3.17,1.81l-1.69,-0.0l-0.85,0.32l-4.65,3.8l-0.58,0.1l-1.2,-1.57l-0.6,-0.32l-1.46,0.59l-0.57,0.8l-0.62,3.19l-1.64,1.03l-0.58,0.99l-1.42,4.71l-0.35,2.6l-1.83,2.78l-0.72,2.01l-1.6,-1.21l-1.15,-1.79l-0.53,-3.47l-0.56,-1.36l1.14,-0.77l-0.12,-1.16l-2.88,-1.38l-0.69,-1.95l-2.44,-3.26l-0.78,-0.22l-2.44,0.35l0.05,-1.49l-0.34,-1.19l-1.91,-2.42l-1.03,-0.42l-8.44,7.7l-0.74,2.6l-2.44,3.55l-0.58,2.41l-3.68,3.99l-0.93,0.45l-1.89,0.2l-3.45,-0.1l-1.45,0.62l-1.19,-1.14l-1.48,-0.11l-5.33,1.64l-0.67,1.8l-0.21,-0.03l-0.95,-1.01l-0.89,-3.39l-1.7,-1.05l1.55,-5.49l-0.1,-0.85l-1.32,-2.73l-3.07,-4.61l-0.85,-5.71l-0.6,-1.16l0.94,-0.4l2.23,-0.24l1.11,-0.74l0.08,-1.24l-1.43,-2.43l-0.11,-0.76l3.2,-2.58l2.85,-5.59l0.22,-1.14l-1.07,-2.31l0.11,-1.37l2.59,-1.98l0.51,-1.87l3.08,-1.33l2.04,-2.9l1.09,-0.69l1.42,-3.08l-0.14,-1.07l-0.95,-0.99Z",name:"Cantal"},"FR-14":{path:"M332.14,133.05l0.5,2.91l0.12,6.48l1.43,2.16l2.42,0.54l0.46,0.57l-0.57,0.58l-1.68,0.72l-0.23,1.35l0.62,1.25l2.42,2.18l0.67,1.99l1.53,2.55l-0.8,2.37l0.44,2.09l-1.99,0.1l-0.58,1.01l0.65,1.85l2.18,1.62l0.66,1.06l-0.48,4.27l-1.02,-1.0l-1.2,-0.16l-2.3,1.38l-0.84,0.1l-1.86,-0.85l-0.91,-1.19l-1.02,0.1l-1.91,2.15l-2.8,0.09l-2.06,1.2l-1.53,-1.99l-1.73,0.25l-3.13,3.65l-11.86,5.98l-10.27,-2.39l-1.31,0.46l-0.43,1.35l-0.43,0.43l-1.16,-0.68l-2.68,-2.58l-2.04,-0.34l-3.2,1.7l-7.41,1.57l-4.44,-0.95l-1.37,1.01l-0.13,0.93l0.58,0.88l-0.66,0.7l-4.12,0.97l-1.09,0.66l-1.67,1.7l-1.01,0.33l-3.39,-1.55l-3.63,-0.84l-2.55,0.72l-2.87,-0.11l-2.72,-0.89l-0.41,-1.55l-0.54,-0.63l-2.19,-0.52l0.8,-1.64l1.8,-1.44l2.54,-0.96l1.41,-1.45l0.05,-1.06l-1.6,-1.58l-0.02,-0.85l0.4,-0.78l0.65,-0.34l2.53,0.58l1.24,-0.22l2.04,-1.45l3.38,-3.42l1.9,-0.87l0.2,-0.52l-0.48,-1.11l-0.84,-5.35l-2.31,-4.25l0.77,-3.01l-0.34,-0.92l-0.94,-0.21l-3.67,1.17l-1.36,-0.09l-6.82,-6.1l-0.76,-1.51l1.05,-2.02l0.04,-1.46l0.93,-0.54l-0.09,-0.79l-0.48,-0.6l0.33,-0.79l0.91,-0.85l0.91,-0.36l7.94,0.35l7.3,2.35l10.46,0.54l4.16,0.79l2.31,-1.02l4.08,1.27l4.12,0.0l2.91,1.4l3.03,0.6l5.69,2.93l1.91,-1.18l9.72,-1.95l2.93,-1.18l1.7,-1.25l1.45,-0.37l2.06,-2.35l3.94,-2.42l7.63,-1.46Z",name:"Calvados"},"FR-13":{path:"M574.87,589.37l0.92,-0.18l1.37,-1.04l2.17,-0.54l3.45,-2.45l1.63,-0.49l0.58,-1.36l1.97,-0.33l0.5,-0.38l0.72,-1.53l-0.09,-0.84l-1.94,-0.6l1.3,-2.75l1.5,-1.9l1.28,-0.92l2.03,-0.52l3.72,1.32l1.03,-0.3l0.65,-1.54l-0.04,-1.78l1.98,-4.92l-0.49,-4.74l5.08,-3.33l2.62,-1.09l7.98,2.74l3.77,2.11l7.34,6.02l6.46,2.82l3.93,0.02l4.9,0.69l2.46,2.09l2.3,1.25l7.19,1.94l3.24,0.25l2.63,-1.13l1.36,-1.05l4.1,-0.86l2.52,-1.83l0.87,0.32l1.2,2.08l0.89,0.51l-1.04,1.57l-5.2,1.45l-1.69,2.68l0.17,2.27l2.54,2.31l0.04,0.87l-0.92,2.93l0.18,1.74l3.7,4.62l-0.86,0.23l-2.91,-0.16l-1.58,0.6l-0.22,0.53l1.07,2.83l-0.63,1.29l-0.12,1.51l0.56,1.02l1.68,-0.02l1.52,0.96l0.62,1.17l-0.73,0.94l-1.96,0.9l-1.32,1.08l-0.82,1.73l-0.43,2.15l-2.32,-0.23l-1.22,1.76l-2.05,-0.53l-1.98,-2.66l-0.96,-0.55l-1.48,0.47l-6.6,-0.49l-1.53,0.31l-1.02,-0.43l0.34,-1.68l0.94,-1.98l-0.08,-0.43l-0.62,-0.64l-1.13,-3.95l-2.92,-1.81l-3.73,1.99l-4.48,-0.09l-2.35,0.26l-3.62,-0.16l-1.71,-0.5l-1.11,-1.51l-0.44,-1.53l1.11,-1.82l1.71,-0.86l5.36,0.0l1.8,-0.48l2.62,-2.32l0.89,-2.0l-0.21,-1.77l-0.6,-0.3l-3.34,1.54l-1.34,-0.21l-1.17,-1.2l-0.81,-2.2l-1.53,-0.53l-1.81,-0.01l-1.47,-1.47l-0.5,0.08l-0.49,0.59l-0.81,2.82l0.42,1.59l2.15,1.63l0.63,1.61l-0.57,1.4l-1.25,0.8l-1.63,0.16l-4.46,-1.86l-2.21,1.1l-1.58,0.35l-0.71,0.61l-0.46,1.44l0.98,2.54l0.42,0.33l0.81,-0.05l-1.29,0.81l-1.31,-2.62l-2.66,-1.4l-1.98,-1.65l-0.86,-1.8l-0.02,-5.7l-1.08,-2.53l-0.85,-1.1l-1.19,-0.67l-0.59,0.35l0.0,0.46l2.09,3.43l0.0,5.28l0.86,2.64l4.89,4.15l-0.11,1.02l-9.05,-0.1l-4.41,-0.9l-1.34,-0.7l-0.03,-0.85l1.11,-1.09l0.22,-1.41l-0.65,-1.13l-1.58,-1.03l-2.76,-0.96l-6.31,0.6l-10.72,-0.78l1.08,-2.45Z",name:"Bouches-du-Rh\xf4ne"},"FR-12":{path:"M496.69,503.56l5.22,5.97l1.03,1.89l-0.19,2.29l0.3,1.4l3.32,4.5l-0.18,2.17l-0.64,1.51l-0.08,1.13l0.32,2.23l1.01,1.78l-1.38,2.78l0.09,1.06l1.58,0.39l3.9,2.06l0.78,0.87l0.34,1.61l0.66,0.45l6.25,-0.23l1.47,0.82l0.29,0.68l-1.87,1.21l-1.04,1.36l-0.22,2.18l-2.12,1.24l-0.14,0.98l1.39,1.0l1.66,-0.16l1.15,1.08l2.11,0.24l2.74,1.92l0.74,1.08l-5.4,4.95l-1.0,2.67l-1.08,0.84l-2.91,0.28l-1.88,1.2l-0.58,0.8l-0.32,1.84l-1.22,1.35l-1.52,0.35l-5.75,-0.72l-2.03,0.54l-0.42,0.6l-0.29,1.6l0.73,1.98l-0.44,1.8l0.13,1.84l-0.64,1.29l-1.29,0.19l-2.18,-0.74l-2.67,0.48l-0.59,-1.83l-1.29,-1.26l-5.47,-1.39l-3.0,1.45l-1.79,0.45l-1.91,-0.45l-2.02,-1.27l-3.54,-3.31l-1.66,-2.27l-1.18,-2.69l-0.93,-3.79l-2.18,-2.52l0.34,-2.35l-2.77,-4.03l-1.28,-1.09l-2.75,-0.57l-0.93,-2.29l-1.02,-1.08l-2.26,-1.19l-2.6,-0.58l-1.68,-1.39l-2.52,-0.18l-1.78,-1.74l-3.12,-1.79l-1.43,-0.3l-1.58,0.16l-5.48,2.79l-1.48,0.37l-1.08,-1.93l-3.23,-0.97l-0.49,-1.35l0.62,-1.43l2.44,-1.04l0.72,-2.26l-0.35,-0.49l-4.72,-0.46l-1.09,-0.58l0.05,-2.42l1.74,-1.34l0.2,-1.22l-2.54,-3.9l-1.55,-5.39l5.46,-2.32l3.69,-2.65l4.47,-2.28l4.69,0.38l2.58,-0.64l1.69,-1.09l0.08,-1.68l0.48,-1.65l0.74,-0.34l4.28,-1.18l1.0,0.08l1.12,1.11l0.62,0.08l1.36,-0.63l3.34,0.11l1.98,-0.21l1.17,-0.54l3.99,-4.3l0.61,-2.45l2.43,-3.52l0.63,-2.44l7.94,-7.42l2.16,2.45l0.35,2.78l0.85,0.31l2.55,-0.29l2.18,2.96l0.8,2.12l1.02,0.73l1.85,0.66l-1.03,0.82l-0.2,0.72l0.58,1.36l0.56,3.56l1.34,2.1l2.09,1.6Z",name:"Aveyron"},"FR-11":{path:"M447.59,651.06l0.02,-0.92l-0.7,-1.19l-3.09,-1.57l-1.3,-1.89l-0.78,-0.52l-1.45,-0.09l-4.97,0.99l-3.19,-1.51l-0.09,-2.0l-0.33,-0.79l-1.13,-1.02l-1.47,-0.6l1.45,-2.0l2.2,-0.09l2.98,-1.12l0.66,-0.91l-0.7,-3.27l-1.98,-1.59l0.22,-0.47l2.52,-0.94l0.35,-0.87l-1.18,-4.24l-1.84,-1.68l1.01,-1.4l-0.13,-1.62l-0.81,-1.39l-1.37,-1.06l-2.78,-0.31l-2.44,-1.23l-5.03,-1.67l-2.51,-2.02l-0.25,-1.95l-0.77,-1.95l0.54,-2.7l1.15,-1.61l0.25,-1.25l2.04,-0.61l1.77,-0.12l1.18,-0.91l0.17,-0.74l-0.43,-1.26l0.08,-0.79l1.5,-1.66l0.46,-1.21l1.39,0.39l0.18,1.21l0.84,0.58l4.13,-1.6l4.75,-0.59l1.8,1.66l1.22,0.49l1.49,0.09l3.87,-0.65l2.63,1.32l1.45,-0.69l0.36,-1.12l-0.32,-1.36l0.34,-0.67l0.77,-0.52l7.02,1.26l5.86,-0.38l6.37,0.52l1.03,0.55l-1.22,1.31l-0.84,1.82l0.3,1.84l1.51,1.68l1.85,1.41l1.87,0.88l1.81,-0.36l1.11,-1.37l1.13,3.01l2.95,1.49l0.41,-0.07l5.14,-4.34l0.88,-2.31l-0.02,-2.2l0.19,-0.52l0.5,-0.11l0.44,0.27l2.43,4.27l0.78,0.62l1.28,0.31l2.93,-0.3l-0.01,1.4l0.71,1.15l3.08,0.45l3.07,1.73l2.64,0.07l2.13,0.47l2.89,1.67l-1.14,1.47l-2.59,2.25l-1.5,2.23l-2.52,2.24l-2.67,5.89l-1.95,6.31l0.17,0.94l0.79,0.58l-0.47,5.83l-8.86,-4.09l-1.6,-1.19l-0.82,-0.21l-4.72,1.87l-2.6,3.06l-0.65,0.56l-1.43,0.42l-20.24,-0.95l-2.07,0.73l-0.85,1.3l1.16,5.96l0.02,0.97l-0.39,0.66l-1.93,0.88l-2.6,-0.26l-3.16,3.14l-1.43,0.99l-0.93,-0.56Z",name:"Aude"},"FR-10":{path:"M542.23,201.62l1.67,2.04l2.4,0.7l3.77,0.44l0.48,-0.31l0.39,-1.88l0.75,-1.38l1.18,-0.59l7.36,-6.27l2.86,-0.72l1.4,-2.14l2.16,0.14l4.84,-1.39l7.15,0.57l0.36,0.37l0.36,1.45l-0.67,4.15l0.66,1.26l12.12,6.47l1.16,-0.11l2.23,-1.24l1.26,-0.24l3.99,1.31l-0.44,2.54l-1.43,2.0l-0.13,0.94l0.39,0.68l2.31,1.4l2.28,2.89l2.18,1.21l1.32,1.98l2.99,1.23l-0.35,2.17l1.65,1.75l0.92,7.61l-1.03,1.78l-0.12,1.84l-0.85,2.37l-0.61,0.38l-3.32,-0.77l-2.22,0.32l-1.04,0.8l-0.98,1.93l1.31,2.94l-1.01,1.36l-2.19,0.96l-2.98,-0.51l-1.76,0.38l-1.47,1.25l-0.22,1.84l-0.81,0.45l-13.17,1.5l-2.39,1.7l-0.5,0.01l-1.12,-0.71l-1.95,-2.64l-0.78,-0.38l-0.55,0.41l-0.26,2.11l-1.42,-0.99l-1.02,-0.13l-0.91,0.39l-1.31,1.25l-1.75,0.05l-1.93,-0.43l-1.85,1.2l-2.25,-0.63l-2.87,0.17l-1.97,-0.36l-0.57,-0.86l0.08,-2.22l-0.52,-0.94l-0.98,-0.2l-1.67,0.35l-1.41,-0.73l1.56,-0.67l0.12,-0.94l-4.65,-7.0l-1.91,-1.9l-1.19,-2.29l-1.36,-0.51l-0.78,0.28l-0.57,1.04l-1.58,0.12l-2.82,-1.93l-2.05,-0.84l1.35,-1.41l0.55,-1.05l-0.39,-3.31l-0.49,-0.96l-5.62,-6.39l-3.0,-1.66l-2.3,-0.01l-0.47,-2.37l-1.12,-0.92l-0.15,-0.51l0.56,-2.27l-0.63,-1.75l1.81,-1.89l-0.93,-1.96l2.55,-0.54l0.75,-0.59l1.02,-2.47l0.98,-1.32l2.57,-1.91l1.37,-0.09l1.99,2.7l1.48,0.1l0.62,2.61l0.57,0.31l1.15,-0.57l2.83,-0.55l0.95,-0.81Z",name:"Aube"},"FR-2B":{path:"M840.29,672.01l0.19,-0.25l0.97,0.12l1.07,-2.21l1.86,-0.26l0.74,-0.59l0.25,-1.79l0.9,-1.48l-0.38,-0.73l-0.69,-0.15l0.49,-1.84l0.66,-0.7l2.07,-0.66l0.26,-0.57l-0.29,-0.57l0.29,-1.57l1.09,-0.31l1.75,0.99l1.22,-0.28l0.96,-0.92l0.83,-2.39l1.69,-0.12l3.84,-1.79l6.8,-1.3l2.03,-0.92l0.4,-1.61l3.75,-3.54l2.7,-0.22l4.3,0.91l1.55,0.91l1.19,2.4l0.37,0.25l0.75,-0.18l2.19,-3.35l0.93,-2.22l-0.53,-1.78l0.44,-1.29l-0.33,-1.53l-1.69,-2.25l1.55,-2.06l-0.41,-1.45l0.2,-1.05l1.75,-1.77l0.11,-1.69l-1.01,-1.98l0.14,-1.93l0.77,-0.45l2.42,-0.01l0.97,-0.35l0.69,0.85l1.59,0.95l-0.62,1.65l0.32,1.04l0.64,0.74l-0.24,1.34l1.15,6.71l-0.1,2.14l-1.97,6.87l-0.02,4.12l-0.45,1.01l0.91,0.83l0.24,0.8l-0.14,1.25l1.14,1.91l2.33,1.17l0.51,-0.65l0.25,0.54l0.31,7.85l0.73,1.54l-0.6,1.91l-0.19,2.68l1.67,5.79l-0.45,9.13l0.43,1.76l-0.38,2.31l-0.37,0.56l-1.68,1.43l-1.61,2.76l-5.49,7.01l-0.44,6.49l-0.8,-0.12l-1.39,0.44l-2.65,1.71l-4.61,-1.41l0.81,-2.11l0.12,-1.38l-1.48,-3.98l0.03,-4.84l-0.41,-0.48l-3.1,0.15l-0.62,-0.31l-0.74,-1.15l-0.82,-3.61l-4.08,-4.46l-1.23,-3.5l-0.78,-0.4l-2.41,-0.33l-6.35,-3.95l-1.27,-4.03l-1.02,-0.49l-2.14,0.51l-6.63,-1.58l-5.01,-2.35l-2.75,-0.26Z",name:"Haute-Corse"},"FR-2A":{path:"M838.53,672.37l1.83,0.51l2.41,0.15l5.06,2.36l6.76,1.61l2.26,-0.49l0.44,0.27l0.67,2.74l0.64,1.31l6.51,4.05l2.96,0.55l1.14,3.37l4.05,4.41l0.77,3.47l0.9,1.47l1.16,0.59l2.69,-0.13l0.06,4.61l1.47,3.89l-0.09,1.14l-0.94,2.44l0.24,0.52l5.33,1.6l2.87,-1.77l1.24,-0.39l0.58,0.13l0.47,5.63l-0.08,5.26l-1.16,0.85l-0.93,1.45l0.36,0.56l0.38,0.0l-0.34,1.47l-1.74,0.45l-0.13,1.0l-2.1,-0.31l-0.71,0.1l-0.34,0.46l0.08,0.47l-0.87,1.33l0.15,0.53l1.18,0.53l2.94,-0.89l0.29,0.34l-0.16,0.77l-1.25,1.25l-1.71,0.61l-1.08,1.44l-0.92,0.16l-0.29,0.57l0.28,0.85l-0.28,0.85l0.82,0.98l-0.71,0.84l0.01,0.67l-2.14,1.17l-0.98,0.12l-0.35,0.4l0.0,0.54l0.75,0.99l-0.59,0.7l-0.15,0.77l0.54,0.37l1.71,-1.1l-1.36,2.96l-0.77,0.37l-0.56,-0.17l-1.56,-1.26l-4.09,-1.13l0.5,-1.41l0.63,-0.25l0.15,-0.7l-3.04,-1.76l0.64,-0.96l0.0,-0.46l-0.51,-0.38l-2.15,1.21l-0.36,-0.76l-1.07,0.38l-0.9,-0.82l-1.69,-0.51l-2.48,-0.05l-1.61,-1.23l-1.4,-0.31l-0.77,-0.93l-1.36,-0.18l0.42,-0.48l-0.28,-0.83l-3.45,-1.04l0.22,-1.42l-0.44,-0.73l-0.5,-0.17l1.06,-2.73l1.05,0.33l3.28,-1.35l0.76,-0.71l0.25,-0.88l2.21,-1.71l-0.28,-0.67l-8.03,-1.29l-0.49,-0.46l0.45,-1.23l-0.37,-0.54l-1.66,0.01l-3.15,0.9l0.15,-0.36l-0.39,-0.56l-1.58,-0.18l1.37,-0.22l1.43,-1.12l0.36,-1.08l-0.11,-0.68l-0.53,-0.48l2.22,-0.4l2.07,-1.1l0.18,-0.51l-0.3,-0.7l-0.72,-0.7l1.32,-0.68l0.04,-0.58l-0.51,-0.92l1.44,-2.22l-1.63,-2.04l-1.3,-0.47l-1.37,0.15l-3.3,1.36l-2.54,0.15l-1.78,0.63l-0.16,-0.36l0.64,-1.35l-0.36,-1.17l-1.16,-1.23l2.2,-0.2l1.3,-0.47l1.04,-1.45l-0.12,-0.56l-0.44,-0.27l0.27,-0.44l1.08,-0.73l3.47,-1.33l0.38,-0.36l0.09,-0.92l-0.43,-0.78l-0.97,-0.68l-1.71,-2.86l-0.82,-0.13l-1.52,0.37l-0.72,-1.14l-1.11,-0.59l-2.23,-0.31l0.1,-0.87l-0.66,-0.46l0.63,-0.4l0.19,-0.89l-0.4,-0.4l-0.84,0.0l0.49,-1.2l-0.24,-0.73l-0.53,-0.37l0.18,-0.95l-1.46,-1.0l2.12,-0.06l1.46,-0.81l2.49,-0.44l2.27,-0.94l0.28,-0.91l-1.26,-1.16l-2.16,-0.95l-0.59,-1.02l-0.54,-0.04l-0.76,0.57l-0.02,-0.4l1.8,-0.96l0.05,-0.67l-1.61,-1.07l-1.41,0.12l-1.48,0.55l-0.55,-1.32l-0.01,-0.82Z",name:"Corse-du-Sud"},"FR-19":{path:"M391.83,442.28l1.35,-1.87l1.52,-1.17l3.83,-0.97l2.33,-1.62l0.94,-1.27l1.29,-2.82l3.51,1.97l4.0,-0.33l8.09,-5.41l3.21,-1.16l2.32,-2.4l0.78,-0.11l1.2,0.95l3.0,-0.08l2.35,-1.05l0.13,-0.63l-0.36,-0.41l4.47,-0.61l1.76,-2.84l1.97,-1.47l1.24,0.07l2.42,1.87l4.27,0.65l7.14,3.9l1.73,-0.03l0.97,-0.41l2.02,-2.4l4.42,0.27l1.5,-0.64l1.68,-1.29l1.28,1.41l0.51,1.09l-0.24,3.82l-0.55,0.67l-1.79,0.8l-1.06,3.12l0.17,0.96l1.69,2.26l0.25,4.1l1.11,1.0l-1.72,5.84l-0.79,0.43l-1.66,-0.23l-3.58,-1.66l-1.74,0.31l-0.64,0.49l-0.08,0.65l0.95,0.93l0.15,0.84l-1.24,2.6l-1.06,0.64l-1.96,2.84l-3.1,1.35l-0.66,2.04l-2.65,2.08l-0.16,1.81l0.96,1.75l-0.04,1.26l-2.76,5.43l-2.8,2.03l-0.55,0.87l0.17,1.26l1.47,2.59l-0.74,0.72l-2.13,0.22l-1.44,0.59l-4.52,0.2l-1.94,0.88l-1.38,-0.66l-0.83,-0.05l-4.06,1.88l-3.12,0.95l-1.23,-0.04l-3.73,-1.98l-1.24,-1.82l-2.13,-1.68l-3.13,-1.75l-1.92,-0.51l-2.06,0.56l-0.77,-1.17l-0.7,-0.11l-3.75,2.17l-0.61,-0.97l-1.41,-1.24l-1.53,-2.72l-0.16,-1.05l0.45,-2.03l-0.39,-0.62l-0.76,-0.29l-3.42,0.15l-1.37,-0.4l-1.11,-0.64l-0.51,-0.73l0.71,-1.38l-0.24,-1.53l-0.65,-0.48l-1.73,0.03l-0.5,-0.28l0.37,-0.93l2.04,-1.69l0.24,-0.77l-0.56,-0.85l-1.85,-1.47l0.6,-2.56l1.28,-0.93l0.89,-1.14l1.62,-0.95l0.73,-1.34l-0.14,-0.73l-0.54,-0.5l-1.94,0.2l-0.72,-0.38l-0.05,-0.67l0.94,-1.5l0.23,-1.06l-0.86,-0.96l-1.17,-0.07Z",name:"Corr\xe8ze"},"FR-18":{path:"M490.39,283.47l1.8,3.36l1.35,1.6l0.08,0.79l-0.52,2.31l-0.86,1.93l-2.02,2.99l-0.08,0.93l0.92,1.57l1.73,0.94l3.6,3.47l0.78,3.4l1.43,3.27l1.23,3.95l-0.07,3.7l2.22,2.27l0.43,5.38l-1.31,4.71l1.16,3.29l-2.28,4.15l-0.31,1.64l-3.08,-0.17l-2.72,0.77l-4.06,2.3l-1.68,2.09l-2.02,-0.32l-1.56,1.24l-2.13,-0.62l-0.64,-0.74l-0.84,-0.12l-4.12,3.34l-1.44,0.06l-0.57,0.31l-0.14,1.87l-1.92,-0.0l-0.79,0.54l-0.1,0.83l1.0,1.52l-0.51,1.0l0.05,1.2l1.67,2.1l0.24,1.43l-5.01,1.3l-7.99,0.81l-3.73,1.66l-1.58,1.88l-1.55,0.74l-2.19,3.55l-6.26,-0.22l0.78,-1.45l2.17,-2.14l0.28,-1.08l-0.07,-1.22l-0.65,-1.92l-1.5,-1.65l-0.02,-0.65l1.42,-2.43l0.37,-2.53l-0.24,-1.1l-0.78,-1.0l-1.58,-0.98l0.11,-2.26l-0.63,-0.94l-1.04,-0.53l-2.48,-0.4l-0.73,-0.83l0.44,-1.13l1.97,-1.4l0.44,-0.97l-0.37,-1.39l-1.89,-1.35l-0.19,-0.92l0.24,-1.28l1.08,-2.18l1.97,-1.79l0.3,-0.97l-0.68,-1.15l-2.11,-1.19l-0.46,-0.89l0.85,-3.02l0.0,-1.33l-0.55,-1.28l-2.59,-2.57l0.65,-2.75l-0.34,-1.74l-0.76,-0.77l-1.4,-0.58l-3.25,-0.31l-4.86,1.54l-6.14,-1.76l2.79,-2.55l0.88,-1.85l0.0,-1.77l1.71,0.31l1.27,-0.24l0.99,-0.69l0.35,-0.65l0.21,-2.35l1.53,-1.56l3.38,1.02l3.17,0.36l3.19,-0.39l2.5,-1.37l0.55,-0.86l0.1,-1.08l-1.75,-4.11l-0.26,-2.32l0.2,-0.97l1.0,-1.16l0.66,-0.24l3.91,1.21l1.76,0.01l0.37,-0.26l0.85,-2.33l-0.32,-2.41l-0.49,-1.05l-1.46,-1.65l-1.55,-3.15l-1.22,-0.7l-2.39,0.04l-0.52,-0.53l0.22,-1.85l1.64,-1.09l6.44,-1.59l1.33,0.16l3.11,1.74l1.71,0.36l3.28,-1.04l0.88,0.11l2.95,2.37l1.53,0.4l3.18,-0.09l0.94,0.6l2.58,3.54l2.15,2.02l1.37,0.65l1.81,-0.28l1.67,-2.81l0.94,0.08l2.84,2.04l1.46,-0.15l3.11,-1.59Z",name:"Cher"},"FR-88":{path:"M751.57,206.43l-0.94,1.25l-0.59,7.58l-0.82,2.89l0.48,1.0l1.16,0.64l3.71,0.29l1.04,0.99l-0.01,0.68l-7.65,10.83l-0.6,1.6l0.78,1.75l-0.29,1.31l-1.35,1.61l-3.07,5.74l-3.51,4.22l-0.66,3.17l-1.65,3.3l0.55,2.46l-0.81,0.78l-2.2,0.86l-1.5,-0.16l-6.14,-4.25l-3.36,-1.49l-2.89,-3.05l-1.0,-0.52l-0.66,-0.08l-0.72,0.37l-1.82,2.29l-2.17,0.57l-2.22,-0.33l-5.28,-2.92l-2.42,-0.87l-3.37,0.19l-1.11,0.31l-1.36,0.92l-2.15,0.18l-3.33,-1.51l-0.16,-1.78l-1.1,-1.33l-1.36,-0.79l-3.03,-0.56l-1.94,0.42l-2.72,2.89l-3.08,1.95l0.04,-2.28l-0.66,-0.67l-1.05,0.29l-1.69,2.58l-1.46,0.73l-2.76,-2.68l-1.27,0.12l-1.23,0.64l-0.33,-0.86l0.11,-2.75l-0.67,-1.26l-3.49,-1.97l-4.37,-3.63l0.64,-1.84l1.18,-2.01l0.51,-2.47l1.45,-1.47l-0.5,-1.38l-3.56,-2.51l-0.06,-1.62l-0.6,-1.04l-1.48,-0.72l-2.31,0.06l-3.01,-3.86l-1.61,-1.35l-2.24,-0.13l-0.71,0.34l-0.86,1.14l-0.51,0.13l-0.78,-3.46l1.77,-2.56l1.42,0.46l1.57,-0.51l3.0,-1.66l3.71,-0.07l3.32,-2.0l2.83,0.26l1.3,-0.32l1.14,-0.94l0.65,-1.14l0.82,0.57l0.72,-0.1l1.72,-0.97l1.33,-0.16l1.35,0.19l1.94,1.21l-0.3,2.25l-1.49,2.14l0.21,1.01l4.75,2.05l-0.31,1.39l0.26,0.46l1.87,0.64l8.74,-0.33l1.96,-0.8l0.25,-0.39l-0.09,-2.23l1.21,0.45l5.1,-0.33l1.64,-2.43l1.06,1.35l1.64,0.83l1.97,0.22l1.36,-0.21l-0.09,0.7l0.45,0.44l0.93,-0.13l1.95,-1.32l4.3,-0.37l6.3,-4.24l1.45,-0.08l0.65,2.62l1.05,1.0l4.61,0.62l4.63,1.54l3.31,-2.91l1.13,1.02l0.47,0.05l1.7,-1.01l3.3,-3.19l5.2,-3.55l1.87,-0.35l2.98,1.42Z",name:"Vosges"},"FR-89":{path:"M572.78,248.31l2.01,2.7l1.73,0.94l-1.28,3.9l-0.11,1.94l0.52,0.4l2.09,-0.18l0.54,0.22l1.64,4.91l-0.53,0.88l-4.51,2.33l-0.11,3.62l-0.69,2.29l-1.52,1.8l-1.11,2.61l-3.54,5.68l-1.1,0.73l-0.52,1.14l-0.07,3.69l-0.72,0.98l-1.66,0.74l-0.61,0.72l-0.05,1.75l0.85,1.97l1.28,0.9l0.18,1.68l-3.19,0.02l-1.92,2.05l-0.77,0.04l-1.21,-0.94l-0.67,-3.65l-0.98,-1.49l-0.51,-0.13l-3.89,1.9l-0.56,-0.31l-0.04,-0.63l0.52,-1.46l0.01,-1.16l-0.78,-1.25l-0.73,-0.22l-1.49,0.75l-0.85,2.16l-0.57,0.68l-5.63,-1.91l-4.42,-3.53l-1.2,-0.44l-2.2,-0.2l-1.5,-2.6l-1.93,-1.61l-2.41,-3.11l-0.66,0.33l0.14,2.56l-0.3,2.07l-4.03,-1.06l-1.63,0.16l-2.81,2.01l-0.62,-0.05l-2.71,-1.56l-2.22,0.8l-0.72,-0.1l-1.75,-1.81l-1.34,-0.46l-2.7,-0.28l-0.9,-0.76l-0.52,-2.7l-0.85,-0.59l-0.8,-0.12l-6.31,1.19l-1.26,-0.27l-0.52,-1.14l-2.08,-2.61l0.57,-2.21l-1.26,-2.45l-2.54,-2.22l-1.81,-0.58l-0.63,-0.61l0.13,-1.83l0.76,-0.58l4.07,-0.42l4.77,-2.29l0.53,-0.86l-0.08,-2.09l0.82,-1.64l-0.97,-2.16l-0.15,-2.18l1.55,-0.25l1.46,-1.47l2.5,-1.52l2.08,-4.18l-0.63,-2.78l-2.95,-2.35l-0.89,-1.09l-1.46,-4.45l-1.91,-1.27l-3.81,-0.73l0.73,-2.78l3.72,-2.26l1.64,-2.66l0.15,-0.86l-0.86,-1.48l-0.18,-1.43l1.15,-3.5l0.41,-0.36l3.03,0.06l2.27,-0.89l4.61,0.48l6.23,-0.91l2.51,0.47l0.72,-0.38l0.87,-1.43l1.29,-1.21l0.68,0.48l0.65,2.62l0.7,0.31l1.89,-0.13l2.82,1.56l5.42,6.18l0.37,0.67l0.39,2.99l-1.82,2.13l0.14,1.13l2.19,0.89l3.06,2.04l1.02,0.12l1.09,-0.29l0.78,-1.18l1.07,0.24l1.04,2.12l1.93,1.93l4.55,6.82l-1.58,0.69l-0.06,1.02l2.02,1.14l2.25,-0.31l0.24,0.47l-0.05,2.31l0.83,1.24l2.41,0.53l2.82,-0.18l1.96,0.66l0.71,-0.08l1.68,-1.15l1.71,0.44l2.04,-0.07l2.04,-1.61l0.63,0.05l1.22,0.92l0.82,0.12l0.66,-0.82l0.03,-1.6Z",name:"Yonne"},"FR-80":{path:"M411.99,58.04l2.13,1.96l1.56,0.75l1.81,0.01l3.71,-1.21l3.67,-0.22l0.86,0.15l1.05,0.68l1.93,2.02l1.13,0.56l1.08,-0.04l1.34,-1.04l0.83,-0.09l0.45,0.32l-0.93,1.21l0.23,1.04l6.67,3.17l0.5,0.49l0.08,1.01l0.75,1.43l1.91,1.29l8.93,-0.46l3.92,-0.85l1.24,-1.53l1.52,1.73l0.76,0.31l0.74,-0.23l0.76,-0.74l1.3,0.11l2.71,1.26l0.54,0.67l-4.33,2.61l-1.17,1.54l-0.21,1.73l0.37,1.17l1.07,1.26l0.76,0.26l0.97,-0.29l1.56,-2.2l2.16,-0.19l2.38,0.33l1.34,-0.69l1.45,-0.17l0.19,0.32l-0.33,1.26l0.52,0.66l3.45,0.68l2.92,1.4l1.0,0.18l0.86,-0.76l-0.13,-1.95l0.49,-1.31l1.67,1.4l1.14,1.83l0.06,0.74l-1.28,1.91l0.29,0.94l0.77,0.38l0.95,-0.07l3.86,-2.53l0.65,0.79l0.19,2.96l0.68,0.44l0.7,-0.01l2.37,-1.26l3.76,-0.4l0.75,-1.0l-0.04,-1.56l0.65,-0.42l2.34,0.28l3.76,1.96l3.79,2.28l2.03,3.11l-2.34,2.6l-2.16,4.61l-2.01,1.7l-0.28,1.39l0.23,2.55l-1.71,2.13l0.19,1.14l1.13,0.63l1.39,0.25l0.81,4.05l-3.34,-0.53l-0.46,0.4l0.03,1.37l-0.41,0.46l-0.68,-0.0l-1.91,-1.21l-1.0,-0.13l-2.69,0.76l-1.97,-1.18l-1.26,-0.06l-0.99,0.81l-1.79,2.72l-2.52,0.78l-0.48,1.04l-0.11,2.07l-0.51,0.11l-2.55,-0.88l-2.55,0.31l-1.95,1.8l-1.21,1.85l-0.34,-0.2l-0.36,-1.68l-0.68,-0.87l-1.0,-0.11l-1.83,0.88l-0.78,-0.29l-2.35,-1.97l-0.9,-0.16l-1.94,0.33l-2.45,-2.09l-4.82,-0.91l-3.22,-1.99l-4.27,-0.69l-10.45,1.06l-5.9,-2.44l-6.94,1.08l-0.3,-0.21l-0.8,-2.81l-4.85,-1.97l-0.28,-1.33l-2.44,-4.06l-0.9,-3.09l-1.01,-1.33l-10.08,-8.97l-8.3,-4.93l5.17,-5.05l1.41,-4.28l1.94,-2.2l1.85,-0.21l5.97,2.46l0.78,-0.01l0.75,-0.53l0.14,-0.85l-1.42,-0.64l0.57,0.0l0.4,-0.4l0.0,-0.59l-0.39,-0.4l-2.26,-0.33l-0.8,-0.54l-1.15,-2.03l-2.54,-1.04l-0.42,-0.47l0.59,-5.43l1.08,-1.83l1.07,0.18Z",name:"Somme"},"FR-81":{path:"M493.7,574.5l-2.7,2.83l-6.65,2.58l-1.23,-0.04l-2.62,-1.24l-1.35,-0.31l-2.38,0.11l-0.75,0.39l-1.36,2.84l-0.07,2.58l0.55,1.19l1.7,1.63l0.13,0.42l-0.6,2.34l0.7,1.51l-1.8,1.74l-1.39,0.83l-2.18,0.54l-6.45,-0.53l-5.8,0.38l-7.23,-1.26l-0.84,0.38l-0.74,0.89l-0.21,0.68l0.29,1.74l-0.63,0.62l-0.74,-0.06l-2.2,-1.21l-3.19,0.57l-2.01,0.01l-0.91,-0.34l-1.82,-1.67l-0.33,-1.07l0.47,-1.88l1.17,-1.37l-0.68,-1.43l-1.18,-0.81l-1.23,-0.17l-0.75,0.44l-1.07,1.47l-0.88,0.41l-0.68,-0.17l-4.07,-3.0l-2.62,-3.3l-1.16,-0.87l-1.98,-0.58l-5.89,-3.16l0.72,-0.96l1.33,-0.48l0.31,-0.44l-0.16,-1.17l-0.64,-1.01l-2.15,-1.92l-2.26,-5.99l-3.89,-1.82l-0.09,-1.78l-1.81,-3.27l0.4,-2.51l-0.43,-2.33l0.58,-0.65l2.56,0.13l0.84,-0.38l1.54,-1.99l2.42,-1.71l1.08,-1.24l0.1,-2.05l-2.77,-3.24l0.3,-1.07l1.35,-0.48l5.87,1.98l1.56,-1.93l2.93,-1.72l2.7,0.07l1.8,-1.38l2.38,0.13l0.5,-0.33l0.53,1.08l0.46,0.21l1.93,-0.49l5.45,-2.78l2.49,0.16l2.9,1.68l1.85,1.79l2.62,0.22l1.67,1.4l2.66,0.59l2.05,1.09l0.74,0.78l1.13,2.56l1.19,0.49l1.85,0.21l0.87,0.8l2.63,3.82l-0.4,1.19l0.1,1.19l2.17,2.49l0.92,3.73l1.23,2.83l1.81,2.47l3.59,3.36l2.17,1.37l2.19,0.54l2.21,-0.52l2.63,-1.37l5.04,1.24l1.03,0.95l0.59,1.82Z",name:"Tarn"},"FR-82":{path:"M361.5,548.73l-0.38,-1.14l-0.84,-1.04l0.59,-2.03l0.66,-0.78l1.81,-0.88l0.77,-1.7l1.0,-0.23l2.75,0.7l1.35,-0.49l0.37,-0.64l-0.02,-0.8l-0.33,-0.62l-1.03,-0.71l2.05,-1.55l2.5,-4.95l-0.22,-1.41l-2.82,-1.29l-0.59,-1.01l0.8,-1.93l0.07,-1.99l0.39,-0.51l3.33,1.13l5.11,-0.37l1.05,-0.9l2.02,-0.88l0.87,-0.07l0.35,0.4l-0.07,0.83l-0.73,1.97l0.16,1.27l0.79,1.18l1.19,0.98l4.38,2.12l2.05,0.47l1.39,-0.81l0.66,-0.06l0.59,0.63l-1.05,1.88l0.06,0.43l0.6,0.6l3.28,0.95l1.71,0.05l4.46,-2.18l1.37,-1.13l0.86,-1.34l1.47,0.78l1.42,1.93l1.06,0.86l1.56,0.05l1.31,-1.11l-0.08,-1.21l-0.67,-1.6l0.2,-0.67l0.8,-0.28l1.34,0.12l0.85,1.57l1.15,0.47l0.75,-0.41l1.84,-1.99l4.93,-1.93l4.75,-0.19l1.1,-0.33l0.1,3.15l1.58,0.8l4.34,0.42l-0.33,1.34l-2.62,1.23l-0.75,2.01l0.87,1.94l3.26,0.98l-0.27,0.29l-2.35,-0.12l-1.84,1.39l-2.82,-0.03l-3.2,1.9l-1.32,1.74l-5.42,-2.01l-1.96,0.6l-0.61,2.05l2.82,3.32l-0.08,1.27l-0.89,1.04l-2.43,1.71l-1.48,1.95l-0.46,0.24l-2.56,-0.13l-0.9,0.4l-0.41,1.15l0.42,2.0l-1.8,1.09l-0.55,0.17l-1.8,-0.54l-2.59,2.11l-2.28,-0.39l-1.91,0.05l-4.54,2.48l-0.05,0.67l1.26,0.97l1.89,0.83l-6.27,3.21l-1.28,0.04l-3.61,-3.13l-1.84,0.04l-1.95,0.78l-3.2,-0.07l-5.96,1.36l-2.81,-0.07l0.43,-1.79l-0.76,-2.68l-0.26,-2.94l-1.14,-2.26l-4.63,-0.38l-1.59,-0.6l-0.43,-0.55l1.28,-0.83l3.25,-3.79l0.65,-1.48l-0.11,-1.38l-0.86,-0.96l-1.17,-0.19l-3.14,1.38Z",name:"Tarn-et-Garonne"},"FR-83":{path:"M662.32,612.72l0.43,-2.22l0.66,-1.46l1.12,-0.93l2.01,-0.92l1.1,-1.34l0.04,-0.43l-0.93,-1.64l-1.71,-1.08l-1.69,-0.05l-0.08,-0.36l0.1,-1.12l0.67,-1.59l-0.97,-2.72l0.94,-0.38l3.01,0.14l1.51,-0.41l0.21,-0.64l-3.97,-4.91l-0.12,-1.32l0.91,-2.86l-0.03,-1.21l-0.75,-1.05l-1.89,-1.51l-0.06,-1.74l1.46,-2.21l4.97,-1.29l1.61,-2.25l-0.16,-0.58l-1.02,-0.49l-1.21,-2.1l-0.87,-0.42l0.93,-1.28l4.57,2.34l1.88,-0.03l0.85,-0.52l0.84,-1.19l0.9,-0.05l1.69,1.78l1.74,1.27l1.27,2.25l1.33,0.49l0.98,-0.5l0.89,-1.66l1.23,-1.17l4.05,-1.61l4.51,-4.06l1.63,-0.62l1.12,0.55l3.72,3.26l2.04,0.99l2.19,-0.51l1.52,-2.88l0.88,-0.93l2.86,0.06l2.77,-0.66l1.75,0.84l3.87,-1.13l1.01,1.11l0.79,1.82l1.06,0.97l3.03,1.01l2.2,0.16l0.33,0.36l0.78,2.08l-0.15,2.6l0.56,1.08l3.76,3.14l1.08,0.56l2.88,-0.18l0.52,0.59l0.07,0.9l-1.59,2.99l-0.52,1.83l0.87,1.71l2.23,1.3l-0.53,1.99l-1.2,0.73l-0.35,0.74l-0.79,0.06l-0.5,-0.8l-0.56,-0.07l-0.45,0.47l0.04,1.32l-0.33,0.1l-1.7,-0.24l-2.06,0.51l-0.64,-0.66l-0.97,-0.32l-0.96,0.39l-1.15,1.12l0.09,1.77l-0.82,1.01l-0.09,1.11l-2.6,0.48l-0.8,1.76l-2.13,1.86l-1.83,1.09l-0.39,1.12l0.27,0.52l1.27,0.34l3.83,-0.86l1.11,0.38l-0.61,1.02l-1.15,0.87l-0.18,1.36l0.76,1.4l-2.03,1.21l-1.78,0.59l-1.1,-1.03l-3.19,0.39l-1.04,1.7l-1.07,0.59l-1.62,-0.35l-3.45,0.27l-1.36,0.42l-1.49,0.84l-0.91,1.44l0.37,1.87l-1.34,0.0l-1.03,-0.98l-2.86,-1.09l-1.75,-0.16l-2.14,0.34l-2.56,1.04l-1.16,0.98l-0.63,1.67l-0.02,1.77l0.91,0.63l-3.08,0.19l0.74,-0.26l0.95,-0.93l-0.33,-1.65l-1.19,-0.96l-5.05,0.37l-0.84,-1.54l-3.51,-0.25l-1.12,-0.63l0.3,-1.17l-0.36,-0.56l-2.16,0.24l-1.78,0.81l-0.23,0.38l1.15,0.68l1.01,1.7l1.82,0.87l-3.07,-0.08l-0.89,0.28l-1.2,1.7l-1.96,-0.54l-1.85,-1.41l1.88,-1.3l0.07,-0.54l-0.41,-0.57l-1.72,-0.7l-0.74,-1.26l-2.11,-0.09l-2.49,-1.0l-0.47,-1.46l-0.88,-0.93ZM708.84,625.18l0.07,-0.56l1.07,-0.35l0.67,-0.95l0.94,-0.47l-1.31,1.7l-1.44,0.64ZM692.6,626.12l1.76,-0.0l0.97,-0.54l0.94,-0.02l0.43,-0.62l0.24,0.26l0.04,0.66l-2.62,1.0l-1.76,-0.73Z",name:"Var"},"FR-84":{path:"M604.27,544.85l-0.38,-2.49l0.33,-2.07l-0.19,-2.88l-0.5,-0.93l-1.47,-1.11l-0.09,-1.56l-1.29,-1.64l-0.54,-1.66l-0.02,-2.97l3.17,-0.14l2.43,0.62l1.57,1.66l1.7,4.01l1.31,0.65l1.08,-0.2l2.24,-1.34l2.77,-0.41l3.47,-1.46l4.07,-1.05l3.48,0.59l1.1,-0.08l2.31,-1.4l0.14,0.38l-0.71,1.56l-0.03,1.7l0.31,1.17l0.77,0.67l2.96,0.79l2.82,-0.21l4.22,1.37l1.95,0.19l0.66,0.8l0.94,2.37l3.97,2.67l2.43,0.48l-0.2,4.0l0.24,0.39l1.05,-0.21l0.97,0.36l0.28,0.59l-0.31,1.92l-1.83,3.84l0.0,1.28l0.75,0.97l0.93,0.32l1.85,0.01l0.72,0.39l0.66,2.08l-0.21,0.96l-2.3,3.79l-0.22,1.71l0.52,0.42l3.8,-1.25l3.06,1.6l5.26,5.65l-2.2,1.58l-4.01,0.82l-1.48,1.11l-2.3,1.04l-3.02,-0.23l-7.12,-1.92l-2.07,-1.14l-2.7,-2.21l-5.03,-0.71l-3.78,0.01l-6.35,-2.77l-7.2,-5.93l-3.9,-2.2l-7.57,-2.61l2.0,-1.55l0.6,-1.17l-0.07,-1.83l1.4,-0.03l0.4,-1.37l-0.44,-0.88l-4.39,-4.94l-1.65,-0.36l-1.13,0.37ZM619.44,527.85l-4.96,0.01l-0.37,-0.2l-0.33,-0.9l0.44,-1.6l2.99,-4.46l1.31,-0.8l1.47,0.37l2.37,2.16l0.58,1.0l-0.0,0.54l-1.24,1.1l-1.26,2.17l-1.01,0.62Z",name:"Vaucluse"},"FR-85":{path:"M204.85,362.1l-0.62,-0.64l-1.32,-5.47l0.25,-1.25l-0.25,-0.45l-0.84,-0.31l-1.14,-2.75l-2.53,-2.31l-0.74,-2.09l-0.93,-0.62l-1.98,-0.4l-2.24,-3.59l-3.41,-3.09l-4.13,-2.11l-0.62,-2.47l0.07,-2.83l0.33,-0.63l1.48,-0.93l0.17,-0.46l-0.28,-0.85l3.12,-1.98l2.48,-5.26l0.78,-0.51l1.11,0.64l3.64,3.66l2.0,1.43l6.44,2.71l3.21,3.11l1.09,0.43l3.21,0.02l6.4,1.46l2.1,-0.76l1.05,-1.03l0.11,-0.59l-1.05,-1.36l-1.3,-3.38l-0.81,-3.57l0.33,-1.77l2.67,-1.06l0.57,0.06l0.82,1.52l0.0,4.18l0.55,1.33l1.18,0.72l1.41,-0.13l2.92,-1.69l0.67,-0.76l0.52,-1.76l-0.33,-2.96l0.24,-0.7l0.9,-0.55l2.21,0.43l0.42,-0.18l1.98,-2.63l2.07,0.63l5.08,2.9l4.49,1.72l2.8,0.29l2.35,-1.23l1.75,1.21l1.01,0.26l2.14,1.33l2.18,3.03l1.67,0.89l0.69,0.84l0.74,3.47l1.17,1.57l4.88,2.98l0.6,0.88l-0.77,1.55l0.04,1.22l3.83,6.52l0.57,3.11l1.58,2.68l0.65,4.43l-1.22,1.54l-0.25,0.91l0.97,4.27l-0.6,2.86l0.25,1.23l0.83,0.72l1.04,-0.23l1.97,1.38l0.71,1.02l-0.74,0.77l-1.26,-0.1l-1.22,0.34l-2.25,2.0l-2.76,0.16l-3.62,1.68l-4.06,-2.24l-1.7,-0.27l-6.67,1.09l-0.44,-0.27l0.9,-1.15l0.08,-0.99l-0.69,-0.77l-0.69,-0.05l-7.38,1.76l-1.66,1.88l-0.75,-0.72l-2.95,-0.11l-2.27,1.19l-0.16,2.27l-1.02,-0.24l-2.4,-2.73l-1.56,-0.33l-4.08,-2.32l-3.43,0.87l-1.24,-0.06l-0.97,-3.42l-1.1,-1.51l-1.55,-0.91l-6.9,-0.76l0.18,-1.01l-1.0,-0.83l-3.36,-0.58l-1.97,-1.51l-2.47,-0.81l-1.08,-2.24l-0.58,-0.83l-0.45,-0.15l-0.26,1.35l0.41,1.74ZM179.99,325.41l2.68,1.47l0.24,2.88l-0.47,-0.24l-2.28,-3.55l-1.56,-0.93l-1.75,0.59l-0.73,-0.9l-0.93,-2.89l-0.56,-0.68l2.62,-0.12l2.02,0.71l-0.04,2.78l0.75,0.89ZM174.33,345.92l-4.93,-0.12l-0.49,-0.98l0.24,-0.36l1.99,0.02l3.18,1.44Z",name:"Vend\xe9e"},"FR-86":{path:"M318.26,311.84l1.47,2.34l0.64,0.37l0.98,-0.07l1.14,-0.55l0.13,1.56l0.57,0.55l2.68,-0.26l0.19,0.85l-0.35,1.75l0.25,0.7l0.48,0.33l1.15,0.07l2.51,-0.61l1.03,1.31l1.83,0.26l-0.34,5.65l0.36,1.29l1.37,1.15l1.25,0.23l2.61,-0.25l2.91,0.46l1.93,-1.14l1.04,-0.24l5.49,-0.33l0.79,-0.44l0.19,-0.71l-0.77,-1.6l-0.1,-0.95l5.63,2.78l1.17,1.63l1.3,3.39l7.23,9.31l2.64,1.85l1.67,1.93l0.84,2.19l-0.61,2.63l0.01,1.65l0.57,2.3l0.59,0.87l2.29,1.98l3.29,1.27l0.85,2.04l0.88,0.33l4.33,0.13l1.69,1.4l0.35,0.75l-0.49,1.9l0.16,1.06l0.74,0.86l1.78,1.01l0.54,0.76l-0.93,2.7l-3.26,1.63l-2.54,0.08l-1.43,0.44l-1.28,1.12l-2.44,3.01l-0.64,1.72l-1.05,0.36l-4.1,0.06l-4.24,3.26l-2.35,0.69l-0.42,1.05l0.42,1.23l1.24,1.86l0.56,2.78l-0.2,0.35l-6.81,-0.46l-3.83,3.52l-2.69,0.59l-2.66,-0.56l-2.57,-2.68l-0.81,-0.54l-0.92,-0.09l-1.71,0.84l-1.25,2.22l0.13,0.5l1.39,0.98l-0.61,1.28l-0.66,0.27l-2.39,-0.72l-7.06,0.08l-1.13,-0.29l-2.69,-1.78l-1.37,-0.41l-0.11,-0.51l0.62,-2.25l-0.52,-1.52l-4.27,-1.83l-1.11,-0.91l-0.06,-0.84l0.74,-1.99l2.18,-2.58l0.93,-1.69l0.38,-1.84l-0.32,-1.84l-1.41,-1.28l-1.65,-0.08l-1.22,0.62l-1.77,2.02l-0.69,0.21l-1.1,-0.71l-1.04,-1.26l-0.38,-1.12l-0.02,-2.18l-1.51,-1.42l-0.57,-1.02l0.19,-2.74l-0.21,-1.47l-1.19,-1.45l-0.0,-1.77l1.57,-2.08l1.72,-4.63l-0.41,-1.38l-1.63,-0.57l-0.81,-0.98l0.11,-2.33l1.63,-2.79l0.76,-2.63l-0.45,-1.48l-1.38,-1.45l-0.19,-2.93l0.13,-0.94l1.44,0.09l1.03,-0.72l0.28,-1.38l-0.35,-0.86l-1.32,-1.09l-0.88,-1.27l-1.68,-4.96l0.02,-1.98l-0.89,-1.06l-1.34,-0.4l-0.63,-2.7l-1.27,-2.64l0.8,-0.94l2.51,-0.92l1.0,-2.45l1.89,-2.08l0.9,-0.26l2.97,0.49Z",name:"Vienne"},"FR-87":{path:"M400.84,373.71l1.37,1.0l-0.09,1.47l-3.2,5.72l0.1,2.58l1.3,1.83l2.84,0.95l2.04,1.94l0.38,0.95l-0.44,2.84l0.39,0.99l2.07,1.25l1.49,5.38l1.33,0.42l-0.69,1.04l-1.03,0.82l-1.49,0.68l-0.2,2.25l0.97,0.78l4.05,0.11l0.71,0.32l0.46,0.63l0.05,0.85l-0.46,2.3l0.28,0.99l0.81,0.68l2.21,0.26l4.48,-1.17l1.31,0.05l1.7,2.18l0.88,0.66l4.16,1.91l0.9,1.33l-0.15,2.54l-0.7,2.03l0.14,0.45l1.94,1.69l-1.68,0.77l-2.33,0.13l-1.47,-0.98l-1.27,0.11l-2.55,2.52l-3.15,1.12l-8.04,5.38l-3.36,0.29l-3.78,-2.12l-0.56,0.18l-2.2,4.2l-2.13,1.5l-3.94,1.03l-1.68,1.31l-1.46,2.02l-1.5,-0.89l-1.67,0.31l-3.97,-1.86l0.03,-0.66l1.79,-1.66l-0.12,-1.13l-0.97,-0.71l-3.78,-0.79l-0.97,-0.93l-2.29,-3.4l-0.77,-0.58l-0.71,-0.28l-2.28,0.21l-1.67,-0.27l-3.12,0.5l-1.36,-0.83l-0.67,0.19l-1.04,1.31l-0.53,0.24l-0.92,0.1l-1.95,-0.46l-1.21,-0.71l0.7,-2.38l-0.14,-1.2l-2.33,-2.53l-0.86,-0.39l-4.12,-0.22l-0.84,-0.59l1.24,-2.69l2.24,-1.82l1.25,-1.95l1.82,0.71l1.43,-0.0l1.03,-0.91l0.59,-1.88l0.92,-7.22l3.93,-0.81l2.62,-1.86l0.48,-0.93l-0.03,-0.82l-2.06,-3.42l-0.65,-0.47l-1.46,0.4l-0.62,-0.18l-2.23,-2.92l-0.09,-2.84l-0.51,-2.08l1.19,-0.01l0.56,-1.09l-0.6,-2.96l-1.3,-2.02l-0.18,-1.29l2.22,-0.61l4.13,-3.21l3.91,-0.02l1.37,-0.47l0.49,-0.56l0.37,-1.36l2.95,-3.54l1.62,-0.7l2.72,-0.12l2.77,-1.57l3.18,1.35l1.69,0.1l3.59,-0.55l1.16,-1.42l1.05,-0.24l1.47,1.8l2.71,1.62Z",name:"Haute-Vienne"},"FR-01":{path:"M617.23,362.0l1.76,-0.36l4.28,1.38l1.47,-0.15l3.7,-1.24l1.74,-0.16l1.25,0.39l2.16,1.97l1.64,0.85l4.11,0.99l0.02,2.41l0.61,1.09l1.69,0.58l0.98,0.74l0.72,2.39l1.08,1.11l2.12,0.65l0.91,1.09l1.74,0.37l-0.08,3.17l0.9,0.94l1.79,0.47l2.93,-1.5l1.13,-1.19l1.49,-0.38l0.56,-1.17l2.38,-2.03l2.83,2.21l0.53,0.68l0.4,1.81l0.7,0.56l7.33,0.5l1.48,-0.19l1.31,-0.52l4.16,-3.47l1.29,-1.9l5.29,-5.36l2.71,1.45l0.82,0.77l0.73,1.68l-2.15,4.4l-0.57,4.01l-1.43,0.34l-1.27,-0.13l-5.25,2.42l-0.38,1.48l1.62,2.13l-1.34,2.71l-2.71,0.14l-1.68,2.2l-0.62,0.32l-1.36,-1.23l-0.5,0.04l-1.27,1.21l-0.19,3.73l0.91,6.14l0.09,2.81l-0.51,2.57l-2.91,7.65l-0.73,4.3l-0.93,1.66l-2.6,1.32l-4.3,4.06l-1.02,0.12l-1.0,-0.76l-3.27,-4.86l-4.27,-3.42l-1.62,-2.12l-0.91,-2.52l0.21,-0.6l-0.57,-0.85l-2.84,-2.33l-1.05,-0.51l-0.66,0.02l-2.0,1.0l-3.71,5.19l-0.84,0.68l-0.94,0.26l-1.02,-0.21l-1.71,-1.04l-4.67,-1.87l-4.14,0.52l-3.63,-0.52l-4.19,1.09l-0.75,-3.12l0.3,-1.1l-0.2,-0.46l-3.83,-2.69l-1.54,0.13l-0.34,-0.93l-1.17,-0.79l-0.65,-1.05l-2.11,-0.86l0.45,-2.94l-0.39,-4.61l1.2,-3.66l1.56,-3.33l0.22,-1.64l-0.23,-1.26l1.28,-4.71l3.52,-6.66l0.17,-1.98l1.46,-2.52l0.86,-4.24l1.47,-3.8Z",name:"Ain"},"FR-02":{path:"M567.45,89.94l3.32,1.51l1.54,0.17l0.08,2.76l1.79,2.83l0.07,1.8l-1.86,3.26l-0.49,2.91l0.31,0.92l0.9,0.74l0.32,1.65l-0.7,1.08l-3.14,2.62l-1.8,1.1l-1.44,2.0l-1.21,0.65l-2.01,0.15l-1.16,1.07l0.06,0.89l1.48,3.98l-0.45,1.42l0.37,2.06l-1.37,1.28l-0.45,0.95l0.11,0.84l1.61,2.67l-1.45,0.55l-0.75,1.27l0.2,0.5l0.68,0.33l0.4,0.93l-0.07,1.86l-0.4,1.06l-0.57,0.36l-2.25,-0.85l-1.92,0.68l-2.88,-1.37l-2.38,-0.13l-1.45,0.91l-0.06,1.82l-4.11,0.52l-5.16,1.25l-3.39,1.78l-0.06,0.98l0.85,1.81l0.67,5.15l0.51,0.49l1.41,0.26l2.36,2.15l-0.2,0.54l-0.95,0.74l-1.13,0.21l-3.3,-0.33l-1.41,0.67l-0.54,1.6l0.35,1.68l-0.15,1.05l-0.98,1.37l-1.47,1.05l-0.17,1.35l0.25,0.78l0.6,0.45l3.9,0.07l0.6,0.44l-0.02,0.44l-2.28,1.99l-0.73,1.1l-1.76,1.18l-1.05,2.05l-3.83,3.24l-2.02,3.25l-1.48,0.21l-1.71,-0.42l-2.07,-1.34l-0.43,-0.63l-0.43,-2.64l-0.39,-0.68l-0.73,-0.42l-1.48,0.55l-0.51,-0.14l-9.06,-6.98l-0.18,-0.8l0.61,-1.88l-0.14,-0.89l-0.92,-1.78l-1.36,-1.39l-2.91,-0.8l1.22,-1.17l1.33,-2.47l-0.1,-1.34l-0.76,-1.04l-1.11,-0.7l-2.26,-0.71l-1.32,-0.01l-3.62,0.78l-0.68,-0.81l-0.22,-1.54l2.46,-1.51l0.85,-1.77l-0.61,-1.84l-2.74,-2.56l1.36,-0.9l3.13,-0.24l1.77,-1.04l0.96,-1.77l1.02,-3.74l0.86,-0.6l1.32,0.6l1.02,-0.06l0.79,-0.7l0.27,-0.81l-0.52,-2.08l-1.67,-1.09l-0.65,-1.37l-0.08,-1.74l0.68,-3.72l-0.01,-1.49l-1.53,-3.7l0.85,-5.59l-0.68,-2.03l-0.32,-2.65l-0.76,-1.41l-1.35,-0.18l-0.84,-0.47l0.01,-0.4l1.31,-1.18l0.38,-0.9l-0.06,-3.69l2.03,-1.74l2.17,-4.63l2.43,-2.74l-0.36,-1.23l-1.5,-2.16l3.58,-0.7l1.83,0.05l3.72,0.8l0.96,-0.15l1.87,-0.98l5.14,1.35l1.1,-0.07l3.93,-1.62l1.69,-1.03l0.9,0.04l2.79,0.99l0.93,-0.14l3.23,-1.67l0.73,-0.05l3.32,0.71l6.2,0.65l1.83,1.69l0.78,0.18l3.05,-1.51l1.71,-0.23l0.41,0.51l-0.04,2.45l0.56,0.74l5.66,1.94l1.22,0.15l1.87,-0.46Z",name:"Aisne"},"FR-03":{path:"M499.59,339.93l0.27,1.52l1.25,1.52l3.22,1.84l2.72,0.19l2.74,2.56l0.75,0.33l1.03,0.0l2.4,-1.05l1.66,-0.1l1.61,0.25l2.97,1.11l0.77,-0.19l1.41,-1.51l0.75,-0.34l1.37,0.37l1.29,2.19l0.04,1.49l0.5,0.54l0.6,0.12l1.71,-0.33l4.06,-2.15l0.58,-1.97l1.34,-0.87l0.39,-1.8l1.21,0.2l1.4,2.25l0.6,1.79l2.46,2.19l1.56,2.63l0.94,0.54l0.28,1.5l-0.41,3.04l0.32,0.67l4.03,2.05l1.74,0.08l2.67,2.22l3.67,0.71l2.12,1.04l0.8,2.92l-0.64,3.08l0.52,1.3l-0.02,1.46l0.82,1.68l-1.19,1.0l-5.54,2.72l-4.06,1.13l-3.09,2.23l-0.46,0.67l0.1,0.81l1.06,1.16l0.45,3.18l-0.15,4.03l0.68,2.18l0.34,3.41l0.64,2.1l-0.42,0.97l-1.55,0.78l-3.88,0.68l-2.22,1.06l-1.3,-0.52l-2.73,-2.25l-1.7,-0.84l-4.04,-0.77l-1.99,0.11l-1.42,0.57l0.01,-0.79l-1.21,-3.96l-0.51,-0.26l-6.28,2.04l-1.17,-0.97l-4.88,-1.19l-5.39,0.45l-0.97,-0.29l-2.45,-3.12l-4.46,0.7l-1.86,-0.94l-2.01,-1.92l-1.55,-2.4l-0.54,-2.4l0.09,-2.71l-0.61,-1.08l-1.32,-0.68l-2.45,0.07l-1.33,0.64l-1.02,1.09l-0.17,2.84l-0.65,0.18l-3.18,-1.75l-1.24,-0.04l-0.54,0.83l-0.21,2.58l-2.52,2.99l-1.55,0.94l-1.67,0.26l-1.7,-0.42l-1.35,-0.55l-2.11,-3.65l-1.03,-3.11l-3.21,-4.25l-1.27,-0.36l-1.13,0.66l-1.17,-2.27l-0.72,-0.46l-2.83,-0.61l-0.88,-0.67l-0.94,-2.84l-1.76,-1.56l-1.91,-2.38l2.1,-3.42l1.46,-0.64l1.48,-1.8l3.52,-1.57l7.94,-0.8l5.29,-1.4l0.38,-0.42l-0.0,-1.27l-1.97,-2.78l-0.03,-0.72l0.53,-1.33l-1.01,-1.81l2.56,-0.35l0.41,-0.79l-0.21,-1.13l1.75,-0.2l4.07,-3.3l0.82,0.8l2.07,0.75l0.7,-0.08l1.5,-1.22l2.21,0.26l1.77,-2.17l3.83,-2.18l2.59,-0.73l2.86,0.18Z",name:"Allier"},"FR-04":{path:"M651.92,546.28l0.17,-3.46l1.76,-0.99l3.2,-3.13l1.92,0.05l0.53,0.33l0.75,1.42l1.06,0.44l0.64,-0.19l0.44,-0.58l-0.18,-1.95l0.27,-0.4l1.58,0.11l5.96,-1.63l3.73,1.33l1.73,-0.0l0.66,-0.63l0.07,-0.48l-0.57,-1.04l-2.45,-2.72l-1.44,-1.05l-0.22,-0.74l0.57,-1.37l1.35,0.23l3.02,2.06l0.62,-0.3l0.32,-2.78l-0.85,-1.11l0.13,-1.09l1.7,-1.84l1.73,-3.22l3.99,-2.13l2.54,-2.48l1.12,-0.39l2.15,0.09l1.6,2.63l1.39,0.64l1.99,2.81l1.38,0.49l1.86,-1.26l0.69,-1.82l-0.1,-1.94l-0.44,-1.35l2.08,-0.62l1.7,-1.27l2.27,-2.81l3.81,3.91l2.32,1.58l2.87,0.74l6.29,0.16l1.29,-0.64l0.95,-2.17l1.43,-1.71l0.76,-2.54l1.87,-0.29l4.74,-4.19l4.97,-2.21l1.9,-1.9l0.77,-0.44l0.6,0.11l-0.11,0.7l0.56,1.29l-0.69,0.5l-2.06,3.14l-3.05,2.06l-0.83,1.38l0.25,2.53l1.44,2.18l2.96,2.54l-1.46,0.71l-0.65,0.92l-0.69,3.25l0.55,1.28l-4.5,2.46l-1.8,2.73l-1.72,1.55l-2.54,5.66l-0.47,2.74l1.43,2.4l1.69,1.86l0.53,1.82l0.33,2.99l1.73,1.32l1.97,0.96l2.36,3.75l3.58,2.65l1.13,1.23l-2.14,0.22l-3.05,-1.51l-2.25,0.02l-3.1,2.61l-2.55,0.17l-0.83,0.45l-1.01,2.11l0.66,2.69l-1.81,0.32l-1.82,0.77l-1.31,-1.19l-1.32,0.16l-2.71,0.98l-1.61,-0.83l-2.91,0.66l-3.08,-0.02l-1.25,1.2l-1.45,2.78l-1.63,0.29l-1.54,-0.81l-3.72,-3.26l-1.74,-0.72l-1.99,0.79l-4.39,3.99l-4.18,1.7l-1.33,1.27l-1.22,1.88l-0.77,-0.22l-1.3,-2.26l-3.72,-3.26l-1.68,0.15l-0.86,1.22l-0.65,0.4l-1.45,-0.03l-4.62,-2.41l-0.51,0.12l-1.18,1.63l-5.3,-5.7l-3.38,-1.79l-3.68,1.08l0.09,-0.84l2.29,-3.78l0.29,-1.36l-0.24,-1.42l-0.74,-1.26l-1.1,-0.55l-1.88,-0.01l-0.61,-0.22l-0.41,-0.61l0.02,-0.67l1.83,-3.86l0.35,-2.24l-0.65,-1.22l-1.85,-0.49Z",name:"Alpes-de-Haute-Provence"},"FR-05":{path:"M662.86,537.06l0.07,-5.03l-0.46,-0.67l-1.82,-1.02l-1.39,-1.55l0.47,-1.33l-0.29,-0.71l-1.33,-0.38l-2.81,0.16l-3.98,-1.31l-2.2,-1.6l-0.54,-1.85l-1.31,-1.69l0.85,-0.19l2.33,0.46l0.67,-0.16l0.58,-0.67l-0.17,-1.21l-1.58,-1.26l-0.32,-1.32l0.2,-0.43l2.95,0.15l4.34,1.28l0.95,-0.24l2.8,-1.78l0.61,-0.81l-0.12,-1.02l-0.85,-1.05l-1.56,-0.99l-0.6,-0.98l0.34,-1.04l1.84,-2.49l0.74,-2.54l1.28,-0.26l2.49,0.32l4.9,-1.34l1.9,-1.99l0.0,-1.34l-0.94,-1.02l1.78,-2.52l4.33,-0.43l2.59,-0.77l1.06,-1.17l-0.23,-1.81l1.51,-1.3l1.93,-0.81l1.61,0.45l1.3,-0.18l3.71,-2.08l2.21,0.4l1.91,-0.35l1.7,0.15l3.74,-0.98l2.72,0.76l1.33,-0.13l0.6,-0.99l0.28,-3.45l-0.47,-1.39l-1.68,-1.88l-0.61,-3.45l-1.52,-0.82l-3.62,0.45l-0.92,-0.3l-0.21,-0.57l1.03,-6.05l1.31,-1.51l1.5,0.78l3.9,0.36l1.08,0.74l1.0,1.99l4.33,1.4l1.59,-0.46l0.96,-1.07l0.85,-2.13l2.87,-0.24l2.8,-1.28l-0.62,0.73l-0.02,0.5l2.03,2.18l0.17,1.69l0.79,1.24l0.95,0.66l2.05,0.17l1.38,0.88l0.35,1.96l-0.12,4.19l1.23,1.91l2.07,1.56l4.22,2.16l1.41,0.3l3.93,-0.45l2.94,1.06l1.2,1.26l-0.4,2.57l1.25,4.13l2.03,3.55l-3.87,-0.56l-1.58,0.72l-1.43,1.8l-1.1,-0.11l-1.03,0.61l-1.77,1.8l-5.05,2.27l-4.7,4.15l-1.97,0.35l-0.95,2.83l-1.41,1.68l-0.9,2.07l-0.84,0.33l-6.01,-0.18l-2.67,-0.7l-2.04,-1.41l-4.1,-4.21l-0.6,0.03l-2.45,3.06l-1.6,1.2l-2.28,0.65l-0.27,0.51l0.53,1.6l0.11,1.65l-0.5,1.44l-1.25,0.99l-0.83,-0.24l-1.98,-2.8l-1.32,-0.57l-1.61,-2.68l-0.35,-0.24l-2.63,-0.09l-1.43,0.54l-2.52,2.47l-3.05,1.5l-1.67,1.48l-1.17,2.53l-1.72,1.87l-0.37,1.01l0.16,0.89l0.77,0.79l-0.25,2.0l-2.67,-1.78l-1.75,-0.3l-0.44,0.24l-0.75,1.8l0.29,1.27l1.6,1.25l2.33,2.58l0.4,0.73l-0.31,0.3l-1.05,-0.06l-3.91,-1.37l-6.17,1.64l-1.06,-0.09Z",name:"Hautes-Alpes"},"FR-06":{path:"M739.85,588.82l0.14,0.15l-0.95,1.09l-2.27,-1.32l-0.56,-1.01l0.46,-1.62l1.62,-3.07l-0.17,-1.52l-1.01,-0.96l-2.81,0.22l-0.88,-0.44l-3.9,-3.31l0.04,-2.99l-0.85,-2.3l-0.56,-0.67l-2.49,-0.28l-2.75,-0.88l-0.93,-0.85l-0.56,-1.35l3.81,-1.23l0.21,-1.17l-0.69,-1.94l0.78,-1.63l3.17,-0.47l2.96,-2.56l1.83,-0.02l3.14,1.53l3.1,-0.36l0.22,-0.66l-1.7,-1.85l-3.45,-2.52l-2.38,-3.78l-3.69,-2.28l-0.17,-2.56l-0.58,-2.04l-3.05,-3.97l0.41,-2.46l1.72,-4.25l0.72,-1.21l1.71,-1.53l1.69,-2.6l4.53,-2.48l1.25,1.52l1.14,2.19l2.27,1.81l0.83,2.02l0.81,0.8l1.01,0.31l2.19,-0.38l0.67,0.17l6.04,2.48l6.53,3.55l3.45,0.91l1.49,1.72l3.23,0.17l10.62,-2.7l1.73,-0.12l2.57,-1.44l1.28,0.21l-0.66,2.31l0.83,1.51l1.3,1.15l0.87,1.66l-0.1,1.05l-2.22,2.08l-1.33,3.37l-4.45,3.63l-1.3,1.81l-2.63,2.56l-1.02,1.63l0.26,2.23l1.1,3.29l-1.5,0.69l0.05,1.26l-0.73,0.15l-1.26,1.13l-0.56,-0.67l-1.18,-0.6l-1.65,0.49l-1.0,1.05l-0.43,1.64l-1.32,1.04l-0.71,1.53l-2.86,-0.54l-1.56,0.17l-1.86,1.37l0.04,0.96l-1.09,1.0l-0.54,-0.78l-1.17,-0.24l-1.72,0.39l-1.25,1.27l-0.66,2.71l0.71,3.75l-0.22,0.12l-0.57,-0.92l-0.68,-0.42l-1.15,-0.07l-1.27,0.64l-1.75,1.52l-0.56,-0.6l-3.4,0.07l-2.2,1.77l-0.26,1.1l0.65,0.74Z",name:"Alpes-Maritimes"},"FR-07":{path:"M577.55,476.22l1.11,-1.41l2.95,-0.55l0.74,-0.72l-0.0,-0.72l-1.19,-1.6l2.16,-2.5l-0.86,-2.16l1.27,0.23l1.38,1.13l0.92,-0.02l0.45,-0.42l0.63,-2.87l1.86,-3.84l0.13,-1.54l-0.32,-0.45l7.61,-0.57l0.23,-1.28l-0.35,-2.29l0.79,-1.72l1.18,-0.9l5.42,-2.49l2.64,-0.46l0.25,1.75l0.5,1.07l1.67,1.89l-0.05,1.4l0.31,0.32l-0.26,3.51l0.16,2.41l0.8,2.99l-0.27,3.52l1.29,0.96l-0.12,0.95l1.02,1.63l-0.44,3.35l0.44,1.57l1.71,2.65l0.36,1.15l-1.81,5.39l-1.82,1.73l-0.54,1.53l-2.15,1.83l-1.09,2.24l-0.14,2.08l1.66,4.33l-0.4,2.69l-2.95,3.83l-1.23,2.68l-1.1,7.4l-2.03,4.07l0.16,0.54l-0.95,6.57l0.01,2.92l-3.85,-1.27l-2.16,-2.01l-1.95,-0.76l-3.44,0.06l-0.76,0.36l-0.51,0.78l-0.28,1.65l-1.3,0.63l-1.06,-0.63l0.11,-1.94l-0.77,-0.99l-1.14,-0.12l-1.89,0.45l-5.53,3.89l-1.17,-0.23l-4.88,-2.4l-1.24,-1.11l-4.78,0.52l-0.65,-3.42l0.81,-1.28l-0.09,-1.09l-1.77,-2.77l-1.61,-1.3l-2.22,-6.93l-0.89,-1.48l-1.35,-0.86l-0.56,-0.98l-0.68,-1.98l-0.52,-3.12l-1.27,-3.49l0.05,-2.72l1.27,-0.58l3.25,-4.5l3.93,-1.27l1.08,-2.19l2.26,0.12l4.33,-0.67l1.51,-0.63l2.02,-2.74l1.34,-3.3l0.62,-0.22l1.42,0.25l2.97,-1.28l0.14,-1.25l-0.57,-1.03Z",name:"Ard\xe8che"},"FR-08":{path:"M573.11,91.52l3.32,-0.4l9.73,2.22l1.91,-0.29l8.49,-3.54l2.64,-0.38l0.81,-0.51l1.03,-2.26l0.49,-2.73l-0.42,-1.4l0.42,-1.14l6.43,-5.47l1.16,-0.45l0.17,0.74l0.95,0.53l1.9,-0.28l0.3,0.34l-0.46,3.48l-0.42,-0.16l-0.65,0.28l-1.15,2.13l-0.07,2.33l-2.32,4.87l-0.3,1.37l0.89,1.44l2.96,1.1l0.83,1.27l-0.04,1.46l-1.51,3.13l0.87,1.86l0.09,3.19l0.8,0.73l1.6,0.19l4.15,-0.98l1.14,-0.05l0.97,0.46l2.32,1.92l3.4,1.12l3.27,3.72l2.07,1.47l1.72,0.4l3.86,-0.67l2.26,2.11l0.31,0.88l-0.71,0.59l-0.19,1.13l0.55,1.39l1.85,0.16l0.97,-1.0l2.53,0.92l0.24,0.19l-0.05,0.81l-6.21,3.82l-0.34,-0.04l-0.49,-0.99l-0.68,-0.39l-3.82,0.0l-2.25,-1.55l-1.05,-0.35l-1.15,0.2l-1.35,1.12l-0.38,0.72l-0.36,3.28l-1.46,1.89l0.74,2.38l1.02,0.78l0.75,2.44l-0.1,1.25l-1.08,2.51l-3.38,4.46l0.01,1.28l0.73,2.15l-3.98,3.18l-2.32,-1.4l-2.13,0.05l-4.27,1.39l-6.83,-1.28l-5.3,1.34l-0.89,-0.62l-1.22,-2.2l-1.55,-1.05l-1.7,-0.2l-6.2,0.85l-1.94,-0.43l-2.29,-2.8l-2.67,-0.15l-0.88,-0.49l-1.45,-1.44l-6.0,-4.02l-2.07,-0.61l-6.54,-0.45l-0.4,-0.92l-0.68,-0.44l0.36,-0.58l1.56,-0.48l0.31,-0.52l-1.78,-3.16l0.25,-1.03l1.13,-0.91l0.39,-0.79l-0.38,-2.04l0.46,-1.54l-1.6,-4.48l0.75,-0.67l1.86,-0.09l1.55,-0.83l1.47,-2.03l1.72,-1.03l3.2,-2.67l0.94,-1.48l0.01,-1.35l-1.51,-2.11l0.44,-2.67l1.83,-3.2l0.19,-1.43l-0.27,-1.06l-1.76,-2.77l-0.03,-2.56Z",name:"Ardennes"},"FR-09":{path:"M418.24,606.75l-0.29,1.54l0.8,2.04l0.24,1.92l0.48,0.75l3.51,2.37l4.07,1.14l2.5,1.26l2.66,0.27l1.08,0.84l0.66,1.11l0.15,1.08l-1.08,1.79l1.93,1.96l1.1,3.87l-0.38,0.48l-2.23,0.75l-0.49,1.18l2.08,1.84l0.62,2.74l-0.3,0.38l-2.78,1.03l-1.69,-0.0l-1.08,0.43l-1.46,2.27l0.23,0.77l1.63,0.67l0.9,0.82l0.09,2.3l0.54,0.69l2.38,1.32l1.14,0.3l6.15,-0.98l1.95,2.33l2.97,1.46l0.54,0.91l-0.2,0.8l-0.35,0.18l-3.39,-0.53l-6.47,0.84l-2.14,2.49l-0.42,2.59l-1.41,1.09l-3.35,-0.73l-6.66,0.81l-0.58,-0.62l-2.03,-0.75l0.42,-1.19l-0.34,-0.53l-6.9,-0.61l-4.12,-2.32l-2.77,0.67l-1.86,-0.09l-0.4,0.28l-0.88,2.73l-0.91,0.33l-0.66,-0.77l-1.07,-2.58l-2.23,-3.15l-1.29,-0.49l0.21,-0.83l-0.29,-0.49l-1.53,-0.36l-7.55,-0.02l-2.58,0.53l-0.9,-0.58l-1.64,-3.14l-1.32,-1.06l-1.36,-0.37l-5.14,-0.31l-1.98,-1.15l-1.93,0.82l-1.92,-1.37l-1.71,-0.61l-1.37,-5.0l0.27,-1.51l1.85,-1.22l0.45,-1.83l0.46,-0.57l1.64,0.0l2.6,-0.62l1.31,-0.73l1.08,-1.1l0.45,-1.8l-0.66,-3.57l0.04,-1.54l0.44,-0.83l2.59,-1.15l1.0,-2.04l0.48,-0.39l1.42,0.0l1.96,-0.78l0.71,0.04l3.3,1.87l1.98,2.72l1.28,0.28l3.23,-2.67l0.04,-0.55l-1.04,-1.27l-2.95,-1.28l-0.15,-0.52l0.76,-0.88l4.09,-0.47l2.73,-0.96l1.52,-0.93l0.72,-1.27l-0.05,-0.44l-0.95,-1.03l-3.22,-1.18l-0.68,-0.75l0.21,-1.57l0.95,-0.54l1.39,0.16l1.24,0.65l2.71,2.5l-0.22,2.41l1.88,1.37l1.81,-0.13l1.54,-1.1l0.92,-2.0l-0.93,-2.11l0.32,-0.65l0.79,-0.2l3.53,2.42l2.17,-0.13l1.54,1.52l1.28,-0.4l1.47,-1.74l1.11,0.38Z",name:"Ari\xe8ge"},"FR-RE":{path:"M761.79,701.36l1.08,0.18l1.12,-0.39l1.21,0.39l2.77,-0.03l2.17,1.11l3.51,0.8l0.97,0.55l2.4,2.39l0.54,1.06l0.32,2.77l0.52,1.06l1.9,1.97l0.91,3.81l1.85,0.93l1.43,2.47l3.94,1.89l0.84,0.82l0.32,1.39l-1.08,2.72l-1.31,6.18l-0.27,4.98l-0.6,1.25l-1.42,0.53l-4.24,0.16l-2.56,1.32l-1.76,0.26l-1.74,-0.1l-1.22,-0.48l-1.58,0.46l-1.92,0.08l-3.62,-0.55l-3.79,-2.43l-5.72,-1.87l-1.23,-0.75l-1.75,-2.11l-3.42,-0.26l-3.52,-4.42l-0.9,-1.55l-0.63,-4.75l-3.33,-4.36l-1.6,-3.39l0.0,-1.42l0.43,-1.55l0.75,-1.19l2.55,-1.05l1.15,-1.41l0.43,-1.65l-0.32,-1.19l0.55,-0.82l-0.29,-0.86l0.61,-0.27l2.76,-0.09l5.6,-3.4l4.93,-0.0l2.25,0.81Z",name:"La R\xe9union"},"FR-75":{path:"M465.44,178.43l-0.81,2.42l-0.63,0.32l-6.66,-0.1l-4.66,-1.66l-1.08,0.25l-0.35,-1.01l0.33,-1.1l1.86,-2.31l6.5,-0.01l0.75,0.27l1.32,1.54l1.0,0.67l2.45,0.72Z",name:"Paris"},"FR-74":{path:"M679.63,390.63l1.41,-0.73l2.69,-0.56l2.68,-0.09l2.31,0.77l2.11,-0.97l3.09,-3.14l3.94,-2.28l1.58,-1.45l-0.19,-2.13l-0.68,-0.47l-1.16,0.35l-0.4,-0.18l-0.89,-2.03l4.08,-5.7l3.32,0.16l1.15,1.46l0.93,0.33l0.77,-0.37l0.82,-1.0l4.35,-1.83l1.15,-1.48l11.95,-1.05l5.16,0.78l0.08,0.91l-0.38,1.12l-1.55,1.58l-0.38,1.39l1.23,1.83l2.14,1.97l1.23,1.83l-2.07,3.51l-1.08,2.81l-0.54,2.86l0.83,1.53l4.77,0.91l0.69,0.58l-1.17,1.69l0.25,3.27l1.29,0.49l1.46,-0.85l1.18,0.45l4.32,4.17l1.84,4.74l-1.27,1.06l-1.66,3.08l-1.14,0.85l-2.54,0.9l-1.94,0.05l-0.44,1.16l-1.45,-0.68l-2.69,0.96l-0.98,1.38l-0.34,1.34l0.04,2.12l-4.13,2.65l-0.73,-0.03l0.35,-2.15l-1.24,-1.81l-2.0,-0.99l-2.81,-0.28l-1.03,-0.51l-1.81,-1.57l-0.56,-1.14l1.0,-1.78l0.02,-1.93l-1.76,-1.43l-1.59,-0.03l-3.28,3.19l-0.87,1.3l-1.24,3.11l-0.67,0.83l-2.92,2.02l-1.3,3.76l-1.06,1.36l-1.32,0.92l-1.47,0.48l-1.52,0.03l-0.54,-0.18l-2.86,-3.29l-1.72,-1.36l-1.97,-0.89l-2.29,-0.03l-1.84,1.2l-1.36,0.1l-2.67,-0.73l-1.01,-0.85l-0.99,-3.12l-1.13,-0.8l-3.31,-0.61l-0.71,-0.81l-0.96,-6.52l-0.65,-1.13l-1.01,-0.37l-0.98,-8.24l0.06,-3.25l0.91,-0.87l0.83,0.89l0.88,0.31l1.03,-0.56l1.55,-2.09l1.78,0.11l1.01,-0.3Z",name:"Haute-Savoie"},"FR-77":{path:"M527.01,179.34l-0.11,1.1l-0.51,0.67l-2.55,0.08l-0.94,0.42l-0.16,0.75l1.09,1.07l-1.54,1.52l-0.27,1.55l0.54,0.66l1.24,-0.02l1.67,1.83l0.7,2.85l-0.5,1.9l0.28,1.65l0.9,0.56l2.22,-0.3l1.49,1.83l-2.45,1.85l-1.06,1.42l-0.92,2.34l-0.48,0.4l-2.35,0.42l-0.63,0.51l-0.08,0.73l0.94,1.41l-1.79,1.84l-0.05,0.79l0.65,1.23l-0.56,2.16l0.16,0.69l-1.39,1.3l-0.9,1.45l-0.77,0.1l-1.91,-0.46l-6.17,0.91l-4.68,-0.48l-2.32,0.9l-3.26,0.0l-0.8,0.78l-1.15,3.24l0.03,1.71l0.9,2.26l-1.5,2.46l-3.77,2.32l-0.95,3.37l-6.65,1.88l-0.6,-0.12l0.46,-1.24l-0.4,-0.63l-0.91,-0.28l-1.66,0.13l-1.16,0.39l-1.65,1.59l-1.87,0.81l-8.32,-0.58l-4.04,0.66l-1.59,-0.77l0.02,-0.63l0.53,-0.53l2.04,0.27l0.77,-0.41l0.21,-0.87l-0.51,-1.19l0.65,-0.98l0.18,-1.12l-1.38,-1.72l-3.43,-1.97l-0.96,-3.2l-1.72,-2.25l5.65,-5.46l1.78,-1.03l0.76,-0.92l-0.07,-0.57l-1.16,-0.88l-0.12,-0.46l-0.39,-5.8l1.51,-4.97l0.18,-3.88l0.77,-1.17l2.31,-2.12l-0.19,-2.68l1.31,-1.81l0.38,-1.59l-0.6,-6.14l-1.09,-2.66l0.08,-1.07l1.2,-3.57l0.0,-1.26l-1.33,-2.97l0.48,-1.75l-0.39,-0.89l-0.98,-0.66l0.63,-1.27l0.34,-2.93l0.59,-1.15l2.39,-0.95l1.28,0.25l1.79,1.42l0.99,0.02l1.16,-0.44l1.27,0.83l1.39,0.28l2.4,-1.49l4.01,0.91l5.72,-1.07l1.57,0.83l2.35,-1.11l1.82,-0.03l2.03,-1.04l3.48,0.96l0.98,1.05l0.87,1.67l-0.52,2.79l0.73,1.41l8.88,6.73l0.87,0.26l1.23,-0.5l0.48,0.14l0.61,2.97l0.7,1.03l3.28,1.81l2.3,-0.04Z",name:"Seien-et-Marne"},"FR-76":{path:"M421.48,106.09l-2.06,1.53l-2.09,2.85l-0.45,1.3l0.44,0.98l2.53,-0.43l0.4,0.34l-0.82,1.37l-1.94,1.09l-0.47,0.89l0.74,1.37l0.19,3.89l0.54,1.79l0.44,3.63l0.8,0.82l2.01,-0.46l0.65,0.53l-0.4,1.31l-1.05,0.52l-0.47,0.65l-1.01,2.31l-0.24,1.82l-2.08,0.81l-8.41,-3.23l-9.16,-1.1l-2.76,1.06l-1.7,1.98l-2.65,4.9l-0.59,0.43l-4.31,-0.27l-1.66,0.48l-1.22,0.86l-1.39,1.74l-3.89,0.92l-1.17,0.83l-0.65,1.2l0.29,1.23l-0.88,0.29l-0.99,-0.12l-3.87,-2.8l-2.21,-0.65l-1.68,-0.96l-0.59,-1.63l3.05,0.44l0.46,-0.41l-0.17,-2.06l-0.9,-0.89l-2.36,-1.02l-2.91,-2.45l-0.98,-0.39l-5.97,1.34l-2.55,-0.37l-1.75,-2.77l-0.47,-0.17l-2.35,0.47l-1.02,-0.38l-1.98,-2.28l-2.48,-1.7l-0.84,0.03l-4.29,2.28l-4.93,0.6l-4.99,-0.57l-4.35,-1.26l-3.7,-0.45l-1.09,-0.56l-1.65,-2.15l0.22,-1.23l3.15,-4.92l2.42,-6.93l3.76,-2.82l9.31,-3.67l0.73,-0.8l7.56,-3.82l2.18,-0.58l2.37,-1.37l4.68,-1.45l5.32,0.04l25.22,-6.87l1.56,-1.02l1.59,-0.51l2.41,-2.26l6.63,-4.5l8.53,5.05l10.02,8.92l0.82,1.05l0.92,3.13l1.89,2.97l0.77,2.22Z",name:"Seine-Maritime"},"FR-71":{path:"M562.27,336.18l0.34,-0.39l2.2,-0.79l0.73,-1.26l-0.24,-1.31l-2.75,-2.1l0.02,-3.93l-0.92,-0.98l-1.84,-0.56l-0.18,-0.63l0.21,-0.67l2.84,-0.75l0.95,-1.27l0.11,-1.78l-1.0,-2.98l0.55,-2.03l4.19,-0.67l3.55,-1.98l1.28,-0.32l0.94,0.2l2.52,2.56l3.25,1.17l1.71,2.88l0.9,0.16l1.88,-0.56l1.71,2.13l1.13,0.82l4.1,1.22l2.31,-0.15l2.09,4.11l1.21,1.07l3.27,0.91l0.98,2.32l1.15,0.68l1.06,-0.1l1.91,-1.42l3.31,-0.2l7.33,-2.89l5.05,-0.51l3.5,-0.95l1.75,1.53l5.44,-0.2l4.0,-1.74l0.92,0.33l1.55,2.84l3.44,3.22l2.4,1.27l1.61,0.29l1.67,1.37l1.99,0.63l-1.05,1.51l-4.39,0.61l-1.2,1.17l-0.05,0.66l0.39,0.73l1.85,1.61l-0.8,1.32l-0.1,0.94l1.47,1.38l1.77,6.19l-1.03,3.43l-1.83,1.08l-0.81,1.06l-0.2,2.01l0.61,1.51l2.83,1.66l0.43,0.91l-1.02,0.93l-4.32,0.87l-1.26,0.59l-4.14,-0.98l-1.53,-0.8l-2.16,-1.97l-1.58,-0.52l-2.05,0.18l-3.7,1.25l-1.28,0.13l-4.17,-1.37l-0.92,-0.05l-1.3,0.44l-1.85,4.3l-0.85,4.21l-1.47,2.56l-0.15,1.93l-3.53,6.7l-1.32,4.86l0.08,0.87l-2.89,-0.32l-0.98,-0.75l-0.98,-2.54l0.04,-1.79l-1.73,-1.29l-0.18,-1.86l-0.76,-0.6l-1.87,-0.55l-1.12,0.62l-0.53,1.93l-1.03,0.26l-2.35,-2.01l-0.72,0.04l-1.62,0.92l-1.03,0.08l-2.29,-0.51l-2.25,-0.92l-0.92,0.11l-0.68,0.9l-1.27,4.46l-1.74,2.06l-1.51,1.09l-1.62,0.57l-1.65,0.02l-4.83,-1.24l-3.08,0.65l-4.17,-0.93l-4.25,1.28l-1.42,-0.08l-2.06,-1.47l-2.77,-1.06l0.11,-2.73l-0.6,-1.7l5.26,-2.58l1.52,-1.33l0.08,-0.97l-0.86,-1.29l0.04,-1.38l-0.52,-1.25l0.64,-3.0l-0.8,-3.17l-2.08,-1.35l-4.18,-0.89l-2.7,-2.24l-1.72,-0.07l-3.83,-1.94l0.37,-3.1l-0.38,-1.88l-1.07,-0.72l-1.57,-2.64l-2.41,-2.14l-0.47,-1.58l-1.23,-1.99l6.23,-0.88l1.46,0.86l2.65,2.87l0.44,0.1l1.46,-0.58l1.52,-1.21l3.71,-1.21l4.85,-2.87l3.05,-0.59l0.49,-0.7l0.09,-2.12l-0.8,-1.29Z",name:"Sa\xf4ne-et-Loire"},"FR-70":{path:"M732.55,259.44l-2.88,3.17l-1.2,2.11l-0.42,2.48l1.68,5.43l0.2,3.95l1.28,2.06l-0.19,0.86l-1.42,1.33l-4.67,-1.11l-2.25,0.63l-1.97,1.28l-2.26,-0.42l-1.03,0.82l-1.64,2.83l-3.01,-1.42l-0.7,0.17l-0.94,0.9l-1.98,-1.56l-1.16,-0.14l-5.54,0.9l-1.91,1.17l-1.98,4.16l-0.8,0.72l-3.35,-0.18l-1.04,0.81l-1.02,1.85l-0.9,0.3l-2.2,-0.03l-2.92,2.94l-4.6,1.44l-4.42,-0.47l-11.89,6.05l-3.92,-0.48l-4.0,0.76l-3.44,-1.66l-0.69,-0.66l-0.63,0.02l-0.84,-1.07l-0.56,-4.91l-2.21,-1.91l-0.59,-3.43l-0.81,-0.72l-1.67,-0.59l0.44,-1.97l0.7,-0.55l1.95,-0.44l2.03,-2.43l0.31,-1.4l-0.34,-1.34l-0.93,-1.42l0.2,-1.34l-0.22,-0.65l-1.0,-1.07l-0.91,-0.31l-0.83,0.13l-1.8,1.57l-1.46,-0.6l2.09,-4.03l1.01,-0.53l3.99,-0.6l3.21,1.65l1.53,0.3l6.58,-1.86l0.7,-0.44l0.69,-0.83l0.2,-0.97l-0.19,-2.21l0.55,-2.48l-0.58,-2.14l0.19,-0.51l0.63,-0.82l6.42,-3.94l2.41,-2.91l2.03,-0.75l0.4,-0.92l-0.24,-0.87l1.66,-0.91l1.8,-2.61l0.31,0.88l-0.17,1.53l0.84,0.59l3.53,-2.14l2.66,-2.84l1.54,-0.3l2.78,0.53l1.12,0.68l0.83,1.02l-0.06,1.28l0.31,0.67l3.72,1.77l2.64,-0.19l2.39,-1.21l3.0,-0.19l2.26,0.8l5.28,2.92l1.38,0.35l2.17,-0.03l1.59,-0.57l1.93,-2.36l0.72,-0.14l3.61,3.45l3.4,1.51l5.45,3.8Z",name:"Haute-Sa\xf4ne"},"FR-73":{path:"M658.46,427.8l1.73,-0.16l4.42,-4.15l2.23,-1.04l0.99,-1.05l0.84,-2.26l0.46,-3.28l2.91,-7.66l0.55,-2.73l0.4,0.1l0.46,0.75l0.65,5.41l0.44,1.39l1.0,1.06l3.47,0.68l0.76,0.58l0.53,2.21l0.99,1.46l2.07,0.99l1.65,0.28l1.63,-0.15l1.83,-1.19l1.78,0.03l1.77,0.79l1.66,1.31l2.85,3.29l1.02,0.37l1.77,-0.06l1.58,-0.52l1.6,-1.13l1.2,-1.57l1.17,-3.53l2.91,-2.03l0.8,-1.02l1.25,-3.12l0.78,-1.16l2.92,-2.92l0.45,-0.1l1.07,0.4l0.92,1.0l-0.17,1.13l-1.03,1.87l0.69,1.7l2.0,1.78l1.23,0.62l2.94,0.32l1.7,0.87l0.94,1.44l-0.47,2.15l0.38,0.48l1.56,-0.02l3.93,-2.52l0.65,2.99l1.41,1.87l1.65,1.08l2.44,0.57l2.19,1.73l2.63,0.83l0.29,0.87l-0.98,2.48l1.03,2.1l0.33,3.09l0.49,1.22l5.55,3.27l1.58,2.67l3.47,1.57l0.2,0.81l-1.73,3.0l-2.31,2.53l0.24,2.49l0.65,1.55l0.0,0.91l-1.6,1.21l-1.33,1.99l-0.85,-0.84l-0.72,-0.2l-4.4,1.41l-2.78,3.01l-2.44,0.32l-0.53,0.84l0.54,1.12l-1.68,0.71l-4.26,-1.68l-2.26,-0.35l-2.28,1.23l-2.07,0.11l-2.41,1.23l-1.98,0.23l-2.21,1.2l-2.53,0.08l-0.73,0.39l-0.94,2.26l-0.81,0.88l-1.02,0.26l-3.86,-1.22l-0.85,-1.84l-1.43,-1.0l-4.54,-0.57l-0.87,-0.62l-0.8,-1.5l-1.95,-0.61l-3.81,-0.24l-0.27,-2.67l-1.39,-5.1l0.11,-1.29l0.63,-1.24l2.75,-2.38l0.41,-2.05l-0.5,-2.06l-1.14,-1.71l-2.71,-2.72l-0.85,-0.35l-4.2,-0.4l-3.65,-2.95l-2.4,-0.56l-1.35,0.34l-1.1,0.96l-0.35,5.75l-8.79,-3.19l-0.82,-0.79l-7.95,-14.1Z",name:"Savoie"},"FR-72":{path:"M351.4,270.06l0.02,0.93l-2.17,0.43l-3.23,1.43l-2.52,0.52l-1.04,0.58l-0.9,0.99l-1.95,-0.85l-1.07,0.0l-0.78,0.53l-0.36,0.7l0.4,2.57l-5.8,-1.04l-6.07,-1.69l-0.5,0.27l-0.57,1.88l-1.08,0.05l-3.11,-1.35l-2.23,-0.37l-6.66,-3.2l-3.43,-0.45l-0.68,0.27l-0.86,1.05l-1.16,0.43l-1.42,-0.29l-1.32,-0.88l-0.81,-1.26l-0.1,-1.37l1.2,-0.92l0.27,-0.59l-0.87,-1.29l-0.99,-0.13l-2.11,1.18l-9.84,-4.01l1.52,-1.18l0.27,-1.75l-0.32,-0.43l-2.15,-0.41l-0.74,-0.43l-0.62,-0.89l0.02,-0.71l2.8,-1.29l0.77,-0.83l0.19,-1.25l-0.86,-1.98l0.51,-1.45l1.22,-0.73l2.99,-0.23l1.11,-0.49l0.65,-0.82l0.05,-1.28l-0.48,-1.18l-2.27,-2.6l-0.42,-0.77l0.21,-0.82l4.77,-1.14l1.85,-1.48l0.52,-2.07l-0.91,-2.91l0.27,-2.05l4.53,-2.75l1.2,-2.44l-0.88,-8.62l0.85,-1.78l0.67,-0.45l7.89,-1.16l3.37,0.46l0.6,-0.45l0.44,-1.41l2.46,-0.81l2.23,-2.53l2.43,-1.15l5.27,-1.07l1.66,0.18l3.55,1.66l0.35,1.07l-0.32,2.68l0.3,3.32l0.87,2.03l1.63,1.4l1.84,0.94l2.82,-0.07l0.41,2.48l1.13,0.63l5.3,1.27l2.3,0.07l0.97,-0.32l1.62,1.39l1.93,2.55l2.19,1.39l1.53,0.31l1.53,-0.36l2.97,1.92l3.09,0.38l0.63,0.45l-0.41,0.52l-4.24,2.22l-0.26,1.28l1.21,1.18l-2.67,0.5l-0.68,0.75l0.01,0.82l1.12,2.05l1.71,0.46l-0.65,3.22l0.42,1.92l-0.62,1.15l-3.06,2.39l-0.56,1.67l-0.05,3.43l-1.51,4.18l-1.33,1.2l-1.74,0.98l-3.44,1.47l-1.46,1.3l-0.79,1.81l0.48,1.28Z",name:"Sarthe"},"FR-79":{path:"M307.7,318.83l1.01,2.11l0.31,2.12l0.43,0.78l1.59,0.62l0.51,0.63l-0.04,1.91l1.71,5.06l2.48,2.93l-0.11,0.87l-0.46,0.4l-1.76,-0.04l-0.36,0.34l-0.18,1.29l0.21,3.21l1.5,1.72l0.3,0.95l-0.7,2.37l-1.66,2.9l-0.27,1.28l0.15,1.41l0.77,1.23l1.89,0.75l0.18,0.78l-1.63,4.28l-1.29,1.43l-0.35,0.87l0.03,2.17l1.17,1.4l0.04,4.29l0.67,1.2l1.43,1.29l-0.04,2.02l0.5,1.39l1.12,1.37l1.4,0.93l1.33,-0.26l1.92,-2.12l0.98,-0.48l0.98,0.03l1.05,0.86l0.28,1.47l-0.35,1.7l-0.79,1.42l-2.24,2.67l-0.55,1.15l-0.3,1.85l0.85,1.39l4.2,1.72l0.65,0.44l0.28,0.88l-0.61,2.2l0.12,0.72l-0.77,0.42l-2.59,-1.26l-3.0,0.43l-3.33,1.46l-2.96,2.31l-3.1,5.17l-2.17,0.89l-1.1,-0.39l-3.28,-3.64l-5.12,-3.24l-2.81,-0.86l-4.02,-0.1l-3.17,-2.08l-1.48,-0.19l-2.64,0.33l-2.25,-2.14l-1.36,-0.65l-3.99,-0.28l-1.25,-0.8l-5.25,-5.83l-1.47,-0.94l0.45,-0.86l0.02,-1.06l-0.75,-1.98l3.3,-1.6l2.86,-0.19l2.34,-2.04l2.9,-0.42l0.56,-0.59l0.18,-0.79l-0.96,-1.5l-2.15,-1.52l-1.48,-0.05l-0.2,-0.92l0.59,-2.98l-0.97,-4.09l1.47,-2.55l-0.66,-4.53l-1.62,-2.86l-0.6,-3.2l-3.78,-6.41l-0.05,-0.67l0.83,-1.82l-0.25,-0.71l-1.96,-1.84l-3.53,-1.93l-0.97,-1.29l-0.82,-3.62l-0.91,-1.07l-1.53,-0.78l-2.22,-3.06l-2.05,-1.29l0.28,-0.66l0.72,0.13l4.34,1.93l4.31,-0.56l5.13,0.68l3.99,-0.34l1.28,-0.41l1.37,-1.03l2.73,-1.24l0.34,-1.13l-0.81,-1.37l1.0,-0.85l1.73,-0.42l2.13,0.74l5.97,-1.69l6.45,-0.7l3.52,0.09l1.83,-0.35l1.08,0.56l1.0,2.22l1.71,0.55l0.63,-0.49Z",name:"Deux-S\xe8vres"},"FR-78":{path:"M418.01,161.81l0.47,1.62l1.53,0.32l3.71,-1.8l2.31,-0.25l0.99,0.35l0.64,0.72l0.72,2.92l0.93,1.67l0.47,0.18l3.61,-1.19l1.99,0.28l1.59,2.11l-0.41,1.35l0.52,1.33l1.23,0.51l1.54,-0.92l1.78,-3.26l1.06,-0.33l3.04,0.23l1.68,0.75l-0.28,1.59l-2.23,1.75l-0.89,2.2l0.17,2.13l0.34,0.36l1.31,0.21l0.05,2.93l0.86,2.02l3.06,2.77l-5.57,1.66l-0.64,0.67l-1.39,3.89l-1.84,0.37l-0.95,0.59l-0.89,1.34l-0.26,1.51l0.54,3.15l-0.45,2.53l-0.65,1.03l-0.75,0.35l-2.82,0.14l-0.66,0.79l-1.85,7.72l-2.31,0.34l-4.37,-1.8l-0.92,-0.66l-1.17,-1.71l0.01,-2.65l-0.44,-1.51l-0.7,-0.87l-2.25,-1.46l-0.79,-2.45l-3.87,-2.43l-1.32,-1.5l-0.63,-1.5l-1.41,-0.91l0.0,-0.93l1.6,-2.06l0.18,-1.09l-0.28,-0.53l-1.69,-0.85l-0.41,-0.65l-0.06,-1.41l0.53,-2.41l-0.31,-1.9l-1.49,-1.94l-3.28,-5.55l-0.4,-2.82l-2.11,-0.85l0.25,-2.13l-0.72,-1.71l0.41,-0.57l7.7,-1.56l2.34,-1.08l4.31,0.9Z",name:"Yvelines"},"FR-YT":{path:"M678.38,715.39l-0.52,0.0l-2.02,-6.29l2.65,-2.73l0.87,2.15l0.24,2.21l-0.38,2.26l-0.84,2.4ZM647.49,692.27l-1.04,0.75l-0.14,0.46l1.6,0.36l0.6,0.88l2.18,1.87l2.93,3.52l1.63,1.28l2.49,0.62l4.96,-0.04l2.61,0.78l2.6,1.74l1.05,1.73l0.02,2.1l-0.68,2.82l-3.71,5.46l-1.53,1.19l0.14,2.09l1.04,1.92l2.81,1.86l-0.3,1.89l-3.07,6.4l-2.6,3.07l-1.21,3.45l2.82,4.18l-1.15,1.69l-1.53,1.06l-0.76,-1.37l-0.41,-0.2l-1.1,0.17l-1.53,1.03l-1.83,0.51l-1.63,-0.43l-2.25,-1.33l-1.24,0.41l0.12,-1.88l-0.84,-1.8l-1.74,-0.77l-1.92,0.17l0.0,-0.31l2.91,-1.61l0.29,-2.68l-1.49,-2.81l-2.83,-1.57l0.22,-0.43l1.06,-0.67l1.55,-0.14l0.82,0.5l2.83,3.33l2.81,1.68l1.89,-0.73l0.6,-2.42l-0.76,-2.88l-1.37,-2.17l-1.74,-1.96l-4.21,-3.56l2.58,-0.75l0.36,-0.4l-0.07,-1.34l-0.91,-1.33l-0.68,-2.3l-0.55,-4.71l-0.6,-2.37l-1.57,-1.23l-1.87,-0.61l-1.59,-1.03l-1.74,-2.81l-0.41,-4.1l7.31,-7.87l0.59,1.27l-0.82,0.34Z",name:"Mayotte"},"FR-66":{path:"M419.41,662.94l0.18,-1.54l0.62,-1.4l0.95,-0.83l6.33,-1.23l1.62,-0.04l2.87,0.76l1.42,-0.31l1.24,-1.33l0.24,-2.08l0.4,-0.91l1.5,-1.63l6.16,-0.76l3.36,0.54l0.91,-0.41l1.55,0.66l1.74,-1.21l2.82,-2.93l2.32,0.28l1.26,-0.26l1.25,-0.79l0.69,-1.19l-1.22,-6.76l0.48,-0.85l1.85,-0.65l20.21,0.96l1.72,-0.54l3.27,-3.63l4.2,-1.71l2.09,1.3l9.15,4.22l-0.42,6.18l0.26,1.92l-0.34,3.08l0.88,9.52l1.12,1.26l4.27,1.24l0.37,0.52l-0.12,1.76l1.98,2.59l0.3,1.34l-2.29,0.36l-3.05,-0.09l-1.83,-0.7l-1.61,-2.13l-2.87,-0.28l-1.16,0.57l-2.17,-0.57l-1.94,1.35l-3.1,0.24l-3.76,2.65l-4.83,-0.08l-1.22,0.53l-2.65,1.86l-0.57,0.72l0.5,1.8l0.52,0.57l-2.26,-0.17l-2.79,-0.85l-1.31,0.01l-0.83,0.63l-0.48,1.11l-0.67,0.22l-2.94,-1.07l-1.08,-0.76l-1.67,-2.44l-2.78,-0.4l-6.16,-2.91l-1.99,0.2l-3.71,1.04l-3.02,-0.29l-1.14,0.54l-1.01,1.86l-2.45,1.95l-0.62,0.36l-2.45,0.36l-0.71,-0.1l-1.77,-1.24l-1.32,-3.75l-1.07,-1.5l-3.53,-0.74l-3.45,-2.1l-1.38,-0.5l-3.76,-0.46l-0.8,-0.3l-0.31,-0.6ZM436.08,668.09l0.96,-0.22l0.2,-0.59l-1.32,-2.33l-0.63,-0.79l-0.47,-0.12l-0.9,0.48l-0.67,1.33l0.07,1.16l0.97,0.84l1.79,0.25Z",name:"Pyr\xe9n\xe9es-Orientales"},"FR-67":{path:"M749.43,204.53l5.77,-0.36l0.71,-0.43l0.65,-1.16l2.35,-1.16l0.73,-0.71l0.93,-1.77l1.44,-4.66l-0.53,-0.88l-1.5,-0.78l-0.14,-0.62l2.91,-4.3l0.33,-1.37l-0.57,-1.43l-3.83,-3.82l-1.83,-0.81l-0.15,-1.32l-0.77,-0.76l-0.74,0.09l-0.54,0.56l-0.45,1.75l-2.17,0.87l-1.14,1.58l-1.05,0.07l-0.85,-1.8l-0.77,-0.61l0.26,-0.79l0.96,-0.95l-0.06,-1.04l-5.03,-1.96l-1.91,-1.6l-0.2,-0.81l0.44,-1.33l0.89,-1.07l2.61,-2.08l0.31,-1.9l2.13,-2.7l-0.21,-1.76l0.28,-0.4l1.23,0.18l0.29,0.32l0.81,2.78l0.94,1.02l8.51,2.56l1.02,1.76l1.21,0.68l1.4,0.29l2.12,-0.08l7.03,-1.14l3.26,1.63l1.38,-0.12l0.76,-0.45l1.05,-1.41l1.35,-2.8l1.9,-2.92l2.27,-0.55l2.64,0.55l2.77,-0.96l5.0,1.23l4.59,-0.2l9.65,4.37l6.29,1.29l-1.02,1.01l-1.91,3.08l-2.79,6.52l-0.7,1.0l-3.2,1.38l-0.7,0.85l-0.46,1.3l-2.12,0.14l-0.95,0.41l-0.65,2.78l-3.8,3.45l-2.72,1.47l-2.58,3.44l-0.59,2.73l-0.01,2.81l0.72,2.0l-2.23,1.72l-0.47,2.28l-1.12,1.98l-0.77,3.01l-0.07,1.2l0.89,2.96l-0.06,0.91l-0.71,0.98l-2.24,1.43l-0.92,4.51l-4.46,5.68l-0.61,2.23l-1.29,2.14l-2.85,-0.38l-0.93,-1.96l-2.43,-0.53l0.39,-2.66l-0.86,-1.15l-9.78,-4.05l-0.93,-2.72l-1.79,-0.58l-3.01,-0.19l-0.06,-0.79l-1.49,-1.39l-3.3,-0.17l-1.31,-0.59l-0.23,-0.56l0.82,-2.61l0.59,-7.58l1.09,-1.01l0.02,-0.68l-3.11,-1.58Z",name:"Bas-Rhin"},"FR-64":{path:"M204.81,598.27l0.63,0.4l0.52,-0.08l1.38,-0.84l5.64,-0.92l1.36,-1.72l2.57,-1.46l2.17,-3.85l2.64,-3.02l2.34,1.93l1.96,0.84l3.62,-0.6l4.13,-0.08l2.15,-0.46l2.54,-1.24l2.39,-2.3l1.4,0.72l0.29,0.8l-0.18,2.62l1.09,1.13l0.44,0.09l4.3,-2.38l2.57,1.36l1.05,0.16l1.13,-0.26l1.13,-0.65l0.53,-1.09l-0.02,-1.16l3.11,0.76l1.49,-0.99l2.78,0.18l3.59,-1.69l2.16,0.06l2.94,1.44l2.65,-0.72l6.78,1.04l1.02,-0.26l5.11,-3.37l0.44,0.14l-0.23,1.88l1.48,0.88l6.8,-0.81l3.48,-1.38l3.8,-0.5l5.59,1.04l1.06,0.66l0.67,1.47l1.56,1.16l2.16,4.89l-0.31,0.26l-1.15,-0.07l-0.56,0.49l0.03,2.28l0.52,0.69l0.76,0.17l1.43,-1.29l0.75,0.02l-0.11,3.16l1.06,3.23l-0.48,0.48l-1.62,0.52l-0.96,1.06l-0.61,2.64l0.6,2.08l-0.4,0.75l-1.97,1.89l-1.1,3.23l-1.55,0.13l-1.74,2.98l-2.28,1.29l-0.98,1.23l0.15,3.83l-0.4,0.28l-2.98,0.33l-2.69,2.77l-0.17,0.81l0.39,1.61l-0.03,1.69l-1.67,2.29l-0.35,1.23l0.55,3.77l-0.88,-0.07l-0.78,1.18l-0.86,-0.35l-4.31,2.79l-1.69,0.12l-3.22,-1.34l-1.7,-0.07l-0.41,0.38l-0.09,1.49l-1.58,0.74l-0.62,-1.55l-1.55,-0.25l-0.08,-0.92l-2.44,-2.91l-3.24,-2.0l-1.85,-0.11l-0.47,-0.41l-0.25,-0.49l0.25,-1.36l-1.4,-2.86l-1.82,-0.51l-4.68,0.75l-4.79,-0.35l-2.24,-0.65l-2.95,-2.22l-3.08,-0.49l-2.02,-1.09l-2.32,0.15l-4.04,-2.44l-3.6,-0.59l-1.04,-0.56l-0.92,-0.94l-0.21,-0.75l0.38,-0.75l1.21,-0.93l-0.15,-0.71l-1.6,-0.32l-1.53,0.56l-1.05,1.06l-0.53,1.66l-0.16,1.94l-0.41,0.78l-2.38,0.12l-2.68,-0.98l-1.02,-1.03l-0.63,-1.32l3.7,-3.88l0.95,-2.41l0.66,-2.96l-0.35,-3.1l-2.03,-1.72l-2.04,0.3l-2.51,-1.16l-3.21,-0.56l-1.3,0.75l-0.75,1.77l-1.7,0.25l-0.8,-0.46l-0.49,-1.68l0.17,-0.84l-0.85,-0.76l-1.84,-0.58l-3.76,1.0l-0.43,-1.87l-0.91,-1.03l-1.52,-0.66l0.07,-2.41ZM309.11,602.32l1.15,-0.9l0.67,-2.47l-0.61,-1.33l-1.64,-0.44l-1.19,0.8l-0.49,2.49l0.63,1.45l1.49,0.4ZM307.84,608.3l0.94,-0.4l1.08,-1.94l-0.6,-1.74l-1.63,-0.95l-0.46,0.07l-1.45,1.45l-0.2,1.38l0.25,1.08l0.52,0.68l1.55,0.37Z",name:"Pyr\xe9n\xe9es-Atlantiques"},"FR-65":{path:"M296.09,638.61l-0.69,-4.39l0.23,-0.9l1.78,-2.58l-0.28,-3.88l2.39,-2.45l2.79,-0.25l0.84,-0.59l0.32,-0.83l-0.41,-1.39l0.02,-1.75l0.72,-0.92l2.37,-1.37l1.67,-2.92l1.05,0.11l0.6,-0.32l1.2,-3.37l1.88,-1.77l0.55,-1.02l0.07,-0.67l-0.62,-1.7l0.51,-2.21l0.68,-0.76l2.02,-0.75l0.42,-0.66l-0.06,-1.09l-0.97,-2.51l0.21,-2.73l-0.21,-0.77l-0.56,-0.5l-0.61,-0.06l-0.78,0.37l-1.02,1.09l-0.38,-0.27l-0.07,-1.71l1.65,-0.19l0.4,-0.55l-0.04,-0.91l-1.88,-4.23l-1.97,-1.72l-0.58,-1.36l-0.95,-0.68l0.87,-0.85l1.51,-0.95l1.62,-0.48l1.39,0.18l0.57,2.55l1.26,2.72l1.24,0.37l3.06,1.7l1.79,0.31l0.52,1.92l1.02,1.53l-0.53,1.94l0.23,1.42l1.31,0.87l1.13,1.6l0.97,0.79l2.03,0.3l4.05,-0.88l0.82,0.14l1.23,1.44l1.4,0.78l0.95,-0.14l1.36,-0.84l1.27,1.95l0.96,0.24l2.74,-0.2l8.19,1.7l0.38,1.06l-2.92,2.88l0.13,2.25l-0.32,0.39l-2.29,0.86l-1.23,1.77l-3.84,3.53l0.07,0.64l7.15,4.1l-1.97,3.94l0.1,1.15l0.5,0.33l0.87,-0.24l1.82,-1.22l1.58,-0.52l2.13,5.0l-3.75,5.0l-1.72,1.29l-3.06,-0.36l-1.37,0.25l-1.04,1.57l-0.46,1.98l-0.12,4.52l0.7,5.23l-2.01,0.47l-2.19,-0.13l-0.39,-1.05l-2.06,-1.35l-1.26,0.44l-2.75,3.06l-0.55,0.07l-2.26,-3.03l-4.46,-1.22l-1.15,0.19l-1.08,0.65l-3.75,0.5l-4.68,1.54l-1.99,0.16l-2.26,-0.8l-1.02,-1.0l-1.36,-0.45l-0.27,-0.97l-1.39,-1.16l-0.66,-0.99l-0.32,-1.14l0.13,-1.21l-0.54,-0.42l-2.76,0.82l-1.36,-0.14l-0.79,-1.35l-3.39,-1.83ZM309.0,601.52l-0.8,-0.16l-0.41,-0.99l0.4,-2.01l0.84,-0.4l0.79,0.28l0.31,0.77l-0.59,2.03l-0.54,0.47ZM307.75,607.5l-0.9,-0.16l-0.53,-1.24l0.07,-0.86l1.14,-1.14l1.03,0.52l0.48,1.4l-0.86,1.31l-0.43,0.15Z",name:"Hautes-Pyr\xe9n\xe9es"},"FR-62":{path:"M413.26,57.99l0.02,-1.01l-3.2,-2.12l1.12,-3.04l0.33,-6.83l1.74,-1.1l0.1,-0.58l-1.61,-2.08l-0.3,-1.01l-0.26,-3.74l-0.64,-3.46l0.26,-2.94l2.0,-4.41l0.34,-1.54l-1.52,-6.24l1.26,-0.84l3.05,-0.71l2.82,-2.96l1.8,-1.42l11.58,-4.22l1.24,0.13l2.03,-1.0l5.25,-0.55l2.42,2.31l4.96,8.43l2.25,6.01l1.42,1.12l1.84,0.6l5.52,-0.1l1.0,0.31l0.46,0.59l-2.34,2.65l-0.02,1.1l0.98,1.29l-0.35,2.13l0.77,0.98l3.22,0.58l2.96,2.38l1.15,0.37l15.06,0.55l1.38,-0.82l1.83,-2.04l1.02,-0.52l0.9,0.15l1.0,0.69l1.3,1.43l-2.22,0.94l-0.91,0.89l-0.4,1.05l0.06,1.66l-1.07,1.87l0.19,1.3l1.07,1.24l1.24,0.31l2.29,-0.59l0.86,0.1l2.28,2.2l3.62,-0.22l1.06,0.77l0.59,2.11l0.72,1.19l2.6,0.82l-0.15,0.97l-2.82,1.98l-0.48,1.75l1.16,1.72l1.53,1.4l0.91,1.31l0.1,0.8l-2.5,2.87l-0.01,1.38l0.7,0.76l0.97,0.21l2.38,-1.03l2.06,0.16l1.0,0.46l1.66,1.62l0.28,0.93l-1.83,1.86l-0.79,1.44l-2.26,8.75l-0.05,1.35l-3.49,-1.73l-2.18,-0.15l-1.29,0.85l-0.01,1.73l-0.42,0.53l-3.52,0.3l-2.63,1.27l-0.35,-0.48l-0.01,-2.43l-0.6,-1.0l-0.66,-0.3l-0.96,0.27l-3.34,2.32l-0.75,-0.07l-0.01,-0.57l1.09,-1.47l-0.03,-1.29l-1.31,-2.12l-0.95,-1.02l-1.19,-0.66l-0.76,0.22l-0.47,0.72l-0.22,3.08l-3.59,-1.54l-3.28,-0.62l0.23,-1.55l-0.84,-0.78l-1.17,-0.0l-1.89,0.86l-2.21,-0.34l-2.47,0.23l-0.82,0.62l-1.01,1.74l-0.72,-0.02l-0.81,-0.93l-0.31,-0.93l0.37,-1.76l1.95,-1.64l2.76,-1.45l0.65,-0.83l-0.19,-0.81l-0.67,-0.61l-2.96,-1.39l-1.81,-0.11l-1.13,0.92l-1.61,-1.74l-0.92,-0.29l-0.8,0.45l-0.34,0.97l-1.02,0.36l-6.98,0.99l-4.57,0.1l-1.52,-1.03l-0.6,-1.14l-0.08,-1.04l-0.83,-0.91l-6.58,-3.15l0.97,-1.81l-1.0,-0.9l-1.27,0.07l-1.48,1.08l-0.5,0.02l-0.91,-0.44l-1.88,-1.99l-1.36,-0.85l-2.32,-0.22l-2.56,0.27l-4.46,1.3l-2.04,-0.71l-1.31,-1.35ZM502.82,75.26l-0.41,-1.74l-0.71,-0.15l-1.47,1.47l-1.82,0.28l-0.4,0.37l-0.14,2.13l0.33,0.42l1.15,0.19l3.31,-0.77l0.35,-0.44l-0.19,-1.76Z",name:"Pas-de-Calais"},"FR-63":{path:"M539.28,403.78l-0.1,0.97l0.42,0.81l2.12,1.59l0.81,1.4l-1.18,2.85l-0.09,2.56l-0.9,1.89l0.2,0.76l1.8,2.84l1.04,0.63l0.51,0.79l3.2,6.42l7.55,6.03l2.43,5.41l0.06,0.97l-0.44,1.28l-0.44,0.82l-2.82,2.97l-0.8,1.5l-0.51,2.35l-4.5,-1.88l-1.24,0.65l-0.7,1.6l-1.04,0.46l-1.35,-0.11l-2.73,-1.3l-0.8,-0.09l-3.34,1.65l-0.8,-0.4l-2.4,-2.99l-3.95,-1.79l-1.72,-0.06l-5.17,1.19l-2.96,-1.53l-1.3,-0.04l-1.64,1.33l-4.08,1.3l-2.15,2.12l-1.79,0.43l-4.22,0.04l-4.2,4.06l-2.11,0.79l-2.63,-1.43l-1.86,-3.64l-1.2,-1.24l-4.3,-1.84l-5.21,0.79l-2.48,-0.15l-2.22,-3.5l-1.67,-0.85l-3.09,-0.68l-3.23,-1.92l-1.25,-0.0l-0.9,-0.64l-0.26,-4.14l-1.44,-1.87l-0.36,-0.94l0.86,-2.7l1.65,-0.68l0.84,-1.03l0.29,-4.28l-0.66,-1.43l-1.92,-2.11l-0.96,-0.86l-1.78,-0.64l-0.67,-1.98l-1.61,-2.01l-0.03,-0.75l3.69,-2.85l2.41,-0.16l2.54,-2.66l1.57,-3.25l1.7,-1.93l0.18,-3.82l-2.07,-4.09l-0.15,-0.82l0.28,-3.52l3.05,0.89l1.97,-0.34l1.66,-1.01l2.79,-3.32l0.51,-3.05l3.68,1.89l1.34,-0.26l0.47,-1.3l0.01,-1.99l1.77,-1.21l2.08,-0.06l1.0,0.54l0.34,0.69l-0.12,2.57l0.62,2.65l1.67,2.57l2.09,2.0l2.1,1.08l4.49,-0.67l1.39,2.21l0.96,0.86l1.28,0.36l5.27,-0.46l4.72,1.15l1.48,1.05l6.11,-1.99l1.07,3.51l-0.05,1.21l0.55,0.39l1.81,-0.75l1.87,-0.1l3.84,0.75l1.44,0.71l2.74,2.26l1.24,0.52Z",name:"Puy-de-D\xf4me"},"FR-60":{path:"M505.12,111.37l0.08,1.16l-0.83,4.81l1.53,3.74l-0.67,5.09l0.09,1.94l0.84,1.77l1.58,0.97l0.42,1.49l-0.66,0.97l-1.93,-0.64l-1.46,0.84l-1.21,4.06l-0.7,1.39l-1.58,0.93l-3.16,0.25l-1.68,1.1l-0.17,0.42l0.21,0.63l2.72,2.49l0.45,1.35l-0.69,1.31l-2.48,1.5l0.11,2.24l0.53,0.91l0.61,0.44l0.8,0.05l3.28,-0.78l1.11,0.02l2.04,0.66l1.38,1.21l0.1,0.94l-1.19,2.18l-3.14,2.31l-2.42,0.25l-2.07,1.06l-1.51,-0.82l-5.87,1.07l-4.04,-0.91l-0.77,0.16l-1.31,1.18l-0.79,0.15l-2.03,-1.11l-1.93,0.48l-1.66,-1.34l-1.69,-0.39l-2.67,0.99l-2.8,-2.54l-1.69,0.38l-11.67,-5.3l-1.4,0.29l-2.01,1.11l-1.55,-0.09l-3.94,-1.5l-2.4,-0.25l-1.47,-0.68l-1.66,-1.28l-0.74,-0.17l-1.89,0.7l-3.44,2.04l-4.01,0.26l-2.09,0.47l-5.65,-1.4l-3.29,-0.27l-0.95,-0.91l-0.49,-1.57l-0.8,-0.65l-0.36,-1.25l1.17,-1.22l0.93,0.15l1.28,1.38l0.8,0.35l1.12,-0.28l0.34,-0.65l-2.06,-4.76l-1.74,-5.57l-0.28,-3.2l1.24,-3.11l1.48,-1.09l0.51,-1.75l-0.83,-1.22l-2.26,0.41l-0.42,-0.32l-0.42,-3.51l-0.53,-1.76l-0.18,-3.85l-0.71,-1.37l2.11,-1.28l1.1,-1.85l-0.66,-1.22l-2.68,0.42l0.29,-1.1l2.51,-3.29l1.48,-0.9l4.6,1.83l0.57,2.49l0.73,0.66l7.29,-1.02l5.86,2.44l10.5,-1.06l4.03,0.67l3.21,1.99l4.78,0.9l2.38,2.06l2.76,-0.21l2.31,1.93l1.09,0.42l2.66,-0.82l0.63,2.13l1.2,0.68l0.73,-0.37l0.96,-1.74l1.68,-1.61l2.18,-0.25l2.67,0.88l1.01,-0.32l0.43,-0.71l-0.08,-1.86l0.32,-0.63l2.36,-0.62l2.47,-3.38l0.78,-0.0l2.24,1.25l2.85,-0.78l0.67,0.11l2.0,1.24l1.28,-0.13l0.73,-0.98l-0.02,-1.04l3.31,0.53Z",name:"Oise"},"FR-61":{path:"M339.45,171.33l-1.19,2.6l0.44,1.49l1.28,1.11l0.76,0.28l2.03,-0.04l4.74,1.12l3.05,-0.82l0.53,0.56l0.61,1.79l2.9,3.45l1.71,1.0l2.29,0.55l0.97,0.6l0.98,1.74l-0.43,1.2l-1.34,1.44l0.1,1.13l1.12,0.58l1.33,1.63l2.71,1.01l0.4,3.39l1.71,2.99l2.69,1.76l3.44,3.47l-0.31,2.12l0.17,1.43l1.87,2.7l-1.12,1.47l-0.63,1.57l-1.95,1.77l-1.26,0.69l-4.1,1.48l-2.34,0.41l-0.89,1.14l-0.23,0.89l0.24,0.83l1.14,1.2l-0.05,2.88l1.83,3.34l-0.46,0.79l-1.04,0.63l-1.56,0.37l-2.49,-1.01l-2.47,-2.98l-1.91,-1.6l-3.5,0.2l-5.14,-1.24l-0.71,-0.36l-0.06,-1.74l-0.56,-0.94l-3.09,-0.02l-2.45,-1.44l-1.01,-1.58l-0.49,-1.75l0.27,-4.85l-0.45,-1.45l-1.38,-1.0l-2.69,-1.04l-1.94,-0.2l-5.54,1.15l-3.07,1.61l-1.67,2.12l-2.54,0.86l-0.55,1.53l-0.8,0.2l-1.9,-0.51l-3.9,0.33l-0.22,-3.58l-0.39,-0.79l-0.77,-0.81l-1.89,-0.44l-3.02,-2.76l-0.65,-1.6l0.49,-1.46l-0.32,-0.81l-0.74,-0.61l-3.82,-1.27l-0.99,0.47l-0.03,1.62l-0.34,0.71l-1.15,0.57l-1.4,-0.02l-1.63,0.51l-1.2,1.45l-0.68,0.11l-4.11,-0.95l-3.98,-0.16l-1.2,0.44l-2.14,1.99l-1.05,0.56l-5.18,1.05l-1.18,-1.31l-0.96,-0.14l-3.52,0.92l-0.5,1.08l-0.81,0.48l-1.68,-1.15l-1.86,0.23l-1.74,-2.89l-0.78,-0.61l1.1,-1.52l3.31,-2.63l1.9,-3.49l0.3,-1.03l-0.88,-3.57l1.71,-1.91l-0.07,-0.62l-5.1,-3.21l-1.17,-0.16l0.06,-1.22l1.15,-0.43l2.61,-2.27l4.22,-1.02l0.97,-0.99l-0.03,-0.75l-0.53,-0.71l0.58,-0.88l4.69,0.87l7.52,-1.59l2.99,-1.66l1.62,0.23l2.59,2.51l1.48,0.83l0.96,-0.29l0.67,-1.71l0.64,-0.21l10.57,2.36l12.06,-6.08l3.02,-3.58l1.06,-0.25l1.1,1.64l0.8,0.44l2.26,-1.25l3.01,-0.19l1.72,-2.05l0.59,-0.06l0.57,0.97l1.0,0.69l1.27,0.35l1.32,-0.17l2.03,-1.3l0.66,0.04l1.0,0.98Z",name:"Orne"},"FR-68":{path:"M752.43,285.23l0.39,-1.2l0.0,-1.45l-1.07,-2.08l-3.5,-3.34l-0.86,-0.37l-1.8,-0.05l-0.57,-0.53l0.01,-0.77l1.5,-2.01l0.6,-1.7l-0.15,-2.99l-0.41,-1.19l-1.75,-1.66l-8.58,-4.29l-0.62,-0.69l-0.05,-0.84l2.13,-0.87l1.13,-1.09l0.16,-1.12l-0.61,-1.66l1.6,-3.12l0.61,-3.06l3.45,-4.12l3.12,-5.81l1.69,-2.31l0.01,-1.28l-0.73,-1.48l0.49,-1.19l7.55,-10.68l3.11,0.2l1.43,0.48l0.9,2.69l9.88,4.09l0.43,0.5l-0.47,1.92l0.32,1.28l1.01,0.53l1.61,0.15l0.88,1.92l3.01,0.47l-0.42,1.72l0.19,3.23l2.65,4.1l0.12,2.21l-2.19,2.41l-0.36,2.63l-1.24,1.91l0.21,3.21l-1.19,0.9l-1.06,3.68l0.75,2.84l-0.03,1.09l-1.25,1.28l-0.34,0.8l0.43,2.7l1.98,1.77l2.51,3.91l-0.3,0.82l-3.51,1.37l-2.73,1.91l0.1,0.7l1.12,0.69l0.01,0.32l-1.72,0.61l-0.07,0.53l0.6,1.0l-0.84,0.74l-2.31,-0.79l-0.93,0.18l-0.3,0.87l0.84,1.21l-0.09,0.79l-1.08,1.21l-1.53,0.53l-4.27,-0.15l-4.24,1.21l-0.96,-0.82l-3.02,-1.12l-0.26,-0.95l1.04,-2.07l-0.39,-0.58l-1.82,0.11Z",name:"Haute-Rhin"},"FR-69":{path:"M607.86,387.47l-0.14,1.11l-1.54,3.29l-1.25,3.86l0.39,4.66l-0.52,2.34l0.25,1.14l2.23,0.97l0.62,1.03l1.0,0.58l0.4,1.1l0.43,0.26l1.44,-0.22l3.49,2.5l-0.24,1.13l0.79,3.5l0.47,0.36l4.54,-1.15l3.58,0.52l2.61,-0.37l-1.69,2.95l0.03,1.65l0.82,1.02l3.8,1.9l0.51,0.57l-0.08,0.59l-1.28,0.04l-1.68,0.77l-2.91,2.33l-1.43,2.94l-1.05,0.63l-11.83,0.9l-1.41,0.84l0.15,0.46l3.9,3.08l-0.81,2.28l-4.09,3.12l-1.38,1.83l-1.36,-1.77l-1.0,-0.6l-2.55,0.09l-0.75,-0.19l-0.42,-0.56l-0.08,-1.27l0.8,-3.52l-0.38,-1.29l-1.35,-0.96l-2.33,-0.3l-3.66,0.5l-2.87,-0.52l-3.66,-2.12l-3.05,-3.02l-1.06,-3.12l1.95,-2.75l-0.06,-1.23l-1.2,-0.62l-2.02,-0.41l-0.0,-0.93l2.32,-2.98l0.65,-2.37l-1.32,-1.76l-1.91,-1.02l-0.38,-0.51l-0.14,-0.62l0.55,-2.07l-0.83,-1.56l-4.23,-2.25l-0.21,-0.67l2.75,-1.04l0.49,-1.41l-0.62,-0.98l-2.67,-1.83l0.26,-0.95l5.82,-5.57l3.12,-0.19l1.74,-0.79l0.43,-1.75l-0.46,-1.69l-0.9,-1.34l-1.87,-1.23l1.47,-4.64l5.06,1.43l1.25,-0.12l1.94,-0.93l1.54,1.64l0.93,0.37l1.05,-0.11l0.65,-0.45l0.73,-2.14l1.87,0.38l0.31,0.19l0.27,1.99l1.62,1.08l0.05,2.15l1.07,2.48l1.36,0.98l3.19,0.35Z",name:"Rh\xf4ne"},"FR-53":{path:"M310.77,215.54l-4.2,0.74l-1.58,1.61l-0.37,1.34l0.91,8.38l-0.94,2.05l-4.74,3.0l-0.35,2.5l0.91,2.88l-0.43,1.64l-1.48,1.12l-4.22,0.81l-0.96,0.75l-0.24,1.37l2.76,3.47l0.44,1.72l-0.49,0.61l-0.78,0.3l-3.0,0.23l-1.53,0.91l-0.58,0.88l-0.18,1.13l0.88,2.13l-0.14,0.78l-0.47,0.48l-2.09,0.77l-1.07,0.98l0.04,1.28l0.87,1.18l1.01,0.56l1.86,0.35l-0.09,0.98l-0.78,0.72l-2.11,0.84l-4.17,-1.53l-1.62,1.77l-1.25,0.22l-1.78,-0.37l-0.76,0.32l-1.18,1.37l-0.82,0.05l-20.13,-4.54l-0.91,0.5l-0.94,1.8l-2.53,-0.86l-6.81,-0.22l-3.08,-0.79l-2.72,-1.42l0.85,-1.47l2.89,-9.08l0.53,-0.9l1.85,-1.62l4.09,-0.58l1.25,-0.49l0.67,-0.66l-0.07,-4.84l-1.76,-2.27l-0.71,-4.7l0.64,-0.86l0.08,-0.99l-0.82,-4.82l-1.09,-2.36l1.95,-4.01l-0.03,-2.5l-0.74,-5.78l0.2,-5.45l4.76,0.37l3.56,-1.09l2.14,0.78l2.29,-0.33l0.82,0.61l1.89,3.04l0.78,0.28l1.22,-0.43l1.2,1.0l0.96,0.2l0.9,-0.36l0.74,-1.34l3.16,-0.79l0.67,0.27l0.43,0.85l0.82,0.32l5.49,-1.07l1.32,-0.69l2.1,-1.96l0.92,-0.33l3.75,0.17l4.09,0.95l1.06,-0.14l1.34,-1.53l1.33,-0.41l1.5,0.0l1.45,-0.72l0.62,-1.2l-0.17,-1.13l0.3,-0.28l3.98,1.51l0.19,0.36l-0.49,1.44l0.18,1.02l0.67,1.13l3.2,2.92l2.03,0.53l0.36,0.46l0.28,0.51l0.22,3.61Z",name:"Mayenne"},"FR-52":{path:"M620.05,191.66l0.83,3.39l1.78,2.43l2.21,1.63l2.79,1.3l4.32,3.1l5.08,2.47l3.16,0.28l1.23,0.4l0.83,1.56l5.79,4.67l-1.67,2.08l-0.22,0.82l0.6,3.51l0.45,0.64l0.99,0.2l1.86,-1.66l1.62,0.08l1.4,1.19l3.12,3.97l0.92,0.25l1.78,-0.17l1.05,0.53l0.59,2.6l2.43,1.57l1.39,1.38l-1.32,1.49l-0.55,2.56l-1.17,1.96l-0.63,2.55l4.62,3.89l3.34,1.83l0.57,1.4l-0.05,2.95l0.46,0.64l1.01,0.19l0.95,-0.67l0.94,-0.09l2.41,2.53l0.3,0.85l-0.2,0.45l-1.94,0.67l-2.38,2.89l-6.41,3.93l-0.82,1.02l-0.32,0.82l0.58,2.29l-0.54,2.43l0.2,2.14l-0.17,0.81l-0.92,0.79l-6.35,1.81l-1.15,-0.23l-3.43,-1.72l-4.29,0.62l-1.46,0.81l-2.83,5.28l-0.39,0.11l-0.67,-0.88l-0.77,-0.22l-2.89,1.56l-0.53,-0.69l-0.42,-1.51l-3.74,-2.21l-0.5,-0.48l-0.45,-1.41l-0.55,-0.47l-1.19,0.09l-1.76,1.89l-1.49,0.14l-2.23,-1.34l-2.42,-2.98l-1.06,-0.04l-1.33,1.3l-0.7,0.01l-0.9,-1.16l-0.61,-3.64l-1.3,-1.58l0.33,-0.6l2.33,-0.37l0.83,-0.93l-0.18,-1.31l-1.18,-2.31l-4.52,-5.41l-1.18,-0.18l-1.09,1.24l-0.51,-0.21l-0.23,-0.95l0.85,-1.35l0.11,-1.07l-1.02,-0.91l-2.65,-0.91l0.44,-1.3l-0.31,-0.7l-0.84,-0.49l-3.68,-0.69l-1.62,-1.0l0.99,-1.7l-1.33,-2.62l0.84,-1.66l1.62,-0.79l4.26,0.81l1.15,-0.58l0.78,-1.43l0.45,-3.19l1.01,-1.73l0.08,-0.84l-1.0,-7.31l-1.65,-1.75l0.44,-1.44l-0.18,-0.9l-3.13,-1.39l-1.38,-2.02l-2.2,-1.22l-2.15,-2.78l-2.26,-1.34l-0.15,-0.85l1.4,-1.94l0.4,-1.04l0.13,-1.76l5.87,-0.24l0.87,-0.28l0.33,-1.09l-1.07,-2.3l0.32,-1.17l4.51,-1.27l0.38,-0.55l-1.04,-2.5l-0.35,-0.25l-3.14,-0.04l1.22,-1.88l3.77,-1.11l7.44,0.03Z",name:"Haute-Marne"},"FR-51":{path:"M522.82,186.37l0.16,-1.02l1.68,-1.84l-0.22,-0.68l-0.89,-0.72l3.35,-0.37l0.76,-1.01l0.2,-1.75l1.48,-2.59l4.29,-3.81l1.07,-2.07l1.68,-1.1l0.81,-1.18l2.06,-1.61l0.39,-0.63l-0.02,-1.16l-0.99,-0.78l-3.39,0.04l-0.83,-0.47l0.06,-1.11l1.31,-0.86l1.17,-1.67l0.21,-0.79l-0.25,-2.97l1.17,-0.73l3.12,0.34l1.45,-0.25l1.33,-1.0l0.36,-0.86l-0.5,-1.26l-1.41,-0.81l-0.87,-0.98l-1.6,-0.47l-0.56,-4.86l-0.91,-2.12l2.95,-1.52l5.1,-1.23l4.31,-0.57l0.52,-0.78l-0.12,-1.35l0.85,-0.54l2.04,0.1l3.04,1.4l2.06,-0.68l2.32,0.84l1.14,-0.78l0.47,-1.24l0.08,-1.7l6.33,0.44l1.77,0.51l8.42,5.99l2.47,0.04l2.51,2.92l2.29,0.48l6.22,-0.85l1.44,0.18l1.21,0.87l1.1,2.07l1.24,0.92l5.55,-1.3l7.04,1.27l4.31,-1.4l1.84,-0.03l2.07,1.32l0.06,1.73l-1.31,2.24l-0.19,1.39l1.8,5.02l0.13,4.29l0.32,0.97l0.62,0.73l1.6,0.68l0.35,0.84l-0.84,1.15l-0.07,2.87l-0.56,1.42l-1.01,0.68l-2.7,0.71l-1.22,1.6l-0.51,2.57l0.58,2.62l-1.01,1.24l-0.44,1.14l0.49,1.38l4.23,3.15l0.58,1.99l-0.08,1.85l-7.28,-0.03l-4.31,1.35l-1.76,2.71l0.38,0.62l3.61,-0.06l0.71,1.71l-3.66,0.98l-0.9,0.62l-0.42,0.75l-0.05,0.99l1.03,2.63l-6.61,0.41l-4.47,-1.41l-1.54,0.31l-2.8,1.32l-11.93,-6.37l-0.31,-0.68l0.66,-4.11l-0.44,-1.76l-0.57,-0.63l-0.88,-0.35l-6.81,-0.4l-4.94,1.4l-1.13,-0.22l-1.49,0.3l-1.23,2.03l-2.91,0.76l-7.38,6.28l-1.28,0.67l-0.6,0.81l-0.67,2.46l-3.36,-0.35l-2.25,-0.66l-0.93,-1.47l-1.09,-0.78l-1.26,1.02l-3.5,0.89l-0.66,-2.48l-0.41,-0.29l-1.24,0.06l-1.99,-2.71l-1.85,-0.07l-1.65,-2.04l-0.63,-0.31l-2.37,0.21l-0.2,-1.26l0.51,-1.93l-0.76,-3.12l-2.03,-2.25l-1.36,-0.04Z",name:"Marne"},"FR-50":{path:"M199.1,110.63l3.02,0.17l0.93,1.73l6.68,0.92l5.27,1.29l0.19,0.68l0.67,0.4l0.84,-0.17l1.4,-0.93l2.68,0.54l1.2,-0.43l3.43,-3.16l2.74,-0.72l1.03,-0.08l7.56,1.27l2.02,5.19l-1.5,1.01l-0.48,1.56l-1.27,0.04l-1.1,0.67l-0.37,2.34l1.83,2.99l0.97,2.27l4.63,4.95l0.53,1.09l0.2,1.62l-0.75,1.97l0.17,1.08l0.44,0.3l1.7,-0.5l1.73,1.31l0.02,1.02l-1.12,2.23l0.89,2.06l7.07,6.37l1.82,0.2l3.77,-1.18l0.35,0.33l-0.73,2.09l-0.02,1.11l2.33,4.3l1.19,6.19l-1.73,0.82l-3.41,3.44l-1.89,1.33l-0.75,0.13l-2.59,-0.59l-1.17,0.51l-0.67,1.15l-0.02,1.28l1.46,1.49l0.17,0.61l-1.14,1.16l-2.44,0.91l-2.01,1.58l-0.85,1.16l-0.26,1.31l0.31,0.46l2.27,0.49l0.45,1.59l0.59,0.65l2.89,0.95l3.11,0.13l2.44,-0.72l3.49,0.8l3.18,1.45l-0.08,1.6l0.36,0.42l1.28,0.13l4.59,2.89l-1.59,2.0l0.04,1.15l0.84,2.61l-0.18,0.54l-1.78,3.33l-3.29,2.61l-1.34,1.83l-1.98,0.34l-2.37,-0.8l-3.57,1.1l-2.0,0.01l-3.01,-0.43l-2.56,-1.35l-6.25,-1.53l-1.67,-0.15l-1.33,0.23l-2.22,2.41l-1.99,0.71l-2.78,1.91l-1.65,0.53l-1.32,0.02l-0.77,-0.19l-2.96,-2.18l-1.8,-2.76l-0.99,-2.96l-2.54,-5.28l4.98,0.51l6.48,-1.24l2.14,0.69l0.44,-0.14l0.0,-0.47l-1.13,-1.5l-1.5,-0.64l-2.34,-0.18l-0.46,0.44l-0.7,-1.34l-2.87,-0.97l-0.88,-2.35l-2.17,-1.65l-0.47,-1.69l-0.34,-4.2l-0.74,-1.24l-1.4,-0.44l1.45,-1.15l0.44,-1.03l0.49,-3.71l0.92,-0.11l0.34,-0.9l0.0,-1.07l-1.2,-0.91l0.97,-5.38l0.51,-0.24l1.33,0.54l0.55,-0.37l-0.25,-0.86l-1.33,-0.51l-1.38,0.0l-1.32,0.6l-0.59,1.22l-0.56,-1.29l0.43,-3.35l-0.31,-0.52l-0.67,-0.12l-0.18,-0.32l0.72,-2.62l1.48,-1.06l0.02,-0.68l-0.75,-0.5l-0.56,0.09l-0.66,-2.09l-0.35,-2.8l0.3,-0.47l0.85,-0.05l2.15,0.54l0.5,-0.39l0.0,-0.49l-0.3,-0.39l-2.96,-0.99l-1.32,-0.03l-0.67,1.15l-0.44,-0.44l-0.98,-2.84l-0.71,-0.78l0.42,-0.24l0.06,-0.7l-2.38,-1.94l-0.24,-0.63l0.68,0.0l0.4,-0.4l-0.83,-2.29l-0.82,-0.22l-0.71,1.2l-3.02,-2.14l0.32,-0.66l-0.42,-0.61l-2.16,0.52l-0.37,-0.34l-0.17,-5.35l-1.15,-1.92l-0.39,-1.49l-2.39,-2.79l0.28,-0.81l1.64,-1.27l0.51,-0.95l0.27,-4.14l-1.3,-2.8l-0.63,-0.67l-4.47,-1.27l0.43,-3.05l1.34,-0.15l1.62,0.85Z",name:"Manche"},"FR-57":{path:"M697.12,128.57l4.59,2.63l1.98,0.19l2.29,-0.93l0.53,0.08l5.52,2.34l0.95,0.78l0.43,1.78l3.49,3.43l-1.28,0.51l-0.34,1.05l0.39,0.92l5.12,4.46l-0.0,1.31l1.48,0.85l1.03,2.86l0.65,0.17l0.76,-0.38l0.24,0.78l-0.46,1.9l1.04,1.55l0.86,0.29l2.67,0.02l2.33,0.73l0.97,-0.14l1.37,-1.65l-0.67,-2.53l0.24,-0.75l2.79,0.42l1.85,-0.14l4.34,1.88l1.09,0.08l-0.03,2.41l0.73,2.3l1.51,1.11l2.29,-0.99l0.3,-0.66l-0.21,-0.77l0.26,-0.22l2.39,1.43l1.98,0.72l5.31,0.06l2.06,0.7l0.67,-0.41l0.98,-1.46l2.37,-0.6l0.98,-1.9l2.23,-0.77l0.85,0.06l0.55,0.9l3.47,0.42l0.22,0.64l-0.49,0.46l-0.0,0.71l3.02,3.51l1.57,0.84l2.62,0.39l1.24,0.55l1.04,1.49l0.76,0.49l-3.08,5.46l-1.37,1.52l-0.94,0.11l-3.4,-1.65l-9.1,1.22l-2.18,-0.77l-0.57,-1.35l-0.66,-0.54l-8.43,-2.52l-0.63,-0.69l-0.58,-2.32l-0.9,-1.14l-1.12,-0.32l-1.33,0.51l-0.22,0.75l0.3,1.4l-2.13,2.71l-0.26,1.81l-2.5,1.95l-1.01,1.21l-0.49,1.21l0.0,1.18l0.54,1.07l0.95,0.87l5.74,2.33l-0.95,1.04l-0.38,1.39l0.94,0.93l0.85,1.8l0.62,0.41l1.5,-0.31l1.16,-1.59l2.22,-0.91l0.43,-0.63l0.2,-1.32l0.37,-0.29l0.49,1.78l1.97,0.95l3.72,3.7l0.4,0.92l-0.22,0.99l-3.01,4.58l0.29,1.21l1.86,1.19l-1.76,5.33l-0.93,1.1l-2.37,1.17l-1.19,1.51l-5.74,0.33l-0.53,0.33l-7.11,-6.72l-2.93,-1.24l-3.41,0.49l-9.75,-3.72l-2.42,-2.06l-2.68,-0.83l-1.47,-0.83l-1.93,-2.75l-0.67,-0.39l-2.37,0.0l-5.29,-2.7l-3.73,0.68l-4.05,-5.03l-0.21,-0.84l0.25,-1.56l1.24,-1.79l-0.32,-1.43l-0.67,-0.65l-1.55,-0.63l-8.73,-0.26l-0.71,-0.47l-1.27,-1.94l-3.43,-1.16l-0.36,-1.98l-0.72,-1.09l-4.16,-1.75l-0.7,-0.77l-1.12,-2.35l-0.02,-0.87l0.69,-0.55l2.54,-0.84l1.33,-1.27l0.36,-1.9l-1.71,-3.68l1.93,-2.33l0.06,-1.16l-0.97,-3.93l-0.53,-1.05l-1.64,-1.12l-1.0,-2.7l-1.73,-1.76l1.1,-4.12l-0.52,-3.06l0.89,2.24l0.48,0.25l7.2,-0.85l1.6,-1.26l0.33,-1.21l1.94,-0.22l0.21,-0.79l2.88,-0.27l1.66,0.15l1.65,0.58Z",name:"Moselle"},"FR-56":{path:"M109.52,267.85l0.38,-0.4l0.08,-1.06l0.95,0.1l0.65,-0.32l1.28,-2.54l0.88,-0.82l-0.25,-0.95l-0.44,0.09l-2.95,2.66l-1.78,0.9l-1.23,0.25l-0.32,0.34l0.22,0.41l0.92,0.77l-4.61,0.99l-0.63,-0.17l-2.02,-2.33l-2.01,-3.11l-0.6,-0.18l-0.35,0.25l-0.45,-1.04l-0.01,-1.54l0.9,-1.31l0.97,0.03l1.25,0.66l1.03,-0.09l1.08,-0.85l0.86,-1.79l2.18,-0.09l1.0,-0.67l0.57,-1.29l0.33,-2.58l-0.6,-3.09l-0.82,-0.87l-1.32,-0.34l-2.96,0.59l-1.33,-0.42l-3.3,-1.97l-1.52,-0.09l-3.2,0.59l-0.96,-0.72l-2.13,-5.31l-2.99,-2.98l-0.09,-0.73l0.41,-1.27l0.88,-0.78l8.58,-3.25l1.34,0.41l5.97,-0.26l0.36,1.66l1.26,0.9l1.53,-0.21l3.13,-1.15l1.22,1.3l1.94,0.58l8.02,-0.95l1.06,-0.53l0.62,-0.83l0.85,-2.33l1.12,-0.31l3.78,0.24l1.1,0.41l0.64,2.34l0.64,0.68l0.92,0.0l2.55,-0.85l1.49,0.2l4.05,2.12l3.19,0.86l0.96,2.18l1.0,0.73l0.89,-0.2l1.68,-1.5l3.3,-1.04l0.45,0.25l-0.04,6.27l0.27,0.38l1.32,0.46l2.52,-1.2l3.4,-2.96l0.76,-1.28l0.3,-3.56l0.45,-0.92l0.78,-0.28l4.92,-0.19l1.9,0.76l2.15,3.06l1.28,0.01l2.14,-1.17l0.89,-0.02l1.02,0.9l1.37,2.64l0.68,0.66l2.99,0.0l0.39,0.31l0.01,0.41l-0.64,0.66l-4.17,1.19l-0.87,1.19l-0.04,1.67l1.29,1.01l5.3,0.98l2.55,1.59l1.01,1.3l0.35,1.81l-0.59,5.45l0.39,0.48l2.72,0.15l0.42,0.57l-0.04,0.91l-0.87,1.82l-0.68,0.52l-2.12,0.6l-0.62,0.86l0.22,1.11l0.9,0.49l2.15,0.11l0.36,0.63l-0.49,0.45l-2.42,0.13l-0.84,0.83l0.08,2.27l1.03,2.25l0.0,1.69l0.23,0.68l1.13,1.14l-1.56,6.13l-0.54,0.87l-2.04,1.23l-1.46,2.33l-0.6,-0.23l-0.05,-1.13l-0.56,-0.55l-0.75,-0.02l-2.38,0.9l-1.56,-0.86l-0.9,0.05l-0.9,0.52l-1.89,2.82l-1.08,0.35l-2.85,0.22l-1.9,-0.8l-1.35,0.35l-0.47,0.66l-1.07,-0.28l0.4,-1.16l-0.67,-1.08l0.25,-0.19l3.7,-0.17l2.26,-0.53l1.21,0.07l0.42,-0.34l-0.3,-0.45l-0.99,-0.24l-2.8,0.23l-5.66,-1.72l-2.91,0.66l-1.93,0.0l1.05,-1.04l0.47,-1.05l-0.12,-0.48l-0.5,0.01l-0.86,0.73l-2.73,0.25l-0.32,0.4l1.11,0.66l-1.57,-0.11l-0.6,-0.37l-0.61,0.32l-0.09,1.63l-0.48,0.24l-1.89,-0.59l-1.16,0.04l-4.35,1.05l-1.51,-0.37l-2.24,-2.86l-1.34,-0.5l-0.54,-0.67l1.53,-0.13l1.13,1.56l1.15,-0.56l0.69,0.46l0.65,-0.25l0.21,-0.93l0.66,0.6l1.69,0.45l1.67,-0.14l1.46,-0.78l-0.13,-0.88l2.17,-2.6l0.37,-1.63l-1.48,-1.88l-0.44,-0.11l-0.26,0.86l0.64,0.9l-1.1,0.64l0.6,0.74l-0.39,0.02l-1.13,-0.82l0.39,-0.14l-0.02,-0.47l-0.84,-1.0l-0.86,-0.45l-1.89,-0.29l-0.44,0.26l0.31,0.55l-3.56,0.47l-0.85,0.64l-0.55,0.91l-2.13,0.65l0.0,-0.48l-0.46,-0.4l-1.32,0.49l-0.19,-1.21l0.7,-1.13l-1.61,-0.61l-0.47,-1.47l-0.85,-0.33l-0.4,0.46l0.45,2.1l0.01,1.94l0.27,0.88l1.3,1.72l-0.77,0.06l-1.84,-1.77l-0.48,-0.01l0.02,1.33l-0.45,-1.98l-0.51,-0.31l-0.67,0.4l-0.04,1.56l-1.22,-0.46l-1.86,0.87l-0.79,0.06l0.11,-0.88l-1.36,-0.9l-0.9,-0.02l-0.6,0.64l-1.75,-2.35l-1.96,-1.13l0.78,-2.82l4.43,-1.77l0.2,-0.57l-0.36,-1.98l-0.6,-0.34l-0.71,0.3l0.01,-1.53l-0.4,-0.43l-0.73,0.2l-0.33,0.57l-1.35,-0.45l-0.97,0.16l-0.33,0.36l1.51,1.12l0.5,1.38l-0.92,0.03l-0.89,0.76l-0.75,0.18l-0.19,0.67l0.52,0.61l-0.59,0.38l-0.66,1.45l-2.06,-1.94l-1.14,-0.34l-0.21,-0.79l-2.13,-0.87l-1.87,-0.17ZM122.84,278.42l0.11,0.08l-0.08,0.32l-0.03,-0.4ZM122.52,282.02l0.23,1.3l1.65,2.47l-0.96,-0.23l-0.59,0.29l-0.71,-2.5l0.37,-1.33ZM133.84,278.57l0.45,0.38l-0.04,0.12l-0.41,-0.51ZM123.36,297.99l1.01,0.42l1.66,-0.07l0.33,0.33l-0.17,0.99l-1.32,0.33l-4.68,-0.38l-3.08,-0.8l-0.79,-0.48l0.14,-1.16l-1.41,-3.37l0.57,-0.67l4.02,1.8l3.72,3.05Z",name:"Morbihan"},"FR-55":{path:"M625.46,127.51l1.43,-1.72l0.37,-3.32l1.33,-1.31l1.39,0.12l2.52,1.66l3.7,-0.04l0.91,1.24l0.89,0.23l1.45,-0.59l3.12,-2.32l2.22,-1.14l0.23,-0.81l2.9,4.42l0.21,0.61l-0.22,2.41l0.64,0.91l0.95,0.21l-0.76,2.22l1.67,3.94l1.55,0.77l4.36,-0.27l3.79,-1.81l1.09,0.5l2.04,1.97l1.1,1.55l0.63,1.81l-0.13,2.9l0.75,0.94l1.21,0.71l-2.13,3.84l-0.11,3.18l0.87,1.09l1.45,0.54l0.1,0.71l-0.75,2.39l0.04,1.87l0.65,1.66l1.29,0.41l1.97,-0.41l0.46,0.43l1.27,4.3l-1.39,3.28l-0.07,1.12l0.54,1.24l1.09,0.73l0.27,0.53l-0.2,0.91l-1.94,-0.32l-0.92,0.23l-1.77,1.51l-0.73,1.37l1.09,3.21l-0.04,3.79l-0.93,3.38l-2.08,2.91l-0.17,1.07l1.73,2.41l0.27,6.76l-0.43,0.81l-1.63,1.18l-0.42,1.58l0.55,1.31l2.0,1.04l0.35,0.6l0.09,2.67l-0.7,1.3l-0.86,0.74l-1.0,0.27l-2.89,-0.26l-3.49,2.04l-3.64,0.05l-4.52,2.15l-1.28,-0.5l-5.97,-4.81l-0.81,-1.57l-1.66,-0.59l-3.06,-0.26l-4.93,-2.41l-4.26,-3.07l-2.86,-1.34l-2.09,-1.55l-1.19,-1.4l-0.58,-1.33l-0.28,-2.43l-0.47,-0.59l0.07,-2.24l-0.69,-2.27l-4.55,-3.64l0.3,-1.22l0.98,-1.18l0.19,-0.77l-0.65,-2.29l0.44,-2.23l0.86,-1.22l2.6,-0.67l1.38,-0.95l0.61,-1.14l0.15,-3.39l0.86,-1.2l-0.06,-0.86l-0.53,-0.77l-2.02,-1.13l-0.4,-5.12l-1.78,-5.41l1.45,-2.76l-0.02,-2.07l4.21,-3.39l0.13,-1.1l-0.75,-1.69l-0.03,-0.85l3.33,-4.34l1.37,-3.47l-0.92,-3.48l-1.1,-0.9l-0.58,-1.83Z",name:"Meuse"},"FR-54":{path:"M650.32,128.04l3.92,-2.09l2.36,0.84l1.04,-0.1l1.27,-1.8l1.33,-0.57l3.92,0.99l0.96,-0.3l1.37,-1.14l2.44,0.88l3.06,3.02l1.61,0.63l3.65,0.74l0.78,3.77l-1.03,3.1l-0.04,1.34l0.3,0.64l1.52,1.31l1.02,2.74l1.64,1.13l1.35,4.58l-0.0,0.78l-1.41,1.42l-0.59,1.33l1.73,3.75l-0.32,1.43l-0.91,0.84l-2.65,0.9l-1.05,1.04l0.06,1.32l1.18,2.48l0.86,0.98l4.16,1.75l0.5,0.76l0.18,1.53l0.43,0.8l3.48,1.18l1.06,1.73l1.04,0.76l8.98,0.32l1.16,0.47l0.45,0.39l0.23,0.93l-1.15,1.54l-0.3,0.94l0.21,2.07l0.72,1.27l3.6,4.17l1.51,0.17l2.53,-0.72l5.26,2.69l2.31,-0.02l2.42,3.04l1.64,0.91l2.5,0.74l2.53,2.12l9.89,3.78l3.56,-0.46l2.61,1.15l6.62,6.3l-1.46,0.31l-5.3,3.62l-3.26,3.16l-1.41,0.83l-1.19,-1.07l-0.54,0.01l-3.27,2.95l-4.16,-1.53l-4.42,-0.54l-0.72,-0.61l-0.34,-2.13l-0.86,-1.0l-1.99,0.17l-6.31,4.24l-4.11,0.31l-1.99,1.33l-0.32,0.05l0.09,-0.71l-0.46,-0.44l-1.73,0.29l-1.7,-0.17l-1.49,-0.75l-1.17,-1.57l-0.63,-0.01l-1.77,2.56l-4.63,0.3l-1.52,-0.62l-0.55,0.39l0.1,2.57l-1.64,0.67l-8.45,0.29l-1.32,-0.47l0.31,-1.38l-0.25,-0.46l-4.74,-1.96l1.73,-3.24l0.09,-1.26l-0.31,-1.09l-2.18,-1.23l-1.59,-0.25l-1.57,0.18l-2.18,1.04l-0.64,-0.6l0.01,-2.15l-0.37,-1.18l-2.28,-1.39l-0.33,-0.8l0.34,-1.17l1.42,-0.93l0.7,-1.27l-0.27,-7.02l-0.47,-1.04l-1.24,-1.32l0.08,-0.66l2.08,-2.93l1.0,-3.6l0.04,-4.03l-1.08,-2.99l0.55,-0.95l1.58,-1.33l2.72,0.18l0.71,-1.21l-0.21,-1.21l-1.37,-1.07l-0.32,-0.75l0.04,-0.86l1.42,-3.48l-1.35,-4.65l-1.15,-0.91l-2.08,0.43l-0.61,-0.16l-0.48,-1.26l-0.03,-1.69l0.73,-2.24l-0.12,-1.24l-1.83,-0.91l-0.47,-0.58l0.1,-2.78l1.9,-3.0l0.23,-1.3l-0.44,-0.62l-1.51,-0.98l0.13,-2.84l-0.71,-2.05l-1.23,-1.73l-2.12,-2.04l-1.71,-0.68l-3.78,1.82l-4.78,0.08l-0.65,-0.64l-1.24,-3.19l0.78,-2.16Z",name:"Meurhe-et-Moselle"},"FR-59":{path:"M468.73,0.56l0.71,1.42l0.6,3.51l0.63,1.64l3.14,3.26l0.16,1.34l-1.61,1.47l-0.46,0.87l1.16,3.76l-0.52,1.99l1.22,0.87l1.03,1.61l4.25,0.56l0.92,1.61l2.23,1.78l1.46,2.61l1.24,0.91l5.27,2.03l1.32,0.13l0.92,-0.63l1.82,-2.63l2.37,-1.63l7.93,-2.08l1.41,0.36l0.92,0.73l2.64,4.35l0.72,0.59l1.48,0.27l0.38,0.58l0.61,1.69l-0.8,1.48l0.51,2.38l1.6,4.47l0.09,2.5l0.42,1.17l1.9,1.66l3.82,1.44l1.7,-0.16l2.68,-0.82l2.06,-1.38l0.72,-0.05l0.89,0.38l-0.6,1.19l0.12,0.56l0.76,0.47l4.13,0.08l2.56,0.75l1.12,0.9l0.91,1.39l1.05,10.05l2.3,1.94l1.29,-0.74l1.51,-2.44l1.09,-0.6l2.59,-0.16l2.45,0.25l3.52,1.61l1.52,-0.04l3.85,-1.36l1.15,-0.1l1.03,0.41l1.98,1.84l2.53,1.56l1.84,3.13l1.53,0.38l0.59,-0.74l-0.06,-0.72l0.39,-0.14l1.83,1.02l0.14,0.88l-2.69,2.35l-1.79,5.34l-0.17,1.55l1.11,0.78l1.48,-0.45l0.84,0.08l1.74,4.81l-2.7,1.39l-1.71,1.5l-0.59,1.62l0.66,2.17l-2.04,0.47l-1.03,-0.14l-5.08,-1.67l-0.55,-0.62l-0.05,-2.72l-0.69,-0.57l-0.96,-0.16l-2.19,0.7l-1.93,1.12l-2.51,-1.85l-6.24,-0.65l-3.45,-0.71l-0.98,0.1l-3.23,1.68l-0.69,0.09l-2.57,-0.97l-1.25,-0.05l-4.85,2.46l-1.59,0.26l-5.33,-1.36l-2.8,1.13l-3.55,-0.79l-1.98,-0.06l-4.16,0.8l-3.88,-2.32l0.05,-1.61l2.24,-8.66l0.61,-1.13l1.71,-1.56l0.28,-1.47l-0.42,-0.84l-1.75,-1.71l-1.31,-0.62l-2.38,-0.17l-2.28,1.01l-0.95,-0.58l0.47,-1.35l1.77,-1.49l0.37,-1.0l-0.19,-1.17l-0.99,-1.43l-2.5,-2.65l0.23,-1.14l2.9,-2.08l0.2,-1.9l-0.78,-0.64l-1.93,-0.31l-1.19,-3.12l-1.47,-1.14l-1.12,-0.16l-2.71,0.31l-2.16,-2.16l-1.21,-0.11l-2.08,0.58l-0.88,-0.19l-0.79,-0.94l-0.1,-0.8l1.06,-1.81l-0.04,-1.78l0.31,-0.72l1.51,-1.11l1.79,-0.4l0.25,-0.67l-1.93,-2.11l-1.11,-0.77l-1.27,-0.25l-1.45,0.65l-1.96,2.14l-1.32,0.64l-0.95,-0.25l-13.54,-0.34l-0.79,-0.25l-3.08,-2.44l-3.17,-0.57l-0.37,-0.8l0.39,-1.69l-1.03,-1.49l0.06,-0.6l1.78,-1.77l0.6,-0.85l-0.01,-0.48l-0.91,-1.06l-1.18,-0.37l-5.52,0.1l-1.57,-0.49l-1.27,-1.01l-2.13,-5.83l-5.01,-8.51l-2.04,-1.97l3.54,-0.38l11.16,-3.16l4.16,0.3l5.0,-1.09l3.16,-1.35ZM502.03,75.37l0.14,1.34l-2.79,0.71l-0.69,-0.11l0.09,-1.4l1.76,-0.34l1.28,-1.06l0.2,0.85Z",name:"Nord"},"FR-58":{path:"M528.78,280.97l1.59,2.28l2.55,2.41l0.9,1.86l3.66,0.81l4.42,3.53l5.43,1.99l0.7,-0.02l0.78,-0.5l1.06,-2.57l1.16,-0.44l0.49,0.82l-0.57,2.37l0.27,1.26l1.3,0.52l3.77,-1.84l0.67,0.98l0.68,3.72l1.6,1.37l1.61,-0.09l1.72,-1.96l3.18,0.03l0.85,1.0l0.1,5.56l0.32,0.39l1.92,0.37l1.13,-0.2l0.92,0.22l0.85,0.63l0.65,1.09l0.26,1.33l-0.71,1.77l-0.13,1.41l-1.24,0.33l-3.52,1.97l-3.93,0.47l-0.56,0.45l-0.72,2.59l1.01,3.06l-0.05,1.31l-1.08,1.16l-1.74,0.2l-0.94,0.58l-0.29,0.95l0.25,1.13l0.79,0.6l1.47,0.34l0.52,0.64l-0.04,3.9l0.72,0.83l1.99,1.19l0.18,1.0l-0.49,0.71l-1.97,0.63l-0.72,0.74l0.01,0.76l0.72,0.99l-0.2,2.06l-2.99,0.57l-4.86,2.88l-3.65,1.19l-1.65,1.29l-1.04,0.4l-2.51,-2.71l-1.72,-1.04l-7.17,0.93l-1.66,-0.27l-0.44,0.26l-0.43,1.96l-1.36,0.87l-0.44,1.79l-3.8,2.0l-1.31,0.28l-0.45,-0.19l-0.06,-1.53l-1.67,-2.57l-1.59,-0.43l-0.82,0.13l-1.33,1.43l-0.97,0.48l-2.64,-1.07l-1.82,-0.29l-1.87,0.11l-3.04,1.06l-3.34,-2.82l-1.29,-0.36l-1.77,0.04l-2.77,-1.63l-1.05,-1.28l-0.19,-0.83l0.34,-2.43l2.35,-4.46l-1.16,-3.32l1.31,-4.66l-0.44,-5.56l-2.26,-2.43l0.11,-3.58l-1.26,-4.05l-1.41,-3.21l-0.84,-3.54l-3.63,-3.57l-1.85,-1.04l-0.71,-1.21l2.92,-5.34l0.56,-3.19l-0.17,-0.62l-1.7,-2.2l-1.25,-2.57l-1.44,-1.56l0.08,-0.29l2.79,-1.26l2.32,-0.04l1.28,-0.37l1.6,0.31l6.32,-1.19l0.9,0.34l0.47,2.6l1.22,1.11l4.09,0.77l1.89,1.87l1.16,0.11l1.96,-0.77l2.43,1.48l1.01,0.12l1.16,-0.52l1.82,-1.52l1.28,-0.15l4.38,1.15l0.5,-0.33l0.29,-4.18Z",name:"Ni\xe8vre"},"FR-48":{path:"M521.61,538.83l-0.52,-1.13l-1.33,-0.92l-6.93,0.03l-0.32,-1.55l-1.01,-1.16l-4.04,-2.16l-1.29,-0.2l1.45,-3.24l-0.19,-0.85l-0.85,-1.25l-0.29,-2.01l0.71,-2.49l0.15,-2.55l-3.33,-4.54l-0.25,-1.16l0.15,-2.52l-1.11,-2.03l-5.17,-5.93l0.78,-2.2l1.89,-2.92l0.36,-2.65l1.38,-4.58l0.47,-0.79l1.76,-1.22l0.98,-3.72l0.74,-0.4l1.59,1.82l1.21,-0.05l1.38,-0.79l3.42,-3.06l2.41,-0.28l3.68,-2.03l1.93,-0.24l0.36,0.35l0.79,2.6l3.5,5.9l1.31,1.29l1.23,0.42l1.33,-0.63l3.37,-0.36l1.07,-0.91l0.56,-2.31l0.89,-0.32l1.69,0.16l0.84,0.67l-0.48,1.5l0.3,0.89l4.51,0.95l4.08,3.38l2.89,1.45l1.57,0.41l-0.03,2.85l1.28,3.55l0.51,3.07l0.72,2.11l0.66,1.17l1.36,0.88l0.8,1.32l2.15,6.73l-1.98,3.13l-0.84,0.57l-2.06,0.37l-1.0,0.81l-0.08,0.53l1.91,2.93l0.62,3.31l1.55,3.3l0.16,0.98l-0.44,1.55l-2.23,4.29l-2.6,2.5l-4.89,-0.36l-6.09,-3.28l-1.5,-0.33l-1.99,0.8l-0.31,0.97l-0.05,2.63l-1.0,0.63l-5.86,0.25l-2.2,-0.6l-6.15,-3.38Z",name:"Loz\xe8re"},"FR-49":{path:"M233.03,298.51l1.68,-1.19l4.85,-0.76l3.64,-1.93l2.11,-0.43l7.86,-0.14l4.72,-0.85l0.24,-0.64l-1.06,-1.36l-0.84,-1.98l-0.51,-2.15l-0.06,-1.85l-0.36,-0.38l-9.92,-1.02l-1.33,-0.83l-1.22,-1.81l-0.2,-1.33l0.7,-0.39l6.35,0.53l1.77,-0.53l1.47,-1.4l-0.04,-0.61l-1.54,-1.13l-7.67,-2.31l-0.6,-0.61l-0.59,-4.56l-1.04,-1.15l-1.13,-0.59l-1.63,-0.18l-0.33,-0.63l-0.18,-3.53l0.36,-1.67l2.85,1.47l3.17,0.81l6.88,0.23l2.53,0.88l1.05,-0.55l0.86,-1.75l20.14,4.52l1.2,-0.13l1.7,-1.61l2.6,0.36l0.88,-0.45l1.24,-1.52l2.86,1.33l1.03,0.2l1.11,-0.23l10.64,4.33l1.01,-0.16l1.58,-1.05l0.32,0.09l0.32,0.56l-0.94,0.75l-0.47,0.91l0.2,1.48l1.05,1.63l1.59,1.02l1.83,0.32l1.37,-0.51l1.29,-1.24l3.12,0.44l6.53,3.17l2.26,0.37l3.15,1.37l1.63,-0.03l0.36,-0.28l0.54,-1.77l2.61,0.81l-1.52,3.88l0.46,3.58l-1.91,3.72l-1.03,3.13l0.2,2.82l-4.39,6.08l-1.47,5.38l-0.85,5.56l-2.84,-0.47l-1.46,0.44l-2.01,2.22l-0.96,2.4l-2.38,0.81l-1.53,2.05l-1.11,-0.31l-0.83,-2.02l-0.97,-0.76l-0.79,-0.2l-1.88,0.35l-3.55,-0.08l-6.53,0.7l-5.83,1.67l-2.05,-0.73l-2.08,0.46l-1.21,0.8l-0.31,0.62l0.12,0.77l0.69,0.97l-0.13,0.38l-4.92,2.46l-3.85,0.33l-5.2,-0.68l-4.23,0.56l-3.49,-1.69l-1.61,-0.38l-0.68,0.31l-0.33,0.87l-0.46,-0.1l-1.99,-1.33l-2.8,1.27l-2.3,-0.29l-3.58,-1.38l1.02,-0.49l0.2,-0.51l-0.78,-1.82l-2.01,-1.72l-3.92,-1.8l0.51,-1.32l3.47,-4.13l-1.27,-3.9l-0.81,-1.39l-0.43,-0.19l-1.65,0.37l-1.37,-0.22l-3.02,-3.81l-2.17,-0.39l0.19,-1.21Z",name:"Maine-et-Loire"},"FR-44":{path:"M159.66,300.12l3.14,1.13l1.62,-0.32l1.05,-1.07l0.07,-0.47l-0.56,-1.04l-2.21,-2.2l-0.46,-0.11l-0.82,0.44l-0.77,-1.59l-2.05,-1.2l4.12,-2.13l1.57,0.33l-0.09,0.55l0.45,0.48l0.58,0.01l2.59,-1.53l0.4,-0.74l-0.31,-0.53l-2.95,-0.38l0.35,-0.69l-0.16,-0.53l-0.77,-0.68l0.87,-0.21l2.37,0.81l3.21,-0.37l0.81,-0.45l0.88,-1.05l1.08,-1.85l0.93,-0.29l1.83,0.9l2.88,-0.91l0.01,0.96l0.41,0.72l0.57,0.29l0.85,-0.14l0.92,-1.04l0.66,-1.38l2.05,-1.24l0.71,-1.09l0.79,-3.53l0.74,-1.69l0.12,-1.43l-0.24,-0.62l0.35,-1.02l2.91,-1.59l2.21,-0.38l2.07,0.05l5.67,-2.08l1.82,0.61l1.85,0.19l7.5,-2.05l2.87,-1.7l1.19,-1.55l1.73,-1.21l6.3,-2.55l1.6,-1.15l3.02,-0.01l1.01,0.42l0.73,1.19l0.96,0.56l6.76,1.15l0.16,3.45l0.67,1.05l1.76,0.23l1.0,0.53l0.75,0.86l0.19,3.41l0.37,1.1l0.83,0.9l7.87,2.42l0.98,0.74l-1.05,1.0l-1.44,0.39l-6.49,-0.5l-1.25,1.0l0.26,1.69l1.38,2.12l1.77,1.1l9.66,0.99l0.59,3.84l0.89,2.13l0.74,0.97l-4.04,0.73l-7.8,0.13l-2.28,0.45l-3.64,1.92l-3.75,0.4l-1.21,0.4l-1.97,1.38l-0.44,2.05l0.34,0.46l2.15,0.27l3.27,3.95l1.6,0.25l1.59,-0.33l0.58,0.98l0.46,1.89l0.78,1.46l-3.34,3.98l-0.73,1.85l0.21,0.51l4.21,1.93l1.79,1.56l0.5,1.23l-1.33,0.64l-4.88,-2.79l-2.44,-0.76l-0.42,0.12l-2.08,2.69l-2.09,-0.41l-1.44,0.76l-0.51,1.31l0.34,2.89l-0.42,1.43l-3.09,2.07l-0.96,0.14l-0.76,-0.4l-0.43,-0.97l-0.0,-4.16l-0.54,-1.5l-0.62,-0.62l-1.05,-0.2l-3.16,1.21l-0.63,2.53l0.85,3.73l1.33,3.46l0.87,1.16l-0.79,0.87l-1.72,0.58l-6.12,-1.46l-3.27,-0.03l-0.79,-0.34l-3.21,-3.11l-6.39,-2.68l-1.88,-1.34l-3.66,-3.68l-1.27,-0.75l-0.14,-1.25l-0.69,-1.37l-1.79,-1.89l-3.8,-1.82l-7.01,-1.07l-1.45,-0.69l1.47,-1.03l1.91,-0.24l0.8,-0.55l0.42,-2.94l-0.66,-1.35l-0.09,-1.84l1.02,-2.31l1.32,-0.5l5.58,-0.5l1.1,-0.5l1.01,0.86l3.14,0.71l1.04,-0.02l0.24,-0.51l0.65,0.2l-0.47,0.4l0.19,0.91l2.51,1.59l2.62,0.48l1.97,1.62l1.54,0.57l3.31,0.09l0.4,-0.29l-0.19,-0.46l-1.24,-0.71l-2.55,-0.47l-5.05,-4.17l-2.19,-1.13l-2.7,-0.49l-1.38,-0.93l-2.33,-0.59l-8.57,0.49l-2.09,1.06l-1.63,2.06l-1.9,0.52l-1.37,1.18l-2.09,0.34l-0.98,-0.34l-2.32,-2.13l-1.22,-0.61l-2.17,0.0l-0.78,0.6l-0.33,0.97l-1.39,-0.03l-4.87,-2.21ZM161.53,297.57l0.02,0.14l-0.01,0.02l-0.01,-0.17Z",name:"Loire-Atlantique"},"FR-45":{path:"M460.91,221.47l0.33,-0.04l0.75,0.86l1.36,3.99l3.56,2.09l1.09,1.21l-0.82,1.86l0.48,1.68l-2.36,-0.11l-1.14,1.09l0.09,1.33l1.07,0.83l2.02,0.26l3.17,-0.65l8.35,0.59l2.29,-0.94l1.66,-1.6l0.83,-0.26l2.03,0.05l-0.41,1.53l0.32,0.38l1.06,0.2l7.05,-1.97l1.76,0.12l2.27,0.58l1.52,1.02l1.38,4.33l1.05,1.28l1.91,1.34l1.11,1.26l0.31,1.76l-1.88,3.81l-2.42,1.45l-1.42,1.43l-1.36,0.14l-0.46,0.42l0.1,2.67l0.95,2.06l-0.78,1.4l0.13,1.67l-0.42,0.96l-4.41,2.06l-4.1,0.43l-1.2,0.99l-0.29,1.64l0.41,1.33l2.48,1.05l2.32,2.0l1.13,2.08l-0.6,1.62l0.07,0.78l2.52,3.57l-3.22,0.29l-3.17,1.42l-0.3,1.25l0.72,0.77l-2.84,1.5l-1.07,0.08l-2.48,-1.92l-1.53,-0.21l-0.83,0.83l-1.2,2.16l-1.24,0.11l-0.91,-0.47l-2.08,-1.96l-2.56,-3.52l-1.22,-0.81l-3.47,0.03l-1.28,-0.35l-3.03,-2.4l-1.26,-0.12l-3.06,1.02l-1.43,-0.29l-3.28,-1.8l-3.15,0.05l-1.1,-3.21l-3.19,-1.1l-12.45,0.99l-1.67,-0.21l-3.13,-1.95l-2.01,-0.61l-0.99,0.36l-0.62,2.28l-1.06,1.75l-1.56,0.16l-1.79,-0.95l-1.35,-1.56l-0.91,-3.7l-0.83,-0.87l-2.54,-0.96l-2.25,-1.44l-0.58,0.18l-0.68,1.58l-0.69,0.36l-2.68,-2.27l1.14,-1.83l-0.03,-0.53l-2.02,-2.07l2.53,-2.72l0.15,-3.26l-0.91,-1.06l-1.61,-0.86l1.52,-1.97l0.29,-1.12l-0.39,-1.13l-0.72,-0.68l-1.86,-0.04l-0.18,-2.02l0.27,-0.71l0.82,-0.73l0.73,-0.12l1.8,0.74l1.17,-0.19l2.1,-2.38l0.86,-0.52l1.54,-0.15l3.3,0.6l3.84,-1.4l1.12,-0.16l1.62,0.35l1.42,-0.39l2.22,-2.35l1.73,-3.94l2.64,-0.88l0.63,-0.75l0.39,-1.43l-0.68,-3.44l1.26,-2.08l8.8,-1.74l2.18,-0.89l1.74,-2.19l1.08,0.42l1.34,1.84l0.89,0.32l1.9,-0.44l1.41,-1.25l0.41,-0.04l2.61,1.32l2.09,-0.21Z",name:"Loiret"},"FR-46":{path:"M440.29,478.66l0.61,1.12l0.9,5.86l3.12,4.71l1.22,2.47l-0.85,4.57l-0.66,1.67l0.43,0.65l1.41,0.75l0.84,3.28l0.5,0.83l1.27,0.7l-0.05,1.13l-3.48,1.2l-4.94,-0.35l-4.66,2.37l-3.63,2.62l-5.71,2.41l-0.24,0.48l1.66,5.79l2.5,3.77l-0.0,0.52l-3.11,1.27l-4.89,0.22l-5.08,1.99l-2.39,2.3l-1.58,-2.03l-1.59,-0.15l-1.24,0.4l-0.55,1.27l0.76,2.73l-0.66,0.49l-1.02,0.03l-2.32,-2.65l-2.03,-1.07l-0.49,0.16l-0.92,1.48l-1.2,1.0l-4.32,2.11l-1.36,-0.08l-3.04,-0.89l-0.16,-0.19l1.05,-1.93l-0.97,-1.37l-1.29,-0.04l-1.21,0.77l-1.83,-0.42l-4.22,-2.04l-1.03,-0.86l-0.62,-0.96l-0.08,-0.89l0.72,-1.87l-0.01,-1.35l-0.93,-0.81l-1.27,0.13l-1.62,0.71l0.11,-2.87l-1.84,-1.84l-0.96,-2.38l-0.09,-1.96l-1.25,-1.9l0.7,-0.81l2.99,-1.33l3.6,-2.94l3.41,-5.27l0.78,-0.63l2.29,-0.5l1.89,-1.35l1.85,-0.79l1.77,-1.9l0.54,-1.79l-0.67,-1.05l0.11,-0.81l0.64,-0.86l2.37,-0.76l1.69,-2.66l2.13,-1.79l0.74,-1.12l-0.14,-1.73l0.68,-1.13l0.08,-1.03l-1.31,-3.89l0.24,-0.96l3.33,-2.09l1.05,-0.26l1.04,-0.9l1.16,1.27l2.28,-0.55l1.67,0.46l2.94,1.66l2.03,1.61l1.3,1.87l1.92,0.91l1.31,1.01l0.92,0.2l1.46,0.02l3.21,-0.98l3.94,-1.84l2.17,0.72l1.98,-0.89l4.23,-0.19Z",name:"Lot"},"FR-47":{path:"M319.78,553.37l-1.2,-3.4l1.04,-0.97l1.37,-3.11l2.04,-2.74l-0.11,-0.58l-1.17,-0.7l-12.14,-2.12l-2.72,0.1l-0.02,-2.51l-0.58,-2.42l4.21,-1.88l2.04,-1.73l0.12,-0.43l-0.81,-2.36l-2.17,-2.67l0.43,-0.38l4.03,-1.09l1.11,0.2l0.47,-0.37l0.04,-1.27l-1.02,-2.11l0.74,-2.96l-0.36,-0.86l-1.26,-1.08l-0.12,-0.67l0.63,-1.59l2.34,-2.93l2.17,-0.04l0.8,-0.56l5.55,-6.3l0.27,-1.37l-0.64,-0.97l-2.55,-0.77l-0.6,-0.65l-0.14,-1.7l0.97,-1.37l0.8,-0.39l1.36,-0.1l1.73,1.8l1.12,0.02l0.79,-0.68l0.54,-2.67l2.3,0.19l1.33,-0.33l1.71,2.3l1.3,2.9l1.55,2.44l2.75,1.08l1.68,-0.35l3.94,-1.97l1.83,0.78l0.82,0.01l0.96,-0.61l1.52,-1.88l0.64,-0.14l2.33,0.07l1.41,1.49l1.49,0.49l3.11,-0.26l3.45,-1.11l0.96,0.12l1.08,0.85l0.53,1.13l-0.18,1.09l-1.19,1.0l-0.06,0.55l1.45,1.89l2.31,0.01l4.15,-2.55l1.83,-0.04l2.6,1.09l2.33,1.66l1.03,1.57l-3.67,1.83l-0.75,0.74l-0.26,0.78l1.31,2.09l0.06,1.85l1.05,2.61l1.8,1.78l-0.18,3.0l-0.59,0.58l-4.81,0.36l-1.13,-0.2l-1.77,-0.98l-0.77,0.08l-0.72,0.57l-0.27,2.47l-0.74,1.55l-0.06,0.88l0.85,1.37l2.45,0.96l0.36,0.51l-2.45,5.11l-2.16,1.72l0.1,0.72l1.14,0.8l-0.03,0.97l-1.25,0.21l-2.22,-0.7l-1.4,0.32l-0.49,0.48l-0.46,1.35l-2.26,1.33l-1.04,2.84l-3.57,1.87l-1.05,0.18l-2.71,-2.15l-1.51,-0.47l-5.15,1.53l-2.7,-0.26l-1.21,0.8l-4.35,1.91l-1.3,0.2l-3.0,1.53l-4.83,-1.62l-0.8,0.09l-1.07,0.84l-1.29,1.99l-1.07,0.78l-0.59,0.02l-0.58,-0.74l-0.76,-0.21l-2.2,0.65Z",name:"Lot-et-Garonne"},"FR-40":{path:"M257.68,586.1l-3.47,-0.76l-0.46,0.4l0.02,1.53l-0.37,0.7l-0.71,0.37l-1.74,0.1l-2.93,-1.39l-4.19,2.35l-0.77,-0.8l0.28,-2.2l-0.4,-1.23l-2.1,-1.2l-0.55,0.19l-0.33,0.71l-1.9,1.61l-2.45,1.2l-1.9,0.4l-4.17,0.09l-3.36,0.61l-1.68,-0.7l-2.34,-1.93l2.16,-2.92l0.41,-2.32l1.48,-4.27l2.51,-12.23l1.46,-4.3l2.15,-9.72l3.95,-21.25l1.83,-12.26l6.25,-1.83l4.03,-2.64l4.42,1.75l0.54,1.31l-1.08,3.38l0.25,0.5l1.12,0.37l1.26,0.04l3.0,-0.66l5.04,1.27l9.78,-2.13l2.02,0.19l0.84,0.91l0.31,1.52l0.82,1.09l4.86,2.61l0.9,2.07l0.99,0.56l3.91,0.98l2.79,2.16l0.27,0.44l-0.71,3.25l0.4,1.51l0.71,0.82l8.88,0.94l1.27,-1.19l0.32,-3.47l0.59,-0.27l3.55,2.64l0.62,2.47l0.02,2.84l0.42,0.4l3.0,-0.12l12.02,2.1l0.6,0.37l-1.85,2.5l-1.36,3.07l-1.19,1.39l1.46,4.12l-0.51,0.98l0.35,1.83l-0.42,1.05l-0.84,0.31l-3.14,-0.52l-0.37,-0.73l0.78,-1.23l-0.06,-1.08l-0.91,-0.88l-1.22,-0.35l-1.33,0.44l-1.59,1.05l-1.8,1.72l-1.77,0.13l-2.38,-0.3l-2.89,1.82l-0.59,0.71l-0.12,1.04l1.56,1.74l0.82,2.14l-1.14,2.17l-0.36,1.38l-0.05,2.41l0.76,1.67l-1.41,2.79l-1.21,0.16l-0.79,0.5l-0.11,0.65l0.54,1.41l-1.35,2.19l0.02,0.65l0.98,0.76l0.55,1.63l-4.66,1.61l-6.63,0.79l-0.71,-0.35l0.26,-1.88l-0.28,-0.39l-1.04,-0.28l-0.87,0.23l-4.57,3.24l-0.72,0.17l-6.65,-1.04l-2.64,0.72l-2.68,-1.37l-1.42,-0.25l-1.34,0.18l-3.55,1.67l-2.71,-0.2l-1.3,0.91Z",name:"Landes"},"FR-41":{path:"M366.23,238.4l1.39,-0.45l3.94,-0.19l2.09,-0.61l1.72,-1.09l1.22,-0.18l0.94,3.47l1.02,0.64l2.8,0.62l6.81,7.85l2.85,-0.52l4.43,1.84l1.58,0.07l1.59,-0.4l5.9,-2.92l2.85,0.84l1.93,-0.34l0.73,1.25l-0.22,0.64l-1.27,1.31l-0.37,1.04l0.15,0.45l2.42,1.6l-0.02,2.63l-2.71,2.99l0.04,0.51l2.01,2.06l-1.16,1.86l0.06,0.55l3.14,2.66l1.32,-0.28l0.95,-1.67l1.97,1.25l2.36,0.86l0.57,0.54l0.99,3.84l1.46,1.69l2.08,1.13l2.41,-0.33l1.21,-1.99l0.29,-1.73l0.66,-0.46l1.55,0.51l3.16,1.97l1.96,0.29l12.33,-1.01l2.92,1.01l0.77,2.69l-4.29,1.25l-1.96,1.28l-0.44,2.51l1.18,1.24l2.44,-0.04l0.8,0.51l1.38,2.93l1.89,2.53l0.29,2.13l-0.7,1.84l-1.42,-0.0l-3.86,-1.21l-1.11,0.31l-0.9,0.73l-0.53,0.94l-0.2,2.46l0.28,1.35l1.7,3.88l-0.46,1.37l-2.19,1.15l-2.93,0.33l-2.99,-0.35l-3.07,-1.09l-0.73,0.1l-1.95,1.93l-0.49,2.89l-1.71,0.63l-1.85,-0.46l-6.98,-5.39l-3.46,1.18l-4.12,-0.91l-0.44,0.3l-0.58,1.73l-1.13,-0.19l-1.56,0.32l-1.05,0.86l-0.43,1.45l-3.05,-0.69l-2.94,0.73l-5.7,2.97l-3.12,-5.16l-2.14,-1.75l-2.74,-0.57l-2.1,0.29l-2.59,-1.62l-0.99,-1.5l1.2,-3.48l0.32,-2.78l-0.28,-2.83l-0.95,-2.44l-1.95,-2.96l-1.21,-0.99l0.13,-0.95l0.82,-1.43l-0.03,-0.86l-1.89,-2.92l-0.86,-0.32l-1.67,0.72l-0.61,-2.06l-0.84,-0.53l-1.01,-0.13l-2.04,0.25l-1.06,0.53l-1.16,1.28l-1.06,0.22l-0.75,-0.8l0.44,-2.41l-0.21,-1.3l-0.61,-0.88l-0.9,-0.49l-6.06,-1.44l-2.11,0.75l-2.89,-1.54l-0.89,-0.16l-1.08,0.26l-1.07,0.76l-0.13,-0.27l0.59,-1.42l1.29,-1.16l5.17,-2.45l1.63,-1.53l1.57,-4.34l0.07,-3.55l0.45,-1.34l2.91,-2.22l0.88,-1.62l-0.43,-1.98l0.6,-3.59l-0.6,-0.63l-1.31,-0.12l-0.89,-1.68l0.21,-0.59l2.27,-0.25l0.71,-0.46l0.07,-1.0l-0.69,-0.59Z",name:"Loir-et-Cher"},"FR-42":{path:"M583.09,383.52l1.72,1.09l0.77,1.17l0.35,1.21l-0.35,1.44l-1.12,0.39l-3.17,0.2l-1.25,0.79l-5.05,5.08l-0.45,1.47l0.12,0.4l2.9,2.04l0.31,0.55l-0.33,0.68l-1.86,0.46l-0.95,0.6l-0.16,0.46l0.36,1.11l4.31,2.35l0.65,1.11l-0.54,1.84l0.24,1.21l0.63,0.77l1.77,0.9l1.13,1.52l-0.55,1.62l-2.44,3.28l0.24,1.69l3.02,0.77l0.08,0.5l-2.0,2.9l1.13,3.68l3.25,3.28l3.98,2.29l3.0,0.54l3.8,-0.5l1.89,0.21l1.14,0.81l0.17,0.81l-0.79,3.31l0.17,1.78l0.8,0.92l0.95,0.24l2.4,-0.12l0.7,0.4l1.54,2.0l-0.27,3.07l0.76,2.48l-2.68,0.48l-5.51,2.54l-1.35,1.01l-0.94,1.46l0.19,3.77l-7.86,0.47l-1.9,-1.64l-1.54,-0.81l-2.83,-0.33l-1.06,-2.26l0.79,-1.98l-0.44,-1.83l-1.29,-2.03l-1.55,-0.99l-2.48,1.54l-4.06,-1.11l-2.36,0.02l-0.64,0.32l-0.28,1.19l-0.59,0.59l-5.7,0.96l-2.47,0.09l-1.61,-1.66l-0.73,-0.21l-2.27,0.68l-1.66,1.06l-0.4,-0.55l0.57,-2.63l0.71,-1.31l2.82,-2.97l0.97,-2.32l-0.07,-1.42l-2.55,-5.63l-7.56,-6.05l-3.13,-6.33l-0.58,-0.9l-1.05,-0.64l-1.81,-3.03l0.87,-1.71l0.1,-2.6l0.88,-1.58l0.32,-1.57l-0.57,-1.38l-2.48,-1.95l-0.33,-0.83l0.19,-0.43l2.19,-1.04l4.84,-1.05l0.92,-0.65l0.52,-0.86l-0.92,-6.28l-0.68,-2.16l0.16,-3.93l-0.45,-3.2l-1.15,-1.48l0.18,-0.5l2.9,-2.1l3.64,-1.01l0.56,1.52l-0.19,2.42l0.26,0.72l1.01,0.63l2.01,0.62l2.09,1.49l0.94,0.18l5.09,-1.32l3.56,0.89l3.56,-0.61l4.78,1.24l1.92,-0.02l1.84,-0.64l1.67,-1.19l1.71,-2.0Z",name:"Loire"},"FR-43":{path:"M552.14,449.48l0.67,0.85l0.84,0.2l1.6,-1.2l1.9,-0.6l2.13,1.82l2.81,-0.06l5.93,-1.02l0.73,-0.54l0.63,-1.51l2.08,-0.01l4.17,1.12l0.77,-0.18l1.64,-1.34l1.05,0.73l1.46,2.67l-0.74,2.73l1.01,2.4l0.55,0.5l2.83,0.32l1.35,0.69l2.79,2.4l0.01,0.38l-0.57,2.1l-1.56,2.88l-0.39,2.24l-0.49,0.1l-1.12,-1.01l-1.15,-0.45l-0.79,0.06l-0.57,0.5l-0.04,0.8l0.87,1.5l-1.86,1.79l-0.32,0.95l1.23,1.99l-1.15,0.49l-2.02,0.27l-0.8,0.49l-0.88,1.68l0.6,1.25l-0.04,0.58l-2.45,0.94l-1.75,-0.24l-0.7,0.42l-1.47,3.48l-2.26,2.8l-5.01,0.84l-2.52,-0.04l-0.63,0.49l-0.58,1.76l-3.92,1.29l-3.33,4.57l-1.1,0.45l-1.34,-0.28l-3.14,-1.55l-4.13,-3.41l-4.32,-0.85l0.51,-1.34l-0.08,-0.66l-1.42,-1.21l-1.93,-0.18l-1.33,0.48l-0.47,0.69l-0.31,1.9l-0.69,0.54l-3.23,0.32l-1.34,0.6l-0.62,-0.3l-1.06,-1.05l-3.45,-5.83l-1.02,-2.98l-1.04,-0.38l-0.16,-1.22l-0.68,-1.37l-3.66,-3.52l-0.3,-0.83l0.23,-1.07l2.14,-2.1l-0.09,-1.37l-0.66,-0.63l-1.9,-0.28l-0.72,-1.02l-0.39,-3.9l-0.44,-1.16l-1.67,-2.2l-0.5,-2.83l-0.66,-0.76l-1.65,-0.75l-1.77,-0.29l-2.82,0.33l0.05,-2.32l-0.44,-2.12l3.43,0.06l2.05,-0.48l2.28,-2.19l0.84,-0.45l2.27,-0.41l1.03,-0.48l1.31,-1.17l0.83,-0.02l3.17,1.58l5.41,-1.2l1.34,0.03l3.7,1.65l2.36,2.96l1.35,0.62l0.97,-0.2l2.41,-1.46l3.22,1.35l1.86,0.13l1.28,-0.57l0.79,-1.69l0.57,-0.41l4.6,1.93Z",name:"Haute-Loire"},"FR-95":{path:"M472.15,160.47l-0.57,1.17l-0.34,2.93l-0.72,1.39l-1.7,0.89l-3.08,2.77l-1.79,0.51l-6.03,-1.25l-1.59,1.06l-1.49,0.13l-2.45,0.94l-2.51,1.9l-1.87,0.64l-1.91,2.31l-1.15,-0.18l-0.15,-1.53l0.8,-1.99l1.85,-1.25l0.69,-1.15l0.06,-1.58l-0.55,-0.62l-1.79,-0.69l-3.19,-0.24l-1.41,0.41l-0.96,1.17l-1.13,2.37l-0.81,0.54l-0.64,-0.2l-0.35,-0.74l0.37,-1.7l-1.09,-1.77l-0.96,-0.82l-2.38,-0.34l-3.48,1.12l-0.7,-1.24l-0.75,-3.02l-1.03,-1.11l-1.25,-0.42l-1.35,0.0l-1.35,0.31l-3.47,1.74l-0.79,-0.03l-0.51,-1.72l-1.59,-0.6l-2.87,-0.41l2.79,-8.08l1.58,-2.72l0.43,0.35l0.8,2.03l0.97,0.67l3.39,0.3l5.65,1.41l6.54,-0.78l5.01,-2.69l3.66,2.09l2.47,0.26l3.97,1.5l1.83,0.1l3.18,-1.39l11.5,5.26l0.91,0.03l0.87,-0.37l2.41,2.32Z",name:"Val-d'Oise"},"FR-GF":{path:"M0.97,715.11l0.03,-0.01l1.04,0.32l0.16,0.02l0.86,-0.15l0.51,-0.46l0.86,-2.17l2.19,-0.54l1.75,-1.7l3.1,-6.63l2.47,-3.35l0.8,-2.07l0.47,-0.34l0.06,-0.66l-0.55,-0.79l0.94,-2.39l-0.02,-0.46l-0.64,-0.76l0.44,-0.66l-0.5,-1.65l0.23,-1.91l-0.45,-0.69l-0.46,-0.14l0.86,-1.73l2.07,-2.81l1.19,-0.89l0.84,-2.29l1.16,-1.21l0.63,-1.48l-0.08,-2.67l0.59,-2.69l-0.24,-0.63l-0.99,-0.8l-0.94,0.14l-0.73,-1.11l-0.67,-2.34l-1.1,-1.52l-2.15,-0.96l-0.85,-1.38l-0.94,-0.69l-0.78,-1.45l-0.91,-0.91l-0.6,-1.53l-1.41,-1.5l0.64,-2.85l-0.13,-0.85l-2.32,-1.44l0.46,-1.46l-0.01,-1.08l-0.33,-1.55l-1.0,-2.09l-0.57,-3.53l0.9,-2.56l0.01,-1.55l-0.48,-1.52l0.02,-2.19l-1.39,-1.38l0.0,-4.12l-0.26,-0.77l1.19,-1.14l-0.22,-1.91l0.25,-0.92l2.73,-3.76l0.74,-0.61l1.11,-2.37l4.66,-4.06l2.22,-1.17l1.58,-1.93l1.87,-4.21l0.52,-3.48l1.46,-2.55l2.53,0.36l1.76,0.65l0.25,-0.36l3.4,2.05l6.81,3.12l3.05,0.38l3.49,0.88l0.86,-0.07l1.81,1.42l0.75,-0.24l0.28,-0.38l-0.11,-0.54l0.6,0.16l3.21,1.77l2.63,0.74l0.44,-0.2l3.1,1.65l2.24,2.12l1.54,0.85l1.06,1.69l7.47,6.54l0.33,0.77l1.43,0.41l2.53,2.16l0.64,1.06l-0.27,1.23l0.6,0.43l2.01,-1.77l1.2,0.54l0.54,0.96l-2.76,4.28l0.03,1.47l0.4,0.37l0.6,-0.32l0.54,-0.93l0.57,-1.94l2.11,-1.78l0.87,0.63l1.21,1.89l2.18,1.25l2.26,2.1l0.89,1.31l1.5,6.51l-0.33,1.34l-1.91,1.37l-0.89,1.13l-0.01,0.47l0.45,0.15l2.11,-0.67l1.15,-0.61l0.64,-0.84l0.53,-2.04l-0.28,-4.87l0.65,-1.95l1.05,-0.2l1.97,1.65l0.0,0.74l1.13,1.9l0.28,1.83l0.66,0.89l-0.25,0.37l0.26,0.94l0.51,0.66l1.03,0.2l-0.69,0.86l-0.09,1.41l1.97,3.43l0.18,0.84l-0.06,2.16l-0.64,2.0l-0.3,0.58l-2.4,1.19l-1.04,0.92l-1.71,3.75l-2.1,2.32l-1.35,0.82l-0.13,1.42l-0.89,0.24l-0.67,0.68l-0.88,2.96l-1.99,3.34l-0.78,0.63l0.04,0.74l-4.48,7.35l-0.56,0.42l-1.13,0.12l-0.77,0.72l-0.64,1.51l-1.27,1.01l-0.24,0.8l0.31,2.33l-2.32,4.42l0.33,0.96l-1.39,1.05l-2.96,7.18l-1.09,0.6l0.67,2.17l-2.13,3.57l-1.21,1.07l-1.71,2.4l-5.24,2.87l-0.69,0.6l-0.84,1.79l-2.17,0.93l-2.57,-0.42l-1.92,-1.13l-5.09,0.79l1.41,-1.11l-0.13,-0.65l-2.09,-1.75l-0.88,-1.21l-0.87,-0.45l-0.43,0.08l-1.13,1.43l-2.74,1.58l-2.14,0.34l-1.52,-0.76l-2.22,-0.27l-2.22,-0.96l-0.87,-0.06l0.23,-1.21l-0.6,-0.69l-0.75,-0.14l-1.33,0.55l-1.05,1.47l-1.27,0.26l-0.98,1.22l-1.24,-0.04l-0.49,1.63l-0.46,0.33l-1.97,0.97l-0.71,-0.32l-1.16,0.23l-0.87,2.01l-0.86,0.39l-1.72,-1.68l-2.66,0.42l-1.6,-0.21l-2.03,-1.41l-3.41,-0.59l-1.86,-1.51l0.34,-0.7l-0.6,-0.59l-1.7,-0.92Z",name:"Guyane fran\xe7aise"},"FR-GP":{path:"M44.87,452.95l2.26,-1.9l1.31,-0.53l0.63,0.19l-2.39,1.57l-1.81,0.66ZM16.07,454.56l0.99,-3.24l0.45,-0.54l1.25,-0.4l0.33,-0.98l-0.15,-1.3l-1.63,-0.93l-0.61,-3.02l1.65,-2.23l2.47,-1.44l2.87,2.33l0.67,1.2l0.24,4.01l1.84,2.68l1.77,1.09l0.71,-0.33l2.34,0.36l6.21,4.32l1.16,0.34l-0.55,0.18l-3.31,-0.89l-10.9,2.46l-3.09,1.07l-2.38,-0.65l-1.77,-1.2l-0.78,-1.34l0.24,-1.57ZM29.3,476.81l1.29,-2.59l1.05,-1.18l1.16,-0.64l1.27,0.28l1.08,0.91l0.68,1.72l0.94,0.93l0.13,1.34l-1.12,1.36l-1.47,0.73l-1.99,0.48l-1.58,-0.25l-1.44,-3.1ZM6.63,475.24l-0.25,-0.65l0.35,-0.72l-0.44,-0.85l-1.95,-1.6l-0.87,-1.97l-0.57,-0.45l-0.69,-2.06l-0.05,-4.94l-0.89,-2.29l0.25,-1.07l-1.09,-2.09l0.05,-3.66l1.5,-2.21l0.77,-0.65l0.89,-0.23l1.5,1.13l3.84,1.09l2.02,1.06l0.67,0.81l-0.4,0.18l0.01,0.74l0.87,0.07l0.72,0.74l0.65,-0.12l0.7,-0.95l0.47,-0.08l0.26,0.32l-0.35,1.27l0.32,1.1l-1.34,0.42l-0.48,0.89l0.13,2.94l0.8,2.29l0.41,3.37l-0.49,3.19l-1.83,2.19l-2.76,1.62l-2.74,1.16ZM13.68,480.6l0.09,-0.17l0.15,-0.01l-0.11,0.1l-0.13,0.09ZM10.63,481.22l0.17,0.27l-0.27,0.31l-0.19,-0.11l0.3,-0.46Z",name:"Guadeloupe"},"FR-39":{path:"M636.54,324.96l3.3,-1.96l0.29,-0.73l-0.62,-2.26l0.27,-0.68l5.24,-2.45l5.77,-8.09l0.56,-1.07l0.24,-2.05l1.4,-4.44l3.31,2.04l1.05,0.28l1.17,0.03l3.94,-0.81l0.76,0.37l0.46,0.74l1.09,2.82l3.51,2.25l1.95,3.33l-0.51,1.91l-1.77,1.97l-0.1,2.5l-1.72,1.99l0.3,1.45l1.37,0.56l2.08,-1.29l2.03,1.7l4.71,0.92l2.03,0.9l1.96,2.56l0.58,4.16l1.96,2.96l0.83,0.55l2.78,0.44l7.29,5.91l-0.57,0.75l-6.3,4.25l-0.52,0.66l0.0,1.44l0.82,1.57l-1.76,1.41l-0.84,1.22l0.33,1.61l1.72,1.74l3.37,1.86l-1.94,2.13l-3.09,4.33l0.33,2.88l-3.79,4.35l-2.1,1.94l-1.03,1.64l-4.26,3.58l-2.33,0.56l-7.03,-0.44l-0.45,-0.65l-0.22,-1.3l-0.66,-0.88l-3.08,-2.47l-0.52,-0.06l-2.8,2.33l-0.57,1.15l-1.28,0.24l-1.18,1.22l-1.45,0.59l-0.82,0.73l-1.63,-0.33l-0.55,-0.58l0.29,-2.41l-0.42,-1.04l-1.87,-0.45l-0.9,-1.08l-2.11,-0.64l-0.82,-0.85l-0.79,-2.49l-1.25,-0.94l-1.43,-0.41l-0.41,-0.65l-0.02,-2.36l1.02,-0.49l4.42,-0.91l1.13,-0.73l0.39,-0.89l-0.11,-0.84l-0.52,-0.67l-2.59,-1.42l-0.66,-1.39l0.39,-1.98l1.89,-1.03l0.5,-0.65l1.1,-3.74l-1.49,-5.71l-0.52,-1.09l-1.27,-1.09l0.92,-2.13l-0.29,-0.66l-1.72,-1.29l-0.18,-0.73l1.26,-0.72l3.88,-0.5l1.03,-0.96l0.46,-1.58l-0.25,-0.34l-2.12,-0.68l-1.69,-1.38l-1.75,-0.35l-2.19,-1.16l-3.31,-3.1l-1.32,-2.47Z",name:"Jura"},"FR-38":{path:"M609.43,431.43l0.37,-0.26l11.99,-0.96l1.42,-0.94l1.29,-2.78l2.74,-2.21l1.55,-0.72l1.38,0.0l0.4,-0.35l0.15,-1.12l-0.77,-1.09l-3.91,-1.99l-0.55,-0.73l-0.01,-0.96l1.81,-3.4l1.46,0.25l5.22,2.56l1.5,0.29l1.26,-0.39l0.95,-0.77l3.72,-5.2l1.66,-0.79l1.02,0.37l2.95,2.53l-0.16,0.54l1.05,2.91l1.74,2.31l4.28,3.44l1.11,1.33l2.09,3.44l1.43,3.24l7.19,12.36l0.99,0.97l9.61,3.52l0.53,-0.42l0.24,-5.99l0.77,-0.59l1.92,-0.13l0.96,0.33l3.69,2.98l4.95,0.68l2.57,2.57l1.08,1.62l0.41,1.78l-0.28,1.51l-2.76,2.4l-0.7,1.38l-0.16,1.59l1.41,5.27l0.16,2.5l0.48,0.71l0.6,0.2l3.54,0.13l1.61,0.52l0.42,0.96l-1.56,1.89l-1.05,4.98l0.01,1.51l0.51,1.03l1.24,0.41l3.69,-0.43l0.93,0.46l0.56,3.36l1.97,2.53l-0.32,4.01l-0.85,0.16l-2.83,-0.77l-3.8,0.98l-1.71,-0.15l-1.86,0.35l-2.28,-0.4l-3.91,2.12l-3.38,-0.2l-3.2,2.03l-0.33,0.77l0.25,1.63l-0.69,0.66l-2.32,0.66l-4.54,0.49l-2.12,2.84l-2.13,0.21l-7.15,-1.11l-5.25,-4.64l-1.23,-0.57l-0.56,0.37l0.02,1.16l-3.85,-1.07l-0.77,-0.79l-0.02,-1.18l1.34,-7.85l0.0,-2.77l0.7,-2.77l-1.35,-4.55l0.89,-1.79l-0.37,-0.58l-1.95,0.13l-4.0,2.45l-2.19,-0.04l-0.76,-1.11l-1.94,0.36l-1.68,-0.41l-1.95,-0.01l-1.01,-1.74l-2.6,-0.1l-0.59,0.26l-0.24,-0.8l1.17,-3.91l-0.89,-4.16l-0.15,-2.44l-0.84,-1.66l-0.5,-0.19l-1.67,0.65l0.4,-2.19l-0.39,-0.47l-2.66,-0.05l-0.71,-0.53l-1.36,-2.01l-1.81,-0.09l-1.11,-1.65l-1.05,-0.26l-1.5,0.3l-5.43,2.97l-3.6,0.31l-2.13,-2.79l-0.16,-1.49l-1.08,-3.38l0.27,-3.03l1.51,-2.04l4.14,-3.16l1.07,-2.82l-0.1,-0.43l-1.88,-1.77l-1.7,-1.15Z",name:"Is\xe8re"},"FR-31":{path:"M438.35,594.54l-4.57,0.58l-3.86,1.57l-0.35,-1.32l-0.56,-0.57l-1.18,-0.36l-0.78,0.18l-0.7,1.44l-1.61,1.87l-0.18,0.68l0.42,1.98l-0.7,0.55l-1.69,0.11l-2.37,0.73l-1.83,3.99l-1.62,-0.34l-1.69,1.92l-0.67,0.15l-0.53,-0.93l-0.7,-0.5l-2.26,0.09l-3.43,-2.4l-1.51,0.22l-0.75,1.47l0.93,2.1l-0.77,1.46l-1.23,0.84l-1.35,0.05l-1.19,-0.81l0.4,-1.59l-0.23,-0.93l-3.02,-2.84l-1.49,-0.75l-1.59,-0.19l-1.48,0.75l-0.37,2.57l1.03,1.07l3.21,1.18l0.54,0.63l-0.4,0.78l-1.31,0.81l-2.63,0.93l-4.2,0.5l-1.19,1.26l0.41,1.54l2.88,1.2l0.73,0.9l-2.48,2.2l-0.7,-0.1l-2.02,-2.74l-3.53,-1.98l-1.05,-0.07l-2.07,0.8l-1.63,0.09l-0.77,0.7l-0.87,1.86l-2.5,1.07l-0.7,1.18l-0.08,1.93l0.65,3.53l-0.3,1.26l-1.98,1.54l-2.5,0.59l-1.87,0.07l-0.84,0.99l-0.34,1.64l-1.88,1.25l-0.41,2.1l1.2,4.4l-1.96,-1.01l-2.28,-0.07l-3.17,-0.95l-2.82,0.01l-1.52,0.52l-0.54,1.34l0.11,1.63l-0.82,1.99l0.47,0.91l-0.83,1.28l0.24,0.56l0.76,0.24l0.61,0.69l0.36,0.97l-0.05,1.0l-0.39,0.58l-10.29,0.14l-0.66,-0.25l-0.7,-5.3l0.12,-4.44l0.39,-1.7l0.65,-1.16l1.0,-0.2l3.45,0.3l1.97,-1.5l3.97,-5.65l-2.4,-5.55l-0.48,-0.2l-1.96,0.65l-2.16,1.31l0.36,-1.37l1.29,-2.08l0.35,-1.15l-0.18,-0.46l-6.96,-3.98l3.47,-3.2l1.19,-1.73l2.09,-0.72l0.7,-0.75l-0.1,-2.33l2.19,-1.81l0.75,-1.08l-0.3,-1.32l1.57,-0.13l1.53,-0.85l3.15,-3.7l2.01,-0.99l2.09,-1.87l7.67,0.4l1.23,0.7l2.77,2.43l1.75,0.36l1.71,-1.59l0.5,-2.5l0.11,-4.81l1.16,-3.23l0.85,-1.05l3.79,-0.02l2.88,-2.08l0.92,-2.77l-0.11,-0.42l-2.97,-2.72l-4.72,-2.63l-1.01,-2.3l-2.09,-1.29l-2.6,-2.61l-0.98,-1.95l5.54,-1.27l3.13,0.08l2.12,-0.81l1.48,-0.01l3.38,3.05l1.92,-0.01l6.87,-3.51l0.09,-0.65l-0.7,-0.63l-2.44,-1.22l3.91,-2.14l4.12,0.36l0.93,-0.42l1.66,-1.68l1.72,0.56l2.12,-1.15l-0.25,2.12l1.83,3.3l0.04,1.74l2.14,1.35l1.79,0.59l2.29,5.99l2.73,2.76l0.1,0.71l-1.25,0.52l-0.73,0.77l-0.45,0.83l0.16,0.54l6.28,3.37l1.9,0.54l0.98,0.72l2.66,3.34l4.34,3.17l1.17,0.2l1.26,-0.64l1.07,-1.48l1.14,-0.06l1.3,1.29l-1.5,2.12l-0.12,1.34l0.26,0.94Z",name:"Haute-Garonne"},"FR-30":{path:"M566.02,584.87l-0.06,-1.85l3.33,-1.3l1.57,-2.94l-0.27,-4.12l-2.13,-3.56l-0.92,-0.7l-2.81,-1.24l-3.53,-2.48l-3.2,-0.45l-0.09,-3.29l-0.36,-1.11l-0.69,-0.87l-1.07,-0.59l-2.18,-0.12l-4.39,0.66l-1.56,-1.15l1.35,-3.1l-0.1,-0.46l-2.7,-2.28l-3.77,-0.42l-2.69,1.99l-0.9,2.3l-2.1,-0.17l-1.35,0.34l-1.85,2.64l-0.86,0.74l-0.97,-0.02l-1.81,-1.45l-1.55,-0.47l-1.27,0.54l-0.57,1.76l-0.36,0.59l-0.4,0.09l-1.06,-0.9l-1.22,-2.44l-1.2,-0.57l-2.57,0.04l0.68,-1.95l5.28,-4.67l0.31,-0.63l-0.08,-0.85l-0.93,-1.06l-2.91,-2.03l-1.78,-0.14l-1.54,-1.21l-1.67,0.17l-0.93,-0.62l2.15,-1.34l0.28,-2.27l0.84,-1.14l1.88,-1.21l6.14,3.38l2.51,0.67l6.22,-0.32l1.43,-1.05l0.3,-3.47l1.43,-0.44l1.03,0.26l6.27,3.34l4.61,0.45l0.9,-0.21l2.81,-2.74l2.28,-4.39l0.51,-1.75l-0.2,-1.4l-1.55,-3.3l-0.62,-3.31l-1.79,-2.77l0.63,-0.51l2.02,-0.35l0.99,-0.67l1.96,-3.09l1.34,1.08l1.64,2.61l-0.83,2.07l0.49,3.26l0.66,0.8l4.86,-0.5l1.08,1.04l4.93,2.42l1.51,0.3l0.78,-0.21l1.6,-1.52l3.36,-2.18l2.44,-0.38l0.36,0.44l-0.26,1.47l0.24,0.69l0.83,0.79l0.97,0.26l0.84,-0.14l1.05,-0.78l0.64,-2.28l2.19,-0.38l1.44,0.09l1.68,0.67l2.19,2.02l1.73,0.78l2.57,0.61l0.57,1.69l1.23,1.54l0.1,1.58l1.9,1.83l0.18,2.73l-0.33,2.14l0.45,2.79l0.62,0.47l1.22,-0.4l1.2,0.21l4.51,5.33l-0.09,0.53l-1.09,-0.09l-0.55,0.26l-0.07,2.45l-1.05,1.25l-1.67,1.19l-2.8,1.16l-5.36,3.57l-0.17,0.92l0.54,4.15l-1.95,4.79l-0.24,2.71l-0.49,0.37l-1.49,-0.73l-2.67,-0.6l-2.03,0.57l-1.49,1.04l-1.68,2.12l-1.37,2.92l0.45,1.06l1.58,0.26l-0.69,1.49l-2.15,0.42l-0.61,1.38l-1.54,0.44l-3.46,2.46l-2.02,0.48l-1.44,1.06l-1.17,0.31l-1.37,3.01l-2.27,-0.34l-2.81,-1.63l-0.8,-1.47l0.87,-1.81l-1.93,-1.64Z",name:"Gard"},"FR-33":{path:"M238.0,500.65l3.34,-33.36l2.55,-12.04l1.09,-15.98l2.41,-4.69l0.79,-1.06l0.72,-0.24l0.41,0.27l-0.33,2.59l1.44,2.01l4.22,2.89l3.51,1.53l7.32,7.13l1.65,2.15l1.65,6.53l1.42,7.99l2.13,4.49l2.13,2.43l2.35,2.0l2.44,1.49l0.52,1.41l-0.17,1.23l0.35,3.2l0.54,1.31l0.97,0.73l0.45,-0.0l0.16,-0.42l-0.81,-4.06l0.53,-2.18l-0.8,-1.78l-1.38,-1.23l1.66,0.3l2.68,1.57l0.51,-0.03l0.06,-0.51l-1.72,-2.53l-5.08,-1.82l-2.05,-1.4l-1.05,-1.86l-0.76,-2.33l-2.25,-14.04l4.57,0.18l1.0,-0.64l1.05,-1.41l0.92,0.83l0.37,1.95l0.61,0.79l2.13,0.71l2.33,0.11l3.23,2.19l0.41,0.91l-0.17,2.14l0.36,1.62l1.1,1.8l0.99,0.81l3.02,-0.17l1.87,1.12l1.79,0.6l2.4,1.97l4.08,1.26l1.94,-0.24l3.34,-1.09l1.62,0.54l1.87,-0.63l3.77,-0.0l0.86,0.7l0.85,1.9l0.12,1.21l-1.66,3.4l0.03,1.68l-1.47,1.64l-0.45,1.0l-0.12,1.41l1.53,1.97l-0.01,0.4l-2.58,3.64l0.39,0.63l0.61,-0.09l1.97,1.69l8.78,1.03l1.48,-0.51l2.82,-2.66l-0.03,-0.86l3.63,0.92l0.66,0.53l-1.25,1.32l-1.81,0.49l-0.36,0.49l0.68,2.82l1.1,1.81l-2.83,-0.11l-0.79,0.27l-0.38,0.53l-0.22,2.0l-0.4,0.64l-0.52,0.05l-1.67,-1.76l-0.96,-0.21l-2.05,0.69l-0.81,0.75l-0.67,2.2l0.31,1.13l1.02,1.08l2.35,0.65l0.34,0.39l-0.21,1.07l-5.31,5.95l-0.48,0.38l-1.65,-0.17l-0.88,0.43l-2.92,3.93l-0.27,1.03l0.15,1.03l1.6,1.84l-0.76,2.83l1.04,2.29l-0.04,0.56l-0.94,-0.13l-4.21,1.14l-0.89,0.74l-0.09,0.48l0.63,1.22l1.67,1.71l0.69,2.02l-1.69,1.46l-4.28,1.92l-4.05,-2.75l-1.25,0.81l-0.23,3.33l-0.71,0.8l-8.28,-0.78l-0.44,-0.46l-0.35,-1.31l0.73,-3.12l-0.54,-1.05l-3.06,-2.33l-3.93,-0.99l-0.75,-0.44l-0.94,-2.1l-4.74,-2.51l-0.63,-0.78l-0.41,-1.73l-1.27,-1.23l-2.36,-0.21l-9.74,2.12l-4.86,-1.26l-4.17,0.64l-0.69,-0.23l1.0,-3.14l-0.68,-1.87l-5.07,-2.13l-4.33,2.73l-5.9,1.73l0.19,-2.24l-0.62,-3.67l1.83,-2.53l1.26,-4.35l1.04,-1.14l1.32,-0.04l3.7,0.81l2.29,-0.28l1.4,-0.83l0.21,-1.48l-1.01,-1.12l0.28,-0.48l-0.7,-1.19l-4.63,-3.83l-1.79,-0.89l-0.92,0.36l-3.56,5.22l-0.53,2.34Z",name:"Gironde"},"FR-32":{path:"M359.79,547.18l0.65,0.81l0.4,1.58l0.66,0.23l3.14,-1.63l0.89,0.14l0.43,0.57l0.03,0.93l-0.49,1.07l-3.18,3.71l-1.5,0.87l-0.15,0.61l0.99,1.17l1.74,0.65l4.32,0.23l0.53,0.72l1.39,6.68l-0.62,1.87l0.36,0.56l3.17,0.08l1.18,2.38l2.68,2.69l2.04,1.25l0.51,1.61l0.55,0.73l4.81,2.7l2.66,2.45l-0.8,2.4l-2.51,1.73l-3.62,-0.05l-1.33,1.4l-1.3,3.59l-0.11,4.84l-0.46,2.27l-1.31,1.13l-0.93,-0.27l-2.74,-2.4l-1.42,-0.82l-7.83,-0.52l-1.11,0.52l-1.55,1.52l-2.15,1.1l-3.04,3.62l-1.39,0.77l-1.79,0.11l-8.42,-1.75l-3.48,0.02l-1.29,-2.02l-0.57,-0.05l-0.64,0.61l-1.27,0.43l-0.98,-0.57l-0.81,-1.16l-0.76,-0.46l-1.13,-0.17l-4.88,0.9l-0.78,-0.25l-1.87,-2.23l-1.19,-0.73l-0.11,-0.88l0.54,-2.12l-1.07,-1.75l-0.7,-2.22l-0.78,-0.41l-1.24,-0.05l-3.06,-1.7l-0.93,-0.16l-1.15,-2.48l-0.59,-2.7l-0.34,-0.31l-1.92,-0.22l-1.76,0.52l-2.87,2.2l-5.51,-1.02l-1.94,0.13l-0.8,-1.93l-0.88,-0.6l1.33,-2.32l-0.5,-1.87l1.85,-0.49l1.64,-3.16l0.08,-0.71l-0.81,-1.29l0.05,-2.22l1.48,-3.42l-0.0,-0.64l-0.91,-2.1l-1.51,-1.7l0.46,-0.78l2.03,-1.39l0.59,-0.28l2.14,0.33l2.0,-0.16l2.08,-1.86l2.5,-1.32l1.3,0.7l0.06,0.52l-0.83,1.47l0.38,1.15l1.26,0.69l2.78,0.25l1.22,-0.46l0.56,-0.85l0.17,-0.92l-0.33,-1.74l0.68,-1.02l1.79,-0.56l0.96,0.87l1.31,-0.01l1.3,-0.95l2.0,-2.61l5.5,1.55l3.19,-1.57l1.3,-0.2l4.46,-1.96l1.1,-0.75l2.5,0.3l5.09,-1.52l1.7,0.75l2.48,1.88l1.39,-0.26l3.55,-1.86Z",name:"Gers"},"FR-35":{path:"M193.66,200.25l0.91,0.63l0.48,-0.04l0.09,-0.48l-0.55,-1.04l-0.7,-0.57l-1.7,-0.54l-1.61,-3.1l0.51,-1.02l1.66,-0.82l0.37,-1.34l0.28,-0.13l2.22,0.0l0.28,-0.7l4.99,-0.86l0.54,1.16l-1.35,1.87l-0.06,2.08l1.7,1.73l2.67,0.63l4.54,0.04l4.83,-0.64l3.02,-1.39l2.6,5.45l1.04,3.06l1.91,2.9l3.27,2.38l2.44,0.21l1.93,-0.61l2.78,-1.91l2.08,-0.77l2.22,-2.4l2.39,0.03l6.14,1.5l2.32,1.25l-0.2,5.67l0.77,8.15l-1.95,4.1l0.21,1.05l0.9,1.52l0.8,4.72l-0.73,1.74l0.74,4.88l0.57,1.17l1.18,1.08l0.09,4.44l-1.36,0.63l-4.18,0.61l-2.21,1.9l-0.63,1.08l-2.9,9.1l-1.14,1.77l-0.41,1.91l-6.47,-1.09l-0.75,-0.44l-0.77,-1.22l-1.29,-0.55l-3.34,-0.0l-1.83,1.23l-6.34,2.57l-1.86,1.31l-1.2,1.55l-2.58,1.54l-7.31,2.01l-3.72,-0.8l-4.42,1.41l-1.22,0.67l-4.0,0.25l-3.59,1.82l-0.51,1.1l-0.32,-0.19l-0.17,-2.18l-1.02,-2.2l-0.09,-1.86l0.33,-0.32l2.98,-0.32l0.46,-1.25l-0.89,-1.18l-2.27,-0.12l-0.44,-0.27l-0.01,-0.41l0.68,-0.49l1.58,-0.35l0.94,-0.71l1.05,-2.15l0.07,-1.24l-0.88,-1.2l-2.57,-0.21l0.4,-6.26l-0.33,-1.06l-1.18,-1.53l-2.87,-1.77l-5.29,-0.98l-0.72,-0.47l-0.03,-1.08l0.71,-0.97l4.1,-1.14l0.83,-0.85l0.1,-1.05l-1.0,-0.9l-2.74,0.1l-1.37,-2.46l-1.39,-1.47l3.16,-2.19l0.88,-2.86l0.34,-0.59l1.51,-1.03l0.97,-2.6l0.45,-0.27l2.77,-0.1l1.73,-1.78l1.25,-0.81l4.97,1.15l1.64,-1.71l0.01,-3.24l1.33,-0.34l0.57,-1.09l-1.23,-5.68l2.64,-4.77l-1.01,-4.44l-0.63,-0.64l-0.55,0.02l-0.71,0.73l-0.55,-0.33l0.13,-0.69l-0.92,-1.66Z",name:"Ille-et-Vilaine"},"FR-34":{path:"M472.95,595.08l2.8,-1.36l1.66,-1.38l0.42,-0.75l-0.67,-1.83l0.6,-2.13l-0.19,-0.87l-1.8,-1.81l-0.4,-0.78l0.06,-2.31l1.08,-2.4l2.53,-0.35l4.36,1.68l1.08,-0.09l6.9,-2.67l1.13,-0.84l0.89,-1.44l0.94,-0.73l2.76,-0.52l2.05,0.72l1.31,-0.01l1.13,-0.87l0.42,-1.21l-0.12,-1.91l0.44,-1.97l-0.73,-1.88l0.22,-1.3l0.63,-0.54l1.14,-0.13l5.68,0.72l1.26,-0.14l1.39,-0.84l0.82,-1.13l0.22,-1.48l0.5,-0.93l1.64,-1.06l2.89,-0.27l1.28,-0.95l2.91,-0.05l0.8,0.42l1.07,2.27l1.44,1.2l1.25,-0.29l0.99,-2.42l0.74,-0.23l0.99,0.34l1.86,1.49l1.5,0.12l1.36,-1.05l1.56,-2.39l3.67,-0.32l0.92,-2.34l2.17,-1.72l3.48,0.38l2.17,1.9l-1.36,3.12l0.13,0.48l1.96,1.44l4.72,-0.6l2.04,0.12l0.73,0.44l0.75,1.51l-0.04,2.62l0.4,1.15l3.35,0.52l3.47,2.44l2.8,1.24l0.71,0.51l2.04,3.41l0.25,3.51l-1.45,2.7l-3.23,1.15l-0.27,0.38l0.03,2.02l-2.89,-0.25l-3.46,0.39l-2.5,0.88l-13.02,9.46l-7.26,2.86l-2.05,1.55l-4.61,5.42l-1.04,0.41l-2.52,-1.04l-4.18,0.38l-4.24,1.6l-4.26,3.08l-3.27,-1.88l-2.29,-0.5l-2.5,-0.06l-3.01,-1.69l-2.94,-0.4l-0.36,-0.71l0.07,-1.71l-0.55,-0.39l-3.21,0.47l-0.86,-0.2l-0.54,-0.39l-2.44,-4.28l-1.1,-0.6l-1.16,0.45l-0.31,0.94l0.04,2.06l-0.7,1.96l-4.87,4.11l-2.35,-1.1l-1.39,-3.47l-0.66,-0.06l-1.39,1.71l-1.27,0.17l-3.16,-2.04l-1.4,-1.56l-0.17,-1.38l0.72,-1.43l1.48,-1.55l-0.1,-0.63l-0.49,-0.26Z",name:"H\xe9rault"},"FR-37":{path:"M352.22,269.97l1.75,-1.0l3.68,1.68l0.83,-0.03l1.3,-0.71l5.87,1.39l1.05,0.87l0.18,0.97l-0.4,2.78l0.41,0.75l0.8,0.52l0.91,0.07l0.85,-0.34l1.29,-1.38l0.8,-0.37l1.8,-0.2l1.2,0.39l0.34,1.65l0.49,0.6l0.66,0.12l1.09,-0.66l0.59,-0.01l1.67,2.46l-0.09,0.96l-0.83,1.38l0.08,1.15l1.3,1.12l1.88,2.86l0.85,2.17l0.27,2.64l-0.31,2.69l-1.21,3.49l0.39,1.26l3.11,2.54l0.91,0.24l1.99,-0.29l2.4,0.46l1.91,1.54l5.1,8.02l0.3,1.55l-0.35,1.42l-2.1,0.31l-0.75,2.28l-0.93,0.25l-1.44,2.34l-1.86,1.74l-3.39,-1.22l-1.61,-0.11l-3.27,0.8l-1.71,0.81l-1.23,1.46l-0.2,1.11l0.21,2.5l-1.27,0.79l-0.13,2.05l-1.79,8.58l-1.51,3.53l-1.97,0.76l-1.3,-1.56l-0.5,-0.09l-1.92,1.07l-2.81,-2.03l-7.16,-9.22l-1.26,-3.31l-1.44,-1.93l-6.17,-2.97l-0.71,0.68l0.16,1.39l0.73,1.37l-0.4,0.35l-5.41,0.31l-1.21,0.29l-1.78,1.09l-2.67,-0.46l-2.71,0.24l-1.01,-0.19l-0.92,-0.81l-0.25,-0.98l0.04,-2.48l0.47,-2.57l-0.35,-1.03l-2.01,-0.4l-0.72,-1.12l-0.61,-0.29l-3.43,0.61l-0.29,-0.38l0.35,-1.68l-0.32,-1.32l-0.99,-0.39l-1.98,0.41l-0.5,-1.99l-0.74,-0.2l-1.7,0.66l-1.69,-2.39l0.88,-5.76l1.43,-5.26l4.43,-6.2l-0.2,-2.84l0.98,-2.98l1.96,-3.88l-0.45,-3.6l1.51,-3.81l7.61,1.68l0.98,-0.08l0.62,-0.83l-0.48,-2.31l0.7,-0.71l2.9,0.89l2.04,-1.63l2.39,-0.48l3.32,-1.45l2.28,-0.47l0.53,-0.73l-0.11,-1.0Z",name:"Indre-et-Loire"},"FR-36":{path:"M393.95,318.07l0.9,-0.09l0.61,-2.25l1.58,-0.11l0.8,-0.54l0.42,-1.84l-0.33,-1.69l-1.6,-2.47l5.44,-2.85l2.8,-0.69l3.15,0.76l0.48,-0.3l0.36,-1.49l0.86,-0.71l1.2,-0.21l1.29,0.24l0.46,-0.3l0.59,-1.74l3.84,0.88l3.17,-1.22l6.69,5.17l0.04,1.92l-0.81,1.69l-3.06,2.75l0.08,0.65l1.25,0.67l5.66,1.45l5.07,-1.54l3.01,0.3l1.15,0.49l0.43,0.43l0.26,1.29l-0.65,2.27l0.08,0.95l2.03,1.92l1.02,1.64l0.02,1.03l-0.75,2.0l-0.09,1.49l0.73,1.27l2.01,1.1l0.45,0.6l-0.11,0.46l-1.99,1.83l-1.21,2.47l-0.26,1.4l0.24,1.28l2.04,1.59l0.18,0.69l-0.21,0.55l-2.03,1.48l-0.56,0.91l-0.03,0.97l0.45,0.84l0.67,0.46l3.34,0.78l0.4,0.52l-0.05,2.41l0.47,0.67l1.3,0.58l0.57,0.68l0.21,0.95l-0.34,2.17l-1.41,2.37l-0.02,1.11l1.58,1.86l0.63,2.64l-0.65,1.45l-2.3,2.34l-0.36,1.17l-1.91,0.36l-2.11,-0.72l-3.44,0.0l-2.44,-0.84l-5.56,-0.15l-1.36,0.29l-1.79,1.06l-1.02,-0.37l-1.84,-1.89l-0.73,-0.15l-0.91,0.28l-0.52,0.62l-0.16,2.28l-0.72,0.98l-3.85,-0.24l-2.6,1.5l-1.18,-0.45l-0.12,-1.0l-0.46,-0.52l-0.8,-0.24l-1.55,0.21l-2.31,-0.53l-1.04,0.29l-3.98,3.58l-1.69,0.94l-2.46,-1.47l-0.93,-1.4l-0.84,-0.54l-0.84,-0.04l-0.83,0.37l-1.03,1.35l-3.36,0.5l-1.43,-0.08l-2.37,-1.16l0.93,-3.22l-0.72,-1.01l-1.32,-0.68l-1.11,-1.06l0.45,-2.58l-0.89,-1.68l-1.75,-1.2l-5.0,-0.37l-0.32,-1.41l-0.46,-0.57l-3.41,-1.35l-2.52,-2.46l-0.51,-2.09l-0.01,-1.46l0.61,-2.86l-0.92,-2.42l-1.03,-1.33l1.45,-0.81l1.27,1.52l0.45,0.12l2.62,-1.14l1.61,-3.8l1.81,-8.66l0.09,-1.84l1.3,-0.85l-0.12,-3.47l0.97,-1.2l1.52,-0.73l3.17,-0.77l1.22,0.08l2.76,1.19l1.01,0.08l2.31,-2.0l1.48,-2.38Z",name:"Indre"}},height:749.2159980728637,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","fr_regions_mill",{insets:[{width:100,top:600,height:122.71220181016422,bbox:[{y:-640515.9263248637,x:-6082830.163693012},{y:-235112.28629661424,x:-5752460.702426716}],left:0},{width:50,top:440,height:42.928059423707,bbox:[{y:-1855676.1027106678,x:-6882793.3793751765},{y:-1778355.8860469644,x:-6792735.480530344}],left:0},{width:50,top:510,height:57.21127928831266,bbox:[{y:-1668974.3969949444,x:-6819419.302373176},{y:-1615651.747314515,x:-6772817.783980524}],left:0},{width:50,top:700,height:42.31095479952366,bbox:[{y:2357030.8412201093,x:6150785.273719754},{y:2416319.6251247157,x:6220848.433704593}],left:740},{width:40,top:690,height:55.96611426730096,bbox:[{y:1415975.8044653006,x:5016650.333473452},{y:1454680.1669724442,x:5044313.045465417}],left:640},{width:900,top:0,height:749.2159980728637,bbox:[{y:-6244653.662562441,x:-571670.6975907331},{y:-4882430.695155527,x:1064707.428102987}],left:0}],paths:{"FR-C":{path:"M458.84,445.76l1.95,-0.35l3.03,1.58l1.95,0.27l1.37,-0.72l0.73,-1.76l1.22,-4.68l-1.19,-1.15l-0.26,-4.14l-1.44,-1.87l-0.36,-0.94l0.86,-2.7l1.65,-0.68l0.84,-1.03l0.29,-4.28l-0.66,-1.43l-1.92,-2.11l-0.96,-0.86l-1.78,-0.64l-0.67,-1.98l-1.72,-2.4l0.64,-0.91l3.14,-2.29l2.41,-0.16l2.48,-2.58l1.63,-3.33l1.7,-1.93l0.19,-3.74l-0.21,-0.9l-1.86,-3.26l-0.2,-1.44l0.37,-3.62l-2.17,-3.8l-1.06,-3.16l-3.18,-4.2l-1.27,-0.36l-1.13,0.66l-0.76,-1.76l-0.96,-0.91l-3.48,-0.95l-0.4,-0.39l-0.94,-2.84l-1.76,-1.56l-1.91,-2.38l2.1,-3.42l1.46,-0.64l1.48,-1.8l3.52,-1.57l7.94,-0.8l5.29,-1.4l0.38,-0.42l0.01,-1.21l-1.98,-2.84l-0.03,-0.72l0.53,-1.33l-0.89,-1.33l-0.03,-0.59l2.46,-0.23l0.41,-0.79l-0.21,-1.13l1.75,-0.2l4.07,-3.3l0.82,0.8l2.07,0.75l0.92,-0.2l1.28,-1.11l1.91,0.36l0.95,-0.67l1.12,-1.59l3.83,-2.18l2.59,-0.73l2.86,0.18l0.27,1.52l1.25,1.52l3.22,1.84l2.72,0.19l2.74,2.56l0.75,0.33l1.03,0.0l2.4,-1.05l1.66,-0.1l1.61,0.25l2.97,1.11l1.41,-0.68l1.06,-1.27l1.82,0.28l1.29,2.19l0.04,1.49l0.5,0.54l0.6,0.12l1.71,-0.33l4.06,-2.15l0.58,-1.97l1.34,-0.87l0.39,-1.8l1.21,0.2l1.4,2.25l0.6,1.79l2.46,2.19l1.56,2.63l0.94,0.54l0.28,1.5l-0.41,3.04l0.32,0.67l4.03,2.05l1.74,0.08l2.67,2.22l3.67,0.71l2.06,1.0l0.85,2.72l-0.63,3.32l0.52,1.3l-0.02,1.46l0.82,1.68l-1.19,1.0l-5.54,2.72l-4.06,1.13l-3.09,2.23l-0.46,0.67l0.1,0.81l1.06,1.16l0.45,3.18l-0.15,4.03l0.68,2.18l0.93,5.93l-0.99,0.98l-4.7,1.0l-2.48,1.16l-0.52,1.08l0.55,1.39l2.04,1.49l0.81,1.4l-1.18,2.85l-0.09,2.56l-0.9,1.89l0.2,0.76l1.8,2.84l1.04,0.63l0.51,0.79l3.2,6.42l7.55,6.03l2.43,5.41l0.06,0.97l-0.87,2.1l-2.77,2.89l-0.81,1.47l-0.62,3.19l0.73,0.99l0.84,0.2l1.6,-1.2l1.9,-0.6l2.13,1.82l2.81,-0.06l5.93,-1.02l0.73,-0.54l0.63,-1.51l2.08,-0.01l4.17,1.12l0.77,-0.18l1.64,-1.34l1.05,0.73l1.46,2.67l-0.74,2.73l1.01,2.4l0.55,0.5l2.83,0.32l1.35,0.69l2.79,2.4l0.01,0.38l-0.57,2.1l-1.56,2.88l-0.39,2.24l-0.49,0.1l-1.12,-1.01l-1.15,-0.45l-0.79,0.06l-0.57,0.5l-0.04,0.8l0.87,1.5l-1.86,1.79l-0.32,0.95l1.23,1.99l-1.15,0.49l-2.02,0.27l-0.8,0.49l-0.88,1.68l0.6,1.25l-0.04,0.58l-2.45,0.94l-1.75,-0.24l-0.7,0.42l-1.47,3.48l-2.26,2.8l-5.01,0.84l-2.52,-0.04l-0.63,0.49l-0.58,1.76l-3.92,1.29l-3.33,4.57l-1.1,0.45l-1.34,-0.28l-3.14,-1.55l-4.13,-3.41l-4.32,-0.85l0.51,-1.34l-0.08,-0.66l-1.42,-1.21l-2.79,0.02l-0.88,0.82l-0.22,1.67l-0.41,0.69l-3.66,0.55l-1.34,0.6l-1.68,-1.35l-3.45,-5.83l-1.02,-2.98l-0.61,-0.39l-1.62,0.07l-1.27,0.4l-3.17,1.81l-1.69,-0.0l-0.85,0.32l-4.65,3.8l-0.58,0.1l-1.2,-1.57l-0.6,-0.32l-0.8,0.12l-0.74,0.54l-0.49,0.73l-0.62,3.19l-1.64,1.03l-0.58,0.99l-1.42,4.71l-0.35,2.6l-1.83,2.78l-0.72,2.01l-1.6,-1.21l-1.15,-1.79l-0.53,-3.47l-0.56,-1.36l1.14,-0.77l-0.12,-1.16l-2.88,-1.38l-0.69,-1.95l-2.44,-3.26l-0.78,-0.22l-2.44,0.35l0.05,-1.49l-0.34,-1.19l-1.91,-2.42l-1.03,-0.42l-8.44,7.7l-0.74,2.6l-2.44,3.55l-0.58,2.41l-3.68,3.99l-0.93,0.45l-1.89,0.2l-3.45,-0.1l-1.45,0.62l-1.19,-1.14l-1.48,-0.11l-5.33,1.64l-0.67,1.8l-0.21,-0.03l-0.95,-1.01l-0.89,-3.39l-1.7,-1.05l1.55,-5.49l-0.1,-0.85l-1.32,-2.73l-3.07,-4.61l-0.85,-5.71l-0.6,-1.16l0.94,-0.4l2.23,-0.24l1.11,-0.74l0.08,-1.24l-1.43,-2.43l-0.11,-0.76l3.2,-2.58l2.85,-5.59l0.22,-1.14l-1.07,-2.31l0.11,-1.37l2.59,-1.98l0.51,-1.87l3.08,-1.33l2.04,-2.9l1.09,-0.69l1.42,-3.08l-0.14,-1.07l-0.95,-0.99Z",name:"Auvergne"},"FR-B":{path:"M204.81,598.27l0.63,0.4l0.52,-0.08l1.38,-0.84l5.64,-0.92l1.36,-1.72l2.57,-1.46l2.17,-3.85l5.18,-6.42l0.5,-2.5l1.48,-4.27l2.51,-12.23l1.46,-4.3l2.15,-9.72l3.95,-21.25l1.68,-10.56l0.42,-4.7l-0.62,-3.76l1.59,-2.05l1.5,-4.83l1.04,-1.14l1.32,-0.04l3.84,0.81l2.32,-0.34l1.43,-1.11l0.02,-1.15l-1.01,-1.12l0.28,-0.48l-0.7,-1.19l-4.63,-3.83l-1.79,-0.89l-0.92,0.36l-3.56,5.22l-0.53,2.34l3.34,-33.36l2.55,-12.04l1.09,-15.98l3.2,-5.75l1.08,-0.08l-0.29,2.7l1.44,2.01l4.22,2.89l3.51,1.53l7.32,7.13l1.65,2.15l1.65,6.53l1.42,7.99l2.13,4.49l2.13,2.43l2.35,2.0l2.44,1.49l0.52,1.41l-0.17,1.23l0.35,3.2l0.54,1.31l0.97,0.73l0.45,-0.0l0.16,-0.42l-0.81,-4.06l0.53,-2.18l-0.8,-1.78l-1.38,-1.23l1.66,0.3l2.68,1.57l0.51,-0.03l0.06,-0.51l-1.72,-2.53l-5.08,-1.82l-2.05,-1.4l-1.05,-1.86l-0.76,-2.33l-2.25,-14.04l4.57,0.18l1.0,-0.64l0.76,-1.27l0.56,-0.11l0.65,0.81l0.37,1.95l0.61,0.79l2.13,0.71l2.33,0.11l3.23,2.19l0.41,0.91l0.02,3.27l1.85,2.9l1.13,0.33l2.3,-0.3l1.87,1.12l1.79,0.6l2.4,1.97l4.08,1.26l1.94,-0.24l3.34,-1.09l1.9,0.53l1.84,-0.78l1.74,-1.98l0.4,-1.04l-0.7,-1.52l0.58,-0.84l4.85,-2.23l2.42,0.63l1.33,-0.31l1.22,-1.11l0.8,-1.83l2.77,-1.19l1.9,-1.66l0.55,-1.77l-0.03,-3.99l0.77,-2.85l0.66,-1.26l6.52,-4.29l1.11,-0.35l0.88,0.11l0.87,-0.54l4.41,-6.14l0.49,-1.81l0.23,-3.15l0.79,-0.39l1.26,-0.03l0.77,-0.51l2.26,-3.05l1.88,-1.54l1.09,0.73l4.71,0.47l2.19,2.61l-0.7,2.48l0.06,0.82l1.7,1.06l2.04,0.48l1.19,-0.1l0.81,-0.34l1.25,-1.36l1.25,0.8l3.25,-0.49l4.3,0.25l3.95,4.87l1.43,0.54l2.5,0.33l0.6,0.42l-0.17,0.68l-1.67,1.44l-0.1,0.87l0.38,0.6l4.23,2.02l1.93,-0.26l1.79,1.23l1.56,0.22l-0.04,0.74l-1.01,1.7l0.11,1.19l0.83,0.73l2.19,-0.19l0.25,0.38l-0.48,0.88l-1.53,0.87l-2.43,2.37l-0.63,3.22l0.4,0.65l1.93,1.39l-0.41,0.68l-1.65,1.24l-0.56,1.57l0.46,0.73l2.59,0.41l0.07,0.86l-0.73,1.62l0.87,1.3l2.81,1.17l3.51,-0.14l0.38,0.23l-0.49,2.38l0.26,0.87l1.61,2.88l1.96,2.11l-1.43,0.93l-0.47,1.47l1.31,4.0l-0.03,0.72l-0.72,1.24l0.17,1.64l-2.71,2.63l-1.66,2.62l-2.23,0.65l-0.87,1.1l-0.29,0.94l0.72,1.44l-0.03,0.57l-1.25,1.78l-4.31,2.66l-2.39,0.56l-0.98,0.82l-3.33,5.17l-3.48,2.85l-2.93,1.29l-0.86,0.82l-0.26,0.78l1.31,2.09l0.06,1.85l0.83,2.15l2.02,2.25l-0.18,3.0l-0.59,0.58l-4.81,0.36l-1.13,-0.2l-1.77,-0.98l-0.77,0.08l-0.72,0.57l-0.27,2.47l-0.74,1.55l-0.06,0.88l0.85,1.37l2.45,0.96l0.36,0.51l-2.45,5.11l-2.16,1.72l0.1,0.72l1.14,0.8l-0.03,0.97l-1.25,0.21l-2.22,-0.7l-1.4,0.32l-0.49,0.48l-0.46,1.35l-2.26,1.33l-1.04,2.84l-3.57,1.87l-1.05,0.18l-2.71,-2.15l-1.51,-0.47l-5.15,1.53l-2.7,-0.26l-1.21,0.8l-4.35,1.91l-1.3,0.2l-3.0,1.53l-4.83,-1.62l-0.8,0.09l-1.07,0.84l-1.29,1.99l-1.07,0.78l-0.59,0.02l-0.58,-0.74l-0.76,-0.21l-2.4,0.81l-0.9,1.56l0.26,2.33l-0.72,0.77l-2.48,-0.06l-1.1,-0.37l-0.37,-0.73l0.78,-1.23l-0.06,-1.08l-0.91,-0.88l-1.22,-0.35l-1.33,0.44l-1.59,1.05l-1.8,1.72l-1.77,0.13l-2.38,-0.3l-2.89,1.82l-0.59,0.71l-0.12,1.04l1.31,1.37l1.05,2.2l-1.49,3.87l-0.05,2.41l0.82,1.36l-1.48,3.09l-1.21,0.16l-0.79,0.5l-0.11,0.65l0.54,1.41l-1.07,1.59l-0.25,1.25l0.98,0.76l0.47,1.52l0.52,0.63l2.33,-0.0l5.59,1.04l1.06,0.66l0.67,1.47l1.56,1.16l2.16,4.89l-0.31,0.26l-1.15,-0.07l-0.56,0.49l0.03,2.28l0.52,0.69l0.76,0.17l1.43,-1.29l0.75,0.02l-0.11,3.16l1.06,3.23l-0.48,0.48l-1.62,0.52l-0.96,1.06l-0.61,2.64l0.6,2.08l-0.4,0.75l-1.97,1.89l-1.1,3.23l-1.55,0.13l-1.74,2.98l-2.28,1.29l-0.98,1.23l0.15,3.83l-0.4,0.28l-2.98,0.33l-2.69,2.77l-0.17,0.81l0.39,1.61l-0.03,1.69l-1.67,2.29l-0.35,1.23l0.55,3.77l-0.88,-0.07l-0.78,1.18l-0.86,-0.35l-4.31,2.79l-1.69,0.12l-3.22,-1.34l-1.7,-0.07l-0.41,0.38l-0.09,1.49l-1.58,0.74l-0.62,-1.55l-1.55,-0.25l-0.08,-0.92l-2.44,-2.91l-3.24,-2.0l-1.85,-0.11l-0.47,-0.41l-0.25,-0.49l0.25,-1.36l-1.4,-2.86l-1.82,-0.51l-4.68,0.75l-4.79,-0.35l-2.24,-0.65l-2.95,-2.22l-3.08,-0.49l-2.02,-1.09l-2.32,0.15l-4.04,-2.44l-3.6,-0.59l-1.04,-0.56l-0.92,-0.94l-0.21,-0.75l0.38,-0.75l1.21,-0.93l-0.15,-0.71l-1.6,-0.32l-1.53,0.56l-1.05,1.06l-0.53,1.66l-0.16,1.94l-0.41,0.78l-0.81,0.24l-3.0,-0.46l-1.26,-0.64l-1.02,-1.03l-0.63,-1.32l3.7,-3.88l0.95,-2.41l0.66,-2.96l-0.35,-3.1l-2.03,-1.72l-2.04,0.3l-2.51,-1.16l-3.21,-0.56l-1.3,0.75l-0.75,1.77l-1.7,0.25l-0.8,-0.46l-0.49,-1.68l0.17,-0.84l-0.85,-0.76l-1.84,-0.58l-3.76,1.0l-0.43,-1.87l-0.91,-1.03l-1.52,-0.66l0.07,-2.41ZM309.11,602.32l1.15,-0.9l0.67,-2.47l-0.61,-1.33l-1.64,-0.44l-1.19,0.8l-0.49,2.49l0.63,1.45l1.49,0.4ZM307.84,608.3l0.94,-0.4l1.08,-1.94l-0.6,-1.74l-1.63,-0.95l-0.46,0.07l-1.45,1.45l-0.2,1.38l0.25,1.08l0.52,0.68l1.55,0.37Z",name:"Aquitaine"},"FR-A":{path:"M749.43,204.53l5.77,-0.36l0.71,-0.43l0.65,-1.16l2.35,-1.16l0.73,-0.71l0.93,-1.77l1.44,-4.66l-0.53,-0.88l-1.5,-0.78l-0.14,-0.62l2.91,-4.3l0.33,-1.37l-0.57,-1.43l-3.83,-3.82l-1.83,-0.81l-0.15,-1.32l-0.77,-0.76l-0.74,0.09l-0.54,0.56l-0.45,1.75l-2.17,0.87l-1.14,1.58l-1.05,0.07l-0.85,-1.8l-0.77,-0.61l0.26,-0.79l0.96,-0.95l-0.06,-1.04l-5.03,-1.96l-1.91,-1.6l-0.2,-0.81l0.44,-1.33l0.89,-1.07l2.61,-2.08l0.31,-1.9l2.13,-2.7l-0.21,-1.76l0.28,-0.4l1.23,0.18l0.29,0.32l0.81,2.78l0.94,1.02l8.51,2.56l1.02,1.76l1.21,0.68l1.4,0.29l2.12,-0.08l7.03,-1.14l3.26,1.63l1.38,-0.12l0.76,-0.45l1.05,-1.41l1.35,-2.8l1.9,-2.92l2.27,-0.55l2.64,0.55l2.77,-0.96l5.0,1.23l4.59,-0.2l9.65,4.37l6.29,1.29l-1.02,1.01l-1.91,3.08l-2.79,6.52l-0.7,1.0l-3.2,1.38l-0.7,0.85l-0.46,1.3l-2.12,0.14l-0.95,0.41l-0.65,2.78l-3.8,3.45l-2.72,1.47l-2.66,3.6l-0.53,2.65l-0.01,2.74l0.72,2.0l-2.23,1.72l-0.47,2.28l-1.12,1.98l-0.77,3.01l-0.07,1.2l0.89,2.96l-0.06,0.91l-0.71,0.98l-2.24,1.43l-0.92,4.51l-4.52,5.78l-0.55,2.13l-1.16,1.77l-0.81,2.75l0.18,3.35l2.65,4.1l0.12,2.21l-2.19,2.41l-0.36,2.63l-1.24,1.91l0.21,3.21l-1.19,0.9l-1.06,3.68l0.75,2.84l-0.03,1.09l-1.25,1.28l-0.34,0.8l0.43,2.7l1.98,1.77l2.51,3.91l-0.3,0.82l-3.51,1.37l-2.73,1.91l0.1,0.7l1.12,0.69l0.01,0.32l-1.72,0.61l-0.07,0.53l0.6,1.0l-0.84,0.74l-2.31,-0.79l-0.93,0.18l-0.3,0.87l0.84,1.21l-0.09,0.79l-1.08,1.21l-1.53,0.53l-4.27,-0.15l-4.24,1.21l-0.96,-0.82l-3.02,-1.12l-0.26,-0.95l1.04,-2.07l-0.39,-0.58l-1.82,0.11l0.46,-2.1l-0.6,-1.89l-3.92,-4.0l-0.97,-0.45l-1.8,-0.05l-0.57,-0.53l0.01,-0.77l1.5,-2.01l0.6,-1.7l-0.15,-2.99l-0.41,-1.19l-1.75,-1.66l-8.58,-4.29l-0.62,-0.69l-0.05,-0.84l2.13,-0.87l1.13,-1.09l0.16,-1.12l-0.61,-1.66l1.6,-3.12l0.61,-3.06l3.45,-4.12l3.12,-5.81l1.69,-2.31l0.05,-1.09l-0.74,-2.01l8.2,-11.93l-0.06,-1.17l-1.33,-1.31l-1.05,-0.28l-2.4,0.03l-1.4,-0.76l-0.14,-0.39l0.82,-2.61l0.59,-7.58l1.09,-1.01l0.02,-0.68l-3.11,-1.58Z",name:"Alsace"},"FR-G":{path:"M522.82,186.37l0.16,-1.02l1.68,-1.84l-0.22,-0.68l-0.89,-0.72l3.35,-0.37l0.76,-1.01l0.2,-1.75l1.48,-2.59l4.29,-3.81l1.07,-2.07l1.68,-1.1l0.81,-1.18l2.06,-1.61l0.39,-0.63l-0.02,-1.16l-0.99,-0.78l-3.39,0.04l-0.83,-0.47l0.06,-1.11l1.31,-0.86l1.17,-1.67l0.21,-0.79l-0.25,-2.97l1.17,-0.73l3.12,0.34l1.45,-0.25l1.33,-1.0l0.36,-0.86l-0.5,-1.26l-1.41,-0.81l-0.87,-0.98l-1.6,-0.47l-0.56,-4.86l-0.91,-2.12l2.95,-1.52l5.1,-1.23l4.31,-0.57l0.52,-0.78l-0.12,-1.35l0.85,-0.54l2.04,0.1l3.04,1.4l2.06,-0.68l2.32,0.84l1.14,-0.78l0.49,-1.35l0.08,-2.0l-0.52,-1.32l-0.68,-0.44l0.36,-0.58l1.56,-0.48l0.31,-0.52l-1.82,-3.65l1.76,-1.97l-0.32,-2.31l0.46,-1.54l-1.6,-4.48l0.75,-0.67l1.86,-0.09l1.55,-0.83l1.47,-2.03l1.72,-1.03l3.2,-2.67l0.94,-1.48l0.01,-1.35l-1.51,-2.11l0.44,-2.67l1.83,-3.2l0.19,-1.43l-0.27,-1.06l-1.76,-2.77l-0.03,-2.56l3.32,-0.4l9.73,2.22l1.91,-0.29l8.49,-3.54l2.64,-0.38l0.81,-0.51l1.03,-2.26l0.49,-2.73l-0.42,-1.4l0.42,-1.14l6.43,-5.47l1.16,-0.45l0.17,0.74l0.95,0.53l1.9,-0.28l0.3,0.34l-0.46,3.48l-0.42,-0.16l-0.65,0.28l-1.15,2.13l-0.07,2.33l-2.32,4.87l-0.3,1.37l0.89,1.44l2.96,1.1l0.83,1.27l-0.04,1.46l-1.51,3.13l0.87,1.86l0.09,3.19l0.8,0.73l1.7,0.19l5.18,-1.02l3.3,2.38l3.4,1.12l3.27,3.72l2.07,1.47l1.72,0.4l3.86,-0.67l2.26,2.11l0.31,0.88l-0.71,0.59l-0.19,1.13l0.55,1.39l1.85,0.16l0.84,-1.02l2.9,1.12l-0.05,0.81l-6.21,3.82l-0.34,-0.04l-0.49,-0.99l-0.68,-0.39l-3.82,0.0l-2.25,-1.55l-1.05,-0.35l-1.0,0.14l-0.96,0.6l-0.88,1.16l-0.41,3.41l-1.46,1.89l0.74,2.38l1.02,0.78l0.75,2.44l-0.1,1.25l-1.08,2.51l-3.38,4.46l0.01,1.28l0.73,2.15l-4.2,3.37l-0.07,2.26l-1.5,3.0l0.03,0.77l1.78,4.87l0.13,4.29l0.32,0.97l0.62,0.73l1.6,0.68l0.35,0.84l-0.84,1.15l-0.07,2.87l-0.56,1.42l-1.01,0.68l-2.7,0.71l-1.22,1.6l-0.51,2.57l0.64,2.23l-1.48,2.56l0.09,0.99l0.65,0.83l3.96,2.92l0.58,1.99l-0.09,2.24l0.5,0.68l0.29,2.44l0.67,1.52l1.33,1.57l2.25,1.66l2.79,1.3l4.32,3.1l5.08,2.47l3.16,0.28l1.23,0.4l0.83,1.56l5.79,4.67l-1.67,2.08l-0.22,0.82l0.6,3.51l0.45,0.64l0.99,0.2l1.86,-1.66l1.62,0.08l1.4,1.19l3.12,3.97l0.92,0.25l1.78,-0.17l1.23,0.72l0.4,2.4l3.51,2.44l0.33,0.77l-1.35,1.24l-0.55,2.56l-1.17,1.96l-0.63,2.55l4.62,3.89l3.34,1.83l0.57,1.4l-0.05,2.95l0.46,0.64l1.01,0.19l0.95,-0.67l0.94,-0.09l2.41,2.53l0.26,1.05l-2.1,0.92l-2.38,2.89l-6.41,3.93l-0.82,1.02l-0.32,1.1l0.57,2.0l-0.54,2.43l0.2,2.14l-0.58,1.27l-6.85,2.14l-1.15,-0.23l-3.43,-1.72l-4.29,0.62l-1.46,0.81l-2.83,5.28l-0.39,0.11l-0.67,-0.88l-0.77,-0.22l-2.89,1.56l-0.53,-0.69l-0.42,-1.51l-3.74,-2.21l-0.5,-0.48l-0.45,-1.41l-0.55,-0.47l-1.19,0.09l-1.76,1.89l-1.49,0.14l-2.23,-1.34l-2.42,-2.98l-1.06,-0.04l-1.62,1.4l-0.89,-0.42l-0.59,-1.48l-0.36,-2.77l-1.38,-1.79l0.33,-0.6l2.33,-0.37l0.83,-0.93l-0.18,-1.31l-1.18,-2.31l-4.52,-5.41l-1.18,-0.18l-1.09,1.24l-0.51,-0.21l-0.23,-0.95l0.85,-1.35l0.11,-1.07l-1.02,-0.91l-2.65,-0.91l0.44,-1.3l-0.31,-0.7l-0.84,-0.49l-3.68,-0.69l-1.99,-1.23l-2.67,0.98l-2.98,-0.51l-1.76,0.38l-1.47,1.25l-0.22,1.84l-0.81,0.45l-13.17,1.5l-2.39,1.7l-0.5,0.01l-1.12,-0.71l-1.95,-2.64l-0.78,-0.38l-0.55,0.41l-0.26,2.11l-1.42,-0.99l-1.02,-0.13l-0.91,0.39l-1.31,1.25l-1.75,0.05l-1.93,-0.43l-1.85,1.2l-2.25,-0.63l-2.87,0.17l-1.97,-0.36l-0.57,-0.86l0.08,-2.22l-0.52,-0.94l-0.98,-0.2l-1.67,0.35l-1.41,-0.73l1.56,-0.67l0.12,-0.94l-4.65,-7.0l-1.91,-1.9l-0.72,-1.79l-0.62,-0.61l-1.22,-0.42l-0.78,0.28l-0.57,1.04l-1.58,0.12l-2.82,-1.93l-2.05,-0.84l1.35,-1.41l0.55,-1.05l-0.39,-3.31l-0.49,-0.96l-5.62,-6.39l-3.0,-1.66l-2.3,-0.01l-0.47,-2.37l-1.12,-0.92l-0.15,-0.51l0.56,-2.27l-0.63,-1.75l1.81,-1.89l-0.93,-1.96l2.55,-0.54l0.75,-0.59l1.02,-2.47l0.98,-1.32l2.66,-1.99l0.06,-0.58l-1.98,-2.34l-2.8,0.05l-0.2,-1.26l0.51,-1.93l-0.76,-3.12l-2.03,-2.25l-1.36,-0.04Z",name:"Champagne-Ardenne"},"FR-F":{path:"M352.12,269.71l-0.39,-0.79l0.59,-1.42l1.29,-1.16l5.17,-2.45l1.63,-1.53l1.57,-4.34l0.07,-3.55l0.45,-1.34l2.91,-2.22l0.88,-1.62l-0.43,-1.98l0.6,-3.59l-0.6,-0.63l-1.31,-0.12l-0.88,-2.08l2.47,-0.44l0.71,-0.46l0.07,-1.0l-1.12,-0.94l0.07,-0.52l3.99,-2.03l0.86,-0.92l-0.08,-0.73l-0.51,-0.52l-3.66,-0.66l-2.36,-1.54l1.12,-0.96l0.25,-1.0l-1.86,-3.44l0.07,-2.76l-0.31,-0.7l-0.92,-0.77l0.03,-1.1l0.42,-0.63l2.29,-0.4l5.6,-2.3l2.13,-1.95l0.67,-1.64l1.22,-1.8l-0.16,-0.83l-1.74,-2.11l0.08,-3.7l-3.65,-3.73l-2.55,-1.62l-1.61,-2.81l-0.36,-3.23l1.82,-1.67l1.34,-0.77l5.76,-1.41l2.04,-0.07l0.74,-0.36l1.7,-2.02l3.48,-0.35l0.63,-0.53l0.22,-1.53l3.0,1.67l3.49,-0.02l1.93,0.63l4.71,-2.07l1.42,-1.16l0.69,-1.87l0.95,-1.4l1.34,-1.03l2.49,-1.16l1.05,-1.01l0.26,-1.64l-0.52,-1.68l0.12,-0.44l2.22,-1.39l3.12,5.29l1.41,1.78l0.26,1.59l-0.56,2.83l0.31,1.68l0.56,0.67l1.6,0.81l-0.36,1.11l-1.35,1.63l-0.2,0.71l0.26,0.98l1.48,0.99l0.55,1.38l1.5,1.71l3.83,2.4l0.73,2.38l2.38,1.58l0.52,0.67l0.38,1.69l-0.03,2.29l1.38,2.04l1.1,0.79l4.59,1.88l2.43,-0.21l0.24,2.38l2.15,2.42l0.66,2.91l0.56,0.84l1.26,0.74l-1.59,2.0l-0.13,0.8l0.28,0.63l1.27,0.64l8.96,-1.77l2.18,-0.89l1.74,-2.19l1.08,0.42l1.34,1.84l0.89,0.32l1.9,-0.44l1.41,-1.25l0.41,-0.04l2.61,1.32l2.42,-0.25l1.05,1.47l1.06,3.38l3.56,2.09l1.09,1.21l-0.82,1.86l0.48,1.68l-2.36,-0.11l-1.14,1.09l0.09,1.33l1.07,0.83l2.02,0.26l3.17,-0.65l8.35,0.59l2.29,-0.94l1.66,-1.6l0.83,-0.26l2.03,0.05l-0.41,1.53l0.32,0.38l1.06,0.2l7.05,-1.97l1.76,0.12l2.27,0.58l1.52,1.02l1.38,4.33l1.05,1.28l2.81,2.18l0.52,2.18l-1.42,3.21l-0.46,0.6l-2.42,1.45l-1.42,1.43l-1.36,0.14l-0.46,0.42l0.1,2.67l0.95,2.06l-0.78,1.4l0.13,1.67l-0.42,0.96l-4.41,2.06l-4.17,0.46l-1.07,0.84l-0.36,1.76l0.56,1.49l2.33,0.9l2.32,2.0l1.13,2.08l-0.6,1.62l0.07,0.78l2.52,3.57l-3.82,0.47l-2.79,1.57l-0.07,0.91l1.55,1.67l1.57,3.11l1.42,1.89l-0.51,2.82l-0.86,1.93l-2.02,2.99l-0.1,0.83l0.94,1.66l1.73,0.94l3.6,3.47l0.78,3.4l1.43,3.27l1.23,3.95l-0.07,3.7l2.22,2.27l0.43,5.38l-1.31,4.71l1.12,2.83l-0.12,0.92l-2.12,3.69l-0.31,1.64l-3.08,-0.17l-2.72,0.77l-4.06,2.3l-1.68,2.09l-2.02,-0.32l-1.56,1.24l-2.13,-0.62l-0.64,-0.74l-0.84,-0.12l-4.12,3.34l-1.44,0.06l-0.57,0.31l-0.14,1.87l-2.29,0.13l-0.55,1.04l1.04,1.73l-0.51,1.0l0.05,1.2l1.67,2.1l0.3,1.38l-5.07,1.34l-7.99,0.81l-3.73,1.66l-1.58,1.88l-1.55,0.74l-2.19,3.55l-5.83,-0.29l-3.22,0.59l-2.11,-0.72l-3.44,0.0l-2.44,-0.84l-5.56,-0.15l-1.36,0.29l-1.79,1.06l-1.02,-0.37l-1.84,-1.89l-0.73,-0.15l-0.91,0.28l-0.52,0.62l-0.16,2.28l-0.72,0.98l-3.85,-0.24l-2.6,1.5l-1.18,-0.45l-0.12,-1.0l-0.46,-0.52l-0.8,-0.24l-1.55,0.21l-2.31,-0.53l-1.04,0.29l-3.98,3.58l-1.69,0.94l-2.46,-1.47l-0.93,-1.4l-0.84,-0.54l-0.84,-0.04l-0.83,0.37l-0.7,1.07l-1.07,0.49l-3.45,0.3l-2.25,-0.75l-0.71,-0.49l0.93,-3.22l-0.72,-1.01l-1.32,-0.68l-1.11,-1.06l0.45,-2.58l-0.5,-1.16l-0.91,-1.04l-1.23,-0.68l-5.0,-0.37l-0.32,-1.41l-0.46,-0.57l-3.41,-1.35l-2.07,-1.8l-0.45,-0.65l-0.51,-2.09l-0.01,-1.46l0.61,-2.86l-0.92,-2.42l-1.83,-2.14l-2.6,-1.8l-7.16,-9.22l-1.26,-3.31l-1.36,-1.88l-6.25,-3.03l-0.71,0.68l0.16,1.39l0.73,1.37l-0.4,0.35l-5.41,0.31l-1.21,0.29l-1.78,1.09l-2.67,-0.46l-2.71,0.24l-1.01,-0.19l-0.92,-0.81l-0.25,-0.98l0.04,-2.48l0.47,-2.57l-0.35,-1.03l-2.01,-0.4l-0.72,-1.12l-0.61,-0.29l-3.43,0.61l-0.29,-0.38l0.35,-1.68l-0.32,-1.32l-0.99,-0.39l-1.98,0.41l-0.5,-1.99l-0.74,-0.2l-1.7,0.66l-1.69,-2.39l0.88,-5.76l1.43,-5.26l4.43,-6.2l-0.2,-2.84l0.98,-2.98l1.96,-3.88l-0.45,-3.6l1.51,-3.81l7.61,1.68l0.98,-0.08l0.62,-0.83l-0.48,-2.31l0.7,-0.71l2.9,0.89l2.04,-1.63l2.39,-0.48l3.32,-1.45l2.28,-0.47l0.53,-0.73l-0.22,-1.26Z",name:"Centre"},"FR-E":{path:"M25.63,242.25l0.98,-1.98l0.98,0.49l19.62,-3.77l3.65,0.88l0.91,-0.32l0.5,-0.76l0.62,-2.51l-0.36,-1.04l-0.81,-0.89l-0.58,-2.39l-1.01,-0.81l-2.92,-0.69l-0.66,-1.14l-0.5,-0.27l-1.37,0.44l-3.11,-1.71l-2.01,0.46l-2.96,4.7l-0.73,0.21l0.57,-1.39l-1.14,-2.33l0.91,-1.36l-0.39,-1.22l-1.09,-0.38l-3.21,-0.11l-0.03,-1.0l1.84,0.17l0.95,-0.24l0.41,-0.81l-0.22,-0.93l0.98,-2.21l0.53,-0.43l0.46,0.19l-0.71,2.55l0.23,0.48l1.87,0.72l5.36,-0.32l1.36,0.83l1.04,0.18l3.66,-0.78l2.04,-0.12l0.21,0.35l1.46,0.44l5.01,-0.91l0.33,-0.98l-0.42,-0.4l-1.83,0.11l-0.45,-0.19l-0.2,-0.74l-0.68,-0.16l-1.09,0.67l-1.22,-1.03l-2.07,0.18l0.59,-0.25l0.44,-0.73l1.79,-1.5l0.1,-0.44l-0.38,-0.25l-1.24,0.08l-1.29,0.8l0.0,-0.47l-0.85,-0.4l-0.96,1.04l-0.96,-0.2l-1.87,1.11l-0.5,0.08l-0.43,-0.77l-0.56,-0.05l-1.09,0.68l-1.02,0.2l3.24,-3.36l6.46,-3.39l0.19,-0.5l-0.47,-0.25l-4.22,1.6l-4.19,0.6l-5.77,2.77l-2.94,0.62l-1.85,0.8l-1.08,0.12l-4.35,-1.11l-0.58,0.4l-0.15,1.12l-0.27,0.13l-3.57,-0.23l-0.68,-1.74l0.68,-0.06l0.36,-0.44l-0.1,-1.01l-1.05,-2.18l-0.09,-1.34l0.28,-1.34l0.6,-0.89l1.01,-0.27l0.3,-0.88l-1.49,-1.16l0.52,-1.93l2.34,-3.42l1.07,0.45l0.46,-0.14l-0.19,-0.71l0.54,-0.32l2.86,-0.47l3.08,1.22l1.04,-0.16l0.21,-0.65l-1.67,-2.31l0.37,-0.22l2.65,0.59l1.24,-0.03l0.38,-0.34l-0.26,-0.44l-1.23,-0.43l0.07,-0.55l-0.35,-0.44l4.17,-0.0l3.43,-1.04l1.35,-0.03l0.38,-0.31l-0.2,-0.45l-0.86,-0.45l1.38,-0.23l3.24,-1.36l1.36,0.05l0.84,0.86l-0.39,1.52l0.42,0.5l1.58,-0.18l2.35,-1.07l2.95,0.58l0.4,-0.4l0.0,-0.59l-1.04,-0.57l0.11,-0.28l1.91,-1.43l2.45,-0.6l1.27,0.07l1.03,0.52l0.71,-0.39l0.36,0.69l0.75,0.24l1.01,-1.05l-0.02,-1.18l4.45,-1.51l-0.24,1.62l0.55,0.4l-0.25,0.84l1.04,1.07l-0.07,1.9l0.48,-0.03l1.68,-1.43l0.9,-0.29l-0.28,0.38l0.1,0.75l3.35,2.74l0.61,-0.01l0.45,-0.54l-0.24,-0.79l0.28,-0.74l-0.54,-1.41l0.79,0.35l0.21,-0.4l0.01,-2.72l0.24,-0.43l0.93,0.16l0.45,-0.85l1.48,0.59l2.89,-0.11l2.82,1.61l2.57,-0.38l0.28,1.21l1.61,0.42l1.96,-0.05l0.87,-0.41l0.21,-0.49l-0.71,-3.08l2.98,-0.46l0.33,-0.33l-3.03,-3.0l-0.19,-0.98l2.29,-1.26l1.58,-2.51l0.68,0.39l1.86,0.1l2.17,1.06l-0.28,0.54l0.32,0.6l2.25,0.04l1.71,-1.23l5.84,-2.09l1.17,0.0l1.67,-1.78l0.55,0.11l0.26,2.26l-0.4,1.28l-0.83,1.08l0.5,1.21l0.41,0.18l0.97,-1.9l1.78,-1.89l1.89,-1.51l0.81,0.06l1.06,-1.09l0.51,-0.13l0.85,0.83l-0.4,1.97l0.68,0.68l-1.05,2.42l-1.65,2.02l-0.1,0.85l0.4,0.4l0.8,-0.2l3.03,-4.81l0.76,0.15l1.33,-0.56l0.67,0.24l-0.02,0.75l-1.71,1.0l-0.01,1.15l2.48,1.16l4.01,0.41l0.01,1.2l-0.8,0.72l0.21,0.84l1.94,1.27l1.37,1.73l3.87,2.85l0.88,3.1l-0.26,0.69l0.22,0.77l2.78,1.74l3.18,1.32l-1.16,1.99l1.46,0.52l1.88,1.65l0.62,-0.24l0.25,-2.13l2.16,0.1l1.16,-0.4l3.22,-3.61l5.89,-2.95l0.99,-1.12l0.0,-0.53l-0.84,-0.45l1.49,-0.39l1.05,0.13l0.44,0.89l0.49,0.2l3.51,-1.61l2.1,-2.09l0.67,0.82l1.02,0.23l-1.01,1.46l-1.68,1.58l0.05,0.62l1.51,0.76l3.43,-2.2l0.62,2.37l0.78,0.42l0.63,2.14l0.57,0.3l1.25,-1.02l0.75,0.88l1.35,-0.4l0.22,-0.89l-0.64,-0.57l0.93,-0.86l1.16,0.66l0.55,-0.01l0.02,-0.55l-1.01,-1.64l2.26,-0.68l2.61,-0.22l1.31,2.11l0.42,1.64l1.16,0.92l-0.26,1.06l1.54,2.0l0.32,0.9l-0.23,1.64l0.21,0.41l0.46,-0.06l2.43,-1.55l0.01,-0.69l-1.38,-0.83l0.13,-0.69l-0.92,-1.66l0.91,0.63l0.48,-0.04l0.09,-0.48l-1.1,-1.52l-1.85,-0.63l-1.61,-3.1l0.13,-0.41l0.98,-1.09l1.07,-0.34l0.37,-1.34l0.28,-0.13l2.22,0.0l0.28,-0.7l4.99,-0.86l0.54,1.16l-1.35,1.87l-0.06,2.08l1.7,1.73l2.67,0.63l4.54,0.04l4.83,-0.64l3.02,-1.39l2.6,5.45l1.04,3.06l1.91,2.9l3.27,2.38l2.44,0.21l1.93,-0.61l2.78,-1.91l2.08,-0.77l2.22,-2.4l2.39,0.03l6.14,1.5l2.32,1.25l-0.2,5.67l0.77,8.15l-1.95,4.1l0.21,1.05l0.9,1.52l0.8,4.72l-0.73,1.74l0.74,4.88l0.57,1.17l1.18,1.08l0.09,4.44l-1.36,0.63l-4.18,0.61l-2.21,1.9l-0.63,1.08l-2.9,9.1l-1.14,1.77l-0.41,1.91l-6.47,-1.09l-0.75,-0.44l-0.77,-1.22l-1.29,-0.55l-3.34,-0.0l-1.83,1.23l-6.34,2.57l-1.86,1.31l-1.2,1.55l-2.58,1.54l-7.31,2.01l-3.72,-0.8l-4.42,1.41l-1.22,0.67l-2.07,-0.04l-2.38,0.42l-3.35,1.92l-0.46,1.34l0.13,2.04l-0.71,1.59l-0.73,3.38l-0.54,0.87l-2.15,1.35l-1.11,2.03l-0.68,0.15l-0.2,-1.32l-0.56,-0.55l-0.75,-0.02l-2.38,0.9l-1.56,-0.86l-0.9,0.05l-0.9,0.52l-1.08,1.85l-1.37,1.25l-3.37,0.29l-1.9,-0.8l-1.35,0.35l-0.47,0.66l-0.66,-0.06l-0.41,-0.22l0.4,-1.16l-0.67,-1.08l0.25,-0.19l3.7,-0.17l2.26,-0.53l1.21,0.07l0.42,-0.34l-0.3,-0.45l-0.99,-0.24l-2.8,0.23l-5.66,-1.72l-2.91,0.66l-1.93,0.0l1.05,-1.04l0.47,-1.05l-0.12,-0.48l-0.5,0.01l-0.86,0.73l-2.73,0.25l-0.32,0.4l1.11,0.66l-1.57,-0.11l-0.6,-0.37l-0.61,0.32l-0.09,1.63l-0.48,0.24l-1.89,-0.59l-1.16,0.04l-4.35,1.05l-1.51,-0.37l-2.24,-2.86l-1.34,-0.5l-0.54,-0.67l1.53,-0.13l1.13,1.56l1.15,-0.56l0.69,0.46l0.65,-0.25l0.21,-0.93l0.66,0.6l1.69,0.45l1.67,-0.14l1.46,-0.78l-0.13,-0.88l2.17,-2.6l0.37,-1.63l-1.48,-1.88l-0.44,-0.11l-0.26,0.86l0.64,0.9l-1.1,0.64l0.6,0.74l-0.39,0.02l-1.13,-0.82l0.39,-0.14l-0.02,-0.47l-0.84,-1.0l-0.86,-0.45l-1.89,-0.29l-0.44,0.26l0.31,0.55l-3.56,0.47l-0.85,0.64l-0.55,0.91l-2.13,0.65l0.0,-0.48l-0.46,-0.4l-1.32,0.49l-0.19,-1.21l0.7,-1.13l-1.61,-0.61l-0.47,-1.47l-0.85,-0.33l-0.4,0.46l0.45,2.1l0.01,1.94l0.27,0.88l1.3,1.72l-0.77,0.06l-1.84,-1.77l-0.48,-0.01l0.02,1.33l-0.45,-1.98l-0.51,-0.31l-0.67,0.4l-0.04,1.56l-1.22,-0.46l-1.86,0.87l-0.79,0.06l0.11,-0.88l-1.36,-0.9l-0.9,-0.02l-0.6,0.64l-1.75,-2.35l-1.96,-1.13l0.78,-2.82l4.43,-1.77l0.2,-0.57l-0.36,-1.98l-0.6,-0.34l-0.71,0.3l0.01,-1.53l-0.4,-0.43l-0.73,0.2l-0.33,0.57l-1.35,-0.45l-0.97,0.16l-0.33,0.36l1.51,1.12l0.5,1.38l-0.92,0.03l-0.89,0.76l-0.75,0.18l-0.19,0.67l0.52,0.61l-0.59,0.38l-0.66,1.45l-2.06,-1.94l-1.14,-0.34l-0.21,-0.79l-2.13,-0.87l-1.87,-0.17l0.38,-0.4l0.08,-1.06l0.95,0.1l0.65,-0.32l1.28,-2.54l0.88,-0.82l-0.25,-0.95l-0.44,0.09l-2.95,2.66l-1.78,0.9l-1.23,0.25l-0.32,0.34l0.22,0.41l0.92,0.77l-4.61,0.99l-0.63,-0.17l-2.02,-2.33l-2.01,-3.11l-0.6,-0.18l-0.57,0.4l-0.83,-0.02l-2.13,-0.46l-2.06,0.0l-1.4,-1.03l-2.45,0.05l-0.95,-0.29l-0.44,-0.91l-0.74,-0.41l-3.29,1.44l-0.96,-0.68l-3.48,0.2l-1.22,-1.97l-0.89,-0.77l0.11,-1.0l-0.37,-0.51l-1.34,-0.44l-0.26,-0.87l-1.15,-1.13l-1.72,-1.0l-1.75,-0.32l-0.44,0.53l0.51,1.46l-0.36,0.96l-0.24,0.22l-0.49,-0.49l-1.37,0.27l-0.79,0.62l-1.44,-1.0l-2.43,-0.67l-0.69,-0.82l-1.04,-2.67l-0.42,0.16l-0.7,1.27l0.43,1.31l1.4,1.55l-1.0,0.23l-0.97,0.66l-0.91,-1.34l-1.28,0.04l-0.48,1.28l0.73,0.75l-0.22,0.89l0.4,0.4l1.27,0.0l-1.81,1.5l-2.27,0.79l-8.52,-0.35l-0.07,-1.48l1.2,-0.18l0.52,-0.76l-0.21,-1.72l-1.54,-4.18l-0.96,-1.47l-2.99,-3.31l-6.1,-3.99l-1.18,0.45l-1.3,1.04l-1.84,-1.46l-3.15,-0.06l-3.8,-0.92ZM122.84,278.42l0.11,0.08l-0.08,0.32l-0.03,-0.4ZM122.52,282.02l0.23,1.3l1.65,2.47l-0.96,-0.23l-0.59,0.29l-0.71,-2.5l0.37,-1.33ZM133.84,278.57l0.45,0.38l-0.04,0.12l-0.41,-0.51ZM123.36,297.99l1.01,0.42l1.66,-0.07l0.33,0.33l-0.17,0.99l-1.32,0.33l-4.68,-0.38l-3.08,-0.8l-0.79,-0.48l0.14,-1.16l-1.41,-3.37l0.57,-0.67l4.02,1.8l3.72,3.05ZM1.37,208.95l2.5,-0.92l1.47,0.95l-2.48,1.11l-0.61,-1.01l-0.88,-0.14Z",name:"Bretagne"},"FR-D":{path:"M572.78,248.31l2.08,2.76l1.34,0.84l0.91,0.04l2.45,-1.72l13.22,-1.52l1.29,-0.82l0.21,-1.86l1.83,-1.16l3.72,0.47l2.38,-0.98l2.0,1.2l3.68,0.69l0.55,0.46l-0.52,1.12l0.41,0.79l2.84,0.99l0.59,0.52l-1.02,1.96l0.47,1.65l1.15,0.43l0.67,-0.37l0.54,-0.83l0.47,-0.03l3.02,3.37l2.43,4.0l0.05,1.03l-2.6,0.55l-0.58,0.46l-0.24,0.88l1.41,1.97l0.37,2.77l0.83,1.89l1.58,0.62l1.84,-1.46l0.41,0.07l2.15,2.8l2.67,1.55l2.02,-0.25l1.44,-1.65l0.75,-0.28l0.64,1.53l0.67,0.7l3.65,2.12l0.68,2.08l0.72,0.4l0.98,-0.16l2.08,-1.37l1.56,1.15l0.73,-0.29l0.57,-0.7l2.12,0.66l1.21,-1.19l1.1,-0.47l1.19,0.92l-0.01,1.95l1.12,1.97l-0.07,1.43l-1.89,2.28l-1.75,0.32l-1.04,0.83l-0.58,2.49l0.56,0.82l2.03,0.82l0.58,3.42l2.32,2.25l0.39,4.41l1.07,1.44l-1.39,4.41l-0.25,2.08l-6.08,8.72l-5.33,2.53l-0.45,1.23l0.54,1.75l-0.09,0.77l-2.28,1.17l-1.09,0.77l-0.12,0.52l1.6,2.94l3.44,3.22l2.4,1.27l1.61,0.29l1.67,1.37l1.99,0.63l-1.05,1.51l-4.39,0.61l-1.2,1.17l-0.05,0.66l0.39,0.73l1.85,1.61l-0.8,1.32l-0.1,0.94l1.47,1.38l1.77,6.19l-1.03,3.43l-1.83,1.08l-0.81,1.06l-0.2,2.01l0.61,1.51l2.83,1.66l0.43,0.91l-1.02,0.93l-4.32,0.87l-1.26,0.59l-4.14,-0.98l-1.53,-0.8l-2.16,-1.97l-1.58,-0.52l-2.05,0.18l-3.7,1.25l-1.28,0.13l-4.17,-1.37l-0.92,-0.05l-1.3,0.44l-1.85,4.3l-0.85,4.21l-1.47,2.56l-0.15,1.93l-3.53,6.7l-1.32,4.86l0.08,0.87l-2.89,-0.32l-0.98,-0.75l-0.98,-2.54l0.04,-1.79l-1.73,-1.29l-0.18,-1.86l-0.76,-0.6l-1.87,-0.55l-1.12,0.62l-0.53,1.93l-1.03,0.26l-2.35,-2.01l-0.72,0.04l-1.62,0.92l-1.03,0.08l-2.29,-0.51l-2.25,-0.92l-0.92,0.11l-0.68,0.9l-1.27,4.46l-1.74,2.06l-1.51,1.09l-1.62,0.57l-1.65,0.02l-4.83,-1.24l-3.08,0.65l-4.17,-0.93l-4.25,1.28l-1.42,-0.08l-2.06,-1.47l-2.77,-1.06l0.11,-2.73l-0.6,-1.7l5.26,-2.58l1.52,-1.33l0.08,-0.97l-0.86,-1.29l0.04,-1.38l-0.52,-1.25l0.64,-3.0l-0.8,-3.17l-2.08,-1.35l-4.18,-0.89l-2.7,-2.24l-1.72,-0.07l-3.83,-1.94l0.37,-3.1l-0.38,-1.88l-1.07,-0.72l-1.57,-2.64l-2.41,-2.14l-0.51,-1.65l-1.52,-2.44l-2.0,-0.46l-0.44,0.26l-0.43,1.96l-1.36,0.87l-0.44,1.79l-3.8,2.0l-1.31,0.28l-0.45,-0.19l-0.06,-1.53l-1.67,-2.57l-1.59,-0.43l-0.82,0.13l-1.33,1.43l-0.97,0.48l-2.64,-1.07l-1.82,-0.29l-1.87,0.11l-3.04,1.06l-3.34,-2.82l-1.29,-0.36l-1.59,0.11l-1.82,-0.88l-1.13,-0.81l-1.13,-1.49l0.24,-3.05l2.35,-4.46l-1.16,-3.32l1.31,-4.66l-0.44,-5.56l-2.26,-2.43l0.11,-3.58l-1.26,-4.05l-1.41,-3.21l-0.84,-3.54l-3.63,-3.57l-1.85,-1.04l-0.71,-1.21l2.92,-5.34l0.56,-3.19l-0.17,-0.62l-1.7,-2.2l-1.25,-2.57l-1.44,-1.56l0.08,-0.29l2.27,-1.1l2.94,-0.21l1.27,-0.38l0.25,-0.54l-0.6,-1.33l-2.08,-2.61l0.57,-2.21l-1.26,-2.45l-2.54,-2.22l-2.26,-0.85l-0.27,-0.84l0.22,-1.32l0.76,-0.58l4.07,-0.42l4.77,-2.29l0.53,-0.86l-0.08,-2.09l0.82,-1.64l-0.97,-2.16l-0.15,-2.18l1.55,-0.25l1.46,-1.47l2.5,-1.52l2.08,-4.18l-0.63,-2.78l-2.95,-2.35l-0.89,-1.09l-1.46,-4.45l-1.91,-1.27l-3.81,-0.73l0.73,-2.78l3.72,-2.26l1.64,-2.66l0.15,-0.86l-0.86,-1.48l-0.18,-1.43l1.15,-3.5l0.41,-0.36l3.03,0.06l2.27,-0.89l4.61,0.48l6.23,-0.91l2.51,0.47l0.72,-0.38l0.87,-1.43l1.29,-1.21l0.68,0.48l0.65,2.62l0.7,0.31l1.89,-0.13l2.82,1.56l5.42,6.18l0.37,0.67l0.39,2.99l-1.82,2.13l0.14,1.13l2.19,0.89l3.06,2.04l1.02,0.12l1.09,-0.29l0.78,-1.18l1.07,0.24l1.04,2.12l1.93,1.93l4.55,6.82l-1.58,0.69l-0.06,1.02l2.02,1.14l2.25,-0.31l0.24,0.47l-0.05,2.31l0.83,1.24l2.41,0.53l2.82,-0.18l1.96,0.66l0.71,-0.08l1.68,-1.15l1.71,0.44l2.04,-0.07l2.04,-1.61l0.63,0.05l1.22,0.92l0.82,0.12l0.66,-0.82l0.03,-1.6Z",name:"Bourgogne"},"FR-K":{path:"M419.41,662.94l0.18,-1.54l0.62,-1.4l0.95,-0.83l6.33,-1.23l1.62,-0.04l2.87,0.76l1.42,-0.31l1.24,-1.33l0.24,-2.08l0.4,-0.91l1.5,-1.63l6.16,-0.76l3.36,0.54l0.96,-0.45l0.41,-0.96l-0.76,-1.81l-3.09,-1.57l-1.3,-1.89l-0.78,-0.52l-1.45,-0.09l-4.97,0.99l-3.19,-1.51l-0.09,-2.0l-0.33,-0.79l-1.13,-1.02l-1.47,-0.6l1.45,-2.0l2.2,-0.09l2.98,-1.12l0.66,-0.91l-0.7,-3.27l-1.98,-1.59l0.22,-0.47l2.52,-0.94l0.35,-0.87l-1.18,-4.24l-1.84,-1.68l1.01,-1.4l-0.13,-1.62l-0.81,-1.39l-1.37,-1.06l-2.78,-0.31l-2.44,-1.23l-5.03,-1.67l-2.51,-2.02l-0.25,-1.95l-0.77,-1.95l0.54,-2.7l1.15,-1.61l0.25,-1.25l2.04,-0.61l1.77,-0.12l1.18,-0.91l0.17,-0.74l-0.43,-1.26l0.08,-0.79l1.5,-1.66l0.46,-1.21l1.39,0.39l0.18,1.21l0.84,0.58l4.13,-1.6l4.75,-0.59l1.8,1.66l1.22,0.49l1.49,0.09l3.87,-0.65l2.63,1.32l1.45,-0.69l0.36,-1.12l-0.32,-1.36l0.34,-0.67l0.77,-0.52l7.11,1.27l5.76,-0.38l6.52,0.53l2.44,-0.6l3.24,-2.32l0.42,-0.75l-0.67,-1.83l0.6,-2.13l-0.19,-0.87l-1.8,-1.81l-0.4,-0.78l0.06,-2.31l1.08,-2.4l2.53,-0.35l4.36,1.68l1.08,-0.09l6.9,-2.67l1.13,-0.84l0.89,-1.44l0.94,-0.73l2.76,-0.52l2.56,0.79l1.34,-0.36l0.68,-0.74l0.34,-1.18l-0.14,-1.78l0.44,-1.97l-0.73,-1.88l0.39,-1.59l1.59,-0.38l6.2,0.72l1.39,-0.44l1.56,-1.67l0.22,-1.48l0.5,-0.93l1.64,-1.06l2.89,-0.27l1.39,-1.03l1.01,-2.68l5.43,-4.9l0.14,-1.04l-0.48,-0.79l-2.93,-2.22l-2.63,-0.53l-1.18,-1.1l-1.67,0.17l-0.93,-0.62l2.15,-1.34l0.28,-2.27l0.84,-1.14l2.09,-1.35l0.15,-0.49l-0.57,-1.23l-1.21,-0.88l-0.78,-0.19l-6.03,0.28l-0.56,-1.65l-1.01,-1.16l-4.04,-2.16l-1.29,-0.2l1.45,-3.24l-0.19,-0.85l-0.85,-1.25l-0.29,-2.01l0.71,-2.49l0.15,-2.55l-3.33,-4.54l-0.25,-1.16l0.15,-2.52l-1.11,-2.03l-5.17,-5.93l0.78,-2.2l1.89,-2.92l0.36,-2.65l1.38,-4.58l0.47,-0.79l1.76,-1.22l0.66,-3.31l0.73,-0.72l0.53,0.01l1.38,1.73l1.21,-0.05l1.38,-0.79l3.42,-3.06l2.41,-0.28l3.68,-2.03l1.93,-0.24l0.36,0.35l0.79,2.6l3.5,5.9l1.31,1.29l1.23,0.42l1.33,-0.63l3.37,-0.36l1.07,-0.91l0.56,-2.31l0.89,-0.32l1.69,0.16l0.84,0.67l-0.48,1.5l0.3,0.89l4.51,0.95l4.08,3.38l2.89,1.45l1.57,0.41l-0.03,2.85l1.28,3.55l0.51,3.07l0.72,2.11l0.66,1.17l1.36,0.88l0.8,1.32l2.21,6.94l1.77,1.52l1.64,2.61l-0.83,2.07l0.49,3.26l0.66,0.8l4.86,-0.5l1.08,1.04l4.93,2.42l1.51,0.3l0.78,-0.21l1.6,-1.52l3.36,-2.18l2.44,-0.38l0.36,0.44l-0.26,1.47l0.24,0.69l0.83,0.79l0.97,0.26l0.84,-0.14l1.05,-0.78l0.64,-2.28l2.19,-0.38l1.44,0.09l1.68,0.67l2.19,2.02l1.73,0.78l2.57,0.61l0.57,1.69l1.23,1.54l0.1,1.58l1.9,1.83l0.18,2.73l-0.33,2.14l0.45,2.79l0.62,0.47l1.22,-0.4l1.2,0.21l4.27,4.83l0.23,0.7l-0.08,0.33l-1.09,-0.09l-0.55,0.26l-0.07,2.45l-1.05,1.25l-1.67,1.19l-2.8,1.16l-5.36,3.57l-0.17,0.92l0.54,4.15l-1.95,4.79l0.01,1.9l-0.43,1.1l-4.47,-1.25l-2.03,0.57l-1.49,1.04l-1.68,2.12l-1.37,2.92l0.45,1.06l1.58,0.26l-0.52,1.33l-2.32,0.57l-0.61,1.38l-1.54,0.44l-3.46,2.46l-2.02,0.48l-1.44,1.06l-1.17,0.31l-1.37,3.01l-2.27,-0.34l-2.81,-1.63l-0.8,-1.47l0.85,-1.47l-0.07,-0.6l-1.92,-1.42l-3.63,-0.32l-3.46,0.39l-2.41,0.83l-13.11,9.5l-7.26,2.86l-2.05,1.55l-4.61,5.42l-1.04,0.41l-2.52,-1.04l-4.05,0.36l-4.36,1.63l-4.56,3.3l-1.44,1.8l-2.59,2.25l-1.5,2.23l-2.52,2.24l-2.69,5.94l-1.93,6.26l0.17,0.94l0.79,0.58l0.07,1.22l-0.96,8.67l0.17,4.88l-0.34,3.08l0.26,4.02l0.72,5.72l1.02,1.05l4.27,1.24l0.37,0.52l-0.12,1.76l1.98,2.59l0.3,1.34l-2.29,0.36l-3.05,-0.09l-1.83,-0.7l-1.61,-2.13l-2.87,-0.28l-1.16,0.57l-2.17,-0.57l-1.94,1.35l-3.1,0.24l-3.76,2.65l-4.83,-0.08l-1.22,0.53l-2.65,1.86l-0.57,0.72l0.5,1.8l0.52,0.57l-2.26,-0.17l-2.79,-0.85l-1.31,0.01l-0.83,0.63l-0.48,1.11l-0.67,0.22l-2.94,-1.07l-1.08,-0.76l-1.67,-2.44l-2.78,-0.4l-6.16,-2.91l-1.99,0.2l-3.71,1.04l-3.02,-0.29l-1.14,0.54l-1.01,1.86l-2.45,1.95l-0.62,0.36l-2.45,0.36l-0.71,-0.1l-1.77,-1.24l-1.32,-3.75l-1.07,-1.5l-3.53,-0.74l-3.45,-2.1l-1.38,-0.5l-3.76,-0.46l-0.8,-0.3l-0.31,-0.6ZM436.08,668.09l0.96,-0.22l0.2,-0.59l-1.32,-2.33l-0.63,-0.79l-0.47,-0.12l-0.9,0.48l-0.67,1.33l0.07,1.16l0.97,0.84l1.79,0.25Z",name:"Languedoc-Roussillon"},"FR-J":{path:"M472.43,160.67l2.91,-0.96l1.28,0.25l1.79,1.42l0.99,0.02l1.16,-0.44l1.27,0.83l1.39,0.28l2.4,-1.49l4.01,0.91l5.72,-1.07l1.57,0.83l2.35,-1.11l1.82,-0.03l2.03,-1.04l3.48,0.96l0.98,1.05l0.87,1.67l-0.52,2.79l0.73,1.41l8.88,6.73l0.87,0.26l1.23,-0.5l0.48,0.14l0.61,2.97l0.7,1.03l3.28,1.81l2.3,-0.04l-0.11,1.1l-0.51,0.67l-2.55,0.08l-0.94,0.42l-0.16,0.75l1.09,1.07l-1.54,1.52l-0.27,1.55l0.54,0.66l1.24,-0.02l1.67,1.83l0.7,2.85l-0.5,1.9l0.28,1.65l0.9,0.56l2.22,-0.3l1.49,1.83l-2.45,1.85l-1.06,1.42l-0.92,2.34l-0.48,0.4l-2.35,0.42l-0.63,0.51l-0.08,0.73l0.94,1.41l-1.79,1.84l-0.05,0.79l0.65,1.23l-0.56,2.16l0.16,0.69l-2.61,2.88l-2.24,-0.49l-6.28,0.91l-4.68,-0.48l-2.32,0.9l-3.26,0.0l-0.8,0.78l-1.14,3.17l0.16,2.32l0.83,1.42l-1.58,2.76l-3.77,2.32l-0.95,3.37l-5.9,1.83l-1.36,-0.07l0.46,-1.24l-0.4,-0.63l-0.91,-0.28l-2.7,0.45l-1.78,1.66l-1.87,0.81l-8.32,-0.58l-3.25,0.65l-1.6,-0.18l-0.78,-0.59l0.23,-0.94l0.72,-0.24l1.65,0.3l0.91,-0.65l0.07,-0.64l-0.51,-1.19l0.65,-0.98l0.11,-1.36l-1.39,-1.54l-3.36,-1.92l-1.3,-3.89l-1.33,-1.28l-2.27,0.3l-2.83,-1.36l-0.86,0.16l-1.36,1.23l-1.4,0.35l-0.76,-0.38l-0.47,-1.03l-0.68,-0.61l-0.85,-0.52l-0.84,-0.03l-0.66,0.4l-1.38,1.92l-1.99,0.8l-8.7,1.71l-0.72,-0.42l-0.0,-0.42l1.65,-1.87l0.02,-0.74l-1.91,-1.77l-0.62,-2.84l-0.52,-0.9l-1.62,-1.5l-0.35,-2.59l-0.81,-0.45l-2.11,0.38l-4.37,-1.8l-0.92,-0.66l-1.17,-1.71l0.01,-2.65l-0.44,-1.51l-0.7,-0.87l-2.25,-1.46l-0.79,-2.45l-3.87,-2.43l-1.32,-1.5l-0.63,-1.5l-1.41,-0.91l0.0,-0.93l1.6,-2.06l0.18,-1.09l-0.28,-0.53l-1.69,-0.85l-0.41,-0.65l-0.06,-1.41l0.53,-2.41l-0.31,-1.9l-1.49,-1.94l-3.28,-5.55l-0.4,-2.82l-2.11,-0.85l0.25,-2.13l-0.72,-1.71l0.41,-0.57l7.7,-1.56l2.46,-1.13l3.15,-8.76l1.58,-2.72l0.43,0.35l0.8,2.03l0.97,0.67l3.39,0.3l5.65,1.41l6.54,-0.78l5.01,-2.69l3.66,2.09l2.47,0.26l3.97,1.5l1.83,0.1l3.18,-1.39l11.5,5.26l0.91,0.03l0.87,-0.37l1.31,1.53l1.38,0.99Z",name:"\xcele-de-France"},"FR-I":{path:"M636.54,324.96l3.3,-1.96l0.29,-0.73l-0.62,-2.26l0.27,-0.68l5.24,-2.45l5.77,-8.09l0.56,-1.07l0.24,-2.05l1.45,-4.6l-1.14,-1.69l-0.56,-4.91l-2.21,-1.91l-0.59,-3.43l-0.81,-0.72l-1.67,-0.59l0.44,-1.97l0.7,-0.55l1.95,-0.44l2.03,-2.43l0.31,-1.4l-0.34,-1.34l-0.93,-1.42l0.2,-1.34l-0.22,-0.65l-1.0,-1.07l-0.91,-0.31l-0.83,0.13l-1.8,1.57l-1.46,-0.6l1.76,-3.55l0.7,-0.81l0.64,-0.2l3.99,-0.6l3.21,1.65l1.53,0.3l6.58,-1.86l0.7,-0.44l0.69,-0.83l0.2,-0.97l-0.19,-2.21l0.55,-2.48l-0.58,-2.14l0.19,-0.51l0.63,-0.82l6.42,-3.94l2.41,-2.91l2.03,-0.75l0.4,-0.92l-0.24,-0.87l1.66,-0.91l1.8,-2.61l0.31,0.88l-0.17,1.53l0.84,0.59l3.53,-2.14l2.66,-2.84l1.54,-0.3l2.78,0.53l1.12,0.68l0.83,1.02l-0.06,1.28l0.31,0.67l3.72,1.77l2.64,-0.19l2.39,-1.21l3.0,-0.19l2.26,0.8l5.28,2.92l1.38,0.35l2.17,-0.03l1.59,-0.57l1.93,-2.36l0.72,-0.14l3.61,3.45l3.4,1.51l6.19,4.28l1.5,0.2l0.14,1.19l0.91,0.99l8.6,4.3l1.49,1.43l0.42,3.57l-0.51,1.44l-1.54,2.09l-0.06,1.28l1.05,1.09l2.57,0.38l3.26,3.13l0.91,1.7l-0.38,2.33l-2.02,-0.53l-3.13,0.45l-2.79,-0.68l-2.25,0.79l-0.29,0.46l0.15,0.87l0.88,1.86l-1.14,1.05l-2.47,0.75l-0.32,0.37l-0.08,1.24l-1.37,0.7l-1.02,1.11l-1.15,2.35l0.42,0.52l7.29,-0.62l1.04,-0.41l2.04,1.73l-0.29,0.52l-1.73,0.73l-0.94,1.05l-0.92,0.22l-1.15,1.02l-0.52,1.79l0.21,1.82l-4.0,2.53l-1.78,1.58l-1.19,1.68l-3.91,3.12l-1.76,0.53l-0.28,0.41l0.06,1.05l-0.9,0.44l-0.31,0.51l-1.37,0.42l-0.72,0.57l-0.9,1.31l0.59,1.61l-1.2,1.49l-3.98,2.62l-6.53,1.77l-3.04,1.51l-1.11,2.94l1.07,2.32l0.08,1.66l-1.81,4.3l0.94,1.51l-0.16,1.55l-1.18,1.03l-2.12,1.0l-2.15,1.96l-4.43,2.12l-8.29,6.58l-0.92,1.27l0.3,1.23l1.2,1.17l-1.94,2.13l-3.09,4.33l0.33,2.88l-3.79,4.35l-2.1,1.94l-1.03,1.64l-4.26,3.58l-2.33,0.56l-7.03,-0.44l-0.45,-0.65l-0.22,-1.3l-0.66,-0.88l-3.08,-2.47l-0.52,-0.06l-2.8,2.33l-0.57,1.15l-1.28,0.24l-1.18,1.22l-1.45,0.59l-0.82,0.73l-1.63,-0.33l-0.55,-0.58l0.29,-2.41l-0.42,-1.04l-1.87,-0.45l-0.9,-1.08l-2.11,-0.64l-0.82,-0.85l-0.79,-2.49l-1.25,-0.94l-1.43,-0.41l-0.41,-0.65l-0.02,-2.36l1.02,-0.49l4.42,-0.91l1.13,-0.73l0.39,-0.89l-0.11,-0.84l-0.52,-0.67l-2.59,-1.42l-0.66,-1.39l0.39,-1.98l1.89,-1.03l0.5,-0.65l1.1,-3.74l-1.49,-5.71l-0.52,-1.09l-1.27,-1.09l0.92,-2.13l-0.29,-0.66l-1.72,-1.29l-0.18,-0.73l1.26,-0.72l3.88,-0.5l1.03,-0.96l0.46,-1.58l-0.25,-0.34l-2.12,-0.68l-1.69,-1.38l-1.75,-0.35l-2.19,-1.16l-3.31,-3.1l-1.32,-2.47Z",name:"Franche-Comt\xe9"},"FR-YT":{path:"M678.38,715.39l-0.52,0.0l-2.02,-6.29l2.65,-2.73l0.87,2.15l0.24,2.21l-0.38,2.26l-0.84,2.4ZM647.49,692.27l-1.04,0.75l-0.14,0.46l1.6,0.36l0.6,0.88l2.18,1.87l2.93,3.52l1.63,1.28l2.49,0.62l4.96,-0.04l2.61,0.78l2.6,1.74l1.05,1.73l0.02,2.1l-0.68,2.82l-3.71,5.46l-1.53,1.19l0.14,2.09l1.04,1.92l2.81,1.86l-0.3,1.89l-3.07,6.4l-2.6,3.07l-1.21,3.45l2.82,4.18l-1.15,1.69l-1.53,1.06l-0.76,-1.37l-0.41,-0.2l-1.1,0.17l-1.53,1.03l-1.83,0.51l-1.63,-0.43l-2.25,-1.33l-1.24,0.41l0.12,-1.88l-0.84,-1.8l-1.74,-0.77l-1.92,0.17l0.0,-0.31l2.91,-1.61l0.29,-2.68l-1.49,-2.81l-2.83,-1.57l0.22,-0.43l1.06,-0.67l1.55,-0.14l0.82,0.5l2.83,3.33l2.81,1.68l1.89,-0.73l0.6,-2.42l-0.76,-2.88l-1.37,-2.17l-1.74,-1.96l-4.21,-3.56l2.58,-0.75l0.36,-0.4l-0.07,-1.34l-0.91,-1.33l-0.68,-2.3l-0.55,-4.71l-0.6,-2.37l-1.57,-1.23l-1.87,-0.61l-1.59,-1.03l-1.74,-2.81l-0.41,-4.1l7.31,-7.87l0.59,1.27l-0.82,0.34Z",name:"Mayotte"},"FR-O":{path:"M413.26,57.99l0.02,-1.01l-3.2,-2.12l1.12,-3.04l0.33,-6.83l1.74,-1.1l0.1,-0.58l-1.61,-2.08l-0.3,-1.01l-0.26,-3.74l-0.64,-3.46l0.26,-2.94l2.0,-4.41l0.34,-1.54l-1.52,-6.24l1.26,-0.84l3.05,-0.71l2.82,-2.96l1.8,-1.42l11.58,-4.22l1.24,0.13l2.03,-1.0l9.83,-1.04l11.16,-3.16l4.16,0.3l5.0,-1.09l3.16,-1.35l0.71,1.42l0.6,3.51l0.63,1.64l3.14,3.26l0.16,1.34l-1.61,1.47l-0.48,1.18l1.18,3.46l-0.52,1.99l1.22,0.87l0.85,1.47l1.61,0.49l1.71,-0.11l1.11,0.33l0.92,1.61l2.23,1.78l1.56,2.71l1.22,0.84l6.21,2.17l1.21,-0.69l1.82,-2.63l2.37,-1.63l7.93,-2.08l1.41,0.36l0.92,0.73l2.64,4.35l0.72,0.59l1.48,0.27l0.38,0.58l0.61,1.69l-0.8,1.48l0.51,2.38l1.6,4.47l0.09,2.5l0.42,1.17l1.9,1.66l3.82,1.44l1.7,-0.16l2.68,-0.82l2.06,-1.38l0.72,-0.05l0.89,0.38l-0.6,1.19l0.12,0.56l0.76,0.47l4.13,0.08l2.56,0.75l1.12,0.9l0.91,1.39l1.05,10.05l2.3,1.94l1.29,-0.74l1.51,-2.44l1.09,-0.6l2.59,-0.16l2.45,0.25l3.52,1.61l1.52,-0.04l3.85,-1.36l1.15,-0.1l1.03,0.41l1.98,1.84l2.53,1.56l1.84,3.13l1.53,0.38l0.59,-0.74l-0.06,-0.72l0.39,-0.14l1.83,1.02l0.14,0.88l-2.69,2.35l-1.79,5.34l-0.17,1.55l1.11,0.78l1.48,-0.45l0.84,0.08l1.74,4.81l-2.7,1.39l-1.65,1.4l-0.66,1.72l0.66,2.17l-2.04,0.47l-6.39,-1.96l-0.28,-0.47l-0.05,-2.72l-0.86,-0.63l-2.19,0.26l-2.72,1.45l-2.51,-1.85l-6.24,-0.65l-3.38,-0.71l-1.05,0.1l-3.23,1.68l-0.69,0.09l-2.57,-0.97l-1.25,-0.05l-5.56,2.65l-0.88,0.07l-5.33,-1.36l-2.8,1.13l-3.55,-0.79l-1.98,-0.06l-4.16,0.8l-7.56,-4.25l-2.77,-0.36l-1.29,0.85l-0.01,1.73l-0.42,0.53l-3.52,0.3l-2.63,1.27l-0.35,-0.48l-0.01,-2.43l-0.6,-1.0l-0.66,-0.3l-0.96,0.27l-3.34,2.32l-0.75,-0.07l-0.01,-0.57l1.09,-1.47l-0.03,-1.29l-1.31,-2.12l-0.95,-1.02l-1.19,-0.66l-0.76,0.22l-0.47,0.72l-0.22,3.08l-3.59,-1.54l-3.28,-0.62l0.23,-1.55l-0.84,-0.78l-1.17,-0.0l-1.89,0.86l-2.21,-0.34l-2.47,0.23l-0.82,0.62l-1.01,1.74l-0.72,-0.02l-0.81,-0.93l-0.31,-0.93l0.37,-1.76l1.95,-1.64l2.76,-1.45l0.65,-0.83l-0.19,-0.81l-0.67,-0.61l-2.96,-1.39l-1.81,-0.11l-1.13,0.92l-1.61,-1.74l-0.92,-0.29l-0.8,0.45l-0.34,0.97l-1.02,0.36l-6.98,0.99l-4.57,0.1l-1.52,-1.03l-0.6,-1.14l-0.08,-1.04l-0.83,-0.91l-6.58,-3.15l0.97,-1.81l-1.0,-0.9l-1.27,0.07l-1.48,1.08l-0.5,0.02l-0.91,-0.44l-1.88,-1.99l-1.36,-0.85l-2.32,-0.22l-2.56,0.27l-4.46,1.3l-2.04,-0.71l-1.31,-1.35Z",name:"Nord-Pas-de-Calais"},"FR-N":{path:"M296.09,638.61l-0.69,-4.39l0.23,-0.9l1.78,-2.58l-0.28,-3.88l2.39,-2.45l2.79,-0.25l0.84,-0.59l0.32,-0.83l-0.41,-1.39l0.02,-1.75l0.72,-0.92l2.37,-1.37l1.67,-2.92l1.05,0.11l0.6,-0.32l1.2,-3.37l1.88,-1.77l0.55,-1.02l0.07,-0.67l-0.62,-1.7l0.51,-2.21l0.68,-0.76l2.02,-0.75l0.47,-0.89l-1.07,-3.38l0.21,-2.73l-0.21,-0.77l-0.56,-0.5l-0.61,-0.06l-0.78,0.37l-1.02,1.09l-0.38,-0.27l-0.07,-1.71l1.65,-0.19l0.44,-0.8l-0.43,-1.63l-1.92,-3.78l-1.59,-1.2l-0.74,-1.54l-1.23,-0.77l-5.85,-1.11l-1.94,0.13l-0.8,-1.93l-0.88,-0.6l1.33,-2.32l-0.5,-1.87l1.41,-0.23l0.84,-0.72l1.33,-3.17l-0.83,-1.53l0.05,-2.22l1.48,-3.42l-0.0,-0.64l-0.91,-2.1l-1.51,-1.7l0.06,-0.26l3.02,-2.18l2.14,0.33l2.17,-0.22l1.91,-1.79l2.5,-1.32l1.3,0.7l0.06,0.52l-0.83,1.47l0.06,0.63l0.61,0.78l1.48,0.53l2.83,0.04l0.81,-0.49l0.46,-0.83l-0.21,-2.54l0.68,-1.02l1.79,-0.56l0.96,0.87l1.31,-0.01l1.3,-0.95l2.0,-2.61l0.42,-0.08l4.36,1.63l0.81,-0.02l3.09,-1.56l1.3,-0.2l4.46,-1.96l1.1,-0.75l2.5,0.3l5.09,-1.52l1.7,0.75l2.19,1.82l1.56,-0.16l3.92,-2.03l1.14,-2.97l2.17,-1.22l0.77,-1.7l1.0,-0.23l2.2,0.69l1.76,-0.35l0.51,-0.77l-0.02,-0.8l-0.33,-0.62l-1.03,-0.71l2.05,-1.55l2.29,-4.41l0.28,-1.14l-0.68,-1.14l-2.14,-0.75l-0.89,-1.21l0.8,-1.93l0.2,-2.29l0.6,-0.27l1.68,0.95l1.42,0.26l5.01,-0.38l1.18,-1.19l0.12,-3.52l-1.84,-1.84l-0.96,-2.38l-0.09,-1.96l-1.19,-1.7l0.07,-0.49l0.56,-0.53l2.99,-1.33l3.6,-2.94l3.41,-5.27l0.78,-0.63l2.29,-0.5l4.57,-2.86l1.44,-2.18l-0.02,-1.02l-0.61,-0.82l0.11,-0.81l0.64,-0.86l2.37,-0.76l1.69,-2.66l2.13,-1.79l0.74,-1.12l-0.14,-1.73l0.68,-1.13l0.08,-1.03l-1.31,-3.89l0.24,-0.96l3.33,-2.09l1.05,-0.26l1.04,-0.9l1.16,1.27l2.28,-0.55l2.62,0.91l4.01,2.82l1.3,1.87l1.92,0.91l1.31,1.01l0.85,0.2l1.52,0.03l3.21,-0.98l3.94,-1.84l2.17,0.72l1.98,-0.89l4.23,-0.19l0.61,1.12l0.9,5.86l3.12,4.71l1.22,2.47l-0.85,4.57l-0.66,1.67l0.13,0.4l1.71,1.0l1.23,3.98l0.91,0.71l0.84,0.16l0.43,-0.29l0.49,-1.7l5.01,-1.51l1.0,0.08l1.12,1.11l0.62,0.08l1.36,-0.63l3.34,0.11l1.98,-0.21l1.25,-0.59l3.91,-4.25l0.61,-2.45l2.43,-3.52l0.63,-2.44l8.11,-7.4l1.98,2.43l0.35,2.78l0.85,0.31l2.55,-0.29l2.18,2.96l0.8,2.12l1.02,0.73l1.85,0.66l-1.03,0.82l-0.2,0.72l0.58,1.36l0.56,3.56l0.51,1.07l0.89,1.09l2.04,1.54l5.22,5.97l1.03,1.89l-0.19,2.29l0.3,1.4l3.32,4.5l-0.18,2.17l-0.64,1.51l-0.08,1.13l0.32,2.23l1.01,1.78l-1.38,2.78l0.09,1.06l1.58,0.39l3.9,2.06l0.78,0.87l0.34,1.61l0.66,0.45l6.25,-0.23l1.47,0.82l0.29,0.68l-1.87,1.21l-1.04,1.36l-0.22,2.18l-2.12,1.24l-0.14,0.98l1.39,1.0l1.66,-0.16l1.15,1.08l2.51,0.46l2.73,2.04l0.32,0.46l-0.13,0.6l-5.25,4.63l-1.0,2.67l-1.08,0.84l-2.91,0.28l-1.88,1.2l-0.58,0.8l-0.32,1.84l-1.22,1.35l-1.52,0.35l-5.75,-0.72l-2.03,0.54l-0.42,0.6l-0.29,1.6l0.73,1.98l-0.44,1.8l0.13,1.84l-0.64,1.29l-1.29,0.19l-2.18,-0.74l-3.03,0.56l-1.22,0.91l-0.92,1.47l-0.94,0.7l-6.65,2.58l-1.23,-0.04l-2.62,-1.24l-1.35,-0.31l-2.38,0.11l-0.75,0.39l-1.36,2.84l-0.07,2.58l0.55,1.19l1.7,1.63l0.13,0.42l-0.6,2.34l0.7,1.51l-1.8,1.74l-1.39,0.83l-2.18,0.54l-6.45,-0.53l-5.8,0.38l-7.23,-1.26l-0.84,0.38l-0.74,0.89l-0.21,0.68l0.29,1.74l-1.0,0.67l-2.57,-1.32l-3.19,0.57l-2.01,0.01l-0.91,-0.34l-2.22,-1.85l-5.04,0.64l-3.86,1.57l-0.46,-1.5l-0.6,-0.48l-1.24,-0.27l-0.78,0.36l-0.48,1.25l-1.61,1.87l-0.12,1.21l0.42,1.17l-0.4,0.71l-3.58,0.55l-1.0,0.56l-0.38,1.49l-1.15,1.6l-0.59,2.9l0.8,2.22l0.31,2.12l3.4,2.69l4.59,1.38l2.5,1.26l2.66,0.27l1.08,0.84l0.66,1.11l0.15,1.08l-1.08,1.79l1.93,1.96l1.06,3.35l-0.06,0.82l-2.38,0.84l-0.49,0.5l-0.14,0.78l2.08,1.84l0.56,2.94l-3.03,1.21l-1.69,-0.0l-1.08,0.43l-1.46,2.27l0.23,0.77l2.07,0.97l0.64,0.92l0.04,2.18l2.73,1.69l2.42,0.3l4.95,-0.94l1.88,2.27l2.44,1.09l1.14,1.33l-0.08,0.62l-0.47,0.35l-3.39,-0.53l-6.47,0.84l-1.85,1.95l-0.5,1.16l-0.21,1.97l-0.93,0.94l-0.95,0.18l-2.88,-0.76l-6.66,0.81l-0.58,-0.62l-2.03,-0.75l0.42,-1.19l-0.34,-0.53l-6.9,-0.61l-4.12,-2.32l-2.77,0.67l-1.86,-0.09l-0.4,0.28l-0.88,2.73l-0.91,0.33l-0.66,-0.77l-1.07,-2.58l-2.23,-3.15l-1.29,-0.49l0.21,-0.83l-0.29,-0.49l-1.53,-0.36l-7.55,-0.02l-2.58,0.53l-0.9,-0.58l-1.64,-3.14l-1.32,-1.06l-1.36,-0.37l-5.14,-0.31l-1.98,-1.15l-1.93,0.82l-1.92,-1.37l-4.5,-2.05l-2.41,-0.11l-3.17,-0.95l-2.82,0.01l-1.77,0.79l-0.3,1.2l0.12,1.49l-0.82,1.99l0.47,0.91l-0.83,1.28l0.24,0.56l0.76,0.24l0.61,0.69l0.36,0.97l-0.05,1.0l-0.39,0.58l-10.29,0.14l-1.18,-0.37l-3.41,0.59l-1.07,-0.19l-0.39,-1.05l-2.06,-1.35l-1.26,0.44l-2.75,3.06l-0.55,0.07l-2.26,-3.03l-4.31,-1.22l-1.14,0.13l-1.23,0.71l-3.75,0.5l-4.68,1.54l-1.99,0.16l-2.26,-0.8l-1.02,-1.0l-1.36,-0.45l-0.27,-0.97l-1.39,-1.16l-0.66,-0.99l-0.32,-1.14l0.13,-1.21l-0.54,-0.42l-2.76,0.82l-1.36,-0.14l-0.79,-1.35l-3.39,-1.83ZM309.0,601.52l-0.8,-0.16l-0.41,-0.99l0.4,-2.01l0.84,-0.4l0.79,0.28l0.31,0.77l-0.59,2.03l-0.54,0.47ZM307.75,607.5l-0.9,-0.16l-0.53,-1.24l0.07,-0.86l1.14,-1.14l1.03,0.52l0.48,1.4l-0.86,1.31l-0.43,0.15Z",name:"Midi-Pyr\xe9n\xe9es"},"FR-M":{path:"M625.46,127.51l1.43,-1.72l0.37,-3.32l1.33,-1.31l1.39,0.12l2.52,1.66l3.7,-0.04l0.91,1.24l0.89,0.23l1.45,-0.59l3.12,-2.32l2.22,-1.14l0.23,-0.81l2.9,4.42l0.2,1.33l-0.26,1.48l0.43,0.93l1.59,0.5l4.36,-2.2l2.36,0.84l1.04,-0.1l1.27,-1.8l1.33,-0.57l3.92,0.99l0.96,-0.3l1.37,-1.14l2.44,0.88l3.06,3.02l1.61,0.63l3.79,0.76l0.99,0.85l0.81,2.18l0.48,0.25l7.2,-0.85l1.6,-1.26l0.33,-1.21l1.94,-0.22l0.21,-0.79l2.88,-0.27l3.24,0.68l4.79,2.7l1.85,0.15l2.29,-0.93l0.53,0.08l5.52,2.34l0.95,0.78l0.43,1.78l3.49,3.43l-1.28,0.51l-0.34,1.05l0.39,0.92l5.12,4.46l-0.0,1.31l1.48,0.85l1.03,2.86l0.65,0.17l0.76,-0.38l0.24,0.78l-0.46,1.9l1.04,1.55l0.86,0.29l2.67,0.02l2.33,0.73l0.97,-0.14l1.37,-1.65l-0.67,-2.53l0.24,-0.75l2.79,0.42l1.85,-0.14l4.34,1.88l1.09,0.08l-0.03,2.41l0.73,2.3l1.51,1.11l2.29,-0.99l0.3,-0.66l-0.21,-0.77l0.26,-0.22l2.39,1.43l1.98,0.72l5.31,0.06l2.06,0.7l0.67,-0.41l0.98,-1.46l2.37,-0.6l0.98,-1.9l2.23,-0.77l0.85,0.06l0.55,0.9l3.47,0.42l0.22,0.64l-0.49,0.46l-0.0,0.71l3.02,3.51l1.57,0.84l2.62,0.39l1.24,0.55l1.04,1.49l0.76,0.49l-3.08,5.46l-1.37,1.52l-0.94,0.11l-3.4,-1.65l-9.1,1.22l-2.18,-0.77l-0.57,-1.35l-0.66,-0.54l-8.43,-2.52l-0.63,-0.69l-0.91,-2.92l-0.57,-0.54l-1.78,-0.23l-0.82,0.7l0.24,1.88l-2.13,2.71l-0.26,1.81l-2.5,1.95l-1.3,1.8l-0.19,1.8l1.06,1.59l1.44,0.92l4.74,1.76l-0.95,1.04l-0.38,1.39l0.94,0.93l1.0,1.94l1.42,0.25l0.69,-0.4l1.03,-1.48l2.22,-0.91l0.43,-0.63l0.2,-1.32l0.37,-0.29l0.49,1.78l1.97,0.95l3.4,3.32l0.72,1.3l-0.22,0.99l-3.01,4.58l0.29,1.21l1.86,1.19l-1.37,4.37l-0.81,1.56l-2.88,1.68l-1.19,1.51l-5.74,0.33l-0.8,0.54l0.08,0.68l3.1,1.47l-0.94,1.25l-0.59,7.58l-0.83,2.66l0.2,0.77l0.64,0.72l1.31,0.51l3.22,0.15l1.04,0.99l-0.01,0.68l-7.65,10.83l-0.6,1.6l0.78,1.75l-0.29,1.31l-1.35,1.61l-3.07,5.74l-3.51,4.22l-0.66,3.17l-1.52,2.73l-0.12,0.74l0.62,1.74l-0.37,0.95l-2.1,1.11l-2.1,-0.03l-6.14,-4.25l-3.36,-1.49l-2.89,-3.05l-1.0,-0.52l-0.66,-0.08l-0.72,0.37l-1.82,2.29l-2.17,0.57l-2.22,-0.33l-5.28,-2.92l-2.42,-0.87l-3.37,0.19l-1.11,0.31l-1.36,0.92l-2.15,0.18l-3.33,-1.51l-0.16,-1.78l-1.1,-1.33l-1.36,-0.79l-2.91,-0.55l-2.05,0.41l-2.72,2.89l-3.08,1.95l0.04,-2.28l-0.66,-0.67l-1.05,0.29l-1.69,2.58l-1.46,0.73l-2.76,-2.68l-1.27,0.12l-1.23,0.64l-0.33,-0.86l0.11,-2.75l-0.67,-1.26l-3.49,-1.97l-4.37,-3.63l0.64,-1.84l1.18,-2.01l0.51,-2.47l1.45,-1.47l-0.59,-1.48l-3.47,-2.4l-0.38,-2.37l-1.66,-0.99l-2.42,0.04l-3.01,-3.86l-1.79,-1.42l-2.05,-0.06l-0.71,0.34l-0.86,1.14l-0.51,0.13l-0.78,-3.46l1.95,-2.86l-0.09,-0.52l-6.01,-4.85l-0.81,-1.57l-1.66,-0.59l-3.06,-0.26l-4.93,-2.41l-4.26,-3.07l-2.86,-1.34l-2.73,-2.16l-1.13,-2.11l-0.28,-2.43l-0.47,-0.59l0.07,-2.24l-0.69,-2.27l-4.34,-3.29l-0.25,-0.79l1.32,-1.97l0.19,-0.77l-0.65,-2.29l0.44,-2.23l0.86,-1.22l2.6,-0.67l1.38,-0.95l0.61,-1.14l0.15,-3.39l0.86,-1.2l-0.06,-0.86l-0.53,-0.77l-2.02,-1.13l-0.4,-5.12l-1.78,-5.41l1.45,-2.76l-0.02,-2.07l4.21,-3.39l0.13,-1.1l-0.75,-1.69l-0.03,-0.85l3.33,-4.34l1.37,-3.47l-0.92,-3.48l-1.1,-0.9l-0.58,-1.83Z",name:"Lorraine"},"FR-L":{path:"M466.64,420.7l1.53,1.68l0.51,1.09l0.04,1.47l-0.38,2.56l-2.25,1.27l-1.06,3.12l0.17,0.96l1.69,2.26l0.25,4.1l1.11,1.0l-1.72,5.84l-0.79,0.43l-1.66,-0.23l-3.58,-1.66l-1.74,0.31l-0.64,0.49l-0.08,0.65l0.95,0.93l0.15,0.84l-1.24,2.6l-1.06,0.64l-1.96,2.84l-3.1,1.35l-0.66,2.04l-2.65,2.08l-0.16,1.81l0.96,1.75l-0.04,1.26l-2.76,5.43l-2.8,2.03l-0.55,0.87l-0.03,0.76l1.6,2.88l-0.03,0.57l-4.22,1.17l-4.52,0.2l-1.94,0.88l-1.38,-0.66l-0.83,-0.05l-4.06,1.88l-3.12,0.95l-1.84,-0.16l-3.13,-1.86l-1.24,-1.82l-2.13,-1.68l-3.13,-1.75l-1.92,-0.51l-2.06,0.56l-0.77,-1.17l-0.7,-0.11l-3.75,2.17l-0.61,-0.97l-1.41,-1.24l-1.53,-2.72l-0.16,-1.05l0.45,-2.03l-0.39,-0.62l-0.76,-0.29l-4.04,0.01l-2.3,-1.35l0.63,-1.67l-0.11,-1.33l-0.77,-0.68l-2.16,-0.11l-0.08,-0.41l0.38,-0.66l2.04,-1.69l0.24,-0.77l-0.56,-0.85l-1.64,-1.1l-0.2,-0.71l0.58,-2.22l1.28,-0.93l0.89,-1.14l1.62,-0.95l0.73,-1.57l-0.68,-1.0l-1.94,0.2l-0.72,-0.38l-0.05,-0.67l1.19,-2.28l-0.4,-0.95l-0.62,-0.34l-1.14,-0.01l-1.8,-1.23l-1.97,0.24l-3.97,-1.86l0.03,-0.66l1.79,-1.66l-0.01,-0.89l-0.47,-0.61l-4.39,-1.12l-0.97,-0.93l-2.29,-3.4l-1.31,-0.83l-2.45,0.18l-2.21,-0.25l-2.58,0.48l-1.36,-0.83l-0.67,0.19l-1.04,1.31l-1.45,0.33l-2.83,-0.83l-0.3,-0.61l0.69,-2.75l-0.24,-0.72l-1.36,-1.56l-1.63,-1.17l-2.67,0.03l-1.56,-0.28l-0.84,-0.59l1.24,-2.69l2.24,-1.82l1.25,-1.95l1.82,0.71l1.43,-0.0l1.03,-0.91l0.59,-1.88l0.92,-7.22l3.93,-0.81l2.62,-1.86l0.48,-0.93l-0.03,-0.82l-2.06,-3.42l-0.65,-0.47l-1.46,0.4l-0.62,-0.18l-2.23,-2.92l-0.09,-2.84l-0.51,-2.08l1.19,-0.01l0.56,-1.09l-0.6,-2.96l-1.3,-2.02l-0.18,-1.29l2.22,-0.61l4.13,-3.21l3.91,-0.02l1.37,-0.47l0.49,-0.56l0.37,-1.36l2.95,-3.54l1.62,-0.7l2.72,-0.12l2.77,-1.57l3.18,1.35l1.69,0.1l3.59,-0.55l1.16,-1.42l1.05,-0.24l1.47,1.8l3.13,1.64l2.0,-1.13l3.93,-3.54l0.68,-0.15l2.17,0.53l2.02,-0.06l0.36,1.35l0.7,0.52l1.01,0.19l1.02,-0.2l1.87,-1.33l3.01,0.41l0.9,-0.2l1.03,-0.98l0.25,-2.59l0.71,-0.54l0.76,0.32l1.92,1.93l0.96,0.16l2.07,-1.12l1.08,-0.24l5.41,0.14l2.45,0.84l3.5,0.01l2.22,0.72l3.19,-0.59l5.83,0.29l2.01,2.5l1.67,1.44l0.91,2.78l0.59,0.64l0.74,0.43l2.88,0.63l0.67,0.63l1.08,2.07l0.77,0.02l0.86,-0.61l1.19,0.76l2.45,3.45l1.01,3.07l2.11,3.67l-0.39,3.35l0.22,1.7l1.9,3.38l0.17,1.11l-0.16,2.92l-1.62,1.78l-1.56,3.24l-2.36,2.46l-2.3,0.1l-4.07,3.26l0.03,1.36l1.66,2.11l0.73,2.07l0.5,0.47l1.47,0.35l1.17,1.12Z",name:"Limousin"},"FR-S":{path:"M415.84,70.92l0.57,0.0l0.4,-0.4l0.0,-0.59l-0.39,-0.4l-2.26,-0.33l-0.8,-0.54l-1.15,-2.03l-2.54,-1.04l-0.42,-0.47l0.59,-5.43l1.08,-1.83l1.5,0.42l1.69,1.73l1.56,0.75l1.81,0.01l3.71,-1.21l3.67,-0.22l0.86,0.15l1.05,0.68l1.93,2.02l1.13,0.56l1.08,-0.04l1.34,-1.04l0.83,-0.09l0.45,0.32l-0.93,1.21l0.23,1.04l6.67,3.17l0.5,0.49l0.08,1.01l0.75,1.43l1.04,0.93l0.98,0.39l8.82,-0.48l3.92,-0.85l1.24,-1.53l1.52,1.73l0.76,0.31l0.74,-0.23l0.76,-0.74l1.3,0.11l2.71,1.26l0.54,0.67l-4.33,2.61l-0.9,1.01l-0.44,1.09l-0.02,1.24l0.39,1.17l1.04,1.19l0.98,0.26l0.75,-0.29l1.56,-2.2l2.16,-0.19l2.38,0.33l1.34,-0.69l1.45,-0.17l0.19,0.32l-0.33,1.26l0.52,0.66l3.45,0.68l2.92,1.4l1.0,0.18l0.86,-0.76l-0.13,-1.95l0.49,-1.31l1.67,1.4l1.14,1.83l0.06,0.74l-1.28,1.91l0.29,0.94l0.77,0.38l0.95,-0.07l3.86,-2.53l0.65,0.79l0.19,2.96l0.68,0.44l0.89,-0.08l2.17,-1.19l3.76,-0.4l0.75,-1.0l-0.04,-1.56l0.65,-0.42l2.34,0.28l7.91,4.34l4.18,-0.82l1.83,0.05l3.72,0.8l0.96,-0.15l1.87,-0.98l5.14,1.35l1.1,-0.07l3.93,-1.62l1.69,-1.03l0.9,0.04l2.79,0.99l0.93,-0.14l3.23,-1.67l0.73,-0.05l3.32,0.71l6.2,0.65l1.83,1.69l0.78,0.18l3.05,-1.51l1.71,-0.23l0.41,0.51l-0.04,2.45l0.93,0.94l5.29,1.74l1.22,0.15l1.87,-0.46l3.32,1.51l1.54,0.17l0.08,2.76l1.98,3.57l-0.12,1.06l-1.86,3.26l-0.49,2.91l0.31,0.92l0.9,0.74l0.32,1.65l-0.7,1.08l-3.14,2.62l-1.8,1.1l-1.44,2.0l-1.21,0.65l-2.01,0.15l-1.16,1.07l0.06,0.89l1.48,3.98l-0.45,1.42l0.37,2.06l-1.37,1.28l-0.45,0.95l0.11,0.84l1.61,2.67l-1.45,0.55l-0.75,1.27l0.2,0.5l0.68,0.33l0.4,0.93l-0.07,1.86l-0.63,1.32l-0.79,0.0l-1.69,-0.75l-2.03,0.68l-2.88,-1.37l-2.38,-0.13l-1.45,0.91l-0.06,1.82l-4.11,0.52l-5.16,1.25l-3.39,1.78l-0.06,0.98l0.85,1.81l0.67,5.15l0.51,0.49l1.41,0.26l2.36,2.15l-0.2,0.54l-0.95,0.74l-1.13,0.21l-3.3,-0.33l-1.51,0.77l-0.45,1.51l0.35,1.68l-0.15,1.05l-0.98,1.37l-1.47,1.05l-0.1,1.7l0.34,0.61l1.16,0.44l3.19,-0.1l0.6,0.44l-0.02,0.44l-2.28,1.99l-0.73,1.1l-1.76,1.18l-1.05,2.05l-3.83,3.24l-2.02,3.25l-2.26,0.11l-3.0,-1.67l-0.43,-0.63l-0.47,-2.75l-0.76,-0.9l-0.81,-0.01l-0.99,0.47l-0.51,-0.14l-8.73,-6.6l-0.51,-1.18l0.6,-1.73l-0.09,-0.9l-0.97,-1.91l-1.19,-1.29l-3.91,-1.13l-2.27,1.08l-1.86,0.05l-1.84,1.04l-1.74,-0.79l-5.87,1.07l-4.04,-0.91l-0.77,0.16l-1.31,1.18l-0.79,0.15l-2.03,-1.11l-1.93,0.48l-1.66,-1.34l-1.69,-0.39l-2.67,0.99l-1.08,-0.76l-1.25,-1.57l-0.8,-0.23l-1.37,0.39l-10.67,-5.04l-1.18,-0.26l-1.21,0.29l-2.01,1.11l-1.55,-0.09l-3.94,-1.5l-2.4,-0.25l-1.47,-0.68l-1.66,-1.28l-0.74,-0.17l-1.89,0.7l-3.44,2.04l-4.01,0.26l-2.09,0.47l-5.65,-1.4l-2.68,-0.11l-1.23,-0.58l-0.69,-1.87l-0.93,-0.84l-0.28,-0.86l-0.07,-0.43l0.7,-0.94l0.92,-0.28l0.45,0.19l1.28,1.38l0.8,0.35l0.78,-0.08l0.66,-0.55l-0.41,-1.62l-1.62,-3.45l-1.74,-5.57l-0.28,-3.2l1.24,-3.11l1.48,-1.09l0.51,-1.75l-0.83,-1.22l-2.26,0.41l-0.42,-0.32l-0.42,-3.51l-0.53,-1.76l-0.18,-3.85l-0.71,-1.37l2.2,-1.38l0.74,-1.07l0.26,-1.01l-0.65,-0.89l-2.49,0.44l-0.22,-0.26l2.37,-3.65l2.12,-1.58l0.03,-1.31l-2.65,-4.66l-0.9,-3.09l-1.01,-1.33l-10.08,-8.97l-8.3,-4.93l5.17,-5.05l1.41,-4.28l1.94,-2.2l1.85,-0.21l5.97,2.46l0.78,-0.01l0.75,-0.53l0.14,-0.85l-1.42,-0.64Z",name:"Picardie"},"FR-R":{path:"M159.66,300.12l3.14,1.13l1.62,-0.32l1.05,-1.07l0.07,-0.47l-0.56,-1.04l-2.21,-2.2l-0.46,-0.11l-0.82,0.44l-0.77,-1.59l-2.05,-1.2l4.12,-2.13l1.57,0.33l-0.09,0.55l0.45,0.48l0.58,0.01l2.59,-1.53l0.4,-0.74l-0.31,-0.53l-2.95,-0.38l0.35,-0.69l-0.16,-0.53l-0.77,-0.68l0.87,-0.21l2.37,0.81l3.21,-0.37l0.81,-0.45l0.88,-1.05l1.08,-1.85l0.93,-0.29l1.83,0.9l2.88,-0.91l0.01,0.96l0.41,0.72l0.57,0.29l0.85,-0.14l0.92,-1.04l0.66,-1.38l2.05,-1.24l0.71,-1.09l0.79,-3.53l0.74,-1.69l0.12,-1.43l-0.24,-0.62l0.35,-1.02l2.91,-1.59l2.21,-0.38l2.07,0.05l5.67,-2.08l1.82,0.61l1.95,0.17l7.4,-2.04l2.87,-1.7l1.19,-1.55l1.73,-1.21l6.3,-2.55l1.6,-1.15l1.76,-0.13l1.82,0.29l1.17,1.44l1.85,0.86l6.14,0.89l0.45,-0.31l0.47,-2.16l1.14,-1.77l2.89,-9.08l0.53,-0.9l1.85,-1.62l4.09,-0.58l1.25,-0.49l0.67,-0.66l-0.07,-4.84l-1.76,-2.27l-0.71,-4.7l0.64,-0.86l0.08,-0.99l-0.82,-4.82l-1.09,-2.36l1.95,-4.01l-0.03,-2.5l-0.74,-5.78l0.2,-5.45l4.76,0.37l3.56,-1.09l2.14,0.78l2.29,-0.33l0.82,0.61l1.89,3.04l0.78,0.28l1.22,-0.43l1.2,1.0l0.96,0.2l0.9,-0.36l0.74,-1.34l3.16,-0.79l0.67,0.27l0.43,0.85l0.82,0.32l5.49,-1.07l1.32,-0.69l2.1,-1.96l0.92,-0.33l3.75,0.17l4.09,0.95l1.06,-0.14l1.34,-1.53l1.33,-0.41l1.5,0.0l1.45,-0.72l0.62,-1.2l-0.17,-1.13l0.3,-0.28l3.98,1.51l0.19,0.36l-0.49,1.44l0.18,1.02l0.67,1.13l3.2,2.92l2.03,0.53l0.36,0.46l0.28,0.51l0.24,3.91l0.44,0.37l3.61,-0.38l3.37,0.46l0.6,-0.45l0.44,-1.41l2.46,-0.81l2.23,-2.53l2.43,-1.15l5.27,-1.07l1.66,0.18l3.55,1.66l0.35,1.07l-0.32,2.68l0.3,3.32l0.87,2.03l1.63,1.4l1.84,0.94l2.82,-0.07l0.41,2.48l1.13,0.63l5.3,1.27l2.3,0.07l0.97,-0.32l1.62,1.39l1.93,2.55l2.19,1.39l1.53,0.31l1.53,-0.36l2.97,1.92l3.09,0.38l0.63,0.45l-0.41,0.52l-4.24,2.22l-0.26,1.28l1.21,1.18l-2.67,0.5l-0.56,0.47l-0.11,1.1l0.84,1.7l0.5,0.5l1.48,0.31l-0.65,3.22l0.42,1.92l-0.15,0.49l-3.53,3.05l-0.56,1.67l-0.05,3.43l-1.51,4.18l-1.33,1.2l-1.74,0.98l-3.44,1.47l-1.46,1.3l-0.79,1.81l0.64,1.76l-0.14,0.45l-2.17,0.43l-3.23,1.43l-2.52,0.52l-1.04,0.58l-0.9,0.99l-1.95,-0.85l-1.07,0.0l-0.78,0.53l-0.36,0.7l0.4,2.57l-8.48,-1.68l-0.46,0.23l-1.7,4.29l0.46,3.58l-1.91,3.72l-1.03,3.13l0.2,2.82l-4.39,6.08l-1.47,5.38l-0.85,5.56l-2.84,-0.47l-1.46,0.44l-2.01,2.22l-0.96,2.4l-2.38,0.81l-1.53,2.05l-1.11,-0.31l-0.83,-2.02l-0.97,-0.76l-0.79,-0.2l-1.88,0.35l-3.55,-0.08l-6.53,0.7l-5.83,1.67l-2.05,-0.73l-2.08,0.46l-1.21,0.8l-0.31,0.62l0.12,0.77l0.69,0.97l-0.13,0.38l-4.92,2.46l-3.85,0.33l-5.2,-0.68l-4.23,0.56l-4.16,-1.9l-0.94,-0.18l-0.84,0.51l-0.29,1.01l0.17,0.47l2.2,1.37l2.18,3.03l1.67,0.89l0.69,0.84l0.32,2.18l1.04,2.25l0.66,0.7l3.5,1.91l1.73,1.57l0.1,0.48l-0.78,1.59l0.1,0.98l3.83,6.52l0.57,3.11l1.44,2.21l0.79,4.91l-1.22,1.54l-0.25,0.91l0.97,4.27l-0.6,2.86l0.25,1.23l0.83,0.72l1.04,-0.23l1.97,1.38l0.71,1.02l-0.74,0.77l-1.26,-0.1l-1.22,0.34l-2.25,2.0l-2.76,0.16l-3.62,1.68l-4.06,-2.24l-1.7,-0.27l-6.67,1.09l-0.44,-0.27l0.9,-1.15l0.15,-0.7l-0.48,-0.9l-0.77,-0.24l-6.96,1.54l-1.16,0.7l-1.12,1.42l-0.75,-0.72l-2.95,-0.11l-2.27,1.19l-0.16,2.27l-1.02,-0.24l-2.4,-2.73l-1.56,-0.33l-4.08,-2.32l-3.43,0.87l-1.24,-0.06l-0.97,-3.42l-1.1,-1.51l-1.55,-0.91l-6.9,-0.76l0.18,-1.01l-1.0,-0.83l-3.36,-0.58l-1.97,-1.51l-2.47,-0.81l-1.08,-2.24l-0.58,-0.83l-0.45,-0.15l-0.28,0.39l0.27,2.62l-0.46,-0.56l-1.32,-5.47l0.25,-1.25l-0.25,-0.45l-0.84,-0.31l-1.14,-2.75l-2.53,-2.31l-0.74,-2.09l-0.93,-0.62l-1.98,-0.4l-2.24,-3.59l-3.47,-3.13l-4.07,-2.07l-0.39,-1.05l-0.3,-2.69l0.47,-2.19l1.48,-0.93l0.17,-0.46l-0.28,-0.85l3.12,-1.98l2.48,-5.26l1.17,-1.01l-0.16,-1.45l-0.69,-1.37l-1.7,-1.83l-3.77,-1.84l-7.12,-1.1l-1.45,-0.69l1.47,-1.03l1.91,-0.24l0.8,-0.55l0.42,-2.94l-0.66,-1.35l-0.09,-1.84l1.02,-2.31l1.32,-0.5l5.58,-0.5l1.1,-0.5l1.01,0.86l3.14,0.71l1.04,-0.02l0.24,-0.51l0.65,0.2l-0.47,0.4l0.19,0.91l2.51,1.59l2.62,0.48l1.97,1.62l1.54,0.57l3.31,0.09l0.4,-0.29l-0.19,-0.46l-1.37,-0.76l-2.42,-0.42l-2.85,-2.6l-4.32,-2.68l-2.78,-0.52l-1.38,-0.93l-2.33,-0.59l-8.74,0.54l-2.06,1.13l-1.5,1.94l-1.74,0.44l-1.54,1.27l-1.02,0.36l-2.05,-0.36l-2.32,-2.13l-1.22,-0.61l-2.17,0.0l-0.78,0.6l-0.33,0.97l-1.39,-0.03l-4.87,-2.21ZM161.53,297.57l0.02,0.14l-0.01,0.02l-0.01,-0.17ZM179.99,325.41l2.68,1.47l0.24,2.88l-0.47,-0.24l-2.28,-3.55l-1.56,-0.93l-1.75,0.59l-0.73,-0.9l-0.93,-2.89l-0.56,-0.68l2.62,-0.12l2.02,0.71l-0.04,2.78l0.75,0.89ZM174.33,345.92l-4.93,-0.12l-0.49,-0.98l0.24,-0.36l1.99,0.02l3.18,1.44Z",name:"Pays de la Loire"},"FR-Q":{path:"M332.92,132.9l6.77,-1.3l2.9,-1.25l1.33,-1.0l1.02,-1.19l0.01,-0.51l-0.5,-0.1l-4.29,2.28l-4.93,0.6l-4.99,-0.57l-4.35,-1.26l-2.37,-0.09l-2.42,-0.92l-0.79,-1.28l-0.73,-0.42l-0.07,-1.2l3.27,-5.32l2.46,-7.02l0.83,-0.83l2.93,-1.99l9.31,-3.67l0.73,-0.8l7.56,-3.82l2.18,-0.58l2.37,-1.37l4.68,-1.45l5.32,0.04l25.22,-6.87l1.56,-1.02l1.59,-0.51l2.41,-2.26l6.63,-4.5l8.53,5.05l10.02,8.92l0.82,1.05l0.92,3.13l2.61,4.54l0.05,0.66l-1.49,0.92l-2.71,3.56l-0.4,1.2l0.44,0.98l2.53,-0.43l0.4,0.34l-0.82,1.37l-1.94,1.09l-0.47,0.89l0.74,1.37l0.19,3.89l0.54,1.79l0.44,3.63l0.8,0.82l2.01,-0.46l0.65,0.53l-0.4,1.31l-1.05,0.52l-0.44,0.58l-1.34,3.49l0.3,3.4l1.76,5.64l1.98,4.52l-0.91,-0.06l-0.81,-0.99l-1.21,-0.74l-0.85,0.03l-0.88,0.48l-0.92,1.37l0.38,1.6l-1.77,3.08l-2.9,8.4l-2.17,1.01l-7.75,1.57l-0.75,0.55l-0.17,1.05l0.69,1.52l-0.24,2.26l0.57,0.74l1.67,0.42l0.21,2.28l-2.16,1.15l-0.44,0.6l-0.21,0.94l0.52,1.61l-0.14,1.15l-0.79,0.76l-2.47,1.15l-1.51,1.17l-1.09,1.61l-0.67,1.82l-0.53,0.5l-4.82,2.29l-1.94,-0.6l-3.38,0.04l-2.24,-1.49l-1.25,-0.15l-0.48,0.48l-0.06,1.17l-0.31,0.42l-3.47,0.34l-2.42,2.37l-1.92,0.04l-5.91,1.45l-1.53,0.88l-1.84,1.69l-2.56,-0.94l-1.25,-1.56l-1.01,-0.49l1.29,-1.62l0.54,-1.51l-1.16,-2.36l-1.26,-0.82l-2.33,-0.57l-1.49,-0.86l-2.76,-3.3l-0.98,-2.3l-0.73,-0.39l-0.92,0.06l-2.15,0.77l-4.68,-1.11l-2.05,0.04l-1.25,-0.79l-0.53,-1.28l1.85,-3.58l0.27,-4.11l-0.86,-1.45l-2.12,-1.54l-0.49,-1.34l0.35,-0.36l1.57,0.06l0.59,-0.55l-0.39,-2.41l0.87,-2.03l-1.68,-3.19l-0.73,-2.11l-2.48,-2.25l-0.45,-0.94l0.06,-0.6l2.03,-0.96l0.42,-0.91l-0.82,-1.2l-2.45,-0.56l-1.1,-1.77l-0.07,-6.22l-0.51,-3.02Z",name:"Haute-Normandie"},"FR-P":{path:"M215.0,114.74l0.19,0.68l0.67,0.4l0.84,-0.17l1.4,-0.93l2.84,0.51l1.15,-0.47l3.33,-3.1l2.74,-0.72l1.03,-0.08l7.56,1.27l2.02,5.19l-1.5,1.01l-0.48,1.56l-1.27,0.04l-1.1,0.67l-0.37,2.34l1.83,2.99l0.97,2.27l4.63,4.95l0.53,1.09l0.2,1.62l-0.75,1.97l0.17,1.08l0.44,0.3l1.7,-0.5l1.69,1.31l1.46,-0.25l0.31,-0.93l-0.57,-0.85l0.33,-0.79l0.91,-0.85l0.91,-0.36l7.94,0.35l7.3,2.35l10.46,0.54l4.16,0.79l2.31,-1.02l4.08,1.27l4.12,0.0l2.91,1.4l3.03,0.6l5.69,2.93l1.91,-1.18l9.72,-1.95l2.93,-1.18l1.7,-1.25l1.45,-0.37l2.06,-2.35l3.94,-2.42l7.63,-1.46l0.5,2.91l0.12,6.48l1.43,2.16l2.42,0.54l0.46,0.57l-0.57,0.58l-1.68,0.72l-0.23,1.35l0.62,1.25l2.42,2.18l0.67,1.99l1.6,2.88l-0.85,1.84l0.42,2.29l-1.99,0.1l-0.58,1.01l0.65,1.85l2.18,1.62l0.66,1.06l-0.25,3.74l-1.86,3.57l0.32,1.58l2.02,1.5l2.14,-0.02l4.66,1.11l0.81,0.01l2.32,-0.82l0.53,0.56l0.61,1.79l2.9,3.45l1.71,1.0l2.29,0.55l0.97,0.6l0.98,1.74l-0.43,1.2l-1.34,1.44l0.1,1.13l1.12,0.58l1.33,1.63l2.71,1.01l0.4,3.39l1.71,2.99l2.69,1.76l3.44,3.47l-0.31,2.12l0.17,1.43l1.87,2.7l-1.12,1.47l-0.63,1.57l-1.95,1.77l-1.26,0.69l-4.1,1.48l-2.34,0.41l-0.89,1.14l-0.23,0.89l0.24,0.83l1.14,1.2l-0.05,2.88l1.62,2.66l0.1,1.08l-1.39,1.01l-1.56,0.37l-1.1,-0.24l-1.99,-1.26l-1.87,-2.49l-1.91,-1.6l-3.5,0.2l-5.14,-1.24l-0.71,-0.36l-0.06,-1.74l-0.56,-0.94l-3.09,-0.02l-1.57,-0.82l-1.44,-1.23l-0.72,-1.73l-0.28,-3.11l0.32,-2.72l-0.45,-1.45l-1.38,-1.0l-2.69,-1.04l-1.94,-0.2l-5.54,1.15l-3.07,1.61l-1.67,2.12l-2.54,0.86l-0.71,1.68l-2.54,-0.46l-3.9,0.33l-0.22,-3.58l-0.39,-0.79l-0.77,-0.81l-1.89,-0.44l-3.02,-2.76l-0.65,-1.6l0.49,-1.46l-0.32,-0.81l-0.74,-0.61l-3.82,-1.27l-0.99,0.47l-0.03,1.62l-0.34,0.71l-1.15,0.57l-1.4,-0.02l-1.63,0.51l-1.2,1.45l-0.68,0.11l-4.11,-0.95l-3.98,-0.16l-1.2,0.44l-2.14,1.99l-1.05,0.56l-5.18,1.05l-1.18,-1.31l-0.96,-0.14l-3.52,0.92l-0.5,1.08l-0.81,0.48l-1.68,-1.15l-1.86,0.23l-1.74,-2.89l-1.1,-0.85l-2.45,0.29l-2.37,-0.8l-3.57,1.1l-2.0,0.01l-3.01,-0.43l-2.56,-1.35l-7.85,-1.68l-1.41,0.23l-2.22,2.41l-1.99,0.71l-2.78,1.91l-1.65,0.53l-2.09,-0.17l-2.56,-1.81l-2.2,-3.13l-0.99,-2.96l-2.54,-5.28l4.98,0.51l6.48,-1.24l2.14,0.69l0.44,-0.14l0.0,-0.47l-1.13,-1.5l-1.5,-0.64l-2.34,-0.18l-0.46,0.44l-0.7,-1.34l-2.87,-0.97l-0.88,-2.35l-2.17,-1.65l-0.47,-1.69l-0.34,-4.2l-0.74,-1.24l-1.4,-0.44l1.45,-1.15l0.44,-1.03l0.49,-3.71l0.92,-0.11l0.34,-0.9l0.0,-1.07l-1.2,-0.91l0.97,-5.38l0.51,-0.24l1.33,0.54l0.55,-0.37l-0.25,-0.86l-1.33,-0.51l-1.38,0.0l-1.32,0.6l-0.59,1.22l-0.56,-1.29l0.43,-3.35l-0.31,-0.52l-0.67,-0.12l-0.18,-0.32l0.72,-2.62l1.48,-1.06l0.02,-0.68l-0.75,-0.5l-0.56,0.09l-0.66,-2.09l-0.35,-2.8l0.3,-0.47l0.85,-0.05l2.15,0.54l0.5,-0.39l0.0,-0.49l-0.3,-0.39l-2.96,-0.99l-1.32,-0.03l-0.67,1.15l-0.44,-0.44l-0.98,-2.84l-0.71,-0.78l0.42,-0.24l0.06,-0.7l-2.38,-1.94l-0.24,-0.63l0.68,0.0l0.4,-0.4l-0.83,-2.29l-0.82,-0.22l-0.71,1.2l-3.02,-2.14l0.32,-0.66l-0.42,-0.61l-2.16,0.52l-0.37,-0.34l-0.17,-5.35l-1.15,-1.92l-0.39,-1.49l-2.39,-2.79l0.28,-0.81l1.64,-1.27l0.51,-0.95l0.27,-4.14l-1.3,-2.8l-0.63,-0.67l-4.47,-1.27l0.4,-1.53l-0.1,-1.22l0.13,-0.3l1.34,-0.15l2.46,1.07l1.75,-0.2l0.58,0.33l0.27,1.01l0.5,0.53l6.68,0.92l5.27,1.29Z",name:"Basse-Normandie"},"FR-V":{path:"M577.55,476.22l1.11,-1.41l2.95,-0.55l0.74,-0.72l-0.0,-0.72l-1.19,-1.6l2.16,-2.5l-0.86,-2.16l1.27,0.23l1.38,1.13l0.92,-0.02l0.45,-0.42l0.63,-2.87l1.73,-3.35l0.28,-1.44l-0.16,-0.88l-3.03,-2.6l-1.46,-0.75l-2.03,-0.16l-1.01,-0.41l-0.84,-2.02l0.79,-1.98l-0.44,-1.83l-1.29,-2.03l-1.55,-0.99l-2.48,1.54l-4.06,-1.11l-2.36,0.02l-0.64,0.32l-0.28,1.19l-0.59,0.59l-5.7,0.96l-2.47,0.09l-1.61,-1.66l-0.73,-0.21l-2.27,0.68l-1.46,1.14l-0.41,-0.24l-0.18,-0.38l0.57,-2.63l0.71,-1.31l2.82,-2.97l0.97,-2.32l-0.07,-1.42l-2.55,-5.63l-7.56,-6.05l-3.13,-6.33l-0.58,-0.9l-1.05,-0.64l-1.72,-2.72l-0.04,-0.59l0.91,-1.9l0.0,-2.12l0.88,-1.58l0.32,-1.57l-0.57,-1.38l-2.48,-1.95l-0.33,-0.83l0.19,-0.43l2.19,-1.04l4.84,-1.05l0.92,-0.65l0.52,-0.86l-0.92,-6.28l-0.68,-2.16l0.16,-3.93l-0.45,-3.2l-1.16,-1.77l2.62,-2.04l4.12,-1.28l0.56,1.52l-0.19,2.42l0.26,0.72l1.01,0.63l2.01,0.62l2.22,1.54l1.84,0.08l4.06,-1.25l4.13,0.93l2.99,-0.65l5.98,1.31l2.65,-0.78l1.66,-1.21l1.81,-2.14l1.71,-5.14l5.06,1.43l1.25,-0.12l1.94,-0.93l1.54,1.64l0.93,0.37l1.05,-0.11l0.65,-0.45l0.57,-1.97l0.55,-0.28l1.79,0.68l0.27,1.99l1.62,1.08l0.05,2.15l1.07,2.48l1.36,0.98l3.59,0.4l0.43,-0.51l-0.22,-1.1l1.28,-4.71l3.52,-6.66l0.17,-1.98l1.46,-2.52l0.86,-4.24l1.47,-3.8l1.76,-0.36l4.28,1.38l1.47,-0.15l3.7,-1.24l1.74,-0.16l1.25,0.39l2.16,1.97l1.64,0.85l4.11,0.99l0.02,2.41l0.61,1.09l1.69,0.58l0.98,0.74l0.72,2.39l1.08,1.11l2.12,0.65l0.91,1.09l1.74,0.37l-0.08,3.17l0.9,0.94l1.79,0.47l2.93,-1.5l1.13,-1.19l1.49,-0.38l0.56,-1.17l2.38,-2.03l2.83,2.21l0.53,0.68l0.4,1.81l0.7,0.56l7.33,0.5l2.1,-0.36l4.85,-3.81l1.29,-1.9l5.29,-5.36l2.71,1.45l1.49,1.81l0.06,0.64l-2.15,4.4l-0.44,3.76l-1.28,0.56l-1.6,-0.08l-5.2,2.4l-0.38,1.48l1.62,2.13l-1.39,2.81l0.08,0.46l0.46,0.07l1.43,-0.74l2.69,-0.56l2.68,-0.09l2.31,0.77l2.11,-0.97l3.09,-3.14l3.94,-2.28l1.58,-1.45l-0.19,-2.13l-0.68,-0.47l-1.16,0.35l-0.4,-0.18l-0.89,-2.03l4.08,-5.7l3.32,0.16l1.15,1.46l0.93,0.33l0.77,-0.37l0.82,-1.0l4.35,-1.83l1.15,-1.48l11.95,-1.05l5.16,0.78l0.08,0.91l-0.38,1.12l-1.55,1.58l-0.38,1.39l1.23,1.83l2.14,1.97l1.23,1.83l-2.07,3.51l-1.08,2.81l-0.54,2.86l0.83,1.53l4.77,0.91l0.69,0.58l-1.17,1.69l0.25,3.27l1.29,0.49l1.46,-0.85l1.18,0.45l4.32,4.17l1.84,4.74l-1.27,1.06l-1.66,3.08l-1.14,0.85l-2.54,0.9l-1.94,0.05l-0.44,1.16l-1.45,-0.68l-2.83,1.09l-0.84,1.25l-0.34,1.34l0.12,2.79l0.7,3.2l1.31,1.78l1.75,1.17l2.44,0.57l2.19,1.73l2.63,0.83l0.29,0.87l-0.98,2.48l1.03,2.1l0.33,3.09l0.49,1.22l5.55,3.27l1.58,2.67l3.72,1.73l-0.54,1.71l-1.23,1.93l-2.31,2.53l0.24,2.49l0.65,1.55l0.0,0.91l-1.6,1.21l-1.33,1.99l-0.85,-0.84l-0.72,-0.2l-4.51,1.48l-2.67,2.94l-2.44,0.32l-0.53,0.84l0.54,1.12l-1.68,0.71l-4.37,-1.72l-2.37,-0.29l-2.05,1.2l-2.07,0.11l-2.41,1.23l-1.98,0.23l-2.21,1.2l-2.35,0.04l-0.74,0.29l-1.11,2.4l-1.35,1.11l-4.34,-1.2l-0.85,-1.84l-1.43,-1.0l-4.05,-0.41l-1.45,-0.84l-0.51,0.04l-1.75,2.08l-1.05,4.98l0.01,1.51l0.51,1.03l1.24,0.41l3.69,-0.43l0.93,0.46l0.56,3.36l1.75,2.0l0.32,1.03l-0.27,3.17l-0.32,0.52l-3.52,-0.79l-3.8,0.98l-1.71,-0.15l-1.86,0.35l-2.28,-0.4l-3.91,2.12l-0.99,0.14l-1.72,-0.45l-2.3,0.93l-1.47,1.08l-0.4,0.64l0.21,1.89l-0.69,0.66l-2.32,0.66l-3.68,0.21l-1.02,0.38l-2.07,2.9l0.34,1.1l0.66,0.51l0.02,0.62l-1.63,1.7l-4.53,1.21l-3.09,-0.29l-1.24,0.51l-0.43,1.87l-2.53,3.81l-0.14,0.94l0.84,1.52l2.0,1.4l0.28,0.97l-0.33,0.33l-3.19,1.81l-4.23,-1.27l-3.35,-0.13l-0.63,0.63l0.07,1.69l0.63,1.09l1.24,0.83l0.0,0.57l-0.98,0.17l-2.3,-0.43l-1.08,0.62l-0.06,0.66l1.42,1.81l0.6,1.94l2.39,1.76l4.27,1.43l3.69,-0.02l-0.41,1.18l0.12,0.71l1.56,1.75l2.09,1.43l-0.14,4.66l-0.66,1.16l0.12,1.87l-0.76,-0.17l-0.63,-1.31l-0.81,-0.55l-1.74,-0.29l-0.98,0.29l-3.26,3.17l-1.73,0.96l-1.95,-0.21l-4.26,-2.77l-0.76,-2.13l-1.01,-1.15l-2.12,-0.25l-4.34,-1.4l-2.82,0.21l-2.6,-0.66l-0.67,-0.77l-0.1,-1.5l0.78,-2.2l-0.29,-0.88l-0.62,-0.28l-2.47,1.42l-4.48,-0.52l-4.27,1.08l-3.5,1.47l-2.77,0.41l-2.98,1.5l-1.01,-0.71l-1.77,-4.15l-1.43,-1.32l-1.13,-0.54l-3.59,-0.26l-1.8,0.22l-0.35,0.4l0.02,2.88l-3.85,-1.27l-2.16,-2.01l-1.82,-0.73l-3.57,0.03l-1.2,0.93l-0.35,1.86l-1.3,0.63l-0.49,-0.12l-0.72,-0.87l0.27,-1.36l-0.32,-0.86l-0.67,-0.41l-0.94,-0.05l-2.47,0.7l-4.94,3.64l-1.17,-0.23l-4.88,-2.4l-1.24,-1.11l-4.78,0.52l-0.65,-3.42l0.81,-1.28l-0.0,-0.88l-1.75,-2.86l-1.71,-1.42l-2.22,-6.93l-0.89,-1.48l-1.35,-0.86l-0.56,-0.98l-0.68,-1.98l-0.52,-3.12l-1.27,-3.49l0.05,-2.72l1.27,-0.58l3.25,-4.5l3.93,-1.27l1.08,-2.19l2.26,0.12l4.33,-0.67l1.51,-0.63l2.02,-2.74l1.34,-3.3l0.62,-0.22l1.42,0.25l2.97,-1.28l0.14,-1.25l-0.57,-1.03ZM619.51,528.65l1.54,-0.89l1.27,-2.18l1.36,-1.26l0.07,-0.97l-0.77,-1.43l-2.49,-2.28l-2.0,-0.54l-1.01,0.36l-0.89,0.76l-3.05,4.55l-0.55,2.1l0.5,1.33l0.7,0.43l5.31,0.04Z",name:"Rh\xf4ne-Alpes"},"FR-U":{path:"M574.87,589.37l0.92,-0.18l1.37,-1.04l2.17,-0.54l3.45,-2.45l1.63,-0.49l0.58,-1.36l1.97,-0.33l0.5,-0.38l0.72,-1.53l-0.09,-0.84l-1.94,-0.6l1.3,-2.75l1.5,-1.9l1.28,-0.92l2.03,-0.52l3.72,1.32l1.03,-0.3l0.65,-1.54l-0.04,-1.78l1.98,-4.92l-0.49,-4.74l5.08,-3.33l2.76,-1.14l1.8,-1.27l1.33,-1.63l0.03,-2.18l1.18,0.07l0.47,-0.43l0.15,-1.04l-0.37,-0.8l-4.15,-4.77l-1.27,-0.56l-1.83,0.31l-0.37,-2.47l0.33,-2.07l-0.19,-2.88l-0.5,-0.93l-1.47,-1.11l-0.09,-1.56l-1.29,-1.64l-0.54,-1.66l-0.02,-2.97l3.17,-0.14l2.43,0.62l1.57,1.66l1.7,4.01l1.31,0.65l1.08,-0.2l2.24,-1.34l2.77,-0.41l3.47,-1.46l4.07,-1.05l3.48,0.59l1.1,-0.08l2.31,-1.4l0.14,0.38l-0.71,1.56l-0.03,1.7l0.31,1.17l0.77,0.67l2.96,0.79l2.82,-0.21l4.22,1.37l1.95,0.19l0.66,0.8l0.94,2.37l4.51,2.92l2.5,0.22l1.96,-1.1l2.53,-2.56l1.32,-0.74l1.8,0.54l0.64,1.31l0.52,0.4l0.87,0.13l0.61,-0.33l0.31,-0.68l-0.23,-1.68l0.64,-1.04l0.14,-4.96l-0.53,-0.87l-1.46,-0.73l-1.74,-1.84l0.47,-1.33l-0.29,-0.71l-1.33,-0.38l-2.81,0.16l-3.98,-1.31l-2.2,-1.6l-0.54,-1.85l-1.31,-1.69l0.85,-0.19l2.33,0.46l0.67,-0.16l0.58,-0.67l-0.17,-1.21l-1.58,-1.26l-0.32,-1.32l0.2,-0.43l2.95,0.15l4.34,1.28l0.95,-0.24l2.8,-1.78l0.61,-0.81l-0.12,-1.02l-0.85,-1.05l-1.56,-0.99l-0.6,-0.98l0.34,-1.04l1.84,-2.49l0.74,-2.54l1.28,-0.26l2.49,0.32l4.9,-1.34l1.9,-1.99l0.0,-1.34l-0.94,-1.02l1.78,-2.52l4.33,-0.43l2.59,-0.77l1.06,-1.17l-0.23,-1.81l1.51,-1.3l1.93,-0.81l1.61,0.45l1.3,-0.18l3.71,-2.08l2.21,0.4l1.91,-0.35l1.7,0.15l3.74,-0.98l2.72,0.76l1.33,-0.13l0.6,-0.99l0.28,-3.45l-0.47,-1.39l-1.68,-1.88l-0.61,-3.45l-1.52,-0.82l-3.62,0.45l-0.92,-0.3l-0.21,-0.57l1.03,-6.05l1.31,-1.51l1.5,0.78l3.9,0.36l1.08,0.74l1.0,1.99l4.33,1.4l1.59,-0.46l0.96,-1.07l0.85,-2.13l2.87,-0.24l2.8,-1.28l-0.62,0.73l-0.02,0.5l2.03,2.18l0.17,1.69l0.79,1.24l0.95,0.66l2.05,0.17l1.38,0.88l0.35,1.96l-0.12,4.19l1.23,1.91l2.07,1.56l4.22,2.16l1.41,0.3l3.93,-0.45l2.94,1.06l1.2,1.26l-0.4,2.57l1.25,4.13l2.03,3.55l-3.87,-0.56l-1.7,0.81l-1.13,1.22l-0.53,1.69l0.58,1.56l-0.69,0.5l-2.06,3.14l-3.05,2.06l-0.83,1.38l0.25,2.53l1.44,2.18l2.96,2.54l-1.46,0.71l-0.59,0.79l-0.73,3.01l0.24,1.21l1.67,1.86l1.59,2.88l2.27,1.81l0.83,2.02l0.66,0.7l1.16,0.41l2.19,-0.38l0.67,0.17l6.04,2.48l6.53,3.55l3.45,0.91l0.74,1.13l1.35,0.71l2.64,0.05l10.62,-2.7l1.73,-0.12l2.57,-1.44l1.28,0.21l-0.66,2.31l0.83,1.51l1.3,1.15l0.87,1.66l-0.1,1.05l-2.22,2.08l-1.33,3.37l-4.45,3.63l-1.3,1.81l-2.63,2.56l-1.02,1.63l0.26,2.23l1.1,3.29l-1.5,0.69l0.05,1.26l-0.73,0.15l-1.26,1.13l-0.56,-0.67l-1.18,-0.6l-1.65,0.49l-1.0,1.05l-0.43,1.64l-1.32,1.04l-0.71,1.53l-2.86,-0.54l-1.41,0.13l-2.01,1.42l0.04,0.96l-1.09,1.0l-0.54,-0.78l-1.17,-0.24l-2.01,0.57l-0.96,1.09l-0.66,2.71l0.71,3.75l-0.22,0.12l-0.57,-0.92l-0.68,-0.42l-1.15,-0.07l-1.27,0.64l-1.75,1.52l-0.56,-0.6l-2.19,-0.07l-1.21,0.15l-0.99,0.57l-1.1,1.01l-0.38,1.3l0.79,0.89l-1.67,1.9l-0.35,1.79l-1.2,0.73l-0.35,0.74l-0.79,0.06l-0.5,-0.8l-0.56,-0.07l-0.45,0.47l0.04,1.32l-0.33,0.1l-1.7,-0.24l-2.06,0.51l-0.64,-0.66l-0.97,-0.32l-1.96,1.17l-0.06,2.1l-0.82,1.01l-0.09,1.11l-2.6,0.48l-0.8,1.76l-2.13,1.86l-1.64,0.87l-0.58,1.35l0.27,0.52l1.27,0.34l3.83,-0.86l1.01,0.19l-0.51,1.21l-1.15,0.87l-0.18,1.36l0.76,1.4l-2.03,1.21l-1.78,0.59l-1.1,-1.03l-3.19,0.39l-1.04,1.7l-1.07,0.59l-1.62,-0.35l-3.45,0.27l-1.36,0.42l-1.49,0.84l-0.91,1.44l0.37,1.87l-1.34,0.0l-1.03,-0.98l-2.86,-1.09l-1.75,-0.16l-3.76,0.92l-1.97,1.27l-0.72,1.7l-0.05,1.91l0.91,0.63l-3.08,0.19l0.74,-0.26l0.95,-0.93l-0.33,-1.65l-1.19,-0.96l-5.05,0.37l-0.84,-1.54l-3.51,-0.25l-1.12,-0.63l0.3,-1.17l-0.36,-0.56l-2.16,0.24l-1.78,0.81l-0.23,0.38l1.15,0.68l1.01,1.7l1.93,0.76l-3.17,0.02l-0.89,0.28l-1.2,1.7l-1.96,-0.54l-1.85,-1.41l1.88,-1.3l0.07,-0.54l-0.41,-0.57l-1.72,-0.7l-0.74,-1.26l-2.11,-0.09l-2.49,-1.0l-0.47,-1.46l-1.08,-1.07l-2.53,-0.57l-1.03,0.91l-0.53,0.98l-2.05,-0.53l-1.98,-2.66l-0.96,-0.55l-1.48,0.47l-6.6,-0.49l-1.53,0.31l-1.02,-0.43l0.34,-1.68l0.94,-1.98l-0.08,-0.43l-0.62,-0.64l-1.13,-3.95l-2.92,-1.81l-3.73,1.99l-4.48,-0.09l-2.35,0.26l-3.62,-0.16l-1.71,-0.5l-1.11,-1.51l-0.44,-1.53l1.11,-1.82l1.71,-0.86l5.36,0.0l1.8,-0.48l2.62,-2.32l0.89,-2.0l-0.21,-1.77l-0.6,-0.3l-3.34,1.54l-1.34,-0.21l-1.17,-1.2l-0.81,-2.2l-1.53,-0.53l-1.81,-0.01l-1.47,-1.47l-0.5,0.08l-0.49,0.59l-0.81,2.82l0.42,1.59l2.15,1.63l0.63,1.61l-0.57,1.4l-1.25,0.8l-1.63,0.16l-4.46,-1.86l-2.21,1.1l-1.58,0.35l-0.71,0.61l-0.46,1.44l0.98,2.54l0.42,0.33l0.81,-0.05l-1.29,0.81l-1.31,-2.62l-2.66,-1.4l-1.98,-1.65l-0.86,-1.8l-0.02,-5.7l-1.08,-2.53l-0.85,-1.1l-1.19,-0.67l-0.59,0.35l0.0,0.46l2.09,3.43l0.0,5.28l0.86,2.64l4.89,4.15l-0.11,1.02l-9.05,-0.1l-4.41,-0.9l-1.34,-0.7l-0.03,-0.85l1.11,-1.09l0.22,-1.41l-0.65,-1.13l-1.58,-1.03l-2.76,-0.96l-6.31,0.6l-10.72,-0.78l1.08,-2.45ZM708.84,625.18l0.07,-0.56l1.07,-0.35l0.67,-0.95l0.94,-0.47l-1.31,1.7l-1.44,0.64ZM692.6,626.12l1.76,-0.0l0.97,-0.54l0.94,-0.02l0.43,-0.62l0.24,0.26l0.04,0.66l-2.62,1.0l-1.76,-0.73ZM619.44,527.85l-4.96,0.01l-0.37,-0.2l-0.33,-0.9l0.44,-1.6l2.99,-4.46l1.31,-0.8l1.47,0.37l2.37,2.16l0.58,1.0l-0.0,0.54l-1.24,1.1l-1.26,2.17l-1.01,0.62Z",name:"Provence-Alpes-C\xf4te-d'Azur"},"FR-T":{path:"M244.25,389.03l0.07,-0.62l-0.38,-0.5l-2.85,-0.2l-0.42,-0.73l1.36,-1.47l0.19,-0.43l-0.29,-1.3l0.52,-0.79l4.3,-2.4l0.5,-0.98l-0.01,-0.83l-0.87,-2.37l1.49,-1.82l7.43,-1.66l0.17,0.65l-1.0,1.63l0.99,0.9l1.99,-0.09l4.86,-0.96l1.46,0.21l4.42,2.32l3.79,-1.72l2.86,-0.19l2.34,-2.04l2.77,-0.34l0.86,-1.23l-0.25,-0.98l-0.76,-0.79l-2.09,-1.47l-1.48,-0.05l-0.2,-0.92l0.59,-2.98l-0.97,-4.09l1.47,-2.55l-0.66,-4.53l-1.62,-2.86l-0.6,-3.2l-3.78,-6.41l-0.05,-0.67l0.8,-2.07l-0.78,-1.19l-1.4,-1.1l-3.53,-1.93l-0.48,-0.54l-0.88,-1.94l-0.43,-2.43l-0.91,-1.07l-1.53,-0.78l-2.22,-3.06l-2.05,-1.29l0.13,-0.56l1.47,0.22l2.4,1.36l1.33,0.38l4.31,-0.56l5.13,0.68l3.99,-0.34l1.28,-0.41l1.37,-1.03l2.73,-1.24l0.34,-1.13l-0.81,-1.37l1.0,-0.85l1.73,-0.42l2.13,0.74l5.97,-1.69l6.45,-0.7l5.88,-0.12l0.56,0.42l1.0,2.22l1.71,0.55l0.45,-0.18l1.48,-2.08l2.51,-0.92l1.0,-2.45l1.89,-2.08l0.9,-0.26l2.97,0.49l1.47,2.34l0.64,0.37l0.98,-0.07l1.14,-0.55l0.13,1.56l0.57,0.55l2.68,-0.26l0.19,0.85l-0.35,1.75l0.25,0.7l0.48,0.33l1.15,0.07l2.51,-0.61l1.03,1.31l1.83,0.26l-0.34,5.65l0.36,1.29l1.37,1.15l1.25,0.23l2.61,-0.25l2.91,0.46l1.93,-1.14l1.04,-0.24l5.49,-0.33l0.79,-0.44l0.19,-0.71l-0.77,-1.6l-0.1,-0.95l5.63,2.78l1.17,1.63l1.3,3.39l7.23,9.31l2.64,1.85l1.67,1.93l0.84,2.19l-0.61,2.63l0.01,1.65l0.57,2.3l0.55,0.83l2.33,2.03l3.29,1.27l0.85,2.04l0.88,0.33l3.79,0.0l1.5,0.67l1.08,1.6l-0.49,1.9l0.16,1.06l0.74,0.86l1.78,1.01l0.54,0.76l-0.93,2.7l-3.26,1.63l-2.6,0.09l-1.98,0.86l-3.1,3.7l-0.64,1.72l-1.05,0.36l-4.1,0.06l-4.24,3.26l-1.74,0.36l-0.77,0.52l-0.26,0.86l0.42,1.23l1.24,1.86l0.56,2.78l-0.2,0.35l-1.24,-0.17l-0.44,0.5l0.65,2.55l0.13,3.01l2.55,3.33l0.64,0.29l1.45,-0.41l0.5,0.27l1.87,3.15l-0.27,0.89l-3.04,1.96l-2.38,0.2l-1.12,0.48l-0.39,1.01l0.03,1.69l-1.25,6.55l-0.51,0.55l-1.1,0.02l-1.68,-0.77l-1.19,0.49l-0.97,1.76l-2.34,1.96l-1.37,2.98l-2.13,1.76l-2.19,2.98l-0.47,0.34l-1.88,0.21l-0.55,0.47l-0.33,0.71l-0.08,2.84l-0.44,1.62l-4.25,5.89l-2.66,0.63l-6.76,4.5l-0.78,1.47l-0.8,2.98l-0.2,2.04l0.21,2.06l-0.37,1.29l-1.66,1.46l-2.94,1.32l-0.89,1.94l-0.92,0.86l-0.88,0.24l-2.68,-0.62l-5.18,2.36l-0.92,1.54l0.67,1.71l-1.85,2.2l-1.43,0.56l-1.75,-0.54l-5.11,1.35l-3.9,-1.19l-2.34,-1.94l-1.85,-0.63l-1.88,-1.13l-2.58,0.24l-0.76,-0.22l-1.52,-2.46l0.02,-3.08l-0.6,-1.38l-0.77,-0.79l-2.79,-1.63l-2.48,-0.15l-1.8,-0.57l-0.72,-2.44l-1.16,-1.24l-1.2,0.22l-0.92,1.41l-0.63,0.41l-4.5,-0.2l-0.74,-2.71l-2.06,-4.83l-2.62,-4.07l-2.88,-2.9l-8.68,-5.52l-0.48,-1.77l-2.47,-1.03l-3.22,-2.81l-4.04,-1.44l-2.76,-2.39l-2.34,0.33l-0.67,-0.24l0.99,-5.73l3.71,-0.99l0.98,0.04l3.79,3.91l1.46,1.04l4.4,1.81l0.48,-0.15l-0.05,-0.5l-1.38,-1.36l-5.52,-3.9l-1.78,-2.15l-0.36,-2.01l-0.73,-1.64l2.03,-1.93l0.85,-0.46l1.49,-0.18l0.47,-1.14l-0.1,-1.07l-0.95,-1.64l0.89,-0.77l-0.02,-0.68l-0.92,-0.54l-1.09,-2.34l1.82,0.24l0.92,-0.76l0.72,-1.95l-0.78,-1.03l-1.49,-0.65l-0.71,-3.23l-1.9,-1.16l0.55,-0.47l-0.04,-0.64l-1.96,-1.09ZM235.41,400.43l1.09,0.41l1.35,-0.28l0.64,0.57l0.15,2.37l0.68,0.73l-0.16,1.32l2.38,1.46l0.35,0.53l-0.41,3.62l-0.61,1.91l-0.67,0.91l-0.62,-0.25l-0.84,-2.53l-1.25,-2.19l-3.59,-3.54l-1.32,-0.83l-2.14,-2.59l0.33,-1.57l-1.72,-3.8l1.1,0.13l1.99,0.91l3.27,2.7ZM219.58,381.29l3.07,-0.67l0.94,0.18l0.51,0.48l-0.09,0.29l-1.95,-0.5l-0.35,0.62l1.41,1.8l1.75,-0.06l1.83,-0.69l0.25,0.77l1.02,0.43l6.19,0.88l1.32,0.74l1.5,1.94l-0.96,0.35l-3.3,-0.75l-5.87,-3.31l-3.6,0.51l-0.76,-0.27l-2.9,-2.73Z",name:"Poitou-Charentes"},"FR-RE":{path:"M761.79,701.36l1.08,0.18l1.12,-0.39l1.21,0.39l2.77,-0.03l2.17,1.11l3.51,0.8l0.97,0.55l2.4,2.39l0.54,1.06l0.32,2.77l0.52,1.06l1.9,1.97l0.91,3.81l1.85,0.93l1.43,2.47l3.94,1.89l0.84,0.82l0.32,1.39l-1.08,2.72l-1.31,6.18l-0.27,4.98l-0.6,1.25l-1.42,0.53l-4.24,0.16l-2.56,1.32l-1.76,0.26l-1.74,-0.1l-1.22,-0.48l-1.58,0.46l-1.92,0.08l-3.62,-0.55l-3.79,-2.43l-5.72,-1.87l-1.23,-0.75l-1.75,-2.11l-3.42,-0.26l-3.52,-4.42l-0.9,-1.55l-0.63,-4.75l-3.33,-4.36l-1.6,-3.39l0.0,-1.42l0.43,-1.55l0.75,-1.19l2.55,-1.05l1.15,-1.41l0.43,-1.65l-0.32,-1.19l0.55,-0.82l-0.29,-0.86l0.61,-0.27l2.76,-0.09l5.6,-3.4l4.93,-0.0l2.25,0.81Z",name:"R\xe9union"},"FR-GF":{path:"M0.97,715.11l0.03,-0.01l1.04,0.32l0.16,0.02l0.86,-0.15l0.51,-0.46l0.86,-2.17l2.19,-0.54l1.75,-1.7l3.1,-6.63l2.47,-3.35l0.8,-2.07l0.47,-0.34l0.06,-0.66l-0.55,-0.79l0.94,-2.39l-0.02,-0.46l-0.64,-0.76l0.44,-0.66l-0.5,-1.65l0.23,-1.91l-0.45,-0.69l-0.46,-0.14l0.86,-1.73l2.07,-2.81l1.19,-0.89l0.84,-2.29l1.16,-1.21l0.63,-1.48l-0.08,-2.67l0.59,-2.69l-0.24,-0.63l-0.99,-0.8l-0.94,0.14l-0.73,-1.11l-0.67,-2.34l-1.1,-1.52l-2.15,-0.96l-0.85,-1.38l-0.94,-0.69l-0.78,-1.45l-0.91,-0.91l-0.6,-1.53l-1.41,-1.5l0.64,-2.85l-0.13,-0.85l-2.32,-1.44l0.46,-1.46l-0.01,-1.08l-0.33,-1.55l-1.0,-2.09l-0.57,-3.53l0.9,-2.56l0.01,-1.55l-0.48,-1.52l0.02,-2.19l-1.39,-1.38l0.0,-4.12l-0.26,-0.77l1.19,-1.14l-0.22,-1.91l0.25,-0.92l2.73,-3.76l0.74,-0.61l1.11,-2.37l4.66,-4.06l2.22,-1.17l1.58,-1.93l1.87,-4.21l0.52,-3.48l1.46,-2.55l2.53,0.36l1.76,0.65l0.25,-0.36l3.4,2.05l6.81,3.12l3.05,0.38l3.49,0.88l0.86,-0.07l1.81,1.42l0.75,-0.24l0.28,-0.38l-0.11,-0.54l0.6,0.16l3.21,1.77l2.63,0.74l0.44,-0.2l3.1,1.65l2.24,2.12l1.54,0.85l1.06,1.69l7.47,6.54l0.33,0.77l1.43,0.41l2.53,2.16l0.64,1.06l-0.27,1.23l0.6,0.43l2.01,-1.77l1.2,0.54l0.54,0.96l-2.76,4.28l0.03,1.47l0.4,0.37l0.6,-0.32l0.54,-0.93l0.57,-1.94l2.11,-1.78l0.87,0.63l1.21,1.89l2.18,1.25l2.26,2.1l0.89,1.31l1.5,6.51l-0.33,1.34l-1.91,1.37l-0.89,1.13l-0.01,0.47l0.45,0.15l2.11,-0.67l1.15,-0.61l0.64,-0.84l0.53,-2.04l-0.28,-4.87l0.65,-1.95l1.05,-0.2l1.97,1.65l0.0,0.74l1.13,1.9l0.28,1.83l0.66,0.89l-0.25,0.37l0.26,0.94l0.51,0.66l1.03,0.2l-0.69,0.86l-0.09,1.41l1.97,3.43l0.18,0.84l-0.06,2.16l-0.64,2.0l-0.3,0.58l-2.4,1.19l-1.04,0.92l-1.71,3.75l-2.1,2.32l-1.35,0.82l-0.13,1.42l-0.89,0.24l-0.67,0.68l-0.88,2.96l-1.99,3.34l-0.78,0.63l0.04,0.74l-4.48,7.35l-0.56,0.42l-1.13,0.12l-0.77,0.72l-0.64,1.51l-1.27,1.01l-0.24,0.8l0.31,2.33l-2.32,4.42l0.33,0.96l-1.39,1.05l-2.96,7.18l-1.09,0.6l0.67,2.17l-2.13,3.57l-1.21,1.07l-1.71,2.4l-5.24,2.87l-0.69,0.6l-0.84,1.79l-2.17,0.93l-2.57,-0.42l-1.92,-1.13l-5.09,0.79l1.41,-1.11l-0.13,-0.65l-2.09,-1.75l-0.88,-1.21l-0.87,-0.45l-0.43,0.08l-1.13,1.43l-2.74,1.58l-2.14,0.34l-1.52,-0.76l-2.22,-0.27l-2.22,-0.96l-0.87,-0.06l0.23,-1.21l-0.6,-0.69l-0.75,-0.14l-1.33,0.55l-1.05,1.47l-1.27,0.26l-0.98,1.22l-1.24,-0.04l-0.49,1.63l-0.46,0.33l-1.97,0.97l-0.71,-0.32l-1.16,0.23l-0.87,2.01l-0.86,0.39l-1.72,-1.68l-2.66,0.42l-1.6,-0.21l-2.03,-1.41l-3.41,-0.59l-1.86,-1.51l0.34,-0.7l-0.6,-0.59l-1.7,-0.92Z",name:"Guyane fran\xe7aise"},"FR-H":{path:"M838.53,672.37l1.08,0.06l0.88,-0.67l0.97,0.12l1.07,-2.21l1.86,-0.26l0.74,-0.59l0.25,-1.79l0.9,-1.48l-0.38,-0.73l-0.69,-0.15l0.49,-1.84l0.66,-0.7l2.07,-0.66l0.26,-0.57l-0.29,-0.57l0.29,-1.57l1.09,-0.31l1.75,0.99l1.22,-0.28l0.96,-0.92l0.83,-2.39l1.69,-0.12l3.84,-1.79l6.8,-1.3l2.03,-0.92l0.4,-1.61l3.75,-3.54l2.7,-0.22l4.3,0.91l1.55,0.91l1.19,2.4l0.37,0.25l0.75,-0.18l2.19,-3.35l0.93,-2.22l-0.53,-1.78l0.44,-1.29l-0.33,-1.53l-1.69,-2.25l1.55,-2.06l-0.41,-1.45l0.2,-1.05l1.75,-1.77l0.11,-1.69l-1.01,-1.98l0.14,-1.93l0.77,-0.45l2.42,-0.01l0.97,-0.35l0.69,0.85l1.59,0.95l-0.62,1.65l0.32,1.04l0.64,0.74l-0.24,1.34l1.15,6.71l-0.1,2.14l-1.97,6.87l-0.02,4.12l-0.45,1.01l0.91,0.83l0.24,0.8l-0.14,1.25l1.14,1.91l2.33,1.17l0.51,-0.65l0.25,0.54l0.31,7.85l0.73,1.54l-0.6,1.91l-0.19,2.68l1.67,5.79l-0.45,9.13l0.43,1.76l-0.38,2.31l-0.37,0.56l-1.68,1.43l-1.61,2.76l-5.49,7.01l-0.58,7.85l0.53,5.07l-0.08,5.26l-1.16,0.85l-0.93,1.45l0.36,0.56l0.38,0.0l-0.34,1.47l-1.74,0.45l-0.13,1.0l-2.1,-0.31l-0.71,0.1l-0.34,0.46l0.08,0.47l-0.87,1.33l0.15,0.53l1.18,0.53l2.94,-0.89l0.29,0.34l-0.16,0.77l-1.25,1.25l-1.71,0.61l-1.08,1.44l-0.92,0.16l-0.29,0.57l0.28,0.85l-0.28,0.85l0.82,0.98l-0.71,0.84l0.01,0.67l-2.14,1.17l-0.98,0.12l-0.35,0.4l0.0,0.54l0.75,0.99l-0.59,0.7l-0.15,0.77l0.54,0.37l1.71,-1.1l-1.36,2.96l-0.77,0.37l-0.56,-0.17l-1.56,-1.26l-4.09,-1.13l0.5,-1.41l0.63,-0.25l0.15,-0.7l-3.04,-1.76l0.64,-0.96l0.0,-0.46l-0.51,-0.38l-2.15,1.21l-0.36,-0.76l-1.07,0.38l-0.9,-0.82l-1.69,-0.51l-2.48,-0.05l-1.61,-1.23l-1.4,-0.31l-0.77,-0.93l-1.36,-0.18l0.42,-0.48l-0.28,-0.83l-3.45,-1.04l0.22,-1.42l-0.44,-0.73l-0.5,-0.17l1.06,-2.73l1.05,0.33l3.28,-1.35l0.76,-0.71l0.25,-0.88l2.21,-1.71l-0.28,-0.67l-8.03,-1.29l-0.49,-0.46l0.45,-1.23l-0.37,-0.54l-1.66,0.01l-3.15,0.9l0.15,-0.36l-0.39,-0.56l-1.58,-0.18l1.37,-0.22l1.43,-1.12l0.36,-1.08l-0.11,-0.68l-0.53,-0.48l2.22,-0.4l2.07,-1.1l0.18,-0.51l-0.3,-0.7l-0.72,-0.7l1.32,-0.68l0.04,-0.58l-0.51,-0.92l1.44,-2.22l-1.63,-2.04l-1.3,-0.47l-1.37,0.15l-3.3,1.36l-2.54,0.15l-1.78,0.63l-0.16,-0.36l0.64,-1.35l-0.36,-1.17l-1.16,-1.23l2.2,-0.2l1.3,-0.47l1.04,-1.45l-0.12,-0.56l-0.44,-0.27l0.27,-0.44l1.08,-0.73l3.47,-1.33l0.38,-0.36l0.09,-0.92l-0.43,-0.78l-0.97,-0.68l-1.71,-2.86l-0.82,-0.13l-1.52,0.37l-0.72,-1.14l-1.11,-0.59l-2.23,-0.31l0.1,-0.87l-0.66,-0.46l0.63,-0.4l0.19,-0.89l-0.4,-0.4l-0.84,0.0l0.49,-1.2l-0.24,-0.73l-0.53,-0.37l0.18,-0.95l-1.46,-1.0l2.12,-0.06l1.46,-0.81l2.49,-0.44l2.27,-0.94l0.28,-0.91l-1.26,-1.16l-2.16,-0.95l-0.59,-1.02l-0.54,-0.04l-0.76,0.57l-0.02,-0.4l1.8,-0.96l0.05,-0.67l-1.61,-1.07l-1.41,0.12l-1.48,0.55l-0.55,-1.32l-0.01,-0.82Z",name:"Corse"},"FR-MQ":{path:"M29.58,521.59l2.04,4.09l0.61,0.13l1.69,-1.37l2.35,-1.15l2.71,-0.7l1.66,-0.01l-1.1,1.0l0.15,0.92l-1.99,2.03l-1.17,-1.91l-0.57,-0.12l-1.08,0.91l-0.34,2.42l0.25,2.72l0.56,0.33l1.58,-0.37l0.87,0.65l-2.81,1.51l-0.09,0.63l0.51,0.51l-0.97,0.5l-0.21,0.44l0.48,1.35l1.03,0.35l0.45,-0.14l0.84,-1.13l2.53,1.1l-1.26,0.61l-0.22,0.52l0.83,1.98l1.01,1.02l2.32,1.31l0.92,2.1l2.03,0.78l0.32,0.71l-0.03,1.98l0.6,0.39l0.71,-0.41l-0.25,2.4l0.41,1.46l0.77,1.07l-1.35,1.57l0.15,0.59l1.42,0.69l1.69,5.35l-1.43,0.75l-1.43,3.51l-1.14,1.51l-1.19,0.51l-1.52,0.14l-1.15,-0.51l-0.42,-1.43l0.56,-0.96l1.27,-0.41l1.36,-0.96l0.05,-2.11l-1.15,-1.71l-0.48,-0.15l-3.49,1.8l-1.39,-0.1l0.06,-0.84l-0.32,-0.42l-0.79,-0.15l-3.38,0.55l-6.91,-0.91l-2.07,0.3l-2.92,1.18l-1.59,0.24l-0.81,-0.46l-2.5,-3.48l-0.12,-1.4l-1.35,-0.99l2.86,-2.99l3.07,-1.49l0.78,-0.71l1.21,1.62l2.11,0.55l1.94,-0.83l0.87,-2.13l-2.15,-3.7l-0.25,-2.0l-0.53,-0.33l-3.16,0.87l-5.49,-0.02l-1.6,-2.4l-4.32,-2.94l-2.07,-1.98l-1.24,-3.51l-1.31,-1.93l0.78,-2.27l-0.31,-1.75l-1.64,-2.67l-3.41,-3.56l-0.79,-1.4l-0.29,-1.59l0.29,-1.51l0.74,-1.23l0.98,-0.9l4.61,-2.61l4.02,-0.06l3.94,1.27l5.23,3.33l4.71,2.09l1.84,1.19l1.36,2.81l1.45,0.5Z",name:"Martinique"},"FR-GP":{path:"M44.87,452.95l2.26,-1.9l1.31,-0.53l0.63,0.19l-2.39,1.57l-1.81,0.66ZM16.07,454.56l0.99,-3.24l0.45,-0.54l1.25,-0.4l0.33,-0.98l-0.15,-1.3l-1.63,-0.93l-0.61,-3.02l1.65,-2.23l2.47,-1.44l2.87,2.33l0.67,1.2l0.24,4.01l1.84,2.68l1.77,1.09l0.71,-0.33l2.34,0.36l6.21,4.32l1.16,0.34l-0.55,0.18l-3.31,-0.89l-10.9,2.46l-3.09,1.07l-2.38,-0.65l-1.77,-1.2l-0.78,-1.34l0.24,-1.57ZM29.3,476.81l1.29,-2.59l1.05,-1.18l1.16,-0.64l1.27,0.28l1.08,0.91l0.68,1.72l0.94,0.93l0.13,1.34l-1.12,1.36l-1.47,0.73l-1.99,0.48l-1.58,-0.25l-1.44,-3.1ZM6.63,475.24l-0.25,-0.65l0.35,-0.72l-0.44,-0.85l-1.95,-1.6l-0.87,-1.97l-0.57,-0.45l-0.69,-2.06l-0.05,-4.94l-0.89,-2.29l0.25,-1.07l-1.09,-2.09l0.05,-3.66l1.5,-2.21l0.77,-0.65l0.89,-0.23l1.5,1.13l3.84,1.09l2.02,1.06l0.67,0.81l-0.4,0.18l0.01,0.74l0.87,0.07l0.72,0.74l0.65,-0.12l0.7,-0.95l0.47,-0.08l0.26,0.32l-0.35,1.27l0.32,1.1l-1.34,0.42l-0.48,0.89l0.13,2.94l0.8,2.29l0.41,3.37l-0.49,3.19l-1.83,2.19l-2.76,1.62l-2.74,1.16ZM13.68,480.6l0.09,-0.17l0.15,-0.01l-0.11,0.1l-0.13,0.09ZM10.63,481.22l0.17,0.27l-0.27,0.31l-0.19,-0.11l0.3,-0.46Z",name:"Guadeloupe"}},height:749.2159980728637,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","in_mill",{insets:[{width:900,top:0,height:932.9661457393951,bbox:[{y:-4125883.782575976,x:7589536.343670783},{y:-752405.3962423172,x:10843813.641475728}],left:0}],paths:{"IN-BR":{path:"M484.32,277.67l0.73,-0.96l-0.3,-0.93l-0.88,-0.99l2.18,-0.33l2.83,0.22l2.64,-2.44l0.65,0.88l1.12,0.53l0.73,1.16l1.44,0.13l0.88,1.39l0.78,0.52l8.92,1.6l1.49,1.54l0.75,2.31l-0.09,2.43l-1.0,2.2l0.17,0.95l0.56,0.5l3.94,1.04l1.49,-0.43l1.1,0.93l2.15,0.84l0.79,1.78l1.96,0.85l0.04,0.75l0.36,0.35l0.96,0.04l2.23,-0.69l0.89,0.36l0.08,1.86l1.02,1.19l3.03,0.83l1.86,-0.39l1.41,-1.3l1.63,-0.0l2.51,-1.3l2.45,-0.81l2.64,1.62l0.21,0.97l-0.22,2.39l0.42,1.46l2.16,1.84l1.01,-0.0l0.22,0.89l0.54,0.28l1.3,-0.5l2.57,-2.01l1.7,-0.38l3.07,1.67l1.2,0.08l1.34,0.59l2.79,-0.96l0.36,0.09l0.11,0.57l0.46,0.36l1.14,-0.05l4.28,1.79l1.88,1.41l4.91,2.34l0.65,-0.32l0.42,-0.67l1.5,0.42l1.07,-0.27l0.84,-0.55l0.93,-1.39l2.89,-1.18l1.56,-1.41l0.73,3.4l1.29,2.14l1.24,0.5l2.44,-0.41l0.71,1.14l2.25,0.92l0.7,-0.4l0.94,-1.66l1.64,-0.68l1.77,0.1l2.15,1.18l1.43,0.3l2.71,-1.46l0.9,0.58l0.74,0.03l0.64,-0.42l0.39,-1.06l1.69,0.41l1.28,-0.84l0.78,0.58l1.04,1.56l1.36,0.93l1.28,-0.0l1.4,-1.3l0.98,-1.67l0.32,-2.54l1.11,0.19l1.81,-0.54l-0.25,1.26l2.57,2.21l-0.61,0.46l-0.14,0.71l1.31,0.93l0.18,0.65l-0.99,0.12l-1.4,1.13l-1.21,0.45l-3.14,3.08l-1.92,1.35l-1.46,0.45l-1.05,1.31l-3.05,2.6l-0.73,2.89l-0.66,0.33l-0.26,0.54l0.49,1.44l1.99,1.18l1.38,2.54l1.16,1.11l1.88,0.79l1.0,0.91l0.39,1.89l-0.42,2.19l0.68,1.39l-1.31,-0.23l-0.83,-0.82l-1.07,-0.2l-2.31,1.07l-0.91,0.98l-2.54,1.15l-0.86,1.17l-0.03,0.52l1.06,1.26l0.71,0.03l1.1,2.34l-1.16,1.61l-1.13,-0.8l-2.11,0.07l-2.4,-0.65l-0.85,-1.16l-1.55,-0.73l-2.09,1.48l-1.42,3.04l-1.75,-0.38l-1.94,0.54l-0.7,1.28l-0.53,2.54l-1.11,-0.28l-1.23,0.43l-1.15,1.08l-0.95,1.56l-0.02,4.14l-1.58,2.6l0.22,1.29l-0.25,2.5l-0.67,2.32l-3.65,-0.85l-1.11,1.73l-0.08,0.78l-1.8,-0.56l-1.86,-1.14l-0.7,0.13l-0.57,0.88l-0.58,0.3l-1.44,0.17l-1.24,-0.58l-1.1,0.08l-2.84,2.71l-0.35,2.31l-0.66,0.61l-0.34,1.45l-4.74,-2.95l0.93,-1.5l-0.46,-2.24l-2.49,-0.71l-1.39,0.5l-1.2,-0.75l-0.53,-2.93l-0.94,-1.11l-1.16,-0.27l0.25,-0.54l-0.25,-0.67l-1.15,0.06l-1.82,1.29l-1.16,0.12l-1.33,-1.63l-1.34,-0.72l-2.71,0.04l-1.03,0.64l-0.64,1.13l-0.35,1.75l-1.32,0.86l0.46,1.43l-0.08,1.26l-2.09,-0.13l-1.88,1.89l-1.05,-0.3l-2.8,-0.01l-3.56,0.74l-0.45,0.74l-3.09,1.2l-0.45,0.51l-0.04,0.72l-1.53,1.38l0.11,-1.07l-0.45,-0.39l-3.33,1.32l-1.97,-0.04l-0.37,-0.38l-0.39,-2.05l-0.44,-0.37l-0.85,0.15l-0.38,-1.56l-1.06,-0.48l-3.69,2.24l-0.86,1.72l-2.29,-0.51l-1.24,1.5l-0.27,0.79l-0.51,0.49l-0.76,0.1l-1.39,-1.35l-2.08,-1.34l-1.51,-1.71l0.38,-0.69l-0.02,-1.06l-0.71,-1.19l-0.78,-0.19l-0.66,0.49l-0.73,-0.27l-1.47,0.23l-0.36,0.39l-0.0,1.03l-0.3,-0.98l-0.78,-0.09l-0.53,1.26l-0.76,-0.87l-1.6,-3.93l-0.85,-0.67l-0.69,0.16l-0.72,1.49l-2.03,1.42l-2.05,0.28l-1.37,-0.23l-0.86,0.31l-0.55,0.68l-1.94,0.19l-4.92,-0.81l0.03,-2.88l-0.43,-1.19l0.61,-1.14l-0.28,-1.64l-0.55,-0.62l-2.0,-0.71l-2.6,-2.78l0.35,-1.72l-0.05,-2.24l-1.27,-2.58l0.34,-3.02l0.62,-1.14l1.7,-1.27l11.06,-6.27l0.86,-0.66l0.44,-0.81l2.19,-0.92l3.62,-3.02l1.7,-2.16l2.53,-1.98l0.88,-0.25l0.74,0.43l-0.04,1.29l0.37,0.92l0.82,0.61l1.2,0.16l1.16,-0.32l0.69,-0.62l0.03,-1.0l-0.41,-1.1l0.17,-0.52l1.25,-0.49l1.93,1.49l1.54,0.6l1.32,0.01l2.29,-1.37l0.73,-1.81l-0.34,-0.78l-2.28,-2.05l-2.42,-0.33l-1.18,-0.71l-0.5,-0.92l-0.82,-0.67l-3.49,0.28l-0.93,-0.9l-0.59,-1.69l-0.97,-0.39l-0.91,-1.45l-2.52,-1.19l-1.28,-2.57l-1.04,-0.81l0.41,-0.8l2.49,-0.34l0.91,-0.6l1.31,0.19l0.82,-0.39l0.25,-0.57l-0.78,-1.52l0.71,-1.33l0.02,-0.66l-0.45,-0.55l-2.83,-0.73l-2.18,-1.58l-1.33,0.6l-1.31,-0.25l0.0,-2.11l0.43,0.93l0.6,0.15l0.88,-1.02l1.95,-0.62l1.34,-2.77l8.58,0.29l0.57,-0.33l0.16,-0.55l-0.47,-0.95l-2.41,-2.3l-0.79,-0.41l-1.03,-0.04l0.16,-2.85l-0.51,-1.31l-1.39,-0.46l-1.37,0.64l-2.26,-1.46l-1.22,-2.32l-0.19,-2.14l-0.79,-0.77l-0.57,-1.24l-1.11,-1.03l0.06,-2.11l-0.66,-1.12l-1.11,-0.96l0.19,-1.5l-0.52,-0.38l-0.62,0.03Z",name:"Bihar"},"IN-PY":{path:"M432.94,621.28l0.12,-0.11l0.06,0.17l-0.03,-0.0l-0.16,-0.05ZM434.43,621.71l0.34,-0.0l0.03,0.12l-0.21,-0.03l-0.16,-0.08ZM355.48,770.41l0.24,-0.33l0.83,0.78l1.19,-0.08l-0.49,1.07l1.07,0.9l0.61,-0.12l1.09,-0.94l-0.97,2.81l-1.98,-0.18l-0.66,-0.53l0.23,-1.51l-1.16,-1.87ZM356.86,803.07l0.79,-0.26l-0.03,-0.93l0.92,0.32l0.8,-0.45l0.68,0.07l0.07,4.51l-0.78,-0.6l0.25,-0.69l-0.28,-0.5l-2.69,-0.99l0.29,-0.48ZM218.44,768.85l0.02,-2.05l1.16,0.12l1.63,-1.29l0.73,0.2l-0.37,0.3l-0.72,-0.09l-0.44,0.41l-0.27,1.66l-1.25,1.09l-0.5,-0.37Z",name:"Puducherry"},"IN-DD":{path:"M144.48,504.35l0.06,-0.81l0.49,-1.24l0.48,0.6l0.06,1.15l-1.09,0.3Z",name:"Daman and Diu"},"IN-DN":{path:"M146.62,508.98l1.49,0.02l0.64,-1.32l0.96,0.1l1.81,-1.3l0.0,1.2l1.42,0.47l-2.51,1.64l-0.2,0.71l0.26,1.36l0.63,0.79l1.15,0.12l0.71,-0.32l0.3,-1.06l1.1,0.26l-0.01,2.67l-0.38,1.21l-1.24,-0.9l-1.12,0.47l-0.96,-0.54l-0.98,0.61l-1.35,-2.56l-0.26,-1.86l-1.39,-1.3l-0.07,-0.48Z",name:"Dadra and Nagar Haveli"},"IN-DL":{path:"M269.18,237.92l-1.09,-1.45l1.02,-1.35l1.39,-0.53l0.24,-1.0l0.78,-0.87l-0.35,-3.41l0.21,-0.9l1.59,-0.79l1.2,-0.05l0.91,-0.88l2.3,0.67l1.4,-0.39l0.27,0.61l-0.2,0.97l0.58,1.16l2.51,2.23l0.25,0.66l0.62,2.22l-0.95,1.04l-0.26,0.81l0.7,1.44l-2.32,0.75l-0.66,0.79l0.48,1.01l-0.98,0.25l-2.63,-1.33l-0.89,-1.75l-2.19,-1.1l-0.66,0.01l-0.48,0.79l-2.76,0.39Z",name:"Delhi"},"IN-NL":{path:"M779.92,344.86l0.24,-2.48l-0.5,-1.53l-1.51,-1.38l-1.72,-2.41l5.61,-4.5l1.79,-2.48l3.84,-3.32l0.18,-0.6l-0.86,-1.43l1.99,-1.01l0.92,0.2l0.22,1.55l-1.05,1.7l0.18,0.61l0.39,0.2l3.95,-0.86l1.52,-1.07l1.37,-2.13l-0.58,-1.75l0.0,-0.99l1.01,-1.64l0.11,-3.4l2.88,-3.87l2.12,-1.95l0.79,-3.49l2.04,-2.58l0.89,2.11l0.8,0.16l0.76,-0.33l1.67,-1.57l0.74,-1.09l0.25,-1.63l1.49,-1.74l1.12,-0.19l0.86,-0.7l1.24,0.02l2.52,-1.07l3.03,-1.88l1.13,-0.97l1.92,-2.9l1.52,-1.46l1.31,0.78l1.78,-0.04l4.5,-2.81l1.45,1.13l0.13,1.9l-0.88,1.28l-0.18,0.95l0.32,0.93l0.81,0.73l-0.26,2.06l0.63,1.74l-1.12,0.02l-0.96,1.1l-1.61,0.79l-0.48,2.09l-2.17,2.74l0.78,2.22l-0.69,2.6l0.11,2.79l0.48,1.15l0.9,0.47l-0.42,0.83l0.3,2.22l0.56,0.6l1.14,0.39l0.23,0.64l-2.48,2.95l-2.14,1.25l-0.24,1.45l0.63,3.47l-0.08,1.03l-1.42,0.62l-3.3,4.31l-0.08,0.67l-0.92,0.26l-1.66,2.11l-2.18,0.49l-1.29,0.92l-0.79,-0.14l-2.19,-1.69l1.06,-3.49l0.1,-2.14l-0.72,-0.37l-2.49,2.12l-1.72,0.98l-1.48,1.73l-1.75,0.89l-3.83,0.5l-1.34,-0.81l-1.99,0.08l-1.96,-1.16l-6.95,0.35l-1.1,0.4l-0.54,1.41l0.25,0.38l1.19,0.4l0.13,0.77l-3.93,3.81l-0.97,2.24l-1.16,1.64l-1.08,-1.27l-1.34,-0.42l-1.8,-1.16Z",name:"Nagaland"},"IN-WB":{path:"M545.45,405.85l-0.5,-0.98l0.56,-0.42l5.08,-0.89l0.31,-0.72l-0.47,-1.55l0.74,-0.53l1.67,0.87l0.84,0.07l-0.32,2.17l0.35,0.57l1.81,0.66l1.35,0.95l1.69,-0.33l1.95,-1.65l0.58,-2.23l1.76,-1.44l7.16,-2.58l3.6,-0.58l1.37,-0.52l0.56,-0.8l0.21,-1.04l-0.38,-1.28l0.13,-0.59l1.64,-2.23l2.89,1.56l1.05,0.13l2.02,1.46l1.68,0.42l1.24,-0.23l0.42,-0.94l-0.98,-1.3l1.48,0.29l0.47,0.6l0.77,0.13l0.6,-0.83l0.08,-1.2l0.67,-0.26l0.38,-0.66l-0.04,-1.15l-1.61,-2.24l1.91,-0.48l0.42,1.44l0.56,0.34l1.97,-0.7l1.91,0.1l1.22,-1.17l-0.03,-2.65l0.4,-0.06l1.12,0.83l0.64,-0.01l0.71,-0.96l0.29,-1.21l1.52,0.03l0.69,-0.57l0.01,-0.7l-0.45,-0.74l-0.74,-0.19l-0.01,-0.67l2.93,-1.81l1.74,-3.39l0.04,-1.52l0.75,-1.33l-0.41,-1.07l0.04,-1.25l-0.42,-0.42l1.37,0.59l1.07,-0.12l0.94,-0.6l0.46,-0.93l-0.2,-0.47l-0.58,-0.24l0.58,-0.51l0.08,-0.51l-0.69,-2.04l-0.63,-1.08l-1.12,-0.31l-0.14,-0.29l0.68,0.28l0.62,-0.34l0.26,-2.07l0.61,-1.34l-0.14,-1.71l-1.05,-3.44l-2.07,-1.79l-0.21,-1.92l0.46,-1.62l0.97,-1.02l0.74,-1.55l-0.87,-2.23l-0.57,-0.72l-0.74,-0.08l-0.57,-0.84l0.56,-0.79l2.33,-1.03l0.96,-1.0l2.16,-0.97l1.4,1.03l1.9,0.33l0.47,-0.45l-0.11,-1.05l-0.63,-0.84l0.41,-2.35l-0.5,-2.1l-1.25,-1.16l-1.89,-0.81l-1.11,-1.14l-1.2,-2.32l-1.92,-1.09l-0.39,-1.0l0.85,-0.61l0.64,-2.73l2.92,-2.46l1.08,-1.34l1.42,-0.41l1.96,-1.39l2.66,-2.74l1.56,-0.7l1.28,-1.06l1.18,-0.21l0.32,-0.73l-0.46,-1.15l-1.07,-0.55l0.79,-0.66l-0.12,-0.71l-1.34,-1.38l-1.14,-0.68l0.23,-1.51l-0.57,-0.35l-2.11,0.6l-0.78,-0.16l2.21,-5.06l0.16,-2.07l-0.51,-3.36l-1.72,-3.31l-1.28,-1.98l-1.44,-0.95l-1.12,-1.75l0.87,-4.21l1.51,1.11l0.39,1.54l0.74,0.73l4.09,0.21l3.92,1.74l2.29,-0.56l2.85,-2.48l2.71,0.28l1.59,-0.16l0.79,0.57l1.28,0.26l2.69,1.54l0.46,1.37l0.19,3.46l0.29,0.34l1.63,-1.15l0.76,1.97l0.84,0.27l1.26,-0.33l0.64,0.28l1.07,0.92l0.7,1.54l0.63,0.6l3.73,0.29l1.04,-0.28l0.94,-0.75l1.87,-0.3l3.01,1.82l2.09,-0.18l2.3,0.6l0.6,0.46l-0.29,1.59l0.63,0.37l2.22,-0.41l1.68,0.7l2.49,0.24l0.75,-0.98l0.75,2.6l0.28,3.28l-0.9,2.05l-0.46,2.89l-0.88,0.81l0.31,0.9l-1.25,0.59l-0.72,1.5l-0.86,0.56l0.04,1.22l-1.55,0.49l-0.18,-0.8l-0.86,-0.37l-1.27,0.64l-0.02,1.22l-0.94,0.39l-0.42,1.08l0.57,0.68l-0.48,0.58l0.23,0.75l1.09,0.15l-1.54,1.52l-0.38,1.81l-1.38,-1.31l-2.29,0.18l-0.73,-0.75l-1.31,0.6l-0.84,-0.27l-1.33,-1.22l-1.01,-0.45l-0.8,-1.36l-2.47,-1.14l-0.46,-0.78l-0.28,-2.06l-1.01,-1.97l-0.01,-0.39l0.84,-0.04l0.09,-1.08l-1.36,-0.64l-0.24,-0.96l-1.33,-0.55l-1.96,-1.58l-0.57,-0.06l-0.99,0.67l-0.74,1.31l-0.01,0.73l0.75,0.92l1.61,0.68l0.49,1.17l0.62,0.23l0.34,0.57l0.65,0.14l-0.29,0.34l-1.18,0.29l-0.68,-0.22l-1.29,-1.25l-1.04,-0.25l-0.91,0.46l-0.72,1.18l-0.91,-1.51l-1.33,-0.61l-1.97,0.6l0.81,-0.62l0.24,-1.27l-1.29,-0.96l-0.66,-1.82l-1.2,-0.43l-0.74,-1.07l-1.95,-0.46l-2.01,-1.77l-1.53,-0.53l-0.33,-2.09l-0.46,-0.49l-0.9,0.45l-0.68,1.2l-1.21,3.24l0.06,0.87l0.87,0.76l0.58,-0.35l0.14,-0.78l2.98,0.87l0.96,2.56l-1.84,-0.15l-3.0,2.73l-0.3,2.13l-3.15,1.09l-1.89,1.47l-0.78,1.93l0.51,1.07l-0.12,0.57l-0.79,0.64l-1.63,3.72l0.4,2.48l1.35,2.12l1.02,0.06l2.3,-0.88l0.79,0.4l1.81,2.04l2.96,2.25l0.25,2.15l1.56,0.98l1.71,2.04l2.13,0.28l2.25,1.05l0.73,-0.2l0.76,-0.76l1.66,-0.37l1.12,1.2l-0.48,1.96l1.4,2.3l1.33,0.44l0.8,0.66l2.14,0.08l-0.15,0.49l-1.45,1.22l-0.04,1.1l-0.32,0.07l-0.24,0.62l-2.61,-0.88l-0.47,0.18l-0.58,0.98l-1.64,-0.16l-2.86,-0.85l-1.23,-0.01l-1.12,0.71l-2.46,-0.78l-1.5,0.37l-0.35,0.76l-0.17,3.89l-0.99,1.68l-0.5,1.66l-1.59,2.27l-1.78,-0.3l-0.37,-1.1l-1.21,-1.04l-1.33,0.16l-1.59,0.83l-0.21,0.5l0.78,2.11l-0.83,1.08l-0.67,0.34l-0.28,1.04l-0.9,0.53l-0.14,1.33l-0.83,2.23l0.28,0.45l0.9,0.3l0.73,1.05l0.07,1.91l1.05,1.48l0.84,0.18l8.01,4.07l2.42,1.81l5.01,0.7l1.0,-1.38l1.17,0.59l0.6,0.78l0.3,2.04l-0.42,0.68l-1.42,0.76l-0.3,0.7l-0.09,2.48l0.81,1.21l0.65,0.38l-0.58,0.9l0.35,2.32l-1.67,1.6l-1.68,0.07l-0.85,0.66l-0.02,1.23l-0.76,1.49l0.25,1.1l-0.6,3.39l0.72,0.51l-0.1,0.68l0.41,0.56l1.25,0.21l1.1,1.66l1.75,1.33l0.39,0.76l0.88,0.04l0.61,-0.71l-1.51,4.2l-1.03,1.81l-0.01,0.88l0.44,0.92l2.58,1.08l1.56,-0.51l3.8,1.0l-2.85,2.89l-0.46,0.98l-0.39,3.23l1.78,3.39l1.51,0.97l-0.23,1.76l-0.92,1.57l1.48,4.98l-0.13,0.51l-0.56,0.36l0.08,0.71l1.11,0.51l0.92,3.0l-0.39,1.34l0.91,2.85l-0.27,0.58l1.66,2.45l0.42,1.62l-1.03,0.69l-0.22,1.48l0.63,1.91l0.14,2.67l-1.18,0.15l-0.44,0.52l-1.34,-0.77l-0.36,-1.32l-0.38,-0.28l-0.81,0.22l-0.3,0.82l0.64,1.51l2.25,1.42l0.54,0.87l0.86,3.85l1.27,1.9l-0.01,1.43l-0.48,0.14l-0.33,-0.52l-0.69,-0.07l-0.64,0.78l-1.89,-1.22l-1.24,-0.27l-0.7,-3.49l-0.61,-0.28l-0.4,0.34l-0.62,2.07l0.63,2.03l-0.94,0.29l0.5,-1.05l-0.26,-0.97l-0.39,-0.27l-1.42,1.86l0.48,2.23l-0.61,0.28l-1.15,-0.41l0.33,-1.07l-1.1,-2.67l0.57,-3.6l-0.26,-0.99l0.59,-1.77l0.2,-2.12l1.06,-1.02l0.23,-0.74l-0.27,-0.9l-1.35,-1.0l1.61,-2.01l-1.14,-0.17l-1.44,1.2l-0.31,1.39l1.07,0.87l-0.15,0.5l-0.98,2.08l-1.2,-0.05l0.8,-2.06l-0.43,-2.86l1.34,-2.58l-0.1,-0.63l-0.99,-0.36l-1.64,3.33l0.18,2.1l-0.71,1.31l-0.13,2.49l-0.97,2.58l-0.07,2.69l0.46,0.46l1.46,-0.37l0.16,0.55l-0.31,1.14l-0.55,-0.13l-0.4,0.44l0.23,2.14l-0.66,0.46l-0.07,1.76l-0.47,-0.41l-0.69,0.01l-0.11,1.32l-0.51,-0.09l0.07,-1.06l0.6,-0.74l0.46,-2.03l-0.73,-2.54l0.85,-1.8l-0.11,-1.1l-0.98,-1.56l0.53,-1.9l-0.75,-0.79l-0.46,-0.03l-0.08,0.85l-0.75,1.52l0.64,2.32l-0.63,0.42l-0.66,1.98l0.48,3.04l-0.28,0.49l-1.35,0.68l-0.22,-1.85l0.28,-0.81l-0.46,-0.52l-1.07,0.39l-0.38,-0.84l-0.84,0.2l-0.44,-2.18l-0.57,-0.66l-0.63,-0.16l-0.42,0.44l0.08,0.75l1.01,3.85l-0.42,1.45l0.66,1.05l-0.95,0.35l-0.35,-1.27l-0.51,-0.52l-0.6,0.03l-0.58,-1.49l0.87,-2.47l-0.23,-0.94l0.2,-0.63l-1.67,-3.15l-0.24,-2.24l0.24,-0.83l2.02,-2.79l-0.71,-3.23l-3.61,-1.75l-0.09,-0.54l-0.61,-0.27l-0.84,0.43l-0.77,-0.39l-1.03,-1.26l-0.97,-4.14l-0.49,-0.54l-0.92,-0.13l-0.41,0.6l0.54,0.86l0.74,3.83l0.6,1.16l1.56,1.46l3.72,0.8l0.73,0.61l0.32,1.05l-0.22,0.69l-1.51,1.64l-2.08,0.56l0.04,1.33l-2.0,4.07l-2.48,1.79l-1.01,1.44l-4.96,3.02l-2.47,0.14l-4.13,1.11l-1.25,-2.09l0.04,-2.21l-0.26,-0.62l-0.76,-0.57l-4.7,-1.12l-0.64,-1.11l-0.35,-2.0l-0.83,-1.17l-2.44,-0.78l-2.21,2.36l-0.3,-0.07l-0.94,-1.35l0.28,-2.14l-0.68,-1.6l-1.45,-1.03l-1.64,-0.67l-1.74,-0.15l-2.08,-1.48l-1.77,-0.61l-0.33,-0.57l0.32,-0.22l0.61,-0.36l1.19,0.03l0.28,-1.32l2.26,-0.3l0.3,-0.79l-1.52,-1.54l-0.47,-2.23l-2.14,-1.64l-0.14,-0.58l0.98,0.03l0.45,-0.53l-0.69,-1.9l-1.33,-1.0l-2.63,-0.5l-0.79,-2.5l-1.98,-1.62l-0.94,-0.49l-1.31,-0.05l-1.46,-1.14l0.13,-2.51l0.41,-1.21l-0.13,-0.83l0.77,-0.68l1.92,-0.56l0.18,-0.83l-1.95,-0.64l-4.23,-0.15l-1.7,-0.37l-1.31,-0.0l-1.19,0.45l-5.28,-5.12l-1.99,-0.54l-1.51,0.49l-0.33,-1.19l-1.25,-1.57l0.38,-1.25l1.12,-1.59l0.49,-2.12l-0.57,-0.72l-1.16,-0.03ZM621.37,462.65l0.62,0.85l-0.48,1.24l-0.1,-0.46l-0.03,-1.63ZM639.28,467.29l-1.47,0.01l-0.03,-1.73l1.33,0.75l0.17,0.97ZM630.2,458.45l-0.18,-0.62l0.39,-0.95l1.22,-1.6l0.22,0.26l-0.7,3.21l-0.96,-0.3ZM615.62,464.13l-1.95,-0.31l-0.34,-0.61l1.43,-4.38l1.08,-1.59l0.53,2.85l-0.1,1.69l-0.79,0.55l-0.14,0.48l0.28,1.31ZM614.23,456.85l0.15,-1.15l0.64,-1.08l0.26,0.49l-0.18,0.81l-0.87,0.92Z",name:"West Bengal"},"IN-HR":{path:"M197.67,196.54l-1.92,0.66l-0.68,-0.19l-0.12,-0.33l0.58,-1.74l1.54,-0.71l0.56,-0.71l0.04,-0.87l-1.03,-1.19l0.03,-0.46l3.74,1.02l2.05,-1.87l3.05,-0.56l0.68,0.68l2.25,0.52l0.65,1.26l1.95,1.36l2.44,-0.58l0.57,-1.17l-0.41,1.39l0.24,1.61l1.61,1.38l0.49,-0.02l0.38,-1.05l0.49,-0.25l0.24,0.89l0.89,1.26l-0.77,0.21l-0.05,1.32l-0.89,0.47l-0.18,0.49l2.26,4.51l0.68,0.02l1.72,-0.75l-0.08,-1.9l0.4,-0.66l1.05,-0.42l0.07,-0.72l1.15,-1.12l1.84,-2.76l4.54,1.48l1.87,-0.35l1.18,0.2l0.81,-0.43l0.25,-1.03l1.84,-0.6l1.45,0.72l0.68,1.43l0.66,0.57l2.19,0.36l1.5,-0.6l1.29,-0.08l1.38,-1.54l2.31,-0.92l2.19,-1.64l-0.08,-0.61l-0.99,-0.75l-0.42,-1.25l0.77,-2.4l0.6,-0.91l-0.16,-0.9l0.93,-0.28l0.17,-0.47l-1.41,-0.86l0.04,-0.31l1.21,0.8l1.17,0.28l1.1,-0.22l0.28,-0.67l0.98,0.56l0.49,-0.29l0.43,-0.88l0.03,-1.16l0.63,1.85l0.67,0.93l1.52,0.62l1.31,-0.04l3.08,-2.2l0.45,-2.11l-1.11,-0.83l-0.74,-1.06l1.96,-0.97l2.75,-2.1l0.15,-0.69l-0.67,-0.42l0.18,-0.95l0.62,-0.28l0.94,0.26l1.29,-0.13l1.11,2.15l0.94,0.05l0.48,-0.5l0.29,-1.07l-0.34,-3.0l0.44,-1.02l-0.52,-1.05l0.23,-1.9l-0.5,-1.28l-0.77,-0.38l-0.31,-1.22l-0.78,-0.13l0.06,-1.77l-0.44,-1.16l0.68,-1.4l0.01,-0.71l-0.29,-0.49l-0.85,-0.37l-0.78,-1.44l0.75,-0.5l0.96,1.15l1.8,0.0l0.72,0.82l0.49,1.43l1.37,0.91l0.34,0.94l3.46,1.85l0.71,0.88l0.16,2.59l-0.5,1.22l0.09,0.78l2.08,1.94l0.25,0.78l0.44,0.23l0.93,-0.4l1.76,0.9l1.62,0.31l0.93,0.77l1.26,-0.33l0.59,0.71l2.07,-0.23l2.03,1.34l-0.49,3.0l-4.77,4.22l-0.4,1.32l-2.42,1.67l-0.2,0.66l-0.96,0.19l-0.26,0.72l-1.47,1.42l-0.66,1.71l-0.89,4.15l-0.47,0.9l-0.85,0.28l0.03,1.48l-0.81,0.56l-0.03,0.91l-0.63,0.62l-0.17,1.53l0.38,1.01l-0.82,0.38l-0.38,0.67l0.4,1.11l-0.1,1.06l0.71,0.51l0.71,-0.06l-1.49,1.77l0.33,0.56l2.21,0.16l-0.49,1.16l0.06,1.19l0.44,0.83l-0.56,1.13l0.32,4.99l-0.22,0.57l1.83,3.91l-0.49,0.52l-0.07,0.59l1.38,1.81l-0.48,0.8l-1.19,0.43l-2.62,-0.68l-1.12,0.96l-1.76,0.23l-1.23,0.79l-0.42,1.42l0.38,3.16l-0.71,0.77l-0.21,0.93l-1.26,0.39l-1.28,1.97l1.21,2.02l0.49,0.29l3.29,-0.53l0.51,-0.79l1.96,0.95l0.92,1.77l2.96,1.49l1.17,-0.15l0.67,-0.44l0.11,-0.6l-0.47,-0.68l0.36,-0.34l2.21,-0.63l1.36,1.03l-0.01,0.77l0.51,0.3l0.72,-0.35l0.65,1.19l0.96,-0.1l-0.04,0.82l0.65,0.59l-0.7,2.07l0.67,0.83l0.27,1.32l1.0,0.34l-0.17,0.55l-0.64,0.25l-0.17,0.47l0.74,0.72l-0.77,0.85l0.01,1.32l-0.24,-0.15l-0.61,0.36l0.19,1.33l-0.23,0.73l0.1,0.41l1.03,0.81l0.7,1.8l-0.54,0.3l-1.08,1.73l-1.24,-0.14l-1.14,1.02l-2.4,0.84l-0.96,0.82l-1.05,0.03l-0.37,0.47l-0.86,-0.73l-0.59,0.56l-0.3,-0.44l-0.52,-0.11l-0.85,0.76l-1.92,-0.54l-0.95,0.12l-0.53,1.25l0.42,0.62l0.78,0.36l-1.77,0.36l-1.03,1.64l-1.71,0.27l-0.23,-0.17l0.72,-0.3l0.15,-0.38l-0.57,-0.95l0.43,-2.47l0.88,-1.72l-0.19,-3.96l-0.52,-2.28l0.64,-2.88l-0.31,-0.93l-2.2,-2.22l-0.95,-0.48l-1.46,0.62l-1.38,1.94l-3.45,2.5l-0.25,0.95l0.49,1.35l-1.85,0.43l-0.89,0.93l-0.83,-2.12l-1.96,-0.59l0.71,-0.57l-0.55,-0.72l0.54,-0.08l0.22,-0.4l-0.98,-1.7l-0.96,-0.35l-1.98,0.38l-0.71,-1.02l-1.24,-0.44l-0.56,0.44l-0.0,0.81l1.23,1.18l-0.83,0.3l-0.23,0.52l0.19,0.51l1.05,0.65l-0.19,0.59l-0.5,0.06l-1.74,-1.05l-0.94,0.38l-1.54,-0.12l-0.66,0.79l-0.18,1.38l0.66,2.16l0.02,1.52l0.69,0.96l0.29,1.5l-0.62,0.44l-1.77,-1.38l-3.88,0.2l-0.48,-1.45l-1.14,-0.82l-0.09,-0.38l1.1,-0.25l0.59,-0.56l0.14,-0.71l-0.49,-0.68l0.63,-1.33l1.08,-1.16l0.14,-0.82l-0.76,-0.63l-0.7,0.22l-0.51,0.59l-0.74,-0.62l1.69,-0.98l0.71,-0.94l0.81,0.77l0.71,0.05l0.34,-1.01l-1.72,-2.96l-2.17,-2.79l-2.33,-2.11l-2.17,-0.91l-1.14,0.06l-0.05,-1.25l-2.28,-1.69l-3.18,-4.01l-3.25,-9.33l1.03,-1.13l-0.06,-1.08l-0.44,-0.58l-1.68,-0.7l-1.73,-2.58l0.02,-0.98l-0.52,-1.06l0.81,-0.33l0.22,-0.76l-0.73,-2.06l-0.71,-0.18l-1.11,0.73l0.1,-1.56l-0.26,-0.42l-0.65,-0.14l-1.3,0.6l-0.77,0.84l-0.86,0.08l-1.19,-0.66l-1.07,0.71l-1.9,0.54l-1.12,-1.64l-0.56,-0.19l-1.59,0.27l-1.1,-2.41l-0.82,-0.74l-2.52,-0.92l-0.97,0.26l-1.36,1.06l-1.48,-0.23l-1.78,0.2l-0.51,0.37l-0.23,0.76l-0.28,-0.03l-2.1,-3.33l0.28,-0.41l1.47,-0.13l0.47,-0.84l0.07,-1.62l-1.13,-1.94l0.92,-5.58l-0.73,-0.83l-1.02,0.44ZM259.41,180.33l-0.42,0.53l-0.13,0.09l0.07,-0.25l0.48,-0.37Z",name:"Haryana"},"IN-HP":{path:"M229.45,117.96l1.78,-1.92l0.71,-1.52l-0.42,-0.79l-1.07,0.13l-0.02,-1.36l3.39,-1.15l1.65,-1.71l4.23,-3.05l-0.07,-0.68l-1.73,-2.9l0.38,-1.22l1.73,-1.98l0.07,-1.31l-0.71,-1.74l0.32,-2.08l-1.4,-2.4l-1.75,-1.91l-0.13,-0.95l1.18,-0.43l1.48,0.51l0.94,0.92l0.79,-0.09l4.49,-3.83l4.22,-1.75l0.9,-0.95l0.55,-1.64l2.1,-1.4l1.27,-0.58l3.51,-0.66l0.95,-0.52l2.35,1.47l3.95,-0.18l5.58,5.42l4.66,2.96l1.53,0.84l6.68,2.06l0.97,-0.1l0.54,-0.69l2.55,-0.39l2.39,-0.78l1.97,-1.57l2.83,-1.51l4.08,4.65l1.07,2.36l1.06,1.32l0.31,2.34l2.3,3.1l1.48,0.01l1.99,-1.8l2.17,-0.84l2.03,-0.16l0.85,-0.83l1.36,-0.66l0.22,-1.01l0.92,0.01l0.38,1.9l-0.26,1.58l-2.3,2.04l-0.82,2.5l0.0,1.13l0.76,0.84l0.89,0.12l1.87,-1.75l1.92,3.19l-0.51,1.13l0.86,3.58l-0.14,1.8l1.83,1.02l4.14,5.78l2.59,1.76l0.19,0.99l-0.67,1.45l-0.59,2.7l-0.94,1.85l0.75,1.03l-0.01,1.01l0.96,1.57l1.22,0.41l1.58,1.69l-3.62,3.17l0.06,1.16l1.86,1.29l-0.72,3.51l0.1,0.8l0.49,0.69l1.22,0.56l2.79,-0.26l1.58,1.74l1.69,2.52l0.03,0.64l-1.52,0.33l-1.82,-0.11l-0.93,-0.71l-1.48,-2.18l-4.35,-0.29l-1.49,-0.5l-3.2,0.35l-2.0,-1.63l-0.97,-0.01l-1.04,-0.74l-1.82,-0.16l-1.0,0.16l-1.58,1.0l-1.51,0.46l-4.45,2.55l-3.03,-0.02l-4.59,4.61l0.1,1.68l-1.55,0.35l-0.07,0.87l1.2,1.32l0.08,0.92l-0.09,0.37l-0.57,-0.32l-0.55,0.2l-1.49,3.28l0.05,1.22l0.89,0.92l0.27,1.62l0.79,1.6l-0.76,0.85l-0.03,0.51l0.97,1.5l1.17,0.3l-0.02,0.5l-4.31,2.33l-2.78,0.6l-0.54,1.0l-1.24,-0.9l-1.78,0.25l0.35,-0.76l-0.47,-0.5l-2.06,0.86l-0.62,-0.66l-1.76,-0.37l-1.86,-0.95l-0.96,0.35l-0.19,-0.67l-1.61,-1.27l-0.4,-0.67l0.53,-1.47l0.06,-1.86l-0.36,-1.18l-0.9,-1.08l-3.39,-1.8l-0.27,-0.87l-1.32,-0.83l-0.45,-1.35l-0.95,-1.09l-1.97,-0.09l-1.17,-1.21l-1.44,0.74l-4.03,-3.4l-0.52,-1.32l0.49,-1.87l-0.67,-0.63l0.08,-1.55l0.76,-1.11l-0.03,-0.41l-0.37,-0.37l-0.92,-0.05l-0.01,-0.8l-0.54,-0.83l-0.54,-0.15l-0.51,0.57l-0.55,-0.83l-1.05,0.02l-0.81,-0.71l-0.55,0.31l-2.49,-4.37l-1.8,0.74l-0.04,1.86l-0.67,0.19l-0.54,1.21l-0.85,-0.29l-1.23,0.33l-0.44,-0.26l-0.89,-1.09l-2.37,-7.15l-4.5,-8.19l0.07,-0.38l1.15,-0.14l0.15,-0.7l-2.74,-4.52l-5.6,-2.94l-3.59,-0.7Z",name:"Himachal Pradesh"},"IN-AS":{path:"M663.07,316.48l0.01,-0.33l2.23,-0.81l0.27,-0.58l-0.2,-0.73l0.78,-0.56l0.58,-1.33l1.61,-0.9l-0.43,-0.98l0.82,-0.66l0.51,-3.03l0.94,-2.19l-0.3,-3.5l-0.71,-2.22l1.37,0.07l6.69,-1.16l1.04,-0.91l0.73,-1.87l0.84,-0.52l2.26,-0.19l1.89,-1.28l0.86,0.13l2.83,1.94l3.6,1.77l4.05,0.43l8.94,-0.5l1.75,-0.74l0.81,-0.01l3.25,0.08l2.45,0.93l1.24,-0.17l1.11,-0.58l1.4,-2.16l0.7,-0.32l1.42,0.14l0.88,1.73l0.8,0.57l2.17,-0.43l1.87,0.42l1.57,-0.18l3.68,-1.8l0.91,1.59l0.76,0.22l0.63,-0.55l-0.09,-1.07l0.42,-0.45l-0.02,-0.62l1.9,1.21l2.1,-0.24l1.36,-1.2l0.28,-0.99l3.65,0.29l3.76,-0.78l8.62,-2.47l2.73,-1.83l3.43,0.48l3.48,1.5l0.3,0.71l0.71,0.55l1.88,0.49l10.99,-1.18l1.14,0.32l1.27,0.98l0.87,0.01l1.48,-0.64l3.25,-0.5l1.99,-0.77l4.25,-3.13l0.32,-0.77l-0.24,-1.72l0.51,-0.89l4.15,-4.24l8.09,-6.65l0.47,-1.11l-1.32,-1.97l0.7,-0.82l1.01,1.03l2.02,0.77l3.03,-0.68l1.08,0.66l1.54,-0.32l4.22,-2.16l4.21,-1.1l4.59,-2.26l9.18,-3.21l1.71,-0.97l1.72,0.75l1.48,0.08l4.22,-1.06l4.0,-2.54l1.27,-0.38l7.37,-0.1l-2.08,3.62l-3.49,4.12l-0.39,1.22l0.72,3.03l2.67,2.25l0.25,1.82l-0.48,1.35l0.33,0.7l-0.05,1.3l0.79,0.26l1.3,-1.47l0.92,-0.12l0.74,0.97l-0.03,1.23l-1.02,0.66l-0.4,0.89l-1.02,0.43l-0.42,0.76l-0.96,-0.32l-2.26,0.04l-4.83,1.83l-2.47,-1.34l-1.74,0.34l-0.89,0.84l-0.76,2.13l-1.08,1.05l-2.06,0.87l-2.93,2.18l-2.33,0.23l-1.17,1.42l-3.92,2.33l-1.33,0.03l-1.25,-0.77l-0.62,0.03l-1.42,1.26l-2.28,3.32l-0.98,0.83l-2.89,1.8l-2.43,1.03l-1.31,-0.0l-0.86,0.71l-1.1,0.15l-1.9,2.12l-0.28,1.68l-0.66,0.97l-1.47,1.38l-0.68,0.17l-0.59,-1.92l-0.66,-0.39l-0.54,0.12l-2.29,2.96l-0.75,3.42l-2.08,1.89l-2.98,4.02l-0.17,3.6l-1.03,1.73l0.01,1.2l0.57,1.47l-1.16,1.72l-1.19,0.85l-3.43,0.81l1.09,-1.91l-0.08,-1.11l-0.43,-0.8l-1.57,-0.43l-2.36,1.15l-0.41,1.0l0.9,1.2l-3.78,3.26l-1.75,2.44l-5.74,4.65l0.02,1.06l1.74,2.27l1.43,1.25l0.42,1.24l-0.09,1.81l-1.83,2.72l-2.5,5.47l-0.88,0.27l-0.67,0.79l-0.14,1.08l0.51,1.11l-1.1,0.82l0.37,1.06l-1.35,2.11l-0.19,0.93l-1.4,-0.34l-0.76,0.41l-0.42,0.68l-0.98,3.15l0.15,0.92l0.37,0.32l-0.7,1.62l0.54,1.23l-1.03,0.63l-0.78,4.46l-0.49,0.04l-0.71,1.05l-1.92,-0.33l-2.5,0.78l-1.72,-3.21l-0.61,-0.53l-0.52,-0.02l-0.53,0.59l-1.18,3.26l-2.61,2.91l0.05,1.31l-0.98,0.5l-3.21,2.95l-0.74,-0.22l-0.53,-0.84l-0.23,-0.86l0.42,-1.1l-0.34,-0.48l-4.04,-0.06l-1.99,-0.48l0.99,-2.26l0.18,-1.77l-0.74,-1.72l-0.3,-1.98l-2.13,-1.46l0.78,-3.19l1.58,-4.31l0.04,-1.65l-0.52,-1.57l0.67,-0.52l0.99,0.32l2.9,1.82l3.14,-0.9l0.81,-1.3l-0.35,-1.35l-0.87,-0.64l-0.1,-0.43l-1.9,-1.24l3.56,-3.27l1.3,-0.42l0.35,-0.75l2.67,-0.27l0.89,-0.99l3.76,-1.27l0.46,-0.64l-0.78,-1.58l0.37,-1.38l-0.38,-1.05l-2.72,-2.53l-2.06,-0.78l-0.47,-0.7l-0.81,-0.43l1.34,-1.1l1.33,-1.73l0.23,-0.63l-0.27,-0.67l-1.06,-0.16l-1.61,0.87l-3.56,-3.68l-2.01,-1.75l-1.09,-0.46l-2.26,1.22l-2.7,0.45l-1.34,0.75l0.18,-1.73l-0.23,-1.9l1.48,-3.54l-0.29,-0.86l-0.88,-0.3l-0.05,-0.67l2.62,-2.44l0.29,-0.89l-0.27,-0.45l-3.49,-0.3l-3.33,1.02l-1.08,-0.05l-2.93,0.66l-0.79,-0.14l-2.03,-1.5l-0.88,0.03l-1.87,1.45l-1.06,2.67l-1.17,1.02l-0.79,-0.11l0.48,-1.79l-0.31,-1.05l-0.62,-0.43l-1.23,-0.02l-3.89,4.8l0.26,0.86l-1.79,0.13l-1.8,0.55l-1.04,0.78l-1.85,2.29l-1.11,0.57l-0.36,-0.65l-0.11,-3.58l-0.9,-0.34l-2.65,0.99l-0.98,-0.4l-0.72,0.37l0.17,-1.18l-0.25,-0.83l-1.14,-0.53l-0.7,-0.86l-3.36,-0.26l-1.72,0.28l-0.87,0.55l-0.12,-0.83l-0.79,-0.34l-3.3,0.94l-0.24,-0.8l-0.65,-0.4l-0.61,0.19l-1.3,1.31l0.29,-0.71l-0.11,-0.76l-1.17,-0.96l-1.09,-0.45l-2.78,-0.18l-0.9,0.14l-1.44,0.94l-5.77,0.82l-3.11,2.52l-1.92,2.43l-0.44,1.79l-0.72,1.25l0.16,2.24l1.61,1.92l-0.05,0.49l-0.77,0.48l-2.0,0.28l-0.42,0.72l-0.22,2.1l-1.52,0.65l0.59,-5.87l-1.02,-2.98l-0.55,-2.85l0.1,-0.67l1.34,-2.33l0.13,-0.78l-0.68,-0.66l0.5,-0.89l-0.56,-0.92l-0.84,0.15l-0.91,-1.29l-0.12,-1.51l-1.12,-2.31l-0.58,-0.37l-1.15,-0.04Z",name:"Assam"},"IN-UT":{path:"M290.95,175.24l-0.31,-0.45l0.16,-0.23l3.37,-0.85l3.64,-1.92l0.42,-0.6l-0.06,-1.2l-1.32,-0.46l-0.68,-1.08l0.48,-0.37l0.27,-0.91l-0.22,-0.97l-0.63,-0.85l-0.26,-1.61l-0.89,-0.91l-0.01,-0.76l1.22,-2.78l0.89,0.28l0.59,-1.05l-0.14,-1.41l-1.18,-1.28l0.81,0.08l0.67,-0.49l0.3,-0.73l-0.32,-1.05l3.9,-4.07l0.54,-0.28l2.79,0.1l4.5,-2.57l3.73,-1.55l1.69,0.15l0.85,0.68l1.03,0.03l1.2,1.2l0.94,0.46l2.61,-0.37l2.11,0.53l4.18,0.25l1.13,1.91l1.22,0.95l3.16,0.05l1.25,-0.6l0.0,-1.27l-1.82,-2.75l-1.58,-1.74l0.87,-1.39l0.96,0.85l1.0,-0.03l1.1,-3.41l1.16,-0.22l2.08,1.39l0.62,1.44l1.05,0.36l-0.03,1.25l0.74,0.86l0.04,1.22l1.46,0.85l0.54,2.52l0.53,0.57l2.26,0.97l1.08,2.47l2.17,0.27l1.63,2.04l1.6,0.58l1.91,-0.81l3.23,-0.54l3.15,0.76l1.58,2.12l3.25,1.54l1.81,2.14l1.15,0.36l1.78,-0.62l0.99,1.35l0.94,0.56l-0.58,1.06l-0.99,0.19l-0.34,0.48l0.09,0.66l0.95,1.13l0.08,0.47l-0.68,1.46l0.45,0.55l2.1,-0.18l2.17,0.6l5.67,2.86l2.65,0.07l3.78,2.21l1.84,2.43l5.1,1.78l0.86,0.44l0.68,1.13l-2.12,0.8l-0.8,-0.96l-0.55,-0.09l-0.49,0.35l-1.01,1.05l0.22,1.15l-0.44,0.64l-2.27,1.77l-1.2,1.7l-2.2,1.62l-2.18,0.57l-0.85,1.97l-2.18,2.84l-0.56,0.44l-1.9,0.52l-0.92,0.77l-0.45,0.93l-0.04,1.03l0.96,3.25l-1.75,1.83l-0.16,1.01l-1.64,1.45l-0.25,0.68l-1.2,0.53l-0.28,0.84l1.3,3.62l0.76,0.26l-0.56,2.85l-0.47,-0.21l-0.86,0.34l-0.15,0.75l0.5,1.37l-0.14,0.51l-1.7,0.08l-1.15,0.63l-0.63,1.38l-0.35,2.99l-1.44,0.97l-0.65,1.28l0.08,2.75l1.04,0.9l-1.16,1.58l-1.43,0.55l-0.87,-0.37l-0.04,-1.04l-0.44,-0.24l-0.79,0.2l0.08,-0.94l-0.38,-0.4l-1.62,0.37l0.3,-1.52l-1.13,-0.87l-2.18,-0.29l-0.6,0.22l-0.26,0.74l-0.54,0.19l-1.94,-0.41l-1.16,0.47l-0.67,-0.89l-1.55,-0.1l-2.32,0.86l-0.71,-2.13l-1.46,-1.68l-2.4,-0.13l-3.8,-2.61l-0.66,-0.74l-0.55,-1.37l-2.39,-1.3l-0.84,-0.11l-3.42,1.35l-0.4,-1.87l-1.03,-1.41l-4.38,-2.28l0.11,-0.62l0.69,-0.26l1.19,0.27l0.76,-1.03l0.69,0.21l0.69,-0.27l1.77,-1.76l0.03,-1.29l-3.55,-1.07l-4.97,-2.81l-1.61,-1.38l-2.29,-3.67l-1.11,-1.1l-3.59,-1.79l-2.29,-3.9l-2.23,-2.17l-1.68,0.04l-0.85,1.12l0.16,1.82l1.13,4.27l-0.23,1.21l-0.92,0.93l-1.27,0.59l-0.53,-0.16l-3.81,-2.16l-3.95,2.04l-1.26,-2.37l-1.0,-3.95l-0.15,-3.69l1.35,-2.08l1.34,-3.04l3.16,-2.75l0.2,-1.02l-0.65,-0.63l-5.42,-2.71l-2.87,-2.4l-1.41,-0.26l-0.93,0.49Z",name:"Uttaranchal"},"IN-JH":{path:"M485.62,401.35l-2.2,-0.83l-1.66,0.13l-0.64,-0.47l-0.92,-2.18l0.46,-1.96l-0.75,-2.15l-5.31,-5.13l-0.45,-1.24l-0.28,-2.67l-2.23,-1.57l-3.11,-0.55l0.74,-1.85l1.39,-1.87l0.17,-1.31l1.15,-1.83l-0.17,-0.87l-1.63,-2.76l0.11,-0.69l0.93,-0.61l2.97,-0.32l4.77,0.81l1.87,-0.08l1.71,-1.09l1.28,0.23l2.91,-0.51l1.72,-1.44l0.63,-1.37l1.28,2.2l0.99,2.58l0.91,0.66l0.71,-0.13l0.37,-0.54l0.48,0.46l0.71,-0.09l0.31,-0.39l0.0,-0.99l1.13,-0.14l0.85,0.26l0.77,-0.44l0.4,0.65l0.01,0.81l-0.37,0.6l0.15,0.73l1.64,1.83l3.74,2.84l1.49,-0.24l1.96,-2.6l1.54,0.48l0.78,-0.11l0.96,-1.83l3.19,-2.01l0.37,0.18l0.47,1.68l1.14,0.05l0.36,1.93l0.73,0.76l1.93,0.23l3.38,-1.36l-0.14,0.95l0.71,0.62l2.29,-1.85l0.34,-1.09l2.75,-1.0l0.7,-0.85l3.22,-0.65l2.72,-0.0l1.15,0.31l2.07,-1.87l1.74,0.23l0.61,-0.3l0.36,-0.71l0.0,-1.21l-0.39,-1.16l1.12,-0.67l0.91,-2.77l0.59,-0.38l2.49,-0.03l0.87,0.51l1.73,1.86l1.65,-0.22l1.97,-1.34l-0.19,1.0l1.95,0.69l0.56,2.96l0.66,1.0l1.38,0.68l1.57,-0.48l1.85,0.5l0.24,1.48l-0.96,1.25l0.15,0.88l5.46,3.3l0.78,-0.54l0.24,-1.39l0.74,-0.75l0.22,-2.08l2.61,-2.45l1.79,0.61l1.64,-0.17l0.97,-0.45l0.63,-0.86l1.69,1.09l2.36,0.74l0.49,-0.24l0.04,-1.06l0.79,-1.32l2.54,0.86l1.25,-0.22l0.91,-2.73l0.27,-2.7l-0.24,-0.98l1.59,-2.79l-0.02,-3.96l1.79,-2.25l0.83,-0.3l1.16,0.31l0.51,-0.24l1.12,-3.76l1.51,-0.38l1.41,0.51l0.77,-0.28l1.6,-3.24l1.37,-1.12l1.1,0.52l1.08,1.31l2.68,0.7l1.93,-0.1l0.67,0.49l0.1,0.59l-0.46,1.42l0.24,2.13l2.17,2.01l1.05,3.9l-0.72,3.72l-1.0,-0.18l-0.39,1.06l0.51,0.67l1.0,0.23l0.43,0.82l0.61,1.83l-0.66,0.58l-0.05,0.67l0.77,0.42l-1.14,0.75l-2.41,-0.72l-0.85,0.38l0.07,0.8l1.03,0.5l-0.1,1.01l0.4,0.96l-0.7,1.06l-0.04,1.52l-1.26,2.69l-3.44,2.56l0.02,1.36l0.28,0.36l0.67,-0.02l0.2,0.56l-1.83,0.11l-0.91,2.13l-1.27,-0.85l-1.16,0.28l-0.22,0.53l0.12,2.26l-0.83,0.87l-1.67,-0.16l-1.77,0.66l-0.38,-1.37l-0.75,-0.37l-2.33,0.63l-0.38,0.95l1.58,2.04l0.13,0.85l-0.99,0.74l-0.22,1.61l-0.67,-0.67l-1.24,-0.31l-1.18,0.26l-0.11,0.83l0.9,1.18l-0.74,0.16l-1.48,-0.36l-1.99,-1.45l-1.11,-0.15l-2.74,-1.55l-0.75,0.01l-2.05,2.64l-0.2,0.99l0.37,1.17l-0.54,1.3l-4.61,0.89l-7.31,2.64l-2.04,1.68l-0.42,2.01l-1.8,1.61l-1.1,0.29l-1.25,-0.91l-1.7,-0.6l0.37,-1.76l-0.17,-0.83l-3.17,-1.24l-0.91,0.23l-0.6,0.76l0.27,2.08l-4.66,0.65l-1.05,0.72l-0.09,0.97l0.72,1.07l1.45,0.25l-0.37,1.69l-1.12,1.59l-0.47,1.62l0.4,0.99l0.91,0.9l0.58,1.59l0.42,0.13l1.6,-0.54l1.56,0.43l4.28,4.41l1.21,0.8l2.64,-0.43l6.48,0.73l-1.12,0.37l-1.06,1.04l-0.38,5.19l1.78,1.49l1.55,0.14l2.47,1.85l0.25,1.52l0.66,1.08l0.97,0.46l1.88,0.17l1.02,0.78l0.5,1.15l-1.24,0.06l-0.21,0.5l0.21,1.04l2.24,1.83l0.38,2.09l1.43,1.35l-2.14,0.24l-0.34,0.37l-0.06,1.01l-0.83,-0.19l-1.36,0.84l-5.58,-3.66l-3.08,0.44l-0.93,-0.27l-2.33,-2.54l-5.72,-2.93l-1.38,-1.66l-0.96,-0.22l-0.63,0.3l-0.7,0.93l-1.56,0.42l-0.49,0.53l0.14,1.26l1.25,1.79l0.31,2.33l-0.08,0.94l-0.78,1.36l0.01,0.75l0.7,1.68l-0.43,2.63l-1.68,2.46l-1.06,0.74l-1.12,0.27l-1.32,-0.84l-0.04,-1.41l0.7,-1.51l-0.5,-0.78l-3.63,1.66l-3.84,-0.98l-3.16,-1.78l-1.39,-0.0l-2.85,1.24l-2.91,3.01l-0.82,-0.88l-2.85,-1.79l-1.6,-0.26l-1.46,0.46l1.5,-2.94l1.65,-2.4l0.39,-1.42l-0.54,-3.97l-0.68,-1.83l-0.62,-0.17l-2.32,1.61l-1.27,0.2l-0.95,0.73l-3.4,-0.9l-1.07,0.16l-1.02,0.58l-6.68,0.19l-0.58,0.37l-0.42,1.49l-2.34,1.14l-2.91,0.15l-2.41,-1.06l-1.51,-0.19l-0.86,-0.65l-2.56,-3.71l-2.65,-1.24l0.21,-0.7l2.1,-1.9l1.68,-0.16l2.55,-1.92l1.17,-2.68l0.95,-0.49l2.7,-2.47l0.21,-1.44l-0.78,-2.37l-1.27,-0.8l-2.38,0.04l-2.05,-0.95l-0.44,0.2l-0.1,0.88l-0.34,-0.13l-0.73,-2.68l-1.84,-1.99l-0.24,-1.17l0.56,-3.95l-0.52,-2.22l-1.03,-0.81l-1.27,0.92l-0.09,-0.36l0.24,-2.83l1.54,-1.82l0.43,-1.07l-0.96,-2.79l-0.87,-0.33l-1.62,0.72l-0.34,0.71l0.12,1.14Z",name:"Jharkhand"},"IN-JK":{path:"M176.08,35.04l2.37,-2.36l-0.15,-2.71l0.72,-0.56l5.27,-0.96l3.12,-1.98l1.87,-0.7l1.84,-0.15l1.87,0.3l7.81,2.66l10.87,2.04l5.97,-0.52l1.57,1.55l2.54,1.46l8.19,2.07l5.87,-0.33l2.57,-2.29l3.11,-1.82l1.42,-1.8l0.86,-0.17l1.84,0.74l1.27,-0.01l3.39,-0.84l5.27,-2.66l0.99,0.15l1.97,1.12l3.39,-0.56l3.4,-2.92l0.32,-0.85l0.08,-2.41l0.59,-0.43l1.96,-0.39l1.61,0.69l0.77,0.01l2.91,-2.36l0.56,-0.77l0.2,-1.26l-0.34,-1.59l0.44,-0.53l22.94,-13.34l0.94,1.29l1.66,0.81l1.15,-0.36l2.19,-1.83l1.4,0.07l0.25,0.97l-1.39,3.65l-0.24,2.94l1.11,2.66l2.85,4.79l0.56,3.9l0.5,1.32l1.45,1.99l1.9,6.57l0.74,1.28l1.29,1.15l1.47,0.62l7.06,1.14l1.68,0.66l2.57,1.86l1.66,2.01l3.68,1.47l0.79,0.71l0.72,1.3l0.34,1.43l-0.32,1.36l-2.12,1.93l-2.99,1.23l-2.52,1.81l-0.26,3.11l1.51,4.2l0.72,4.34l-0.37,6.71l0.6,2.02l0.76,1.24l2.91,2.63l1.83,2.73l2.61,1.09l0.44,1.63l0.42,0.49l2.17,-0.32l3.4,1.53l2.5,0.11l0.76,0.38l0.07,0.93l-1.15,2.16l-0.31,3.79l0.76,1.2l1.74,1.47l1.04,2.98l1.58,1.74l-0.13,2.04l-1.78,2.45l-2.99,2.26l-1.28,1.37l-2.29,-0.49l-2.63,0.8l-0.83,0.67l-1.0,3.25l-1.34,-0.22l-2.55,1.01l-0.76,-0.22l-4.17,-3.55l-0.99,-2.71l0.36,-2.45l-0.62,-0.72l-0.73,-0.26l-0.88,0.28l-1.95,1.75l-6.89,0.7l-0.72,0.37l-0.3,0.78l-1.91,1.79l-0.48,-0.21l-0.24,-0.53l0.84,-2.71l2.04,-1.64l0.41,-0.81l0.1,-2.61l-0.35,-1.18l-0.52,-0.44l-1.59,0.09l-0.31,0.35l-0.01,0.78l-1.28,0.59l-0.52,0.64l-1.76,0.13l-2.36,0.83l-1.87,1.76l-1.16,0.19l-1.94,-2.71l-0.28,-2.27l-1.13,-1.48l-1.11,-2.41l-4.43,-4.94l-0.7,-0.03l-1.02,0.5l-3.7,2.62l-4.93,1.16l-0.67,0.74l-0.48,-0.0l-6.46,-2.01l-1.4,-0.78l-4.53,-2.86l-5.76,-5.55l-4.11,0.12l-1.88,-1.36l-0.71,-0.13l-1.11,0.56l-3.58,0.69l-3.2,1.74l-0.74,0.87l-0.39,1.36l-0.68,0.71l-4.17,1.72l-4.44,3.8l-1.01,-0.85l-1.7,-0.58l-1.74,0.49l-0.44,0.98l0.29,1.07l3.0,3.83l-0.27,2.22l0.73,1.87l-0.04,0.89l-1.7,1.9l-0.05,0.61l-0.99,1.43l-2.76,1.28l-0.43,1.18l-0.85,0.7l-2.45,0.3l-1.37,0.77l-2.13,2.4l-1.29,-0.76l0.03,-0.69l-0.42,-0.49l-1.71,0.82l-2.67,0.07l-3.04,-2.13l-2.21,-0.52l-3.16,-1.86l-3.66,0.69l-2.22,-1.01l-3.41,0.48l-0.92,-0.3l-0.7,-0.79l-0.95,-2.82l0.8,-1.82l-0.19,-2.8l1.2,-2.89l-0.26,-1.2l-0.74,-0.4l-0.76,0.21l-0.63,0.65l-0.62,1.67l-1.02,0.49l-2.05,0.22l-2.05,-1.37l-2.17,0.76l-0.5,-0.09l-0.91,-1.05l0.73,-1.21l0.13,-0.85l-0.81,-4.48l-1.14,-0.74l-2.8,-0.45l-1.0,-0.55l-1.7,-2.2l-2.9,-2.45l-0.36,-0.9l0.31,-1.78l2.08,-1.05l0.87,-1.05l1.26,-3.13l0.67,-2.87l-0.65,-2.12l-5.01,-3.36l-0.4,-1.27l0.28,-1.74l1.77,-2.59l3.3,-0.55l2.28,-1.26l1.59,-1.84l0.35,-1.48l-0.54,-1.32l-1.2,-0.71l-3.32,0.36l-2.29,-0.58l-2.14,0.5l-0.78,-0.15l-1.4,-1.35l-0.24,-0.86l0.22,-0.85l3.05,-2.05l0.2,-1.12l-1.36,-3.16l-0.58,-0.7l-2.81,-0.24l-1.92,-1.19l-0.07,-1.35l1.86,-1.69l0.23,-1.76Z",name:"Jammu and Kashmir"},"IN-UP":{path:"M275.34,205.39l0.08,-0.87l-0.4,-0.81l0.98,-0.64l0.26,-0.62l-0.39,-1.02l0.09,-1.08l0.63,-0.63l-0.03,-0.78l0.85,-0.74l-0.12,-1.31l0.85,-0.26l0.57,-1.11l1.48,-5.73l1.43,-1.37l0.17,-0.58l0.94,-0.1l0.3,-0.86l2.37,-1.61l0.44,-1.41l4.79,-4.24l0.56,-1.76l0.08,-1.88l0.69,-0.43l1.01,0.2l2.73,2.32l5.75,3.03l-3.25,2.91l-1.42,3.18l-1.4,2.22l0.14,4.1l1.02,4.01l1.5,2.84l0.53,0.17l3.93,-2.12l4.27,2.33l1.87,-0.79l1.16,-1.27l0.27,-1.53l-1.31,-5.86l0.44,-0.6l0.93,-0.03l1.97,1.95l2.37,3.99l3.63,1.83l1.01,1.0l2.3,3.68l1.72,1.49l5.15,2.91l3.22,0.87l-0.29,0.67l-1.36,1.2l-1.25,-0.03l-0.74,1.01l-0.97,-0.35l-0.89,0.33l-0.75,1.13l0.36,0.82l4.44,2.28l0.82,1.11l0.45,2.3l0.61,0.28l1.07,-0.68l2.94,-0.83l2.2,1.17l0.37,1.16l0.83,0.95l3.93,2.71l1.56,0.36l0.81,-0.24l1.2,1.39l0.83,2.42l0.51,0.21l2.48,-0.94l0.99,-0.02l0.51,0.84l0.69,0.17l1.07,-0.46l2.12,0.39l0.81,-0.28l0.49,-0.86l1.92,0.26l0.58,0.43l-0.37,1.25l0.26,0.54l0.61,0.21l1.18,-0.4l0.11,1.23l0.97,0.05l0.34,0.98l1.38,0.56l1.93,-0.72l0.97,-1.03l0.5,-1.07l2.2,2.05l1.78,0.44l1.1,1.2l1.02,0.42l1.36,2.19l0.82,0.27l1.64,-0.21l2.4,2.1l0.56,-0.22l0.15,-0.44l-0.17,-2.69l0.63,-0.53l0.74,0.02l0.4,1.04l2.24,0.66l1.17,1.65l1.64,0.62l1.64,1.48l0.65,0.35l2.05,0.21l0.35,1.28l0.73,0.61l1.33,0.34l1.04,-0.11l0.72,1.29l5.03,1.12l0.53,0.65l1.04,2.88l2.01,2.4l-0.35,0.91l0.75,0.97l1.19,0.06l0.59,-0.34l0.52,-0.97l0.76,0.17l1.08,0.92l0.65,1.65l0.59,0.53l2.77,1.38l1.6,1.47l2.32,0.63l1.89,1.78l3.25,1.95l1.27,0.05l1.97,-1.88l0.73,-0.31l1.44,0.14l0.64,0.2l1.19,1.09l1.86,0.8l3.63,2.88l2.4,1.17l1.78,1.68l1.35,0.37l2.68,-0.3l3.76,-0.93l0.61,0.23l0.78,1.86l0.64,3.77l1.05,1.07l3.78,0.24l2.16,1.0l1.95,0.46l3.79,-0.02l1.0,0.38l1.46,1.18l1.22,1.83l0.87,0.34l1.01,-0.06l1.26,-0.95l0.95,-1.56l-0.43,-1.73l0.64,-0.32l6.11,0.45l7.74,3.44l-0.08,0.57l0.44,0.31l0.89,-0.1l-0.14,1.46l1.68,1.8l-0.02,2.27l2.55,3.19l0.12,2.0l1.36,2.56l2.76,1.74l1.3,-0.6l0.85,0.05l0.44,0.97l-0.19,2.57l0.25,0.77l1.93,0.52l2.54,2.63l-8.75,-0.21l-0.69,0.64l-0.89,2.26l-1.87,0.57l-0.58,0.71l-0.53,-0.86l-1.04,0.3l-0.27,2.29l0.45,0.95l1.56,0.43l1.39,-0.63l2.0,1.49l2.85,0.74l-0.75,1.75l0.72,1.59l-1.71,-0.01l-0.98,0.62l-2.56,0.37l-0.78,0.73l-0.02,1.17l1.57,1.59l0.8,1.89l2.75,1.4l0.66,1.24l1.01,0.41l0.56,1.63l1.2,1.16l0.84,0.22l2.77,-0.43l1.0,1.36l1.44,0.91l2.29,0.25l2.18,1.96l0.09,0.43l-0.43,1.02l-1.48,1.05l-1.13,0.16l-1.72,-0.61l-1.57,-1.34l-1.31,-0.02l-1.48,0.93l0.37,2.52l-1.19,0.43l-1.3,-0.47l-0.42,-2.32l-1.02,-0.59l-1.43,0.28l-2.76,2.12l-1.74,2.2l-3.5,2.93l-2.15,0.89l-1.31,1.48l-12.02,6.86l-1.28,1.31l-0.44,1.05l-0.35,3.14l0.15,0.85l1.12,1.85l-0.29,4.03l2.54,2.96l2.69,1.36l0.21,1.11l-0.62,1.25l0.43,1.32l-0.04,2.89l-2.45,0.3l-1.39,1.1l-0.01,1.49l1.65,3.07l-0.95,1.29l-0.26,1.5l-1.39,1.86l-1.72,4.05l-1.53,1.2l-0.32,1.67l-0.84,1.34l-3.39,1.26l-4.96,-0.24l-1.19,-0.65l-1.66,-1.53l-1.22,-0.35l-0.94,-1.34l-0.99,-0.75l0.07,-1.48l-1.86,-1.99l0.85,-0.12l0.85,-0.74l0.33,-2.2l0.73,-1.76l-0.05,-2.43l-0.94,-0.86l0.33,-2.55l-0.28,-1.36l0.21,-0.26l0.93,0.28l0.92,-0.26l0.51,-1.09l-1.52,-2.87l-1.63,-0.31l-0.22,-1.37l-0.98,-0.12l-2.9,1.04l-1.34,-0.13l-2.9,-0.97l-1.02,0.1l-0.38,0.54l0.07,1.74l-0.34,0.46l-2.48,0.03l0.46,-0.94l-0.09,-0.81l-0.63,-0.61l-1.13,-0.04l0.05,-2.17l-0.46,-0.58l-0.5,0.11l-0.69,1.01l-0.23,-0.11l0.34,-1.13l-0.43,-1.53l-0.75,-0.06l-2.07,1.15l-2.62,-1.65l-2.34,-0.36l-2.44,-1.83l0.1,-1.46l-1.19,-1.84l-1.25,-0.33l-1.65,0.49l-0.55,-0.18l-0.66,-1.21l-3.93,-0.58l0.12,-0.94l-1.36,-2.79l-0.44,-0.15l-3.52,1.18l-0.04,0.71l1.17,0.85l-1.17,0.38l-1.22,-0.17l0.17,-0.95l-0.6,-0.6l-1.6,-0.5l-2.36,0.14l-0.44,0.65l0.07,2.14l-1.89,2.61l0.26,1.6l-1.41,0.32l-0.94,1.06l-2.61,-1.77l-1.96,0.4l-1.39,-1.0l-2.12,0.47l-1.76,-0.18l0.84,-1.31l0.15,-0.88l0.88,-0.9l0.2,-1.29l0.88,-2.03l-0.08,-0.99l-0.92,-0.55l-1.39,0.37l-0.83,1.53l-3.3,0.4l-0.04,0.77l1.71,1.4l-2.08,0.3l-0.9,-0.82l-0.8,-1.5l-0.89,-0.3l-0.66,0.44l0.01,1.06l-2.31,-0.37l-0.6,0.3l0.4,1.75l1.24,0.71l-0.82,0.53l-0.4,0.04l-1.56,-1.55l-0.56,0.43l0.22,1.27l-1.38,-0.38l-1.63,0.37l-0.51,-0.7l-0.17,-0.93l1.06,-0.2l1.53,-1.78l2.0,-1.08l0.21,-0.73l-0.78,-2.05l-0.88,-0.18l-0.5,-0.7l-0.94,-0.49l-0.28,-2.59l-0.93,-1.59l-0.79,-0.28l-1.27,0.27l-0.88,-0.25l-2.49,2.19l-1.13,-0.36l-2.27,1.05l-3.01,2.29l-2.37,0.66l-0.35,0.48l0.02,0.73l1.03,1.63l-1.68,0.65l-0.98,-0.78l-3.65,0.23l-3.08,-0.97l-0.92,0.48l-1.43,1.94l-0.32,-0.02l-0.21,-0.76l-0.47,-0.4l-1.47,0.02l-0.45,0.65l0.08,1.56l-0.7,0.07l-0.49,-0.55l0.21,-1.36l0.89,-0.87l1.71,-2.67l0.6,-1.48l-0.19,-0.47l-0.47,-0.14l-1.16,0.86l-0.87,-0.19l-0.77,0.28l-0.81,0.96l-0.37,-0.96l1.04,-2.22l-0.64,-0.78l-0.75,0.11l-1.26,2.01l-0.04,1.23l0.78,3.19l-3.22,-0.57l-1.29,1.21l-0.23,-1.37l-0.3,-0.28l-0.87,-0.01l-1.75,0.66l-0.09,-0.73l1.1,-1.71l-0.97,-0.87l-0.86,-0.22l-0.71,0.35l-0.16,1.32l-1.22,0.43l-1.02,1.15l-0.59,0.21l-0.12,-0.99l0.32,-0.89l1.91,-1.82l-0.03,-1.44l0.63,-1.25l0.16,-1.42l-0.55,-0.91l-1.06,0.13l0.35,-1.08l-0.08,-1.1l-0.23,-0.57l-0.88,-0.52l-0.72,0.25l-0.62,0.73l-0.32,0.9l0.03,1.77l-0.3,0.25l-0.55,-0.02l-0.1,-2.28l-0.54,-0.97l-0.57,-0.09l-1.75,1.02l-0.19,1.54l0.75,0.94l-0.52,0.98l0.19,1.26l-2.07,-2.02l-1.41,-0.23l-1.13,0.35l-0.36,0.65l0.12,0.74l-1.48,1.74l-0.57,1.6l0.32,0.71l1.59,1.5l1.08,2.41l1.2,6.41l2.31,3.04l0.36,3.85l-0.65,1.88l0.4,1.02l1.03,0.66l2.06,-0.54l1.03,0.19l1.85,3.2l-0.17,1.52l0.39,0.4l1.51,0.37l-0.16,1.09l-0.47,0.87l-1.67,1.57l-1.07,2.4l-1.57,1.53l-0.99,-0.36l-0.45,-1.43l-2.96,-0.6l-3.64,-3.03l-1.66,-0.82l-1.14,0.44l-0.61,1.98l-0.56,0.69l-0.97,0.47l-0.88,-0.44l-0.41,-0.83l0.63,-1.22l-0.08,-0.85l-2.21,-1.45l-0.19,-0.65l-0.85,-0.52l-0.49,-0.89l1.35,-2.51l0.03,-0.97l-0.38,-0.52l0.07,-1.6l-0.96,-1.46l-0.21,-2.0l-0.83,-1.48l-0.83,-0.73l0.24,-0.53l2.34,-1.55l2.17,-2.14l0.53,-1.55l-0.31,-1.12l1.1,-3.45l-0.18,-1.0l-1.96,-3.91l-1.39,-2.03l2.35,-2.06l0.58,-0.87l0.55,-1.89l3.26,-0.78l2.42,0.06l1.81,-1.06l2.97,-0.59l1.28,-0.74l0.27,-0.98l-0.81,-2.2l0.14,-1.22l0.38,-0.7l1.92,-1.49l0.81,-2.07l1.37,-1.68l1.06,-2.84l1.2,-1.91l-0.03,-0.77l-0.96,-0.97l0.0,-0.62l1.1,-0.89l-0.56,-1.88l0.59,-0.57l1.79,-0.57l1.29,-1.72l0.13,-0.63l-0.6,-0.73l0.33,-1.15l-0.1,-1.04l-0.67,-1.92l-2.1,-3.28l-0.72,-3.17l-0.59,-0.68l-1.97,0.16l-2.0,-1.93l-0.9,-0.14l-0.36,-0.7l-0.99,0.05l-0.56,-0.52l-1.79,0.76l-1.18,-0.01l-0.74,0.63l-0.64,-0.02l-1.43,-0.82l-1.72,-0.3l-1.05,-1.0l-1.16,-0.1l-0.54,-0.83l-0.76,-0.27l-2.23,0.18l-0.93,1.15l-1.2,-0.18l-0.62,-0.89l0.78,-0.3l1.09,-1.02l0.27,-0.71l-0.74,-0.73l-1.94,-0.48l-2.22,0.1l-1.26,1.15l-1.17,0.12l-0.39,0.59l-0.88,-0.48l-2.81,-0.37l-1.09,0.33l-0.92,-0.47l-3.28,-0.47l-2.51,1.71l-3.97,1.63l-1.26,-0.07l-0.91,1.46l-0.86,0.49l0.13,-2.17l0.57,-0.69l6.23,-2.89l2.25,-0.54l0.72,-0.58l0.09,-0.67l-0.84,-0.74l-0.84,0.58l-0.62,-1.04l-0.47,-0.22l-0.8,0.55l-1.65,-0.21l-0.65,-1.0l-0.85,-0.27l0.11,-0.38l2.42,-0.72l0.53,-1.05l1.15,-0.65l0.56,-1.2l-1.43,-2.52l-0.3,-1.75l-1.54,-0.43l-3.64,-2.12l-0.61,-1.8l-2.26,-2.94l0.03,-1.53l-0.68,-0.68l0.5,-0.81l-0.04,-0.86l-0.47,-1.19l-0.72,-0.53l-0.37,-2.72l0.75,-0.66l2.6,-0.95l0.83,-0.85l0.99,0.2l0.51,-0.21l1.14,-1.79l0.79,-0.67l-0.81,-2.35l-1.02,-0.86l0.1,-1.29l0.34,0.21l0.6,-0.43l-0.26,-1.77l1.08,-0.7l0.18,-0.62l-0.76,-0.58l0.74,-1.51l-1.42,-0.68l-0.05,-0.97l-0.62,-0.65l0.87,-2.29l-0.41,-0.56l-0.44,0.04l-0.11,-1.16l-0.36,-0.26l-0.88,0.17l-0.49,-1.15l-0.94,0.01l-0.29,-0.67l-1.11,-0.66l-1.05,-1.92l1.12,-1.48l-0.06,-1.04l-0.85,-2.6l-2.48,-2.18l-0.53,-1.11l0.23,-0.83l-0.41,-0.93l0.54,-1.42l-1.35,-1.66l0.54,-1.2l-1.8,-3.7l-0.14,-5.52l0.56,-1.3l-0.47,-0.92l-0.03,-0.89l0.47,-1.5l-0.93,-0.73l-1.3,0.03l1.29,-1.31l-0.05,-0.56l-0.46,-0.39l-0.95,-0.01Z",name:"Uttar Pradesh"},"IN-SK":{path:"M624.09,256.17l1.74,-1.11l1.5,0.04l2.71,-2.5l1.43,1.15l2.65,0.52l2.31,1.81l-0.23,2.08l1.28,1.8l0.06,0.92l-1.46,6.18l-1.76,3.15l-0.24,1.13l0.49,0.78l-0.09,1.51l0.63,1.96l3.56,3.09l-0.14,0.55l-0.53,0.4l-1.78,0.44l-1.01,0.67l-1.42,2.94l-1.56,-0.85l-4.67,-0.11l-3.06,2.58l-1.78,0.44l-3.84,-1.72l-3.55,-0.05l-0.65,-0.3l-0.58,-1.87l-1.79,-1.32l0.79,-2.13l-0.61,-1.91l0.81,-1.92l-0.56,-1.88l2.65,-4.71l1.54,-4.54l-0.12,-1.42l0.29,-1.16l-0.51,-0.51l-1.07,-0.3l-0.48,-1.12l0.06,-0.62l0.47,-0.48l1.19,0.1l6.6,-1.18l0.74,-0.55Z",name:"Sikkim"},"IN-MZ":{path:"M743.96,392.77l0.71,0.19l0.37,-0.45l-0.14,-2.85l0.55,-1.85l-0.42,-1.43l0.33,-2.14l-0.11,-2.89l-0.65,-1.18l2.99,-0.03l-0.38,1.02l0.75,1.88l1.11,0.72l1.07,-0.2l3.08,-2.92l1.24,-0.79l-0.05,-1.35l2.53,-2.77l1.3,-3.49l2.32,3.71l1.02,0.04l1.89,-0.78l1.44,0.32l0.94,-0.24l0.11,0.82l0.68,0.79l-0.94,1.59l0.08,1.22l-0.6,3.47l-0.55,0.59l0.12,0.67l2.91,1.14l1.2,0.91l1.31,-0.55l0.72,0.69l0.62,0.01l1.32,-0.83l0.11,1.34l0.61,0.24l0.97,-0.45l0.25,1.53l1.46,2.27l0.56,5.39l1.62,1.71l0.15,1.2l-0.99,6.3l0.22,3.39l-0.91,1.69l-0.09,5.36l-1.22,2.4l-1.63,1.33l-0.58,0.03l-1.4,-1.49l-0.78,-0.25l-0.99,0.29l-0.58,0.74l0.04,2.05l0.88,1.94l0.12,0.97l-1.74,2.48l-1.23,1.16l-0.27,2.69l1.21,3.12l-0.33,2.8l0.6,1.65l1.1,1.18l0.34,1.19l0.24,3.97l-1.47,0.77l-0.09,0.62l0.38,0.78l-2.29,-0.79l-1.1,0.42l-0.08,2.78l-1.0,0.47l-0.71,1.34l0.31,2.1l-0.63,-0.79l-0.82,-0.32l-0.71,0.4l-0.47,1.47l-0.37,-1.67l-0.66,-0.91l-2.03,-1.9l-1.96,-1.42l-0.88,-0.27l-0.8,0.54l0.01,1.48l-0.37,0.18l-0.18,0.63l-0.08,1.63l-0.92,0.25l-0.78,0.79l-1.04,-4.15l0.88,-0.24l0.27,-1.25l-1.83,-11.1l-0.51,-1.55l-0.17,-4.45l-0.52,-1.11l-1.15,-1.14l-0.55,-3.59l-0.61,-0.67l-0.91,-0.36l-0.68,-1.66l0.02,-2.29l-0.78,-4.56l0.13,-1.61l0.79,-1.88l-0.27,-2.46l-0.7,-0.81l-0.08,-0.97l-0.71,-0.88l-1.55,-6.66l0.55,-2.59l-0.21,-1.75l0.23,-1.48l0.46,-0.67Z",name:"Mizoram"},"IN-CT":{path:"M376.2,561.12l-0.76,-1.04l-0.54,-2.04l-1.09,-0.57l-0.15,-0.57l0.27,-0.65l2.07,-1.28l0.36,-0.85l-0.24,-0.79l-1.82,-2.18l-0.32,-1.59l0.51,-1.14l2.36,-3.16l1.16,-4.17l1.21,-0.64l1.08,-1.84l1.03,-0.48l0.89,-1.14l0.61,-0.26l1.07,2.14l2.07,0.07l0.93,1.63l0.73,0.22l1.24,-1.17l2.22,-1.2l0.11,-0.81l-0.84,-1.42l2.23,-0.73l0.65,-1.58l-0.64,-1.49l-1.37,-1.28l-4.18,-1.73l-0.94,-2.81l-2.92,-1.34l-1.24,-2.7l-0.75,-0.22l-0.84,0.27l-0.46,0.55l-0.09,0.78l-1.61,-0.42l1.75,-0.9l0.59,-1.0l-0.24,-0.9l-1.6,-0.51l0.5,-0.9l1.91,0.56l0.81,-0.33l0.83,-4.19l-1.06,-3.19l-3.34,-0.41l0.3,-2.29l0.6,-0.47l2.53,-0.4l2.93,-1.99l0.18,-0.75l-0.42,-1.42l0.05,-2.41l0.61,-1.47l-0.41,-1.1l-0.13,-2.2l-1.6,-0.59l-2.16,0.82l0.34,-0.93l1.82,-1.1l0.25,-1.05l-0.49,-2.64l-0.19,-4.61l-0.89,-0.79l-1.73,0.09l-0.93,-1.74l0.73,-4.2l0.63,-0.84l4.35,-2.42l1.73,-2.04l0.06,-1.69l1.3,-3.97l-0.11,-3.65l0.64,-4.84l1.91,-0.95l0.61,-1.04l0.55,-1.62l-0.09,-3.28l2.01,-4.15l0.85,-0.2l1.2,1.46l0.55,-0.07l0.46,-0.5l0.09,-0.85l-0.42,-0.87l0.8,-0.52l0.42,-2.56l1.99,-1.5l0.72,-1.23l0.16,-3.55l1.21,-1.92l0.5,-0.43l0.46,0.94l1.05,0.27l3.57,-1.69l1.2,1.52l0.79,0.43l1.06,-0.45l2.76,-2.24l3.2,-1.03l0.92,-1.95l2.97,-1.77l-0.02,-1.86l0.73,-1.05l-0.19,-2.83l0.19,-0.37l2.32,-0.91l2.35,-2.12l0.23,-0.95l-0.31,-1.56l0.29,-0.66l3.67,-1.75l1.99,-0.03l0.88,-1.76l1.03,-4.6l-0.16,-1.02l-2.37,-2.04l-2.34,0.08l-0.36,-0.7l-0.98,-0.37l-2.06,-3.14l-0.79,-0.36l-1.44,-0.08l-3.16,-1.17l-0.65,0.1l-2.65,1.78l-0.44,0.01l-0.97,-2.0l0.65,-0.89l0.15,-1.17l1.07,-0.61l1.02,-1.6l-0.17,-1.22l-1.75,-3.33l0.06,-1.2l1.2,-0.2l1.84,1.89l1.03,0.75l1.08,0.3l1.09,-0.04l3.01,-1.44l1.96,0.13l2.28,1.14l3.87,0.03l1.87,0.48l8.34,0.33l1.27,-0.98l2.41,-1.15l0.77,-1.85l3.07,-1.14l0.59,-0.82l0.3,-1.29l0.83,0.21l1.66,1.52l1.43,0.77l5.35,0.26l3.78,-1.46l1.03,-1.62l0.25,-1.54l1.45,-1.09l0.74,-1.65l3.19,0.58l1.86,1.28l0.24,2.82l0.99,1.75l4.75,4.36l0.66,1.82l-0.44,2.11l1.35,2.8l1.06,0.48l1.68,-0.12l2.34,0.83l0.55,-0.55l-0.05,-1.51l1.36,-0.48l0.76,2.35l-1.89,2.51l-0.29,3.17l0.54,1.11l0.6,0.01l0.99,-0.91l0.48,0.7l0.3,1.5l-0.56,4.03l0.33,1.47l1.84,1.98l0.9,2.89l1.12,0.31l0.52,-0.4l0.04,-0.52l1.65,0.8l2.21,-0.09l0.9,0.49l0.71,2.65l-0.72,0.97l-2.99,2.18l-1.13,2.64l-2.36,1.79l-1.78,0.21l-2.14,1.78l-0.72,2.26l0.72,1.48l0.15,1.18l-1.13,1.76l-3.47,0.93l-3.65,3.0l-3.05,1.37l-2.17,2.82l-0.35,1.32l0.73,1.02l-1.48,0.97l-0.33,1.95l0.41,0.86l1.39,0.93l-0.35,1.31l0.13,0.75l-0.12,0.3l-0.98,0.13l-0.29,0.89l-1.06,-0.2l-0.46,0.37l-0.32,1.8l-3.28,5.47l-0.78,2.64l0.11,1.7l1.58,1.75l0.07,1.4l-2.14,-0.68l-0.99,0.11l-0.68,0.98l-0.1,1.33l-0.9,1.29l-0.91,2.51l-1.44,1.46l-2.01,0.14l-3.31,-2.01l-4.53,0.66l-0.98,0.41l-1.12,-0.49l-3.11,0.28l-0.56,0.45l-0.04,1.31l-2.46,4.73l-1.43,0.95l-1.59,2.2l-1.09,0.56l0.01,-0.76l-0.55,-0.52l-1.36,-0.25l-0.68,0.54l-0.09,4.18l0.72,2.52l-0.83,4.18l0.61,1.45l0.67,0.17l0.4,1.27l0.79,0.22l-0.29,3.71l0.48,1.12l0.27,3.76l-0.69,2.58l0.08,0.98l2.58,1.62l2.3,0.07l1.42,1.1l1.33,-0.5l1.05,0.06l-0.41,3.09l0.82,1.35l-3.43,2.25l0.01,-2.29l-1.81,-0.32l-1.56,-0.7l-3.66,-0.37l-0.86,0.54l-0.78,1.34l-2.46,-4.66l-0.59,-0.31l-1.08,0.07l-0.43,-0.79l-2.26,-1.77l-0.81,0.21l-0.92,1.26l-0.28,-0.91l-2.18,-2.08l-0.5,0.09l-1.32,1.38l-0.97,0.56l-1.53,2.64l-0.2,1.29l0.69,1.16l3.02,1.8l0.98,1.71l2.17,0.75l-0.29,2.12l0.41,1.88l-0.25,4.24l0.5,0.47l0.99,0.22l0.95,1.7l1.38,0.51l0.36,0.45l-0.98,1.25l0.11,0.61l0.97,0.86l-0.71,1.75l-0.07,1.21l0.69,1.82l-0.2,1.59l1.06,0.93l0.17,1.09l0.72,1.28l0.08,2.46l-1.85,1.77l-0.79,3.73l-0.61,-0.56l-0.52,-0.03l-0.99,1.69l-2.34,0.54l-1.59,1.62l-1.01,0.36l-0.27,0.97l1.23,1.04l0.02,0.59l-1.55,1.0l-3.02,2.84l-1.83,2.83l-1.7,0.58l-0.96,1.18l-3.23,1.04l-0.99,2.18l0.33,1.34l-0.54,2.23l-0.74,1.15l-0.25,2.85l-0.67,1.16l-0.18,1.23l-0.74,-0.38l-0.78,0.41l-0.23,2.18l-4.04,0.11l-2.81,-1.08l-3.48,1.96l-0.54,-0.18l-0.8,-1.55l-0.22,-3.95l-1.15,-2.66l-0.11,-1.07l0.7,-1.59l-0.22,-0.76l-1.09,-0.27l-1.63,0.55l-0.57,-2.01l-0.9,-0.47l-0.7,0.29l-0.43,1.22l-1.37,0.06l-0.16,-0.75l1.24,-0.83l0.07,-0.8l-2.14,-4.79l-2.4,-3.04l-2.13,-2.27l-1.92,-1.33l-1.32,-0.24l-1.74,0.54l-1.0,-0.81l-0.58,0.42Z",name:"Chhattisgarh"},"IN-CH":{path:"M266.15,165.51l-2.24,-2.23l-0.12,-0.55l1.16,-0.55l1.66,0.15l0.44,1.34l-0.16,1.56l-0.74,0.28Z",name:"Chandigarh"},"IN-GA":{path:"M171.13,653.34l0.82,-0.49l2.2,-0.25l0.84,-1.12l0.38,0.84l1.86,0.75l0.72,2.4l1.25,1.01l1.01,0.17l2.17,-0.81l2.03,0.13l1.31,-0.56l1.58,0.8l0.64,3.06l-0.59,1.24l0.03,0.83l0.59,0.86l0.06,1.41l1.19,1.5l0.15,1.34l-0.25,0.39l-1.24,0.3l-0.42,0.49l0.16,0.93l1.4,1.13l-1.01,2.75l0.15,2.34l-1.02,2.28l-0.76,0.39l-1.33,0.04l-1.82,1.18l-1.4,-0.88l0.06,-1.67l-0.32,-0.72l-0.99,-0.43l-1.0,-1.7l-1.34,-0.43l0.32,-0.82l0.93,-0.77l0.11,-0.61l-0.54,-0.55l-1.62,-5.41l-0.52,-0.65l-1.65,-0.3l-0.6,-0.51l2.08,0.23l0.62,-0.25l0.78,0.3l0.93,0.96l0.63,-0.35l-0.02,-0.58l-1.35,-1.45l-3.77,-1.12l0.45,-0.68l1.85,-0.72l-0.19,-0.91l-0.59,-0.35l-2.36,1.34l-0.55,-0.34l0.05,-0.87l-0.54,-1.54l0.59,-0.89l2.24,-0.65l0.3,-0.6l-0.39,-0.4l-1.74,0.07l-1.67,1.11l-0.87,-2.2Z",name:"Goa"},"IN-GJ":{path:"M0.5,399.96l0.7,-0.07l0.65,-0.85l1.21,0.35l1.42,-0.85l0.14,-0.66l-0.59,-0.43l-0.93,0.34l-0.77,-0.57l-0.51,-2.68l-0.67,0.36l0.47,-2.07l0.64,-0.96l1.64,-0.62l-0.08,-1.16l0.42,0.58l0.75,0.19l1.26,-1.22l0.45,0.24l0.9,-0.64l10.29,-0.14l0.4,-0.4l0.04,-10.49l0.51,-1.05l1.13,0.05l0.45,2.22l0.74,0.73l0.91,-0.37l1.29,-2.29l1.82,2.06l0.74,0.04l2.52,-1.05l3.13,1.14l3.52,-0.99l8.54,0.22l0.76,0.33l2.36,2.42l1.6,0.78l7.98,0.11l1.43,-0.3l1.28,-1.0l1.64,-3.28l4.06,-0.84l1.74,-1.07l2.27,-0.31l1.43,-0.97l4.1,-0.7l0.18,0.38l-0.74,0.64l-0.12,0.58l0.81,3.24l1.9,1.14l4.26,0.3l3.16,-1.22l0.2,-0.72l-0.41,-0.77l2.11,-1.57l2.5,0.12l0.86,-0.95l1.84,-0.89l-0.41,-1.47l-2.81,-0.83l0.18,-2.07l-0.72,-0.83l-0.07,-0.71l0.57,-1.53l2.65,-1.55l1.66,0.93l2.93,0.8l0.95,0.0l2.15,-0.83l2.27,0.43l1.81,-1.1l2.8,-0.18l1.22,0.17l1.61,0.83l3.68,-0.64l0.6,1.02l1.38,0.34l0.62,-0.37l0.1,-0.96l0.5,-0.3l0.41,0.01l0.74,0.75l1.17,0.13l1.71,-1.24l1.73,-0.39l1.37,1.61l2.36,0.79l1.19,0.15l3.43,-0.47l-2.31,0.59l-0.18,0.93l1.37,1.15l1.47,0.26l0.66,0.97l1.68,0.05l0.11,1.14l1.25,1.86l1.07,-0.16l0.95,-2.34l0.8,-0.05l1.64,0.97l1.95,0.54l0.81,1.65l0.86,0.74l5.67,1.0l1.08,-0.16l1.04,-0.81l0.65,-2.67l0.5,-0.68l2.52,-0.5l-0.24,2.59l0.32,0.65l2.29,0.98l1.23,-0.39l0.06,0.28l-0.47,0.73l-1.64,-0.01l-1.21,1.67l-0.94,2.61l0.78,2.06l0.54,0.75l2.28,1.54l0.5,1.22l1.44,1.4l0.56,-0.04l1.5,-1.02l1.08,-1.87l1.13,1.79l0.1,1.35l0.71,1.7l-1.66,1.34l-0.33,3.86l0.52,0.44l1.25,0.07l1.17,1.92l1.59,0.55l0.03,3.2l1.07,0.14l1.29,-1.03l1.02,0.87l0.0,2.34l0.46,1.2l-0.33,1.36l0.26,0.43l1.46,0.1l1.41,0.86l2.79,-0.78l2.48,3.21l1.08,0.17l1.17,-0.81l2.08,1.91l1.71,0.9l0.52,0.58l0.09,1.77l0.56,0.94l1.07,0.46l1.24,-0.62l0.32,0.13l0.75,0.47l1.19,2.04l1.06,0.7l1.04,2.54l0.7,3.74l0.67,0.28l0.99,-0.26l1.0,1.07l0.15,0.89l-2.47,4.86l-0.69,0.73l-2.4,0.5l-3.97,3.3l-2.47,-0.52l-1.06,0.61l-0.17,1.4l2.3,2.09l0.7,0.27l2.5,-0.14l1.17,0.57l-0.52,0.85l-1.21,0.63l-1.38,0.14l-0.87,-0.73l-0.66,-0.14l-0.64,0.34l-0.43,0.83l0.19,3.95l0.98,1.17l0.6,2.21l0.72,1.01l-0.37,1.38l-0.01,2.02l-1.86,0.34l-2.66,1.26l-0.98,0.85l-1.36,0.17l-2.94,1.25l-0.44,1.12l0.24,2.28l1.08,1.72l-0.69,1.24l-1.5,0.35l-0.49,0.63l0.39,1.13l1.62,2.41l0.55,0.29l5.43,-1.52l3.48,0.09l1.05,-0.57l1.48,0.8l2.63,-0.9l0.24,0.98l-1.57,1.06l-3.99,1.1l-1.51,-0.44l-0.73,0.2l-2.61,2.26l-1.23,3.23l-2.07,0.72l-0.67,-0.54l-0.58,-0.03l-0.41,0.34l-0.93,2.34l-2.01,1.14l-0.89,-0.22l-0.84,0.23l-2.12,-1.04l-0.82,0.35l0.24,1.02l1.22,1.18l1.38,0.77l2.01,-0.03l1.03,1.36l1.56,0.58l2.32,2.59l0.99,2.76l0.19,3.31l-0.49,0.92l-2.42,2.07l-0.13,1.4l-0.42,0.84l-2.66,1.32l-1.84,0.02l-1.33,-1.63l-3.25,-1.89l-1.11,-1.53l-0.78,0.14l-0.93,1.49l-1.29,0.62l-0.04,0.76l1.28,0.48l0.25,1.12l0.99,0.4l0.28,1.19l-2.99,5.31l0.78,1.33l0.23,1.97l-0.49,1.57l0.17,0.94l-3.44,-0.35l-0.69,0.66l-0.27,1.36l-1.1,0.52l-0.38,-0.06l-0.01,-1.51l-0.72,-0.56l-1.37,-0.12l-0.43,0.32l-0.21,0.95l-0.95,0.04l-0.36,-1.68l2.24,-1.3l0.45,-0.95l-0.35,-0.68l-1.23,-0.09l0.08,-1.11l-0.81,-0.47l-2.07,1.39l-1.14,-0.0l-0.65,1.29l-1.14,-0.15l-0.55,0.41l-0.11,0.95l1.46,1.36l0.23,1.61l-1.88,0.66l-1.35,-0.06l-0.65,0.32l-1.02,-0.24l-1.45,0.83l0.73,-2.93l0.57,-1.06l-0.41,-0.59l0.18,-1.49l0.99,-2.09l0.98,-0.77l1.51,-0.17l0.65,-0.65l-0.08,-1.64l-0.77,-1.03l0.99,-1.77l-0.03,-2.84l0.62,-1.11l-0.07,-2.45l1.33,-1.05l-0.21,-0.59l-0.63,-0.42l-0.03,-1.1l-0.67,-0.08l-0.38,0.46l-0.11,-0.45l0.53,-1.02l-0.21,-0.61l-1.26,0.33l0.35,-1.15l-0.63,-0.76l1.16,-0.71l0.28,-0.98l-0.44,-0.43l-1.52,0.3l-0.45,-0.77l-1.18,-0.59l1.25,0.19l0.67,-0.14l0.43,-0.53l-1.08,-2.77l-0.57,-0.44l-1.51,0.57l-0.74,-0.19l0.11,-0.83l-0.45,-0.52l-0.52,-0.03l1.22,-0.68l-0.09,-0.44l-1.49,-0.75l-1.09,-0.93l-0.03,-0.45l-0.63,-0.3l-0.58,0.41l-0.15,-0.32l-0.44,-1.87l1.42,-0.28l0.28,-0.74l-0.56,-0.42l-1.68,0.12l1.8,-0.54l2.67,-1.74l0.35,0.25l0.59,-0.15l0.08,-1.13l-0.83,-0.39l-2.31,0.85l-1.68,1.13l0.77,-1.49l2.09,-1.65l2.56,-1.29l1.44,-1.98l1.44,0.24l2.03,-0.72l0.96,-0.67l4.65,-1.88l0.51,-0.51l0.13,-0.73l-0.86,-0.4l-3.05,1.6l-2.75,0.95l-2.09,-0.31l-1.84,0.69l-1.99,-0.44l-1.81,0.3l-1.83,-0.23l-2.19,0.51l-0.03,-0.91l0.75,-1.97l0.26,-2.24l0.6,-0.39l1.0,-2.09l0.74,-0.36l1.38,-0.01l0.52,-0.51l0.26,-0.88l0.74,-0.47l-0.31,-0.63l-1.03,0.01l-0.6,0.71l-2.18,0.28l-2.07,1.63l-0.98,-1.7l1.19,-5.61l0.93,-1.11l0.97,-0.45l1.83,0.91l0.97,-0.07l1.05,0.62l0.56,-0.08l1.83,-2.13l0.87,-0.16l1.4,0.83l0.95,-0.34l0.39,-1.48l-0.64,-1.05l-0.97,0.51l-1.22,-0.43l-0.84,0.08l-1.89,0.94l-2.79,-0.93l-1.08,0.05l-1.68,-0.54l-0.77,0.2l-1.65,1.38l-0.67,0.2l0.15,-0.47l-0.39,-0.52l-1.99,0.41l-0.25,-1.46l0.75,-0.74l0.1,-0.66l-0.41,-0.73l-0.48,-0.12l-1.3,0.92l-0.97,2.53l-1.14,-0.05l-0.41,-1.1l-0.83,-0.23l-1.09,0.05l-0.53,0.76l-1.33,-0.02l-0.2,0.66l0.68,0.67l1.07,0.28l0.85,-0.5l0.31,0.91l0.9,0.39l1.02,-0.03l0.24,1.05l-0.28,3.28l-1.38,1.94l-1.79,0.18l-0.67,0.89l-0.99,-0.87l-1.35,-0.09l-0.31,0.32l0.18,0.41l0.66,0.43l-0.97,-0.27l-0.45,0.17l0.18,0.63l-1.59,0.61l0.15,0.67l1.89,0.64l1.44,-0.1l0.69,0.88l-0.18,0.92l-1.97,-1.61l-0.75,-0.2l-0.45,0.23l-0.2,1.02l1.11,0.46l0.3,0.48l-2.34,-0.84l-0.76,0.39l0.16,2.39l0.61,0.07l0.52,0.59l1.44,-0.43l1.41,0.38l1.26,-0.46l0.97,1.2l0.7,1.57l0.66,0.39l0.82,0.02l0.65,0.95l0.03,0.91l-0.66,0.75l-1.0,3.65l-2.24,2.74l-0.51,1.07l-1.35,1.36l-0.58,2.43l0.41,1.27l-3.25,1.99l-2.05,0.24l-4.99,3.12l-1.45,0.04l-2.41,1.15l-1.67,1.19l0.07,-0.5l-1.13,0.05l-1.81,1.46l-0.9,1.36l-4.4,1.16l-5.39,2.64l-1.52,0.13l-0.92,0.73l-2.44,0.05l-0.65,0.93l-3.65,0.22l-0.99,-0.18l-0.85,-0.59l-1.16,0.23l-1.21,-0.86l-4.8,-1.96l-2.71,-1.5l-1.64,-1.54l-1.94,-0.78l-8.52,-7.09l-3.03,-3.95l-3.49,-3.74l-0.87,-1.33l-0.17,-0.96l-1.73,-1.02l-3.88,-4.04l-1.94,-1.14l-2.67,-3.2l-1.63,-1.0l-0.84,-1.01l-0.18,-1.89l-0.66,-0.19l-0.63,0.59l-0.54,-0.17l-4.18,-3.73l-1.45,-1.96l-1.46,-1.14l-1.7,-2.63l-1.65,-1.48l-1.47,-2.81l0.88,-3.29l0.5,-0.76l1.32,-0.83l-0.26,0.75l1.01,1.24l0.67,0.08l1.02,-0.44l0.83,0.17l0.94,-0.69l0.25,0.21l-1.03,2.68l0.24,0.84l1.52,1.23l2.4,-0.38l1.52,-0.7l0.65,-0.71l2.26,-0.04l1.51,-0.42l1.45,-1.37l0.19,-0.7l-0.34,-1.28l0.36,-0.06l0.3,2.26l1.88,0.7l0.59,-0.29l0.11,-0.39l0.69,-0.13l0.66,-0.9l0.59,0.21l0.46,-0.2l0.83,-2.0l1.53,1.64l0.7,-0.0l0.95,-1.43l1.58,-0.33l2.54,-2.09l2.6,-0.59l2.59,0.34l1.25,-0.49l4.5,-7.15l0.16,-1.52l1.55,-2.48l2.22,-1.93l1.09,0.04l0.73,-0.69l0.69,-1.43l0.07,-0.9l-0.87,-2.13l-1.25,-0.94l-2.24,1.56l-0.43,0.78l0.33,1.53l-0.31,2.26l-1.2,0.23l-0.53,-0.37l-0.68,0.08l-0.97,-0.5l-1.1,-1.31l-0.65,0.29l-0.22,1.03l-1.45,0.21l-0.85,-0.55l-0.06,-0.82l-0.53,0.16l-0.65,1.13l0.61,0.91l-1.78,0.22l-2.05,0.8l-5.13,1.18l-2.35,1.7l-1.17,1.86l-1.81,-0.42l-2.04,-0.02l-0.85,-0.55l-1.78,-0.11l-5.03,-1.67l-4.08,-0.59l-4.99,-3.19l-5.31,-2.24l-6.42,-4.41l-0.28,-0.83l-0.74,-0.31l-0.42,-0.6l0.49,-0.71l0.1,-0.83l-0.57,-0.36l-1.75,0.26l-0.15,-0.25l0.45,-0.89l1.3,-0.27l0.19,-0.55l-1.43,-1.28l-1.29,-0.24l-0.08,-0.55l0.78,-0.72l-0.27,-0.47l-1.15,-0.11l-0.95,0.55l-0.06,-1.22l-1.08,0.26l1.83,-2.32l-0.14,-0.36l-0.86,-0.1l-0.56,-0.78l-0.49,-0.1l-0.21,0.45l0.29,1.18l-0.41,0.11l-0.0,-3.49l2.18,0.23l0.39,-0.38l0.04,-0.61l-0.48,-0.5l1.61,-0.59l1.53,-1.82l1.55,-0.78l1.08,-1.78l1.61,-0.09l3.07,-2.0l-0.09,-0.69l-0.8,-0.19l-1.32,0.28l-1.37,1.12l-2.52,0.25l-0.62,0.52l-0.65,1.24l-5.16,2.14l-2.79,3.05l0.2,0.67l-0.49,0.4l-4.27,-0.24l-0.75,-0.44ZM141.04,481.24l-0.02,0.35l-0.14,0.07l0.03,-0.2l0.13,-0.22ZM139.1,480.22l0.01,0.97l-0.7,0.34l-0.26,-0.5l0.95,-0.81ZM28.19,437.73l0.34,-0.24l-0.1,0.14l-0.23,0.1Z",name:"Gujarat"},"IN-RJ":{path:"M113.16,366.39l-0.79,-0.19l-0.82,-1.14l-3.88,0.61l-1.37,-0.78l-1.49,-0.21l-3.05,0.21l-1.75,1.08l-2.15,-0.45l-2.94,0.83l-2.75,-0.76l-1.27,-0.83l-0.91,-0.2l-1.55,-3.64l-2.68,-4.47l-2.06,-7.11l-3.54,-3.49l-0.79,-2.29l-1.64,-1.88l-0.21,-1.01l0.33,-6.6l-0.19,-1.6l-0.91,-1.04l-1.23,-0.24l-3.67,1.06l-3.52,0.09l-2.79,-0.74l-0.75,-0.92l-0.69,-1.91l-3.03,-3.12l-0.94,-1.52l-0.54,-1.56l0.29,-3.26l1.77,-3.12l0.63,-2.52l-0.28,-1.98l0.55,-1.87l-0.16,-5.57l-1.0,-1.17l-2.36,-0.91l-7.44,0.28l-1.19,-0.44l-3.46,-2.72l-4.77,-1.9l-0.82,-0.89l-0.21,-1.18l1.29,-7.93l0.8,-2.43l1.22,-2.0l8.35,-7.32l1.89,-2.92l2.65,-2.47l0.77,-1.08l2.56,-6.91l7.24,-6.53l3.37,-0.9l2.19,0.73l2.89,2.68l0.22,2.51l0.96,2.12l1.23,1.73l1.86,1.21l2.15,0.28l2.76,-0.58l7.27,-3.47l2.28,-0.75l5.18,-0.75l5.05,-0.01l9.45,-2.8l0.73,-1.01l0.37,-4.13l0.46,-1.13l2.41,-3.02l5.04,-4.28l1.5,-3.1l1.81,-6.71l0.69,-1.31l2.22,-2.6l16.76,-8.5l1.03,-0.96l1.04,-2.37l2.71,-3.73l5.61,-10.36l4.24,-13.14l5.55,-2.7l5.67,-1.24l1.25,-0.68l5.27,-4.38l0.01,1.53l-2.58,4.47l0.0,0.93l0.33,0.34l15.39,0.72l3.64,0.48l0.02,0.94l0.94,0.93l0.04,0.52l-2.13,1.4l-0.59,2.13l0.48,0.91l1.08,0.31l2.26,-0.71l0.48,-0.41l0.19,0.23l-0.67,2.55l-0.26,2.85l0.37,1.18l0.79,0.98l-0.07,1.22l-0.19,0.37l-1.73,0.3l-0.34,0.95l2.48,3.97l1.17,-0.0l0.51,-1.04l3.42,-0.01l1.87,-1.25l2.62,1.15l1.36,2.74l1.0,0.28l1.28,-0.27l0.65,1.25l0.71,0.48l2.28,-0.55l0.86,-0.67l1.03,0.64l1.26,-0.12l1.93,-1.4l-0.21,1.19l0.37,0.73l0.69,0.23l1.08,-0.74l0.54,1.48l-0.83,0.46l-0.2,0.49l0.54,1.33l0.0,1.06l1.94,2.91l1.92,0.98l-0.02,0.67l-0.77,0.56l-0.22,0.85l3.34,9.56l3.35,4.22l2.17,1.57l-0.14,0.74l0.33,0.67l1.41,0.08l2.09,0.88l2.08,1.93l2.08,2.67l1.58,2.67l-0.7,-0.71l-0.52,-0.07l-1.05,1.15l-1.53,0.73l-0.43,0.67l0.27,0.88l0.98,0.7l0.61,-0.02l0.86,-0.7l-1.13,1.37l-0.82,1.64l0.59,0.99l-0.48,0.39l-0.91,-0.04l-0.45,0.81l0.15,0.87l1.22,0.93l0.58,1.57l0.74,0.31l3.48,-0.31l1.76,1.41l1.39,-0.66l0.29,-1.0l-0.42,-1.48l-0.6,-0.68l-0.03,-1.56l-0.65,-2.07l0.15,-1.09l0.22,-0.27l1.06,0.2l1.09,-0.39l1.6,1.04l1.18,-0.25l0.39,-0.55l0.02,-0.94l-1.13,-0.83l0.85,-0.33l0.02,-0.98l0.68,0.29l2.29,-0.31l0.49,0.72l-0.59,-0.08l-0.38,0.31l0.06,0.73l0.66,0.56l-0.57,0.47l0.03,0.51l1.42,0.83l0.92,0.06l0.52,1.73l0.97,0.65l1.15,-1.04l2.04,-0.52l0.28,-0.58l-0.44,-1.85l3.39,-2.44l1.36,-1.92l1.01,-0.38l2.42,2.36l0.15,0.52l-0.65,2.79l0.52,2.35l0.19,3.84l-0.86,1.6l-0.46,2.44l0.4,1.04l-0.58,0.37l-0.03,0.84l0.72,0.56l2.1,-0.25l1.27,-1.76l2.05,-0.4l0.26,-0.81l-1.3,-0.89l0.24,-0.53l1.97,0.6l0.71,-0.1l0.6,-0.56l0.81,0.49l0.58,-0.41l0.82,0.59l0.81,-0.67l0.38,0.07l0.36,2.7l0.84,0.78l0.33,0.85l0.04,0.6l-0.52,1.02l0.73,0.91l0.01,1.61l2.3,3.01l0.95,2.22l1.87,0.74l1.89,1.31l1.14,0.19l0.15,1.49l0.75,1.73l0.61,0.61l-0.36,0.58l-1.2,0.7l-0.31,0.83l-2.57,0.82l-0.37,0.89l0.3,0.66l0.88,0.32l0.64,1.0l2.23,0.36l0.7,-0.5l0.87,1.25l-1.42,0.37l-6.42,3.0l-0.85,1.15l-0.02,2.84l0.73,0.32l0.77,-0.2l1.26,-1.79l1.15,0.07l4.09,-1.67l2.33,-1.65l2.98,0.47l0.85,0.51l1.05,-0.35l2.89,0.35l1.09,1.2l0.67,-0.29l0.09,-1.11l1.09,-0.08l1.28,-1.16l1.69,-0.04l2.02,0.57l-0.98,0.92l-1.12,0.42l-0.05,0.72l0.66,0.88l-0.85,0.24l-0.1,0.82l-1.0,-0.26l-0.95,0.2l-0.54,3.52l-0.93,0.02l-0.98,-0.46l-1.99,0.86l-1.51,0.22l-0.57,0.55l-0.21,0.79l-1.71,0.58l-0.26,0.53l0.27,0.69l-2.38,1.08l-0.92,1.0l-2.98,0.75l-3.21,2.22l-2.11,0.06l-0.56,0.59l-0.11,0.9l-2.76,0.32l-1.52,2.06l-2.32,1.81l-2.65,0.18l-0.91,0.72l-0.32,0.96l-1.97,0.47l-0.92,1.2l-1.56,1.0l-1.05,0.28l-0.68,1.19l-2.24,1.52l-0.52,1.68l-0.79,0.35l-0.93,1.01l-2.88,0.01l-0.79,1.22l-0.84,0.14l-1.36,1.03l-1.09,1.85l-0.12,1.68l-1.03,0.59l1.24,6.15l1.02,3.16l1.64,0.79l1.23,1.75l2.04,0.43l1.85,1.25l0.57,0.11l1.26,-0.41l1.39,0.2l1.84,1.04l0.77,-0.39l1.71,0.0l2.77,-1.21l2.19,0.5l1.34,-0.62l0.88,-1.95l0.69,-0.54l1.52,-0.36l0.69,0.22l0.38,0.55l-0.47,1.46l0.69,1.45l-0.15,1.82l1.16,1.77l-0.39,1.97l-1.43,1.01l-1.76,-0.7l-1.13,0.24l-1.06,-0.21l-3.5,1.17l-2.7,0.19l-4.12,1.59l-0.88,1.16l-0.03,0.67l0.99,2.1l0.11,1.21l-0.8,0.67l-1.8,0.4l-0.46,0.59l0.01,0.63l2.21,2.47l1.07,0.57l2.33,0.03l1.64,1.33l0.87,1.46l0.43,2.21l-0.59,0.95l-3.32,1.33l-0.31,-0.01l-0.09,-0.98l-0.76,-1.19l-1.72,-0.45l-0.99,0.55l0.19,7.02l0.56,1.52l1.87,2.64l-0.75,1.42l-2.66,0.44l-2.87,-1.98l-0.29,-0.38l0.59,-1.58l-0.65,-0.89l-1.49,0.26l-1.32,0.66l-0.62,0.81l-0.38,1.25l-0.93,0.27l-0.8,-1.35l-0.81,-0.46l-2.36,0.15l-2.37,-0.75l-2.62,0.03l-0.56,-0.65l-0.06,-1.39l-0.91,-0.21l-1.44,0.8l-0.41,0.77l-0.22,5.75l-0.91,1.03l-3.07,2.04l-0.18,0.86l0.58,0.69l-0.36,0.8l-2.54,1.42l-3.18,1.16l-1.39,-1.09l-0.78,0.05l-0.42,0.67l0.21,1.39l-0.75,1.99l-1.04,-0.67l-1.53,-0.23l-0.54,-1.73l-2.26,-1.43l-0.39,-0.57l-0.11,-1.38l0.73,-1.34l0.34,-0.08l2.56,1.5l0.99,-0.14l1.03,-0.78l1.53,0.76l2.78,-3.75l-0.19,-0.69l-1.38,-0.85l-0.38,-0.73l0.33,-1.04l1.14,-1.39l0.31,-1.44l-0.35,-1.02l-1.31,-0.83l-0.49,-2.5l0.29,-1.27l0.46,-0.6l2.12,0.79l0.87,-0.42l0.54,-0.87l-0.12,-3.35l-1.72,-2.18l-0.08,-1.9l-1.45,-1.82l-0.93,-0.39l-1.02,0.2l-2.12,1.19l-6.1,1.13l-1.71,-0.05l-2.46,-0.66l-2.71,0.12l-0.69,-0.28l-0.43,-0.95l1.0,-1.04l0.14,-0.7l-0.82,-1.9l1.39,1.33l1.73,0.45l2.43,-0.55l1.29,-1.43l-0.03,-0.57l-0.61,-0.38l-3.06,0.55l-1.27,-0.53l0.04,-0.32l1.57,0.36l0.71,-0.62l-0.09,-0.83l-0.78,-1.15l0.96,-1.84l-0.38,-0.68l-2.77,0.61l-2.39,-0.18l-0.87,0.22l-1.43,2.29l0.29,1.74l-0.19,0.81l-1.27,-0.2l-1.56,1.09l-2.66,-1.04l-1.24,-1.01l-1.28,-0.2l-0.46,0.24l-0.21,0.62l0.68,2.0l-0.19,1.6l0.21,0.59l3.12,0.55l1.1,-0.15l0.1,0.39l-0.55,2.44l-0.6,0.36l-1.68,0.1l-1.61,-1.83l-0.62,-1.83l-0.6,-0.15l-0.56,0.47l-0.19,2.47l0.42,1.11l-2.09,4.22l-0.12,0.98l0.53,0.75l3.35,1.05l0.25,0.61l-2.43,2.42l-0.39,1.79l-0.73,1.25l0.16,0.52l0.56,0.3l2.45,-0.12l1.2,0.69l0.89,3.8l2.05,2.4l-0.64,1.04l-1.18,3.43l-0.18,1.43l0.11,2.2l0.8,1.33l0.19,1.94l-2.53,4.99l-0.87,0.81l-5.89,2.59l-2.01,1.8l-1.52,2.59l0.02,1.08l0.6,0.72l2.45,0.79l1.39,0.05l1.5,1.36l-2.98,1.57l-1.93,0.47l-2.21,1.15l-2.7,-0.33l-1.68,0.98l-0.59,-0.97l-0.83,-0.47l-1.34,-2.19l-1.43,-0.75l-1.43,0.61l-0.48,-0.26l-0.72,-2.86l-2.18,-1.34l-2.15,-1.97l-0.91,-0.2l-0.73,0.85l-0.66,-0.04l-2.15,-2.97l-0.57,-0.34l-2.93,0.76l-1.14,-0.82l-1.17,0.04l0.32,-1.25l-0.46,-1.22l0.13,-1.76l-0.24,-0.9l-1.4,-1.24l-0.65,0.06l-1.41,1.07l0.32,-2.39l-0.31,-0.73l-1.75,-0.71l-1.19,-1.94l-1.47,-0.23l0.28,-3.15l1.47,-1.08l0.28,-0.53l-0.77,-1.97l-0.12,-1.42l-1.32,-2.1l-0.38,-0.24l-0.65,0.19l-1.13,1.93l-1.34,0.87l-0.98,-1.08l-0.62,-1.36l-2.63,-2.03l-0.7,-1.62l0.87,-2.35l0.88,-1.21l1.13,0.05l0.78,-0.31l0.62,-1.27l-0.18,-0.76l-0.43,-0.3l-1.27,0.38l-1.91,-0.74l0.23,-2.35l-0.43,-1.01l-1.21,-0.11l-2.26,0.63l-0.78,1.08l-0.46,2.35l-0.86,0.68l-0.6,0.06l-1.89,-0.53l-3.52,-0.4l-1.51,-2.29l-2.14,-0.65l-1.84,-1.02l-1.46,0.26l-0.78,2.15l-0.36,0.2l-0.92,-1.62l-0.24,-1.27l-1.85,-0.15l-0.62,-0.94l-1.53,-0.29l-0.97,-0.75l2.33,-0.44l0.22,-0.89l-0.68,-0.67l-4.54,0.35l-2.17,-0.71l-1.13,-1.44l-0.59,-0.29l-2.11,0.47l-1.51,1.18l-0.76,-0.09l-0.9,-0.81l-0.82,0.05l-0.91,0.64l-0.15,0.93ZM294.16,288.97l0.26,-0.35l0.11,-0.1l-0.05,0.3l-0.31,0.15ZM252.61,250.52l-0.88,-0.6l-0.15,-0.41l0.59,0.24l0.44,0.77Z",name:"Rajasthan"},"IN-MP":{path:"M191.91,423.84l-0.52,-3.36l-0.53,-1.39l0.74,-0.61l0.77,-0.34l2.88,0.29l2.23,-1.16l1.99,-0.5l3.36,-1.88l-0.0,-0.75l-1.53,-1.53l-4.03,-0.93l-0.42,-0.88l1.39,-2.39l1.85,-1.66l5.83,-2.55l1.04,-0.94l1.49,-3.12l1.15,-1.64l0.11,-1.95l-0.24,-1.12l-0.77,-1.25l-0.08,-1.88l0.16,-1.29l1.86,-4.79l-2.14,-2.67l-0.45,-2.8l-0.59,-1.21l-1.63,-0.91l-2.47,0.1l0.66,-1.0l0.32,-1.64l1.74,-1.48l0.81,-1.32l-0.17,-0.87l-0.45,-0.45l-3.45,-1.11l-0.08,-0.37l2.2,-4.61l-0.4,-1.42l0.1,-1.99l0.36,1.48l0.95,0.81l0.7,1.18l0.53,0.26l1.56,-0.03l1.01,-0.34l0.72,-0.72l0.5,-2.94l-0.75,-0.84l-1.19,0.14l-2.6,-0.34l0.17,-1.7l-0.66,-1.97l0.84,0.14l1.09,0.93l2.15,1.06l1.16,0.09l1.62,-1.1l1.02,0.31l0.63,-0.38l0.36,-1.3l-0.29,-1.62l1.1,-1.75l2.84,0.09l2.19,-0.57l-0.84,1.67l0.9,1.76l-1.84,-0.24l-0.48,0.64l0.06,0.81l0.84,0.71l1.12,0.24l2.91,-0.55l-1.3,1.1l-1.61,0.23l-1.34,-0.35l-1.47,-1.38l-0.77,0.01l-0.33,0.88l0.81,1.84l-0.85,0.94l-0.32,0.92l0.8,1.39l1.08,0.43l2.69,-0.13l2.41,0.65l1.95,0.06l6.25,-1.16l2.89,-1.35l0.81,0.55l0.9,1.26l0.02,1.76l1.69,2.09l0.14,2.99l-0.72,0.67l-1.35,-0.77l-1.15,0.13l-0.74,0.98l-0.34,1.56l0.56,2.82l1.31,0.91l0.28,0.62l-0.23,1.1l-1.45,2.03l-0.07,0.88l0.25,0.76l1.62,1.36l-2.15,2.93l-1.36,-0.75l-1.75,0.95l-3.0,-1.53l-0.78,0.44l-0.86,1.74l0.13,1.58l0.39,0.76l2.43,1.6l0.49,1.72l0.33,0.26l1.63,0.23l0.86,0.6l0.71,0.05l0.53,-0.62l0.69,-1.91l-0.18,-1.56l1.04,0.97l0.88,0.15l3.38,-1.22l2.74,-1.55l0.62,-1.43l-0.58,-1.02l2.89,-1.87l1.22,-1.46l0.23,-5.8l1.25,-0.97l0.03,1.13l0.96,1.07l0.65,0.22l2.18,-0.18l2.45,0.76l2.27,-0.16l0.37,0.22l0.5,1.22l0.8,0.37l1.54,-0.47l0.94,-2.01l2.1,-0.79l-0.46,2.16l2.85,2.18l0.96,0.53l3.22,-0.59l1.09,-2.16l-2.28,-3.57l-0.43,-4.0l0.27,-1.37l-0.24,-1.82l1.59,0.28l0.46,1.83l1.11,0.44l3.72,-1.46l0.82,-0.85l0.14,-0.79l-0.48,-2.47l-1.05,-1.74l-1.9,-1.51l-2.48,-0.08l-0.78,-0.44l-1.9,-2.1l0.23,-0.33l1.92,-0.41l0.89,-0.95l-0.08,-1.74l-0.97,-2.28l0.51,-0.72l3.91,-1.51l2.67,-0.19l3.37,-1.16l1.06,0.21l0.95,-0.26l1.95,0.71l1.88,-1.18l0.37,-0.58l0.33,-2.13l-1.25,-2.17l0.23,-1.44l-0.69,-1.42l0.48,-1.43l-0.97,-1.29l-1.87,-0.11l-1.6,0.8l-0.94,1.95l-0.61,0.55l-2.56,-0.43l-2.91,1.24l-1.6,-0.03l-0.73,0.39l-1.59,-1.02l-1.63,-0.22l-1.33,0.41l-1.98,-1.3l-1.68,-0.23l-1.39,-1.83l-1.51,-0.67l-0.88,-2.84l-1.3,-5.49l1.02,-0.67l0.31,-2.18l0.62,-1.04l1.1,-0.9l1.23,-0.38l0.55,-1.06l2.42,0.18l0.59,-0.28l0.95,-1.02l0.89,-0.44l0.58,-1.75l2.19,-1.47l0.56,-1.08l0.9,-0.2l1.61,-1.02l0.91,-1.21l2.0,-0.48l0.62,-1.26l0.58,-0.41l2.55,-0.13l2.61,-2.01l1.39,-1.95l2.46,-0.14l0.69,-0.61l0.16,-0.98l2.14,-0.08l3.22,-2.23l3.09,-0.81l0.88,-0.97l2.69,-1.32l-0.1,-1.03l1.58,-0.6l0.61,-1.23l1.4,-0.18l1.79,-0.82l1.11,0.48l1.32,-0.23l0.74,-2.26l-0.13,-1.3l1.54,0.32l0.58,-0.57l0.06,-0.52l1.15,-0.19l1.1,0.21l1.15,-1.25l2.21,0.06l0.6,0.87l1.21,0.11l1.07,1.0l1.77,0.32l1.5,0.84l1.12,-0.0l0.65,-0.6l1.15,0.01l1.42,-0.73l0.31,0.53l0.62,0.09l0.33,-0.27l0.47,0.74l0.85,0.09l2.08,1.98l1.97,-0.15l0.92,3.46l2.47,4.19l0.31,1.69l-0.36,1.13l0.63,0.93l-1.09,1.53l-1.67,0.49l-0.96,0.95l-0.03,1.06l0.54,0.96l-0.96,0.59l-0.16,1.24l1.03,1.32l-1.17,1.84l-1.04,2.8l-1.41,1.74l-0.79,2.01l-2.15,1.79l-0.42,1.83l0.82,2.19l-0.08,0.67l-0.87,0.47l-3.09,0.63l-2.0,1.1l-2.01,-0.16l-3.47,0.83l-0.72,0.75l-0.3,1.66l-0.43,0.6l-2.48,2.28l0.14,1.03l1.3,1.67l2.05,4.43l-1.1,3.43l0.3,1.25l-0.41,1.16l-1.97,1.91l-2.39,1.59l-0.5,1.2l1.73,2.46l0.18,1.91l0.95,1.42l-0.09,1.58l0.4,0.6l-0.05,0.55l-1.41,2.68l0.63,1.3l0.81,0.48l0.33,0.83l2.13,1.35l-0.66,2.0l1.03,1.4l1.2,0.28l1.31,-0.64l0.68,-0.76l0.44,-1.78l0.54,-0.38l1.29,0.66l3.7,3.07l1.13,0.44l1.71,0.11l0.29,1.21l0.51,0.5l1.39,0.24l2.0,-1.84l1.09,-2.43l1.6,-1.48l0.61,-1.1l0.21,-1.63l-0.77,-0.66l-1.18,-0.2l0.18,-1.5l-0.89,-1.24l-0.76,-1.86l-1.56,-0.8l-2.6,0.54l-0.4,-0.6l-0.1,-0.69l0.64,-1.42l-0.4,-4.14l-2.32,-3.07l-0.93,-5.45l-1.38,-3.44l-1.82,-1.91l0.46,-1.11l1.51,-1.78l-0.04,-0.98l0.34,-0.29l1.63,0.2l1.78,1.89l1.0,-0.11l0.24,-0.64l-0.22,-1.03l0.54,-1.16l-0.8,-1.21l0.38,-1.0l1.02,-0.28l0.21,2.56l0.28,0.42l0.67,0.24l1.06,-0.34l0.39,-0.55l0.01,-2.04l0.8,-1.02l0.43,0.73l-0.35,2.05l0.5,0.45l1.11,-0.0l-0.13,1.21l-0.65,1.35l0.06,1.31l-1.51,1.2l-0.74,1.59l0.05,1.24l0.86,0.77l1.08,-0.45l0.92,-1.08l1.46,-0.63l0.23,-1.37l0.95,0.5l-1.07,1.61l0.14,0.88l0.53,0.5l2.51,-0.66l0.27,1.38l0.64,0.34l0.66,-0.28l0.8,-0.96l3.2,0.58l0.73,-0.83l-0.57,-2.42l0.54,0.56l0.59,0.1l1.28,-1.19l1.03,0.15l0.67,-0.35l-1.84,2.96l-0.99,1.04l-0.22,2.1l0.69,0.76l1.57,0.06l0.34,-0.27l0.21,-2.05l0.73,0.13l0.64,1.13l0.95,-0.04l2.13,-2.35l2.82,0.98l3.59,-0.24l0.55,0.59l0.71,0.2l2.3,-1.07l-0.01,-0.76l-0.98,-1.46l0.31,-0.53l1.98,-0.41l3.08,-2.33l2.01,-0.92l1.31,0.28l1.46,-1.05l0.73,-1.06l0.9,0.24l1.34,-0.26l0.81,1.27l0.36,2.78l1.13,0.71l0.62,0.83l0.69,-0.02l0.56,1.65l-1.97,1.05l-1.44,1.71l-0.96,-0.01l-0.34,0.31l0.1,1.75l0.99,1.21l1.85,-0.32l1.64,0.37l0.55,-0.44l0.02,-0.69l0.89,0.96l1.03,-0.11l1.14,-0.73l0.14,-0.7l-1.44,-0.98l-0.23,-0.67l1.41,0.35l0.98,-0.14l0.49,-0.56l-0.02,-0.89l0.91,1.49l1.19,1.06l2.66,-0.26l0.57,-0.45l-0.02,-0.8l-1.53,-1.17l2.9,-0.26l0.82,-1.55l0.76,-0.22l0.37,0.5l-0.88,2.05l-0.17,1.21l-0.87,0.88l-0.27,1.12l-0.71,0.9l-0.01,0.88l0.65,0.49l1.01,0.13l2.85,-0.5l1.42,1.01l1.82,-0.42l2.77,1.85l0.48,-0.11l0.95,-1.14l1.13,-0.17l0.55,-0.44l-0.19,-1.79l1.86,-2.5l0.21,-1.01l-0.21,-1.35l1.88,-0.09l1.44,0.45l0.14,1.38l1.85,0.38l1.28,-0.26l0.5,-0.44l-0.0,-0.94l-0.92,-0.68l2.58,-0.76l1.08,2.35l-0.2,0.73l0.3,0.56l2.82,0.72l1.28,-0.01l0.48,1.09l0.94,0.37l1.83,-0.48l0.75,0.19l0.86,1.37l-0.24,1.06l0.26,0.65l2.72,2.08l2.45,0.41l2.82,1.69l0.96,-0.18l1.48,-1.0l-0.13,2.39l0.86,0.49l0.92,-0.62l0.09,1.92l0.52,0.37l0.8,-0.12l0.35,0.24l-0.59,1.47l0.13,0.65l3.0,0.17l0.76,-0.21l0.66,-0.93l-0.07,-1.74l4.89,1.07l3.33,-1.1l0.09,1.22l0.4,0.33l1.39,0.15l0.54,1.49l0.68,0.8l-0.36,0.47l-1.52,-0.19l-0.64,0.68l0.2,2.3l-0.31,2.05l0.32,0.63l0.66,0.4l0.01,2.03l-0.73,1.7l-0.24,1.96l-0.48,0.42l-0.99,0.18l-0.36,0.6l0.51,1.13l1.45,1.26l-0.08,1.5l1.94,2.08l-0.51,1.73l-3.3,1.36l-0.49,0.55l-0.31,1.33l-2.3,1.07l-1.01,0.87l-0.88,0.08l-7.25,-0.43l-1.86,-0.49l-3.75,-0.02l-2.21,-1.13l-2.21,-0.16l-3.22,1.48l-0.71,0.02l-1.74,-0.88l-1.97,-1.98l-1.49,-0.09l-0.93,0.68l0.04,1.82l1.74,3.3l0.13,0.87l-0.82,1.16l-1.16,0.74l-0.2,1.29l-0.68,0.92l1.15,2.78l0.98,0.35l3.34,-1.97l2.94,1.13l2.03,0.35l1.91,3.02l1.05,0.45l0.42,0.74l2.45,-0.02l2.02,1.71l-0.93,5.0l-0.6,1.3l-1.71,-0.05l-4.13,2.09l-0.4,0.98l0.22,2.14l-2.16,1.95l-2.51,1.09l-0.4,1.44l0.25,2.13l-0.72,1.02l0.15,1.54l-2.9,1.71l-0.81,1.84l-3.11,0.97l-3.42,2.57l-1.2,-1.63l-0.76,-0.29l-2.59,0.93l-1.23,0.78l-0.33,-0.11l-0.37,-0.87l-0.55,-0.26l-1.18,0.75l-1.36,2.21l-0.12,3.42l-0.63,1.08l-2.01,1.52l-0.47,2.63l-0.86,0.45l-0.09,0.55l0.46,1.25l-1.05,-1.17l-0.71,-0.26l-0.67,0.17l-1.14,1.39l-1.27,2.61l-0.33,1.02l0.08,3.35l-0.46,1.29l-0.84,1.13l-1.17,0.26l-0.81,1.51l-0.42,4.31l0.2,2.79l-0.79,3.1l-0.5,1.32l-1.2,0.7l-4.35,-2.38l-2.47,0.26l0.66,-1.14l-0.53,-1.51l-2.06,-1.52l-0.86,-1.78l-1.97,-0.57l-1.82,-1.32l-2.9,1.1l-0.95,1.06l-2.08,0.67l-1.29,-0.44l-1.59,0.81l-1.72,0.26l-1.05,-1.58l-1.84,-0.51l-3.21,0.31l-2.72,1.46l-0.66,-2.26l-1.15,-0.86l-0.48,-0.84l-1.97,-0.81l-2.96,-0.11l-2.32,-0.77l-0.87,0.22l-0.62,1.76l-4.01,1.3l-2.67,0.31l-2.03,0.7l-0.54,0.74l0.27,1.26l-0.51,0.33l-6.33,1.11l-4.0,-0.66l-1.57,-1.01l-0.97,-0.01l-1.3,0.64l-0.55,-3.04l-0.83,-0.67l-1.23,-0.09l-0.76,0.24l-0.93,1.06l-3.57,1.12l-1.56,1.75l-1.72,1.11l-5.31,1.96l-1.03,0.07l-2.53,-0.84l-2.73,1.48l-0.66,-0.51l-1.65,-0.17l-1.51,0.48l-1.41,-1.01l-0.7,0.0l-0.39,0.34l-1.68,-3.06l0.14,-0.72l3.36,0.16l0.93,-0.48l-0.89,-5.48l-1.4,-0.87l-0.32,-0.69l-0.8,-0.52l-4.42,-0.24l-0.78,0.24l-0.86,0.87l-1.11,0.34l-0.85,0.92l-1.1,-0.81l-2.12,0.08l-2.74,1.01l-3.44,2.43l-2.09,0.11l-1.09,0.46l-0.85,1.04l-0.3,2.63l-1.62,2.5l-2.88,2.12l-0.14,0.51l0.61,1.53l0.02,1.19l-0.72,1.14l-3.85,0.87l-1.98,2.37l-1.61,0.61l-2.78,0.38l-2.94,-0.34l-1.16,-0.59l-1.08,-1.5l0.86,-0.25l0.29,-0.6l-0.36,-2.94l-1.17,-2.7l-0.64,-0.52l-1.32,0.08l-2.71,-0.81l-2.23,-0.27l-2.14,0.52l-3.25,0.17l-2.54,-0.23l-3.15,0.44l-6.44,-0.32l-3.07,-0.67l-2.27,-1.01l-1.93,-3.14l-1.84,-1.33l-1.81,-0.18l-1.57,-0.99l-1.27,-0.25l-4.77,0.17l-1.46,-1.1l-2.02,-0.68l-2.12,-1.56l-0.9,-2.61l0.18,-3.47l-0.27,-1.11l-2.52,-2.68l-1.03,0.05l-1.18,1.1l-1.83,0.63l-0.3,0.75l-0.91,0.4l-1.79,0.03l-1.41,-0.68l0.36,-3.59l-0.75,-1.1l-0.65,-2.31l-0.92,-1.03l-0.2,-3.47l0.42,-0.63l1.49,0.91l2.06,-0.4l1.35,-0.99l0.42,-1.19l-0.17,-0.49l-0.87,-0.58l-3.69,-0.2l-2.05,-1.99l0.61,-0.64l1.89,0.55l1.15,-0.22l3.77,-3.23l1.72,-0.16l1.38,-0.98l2.78,-5.33l0.07,-0.76l-1.19,-1.96l-0.93,-0.37l-0.9,0.29ZM342.94,345.9l-0.07,-0.47l0.06,-0.58l0.99,-1.54l-0.98,2.59Z",name:"Madhya Pradesh"},"IN-OR":{path:"M408.6,584.62l0.87,0.38l0.7,-0.57l0.17,-1.23l0.78,-1.54l0.14,-2.48l0.72,-1.11l0.53,-2.11l-0.29,-1.58l0.84,-1.84l0.76,0.02l2.17,-0.82l1.07,-1.24l1.83,-0.69l1.82,-2.82l4.8,-4.17l-0.13,-1.22l-1.17,-0.95l0.98,-0.36l1.48,-1.56l2.18,-0.42l1.07,-1.66l0.73,0.55l0.81,-0.24l0.83,-3.98l0.54,-0.67l1.08,-0.58l0.29,-0.71l-0.1,-2.84l-0.74,-1.34l-0.25,-1.24l-0.98,-0.82l0.26,-1.36l-0.7,-1.85l0.8,-2.84l-0.22,-0.61l-0.86,-0.66l0.89,-0.73l0.05,-0.95l-0.72,-0.89l-1.26,-0.42l-0.99,-1.74l-1.27,-0.51l0.35,-3.73l-0.41,-1.94l0.27,-2.32l-0.75,-0.79l-1.7,-0.38l-0.94,-1.68l-2.97,-1.76l-0.47,-0.78l0.14,-0.74l1.38,-2.44l0.97,-0.56l1.15,-1.25l1.66,1.78l0.44,1.11l1.07,-0.03l0.97,-1.34l1.85,1.55l0.52,0.87l1.61,0.18l2.16,4.28l0.64,0.59l0.76,-0.22l1.26,-1.7l3.32,0.37l1.51,0.69l1.33,0.07l-0.14,2.05l0.48,0.54l0.74,-0.1l3.64,-2.46l0.2,-0.83l-0.84,-1.09l0.5,-2.36l-0.44,-1.37l-1.49,-0.16l-1.2,0.53l-1.26,-1.05l-2.25,-0.06l-2.22,-1.3l0.69,-3.13l-0.27,-3.86l-0.48,-1.12l0.27,-3.95l-0.1,-0.42l-0.55,-0.27l-0.35,0.21l-0.3,-1.32l-0.82,-0.26l-0.35,-0.87l0.85,-4.04l-0.72,-2.56l-0.04,-3.65l0.23,-0.22l0.93,0.25l0.06,0.91l0.5,0.38l1.85,-0.78l1.59,-2.19l1.54,-1.08l2.51,-4.8l0.2,-1.41l2.78,-0.21l1.21,0.48l1.08,-0.43l4.28,-0.65l3.13,1.97l2.46,-0.12l1.12,-0.71l0.83,-1.15l0.91,-2.52l0.94,-1.38l-0.0,-1.07l0.48,-0.85l2.25,0.71l0.98,-0.23l0.33,-0.74l-0.12,-1.25l-1.59,-1.85l-0.16,-1.47l0.71,-2.42l3.3,-5.53l0.24,-1.66l1.26,0.23l0.4,-1.1l0.9,-0.08l0.47,-0.83l0.2,-2.45l-1.77,-1.6l0.22,-1.51l1.57,-1.15l-0.05,-0.68l-0.65,-1.0l2.18,-3.06l2.99,-1.33l3.65,-3.0l2.69,-0.52l0.96,-0.56l1.06,-1.28l0.29,-0.96l-0.2,-1.52l-0.66,-1.22l2.36,1.1l2.44,3.59l1.03,0.81l1.71,0.29l2.63,1.1l3.55,-0.27l2.45,-1.4l0.45,-1.5l6.57,-0.18l2.05,-0.74l3.38,0.91l1.21,-0.78l1.34,-0.23l2.05,-1.36l0.86,2.95l0.13,1.93l-0.32,1.19l-1.6,2.32l-1.72,3.41l0.2,0.71l0.42,0.13l1.79,-0.54l1.28,0.22l4.01,2.74l3.34,-3.21l2.5,-1.08l0.99,-0.02l3.14,1.77l3.92,1.01l2.38,-0.82l1.13,-0.8l-0.69,1.35l0.07,1.78l0.31,0.54l1.81,0.87l1.44,-0.37l1.24,-0.87l1.91,-2.83l0.46,-2.86l-0.71,-2.31l0.76,-1.24l0.11,-1.23l-0.34,-2.49l-1.3,-1.91l-0.08,-0.67l1.7,-0.51l0.76,-0.96l0.5,-0.16l1.56,1.77l5.7,2.91l2.44,2.6l1.27,0.35l2.8,-0.49l5.68,3.71l0.66,0.99l1.88,0.67l2.06,1.47l1.92,0.22l2.3,1.14l0.67,0.67l0.2,0.8l-0.24,2.33l1.32,1.8l1.16,0.01l1.78,-2.16l0.87,0.07l1.39,0.85l0.72,2.92l0.74,1.0l5.27,1.5l0.12,2.57l1.25,2.13l-3.71,1.5l-4.33,0.33l-2.84,1.48l-1.58,1.12l-4.5,4.76l-1.65,2.44l-0.94,2.78l0.21,2.98l3.72,8.83l-0.15,0.33l-2.19,0.13l-0.26,0.6l0.52,0.68l0.66,0.26l2.2,0.07l0.33,0.76l-0.94,-0.18l-0.86,0.63l0.29,0.63l1.57,0.73l-2.3,1.0l-5.38,4.36l-0.87,1.94l-0.14,2.13l0.59,0.38l1.32,-0.93l0.32,0.19l-0.66,0.93l-2.07,1.29l-0.17,0.9l-1.96,1.18l-3.56,1.2l-0.62,0.5l-0.99,3.01l-2.18,2.22l0.07,0.88l-3.15,-2.37l-2.09,-0.05l-0.98,-0.98l-0.43,-1.27l-0.55,-0.22l-0.38,0.27l-0.24,0.91l0.53,1.5l1.8,1.31l2.24,0.53l0.58,1.03l1.33,0.59l-2.46,1.35l-5.48,2.09l-1.05,-0.38l-0.74,0.47l-5.64,1.45l-1.8,0.97l-1.66,0.07l-2.84,1.15l-0.84,-0.01l-2.11,1.23l-2.56,0.82l-0.12,-0.91l1.47,-0.48l0.08,0.59l0.46,0.02l1.85,-1.08l0.04,-4.51l-0.63,-0.57l-2.59,-0.65l-1.42,0.22l-3.64,3.22l-1.69,0.52l-2.08,2.43l0.02,0.78l-1.97,2.76l0.13,1.11l-0.98,0.61l-0.34,0.66l0.22,0.87l0.6,0.2l-0.13,0.36l0.47,0.55l0.96,-0.7l0.74,-0.13l-3.75,3.53l-6.09,4.87l-2.33,2.95l-0.87,-1.1l-2.14,-0.04l-0.56,0.34l0.14,1.16l-0.34,0.71l-0.9,-0.27l-2.35,1.12l-1.26,1.04l-1.69,0.08l-0.26,0.34l0.17,0.89l-0.33,0.72l0.05,0.87l-1.0,1.23l-1.18,0.2l-0.74,1.7l-1.32,1.09l-4.68,0.75l-2.81,-1.03l-5.13,0.38l-1.2,-1.49l-1.61,-4.45l-1.01,-0.54l-1.01,0.18l-0.5,0.86l0.2,1.32l-0.8,-2.26l-2.99,-3.94l-0.88,0.3l-0.51,1.45l-1.24,0.87l-0.57,1.24l-0.56,-1.57l-1.12,-0.44l-0.41,0.64l0.3,1.21l-0.52,0.7l0.12,0.82l-3.07,-1.25l-1.04,0.21l-0.61,0.54l-0.01,0.6l0.92,1.68l0.72,0.88l0.72,0.22l0.53,0.86l-1.83,0.9l-2.19,1.79l-1.56,0.69l-1.43,-0.77l-1.03,0.31l-3.19,3.91l-0.17,2.09l0.81,1.42l1.02,0.22l-1.53,2.04l0.32,1.52l-0.23,0.78l-0.89,0.07l-1.43,0.66l-1.31,0.07l-0.23,-0.16l0.01,-1.09l-0.37,-0.38l-2.06,-0.8l-0.93,0.12l-0.62,0.52l0.12,1.64l-0.33,0.6l-3.15,1.78l-0.71,1.76l-1.31,-0.43l0.47,-2.32l-0.48,-0.89l-2.17,-2.19l-0.29,-2.87l-2.46,-0.5l-2.38,3.46l-0.09,1.68l-0.5,1.42l0.29,1.04l-1.51,2.72l0.14,0.92l1.34,1.18l-0.86,0.75l0.1,2.0l-1.65,0.16l-0.93,1.4l-1.59,-0.19l-1.48,-1.2l-1.32,-0.39l-1.7,0.2l-1.56,1.08l-2.27,0.35l-3.0,1.96l-2.65,1.29l-1.11,1.17l-1.46,0.31l-2.23,1.63l-1.94,-0.89l-0.68,0.23l-0.52,1.0l-2.17,-0.55l0.13,-1.87ZM525.81,532.38l-0.05,-0.65l0.8,-0.25l0.04,-0.71l-0.49,-0.28l1.13,-1.12l-0.4,-0.64l0.3,-0.48l1.49,0.43l1.55,-1.12l1.08,-0.07l0.05,0.45l-1.37,1.35l-0.86,-0.66l-0.66,0.66l-0.63,0.11l0.75,1.39l-2.7,1.6Z",name:"Orissa"},"IN-TN":{path:"M249.84,785.28l-0.33,-0.95l0.1,-1.86l1.6,0.49l1.48,-0.2l1.11,-1.27l1.32,-0.6l0.3,-1.05l1.07,-0.88l1.68,0.16l0.34,0.48l0.05,1.28l0.84,0.64l5.71,-0.26l2.06,0.51l0.81,-0.69l0.4,-2.03l2.08,-2.99l2.57,-0.44l2.02,1.94l0.79,0.31l0.61,-0.27l0.51,-1.19l2.74,-0.17l1.14,-0.44l2.26,1.02l2.41,-0.26l1.0,-0.81l1.68,-3.48l0.65,-0.34l3.83,-0.43l1.03,-0.61l3.07,-4.27l0.07,-0.85l-1.01,-1.75l-1.33,-0.89l-1.06,-0.22l-5.49,-0.07l-0.44,-1.25l2.84,-2.25l1.44,-2.2l0.47,-2.63l-0.45,-0.65l-0.84,0.03l0.12,-0.69l-0.38,-1.02l1.14,-3.22l2.33,-0.11l2.46,-1.36l-0.16,-1.26l1.0,-1.73l0.33,-1.31l1.11,-0.38l1.66,-0.0l1.7,1.66l1.0,0.45l0.79,-0.3l0.66,-1.11l0.44,0.08l2.35,1.72l2.91,0.96l1.35,1.89l2.47,1.79l2.53,0.3l0.89,-0.42l1.33,-1.4l0.29,-1.48l0.98,0.03l1.45,-1.18l1.06,-2.6l1.03,-4.37l0.4,-0.53l1.29,-0.38l0.6,-0.96l3.87,-0.67l0.65,1.17l0.79,0.15l0.91,-0.67l0.3,-1.05l0.55,-0.02l0.97,0.23l0.51,0.92l2.1,0.65l2.72,-0.3l0.76,-0.54l2.09,-2.71l1.31,0.59l0.57,-0.08l2.15,-2.17l1.18,-0.62l0.42,-0.71l-0.07,-0.91l0.47,-1.75l0.53,-0.28l1.75,0.15l1.06,1.37l0.63,0.35l2.87,-0.38l0.18,1.3l1.04,0.76l2.31,-0.02l0.42,-0.96l-1.05,-0.98l-0.01,-0.36l1.61,0.07l4.38,-2.25l0.44,-0.72l0.05,-1.3l2.65,-1.83l-0.01,-0.75l-0.67,-0.64l1.64,0.69l-0.38,1.1l0.47,0.56l3.19,0.35l1.48,-0.39l1.4,1.36l0.73,-0.21l0.37,2.77l-0.32,2.03l-0.47,0.24l-0.18,1.0l0.58,0.53l-0.78,1.59l0.16,1.33l-0.83,1.23l-1.04,9.49l-2.92,8.93l-1.83,3.47l-1.09,0.85l-1.06,1.81l-2.53,1.85l0.16,0.59l0.84,0.04l-3.55,5.53l-0.05,1.49l-0.3,0.47l-1.72,1.18l-0.44,-0.37l0.52,-1.02l-0.5,-0.57l-1.34,0.11l-1.1,-0.87l-0.45,0.2l-0.56,0.93l0.7,1.08l0.11,0.84l0.4,0.31l-0.32,1.19l0.17,0.58l1.13,0.75l2.01,0.21l-0.67,1.5l-1.05,6.13l1.05,4.71l0.4,0.35l0.61,-0.29l0.1,0.95l-2.0,0.22l-2.44,2.58l0.36,0.58l0.4,-0.05l2.7,-2.02l1.33,0.48l0.06,2.28l0.62,3.2l-0.18,5.1l-0.92,-0.09l-0.81,0.43l-1.49,-0.42l-0.49,0.56l0.19,0.5l-0.54,-0.02l-0.42,0.61l0.15,1.36l1.28,0.83l1.44,0.41l0.03,0.97l1.52,1.03l0.49,13.03l-0.26,2.66l-1.42,0.34l-0.31,-0.79l-0.71,-0.39l-3.95,-0.65l-0.57,0.16l-0.15,-0.37l-0.92,-0.24l-1.62,0.14l-0.37,0.6l-1.79,0.33l-2.01,-0.48l-3.57,2.3l-0.57,0.81l-0.07,0.98l-0.83,0.53l-0.21,0.7l0.26,2.63l0.76,1.39l-2.05,1.82l-1.8,2.46l-1.51,2.81l-1.66,1.67l-1.79,2.49l-0.15,0.98l-1.21,1.73l-0.77,3.4l0.09,0.95l0.61,1.22l3.32,3.21l1.25,0.55l2.2,0.29l-1.72,0.32l-1.86,-0.59l-2.21,-0.03l-1.0,0.68l-2.02,0.14l-2.57,0.91l-1.52,0.99l-1.66,0.14l-1.25,1.21l-5.65,0.86l-2.39,1.3l-4.3,3.53l-1.8,2.81l-0.65,3.87l0.32,0.48l-1.12,2.25l-0.31,0.0l-0.34,0.62l0.79,1.81l-0.42,3.13l-1.41,1.59l-0.66,2.01l-1.71,0.61l-5.96,3.6l-1.22,1.49l-5.3,1.31l-1.05,0.76l-0.09,0.97l-1.21,0.15l-1.8,-0.34l-4.2,-1.29l-0.71,-0.71l-1.86,-0.93l-2.94,-2.68l1.1,-0.45l0.27,-1.46l1.29,-1.9l-0.16,-1.64l1.05,-0.34l1.18,-1.84l-0.4,-1.16l-2.42,-2.44l-0.23,-1.72l1.65,-2.45l0.62,-2.26l-0.4,-0.73l-1.24,-0.88l-1.07,-2.96l1.19,-0.85l0.75,-1.07l2.53,-7.34l0.84,-1.38l0.92,-2.56l1.1,-1.19l-0.19,-1.38l-1.73,-2.54l-1.26,-0.19l-1.8,0.71l-1.71,-0.93l1.56,-5.5l-0.33,-2.9l1.03,-2.56l-1.11,-3.46l1.54,-3.34l0.06,-1.34l-0.72,-0.72l-0.37,-1.59l-0.96,-1.63l-0.72,-0.66l-1.08,0.13l-2.94,1.32l-3.15,2.41l-1.14,-0.38l-2.36,-2.12l-0.06,-1.8l-0.9,-1.93l0.55,-3.53l-0.17,-2.56l1.09,-0.6l0.57,-0.74l0.43,-3.33l-0.23,-0.65l-0.94,-0.6l-0.87,-1.77l-3.86,-1.64l-0.66,-0.88l-0.13,-0.87l0.37,-1.13l1.9,0.19l0.65,-0.91l-0.74,-0.92l-0.83,-2.15l-0.87,-0.98l0.45,-1.93l-0.71,-0.36l-1.63,0.94l-2.99,0.25l-1.41,-0.46l-1.27,0.3l0.6,-1.1l2.2,-1.72l0.28,-0.77l-0.18,-0.49l-0.71,-0.39l-1.01,-1.28l-1.19,-0.47l-1.21,-0.95l-4.71,-1.32l-0.24,-0.32ZM341.41,854.52l0.89,-0.01l1.99,-1.02l0.32,0.12l-0.32,0.93l0.54,1.1l-1.22,-0.66l-2.2,-0.45ZM352.97,822.23l0.25,0.38l-0.78,-0.16l0.52,-0.21ZM353.99,822.77l0.71,0.09l0.49,0.17l-1.19,-0.25Z",name:"Tamil Nadu"},"IN-AN":{path:"M786.03,923.93l0.01,-2.47l0.71,-1.66l1.1,-0.13l0.59,-0.57l1.24,-0.26l1.04,-0.8l0.96,0.7l0.57,1.41l0.32,2.29l1.27,2.41l0.03,1.46l-1.11,2.56l-0.1,1.29l0.41,0.66l-1.31,0.13l-0.67,1.5l0.01,-1.41l-0.81,-0.89l0.05,-0.68l-0.44,-0.46l-0.29,-1.55l-0.7,-0.41l-0.89,-2.01l-1.06,-0.91l-0.92,-0.2ZM785.02,916.8l-0.54,-1.41l0.47,-1.37l1.32,-0.39l0.58,-0.69l0.93,0.88l-0.04,0.59l-2.72,2.39ZM782.63,894.17l0.29,0.95l-0.0,0.53l-1.15,-1.01l0.86,-0.47ZM780.5,891.72l-0.4,-0.52l-0.31,-1.96l1.06,-1.6l0.69,-0.13l0.06,0.48l-0.79,1.64l0.65,1.74l-0.29,-0.16l-0.66,0.5ZM781.79,892.53l-0.6,0.48l-0.41,0.67l-0.01,-0.52l1.02,-0.63ZM777.4,894.02l0.09,1.05l1.22,0.8l0.7,1.14l-0.03,0.45l-0.93,-0.4l-1.7,0.32l-0.12,-1.23l-1.17,-0.29l0.37,-1.49l1.57,-0.36ZM770.19,887.29l-1.18,-0.38l-0.98,-1.26l-0.11,-1.42l0.4,-0.73l0.16,2.27l0.42,0.72l1.29,0.81ZM768.4,766.2l-0.53,-0.93l0.37,-1.58l0.2,0.17l-0.27,1.01l0.23,1.33ZM751.49,774.12l0.88,-1.81l1.07,1.76l0.79,-0.06l0.11,-0.27l0.28,-2.36l-0.24,-1.3l0.63,-1.54l-0.05,-3.07l0.91,-2.0l0.45,0.12l0.42,-0.38l-0.13,0.98l0.73,0.48l1.83,-0.55l0.47,-0.81l-0.31,-1.49l-0.55,-0.41l0.77,-0.26l0.05,-0.92l-0.62,-0.6l-1.27,-0.21l-0.37,-1.1l0.12,-7.3l0.85,-1.29l0.61,-0.06l0.41,-0.65l-0.14,-0.45l-0.94,-0.64l-0.3,-3.47l0.61,-0.75l0.78,-0.04l0.52,-0.68l0.41,-1.58l0.01,-1.58l0.64,-1.33l-0.17,-0.58l-0.62,-0.37l0.62,-2.2l0.77,-1.37l-0.52,-0.97l0.18,-1.42l0.66,-0.54l-0.55,-3.24l1.34,-1.74l0.16,-1.78l1.42,-1.61l0.17,-1.04l1.5,0.01l0.36,-0.57l0.61,-0.13l0.39,0.69l-0.32,1.01l0.14,3.07l0.36,0.22l-0.97,1.23l-0.37,0.19l-0.32,-0.4l-0.65,-0.09l-0.59,0.8l0.51,1.08l1.25,0.22l1.33,1.3l-0.64,1.07l-0.13,2.9l-0.46,2.09l-0.32,0.53l-0.73,-0.2l-0.43,0.42l0.01,-1.38l-0.39,-0.32l-1.19,0.78l-0.29,1.52l0.64,1.07l-0.98,-0.16l-0.37,0.28l-0.91,2.21l0.36,0.65l0.53,0.22l0.74,-0.35l1.04,1.19l0.14,1.72l-0.24,0.98l0.95,1.63l-0.54,2.9l0.5,1.29l0.04,2.05l-1.01,1.21l0.24,0.65l-0.74,0.57l-0.86,-0.65l-0.46,0.06l-0.03,0.59l-1.15,-0.04l-0.43,0.4l0.65,1.8l1.06,0.71l0.12,0.47l-0.83,0.84l0.68,1.2l-0.59,0.69l0.3,1.14l-1.88,2.04l0.04,0.7l-0.77,0.79l-1.34,0.41l-0.13,0.54l0.54,0.76l-1.11,1.91l-0.1,3.33l0.4,0.4l0.63,-0.35l0.24,-1.5l0.24,-0.04l0.31,0.28l0.02,1.58l-1.11,4.78l-1.06,0.35l-1.07,1.13l-0.28,0.88l0.14,1.02l1.12,0.1l0.35,-0.4l0.06,-0.84l0.63,-0.36l0.09,-0.39l0.16,1.37l-0.54,0.66l-0.51,2.56l-1.5,-1.08l-0.07,-0.68l-0.92,-0.79l-0.1,-0.4l0.72,-0.38l0.02,-0.66l-0.9,-0.46l-0.4,-1.88l-0.33,-0.31l-0.95,-0.05l0.1,-3.11l-1.16,-0.79ZM766.4,766.0l0.11,0.62l0.39,0.73l-0.4,-0.42l-0.1,-0.93ZM766.14,717.57l0.26,-0.08l0.11,0.23l-0.14,-0.04l-0.24,-0.1ZM764.5,769.92l0.71,-0.98l0.67,-0.02l1.15,3.22l-0.42,-0.93l-2.11,-1.29ZM758.46,855.43l1.65,1.52l-0.05,1.49l-0.73,0.79l-1.73,-0.53l-0.46,-1.12l-0.04,-0.78l0.91,-0.49l0.44,-0.89ZM756.86,735.74l-0.0,-0.0l0.0,0.0l-0.0,0.0ZM756.0,743.21l0.29,-3.46l0.53,-0.59l0.3,0.45l-0.2,2.01l-0.92,1.58ZM754.65,789.3l-1.08,-0.41l0.1,-0.42l0.79,-0.21l0.37,-0.63l-0.25,-1.63l0.26,-0.56l1.0,1.26l-0.55,1.24l0.54,0.89l-1.17,0.46ZM746.83,808.06l1.1,-0.64l0.47,-1.64l1.46,-0.96l1.09,-0.24l0.89,1.13l0.95,5.03l-1.65,1.72l-0.03,1.18l0.75,0.47l-1.33,1.68l-0.74,-0.18l-1.27,-0.94l-0.69,-0.03l-0.86,0.53l0.62,-0.89l0.47,-1.76l-0.28,-0.78l-0.88,-0.81l-0.09,-2.85ZM751.89,783.09l0.03,-0.27l0.15,0.08l-0.18,0.2ZM742.26,782.71l0.82,0.26l-0.03,0.97l-0.62,-0.14l-0.17,-1.09Z",name:"Andaman and Nicobar"},"IN-AP":{path:"M264.69,675.87l0.59,-0.76l0.07,-1.39l0.36,-0.6l2.8,1.59l2.62,0.61l1.43,-0.37l0.97,0.82l0.73,-0.01l1.54,-1.37l1.31,-2.8l0.15,-1.56l-0.84,-4.18l-0.77,-0.9l-1.69,-0.61l-0.35,-2.03l-1.24,-2.4l0.68,0.17l0.39,-0.54l-0.25,-3.31l0.26,-0.71l0.58,-0.39l1.35,0.21l0.43,-0.69l-1.06,-2.44l-0.71,-0.66l0.22,-3.36l1.07,-1.31l2.59,-1.37l1.85,-0.28l2.42,0.6l4.32,0.13l1.56,-1.78l-0.11,-5.3l0.29,-2.68l1.74,-1.65l0.23,-0.94l-0.19,-0.53l-0.65,-0.77l-1.33,-0.57l-3.05,-0.09l-2.95,-0.77l-0.81,-0.99l3.28,-2.1l0.59,-1.33l1.2,-0.69l0.63,-1.85l-0.17,-0.57l-0.53,-0.26l0.62,-0.61l0.01,-0.5l-1.05,-1.21l0.15,-1.25l0.6,-1.07l0.04,-4.5l0.99,-2.39l-1.06,-2.3l-0.29,-1.52l-1.7,-0.89l0.14,-1.28l3.71,-4.76l0.84,-1.7l1.36,-0.46l0.8,-1.28l1.71,-0.45l1.19,-2.36l-0.1,-0.48l-0.75,-0.34l-2.14,0.93l-0.19,-0.69l-0.45,-0.3l-2.59,0.04l-2.16,-1.31l1.48,-2.39l1.78,-0.93l0.36,-0.49l-0.05,-1.04l-0.88,-1.04l0.17,-0.39l3.37,-2.8l0.33,-0.72l-0.5,-2.65l-1.6,-2.0l1.29,-0.9l-0.29,-2.04l-0.67,-1.77l0.45,-1.86l-0.92,-0.71l0.14,-0.69l-0.41,-0.76l-1.22,-0.85l1.13,-1.1l0.45,-2.51l1.0,-1.27l2.52,-0.58l0.7,-0.58l0.49,-1.38l0.0,-1.97l0.53,-0.34l1.61,-0.16l1.72,-3.28l2.15,-0.78l0.23,-0.36l-0.34,-1.09l-1.84,-1.47l-0.22,-1.32l-0.91,-0.24l-0.46,-1.07l-0.79,-0.01l-0.36,-1.59l2.55,-2.32l-0.08,-1.17l0.67,-2.12l1.1,-1.47l-0.09,-0.62l-0.52,-0.3l1.17,-0.67l1.93,0.21l0.99,1.37l0.94,0.51l3.82,0.06l0.7,-0.84l-0.2,-2.94l1.1,-2.01l0.66,-0.49l1.6,-0.35l0.53,-0.52l0.29,-3.48l0.9,-2.06l1.51,-1.08l0.48,-1.2l-0.25,-0.8l-1.04,-0.7l-1.01,-2.43l-0.11,-1.01l1.12,0.56l0.9,1.36l2.14,0.86l1.88,-0.79l1.03,0.35l1.4,-0.06l2.99,1.32l2.05,-0.07l1.73,1.25l1.07,2.89l1.36,0.62l0.25,0.68l1.79,1.04l1.99,-0.29l0.95,-1.2l1.14,-0.51l2.17,-0.33l0.97,0.36l0.92,1.25l3.18,0.53l1.67,1.34l4.21,0.15l0.63,0.59l0.8,0.23l0.8,-0.43l0.38,-1.24l0.6,-0.33l2.94,-1.04l1.61,0.26l2.07,2.63l1.96,0.76l0.99,1.71l-0.24,3.47l-0.86,1.68l0.37,2.75l-1.36,0.99l-1.06,2.07l0.34,1.38l2.14,0.09l0.69,3.21l-0.02,1.49l-0.09,0.45l-1.23,1.17l-0.02,0.58l2.7,1.38l1.76,1.5l0.97,1.3l2.69,0.3l2.3,-0.25l1.3,-0.53l0.65,2.12l1.01,1.62l0.57,0.07l0.54,-0.54l0.85,0.72l2.42,-0.54l2.78,1.95l3.43,4.07l2.24,4.82l0.1,0.39l-1.3,0.98l0.21,1.46l0.85,0.41l1.52,-0.16l0.8,-1.46l0.32,0.3l0.19,1.39l0.64,0.71l2.5,-0.43l-0.56,1.11l-0.13,1.27l1.26,3.31l0.2,3.88l0.99,1.96l0.73,0.43l0.68,-0.01l3.28,-1.92l2.72,1.08l4.53,-0.1l2.71,0.61l0.54,-0.36l0.41,-0.86l2.25,0.87l2.32,-1.68l1.53,-0.34l1.16,-1.21l2.62,-1.27l2.95,-1.92l2.16,-0.31l1.52,-1.07l1.35,-0.19l1.09,0.31l1.49,1.22l2.48,0.09l0.83,-1.36l1.55,-0.1l0.49,-0.61l-0.17,-1.85l0.74,-0.51l0.17,-0.52l-1.52,-1.91l1.52,-2.75l-0.28,-1.1l0.48,-1.33l0.06,-1.57l1.95,-3.0l1.51,0.29l0.18,2.62l2.61,2.97l-0.52,1.6l0.12,0.91l0.46,0.47l1.33,0.37l0.44,0.03l0.56,-0.48l0.51,-1.52l3.2,-1.82l0.51,-1.01l0.02,-1.54l0.74,0.0l1.56,0.66l0.07,1.24l0.76,0.46l1.63,-0.08l1.47,-0.67l0.98,-0.1l0.56,-0.58l0.14,-0.85l-0.35,-1.36l1.58,-2.2l-0.21,-0.73l-1.06,-0.17l-0.66,-1.2l0.16,-1.29l2.94,-3.66l0.7,-0.12l0.81,0.62l0.73,0.08l1.77,-0.8l2.21,-1.8l1.98,-1.03l0.06,-1.12l-0.63,-0.87l-0.79,-0.25l-1.37,-2.23l0.86,-0.26l3.12,1.32l0.82,-0.81l-0.07,-0.7l0.43,-0.9l-0.25,-0.94l0.63,1.68l0.95,0.15l0.99,-1.63l1.13,-0.74l0.49,-1.38l2.55,3.51l0.75,2.17l0.48,0.59l0.48,0.05l0.47,-0.47l-0.04,-1.94l0.98,0.08l1.57,4.35l1.49,1.81l3.28,0.09l2.2,-0.35l2.93,1.04l5.54,-1.07l1.09,-1.13l0.62,-1.56l0.98,-0.06l1.31,-1.51l0.42,-1.9l-0.15,-0.67l1.43,-0.02l1.38,-1.1l2.15,-1.02l0.56,0.31l0.53,-0.11l0.65,-0.92l-0.09,-1.22l0.85,-0.03l-0.54,1.48l0.68,1.11l0.49,0.03l-0.47,1.04l-2.23,3.0l-1.15,0.57l-2.77,4.48l-2.82,2.96l-0.73,1.38l-1.6,1.1l-1.15,1.5l-1.5,0.86l-1.27,0.17l-0.2,0.99l0.68,0.39l-3.6,3.35l-1.01,2.48l-0.96,0.74l-9.31,4.2l-5.02,3.04l-1.05,0.92l-0.79,1.44l-2.3,1.96l-0.27,-0.36l-0.72,0.17l0.02,1.59l-0.64,0.52l-0.41,1.5l-2.25,2.68l-1.09,0.75l-0.71,-0.8l-1.21,0.21l0.09,1.05l1.36,0.64l-1.18,0.69l-0.95,-0.02l-0.33,0.64l0.63,0.87l-4.38,1.88l-5.68,3.7l-0.6,-0.27l-1.36,0.9l-3.72,1.43l-7.5,4.53l-1.63,2.1l-1.66,1.0l-2.23,2.57l-1.51,3.41l0.08,1.5l0.46,0.72l1.58,0.79l1.39,-0.02l-0.85,4.85l-0.72,1.56l-0.34,-0.21l-0.64,0.36l0.4,1.35l-1.04,0.36l-1.68,1.64l-3.44,1.81l-1.69,0.26l-1.26,1.15l-1.04,0.04l-0.51,0.6l-2.47,0.43l-3.09,1.68l-1.37,0.3l-1.56,-0.75l-2.35,-0.2l-0.15,-0.58l-0.72,-0.39l-0.52,-0.02l-0.33,0.68l-1.09,-0.27l-1.67,0.39l-0.14,-0.58l-0.74,-0.5l-1.17,0.41l-1.79,0.07l-1.92,1.15l-0.53,0.79l0.21,1.29l-0.76,0.97l-2.28,6.46l-0.11,1.95l-3.74,2.84l-0.92,1.13l-0.06,0.8l0.57,1.13l-2.57,-2.06l0.0,-4.01l-0.39,-1.55l-0.36,-0.29l-0.5,0.52l-0.41,-0.01l-0.14,0.47l0.47,1.18l-0.03,2.41l-1.75,4.39l-0.16,-2.66l-0.88,-1.48l-0.76,-0.46l-2.81,-0.47l-0.67,0.59l-1.07,0.05l-1.2,0.52l-0.67,-0.32l-3.79,2.32l-1.37,0.39l-3.56,3.09l-2.52,5.95l0.09,0.92l-2.32,3.04l-1.15,2.69l-0.28,3.27l-0.91,3.59l0.05,2.53l1.66,9.47l0.36,0.68l1.24,1.01l0.53,1.67l-0.88,0.68l-0.09,0.67l0.52,0.29l0.92,-0.16l-0.53,2.8l-0.02,3.74l-1.28,2.53l-1.34,0.32l-1.03,0.97l-0.28,0.8l0.6,0.58l0.7,-0.18l1.35,-1.13l-0.31,1.02l0.08,1.41l0.74,3.85l3.06,7.11l-0.1,1.25l-0.75,1.85l0.88,2.52l-2.65,-3.71l-0.68,0.29l-0.0,1.53l-1.2,-0.83l-0.32,1.26l-1.21,1.55l0.16,0.9l1.44,1.97l-1.28,-0.67l-0.81,0.14l-0.23,0.82l0.76,0.9l-1.54,0.67l-0.98,0.96l-0.37,0.8l-0.0,1.1l-4.14,2.13l-1.51,-0.11l-0.43,0.24l-0.2,1.13l0.99,1.03l-1.6,-0.04l-0.56,-0.31l-0.13,-1.26l-0.58,-0.5l-2.98,0.35l-1.45,-1.63l-2.26,-0.23l-1.14,0.77l-0.55,3.0l-1.21,0.66l-1.92,2.04l-0.89,-0.53l-1.16,0.1l-2.64,3.15l-2.32,0.28l-1.86,-0.57l-0.43,-0.86l-1.41,-0.39l-1.2,0.29l-0.34,1.11l-0.43,0.35l-0.49,-0.96l-0.74,-0.38l-4.19,0.72l-0.84,1.11l-1.18,0.3l-0.67,0.81l-1.1,4.55l-0.94,2.36l-1.21,0.96l-0.58,-0.31l-0.63,0.22l-0.3,1.75l-1.22,1.28l-1.26,0.29l-1.25,-0.27l-2.28,-1.65l-1.18,-1.67l0.49,-1.04l-0.22,-1.64l1.12,0.41l1.29,-0.57l0.58,-0.55l0.25,-1.16l2.34,1.53l1.22,-0.06l0.18,-0.61l-0.23,-0.64l-0.55,-0.73l-0.93,-0.53l1.23,-1.78l0.45,-1.4l1.33,-1.04l0.36,-1.9l1.04,-1.54l0.39,-2.6l-0.23,-1.04l-0.44,-0.45l-1.33,0.66l-1.64,-1.13l-1.52,-0.39l-0.68,0.28l-0.85,-1.4l0.29,-1.11l0.25,-5.76l-2.41,-0.54l-1.07,0.43l-1.06,-0.1l-1.4,-0.36l-1.79,-1.79l-1.64,0.09l-0.25,-0.55l1.04,0.02l0.45,-0.71l-0.69,-1.44l0.46,-1.37l-0.59,-2.04l-2.02,-1.06l-0.89,0.52l-1.23,-0.07l-0.99,0.93l-0.07,-0.92l0.96,-1.22l-0.02,-1.23l-0.48,-0.53l-1.02,0.4l-0.82,1.05l-0.97,-0.53l-1.68,-0.25l-0.5,0.21l-0.53,0.99l0.57,1.25l-1.57,1.32l-1.31,0.57l-0.59,1.23l-0.75,-0.55l-1.23,0.19l-0.52,0.4l-0.14,0.76l-1.03,0.09l-1.67,1.05l-1.15,0.02l-0.52,-2.73l-1.41,-1.75l-2.98,-0.12l-1.04,-0.57l-1.02,-0.01l-0.97,-0.78l-0.94,0.37l-0.52,-0.92l-0.7,0.21l-0.38,1.14l-0.84,0.61l0.15,0.54l0.66,0.48l0.16,1.57l-1.79,-0.15l-0.65,0.76l-1.27,-1.08l-0.39,0.07l-0.3,0.59l-0.17,-1.78l1.47,-2.02l0.17,-0.7l-2.33,-3.22l0.13,-1.79l-2.1,-2.47l1.13,-0.73l1.21,0.58l0.81,3.14l2.72,1.07l0.99,0.93l2.32,-0.02l1.96,-0.48l1.11,0.29l1.12,2.0l0.1,1.09l2.11,0.75l0.59,-0.3l0.14,-0.59l-0.49,-1.0l0.03,-1.08l-0.98,-0.86l-0.78,-1.6l0.98,-1.6l-0.1,-0.47l-0.56,-0.36l0.9,-0.86l2.24,-0.25l0.65,-0.42l0.16,-0.69l-0.4,-1.48l0.3,-1.18l-0.34,-0.55l-1.16,-0.23l-0.64,-0.92l-1.06,-0.27l-0.62,0.36l-0.25,0.64l0.8,2.01l-1.15,-1.29l-1.73,-0.59l-0.11,-0.7l-0.49,-0.42l-2.21,0.23l-1.61,-0.55l-0.95,0.55l-0.84,1.16l-0.27,1.81l-4.51,-0.75l0.44,-1.18l-1.73,-1.24l-0.23,-1.08l0.27,-0.48l1.22,-0.27l0.76,-1.39l-0.09,-0.76l-0.92,-0.84l-1.56,-0.07l-0.81,0.33l-1.0,-1.83l-1.09,-0.58l-0.47,-1.96l0.82,-2.71l-0.07,-1.53l0.79,-0.32l0.34,-0.53l0.68,-4.44l-0.77,-0.97l-2.24,-0.88ZM433.84,620.88l0.17,-0.38l-0.47,-0.55l-1.43,0.9l-0.23,0.47l0.64,0.66l2.25,0.65l0.99,-0.27l0.73,-1.0l-0.06,-0.69l-0.49,-0.46l-0.91,0.66l-1.19,0.01ZM368.9,723.15l3.01,0.37l0.36,0.27l-3.63,-0.13l0.26,-0.51ZM392.61,649.39l1.24,0.72l1.36,1.23l-0.92,0.46l-0.54,-0.32l-1.33,-1.56l0.2,-0.53Z",name:"Andhra Pradesh"},"IN-TR":{path:"M717.67,412.64l-0.65,-0.93l-0.85,-0.54l-0.68,0.03l-0.65,0.63l-0.23,2.44l0.57,2.74l-0.06,0.54l-0.45,-0.12l-0.61,-0.81l-0.37,-1.24l-1.03,-5.9l0.59,-1.13l-0.93,-0.66l-0.88,-2.95l-1.06,-0.99l-1.73,-4.15l0.05,-0.4l0.82,-0.19l0.29,-0.86l-0.43,-0.72l-0.77,-0.33l-0.07,-0.39l0.16,-0.36l1.69,-0.62l0.97,-2.38l-0.28,-2.65l1.62,-2.42l1.36,0.06l0.65,-0.3l0.79,-3.37l4.46,0.5l2.13,-0.37l1.01,-1.0l0.52,-2.43l0.74,1.43l1.5,0.46l1.08,-0.84l-0.14,-2.07l1.8,0.37l0.24,1.14l1.12,1.01l0.62,0.15l0.7,-0.29l1.07,-3.6l-0.23,-2.31l1.73,0.78l0.54,-0.4l-0.61,-1.47l3.03,0.1l1.08,-0.51l0.67,-0.99l0.07,-3.38l0.92,-0.64l2.0,1.31l0.19,1.75l0.72,1.63l-0.16,1.4l-1.03,2.69l0.62,0.74l1.84,0.3l0.73,1.3l0.1,2.73l-0.33,2.19l0.42,1.35l-0.55,1.87l0.21,2.41l-0.73,0.03l-0.79,1.0l-0.32,1.9l0.2,1.67l-0.69,-0.15l-0.51,0.3l-0.6,1.69l-0.45,-1.43l-0.61,-0.91l-0.46,-0.16l-1.47,0.55l-1.5,1.91l-0.91,0.48l-2.28,-2.56l-1.1,0.12l-0.24,2.55l0.81,3.79l-0.04,1.12l-0.97,1.4l-2.69,1.48l-1.81,2.75l-0.6,1.79l1.57,5.86l-1.05,0.63l-0.6,1.26l-0.91,0.89l-1.59,0.51l-1.08,-0.01l-0.53,0.84l-0.37,-0.53l-1.18,-0.4l-0.36,-0.51l-0.1,-1.09l-0.43,-0.32l-1.19,-4.38l-0.54,-0.55l-0.07,-0.63l-0.43,-0.22Z",name:"Tripura"},"IN-AR":{path:"M727.36,274.74l-0.62,-1.27l-2.25,-0.75l-1.77,-2.04l-0.63,-2.3l0.17,-1.09l1.38,-1.87l0.22,-1.28l3.95,-0.13l2.71,1.1l3.56,0.14l1.39,-0.61l1.72,-1.71l1.01,-0.5l3.83,-0.02l0.37,-0.53l-0.09,-1.07l1.06,2.04l0.62,0.37l0.5,-0.13l0.54,-0.87l0.59,0.49l0.55,-0.04l0.85,-1.64l0.39,0.72l0.65,0.34l3.1,-1.35l1.28,-1.18l1.97,-0.69l1.9,-1.8l0.51,-2.58l-0.5,-0.64l-1.47,-0.43l1.15,-1.82l2.62,-1.84l1.03,0.45l1.55,-0.52l1.69,-1.95l1.76,-0.71l1.24,-1.28l2.81,-1.91l1.46,-2.07l0.6,-2.32l1.84,-1.44l6.87,-4.3l3.12,-0.23l2.29,0.22l1.58,-0.99l0.71,0.3l0.81,-0.14l2.24,-1.87l3.52,-1.53l0.33,-1.17l1.78,-0.1l1.59,-0.97l3.25,-1.09l1.23,-1.08l2.5,-0.23l2.96,-3.02l0.01,-0.58l-2.19,-2.29l0.36,-1.16l1.48,-0.19l1.11,-1.53l0.6,-0.3l2.38,-0.12l1.39,-0.42l2.54,-3.14l0.72,-0.07l2.06,1.06l1.8,2.16l-0.17,1.17l0.66,0.67l2.54,-0.06l4.07,1.52l0.43,-0.15l-0.23,-0.8l1.58,0.39l2.15,1.1l2.51,0.45l0.72,1.13l1.93,0.3l0.45,-0.44l-0.2,-1.79l0.72,-0.57l1.81,-0.09l1.12,0.28l0.48,-0.28l0.36,-1.24l0.67,1.6l2.25,-0.39l0.22,-1.1l-0.31,-1.27l1.15,-0.39l0.21,-0.82l0.66,-0.09l1.65,0.69l2.17,0.34l0.42,-0.22l0.93,-1.86l-0.03,-2.09l1.15,-0.32l2.24,0.9l2.73,-1.16l5.47,-0.31l0.94,2.55l1.97,1.67l1.4,-0.02l2.08,-1.11l0.36,0.57l-1.13,2.01l-3.49,1.07l-0.63,0.41l-0.65,1.26l0.64,2.74l0.61,0.25l2.59,-1.66l1.71,-0.53l0.58,1.89l2.46,1.23l0.08,0.91l1.18,0.7l0.56,2.05l2.02,2.58l0.6,2.92l-2.74,2.04l-2.04,1.1l-0.15,0.56l0.83,1.34l-1.06,1.29l0.04,0.55l1.03,0.95l0.99,2.16l0.53,0.2l0.76,-0.58l0.45,-3.4l0.84,-1.52l1.46,-0.72l2.38,0.61l2.09,2.27l2.2,1.38l1.28,1.55l0.59,2.63l2.37,0.85l3.42,-1.46l0.92,0.23l2.0,1.66l0.8,0.21l0.66,1.15l2.77,1.85l0.1,0.6l-0.87,1.91l-0.18,1.48l0.49,0.95l1.42,1.47l0.17,0.72l-0.79,1.9l0.03,1.18l-0.7,0.34l-0.46,-0.84l-0.74,-0.19l-1.48,0.51l-2.77,2.73l-2.06,1.44l-0.27,0.83l-2.08,0.81l-1.02,1.26l-2.24,1.7l-0.77,1.39l-0.0,0.98l0.8,2.32l-0.35,1.45l0.18,0.76l6.72,8.57l0.2,1.05l0.81,0.73l-0.34,0.96l-1.06,-0.38l-1.09,0.3l-0.98,-0.87l-4.19,-1.87l-0.52,-0.42l0.5,-1.38l-0.22,-0.64l-1.04,-0.87l-1.45,-1.95l-2.32,-1.06l-1.15,0.12l-0.8,0.69l-2.05,-0.49l-1.22,1.56l-0.94,0.38l-3.16,-0.19l-8.17,1.35l-2.27,0.98l-1.97,1.39l-2.32,3.7l-1.42,1.63l-3.49,1.13l-2.36,3.2l-2.21,0.47l-1.16,1.96l-1.65,0.03l-1.5,0.46l-2.38,3.54l-4.38,1.68l-0.65,-2.41l0.28,-2.02l-1.15,-1.62l0.08,-0.57l0.86,-1.12l0.18,-1.79l-0.4,-1.17l-1.3,-0.89l0.03,-0.74l2.24,-0.17l3.03,-2.24l2.08,-0.89l1.32,-1.31l0.89,-2.35l1.07,-0.6l3.2,1.39l4.93,-1.84l2.11,-0.03l1.11,0.35l0.89,-1.03l1.04,-0.45l0.4,-0.9l1.19,-0.94l0.02,-1.73l-1.11,-1.43l-1.54,0.04l-1.04,1.08l-0.29,-1.15l0.49,-1.32l-0.31,-2.08l-0.56,-0.76l-2.03,-1.4l-0.74,-3.0l4.9,-6.49l1.13,-2.28l-0.47,-0.76l-7.92,0.07l-1.46,0.45l-3.93,2.51l-4.03,1.0l-1.16,-0.06l-2.12,-0.75l-1.82,1.0l-9.17,3.2l-4.61,2.27l-4.21,1.1l-4.11,2.12l-1.45,0.25l-0.95,-0.65l-2.82,0.73l-1.84,-0.68l-0.97,-1.0l-0.65,-0.12l-0.98,0.82l-0.31,0.87l1.19,1.68l-0.16,0.82l-7.98,6.54l-4.22,4.3l-0.72,1.32l0.11,2.07l-3.97,2.93l-1.86,0.72l-3.28,0.5l-1.4,0.62l-0.37,0.04l-1.8,-1.22l-0.99,-0.14l-10.87,1.18l-1.55,-0.38l-0.87,-1.17l-3.78,-1.66l-3.69,-0.53l-0.9,0.25l-2.12,1.63l-8.52,2.44l-1.58,0.13l-1.99,0.63l-3.48,-0.28l-1.08,-3.29l-1.55,-1.52l-0.32,-0.92l0.42,-2.0l0.73,-0.89l0.31,-1.23l1.41,-1.35l0.22,-0.83l-2.85,-5.27l-1.16,-0.97l-1.6,0.88l-1.97,0.08l-3.01,0.86Z",name:"Arunachal Pradesh"},"IN-KA":{path:"M183.76,654.66l1.17,-1.76l1.58,-1.17l0.11,0.99l0.66,0.4l1.93,-0.14l1.67,-1.1l1.39,-2.47l-0.57,-1.14l2.3,-3.92l0.01,-1.78l-1.37,-0.64l0.65,-0.48l1.42,-0.09l0.56,-0.68l0.21,-3.0l-0.24,-1.26l-0.69,-0.68l-2.69,-1.26l-1.19,0.3l-0.47,-2.4l1.24,-0.28l0.35,-0.84l-1.1,-0.79l-0.36,-1.12l-1.04,-0.15l-0.39,-1.08l-0.95,0.09l0.31,-0.89l0.87,0.52l0.75,-0.34l0.34,-0.8l0.72,0.63l0.63,-0.14l1.85,-1.63l0.52,-1.51l2.28,0.61l0.64,1.97l0.55,0.41l0.87,-0.23l1.48,-1.21l1.3,-0.31l0.44,-0.89l-0.63,-0.9l0.68,-0.64l0.32,-1.0l0.9,-0.17l0.61,-0.68l1.67,-0.79l2.05,0.17l0.41,-0.88l-0.66,-2.45l2.16,-0.78l0.95,-0.97l0.35,-1.04l0.96,0.29l1.32,-0.24l0.43,0.85l1.57,1.28l1.74,0.56l2.56,-1.13l0.32,-1.76l2.11,-0.15l1.37,-0.65l1.59,-0.01l0.78,0.64l0.73,0.05l1.58,-0.66l0.84,-0.95l1.47,1.12l1.13,-0.06l0.56,-1.31l-0.58,-1.4l0.66,-0.66l0.08,-0.53l-1.28,-2.2l0.49,-2.65l-0.42,-1.11l-0.82,-0.58l-0.88,-2.78l0.83,-0.73l1.1,-1.81l0.67,0.2l0.76,1.43l1.88,0.29l1.02,1.25l0.74,0.0l1.18,-1.12l0.68,0.28l0.52,-0.31l0.52,1.7l1.37,1.03l2.4,-0.79l1.12,0.08l2.15,-1.02l1.3,0.35l1.64,-0.57l1.62,0.97l2.17,0.25l0.88,-0.29l0.98,-1.09l-0.17,-0.54l-0.94,-0.76l-0.84,-1.71l0.71,-1.31l-0.11,-1.65l-0.73,-1.08l2.27,-0.76l0.96,-1.31l1.3,-0.71l0.19,-1.02l0.84,-0.4l0.57,-0.91l0.9,0.33l1.1,-0.13l2.11,1.92l0.94,-0.21l0.83,-2.54l1.63,-1.28l-0.43,-2.03l2.59,0.52l1.11,-0.85l0.65,-1.76l0.44,-6.2l1.3,-0.6l1.67,0.06l2.75,-0.68l0.94,-1.82l3.43,-2.24l0.12,-2.6l0.97,-1.48l0.81,-0.16l0.82,0.6l0.26,2.57l2.49,1.24l0.14,0.8l0.46,0.46l1.07,-0.06l1.25,-0.96l1.87,0.57l-0.46,1.64l0.98,3.56l-0.97,0.35l-0.34,0.81l0.3,0.72l1.16,1.08l0.66,2.67l-1.93,2.03l-1.65,1.2l-0.31,0.97l0.86,1.02l0.13,0.63l-2.0,1.18l-1.66,3.11l0.54,0.74l2.14,1.1l2.63,0.05l0.62,0.92l2.4,-0.87l-0.85,1.7l-1.86,0.54l-0.68,1.22l-1.41,0.5l-0.93,1.81l-3.8,4.92l-0.3,1.05l0.18,0.89l1.75,0.99l0.21,1.34l1.01,2.06l-0.98,2.22l-0.04,4.51l-0.57,0.94l-0.19,1.47l0.2,0.87l0.84,0.59l-0.7,0.62l-0.29,0.74l0.33,0.43l0.72,-0.12l-0.46,1.4l-1.11,0.6l-0.57,1.31l-3.6,2.5l0.04,0.43l1.33,1.5l3.15,0.82l2.99,0.08l1.46,0.98l-0.05,0.65l-1.49,1.1l-0.35,0.85l-0.3,2.77l0.14,5.08l-0.92,1.2l-4.11,-0.1l-2.41,-0.6l-2.16,0.31l-2.83,1.49l-1.33,1.59l-0.27,3.92l0.26,0.61l0.54,0.3l0.92,1.92l-1.1,-0.21l-1.05,0.68l-0.44,1.23l0.31,2.89l-0.61,-0.36l-0.47,0.14l-0.26,0.54l1.49,3.11l0.45,2.23l2.35,1.26l0.79,5.01l-1.29,2.89l-1.27,1.08l-0.98,-0.83l-1.9,0.28l-2.26,-0.55l-2.7,-1.55l-0.83,0.05l-0.64,1.13l-0.05,1.31l-0.76,1.17l0.34,0.49l2.58,1.0l0.24,0.53l-0.67,3.87l-0.92,0.48l-0.24,0.51l0.09,1.46l-0.65,1.58l-0.11,1.87l0.53,1.82l1.15,0.65l1.13,1.95l2.75,-0.11l0.28,0.38l-0.58,1.33l-0.75,-0.03l-0.6,0.43l-0.33,1.18l0.67,1.5l1.34,0.7l-0.5,1.06l0.38,0.63l5.22,0.79l0.57,-0.66l0.04,-1.35l1.22,-1.48l1.49,0.54l2.05,-0.25l0.35,0.98l1.75,0.6l0.81,1.07l0.71,0.37l0.61,-0.09l0.42,-0.71l-0.87,-2.14l0.63,0.06l0.57,0.9l1.2,0.25l-0.29,1.29l0.4,1.46l-2.57,0.43l-1.69,1.64l0.17,0.52l0.77,0.22l-0.9,1.3l-0.01,0.61l0.89,1.82l0.88,0.68l-0.09,0.84l0.46,1.04l-1.36,-0.46l-0.12,-1.15l-1.33,-2.11l-1.58,-0.4l-2.02,0.49l-1.93,0.06l-0.86,-0.87l-2.53,-0.91l-0.68,-2.95l-0.45,-0.49l-1.65,-0.55l-1.55,0.95l-0.26,0.99l2.22,2.42l-0.16,1.73l2.27,3.02l-1.7,2.74l0.13,1.43l0.5,1.1l0.7,0.06l0.45,-0.65l1.18,0.94l0.5,-0.15l0.37,-0.63l1.31,0.24l0.78,-0.26l0.35,-1.0l-0.25,-1.5l-0.54,-0.55l0.64,-0.79l0.65,0.55l0.97,-0.55l0.77,0.74l1.09,0.02l1.04,0.57l2.88,0.1l1.0,1.31l0.76,3.18l1.76,0.02l1.87,-1.1l1.4,-0.17l0.29,-1.09l0.84,-0.13l0.54,0.58l0.75,-0.06l0.7,-1.41l1.23,-0.5l1.78,-1.55l0.13,-0.72l-0.57,-0.89l0.16,-0.39l1.51,0.14l1.31,0.55l0.69,-0.36l0.76,-1.03l-0.06,0.91l-0.96,1.22l0.45,1.84l0.61,0.04l1.08,-1.14l1.08,0.1l0.98,-0.51l1.13,0.68l0.47,1.62l-0.46,1.45l0.68,1.33l-0.98,-0.09l-0.43,0.33l-0.05,0.66l0.46,0.93l0.44,0.26l1.43,-0.19l1.73,1.76l1.63,0.44l1.35,0.11l0.84,-0.42l0.8,0.37l1.06,-0.13l-0.34,1.19l-0.06,3.99l-0.34,1.2l1.1,1.98l0.69,0.23l0.59,-0.29l1.3,0.36l1.75,1.15l1.21,-0.5l-0.05,2.1l-0.32,1.1l-0.91,1.18l-0.34,1.83l-1.24,0.9l-0.54,1.55l-1.32,2.03l0.1,0.59l1.12,0.65l0.48,0.78l-2.19,-1.45l-1.12,-0.16l-0.49,0.39l-0.35,1.35l-1.07,0.42l-1.03,-0.36l-0.62,0.37l0.11,2.05l-0.34,0.59l-2.6,-0.85l-2.48,-1.78l-0.99,-0.1l-1.2,1.37l-2.15,-1.97l-2.37,-0.1l-1.63,0.75l-0.34,1.39l-1.03,1.8l0.24,1.06l-2.02,1.05l-1.7,-0.11l-1.04,0.49l-1.29,3.66l0.38,1.14l-0.1,1.1l1.28,0.34l-0.45,2.16l-2.18,2.84l-1.81,1.11l-0.33,1.06l0.88,1.69l6.59,0.29l1.01,0.65l0.87,1.65l-3.17,4.34l-4.19,0.64l-1.02,0.5l-1.01,1.52l-0.85,2.18l-0.54,0.46l-2.0,0.25l-2.48,-1.04l-1.24,0.45l-2.9,0.22l-0.46,0.31l-0.39,1.08l-1.99,-1.91l-1.21,-0.41l-2.06,0.44l-0.92,0.51l-1.97,3.01l-0.52,2.22l-2.05,-0.47l-5.1,0.34l-0.7,-0.25l-0.01,-1.16l-0.76,-0.99l-1.01,-0.34l-1.28,0.14l-1.47,1.17l-0.23,-1.51l-0.53,-0.66l-2.29,-0.05l-1.56,-1.76l-1.37,-0.01l-1.51,-1.78l-0.98,-0.16l-1.05,0.26l-0.38,-0.58l0.08,-2.01l-0.53,-0.63l-0.84,-0.04l-2.77,1.07l-2.93,-0.54l-1.33,-0.58l-1.09,-1.2l-0.6,-1.99l-1.88,-0.3l-1.33,-0.81l-0.81,0.09l-0.76,-1.06l-2.07,-1.0l-3.42,-3.85l-1.12,-0.12l-0.54,-1.89l-0.87,-1.28l0.04,-0.64l0.75,-0.81l0.05,-0.7l-0.69,-0.48l-1.29,0.25l-1.68,-1.95l0.67,-1.64l-0.28,-0.5l-1.53,-0.38l-1.26,0.46l-0.83,-1.04l-1.18,0.1l-0.21,-1.49l-1.02,-0.68l-0.95,-0.16l-0.98,0.44l-0.22,-0.85l-1.23,-0.36l-0.55,-1.43l-0.97,-0.23l-1.59,0.31l-0.32,-0.91l0.99,-0.81l1.53,-0.55l0.39,-0.51l-0.4,-0.61l-3.41,0.56l-1.36,-5.58l0.26,-1.33l-0.35,-0.37l-0.6,-2.16l-1.04,-5.01l-0.74,-1.48l0.06,-0.6l0.43,-0.2l-0.18,-1.85l-0.72,-1.98l-0.17,-2.91l1.43,-0.43l0.51,-0.72l-0.79,-0.24l-0.74,-1.69l-0.59,-0.04l-0.59,0.82l-1.04,-4.59l-0.98,-2.21l-2.65,-3.83l0.0,-1.22l-0.63,-1.13l-0.24,-2.4l-1.15,-1.8l2.13,0.13l0.18,-0.69l-2.5,-1.07l-0.26,-0.37l-0.08,-1.26l-1.06,-3.28l0.48,0.02l0.27,-0.5l0.73,-0.16l-0.05,-0.45l-1.48,-1.63l-0.14,-0.62l-0.98,-0.84l-0.71,0.54l-0.06,1.03l-0.4,0.04l-0.22,-1.61l1.0,-0.33l0.35,-0.61l-0.72,-0.56l-1.25,0.35l-0.23,-0.18l0.24,-0.61l-0.84,-2.65l-1.14,-0.68l-0.83,0.38l-0.42,-0.63l-0.7,-0.13l-1.41,-0.99l0.54,-0.99l1.17,0.17l0.75,-0.99l1.08,0.02l0.47,-0.37l-0.08,-0.75l-1.37,-0.74l-2.36,1.62l-0.46,-0.72l1.61,-1.08l1.69,-0.19l1.18,-0.91l0.82,-2.53l-0.14,-2.48l0.94,-2.43l-0.25,-0.71l-1.34,-1.11l1.61,-0.57l0.34,-0.87l-0.21,-1.62l-1.2,-1.53l-0.04,-1.34l-0.58,-0.86l0.59,-1.77l-0.66,-3.34l-0.5,-0.59l-1.53,-0.72l-1.74,0.51l-0.43,-0.07l-0.12,-0.46Z",name:"Karnataka"},"IN-PB":{path:"M176.07,176.63l0.49,-0.66l0.91,-0.18l0.37,-0.76l0.93,-0.37l1.98,-2.76l1.11,-0.3l0.6,-0.54l0.35,-2.73l1.22,-1.08l1.65,-0.66l0.97,-1.89l2.26,-2.34l-0.1,-1.02l1.19,-0.74l0.5,-1.77l2.56,-0.03l1.17,-1.73l2.45,-0.6l1.36,-1.41l0.49,-1.31l2.35,-1.33l0.12,-0.61l-1.4,-1.16l-2.43,0.02l-0.78,-1.72l0.77,-4.21l2.63,-5.48l-0.15,-0.82l-0.89,-1.3l-0.91,-3.26l-1.88,-3.18l1.28,-1.9l0.42,-1.8l3.6,-2.55l0.85,-1.45l1.71,0.33l1.05,-0.31l1.2,-2.56l1.09,0.37l0.83,-0.6l2.02,-0.13l1.02,-1.1l1.11,-0.02l0.36,-0.49l-0.14,-0.56l1.94,0.66l1.17,-0.5l1.03,0.2l0.93,-1.49l3.2,-0.92l0.63,-2.0l1.01,-1.12l0.35,-0.94l-0.27,-0.94l-1.12,-1.22l1.94,0.13l1.25,-0.69l0.47,1.04l1.62,0.83l0.46,-0.14l2.1,-2.45l1.07,-0.64l2.7,-0.39l1.07,-0.89l0.4,-1.14l1.66,-0.59l1.42,-1.04l1.5,2.65l-3.97,2.7l-1.59,1.66l-3.57,1.31l-0.33,1.08l0.28,1.2l0.7,0.45l0.63,-0.16l-0.52,1.03l-1.81,1.94l-0.05,0.85l0.87,0.49l3.03,0.5l5.38,2.71l2.54,4.11l-1.07,0.21l-0.18,1.25l4.53,8.24l2.34,7.11l1.09,1.36l0.75,0.46l1.42,-0.32l1.34,0.16l0.65,-1.28l0.84,-0.38l-0.02,-1.78l0.92,-0.36l2.27,4.24l0.98,-0.15l0.78,0.72l0.73,-0.2l0.39,0.92l0.53,0.22l0.69,-0.62l0.06,1.28l0.34,0.31l0.96,-0.04l-0.73,1.33l-0.03,1.58l0.68,0.74l-0.51,1.25l0.31,1.59l1.02,1.2l3.79,3.11l1.0,1.7l0.95,0.53l-0.41,1.04l-2.24,-0.16l-1.46,0.74l-0.24,0.82l0.32,0.8l2.49,2.48l2.18,-0.11l0.28,1.06l0.84,0.47l0.29,0.86l-0.26,1.77l0.52,0.95l-0.43,1.01l0.34,3.05l-0.33,0.84l-1.25,-2.16l-2.78,-0.23l-1.08,0.49l-0.44,1.63l0.52,0.73l-2.37,1.72l-3.57,1.91l-0.22,0.62l0.44,0.79l0.82,-0.04l0.76,-0.82l0.42,0.84l0.87,0.45l-0.38,1.5l-2.73,1.89l-1.97,-0.49l-1.02,-2.47l-0.61,-0.47l-0.6,0.06l-0.49,0.47l0.18,1.05l-0.33,0.74l-0.93,-0.81l-0.57,0.13l-0.15,0.98l-0.26,0.08l-1.13,-0.23l-1.27,-0.87l-0.79,0.13l-0.49,1.0l0.9,0.83l-0.46,0.56l0.17,0.85l-0.56,0.83l-0.83,2.76l0.55,1.64l0.95,0.71l-2.16,1.34l-1.95,0.72l-1.28,1.49l-1.16,0.03l-1.39,0.58l-1.91,-0.35l-1.01,-1.8l-1.91,-0.93l-2.34,0.7l-0.72,1.35l-1.13,-0.2l-1.76,0.35l-4.86,-1.45l-3.42,4.21l-0.13,0.69l-0.95,0.4l-0.7,1.35l0.37,1.21l-1.34,0.48l-0.53,-1.63l-0.78,-0.89l0.03,-0.68l-0.47,-0.53l0.89,-0.62l-0.01,-1.11l0.84,-0.15l0.16,-0.58l-1.61,-2.94l-1.18,0.18l-0.57,0.76l-0.91,-0.57l-0.12,-1.21l0.35,-1.46l-0.53,-0.88l-0.81,0.2l-0.42,1.1l-1.94,0.49l-1.47,-1.09l-0.81,-1.4l-2.41,-0.6l-0.88,-0.73l-3.48,0.62l-1.31,0.92l-0.55,0.88l-3.88,-1.1l-4.07,-0.54l-15.05,-0.66l0.36,-1.18l2.21,-3.51l0.25,-1.48l-0.23,-0.77l-0.66,-0.4l-1.19,-3.33l-0.77,-1.0l-1.17,-0.6Z",name:"Punjab"},"IN-ML":{path:"M692.14,323.41l0.36,0.99l0.49,0.26l3.48,-1.0l0.19,0.86l0.64,0.35l1.2,-0.63l1.49,-0.23l3.08,0.24l0.52,0.77l0.96,0.42l-0.17,1.66l0.43,0.66l1.1,-0.39l0.55,0.36l0.64,-0.07l2.66,-0.96l0.05,3.31l0.27,0.81l0.85,0.45l1.66,-0.78l2.72,-2.95l3.5,-0.63l1.66,-0.86l0.37,-0.68l-0.38,-0.52l-1.21,0.62l3.21,-4.23l0.7,0.03l0.35,0.35l-0.47,2.0l0.21,0.69l1.52,0.36l1.37,-0.91l0.76,-1.27l0.44,-1.6l1.65,-1.4l0.96,0.24l1.41,1.21l1.05,0.19l3.13,-0.68l1.07,0.06l3.34,-1.03l2.77,0.13l-2.86,2.99l0.12,1.26l1.06,0.72l-1.5,3.63l0.24,1.32l-0.13,2.9l0.69,0.35l1.64,-0.98l2.82,-0.49l1.83,-1.14l2.64,2.02l3.7,3.79l0.62,0.07l1.88,-0.9l-1.34,1.9l-1.55,1.24l-0.1,0.59l1.68,1.57l2.05,0.77l2.62,2.44l0.18,0.48l-0.36,1.54l0.66,1.41l-3.66,1.24l-1.0,1.03l-2.75,0.23l-0.26,0.76l-1.33,0.48l-3.41,3.12l-1.72,-0.99l-0.78,-0.86l-2.26,-0.4l-1.74,-1.46l-1.79,-0.29l-0.79,-0.85l-1.94,-0.58l-2.44,0.38l-1.73,-0.24l-5.25,0.33l-0.64,0.7l-0.94,-0.21l-0.65,0.86l-0.55,0.08l-1.11,-0.13l-1.08,-1.05l-0.72,-0.01l-2.03,0.82l-1.34,-0.09l-4.49,-1.33l-1.65,-0.78l-12.73,1.95l-2.04,-0.82l-0.72,-0.02l-0.73,0.49l-2.6,-0.6l-1.28,0.3l-2.57,-0.21l-4.05,0.61l-2.4,-0.98l-4.8,-1.03l-6.8,-2.79l-2.64,0.4l-0.59,-2.56l0.35,-1.85l2.3,-0.94l0.38,-0.8l0.21,-2.01l1.81,-0.2l1.28,-1.0l0.04,-0.93l-1.52,-1.7l-0.34,-1.72l0.88,-1.75l0.26,-1.36l2.26,-2.72l2.31,-1.91l5.74,-0.81l1.82,-1.05l3.24,0.21l1.4,0.87l-0.56,1.9l0.39,0.49l1.72,-0.91l0.85,-1.0Z",name:"Meghalaya"},"IN-MN":{path:"M765.49,384.0l0.47,-0.68l0.61,-3.47l-0.09,-1.17l0.96,-1.67l-0.13,-0.68l-0.62,-0.57l-0.09,-1.32l0.56,-0.31l0.28,-0.98l0.55,-3.63l1.0,-0.49l0.14,-0.43l-0.57,-1.42l0.73,-1.43l-0.56,-1.21l0.91,-2.88l0.63,-0.62l0.88,0.47l0.98,-0.44l0.27,-1.08l1.36,-2.09l-0.23,-1.11l1.0,-0.91l-0.44,-2.02l1.51,-0.98l3.35,-6.82l0.5,-0.52l1.87,1.18l1.29,0.39l1.16,1.32l0.79,-0.03l1.42,-1.94l0.99,-2.22l3.94,-3.86l-0.04,-1.41l-1.34,-0.76l0.16,-0.53l4.57,-0.6l2.93,0.03l1.7,1.1l2.18,-0.03l1.33,0.81l4.11,-0.51l2.05,-1.03l1.5,-1.74l1.68,-0.96l1.91,-1.65l-0.05,1.34l-1.04,3.76l0.67,0.94l2.42,1.37l-0.87,1.31l-1.78,4.9l0.08,1.52l0.99,1.35l3.31,1.08l0.64,2.0l-0.15,1.25l-1.08,1.72l-0.56,2.75l-1.73,2.55l-0.49,2.59l-0.58,0.52l-1.44,0.34l-1.22,3.42l-1.79,1.31l-0.65,2.06l-1.03,1.02l-0.12,1.37l-1.01,1.13l0.08,0.9l-1.09,1.03l-0.39,2.16l-1.51,3.48l-1.33,5.32l-1.69,2.49l-0.11,2.01l-0.25,0.27l-1.49,-1.41l-1.93,-1.02l-3.52,-0.92l-2.47,0.28l-1.62,-1.76l-1.26,-0.49l-3.11,-0.12l-0.94,0.51l-0.51,0.86l-0.79,-0.43l-1.46,0.7l-0.87,-0.01l-0.47,-1.06l-2.13,-2.65l-0.75,-0.47l-1.33,0.4l-0.63,1.3l-0.8,0.38l-0.15,-0.87l-0.68,-0.58l-1.63,0.9l-1.15,-0.71l-1.16,0.57l-1.01,-0.83l-2.54,-0.88Z",name:"Manipur"},"IN-MH":{path:"M140.02,524.29l0.06,-1.24l-0.89,-1.35l0.45,-1.03l-0.02,-2.02l0.58,-0.43l0.77,-1.67l0.01,-1.67l1.8,-0.88l1.02,0.27l0.61,-0.35l2.1,-0.11l1.26,-0.53l1.63,2.69l1.38,-0.59l0.87,0.56l1.01,-0.49l0.85,0.82l0.58,0.11l0.82,-0.93l0.21,-1.81l0.82,-0.04l1.23,-0.66l0.57,-1.77l3.01,0.37l0.95,-0.4l-0.07,-1.27l0.49,-1.74l-0.34,-2.56l-0.66,-0.58l2.42,-3.82l0.56,-1.66l-0.48,-1.67l-0.94,-0.32l-0.37,-1.27l-0.99,-0.24l0.99,-0.38l0.9,-1.46l0.9,1.35l3.28,1.92l1.77,1.83l2.49,-0.21l2.88,-1.69l0.39,-0.98l-0.0,-1.07l2.33,-1.97l0.71,-1.34l-0.19,-3.58l-0.9,-2.69l-2.67,-3.15l-1.52,-0.55l-1.15,-1.45l-0.83,-0.24l-1.49,0.14l-2.13,-1.69l1.87,0.97l2.29,-0.02l2.26,-1.34l1.02,-2.45l1.02,0.6l2.51,-0.87l1.4,-3.41l2.42,-2.08l1.87,0.38l4.14,-1.13l1.72,-0.97l0.43,-1.02l-0.34,-1.17l-0.46,-0.42l-2.95,0.88l-1.44,-0.8l-1.14,0.58l-3.52,-0.08l-5.22,1.49l-1.82,-2.89l1.68,-0.47l0.65,-0.69l0.32,-1.01l-0.15,-0.9l-0.83,-0.77l-0.29,-2.57l0.27,-0.56l2.56,-0.97l1.38,-0.19l1.13,-0.92l2.52,-1.2l1.96,-0.35l2.37,0.85l2.05,-0.37l0.72,-0.45l0.19,-0.59l1.73,-0.61l1.41,-1.13l2.18,2.28l0.21,0.76l-0.17,3.62l0.77,2.62l3.13,2.41l1.63,0.45l1.6,1.13l4.83,-0.16l1.07,0.2l1.64,1.01l1.69,0.14l1.58,1.14l2.36,3.5l2.18,0.87l3.21,0.71l6.95,0.32l2.77,-0.44l2.5,0.23l3.35,-0.17l1.94,-0.51l2.2,0.26l2.69,0.81l1.26,-0.08l1.24,2.54l0.36,2.7l-1.11,0.57l0.15,0.97l1.09,1.49l0.87,0.53l3.81,0.66l4.02,-0.74l0.95,-0.46l1.82,-2.26l4.01,-0.99l0.96,-1.64l-0.02,-1.37l-0.56,-1.56l2.52,-1.7l1.81,-2.57l0.52,-3.12l0.5,-0.59l0.75,-0.35l2.31,-0.17l3.51,-2.47l2.54,-0.93l1.74,-0.08l0.77,0.73l0.74,0.08l1.15,-1.07l0.99,-0.26l1.28,-1.01l4.16,0.21l0.84,1.07l1.22,0.67l0.36,3.83l0.44,0.85l-3.7,-0.1l-0.72,0.76l0.04,1.29l1.97,3.68l0.53,0.02l0.58,-0.76l1.39,0.99l0.88,0.02l1.05,-0.43l1.38,0.13l0.82,0.55l2.93,-1.48l2.94,0.87l4.44,-1.33l3.05,-1.56l2.07,-2.14l3.51,-1.08l1.4,-1.22l1.25,0.34l0.42,2.93l0.32,0.47l0.78,0.04l1.24,-0.64l0.62,0.01l1.47,0.98l2.09,0.55l2.14,0.15l6.99,-1.28l0.7,-0.93l-0.15,-1.32l1.82,-0.62l2.66,-0.31l4.17,-1.36l0.59,-0.54l0.29,-1.34l1.77,0.62l3.23,0.14l1.66,0.54l0.8,1.02l0.92,0.57l0.58,2.17l0.81,0.57l1.25,-0.33l1.75,-1.17l2.95,-0.27l1.39,0.37l0.77,1.38l0.58,0.33l1.6,-0.12l2.05,-0.95l0.35,0.4l0.86,0.06l2.42,-0.77l0.92,-1.07l2.29,-0.91l1.67,1.15l1.92,0.55l0.2,1.01l0.5,0.63l2.02,1.48l0.35,0.91l-0.73,1.25l0.43,0.65l0.81,0.15l1.85,-0.32l4.3,2.41l1.39,-0.57l-0.01,0.89l-1.13,1.42l-2.68,1.41l-2.67,1.98l-0.97,4.16l0.16,1.64l0.77,1.33l1.09,0.52l1.28,-0.23l0.35,0.63l0.06,4.02l0.45,3.05l-1.84,1.2l-0.47,0.89l-0.02,0.79l0.38,0.48l0.66,0.16l1.78,-0.88l1.02,0.27l0.01,1.81l0.39,0.89l-0.58,1.41l-0.1,2.11l0.45,2.13l-1.09,0.47l-1.52,1.28l-2.81,0.5l-0.75,0.81l-0.36,2.4l0.18,0.72l3.49,0.54l0.73,2.48l-0.7,3.76l-2.02,-0.7l-1.12,1.16l-0.04,1.18l1.69,0.75l-0.51,0.69l-1.68,0.86l-0.09,0.89l0.85,0.59l1.62,0.25l0.63,-0.44l0.13,-0.95l0.77,-0.12l1.15,2.63l2.81,1.23l0.47,2.03l0.58,0.9l4.26,1.79l1.18,1.1l0.48,0.98l-0.64,1.2l-1.62,0.32l-0.53,0.42l-0.01,0.81l0.78,1.35l-1.97,0.98l-0.97,0.87l-1.04,-1.54l-2.0,-0.01l-0.88,-1.94l-0.71,-0.42l-0.85,0.24l-1.13,1.33l-1.18,0.61l-1.0,1.75l-1.36,0.8l-1.22,4.29l-2.27,3.01l-0.64,1.37l-0.01,1.37l2.24,3.09l-0.09,0.72l-2.24,1.45l-0.28,0.71l0.24,1.15l-0.3,0.22l-2.34,0.29l-2.31,-0.22l-0.58,-0.96l-2.01,-1.76l-2.23,-1.06l0.99,-0.99l0.21,-0.84l0.02,-1.59l-0.72,-3.35l-0.74,-0.8l-1.66,0.26l-0.06,-0.71l0.87,-1.58l1.42,-0.93l0.21,-0.5l-0.44,-2.8l0.57,-0.64l0.28,-0.94l0.23,-3.74l-1.23,-2.15l-1.96,-0.77l-2.06,-2.64l-2.29,-0.45l-3.08,1.08l-0.91,0.51l-0.3,1.12l-0.39,0.32l-1.26,-0.82l-4.24,-0.18l-1.47,-1.27l-3.01,-0.45l-0.87,-1.21l-1.35,-0.51l-2.56,0.37l-1.33,0.62l-0.81,1.12l-1.3,0.27l-1.56,-0.84l-0.34,-0.77l-1.28,-0.55l-0.99,-2.79l-2.09,-1.54l-2.16,0.04l-2.92,-1.29l-1.56,0.02l-1.1,-0.35l-1.07,0.25l-0.61,0.57l-1.9,-0.74l-1.36,-1.66l-1.24,-0.52l-0.54,0.27l-0.23,0.9l0.26,1.04l1.09,2.59l1.15,1.04l-0.25,0.64l-1.24,0.79l-0.61,0.83l-0.91,2.35l-0.06,2.8l-2.01,0.66l-0.77,0.68l-1.2,2.21l0.22,2.5l-0.2,0.74l-3.33,-0.06l-0.9,-0.6l-0.87,-1.24l-2.11,-0.28l-1.27,0.34l-0.99,0.93l0.11,0.69l0.53,0.26l-1.01,1.36l-0.7,2.23l0.12,1.03l-2.39,2.03l-0.22,0.63l0.57,2.11l1.03,0.18l0.28,0.94l0.86,0.22l0.16,1.21l2.03,1.81l-2.16,0.84l-1.71,3.25l-1.27,-0.02l-0.95,0.63l-0.33,0.77l0.19,1.51l-0.52,1.27l-2.57,0.53l-1.5,1.72l-0.5,2.61l-1.3,1.55l1.51,1.29l0.1,0.66l-1.31,-0.1l-1.69,1.02l-0.3,-1.06l-2.38,-1.06l-0.11,-2.21l-0.63,-0.91l-1.3,-0.5l-1.15,0.41l-1.16,1.82l-0.03,2.41l-1.43,0.66l-1.86,1.41l-0.68,0.82l-0.31,1.03l-1.26,0.02l-1.02,0.42l-1.68,-0.05l-1.83,0.93l-0.27,0.64l0.14,1.57l-0.48,2.32l0.04,2.02l-0.55,1.47l-0.5,0.44l-3.0,-0.44l-0.32,0.42l0.47,2.13l-1.5,1.02l-0.86,2.44l-2.06,-1.89l-2.52,-0.23l-0.88,1.08l-0.94,0.5l-0.2,1.02l-1.14,0.56l-0.95,1.3l-2.46,0.92l-0.17,0.5l0.77,1.23l0.09,1.48l-0.71,1.34l1.01,2.17l0.92,0.74l-0.6,0.51l-2.45,-0.08l-1.78,-0.99l-1.68,0.57l-1.38,-0.34l-2.26,1.05l-0.94,-0.14l-2.15,0.79l-0.87,-0.67l-0.28,-1.22l-0.68,-0.84l-0.88,0.28l-0.74,-0.28l-1.46,1.22l-0.85,-1.16l-1.9,-0.32l-0.65,-1.35l-0.88,-0.45l-0.63,0.12l-2.43,3.16l0.98,3.28l0.92,0.73l0.24,0.71l-0.5,2.6l1.28,2.16l-0.74,1.05l0.55,1.29l-0.2,0.88l-2.2,-1.25l-1.22,1.13l-1.28,0.53l-1.19,-0.68l-1.83,-0.01l-1.52,0.68l-2.02,0.12l-0.77,0.53l-0.02,1.43l-2.01,0.92l-1.23,-0.4l-1.49,-1.22l-0.67,-1.03l-1.68,0.2l-1.2,-0.27l-1.49,2.14l-2.45,1.04l0.56,3.05l-1.89,-0.24l-1.82,0.86l-0.57,0.65l-1.08,0.31l-0.5,1.26l-0.78,0.59l-0.04,0.6l0.64,0.85l-1.22,0.28l-1.77,1.34l-0.89,-2.23l-2.91,-0.76l-0.53,0.3l-0.53,1.56l-1.66,1.42l-0.93,-0.68l-0.61,0.31l-0.37,0.87l-0.8,-0.53l-0.65,0.1l-0.76,2.26l0.62,0.38l0.81,-0.38l0.26,0.87l1.12,0.26l0.23,0.93l0.78,0.55l-0.95,0.16l-0.48,0.69l0.62,2.98l0.63,0.32l0.91,-0.41l2.9,1.47l0.22,0.97l-0.19,2.82l-1.77,0.32l-0.86,0.93l0.13,0.7l1.32,0.54l0.03,0.51l-0.3,1.18l-2.16,3.44l0.6,1.18l-1.19,2.09l-1.32,0.88l-1.54,0.11l-0.16,-1.09l-1.05,-0.25l-2.28,1.88l-0.4,0.99l-0.63,0.47l0.15,0.72l-0.91,0.04l-2.08,0.78l-1.43,-0.79l-1.0,-2.75l-1.76,-0.62l-0.53,-1.11l-0.79,0.21l-0.89,1.14l-1.83,0.13l-0.71,0.34l-1.25,-0.26l0.03,-1.62l-1.31,-2.88l-3.48,-3.53l0.79,-0.83l-0.41,-0.4l-0.8,-0.07l-0.82,-0.82l0.33,-0.64l0.06,-2.16l0.71,-0.87l-0.01,-0.47l-0.44,-0.14l-0.95,0.42l-0.17,-1.06l-0.71,-0.29l-1.12,-4.25l-0.51,-0.32l0.58,-0.47l-0.03,-0.73l-1.12,-0.76l-0.68,-2.42l-0.45,-0.54l1.06,0.74l0.82,0.06l0.41,-0.32l-0.74,-0.71l0.5,-0.8l-1.26,-0.43l-0.4,-0.57l0.51,-0.22l0.18,0.36l0.66,0.09l0.32,-0.64l-0.15,-0.76l-0.57,-0.46l-0.98,0.18l0.18,-1.71l-0.97,-1.49l0.42,-2.29l-0.5,-0.3l-0.41,-0.93l-0.12,-0.62l0.28,-0.53l-0.31,-1.31l0.56,-1.5l-0.17,-0.55l-0.76,-0.39l0.59,-1.37l-0.03,-0.91l-0.58,-1.34l0.09,-1.05l-1.37,-3.59l0.76,-0.16l0.19,-0.63l-1.62,-2.66l-0.76,-0.65l-0.09,-0.38l0.56,-0.85l-0.28,-0.75l0.12,-0.77l-1.59,-2.24l2.03,-0.65l-0.02,-0.73l-1.83,-0.43l-0.38,-0.57l0.05,-1.09l-0.52,-0.83l0.53,-1.46l-0.55,-1.76l-0.81,-1.2l-0.45,-1.72l-1.42,-2.31l0.42,-0.88l-0.28,-0.67l-0.53,-0.26l0.98,-0.85l0.18,-0.85l-0.51,-0.41l-0.94,0.54l-0.34,-0.37l-0.61,-4.09l-0.38,-0.69l-0.67,-0.29l0.19,-0.69l0.62,0.73l1.75,0.17l0.54,0.38l-0.31,0.81l0.58,0.48l0.45,-0.14l0.51,-0.78l-0.02,-2.09l-0.62,-0.75l-1.94,-0.11l-0.55,-0.53l0.14,-0.36l-0.36,-0.54l-1.6,-0.94l-0.01,-1.02l-0.62,-1.29l0.45,-2.33l0.71,-0.18l1.81,2.51l0.68,-0.15l0.19,-0.62l-0.86,-1.02l-0.88,-2.03l-0.71,-0.34l-0.82,0.14l-1.64,-3.67l-0.09,-2.7l0.29,-0.7l1.18,0.09l0.55,-0.62l0.88,0.95l0.04,1.25l0.91,0.59l0.53,-0.48l-0.1,-1.31l0.64,-0.91l-0.12,-0.67l-0.88,-0.45l-0.18,-1.43l-0.6,-0.05l-0.65,0.44l-1.04,-0.76l0.14,-0.26l0.68,-0.01l0.31,-1.08l1.2,-0.1l0.34,-0.51l-0.2,-0.37l2.02,-0.66l0.31,-0.64l-0.31,-0.57l-0.52,-0.07l-1.35,0.42l0.13,-1.87l-0.65,-0.58l0.22,-2.19l-0.4,-0.44l-0.59,0.23l-1.02,1.69l-0.22,1.38l0.37,0.69l-0.13,0.31l-0.7,0.72l-0.08,-0.33l-0.66,-0.2l-0.49,0.46l-1.25,2.43l-0.6,-0.82l0.51,-1.73l0.36,-0.09l0.25,-0.76l-0.32,-0.73l0.29,-1.17l-0.39,-1.12l0.4,-0.71l-0.24,-0.49l-0.7,-0.1l1.07,-1.85l-0.27,-0.66l-0.46,-0.04l-0.91,0.92l0.19,-2.07l2.08,-0.09l0.63,0.65l1.46,0.32l1.18,-0.24l1.53,2.69l0.5,0.1l0.71,-0.39l-0.01,-0.7l-0.42,-0.22l-0.17,-1.08l-1.36,-1.37l-2.73,-0.21l-1.89,-1.29l-1.07,0.49l-1.01,-1.35l-0.33,-2.78l3.69,-1.53l0.25,-0.37l-0.25,-0.37l-0.94,-0.31l-1.71,0.45l-0.95,-1.4l-1.01,-0.32l-0.28,0.39l0.16,-0.89l-0.58,-2.49l0.85,-0.61l-0.33,-1.12l0.55,-0.55l-0.18,-1.26l-0.69,-0.14l-0.89,1.09Z",name:"Maharashtra"},"IN-KL":{path:"M207.32,745.98l1.92,-0.19l0.39,1.27l1.23,0.49l0.41,0.89l0.63,0.19l0.89,-0.52l0.47,0.08l0.64,0.37l-0.1,0.79l0.5,0.89l0.57,0.23l0.78,-0.21l0.85,1.04l0.65,0.11l0.96,-0.48l0.95,0.25l-0.62,1.55l0.94,1.35l1.25,1.27l1.53,-0.21l-0.72,0.78l-0.15,1.13l0.93,1.53l0.64,2.08l1.3,0.28l3.32,3.77l2.15,1.07l0.78,1.07l1.13,0.04l1.41,0.84l1.39,0.08l0.46,1.8l1.32,1.45l1.59,0.7l3.14,0.56l3.3,-1.08l0.01,2.3l0.65,0.82l2.2,-0.0l1.26,1.62l1.5,0.11l1.64,1.8l1.14,0.25l1.17,-0.18l0.27,1.6l0.54,0.81l-1.2,0.5l-1.02,1.21l-0.98,0.1l-1.84,-0.51l-0.38,0.17l-0.33,0.69l-0.03,2.0l0.9,1.74l4.83,1.38l1.12,0.9l1.17,0.45l1.49,1.54l-2.87,2.82l-0.17,0.89l0.34,0.48l0.86,0.17l0.99,-0.3l1.57,0.46l3.34,-0.37l0.94,-0.61l-0.36,1.61l0.94,1.09l0.8,2.1l0.59,0.57l-1.64,-0.24l-0.64,0.35l-0.59,1.61l0.2,1.28l0.98,1.23l3.74,1.55l0.74,1.63l1.03,0.92l-0.41,2.95l-1.35,0.7l-0.35,0.83l0.17,2.6l-0.55,3.61l0.93,2.08l0.11,1.93l2.58,2.4l1.39,0.59l1.1,-0.31l2.7,-2.22l3.3,-1.4l1.27,1.82l0.4,1.65l0.73,0.77l-1.69,4.21l1.1,3.48l-1.02,2.47l0.32,2.94l-1.56,5.71l0.29,0.53l1.83,1.05l2.88,-0.69l1.58,2.31l0.11,0.81l-1.01,1.01l-0.96,2.65l-0.84,1.39l-2.5,7.28l-1.99,1.95l1.13,3.67l1.53,1.25l-0.52,1.84l-1.71,2.58l0.21,2.15l0.35,0.76l1.72,1.46l0.73,1.15l-0.92,1.3l-0.26,0.16l-0.49,-0.36l-0.56,0.34l0.28,1.93l-1.34,2.06l-0.32,1.41l-1.22,0.16l-3.21,-2.34l-3.51,-4.66l-1.64,-1.53l-0.43,-1.0l-3.63,-4.29l-1.58,-2.45l-2.39,-2.02l1.57,-0.71l0.15,-0.44l-0.37,-0.28l-1.08,0.1l0.47,-0.7l1.68,0.13l0.44,-0.23l-0.2,-0.71l0.54,-0.49l-0.28,-0.62l-0.95,-0.03l-0.85,0.6l-1.25,-0.25l-1.31,0.82l-1.58,-3.84l0.32,-0.33l0.19,-1.64l-0.19,-0.41l-0.65,0.2l-0.86,-2.3l-0.74,-0.28l-0.21,0.22l-1.05,-2.39l-1.56,-5.16l-1.24,-10.4l0.63,-0.17l0.66,4.3l0.62,0.34l0.41,-0.52l0.65,0.91l-0.63,1.46l-0.6,2.77l0.13,0.65l0.86,0.47l2.79,0.53l0.73,-0.32l0.81,-0.97l-0.14,-0.62l-1.15,-0.68l-1.47,-0.14l0.28,-0.66l-0.17,-2.85l-0.66,-1.06l-0.37,-2.02l0.45,-1.0l-0.04,-0.85l-1.08,-2.32l-1.52,-1.72l-0.77,0.08l-0.45,-1.39l0.12,-0.52l-0.61,-0.7l-0.27,-1.52l-1.31,-1.45l-0.38,0.26l-0.25,0.92l0.66,1.82l-0.66,-1.68l-0.14,-1.7l1.71,-1.2l0.21,-1.28l-0.71,-0.22l-0.54,-0.77l-0.8,-0.12l0.31,1.86l-0.42,0.47l-0.54,-0.68l-1.44,-5.09l-1.12,-1.55l-0.55,-2.53l-1.35,-1.65l-0.27,-1.2l-2.36,-4.94l0.51,-0.56l-0.14,-0.64l-0.79,-0.34l-0.43,-1.07l-1.9,-7.73l-3.14,-7.29l0.34,-0.6l-0.24,-0.72l-0.61,-0.15l-1.63,-2.78l-1.62,-0.56l-2.42,-6.52l-0.81,-1.13l-3.92,-4.33l-0.84,-0.02l-1.08,-1.51l2.17,0.47l0.48,-0.39l-0.52,-0.81l0.19,-1.18l-0.45,-0.08l-1.02,0.74l-0.61,0.02l-1.17,-1.08l1.13,-0.11l0.25,-0.56l-0.73,-0.93l0.1,-1.21l0.73,-0.02l1.61,-0.9l0.41,-0.84l-0.76,-0.53l-0.97,0.34l-0.9,-0.22l-1.68,1.27l-0.82,-0.2l-0.83,0.31l-0.37,2.56l-1.86,-5.57l0.26,-1.27l-0.48,-0.39l-0.64,0.24l-0.68,-1.84l-3.92,-7.22l-2.86,-6.72ZM250.45,836.37l-0.0,-0.01l0.01,-0.0l-0.0,0.02ZM249.88,834.43l-0.08,-0.57l-0.05,-0.2l0.67,0.8l-0.54,-0.03Z",name:"Kerala"}},height:932.9661457393951,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","indonesia",{insets:[{top:0,left:0,width:793,height:335.58228316462225,bbox:[{y:-678131.2320454835,x:10577634.333586475},{y:-220216.79943139793,x:10946840.788638955}]}],paths:{ID_ac:{name:"Aceh",path:"m36.71 92.06l-0.17 0.10l-0.71 -1.09l-1.25 -1.34l-0.98 -0.46l-0.59 -0.10l-0.24 -0.15l0.11 -0.15l0.99 -0.20l2.06 0.13l0.69 1.08l0.34 0.98l-0.01 0.86l-0.24 0.34zm-27.55 -61.11l2.59 1.42l0.08 0.66l0.28 0.46l1.01 1.00l1.79 1.40l0.85 0.35l3.94 0.98l4.04 0.27l1.91 -0.35l2.23 -0.88l0.36 0.00l0.90 0.48l1.52 -0.36l1.12 0.12l1.41 0.53l0.38 0.33l0.32 0.86l0.62 0.21l0.98 -0.20l3.93 -1.52l0.47 0.02l0.88 0.89l1.09 1.51l2.15 2.26l1.56 1.32l1.21 0.28l0.89 1.77l0.15 1.52l0.41 0.97l0.44 0.59l-0.09 0.93l0.82 -0.10l0.97 0.36l0.64 0.31l2.06 1.58l0.14 1.33l-0.36 0.86l0.00 0.00l-0.40 0.14l-0.80 -0.15l-0.77 0.21l-0.06 0.32l-0.27 0.12l-0.56 0.12l-0.38 -0.09l-0.09 0.21l0.30 0.53l-0.03 0.38l-0.41 0.24l0.15 0.47l-0.47 0.68l0.03 0.97l-0.21 0.29l-0.24 1.33l-1.21 0.65l0.06 0.38l-0.15 0.27l-0.56 -0.38l-0.18 0.03l-0.09 0.32l0.41 0.74l-0.12 0.35l-1.48 1.18l-0.44 0.62l0.33 0.82l0.47 0.50l0.00 0.32l0.27 0.18l-0.03 0.74l0.74 0.35l0.21 0.88l0.56 0.41l-0.33 0.53l0.27 0.56l0.03 0.44l0.65 0.44l0.27 -0.12l0.38 0.71l-0.24 0.79l-2.37 0.65l0.09 0.18l0.59 0.12l0.50 0.50l0.06 0.74l0.62 0.65l-0.09 0.97l-0.62 -0.06l-0.18 0.12l0.21 0.26l-0.03 0.53l0.27 0.88l0.00 1.06l0.92 0.24l0.59 1.06l0.95 0.12l-0.03 0.26l0.24 0.29l-0.33 0.50l-0.06 0.38l0.15 0.65l0.50 0.50l0.03 0.26l-0.62 0.21l-0.24 1.41l0.18 1.00l0.41 0.56l-0.06 0.71l0.83 0.35l0.53 1.62l-0.61 2.79l0.00 0.00l-3.51 -1.98l-0.40 0.00l-0.93 0.46l-2.10 -0.53l-1.65 -2.30l-0.10 -4.00l-0.32 -2.17l-0.58 -1.78l-0.20 -0.21l-0.80 -0.01l-1.57 -0.62l-0.47 -0.22l-0.66 -0.63l-1.24 -1.73l-0.46 -1.96l-0.47 -0.77l-1.53 -0.52l-1.58 -2.52l-1.23 -2.32l-1.40 -0.78l-0.47 -0.52l-0.30 -1.13l-1.60 -1.12l-2.64 -0.15l-1.33 0.22l-0.68 -0.14l-0.52 -0.30l-1.68 -1.64l-1.86 -2.77l-1.70 -1.81l-0.76 -0.24l-1.31 -1.01l-0.98 -0.44l-1.17 -1.04l-1.96 -2.36l-2.84 -2.64l-2.30 -1.88l-1.87 -2.83l-2.41 -4.69l0.34 -0.67l-0.06 -0.30l-1.17 -1.87l0.40 -2.12l-0.56 -1.28l0.17 -1.57l0.86 0.01l2.17 -1.40l0.40 -0.07l2.87 0.44l2.43 0.76l0.00 -0.00z"},ID_ba:{name:"Bali",path:"m352.57 279.00l-0.52 -0.07l-1.06 -0.59l-0.83 -0.67l0.13 -0.37l0.63 -0.57l0.28 -0.08l0.99 0.00l0.28 0.16l0.62 1.15l-0.01 0.28l-0.51 0.76zm-19.22 -12.44l0.39 0.18l0.33 0.57l0.33 0.10l0.67 -0.37l3.28 0.94l1.91 0.33l1.74 -0.17l0.67 -0.23l1.67 -1.47l0.92 -0.42l0.34 0.08l4.56 1.70l1.87 1.17l1.27 1.64l1.30 0.70l0.14 0.36l-0.07 0.34l-0.30 0.41l-1.34 1.14l-1.95 0.99l-0.97 0.33l-0.94 0.08l-1.20 0.57l-1.00 0.94l0.04 0.75l-1.34 0.79l0.53 0.67l0.12 -0.38l0.22 0.71l-0.36 0.51l-1.07 0.30l-0.96 -0.12l-0.19 -0.34l0.80 -0.64l0.61 -0.26l-0.24 -0.45l0.28 -0.63l-0.35 -0.50l-1.40 -1.47l-2.57 -2.24l-0.72 -0.41l-1.60 -0.62l-1.42 -0.27l-2.13 0.12l-2.43 -3.08l-0.27 -1.87l0.13 -0.43l0.70 -0.05z"},ID_bb:{name:"Bangka Belitung",path:"m202.10 179.06l-0.64 0.18l-0.57 -0.17l-1.69 -0.97l0.32 -0.77l1.15 -0.51l1.70 0.73l0.13 0.29l-0.40 1.22zm16.28 -8.41l4.36 1.21l3.09 2.51l0.52 1.76l-1.52 2.63l-0.13 1.93l-1.62 0.74l-0.46 1.13l-1.60 0.37l-0.18 -0.29l-0.10 -1.15l-1.72 -1.95l-0.37 0.14l-0.46 0.47l0.34 0.42l-0.07 0.76l-0.39 0.26l-2.95 0.95l-0.56 -0.24l-0.57 -3.51l0.56 -1.65l0.06 -2.30l0.36 -0.43l-0.03 -0.95l0.27 -1.94l0.28 -0.37l0.74 -0.11l1.05 0.07l1.10 -0.46zm-30.13 -13.12l0.82 1.33l0.49 1.40l-0.01 1.81l0.37 1.93l0.92 2.81l0.51 1.08l0.78 0.99l0.73 0.69l0.50 0.21l3.98 0.73l2.86 1.12l-0.68 0.39l-1.05 1.20l-1.27 3.27l-0.12 0.83l0.13 0.44l0.78 0.46l0.31 -0.07l1.19 0.55l0.00 1.23l-0.41 0.43l-3.43 0.07l-1.30 -2.08l-2.82 -1.27l-2.34 -0.67l-0.91 -0.45l-1.67 -0.17l-0.41 -0.30l-0.93 -1.55l-0.31 -1.34l0.00 -0.59l0.65 -1.50l-0.08 -0.89l-0.61 -0.52l-0.74 -0.21l-0.59 -0.74l-0.36 -3.52l-0.15 -0.33l-0.78 -0.56l-4.62 -0.52l-1.11 0.33l-1.27 0.11l-3.55 -0.88l-0.26 -0.85l0.35 -1.31l0.61 -0.45l1.88 -0.68l1.71 -1.18l0.23 -0.36l0.05 -0.46l-0.24 -0.47l-0.90 -0.55l0.16 -0.91l0.83 -0.85l1.07 -0.68l2.10 -0.66l0.49 0.12l0.74 1.75l0.15 1.67l0.92 0.74l1.24 0.29l0.49 -0.04l-1.74 -4.21l0.61 -0.32l2.47 -0.67l0.41 0.09l2.01 1.36l0.29 0.42l-0.27 0.83l0.14 0.57l0.96 1.56z"},ID_be:{name:"Bengkulu",path:"m118.55 174.61l0.21 0.59l0.85 0.54l0.14 0.71l0.88 0.53l0.13 0.28l0.44 0.15l0.30 1.19l0.40 0.64l0.62 0.14l0.47 0.44l1.15 -0.40l0.97 0.22l0.63 0.58l0.29 0.74l-0.11 1.22l0.23 0.15l-0.20 0.50l1.67 1.52l0.63 0.10l0.25 0.25l0.79 -0.56l0.86 -0.03l0.90 -0.56l0.25 0.11l0.03 0.34l0.29 0.47l0.27 -0.12l0.56 0.26l0.56 -0.25l-0.16 0.11l0.07 0.56l0.21 0.20l0.82 -0.32l0.79 0.09l0.21 0.45l-0.18 0.35l0.04 0.83l-0.15 0.93l-0.03 0.14l-0.33 0.09l-0.32 0.72l-0.72 0.74l-0.17 -0.05l-0.36 -0.64l-0.53 -0.56l-0.53 -0.30l-0.16 0.04l-0.07 1.45l-0.49 0.31l-0.63 0.76l-0.12 1.14l-1.33 0.47l-0.23 0.36l-0.47 0.18l0.67 0.20l0.40 0.40l0.17 0.40l0.89 0.51l0.85 1.08l0.68 0.39l0.76 0.20l0.61 -0.29l0.40 0.16l0.26 0.51l0.21 0.12l1.26 0.06l0.94 -0.14l0.29 0.24l0.40 0.05l0.50 1.37l0.46 0.67l0.01 1.63l1.91 0.31l0.49 0.56l0.73 0.44l0.73 0.01l0.57 0.21l0.40 -0.09l0.34 0.61l0.55 0.30l0.98 -0.36l0.56 0.18l0.31 0.65l0.01 0.57l-0.57 0.54l-0.26 0.52l1.09 1.04l-0.71 0.62l0.78 0.04l0.64 0.50l0.30 0.42l0.18 0.88l-0.39 0.49l0.36 -0.09l0.62 0.29l0.40 0.02l0.36 0.60l-0.08 0.33l0.00 0.00l-0.08 0.05l0.00 0.00l-0.11 0.11l-0.81 -0.05l-0.13 0.51l-0.51 0.40l-0.43 0.08l-0.57 0.53l-0.32 0.06l-0.18 0.53l0.00 0.00l-0.80 -0.10l-0.53 -0.57l-0.47 -0.23l-0.85 -0.20l-0.30 0.20l-0.31 -0.13l-0.07 -0.24l0.22 -0.16l-0.26 -0.39l-0.51 -0.38l-0.32 0.02l-0.28 0.25l-0.40 -0.31l-0.05 -0.18l0.24 -0.34l-1.59 -1.74l-3.14 -2.08l-2.64 -0.97l0.06 -0.25l-0.60 -0.82l-0.99 -0.72l-0.14 -0.34l-3.57 -2.69l-0.77 -0.73l-4.55 -3.28l-0.18 -0.22l0.03 -1.06l0.42 -0.11l0.04 -0.27l-0.87 -1.73l-0.26 -1.61l-2.22 -1.80l-2.02 -1.22l-1.24 -0.49l0.06 -0.32l-5.58 -4.03l-1.47 -1.88l0.09 -0.24l-0.22 -0.51l-0.37 -0.26l-0.19 -0.73l-0.33 -0.22l-1.20 -1.78l-1.20 -2.90l-3.21 -1.80l-1.13 -1.59l-0.85 -0.80l0.00 0.00l1.61 -1.11l0.42 -0.44l1.09 -0.44l0.74 -0.56l0.80 -0.97l0.00 0.00l0.01 -0.02l0.00 0.00l4.71 2.96l-0.33 1.97l0.17 0.12l0.28 -0.48l0.44 -0.08l0.29 0.20l0.56 -0.16l0.12 -0.29l0.37 0.04l0.44 0.69l1.46 1.57l0.40 0.16l0.20 0.36l0.33 0.08l0.48 0.48l0.69 0.20l1.34 -0.16l0.84 0.52l0.47 0.12l0.00 0.00l0.05 0.02z"},ID_bt:{name:"Banten",path:"m199.17 231.93l-0.60 0.25l-0.04 1.12l0.61 0.33l-0.02 0.67l0.39 0.08l0.16 0.73l0.44 0.76l0.00 0.00l-0.04 0.15l0.00 0.00l-0.18 0.61l-2.91 0.02l-0.30 -0.36l-1.02 -0.27l-0.10 0.06l0.30 0.16l0.01 0.25l-0.54 0.04l-0.21 -0.65l-0.33 -0.10l-0.67 0.64l0.44 1.40l-0.25 0.33l-0.62 0.09l-0.11 0.96l0.56 1.24l-0.09 1.73l0.11 0.34l0.16 0.00l0.44 0.48l0.21 -0.03l0.55 0.66l-0.37 0.25l-0.03 0.27l-0.94 0.44l-0.08 0.71l-0.65 0.69l0.10 0.44l-0.18 0.18l0.16 0.76l0.00 0.00l-0.49 0.19l-1.01 0.05l-0.09 -0.28l-0.66 -0.03l-0.06 -0.23l-0.37 -0.10l0.03 -0.43l-0.91 -0.43l-0.55 -0.02l-0.54 -0.39l-0.46 -0.10l-0.70 -0.81l-0.54 -0.23l-1.44 -0.12l-2.94 0.61l-1.50 -0.19l-2.12 0.33l-0.40 0.29l-0.70 -0.19l-0.34 0.12l-0.61 -0.55l-0.31 -0.05l-0.15 0.31l-0.19 0.01l0.07 -0.26l-0.57 -0.38l-1.15 -0.24l-0.32 0.07l-0.20 0.43l-0.33 0.28l-0.41 -0.10l-0.15 -1.00l-0.21 -0.28l-0.16 0.00l-0.07 -0.26l0.98 0.07l0.33 -0.45l0.80 -0.58l-0.12 -0.43l0.83 -0.40l0.57 1.27l-0.18 0.05l-0.07 0.23l0.50 0.33l0.32 0.53l0.05 0.44l0.31 0.25l0.21 -0.04l0.52 -0.63l0.14 -0.99l1.05 -0.86l0.07 -0.40l0.36 -0.14l0.32 -0.42l0.22 -0.71l-0.09 -0.80l0.54 -0.94l0.40 -0.31l0.13 0.48l-0.18 0.24l0.41 0.32l0.34 0.06l1.02 -0.21l0.70 -0.96l0.17 -0.58l0.08 -3.08l0.61 -2.25l0.39 -0.24l-0.03 -0.61l0.75 -0.47l0.27 -0.40l0.78 -0.64l0.18 -0.87l-0.27 0.05l0.87 -0.84l0.74 -0.11l0.56 0.65l-0.02 1.29l1.02 0.55l0.26 0.03l0.76 -0.35l0.26 -0.29l0.12 -0.49l0.23 -0.17l0.87 0.29l0.12 0.20l0.29 0.09l0.40 -0.41l0.27 0.26l0.32 0.03l-0.09 0.15l0.23 0.52l0.49 0.26l0.38 -0.07l0.73 0.23l0.73 -0.53l0.49 0.31l0.93 -0.17l0.21 -0.16l0.43 0.25l0.49 -0.15l0.47 0.46l-0.09 0.12l0.31 0.69z"},ID_go:{name:"Gorontalo",path:"m466.82 109.58l0.59 0.20l2.41 -0.05l1.67 0.18l3.41 0.99l0.24 0.35l2.96 1.83l1.11 -0.69l0.85 -1.22l2.55 -0.37l0.00 0.00l0.21 0.82l0.54 0.39l0.86 0.23l0.70 0.69l-0.04 0.47l0.27 0.85l0.62 0.54l1.21 0.89l2.03 0.35l0.54 0.58l0.31 0.85l-0.15 1.08l0.07 1.01l-0.81 1.43l-0.28 0.98l0.00 0.00l-2.14 0.03l-1.50 -0.40l-1.28 -1.18l-0.81 -1.20l-1.03 -0.89l-0.51 0.38l-1.38 0.14l-8.43 -0.31l-1.82 0.00l-3.06 0.31l-2.37 -0.05l-0.51 0.13l-0.60 0.52l-1.63 0.32l-1.75 0.06l-1.48 -1.67l-2.93 -0.32l-0.24 0.12l-0.20 0.68l-0.29 0.25l-2.77 0.32l0.00 0.00l0.28 -0.50l-0.17 -1.47l-0.69 -0.03l-1.07 -0.34l-0.50 -0.78l-0.57 -0.31l-0.26 -0.43l0.31 -0.17l0.06 -1.07l0.34 -0.34l1.06 -0.38l0.97 0.38l0.52 -0.10l0.02 -0.96l0.35 -0.41l0.89 0.51l1.33 0.05l0.48 -0.41l1.45 -0.01l2.07 -0.95l1.11 -0.30l0.79 -0.61l0.85 -0.14l0.49 0.80l0.49 0.52l0.42 0.17l0.30 -0.27l0.13 -0.65l0.37 0.00l0.52 -0.60l0.26 0.03l2.26 -0.85z"},ID_ja:{name:"Jambi",path:"m160.61 155.65l-1.28 -0.52l-0.54 0.11l-0.32 0.16l-0.16 0.27l0.10 0.75l-0.32 0.43l-1.02 0.27l-0.97 -0.11l-0.92 0.43l-1.35 0.32l-1.08 -0.27l-0.75 0.00l-0.50 0.18l-1.01 -0.52l-0.45 -0.08l-0.72 0.36l-0.29 0.52l-1.66 0.08l-2.18 0.81l-1.09 0.96l0.00 0.81l-0.20 0.76l0.08 0.32l-0.20 0.40l0.00 1.33l0.56 0.48l-0.69 0.48l-1.09 0.28l-0.08 0.41l0.20 1.56l-0.20 0.21l0.12 0.76l-0.16 0.04l-0.20 -0.36l-0.53 -0.12l-0.36 -0.65l-0.81 -0.44l-0.16 -0.44l-0.65 -0.56l-0.08 -0.77l-0.32 -0.36l-0.49 -0.08l-0.28 0.24l-0.16 0.44l-0.33 0.12l-0.20 0.29l-0.24 0.60l0.69 0.68l0.16 0.73l-1.54 0.60l-1.13 -0.36l-0.08 -0.24l-0.20 -0.04l-0.29 0.52l-1.90 -0.32l-0.72 -0.28l-0.57 0.84l0.61 1.00l-0.49 0.37l-1.05 1.77l-0.45 0.36l-0.28 0.04l-0.28 -0.16l-0.93 0.76l-0.77 0.32l-0.20 0.20l0.00 0.32l-0.61 0.65l-0.48 -0.20l-0.41 0.08l-0.60 0.44l-0.09 -0.16l-0.76 0.00l-0.69 -0.16l-0.57 -0.56l-0.52 -0.29l-0.20 0.20l-0.29 0.00l-0.85 -0.52l-0.56 0.24l-0.08 0.73l-0.41 0.44l-0.81 0.12l-0.20 0.20l-0.61 0.16l-0.40 0.73l0.00 0.00l-0.57 -0.17l0.00 0.00l-0.47 -0.12l-0.84 -0.52l-1.34 0.16l-0.69 -0.20l-0.48 -0.48l-0.33 -0.08l-0.20 -0.36l-0.40 -0.16l-1.46 -1.57l-0.44 -0.69l-0.37 -0.04l-0.12 0.29l-0.56 0.16l-0.29 -0.20l-0.44 0.08l-0.28 0.48l-0.17 -0.12l0.33 -1.97l-4.71 -2.96l0.00 0.00l0.23 -0.51l0.00 0.00l-0.18 -1.65l-0.56 -1.67l-0.39 -0.74l-0.71 -0.32l-0.35 -0.41l-0.15 -0.50l-0.47 -0.50l-0.15 -0.41l-0.21 -3.65l0.18 -0.03l0.50 0.36l0.18 -0.36l0.15 -0.03l0.68 0.71l0.56 -0.35l1.06 0.03l0.54 -0.27l0.56 0.03l0.62 -0.18l0.38 0.36l1.01 -0.27l1.18 -1.79l2.01 -1.23l0.62 -1.12l0.00 -0.23l-0.41 -0.35l0.00 -0.21l0.41 -0.47l-0.41 -1.62l0.62 -0.61l0.62 0.03l0.33 -0.24l0.62 -0.15l0.82 -1.02l0.30 -0.86l-0.12 -0.08l-0.35 0.26l-0.53 -0.44l0.11 -0.76l-0.14 -0.12l-0.03 -1.00l0.00 0.00l-0.03 -0.02l0.00 0.00l0.60 0.10l0.04 -0.31l0.80 -0.18l0.18 -0.62l0.59 -0.29l0.24 0.21l0.11 -0.35l0.47 -0.27l0.40 0.06l0.45 0.33l0.41 -0.16l0.93 0.45l0.37 -0.33l0.39 0.04l0.41 0.35l0.00 0.31l0.20 0.14l0.39 -0.04l0.86 -0.49l0.57 -0.04l0.30 0.76l1.00 0.51l-0.04 0.64l1.22 0.12l0.47 0.76l0.77 0.02l0.80 0.33l0.67 -0.09l0.61 0.42l0.29 -0.05l0.51 -0.61l0.69 -0.08l0.53 -0.86l0.47 -0.44l0.10 -0.36l2.10 -1.50l0.85 -0.97l0.86 -1.35l1.18 0.08l0.85 -0.22l3.61 0.63l0.39 0.31l0.85 -0.47l1.18 -0.11l0.00 0.00l0.42 0.43l0.79 0.36l0.89 1.10l0.90 0.73l1.00 0.42l0.63 0.52l1.10 0.26l0.53 0.37l0.84 -0.37l-0.03 0.11l1.22 -0.26l2.65 0.75l1.91 0.74l2.21 -0.75l0.40 0.07l0.75 1.74l-0.31 1.44l0.25 0.82l0.71 1.17l0.12 1.06l-0.30 1.95l0.44 1.86l0.48 0.85z"},ID_jb:{name:"Jawa Barat",path:"m205.67 229.27l0.77 0.80l0.42 0.08l2.20 -0.50l0.91 0.26l0.88 0.94l1.22 2.06l1.61 0.62l1.06 0.13l0.86 0.94l0.42 -0.34l0.22 0.14l0.49 -0.03l1.31 -0.79l0.62 0.02l0.12 0.42l0.61 -0.33l0.15 0.27l-0.28 -0.01l0.08 0.50l1.08 0.38l1.42 0.81l1.61 0.49l1.00 -0.62l0.42 -0.47l-0.07 -0.38l-0.35 -0.34l0.37 0.06l0.27 0.28l1.34 -0.03l0.63 0.45l0.08 -0.49l0.14 -0.07l0.29 0.40l0.16 0.54l-0.12 0.17l0.28 0.83l1.34 1.50l1.36 0.81l0.15 1.20l-0.09 0.57l0.37 1.85l0.65 1.15l0.59 0.15l0.28 -0.34l0.48 0.26l0.08 0.57l1.17 0.28l0.93 -0.46l0.05 -0.37l-0.31 -0.11l0.23 -0.27l0.47 -0.03l0.00 0.00l-0.07 1.47l-0.56 0.85l-0.25 0.11l-0.43 0.58l0.16 0.50l-0.05 0.65l0.65 0.37l-0.04 0.36l-0.27 0.23l0.10 0.31l-0.17 0.37l0.05 0.37l-0.28 0.26l-0.66 0.05l-0.48 0.58l-0.58 0.06l-0.34 -0.31l-0.34 0.01l-0.98 0.48l-0.02 0.57l0.28 0.27l0.00 0.51l-0.47 0.81l0.09 0.82l0.18 -0.02l0.21 0.24l1.17 -0.09l0.51 0.48l0.11 0.48l0.55 0.59l-0.13 0.46l0.10 0.44l0.30 0.37l0.34 0.94l-0.08 0.52l-0.29 0.44l0.69 0.73l0.49 0.25l0.00 0.00l-0.68 0.43l-0.52 -0.30l-0.74 -0.06l-0.47 0.31l-0.04 0.14l0.33 0.35l-0.14 0.13l-0.36 -0.22l-0.13 -0.51l-1.05 -0.04l-0.92 0.21l-0.40 0.39l-0.08 1.12l-0.45 0.32l-0.62 0.24l-1.69 0.00l-4.47 -0.77l-1.54 -0.52l-1.46 -0.18l-1.04 0.07l-0.18 -0.10l-0.10 -0.47l-0.45 -0.28l-0.49 -0.21l-1.50 -0.16l-0.33 -0.73l-1.22 -0.87l-2.18 -0.79l-0.36 -0.31l-1.31 -0.25l-2.57 -0.19l-2.01 -0.53l-9.47 -0.66l-0.87 -0.25l-0.49 -0.47l-0.86 -0.28l-0.55 0.19l-0.02 -0.35l-0.47 -1.06l0.01 -0.80l0.57 -0.91l0.88 -0.19l-0.24 -0.52l0.10 -0.37l0.49 -0.42l0.45 -0.17l0.63 -0.85l-0.07 -0.91l-0.51 -0.51l-1.23 -0.15l-0.47 0.17l-0.31 0.32l0.00 0.00l-0.16 -0.76l0.18 -0.18l-0.10 -0.44l0.65 -0.69l0.08 -0.71l0.94 -0.44l0.03 -0.27l0.37 -0.25l-0.55 -0.66l-0.21 0.03l-0.44 -0.48l-0.16 0.00l-0.11 -0.34l0.09 -1.73l-0.56 -1.24l0.11 -0.96l0.62 -0.09l0.25 -0.33l-0.44 -1.40l0.67 -0.64l0.33 0.10l0.21 0.65l0.54 -0.04l-0.01 -0.25l-0.30 -0.16l0.10 -0.06l1.02 0.27l0.30 0.36l2.91 -0.02l0.18 -0.61l0.00 0.00l0.04 -0.15l0.00 0.00l0.52 -0.05l-0.24 0.68l0.12 0.15l0.90 -0.25l0.85 0.49l0.18 -0.05l0.21 -0.95l-0.21 -0.37l-0.05 -0.56l0.63 -0.17l0.41 -0.86l0.06 -1.99l0.00 0.00l0.37 -0.06l0.18 -0.25l-0.25 -0.41l0.42 -0.28l-0.16 -0.22l-0.17 0.09l-0.05 -0.34l0.31 -0.26l0.11 -0.66l-0.17 -0.23l-0.29 0.07l0.00 -0.09l0.60 -0.41l1.28 0.38z"},ID_jl:{name:"Jawa Timur",path:"m313.04 272.79l0.65 0.13l0.86 -0.05l0.48 0.30l-0.17 0.37l-1.01 0.24l-0.98 0.05l-0.45 -0.19l0.03 -0.52l0.35 -0.14l0.08 -0.27l0.16 0.08zm42.62 -23.22l0.54 0.18l-0.07 0.26l0.23 0.20l0.52 0.06l0.10 0.21l0.26 0.00l0.17 -0.14l0.00 -0.37l0.41 -0.18l-0.01 -0.23l0.27 -0.13l-0.27 1.55l-0.30 0.23l-0.79 0.06l-1.30 -0.64l-0.17 -0.33l0.28 -0.44l-0.16 -0.45l0.14 -0.24l0.15 0.40zm-23.80 1.19l-0.28 0.06l-0.70 -0.19l-0.79 -0.55l-0.32 -0.62l0.23 -0.57l0.85 -0.26l0.49 0.34l0.74 1.51l-0.22 0.28zm21.69 -3.62l0.57 0.33l0.16 0.37l-0.55 -0.20l-0.58 0.14l-0.48 -0.18l-0.06 -0.34l-0.28 -0.03l-0.11 -0.27l0.26 -0.33l1.07 0.51zm-28.43 -1.48l1.76 0.91l0.32 0.77l-0.57 -0.02l-0.36 0.32l-0.53 0.19l-1.23 0.08l-0.34 0.28l-0.45 -0.21l-0.21 0.13l0.60 0.28l0.42 0.47l1.44 0.08l0.23 0.66l-1.60 -0.19l-0.64 -0.47l0.09 -0.32l-0.43 -0.19l-0.57 0.45l-0.13 0.28l-0.04 0.17l0.25 0.11l0.11 0.32l-0.11 0.23l-3.59 -0.43l-0.60 0.38l-0.21 -0.09l-0.58 0.11l-0.42 0.47l-0.42 1.21l-0.68 0.45l-0.21 -0.17l0.13 -0.09l-0.08 -0.17l-0.76 -0.15l-3.13 -0.11l-0.30 0.17l-1.27 0.04l-0.30 -0.49l-0.34 0.06l-0.02 -0.23l0.21 -0.26l-0.34 -0.30l-0.38 0.45l0.17 0.38l0.38 0.34l-0.93 0.09l-3.55 -0.87l-0.49 -0.28l-1.49 -0.09l-0.40 0.25l-0.66 0.02l-0.45 -0.36l0.23 -0.94l-0.28 0.00l-0.26 -0.68l0.21 -0.47l0.60 0.15l1.23 -1.02l0.60 -0.89l-0.04 -0.34l1.06 -0.38l1.59 -0.02l0.68 -0.15l1.64 0.21l5.59 -0.06l1.19 0.17l3.46 -0.25l1.15 0.06l2.57 -0.38l1.48 0.33zm22.26 -0.93l2.21 0.16l0.96 0.33l1.49 0.84l0.24 0.44l-0.44 0.60l-0.43 -0.26l-0.45 0.03l-0.43 -0.43l-1.02 0.16l-0.33 -0.38l-0.41 0.06l-0.10 0.14l-0.50 -0.06l0.07 0.23l0.71 0.33l0.38 0.55l-1.16 0.13l-0.27 -0.38l-0.18 0.01l-0.23 0.13l0.03 0.38l-0.26 0.08l-0.67 -0.64l0.47 -0.54l-0.31 0.10l-0.84 -0.08l-0.14 -0.31l0.18 -0.62l0.50 -0.09l0.24 -0.33l0.01 -0.18l-0.43 -0.23l0.09 -0.10l0.33 -0.16l0.69 0.09zm-61.39 -1.01l0.50 0.05l0.83 0.41l0.63 0.02l0.93 -0.23l0.70 -0.40l0.44 0.05l1.15 1.90l0.39 0.29l0.91 0.12l0.89 -0.05l1.03 -0.43l0.47 0.12l1.30 -0.25l1.25 0.17l0.25 -0.14l0.53 0.15l0.59 0.45l0.66 0.13l0.37 -0.46l-0.23 -0.29l0.28 -0.18l-0.05 -0.34l0.40 0.34l0.12 -0.07l0.02 0.31l0.28 0.39l0.29 -0.01l0.21 0.28l-0.13 0.27l-0.22 -0.09l-0.02 0.27l0.32 1.01l0.61 0.45l0.09 0.55l-0.38 0.44l-0.15 0.79l0.78 0.71l0.04 0.38l-0.29 0.18l0.00 0.29l0.27 0.18l0.63 0.04l0.17 -0.39l0.81 -0.09l0.36 0.27l0.39 0.71l0.70 0.56l-0.02 0.50l-0.22 0.26l0.20 0.10l-0.16 1.17l0.06 1.27l-0.37 0.06l0.34 0.60l0.47 0.15l0.14 0.22l-0.14 0.86l0.20 0.05l0.25 0.49l0.79 0.28l0.24 -0.18l0.37 0.41l0.48 0.23l0.40 -0.17l0.45 0.11l0.74 0.84l1.43 0.73l0.71 -0.14l0.67 0.11l0.59 0.70l0.39 -0.22l0.26 0.07l0.51 -0.20l0.38 -0.39l0.59 -0.06l1.65 -0.66l0.83 0.23l0.50 -0.06l1.55 0.44l0.75 -0.42l0.66 0.47l0.23 -0.02l0.50 -0.15l0.43 -0.52l0.58 -0.27l1.26 0.31l1.07 -1.09l0.86 -0.43l0.56 0.39l0.59 1.23l0.16 0.07l1.60 0.12l0.65 -0.31l0.85 0.80l1.55 0.26l0.99 0.60l0.45 0.63l0.00 0.92l-0.78 0.69l0.20 1.30l-0.01 1.12l-0.42 0.79l-0.09 0.77l-0.31 0.66l0.10 0.74l-0.37 0.79l-0.42 2.22l-0.05 0.58l0.42 0.84l-0.22 0.66l0.23 0.21l0.17 -0.09l0.18 -0.86l-0.09 -0.55l0.12 -0.07l0.20 0.22l-0.02 0.50l0.20 0.52l-0.12 0.57l0.37 0.95l0.48 0.58l0.48 -0.38l0.62 0.60l0.98 0.16l0.59 0.90l-0.25 0.78l-0.34 0.27l-0.70 0.16l-1.63 -0.55l-1.07 0.03l-0.48 -0.12l-0.06 -0.23l0.45 -0.22l0.12 -0.33l-0.16 -0.57l-0.61 -0.62l-1.22 -0.55l-0.54 0.05l-0.15 0.18l0.04 0.47l-0.16 0.10l-1.94 -0.51l-1.06 0.30l-0.26 -0.18l0.00 -0.46l-0.29 -0.12l-0.27 0.16l-0.03 0.21l-0.61 0.05l-0.23 -0.25l0.37 -0.10l0.02 -0.26l-0.28 -0.33l-0.29 0.00l-0.32 0.34l-0.58 -0.33l-0.84 -0.14l0.02 -0.41l-0.30 0.34l-0.16 -0.03l0.02 -0.85l-0.20 -0.11l-0.66 0.23l-0.16 0.27l-0.23 0.09l-0.22 -0.11l-0.14 0.13l-0.09 -0.06l0.17 -0.43l-0.13 -0.25l-0.37 0.28l-0.20 -0.17l-0.17 0.12l-0.79 -0.92l-0.43 -0.16l-0.40 0.06l0.06 -0.12l-0.17 -0.12l-0.27 0.15l-0.52 -0.07l-0.78 -0.37l-0.02 -0.41l-0.37 -0.16l-0.60 0.06l-0.60 0.36l-0.65 -1.07l-0.29 -0.25l-0.80 -0.53l-0.93 -0.23l-0.87 -0.06l-2.68 0.45l-1.02 0.60l-0.34 0.61l-0.52 0.42l-3.65 0.50l0.08 0.50l-0.39 0.13l-1.21 -0.63l-1.07 -0.33l-2.01 -0.17l-0.46 -0.28l-0.46 0.00l-0.83 -0.61l-0.76 -0.22l-0.59 0.31l-0.61 -0.09l-0.57 -0.31l-2.53 -0.09l-0.46 -0.09l-0.28 -0.31l-0.47 -0.20l-0.63 -0.10l-0.10 0.12l0.11 0.22l-0.78 0.00l-0.71 -0.59l-0.22 -0.02l-0.12 0.25l-0.65 -0.17l-0.05 -0.16l-0.41 0.10l0.09 1.06l-0.31 0.18l-0.33 -0.04l0.11 -0.33l-0.22 -0.39l-0.34 0.01l-0.08 0.16l0.20 0.35l-0.38 0.01l-0.10 0.21l0.39 0.33l0.07 0.24l-0.50 0.13l-0.31 -0.02l-0.16 -0.28l-0.75 -0.08l0.14 -0.20l-0.07 -0.33l-0.22 0.00l-0.04 0.13l-0.33 -0.09l-0.15 0.18l-0.28 -0.07l-0.02 -0.37l-0.31 -0.07l-0.24 0.46l-1.29 -0.31l-0.17 -0.78l-0.33 -0.20l-0.66 0.37l-2.50 -0.53l-0.52 0.35l-1.24 0.11l-0.83 -0.58l-0.04 -0.34l-0.28 -0.02l-0.08 0.45l-1.00 0.11l-1.96 -0.65l0.00 0.00l-0.12 -0.82l0.25 -0.91l0.70 -0.92l1.26 0.33l0.84 -0.61l0.55 0.31l0.44 -0.70l-0.07 -1.06l0.28 -0.19l-0.04 -0.30l0.18 -0.18l0.64 -0.16l0.07 0.28l0.42 -0.06l0.27 0.33l0.30 -0.09l0.62 -0.68l0.18 -0.70l0.31 -0.24l-0.58 -1.31l0.10 -0.56l-0.96 0.04l-0.83 -0.68l0.10 -0.38l-0.07 -0.77l0.18 -0.62l-0.64 -0.42l-0.19 -0.80l0.03 -0.64l-0.27 -0.33l-0.30 -1.02l0.46 -0.97l-0.06 -0.49l0.15 -0.42l-0.18 -0.12l0.19 -0.71l0.09 -0.13l0.33 0.10l0.40 -0.13l0.09 -0.18l0.21 0.03l0.46 0.56l1.16 0.42l0.74 0.50l1.14 0.27l0.25 0.30l0.40 0.13l0.09 -0.27l-0.30 -0.15l0.16 -0.55l-0.46 0.00l0.36 -0.89l0.21 -0.21l0.15 0.10l0.22 -0.18l0.10 0.09l0.95 -0.50l0.68 -0.70l0.65 -1.28l-0.06 -0.50l0.21 -0.33l-0.21 -0.90l0.19 -0.45l-0.98 -0.67l0.30 -0.52l0.40 -0.16l0.24 -1.35l0.67 -0.09l0.15 -0.21l-0.04 -0.61l0.16 -0.18l0.18 0.15l0.20 -0.34l0.00 0.00l0.39 0.27l0.38 0.03zm16.67 -17.98l0.39 0.10l-0.01 0.30l0.27 0.53l-0.18 0.82l-0.76 0.39l-0.63 -0.05l-0.17 -0.14l-0.36 0.17l-0.47 0.00l-0.29 -0.52l0.27 -0.89l0.32 -0.05l0.07 -0.37l0.35 -0.22l0.29 -0.12l0.39 0.09l0.22 -0.34l0.30 0.30z"},ID_jk:{name:"DKI Jakarta",path:"m173.99 239.52l-0.26 0.49l0.16 0.73l-0.30 0.61l-0.64 0.23l-0.42 0.57l-0.21 -0.28l0.38 -0.45l0.03 -0.40l-0.33 -0.26l0.02 -0.42l-0.28 0.04l-0.54 0.49l-0.05 0.31l-0.26 -0.16l0.28 -0.59l0.99 -0.75l0.52 0.12l0.00 -0.26l0.49 0.02l0.26 -0.16l0.16 0.12zm25.57 -7.41l1.80 0.34l0.73 -0.41l1.40 -0.09l0.00 0.00l-0.06 1.98l-0.41 0.86l-0.64 0.17l0.06 0.56l0.21 0.37l-0.21 0.95l-0.18 0.06l-0.85 -0.49l-0.90 0.25l-0.11 -0.16l0.24 -0.68l-0.53 0.06l0.00 0.00l0.00 0.00l0.00 0.00l-0.44 -0.76l-0.16 -0.73l-0.39 -0.08l0.02 -0.66l-0.61 -0.33l0.03 -1.12l0.60 -0.26l0.00 0.00l0.40 0.17z"},ID_jt:{name:"Jawa Tengah",path:"m285.21 243.42l-0.20 0.34l-0.18 -0.15l-0.16 0.18l0.04 0.61l-0.15 0.21l-0.66 0.09l-0.24 1.35l-0.40 0.16l-0.30 0.52l0.98 0.67l-0.19 0.44l0.21 0.91l-0.21 0.32l0.06 0.51l-0.65 1.27l-0.69 0.71l-0.95 0.50l-0.10 -0.09l-0.22 0.18l-0.15 -0.10l-0.21 0.20l-0.35 0.89l0.46 0.00l-0.17 0.55l0.30 0.15l-0.09 0.27l-0.40 -0.13l-0.25 -0.30l-1.14 -0.27l-0.74 -0.50l-1.16 -0.42l-0.46 -0.56l-0.21 -0.03l-0.09 0.18l-0.40 0.13l-0.32 -0.10l-0.09 0.13l-0.19 0.71l0.17 0.12l-0.15 0.42l0.06 0.49l-0.46 0.96l0.30 1.03l0.27 0.32l-0.03 0.64l0.19 0.80l0.64 0.42l-0.18 0.62l0.07 0.78l-0.10 0.37l0.83 0.69l0.96 -0.05l-0.10 0.57l0.58 1.30l-0.31 0.24l-0.18 0.70l-0.62 0.69l-0.30 0.08l-0.27 -0.32l-0.41 0.06l-0.08 -0.29l-0.63 0.17l-0.18 0.18l0.04 0.29l-0.28 0.20l0.08 1.05l-0.45 0.70l-0.55 -0.31l-0.84 0.61l-1.27 -0.33l-0.69 0.92l-0.25 0.91l0.12 0.82l0.00 0.00l-1.19 -0.29l0.00 0.00l0.04 -0.50l-0.12 -0.05l-0.18 0.18l-0.08 -0.11l0.24 -0.61l-0.22 -0.01l-0.32 0.38l-0.23 -0.18l0.05 -0.75l-0.57 -1.61l0.23 -0.55l-0.02 -1.10l0.29 -0.84l0.05 -0.89l-0.29 -0.17l-0.24 0.27l-0.37 -0.46l-0.32 -0.13l-0.17 0.22l-0.41 0.05l-0.19 -0.33l-0.24 0.23l-0.14 -0.14l-1.10 0.23l-0.21 -0.34l-0.23 -0.09l-0.36 0.23l-0.43 -0.40l-0.32 -0.06l-0.81 -3.89l-2.39 1.88l-0.57 0.77l-0.26 -0.14l0.03 -0.59l-0.20 -0.17l-0.29 0.12l-1.26 -0.13l-0.61 0.16l-0.18 0.43l0.32 0.28l-0.12 0.88l-0.34 0.51l-0.26 0.10l-0.20 0.42l-0.40 0.24l-0.31 1.28l-0.58 -0.03l0.00 0.00l-1.69 -0.62l-3.62 -0.99l-3.34 -0.53l-0.46 -0.18l-1.19 0.26l-0.46 -0.34l0.17 -0.50l-1.87 -0.42l-3.08 -0.23l-0.77 0.12l-0.59 0.35l-0.16 0.30l-0.09 0.38l0.19 0.24l0.28 -0.09l0.12 0.16l-0.19 0.24l-3.71 -0.80l-0.50 0.09l-0.17 -0.30l0.18 -0.27l-0.25 -0.08l0.30 -0.31l0.46 -0.07l0.18 -0.24l0.40 0.00l0.00 -0.15l-0.22 -0.09l-0.83 0.30l0.00 0.00l-0.49 -0.25l-0.69 -0.73l0.29 -0.44l0.08 -0.52l-0.34 -0.94l-0.30 -0.37l-0.10 -0.44l0.13 -0.46l-0.55 -0.59l-0.11 -0.48l-0.51 -0.48l-1.17 0.09l-0.21 -0.24l-0.18 0.02l-0.09 -0.82l0.47 -0.81l0.00 -0.51l-0.28 -0.27l0.02 -0.57l0.98 -0.48l0.34 -0.01l0.34 0.31l0.58 -0.06l0.48 -0.58l0.66 -0.05l0.28 -0.26l-0.05 -0.37l0.17 -0.37l-0.10 -0.31l0.27 -0.23l0.04 -0.36l-0.65 -0.37l0.05 -0.65l-0.16 -0.50l0.43 -0.58l0.25 -0.11l0.56 -0.85l0.07 -1.47l0.00 0.00l0.10 0.24l-0.10 0.26l0.29 0.05l0.25 0.45l1.63 0.47l0.24 -0.40l0.35 -0.02l0.69 -0.47l0.30 0.07l0.34 -0.39l0.14 0.89l0.66 0.62l0.87 0.00l0.46 0.28l1.22 0.18l0.76 -0.01l0.62 -0.20l0.42 0.08l0.99 -0.26l1.03 -0.57l0.69 -0.65l0.96 1.02l1.48 0.17l3.75 1.21l0.88 -0.09l0.64 0.17l0.76 -0.06l2.33 -0.77l0.39 -0.27l0.09 -0.25l0.76 0.24l0.50 0.82l0.87 0.32l0.33 0.27l1.01 0.31l1.13 -0.25l0.12 0.23l0.61 -0.23l-0.01 -0.43l0.47 -0.68l0.23 -0.74l0.59 -0.48l0.38 -0.77l-0.55 -0.04l-0.15 -0.23l0.40 0.07l-0.25 -0.46l0.36 -0.08l0.26 0.16l0.41 -0.30l0.63 -0.84l-0.07 -0.82l0.24 -0.08l0.09 -0.78l-0.11 -0.17l0.55 -0.62l-0.29 -0.32l0.28 -0.11l0.70 -0.85l1.07 -0.37l0.49 0.00l0.35 -0.28l1.24 -0.13l0.86 0.21l0.47 -0.16l1.09 0.35l1.03 3.09l0.65 0.86l1.03 0.23l0.70 0.37l2.31 0.23l1.40 -0.61l0.18 -0.49l0.49 -0.27l0.29 0.21l0.38 -0.09l0.70 0.29l2.12 1.87z"},ID_kb:{name:"Kalimantan Barat",path:"m236.01 155.78l-0.39 -0.07l-0.58 -1.45l0.15 -0.30l1.59 -0.47l0.62 0.14l0.55 0.61l0.02 0.26l-0.32 0.63l-1.64 0.65zm11.81 -11.54l0.54 0.06l0.42 -0.33l0.63 0.04l0.46 0.47l0.40 0.12l0.34 -0.14l0.33 -0.40l0.47 0.24l0.31 0.53l0.19 0.86l-0.07 0.53l0.23 0.25l0.00 0.25l-5.01 2.89l-1.31 -0.43l-0.44 -0.45l0.56 -0.61l0.18 -0.51l0.42 -2.20l-0.04 -0.43l0.75 -1.05l0.64 0.31zm1.94 -52.76l-0.50 1.38l-0.38 0.22l-0.30 0.75l-0.60 0.07l-0.05 0.48l0.17 0.65l0.45 0.32l0.40 0.62l1.20 0.30l0.15 0.35l-0.42 2.14l0.30 0.65l1.82 1.81l0.35 0.15l0.83 1.29l1.27 0.05l0.50 0.20l0.25 0.30l0.17 1.39l1.49 0.74l0.35 0.87l0.43 0.35l0.60 -0.07l0.73 0.15l0.45 0.67l0.15 0.52l0.48 0.40l0.42 0.72l0.32 0.97l0.98 0.00l0.97 0.25l0.90 1.37l0.35 0.27l1.20 0.42l0.73 0.07l0.55 -0.12l0.40 -0.67l0.45 0.45l0.45 -0.02l0.38 -0.32l0.77 -0.25l0.95 -0.55l0.72 -0.12l0.63 -0.55l0.27 -0.60l3.85 -0.50l1.95 -0.57l0.32 0.30l1.75 0.57l0.50 0.32l0.50 -0.02l0.70 -0.30l0.77 0.12l0.70 1.17l0.23 -0.02l0.10 -0.52l0.52 -0.07l1.13 -0.82l0.27 -0.02l1.00 0.52l0.58 -0.17l1.70 0.35l0.32 -0.77l1.35 -1.39l3.22 -0.22l-0.03 -0.65l0.25 -0.60l0.15 -1.49l0.85 -0.84l0.05 -0.65l-0.42 -0.65l0.50 -0.55l0.42 0.00l1.27 -0.79l1.57 -0.35l0.55 -0.27l0.08 -0.30l1.02 -0.37l2.90 0.37l1.65 -0.12l0.55 0.40l0.35 0.02l0.57 -0.30l0.35 -0.47l0.20 -0.05l0.82 0.22l0.92 -0.07l0.63 0.12l0.52 0.30l0.13 0.40l-0.17 0.05l-0.50 0.99l-0.50 0.17l-0.30 0.30l-0.15 0.45l0.75 0.07l1.35 -0.45l0.37 0.05l0.38 0.67l0.75 0.22l1.60 -0.15l0.77 0.20l0.72 0.50l0.17 0.35l0.60 0.37l0.30 0.37l0.40 0.02l0.33 -0.30l0.57 -0.22l0.82 -0.05l0.67 0.30l0.75 1.34l0.32 0.10l0.30 0.00l0.35 -0.22l0.38 -0.45l1.90 -0.77l0.28 -0.84l-0.13 -0.20l0.07 -0.17l1.92 -0.79l0.40 -0.45l3.05 -0.32l0.97 0.65l0.20 0.28l0.00 0.00l-0.03 0.01l0.00 0.00l-0.82 0.42l-0.12 1.72l0.21 0.18l-0.33 0.42l0.00 0.69l-0.21 0.69l-0.30 0.30l-0.52 -0.09l-0.55 0.36l-0.30 -0.15l-0.70 0.06l-0.52 0.42l-0.09 0.66l-0.30 0.24l-0.67 0.15l-0.09 0.36l0.33 0.30l0.12 0.42l-0.18 0.51l-0.52 0.51l-0.09 0.27l0.27 0.69l0.58 0.48l0.00 0.30l-0.52 0.63l0.06 0.81l-0.18 0.36l-0.67 0.27l-0.18 0.54l0.12 0.24l0.00 0.00l-0.51 0.29l-0.23 0.71l-0.36 0.24l-0.19 0.44l-0.37 0.16l-0.19 0.42l-0.40 0.00l-0.68 0.42l-0.27 1.09l-1.31 0.76l-0.16 0.31l-0.96 0.82l-0.05 0.23l-0.53 0.41l-0.92 0.56l-1.38 -0.26l-0.74 0.20l-0.63 0.38l-0.03 0.19l1.03 1.01l1.55 0.82l-0.15 1.34l0.19 0.35l0.36 0.25l-0.26 0.38l-0.18 0.76l0.37 0.05l0.07 0.22l-0.36 0.79l-0.44 0.26l0.34 0.20l-0.08 0.33l-0.36 0.07l-0.27 0.57l-0.56 0.52l-0.85 0.18l-0.42 0.60l-0.53 0.37l-0.19 0.60l-0.29 0.22l0.78 0.71l0.19 0.78l-0.66 0.80l-0.16 0.49l-0.12 0.08l-0.15 -0.14l-0.29 -0.50l-0.49 -0.01l-0.14 -0.35l-0.38 0.12l-0.27 0.52l-0.37 0.00l-0.33 0.23l-1.33 -0.14l-0.33 0.31l-1.44 0.42l-0.67 0.63l-0.70 0.12l-0.58 -0.18l-0.58 0.15l-0.08 0.86l-0.74 0.03l-0.25 0.42l-0.89 0.03l-0.60 0.35l0.00 0.20l-0.92 0.08l-0.10 0.19l-0.85 -0.16l-0.08 0.46l-0.23 0.23l-0.37 -0.26l-0.01 -0.61l-0.37 -0.14l-0.49 0.44l-0.85 0.31l-0.41 -0.18l-0.36 0.44l-0.41 -0.48l-0.64 -1.21l-0.34 -0.29l-0.55 -0.03l-0.82 1.14l0.23 0.72l-0.10 0.07l-0.38 0.00l-0.77 -0.31l-1.08 -0.11l-0.19 0.18l0.31 1.12l-0.07 0.31l-1.21 0.34l-0.37 -0.15l-0.49 -0.53l-0.14 0.86l0.29 0.76l-0.67 -0.15l-0.15 0.07l-0.16 0.57l-0.46 0.26l-1.01 -0.07l-0.77 0.27l-0.22 0.30l-0.93 0.56l-0.59 0.04l-0.30 0.37l0.18 0.69l-0.47 0.48l-0.48 0.15l-0.27 0.54l0.31 0.64l-0.26 0.48l0.33 0.29l-0.12 0.30l-1.19 0.20l-0.31 0.26l-1.11 0.01l-0.22 0.18l-0.12 0.54l-0.30 0.00l-0.36 0.75l-0.63 0.33l-0.16 0.60l-0.42 0.48l-0.21 0.04l0.04 0.29l-1.11 -0.22l-0.12 0.53l-0.38 -0.14l0.14 0.79l-0.08 0.65l-0.31 -0.14l-0.04 -0.49l-0.27 -0.16l-0.82 0.49l0.26 0.39l0.07 0.45l-0.81 0.22l-0.37 -0.42l-0.48 0.15l-0.30 0.30l-0.49 -0.39l-0.44 0.54l-0.88 0.22l-0.29 0.42l-0.55 0.38l0.04 0.78l0.44 0.11l0.18 0.44l0.26 0.19l0.42 -0.10l0.18 -0.14l0.11 -0.45l0.42 -0.18l0.29 0.16l0.22 0.52l0.12 1.20l-0.15 0.38l-0.37 0.34l-0.11 0.44l-0.03 0.64l0.33 0.41l-0.04 0.37l-0.34 0.42l0.15 0.42l0.34 0.23l0.52 -0.14l0.89 0.12l0.04 0.15l-0.15 0.40l0.07 0.42l-0.70 0.59l0.68 1.29l-0.04 0.23l-0.19 0.23l0.03 0.29l-0.62 0.72l0.69 1.13l0.52 1.82l0.08 1.31l0.53 2.06l-0.33 0.82l0.45 0.27l0.34 -0.01l0.15 0.45l-0.52 0.91l-0.90 0.45l-1.45 0.37l-0.15 0.57l-0.62 0.52l-1.18 0.20l-0.78 0.48l-1.21 0.41l-0.38 0.29l-0.34 0.94l0.00 0.00l-1.33 0.83l-0.34 -0.14l0.08 -0.30l-0.19 -0.69l0.08 -0.84l-0.37 -0.87l-0.47 -0.57l-0.64 -0.07l-1.08 0.33l-1.31 0.63l-1.95 1.60l-0.20 -0.27l-0.47 -0.10l-0.17 -0.94l-0.34 -0.57l0.54 -1.07l0.10 -0.60l-0.34 -0.47l-0.41 -0.19l-0.18 -1.66l-1.26 -0.37l0.67 -0.80l0.25 -1.26l-1.04 -3.80l-0.73 -0.87l0.04 -1.11l0.49 -1.46l0.01 -0.68l-0.70 -1.80l-0.69 -0.50l-1.67 -0.71l-0.78 -0.75l0.19 -0.92l1.34 -0.79l0.69 -1.20l0.65 -3.33l0.01 -1.52l-0.22 -0.74l-0.21 -0.38l-0.66 -0.52l-0.80 -0.18l-0.87 -1.10l0.52 -1.40l-1.92 -0.63l-1.17 -1.61l-0.67 -0.41l-0.73 0.49l-1.13 -0.75l-0.41 -0.76l-0.30 -0.27l-1.98 -0.55l-0.29 -0.27l-0.48 0.12l0.20 0.84l-0.26 0.41l-0.26 0.08l-1.72 -0.57l-0.56 -0.57l-0.46 -0.89l0.20 -2.60l0.46 0.12l0.36 0.37l1.15 0.34l0.79 0.04l1.05 0.63l0.02 -0.51l-0.97 -0.73l-0.87 -0.03l-0.23 -0.46l0.27 -0.46l0.04 -0.66l-1.42 0.03l-0.40 0.13l-1.68 -0.60l-0.72 -0.81l-0.43 -1.93l-0.99 -2.58l0.34 -0.59l0.64 -0.13l-0.17 -0.81l1.13 -1.79l0.38 -1.61l-0.20 -1.18l-0.84 -1.89l-1.10 -1.16l-0.82 -0.24l-1.23 -0.05l-0.28 -0.26l0.03 -0.63l0.45 -0.94l0.00 -0.52l-0.71 -0.84l0.47 -2.12l-0.27 -0.92l-0.73 -0.79l0.25 -0.87l-0.75 -0.89l0.15 -0.43l0.69 -0.55l0.52 -0.05l0.67 -0.69l0.39 -1.14l-0.43 -1.42l-0.49 -0.42l-0.47 -1.36l0.13 -0.20l0.73 0.17l0.00 -0.76l0.60 -1.12l0.73 -0.73l0.23 -0.79l-0.20 -1.26l0.13 -0.89l0.37 -0.69l0.74 -0.69l2.22 -1.34l0.54 -0.59l0.00 -0.45l0.50 -1.09l0.70 -0.96l0.06 -1.05l-0.26 -0.61l0.07 -0.26l0.47 -0.17l1.38 -0.03l0.31 -0.44l0.47 -0.20l1.69 -0.03l1.21 -1.40zm-13.97 -13.37l-0.17 0.06l-0.97 -0.74l0.92 -0.77l0.31 -1.05l0.48 -0.17l0.27 0.08l0.18 0.35l-0.18 1.49l-0.84 0.75zm-53.61 0.22l-0.38 0.02l-0.26 -0.27l-0.33 -2.69l0.12 -0.88l0.18 -0.04l2.55 1.42l-0.61 1.34l-0.87 0.88l-0.40 0.22zm44.48 -14.45l-2.29 0.48l-1.46 -0.81l0.60 -0.84l1.25 -0.91l-0.63 -0.37l-1.79 -0.59l-0.98 -1.85l-0.23 -1.12l0.59 -0.71l0.74 -0.21l1.96 -2.05l1.21 0.28l0.11 0.84l0.22 0.49l2.20 2.17l0.16 1.79l-0.22 0.78l-1.44 2.63z"},ID_ki:{name:"Kalimantan Timur",path:"m393.77 84.72l1.44 1.57l0.74 1.23l-0.02 0.43l-0.61 0.92l-2.71 2.45l-1.00 -0.42l-0.30 0.01l0.47 0.44l0.21 0.71l-0.09 2.17l0.15 0.60l0.80 0.91l2.30 1.59l1.45 1.46l4.93 2.90l0.53 1.35l1.32 0.61l0.59 -0.09l0.60 0.18l3.10 2.66l0.35 0.92l0.76 0.89l1.17 0.47l0.27 -0.03l1.25 0.41l0.18 0.16l0.07 0.95l-0.56 0.80l-0.73 0.69l-2.42 1.67l-2.04 -0.77l-2.97 0.28l-2.79 -0.25l-3.08 -0.58l-1.63 -0.74l-0.70 -0.72l-0.67 -1.80l-0.67 -0.57l-0.81 -0.40l-0.24 0.09l-0.03 0.44l2.40 4.10l0.09 0.74l-0.23 0.37l-0.38 0.07l-0.34 -0.10l-0.75 -0.70l-0.58 -0.10l-1.59 0.51l-1.20 1.17l-0.36 0.77l-0.01 0.91l-1.71 3.53l-0.91 0.66l-0.81 1.73l-0.71 2.10l-0.24 1.23l0.44 1.23l0.47 0.42l0.15 0.69l-0.19 0.43l-0.63 0.67l-0.79 2.47l0.01 0.47l0.60 1.28l-0.45 3.12l2.57 -1.67l0.45 -0.14l0.21 0.09l0.07 0.27l-1.06 3.59l0.82 1.77l0.03 0.44l-0.14 0.22l-2.79 1.24l-2.14 -0.12l-0.70 -0.83l-0.42 0.26l-0.14 0.80l-1.95 2.35l-2.05 3.34l-0.38 0.33l-1.40 0.62l-1.84 0.33l-1.32 -2.97l0.31 -1.12l-0.08 -0.20l-0.24 0.06l-0.48 1.29l0.01 0.54l0.70 0.70l0.59 1.31l-0.55 2.00l-2.25 0.78l-1.50 1.05l-0.13 0.16l0.09 0.76l0.49 0.79l-0.11 0.48l-0.33 0.40l-2.37 0.94l-1.66 0.81l-1.43 0.90l0.12 0.31l0.53 0.27l0.70 -0.15l0.59 -0.47l0.82 -0.18l0.72 0.08l0.35 0.21l0.26 2.24l-0.04 2.27l-0.39 0.49l-1.09 0.38l-0.25 0.28l1.32 0.28l0.81 0.00l0.41 -0.40l0.34 0.74l-0.05 0.34l1.42 0.38l-0.11 1.39l-0.70 2.47l0.00 0.00l-1.33 -0.61l-1.10 -0.29l-2.70 -0.03l-1.28 -0.42l-2.73 -0.15l-0.39 -0.07l-0.53 -0.49l-0.54 0.49l-0.78 0.29l-0.10 0.31l-0.39 0.36l-0.54 0.17l-0.28 -0.53l0.03 -1.02l-0.71 -1.73l0.18 -1.52l0.36 -0.56l-0.15 -0.25l-0.60 -0.25l-0.50 0.14l-0.35 -0.28l-0.18 0.04l0.21 -0.60l-0.28 -0.32l0.00 -0.42l0.32 -0.71l0.07 -0.71l-0.14 -1.87l-0.36 -0.74l-0.49 -0.56l-0.11 -0.50l0.14 -0.31l-0.71 -0.57l-0.14 -0.32l0.14 -0.70l-0.28 -0.39l-0.61 -0.11l-0.60 0.25l-0.18 -0.35l0.07 -0.35l0.64 -0.57l0.43 -0.67l0.82 -0.70l0.32 0.07l-0.15 0.77l0.25 0.07l1.07 -1.27l0.25 -0.99l0.00 0.00l-0.01 0.01l0.00 0.00l0.23 -1.30l0.45 -0.53l0.91 -0.66l0.03 -0.26l-0.76 -0.66l-0.32 0.07l-0.34 0.33l-0.23 -0.14l-0.19 -0.69l-0.34 -0.14l-0.40 -0.44l-0.42 0.05l-0.21 -0.95l-0.23 -0.29l-1.32 -0.84l-0.60 -0.98l-0.79 -0.69l-1.68 -0.30l-0.41 -1.01l0.03 -1.19l-0.28 -1.90l-0.50 -0.43l-0.39 -1.03l-0.72 -0.74l-0.23 -0.06l0.21 -1.09l-0.37 -0.10l-0.19 -1.46l0.42 -0.08l0.04 -0.48l-0.29 -0.45l0.55 -0.95l0.00 -0.67l0.44 -0.26l0.42 -0.58l-0.36 -1.12l-2.42 1.17l-0.29 0.66l-0.47 0.01l-0.47 0.23l-0.76 0.66l-0.90 -0.24l-1.02 0.19l0.00 -0.53l-0.21 -0.47l0.08 -0.64l-0.45 -0.85l-0.10 -1.44l-0.24 -0.31l-0.37 0.02l-0.32 -0.35l-0.59 0.11l-0.29 -0.50l0.37 -0.88l-0.08 -0.42l0.43 -0.48l0.02 -0.35l0.39 -0.07l0.19 -0.20l0.53 -1.13l0.67 -0.43l0.27 0.06l0.11 0.21l0.31 -0.16l0.73 -0.05l0.17 0.02l0.34 0.48l0.15 -0.32l1.19 -0.83l0.20 -0.39l0.05 -0.71l-0.65 -0.57l-0.32 -0.65l-0.73 -0.86l-0.56 -1.16l-0.29 -1.61l-0.39 -0.70l-0.45 -0.37l-0.51 -0.14l-0.80 0.75l-0.04 0.23l0.30 0.48l-0.47 -0.12l-0.20 -0.42l-0.53 -0.33l-0.39 0.24l-0.50 -0.07l-0.82 0.60l-0.32 -0.14l-0.55 0.10l-0.49 0.65l-0.89 0.64l-0.79 0.03l0.00 0.63l-0.21 0.39l-1.00 0.03l-0.67 0.45l0.06 0.67l-0.21 0.06l-0.70 -0.12l-0.51 -0.43l-0.73 -0.18l-1.55 0.18l-0.42 -0.18l-0.10 -0.42l-0.63 -0.33l0.00 -0.21l0.33 -0.33l-0.33 -0.97l-0.73 -0.45l-0.30 0.12l-0.36 -0.09l-1.28 0.66l-0.54 -0.09l-0.70 0.24l-0.24 -0.06l-0.25 0.18l-0.42 -0.33l-0.49 0.00l0.00 0.00l-0.12 -0.24l0.18 -0.54l0.67 -0.27l0.18 -0.36l-0.06 -0.82l0.52 -0.63l0.00 -0.30l-0.58 -0.48l-0.27 -0.70l0.09 -0.27l0.52 -0.51l0.18 -0.51l-0.12 -0.43l-0.34 -0.30l0.09 -0.36l0.67 -0.15l0.30 -0.24l0.10 -0.66l0.51 -0.43l0.70 -0.06l0.30 0.15l0.55 -0.36l0.51 0.09l0.31 -0.30l0.21 -0.69l0.00 -0.69l0.33 -0.43l-0.21 -0.18l0.12 -1.72l0.82 -0.42l0.00 0.00l0.37 -0.15l0.00 0.00l0.24 -0.45l0.70 -0.09l1.58 -0.67l0.57 -0.54l2.58 1.51l0.40 -0.12l0.21 -0.43l0.00 0.00l0.79 0.42l0.25 0.46l0.62 0.51l1.59 0.46l0.78 0.87l0.20 1.02l0.21 0.26l0.82 -0.46l0.72 0.10l0.52 0.21l0.31 0.40l0.15 0.62l0.41 0.46l0.46 0.20l0.67 0.05l0.88 -0.97l1.34 0.00l0.56 0.26l0.77 0.10l0.83 -0.92l1.03 0.20l0.77 -0.92l0.51 -0.25l0.26 -1.59l0.41 -0.41l1.96 0.06l2.31 -0.87l2.32 -0.05l1.03 -0.87l0.56 -1.18l0.88 -0.77l1.59 -2.14l1.29 -2.46l-0.31 -1.17l0.10 -0.67l0.47 -0.56l1.08 -0.56l0.25 -0.67l0.67 -0.41l0.16 -0.82l0.05 -2.20l0.20 -0.71l0.83 -1.38l0.36 -0.26l0.31 -1.33l0.25 -0.31l0.52 -0.05l0.56 0.57l0.78 0.30l0.30 0.31l0.00 0.41l0.62 0.31l0.72 -0.06l1.03 -0.30l1.75 -1.13l2.26 -0.77l2.01 -1.17l1.29 -0.05l1.44 0.30l1.59 -0.41l0.88 0.00l0.51 1.13l0.62 0.46l1.29 0.61l0.51 0.11l1.08 -0.26l0.46 0.31l1.14 1.38l1.38 0.51l0.37 0.05l1.28 -0.77l1.29 -0.15"},ID_kr:{name:"Kepulauan Riau",path:"m160.45 132.94l0.12 0.27l0.76 0.22l0.12 0.44l0.59 0.93l0.42 0.32l-0.07 0.24l-1.03 0.83l-0.39 0.81l-0.15 1.08l-0.12 0.10l-0.42 -0.10l-0.66 -0.88l-0.20 0.00l-0.49 0.20l-0.15 1.27l-0.49 0.20l-0.22 -0.29l-0.12 -1.00l-0.37 -1.22l-0.64 -0.29l-0.54 -0.61l0.22 -0.86l0.25 -0.32l-0.02 -0.34l0.62 -0.07l0.12 -0.15l0.07 -0.78l0.22 0.76l-0.44 0.42l0.42 0.64l0.17 -0.15l-0.02 -0.71l0.12 -0.05l0.25 0.27l0.62 0.05l0.49 -0.32l0.00 -0.59l0.17 -0.20l0.62 -0.20l0.17 0.08zm5.26 -2.37l0.15 0.10l0.37 -0.10l-0.02 -0.90l0.25 -0.20l1.18 1.59l0.94 0.76l0.76 0.07l0.07 0.44l-0.30 0.05l-1.16 -0.49l-0.29 0.27l0.44 0.51l-0.12 0.24l-0.91 -0.46l-0.39 0.12l-0.91 -0.66l0.05 -0.22l-0.15 -0.12l-0.37 0.05l-0.30 -0.54l-0.81 -0.44l-0.89 0.15l-0.89 0.61l-0.54 -0.10l-0.66 0.51l-0.37 -0.15l-0.15 -0.44l-0.71 0.15l-0.49 -0.24l-0.05 -0.22l0.02 -0.64l0.69 -0.51l0.10 -0.22l0.59 -0.22l-0.17 -2.27l0.81 -0.37l1.03 0.51l0.64 0.56l0.54 0.81l0.25 0.02l0.25 0.49l0.62 0.49l0.02 0.42l0.20 0.29l0.68 0.30zm-6.92 -6.01l0.17 0.22l0.07 -0.44l0.25 0.12l0.27 -0.07l1.92 2.05l-0.44 0.15l-0.15 -0.10l-0.39 0.37l-0.49 -0.29l-1.28 -1.42l-0.91 -1.56l0.22 0.05l0.76 0.92zm2.41 -1.54l1.75 2.15l0.76 0.78l0.57 0.32l0.10 0.27l-0.17 0.29l-0.66 -0.32l-0.62 -0.61l-0.94 -0.61l-0.89 -1.22l-0.74 -0.61l-0.02 -0.51l0.62 0.15l0.05 -0.20l0.19 0.12zm-2.01 -1.59l0.57 0.39l-0.05 0.10l-0.44 -0.07l-0.07 0.15l0.25 0.07l0.10 0.27l-0.25 0.07l-0.62 -0.42l0.07 0.27l-0.20 0.07l-0.25 0.39l-0.30 -0.07l-0.47 -0.83l-0.22 0.07l-0.07 -0.64l0.07 -0.17l0.47 0.42l0.17 -0.05l0.07 -0.44l-0.44 -0.22l-0.22 -0.32l0.32 0.05l1.51 0.91zm-2.39 -7.91l-0.20 0.39l0.02 0.44l0.70 0.53l-0.33 0.06l-0.47 0.28l0.93 0.18l0.07 -0.32l0.39 0.29l-0.20 0.29l-0.64 -0.15l0.00 0.93l-0.12 0.10l-0.57 -0.46l-1.30 -2.20l0.02 -0.17l0.49 -0.12l0.29 -0.03l0.64 -0.20l0.28 0.16zm-6.01 0.42l-0.10 0.17l-0.47 -0.64l-1.06 -0.90l-0.22 -0.37l-0.07 -0.56l0.98 0.39l0.66 0.61l0.12 0.42l0.42 0.51l-0.10 0.29l-0.16 0.08zm-1.50 -0.25l-0.22 0.49l-0.17 -0.42l-0.37 -0.05l-0.84 -0.56l-0.47 -0.78l0.00 -0.42l0.27 -0.02l0.32 -0.42l1.13 1.27l0.35 0.91zm-6.18 -1.89l0.11 0.64l1.14 1.32l-0.20 0.35l-0.98 -0.75l0.41 0.72l-0.17 0.79l0.31 0.37l-0.39 0.97l-0.17 0.17l-0.35 0.04l-0.24 -0.37l-0.15 0.13l-0.57 -0.18l-0.31 -0.64l-0.61 -0.70l-0.18 -1.80l0.33 -0.48l0.04 -0.73l0.54 0.13l0.22 0.31l-0.11 -0.55l0.13 -0.44l-0.11 -0.13l0.55 -0.42l0.50 0.07l0.17 0.27l0.09 0.91zm11.06 -1.01l0.32 0.10l0.15 -0.44l0.42 -0.05l0.32 0.39l-0.15 0.51l-0.30 0.07l0.10 0.51l0.42 0.15l0.37 -0.07l0.79 0.34l0.00 0.20l-0.32 0.37l-0.96 0.65l-0.35 0.03l-0.37 -1.20l-0.66 -0.32l-0.25 0.10l-0.02 -0.95l-0.20 -0.17l-0.34 0.32l-0.27 -0.24l0.17 -0.66l0.49 -0.10l0.59 0.27l0.05 0.19zm-5.47 -0.30l-0.20 0.00l-0.71 -0.78l0.00 -0.32l0.42 -0.34l0.49 0.49l0.00 0.95zm1.18 -1.93l-0.05 0.27l0.32 0.37l0.25 0.22l0.27 0.27l1.23 0.66l0.05 0.49l-0.30 -0.07l-0.12 0.17l-0.12 0.20l0.10 0.39l-0.15 0.15l-0.22 0.00l-0.49 -0.61l-0.74 -0.24l-0.66 -0.51l0.00 -0.56l0.20 -0.22l-0.64 -0.61l0.12 -0.29l0.34 0.17l0.37 -0.24l0.00 -0.49l0.17 0.10l0.07 0.38zm-8.03 -1.12l0.06 0.17l-0.13 0.07l-0.35 -0.11l-0.06 0.75l0.26 0.60l0.35 0.06l0.50 1.12l-0.87 -0.04l-0.09 -0.22l-0.59 -0.07l-0.72 -0.53l-0.02 -0.77l0.18 -0.13l0.13 -0.48l0.70 -0.20l0.33 -0.57l0.32 0.35zm12.78 -0.03l0.05 0.49l-0.22 0.22l0.00 1.20l-0.74 0.05l-0.17 0.44l0.20 0.44l-0.84 -0.22l-0.25 0.22l-0.49 -0.15l-0.15 -0.24l-0.76 -0.08l-0.71 -0.46l-0.32 -1.03l0.05 -0.27l0.40 -0.06l-0.08 0.55l0.37 -0.02l-0.07 -0.71l-0.17 -0.07l-0.02 -0.27l1.21 0.12l0.17 -0.81l0.37 -0.07l0.57 0.71l0.34 0.10l0.17 -0.24l-0.25 -0.17l0.00 -0.34l0.57 -0.24l0.44 0.37l0.33 0.54zm7.46 -0.54l0.15 0.66l0.74 0.44l0.47 1.20l-0.25 1.22l0.07 0.39l0.20 0.20l0.00 0.42l-0.27 0.07l0.00 0.24l0.25 0.12l0.62 -0.07l-0.12 0.51l-0.76 1.03l-0.57 -0.24l-0.96 0.02l-0.57 -0.20l-0.76 -0.66l-0.25 0.10l-0.69 -0.17l0.02 -0.17l0.69 -0.17l-0.47 -0.42l0.10 -0.27l-0.12 -0.17l-0.44 -0.37l0.22 -0.34l0.57 0.05l-0.20 -0.44l0.42 -0.51l-0.44 -0.42l-0.79 0.42l0.02 0.56l-0.17 0.15l-0.30 0.00l0.05 -0.37l-0.47 -0.17l-0.17 0.37l-0.22 0.12l-1.18 -0.07l-0.37 -0.32l-0.27 -0.61l-0.12 -0.44l0.52 -0.76l1.50 -0.24l-0.27 -0.76l0.39 -0.17l0.71 0.15l0.10 -0.20l0.39 -0.15l1.13 0.46l0.62 0.02l0.59 -0.37l0.20 -0.51l0.42 -0.12l0.15 0.10l-0.11 0.86z"},ID_ks:{name:"Kalimantan Selatan",path:"m366.42 189.54l-0.17 0.20l-1.10 -1.78l0.65 -1.65l0.86 -1.09l0.23 -0.06l0.20 0.45l0.00 0.59l-0.67 3.34zm-4.71 6.95l-0.56 0.16l-0.53 -0.05l-0.07 -0.21l0.06 -0.77l0.39 -1.28l-0.06 -1.79l-0.90 -1.25l-0.25 -0.81l0.02 -0.66l1.90 -5.56l2.45 -1.75l0.23 0.06l0.06 0.35l-0.36 2.29l0.27 2.65l0.82 3.98l-0.24 2.43l-2.51 1.88l-0.72 0.33zm-6.34 -46.88l-0.25 0.99l-1.06 1.27l-0.25 -0.07l0.14 -0.78l-0.32 -0.07l-0.82 0.71l-0.43 0.67l-0.64 0.56l-0.07 0.35l0.18 0.35l0.60 -0.25l0.60 0.11l0.28 0.39l-0.14 0.71l0.14 0.32l0.71 0.56l-0.14 0.32l0.11 0.49l0.50 0.56l0.35 0.74l0.14 1.87l-0.07 0.71l-0.32 0.71l0.00 0.42l0.28 0.32l-0.21 0.60l0.18 -0.04l0.35 0.28l0.50 -0.14l0.60 0.25l0.14 0.25l-0.35 0.56l-0.18 1.52l0.71 1.73l-0.04 1.02l0.28 0.53l0.53 -0.18l0.39 -0.35l0.11 -0.32l0.78 -0.28l0.53 -0.49l0.53 0.49l0.39 0.07l2.73 0.14l1.28 0.42l2.70 0.04l1.10 0.28l1.33 0.62l0.00 0.00l-0.39 1.87l-0.52 0.66l-0.40 0.02l-0.16 -0.16l-0.12 -0.61l-0.76 -0.40l-1.98 0.40l-0.05 1.62l1.01 0.91l0.20 3.11l-0.33 0.85l-1.39 1.80l-0.51 0.26l-0.23 -0.05l-0.24 -0.35l-0.21 -1.20l-0.95 -1.65l-0.20 -0.19l-0.13 0.14l-0.38 1.72l0.19 0.89l0.98 1.40l0.57 0.50l0.10 0.98l-0.77 0.39l-1.25 1.71l-1.52 2.87l-0.38 2.45l-0.24 0.47l-0.38 0.22l-1.98 0.29l-1.15 1.10l-0.65 0.42l-3.24 1.38l-4.53 1.63l-6.20 2.59l-3.79 2.28l-1.24 0.16l-0.36 -0.39l-0.13 -0.57l-0.01 -7.32l-0.11 -0.84l-0.35 -0.70l-1.02 -1.34l-0.71 -0.66l-0.73 0.08l-1.54 -0.88l0.00 0.00l0.00 -0.91l0.78 -2.37l1.46 -2.29l0.39 -2.26l1.53 -3.00l0.99 -0.28l0.35 -0.28l0.18 -0.21l-0.14 -0.25l0.21 -0.39l0.36 0.11l0.85 -0.32l0.46 -0.60l0.32 -1.80l0.70 -0.55l0.50 -0.78l-0.04 -0.64l0.21 -0.32l0.57 0.04l5.90 -4.27l0.39 0.28l0.32 -0.04l0.21 -1.31l0.39 -0.81l-0.71 -1.55l0.00 -0.39l0.96 -0.74l0.25 -0.81l-0.67 -0.92l-0.11 -0.78l0.71 -2.22l0.89 -3.88l0.14 -0.18l1.85 -0.14l1.81 -0.67l0.39 -0.32l0.50 0.11l0.99 -0.78l0.00 0.00l0.39 -0.30z"},ID_kt:{name:"Kalimantan Tengah",path:"m268.62 178.55l0.35 -0.93l0.38 -0.29l1.20 -0.41l0.78 -0.47l1.18 -0.21l0.62 -0.52l0.15 -0.57l1.45 -0.37l0.91 -0.45l0.52 -0.91l-0.16 -0.45l-0.34 0.02l-0.45 -0.28l0.33 -0.81l-0.53 -2.07l-0.09 -1.30l-0.52 -1.83l-0.68 -1.13l0.61 -0.72l-0.02 -0.29l0.19 -0.23l0.04 -0.23l-0.69 -1.29l0.70 -0.59l-0.07 -0.42l0.16 -0.39l-0.05 -0.15l-0.89 -0.13l-0.52 0.14l-0.34 -0.23l-0.15 -0.42l0.34 -0.43l0.04 -0.36l-0.32 -0.41l0.02 -0.64l0.11 -0.44l0.37 -0.34l0.15 -0.38l-0.12 -1.20l-0.22 -0.52l-0.29 -0.16l-0.42 0.18l-0.11 0.45l-0.18 0.13l-0.42 0.10l-0.26 -0.19l-0.18 -0.44l-0.44 -0.11l-0.04 -0.77l0.55 -0.38l0.28 -0.43l0.88 -0.21l0.44 -0.55l0.49 0.40l0.30 -0.30l0.48 -0.15l0.37 0.42l0.81 -0.22l-0.07 -0.45l-0.26 -0.39l0.82 -0.49l0.28 0.16l0.04 0.49l0.31 0.14l0.09 -0.66l-0.14 -0.79l0.38 0.14l0.13 -0.53l1.11 0.22l-0.05 -0.29l0.21 -0.04l0.42 -0.48l0.17 -0.59l0.63 -0.33l0.36 -0.75l0.30 0.00l0.12 -0.54l0.22 -0.18l1.11 -0.01l0.31 -0.26l1.20 -0.21l0.12 -0.30l-0.33 -0.28l0.26 -0.48l-0.32 -0.64l0.28 -0.54l0.48 -0.15l0.46 -0.48l-0.17 -0.69l0.30 -0.37l0.59 -0.04l0.93 -0.56l0.22 -0.29l0.76 -0.28l1.02 0.07l0.46 -0.26l0.16 -0.57l0.15 -0.07l0.68 0.15l-0.29 -0.76l0.14 -0.86l0.49 0.53l0.37 0.15l1.20 -0.34l0.07 -0.31l-0.31 -1.11l0.19 -0.18l1.08 0.11l0.77 0.31l0.38 0.00l0.10 -0.07l-0.24 -0.72l0.83 -1.14l0.54 0.03l0.35 0.28l0.64 1.21l0.41 0.48l0.36 -0.44l0.41 0.18l0.85 -0.31l0.49 -0.44l0.37 0.14l0.01 0.61l0.37 0.26l0.24 -0.23l0.08 -0.47l0.85 0.17l0.09 -0.19l0.92 -0.08l0.00 -0.21l0.60 -0.35l0.89 -0.03l0.25 -0.42l0.74 -0.03l0.08 -0.85l0.58 -0.15l0.57 0.17l0.70 -0.12l0.67 -0.63l1.44 -0.42l0.33 -0.31l1.33 0.14l0.33 -0.24l0.37 0.00l0.27 -0.51l0.39 -0.12l0.13 0.35l0.50 0.01l0.28 0.51l0.15 0.13l0.13 -0.08l0.16 -0.49l0.66 -0.80l-0.19 -0.78l-0.78 -0.71l0.28 -0.21l0.20 -0.60l0.53 -0.37l0.42 -0.60l0.86 -0.18l0.56 -0.51l0.27 -0.57l0.36 -0.07l0.08 -0.33l-0.34 -0.20l0.44 -0.26l0.35 -0.79l-0.07 -0.22l-0.37 -0.05l0.18 -0.77l0.26 -0.38l-0.35 -0.24l-0.20 -0.35l0.16 -1.35l-1.55 -0.81l-1.03 -1.01l0.03 -0.19l0.63 -0.38l0.74 -0.20l1.38 0.25l0.92 -0.55l0.53 -0.41l0.06 -0.23l0.96 -0.82l0.16 -0.31l1.32 -0.76l0.27 -1.09l0.68 -0.42l0.40 0.00l0.19 -0.42l0.37 -0.17l0.19 -0.43l0.36 -0.25l0.23 -0.71l0.51 -0.29l0.00 0.00l0.49 0.00l0.42 0.33l0.25 -0.18l0.24 0.06l0.70 -0.24l0.54 0.09l1.28 -0.66l0.36 0.09l0.30 -0.12l0.73 0.45l0.33 0.97l-0.33 0.33l0.00 0.21l0.63 0.33l0.10 0.42l0.42 0.18l1.55 -0.18l0.73 0.18l0.51 0.43l0.70 0.12l0.21 -0.06l-0.06 -0.67l0.67 -0.45l1.00 -0.03l0.21 -0.39l0.00 -0.63l0.79 -0.03l0.89 -0.64l0.49 -0.65l0.55 -0.10l0.32 0.14l0.82 -0.60l0.50 0.07l0.39 -0.24l0.53 0.33l0.20 0.42l0.47 0.12l-0.30 -0.48l0.04 -0.23l0.80 -0.75l0.51 0.14l0.45 0.37l0.39 0.70l0.29 1.61l0.56 1.16l0.73 0.86l0.32 0.65l0.65 0.57l-0.05 0.71l-0.20 0.39l-1.19 0.83l-0.15 0.32l-0.34 -0.48l-0.17 -0.02l-0.73 0.05l-0.31 0.16l-0.11 -0.21l-0.27 -0.06l-0.67 0.43l-0.53 1.13l-0.19 0.20l-0.39 0.07l-0.02 0.35l-0.43 0.48l0.08 0.42l-0.37 0.88l0.29 0.50l0.59 -0.11l0.32 0.35l0.37 -0.02l0.24 0.31l0.10 1.44l0.45 0.85l-0.08 0.64l0.21 0.47l0.00 0.53l1.02 -0.19l0.90 0.24l0.76 -0.66l0.47 -0.23l0.47 -0.01l0.29 -0.66l2.42 -1.17l0.36 1.12l-0.42 0.58l-0.44 0.26l0.00 0.67l-0.55 0.95l0.29 0.45l-0.04 0.48l-0.42 0.08l0.19 1.46l0.37 0.10l-0.21 1.09l0.23 0.06l0.72 0.74l0.39 1.03l0.50 0.43l0.28 1.90l-0.03 1.19l0.41 1.01l1.68 0.30l0.79 0.69l0.60 0.98l1.32 0.84l0.23 0.29l0.21 0.95l0.42 -0.05l0.40 0.44l0.34 0.14l0.19 0.69l0.23 0.14l0.34 -0.33l0.32 -0.07l0.76 0.66l-0.03 0.26l-0.91 0.66l-0.45 0.53l-0.23 1.30l0.00 0.00l-0.35 0.31l0.00 0.00l-0.99 0.78l-0.50 -0.11l-0.39 0.32l-1.81 0.67l-1.85 0.14l-0.14 0.18l-0.89 3.88l-0.71 2.22l0.11 0.78l0.67 0.92l-0.25 0.81l-0.96 0.74l0.00 0.39l0.71 1.55l-0.39 0.81l-0.21 1.31l-0.32 0.03l-0.39 -0.28l-5.89 4.27l-0.57 -0.03l-0.22 0.32l0.04 0.63l-0.50 0.78l-0.70 0.55l-0.32 1.80l-0.46 0.60l-0.85 0.31l-0.36 -0.10l-0.21 0.39l0.14 0.24l-0.18 0.22l-0.35 0.28l-1.00 0.28l-1.52 3.00l-0.39 2.26l-1.46 2.30l-0.78 2.36l0.00 0.91l0.00 0.00l-2.42 -1.15l-1.86 -0.50l-1.22 0.09l-3.59 1.72l-1.85 0.28l-0.80 -0.03l-1.07 -0.65l0.49 -1.56l0.07 -1.58l-0.26 -0.91l-0.36 -0.53l-2.26 0.14l-0.45 0.49l-0.17 0.60l-1.27 0.29l-2.09 -1.33l-3.12 -3.26l-0.52 -0.07l-1.47 1.60l-0.11 0.57l0.44 0.57l-0.30 1.00l-3.31 2.03l-1.18 0.83l-0.70 0.72l-1.75 0.54l-0.32 -0.03l-1.98 -1.57l-1.93 -0.67l-1.04 -0.02l-1.45 0.56l-3.69 3.52l-0.61 0.34l-0.41 0.06l-1.45 -0.60l0.65 -2.28l-0.47 -3.66l0.00 -0.82l0.28 -1.08l-0.03 -0.72l-1.36 -2.43l-0.40 -1.60l-0.48 -0.07l0.07 0.80l-0.57 0.84l0.43 0.35l-0.10 0.45l-0.94 0.17l-0.30 0.33l-1.24 0.77l-0.17 -0.47l-0.91 -0.80l-0.74 -0.57l-0.43 -0.07l-1.48 0.00l-3.05 1.75l-1.22 0.53l-0.97 0.30l-1.48 0.20l-2.18 -1.54l-1.40 0.24z"},ID_ku:{name:"Kalimantan Utara",path:"m388.45 70.62l-0.56 0.43l-1.29 -1.02l-0.47 -1.24l0.03 -0.41l0.16 -0.22l1.46 -0.12l0.82 0.25l0.15 0.32l-0.30 2.01zm-4.73 -4.79l2.20 1.30l-0.01 0.20l-0.54 0.47l-1.69 -0.74l-1.93 -0.10l-0.64 -0.31l-0.40 -0.54l0.08 -0.43l0.91 -0.38l2.02 0.53zm5.69 -7.40l-0.78 0.29l-1.19 -0.87l-0.18 -0.89l0.07 -0.22l0.78 -0.85l0.49 0.05l1.25 1.01l0.10 0.47l-0.54 1.01zm2.78 -3.31l0.43 0.19l0.42 2.01l-0.56 0.44l-0.51 0.08l-0.61 -0.31l-3.52 -2.82l0.06 -0.26l0.90 -0.74l0.51 -0.03l1.00 0.35l0.19 0.38l0.58 0.42l1.11 0.29zm-37.96 1.44l0.04 -0.93l0.33 -0.67l0.37 0.03l0.79 -0.91l0.40 0.06l0.14 0.33l0.41 -0.11l0.13 -0.57l0.72 -0.60l-0.14 -0.42l0.12 -1.04l0.53 -0.19l0.33 0.57l1.51 0.30l0.27 0.20l0.11 0.49l0.65 0.50l0.20 -0.13l0.39 -0.76l0.85 -0.33l0.13 -0.64l0.15 -0.11l1.41 0.21l0.30 0.18l1.52 -0.35l1.17 0.97l0.20 0.64l0.59 -0.14l0.23 -0.54l0.37 0.16l0.47 -0.08l-0.05 -0.62l0.54 -0.67l0.41 0.45l0.38 0.12l0.25 0.61l0.77 -0.24l0.53 0.16l0.31 -0.10l0.28 -0.16l0.26 -0.50l0.41 0.25l0.38 0.48l0.26 -0.11l0.49 0.28l0.69 -0.20l0.53 -0.41l0.73 0.18l0.29 0.23l0.65 0.06l0.28 0.30l0.34 -0.39l1.11 0.15l0.65 -0.17l0.59 0.11l0.64 -0.16l0.09 -0.19l0.53 -0.21l3.02 2.15l0.40 0.86l0.24 0.15l1.21 0.34l0.89 -0.26l0.24 0.17l0.00 0.00l-0.81 0.50l-0.91 0.28l-1.56 -0.45l-0.17 0.19l0.00 0.56l0.39 0.32l0.96 0.23l2.64 2.22l-1.75 0.26l1.66 0.95l1.56 0.17l1.27 1.34l0.04 0.26l-0.25 0.64l1.06 0.32l-0.08 0.25l-1.20 1.12l-1.07 0.21l-3.17 0.23l-2.67 -0.38l-1.80 0.30l-0.48 0.29l-0.44 0.65l0.03 0.41l0.56 0.87l1.48 0.93l1.26 -0.15l0.80 0.21l0.02 0.84l-0.28 0.52l1.76 0.92l-0.17 0.28l-1.26 0.17l-0.86 0.34l-0.29 0.46l-0.97 0.17l-0.17 0.34l0.54 0.32l2.01 0.35l2.71 1.18l1.22 2.08l-0.28 1.61l-0.01 1.26l1.02 0.18l0.80 0.49l0.21 0.33l0.14 1.34l0.23 0.72l2.78 2.74l0.00 0.00l-0.69 0.59l-1.29 0.15l-1.29 0.77l-0.36 -0.05l-1.39 -0.51l-1.13 -1.38l-0.46 -0.31l-1.08 0.26l-0.51 -0.10l-1.29 -0.61l-0.62 -0.46l-0.51 -1.13l-0.87 0.00l-1.60 0.41l-1.44 -0.31l-1.29 0.05l-2.01 1.18l-2.26 0.77l-1.75 1.13l-1.03 0.31l-0.72 0.05l-0.62 -0.31l0.00 -0.41l-0.29 -0.31l-0.77 -0.31l-0.57 -0.56l-0.51 0.05l-0.26 0.31l-0.31 1.33l-0.36 0.26l-0.82 1.38l-0.21 0.72l-0.05 2.20l-0.15 0.82l-0.67 0.41l-0.26 0.66l-1.08 0.56l-0.46 0.56l-0.10 0.67l0.31 1.18l-1.29 2.45l-1.60 2.15l-0.87 0.77l-0.57 1.18l-1.03 0.87l-2.32 0.05l-2.31 0.87l-1.96 -0.05l-0.41 0.41l-0.26 1.58l-0.51 0.26l-0.77 0.92l-1.03 -0.20l-0.82 0.92l-0.77 -0.10l-0.57 -0.26l-1.34 0.00l-0.87 0.97l-0.67 -0.05l-0.46 -0.20l-0.41 -0.46l-0.15 -0.61l-0.31 -0.41l-0.51 -0.20l-0.72 -0.10l-0.82 0.46l-0.21 -0.26l-0.21 -1.02l-0.77 -0.87l-1.59 -0.46l-0.62 -0.51l-0.26 -0.46l-0.79 -0.42l0.00 0.00l0.49 -0.81l-0.18 -0.30l0.12 -0.75l0.80 -0.47l0.52 -0.92l0.38 -0.31l0.13 -0.99l-0.11 -1.19l-0.13 -0.13l0.49 -0.66l-0.07 -0.27l0.56 -0.16l0.54 0.25l0.45 -0.64l0.67 -0.11l0.36 -0.34l-0.40 -0.81l0.05 -0.23l0.69 -0.52l-0.02 -0.22l-0.51 -0.25l-0.76 0.34l-0.20 -0.45l0.16 -0.96l-0.35 -0.19l-0.16 -0.29l-0.02 -0.82l0.34 -1.31l1.84 -0.20l0.78 -0.49l0.04 -0.23l-0.33 -0.43l0.31 -0.63l0.67 0.11l0.43 -0.23l0.51 -0.59l0.67 0.00l0.20 -0.59l0.45 -0.41l0.58 -0.18l0.78 0.02l0.60 -0.50l0.07 -0.31l-0.47 -0.34l-0.11 -0.34l-0.67 -0.79l-0.99 0.31l-0.31 -0.47l0.31 -0.38l0.09 -0.41l0.00 -0.49l-0.23 -0.14l0.00 -0.38l0.60 -0.52l0.00 -0.43l0.18 -0.34l-0.18 -0.27l-0.51 -0.13l-0.04 -0.18l0.96 -0.77l0.25 -1.06l1.59 -1.06l0.34 -0.83l0.61 0.65l0.04 0.41l1.23 -0.09l0.81 -0.77l1.03 -0.14l0.18 -0.34l0.00 -0.84l0.13 -0.25l0.81 -0.67l0.00 -0.20l-0.71 -0.52l-0.05 -0.18l0.42 -2.81l0.63 -1.26l0.34 0.02l0.40 0.63l0.40 -0.58l-0.58 -1.01l-0.13 -1.10l-0.38 -0.47l-0.16 -0.86l0.05 -1.55l0.14 -0.71l0.52 -1.04l0.04 -0.56l-0.05 -0.18l-0.78 -0.56l-0.13 -0.31l0.85 -0.23l0.45 -0.41l0.67 -2.08l0.00 0.00l0.01 -0.19l0.00 -0.00z"},ID_la:{name:"Lampung",path:"m148.28 209.53l0.65 -0.05l0.05 0.51l0.43 0.03l0.38 0.48l0.00 0.54l-0.43 0.40l0.00 0.21l0.35 0.03l0.75 0.70l0.30 -0.35l0.16 -0.89l0.51 0.38l1.40 -0.16l0.24 -0.21l0.19 0.05l0.08 0.24l0.91 0.27l1.00 -0.54l0.13 -0.38l0.38 -0.08l0.46 0.27l0.40 0.00l0.30 -0.19l0.40 0.38l0.35 -0.11l0.73 -0.94l0.03 -0.35l-0.11 -0.35l-0.67 -0.62l-0.05 -0.83l-0.54 -0.32l0.27 -0.78l0.65 -0.64l-0.30 -2.71l0.27 -0.83l0.27 -0.08l0.08 -0.38l0.80 -0.56l0.51 -0.59l0.62 0.05l0.62 -0.51l1.21 -0.48l0.67 -0.56l0.40 0.51l0.22 0.05l2.21 0.11l1.48 -0.24l0.08 -0.35l1.13 -0.56l0.62 -0.24l0.62 0.03l0.38 -0.51l0.62 -0.43l0.32 -0.96l0.30 -0.32l0.38 -0.05l-0.30 -0.35l0.43 -0.43l0.27 -1.07l0.22 0.13l0.16 -0.08l0.11 -0.51l0.54 -0.27l0.67 0.24l0.70 -0.64l0.22 -0.48l-0.27 -0.62l0.40 -0.32l0.11 -0.56l0.35 -0.46l0.22 0.13l0.30 1.07l0.32 -0.24l0.54 -0.11l0.32 0.08l0.11 0.72l0.78 -0.05l0.19 0.27l0.59 0.00l-0.13 0.80l0.13 0.16l0.40 -0.16l0.35 0.27l-0.05 0.46l0.24 0.19l0.32 -0.19l0.11 0.08l0.11 0.32l-0.38 0.00l0.46 0.38l0.00 0.24l0.30 0.32l-0.40 0.54l-0.05 0.29l0.24 0.05l0.00 -0.27l0.24 0.13l0.46 -0.05l0.08 0.05l-0.30 0.29l0.00 0.24l0.65 0.00l0.03 0.24l0.27 0.11l-0.11 0.46l0.19 0.13l0.75 0.08l0.30 -0.13l0.05 -0.27l0.22 -0.05l0.51 0.27l0.29 0.55l0.00 0.00l-0.19 2.70l1.46 2.41l0.05 0.33l0.00 1.25l-0.34 0.83l0.02 0.35l0.49 0.48l-0.60 1.22l-0.36 1.87l0.18 0.86l0.49 0.62l0.11 0.38l-0.04 0.22l-0.49 0.26l-0.27 1.24l0.15 3.61l-0.15 0.53l-0.49 0.33l-0.13 0.53l0.09 2.17l-0.17 1.61l0.21 0.73l-0.58 2.13l0.07 1.18l-0.36 1.05l-0.79 1.12l-0.27 0.11l-0.16 -0.97l-1.66 -0.22l-0.35 -0.27l-0.20 -0.51l0.02 -0.51l0.18 -0.34l-0.09 -0.23l-0.58 -0.55l-0.53 0.00l-0.20 -0.24l-1.38 -0.77l-0.83 -0.78l-0.27 -0.71l-1.16 -1.73l-0.33 -0.07l-0.35 0.15l-0.16 0.31l0.00 1.77l-0.13 0.27l-0.73 -0.25l-0.60 0.41l0.39 0.49l0.01 0.32l0.32 -0.01l-0.48 0.34l0.20 0.22l0.01 0.35l0.43 0.31l-0.09 0.12l-0.63 0.01l-0.37 0.40l0.26 0.46l0.75 -0.08l-0.51 0.53l-0.57 0.10l-1.68 -0.92l-1.68 -0.70l-3.02 -1.91l-0.74 -0.58l-0.79 -0.96l-0.56 0.02l-1.04 -0.31l-0.86 0.40l-0.46 0.40l0.41 0.26l0.13 0.58l1.01 1.21l0.37 0.25l0.29 0.53l-0.02 0.35l-0.16 0.11l1.18 1.77l-0.11 0.29l0.44 1.17l-0.09 0.20l-2.48 0.13l-0.37 -0.21l-0.08 -0.23l0.31 -0.16l-0.18 -0.73l-2.12 -1.93l-0.41 -0.72l-0.84 -0.62l-1.18 -0.55l0.33 -0.46l-0.94 -1.15l-2.96 -2.09l-1.48 -1.71l-0.12 -1.03l-0.32 -0.30l-1.31 -0.29l-0.04 -0.42l0.53 -0.55l-0.16 -0.49l-0.40 -0.47l-0.24 -0.23l-0.36 0.02l-0.47 -0.62l-1.00 -0.75l-0.31 0.00l-0.02 0.20l-0.18 0.04l-0.18 -0.11l0.07 -0.71l-0.78 -0.66l-0.71 0.04l-0.64 -0.55l-0.53 -0.13l0.00 0.00l0.18 -0.53l0.32 -0.05l0.57 -0.54l0.43 -0.08l0.51 -0.40l0.13 -0.51l0.81 0.05l0.11 -0.11l0.00 0.00l0.12 -0.06z"},ID_ma:{name:"Maluku",path:"m584.82 269.63l-1.56 -0.07l-1.47 -0.72l-0.16 -0.33l1.05 -0.38l1.36 0.07l1.03 0.51l0.06 0.52l-0.31 0.40zm-20.27 -2.88l1.84 0.65l1.74 0.15l0.87 -0.15l0.44 0.27l0.03 0.25l-1.58 1.67l-0.19 0.05l-3.38 -1.12l-0.48 -0.30l-0.68 -1.31l1.39 -0.16zm51.21 4.36l-0.67 0.05l-0.01 -0.23l1.59 -1.72l1.23 -0.67l0.59 -0.99l0.90 -0.99l0.33 -0.09l2.52 0.81l-0.63 0.62l-3.16 1.22l-1.08 0.77l-0.15 0.44l-1.15 0.74l-0.31 0.04zm-17.94 -5.06l-1.26 -0.30l-1.91 -2.34l-0.14 -0.39l0.15 -0.73l0.10 -0.38l0.28 -0.31l1.63 -0.22l2.05 0.55l0.39 0.32l0.34 1.44l-1.63 2.36zm-52.72 -6.75l0.81 0.01l0.43 1.34l-1.41 0.06l-1.68 0.51l-0.90 0.64l-0.97 1.19l-1.47 0.78l-2.43 -0.28l-2.73 -0.54l-1.00 0.02l-2.30 0.48l-2.23 1.79l-0.30 0.06l-0.18 -0.25l0.70 -2.67l2.76 -3.36l3.69 1.09l2.65 -0.46l1.24 -1.07l1.29 -0.60l2.30 -0.58l0.21 0.15l0.08 0.67l1.44 1.02zm11.67 -0.35l-0.26 0.13l-0.34 -0.07l-0.24 -0.41l0.37 -2.00l0.36 -0.23l1.69 0.55l0.06 0.26l-0.13 0.70l-1.51 1.07zm63.64 -2.43l-1.34 -0.42l-0.23 -0.53l0.31 -0.48l0.52 -0.19l2.33 -0.24l0.21 0.14l-0.74 0.90l-1.06 0.82zm11.54 -5.24l-0.73 0.31l-0.38 -0.07l-0.61 0.50l0.67 3.27l0.00 0.71l-0.85 2.56l-1.00 1.30l-2.96 2.18l-0.99 1.60l-0.06 1.26l-0.20 0.34l-0.46 0.24l-2.88 -0.28l-0.48 -0.24l-0.42 -2.30l1.82 -3.14l-0.23 -0.51l1.05 -2.85l1.20 -1.00l0.47 -0.18l0.91 -0.86l1.23 -1.49l1.36 -2.40l0.76 -0.41l1.30 -0.14l0.98 0.49l0.50 1.11zm3.24 -1.76l0.90 1.34l0.15 0.64l-0.27 0.52l-0.18 0.05l-0.84 -0.58l-0.41 -0.89l-0.99 -0.18l-1.17 0.26l-0.51 -0.10l-0.14 -0.22l0.10 -0.48l0.29 -0.20l3.07 -0.16zm-56.61 1.75l-0.49 0.17l-1.51 -0.94l-0.23 -0.41l0.06 -0.21l0.32 -0.36l1.22 -0.74l1.39 0.76l0.08 0.20l-0.40 0.99l-0.44 0.54zm108.06 -14.83l-0.30 0.33l-0.63 1.45l-0.10 0.66l-0.63 1.22l-0.26 -0.23l-0.46 0.07l-0.07 0.40l0.17 0.46l0.30 0.17l0.00 0.40l-0.33 0.00l-0.33 0.20l-0.13 0.69l-0.66 1.02l-0.53 0.50l-0.30 0.00l-0.56 -0.43l0.07 -0.46l0.50 -0.46l0.33 -0.79l0.07 -0.83l0.40 -0.59l-0.30 0.03l-0.23 -0.30l-0.33 -0.89l0.10 -0.50l0.66 -0.46l0.73 -0.26l-0.03 -0.73l0.17 -0.23l0.69 -0.33l0.30 -0.53l0.99 -0.79l0.53 0.03l0.30 0.30l-0.13 0.88zm-36.79 -7.18l-0.61 0.25l-0.82 -0.26l-0.44 -0.44l0.05 -1.24l-0.23 -2.15l-0.48 -1.37l0.11 -0.32l1.12 -0.32l1.81 3.45l0.00 1.13l-0.51 1.27zm33.85 -4.39l0.10 1.02l0.40 1.09l-0.63 0.13l0.00 0.30l1.32 0.66l-0.03 0.33l-0.17 0.26l-0.40 0.10l-0.76 -0.33l-0.03 0.50l0.40 0.26l0.07 0.23l-0.07 0.43l-0.26 0.13l-0.36 -0.07l-0.63 -0.50l-0.17 0.13l0.00 0.30l0.93 0.66l0.20 0.36l0.56 0.33l0.36 0.59l-0.36 2.31l-0.30 0.92l-0.66 1.12l-1.26 0.66l-0.50 -0.10l-0.23 0.20l0.36 0.99l0.53 0.33l-0.07 0.50l-1.09 0.99l-0.89 -0.26l-0.33 0.17l-0.23 0.56l0.10 0.33l0.50 -0.17l-0.03 0.50l-0.63 1.02l-0.69 0.46l-1.32 1.52l-0.03 0.66l-0.50 0.63l-2.05 0.89l-0.30 0.33l-0.46 -0.05l-0.36 -0.89l-0.33 -0.30l-0.69 0.00l-0.76 -1.32l0.00 -0.36l0.23 -0.20l0.36 -1.52l0.23 -3.11l0.30 -0.76l-0.03 -0.43l0.30 -0.99l-0.13 -1.75l-0.43 -1.52l0.66 -0.07l-0.43 -1.19l0.23 -0.56l0.00 -0.50l0.43 -0.36l0.17 0.17l0.00 0.33l0.26 0.03l0.50 -0.30l0.50 0.00l0.10 0.66l0.20 0.17l0.33 -0.10l0.46 -0.46l0.53 -1.32l0.00 -0.20l-0.50 -0.30l0.03 -0.30l0.17 -0.30l0.53 -0.40l0.07 -0.33l0.40 -0.33l0.26 -0.63l-0.07 -0.23l-0.30 -0.13l-0.50 0.30l-0.73 -0.59l-0.83 -0.10l-0.50 -0.53l0.07 -0.33l0.63 -0.69l0.99 0.63l0.36 0.03l1.29 -0.99l0.63 -1.65l0.76 -0.50l0.07 -0.63l-0.20 -0.86l0.17 -0.46l0.89 -1.22l0.63 -0.17l0.36 0.20l0.96 1.65l0.50 0.43l0.03 0.33l0.43 0.66l0.03 1.12l0.83 1.06l-0.07 0.50l-0.41 0.19zm-30.73 3.18l-1.83 2.38l-0.17 -0.05l-0.01 -0.31l1.61 -5.00l0.34 -0.60l0.59 -0.56l2.22 -5.58l0.41 -0.17l0.57 0.08l0.33 0.70l-1.35 4.39l-0.53 0.65l-0.85 0.50l-1.17 1.60l-0.28 1.01l0.12 0.96zm-76.67 -38.78l-2.08 0.41l-0.13 -0.13l0.26 -0.58l-0.01 -0.98l0.53 -0.39l1.21 0.12l0.92 0.91l-0.02 0.20l-0.68 0.44zm1.74 -1.65l0.82 0.29l0.36 -0.65l0.26 0.03l0.29 0.78l0.00 1.19l-1.44 0.22l-0.22 -0.09l-1.20 -1.68l-0.03 -0.31l0.22 -0.21l0.26 -0.02l0.68 0.45zm-4.99 1.80l-0.64 1.16l-1.00 0.84l-2.11 0.61l-0.38 -0.04l1.81 -1.71l0.22 -0.45l-0.28 -0.12l-3.66 2.28l-0.75 -0.05l-0.42 -0.53l-0.03 -0.84l0.90 -0.99l1.08 -0.69l2.71 -0.52l0.77 -0.95l0.71 -0.29l0.55 0.13l0.57 0.33l0.15 0.24l-0.20 1.59zm-12.15 -4.48l-1.94 -0.56l-0.69 -0.68l0.75 -0.60l0.78 0.10l0.94 0.88l0.46 0.66l-0.30 0.20zm2.43 -1.91l-1.74 -0.01l-0.60 -0.50l1.21 -1.10l0.83 -0.13l0.58 0.46l-0.04 1.13l-0.24 0.15zm-13.48 -1.88l1.87 1.18l0.21 0.97l-1.03 -0.05l-0.22 0.36l0.20 0.74l0.75 0.68l0.53 -0.20l0.31 -0.33l2.00 0.66l-0.41 4.13l-0.34 0.63l-0.54 0.16l-0.66 -0.18l-0.72 0.18l-1.55 0.64l-2.58 1.38l-3.00 0.93l-3.20 -1.14l-2.18 -1.01l-2.42 -1.63l-3.43 -3.25l-0.47 -1.30l-0.14 -2.87l0.27 -0.56l1.23 -0.84l0.41 0.09l0.43 0.60l0.57 0.47l0.61 0.03l0.55 -0.75l0.68 -0.38l2.29 -0.60l5.55 -0.22l1.55 0.26l2.88 1.22zm48.47 -4.08l3.87 1.54l1.22 0.06l4.28 -0.38l0.66 0.17l3.68 2.61l0.71 1.81l0.00 1.37l0.27 0.91l0.45 0.52l1.21 -0.04l0.83 0.20l0.64 0.64l0.82 2.39l-0.07 0.62l-0.60 0.85l-0.25 2.54l0.15 0.81l-3.70 -1.45l-1.01 -1.06l-2.76 -1.61l-4.57 -1.54l-2.47 -1.26l-0.56 -0.74l-0.03 -0.85l-0.79 -0.63l-0.40 -0.13l-4.09 -0.31l-2.35 -0.33l-0.29 0.32l0.12 0.54l0.73 0.86l0.19 0.56l-0.25 0.57l-0.47 0.12l-3.66 -0.91l-1.05 -0.08l-1.63 -0.62l-0.75 -0.46l-2.88 0.12l-0.32 -0.26l0.16 -0.39l0.69 -0.62l0.04 -0.67l-0.69 -0.49l-0.88 -0.13l-1.92 1.21l-1.47 1.37l-0.25 0.47l-1.02 0.86l-2.00 0.44l-0.47 -0.02l-0.65 -0.27l-0.49 -0.42l-1.76 -2.61l-1.47 -0.99l-0.62 -2.36l-0.69 0.02l-0.78 0.79l-0.62 1.51l-0.33 2.23l-0.46 0.64l-0.43 0.11l-0.93 1.67l-0.33 1.39l-0.16 -0.25l-0.25 -1.04l0.52 -1.15l0.12 -1.25l-0.87 -1.35l-0.45 -1.37l2.21 -1.72l3.26 -3.96l3.97 0.10l2.83 -0.13l4.95 0.18l2.13 -0.48l0.88 -0.71l0.36 0.03l0.32 0.19l0.13 0.35l-0.03 1.35l0.53 0.61l0.55 0.32l1.38 -0.29l2.31 -1.47l0.33 -0.27l0.18 -0.70l0.48 -0.21l2.13 -0.15l1.78 0.54l2.45 1.02l0.45 0.60z"},ID_mu:{name:"Maluku Utara",path:"m533.86 169.62l-0.51 0.08l-0.53 -0.30l-0.47 -0.59l-0.35 -0.72l-0.25 -1.65l-0.89 -1.29l-0.62 -2.48l0.44 -1.09l0.25 -0.40l0.36 -0.23l0.59 0.08l0.79 0.69l0.02 0.43l-0.53 1.47l-0.03 0.61l2.04 4.47l-0.31 0.92zm-10.97 -11.50l3.77 0.32l1.31 -0.17l0.54 -0.32l3.94 -0.12l6.23 0.53l-0.25 0.38l-1.41 0.60l-4.70 0.53l-8.89 0.55l-2.06 -0.97l-0.13 -0.22l-0.01 -0.83l0.63 -0.73l0.59 -0.09l0.18 0.38l0.26 0.16zm-8.31 -1.81l0.97 0.34l1.85 -0.50l2.98 0.71l0.48 0.98l0.03 1.67l-0.38 -0.13l-2.39 -0.08l-1.80 0.27l-0.45 0.23l-0.14 0.58l-0.38 0.12l-2.51 -0.82l-1.18 0.27l-1.64 0.97l-2.04 0.57l-0.87 0.18l-2.05 0.06l-1.33 -2.30l-0.02 -1.07l0.70 -2.15l0.48 -0.55l2.34 -0.46l1.81 -0.01l5.54 1.12zm50.59 -4.71l3.99 2.32l0.53 0.45l0.29 0.51l0.03 0.43l-0.36 0.76l-0.84 0.46l-0.53 0.06l-6.10 -0.48l-1.14 0.66l-1.66 0.25l-1.94 -0.89l-0.65 -0.53l-0.27 -0.44l0.28 -1.04l-0.07 -0.50l0.22 -1.05l0.37 -0.73l0.30 -0.34l0.32 0.25l2.91 -1.80l1.61 0.31l2.71 1.34zm-4.58 -2.91l-2.06 0.19l-0.67 -0.45l0.00 -0.18l0.86 -0.79l0.70 -0.24l1.80 0.72l-0.63 0.75zm-5.13 -7.96l-0.70 0.24l-2.02 -0.46l-0.13 -0.19l0.02 -0.49l0.58 -1.84l0.24 -0.24l0.42 -0.10l0.45 0.10l0.65 1.22l0.49 1.76zm4.38 -8.13l1.94 2.51l-0.31 0.95l-0.70 0.67l-0.38 0.81l0.06 0.48l0.73 1.14l0.54 0.31l0.63 -0.38l1.23 -0.18l1.10 0.49l0.77 1.02l-0.06 0.51l-1.34 1.10l-1.06 0.29l-1.36 -0.58l-1.21 -1.47l-2.12 0.90l-0.44 -0.15l-0.34 -0.60l-0.61 -2.67l-1.72 -1.82l-0.23 -1.01l0.53 -1.97l0.87 -0.22l0.72 0.64l1.19 -0.26l0.88 -0.71l0.69 0.20zm-6.72 3.57l-1.15 -0.07l-0.16 -0.44l-0.02 -3.52l0.65 -0.47l1.60 -0.17l0.40 0.46l0.38 1.67l-0.46 2.00l-1.24 0.54zm11.90 -40.14l0.47 0.17l0.33 -0.09l0.42 0.12l0.96 0.87l0.27 0.50l0.43 3.34l-0.82 2.98l-1.41 2.47l-1.27 1.05l-3.16 2.16l-0.39 0.59l0.05 1.02l0.42 0.71l1.68 1.19l0.69 0.29l0.86 -0.13l1.26 -0.95l0.20 -2.27l0.79 -1.33l1.11 -0.85l0.88 -0.11l0.78 0.14l0.57 -0.29l0.49 -1.03l-0.15 -0.47l-0.33 -0.27l-0.43 -0.05l-0.21 -0.82l1.00 -1.59l3.22 -2.23l1.17 -0.49l1.84 -0.51l1.36 -0.20l1.02 0.03l0.39 0.08l0.26 0.24l-0.47 7.82l-0.58 0.67l-3.78 2.21l-2.54 0.74l-1.49 1.48l-0.01 0.44l0.42 0.85l1.08 0.93l0.87 0.50l4.13 1.49l0.75 -0.03l0.75 0.16l0.32 2.48l-0.17 0.88l0.66 0.48l1.87 0.50l0.78 0.64l0.53 1.02l-0.89 -0.66l-0.67 -0.25l-4.69 -1.10l-1.57 -1.32l-1.61 -0.01l-1.38 0.20l-1.14 -0.30l-0.59 -0.34l-0.34 -0.49l-1.50 -0.26l-2.01 -0.18l-0.63 0.38l-0.26 0.33l-0.47 2.33l0.48 0.38l0.30 2.37l-0.69 1.13l0.04 1.35l2.61 6.84l0.99 1.85l0.76 1.01l1.31 2.23l3.26 3.24l-2.07 -0.11l-0.51 -0.17l-0.38 -0.36l0.13 -0.35l-1.73 -1.32l-1.49 -0.61l-0.54 -0.44l-1.36 -3.00l-1.44 -2.40l-2.42 -1.36l-0.95 -1.46l0.64 -4.83l-0.22 -2.24l-0.55 -2.46l-0.65 -0.36l-0.83 -0.88l-0.76 -2.32l-0.07 -0.95l0.39 -1.96l0.73 -0.76l0.54 -1.08l-0.08 -0.52l-1.85 -0.55l-0.20 -0.30l0.26 -0.98l-0.47 -1.64l-1.40 0.26l-0.13 -0.39l0.11 -2.59l2.16 -3.91l0.13 -1.00l-0.15 -0.38l0.75 -3.76l2.14 -3.19l3.77 -4.02l0.66 -0.56l1.85 -0.01l-0.24 1.12l-1.61 2.44l-0.42 0.50l-0.47 0.15l-0.69 0.55l-0.09 1.56l0.33 0.38l0.00 0.00zm10.85 -4.18l-1.92 0.09l-1.91 0.47l-0.54 -1.42l-0.32 -2.51l0.10 -1.04l1.03 -1.92l0.95 -1.18l1.50 -1.46l2.22 -1.05l0.25 0.05l1.88 2.57l0.15 0.79l-1.28 3.75l-0.89 1.60l-0.98 1.12l-0.24 0.14z"},ID_nb:{name:"Nusa Tenggara Barat",path:"m416.34 271.96l0.12 0.32l0.67 -0.30l-0.04 0.16l0.29 0.34l-0.27 0.41l-0.33 -0.23l-0.14 0.32l-0.19 0.07l-0.15 -0.16l-0.15 -0.95l0.19 -0.11l0.00 0.13zm-44.16 -0.61l0.05 0.40l-0.18 0.30l-0.07 0.70l-0.57 0.51l-0.42 1.71l-1.60 2.38l-0.22 0.58l-0.77 0.98l-0.10 0.58l0.65 0.02l0.50 0.35l0.37 0.08l-0.47 0.63l-0.62 0.20l-0.10 -0.18l-0.23 0.03l-0.45 0.30l-0.62 -0.02l0.47 -1.48l-0.85 0.18l-0.40 0.38l0.10 0.53l-0.10 1.03l-0.40 -0.03l-0.17 -0.35l-1.17 -0.40l-0.37 0.13l-1.12 -0.18l-0.27 0.23l-0.40 -0.10l-0.15 -0.75l-0.30 -0.05l-0.87 0.18l-0.25 0.23l-0.40 -0.08l-0.27 -0.23l-0.22 0.05l-0.13 0.38l-0.30 0.08l-0.60 -0.43l-0.55 -0.65l-0.38 0.08l-0.45 -0.20l-0.62 0.00l-0.35 -0.40l-0.20 -0.63l0.40 -0.75l0.35 -0.08l0.07 0.38l0.77 0.43l0.30 0.00l0.57 -0.58l0.42 -0.05l0.45 0.25l0.27 -0.20l0.00 -0.18l0.32 0.02l0.25 -0.25l0.15 -1.61l-0.05 -1.58l-0.55 -0.54l-0.17 -0.78l0.45 -0.65l0.82 -0.48l0.10 -0.50l0.30 0.10l0.05 -0.15l0.97 -0.43l0.50 -0.78l0.90 -0.70l1.65 -0.60l1.12 0.10l0.80 0.25l0.45 0.30l2.40 0.55l1.40 1.13l0.11 0.31zm15.05 -3.68l1.15 -0.07l0.44 0.25l0.09 0.21l-1.26 0.92l-0.84 1.84l-0.70 0.95l-1.00 -0.63l0.61 -1.24l-0.19 -0.38l-0.24 -0.01l0.10 -0.57l-0.09 -0.66l0.58 -0.47l0.74 -0.32l0.61 0.18zm25.53 1.79l-0.69 0.00l-0.49 -0.40l-0.04 -0.90l0.32 -0.55l0.51 -0.37l0.79 0.08l0.39 0.40l0.15 0.53l-0.26 0.70l-0.41 0.46l-0.27 0.05zm-19.25 -2.66l1.12 -0.13l0.40 0.20l0.45 -0.08l1.30 0.50l0.05 0.85l0.32 1.03l0.52 0.55l0.22 0.05l0.38 0.95l1.20 0.63l0.32 0.02l0.38 -0.35l0.67 -0.20l0.30 -0.65l1.07 -0.88l0.70 0.00l0.28 0.28l0.87 0.03l1.55 0.48l0.52 0.85l0.08 0.53l-0.13 1.56l-0.40 0.60l0.08 0.43l0.62 -0.20l0.22 -0.40l0.13 -0.80l-0.27 -0.40l0.05 -0.43l0.45 -0.85l0.33 -0.40l1.02 -0.73l0.42 0.00l0.17 0.23l1.02 -0.08l1.60 0.40l-0.17 0.68l0.08 0.45l0.95 1.43l0.05 0.95l-0.54 0.25l0.06 0.37l-0.16 0.21l0.39 0.62l-0.03 0.79l0.28 0.18l0.41 0.00l0.40 -0.28l0.54 -0.10l-0.36 -0.56l0.39 0.05l0.25 -0.15l0.08 -0.35l0.32 -0.20l0.33 0.50l-0.13 0.68l-0.33 0.45l0.15 1.13l-0.65 0.53l-0.35 -0.10l-0.33 0.13l-0.90 -0.30l-1.20 0.23l-0.52 -0.65l-0.60 -0.40l-0.47 0.20l-0.15 0.35l-0.25 0.05l-0.80 -0.25l-0.62 0.05l-0.17 -0.18l-0.38 0.20l-0.20 0.38l-0.53 0.25l0.10 0.13l0.52 0.23l2.75 -0.02l0.80 0.45l0.17 0.45l-0.40 0.33l-1.37 0.18l-0.47 -0.13l-0.77 -0.50l-0.85 -0.20l-1.22 0.23l-2.22 1.03l-1.07 0.25l-1.25 -0.48l-0.33 -0.73l0.11 -0.64l0.65 -0.80l0.08 -0.35l-0.15 -0.28l0.25 -0.43l-0.17 -0.48l-0.28 -0.40l-0.15 0.00l-0.10 0.18l0.07 0.55l0.15 0.10l-0.13 0.28l-0.30 0.20l-0.42 -0.13l-0.38 0.58l-0.65 0.30l-0.13 0.53l-0.47 0.11l-1.37 1.38l-0.92 0.38l-0.82 -0.60l-0.30 0.00l-0.27 0.23l-0.73 0.05l-0.32 0.60l-0.50 0.25l-0.35 0.00l-1.07 0.63l-0.62 -0.23l-0.18 -0.20l0.00 -0.30l-0.65 0.20l-0.15 0.28l-0.52 0.03l-0.30 -0.25l-0.30 0.00l-0.47 0.13l-2.40 1.36l-2.37 0.80l-1.30 0.08l-1.65 -0.55l-1.00 0.05l-0.97 1.01l-1.67 0.40l-1.00 -0.35l-0.32 -0.40l-0.65 -0.13l-0.37 0.25l-1.92 -0.73l-0.79 -0.48l-0.30 -0.50l0.23 -0.30l0.05 -0.38l-0.13 -0.23l0.17 -0.85l0.33 -0.05l0.22 -0.23l-0.08 -0.40l0.77 -0.15l-0.15 -0.55l-0.65 -0.98l0.27 -0.23l-0.42 -1.00l0.67 -1.41l0.47 -0.13l0.10 -0.20l-0.22 -0.83l0.47 0.33l1.58 -0.25l2.32 -1.58l0.67 -0.88l0.50 -0.15l0.30 0.00l0.97 0.60l0.23 -0.05l2.95 1.20l0.20 -0.48l0.45 -0.40l0.62 -0.23l0.45 0.15l1.17 -0.13l0.25 0.28l0.40 0.02l0.47 0.48l0.62 -0.05l0.32 0.95l-0.15 0.25l-0.62 0.18l-0.08 0.18l0.18 0.25l0.47 0.23l0.90 -0.08l-0.32 -1.30l0.40 -0.13l0.37 0.95l0.55 0.02l0.05 0.45l-0.80 0.08l0.32 0.38l-0.10 0.60l0.32 1.21l0.30 0.45l1.50 -0.30l1.30 0.55l0.35 0.00l1.47 -1.21l1.37 -0.30l0.67 0.08l0.37 0.35l1.57 -0.63l-0.20 -0.75l-0.38 -0.10l-0.13 -0.35l-0.57 -0.15l-0.15 0.25l-0.35 -0.58l-0.62 -0.38l-0.30 -0.50l-0.37 0.10l-0.50 -0.73l-1.67 0.20l-2.92 -1.86l-0.80 -1.03l-0.92 -0.83l-0.17 -0.35l0.32 -1.00l1.15 -0.83l0.70 0.05l1.70 -0.80l0.55 0.38z"},ID_nt:{name:"Nusa Tenggara Timur",path:"m487.55 308.46l0.71 -0.08l0.12 0.16l-1.19 1.40l-0.37 0.13l0.13 0.18l1.00 0.14l0.21 0.82l-0.48 0.59l-0.94 -0.03l-0.59 0.29l-0.29 0.36l-0.77 0.29l-0.18 0.34l0.07 0.36l-0.37 0.86l-0.26 -0.09l-0.37 0.24l-0.48 -0.33l-0.39 -0.05l-0.50 0.28l-0.35 0.49l-1.76 0.09l-0.57 0.41l0.34 0.34l-0.29 0.53l-0.38 0.01l-0.12 -0.30l-0.46 0.04l-0.08 -0.16l-0.60 0.15l-0.12 0.37l-0.50 -0.30l-0.09 -0.49l0.14 -0.80l-0.46 -0.88l0.13 -0.37l0.85 -0.37l0.65 -0.04l0.63 -0.33l0.73 0.11l0.37 -0.22l0.78 -0.09l1.41 -1.37l0.51 0.04l0.48 -0.32l0.22 -0.65l0.44 0.03l-0.07 -0.40l0.83 -0.88l1.73 -0.78l0.20 -0.83l0.61 0.63l-0.33 0.24l0.07 0.24zm-24.85 -1.04l0.71 0.12l0.16 0.18l-0.19 1.32l-0.30 0.35l-0.58 0.18l-0.57 0.60l-0.74 0.46l-0.61 0.10l-0.51 -0.25l-0.99 0.09l-1.10 -0.67l2.61 -1.46l0.22 -0.83l0.41 -0.25l0.67 -0.22l0.81 0.28zm26.17 -4.80l0.53 -0.11l0.09 0.45l-0.78 0.26l-0.12 0.38l-0.40 0.22l-0.17 -0.01l-0.01 -0.33l-0.44 -0.04l0.01 0.41l0.28 0.14l0.14 0.34l-0.09 0.29l0.13 0.34l-0.43 -0.06l0.11 0.28l0.20 0.07l-0.11 0.42l-0.40 -0.01l-0.14 -0.47l-0.19 -0.05l-0.38 0.07l-0.25 0.48l-0.15 0.02l-0.25 -0.44l0.07 -0.53l-0.15 -0.26l0.43 -0.58l0.52 -0.27l0.52 -0.87l0.15 -0.58l0.99 -0.39l0.22 0.33l0.07 0.50zm-59.68 -13.46l0.37 0.25l0.47 0.87l0.42 0.37l0.49 0.15l1.01 -0.22l0.27 0.12l0.39 0.60l0.12 0.47l0.07 1.21l0.39 0.50l0.69 0.05l0.37 0.45l0.20 0.00l0.71 -0.40l1.72 -0.42l0.47 0.55l0.07 0.42l1.70 0.87l0.30 0.87l1.18 2.21l1.01 0.35l1.06 0.62l0.49 0.70l0.34 1.07l-0.22 0.80l-0.69 0.60l-0.47 0.07l-0.62 0.94l-0.86 0.57l-0.62 0.02l-0.42 0.35l-1.03 -0.20l-0.49 0.12l-0.91 0.47l-0.07 0.35l-0.25 0.27l-0.32 0.02l-0.79 -0.45l-0.57 -0.55l-1.45 0.05l-0.71 -0.12l-0.42 0.10l-1.11 -0.50l-0.74 -0.72l-0.37 -0.12l-0.74 -0.90l-0.44 -0.10l-0.15 -0.15l0.17 -0.35l-0.25 -0.62l-1.04 -1.19l-0.67 -0.20l-0.07 -0.32l-0.47 0.00l-0.05 -0.47l-1.28 -0.20l-0.27 0.07l-0.30 -0.45l-1.22 -0.81l-0.25 -0.30l-0.25 -0.75l-0.32 0.00l-0.31 0.23l-0.22 -0.37l-0.49 -0.20l-1.21 -0.17l-0.84 -0.30l-0.94 0.40l-0.27 0.50l-1.01 -0.52l-0.37 0.10l-0.22 -0.35l-1.55 -0.12l-0.57 0.10l-0.12 -0.15l-2.00 -0.67l-0.42 -0.30l-1.01 -1.37l-0.67 -0.50l-0.32 -0.55l0.64 -1.09l0.57 -0.55l0.67 -0.40l1.45 -0.35l1.13 -0.67l0.29 0.07l0.25 0.27l1.01 -0.50l0.49 -0.07l0.76 0.32l1.06 0.00l0.91 -0.30l1.26 0.32l0.79 -0.52l1.03 -0.02l0.74 0.52l1.00 0.22l0.34 -0.07l0.59 0.25l0.59 -0.55l1.18 -0.72l0.57 -0.84l0.20 -0.05l0.54 1.02l0.90 0.96zm85.11 -7.52l0.20 0.08l-0.30 0.63l-0.01 0.52l0.23 0.36l0.51 0.25l0.45 -0.01l0.67 -0.52l0.61 -0.17l0.32 -0.34l0.28 -0.63l0.41 0.45l0.26 0.05l0.61 0.51l0.02 0.85l-0.26 0.89l0.15 0.75l-0.69 0.08l-0.64 0.38l-0.03 0.14l-0.72 -0.56l-1.04 0.02l-0.28 0.57l-0.05 0.39l0.26 1.08l0.97 0.67l0.04 0.58l0.48 0.56l0.16 1.19l0.00 0.00l-0.91 0.65l-0.77 0.86l-0.17 1.64l-0.53 0.56l-1.11 0.46l-0.51 0.45l-1.46 1.86l-0.61 1.02l-0.67 0.25l-0.80 0.79l-1.89 1.10l-0.65 1.39l-1.42 1.07l-0.57 0.26l-0.48 0.01l-3.42 -0.29l-0.48 0.09l-0.46 0.19l-0.51 0.51l-0.16 0.44l-0.78 0.47l-0.28 0.37l-1.01 0.13l-1.19 0.54l-0.25 0.31l-1.29 0.40l-0.77 0.00l-0.90 0.22l-0.54 -0.26l-0.30 0.01l-0.71 0.35l-0.27 -0.35l-0.97 -0.38l-1.36 0.51l0.04 -0.53l0.23 -0.19l0.38 -0.82l-0.13 -0.69l0.58 -0.22l0.07 -0.66l1.49 -0.63l0.61 -0.04l0.55 -0.38l1.00 -0.38l0.49 -0.86l-0.20 -0.28l-1.01 -0.35l-0.30 0.12l-0.59 -0.10l-0.42 0.18l-0.23 0.35l-0.30 -0.09l-0.12 -0.19l-0.01 -1.81l0.36 -0.47l0.28 -0.10l0.33 0.09l0.40 -0.48l0.11 -1.07l-0.45 -0.66l0.49 -0.20l0.19 -0.35l0.04 -0.64l-0.23 -1.16l1.20 -1.24l0.77 -0.31l0.15 -0.60l0.30 -0.26l0.19 0.02l0.48 -0.39l0.62 -0.20l0.33 -0.60l0.54 -0.18l0.09 -0.34l0.39 -0.28l0.19 -0.43l0.33 -0.27l0.87 -0.06l0.00 0.00l0.88 1.19l0.46 -0.02l0.26 0.32l0.41 -0.11l0.20 -0.48l0.70 -0.42l0.21 0.04l0.83 0.81l0.25 0.61l-0.14 0.86l1.21 -0.28l0.23 -0.50l-0.22 -0.45l0.55 -0.68l-0.12 -0.25l0.11 -0.30l0.17 0.02l0.31 -0.40l0.49 -0.07l0.14 -0.43l0.30 -0.15l-0.12 -0.56l0.20 -0.43l0.04 -0.59l0.19 -0.24l-0.03 -0.31l0.00 0.00l0.45 0.12l0.85 -0.09l0.88 -0.31l1.51 -1.21l0.08 -0.56l0.79 -0.09l0.96 -0.70l1.07 -0.24l0.52 -0.45l0.87 -0.30zm-88.95 -2.35l-0.42 -0.02l-0.01 -0.27l0.26 -0.27l0.25 0.14l-0.08 0.42zm-2.21 -0.28l-0.05 0.15l-0.60 -0.24l0.44 -0.22l0.21 0.31zm-1.10 -2.63l-0.24 0.15l-0.15 -0.13l-0.31 0.05l-0.15 0.28l0.27 0.28l-0.20 0.01l-0.41 -0.41l1.06 -0.68l0.15 0.07l-0.02 0.38zm0.70 -0.78l0.29 0.01l-0.01 0.61l0.19 0.69l0.10 -0.21l0.47 -0.04l0.02 -0.24l-0.33 -0.35l0.40 0.15l0.17 -0.46l0.37 0.12l0.35 -0.19l0.51 -0.01l0.23 0.18l-0.12 0.58l-0.70 0.13l-0.12 0.38l-0.22 0.17l-0.19 0.00l-0.04 -0.23l-0.20 0.01l-0.23 0.37l-0.08 0.37l0.48 0.18l0.15 0.30l-0.05 0.28l-0.60 0.67l-0.27 -0.01l-0.04 -0.34l-0.26 -0.26l-0.74 0.31l-0.21 -0.67l0.27 -0.86l0.24 -0.12l0.41 0.11l-0.15 -0.50l-0.23 0.21l-0.15 -0.08l0.18 -0.11l0.04 -0.36l-0.43 -0.80l0.32 -0.13l0.18 0.14zm47.22 -3.16l0.58 0.33l0.11 -0.20l0.11 0.18l-0.14 0.53l-0.43 0.36l-0.57 -0.16l-0.36 -0.44l0.05 -0.52l0.65 -0.08zm-50.22 0.41l-0.01 0.47l0.18 0.11l1.15 0.21l0.38 -0.19l-0.04 0.65l0.15 0.26l-0.14 0.02l-0.22 -0.30l-0.09 0.19l0.17 0.26l0.00 0.69l0.22 0.10l-0.91 0.13l0.00 -0.48l-0.37 -0.08l-0.05 0.29l-0.34 0.33l-0.37 0.03l0.18 0.35l0.25 -0.03l0.20 -0.23l0.05 0.13l-0.16 0.25l-0.04 0.15l-0.13 0.21l-0.39 -0.06l-0.33 0.46l0.38 0.45l-0.14 0.37l0.41 0.23l-0.52 0.25l-0.61 -0.48l-0.52 0.22l0.09 -0.50l0.39 -0.33l0.09 -0.61l-0.04 -0.21l-0.36 -0.28l-0.20 0.09l0.24 -0.50l-0.25 -0.25l0.28 -0.48l0.20 0.05l0.38 -0.20l0.00 -0.39l0.19 -0.04l-0.02 -0.23l-0.32 -0.13l0.42 -0.30l-0.03 -0.20l-0.20 -0.10l-0.05 -0.47l0.50 0.12l0.06 -0.44l0.29 0.44zm63.80 -0.41l0.08 0.32l-0.33 0.28l-1.33 0.50l-0.46 -0.02l-0.36 -0.21l-0.72 0.61l-0.78 1.45l-0.46 0.27l-0.41 -0.04l-0.28 -0.47l0.25 -1.02l1.08 -0.58l0.06 -0.50l0.43 -0.44l0.39 -0.03l0.39 0.23l0.32 -0.23l1.37 0.00l0.39 -0.21l0.37 0.09zm-24.91 -2.28l0.20 0.03l0.22 0.49l-0.10 0.34l-0.26 0.15l-0.77 -0.25l-0.17 0.13l-0.08 -0.10l0.19 -0.14l0.22 -0.60l0.31 -0.14l0.24 0.09zm25.80 -1.04l0.13 0.09l0.21 -0.26l0.22 -0.04l0.36 0.31l0.62 0.05l0.59 0.32l-0.29 0.47l-0.23 0.08l0.06 1.02l-0.28 0.60l-0.96 0.12l-1.05 -0.18l-1.87 0.44l-0.41 -0.16l-0.77 0.15l-0.05 -0.72l0.61 -1.06l1.20 -0.69l0.68 -0.59l0.66 0.09l0.43 -0.26l0.14 0.04l0.00 0.18zm18.17 1.97l-0.84 1.05l-0.15 1.07l-1.34 1.24l-1.03 0.15l-0.23 -0.16l0.20 -0.81l-0.55 -1.30l-0.80 -0.04l-0.68 0.50l-0.01 0.17l-0.56 -0.16l-0.01 -0.21l0.48 -0.54l0.33 -0.98l1.63 -0.93l0.51 0.30l0.04 0.67l0.17 0.15l0.39 -0.11l0.64 -0.67l0.19 -0.46l0.66 -0.38l0.72 -1.22l0.42 -0.35l0.64 -0.01l0.23 0.19l0.09 0.39l-0.44 0.82l0.08 0.98l-0.19 0.35l-0.59 0.30zm-7.27 -2.47l1.00 0.12l0.44 0.63l-1.47 0.55l-0.63 -0.16l-0.72 0.28l-0.38 0.48l-0.07 0.47l-0.59 0.60l-0.07 0.32l-0.40 0.48l-0.36 -0.04l0.03 -0.25l-0.15 -0.08l-0.43 0.01l-0.54 0.58l-0.47 0.24l-0.15 0.38l0.38 0.48l0.11 0.50l-0.53 0.62l-0.58 -0.04l-0.28 -0.70l-0.21 -0.09l-0.72 0.32l-0.47 0.73l-0.39 0.11l-0.78 -0.31l-0.20 -0.40l-0.52 -0.28l-0.41 0.35l-0.88 -0.13l-0.19 0.24l-0.35 -0.30l0.03 -0.42l0.38 -0.01l1.28 -1.07l0.43 -0.85l0.82 -0.27l0.21 -0.23l0.78 -0.13l0.59 -0.42l-0.74 -0.75l-0.42 -0.07l-0.98 0.17l0.60 -0.73l0.45 -0.20l0.28 0.24l0.64 0.08l0.48 -0.48l0.58 -0.11l0.63 0.09l0.12 0.09l-0.24 0.25l-0.12 0.47l-0.75 0.86l-0.04 0.27l0.94 0.32l0.71 -0.56l-0.01 -0.32l-0.31 -0.15l-0.01 -0.43l0.50 0.00l-0.07 0.35l0.08 0.16l0.58 -0.50l-0.17 -0.70l-0.38 -0.13l0.00 -0.32l0.70 -0.09l0.23 0.12l-0.04 0.40l0.71 0.15l0.13 -0.15l-0.12 -0.46l1.52 -0.93l0.98 0.75zm11.71 -1.52l1.44 0.10l-0.18 0.33l-0.02 0.69l0.25 0.16l0.83 -0.50l1.68 -0.32l1.33 0.26l1.46 0.03l0.77 -0.36l0.84 0.18l0.64 -0.15l0.93 0.05l0.70 1.39l-0.08 1.14l0.12 0.51l-0.38 0.33l-0.92 0.25l-3.00 0.12l-1.57 0.61l-1.08 0.07l-1.36 -0.16l-1.07 0.69l-0.88 0.20l-0.26 -0.31l-0.56 -0.13l-1.21 0.71l-0.16 -0.03l-0.07 -0.31l-0.88 0.10l-0.39 -0.38l0.03 -0.35l0.10 -0.31l0.95 -1.14l0.05 -0.38l0.41 -0.13l0.79 -0.64l0.64 -0.08l0.54 -0.33l-0.16 -0.13l-0.66 0.12l-1.59 0.79l0.08 -0.48l-0.17 -0.38l0.96 -1.29l0.35 -0.37l0.76 -0.17zm-27.53 -0.26l0.78 0.51l0.03 0.44l-0.20 0.56l0.28 0.33l0.05 0.60l0.68 0.69l0.02 0.41l-0.71 0.68l-0.29 0.05l-0.67 -0.38l-0.21 0.07l-0.58 0.85l0.23 0.57l-0.12 0.60l-0.46 0.07l-0.52 -0.36l-0.62 -0.17l-0.16 0.15l0.11 0.87l0.88 0.93l0.05 0.60l-0.21 0.37l-0.88 0.34l-0.84 -0.01l-0.11 0.41l-0.21 -0.16l-0.83 0.00l-0.84 0.52l-0.27 -0.08l-0.24 0.20l-0.48 0.07l-0.58 0.74l-1.97 0.65l-0.76 0.08l-0.53 -0.20l-1.08 0.26l-0.71 -0.23l-0.69 0.12l-0.35 -0.32l-1.05 0.04l-0.44 0.13l-0.30 0.43l-0.22 0.04l-0.50 0.50l-1.89 0.67l-0.96 0.02l-0.22 0.30l-1.19 0.48l-0.87 -0.07l-0.52 -0.41l-0.52 -0.07l-0.19 0.14l0.06 0.45l-0.15 0.35l-0.25 0.07l-0.31 -0.14l0.32 -1.03l-0.60 -0.24l-0.49 -0.40l-0.74 0.15l-2.52 -0.32l-0.24 0.04l-0.17 0.60l0.06 0.85l-0.43 0.42l-0.57 0.17l-0.71 -0.39l-1.36 0.14l-0.29 -0.15l-1.58 0.60l-0.92 0.61l-0.43 -0.02l-1.47 -0.49l-0.92 -0.75l-0.28 -0.80l-0.24 -0.09l-0.81 0.18l-0.34 0.75l-0.46 0.12l-0.95 -0.39l-0.81 -0.06l-0.89 -0.90l-2.60 0.02l-0.78 0.14l-0.24 -0.13l-1.23 0.63l-0.30 -0.18l-0.29 0.16l-1.15 -0.30l-0.81 -0.84l-0.33 -0.05l-2.23 0.61l-0.87 0.12l-0.42 -0.09l-0.36 0.38l0.00 0.32l-0.21 0.07l-0.42 -0.13l0.13 -0.27l-0.16 -0.09l0.01 -0.46l-0.80 -0.07l-0.15 -0.31l-0.52 -0.44l-0.06 -0.37l0.01 -0.25l0.09 -0.35l-0.10 -0.23l0.23 -0.46l0.01 -1.12l-0.22 -0.10l0.09 -0.33l0.48 -0.52l-0.05 -0.15l0.50 -0.17l0.32 -0.37l0.08 -0.55l-0.34 -0.44l-0.07 -0.39l0.42 -0.04l0.04 0.58l0.30 0.06l0.11 0.17l0.48 -0.32l0.24 0.01l0.40 -0.42l0.50 0.47l0.24 -0.36l-0.25 -0.14l0.02 -0.24l0.35 -0.56l0.51 0.04l0.24 -0.17l0.21 0.01l0.14 0.43l0.22 0.18l-0.18 0.36l0.38 0.04l0.21 -0.39l0.01 -1.00l0.63 0.29l0.25 -0.43l0.15 0.00l0.33 -0.74l0.24 0.04l0.49 -0.15l0.24 -0.25l0.49 -0.04l0.71 -0.03l0.78 0.20l0.71 -0.25l0.07 -0.47l0.19 -0.17l0.46 0.38l-0.01 0.33l0.40 0.24l0.85 -0.33l0.51 0.29l0.72 0.01l0.17 -0.22l-0.24 -0.27l0.11 -0.20l0.75 0.35l0.73 0.89l0.49 -0.04l0.43 0.38l1.17 -0.15l0.90 0.29l1.15 -0.01l0.53 -0.18l0.50 0.07l-0.03 0.35l0.13 0.13l0.50 -0.03l0.00 0.36l0.21 0.39l0.71 -0.10l0.65 0.28l0.63 0.04l0.38 0.26l0.43 -0.08l0.75 0.46l0.78 0.10l0.49 0.21l0.75 1.21l1.22 0.56l0.85 -0.45l0.25 0.31l0.33 0.13l0.21 0.53l0.51 -0.60l0.61 -0.20l-0.25 -0.22l-0.01 -0.35l0.17 -0.06l0.65 0.42l-0.22 -0.43l0.10 -0.82l0.21 -0.22l0.44 0.11l-0.03 0.36l0.40 -0.11l0.24 0.32l0.86 -0.31l0.89 0.09l0.28 0.19l0.51 -0.20l0.29 -0.31l0.28 0.22l0.89 0.04l0.28 -0.17l0.54 -0.74l-0.06 0.50l0.51 -0.44l0.49 -0.12l0.23 0.06l-0.27 0.81l0.09 0.67l0.92 -0.11l0.29 0.36l0.31 -0.25l0.96 0.45l1.21 1.21l1.15 0.28l0.60 -0.38l0.53 -0.10l1.50 -0.16l0.42 0.10l0.76 -1.05l-0.04 -0.39l-0.61 -0.54l0.22 -0.34l1.12 -0.32l0.30 -0.47l0.32 -0.09l0.14 -0.55l0.27 0.07l0.29 -0.27l0.53 0.15l1.20 -0.54l0.55 0.10l0.76 -1.11l1.11 -0.12l0.36 -0.23l0.36 -1.12l0.43 -0.26l-0.61 -0.34l-0.63 -0.01l-0.94 0.31l-0.41 0.68l-0.98 -0.19l-0.03 -0.13l0.47 -0.40l0.42 -0.74l0.00 -0.77l0.82 -0.21l0.62 -0.53l1.08 0.67z"},ID_pa:{name:"Papua",path:"m755.56 272.16l-2.51 -0.14l-2.81 -0.49l-0.36 -0.18l-0.21 -0.57l0.08 -0.21l2.73 -2.39l1.71 -0.48l0.23 0.05l0.27 0.88l1.28 2.71l0.02 0.34l-0.43 0.48zm-4.89 -2.73l-2.60 2.13l-1.27 0.57l-1.38 0.28l-0.47 -0.05l-0.39 -0.32l-0.65 -0.18l-5.96 -0.40l-2.85 0.69l-0.51 0.35l-0.50 0.06l-0.24 -0.42l0.06 -0.52l1.62 -4.23l3.07 -5.93l1.96 -2.96l0.53 -0.57l2.98 -2.10l2.44 -0.96l4.78 -0.89l2.12 0.11l0.79 0.22l0.37 0.33l1.08 1.81l0.59 0.62l1.32 0.25l0.62 0.98l-0.96 2.70l-1.18 1.89l-0.54 2.73l-0.57 0.73l-1.15 1.06l-1.99 0.44l-1.12 1.58zm0.44 -26.51l0.61 0.50l1.30 0.24l0.82 1.21l-0.99 0.62l-0.75 -0.28l-1.16 -1.53l-0.13 -0.51l0.30 -0.25zm-40.39 -86.82l2.86 0.57l5.96 0.44l1.59 0.67l0.09 0.16l-0.43 0.46l-3.22 0.55l-2.54 0.83l-5.61 -0.50l-4.02 -0.96l-0.89 -0.65l-1.03 -0.45l-2.55 -0.77l-1.02 -0.20l-1.13 0.08l-2.09 -0.34l-1.08 -1.28l0.93 -0.28l1.17 0.38l11.08 0.79l1.93 0.50zm44.47 4.67l1.20 0.01l1.96 0.66l6.25 2.86l6.46 3.36l1.79 0.26l2.55 -0.31l1.28 -0.61l0.99 0.06l0.17 0.54l0.69 0.85l1.91 0.88l0.92 -0.17l0.10 -0.27l1.66 0.03l2.67 0.39l1.57 0.56l0.34 0.26l0.12 0.41l-0.25 0.63l-0.47 0.49l-0.11 0.35l0.46 0.38l1.67 -0.47l2.48 -0.10l0.61 0.05l0.06 0.12l0.00 64.11l-0.68 0.07l-0.67 1.97l0.40 0.51l-0.07 0.34l-0.92 1.75l-0.53 0.53l-0.07 0.81l0.21 1.87l0.55 1.20l0.81 0.83l0.55 0.05l0.43 -0.23l0.02 38.79l-1.09 -0.68l-1.17 -0.32l-0.60 -0.42l-1.46 -1.85l-2.57 -2.39l-1.82 -2.97l-4.75 -4.06l-3.07 -2.25l-1.15 -1.31l-0.18 -0.29l0.12 -0.68l1.38 -1.15l1.25 -2.29l0.24 -0.93l-1.63 0.71l-0.28 1.17l0.05 1.05l-1.29 0.74l-0.86 0.31l-3.52 -0.01l-1.59 0.19l-1.58 0.91l-1.92 0.46l-0.90 0.05l-0.70 -0.08l-0.87 -0.55l-1.00 -1.40l-2.32 0.88l-1.91 1.40l-0.60 1.29l-0.50 0.06l-1.07 -2.05l-0.20 -0.87l1.17 -1.61l0.12 -2.16l0.20 -0.22l1.20 -0.57l0.24 -0.82l-0.04 -1.04l0.89 -2.23l0.66 -0.70l0.02 -0.51l-0.44 -0.44l-1.08 -0.40l-1.25 -0.87l-0.63 -1.45l-0.61 -0.75l-1.71 -1.13l-1.61 -0.82l-0.15 -0.40l0.21 -0.14l4.50 0.17l1.04 0.63l0.96 0.22l2.17 -0.22l0.81 -1.32l-0.81 0.36l-0.25 0.34l-2.06 0.19l-3.37 -1.03l-1.71 -0.78l-2.89 -2.55l-0.31 -0.40l-0.02 -0.55l0.61 -0.49l0.80 -0.02l0.95 0.33l0.73 0.02l1.10 -0.71l1.80 -0.22l1.28 0.44l1.12 1.12l1.02 0.64l0.51 0.14l0.86 -0.19l-1.00 -0.23l-0.70 -0.37l-1.24 -1.12l-0.53 -0.30l-0.85 -0.33l-0.95 -0.12l-3.47 -1.82l-0.26 -1.09l0.66 -0.19l-0.49 -0.66l-3.38 -3.24l-0.76 -1.01l-0.51 -1.14l-0.32 -1.10l0.05 -0.85l-0.48 -1.44l-1.20 -2.22l0.02 -2.02l-1.48 -0.41l-0.76 -0.66l0.41 -0.60l2.77 -1.35l-0.18 -0.15l-0.47 -0.01l-1.61 0.25l-0.99 0.57l-1.35 0.38l-0.25 -0.15l-0.32 -1.80l0.36 -3.26l-0.14 -0.50l-0.50 0.88l-1.52 -0.57l-2.95 -1.94l-0.49 -0.59l-1.51 -0.98l-0.94 -0.25l-0.58 -0.36l-0.08 -0.20l0.40 -0.36l-1.30 -0.01l-1.89 -0.85l-1.81 -1.31l-0.62 -0.74l-1.00 0.44l-3.58 -1.01l-3.13 -0.41l-0.41 -0.42l-2.90 -1.34l-4.70 -2.50l-1.76 0.02l-3.86 -1.56l-0.47 -0.42l-0.62 -0.92l-0.76 -0.31l-2.20 -0.11l-1.33 0.16l-5.17 -1.12l-1.66 0.14l-1.68 0.38l-0.96 -0.34l-3.70 -2.11l-1.63 -0.69l0.00 0.00l1.64 -2.37l1.06 -0.81l0.65 -1.38l1.06 -1.63l2.29 -2.84l-0.90 -0.41l-0.49 0.00l-1.22 -0.57l-2.86 -0.89l-3.02 -1.22l-6.45 -1.87l-1.96 -0.97l-1.39 -0.41l1.14 -2.52l0.98 -1.22l1.63 -0.97l0.24 -0.81l0.00 -1.14l1.55 -0.81l2.48 -2.27l0.00 0.00l0.61 2.49l0.47 0.36l0.71 -0.15l0.67 -0.48l0.09 -0.50l0.31 -0.37l0.45 0.04l0.12 0.65l-0.18 1.21l-0.49 0.45l-0.17 1.43l1.11 2.15l2.05 1.51l2.13 0.55l3.73 0.43l2.22 -0.42l0.95 -0.47l0.67 -0.64l0.26 -0.60l-0.03 -0.40l0.64 -0.78l0.49 -0.34l1.37 -0.40l0.92 -0.73l-0.03 -0.26l-0.42 -0.32l0.40 -0.51l2.48 -1.07l0.51 -0.79l0.32 -2.73l1.23 -1.46l0.40 -0.05l2.31 -1.08l1.25 -1.01l0.43 -0.75l1.09 -2.85l0.05 -0.66l-0.19 -0.79l0.39 -0.49l0.91 -0.63l1.27 -0.10l0.87 0.05l0.06 0.29l0.18 0.12l0.96 0.24l1.14 0.10l1.49 -0.13l1.46 -0.83l2.65 -1.17l1.31 -0.41l0.80 0.11l1.30 -0.22l0.78 -0.52l0.04 -0.29l-0.64 -1.80l-0.63 -0.29l-0.91 -1.04l0.19 -1.23l1.22 -0.64l1.25 -0.31l1.40 -0.61l2.50 -1.32l0.44 -0.53l1.55 -0.75l4.17 -1.47l0.52 -0.02l0.96 0.28l0.81 0.92l1.43 1.10l6.10 2.16l4.19 1.00l1.53 0.96l0.76 1.02l0.96 0.82l0.38 0.07zm-68.19 -14.13l-0.97 -0.01l-1.13 -1.66l0.19 -1.00l0.50 -0.67l0.81 -0.05l0.73 0.35l1.08 1.11l-0.08 1.04l-0.49 0.69l-0.64 0.20zm9.63 -8.01l1.79 0.04l1.52 0.24l1.62 1.07l0.97 -0.75l0.54 -0.07l0.66 0.38l3.03 2.55l2.23 3.23l1.25 -0.22l1.72 0.77l0.36 0.36l-0.81 0.72l-1.29 0.72l-1.85 0.40l-1.04 -0.02l-0.87 -0.65l-0.48 -0.15l-1.00 0.05l-0.75 0.27l-0.59 -0.12l-0.88 -0.87l-0.78 -3.16l0.03 -0.92l-0.57 -1.23l-0.50 -0.05l-1.81 0.86l-1.79 -1.52l-0.66 -0.15l0.08 0.54l-0.42 -0.16l-1.00 -0.95l-0.62 -1.33l0.26 -0.49l1.65 0.61z"},ID_pb:{name:"Papua Barat",path:"m663.64 200.15l0.76 0.90l-5.00 -2.24l-0.16 -1.15l0.51 0.19l1.24 0.95l2.65 1.35zm-58.47 -37.60l-1.23 0.04l-3.61 -1.07l-3.03 -1.57l-0.33 -0.42l0.58 -0.54l3.53 -1.26l1.42 -0.72l5.41 -1.05l0.08 0.52l1.33 1.97l0.06 2.57l-0.94 0.62l-3.27 0.91zm-4.51 -14.67l-1.71 0.55l-1.58 -0.54l0.06 -0.33l0.37 -0.34l1.80 -0.50l1.55 0.52l-0.49 0.64zm16.75 -5.48l0.59 0.77l1.09 -0.15l0.66 -0.26l0.69 1.04l-0.05 1.91l-0.58 2.67l-0.72 1.64l-0.21 0.26l-0.40 0.12l-1.50 -0.28l-2.04 -1.69l-0.35 -1.00l-0.75 -1.06l0.35 -0.54l-0.27 -0.73l-0.38 -0.64l-0.56 -0.21l-0.07 -0.22l0.07 -0.25l0.36 -0.20l3.39 -1.11l0.68 -0.07zm0.31 -1.73l-0.45 0.77l-1.64 0.70l-2.22 0.47l-1.46 0.15l-1.84 -0.10l-0.59 0.10l-0.55 0.28l-0.24 -0.08l0.88 -1.01l0.66 -0.52l4.17 -0.12l1.33 -0.30l0.63 -0.70l0.79 0.00l0.53 0.36zm-5.38 -4.29l-2.44 -0.27l-0.16 -0.97l0.42 -0.31l2.32 -0.69l0.80 0.28l0.57 0.45l0.02 0.26l-0.45 0.75l-1.08 0.50zm51.35 3.65l3.04 0.05l0.08 -0.56l3.91 0.10l2.24 1.81l-1.41 2.26l1.69 3.19l1.35 1.19l1.31 2.39l-0.79 0.87l-0.24 2.51l-2.30 2.07l0.59 3.54l0.39 0.86l-0.21 2.02l0.46 4.60l1.09 1.87l0.53 0.18l1.15 1.14l2.47 6.13l0.55 0.02l0.54 -0.46l-0.90 -3.57l-0.05 -1.18l0.25 -0.58l0.94 -0.96l0.53 0.11l1.23 0.78l0.26 0.91l0.10 4.32l0.00 0.00l-2.48 2.27l-1.55 0.81l0.00 1.14l-0.24 0.81l-1.63 0.97l-0.98 1.22l-1.14 2.52l1.39 0.41l1.96 0.97l6.45 1.87l3.02 1.22l2.86 0.89l1.22 0.57l0.49 0.00l0.90 0.41l-2.29 2.84l-1.06 1.63l-0.65 1.38l-1.06 0.81l-1.64 2.37l0.00 0.00l-1.16 -0.49l-2.68 -2.25l-0.08 -0.22l0.73 -2.82l0.43 -0.22l2.50 0.31l1.04 0.45l0.32 -0.03l0.65 -0.48l-0.03 -0.17l-1.16 -0.20l-3.94 -0.25l-0.96 0.74l-0.34 0.90l-1.31 0.28l-0.94 -1.35l-0.60 -0.59l-1.16 -0.28l-0.45 1.63l-0.64 0.33l-1.57 -0.88l-0.51 -0.44l-0.35 -0.72l0.06 -0.53l0.41 -0.30l0.05 -0.28l-0.29 -0.62l-0.59 -0.59l-0.25 -0.11l-1.74 0.91l-1.75 -0.94l-1.60 -2.78l-0.56 0.28l-0.07 0.16l0.14 0.98l-0.44 0.10l-1.23 -0.78l-1.10 -2.17l-0.14 -0.56l0.08 -0.22l0.91 -0.58l0.11 -0.24l0.05 -1.06l-0.25 -1.28l0.44 -1.45l1.21 -1.03l1.34 -0.86l0.03 -1.29l-0.58 -0.79l-1.69 1.53l-1.25 1.48l-0.32 2.64l0.04 2.08l-0.65 0.13l-1.06 0.72l0.39 0.37l0.41 0.91l-0.07 0.58l-1.68 1.30l-1.54 1.53l-0.07 0.30l0.20 0.90l0.60 0.52l0.17 0.64l-2.39 2.51l-1.30 1.06l-0.65 0.06l-2.62 -0.30l-0.34 0.19l-0.65 0.76l-1.36 -0.34l-1.12 -1.51l-0.55 -1.27l0.20 -0.16l-0.16 -0.61l-1.16 -2.99l0.56 -1.47l1.83 -0.66l0.53 -0.41l0.12 -0.27l-0.77 -1.44l-0.27 -0.08l-0.29 0.15l-0.47 -0.38l-0.37 -1.40l0.35 -0.85l-0.05 -0.29l-0.39 -0.50l-0.52 -0.13l-0.60 0.24l-0.02 0.90l-0.15 0.15l-0.23 0.06l-0.79 -0.37l-1.16 -1.56l-0.08 -0.85l-0.62 -1.18l-1.58 -1.24l-2.59 -1.61l-0.74 -0.21l-1.44 0.00l-1.90 0.49l-2.14 -3.10l0.18 -0.21l2.96 -1.40l1.20 -0.25l1.91 0.06l3.34 0.31l1.06 0.29l1.20 0.75l0.41 0.53l0.98 0.45l2.07 -1.49l3.05 -4.02l1.51 -0.87l0.90 -0.28l1.52 -0.21l1.10 0.53l1.32 1.27l2.08 0.76l0.71 -0.04l0.99 -0.43l0.76 0.09l0.51 0.73l-0.10 0.91l0.11 1.36l0.25 -0.34l0.32 -2.52l-0.10 -0.61l0.24 -0.05l0.36 0.17l1.08 2.21l0.22 0.13l0.07 -2.02l-0.29 -0.80l-0.39 -0.24l1.02 -0.97l1.28 -0.61l0.71 -1.04l0.05 -1.62l-0.20 -0.42l-0.40 1.05l-1.47 0.49l-0.31 -0.03l-0.56 -0.72l0.12 -0.21l2.03 -0.79l0.58 -0.48l-0.20 -1.15l-1.01 0.17l-3.98 2.12l-1.78 0.15l-1.81 -0.12l-0.66 -0.35l-1.78 -0.31l-1.67 0.22l-4.11 1.28l-1.09 -0.07l-1.44 -0.62l-0.60 0.17l-1.61 0.87l-0.88 -0.43l-0.19 -0.22l-0.21 -0.79l-0.41 -0.53l-0.30 -0.07l-2.05 0.52l-1.09 0.68l-0.96 0.22l-0.67 -0.08l-2.47 -2.01l-0.84 -0.32l-1.14 -0.82l-1.20 -2.03l-0.70 -1.58l-0.07 -1.12l0.76 -0.83l-0.25 -0.93l-1.28 -1.13l-2.76 -1.04l-0.33 -0.38l0.02 -0.27l-1.98 -0.92l-5.48 -1.83l0.17 0.40l0.82 0.54l0.04 0.38l-0.78 0.65l-1.38 0.50l-0.52 -0.85l-1.15 -0.45l-1.07 0.06l-1.48 -0.90l0.83 -1.17l0.41 -1.03l0.42 -0.54l2.06 -0.42l1.21 -2.10l0.64 -3.07l-0.53 -1.64l4.46 -1.52l0.37 0.05l0.06 0.21l0.68 0.22l3.41 -0.63l1.70 -0.55l0.78 -1.22l3.25 -2.69l1.23 -0.77l1.60 -0.65l2.84 -0.68l4.83 0.39l1.84 0.94l5.11 1.98l1.01 0.09l3.48 3.04l0.96 0.29l2.54 0.31zm-46.66 -12.62l2.85 0.81l1.68 0.16l2.77 1.58l0.23 0.60l0.15 1.22l-0.44 0.95l-0.71 1.01l-1.49 -0.83l-1.10 -0.10l-1.23 0.47l-0.99 0.05l-0.53 -0.32l-1.24 -1.61l-1.46 -0.58l-1.40 -2.07l-0.37 -0.29l-1.29 0.15l0.22 0.83l1.75 1.85l1.69 0.78l1.01 0.16l0.59 0.36l0.44 0.74l-0.47 0.76l-1.17 0.55l-1.54 0.21l-0.57 -0.20l-0.30 -0.40l-0.50 -1.96l-1.58 0.35l-0.80 0.73l-0.53 -1.92l-1.45 0.36l-1.19 -0.14l-2.01 -0.68l-0.42 -0.28l0.35 -0.22l0.42 0.21l2.11 0.18l0.75 -0.41l-0.48 -0.82l-1.07 0.03l0.11 0.62l-0.85 -0.19l-0.35 -0.64l0.13 -0.56l1.32 -0.32l1.46 0.00l3.65 -0.59l0.75 -0.29l0.36 0.26l0.84 -0.07l-0.29 -0.27l0.56 -0.34l0.71 -0.07l0.92 0.19zm-22.88 3.34l-0.32 0.15l-0.86 -1.04l-3.37 -3.33l-0.03 -0.20l0.25 -0.03l0.58 0.38l3.54 2.85l0.39 0.68l0.04 0.31l-0.22 0.23z"},ID_ri:{name:"Riau",path:"m137.98 118.33l-0.59 -0.17l-0.31 -0.80l0.47 -1.73l0.52 -0.54l0.51 -0.12l0.81 0.67l0.38 0.56l0.13 1.39l-0.40 0.36l-1.52 0.38zm-9.70 -8.36l0.39 0.06l1.17 -0.40l0.79 0.06l2.84 1.65l1.82 1.37l0.21 0.32l0.18 0.77l-0.25 1.05l-0.55 0.30l-1.23 -1.23l-1.06 -0.49l-3.49 -0.10l-1.69 0.45l-0.53 -0.03l-1.10 -0.55l-1.28 -1.23l0.53 -0.80l0.86 -0.12l0.19 -0.16l0.00 -0.74l-0.52 -1.13l0.05 -0.99l0.29 -0.42l0.61 -0.11l0.57 0.26l1.04 1.34l-0.17 0.47l0.33 0.40zm7.14 -0.75l2.22 2.51l0.06 0.52l-0.35 0.39l-0.62 0.15l-0.49 -0.10l-2.44 -1.71l-3.16 -1.62l-0.59 -0.09l-0.60 0.19l-0.60 -0.53l0.95 -1.65l0.51 -0.20l0.71 0.00l1.46 0.43l1.54 0.72l1.40 0.99zm-11.06 1.94l-0.42 0.00l-1.53 -1.44l-0.36 -0.35l-0.43 -0.81l-0.65 -3.48l0.04 -1.92l0.11 -0.22l0.83 -0.18l0.52 0.13l2.96 2.65l0.28 0.46l0.02 0.33l-0.56 1.71l0.06 1.07l0.35 1.12l-0.06 0.28l-1.16 0.65zm1.69 -8.98l0.17 2.88l-0.24 0.35l-0.52 -0.24l-2.64 -2.52l-0.81 -0.26l-1.98 -0.16l-0.82 -0.36l-0.96 -0.93l-0.88 -1.49l0.27 -0.22l0.81 -0.04l1.85 0.75l2.93 0.40l1.78 0.47l0.75 0.43l0.29 0.94zm-15.46 -4.50l-0.79 -0.03l-1.10 -0.31l-0.38 -0.21l-0.39 -0.50l-0.93 -2.49l0.08 -1.32l0.19 -0.69l0.55 -0.52l3.47 -0.99l0.65 0.18l0.34 0.31l1.26 1.70l0.05 0.89l-0.76 0.97l0.01 1.35l-0.24 0.47l-1.28 0.99l-0.73 0.20l0.00 -0.00zm-16.92 -7.07l0.82 -0.13l0.95 0.59l0.75 0.15l0.51 -0.39l-1.14 -0.71l-0.32 -0.63l-0.08 -0.78l0.20 -0.39l0.95 -0.55l2.40 -0.27l2.46 0.31l-0.12 0.51l0.35 0.77l3.45 2.31l0.74 0.79l0.26 0.81l0.02 1.34l0.72 2.11l0.68 1.09l2.34 1.09l0.75 0.06l1.72 -0.42l1.21 0.33l4.51 3.78l2.02 1.07l1.09 3.06l-0.19 1.73l0.40 1.37l0.43 0.63l3.29 3.10l0.69 0.50l1.38 0.63l0.52 0.07l2.40 -0.22l2.61 0.16l0.69 0.26l0.48 0.37l2.56 3.08l0.18 0.53l-0.15 0.67l-8.84 4.63l-0.71 -0.37l-0.73 -0.82l-1.00 0.01l1.90 1.34l0.82 0.24l1.24 -1.12l4.24 -0.78l4.47 -2.52l0.27 -0.20l0.72 -1.14l2.26 -0.84l0.56 0.06l1.16 0.56l5.00 3.76l0.26 0.56l0.98 4.33l-0.63 0.23l-2.97 0.18l-0.28 0.39l-0.11 0.91l-2.66 1.83l0.17 0.28l0.32 -0.05l0.68 -0.57l0.68 -0.16l0.58 0.05l0.05 0.16l-0.37 0.47l1.63 0.21l0.05 0.21l1.63 0.52l0.89 1.31l-0.63 -0.10l-0.89 0.16l-1.68 0.73l-0.21 0.21l0.16 0.26l-0.30 0.66l-2.63 1.75l-0.38 2.14l0.10 0.42l1.00 0.98l0.00 0.00l-1.18 0.12l-0.84 0.47l-0.39 -0.31l-3.61 -0.62l-0.84 0.21l-1.18 -0.08l-0.86 1.35l-0.84 0.98l-2.10 1.50l-0.10 0.35l-0.47 0.45l-0.53 0.86l-0.69 0.08l-0.51 0.60l-0.29 0.06l-0.61 -0.43l-0.67 0.10l-0.81 -0.33l-0.77 -0.02l-0.47 -0.76l-1.22 -0.12l0.04 -0.64l-1.00 -0.51l-0.29 -0.76l-0.57 0.04l-0.86 0.49l-0.39 0.04l-0.20 -0.14l0.00 -0.31l-0.41 -0.35l-0.39 -0.04l-0.37 0.33l-0.92 -0.45l-0.41 0.16l-0.45 -0.33l-0.39 -0.06l-0.47 0.27l-0.12 0.35l-0.24 -0.21l-0.59 0.29l-0.18 0.62l-0.81 0.18l-0.04 0.31l-0.60 -0.10l0.00 0.00l-0.21 -0.13l0.00 0.00l-0.89 0.00l-0.50 -0.32l-1.27 -0.35l0.03 -0.29l-0.35 -0.18l-0.65 -0.88l-1.12 -0.68l-0.44 -0.03l-0.24 -0.35l-1.45 -0.88l-0.09 -0.56l-0.53 -0.12l-0.38 -0.29l0.18 -0.32l-0.09 -0.09l-1.71 -0.61l-0.44 -0.56l-0.65 -0.26l-0.12 -0.41l-1.12 -0.47l-0.35 -0.41l-0.24 0.06l-0.30 -0.15l-0.71 -1.53l0.18 -0.38l0.03 -0.68l-0.80 -0.59l-0.43 -0.07l-0.86 0.26l-0.09 0.15l0.15 0.09l-0.27 0.50l-0.56 -0.44l-0.47 -0.03l-0.21 -0.32l-0.06 -0.62l-0.53 -0.29l-0.33 -0.50l0.00 0.00l-0.12 -0.35l0.12 -0.44l0.00 0.00l-0.53 -0.91l-0.03 -0.24l0.18 -0.18l-0.27 -0.88l0.03 -0.35l0.47 -0.38l0.21 -0.03l0.33 0.47l0.59 -1.03l0.09 -0.85l-0.38 -0.94l0.00 -0.48l0.27 -0.85l-0.38 -1.00l-0.18 -0.24l-0.35 -0.09l-0.65 0.23l-1.09 0.94l-0.24 0.38l-1.09 -0.03l-2.84 -0.79l-0.77 -1.73l-0.38 -0.26l-0.38 -0.15l-0.92 0.47l-0.27 0.00l-0.15 -0.44l0.00 -1.15l-1.27 -2.64l0.09 -0.94l0.83 -1.29l-0.47 -0.73l-1.06 -0.43l0.00 0.00l-0.87 -1.02l0.28 -0.20l-0.12 -0.23l0.12 -0.90l-0.43 0.04l-0.43 -0.47l0.00 -0.23l0.75 -0.04l0.24 -0.27l0.16 -0.63l-0.35 -1.02l-0.39 -0.16l0.04 -0.43l0.55 -0.31l0.63 -0.08l-0.08 -0.31l-0.59 -0.43l-0.28 -0.51l-0.20 -1.59l-0.51 -0.94l-0.24 0.04l-0.24 -0.24l-0.04 -0.39l0.39 -0.27l3.00 -0.16l0.00 -0.35l0.47 -0.12l0.59 0.12l0.28 -0.16l0.04 -0.39l0.79 0.00l0.83 -0.71l0.12 -0.47l-0.24 -0.23l0.08 -0.39l0.43 -0.71l0.08 -0.47l-0.16 -0.31l0.12 -0.39l-0.08 -0.31l-0.59 -0.12l0.04 -0.43l0.27 -0.28l-0.24 -0.78l-1.89 -0.35l-0.28 -0.31l0.00 -0.39l0.47 -1.25l0.24 -2.98l0.51 -1.72l-0.16 -0.94l-0.71 -1.57l-0.16 -1.33l0.04 -0.67l0.35 -1.25l0.82 2.50l0.57 1.20l1.34 1.39l1.53 1.19l0.92 0.49l0.00 -0.00z"},ID_sa:{name:"Sulawesi Utara",path:"m517.81 102.65l-0.89 1.24l-0.77 2.53l-1.01 1.83l-1.54 2.12l-1.32 0.57l-1.52 1.14l-1.20 1.17l-1.52 2.55l-0.41 1.12l-1.93 2.33l-2.09 1.07l-1.29 0.31l-1.01 0.01l-4.19 0.65l-2.95 0.70l-2.24 0.26l-1.02 -0.31l-2.22 0.02l0.00 0.00l0.27 -0.98l0.82 -1.43l-0.08 -1.01l0.16 -1.08l-0.31 -0.85l-0.54 -0.58l-2.02 -0.35l-1.21 -0.89l-0.62 -0.54l-0.27 -0.85l0.04 -0.46l-0.70 -0.70l-0.86 -0.23l-0.54 -0.39l-0.20 -0.81l0.00 0.00l2.33 -0.11l2.29 0.48l3.00 1.00l0.31 0.04l0.59 -0.34l3.84 0.91l1.58 -0.06l1.24 -0.73l5.33 -2.36l0.42 -0.53l0.83 -2.15l0.99 -0.40l2.68 0.17l0.23 -0.13l0.42 -0.58l-0.01 -0.61l-0.54 -0.32l-0.63 0.03l-0.26 -0.45l-0.03 -0.36l0.46 -0.78l1.13 -0.82l0.98 0.36l0.71 -0.05l2.02 -1.14l0.21 -0.54l-0.54 -1.05l0.05 -0.29l2.62 -2.05l1.07 -0.09l1.71 0.49l0.68 0.55l-0.17 0.54l0.09 0.48l1.44 1.22l-0.32 0.85l-0.60 0.35l-0.65 0.06l-0.32 0.25zm4.74 -20.79l-0.21 0.07l-0.47 -0.20l-0.38 -1.48l0.45 -1.18l0.53 -0.24l0.55 0.33l0.12 0.26l-0.08 0.34l-0.75 0.85l0.03 0.45l0.38 0.56l-0.17 0.24l0.00 0.00zm3.02 -16.98l-0.22 0.56l1.01 1.29l0.17 -0.11l0.42 0.26l0.12 1.26l-0.64 0.96l-0.20 -0.14l-0.17 0.08l-0.09 0.62l-0.16 -0.11l0.02 -0.31l-0.33 -0.56l-0.50 0.02l-0.22 -0.29l-0.41 -0.12l-0.06 -0.29l-0.28 0.05l-0.30 -0.70l-0.03 -0.47l0.47 -1.04l-0.08 -0.16l-0.27 0.00l-0.11 -0.39l0.33 -0.12l-0.08 -0.14l-0.34 0.08l-1.17 -0.73l-0.22 -0.36l0.09 -0.92l0.73 -0.26l1.03 0.19l1.49 1.85l0.00 0.00zm19.42 -3.15l-0.29 0.05l-0.21 -0.30l-1.27 -2.80l-0.13 -1.03l0.27 -0.02l0.41 0.30l1.39 1.87l0.06 0.46l-0.23 1.47zm0.85 -3.22l-1.08 -0.15l-0.16 -1.28l0.72 -0.61l0.98 -1.85l0.00 -0.41l-0.21 -0.19l-1.00 -0.24l-0.17 -0.16l-0.29 -0.96l-0.04 -0.58l0.54 -2.47l0.35 -0.63l1.27 0.23l0.78 0.70l0.96 3.62l-0.78 1.17l-1.28 3.23l-0.59 0.58z"},ID_sb:{name:"Sumatera Barat",path:"m90.90 179.86l-0.03 0.60l0.27 0.53l-0.07 0.20l-1.00 0.13l-0.47 0.23l1.37 2.66l0.03 0.23l-0.40 0.27l-0.30 -0.17l-0.30 -0.66l-0.20 0.03l-0.43 -0.33l0.20 -0.17l-0.20 -0.33l-0.77 -0.27l0.17 -0.70l-0.20 -0.46l0.07 -0.60l-0.60 -0.80l-0.60 0.07l-0.67 -0.80l-0.67 -1.23l-0.03 -0.23l0.30 -0.60l-0.47 -1.92l0.07 -0.30l1.03 -0.37l1.37 1.73l0.90 0.53l1.20 1.53l0.50 0.37l-0.07 0.83zm-5.50 -4.42l-0.03 0.40l-1.00 0.00l-0.07 0.17l-0.53 -0.46l-0.17 0.50l-0.23 0.13l-0.43 -0.37l0.13 -0.33l-0.37 -0.40l0.30 -0.96l0.00 -0.93l-0.37 -0.80l0.03 -0.56l-0.47 -0.30l0.27 -0.33l-0.10 -0.80l0.23 -0.33l0.50 0.10l0.73 1.03l1.03 0.63l0.30 0.43l0.70 0.30l0.47 1.06l0.37 0.40l-0.17 0.76l-0.63 0.23l-0.49 0.43zm-7.48 -11.39l0.67 1.36l0.50 0.53l0.07 0.37l0.60 0.33l0.43 0.70l0.33 0.73l0.00 0.23l-0.17 0.13l-0.20 -0.07l0.03 -0.36l-0.20 -0.30l-0.23 0.20l-0.37 0.00l-0.23 -0.50l-0.80 0.00l-0.97 -0.83l-0.50 -0.20l-0.87 0.10l-0.27 -0.83l-0.27 -0.13l-0.73 -1.23l0.03 -0.23l0.23 -0.17l0.40 0.23l0.07 -0.13l-0.30 -0.40l-0.13 -0.90l0.17 -0.36l0.53 -0.43l0.60 0.00l1.33 1.13l0.25 1.03zm-13.50 -20.57l0.33 0.99l-0.20 0.07l-0.20 -0.50l-0.13 0.10l0.40 1.29l1.00 0.80l0.10 0.76l0.63 0.76l0.03 0.40l0.43 0.70l-0.13 0.30l0.57 0.66l0.03 0.63l1.03 0.99l0.13 0.33l0.10 0.70l-0.27 -0.23l-0.33 0.03l0.40 0.53l0.73 0.27l0.10 0.27l-0.10 0.43l0.40 0.99l0.67 -0.23l0.47 0.66l0.10 1.46l-0.33 0.50l-0.60 -1.16l-0.13 0.03l0.20 0.99l0.27 0.56l-0.43 0.40l-0.37 -0.30l-0.77 -0.03l-0.43 0.13l-0.07 0.30l-0.57 0.10l-4.10 -2.22l-0.20 -0.56l-0.60 -0.53l0.20 -0.10l0.00 -0.23l-0.63 -1.23l-2.67 -3.94l-0.23 -0.66l-0.40 -0.23l-0.17 -0.30l-0.10 -0.43l0.37 -0.40l0.80 -2.15l-0.03 -1.06l0.63 -0.66l0.40 -0.10l0.43 0.20l1.13 -0.10l0.80 -0.30l0.67 -0.50l0.23 0.03l0.41 0.79zm16.52 -31.94l0.39 0.35l0.67 -0.12l0.32 0.71l1.30 0.47l0.28 0.35l2.13 0.71l-0.20 -0.15l0.00 0.00l1.06 0.43l0.47 0.73l-0.83 1.29l-0.09 0.94l1.27 2.64l0.00 1.15l0.15 0.44l0.27 0.00l0.92 -0.47l0.38 0.15l0.38 0.26l0.77 1.73l2.84 0.79l1.09 0.03l0.24 -0.38l1.09 -0.94l0.65 -0.23l0.35 0.09l0.18 0.24l0.38 1.00l-0.27 0.85l0.00 0.48l0.38 0.94l-0.09 0.85l-0.59 1.03l-0.33 -0.47l-0.21 0.03l-0.47 0.38l-0.03 0.35l0.27 0.88l-0.18 0.18l0.03 0.24l0.53 0.91l0.00 0.00l-0.12 0.29l0.12 0.50l0.00 0.00l0.33 0.50l0.53 0.29l0.06 0.62l0.21 0.32l0.47 0.03l0.56 0.44l0.27 -0.50l-0.15 -0.09l0.09 -0.15l0.86 -0.26l0.38 0.06l0.80 0.59l-0.03 0.68l-0.18 0.38l0.71 1.53l0.30 0.15l0.24 -0.06l0.35 0.41l1.12 0.47l0.12 0.41l0.65 0.26l0.44 0.56l1.71 0.61l0.09 0.09l-0.18 0.32l0.38 0.29l0.53 0.12l0.09 0.56l1.45 0.88l0.24 0.35l0.44 0.03l1.12 0.68l0.65 0.88l0.35 0.18l-0.03 0.29l1.27 0.35l0.50 0.32l0.89 0.00l0.00 0.00l0.24 0.15l0.00 0.00l0.03 1.00l0.15 0.12l-0.12 0.76l0.53 0.44l0.35 -0.26l0.12 0.09l-0.30 0.85l-0.83 1.03l-0.62 0.15l-0.33 0.24l-0.62 -0.03l-0.62 0.62l0.06 0.56l0.35 0.82l0.00 0.23l-0.41 0.47l0.00 0.21l0.41 0.35l0.00 0.23l-0.62 1.11l-2.01 1.23l-1.18 1.79l-1.00 0.26l-0.38 -0.35l-0.62 0.18l-0.56 -0.03l-0.53 0.26l-1.06 -0.03l-0.56 0.35l-0.68 -0.71l-0.15 0.03l-0.18 0.35l-0.50 -0.35l-0.18 0.03l0.21 3.64l0.15 0.41l0.47 0.50l0.15 0.50l0.35 0.41l0.71 0.32l0.38 0.73l0.56 1.68l0.18 1.65l0.00 0.00l-0.24 0.53l0.00 0.00l-0.80 0.97l-0.74 0.56l-1.09 0.44l-0.41 0.44l-1.61 1.11l0.00 0.00l-0.28 -0.54l-2.00 -2.21l-0.40 -1.59l-0.84 -1.17l0.04 -0.46l0.74 -0.67l0.30 -0.59l0.01 -1.18l-0.45 -1.67l-1.99 -2.86l-1.44 -1.76l-0.90 -2.38l-0.76 -0.78l0.36 -0.56l0.05 -0.60l-0.43 -0.98l-0.40 -0.27l-0.75 -0.10l-0.80 -0.75l-0.40 0.29l-0.38 -0.11l0.13 -0.62l0.44 0.07l-0.29 -0.67l-0.38 -0.11l-0.55 -0.84l-0.02 -0.29l0.33 -0.02l-0.33 -0.73l0.30 -0.35l0.00 -0.32l-0.55 -1.55l-0.26 -1.39l-0.28 -0.54l-0.44 -0.62l-2.83 -2.81l-0.72 -1.41l-0.66 -0.87l-2.30 -1.89l0.00 -0.23l-0.49 -0.71l-1.13 -0.68l-0.38 -0.84l0.00 -0.53l-0.69 -1.17l-0.22 -0.14l0.22 -0.66l-0.14 -0.36l0.19 -0.32l-0.58 -0.87l-0.90 -0.61l-0.58 -0.62l-1.35 -0.73l-2.28 -0.95l-0.69 -0.15l-0.42 -0.93l-0.36 -0.35l-0.80 -0.10l-1.11 0.41l-1.18 -0.42l0.93 -1.39l0.75 -0.35l0.79 -0.08l0.63 -0.78l0.87 -1.61l0.47 -0.12l1.22 -0.78l1.06 0.43l1.46 -0.51l0.51 0.67l0.08 0.39l0.63 0.47l0.83 -0.43l0.28 -0.04l0.51 0.12l0.12 0.20l0.63 0.04l0.71 -0.12l0.51 -0.31l0.67 -0.82l0.00 -0.67l-0.67 -0.51l-0.08 -1.17l-0.63 -0.24l-0.63 0.00l-0.28 -0.78l0.00 -0.31l0.28 -0.31l-0.08 -2.08l0.59 -0.35l0.28 0.02z"},ID_sg:{name:"Sulawesi Tenggara",path:"m446.93 174.58l1.63 0.42l0.58 0.26l0.45 0.54l0.39 0.14l0.70 -0.57l0.72 -0.21l0.40 0.08l0.59 1.35l-0.31 0.58l0.00 0.33l0.17 0.30l1.09 0.55l1.20 0.16l0.44 -0.24l1.11 -1.14l1.51 -0.58l0.00 0.00l2.65 1.08l1.98 0.56l0.64 -0.33l0.74 0.14l1.04 -0.05l0.44 0.23l0.51 0.68l1.08 0.21l0.16 0.33l-0.11 0.88l0.43 0.18l0.44 0.61l0.55 -0.10l0.42 1.04l0.53 -0.03l0.17 0.15l-0.11 0.21l0.13 0.43l0.00 0.00l-0.88 1.22l0.19 0.77l1.32 0.40l0.35 0.36l0.51 0.20l0.71 1.16l-0.15 0.41l-0.36 0.15l-1.82 -1.82l-0.61 -0.36l-0.75 -0.01l0.72 1.29l-0.42 1.26l-1.18 0.47l-0.03 0.39l0.83 1.32l1.66 1.20l2.21 1.22l-0.05 0.23l0.56 0.71l0.10 0.50l0.46 0.30l1.57 -0.14l0.61 0.10l0.10 0.40l-0.50 0.36l-0.16 0.97l0.66 0.34l0.11 0.36l-0.33 0.43l0.57 1.30l0.17 0.13l2.45 -0.18l-0.11 -0.42l-0.84 -0.61l-0.19 -0.42l0.21 -0.11l0.63 0.04l0.69 0.49l0.68 1.57l0.17 1.07l-0.13 2.76l-1.20 0.96l-0.79 -0.49l-1.68 -1.47l-0.30 0.05l-0.16 0.15l0.21 0.41l1.16 1.01l0.36 0.55l0.08 0.43l-0.28 0.34l-0.36 0.15l-0.30 -0.41l-0.56 0.26l-0.66 -1.32l-0.76 -0.50l-1.32 0.76l-0.76 0.25l-0.82 -0.10l-2.74 0.76l-0.75 -0.14l-1.33 0.74l-0.93 0.17l-0.62 1.16l-0.35 1.41l0.33 1.08l0.86 0.79l0.02 0.32l-1.25 1.30l-1.68 0.04l-1.53 -0.70l-2.06 -0.22l-0.56 0.27l-0.41 -0.10l-0.20 -0.41l-0.46 -0.30l-1.57 -0.61l-0.51 -0.50l-0.20 -0.51l-0.56 -0.56l-0.20 -0.45l0.25 -1.82l0.17 -0.14l0.58 -2.14l-0.09 -1.42l0.41 -1.16l0.51 -0.25l0.66 -1.42l-0.06 -1.41l-0.25 -0.56l-1.32 -0.51l-2.39 -0.35l-0.45 -0.35l-1.12 -1.62l-0.46 -0.20l-0.20 -0.36l0.00 -0.50l-0.51 -0.10l-0.61 0.10l-1.02 -1.36l-3.13 -2.72l-0.62 -0.79l-0.43 -0.20l-0.23 -0.68l-0.03 -0.82l0.36 -0.92l1.61 -2.19l0.70 -0.35l0.61 -1.54l-0.05 -2.32l0.15 -0.55l0.35 -0.45l0.02 -1.18l-0.19 -0.08l0.13 -0.38l-0.27 0.15l-0.24 -0.18l-0.12 -0.79l-0.13 0.00l-0.14 0.44l-0.57 -0.13l0.13 0.29l0.21 0.05l-0.04 0.23l-0.31 -0.03l-0.09 -0.71l-0.29 -0.21l-0.02 -0.21l0.47 0.15l0.47 -0.74l0.34 -0.14z"},ID_sn:{name:"Sulawesi Selatan",path:"m444.97 252.58l1.11 -0.05l1.17 0.37l-0.33 0.47l-0.77 0.12l-3.17 -0.52l-0.43 -0.28l-0.01 -0.24l0.41 -0.27l0.97 0.31l1.05 0.09zm-4.27 -4.15l1.12 0.55l0.46 -0.28l0.15 0.47l-0.25 0.81l-1.67 0.22l-0.61 -0.43l-0.22 -0.64l0.15 -1.19l0.42 0.11l0.45 0.38zm-3.12 -10.68l-0.42 0.95l-0.34 -1.80l0.20 -1.27l-0.46 -2.48l-0.08 -4.31l0.39 -2.09l0.19 -0.34l0.23 -0.03l0.14 0.30l-0.02 0.65l0.46 0.83l0.70 2.68l-0.45 3.92l-0.54 2.99zm-11.04 -76.10l0.40 0.54l0.34 -0.33l0.59 -0.13l0.92 -0.92l0.33 0.17l1.47 -0.13l0.13 0.58l0.84 0.38l1.80 0.00l1.34 0.58l0.80 -2.46l0.00 -0.42l0.29 -0.12l1.27 1.45l0.17 0.46l1.47 2.04l1.13 1.08l1.30 0.67l0.76 0.33l0.84 0.00l0.08 -0.33l0.46 -0.13l1.01 0.15l0.23 0.21l0.77 0.10l4.70 2.00l1.72 0.29l0.96 0.58l0.86 -0.07l0.68 0.12l1.27 0.98l0.62 0.21l0.83 0.06l0.67 1.00l0.45 -0.06l0.64 0.50l1.26 2.55l-0.62 0.17l-0.27 0.27l-0.77 1.49l-0.41 0.23l-0.25 0.76l0.00 0.00l-1.52 0.58l-1.10 1.14l-0.44 0.24l-1.20 -0.15l-1.09 -0.55l-0.17 -0.31l0.00 -0.33l0.31 -0.57l-0.60 -1.35l-0.39 -0.08l-0.72 0.20l-0.70 0.57l-0.39 -0.14l-0.45 -0.53l-0.58 -0.27l-1.64 -0.42l0.00 0.00l0.42 -0.46l-0.77 -1.11l-3.68 -0.97l-0.69 -0.05l-1.64 0.61l-1.83 1.09l-3.43 2.49l-2.96 1.84l1.14 3.00l1.33 0.97l0.58 0.24l0.52 0.88l-0.15 0.85l-0.08 3.50l0.57 1.33l0.32 2.23l-0.13 0.54l-1.16 1.86l-0.34 1.01l-0.18 3.35l0.77 1.06l-0.51 3.74l0.67 1.83l0.46 3.20l-0.54 1.82l-0.90 0.90l-0.52 0.32l-0.01 2.37l-0.73 2.79l2.04 3.47l1.37 4.59l-0.13 0.20l-0.83 -0.28l-1.01 -1.60l-0.36 -0.17l-1.87 0.52l-1.33 0.68l-0.83 0.24l-2.91 -0.58l-1.30 1.09l-0.25 0.75l-0.92 0.61l-1.93 -0.05l-0.31 -0.22l-0.24 -0.53l0.05 -0.28l-0.33 -0.38l-2.76 -0.96l-1.90 -2.82l-0.05 -1.10l0.46 -2.67l0.38 -0.80l1.20 -1.56l0.87 -2.18l0.08 -0.77l-0.38 -0.95l-0.19 -1.40l1.79 -2.95l0.49 -4.11l0.05 -2.35l-0.49 -3.72l-1.06 -1.71l-1.53 -2.99l0.55 -1.42l0.62 -0.86l-0.46 -1.39l0.00 0.00l-0.34 -1.87l-0.50 -1.17l-0.08 -0.92l-0.71 -0.67l0.00 -0.42l0.38 -0.29l0.38 -0.04l0.21 0.29l0.88 -0.25l0.25 -0.21l0.21 -0.58l0.67 -0.25l1.05 0.04l0.04 -0.38l-0.59 -0.67l-0.50 -1.17l0.29 -0.70l-0.10 -0.62l-0.26 -0.33l0.20 -0.88l0.00 -1.02l0.32 -0.75l0.75 0.29l1.05 -0.42l0.50 0.00l0.71 -0.79l0.21 -0.73l1.25 -0.92l0.23 -0.59l-0.10 -0.79l-0.20 -0.36l-0.56 -0.33l-0.92 -0.16l-0.16 -0.20l-0.26 -0.52l0.00 -0.85l-0.30 -0.33l-1.52 -0.73l0.04 -1.30l1.78 -1.28l0.46 -0.43l0.13 -0.36l0.72 -0.10l0.13 -0.33l-0.27 -0.89l1.02 -0.48z"},ID_sr:{name:"Sulawesi Barat",path:"m421.31 141.44l0.11 0.90l-0.22 0.56l0.01 0.95l0.25 0.89l0.16 1.39l0.09 0.25l0.38 -0.08l0.03 0.51l-0.55 1.21l0.05 0.55l-0.19 0.38l-1.55 0.19l-0.19 0.37l0.55 -0.19l0.11 0.24l-0.57 0.33l-0.65 0.08l0.01 0.26l0.49 0.63l0.32 0.21l0.35 -0.06l0.38 0.56l0.64 -0.07l0.57 -0.46l0.36 0.00l0.76 0.44l0.57 0.55l-0.08 0.27l-0.55 0.56l0.29 0.85l1.04 0.98l-0.08 0.63l0.39 0.13l0.44 0.76l-0.33 0.40l-0.11 0.54l0.40 0.27l0.62 -0.09l0.55 0.24l0.31 -0.12l0.05 2.76l0.14 0.34l-0.36 0.21l0.24 0.89l0.00 0.00l-1.02 0.46l0.26 0.90l-0.13 0.33l-0.72 0.09l-0.13 0.36l-0.47 0.43l-1.77 1.28l-0.04 1.30l1.52 0.73l0.29 0.32l0.00 0.85l0.27 0.53l0.16 0.19l0.92 0.17l0.56 0.33l0.20 0.36l0.10 0.78l-0.23 0.59l-1.25 0.92l-0.21 0.73l-0.72 0.79l-0.50 0.00l-1.05 0.42l-0.75 -0.29l-0.33 0.75l0.00 1.02l-0.20 0.88l0.27 0.33l0.10 0.62l-0.30 0.70l0.50 1.17l0.59 0.66l-0.05 0.38l-1.05 -0.04l-0.67 0.25l-0.21 0.58l-0.25 0.21l-0.88 0.25l-0.21 -0.29l-0.38 0.04l-0.37 0.29l0.00 0.42l0.71 0.67l0.08 0.92l0.51 1.17l0.34 1.87l0.00 0.00l-2.39 -0.92l-1.01 -0.14l-1.26 1.10l-0.50 0.09l-0.98 -0.15l-1.43 0.29l-1.53 0.68l-0.46 0.59l-0.19 -0.09l-1.40 -3.20l-0.13 -0.77l-0.04 -4.60l0.26 -0.25l0.67 -2.89l-0.09 -0.38l-0.30 -0.29l-0.95 -0.17l-0.71 0.33l-0.19 -1.53l0.38 -1.65l0.36 -0.70l0.37 -0.23l0.70 0.56l0.71 0.00l1.74 -1.15l2.39 -2.36l0.00 -1.00l-0.36 -1.06l0.04 -0.81l0.24 -1.24l1.18 -3.31l0.45 -0.61l0.46 -0.25l0.73 -0.24l0.58 0.27l0.32 -0.64l0.27 -1.64l-0.14 -0.30l-0.51 -0.28l-0.12 -0.24l-0.47 -1.72l0.02 -0.51l0.43 -1.07l-0.46 -2.20l-0.10 -1.27l0.03 -0.25l0.66 -0.49l-0.20 -0.95l-0.23 -0.32l0.04 -0.29l0.74 -1.49l1.75 -1.51l0.44 -1.99l0.53 -1.37l0.28 -0.54l0.66 -0.48z"},ID_ss:{name:"Sumatera Selatan",path:"m148.23 209.56l0.08 -0.33l-0.36 -0.60l-0.40 -0.02l-0.62 -0.29l-0.36 0.09l0.39 -0.49l-0.18 -0.88l-0.30 -0.42l-0.64 -0.50l-0.78 -0.04l0.71 -0.62l-1.09 -1.04l0.26 -0.52l0.57 -0.54l-0.01 -0.57l-0.31 -0.65l-0.56 -0.18l-0.98 0.36l-0.55 -0.30l-0.34 -0.61l-0.40 0.09l-0.57 -0.21l-0.73 -0.01l-0.73 -0.44l-0.49 -0.56l-1.91 -0.31l-0.01 -1.63l-0.46 -0.67l-0.50 -1.37l-0.40 -0.05l-0.29 -0.24l-0.94 0.14l-1.26 -0.06l-0.21 -0.12l-0.26 -0.51l-0.40 -0.16l-0.61 0.29l-0.76 -0.20l-0.68 -0.39l-0.85 -1.08l-0.89 -0.51l-0.17 -0.40l-0.40 -0.40l-0.67 -0.20l0.47 -0.18l0.23 -0.36l1.33 -0.47l0.12 -1.14l0.63 -0.76l0.49 -0.31l0.07 -1.45l0.16 -0.04l0.53 0.30l0.53 0.56l0.36 0.64l0.17 0.05l0.72 -0.74l0.32 -0.72l0.33 -0.09l0.03 -0.14l0.15 -0.93l-0.04 -0.83l0.18 -0.35l-0.21 -0.45l-0.79 -0.09l-0.82 0.32l-0.21 -0.20l-0.07 -0.56l0.16 -0.11l-0.56 0.25l-0.56 -0.26l-0.27 0.12l-0.29 -0.47l-0.03 -0.34l-0.25 -0.11l-0.90 0.56l-0.86 0.03l-0.79 0.56l-0.25 -0.25l-0.63 -0.10l-1.67 -1.52l0.20 -0.50l-0.23 -0.15l0.11 -1.22l-0.29 -0.74l-0.63 -0.58l-0.97 -0.22l-1.15 0.40l-0.47 -0.44l-0.62 -0.14l-0.40 -0.64l-0.30 -1.19l-0.44 -0.15l-0.13 -0.28l-0.88 -0.53l-0.14 -0.71l-0.85 -0.54l-0.21 -0.59l0.00 0.00l0.52 0.15l0.00 0.00l0.40 -0.73l0.61 -0.16l0.20 -0.20l0.81 -0.12l0.41 -0.44l0.08 -0.73l0.56 -0.24l0.85 0.52l0.29 0.00l0.20 -0.20l0.52 0.29l0.57 0.56l0.69 0.16l0.76 0.00l0.09 0.16l0.60 -0.44l0.41 -0.08l0.48 0.20l0.61 -0.65l0.00 -0.32l0.20 -0.20l0.77 -0.32l0.93 -0.76l0.28 0.16l0.28 -0.04l0.45 -0.36l1.05 -1.77l0.49 -0.37l-0.61 -1.00l0.57 -0.84l0.72 0.28l1.90 0.32l0.29 -0.52l0.20 0.04l0.08 0.24l1.13 0.36l1.54 -0.60l-0.16 -0.73l-0.69 -0.68l0.24 -0.60l0.20 -0.29l0.33 -0.12l0.16 -0.44l0.28 -0.24l0.49 0.08l0.32 0.36l0.08 0.77l0.65 0.56l0.16 0.44l0.81 0.44l0.36 0.65l0.53 0.12l0.20 0.36l0.16 -0.04l-0.12 -0.76l0.20 -0.21l-0.20 -1.56l0.08 -0.41l1.09 -0.28l0.69 -0.48l-0.56 -0.48l0.00 -1.33l0.20 -0.40l-0.08 -0.32l0.20 -0.76l0.00 -0.81l1.09 -0.96l2.18 -0.81l1.66 -0.08l0.29 -0.52l0.72 -0.36l0.45 0.08l1.01 0.52l0.50 -0.18l0.75 0.00l1.08 0.27l1.35 -0.32l0.92 -0.43l0.97 0.11l1.02 -0.27l0.32 -0.43l-0.10 -0.75l0.16 -0.27l0.32 -0.16l0.54 -0.11l1.28 0.52l0.00 0.00l0.64 0.99l0.16 0.90l-0.16 0.52l-0.48 0.38l-0.33 0.73l0.00 0.72l0.23 0.42l0.23 -0.09l0.49 -1.19l0.41 0.07l1.27 1.08l2.07 1.27l1.37 0.06l0.74 0.67l0.21 0.47l0.31 1.57l-0.05 0.47l-0.26 0.37l-0.43 0.10l-0.36 0.63l-0.32 -0.06l-0.59 0.48l-1.12 1.79l0.88 0.15l0.27 -0.15l1.03 -1.47l1.05 -0.23l0.44 0.80l1.13 0.06l0.49 0.38l1.53 0.39l1.48 -0.83l2.41 0.84l3.06 0.34l1.63 -0.02l0.28 0.60l-0.46 1.73l0.27 1.43l0.16 0.38l0.73 0.64l0.69 0.20l0.81 -0.03l0.34 0.16l0.21 0.62l-0.19 2.00l0.63 1.29l0.71 0.62l1.02 0.09l0.74 -0.20l0.30 0.06l0.80 0.34l0.44 0.40l0.15 0.97l-0.13 1.25l0.78 1.57l0.00 0.40l-0.31 0.42l-1.70 0.88l-1.11 1.16l-1.18 2.51l-0.34 1.12l-0.15 1.13l0.24 0.90l0.45 0.47l1.30 0.73l0.41 0.97l-0.21 0.85l-0.90 1.40l-0.61 1.28l-0.22 1.65l-0.28 0.36l0.00 0.00l-0.30 -0.55l-0.51 -0.27l-0.21 0.05l-0.06 0.27l-0.29 0.14l-0.76 -0.08l-0.18 -0.14l0.10 -0.45l-0.26 -0.11l-0.03 -0.24l-0.65 0.00l0.00 -0.24l0.30 -0.30l-0.08 -0.05l-0.46 0.05l-0.24 -0.13l0.00 0.27l-0.24 -0.06l0.05 -0.29l0.40 -0.54l-0.29 -0.32l0.00 -0.24l-0.46 -0.38l0.38 0.00l-0.11 -0.32l-0.11 -0.08l-0.32 0.19l-0.24 -0.19l0.05 -0.45l-0.35 -0.27l-0.19 0.16l-0.35 -0.16l0.14 -0.81l-0.60 0.00l-0.18 -0.26l-0.78 0.05l-0.11 -0.72l-0.32 -0.08l-0.54 0.10l-0.33 0.24l-0.29 -1.07l-0.22 -0.13l-0.35 0.45l-0.11 0.57l-0.40 0.32l0.27 0.61l-0.21 0.49l-0.70 0.64l-0.68 -0.24l-0.54 0.27l-0.10 0.51l-0.16 0.08l-0.22 -0.14l-0.27 1.07l-0.43 0.43l0.30 0.35l-0.38 0.05l-0.30 0.33l-0.32 0.96l-0.62 0.43l-0.37 0.51l-0.62 -0.03l-0.62 0.24l-1.13 0.57l-0.08 0.34l-1.48 0.25l-2.21 -0.11l-0.22 -0.05l-0.40 -0.51l-0.67 0.56l-1.21 0.48l-0.62 0.51l-0.62 -0.05l-0.51 0.59l-0.80 0.56l-0.08 0.38l-0.27 0.08l-0.27 0.83l0.30 2.70l-0.65 0.65l-0.27 0.77l0.54 0.33l0.06 0.83l0.67 0.61l0.11 0.35l-0.03 0.35l-0.73 0.94l-0.35 0.11l-0.40 -0.38l-0.30 0.19l-0.40 0.00l-0.46 -0.27l-0.37 0.08l-0.14 0.38l-1.00 0.53l-0.91 -0.26l-0.08 -0.25l-0.19 -0.05l-0.24 0.22l-1.40 0.16l-0.51 -0.38l-0.16 0.89l-0.30 0.35l-0.75 -0.70l-0.35 -0.03l0.00 -0.21l0.43 -0.41l0.00 -0.53l-0.38 -0.49l-0.43 -0.02l-0.05 -0.51l-0.65 0.05l0.00 0.00l-0.05 0.03z"},ID_st:{name:"Sulawesi Tengah",path:"m491.71 219.55l-1.17 -0.09l-0.65 -1.23l-0.08 -0.80l1.31 0.15l0.49 0.40l0.17 0.36l-0.07 1.21zm-27.91 1.73l-1.00 0.06l-1.68 -2.02l-0.98 -1.56l0.07 -0.81l0.85 -2.25l0.85 -0.57l1.03 0.21l0.20 0.17l1.36 2.60l-0.11 3.33l-0.17 0.61l-0.42 0.23zm12.09 -14.43l0.60 3.99l0.21 0.38l-0.08 1.01l-2.23 1.93l-0.80 1.74l0.07 0.47l0.47 0.37l0.44 1.02l-0.24 1.32l-0.71 1.21l-0.94 0.26l-1.63 -0.58l-2.47 -0.20l-0.47 -0.18l-0.19 -0.93l0.84 -3.01l0.26 -0.61l0.87 -0.52l0.15 -0.34l-0.13 -1.46l-1.01 -2.32l0.74 -1.61l0.38 -0.21l1.03 -0.05l1.14 -0.32l1.43 -1.12l1.63 -0.79l0.64 0.55zm8.55 1.04l0.04 2.14l-0.20 0.85l-0.61 -0.66l0.15 -1.02l-0.73 -1.10l-0.40 0.21l0.16 2.07l-0.36 0.25l-0.61 -0.25l-0.15 -0.25l0.05 -0.41l0.36 -0.51l-0.05 -0.35l-0.14 -0.15l-0.42 0.22l-0.54 1.34l-0.43 1.92l-0.18 2.77l0.73 0.62l0.37 -0.08l2.93 2.31l0.03 0.37l-1.24 1.59l-1.61 0.70l-0.34 -0.09l-0.57 -0.45l-1.67 0.76l-0.45 0.43l-0.23 0.69l0.68 0.05l0.23 0.33l-0.21 0.58l-1.27 2.01l-0.44 0.27l-2.56 -0.12l-0.90 -1.51l-0.61 -1.57l2.87 -4.36l0.80 -2.15l1.25 -5.50l-0.16 -2.80l0.35 -1.30l0.87 -1.75l2.04 -1.44l0.46 -0.13l0.36 0.13l-0.30 0.52l0.24 0.76l1.01 0.56l1.00 1.40l0.40 2.10zm-2.30 -11.67l0.36 0.06l1.48 -0.35l0.72 0.69l0.35 0.72l-0.09 0.72l-1.57 2.06l-0.25 0.13l-1.36 -0.08l-0.88 -0.89l-0.88 -1.20l-0.18 -0.47l-0.02 -0.73l0.94 -1.04l0.66 -0.14l0.72 0.52zm2.16 -48.96l0.48 0.99l-0.70 1.14l0.85 1.58l0.44 -0.07l0.41 -0.99l0.48 -0.37l0.18 -0.48l0.59 -0.66l0.81 -0.37l2.51 1.18l-0.44 2.76l-0.67 0.40l-0.59 0.85l-0.52 0.04l-1.18 -0.55l-0.26 -0.59l-0.67 -0.66l-0.52 0.22l-0.26 0.48l-0.18 0.59l-0.11 1.69l-0.18 0.29l-0.33 0.00l-0.48 0.33l-0.52 -0.26l-0.44 0.00l-0.33 -0.15l-0.07 -0.40l0.18 -0.26l0.37 -0.04l0.81 -0.92l-0.30 -1.07l-0.26 -2.17l-0.19 -0.33l-0.41 0.26l-1.18 1.32l-0.26 1.07l-0.74 0.92l-0.04 0.29l-1.18 1.07l-0.41 0.18l-0.55 -0.11l-0.70 -1.62l-0.55 -0.22l-0.18 -0.33l0.00 -0.85l0.48 -1.84l1.00 -1.21l0.26 -0.51l0.33 -0.40l0.44 -0.04l0.74 0.44l0.37 -0.26l1.96 -0.59l0.63 0.70l0.44 -0.88l0.30 0.00l0.34 0.41zm-33.95 -41.37l0.42 0.06l2.03 -0.31l0.94 -0.82l0.30 0.00l0.32 0.22l0.00 0.42l-0.20 0.29l-0.59 0.02l-0.24 0.15l0.21 0.11l0.17 0.70l0.59 0.84l0.92 0.96l0.57 0.26l0.66 0.17l5.74 -0.78l0.19 0.11l0.58 1.19l0.32 0.13l0.35 -0.08l0.87 -0.72l0.48 0.02l1.83 0.74l0.00 0.00l-2.26 0.85l-0.26 -0.03l-0.52 0.60l-0.38 0.00l-0.13 0.65l-0.30 0.27l-0.42 -0.17l-0.49 -0.52l-0.48 -0.80l-0.85 0.14l-0.79 0.61l-1.11 0.29l-2.07 0.96l-1.45 0.00l-0.48 0.42l-1.33 -0.05l-0.89 -0.51l-0.35 0.41l-0.02 0.96l-0.52 0.10l-0.97 -0.38l-1.06 0.38l-0.35 0.34l-0.06 1.06l-0.32 0.17l0.26 0.43l0.58 0.32l0.49 0.78l1.07 0.34l0.69 0.03l0.17 1.46l-0.29 0.50l0.00 0.00l-1.37 -0.41l-1.73 0.44l-0.62 0.82l-2.00 -0.24l-1.53 0.35l-0.59 -0.19l-0.42 -0.45l-1.92 -0.58l-0.81 -0.52l-3.39 -0.19l-1.14 0.65l-1.68 0.58l-1.70 1.71l-2.12 3.10l0.35 0.33l-0.54 0.83l-0.20 2.11l-0.59 0.63l-0.49 -0.07l0.07 1.34l-0.46 1.00l-0.05 1.36l0.37 0.56l0.05 0.85l0.61 1.46l-0.27 0.85l-0.13 2.21l0.29 0.72l1.21 1.80l2.38 2.64l0.19 0.46l0.48 0.28l0.36 -0.03l0.76 -0.52l0.33 -0.07l0.58 0.43l0.23 0.56l1.10 0.11l1.44 2.34l-0.45 1.51l0.07 0.59l0.28 0.46l0.52 0.22l1.03 2.16l0.51 0.06l0.82 -0.43l0.25 -0.56l0.51 -0.22l0.68 0.01l0.00 0.72l0.20 0.34l0.51 0.18l1.18 -0.16l2.43 0.30l0.43 -0.29l0.95 -1.24l1.08 -2.17l2.22 -2.78l0.39 -0.12l0.29 -0.47l0.86 -0.67l0.66 -1.19l0.62 -0.35l1.15 -0.29l0.21 -0.93l0.50 -0.15l0.34 -0.02l0.33 0.29l-0.33 1.48l0.25 0.37l0.25 0.00l1.13 0.65l2.18 0.25l0.91 0.39l1.32 -0.88l0.75 -0.14l0.69 0.28l0.49 0.02l0.51 -0.51l0.39 -1.97l1.50 -0.58l0.97 0.43l2.68 -1.00l3.73 0.53l1.70 -0.01l2.61 -0.26l0.70 -0.36l-0.07 -0.26l-1.44 -0.51l-1.99 -0.20l-0.47 -0.30l0.03 -0.27l1.48 -0.63l1.52 -0.21l1.82 0.03l0.50 -0.15l0.35 -0.65l0.23 -0.01l2.66 0.11l1.54 0.59l1.69 0.91l0.75 1.92l-0.14 1.24l-0.79 0.92l-0.34 1.94l-0.50 0.68l-0.32 0.21l-1.15 -0.18l-0.39 -0.20l-1.26 -1.46l-0.33 -0.90l-1.46 -0.34l-4.31 0.63l-0.40 0.54l-0.11 0.72l-0.49 0.92l-1.30 1.42l-1.00 1.73l-1.18 0.94l-2.07 2.22l-1.12 1.42l-3.72 2.08l-2.62 0.34l-1.01 0.66l-2.00 0.39l-0.66 0.50l-0.97 2.39l-0.85 0.86l-0.48 0.26l-1.08 0.19l-1.11 -0.06l-0.33 -0.60l-1.27 -1.30l-1.95 -0.84l-0.51 0.26l-0.17 1.00l0.87 2.52l0.38 -0.30l1.08 -0.06l0.91 1.00l1.53 2.23l0.85 0.34l0.91 -0.16l0.78 0.23l2.11 2.17l2.27 3.87l0.78 2.54l2.03 1.65l3.05 2.14l0.02 0.68l-0.72 1.11l-0.02 0.37l1.91 1.71l0.25 0.15l0.55 -0.25l0.93 0.68l-1.09 1.29l-0.98 -0.27l-0.33 0.32l0.00 0.00l-0.12 -0.43l0.11 -0.20l-0.17 -0.15l-0.53 0.02l-0.42 -1.04l-0.55 0.10l-0.43 -0.61l-0.43 -0.18l0.11 -0.88l-0.16 -0.32l-1.08 -0.21l-0.51 -0.69l-0.43 -0.22l-1.05 0.05l-0.74 -0.14l-0.65 0.33l-1.98 -0.55l-2.65 -1.08l0.00 0.00l0.25 -0.76l0.41 -0.23l0.77 -1.49l0.27 -0.27l0.62 -0.17l-1.26 -2.55l-0.64 -0.50l-0.45 0.06l-0.67 -1.00l-0.83 -0.06l-0.62 -0.21l-1.27 -0.98l-0.68 -0.12l-0.86 0.07l-0.96 -0.58l-1.72 -0.29l-4.70 -2.00l-0.77 -0.10l-0.23 -0.21l-1.01 -0.15l-0.46 0.13l-0.08 0.33l-0.84 0.00l-0.76 -0.33l-1.30 -0.67l-1.13 -1.08l-1.47 -2.04l-0.17 -0.46l-1.27 -1.45l-0.29 0.12l0.00 0.42l-0.80 2.46l-1.34 -0.58l-1.80 0.00l-0.84 -0.38l-0.13 -0.58l-1.47 0.13l-0.33 -0.17l-0.92 0.92l-0.59 0.13l-0.34 0.33l-0.40 -0.54l0.00 0.00l-0.24 -0.89l0.36 -0.21l-0.15 -0.34l-0.05 -2.75l-0.31 0.11l-0.56 -0.24l-0.62 0.09l-0.40 -0.27l0.11 -0.54l0.33 -0.40l-0.44 -0.77l-0.39 -0.12l0.08 -0.63l-1.04 -0.98l-0.28 -0.85l0.55 -0.56l0.08 -0.27l-0.57 -0.55l-0.76 -0.44l-0.36 0.00l-0.57 0.46l-0.63 0.08l-0.38 -0.57l-0.35 0.06l-0.32 -0.21l-0.49 -0.63l0.00 -0.26l0.65 -0.08l0.57 -0.33l-0.11 -0.25l-0.55 0.20l0.19 -0.38l1.55 -0.19l0.19 -0.38l-0.05 -0.55l0.55 -1.21l-0.03 -0.50l-0.38 0.08l-0.09 -0.25l-0.15 -1.39l-0.26 -0.90l0.00 -0.94l0.22 -0.56l-0.11 -0.90l0.00 0.00l1.92 -1.56l0.15 -0.99l0.61 -0.58l0.31 -0.02l0.90 1.93l0.21 0.97l0.57 0.90l0.21 0.03l0.29 -0.53l0.07 -0.52l-0.30 -1.82l-0.82 -1.07l-0.84 -2.81l0.14 -2.57l0.16 0.00l0.15 -0.75l0.64 -1.65l-0.33 -1.19l-1.36 0.42l-0.32 -0.15l-0.71 -0.49l-0.98 -1.82l1.10 0.19l-0.08 -0.58l0.86 0.44l0.51 0.41l-0.05 0.41l0.51 0.34l0.20 0.53l0.71 0.17l0.68 -0.78l0.39 -1.00l-0.04 -1.63l-0.33 -0.61l-1.34 -1.38l-0.12 -0.37l0.42 -0.27l0.82 0.29l0.91 0.03l0.07 -0.26l-0.29 -0.97l-0.59 -0.71l-0.03 -0.23l0.52 -0.81l0.04 -0.65l0.44 -0.68l0.65 -0.42l0.95 -0.11l0.55 -0.40l0.14 -0.78l-0.36 -1.65l0.02 -0.51l0.19 -0.35l0.74 -0.62l0.75 0.00l1.75 -0.97l0.28 -0.50l0.04 -1.51l0.23 -0.72l0.62 -0.45l0.60 -0.01l0.32 0.21l0.08 0.50l-0.22 1.14l0.13 0.40l1.39 0.93l2.68 0.49l0.47 -1.17l0.13 -0.77l0.63 -1.02l0.70 -0.73l1.12 -0.39l0.82 -0.87l0.50 -2.27l-0.18 -1.40l0.20 -0.77l2.11 -0.32l2.48 0.31l0.84 0.34l1.74 1.10z"},ID_su:{name:"Sumatera Utara",path:"m55.60 131.31l0.42 0.04l0.71 0.82l0.52 0.91l0.04 0.51l-0.33 0.36l0.19 0.23l-0.15 0.80l0.11 0.46l-0.21 0.32l-0.25 0.09l0.36 0.76l-0.06 0.21l-0.21 0.11l-0.38 0.06l0.23 -0.63l-0.10 -0.13l-0.29 0.25l-0.33 -0.15l-0.23 0.08l-0.19 0.42l0.21 0.30l-0.10 0.25l-0.29 -0.40l-0.61 -0.42l-1.40 -0.48l0.59 -0.25l0.04 0.23l0.34 -0.02l0.21 -0.84l0.33 -0.23l-0.06 -1.16l0.21 -0.84l0.42 -0.36l0.44 -0.19l0.17 -0.42l-0.52 -0.72l0.17 0.03zm-0.54 -4.25l0.10 0.23l0.32 -0.23l0.00 0.49l1.11 1.29l0.11 0.57l-0.13 0.36l0.27 0.53l-0.04 0.32l0.98 0.72l0.42 0.55l-0.08 0.91l-0.38 0.02l-0.06 0.23l0.27 0.61l-0.11 0.19l-0.50 -1.18l-0.29 -0.23l-0.99 -1.58l-0.25 -0.11l0.00 -0.40l-1.11 -1.37l0.00 -0.15l-0.32 -0.95l-0.96 -0.47l0.99 -0.46l0.65 0.11zm3.91 -3.00l1.02 0.10l0.51 -0.13l0.29 0.32l1.26 -0.25l1.04 0.99l-0.13 0.43l0.09 0.13l-0.41 0.08l-0.20 -0.21l-0.62 -0.10l-0.53 0.42l-0.38 0.05l-0.42 -0.18l-0.87 0.13l-0.90 -0.34l-0.89 -0.01l-0.32 -0.21l-0.11 -0.67l0.79 -0.54l0.66 -0.11l0.12 0.10zm-18.92 -21.46l0.33 0.76l2.46 3.35l1.77 0.62l2.11 1.87l0.46 1.18l-0.70 1.61l-0.16 4.02l-0.28 0.50l-1.03 1.10l-1.93 -0.49l-0.34 -0.41l0.16 -0.31l-1.33 -3.39l-2.06 -2.14l-0.95 -0.05l-0.47 -0.21l-0.33 -0.97l-0.81 -1.55l-1.64 -2.70l-2.35 -2.29l0.75 -0.31l1.14 0.06l0.49 -0.13l1.39 -1.24l1.11 -0.23l1.49 0.54l0.72 0.81zm16.86 -4.05l0.68 0.12l0.30 -0.51l0.43 0.25l0.39 0.69l-0.69 0.12l-1.27 -0.09l-0.71 -0.26l-0.19 -0.49l0.48 -0.63l0.59 0.25l0.00 0.55l-0.01 0.00zm-35.75 -11.74l-1.73 -0.16l-0.31 -0.19l-0.30 -1.00l-4.10 -2.69l-3.14 -1.12l-1.02 -0.19l-2.02 -1.93l-0.18 -0.60l0.09 -0.29l1.62 -2.03l1.61 0.31l1.96 2.43l0.57 0.26l1.24 0.18l1.95 2.10l2.31 1.59l1.46 0.60l0.48 0.71l0.01 0.46l0.43 1.11l-0.93 0.45zm29.74 3.28l0.61 -2.79l-0.53 -1.62l-0.83 -0.35l0.06 -0.71l-0.41 -0.56l-0.18 -1.00l0.24 -1.41l0.62 -0.21l-0.03 -0.26l-0.50 -0.50l-0.15 -0.65l0.06 -0.38l0.33 -0.50l-0.24 -0.29l0.03 -0.26l-0.95 -0.12l-0.59 -1.06l-0.92 -0.24l0.00 -1.06l-0.27 -0.88l0.03 -0.53l-0.21 -0.26l0.18 -0.12l0.62 0.06l0.09 -0.97l-0.62 -0.65l-0.06 -0.74l-0.50 -0.50l-0.59 -0.12l-0.09 -0.18l2.37 -0.65l0.24 -0.79l-0.38 -0.71l-0.27 0.12l-0.65 -0.44l-0.03 -0.44l-0.27 -0.56l0.33 -0.53l-0.56 -0.41l-0.21 -0.88l-0.74 -0.35l0.03 -0.74l-0.27 -0.18l0.00 -0.32l-0.47 -0.50l-0.33 -0.82l0.44 -0.62l1.48 -1.18l0.12 -0.35l-0.41 -0.74l0.09 -0.32l0.18 -0.03l0.56 0.38l0.15 -0.27l-0.06 -0.38l1.21 -0.65l0.24 -1.33l0.21 -0.29l-0.03 -0.97l0.47 -0.68l-0.15 -0.47l0.41 -0.24l0.03 -0.38l-0.30 -0.53l0.09 -0.21l0.38 0.09l0.56 -0.12l0.27 -0.12l0.06 -0.32l0.77 -0.21l0.80 0.15l0.40 -0.14l0.00 0.00l0.10 2.71l0.77 1.04l1.19 -0.04l1.49 0.64l1.11 0.66l0.82 1.30l1.74 0.44l0.35 0.59l-0.10 0.53l0.23 0.83l2.14 1.41l2.23 0.73l1.77 0.98l3.96 2.50l1.18 1.06l1.21 0.47l0.92 0.65l0.72 1.28l0.36 0.35l0.52 0.31l1.36 0.41l1.86 1.05l2.36 2.36l1.38 1.10l0.13 0.33l0.10 2.19l-0.14 0.60l-0.58 0.79l0.04 0.44l1.14 1.28l-0.27 0.26l0.51 -0.15l-0.31 -0.75l0.24 -0.46l-0.53 -0.40l-0.38 0.04l-0.03 -0.14l0.94 -0.63l0.40 0.07l0.71 0.77l-0.07 1.39l0.73 1.70l0.13 -0.02l-0.40 -1.63l0.00 -0.73l0.30 -0.53l0.59 -0.35l0.62 0.02l0.72 0.90l0.65 1.27l0.54 0.52l0.22 0.56l-0.40 1.27l0.12 2.00l0.71 1.57l0.16 0.94l-0.51 1.72l-0.24 2.98l-0.47 1.25l0.00 0.39l0.28 0.31l1.89 0.35l0.24 0.78l-0.32 0.27l-0.04 0.43l0.59 0.12l0.08 0.31l-0.12 0.39l0.16 0.31l-0.08 0.47l-0.43 0.71l-0.08 0.39l0.24 0.24l-0.12 0.47l-0.83 0.71l-0.79 0.00l-0.04 0.39l-0.28 0.16l-0.59 -0.12l-0.47 0.12l0.00 0.35l-3.00 0.16l-0.39 0.27l0.04 0.39l0.24 0.24l0.24 -0.04l0.51 0.94l0.20 1.59l0.28 0.51l0.59 0.43l0.08 0.31l-0.63 0.08l-0.55 0.31l-0.04 0.43l0.39 0.16l0.35 1.02l-0.16 0.63l-0.24 0.27l-0.75 0.04l0.00 0.23l0.43 0.47l0.43 -0.04l-0.12 0.43l0.12 0.71l-0.28 0.20l0.51 0.74l0.55 0.43l-2.13 -0.71l-0.28 -0.35l-1.30 -0.47l-0.32 -0.71l-0.67 0.12l-0.39 -0.35l-0.28 -0.04l-0.59 0.35l0.08 2.08l-0.28 0.31l0.00 0.31l0.28 0.78l0.63 0.00l0.63 0.24l0.08 1.17l0.67 0.51l0.00 0.67l-0.67 0.82l-0.51 0.31l-0.71 0.12l-0.63 -0.04l-0.12 -0.20l-0.51 -0.12l-0.28 0.04l-0.83 0.43l-0.63 -0.47l-0.08 -0.39l-0.51 -0.67l-1.46 0.51l-1.06 -0.43l-1.22 0.78l-0.47 0.12l-0.87 1.61l-0.63 0.78l-0.79 0.08l-0.75 0.35l-0.93 1.39l-0.20 -0.06l-0.26 -0.21l0.32 -0.15l0.00 -0.87l-0.79 -0.48l0.42 -1.16l-0.58 -2.95l-1.17 -3.28l-1.23 -2.78l-2.17 -6.42l-1.33 -3.04l-0.83 -1.06l0.01 -0.33l0.19 0.01l0.45 0.48l0.19 0.08l0.19 -0.16l0.85 -1.33l0.02 -0.83l-0.92 -1.36l-0.76 -0.62l-0.26 0.04l-0.23 0.27l0.50 0.15l0.21 0.68l-0.41 0.03l-0.74 -0.47l-2.04 -2.76l-0.56 -0.51l-1.45 -0.92l-3.43 -1.71l-1.55 -1.11z"},ID_yo:{name:"Yogyakarta",path:"m270.33 268.51l-2.04 -0.09l-5.85 -2.13l-0.41 -0.33l-0.25 -0.48l-1.97 -0.62l-2.48 -1.28l-1.29 -0.48l0.00 0.00l0.58 0.03l0.31 -1.28l0.40 -0.24l0.20 -0.42l0.26 -0.10l0.34 -0.51l0.12 -0.88l-0.32 -0.28l0.18 -0.43l0.61 -0.16l1.26 0.13l0.29 -0.12l0.20 0.17l-0.03 0.59l0.26 0.14l0.57 -0.77l2.39 -1.88l0.81 3.89l0.32 0.06l0.43 0.40l0.36 -0.23l0.23 0.09l0.21 0.34l1.10 -0.23l0.14 0.14l0.24 -0.23l0.19 0.33l0.41 -0.05l0.17 -0.22l0.32 0.13l0.37 0.46l0.24 -0.27l0.29 0.17l-0.05 0.89l-0.29 0.84l0.02 1.10l-0.23 0.55l0.57 1.61l-0.05 0.75l0.23 0.18l0.32 -0.38l0.22 0.01l-0.24 0.61l0.08 0.11l0.18 -0.18l0.12 0.05l-0.04 0.50z"},tl:{name:"Timor Leste",path:"m506.32 285.46l0.03 0.31l-0.19 0.24l-0.04 0.59l-0.20 0.43l0.12 0.56l-0.30 0.15l-0.14 0.43l-0.49 0.07l-0.31 0.40l-0.17 -0.02l-0.11 0.30l0.12 0.25l-0.55 0.68l0.22 0.45l-0.23 0.50l-1.21 0.28l0.14 -0.86l-0.25 -0.61l-0.83 -0.81l-0.21 -0.04l-0.70 0.42l-0.20 0.48l-0.41 0.11l-0.26 -0.32l-0.46 0.02l-0.88 -1.19l0.00 0.00l1.84 -0.67l0.56 -0.70l1.86 -0.70l3.25 -0.75zm48.01 -12.17l-2.76 2.21l-1.31 1.34l-3.94 1.30l-2.31 0.34l-1.29 0.62l-0.72 0.70l-0.34 0.84l-0.80 0.89l-2.60 0.43l-2.96 0.26l-3.63 2.38l-1.70 0.07l-1.08 0.28l-6.72 2.18l-1.12 0.66l-2.05 1.97l-1.42 0.21l-0.69 0.46l0.00 0.00l-0.16 -1.19l-0.48 -0.56l-0.04 -0.58l-0.97 -0.67l-0.26 -1.08l0.05 -0.39l0.28 -0.57l1.04 -0.02l0.72 0.56l0.03 -0.14l0.64 -0.38l0.69 -0.08l-0.15 -0.75l0.26 -0.89l-0.02 -0.85l-0.61 -0.51l-0.26 -0.05l-0.41 -0.45l-0.28 0.63l-0.32 0.34l-0.61 0.17l-0.67 0.52l-0.45 0.01l-0.51 -0.25l-0.23 -0.36l0.01 -0.52l0.30 -0.63l-0.20 -0.08l0.00 0.00l0.55 -0.40l2.12 -3.05l0.28 -1.37l0.62 -0.80l1.46 -0.43l3.37 -0.66l4.92 -0.72l2.35 -0.85l1.62 0.11l0.84 0.22l0.61 0.34l0.95 0.07l2.69 -0.44l0.93 -0.38l1.23 -0.85l0.93 -0.06l1.61 0.48l0.64 0.54l0.39 0.04l3.60 -1.08l2.20 -1.11l1.84 -0.62l3.35 0.15l1.81 1.11l0.02 0.64l-0.88 0.75z"},my_sb:{name:"Sabah Malaysia",path:"m384.46 12.92l-0.36 0.04l-1.07 -0.26l-0.27 -0.31l0.13 -0.24l0.97 -0.08l0.68 -0.27l0.12 -0.23l-0.10 -0.21l-0.61 -0.08l-0.06 -0.24l0.18 -0.18l0.99 -0.25l0.42 0.30l0.40 0.67l-0.04 0.47l-0.21 0.26l-1.17 0.61l0.00 0.00zm-11.24 0.77l0.28 0.13l0.42 -0.06l0.66 -0.28l3.21 -3.97l0.11 -0.31l-0.43 -1.17l0.02 -0.42l0.65 -0.77l0.36 -0.24l0.96 -0.15l0.57 0.19l1.23 0.78l0.06 0.98l-0.13 0.46l0.14 1.62l0.60 2.21l3.09 1.74l1.59 0.03l1.55 0.40l0.49 0.40l0.83 1.18l0.26 0.63l-0.29 2.25l-0.22 0.13l-0.66 -0.10l-0.51 0.20l-0.51 0.40l-0.21 0.48l0.03 0.25l1.05 1.54l0.21 1.84l-0.78 0.73l-2.20 0.76l4.83 -0.33l1.81 -0.65l1.73 -1.79l0.35 -0.09l0.72 0.72l1.32 2.69l-0.77 0.93l-0.69 0.12l-1.89 -0.18l-0.40 0.28l0.17 0.74l0.65 1.21l2.94 -0.08l0.53 -1.68l0.35 -0.29l1.42 -0.41l1.99 0.35l1.75 0.85l1.80 1.20l1.21 0.88l0.75 0.80l4.20 2.79l2.34 0.44l0.56 -0.15l0.50 -0.39l1.01 -0.13l0.85 0.69l0.64 1.01l-0.06 2.09l-0.84 1.29l-0.91 0.63l-1.75 0.73l-2.71 0.73l-3.66 1.46l-2.63 -0.27l-1.78 -0.70l-0.58 -0.54l-1.02 -0.09l-2.54 1.28l-1.16 1.27l-0.14 0.60l2.59 2.98l2.33 1.51l0.22 -0.31l0.18 -0.03l0.77 0.35l0.03 0.48l-0.34 0.46l0.73 0.65l0.60 -0.43l0.88 0.07l0.87 1.44l-0.26 0.39l-1.39 1.11l-2.49 0.05l-3.82 0.71l-1.01 0.30l-2.23 1.14l-1.56 -0.38l-0.74 -0.71l-2.94 -1.51l-1.10 0.36l0.39 1.49l-0.88 1.16l-0.15 0.50l0.00 0.00l-0.24 -0.17l-0.89 0.26l-1.21 -0.34l-0.24 -0.15l-0.40 -0.86l-3.02 -2.15l-0.53 0.21l-0.09 0.19l-0.64 0.16l-0.59 -0.11l-0.65 0.17l-1.11 -0.15l-0.34 0.39l-0.28 -0.30l-0.65 -0.06l-0.29 -0.23l-0.73 -0.18l-0.53 0.41l-0.69 0.20l-0.49 -0.28l-0.26 0.11l-0.38 -0.48l-0.41 -0.25l-0.26 0.50l-0.28 0.16l-0.31 0.10l-0.53 -0.16l-0.77 0.24l-0.25 -0.61l-0.38 -0.12l-0.41 -0.45l-0.54 0.67l0.05 0.62l-0.47 0.08l-0.37 -0.16l-0.23 0.54l-0.55 0.14l-0.19 -0.63l-1.17 -0.97l-1.52 0.35l-0.30 -0.18l-1.41 -0.21l-0.15 0.11l-0.13 0.64l-0.85 0.33l-0.39 0.76l-0.20 0.13l-0.65 -0.50l-0.11 -0.49l-0.27 -0.20l-1.51 -0.30l-0.33 -0.57l-0.53 0.19l-0.12 1.04l0.14 0.42l-0.72 0.60l-0.13 0.57l-0.41 0.11l-0.14 -0.33l-0.40 -0.06l-0.79 0.91l-0.37 -0.03l-0.33 0.67l-0.04 0.93l0.00 0.00l0.00 0.03l0.00 0.00l-0.34 -0.07l-0.55 -0.43l-0.31 -0.74l0.43 -1.10l0.00 -5.70l-0.62 -3.49l-0.49 -4.11l-1.71 -0.26l0.00 0.00l0.88 -0.36l0.50 -0.46l0.28 -1.91l-0.26 -0.40l-0.51 0.04l-0.77 -0.35l-2.17 -1.53l0.36 -1.58l2.56 -2.01l4.05 -0.05l0.95 -0.24l0.54 -0.52l0.80 -1.40l0.41 -1.77l2.29 -1.61l0.04 -1.03l0.64 -1.34l0.34 -2.59l3.78 -4.07l2.98 -2.25l0.11 -0.88l2.36 -2.71l-0.01 -1.25l0.24 -1.27l1.02 -2.10l0.66 -0.87l0.21 -0.09l1.14 1.00l0.12 0.28l0.34 2.52l-0.14 0.80l-0.72 0.93l-0.50 1.03l-0.07 0.73l0.12 0.30zm8.64 -12.73l-0.11 1.40l-0.45 1.03l-1.75 0.18l-0.89 0.54l-0.33 0.56l-0.22 0.00l-0.25 -1.14l0.18 -1.75l0.14 -0.21l1.29 -0.87l1.34 -0.32l0.80 0.15l0.25 0.43zm-7.06 1.69l-0.31 0.66l-0.08 -0.08l0.46 -1.49l2.11 -1.36l0.29 0.77l0.01 0.72l-1.04 0.43l-1.44 0.35z"},my_sr:{name:"Serawak Malaysia",path:"m280.29 86.23l-0.75 0.29l-0.30 -0.21l-0.81 -1.34l0.14 -0.81l-0.32 -4.06l0.18 -0.59l0.44 -0.22l0.44 0.35l0.47 1.06l-0.08 3.49l0.59 2.04zm70.35 -45.54l1.71 0.26l0.49 4.11l0.62 3.49l0.00 5.70l-0.43 1.10l0.31 0.74l0.55 0.43l0.34 0.07l0.00 0.00l-0.01 0.13l0.00 0.00l-0.67 2.08l-0.45 0.41l-0.85 0.23l0.13 0.31l0.78 0.56l0.05 0.18l-0.04 0.56l-0.52 1.04l-0.14 0.71l-0.05 1.55l0.16 0.86l0.38 0.47l0.13 1.10l0.58 1.01l-0.40 0.58l-0.40 -0.63l-0.34 -0.02l-0.63 1.26l-0.42 2.81l0.05 0.18l0.71 0.52l0.00 0.20l-0.81 0.67l-0.13 0.25l0.00 0.84l-0.18 0.34l-1.03 0.14l-0.81 0.77l-1.23 0.09l-0.04 -0.41l-0.61 -0.65l-0.34 0.83l-1.59 1.06l-0.25 1.06l-0.96 0.77l0.04 0.18l0.51 0.13l0.18 0.27l-0.18 0.34l0.00 0.43l-0.60 0.52l0.00 0.38l0.23 0.14l0.00 0.49l-0.09 0.41l-0.31 0.38l0.31 0.47l0.99 -0.31l0.67 0.79l0.11 0.34l0.47 0.34l-0.07 0.31l-0.60 0.50l-0.78 -0.02l-0.58 0.18l-0.45 0.41l-0.20 0.59l-0.67 0.00l-0.51 0.59l-0.43 0.23l-0.67 -0.11l-0.31 0.63l0.33 0.43l-0.04 0.23l-0.78 0.49l-1.84 0.20l-0.34 1.31l0.02 0.82l0.16 0.29l0.35 0.19l-0.16 0.96l0.20 0.45l0.76 -0.34l0.51 0.25l0.02 0.22l-0.69 0.52l-0.05 0.23l0.40 0.81l-0.36 0.34l-0.67 0.11l-0.45 0.64l-0.54 -0.25l-0.56 0.16l0.07 0.27l-0.49 0.66l0.13 0.13l0.11 1.19l-0.13 0.99l-0.38 0.31l-0.52 0.92l-0.80 0.47l-0.12 0.75l0.18 0.30l-0.49 0.81l0.00 0.00l-0.21 0.42l-0.39 0.12l-2.58 -1.51l-0.58 0.54l-1.58 0.66l-0.70 0.09l-0.24 0.45l0.00 0.00l-0.34 0.14l0.00 0.00l-0.20 -0.28l-0.97 -0.65l-3.05 0.32l-0.40 0.45l-1.92 0.79l-0.07 0.17l0.13 0.20l-0.28 0.84l-1.90 0.77l-0.38 0.45l-0.35 0.22l-0.30 0.00l-0.32 -0.10l-0.75 -1.34l-0.67 -0.30l-0.82 0.05l-0.57 0.22l-0.33 0.30l-0.40 -0.02l-0.30 -0.37l-0.60 -0.37l-0.17 -0.35l-0.72 -0.50l-0.77 -0.20l-1.60 0.15l-0.75 -0.22l-0.38 -0.67l-0.37 -0.05l-1.35 0.45l-0.75 -0.07l0.15 -0.45l0.30 -0.30l0.50 -0.17l0.50 -0.99l0.17 -0.05l-0.13 -0.40l-0.52 -0.30l-0.63 -0.12l-0.92 0.07l-0.82 -0.22l-0.20 0.05l-0.35 0.47l-0.57 0.30l-0.35 -0.02l-0.55 -0.40l-1.65 0.12l-2.90 -0.37l-1.02 0.37l-0.08 0.30l-0.55 0.27l-1.57 0.35l-1.27 0.79l-0.42 0.00l-0.50 0.55l0.42 0.65l-0.05 0.65l-0.85 0.84l-0.15 1.49l-0.25 0.60l0.03 0.65l-3.22 0.22l-1.35 1.39l-0.32 0.77l-1.70 -0.35l-0.58 0.17l-1.00 -0.52l-0.27 0.02l-1.13 0.82l-0.52 0.07l-0.10 0.52l-0.23 0.02l-0.70 -1.17l-0.77 -0.12l-0.70 0.30l-0.50 0.02l-0.50 -0.32l-1.75 -0.57l-0.32 -0.30l-1.95 0.57l-3.85 0.50l-0.27 0.60l-0.63 0.55l-0.72 0.12l-0.95 0.55l-0.77 0.25l-0.38 0.32l-0.45 0.02l-0.45 -0.45l-0.40 0.67l-0.55 0.12l-0.73 -0.07l-1.20 -0.42l-0.35 -0.27l-0.90 -1.37l-0.97 -0.25l-0.98 0.00l-0.32 -0.97l-0.42 -0.72l-0.48 -0.40l-0.15 -0.52l-0.45 -0.67l-0.73 -0.15l-0.60 0.07l-0.43 -0.35l-0.35 -0.87l-1.49 -0.74l-0.17 -1.39l-0.25 -0.30l-0.50 -0.20l-1.27 -0.05l-0.83 -1.29l-0.35 -0.15l-1.82 -1.81l-0.30 -0.65l0.42 -2.14l-0.15 -0.35l-1.20 -0.30l-0.40 -0.62l-0.45 -0.32l-0.25 -0.59l0.05 -0.47l0.60 -0.07l0.30 -0.75l0.38 -0.22l0.50 -1.38l0.00 0.00l0.15 1.18l-0.07 1.14l0.34 0.66l0.67 0.80l3.27 2.23l0.49 0.54l0.93 0.14l4.69 -0.40l1.11 -1.52l0.23 -0.13l0.20 0.07l2.34 2.65l0.05 0.33l3.85 1.16l0.53 0.29l0.12 0.32l-0.10 0.33l-1.02 0.89l0.20 0.10l0.81 -0.14l0.49 -0.46l0.21 -1.43l0.82 -0.09l2.67 1.23l1.50 1.57l1.60 0.71l2.84 0.53l1.02 -0.22l-1.58 -1.15l-0.78 -0.05l-0.93 0.34l-0.49 -0.06l-1.76 -1.07l-0.78 -1.23l-0.22 -0.67l0.50 -1.62l0.61 -0.28l1.88 -4.57l0.56 -2.04l0.59 -0.83l0.27 -0.15l1.21 0.31l0.42 -0.23l0.37 -0.47l0.03 -0.20l-0.29 -0.08l-2.82 0.38l-0.33 -0.08l0.18 -2.00l0.49 -2.35l0.25 -0.41l0.33 -0.12l1.23 0.72l0.91 0.83l0.45 -0.29l0.97 -0.21l-0.82 -1.93l0.58 -3.30l0.20 -0.38l3.81 -2.63l2.68 -0.44l2.19 -0.12l2.47 -0.43l13.35 -3.37l1.53 -0.48l0.99 -0.54l0.55 -0.52l0.70 -1.07l3.33 -4.02l2.42 -3.54l1.78 -2.00l2.63 -2.14l1.14 -1.11l3.30 -4.26l0.66 -1.33l0.52 -2.04l-0.05 -0.78l-0.50 -1.46l0.07 -0.22l0.53 -0.29l2.04 0.12l0.00 0.00l1.91 0.72l1.54 2.08l0.25 1.72l1.11 1.23l2.52 2.14l1.23 1.41l0.06 0.37l0.25 0.25l0.55 -0.06l1.29 -0.73l1.23 -1.35l0.98 -3.49l-0.06 -1.16l-0.31 -0.31l-0.98 -4.84l0.06 -0.43l1.11 -1.10l1.60 -0.18l0.49 -0.18l0.37 -0.31l0.45 -0.85l0.00 0.00l0.22 1.31l0.00 0.00l-0.24 0.71l0.18 2.15l0.43 1.23l0.74 3.31l2.03 0.73l2.15 0.49l0.31 -0.12l-0.12 -0.92l-1.05 -0.80l-0.25 -0.37l-0.12 -0.74l0.00 -1.41l0.18 -0.49l-0.06 -0.74l-0.98 -3.06l-1.21 -1.58l0.00 0.00l1.25 -0.91l1.14 0.56l0.72 0.55l0.50 -0.10l0.62 -0.45l1.48 -1.70l0.00 -0.00z"},bn:{name:"Brunei Darussalam",path:"m404.57 47.29l-0.48 0.67l-0.67 -0.01l-3.11 -1.24l2.23 -0.30l2.03 0.88zm-59.64 -4.60l1.21 1.58l0.98 3.06l0.06 0.74l-0.18 0.49l0.12 2.15l0.25 0.37l1.05 0.80l0.12 0.92l-0.31 0.12l-2.15 -0.49l-2.03 -0.73l-0.74 -3.31l-0.43 -1.23l-0.18 -2.15l0.24 -0.71l0.00 0.00l0.29 0.24l0.20 -0.08l1.09 -0.80l0.41 -0.97zm-2.74 0.01l-0.13 0.26l0.63 -0.10l0.03 0.14l0.00 0.00l-0.45 0.85l-0.37 0.31l-0.49 0.18l-1.60 0.18l-1.11 1.10l-0.06 0.43l0.98 4.84l0.31 0.31l0.06 1.16l-0.98 3.49l-1.23 1.35l-1.29 0.73l-0.55 0.06l-0.25 -0.25l-0.06 -0.36l-1.23 -1.41l-2.52 -2.14l-1.11 -1.23l-0.25 -1.72l-1.54 -2.08l-1.91 -0.72l0.00 0.00l1.10 -0.01l0.40 0.19l1.69 -0.24l3.80 -1.65l0.43 -0.28l2.10 -2.16l1.22 -0.92l3.06 -1.91l2.19 -0.88l0.50 -0.10l0.50 0.10l0.10 0.15l-1.97 2.33z"}},height:335.58228316462225,projection:{type:"merc",centralMeridian:0},width:793})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","kr_mill",{insets:[{width:900,top:0,height:768.6419862721414,bbox:[{y:-4526919.37102057,x:13878960.292553546},{y:-3837401.697180795,x:14686313.933831325}],left:0}],paths:{"KR-31":{path:"M577.98,471.89l-3.83,-1.4l-2.55,-2.34l-0.96,-4.03l-2.9,-2.09l-6.33,-3.23l-5.38,-5.69l-3.39,-2.34l-7.45,-1.06l-1.66,-3.12l3.0,-5.61l-0.46,-5.62l2.79,-2.09l3.08,-1.67l2.15,-0.24l0.77,-1.8l-1.17,-1.78l-0.57,-1.65l3.89,-2.79l5.16,-1.67l4.2,-0.59l4.11,0.8l4.22,1.68l1.01,1.54l0.37,3.93l1.84,1.35l2.24,0.51l11.47,-1.92l9.79,2.21l0.77,1.24l-1.54,11.99l-1.21,2.23l-1.96,2.45l-1.39,0.69l-1.39,-5.25l-1.66,-2.56l-1.97,-0.58l-0.47,0.25l-1.03,2.76l0.29,0.53l1.56,0.33l0.87,1.02l0.55,3.51l-0.47,1.63l-2.64,0.58l-1.11,1.28l0.82,6.18l-2.13,3.35l0.02,0.45l1.77,2.05l-0.13,1.45l-2.37,0.73l-2.4,1.34l-3.41,3.11l-2.81,-0.06Z",name:"Ulsan"},"KR-49":{path:"M274.13,718.72l1.37,1.93l1.92,1.43l6.01,2.25l1.68,1.6l1.19,4.06l1.26,1.75l0.62,0.03l1.38,-1.27l0.48,0.92l-1.59,0.74l-0.86,0.96l-0.04,1.11l0.79,1.37l0.0,0.53l-1.63,2.33l-2.18,2.36l-4.31,3.27l-3.16,5.66l-0.14,1.34l-0.7,1.54l-2.84,0.31l-1.22,0.57l-3.42,-0.18l-4.68,3.46l-12.45,2.14l-4.3,3.36l-4.99,1.04l-5.55,-0.51l-6.2,1.08l-5.25,-1.46l-11.95,0.19l-3.68,1.61l-2.28,3.64l-1.7,0.33l-1.78,-0.8l-2.76,-4.19l-3.89,-1.33l-3.51,-3.44l-1.21,-4.13l2.15,-5.5l2.05,-3.43l1.22,-1.16l4.27,-2.37l3.75,-5.99l3.49,-0.99l1.49,-3.01l5.64,-1.82l12.66,-3.39l3.23,-2.56l11.99,-1.17l8.23,-3.34l2.01,0.5l10.02,-1.51l5.76,-0.45l3.64,0.57Z",name:"Jeju"},"KR-48":{path:"M396.51,522.53l-0.21,-3.05l-1.75,-3.94l-7.69,-7.78l-2.46,-5.62l-2.77,-2.7l-3.04,-2.06l-1.59,-2.64l-0.54,-7.49l-1.24,-3.61l-2.5,-2.78l0.6,-2.75l2.64,-2.65l0.18,-3.45l0.79,-3.64l5.11,-5.67l0.84,-4.06l-0.18,-0.42l-1.68,-1.04l-1.18,-2.47l0.18,-3.68l-1.35,-3.28l-0.7,-3.35l-3.16,-1.4l0.11,-3.18l1.72,-3.29l1.06,-4.38l1.43,-4.21l3.48,-6.49l0.39,-4.44l1.33,-3.55l5.46,-4.88l2.36,-4.68l1.01,-0.6l1.71,0.14l3.05,-0.87l6.24,-3.06l1.37,-3.11l4.02,-3.99l0.8,2.52l4.81,3.14l0.12,1.07l0.71,1.35l2.14,0.77l3.64,0.26l3.77,2.53l7.05,0.23l3.05,0.95l2.25,2.27l1.63,2.86l2.79,1.88l1.22,2.61l1.86,1.07l1.5,1.64l-0.07,3.09l-1.47,3.4l1.95,6.53l0.37,0.29l7.66,0.3l3.76,-0.48l3.47,0.54l3.28,1.46l3.15,2.19l3.68,0.72l6.77,-3.14l3.67,0.46l3.03,-4.0l2.27,-1.63l0.94,7.15l3.33,3.83l4.13,2.33l9.08,-1.23l3.93,1.12l4.01,1.91l4.88,0.05l3.99,-2.93l3.64,-0.88l1.71,-1.37l1.41,-1.68l4.28,-1.63l4.62,1.06l3.62,1.58l3.29,-0.92l0.47,5.0l-3.05,5.69l1.86,3.86l7.85,1.28l3.11,2.19l5.45,5.74l6.36,3.25l2.7,1.95l0.8,3.76l2.83,2.7l3.84,1.41l-0.52,1.7l-0.21,2.51l-1.5,2.38l0.66,2.86l-3.31,6.4l-2.17,2.43l-1.13,2.16l-4.74,-5.05l-2.79,-2.1l-2.13,-2.75l-0.86,-3.26l-2.63,-1.5l-3.3,-0.09l-3.01,1.13l-2.36,1.59l-1.85,2.11l-1.37,8.43l-4.41,5.97l-0.81,-0.12l-4.83,7.59l-1.1,0.07l0.02,-5.1l-0.35,-0.41l-0.83,-0.11l-0.41,0.22l-1.08,2.23l-0.82,3.11l-2.78,-0.29l-7.84,0.12l-0.41,-2.25l-0.88,-1.51l-0.73,0.1l-1.08,3.73l-0.92,0.41l-2.61,-1.09l-1.59,-2.44l-1.76,-0.09l-1.28,0.91l0.0,-5.38l-0.63,-0.79l-1.67,0.46l-0.9,1.29l-0.12,1.64l-1.31,-0.95l-1.58,-2.09l-1.7,-1.28l-2.14,0.6l0.33,-1.48l-0.97,-2.67l0.43,-1.19l-1.24,-3.7l-0.92,-0.61l-0.45,0.05l-1.5,1.28l-1.55,2.26l-0.06,1.92l1.55,3.01l1.4,5.04l3.14,4.32l0.26,1.11l-0.55,1.77l0.33,0.52l2.43,0.72l-1.22,0.39l-3.52,-0.23l-0.76,-2.4l-2.16,-1.96l-6.82,-2.25l-1.98,-0.13l-4.21,0.73l-1.22,0.55l-0.15,1.39l1.12,1.57l-1.76,0.34l-4.22,1.98l-5.12,1.48l-0.64,1.78l-0.25,1.88l-1.34,1.46l0.0,0.96l0.58,0.36l12.32,-6.08l1.66,-0.1l1.34,5.41l-0.88,1.64l-1.42,0.74l-2.32,0.36l-2.32,-0.1l-1.55,-0.59l-0.48,0.16l-0.84,1.37l0.62,1.13l1.15,0.65l0.83,1.67l-0.12,3.9l-0.8,6.09l1.53,1.09l1.29,-0.48l1.12,-1.95l0.99,1.08l-1.56,2.6l-3.03,3.68l-2.59,0.72l-3.28,-0.2l0.04,-1.38l3.09,-0.2l0.88,-1.12l-0.29,-0.62l-7.66,-0.8l-1.45,-0.54l-1.65,-2.14l-0.17,-0.78l3.82,-1.59l0.22,-0.57l-2.82,-5.26l-0.62,-0.11l-2.03,1.86l-2.01,3.57l-2.45,0.15l-2.61,-3.21l-1.54,-0.87l-3.05,-0.22l-1.42,0.9l-0.69,1.7l-0.24,3.92l-2.23,-0.34l-5.66,0.24l-2.04,-1.06l-0.23,-2.63l-0.43,-0.84l-2.04,0.08l-4.61,-0.6l-0.84,-0.43l-0.47,-0.91l0.57,-3.03l-0.2,-10.39l0.19,-1.59l1.55,-3.24l0.15,-1.72l-0.24,-0.4l-0.46,0.1l-1.94,2.16l-1.61,2.53l-1.83,1.76l-2.84,0.23l-0.33,0.56l2.13,4.66l-1.15,0.72l-3.46,-0.01l-2.81,1.65l-1.95,-4.37l-1.51,-1.13l-0.63,0.29l-0.36,4.48l-1.28,3.43l-2.42,2.01l-3.1,0.26l-2.6,-0.76l-0.98,0.1l-0.73,0.54l-1.59,-1.22l-1.27,-0.35ZM523.48,517.37l-0.32,-0.21l-0.6,-2.42l-1.25,-1.6l0.11,-1.07l-1.02,-2.19l0.23,-0.69l1.1,-0.58l1.27,-0.12l1.0,0.28l0.73,1.52l-0.06,3.43l-0.52,2.78l-0.68,0.87ZM509.94,523.37l1.28,2.62l-0.03,1.71l-2.43,6.36l0.49,0.53l3.61,-1.48l-0.03,3.73l-0.51,1.62l-0.83,0.74l-1.46,-0.57l-0.52,0.51l2.28,5.05l0.27,1.79l-0.51,0.19l-2.01,-0.65l-3.68,-2.05l-0.62,0.26l-0.72,2.89l-2.1,2.27l-0.78,1.95l0.14,0.47l1.48,1.05l2.05,0.81l0.67,0.7l-1.54,1.26l-8.87,2.56l-1.2,0.08l3.02,-2.04l-0.06,-0.7l-1.63,-0.72l-0.55,-1.02l0.09,-1.51l0.61,-2.01l-0.55,-0.48l-3.65,1.74l-0.84,-0.54l-0.49,-1.41l0.06,-1.38l0.58,-0.54l3.25,-0.76l0.93,-1.73l0.06,-2.14l0.65,-2.43l-0.19,-0.45l-1.7,-0.96l-0.5,0.09l-1.21,1.39l-4.37,1.8l-1.73,1.3l-4.34,-5.46l-0.35,-2.46l0.71,-1.43l1.55,-1.41l1.83,-1.11l1.55,-0.61l4.57,-0.88l1.16,0.02l1.94,0.76l3.31,1.75l2.44,0.18l0.43,-0.4l-0.19,-1.22l-2.22,-1.36l-1.23,-1.96l-0.66,-4.03l1.4,0.09l8.7,-4.6l0.16,-0.55l-1.4,-2.44l0.62,-2.27l1.63,-1.21l1.83,0.67l0.44,0.94l-0.77,6.51l0.66,2.58ZM467.27,542.06l1.22,0.43l3.01,-0.87l1.97,-0.12l0.99,0.9l0.28,1.52l-0.58,1.0l0.32,0.88l-0.22,0.35l-1.28,-0.33l-0.69,0.67l0.36,0.71l0.92,0.17l0.66,0.51l-1.43,1.82l-1.68,0.02l-1.21,-1.93l-0.89,-0.26l0.1,-0.68l-0.34,-0.92l-1.88,-0.51l0.91,-0.8l0.07,-1.47l-1.32,-0.94l-2.24,-0.72l-1.59,0.39l-0.49,-0.02l-0.12,-0.42l0.75,-0.77l1.23,-0.29l1.75,0.66l1.42,1.01ZM453.72,568.48l0.93,0.45l2.23,-0.96l-1.59,1.87l-2.86,-0.02l-2.35,1.25l0.37,-0.78l-0.09,-0.97l-1.54,-1.12l0.03,-0.39l0.38,-1.33l0.9,-0.41l3.58,1.78l0.01,0.62ZM450.01,544.82l-1.67,-0.43l-1.28,-0.83l-0.64,-0.89l0.87,-1.68l1.46,-1.03l1.28,0.27l2.28,2.65l-0.23,0.36l-1.12,0.0l-0.8,0.35l-0.15,1.22ZM421.71,535.28l0.84,0.72l0.58,-0.17l2.06,-3.47l0.7,-0.11l0.36,0.84l1.16,0.84l0.97,3.87l1.63,1.9l-0.64,0.15l-5.52,-1.35l-3.2,0.9l-1.64,-0.18l-1.68,-0.95l-0.95,-1.74l0.76,-1.93l3.79,-5.17l1.51,-0.38l0.45,1.09l-1.26,3.71l0.11,1.44ZM413.96,541.82l1.42,2.36l0.41,0.19l2.4,-0.39l3.09,-1.12l2.78,-0.55l4.72,0.86l0.52,1.3l-1.39,4.63l0.24,4.46l-1.49,1.06l-0.19,0.49l1.0,2.71l-0.39,1.07l-1.54,0.27l-3.7,-1.77l-2.56,0.97l-1.67,0.21l-1.1,-2.42l-1.39,-5.63l-2.25,-1.29l-2.17,1.23l-1.1,2.36l-0.44,2.96l-0.6,0.98l-1.47,0.04l-1.75,-0.56l-1.01,-0.62l-0.68,-1.11l-0.49,-4.03l-3.42,-10.34l-0.44,-2.41l0.31,-2.33l1.34,-2.38l2.58,-1.22l0.75,-3.27l0.63,-0.77l3.38,-2.05l1.66,0.47l1.52,1.26l0.86,1.58l-0.15,1.63l-1.02,1.64l-2.75,2.68l0.97,3.81l0.87,1.52l1.16,0.73l2.51,0.78Z",name:"South Gyeongsang"},"KR-45":{path:"M226.49,464.21l-1.49,-1.57l-0.53,-1.31l0.86,-3.16l5.47,-11.35l2.74,-3.65l3.91,-1.3l4.56,-0.87l4.14,-0.27l1.9,-1.43l1.66,-2.22l2.11,-0.5l4.32,4.73l1.85,0.64l0.5,-0.5l-1.62,-5.27l-1.17,-2.45l-2.05,-1.18l-17.72,2.6l-5.79,-3.34l0.43,-4.84l2.79,-1.31l4.86,-4.79l8.37,-4.42l3.47,-4.49l0.58,-4.21l3.85,-2.34l4.29,-0.4l4.21,0.48l2.68,1.91l1.96,0.49l1.24,1.98l0.7,-0.05l0.96,-2.81l0.03,-2.09l-2.81,-2.0l-2.41,-1.11l-5.76,-3.63l0.22,-0.82l1.87,-1.91l0.99,-0.21l6.88,0.41l1.71,-0.15l1.29,-0.7l1.5,-2.87l1.75,-0.34l0.55,-0.46l0.08,-0.52l-0.74,-1.14l-1.32,-1.07l-1.59,-0.57l-9.73,3.68l-2.98,0.13l-11.56,-0.77l-0.57,-5.73l-1.28,-0.99l-3.7,-1.18l-5.24,0.72l-0.43,-3.46l16.96,-1.78l6.18,-0.34l2.03,-1.08l2.25,0.51l2.67,-1.27l4.53,-3.18l5.76,-2.12l2.54,-1.67l0.4,-2.34l-0.51,-0.43l-5.97,1.7l4.59,-5.23l5.82,-0.59l6.98,-1.38l12.8,-3.73l4.1,0.76l-1.03,5.87l2.71,4.1l0.4,0.17l3.67,-0.63l3.51,-1.25l6.81,-1.22l3.6,-1.31l2.57,-0.49l1.9,-2.53l1.79,-1.7l3.64,2.99l5.55,9.23l4.29,2.07l1.49,0.36l0.56,1.06l-0.78,1.78l0.83,1.37l7.19,0.87l2.78,-0.61l3.7,-0.17l3.84,-1.02l5.68,-4.91l2.01,1.92l1.35,-0.14l0.82,-0.88l1.75,0.95l1.99,2.1l5.45,1.65l1.28,1.37l1.99,0.53l4.27,-2.29l4.33,-1.81l1.71,1.49l1.82,0.91l0.44,-0.05l2.85,-2.57l4.75,7.49l-0.56,8.74l-4.43,4.4l-1.24,2.96l-6.0,2.95l-2.95,0.84l-1.86,-0.11l-1.22,0.73l-2.46,4.78l-5.57,5.02l-1.41,3.81l-0.35,4.27l-3.48,6.48l-1.45,4.26l-1.06,4.39l-1.71,3.23l-0.17,3.73l0.25,0.39l3.0,1.18l0.65,3.19l1.34,3.24l-0.17,3.71l1.27,2.66l1.7,1.13l-0.67,3.49l-5.2,5.85l-0.82,3.77l-0.18,3.38l-2.24,2.13l-6.81,-5.1l-8.06,-2.72l-4.81,2.35l-3.62,3.59l-12.35,1.07l-4.44,-0.07l-4.2,-2.49l-2.13,0.51l-2.6,-0.03l-3.75,0.58l-3.58,1.96l-4.36,-0.6l-2.77,-2.74l0.16,-4.49l-2.57,-2.87l-0.7,-2.41l1.01,-4.29l-2.5,-3.54l-4.32,0.21l-0.87,1.4l-1.28,1.19l-0.8,1.87l-0.27,1.77l-3.3,0.04l-5.77,-7.23l-3.8,-2.88l-2.38,-0.93l-2.58,-0.02l-1.93,2.13l-4.3,-0.27l-3.12,2.6l-0.05,4.01l-1.02,1.43l-1.51,1.03l0.14,3.21l-0.94,1.8l-1.54,1.24l-4.14,1.48l-3.42,2.12l-4.06,0.56l-7.56,2.17l-2.69,-0.84l0.16,-3.48l1.51,-8.95l-0.3,-0.44l-3.78,-0.89l-14.43,3.83ZM204.64,432.78l1.01,-0.86l1.13,-0.31l0.16,-0.72l1.34,0.23l1.65,-0.94l0.18,0.57l-0.36,0.83l-3.76,3.36l-1.7,1.06l-0.64,-1.05l0.16,-0.59l1.14,-0.55l0.14,-0.61l-0.45,-0.42Z",name:"North Jeolla"},"KR-44":{path:"M192.7,261.2l2.12,3.7l0.58,0.06l0.53,-0.46l2.61,0.55l0.42,-0.18l-0.02,-0.45l-2.08,-2.99l2.57,0.71l1.65,-0.34l1.2,-1.89l-0.32,-0.59l-3.11,-0.2l-1.68,-0.7l-0.18,-1.4l1.97,-2.92l-0.09,-0.54l-2.63,-2.01l0.15,-1.59l1.95,-1.46l2.3,-0.76l-0.63,2.79l0.62,1.44l1.79,0.34l3.08,-0.05l1.04,-0.59l0.99,-1.59l0.22,-3.27l-0.31,-4.27l0.53,-3.22l2.02,-0.57l-0.26,1.42l0.1,3.14l0.57,3.21l1.47,3.58l-2.68,3.78l0.07,1.44l0.82,2.39l-3.19,2.21l-0.01,1.66l0.4,1.3l0.74,0.9l1.35,-0.27l2.09,-1.75l1.3,-0.03l3.47,2.2l0.48,-0.04l0.09,-0.48l-2.55,-5.08l-0.84,-2.93l0.86,-0.93l1.71,2.01l1.32,0.82l0.58,-0.21l0.93,-1.82l3.66,-1.02l0.31,-0.39l0.0,-0.89l-0.34,-0.4l-3.04,-0.94l0.0,-0.29l2.92,-0.75l1.82,-2.8l0.45,-3.2l-1.25,-2.81l-1.19,-0.35l-3.18,-0.05l-1.45,-0.54l-1.08,-1.21l-0.14,-1.1l1.55,1.03l0.6,-0.19l0.82,-2.21l-1.15,-1.84l-1.91,-0.53l-1.47,0.08l1.39,-1.04l1.12,-0.18l2.23,1.38l1.2,0.26l0.82,-0.54l0.08,-0.47l-0.5,-1.56l4.12,-0.06l1.97,0.64l0.76,1.55l-1.73,2.25l-0.74,1.91l0.79,2.31l0.65,0.17l2.32,-1.6l0.86,0.02l0.39,0.91l0.82,2.69l-1.22,1.42l-0.46,1.15l0.0,6.37l0.49,2.08l0.91,1.29l1.05,0.61l0.53,-0.15l0.46,-0.82l0.5,-3.52l2.26,-6.78l0.52,-3.31l0.37,-0.44l1.17,0.73l2.08,2.12l1.47,2.89l1.02,1.06l2.04,0.19l0.42,-0.4l-0.09,-1.14l-0.85,-1.03l-1.06,-2.85l-0.99,-1.53l-8.03,-7.74l0.26,-0.93l0.59,0.1l3.18,3.31l1.15,0.92l1.43,0.57l1.55,0.01l1.35,-0.68l0.21,-1.61l-1.05,-1.04l-4.0,-1.4l-2.45,-2.11l-1.11,-3.16l-0.21,-1.73l1.74,-0.04l1.85,0.82l7.61,5.48l3.63,2.07l1.08,1.7l-0.51,1.67l-1.24,1.6l0.28,1.13l1.19,2.1l0.14,1.19l-0.44,2.29l0.61,0.41l1.36,-0.87l0.72,-1.29l0.34,-1.35l-0.46,-3.39l0.45,-1.02l1.86,-3.08l1.85,-0.8l3.9,0.23l5.32,1.53l2.07,1.25l2.47,2.34l0.17,2.82l-1.93,6.1l0.13,0.44l0.45,0.03l1.49,-0.91l2.34,-2.74l0.89,-0.15l0.69,0.91l0.49,1.99l0.27,4.0l-0.82,4.03l0.3,1.31l1.06,1.65l1.01,4.27l-0.27,0.95l-1.82,0.51l-0.27,0.5l0.9,2.1l1.94,1.16l0.55,-0.28l0.71,-3.13l1.18,-1.84l0.67,-2.13l-0.83,-3.12l1.89,0.5l2.64,0.3l0.4,-0.22l-0.07,-0.46l-4.22,-4.31l-1.04,-1.96l2.08,-0.86l2.31,-0.36l5.4,-2.0l2.34,-1.62l5.66,1.07l4.94,0.01l10.31,-4.03l5.17,2.17l4.76,3.68l5.84,0.78l0.97,2.03l1.46,1.42l1.65,0.9l2.07,3.84l1.57,1.08l-0.12,2.7l1.86,2.45l0.25,1.48l-1.44,5.77l-0.51,0.88l-2.35,0.19l-1.04,1.03l-2.67,4.25l-3.25,4.34l-17.39,-6.38l-0.51,0.23l-2.92,7.53l0.38,21.37l-1.86,1.7l-1.13,2.98l0.3,0.54l11.3,2.05l8.36,-2.07l6.48,9.37l2.2,3.95l0.66,10.31l2.57,7.72l0.47,0.26l6.24,-1.53l5.35,-3.69l1.85,-0.6l3.25,-2.42l1.92,-6.29l1.66,-2.52l0.58,-3.24l1.53,-1.9l1.86,-1.25l2.81,1.03l-0.38,1.95l-2.02,1.45l-5.24,9.26l-1.5,5.57l-0.22,3.98l0.33,4.04l0.47,0.36l3.91,-0.75l3.55,1.06l3.63,2.05l1.22,4.0l-0.16,4.94l1.07,4.86l5.21,8.07l-5.61,4.86l-3.56,0.91l-3.62,0.16l-2.69,0.6l-6.89,-0.84l-0.34,-0.75l0.78,-1.82l-0.74,-1.41l-5.78,-2.41l-5.52,-9.19l-4.05,-3.36l-0.53,0.02l-2.08,1.97l-1.63,2.33l-2.44,0.47l-3.58,1.31l-6.81,1.23l-3.51,1.25l-3.38,0.58l-2.4,-3.46l1.07,-6.1l-0.32,-0.46l-4.58,-0.85l-13.03,3.75l-6.94,1.38l-5.92,0.6l-5.77,6.41l-2.55,0.74l-2.51,1.6l-2.11,1.87l-2.22,0.99l-2.72,0.42l-2.53,1.02l-1.63,-0.73l-0.53,-0.82l-0.9,-3.16l-4.04,-5.49l1.43,-1.07l0.06,-0.59l-0.96,-0.99l-3.14,-1.1l-2.95,-4.54l-2.18,-0.88l-2.2,0.85l-0.24,-1.51l-3.07,-1.71l-2.42,0.35l-0.33,0.29l-0.93,3.05l-0.28,-0.24l0.44,-3.71l3.99,-1.87l3.59,-1.05l5.1,1.36l0.43,-0.15l0.01,-0.45l-2.99,-4.02l-1.38,-0.94l-0.97,-0.24l-1.08,0.48l-1.94,-1.91l2.52,-6.39l1.44,-2.8l1.72,-1.06l0.09,-0.61l-1.57,-1.67l-5.24,-1.48l-1.32,-0.65l1.33,-1.14l5.43,-1.22l1.43,-2.03l-1.07,-2.12l-2.05,-0.49l-3.98,-0.02l-0.7,-0.45l-2.33,-2.35l0.0,-0.37l1.22,0.0l0.35,-0.6l-1.65,-2.82l1.84,-0.94l2.74,-0.85l2.3,-3.1l5.05,-1.31l2.42,-1.19l0.21,-0.45l-0.39,-0.31l-7.43,0.05l-1.89,1.04l-2.58,3.55l-1.59,0.28l-1.04,-1.17l-1.09,-2.54l-0.69,-2.61l0.07,-1.38l2.52,-2.73l1.23,-2.13l-0.39,-0.78l-0.48,-0.2l-2.16,0.72l-2.45,-1.54l-0.42,-0.95l0.5,-1.23l-0.12,-1.37l-0.63,-2.45l-0.76,-1.16l1.43,-0.11l2.4,-1.03l2.5,0.08l0.41,-0.36l0.19,-1.67l0.71,-1.47l-1.06,-1.66l-1.6,-0.4l-1.64,-1.5l1.01,-1.33l1.7,-1.26l0.1,-0.53l-1.46,-2.16l-2.72,-0.47l-0.5,-1.98l0.78,-1.44l2.71,-0.4l0.23,-0.67l-1.64,-1.72l-0.89,-2.0l-0.63,-0.2l-2.78,2.56l-2.12,0.97l-0.39,1.01l0.04,1.18l0.88,1.35l0.14,2.23l-0.91,2.89l0.53,3.62l-1.25,3.02l-0.84,0.98l-2.0,-1.44l-2.52,-0.17l-2.09,-1.27l0.58,-7.41l0.73,-2.74l-0.23,-0.47l-1.15,-0.51l0.39,-3.32l-1.79,-1.91l-2.28,0.51l-1.12,1.86l-0.35,2.36l-0.75,1.4l-2.59,0.04l-0.35,0.59l3.42,5.52l0.71,2.03l-1.14,0.89l0.03,1.55l1.76,2.28l-1.35,0.27l-1.61,0.85l-1.84,1.82l-0.78,-2.67l1.59,-3.69l-3.53,-5.34l1.03,-2.81l-0.94,-3.89l-0.57,-0.26l-2.29,1.18l-3.33,3.84l-4.97,1.5l-1.1,0.07l-1.3,-0.7l-0.94,-2.86l0.34,-0.33l5.17,-0.02l1.49,-1.16l-0.03,-2.15l-1.57,-2.6l-3.9,-1.4l-1.54,-1.17l-0.62,0.18l-0.64,1.7l-0.38,3.59l-0.64,1.5l-0.97,0.81l-0.24,-0.57l-0.09,-6.91l0.29,-0.81l3.13,-3.67l0.83,-1.89ZM221.95,307.84l-0.21,1.47l0.35,1.4l0.93,2.63l1.69,2.43l0.42,1.33l-7.49,-0.12l-0.26,-1.66l1.5,-1.53l0.5,-1.26l-0.11,-0.45l-0.46,-0.04l-2.78,1.62l-0.91,-0.4l0.31,-1.72l2.18,-2.79l-0.03,-0.52l-0.85,-0.88l-0.58,0.01l-1.29,1.4l-0.33,-0.72l-0.54,-0.19l-0.58,0.28l0.53,-2.73l-0.48,-5.21l-0.59,-3.24l-1.22,-3.76l3.02,-2.91l2.0,-0.63l1.45,2.13l0.17,0.66l-0.43,0.83l-1.03,1.01l0.11,0.98l2.11,4.46l0.29,1.21l-0.46,1.41l0.79,1.16l1.32,0.72l0.67,1.07l-1.89,0.0l-0.4,0.4l0.0,0.88l0.33,0.39l2.24,0.89Z",name:"South Chungcheong"},"KR-47":{path:"M779.8,166.91l-2.13,0.98l-2.97,-0.53l-2.96,-1.63l-1.93,-2.13l-0.59,-2.68l0.94,-1.95l2.06,-1.26l4.34,-0.68l4.28,-1.25l1.8,1.25l-0.14,3.36l-1.35,3.97l-1.37,2.55ZM529.23,227.19l0.28,2.6l0.53,0.33l3.82,-1.39l3.35,-2.4l1.21,0.46l1.25,1.36l1.55,0.13l1.54,-0.58l4.71,0.73l4.78,1.94l3.33,-0.79l3.25,-1.58l4.05,0.87l3.69,2.05l1.05,2.86l-2.51,1.73l-3.69,-1.25l-2.42,0.85l-2.12,1.48l-1.07,3.92l0.62,4.81l2.55,3.55l4.09,1.84l0.88,2.91l1.39,2.83l5.64,2.55l8.66,0.6l-0.43,2.81l1.98,2.14l-2.93,7.32l0.33,3.99l1.1,3.57l0.37,3.04l-1.33,3.29l0.24,0.53l8.6,2.92l4.14,-1.58l5.0,0.89l0.64,5.56l1.69,5.8l0.67,5.81l-0.76,12.06l-0.72,2.48l-3.78,4.22l-1.59,2.59l-0.67,2.89l-0.53,17.16l0.48,2.54l0.76,1.29l1.46,1.21l0.7,4.7l0.93,3.73l1.62,1.45l-0.41,1.93l-0.88,1.1l-2.51,0.95l-2.07,1.58l-0.27,2.23l6.58,6.72l2.75,0.53l3.54,-2.42l7.89,-7.98l1.34,-2.06l1.58,1.16l1.92,7.47l-1.86,2.7l-4.52,8.38l-1.66,13.31l-3.2,8.37l0.15,5.34l-3.26,9.04l-3.48,6.65l1.26,3.14l-8.92,-1.99l-11.47,1.92l-1.93,-0.46l-1.34,-0.89l-0.34,-3.77l-1.39,-2.1l-4.38,-1.75l-4.28,-0.84l-4.43,0.6l-5.32,1.71l-4.29,3.06l-0.14,0.45l0.68,1.98l1.1,1.71l-0.55,0.98l-1.87,0.09l-3.24,1.76l-2.93,2.2l-3.27,1.01l-3.59,-1.56l-5.01,-1.08l-4.49,1.71l-3.15,3.06l-3.55,0.84l-4.04,2.94l-4.41,-0.12l-3.8,-1.85l-4.12,-1.17l-9.17,1.21l-3.72,-2.18l-3.01,-3.4l-1.01,-7.69l-0.63,-0.27l-2.95,2.14l-2.92,3.85l-3.4,-0.56l-6.53,3.1l-3.32,-0.62l-3.18,-2.2l-3.46,-1.53l-3.58,-0.55l-3.83,0.48l-7.34,-0.29l-1.83,-6.11l1.46,-3.21l-0.03,-3.61l-1.66,-1.8l-1.88,-1.1l-1.09,-2.45l-2.8,-1.89l-1.67,-2.91l-2.36,-2.38l-3.5,-1.12l-6.95,-0.22l-3.74,-2.53l-4.67,-0.56l-0.84,-0.35l-0.66,-2.27l-2.32,-1.72l-2.41,-1.3l-0.93,-2.92l0.51,-9.18l-4.84,-7.63l5.67,-2.12l2.16,-3.66l1.06,-3.67l2.18,-3.04l0.25,-4.33l-0.66,-3.64l2.67,-2.12l5.49,0.63l0.42,-0.47l-1.41,-7.4l-2.98,-2.17l-6.52,1.32l-2.25,-0.98l-3.48,-2.68l-3.13,-0.97l-4.76,0.98l-0.67,-6.09l2.68,-2.17l1.78,-3.27l-1.36,-2.6l-0.74,-2.3l0.73,-3.37l0.5,-7.69l1.18,-3.1l2.19,-1.97l0.05,-0.54l-6.08,-8.14l-4.9,-0.88l-1.15,-2.68l3.41,-1.02l1.83,-1.81l2.8,-3.46l0.74,-1.53l0.24,-2.95l3.69,-2.31l4.31,-1.88l2.67,-3.58l4.54,1.8l8.8,1.29l0.41,-0.59l-1.81,-3.2l-2.28,-2.72l0.77,-2.68l2.81,-5.06l1.89,1.07l2.48,-0.2l2.27,-2.62l1.85,-1.1l1.88,1.11l3.84,1.24l3.67,0.28l0.4,-0.26l1.48,-4.54l1.23,-1.79l1.3,-1.18l1.42,1.45l4.9,3.61l2.05,3.57l4.69,1.33l10.63,-4.27l1.83,-5.6l-2.43,-2.92l2.75,-5.13l2.67,-3.51l3.78,-2.47l1.18,-1.88l1.42,-1.09l2.65,-0.81l5.24,-4.28l2.83,-2.76l1.0,-0.59l1.62,0.44l1.68,-0.89l1.41,-1.45l6.08,2.64l6.92,1.01l0.42,-0.31l0.73,-3.05l0.41,-3.33l-0.78,-3.45l2.06,-2.31l3.2,-1.38l3.09,0.22l1.9,2.82l2.36,0.5l1.85,0.85l-0.27,2.19ZM483.61,402.68l1.55,2.71l4.86,3.43l0.49,-0.0l0.95,-0.75l1.82,-2.9l1.59,-1.16l3.84,0.36l7.15,1.72l3.06,-1.59l0.59,-2.51l1.16,-2.86l0.13,-1.81l1.95,0.08l1.94,-1.85l0.79,-2.54l-0.32,-4.68l-2.33,-2.53l-0.04,-3.33l0.6,-1.04l0.06,-1.12l-1.64,-2.77l-5.34,-3.56l-6.56,0.4l-7.93,0.98l-6.03,4.56l0.61,6.63l-2.07,2.14l-1.33,2.78l0.3,0.57l1.88,0.43l-0.17,1.04l-0.43,1.08l-3.89,0.43l-1.79,2.57l0.74,2.61l2.1,0.93l1.7,1.55Z",name:"North Gyeongsang"},"KR-46":{path:"M395.67,589.98l0.0,-0.73l0.71,-1.01l1.59,-0.56l-0.38,0.88l0.43,1.11l-0.97,0.29l-0.57,-0.37l-0.81,0.4ZM395.17,575.46l-1.14,0.08l-1.24,-0.62l-4.28,-4.05l-0.45,-1.41l0.69,-2.38l2.74,-2.17l0.57,-1.06l0.94,-3.56l-1.83,-2.1l0.14,-0.72l1.1,-0.48l1.38,-0.15l1.05,0.44l0.25,0.99l-0.55,1.34l-1.43,1.23l0.17,0.69l1.14,0.27l1.02,1.51l1.9,5.45l0.11,1.95l-0.36,1.89l-0.85,1.81l-1.08,1.04ZM395.77,599.22l-1.32,-1.28l0.47,-0.95l-0.43,-0.48l0.88,-1.62l0.26,-1.72l1.09,1.07l-0.94,4.98ZM227.11,464.86l13.91,-3.68l3.13,0.78l-1.47,8.63l-0.18,3.82l0.28,0.4l3.3,0.97l7.64,-2.18l4.12,-0.57l3.56,-2.18l4.17,-1.49l1.83,-1.5l1.08,-2.25l-0.32,-2.68l1.48,-1.04l1.14,-1.6l-0.03,-3.86l2.85,-2.37l4.38,0.24l1.94,-2.13l2.0,0.13l2.06,0.81l3.71,2.82l6.11,7.43l3.84,-0.04l0.39,-0.34l0.29,-1.96l0.74,-1.74l1.15,-1.03l0.86,-1.36l3.23,-0.16l2.27,3.2l-1.05,4.1l0.85,2.78l2.41,2.53l-0.16,4.49l3.33,3.36l4.62,0.64l3.75,-1.99l3.64,-0.56l2.64,0.02l2.0,-0.48l4.08,2.47l4.62,0.07l12.51,-1.09l3.81,-3.68l4.3,-2.22l7.72,2.59l6.83,5.11l-0.52,3.18l2.5,2.73l1.2,3.48l0.52,7.43l1.74,2.98l3.14,2.17l2.68,2.61l2.4,5.53l7.76,7.87l1.6,3.67l-0.01,2.56l-6.62,-0.21l-1.54,-2.96l-1.54,-1.19l-0.62,0.2l-0.33,1.08l0.44,2.54l-1.3,3.24l-1.09,1.17l-4.63,3.44l-2.34,0.97l-1.62,-1.29l-2.31,-4.36l-2.15,-0.91l-0.46,0.13l-1.35,1.8l-0.74,2.96l0.17,2.61l3.12,5.78l2.2,2.8l2.02,1.24l1.5,1.74l1.3,0.58l1.97,-0.97l3.76,-3.28l2.49,-0.31l4.38,0.53l1.92,-0.9l-0.5,3.97l-1.24,3.99l-1.41,6.94l-0.91,1.44l-4.08,1.27l-3.32,-1.54l-2.86,-0.58l-0.44,0.22l-2.08,4.24l-0.65,-0.27l-0.98,0.45l-0.26,0.57l1.66,3.74l0.89,6.1l-0.33,0.68l-0.87,-0.45l-1.99,-1.94l-3.13,-0.45l-2.06,-1.06l-1.32,-1.92l-0.57,-2.97l0.72,-2.83l1.61,-2.92l1.19,-3.01l-0.58,-2.37l-1.05,-1.44l-1.95,-3.93l-0.67,-0.47l-1.44,-0.15l-0.41,-0.41l0.49,-2.11l-1.86,-3.64l-0.3,-1.25l0.75,-3.03l-0.36,-0.93l-1.33,-0.9l-1.18,1.12l-2.1,4.96l-1.03,1.15l-4.82,1.45l-2.4,0.28l-5.34,-0.13l-2.14,0.57l-0.14,0.7l1.64,1.25l5.68,2.01l0.0,0.28l-4.99,1.48l-2.74,1.42l-0.66,2.18l0.15,0.41l1.44,0.86l2.19,-0.82l0.98,0.39l0.68,1.03l-0.76,0.36l-0.43,0.76l1.73,5.58l3.71,3.18l3.86,2.31l2.03,2.71l-2.64,-0.05l-0.93,0.19l-0.32,0.36l0.26,0.4l5.17,1.85l0.6,1.34l0.32,2.66l-2.12,1.82l-2.28,-0.1l-1.49,0.33l-5.51,-3.19l-2.09,-0.6l-1.69,0.31l-3.76,2.02l-0.83,1.63l2.03,3.53l1.67,0.34l1.3,0.66l4.53,-1.1l2.05,1.62l-5.52,4.71l-1.96,2.58l-2.38,-0.81l-3.58,2.53l0.21,2.83l1.03,1.15l-2.29,0.01l-4.92,-6.06l-1.8,-3.41l-4.66,-4.69l-1.88,0.22l-4.92,2.39l-0.2,0.49l0.41,1.18l-3.03,-0.7l-1.51,-0.74l-1.05,-1.83l-0.13,-1.83l0.66,-1.0l3.68,-2.31l2.51,-3.09l1.57,-3.05l0.8,-0.94l1.13,-0.51l-0.67,3.84l-1.81,4.07l0.39,0.56l3.64,-0.22l3.33,-1.19l1.9,-2.59l-0.04,-4.14l-0.76,-1.78l-1.67,-1.98l-0.1,-1.89l0.58,-0.97l3.34,-3.44l1.69,1.2l0.16,0.84l-0.61,1.54l0.81,1.94l1.06,1.28l1.62,0.56l2.34,-0.8l3.5,-5.86l-0.01,-0.46l-1.68,-2.33l-0.72,-2.57l-0.88,-1.13l-0.55,-0.08l-2.31,1.68l-2.45,0.97l-2.01,-1.56l-3.03,-4.54l-0.66,-0.0l-1.8,2.64l-2.48,5.93l-1.63,1.85l-1.62,0.61l-4.49,-0.66l-1.67,0.49l-4.7,4.75l-8.5,5.03l-2.48,0.84l-0.43,1.45l-0.16,3.1l-1.88,2.29l-0.65,1.62l0.81,1.88l-6.63,6.07l0.09,5.9l-0.82,0.68l-3.07,-1.43l-0.47,0.1l-1.09,1.23l-0.62,1.66l0.06,1.5l0.4,1.0l-4.28,-2.54l-4.72,-1.29l-0.92,-0.52l-0.89,-2.46l0.51,-7.01l-0.46,-2.74l0.67,-1.82l-0.15,-2.16l-0.85,-2.02l-1.55,-1.16l-1.84,0.39l-1.42,1.26l-1.04,1.52l-0.47,1.44l1.31,4.63l-3.54,1.1l-0.27,0.49l0.57,1.86l2.46,2.91l-4.33,2.34l-1.86,1.58l0.12,0.68l2.05,0.85l-0.02,0.91l-0.66,0.01l-1.8,-0.81l-1.79,0.22l-0.63,0.86l-0.06,1.14l-0.55,1.2l-0.81,0.51l-3.61,0.85l-1.64,1.29l-3.55,10.43l-0.27,2.61l-2.75,-0.5l-5.62,1.72l-1.05,-0.2l-0.13,-1.27l1.14,-3.28l-0.36,-2.03l-1.31,-0.99l-1.66,-0.3l-2.82,0.13l0.84,-1.68l0.23,-2.0l0.83,0.09l0.66,-0.48l1.76,-2.97l0.37,-1.76l-0.47,-1.43l-0.76,-0.65l-4.0,-0.85l-0.09,-0.38l0.62,-0.93l0.5,-3.63l-0.22,-0.92l-0.51,-0.29l-1.37,0.43l0.42,-2.57l2.26,-1.55l3.19,-0.57l3.06,-0.07l0.35,-0.59l-0.63,-1.17l-0.86,-0.9l-1.43,-0.74l1.35,-0.9l1.21,-1.49l-0.09,-1.92l-1.84,-0.8l-0.72,0.32l-1.72,1.66l-0.81,-0.01l-1.52,-0.87l-1.03,-0.08l-1.12,0.85l-0.89,2.07l-5.73,-0.01l-2.93,0.76l-0.27,-1.93l-1.2,-1.4l-2.69,-1.23l-0.65,-1.52l-0.83,-0.78l-0.64,0.14l-0.64,1.28l-1.57,0.55l-3.39,-2.6l-0.32,-1.08l0.8,-0.71l0.46,0.35l1.24,0.02l1.14,-0.75l0.14,-0.46l-0.52,-1.44l-3.5,-1.73l-2.38,-1.63l-0.2,-3.78l1.06,-4.41l1.32,-3.2l0.17,-3.23l0.72,-0.33l2.25,0.67l0.8,1.63l3.61,5.03l-1.07,1.37l-0.37,1.56l0.22,1.48l2.98,8.29l1.72,1.07l6.2,0.99l2.82,1.71l1.76,-0.37l1.01,-2.44l-0.42,-0.55l-1.28,0.18l-3.12,-0.81l-1.11,-1.62l-1.49,-1.4l0.41,-3.02l-0.46,-0.45l-1.64,0.28l-1.01,2.0l-0.72,0.06l-0.68,-2.27l-0.37,-3.35l0.9,-1.89l-0.56,-2.27l2.85,-0.26l4.97,1.01l0.51,0.84l-0.33,2.82l0.49,1.22l1.23,0.74l0.81,0.98l3.84,1.81l4.39,3.17l0.51,-0.08l0.54,-0.62l0.01,-0.52l-2.18,-2.68l0.76,-0.15l5.13,2.67l3.65,1.09l2.8,-0.61l0.31,-0.4l-0.34,-0.38l-2.54,-0.4l-2.03,-1.2l-3.39,-2.77l0.64,-0.73l-0.08,-0.59l-2.64,-1.8l-4.17,-4.91l-2.34,-1.02l-3.09,-0.58l-3.65,0.21l-2.73,-1.51l-3.02,0.76l-2.56,-0.78l-0.26,-0.92l1.57,-1.83l1.55,-0.59l3.81,0.5l4.52,-1.88l5.5,3.77l2.05,-0.25l1.65,1.0l0.53,-0.46l-0.53,-2.64l0.22,-2.29l1.32,-1.61l2.81,-0.65l5.59,1.56l2.99,0.21l0.39,-0.58l-0.7,-1.42l1.5,-0.7l2.56,-0.35l-0.07,-0.44l-2.07,-2.1l-2.92,-0.48l-5.83,0.49l0.29,-0.98l-0.48,-3.19l1.59,-2.35l0.1,-1.66l-1.04,-2.26l-1.96,-0.69l-2.12,0.82l-1.52,1.87l-0.21,1.54l0.95,3.35l-1.66,3.0l-1.37,4.71l-1.14,1.44l-1.91,0.16l-0.57,-0.54l1.47,-2.62l-0.16,-0.59l-1.69,-0.8l-1.46,0.46l-1.13,0.9l-1.46,0.42l-3.45,-0.64l-1.05,0.46l-0.39,1.41l-1.47,-0.0l-2.53,0.78l-1.0,-0.47l-0.33,-1.14l0.76,-1.2l2.55,-2.38l1.47,-2.36l0.31,-2.21l-0.32,-2.07l0.34,-0.84l1.53,-1.25l-0.02,-0.63l-1.48,-1.08l-1.29,-2.23l-0.7,-2.63l0.22,-2.08l3.91,-2.83l0.86,-1.37l-0.26,-0.59l-3.26,-0.69l-1.6,0.32l-1.46,1.33l-2.1,0.88l-0.22,0.41l0.18,1.37l0.6,1.64l0.03,1.06l-1.49,1.26l-2.04,0.13l-3.02,-1.22l1.09,-0.58l0.07,-0.7l-1.94,-1.53l-1.14,-1.86l0.97,-0.46l4.34,0.67l0.47,-0.44l-0.35,-2.82l3.31,-3.06l0.11,-0.41l-0.99,-3.07l-3.54,-4.55l-2.38,-1.99l-2.37,-0.76l-0.5,0.5l0.93,3.01l-0.69,1.45l-1.32,0.04l-1.43,-1.74l0.97,-1.25l-0.01,-0.5l-3.13,-3.86l-0.39,-2.04l1.55,-1.67l2.28,-0.28l2.01,0.96l0.93,2.09l0.57,0.18l1.72,-1.09l0.91,-1.69l0.72,-2.32l0.54,1.94l-0.32,2.5l-0.71,2.16l0.25,1.02l0.38,0.29l1.11,-0.1l0.57,2.46l0.66,0.75l2.76,1.25l2.11,0.09l0.53,0.28l-0.6,1.48l0.26,1.7l0.95,1.52l1.32,1.26l0.64,-0.12l3.17,-6.7l0.33,-2.3l-0.13,-2.72l-0.85,-1.06l-2.28,-0.53l-1.61,-1.14l-1.32,-3.2l-4.03,-4.37l-0.84,-1.82l1.32,-1.77l0.35,-1.46l-0.17,-0.42l-1.23,-0.81l-0.52,-0.92l0.23,-1.82l-0.53,-0.42l-3.14,0.81l-2.62,0.03l0.71,-0.81l4.72,-0.59l2.25,-0.51l0.31,-0.37l-0.26,-0.4l-2.11,-0.97l0.35,-0.74l2.29,-2.08l0.51,-1.2l-0.77,-2.94l0.4,-2.06l1.04,-2.09l2.44,-3.46l2.38,2.67l2.19,0.62l1.24,-0.05l0.36,-0.51l-0.3,-1.03l-2.02,-2.2ZM288.22,480.64l-6.78,1.6l-4.36,-1.07l-3.04,2.44l-0.1,0.48l3.56,7.1l6.9,3.81l7.66,1.13l5.26,-6.19l0.06,-0.4l-2.52,-6.44l-6.64,-2.46ZM392.97,588.24l-0.79,0.03l-0.63,-0.76l-2.96,-1.17l-1.08,-0.77l-1.15,-2.02l-1.74,-1.32l0.46,-0.83l1.92,-0.85l2.06,-0.26l1.41,0.98l1.76,3.19l-0.14,1.47l1.94,0.85l0.38,0.56l-0.15,0.49l-1.3,0.42ZM385.82,531.72l0.93,0.44l1.39,-0.01l-2.32,2.48l-1.89,-0.06l-1.02,-0.93l0.48,-1.02l1.19,-0.81l1.23,-0.07ZM385.8,557.17l0.62,-0.55l-0.16,0.5l0.37,0.46l1.1,0.56l-0.54,0.42l-0.73,-0.34l-0.66,-1.05ZM375.85,577.45l1.03,-1.5l1.12,-0.49l0.69,0.46l0.14,0.63l0.57,0.48l1.66,0.02l0.49,-0.31l0.53,0.16l0.35,0.6l-0.49,0.45l-0.57,-0.88l-0.67,0.07l-0.68,1.31l-2.39,0.58l-1.2,-1.51l-0.6,-0.06ZM362.77,571.53l-0.48,0.48l-0.62,-0.05l-0.13,-0.38l0.26,-0.45l0.97,0.4ZM363.07,571.53l1.53,-0.81l0.94,0.35l0.59,0.83l-1.11,0.2l-0.68,1.24l-0.39,-0.1l-0.37,-0.66l-0.04,-0.86l-0.47,-0.18ZM362.7,619.92l-0.06,0.04l-0.34,-0.34l0.42,-0.1l-0.02,0.4ZM356.35,592.41l0.5,0.43l0.58,-0.14l1.19,-1.03l0.82,-0.04l2.54,2.54l0.5,1.83l-2.96,2.1l-1.77,0.51l-0.36,-0.19l-0.16,-1.24l-1.0,-0.92l-1.13,-0.34l-0.33,-0.41l0.05,-0.87l-1.89,-1.18l0.35,-0.95l-0.06,-1.25l3.15,1.15ZM351.24,584.41l0.29,-1.74l0.89,-0.92l1.64,-0.12l0.74,0.64l-1.09,0.33l-0.34,0.53l1.24,1.47l-1.12,0.19l-0.0,0.7l4.6,1.55l0.46,0.87l-0.98,0.77l-1.14,-0.05l-3.45,0.9l-1.15,-1.11l-0.06,-0.48l0.66,-0.37l0.83,0.05l0.4,-0.53l-1.04,-2.16l-1.38,-0.51ZM352.2,547.66l-0.55,-0.21l0.43,-1.51l1.62,-0.06l-1.19,0.93l-0.32,0.84ZM344.89,617.42l-0.17,-1.19l0.86,-0.03l-0.09,1.06l-0.61,0.16ZM340.24,616.8l1.51,-0.35l-1.64,2.0l0.13,-1.65ZM334.92,649.11l0.78,0.35l0.62,-0.22l0.29,1.56l0.81,1.1l-1.3,-0.51l-1.19,-2.29ZM332.85,648.97l-0.37,1.35l0.27,1.6l1.66,2.53l1.76,1.12l-2.93,-0.95l-0.85,-2.29l-0.88,-0.86l-0.24,-0.75l0.15,-1.48l0.61,0.1l0.83,-0.37ZM329.59,603.32l-1.74,-0.39l-0.35,-0.44l0.17,-1.72l-1.12,-0.77l-0.07,-0.75l1.55,1.39l1.56,2.68ZM328.34,626.85l-2.17,-0.34l-1.65,0.37l0.75,-2.22l1.64,-1.79l0.93,-0.52l0.29,0.03l0.36,0.88l-0.12,1.63l-0.65,0.94l0.62,1.01ZM322.28,597.29l-5.02,0.86l-1.86,-0.25l-1.38,-0.63l-2.76,-1.73l0.0,-0.67l0.58,-0.67l0.21,-0.84l-0.56,-0.95l-0.75,-0.5l3.08,-1.53l4.01,-0.69l3.83,-0.42l1.91,0.13l1.52,0.68l1.22,2.04l-0.37,2.36l-1.51,1.96l-2.15,0.82ZM312.48,585.0l-0.76,0.83l-1.24,0.47l-0.32,-0.54l-0.7,-0.29l-0.04,-0.38l0.75,-0.18l0.22,-0.37l0.48,0.75l0.62,0.19l0.61,-0.56l0.22,-0.76l0.17,0.83ZM308.91,573.0l-0.18,0.09l-0.5,-1.18l0.94,0.54l-0.25,0.54ZM296.24,607.16l1.13,-0.56l2.43,-2.32l1.36,1.6l0.67,1.45l1.24,0.41l2.7,-0.6l2.01,2.29l-2.42,-0.69l-1.11,0.34l-0.17,0.63l0.7,0.62l-3.34,2.31l-0.05,-0.55l1.2,-1.13l0.1,-0.59l-0.44,-0.56l-2.37,-0.55l-0.22,-1.14l-1.0,-0.66l-2.43,-0.3ZM301.48,593.25l1.12,0.55l0.55,-0.13l0.62,0.62l1.27,3.18l-0.45,0.75l0.02,0.85l-0.5,0.46l-0.5,-2.04l-0.69,-0.61l-0.61,0.21l-0.01,1.24l-0.48,-0.34l-1.9,-4.17l0.31,-0.34l1.25,-0.23ZM294.24,613.63l-1.59,0.3l-1.02,-0.9l-0.41,-0.47l0.32,-1.67l1.47,-0.8l2.89,-0.1l1.62,0.83l0.04,0.59l-0.44,0.58l-2.33,1.58l-0.55,0.05ZM279.9,600.35l1.06,0.66l3.16,0.07l1.4,0.87l1.2,0.33l1.33,-0.19l1.17,-1.76l-1.11,2.92l0.39,1.29l-0.61,0.61l-1.18,0.18l-1.22,1.26l-0.86,0.29l-1.27,-0.38l-1.1,-1.08l-0.08,-2.41l-0.57,-0.23l-1.56,1.27l0.11,-3.25l-0.25,-0.45ZM287.62,660.26l-1.86,0.3l-0.18,-1.5l0.68,-0.38l0.55,0.08l0.82,1.5ZM278.4,634.43l-0.42,-1.79l1.36,-3.65l2.36,-1.42l1.85,0.44l1.17,1.56l1.83,1.68l-0.28,1.51l-0.99,1.86l-1.28,0.65l-1.66,0.13l-2.61,-1.59l-0.82,0.09l-0.51,0.53ZM267.0,610.27l2.76,-0.89l2.2,0.6l1.47,-0.59l1.61,-1.22l1.0,-0.24l1.62,0.7l2.47,0.02l2.45,0.81l-0.87,1.46l-0.32,1.42l-0.54,0.55l-2.15,0.04l-1.28,1.04l-0.76,0.15l-1.38,-2.54l-1.13,-0.51l-4.01,0.63l-3.15,-1.42ZM278.54,601.34l0.05,0.37l-0.44,0.07l-2.46,-0.7l-1.26,0.24l-0.8,0.93l-3.33,1.5l-1.15,1.44l-0.65,1.67l-0.47,-0.51l-0.25,-2.6l-1.64,-0.96l1.73,-3.12l1.67,-2.05l2.33,-1.2l2.45,-0.54l1.3,0.21l0.5,1.24l-0.5,0.48l-0.0,0.74l1.29,0.86l1.64,1.95ZM264.32,611.76l2.3,2.19l0.74,2.16l-3.22,-1.24l-0.53,0.1l-0.67,1.09l-4.89,-1.49l-0.01,-0.41l0.98,-0.7l0.15,-0.44l-0.59,-1.31l-1.26,-0.27l-1.2,0.29l-1.46,-0.38l-1.35,-0.82l-0.77,-0.9l-0.45,-3.07l0.56,-3.35l0.88,-1.21l1.2,-0.54l2.73,-0.34l2.54,1.19l1.39,1.53l1.11,2.59l0.36,2.25l1.45,3.05ZM266.39,631.06l-0.13,0.29l-0.9,-1.0l0.19,-1.52l1.19,-0.88l0.55,1.62l-0.91,1.49ZM254.48,639.97l-0.9,0.23l-0.67,-0.89l-1.12,-0.59l-0.22,-1.52l1.05,-4.98l-0.99,-1.3l0.97,-1.11l0.62,0.01l1.84,0.88l0.2,0.93l-0.99,0.8l-0.35,1.3l2.07,2.71l-0.83,0.46l-0.19,2.22l-0.49,0.86ZM247.05,622.49l1.03,-0.22l0.81,0.36l0.25,0.44l-0.87,0.62l-1.65,0.22l-0.39,-0.64l0.83,-0.78ZM241.55,626.67l0.77,-0.86l-0.55,-1.17l1.73,0.71l2.53,0.4l1.25,0.61l0.97,0.93l0.07,0.9l-0.83,0.75l-0.36,1.31l-2.58,0.28l-0.27,0.6l0.42,0.7l-0.19,0.15l-1.61,-0.41l-1.29,-1.43l-0.91,-0.26l0.95,-2.37l-0.12,-0.85ZM242.43,633.74l3.3,-0.13l1.6,0.55l0.59,0.69l-0.53,-0.1l-0.51,0.43l-1.38,-0.64l-1.42,0.13l-1.12,1.37l-4.28,2.85l-2.08,-0.08l-1.13,-1.39l-0.08,-1.88l0.99,-1.89l2.02,-1.31l1.66,0.0l2.36,1.41ZM245.05,642.46l0.4,-0.76l-0.19,-0.58l0.49,0.08l0.81,1.48l-1.51,-0.22ZM242.17,617.58l-0.91,0.55l-1.81,-0.16l0.01,-0.28l0.85,0.21l1.87,-0.32ZM230.68,609.75l-0.41,-0.53l0.04,-0.22l0.48,0.23l-0.1,0.52ZM210.97,581.87l1.28,0.79l2.92,-1.54l0.12,0.77l3.63,5.48l0.18,1.78l-0.97,4.1l-3.35,6.22l-0.78,0.49l-3.28,-2.64l-0.6,0.35l-0.45,2.85l-11.63,5.9l-1.35,0.43l-5.11,0.4l-1.14,-0.27l-0.18,-0.81l1.55,-1.78l0.31,-1.14l-0.78,-0.97l-3.58,-2.1l-0.6,0.35l0.0,1.93l-1.75,-1.93l1.45,-4.37l3.37,-3.6l3.31,-0.23l0.35,-0.26l1.1,-2.98l0.68,-1.01l1.08,-1.12l2.5,-0.87l0.9,-0.62l0.37,-1.42l1.17,1.17l1.97,0.19l2.01,-1.13l0.9,-2.66l-1.06,-1.88l-2.88,-2.11l0.49,-0.69l1.71,-0.12l1.92,0.98l3.05,1.94l1.18,2.13ZM216.4,537.02l0.21,2.51l-2.1,1.81l-0.53,-0.19l0.83,-1.29l-0.34,-0.94l-4.15,-2.19l-3.91,0.52l-1.68,0.75l-1.69,0.25l-1.27,-0.41l-0.46,-0.56l0.33,-0.36l1.91,-0.13l2.53,-0.86l1.18,-1.57l1.55,-0.55l0.56,-0.87l0.12,-1.22l-1.01,-1.45l-0.3,-0.99l0.92,-0.44l1.97,0.44l2.12,1.0l1.37,1.28l-0.06,0.33l-0.95,0.15l-2.06,1.37l-0.25,0.82l0.25,1.55l1.07,0.52l1.8,0.03l2.04,0.67ZM212.08,666.17l-1.71,-2.49l0.85,-0.17l1.25,0.33l1.4,-0.28l-0.24,0.62l-0.92,0.0l-0.39,0.29l-0.24,1.69ZM211.09,549.13l-0.46,-1.12l1.22,-0.79l0.51,0.48l-0.98,0.75l-0.29,0.68ZM205.64,521.97l0.69,-0.29l1.32,0.88l1.29,2.95l-0.2,0.34l-1.47,-0.46l-0.41,-1.37l-1.23,-2.05ZM202.94,516.34l1.43,0.8l0.92,1.12l0.05,1.45l-0.93,0.08l-0.61,0.41l-0.49,-0.3l0.19,-2.8l-0.54,-0.76ZM195.45,502.83l1.46,0.74l2.13,-0.86l1.04,0.93l1.1,-0.15l0.11,0.32l-0.57,0.53l-1.0,0.06l-0.75,0.65l-0.11,1.02l1.49,1.59l1.27,0.57l1.24,0.1l0.58,0.77l1.17,2.9l-0.41,1.14l-1.7,-0.5l-0.5,-0.59l-0.42,-0.7l0.23,-1.68l-0.27,-0.51l-3.97,-0.73l-0.84,-0.59l-1.48,-0.17l-1.75,-1.39l-1.22,-2.64l0.55,-0.83l1.32,-0.41l1.29,0.44ZM202.52,528.27l-0.97,0.39l-1.19,-0.04l-0.45,-0.93l0.19,-1.01l0.71,-0.36l2.37,0.16l-0.34,1.54l-0.32,0.25ZM198.29,521.47l-0.19,1.32l-0.78,-1.67l0.38,-0.96l1.01,-0.62l-0.43,1.92ZM191.26,564.73l0.11,0.88l0.62,0.21l1.73,-1.23l1.01,1.05l0.25,1.73l0.41,0.34l0.81,-0.03l-1.68,0.8l-0.71,0.81l-1.7,-0.29l-1.24,0.84l-1.01,0.08l-1.71,0.77l0.37,-3.46l-1.45,-1.17l3.7,-2.73l0.91,0.19l0.07,0.47l-0.51,0.75ZM189.37,510.85l0.3,-0.21l-0.05,-0.68l-1.1,-0.15l0.81,-0.57l4.2,0.49l0.68,1.06l0.08,1.78l-0.79,0.53l-2.04,-1.6l-1.17,0.22l-0.32,-0.6l-0.6,-0.25ZM188.4,523.67l0.95,-2.18l0.28,-2.72l1.27,-0.61l0.41,-0.65l-0.25,-0.61l-5.85,0.16l-0.57,-0.43l1.19,-0.5l0.7,-0.98l2.27,-1.35l1.99,0.44l0.84,0.65l0.42,1.58l1.85,1.13l0.15,0.44l-0.25,1.66l-1.32,1.04l-2.31,0.5l-0.5,1.19l0.18,0.92l-1.46,0.31ZM186.65,549.55l2.93,1.72l2.67,0.37l0.7,0.59l0.81,3.45l0.04,1.33l-0.56,1.06l-1.18,0.11l-2.74,-2.89l-1.33,-0.02l-1.21,0.75l-0.72,0.06l-0.62,-0.43l-0.23,-1.17l-1.13,-1.93l-2.61,-2.78l1.48,0.12l2.24,-0.56l1.47,0.21ZM191.57,549.57l-1.23,0.3l-2.98,-2.01l-3.01,-1.23l0.66,-0.52l3.08,-0.48l2.66,-1.36l0.88,0.36l0.96,1.31l-0.68,1.18l0.2,1.92l-0.53,0.52ZM185.99,508.27l-0.42,1.04l-0.37,0.09l-3.21,-0.8l-1.18,0.15l-1.24,-0.86l0.87,-4.0l0.58,-1.15l3.73,-1.61l1.52,-2.76l2.09,-1.26l2.39,-0.53l0.81,0.2l-2.87,1.55l-1.0,1.3l-0.15,1.79l0.59,1.53l1.39,2.09l-0.99,0.41l-1.39,1.27l-1.12,1.54ZM190.51,477.83l-0.82,0.59l-0.95,-1.75l0.68,-1.17l0.88,0.7l0.41,1.55l-0.19,0.08ZM189.71,534.24l0.91,0.87l0.08,0.5l-1.44,0.86l-0.18,0.45l0.58,2.09l-0.24,1.06l-0.63,0.36l-1.41,0.08l-0.89,1.11l0.03,1.5l-0.34,1.12l-1.07,0.57l-0.74,-0.06l-0.23,-1.28l-1.85,-1.95l-1.77,-2.58l0.26,-0.78l1.6,-0.75l1.3,-0.12l1.08,0.57l1.35,0.01l0.69,-1.1l-0.19,-1.64l0.91,-0.82l2.18,-0.04ZM185.16,558.62l-0.32,0.31l-0.48,-0.4l0.77,-0.75l0.03,0.84ZM179.15,582.08l-1.2,0.17l-1.2,-0.33l1.05,-0.35l1.48,-1.5l-0.43,-0.77l-2.08,-0.43l3.65,-0.46l1.41,-1.01l0.75,-1.53l-0.6,-1.73l-1.25,-1.87l-0.68,-2.02l0.46,-0.32l2.24,1.87l1.33,0.7l0.07,1.0l0.51,0.99l-0.1,1.34l-0.49,2.79l-2.58,2.16l-2.34,1.29ZM182.81,529.45l0.27,1.87l-0.36,1.83l-0.88,1.56l-1.32,1.06l-1.59,0.44l-2.99,-1.34l-5.1,0.86l3.36,-4.51l1.53,-1.3l1.85,0.34l1.38,-0.23l0.97,-2.58l0.82,-0.19l1.17,0.75l0.89,1.44ZM176.33,613.36l4.12,0.81l1.8,-0.24l0.47,0.22l0.07,2.22l-0.38,0.52l-1.03,0.12l-0.71,0.48l-1.02,-0.93l-0.42,0.02l-0.5,0.73l-0.43,0.06l-2.36,-0.92l-0.79,-1.47l0.55,-1.24l0.63,-0.39ZM178.89,621.95l0.75,0.29l0.17,0.77l-0.9,1.8l-1.18,-0.8l-0.63,0.12l-0.24,0.52l-1.14,-0.78l0.24,-0.21l0.83,0.06l0.41,0.36l0.62,-0.12l0.95,-0.98l0.13,-1.02ZM178.92,588.91l0.31,0.78l0.69,0.17l-2.65,2.11l-0.67,-2.13l1.48,-1.22l0.31,-0.73l0.97,0.44l-0.43,0.59ZM171.59,609.72l1.61,0.49l1.25,-0.56l2.17,0.27l2.24,1.24l0.12,0.36l-2.95,-0.71l-2.63,0.38l-1.41,-0.32l-0.39,-1.14ZM176.83,576.89l-1.1,0.45l-0.68,-0.53l-0.46,-4.64l0.42,-2.54l0.57,-0.68l3.62,6.33l-0.27,1.27l-2.11,0.35ZM173.59,468.47l0.98,0.17l0.32,-0.57l-0.93,-1.15l0.84,-0.67l1.34,1.19l0.36,0.98l-0.89,0.78l-1.16,0.28l-0.14,-0.47l-0.73,-0.54ZM174.91,505.34l-0.62,-0.28l-0.59,-0.81l0.08,-0.8l0.34,-0.19l0.41,-0.06l0.39,0.63l-0.01,1.51ZM172.62,547.7l0.04,2.29l-2.01,-0.7l-0.5,0.1l-0.95,1.17l-2.98,-0.29l-0.95,0.4l-1.08,3.68l-0.98,1.12l-1.29,0.55l-1.23,-0.13l-0.91,-0.8l-0.59,-1.35l-0.2,-1.73l0.34,-1.59l0.89,-1.1l1.27,-0.77l1.34,-0.49l1.77,0.57l7.03,-1.99l0.72,0.33l0.28,0.72ZM171.67,561.93l-1.82,2.28l-0.73,0.5l-1.6,-0.02l-0.21,-0.42l-1.8,-0.98l-2.48,-0.73l-0.86,-1.79l0.63,-0.8l3.74,-1.46l2.2,-2.8l0.49,-0.23l1.2,1.84l1.83,1.78l0.14,0.91l-0.72,1.93ZM168.88,569.06l-0.02,0.75l-0.8,-0.84l-1.74,-0.2l-0.39,-0.72l1.48,-0.86l0.43,0.18l0.29,0.88l0.75,0.81ZM163.54,623.86l0.82,-1.01l1.48,0.52l-1.47,1.0l-0.76,-0.05l-0.07,-0.47ZM160.04,622.07l0.7,-0.88l0.99,-0.31l0.71,0.21l-1.35,0.61l-0.3,0.73l-0.75,-0.36ZM149.08,570.7l1.59,0.16l2.66,-1.45l0.52,0.0l0.46,2.03l-0.68,0.77l-3.76,0.91l-0.43,-0.42l0.5,-0.1l0.35,-0.74l-1.2,-1.16ZM106.31,566.67l-0.62,0.61l-0.67,-0.47l1.09,-1.17l1.07,-0.11l-0.87,1.14ZM101.52,559.87l0.75,1.16l2.24,-0.3l-3.77,4.4l-1.85,3.08l-0.3,0.31l-0.8,-0.31l-0.7,-1.76l0.12,-1.72l0.65,-1.63l1.65,-2.71l0.91,-0.63l0.77,-0.14l0.32,0.24ZM94.4,562.45l-0.41,0.55l-0.44,-0.56l0.83,-0.38l0.27,0.17l-0.25,0.22ZM86.52,602.86l-1.21,-0.08l-0.44,0.41l-1.05,-1.65l1.08,0.26l1.61,1.05ZM83.34,595.59l0.22,-0.44l0.69,-0.83l0.1,0.6l-1.01,0.67ZM73.26,557.36l0.88,0.01l0.01,1.62l-0.71,1.46l-1.61,1.05l0.08,1.16l-0.97,0.81l-0.38,-1.75l1.18,-0.39l1.42,-2.62l0.1,-1.34ZM64.62,649.69l-0.39,0.24l-0.77,-0.45l-3.7,-2.81l-0.22,-0.8l0.52,-1.26l0.71,-0.61l1.05,0.33l0.99,1.14l1.72,3.32l0.1,0.9Z",name:"South Jeolla"},"KR-41":{path:"M255.35,114.18l-0.81,-11.65l0.61,-3.21l1.27,-0.85l2.29,-0.24l3.2,-1.12l5.13,-3.75l10.58,-14.8l2.12,-1.97l4.76,-3.38l2.11,-2.21l4.26,-9.58l1.3,-1.51l8.26,4.51l0.99,2.15l2.49,2.28l0.83,2.3l1.43,1.93l1.72,-0.0l5.52,4.74l4.65,2.03l0.49,-0.14l1.62,-2.31l0.1,-4.93l0.29,-1.31l0.65,-0.63l0.46,0.26l0.81,2.92l2.76,1.6l3.03,-0.54l4.24,-4.19l1.72,0.03l0.48,0.37l-1.07,1.66l-0.96,2.56l0.18,3.17l1.96,1.62l1.99,1.11l4.87,1.1l5.21,-1.63l2.23,1.33l2.29,-0.81l0.61,0.48l1.14,3.26l0.62,6.72l1.7,4.1l3.45,2.21l5.39,-0.06l1.64,4.02l2.51,1.19l2.34,0.44l2.76,3.87l-0.61,5.58l-1.28,1.81l-2.53,0.77l-6.3,4.26l-0.17,0.38l0.28,4.44l-0.69,2.17l1.54,4.92l-3.47,3.74l-0.01,0.53l1.48,1.75l0.42,0.13l2.76,-0.82l-0.03,2.34l-0.5,2.73l-1.32,2.54l-0.06,2.68l2.76,2.14l3.6,-0.87l3.26,0.46l3.05,1.84l3.19,1.2l6.96,3.53l4.27,0.55l2.99,1.04l2.93,0.31l1.7,1.34l1.25,1.95l-1.12,2.21l-2.48,0.99l-2.3,2.57l-1.67,2.66l0.64,3.42l-0.91,3.08l-7.63,14.95l-5.52,12.45l-7.59,12.94l-0.94,1.3l-2.02,1.43l-7.21,12.4l-2.74,1.76l-0.71,-0.72l-2.78,-0.36l-1.92,1.88l-1.09,2.45l-1.4,1.67l-3.09,1.23l-2.16,2.11l-1.16,4.17l-3.96,1.23l-5.25,2.32l-5.46,1.48l-5.68,-0.71l-4.71,-3.64l-5.45,-2.3l-10.55,4.03l-4.75,-0.0l-4.86,-0.92l2.74,-1.43l1.44,-1.58l0.83,-3.7l-0.34,-0.76l-1.1,-1.08l1.6,-0.33l3.67,-1.55l0.51,-1.92l-0.49,-0.46l-7.64,2.06l-1.2,1.74l0.38,4.24l-0.71,0.79l-2.7,0.81l-3.95,-0.51l-4.77,-2.56l-4.31,-3.89l-1.42,-3.23l6.89,-0.7l0.36,-0.4l0.0,-0.89l-1.01,-0.78l1.56,0.03l2.57,1.09l0.18,-0.41l-0.53,-2.72l-1.74,-2.55l-1.16,-2.62l0.88,-3.64l-0.24,-0.46l-1.4,-0.58l-0.46,0.12l-1.08,1.32l-0.74,2.41l-0.76,4.63l-0.76,0.37l-1.32,-0.99l-4.69,1.0l-5.32,-1.47l0.01,-1.46l-0.5,-1.31l0.43,-1.94l-0.23,-2.32l1.36,-2.29l1.64,-2.07l1.87,-0.83l2.04,-0.72l3.17,-0.06l3.58,-0.99l0.77,-1.16l0.02,-3.01l-1.17,-0.54l-1.8,0.91l-2.43,1.94l-2.39,-0.81l-0.53,-0.94l0.01,-1.64l-0.57,-0.36l-2.95,1.38l-2.44,1.6l-5.53,5.22l-1.31,0.43l-1.12,-0.03l-0.56,-0.51l0.04,-1.03l2.51,-3.53l0.02,-0.46l-0.42,-0.18l-3.52,0.75l-0.82,-0.24l-0.32,-1.59l0.56,-1.21l4.5,-2.05l1.51,-1.89l-0.0,-0.5l-0.76,-0.63l-3.19,0.41l-0.89,-0.5l-2.39,-4.69l1.12,-0.81l0.9,0.53l3.77,-0.63l5.13,1.89l1.56,-0.6l0.07,2.53l0.65,1.34l1.68,0.74l1.53,-0.68l0.63,-1.43l0.6,-2.98l1.9,-2.61l1.41,0.18l2.12,1.09l2.74,-0.37l0.3,-0.58l-1.4,-2.12l-1.16,-0.71l-1.28,-0.33l-1.51,0.05l-0.92,-1.08l-1.86,-0.31l-1.61,0.43l-1.39,-0.07l-6.11,-1.53l-5.21,-3.63l-0.23,-1.32l2.28,-3.05l1.54,-1.42l3.82,-1.02l2.8,-1.92l1.8,-3.21l1.12,-3.88l-1.31,-1.9l-1.9,-1.14l-1.24,-2.62l-0.12,-3.6l-7.31,-6.45l-12.04,0.28l-1.49,-3.19l-2.38,-3.67l-1.36,-1.24l-0.03,-1.83l-0.52,-2.94l-1.33,-4.49l-1.77,-11.7l0.4,-1.61l1.29,-0.22l6.75,2.21l5.66,-1.47l1.41,0.86l0.55,1.52l0.23,2.56l-0.18,2.63l-0.68,1.94l0.11,3.69l3.91,2.98l4.83,1.86l3.12,0.2l0.39,-0.24l-0.09,-0.45l-2.39,-2.26l-6.88,-4.55l1.96,-4.79l0.64,-3.12l-0.53,-2.33l-1.17,-2.27l-0.23,-2.74l0.54,-2.76l1.27,-2.24l-0.05,-0.46l-1.28,-1.2l-1.38,0.22l-1.32,0.82ZM296.39,138.65l-1.8,3.45l-2.72,3.18l-5.41,0.48l-0.35,0.28l-0.72,2.28l-0.2,2.34l-2.41,1.34l-2.75,0.86l-3.83,-2.14l-3.65,-0.25l-0.38,0.22l-1.86,3.67l0.06,0.45l5.32,6.41l0.83,4.29l2.58,1.54l3.47,0.96l3.86,4.44l5.33,0.17l2.34,-0.34l2.27,-1.17l5.81,-1.46l1.29,2.71l0.53,0.19l3.6,-1.66l3.61,-0.79l3.37,-1.89l3.28,-4.5l-0.03,-0.53l-0.89,-0.92l-0.03,-2.21l3.61,-2.11l0.3,-2.37l-0.95,-2.09l-0.37,-0.23l-2.65,0.05l-2.85,0.94l-2.8,0.03l1.0,-3.55l-0.06,-3.62l-1.31,-3.3l-0.81,-4.53l-2.19,-3.5l-4.77,-0.52l-3.99,0.86l-2.67,2.53ZM240.26,193.49l1.57,0.46l1.31,-1.06l-0.15,0.86l0.52,1.12l3.97,1.86l0.54,0.5l0.51,1.6l-0.55,1.1l-6.17,4.52l-2.31,0.27l1.36,-1.88l0.18,-0.97l-0.45,-0.86l1.5,-1.72l0.03,-1.84l-0.67,-2.11l-1.21,-1.83ZM237.62,143.66l-1.53,3.12l-1.08,0.87l-0.73,0.08l-1.92,-1.55l-1.26,-0.56l-1.65,0.95l-6.34,0.32l-2.25,-0.96l-2.08,-2.55l3.32,-0.82l1.03,-0.67l1.11,-1.82l-0.32,-0.95l-1.22,-1.11l-4.38,-7.66l-0.24,-1.01l0.44,-1.56l-0.12,-6.74l0.43,-1.3l1.18,-0.45l2.85,-3.03l1.98,-0.47l1.8,1.19l3.75,3.61l4.02,1.87l1.46,1.34l0.59,2.12l-0.91,4.05l1.69,3.93l0.4,5.05l-0.3,1.52l1.51,2.52l-1.24,0.68ZM231.12,198.76l-0.91,0.98l-1.11,0.25l-0.82,-0.55l-1.16,0.01l-0.53,-0.31l-0.24,-1.56l0.21,-1.69l0.9,-1.14l2.01,-0.98l2.63,0.21l1.07,0.65l0.38,1.36l-1.79,0.93l-0.65,1.84ZM217.89,138.82l-2.2,0.12l-7.89,-5.63l0.8,-0.72l1.57,-4.47l1.15,-1.13l0.49,-0.11l0.46,0.43l0.55,3.17l0.78,1.55l5.19,4.46l0.19,1.06l-1.08,1.28ZM206.32,117.59l2.48,1.32l4.52,0.27l0.89,0.92l-0.71,2.21l-2.01,1.59l-2.55,0.15l-5.12,-1.01l-2.71,1.08l-0.82,0.02l-0.35,-1.11l1.61,-4.27l1.38,-1.22l1.56,-0.39l1.84,0.43ZM191.39,200.38l-1.81,1.96l-2.31,0.57l-1.01,-0.43l-1.04,-1.86l-0.47,-0.22l-1.21,0.48l0.38,-2.46l0.66,-1.84l0.65,-0.82l2.43,2.45l3.07,1.49l0.68,0.69ZM133.87,139.5l-0.31,0.14l-0.22,-0.44l-0.62,-1.66l0.1,-0.84l1.79,0.05l0.61,0.58l-0.3,1.22l-1.04,0.95ZM18.7,122.36l0.21,0.51l-1.88,-0.11l-0.96,0.42l-0.94,0.9l1.2,-1.67l2.38,-0.05ZM14.55,93.26l1.18,1.34l-0.17,1.75l-1.36,0.91l-2.43,-1.27l-3.16,0.25l-0.79,0.32l-0.24,0.38l0.28,1.86l2.85,0.96l-1.98,1.43l-4.81,-0.62l-3.49,-2.73l1.12,-4.43l2.99,0.9l6.76,-2.17l3.22,1.11ZM9.19,118.16l-1.3,-1.83l0.26,-0.8l3.82,-3.09l1.43,0.42l0.11,0.58l-1.34,3.76l-0.69,0.34l-1.01,-0.05l-1.28,0.66Z",name:"Gyeonggi"},"KR-43":{path:"M500.54,230.38l-1.12,1.17l-1.47,0.78l-1.65,-0.43l-1.21,0.71l-2.92,2.83l-5.16,4.22l-2.61,0.78l-1.64,1.29l-1.04,1.74l-3.86,2.55l-2.73,3.59l-2.9,5.38l0.88,1.81l1.52,1.31l-1.69,5.16l-10.09,3.9l-4.14,-1.25l-1.87,-3.42l-4.98,-3.68l-1.59,-1.64l-0.56,-0.02l-1.68,1.54l-1.3,1.88l-1.43,4.38l-3.23,-0.23l-3.75,-1.21l-2.37,-1.17l-2.22,1.35l-1.93,2.4l-2.18,0.17l-1.88,-1.14l-0.54,0.13l-3.08,5.49l-0.86,2.99l2.43,3.16l1.39,2.46l-7.95,-1.16l-4.69,-1.87l-0.47,0.14l-2.63,3.61l-4.24,1.85l-3.91,2.44l-0.5,1.96l0.06,1.32l-0.63,1.32l-4.44,5.07l-1.79,0.31l-1.83,0.79l-0.21,0.53l1.4,3.25l5.01,0.97l5.77,7.72l-2.09,1.94l-1.26,3.37l-0.5,7.72l-0.73,3.59l0.78,2.45l1.29,2.13l-1.63,3.0l-2.83,2.5l0.74,6.75l0.48,0.35l4.89,-1.06l2.83,0.85l3.46,2.67l2.5,1.11l6.42,-1.34l2.53,1.72l1.28,6.73l-5.06,-0.62l-3.32,2.46l0.54,4.16l-0.23,4.07l-2.11,2.88l-1.07,3.69l-1.82,3.29l-6.03,2.3l-3.07,2.78l-3.73,-2.4l-4.58,1.91l-3.89,2.2l-1.71,-0.45l-1.26,-1.36l-5.45,-1.66l-1.79,-1.96l-2.21,-1.23l-0.5,0.1l-0.72,0.89l-0.67,0.15l-1.01,-0.85l-3.83,-5.17l-2.49,-4.09l-1.04,-4.75l0.15,-4.98l-1.28,-4.22l-4.0,-2.39l-3.76,-1.14l-3.76,0.67l-0.29,-3.57l0.21,-3.85l1.46,-5.39l5.13,-9.04l2.13,-1.62l0.47,-2.46l-0.28,-0.46l-3.65,-1.15l-2.09,1.41l-1.26,1.54l-1.03,-3.05l-0.21,-2.49l-1.49,-0.93l0.18,-1.33l-0.31,-0.44l-1.73,-0.4l-0.41,0.15l-1.36,1.82l-3.76,0.77l-3.3,-0.87l0.38,-2.36l-0.72,-1.59l-1.21,-0.65l-1.13,-1.63l1.03,-3.87l-0.62,-2.46l0.85,-2.35l0.09,-1.55l-0.38,-0.42l-9.44,-0.55l-8.69,1.6l0.5,-3.78l1.54,-4.04l-0.2,-2.46l2.36,-4.72l3.42,-4.56l2.61,-4.18l0.86,-0.85l1.14,0.13l1.4,-0.49l0.68,-1.24l1.46,-5.87l-0.32,-1.89l-0.82,-1.43l-0.97,-0.85l-0.06,-3.09l-1.54,-1.0l-2.08,-3.86l-1.78,-1.03l-1.37,-1.32l-0.75,-1.62l5.11,-1.38l5.31,-2.35l4.11,-1.27l1.36,-4.38l1.89,-1.89l3.26,-1.35l1.56,-1.89l1.0,-2.3l1.72,-1.68l2.08,0.4l0.61,0.75l0.53,0.08l3.12,-2.0l7.33,-12.53l1.99,-1.4l1.81,-2.79l12.93,-3.25l12.65,-1.59l-0.98,6.38l0.48,0.45l3.72,-0.81l3.65,0.23l2.08,1.03l0.41,-0.06l4.46,-3.64l-0.66,-6.78l2.16,-2.43l5.99,-1.86l4.43,4.31l0.08,3.15l1.94,2.13l4.21,-0.95l4.11,-2.1l2.4,-1.7l3.05,0.51l2.51,-1.22l2.71,-1.92l6.74,2.21l8.87,1.52l-1.18,2.48l-3.49,2.28l-2.24,3.14l0.04,0.51l1.36,1.41l1.86,0.97l1.44,0.03l4.82,-1.62l5.69,-0.6l0.96,0.98l-0.08,2.18l2.41,2.3l0.87,1.81l0.39,0.23l4.96,-0.59l2.98,-0.87l2.78,-0.02l6.14,3.95l6.5,0.97l4.46,2.18Z",name:"North Chungcheong"},"KR-42":{path:"M596.8,287.71l-5.04,-0.91l-4.07,1.59l-8.05,-2.74l1.24,-3.19l-0.4,-3.25l-1.08,-3.48l-0.32,-3.85l2.96,-7.3l-0.08,-0.41l-1.91,-1.88l0.47,-3.02l-0.37,-0.46l-9.01,-0.62l-5.33,-2.44l-1.99,-5.46l-4.22,-1.99l-2.43,-3.38l-0.53,-4.45l0.84,-3.32l1.95,-1.36l2.14,-0.74l3.85,1.22l2.94,-2.02l0.15,-0.47l-1.21,-3.29l-4.17,-2.4l-4.51,-0.88l-3.33,1.62l-3.08,0.72l-4.56,-1.91l-4.86,-0.75l-1.75,0.6l-1.1,-0.13l-1.12,-1.29l-1.51,-0.58l-3.86,2.54l-3.19,1.15l-0.22,-1.95l0.3,-2.44l-0.23,-0.41l-2.16,-0.99l-2.32,-0.5l-1.97,-2.86l-3.39,-0.24l-3.56,1.49l-2.4,2.63l0.71,3.8l-1.03,5.88l-2.8,-0.24l-3.65,-0.72l-3.02,-1.17l-5.68,-3.04l-2.52,-1.0l-6.4,-0.93l-6.37,-4.02l-2.96,0.02l-3.08,0.89l-4.59,0.56l-0.87,-1.75l-2.32,-2.22l0.08,-2.17l-1.56,-1.36l-5.99,0.64l-4.86,1.63l-0.93,-0.02l-1.62,-0.82l-1.08,-1.12l1.9,-2.7l3.66,-2.46l1.44,-3.01l-0.25,-0.56l-2.28,-0.63l-7.05,-1.02l-6.9,-2.26l-5.5,3.18l-3.14,-0.48l-2.47,1.75l-4.04,2.07l-3.82,0.85l-1.3,-1.68l-0.12,-3.22l-5.12,-4.69l-6.33,1.97l-2.53,2.76l0.56,7.01l-2.31,1.45l-1.65,1.58l-2.03,-1.0l-3.8,-0.24l-3.31,0.7l0.98,-6.32l-0.45,-0.46l-13.2,1.66l-12.24,3.08l6.27,-10.67l5.51,-12.44l7.64,-14.97l0.98,-3.29l-0.68,-3.26l1.52,-2.44l2.21,-2.47l2.59,-1.1l1.3,-2.55l-1.43,-2.6l-2.14,-1.63l-2.9,-0.3l-3.07,-1.06l-4.11,-0.51l-6.92,-3.51l-3.15,-1.18l-3.24,-1.91l-3.43,-0.49l-3.3,0.92l-2.42,-1.88l0.19,-2.03l1.31,-2.49l0.52,-2.89l0.04,-2.91l-0.51,-0.39l-3.03,0.9l-1.08,-1.28l3.47,-4.0l-1.57,-5.09l0.69,-1.96l-0.26,-4.35l6.05,-4.09l2.71,-0.9l1.5,-2.19l0.57,-6.11l-2.94,-4.12l-2.62,-0.6l-2.1,-0.89l-1.67,-4.1l-0.35,-0.25l-5.59,0.04l-2.99,-2.0l-1.46,-3.64l-0.64,-6.81l-1.19,-3.41l-0.96,-0.84l-1.28,0.07l-1.32,0.67l-2.33,-1.33l-5.08,1.64l-4.6,-1.02l-1.84,-1.03l-1.79,-1.48l-0.06,-2.46l0.92,-2.44l1.2,-1.91l-0.11,-0.51l-0.82,-0.63l-1.21,-0.3l-1.32,0.26l-4.3,4.22l-2.56,0.4l-2.24,-1.39l-0.79,-2.92l-0.9,-0.5l-0.47,0.06l-1.06,1.12l-0.32,1.47l-0.03,4.7l-1.36,1.94l-4.2,-1.82l-5.57,-4.8l-1.64,0.04l-1.2,-1.59l-0.92,-2.45l-2.45,-2.23l-1.16,-2.35l-8.23,-4.52l7.1,-5.49l7.86,-4.5l8.24,-3.05l7.92,-0.78l3.98,0.38l15.24,-1.22l11.85,3.26l3.81,-0.33l7.26,-2.01l23.78,-1.9l0.85,0.53l1.54,2.04l1.57,1.46l2.05,0.5l8.16,-1.57l12.98,0.69l8.51,-0.61l8.62,-2.79l8.08,-4.78l6.61,-6.33l2.92,-3.8l2.46,-4.12l1.64,-4.55l0.53,-5.25l-1.3,-7.33l0.7,-1.67l3.27,-2.36l6.65,-3.15l9.29,16.77l1.16,4.59l2.95,6.94l10.97,19.81l8.54,20.74l1.42,2.32l4.45,5.05l1.73,4.26l28.72,37.78l9.65,9.8l1.38,1.04l6.33,6.82l0.35,6.29l0.78,3.09l4.49,2.44l1.2,2.26l3.66,10.89l1.62,2.51l2.04,1.18l1.54,1.47l5.62,10.14l3.41,3.95l1.12,2.06l0.46,2.29l0.95,2.35l5.93,5.99l1.86,4.84l1.71,10.87l2.33,5.96l6.37,8.19l0.42,1.5l-2.54,4.62l-0.08,1.63l0.89,4.45l1.1,12.77l1.17,5.94l4.1,11.96l0.33,5.77l-1.27,5.33l-2.8,4.94l-2.17,5.59Z",name:"Gangwon"},"KR-27":{path:"M514.07,395.04l-1.7,1.62l-2.02,-0.11l-0.37,0.43l-0.09,1.99l-1.15,2.78l-0.36,2.13l-2.49,1.4l-7.02,-1.69l-4.07,-0.38l-2.04,1.37l-1.84,2.92l-0.65,0.51l-4.55,-3.19l-1.43,-2.57l-1.89,-1.75l-1.87,-0.71l-0.63,-2.22l1.48,-1.91l3.73,-0.32l0.84,-1.59l0.25,-1.49l-0.27,-0.44l-1.81,-0.49l1.07,-2.24l2.2,-2.45l-0.76,-6.23l5.57,-4.28l7.78,-0.97l6.41,-0.39l4.8,3.25l1.47,2.36l-0.05,0.89l-0.61,1.08l0.04,3.58l1.08,1.62l1.28,1.03l0.3,4.38l-0.62,2.08Z",name:"Daegu"},"KR-11":{path:"M311.41,150.56l-1.13,4.0l0.39,0.51l3.4,-0.04l2.98,-0.96l2.21,-0.03l0.79,1.74l-0.28,1.81l-3.46,1.88l-0.15,2.94l0.87,1.05l-3.06,4.21l-3.08,1.68l-3.57,0.77l-3.29,1.52l-1.25,-2.64l-0.44,-0.22l-6.21,1.55l-2.2,1.15l-2.17,0.33l-5.11,-0.16l-3.53,-4.26l-3.74,-1.11l-2.27,-1.37l-0.7,-4.11l-5.24,-6.34l1.62,-3.19l3.12,0.18l4.21,2.21l2.95,-0.92l2.71,-1.5l1.03,-4.72l5.57,-0.6l2.86,-3.34l1.77,-3.41l2.35,-2.3l3.71,-0.81l4.21,0.31l1.98,3.12l0.81,4.49l1.29,3.2l0.07,3.37Z",name:"Seoul"},"KR-50":{path:"M326.34,284.16l-2.23,4.46l0.18,2.52l-1.54,4.09l-0.58,4.37l0.47,0.45l9.09,-1.68l9.0,0.53l-0.06,1.07l-0.87,2.43l0.63,2.45l-0.63,2.45l-2.67,-0.19l-22.13,5.58l-10.75,-1.95l0.92,-2.44l1.95,-1.91l-0.39,-21.48l2.72,-6.94l16.88,6.2Z",name:"Sejong"},"KR-29":{path:"M288.08,481.43l6.11,2.13l2.36,6.05l-4.6,5.69l-7.36,-1.09l-6.59,-3.67l-3.21,-6.54l2.29,-2.01l4.43,1.05l6.56,-1.61Z",name:"Gwangju"},"KR-28":{path:"M258.97,154.88l7.06,6.22l-0.01,3.2l1.37,2.98l2.08,1.33l1.02,1.54l-1.09,3.31l-1.71,3.02l-2.42,1.64l-3.5,0.94l-0.56,-0.89l-6.51,-0.76l-3.15,3.41l-2.56,-1.79l1.11,-2.27l1.62,-2.25l0.01,-0.45l-1.19,-1.75l-4.01,-1.98l0.26,-2.34l-0.38,-2.02l1.04,-1.66l4.54,-1.47l0.49,-1.47l-0.29,-0.48l-1.67,-0.42l-0.47,0.25l-0.37,1.01l-2.02,0.2l-0.52,-1.11l-0.26,-2.5l0.54,-3.09l11.54,-0.38ZM222.41,170.6l-0.63,-1.17l-1.11,0.05l-1.01,0.96l-1.38,-0.46l0.33,-0.63l-0.27,-0.78l-1.63,-1.8l0.33,-0.73l1.69,0.29l5.55,-3.56l6.8,-0.37l2.74,-1.48l0.81,-3.01l1.33,-0.45l1.4,1.25l4.49,1.49l1.54,1.65l0.62,1.24l-1.84,1.36l-1.96,0.43l-1.11,-0.11l-4.21,1.73l-1.67,1.35l-0.91,1.43l-5.2,3.6l-2.45,-0.16l-0.64,-1.76l-0.98,-0.57l-0.62,0.2Z",name:"Incheon"},"KR-30":{path:"M339.55,308.06l-0.14,0.88l0.44,1.03l0.97,1.02l1.06,0.5l0.6,1.34l-0.45,2.37l0.29,0.46l3.93,0.99l4.0,-0.82l1.53,-1.89l1.12,0.26l-0.17,1.26l0.23,0.41l1.32,0.63l0.22,2.4l1.25,3.68l-0.57,3.15l-1.63,2.46l-1.76,6.01l-3.08,2.3l-1.83,0.59l-5.34,3.69l-5.68,1.37l-2.44,-7.32l-0.69,-10.42l-2.27,-4.08l-6.32,-9.14l13.13,-3.31l2.29,0.18Z",name:"Daejeon"},"KR-26":{path:"M568.89,493.81l-0.4,0.75l-6.11,0.11l-2.9,0.73l-0.36,0.37l-0.12,1.98l1.0,1.54l0.14,1.45l-0.55,1.62l-2.4,1.04l-3.4,-2.69l-0.99,-1.13l-0.58,-0.02l-3.32,3.32l-1.48,2.58l-0.49,2.71l-0.46,0.3l-0.49,-1.07l-1.48,-1.49l-0.45,-0.08l-0.23,0.4l0.37,3.75l-1.3,-1.14l-2.55,1.35l-0.56,-0.64l-0.95,-3.0l1.52,-8.35l4.62,-6.32l1.35,-8.37l1.66,-1.91l2.28,-1.53l2.81,-1.04l2.96,0.11l2.2,1.31l0.73,3.08l2.22,2.86l2.87,2.18l4.82,5.26ZM555.99,508.74l-0.43,0.51l-1.41,-1.44l-2.33,-1.17l-1.03,-1.11l0.08,-1.38l0.69,-0.64l0.98,0.06l2.55,2.7l-0.4,0.45l-0.19,1.03l0.23,0.44l1.26,0.56Z",name:"Busan"}},height:768.6419862721414,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","north_america_mill",{insets:[{width:900,top:0,height:543.9752077221104,bbox:[{y:-12658749.920443352,x:-19602744.043810368},{y:-805507.5274078546,x:8293.375346519799}],left:0}],paths:{PR:{path:"M615.15,486.14l0.49,-0.54l4.41,0.24l0.53,0.27l0.25,-0.21l1.74,0.55l-1.52,1.25l-4.61,0.12l-1.07,-0.1l0.09,-0.95l-0.31,-0.64Z",name:"Puerto Rico"},DO:{path:"M591.08,485.11l1.01,-0.94l0.06,-0.79l-0.32,-0.52l0.75,-0.93l-0.5,-0.96l0.16,-2.32l0.47,-0.33l1.59,0.25l1.43,-0.34l1.49,0.7l1.0,0.03l1.26,0.7l1.15,-0.16l0.52,1.4l1.08,0.56l-0.11,0.58l0.36,0.4l3.61,0.67l1.01,0.41l1.54,1.28l-1.42,1.56l-0.98,-0.9l-2.01,-0.22l-2.55,-0.02l-1.32,0.39l-0.84,0.63l-1.29,0.15l-0.9,-0.61l-2.07,0.34l-0.5,0.35l-0.18,0.93l-1.27,1.96l-0.79,-0.55l-0.56,-1.27l0.01,-1.51l-0.9,-0.91Z",name:"Dominican Rep."},DM:{path:"M644.58,500.93l0.23,0.18l0.09,0.55l-0.06,-0.22l-0.26,-0.5Z",name:"Dominica"},LC:{path:"M646.75,509.74l-0.11,-0.11l0.12,-0.26l-0.02,0.37Z",name:"Saint Lucia"},NI:{path:"M510.73,514.44l0.06,-0.06l0.48,0.45l-0.55,-0.39ZM511.29,514.84l2.51,-0.37l0.5,-0.47l0.25,-0.88l0.89,-0.25l-0.14,-2.33l1.96,-0.04l1.21,-1.35l1.24,0.92l0.61,-0.04l0.37,-0.69l2.63,-1.95l0.14,-1.0l0.59,-0.38l0.22,-0.7l0.41,-0.19l0.96,0.74l1.13,0.1l3.04,-0.79l2.07,-1.05l-0.18,0.72l0.59,0.49l0.48,1.81l-1.11,1.68l-0.43,1.39l-0.38,2.18l0.2,2.87l-1.09,1.22l0.44,1.35l-0.1,0.78l-0.47,0.37l-0.28,0.9l0.84,1.13l-1.07,1.87l0.22,1.13l0.74,1.26l-0.8,0.2l-1.1,-0.22l-0.86,-0.95l-1.68,-0.44l-1.48,0.48l-3.23,-1.18l-0.9,0.36l-3.52,-3.12l-1.96,-2.65l-3.47,-2.91Z",name:"Nicaragua"},PA:{path:"M534.6,538.28l0.75,-0.82l-0.31,-1.31l0.78,-0.58l0.11,-0.46l-1.07,-0.96l0.0,-1.44l0.4,-0.43l0.54,0.28l0.65,-0.15l0.56,0.42l0.14,1.01l0.51,0.34l0.2,0.83l0.77,0.44l1.65,0.03l0.34,-0.32l0.89,0.92l1.09,0.25l2.75,-0.57l1.51,-1.01l2.12,-0.65l2.77,-1.97l2.26,0.3l0.98,0.56l2.07,0.1l3.27,1.65l2.03,1.89l-0.23,1.03l1.29,2.33l-0.63,0.53l-0.17,0.77l-0.68,0.51l-0.58,-0.69l-0.66,0.08l-0.06,1.09l-0.55,0.84l-1.99,-3.13l0.67,-0.54l-0.02,-0.64l0.32,-0.26l1.8,1.09l0.45,-0.2l-0.09,-0.48l-1.26,-0.97l-0.37,-0.76l-1.96,-0.04l-0.28,-0.79l-0.59,-0.47l-2.4,-1.47l-0.94,-0.16l-1.58,0.3l-1.08,0.76l-0.56,1.42l-3.31,1.77l-0.0,1.28l2.11,2.54l-1.18,0.19l-0.73,0.74l-1.04,0.23l-0.76,-0.04l-0.82,-3.08l-1.01,-0.08l-0.44,1.11l-0.93,-0.37l-1.33,-2.2l-2.25,-0.36l-0.53,-0.53l-2.23,-0.06l-1.12,0.36Z",name:"Panama"},CA:{path:"M656.78,311.04l0.24,-0.16l0.13,0.16l-0.06,0.01l-0.31,0.0ZM658.78,310.96l1.32,-2.86l1.52,0.67l0.57,-0.05l-0.0,-0.7l-0.32,-0.25l0.55,-0.85l-0.37,-0.55l-0.78,-0.11l-0.01,-0.43l0.68,-0.71l0.52,0.35l0.69,-0.05l0.26,-0.5l-0.68,-1.17l2.47,-5.27l0.34,-0.49l1.01,-0.41l-0.52,-0.58l1.07,-0.85l0.3,-1.08l0.98,-0.87l0.58,-1.21l3.2,-1.5l1.41,0.61l-1.62,0.22l-0.31,0.33l0.09,1.0l0.56,0.37l0.56,-0.09l-0.02,0.65l-0.32,0.74l-1.15,0.94l-0.25,0.86l-1.47,1.64l-1.55,2.62l-0.63,1.68l0.3,1.48l0.79,-0.27l2.58,-2.87l-0.18,0.68l0.61,0.29l1.02,-0.45l1.08,0.35l-1.88,0.97l-0.63,0.66l-0.05,0.46l0.42,0.2l0.82,-0.39l-0.88,0.8l-0.11,0.47l0.42,0.23l1.26,-0.37l0.85,0.48l1.18,-0.25l0.13,0.51l0.46,0.11l-0.52,1.07l0.29,0.91l0.78,-0.34l0.4,-0.82l0.44,-0.27l0.43,0.17l2.09,-1.46l0.24,0.94l0.61,-0.04l0.38,-0.45l1.78,-0.12l1.47,0.69l0.15,0.68l-3.03,2.63l0.37,0.32l0.62,-0.03l0.27,0.54l0.87,0.13l-0.19,0.41l-1.53,0.81l0.06,0.7l2.53,-0.72l0.75,0.1l2.07,-0.91l-0.6,0.93l-0.76,0.12l-1.38,0.96l0.04,0.81l-1.32,0.41l-0.3,0.4l0.91,0.43l-0.87,0.95l-1.5,-0.7l-1.22,2.12l-1.09,0.78l-1.18,0.26l-2.01,2.83l-2.45,0.37l-0.43,-0.19l2.21,-0.99l1.54,-1.84l1.6,-0.78l0.59,-0.81l-0.53,-0.5l-0.67,0.25l-2.11,-0.25l-0.43,0.23l-0.29,0.96l-1.25,-0.11l-0.27,-0.14l0.07,-1.7l-0.58,-0.22l-1.36,0.21l-0.6,0.79l-2.63,0.59l-7.46,-0.68l-0.64,-0.33l-1.29,0.62l-2.78,0.2l-0.5,-1.6l3.64,-2.99l1.54,-0.89l-0.39,-0.58l-1.45,-0.08ZM683.12,317.23l0.46,0.3l1.12,-0.2l1.62,-2.14l0.85,-0.39l-0.85,1.7l0.07,1.94l0.68,0.3l0.34,-0.18l1.28,-1.47l0.07,1.34l-1.15,2.05l0.08,0.93l-0.93,1.78l-0.88,-0.43l-1.1,0.47l0.18,-2.74l-0.24,-0.4l-0.74,0.07l-1.14,1.28l-0.93,0.54l1.64,-3.37l-0.42,-1.38ZM673.85,292.06l0.2,-0.08l-0.12,0.07l-0.08,0.01ZM674.16,291.85l0.09,-0.48l0.22,-0.03l-0.24,0.43l-0.06,0.08ZM256.05,238.13l-0.69,-2.13l-5.23,-4.12l-0.56,-1.06l-2.14,-1.13l0.48,-1.39l0.0,-0.49l-0.42,-0.4l-3.05,0.12l-1.57,1.06l-2.25,-0.82l-0.7,0.54l-1.85,-0.48l0.0,-77.04l2.6,0.35l2.21,-0.17l3.93,0.93l2.45,1.75l4.29,2.06l5.91,1.83l3.08,0.07l4.41,1.76l0.43,-0.14l0.11,-0.58l-1.11,-1.39l-2.21,-0.71l1.21,-0.07l0.39,-0.4l-0.33,-0.56l-1.23,-0.44l0.75,-1.21l2.32,-0.3l0.47,-1.23l3.54,-0.11l0.18,-1.79l0.56,0.08l0.76,0.92l0.78,0.27l-1.35,1.86l0.49,0.7l2.46,-1.04l2.68,-0.58l1.62,-1.94l2.06,-0.0l0.47,-0.6l-0.18,-0.29l1.17,0.37l3.66,-1.92l1.51,0.1l1.25,-1.39l1.23,-0.64l3.52,0.35l1.28,-0.92l0.43,0.52l-0.42,0.53l-5.94,3.1l-5.64,1.06l-2.08,2.08l-1.86,0.46l-3.86,3.86l0.39,1.1l1.17,0.42l0.3,-0.06l0.08,-0.79l2.01,0.19l0.99,-0.42l0.31,-0.66l-1.07,-0.46l0.04,-0.94l3.95,-1.82l0.83,-0.85l0.03,-0.48l1.67,0.02l0.4,0.71l1.09,-0.84l0.27,1.88l0.34,0.34l2.66,-3.37l1.91,-1.28l4.38,-1.24l0.14,0.8l0.56,0.59l1.44,-0.45l2.44,-1.95l0.62,-1.38l2.98,-1.38l-0.18,-0.7l-1.35,-0.27l-0.12,-0.64l-0.69,-0.34l0.5,-0.82l3.64,2.43l1.47,2.07l1.28,2.66l2.25,2.14l1.83,1.2l2.05,0.64l1.02,-0.03l1.1,-0.71l0.15,-1.01l-0.88,-1.25l0.55,-0.55l0.12,-0.66l0.6,-0.11l1.52,-1.44l-0.12,-0.81l0.98,-0.67l0.39,3.18l1.31,0.85l-1.65,1.97l0.15,0.73l0.82,0.39l4.5,-0.29l1.65,-1.42l0.86,-2.34l4.68,-0.02l2.67,0.36l2.84,1.02l4.28,2.56l6.5,1.11l3.89,1.9l4.54,1.19l5.97,0.68l0.44,-0.47l-0.48,-0.7l1.35,-0.17l4.04,1.2l2.85,1.63l2.05,2.24l-0.32,0.55l-0.78,0.14l-2.46,-0.19l-0.74,0.73l-1.42,0.6l-0.41,0.59l0.05,0.56l-1.1,0.63l-0.23,0.45l0.26,0.46l1.6,0.75l6.39,0.99l7.16,0.22l1.38,-0.43l3.43,-0.24l1.7,-0.54l1.33,0.23l3.11,-1.4l1.32,-0.29l2.18,2.18l2.91,0.28l0.39,1.57l0.66,0.85l0.65,-0.14l0.62,-1.35l1.27,1.61l1.81,1.27l0.28,0.53l-0.22,0.24l-0.99,0.32l-1.34,-0.35l-0.34,0.65l5.23,5.2l1.33,0.89l0.44,-0.55l-2.32,-2.96l-0.13,-1.58l2.37,0.95l0.58,-0.6l-0.85,-1.22l0.17,-0.74l-1.4,-1.4l-0.46,-2.13l-1.51,-1.59l0.01,-0.65l0.99,-0.81l0.07,-0.92l4.4,-0.79l0.8,-0.75l1.29,0.12l0.33,-1.19l0.52,-0.43l1.15,-0.22l1.11,-0.72l0.47,-0.61l0.09,-0.93l-1.14,-0.54l-0.69,0.11l-2.28,0.98l-0.76,1.31l-1.19,-0.18l-2.15,0.78l-1.63,-0.3l-0.88,0.46l-0.02,0.94l-2.44,0.19l-1.81,-0.99l1.71,-2.3l4.42,-0.69l6.43,-2.05l1.7,0.45l0.83,0.62l1.24,3.34l1.45,1.05l2.14,0.56l0.26,0.98l1.54,0.77l2.48,0.01l2.08,-0.6l3.85,2.58l2.05,0.7l2.17,-0.09l1.68,0.45l5.8,-1.27l3.33,0.21l3.16,0.79l1.37,-0.02l2.63,-0.72l0.25,-0.43l-1.57,-1.85l3.48,3.12l2.53,0.84l1.91,-1.1l-0.03,-1.34l-2.23,-1.35l-1.14,-0.15l-2.0,0.53l-1.11,-1.1l0.26,-0.61l-1.12,-1.54l1.75,0.48l2.12,-0.6l0.18,-0.68l-0.54,-0.57l1.0,0.43l1.15,-0.12l2.05,2.05l2.0,0.12l-0.88,1.3l0.47,0.56l1.08,-0.24l0.56,-0.81l1.47,-0.6l-0.87,3.95l-0.83,1.32l-0.06,0.62l0.95,1.28l0.32,1.05l0.94,0.13l1.01,-0.29l-0.19,0.76l0.5,0.26l0.96,-0.24l0.41,0.33l-0.02,0.83l-1.39,0.18l-1.23,-0.44l-0.92,0.18l-0.94,-0.62l-0.58,0.27l-0.1,0.44l2.85,2.78l0.8,1.19l0.36,-0.26l0.21,-0.94l-1.43,-1.65l1.71,0.28l1.42,-0.42l0.8,-2.84l-0.69,-2.51l-1.27,-1.73l0.9,-2.3l1.37,-0.33l1.28,0.34l0.82,-0.28l4.22,-3.58l2.53,-1.36l-0.26,-0.68l-0.7,-0.04l-0.12,-2.04l-0.93,-1.24l-0.82,0.14l-0.79,1.74l-2.13,0.17l0.15,-0.74l2.48,-2.05l-0.38,-0.56l-0.54,-0.0l-0.03,-0.91l1.89,-0.48l-0.37,0.6l0.15,0.48l0.81,0.23l1.56,-1.19l0.19,-0.28l-0.67,-1.5l-0.9,-0.39l-1.4,0.56l-1.55,0.02l-1.86,-1.76l-0.66,0.01l-0.49,0.58l-3.72,-1.55l-1.9,-0.42l-2.51,-2.79l-0.26,-0.67l0.03,-0.82l1.19,-1.59l2.19,-0.44l-0.46,-0.75l0.38,-0.53l-0.2,-0.62l-1.88,0.48l-1.23,-1.3l0.55,-3.8l1.6,-1.31l1.58,0.79l1.07,-0.11l0.96,-1.59l-0.11,-0.57l-2.13,-0.39l3.16,-2.83l2.78,-0.75l0.45,1.21l0.87,0.79l2.71,0.1l0.12,1.13l2.55,1.65l1.11,1.14l0.66,2.24l-0.42,2.27l3.22,2.05l1.49,2.17l0.08,0.87l0.73,0.28l0.7,-0.47l0.71,0.99l-1.48,0.02l-1.34,-0.79l-0.76,0.11l-0.98,1.21l0.13,0.57l2.33,0.31l-4.26,2.97l-0.03,0.67l0.7,0.22l2.37,-0.2l0.47,0.61l1.73,0.68l1.12,-0.19l1.37,-0.78l-0.48,0.42l0.42,0.6l3.63,0.13l-0.89,1.34l-0.8,-0.38l-0.89,0.14l-0.43,0.33l0.12,0.56l2.43,1.56l1.21,1.84l-0.26,0.42l-0.12,3.3l2.08,2.08l0.54,-0.16l1.51,-2.05l0.11,-1.28l1.08,-3.4l1.81,-2.01l0.82,-0.07l2.04,1.79l2.1,1.27l1.2,1.65l0.76,3.06l-0.13,0.49l-0.37,0.07l-0.46,-0.06l-0.68,-0.78l-0.93,0.52l-0.21,0.66l0.25,2.77l0.67,1.73l3.55,3.57l0.8,1.62l0.95,-0.07l3.66,-2.63l0.88,-2.84l2.31,-2.45l1.14,-3.32l-0.01,-1.62l0.33,-0.44l0.63,-0.57l1.05,0.29l2.08,-0.29l0.35,-0.39l-0.25,-0.53l-0.93,-0.36l0.9,-0.63l0.22,-1.42l-2.63,-1.37l-0.12,-2.73l-0.41,-0.85l0.2,-1.35l1.84,0.36l1.94,-0.41l1.6,0.05l3.26,1.29l5.39,0.09l0.83,0.3l-0.33,0.38l-1.25,0.33l-0.07,0.73l2.21,0.76l0.25,1.19l0.43,0.32l1.43,-0.24l2.63,0.7l-1.12,1.01l-1.68,0.81l-0.27,0.54l0.38,0.46l2.78,0.26l0.44,0.61l-0.08,0.49l-1.13,0.81l-1.87,0.8l-1.52,-0.4l-1.76,0.34l-0.29,0.53l1.76,2.93l0.7,0.23l-0.15,0.92l0.28,0.77l3.89,3.71l-0.82,3.23l-0.71,0.5l-1.49,0.23l-1.75,2.04l-1.9,1.27l-1.67,0.38l-2.16,1.45l-0.54,-0.03l-2.12,-2.9l-1.55,-0.39l0.14,-0.56l-1.48,-1.23l-1.69,-0.52l-1.72,1.18l-0.09,0.44l0.74,0.5l1.04,-0.56l0.77,0.23l2.11,1.88l1.96,3.3l-2.07,-0.67l-0.75,0.35l-0.32,0.53l-0.49,-0.15l-2.31,-0.96l-1.67,-1.72l-1.01,-0.39l-2.48,0.39l-3.36,-0.02l-0.3,0.17l-0.2,1.0l0.36,0.83l3.64,1.76l-0.32,0.62l-5.29,4.88l-1.66,0.74l-2.5,-0.08l-3.43,-2.12l-0.51,-0.63l-1.7,-0.48l-3.46,-1.69l-1.19,0.02l-0.13,0.43l-5.19,-0.71l-2.41,0.2l0.02,0.69l2.02,1.02l0.5,-0.71l5.21,1.13l4.96,3.65l3.97,0.57l4.12,0.16l1.55,0.38l-0.0,0.68l-1.25,1.92l-3.07,3.48l-1.06,1.72l-3.4,1.48l-1.03,-0.28l-0.67,-0.6l-0.65,0.15l0.12,0.68l-0.61,-0.29l-1.07,0.08l-0.57,-0.39l-0.32,-0.75l-1.57,0.22l-0.28,0.14l0.02,0.71l0.71,0.65l-1.07,-0.19l-0.26,0.62l0.7,1.09l-0.59,0.76l-0.8,0.4l-1.21,-0.29l-1.09,0.65l-3.61,-1.16l-1.71,-0.23l-0.52,-0.55l-1.85,0.27l-5.48,-1.93l-1.31,-0.93l-0.5,0.03l-0.08,0.5l0.44,0.75l-0.23,0.99l0.72,0.74l1.61,0.22l0.34,-0.54l4.56,1.46l-1.17,0.81l0.4,0.59l1.07,-0.12l2.07,-1.02l2.44,1.47l1.85,0.53l1.11,0.86l0.1,1.45l-0.31,0.8l-1.57,0.34l-1.62,0.92l-2.98,-0.47l-1.69,0.35l-0.39,0.27l-0.04,0.59l0.94,0.99l-1.63,0.36l-1.31,1.88l-1.87,-0.48l-0.25,0.69l1.26,0.76l-0.68,0.6l0.09,0.44l-1.47,0.33l-0.01,0.6l-0.82,-0.08l-0.39,0.58l1.08,1.25l-1.64,0.94l-1.13,1.07l0.05,1.11l-0.84,0.17l-0.03,1.45l-2.23,4.08l-1.17,0.68l0.04,0.68l0.37,0.34l-0.7,3.5l-0.01,5.16l-0.3,1.07l-0.57,0.49l1.02,0.63l0.53,1.11l0.62,0.13l1.29,1.07l-0.25,2.83l0.31,0.39l0.76,-0.81l0.7,-2.56l4.24,0.09l0.33,1.62l3.37,8.51l-0.53,1.32l-1.14,1.18l-0.15,0.57l0.82,0.14l1.49,-0.76l0.08,0.44l0.41,0.02l6.25,-1.94l2.47,0.12l4.07,1.77l4.85,1.18l3.83,2.51l3.13,3.27l9.15,2.98l2.17,1.67l-0.75,1.54l0.23,0.54l1.78,-1.44l2.7,0.19l3.05,-0.4l3.54,0.71l1.2,-0.11l0.61,0.5l1.37,0.06l0.83,0.51l0.74,1.46l-1.04,4.04l0.98,1.59l0.46,1.45l-0.25,1.45l0.17,2.22l-0.69,1.78l0.29,0.77l3.29,3.54l-0.0,0.28l-1.05,0.64l0.01,0.64l1.82,0.13l2.56,1.59l1.5,1.37l1.01,2.14l-1.96,1.65l-0.07,0.46l0.86,0.1l1.98,-1.26l1.2,0.29l1.23,0.67l2.44,2.71l0.51,0.12l0.19,-0.49l-0.21,-0.57l-1.74,-2.01l0.2,-1.08l0.87,-1.35l0.49,-0.24l1.27,0.9l0.64,1.69l0.44,0.24l1.21,-2.46l-1.2,-1.65l0.61,-1.19l1.76,-1.94l0.1,-0.73l-0.45,-1.48l-0.89,-1.02l0.11,-1.38l-0.9,-1.3l-1.03,-4.24l0.24,-0.73l0.57,-0.34l-0.59,-0.76l0.3,-0.66l-0.8,-0.63l0.03,-0.54l-1.48,-1.22l-1.03,-2.08l6.63,-2.52l2.75,-1.62l2.33,-1.91l3.53,-4.05l0.69,-3.04l-0.23,-5.08l-1.67,-4.35l-1.46,-2.05l-2.07,-1.67l-2.34,-1.18l-2.38,-1.8l0.34,-1.38l3.43,-3.62l-0.34,-0.91l0.52,-0.69l-0.0,-0.5l1.1,0.73l0.62,0.0l0.12,-0.71l-0.48,-0.53l0.73,-0.78l-0.2,-0.92l0.37,-0.63l-0.14,-0.59l-0.79,-0.22l0.09,-0.54l-1.07,-1.89l0.66,-0.61l0.11,-0.65l-1.31,-0.5l0.71,-0.88l0.13,-0.69l-2.51,-0.14l1.87,-2.46l-0.03,-1.74l1.04,-0.86l-0.06,-0.65l-2.44,-2.01l-0.55,-2.03l0.01,-1.22l1.01,-0.91l2.5,-1.09l2.42,0.36l5.34,1.64l0.02,0.98l0.49,0.08l2.07,-0.99l1.55,0.36l1.89,1.12l0.46,-0.02l0.05,-0.79l4.4,-1.95l4.02,2.66l1.01,0.05l-0.03,0.81l-0.51,0.86l0.32,0.6l1.38,-0.62l1.18,0.61l0.73,0.85l-0.72,0.26l0.06,0.82l1.3,-0.12l0.69,-0.56l0.74,0.36l-1.03,1.04l0.6,0.65l0.07,0.56l1.7,1.44l3.75,0.87l2.24,-0.1l0.33,0.16l0.37,1.14l0.86,0.33l1.48,-0.45l0.66,-1.1l0.15,0.15l0.31,0.95l-1.13,1.09l-0.66,1.77l0.06,1.31l0.56,0.95l-0.11,0.65l-1.22,0.34l-3.47,-0.06l-0.39,0.59l0.48,0.52l4.32,0.42l0.64,1.5l-0.57,1.4l0.08,1.31l1.62,0.28l-0.46,0.71l0.13,0.78l-0.48,1.39l-0.17,0.13l-0.55,-0.84l-0.42,-0.04l-0.52,0.8l-1.31,0.42l-0.31,0.44l0.35,0.56l2.09,0.51l2.62,-1.45l2.77,-0.13l1.28,0.95l0.27,1.05l0.46,0.5l-0.39,2.0l-0.65,0.93l-2.88,1.11l-0.2,0.44l0.55,0.43l3.32,-1.18l1.62,-3.09l0.4,0.88l-0.81,1.02l-0.02,0.48l0.74,0.05l1.06,-1.18l0.08,2.11l0.79,0.03l0.47,-1.5l2.7,-1.56l1.58,-0.47l1.75,-2.18l1.1,1.16l0.11,1.17l0.41,0.37l0.42,-0.23l0.44,-1.26l-0.61,-1.55l0.95,-0.31l-0.12,-0.77l2.09,-0.44l0.43,-0.42l-0.22,-0.52l-1.22,-0.49l0.57,-0.79l0.75,-0.19l-0.26,-0.9l1.38,0.68l0.55,-0.04l-0.01,-0.81l-1.73,-0.99l-0.27,-0.46l0.18,-0.84l1.88,0.24l0.04,-0.77l-0.54,-0.57l1.18,-2.54l0.73,-0.46l0.9,0.45l0.21,0.29l-0.36,0.38l-1.22,0.63l0.02,0.67l0.54,0.14l1.95,-0.48l0.33,0.44l-0.04,1.96l0.96,-0.46l1.12,1.85l-0.73,0.43l-0.04,0.78l0.86,0.35l0.36,0.62l0.96,-0.45l0.39,0.65l-0.8,0.51l-1.66,0.19l-0.21,0.63l0.47,0.35l0.75,0.0l2.14,-0.4l0.42,1.6l1.14,-0.04l0.52,0.98l-2.36,1.42l-0.92,1.42l0.7,0.24l1.4,-1.0l0.38,0.4l2.2,-0.61l-0.85,1.46l-2.32,1.41l0.11,0.66l0.57,0.08l1.19,-0.66l2.15,-0.43l1.05,1.35l1.62,0.38l-0.28,0.54l0.17,1.08l-2.74,1.0l0.08,0.46l0.74,0.41l2.29,0.17l-0.36,1.21l0.76,0.45l1.11,0.09l1.27,1.06l-0.18,1.92l-3.04,-0.21l-1.02,-0.32l0.12,-0.37l-0.75,-0.31l-0.88,0.31l-0.07,0.62l0.68,0.62l2.26,1.04l-0.38,0.25l0.01,0.67l1.7,0.46l-0.37,0.79l0.32,0.42l1.53,0.09l0.12,0.57l-0.61,0.46l0.28,0.58l1.31,0.29l0.63,0.66l0.73,-0.04l0.69,-0.53l0.91,1.27l0.7,0.15l0.32,-0.31l-0.12,0.91l0.84,0.96l-0.69,0.62l-1.3,2.52l0.73,0.16l1.8,-1.21l2.09,-0.48l0.33,0.75l0.56,0.16l-1.39,1.57l0.03,0.96l0.49,-0.09l2.8,-2.58l0.86,0.21l1.34,2.32l2.01,0.47l1.95,-0.75l0.26,0.68l0.55,0.41l1.85,0.64l-1.09,0.97l-2.28,0.26l-1.71,1.02l-0.88,1.11l-1.35,0.1l-2.96,1.39l-1.64,0.0l-1.4,0.81l-0.33,0.82l-1.41,-0.26l0.04,0.76l1.13,0.68l-0.73,0.54l-0.18,1.19l0.47,0.2l1.05,-0.34l1.55,-1.32l2.63,-0.99l3.39,-2.32l3.51,-0.77l0.4,-0.32l-0.25,-0.51l2.26,0.29l1.26,2.19l-1.96,1.23l1.01,1.23l0.6,0.16l2.4,-1.83l1.49,-0.17l0.72,0.96l1.2,0.27l0.6,0.66l0.78,1.63l-0.44,1.24l0.27,2.43l-1.96,0.29l-0.47,0.35l0.26,0.65l1.4,0.05l1.33,0.34l-0.97,-0.15l-0.5,0.47l1.71,1.31l-1.59,1.48l-4.84,3.17l-2.37,-0.11l-1.65,0.32l-1.29,0.7l-2.55,0.22l-3.41,3.52l-2.25,1.91l-0.97,0.46l-0.48,0.73l-0.8,0.33l-3.77,0.05l-4.42,0.89l-1.11,-0.81l-4.08,-0.46l-2.14,0.05l-0.64,0.34l-3.0,-0.47l-1.69,0.29l-5.65,-0.32l-2.45,0.39l-0.91,-0.22l-1.05,0.58l-1.88,-0.04l-2.55,1.65l-2.07,4.12l-4.56,0.99l-0.13,0.55l-1.32,0.44l-0.71,0.8l-1.32,0.75l-2.3,2.93l-1.33,1.09l-3.44,-1.1l-3.24,-0.58l-0.45,0.28l0.22,0.48l1.04,0.61l1.7,0.09l3.09,1.13l0.23,0.25l-0.56,1.43l-2.75,2.62l-1.27,1.77l-2.82,2.17l-3.13,0.72l-1.57,0.78l-0.43,0.56l-2.01,1.18l-1.57,0.52l-2.55,2.99l-1.26,0.24l-1.49,1.23l-1.29,-0.17l-0.42,0.25l0.49,0.71l1.03,0.33l-3.3,2.06l-2.49,0.72l-4.4,3.31l-3.91,1.27l-0.96,-0.27l-1.58,0.17l-2.14,1.04l-6.38,0.99l-2.53,1.38l-1.68,2.1l0.01,0.6l0.45,0.44l1.11,0.28l1.08,0.06l0.91,-0.36l0.04,0.88l0.42,0.72l-3.34,0.06l-2.12,0.38l-1.07,0.45l-0.95,0.9l-2.64,-0.5l-1.98,0.21l-1.83,1.2l-0.6,0.82l-2.32,0.91l-1.0,0.92l-0.54,-0.22l-1.37,0.2l-0.61,-0.26l0.18,-0.8l2.53,-0.09l0.68,-0.39l0.13,-1.1l-0.79,-0.44l0.78,-2.45l1.55,-0.69l1.92,-1.75l0.1,-4.34l0.78,-1.67l1.41,-1.59l0.12,-1.23l0.36,0.43l0.8,-0.25l0.02,1.05l0.6,0.02l0.81,-0.51l1.0,0.84l2.05,0.6l0.55,-0.25l0.31,-0.62l0.03,-0.68l-0.45,-0.69l0.92,0.49l0.89,-0.02l0.21,-1.13l-1.71,-1.38l-0.3,-2.04l-1.42,-0.13l-0.26,-1.25l-0.29,-0.24l-0.28,0.2l-1.61,-2.21l-1.6,-0.04l-0.32,-0.43l-1.74,0.11l-0.13,-0.57l-0.61,-0.22l-0.47,0.28l-3.25,-0.75l-3.4,0.07l-2.15,-0.35l-3.0,-0.71l0.1,-0.66l-0.59,-0.67l-1.78,0.27l0.89,-2.17l-0.58,-0.52l-1.42,-0.24l0.86,-1.76l-0.23,-0.63l-1.85,-1.48l0.76,-2.22l-0.95,-0.36l-3.27,0.13l-1.34,-0.5l-0.87,-1.06l-0.89,-2.49l-0.68,-1.02l-1.66,-0.59l-2.78,0.19l-4.12,-1.47l-1.46,0.2l-0.04,1.04l-1.15,-0.12l-0.86,1.84l-0.5,-0.21l-2.39,1.05l-0.65,2.02l-1.0,0.71l-1.56,0.04l-1.03,-0.79l-3.19,0.08l-0.92,-0.67l-3.05,0.98l-2.47,-1.58l-1.0,-0.25l-0.98,0.29l-0.49,-0.89l-2.57,-1.17l-2.14,-0.05l-1.59,0.59l-1.69,-0.85l-2.84,-0.54l-0.73,-1.49l-0.37,-2.15l-1.76,-0.53l-0.45,0.39l-0.03,2.1l-140.63,-0.01l-0.67,-0.48l-0.6,-0.01l-0.59,-0.64l1.16,-0.19l0.43,-0.84l-0.17,-0.47l-0.9,0.44l-0.84,-0.16l0.25,-2.07l-0.58,-0.02l-0.81,0.86l-0.02,0.58l-0.68,0.29l-1.29,-0.43l1.19,-0.58l0.22,-0.64l-1.15,-0.05l-0.34,-0.33l-0.1,-1.34l0.61,-0.84l-0.65,-0.85l-0.73,-0.1l-0.15,0.61l0.3,0.38l-0.51,1.13l-0.66,0.48l-1.08,0.07l-1.61,-1.39l-1.33,-2.45l0.92,-1.44l-0.19,-2.02l-0.86,0.5l-0.14,1.13l-0.46,0.8l-1.75,0.06l-0.06,-0.67l-0.7,-0.23l-0.41,1.1l-0.46,-0.29l-1.61,0.07l-0.5,-0.12l1.52,-0.34l0.29,-0.63l-0.74,-0.35l-2.24,0.29l0.53,-0.54l-0.2,-0.57l-0.39,-0.11l-0.09,-1.1l-0.37,-0.3l-0.78,0.97l-1.94,0.31l-1.4,-0.48l-1.6,-1.25l0.33,-1.43l1.02,-1.15l3.36,-0.5l0.5,-0.51l-0.38,-0.35l-3.35,-0.03l-0.82,0.33l-0.86,1.11l-0.53,-0.9l-0.06,-0.81l0.63,-1.05l-0.55,-0.62l0.21,-0.7l1.66,-1.02l0.64,-0.17l0.45,0.48l0.74,0.14l1.48,1.57l0.56,-0.56l-1.16,-1.72l-1.26,-0.93l1.22,-1.51l-0.29,-1.21l-0.41,-0.21l-0.39,0.44l-0.11,0.97l-2.27,1.99l-1.47,0.56l-1.2,2.62l-0.8,-1.38l1.28,-0.86l0.08,-1.11l0.46,-0.49l0.08,-0.49l-0.48,-0.23l-1.0,0.62l0.86,-2.47l-0.35,-0.64l-1.64,0.41l-0.44,-1.87l-0.76,-0.8l-2.1,-0.85l-0.32,-0.81l0.75,-0.84l-0.19,0.51l0.3,0.54l1.84,0.96l1.12,-0.26l0.82,0.23l1.03,0.96l0.48,0.03l0.05,-0.83l-1.03,-1.04l-0.64,-0.31l-1.46,0.06l-0.64,-0.41l-0.38,-1.0l1.0,-0.53l0.02,-0.67l-1.11,-0.5l-1.6,0.67l-1.29,1.41l-0.32,1.64l-1.24,0.75l-1.65,-1.89l-1.61,-0.63l-0.17,-0.22l1.09,-1.44l0.21,-1.03l1.2,-0.23l0.84,-0.45l0.2,-0.44l-1.23,-0.35l-1.45,0.35l-1.39,-1.23l0.33,-1.48l0.66,-0.51l1.68,-3.09l1.64,-2.07l0.04,-0.46l-0.93,-0.05l-0.59,-0.84l-0.47,0.43l-0.13,1.4l-0.55,-1.98l0.36,-2.76l-0.45,-0.87l-1.65,-0.2l-0.52,-0.83l-0.76,-0.21l-0.59,-0.59l-1.71,-0.46l-2.46,-1.38l-1.1,-0.01l-0.44,-1.43l-0.87,-0.33l0.27,-0.88l-0.29,-0.5l-1.03,-0.25l0.25,-0.83l-5.99,-8.32l-0.05,-0.73l-2.12,-2.18l-2.41,-1.43l-0.86,-1.5l-2.47,-1.46l-0.53,-0.94l-0.07,-1.29l-2.58,-1.69l-2.31,0.98l-1.94,0.43l-0.24,0.62l0.24,0.43l-0.63,0.05l-0.42,0.4l-0.0,1.25l-0.4,0.68l-1.15,0.06l-2.87,1.59ZM487.59,210.08l0.47,0.08l0.0,0.0l-0.21,0.06l-0.27,-0.14ZM564.27,340.47l-1.87,-0.22l-0.02,-0.17l0.48,-0.17l0.59,0.26l0.41,-0.33l0.41,0.64ZM507.25,309.52l0.4,0.45l-0.55,0.63l0.24,-0.47l-0.09,-0.61ZM325.09,304.42l-0.29,-0.32l-0.04,-0.19l0.27,0.37l0.06,0.14ZM543.35,335.39l-0.36,-0.67l-0.03,-0.4l0.7,0.69l-0.31,0.37ZM542.65,333.85l-0.26,-0.09l-0.68,-0.9l0.67,0.03l0.27,0.96ZM645.85,327.78l0.37,0.89l-0.43,0.9l0.52,0.4l-1.01,0.11l-0.61,-0.67l-0.15,-1.92l3.02,-4.56l1.57,-1.23l0.49,1.27l-0.86,3.02l-2.9,1.79ZM646.83,329.86l1.35,-0.19l1.4,-1.28l0.15,-0.27l-0.66,-0.51l0.08,-0.49l0.84,-0.82l0.61,0.61l1.45,0.12l-0.28,0.33l0.09,0.64l-2.28,1.6l-1.36,0.38l-1.4,-0.1ZM578.3,333.68l3.21,-1.7l1.2,-0.29l0.55,-1.42l1.51,-2.31l2.14,-1.07l3.12,-2.31l4.24,-1.28l3.95,-1.86l2.29,-2.22l3.11,-3.86l3.21,-2.52l2.97,-1.72l8.34,-3.28l2.08,-0.56l3.3,-0.35l3.38,0.48l2.6,1.56l-0.83,-0.03l-0.4,0.31l1.35,1.26l-0.38,1.24l-1.45,0.45l-0.88,1.01l-2.17,1.12l-3.51,-1.04l-0.71,0.49l-1.93,-0.05l-1.31,0.63l-0.22,0.41l0.69,0.42l1.33,-0.33l2.57,0.96l1.21,1.55l0.9,-0.07l2.03,-0.95l0.15,0.27l1.09,0.15l-0.78,2.0l-1.95,1.61l0.01,0.65l0.74,0.38l1.49,-0.17l-0.14,1.41l0.34,0.8l0.48,0.31l0.54,2.07l0.72,0.8l2.8,0.42l-0.46,0.22l0.02,0.73l1.73,1.0l1.12,-0.04l1.26,0.79l2.45,-0.03l0.32,0.69l1.55,0.11l2.33,-1.33l0.83,1.1l1.74,0.01l0.56,0.78l-0.84,0.82l1.18,0.35l-10.3,3.71l-1.72,-0.13l0.09,1.16l-0.72,-0.13l-0.89,-0.83l-0.79,0.48l-1.03,0.07l-0.5,0.89l0.21,0.69l-2.83,2.82l-0.95,0.73l-0.87,0.09l-1.07,1.15l-0.84,-0.05l-0.86,-1.44l-0.69,-0.28l-0.49,0.19l-0.31,-1.51l0.43,-1.55l1.12,-1.2l-0.1,-0.27l1.32,-0.37l0.62,-0.48l0.04,-0.54l3.68,-2.1l1.43,-0.44l0.36,0.72l1.41,0.69l0.23,-1.23l1.62,-0.55l1.6,-0.12l0.66,-0.7l-0.33,-0.32l-3.78,-0.29l-2.54,0.0l-1.02,0.43l2.79,-2.54l-0.4,-0.59l-0.65,0.11l-0.63,-0.7l-0.68,0.19l0.13,0.86l-0.69,0.82l-5.53,2.61l-0.5,-0.27l0.14,-0.85l-0.48,-0.07l-0.8,0.52l0.01,0.77l-1.08,0.62l-0.55,-0.2l-1.52,0.43l-0.32,-0.46l-1.68,-0.35l-0.49,0.18l-0.33,-0.33l0.18,-0.5l-0.25,-0.66l0.32,-0.53l-0.35,-0.98l-0.89,0.02l-0.65,-0.52l-0.24,-8.63l-2.39,-1.79l-3.51,0.89l-0.33,-0.21l-0.29,-1.19l-0.99,-0.24l-0.41,0.15l-3.9,4.86l-0.37,1.79l-0.94,1.31l-0.23,2.12l-0.64,1.04l-1.36,1.13l-0.1,0.78l-0.68,0.6l-2.43,0.29l-0.93,1.64l-14.28,0.02ZM496.0,27.1l3.35,-1.66l0.31,-0.49l-0.37,-0.56l-4.18,-0.25l-3.36,1.02l-1.46,-0.71l3.39,-1.64l2.27,-0.6l5.68,-0.49l4.18,-1.79l2.5,-0.43l3.17,0.48l1.97,1.18l1.27,-0.9l0.94,-0.19l2.24,0.3l2.65,0.9l3.16,-0.35l0.35,-0.65l-0.85,-0.63l-6.44,-1.82l3.18,-0.74l2.72,-1.44l1.82,-0.52l2.56,0.92l3.91,0.58l2.93,2.27l2.03,0.85l1.5,0.16l0.55,-0.56l-0.19,-0.52l-1.84,-1.01l0.55,-0.15l4.81,1.56l7.31,1.77l3.91,1.53l0.19,-0.69l-1.15,-1.03l-2.61,-1.21l-6.82,-2.03l-2.67,-1.05l-2.04,-1.28l3.74,-1.06l-0.11,-0.68l-1.68,-0.72l1.97,-0.08l3.97,0.83l0.32,-0.81l-1.67,-1.59l0.42,-0.15l1.68,0.12l3.01,0.8l5.37,0.4l1.46,-0.06l0.36,-0.27l-0.51,-0.7l-4.3,-1.14l-1.87,-1.04l0.54,-0.14l3.53,0.07l3.32,0.53l2.91,-0.19l2.37,0.28l5.32,2.65l1.29,1.42l1.15,0.33l2.32,-0.94l0.12,-0.62l-7.44,-4.47l6.23,-0.44l6.73,0.43l1.02,0.28l2.48,1.72l2.24,1.04l3.22,0.66l0.45,-0.23l-0.13,-0.48l-2.97,-1.57l-0.86,-0.63l0.11,-0.46l2.8,-1.2l3.69,-0.31l5.68,2.59l0.48,-0.26l-0.15,-0.59l-1.92,-0.97l2.09,-0.67l4.54,-0.23l2.46,1.27l5.48,0.15l2.51,0.62l7.0,0.21l-1.54,0.77l-7.83,1.81l-0.78,0.73l0.37,0.32l5.55,-0.19l8.49,-2.2l2.16,0.53l1.18,-1.17l0.77,-0.12l2.14,1.56l2.67,-0.64l1.92,0.29l-0.53,0.59l0.08,0.48l2.72,1.77l-0.84,1.08l0.51,0.56l3.88,-0.86l3.89,0.38l1.02,0.24l1.1,1.25l-0.2,0.46l-4.48,2.84l-7.16,2.42l-4.93,1.36l-3.46,-0.09l-2.36,1.18l-4.67,0.35l-1.61,1.63l-9.01,2.31l-0.43,0.62l0.3,0.55l1.04,0.16l14.35,-2.99l4.25,-0.03l-3.19,1.81l-4.21,1.66l-2.15,1.28l-9.73,4.33l-4.68,3.48l-0.81,0.17l-1.92,-0.33l-2.54,-1.54l-0.82,-0.03l0.18,0.86l2.15,2.64l-5.97,1.0l-2.29,0.07l-1.02,0.52l0.21,0.65l2.39,0.43l3.84,-0.6l1.0,0.18l-0.61,0.51l-2.99,0.99l-0.27,0.42l1.14,0.6l-1.05,0.73l-2.88,0.69l-2.27,0.08l-5.2,-1.54l-3.52,-0.6l-1.39,0.06l-1.46,0.47l-0.27,0.37l0.94,0.63l5.35,0.66l1.06,1.12l-0.04,0.66l-0.83,0.46l-2.08,-0.07l-1.67,0.42l-6.62,0.57l-2.83,-0.67l-4.28,-0.45l-0.34,0.65l0.49,0.42l2.68,0.8l1.07,1.06l2.53,0.96l2.69,0.44l2.76,-0.31l-0.17,1.34l-3.18,0.09l-3.57,-0.93l-7.56,0.68l-6.05,-0.2l-0.34,0.58l0.43,0.45l3.38,1.26l7.04,-0.91l2.17,0.42l1.56,1.1l3.46,0.34l2.97,1.2l-0.4,0.83l-1.44,0.72l-7.92,0.41l-0.22,0.42l0.33,0.33l5.66,1.6l-1.51,1.01l-1.54,2.23l-0.36,0.13l-1.87,0.02l-3.17,0.7l-2.47,-0.22l-3.19,0.21l-0.42,1.31l0.06,3.42l-0.89,0.96l-0.99,0.44l-7.1,0.73l-3.31,-0.16l-5.54,-2.28l-0.47,0.72l1.48,1.45l-3.14,0.31l-0.43,0.41l0.13,0.44l1.2,0.78l1.8,0.05l2.11,-0.59l2.11,0.25l2.39,1.07l1.64,-0.5l2.02,-0.02l0.58,0.29l0.15,1.92l0.64,0.56l2.29,0.59l2.47,-1.02l1.24,1.14l0.06,0.77l-1.34,1.71l-6.19,2.73l-5.96,1.39l-1.06,-0.05l0.8,-1.99l-0.92,-1.01l-1.24,-0.51l-2.63,0.2l-1.61,-1.42l-1.35,-0.25l-1.14,-0.73l-0.48,0.09l-0.03,0.49l1.53,2.13l-7.97,0.13l-1.55,-2.18l-0.43,-0.17l-0.3,0.36l-0.24,3.06l-4.06,0.5l-2.63,-0.45l-2.16,-0.88l-1.79,-1.62l-0.99,0.87l-0.53,1.25l-2.93,-0.64l-0.61,-1.28l-0.45,-0.22l-0.32,0.38l-0.03,1.69l-3.89,-0.18l-0.42,-3.51l-0.32,-0.38l-0.44,0.22l-0.6,1.3l0.28,2.07l-4.37,-0.54l0.1,-1.41l0.2,-1.56l5.37,-2.86l5.22,-0.34l2.97,-0.57l-0.01,-0.7l-1.38,-1.26l-1.84,-0.54l-1.6,-1.42l-1.46,-2.24l0.22,-0.39l1.18,-0.5l3.6,-0.59l3.11,0.88l1.0,0.63l3.01,3.13l4.6,1.16l3.97,-0.33l1.98,-0.6l3.69,-3.23l1.32,-1.87l0.37,-1.18l-0.15,-0.42l-0.44,-0.02l-4.29,4.09l-1.7,0.92l-1.79,0.09l-1.82,-0.41l-1.82,0.65l-1.75,-0.49l-0.01,-1.99l-1.13,-1.69l4.32,-2.68l1.82,0.22l0.45,-0.29l-0.24,-0.48l-1.61,-0.81l-1.55,0.04l0.55,-2.69l-0.26,-0.46l-0.49,0.19l-1.2,2.35l-1.9,1.78l-0.74,0.32l-2.32,0.23l1.08,-2.27l-0.13,-0.48l-4.31,2.07l-3.09,0.19l-0.7,-0.32l0.24,-2.29l2.65,-2.66l0.7,-1.15l8.93,-1.51l8.82,1.59l1.6,-0.83l4.3,-0.24l1.99,-1.01l0.31,-0.44l-0.36,-0.59l-3.55,0.81l-8.63,-0.63l-1.2,-0.36l-0.52,-0.52l1.06,-0.17l2.23,0.72l1.66,-0.19l-0.53,-0.86l-2.77,-1.56l-5.5,-5.05l-4.02,-0.72l-1.73,-1.25l-0.35,-1.87l-0.57,-1.18l0.49,-1.3l0.76,-0.56l5.71,0.54l5.62,0.11l1.62,0.37l5.29,2.74l5.07,3.57l3.47,0.87l3.03,0.07l1.86,-0.76l0.21,-0.42l-1.17,-0.44l-3.62,-0.15l-4.24,-3.0l-2.43,-1.29l-3.08,-2.41l1.89,-0.48l7.98,-0.83l4.75,-0.99l2.3,-1.45l6.21,-1.59l7.78,-0.96l0.37,-0.4l-0.31,-0.54l-9.12,-0.71l0.29,-0.64l1.63,-1.39l3.78,-1.83l2.67,-0.83l0.74,-0.54l0.13,-0.49l-0.45,-0.23l-5.56,1.21l-3.99,2.21l-2.4,0.42l-1.15,1.07l-0.74,1.53l-0.97,0.69l-1.86,0.91l-4.42,1.28l-6.9,1.1l-1.79,-0.07l2.84,-1.74l0.1,-0.46l-0.4,-0.24l-6.14,0.72l-4.12,2.07l-4.64,0.19l-2.86,-0.69l-2.72,0.17l-1.51,-0.55l1.64,-1.37l5.04,-2.33l2.85,-0.64l6.78,-0.73l0.61,-0.74l-0.38,-0.6l-12.82,1.37l-2.39,1.05l-5.53,3.31l-1.82,0.15l-6.07,-1.76l-1.32,-0.81l3.82,-0.73l5.23,0.13l4.71,-0.57l7.2,-2.57l0.96,-0.95l-0.36,-0.3l-2.47,0.02l-2.47,0.55l-3.78,1.42l-3.27,0.49l-8.21,0.27l-2.62,0.4l-1.03,-0.08l-1.47,-0.87l1.76,-0.68l1.63,-0.19l0.5,-0.53l-0.29,-0.35l-1.77,-0.51l4.73,-1.76l5.06,-0.09l0.48,-0.42l-0.3,-0.57l-4.61,-0.48l-2.61,0.29l-6.71,1.69l-0.8,-0.14ZM501.93,137.7l3.09,0.16l4.35,0.94l3.48,-0.41l0.44,-0.35l-0.17,-0.65l-3.69,-1.82l-6.24,-0.77l-3.05,-1.24l-0.6,-0.47l-0.86,-3.8l0.37,-1.05l1.44,-1.22l-0.29,-0.64l-0.71,-0.42l-0.02,-1.35l2.55,-3.74l0.65,-2.9l1.17,-1.3l1.05,-0.56l0.38,-0.95l2.67,-1.85l2.22,-1.22l4.78,-1.08l4.09,-0.16l4.19,0.41l0.43,0.27l0.07,0.2l-3.53,2.24l-1.71,1.54l-3.23,4.34l-0.27,1.35l0.41,1.1l1.34,1.84l-0.09,3.18l0.71,2.35l2.45,2.51l3.44,2.33l-1.55,0.89l-2.75,0.6l-2.76,1.15l-0.59,0.3l-0.11,0.64l0.58,0.31l1.17,-0.26l3.43,-1.26l2.62,0.0l0.12,0.78l0.99,0.59l0.7,-0.34l0.27,-0.77l0.64,-4.92l-0.43,-0.63l-0.72,-0.26l-2.46,-0.32l-1.25,-1.54l-1.23,-0.95l1.4,-0.68l1.0,-1.19l1.39,0.13l3.42,1.58l0.35,0.08l0.49,-0.5l-0.44,-0.64l-2.25,-1.66l0.81,-0.36l-0.16,-0.8l-1.26,-0.3l-1.49,0.22l-0.99,-0.47l-1.09,-1.48l-0.09,-1.36l0.82,-1.22l0.71,-0.19l5.04,1.5l0.51,-0.47l-0.34,-0.67l-5.67,-2.19l1.93,-1.95l1.95,-0.5l1.04,-0.65l1.5,-0.03l1.52,0.4l0.52,-0.41l-0.56,-0.88l2.15,-0.83l3.77,-0.96l3.56,-0.0l1.65,0.32l1.14,0.81l1.03,2.85l0.65,0.68l2.07,1.12l0.1,1.93l1.46,1.5l-4.78,4.17l0.12,0.73l0.44,-0.01l2.48,-1.63l-1.43,1.64l-0.09,0.52l0.57,0.55l-0.63,0.78l0.25,1.67l1.07,-0.18l2.16,-2.12l0.94,-0.52l1.43,0.32l0.26,-0.66l-1.02,-1.19l1.01,-0.71l1.08,1.21l1.07,-0.19l0.5,-0.41l1.16,0.83l0.11,2.32l1.26,1.12l1.16,0.53l0.35,-0.73l-1.35,-1.84l0.19,-1.34l0.38,-0.51l1.21,0.61l1.54,0.0l2.07,0.96l1.07,0.02l0.4,-0.5l-0.4,-0.68l-3.73,-1.32l-0.8,-0.79l0.49,-0.83l2.92,-1.16l4.25,0.04l3.59,1.43l2.46,0.01l1.98,0.83l0.75,0.84l0.32,1.07l-1.6,1.63l-0.85,0.41l-1.93,2.71l0.21,0.68l0.86,-0.35l1.18,-1.67l2.16,-1.28l1.15,-0.33l1.84,0.13l1.02,0.29l0.23,0.42l-0.39,0.87l-2.78,1.05l-1.56,0.15l-0.33,0.55l0.36,0.4l1.87,0.2l-0.53,1.05l0.13,0.93l-0.93,1.54l0.33,0.69l0.47,-0.05l1.21,-1.13l0.88,-2.39l0.48,-0.5l1.57,-0.24l1.43,-0.84l0.25,0.05l-2.3,2.75l-0.04,0.48l1.14,-0.04l1.63,-1.32l0.91,0.71l0.52,1.05l1.52,0.88l0.16,-1.02l-0.51,-1.46l1.66,-1.15l1.4,0.58l3.67,0.46l2.01,0.87l0.96,0.88l0.17,0.67l-1.27,1.13l-2.28,0.12l-3.44,2.34l-0.27,0.61l0.37,0.25l1.88,-0.1l1.5,-1.64l1.14,-0.26l1.79,0.63l1.09,-0.0l1.67,-1.16l0.62,0.32l0.1,1.09l-0.52,0.81l-1.25,1.03l-2.92,1.03l-1.49,1.2l-0.02,0.7l1.05,0.39l1.45,-1.41l0.44,0.19l-0.77,3.17l0.41,0.51l0.44,-0.19l2.15,-4.12l0.58,-0.51l1.42,-0.84l2.96,-0.95l1.24,0.54l2.57,0.17l3.44,1.42l0.46,0.69l-1.99,1.23l-2.51,0.41l-2.13,0.84l-1.85,1.09l-0.18,0.63l0.33,0.37l1.51,-0.05l1.6,-1.04l3.34,-0.39l-1.32,1.39l0.14,0.64l1.7,0.32l1.26,-1.09l1.5,-0.59l-0.04,-0.73l-0.31,-0.17l0.85,-0.81l0.9,0.28l2.4,2.17l0.78,1.46l-0.03,0.73l-2.63,-0.5l-1.29,0.07l-1.77,1.13l-1.52,0.02l-2.41,0.66l-0.85,0.79l0.4,0.54l3.69,-0.58l3.08,1.05l3.4,-0.01l2.27,1.06l0.29,0.84l-4.27,-0.1l-1.89,-0.66l-1.22,0.38l-1.14,-0.24l-1.09,0.24l-2.23,1.0l-0.06,0.69l0.58,0.22l2.88,-0.81l1.33,0.33l1.63,0.7l-0.47,1.62l-2.02,-0.5l-2.05,0.3l-3.11,-0.58l-0.35,0.15l0.11,0.71l2.42,0.95l3.33,0.49l0.22,0.7l1.19,0.9l1.56,-0.19l1.03,0.46l2.34,0.29l-0.5,0.68l0.99,1.27l-0.44,1.06l0.3,0.51l0.86,-0.33l0.03,0.31l0.66,0.28l0.51,-0.87l-0.06,-0.86l1.2,-0.32l-0.21,1.5l-1.3,1.79l0.69,0.52l0.89,-0.22l1.29,-1.46l0.17,0.58l0.57,0.3l1.61,-0.48l-0.16,1.58l0.81,0.98l0.52,0.07l0.23,-0.52l-0.18,-1.38l1.97,-1.21l-0.93,1.33l0.32,0.71l1.28,0.18l1.01,-0.45l2.19,1.76l0.87,-0.12l0.25,0.23l-0.85,0.8l0.21,0.76l-3.03,-0.01l-0.36,0.31l0.2,0.44l1.53,0.44l0.42,0.42l2.65,-0.07l1.29,-0.93l2.11,0.83l-0.79,1.56l-2.15,1.63l-0.15,0.44l0.37,0.28l3.8,-1.08l2.91,0.36l1.48,-1.16l3.67,3.06l-0.64,0.26l-2.04,-1.0l-1.26,0.34l-0.09,0.67l2.37,1.19l0.27,0.54l-1.13,0.39l-1.26,-0.19l-1.15,-0.63l-1.19,0.04l-0.14,0.65l0.48,0.49l-0.44,0.58l0.19,0.55l2.13,1.06l-2.16,-0.19l-0.53,0.24l0.07,0.65l0.99,0.95l-1.02,0.89l-0.25,0.61l-2.12,-0.14l-1.37,-1.54l-0.7,0.18l0.23,0.97l-0.92,0.22l-0.3,0.4l0.29,0.48l1.23,0.31l-0.05,2.88l-0.91,2.0l-1.18,-1.28l-1.07,-0.17l-0.5,0.33l-0.54,-0.49l0.34,-1.64l-0.4,-0.52l-0.66,0.47l-0.95,1.65l-2.3,-2.46l-1.41,-2.39l0.9,-1.07l1.78,-0.73l0.94,-1.52l1.04,-0.94l-0.12,-0.73l-1.43,0.35l-1.73,1.73l-1.96,0.66l-1.89,-0.02l1.0,-1.08l-0.12,-0.65l-2.08,0.59l-1.99,-1.15l-1.6,-2.36l-1.4,-0.7l-0.26,0.8l-1.08,-0.28l-0.58,0.3l0.59,1.89l-2.91,-1.53l-0.6,0.42l1.03,2.14l2.39,1.76l-0.47,0.43l-2.13,-0.3l-3.17,-2.37l-1.83,0.38l-0.26,0.37l0.26,0.38l1.42,0.23l1.08,0.68l-0.25,0.95l0.42,0.77l1.48,0.81l-0.39,1.36l0.23,0.45l0.64,0.1l1.48,-0.62l0.65,0.36l0.88,1.06l-0.63,0.45l0.26,0.61l1.15,0.72l0.44,1.24l0.76,0.22l0.64,2.03l0.42,0.23l0.45,-0.38l0.04,-1.04l1.41,0.85l-0.29,0.67l0.55,0.58l0.69,-0.04l1.04,-1.19l0.6,0.18l1.3,1.2l0.53,-0.04l0.32,0.31l-1.08,0.88l0.44,0.57l1.82,0.1l-0.47,0.73l-1.8,-0.03l-0.24,0.71l1.3,0.66l0.83,0.92l0.06,0.72l1.01,0.25l1.27,-0.18l-0.33,0.21l0.02,0.69l1.02,0.09l0.54,1.06l-0.55,0.45l0.32,1.79l-0.13,1.31l-1.67,-3.08l-1.07,-1.02l-0.48,-0.05l-0.18,0.44l0.81,2.6l0.12,0.78l-0.29,0.73l1.74,2.49l-1.53,-0.51l-0.61,0.24l0.48,2.23l-2.05,-1.77l-0.89,-0.52l-0.62,0.05l-1.83,-1.44l-0.33,-0.08l-0.27,0.86l-0.35,-0.14l-1.16,-1.82l-0.43,-0.14l-0.29,0.85l-1.18,-1.16l-1.01,-0.04l-3.54,-3.39l-0.48,0.04l-0.1,0.47l0.65,1.65l-3.16,-2.1l-2.39,-0.09l-0.26,0.85l0.62,0.88l3.36,3.46l2.03,0.71l0.18,0.69l1.8,0.72l2.0,1.72l1.65,0.74l1.85,2.36l1.35,0.62l-0.7,0.77l0.38,1.15l-0.89,0.2l-5.64,-2.19l-5.62,-0.84l-2.88,-1.26l-2.49,-2.77l-1.26,-0.24l-2.09,0.22l-3.89,-1.71l0.53,-0.93l-0.38,-0.23l-1.57,0.59l-1.02,-0.56l-1.72,-1.75l1.13,-0.15l1.36,-1.37l-2.05,-1.47l-2.51,-0.05l0.55,-0.9l-0.22,-0.54l-1.66,0.53l-0.82,-1.46l-3.72,-3.06l0.74,-1.05l-0.4,-0.66l-3.33,0.05l-0.47,1.13l-0.39,-1.36l-1.65,-0.29l-0.76,-1.36l-0.66,-0.22l-1.51,0.68l1.27,2.12l-1.63,0.27l-2.21,-0.69l-1.16,0.14l-0.55,1.14l-1.55,0.08l-3.64,1.12l-4.63,-1.01l-1.79,-1.88l-0.06,-0.8l0.63,-1.8l0.77,-0.63l2.67,-1.06l0.16,-0.56l-0.47,-0.93l0.45,-0.62l4.02,0.71l3.25,1.16l1.42,1.27l-0.39,1.07l0.9,0.85l0.6,-0.17l0.44,-1.74l-0.53,-0.86l-1.32,-1.06l2.51,0.21l1.0,-0.82l2.45,0.08l1.46,-0.98l1.09,-0.23l2.21,0.27l0.39,-0.44l-0.05,-0.48l-0.99,-2.03l-1.58,-1.06l-1.84,-1.95l4.12,-2.74l1.54,-1.43l1.36,-0.55l1.21,-2.54l2.06,-0.83l0.89,-1.17l-0.01,-0.6l-0.65,-0.61l-1.9,-4.07l-1.79,-2.67l-1.25,-1.3l0.09,-0.94l-0.53,-0.15l-1.49,0.61l-0.65,-0.44l-0.21,-0.51l0.47,-1.62l-0.67,-1.02l-1.63,0.04l-0.13,0.58l0.55,0.77l-1.54,-0.25l-1.08,-1.06l-0.25,-0.86l-0.46,-0.14l0.29,-0.49l-0.51,-0.62l0.52,-0.35l-0.12,-0.68l-1.08,-0.13l-1.61,1.28l-1.66,-0.33l-0.66,0.63l-3.05,1.4l-1.4,0.24l0.21,-2.1l0.63,-0.26l2.34,0.13l1.56,-1.22l0.21,-0.68l-0.94,-1.4l-3.33,-1.26l-0.18,-0.65l1.18,-0.37l0.29,-0.46l-0.32,-0.39l-1.54,-0.21l-1.18,0.96l-1.08,-0.33l0.86,-0.72l-0.08,-0.65l-1.0,-0.64l-2.72,-0.05l-0.84,-3.39l-0.63,-0.31l-2.15,0.2l-1.7,-1.14l-2.32,-2.32l-1.41,0.72l-0.89,1.47l0.59,0.7l1.94,0.63l0.53,0.9l0.03,1.14l-1.23,0.66l-2.01,0.32l-5.81,-1.49l-4.62,-0.55l-0.63,0.17l-0.1,0.71l2.32,1.02l1.57,1.46l-3.02,-1.77l-3.89,0.91l-4.36,-1.56l-3.67,0.42l-8.0,-1.35l-1.86,0.66l-2.49,-0.88l-0.77,-1.54l0.43,-1.34l-0.5,-0.11l-1.44,0.65l-2.24,-0.16l-0.46,0.63l0.13,0.26l-2.08,-0.06l-1.24,0.63l-2.52,-1.72l-2.21,-0.69l-1.79,-2.13l-0.83,-2.2ZM642.14,249.05l0.51,0.1l0.23,0.22l-0.22,-0.01l-0.52,-0.3ZM629.46,302.55l1.09,-0.1l5.26,1.11l5.31,2.54l1.43,1.16l-2.13,0.12l-4.1,-0.94l-2.56,-1.1l-0.55,-0.87l-1.11,-0.85l-2.62,-1.06ZM629.68,323.28l1.26,-1.52l-0.45,0.81l0.07,0.5l0.91,0.84l0.15,0.83l-0.5,-0.02l-0.05,-0.79l-0.34,-0.4l-1.05,-0.26ZM632.84,325.02l0.28,-0.41l3.0,0.84l-1.39,0.87l-1.41,-0.37l-0.44,-0.4l-0.03,-0.52ZM636.6,325.42l1.51,-0.21l2.49,-0.17l-2.13,1.22l-0.14,1.26l-0.98,-0.07l-0.74,-2.04ZM627.42,226.93l0.4,-0.02l0.8,0.7l-0.91,-0.39l-0.29,-0.29ZM627.36,210.92l1.2,0.03l0.12,0.12l-0.74,0.41l-0.77,-0.15l0.2,-0.41ZM624.41,217.96l2.61,-0.02l0.37,0.33l-0.08,0.66l-0.49,0.5l-2.42,-1.47ZM625.39,215.77l0.41,0.44l0.34,0.21l-0.55,-0.23l-0.2,-0.42ZM610.36,150.7l0.61,-0.25l0.5,0.01l-0.41,0.46l-0.69,-0.21ZM609.36,228.23l1.11,-1.87l0.81,0.55l-0.29,0.6l-1.62,0.71ZM596.07,208.6l2.01,0.81l0.63,0.78l-1.77,-0.33l-0.86,-1.26ZM582.09,330.79l-0.0,0.03l-0.03,0.01l0.03,-0.03ZM576.77,164.83l1.43,-0.2l4.02,0.68l0.45,0.16l0.16,1.01l-5.0,-0.11l-0.8,-0.72l-0.26,-0.83ZM575.49,161.59l-2.1,-1.37l0.39,-0.89l1.05,0.26l0.79,1.27l-0.13,0.72ZM571.51,162.6l2.53,0.74l0.23,0.33l-0.27,1.64l0.19,2.88l-0.49,1.32l-0.88,0.7l-1.86,0.69l-4.58,0.4l-1.32,-0.19l-0.67,-1.07l-0.72,-2.37l0.36,-1.14l1.4,-2.03l1.61,-1.53l1.08,-0.32l3.4,-0.05ZM545.75,114.47l0.28,-0.67l-0.52,-0.86l0.04,-1.09l0.8,-0.19l6.33,1.24l6.63,-0.07l4.23,1.41l0.99,1.37l1.3,0.5l0.97,1.47l1.23,0.59l-0.0,0.89l0.87,0.84l-1.04,0.25l-7.34,-0.74l-2.5,0.15l-4.2,1.07l-1.71,0.14l-2.03,-0.94l-1.4,-3.6l-2.22,-0.46l-0.62,-0.47l-0.11,-0.84ZM566.12,203.45l-0.75,-0.12l-1.69,-1.08l0.5,-0.32l1.63,0.76l0.38,0.37l-0.06,0.39ZM563.44,152.77l0.74,-0.14l1.9,0.36l-1.12,1.34l-0.77,0.25l-0.67,-0.36l-0.09,-1.46ZM557.5,203.63l2.67,-0.08l0.89,0.36l0.66,1.02l-1.65,0.71l-2.57,-2.0ZM556.46,151.27l0.48,-0.47l1.58,-0.39l0.29,-0.5l0.61,0.36l-2.24,1.01l-0.71,-0.01ZM552.97,156.94l0.69,-0.92l1.53,-0.62l0.73,-1.08l0.76,-0.31l-0.03,-0.68l1.33,-0.17l-0.02,0.37l-1.26,1.06l-1.54,1.99l-1.95,0.64l-0.25,-0.26ZM555.85,258.16l0.06,-0.43l0.03,-0.1l0.01,0.14l-0.1,0.38ZM550.22,260.33l0.64,-0.78l0.31,-0.3l-0.84,0.99l-0.11,0.09ZM552.29,259.02l0.63,-0.68l0.7,-1.76l0.83,0.74l0.12,0.7l-0.35,0.61l-0.25,-0.31l-0.61,0.02l-1.6,2.29l0.71,-1.15l-0.17,-0.45ZM554.51,162.98l-0.4,-0.19l0.05,-0.34l0.56,-0.09l0.25,0.23l-0.46,0.39ZM553.88,89.25l0.02,0.22l-1.19,0.39l-1.16,-0.11l3.25,-2.3l-0.89,1.18l-0.03,0.62ZM552.35,288.12l0.2,-0.08l-0.07,0.07l-0.13,0.01ZM551.71,212.06l1.1,1.37l-0.24,1.16l-2.01,3.11l-2.04,-1.54l0.04,-2.0l1.51,-1.99l1.65,-0.11ZM547.12,149.9l0.49,-0.51l0.69,-0.03l0.65,0.55l2.62,-0.65l0.67,0.46l-0.59,0.38l-1.51,0.18l-0.77,-0.21l-0.46,0.58l0.24,0.44l-2.02,-1.19ZM464.85,80.8l0.83,-0.21l0.24,-0.83l-1.88,-0.98l0.13,-0.29l5.34,-0.89l6.87,1.62l2.42,-0.02l2.64,1.35l0.21,0.7l-1.44,1.87l-0.19,0.94l1.04,-0.2l2.11,-1.5l3.49,0.03l3.81,-0.73l2.04,0.23l2.59,1.28l-3.88,-0.44l-0.6,0.64l0.43,0.72l2.91,0.21l7.84,1.4l-0.51,0.43l-4.51,0.32l-4.91,-0.75l-0.75,0.1l-0.22,0.68l0.87,0.74l2.92,0.88l2.26,0.23l2.18,1.24l0.63,0.83l1.03,0.02l1.02,0.55l0.19,0.18l-0.62,0.72l-1.57,0.98l0.37,0.59l1.69,-0.02l1.99,1.17l0.8,-0.34l0.2,-0.65l-0.27,-0.95l0.4,-0.19l2.33,1.44l2.58,-0.55l0.86,0.86l0.5,-0.1l1.12,-1.17l2.19,1.25l2.92,0.87l1.54,0.13l0.63,-0.71l-0.44,-0.73l1.77,-0.47l1.17,0.04l1.92,-0.73l2.03,-0.12l3.42,-1.67l3.43,0.7l5.47,-0.84l4.45,0.77l0.25,0.73l0.49,0.29l4.06,0.3l0.62,0.37l-0.53,0.34l-0.04,0.64l0.33,0.2l2.86,0.25l0.64,1.45l-4.39,2.26l0.14,0.58l0.72,0.36l3.05,-0.18l0.87,0.56l-2.17,0.53l-2.18,-0.68l-0.27,0.6l0.83,0.81l-0.36,1.85l-4.7,0.15l-3.54,0.94l-4.89,-0.89l-0.74,-1.01l0.05,-1.28l-2.42,-1.14l-0.48,0.17l-0.11,0.45l0.99,1.16l-0.8,1.48l-4.32,0.71l-1.86,-0.31l-1.35,-0.68l-0.44,0.33l-0.09,0.57l-1.47,-0.84l-0.68,0.7l-1.24,0.33l-1.52,-0.41l-1.16,0.25l-1.96,-0.42l-0.27,0.79l-8.31,-0.15l-0.36,-0.24l0.07,-0.38l1.0,-1.77l-0.22,-0.53l-1.1,-0.5l-0.95,0.33l-0.57,0.85l-0.62,-0.75l-1.54,0.56l-0.12,1.18l-1.53,0.64l-1.38,0.06l-3.51,-0.65l-1.71,-0.94l0.31,-0.78l-0.62,-0.3l-1.28,0.83l-0.33,0.76l-1.38,0.04l-1.99,-1.26l-0.99,-2.38l0.34,-0.19l0.1,-0.71l-1.68,-1.74l-0.04,-0.87l1.77,-2.67l-0.61,-2.22l-4.68,-5.41l-1.48,-0.22l-1.99,0.92l-4.51,-0.26l-3.31,0.35l-0.97,-1.04l-2.55,-0.9l1.38,-0.5l0.38,-0.75l-1.9,-0.05l-3.1,-1.29ZM513.14,201.88l1.19,-1.91l2.54,-1.17l0.97,-0.79l-0.53,-3.73l0.94,-3.63l0.58,-4.35l1.23,-2.33l1.03,-0.58l1.6,1.24l0.28,0.77l-0.66,1.04l1.02,0.84l0.81,1.55l0.9,-0.04l1.32,-1.56l1.08,0.69l1.05,1.31l3.01,0.71l1.42,1.39l2.8,1.52l3.03,1.05l1.25,1.67l0.54,1.66l-1.01,1.08l-0.01,0.66l1.23,0.14l1.92,-0.43l1.68,0.35l0.75,-0.5l0.92,0.78l-0.33,0.36l0.29,0.41l1.56,0.55l-3.34,2.23l-4.6,-1.62l-2.03,-0.34l-0.49,-1.77l-2.7,-0.72l-0.0,-0.83l-0.55,-0.39l-1.29,0.13l-1.59,0.77l-0.8,2.04l-1.44,1.19l-1.52,0.66l-1.6,2.17l-1.6,0.86l-2.04,0.58l-0.52,-0.92l-0.75,-3.11l-0.56,-0.64l-4.22,0.29l-1.52,0.72l-1.23,-0.06ZM539.59,280.92l0.58,-0.54l3.34,-0.15l1.73,1.79l0.23,0.65l-5.87,-1.75ZM534.48,328.45l0.17,-0.1l0.15,0.24l-0.13,-0.01l-0.19,-0.13ZM536.92,329.16l0.04,-0.58l0.39,-0.25l1.17,0.66l0.88,-0.68l0.46,1.16l-0.8,0.6l-2.13,-0.91ZM530.86,213.12l-0.96,-1.73l2.58,-3.32l1.87,0.3l1.38,-0.56l2.4,-0.27l0.97,0.19l-0.7,1.72l-4.49,3.43l-1.65,-0.25l-1.4,0.48ZM527.23,181.66l2.67,1.22l0.3,0.27l-0.26,0.56l-1.12,0.19l-0.25,-1.22l-1.35,-1.02ZM532.16,184.95l0.17,0.02l-0.06,0.03l-0.11,-0.04ZM529.08,326.21l0.37,0.1l0.17,0.1l-0.27,0.23l-0.26,-0.42ZM525.38,185.5l-1.58,-1.37l-0.33,-1.63l0.57,0.05l0.81,1.14l0.72,1.54l-0.19,0.27ZM466.13,40.6l1.5,-0.38l2.39,0.19l0.28,-0.68l-0.33,-0.35l-2.62,-1.77l0.07,-1.15l0.74,-0.25l3.41,0.41l0.86,0.39l0.95,0.97l4.92,0.14l0.38,-0.29l-0.69,-0.77l-2.89,-0.67l-1.08,-1.33l-3.31,-0.95l0.98,-1.32l1.28,-0.51l2.38,0.21l3.5,-0.88l2.63,0.18l0.75,-0.86l-0.46,-0.95l-0.81,-0.41l-3.5,-0.18l-0.33,-0.61l4.19,-0.28l1.45,0.21l3.13,0.81l1.99,1.05l3.69,4.01l3.0,1.95l0.35,1.19l4.01,1.14l1.85,-0.46l1.23,0.26l0.33,0.39l-0.31,0.61l0.25,0.43l-0.22,1.29l1.96,1.38l3.38,0.65l0.54,-0.33l-1.03,-1.64l-1.18,-0.41l-0.1,-0.96l0.41,-0.25l1.85,-0.11l2.06,0.6l0.17,1.58l-1.22,0.67l-0.27,0.42l0.19,0.59l3.61,0.65l0.92,1.39l-0.77,2.43l-0.75,0.94l0.19,0.59l2.13,-0.11l1.4,-0.62l1.44,0.12l0.59,0.23l0.81,1.34l0.46,0.21l1.57,-1.47l2.82,3.16l-0.97,0.65l-4.09,1.23l-3.13,1.38l-1.3,0.04l-0.75,1.3l-2.55,2.0l-1.11,-0.55l-0.18,-1.44l0.68,-1.45l-0.08,-0.51l-0.46,-0.17l-1.16,0.6l-0.82,0.97l-0.02,2.17l-0.38,1.06l1.3,0.68l0.04,0.48l-0.47,0.39l-0.5,-0.16l-1.74,-1.22l-1.04,0.29l-0.13,0.44l0.66,1.98l-0.82,1.94l-1.06,-0.2l-4.91,-4.48l-0.51,0.26l-0.15,0.98l2.59,3.35l-2.4,-1.3l-1.79,-0.23l-1.29,0.37l0.11,0.65l1.34,0.86l-4.97,-0.29l-4.72,-1.36l-2.07,-1.13l4.43,-0.67l0.35,-0.31l-0.53,-0.64l-6.89,-0.57l-1.38,-1.1l1.91,-0.01l0.29,-0.36l-0.25,-0.39l-3.79,-1.09l-1.09,-0.74l4.15,-1.52l2.37,-0.21l0.99,-0.49l0.6,-0.94l5.99,-0.88l0.53,-0.64l-0.4,-0.28l-4.71,-0.0l-1.27,-0.75l-1.79,-0.13l-5.73,1.82l-0.24,-0.02l0.47,-0.32l0.08,-0.61l-1.17,-0.31l-1.61,0.14l-3.36,1.12l-1.1,-0.71l-1.65,-0.39l0.12,-0.93l5.62,-1.5l0.83,-0.97l-0.39,-0.61l-4.55,0.96l-2.69,-0.22l-2.96,-1.93l-0.54,-0.67l-0.6,-1.87l4.31,0.69l5.83,0.21l0.57,-0.38l0.02,-0.77l1.4,-0.48l0.36,-0.59l-0.36,-0.28l-1.67,-0.08l-4.03,0.78l-1.12,-1.02l-2.12,0.01l-1.53,-0.73ZM514.35,164.16l1.01,-1.37l0.82,0.5l0.29,2.36l-0.8,1.31l-1.04,-0.66l0.24,-1.2l-0.52,-0.94ZM512.66,146.44l0.56,-0.22l2.28,0.31l0.23,0.29l-0.66,0.13l-2.4,-0.5ZM495.93,80.57l1.8,-0.54l0.8,0.01l0.78,0.51l0.24,0.27l-0.65,1.02l0.18,1.0l-1.3,-0.2l-1.84,-2.07ZM499.04,74.64l-1.76,0.55l-3.79,-1.23l-0.73,-0.77l0.09,-1.68l1.23,-0.33l3.25,0.62l2.11,1.5l0.05,1.02l-0.45,0.31ZM496.34,152.96l0.42,-0.22l0.29,0.15l-0.33,0.55l-0.38,-0.47ZM482.1,107.73l2.92,0.77l1.84,1.09l3.2,-0.52l2.7,0.18l2.28,0.56l1.07,0.6l-0.92,1.4l-1.88,1.57l-1.59,2.17l-1.42,0.58l-0.04,0.74l0.3,0.34l-1.63,2.17l-1.6,1.49l-1.17,0.28l-4.87,-0.81l-4.5,0.44l-0.34,0.3l0.16,0.42l2.24,0.86l0.92,0.96l0.08,0.86l-1.56,1.57l-1.16,2.27l-1.77,-0.39l-3.12,0.21l-0.34,-4.29l-1.79,-3.69l-0.19,-7.7l0.86,-0.39l3.57,0.9l0.39,-0.32l-0.26,-0.55l-0.9,-0.37l-1.09,-1.47l-0.04,-0.52l0.38,-0.42l2.67,-0.83l3.66,-0.08l1.77,-0.57l1.15,0.17ZM494.98,153.24l0.12,-0.01l0.22,0.31l-0.07,-0.09l-0.27,-0.21ZM470.31,69.69l1.39,0.41l8.36,-0.18l1.67,0.6l-0.76,0.35l-0.86,1.57l-1.37,0.15l-10.84,-0.34l-1.16,-1.0l0.41,-0.74l3.16,-0.81ZM465.05,98.52l0.92,-1.47l1.18,-0.48l0.34,-1.24l2.08,-1.55l3.08,-0.94l1.91,-0.01l1.85,0.76l2.48,1.93l1.17,1.94l-0.23,0.95l0.44,1.88l-0.43,1.6l-5.4,0.21l-2.89,-1.49l-2.98,-0.4l-1.19,-1.03l-0.97,-0.05l-0.72,-0.66l-0.64,0.07ZM473.82,89.36l1.34,-0.39l0.77,1.62l-1.59,-0.03l-0.51,-1.2ZM456.17,58.61l1.09,-0.2l3.31,0.24l4.51,1.28l0.95,0.7l0.54,0.84l1.33,0.3l2.01,-0.12l2.56,0.91l0.48,0.39l-1.65,0.76l-0.48,0.55l0.16,0.61l1.78,1.15l-1.03,0.93l-1.29,0.07l-2.84,0.83l-2.35,0.17l-2.45,0.71l-0.05,-1.03l-2.77,-1.34l2.62,-0.3l0.65,-0.56l-0.3,-0.57l-4.23,-0.84l-1.11,-0.93l-0.22,-0.75l-1.13,-0.82l1.06,-0.42l0.21,-0.58l-1.35,-1.98ZM449.92,155.81l0.31,-0.43l2.78,-0.35l2.15,-1.3l0.43,-0.67l-0.39,-0.8l0.38,-0.28l-0.13,-0.41l1.09,0.76l1.1,-0.09l-1.3,-2.22l0.34,-0.7l1.82,-0.52l1.54,0.91l-0.17,0.69l0.41,0.43l0.96,-0.33l1.77,1.43l2.9,1.47l1.73,2.82l1.12,1.22l0.85,0.56l1.34,-0.3l-1.87,0.53l-2.94,2.0l-1.44,0.36l-2.02,-0.66l-2.36,-0.05l-3.83,-1.71l-0.39,-0.87l-2.4,0.18l-0.84,-1.07l-1.72,0.62l-0.75,-0.39l-0.48,-0.8ZM469.24,103.1l0.86,-0.16l0.76,0.56l-0.22,-0.03l-1.4,-0.37ZM468.22,152.22l-0.06,-0.28l0.14,-0.43l0.05,0.18l-0.12,0.52ZM469.52,151.1l0.96,0.7l-0.2,0.73l-0.46,0.24l-0.29,-1.66ZM465.94,92.56l1.34,0.58l-0.53,0.4l-1.48,-0.18l-1.4,1.18l-0.77,-0.16l-0.11,-0.49l2.22,-0.71l0.73,-0.63ZM439.92,114.01l0.73,-0.44l1.56,-0.25l2.2,1.43l0.57,-0.2l-0.46,-1.59l-1.56,-0.91l-0.29,-0.75l2.12,-0.39l2.51,0.47l0.74,-0.67l-0.06,-0.43l3.71,1.72l5.09,-0.85l1.65,-0.61l1.17,-0.08l1.68,0.4l0.92,1.24l-0.57,0.53l-2.0,0.52l-0.59,0.57l0.35,0.8l1.55,0.18l-2.66,1.01l-3.2,2.6l-0.18,0.94l0.63,0.59l1.78,-0.85l1.93,-0.07l1.3,0.71l-0.25,0.39l0.25,0.48l1.27,0.81l-0.39,0.85l0.27,0.56l2.96,-0.68l0.41,1.18l-0.11,0.9l-1.69,1.37l1.04,1.05l-0.86,1.59l0.72,0.79l0.04,0.8l-1.53,0.39l-1.34,1.08l-1.66,0.38l-2.94,-0.3l-0.28,-0.28l-0.08,-1.13l-0.3,-0.36l-0.43,0.04l-0.83,1.2l1.34,2.78l-2.02,1.12l-1.51,-0.6l-0.95,-0.0l-2.7,-3.53l-4.51,-3.87l-2.02,-0.59l-1.23,-1.03l-1.58,0.34l-0.93,-0.29l-1.31,-1.65l-2.14,-1.02l-1.41,-1.45l0.74,-1.7l1.47,-0.8l1.23,0.16l0.73,0.99l1.13,0.65l0.91,1.23l0.71,0.43l1.03,0.08l3.12,-0.58l0.49,-0.55l0.18,-1.08l0.61,0.47l0.82,-0.35l0.2,-0.78l-0.78,-1.47l-1.49,-0.62l0.63,-0.41l1.83,0.61l0.86,-0.12l0.33,-0.37l-0.29,-0.41l-2.74,-1.42l-2.71,0.8l-2.9,-1.7ZM447.4,110.0l-0.39,0.1l-0.35,-0.0l0.55,-0.19l0.19,0.09ZM463.64,119.03l-0.62,0.07l-0.5,-0.45l0.22,-1.04l0.52,-0.2l0.98,0.81l-0.26,0.69l-0.35,0.12ZM438.14,87.59l1.51,-1.04l0.12,-0.58l-0.47,-0.36l-1.76,0.02l-0.72,-0.31l1.14,-1.09l0.69,-0.08l1.58,0.39l0.92,0.62l0.53,1.12l4.86,3.0l2.02,0.36l0.61,-0.39l-0.14,-0.68l-1.78,-1.12l2.4,-0.08l0.36,-0.39l-0.34,-0.4l-3.46,-0.62l1.25,-0.22l0.3,-0.43l-0.19,-0.42l-1.07,-0.53l-2.45,-0.4l-0.88,-0.47l0.12,-0.2l2.07,-0.87l2.82,-0.19l0.63,0.07l2.43,1.72l1.73,-0.03l0.32,-0.59l-0.56,-1.24l1.16,-0.57l2.27,1.22l2.41,0.74l-0.11,1.6l0.87,1.21l0.17,0.84l-0.61,1.42l0.23,1.28l-1.23,0.73l-0.18,0.57l0.38,0.41l2.02,0.52l0.12,1.54l-1.23,-0.37l-1.15,0.95l-0.01,1.95l0.88,1.0l-1.64,-0.8l-0.44,0.75l0.59,0.87l-3.31,0.35l-2.31,-0.1l-0.95,-0.34l-1.58,0.66l-2.89,-0.23l-0.93,-1.41l1.26,-0.14l0.37,-0.39l-0.23,-0.49l-2.64,-0.97l2.03,-0.55l2.76,-1.79l2.51,-0.3l0.44,-0.61l-0.41,-0.49l-3.68,0.18l-6.59,0.94l-1.36,-0.17l-5.49,0.97l-0.52,-0.23l-0.15,-0.34l1.63,-0.79l0.81,-0.68l0.47,-0.94l0.81,-0.07l3.41,1.29l1.77,-0.44l0.22,-0.41l-0.31,-0.34l-1.49,0.13l-0.55,-0.51l-0.37,-0.58l0.3,-0.43l-0.27,-0.64l-1.37,-0.16l-0.49,-0.43ZM459.54,103.72l0.63,-0.49l0.46,-0.03l-0.1,0.13l-1.0,0.4ZM451.16,109.99l2.23,-0.87l5.4,-0.9l-2.77,1.63l-2.01,0.11l-1.45,0.43l-1.4,-0.42ZM453.05,44.6l0.11,1.44l-0.45,1.08l-1.49,-0.53l-0.33,-0.75l-0.93,-0.55l-2.56,-0.01l-0.36,-0.99l0.21,-0.72l1.41,-0.52l3.51,0.36l0.49,0.27l0.4,0.93ZM422.32,57.55l1.07,-1.41l0.01,-0.7l-1.22,-0.61l-2.97,0.21l-0.02,-1.02l0.7,-1.49l2.64,0.13l5.74,-0.47l2.55,0.63l1.3,0.67l1.24,1.43l-0.33,0.94l0.7,1.43l0.58,0.21l0.42,-0.24l0.69,-1.28l1.9,-0.7l1.14,0.01l3.13,1.37l-0.54,0.97l0.39,0.8l1.22,0.21l2.34,-0.4l1.97,0.95l1.86,1.54l-1.08,1.14l0.46,1.95l1.13,0.43l2.1,1.71l0.54,0.92l-0.64,1.31l-3.81,0.65l-3.01,-1.01l-0.75,-0.82l-0.33,-1.17l-1.61,-1.4l-4.99,-0.95l-2.86,0.33l-0.49,-0.41l0.18,-0.34l-0.39,-0.6l-4.83,0.57l-1.41,0.65l-2.67,-0.35l-1.2,-0.59l-1.0,-1.36l0.95,-0.44l4.88,0.66l1.12,-0.24l0.68,-0.76l-0.11,-0.58l-0.64,-0.36l1.18,-0.54l0.09,-0.65l-1.03,-0.47l-2.7,0.0l1.12,-0.78l0.15,-0.45l-1.7,-1.25l-1.45,0.39l-1.85,1.52l-0.52,0.11ZM446.42,155.7l0.23,-0.19l0.22,0.6l-0.3,-0.13l-0.15,-0.28ZM444.47,157.69l0.11,-1.39l0.44,0.02l0.91,0.82l-0.21,0.74l-0.41,0.29l-0.36,-0.46l-0.47,-0.01ZM440.82,81.98l0.4,-0.09l-0.29,0.09l-0.11,0.0ZM441.49,81.81l1.02,-0.71l1.67,-0.16l-0.86,0.32l-1.83,0.55ZM444.23,141.37l1.03,0.39l-0.04,0.35l-0.88,-0.33l-0.11,-0.41ZM353.8,138.14l2.52,-1.34l9.81,-2.1l0.21,-0.65l-0.22,-0.22l2.1,0.09l1.11,-0.38l-0.2,-0.73l-1.6,-0.43l-10.9,1.46l-2.02,-0.34l1.59,-0.62l0.7,-0.93l-0.31,-0.64l-4.24,0.1l-1.32,-0.32l-0.42,-0.5l0.14,-1.73l1.71,-1.64l1.15,-0.39l0.96,-0.83l-0.06,-0.54l-1.27,-1.15l0.4,-0.69l5.58,-3.6l13.25,-4.44l1.91,0.62l0.67,1.98l-0.25,1.81l-2.0,2.32l0.11,0.84l1.12,0.04l3.16,-0.77l0.77,0.17l0.7,-0.7l0.2,-1.5l0.74,-0.77l0.89,-0.35l1.53,0.08l3.56,0.94l3.75,1.58l-0.41,0.86l-1.22,1.23l-1.45,0.77l0.12,0.71l0.99,0.47l0.48,0.01l1.36,-1.16l0.42,0.62l0.86,-0.03l1.93,-1.67l2.79,-1.17l0.31,-0.42l-0.11,-1.23l-1.82,-1.0l-0.49,-0.67l2.9,0.18l4.44,2.46l0.53,0.44l0.14,0.82l1.12,0.36l2.83,7.8l1.63,1.04l0.89,0.08l0.68,-0.9l1.81,-1.08l0.15,-1.2l-1.92,-2.33l-0.62,-2.67l-0.54,-0.77l-1.57,-5.69l0.06,-0.39l1.25,-0.28l0.04,-0.71l-0.49,-0.52l1.3,0.16l3.02,1.31l0.47,-0.02l0.63,-0.74l0.42,0.07l5.08,2.45l0.89,0.75l0.96,1.21l0.95,3.63l2.17,4.91l2.14,3.05l0.15,1.63l-1.09,2.64l0.36,0.66l1.81,1.32l1.19,1.6l1.93,1.24l2.55,1.14l0.77,-0.19l0.18,-0.53l4.66,2.77l1.57,0.06l0.44,1.2l2.5,0.08l0.43,0.76l0.33,1.83l-0.23,0.88l-0.84,-0.05l-0.7,-0.45l-0.48,-0.98l-0.6,0.02l-0.66,1.21l-2.92,-1.29l-2.08,1.24l0.02,1.4l-1.29,-0.11l-2.22,-1.08l-0.84,0.3l-0.14,0.7l0.24,0.3l1.85,1.28l-0.42,2.09l0.56,0.42l1.78,-1.57l1.65,-0.86l1.3,-0.09l0.48,0.25l-0.38,0.67l0.14,0.91l1.28,0.63l-0.27,1.03l-5.03,1.68l-2.87,0.13l-2.98,-0.5l-1.41,-0.54l-1.35,0.46l-2.44,-0.39l0.65,-0.84l-0.38,-0.63l-5.65,-0.71l-0.79,-0.42l-0.06,-1.26l-0.41,-0.49l-1.52,-0.35l-1.28,0.96l-0.9,1.47l-1.94,1.52l-4.71,0.6l-2.99,1.57l-2.62,0.72l-6.93,0.86l-1.47,-0.08l-1.01,0.42l-8.59,0.53l-0.87,-0.39l-1.57,-1.97l-0.23,-2.24l-0.72,-1.76l-3.27,-0.68l-6.63,-0.13l-4.44,-1.24l-2.86,-3.29l-0.4,-2.0l2.94,-0.79l9.97,-1.26l9.99,0.8l2.36,-0.46l1.98,0.02l0.98,-0.38l0.06,-0.65l-0.48,-0.4l-2.13,-0.95l-8.49,-2.27l-11.43,0.97l-1.68,-0.34l-3.45,0.18l-2.9,-0.23l-3.71,-2.81ZM435.02,68.68l3.8,-0.1l2.6,0.95l-4.73,0.45l-1.36,-0.35l-0.31,-0.94ZM441.45,151.89l-0.06,-0.26l0.16,0.18l-0.1,0.08ZM436.25,158.94l0.9,-0.75l0.91,0.47l-0.44,0.76l-1.37,-0.48ZM431.04,90.56l0.96,-0.93l-0.1,-0.64l-1.09,-0.45l-2.78,0.66l-0.45,-0.18l0.57,-0.66l-0.26,-0.66l-2.16,-0.11l-0.5,-0.38l0.11,-0.3l6.14,-1.3l2.26,0.22l0.42,1.75l2.04,1.41l-1.49,0.52l-0.78,0.9l-2.88,0.16ZM431.02,65.13l0.56,-0.51l0.9,-0.15l-0.76,0.55l-0.71,0.11ZM424.16,82.36l2.23,-0.5l0.22,0.87l1.51,-0.17l0.7,0.63l2.33,0.78l-1.68,0.66l-4.25,-0.02l-1.05,-2.25ZM422.82,97.28l0.97,-1.75l1.3,-0.71l1.26,0.05l0.97,0.47l0.92,1.69l-0.64,0.63l-2.33,0.46l-1.55,-0.29l-0.9,-0.55ZM422.07,160.33l1.5,0.12l0.58,0.52l-0.77,0.01l-1.31,-0.65ZM416.93,70.17l1.65,0.11l1.4,0.95l1.31,1.32l0.31,1.01l1.15,0.25l1.01,0.71l0.34,0.74l-0.14,0.62l-0.76,0.25l-2.4,-0.59l-1.6,-1.71l-2.27,-3.67ZM412.25,113.78l1.36,-1.43l6.44,-0.69l3.2,1.42l0.35,1.14l-0.14,1.01l-0.98,1.68l-1.41,1.63l-1.03,0.68l-3.46,-2.58l-0.69,-1.15l-1.83,-1.11l-1.81,-0.6ZM360.07,92.18l0.64,-0.68l0.77,-0.24l6.75,-0.72l2.54,-0.59l0.27,-0.44l-0.4,-0.34l-7.32,0.07l-0.68,-0.25l0.37,-0.47l-0.2,-0.8l2.36,-0.95l6.58,0.3l0.36,-0.33l-0.75,-0.67l-4.6,-0.6l-0.0,-0.32l1.03,-0.9l2.86,-0.61l2.26,-0.04l1.55,0.46l0.6,1.49l1.37,1.13l3.49,-0.5l2.25,0.55l3.87,2.52l-0.83,0.57l0.13,0.67l2.75,0.24l1.22,2.03l1.31,0.8l10.7,0.37l0.78,-1.07l-0.21,-1.42l-4.52,-2.02l1.9,-0.92l0.26,-0.7l-0.15,-0.69l-1.53,-1.18l-2.51,-0.82l-0.38,-0.56l2.11,-1.23l2.7,-2.53l1.08,-0.49l1.21,-0.09l1.5,0.67l-0.77,1.0l-0.0,0.48l0.65,1.72l1.63,1.17l0.25,0.71l-1.24,1.17l-0.01,0.84l0.82,0.32l2.14,-0.02l0.39,0.39l-1.45,1.63l0.23,0.62l0.76,0.02l1.87,-1.02l1.49,0.1l0.61,0.32l1.0,1.9l0.44,-0.33l0.06,-0.83l1.07,-0.59l-0.84,-1.28l0.72,-0.62l1.21,-0.33l2.41,0.51l1.26,0.6l0.63,1.83l-1.9,5.46l-1.0,0.89l-5.22,1.62l-3.49,-0.74l-3.24,0.54l-0.6,-0.13l0.02,-0.52l-0.34,-0.28l-1.17,-0.21l-3.34,1.81l-4.55,0.72l-2.83,1.78l-3.99,1.37l-3.98,0.85l-2.48,0.15l-3.22,-0.49l-2.51,-1.19l-0.73,-0.65l0.91,-0.59l4.12,-1.11l2.46,-1.01l5.99,-0.46l3.11,-1.85l0.27,-0.93l-1.0,-0.46l-2.35,0.95l-2.98,0.36l-2.05,-0.8l-1.78,1.06l-3.77,0.39l-0.38,-0.28l-0.02,-1.1l1.72,-1.31l0.25,-0.64l-1.01,-0.18l-1.38,0.34l-0.68,-0.56l-0.66,0.41l-0.47,1.54l-1.3,-0.42l-0.44,0.16l-0.12,0.62l0.74,0.93l-0.32,0.37l-2.66,1.06l-1.05,-1.15l-1.09,-0.23l-0.76,0.42l-0.71,1.05l-1.94,-0.69l-1.65,-1.29l-2.9,0.08l-2.4,-0.46l-0.28,-0.44l1.47,-1.45l6.03,-0.35l4.27,-1.53l0.7,-0.54l0.17,-0.6l-0.48,-0.31l-6.59,1.24l-3.23,-0.23ZM406.58,174.16l0.29,-0.0l-0.11,0.21l-0.19,-0.21ZM406.05,169.16l0.47,0.8l-0.03,0.24l-0.49,-0.34l0.05,-0.7ZM379.81,63.23l2.96,-1.41l4.78,-0.84l3.27,-1.5l2.22,-0.53l0.95,0.01l4.5,1.91l0.66,1.56l-0.16,0.52l-1.34,0.27l-5.27,-0.07l-2.08,-0.83l-1.94,1.22l-1.08,-0.08l-2.05,-0.93l-4.46,0.82l-0.94,-0.12ZM380.01,68.35l9.99,-1.93l3.8,-0.17l3.78,0.24l-0.48,0.6l-5.55,1.35l-0.18,0.64l0.9,0.67l2.76,0.1l0.1,1.22l-0.3,0.81l-2.3,0.78l-2.78,0.19l-3.66,0.9l-1.95,-0.19l-1.33,-0.83l-2.59,-0.93l0.3,-0.97l-0.75,-1.56l0.2,-0.94ZM372.18,80.09l1.45,-0.48l2.61,-0.2l1.65,0.7l-0.76,0.46l-4.94,-0.48ZM373.77,66.63l0.46,0.72l2.52,1.09l0.43,0.48l-2.05,0.75l-0.81,-0.01l-1.51,-0.48l-1.77,-1.5l2.74,-1.04ZM315.79,128.42l0.18,-1.02l0.7,-0.33l-0.04,-0.76l1.18,-1.63l1.99,-1.57l0.16,-2.54l2.1,-1.04l-0.13,-0.98l-0.94,-0.36l-0.16,-0.4l1.05,-1.14l0.85,-1.68l1.5,-1.01l0.55,-1.27l1.24,-1.45l-0.49,-0.85l-1.62,-0.74l-2.25,-3.88l15.66,-1.9l4.76,1.92l4.33,1.14l-0.39,0.55l0.11,0.66l0.52,0.05l1.22,-0.86l1.07,0.02l0.18,1.52l0.54,0.31l2.57,-2.19l2.03,-0.31l2.43,0.14l3.73,1.46l5.05,3.5l1.68,0.83l0.99,1.02l-0.01,0.45l-0.38,0.28l-4.9,1.61l-13.33,6.01l-2.22,3.25l-1.17,0.51l-1.68,0.16l-0.73,0.5l-1.34,5.47l-0.73,0.94l-4.09,1.04l-0.79,-0.54l-0.78,0.04l-2.18,1.72l-1.94,0.66l-1.48,0.89l-1.08,0.02l-0.94,-0.6l-1.82,-2.98l-1.85,-1.89l-6.58,-2.81l-2.33,0.07ZM331.11,86.43l1.94,-1.77l4.18,-0.58l2.4,-2.24l3.08,-1.37l0.96,-1.22l6.17,-4.28l5.38,-0.8l2.99,0.69l0.93,-0.01l0.58,-0.41l1.56,0.16l0.84,-0.5l-0.03,-0.66l-1.41,-0.51l0.64,-0.38l1.55,-0.19l1.36,0.31l3.43,1.78l-3.41,1.14l-0.71,0.51l-0.11,0.52l0.34,0.51l2.04,1.34l-1.44,-0.03l-0.58,0.64l1.46,1.88l-1.08,0.72l-3.89,0.82l-0.32,0.3l-0.21,1.61l-0.71,0.74l-1.14,0.08l-2.29,-1.24l0.18,-1.43l0.95,-2.26l-0.28,-0.58l-0.61,-0.14l-2.34,0.77l-0.73,0.97l-0.25,1.09l-1.7,0.48l-0.05,0.87l0.85,0.85l-1.03,0.88l-0.7,1.15l-0.77,-0.12l-1.37,-1.87l-0.92,0.17l-0.42,0.71l0.06,1.11l-0.49,0.76l1.06,0.86l-1.7,1.31l-2.17,0.33l-0.66,-1.68l-1.56,-2.01l-0.76,0.24l-0.67,1.51l-0.79,0.3l-3.54,-0.53l-2.47,0.93l-0.73,-0.32l0.43,-0.73l-0.25,-0.93l-0.41,-0.33l-0.65,0.07ZM348.7,92.43l3.57,-2.6l2.53,-0.94l1.85,-1.17l0.69,0.04l-1.82,2.53l-2.11,2.24l-1.34,0.61l-3.36,-0.71ZM304.86,299.15l1.07,-0.29l1.02,0.45l0.21,-0.39l-0.18,-1.54l-1.55,-0.18l-0.41,0.63l-1.09,0.1l-1.17,-1.05l0.33,-0.4l1.43,-0.18l6.14,2.3l5.93,1.15l2.89,3.93l0.54,1.34l1.13,0.82l3.21,1.31l0.8,0.81l1.63,3.26l0.75,0.03l0.21,0.5l-0.6,0.03l-0.45,0.51l-1.58,-0.33l-5.53,-2.1l-0.37,-0.22l1.39,-1.34l0.22,-1.44l-0.66,-0.25l-0.51,1.23l-2.02,0.09l-0.73,0.36l-0.78,-0.59l0.33,-0.33l-0.02,-0.57l-1.48,-0.65l0.11,-0.46l-0.58,-0.39l-2.6,-0.28l-0.03,-0.3l1.98,-0.46l-0.22,-0.8l-1.0,0.07l-0.87,-0.39l-0.7,-0.99l-1.15,-0.46l-1.1,0.41l-0.47,-1.57l-0.6,-0.11l-0.28,0.36l-0.63,-0.58l-1.48,0.18l-0.12,-0.94l-0.42,-0.25ZM318.16,299.33l0.52,0.81l-0.22,0.34l-0.39,-0.94l0.09,-0.21ZM310.07,303.42l0.08,-0.47l0.61,0.92l-0.33,-0.16l-0.36,-0.29ZM303.82,290.72l0.36,0.38l0.0,0.31l-0.15,-0.13l-0.21,-0.56ZM302.31,283.9l-0.01,-0.41l0.12,-0.19l-0.12,0.6ZM299.11,279.79l1.47,0.95l0.36,1.05l0.21,2.68l-0.35,0.56l-0.06,-2.08l-0.63,-0.36l-0.43,0.52l-1.17,-1.77l0.6,-1.55ZM298.52,283.66l0.24,0.22l0.04,0.06l-0.23,-0.2l-0.05,-0.08ZM297.76,280.11l-0.0,-0.01l0.01,-0.02l0.0,0.03l-0.01,-0.0ZM291.81,277.37l2.12,1.18l0.77,1.05l-0.22,0.1l-2.66,-2.33ZM291.2,274.44l0.56,-0.34l0.49,0.5l-0.31,0.35l-0.74,-0.51ZM282.34,280.67l1.98,-0.59l0.39,0.17l0.49,1.27l-1.3,0.07l-0.28,0.2l0.13,0.71l1.99,0.98l-0.32,0.6l0.26,0.58l-2.53,-2.18l-0.31,-0.48l0.53,-0.71l-1.03,-0.62ZM286.48,285.6l0.38,0.11l-0.07,0.33l-0.24,-0.3l-0.07,-0.14ZM287.53,286.56l0.18,0.0l-0.07,0.06l-0.11,-0.06ZM278.62,273.61l1.57,0.19l0.72,0.41l1.03,-0.24l0.31,0.34l0.22,0.84l-2.06,1.23l0.02,0.44l0.54,0.32l2.12,-0.45l0.42,-1.38l-0.08,-0.87l1.48,-0.4l-1.02,2.12l-0.47,2.92l-1.55,0.48l-1.38,-0.43l1.02,0.21l0.39,-0.53l-2.4,-1.57l-0.93,-1.88l0.04,-1.75ZM247.18,150.81l0.14,-0.08l0.06,0.0l-0.14,0.11l-0.06,-0.03Z",name:"Canada"},SV:{path:"M498.24,510.01l2.69,-2.02l0.04,-0.83l0.4,-0.08l1.42,0.34l1.29,1.21l1.56,0.72l0.45,0.73l1.73,-0.66l0.63,0.49l1.16,0.09l-0.53,2.53l-0.3,0.29l-1.07,0.07l-2.13,-0.61l-1.27,0.01l-2.07,-1.0l-2.7,-0.44l-1.31,-0.83Z",name:"El Salvador"},HT:{path:"M580.72,487.14l-0.81,-0.67l-1.65,-0.68l0.21,-0.8l7.95,1.07l0.97,-0.61l1.22,-0.15l0.35,-0.43l-0.14,-0.81l-2.01,-1.72l0.36,-1.85l-0.18,-0.49l-1.81,-0.91l-1.63,-0.4l2.36,-0.52l3.23,0.95l2.16,0.25l-0.0,1.87l0.48,0.56l-0.78,1.07l0.39,0.84l-0.45,0.62l-0.82,0.19l-0.05,0.51l1.21,1.38l-0.07,0.46l-1.12,-0.52l-4.14,0.4l-2.65,-0.52l-1.45,0.14l-1.12,0.76Z",name:"Haiti"},TT:{path:"M643.52,528.92l0.93,-0.6l0.17,-1.53l-0.28,-0.7l1.93,-0.33l-0.23,0.49l0.15,2.42l-2.67,0.25Z",name:"Trinidad and Tobago"},JM:{path:"M563.41,485.93l1.71,0.33l1.05,0.69l1.72,0.54l0.44,0.7l-1.0,0.07l-1.76,-0.57l-0.62,0.65l-0.64,-0.23l-0.7,0.66l-1.05,-0.44l-1.41,-0.09l-1.43,-1.54l-1.29,-0.34l0.31,-0.37l1.7,-0.38l2.99,0.33Z",name:"Jamaica"},GT:{path:"M487.5,505.99l0.25,-2.03l0.38,-0.47l-0.62,-1.16l2.22,-3.83l6.37,-0.01l0.39,-0.45l0.03,-1.91l-0.98,-0.53l-0.55,-1.15l-1.38,-0.86l-1.27,-1.3l0.96,0.01l0.4,-0.4l0.02,-2.57l8.53,0.01l-0.29,9.94l1.99,0.17l1.41,0.63l0.77,-0.52l0.62,0.38l-4.44,3.3l-0.33,1.31l0.26,0.98l-0.81,0.76l-1.08,0.27l-0.12,0.92l-1.83,1.18l-0.93,1.04l-2.11,-0.78l-2.79,0.01l-1.09,-0.31l-3.99,-2.61Z",name:"Guatemala"},HN:{path:"M502.26,506.51l0.75,-0.7l-0.22,-1.4l0.22,-0.76l0.93,-0.43l3.59,-2.89l0.67,0.01l1.18,-0.86l0.79,-0.15l0.82,0.55l1.25,-0.15l2.04,0.36l2.93,-0.16l2.22,-1.15l2.06,0.59l2.56,-0.46l2.09,0.97l1.4,-0.13l1.06,0.86l-0.51,0.53l0.45,0.84l0.71,0.01l1.02,0.94l0.74,-0.23l0.64,0.22l0.13,-0.28l0.44,0.62l-0.9,0.17l-1.73,0.96l-1.9,0.25l-1.12,0.53l-0.66,-0.08l-1.15,-0.79l-0.91,0.32l-1.1,1.41l-0.19,0.93l-2.71,2.24l-1.32,-0.93l-0.76,0.41l-0.87,1.1l-2.16,0.14l-0.23,0.62l0.25,1.74l-0.89,0.4l-0.51,1.1l-0.93,0.04l-1.08,-1.91l-0.97,-0.13l-0.21,-0.55l0.26,-1.52l-0.56,-0.53l-1.13,-0.04l-1.02,-0.52l-1.26,0.55l-0.33,-0.51l-0.89,-0.23l-2.12,-1.76l-0.83,-0.15Z",name:"Honduras"},BZ:{path:"M502.69,498.61l0.37,-10.07l1.09,0.23l0.57,-0.32l1.77,-2.64l0.22,0.62l0.94,0.05l0.11,0.31l-0.92,3.07l0.26,0.66l-0.37,1.02l-0.11,3.45l-1.14,1.6l-0.74,0.32l-1.16,1.71l-0.88,-0.02Z",name:"Belize"},BS:{path:"M582.19,471.96l0.6,-0.57l1.63,0.08l-0.22,0.3l-2.01,0.18ZM564.14,442.52l0.07,0.5l-0.12,0.1l-0.02,-0.38l0.08,-0.22ZM560.35,454.98l0.39,-0.1l0.0,0.48l0.37,0.24l0.5,-0.1l0.02,1.4l-0.36,-0.03l-0.92,-1.9ZM558.49,452.88l0.34,-0.69l-0.2,-0.32l0.53,-0.85l0.04,-1.03l1.41,2.26l0.04,0.9l-1.0,0.58l-0.29,-0.54l-0.87,-0.31ZM556.78,441.65l0.13,-0.32l0.39,0.16l-0.34,0.1l-0.18,0.07Z",name:"Bahamas"},CR:{path:"M520.07,525.02l0.84,-1.08l3.35,1.21l1.27,-0.52l1.6,0.38l1.02,1.02l1.33,0.23l1.32,-0.39l1.24,2.39l2.84,3.21l-0.83,1.04l-0.0,2.02l0.93,0.65l-0.76,0.8l0.32,1.39l-0.64,0.41l-0.37,-1.17l-1.44,-0.72l-0.4,0.06l-0.3,0.59l0.63,0.83l-0.72,-0.17l-0.38,-0.4l0.46,-0.81l-0.0,-1.05l-0.7,-1.14l-2.53,-1.66l-1.86,-0.57l-0.68,-1.7l-2.7,-1.79l-0.72,0.35l0.14,0.77l0.47,0.65l1.25,0.66l-0.38,0.41l-0.37,0.3l-0.87,-0.94l-1.49,-0.44l-0.95,-1.69l0.89,-1.55l0.03,-0.73l-0.85,-0.82Z",name:"Costa Rica"},US:{path:"M321.51,312.91l3.17,1.24l3.48,0.32l0.75,-0.21l0.58,0.45l1.06,-0.08l0.45,0.94l-0.72,0.39l-1.17,1.57l-0.52,1.54l0.45,0.4l0.64,-0.1l-0.43,0.79l0.26,0.67l1.68,0.18l0.71,-0.37l0.44,-0.83l1.04,-0.86l-0.23,-2.77l0.76,-1.59l-1.0,-1.26l0.19,-0.48l-0.73,-0.93l0.28,-0.43l-0.26,-1.75l-0.77,-0.33l-0.29,-0.68l140.63,0.01l0.4,-0.39l0.03,-2.05l0.58,0.07l1.0,3.41l0.67,0.6l2.89,0.55l1.75,0.87l0.97,-0.07l1.0,-0.52l1.68,0.04l2.33,1.07l0.74,1.14l0.81,-0.36l1.09,0.16l2.69,1.63l0.8,-0.02l2.28,-0.96l0.91,0.68l3.16,-0.07l1.02,0.77l-3.65,1.26l-1.88,1.09l-5.91,4.78l-0.02,0.76l0.69,0.46l2.78,-0.39l3.13,-1.26l-0.7,1.57l0.14,0.63l1.36,-0.29l1.13,0.51l0.83,-0.11l2.57,-1.26l2.59,-0.58l2.09,-1.04l1.08,-0.99l0.82,1.06l0.15,1.4l0.54,0.07l1.08,-0.9l1.98,0.39l0.58,0.32l1.68,2.04l1.72,-0.09l0.47,0.34l1.54,0.21l2.57,-1.47l3.57,-0.16l1.77,-0.47l-0.21,1.21l0.42,0.55l2.58,0.45l0.83,-0.41l0.48,1.05l-0.12,0.72l0.94,0.3l0.18,0.5l-2.01,-0.13l-0.7,-0.37l-0.64,0.33l-0.26,0.71l-1.43,-0.98l-2.06,-0.41l-1.26,0.77l-2.63,0.21l-1.2,1.11l-0.53,-0.65l-1.14,0.22l-0.57,0.76l0.03,-0.97l-0.68,-0.11l-0.66,1.39l-2.54,3.44l-0.15,0.83l-1.04,0.6l-0.86,1.58l-0.15,1.01l0.74,0.45l1.13,-0.74l0.82,-1.12l0.5,-0.14l0.26,0.25l-0.93,2.31l0.0,1.2l-0.88,1.36l-0.01,1.59l-1.04,3.06l0.08,1.53l0.52,1.33l-0.03,3.71l1.28,2.82l1.31,0.91l1.6,-0.18l2.06,-1.18l1.85,-2.94l0.65,-2.21l0.06,-1.63l-1.62,-4.6l0.51,-1.02l-0.37,-1.57l1.05,-1.53l0.25,-2.31l0.6,-0.28l0.29,-0.9l1.01,-0.36l0.59,-0.61l0.01,1.5l1.03,0.24l0.87,-1.74l0.03,-1.45l2.16,-0.77l0.11,-0.55l-0.79,-0.68l0.66,-0.98l0.67,-0.11l2.45,0.87l0.87,0.85l3.02,1.07l0.59,0.99l-0.47,0.25l-0.18,0.57l0.78,1.4l-0.16,2.39l-0.89,0.6l-0.43,1.17l-1.46,0.8l-0.33,1.56l0.64,0.78l1.29,0.3l1.2,-0.84l0.93,-1.39l1.36,-0.51l0.89,0.62l1.44,5.57l-0.32,1.53l-0.1,0.24l-0.61,-0.26l-0.79,0.4l-0.58,1.63l-1.04,0.7l-0.46,1.52l-0.85,0.97l-0.47,1.25l2.1,1.0l0.32,0.94l2.04,-0.01l0.77,0.36l2.0,-0.57l2.15,-0.15l2.51,-1.58l4.58,-1.66l4.22,-2.16l2.03,-1.39l1.41,-1.42l-0.18,-1.92l-0.77,-0.34l0.02,-0.49l4.11,-0.6l3.26,0.79l3.09,0.0l1.33,-0.54l1.21,-0.98l1.17,-0.25l0.47,-0.54l-0.21,-1.52l0.78,-0.89l-0.82,-1.14l2.0,-1.3l0.39,-0.78l1.78,-1.55l1.97,-1.19l17.64,-0.21l1.11,-1.73l0.86,0.11l0.68,-0.41l0.8,0.35l0.43,-0.86l0.64,-0.25l0.03,-0.88l1.31,-1.05l0.69,-1.13l0.3,-2.3l0.95,-1.3l0.29,-1.62l3.69,-4.59l0.38,0.09l0.16,0.96l0.77,0.52l0.79,0.03l2.53,-0.94l2.15,1.54l0.17,7.28l-0.35,1.42l1.9,1.06l0.04,1.81l0.98,0.94l0.74,-0.17l0.1,1.55l0.37,0.37l-0.54,0.49l-1.79,0.22l-0.49,0.51l-0.99,-0.07l-0.9,0.94l-0.85,-0.56l-1.66,0.31l-0.39,0.98l-0.32,-0.11l-0.12,-1.11l-0.63,-0.34l-0.98,0.84l-0.74,2.29l-0.51,0.44l-1.21,0.3l-1.16,-0.2l-0.88,1.04l-0.53,-0.28l-1.31,0.69l-0.46,0.59l0.1,0.56l-1.35,1.42l-1.19,1.91l-0.48,1.49l0.56,1.36l-1.58,1.56l0.05,0.59l1.52,0.6l1.05,2.4l0.85,0.62l-0.79,0.4l-0.05,-0.56l-0.51,-0.39l-2.2,1.14l0.22,-0.77l-0.39,-0.56l-0.51,0.21l-0.57,-0.49l-0.52,0.47l-0.5,2.09l-7.21,0.62l-3.28,1.55l-1.05,0.89l0.01,-1.67l-0.51,-0.54l-0.49,-0.02l0.07,2.24l-1.71,2.32l0.42,0.98l1.07,0.15l-0.34,1.93l-1.07,2.38l-0.83,0.71l-0.12,0.72l-0.79,0.46l-0.88,1.57l-0.11,-0.76l-1.29,-0.44l-1.72,-1.43l0.41,-1.38l1.16,-0.37l0.49,-0.53l0.05,-0.87l-2.07,0.88l-1.07,1.23l0.02,1.47l0.78,1.11l0.14,1.17l1.52,1.94l-0.49,1.01l0.74,0.44l-1.58,2.35l-1.26,2.95l-0.97,0.67l1.4,-2.64l-0.26,-0.53l-0.5,-0.13l-0.39,-0.9l0.13,-0.87l-0.47,-0.52l-0.93,0.36l-0.78,-0.8l0.09,-0.29l0.99,0.09l0.34,-0.6l-1.07,-0.91l0.45,-1.98l-0.51,-0.35l0.55,-0.74l0.92,-0.05l0.35,-0.34l-0.41,-1.27l-0.56,-0.42l-0.73,0.32l-0.2,0.75l-1.12,0.13l-0.44,0.81l-0.87,0.18l0.42,0.9l-0.32,0.59l0.25,0.51l-0.08,1.95l-0.53,-0.33l-0.29,0.43l0.19,1.0l0.91,0.92l-0.93,-0.24l-0.42,-0.62l-0.58,0.01l-0.46,-0.52l-0.79,0.22l1.1,-1.65l-0.03,-0.86l-0.39,-0.36l-0.6,1.12l-0.96,0.89l-0.2,1.56l0.61,0.47l0.84,-0.12l0.33,0.44l-0.8,0.22l0.12,0.44l4.21,3.97l-0.74,0.48l-1.12,-1.13l-0.45,-0.09l-0.19,0.7l0.75,0.95l-1.53,-0.55l-1.37,-0.09l-0.39,0.24l0.09,0.45l2.92,0.99l1.22,1.66l1.32,-0.3l0.96,0.18l0.27,0.87l-0.37,1.44l0.56,1.01l-0.77,-0.33l-2.22,1.47l-0.99,-1.23l-0.38,0.38l0.04,1.57l0.34,0.43l0.59,0.08l2.45,-0.21l-0.1,1.26l0.41,0.43l0.66,-0.27l0.52,-1.24l0.04,1.15l-1.73,1.51l-1.34,-0.29l-0.24,-0.53l-0.47,-0.2l-0.8,0.57l-1.36,-0.51l-0.49,0.12l0.34,0.9l2.11,0.88l-0.35,0.83l-0.53,0.33l-1.16,-0.84l-0.52,0.01l-0.07,0.52l0.49,0.75l1.43,0.66l1.34,-0.09l-1.45,0.66l-2.06,0.08l-0.56,0.49l-0.26,-0.54l-0.45,-0.16l-0.28,0.38l0.04,1.03l-2.19,1.99l-0.25,-0.18l-0.37,0.36l-0.16,1.11l-1.75,-0.03l-1.1,0.32l-1.41,0.9l-1.53,1.82l-0.52,0.1l-0.28,0.51l0.1,0.93l-1.44,0.68l-1.06,1.17l-0.5,-0.1l-0.4,0.91l-1.91,0.82l-1.5,-0.02l-0.25,0.37l0.24,0.34l-0.83,-0.36l-0.24,0.88l0.43,0.81l-0.63,0.37l-0.33,0.87l-0.88,0.33l-0.08,0.71l-0.46,0.37l-0.37,1.03l0.17,0.38l-0.82,0.89l0.35,0.47l-0.66,0.25l-0.1,0.41l-0.29,1.98l1.37,5.68l2.47,5.28l-0.38,0.46l0.46,2.11l3.22,7.28l0.34,1.36l-0.37,4.82l-0.85,1.44l-0.34,1.55l-0.41,0.38l-1.84,0.31l-0.23,-0.6l-0.69,-0.34l-1.2,-2.31l-1.88,-1.04l-0.41,-0.75l-0.27,-1.52l-0.34,-0.36l0.45,-1.21l-0.47,-0.11l-0.65,0.47l0.2,-1.38l-0.32,-0.63l-0.99,0.16l-0.22,0.38l-0.63,-0.87l-1.06,-2.1l1.14,-1.46l0.15,-0.73l-0.3,-0.42l-1.44,-0.52l-0.37,0.66l0.29,0.7l-0.38,-0.3l0.45,-2.01l0.46,-1.47l-0.02,-2.46l-0.68,-1.0l-2.63,-2.2l-2.16,-2.72l-2.05,-1.04l-1.55,0.31l-0.46,0.77l-1.88,0.76l-2.12,0.41l-0.27,-0.77l-1.32,-1.1l0.02,-0.78l-0.37,-0.62l-0.98,0.5l-1.5,-0.63l0.24,-0.27l-0.18,-0.37l-0.92,-0.39l-3.24,0.63l-0.14,-0.83l-0.55,-0.2l-0.71,0.14l-0.84,1.18l-0.74,-0.33l-1.24,0.74l-0.63,-0.84l-0.22,-1.09l-0.85,-0.45l-0.7,1.78l-2.49,0.05l-1.18,-0.33l-2.09,0.39l-1.41,0.98l-3.19,-1.17l-0.94,0.78l-0.41,0.77l0.14,0.53l0.74,0.46l0.77,0.22l1.47,-0.52l0.36,0.94l0.78,0.28l0.43,-0.07l0.44,-0.71l0.22,0.59l-1.41,0.71l-0.38,0.86l1.28,1.3l1.63,0.5l0.47,0.51l-0.24,0.22l-0.63,0.04l-0.48,-0.71l-1.66,-0.76l-0.56,-0.7l-1.57,-0.51l-0.52,0.36l0.54,0.81l-0.29,1.12l-0.39,-0.7l-0.57,-0.27l-1.21,0.16l-0.71,0.74l-1.16,-0.31l-0.62,-0.23l0.04,-0.51l-0.82,-1.35l-1.12,0.09l-0.69,-0.93l-1.58,-0.65l-1.06,0.47l-0.36,0.42l0.03,0.56l-0.38,0.09l-1.99,-0.21l-2.62,-1.02l-2.87,0.08l0.09,-0.92l-0.64,-0.28l-0.9,1.12l0.09,0.55l-2.58,0.9l-0.77,-0.22l-0.06,-0.74l-0.38,-0.33l-1.55,0.28l-0.29,0.45l0.59,1.7l-1.05,0.91l-0.69,1.13l-3.33,1.9l-2.03,-0.28l-0.36,0.27l-0.59,-0.59l-0.6,0.07l-0.18,0.53l0.69,1.3l-0.41,0.13l-0.34,-0.3l-0.66,0.22l-0.19,1.02l-1.47,0.21l-0.3,0.4l0.41,0.73l-0.32,0.38l-1.36,0.28l-0.05,0.55l0.59,0.75l-0.58,1.47l-1.66,-0.69l-0.13,0.47l0.39,0.94l1.07,0.44l-0.37,1.32l0.58,2.54l1.3,2.5l-0.7,0.35l-1.96,-0.86l-2.36,-0.36l-4.13,-1.76l-0.57,-1.63l-1.11,-1.55l-0.36,-2.86l-1.3,-1.03l-2.68,-3.2l-0.18,-0.96l-2.19,-3.83l-3.3,-3.22l-1.04,-0.43l-2.25,0.07l-1.89,-0.39l-1.64,0.74l-0.61,0.61l-0.81,2.36l-1.49,1.11l-3.68,-1.77l-2.02,-1.36l-1.01,-1.41l-0.3,-1.55l-1.27,-2.62l-6.36,-4.95l-1.58,-1.82l-9.2,-0.1l-0.4,0.4l-0.01,2.15l-13.99,0.03l-18.83,-6.51l0.31,-0.83l-0.42,-0.54l-11.88,1.0l-0.14,-0.52l-0.49,-0.26l-0.33,-2.13l-0.81,-1.22l-3.32,-2.59l-1.39,-0.06l-0.02,-0.56l-0.83,-1.09l-1.7,-0.05l-1.47,-0.47l-0.59,-0.81l-1.77,-0.95l-4.19,-0.28l-0.84,-0.52l-0.16,-3.08l-1.06,-0.64l-0.18,-1.14l-2.0,-1.55l-2.99,-3.75l-0.16,-1.06l0.6,-0.89l-0.05,-0.97l-0.68,-0.82l-1.32,-0.28l-1.0,-1.08l-0.52,-1.9l-0.0,-0.28l1.75,1.15l0.39,-0.59l-1.42,-2.56l3.89,-0.26l0.36,-0.35l-0.79,-0.59l-2.16,-0.25l-0.74,0.33l-1.08,-0.45l-0.93,0.58l-0.05,1.01l-1.32,-0.83l-0.02,-0.82l-1.1,-1.53l-2.94,-2.75l-0.58,-2.59l0.17,-1.5l-0.3,-1.11l-2.51,-2.91l-0.2,-1.18l0.86,-1.55l0.66,-4.41l-0.83,-2.11l0.12,-1.1l-0.77,-1.03l-0.25,-2.78l-0.63,-1.33l0.91,-2.99l0.68,-0.45l-0.16,-0.7l0.55,-1.26l1.12,-11.92l-0.09,-3.42l1.79,-0.24l1.06,0.48l0.86,-0.38l-0.2,-0.43l-1.45,-0.8l-2.57,-0.17l0.0,-0.28l0.5,-0.08l0.3,-1.51l-1.06,-1.14l1.07,-0.5l0.23,-0.41l-1.68,-0.81l-1.09,-3.83l-1.44,-1.99l-0.08,-1.99ZM600.53,354.34l0.0,-0.0l0.0,0.0l-0.0,0.0ZM565.54,376.21l1.34,0.45l1.32,1.05l-0.23,0.72l-0.34,-0.01l-2.09,-2.21ZM567.19,381.69l0.47,0.2l0.38,0.46l-0.19,-0.03l-0.65,-0.63ZM546.58,409.31l0.07,0.07l-0.02,0.1l-0.05,-0.17ZM330.49,318.83l-0.57,-0.55l1.23,-1.11l0.38,1.87l-1.04,-0.21ZM609.34,337.99l0.0,-0.0l0.0,0.0l-0.0,-0.0ZM580.89,360.6l2.41,-0.95l3.91,-0.3l0.1,0.27l-3.11,0.99l-2.68,0.36l-0.62,-0.36ZM530.89,327.73l0.08,-0.11l0.08,0.12l-0.17,-0.0ZM512.06,334.57l0.33,-0.38l-0.28,0.55l-0.04,-0.17ZM512.71,333.56l0.11,-0.21l0.12,-0.04l0.02,0.06l-0.24,0.19ZM505.9,320.05l0.92,-0.89l1.35,-0.49l0.06,0.31l-1.31,1.22l-0.1,-0.29l-0.92,0.14ZM99.81,185.08l0.47,0.25l1.71,-0.65l0.93,-0.84l1.72,-0.19l1.69,-1.48l1.69,-0.75l3.92,0.11l0.54,-0.43l-0.14,-0.62l-1.01,-0.61l1.53,-0.71l2.02,-0.26l2.97,-1.25l2.51,-0.2l0.47,0.44l-0.54,0.96l-0.02,0.78l-0.59,0.53l0.07,0.62l1.94,1.18l4.1,-0.12l1.54,0.4l4.04,-0.03l1.78,-1.88l2.33,0.69l0.21,-0.44l-0.51,-1.4l-1.87,-0.62l1.31,-0.11l2.59,1.04l2.27,-0.4l0.33,-0.38l0.0,-0.89l-0.84,-1.09l-1.59,-0.01l-1.28,-0.55l-2.69,0.98l-1.95,-1.09l-0.07,-0.52l1.16,-1.31l-0.03,-0.63l-0.65,-0.42l-1.38,-0.25l-1.83,0.22l0.01,-0.28l-0.66,-0.32l-0.75,0.62l-1.99,-0.05l-2.56,-0.61l-0.84,-0.7l-1.07,-2.33l-1.1,-1.32l-6.44,-3.84l-2.95,-0.99l-1.36,-1.04l-1.1,-0.35l0.99,-1.81l0.48,-2.5l5.5,0.0l4.72,-0.74l3.2,-1.91l1.87,-1.93l0.55,-2.25l0.66,-1.22l3.87,-3.74l0.79,0.16l5.1,-1.28l4.49,-2.62l-0.32,0.43l0.3,0.69l-0.3,0.69l0.36,0.56l0.7,0.01l0.53,0.48l0.34,-0.34l0.12,-1.58l2.04,-0.35l0.29,-0.43l-0.38,-0.35l-1.69,-0.05l-0.88,-0.77l1.26,-0.86l1.3,-0.59l0.1,0.79l0.7,0.2l1.33,-0.48l1.79,0.02l0.91,-0.39l2.84,-0.19l3.11,-1.74l3.35,-2.92l0.66,0.62l4.09,1.02l-0.02,0.48l-2.7,1.5l1.23,1.21l0.67,0.06l1.59,-0.59l1.99,-1.85l0.95,0.13l1.0,0.62l-0.36,0.47l0.12,0.64l3.05,0.88l1.67,-0.7l3.39,-0.49l2.19,0.5l1.51,-0.04l0.73,0.24l-0.76,0.65l-0.04,1.13l1.27,0.87l1.75,0.1l-0.33,0.28l0.23,0.7l3.68,0.31l2.9,-0.82l2.05,0.68l2.09,-0.69l1.53,-0.03l4.26,0.88l1.21,0.92l1.61,-0.35l1.3,0.46l1.01,0.81l3.28,0.43l1.7,-0.19l4.6,0.29l3.26,1.38l2.96,0.24l1.18,-0.53l3.37,-0.57l2.71,-0.1l2.39,0.69l2.15,1.51l3.01,0.89l1.58,1.09l1.74,-0.04l0.0,77.5l0.3,0.39l2.44,0.63l0.65,-0.52l2.14,0.78l1.79,-1.09l2.51,-0.1l-0.42,1.87l0.85,0.77l1.57,0.64l0.43,0.94l5.21,4.11l0.63,2.49l0.75,0.02l1.65,-1.05l-0.13,1.32l1.03,-0.02l1.22,0.49l0.72,0.66l0.18,0.83l1.07,0.06l0.68,1.12l-1.71,0.19l-0.72,0.59l-0.28,-0.1l-4.18,-2.27l-2.54,-2.74l-2.4,-1.35l-0.26,-0.41l-1.8,-0.51l-4.02,-1.92l1.05,-1.13l-0.23,-1.64l0.44,0.5l0.15,1.81l0.71,0.17l0.34,-1.56l0.94,0.01l0.33,-0.36l-2.46,-1.73l-0.88,-0.02l-1.98,1.58l-2.41,0.68l-2.05,-0.27l-2.34,-0.89l0.32,-0.8l-0.29,-0.75l-0.54,-0.36l-0.5,0.16l-0.09,0.63l-0.9,0.3l-4.41,-0.87l-2.08,-0.09l-5.47,0.66l-0.73,-1.04l-2.26,-0.55l-1.12,-0.6l0.97,-2.69l-0.72,-0.06l-2.25,1.91l-0.78,0.14l-1.79,-0.61l0.57,-0.89l-0.37,-0.53l-2.13,-0.06l-0.36,-0.56l-0.97,-0.05l-0.1,-0.54l-0.97,-0.43l0.1,-0.73l1.42,-0.41l0.29,-0.37l-0.27,-0.39l-1.68,-0.14l-1.98,1.13l-1.16,-0.11l-0.8,0.59l-1.34,-0.47l-0.39,0.6l-0.82,0.12l-0.23,-0.41l1.1,-1.52l-0.36,-0.63l-1.6,1.06l-1.08,0.01l-0.79,0.42l-0.22,0.32l0.19,0.56l0.4,0.04l-0.22,0.56l-0.82,0.07l-0.34,0.38l0.17,0.53l1.32,0.72l-0.11,0.34l-0.85,0.05l-0.66,0.45l-0.22,0.26l0.2,0.64l2.85,-0.62l0.28,0.24l-1.03,0.56l-0.16,1.68l-0.51,0.28l-0.51,0.95l-1.78,0.26l-1.63,-0.61l-0.54,0.2l-0.39,-0.59l-0.49,-0.15l-0.97,1.8l-0.8,-0.26l-0.54,1.05l-0.94,-0.04l0.06,0.82l-0.87,0.69l-0.62,-0.1l-0.79,0.34l-0.58,-0.2l-0.62,1.15l-1.26,1.17l-0.93,-0.32l-0.47,0.19l-0.02,0.32l-0.63,-0.1l-1.3,0.43l-1.19,-0.5l1.03,-0.8l1.61,-0.47l1.89,-2.03l0.0,-0.46l-0.42,-0.28l-2.04,1.04l-1.57,-0.61l0.52,-1.35l1.77,-2.29l0.44,-1.6l-0.22,-1.78l4.36,-2.11l1.6,0.7l2.38,-0.15l2.88,0.59l0.41,-0.29l-0.67,-0.96l-2.2,-0.42l-1.81,-0.93l1.15,-1.25l2.01,-1.01l0.23,-0.44l-0.37,-0.32l-1.58,0.09l-1.19,0.63l-0.71,0.99l-2.22,0.13l-0.95,-0.31l-3.49,2.03l-1.69,0.54l-1.07,1.06l0.01,0.75l-2.43,1.7l-0.32,0.76l0.14,0.44l-1.11,0.76l-0.74,0.18l-1.02,-0.43l-0.87,0.16l0.12,0.62l1.37,0.82l0.48,0.64l-0.5,0.66l-2.34,0.63l0.15,0.69l0.52,0.28l-0.79,0.27l-0.29,-0.46l-0.87,0.08l-1.09,0.74l0.07,0.42l-0.51,0.53l-1.62,1.04l-0.64,1.79l0.33,0.66l2.56,0.71l1.42,0.82l-1.29,1.35l-1.23,0.49l-0.87,0.75l-0.34,0.93l-0.93,0.41l-0.2,0.53l0.21,0.6l-1.39,0.23l-0.36,0.5l-1.82,0.25l-0.91,1.08l-2.22,1.07l-1.03,1.24l-1.1,0.17l-0.38,0.57l-0.72,0.07l-1.12,0.71l-0.39,0.64l0.4,0.72l-1.01,1.11l-0.62,0.07l-1.92,1.33l-1.56,0.28l-0.72,1.12l-1.44,-0.08l-0.94,0.48l-0.18,0.51l-1.65,0.52l-0.92,1.1l0.2,0.53l1.01,0.25l-0.39,0.46l-0.63,-0.54l-1.25,1.47l-3.18,1.01l-0.73,0.51l-0.6,-0.51l-0.61,0.07l-3.02,1.5l-0.53,0.61l-0.61,-0.1l-0.67,0.44l-0.79,-0.14l-1.34,0.85l-1.05,0.09l0.28,-0.5l0.66,0.09l0.42,-0.59l-0.19,-0.25l-0.86,-0.43l-1.07,-0.02l-0.88,0.55l-0.44,1.22l-1.17,1.32l-1.58,0.92l-0.72,-1.22l-0.68,-0.15l2.61,-2.67l2.26,-1.29l1.98,-0.66l0.41,0.35l0.58,-0.02l1.27,1.41l0.7,-0.12l0.14,-0.68l2.0,0.47l0.41,-0.39l-0.04,-0.46l-1.27,-0.97l1.09,-1.96l2.54,-1.72l2.52,-0.91l1.46,-1.2l1.62,0.43l0.34,-0.55l0.0,-1.45l1.62,-1.75l2.32,-1.63l1.37,0.35l0.61,-0.2l0.17,-0.59l-1.12,-1.08l0.43,-2.63l0.19,-0.45l1.59,-0.31l0.35,-0.35l-0.25,-0.42l-1.32,-0.39l-0.11,-0.83l1.34,-1.41l1.26,-0.69l-0.06,-0.7l1.08,-2.48l-0.16,-0.51l-0.53,0.11l-1.59,1.82l-5.12,1.91l-1.2,-1.43l0.09,-0.44l0.41,-0.27l1.22,0.23l0.4,-0.28l-0.17,-0.46l-1.82,-0.88l-0.72,0.12l-0.82,1.01l-0.82,-0.2l-0.42,2.15l0.44,1.6l-0.44,0.39l-3.5,-3.66l-0.75,0.06l-0.73,0.51l-2.47,-1.68l-2.3,1.32l-2.09,0.54l-0.87,1.03l-2.03,0.33l0.75,-0.62l-0.19,-1.8l0.71,-1.03l-1.72,-0.31l-0.15,-0.75l0.72,-1.08l0.21,-1.49l-2.11,-4.47l-0.79,-0.77l1.23,-2.15l0.89,-0.49l0.01,-0.71l-1.5,0.1l-2.66,3.1l0.02,0.73l0.58,0.29l-0.09,1.06l-0.82,0.06l-2.35,1.06l-3.31,0.29l-0.91,-0.52l-0.12,-0.84l-1.69,-1.15l-0.94,-1.14l-1.91,-0.77l-0.1,-0.86l-0.93,-0.22l1.68,-1.95l2.42,0.74l-0.3,1.35l0.45,0.12l1.89,-1.29l0.95,1.18l0.51,0.1l1.15,-0.68l0.55,-0.72l-0.09,-0.57l-0.88,-0.47l0.04,-0.65l-0.88,-0.55l-1.56,0.77l-5.11,-0.44l0.91,-0.52l0.24,-0.48l-0.37,-0.47l-0.98,0.1l0.03,-0.29l-0.76,-0.3l-0.26,-0.76l-0.75,0.22l-0.31,1.14l-0.32,-0.0l-0.5,-1.28l-0.96,-0.49l0.35,-0.64l-0.23,-0.83l-0.84,-0.28l-0.68,0.24l1.67,-0.7l-0.14,-0.66l-0.83,-0.32l1.78,-0.28l0.19,-0.68l-0.47,-0.54l0.07,-0.81l2.52,-2.85l0.74,-0.36l0.94,0.36l0.59,-0.22l-0.19,-0.67l0.56,-0.24l0.58,-0.97l-0.57,-0.43l-0.62,0.34l0.11,-1.53l0.42,-0.57l1.71,-0.37l-0.1,-0.6l-0.47,-0.36l0.24,-0.25l2.09,-0.24l1.3,0.7l-0.5,0.39l0.01,0.55l0.59,0.14l0.98,-0.6l1.18,0.43l1.82,-0.58l1.67,-1.22l1.8,-2.13l1.35,0.66l3.67,-0.36l1.05,-0.59l1.42,-1.41l0.33,-1.13l-1.16,-3.68l-1.93,-1.54l1.41,-0.11l0.73,-0.42l0.64,-1.0l-0.1,-0.97l-1.13,-1.33l-0.94,-0.3l-1.55,1.07l-1.66,-0.05l-0.49,0.53l-1.54,0.54l-2.74,2.39l-0.42,-1.06l-1.67,-1.12l-0.97,0.39l0.07,0.74l-1.82,-0.66l-3.13,0.02l-1.91,0.59l-0.61,-0.1l-0.93,0.59l-5.84,-1.05l-1.43,-0.96l0.37,-0.68l-0.31,-1.19l-1.56,-0.99l0.91,-0.13l0.62,-0.82l1.77,-0.27l-0.28,-0.71l-6.51,-1.21l-2.87,-1.18l-0.17,-0.49ZM131.96,178.57l-0.62,0.13l-0.11,-0.08l0.08,-0.39l0.65,0.34ZM129.77,176.2l-1.57,-0.58l-0.42,-0.77l1.02,-0.09l1.03,1.14l-0.05,0.31ZM126.91,265.27l-0.23,1.67l-0.56,0.25l-0.57,-0.56l-0.83,-0.24l-0.47,0.31l0.07,0.71l-0.19,0.28l-0.01,-1.02l0.71,-0.43l1.02,-0.0l1.07,-0.98ZM258.69,237.55l1.95,-0.47l0.57,-0.96l0.06,-1.14l0.94,-0.43l0.07,-0.83l3.61,-1.24l1.88,1.41l-0.11,1.0l0.77,1.29l2.52,1.51l0.74,1.4l2.46,1.48l1.96,2.02l0.03,0.67l5.91,8.15l-0.41,0.66l0.24,0.6l1.16,0.29l-0.25,0.84l0.24,0.49l0.88,0.34l0.3,1.26l0.42,0.37l1.16,-0.06l2.42,1.35l1.71,0.46l1.29,0.78l0.51,0.83l1.56,0.18l0.15,0.98l-0.63,1.85l0.56,2.42l-0.92,1.9l-1.5,1.44l-1.05,-0.13l-0.86,-2.16l1.22,-0.56l0.29,-0.5l-0.57,-0.48l-0.34,-2.73l-1.04,-1.57l0.41,-1.02l-0.46,-0.11l-3.87,1.54l-0.91,2.35l-0.45,-0.22l-0.26,-0.66l1.76,-2.77l1.38,-0.36l0.27,-0.42l-0.35,-0.35l-1.53,-0.19l-0.6,-0.9l-0.87,-0.36l-0.83,-1.4l-0.56,-0.22l-0.33,-0.97l-1.39,-0.79l-0.08,-1.11l-3.2,-0.96l0.09,-1.05l-0.84,-2.02l1.77,0.89l0.53,-0.09l0.02,-0.66l-1.94,-1.57l1.5,-0.03l-0.1,-0.76l-1.96,-0.36l-0.67,0.6l-1.39,-1.53l-0.03,-1.27l0.84,-1.67l-0.42,-0.55l-0.61,0.3l-1.1,1.75l-2.52,-1.43l-1.05,-2.29l-0.72,-0.55l-1.28,-4.45l-0.65,0.14l-0.67,2.01l0.55,0.8l1.62,5.81l-0.62,-0.11l-1.42,-1.16l-1.42,0.07l0.15,-1.09l-0.85,-1.46l0.84,-0.44l0.21,-0.43l-0.36,-0.32l-0.87,0.06l-0.57,-1.11l-0.64,0.29l0.06,1.73l-1.69,-1.29l-1.76,-0.53ZM285.0,265.19l-0.1,-0.78l1.01,-1.3l0.1,-1.53l1.43,-0.7l1.16,1.68l-0.52,2.55l-0.36,0.23l-0.75,-0.38l-0.07,-0.78l-0.72,-0.03l-1.18,1.04ZM286.27,266.56l0.09,-0.38l-0.06,-0.26l0.39,0.85l-0.41,-0.22ZM286.98,267.33l0.17,0.3l-0.22,-0.01l0.05,-0.29ZM275.68,261.7l0.04,-0.0l0.35,0.19l-0.18,0.01l-0.22,-0.2ZM276.58,261.93l0.6,-0.38l0.57,-0.95l-0.52,-1.01l-1.4,0.11l0.43,-0.76l-0.32,-0.84l1.45,0.1l0.56,1.63l1.67,0.66l1.03,0.99l0.59,1.2l-0.35,-0.01l-0.67,0.92l0.14,0.69l1.1,-0.03l1.02,0.83l-0.19,0.77l1.11,0.22l-0.11,2.84l-1.09,-1.3l-1.09,-0.39l-0.45,-1.29l-0.56,-0.04l-0.31,0.43l-1.08,-1.32l0.47,-0.38l-0.58,-1.05l0.03,-0.85l-1.31,-0.12l-0.73,-0.65ZM280.54,258.81l1.39,-1.79l1.0,1.39l-0.27,1.62l-0.68,0.12l-0.09,-0.57l-1.27,-0.38l-0.08,-0.39ZM276.74,265.42l0.24,-0.06l0.29,0.23l-0.23,-0.04l-0.31,-0.12ZM277.71,265.94l0.52,0.7l0.14,0.61l-0.46,-0.77l-0.2,-0.55ZM278.46,267.38l0.07,0.09l0.3,0.55l-0.25,-0.35l-0.13,-0.28ZM279.22,268.42l0.87,-0.18l-0.08,0.6l-0.23,0.13l-0.56,-0.54ZM278.87,257.49l0.32,-0.26l0.85,0.03l-0.07,0.49l-0.35,0.18l-0.74,-0.44ZM279.27,256.0l0.38,-0.91l0.64,0.64l-0.67,0.28l-0.35,-0.01ZM274.16,252.77l3.87,0.62l0.4,0.45l-0.02,1.22l-1.3,-1.33l-0.59,0.26l0.9,2.33l-1.72,0.04l-0.26,-2.27l-1.29,-1.32ZM275.48,263.85l0.19,0.04l0.47,0.03l-0.41,0.53l-0.26,-0.6ZM272.76,258.99l0.09,-1.62l0.4,-0.22l0.12,-0.6l-0.91,-0.82l-0.56,-1.06l0.06,-0.47l0.73,-0.44l0.85,0.95l0.62,0.16l0.23,0.49l-0.55,0.46l-0.45,3.0l-0.62,0.17ZM269.79,244.57l1.99,0.27l-0.26,0.42l0.22,1.2l1.68,2.24l0.04,1.38l-0.81,0.33l-0.78,1.07l-0.96,0.62l-0.18,-0.56l0.67,-2.22l-0.91,-1.32l-0.7,-3.43ZM264.84,252.18l-0.27,-1.27l0.91,-0.4l0.71,-1.18l2.01,1.19l1.65,4.18l-0.02,3.29l-0.97,-1.71l0.47,-1.25l-0.94,-0.11l-0.41,-0.29l-0.1,-0.68l-0.86,-0.09l0.68,-1.38l-0.73,-0.48l-0.23,-0.8l-0.41,-0.45l-0.6,-0.08l-0.9,1.52ZM261.72,244.6l0.54,0.46l0.66,-0.3l0.05,-0.34l1.32,-0.49l0.66,0.62l-0.48,0.84l0.58,0.51l1.53,-0.93l1.54,0.47l0.06,1.07l-1.21,-0.0l-0.55,0.35l0.01,0.68l1.83,0.37l0.2,0.92l-2.95,-1.28l-0.66,0.45l-0.19,1.33l-0.73,-0.13l-0.84,-1.63l-2.31,-1.95l0.18,-0.54l0.74,-0.49ZM208.99,227.43l0.32,-0.25l0.78,0.33l-0.85,0.37l-0.26,-0.45ZM203.17,231.47l1.01,-1.0l0.66,-0.42l-0.7,0.99l-0.96,0.43ZM205.79,229.04l0.61,-0.95l0.34,0.18l-0.95,0.77ZM202.92,228.29l0.13,-0.2l0.12,-0.48l0.06,0.13l-0.25,0.63l-0.06,-0.08ZM201.4,229.75l0.03,-0.01l-0.02,0.01l-0.02,-0.0ZM175.19,244.72l1.4,-1.03l0.98,0.13l0.36,-0.39l-0.12,-0.81l0.25,-0.08l1.16,0.65l0.72,-0.26l1.17,0.65l-0.23,0.26l-0.76,-0.62l-0.64,0.44l-0.11,0.49l-1.08,-0.25l-0.58,0.81l-1.04,0.42l-1.49,-0.41ZM168.94,251.96l-0.92,-1.76l0.72,-1.11l1.22,-0.55l0.86,0.01l1.15,1.97l0.71,0.46l0.48,-0.12l-0.58,-2.33l0.63,-0.59l-1.03,-0.91l0.19,-0.23l1.49,1.08l0.69,-0.53l1.05,-0.17l0.28,-0.98l0.61,0.15l0.02,0.9l0.49,0.35l1.84,-0.56l-0.15,0.92l1.11,0.69l-0.48,0.48l-2.71,-0.34l-0.49,0.32l0.12,0.7l1.22,0.29l-2.7,0.75l-2.55,1.63l-0.78,-0.33l-0.48,-0.66l-1.46,0.02l-0.58,0.47ZM168.99,252.11l0.34,0.43l0.53,0.07l-0.11,0.45l-0.68,-0.68l-0.08,-0.26ZM172.59,252.88l0.13,0.05l-0.15,0.19l0.01,-0.24ZM172.34,253.43l-0.11,0.14l-0.15,0.08l0.26,-0.23ZM174.9,252.33l0.03,-0.27l0.32,-0.15l-0.35,0.42ZM162.0,476.41l2.89,1.32l0.52,1.03l1.24,1.17l-0.94,0.68l-1.37,0.36l-1.15,0.8l-0.4,0.68l-0.86,-0.52l0.05,-1.42l-0.72,-1.78l1.03,-1.21l-0.28,-1.11ZM157.93,472.28l0.09,0.07l0.31,0.38l-0.45,-0.35l0.05,-0.1ZM158.79,472.87l0.75,-0.17l1.0,0.67l-1.39,0.38l-0.37,-0.88ZM156.39,472.94l0.0,0.0l-0.0,0.0l-0.0,-0.01ZM149.99,469.25l0.86,-0.5l0.49,0.96l0.64,0.47l-1.17,-0.55l-0.3,0.32l-0.52,-0.7ZM142.16,466.42l0.69,-0.53l0.91,0.11l-0.44,0.89l-1.16,-0.47ZM140.51,266.38l0.09,-0.12l0.02,-0.0l-0.09,0.11l-0.03,0.01ZM136.74,264.95l0.58,0.44l0.16,0.32l-0.75,-0.07l0.01,-0.69ZM135.34,240.76l0.42,-0.41l0.25,-0.09l-0.38,0.6l-0.29,-0.1ZM122.47,267.59l0.61,1.3l-0.73,0.57l-2.68,0.09l-2.03,1.38l-1.56,-0.05l-0.13,-0.58l0.85,-0.57l1.05,-1.44l1.1,0.01l2.23,-1.0l0.91,-0.01l0.38,0.3ZM103.3,229.09l2.32,0.09l0.71,-0.79l2.59,-0.58l0.74,0.47l1.36,0.05l-0.03,1.53l0.56,0.91l-1.51,0.13l-1.13,0.7l-4.64,-1.6l-0.98,-0.92ZM109.88,273.55l0.27,-0.32l0.5,0.19l-0.23,0.11l-0.54,0.01ZM101.42,279.05l0.19,-0.06l0.45,-0.04l-0.56,0.13l-0.08,-0.03ZM104.34,277.95l0.65,-1.12l0.97,0.33l0.38,-0.49l0.04,-0.66l-1.68,-0.5l-0.03,-0.27l1.68,-0.54l0.32,0.88l0.38,0.09l-0.33,0.71l0.34,0.32l-1.32,0.95l-1.4,0.31ZM95.96,281.16l0.47,-1.15l1.1,-0.14l-0.62,0.74l-0.96,0.54ZM98.16,279.26l-0.1,-0.69l0.39,-0.43l0.93,-0.34l0.8,0.21l-2.02,1.25ZM81.67,202.06l0.43,0.35l2.12,0.24l3.04,-0.91l1.29,0.53l0.72,1.13l1.92,0.48l0.43,0.47l3.9,0.43l-0.31,0.41l-2.74,0.09l-1.06,0.96l-0.18,0.59l-0.64,-1.17l-1.93,-0.65l-1.21,-1.2l-2.21,-0.79l-1.25,-0.03l-1.8,0.87l-0.91,-0.07l-0.63,-0.45l-0.02,-0.94l0.35,-0.83l0.67,0.5ZM74.39,226.48l-0.16,-0.06l0.01,-0.05l0.08,-0.04l0.06,0.15ZM66.52,287.35l1.04,-0.28l0.21,-0.15l0.01,0.11l-1.27,0.32ZM67.96,286.34l-0.26,-0.44l0.8,0.03l-0.05,0.21l-0.49,0.2ZM54.59,290.07l0.81,-0.77l0.42,0.4l-0.89,0.5l-0.34,-0.13ZM55.41,288.96l-0.0,-0.03l0.02,-0.05l-0.02,0.08ZM55.43,288.86l0.07,-0.19l0.04,0.0l-0.11,0.19ZM48.47,289.12l0.89,0.46l-0.35,0.6l0.03,-0.51l-0.57,-0.54ZM36.26,288.51l0.19,-0.11l0.18,0.1l-0.13,0.05l-0.24,-0.05ZM5.93,285.16l0.05,-0.02l-0.01,0.05l-0.04,-0.02ZM1.03,281.63l2.02,0.1l0.77,0.4l-1.6,0.43l-1.19,-0.92Z",name:"United States"},GL:{path:"M598.7,69.97l1.63,-0.74l0.09,-0.71l-1.9,-0.19l-1.15,0.49l-1.8,0.08l-5.77,-1.76l-3.11,-2.09l1.12,-1.04l-0.56,-1.19l1.29,-1.04l3.77,-1.32l3.78,-0.16l4.75,-1.56l5.05,-0.91l0.6,-0.42l-0.3,-0.74l2.82,-0.87l5.16,-0.96l6.51,0.06l1.49,-0.7l2.14,-1.96l0.73,-1.18l2.47,-6.42l2.94,-1.06l0.21,-0.66l-1.67,-0.63l-2.76,0.69l-2.12,0.06l-2.11,0.62l-3.18,-0.65l-2.01,0.04l-0.89,-0.44l-0.59,-0.94l0.69,-1.6l3.31,-2.23l3.77,-1.23l5.68,-3.71l3.89,-0.67l1.26,0.46l1.93,1.51l0.52,0.02l0.23,-0.58l-0.99,-2.17l0.07,-0.44l0.93,-0.64l3.31,0.18l3.37,0.94l1.28,-0.24l1.56,-1.92l0.38,-1.53l-0.56,-4.14l1.67,-1.2l2.01,-0.77l1.62,-0.2l4.06,0.65l4.29,2.36l4.71,1.83l3.29,1.91l1.42,0.28l0.37,-0.6l-1.4,-1.33l-5.09,-2.47l-4.9,-3.16l-1.73,-0.58l2.14,-0.82l5.07,-0.93l5.72,-0.73l5.34,-0.23l1.11,-0.68l3.92,-0.63l2.72,0.84l1.47,1.31l0.4,1.12l-0.04,4.69l0.24,0.49l0.56,0.12l2.13,-1.82l0.66,-1.07l0.6,-2.09l-0.89,-1.25l-0.04,-1.4l0.29,-0.57l0.91,0.0l5.13,2.98l2.08,0.67l2.29,1.58l5.5,0.1l1.81,-0.34l0.09,-0.67l-0.78,-0.67l-3.61,-1.87l-1.55,-1.38l-1.22,-2.22l4.34,-0.06l5.94,0.83l7.64,2.88l3.79,0.96l6.74,3.3l3.0,0.64l0.89,-0.47l0.57,-0.76l-0.53,-3.14l0.41,-1.71l1.08,-0.67l0.53,-1.07l-0.6,-1.5l-1.34,-0.93l-4.4,-2.03l1.74,-0.26l12.31,0.55l4.03,0.77l2.65,-0.31l0.35,-0.44l-0.17,-0.8l-0.6,-0.49l-17.03,-1.33l-6.91,0.32l-1.23,-0.83l1.08,-0.98l3.89,0.54l1.46,-0.76l2.3,-0.63l2.38,-0.24l5.1,-1.38l4.61,0.3l2.21,1.07l2.67,0.61l3.44,-2.28l1.54,-0.67l2.25,0.4l2.85,1.2l1.98,0.38l3.27,2.21l0.85,0.07l0.93,-0.77l0.49,-1.98l-0.46,-0.42l-2.74,-0.92l-0.85,-0.75l0.3,-0.37l2.85,-0.11l1.76,-1.1l4.75,0.4l0.59,-0.18l0.41,-0.72l5.83,-0.02l3.96,-0.42l2.67,0.54l1.61,-0.01l4.38,-0.91l11.61,0.08l3.8,0.37l4.86,0.77l2.56,0.89l7.47,0.77l5.3,1.07l-20.87,0.96l-9.71,0.92l-0.39,0.34l-0.2,1.3l0.37,0.46l1.07,0.07l9.55,-1.69l9.21,0.6l5.95,-0.04l9.4,-1.15l3.23,3.47l2.88,-0.0l1.23,0.83l1.6,-0.11l4.43,0.51l4.11,1.3l0.61,0.73l-2.1,1.33l-2.39,0.96l-3.25,0.74l-3.77,0.47l-29.21,1.57l-1.11,0.4l-0.79,1.11l0.35,1.56l1.69,0.47l8.79,-1.34l13.62,0.59l2.69,1.38l1.85,2.32l3.36,-0.5l0.85,-0.43l1.99,-2.93l2.63,-0.48l6.03,-0.2l0.71,0.86l0.21,1.23l-0.14,2.04l-0.39,1.05l-2.41,2.95l-6.98,5.17l-0.63,0.95l-0.1,0.89l0.72,0.54l1.12,-0.74l0.71,-0.91l3.71,-1.27l3.28,-1.91l2.9,-1.21l4.47,-3.5l1.85,-0.86l1.66,-0.0l0.29,1.25l0.35,0.31l3.57,0.18l5.27,1.2l1.28,-0.45l4.85,-3.92l3.97,-0.98l8.88,0.58l6.46,1.3l4.69,2.28l-3.7,1.5l-1.25,0.96l-4.94,2.29l-5.1,0.54l-0.43,0.38l0.07,0.57l1.16,1.03l-1.09,0.77l-3.48,0.49l-1.82,0.85l-4.02,0.03l-2.26,0.91l-0.11,0.68l0.88,0.74l3.04,0.95l-2.44,1.43l-2.5,0.69l-5.4,0.22l-5.75,-1.04l-1.23,0.04l-2.48,1.42l-1.51,1.63l-0.23,2.05l0.7,1.23l1.39,0.42l2.23,-0.0l0.26,0.43l-0.57,2.09l-0.08,1.72l0.32,0.33l1.17,0.2l0.71,1.1l-3.65,1.23l-0.91,1.82l-0.66,0.63l-2.82,0.42l-2.76,1.68l-0.22,0.44l0.2,0.44l0.75,0.5l-1.21,1.96l-1.01,3.34l-1.79,3.12l0.05,1.12l0.92,0.9l0.43,0.05l1.16,-0.62l1.21,-1.57l1.18,-0.61l2.59,0.52l4.13,1.53l0.77,0.82l-0.59,0.07l-3.48,-1.3l-2.71,0.79l-0.2,0.58l1.11,1.87l1.46,1.05l2.13,0.38l2.56,1.18l2.26,-0.6l2.06,0.18l0.57,1.06l-0.21,2.11l-1.04,1.41l-6.33,-1.61l-3.29,-0.07l-2.33,0.36l-0.38,0.6l-3.08,1.52l-2.67,-1.1l-0.92,-0.03l-1.33,0.75l-0.47,0.63l0.18,0.55l0.91,0.64l2.74,0.51l0.62,1.76l1.49,1.45l1.76,0.09l1.45,-0.35l1.66,0.65l2.24,0.2l0.93,0.78l-0.33,1.41l2.24,2.42l0.71,3.71l-0.04,0.81l-0.6,0.95l-0.98,0.19l-2.02,-1.51l-1.66,-0.13l-2.32,1.63l-1.67,0.24l-2.01,1.11l-2.79,-0.94l-0.5,0.16l0.1,0.52l2.48,1.6l1.08,-0.0l2.41,-1.0l0.65,0.05l0.63,1.44l-0.04,0.68l-1.25,1.67l0.32,0.39l0.9,0.18l1.6,-1.01l1.06,-2.53l0.74,-0.32l0.91,0.35l2.19,3.44l1.31,0.85l0.16,1.15l-0.45,0.88l-1.23,0.22l-3.12,-0.25l-0.4,0.47l0.07,0.44l-1.79,0.56l-2.33,0.25l-3.68,-1.13l0.81,-2.1l-0.12,-0.41l-1.36,-0.96l-0.42,0.49l0.14,1.41l-1.86,1.02l0.6,1.12l-0.69,1.38l1.22,1.12l5.8,0.53l3.14,0.87l-0.79,2.9l-5.04,0.49l-3.27,1.58l-0.68,0.01l-4.41,-1.23l-2.62,-1.39l-1.98,-2.14l-0.57,-0.01l-1.42,1.28l-0.91,0.21l-4.2,-2.44l-0.54,0.25l0.08,0.52l3.35,2.7l-2.16,0.71l-1.83,1.36l-1.83,0.33l-6.03,-1.77l-0.47,0.14l0.02,0.49l0.52,0.61l2.9,1.0l-0.46,0.34l-2.63,-0.06l-1.67,0.41l-0.18,0.57l0.22,0.35l1.22,0.54l0.96,-0.64l2.2,0.1l6.9,-1.51l0.81,-0.89l0.92,-0.29l2.33,-0.25l3.35,0.23l3.3,1.97l1.26,0.24l0.78,0.85l3.95,1.49l0.14,2.5l-0.31,2.02l-0.86,0.43l-0.22,0.43l0.06,1.57l-8.56,-3.46l-1.38,-1.7l-1.7,-3.6l-2.02,0.26l-0.91,0.32l-0.53,0.57l-4.75,1.23l-2.31,0.77l-0.27,0.37l0.25,0.38l1.59,0.44l7.81,-2.18l0.59,2.64l-0.16,0.47l-2.47,1.05l-0.07,0.62l0.44,0.44l2.87,-0.63l0.85,0.71l4.2,1.98l5.47,2.12l0.83,1.44l1.5,0.21l-2.37,1.69l0.04,1.46l0.32,1.27l0.38,0.3l0.39,-0.28l0.53,-1.55l1.46,-0.58l0.69,0.18l0.35,2.24l-0.01,3.23l0.7,3.0l-1.62,0.44l-1.9,-0.19l-0.27,-3.28l-0.69,-0.26l-0.56,0.73l-0.62,3.04l-2.98,-0.1l-2.25,-0.91l-0.83,-0.78l-1.24,-2.4l-0.24,-1.25l-0.67,-1.05l-1.0,-0.76l-6.82,-3.3l-4.19,-0.13l-1.73,-0.44l-0.94,0.32l-0.16,0.5l0.59,0.89l6.35,0.48l0.52,0.79l0.13,0.79l-0.27,0.55l-1.98,1.16l-2.75,0.9l-3.05,-0.02l-2.87,-0.46l-2.72,0.1l-0.13,0.71l1.95,0.87l-0.37,1.32l-1.61,1.03l-3.11,1.01l-0.44,0.68l0.39,0.26l2.65,-0.3l2.75,0.69l6.49,-0.68l0.62,0.23l-3.16,1.04l-1.87,1.23l-0.49,1.06l0.27,0.53l1.25,0.33l0.91,-0.49l1.22,-1.45l1.24,-0.33l1.65,0.18l1.44,-0.23l3.13,-0.98l3.91,0.52l5.57,1.44l6.94,0.13l-0.77,0.51l-3.1,0.8l-0.28,0.16l-0.02,0.77l-3.84,0.52l-0.13,0.72l0.58,0.69l-0.74,0.19l-1.88,-0.24l-0.14,1.37l-2.8,1.28l-1.69,0.31l-0.16,0.64l0.36,0.4l-2.19,1.0l-0.71,1.32l-3.85,1.84l-9.64,2.05l-4.52,1.3l-3.17,-0.11l-1.74,0.99l-2.42,-0.46l-0.49,0.46l0.52,0.82l-1.45,0.37l-2.1,-0.55l-4.63,-2.72l-0.57,0.42l0.67,1.38l-0.82,0.34l0.99,1.99l-0.83,0.75l-3.9,2.06l-1.23,1.87l-0.88,0.72l-0.11,1.0l-2.89,4.51l-0.58,0.64l-1.04,0.15l-1.02,1.61l-2.61,1.46l-1.03,-0.08l-2.18,-1.45l-0.63,0.37l0.03,0.3l1.09,2.07l-0.68,0.51l-2.33,1.58l-0.17,-0.75l-0.71,-0.41l-0.6,0.38l-0.49,1.37l-0.66,0.18l-1.44,-0.74l-1.44,0.95l-0.34,0.85l-1.57,0.42l-0.74,-0.45l0.92,-1.12l0.06,-1.04l2.62,-3.11l-0.38,-0.42l-2.63,-0.52l-1.93,-0.01l-0.31,0.32l0.18,0.41l1.52,0.83l-0.73,0.77l-0.65,1.62l-1.65,-0.75l-0.44,0.11l-0.05,0.45l0.54,0.9l1.03,0.63l0.0,0.51l-1.89,0.63l-7.78,0.57l-0.38,0.28l0.12,0.77l2.69,1.26l-1.87,1.53l-0.99,0.38l-2.0,-0.47l-2.16,0.06l-0.46,0.38l-0.02,0.54l0.65,1.52l0.42,0.28l1.43,-0.32l0.88,1.67l1.2,1.34l-1.19,0.85l-1.04,0.11l-0.5,0.87l-1.88,-0.47l-2.06,-0.14l-0.41,0.3l0.21,0.46l2.77,1.43l1.89,-0.12l-0.12,1.49l0.46,1.34l-0.92,0.66l-0.18,0.78l-0.98,0.06l-0.43,0.38l-0.52,1.46l0.14,0.44l-1.08,1.33l-2.06,-0.03l-1.7,-1.09l-0.52,0.51l0.58,0.95l2.07,1.04l-1.12,1.27l-0.67,0.32l-3.97,-0.25l-0.81,0.34l0.7,0.84l3.2,0.81l-0.72,2.84l0.87,1.41l0.14,0.93l-0.41,0.39l-1.35,0.14l-0.5,0.42l0.21,0.67l0.92,0.24l-1.53,4.34l-0.36,2.25l-1.49,1.67l-1.27,0.02l-2.35,-0.58l-1.04,0.25l0.07,0.7l0.55,0.35l3.06,0.93l0.35,2.12l-0.75,0.76l-1.22,-0.05l-1.72,-0.66l-0.51,0.52l0.96,0.9l-0.39,0.15l-0.51,-0.06l-0.3,-0.76l-1.38,0.18l-0.12,-0.39l1.33,-1.63l-0.32,-0.72l-0.52,-0.01l-1.73,1.86l-3.48,-1.27l0.04,-0.68l1.24,-0.35l1.24,-0.94l0.64,-1.04l-0.14,-0.56l-0.52,-0.04l-1.63,1.18l-1.22,0.41l-3.2,-1.21l-0.36,-0.92l1.45,-3.05l-0.12,-0.52l-0.48,-0.25l-0.59,0.25l-0.27,0.75l-2.89,1.04l-1.43,1.06l-1.68,0.25l-1.74,-0.48l-1.12,0.14l-0.41,0.47l0.08,0.34l-1.46,-0.32l2.11,-1.05l-0.08,-0.73l-2.85,-0.1l-0.37,-1.3l-1.07,-0.56l-1.42,-0.2l-0.57,-1.72l-0.97,-0.4l0.25,-0.57l-0.9,-1.63l2.5,-1.22l0.29,-0.39l-0.3,-0.38l-1.68,-0.26l-1.22,0.81l-1.1,0.07l-0.01,-0.61l0.51,-0.56l-0.12,-0.63l-2.0,-0.73l-1.57,-1.0l0.07,-1.79l2.35,-2.28l0.1,-0.51l-0.48,-0.18l-1.53,0.54l-1.2,1.09l-0.55,-0.8l-1.44,-1.08l-3.63,-5.13l0.39,-1.05l-0.26,-0.72l3.83,-1.03l1.75,-0.16l0.66,-0.46l0.1,-0.47l-0.99,-0.16l0.11,-0.38l-0.5,-0.49l-1.49,0.75l-4.06,0.99l-0.36,-0.37l1.4,-1.96l0.74,-0.68l1.77,0.03l0.46,-0.49l-0.08,-0.32l1.44,-0.29l0.49,0.06l0.87,1.41l0.95,0.52l0.57,-0.39l-0.72,-2.4l-0.98,-0.67l-1.14,0.04l-1.88,-3.34l-0.47,-0.25l-0.46,0.5l1.02,3.39l-1.31,0.68l0.16,-0.62l-0.53,-0.47l-0.59,0.23l-0.67,0.53l-2.35,3.81l-0.59,-0.71l-0.12,-2.7l-0.87,-3.91l-1.01,-0.64l-0.32,-0.63l1.57,-0.73l2.79,-2.22l2.57,-0.3l0.37,-0.62l-0.7,-0.47l-3.04,0.54l-3.19,2.19l-0.77,-0.0l-1.31,-1.08l-1.79,0.14l-0.14,-1.21l0.62,-1.65l-0.37,-0.54l-0.79,-0.21l6.36,-3.55l0.92,-1.04l1.86,-0.89l1.62,-1.43l-0.25,-0.56l-0.58,-0.05l-8.95,5.88l-2.44,0.46l-0.05,-1.84l1.02,-1.79l1.41,-0.81l0.45,-0.61l2.97,-0.28l0.37,-0.26l-0.03,-0.65l-1.04,-0.3l-4.55,-0.15l-1.01,-0.43l-0.84,-1.07l0.39,-2.11l4.03,-2.23l2.16,-0.6l3.03,0.85l3.64,0.22l2.39,1.09l0.77,-0.15l0.22,-0.56l-0.33,-0.46l-2.03,-0.88l0.78,-0.35l0.01,-0.72l-0.42,-0.2l-4.21,0.56l-3.06,-0.86l-3.3,0.71l-2.31,1.62l-0.85,0.27l0.58,-1.99l1.15,-1.19l0.97,-1.92l5.25,1.2l2.4,0.18l1.02,-0.67l1.55,-2.51l-0.61,-0.84l-1.47,0.31l-0.86,1.02l-2.72,0.43l-2.37,-0.34l-0.58,-0.45l-2.31,0.1l1.3,-2.09l1.96,-0.75l1.39,0.06l2.59,1.32l0.93,0.16l2.66,-0.57l1.12,-0.84l0.79,-1.02l0.04,-0.54l-0.57,-0.3l-1.56,0.63l0.55,-2.64l3.34,-0.1l0.85,-0.72l-0.32,-0.5l-1.37,-0.57l-2.22,0.35l0.87,-1.37l0.45,-2.19l2.33,-1.31l-0.64,-1.3l0.79,-0.43l-0.01,-0.64l-0.9,-0.3l-1.89,0.32l-1.65,-0.48l-1.91,0.64l-3.81,-0.64l-3.93,-2.23l-5.01,-1.09l-2.31,-2.03l0.65,-0.64l0.78,-0.25l6.85,0.64l1.93,0.56l4.61,2.32l3.01,0.7l1.46,-0.32l0.34,-0.39l-0.16,-0.53l-1.45,-0.37l-1.74,-1.08l0.35,-2.16l-0.17,-0.4l-1.34,-0.69l2.38,0.16l0.32,-0.37l-0.19,-0.51l-1.98,-1.14l-3.48,-0.03l-2.4,-0.73l-2.21,0.22l-0.4,-0.89l1.01,-1.06l4.52,-1.24l1.14,-0.75l0.14,-0.49l-0.49,-0.34l-2.05,0.49l-2.46,-0.38l-2.6,1.27l-1.02,-0.3l1.54,-1.28l0.07,-0.61l-0.47,-0.36l-0.62,0.11l-0.35,-1.69l-1.42,-1.59l-0.49,-1.05l0.65,-0.42l0.06,-0.46l-0.41,-0.21l-1.27,0.2l-0.41,0.4l0.02,0.45l0.64,1.67l1.45,1.56l0.17,0.8l-1.19,0.88l-0.33,0.7l-0.86,0.06l-0.38,0.59l0.48,1.04l-0.15,0.36l-1.59,0.59l-1.8,0.15l-3.16,-0.54l-1.14,-1.05l-0.31,-0.98l0.6,-0.71l1.13,-3.12l2.23,-2.04l0.27,-0.79l-0.51,-0.5l-0.44,0.05l-2.08,1.79l-1.02,0.15l-0.06,-0.5l0.93,0.06l0.73,-0.53l-0.01,-0.58l-0.9,-0.74l1.78,-0.07l1.71,-1.39l0.37,-0.81l-0.02,-1.87l-0.74,-1.05l-1.18,-0.55l-1.19,0.75l-1.66,-0.54l-0.08,-0.57l1.08,-0.41l0.89,-1.1l-0.15,-1.64l-0.67,-0.77l-0.49,-0.08l-1.01,0.57l-0.71,-0.94l-1.06,-0.52l0.56,-1.25l0.51,-0.08l0.29,-0.48l-0.49,-1.43l-1.98,-2.8l-0.74,-0.28l-1.24,0.18l0.36,-0.85l-0.27,-1.35l1.6,-0.37l0.48,-0.37l-0.02,-0.65l-3.09,-1.67l-1.64,-2.02l-3.24,-1.54l-2.2,-2.41l-1.41,-0.69l1.2,-0.65l0.33,-0.55l-0.7,-1.47l-0.89,-0.96l-2.86,-0.78l-1.87,-0.98l-8.98,-3.16l-4.7,-0.9l-3.31,-0.11l-1.28,-0.69l-1.62,-0.35l-0.91,0.2l-1.97,1.23l-0.38,0.05l-1.31,-0.96l-0.68,-0.14l-3.09,1.52l-2.33,0.42l-0.79,-0.12l-1.65,-1.01l-1.45,0.21l-1.63,0.82l-1.88,-0.78l-0.94,0.04l-0.44,0.19l-0.1,0.92l1.27,1.37l-6.39,-0.97l-3.06,-1.23l-3.36,-1.79l2.81,-1.44l3.68,-0.8l0.29,-0.24l-0.09,-0.65l-0.76,-0.33l-5.18,-0.09l-2.09,-0.51l-0.81,-0.7l0.85,-1.27l-0.01,-0.67l-0.46,-0.06l-3.68,1.89l-0.72,-0.13l-0.62,-0.29l0.04,-0.84l-1.88,-1.04l1.19,-0.85l1.25,-0.19l4.79,-0.38l3.43,0.36l2.14,-1.61l2.24,-0.39l6.02,0.16l2.72,0.89l0.6,-0.39l-0.37,-1.08l0.89,-1.26l-0.18,-0.88l-2.14,-1.48l-0.84,-0.11l-4.51,1.78l-2.17,-0.07l-2.46,-0.77l-2.07,1.22l-1.68,0.24l-3.11,-0.85l-0.49,-0.26l-0.22,-0.69l-1.47,-0.66ZM868.11,46.03l-2.0,1.23l-3.02,-0.1l-1.69,-0.55l-0.33,-0.57l0.5,-0.71l2.15,-0.77l2.79,-0.5l2.31,0.27l0.2,0.58l-0.9,1.11ZM866.15,95.15l0.55,1.88l0.94,0.75l1.08,-0.07l0.26,0.56l-0.54,0.24l-5.36,-0.09l-0.83,-0.53l0.15,-2.09l0.75,-0.48l1.1,0.53l1.91,-0.7ZM866.52,70.52l-0.75,-0.01l1.35,-1.66l0.58,0.02l-0.21,1.06l-0.96,0.59ZM862.98,87.68l-1.73,-3.8l0.1,-2.36l0.41,-0.04l0.52,0.45l0.7,5.76ZM862.47,22.09l-1.21,-0.05l-1.63,-1.05l-1.0,-0.79l-0.05,-0.69l0.98,-0.33l2.36,1.99l0.54,0.91ZM860.98,67.01l-0.81,-2.13l-0.08,-1.53l1.1,-0.81l-0.06,2.1l0.34,1.07l-0.49,1.29ZM815.5,142.48l0.34,-0.68l0.76,-0.35l0.47,-0.66l0.17,-1.68l1.92,0.41l3.19,-0.08l4.15,-1.56l1.5,0.87l0.18,0.5l-0.22,1.0l0.35,0.51l-2.53,0.72l-1.49,1.05l-0.43,-0.49l-1.5,-0.4l-6.88,0.84ZM768.9,185.81l-0.3,0.0l-0.09,-0.66l0.57,0.07l-0.18,0.58ZM728.75,18.92l-0.63,0.13l-2.09,-1.26l-6.4,-2.19l-2.68,-2.19l-0.15,-0.55l0.22,-0.39l4.2,-0.42l4.93,1.41l2.42,1.17l0.7,0.81l-0.51,3.48ZM720.41,224.31l0.99,-0.49l0.23,-0.06l-0.48,1.13l-0.74,-0.57ZM696.91,151.06l-0.52,-1.51l0.01,-0.96l0.83,-0.37l1.45,0.44l-0.9,0.55l-0.34,1.59l-0.54,0.26ZM692.3,138.73l0.41,-0.21l0.83,0.34l-1.25,-0.13ZM682.11,152.65l2.11,-0.27l0.15,-0.72l-1.13,-0.75l-4.46,-0.62l-0.66,-0.63l0.5,-1.73l1.82,0.27l0.55,-0.24l-0.11,-0.69l-1.65,-0.62l-0.69,-0.8l0.44,-0.73l1.55,-0.51l5.28,0.98l2.9,2.39l3.43,1.24l0.1,0.97l0.42,0.43l-0.83,0.78l-7.33,2.05l-0.91,-0.05l-1.48,-0.77ZM684.63,137.12l-0.3,0.04l-1.3,-0.54l1.33,-1.07l0.5,0.74l-0.23,0.83ZM671.71,121.68l0.62,-0.36l2.38,0.02l1.89,-0.49l-2.17,1.77l-1.42,-0.89l-1.29,-0.05ZM592.02,73.97l-1.72,0.09l-2.03,-0.62l1.64,-0.21l2.49,0.62l-0.39,0.12Z",name:"Greenland"},MX:{path:"M362.47,413.39l0.23,-0.35l-0.15,-0.86l-1.05,-0.75l-1.25,-2.44l11.15,-0.93l-0.28,0.47l0.19,0.62l19.52,6.73l14.45,-0.03l0.4,-0.4l0.01,-2.14l8.47,0.05l1.4,1.69l6.24,4.83l1.14,2.37l0.33,1.63l1.21,1.69l2.2,1.48l3.77,1.81l0.83,-0.01l1.55,-1.36l0.32,-1.33l0.93,-1.49l1.51,-0.63l1.42,0.41l2.78,0.12l3.32,3.19l2.01,3.53l0.31,1.19l2.78,3.32l1.2,0.93l0.27,2.72l0.8,0.97l1.13,2.52l4.35,1.88l2.45,0.39l2.13,0.92l0.85,-0.4l-0.33,1.42l-1.45,3.13l-0.83,3.43l-0.51,5.92l0.1,1.96l-0.56,1.64l0.08,0.81l1.05,4.87l0.67,0.83l1.68,4.01l3.71,4.48l0.82,2.69l1.64,1.74l0.42,1.29l1.6,0.73l2.25,-0.04l0.9,0.68l0.96,0.26l1.22,1.69l0.72,0.2l1.56,-0.17l3.2,-1.22l3.41,-0.21l1.09,-0.8l1.16,-0.28l2.2,-0.2l0.25,0.93l0.71,0.35l1.48,0.07l1.66,-1.3l-0.33,-1.4l1.84,-1.09l1.22,-1.3l0.23,-1.91l1.04,-1.24l0.04,-3.26l0.61,-2.19l2.48,-1.28l4.82,-0.75l2.05,-0.82l2.23,-0.19l3.89,0.84l0.71,-0.35l0.11,-0.51l1.02,0.85l0.23,1.26l-0.68,1.65l-2.53,2.96l-0.31,0.92l0.16,1.07l-1.21,1.17l0.27,0.96l0.81,-0.0l-1.01,0.79l0.01,0.5l0.55,0.4l-1.21,4.05l-0.57,-0.63l0.1,-1.68l-0.65,-0.3l-0.83,0.69l-0.49,1.19l-1.3,0.43l-1.51,2.51l-0.95,-0.38l-0.66,0.38l-0.18,0.57l-8.94,-0.01l-0.4,0.4l-0.02,2.57l-1.73,-0.01l-0.31,0.66l3.58,2.89l0.45,1.08l0.94,0.48l-0.2,1.11l-6.48,0.2l-2.42,4.23l0.53,1.19l-0.3,0.44l-0.12,1.68l-2.56,-2.75l-5.66,-4.79l-2.58,-1.32l-0.84,0.49l-0.13,-0.69l-0.88,0.03l-0.89,-0.52l-0.86,0.68l-0.09,0.54l-2.07,1.14l-3.76,1.45l-1.43,0.2l-3.39,-1.33l-2.82,-0.29l-1.88,-1.2l-1.96,-0.54l-1.41,-1.25l-4.63,-0.95l-1.73,-1.06l-4.17,-1.46l-3.77,-2.35l-1.67,-1.63l-4.08,-0.58l-3.66,-1.34l-2.42,-2.65l-5.2,-2.53l-1.74,-2.06l-0.95,-1.36l-0.82,-1.99l1.21,-0.31l0.78,-0.6l-0.04,-0.84l-0.87,-0.65l1.04,-1.46l0.14,-1.94l-0.19,-0.43l-1.03,-0.62l-1.02,-1.82l-0.02,-1.86l-0.75,-1.62l-3.18,-3.15l-2.76,-3.73l-2.83,-2.2l0.1,-0.57l-0.33,-0.59l-2.13,-0.62l-0.89,-1.5l0.54,-0.65l-0.22,-0.33l-3.45,-1.85l-0.15,-0.5l-0.73,-0.29l0.24,-0.68l-0.67,-0.27l-1.29,0.65l-0.6,-0.48l-0.18,-1.41l0.68,-0.98l0.43,0.08l0.41,-0.58l-0.79,-1.49l-1.16,-1.13l-1.48,-0.05l-1.04,-2.07l-2.06,-0.76l-0.97,-1.51l0.27,-1.45l-0.24,-0.61l-2.9,-0.53l-1.67,-2.18l-1.13,-0.58l-2.37,-2.92l-0.28,-1.27l-0.83,-0.66l-0.15,-0.87l-1.65,-2.52l-0.45,-1.76l-1.21,-2.02l-0.22,-0.66l0.34,-1.63l-0.16,-0.81l-2.82,-0.91l-0.5,-1.02l-1.38,-0.67l-1.11,0.65l-2.24,-1.39l-1.66,-0.78l-0.49,0.08l0.6,1.67l-0.44,2.77l1.26,3.75l0.07,2.09l1.48,1.99l3.04,2.49l0.99,1.37l0.25,0.97l0.79,0.19l0.14,0.48l0.63,0.2l0.66,1.62l0.99,0.44l0.7,3.15l2.1,1.8l0.7,1.79l0.88,0.58l0.87,2.3l0.89,0.73l0.47,-0.15l0.09,-0.55l-0.36,-0.52l0.32,0.27l1.18,3.07l0.27,1.95l0.73,1.19l0.57,0.32l0.7,1.95l1.04,1.47l-0.25,1.37l0.48,1.63l1.56,1.37l0.75,-0.23l0.22,-0.77l1.77,1.77l0.88,1.66l1.07,0.75l-0.28,1.3l-1.95,1.36l-1.88,-3.72l-1.43,-0.79l-2.04,-1.95l-3.29,-2.43l-0.63,-0.13l-1.34,-1.41l-0.21,-0.83l0.29,-2.97l-0.55,-1.92l-1.08,-1.73l-1.58,-0.71l-1.75,-1.38l-0.91,-2.11l-0.84,0.84l-1.45,0.33l-0.98,-1.14l-3.09,-1.42l-0.46,-1.12l-2.11,-1.59l1.67,0.27l0.99,-0.26l1.21,0.88l0.7,-0.3l-0.69,-1.7l0.78,-2.75l-0.6,-1.12l-3.99,-4.09l-1.3,-0.54l-2.44,-1.72l-0.58,-1.13l-0.15,-1.91l-0.9,-0.68l-0.3,-2.0l-1.21,-1.06l-0.24,-1.32l-1.61,-1.95l-0.03,-0.59ZM384.21,429.35l-0.58,-0.3l0.26,-1.28l0.34,-0.13l0.24,0.83l-0.26,0.88ZM378.19,425.87l0.19,0.17l0.13,0.37l-0.28,-0.39l-0.04,-0.15ZM379.15,427.07l0.28,0.07l0.03,0.24l-0.31,-0.31Z",name:"Mexico"},CU:{path:"M526.78,466.91l0.86,-0.32l-0.06,-1.77l1.1,-1.14l4.28,-1.81l3.02,-0.41l2.78,-0.77l2.61,0.39l1.41,-0.12l0.81,0.45l2.49,-0.25l1.42,0.83l1.49,0.02l1.02,0.39l3.0,2.45l3.16,0.29l5.23,2.99l0.75,0.14l0.33,-0.24l0.44,0.38l-0.33,0.18l0.11,0.47l0.79,0.78l0.89,-0.4l1.25,1.2l0.48,-0.14l0.46,0.4l1.89,0.29l1.05,0.52l1.73,0.12l0.28,0.17l-0.18,0.61l-0.57,0.69l0.33,0.57l4.07,0.3l2.21,1.51l1.66,0.49l-0.35,0.37l-1.87,0.12l-2.05,0.73l-0.14,-0.26l-0.71,0.01l-0.44,0.39l-4.36,-0.51l-7.17,0.69l2.68,-2.28l0.03,-0.82l-0.67,-0.9l-4.65,-0.75l-1.75,-1.39l-0.46,-1.95l-1.01,-1.15l-2.83,0.15l-3.2,-0.95l-1.56,-0.66l-1.23,-1.29l-2.67,0.26l-0.42,-0.16l-0.45,-0.82l-0.72,0.15l-0.33,0.55l-0.57,-0.41l-1.92,-0.11l-0.6,-0.4l1.1,-0.27l0.53,-0.82l-0.42,-0.69l-0.72,-0.33l-4.86,-0.02l-3.27,2.49l-2.67,0.3l-0.65,1.17l-1.77,0.65l-0.14,-0.35ZM534.15,467.72l0.23,-0.31l0.93,0.15l0.65,1.21l-1.53,0.5l0.22,-0.59l-0.5,-0.96Z",name:"Cuba"}},height:543.9752077221104,projection:{type:"mill",centralMeridian:-11.5},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","oceania_mill",{insets:[{width:900,top:0,height:606.4292604642054,bbox:[{y:-2119119.6569834785,x:-7472412.761398178},{y:6796504.590523286,x:5759240.699079444}],left:0}],paths:{GU:{path:"M240.87,42.61l-0.01,-0.59l0.19,-0.14l-0.18,0.73Z",name:"Guam"},PW:{path:"M164.06,87.32l0.02,-0.17l0.14,-0.24l-0.03,0.17l-0.13,0.24Z",name:"Palau"},KI:{path:"M679.59,130.26l0.02,-0.03l0.02,0.04l-0.04,-0.01Z",name:"Kiribati"},NC:{path:"M416.93,308.88l0.36,0.45l0.68,0.17l-0.06,0.61l-0.58,0.13l-0.49,-0.35l-0.29,-0.93l0.39,-0.08ZM411.15,303.46l0.49,0.13l-0.03,1.1l1.04,1.41l-0.11,0.35l-1.92,-1.24l0.92,-0.97l-0.39,-0.79ZM387.8,299.51l0.1,0.08l-0.08,-0.04l-0.02,-0.04ZM388.42,299.97l0.82,0.48l1.04,-0.13l3.92,3.03l1.69,0.74l1.34,1.25l0.46,1.08l1.66,1.52l4.92,2.99l2.91,2.49l1.84,1.04l0.25,1.28l-1.16,0.29l-2.23,-0.94l-2.05,-1.21l-0.77,-1.13l-1.95,-0.76l-0.68,-0.65l-3.72,-1.95l-2.37,-1.87l-3.56,-3.62l-2.07,-2.66l-0.28,-1.29Z",name:"New Caledonia"},NU:{path:"M585.07,289.99l0.09,0.19l-0.28,0.16l0.14,-0.33l0.05,-0.02Z",name:"Niue"},NZ:{path:"M534.0,498.67l0.36,-0.21l0.11,0.44l-0.47,-0.23ZM534.78,500.22l0.77,0.62l-1.2,0.49l-0.15,-0.45l0.58,-0.66ZM456.17,419.08l-1.68,-1.97l-0.75,-0.96l1.06,-0.1l-0.2,0.67l1.56,2.36ZM456.68,419.85l0.23,0.29l0.07,0.25l-0.31,-0.53ZM457.03,420.47l0.58,0.21l0.67,-0.58l2.79,1.38l0.58,-0.3l1.64,0.84l0.08,0.94l0.47,0.51l0.77,-0.01l0.46,-0.36l1.44,2.46l-0.19,0.87l0.24,0.45l-0.71,-0.11l-0.42,0.67l3.03,4.43l-0.3,1.67l0.39,0.8l-0.65,2.1l0.33,0.36l0.55,0.1l0.25,0.12l0.26,0.27l0.74,-0.29l2.34,1.04l0.32,1.34l0.57,0.62l1.33,-0.05l0.51,-0.81l-0.73,-4.4l0.88,1.11l0.65,0.11l0.53,0.95l1.09,4.81l0.62,0.67l-0.26,0.77l0.68,0.6l1.46,0.35l3.68,1.86l3.95,0.93l1.46,-0.34l0.89,-0.57l1.35,-1.73l1.94,-1.2l1.76,0.09l1.67,0.89l-1.01,2.1l-0.91,5.05l-2.25,1.62l-0.51,2.71l0.29,1.27l-0.75,-0.82l-2.11,-0.34l-1.82,0.4l-1.83,1.05l-0.96,1.34l-0.2,1.33l0.27,1.17l0.92,0.6l-1.84,3.95l-3.46,4.58l-3.0,4.84l-4.81,3.42l-0.34,-0.17l-0.64,-1.52l-0.85,-0.24l-1.06,0.28l0.13,-1.04l-0.38,-0.71l-0.59,0.01l-0.34,0.74l-0.57,0.11l2.75,-3.69l1.16,-2.15l0.7,-3.0l-0.78,-1.83l-1.27,-1.61l-1.48,-0.82l-1.86,-0.43l-1.67,-1.52l-3.13,-1.19l-0.8,-0.64l-0.28,-0.74l0.44,-1.22l1.64,-0.91l2.56,-0.65l1.64,-1.73l0.9,-4.94l0.95,-1.82l-0.24,-1.18l0.67,-0.5l0.2,-0.58l-1.32,-2.57l0.14,-1.16l-0.75,-0.92l0.51,-0.24l0.33,-0.63l0.78,-0.17l0.26,-0.67l-1.11,-1.23l-1.67,0.22l-0.64,-0.25l-1.09,-2.38l0.54,-0.07l0.47,-1.07l-0.13,-0.71l-0.63,-0.64l0.32,-0.68l-0.15,-0.57l-0.85,-0.69l-0.81,0.36l-1.0,-0.67l-0.86,-1.73l-0.43,-0.24l-0.34,0.35l-0.0,0.82l-2.91,-3.94l1.5,-1.78l-0.31,-0.53l-0.58,-0.02l-1.4,1.37l-0.4,-0.98l-1.02,-0.98l0.42,-0.68l-0.04,-1.11ZM463.41,431.7l0.14,0.17l0.06,0.19l-0.06,-0.05l-0.14,-0.3ZM473.83,433.91l-0.09,-0.09l0.01,-0.04l0.05,0.08l0.02,0.05ZM473.39,430.83l0.04,-0.47l0.56,0.82l-0.04,-0.04l-0.56,-0.32ZM406.28,517.99l3.24,-0.57l0.56,-0.45l-0.24,-0.69l-1.17,-0.17l1.23,-0.78l0.19,-0.49l-0.45,-0.26l-1.43,0.13l0.15,-0.49l0.83,-0.01l0.28,-0.63l1.38,0.63l0.44,-0.13l-0.23,-0.9l0.87,-0.42l-0.21,-0.42l-1.32,-0.54l-0.02,-0.48l0.38,-0.34l1.08,0.15l0.16,-0.71l-0.45,-0.48l1.16,-0.93l0.64,0.96l0.37,-0.31l0.02,-1.52l2.05,-1.51l1.08,0.55l0.21,-0.42l-0.38,-1.33l3.71,-3.73l1.92,-0.91l1.22,0.16l1.86,-1.13l0.75,0.38l0.51,-0.52l-0.16,-0.82l2.48,-1.34l2.28,-0.78l0.34,-0.7l0.51,-0.26l-0.06,-0.35l2.54,-2.19l1.15,0.17l0.15,-0.47l-0.3,-0.58l0.42,-0.18l0.95,0.42l0.52,-0.13l-0.43,-0.81l0.36,-0.15l0.84,0.54l0.24,-1.09l1.31,-1.43l0.21,1.19l0.65,-0.3l0.05,-1.7l1.1,-1.61l0.68,-0.24l0.32,-0.57l-0.35,-0.49l1.65,-5.17l1.76,-0.59l1.7,-1.7l1.18,-3.2l0.35,-2.27l0.93,-1.57l1.42,-1.17l1.31,-0.91l0.05,1.65l0.47,0.66l1.58,0.66l0.53,2.86l0.7,1.09l1.15,-0.05l4.31,-2.8l0.11,0.54l-0.71,1.61l0.02,0.47l0.46,0.12l0.95,-0.46l0.96,-1.91l0.78,-0.14l0.31,0.23l-1.71,1.71l1.15,0.38l-0.89,1.09l0.03,0.71l0.52,0.71l-0.43,0.72l0.42,0.6l0.69,-0.01l0.28,0.32l-0.18,0.4l-2.57,2.75l-0.44,1.35l-2.23,2.26l-2.43,4.17l-2.39,1.27l-1.31,1.23l-0.61,0.11l-0.31,0.68l0.71,0.52l-1.35,0.68l-0.08,0.46l0.42,0.22l1.19,-0.12l0.75,1.55l1.92,0.5l0.03,0.99l-0.93,0.23l-1.38,-0.72l-0.98,0.11l0.01,-0.4l-0.89,-0.49l-0.81,0.3l-0.62,0.96l-1.84,-1.44l-0.47,0.01l-0.01,0.81l0.81,1.17l-3.5,1.79l-1.66,0.19l-0.67,1.11l-1.15,0.41l0.49,0.53l-0.81,4.15l-0.3,1.02l-0.81,-0.01l-0.32,0.64l0.82,0.76l-1.29,1.64l-0.42,1.57l-1.45,3.04l0.68,1.41l-2.5,0.63l-0.79,0.55l-1.17,1.63l-2.05,1.67l-1.65,1.96l-2.48,0.62l-1.76,0.09l-2.45,-0.6l-1.6,0.39l-1.29,-0.07l-0.22,-1.23l-1.12,-0.97l-2.65,-0.03l-1.13,-1.52l-1.23,-0.52l-0.58,0.04l-0.93,0.82l-1.95,0.07l-2.47,-0.39l1.36,-1.7l0.03,-0.51l-0.5,-0.12l-0.89,0.52l-0.06,-0.93l-0.63,-0.19l-1.14,0.59l0.02,-0.63ZM464.16,475.77l0.52,-0.33l-0.28,0.26l-0.25,0.06ZM461.7,471.81l0.05,-0.2l0.28,-0.24l-0.17,0.35l-0.16,0.08ZM425.9,583.44l0.01,-0.0l0.04,0.01l-0.02,0.01l-0.03,-0.02ZM414.34,530.94l1.81,-2.66l-0.07,-1.86l0.78,-0.03l0.94,1.05l-0.52,0.4l0.02,0.43l1.57,1.04l-1.43,0.31l-0.89,0.58l-0.91,-0.01l-1.28,0.74ZM407.01,516.29l0.33,-0.1l0.09,0.24l-0.23,-0.03l-0.19,-0.11ZM402.53,565.46l0.62,-0.57l0.23,-1.11l0.23,-0.02l-0.42,1.57l0.35,0.71l-1.02,-0.58Z",name:"New Zealand"},AU:{path:"M3.12,347.94l0.52,-0.43l1.06,2.65l-1.15,-1.41l-0.44,-0.81ZM4.9,350.4l1.59,0.34l0.85,-0.84l0.22,-1.59l-1.05,-1.13l0.68,-0.45l0.33,1.19l1.2,1.17l1.13,-0.44l0.47,-0.75l-0.08,-3.75l-4.08,-7.01l-0.76,-2.25l-1.13,-2.04l0.03,-2.27l0.5,-2.04l2.04,-3.72l0.29,-4.05l-0.82,-2.23l2.0,-5.31l0.64,-0.5l-0.35,2.13l0.52,1.26l-0.15,1.15l0.56,0.42l1.19,-0.44l0.74,-0.79l2.47,-4.07l5.57,-2.58l4.25,-3.68l5.17,-2.92l3.08,-0.08l1.06,0.52l1.15,0.09l2.17,-0.64l3.84,-2.09l4.16,-0.89l2.71,-2.08l3.47,0.33l1.53,-0.64l3.25,-0.39l6.19,-2.46l2.67,-2.33l1.21,-1.73l2.47,-4.79l1.32,-0.68l2.69,-2.42l-0.03,-0.98l-0.83,-0.51l-0.64,-3.04l0.08,-1.65l0.7,-1.28l3.49,-2.73l1.31,-2.45l1.18,2.99l1.88,3.44l1.4,1.82l0.67,-0.22l0.33,-2.33l-0.14,-1.24l0.99,0.77l0.53,0.0l0.63,-2.09l-2.7,-2.97l0.82,-0.71l-0.08,-1.51l1.13,1.36l0.46,0.16l1.29,-0.88l1.94,0.95l3.47,0.1l0.44,-0.57l-0.32,-0.42l-2.45,-0.43l0.07,-0.85l0.88,0.03l0.38,-0.37l0.54,-1.93l-0.0,-0.5l-0.56,-0.37l-0.84,0.81l-0.61,-0.92l0.34,-1.61l0.89,-0.02l1.08,-1.51l1.76,1.22l0.87,-0.06l0.29,-1.43l-0.48,-0.36l-0.91,0.03l-0.23,-0.66l1.2,-0.7l2.06,0.67l0.44,-0.18l0.27,-0.97l-1.07,-0.85l-0.47,-1.05l0.73,-1.22l1.06,-0.18l1.09,-0.66l0.65,0.5l0.52,-0.54l0.45,1.05l0.84,0.0l1.04,-1.16l-0.03,-0.89l0.71,-1.98l-0.35,-0.79l0.73,1.32l0.57,0.13l0.83,-0.97l1.02,0.91l0.5,0.04l1.7,-1.68l0.01,-1.23l0.61,-0.21l3.96,2.12l1.59,1.24l1.65,2.26l2.14,1.69l-0.83,2.64l-0.08,1.87l0.55,0.39l0.68,-0.63l0.28,0.3l0.69,-0.24l-0.61,-1.85l1.75,-1.57l0.9,-0.26l3.45,0.81l0.63,0.62l0.06,0.84l0.41,0.58l0.69,-0.16l0.15,-1.89l1.06,0.36l1.32,1.58l0.63,-0.2l0.12,-0.41l-0.19,-1.55l1.38,-0.16l0.16,-0.71l-1.53,-1.02l0.55,-0.78l-2.34,-1.36l0.47,-1.07l1.95,-1.97l0.89,-2.93l2.11,-0.87l1.1,-1.25l-0.01,-0.48l-0.84,-1.08l0.18,-1.06l1.15,-0.69l0.57,-1.37l1.48,-0.23l0.24,-1.76l1.27,1.03l0.53,-0.06l0.33,-0.61l-0.14,-0.81l1.1,-0.46l0.01,-0.83l1.1,-0.08l0.44,-0.35l0.23,0.52l0.96,0.59l2.18,0.01l1.21,-0.33l1.28,0.34l1.54,-0.67l0.84,0.62l0.72,-0.13l0.54,-0.97l1.43,-0.06l0.22,-0.66l-0.51,-0.55l0.17,-3.13l-1.71,-1.29l-2.87,-0.07l-1.51,-1.18l0.5,-0.31l1.47,0.96l0.63,-0.29l0.23,-0.48l0.26,0.07l1.6,1.04l0.92,1.02l0.5,0.08l1.22,-0.8l0.53,0.08l1.8,2.31l1.25,0.17l1.46,0.68l2.69,0.11l2.4,1.28l1.57,0.42l1.09,0.03l1.23,-0.5l2.28,1.54l1.71,0.15l4.14,-2.33l0.11,0.19l-1.09,0.98l0.04,1.05l0.67,0.32l1.31,-0.64l1.09,2.04l1.76,-0.13l0.54,-1.3l-0.44,-1.04l1.38,-1.13l0.55,1.27l0.83,0.71l1.31,0.14l0.2,0.43l-3.01,3.27l-0.1,0.75l0.48,1.02l-0.82,1.38l-1.19,-0.65l-2.8,1.29l-0.21,0.36l0.01,2.45l0.44,1.46l-0.74,2.43l-3.6,4.67l0.41,1.78l5.69,3.73l0.76,1.36l2.24,1.07l0.65,-0.14l-0.01,0.86l0.81,0.69l1.78,-0.03l2.18,1.4l2.99,1.27l1.56,1.85l2.58,1.93l2.07,0.6l0.95,-0.07l2.76,0.9l1.92,3.37l1.39,0.39l4.48,2.5l1.62,0.05l2.39,-0.67l2.45,-1.66l1.16,-3.27l1.88,-2.82l0.59,-1.5l0.92,-3.07l-0.11,-1.4l0.43,-2.24l1.33,-4.39l-0.76,-4.49l0.5,-2.62l-0.84,-1.71l-0.05,-0.84l1.29,-4.06l-0.2,-2.4l1.04,-1.03l0.66,0.14l0.59,-0.29l0.07,-0.49l-0.66,-1.54l-1.22,-0.66l0.06,-0.76l1.06,-2.33l0.38,0.28l0.64,-0.29l-0.06,-1.22l1.39,-4.7l0.21,-2.33l1.11,-0.48l0.94,-1.23l0.3,0.0l-0.07,1.19l1.23,0.99l0.79,2.11l0.26,3.9l1.04,1.03l1.21,0.23l-0.49,1.33l0.04,1.13l1.16,0.94l1.04,1.72l1.4,6.11l-0.26,2.37l1.57,4.67l0.72,0.67l1.4,0.47l1.89,-1.23l1.68,-0.45l1.22,1.88l4.65,3.33l-0.24,1.11l0.3,1.69l-0.14,1.29l1.39,4.45l-0.2,2.82l2.53,3.74l1.09,0.41l-0.02,1.01l1.65,4.27l-0.7,5.0l1.53,2.06l0.7,0.34l-0.22,1.98l0.71,1.31l1.68,1.41l1.9,0.79l1.28,0.17l1.14,1.09l2.1,-0.06l1.07,1.76l1.18,1.16l0.89,0.27l0.6,0.62l1.22,0.23l2.05,1.42l1.78,0.47l1.14,1.08l0.61,0.89l-0.91,0.1l-0.31,1.25l0.86,1.3l3.06,2.98l0.92,2.69l0.94,0.9l0.54,3.46l0.54,1.86l0.85,1.52l0.44,0.21l0.75,-0.25l0.94,1.02l0.56,-0.0l0.34,-0.63l-0.45,-1.59l0.39,-0.73l1.1,1.49l2.4,1.56l0.55,0.04l0.36,-0.48l-0.09,-0.86l0.7,1.22l0.15,4.76l0.58,2.47l2.43,2.67l2.57,1.8l1.56,0.28l0.93,0.59l2.19,3.73l2.47,1.67l0.33,1.24l1.17,1.95l1.08,0.67l0.82,1.11l0.09,2.11l0.86,1.54l0.92,0.63l-0.57,2.68l0.58,5.46l-0.32,1.88l2.04,4.7l0.55,2.35l0.86,1.48l-0.05,2.29l0.36,1.21l-0.08,1.31l-1.92,3.57l-0.59,5.03l-1.84,5.67l0.13,2.88l-0.77,4.3l-1.16,2.85l-1.68,2.13l-0.7,3.33l-2.59,2.21l0.13,0.44l-2.52,1.26l-2.53,3.86l-0.36,1.31l-0.93,0.47l-0.27,3.16l-1.04,0.48l0.32,0.72l-1.61,1.81l-0.74,1.82l-0.71,3.43l0.14,0.76l-0.75,0.47l0.03,0.92l-1.01,0.55l-2.85,5.41l-1.0,6.19l-0.78,2.59l0.18,3.67l-0.31,2.02l-0.87,0.21l-2.38,1.89l-9.12,0.5l-3.09,0.96l-3.7,2.54l-4.01,3.85l-4.82,0.58l-0.25,0.85l1.0,1.25l0.59,0.04l0.35,-0.33l0.09,1.47l-0.28,0.35l-1.63,-2.39l-0.67,-0.28l-0.99,0.43l-0.94,-1.74l-1.61,-0.29l-1.22,-0.83l0.99,-1.18l-0.82,-1.62l-1.54,-0.05l-0.99,1.39l-1.44,0.85l-0.72,-0.5l0.61,-0.12l0.82,-0.75l0.86,-1.62l-0.61,-1.13l-1.27,-1.04l-4.17,2.07l0.09,0.73l1.49,0.24l-3.81,1.9l-2.24,2.12l-1.83,0.97l-2.19,-0.64l-1.01,-0.79l-1.91,-0.63l-3.03,-1.75l-2.03,0.09l-1.87,-0.95l-1.67,-0.15l-1.18,1.01l-0.92,-0.15l-1.52,-1.61l-1.64,-0.91l-2.95,-0.46l-1.64,-1.06l-1.36,-2.23l-3.17,-3.37l-0.3,-1.39l0.9,-3.46l-1.02,-2.77l-2.03,-3.18l-3.34,-2.93l0.68,-0.54l0.92,0.67l0.5,-0.38l0.23,-1.42l-0.36,-0.85l-1.18,-0.37l-2.44,1.6l-1.03,0.14l-1.54,0.77l-1.87,-0.16l1.43,-2.04l0.84,-2.59l-0.14,-2.39l-3.1,-5.26l-0.69,0.02l-1.27,2.41l-0.4,2.44l-1.27,3.28l-1.59,-0.1l-2.37,0.89l-1.35,0.13l0.73,-2.06l2.6,-0.05l0.35,-0.26l0.79,-2.76l-0.25,-1.93l0.25,-1.77l1.14,-2.47l2.18,-2.64l-0.57,-2.93l1.03,-1.21l-0.63,-2.82l-1.03,-1.7l-0.44,-0.14l-0.28,0.38l0.05,1.97l-2.54,2.99l-1.56,3.69l-4.43,2.18l-1.7,1.27l-4.02,5.31l-0.05,0.91l0.65,1.55l-0.82,-0.72l-1.29,0.41l-1.9,-1.96l0.45,-0.11l0.26,-0.59l-1.75,-5.29l-2.51,-2.9l-0.81,-2.61l-1.47,-1.24l-2.3,-0.26l-0.83,-1.36l-0.43,-1.51l0.85,-0.32l0.18,-0.76l-0.33,-1.24l-2.24,-1.12l-1.04,-1.15l-1.12,-0.64l-3.42,-0.21l-3.53,-1.91l-3.99,0.44l-3.71,-2.58l-2.56,-1.27l-1.92,-0.45l-2.85,0.9l-4.94,-0.2l-9.01,1.04l-6.7,3.07l-5.64,1.65l-3.99,0.38l-4.84,-0.45l-1.78,0.34l-2.78,1.81l-2.28,0.91l-3.8,2.24l-3.92,1.13l-1.08,1.16l-1.92,3.89l-1.59,1.96l-0.92,0.57l-1.18,-0.03l-0.97,0.57l-0.85,-0.6l-1.1,-0.22l-5.89,0.88l-0.8,-0.95l-5.07,-0.41l-4.52,0.38l-2.98,0.76l-1.58,-0.22l-2.69,0.33l-1.84,1.15l-1.45,2.3l-1.35,0.66l-2.82,0.28l-5.68,4.28l-4.04,0.92l-7.93,-0.92l-3.9,-1.61l-1.9,-2.22l-1.3,-0.92l-2.23,-1.07l-1.27,0.2l-0.55,-0.45l-0.26,-1.61l0.11,-3.76l1.07,0.75l1.58,-0.11l1.3,-1.06l1.29,-2.9l-0.45,-4.53l0.66,-0.86l0.22,-5.83l-0.35,-1.75l-3.94,-7.4l-0.72,-1.99l-0.81,-4.24l-0.07,-5.04l-0.79,-2.48l-1.75,-2.31l-0.72,-2.74l-2.79,-3.76l-0.47,-4.23l-0.59,-1.78l-2.41,-4.07l-1.52,-1.87ZM5.49,346.12l-1.4,-2.96l0.13,-0.37l1.47,1.56l-0.2,1.77ZM307.15,358.08l0.01,-0.18l0.17,-0.41l-0.17,0.59ZM304.06,342.63l-0.11,-0.67l0.63,-1.96l-0.13,-0.79l1.06,-0.95l0.38,-0.95l0.09,0.6l-1.92,4.72ZM305.51,336.0l-0.11,-0.12l0.09,-0.06l0.01,0.18ZM289.28,325.66l0.66,0.31l0.41,1.19l-0.1,-0.07l-0.97,-1.43ZM266.67,467.87l1.59,-0.39l0.64,0.6l-0.17,0.16l-0.57,-0.46l-1.49,0.09ZM243.31,471.7l1.77,-0.15l4.12,2.28l3.94,1.28l1.95,-0.19l1.08,-0.5l1.13,0.69l0.22,-1.1l0.75,-0.44l2.34,-0.32l1.38,0.29l1.11,-1.28l1.78,0.23l0.91,-0.83l1.42,0.59l0.45,0.64l0.17,8.76l-1.01,0.49l-0.84,1.56l-0.47,2.5l-0.64,1.27l-0.07,2.29l0.48,2.95l-0.95,0.22l-0.68,-1.2l0.97,-0.2l-0.08,-1.09l-1.83,-0.81l-0.68,0.4l-0.09,1.11l-0.29,-0.96l-0.83,-0.94l-0.45,-0.1l-0.25,0.4l0.34,1.49l-0.6,0.9l-0.12,1.26l-1.28,-0.65l-0.61,0.22l-0.09,0.72l0.52,0.57l-1.23,2.68l-0.91,-0.12l-1.34,-0.88l-3.5,0.25l-0.25,-0.76l1.35,-0.11l0.38,-0.54l-0.14,-0.36l-0.42,-0.34l-2.38,-0.16l-1.79,-2.52l-0.91,-0.65l-1.62,-3.41l-0.37,-1.83l1.49,1.9l0.83,-1.19l-0.06,-0.58l-1.24,-1.29l-0.16,-0.56l-0.55,-0.23l-0.23,-1.11l-2.41,-3.36l-1.08,-2.17l-0.9,-3.6l0.5,-2.13l1.97,0.74ZM264.9,463.05l0.55,-0.7l1.44,1.63l0.8,0.35l-0.22,0.56l0.25,0.75l-1.02,0.51l-1.23,-1.81l-0.17,-1.04l-0.38,-0.24ZM259.93,495.5l0.38,-0.53l0.12,-0.34l-0.07,0.94l-0.43,-0.07ZM252.24,284.34l0.26,-0.08l0.33,0.97l-0.33,-0.6l-0.26,-0.29ZM245.66,449.75l0.13,-0.01l-0.11,0.06l-0.02,-0.05ZM235.03,464.86l-0.28,-1.49l0.15,-1.37l0.61,-1.0l0.36,0.27l0.32,2.59l-1.15,1.0ZM221.75,225.27l0.17,0.16l-0.1,0.07l-0.03,-0.02l-0.04,-0.22ZM199.24,271.61l0.83,-1.24l1.97,-0.48l0.13,0.16l-2.07,1.39l-0.86,0.17ZM186.63,426.84l0.35,0.43l1.81,0.2l0.78,-0.28l0.92,0.61l-1.74,-0.21l-1.25,0.26l-0.85,1.2l-0.66,0.25l-1.8,-0.72l-0.71,0.45l-2.69,-0.01l-1.3,-0.93l0.49,-0.77l5.11,-1.31l1.66,0.19l-0.12,0.63ZM178.36,252.29l0.17,-2.22l1.29,-1.17l0.24,0.75l0.61,0.43l-0.47,1.73l1.01,0.85l-2.87,-0.38ZM176.38,249.17l0.08,-0.08l0.09,-0.12l0.03,0.15l-0.2,0.04ZM148.87,228.94l0.1,0.2l-0.04,0.14l-0.12,-0.23l0.05,-0.11ZM132.92,230.01l0.94,0.93l1.29,0.21l1.25,-0.54l0.89,0.15l1.79,-0.92l1.49,1.32l-1.58,1.79l-2.31,1.48l-3.0,-2.14l-0.61,-1.2l-0.15,-1.09ZM130.25,233.73l0.95,-0.55l-0.08,-1.67l0.68,-0.72l0.78,2.33l1.01,0.62l-1.81,-0.41l-1.52,0.39ZM0.69,343.22l0.25,0.69l-0.14,-0.24l-0.11,-0.45Z",name:"Australia"},PG:{path:"M317.31,186.15l1.37,0.38l0.59,0.49l0.78,1.57l1.32,1.12l0.8,1.37l1.32,0.59l1.29,1.13l0.73,1.28l0.13,1.04l-1.43,0.68l-0.6,-0.04l-1.86,-0.92l-0.88,-1.24l0.16,-0.94l-0.24,-0.79l-1.55,-0.91l-1.82,-2.0l-0.34,-1.24l0.24,-1.57ZM316.23,184.69l-0.36,-1.75l0.21,-0.24l0.31,1.07l-0.16,0.92ZM306.38,231.17l1.21,0.64l1.04,0.34l-1.74,-0.38l-0.52,-0.59ZM287.63,164.8l0.1,-0.36l0.53,0.36l-0.63,-0.0ZM291.46,166.57l1.34,0.67l1.75,1.32l1.64,0.57l0.93,1.02l-1.67,-0.58l-3.99,-3.0ZM299.57,172.25l3.99,3.29l0.72,0.98l-0.75,2.84l-0.56,0.78l-1.26,-1.99l-0.13,-2.87l-2.0,-3.03ZM301.3,212.7l0.78,-0.03l1.13,0.78l-0.49,0.34l-0.8,-0.34l-0.63,-0.75ZM281.23,184.76l0.26,0.8l0.85,0.87l0.88,0.09l1.63,-0.56l0.93,0.45l0.82,-0.08l1.38,-0.51l0.57,-0.32l1.36,-2.3l1.34,-1.08l1.86,-0.18l0.95,-0.74l-0.05,-1.94l-0.86,-2.27l0.13,-0.59l1.32,0.1l1.16,0.75l1.25,-0.66l1.72,0.78l-0.21,0.9l0.27,1.65l-0.31,0.59l-0.64,0.92l-1.6,0.28l-0.57,0.78l0.14,0.98l0.96,1.31l-0.32,0.49l-1.36,0.69l-2.91,0.05l-0.71,1.48l-1.38,1.24l-3.11,1.11l-2.56,1.46l-5.93,0.18l-2.0,-1.59l-2.1,0.31l-2.9,-1.9l-2.34,-0.76l-0.34,-0.51l0.04,-0.64l0.37,-0.31l0.91,0.23l3.25,-0.17l2.72,0.75l2.15,-0.5l1.47,0.05l1.2,-0.63l0.31,-1.04ZM281.64,182.69l0.03,-0.1l0.06,-0.03l0.02,0.02l-0.1,0.11ZM288.07,219.52l0.46,0.33l-0.02,0.09l-0.11,-0.17l-0.33,-0.26ZM288.62,220.3l0.88,0.4l0.83,-0.66l-0.26,0.96l-1.44,-0.45l-0.02,-0.25ZM284.67,215.58l1.19,0.54l0.89,-0.08l0.52,0.55l0.06,0.55l-2.19,-0.22l0.04,-0.55l-0.5,-0.79ZM213.01,164.32l1.09,0.12l4.9,2.29l5.42,2.07l2.74,0.89l4.48,0.81l4.24,2.84l3.1,0.15l1.01,1.19l1.68,0.86l1.83,1.86l1.97,0.37l3.1,3.14l-0.03,4.53l0.96,0.58l4.09,1.08l4.82,2.31l2.65,0.26l1.23,0.7l1.73,1.94l0.26,2.21l-3.31,0.37l-1.76,-0.16l-1.51,0.92l-0.11,1.15l1.81,3.58l4.09,3.84l3.0,1.71l0.85,3.28l1.58,1.19l1.19,2.87l1.75,0.32l2.88,-0.48l0.28,0.73l-0.45,1.73l0.52,0.96l1.82,0.85l3.58,0.5l-1.41,0.41l-0.27,0.39l0.11,0.73l0.81,1.06l3.91,1.51l1.36,0.14l0.3,0.12l-1.18,-0.04l-0.3,0.81l1.51,1.15l-0.81,0.48l-1.06,0.11l-2.05,-0.52l-0.55,-0.72l-1.65,-1.07l-6.19,-0.75l-2.14,-0.75l-1.75,0.25l-1.16,-0.48l-3.73,-0.44l-1.44,-1.08l-1.16,-1.86l-2.93,-2.16l-0.59,-0.91l0.13,-1.64l-0.97,0.13l-1.46,-0.88l-3.39,-5.37l-1.22,-1.38l-2.44,-1.02l-2.0,-0.18l-3.71,-0.96l-1.01,-1.32l-2.54,-0.48l-0.73,0.27l-0.27,0.55l-1.79,0.62l-1.71,-0.58l-1.87,-1.63l-0.51,0.11l0.03,0.52l0.62,0.64l1.2,2.37l-0.43,0.64l-2.31,-0.17l-0.13,0.62l0.5,0.98l-3.46,0.73l-2.94,-0.29l-1.39,0.37l-1.32,-1.17l-1.15,0.23l-0.27,0.44l0.39,0.34l0.69,0.01l1.12,1.24l2.58,-0.12l2.26,0.94l1.87,2.04l-0.04,1.05l-5.2,2.66l-3.01,-1.17l-4.64,0.31l-1.74,-0.46l-1.9,0.52l-0.9,-0.59l-0.01,-16.66l-0.85,-1.35l0.84,-2.91l-0.01,-27.96ZM281.58,162.9l1.08,-0.28l1.29,0.55l0.03,0.76l-1.54,-0.0l-0.85,-1.03ZM283.27,215.97l-1.0,-0.85l0.34,-0.57l0.5,0.26l0.16,1.16ZM278.62,155.65l-0.66,-0.55l0.06,-0.28l0.55,0.39l0.04,0.43ZM264.59,186.19l1.37,0.79l-0.08,0.81l-0.73,-0.38l-0.56,-0.73l0.01,-0.49ZM255.56,160.21l0.22,-0.71l1.45,-0.19l3.04,0.38l-0.56,0.54l-4.15,-0.02ZM259.41,184.95l-0.68,-0.65l0.49,-0.31l0.23,0.19l-0.04,0.78ZM250.53,179.67l-0.3,-0.16l0.37,-0.5l0.09,0.28l-0.15,0.38Z",name:"Papua New Guinea"},SB:{path:"M401.2,226.2l0.44,-0.5l0.72,-0.08l0.27,0.05l-0.74,0.06l-0.7,0.48ZM366.91,222.26l0.24,-0.14l0.84,0.36l-0.52,-0.17l-0.56,-0.04ZM368.23,222.63l2.3,1.29l2.05,0.15l1.1,1.91l-2.39,-0.37l-2.49,-1.35l-0.58,-1.62ZM367.84,217.48l0.01,-0.37l0.01,-0.13l0.24,0.52l-0.26,-0.02ZM361.82,207.84l0.44,-0.16l1.63,1.97l-0.3,0.51l0.01,1.05l1.59,1.22l0.69,1.68l0.08,1.03l-2.27,-1.71l-1.47,-3.77l0.27,-0.91l-0.67,-0.9ZM354.72,214.98l1.57,1.16l3.02,-0.01l1.88,1.18l1.3,1.62l-0.83,0.27l-2.47,-0.81l-3.42,-0.21l-1.5,-1.73l-0.09,-1.16l0.54,-0.3ZM360.03,233.55l0.05,0.04l-0.05,-0.03l-0.01,-0.01ZM346.24,202.07l0.73,0.16l2.81,2.24l2.45,0.96l2.8,2.04l-0.16,0.49l-0.67,-0.62l-5.23,-2.49l-2.51,-2.06l-0.22,-0.72ZM350.09,212.96l0.09,-0.06l0.14,0.09l-0.14,-0.03l-0.09,-0.01ZM341.2,209.54l0.67,-0.31l0.12,0.68l-0.63,0.23l-0.17,-0.61ZM339.58,207.08l0.82,1.76l-1.56,-0.79l-0.5,-1.51l-1.69,0.03l-0.56,0.29l1.65,-1.83l0.45,0.17l0.45,1.56l0.94,0.31ZM330.29,194.75l3.73,2.02l0.42,0.38l0.41,1.25l1.22,1.1l-1.12,-0.16l-1.38,-1.01l-1.54,-2.01l-1.74,-1.59ZM337.16,200.01l0.15,0.02l-0.03,0.02l-0.13,-0.04ZM336.24,209.27l-0.13,-0.17l0.54,-0.43l-0.06,0.17l-0.36,0.43ZM335.04,205.4l-0.51,-0.03l-0.43,-0.53l0.3,-0.6l0.65,0.34l-0.01,0.82ZM331.51,203.67l-0.81,-1.21l0.1,-0.34l1.25,0.9l-0.54,0.65ZM324.56,197.56l0.23,0.13l-0.29,0.05l0.06,-0.18Z",name:"Solomon Is."},PF:{path:"M818.2,218.52l0.51,-0.27l0.21,0.07l-0.66,0.22l-0.06,-0.02ZM809.81,211.26l0.74,0.09l-0.0,0.04l-0.63,0.19l-0.11,-0.33ZM740.27,279.5l-1.27,0.03l-0.3,-0.86l1.3,-0.09l0.27,0.91ZM741.11,280.1l0.34,0.11l0.08,0.22l-0.31,-0.13l-0.11,-0.2Z",name:"Fr. Polynesia"},FJ:{path:"M508.66,272.92l-0.0,-0.25l0.48,-0.39l-0.19,0.44l-0.29,0.21ZM497.43,272.16l0.3,-0.39l1.49,-0.09l1.33,-1.19l2.96,-0.78l1.51,-1.03l1.76,-0.2l-0.73,1.08l-1.04,0.74l-0.42,0.85l-0.01,1.03l-0.66,0.07l-0.66,-0.67l-1.06,-0.06l-1.33,0.86l-0.38,0.62l-0.94,-0.03l-0.92,0.55l-0.61,-1.13l-0.59,-0.21ZM506.04,271.76l0.18,-0.16l0.91,-0.62l-0.06,0.73l-1.03,0.05ZM494.84,277.19l0.18,0.54l2.2,1.7l-0.12,0.68l0.59,2.25l-2.1,0.26l-1.39,0.9l-1.42,0.11l-4.48,-1.33l-0.39,-1.1l1.18,-1.05l-0.08,-0.9l0.62,-0.57l2.18,-1.09l0.98,0.03l1.79,-0.6l0.27,0.17Z",name:"Fiji"},FM:{path:"M343.07,91.63l0.52,0.12l-0.04,0.44l-0.24,-0.01l-0.23,-0.55Z",name:"Micronesia"},WS:{path:"M569.03,249.95l0.88,-0.15l1.69,0.49l0.54,0.55l-2.46,-0.35l-0.65,-0.54ZM563.84,247.6l2.37,-0.43l0.64,0.55l0.25,0.72l-0.18,0.45l-1.9,0.02l-1.19,-1.3Z",name:"Samoa"},VU:{path:"M427.15,292.8l0.11,0.66l0.88,0.72l-0.11,0.23l-1.03,-0.95l0.15,-0.66ZM426.24,288.06l-0.02,0.44l0.75,0.77l-1.67,-0.73l0.05,-1.24l0.36,-0.08l0.52,0.83ZM419.3,279.22l0.36,-0.42l0.88,-0.01l0.69,0.96l-0.13,0.23l-1.13,-0.03l-0.17,-0.53l-0.5,-0.21ZM418.76,271.53l0.32,0.34l0.39,0.28l-0.55,0.09l-0.16,-0.71ZM417.42,268.27l1.12,-0.64l0.52,1.0l-1.39,-0.19l-0.26,-0.18ZM415.67,261.93l0.56,-0.52l0.37,-0.06l-0.54,0.6l-0.39,-0.01ZM411.57,267.12l-0.21,-0.24l0.28,-1.05l0.37,0.19l0.41,0.98l-0.85,0.12ZM412.83,267.52l2.5,1.78l0.24,0.51l-1.11,0.03l-0.96,0.5l-0.67,-2.83ZM413.26,252.79l0.07,-0.27l0.53,0.01l-0.14,0.32l-0.47,-0.07ZM413.39,249.66l-0.21,-0.43l0.16,-0.09l0.23,0.34l-0.18,0.19ZM406.71,256.46l0.77,1.0l0.47,2.45l0.4,0.33l0.73,-0.04l0.82,-0.96l0.52,0.72l0.47,2.25l-0.56,0.51l-1.03,-0.02l-0.95,0.43l-0.96,-1.46l0.1,-1.54l-0.89,-2.74l0.12,-0.93Z",name:"Vanuatu"}},height:606.4292604642054,projection:{type:"mill",centralMeridian:180},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","ru_mill",{insets:[{width:900,top:0,height:344.85258690118116,bbox:[{y:-12178456.231950931,x:903208.6719108557},{y:-4863989.504817909,x:19992582.811667882}],left:0}],paths:{"RU-PNZ":{path:"M118.47,262.16l0.27,-1.33l0.89,0.06l0.69,0.59l0.67,-0.39l0.35,0.2l0.55,-0.37l1.83,-0.15l0.38,-0.34l-0.18,-0.86l0.45,-0.09l2.29,0.33l0.46,0.23l0.11,0.83l0.65,0.43l1.15,-0.0l0.66,0.41l0.43,-0.18l0.84,0.46l1.26,-0.42l0.09,-0.48l-0.62,-0.86l1.09,-0.44l1.44,-0.0l0.99,0.59l1.85,-0.24l0.45,-0.43l0.91,-0.18l0.81,0.44l0.41,1.1l0.99,0.85l0.29,1.07l2.03,1.16l-0.03,3.09l0.32,0.48l-0.78,0.82l-0.8,-0.7l-1.67,0.43l-1.78,1.33l-0.13,0.42l-1.02,-0.71l-1.14,0.34l-0.4,0.46l-1.49,-0.07l-0.63,0.45l-0.64,-0.59l-2.03,-0.72l-0.39,0.38l0.08,0.44l-0.83,0.69l-2.8,-0.74l-1.92,0.26l-1.17,-0.46l0.77,-0.93l-0.81,-1.44l-1.04,-1.12l-1.76,-1.16l-0.01,-0.4l-1.28,-1.34l-0.06,-0.42l-1.05,-0.76Z",name:"Penzenskaya oblast"},"RU-VLA":{path:"M98.61,240.64l0.15,-0.68l0.64,0.96l1.32,-0.45l1.02,0.45l0.77,-0.3l0.9,0.3l0.53,-0.7l0.08,-0.99l1.26,-0.39l0.65,0.25l-0.13,1.08l0.69,1.07l1.37,0.5l2.05,-1.12l0.9,-0.1l0.8,0.65l1.1,0.28l4.09,-0.35l0.32,0.91l0.77,0.23l1.24,-0.72l1.43,0.36l0.61,0.56l0.04,0.72l-0.42,0.36l-0.05,0.82l-0.47,0.15l-0.92,1.34l-0.65,0.16l-1.31,1.37l0.29,1.34l-0.78,0.55l-0.34,1.22l-0.75,0.18l-1.16,-0.15l-1.15,-0.61l-0.72,0.13l-0.62,-0.43l-1.69,0.37l-0.49,-0.85l-1.68,-0.08l0.13,-0.56l-0.6,-1.33l-1.37,-1.69l-2.47,0.43l-0.35,-0.45l-1.26,-0.11l-0.41,-0.63l-0.99,0.09l-0.95,-0.4l-0.4,-1.51l-0.48,-0.41l-0.13,-1.41l-0.41,-0.45Z",name:"Vladimirskaya oblast"},"RU-LEN":{path:"M43.32,221.38l0.55,-1.05l0.33,0.04l-0.16,0.49l0.49,0.26l0.49,-0.25l0.23,-0.7l1.71,-0.41l-0.08,-0.6l-0.76,-0.3l-0.53,0.18l-0.91,-1.01l-0.11,-1.93l0.56,0.79l0.88,0.21l0.56,-0.4l0.2,-1.09l0.9,0.52l0.92,0.01l0.9,-0.46l0.72,-1.2l2.31,0.35l0.27,0.74l3.11,1.98l1.3,-0.12l1.69,-1.14l-0.19,-0.81l-1.05,-0.51l0.01,-0.86l-0.83,-0.59l-0.09,-0.76l-4.14,-1.15l-1.36,0.74l-1.4,-0.05l-1.27,-1.37l-0.75,-0.06l0.32,-0.34l-0.26,-1.22l0.41,-0.8l-0.36,-0.56l-1.93,0.52l-0.97,0.88l-1.17,0.18l2.93,-2.49l0.78,-0.3l0.88,-1.0l2.44,-1.54l1.28,0.98l1.64,-0.01l14.95,4.22l2.26,-0.83l0.67,-0.58l0.12,-0.64l0.88,-0.28l0.22,-0.36l1.28,0.31l0.43,-0.18l0.62,-1.07l-0.05,-0.54l-1.01,-0.45l-0.74,0.36l-0.15,-0.34l3.37,-0.16l1.09,0.75l0.48,-0.25l0.32,-0.75l0.84,-0.28l2.76,0.41l0.24,0.56l0.48,0.19l1.05,-0.16l-0.89,1.09l-0.06,0.68l-1.13,0.25l-0.68,0.85l0.51,0.98l0.06,1.57l-0.55,1.44l0.08,1.32l-0.4,0.65l0.29,0.38l1.41,0.38l-0.06,1.58l0.52,0.57l0.0,0.51l-1.09,0.56l0.69,0.78l-0.53,0.49l-1.86,0.4l-0.82,1.08l-0.85,-0.04l-1.52,-0.66l-1.39,0.36l-2.44,-1.71l-1.05,-0.08l-0.39,0.38l-1.37,-0.77l-0.53,0.1l-1.24,1.26l-0.01,0.77l-1.51,-0.4l-1.27,-1.43l-1.22,-0.03l-0.66,0.63l-1.27,-0.42l-0.45,0.34l-0.37,1.95l-0.68,0.56l-0.56,-0.59l-0.86,0.0l-1.82,2.58l-1.25,0.23l-1.49,-0.34l-0.48,0.44l0.04,1.78l-1.24,0.21l-0.92,-0.14l-0.05,-0.42l-0.59,-0.5l-0.7,-0.2l-0.39,-0.63l-1.54,-0.93l-3.69,-0.38l-0.75,-0.99l-1.58,-0.2ZM45.49,209.46l-0.0,0.03l-0.01,-0.03l0.02,-0.0Z",name:"Leningradskaya oblast"},"RU-SAK":{path:"M717.47,282.28l0.03,-0.07l0.9,-0.55l-0.35,0.83l-0.58,-0.2ZM712.59,285.63l0.78,-0.53l1.45,-0.32l1.09,-2.01l0.53,-0.38l0.12,1.08l-1.26,1.71l-0.5,0.4l-1.13,0.19l-0.71,0.75l-0.34,-0.09l-0.03,-0.81ZM713.83,281.28l0.02,0.0l-0.01,-0.0l-0.0,-0.0ZM709.27,291.83l0.13,-0.44l0.12,-0.11l0.12,0.35l-0.37,0.19ZM682.7,316.18l0.52,-0.8l0.39,-0.06l-0.5,0.53l-0.41,0.33ZM684.17,314.91l0.83,-0.97l0.43,-0.08l-0.35,0.64l-0.92,0.41ZM686.17,313.28l-0.02,-0.08l0.35,-0.1l-0.11,0.09l-0.22,0.09ZM670.39,322.32l0.2,-0.55l1.21,-0.86l-0.25,0.55l-1.16,0.86ZM672.77,320.21l1.24,-1.05l0.68,0.19l-1.11,1.08l-0.8,-0.22ZM677.09,318.18l0.61,-0.47l0.33,-0.11l0.04,0.58l-0.98,0.01ZM664.01,325.14l0.51,-0.98l0.82,0.52l-0.32,0.22l-1.01,0.24ZM641.21,272.83l0.27,-0.49l-0.23,-1.42l0.97,-1.54l0.46,-3.09l-0.64,-2.46l1.52,-0.73l0.41,0.94l1.35,-0.1l0.66,-0.87l0.62,-0.25l-0.1,-0.64l0.8,-0.88l0.73,2.39l0.66,0.33l0.72,3.27l-0.14,1.52l-0.31,0.16l-0.79,1.96l0.27,0.59l-0.35,0.99l0.13,1.27l0.93,1.41l-0.44,1.59l0.28,0.41l0.96,-0.09l-0.3,1.13l0.78,0.88l1.28,6.13l1.74,3.78l0.85,3.46l-0.92,-0.6l-3.91,-0.95l-0.55,0.35l0.13,0.64l-1.43,1.16l-0.14,1.49l-1.95,4.86l-0.43,2.15l0.32,1.74l0.75,1.54l0.9,0.35l0.6,0.76l0.54,2.32l-0.16,0.62l0.63,0.83l-1.62,0.01l-0.47,-0.97l-1.38,0.48l-0.73,0.97l-1.1,3.38l-0.39,0.31l-0.85,-3.63l1.26,-3.14l-0.5,-3.61l1.2,-2.55l-0.32,-2.53l-1.44,-2.72l0.58,-0.7l0.83,-4.09l0.26,-4.33l-0.15,-1.95l-0.53,-1.16l0.29,-1.83l0.89,-2.15l-1.04,-2.64l-1.24,-1.23l-0.28,-1.24l-0.58,-0.37l-0.13,-1.24ZM649.04,309.82l0.74,0.15l0.47,-0.25l0.38,1.91l-0.24,0.45l-0.25,-0.71l0.16,-1.07l-1.25,-0.49ZM646.84,259.79l-1.42,-1.97l0.93,-0.37l0.16,-0.56l1.07,1.5l-0.74,1.4Z",name:"Sakhalinskaya oblast"},"RU-KYA":{path:"M309.54,105.92l4.29,0.0l3.16,1.72l3.2,0.82l-0.02,0.74l3.15,1.76l0.43,0.88l2.32,0.78l2.57,-0.05l3.46,-0.75l0.71,0.51l1.14,0.0l-0.47,0.72l-0.87,0.5l-0.19,1.22l-3.75,1.36l0.0,1.15l0.37,0.75l-0.68,0.55l-0.07,0.59l0.99,1.98l-0.77,0.52l-0.88,1.42l0.88,3.0l0.63,0.78l0.46,0.08l0.2,-0.62l-0.79,-3.07l1.14,-0.16l0.28,-0.3l-0.07,-0.65l0.56,-0.85l-0.22,-0.45l0.72,-1.11l1.78,0.61l-0.64,3.91l-1.73,1.49l-0.19,0.57l0.09,0.75l1.38,0.95l1.71,0.12l0.44,-0.88l-0.81,-1.41l2.3,-0.09l1.49,-1.49l0.01,-1.21l-0.82,-1.33l-0.01,-0.62l-1.16,-2.53l-0.75,-0.6l-0.34,-1.21l1.05,-1.16l0.03,-0.79l0.66,-0.24l0.55,-0.71l0.05,-1.04l-1.63,-2.33l-1.16,-0.44l-2.39,-0.06l-0.34,-0.6l-1.54,-1.1l0.12,-1.22l-0.72,-0.87l-3.32,-0.72l-2.0,-0.05l-2.13,-1.48l0.41,-0.51l-0.08,-0.56l-0.91,-0.65l0.67,-0.65l0.4,-1.54l-0.49,-1.17l-0.98,-0.53l-0.19,-1.92l-0.77,-0.37l1.16,-0.93l0.29,-0.49l-0.11,-0.64l6.57,-0.86l8.01,0.07l6.81,-1.1l1.16,0.54l2.22,-0.01l0.59,-0.27l0.44,-0.86l6.09,-0.82l1.15,0.23l-3.36,1.84l-1.51,0.41l-1.72,1.08l-0.19,0.56l0.41,1.59l2.05,0.79l0.73,0.82l1.6,0.53l0.61,1.2l0.64,-0.32l-0.32,-1.31l-2.03,-1.49l-2.33,-0.81l-0.22,-0.83l1.56,-0.78l5.04,-0.55l1.17,-1.09l-0.12,-0.43l1.15,-0.48l0.63,-0.76l0.03,-0.7l-0.56,-0.41l-0.68,0.09l-0.37,0.84l-0.7,-0.31l-0.91,-1.18l1.61,0.33l0.29,-0.65l-0.84,-0.63l-2.04,-0.1l-0.41,-0.47l0.03,-0.59l-0.68,-0.54l1.0,-0.21l0.02,0.36l0.59,0.14l0.46,-0.84l1.12,-0.29l-0.18,-0.45l-0.76,-0.25l-0.14,-0.61l-1.91,-0.14l-0.15,-0.22l0.53,-0.31l-0.25,-0.58l0.85,0.22l0.39,-0.22l-0.19,-1.06l0.53,0.04l0.25,-0.31l0.05,-1.19l1.49,-0.85l0.95,0.18l1.15,-1.02l-0.06,-0.7l-0.3,-0.13l-1.96,-0.08l-1.64,-0.49l4.73,0.67l1.96,-0.86l0.31,-0.81l1.01,-0.08l0.49,-0.54l-0.15,-0.3l0.92,-0.18l0.5,-0.51l1.09,-0.06l0.02,-0.39l0.56,-0.39l0.73,0.45l1.69,0.05l0.3,-0.17l-0.02,-0.54l1.54,-0.09l0.27,-0.72l2.58,-0.26l1.3,-0.54l0.54,0.43l0.94,-0.4l0.4,0.29l2.05,-0.07l0.51,-0.29l0.12,-0.74l3.58,-0.09l8.76,-1.85l0.6,-0.31l0.09,-0.76l-2.45,0.45l-0.75,-0.54l-1.02,0.49l-0.23,-0.31l-0.01,-0.23l0.54,0.15l0.57,-0.37l2.4,-0.07l0.09,-0.73l1.62,0.02l0.2,0.55l0.5,0.21l0.9,-0.27l0.68,-0.8l0.79,0.43l1.62,-0.13l0.83,-0.43l2.37,0.26l0.46,0.22l-0.08,0.58l-2.04,1.16l0.03,0.69l0.97,0.39l1.24,-0.99l1.88,-0.1l0.76,-0.55l0.18,0.22l-0.71,0.81l0.62,0.44l1.05,-0.35l0.79,0.18l1.56,-1.19l0.44,0.76l0.76,-0.13l0.24,-0.5l2.39,-0.04l0.25,-0.74l1.71,-0.45l0.35,-0.42l-0.5,-0.4l1.15,-0.08l1.3,-0.63l0.38,0.49l1.56,-0.23l0.05,0.53l0.51,0.32l1.45,-0.08l-0.09,0.24l0.63,0.58l0.81,0.03l-0.36,0.55l-0.06,1.0l-1.32,1.04l0.32,0.35l1.01,0.12l1.89,-1.7l0.12,-0.63l-0.41,-0.69l0.2,-0.9l-0.55,-0.8l-0.71,-0.36l-0.46,-0.95l-0.95,-0.11l-0.74,-0.75l-1.02,-0.04l-0.65,-0.93l2.8,0.48l3.57,-0.25l0.68,0.32l2.73,-0.81l0.95,0.85l1.54,-0.24l2.09,0.33l0.64,0.53l2.14,0.21l0.4,-0.23l-0.08,-0.45l-0.57,-0.45l-4.2,-1.08l-1.59,-0.07l1.13,-2.16l-0.26,-0.53l-1.25,-0.19l-0.39,-0.73l0.32,-0.75l1.39,-0.14l0.08,-1.24l2.89,-1.81l1.45,-1.31l0.93,0.14l1.65,-1.37l1.69,-0.52l1.56,-1.23l0.74,0.46l1.24,-0.14l2.41,-1.16l0.71,0.08l0.07,0.39l0.5,0.27l2.1,-0.43l0.7,1.04l2.66,0.84l2.32,-0.25l0.78,1.39l-1.01,-0.01l-2.95,1.89l-5.46,1.02l-0.31,0.17l-0.01,0.68l1.21,0.13l2.23,-0.33l0.72,0.31l3.07,-0.09l-0.47,0.85l0.47,0.42l2.4,-0.14l1.6,-0.73l2.35,0.66l0.78,-0.08l0.12,-0.47l0.66,0.48l1.18,-0.05l0.44,0.34l-0.17,0.57l-1.14,0.71l-0.63,0.89l-1.01,-0.05l-0.21,0.66l0.22,0.24l-0.48,0.58l-0.95,-0.29l-0.58,0.27l-0.14,0.69l0.48,0.9l2.16,0.45l0.72,-0.42l1.75,-0.28l1.6,0.31l1.5,-0.33l0.99,-1.16l-0.19,-1.06l1.07,0.0l0.44,0.36l4.66,-0.28l0.86,-0.3l3.71,0.74l1.67,-0.71l0.96,-0.08l0.81,0.41l1.18,-0.08l0.32,-0.34l0.28,0.73l1.79,0.04l0.2,0.82l1.87,0.23l1.46,0.97l-1.55,1.15l-0.04,0.53l0.52,0.1l2.08,-1.15l1.9,0.91l-0.04,0.76l-0.8,-0.1l-0.01,0.7l1.6,0.7l-0.25,0.39l-1.01,0.31l0.08,0.7l2.41,-0.22l0.53,-0.45l0.03,-0.55l1.28,0.42l-0.17,-0.97l0.35,0.44l-0.02,1.12l0.4,0.49l-0.25,0.09l-0.04,0.71l0.37,0.2l-0.36,0.41l0.68,0.4l0.66,-0.16l0.21,-0.59l0.36,0.01l0.19,0.44l-0.83,1.79l-2.35,-0.52l-3.2,-1.68l-1.55,0.05l-0.19,0.41l1.02,0.99l1.36,0.36l-0.03,0.53l0.36,0.28l-0.32,0.69l0.38,0.57l1.42,0.04l0.14,-0.78l0.64,-0.22l-0.08,0.63l0.29,0.35l1.93,0.5l-0.79,0.72l0.55,0.6l-0.15,0.4l-3.67,2.99l-3.89,1.23l-0.53,0.96l-1.4,1.18l-1.81,-0.26l-2.32,1.06l-0.05,0.43l-2.09,0.69l-1.32,-0.09l-0.27,0.19l0.27,0.74l-0.5,0.28l-3.36,0.61l-0.35,0.31l0.19,0.43l0.61,0.31l1.24,-0.11l-0.2,0.38l-2.01,1.14l-2.56,0.65l-2.41,2.08l-0.68,0.05l0.03,0.5l-1.4,0.94l-0.87,-0.08l-1.07,0.57l-1.93,-0.22l-1.34,0.2l-0.49,0.66l0.2,0.34l-1.28,0.87l-0.46,0.99l-0.58,0.27l-2.04,-0.16l-1.13,0.55l-0.41,1.26l-0.84,0.69l-0.11,0.87l-0.91,0.9l-1.76,0.99l-1.05,0.13l-0.35,0.46l0.58,0.51l2.16,-0.03l2.42,-1.24l0.38,-0.54l0.35,0.37l2.83,0.81l2.46,-0.25l0.15,-0.71l-0.27,-0.2l-2.39,-0.26l-1.86,-0.69l-0.14,-1.05l0.58,-0.44l2.21,0.5l1.34,-0.39l3.63,0.11l1.86,-0.77l1.3,0.22l0.54,-0.33l0.06,-0.59l4.09,-0.74l0.46,-0.45l0.57,0.16l0.4,-0.42l1.92,-0.16l1.43,-0.51l0.38,-0.65l1.17,-0.21l0.27,-0.42l2.22,-0.39l0.61,0.32l-1.34,0.24l-1.32,1.47l-2.01,0.09l-0.31,0.36l0.38,0.56l1.79,0.71l-0.87,0.57l0.09,0.57l1.9,0.26l0.38,0.87l-0.54,0.4l0.17,0.59l-0.85,0.57l0.21,2.29l0.4,0.52l0.71,0.18l0.28,0.55l1.76,0.39l-1.0,0.68l0.07,0.86l1.63,0.65l1.05,0.02l0.1,0.78l0.82,0.8l1.14,0.25l0.04,6.78l2.83,1.6l0.71,-0.04l-0.71,0.41l0.02,0.73l-1.23,0.64l-0.92,-0.51l-0.64,0.75l-2.35,0.45l-0.95,0.77l-4.19,0.55l-0.54,0.86l-0.7,0.09l-1.12,0.7l-0.37,1.07l0.34,0.93l-2.5,0.35l-0.46,0.39l0.03,0.72l-1.44,0.6l-0.08,0.75l0.95,1.39l-0.43,1.33l-0.53,0.5l-1.14,-0.12l-0.6,-0.52l-3.32,-0.1l-1.21,0.77l-0.55,0.84l-4.18,0.87l-1.49,0.63l-1.04,0.01l-1.05,-0.47l-1.85,1.63l0.12,0.65l3.79,4.78l0.01,6.69l-0.48,6.74l-0.41,0.52l-0.9,-0.23l-1.41,0.88l-0.91,0.16l-0.56,0.97l-2.06,0.29l-0.35,0.49l0.96,1.0l1.66,0.37l-0.2,0.7l0.73,0.3l0.49,0.63l0.36,1.64l-1.04,0.84l0.09,1.84l0.44,0.52l0.83,0.12l0.57,0.96l-0.2,3.05l1.13,0.44l0.5,0.71l0.86,0.25l-0.27,0.5l-0.83,-0.14l-0.64,0.26l-1.39,1.96l-1.62,1.02l-0.17,0.35l0.38,0.62l-0.97,1.1l-0.13,0.91l-0.62,0.25l0.06,1.0l0.56,1.03l1.27,-0.08l0.09,0.55l0.49,0.23l2.82,-0.5l0.38,0.39l2.32,0.7l0.83,0.73l1.39,-0.4l1.14,0.87l0.78,0.18l0.98,-0.58l0.5,1.22l-2.97,0.09l-0.52,0.38l-0.17,0.68l-0.61,-0.01l-0.63,-0.72l-0.69,-0.03l-0.45,0.49l-1.51,-0.82l-0.78,0.23l-0.21,0.8l0.49,0.62l-0.74,1.07l0.21,0.73l-0.87,1.04l0.99,1.28l-1.16,-0.13l-0.56,0.66l0.12,1.26l-1.11,0.14l-0.29,0.34l0.56,1.68l1.17,0.5l0.31,1.28l0.98,0.48l-0.06,0.82l-0.53,0.5l-0.68,0.07l-0.69,1.25l0.57,0.6l-0.24,1.03l-0.73,0.19l-1.75,1.46l-0.16,0.55l0.28,0.56l-0.42,0.32l-0.58,-0.04l-1.79,0.95l-0.71,0.87l-1.34,0.15l-1.2,0.7l1.0,1.07l-0.56,0.05l-1.28,0.91l-0.25,1.54l-0.62,0.43l0.54,1.01l-0.22,0.85l0.85,2.02l1.37,0.91l2.23,0.04l0.56,0.34l-0.28,0.63l0.33,0.9l-0.26,1.02l-0.87,-0.24l-0.97,0.19l-1.5,1.44l0.53,1.63l0.67,0.6l0.98,0.06l-0.11,0.84l0.57,0.58l0.11,0.87l-0.81,0.23l-1.84,1.42l-0.31,0.66l0.37,0.75l-1.48,0.29l-0.28,-0.61l-2.06,-0.5l-0.51,-0.98l-1.42,-0.21l-1.19,-0.74l-0.45,-0.84l0.37,-0.4l-0.33,-0.6l-1.32,-0.05l-0.61,-0.41l-1.13,0.88l-1.45,0.15l-0.54,0.4l-0.33,0.8l0.17,1.12l0.5,0.49l-0.02,0.9l-1.0,0.55l-0.59,0.88l-2.63,0.82l-0.94,1.47l-1.13,0.06l-1.06,0.88l0.09,1.03l-0.61,0.67l-0.72,-0.11l-0.43,0.49l0.26,0.84l-0.26,0.9l0.7,0.83l-0.63,0.51l-1.43,-0.85l-0.32,-1.43l-1.15,-0.94l-0.27,-1.38l-0.48,-0.42l-2.12,0.05l-1.48,2.09l-2.24,0.56l-0.99,-0.53l-4.42,-0.13l-3.34,6.01l0.79,1.04l-0.02,1.11l1.38,0.21l-0.05,1.42l0.68,0.42l0.0,0.44l-1.6,0.28l0.05,1.27l-0.88,0.91l-0.81,-0.32l-0.65,0.17l-0.78,0.7l-0.11,1.04l-1.01,0.73l-0.13,1.0l0.76,2.34l-0.97,0.45l-0.26,1.45l-0.34,0.22l-0.08,0.37l0.62,1.01l-0.73,1.16l-0.08,0.98l-0.68,-0.35l-1.64,-0.01l-0.78,1.24l-0.96,0.04l-0.58,0.73l0.15,1.07l1.91,1.17l0.07,0.55l2.45,2.32l0.66,0.3l-0.7,0.05l-0.27,-0.43l-0.8,-0.17l-1.1,1.14l-1.58,-0.45l-1.91,1.05l-0.7,-0.6l-1.07,0.55l-1.85,0.07l-0.92,0.69l0.37,0.68l-0.73,1.98l-0.88,-0.0l-0.99,0.56l-0.43,1.24l-1.65,1.7l-0.52,1.5l-1.12,0.32l-2.96,2.12l-1.7,0.41l-2.6,-0.03l-0.54,-0.43l-1.83,-0.32l-1.67,0.12l-0.74,-0.41l-1.06,0.16l-0.51,-0.93l-1.14,-0.65l1.43,-1.99l2.84,-1.99l0.44,-0.69l-0.14,-1.33l1.37,-0.46l1.11,-1.22l-0.03,-0.68l-0.59,-0.75l-1.34,-0.44l-0.74,-1.83l0.68,-1.02l-0.03,-1.02l-1.11,-1.58l-0.46,-1.48l-1.5,-1.03l0.11,-1.32l-1.17,-0.78l-1.0,-0.03l-0.41,-0.87l-0.86,-0.29l-0.27,-0.57l-0.49,-0.15l-2.59,0.94l-0.69,-0.2l-1.54,0.38l-1.07,-1.19l-0.35,-0.94l-1.33,-0.86l1.05,-0.88l2.63,-1.19l0.52,-0.95l-0.7,-0.55l-0.28,-1.14l-1.03,-1.13l-0.1,-0.6l-1.94,-0.75l-0.58,-1.14l0.4,-0.12l0.51,-0.85l-0.59,-1.0l0.49,-1.88l-0.79,-0.29l0.8,-0.5l0.66,-1.5l1.01,-0.52l0.42,-0.64l1.2,-0.32l0.14,-2.54l-0.54,-0.55l-2.47,-0.08l-0.86,-0.57l-2.82,-0.55l-0.95,-2.62l2.3,-2.87l2.44,-1.1l-1.16,-1.7l-0.11,-0.82l-3.76,0.16l-1.89,-2.97l-1.8,-0.28l-0.73,-1.54l-2.49,-0.54l-3.45,-0.05l-2.52,0.5l-4.06,-0.1l-0.38,-0.3l0.3,-1.45l0.84,-1.53l-2.52,-3.73l7.01,-3.22l0.25,-0.22l-0.19,-0.72l1.67,-0.84l-0.07,-0.8l-0.7,-0.55l-0.87,0.09l-1.16,-0.39l-0.54,-0.59l-0.65,0.11l-1.37,-0.81l-1.46,-0.13l-0.74,-0.73l0.14,-0.54l-0.56,-1.36l2.14,-2.04l0.39,-1.02l0.83,-0.54l1.11,-1.74l0.98,-0.45l0.51,-1.24l-0.06,-0.64l-0.48,-0.36l1.0,-1.49l-0.14,-0.52l-1.42,-0.16l-0.12,-0.72l-0.96,-0.51l0.83,-0.93l0.23,-0.92l0.69,-0.89l2.44,-1.35l0.36,-1.87l-1.0,-1.69l0.39,-0.83l-0.5,-0.7l0.18,-0.98l-0.45,-0.45l-1.46,-0.41l-1.99,0.65l-0.2,-0.38l-0.63,-0.09l0.02,-0.63l-0.56,-0.39l-2.7,0.3l0.29,-0.68l-0.39,-0.55l0.36,-0.59l0.68,-0.3l0.38,-0.84l-0.5,-2.06l-1.01,-0.73l-0.09,-0.99l-0.77,-0.15l-0.78,-0.81l-2.43,-0.02l-0.03,-0.77l-1.1,-1.16l1.07,-0.74l0.08,-0.63l-2.32,-2.41l-0.02,-0.73l1.02,-0.5l0.01,-0.73l-1.35,-1.84l-4.31,-2.77l0.72,-0.54l0.07,-0.51l-0.43,-0.57l0.35,-0.19l0.3,-0.9l-0.37,-0.5l-1.19,-0.38l-0.1,-1.08l-1.08,-0.59l-0.4,-0.58l2.92,-0.26l0.2,-1.92l0.65,-0.06l0.13,-0.65l0.87,-0.69l-0.07,-1.77l-0.56,-0.83l2.08,-0.44l0.31,-0.55l-1.2,-0.81l-0.31,-0.59l-1.06,-0.16l-0.25,-1.26l-0.45,-0.48l0.41,-0.52l-0.26,-0.81l-0.55,-0.29l-2.77,-0.15l-0.17,-0.16l0.68,-0.51l0.07,-0.61l-1.54,-1.1l-0.76,0.49l-0.12,1.14l-1.13,-0.15l-1.81,0.68l-1.15,-0.86l-2.74,-0.48l-1.62,0.06l-1.01,-0.91l-1.13,-1.88l-1.72,-0.24l-0.56,-0.98l-0.14,-0.39l0.95,-0.73l0.13,-0.65l0.7,-0.01l0.15,-0.54l0.64,-0.09l0.75,-1.08l1.22,-0.46l1.74,-1.33l1.49,-0.32l0.79,0.63l0.57,-0.1l0.36,-0.81l-0.78,-0.5l0.59,-1.55l-0.78,-0.66l0.41,-0.64l-0.65,-0.7l-0.3,-2.11l-3.13,-0.77l-2.04,-1.37l-1.74,-0.41l-0.2,-0.51l0.98,-0.53l0.25,-0.94l2.24,-0.0l1.39,-0.69l0.23,-0.43l-0.15,-1.34l1.08,-0.25l0.17,-0.69l-0.75,-0.65l-2.83,-1.17l-1.41,0.11l-1.58,-0.33l-2.19,-1.04l-0.3,-0.88l-0.63,-0.33ZM319.28,96.03l-0.12,-0.01l0.02,-0.03l0.11,0.03ZM352.06,86.43l-1.52,-0.2l-0.18,-1.04l1.07,-0.12l0.11,0.47l0.53,0.14l-0.01,0.75ZM349.68,86.2l-0.84,-0.02l-0.05,-0.25l0.54,0.05l0.36,0.22ZM351.9,83.05l-2.24,-0.6l-1.55,-0.09l1.02,-0.17l0.43,-0.43l0.66,0.6l1.19,-0.06l0.5,0.76ZM387.19,68.19l-0.19,-0.09l-0.23,-0.03l0.12,-0.19l0.29,0.3ZM385.84,68.37l-0.6,0.14l0.14,-0.61l0.2,0.34l0.26,0.13ZM451.2,56.59l0.44,-0.09l0.35,0.1l-0.79,-0.01ZM485.81,61.76l0.05,-0.0l0.52,0.18l-0.48,-0.02l-0.09,-0.16ZM486.56,61.96l0.88,-0.18l0.45,1.22l-0.81,-0.78l-0.52,-0.26ZM472.57,91.33l1.44,-0.55l0.84,-1.26l2.71,0.22l2.02,0.85l1.14,-0.61l0.21,0.45l-1.79,0.79l-1.16,-0.15l-1.91,0.8l-2.48,0.01l-0.48,0.29l-0.54,-0.86ZM461.48,54.17l-0.02,-0.24l0.37,0.14l-0.35,0.09ZM457.97,44.58l2.24,0.13l0.49,-0.3l1.06,0.03l0.28,0.32l-0.62,0.35l-0.29,-0.45l-1.2,0.17l-1.96,-0.25ZM454.49,43.55l0.15,0.02l-0.08,0.02l-0.07,-0.03ZM456.12,42.75l0.09,-0.07l0.12,0.0l-0.22,0.07ZM419.1,45.79l1.18,-1.58l2.33,-1.6l-0.03,-1.0l1.36,-1.88l-0.04,-0.99l0.53,-0.87l0.88,-0.43l2.36,0.61l0.82,-0.26l-0.16,-0.8l-1.45,-0.25l-0.23,-0.72l0.51,-0.86l0.56,-0.46l2.66,0.65l0.49,-0.17l0.17,-0.45l-0.39,-0.29l-2.78,-0.79l0.93,-0.64l-0.11,-0.41l1.79,-0.53l0.13,-1.15l0.25,-0.1l0.67,-0.06l0.79,1.28l1.94,0.03l0.04,-0.62l-0.51,-0.85l0.5,-0.58l2.79,0.58l0.38,0.46l-1.27,1.57l0.14,0.46l-1.93,3.11l-0.09,0.79l1.36,-0.18l1.4,-1.34l0.6,-1.11l1.13,0.02l2.18,-1.04l1.03,-0.01l0.85,0.19l-0.04,0.78l0.66,0.72l1.74,0.32l0.09,0.55l-0.65,0.47l0.35,0.37l1.12,0.13l-0.36,0.45l0.29,0.35l1.01,-0.19l0.41,-0.72l1.54,0.43l1.02,2.46l-0.13,0.49l-2.81,1.82l-0.61,-0.25l-1.54,0.17l-3.39,0.97l-3.72,0.01l-1.25,0.89l-0.81,-0.55l-2.93,0.37l-0.43,-0.22l-3.96,0.21l-1.24,0.76l-5.02,1.88l-2.53,0.17l-0.6,-0.6ZM422.21,26.91l0.0,-0.06l0.1,-0.01l-0.09,0.06l-0.01,0.01ZM387.26,28.45l0.21,-0.1l-0.15,0.3l-0.06,-0.2ZM387.32,28.75l0.0,0.01l-0.0,0.0l0.0,-0.01ZM389.78,27.2l0.27,-0.52l1.59,-0.73l2.68,-0.48l0.11,-0.79l-1.69,-0.68l0.19,-0.34l1.91,-0.58l1.02,-0.95l1.36,0.89l0.69,-0.18l0.24,-0.7l0.45,-0.19l3.46,0.24l0.52,-0.27l1.24,0.08l0.52,-0.36l0.63,0.22l4.47,-0.67l1.18,0.52l0.84,0.66l-0.96,0.35l-0.32,1.13l-1.11,0.63l-0.19,0.92l-1.69,0.59l0.01,0.73l0.46,0.14l2.54,-0.77l0.37,-0.62l0.86,-0.5l0.11,-0.53l1.45,0.36l0.87,-0.13l1.1,-1.19l0.11,-0.5l-0.51,-0.37l3.01,0.1l0.05,0.37l0.85,-0.01l0.94,0.84l1.39,0.38l1.06,1.19l-0.89,0.15l0.16,0.82l-0.48,0.38l-0.4,1.36l0.22,0.35l-0.37,0.63l0.03,1.56l-0.92,0.49l-1.87,-0.55l-0.45,0.2l-0.13,0.59l2.59,1.36l-0.2,0.42l0.45,0.39l1.42,0.24l0.36,1.21l-2.4,1.26l-4.15,0.08l-0.46,0.38l-0.89,-0.02l-1.22,-0.42l-1.67,0.13l-1.27,-0.53l-1.44,0.02l-2.53,-1.58l-2.07,-0.05l-0.25,-0.33l-3.31,0.26l-0.08,-0.75l-0.96,-0.53l-2.53,0.82l-1.79,-0.85l0.03,-0.61l-0.38,-0.42l-1.27,-0.41l0.19,-1.88l-0.29,-0.79l-0.74,-0.28l-1.04,0.17l-0.9,-0.47l0.45,-0.82l-0.6,-0.26ZM378.52,18.83l1.48,-0.38l3.58,0.08l0.24,-0.42l-0.35,-0.34l-2.8,-0.38l3.81,-0.49l0.36,-1.7l2.07,-1.34l0.29,-0.66l-0.49,-0.36l-1.87,0.41l-0.98,-0.1l0.49,-0.68l2.01,-0.53l0.25,-0.41l-0.18,-0.53l1.45,-0.39l1.07,0.11l3.72,-0.98l0.99,0.1l1.75,-0.5l1.57,-0.9l1.78,-0.04l0.37,-0.27l-0.22,-0.51l0.96,-0.06l0.89,0.98l0.91,0.09l1.86,1.32l0.24,0.75l1.13,0.95l3.68,1.49l1.5,0.1l0.14,0.26l-0.17,0.92l-3.0,0.02l-0.72,1.15l-0.23,0.98l0.99,1.28l0.09,1.04l0.65,0.27l-0.61,0.54l-11.15,1.13l-1.05,-0.13l-0.67,0.37l-0.88,-0.14l-2.05,1.08l-2.2,0.52l-3.65,-1.13l-0.58,-0.29l0.1,-0.54l-0.44,-0.32l-2.69,-0.47l4.89,0.32l0.44,-0.18l0.12,-0.53l-0.62,-0.58l-8.26,0.06ZM397.89,65.7l0.01,-0.15l0.44,0.15l-0.45,-0.01ZM399.47,65.83l0.6,-0.43l1.02,0.18l0.48,0.57l0.6,-0.25l0.16,0.38l-2.86,-0.45ZM402.61,66.49l0.02,0.01l-0.0,0.01l-0.02,-0.02ZM402.34,65.59l0.16,-0.22l0.13,-0.03l-0.03,0.18l-0.25,0.07ZM398.97,56.9l0.0,-0.0l0.01,0.0l-0.01,0.0ZM400.66,56.63l2.17,-0.66l0.81,-0.52l-0.28,0.7l-0.99,0.46l-0.19,0.44l-1.02,0.02l-0.49,-0.46ZM402.2,61.14l0.26,-0.17l0.21,0.03l-0.04,0.14l-0.43,0.01ZM376.19,22.62l1.77,0.21l1.04,-0.29l3.26,0.38l1.23,0.56l5.66,0.7l-3.63,1.73l-3.26,0.46l-0.19,-0.89l-1.24,-0.68l-4.38,-0.42l0.28,-0.24l-0.04,-0.6l-0.55,-0.35l0.05,-0.56ZM369.62,8.9l0.48,-0.42l7.13,0.41l-1.44,0.73l-6.17,-0.72ZM368.06,55.18l-1.94,0.16l-0.56,-0.5l0.52,-0.5l1.39,-0.05l0.59,0.88ZM363.91,57.2l-0.82,-0.59l1.2,-0.36l-0.38,0.4l-0.0,0.55ZM353.31,79.48l0.57,-0.08l0.18,0.16l-0.4,0.16l-0.36,-0.24ZM347.55,84.26l0.26,-0.55l0.49,-0.04l-0.23,0.46l-0.52,0.13ZM345.92,81.28l0.17,0.07l0.07,0.02l-0.07,0.03l-0.17,-0.12ZM344.6,83.79l0.11,-0.05l1.18,0.01l-0.26,0.34l-1.03,-0.29ZM333.76,88.11l0.07,-0.02l0.94,0.19l-0.08,0.13l-0.93,-0.3ZM333.94,124.26l-0.05,-0.31l0.01,-0.14l0.19,0.29l-0.15,0.15ZM333.96,122.9l0.04,-0.35l0.06,-0.06l-0.01,0.21l-0.09,0.21ZM334.36,122.02l0.07,-0.35l0.04,-0.34l0.4,0.32l-0.51,0.37ZM329.88,88.07l0.6,-0.07l0.37,0.26l-0.31,-0.15l-0.66,-0.05ZM325.55,75.05l0.38,-0.3l0.37,0.52l-0.48,0.17l-0.27,-0.39ZM327.06,75.19l0.64,-0.4l0.21,0.09l-0.51,0.93l-0.35,-0.62ZM328.3,74.89l0.12,-0.02l0.02,0.04l-0.14,-0.02ZM327.91,73.86l0.02,-0.0l-0.0,0.01l-0.02,-0.01ZM312.22,12.57l0.83,-0.9l2.63,-0.29l3.23,0.43l-0.22,0.25l-6.47,0.52ZM313.86,83.25l0.46,0.05l-0.08,0.2l-0.39,-0.25ZM313.18,82.39l-0.01,-0.0l0.01,-0.01l0.0,0.01ZM310.34,100.77l2.45,-1.95l1.37,1.44l0.21,1.57l-2.92,-0.23l-0.97,-0.47l-0.14,-0.35ZM298.25,27.85l0.39,-0.31l4.47,1.0l-2.95,0.13l-0.56,-0.74l-1.35,-0.09Z",name:"Krasnoyarskiy kray"},"RU-UD":{path:"M165.86,234.92l0.22,-0.89l1.88,0.15l1.71,-1.66l0.42,-1.1l-0.03,-0.64l-0.38,-0.34l0.22,-0.77l-0.95,-1.57l0.45,-1.07l0.74,-0.68l0.86,-0.14l3.61,0.59l0.43,-0.32l0.12,-0.6l0.53,-0.02l0.26,0.5l0.98,0.59l1.07,-0.45l1.08,0.08l0.39,0.51l-0.19,0.97l1.39,1.73l0.21,1.1l0.07,0.6l-0.83,1.31l1.08,1.01l-0.39,0.85l0.46,0.49l0.56,0.04l0.05,0.33l-0.15,1.1l-1.06,0.7l-0.01,1.25l-0.87,-0.45l-0.55,0.44l0.14,1.37l0.41,0.4l0.66,-0.07l0.78,0.71l0.29,0.59l0.45,0.14l0.02,0.7l-1.1,0.7l-0.48,0.85l-0.79,-0.09l-1.27,0.96l-1.09,0.27l1.32,-1.54l-0.08,-1.08l-0.92,-0.39l-1.0,0.15l-0.32,0.49l0.29,0.56l-0.04,-0.0l-0.93,-0.7l-0.06,-0.81l0.61,-1.31l-1.17,-0.36l-0.92,0.41l0.35,0.68l-0.66,0.04l-1.09,1.2l0.18,0.69l0.73,0.11l-0.12,0.69l-0.8,-0.35l-0.55,0.25l-1.01,-0.31l-0.41,0.39l0.07,0.92l-0.93,-0.53l-0.74,0.44l-0.34,-0.29l-1.24,0.13l0.94,-0.63l0.19,-0.52l-0.29,-0.38l-0.74,0.02l-0.91,-2.0l-0.54,-0.2l-0.01,-0.57l0.04,-0.34l0.99,-0.26l0.86,-1.58l-0.24,-0.54l-0.88,-0.31l-1.06,-2.38Z",name:"Udmurtskaya Respublika"},"RU-IVA":{path:"M104.67,238.1l0.48,-0.47l0.03,-0.55l2.16,-1.2l0.89,0.01l0.36,-0.53l4.17,-0.45l0.7,-0.64l1.97,-0.29l0.47,-0.79l-0.16,-1.32l1.06,0.43l0.7,0.71l1.01,0.28l1.44,-0.55l1.23,-0.07l0.38,-0.44l-0.06,1.76l0.54,0.55l2.34,-0.26l1.02,-1.2l0.81,0.57l0.11,0.58l-0.27,0.44l-0.67,0.18l-0.31,0.74l0.11,0.87l0.63,0.38l-1.21,0.9l-0.94,-0.09l-1.87,0.5l-0.47,1.25l0.44,0.75l-0.18,0.48l-0.82,0.0l-0.3,0.44l-1.49,-0.4l-1.26,0.64l-0.13,-0.84l-0.44,-0.33l-4.31,0.48l-1.95,-0.91l-1.32,0.06l-1.58,1.12l-0.79,-0.23l-0.43,-0.65l0.12,-0.79l-0.46,-0.85l-1.74,-0.27Z",name:"Ivanovskaya oblast"},"RU-LIP":{path:"M95.85,269.14l0.02,-0.66l0.44,-0.57l-0.3,-0.61l0.27,-1.06l0.71,0.04l1.31,0.7l1.74,-0.82l0.26,-0.69l-0.38,-1.21l0.93,-0.4l-0.09,-1.03l1.05,-0.08l0.95,1.2l1.73,-0.35l0.46,-0.82l0.63,-0.25l0.62,0.37l0.16,0.73l0.98,0.32l-0.18,3.34l-0.73,0.75l0.05,0.92l2.17,1.96l1.69,0.69l-1.01,1.65l-1.73,-0.22l-1.84,0.46l-0.85,-0.2l-0.74,-0.92l-1.54,-0.08l-0.68,0.67l-0.65,-0.64l-1.11,-0.07l-3.93,1.53l-0.45,-0.29l-0.03,-1.08l1.05,-0.47l0.31,-1.15l-1.3,-1.69Z",name:"Lipetskaya oblast"},"RU-AST":{path:"M133.75,298.72l0.8,-0.63l0.78,0.16l0.27,-0.83l1.89,-0.72l1.25,-1.33l1.18,0.16l0.79,0.5l0.62,0.42l-0.57,1.84l3.12,1.0l0.2,1.13l-0.39,0.66l0.48,0.59l0.13,0.84l1.49,0.81l0.37,-0.28l0.1,-0.63l0.97,0.36l1.99,-0.03l1.69,2.02l0.61,0.31l0.87,1.96l1.42,1.93l-0.63,0.18l-0.48,-0.46l-0.8,-0.03l-0.77,0.8l0.61,1.25l1.91,0.59l0.82,0.56l-0.1,0.58l-1.9,0.47l-0.52,0.49l0.31,0.51l-1.07,0.3l-1.41,1.2l-1.87,0.34l-0.95,-0.55l-1.19,0.11l-0.57,0.68l-1.45,0.37l1.33,-3.1l-0.45,-0.35l-1.17,0.16l-0.2,-0.92l-1.47,-0.2l0.51,-0.35l1.32,0.02l0.32,-0.33l-0.07,-0.84l1.07,-0.62l0.34,-0.78l-0.52,-0.82l-0.75,-0.17l-0.43,-0.74l-0.55,-0.15l-1.36,-2.31l1.34,-0.84l-0.03,-0.7l-1.05,-0.35l-1.65,1.27l-0.9,-0.4l-1.88,-2.15l-0.15,-1.33l-1.07,0.09l-2.56,-1.69Z",name:"Astrakhanskaya oblast"},"RU-CE":{path:"M133.18,329.58l0.87,-0.88l0.1,-0.64l1.55,0.17l0.4,-0.78l2.17,0.32l0.2,0.64l0.44,0.21l0.95,-0.25l0.74,-0.84l0.01,0.48l0.67,0.32l-1.39,2.36l0.53,0.95l-0.14,1.09l0.52,1.0l-1.41,-0.0l-0.55,0.61l0.11,0.55l-1.5,1.47l-1.24,-0.38l-0.93,0.12l-0.84,-0.96l0.23,-0.42l-0.06,-2.13l-0.55,-2.2l-0.87,-0.8Z",name:"Chechenskaya Respublika"},"RU-KHA":{path:"M582.51,259.52l0.15,-0.99l1.16,-1.03l0.69,-0.25l0.74,0.26l0.53,-0.38l0.63,-2.19l0.41,-0.36l3.46,-1.57l0.39,-1.06l1.69,-0.14l0.31,-0.43l-0.17,-0.51l1.01,-0.07l0.65,-1.02l1.29,-0.37l-0.14,-0.63l-1.39,-0.68l0.01,-0.57l-0.88,-0.98l-1.65,-0.19l-0.79,0.45l-1.44,0.2l-0.97,-0.27l-2.75,0.25l-0.49,-0.25l-0.37,-1.2l0.52,-1.78l0.66,-0.57l0.3,-1.7l0.3,-0.18l0.18,0.44l0.58,0.1l0.38,-0.36l-0.01,-0.52l0.47,0.64l0.79,-0.06l0.26,-0.42l-0.23,-0.43l0.17,-0.85l0.54,-0.51l-0.3,-1.25l-1.37,-1.24l-0.05,-0.53l-1.07,-0.67l0.98,0.02l0.58,-0.38l0.1,-1.2l1.04,-1.0l0.89,-0.07l0.5,-0.74l-0.29,-0.84l-1.0,-0.94l-0.12,-0.61l-0.71,-0.36l-0.06,-0.55l-0.39,-0.31l2.13,1.18l0.79,-0.4l0.11,-0.48l-0.53,-0.69l0.82,-0.35l-0.08,-1.7l1.13,-0.0l0.11,-0.72l0.81,-0.7l0.07,-1.67l1.06,0.02l0.44,-1.56l0.73,-0.63l2.37,-0.89l0.48,0.43l2.24,-0.18l2.42,0.83l0.91,-0.36l0.8,0.5l1.97,0.09l0.71,-0.72l0.7,-1.47l1.62,-1.02l1.47,0.81l3.73,0.56l1.1,-0.58l1.33,-0.2l0.78,-0.75l0.63,-0.08l0.12,-0.85l0.6,-0.55l1.62,-0.08l0.2,0.43l0.93,0.13l0.66,-0.31l0.28,-0.61l-0.46,-0.76l0.48,-0.83l-0.36,-2.25l0.57,-0.55l-0.19,-1.35l0.84,-1.66l-1.05,-1.2l-0.16,-0.69l0.62,-0.31l0.09,-0.71l1.71,-0.78l0.21,-0.45l-0.29,-0.47l1.23,-0.06l0.92,-0.99l0.72,0.1l1.76,-0.53l0.69,-1.36l1.46,-1.51l0.14,-1.02l0.67,0.01l0.92,-0.8l0.33,-2.67l1.3,-0.13l0.52,-1.07l1.63,1.18l0.95,-0.16l0.5,0.89l0.57,0.35l0.19,0.68l1.73,1.28l1.0,0.07l0.58,-0.38l1.51,1.65l1.51,-0.73l1.64,0.43l0.91,-1.45l0.8,0.48l0.93,0.02l-0.12,0.4l0.71,0.84l0.54,-0.05l0.73,-0.63l-0.16,0.73l0.31,0.84l0.52,0.28l1.21,-0.05l1.95,-1.1l0.28,-0.98l0.55,-0.45l0.91,-0.14l1.11,0.77l0.83,-0.17l0.95,0.29l1.28,-0.7l0.86,0.14l1.54,0.91l1.69,2.02l0.24,1.48l0.54,0.53l-0.19,0.51l0.3,1.33l-0.38,0.56l0.24,0.5l-0.68,-0.05l-0.46,0.38l-0.29,1.97l-0.99,-0.58l-0.72,-0.03l-1.21,1.05l-1.33,0.55l-0.62,1.09l0.48,1.31l1.15,0.97l3.04,-0.44l0.55,1.02l0.91,0.06l-0.11,0.92l0.76,0.73l1.25,-0.22l0.43,0.37l-0.16,3.05l-0.93,0.3l-1.1,-0.62l-1.21,-0.07l-0.84,0.8l0.08,1.2l-1.14,0.3l-0.64,-0.5l0.61,-0.74l-0.09,-0.61l-0.45,-0.15l-0.81,0.22l-0.82,-0.28l-2.08,0.11l-1.22,0.3l-5.9,-0.37l-2.03,0.76l-1.51,-0.5l-5.08,2.05l-1.43,1.09l-2.21,2.87l-3.06,1.49l-1.4,1.2l-1.37,3.27l-2.25,0.92l-1.27,1.65l-0.97,0.26l-0.9,1.1l-1.7,0.61l-0.92,0.73l-0.26,0.82l-1.48,0.59l-1.21,1.7l-1.3,0.99l-0.17,1.1l-1.09,0.77l-1.01,1.55l-0.72,0.17l-0.91,1.0l-2.45,1.47l-0.73,0.79l-1.82,0.74l-1.36,1.79l-1.52,1.04l-2.18,0.91l-1.68,1.7l0.38,1.45l2.25,0.39l0.59,0.71l5.52,-0.41l-0.57,1.06l0.33,2.03l-0.75,1.44l0.12,1.09l0.77,0.56l1.07,-0.58l1.06,0.29l0.98,-1.64l1.3,0.63l-0.84,1.28l-0.65,0.06l-0.86,0.69l0.09,0.57l0.76,0.44l3.29,-0.39l1.81,-0.99l-0.73,1.25l0.42,0.43l1.33,-0.2l0.73,-0.65l0.82,-1.77l0.42,-1.55l-0.03,-0.68l-0.27,-0.15l0.15,-0.71l2.57,0.68l2.15,-0.73l1.21,1.12l1.06,0.42l0.31,0.57l-0.05,0.82l1.36,1.01l0.38,0.67l1.74,0.85l0.2,0.67l2.07,0.93l0.18,0.6l-1.12,0.79l-1.28,-0.82l-1.14,0.16l0.11,0.66l2.41,1.78l0.47,1.09l-0.95,1.57l0.36,0.76l1.27,1.01l-0.66,1.0l0.34,0.65l-0.74,0.54l-0.52,0.98l-1.09,0.53l-0.08,0.79l-0.54,0.44l0.09,0.54l-0.64,0.38l-0.18,0.99l0.23,0.98l-0.87,1.16l-0.39,1.2l0.16,0.55l-0.29,0.74l0.37,0.68l0.03,1.87l0.38,0.74l-0.54,0.4l-0.38,0.94l0.59,0.83l0.15,1.08l-0.6,1.54l-0.54,0.54l0.15,0.89l-0.53,0.51l-0.03,0.72l0.29,0.29l-0.59,1.14l-0.09,1.74l-4.08,3.69l-1.87,3.11l-0.61,-0.32l-0.87,0.14l0.13,-0.67l-0.25,-0.45l1.09,-0.41l0.15,-0.72l-1.17,-1.35l0.48,-0.32l-0.03,-0.9l-0.79,-0.09l-0.5,-1.47l-1.27,-0.28l-0.93,0.89l-0.7,0.1l-0.62,0.53l-2.3,0.13l-0.9,0.98l0.11,0.64l1.12,0.72l-0.58,0.55l0.15,0.63l0.99,0.09l1.03,0.55l0.7,-0.15l-0.08,0.52l0.35,0.42l-2.85,1.73l-0.8,-0.56l-1.31,-0.01l-0.71,1.04l-0.06,1.09l-1.51,1.16l-0.7,-0.16l-0.91,0.3l-1.17,-0.56l-0.53,0.38l-0.37,-0.1l-0.47,-0.85l-1.49,-0.11l-0.92,-1.26l-1.35,-0.34l-2.34,0.66l-1.36,1.27l0.01,1.52l-1.39,0.13l0.19,-1.61l0.82,-0.93l-0.27,-1.27l0.53,-0.52l1.08,-0.19l1.47,-1.85l-0.06,-0.74l-0.97,-1.51l0.64,-0.82l0.15,-1.04l-0.31,-0.17l1.0,-0.37l0.67,-0.76l-0.01,-1.07l-0.9,-0.31l-0.68,0.36l-1.96,-1.13l-1.51,0.72l-0.72,-0.04l-0.85,-0.8l-2.15,-0.36l-0.71,-2.28l-1.9,-0.65l-0.2,-0.49l-1.91,0.23l-0.14,-0.67l-1.38,-0.67l-0.91,0.22l-0.57,1.14l-0.63,-0.31l-1.42,0.58l0.34,-0.83l0.0,-1.35l-0.33,-0.43l0.33,-1.56l-0.26,-0.57l-0.62,-0.28l0.63,-0.53l0.03,-0.45l-0.98,-1.61l-0.67,0.01l-0.43,-0.54l-0.62,0.09l0.36,-0.72l-0.53,-0.89l-1.12,-0.14l0.75,-0.97l-0.19,-0.64l0.59,-0.26l0.68,-1.41l0.6,-0.06l0.59,-0.77l0.65,0.26l0.49,-0.3l-0.37,-2.07l1.31,-0.02l1.57,-0.67l1.41,-0.14l0.91,-0.6l0.73,-1.4l1.25,-0.6l1.81,-0.0l1.46,-0.75l0.13,-0.6l-0.84,-1.14l-0.03,-1.14l2.67,1.14l0.68,-0.07l2.97,0.8l0.76,-0.18l0.11,-1.02l0.78,-0.8l-0.7,-1.24l0.08,-0.7l0.97,-0.86l-0.01,-0.77l0.56,-0.64l-0.34,-0.71l0.12,-0.75l-2.19,-1.65l-2.96,1.32l-2.29,-0.8l-1.94,0.82l-0.59,0.92l-0.95,0.15l-0.32,0.34l-3.97,0.09l-0.83,0.56l-0.36,-0.63l-1.44,0.13l-0.1,-2.22l-0.54,-1.53l-1.98,-0.54l-0.93,0.23l-0.31,-0.36l-1.66,-0.45ZM602.61,307.96l0.0,-0.01l0.0,0.03l-0.0,-0.02ZM586.37,235.48l-0.04,-0.01l-0.05,-0.0l0.03,-0.05l0.06,0.06ZM617.61,258.42l-0.27,-0.23l0.55,-0.28l-0.25,0.29l-0.04,0.23ZM617.96,257.87l0.76,-0.57l0.49,0.11l-0.32,0.35l-0.93,0.11ZM623.65,260.91l0.25,-0.83l0.38,-0.18l0.04,0.35l-0.68,0.66ZM604.28,298.64l-0.02,-0.0l-0.07,-0.03l0.09,0.04ZM618.4,252.59l0.79,-0.67l0.41,-1.05l1.38,0.46l-0.2,0.85l0.7,-0.06l-0.22,0.99l-1.16,0.97l-0.82,-1.51l-0.89,0.03ZM616.13,251.87l0.3,-0.19l-0.04,0.38l-0.25,-0.19Z",name:"Khabarovskiy kray"},"RU-ORE":{path:"M164.34,274.94l2.96,-2.0l0.3,-1.01l-0.19,-0.75l0.77,-0.86l-0.28,-0.63l0.17,-0.56l0.9,-0.18l0.27,-1.39l1.41,-0.92l0.61,-0.86l0.05,-1.5l0.47,-0.1l0.28,-0.5l-0.2,-0.47l-0.64,-0.03l-0.23,-0.42l0.8,-0.97l0.82,-1.94l-0.05,-0.54l0.47,-0.62l-0.87,-1.53l1.83,-0.15l0.65,0.49l0.83,1.44l0.96,0.03l0.64,0.72l0.68,-0.28l0.76,1.81l1.12,0.61l1.29,1.8l2.22,0.45l0.07,0.52l0.7,0.38l1.24,0.02l1.17,2.7l0.72,0.2l-0.19,1.13l0.99,0.2l0.56,1.67l1.69,0.39l0.59,-0.33l0.33,-0.86l0.73,-0.65l0.84,0.38l0.47,1.11l-1.18,0.74l-0.15,0.58l0.6,0.64l1.49,-0.21l0.36,0.62l-0.27,1.4l0.59,0.41l0.15,1.12l0.34,0.31l0.86,-0.07l0.31,-0.51l0.83,0.69l0.55,0.05l2.33,-1.37l0.2,-0.45l0.95,-0.02l1.39,0.72l2.06,-0.21l0.47,-0.37l0.64,-1.83l-0.19,-1.29l0.96,-0.03l0.56,-0.6l1.05,0.48l0.51,-1.45l1.96,0.44l0.7,-0.47l0.49,0.44l0.89,-0.01l-0.04,0.53l-0.89,0.63l-0.35,0.77l0.81,1.94l1.91,0.45l-0.4,0.47l0.31,0.57l0.83,0.35l1.91,0.05l0.75,0.88l2.24,0.38l0.37,0.78l-0.86,2.97l-3.25,0.86l-2.09,-0.21l-0.84,-1.09l-0.84,-0.07l-0.52,0.33l-0.3,1.15l-0.64,0.75l-0.46,0.01l-0.84,-0.68l-2.91,-0.41l-1.43,-1.22l0.15,-0.5l-0.31,-0.69l-1.81,-0.79l-0.68,0.48l-2.04,-0.31l-0.51,0.66l0.01,0.83l-0.73,-0.06l-0.39,0.37l-1.33,-1.62l-1.78,0.28l-0.69,-0.18l-0.6,0.51l-0.43,-0.41l-0.5,0.01l-0.85,1.24l-0.94,0.04l-0.37,1.18l-1.89,1.17l-0.82,-0.76l-0.84,-0.05l-1.09,-0.85l-0.39,-0.72l-1.83,-0.94l-1.14,0.14l-0.23,0.95l-0.7,-0.23l-0.9,-1.35l-1.04,-0.67l-1.25,-0.21l-0.29,-1.11l-1.21,-0.75l-1.39,-0.23l-1.21,0.39l-0.92,-0.33l-1.06,0.3l-1.13,-2.13l-1.2,0.4l-0.33,0.4l-1.22,-0.05l-0.57,0.58l-0.08,0.8l-0.6,-0.51l-0.83,0.44l0.18,-0.55l-0.29,-0.51l-0.71,-0.38l-1.68,0.0l-0.23,-0.3ZM183.54,281.41l0.01,0.01l-0.01,0.02l-0.0,-0.03ZM183.49,281.74l0.23,1.25l-0.51,0.26l-0.23,-0.25l0.51,-1.26Z",name:"Orenburgskaya oblast"},"RU-KIR":{path:"M140.82,212.39l2.02,-0.13l0.74,-1.99l0.89,-0.59l-0.27,-0.93l0.53,-2.0l0.55,-0.6l2.63,0.24l0.6,0.2l0.38,0.81l2.09,0.32l0.53,1.72l-0.13,1.01l0.3,0.68l0.78,0.26l-1.38,1.18l0.35,4.02l2.86,0.53l-0.16,0.93l0.28,0.43l0.68,-0.06l1.64,0.74l-0.04,1.07l1.14,0.45l1.07,-0.51l0.18,-3.05l0.93,-0.18l0.19,-0.58l0.67,0.06l0.86,-0.67l2.32,-0.23l1.35,-1.5l0.94,0.25l0.53,0.62l0.92,-0.02l2.63,-2.84l2.04,0.89l4.75,0.27l0.52,-0.26l0.48,0.28l0.43,0.89l-0.23,1.27l-0.25,0.68l-0.95,0.32l-0.37,1.45l-0.82,1.31l0.88,1.7l2.09,0.71l-0.24,1.03l0.64,1.0l-0.76,1.27l0.31,0.98l-1.09,-0.09l-0.68,0.41l-0.62,-0.36l-0.35,-0.7l-0.54,-0.07l-1.03,0.18l-0.3,0.79l-3.37,-0.57l-1.14,0.21l-1.03,0.84l-0.82,1.79l0.72,0.68l-0.04,0.53l0.4,0.4l-0.22,0.79l0.44,0.59l-0.3,0.9l-1.35,1.03l-2.0,0.21l-0.57,1.36l0.67,2.11l0.57,0.97l0.78,0.38l-0.52,0.93l-1.01,0.25l-0.38,1.42l1.29,1.8l0.21,0.63l-0.32,0.24l-1.67,-0.82l-0.13,-0.91l-0.4,-0.45l-0.49,-0.13l-0.43,0.34l-0.47,-0.33l-0.33,-1.44l-1.03,-0.56l-0.97,0.17l0.12,-0.63l-0.31,-0.6l-1.54,-0.58l-0.36,-1.22l-2.36,0.14l-0.36,-0.68l0.2,-1.02l-0.65,-0.48l-1.04,0.49l-0.18,1.23l-0.8,-0.55l-1.2,0.01l-0.57,0.31l-0.83,-0.26l-0.72,0.44l-0.17,0.79l-1.14,0.02l-0.87,-0.45l-1.43,1.35l-1.09,0.32l-0.75,-0.72l-1.49,-0.01l0.08,-1.24l0.45,-0.51l-0.64,-0.96l0.4,-0.88l0.89,0.14l1.19,-0.54l1.0,0.28l0.69,-0.7l0.23,-1.61l0.75,-0.34l0.33,-0.61l-0.63,-0.79l-1.75,-0.5l-4.91,-0.0l-0.19,-0.22l0.35,-1.34l0.94,-1.13l-0.0,-0.7l1.9,-0.41l0.64,-1.1l0.67,0.06l0.44,-0.38l0.08,-0.78l1.25,0.04l0.35,-0.57l-0.31,-1.36l-1.63,-1.16l0.1,-0.77l-0.33,-0.45l-0.64,-0.11l0.35,-2.42l-0.32,-0.53l-0.79,-0.24l0.6,-2.08l-0.14,-0.48l-0.91,-0.17l-0.6,0.42l-0.98,0.01l-0.87,-0.32l-0.1,-0.42ZM147.16,231.26l-0.0,-0.0l0.0,-0.0l0.0,0.0ZM144.7,223.91l0.01,-0.02l-0.0,0.01l-0.0,0.01Z",name:"Kirovskaya oblast"},"RU-BA":{path:"M176.81,251.11l0.79,-0.42l1.02,0.03l0.73,-0.93l0.96,-0.39l0.67,-1.27l0.92,-0.64l0.18,-0.95l-1.32,-1.2l-1.02,-0.3l0.18,-0.32l0.99,-0.09l0.56,-0.93l1.29,-0.81l0.9,-1.75l1.51,0.85l0.4,0.59l2.53,-0.1l1.69,-0.76l0.62,0.04l0.95,1.05l1.22,-0.08l0.75,-0.55l0.48,0.71l1.96,1.34l1.68,-0.51l0.64,-0.91l0.34,1.06l0.73,0.36l1.44,-0.37l0.51,0.26l1.02,-0.13l1.32,0.55l0.95,-0.76l1.57,0.79l0.81,-0.15l0.49,-0.57l0.51,0.18l-0.36,0.3l0.17,0.87l-0.33,0.84l0.2,0.4l0.51,0.12l-0.24,1.21l0.51,0.37l0.82,-0.34l0.29,0.23l-1.68,0.29l-0.61,1.16l-1.05,-0.27l-1.61,1.21l-0.07,0.76l1.06,0.4l-0.55,0.3l-0.82,-0.74l-0.22,-0.64l-1.03,-0.05l-0.91,-0.89l-2.72,-0.44l-1.67,0.64l-0.78,1.51l0.45,1.08l-0.36,0.56l0.16,0.64l2.93,1.71l0.14,0.64l1.31,0.87l2.18,-1.1l1.38,0.54l1.17,-0.75l1.24,-0.39l0.93,0.09l2.2,-2.01l1.06,0.41l-0.4,1.02l-0.72,0.39l-0.33,0.59l0.31,0.56l-0.37,0.57l0.65,0.63l-0.3,0.33l-0.67,-0.27l-1.39,0.21l-0.86,1.4l-1.03,0.1l-0.3,0.49l-0.14,1.99l-0.41,0.57l0.27,0.57l-0.25,2.22l0.4,0.43l0.0,0.58l-0.77,1.27l0.16,1.07l-0.31,0.55l0.6,2.34l-0.68,0.13l-0.53,0.73l0.32,0.94l-0.45,1.69l-1.55,0.19l-1.31,-0.65l-1.63,-0.24l-0.56,0.84l-0.87,0.21l-0.29,0.6l-0.7,0.32l-0.91,-1.0l-1.5,-0.39l0.42,-0.45l-0.38,-0.54l0.09,-0.57l-0.51,-0.76l-0.93,-0.55l0.24,-0.57l-0.05,-0.73l-0.41,-0.44l0.37,-0.67l-0.28,-0.41l-0.95,0.26l-0.65,-0.58l-0.61,-0.04l-0.26,0.65l-0.65,0.47l-0.23,0.8l-1.15,-0.05l0.14,-1.15l-0.74,-0.63l-0.05,-1.22l-0.61,-0.39l-0.81,0.13l-1.23,-2.63l-0.73,-0.46l-0.84,0.24l-0.69,-0.85l-2.05,-0.36l-1.17,-1.69l-1.06,-0.57l-1.03,-2.17l-0.15,-1.44l-0.41,-0.69l0.38,-1.12l0.93,-1.16l0.18,-1.32l-0.34,-0.6l-0.52,0.05l-1.4,-1.19Z",name:"Bashkortostan, Respublika"},"RU-NGR":{path:"M53.19,227.85l2.35,-1.82l0.29,-0.55l-0.41,-0.81l0.14,-0.54l1.07,0.39l1.74,-0.32l0.46,-0.92l1.11,-0.99l0.15,-0.61l0.78,0.64l0.8,-0.01l1.41,-1.89l-0.03,-0.88l1.1,0.32l0.56,-0.55l1.12,0.26l0.63,1.13l1.57,0.19l0.56,0.42l0.75,-0.68l0.02,-0.7l0.95,-0.78l1.55,0.66l1.06,-0.42l2.5,1.72l1.55,-0.28l2.05,0.58l0.71,0.92l1.37,0.58l0.23,0.77l0.75,0.39l0.92,-0.6l1.41,0.21l0.39,0.49l1.56,0.35l0.26,0.66l-1.23,0.74l-1.56,-0.21l-1.22,0.21l-0.84,0.61l0.04,0.72l-0.74,0.3l-1.67,-0.2l-0.58,0.45l0.01,0.57l-3.19,-0.9l-0.83,0.57l-1.15,-0.01l-0.84,0.84l-0.03,0.43l0.73,0.41l0.06,0.41l-0.56,0.3l-0.18,0.98l-1.17,0.59l-0.48,1.24l-2.06,0.05l-0.97,1.06l-1.11,0.52l-0.74,-0.22l-0.24,0.65l-1.43,0.63l-1.18,0.01l-0.64,1.02l-0.69,0.22l-0.61,-0.24l-0.98,0.23l-2.16,-0.15l0.12,-1.12l0.55,-0.66l-0.27,-0.45l-1.26,-0.42l0.02,-0.75l0.6,-0.98l-0.54,-0.74l0.18,-1.62l-2.85,-0.68l-0.08,-0.64l-1.48,-0.51l-0.15,-0.6Z",name:"Novgorodskaya oblast"},"RU-KLU":{path:"M73.54,258.55l0.75,-1.59l-0.28,-0.56l0.32,-0.87l1.77,0.08l1.02,0.82l0.68,0.0l0.76,-1.76l1.58,-0.35l0.6,-0.53l-0.19,-0.65l1.23,-0.64l1.19,-1.87l0.5,0.04l0.66,-0.44l2.62,0.74l1.15,-0.33l0.46,-0.63l1.39,0.37l0.26,0.51l0.75,-0.04l0.38,0.33l0.98,2.09l-0.47,1.4l-1.22,-0.35l-0.51,0.32l0.25,1.31l0.5,0.33l-0.09,0.4l-2.11,0.02l-0.48,0.47l-0.7,-0.08l-0.37,0.39l-1.01,0.09l-0.11,0.4l0.55,0.84l-1.14,1.42l0.34,1.17l-0.85,0.79l-0.65,-0.12l-1.12,0.82l-0.41,0.82l-0.74,0.14l-0.47,-0.12l-0.25,-0.55l-2.3,-0.26l-0.24,-1.48l-1.63,-1.77l-1.83,-0.08l-0.42,-0.6l-1.09,-0.41Z",name:"Kaluzhskaya oblast"},"RU-OMS":{path:"M267.17,230.51l2.25,-4.71l1.4,0.84l-0.21,1.8l0.54,0.93l3.8,-0.35l0.81,0.72l3.85,0.14l1.27,-1.03l6.03,0.02l2.14,-1.23l2.35,-2.03l0.53,0.37l-1.04,0.74l0.01,0.5l0.61,0.65l-0.57,0.55l0.05,0.52l2.43,1.37l0.14,1.99l0.78,0.54l0.66,1.44l0.75,0.2l0.35,0.52l1.06,4.03l-2.03,1.53l-0.22,0.65l0.47,0.46l0.75,-0.11l0.26,0.87l0.6,0.47l-2.34,0.29l-2.43,1.9l-0.07,0.95l-0.87,-0.12l-0.36,0.38l0.44,0.84l-0.18,0.54l0.54,0.48l-0.77,0.97l0.9,1.12l-0.06,0.79l0.67,0.73l-0.23,0.88l1.77,1.04l0.18,0.66l0.6,0.42l-0.75,0.55l0.03,2.75l-1.54,0.33l0.01,0.75l-1.65,0.99l-1.35,-0.14l-0.97,1.05l-0.88,0.1l-0.22,1.35l-0.57,-0.81l-1.81,-0.34l-1.48,0.25l-0.91,1.01l-0.67,-0.62l0.42,-0.98l0.32,-0.1l0.08,-0.45l1.24,0.0l0.32,-0.51l0.23,-1.13l-0.67,-0.6l-0.64,0.07l-0.59,0.69l-0.67,0.18l-1.14,-0.21l-0.66,-1.01l-2.4,-0.02l-0.64,-0.28l-0.08,-0.5l-0.82,-0.86l-0.96,-0.25l-0.54,0.49l0.28,0.58l-1.5,-0.07l-0.42,0.93l-1.6,-0.65l-0.77,0.62l-0.28,-0.62l0.37,-0.05l0.36,-0.67l-0.28,-1.47l0.51,-0.26l0.1,-0.64l-0.46,-0.62l-0.91,-0.27l-0.25,-0.69l0.11,-1.46l-0.92,-1.12l-0.11,-0.67l-0.71,-0.17l-0.72,0.24l-0.16,-0.5l1.05,-0.5l0.39,-0.76l-0.28,-0.67l-0.76,-0.28l1.05,-0.72l0.58,-1.2l0.29,-1.23l-0.41,-0.5l-0.03,-0.65l0.55,-0.4l-0.1,-0.8l0.66,-0.49l0.35,-0.82l0.97,0.04l1.23,-0.53l0.76,-1.35l-0.36,-0.88l-1.32,-0.87l-1.57,-2.16l-1.81,0.13l-0.48,0.5l-0.73,-0.24l-0.18,-0.34l1.17,-0.75l0.14,-0.71l-0.59,-0.53l-0.86,-1.74Z",name:"Omskaya oblast"},"RU-SAR":{path:"M120.55,275.71l0.77,-0.78l0.27,-1.15l0.6,-0.58l-0.27,-0.89l0.91,-1.1l1.1,-0.64l0.66,0.45l2.19,-0.27l3.03,0.81l0.74,-0.77l0.6,-0.09l0.14,-0.4l1.05,0.28l1.23,0.95l0.66,-0.63l1.56,0.02l0.94,-0.7l1.66,0.69l2.05,-1.89l1.02,-0.16l0.77,0.49l1.23,-0.04l0.72,0.47l1.96,0.0l0.74,-0.33l0.77,0.24l0.7,-0.81l1.05,0.08l0.51,-0.76l0.57,-0.11l0.3,0.02l-0.14,0.83l1.85,0.33l0.18,0.44l0.53,0.18l0.21,0.72l0.61,0.23l0.37,-0.48l1.32,-0.07l0.14,0.71l1.0,0.47l0.47,-0.1l0.21,0.46l1.08,0.61l1.52,0.27l0.11,0.83l2.67,0.54l0.3,1.61l-0.53,-0.14l-0.41,0.34l-0.28,0.99l-0.77,0.32l-0.22,0.76l-1.61,0.44l-1.08,0.86l-1.94,0.05l-0.56,1.19l0.31,0.71l-1.24,0.35l-1.55,1.22l-1.45,-0.26l-0.16,0.57l0.55,0.4l0.55,3.03l0.52,0.51l-2.06,1.07l-0.66,-0.31l-1.31,-2.08l-2.1,-1.89l-1.72,0.49l-0.44,-0.91l-1.33,0.14l-0.54,-1.02l-1.37,-0.45l-0.49,0.11l-0.66,0.87l-1.32,0.19l-0.26,-0.95l-1.45,-0.75l-0.98,0.37l-0.17,0.91l-1.43,-0.01l0.32,-1.59l-0.74,-1.48l-0.99,-0.65l-2.51,-0.24l-0.6,-0.35l-1.23,0.13l-0.76,0.58l-0.59,-0.45l-3.22,1.09l-2.0,-1.27l-0.32,-1.14l-1.76,-1.38l-0.09,-0.36Z",name:"Saratovskaya oblast"},"RU-ORL":{path:"M80.46,267.23l1.25,-0.24l1.11,-0.92l-0.09,-0.57l-0.87,-0.43l-0.03,-0.29l0.93,-0.1l1.2,-1.56l1.13,-0.18l0.7,-0.72l0.75,0.51l0.64,-0.06l0.74,0.89l1.41,0.23l0.84,0.77l2.24,0.35l0.82,-0.41l0.62,0.23l0.38,1.02l0.75,0.06l0.33,0.45l-0.23,1.13l0.24,0.42l-0.58,1.46l0.43,0.81l1.13,0.93l-1.16,0.92l-0.31,1.2l-1.01,-0.24l-0.48,0.49l-1.16,-0.96l-1.57,-0.26l-1.47,-0.69l-1.2,-1.12l-3.36,0.64l-0.48,-0.95l-0.47,-0.14l-2.68,0.74l-0.55,-0.21l0.67,-0.42l0.53,-1.32l-0.31,-0.85l-0.83,-0.65Z",name:"Orlovskaya oblast"},"RU-STA":{path:"M111.92,316.9l0.03,-0.44l1.33,0.03l0.86,-0.65l-0.09,-1.03l0.73,-0.29l3.45,0.42l0.49,-0.34l0.15,-0.69l0.18,0.67l1.3,-0.04l2.06,-1.44l2.33,1.24l2.5,0.44l1.74,2.2l1.24,0.58l1.56,0.17l4.35,2.16l0.5,0.72l-0.43,0.53l0.04,0.71l-0.8,0.82l-1.12,0.52l-0.1,1.15l0.93,0.35l-1.18,0.24l-0.49,0.6l0.29,0.59l1.82,0.09l-0.32,1.23l-0.49,-0.0l-0.36,-0.44l-0.87,0.02l-0.67,1.81l-0.52,-0.88l-2.28,-0.02l0.56,-0.53l-0.03,-0.49l-0.37,-0.24l-1.02,0.47l-1.83,-0.42l-0.93,0.97l-1.26,-0.19l-0.59,0.24l-0.78,-0.77l-2.41,0.84l-0.51,-1.29l-0.58,-0.12l-0.63,0.33l-0.14,-0.24l1.3,-0.95l-0.33,-0.74l-0.87,0.07l-1.78,-0.54l-0.61,-0.78l-0.89,0.08l-1.29,-0.85l0.97,-1.34l-0.0,-0.85l-1.1,-0.29l-0.9,-1.59l-1.24,0.06l-0.18,-0.9l-0.77,-0.95Z",name:"Stavropolskiy kray"},"RU-SE":{path:"M126.06,334.13l1.26,-1.97l1.19,0.2l0.38,-0.8l0.81,-0.38l0.64,-0.07l0.38,0.28l0.15,0.89l0.68,0.09l0.99,0.88l-0.22,0.82l-0.9,-0.27l-0.49,0.82l-1.44,0.32l-1.75,0.88l-0.49,-0.15l0.21,-0.55l-0.28,-0.43l-1.13,-0.57ZM130.75,329.28l-0.48,-0.52l1.74,-0.1l0.02,0.43l-1.28,0.18Z",name:"Severnaya Osetiya-Alaniya, Respublika"},"RU-SAM":{path:"M149.37,263.67l0.2,-0.38l0.73,0.36l0.94,-0.34l0.48,-1.31l0.66,-0.07l0.23,-0.48l1.08,0.14l0.9,-1.0l1.89,-0.09l1.11,0.39l0.91,-0.31l1.52,0.13l0.26,-0.52l-0.28,-0.51l1.11,-0.88l0.22,-1.8l-0.27,-0.66l0.42,-0.12l0.67,0.94l1.09,-0.66l1.31,0.6l0.31,-0.19l0.39,-1.32l0.72,-0.71l3.4,0.8l0.2,0.68l1.86,1.26l-0.38,0.39l0.13,0.53l0.85,0.17l-1.0,2.72l-0.93,1.13l0.54,1.22l-0.66,1.5l0.02,0.8l-1.61,0.85l-0.21,0.52l0.19,0.91l-0.84,-0.15l-0.59,1.01l0.16,0.9l-0.5,0.74l0.05,1.6l-2.86,1.89l-0.11,-0.72l-1.89,-0.62l-0.92,-0.92l-1.1,-0.5l-0.96,0.05l-1.27,-1.43l-0.71,0.07l-1.18,-0.86l-1.74,0.19l-0.95,-1.08l-1.29,-0.38l0.81,-0.71l0.03,-0.78l-0.44,-0.49l-0.74,-0.07l-0.18,-0.6l-0.65,-0.01l-1.14,-1.82ZM171.38,256.43l0.06,-0.09l0.24,0.07l-0.13,-0.01l-0.17,0.03Z",name:"Samarskaya oblast"},"RU-SA":{path:"M452.06,155.96l1.57,-0.31l0.56,-0.95l0.83,-0.14l1.3,-0.84l1.02,0.3l0.9,-1.22l0.48,-6.86l-0.03,-6.91l-3.82,-4.92l1.21,-1.18l0.56,0.46l1.39,0.01l1.64,-0.67l4.25,-0.89l0.65,-0.45l0.13,-0.54l0.99,-0.6l2.84,0.16l0.98,0.61l1.24,-0.03l0.88,-0.78l0.82,-1.95l-0.3,-0.52l-0.56,-0.13l-0.38,-0.85l1.26,-0.44l0.41,-1.02l3.4,-0.51l0.16,-0.61l-0.79,-0.47l-0.02,-0.99l1.76,-0.67l0.18,-0.71l1.6,-0.0l1.17,-0.45l1.46,-0.1l0.95,-0.78l2.44,-0.5l0.42,-0.63l0.45,0.51l0.56,-0.03l1.71,-0.97l0.07,-0.78l0.76,-0.53l0.06,-0.54l-0.56,-0.59l-0.79,0.07l-2.36,-1.16l-0.0,-6.81l-0.4,-0.4l-0.96,-0.02l-1.13,-1.73l-2.17,-0.45l0.93,-0.71l-0.13,-0.74l-1.85,-0.72l-0.3,-0.52l-0.97,-0.18l-0.24,-0.87l0.37,-0.38l-0.18,-0.6l0.94,-0.61l-0.21,-0.48l0.48,-0.26l0.09,-0.5l-0.82,-1.45l-1.11,-0.18l0.32,-0.67l-0.8,-0.8l0.75,-0.38l1.11,-1.28l0.85,-0.02l0.66,-0.43l0.16,-0.78l-1.18,-0.95l0.4,-0.32l1.32,-0.46l2.6,1.17l3.05,0.4l2.42,-0.43l0.68,-0.39l0.36,-0.46l-0.09,-0.87l1.75,2.33l0.05,0.33l-0.61,0.18l-0.89,1.27l0.09,0.53l0.68,0.69l1.08,0.34l0.13,2.12l-0.29,1.32l-1.64,0.8l-0.25,0.8l0.49,1.12l0.58,0.5l4.44,0.91l0.42,-0.24l-0.37,-0.67l-3.51,-0.66l-0.94,-1.04l1.93,-1.35l-0.03,-0.75l0.39,-0.72l-0.32,-1.2l0.69,-0.56l1.74,-0.36l-0.03,-0.68l-1.33,-0.07l-1.24,-0.88l1.79,-0.21l1.09,-0.64l3.83,-0.1l2.93,-1.03l6.17,0.36l4.45,0.87l5.26,-0.0l1.71,0.32l0.54,0.27l-0.98,0.05l-0.4,-0.36l-0.63,-0.01l-1.02,0.82l-0.07,1.52l0.36,0.87l2.85,1.25l3.13,0.61l1.16,1.02l4.26,0.85l0.51,-0.21l0.01,-0.65l-0.56,-0.23l2.79,0.52l1.86,-0.44l2.16,0.01l1.02,0.78l2.06,0.21l1.17,0.48l0.57,0.01l0.4,-0.31l-0.11,-0.23l0.62,0.04l0.66,-0.58l1.2,-0.01l0.79,-0.69l0.08,-0.75l0.57,-0.19l0.0,-0.67l0.78,-0.08l0.31,-0.35l-0.17,-0.76l-0.69,-0.16l-0.02,-0.32l-0.77,-0.52l0.31,-1.22l-0.63,-0.67l0.7,-0.64l-0.19,-0.39l0.17,-0.14l0.6,0.76l1.93,-0.2l1.76,-1.48l0.7,-0.11l1.29,0.72l0.5,-0.02l1.09,0.88l0.6,-0.35l0.21,1.04l1.79,0.19l-0.22,0.58l0.64,0.76l0.9,-0.59l1.21,0.37l0.58,-0.59l0.02,0.82l0.41,0.28l1.16,-0.25l0.47,0.35l0.11,1.16l0.71,0.04l0.52,-0.75l-0.03,-0.86l0.6,0.26l0.81,-0.58l0.02,-1.03l4.4,0.67l0.51,0.49l-0.17,0.21l0.37,0.63l1.32,-0.03l-0.29,0.61l0.39,0.25l0.94,0.28l1.01,-0.28l1.08,0.45l-0.58,1.0l0.22,0.47l1.66,-0.53l1.7,0.86l-0.11,0.2l-2.33,-0.39l-3.37,0.72l-0.55,0.41l-0.6,1.33l0.41,0.27l1.47,-0.03l-0.23,0.36l-2.81,0.28l0.67,0.97l3.25,1.41l3.12,0.13l0.28,0.56l0.65,0.22l-0.5,0.6l0.47,0.7l-0.77,0.49l0.02,0.4l-1.34,0.17l-0.51,-0.56l-1.3,-0.51l-0.17,-0.68l-2.05,-0.61l-1.96,-1.23l-1.14,0.37l0.67,0.84l-0.15,0.56l2.5,1.09l1.11,1.11l0.02,0.61l0.98,0.79l0.26,0.99l1.12,0.97l-0.44,0.61l0.35,0.93l0.52,0.22l1.05,-0.21l1.31,2.64l1.44,0.93l0.13,0.57l-0.47,0.27l-0.07,0.47l0.43,0.21l1.1,-0.2l0.43,0.4l0.61,-0.18l0.47,1.09l1.47,0.4l0.44,0.48l0.81,0.11l0.59,-0.42l0.26,1.19l1.17,0.47l1.18,-0.17l1.75,-1.36l1.26,-2.37l0.52,-0.3l0.01,-0.46l1.66,-0.12l-0.23,-0.62l-0.96,-0.27l1.57,-3.59l1.96,-2.32l-0.36,0.92l0.15,0.55l1.41,0.6l0.95,1.38l2.66,1.41l1.44,0.38l1.45,0.28l2.19,-0.32l0.23,0.12l-0.19,0.95l0.41,0.29l0.85,-1.19l0.13,-1.0l1.88,-0.58l1.08,0.19l0.33,-0.65l0.81,-0.25l1.76,-0.11l2.35,0.56l0.67,0.97l1.02,-0.48l0.73,0.65l1.68,0.52l0.06,0.34l0.78,0.1l-0.01,0.66l0.54,0.24l0.17,0.47l1.66,0.94l1.43,-0.14l0.32,-0.52l-0.21,-0.4l1.75,-1.26l-0.59,-0.58l-1.71,-0.12l0.68,-1.47l1.04,-0.19l0.64,0.64l0.73,-0.13l0.71,-0.9l1.34,0.59l0.68,1.52l0.43,0.13l1.05,-0.15l0.4,-0.63l1.17,0.34l0.83,-0.3l1.03,0.18l0.28,-0.73l-1.16,-1.17l-0.45,-0.97l-0.07,-0.59l0.54,-0.63l-0.19,-0.44l-0.71,-0.35l0.34,-0.45l0.02,-0.81l0.68,-0.72l0.8,0.26l0.82,-0.21l0.32,-0.33l-0.07,-0.66l-0.63,-0.35l-3.07,-0.07l-0.93,0.68l-0.84,0.0l-0.27,-0.34l0.85,-1.25l1.17,-0.92l5.36,0.02l2.94,-0.93l0.24,-0.45l-0.7,-0.33l0.02,-1.02l-1.79,-1.27l2.84,0.31l1.48,0.92l3.57,0.72l6.63,0.02l10.03,1.42l5.27,1.31l-5.34,-0.05l-0.91,-0.67l-1.44,-0.21l-1.39,0.69l-0.9,1.18l-0.99,-0.47l-1.43,0.42l0.6,0.98l1.66,0.64l3.24,-0.92l2.59,-0.13l0.42,0.52l-0.58,1.06l0.36,0.68l0.58,0.14l0.06,0.41l-2.06,0.35l-1.77,-0.98l-0.57,0.22l0.01,0.94l0.87,0.6l-1.13,0.27l0.02,1.64l0.65,-0.2l0.16,0.25l1.75,0.14l1.29,-0.76l0.88,0.07l1.7,-0.6l1.72,-1.17l1.42,-1.7l2.82,-2.41l6.18,0.19l6.24,1.57l2.12,1.9l-0.02,0.33l-1.54,0.69l-1.15,-1.07l-0.63,-0.2l-1.25,1.3l-1.36,-0.42l-0.48,0.46l0.56,0.67l-0.47,0.32l0.25,0.69l1.03,0.07l0.53,-0.3l4.1,0.39l-0.54,1.29l0.14,0.54l1.63,-0.44l2.42,-0.01l-0.69,0.91l-2.56,1.24l0.15,0.74l0.64,0.04l2.17,-1.06l0.43,0.42l1.29,-0.89l0.86,-0.2l2.3,0.56l2.95,2.58l-1.94,-0.07l-0.19,0.81l4.43,1.33l0.24,0.54l0.65,-0.39l1.9,-0.0l1.93,-0.45l1.65,0.19l3.08,-1.0l6.06,-0.87l0.37,0.73l0.58,-0.22l0.28,-0.66l1.5,-0.24l10.68,0.49l6.46,2.06l3.04,2.25l1.25,2.43l-0.65,1.21l-1.0,-0.14l-0.49,0.55l0.87,0.58l-0.02,0.46l-0.84,0.95l0.5,1.69l0.82,-0.1l1.54,0.79l0.39,-0.15l0.64,0.56l0.81,-0.25l1.97,0.45l-0.18,1.4l0.58,2.37l-0.36,0.61l0.15,0.5l2.17,0.88l-1.0,1.59l-0.04,0.81l-0.49,0.74l-0.25,0.26l-1.21,-0.05l-0.4,0.58l0.29,0.41l1.8,0.02l1.64,-1.58l-0.08,-0.89l1.38,-1.37l-0.09,-1.14l-0.72,-1.76l0.28,-1.27l1.55,-1.13l1.13,-0.21l0.99,-0.86l0.24,1.83l1.95,1.92l-1.18,0.68l0.12,1.31l1.4,1.17l-1.05,0.33l0.04,1.18l0.56,0.76l-0.65,0.71l-0.03,0.66l-0.65,0.95l-5.22,-0.91l-2.22,1.01l-5.92,0.21l-0.58,0.41l-1.05,-0.06l-3.26,0.86l-1.59,0.03l-2.22,0.85l-0.32,0.99l-0.71,0.4l-0.1,0.69l0.32,0.51l0.95,0.27l-1.55,-0.05l-0.78,0.31l-0.58,0.72l-0.26,1.09l0.5,0.94l0.39,0.16l-0.4,0.72l0.53,0.9l2.65,1.43l1.79,0.53l0.7,1.46l0.13,0.42l-0.83,0.42l-0.46,1.05l-1.48,1.56l0.73,0.96l-0.56,0.77l0.21,0.88l-1.21,-0.34l-2.28,0.4l-1.91,1.06l-0.19,0.56l-0.86,0.06l-0.55,-0.19l-0.02,-0.74l-1.1,-0.62l-0.84,-0.93l-0.58,0.13l-1.05,1.01l-1.78,-0.21l-1.09,-0.71l-2.25,0.22l-1.09,-0.5l-1.3,0.62l-1.9,-0.87l-0.96,0.33l-1.12,1.38l-0.04,0.33l0.76,0.39l0.08,0.58l-0.47,0.59l-0.39,0.14l-0.84,-0.65l-1.42,-0.0l-1.52,0.68l-0.23,0.57l0.27,1.41l-0.55,1.03l0.48,0.88l-1.72,0.7l-2.38,0.45l-0.54,0.95l0.26,0.9l-0.83,1.01l0.34,1.21l0.89,0.79l-1.98,1.25l0.14,1.01l-0.55,0.2l-0.26,-0.93l-0.77,-0.3l-2.96,0.62l-0.43,0.67l-1.04,-0.21l-1.11,0.37l-1.77,0.02l-0.3,0.29l-0.1,1.02l-1.56,-0.33l-0.74,-0.9l0.35,-0.71l-0.13,-0.59l-1.61,-0.78l-0.86,0.09l-1.43,0.98l-0.69,-0.08l-0.38,0.29l-0.53,-0.23l-2.45,0.17l-0.76,-0.79l-0.92,-0.35l-1.89,1.37l0.07,1.0l1.12,0.74l-1.18,1.93l-1.34,-0.47l0.22,-0.61l-0.5,-0.68l-1.93,0.33l-0.33,0.48l-1.04,-0.64l-3.42,-0.47l-0.58,1.25l-0.94,0.99l-3.08,1.17l0.41,1.25l-0.95,1.22l-1.08,2.92l0.1,1.45l0.48,0.96l-0.19,1.23l0.61,1.59l-0.65,-0.14l-0.88,0.41l-0.09,1.97l-0.49,-0.06l-0.25,0.68l-1.14,0.47l-0.91,1.15l-0.35,1.01l-1.44,0.76l-0.94,0.09l0.12,-1.43l-0.25,-0.54l-0.51,-0.09l-1.03,0.54l-0.2,-0.8l-1.47,-0.07l-0.73,-0.71l-0.86,0.25l-0.77,1.34l-1.3,-0.38l-1.06,0.48l-1.42,-1.43l-0.66,-0.04l-0.46,0.49l-0.48,-0.47l-0.93,-0.17l-0.59,-0.42l-0.11,-0.61l-0.6,-0.38l-0.66,-1.15l-1.12,-0.03l-0.21,-0.4l-1.26,-0.56l-1.07,-0.12l-0.39,0.48l0.02,0.66l-1.0,-0.02l-0.56,0.46l-0.52,2.74l-1.32,0.57l-0.24,1.2l-1.43,1.4l-0.58,1.27l-2.3,0.27l-0.77,0.94l-1.17,-0.08l-0.6,0.69l0.01,0.71l-1.64,0.42l-0.27,0.41l0.2,0.65l-0.56,0.29l-0.2,0.91l0.59,1.17l0.69,0.42l-0.94,1.24l0.41,0.97l-0.66,1.15l0.27,2.29l-0.41,0.84l0.15,0.9l-0.69,-0.89l-0.49,0.39l-1.71,0.11l-0.96,0.85l-0.12,0.56l-1.11,0.82l-1.17,0.17l-1.04,0.55l-2.2,-0.61l-1.14,0.05l-1.16,-0.76l-0.77,-0.02l-1.96,1.22l-1.13,1.98l-1.55,-0.13l-0.55,-0.58l-1.39,0.4l-2.23,-0.76l-2.0,0.2l-0.64,-0.51l-2.5,0.74l-0.9,0.78l-0.6,0.02l-0.29,1.64l-0.76,-0.06l-0.74,1.03l0.05,1.15l-0.85,0.89l-1.19,0.13l0.27,1.71l-0.87,0.59l-0.12,0.67l-1.15,-0.66l-1.67,0.27l-0.01,0.51l0.74,0.73l0.05,0.49l0.77,0.6l0.0,0.55l1.33,0.99l-1.59,0.59l-1.1,2.25l-1.02,-0.39l-1.09,0.73l0.48,1.23l1.23,0.32l1.83,2.26l-0.54,0.52l-0.07,0.76l-0.57,-0.16l-0.69,0.48l-0.76,-0.02l-0.8,0.78l-0.18,1.53l-0.65,0.53l-0.58,1.84l0.33,1.23l-0.83,-0.26l-3.49,0.26l-0.64,-0.33l-2.29,0.05l-2.55,0.67l-0.16,0.43l0.3,0.65l-0.27,0.17l-2.26,-0.36l-1.43,-1.07l-2.11,0.25l-0.78,-0.43l-0.62,0.21l-0.54,0.66l-0.72,-0.7l-0.89,-0.22l-1.41,0.06l-0.41,0.56l-1.26,-0.34l-0.88,0.68l-1.17,-0.22l-0.58,-0.91l-1.35,-0.61l-1.47,0.35l-0.5,-0.68l-1.0,-0.28l-1.65,0.37l-1.42,-0.57l-0.78,0.24l-0.55,-1.16l-0.6,-0.26l-1.95,-2.29l-3.38,-0.38l-2.11,-1.27l-0.69,0.15l-0.27,0.56l-0.41,0.1l-0.62,-0.74l-1.74,-1.12l-2.64,-0.11l-0.67,-1.23l-0.7,-0.46l-1.72,-0.13l-0.52,-0.33l-1.76,0.03l-2.02,0.23l-1.99,0.82l-0.46,-0.62l-0.64,-0.13l0.31,-1.13l-1.38,-1.8l0.42,-0.97l-0.11,-0.45l-0.68,-0.33l-0.96,0.21l-0.11,-0.65l-0.39,-0.28l0.48,-2.05l-0.43,-2.42l0.3,-0.96l-0.25,-0.44l-1.35,-0.64l0.35,-1.47l-0.46,-0.71l0.23,-0.88l-0.73,-0.48l-0.12,-0.82l0.82,-0.96l-0.46,-0.44l-0.11,-0.64l-1.93,-0.9l-0.74,-0.78l-1.46,0.23l-0.77,1.06l-0.45,-0.72l-1.12,0.46l-1.55,-0.39l-0.21,-0.26l0.32,-1.67l-0.61,-0.63l0.9,-0.42l-0.01,-0.72l-1.25,-0.26l-0.47,-0.86l-2.09,-1.65l-2.74,-0.43l-1.99,-0.93l-2.72,0.63l-2.08,1.96l-0.93,-0.04l-0.85,0.95l-0.05,0.94l-1.13,0.77l-0.64,0.9l-1.69,0.56l-0.38,0.56l-0.95,0.34l-0.2,0.79l-0.84,0.76l0.12,0.97l-0.78,0.63l-1.64,0.01l-1.47,0.81l-0.59,-0.08l0.95,-1.11l-0.01,-0.53l-0.42,-0.35l-1.3,0.0l0.11,-0.62l-0.52,-0.79l-0.39,-0.04l-1.72,1.75l-0.81,0.04l-0.61,0.47l-0.83,-0.44l-1.04,0.13l-0.51,0.39l-0.38,-0.27l-2.2,-0.16l-0.9,0.71l-0.29,1.02l-0.73,0.04l-0.38,0.35l-2.12,-0.08l-1.2,-1.36l-0.3,-0.84l-1.04,-0.18l0.34,-0.44l-0.19,-0.43l1.05,-1.14l-0.09,-1.01l0.71,-0.71l0.67,-1.38l-0.33,-0.91l0.14,-0.56l1.12,-1.44l-0.0,-0.61l0.86,-0.8l0.1,-0.56l0.7,-0.33l-0.04,-1.2l1.0,-1.05l0.43,-1.09l-0.38,-0.92l-0.67,-0.22l-0.89,0.23l-0.56,-0.9l-1.21,-0.28l0.29,-1.62l-1.27,-1.52l-0.14,-0.94l2.04,-2.24l0.06,-1.32l-0.71,-1.31l-2.28,-0.13l-0.75,-0.44l0.46,-0.29l0.5,-1.31l0.95,-0.79l-0.28,-0.72l-0.67,-0.36l-0.07,-2.27l-0.51,-1.25l-0.54,-0.23l-1.33,-1.58l-1.08,0.08l-1.55,-0.5l-1.44,0.18l0.29,-1.18l1.67,0.2l0.89,-0.96l-0.21,-1.2l-0.89,-0.74l-0.19,-1.46l-0.43,-0.48l-0.92,-0.23l-0.39,0.42l-0.82,-0.06l-1.2,0.64l-1.37,-0.95l-1.44,0.38l-0.53,-0.67l-2.42,-0.72l-0.76,-0.81l-0.57,0.09l-0.2,0.47l-1.43,0.22l-0.66,-0.73l-1.13,0.11l-0.33,-0.48l0.7,-0.45l-0.17,-1.05l1.93,-0.53l-0.02,-0.51l-1.05,-1.04l1.8,-1.31l0.69,-0.05l-0.27,-0.9l0.74,-0.56l1.22,0.05l0.83,-1.36l-0.28,-0.47l-1.01,-0.29l-0.57,-0.75l-0.84,-0.24l0.03,-3.07l-0.69,-1.16l-1.04,-0.17l-0.09,-1.36l1.15,-0.93l-0.75,-3.1l-0.56,-0.29l-0.33,-0.76l-2.01,-0.42ZM651.49,198.62l0.0,0.04l-0.04,0.02l-0.0,-0.0l0.04,-0.06ZM667.6,106.69l-1.57,1.66l-1.99,1.38l0.05,-0.39l1.55,-0.91l0.15,-0.64l-0.95,-0.6l-1.23,0.31l-0.3,-0.63l4.28,-0.19ZM576.72,106.25l0.0,0.03l-0.02,-0.02l0.02,-0.01ZM541.87,99.83l-0.15,-0.05l0.14,0.02l0.01,0.03ZM545.78,96.69l-0.02,-0.04l0.03,0.03l-0.01,0.01ZM559.14,94.73l-0.0,-0.14l0.21,-0.05l-0.17,0.08l-0.04,0.1ZM559.5,94.48l0.54,-0.29l0.24,0.21l-0.61,-0.0l-0.16,0.08ZM746.56,132.23l0.14,-0.06l0.02,0.14l-0.11,0.01l-0.05,-0.08ZM745.08,133.49l-0.09,-0.92l0.23,-0.24l0.08,0.94l-0.23,0.22ZM743.53,135.67l0.18,-1.0l-0.5,-0.85l0.86,-0.59l-0.49,0.68l0.34,0.61l-0.16,1.23l0.33,1.1l-0.5,-0.15l-0.06,-1.03ZM740.48,120.24l0.09,0.3l-0.17,0.03l0.05,-0.09l0.03,-0.24ZM698.77,66.74l0.57,-0.15l0.1,0.26l-0.18,0.11l-0.49,-0.22ZM664.61,76.45l0.43,-1.26l0.43,-0.28l-0.03,-0.44l0.58,-0.21l0.02,-1.27l0.82,0.34l0.19,0.3l-0.39,0.91l1.13,0.89l2.87,0.18l0.92,-0.97l4.64,0.21l0.41,0.21l-0.44,0.45l0.01,0.61l1.08,0.89l1.65,-0.06l1.21,-0.48l5.1,0.44l-0.03,0.56l1.74,0.41l0.39,0.41l1.31,-0.75l-0.9,1.09l-0.03,1.0l-4.19,0.91l-0.49,0.4l-2.56,0.08l-5.28,-0.46l-2.69,-1.57l-2.94,-0.52l-2.31,-1.29l-2.65,-0.74ZM678.15,61.05l0.69,-0.36l1.58,-0.21l-0.11,0.59l-2.15,-0.02ZM616.32,75.24l0.74,0.49l0.69,0.03l0.83,-0.2l0.44,-0.47l-0.14,-0.78l-0.71,-0.28l0.17,-0.28l-0.56,-0.69l0.49,-0.29l-0.89,-1.58l0.69,-0.27l2.16,0.5l0.47,-0.45l-0.23,-0.63l-1.46,-1.27l1.22,-0.54l1.68,-0.22l0.71,-0.98l0.51,-0.17l0.38,0.69l0.57,0.1l0.56,-1.32l1.62,-0.34l1.06,1.31l3.58,1.29l-0.18,0.76l0.96,0.71l1.11,0.43l0.78,-0.28l0.97,0.31l-0.52,1.09l0.55,0.62l2.35,0.26l0.94,-0.3l0.11,-0.77l-0.78,-0.79l0.15,-2.48l0.25,-0.31l0.98,-0.06l2.23,0.45l0.25,-0.56l-0.8,-0.77l2.98,1.31l2.14,1.61l2.89,0.64l1.62,-0.01l0.36,-0.47l1.17,-0.13l5.33,1.77l0.61,0.57l2.25,0.56l-2.91,1.06l-0.39,1.07l0.53,0.75l-0.34,1.02l-1.52,1.04l-1.81,0.25l-1.27,-0.58l-1.83,0.14l-2.4,-0.71l-0.4,-0.91l-0.54,-0.11l-0.35,-0.78l-0.65,-0.37l0.14,-0.75l0.51,-0.48l1.97,-0.94l0.22,-0.65l-0.24,-0.84l-0.76,-0.43l-3.31,0.02l-0.42,0.59l-1.17,0.02l-0.32,0.73l0.52,0.63l-0.13,0.57l0.5,0.64l0.17,1.39l1.14,0.93l0.06,0.53l0.81,0.57l0.42,0.79l5.3,1.07l-3.12,0.42l-1.67,-0.12l-0.96,0.79l-1.1,-0.3l0.53,-0.14l0.13,-0.58l-0.97,-0.87l-2.1,-0.01l-2.53,0.83l-6.61,0.94l-1.15,-1.38l-1.27,-0.2l-1.22,0.62l-0.02,1.01l0.32,0.37l-0.17,0.4l-0.7,0.73l-0.92,0.29l-1.54,-0.63l-3.35,-0.64l-1.3,-0.66l-0.57,-1.38l-3.36,-1.66l-1.05,-1.32l-0.08,-0.61ZM633.41,95.25l-1.43,0.47l-0.59,-0.35l0.39,-0.29l1.62,0.17ZM634.77,94.93l1.2,-1.16l1.22,-2.2l0.98,-0.67l1.15,0.16l1.3,-0.43l2.21,-0.1l2.7,0.88l4.24,2.81l0.42,0.66l-0.33,0.54l0.51,1.58l-1.51,0.23l-3.33,-0.37l-5.33,-0.85l-3.78,-1.11l-1.65,0.03ZM634.93,89.75l-0.78,-0.15l-0.59,-0.78l0.07,-1.51l3.17,-0.47l0.6,0.29l0.18,0.4l-0.29,1.44l-2.37,0.77ZM617.39,114.02l0.29,-0.18l0.17,-0.01l-0.24,0.3l-0.23,-0.12ZM618.14,113.81l1.98,-0.15l0.86,0.35l-0.9,0.55l-1.95,-0.75ZM608.44,87.2l0.41,0.04l0.18,0.15l-0.55,-0.11l-0.04,-0.08ZM609.71,87.91l1.33,0.66l1.1,0.97l0.02,0.37l-0.27,0.13l-1.87,-1.49l-0.32,-0.63ZM608.72,74.52l0.66,-1.43l-0.19,-1.22l0.55,-1.21l0.4,1.02l1.37,0.79l-0.9,0.91l0.16,0.82l-2.05,0.32ZM572.05,101.03l2.38,-0.54l1.01,0.05l0.73,0.59l-0.69,0.25l-3.43,-0.36ZM570.84,103.26l1.73,-0.2l0.82,0.18l-0.8,0.48l-1.74,-0.45ZM550.43,90.36l0.01,-0.09l0.01,-0.0l0.03,0.09l-0.05,0.01ZM526.23,98.62l-0.06,-0.44l1.03,-0.05l0.84,0.35l-1.81,0.13ZM506.01,85.88l0.2,-0.1l0.18,0.15l-0.16,0.01l-0.21,-0.06ZM485.42,85.02l0.08,-0.97l0.25,-0.06l6.18,0.72l0.26,0.25l-1.04,1.56l-1.14,0.41l-0.85,1.0l-3.04,-0.47l-1.11,-0.77l-2.3,-0.73l0.61,-0.2l1.38,0.24l0.5,-0.31l0.21,-0.67Z",name:"Sakha, Respublika"},"RU-SVE":{path:"M198.15,238.57l0.05,-0.49l1.29,0.2l1.39,-0.61l0.29,-0.63l0.54,0.14l0.61,-0.27l0.21,-0.84l-0.82,-1.64l0.24,-1.2l0.5,-0.02l0.44,-0.79l0.46,-0.09l0.36,0.6l0.77,0.19l1.71,-1.19l0.32,-1.23l-1.29,-1.13l0.29,-0.57l0.7,-0.63l0.74,-0.0l1.19,-0.82l1.49,-1.65l-0.28,-1.85l-1.71,-0.7l0.54,-0.97l-0.38,-0.7l0.3,-1.34l-2.75,-1.08l-0.73,-1.06l-0.7,-0.18l0.4,-1.27l0.64,-0.17l0.46,-1.01l0.59,-0.05l0.34,-0.5l0.7,-0.04l0.06,-0.71l1.1,-2.15l-0.11,-0.78l1.18,-1.71l0.44,-3.01l-0.48,-0.47l-0.12,-1.22l-0.52,-0.95l0.84,-1.21l-0.38,-1.94l0.23,-0.82l-0.29,-0.44l0.51,-0.73l2.03,0.35l0.07,1.07l0.64,0.52l2.1,-0.18l3.72,0.49l3.99,2.22l2.56,0.8l0.95,0.68l1.04,1.39l-0.42,1.21l0.69,1.87l1.73,2.6l-0.01,0.71l1.21,0.6l0.99,0.1l0.82,2.54l0.23,2.62l1.26,0.77l1.67,-0.1l3.47,0.56l0.31,0.66l0.52,0.21l0.93,2.19l1.51,1.97l1.4,0.45l0.24,2.1l0.85,1.81l-2.38,0.99l-0.6,0.78l-0.62,-0.38l-3.32,1.79l0.52,0.59l-0.5,0.83l0.21,0.65l-0.28,0.6l0.84,0.6l0.02,1.35l0.41,1.08l0.56,0.49l-0.65,-0.01l-0.78,-0.53l-2.78,0.71l-0.3,0.31l0.1,0.64l-0.72,0.59l0.02,0.49l-1.65,-0.18l-1.63,-0.88l-2.04,0.37l-0.88,-0.2l-1.44,0.58l-0.3,-0.36l-0.64,-0.02l-2.55,2.26l-0.15,0.87l-1.59,-1.22l-0.75,0.03l-0.85,-0.45l-1.45,0.04l-0.47,0.57l0.3,0.64l-0.83,0.07l-0.81,-0.34l-2.88,0.22l-1.46,-0.42l-0.73,0.23l-0.44,-0.54l-2.58,-0.35l-0.8,0.42l-0.02,0.62l-0.64,0.18l-0.17,0.95l-0.64,-0.01l-1.24,-0.76l-0.97,0.52l-2.85,-0.43l-1.39,0.37l-0.72,-1.87l0.42,-2.04l-0.79,-0.94Z",name:"Sverdlovskaya oblast"},"RU-KK":{path:"M358.99,274.56l0.83,-1.33l0.78,0.07l0.7,-0.72l1.7,-0.71l0.32,-1.03l1.99,-1.47l-0.11,-0.75l0.79,-0.91l-1.0,-1.35l-0.69,-0.12l0.69,-0.73l0.02,-1.05l-1.08,-1.27l0.14,-0.91l0.64,-0.53l0.1,-0.51l0.56,-0.11l0.79,-0.74l-0.37,-1.07l-1.07,-0.62l0.85,-0.28l0.32,-1.24l-0.48,-0.85l-0.89,0.05l-0.86,-0.61l-1.48,0.61l0.48,-0.9l0.06,-1.21l0.75,-1.19l-0.12,-0.61l-0.96,-0.89l-0.78,-1.64l0.86,-0.71l1.27,0.85l0.76,1.6l0.93,0.69l1.15,0.08l0.73,-0.51l0.69,0.28l2.45,-0.76l0.3,0.4l0.81,0.18l0.06,0.9l0.49,0.27l0.85,-0.19l0.43,0.49l0.49,-0.04l-0.0,1.47l1.48,0.92l0.46,1.47l1.08,1.52l-0.72,1.64l0.75,2.19l0.62,0.54l0.97,0.21l0.36,0.66l-1.18,0.97l-1.21,0.34l0.05,1.68l-3.55,2.76l-1.17,1.86l-0.52,-0.08l-1.37,0.56l-0.08,0.64l-0.52,0.61l0.2,1.21l-0.47,0.12l-1.1,1.16l-2.01,-0.1l-0.61,-0.48l-2.95,0.89l-0.2,0.94l-0.52,0.55l-0.57,-0.02l-2.05,-1.15l1.0,-1.54l-0.23,-0.43l-0.85,-0.07Z",name:"Khakasiya, Respublika"},"RU-SPE":{path:"M54.42,213.0l1.62,0.4l0.15,0.62l0.71,0.41l0.13,1.08l1.02,0.55l-0.55,0.03l-0.6,0.6l-0.85,0.07l-1.82,-1.32l-0.21,-0.24l1.76,0.17l0.44,-1.25l-0.35,-0.38l-1.24,-0.16l-0.21,-0.58ZM53.61,215.07l-0.08,0.0l-0.22,-0.14l0.09,0.01l0.21,0.12Z",name:"Sankt-Peterburg"},"RU-MOS":{path:"M82.29,244.89l-0.01,-0.26l0.63,-0.32l0.33,-1.13l0.66,-0.31l0.08,-1.4l0.76,0.56l1.83,0.37l1.29,-0.7l1.08,0.0l1.63,-1.03l1.15,0.45l0.72,-0.62l0.04,-1.22l1.63,-0.2l0.85,-1.19l1.14,0.56l0.37,0.7l1.37,0.07l-0.09,1.5l0.47,0.6l0.09,1.35l1.2,2.5l2.12,0.43l0.59,0.56l0.87,0.01l0.5,0.53l1.85,-0.16l0.67,-0.34l0.11,0.53l0.83,0.76l-0.11,0.86l0.64,0.18l0.08,1.07l-2.23,1.04l-0.04,0.73l-1.77,1.19l-0.96,1.63l-2.09,0.39l-0.29,0.61l0.21,1.0l-0.55,0.71l-0.86,-1.19l0.61,-0.76l-0.42,-0.73l-2.12,-0.53l-0.86,-0.94l-1.21,0.13l-0.22,0.72l-0.97,-0.78l-1.11,-0.11l-0.28,-0.5l0.42,-0.84l0.49,-0.04l0.45,-0.48l0.21,-1.2l0.61,-0.21l0.46,-1.39l1.19,-1.26l-0.57,-1.36l-1.07,-0.52l-0.73,0.1l-0.69,-0.31l0.01,-0.42l-0.71,-0.51l-0.55,0.27l0.06,0.96l0.41,0.23l0.59,-0.19l-0.3,1.37l0.17,0.48l-0.61,0.24l0.26,-0.49l-0.32,-0.48l-1.29,0.23l-0.12,0.56l0.32,0.38l1.06,-0.12l-0.33,1.04l-0.48,-0.52l-0.57,0.02l-0.39,0.4l0.43,1.5l-0.42,0.33l-1.24,-0.75l-0.94,-0.03l-1.39,0.96l-2.31,-0.78l-0.82,0.03l-0.52,0.47l-0.36,-0.15l-0.06,-1.2l0.48,-1.14l-0.34,-0.68l0.1,-0.62l-0.77,-1.19Z",name:"Moskovskaya oblast"},"RU-BEL":{path:"M83.01,281.08l0.59,0.33l1.61,-0.26l1.2,-0.97l-0.0,-0.36l2.99,0.38l1.26,-0.73l1.39,-0.33l0.32,-0.65l1.02,-0.37l1.49,0.1l1.44,-0.34l0.28,0.38l1.89,0.65l-0.4,0.45l0.38,0.86l1.28,0.56l0.91,-0.35l-0.64,0.6l-0.04,0.85l0.61,0.78l1.22,0.57l-0.43,1.08l0.67,1.5l-0.09,0.41l0.75,0.85l-0.79,1.11l-1.41,-0.61l-0.29,-0.45l-1.5,-0.08l-0.5,-0.6l-0.8,0.01l-0.33,0.89l-0.3,0.05l-1.35,-0.98l-0.57,-0.7l-0.11,-0.75l-1.28,-1.07l-3.05,0.76l-1.18,0.68l-0.95,-0.56l-0.58,0.18l-1.05,-0.98l-1.55,0.0l-0.84,0.54l-0.38,-0.67l-0.47,-0.19l-0.16,-0.55l0.3,-0.98l-0.54,-1.04ZM96.86,278.3l0.0,-0.0l-0.0,0.0l-0.0,-0.0Z",name:"Belgorodskaya oblast"},"RU-KHM":{path:"M208.41,189.45l0.38,-0.5l0.21,-2.27l0.83,-1.68l0.4,-2.53l0.99,-0.57l0.52,-1.27l-0.18,-0.55l-0.64,-0.05l-0.63,-0.55l0.28,-0.73l-0.18,-1.08l-0.41,-0.33l0.9,-1.09l-0.17,-1.12l2.27,-2.08l1.01,0.02l1.11,1.35l0.66,0.01l0.86,-1.25l0.88,-0.08l0.76,-1.0l0.6,-0.21l0.59,-0.88l-0.09,-0.56l1.34,-1.66l1.92,-1.32l1.1,0.65l1.1,2.35l1.62,0.48l-0.03,1.74l-0.66,1.44l0.11,0.38l0.58,0.26l-0.04,0.6l-1.04,0.68l-0.32,1.09l1.13,0.76l1.22,0.14l1.57,-0.4l0.99,0.54l-0.17,1.06l1.04,0.52l1.76,-0.09l0.7,-0.61l2.41,-0.03l0.72,-0.64l3.01,-0.1l1.14,-1.04l3.17,-0.19l2.27,0.69l1.15,-0.37l0.97,0.33l-0.72,1.19l0.3,1.21l1.63,0.51l1.0,0.77l2.04,0.02l0.71,0.39l3.39,-2.22l2.44,0.58l0.79,-1.16l-0.43,-0.81l0.25,-0.09l0.95,0.03l0.84,0.66l1.74,-0.06l1.48,0.68l1.52,-0.25l0.83,0.73l1.45,0.4l-1.17,1.42l2.0,2.84l2.63,0.23l0.62,0.54l0.25,3.17l0.5,0.36l2.01,-0.14l0.87,-0.78l2.63,0.14l2.16,-1.23l1.34,1.83l4.6,0.3l1.39,1.05l2.23,0.11l2.41,-0.62l2.52,-0.03l1.81,0.7l0.52,0.63l1.98,-0.75l1.59,0.48l0.75,1.5l3.83,1.92l0.87,0.84l2.02,-0.87l2.13,-0.38l5.5,0.07l0.38,-0.32l0.37,-1.39l3.16,-1.59l0.35,-0.71l2.05,-0.18l0.38,1.13l0.9,1.19l2.4,1.17l0.6,-0.01l1.49,-0.95l0.86,0.33l1.89,0.06l0.09,0.57l1.35,0.69l0.21,0.56l1.48,0.65l2.64,-0.8l1.06,1.25l1.15,0.2l1.47,2.74l0.0,0.89l0.95,0.96l1.67,0.22l0.93,0.67l1.08,0.1l0.53,0.51l2.32,0.57l-1.56,0.66l-0.07,0.87l-5.27,2.21l-1.84,1.11l-1.19,0.2l-2.49,-1.72l-2.25,0.19l-3.87,2.43l-0.29,1.0l-0.76,0.47l-1.68,-0.9l-3.63,0.06l-0.53,-0.92l-1.65,-0.35l-1.79,0.28l-1.2,0.77l-1.67,-0.22l-2.41,0.21l-0.07,-0.85l-0.91,-0.49l-2.04,0.44l-0.61,-0.38l-1.21,0.4l-1.86,-0.19l-1.02,0.42l-1.05,-0.59l-3.38,-0.21l-0.96,1.41l0.38,1.22l-1.39,0.84l-0.17,0.93l0.5,0.56l-0.79,1.21l0.32,0.56l-0.08,2.25l-0.43,0.44l-0.06,0.67l-2.31,0.26l-0.87,0.88l-0.6,0.04l-0.46,1.07l-1.1,0.64l0.14,1.81l-2.39,2.22l-1.95,-0.56l-3.28,0.07l-0.68,-0.51l-1.85,-0.37l-0.86,0.27l-1.77,-0.26l0.12,-0.44l-0.72,-0.58l0.09,-0.61l-0.37,-0.52l-0.62,-0.21l-1.08,0.37l-0.42,-0.26l-0.41,-1.1l-2.28,-2.05l-0.74,-0.14l-0.6,-0.6l-2.39,-1.12l-0.74,-0.94l-0.66,0.1l-0.57,0.59l-1.01,-0.34l-2.03,0.35l-1.27,-0.64l-2.74,-0.04l-0.4,-0.61l-1.32,-0.05l-1.15,0.43l-0.45,0.5l0.08,0.48l0.83,0.49l-3.44,1.45l-1.11,2.24l-3.16,0.51l-0.99,0.94l-2.39,1.17l-0.49,-0.32l-1.23,0.4l-0.27,0.5l0.12,1.49l-1.75,0.57l-2.22,-0.18l-1.24,-0.33l-1.4,-1.81l-0.96,-2.29l-0.63,-0.3l-0.39,-0.74l-3.87,-0.7l-1.54,0.12l-0.77,-0.41l-0.14,-2.35l-0.87,-2.73l-0.44,-0.43l-1.71,-0.45l-0.72,-1.77l-1.09,-1.41l-0.61,-1.67l0.52,-1.14l-1.41,-1.89l-1.17,-0.81l-2.46,-0.76l-4.15,-2.28l-3.89,-0.53l-1.94,0.19l-0.18,-1.33l-1.31,-0.52l-1.16,-0.06l-0.48,-0.93l1.03,-1.89l0.24,-1.33l-0.8,-0.54l-0.46,-1.14l0.36,-1.66l-0.49,-0.51l-0.61,-0.12l-0.2,-0.5Z",name:"Khanty-Mansiyskiy avtonomnyy okrug"},"RU-VLG":{path:"M80.18,221.07l0.29,-0.54l2.62,-0.69l0.73,-2.41l0.75,-0.6l-0.33,-0.85l-0.95,0.09l-0.08,-0.91l0.36,-0.78l-0.51,-0.48l-1.04,-0.2l-0.04,-1.55l0.41,-0.63l0.16,-2.03l-0.46,-1.46l1.46,-0.59l0.27,-0.92l0.96,-1.18l-0.04,-0.54l3.9,-1.5l0.82,-1.16l1.16,0.09l0.65,-0.39l1.52,0.73l2.37,-0.16l0.26,1.61l0.64,1.24l0.43,0.2l-0.03,0.84l0.59,0.17l0.48,0.71l0.81,0.07l0.12,0.7l0.9,0.21l0.4,0.63l1.06,0.04l0.69,-0.5l1.32,0.99l0.38,-0.42l0.59,0.18l1.36,-0.45l1.72,0.72l2.12,-0.47l0.45,-0.43l0.55,0.35l0.76,-0.29l1.7,0.82l1.79,0.03l0.57,-1.83l0.31,-0.15l0.92,0.48l0.67,-0.48l0.45,0.51l2.47,0.53l0.97,-0.14l0.39,-0.6l0.73,0.04l0.94,0.96l1.02,-0.49l1.88,0.24l0.37,-0.76l1.04,-0.34l0.24,-0.97l1.29,-0.37l0.57,0.81l5.4,0.54l0.42,-0.31l0.5,-2.08l1.63,0.19l0.07,0.93l0.66,0.35l2.22,0.41l1.15,-0.55l0.98,0.39l0.27,0.65l1.4,0.41l-0.58,1.07l0.28,0.52l-0.64,0.42l-0.56,1.9l-1.58,-0.07l-0.76,0.21l-0.2,0.43l0.79,1.42l1.75,0.39l1.24,-0.49l-0.5,2.18l0.27,0.41l0.8,0.22l-0.01,0.37l-3.34,-0.12l-0.48,0.43l-0.19,1.83l-1.53,0.33l-0.59,0.89l-4.2,0.0l-0.59,0.47l-2.13,-0.16l-0.62,-0.54l-0.59,0.53l-1.05,-0.66l-0.98,0.18l-1.19,-0.4l-0.7,0.37l-0.54,-0.67l-1.16,0.48l-0.9,-0.42l-0.59,0.66l-0.81,0.23l-0.92,-1.03l-1.95,0.24l-0.27,-0.84l-0.94,-0.33l-0.43,0.24l-0.46,1.21l0.65,0.8l-0.81,0.38l-0.76,-0.21l-1.9,1.11l-1.05,0.11l-0.45,1.58l0.28,0.53l-1.16,0.79l-1.39,-0.18l-0.73,0.38l-1.42,0.06l-1.0,-1.49l-0.68,-0.15l-1.34,-1.04l-2.83,-0.44l-1.18,0.26l-0.25,1.3l-1.48,-0.2l-0.51,0.54l-2.07,-0.21l-0.89,0.84l-1.0,0.02l-0.38,0.86l-2.52,-2.71l-1.89,0.31l-1.05,1.54l-1.19,0.88l-1.06,-1.42l-1.39,-0.46l-0.75,-0.61l-1.84,-0.09l-0.59,0.33l-0.32,-0.22l0.08,-0.59l-1.52,-0.49l-0.35,-0.66ZM143.27,209.53l-0.03,0.04l0.01,-0.02l0.02,-0.02Z",name:"Vologodskaya oblast"},"RU-CHE":{path:"M197.46,251.35l0.45,-0.33l0.1,-0.59l1.05,-0.55l2.33,0.36l-0.4,0.41l0.31,0.77l-0.33,0.92l0.53,0.58l0.94,-0.43l0.02,-0.53l0.65,-0.85l0.17,1.04l1.03,0.48l0.7,0.0l1.03,-0.55l0.23,-0.47l-0.37,-0.71l0.24,-0.49l0.81,0.09l1.0,-0.75l0.14,-0.74l1.38,-0.15l1.06,-0.9l-0.05,-0.5l-1.58,-0.55l-0.07,-0.82l-0.58,-0.32l-0.05,-1.1l0.44,-0.33l0.14,-0.71l-0.22,-0.39l-0.67,-0.06l0.11,-0.83l1.87,0.31l0.31,0.44l0.7,0.13l0.81,-0.22l1.36,0.41l2.76,-0.22l1.03,0.37l1.36,-0.23l0.3,-0.32l-0.07,-0.59l0.73,-0.17l0.85,0.49l0.5,-0.17l1.04,0.96l1.14,0.41l0.56,0.61l0.34,1.48l1.25,0.61l-0.34,1.69l-1.13,0.01l-0.29,0.82l-0.75,0.45l0.02,0.52l0.74,0.33l0.24,0.68l-0.95,0.11l-0.41,0.43l0.11,0.92l0.52,0.53l-0.3,1.02l0.88,0.72l1.75,-0.47l0.57,0.63l1.91,-0.51l1.14,0.04l0.23,0.66l-0.67,0.3l-0.26,1.34l0.82,0.59l-0.59,0.23l-0.12,0.42l-2.01,0.09l-0.85,0.51l-2.58,-0.09l-0.38,0.59l-0.52,-0.43l-1.25,0.16l-1.27,-0.64l-0.83,0.32l-0.33,0.47l-0.98,0.22l-0.16,0.86l0.95,0.43l-0.63,0.7l-0.67,0.08l-0.08,0.7l1.68,0.63l-0.45,0.9l0.19,0.78l2.09,0.82l0.72,-0.18l0.55,0.44l1.55,0.34l-0.05,0.37l-2.22,0.04l-0.9,-0.46l-2.58,0.39l-0.03,0.7l-1.43,0.98l-0.34,0.74l0.74,0.79l0.18,0.66l0.56,0.22l0.25,0.69l-1.45,1.03l-0.88,-0.03l-1.61,1.09l-0.5,0.0l-0.3,-0.57l1.07,-0.95l-0.22,-1.47l-1.17,-0.08l-0.74,-0.48l-1.62,0.36l-0.49,-0.34l-0.85,0.0l-0.43,0.4l-0.15,0.88l-0.61,-0.72l-0.72,-0.26l0.08,-0.4l-0.44,-0.59l0.25,-1.91l0.84,-0.29l0.34,-0.57l-0.63,-0.5l-0.39,-0.97l0.41,-4.28l0.16,-0.43l1.0,-0.28l0.75,-1.35l0.93,-0.1l0.77,0.47l0.67,-0.28l0.43,-1.02l-0.46,-0.74l-0.03,-1.05l0.77,-0.56l0.61,-1.46l-0.43,-0.93l-0.74,0.05l-0.87,-0.43l-2.37,2.14l-1.04,-0.05l-2.05,1.04l-1.52,-0.49l-1.96,1.07l-0.72,-0.65l-0.14,-0.59l-2.96,-1.65l0.47,-0.8l-0.55,-0.86ZM219.34,262.66l0.12,-0.13l0.3,-0.0l-0.32,0.26l-0.1,-0.13Z",name:"Chelyabinskaya oblast"},"RU-YAR":{path:"M94.1,230.7l0.45,-1.24l0.7,-0.49l-0.75,-1.0l-0.85,-0.23l0.21,-0.84l1.21,-0.5l0.36,-1.29l0.77,0.07l0.75,-0.84l2.09,0.21l0.68,-0.52l1.74,0.24l0.93,-1.59l2.54,0.44l1.12,0.91l0.64,0.08l1.19,1.59l1.92,-0.03l0.53,-0.32l1.43,0.15l0.74,1.36l-1.14,0.99l-0.11,0.51l-1.36,1.58l0.09,2.41l-0.77,0.21l-0.44,0.54l0.14,1.42l-0.89,0.05l-0.34,0.53l-1.47,0.28l-0.4,0.55l-1.55,0.71l-0.04,0.63l-0.67,0.76l-0.48,1.31l0.06,0.74l-0.67,-0.33l-0.68,0.37l-1.15,-0.48l-0.84,0.22l-1.2,-0.88l-0.65,-0.85l0.39,-1.7l-0.41,-0.76l0.64,-0.54l-0.13,-0.95l-0.48,-0.27l-0.85,0.23l-0.98,-0.47l-0.37,-1.71l-0.7,-0.25l-0.94,-1.01Z",name:"Yaroslavskaya oblast"},"RU-TUL":{path:"M86.24,260.76l0.12,-0.76l1.19,-1.13l0.11,-0.89l0.66,0.06l0.49,-0.56l1.96,0.05l0.49,-0.24l0.28,-1.11l-0.65,-0.85l1.11,0.24l0.79,-1.23l0.1,-0.79l2.07,0.84l0.59,-0.23l0.26,-0.66l0.88,0.9l2.01,0.51l-0.5,0.38l0.06,0.6l0.63,0.74l0.04,0.51l0.8,0.53l0.22,1.59l0.46,0.55l0.02,1.09l0.54,0.38l-0.17,0.75l-0.91,0.53l0.15,0.9l-1.07,0.26l-0.15,0.68l0.45,0.38l0.08,0.86l-0.98,0.33l-3.67,-0.93l-0.19,-1.17l-1.37,-0.16l-0.76,0.4l-1.06,-0.39l-0.94,0.06l-0.59,-0.79l-0.88,0.11l-1.25,-1.09l-1.12,-0.2l0.24,-0.66l-0.51,-0.4Z",name:"Tulskaya oblast"},"RU-IRK":{path:"M399.71,257.15l0.23,-0.49l1.02,-0.07l0.67,-1.06l2.75,0.2l0.16,-1.55l0.68,-1.2l0.02,-0.62l-0.41,-0.56l0.36,-1.5l0.83,-0.26l0.31,-0.49l-0.7,-3.11l0.89,-0.68l0.12,-0.98l0.59,-0.58l1.19,0.34l0.61,-0.82l0.56,-0.23l0.25,-0.44l-0.14,-0.94l1.18,-0.05l0.45,-0.33l0.04,-1.25l-0.54,-0.44l-0.05,-1.47l-0.65,-0.36l-0.88,0.05l0.69,-0.48l0.02,-0.51l-1.25,-0.65l2.83,-5.27l3.85,0.25l1.28,0.48l2.56,-0.6l1.43,-2.11l1.46,-0.0l0.29,1.35l1.07,1.06l0.46,1.48l1.81,1.17l0.52,0.0l1.22,-0.8l-0.0,-0.86l-0.7,-0.71l0.34,-0.58l-0.12,-0.5l0.71,-0.26l0.69,-0.79l0.12,-1.03l0.56,-0.61l1.28,-0.09l0.91,-1.52l2.55,-0.77l0.75,-0.96l1.08,-0.68l0.32,-0.96l-0.79,-2.04l0.4,-0.47l1.35,-0.12l0.87,-0.71l0.94,0.28l0.97,1.78l0.8,0.35l0.34,0.53l1.48,0.19l0.14,0.33l-0.43,0.55l0.2,0.3l1.83,-0.17l1.57,1.23l1.92,-0.6l0.54,-0.76l-0.47,-0.78l1.72,-1.28l1.14,-0.45l0.01,-1.18l-0.56,-0.84l-0.06,-1.11l-0.46,-0.49l-0.91,0.11l-0.73,-1.3l0.88,-0.39l0.48,-0.61l1.26,0.26l0.84,-0.3l-0.16,-0.81l0.26,-0.79l-0.34,-0.79l0.27,-1.17l-1.15,-0.66l-2.12,-0.01l-1.01,-0.75l-0.68,-1.66l0.32,-0.89l-0.47,-0.43l0.64,-0.47l0.0,-1.25l0.88,-0.73l1.03,-0.19l-0.43,-1.61l1.57,-0.18l0.74,-0.93l1.53,-0.85l0.74,0.1l0.88,-0.8l-0.26,-1.01l1.46,-1.22l1.18,-0.44l0.08,-2.11l1.45,-1.43l-0.06,-0.76l0.62,-0.44l-0.25,-0.44l-1.22,-0.54l-0.44,-1.28l-1.11,-0.53l-0.31,-0.73l1.25,-0.63l-0.06,-1.38l1.26,0.1l0.54,-0.89l-0.95,-1.14l0.69,-0.88l-0.21,-0.72l0.8,-1.27l-0.57,-0.8l1.48,0.81l0.96,-0.54l0.57,0.69l1.28,0.11l0.67,-1.1l3.23,-0.18l0.38,-0.71l-0.46,-1.27l0.59,-0.35l0.03,1.21l1.19,1.1l-0.19,0.54l0.28,0.37l-2.22,0.11l-0.25,1.25l-0.77,0.43l0.05,0.75l0.48,0.33l2.1,-0.3l1.58,0.51l0.87,-0.11l1.05,1.5l0.45,0.2l0.51,3.14l0.82,0.62l-0.75,0.54l-0.57,1.24l-0.68,0.38l0.13,0.61l1.34,1.1l1.94,-0.02l0.4,0.68l-0.2,0.46l0.25,0.43l-2.04,2.61l0.21,1.35l1.23,1.32l-0.35,1.8l1.63,0.57l0.63,0.95l1.28,-0.14l0.17,0.28l-1.4,1.95l0.12,0.94l-1.1,0.29l0.26,0.64l-0.87,0.92l-0.07,0.57l-1.0,1.44l-0.22,0.95l0.24,0.79l-1.23,1.9l0.03,1.03l-1.27,1.39l0.06,1.38l1.18,0.38l0.18,0.58l0.51,0.31l0.12,0.72l0.62,0.14l0.42,0.58l2.62,0.04l1.28,-0.45l1.02,-1.68l2.33,0.54l1.37,-0.61l1.31,0.43l0.67,-0.5l1.01,-0.08l1.22,-1.48l0.09,1.25l1.26,-0.04l-0.47,0.7l-0.1,1.96l0.33,0.68l0.54,0.1l1.2,-1.66l0.91,-0.39l1.8,-0.14l1.17,-0.87l0.24,-0.95l-0.19,-0.34l0.73,-0.55l0.1,-0.61l2.93,-1.43l0.7,-0.97l1.4,-0.99l-0.09,-0.87l0.61,-0.62l0.76,0.1l2.11,-2.02l2.19,-0.58l1.88,0.91l2.68,0.38l1.87,1.48l0.62,1.08l-0.23,0.68l0.84,0.75l-0.67,1.87l0.94,0.61l2.03,0.5l0.74,-0.41l0.34,0.55l0.53,0.09l0.5,-0.19l0.58,-0.94l0.93,-0.16l0.44,0.67l1.68,0.75l0.19,0.69l-0.54,0.66l0.09,1.11l0.65,0.66l-0.21,0.73l0.53,0.57l-0.6,1.61l0.37,0.47l1.47,0.67l-0.31,0.61l0.18,0.62l-1.96,0.44l-1.1,-0.6l-0.55,-0.73l-2.75,-0.43l-0.89,0.1l-1.19,0.76l-0.15,0.52l0.51,0.64l-0.46,-0.02l-0.32,0.36l-0.22,1.79l-1.17,0.24l-0.35,0.59l0.43,0.59l-0.13,0.74l0.74,0.38l-0.13,0.66l1.04,2.11l0.49,0.22l1.17,-0.49l-0.84,0.56l0.34,1.31l-0.84,0.72l-0.29,-0.6l-0.39,-0.07l-1.12,0.95l-1.51,0.62l-1.11,-0.16l-1.22,-0.7l-1.14,0.28l-1.52,-0.94l2.04,-0.82l0.28,-0.6l-0.75,-0.83l-1.58,-0.07l-1.06,0.83l-0.77,0.18l-2.32,-0.06l-1.5,2.3l-0.21,0.81l-1.32,0.01l-0.24,0.29l-1.74,-0.11l-1.07,1.11l-0.31,-0.46l-1.66,-0.65l-0.99,0.34l-2.07,-0.38l-0.75,-0.47l0.07,-1.07l-0.37,-0.42l-0.74,-0.05l-0.96,0.64l-0.88,-0.09l-0.78,-0.51l-1.43,0.13l-0.72,-0.53l-0.16,-0.65l-0.98,-0.17l-0.64,0.46l-0.48,1.26l-0.68,0.45l-1.9,-0.4l-0.88,0.3l-1.34,-0.79l-2.0,-0.25l-0.72,0.61l-0.57,1.41l-1.77,-0.25l-0.65,0.51l-0.81,-0.05l-1.18,0.62l-1.31,0.17l-0.04,0.77l-0.8,1.2l0.1,0.61l1.48,0.57l0.86,1.48l-0.88,0.84l-0.37,1.58l-0.47,0.3l-0.38,1.23l0.16,1.23l0.64,0.88l-0.43,0.72l0.05,2.73l-0.72,1.29l2.37,0.51l-3.04,4.59l-1.9,4.11l-9.68,5.35l-2.38,2.91l-1.47,1.14l-1.72,0.9l-2.42,0.74l-0.37,0.54l0.11,1.84l-0.59,-0.21l-1.51,0.22l-1.53,0.84l-0.16,-1.65l-1.43,-0.59l-1.19,0.26l-0.48,-0.88l-0.01,-1.53l-2.36,-1.34l-1.12,-1.55l-0.89,-0.43l-0.61,0.17l-0.78,-0.3l-0.89,0.43l-0.16,-0.53l-2.5,-2.28l-3.06,-1.25l-1.33,-0.97l-1.1,-1.12l0.12,-0.77l-0.89,-1.23l-2.4,0.49l-0.41,0.79l-1.29,0.55l-0.95,0.0l-0.68,0.97l-0.5,-0.21l-0.04,-0.62l-0.83,-0.43l-1.46,-0.04l-0.49,0.34l-1.12,0.05l-0.18,-0.81l-1.4,-0.27l-0.43,-0.74l-1.66,-0.14l-1.6,-1.55l-1.13,-0.21l-1.35,-0.78l-1.65,0.47l-2.25,-2.23l-0.17,-0.7l-2.0,-1.12Z",name:"Irkutskaya oblast"},"RU-NIZ":{path:"M117.31,250.88l0.44,-1.13l0.87,-0.87l-0.3,-1.08l0.25,-0.52l0.58,-0.62l0.7,-0.16l0.83,-1.25l0.58,-0.09l0.34,-0.62l-0.1,-0.64l1.01,-0.11l0.42,-0.52l-0.31,-0.49l-0.7,-0.08l-0.0,-0.56l-0.62,-0.73l0.91,0.08l0.36,-0.31l0.15,-1.38l-0.5,-0.47l0.05,-0.44l3.38,-0.74l1.13,-1.5l-0.93,-0.81l0.23,-0.36l1.47,-0.78l0.17,-0.48l2.37,-0.8l1.16,-1.22l0.99,-0.15l0.76,-1.49l-0.35,-0.77l0.17,-0.44l2.77,0.31l0.72,0.77l1.48,-0.87l2.49,-0.19l0.52,0.4l4.86,-0.04l1.54,0.53l-0.74,0.57l-0.45,1.81l-0.8,-0.24l-1.26,0.57l-1.71,-0.1l-0.46,1.7l0.56,0.64l-0.3,0.35l0.13,1.04l-0.46,0.64l-1.32,-0.2l-0.76,0.45l-1.41,0.18l-0.55,1.81l-1.28,0.49l-0.15,0.73l0.25,0.66l1.29,0.36l-0.26,0.97l1.05,0.87l0.14,0.77l0.34,0.16l-0.38,1.25l-0.87,0.92l0.04,0.44l1.19,1.27l0.94,0.23l-0.56,0.43l-0.09,0.77l-0.59,0.4l-0.25,1.21l-0.73,0.06l0.01,-0.65l-0.62,-0.6l-0.88,0.15l-0.66,0.56l-0.5,1.44l-0.6,0.1l-1.27,1.07l-0.1,1.7l-1.19,-0.24l-0.54,-0.47l-0.86,0.34l-1.56,-0.7l-0.11,-0.61l-0.66,-0.11l-0.2,-0.5l-1.28,-0.15l-0.56,-0.57l-1.14,-0.37l-1.54,0.35l-0.43,0.77l-1.89,-0.18l-0.41,0.22l-0.47,-1.5l-0.49,-0.13l-1.32,0.45l-0.49,-0.2l-0.17,-0.65l-0.51,-0.15Z",name:"Nizhegorodskaya oblast"},"RU-YAN":{path:"M223.7,167.2l1.8,-0.82l1.73,-0.31l0.36,-1.11l-0.11,-0.76l1.13,-1.43l1.11,-0.01l-0.13,-0.98l0.7,-0.89l1.96,-0.69l0.92,-0.9l1.61,-0.11l0.63,-0.52l0.76,-0.13l0.22,-0.57l2.7,-0.84l0.19,-1.42l0.5,-0.26l0.05,-0.6l2.26,-1.45l0.37,-0.55l1.23,-0.23l0.82,-0.86l-0.4,-1.26l0.71,-0.33l0.28,-0.62l-0.2,-0.59l-0.7,-0.4l0.17,-1.28l-1.32,-0.4l-0.67,0.33l-1.59,0.0l-0.45,-0.56l0.15,-0.63l-0.29,-1.11l1.71,-2.26l0.2,-1.03l-0.75,-0.34l-1.21,-2.05l-1.23,-0.06l-1.59,-0.77l-0.9,0.27l-0.12,-0.86l2.5,-1.99l2.58,0.89l0.45,0.7l2.19,0.43l3.0,1.31l1.7,0.2l0.06,0.67l0.93,0.85l1.96,0.91l1.16,1.17l1.73,0.49l0.39,0.43l-0.28,0.73l0.68,0.93l1.3,-0.42l1.25,-0.98l-0.39,-0.51l1.76,-2.25l0.91,-1.96l-0.03,-0.54l0.73,-0.81l-0.43,-0.29l-1.19,-0.02l-1.46,0.42l-0.98,-0.47l-2.19,-2.94l0.39,-0.76l-0.22,-1.63l-0.57,-0.03l-0.42,0.5l-0.48,-0.11l-1.1,-0.76l-3.21,-1.05l-0.86,0.58l-0.13,-0.71l0.45,-1.72l0.45,0.21l1.11,-0.33l0.91,-1.27l-0.47,-1.25l-0.71,-0.06l1.01,-2.28l-0.4,-0.54l0.62,-2.19l-0.71,-1.02l-0.92,-0.14l-1.85,0.54l-0.26,-0.51l0.72,-0.56l0.57,-1.08l0.03,-0.54l-0.4,-0.31l0.46,-1.15l3.39,-1.14l1.99,-1.13l1.6,-1.53l0.58,0.05l-0.03,-0.67l0.75,-0.91l0.95,-2.1l1.25,-4.98l0.74,-1.69l1.01,-0.8l0.49,-1.35l0.5,-0.24l0.08,0.6l0.52,0.36l10.23,-0.39l1.2,0.44l-0.12,0.33l0.85,0.43l1.15,-0.31l2.81,0.91l-0.03,1.01l0.46,0.87l-0.09,1.17l0.38,0.96l-1.52,2.26l-0.28,1.17l-0.93,0.64l0.0,1.35l-0.61,0.38l-0.17,0.64l-1.74,0.65l-0.38,0.94l0.3,0.68l1.4,1.36l2.79,1.53l-0.13,0.96l1.06,1.38l-0.8,2.24l0.48,0.89l-0.06,0.77l-0.67,0.31l-1.05,1.21l0.24,0.68l0.71,0.52l-0.65,1.15l1.04,1.89l-0.84,1.47l0.54,2.0l-0.6,0.15l-0.03,0.62l0.66,0.76l-0.62,0.51l-0.25,0.83l0.56,2.1l1.59,1.51l3.76,2.15l-2.58,2.58l0.13,0.71l-0.32,0.69l0.68,1.11l0.0,0.77l-0.59,0.3l-0.02,0.68l-0.84,0.43l-0.19,0.42l-1.52,0.22l-0.3,0.92l-0.74,0.5l0.13,1.14l-1.0,-0.09l-0.86,0.34l-0.12,0.69l0.34,0.59l-1.07,0.49l0.39,0.49l-1.07,0.97l-0.94,0.03l-0.74,-0.45l-0.7,0.27l0.1,0.7l0.69,0.54l0.51,1.42l-0.79,-0.34l-0.43,0.38l-1.24,0.13l-0.86,0.57l0.05,0.27l-0.98,0.12l-1.41,-0.43l1.62,-0.64l0.41,-0.51l-0.23,-0.52l-1.08,-0.04l-0.64,0.59l-0.72,0.09l-1.99,-1.65l-0.95,0.52l-0.71,-0.24l-0.4,0.29l-0.81,-0.23l-2.26,0.2l-0.24,0.63l0.73,0.41l0.16,1.41l1.55,0.94l1.79,0.27l0.92,0.59l2.52,0.72l5.51,-0.19l1.26,0.27l0.71,0.72l1.05,0.1l1.9,-0.58l0.52,-0.7l0.05,-1.6l0.39,-0.54l2.2,-0.32l0.55,-0.77l2.5,-0.76l0.83,-1.01l0.83,-0.28l0.73,-1.12l0.02,-2.06l0.83,-0.96l3.5,-2.57l0.43,-2.39l-0.52,-1.9l-0.85,-1.17l-1.15,-0.89l0.59,-0.99l-0.18,-1.07l0.22,-0.71l3.52,-1.29l2.3,-0.24l2.54,-0.7l2.21,0.01l0.28,0.61l-0.31,0.7l0.31,0.53l1.87,1.07l0.57,0.77l0.79,0.12l-0.23,0.43l0.24,0.69l-0.71,0.86l0.18,0.51l0.67,0.31l-0.52,0.77l-0.15,1.12l0.5,0.91l-1.09,0.45l-0.03,0.59l0.34,0.44l2.87,1.35l0.04,0.53l0.5,0.2l0.66,-0.23l1.22,0.24l0.83,-0.32l0.71,0.25l1.96,-0.32l1.66,0.18l0.29,-0.64l-0.42,-0.44l-0.71,-0.09l-0.16,-0.37l-1.02,0.14l-1.32,-0.57l-0.25,0.28l-1.29,0.1l-1.94,-1.05l-0.41,0.36l-0.73,-0.09l0.03,-0.86l0.53,-0.33l-0.48,-0.61l0.43,-1.27l0.52,-0.44l2.03,-0.23l0.58,-0.4l-0.38,-1.08l-0.74,-0.48l-0.03,-0.9l-1.16,-0.87l0.07,-1.2l-0.29,-1.35l-0.44,-0.52l-3.78,-0.92l-1.0,-1.1l-1.65,-0.14l-2.16,-0.89l-2.91,-0.19l-2.08,1.0l-0.25,0.43l-1.44,0.21l-2.33,-0.59l-1.89,0.56l-0.7,-0.54l0.74,-2.31l-1.97,-2.87l0.68,-0.87l0.58,-2.12l-0.26,-0.81l1.45,-1.2l1.66,-2.09l0.09,-1.61l-0.42,-0.75l-1.68,-1.23l-0.16,-1.09l-1.05,-1.03l-0.78,-1.77l-2.57,-1.45l2.26,-2.06l0.04,-1.43l2.08,-0.86l2.09,-0.42l3.13,-1.4l0.51,-0.52l0.49,-0.84l0.2,-1.41l-0.27,-2.54l-0.37,-0.96l-1.06,-1.09l0.91,-0.36l1.78,0.87l-0.54,0.51l1.5,1.24l-0.39,0.9l0.95,2.04l-1.1,1.04l-0.52,1.71l-0.62,0.09l-0.31,0.47l-0.17,1.62l0.4,0.7l0.79,0.45l-0.27,0.52l0.51,0.54l-0.34,0.51l-0.65,-0.01l-0.34,0.38l0.16,1.08l0.65,0.5l4.08,1.27l0.32,-0.33l3.41,0.41l0.17,0.86l0.61,0.28l0.38,-0.99l3.81,0.36l0.76,1.52l2.68,0.87l3.39,-0.41l0.66,-0.84l-0.04,-0.5l-0.64,-0.26l-0.5,0.28l-0.81,-0.13l-0.43,0.6l-0.68,-0.19l0.2,-0.58l-0.35,-0.71l-1.08,-0.06l0.18,-0.77l-0.23,-0.53l-1.59,-0.39l0.18,-0.28l-0.27,-0.6l-0.97,0.19l-0.82,0.58l-7.12,-2.65l0.03,-0.6l-1.07,-2.24l1.29,-0.63l2.63,-0.48l3.68,2.14l2.88,-0.49l0.67,-0.55l0.24,-0.85l-1.21,-1.43l-1.89,-0.26l-1.24,0.43l0.42,-0.5l0.63,0.12l0.5,-0.27l1.11,-1.11l2.05,-0.57l1.09,1.02l-0.03,0.71l1.59,0.9l2.96,0.81l1.32,-0.16l2.39,1.11l-0.94,0.55l0.35,1.41l-0.51,0.46l-3.11,0.03l-0.36,0.3l0.1,1.0l-0.88,0.41l-0.3,0.66l0.67,1.19l1.74,0.4l2.17,1.42l2.79,0.6l0.09,1.71l0.47,0.55l-0.3,0.84l0.82,0.55l-0.75,1.38l-1.92,0.25l-1.72,1.52l-0.97,0.08l-1.0,1.4l-0.86,-0.27l-0.26,0.83l-1.02,0.7l0.02,0.47l-1.37,0.91l0.98,1.13l-0.23,0.69l2.58,0.7l2.1,2.77l2.06,-0.05l2.53,0.45l1.45,0.91l1.82,-0.69l0.58,0.26l0.87,-0.21l0.51,-0.49l0.01,-1.02l0.68,0.53l-0.8,0.79l0.62,0.9l2.33,0.41l0.74,-0.14l-0.71,0.8l0.94,0.76l0.32,1.48l2.0,1.14l-1.72,0.15l-0.76,0.54l0.13,0.54l0.95,0.59l0.05,1.41l-1.55,1.15l-0.09,1.84l-2.85,-0.06l-0.56,0.48l0.08,0.56l0.85,1.05l0.96,0.52l-0.23,0.46l0.38,0.6l1.17,0.7l-0.47,0.69l0.25,0.67l-0.97,1.01l5.55,3.97l0.52,0.95l-0.95,0.53l-0.0,1.52l2.16,2.24l-0.53,0.19l-0.57,0.89l0.38,0.85l0.81,0.74l0.09,0.82l0.58,0.53l2.17,-0.2l1.07,0.91l-0.35,0.5l0.21,0.31l1.46,0.68l-0.01,0.82l0.38,0.7l-1.4,1.58l0.29,0.89l-0.47,0.46l0.11,0.65l1.26,0.3l2.11,-0.33l0.12,0.81l1.35,0.7l2.11,-0.66l1.21,0.34l-0.21,0.95l0.44,0.45l-0.3,1.07l0.98,1.55l-0.4,1.5l-2.11,1.0l-1.38,2.38l-1.26,0.56l0.31,0.94l1.4,0.5l0.35,1.08l0.88,-0.1l-0.73,1.47l0.49,0.78l-0.27,0.91l-0.88,0.33l-2.28,2.72l-0.11,0.66l-1.9,1.78l-0.45,-0.26l-0.38,-0.86l-1.23,-0.23l-1.2,-1.36l-2.79,0.78l-2.49,-1.57l0.04,-0.51l-0.4,-0.34l-3.28,-0.45l-1.72,1.01l-2.1,-1.03l-0.84,-1.07l-0.33,-1.22l-0.53,-0.21l-2.81,0.35l-0.2,0.67l-3.33,1.74l-0.43,1.47l-5.31,-0.08l-2.24,0.41l-1.74,0.8l-0.44,-0.66l-3.84,-1.92l-0.7,-1.51l-1.97,-0.61l-1.91,0.59l-0.37,-0.41l-2.4,-0.8l-2.42,0.06l-2.32,0.61l-2.03,-0.09l-1.45,-1.06l-4.35,-0.23l-0.9,-1.48l-0.87,-0.46l-2.27,1.27l-2.63,-0.15l-0.97,0.81l-1.48,0.01l-0.38,-3.12l-1.08,-0.82l-2.27,-0.1l-1.64,-2.19l1.01,-0.88l-0.05,-0.94l-0.66,-0.55l-1.13,-0.17l-0.95,-0.78l-1.64,0.23l-1.35,-0.65l-1.78,0.03l-0.88,-0.67l-1.23,-0.02l-1.04,0.39l-0.1,0.51l0.54,0.67l-0.44,0.5l-2.03,-0.59l-3.33,2.12l-0.47,-0.28l-1.96,-0.1l-0.74,-0.62l-1.63,-0.42l0.73,-1.55l-0.08,-0.59l-0.45,-0.39l-1.25,-0.39l-1.26,0.33l-2.14,-0.64l-3.31,0.2l-1.25,1.04l-2.97,0.1l-0.77,0.67l-2.34,0.01l-0.9,0.65l-1.15,0.08l-0.32,-0.14l0.17,-0.4l-0.32,-0.89l-1.29,-0.66l-1.99,0.27l-1.33,-0.32l1.25,-1.3l0.06,-0.97l-0.62,-0.58l0.54,-1.19l0.03,-2.31l-1.85,-0.61l-0.4,-0.56l0.17,-0.61l-1.44,-1.54ZM263.08,158.39l1.43,0.44l-0.03,1.02l-0.6,0.12l-1.12,-0.68l0.32,-0.89ZM248.54,131.73l-0.03,0.04l-0.02,-0.03l0.05,-0.01ZM243.69,150.32l-0.03,0.0l-0.43,0.08l0.34,-0.16l0.12,0.08ZM301.05,106.05l1.76,-0.96l0.47,-0.85l1.32,-0.78l2.62,0.48l0.84,0.45l-2.78,1.54l-4.23,0.11ZM294.05,94.47l0.18,-0.25l0.84,-0.1l-0.05,0.32l-0.97,0.03ZM286.54,99.15l0.3,-0.5l2.02,-0.02l-0.27,1.42l-2.05,-0.9ZM264.71,98.19l0.65,-1.33l-0.48,-1.26l2.16,-0.78l2.5,-0.21l0.55,0.2l0.08,0.55l-0.79,1.25l0.4,0.54l1.46,0.12l1.03,-0.8l0.74,0.86l0.13,0.67l-1.37,-0.78l-0.62,0.37l-3.12,0.39l-1.12,0.53l-1.03,0.08l-0.59,-0.58l-0.59,0.17ZM249.52,133.3l0.38,-0.36l0.36,-0.11l-0.28,0.56l-0.46,-0.09Z",name:"Yamalo-Nenetskiy avtonomnyy okrug"},"RU-KGD":{path:"M2.08,255.68l2.51,-1.44l-0.38,-0.46l-1.58,0.07l-0.38,-0.3l-0.17,-0.89l2.51,-0.14l3.27,0.5l1.02,-0.51l-0.17,-1.7l0.47,-0.56l0.55,0.57l3.13,1.26l2.43,-0.3l0.26,0.65l1.04,0.77l-0.73,0.87l0.01,2.19l-13.81,-0.59Z",name:"Kaliningradskaya oblast"},"RU-MOW":{path:"M91.41,250.34l0.33,-0.83l-0.27,-0.48l0.77,0.0l0.39,-0.33l0.15,-0.91l0.86,-0.35l0.13,-1.61l0.72,-0.15l0.74,0.37l-0.01,0.9l-0.84,0.7l-0.35,1.15l-0.63,0.12l-0.27,0.43l0.05,1.01l-0.7,0.22l-0.36,0.5l-0.72,-0.75Z",name:"Moskva"},"RU-KAM":{path:"M714.94,244.35l1.6,-4.78l2.31,-1.75l0.52,-0.88l0.73,0.04l1.7,-2.89l-0.32,-2.02l-0.53,-0.69l0.33,-0.22l1.33,0.52l1.04,-0.1l0.84,-0.56l0.67,-1.22l1.29,0.27l1.33,-0.31l0.64,0.54l0.42,-0.26l-0.26,-0.77l0.55,-0.54l3.62,-2.48l0.75,-0.04l-0.08,-0.69l1.42,-1.0l1.27,-1.56l0.38,-1.61l2.72,-1.97l0.82,-1.47l1.84,-0.52l2.27,-1.95l1.04,-1.33l2.28,-1.37l0.34,-0.68l-0.1,-0.95l2.81,-1.55l1.36,-0.24l0.83,-0.87l0.69,0.07l0.77,-0.36l0.15,0.53l0.39,0.09l0.71,-0.89l1.76,-0.49l0.09,-0.88l-0.95,-0.43l0.4,-0.77l1.35,-0.69l0.59,-0.97l-0.25,-1.05l-0.88,-0.44l0.29,-0.89l0.61,-0.07l0.39,-0.43l0.4,-4.53l0.37,-0.36l0.87,-0.22l1.16,-0.88l2.27,0.49l1.26,0.64l0.31,-0.56l-0.37,-0.57l1.49,0.16l0.55,-0.24l0.09,-0.44l-0.37,-0.25l-2.77,-0.21l-1.71,-0.57l-1.03,-0.96l-0.8,-0.13l-2.3,0.34l-0.58,0.42l-2.48,0.2l-1.17,0.56l-0.48,0.69l-0.09,0.45l0.48,0.5l-0.91,0.91l0.27,1.67l-0.87,1.77l0.28,0.57l1.28,0.44l-0.99,0.62l-0.06,-0.61l-0.66,-0.51l-0.66,-0.02l-0.88,0.48l-0.18,-0.2l-0.03,-0.96l-0.52,-0.62l0.71,-0.29l0.18,-1.14l-0.33,-0.46l-0.88,-0.2l0.52,-0.34l1.11,-0.02l0.57,-0.44l0.25,-1.85l-0.35,-0.65l0.61,-1.08l-0.3,-0.44l-0.66,0.05l-0.69,-1.09l-1.21,-0.53l0.32,-0.92l1.06,-0.16l0.31,-0.43l0.8,-0.19l0.28,-0.87l-0.41,-0.78l1.21,-0.94l0.11,-1.38l-1.33,-1.4l0.71,-0.26l0.38,-0.81l-0.67,-1.61l1.64,-0.11l0.6,-1.14l1.17,-0.7l-0.59,-1.28l-0.83,-0.41l0.01,-0.5l0.41,-0.76l-0.25,-0.49l0.56,-0.13l0.83,-0.89l1.67,0.57l1.74,-0.51l2.88,1.26l0.69,0.78l1.09,-0.3l0.01,-1.11l0.8,0.01l0.47,0.74l1.65,0.04l0.62,1.39l0.57,0.36l2.5,-0.43l2.41,0.61l1.16,-0.17l0.91,-0.58l0.64,0.99l0.67,0.19l1.19,1.14l1.86,0.5l0.74,-0.06l0.39,-0.43l1.15,0.2l0.5,0.75l0.68,0.24l0.66,1.41l1.43,0.67l0.95,0.02l0.3,0.59l0.76,0.32l0.08,1.0l-0.33,0.55l-1.34,0.45l-2.22,1.81l-1.69,1.7l-0.17,0.55l0.47,0.48l2.22,0.92l0.98,-0.25l2.0,1.27l0.83,0.9l1.69,0.45l-0.21,0.52l0.32,0.96l1.44,1.57l0.89,-0.24l2.39,0.52l1.26,-0.36l0.45,-0.44l1.64,0.28l1.93,-0.56l0.93,-0.68l1.24,0.51l0.97,-0.29l2.09,0.87l0.43,-0.4l1.36,-0.17l1.59,-1.02l0.89,-0.06l0.79,0.71l0.95,-0.0l-0.42,1.03l0.66,1.88l1.14,0.11l0.51,0.47l0.03,0.58l-0.63,0.28l-0.74,-0.29l-0.68,0.25l-0.24,0.86l-0.49,0.26l-1.25,-0.61l-0.5,0.06l-0.58,1.5l-0.66,0.2l-0.3,0.7l-0.64,0.42l-0.92,-0.59l-0.71,0.05l-0.58,0.31l0.03,0.74l-0.47,0.23l0.26,0.56l-0.27,0.36l-1.28,-0.27l-0.35,0.7l-0.48,0.03l-0.04,0.61l-0.78,-0.34l-0.49,0.15l0.06,0.51l0.79,0.59l-0.73,-0.09l-0.45,0.37l-0.06,0.56l-0.83,-0.1l-1.05,0.35l-0.08,0.48l-0.71,-0.28l-0.35,1.3l-0.33,0.21l-1.54,0.54l-1.29,0.05l-0.07,0.7l-0.88,-0.19l-0.37,0.56l0.57,0.68l-0.63,0.4l-0.52,2.36l-0.41,0.17l-1.65,-1.6l0.57,-0.36l-0.19,-0.42l-1.01,-0.25l-0.44,-1.19l-1.7,-0.87l-0.28,-0.63l-0.58,-0.21l-0.88,0.41l-2.23,0.14l-0.84,-0.36l-1.15,0.01l-2.24,0.63l-0.62,-0.24l-0.83,0.81l-1.58,-0.05l-0.41,0.75l-0.94,-0.56l-0.36,0.37l0.07,0.54l-0.67,0.28l0.01,0.38l-3.23,3.14l-0.23,-0.16l0.36,-1.58l0.54,-0.53l-0.01,-1.42l0.63,-1.08l-0.29,-0.45l-2.08,0.35l-1.97,1.58l-0.65,0.21l-0.35,-0.29l-0.4,0.23l-0.1,0.53l-0.62,0.31l-0.44,-0.36l-1.23,0.7l0.15,0.64l0.74,0.41l-0.68,0.85l-0.55,0.2l-0.52,-1.18l-1.37,-1.16l-1.01,0.18l-0.33,0.38l0.07,0.49l-2.06,-0.61l-1.37,0.08l-0.3,0.48l0.28,0.62l-0.65,0.07l-0.79,0.57l-0.09,1.77l-1.05,0.52l-0.07,0.7l0.75,0.69l0.02,0.41l-1.04,0.24l-0.26,0.83l-0.76,0.25l-0.2,0.64l0.47,0.57l-0.65,0.65l-0.57,0.12l-0.26,0.74l-1.47,1.15l-1.26,1.95l-0.94,2.47l0.25,1.59l0.75,0.72l1.06,0.44l0.05,0.77l1.27,-0.52l0.18,-1.46l0.48,-0.05l2.79,1.4l-1.01,1.66l-1.36,0.72l-0.36,1.13l0.39,1.65l-0.32,0.89l0.07,1.47l1.17,0.57l1.21,-0.21l-0.03,1.08l-0.9,-0.42l-0.66,0.71l-0.99,-0.32l-1.64,0.77l-0.08,0.82l0.54,0.3l-2.46,1.34l-1.55,3.58l-0.16,1.77l0.36,1.55l1.62,2.29l-0.02,0.51l-1.79,1.59l-1.99,0.12l-0.91,-0.77l-2.27,0.47l-3.75,2.68l-0.89,1.52l-0.34,1.42l-0.05,0.82l0.41,0.85l-0.55,0.17l-0.04,0.66l0.67,0.99l-1.49,0.11l-2.31,0.88l-2.06,1.46l-0.67,-0.98l-1.16,0.35l-0.15,1.15l0.81,0.42l-0.5,0.57l0.47,0.56l-0.62,-0.15l-0.23,0.46l0.5,0.88l-0.38,0.48l0.14,0.67l0.27,0.02l-1.02,1.39l-0.23,1.18l-1.88,2.13l-1.89,1.08l-0.45,0.86l-2.98,2.37l-0.39,-1.22l-0.87,-0.57l-0.19,-4.47l-0.6,-3.17l0.38,-0.57l-0.15,-0.46l-0.82,-0.45l-0.78,-2.28l-0.92,-6.61l-1.71,-7.48l-0.29,-3.34l0.69,-4.93ZM751.55,242.94l0.43,-0.62l1.66,-0.86l0.26,-0.56l0.47,2.1l-1.1,0.5l-0.35,0.59l-0.7,-0.29l-0.67,-0.85ZM768.53,249.68l0.99,0.28l0.15,1.06l1.45,1.71l-1.07,-0.69l-1.52,-2.36ZM771.58,253.07l0.09,0.09l-0.01,0.1l-0.0,-0.0l-0.07,-0.19ZM756.8,224.34l0.01,-0.01l0.1,-0.1l-0.08,0.1l-0.03,0.01ZM757.11,223.99l0.27,-1.05l0.64,-0.88l1.81,-0.69l1.06,-0.81l0.68,1.15l-0.25,0.82l-2.38,0.34l-1.82,1.12Z",name:"Kamchatskiy kray"},"RU-BU":{path:"M415.56,270.95l-0.04,-0.39l0.81,-0.79l-0.06,-0.46l0.66,-0.54l-0.24,-1.45l1.45,0.4l1.05,-1.82l1.49,-0.16l1.12,-0.63l0.02,-0.56l1.46,-0.31l0.5,0.55l-0.06,0.81l1.33,1.42l1.47,1.09l2.95,1.19l2.73,2.85l0.75,0.14l0.56,-0.44l1.71,0.3l1.21,1.61l2.19,1.22l-0.14,1.26l0.91,1.4l1.56,-0.2l0.85,0.32l-0.02,1.68l0.45,0.4l2.14,-1.04l2.31,-0.06l0.39,-0.75l-0.17,-1.63l4.12,-1.66l1.63,-1.26l2.3,-2.83l9.9,-5.58l1.89,-4.11l3.27,-5.12l-0.24,-0.54l-1.85,-0.41l0.64,-2.38l-0.37,-0.85l0.48,-0.96l-0.03,-0.55l-0.62,-0.67l-0.1,-0.9l0.68,-1.11l0.35,-1.61l0.47,-0.44l1.19,0.16l0.54,-0.85l-0.3,-0.5l-1.16,-0.24l-1.04,-1.58l-1.06,-0.24l0.79,-1.53l1.44,-0.26l0.36,-0.36l0.96,-0.01l0.49,-0.48l1.96,0.2l0.77,-0.73l0.09,-0.91l0.57,-0.37l1.54,0.35l1.13,0.71l0.97,-0.26l2.21,0.38l1.27,-0.73l0.22,-1.02l0.44,-0.44l0.16,0.59l1.13,0.88l1.57,-0.25l0.62,0.48l1.26,0.13l0.94,-0.62l0.26,1.16l0.99,0.71l2.55,0.52l0.91,-0.35l2.01,1.1l0.75,-0.2l0.67,-0.98l1.44,0.22l1.95,-0.42l0.5,-1.14l1.01,-1.14l0.11,-0.74l1.67,0.12l1.44,-0.33l0.83,-0.76l1.18,0.08l-1.82,0.76l-1.1,0.85l-0.14,1.35l-0.76,0.4l-0.11,0.66l0.5,0.5l0.77,0.1l0.22,0.64l-0.15,1.2l0.51,1.02l-0.08,0.93l0.66,0.82l-0.28,1.7l0.58,2.36l1.11,0.42l1.33,-0.16l0.39,0.98l1.67,0.94l0.57,1.7l-1.01,1.85l-0.94,0.23l-1.57,-0.16l-3.02,0.72l-0.68,0.37l-0.18,0.5l-1.59,0.85l-1.52,1.58l-1.37,0.32l-0.62,0.7l-0.72,0.07l-0.21,0.33l-1.72,0.31l-1.04,0.77l-0.19,0.62l0.44,0.49l-0.21,1.21l0.55,0.4l0.27,0.78l0.83,0.36l-0.05,0.79l0.72,0.15l-0.86,1.93l-2.5,1.48l-1.72,0.03l-1.72,0.96l-1.98,-0.06l-0.79,0.92l-1.13,-0.58l-0.73,0.18l-2.14,2.22l-3.21,1.21l-1.16,0.94l-0.08,0.51l-0.57,0.5l-3.37,-0.75l-2.21,1.16l-1.76,0.52l-0.86,-0.9l-0.89,0.42l-2.03,-0.39l-1.42,1.9l0.15,0.49l0.9,0.6l-0.99,0.23l-0.57,1.46l-0.99,0.8l0.56,0.92l1.85,0.8l-2.78,1.07l-1.15,1.27l0.03,0.99l-2.53,-0.2l-1.16,-1.31l-1.72,-0.92l-2.29,0.23l-1.27,-0.74l-3.43,-0.53l-1.38,0.6l-3.65,0.61l-1.49,1.04l-1.66,-0.27l-0.89,0.36l-1.57,-0.4l-0.53,-0.72l-1.41,-0.04l-1.58,-0.65l-0.7,-0.82l-0.79,-0.19l0.17,-1.02l-0.59,-0.58l0.12,-1.05l-0.44,-0.88l0.22,-1.53l-0.81,-0.67l-2.99,-0.74l-0.9,0.17l-4.33,-1.89l-3.11,-0.16l-1.14,-0.93l-2.03,-0.38l-1.58,-0.79l-0.35,-0.94l-1.22,-0.78Z",name:"Buryatiya, Respublika"},"RU-KEM":{path:"M341.23,245.3l0.12,-1.07l1.58,-0.54l0.95,0.17l0.79,-0.69l0.74,0.22l1.62,-0.19l0.34,-0.5l-0.14,-0.31l0.54,-0.18l0.2,-0.49l1.44,-0.48l0.61,-0.92l0.74,0.57l1.5,-0.61l1.8,0.7l0.83,-0.15l0.34,-0.76l0.76,0.33l0.68,-0.29l1.46,0.79l3.18,-2.05l0.85,0.25l0.18,0.36l-0.67,0.09l-0.28,0.41l0.14,0.7l0.4,0.25l-0.07,0.46l0.85,0.71l1.59,0.6l-0.0,0.45l1.08,1.09l0.62,1.46l-3.52,2.12l-1.68,2.07l0.89,2.16l1.0,1.19l-0.59,0.33l-0.4,2.12l-0.85,0.35l-0.06,0.56l1.25,0.9l1.52,-0.9l0.62,0.81l0.74,-0.26l0.11,0.31l-1.14,1.22l1.14,1.68l-0.78,0.32l-0.21,0.65l-0.85,0.59l0.08,0.86l-0.54,1.0l0.4,0.45l0.63,-0.21l0.42,0.56l-0.03,0.76l-0.62,0.61l-0.06,0.64l1.11,0.47l0.46,0.65l-0.82,0.6l0.24,0.7l-0.19,0.27l-1.95,1.44l0.01,0.6l-0.86,0.42l0.32,-1.45l-0.35,-0.47l-1.16,0.25l-1.58,-0.92l-1.37,0.61l-1.12,-0.3l-0.34,-0.61l-0.61,0.01l-0.12,-0.66l-1.04,-0.77l0.55,-1.24l-0.06,-0.64l-0.91,-0.18l-0.72,-0.54l1.21,-1.2l0.07,-1.15l-1.37,0.09l-0.99,-0.37l-0.74,-0.91l-0.15,-0.79l-1.36,-1.53l-1.1,-0.43l-1.78,-1.39l-0.86,0.13l-1.33,-1.85l-0.6,-0.12l-0.28,-0.4l0.3,-0.33l-0.19,-0.7l0.37,-1.16l-0.9,-0.83l0.09,-1.25l-0.38,-0.51l0.18,-1.02l-0.59,-0.53l-0.2,-1.41l-0.61,-0.58l-0.06,-1.02l-0.42,-0.26Z",name:"Kemerovskaya oblast"},"RU-CHU":{path:"M725.55,150.92l0.45,-1.07l1.51,-0.02l1.2,-0.39l0.11,-0.41l-0.44,-0.85l-0.99,-0.24l0.64,-0.39l0.33,-0.98l0.68,-0.29l2.66,-0.29l3.2,-0.85l1.15,0.27l0.52,-0.62l5.89,-0.21l2.13,-1.0l5.28,0.93l0.85,-0.47l0.46,-1.6l0.73,-1.0l-0.65,-1.35l0.62,-0.14l0.67,-0.93l-0.59,-0.91l-1.01,-0.51l-0.13,-0.63l1.13,-0.52l0.25,-0.52l-1.38,-1.26l-0.98,-1.78l0.58,-0.98l1.4,0.22l2.05,-0.61l3.18,0.24l1.33,-0.73l2.02,1.4l2.11,0.5l4.42,-0.26l2.08,0.66l2.92,-0.08l0.35,0.35l1.13,0.0l4.25,-2.6l0.45,-0.01l0.5,0.39l-0.05,0.64l1.58,0.84l-0.26,1.62l0.56,1.35l3.1,0.6l2.58,0.94l0.35,1.94l0.52,0.59l0.82,0.33l3.7,-0.45l1.35,0.69l0.49,-0.14l-0.55,-1.19l0.56,0.63l0.59,-0.37l-0.08,-0.81l1.09,-0.74l0.91,-0.0l0.34,-0.46l-0.78,-0.41l-0.51,-1.0l-0.05,-1.19l-0.84,-0.86l-0.81,-1.85l-0.79,-0.27l-1.35,0.2l0.41,-0.46l1.55,-0.51l0.02,-3.22l7.12,1.13l3.75,0.12l0.59,0.65l1.53,0.52l0.47,0.68l1.65,-0.43l0.18,-0.66l-0.32,-0.37l1.34,0.81l0.31,-0.22l0.88,0.23l0.56,-0.33l5.32,0.38l2.13,-0.25l2.23,0.9l1.43,-0.16l1.51,0.34l1.18,0.72l3.4,0.58l4.47,1.61l0.8,-0.4l1.36,0.42l-0.15,0.66l0.31,0.63l3.12,0.26l1.46,1.09l-0.02,0.42l1.2,1.09l1.32,0.12l1.51,0.58l1.19,-0.01l0.82,0.97l2.4,0.51l0.46,0.35l0.01,0.96l0.35,0.62l3.34,1.02l0.17,0.52l-0.48,0.63l0.26,0.41l0.69,0.02l0.92,-0.61l-0.12,0.48l0.91,0.71l1.49,-0.46l0.72,0.96l0.87,-0.12l1.23,0.64l-0.16,0.78l1.54,0.9l2.13,0.0l-0.23,0.71l-1.09,0.49l0.84,1.0l1.37,0.16l0.33,0.42l1.37,-0.0l0.35,-0.71l-1.02,-0.66l0.07,-0.48l2.12,1.0l0.57,1.52l-0.82,0.62l0.14,0.74l1.18,0.21l1.14,-0.58l0.46,0.22l-0.49,0.9l-0.15,1.37l1.07,2.53l-1.1,0.57l-0.29,0.58l1.08,0.96l1.77,0.48l-0.19,0.92l0.3,1.37l0.95,-0.06l1.26,-1.57l0.21,0.5l-0.44,1.15l0.44,0.51l1.93,-1.41l0.21,-0.87l-0.27,-0.42l-0.74,-0.58l-1.23,-0.22l0.98,-0.73l0.01,-0.92l-0.52,-1.89l-0.85,-0.52l1.88,0.06l0.75,-0.27l0.87,0.65l0.58,-0.37l-0.3,1.72l0.56,0.49l1.18,-0.18l0.14,-0.72l1.91,0.35l1.58,-0.33l0.26,-0.47l3.01,0.21l0.06,0.66l1.48,0.86l0.28,0.85l2.65,1.46l1.72,1.42l-0.78,0.33l0.24,0.62l0.87,0.17l1.13,-0.58l0.35,0.17l-0.96,0.22l0.19,0.49l0.6,0.33l2.0,-0.1l0.75,0.43l-1.44,-0.11l-3.4,1.62l0.26,2.12l-1.2,-0.14l-1.41,-0.62l-1.77,-1.2l-0.52,0.43l0.57,1.16l0.74,0.7l0.96,0.19l0.31,0.31l-0.11,0.32l-0.96,-0.44l-2.38,0.27l-1.89,-0.64l-0.47,0.16l-0.38,-0.85l-0.83,-0.31l-2.81,-0.02l0.18,0.73l2.21,0.8l-0.2,0.77l0.44,0.62l0.83,0.14l-0.07,0.56l-2.39,-0.02l-0.22,0.75l1.03,0.53l1.41,-0.05l-0.08,0.49l0.43,0.57l-2.85,1.3l-1.33,-0.05l-0.81,0.75l-0.24,0.55l0.44,0.27l1.57,-0.42l-1.07,0.42l-0.33,0.52l0.74,1.09l-0.35,0.15l-0.13,0.64l0.94,0.21l-1.13,0.95l-0.98,-0.37l0.5,-0.77l-0.13,-1.0l-0.72,-0.86l-0.43,-0.13l-0.28,0.35l0.23,1.64l-0.88,0.4l-1.73,-0.64l-0.22,-0.89l-1.4,-0.77l0.01,-0.39l-1.7,-0.48l0.29,-0.63l-0.65,-0.98l-0.58,0.21l-0.12,0.58l-0.82,-0.47l-0.43,0.14l-0.24,0.71l-1.25,-0.14l-0.01,-0.38l-2.14,-0.96l0.17,-1.76l-0.65,-0.71l-0.2,-1.3l-0.93,-0.65l-4.93,-1.36l-1.31,0.38l-1.25,1.04l-5.17,-0.24l0.46,-1.54l-0.15,-0.42l-0.58,-0.52l-0.6,0.14l-1.16,-1.19l0.7,-0.29l0.39,-0.9l0.85,-0.43l0.22,-2.46l-0.47,-0.32l-0.51,0.2l-1.29,1.72l-0.37,0.1l-0.72,-0.55l0.15,-0.49l-0.33,-0.91l-0.74,-0.27l-0.23,0.92l-0.77,-0.37l-0.49,0.53l0.95,1.3l-1.01,0.14l-0.73,-0.58l-0.46,0.04l-0.9,2.33l0.51,1.62l2.23,1.4l0.11,0.65l-1.02,0.88l-0.24,1.47l-0.51,0.59l-2.96,1.12l-1.56,1.64l-1.2,0.11l-2.18,1.12l-0.66,-0.22l-1.86,0.29l-1.61,-0.12l-1.76,-0.36l-0.7,-0.73l-0.27,-0.9l-1.1,-0.24l-0.5,-0.74l-1.31,-0.47l-1.76,0.43l-1.04,-0.5l-0.87,0.55l0.25,0.59l1.33,0.42l2.0,-0.4l1.4,1.37l-0.68,0.13l-0.74,-0.52l-1.44,-0.24l-0.77,0.42l-2.47,-1.21l-1.67,1.39l-3.55,0.16l-1.57,0.77l-1.47,-0.05l-0.39,0.27l0.48,0.67l1.66,-0.03l1.75,-0.71l3.24,-0.1l1.77,-1.23l1.29,1.36l-1.21,0.53l-0.26,0.74l0.21,0.49l2.18,-1.17l1.55,0.97l1.29,-1.19l1.95,-0.51l-0.53,1.83l0.38,0.84l1.01,0.96l2.3,1.15l0.97,0.04l0.52,-0.99l0.74,1.46l-0.49,0.44l-0.11,0.64l0.39,0.42l1.25,0.19l0.26,1.56l-1.9,0.37l-0.55,0.46l-0.03,0.53l0.82,0.61l0.88,-0.44l0.69,0.1l-0.63,0.67l0.16,0.57l3.73,1.67l0.35,0.41l-0.78,0.48l-0.08,0.69l0.52,0.9l1.02,0.3l0.32,0.92l-0.22,0.37l-0.66,0.31l-0.23,0.67l-1.19,0.19l-0.27,0.42l0.11,0.83l-5.18,-1.75l-3.63,-0.33l0.11,-0.76l0.65,-0.58l-0.1,-0.48l-0.89,-0.07l-0.59,0.48l-1.23,-0.96l-0.47,0.51l0.24,0.71l-0.49,0.76l0.52,0.73l-1.01,0.27l-0.6,-0.22l-2.09,1.8l-4.48,1.6l-1.06,-0.22l-0.26,1.02l-1.7,0.55l-1.09,-0.28l-0.36,0.49l-0.93,-1.32l-0.86,0.16l-0.55,-1.35l0.38,-0.39l-0.1,-1.1l-1.23,-0.23l-0.37,-0.51l-0.73,-0.21l-1.22,0.03l-1.79,1.07l-1.29,0.06l-0.39,0.32l-1.6,-0.71l-1.05,0.27l-1.37,-0.5l-3.03,1.25l-1.33,-0.45l-1.06,0.23l-0.29,0.46l-0.64,0.2l-2.16,-0.45l-0.66,0.23l-1.13,-1.86l0.37,-0.8l-0.21,-0.36l-1.39,-0.03l-0.84,-0.38l-0.66,-0.79l-2.19,-1.39l-1.15,0.19l-1.8,-0.74l0.98,-0.58l0.51,-0.94l2.0,-1.72l1.65,-0.58l0.58,-0.95l-0.37,-1.57l-0.86,-0.48l-0.29,-0.71l-1.35,-0.08l-1.06,-0.49l-0.49,-1.35l-0.89,-0.32l-0.66,-0.86l-1.58,-0.3l-1.06,0.51l-0.99,-0.5l-0.6,0.05l-0.99,-1.11l-0.59,-0.08l-0.84,-1.16l-2.48,0.7l-2.32,-0.58l-1.07,-0.02l-1.02,0.4l-1.2,-1.55l-1.65,-0.15l-0.68,-0.74l-1.56,0.09l-0.32,1.29l-0.46,-0.66l-3.5,-1.46l-1.61,0.58l-2.04,-0.51l-0.87,0.93l-1.35,0.28l-0.24,1.13l-1.36,-0.08l-0.9,-0.71l-1.41,0.02l-2.42,-0.66l-0.55,-1.35l-2.28,-1.35l-1.52,-0.28l-2.39,0.08l-1.67,-1.6l-0.12,-0.77l-0.87,-0.64l-1.07,-0.14l-4.55,-1.76l0.08,-0.87l1.41,-2.3l-0.03,-0.77l-0.43,-0.41l-1.99,-0.42l-1.63,-1.01l1.4,-2.19l1.11,-0.78l-0.59,-1.37l0.07,-0.53l-0.74,-0.91l-1.84,-0.57l-2.46,-1.3l-0.21,-0.32l0.43,-1.0l-0.91,-0.88ZM813.52,198.5l0.18,0.28l0.27,0.19l-0.19,0.07l-0.26,-0.54ZM879.95,177.08l1.53,0.23l0.4,0.59l-0.67,0.22l-1.25,-1.05ZM878.46,156.73l-0.01,-0.0l-0.0,-0.0l0.0,-0.0l0.0,0.0ZM881.71,175.34l0.43,-0.33l0.73,0.17l-0.69,0.2l-0.46,-0.04ZM836.19,120.37l-0.81,-1.8l1.26,-1.45l3.41,-2.07l3.56,-1.27l2.22,0.26l1.26,-0.42l3.42,0.55l1.69,0.71l0.19,0.58l2.79,1.38l-2.17,1.37l-4.93,0.58l-2.15,0.63l-3.75,-0.74l-1.81,1.12l-2.73,-0.04l-1.44,0.59ZM778.49,129.97l2.18,-1.27l5.74,1.42l-0.85,0.44l0.1,1.08l-0.26,0.39l-1.57,0.12l-3.53,-1.14l-0.7,-0.67l-1.11,-0.36Z",name:"Chukotskiy avtonomnyy okrug"},"RU-ULY":{path:"M138.43,258.73l0.43,-0.55l1.8,-0.29l2.1,-0.96l0.04,-0.65l-0.83,-0.43l-0.29,-1.42l1.35,0.58l1.12,-0.42l0.94,0.17l0.74,1.18l1.31,-0.34l0.68,-0.89l0.84,0.12l0.81,-0.67l2.06,0.84l1.85,-0.11l1.15,-1.08l1.3,-0.47l0.65,0.47l0.7,1.64l2.57,0.38l0.77,1.25l-0.21,1.52l-1.19,0.62l-0.16,0.46l-1.23,0.32l-1.18,-0.28l-2.03,0.08l-1.06,1.0l-2.15,-0.28l-0.14,0.68l-0.5,0.01l-0.29,0.36l0.28,1.06l-1.38,-0.09l-0.88,1.18l0.81,0.97l0.39,0.8l-0.08,0.62l0.43,0.49l1.83,0.48l-0.45,0.36l-1.87,-0.03l-1.47,0.58l-0.49,0.8l-0.73,-0.13l-0.73,0.32l-1.43,-0.26l-0.47,0.2l-0.53,-0.39l0.5,-0.72l-0.33,-1.43l0.29,-1.39l-0.38,-1.24l-1.35,-1.17l-0.71,-0.08l-0.16,-0.97l-1.4,-1.37l-0.12,-0.69l-1.5,-0.73Z",name:"Ulyanovskaya oblast"},"RU-KGN":{path:"M222.84,252.06l1.04,0.19l0.52,-1.26l-0.28,-0.85l-0.41,-0.28l0.91,-0.72l0.67,-0.02l0.78,-0.87l-0.38,-0.65l-0.04,-1.33l-0.94,-0.83l-0.11,-0.87l-0.97,-0.77l-0.3,-0.73l1.26,-1.67l0.74,-0.58l0.4,0.41l0.58,-0.03l1.48,-0.69l1.31,0.17l0.62,0.45l0.77,-0.76l0.29,0.4l1.38,0.52l1.94,0.17l0.53,-0.36l0.03,-0.63l0.65,-0.59l0.04,-0.57l2.06,-0.57l0.49,0.65l-0.09,1.64l0.62,0.43l0.55,1.27l2.53,0.15l1.05,1.47l1.05,0.66l1.07,-0.56l1.12,0.84l1.51,-0.63l0.47,0.57l2.19,0.04l1.04,1.61l2.02,0.15l0.56,0.4l1.04,-0.26l0.14,0.77l0.63,0.24l0.96,1.11l0.91,0.15l-0.35,0.62l-2.07,0.23l0.14,1.14l-0.27,0.41l-1.35,-0.12l-1.04,0.77l-1.99,0.05l-0.57,0.46l-6.03,1.22l-0.19,-0.43l-0.44,-0.11l-1.03,0.73l-1.34,-0.23l-0.46,0.5l-1.19,0.45l-0.19,1.37l-0.91,-0.65l-1.19,0.47l-0.88,-0.32l-3.05,0.5l-0.43,0.78l-0.87,-0.35l-1.57,0.44l-0.66,-0.45l-0.34,-0.37l0.79,-1.36l-0.86,-1.4l-1.64,-0.08l-0.9,0.44l-0.94,-0.68l-0.78,0.05l-0.62,0.48l-0.68,-0.14l0.2,-0.79l-0.76,-1.03Z",name:"Kurganskaya oblast"},"RU-KRS":{path:"M76.69,275.94l1.33,-0.42l-0.04,-0.97l0.27,-0.38l-0.32,-0.53l1.46,-0.42l1.3,-1.77l2.14,-0.22l0.34,-0.27l0.58,0.26l-0.04,0.57l0.4,0.25l3.64,-0.86l0.72,0.87l1.82,0.89l1.68,0.32l1.24,1.02l0.89,-0.56l0.97,0.21l0.81,0.65l2.07,-0.36l0.42,0.33l-0.11,0.58l-0.79,-0.04l-0.56,0.83l0.68,0.97l0.08,0.88l-0.84,-0.75l-1.28,0.02l-0.74,0.36l-1.65,-0.12l-0.65,0.39l-0.58,-0.07l-0.89,1.03l-1.83,0.7l-3.35,-0.47l-0.89,1.38l-1.16,0.21l-0.75,-0.23l-0.33,-0.54l-0.83,-0.02l-0.53,-1.15l-2.1,0.27l-0.45,-0.47l-1.26,-0.16l-0.85,-2.24Z",name:"Kurskaya oblast"},"RU-KR":{path:"M51.86,159.49l8.28,-0.46l2.41,0.24l0.24,0.74l0.9,0.54l0.23,1.05l0.63,0.3l2.45,-0.08l0.33,-0.98l0.86,-0.25l0.2,-0.67l1.2,-0.02l0.6,0.64l1.25,-0.18l1.4,0.59l-1.17,0.62l-0.1,0.43l0.37,0.25l1.41,-0.09l1.43,0.76l1.19,-0.08l0.18,0.46l1.79,0.63l0.87,0.78l0.19,1.02l0.57,0.03l-0.01,0.31l-0.76,0.14l0.26,2.21l-0.38,0.52l-1.82,0.69l0.22,0.68l0.58,0.09l0.11,0.63l0.89,0.56l-0.1,0.4l0.59,0.65l-0.22,0.54l1.03,1.36l-0.6,0.25l-0.04,0.67l0.77,0.94l-0.78,0.23l-0.21,0.45l1.26,0.6l0.3,0.74l1.48,0.47l0.44,0.68l0.61,0.04l1.2,-0.64l0.53,0.19l0.7,1.05l0.79,0.1l0.43,0.4l0.37,1.06l1.13,0.43l0.25,1.36l-0.32,0.52l-3.03,0.49l-0.29,0.59l1.0,1.19l0.94,0.43l0.5,1.69l-0.32,1.45l1.42,1.82l1.46,0.93l1.8,0.54l1.39,-0.25l0.54,0.21l0.34,1.33l-0.8,2.08l0.42,0.31l1.21,-0.03l0.34,1.41l0.65,0.65l-0.3,1.36l-0.57,0.51l-0.02,0.83l-1.85,0.12l-1.83,-0.73l-0.79,0.43l-1.2,-0.08l-1.01,1.23l-5.2,1.89l0.01,-0.61l-0.36,-0.36l-0.64,0.22l-2.11,-0.18l-0.47,-0.34l-1.31,0.47l-0.6,0.57l-0.9,-0.41l-3.58,0.17l-0.85,0.8l0.11,0.53l0.58,0.46l-0.71,0.08l-0.18,0.56l-1.22,0.73l-0.21,0.69l-0.83,0.1l-0.95,0.62l-14.86,-4.2l-1.51,0.03l-0.82,-0.65l-0.17,-0.18l0.82,-0.92l1.36,-0.94l4.56,-4.84l1.45,-0.89l1.68,-1.65l1.78,-3.37l-0.36,-1.01l-1.25,-1.07l-0.39,-1.0l-2.1,-1.4l-1.76,-0.73l-2.17,-1.79l0.8,-0.29l1.64,-1.69l0.48,-1.18l-0.35,-1.4l-2.5,-1.2l0.16,-0.45l-0.5,-0.71l0.82,-0.35l0.3,-0.55l-0.52,-1.31l-1.83,-0.28l-0.78,-1.33l0.15,-0.32l0.93,-0.22l0.27,-0.45l-0.36,-1.18l-0.73,-0.12l0.41,-0.49l0.02,-1.33l0.55,-0.56l-0.19,-0.63l1.49,-0.08l0.21,-0.6l-1.19,-3.81l-1.32,-1.59l-0.61,-1.68l-0.58,-0.7ZM73.29,206.0l0.82,-0.4l0.3,0.05l-0.28,0.55l-0.83,-0.2ZM83.89,172.32l0.33,-0.02l0.27,-0.15l0.15,-0.0l-0.08,0.41l-0.67,-0.23Z",name:"Kareliya, Respublika"},"RU-ME":{path:"M137.09,240.73l0.26,-0.42l1.15,-0.38l0.15,-1.45l1.95,-0.59l3.64,0.15l-0.09,0.47l0.54,0.37l1.84,-0.3l1.02,-1.16l1.47,0.21l0.97,-0.21l0.77,-1.07l0.65,0.17l1.6,-0.34l0.29,0.53l0.73,0.13l0.7,-0.77l0.93,1.08l0.92,0.12l1.08,-0.35l0.35,1.24l1.51,0.34l0.3,1.85l-0.87,0.18l-0.42,-0.36l-0.89,0.03l-0.67,0.5l-0.61,-0.11l-0.38,0.88l-0.46,-0.29l-0.87,0.06l-1.05,1.22l0.2,0.59l-0.62,0.56l-0.73,0.07l-0.13,0.87l-1.18,0.28l-0.35,0.46l-1.45,-0.72l-0.81,-1.46l-2.03,-0.24l-0.28,-0.98l-0.38,-0.27l-1.91,0.39l-1.76,1.2l-0.86,-0.14l-1.78,0.69l-0.2,-0.66l-0.9,-0.59l0.25,-0.31l-0.09,-1.2l-1.5,-0.33ZM154.88,235.25l-0.01,-0.02l0.01,-0.01l-0.0,0.02l-0.0,0.01Z",name:"Mariy El, Respublika"},"RU-IN":{path:"M131.12,330.57l0.03,-0.27l0.9,-0.22l1.23,0.52l0.52,2.01l-0.03,2.02l-0.33,0.3l-0.53,-0.31l0.5,-0.75l-0.15,-1.02l-1.75,-1.42l-0.09,-0.7l-0.31,-0.18ZM132.15,334.87l-0.09,0.16l-0.32,-0.29l0.16,0.09l0.24,0.04Z",name:"Ingushetiya, Respublika"},"RU-MAG":{path:"M658.25,197.25l1.46,-1.19l0.02,-1.66l0.84,-0.03l0.77,-0.61l-0.79,-1.93l0.19,-1.22l-0.59,-2.22l1.01,-2.62l1.01,-1.23l-0.13,-1.23l2.79,-1.12l0.87,-1.0l0.28,-0.93l2.78,0.53l1.46,0.81l0.72,-0.32l0.13,-0.45l0.75,-0.15l0.06,0.97l1.11,0.82l0.89,0.05l0.71,-0.46l1.14,-1.7l0.15,-1.01l-1.05,-0.89l1.05,-1.05l1.43,1.09l2.53,-0.16l0.83,0.27l0.46,-0.33l0.67,0.07l1.08,-0.88l0.77,-0.2l1.11,0.47l-0.33,1.04l1.02,1.32l2.35,0.56l0.58,-0.32l0.07,-1.08l1.29,0.02l1.04,-0.37l1.31,0.66l0.55,-1.19l2.7,-0.55l0.2,1.14l1.81,-0.25l0.36,-0.65l-0.27,-0.6l2.03,-1.43l-1.22,-2.32l0.75,-0.74l-0.24,-0.98l0.39,-0.42l2.0,-0.3l1.99,-0.91l0.43,-0.7l-0.6,-0.77l0.63,-1.68l-0.31,-0.88l2.18,-0.34l0.41,0.7l0.4,0.09l0.93,-0.38l0.86,-1.17l-0.1,-0.98l-0.36,-0.42l0.85,-0.89l1.73,0.88l1.64,-0.64l0.61,0.56l2.44,-0.27l0.94,0.67l2.04,0.31l1.57,-1.11l1.29,1.15l0.01,0.68l1.37,0.58l1.51,-0.15l0.27,-0.72l1.39,-0.84l2.09,-0.37l2.02,0.29l0.21,-0.51l-0.47,-0.95l0.68,-0.6l0.83,0.63l1.96,0.42l-1.41,2.41l-0.23,1.21l0.27,0.56l4.92,1.93l0.95,0.09l0.62,0.44l0.23,0.9l1.82,1.7l2.69,-0.01l1.6,0.35l0.33,0.44l1.39,0.61l0.75,1.5l2.66,0.74l1.29,-0.05l1.03,0.74l1.87,-0.01l0.16,0.83l1.07,0.8l-1.09,1.55l-1.28,0.01l-0.8,0.63l0.25,1.39l0.42,0.3l-0.93,0.79l-0.11,0.64l0.24,0.66l1.04,0.92l-0.02,0.75l-1.47,0.93l0.53,1.39l-1.83,0.55l-0.71,0.66l-0.06,1.59l1.53,0.73l0.24,0.64l0.73,0.57l-0.37,0.59l0.36,1.56l-0.14,0.63l-1.43,0.12l-1.54,0.76l0.29,0.72l1.66,0.67l-0.89,0.28l-0.31,0.47l0.82,1.81l-2.04,2.15l-0.45,-0.2l-0.53,0.22l-0.47,0.85l-1.57,0.84l-0.38,0.68l-2.73,1.96l-0.42,0.91l-1.93,-0.0l-0.35,0.3l-0.15,-0.51l1.08,-1.47l-0.3,-0.66l-1.42,0.01l-0.81,0.38l0.28,-0.67l-0.33,-0.82l0.31,-0.33l-0.2,-0.43l0.73,-0.65l0.03,-0.44l0.8,-0.46l0.32,-1.38l0.38,-0.34l-0.05,-1.49l-0.69,-0.66l-1.65,0.81l-0.94,1.15l-1.13,0.19l-0.13,-1.12l-0.59,0.15l-0.36,-0.7l-1.53,-0.28l-1.21,0.15l-0.57,0.61l-2.73,-0.03l-1.18,0.75l-2.68,-0.47l-1.18,0.77l-1.51,0.38l-0.7,0.86l-1.35,0.3l-0.32,2.35l-1.16,0.55l-2.32,1.84l-0.33,1.45l-5.6,3.51l-1.18,1.48l-0.95,0.35l-0.16,0.51l0.29,0.67l-1.13,0.35l-0.01,1.66l-0.85,1.27l0.35,0.79l2.28,0.56l0.42,-0.19l-0.01,-0.64l0.27,-0.11l0.75,0.47l0.88,-0.04l0.87,0.68l-0.05,0.75l-1.45,-0.03l-0.55,0.39l-1.51,-0.57l-0.59,0.19l-0.29,0.78l-1.17,0.28l-1.63,-1.44l-0.52,0.3l-1.31,-0.3l-0.92,1.17l-1.4,0.43l-0.5,0.85l-1.29,-0.17l-1.34,-0.86l-1.77,1.41l-3.18,0.18l-0.75,-1.12l1.03,-0.52l1.54,0.25l1.97,-0.17l1.08,-0.39l0.28,-0.68l-1.13,-0.77l-0.89,0.19l-0.94,-0.25l-0.64,-1.28l-1.45,-1.07l-0.69,0.33l-1.29,-0.14l-1.12,0.45l-0.35,-0.33l-1.15,0.06l-0.34,-0.44l-2.4,-0.69l-3.52,-0.55l-0.38,0.54l-1.49,0.52l-0.15,0.67l0.38,0.55l-0.59,0.07l-0.34,-0.65l-0.72,0.47l-0.42,1.22l0.57,0.64l-1.32,-0.02l-0.5,-0.97l-0.93,-0.23l-2.14,0.26l-0.44,0.33l-0.01,0.52l-0.64,-0.32l-0.67,0.42l-0.97,-0.59l-0.73,0.04l0.37,-2.09l-0.35,-2.16l-0.8,-0.62l-1.05,0.22l-0.34,-0.33l-0.11,-1.0l-1.0,-0.32l-0.61,-1.03l-3.27,0.41l-0.65,-0.51l0.11,-0.73l-0.56,-0.35l2.72,-1.79l0.98,0.6l0.8,-0.12l0.52,-0.7l0.02,-1.52l0.72,0.04l0.42,-0.32l0.29,-2.21l-0.34,-0.65l0.4,-1.01l-0.71,-0.28l-0.28,-1.63l-0.68,-0.51l-0.66,-1.18l-2.48,-1.62l-1.14,-0.31l-1.22,0.82l-0.95,-0.27l-0.57,0.21l-1.14,-0.77ZM689.04,217.87l0.02,0.05l0.08,0.09l-0.16,-0.06l0.06,-0.07Z",name:"Magadanskaya oblast"},"RU-MO":{path:"M120.4,257.16l0.91,-0.71l-0.19,-0.51l0.53,-1.02l-0.46,-1.15l2.13,0.09l0.59,-0.91l0.9,-0.27l2.52,1.06l1.07,1.07l2.43,0.91l0.28,0.41l1.01,-0.32l0.76,0.32l1.17,-0.16l0.4,-0.4l-0.45,-0.76l0.17,-0.53l-0.23,-0.32l0.58,0.13l0.45,-0.88l0.77,-0.08l0.26,-1.31l0.63,-0.28l0.21,-0.47l-0.32,0.86l0.3,0.55l2.05,-0.34l1.45,0.75l0.38,1.67l-0.23,0.52l0.58,1.33l0.42,0.25l-3.11,0.87l-1.58,1.74l-1.57,0.29l-0.74,-0.56l-1.78,-0.0l-1.54,0.58l-0.26,0.39l0.08,1.2l-1.85,-0.69l-0.9,0.12l-0.56,-1.13l-2.02,-0.79l-2.08,0.14l-0.56,1.0l-0.67,0.42l-1.83,-0.23l-0.46,0.23l-0.25,-0.1l0.57,-0.49l-0.08,-0.65l0.51,-0.24l0.32,-0.76l-0.06,-0.41l-0.64,-0.4Z",name:"Mordoviya, Respublika"},"RU-TA":{path:"M145.76,254.29l0.44,-0.98l1.36,0.23l-0.78,1.33l-0.72,-0.03l-0.31,-0.55ZM148.49,253.59l0.18,-0.5l-0.24,-0.39l1.12,-0.19l0.5,-0.48l-0.54,-2.35l-0.75,-0.46l1.17,-1.07l-0.13,-0.71l1.58,-1.05l0.23,-0.8l1.26,-0.33l0.24,-0.71l1.71,-1.2l0.05,-1.14l1.4,0.08l1.19,-0.65l0.35,-0.63l0.33,0.45l1.48,0.21l1.13,-0.85l0.23,-0.64l0.37,-0.04l1.08,2.09l1.27,0.18l0.11,0.73l1.26,0.82l0.52,-0.08l1.06,0.5l-0.12,0.43l0.32,0.57l1.26,-0.05l0.9,0.46l0.95,-0.55l0.34,0.47l0.64,0.02l0.74,-0.51l-0.02,-0.65l2.1,0.19l1.15,-0.85l-0.19,-1.01l-0.89,-0.46l0.86,-0.46l0.06,0.85l0.5,0.91l1.73,0.58l-1.02,0.76l0.64,0.82l1.65,-0.27l1.5,0.2l1.47,1.14l-0.95,0.66l-0.48,1.14l-0.92,0.35l-0.79,0.89l-0.73,-0.1l-1.63,0.85l0.09,0.7l0.73,0.68l0.69,0.11l0.8,0.85l0.05,0.84l-0.85,0.9l-0.44,1.42l0.46,2.46l-0.3,-0.41l-1.21,-0.48l0.56,-0.38l-0.47,-1.08l-0.71,0.18l-1.68,-0.32l-0.95,-0.93l-1.87,0.58l-0.71,-0.93l-1.31,-0.22l-0.97,-0.59l-0.33,0.16l-0.3,-0.41l-1.28,0.19l-1.09,0.81l-0.32,1.17l-1.14,-0.38l-0.72,0.47l-0.85,-0.91l-0.44,0.2l-0.39,-0.33l-3.07,-0.45l-0.57,-1.38l-1.21,-0.93l-1.8,0.75l-0.83,0.95l-1.68,0.06l-0.88,-0.68l-1.13,-0.22l-1.13,0.36ZM177.51,243.47l-0.04,-0.18l-0.19,-0.34l0.5,0.08l-0.27,0.44ZM166.79,244.23l0.05,-0.07l-0.02,0.03l-0.03,0.04ZM166.92,244.03l0.01,-0.05l0.03,-0.02l-0.04,0.07Z",name:"Tatarstan, Respublika"},"RU-ZAB":{path:"M463.4,286.39l0.63,-0.32l0.38,-0.71l0.5,0.1l0.56,-0.64l2.14,-0.35l0.46,-0.5l-0.2,-0.69l-0.73,-0.07l-2.14,-1.09l0.74,-0.4l0.44,-1.35l0.74,-0.06l0.54,-0.49l-0.02,-0.7l-0.76,-0.66l0.69,-1.2l0.72,0.37l1.66,-0.22l0.66,0.68l0.94,0.2l3.55,-1.8l1.31,0.14l1.15,0.64l0.94,-0.05l1.07,-0.68l0.18,-0.64l0.82,-0.75l2.89,-0.97l2.48,-2.41l1.45,0.51l0.78,-0.39l0.25,-0.6l1.85,0.09l1.76,-0.97l1.87,0.05l0.82,-0.81l1.93,-0.97l1.21,-2.04l0.05,-0.64l-0.74,-1.36l-1.14,-0.53l-0.15,-0.57l-0.48,-0.22l0.17,-1.47l0.6,-0.53l1.52,-0.28l1.05,-0.47l0.52,-0.63l1.84,-0.6l1.3,-1.43l1.54,-0.83l0.63,-0.76l2.81,-0.66l1.67,0.29l1.35,-0.57l1.19,-2.37l-0.27,-1.25l-0.52,-1.13l-1.59,-0.87l-0.6,-1.16l-1.5,0.08l-0.95,-0.84l0.14,-0.87l-0.35,-1.32l0.27,-0.75l-0.67,-0.97l0.31,-0.9l-0.75,-0.96l0.59,-1.0l-0.64,-0.61l-0.13,-0.67l-0.84,-0.22l0.51,-0.55l0.0,-1.11l0.25,-0.12l2.05,1.1l1.17,-0.21l2.47,0.88l1.97,-0.66l0.55,-0.7l0.87,0.65l1.04,-0.48l0.64,-1.37l-0.32,-0.85l0.63,-0.43l0.21,-1.03l-1.32,-0.42l-0.48,0.25l-0.49,-0.37l-0.46,-1.02l0.11,-0.8l-0.65,-0.43l-0.1,-0.78l0.72,-0.1l0.65,-0.61l-0.08,-1.26l0.9,-0.5l0.15,-0.44l-0.45,-0.94l0.75,-0.39l1.29,-0.0l0.47,0.43l0.67,-0.3l0.51,0.17l0.39,0.64l1.4,0.76l2.3,-0.4l0.08,1.03l-0.56,2.31l0.62,0.59l-0.05,1.17l0.79,0.38l0.58,-0.77l0.22,-0.02l-0.25,1.09l1.35,1.9l-0.2,1.22l1.16,0.87l-0.69,0.37l-0.2,0.72l0.77,0.65l-0.02,0.65l0.85,0.83l1.52,0.38l0.78,0.96l-1.91,0.96l0.71,2.23l0.4,0.16l0.49,-0.29l1.0,0.31l2.26,-1.03l1.4,0.0l0.44,1.2l-0.17,0.53l0.43,1.86l0.6,0.31l0.69,-0.16l1.21,-0.82l0.61,0.75l-0.14,3.22l-1.37,1.14l-0.2,0.87l0.52,0.55l0.85,-0.37l0.12,1.25l0.81,0.68l-0.39,0.14l-0.66,-0.43l-0.88,0.34l-0.29,0.42l0.35,1.43l-0.53,0.78l0.13,0.73l0.91,0.5l0.46,0.69l0.15,1.61l0.37,0.73l-3.96,1.1l-1.93,0.04l-3.17,3.01l-1.25,0.72l-0.14,1.23l0.44,0.61l2.1,-0.25l1.0,0.45l-0.39,1.31l0.64,0.76l0.1,0.63l-0.49,1.16l-2.96,1.9l-0.71,1.69l-1.13,1.57l-0.08,0.9l-1.09,1.04l-0.18,1.24l-1.06,0.95l-0.26,1.04l-0.56,0.39l0.07,0.59l0.91,0.35l0.03,0.98l-0.55,0.56l-2.85,0.36l-2.5,1.93l-1.95,1.05l-1.39,-0.64l-2.19,-0.41l-1.7,-0.85l-0.85,-0.86l-1.88,-0.63l-1.09,0.1l-1.73,0.81l-1.61,-0.09l-1.85,-1.64l-1.36,-0.68l-2.75,-0.3l-2.35,1.35l-1.47,0.46l-2.12,1.52l-0.71,1.37l-1.29,0.61l-1.53,-0.24l-2.35,0.83l-2.85,0.46l-0.76,-0.14l-3.36,1.56l-1.58,-0.72l-1.05,0.53l-2.28,-0.68l-1.14,0.04l-1.28,-0.55l-3.84,0.08l-1.43,-1.3l-1.06,-0.39l-0.31,-0.56l-0.05,-1.67l-0.8,-0.3l-0.03,-0.85ZM505.34,243.53l0.0,-0.02l0.0,0.02l-0.0,-0.0Z",name:"Zabaykalskiy kray"},"RU-RYA":{path:"M100.63,257.47l0.1,-0.48l1.06,-0.7l-0.65,-0.66l0.01,-0.48l2.05,-0.21l0.84,-0.84l0.16,-0.97l0.47,-0.48l0.64,-0.44l1.12,-0.05l0.45,-0.75l-0.09,-0.47l1.64,-0.98l0.42,0.25l0.73,-0.14l0.66,0.74l1.77,-0.4l0.78,0.84l0.62,-0.54l1.0,0.65l1.71,0.06l1.15,0.88l1.08,0.38l1.17,-0.37l0.14,0.4l-0.44,0.82l1.42,1.38l-0.47,0.49l-0.36,1.24l-0.8,0.43l-0.46,-0.18l-0.4,0.43l0.53,1.47l0.81,0.52l-0.51,0.63l-4.74,0.46l-0.45,0.5l0.01,1.3l-0.76,0.66l-2.3,-0.94l-1.04,0.66l-0.54,-0.12l-0.31,0.85l-0.76,0.19l-0.22,-0.36l-0.86,-0.05l-0.25,-0.73l-1.14,-0.63l-1.33,0.55l-0.11,0.64l-1.25,0.23l-0.53,-0.96l-0.61,-0.2l-0.0,-1.07l-0.53,-0.39l0.16,-0.81l-0.76,-1.01l0.33,-0.59l-0.34,-0.61ZM119.78,257.98l0.13,-0.17l0.12,0.09l-0.04,0.09l-0.21,-0.01ZM111.37,262.23l0.01,0.01l-0.0,0.0l-0.01,-0.01Z",name:"Ryazanskaya oblast"},"RU-TAM":{path:"M107.59,268.05l0.31,-0.29l0.33,-1.98l-0.16,-1.45l1.22,-0.11l0.38,-0.74l1.12,-0.71l0.65,0.49l0.53,-0.13l1.39,0.48l1.16,-1.04l0.05,-1.46l3.04,-0.26l0.08,1.75l0.9,0.58l0.02,0.77l0.73,0.2l0.62,0.74l0.13,0.77l2.06,1.24l1.41,1.73l-0.89,0.67l-0.04,1.05l-0.44,0.1l-0.16,0.63l-0.86,0.9l0.02,1.11l-0.54,1.42l-1.3,1.23l-0.68,-0.82l-1.33,0.47l-2.38,-1.0l-0.49,0.24l-0.72,-0.17l-0.38,0.41l-1.09,-0.04l0.13,-0.59l-0.25,-0.43l-1.71,-0.43l0.68,-1.44l-0.11,-0.76l-1.94,-0.92l-1.37,-1.12l-0.4,-0.45l0.27,-0.63Z",name:"Tambovskaya oblast"},"RU-ARK":{path:"M179.74,91.95l1.45,-0.62l0.1,-0.36l1.09,-0.61l2.6,-0.43l0.21,-0.53l-0.71,-0.55l1.61,-0.98l0.59,-0.13l1.13,0.48l2.74,0.33l0.25,-0.44l-0.16,-0.42l-2.02,-0.92l1.17,0.05l0.27,-0.86l-0.73,-0.5l-1.51,-0.24l4.67,-0.5l0.43,-0.26l0.02,-0.49l-1.91,-0.73l-1.18,0.07l-0.71,-0.62l0.72,-0.17l0.8,0.3l2.47,-0.61l0.91,0.38l2.26,-0.07l0.39,-0.41l-0.32,-0.43l-1.89,-0.01l-0.63,-1.01l-2.72,0.09l3.74,-0.99l0.06,-0.7l-0.59,-0.27l-0.53,0.2l0.05,-0.52l2.29,-1.83l0.1,-0.61l-0.54,-0.57l0.92,-0.38l3.58,0.73l0.39,-0.22l-0.06,-0.44l-0.48,-1.11l-0.51,-0.3l3.05,-0.6l0.41,-0.53l-0.29,-0.65l2.08,-0.45l1.02,-1.15l2.9,-0.57l0.3,-0.47l1.86,0.06l1.53,-0.66l1.4,-0.06l0.51,-0.58l0.92,0.57l0.83,-0.09l0.57,-0.62l1.28,-0.24l0.51,-0.47l0.08,-0.64l-0.8,-0.35l0.13,-0.62l2.56,-0.05l0.52,-0.33l2.11,0.66l1.16,-0.13l0.27,0.7l0.64,0.23l1.0,-0.33l0.67,-0.64l0.41,0.52l0.58,0.14l3.87,-1.52l1.12,-0.08l0.85,0.47l2.24,-0.91l0.68,0.21l1.08,-1.19l0.8,-0.16l0.8,0.32l1.8,-1.13l2.6,0.46l0.44,-0.25l0.06,-0.55l-1.11,-1.27l0.25,-0.24l1.1,-0.13l1.26,-0.57l0.39,-0.52l2.66,-1.03l1.32,-0.03l1.52,-0.59l4.8,0.45l2.16,1.74l0.12,0.69l-0.65,1.08l0.24,0.55l-1.33,1.05l-0.73,0.16l-0.21,0.6l-1.02,0.42l-0.12,0.5l-3.18,0.8l-2.06,1.01l-2.3,0.47l-2.78,1.08l-5.01,1.15l-0.77,0.51l-5.12,0.95l-1.53,0.66l-0.43,-0.56l-0.9,-0.04l-0.3,0.89l-1.0,0.41l-1.41,0.01l-4.03,1.58l-1.23,-0.1l-1.13,0.87l-0.66,-0.09l-1.08,1.59l-0.52,-1.16l-0.54,0.07l-0.28,0.81l-0.74,0.6l-1.59,0.58l-0.35,1.18l-0.26,-0.0l0.02,-0.73l-0.5,-0.21l-0.57,0.14l-0.4,1.02l-2.72,0.23l0.06,0.46l0.59,0.38l3.16,0.16l-0.26,0.26l-2.01,0.17l-0.13,0.55l0.59,0.51l-1.6,0.23l-2.06,-0.73l-0.52,0.13l0.68,1.21l1.17,0.43l-0.42,0.42l-2.95,-1.65l-0.53,0.09l-0.12,1.0l0.15,0.67l0.31,0.1l-0.54,1.18l-4.24,-1.34l-0.48,0.24l0.1,0.71l2.02,1.17l0.0,0.57l0.55,0.85l-0.46,0.0l-0.34,0.57l-0.95,-0.42l-0.28,0.15l-0.27,0.63l-0.52,0.21l-0.04,1.34l-1.57,-0.49l-1.05,-1.42l-0.98,0.0l-0.2,0.66l0.35,0.38l-0.99,0.04l-0.26,0.42l0.35,0.35l1.36,0.16l1.33,1.01l0.02,0.67l0.45,0.44l-0.71,0.56l-1.66,-1.23l-4.41,-0.44l-0.42,0.27l0.17,0.47l0.6,0.32l3.55,0.37l1.15,1.29l-1.18,0.64l-1.3,-0.24l-1.44,-1.0l-0.55,0.17l0.19,1.32l0.94,0.14l1.41,0.76l-1.31,1.16l-0.99,-0.29l-0.37,1.1l-2.64,-0.4l-0.38,-1.11l-0.7,-0.49l-0.55,0.15l0.0,0.72l0.34,0.4l-0.71,-0.27l-1.66,0.15l-2.07,-1.07l-0.79,-0.09l-2.85,0.87l0.67,-0.88l-0.57,-0.26l2.22,-1.08l2.9,-0.58l0.36,-0.32l-0.38,-0.52l-2.36,0.14l-0.2,-0.25l-1.89,0.3l-1.47,0.97l-1.2,-0.17l-0.83,-0.77ZM182.04,95.64l-0.11,0.05l-0.1,-0.04l0.21,-0.01ZM205.14,87.02l0.03,0.06l-0.08,-0.03l0.04,-0.03ZM193.09,78.13l-2.1,0.43l0.03,-0.76l-0.56,-0.23l0.84,-0.55l0.57,0.67l1.0,-0.29l0.23,0.72ZM214.21,67.9l-0.26,-0.25l-0.5,-0.1l1.34,-0.12l-0.58,0.48ZM225.97,12.84l2.72,-1.36l4.61,-0.19l0.83,-0.32l0.41,-0.8l-0.19,-0.65l1.06,-0.8l2.18,0.02l1.74,0.64l0.73,0.91l-0.51,0.55l0.78,0.61l-2.13,1.24l-2.14,0.63l-7.47,0.86l-2.62,-1.36ZM225.43,2.31l0.93,-0.18l5.18,0.5l-1.26,0.36l-1.34,-0.04l-2.6,-0.26l-0.9,-0.38ZM208.99,16.43l0.18,-0.3l-0.62,-1.1l0.19,-0.41l1.85,-1.51l1.0,-0.08l0.34,0.42l1.72,-0.01l0.37,0.25l1.13,-0.41l5.09,-0.51l0.28,-0.37l2.25,0.18l0.87,0.98l-1.11,0.95l0.02,0.58l-1.78,0.27l-0.71,0.78l-1.49,0.34l-0.18,0.41l0.22,0.22l-1.07,0.46l-3.9,-1.08l-3.19,0.82l-1.47,-0.9ZM213.53,10.7l1.88,-0.71l4.88,-0.04l-3.08,1.34l-3.68,-0.58ZM206.53,22.59l3.05,-0.73l1.28,0.29l0.05,0.66l-1.78,0.3l-0.38,0.33l-2.23,-0.85ZM201.59,1.71l0.85,-0.29l0.31,-0.36l-0.2,-0.31l5.76,-0.18l0.02,0.39l-6.74,0.75ZM205.04,6.48l1.89,-0.35l1.32,0.47l-1.15,0.17l-2.06,-0.29ZM197.74,17.51l6.15,0.13l3.25,0.85l-2.44,-0.06l-2.56,0.71l-0.45,0.9l-0.94,0.53l0.25,0.74l-0.83,0.0l-1.92,-0.67l-0.32,-2.07l0.18,-0.62l-0.37,-0.43ZM203.4,20.37l0.13,0.0l-0.01,0.04l-0.12,-0.04ZM202.06,12.94l3.41,-0.61l1.0,0.52l-2.64,0.56l-1.76,-0.47ZM201.47,10.15l0.47,-0.39l2.59,0.71l-0.18,0.41l-0.83,0.11l-2.05,-0.84ZM196.63,4.46l2.23,0.04l0.43,-0.34l0.96,-0.04l0.58,0.94l2.96,0.35l-0.67,0.25l-2.52,-0.02l-1.84,-0.72l-2.26,-0.02l0.13,-0.44ZM194.28,9.74l0.41,-0.01l1.05,0.4l-0.12,0.01l-1.34,-0.4ZM196.08,10.24l3.38,0.53l0.74,0.71l1.15,0.22l-0.68,0.42l-1.41,-0.1l-1.34,-0.45l-0.4,-0.66l-1.25,-0.17l-0.19,-0.51ZM197.96,8.68l0.56,-0.23l1.89,-0.21l-0.48,0.4l-1.97,0.04ZM189.32,7.11l1.0,-0.0l1.59,0.49l-1.71,0.41l-0.95,-0.16l0.07,-0.74ZM193.37,7.89l0.99,-0.01l0.29,-0.38l-1.05,-1.19l1.21,-0.09l0.43,0.35l0.59,-0.12l2.62,0.63l-2.0,0.15l-2.27,0.91l-0.69,0.04l-0.12,-0.28ZM183.52,10.38l0.63,-0.78l3.67,1.09l-1.91,0.23l-0.82,-0.62l-1.56,0.07ZM188.17,10.87l0.77,0.16l2.24,-0.43l2.87,0.69l0.35,0.52l4.98,1.43l-2.71,0.85l-2.02,-1.42l-4.41,-0.54l-0.29,-0.42l-1.6,-0.36l-0.17,-0.49ZM167.4,111.65l0.11,-1.62l0.77,-1.28l1.01,-0.52l1.19,0.76l0.42,-0.24l1.29,0.19l0.32,-0.76l0.51,-0.3l-0.06,-0.76l1.08,-0.79l0.99,-0.3l-0.15,-0.44l-0.74,-0.26l0.35,-0.05l0.68,-1.26l0.9,-0.27l0.18,-0.43l0.61,-0.26l-0.14,-0.45l-1.36,-0.42l-2.2,0.12l-0.3,-0.3l0.67,-0.86l1.94,-0.56l1.49,0.46l0.58,-0.17l0.22,-0.66l-0.39,-0.56l0.35,-0.24l-0.17,-0.46l-0.97,-0.62l0.0,-0.34l0.62,-0.43l1.07,-0.08l1.13,-0.68l2.38,0.23l1.81,-1.05l1.86,-0.45l1.92,0.86l2.33,0.13l0.37,0.37l3.15,0.59l0.32,0.38l-3.5,0.5l-0.34,0.33l0.54,0.54l-1.36,0.2l-0.18,0.43l0.69,0.43l1.5,0.1l1.03,-0.31l-0.32,1.12l-3.2,-0.28l-0.53,0.3l-0.13,0.45l0.38,0.27l0.93,0.07l-0.05,0.86l-0.19,0.61l-1.53,-0.36l-0.41,0.34l0.3,0.45l0.94,0.37l-1.67,0.13l-0.36,0.56l0.36,0.3l1.48,0.13l-0.39,1.19l0.84,0.75l-1.01,1.05l0.03,1.0l-0.68,0.38l0.3,0.63l1.17,0.2l0.07,0.93l0.76,1.71l1.83,2.25l0.53,1.29l5.0,3.82l2.09,0.58l-0.15,0.52l0.29,0.29l-0.28,0.28l-2.97,-0.87l-0.51,0.07l-0.12,0.37l-0.75,-0.89l-0.83,0.34l-0.92,-0.22l-0.33,0.77l-0.69,0.11l-3.21,-0.96l-1.23,0.95l-0.06,0.85l-1.85,-1.04l-0.25,-0.73l-1.01,-0.61l-0.54,-0.06l-0.27,0.73l-0.55,-0.33l-1.27,0.28l-1.08,-0.72l-0.52,0.18l0.24,-1.12l-0.64,-0.83l1.41,0.28l0.1,-0.41l1.59,-0.23l0.16,-0.58l-0.6,-0.34l0.24,-0.25l-0.79,-0.66l-0.82,0.49l-0.64,-0.25l-0.2,0.36l-1.0,-0.36l0.85,-1.15l1.3,-0.46l-0.05,-0.81l-0.64,-0.07l-1.62,0.74l-0.56,0.77l-0.46,-0.83l0.67,-0.72l-0.03,-0.68l-0.76,-0.26l-1.17,0.91l-0.66,-0.19l-0.31,0.64l-1.08,-0.53l-0.58,-1.32l-0.51,-0.13l-0.42,0.75l-0.47,0.14l-0.55,-0.45l-0.6,0.39l-0.26,0.63l-1.13,0.2l-1.27,-0.79l-0.69,-1.75ZM172.5,108.32l-0.02,0.06l0.01,-0.01l0.01,-0.05ZM172.5,108.3l0.01,-0.0l-0.0,-0.01l-0.0,0.02ZM173.81,116.0l2.22,1.15l-0.29,0.61l-0.48,0.33l-0.58,-0.24l-0.25,-0.73l-0.92,-0.72l-1.87,-0.38l1.27,-0.34l0.91,0.31ZM189.92,102.25l0.03,-0.0l0.02,0.02l-0.03,-0.0l-0.02,-0.01ZM190.66,21.47l1.01,-0.77l-0.23,-1.56l2.98,0.23l0.65,-0.52l1.46,0.15l0.01,1.47l-0.34,0.46l0.28,0.62l-5.82,-0.08ZM189.71,14.38l0.44,-0.33l3.55,-0.29l1.76,0.77l-2.26,0.33l-0.52,-0.3l-2.36,0.27l-0.61,-0.45ZM181.55,12.9l2.77,-0.18l0.1,0.31l0.57,0.11l1.34,-0.81l2.7,0.79l-3.84,0.63l-0.62,-0.14l-0.54,-0.67l-2.48,-0.04ZM187.02,19.71l-0.05,-0.27l0.98,-0.07l-0.63,0.16l-0.3,0.18ZM184.98,16.87l0.2,-0.02l0.42,0.17l-0.57,-0.13l-0.05,-0.02ZM183.49,17.94l0.47,-0.41l0.53,0.23l-0.01,0.01l-0.99,0.17ZM180.34,16.99l0.28,-0.14l0.06,-0.68l-0.38,-0.22l0.72,0.1l0.06,0.46l1.37,0.47l-0.56,0.45l-1.55,-0.43ZM181.87,20.07l-0.27,-0.44l0.71,0.06l-0.0,0.33l-0.43,0.05ZM171.81,19.76l1.44,-0.0l0.85,-0.41l0.06,-0.63l0.75,-0.41l1.76,0.04l0.28,0.53l1.33,0.73l-0.57,0.82l-4.04,-0.01l-1.85,-0.65ZM174.08,18.62l-0.09,-0.11l0.05,0.03l0.04,0.08ZM142.56,19.35l1.75,-0.53l0.22,0.51l0.54,0.23l0.98,-0.15l1.91,0.1l-1.95,0.14l-0.64,0.57l-1.04,0.2l-1.77,-1.07ZM148.81,19.54l1.13,-0.23l0.53,-0.52l-0.27,-0.36l-0.76,-0.14l1.12,-0.24l-0.06,-0.68l-0.59,-0.54l1.2,-0.45l1.03,0.79l1.26,0.1l0.72,-0.4l1.01,0.16l1.47,-1.04l0.12,-0.6l1.18,0.06l0.32,-1.04l-0.15,-0.63l-1.65,0.09l-0.46,-0.41l2.04,-0.55l0.68,-0.5l0.68,-0.15l0.01,0.45l0.4,0.14l4.21,-0.71l0.21,0.24l-2.13,0.27l-0.38,0.49l-0.82,0.21l-0.27,0.31l0.72,0.93l1.74,-0.57l0.76,0.25l0.51,-0.39l1.17,0.31l0.74,-0.43l1.74,0.65l-2.3,0.6l-1.19,0.98l-4.25,0.12l-0.55,0.35l-1.71,0.1l-0.33,0.81l0.52,0.38l-1.27,0.34l-3.68,-0.16l-1.17,1.19l0.21,0.57l1.59,0.24l0.18,0.7l-0.94,-0.07l-1.11,-0.6l-0.57,0.32l0.14,0.68l-0.47,0.37l-0.7,-0.48l-0.7,-0.03l0.23,-0.62l-0.73,-0.2l-0.35,-0.48ZM149.19,21.03l-0.28,0.41l-1.33,0.16l0.52,-0.44l1.09,-0.14ZM149.46,16.75l-0.55,0.08l-0.14,-0.02l0.39,-0.12l0.29,0.06ZM163.02,23.09l0.25,-0.43l1.44,-0.56l0.76,0.44l0.41,0.82l-2.87,-0.28ZM162.26,9.57l0.48,-0.52l1.28,0.17l-0.73,0.17l-0.16,0.41l-0.77,0.04l-0.1,-0.26ZM85.98,185.23l2.09,-0.19l0.71,-0.34l0.6,-1.01l-0.2,-1.27l2.95,0.53l0.46,0.56l1.08,0.29l0.96,-0.21l0.32,-0.7l1.81,-0.47l0.63,-0.86l-0.19,-1.24l-0.51,-0.57l0.41,-0.67l-0.37,-0.59l-0.81,-0.25l-0.49,-0.65l-2.38,0.77l-0.84,-0.34l-1.96,-2.39l-0.95,-0.42l-0.05,-0.77l1.19,-0.49l0.58,-1.66l0.4,-0.13l3.24,1.13l0.6,0.93l1.38,0.61l-0.21,1.46l0.32,0.34l0.88,-0.24l0.88,-0.71l0.58,0.14l0.39,-0.31l1.82,0.38l3.56,1.61l1.02,-0.12l1.02,-0.73l1.1,0.73l1.66,0.16l0.51,-0.22l0.11,-0.57l-0.48,-1.1l0.42,-0.54l-1.33,-2.27l-0.89,-0.53l-1.92,-2.35l0.04,-1.25l3.69,-2.15l1.23,-1.36l3.2,-0.75l1.71,-1.01l2.71,-3.07l1.66,0.48l-0.19,0.57l0.39,0.23l3.69,-0.42l0.36,0.69l1.43,0.49l-1.89,1.08l0.22,0.88l1.28,0.86l0.41,-0.72l-0.36,-0.69l1.5,-0.4l0.78,0.68l0.0,0.71l1.14,1.39l0.42,-0.69l-0.58,-2.66l0.34,-1.17l0.42,-0.25l2.78,1.51l4.65,1.48l0.61,-0.15l2.58,0.5l4.28,1.85l3.23,-0.05l0.42,-0.5l-0.12,-0.67l1.89,-1.5l3.97,0.09l-0.01,7.34l0.56,0.27l2.84,-0.45l2.3,3.33l1.9,0.77l-0.5,1.73l-3.6,-0.66l-0.89,1.07l-2.74,-0.14l-0.63,1.12l-1.69,0.05l-0.43,0.99l-0.78,-0.08l-0.62,-0.95l-7.9,0.18l-1.55,0.51l-2.71,-0.13l-2.29,1.11l0.06,0.53l0.99,0.94l1.58,0.86l2.85,0.63l1.94,1.13l0.92,1.39l-0.38,0.71l0.03,1.16l0.88,0.91l2.19,0.85l-0.46,0.8l-1.95,1.29l0.81,1.85l-0.02,2.29l0.88,0.5l-0.01,0.67l0.38,0.44l1.24,0.06l0.68,-1.1l2.88,-0.02l0.34,-0.44l-0.0,-0.7l-0.34,-0.41l0.47,-1.74l1.37,0.15l0.59,-0.93l0.52,-0.07l3.36,0.42l-1.09,4.41l-0.84,0.59l-0.88,3.34l0.55,0.76l1.56,0.31l-0.67,2.77l-2.05,0.3l-1.99,0.75l-0.51,0.58l-0.16,0.89l-1.61,-0.22l-0.36,-0.94l-2.12,-0.43l-2.16,0.12l-0.98,1.5l-0.8,-0.29l-0.25,-0.68l-0.84,-0.13l-0.53,-0.55l-1.44,0.72l-1.81,-0.33l-0.26,-0.11l0.08,-0.71l-0.3,-0.38l-2.21,-0.32l-0.63,0.31l-0.51,2.06l-4.89,-0.49l-0.2,-0.84l-0.82,-0.03l-1.61,0.52l-0.42,1.07l-0.89,0.3l-0.23,0.56l-1.69,-0.25l-0.5,0.46l-0.94,-0.85l-1.0,-0.08l-1.36,0.73l-1.9,-0.51l-0.54,-0.65l-1.13,0.47l-0.99,-0.33l-0.89,0.38l-0.46,1.5l-0.35,0.07l-1.88,-0.41l-0.57,-0.57l-0.84,0.45l-0.98,-0.48l-0.48,0.65l-1.83,0.4l-0.8,-0.64l-0.77,-0.12l-1.56,0.44l-1.17,-0.1l-0.63,-0.7l-0.51,-0.05l-1.17,0.69l-0.26,-0.54l-0.77,-0.18l-0.43,-1.11l-0.78,0.23l-0.16,-1.56l-0.97,-0.32l-0.59,-0.86l-0.52,-2.62l0.63,-0.62l0.23,-2.15l-0.66,-0.43l-0.48,-1.65l-1.21,-0.24l0.45,-0.62l0.13,-0.95l-0.51,-1.77l-1.06,-0.5l-1.31,0.27l-1.71,-0.52l-1.26,-0.82l-1.15,-1.43l0.77,-1.57l-0.72,-0.33l-0.38,-1.54l-1.51,-1.01ZM107.95,176.09l0.13,0.03l0.14,0.31l-0.05,-0.03l-0.21,-0.31ZM157.9,21.01l1.24,-0.53l1.56,0.14l-0.79,0.32l-0.38,0.85l-1.64,-0.77ZM134.6,15.34l8.91,-1.14l1.58,-0.75l0.02,-0.43l1.49,-0.13l0.91,0.29l-1.16,0.4l-0.38,0.59l-0.59,0.16l-0.25,0.66l-0.73,0.1l-0.79,0.7l-1.75,-0.07l-0.22,0.46l-0.74,0.3l-0.05,0.5l-1.71,0.2l0.24,-1.18l-0.5,-0.43l-1.65,0.14l-1.13,0.47l-0.56,-0.54l-0.93,-0.29ZM148.31,13.43l2.19,-0.2l0.91,0.31l-0.25,0.28l0.15,0.63l0.8,0.42l-2.58,-0.39l-1.21,-1.04Z",name:"Arkhangelskaya oblast"},"RU-KC":{path:"M111.18,329.18l0.38,-1.28l0.77,-0.41l-0.02,-0.75l1.11,0.19l0.16,0.44l0.58,0.19l0.6,-0.07l1.06,-0.84l0.61,-1.07l-0.25,-0.95l0.63,-0.31l0.39,0.6l1.79,0.43l0.32,0.34l-0.61,0.78l0.46,0.96l1.28,0.2l0.28,0.76l-0.03,0.48l-1.08,0.49l-0.35,2.2l-1.5,0.34l-2.31,-0.21l-1.01,-0.75l-1.9,-0.25l-1.43,-0.76l0.06,-0.74Z",name:"Karachayevo-Cherkesskaya Respublika"},"RU-TY":{path:"M363.89,276.71l1.2,-0.36l0.62,0.6l0.89,-0.39l0.79,0.36l0.96,-0.23l1.13,-1.14l0.99,-0.17l-0.27,-1.73l0.48,-0.8l0.84,-0.37l1.67,0.72l0.81,1.23l1.25,-0.21l0.8,0.39l1.64,-0.12l2.94,0.82l2.14,0.01l1.04,-0.43l0.96,0.03l2.73,-2.12l1.72,-0.71l0.54,-1.59l1.55,-1.58l0.47,-1.22l1.88,-0.56l0.57,-1.9l0.45,-0.48l-0.01,-0.79l1.49,0.06l0.89,-0.45l1.01,0.47l1.68,-0.99l1.97,0.43l0.92,-0.93l0.7,0.49l1.4,-0.31l0.71,-1.21l2.44,0.95l1.54,1.55l1.64,0.17l0.57,0.69l1.09,0.22l0.36,0.85l3.4,-0.27l0.17,0.75l-0.94,0.96l0.45,1.01l-0.64,0.46l-0.12,0.56l-0.87,0.97l0.1,1.25l0.27,0.29l0.6,-0.14l0.18,1.21l-0.76,1.38l-1.7,0.61l-0.8,1.6l-0.92,0.38l-0.66,1.07l0.03,0.72l-0.65,1.62l0.83,1.16l-0.07,0.56l0.52,1.09l1.31,0.68l-0.16,1.29l-0.98,1.61l-0.93,0.5l-1.46,0.18l-0.29,0.72l-1.06,0.57l-1.64,-1.1l-1.4,-0.19l-0.58,0.25l-0.52,-0.31l-0.7,0.24l-1.57,-0.76l-0.61,0.22l-0.76,-0.36l-1.63,0.82l-0.65,-0.32l-1.47,0.0l-0.82,-0.68l-1.53,0.17l-1.16,-1.15l-0.17,-1.36l-0.54,-1.15l-6.19,-0.33l-0.62,-1.2l-1.25,-0.05l-0.5,0.71l-1.51,-1.32l-0.61,0.23l-0.61,1.01l-2.17,0.05l-1.89,1.54l-2.21,0.33l-1.34,0.85l-0.27,0.54l-0.92,-0.05l-2.54,1.04l-0.32,0.73l-1.26,0.16l-0.11,-0.87l-0.51,-0.86l-0.53,-0.29l2.19,-0.64l0.29,-1.01l-4.28,-3.92l-0.05,-0.73l-0.46,-0.4l0.08,-1.35l-0.68,-0.54ZM417.15,266.65l0.34,0.14l-0.23,-0.05l-0.11,-0.09Z",name:"Tyva, Respublika [Tuva]"},"RU-MUR":{path:"M47.65,138.6l2.8,-1.12l1.04,-2.11l3.02,-0.62l1.01,-0.8l0.64,-1.35l1.03,0.63l2.05,0.02l0.59,-0.91l-0.28,-1.45l1.89,0.46l-0.44,0.95l0.42,0.23l0.96,-0.74l1.64,0.04l0.41,-0.56l-0.45,-0.47l-0.04,-0.52l0.23,0.01l1.07,0.69l0.02,0.32l-0.75,0.36l0.24,0.92l0.65,0.31l0.37,-0.22l1.16,0.25l-1.25,0.79l0.45,0.54l1.51,-0.59l1.19,-0.07l0.01,0.68l0.36,0.02l-0.27,0.49l0.43,0.63l0.62,-0.2l0.42,-0.69l1.78,-0.37l-0.17,0.49l-0.8,0.42l0.3,0.8l0.7,0.17l-1.71,0.61l-0.47,0.53l-0.05,0.95l0.42,0.48l0.39,-0.25l0.17,-0.83l1.67,-0.31l0.82,-0.76l0.29,-1.31l0.45,0.23l0.91,-0.28l2.38,0.21l2.81,0.74l0.22,0.36l0.67,-0.27l0.41,0.39l0.71,-0.32l0.24,-0.53l3.19,0.88l0.6,0.47l0.78,0.11l0.49,0.53l4.53,1.89l1.41,0.97l1.16,0.28l1.99,1.83l1.29,0.58l0.51,0.98l1.81,0.48l0.89,-0.26l0.13,0.41l3.13,1.8l2.15,0.14l1.91,1.35l-0.07,0.46l1.09,0.95l0.83,-0.39l0.85,0.62l0.71,-0.02l0.27,0.36l-0.28,1.52l0.75,0.59l-0.07,1.68l1.09,0.43l0.03,1.16l-0.35,0.29l0.11,0.53l-0.55,0.99l-3.75,3.45l-1.87,1.0l-3.81,1.31l-4.05,0.68l-4.61,-0.58l-2.0,-0.93l-2.03,-0.48l-2.57,-0.1l-4.45,-0.8l-3.91,-1.97l-1.74,0.65l0.56,-0.66l-0.24,-0.35l-1.67,-0.17l-0.26,-0.82l-0.55,0.08l-0.61,0.62l-1.68,-1.16l-0.74,-0.1l-0.36,0.67l-2.89,-1.93l0.62,-0.3l-0.03,-0.73l-3.23,-0.64l-2.72,-0.04l-0.45,0.63l0.69,0.52l1.6,-0.08l0.22,0.51l0.93,0.28l-0.61,0.35l0.14,0.67l1.37,0.72l0.71,0.92l1.15,0.46l-2.18,0.25l-0.33,0.78l-0.92,0.3l-0.16,0.8l-1.95,0.01l-0.21,-1.03l-0.86,-0.47l-0.27,-0.81l-0.44,-0.29l-2.58,-0.26l-8.71,0.48l-1.33,-1.64l0.06,-0.96l2.15,-2.66l2.13,-1.94l0.35,-2.12l-1.8,-1.17l-1.8,-2.33l-3.33,-1.03l-1.08,-2.67l1.82,-2.74l-0.14,-0.48l-0.84,-0.38ZM70.24,158.97l0.25,-0.0l-0.03,0.07l-0.22,-0.07ZM65.98,130.46l-0.64,-1.11l0.95,0.68l1.04,0.18l0.35,0.52l2.11,0.23l0.75,0.38l-0.02,0.25l-0.9,0.41l-3.22,-0.63l-0.42,-0.91Z",name:"Murmanskaya oblast"},"RU-VOR":{path:"M97.97,276.16l1.44,-0.54l0.15,-0.56l-0.39,-0.27l-0.14,-1.09l1.96,-0.61l1.13,0.76l1.07,-0.8l0.86,0.18l0.25,0.72l1.37,0.36l1.96,-0.37l3.91,0.46l-0.12,1.01l1.1,0.37l2.43,-0.48l2.28,0.87l0.94,0.11l0.4,-0.27l0.39,0.56l0.87,-0.19l1.36,0.96l0.46,0.45l-0.01,0.51l-2.62,0.72l-1.55,-0.49l-0.96,0.25l-0.61,1.11l-3.06,1.81l0.16,0.55l0.81,0.37l0.47,0.71l-0.15,0.63l0.41,0.59l-1.08,1.31l0.2,0.71l-1.08,0.61l-0.45,1.24l-0.56,0.54l-1.99,0.65l-1.52,-0.22l-1.94,0.58l-0.73,-0.38l-0.34,-0.74l-1.63,-0.23l-0.22,-0.71l0.46,-1.03l-0.78,-0.89l-0.6,-1.77l0.34,-0.18l0.12,-1.29l-1.56,-0.74l-0.29,-0.57l0.66,-0.3l-0.16,-1.23l-0.87,-0.48l-0.77,0.47l-0.36,-0.4l0.19,-0.66l-0.81,-0.83l-0.34,-1.46l-0.43,-0.42Z",name:"Voronezhskaya oblast"},"RU-PSK":{path:"M41.18,232.73l0.7,-1.37l1.13,-0.23l0.35,-0.43l0.32,0.32l1.06,0.01l0.6,-0.75l-0.12,-0.98l-1.13,-1.33l-1.07,-0.25l-0.66,0.17l-0.12,-0.28l1.35,-1.62l-0.36,-1.64l0.15,-1.45l-0.37,-0.54l1.55,0.02l0.95,1.05l3.25,0.23l1.58,0.85l0.08,0.62l1.02,0.24l0.51,0.86l1.45,0.35l-1.02,1.02l0.24,1.69l0.78,-0.02l0.76,1.09l2.7,0.41l-0.54,0.5l0.89,1.35l-0.71,1.88l1.27,0.81l-0.21,2.13l1.3,0.54l-0.61,0.88l0.65,1.13l0.89,-0.02l-0.27,1.2l1.05,0.45l0.23,0.72l1.19,0.36l0.01,1.4l-0.62,0.41l-0.11,0.52l0.37,1.12l-1.47,-0.25l-1.04,1.17l-0.49,0.06l-1.36,-1.32l-1.6,-0.58l-1.79,0.14l-2.03,1.07l-0.35,-0.3l0.5,-0.99l-0.56,-0.59l-1.99,-0.56l-1.33,0.62l-0.75,-1.07l-1.74,0.21l-0.32,-0.29l0.25,-0.96l-0.5,-2.13l-0.67,-0.42l-0.1,-0.63l-0.45,-0.35l-0.06,-0.83l-0.94,-0.43l0.17,-1.25l0.53,-0.62l-0.02,-1.1l-1.61,-1.04l0.03,-0.5l-0.4,-0.44l-0.4,0.0Z",name:"Pskovskaya oblast"},"RU-TVE":{path:"M59.28,238.95l0.79,-1.06l2.76,0.04l0.85,-0.64l0.08,-0.55l1.02,0.13l2.59,-1.2l1.34,-0.73l0.75,-0.9l2.46,0.2l0.54,-1.84l0.94,-0.43l0.31,-1.04l0.66,-0.59l-0.27,-1.59l0.88,0.08l1.34,-0.46l2.95,0.95l0.41,-0.38l-0.01,-0.81l1.3,0.29l0.69,-0.2l0.86,-0.49l0.41,-1.02l2.8,-0.0l0.89,-0.65l2.18,-0.22l1.83,-1.74l0.03,-0.61l1.11,-0.18l0.24,0.61l2.22,2.07l-0.71,0.06l-0.56,0.54l-0.06,1.54l1.18,0.61l-0.41,0.52l-0.81,0.31l0.06,1.32l2.25,1.81l-0.06,1.26l1.14,0.75l1.09,0.23l-0.4,0.8l0.59,0.68l-0.52,0.57l0.14,0.58l-0.35,0.46l-1.79,-0.99l-1.1,0.49l-0.24,0.76l-1.86,0.37l-0.28,0.49l0.1,1.01l-1.35,-0.34l-1.79,1.08l-0.81,-0.02l-1.26,0.56l-1.46,-0.26l-0.62,-0.53l-1.24,0.09l-0.28,0.34l0.25,1.25l-0.68,0.24l-0.39,1.23l-0.57,0.63l-1.94,-0.06l-0.56,0.36l-2.05,-1.12l-1.86,-0.03l-0.77,0.94l-0.81,0.14l-0.02,0.71l-0.73,0.61l-1.7,0.74l-4.07,-0.45l-1.14,0.2l-1.15,-0.65l-0.99,0.36l-1.13,-0.1l-0.32,-1.14l0.62,-0.62l-0.07,-2.16l-1.0,-0.32l-0.68,-0.97l-0.75,-0.21l0.29,-0.8l-0.3,-0.74l-1.06,-0.22ZM96.93,238.34l0.02,0.03l0.01,0.04l-0.0,-0.0l-0.02,-0.07ZM97.47,234.95l0.03,-0.03l-0.01,0.02l-0.02,0.0Z",name:"Tverskaya oblast"},"RU-VGG":{path:"M114.24,281.97l0.63,-0.69l1.57,-0.78l0.89,-1.15l1.73,0.49l2.9,-0.72l2.73,1.54l3.02,-0.83l0.37,0.36l0.91,-0.07l0.47,-0.62l1.0,-0.1l0.58,0.43l1.47,-0.12l1.52,0.6l0.05,0.59l0.5,0.59l-0.75,0.91l0.62,1.22l1.2,-0.17l0.45,0.4l0.95,-0.31l0.19,-1.07l0.36,-0.11l0.94,0.56l0.03,0.82l0.45,0.31l2.22,-0.19l0.97,-0.91l1.12,1.32l1.21,-0.11l0.55,0.93l-0.24,1.0l0.29,0.65l-1.77,1.03l-0.42,0.59l-0.68,3.41l1.35,1.15l-0.03,0.36l-1.34,1.15l-0.57,1.31l-1.33,-0.9l-1.73,-0.22l-2.25,1.87l-1.93,0.28l-1.28,1.31l-0.54,1.66l-0.44,0.31l-0.83,-0.17l-0.27,-0.77l-1.59,-0.31l-0.24,0.48l0.13,1.13l0.7,0.48l-0.3,0.37l-1.51,-0.13l-0.53,0.94l-1.42,0.55l-0.5,1.26l-1.73,0.24l-0.34,-0.79l-1.01,0.22l-0.99,-1.96l-1.34,-1.16l-1.01,-0.29l-1.2,0.11l0.53,-1.16l-0.27,-0.89l2.71,-0.75l0.47,-0.55l-0.17,-0.77l0.43,-0.8l-0.47,-1.19l-1.46,-0.75l-0.31,-0.62l-1.27,-0.02l-0.03,-1.85l0.54,-1.64l-1.67,-1.58l-1.41,-0.48l-0.09,-0.55l-0.99,-0.91l0.64,-0.97l-0.4,-0.93l0.53,-0.7l-1.25,-1.14Z",name:"Volgogradskaya oblast"},"RU-KOS":{path:"M109.81,233.69l1.14,-0.88l-0.33,-2.49l1.47,-1.56l0.39,-0.95l1.08,-0.85l-0.92,-1.82l1.15,-0.91l-0.2,-0.76l0.42,-0.87l2.28,-1.13l0.62,0.16l1.08,-0.39l0.38,-0.49l-0.0,-0.9l0.72,0.41l1.54,-0.43l0.17,0.55l0.88,0.58l1.4,-0.29l0.43,-0.41l1.03,0.39l0.52,-0.32l0.19,0.5l0.52,0.11l0.87,-0.6l1.19,0.36l0.84,-0.19l1.04,0.7l3.62,0.14l0.59,-0.48l4.39,-0.04l0.65,-0.95l1.57,-0.29l0.32,-0.35l0.17,-1.83l2.14,-0.03l0.81,0.11l-0.23,1.4l0.33,0.46l0.65,0.11l0.15,1.05l1.51,1.09l-0.0,0.53l-1.24,0.15l-0.18,1.07l-0.78,0.0l-0.68,1.17l-2.04,0.45l-0.27,1.19l-0.77,0.49l-0.04,1.07l-0.52,0.9l-2.32,0.2l-1.06,0.79l-0.67,-0.71l-3.2,-0.3l-0.65,0.7l-0.08,0.64l0.33,0.58l-0.51,0.9l-0.77,0.09l-0.93,1.06l-1.72,0.77l-1.27,-0.01l-0.74,-0.65l0.06,-0.5l-0.44,-0.39l-1.6,1.12l-0.17,-0.92l-0.49,0.12l-0.33,1.52l-0.94,0.15l0.12,-1.76l-0.68,-0.58l-3.09,1.04l-0.7,-0.15l-1.54,-1.14l-0.74,-0.12l-0.75,0.58l0.1,1.58l-1.77,0.22l-1.03,0.74l-2.52,0.33l0.1,-0.82ZM118.27,219.75l-0.35,-0.16l0.05,-0.53l0.16,0.07l0.15,0.63ZM125.1,220.1l-0.0,-0.03l0.0,-0.0l0.01,0.01l-0.01,0.02Z",name:"Kostromskaya oblast"},"RU-KL":{path:"M116.23,313.29l0.71,0.15l0.81,-0.96l1.14,-0.16l-0.0,-0.87l-0.66,-0.67l0.25,-0.11l2.18,1.1l1.04,0.14l0.71,-0.28l1.59,1.27l-1.65,-0.82l-2.19,1.66l-0.47,0.06l0.04,-0.61l-0.38,-0.34l-1.02,0.21l-0.37,0.89l-1.5,-0.2l-0.24,-0.46ZM124.77,313.35l1.2,-0.04l0.98,-1.18l0.39,0.43l0.8,-0.41l0.15,-0.54l-0.53,-1.5l0.95,-1.15l1.01,-0.54l0.45,-1.59l0.04,-2.59l-0.6,-0.86l-1.11,0.13l-0.22,0.82l-0.58,0.17l-0.29,0.52l-0.83,-1.38l0.27,-0.51l1.26,-0.41l0.52,-0.88l1.4,0.24l0.87,-1.28l1.48,-0.04l0.95,-0.72l0.56,0.39l1.35,0.12l0.83,0.66l0.56,-0.09l0.15,0.88l1.26,1.65l1.9,1.28l0.9,-0.1l1.56,2.8l0.73,0.34l0.42,0.77l0.66,0.09l0.07,0.52l-1.17,0.8l0.04,0.66l-1.62,0.27l-0.74,0.9l0.03,0.42l1.88,0.42l-0.17,0.71l0.23,0.37l1.31,-0.17l-0.41,0.36l-0.74,2.25l-0.09,0.38l0.38,0.49l2.51,-0.61l0.4,0.61l-0.62,0.43l-0.11,1.29l-0.4,0.27l-0.42,1.2l-1.01,0.37l-0.15,0.87l-0.48,-0.08l-2.04,-0.97l-3.52,-0.34l-0.82,-1.07l-4.48,-2.21l-1.68,-0.21l-1.03,-0.5l-0.55,-1.1l-1.19,-1.1l-2.88,-0.74ZM130.56,300.1l-0.45,-0.04l-0.05,-0.41l0.45,0.13l0.04,0.33Z",name:"Kalmykiya, Respublika"},"RU-TOM":{path:"M291.79,227.0l1.06,-0.9l-0.18,-0.59l-0.67,-0.47l0.09,-0.49l1.01,-0.74l1.72,-2.08l-0.26,-1.42l0.82,-0.38l0.41,-0.89l0.54,-0.11l0.8,-0.85l1.37,-0.02l1.26,-0.41l0.14,-0.9l0.49,-0.67l-0.06,-2.86l0.62,-1.17l-0.39,-1.3l1.32,-0.72l0.15,-0.54l-0.33,-0.71l0.4,-0.3l0.08,-0.69l1.27,0.31l1.54,-0.11l1.24,0.62l1.08,-0.43l1.88,0.19l0.99,-0.37l0.71,0.36l1.88,-0.44l0.26,0.73l0.75,0.64l2.55,-0.23l1.8,0.21l1.37,-0.81l1.39,-0.23l1.33,0.27l0.78,0.98l1.96,0.18l1.75,-0.23l1.89,0.92l1.3,-0.77l0.15,-0.88l3.71,-2.33l1.65,-0.13l2.46,1.69l1.44,-0.14l2.19,2.92l0.28,0.5l-0.72,1.18l-0.13,1.22l-0.42,0.6l1.02,0.98l4.44,0.17l2.53,-0.5l3.37,0.04l2.2,0.48l0.49,1.4l1.83,0.28l2.04,3.08l3.47,-0.14l0.97,1.54l-1.95,0.71l-2.49,3.08l-0.12,0.52l0.56,2.05l0.94,1.23l2.82,0.54l0.9,0.59l2.44,0.08l0.02,1.74l-1.16,0.18l-0.33,0.7l-1.13,0.62l-0.66,1.52l-1.13,0.86l0.09,0.77l0.75,0.18l-0.51,1.38l-0.82,-0.25l-3.06,1.99l-1.14,-0.7l-0.92,0.22l-1.14,-0.39l-0.58,0.33l0.13,0.69l-2.0,-0.7l-1.41,0.55l-0.47,-0.44l-0.87,-0.01l-0.73,1.0l-2.67,1.34l-0.24,0.62l-1.36,-0.15l-0.75,0.22l-0.34,0.52l-0.79,-0.18l-2.82,1.15l-0.68,-0.31l-1.49,0.36l-1.84,2.31l-1.19,-0.23l0.69,-0.87l-0.8,-1.1l0.17,-0.51l-0.49,-0.4l0.05,-0.54l-0.3,-0.27l0.56,-1.38l-1.12,-1.04l-1.73,0.21l-0.28,0.72l-6.1,1.19l-1.6,-1.71l-0.65,-0.28l-4.46,0.62l-3.59,-3.59l-5.71,-1.38l-0.39,-0.38l-7.98,-0.2l-4.08,-0.45l-0.59,-0.95l-0.7,-0.21l-0.66,-1.38l-0.65,-0.44l-0.24,-2.08l-2.14,-1.21l0.48,-0.57l-0.6,-1.0Z",name:"Tomskaya oblast"},"RU-KO":{path:"M136.15,180.32l1.6,-0.64l2.49,0.16l1.62,-0.52l7.51,-0.17l0.48,0.82l1.36,0.22l0.48,-0.26l0.33,-0.83l1.64,-0.06l0.6,-1.07l2.41,0.21l0.96,-1.08l3.88,0.57l0.93,-2.56l-0.16,-0.46l-2.05,-0.76l-2.45,-3.45l-3.09,0.3l0.08,-6.9l12.91,-5.71l0.26,-0.16l-0.02,-1.14l1.37,-0.22l1.74,-1.12l8.38,0.78l31.65,-0.03l0.63,0.42l0.93,-0.32l8.1,-0.2l1.36,-1.08l5.13,-2.37l0.37,-1.83l1.09,-0.69l1.53,-0.77l1.43,0.04l0.33,-0.53l0.68,-0.16l0.58,-0.72l-0.33,-1.13l2.03,-0.8l0.55,-0.62l0.6,0.0l0.26,-0.49l-0.18,-0.88l1.01,-0.45l3.01,-0.14l-0.75,1.29l0.2,2.3l0.91,0.92l3.02,-0.1l-0.17,1.01l0.95,0.57l-0.9,-0.05l-0.95,0.37l-0.27,1.19l0.46,0.3l0.95,-0.15l0.17,0.27l-0.6,0.54l-1.35,0.09l-0.27,0.7l-2.39,1.45l-0.14,0.7l-0.63,0.43l0.17,1.18l-2.6,0.75l-0.4,0.61l-1.02,0.56l-1.7,0.12l-0.98,0.95l-1.3,0.62l-0.75,-0.04l-1.11,1.83l-0.81,0.41l-1.13,1.45l-0.31,1.64l-4.85,1.55l-3.23,3.25l-0.15,1.1l-0.58,0.22l-0.59,0.9l-0.94,0.08l-0.64,0.94l-1.2,-1.11l-1.58,-0.03l-2.64,2.36l-0.28,0.79l0.19,0.54l-1.0,1.58l0.68,0.55l-0.09,1.78l1.29,0.95l-0.28,0.55l-1.09,0.72l-0.44,2.71l-1.09,2.3l0.2,0.57l-0.54,1.7l0.42,1.13l0.94,0.39l-0.42,1.47l0.63,1.51l0.56,0.3l-0.13,0.83l-1.02,1.91l0.39,1.3l-0.72,1.03l0.13,1.14l-2.59,1.32l-8.98,0.16l-2.26,-0.26l-1.75,1.02l-0.42,1.48l-2.21,-0.32l-0.77,1.28l-2.08,-0.26l-0.64,0.9l-0.77,0.09l-0.38,1.01l-5.63,-0.88l-0.46,0.37l-0.13,0.64l-1.71,-0.27l0.16,-0.61l-0.26,-0.47l-2.72,-0.56l-0.43,0.22l-0.35,0.89l-1.91,-0.07l-0.39,0.94l-2.31,-0.23l-0.82,2.7l1.87,0.63l0.29,0.64l0.74,0.18l-0.05,0.68l-0.85,-0.39l-0.71,0.21l-2.36,2.69l-0.88,-0.63l-1.38,-0.28l-1.54,1.58l-2.13,0.16l-0.93,0.64l-1.29,-0.07l-0.29,0.78l-0.7,0.53l-0.17,2.98l-0.73,-0.05l0.14,-0.87l-0.28,-0.44l-2.25,-0.89l-0.04,-1.08l-2.88,-0.42l-0.24,-3.31l1.13,-0.77l0.44,-0.77l-1.31,-1.14l0.17,-0.77l-0.61,-1.98l0.26,-1.16l3.02,-0.98l1.01,-0.0l0.37,-0.36l0.7,-3.59l-0.47,-0.39l-1.54,-0.3l0.74,-2.84l0.86,-0.63l1.27,-5.1l-0.34,-0.49l-4.8,-0.37l-0.49,0.88l-1.24,-0.17l-0.51,0.29l-0.63,2.21l0.36,0.86l-2.65,-0.01l-0.53,0.2l-0.31,0.9l-0.46,-0.02l-0.1,-0.84l-0.8,-0.42l0.05,-2.05l-0.72,-1.49l1.67,-0.99l0.52,-0.73l0.17,-1.06l-2.65,-1.07l-0.53,-0.59l0.38,-1.71l-1.19,-1.8l-2.17,-1.26l-2.83,-0.62l-2.0,-1.29Z",name:"Komi, Respublika"},"RU-TYU":{path:"M238.12,234.54l-0.08,-0.68l0.71,-1.14l-0.22,-0.52l1.87,-0.86l0.92,0.26l0.88,-0.88l0.55,-0.02l0.27,-0.43l2.0,-0.93l-1.09,-2.33l-0.17,-1.73l1.95,0.14l1.89,-0.62l0.5,-0.58l-0.07,-1.49l0.54,-0.22l0.66,0.34l2.71,-1.32l0.89,-0.9l3.32,-0.59l1.14,-2.22l1.43,-0.42l2.54,-1.43l-0.07,-0.63l-0.8,-0.53l0.62,-0.24l0.89,-0.0l0.46,0.63l2.89,0.07l1.38,0.64l2.12,-0.34l1.1,0.33l0.82,-0.66l0.57,0.78l2.46,1.16l0.62,0.61l0.63,0.08l2.1,1.91l0.6,1.24l0.9,0.43l1.17,-0.37l-0.02,0.77l0.63,0.56l-0.19,0.66l0.32,0.26l2.23,0.36l0.99,-0.27l0.55,0.32l1.13,0.01l0.75,0.54l3.37,-0.07l1.73,0.52l-2.67,2.21l-1.97,1.17l-5.74,-0.1l-1.27,1.03l-3.56,-0.12l-0.94,-0.73l-3.52,0.3l0.21,-2.19l-1.34,-1.14l-1.45,-0.06l-2.72,5.07l0.28,1.18l0.73,0.79l0.37,0.98l-1.0,0.64l-0.1,0.58l1.29,1.65l0.95,-0.02l0.37,-0.41l-0.06,-0.52l0.92,-0.19l0.1,0.83l0.72,0.25l2.2,2.2l-0.48,0.66l-0.48,-0.1l-0.47,0.43l-1.59,-0.13l-0.12,1.25l-1.43,0.54l-0.05,0.59l0.69,0.3l-0.79,0.66l0.67,1.5l-0.61,0.23l-0.41,0.85l-0.84,0.06l-0.33,0.36l0.07,0.43l0.5,0.32l-0.1,1.12l0.88,0.46l-0.92,0.41l-0.47,0.7l0.07,0.7l-1.14,0.98l-2.69,-1.4l-1.91,-0.37l-0.53,0.29l-1.47,-0.66l-0.45,0.2l-0.11,0.46l-1.06,-0.57l-0.58,0.08l-0.85,-1.03l-0.53,-0.13l-0.13,-0.93l-1.53,0.22l-0.48,-0.4l-1.85,-0.05l-0.94,-1.71l-1.84,-0.22l-0.57,0.19l-0.65,-0.65l-1.41,0.69l-0.74,-0.73l-0.71,-0.1l-0.79,0.56l-0.96,-0.72l-0.95,-1.36l-2.07,-0.19l-1.11,-1.25l-0.01,-1.46l0.72,-0.11l0.57,-1.42l-0.38,-0.45l-0.67,-0.07l-0.29,-2.03l-0.54,-0.61Z",name:"Tyumenskaya oblast"},"RU-DA":{path:"M135.57,325.4l0.47,-1.03l-0.37,-0.49l-0.59,-0.13l1.77,-1.39l0.38,-1.24l3.5,0.28l1.54,0.7l-0.52,1.42l0.19,0.96l0.49,0.39l1.28,0.21l0.37,0.75l0.74,0.3l1.15,2.19l-0.65,1.19l0.63,1.09l-0.02,3.0l1.19,0.96l0.18,1.28l1.94,1.99l1.57,2.65l0.74,0.35l-0.8,1.27l-1.77,0.87l-0.91,1.45l-2.61,-0.57l-0.64,-1.53l-0.65,-0.21l-1.74,-1.8l-0.64,0.23l-1.98,-1.11l-1.39,-0.25l-1.4,-0.9l0.48,-1.13l2.24,-1.74l0.03,-0.77l1.18,-0.06l0.78,-0.63l0.01,-1.09l-0.49,-0.37l-0.46,-1.74l0.61,-1.36l1.08,-1.11l-0.56,-0.66l-0.55,-0.14l-0.47,-0.79l-0.73,0.03l-0.67,0.47l-0.08,0.41l-0.56,-0.52l-2.51,-0.39l-0.01,-1.04l-0.81,-0.26Z",name:"Dagestan, Respublika"},"RU-NVS":{path:"M292.37,246.79l0.75,-0.41l-0.21,-0.84l1.08,-1.0l0.79,-0.18l0.23,-0.45l2.06,-0.09l1.05,-0.46l-0.11,-0.76l-0.99,-0.69l0.19,-0.76l-0.68,-0.52l1.45,-1.43l-0.85,-3.53l3.78,0.43l7.7,0.19l0.24,0.29l5.89,1.42l3.53,3.55l4.71,-0.55l2.11,2.01l6.64,-1.14l0.58,-0.41l0.01,-0.46l1.0,-0.03l0.34,0.29l-0.43,0.41l-0.4,1.28l1.57,2.28l-0.78,1.15l0.74,0.91l2.05,-0.18l0.78,-1.31l0.77,-0.41l0.17,-0.6l1.04,-0.25l0.61,0.5l0.55,-0.2l0.01,0.71l0.45,0.44l-0.19,0.72l0.92,0.67l0.18,0.49l-0.64,0.86l0.11,0.47l1.1,0.18l-0.24,0.83l0.46,0.57l-0.17,1.24l0.9,0.99l-0.58,0.72l0.37,0.57l-0.27,0.68l0.41,0.59l-1.74,0.86l-0.8,1.15l-1.26,-0.4l-1.52,0.6l-2.11,0.04l-0.63,0.44l-0.05,0.72l-0.62,-0.86l-0.82,0.19l-2.44,2.04l-1.13,1.93l-0.96,-0.6l-0.21,-0.74l-0.65,0.18l-1.59,-0.67l0.53,-0.51l-0.12,-0.94l-1.34,-0.15l-0.73,-0.63l-1.67,-0.43l-1.04,-1.78l-0.54,-0.1l-2.24,1.9l-2.24,0.6l-1.23,1.02l-0.09,0.48l-0.76,0.07l-0.53,0.69l-4.79,0.57l-0.42,0.35l-0.03,0.51l-0.88,0.28l-0.36,-0.03l-0.43,-0.84l-1.46,0.26l-0.48,0.46l0.02,0.87l-0.43,0.23l-6.34,-4.34l-0.26,-0.58l1.06,0.02l0.97,-1.25l-0.01,-0.73l0.44,-0.53l-0.2,-0.46l-1.51,0.11l-1.19,0.85l-1.18,-0.19l-0.6,0.82l-1.72,0.67l-0.03,-2.19l0.53,-0.23l0.24,-0.7l-0.26,-0.79l-0.53,-0.21l-0.28,-0.65l-0.55,-0.13l-0.09,-0.57l-0.73,-0.15l0.12,-0.7l-0.64,-0.73l-0.03,-0.85l-0.61,-0.78l0.93,-0.94l-0.07,-0.5l-0.49,-0.33l-0.01,-0.56Z",name:"Novosibirskaya oblast"},"RU-AD":{path:"M101.12,320.84l1.19,0.38l1.67,-0.56l0.62,0.8l-2.32,-0.02l-1.15,-0.59ZM104.89,320.02l0.17,-0.25l1.02,0.49l-0.37,0.21l-0.29,-0.41l-0.53,-0.04ZM106.97,320.5l1.23,-0.14l1.53,1.47l-0.84,0.21l-0.52,1.06l0.43,0.86l0.11,1.17l-0.32,0.69l0.4,1.53l-0.43,0.9l-1.75,-0.92l-0.66,0.01l0.02,-0.67l0.37,0.36l0.6,-0.07l0.72,-1.32l-0.14,-0.46l-0.69,-0.16l-0.5,-0.53l0.49,-1.59l0.56,-0.52l-0.63,-1.87Z",name:"Adygeya, Respublika"},"RU-PER":{path:"M169.38,209.07l0.46,-1.52l2.11,0.28l0.64,-1.05l1.97,0.06l0.38,-0.94l1.94,0.35l-0.15,0.74l0.41,0.45l2.45,0.36l0.57,-0.99l5.52,0.86l0.4,-0.17l0.41,-0.99l0.77,-0.17l0.34,-0.71l2.07,0.26l0.8,-1.25l2.27,0.27l0.71,-1.74l0.76,-0.12l0.65,-0.64l2.0,0.28l8.42,-0.12l1.78,-0.39l1.35,-0.9l0.18,0.19l0.0,1.17l-0.49,0.46l-0.29,1.12l0.52,0.92l0.1,1.34l0.5,0.43l-0.4,2.48l-0.82,0.83l-0.99,3.35l-1.13,1.21l-0.77,0.2l-0.42,0.96l-0.65,0.13l-0.9,2.21l0.27,0.41l0.93,0.14l0.96,1.14l2.29,0.9l-0.31,0.66l0.26,0.71l-0.43,0.43l0.09,1.05l0.79,0.75l0.9,0.15l0.18,1.09l-0.73,0.38l-0.39,0.8l-1.02,0.71l-0.9,0.1l-0.99,0.92l-0.35,1.08l1.27,1.62l-1.29,0.98l-0.33,-0.67l-1.72,-0.08l-1.11,1.15l-0.35,1.84l0.49,1.52l-0.6,0.19l-1.19,1.13l-1.53,-0.11l-0.82,0.64l0.69,2.44l-0.25,1.56l-0.7,1.08l-1.09,0.41l-0.62,-0.79l-0.96,-0.41l-0.05,-0.73l-0.45,-0.16l-0.79,-0.02l-0.66,0.59l-0.71,0.07l-0.7,-1.12l-0.57,-0.05l-1.81,0.43l-0.63,0.46l-0.96,-0.22l-1.03,0.25l-2.28,-1.52l-0.58,0.23l-0.37,0.87l-1.31,-1.1l-0.28,-0.95l0.31,-0.38l0.01,-1.23l1.21,-0.28l0.41,-0.67l-0.4,-0.5l-0.04,-1.38l-0.74,-0.38l0.52,-0.67l-0.91,-1.54l0.3,-0.46l-0.35,-2.22l-1.38,-1.84l0.27,-0.75l-0.88,-1.94l0.22,-0.65l0.86,-0.63l-0.07,-0.41l-0.94,-0.86l0.6,-0.74l0.13,-0.75l-0.74,-0.47l-1.91,-0.11l-0.79,-1.24l0.73,-0.97l0.32,-1.25l0.92,-0.36l0.58,-2.71l-0.56,-1.12l-0.92,-0.59l-0.78,0.26l-5.01,-0.43l0.18,-0.83l-0.28,-0.76l-0.78,-0.31l-0.2,-0.58l-1.65,-0.4Z",name:"Permskiy kray"},"RU-ROS":{path:"M98.2,305.18l0.32,-1.33l1.94,-0.47l0.7,-1.2l4.41,0.29l0.5,-0.23l0.51,-1.99l0.85,-1.22l-0.49,-0.57l-0.33,-1.64l-0.91,-0.36l0.42,-0.71l0.65,0.18l0.63,-0.25l0.35,-0.69l-0.46,-0.52l-1.35,-0.19l0.9,-0.16l1.31,-1.48l0.1,-1.0l-0.58,-0.82l0.47,-0.58l1.51,0.21l2.29,-0.73l0.87,-0.83l0.38,-1.16l1.33,-0.87l0.73,0.94l1.44,0.51l1.38,1.19l-0.61,1.76l0.16,0.62l-0.28,0.5l0.28,0.94l1.52,0.09l0.29,0.68l1.22,0.46l0.38,0.83l-0.43,0.6l0.02,0.8l-1.75,0.33l-1.26,0.79l0.16,0.74l-0.35,0.46l0.01,1.79l2.56,0.21l1.1,0.96l1.26,2.35l0.89,-0.25l0.68,0.73l1.89,-0.23l0.72,0.21l0.11,0.89l0.34,0.25l0.98,0.04l0.27,-0.88l0.73,-0.16l0.15,-0.64l0.33,0.18l-0.34,3.4l-0.85,0.35l-0.93,0.9l-0.6,0.98l0.54,0.96l-0.66,0.0l-0.74,1.33l-1.05,0.1l-2.17,-1.7l-1.7,0.16l-1.09,-0.77l-1.48,-0.36l-0.99,0.53l0.44,1.26l-0.6,0.14l-0.48,0.8l-0.56,-0.34l-0.7,0.37l0.08,1.15l-1.11,-0.08l-0.38,0.29l-0.52,-0.02l-0.3,-0.67l-0.64,-0.43l0.11,-0.73l-0.5,-0.41l-0.6,0.38l-0.73,-0.31l-1.83,0.01l-0.61,-1.53l-0.6,-0.17l0.13,-1.16l-0.57,-0.29l-3.23,-0.35l-1.38,0.38l-0.48,0.98l-0.82,-0.18l0.23,-0.68l-0.44,-0.6l0.94,-0.5l1.18,0.04l0.65,-0.71l0.01,-0.7l-0.38,-0.15l-0.39,-0.87l-1.16,-0.15l-0.85,0.36l-0.39,-0.39l-1.55,0.4l-0.68,0.63l-0.46,0.05l0.34,-0.57l-0.35,-0.51Z",name:"Rostovskaya oblast"},"RU-PRI":{path:"M582.51,335.16l1.39,-0.43l0.97,0.08l0.78,-0.45l0.05,-0.92l0.56,-0.67l0.52,-1.73l-0.12,-0.73l-0.42,-0.36l-0.03,-1.5l0.48,-1.85l-1.04,-4.05l-0.45,-0.7l0.28,-0.3l2.03,-0.47l1.77,-2.09l0.49,0.42l0.08,1.0l0.52,0.36l-0.4,1.03l0.25,0.81l0.7,0.43l0.36,0.71l1.1,0.17l1.42,-1.21l0.13,-0.97l0.83,-1.02l0.65,0.04l0.97,-0.77l0.32,-2.39l1.2,-0.48l0.44,-0.71l0.09,-1.15l0.73,-0.5l0.38,-1.43l1.02,-0.99l-0.03,-1.87l2.63,-0.62l0.36,-0.97l-0.26,-0.48l1.17,-1.31l1.6,-0.03l0.43,-0.46l1.03,0.63l-0.1,0.74l0.31,0.41l1.62,-0.12l0.8,0.76l0.76,0.23l0.7,-0.29l0.97,0.45l1.91,-0.15l2.17,-1.66l-0.11,-0.67l0.43,-1.0l1.35,0.62l0.64,-0.03l2.27,-1.25l1.3,-1.11l-0.43,-1.58l-2.14,-0.59l-0.03,-0.79l-1.27,-1.15l0.88,-0.39l1.47,0.1l1.82,-0.84l0.41,-0.68l0.65,0.16l0.24,1.2l0.46,0.37l-0.2,0.84l1.18,1.1l-1.51,0.9l0.03,0.57l0.38,0.24l-0.27,0.69l0.64,0.49l1.58,0.16l-2.1,2.05l-1.12,2.42l-0.06,0.79l-0.69,0.57l-0.87,1.95l-4.62,5.04l-1.76,1.21l-0.26,0.67l-2.23,2.09l-0.89,1.74l-1.62,0.81l-1.16,1.48l-0.16,0.72l-0.86,0.69l0.13,0.72l-0.54,0.53l-0.74,0.03l-0.56,1.4l-4.77,2.68l-1.3,1.15l-2.18,0.44l-1.81,0.79l-0.66,-0.78l-0.92,0.14l-0.06,-0.46l-0.4,-0.24l-0.94,0.36l-0.29,-0.44l-0.79,-0.1l0.41,-1.35l-0.5,-0.99l-0.54,-0.01l-0.79,0.75l0.02,-0.69l-1.53,-0.27l-1.64,2.15l-0.96,0.63l0.09,0.53l-0.7,0.48l-0.2,0.66l-1.85,-0.38l-0.72,0.06l-0.41,0.38l-0.31,-0.24ZM583.14,336.12l0.54,0.39l-0.34,0.45l-0.39,-0.42l0.19,-0.43Z",name:"Primorskiy kray"},"RU-KB":{path:"M120.09,331.7l0.4,-1.94l0.83,-0.37l0.21,-0.78l2.34,-0.78l0.28,0.68l0.43,0.18l0.67,-0.4l1.6,0.14l0.78,-0.94l0.89,0.19l0.67,0.24l0.0,1.05l0.67,0.62l-0.2,0.73l-1.36,0.14l-0.41,0.85l-0.92,-0.12l-1.4,2.2l-0.53,-0.06l-0.38,0.36l-0.8,-0.23l-0.91,-1.04l-0.82,-0.41l-1.38,0.11l-0.66,-0.43Z",name:"Kabardino-Balkarskaya Respublika"},"RU-AL":{path:"M339.15,279.83l0.66,-1.04l1.0,-0.05l2.76,-1.39l1.17,0.13l0.62,-0.63l0.7,-0.1l0.43,-0.91l1.15,-0.59l0.88,-1.99l2.09,0.45l0.59,-0.18l0.34,-0.58l1.4,-0.05l0.4,-0.58l-0.06,-1.05l-0.92,-0.67l0.83,-1.33l1.13,-0.14l0.24,0.44l0.86,0.04l0.34,0.57l1.41,0.43l1.48,-0.68l1.45,0.91l0.78,-0.21l-0.23,1.48l-1.37,0.43l-1.37,2.05l0.17,0.68l0.79,0.17l-0.79,1.31l0.48,0.63l2.48,1.15l1.23,-0.19l0.67,-0.69l0.1,-0.7l0.75,0.62l-0.08,1.28l0.54,0.49l0.12,0.83l1.76,1.46l1.55,1.94l0.87,0.34l-0.62,0.19l-1.07,-0.42l-1.1,2.06l0.2,0.41l0.74,0.17l0.74,2.71l-1.23,0.63l-0.88,-0.27l-0.34,0.32l0.05,0.57l-0.62,0.23l-0.7,-0.53l-0.49,0.68l-0.81,-0.36l-2.42,0.31l-0.61,0.83l0.08,0.6l-0.7,0.48l-1.23,0.07l-1.55,0.58l-0.47,-0.85l-1.18,-0.28l-1.01,-1.19l-0.12,-0.57l-0.72,-0.37l0.48,-0.28l0.05,-0.89l-0.27,-0.36l-1.23,0.02l-2.01,1.87l-2.93,-0.82l-1.77,0.22l-0.77,-1.74l-0.46,-0.31l0.35,-0.47l-0.39,-0.71l-2.87,-1.21l-0.87,-0.07l-0.55,-2.08l1.96,-0.27l0.51,-1.39l-0.7,-1.12l-1.85,-0.49Z",name:"Altay, Respublika"},"RU-NEN":{path:"M125.16,141.24l2.8,1.07l6.93,0.06l1.39,0.27l1.66,0.54l0.61,1.15l2.23,1.38l-0.18,0.24l1.34,2.29l-1.46,-0.09l-5.55,0.87l-0.4,0.56l0.19,0.65l-0.7,0.07l-0.84,0.56l-0.62,0.88l-0.09,0.77l0.4,0.83l3.28,1.39l1.43,2.44l1.24,0.57l2.02,-0.29l-0.66,0.66l0.49,0.38l1.13,-0.63l4.23,-0.98l0.64,0.53l0.45,-0.08l0.24,-0.79l0.75,-0.84l-0.19,-1.5l0.43,-0.49l-0.06,-0.78l0.89,-0.91l-0.59,-1.24l0.46,-0.24l0.57,0.43l0.99,-0.84l1.07,0.2l0.89,-0.39l2.32,0.65l0.2,-0.78l-1.42,-0.88l-0.03,-0.36l1.43,-0.02l3.47,-1.52l0.39,0.1l4.79,-3.12l1.47,0.12l2.76,-0.79l0.12,-0.48l1.86,-0.34l0.56,0.42l0.69,-0.18l-0.73,0.49l0.63,1.06l1.28,-0.1l1.87,-1.26l-0.06,-0.73l-0.89,-0.59l0.53,-0.37l-0.09,-0.56l4.45,-1.86l0.54,0.58l1.02,-0.17l-1.03,1.78l1.08,2.01l-0.3,0.19l-0.88,-0.45l-0.49,0.19l0.03,0.27l-1.33,0.17l-0.75,0.91l0.43,0.7l2.99,0.03l0.53,0.27l1.2,-0.25l0.47,0.36l1.52,-0.89l0.77,1.11l1.12,0.08l0.7,-0.87l0.05,-1.32l2.18,-1.35l1.63,-0.12l1.43,-0.73l0.99,0.35l1.31,-0.05l0.09,0.31l0.89,-0.46l1.13,0.64l2.64,0.06l0.53,-0.25l1.06,-1.38l1.53,-0.07l0.58,-0.56l0.0,-0.46l0.44,-0.14l1.1,1.31l0.63,-0.1l0.28,-0.39l-0.83,-1.17l2.59,-0.73l0.22,0.57l0.96,0.24l1.35,1.04l-0.89,0.09l-0.82,0.84l0.18,2.41l3.52,0.81l1.09,-0.5l0.67,-1.06l-0.23,-0.82l-0.74,-0.86l3.36,-0.27l1.7,-1.47l1.17,-0.51l-0.45,-2.34l-0.99,-0.63l-0.57,0.44l-0.28,-1.52l-1.98,-2.43l2.44,-0.36l0.48,-0.8l-0.12,-0.69l0.83,-0.25l4.38,0.97l4.54,0.19l4.04,0.65l5.88,2.01l1.49,0.87l-0.41,0.52l-0.15,0.96l-1.29,1.22l0.19,1.57l0.44,0.32l1.31,-0.15l1.3,0.65l1.03,0.03l0.33,1.01l1.16,1.09l-0.44,0.54l-3.75,0.23l-1.22,0.5l-0.46,0.53l0.09,0.79l-0.91,0.7l-2.55,0.99l-0.16,0.37l0.45,0.69l-0.08,0.66l-0.68,0.14l-0.37,0.42l-1.21,0.0l-1.69,0.85l-1.39,1.0l-0.21,1.61l-4.98,2.27l-0.98,0.96l-8.15,0.21l-0.68,0.25l-0.18,-0.35l-32.25,0.03l-8.54,-0.77l-2.44,1.38l-1.11,0.11l-0.32,1.37l-12.72,5.63l-4.67,-0.02l-2.11,1.68l-0.22,1.03l-2.76,-0.09l-4.05,-1.8l-2.71,-0.52l-0.57,0.14l-4.48,-1.42l-2.72,-1.5l0.5,-1.29l0.61,-0.2l0.26,-0.6l-0.81,-0.74l0.43,-0.44l-0.01,-1.28l-0.69,-0.86l0.11,-0.56l-2.01,-0.73l-1.07,-0.07l-0.07,-0.47l1.35,-3.12l0.62,-0.4l-0.18,-1.6l0.69,-0.41l-0.04,-0.67l-0.29,-0.19l1.24,-0.63l-0.26,-0.44l-0.92,0.02l0.3,-1.59l-0.55,-0.8l-4.04,-2.35ZM204.93,126.61l0.88,0.25l0.48,-0.53l-0.88,-0.87l0.53,-0.65l0.86,-0.3l1.46,0.82l1.01,0.97l0.22,0.63l2.55,1.02l2.07,1.32l0.29,0.91l-1.08,0.84l-0.97,-0.31l-0.76,0.28l-1.3,-0.14l0.14,-0.78l-1.19,-0.92l-2.84,-0.41l-0.88,-0.58l-0.43,-0.46l-0.15,-1.09ZM150.72,137.62l0.42,-2.32l1.15,-1.05l1.62,-0.75l1.75,-0.0l4.82,2.49l-1.42,0.85l-1.26,1.69l-2.31,0.91l-2.14,0.42l-0.36,-0.21l-0.66,0.21l-1.0,-0.74l-0.63,-0.76l0.04,-0.74Z",name:"Nenetskiy avtonomnyy okrug"},"RU-ALT":{path:"M306.13,264.04l1.11,-0.8l-0.06,-0.7l0.58,0.59l0.93,0.1l1.49,-0.39l0.07,-0.72l2.98,-0.26l0.39,-0.26l0.54,0.19l0.87,-0.33l0.6,-0.72l0.97,-0.19l0.2,-0.63l1.02,-0.8l0.49,0.14l1.59,-0.53l0.47,-0.6l1.57,-0.78l0.88,1.19l1.79,0.47l0.43,0.96l1.21,-0.2l-0.44,0.7l0.67,1.07l1.01,0.11l2.68,1.76l0.78,-0.31l0.05,-0.73l0.95,-1.53l1.96,-1.63l1.14,0.81l0.59,-0.26l0.34,-1.1l1.25,-0.04l0.49,0.28l1.31,-0.71l1.58,0.38l0.7,-0.41l0.71,-1.08l2.04,-0.94l1.45,1.91l0.96,-0.12l1.64,1.31l0.99,0.34l1.21,1.36l0.34,1.16l0.7,0.7l1.77,0.56l-0.2,0.58l-0.92,0.22l-0.26,0.48l0.32,0.6l1.59,0.94l-0.45,1.18l0.69,1.1l-1.18,0.15l-1.2,1.93l0.11,0.57l0.76,0.43l0.15,0.69l-1.39,-0.04l-0.59,0.74l-1.02,-0.41l-1.39,-0.02l-0.68,0.79l-0.02,0.55l-0.45,0.26l-0.05,0.63l-0.93,0.43l-0.49,0.91l-0.74,0.01l-0.27,0.54l-1.28,0.02l-2.96,1.45l-0.76,-0.07l-0.73,1.03l-0.85,0.1l0.08,1.11l2.54,0.71l0.34,0.66l-0.19,0.42l-2.06,0.39l-1.25,-1.52l-2.74,-0.97l-1.28,0.08l-0.63,0.75l-1.35,-0.12l-0.46,0.83l-0.73,0.37l-0.96,-0.16l-0.79,0.32l-2.12,-0.57l-1.21,0.37l0.05,-0.55l-0.64,-1.02l-1.36,0.15l0.45,-1.08l-0.23,-0.6l-0.76,0.03l-0.7,-0.75l-1.25,-0.13l-0.69,0.68l-0.95,0.28l0.08,1.58l-1.41,0.68l-0.57,-0.02l-4.68,-7.85l-6.29,-9.18ZM321.82,256.89l-0.01,-0.01l0.0,-0.0l0.0,0.01Z",name:"Altayskiy kray"},"RU-KDA":{path:"M90.51,319.49l0.79,-0.37l0.37,0.32l0.86,-0.09l1.43,-0.64l0.27,0.35l1.16,-0.13l0.3,-0.96l-0.34,-1.63l0.89,-0.98l0.35,0.29l0.5,-0.11l0.72,-1.96l0.98,0.65l1.06,-0.19l-0.1,-1.02l-1.33,-0.69l-1.18,-1.2l-0.91,-0.07l-0.45,-0.71l0.69,0.03l1.3,-0.55l1.87,0.3l0.31,-0.72l-0.66,-0.54l0.42,-0.06l0.94,0.28l-0.19,0.95l0.21,0.42l2.04,-0.08l0.68,-0.98l0.74,-0.22l2.84,0.25l-0.15,1.16l0.93,0.35l0.08,1.0l0.64,0.59l3.14,0.4l0.92,0.97l0.52,1.42l-0.31,0.43l-1.46,-0.02l-0.28,1.52l0.83,0.98l0.44,1.31l1.41,-0.06l0.0,0.52l0.67,0.91l0.91,0.17l-0.5,0.9l-0.63,0.18l-0.15,0.42l1.31,1.48l-0.3,0.71l0.56,0.64l-1.18,1.21l-0.62,-0.48l-2.29,-0.37l-0.43,0.41l0.39,0.7l-0.65,0.35l-0.41,0.97l-0.1,1.39l-0.59,0.2l-1.93,-0.44l-0.59,0.2l-0.41,0.7l-6.1,-5.35l-2.91,-0.77l-2.27,-2.19l-0.5,0.5l-1.01,-0.15l-1.47,-1.98l-2.07,-0.86ZM100.52,320.11l-0.74,0.18l0.04,0.91l2.28,1.02l2.69,0.02l1.47,-1.18l0.43,1.07l-0.36,0.15l-0.73,2.56l1.35,1.02l-0.17,0.18l-0.67,-0.6l-0.67,0.11l-0.26,0.59l0.1,1.56l3.15,1.33l0.71,-0.23l0.73,-1.48l-0.47,-1.54l0.37,-0.6l-0.18,-1.43l-0.37,-0.48l0.29,-0.66l0.68,1.05l-0.23,0.27l0.2,0.51l0.99,-0.02l0.25,-0.54l-0.16,-0.92l-1.14,-2.1l-1.63,-1.24l-1.78,0.08l-1.5,-0.75l-0.64,0.14l-1.32,1.15l-1.07,0.19l-0.83,-0.56l-0.82,0.24ZM96.4,314.68l0.03,-0.16l0.06,0.07l-0.1,0.1Z",name:"Krasnodarskiy kray"},"RU-YEV":{path:"M582.91,296.53l0.65,-1.68l1.47,-0.24l1.01,-1.84l1.3,0.31l1.72,-0.73l1.13,0.51l0.68,-1.67l0.95,0.44l-0.07,0.53l0.33,0.29l1.95,-0.09l0.35,0.51l1.73,0.41l0.55,2.06l0.34,0.33l2.18,0.38l1.01,0.83l1.04,0.07l1.38,-0.69l0.86,0.9l1.94,0.05l-0.81,0.68l-1.31,-0.27l-4.18,1.13l-1.07,1.02l-2.31,-0.05l-1.45,1.07l-0.87,0.07l-0.62,1.5l-0.94,-0.19l-3.73,0.45l-0.98,-0.49l-1.79,0.45l-0.36,-0.13l-0.27,-1.14l-1.13,-1.07l0.78,-1.73l-0.44,-1.25l-0.61,-0.19l-0.41,-0.55Z",name:"Yevreyskaya avtonomnaya oblast"},"RU-AMU":{path:"M526.12,238.76l2.7,-1.29l2.96,-0.26l0.91,0.43l1.77,0.05l0.93,1.71l2.86,0.04l1.51,0.93l0.78,0.9l1.29,-0.02l0.36,-0.51l2.1,1.06l3.19,0.3l0.7,1.03l0.73,0.46l0.25,0.68l0.78,0.41l0.2,0.77l0.52,0.41l0.97,-0.2l1.51,0.58l1.51,-0.39l0.67,0.19l0.89,0.87l1.43,-0.44l0.97,0.47l-0.09,0.55l0.42,0.54l1.99,0.22l0.93,-0.68l0.65,0.37l0.95,-0.17l0.45,-0.44l1.03,-0.07l1.63,0.98l0.65,-0.31l0.35,-0.64l0.37,0.39l0.73,0.06l1.66,-0.29l1.34,1.07l2.55,0.39l0.85,-0.37l0.14,-1.12l2.64,-0.56l1.92,0.41l3.51,-0.27l2.15,0.8l2.5,0.02l0.39,-0.27l0.88,0.25l1.7,-0.23l0.65,-0.4l1.14,0.15l0.4,0.48l0.02,0.62l0.52,0.43l-0.38,0.39l-0.05,0.79l-1.36,0.12l-0.12,1.03l-1.41,0.04l-0.68,0.52l0.05,0.67l-2.1,1.12l-0.76,0.06l-1.16,0.86l-0.49,2.14l-0.76,-0.17l-1.43,0.68l-1.03,1.03l-0.57,1.85l0.49,0.41l1.2,0.04l1.31,0.79l0.98,-0.31l1.38,0.32l0.55,2.82l-0.42,0.52l0.09,0.46l1.96,0.05l0.6,0.71l0.9,-0.1l0.42,-0.56l3.93,-0.07l0.55,-0.37l1.04,-0.08l0.47,-1.05l1.78,-0.72l0.48,0.51l1.67,0.27l1.53,-0.65l0.78,0.01l0.58,-0.62l1.1,0.99l-0.17,0.71l0.55,0.49l-1.55,2.74l0.18,1.16l0.43,0.31l-0.49,0.48l-0.15,0.74l-3.37,-0.67l-3.19,-1.11l-0.63,0.48l-0.1,0.74l0.08,0.99l0.8,1.06l-0.16,0.15l-2.61,0.15l-2.28,1.53l-0.15,0.86l-0.34,0.2l-1.2,0.02l-1.75,0.85l-1.75,0.03l-0.31,1.07l0.54,1.1l-0.85,0.04l-0.58,0.73l-0.7,0.16l-0.74,1.49l-0.74,0.23l-0.24,0.64l0.22,0.38l-0.86,1.62l0.58,0.74l1.19,-0.31l-0.59,0.83l0.3,0.76l0.62,0.32l0.58,-0.27l0.27,0.52l0.61,-0.05l0.5,0.89l-0.54,0.54l-0.1,0.71l0.28,0.41l0.76,0.11l-0.09,0.83l-0.64,0.51l0.23,0.6l0.53,0.24l-0.04,1.1l-0.35,0.78l-1.29,0.21l-0.89,1.7l-0.67,-0.09l-1.37,0.86l-0.56,-0.28l-0.94,0.2l-1.43,-1.0l-1.11,-1.55l-0.9,-0.23l-0.11,-0.6l-0.45,-0.37l-2.06,0.42l-2.07,-1.65l-2.74,0.42l-1.09,-0.43l-0.58,0.12l-0.59,-0.39l-0.34,-0.75l-0.6,-0.22l-0.11,-1.21l0.54,-1.3l-0.31,-0.46l-1.01,-0.44l-0.15,-0.96l0.29,-0.78l-0.43,-1.23l-1.87,-2.21l-0.12,-0.78l0.37,-0.92l-0.87,-0.94l-0.07,-0.69l-0.44,-0.26l-0.01,-1.0l-1.32,-1.7l0.47,-0.71l-0.03,-0.55l-0.8,-0.39l0.14,-0.66l-0.37,-0.2l-0.1,-0.58l-1.5,-1.52l0.21,-1.13l-0.85,-0.22l-1.63,-1.86l-2.85,-1.18l-1.97,0.39l-0.42,-0.37l-1.3,-0.21l-0.74,-0.96l-0.86,-0.0l-0.67,-0.59l-1.83,-0.75l-2.15,-0.1l-2.1,0.67l-2.23,0.13l-0.63,-0.28l-1.08,0.34l-0.55,-2.48l-1.48,-1.67l0.62,-0.42l-0.33,-1.7l0.83,0.43l1.18,-0.31l0.33,-0.46l-0.09,-0.55l-0.95,-0.75l-0.28,-1.7l-0.69,-0.05l0.97,-0.91l0.04,-1.02l0.43,-0.54l-0.38,-0.48l0.12,-1.92l-0.57,-1.01l-0.72,-0.19l-2.02,0.88l-0.17,-1.38l0.23,-0.58l-1.03,-1.87l-1.87,0.02l-2.4,1.05l-0.93,-0.35l-0.51,-0.9l0.52,-0.39l1.73,-0.34l0.19,-0.79l-1.35,-0.92l-0.23,-0.61l-1.59,-0.27l-0.53,-0.54l0.08,-0.83l-0.62,-0.43ZM541.57,241.17l0.0,-0.0l-0.0,0.0l-0.0,-0.0Z",name:"Amurskaya oblast"},"RU-BRY":{path:"M61.71,266.14l0.42,-0.84l0.83,-0.07l1.66,0.86l1.05,0.06l1.06,-0.4l1.19,-1.13l1.13,-0.34l0.13,-0.6l0.7,-0.22l0.33,-1.08l1.96,-1.71l-0.06,-0.82l1.59,-0.51l0.97,1.07l1.65,0.03l0.54,0.4l0.95,0.97l0.04,1.29l0.35,0.59l2.25,0.34l0.95,1.84l-0.27,0.35l-0.73,0.02l-1.03,0.94l0.51,1.01l0.71,0.26l-0.18,1.05l-0.84,0.78l0.3,0.88l-0.18,0.33l-0.85,0.22l-0.02,0.87l-0.76,0.02l-1.07,1.17l-0.68,-0.72l-0.13,-1.09l-1.76,-1.49l-1.17,0.28l-2.03,-0.32l-1.4,0.84l-2.95,-0.52l-0.63,1.65l-1.39,0.29l-1.5,-1.51l-0.07,-1.26l0.23,-0.26l-0.55,-0.94l0.24,-0.86l-1.47,-1.71ZM63.77,271.87l0.01,-0.01l-0.01,0.03l-0.0,-0.02Z",name:"Bryanskaya oblast"},"RU-SMO":{path:"M59.08,253.23l1.16,-1.47l-0.19,-1.03l-0.82,-1.03l0.48,-0.38l0.05,-1.59l0.63,-0.93l0.53,0.25l1.97,-0.2l0.83,0.22l0.87,-0.4l0.65,0.79l1.65,-0.3l1.06,0.32l0.81,-0.23l1.05,0.39l1.4,-0.07l2.0,-0.9l1.04,-1.26l0.7,-0.08l0.32,-0.81l1.36,-0.11l0.36,0.51l1.87,0.65l2.08,-0.48l0.59,0.23l0.64,0.97l-0.13,0.44l0.3,0.6l-0.47,0.5l0.05,1.8l0.28,0.53l-0.46,1.02l-1.21,1.13l-0.83,0.3l-0.09,1.05l-0.72,0.29l-1.47,-0.02l-0.07,0.53l0.31,0.21l-0.47,0.79l-0.97,-0.67l-2.4,0.01l-0.58,0.79l0.1,1.29l-0.37,0.32l0.09,0.41l-0.95,1.26l-0.86,0.38l-0.01,0.98l-1.81,1.76l-0.1,0.76l-1.75,-0.72l0.4,-0.66l-0.46,-0.53l-2.0,-0.72l-1.22,0.2l0.17,-1.66l-2.71,-1.45l-0.55,-1.5l-0.54,-0.34l0.33,-0.53l-0.13,-0.52l-1.84,-1.11Z",name:"Smolenskaya oblast"},"RU-CU":{path:"M138.63,246.88l0.8,-0.72l0.6,-1.69l1.33,-0.52l1.14,0.07l1.74,-1.19l1.12,-0.34l0.61,1.08l2.23,0.35l0.62,1.33l1.61,0.83l-1.16,0.53l-0.48,0.69l0.12,0.54l-0.99,1.25l-0.83,0.37l0.2,1.19l1.71,-0.04l-0.7,0.66l0.1,0.64l-0.62,0.09l-0.8,0.69l-1.09,-0.33l-0.49,1.18l-0.62,0.46l-0.73,-0.21l-0.91,0.36l-2.03,-0.91l0.03,-0.65l-0.64,-0.55l-0.11,-0.64l-0.58,-0.39l-0.48,0.13l0.09,-0.47l0.69,-0.48l-0.01,-0.71l0.62,-0.28l0.28,-0.66l-2.37,-1.66Z",name:"Chuvashskaya Respublika"}},height:344.85258690118116,projection:{type:"mill",centralMeridian:11.5},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","se_mill",{insets:[{width:900,top:0,height:1452.0211302823068,bbox:[{y:-9262763.575792028,x:1223668.3208382255},{y:-6888448.113700481,x:2695330.0420880616}],left:0}],paths:{"SE-O":{path:"M30.44,1096.25l0.92,2.76l-0.08,6.39l0.24,0.37l2.22,0.95l4.39,0.22l4.65,-0.92l3.73,-2.88l2.0,-5.35l1.04,-4.84l2.48,-7.09l0.23,-4.85l1.83,-6.22l2.29,-4.33l5.69,1.46l1.9,-0.2l1.65,-1.07l0.8,0.08l7.15,4.43l0.98,0.15l0.89,-0.2l1.17,-0.93l0.16,-3.08l1.06,-0.69l3.83,-0.61l1.79,0.26l1.16,0.69l1.65,3.03l1.12,0.68l5.49,1.98l1.1,0.12l5.83,-1.35l1.0,0.11l0.33,0.22l-0.42,0.24l-3.27,0.56l-0.59,0.97l0.73,1.31l2.93,1.37l1.47,1.14l1.33,0.14l1.61,-0.68l1.31,-0.14l1.45,1.83l1.29,0.75l0.94,-0.3l1.0,-1.04l1.4,-2.24l2.16,-1.58l1.24,-0.1l3.68,2.8l0.79,0.9l0.47,1.37l0.96,6.18l5.55,7.34l4.96,17.51l24.53,7.29l6.04,0.02l2.09,-0.43l2.2,-0.84l0.91,-0.94l-0.22,-1.16l-3.96,-5.63l-0.29,-1.45l2.81,-7.77l2.38,-4.53l2.37,-3.17l1.59,-1.77l2.62,-2.1l2.13,-1.18l1.72,-0.31l41.61,1.01l1.61,0.52l3.98,2.19l2.69,6.26l3.08,5.78l0.13,3.53l0.75,1.56l3.8,4.77l0.92,1.65l0.5,3.39l0.64,1.17l1.95,0.86l2.64,0.31l0.54,0.23l0.67,1.19l0.84,0.16l2.71,-1.37l0.69,-0.66l0.62,-1.26l0.6,-0.22l1.12,0.22l1.22,0.7l1.12,1.98l0.88,2.52l1.5,1.67l4.16,2.51l-25.87,41.52l-13.05,22.06l0.84,4.96l-0.25,1.08l-0.77,1.13l-3.41,2.21l-9.04,3.69l-0.72,1.02l-0.52,2.22l-0.72,0.53l-0.93,-0.16l-3.24,-1.96l-1.6,-0.49l-7.15,0.63l-1.59,-0.33l-3.7,-0.08l-0.4,0.5l1.14,4.34l-0.06,2.56l-1.69,2.51l-1.18,3.46l0.36,4.35l-0.24,0.96l-2.14,3.5l-0.3,5.1l-0.49,1.23l-3.0,2.92l-2.88,3.7l-4.54,7.19l-3.69,2.55l-4.16,4.12l-2.73,1.94l-3.98,1.82l-1.2,1.32l-1.49,3.13l-1.52,0.36l-1.44,1.0l-1.72,1.85l-3.73,5.61l-2.23,2.18l-3.86,-0.99l-2.49,-2.44l-4.5,-0.66l-0.92,-0.76l-0.51,-1.15l0.1,-0.82l1.5,-2.85l0.11,-1.26l-0.46,-0.63l-5.98,-0.8l-1.14,-0.37l-1.95,-1.42l-3.31,0.59l-1.35,-0.56l-3.11,-3.23l-2.04,-1.13l-5.61,-0.39l-3.21,2.29l-2.4,2.91l-1.88,0.68l-2.28,-0.38l-0.74,-0.95l-2.65,-6.17l-0.1,-1.16l1.52,-3.42l-0.01,-1.84l-1.76,-2.17l-3.66,-3.37l-0.36,-1.35l0.26,-4.45l-0.18,-3.16l-2.1,-3.37l-0.46,-0.16l-10.62,3.51l-5.09,0.77l-7.64,-1.35l-2.66,0.29l0.14,-3.61l-1.49,-0.68l-0.48,0.29l-0.33,1.26l-0.59,0.48l-0.44,-0.06l-0.56,-2.31l-1.5,-2.7l0.53,-1.68l4.46,-0.54l0.96,-1.57l-0.04,-0.47l-3.69,0.8l-1.88,-0.0l-1.59,-0.25l-3.41,-1.57l-1.68,-0.17l-0.43,0.46l0.22,1.38l-1.64,0.13l-0.69,-0.34l0.06,-1.85l6.36,-5.04l0.74,-1.12l-0.49,-0.95l-1.26,-0.22l-2.52,0.46l-4.26,-5.02l-1.43,-0.22l0.82,-0.76l1.58,-0.6l0.3,-0.52l-0.63,-1.81l0.69,-0.75l3.44,-1.02l0.29,-0.38l0.0,-0.61l-0.86,-0.4l0.83,-0.49l0.45,-0.96l-0.19,-0.53l-1.71,-0.83l0.37,-1.29l2.93,-4.09l0.95,-2.61l0.17,-1.59l-1.32,-3.11l0.17,-0.69l0.89,-0.69l-0.25,-1.35l1.55,-0.47l0.7,-1.79l0.81,-7.01l2.34,-0.58l1.03,-1.88l-0.43,-0.53l-1.68,-0.1l-0.47,-0.64l-0.48,-2.56l-2.11,-2.55l-0.29,-2.1l0.99,-1.21l3.78,-1.58l0.18,-0.59l-1.25,-1.41l-1.54,0.31l-2.79,1.54l-3.64,-0.3l-1.8,0.27l-0.34,0.38l-0.06,1.18l-0.69,0.38l-2.35,0.09l-4.12,2.92l-2.47,2.63l-1.73,0.04l-1.68,-0.7l-0.48,0.08l0.56,1.72l-1.34,-0.34l-0.51,-1.21l0.45,-2.01l1.03,-2.46l1.52,-2.73l1.7,-2.08l3.7,-3.26l-0.04,-0.63l-0.61,-0.42l0.63,-0.72l0.96,-0.69l2.2,-0.84l0.17,-0.62l-1.18,-1.51l-0.46,-0.13l-1.75,0.69l-2.4,2.57l-2.09,-5.56l-0.81,-0.29l-0.4,0.46l0.43,2.87l-0.11,3.37l-0.67,3.34l-1.27,2.76l-1.82,2.3l-1.92,1.77l-3.66,2.25l0.82,-1.3l1.94,-1.77l0.0,-0.73l-0.44,-0.4l-1.16,0.15l-1.82,0.81l-0.33,-0.13l-0.28,-0.94l0.31,-0.87l0.66,-0.64l3.06,-0.44l0.3,-0.62l-1.68,-2.11l0.08,-2.26l-0.43,-0.41l-1.46,0.24l-1.67,3.3l-1.66,0.79l4.6,-7.79l0.59,-1.41l-0.19,-0.51l-0.52,0.16l-0.58,1.03l-2.85,3.11l-1.64,1.18l-0.98,2.02l-1.6,0.64l-1.75,-0.56l-1.87,0.01l-1.59,2.38l-0.32,-0.64l0.34,-1.9l-1.37,-3.0l0.26,-1.45l0.71,-0.43l2.29,0.25l0.43,-0.5l-0.47,-1.83l0.51,-0.76l1.19,-0.71l1.03,-1.09l-0.11,-0.63l-2.37,-1.16l-1.15,-2.23l0.91,-1.06l0.2,-3.53l1.59,-1.33l0.51,-1.11l-0.37,-0.55l-0.9,0.0l0.09,-1.07l-1.11,-1.32l0.46,-2.65l-0.66,-1.6l-2.62,-2.99l0.47,-2.63l-0.17,-0.45l-0.6,-0.3l-1.54,0.01l-0.43,-0.56l0.07,-1.56l0.66,-1.42l1.25,-0.39l0.27,-0.46l-0.23,-1.23l1.67,-2.86l0.0,-4.47l-0.65,-0.9l-1.39,-0.51l-0.27,-0.7l-0.0,-2.35l-0.47,-1.96l0.46,-1.36l-0.29,-0.48l-3.42,-0.86l-1.69,-0.89l-0.63,-1.01l0.51,-1.22l4.36,-2.16l0.23,-0.46l-0.41,-0.31l-2.78,0.18l-1.04,-0.36l-0.42,-1.13l0.26,-1.08l4.94,-5.8l1.68,-0.94l6.7,-0.92l2.02,0.7l1.4,4.79l1.23,2.33l1.46,1.94l1.06,0.97l0.55,0.11ZM32.09,1185.22l-0.46,-1.26l-2.63,-2.55l0.12,-1.16l1.26,-1.39l6.64,-5.07l2.3,-0.65l2.64,-1.74l2.99,0.32l1.22,-0.33l0.27,-0.49l-0.21,-1.83l1.18,-1.56l-0.36,-1.06l0.69,-0.38l1.01,-0.0l2.15,0.54l0.83,2.19l2.66,1.62l1.09,1.45l0.53,3.91l-0.1,4.36l-0.54,1.61l-3.16,0.7l-3.16,1.9l-3.48,-0.92l-1.7,0.66l-1.19,-1.71l-2.04,-0.44l-1.96,0.52l-1.66,1.15l-1.17,1.98l-1.0,-0.32l-2.13,-1.65l-0.65,0.32l0.0,1.29ZM50.9,1229.48l0.84,0.01l0.93,-0.64l0.22,0.28l0.86,-0.19l0.3,0.56l-0.19,0.78l-1.29,-0.67l-1.34,0.33l-0.32,-0.46ZM50.81,1188.98l-0.01,1.51l0.44,1.02l-0.81,2.94l-0.87,0.38l0.18,-1.35l-0.26,-0.48l-1.49,-0.3l-1.17,1.0l-0.83,1.67l-0.54,2.59l-0.49,0.64l-0.56,0.29l-1.63,-0.14l-1.49,1.71l-0.66,-0.02l-1.31,-1.24l-2.07,-0.38l-1.01,-3.6l0.14,-0.54l0.51,-0.29l1.89,0.27l1.19,-0.5l-0.24,-0.41l-1.39,-0.6l-2.68,-0.27l-0.41,-1.16l0.45,-1.46l1.0,-0.36l2.88,0.51l6.27,0.0l1.61,-0.49l2.28,-1.36l1.1,0.43ZM45.24,1223.62l-0.17,0.33l0.25,0.49l0.53,0.19l0.45,1.22l-1.44,-0.15l-0.95,-0.99l-1.01,-0.35l1.46,0.01l0.49,-0.39l-0.74,-1.31l0.05,-0.85l1.24,1.11l0.2,0.37l-0.36,0.32ZM39.79,1205.7l0.82,-0.69l1.09,-0.17l1.4,0.32l1.03,1.37l-2.79,2.35l0.03,-0.63l-0.46,-0.46l-0.6,0.29l-0.87,-0.36l0.17,-0.35l0.59,0.07l1.63,-0.72l0.22,-0.69l-0.97,-0.46l-0.96,0.34l-0.33,-0.19ZM0.64,1105.91l0.71,-0.72l-0.92,-1.0l1.41,-0.44l0.39,0.43l-0.11,1.06l0.3,0.43l1.34,-0.37l0.8,0.36l-0.56,0.84l0.37,0.64l0.71,0.23l-0.05,0.36l-0.53,0.56l-0.87,-0.25l-2.3,-1.8l-0.66,0.21l-0.04,-0.54Z",name:"V\xe4stra G\xf6taland"},"SE-N":{path:"M63.5,1235.91l2.51,-0.29l7.78,1.35l5.26,-0.8l10.36,-3.42l1.83,2.86l0.16,2.95l-0.26,4.5l0.45,1.69l5.34,5.38l0.01,1.41l-1.52,3.42l0.09,1.48l2.73,6.43l0.87,1.13l1.07,0.52l3.01,-0.17l1.94,-1.33l1.67,-2.22l2.87,-2.09l0.6,-0.1l5.41,0.76l4.0,3.93l1.64,0.71l1.24,0.01l2.18,-0.58l1.7,1.33l1.3,0.44l5.82,0.75l-0.25,1.55l-1.31,2.29l-0.1,1.22l0.59,1.34l1.34,1.11l4.45,0.64l2.37,2.37l3.6,0.96l-0.69,0.7l-0.69,2.19l0.23,2.91l0.57,1.36l2.92,4.45l0.98,0.16l1.53,-0.8l1.65,-2.08l2.29,-1.53l0.93,-1.74l10.06,-1.87l2.06,0.22l4.63,1.17l1.5,1.16l2.52,0.87l2.39,1.58l0.55,1.3l0.03,2.15l0.48,1.12l2.33,2.05l3.48,1.62l0.25,1.53l-1.33,2.73l-1.28,1.26l-2.29,1.28l-5.63,1.27l-2.67,1.23l-5.46,0.19l-4.69,1.16l-0.89,0.85l-0.88,1.58l-0.74,2.72l-0.13,9.84l-0.51,1.61l3.05,3.12l5.81,8.8l0.69,1.85l0.47,2.92l-0.29,3.44l0.32,1.86l1.08,2.6l1.39,1.62l-2.42,-0.29l-4.28,0.92l-4.9,2.42l-1.68,1.1l-4.36,3.84l-1.4,0.42l-0.88,-0.05l-2.62,-1.75l-9.41,-1.34l-2.29,-0.84l-0.15,-1.1l0.83,-2.49l-0.26,-1.54l-0.78,-1.04l-3.07,-1.67l-1.04,-1.0l1.39,-2.89l0.39,-2.22l-0.32,-2.02l-2.07,-4.42l-1.27,-4.39l-1.2,-1.33l-2.02,-0.43l-1.83,0.14l-2.68,0.79l-2.89,-0.24l-3.41,-3.04l-0.58,-1.09l-0.51,-2.3l-2.24,-1.92l-1.0,-1.46l-1.37,-3.53l0.37,-2.14l-0.34,-1.38l-4.33,-2.43l-0.36,-1.18l-1.98,-0.8l-1.26,-1.83l-0.79,-0.64l-2.31,-0.47l-1.77,-0.92l-2.41,-0.6l-1.13,-1.02l-0.7,-1.57l-0.2,-1.96l0.84,-1.49l-0.02,-0.8l-0.95,-2.91l-0.74,-0.85l-2.11,-0.8l-2.0,-1.28l-1.49,-1.6l-0.13,-1.65l-1.65,-1.35l1.12,-1.54l-0.36,-1.47l-1.93,-2.52l-0.43,-3.44l-0.36,-0.38l-2.56,0.0l2.4,-2.04l-0.12,-0.62l-0.88,-0.4l-2.77,-0.32l-1.53,-0.88l1.79,-0.2l1.01,-0.44l0.02,-0.72l-2.09,-0.74l-1.87,-0.03l1.51,-1.69l1.67,-0.6l0.37,-1.4l-0.29,-0.66l0.03,-1.27l-0.48,-0.92l-1.55,-1.34l-0.65,-1.14l-0.89,-0.36l-1.86,0.65l-0.8,-0.75l3.79,-3.94l-0.31,-0.65l-1.63,0.0l0.82,-1.03l-0.08,-1.43l-2.14,-3.66l-0.78,-0.57l-0.91,0.19l-2.56,2.75l-1.0,6.79l-0.45,0.9l-0.19,-0.7l-0.47,-0.29l-2.01,0.31l0.62,-2.11l-0.42,-0.51l-1.4,0.02l-0.8,-0.35l0.61,-0.85l-0.8,-4.43l0.23,-1.46l0.56,-0.95l1.83,-1.26l0.02,-0.68l-1.59,-0.99l0.65,-0.41l0.02,-0.66l-1.56,-1.1l0.81,-1.4l-0.3,-3.87Z",name:"Halland"},"SE-M":{path:"M131.13,1344.16l1.04,0.98l3.05,1.66l0.52,0.74l0.17,1.12l-0.86,3.25l0.79,1.3l2.34,0.72l9.36,1.33l2.48,1.7l1.23,0.12l1.81,-0.55l4.42,-3.89l1.6,-1.04l4.81,-2.37l4.01,-0.85l3.36,0.42l5.2,-0.0l28.38,-5.36l3.4,-1.33l1.58,-3.26l1.96,-1.4l1.62,0.22l1.52,1.19l1.25,0.32l7.92,-0.05l1.98,0.34l3.5,1.27l11.72,2.72l-5.27,6.29l-3.01,5.95l-0.24,1.08l0.2,0.91l1.81,3.37l0.68,2.8l0.82,1.03l3.39,1.38l2.31,0.33l0.85,0.79l1.26,2.69l0.51,2.13l0.18,2.12l-0.25,1.53l-1.84,3.96l-0.2,3.96l-1.13,0.66l-2.51,0.55l-1.26,0.84l-2.34,2.84l-2.54,2.43l-4.13,2.24l-1.72,3.73l-0.69,0.7l-2.84,1.3l-2.47,3.05l-1.84,4.06l-0.72,4.09l-0.15,5.38l0.77,1.76l1.2,1.18l2.56,1.55l0.75,1.05l0.14,2.99l0.62,1.3l2.26,2.07l2.76,3.61l0.58,1.59l-0.27,1.87l-0.88,1.13l-3.63,3.29l-2.05,1.38l-4.44,5.93l-1.16,0.72l-1.44,0.32l-4.3,-0.02l-1.98,-0.31l-1.9,-0.59l-5.43,-2.84l-1.87,-0.58l-2.23,-0.2l-3.84,1.3l-4.19,-0.59l-9.06,0.59l-1.45,0.38l-2.24,2.34l-0.86,0.35l-2.82,-0.41l-2.48,0.47l-6.38,3.46l-1.93,0.57l-4.61,0.31l-2.11,-0.25l-11.21,-3.3l-3.73,-0.11l-2.05,-0.48l-2.02,-1.27l-1.52,-0.34l-1.68,0.33l-1.75,1.13l-1.22,0.03l-1.85,-0.54l-2.64,1.05l-0.57,-0.03l-0.2,-1.2l1.89,-3.0l0.47,0.03l0.99,0.94l1.22,0.6l1.9,-0.04l1.7,-0.62l1.03,-1.04l-0.19,-1.72l1.48,0.53l0.16,-0.43l-0.67,-2.59l-3.25,-4.37l-0.7,-2.41l0.75,-2.81l1.86,-1.72l4.66,-2.7l1.64,-2.08l0.87,-2.76l-0.45,-2.03l-2.04,-1.95l-0.97,-1.47l-2.56,0.02l-0.5,-1.62l-0.4,-0.28l-1.61,0.07l-1.04,-0.32l-0.41,-0.74l1.14,-0.69l0.49,-2.12l-0.86,-4.3l-2.51,-2.1l-2.78,-1.18l-1.9,-1.91l-0.67,-1.39l-0.41,-2.61l-2.35,-1.92l-1.24,-4.54l-2.34,-1.66l-0.61,-0.74l-0.27,-1.75l-0.56,-1.26l-6.48,-6.83l-3.27,-5.56l-0.87,-3.88l-1.68,-2.92l-0.8,-2.2l-2.9,-1.87l12.0,4.11l1.32,1.69l2.7,1.67l2.25,-0.63l2.8,0.27l1.57,-0.22l1.31,-0.89l0.93,-1.44l0.42,-1.52l-0.27,-1.43l-3.25,-1.66l-3.59,-6.42l-5.91,-3.46l-1.31,-1.94l2.17,-3.13l3.62,-1.09l8.26,2.36l3.87,-1.23l1.37,-1.59Z",name:"Sk\xe5ne"},"SE-K":{path:"M243.35,1383.41l0.15,-3.35l1.8,-3.87l0.31,-1.78l-0.75,-4.64l-1.3,-2.77l-0.71,-0.81l-1.16,-0.49l-1.77,-0.19l-3.08,-1.21l-0.62,-0.74l-1.15,-4.03l-1.47,-2.81l3.12,-6.54l5.46,-6.5l3.48,1.16l7.01,5.24l1.78,0.8l9.91,2.23l1.74,0.09l1.69,-0.43l2.29,-1.66l2.38,-2.63l1.25,-2.34l3.54,-0.28l3.22,-0.82l1.08,0.01l4.49,1.79l2.02,0.1l0.73,-0.38l1.56,-2.01l1.28,-0.34l3.31,0.41l1.84,-0.24l3.72,-3.02l2.56,-0.04l1.49,0.63l3.73,0.68l1.24,-0.29l1.42,-1.8l1.69,0.01l1.17,0.65l4.79,4.28l3.85,2.79l5.13,5.13l4.13,2.4l8.37,2.4l3.56,-0.01l1.83,-0.88l-1.75,7.15l-1.21,0.85l-1.06,2.54l-4.88,4.27l-3.97,6.95l-1.36,1.39l-0.83,-0.11l-2.73,-1.57l1.84,-2.94l0.53,-1.86l-0.18,-0.45l-1.71,-0.86l-3.31,1.06l-1.47,-0.04l-1.08,-1.52l-0.52,-0.12l-0.54,0.3l-0.6,-0.7l-1.44,-0.47l-1.55,-1.07l-1.52,0.9l-1.37,1.6l-0.99,0.62l-0.68,-0.84l0.95,-1.51l0.31,-1.19l-0.15,-0.42l-1.01,-0.56l-1.05,0.3l-2.54,1.7l-2.97,1.25l-0.53,0.72l-0.12,1.39l-3.02,-2.47l-1.19,-0.26l-1.11,0.23l-1.95,1.88l-0.65,1.79l-2.81,0.13l-0.95,-0.27l1.05,-0.27l0.35,-0.56l-1.89,-3.39l-0.64,-0.06l-1.41,1.59l-2.54,1.28l-2.68,0.39l-2.78,-1.48l-1.55,0.71l-2.39,0.0l-0.28,-0.18l-0.28,-1.67l-0.8,-0.78l-2.77,0.66l-0.33,0.55l0.64,1.85l-3.28,-1.19l-2.47,-0.38l-3.3,1.12l-3.95,-0.26l-0.38,0.42l0.08,1.29l-0.85,0.3l-2.24,-1.72l-1.44,-0.64l-3.68,0.02l-1.61,0.6l-1.23,1.47l-0.32,3.19l0.58,0.69l1.0,0.35l1.08,2.3l1.9,2.27l1.14,2.43l-1.38,0.81l-1.6,1.59l-0.73,-1.26l-1.36,0.0l-0.99,1.09l-1.39,-0.44l-2.27,-0.03l0.7,-0.64l0.0,-0.59l-1.02,-1.11l-0.25,-1.82l-0.68,-0.29l-1.17,1.11l-0.56,-0.59l-0.0,-0.47l-0.97,0.01ZM326.75,1386.94l0.39,-0.14l0.65,-0.35l-0.77,0.99l-0.27,-0.5ZM324.9,1376.76l0.99,0.15l-0.92,1.54l-0.58,-0.81l-1.85,-1.3l0.88,-0.2l1.49,0.62ZM319.08,1377.97l0.82,0.35l2.14,0.09l-1.33,0.52l-0.0,2.73l-0.65,-0.07l-2.03,-1.3l-0.47,-1.11l0.69,-1.14l0.62,-0.28l0.23,0.2ZM315.88,1378.93l-1.01,0.42l-0.63,-0.73l1.36,-1.69l0.57,-0.25l-0.28,2.26ZM311.19,1378.86l-0.16,0.29l-2.01,-0.2l-0.26,-0.38l0.36,-1.08l0.57,-0.3l1.42,0.32l0.33,0.4l-0.25,0.94ZM305.52,1379.24l-0.58,0.35l-1.16,-0.3l-0.22,-0.49l0.96,-0.74l1.7,-0.53l-0.7,1.7ZM300.53,1374.47l0.0,-0.09l0.03,0.02l-0.03,0.07ZM271.42,1377.85l0.08,-0.01l-0.03,0.06l-0.05,-0.04ZM262.46,1387.76l0.53,0.25l-0.28,0.68l-0.19,-0.24l-0.06,-0.69Z",name:"Blekinge"},"SE-I":{path:"M560.65,1196.09l0.19,1.07l1.18,0.61l2.42,-0.57l2.11,0.02l1.71,0.91l-1.63,0.38l-0.82,1.08l-3.28,-0.78l-1.6,0.67l-1.34,1.05l-3.07,1.0l-1.5,1.75l0.08,0.59l1.27,1.06l-0.03,1.21l-2.04,3.01l-1.61,-0.48l-1.71,-1.4l-2.26,-3.51l0.15,-0.92l1.91,-2.18l1.25,-2.82l0.68,-0.68l0.95,-0.26l2.26,0.06l1.17,-0.8l2.71,0.37l0.87,-0.43ZM565.47,1159.44l-2.58,0.68l-2.2,-1.05l-1.48,-3.3l1.65,0.0l1.82,0.88l3.8,0.69l1.17,0.75l-2.17,1.36ZM502.26,1291.76l-1.1,0.0l-0.4,0.4l0.0,0.67l0.66,0.71l-2.13,1.75l-0.72,2.07l-0.74,0.53l-6.35,2.53l-2.17,0.29l-1.57,-0.72l4.16,-5.86l0.24,-1.09l-0.34,-2.05l0.66,-0.63l2.42,-0.71l1.13,-0.8l1.8,-5.14l-0.08,-0.46l-0.46,-0.07l-1.62,0.81l-2.81,2.27l-1.07,-0.35l1.65,-2.54l0.15,-1.23l-0.75,-0.79l0.75,-1.62l-0.21,-0.58l-2.7,-1.01l-1.85,-8.32l-3.93,-2.72l0.1,-1.55l0.9,-1.69l2.46,-1.55l1.02,-1.94l0.39,-2.11l-0.31,-1.45l0.85,-1.42l-0.18,-0.59l-1.25,-0.99l-0.84,-1.26l-0.05,-1.74l-1.65,-3.79l-0.5,-2.18l-0.1,-2.16l1.06,-3.5l2.2,-2.83l11.17,-9.34l9.38,-12.82l2.39,-2.22l3.28,-1.2l2.93,0.77l1.2,-0.53l2.34,-5.05l2.4,-2.62l1.43,-0.68l1.43,-0.15l1.09,0.43l0.9,1.04l0.77,1.69l-0.46,1.45l0.15,0.79l0.71,0.66l0.67,1.95l1.37,1.45l0.68,-0.2l0.47,-2.4l2.28,-2.28l0.5,-2.05l-0.88,-1.6l4.31,-0.72l-0.99,1.67l0.11,0.53l1.56,1.01l1.66,-0.07l0.38,-0.41l-0.02,-1.06l0.79,-0.42l1.26,-0.35l1.54,0.09l-0.22,0.57l0.87,2.17l0.73,0.93l1.77,0.98l2.05,2.96l-4.4,0.4l-2.09,1.72l-0.25,2.7l-1.11,-0.76l-0.94,0.16l-0.35,1.42l-1.06,1.95l0.0,1.13l0.4,0.82l-4.51,0.49l-2.96,-1.33l-1.14,0.25l-0.38,0.98l0.29,1.8l-0.9,3.25l-2.17,4.77l-0.17,1.04l0.63,0.67l2.48,0.64l-0.91,2.52l-0.34,2.91l-1.92,3.95l0.93,1.24l-0.42,1.3l0.3,1.19l1.08,0.64l0.59,-0.0l-0.53,1.38l0.25,0.52l2.66,0.88l2.79,0.48l0.64,-0.47l0.28,-0.81l1.63,0.83l1.03,1.84l0.24,1.22l-0.19,0.88l-0.85,0.38l-1.94,0.0l-1.71,-0.6l-1.19,1.13l-2.65,0.63l-2.2,1.19l-1.95,1.62l-1.62,1.86l-2.61,1.87l-0.99,1.67l0.47,1.87l0.76,0.49l1.78,-0.02l0.18,2.56l-2.13,0.83l-0.18,0.38l-5.81,1.07l-1.84,0.91l-0.22,1.09l0.39,0.39l-9.23,3.89l-1.82,1.19l-1.41,1.52l0.29,0.67l3.32,0.0l-5.24,2.28l-1.28,1.64l-0.47,5.02l0.79,1.48l1.17,0.81Z",name:"Gotland"},"SE-H":{path:"M397.74,1309.11l-3.21,1.48l-1.09,1.58l-0.84,4.8l-3.95,9.9l-1.06,4.97l-1.15,1.6l-1.53,0.8l-0.46,0.96l-0.38,2.72l0.47,0.73l-0.9,1.92l-0.36,2.74l-2.98,6.71l-0.45,1.9l-0.19,3.82l-0.98,1.43l-0.73,2.43l-3.38,6.33l-1.16,1.11l-1.4,0.76l-1.21,0.05l-0.87,-0.88l0.03,-3.82l-0.91,-2.64l0.55,-2.07l-0.1,-6.42l0.55,-1.68l-1.53,-5.34l0.5,-8.22l1.35,-3.83l1.55,-2.19l0.75,-2.88l11.39,-22.66l1.03,-0.88l5.28,-0.88l1.27,-1.45l1.15,-3.65l3.06,-5.98l3.55,-5.4l2.92,-5.77l1.46,-8.14l2.01,-0.99l0.91,-0.91l0.45,-0.96l0.5,-7.17l1.45,-1.23l2.05,-2.59l1.05,-0.74l1.53,-0.46l0.47,1.19l0.82,0.41l0.92,-0.32l0.37,-0.55l1.25,2.3l-1.65,0.23l-1.46,1.2l-2.36,3.43l1.47,3.18l0.11,1.3l-1.04,2.4l-0.05,1.16l-1.47,0.78l-0.87,3.24l-2.87,4.33l-0.86,3.9l-1.03,0.96l-3.01,1.34l-0.17,0.53l0.42,0.84l1.45,1.14l-1.76,1.62l-1.94,2.69l0.83,3.53l-0.09,1.65l-0.99,0.82l-0.71,1.19l-1.11,5.08l-0.68,1.53ZM389.85,1209.83l0.3,-0.46l0.77,-0.03l1.15,1.38l0.9,0.21l0.35,1.49l-1.23,0.4l-0.73,-1.81l-1.51,-1.18ZM370.3,1313.9l-1.9,0.14l-1.46,0.89l-0.96,0.18l-0.58,0.7l1.39,3.47l0.09,4.69l-0.45,1.22l-1.75,0.82l-0.96,-0.07l-1.54,-1.02l-1.18,0.13l-2.35,1.1l-0.77,0.93l-1.76,3.33l-0.54,5.87l-0.3,0.67l-2.02,0.36l-0.87,2.82l-3.25,5.04l-1.56,3.52l-1.92,7.8l-1.48,0.4l-0.76,0.56l-3.25,-0.01l-8.11,-2.33l-3.96,-2.29l-5.11,-5.11l-3.88,-2.81l-4.81,-4.3l-1.35,-0.77l-2.42,0.04l-1.79,1.95l-3.99,-0.62l-2.79,-0.82l-1.76,0.26l-2.0,1.52l-0.25,-0.46l0.89,-3.58l0.96,-1.36l1.46,-1.13l0.36,-1.3l0.67,-10.51l-0.43,-3.26l-1.38,-4.43l0.1,-0.84l0.34,-0.47l1.63,-0.65l2.22,-1.47l4.25,-0.23l1.84,-0.88l0.68,-0.79l0.31,-1.08l-0.1,-1.39l-1.97,-5.41l-0.04,-0.86l0.34,-0.6l0.71,-0.59l1.72,-0.52l1.13,0.14l4.95,2.03l1.93,-0.6l6.22,-0.04l2.12,-0.53l1.65,-1.37l0.86,-1.84l-0.0,-1.66l-2.81,-6.12l-5.1,-6.08l-2.96,-2.43l-1.13,-2.32l-4.53,-1.81l-0.87,-0.67l-0.56,-3.5l-2.18,-1.83l-0.46,-2.93l-2.72,-3.37l-0.56,-2.29l0.13,-0.77l1.66,-1.76l0.39,-1.64l-0.39,-2.97l0.76,-2.89l-0.35,-3.5l0.27,-1.16l0.52,-0.86l1.11,-0.5l0.8,0.26l1.89,1.89l1.01,0.01l0.68,-0.54l0.63,-1.11l0.77,-2.68l1.38,-1.9l0.22,-1.24l-0.54,-1.92l-2.15,-0.92l-0.78,-0.93l3.63,-4.84l-0.48,-0.89l-1.83,-0.75l-1.49,-2.0l-2.58,-1.31l-2.44,-0.54l-5.14,-3.46l-1.21,-1.36l1.07,-3.54l1.82,-1.06l4.36,-1.55l1.43,-2.16l4.11,-4.51l2.3,-1.03l3.84,-0.46l2.55,0.35l4.3,2.09l4.84,0.85l2.11,0.93l1.66,0.1l1.64,-0.48l1.86,-1.22l2.71,-2.83l0.84,-1.34l0.31,-1.63l-0.92,-4.3l0.13,-0.7l1.28,-1.65l0.8,-1.66l-0.47,-1.67l-2.92,-3.61l-0.12,-0.72l0.64,-2.12l-0.87,-1.76l4.78,0.6l2.22,-0.13l2.04,0.3l1.0,-0.21l1.82,-2.97l1.18,-0.63l5.68,-1.48l4.38,0.41l2.42,-0.54l2.51,0.01l1.45,0.65l2.78,1.99l3.41,-0.2l1.74,0.49l1.02,1.43l0.96,4.6l1.77,3.39l0.86,0.77l2.66,0.34l1.27,2.51l0.53,0.11l1.45,-1.01l0.41,2.46l2.34,2.43l-2.79,-1.3l-0.45,0.06l-0.1,0.45l0.6,1.48l2.0,1.55l0.17,0.77l-0.51,0.75l-0.85,-0.01l-1.07,-0.56l-0.77,-0.69l-1.3,-2.4l-0.75,-0.44l-0.57,0.32l-0.22,1.9l-0.4,0.46l-3.41,-0.26l0.12,-1.38l-0.44,-1.31l1.93,0.73l0.54,-0.09l-0.06,-0.54l-8.81,-7.65l-0.94,-0.04l-0.76,0.63l-0.36,1.05l0.75,1.72l2.06,2.11l3.33,1.22l-1.01,1.42l0.41,0.93l-0.18,1.38l-0.33,0.3l-2.4,-1.64l-3.06,-0.9l-0.44,0.15l0.0,0.46l0.66,1.21l-1.62,-0.55l-0.51,0.39l0.14,1.03l4.04,3.54l-6.34,-4.18l-0.46,0.02l-0.14,0.44l0.55,1.75l0.91,1.33l2.4,1.86l3.81,2.1l2.87,2.87l1.46,2.23l1.69,0.69l2.84,2.54l-0.69,0.91l2.8,0.6l1.2,1.49l-0.83,0.0l-0.4,0.4l0.24,0.92l-3.44,-0.28l-4.13,-1.67l-0.46,0.08l0.41,1.38l1.82,1.8l0.57,1.38l-0.08,0.43l-0.5,0.08l-1.37,-0.47l-0.44,0.12l-0.04,0.45l0.81,1.19l1.52,0.37l0.8,1.41l-4.11,3.12l-0.14,-2.83l-0.66,-0.33l-0.9,0.53l-1.52,-0.52l-0.08,0.5l1.26,1.78l-1.1,1.02l-0.21,1.03l1.48,0.94l-1.46,0.0l-0.4,0.4l0.0,0.61l0.39,0.4l5.22,0.14l2.28,0.71l3.76,7.48l-1.32,-0.29l-0.44,0.58l0.74,1.39l-2.02,0.76l-0.53,1.39l0.52,1.45l1.45,0.92l-1.42,0.39l-0.96,0.8l0.15,1.59l-3.44,-0.56l-2.14,0.73l-0.87,2.18l0.17,0.5l1.98,1.12l-1.31,1.48l0.7,0.95l-4.72,2.16l-1.28,2.04l1.56,3.26l-1.81,1.48l-0.54,2.5l0.5,2.71l1.11,2.26l2.0,2.73l1.59,1.09l0.79,-0.08l0.5,0.6l0.97,1.91l-0.69,0.37l-0.18,0.49l1.68,2.99l-2.32,-0.63l0.07,-0.83l-0.97,-0.57l-0.63,0.2l-0.7,0.81l-0.46,1.38l-3.23,-1.03l-0.86,-0.03l-0.34,0.64l1.09,1.33l1.13,0.76l-1.26,0.14l-0.91,0.92l-0.44,1.78l0.38,2.35l1.84,2.52l-2.13,3.65l0.23,4.26l-2.1,5.7l-0.02,1.11l0.55,1.08l0.86,0.57ZM370.77,1314.0l1.72,-1.11l0.79,-0.1l-0.32,1.66l-0.52,0.18l-1.67,-0.64ZM380.08,1211.78l7.12,6.24l1.77,1.26l-4.02,-2.01l-4.87,-5.49ZM386.36,1235.27l0.37,-0.81l0.83,-0.46l1.26,0.18l0.45,-0.32l0.23,-1.82l1.16,0.29l-0.04,1.09l-1.59,2.36l-0.3,0.11l-1.37,-0.99l-0.99,0.37ZM389.41,1215.68l-1.18,-0.92l-1.56,-1.02l0.53,-0.29l2.36,0.25l0.62,0.64l-0.76,1.33ZM388.68,1242.22l0.23,0.11l0.63,0.53l-0.72,-0.37l-0.14,-0.27ZM381.52,1281.36l1.04,0.59l-1.02,0.17l-0.02,-0.76ZM379.55,1275.73l0.2,1.0l-1.62,0.86l-0.29,-0.24l-0.18,-0.61l0.56,-0.93l1.33,-0.08Z",name:"Kalmar"},"SE-G":{path:"M310.69,1272.3l2.02,1.63l0.1,2.24l0.57,1.42l1.12,0.85l4.34,1.7l0.47,1.47l0.58,0.76l2.97,2.44l5.02,5.96l2.26,4.69l0.44,1.2l-0.02,1.36l-0.64,1.38l-1.51,1.25l-1.82,0.42l-6.17,0.03l-1.8,0.59l-4.71,-1.98l-1.37,-0.19l-2.14,0.61l-1.0,0.84l-0.48,0.98l0.05,1.05l1.65,4.04l0.42,2.52l-0.19,0.77l-0.49,0.59l-1.54,0.73l-4.35,0.26l-2.3,1.51l-1.66,0.66l-0.73,0.97l-0.11,1.17l1.39,4.48l0.41,3.12l-0.67,10.42l-0.23,0.9l-1.33,0.99l-1.15,1.61l-0.98,3.29l0.44,1.63l-1.09,0.96l-1.5,0.18l-3.38,-0.41l-1.54,0.39l-2.14,2.35l-1.67,-0.08l-4.63,-1.81l-8.16,1.12l-0.8,0.65l-0.82,1.95l-2.32,2.57l-2.13,1.54l-1.3,0.32l-1.58,-0.08l-9.77,-2.19l-1.64,-0.73l-7.04,-5.26l-3.88,-1.3l-12.39,-2.88l-3.53,-1.27l-2.12,-0.36l-7.82,0.06l-0.96,-0.21l-1.5,-1.18l-1.26,-0.44l-1.13,0.15l-2.2,1.56l-0.63,0.85l-0.87,2.32l-3.11,1.21l-28.32,5.34l-4.91,-0.0l-1.86,-2.12l-1.02,-2.43l-0.3,-1.64l0.29,-3.55l-0.49,-2.99l-0.77,-2.05l-5.88,-8.9l-2.89,-2.81l0.5,-1.38l0.13,-9.82l0.66,-2.44l1.14,-1.9l3.68,-1.11l6.59,-0.35l2.7,-1.23l5.63,-1.27l1.45,-0.64l2.51,-2.14l1.15,-1.92l0.39,-1.38l-0.27,-1.65l3.69,-4.34l0.65,-0.24l1.06,-0.2l1.81,0.91l2.77,2.08l1.15,0.22l0.77,-0.21l5.35,-3.36l4.02,-0.5l1.57,-0.58l1.95,-0.0l5.08,2.69l1.98,1.47l1.42,2.21l2.71,6.31l0.81,1.03l1.16,0.88l2.15,0.86l2.31,0.26l1.16,-0.59l2.49,-3.27l1.55,-2.94l0.22,-1.89l-0.49,-2.7l-1.77,-1.39l-0.61,-1.62l0.87,-3.64l0.44,-5.18l0.55,-1.67l1.39,-1.21l1.76,-0.65l7.88,-1.31l11.63,-4.23l3.41,-0.75l2.57,-0.0l5.56,2.55l0.64,0.66l0.71,2.11l1.12,1.19l1.69,0.83l2.24,0.24l1.39,-0.18l1.45,-0.73l3.67,-2.79l1.89,-0.97l1.49,-0.28l2.6,0.5l0.66,-0.16l0.33,-1.23l-1.0,-3.12l4.56,0.71l9.3,-0.42l3.05,0.28l9.1,2.36Z",name:"Kronoberg"},"SE-F":{path:"M231.39,1292.76l0.42,3.06l-0.19,0.94l-1.43,2.7l-2.61,3.32l-0.55,0.2l-1.9,-0.23l-2.05,-0.82l-1.61,-1.55l-2.7,-6.29l-1.59,-2.45l-2.12,-1.58l-5.24,-2.77l-2.3,-0.03l-1.68,0.61l-4.03,0.5l-6.0,3.54l-0.64,-0.12l-2.73,-2.04l-2.02,-1.03l-1.48,0.19l-1.01,0.43l-3.68,4.33l-3.34,-1.56l-2.13,-1.89l-0.29,-0.71l-0.05,-2.25l-0.74,-1.63l-1.18,-0.95l-3.97,-1.66l-2.09,-1.38l-6.46,-1.24l-10.36,1.94l-0.51,0.44l-0.65,1.47l-1.68,1.01l-2.22,2.56l-1.19,0.63l-0.57,-0.17l-2.48,-4.07l-0.72,-2.4l0.02,-1.3l0.6,-1.95l3.55,-3.41l3.76,-5.65l1.63,-1.74l1.26,-0.87l1.72,-0.51l1.62,-3.31l1.04,-1.12l3.86,-1.73l2.8,-1.98l4.2,-4.15l3.73,-2.59l4.61,-7.28l2.84,-3.66l3.05,-2.97l0.63,-1.61l0.28,-5.02l2.05,-3.26l0.34,-1.24l-0.37,-4.3l1.11,-3.27l1.76,-2.71l0.07,-2.8l-1.03,-3.96l4.79,0.4l6.98,-0.64l1.35,0.4l3.34,2.01l1.39,0.21l0.7,-0.23l0.56,-0.7l0.97,-2.95l3.78,-1.4l0.78,-0.65l4.35,-1.58l2.17,-1.16l1.57,-1.29l0.84,-1.24l0.33,-1.35l-0.06,-1.36l-0.85,-3.37l12.65,-21.39l3.57,6.37l2.08,2.01l5.85,2.35l16.15,1.68l2.81,-0.23l1.55,-0.53l1.18,-0.98l1.19,-3.14l4.33,-1.0l2.45,4.25l1.47,5.24l2.4,2.81l0.45,1.05l-0.81,0.83l-2.18,0.57l-0.83,0.64l-1.43,3.8l0.49,2.05l-0.48,1.19l-0.01,1.07l0.55,1.28l3.26,4.39l0.49,2.39l1.22,3.37l3.28,5.77l1.49,1.32l1.79,0.52l16.59,1.15l1.35,1.51l5.19,3.49l1.0,0.46l1.62,0.17l1.82,0.87l1.07,0.81l1.39,1.92l1.55,0.48l-3.29,3.95l-0.34,0.91l0.49,1.21l2.3,1.04l0.59,0.75l-0.05,1.74l-1.39,1.94l-0.81,2.78l-0.51,0.87l-0.73,0.26l-2.26,-2.09l-1.51,0.02l-0.99,0.68l-0.96,2.4l0.35,3.53l-0.76,2.94l0.39,2.9l-0.27,1.3l-1.48,1.43l-0.42,1.59l0.69,2.68l2.7,3.34l0.3,2.2l-8.68,-2.25l-3.16,-0.29l-9.26,0.42l-4.66,-0.72l-0.68,0.39l-0.13,0.45l1.05,3.64l-2.69,-0.46l-1.88,0.34l-2.04,1.05l-3.61,2.75l-1.35,0.68l-1.05,0.12l-2.12,-0.22l-1.32,-0.65l-0.93,-0.95l-0.69,-2.06l-0.86,-0.96l-5.83,-2.7l-2.96,-0.02l-3.48,0.76l-11.67,4.25l-7.88,1.31l-1.99,0.77l-1.53,1.33l-0.73,2.09l-0.44,5.19l-0.87,3.82l0.76,2.01l1.7,1.3Z",name:"J\xf6nk\xf6ping"},"SE-E":{path:"M410.87,1168.7l0.1,-0.12l0.8,-0.18l-0.26,0.11l-0.63,0.18ZM408.13,1146.13l-1.01,-0.1l-0.27,-0.7l0.35,-0.21l1.61,0.54l-0.68,0.47ZM406.79,1152.69l-0.12,-0.34l0.91,-0.42l-0.31,0.42l-0.48,0.34ZM405.02,1143.8l-1.5,-0.39l-0.84,-0.93l0.59,-0.07l1.75,1.39ZM404.1,1174.75l0.57,0.37l0.42,-0.28l0.38,1.15l-0.36,0.32l-1.33,-0.53l0.0,-0.76l0.32,-0.28ZM335.52,1096.41l11.02,6.41l4.01,3.51l10.95,6.6l2.72,3.85l3.4,3.31l1.28,3.57l2.37,2.11l1.05,0.39l12.01,0.33l3.87,0.87l3.13,1.48l2.44,2.19l-36.35,-3.38l-0.44,0.4l0.0,0.74l1.64,1.23l0.21,0.61l-0.28,0.53l-0.76,0.17l-2.95,-0.49l-1.26,0.29l-0.31,1.01l0.55,0.37l1.5,-0.51l0.41,0.16l0.34,0.88l0.56,0.21l1.21,-0.64l2.91,1.15l1.77,-0.89l1.01,-1.15l0.66,-0.22l2.2,1.7l-0.02,1.39l0.36,1.01l1.17,0.61l1.05,-0.14l0.76,-0.61l1.29,-4.2l0.56,-0.63l5.18,2.31l7.98,-0.22l1.31,0.4l2.21,1.67l2.81,0.35l1.13,0.86l0.47,0.02l0.16,-0.44l-0.29,-1.44l2.15,0.49l-0.49,1.58l0.43,1.59l1.37,1.26l1.14,0.23l-0.44,0.47l0.0,0.56l0.4,0.4l1.46,0.0l-0.6,1.04l0.12,0.58l0.97,0.56l2.53,0.57l3.14,2.27l-0.94,0.44l-3.34,0.04l-1.63,0.58l-0.23,0.53l0.48,1.14l-1.22,0.87l-4.41,1.14l-1.1,1.11l-1.74,-0.73l-8.29,-1.2l-3.98,-1.94l-6.7,-1.77l-2.22,0.87l-0.24,0.43l0.35,0.34l2.37,0.26l14.34,5.95l2.28,0.22l0.71,0.4l0.54,1.07l-0.35,2.41l0.38,1.1l1.1,0.17l2.14,-1.09l0.58,0.61l0.19,1.73l-9.25,-1.34l-0.42,0.22l0.08,0.46l1.12,1.06l3.36,2.25l-0.04,1.67l1.09,0.59l0.95,-0.09l0.58,-0.49l-0.15,-1.51l4.22,-0.43l-0.43,1.16l-1.63,-0.09l-0.35,0.32l-0.35,1.8l-3.02,0.59l-0.35,0.4l0.0,0.68l0.33,0.39l1.5,0.28l4.41,2.08l-0.41,0.29l-0.03,0.68l1.53,1.53l0.66,2.54l-0.11,1.09l-1.57,-0.38l-0.73,0.76l0.3,0.76l0.97,0.92l-1.78,2.5l-3.45,-1.74l-4.08,-3.55l-3.03,-1.74l-0.48,0.06l-0.06,0.48l1.1,1.84l2.64,1.98l0.59,1.03l-1.08,0.02l-0.36,0.64l4.9,5.8l-0.95,0.34l-0.26,0.44l0.17,1.14l-0.23,0.46l-1.42,0.03l-0.44,0.26l0.17,0.48l3.6,1.81l0.78,1.16l-0.64,0.62l-1.38,-0.98l-1.97,1.0l-0.49,0.76l-1.25,-2.61l-1.13,-0.53l-0.44,0.11l-1.0,1.44l0.45,1.42l0.95,1.5l-1.54,-2.28l-1.48,-5.94l-1.24,-1.75l-1.18,-0.59l-4.28,0.14l-2.56,-1.9l-1.73,-0.76l-2.74,-0.02l-2.32,0.53l-4.36,-0.41l-1.81,0.27l-4.16,1.26l-1.36,0.72l-1.08,1.35l-0.65,1.54l-0.59,0.14l-2.09,-0.3l-2.12,0.13l-3.98,-0.7l-1.21,0.12l-0.59,0.88l0.97,1.66l-0.63,1.98l0.14,1.06l3.05,3.88l0.32,1.04l-2.01,3.12l-0.21,0.97l0.92,4.43l-0.23,1.21l-0.73,1.17l-2.65,2.77l-1.7,1.1l-1.27,0.38l-1.52,-0.09l-2.05,-0.92l-4.82,-0.84l-4.35,-2.1l-2.7,-0.36l-4.01,0.48l-2.69,1.24l-4.2,4.61l-1.32,2.04l-5.68,2.14l-0.71,0.75l-1.06,3.53l-16.41,-1.14l-1.42,-0.39l-1.31,-1.15l-1.43,-2.13l-2.54,-5.4l-0.95,-3.87l-3.32,-4.47l-0.44,-1.05l0.52,-2.1l-0.5,-1.84l1.31,-3.5l2.73,-0.95l0.86,-0.66l0.36,-0.88l-0.61,-1.5l-2.33,-2.68l-1.99,-6.45l-2.18,-3.35l-0.85,-0.23l-4.37,1.18l-0.63,0.75l-0.74,2.54l-0.93,0.8l-1.33,0.46l-2.65,0.22l-16.06,-1.67l-5.49,-2.19l-1.91,-1.82l-3.77,-6.72l25.92,-41.6l3.24,-2.35l2.25,-1.11l8.04,-1.85l3.59,-3.1l5.31,-6.08l1.97,-1.66l7.29,-3.71l2.02,-0.4l1.7,0.09l2.53,0.71l1.96,0.01l1.99,-0.43l7.59,-2.87l1.98,-1.2l1.78,-2.24l0.46,-1.79l-0.31,-2.44l0.49,-0.72l1.36,-0.83l6.55,-1.77l3.48,1.47l1.02,-0.13l1.13,-0.66l1.19,-2.35l1.77,-0.89l1.95,0.2l2.36,1.81ZM403.66,1169.3l0.65,-0.91l0.08,0.05l0.0,0.39l-0.73,0.47ZM398.39,1157.56l-0.45,0.14l-0.51,0.89l0.31,0.94l1.05,1.05l1.7,1.24l2.55,-0.25l-0.25,0.34l-1.37,0.79l-1.01,0.04l-2.34,-0.97l-1.72,-2.82l-0.32,-1.42l-0.66,-0.76l0.19,-0.51l1.02,-0.43l1.79,-0.58l1.42,-0.06l-0.61,1.0l-1.66,0.36l0.13,0.48l0.72,0.54ZM400.41,1167.12l-0.92,-0.17l-0.67,-1.34l-0.21,-1.05l0.46,-0.34l1.81,0.86l0.07,1.47l-0.54,0.58ZM396.85,1184.94l0.02,0.05l-0.98,-0.32l-0.66,-0.67l0.21,-0.47l1.29,-0.47l0.25,0.64l-0.66,0.77l0.52,0.47Z",name:"\xd6sterg\xf6tland"},"SE-D":{path:"M453.18,1112.79l1.54,0.83l1.98,1.37l-2.27,-0.95l-1.25,-1.25ZM360.53,1050.06l0.61,-0.33l38.13,-5.63l3.14,0.04l4.94,-2.29l7.0,1.07l5.3,-0.58l1.4,0.2l2.01,0.71l2.64,1.51l1.78,2.8l2.16,1.66l4.29,1.69l3.74,2.6l2.52,3.82l-0.36,1.55l-0.95,0.43l-3.68,0.37l-1.1,0.41l-0.77,0.82l-0.89,1.4l-0.31,2.37l0.1,2.71l-0.36,1.86l-3.18,2.68l-0.29,2.03l0.94,3.92l2.66,5.11l1.19,7.84l0.89,2.36l1.44,2.23l0.84,0.45l8.85,0.52l2.12,0.88l1.6,1.33l-0.35,1.05l1.15,1.03l1.07,0.39l-0.58,0.94l0.15,0.62l1.41,0.78l-0.44,1.16l-1.06,0.65l-4.15,-0.78l-0.4,0.59l0.67,1.24l1.0,1.02l2.01,1.25l-1.04,0.0l-0.37,0.25l0.12,0.46l-0.57,-0.02l-5.05,-3.14l-2.31,-0.94l-0.55,0.37l0.0,0.68l1.26,0.95l0.21,0.85l-1.29,5.39l0.18,0.39l2.01,1.2l-1.17,0.49l-8.21,-1.48l-0.42,0.19l0.04,0.46l2.27,2.67l0.28,1.15l-1.02,1.04l-3.4,-0.12l-2.07,0.36l-0.33,0.39l0.0,1.41l-7.29,-0.12l-1.94,-0.52l-2.17,-2.39l-0.95,-0.35l-1.03,0.21l-3.51,1.49l0.23,0.41l0.93,0.41l2.13,0.24l0.48,0.5l-0.35,1.33l-0.93,0.93l0.07,0.67l1.62,0.77l2.82,-0.29l1.01,0.22l-3.33,3.45l-1.34,-0.08l-4.06,-2.0l-2.45,-0.35l-1.79,1.74l0.28,0.67l3.14,0.13l1.05,0.69l0.7,1.16l-0.95,0.01l-5.98,1.58l-9.49,-0.88l-3.09,-2.94l-3.38,-1.6l-4.03,-0.9l-11.98,-0.33l-0.73,-0.28l-2.14,-1.92l-1.3,-3.61l-3.4,-3.3l-2.78,-3.91l-11.06,-6.69l-4.02,-3.51l-10.99,-6.39l-2.4,-1.85l-2.46,-0.32l-1.53,0.63l-1.14,1.07l-0.87,1.88l-1.29,0.46l-3.47,-1.46l-4.24,-3.03l-1.23,-1.87l0.87,-1.57l3.11,-2.76l0.83,-1.19l1.78,-0.95l3.34,-1.01l1.08,-0.77l0.45,-0.84l-0.15,-1.28l-2.2,-4.95l-0.16,-0.68l0.35,-0.68l5.24,-1.53l3.01,-2.12l0.51,-1.26l0.1,-2.57l4.5,-6.35l1.94,-1.46l2.7,-0.86l2.85,-0.06l4.3,0.94l1.68,0.06l2.16,-0.29l4.89,-1.47l2.36,-1.43l0.59,-1.35l-0.43,-0.84l-1.56,-0.79l-0.94,-1.09l-0.3,-1.51l0.28,-0.55ZM439.65,1122.24l0.7,-0.32l0.03,-1.12l-1.34,-0.88l0.74,-0.48l0.61,0.09l1.1,1.09l-1.05,2.09l-0.19,0.15l-0.59,-0.62ZM441.68,1120.54l0.05,-1.25l1.24,0.44l0.03,0.66l-1.32,0.16ZM442.16,1123.89l-0.84,0.39l0.18,-1.31l0.54,0.39l0.12,0.52Z",name:"S\xf6dermanland"},"SE-C":{path:"M520.41,966.01l-0.26,-0.15l-0.63,0.58l-0.53,-0.3l0.5,-0.74l0.92,0.61ZM516.48,972.87l1.25,-0.3l2.03,1.11l-1.61,0.61l-1.67,-1.43ZM448.54,1029.37l-0.76,1.26l-0.2,3.09l0.45,1.19l1.59,1.89l-0.21,1.34l-3.26,4.48l-0.5,1.18l-0.44,4.56l-0.41,0.7l-2.66,1.74l-2.31,4.65l-1.51,-2.45l-1.62,-1.34l-2.44,-1.51l-4.18,-1.63l-1.99,-1.51l-1.62,-2.7l-3.12,-1.82l-3.65,-0.96l-5.29,0.59l-6.86,-1.05l-1.22,-2.9l-2.06,-7.85l-1.14,-2.88l-7.63,-13.01l0.17,-0.55l3.06,-1.6l1.14,-1.3l0.45,-1.41l-0.09,-3.47l1.23,0.07l4.7,1.35l3.72,0.54l1.97,2.31l1.21,0.35l1.4,-0.26l4.07,-2.66l3.51,-1.76l1.1,-1.42l0.74,-1.93l0.44,-4.36l-0.34,-1.35l-2.48,-1.53l-0.28,-1.07l3.56,-4.98l2.42,0.03l1.08,-0.28l1.24,-0.96l1.31,-1.89l5.36,-12.71l0.59,-2.44l-0.35,-1.76l-1.47,-1.33l-9.63,-5.93l-0.57,-7.43l0.41,-1.86l1.44,-2.4l2.42,-1.86l2.38,-4.1l4.11,-14.02l2.33,-1.39l8.98,-1.14l1.75,0.12l2.24,1.76l2.45,1.18l0.63,0.72l-0.54,0.58l-2.46,1.17l-0.63,0.81l0.24,1.6l2.13,5.55l2.53,1.4l4.83,0.58l0.45,-0.4l0.0,-0.76l-0.93,-2.88l2.21,-2.71l3.55,-2.19l6.87,-1.5l1.89,0.09l1.58,1.04l1.32,3.36l-0.47,2.03l-1.23,1.07l-0.2,1.05l0.37,0.4l1.68,0.12l1.59,0.83l3.1,2.47l2.27,1.31l0.86,2.73l2.3,2.59l2.51,1.54l4.71,1.4l-2.03,1.51l-1.03,1.2l0.13,1.06l1.84,2.03l0.55,0.11l2.9,-2.27l2.23,-0.71l3.07,0.95l4.63,-0.12l0.98,0.55l0.16,2.92l1.72,1.51l-2.33,0.1l-0.76,0.6l0.14,0.7l9.37,2.72l2.08,1.66l-2.03,0.79l-10.89,-3.2l-2.05,-1.9l-3.54,-4.27l-0.49,-0.1l-0.2,0.46l1.05,3.78l7.39,7.0l-0.98,-0.45l-1.65,-1.64l-0.47,-0.07l-0.2,0.43l0.58,2.68l1.48,1.54l3.25,1.73l2.61,2.12l1.49,0.02l1.18,-0.6l0.37,3.67l-3.29,4.24l-2.09,2.12l-0.93,1.67l-0.03,1.23l0.56,0.8l1.63,1.22l-2.68,1.31l-1.79,1.78l-0.41,1.68l0.03,4.22l-0.64,2.05l-1.37,1.79l-3.07,1.68l-4.65,1.69l-4.29,0.87l-2.35,1.12l-1.84,1.79l-2.87,5.03l-1.24,0.86l-5.55,0.14l-9.39,4.32l-4.07,0.92l-1.92,0.76l-4.3,-1.67l-3.09,-0.09l-2.86,2.94l-3.57,1.54l-0.39,1.81ZM507.3,947.7l1.81,1.32l0.22,0.48l-1.98,-1.07l-1.0,-0.18l-0.43,0.56l4.43,7.98l0.97,1.18l1.2,-0.03l0.93,-0.77l0.43,1.83l1.02,1.91l1.15,0.57l-0.08,0.73l-3.04,-1.33l-3.85,-3.4l-3.71,-1.57l-0.8,-1.97l-0.28,-2.67l0.21,-6.26l-0.85,-2.2l0.14,-0.42l1.29,0.2l1.03,1.43l0.25,2.56l0.93,1.11ZM515.02,974.35l-0.52,-0.03l-2.71,-1.71l-0.86,-1.07l1.79,0.2l2.14,1.1l-0.24,0.75l0.41,0.76ZM502.87,940.57l1.94,-0.54l0.53,1.2l-0.49,0.09l-1.98,-0.75Z",name:"Uppsala"},"SE-Z":{path:"M228.1,451.55l25.18,12.48l4.89,4.25l1.83,2.66l5.36,6.48l2.07,1.14l3.51,0.94l2.52,1.07l2.55,2.03l2.19,5.71l1.72,2.33l1.0,0.37l3.92,0.2l2.59,1.03l3.99,2.44l1.47,1.82l2.2,1.97l2.86,1.6l-4.32,1.68l-0.76,0.98l0.06,0.52l3.69,2.8l1.28,1.5l11.38,7.13l1.79,1.49l1.23,1.47l1.46,4.42l0.55,0.59l1.01,0.17l1.7,-0.6l1.1,-3.27l1.32,-2.72l2.34,-0.31l1.89,2.28l0.59,4.23l0.8,2.52l1.61,2.16l13.55,8.08l2.5,2.48l1.7,4.18l1.51,2.45l1.39,0.86l4.82,-1.2l2.46,0.01l4.56,1.95l32.56,25.73l-7.69,17.68l-0.79,6.43l-1.79,5.92l-4.17,2.25l-2.7,0.84l-15.25,1.63l-6.75,-1.08l-4.08,0.71l-6.33,2.36l-5.03,1.09l-1.98,2.77l0.01,0.45l3.73,5.21l1.49,3.15l2.24,10.9l2.08,1.45l2.63,0.72l3.19,2.28l3.04,4.59l53.46,41.05l-0.19,1.01l-16.24,3.88l-4.47,2.15l-14.86,14.57l-3.37,4.38l-2.42,1.39l-2.7,0.68l-29.1,1.52l-18.94,6.08l-29.66,5.32l-12.17,-0.81l-9.03,0.97l-2.13,1.08l-0.7,1.29l0.5,1.21l-0.09,2.45l1.28,2.42l1.48,5.22l-2.23,2.09l1.0,3.66l3.06,2.36l4.07,5.25l3.06,2.71l4.54,3.22l4.22,1.54l4.53,0.96l5.31,-1.42l5.71,0.57l1.38,4.14l3.46,4.31l0.92,1.77l0.67,2.27l-0.58,1.93l-1.87,2.31l-19.85,12.27l1.23,6.39l-0.44,3.31l-0.87,0.72l-0.41,0.92l0.38,4.48l-0.74,1.08l-1.38,-0.04l-2.05,-1.46l-3.51,-0.46l-3.21,0.36l-1.74,2.2l-2.11,0.22l-2.87,-1.61l-1.74,0.65l-0.24,0.49l0.82,2.68l-0.46,1.29l-1.49,-0.98l-4.8,-6.58l-0.37,-0.95l-0.42,-0.25l-1.31,0.16l-2.23,1.15l-5.72,6.02l-2.23,3.99l-1.71,5.57l-1.59,9.46l-2.58,3.95l-6.49,0.95l-5.84,-1.85l-46.89,-6.11l-3.96,-2.72l-1.51,-3.72l-1.95,-3.26l-3.29,-4.27l-2.55,-4.46l-5.48,-7.17l2.11,-7.56l1.55,-2.5l-0.11,-0.54l-6.59,-4.52l-6.88,0.35l-9.24,-3.91l-5.0,-5.2l-12.28,-8.12l-31.05,-7.1l-1.48,0.2l-0.07,-1.19l-1.92,-5.25l-13.25,-26.49l-0.07,-1.97l0.86,-2.85l3.47,-8.14l0.17,-2.57l-4.04,-16.38l-0.24,-2.09l0.68,-1.53l8.01,-8.29l0.07,-0.46l-15.57,-30.56l14.31,-17.62l1.06,-2.19l0.0,-2.7l-3.27,-10.69l8.22,-6.26l12.89,-16.49l13.55,-15.89l4.93,-3.76l15.39,-7.3l17.02,-3.46l47.97,8.84l1.76,0.01l1.56,-1.26l11.27,-16.28l0.94,-2.2l0.06,-2.04l-3.16,-25.9l-1.27,-2.64l-2.64,-1.42l-8.27,-1.63l-19.77,-9.93l35.77,-44.52l9.4,-10.24l1.41,-3.14Z",name:"J\xe4mtland"},"SE-Y":{path:"M402.7,578.12l56.53,7.68l43.18,-10.13l4.25,-0.01l2.57,1.19l0.67,2.21l-0.57,0.63l-2.61,0.05l-0.36,0.69l0.27,0.94l4.6,6.92l1.68,1.5l4.08,1.95l1.55,0.4l6.17,0.03l3.33,1.4l3.19,0.73l1.26,0.61l1.68,1.43l1.64,0.69l4.0,0.11l1.3,0.42l1.39,1.04l0.68,1.43l0.14,1.61l0.57,0.68l3.5,1.3l3.54,3.2l8.58,10.78l7.06,13.51l-1.05,-0.26l-0.97,0.99l-0.32,1.87l-0.45,10.69l-0.62,1.27l-0.68,0.52l-0.39,-0.17l-0.26,-1.59l-0.7,-0.19l-1.39,1.65l-3.34,0.73l-1.75,1.22l0.01,0.65l1.07,1.16l-0.6,0.58l-2.01,3.65l0.34,0.62l0.71,0.0l-0.59,0.94l-0.95,-0.09l-2.61,-2.34l-0.62,0.11l-1.19,2.31l0.05,0.44l1.32,1.46l3.31,0.72l-0.23,0.55l-1.59,0.06l-0.83,0.58l-1.02,2.44l-0.67,0.06l-4.41,-4.2l-0.47,-0.61l0.17,-1.6l-0.78,-0.74l-1.28,-0.57l-2.14,-1.79l-1.72,-0.59l-0.89,0.36l-0.24,0.47l0.34,1.39l-0.43,0.17l-3.67,-1.1l-2.9,-0.2l-1.34,0.3l-1.21,0.74l-0.04,0.65l1.52,1.18l10.16,3.11l-0.82,0.97l-1.99,0.57l-4.44,0.05l-0.38,0.51l0.38,1.25l-0.78,0.75l-0.63,-0.05l-0.69,-0.75l-0.45,-2.75l1.09,-0.34l3.31,-0.02l0.4,-0.4l0.0,-0.8l-0.32,-0.39l-6.67,-1.32l-1.95,0.67l-0.11,0.7l0.85,0.64l0.88,2.83l1.62,2.97l-9.08,-2.12l-3.3,0.09l-0.39,0.4l0.0,0.73l0.39,0.4l1.38,0.04l1.46,0.54l2.19,1.84l0.88,2.28l-0.12,0.76l-0.68,0.29l-4.04,-1.55l-1.77,0.9l-1.4,3.52l-1.09,1.36l1.32,0.25l-2.91,1.55l-0.48,0.75l-0.69,2.72l-2.63,-2.7l-1.1,-0.67l-1.16,-0.31l-1.24,0.15l-1.24,0.77l0.02,0.68l2.2,1.28l1.44,1.43l-3.49,-0.51l-1.04,-1.67l-0.72,-0.38l-0.53,0.2l-0.35,1.56l-0.82,1.0l-1.54,0.73l-3.91,0.72l-0.32,0.32l0.19,0.41l1.9,1.07l17.5,-0.17l1.66,0.58l1.19,1.23l0.32,1.23l-0.19,0.18l-0.59,-0.33l-1.0,-1.68l-0.88,0.29l-0.52,1.85l-1.27,0.4l-1.77,-0.39l-3.97,-1.71l-1.34,0.48l-0.94,2.32l0.18,0.48l4.29,2.21l3.83,-0.78l0.51,0.51l-0.55,1.72l-2.42,0.23l-4.86,-0.99l-0.41,0.17l0.0,0.45l1.02,1.48l3.37,1.13l0.58,0.88l-0.64,1.29l-2.39,0.74l-1.78,1.3l-1.44,0.48l-3.3,-0.45l-0.47,-1.47l-2.21,-2.19l-1.37,-0.88l-1.35,-0.03l-0.38,0.55l0.31,0.98l-2.77,0.0l-0.4,0.4l0.0,0.66l0.79,0.68l0.09,0.46l-0.82,1.62l0.18,0.59l1.93,0.55l2.04,-1.82l0.8,0.41l-1.43,2.9l-0.93,1.12l-1.31,0.51l-1.74,1.63l-0.45,-0.77l1.11,-1.72l-0.14,-0.65l-0.99,-0.39l-0.46,0.12l-0.64,0.81l-1.2,2.53l-1.11,0.76l-3.63,-0.16l0.34,-0.88l-0.14,-0.5l-1.11,-0.74l-3.29,-0.17l0.89,-0.95l5.76,0.58l2.01,-1.87l-0.16,-0.66l-4.07,-1.54l-0.67,-0.92l0.28,-0.54l-0.43,-0.59l-1.65,0.35l-2.4,1.27l-2.16,1.63l-1.26,1.8l-1.89,-0.86l-0.47,-0.43l-0.12,-0.77l0.11,-3.89l-0.89,-1.7l0.88,-1.63l-0.32,-1.87l-0.39,-0.32l-0.82,-0.0l-1.15,0.52l-0.7,-0.02l-1.55,-4.53l-1.34,-1.68l-1.34,-0.81l1.09,-1.87l-0.39,-0.59l-1.71,0.23l-2.95,1.93l-1.05,-0.38l-2.23,-1.56l-1.52,0.48l-0.06,0.7l8.4,5.45l1.99,2.18l2.8,5.35l0.78,3.09l-1.03,1.67l-0.06,1.0l3.14,1.86l1.54,1.47l0.05,2.13l0.54,1.37l2.25,2.63l0.46,1.83l-0.79,3.02l0.29,1.85l-0.92,0.2l-2.87,-1.44l-4.21,0.0l-0.28,0.68l1.51,1.46l10.07,3.3l0.3,1.88l0.58,0.88l-0.77,0.23l-4.81,3.19l-0.7,-5.16l-0.51,-0.51l-1.2,-0.0l-0.91,1.38l-1.08,5.71l-1.87,0.75l-0.21,0.6l0.81,1.21l-3.1,3.66l-1.09,0.33l-2.41,-2.04l-3.69,-0.04l-2.95,0.87l-1.7,1.03l-0.91,1.41l0.05,1.81l1.31,0.98l1.29,0.48l0.36,0.64l-8.15,-0.28l-0.9,-0.33l-2.32,-2.16l-3.02,-4.31l-2.96,-3.29l-0.86,-0.53l-2.0,0.82l-0.67,2.41l-2.37,0.7l-1.31,0.75l-0.79,1.32l-0.02,1.64l3.08,3.9l0.23,1.06l-0.03,1.36l-0.34,0.32l-2.45,0.44l0.12,0.46l1.47,1.42l0.34,0.94l-0.42,2.41l0.63,1.6l0.86,1.1l0.95,0.57l2.33,-0.31l0.77,0.13l0.97,0.82l1.51,3.01l0.73,0.61l-1.75,0.92l0.08,0.69l5.88,2.53l1.56,-0.46l2.08,0.42l2.95,1.43l-5.0,2.54l-1.3,0.25l1.76,-2.52l-0.15,-0.59l-1.38,-0.59l-1.38,0.3l-1.08,0.75l-0.87,1.26l-0.3,1.55l0.29,4.23l-0.48,1.33l-16.34,-2.27l-3.14,-0.91l-13.48,-0.24l-35.62,-7.43l-18.96,-1.03l-39.68,-9.97l-3.25,-0.31l-3.49,0.95l-11.68,7.06l-5.91,-0.59l-5.24,1.42l-4.41,-0.94l-4.09,-1.5l-4.39,-3.13l-2.98,-2.64l-4.02,-5.21l-3.07,-2.39l-0.83,-2.78l0.49,-0.64l1.34,-0.78l0.45,-0.93l-1.52,-5.51l-1.26,-2.33l0.17,-1.75l-0.54,-1.88l0.46,-0.62l1.7,-0.84l8.92,-0.95l12.22,0.8l29.74,-5.33l18.87,-6.07l29.09,-1.52l2.87,-0.72l2.75,-1.6l3.37,-4.38l14.69,-14.43l4.29,-2.08l16.45,-3.93l0.3,-0.31l0.14,-1.9l-53.61,-41.16l-3.06,-4.6l-3.31,-2.37l-2.75,-0.78l-1.77,-1.26l-2.09,-10.64l-1.56,-3.29l-3.59,-5.02l1.49,-2.24l4.95,-1.08l6.25,-2.33l3.84,-0.69l6.85,1.08l15.35,-1.64l2.92,-0.91l4.55,-2.58l1.85,-6.11l0.77,-6.37l7.58,-17.42l2.34,1.91l8.0,4.06ZM557.57,651.89l-0.15,-0.09l-0.07,-0.1l0.03,-0.01l0.19,0.2ZM538.18,660.79l0.65,-0.07l-0.26,0.24l-0.39,-0.17ZM534.82,665.05l0.76,-0.57l0.05,0.01l-0.64,0.56l-0.18,0.01ZM532.53,666.31l-0.96,0.34l-0.61,-0.54l0.03,-0.04l1.54,0.23ZM523.87,666.7l-1.04,-0.47l0.36,-0.94l0.36,0.33l0.32,1.07ZM521.65,682.57l-1.32,0.68l0.46,-2.43l1.47,-1.06l-0.05,1.44l-0.56,1.38ZM519.76,674.67l-0.24,-1.21l0.4,-0.35l0.17,0.47l-0.33,1.08ZM511.87,678.55l0.38,-0.43l-0.24,-0.99l0.56,-1.43l1.71,-0.79l0.31,0.44l0.92,0.3l-1.02,1.99l-1.53,0.75l-0.58,0.64l-0.51,-0.47ZM491.57,706.9l0.04,-0.62l1.08,-1.31l0.85,-0.31l-1.98,2.24ZM483.74,708.32l0.81,0.39l1.91,-0.64l1.74,0.35l-0.19,1.89l-0.7,1.66l-1.83,0.34l-0.2,0.51l0.79,1.03l-0.15,0.24l-2.88,0.8l-3.27,-0.47l-1.22,-1.91l1.44,-3.98l0.71,-0.82l1.35,-0.3l1.02,0.32l0.67,0.6ZM478.75,717.31l0.53,-0.44l3.2,-0.32l0.33,0.57l1.35,0.51l-0.57,1.31l-4.84,-1.63ZM475.5,704.36l2.52,0.37l0.73,0.46l0.25,0.57l-0.19,0.43l-1.53,0.72l-1.51,-1.73l-0.27,-0.81ZM469.74,692.36l-0.12,-0.44l0.75,-0.26l-0.63,0.71ZM457.79,766.95l-0.58,0.15l-0.43,-0.74l-0.23,-1.28l0.33,-0.98l0.89,-0.63l2.26,0.64l-0.13,0.6l-2.1,2.24Z",name:"V\xe4sternorrland"},"SE-X":{path:"M446.71,815.89l-0.77,0.76l-0.4,-0.25l0.13,-0.47l1.05,-0.04ZM444.06,791.75l0.09,0.02l1.32,0.11l-0.76,0.27l-0.65,-0.4ZM420.4,859.3l-1.39,-1.02l-1.25,-0.43l-1.53,-0.14l-0.43,0.4l0.26,1.09l1.6,0.59l3.91,3.25l1.29,1.65l0.75,2.19l-0.81,0.71l-1.89,0.75l-1.3,1.65l0.12,0.59l2.13,1.22l-0.29,2.26l-1.42,1.52l-0.04,0.59l1.3,1.32l0.2,1.0l-0.52,0.57l-1.58,0.03l-0.39,0.33l0.24,0.44l0.75,0.31l2.35,0.26l0.33,0.99l-1.23,1.12l-0.88,2.63l-0.12,1.57l1.06,1.23l-1.41,0.98l-0.19,0.47l0.43,0.28l3.55,-0.41l1.45,0.14l0.3,0.38l-3.42,0.68l-1.59,1.38l-0.74,3.07l-0.04,1.8l1.61,1.42l1.54,0.27l-0.13,1.14l1.03,2.4l0.52,0.15l0.95,-0.47l0.53,0.44l2.25,5.41l-1.48,1.02l-0.18,0.76l0.25,1.21l0.35,0.32l1.23,0.07l0.16,3.38l1.09,0.96l2.28,0.28l-1.37,1.82l-2.15,0.9l-1.91,1.71l-2.48,1.38l-1.78,0.61l-0.38,1.21l0.91,0.6l2.97,-0.76l1.16,0.29l1.46,1.52l2.14,0.69l3.08,2.04l-2.17,1.09l-0.22,0.36l0.21,1.06l1.22,0.64l2.0,0.04l-3.94,13.46l-2.3,3.97l-2.36,1.8l-1.62,2.71l-0.44,2.1l0.57,7.36l-4.27,1.17l-1.39,0.97l-1.16,0.34l-5.48,-0.51l-1.16,-0.5l-2.74,-0.28l-2.22,0.45l-1.73,1.69l-0.17,2.33l-0.65,0.85l-7.09,3.52l-3.32,0.44l-2.56,-0.93l-0.63,-1.11l-3.27,-2.73l-4.25,-6.66l-3.71,-3.92l-4.01,-2.67l-2.18,-0.6l-3.62,-3.0l-6.39,-8.54l-2.57,-1.55l-0.96,-1.14l-3.37,-5.19l0.15,-4.23l3.81,-2.4l5.5,-5.95l0.76,-1.82l2.91,-2.81l0.67,-1.84l0.15,-1.51l-0.26,-1.62l-1.27,-2.0l-8.44,-7.81l-0.89,-2.21l-2.58,-4.46l-3.76,-4.7l-2.68,-0.95l-13.7,-2.39l-7.89,-3.36l-2.26,-1.86l-4.29,-4.67l-0.41,-5.62l-1.46,-3.7l-2.71,-3.07l-12.66,-10.35l-14.02,-15.54l-0.69,-1.33l-1.05,-0.85l-2.25,-2.88l-0.61,-0.02l-4.67,4.84l-0.85,0.43l-26.28,0.0l-0.4,-0.33l-0.27,-1.07l-1.3,-1.63l-0.88,-4.02l-0.3,-0.3l-12.06,-2.84l2.48,-3.85l1.6,-9.52l1.65,-5.38l2.13,-3.83l5.53,-5.85l1.97,-1.04l0.93,-0.11l5.19,7.47l2.0,1.3l0.94,-0.53l0.43,-1.53l-0.75,-2.64l1.2,-0.45l2.47,1.54l2.68,-0.2l1.75,-2.2l2.88,-0.33l3.36,0.44l2.11,1.48l2.07,-0.12l1.01,-1.61l-0.41,-4.36l1.27,-1.56l0.38,-1.84l-0.17,-3.73l-1.04,-3.99l19.62,-12.06l2.14,-2.65l0.63,-2.35l-0.72,-2.42l-1.05,-2.01l-3.35,-4.12l-1.34,-4.02l11.37,-6.89l3.36,-0.92l3.01,0.31l39.64,9.97l18.99,1.03l35.63,7.43l13.54,0.25l3.07,0.9l16.0,2.23l-1.35,2.83l-0.11,3.41l-0.29,0.67l-1.28,0.79l0.05,0.71l1.1,0.47l-0.46,0.99l-2.21,2.28l0.07,0.61l2.03,1.98l-4.29,0.91l-0.59,1.32l-0.0,1.92l-1.95,0.66l-0.67,1.09l-0.27,2.62l1.36,3.88l-1.42,1.56l-0.06,1.67l0.74,0.84l-1.09,2.46l0.45,1.01l0.88,0.42l3.11,-0.57l-0.53,0.82l-1.25,0.4l-0.34,0.4l0.24,1.15l0.94,0.42l-0.19,4.22l0.35,1.92l0.66,0.77l5.89,-1.14l1.11,0.81l0.76,1.13l0.36,2.09l-0.96,2.5l-0.6,3.21l-0.77,0.51l-1.17,-0.08l-1.75,-0.91l-3.31,-5.48l-1.47,-1.78l-2.31,-1.05l-0.56,0.4l0.12,1.37l0.96,2.33l-1.67,-0.33l-0.67,-0.61l0.03,-1.76l-2.64,-1.8l-2.97,-0.6l-5.88,0.18l-0.31,0.63l1.02,1.31l1.2,0.44l2.24,-0.09l4.26,1.95l-0.43,1.25l-1.93,1.06l-4.13,0.64l-0.38,0.4l0.0,0.71l1.21,0.7l-0.9,0.29l-3.01,-0.94l-1.83,1.06l-0.16,0.42l0.32,0.31l8.63,1.46l0.97,0.88l-0.81,0.34l-1.02,-0.15l-2.41,-1.14l-1.58,-0.27l-4.66,0.23l-0.38,0.4l0.0,0.71l0.41,0.4l2.35,-0.09l0.88,0.32l0.38,0.59l-2.39,0.87l-3.12,0.29l-0.35,0.3l0.17,0.43l1.93,1.2l6.4,0.97l-5.78,-0.17l-0.97,0.67l-0.01,0.61l0.77,0.62l1.46,0.39l1.36,0.94l2.13,0.49l-2.44,0.1l-0.4,0.4l0.0,0.65l0.26,0.38l3.04,1.33l0.25,0.99l-0.98,1.12l-0.67,1.39l1.23,2.55l0.82,0.54l1.05,0.05l-1.71,1.08l-1.16,-1.47l-0.73,-0.37l-0.56,0.24l-0.57,1.83l-1.35,1.07l-0.26,1.35l2.43,3.25l1.97,1.41l2.12,0.76l0.31,1.22l3.95,1.87l-2.87,-0.16l-4.17,-1.53l-0.43,0.11l-0.07,0.44l0.85,1.79ZM421.85,860.36l0.78,0.39l1.42,0.35l-1.55,-0.27l-0.64,-0.47ZM422.77,846.39l0.99,-1.22l0.44,-0.06l-0.16,0.95l-1.27,0.33ZM442.54,792.44l-0.14,-0.26l0.11,-0.3l0.11,0.08l-0.08,0.48ZM439.39,834.16l1.05,0.76l-0.38,0.25l-3.45,-0.22l-0.47,-1.08l-0.63,0.23l-0.44,1.14l-0.46,-1.06l0.06,-0.44l0.7,-0.24l4.02,0.66ZM433.19,912.7l-2.67,0.39l-0.15,-0.61l0.52,-0.78l0.78,0.06l0.86,0.85l0.67,0.08ZM431.16,875.97l-0.55,-1.0l0.37,-0.87l0.5,-0.14l-0.32,2.0ZM428.78,833.6l-0.9,-0.22l0.33,-1.52l1.34,0.42l-0.14,1.01l-0.62,0.31ZM425.95,888.39l-1.88,-0.48l1.3,-1.64l1.11,0.65l-0.54,0.76l0.01,0.71Z",name:"G\xe4vleborg"},"SE-W":{path:"M238.02,830.33l12.29,2.9l0.84,3.87l1.38,1.79l0.34,1.16l0.87,0.61l26.52,-0.0l1.33,-0.67l4.36,-4.52l1.99,2.55l0.98,0.76l0.73,1.38l14.08,15.6l12.7,10.39l2.6,2.94l1.32,3.37l0.44,5.76l4.51,4.98l2.42,1.97l7.99,3.4l13.8,2.42l2.32,0.78l3.6,4.51l2.56,4.41l0.97,2.34l8.46,7.83l1.15,1.83l0.18,1.33l-0.74,2.95l-2.82,2.67l-0.75,1.8l-5.41,5.86l-3.85,2.4l-0.49,3.46l0.21,1.7l3.47,5.33l1.09,1.27l2.44,1.43l6.44,8.6l3.81,3.14l2.21,0.6l3.81,2.53l3.64,3.84l4.25,6.66l3.31,2.78l0.55,1.02l0.1,1.09l-1.08,0.46l-9.85,2.06l-2.58,2.19l-3.12,4.54l-1.53,1.08l-1.71,0.83l-3.98,1.05l-2.93,0.29l-6.44,-0.57l-3.03,-1.33l-0.76,-1.29l-0.82,-4.0l-1.63,-1.46l-3.51,-0.92l-1.71,-0.94l-1.63,0.27l-1.32,-0.63l-4.41,-0.52l-5.6,1.49l-3.71,-0.3l-4.52,3.22l-0.3,1.04l0.45,1.2l-1.78,3.64l-1.31,1.33l-0.29,1.06l1.22,2.19l0.05,4.69l-0.9,1.51l-1.69,1.39l-1.19,0.41l-1.05,-0.11l-3.63,-1.45l-2.47,-0.04l-1.69,0.84l-0.94,1.41l-0.91,2.89l-2.42,2.31l-1.14,2.16l-13.05,-12.34l-1.42,-0.81l-15.03,-4.96l-6.16,-1.15l-3.05,-1.31l-1.22,-0.89l-0.33,-0.38l-0.27,-1.51l-0.59,-0.48l-1.15,-0.02l-1.38,0.43l-3.27,2.03l-0.86,2.01l-0.35,2.0l1.21,3.58l-3.15,0.36l-18.03,-1.88l-13.0,-7.09l-1.35,-2.99l-1.74,-2.17l-2.27,-4.88l-1.41,-2.27l-1.15,-1.12l-1.23,-0.57l-5.71,-0.4l-4.4,-1.18l-0.88,0.49l0.31,1.64l2.78,2.86l-2.49,1.25l-1.34,-0.57l-7.2,-5.83l-12.11,-14.94l-2.01,-1.26l-7.6,-2.81l-2.36,-1.8l-2.71,-3.33l-1.17,-2.62l-2.42,-3.95l-9.36,-12.43l-3.89,-2.4l-2.56,-5.76l-1.74,-2.58l-2.98,-3.13l-23.26,-18.98l-0.81,-1.33l-2.1,-4.28l1.43,-7.3l0.88,-2.18l4.94,-5.51l1.45,-2.42l1.03,-2.98l2.28,-9.8l-0.07,-1.35l-0.74,-1.18l-18.04,-18.44l-2.07,-1.47l-2.34,-0.67l-4.72,-0.24l-2.49,-0.44l-1.82,-0.86l-5.31,-5.25l-3.22,-1.94l-7.82,-6.26l-0.82,-1.2l10.58,-53.33l-0.14,-3.72l1.35,-0.21l30.91,7.07l12.05,8.0l5.09,5.26l9.4,3.98l6.77,-0.39l6.16,4.23l-1.42,2.33l-2.11,8.16l5.58,7.31l2.55,4.46l3.26,4.24l1.89,3.15l1.54,3.8l4.29,3.02l47.13,6.18l5.82,1.85l6.87,-0.96Z",name:"Dalarna"},"SE-BD":{path:"M704.1,423.5l-0.55,0.85l-2.95,0.33l-0.91,1.49l0.27,0.6l8.56,1.63l1.97,1.37l4.06,5.27l3.79,3.37l4.85,6.79l0.52,1.98l-0.98,0.75l-3.65,0.17l-0.36,0.28l1.23,1.85l-0.04,1.01l-1.22,3.22l-18.46,-9.35l-78.42,-16.34l-28.19,6.86l-5.24,4.65l-8.3,3.92l-3.79,1.18l-1.66,0.26l-1.21,-0.27l-1.01,-0.7l-0.06,-1.0l-0.47,-0.55l-3.37,-1.97l-2.19,-0.65l-1.94,0.01l-1.13,-0.72l-0.5,-3.21l-0.84,-2.04l-2.09,-1.88l-3.99,-2.14l-7.06,-1.39l-3.75,-3.72l-11.27,-3.63l-3.71,-3.0l-3.22,-4.07l-1.38,-0.43l-9.41,-0.27l-2.27,-0.87l-4.39,-3.37l-7.16,-1.44l-3.7,-1.55l-3.52,-2.44l-3.13,-3.24l-1.67,-2.38l-27.3,-8.48l-20.96,-10.99l-40.22,-28.15l-26.19,-7.9l-43.18,-22.65l-26.24,-8.88l-3.09,-12.09l-0.23,-2.89l16.47,-12.26l25.14,-32.88l5.87,-5.32l12.54,-8.63l3.99,-1.63l2.11,-1.38l1.21,-2.06l1.97,-15.09l-0.41,-2.17l-21.1,-25.67l3.53,-8.24l1.14,-1.22l11.26,-1.53l4.27,-1.45l3.87,-2.87l7.1,-7.9l1.54,-2.61l10.42,-26.74l1.38,-2.24l1.63,-1.52l28.02,-15.11l5.52,-6.82l1.23,-0.73l38.91,15.81l2.19,-0.47l2.06,-2.17l14.7,-19.61l1.55,-4.85l-3.59,-23.33l0.08,-3.55l1.64,-12.09l0.55,-0.53l17.77,-4.43l2.95,1.34l11.21,7.22l3.88,0.67l22.94,-1.18l30.16,9.62l30.6,8.71l3.04,-0.16l2.66,-1.49l16.11,-13.43l-0.11,-0.68l-18.57,-7.25l12.21,-7.35l5.87,-6.26l7.02,-12.71l0.93,-2.45l0.32,-2.34l-0.53,-10.6l-0.67,-2.31l-15.47,-12.71l34.32,-1.64l3.63,2.16l8.07,0.82l4.59,2.93l3.23,0.7l1.39,1.43l-0.02,1.87l-0.99,1.7l-1.91,0.65l-0.27,0.34l-0.21,2.43l1.56,1.76l11.46,3.09l9.73,6.14l3.99,4.81l1.22,1.0l0.98,1.57l5.53,0.25l1.18,0.5l0.96,2.42l3.02,4.96l2.32,1.4l5.15,0.95l6.0,3.97l3.67,1.66l1.62,3.8l12.3,2.31l2.91,2.4l3.33,3.65l1.52,1.1l0.33,2.27l2.3,1.33l15.89,0.16l4.47,0.88l0.0,1.04l0.65,0.68l5.31,0.27l4.34,1.58l3.02,0.24l3.0,1.35l3.59,-0.29l1.77,1.16l1.93,2.09l2.06,1.61l4.23,-0.99l1.5,1.05l2.8,3.92l2.01,1.77l10.15,4.56l0.9,0.84l1.02,2.94l0.96,1.21l3.01,2.46l0.94,1.78l-0.38,2.62l0.63,1.06l0.07,0.78l-0.7,4.68l0.25,1.28l0.93,0.93l1.96,0.11l5.71,-2.63l2.1,-0.07l1.46,1.87l3.0,7.96l0.7,1.17l6.92,4.13l6.03,4.96l4.77,1.23l1.11,1.28l-0.05,1.77l-1.58,2.09l-2.11,1.16l-4.87,1.17l-2.44,1.43l-1.25,2.2l-0.31,2.79l0.54,5.26l-0.0,6.92l1.02,3.32l1.32,6.53l1.63,3.08l0.51,1.75l0.2,2.54l-1.05,0.99l-2.4,1.22l-1.83,1.35l-0.11,0.51l0.66,1.21l-2.73,4.29l-0.84,2.48l0.96,3.02l2.56,2.09l2.53,-0.12l2.75,-0.84l2.63,-0.18l4.55,1.97l4.71,0.58l1.36,0.44l0.66,0.65l-0.12,2.39l-0.81,3.3l0.01,2.69l0.24,0.37l1.96,0.85l-1.34,3.15l-1.77,1.81l-7.61,2.36l-1.59,1.28l-0.57,1.91l-0.21,2.24l0.39,1.01l1.09,0.53l-1.01,2.29l-1.55,1.92l0.4,2.65l5.83,6.45l0.68,4.48l3.05,4.92l1.68,1.89l1.32,0.82l1.98,0.59l1.57,1.45l3.85,5.79l4.08,4.13l1.85,3.03l2.88,6.28l-0.24,0.73l-0.75,0.28l-1.6,-0.06l-1.77,0.5l-0.96,2.02l-2.27,2.72l0.72,5.09l0.01,2.29l-0.28,2.23l-1.15,3.88l0.75,4.23l-0.11,1.85l-0.59,1.58l-1.28,0.93l-3.61,1.73l-0.32,1.42l-1.19,0.96l-2.03,0.72l-1.71,1.03l-0.19,1.85l-3.48,1.44l-1.87,1.98l-0.69,2.75l0.35,1.51l1.28,2.05l0.73,4.63l-0.04,1.47l-0.92,3.91l1.84,6.83l2.44,5.81l1.85,1.99l2.42,1.47l7.08,1.78l1.38,1.29l4.29,8.53l3.07,2.7l2.37,7.04l0.02,4.34l3.22,4.41l1.56,4.52l2.56,3.05l-0.02,1.75l-1.37,1.8l-2.17,0.27l-4.87,-0.88l-0.41,0.61l0.77,1.28l-0.74,0.3l-3.21,-0.52l-1.79,0.67l-0.62,0.94l-0.49,1.77l-0.75,0.47l-2.61,-1.37l-0.43,-0.5l-0.36,-1.65l-0.39,-0.33l-0.68,0.1l-0.64,0.55l-3.14,-0.03l-1.4,-0.35l-1.25,-3.07l-1.9,-1.06l-3.55,-0.05l-1.18,0.66l-1.72,2.46l-0.78,0.65l-0.51,-0.01l-1.25,-1.52l-5.38,-0.03l-2.53,-0.56l0.23,-1.53l-0.82,-0.64l-1.02,0.15l-0.86,0.36l-0.68,1.72l-1.3,0.7l-0.61,0.87l0.12,0.55l0.9,0.88l-0.26,2.5l-1.65,-0.33l-0.97,-0.62l-0.66,-1.54l-0.25,-1.9l0.25,-1.56l-0.44,-0.46l-1.69,0.26l-2.64,2.74l-1.28,0.02l-4.0,-2.98l-1.15,-0.49l-1.35,-0.02l-1.23,1.2l-0.06,2.13l0.67,1.53l2.68,2.05l-4.74,1.73l-0.81,0.58l-1.39,1.34l-0.05,2.2l-1.48,0.95l-1.08,-0.19l0.39,-2.19l-1.95,-3.07l-0.91,-0.78l-3.99,-0.43l-3.02,-1.2l-2.05,-2.35l-1.16,-0.3l-1.52,0.41l-1.0,-0.11l-1.41,-1.17l-2.09,-4.51l-1.57,-1.94l-7.64,-4.65l-1.68,-0.35l-1.27,0.36l-0.21,0.63l2.61,2.65l0.59,1.09l1.17,7.4l-0.71,3.01l-1.53,1.84l-0.4,0.1l0.11,-2.36l-1.89,-1.46l-4.19,-0.61l-3.57,2.27l-0.22,-0.53l0.35,-1.05l1.3,-1.57l0.07,-0.51l-0.93,-1.45l-3.14,-2.26l0.39,-1.26l-0.32,-0.51l-4.99,-0.79l-2.41,0.25l-0.36,0.36l-0.16,1.8l-2.55,0.63l-0.2,0.66l2.7,2.92l-0.13,0.86l-0.52,0.08l-2.1,-0.61l-0.44,0.16l1.76,3.85l0.87,0.99l-1.97,2.41l-2.45,-0.78l-2.94,-1.93l-2.41,-0.11l-0.33,0.65l1.43,1.78l1.51,1.2l1.67,0.6l4.44,0.7l1.36,0.8l0.93,1.65l0.62,2.49l-1.32,0.05l-1.2,0.57l-0.54,-2.13l-1.59,-1.5l-2.26,-0.12l-1.63,0.95l-0.09,0.62l0.6,1.06l-0.65,1.61l1.7,3.73l-1.13,0.49l-4.89,0.16l-0.38,0.35l0.29,0.43l5.01,1.38l2.69,0.04l1.65,-2.75l-0.45,-1.33l-1.59,-1.48l-0.23,-0.77l0.29,-0.5l0.66,0.3l1.43,1.67l-0.34,0.46l0.19,0.62l3.61,1.39l-2.72,1.5l-0.59,1.56l0.84,1.08l1.61,0.78l2.54,0.62l1.36,3.25l-1.09,0.53l-2.26,-2.22l-1.48,-0.78l-3.37,-0.8l-1.71,-1.26l-1.16,-0.11l-0.84,0.72l0.12,1.38l-1.26,-0.22l-6.88,-3.51l-5.1,-1.52l-3.04,-2.7l-2.95,-0.6l-2.4,-1.88l-4.16,-1.01l-1.5,-1.15l-2.35,-3.03l-3.58,-1.97l-0.16,0.47l1.75,4.79l4.18,2.93l8.29,3.28l5.58,3.77l4.54,1.61l1.86,1.48l1.51,1.81l1.05,0.6l-0.39,0.22l-3.71,0.03l-1.98,0.48l-0.89,0.62l-0.83,1.63l-1.28,-1.1l-0.81,0.02l-1.72,0.79l-9.17,-2.13l-1.58,0.16l-0.26,0.65l3.26,3.87l2.26,1.37l1.53,-0.61l0.12,-0.67l-0.98,-0.87l0.35,-0.03l3.78,3.51l1.63,0.98l-1.19,3.46l-0.76,0.52l-0.86,-0.06l-0.89,-0.67l-1.59,-2.14l-0.68,0.06l-0.71,1.6l0.71,2.2l-0.03,0.82l-0.76,0.66l-1.18,0.13l-1.02,-0.44l-0.46,-1.08l-0.58,-0.19l-2.0,1.22l-1.95,0.69l-1.97,0.1l-5.87,-1.59l-1.2,0.24l-0.26,0.6l0.61,1.0l-2.44,0.08l-1.5,-0.28l-1.68,-2.11l-1.59,0.05l-2.96,0.72l-0.3,0.39l0.28,1.07l1.47,0.47l-2.56,-0.27l-2.88,0.54l-1.3,1.75l0.2,0.62l0.68,0.35l-2.18,1.19l-0.2,0.41l0.32,0.33l2.77,0.94l3.64,3.36l1.79,0.28l1.25,-0.57l0.33,-1.61l0.75,0.19l3.34,2.75l2.17,1.29l0.85,1.03l-0.13,1.28l-1.96,1.94l-2.96,1.27l-2.95,0.28l-2.01,-0.93l-2.73,-5.28l-2.05,-2.12l-1.29,-0.73l-1.46,-0.29l-1.7,-1.12l-2.04,-2.39l-2.28,-2.02l-2.57,0.12l-0.36,0.34l0.25,0.43l0.96,0.56ZM894.17,375.41l-0.4,0.23l1.03,-0.72l-0.02,0.14l-0.6,0.35ZM890.64,380.91l-0.32,0.11l-0.03,-0.05l0.34,-0.3l0.01,0.24ZM883.87,386.52l0.88,0.22l1.32,0.05l-0.5,0.59l-0.69,-0.05l-0.65,-0.24l-0.36,-0.56ZM884.9,390.45l0.14,-0.1l-0.07,0.15l-0.06,-0.05ZM883.9,376.42l0.01,0.08l-0.09,-0.03l0.05,-0.06l0.03,0.01ZM874.63,390.59l0.0,-0.02l0.0,0.03l-0.01,-0.01ZM872.63,392.65l-0.8,-0.19l-0.92,-0.43l0.54,-0.67l1.18,1.29ZM867.16,380.59l0.64,0.51l1.72,0.47l1.61,-0.88l0.38,0.45l0.68,-0.04l0.25,-0.52l0.06,0.31l-1.27,2.76l-2.75,2.06l-2.33,-1.07l-1.11,-1.41l0.01,-2.11l0.94,0.96l0.54,-0.06l0.61,-1.45ZM869.2,397.6l-0.06,0.9l1.18,2.64l-2.61,-1.22l0.03,-0.33l1.01,-0.68l0.45,-1.3ZM851.91,381.35l1.0,1.65l0.08,1.14l-1.16,-0.96l0.09,-1.83ZM846.66,380.19l0.09,-0.37l0.14,-0.25l0.17,0.83l-0.39,-0.21ZM833.6,382.29l0.49,0.24l0.57,-0.29l-0.22,-1.1l0.67,-0.37l1.47,0.61l-0.64,-0.2l-0.85,0.54l0.05,0.99l0.64,1.24l-0.29,0.32l-1.87,-1.99ZM837.92,383.27l0.38,0.22l0.06,0.06l-0.14,-0.03l-0.29,-0.25ZM835.25,379.28l1.22,-0.17l-0.02,0.7l-0.35,-0.11l-0.85,-0.42ZM831.44,380.11l2.0,-0.68l0.52,0.43l-1.46,0.7l-0.75,-0.01l-0.31,-0.44ZM834.19,375.83l-0.67,-0.04l-0.34,-0.51l0.89,0.24l0.12,0.31ZM822.39,389.19l0.51,-0.54l1.08,0.5l0.11,0.45l-0.4,0.14l-1.3,-0.55ZM818.29,388.88l0.81,0.0l0.13,0.4l-0.41,0.03l-0.53,-0.44ZM816.25,391.8l0.47,0.33l0.17,0.21l-0.48,-0.32l-0.16,-0.22ZM816.8,385.82l-1.39,0.35l-0.23,0.8l0.45,1.79l-3.94,-3.35l-1.06,-1.96l0.23,-1.56l0.96,-0.47l1.54,0.09l1.56,0.85l0.07,0.26l-0.54,0.05l-0.36,0.49l0.08,0.33l2.18,1.49l0.44,0.85ZM802.77,402.92l-1.18,-0.08l-0.23,-0.38l0.06,-0.07l1.35,0.53ZM803.59,403.3l1.45,0.63l-0.58,0.47l0.01,0.81l-0.88,-1.9ZM804.98,384.2l-0.24,0.59l-2.7,-0.32l-1.72,-1.02l-0.32,-0.93l0.6,-3.9l0.38,-0.22l2.7,2.03l1.3,3.77ZM804.87,402.17l-1.18,-0.04l-0.72,-0.74l1.04,-0.39l0.86,1.18ZM803.55,389.67l0.42,1.07l-0.21,0.06l-0.74,-0.21l-0.3,-0.75l0.84,-0.17ZM800.73,374.37l-0.23,-0.26l0.06,0.01l0.17,0.25ZM798.92,411.07l0.62,-1.07l0.75,-0.28l-0.2,1.38l-1.17,-0.03ZM799.05,405.81l-0.75,0.03l-0.09,-0.39l0.58,-0.24l0.26,0.6ZM798.86,388.92l-0.68,-0.13l-0.6,-0.33l0.96,-0.06l0.32,0.52ZM798.25,408.51l-1.57,-0.54l-0.39,-0.54l0.83,0.22l1.14,0.87ZM796.53,402.56l-1.67,0.73l-0.64,0.07l0.28,-0.88l0.55,-0.43l1.21,0.03l0.27,0.49ZM793.87,392.76l-0.5,0.2l-0.84,-0.22l-0.19,-0.43l1.45,0.02l0.08,0.44ZM791.45,390.29l0.78,-0.73l0.13,-1.13l0.54,-0.6l0.45,0.65l0.03,1.46l-1.93,0.36ZM791.76,377.39l0.24,-0.64l1.23,0.12l-0.2,0.31l-1.27,0.21ZM788.91,401.58l-1.79,-0.84l-0.5,-1.0l0.22,-0.27l2.74,-0.15l3.17,-1.15l0.61,0.28l-0.14,0.53l-1.55,0.94l-0.54,1.55l-0.39,0.26l-1.53,-0.43l-0.3,0.29ZM791.43,413.31l0.66,-0.48l0.44,0.48l-0.28,0.12l-0.82,-0.11ZM791.66,406.51l-1.34,-0.08l-1.27,-0.48l-0.8,-1.18l0.15,-0.34l3.04,1.38l0.21,0.71ZM790.81,396.83l-0.66,0.46l-1.02,-0.09l-0.72,-0.71l0.57,-0.49l1.43,-0.04l0.4,0.88ZM786.91,407.53l2.0,2.39l0.1,0.48l-0.3,0.21l-2.98,-0.17l-0.69,-0.47l-0.32,-0.82l0.28,-0.82l0.62,-0.65l1.29,-0.15ZM784.02,418.37l1.41,0.25l0.32,0.59l-0.9,0.06l-0.82,-0.9ZM782.01,373.8l0.02,0.06l0.14,0.43l-0.18,-0.37l0.02,-0.12ZM781.13,424.26l0.37,-0.31l0.47,0.05l-0.03,0.01l-0.81,0.25ZM782.18,421.57l-0.75,-0.35l-0.07,-0.37l0.6,0.29l0.22,0.43ZM781.63,388.75l0.22,-0.04l0.01,0.14l-0.24,-0.1ZM779.17,394.82l0.02,0.0l0.02,0.02l-0.02,-0.01l-0.02,-0.01ZM777.7,422.04l1.74,0.82l-0.21,0.67l-1.09,-1.14l-0.44,-0.35ZM778.76,385.36l-1.23,-0.38l0.06,-0.44l1.27,-0.36l-0.09,1.17ZM777.72,375.66l-0.61,0.03l-0.17,-0.45l0.11,-0.13l0.67,0.55ZM778.09,413.85l-0.3,0.58l-2.15,1.08l-5.32,0.28l-0.35,-0.2l0.52,-1.82l0.48,-0.17l1.61,1.29l1.71,-0.69l1.25,-1.09l1.13,-0.01l1.41,0.76ZM775.65,396.22l0.17,0.15l-0.03,0.55l-0.21,-0.13l0.07,-0.57ZM775.3,428.75l-0.02,-0.01l0.02,0.0l0.0,0.01ZM775.23,405.84l0.36,0.37l-0.12,0.39l-0.14,-0.04l-0.1,-0.72ZM768.35,407.86l-0.03,1.39l0.6,0.8l-3.6,-2.92l-1.67,-2.04l-0.32,-0.97l1.25,-0.58l0.86,0.11l5.19,2.31l1.12,-0.04l2.4,2.02l-0.02,0.54l-1.13,0.26l-1.73,-1.67l-2.08,-0.76l-0.87,0.44l0.02,1.11ZM765.61,416.66l-4.79,-1.08l-0.56,-1.39l0.31,-2.34l0.4,-0.4l0.95,0.0l2.26,0.87l-0.29,1.67l1.41,1.52l0.32,1.16ZM757.66,416.38l0.22,-0.38l0.15,-0.5l0.32,0.25l-0.5,0.5l0.14,0.44l-0.32,-0.32ZM755.96,406.91l1.8,0.76l-0.59,0.73l-0.97,0.45l-0.23,-1.94ZM754.78,409.27l0.11,-0.03l0.08,0.13l-0.11,-0.04l-0.08,-0.06ZM753.92,419.21l-0.68,-0.15l-0.18,-0.68l0.52,-0.1l0.83,0.44l-0.48,0.49ZM750.09,407.97l0.03,0.0l-0.01,0.01l-0.02,-0.01ZM751.19,407.81l0.25,-0.04l0.33,0.1l-0.06,0.13l-0.51,-0.19ZM751.44,422.22l-1.4,-0.28l-1.19,-0.76l-0.2,-0.44l0.29,-0.48l0.66,-0.13l1.43,0.77l0.42,1.33ZM742.66,425.23l0.26,-0.15l0.57,0.48l-0.35,-0.21l-0.48,-0.12ZM740.29,435.46l0.07,0.99l-0.99,-1.19l-1.8,0.28l-2.36,-0.63l-1.54,-2.56l2.12,0.34l1.76,1.42l2.74,1.34ZM739.53,442.0l-4.83,-3.34l-0.21,-0.56l0.72,-0.3l0.66,0.4l1.13,0.05l1.13,0.8l1.01,0.95l0.39,2.0ZM736.93,420.89l0.37,0.21l-0.24,-0.05l-0.13,-0.16ZM727.4,420.76l1.98,0.75l0.6,-0.37l0.16,-0.62l0.51,-0.14l2.5,0.51l2.46,1.46l2.01,2.48l-1.67,-0.34l-1.91,-0.96l-2.85,-2.74l-0.69,0.3l-0.35,0.83l-1.23,-0.28l-1.53,-0.87ZM736.93,428.44l-2.61,-0.58l-0.66,-0.66l0.52,-0.14l1.85,0.58l0.9,0.8ZM731.24,449.45l0.04,-0.09l0.06,-0.41l0.25,0.2l-0.35,0.29ZM728.86,449.09l-0.75,-0.13l-1.08,-0.89l0.12,-0.52l0.28,-0.14l1.43,1.68ZM721.21,453.92l-0.05,-0.78l0.92,-0.54l0.9,0.55l-0.03,0.54l-1.22,-0.15l-0.52,0.38Z",name:"Norrbotten"},"SE-T":{path:"M303.99,1006.09l1.75,2.63l0.11,0.81l-0.71,1.57l0.18,0.86l4.49,1.99l1.03,1.54l1.24,2.91l0.29,1.89l-1.64,6.62l-0.14,2.49l0.39,1.46l0.9,0.91l4.89,0.39l0.91,1.1l0.6,4.53l0.34,1.34l0.64,0.98l1.14,0.37l1.84,-0.18l1.11,0.58l-0.11,1.49l-1.37,2.09l-0.06,1.09l1.95,2.4l0.41,2.62l-0.6,0.95l-1.21,0.62l-5.37,1.44l-0.98,1.88l-0.17,1.33l0.29,1.21l1.53,2.11l-1.76,3.83l-0.11,1.43l0.55,0.52l2.72,1.1l1.63,1.17l2.53,3.15l1.19,0.4l3.38,-0.01l-1.75,2.4l-0.53,1.24l0.79,2.47l1.64,3.41l-0.11,1.24l-0.87,0.63l-3.27,0.98l-2.02,1.08l-0.86,1.22l-3.18,2.84l-1.06,2.0l1.46,2.5l3.74,2.69l-4.12,0.96l-3.41,1.57l-0.78,1.15l-0.1,0.96l0.39,1.74l-0.34,1.3l-1.69,2.12l-1.78,1.05l-7.46,2.82l-1.86,0.39l-1.77,-0.01l-2.42,-0.69l-1.89,-0.11l-2.33,0.47l-7.45,3.8l-2.07,1.75l-5.29,6.07l-3.42,2.96l-7.96,1.81l-2.38,1.18l-3.12,2.26l-4.14,-2.48l-1.32,-1.43l-0.86,-2.48l-1.22,-2.17l-1.52,-0.93l-1.41,-0.3l-1.02,0.31l-1.44,2.02l-2.27,1.19l-0.45,-0.21l-0.53,-1.01l-0.75,-0.31l-2.75,-0.34l-1.47,-0.59l-0.47,-0.8l-0.56,-3.58l-1.0,-1.78l-3.79,-4.76l-0.65,-1.38l-0.13,-3.51l-3.11,-5.87l-2.67,-6.23l0.99,-3.92l0.33,-4.05l-1.45,-6.6l-0.07,-4.56l1.35,-9.29l1.29,-4.02l4.63,-9.61l3.46,-3.64l0.39,-1.25l-0.31,-1.59l-2.26,-2.18l-0.39,-0.89l-0.02,-1.1l0.93,-2.2l0.46,-0.19l1.16,0.5l0.54,-0.17l0.37,-0.78l0.12,-1.52l-0.52,-4.46l-1.99,-6.11l-0.66,-4.0l0.08,-9.2l-0.61,-9.14l-0.79,-2.11l-1.21,-1.08l-2.85,-1.69l-0.12,-0.88l0.89,-0.69l5.78,-2.75l0.23,-0.4l-0.28,-3.06l17.65,1.84l3.81,-0.46l0.3,-0.53l-1.31,-3.72l0.3,-1.76l0.79,-1.85l2.87,-1.72l2.04,-0.37l0.32,1.49l0.57,0.7l1.37,0.98l3.14,1.34l6.21,1.16l14.96,4.94l1.28,0.74l13.29,12.59Z",name:"Orebro"},"SE-S":{path:"M56.58,1069.67l-0.33,-4.24l-1.56,-6.78l-7.26,-20.05l-0.42,-2.09l0.25,-2.51l1.14,-1.37l9.19,-3.81l1.69,-1.44l3.1,-4.2l0.37,-7.41l-0.96,-1.91l-2.34,-2.28l-0.72,-1.27l0.41,-3.15l2.58,-1.92l3.39,-0.9l10.87,0.81l3.03,-0.51l10.06,-6.17l10.68,-9.45l2.53,-3.14l1.89,-3.75l0.97,-4.56l-0.22,-3.85l-1.76,-6.56l-0.56,-3.38l0.28,-1.53l0.82,-1.26l4.99,-5.15l1.14,-2.09l0.81,-2.54l0.5,-3.8l-0.27,-3.19l-1.02,-3.07l-7.62,-14.63l-7.19,-9.98l-1.81,-3.98l-2.51,-11.19l-1.28,-3.51l-2.6,-4.68l-0.16,-1.8l1.64,-1.21l15.6,-3.48l3.87,-0.15l7.65,1.06l1.66,-0.63l0.4,-0.64l2.75,5.26l23.3,19.01l2.9,3.05l1.62,2.4l2.64,5.9l0.75,0.74l2.17,0.93l1.01,0.78l9.32,12.37l2.38,3.87l1.23,2.71l3.74,4.29l1.65,1.09l7.6,2.81l1.84,1.17l12.0,14.84l7.43,6.01l1.84,0.66l2.59,-1.13l0.49,-0.54l-0.08,-0.94l-2.71,-2.67l-0.3,-0.72l0.31,-0.25l4.14,1.19l5.68,0.4l0.96,0.47l2.29,3.11l2.29,4.92l1.7,2.11l1.56,3.25l13.0,7.09l0.28,3.06l-5.64,2.69l-1.02,0.79l-0.35,0.96l0.52,1.05l4.0,2.71l0.62,1.8l0.58,8.96l-0.07,9.27l0.68,4.09l1.98,6.09l0.5,4.26l-0.21,1.59l-1.36,-0.4l-0.87,0.43l-0.59,0.84l-0.53,1.76l0.01,1.36l0.56,1.3l2.12,1.92l0.27,1.39l-0.97,1.76l-2.76,2.69l-4.67,9.7l-1.34,4.16l-1.37,9.45l0.08,4.66l1.44,6.49l-0.31,3.91l-0.88,3.51l-3.67,-2.02l-1.91,-0.6l-41.7,-1.02l-2.02,0.38l-2.27,1.26l-2.68,2.14l-4.09,5.09l-2.46,4.68l-2.44,6.59l-0.43,1.55l0.32,1.61l0.98,1.8l3.06,4.02l0.1,0.63l-0.51,0.38l-3.9,1.15l-5.83,-0.01l-24.26,-7.21l-4.65,-17.09l-5.58,-7.41l-0.9,-5.97l-0.6,-1.7l-3.73,-3.36l-1.12,-0.64l-1.89,0.14l-2.32,1.69l-1.48,2.31l-1.35,1.04l-2.53,-2.54l-1.7,0.14l-1.89,0.68l-4.7,-2.48l-0.38,-0.42l0.11,-0.56l3.02,-0.47l0.8,-0.4l0.3,-0.74l-0.81,-0.83l-1.47,-0.19l-5.83,1.35l-0.71,-0.08l-6.4,-2.54l-1.47,-2.85l-1.64,-1.02l-2.05,-0.28l-4.13,0.69l-1.45,1.11l-0.26,1.59l0.18,1.37l-1.35,0.76l-0.65,-0.07l-7.35,-4.49l-1.23,-0.06l-1.61,1.06l-1.62,0.17l-5.54,-1.44Z",name:"V\xe4rmland"},"SE-U":{path:"M406.77,1041.24l-4.52,2.11l-3.04,-0.05l-38.39,5.69l-0.95,0.59l-0.43,0.97l0.07,0.94l0.93,1.88l2.19,1.36l-0.27,0.86l-0.78,0.58l-1.39,0.74l-4.75,1.42l-2.04,0.27l-7.19,-1.08l-1.77,0.16l-2.89,0.93l-2.13,1.62l-4.15,5.68l-0.54,1.02l-0.12,2.67l-0.31,0.81l-2.69,1.92l-4.17,1.22l1.1,-1.58l-0.04,-0.77l-0.32,-0.33l-3.75,0.02l-0.85,-0.32l-2.37,-3.05l-1.8,-1.28l-2.89,-1.3l1.96,-4.9l-1.63,-2.44l-0.2,-0.81l0.54,-2.19l0.35,-0.44l5.16,-1.32l1.35,-0.69l0.88,-1.29l-0.41,-3.24l-1.91,-2.25l0.01,-0.67l1.37,-2.11l0.13,-2.01l-1.11,-0.99l-3.17,-0.11l-0.77,-1.89l-0.18,-2.82l-0.45,-1.83l-1.13,-1.44l-1.63,-0.39l-2.83,0.01l-1.11,-0.62l-0.33,-1.17l0.13,-2.38l1.64,-6.63l-0.3,-2.14l-1.31,-3.09l-1.15,-1.72l-2.27,-1.24l-2.16,-0.69l0.66,-1.83l-0.13,-1.15l-1.76,-2.66l1.18,-2.33l2.48,-2.4l0.93,-2.93l0.7,-1.12l1.31,-0.7l2.31,0.04l3.41,1.39l1.35,0.17l1.64,-0.55l1.88,-1.57l1.07,-1.93l-0.07,-4.9l-0.32,-0.96l-0.7,-0.67l0.02,-1.12l1.25,-1.25l1.9,-3.89l-0.33,-1.89l4.21,-3.02l3.49,0.35l5.54,-1.49l4.17,0.49l1.31,0.64l1.51,-0.3l1.77,0.94l3.42,0.88l1.35,1.24l1.0,4.62l0.78,0.85l1.92,1.01l1.44,0.44l6.52,0.57l3.08,-0.3l4.18,-1.11l3.45,-2.03l3.17,-4.58l2.28,-2.0l9.86,-2.07l1.38,-0.59l0.16,-1.24l2.34,0.82l3.57,-0.47l7.31,-3.61l0.99,-1.3l0.1,-2.15l1.36,-1.35l1.87,-0.39l2.6,0.26l1.22,0.51l5.6,0.52l1.45,-0.4l1.38,-0.97l4.35,-1.2l9.58,5.89l1.2,1.0l0.3,1.35l-0.54,2.26l-5.29,12.57l-1.25,1.8l-1.03,0.78l-2.64,-0.01l-0.93,0.3l-3.83,5.36l-0.09,0.94l0.46,0.87l2.49,1.56l0.1,2.66l-0.34,2.4l-0.63,1.65l-0.87,1.18l-3.45,1.73l-2.85,2.02l-2.28,0.8l-1.3,-0.74l-0.88,-1.35l-0.72,-0.55l-3.8,-0.56l-4.66,-1.34l-1.74,-0.06l-0.56,0.94l0.17,3.28l-0.38,1.09l-0.84,0.96l-3.15,1.64l-0.46,1.1l0.67,1.7l7.03,11.72l1.1,2.78l2.06,7.85l1.19,2.85Z",name:"V\xe4stmanland"},"SE-AC":{path:"M562.49,440.1l1.57,1.16l2.1,0.03l2.01,0.6l3.23,1.87l0.41,1.45l1.24,0.89l1.64,0.36l1.76,-0.28l3.96,-1.23l8.38,-3.96l5.14,-4.6l27.82,-6.82l78.28,16.31l20.72,10.4l-0.46,0.26l-5.88,-0.01l-0.93,1.21l0.75,1.74l1.44,1.81l-2.1,1.16l-1.85,-0.75l-0.96,0.0l-0.77,1.62l-2.25,1.78l-0.17,1.38l0.71,0.83l-0.65,0.43l-8.18,0.36l-1.02,0.44l-0.36,1.16l0.7,1.5l-0.31,0.99l-1.21,1.57l-1.55,0.79l-0.3,0.48l0.64,2.7l-2.48,1.85l-0.17,0.46l0.5,1.64l-3.04,1.15l-1.06,0.07l-0.82,-0.41l-0.78,-3.16l-1.63,-0.58l-1.23,0.58l-0.79,1.08l-0.38,1.89l0.49,1.65l0.97,0.66l1.71,0.48l-0.2,1.6l1.37,1.13l1.34,0.45l2.66,0.03l4.31,-0.88l4.2,1.33l1.49,0.83l0.31,1.14l-0.51,0.32l-3.48,-0.19l-1.3,0.34l-0.24,0.6l1.16,1.86l1.48,1.54l2.95,1.94l-1.03,0.32l-0.56,0.92l0.3,1.04l0.71,0.63l-1.12,-0.36l-3.17,-2.5l-3.15,-1.4l-1.36,-1.62l-1.78,-1.34l-1.64,0.36l-1.0,1.68l0.1,2.08l0.82,1.93l1.48,1.45l6.08,1.15l0.81,1.21l-0.62,0.07l-0.35,0.41l0.03,1.06l0.96,1.43l1.43,0.72l1.57,0.09l1.11,0.52l0.92,1.91l0.79,0.67l0.88,1.47l0.79,0.49l1.22,-0.53l0.18,-0.8l-0.26,-0.64l0.56,-2.13l1.04,0.41l2.84,3.4l1.33,1.03l0.63,-0.21l0.72,-2.45l0.65,0.31l0.18,2.75l0.84,1.49l1.18,0.95l1.43,0.33l-1.56,0.64l-0.77,-0.31l-1.68,-2.16l-1.06,-0.47l-4.88,2.78l-0.9,-1.64l-1.27,-0.44l-0.84,0.68l-0.01,1.11l1.32,0.47l1.21,1.8l1.01,0.68l1.92,-0.98l3.26,-0.08l0.79,2.67l-0.76,1.56l0.1,1.41l0.98,0.97l1.71,0.28l0.81,-0.52l0.95,-1.65l2.55,0.7l0.52,-0.48l-0.29,-1.06l0.27,0.0l0.61,0.42l0.44,0.88l0.07,1.3l-0.32,0.78l-1.64,0.17l-1.67,1.38l-1.74,0.78l-4.66,5.48l-5.43,4.32l-1.19,-0.86l-1.27,-1.73l-1.02,-0.91l-0.48,-0.04l-0.17,0.45l0.37,1.8l-0.37,1.78l0.78,1.43l-2.61,1.25l-0.98,0.08l-1.6,-0.76l-0.58,0.27l-8.61,9.35l-2.61,-0.61l-0.67,0.66l-1.71,3.23l-5.26,4.55l-1.31,2.21l0.76,2.12l-0.4,1.77l-2.85,4.57l-0.35,2.0l0.45,1.21l-0.66,0.46l-0.2,0.56l-0.3,3.25l-1.14,0.61l-1.03,1.22l-1.56,0.76l-1.13,1.6l-3.22,8.12l-3.09,2.04l-2.93,0.11l-0.93,0.73l-0.38,2.02l0.79,0.86l1.44,0.14l-1.73,2.62l-1.77,-2.59l-1.07,-0.77l-1.2,-0.15l-3.55,2.67l-0.35,1.59l-0.82,0.78l-0.37,-0.3l0.55,-1.1l-0.22,-1.16l-2.59,-2.44l-0.48,0.17l-3.21,5.35l-1.06,0.98l-1.79,-0.5l0.26,1.24l-0.37,2.08l0.5,2.89l-0.99,2.27l-0.69,0.85l-0.55,0.27l-0.96,-0.26l-0.54,-0.71l-0.07,-1.12l0.59,-1.66l-0.08,-1.17l-1.6,-2.75l-1.07,-0.54l-0.54,0.22l-0.63,1.66l0.1,6.55l-0.62,2.39l-0.46,0.12l-0.87,-0.61l-0.7,-1.07l-0.04,-0.96l1.33,-4.27l-0.15,-1.42l-0.69,-0.23l-1.39,1.5l-1.32,2.42l-0.69,2.67l0.35,2.06l-5.61,0.09l-2.18,0.87l-0.5,-0.36l-0.71,-1.47l-0.72,-0.52l-1.4,-0.18l-1.47,0.35l-1.29,0.71l-1.08,1.08l-0.69,1.57l0.13,1.42l0.74,1.45l-4.37,-1.49l-1.37,0.01l-0.95,0.77l-2.52,1.05l-0.6,0.6l-1.0,2.69l-7.49,5.21l-0.32,1.55l1.11,2.83l0.35,2.3l-1.71,0.55l-3.04,2.49l-0.61,0.19l-2.92,-1.31l-0.14,-3.42l-1.52,-0.91l0.3,-1.23l-0.21,-0.47l-0.85,-0.4l-1.97,-1.9l-3.48,-0.98l-2.19,-2.3l-1.61,-1.02l-2.08,0.09l-1.76,1.33l-0.01,0.63l1.61,1.08l1.41,0.41l-0.73,2.74l1.05,0.98l1.76,0.36l1.35,0.84l-2.12,0.93l-1.08,0.11l-0.55,0.61l0.7,1.36l2.72,2.89l0.08,1.66l-3.37,-1.96l-5.56,-5.18l-1.93,-0.77l-0.54,0.34l-0.02,1.11l1.65,3.12l-0.83,0.3l-2.13,-1.67l-7.51,-14.76l-8.62,-10.83l-2.22,-2.27l-1.6,-1.15l-3.62,-1.49l-0.15,-1.63l-0.76,-1.59l-1.64,-1.29l-1.69,-0.54l-3.87,-0.09l-1.44,-0.62l-1.57,-1.36l-1.43,-0.71l-3.22,-0.74l-3.42,-1.43l-6.22,-0.04l-1.38,-0.35l-3.93,-1.87l-0.97,-0.76l-5.01,-7.29l-0.19,-0.67l2.22,0.08l0.8,-0.38l0.5,-1.05l-0.2,-1.22l-0.8,-1.65l-2.79,-1.29l-4.65,-0.02l-43.01,10.12l-56.26,-7.62l-7.9,-4.01l-35.54,-28.16l-2.73,-1.37l-2.16,-0.69l-2.67,0.0l-4.69,1.17l-0.84,-0.63l-1.32,-2.19l-1.72,-4.23l-2.68,-2.7l-13.48,-8.03l-1.46,-1.93l-0.75,-2.36l-0.65,-4.43l-0.84,-1.35l-1.37,-1.3l-3.36,0.46l-1.46,3.0l-0.81,2.87l-1.79,0.45l-1.77,-4.72l-1.4,-1.69l-1.87,-1.56l-11.35,-7.11l-1.23,-1.45l-3.43,-2.55l0.3,-0.44l4.19,-1.56l0.52,-0.44l-0.22,-0.97l-2.93,-1.65l-4.83,-4.66l-2.95,-1.64l-2.85,-1.11l-4.55,-0.41l-1.49,-2.06l-1.34,-4.02l-0.96,-1.84l-1.44,-1.41l-1.38,-0.82l-2.62,-1.11l-3.45,-0.92l-1.86,-1.02l-7.11,-9.05l-5.02,-4.36l-25.32,-12.56l2.13,-10.89l0.94,-2.63l1.3,-1.59l5.51,-3.66l2.37,-3.58l0.27,-5.22l-0.54,-11.11l3.42,-26.35l0.62,-1.67l4.53,-7.2l0.86,-2.62l-0.31,-4.61l-6.98,-31.38l34.61,-3.14l29.19,-13.75l0.9,-1.87l-0.9,-6.93l25.65,8.66l43.19,22.65l26.13,7.86l40.23,28.15l21.07,11.04l27.27,8.49l1.38,2.15l3.25,3.35l3.59,2.49l3.85,1.62l7.18,1.45l4.19,3.27l2.49,0.97l9.56,0.3l1.12,0.36l2.99,3.91l3.84,3.1l11.38,3.69l3.81,3.75l7.12,1.4l3.78,2.05l1.81,1.59l0.76,1.82l0.52,3.34ZM701.97,477.32l-0.76,-0.03l-1.24,-1.28l-0.08,-1.5l1.44,0.86l0.61,1.07l0.04,0.88ZM692.3,498.41l0.65,0.33l0.45,-0.13l0.99,-0.82l1.08,0.91l0.31,0.76l-0.55,0.16l-3.62,-1.34l-0.66,-1.41l-0.13,-1.12l1.12,0.39l-0.06,1.53l0.4,0.73ZM682.61,594.47l-0.06,-0.25l0.23,-0.1l-0.02,0.24l-0.15,0.1ZM675.58,606.11l-0.84,0.48l-0.93,-0.05l-0.72,0.48l1.19,-5.51l0.47,-0.7l2.85,-2.1l0.17,0.9l-0.7,1.3l0.24,2.02l-0.24,1.21l-0.61,1.19l-0.88,0.78ZM672.01,597.74l1.03,-1.86l2.22,0.29l0.82,1.64l-1.87,1.26l-0.66,-1.15l-0.67,-0.3l-0.88,0.13ZM671.18,611.56l-0.56,0.03l0.05,-0.42l2.11,-2.14l-0.34,1.11l-1.26,1.43ZM665.52,616.45l0.82,0.25l0.68,-1.67l-0.25,1.52l-1.01,0.49l-0.37,-0.26l0.12,-0.33ZM653.14,596.97l0.31,-0.58l-0.12,0.5l-0.19,0.08ZM652.57,602.21l-0.01,-0.24l0.22,-0.17l0.19,0.54l-0.4,-0.13ZM632.45,610.65l0.02,0.01l0.01,0.03l-0.03,-0.04ZM606.63,629.21l0.07,0.37l-0.06,0.01l-0.09,-0.33l0.09,-0.05ZM605.73,622.27l-0.0,-0.08l0.02,0.05l-0.01,0.03ZM579.98,632.39l0.57,0.48l-0.36,-0.09l-0.21,-0.4ZM580.71,633.01l0.9,0.46l-0.17,0.33l-0.52,-0.24l-0.22,-0.55Z",name:"V\xe4sterbotten"},"SE-AB":{path:"M560.47,1050.72l-0.02,-0.04l0.02,-0.0l-0.0,0.04ZM557.18,1016.75l0.82,-0.5l0.99,-0.0l-1.09,1.56l-0.73,-1.06ZM558.26,1028.28l0.02,-0.44l0.56,0.12l-0.35,0.27l-0.24,0.05ZM556.86,1035.44l0.53,-0.3l0.1,0.14l-0.32,0.15l-0.31,0.02ZM555.04,1028.71l0.36,-0.0l0.14,0.26l-0.28,-0.18l-0.22,-0.08ZM555.47,1019.41l0.17,0.24l-0.65,0.26l-1.01,-0.32l-0.43,-0.55l1.92,0.36ZM552.55,1010.95l1.29,-2.29l1.03,-0.44l-0.05,1.0l-0.61,0.27l-1.17,1.42l-0.49,0.05ZM552.09,1016.43l-0.52,-0.12l-0.04,-0.4l0.48,-0.35l0.53,0.09l-0.45,0.77ZM449.5,1097.99l-1.81,-1.49l-2.34,-0.95l-3.12,-0.35l-4.49,0.07l-1.61,-0.44l-1.36,-2.1l-0.79,-2.1l-1.2,-7.88l-2.7,-5.21l-0.9,-4.6l0.65,-1.1l2.81,-2.33l0.39,-2.05l-0.1,-2.81l0.29,-2.17l0.76,-1.12l0.63,-0.67l0.8,-0.26l3.6,-0.34l1.3,-0.56l0.64,-1.38l0.04,-0.96l-0.68,-0.97l1.18,-2.07l0.8,-2.2l0.43,-0.58l2.58,-1.66l0.62,-0.98l0.48,-4.65l0.41,-1.0l3.27,-4.5l0.36,-1.05l-0.16,-1.17l-1.11,-1.18l-0.81,-1.57l0.17,-2.75l0.71,-1.14l0.29,-1.64l3.38,-1.38l2.65,-2.83l2.69,0.09l3.47,1.51l1.19,0.16l1.94,-0.77l4.16,-0.95l9.35,-4.3l5.65,-0.17l1.51,-1.08l2.92,-5.11l1.57,-1.53l2.15,-1.04l4.33,-0.88l4.7,-1.71l3.23,-1.76l1.59,-2.02l0.74,-2.3l-0.01,-4.36l0.37,-1.45l1.47,-1.39l3.03,-1.66l-0.13,-0.79l-2.1,-1.88l0.07,-0.75l0.75,-1.31l2.11,-2.13l3.0,-3.88l1.34,4.12l0.39,0.31l0.81,-0.3l0.45,-3.59l-0.25,-2.02l-0.49,-1.23l2.72,-0.69l1.59,0.24l2.26,1.72l2.41,0.53l0.83,0.96l0.3,1.5l-0.11,3.47l0.48,1.6l3.02,3.37l0.51,1.22l0.52,0.22l0.22,-0.52l-2.32,-5.19l-0.61,-2.52l0.79,-2.66l2.23,-0.94l0.64,0.29l0.06,3.45l0.36,1.41l2.98,7.6l2.39,4.77l1.56,1.52l2.94,0.75l2.6,1.47l0.21,1.52l1.64,1.59l1.02,-0.0l0.36,-0.5l-0.3,-1.49l1.38,0.4l-0.25,5.68l-1.7,-0.1l-0.77,-0.43l-4.87,-6.03l-2.23,-2.2l-2.22,-0.96l-0.45,0.1l-0.06,0.46l0.7,1.3l2.31,3.18l0.28,1.51l-0.69,1.48l-4.18,4.91l-1.12,0.69l-1.42,0.27l-2.94,-0.12l-1.62,0.28l-1.26,0.93l-0.47,1.65l0.39,0.49l1.23,-0.01l2.66,-1.03l17.02,-0.6l2.53,1.11l-0.6,1.87l-1.04,1.25l-1.37,0.71l-4.04,0.93l-1.13,-0.01l-0.9,-0.4l-1.86,-2.78l-0.65,0.1l-0.78,1.66l-1.37,1.24l-1.57,0.81l-5.14,1.21l-1.6,1.06l-0.29,1.41l-2.08,0.08l-0.6,0.31l-0.51,1.72l-1.06,1.14l0.39,0.3l2.53,0.17l-2.07,1.83l-1.63,-1.27l-1.1,-0.14l-0.35,0.63l1.65,2.67l-1.29,0.64l-1.6,1.37l-2.94,1.0l-3.8,2.81l-3.91,1.19l-1.84,1.31l-3.02,3.09l-2.17,1.41l-2.23,0.31l-5.13,-0.44l-0.43,0.4l0.2,1.03l1.79,1.06l-0.31,0.21l-1.84,-0.16l-1.23,0.59l2.27,1.56l-0.19,1.57l1.25,0.93l1.84,0.45l-0.88,0.5l-3.91,-0.09l-3.9,-0.95l-1.41,-1.05l0.88,-0.25l1.86,0.51l0.15,-0.42l-0.56,-3.0l-0.66,-0.81l-0.86,-0.12l-2.49,1.42l-1.2,-1.1l-0.5,-0.17l-0.72,0.27l-2.15,1.93l0.02,1.26l0.73,1.67l-1.79,0.91l-1.27,-0.02l-2.32,-1.13l-0.48,0.2l0.12,0.5l8.59,6.33l-1.43,0.25l-0.97,-0.22l-0.49,0.39l0.01,1.17l0.4,0.4l5.29,0.02l1.67,-0.75l0.36,0.08l0.42,1.1l0.79,0.26l2.6,-4.4l4.08,-1.25l4.74,0.63l3.31,1.31l-0.94,0.94l0.17,0.69l2.05,0.49l1.32,-0.32l0.84,-1.5l-2.12,-4.22l2.7,0.0l0.39,-0.3l-0.2,-0.45l-3.82,-2.3l-0.44,-1.05l3.25,0.18l1.67,0.58l1.61,1.12l0.68,2.18l4.24,1.88l-0.42,0.68l-3.61,-0.57l-0.42,0.3l0.22,0.47l1.54,0.69l4.38,1.4l0.79,1.4l-0.41,1.21l-1.08,0.57l-3.53,0.16l-3.16,0.83l-1.95,-0.94l-2.03,-0.47l-6.57,0.58l-1.37,-0.48l0.36,-1.76l-0.37,-0.51l-1.5,-0.01l-2.43,1.27l-1.05,0.98l0.09,0.64l1.55,1.09l1.03,1.59l-1.9,-0.02l-0.92,0.55l-0.15,0.46l0.43,1.26l4.19,1.96l1.61,0.39l1.75,1.0l1.56,1.46l0.23,0.43l-4.91,-3.11l-1.76,0.13l-0.35,0.39l0.16,1.54l1.21,0.81l2.33,0.47l0.75,1.74l0.64,0.82l0.52,0.1l-0.23,1.08l0.53,0.38l2.1,-0.57l0.03,1.62l-0.41,0.8l-0.35,0.2l-0.72,-0.45l-1.63,-0.24l-2.64,0.63l-2.46,1.05l-1.3,1.15l-0.09,0.48l1.62,0.15l0.53,0.69l-4.8,1.8l0.85,-0.54l0.02,-0.66l-0.51,-0.37l0.67,-0.62l0.0,-0.63l-0.37,-0.4l-2.27,0.11l-2.68,2.03l-2.17,0.19l-1.16,0.49l-2.03,3.05l-0.66,0.37l-3.5,-0.13l-0.4,0.5l0.3,1.35l-1.13,-0.41l-1.05,0.14l-0.75,0.64l-0.07,0.53l0.93,1.36l-2.69,3.46l-1.1,2.32l0.58,2.87l-0.55,1.16l-0.77,0.68l-1.06,0.42l-1.02,0.02l-0.79,-0.52l-0.6,0.22l-0.38,1.31l-0.11,3.48l-0.82,-0.98l-0.24,-0.99l0.41,-1.49l-0.83,-1.86l-0.92,-0.67l-1.32,0.23l-0.97,-0.5l-1.92,-2.51l-1.3,-0.76l-0.05,1.84l0.8,2.17l1.02,1.62l-1.12,2.06l0.55,-2.7l-0.24,-0.51l-2.05,-0.73l-0.14,-1.58l0.35,-2.2l-0.71,-2.03l0.0,-0.56l0.97,-1.57l0.35,-3.13l-0.29,-4.83l0.83,-2.25l0.01,-1.31l-1.26,-0.91l-1.08,0.42l-0.81,0.83l-0.45,1.25l-0.1,3.08l-0.31,1.29l-0.39,0.33l-2.6,-2.44l0.16,-1.19l1.33,-2.19l0.38,-1.64l-0.91,-2.32l-1.57,-1.65l-0.48,-0.04l-0.17,0.45l0.92,3.28l-1.6,2.44l-2.35,1.35l-0.23,0.48l0.61,2.05l-0.4,4.0l1.1,1.49l-1.41,4.51l-0.7,-0.15l-0.52,0.41ZM547.92,1037.33l1.36,-0.32l1.18,0.12l-1.09,0.6l-1.45,-0.4ZM547.62,1030.31l0.64,-0.68l0.57,0.55l-0.35,0.16l-0.86,-0.03ZM544.89,1012.85l-0.03,0.68l0.68,0.32l-0.01,0.36l-0.75,0.8l-1.88,0.22l-1.31,-0.53l-0.93,0.53l-2.02,0.12l-0.18,-0.4l0.71,-1.41l3.89,-5.26l1.0,0.48l1.03,1.65l-0.2,2.46ZM543.98,1031.85l-1.26,0.51l-1.67,-0.41l-0.58,0.22l-1.4,3.76l-1.08,0.38l-1.17,-0.42l-0.23,-0.82l0.54,-0.81l4.63,-4.32l0.74,-0.29l0.59,0.38l1.29,1.68l-0.42,0.13ZM542.79,1052.93l1.05,0.46l-1.45,1.48l-0.46,-1.53l0.86,-0.41ZM541.85,1056.73l-0.33,0.26l-0.85,-0.46l-1.3,-1.3l-0.02,-0.37l0.34,-0.32l0.62,0.03l0.84,0.61l0.61,0.85l0.09,0.7ZM540.63,1067.13l-1.13,-0.67l-0.08,-0.41l0.57,-0.05l0.67,0.76l-0.04,0.36ZM536.98,1062.37l0.56,-2.06l0.32,-0.48l0.54,0.28l-0.02,0.74l0.31,0.31l-0.81,0.92l-0.91,0.28ZM539.0,1059.88l0.3,-0.29l0.71,0.3l-0.51,-0.02l-0.5,0.01ZM539.29,1052.7l-0.88,0.92l-1.05,-0.11l-0.6,-1.21l0.7,-1.22l2.3,-0.67l0.57,0.82l-1.03,1.47ZM530.64,1036.85l1.55,-0.92l4.63,-4.33l3.41,-2.08l-4.38,4.41l-1.89,1.24l-0.29,0.63l-3.02,1.05ZM535.62,1028.01l2.03,-0.92l0.73,0.99l-0.63,0.27l-1.01,-0.52l-1.12,0.17ZM537.22,1063.98l0.08,-0.04l0.57,0.02l-0.05,0.04l-0.6,-0.02ZM536.36,1055.5l-0.38,0.22l-0.22,-0.42l0.24,-0.31l0.36,0.51ZM527.94,1047.68l2.32,-0.59l0.31,0.27l-2.63,0.33ZM531.48,1047.24l0.14,-0.25l1.94,-0.03l-0.01,0.02l-2.08,0.26ZM530.38,1068.64l-0.12,0.67l-0.4,0.03l-1.43,-0.73l-1.09,-0.18l0.09,-0.68l0.84,-1.13l1.2,-0.86l1.09,-0.29l1.65,0.35l0.15,0.48l-1.97,2.34ZM530.83,975.72l-0.08,0.57l0.47,0.22l0.67,-0.23l0.34,1.07l-2.72,0.92l-2.19,-0.47l-0.66,-2.42l0.28,-0.94l0.79,-0.53l0.0,-0.38l-0.97,-1.19l1.98,0.62l0.85,1.33l1.14,0.66l0.11,0.77ZM527.72,1074.8l-4.52,2.25l-0.08,-0.04l1.84,-2.64l0.69,-0.2l2.3,0.42l-0.23,0.21ZM525.14,1057.83l2.73,2.21l0.28,1.56l-0.32,0.99l-0.87,0.7l-2.96,1.16l0.72,-1.05l-0.22,-1.87l-0.53,-1.05l-2.24,-2.38l3.4,-0.27ZM515.32,1044.34l0.79,-1.21l2.18,-2.07l2.53,-1.04l1.37,-0.02l1.23,0.4l1.0,1.23l1.21,-0.11l-1.67,0.61l-1.76,1.49l-0.75,0.28l-0.6,0.53l-0.36,0.92l-1.78,-0.4l-0.91,1.16l0.7,1.92l-0.17,0.78l-0.63,0.05l-0.23,-0.7l-0.45,-0.27l-0.33,0.41l0.14,2.83l-1.02,0.38l-0.4,0.51l-0.82,-2.13l-1.15,-1.75l-0.54,-1.85l0.16,-0.48l1.22,-0.33l0.51,0.18l0.51,0.97l0.7,0.01l0.08,-0.84l1.1,-0.31l0.19,-0.58l-2.05,-0.62ZM521.95,1050.58l1.26,-1.14l2.54,-0.08l0.8,-0.5l0.72,0.12l-1.35,0.42l-0.32,0.4l0.13,0.38l-1.74,-0.21l-0.83,0.48l-1.23,0.13ZM521.28,1077.43l0.49,-0.81l0.2,-0.09l-0.36,0.66l-0.33,0.25ZM518.56,1086.69l-0.0,-0.69l0.42,-0.46l-0.21,1.06l-0.21,0.09ZM519.08,1071.95l0.06,-0.01l-0.0,0.03l-0.05,-0.02ZM513.2,1066.37l4.59,2.32l-3.23,-0.19l-1.49,-1.09l-0.64,0.34l0.25,2.56l1.29,0.79l2.05,-0.18l-0.93,0.97l-1.84,-0.24l-3.47,-2.31l-2.58,-0.65l-1.18,-2.03l-2.58,-1.3l5.62,0.07l4.12,0.95ZM517.31,1082.25l0.24,-0.25l0.14,0.06l-0.39,0.18ZM513.22,1089.7l0.51,0.07l0.07,1.07l-0.58,0.78l-0.34,-0.04l0.34,-1.89ZM502.07,1089.77l1.5,-0.88l0.29,-0.88l-0.35,-0.59l2.64,-1.4l2.43,-1.93l1.45,-0.43l0.49,2.56l-2.06,2.71l-1.49,0.94l-0.57,2.4l-0.83,1.23l-1.27,0.01l-0.92,0.38l-1.21,-0.76l-0.82,-1.39l1.1,-0.32l0.21,-0.51l-0.61,-1.14ZM502.94,1053.26l1.78,0.5l-1.34,0.1l0.23,0.63l2.37,0.58l-1.77,-0.07l-0.77,-0.36l-0.5,-1.38ZM506.24,1073.2l0.05,0.02l0.01,0.06l-0.07,-0.08ZM498.28,1102.06l-4.47,1.14l-1.5,0.85l-1.01,-0.32l0.09,-0.59l0.97,-1.38l3.31,-2.35l2.51,-0.3l3.38,-1.62l-0.13,0.56l-0.88,0.82l-3.23,1.32l-0.19,0.94l1.16,0.93ZM500.56,1052.15l-1.77,0.29l0.08,-1.16l0.47,-0.4l0.63,0.16l1.35,0.86l-0.76,0.25ZM493.71,1057.9l-2.13,-0.1l-0.38,0.25l1.13,1.59l-0.45,0.66l-1.27,0.27l-1.55,-0.21l-2.71,-1.51l-1.04,-2.28l0.76,-0.29l7.63,1.62ZM488.04,1104.06l1.17,-0.7l0.46,-1.81l2.01,-0.34l-3.05,2.72l-0.58,0.14ZM481.53,1098.6l0.51,-1.94l1.47,-1.06l0.17,-1.35l1.15,-1.12l1.5,0.16l3.08,-0.64l2.1,0.2l-1.79,0.62l-0.08,0.81l1.09,-0.05l-0.16,0.74l-0.85,-0.49l-1.01,0.36l-0.67,-0.66l-0.64,0.03l-0.19,0.43l0.28,2.6l-0.26,0.55l-0.66,0.31l-0.69,-0.19l-1.57,-1.18l-2.79,1.87ZM488.73,1089.61l0.59,0.51l-0.71,0.39l-0.68,-0.3l0.79,-0.6ZM484.73,1109.25l-0.31,-0.62l0.8,-1.08l1.73,-1.27l-0.39,1.69l-1.55,0.72l-0.28,0.56ZM478.57,1101.62l-0.36,-0.36l-0.65,-0.04l1.52,-2.39l0.21,1.92l-0.73,0.88ZM479.27,1098.53l0.0,-0.0l0.48,-0.5l-0.17,0.29l-0.31,0.21ZM464.08,1114.84l1.3,-1.01l0.15,-1.03l-0.46,-2.28l0.13,-0.44l0.68,-0.36l-0.24,-2.22l1.83,-2.01l0.22,0.95l-1.04,1.21l-0.66,1.61l0.36,0.61l1.57,0.47l0.4,1.07l0.07,2.32l-0.93,0.64l-0.13,0.67l-0.63,-0.28l-2.62,0.07ZM458.09,1110.34l0.2,0.17l-0.11,0.5l-0.15,-0.37l0.06,-0.31ZM453.97,1102.72l-0.46,-0.9l0.05,-1.77l-1.06,-1.45l0.16,-1.64l1.31,-2.84l-0.13,-5.18l0.59,-0.74l0.33,1.03l1.25,0.95l0.47,1.06l0.81,2.98l0.06,1.39l-0.47,1.65l0.26,2.18l-0.62,2.49l-0.79,0.57l-0.04,1.18l-1.0,-1.19l-0.71,0.25Z",name:"Stockholm"},"SE-":{path:"M117.39,1399.24l-0.38,0.12l-1.79,-2.07l1.54,0.13l1.05,0.7l0.1,0.42l-0.52,0.7Z",name:""}},height:1452.0211302823068,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","south_america_mill",{insets:[{width:900,top:0,height:905.8723093907364,bbox:[{y:-1391900.644539083,x:-12188330.527048683},{y:6974170.643481547,x:-3876492.223609794}],left:0}],paths:{PY:{path:"M617.96,397.13l0.51,1.91l1.38,1.97l0.3,2.45l1.0,1.01l-0.05,1.74l0.83,1.52l0.04,1.56l-0.79,2.14l0.2,0.71l-0.84,1.85l0.34,2.51l-0.39,1.88l0.17,0.76l-0.61,1.7l0.39,1.02l1.95,0.65l1.21,-0.52l1.83,1.03l2.79,0.41l1.23,-0.23l3.66,0.95l3.93,-0.58l1.27,-1.62l0.68,-0.25l2.31,2.35l4.74,0.56l0.93,1.05l0.07,1.18l0.56,1.17l0.98,0.9l-0.38,2.67l0.61,2.74l0.48,0.79l0.07,1.93l0.43,1.23l-0.23,2.16l0.98,1.51l0.19,2.21l0.44,1.29l0.79,0.59l2.22,0.34l2.64,-0.58l4.14,-2.0l1.99,1.02l1.98,1.6l-0.65,0.98l0.44,2.31l-0.37,2.72l-1.7,6.89l0.19,0.79l-2.08,4.0l-0.26,7.36l-0.54,3.86l-0.91,2.83l-0.75,1.36l-1.31,0.69l-0.41,0.81l-1.98,1.6l-0.15,0.58l-3.31,0.93l-0.92,1.42l-0.93,0.58l-0.44,0.95l0.04,0.94l-1.19,1.34l-0.63,0.01l-2.02,-1.17l-1.4,-0.23l-1.29,0.18l-1.17,0.72l-1.52,2.14l-0.42,0.11l-0.91,-0.8l-1.12,-0.26l-1.47,0.32l-0.9,-0.1l-0.93,-0.59l-1.23,-0.06l-1.71,0.44l-3.26,-0.5l-5.11,-1.49l-4.29,-0.56l-5.03,0.5l-0.32,-1.1l0.2,-0.59l0.84,-0.63l1.26,-2.01l1.43,-0.89l0.0,-0.67l0.66,-0.53l0.44,-1.29l0.59,-0.7l-0.14,-3.19l1.09,-2.51l2.55,-2.09l1.75,-4.11l2.13,-2.02l0.17,-1.15l-1.03,-1.97l-2.17,-2.5l-1.74,-1.19l-2.27,-0.98l-1.4,-0.3l-0.78,0.28l-0.42,-0.16l-0.74,-0.85l-1.17,-0.66l-2.51,-0.75l-5.54,-2.85l-8.55,-6.02l-2.63,-1.08l-1.95,0.03l-2.86,-0.63l-3.98,-1.33l-2.19,-1.23l-0.67,-1.28l-1.49,-1.27l-2.41,-1.31l-1.98,-1.74l-2.72,-1.73l-1.52,-1.52l-1.64,-2.37l-1.82,-3.31l-1.91,-2.2l-2.96,-1.82l-0.24,-0.59l4.43,-14.56l0.02,-6.33l4.27,-6.28l1.89,-5.0l20.85,-4.31l10.9,-0.14l10.79,6.54l0.38,1.99l-0.23,2.03Z",name:"Paraguay"},CO:{path:"M382.29,58.03l1.56,1.88l0.98,-0.25l2.33,-1.73l0.19,-1.72l1.79,-1.65l-1.04,-2.95l-0.78,-1.05l-0.8,-1.99l-0.67,-0.67l0.8,-1.35l0.99,1.69l1.67,1.23l1.6,1.76l0.66,1.21l0.85,0.55l-0.61,0.55l-0.15,0.73l0.42,0.74l0.73,0.4l1.24,-0.35l0.59,-1.11l-0.36,-3.74l-0.58,-1.95l-1.11,-1.22l2.52,-1.13l4.97,-3.58l1.8,-3.44l1.22,-1.13l1.32,-0.71l1.84,0.16l1.66,-0.66l0.45,-1.32l-0.86,-2.26l0.99,-3.06l-0.02,-1.6l0.61,-0.86l-0.23,-0.83l-0.47,-0.08l0.57,-0.7l0.72,-2.4l0.5,-0.9l1.92,-1.37l0.46,-0.73l3.88,-3.31l0.74,-0.51l4.13,1.29l-0.32,0.28l-0.23,1.24l0.86,1.06l1.13,0.18l0.71,-0.74l1.56,-3.51l0.25,-1.96l0.51,-0.5l0.81,-0.19l3.06,0.77l1.53,0.07l4.63,-0.37l7.08,-5.05l3.26,-1.08l2.13,-1.09l1.48,-2.23l0.37,-1.53l0.73,-0.46l1.16,-0.09l0.7,-0.9l2.26,-1.24l2.45,-0.14l2.61,1.11l1.18,1.92l0.17,1.15l-2.04,2.08l-0.88,0.44l-6.86,2.03l-3.47,5.68l-2.36,1.01l-2.99,3.45l-2.24,4.36l-1.65,8.53l-4.17,6.75l-0.05,0.91l0.7,0.41l1.73,-0.32l1.57,-0.75l1.08,1.47l1.73,0.21l1.53,5.67l3.03,3.09l0.28,1.03l0.37,2.2l-1.05,1.57l-0.28,5.55l0.35,0.84l0.7,0.64l2.22,0.57l1.42,3.15l1.16,0.98l1.59,0.53l3.22,-0.51l5.94,0.56l1.52,-0.12l3.19,-1.13l0.89,0.08l3.23,1.33l3.11,0.24l8.1,9.77l0.58,0.26l0.74,-0.25l1.13,0.56l1.03,-0.25l1.18,-0.78l1.68,-0.15l2.44,0.5l3.24,-0.0l4.0,-0.5l2.46,-0.54l0.98,-0.57l3.23,0.55l0.85,0.61l0.46,1.64l-0.34,0.94l-1.24,1.23l-0.71,1.63l-0.13,1.75l-0.56,1.19l-1.19,1.0l-0.44,1.27l0.23,1.82l-0.61,7.54l0.53,0.81l0.35,2.99l1.52,4.17l0.71,1.15l1.29,1.0l2.13,3.14l-0.36,0.75l-5.79,5.18l-0.45,0.76l0.03,0.74l0.56,0.35l0.98,-0.42l1.57,0.43l0.66,1.25l4.09,3.45l-0.07,1.32l1.17,2.57l-0.12,0.84l1.66,3.72l0.07,0.9l1.15,2.95l0.01,1.28l-1.7,0.4l0.02,-4.85l-0.37,-1.18l-2.84,-4.69l-0.9,-0.57l-0.84,-0.04l-1.3,0.64l-3.15,3.42l-1.23,0.42l-0.83,-0.34l-1.13,-1.95l-0.94,-0.54l-0.78,0.46l-0.53,1.5l0.58,1.21l-13.01,0.01l-2.73,-0.63l-3.63,0.78l-0.43,0.4l-0.04,7.83l0.53,0.38l0.58,-0.2l4.28,0.47l1.36,-0.17l0.52,0.34l1.04,1.68l0.07,2.24l-1.95,-0.23l-1.53,-0.92l-4.05,1.48l-2.91,0.34l-0.36,0.39l-0.16,8.83l0.4,0.81l1.46,1.46l3.45,2.29l0.41,1.31l-0.22,1.57l0.91,2.04l1.07,0.93l-0.03,0.91l0.57,1.24l-6.52,35.85l-2.02,-1.67l-0.8,-1.87l-1.34,-1.01l-2.43,0.56l-1.95,-0.86l7.71,-12.05l0.15,-0.77l-0.67,-0.91l-1.66,-0.57l-2.19,-1.44l-2.71,-1.02l-0.69,-0.74l-3.29,-1.68l-1.92,0.47l-1.09,0.84l-2.1,0.23l-1.96,-1.3l-2.57,-0.87l-0.78,0.26l-2.04,1.82l-0.94,0.05l-1.83,0.85l-2.05,0.32l-2.9,-0.91l-1.1,0.49l-2.39,0.05l-0.67,-0.68l-1.79,-0.66l-0.14,-0.55l0.53,-1.63l-0.9,-3.15l-0.53,-0.68l-1.58,-0.08l-1.53,-0.94l-0.23,-0.43l0.32,-1.31l-0.33,-1.05l-1.79,-2.55l-1.0,-0.53l-1.48,-0.19l-2.25,-1.97l-2.36,-0.75l-0.88,-1.2l-1.1,-3.4l-2.43,-2.59l-1.65,-0.86l-0.51,-1.08l-1.95,-0.35l-2.39,-1.67l-1.12,-0.11l-0.83,0.71l-1.87,-0.71l-1.81,-1.2l-2.0,-0.37l-1.13,-0.68l-2.27,-2.35l-2.6,-1.21l-0.77,-0.07l-1.02,0.6l-0.42,0.57l-0.11,1.15l-0.53,0.2l-2.73,-0.44l-0.54,0.36l-0.64,-0.06l-3.31,-1.25l-2.26,-0.1l-1.1,-0.36l-0.8,-2.85l-2.15,-1.04l-0.63,-1.31l-1.83,-0.07l-2.4,-0.85l-3.25,-1.74l-2.39,-1.83l-2.03,-1.02l-2.09,-2.02l-0.43,-0.89l-1.37,-1.0l0.6,-1.14l1.73,-1.01l2.43,0.84l0.53,-0.31l0.32,-1.81l-0.93,-1.77l0.38,-3.3l0.62,-0.73l1.16,-0.61l0.77,0.24l0.83,-0.56l1.92,0.24l0.84,-0.28l1.77,-1.55l0.54,-1.01l0.53,0.08l0.45,-0.32l1.74,-2.05l-0.35,-1.59l1.65,-0.61l1.61,-3.0l0.86,-0.36l0.37,-1.45l2.97,-5.29l-0.41,-0.58l-1.18,0.59l-0.58,-0.19l0.15,-1.51l-0.55,-0.6l-0.53,0.11l-0.61,0.87l-0.47,-0.79l0.23,-2.17l-0.57,-0.33l1.22,-1.33l0.81,-4.16l-0.63,-1.42l-0.41,-5.85l-0.46,-1.29l-1.22,-1.12l2.21,-1.49l0.95,-1.66l-1.15,-2.6l-1.47,-2.16l-0.02,-0.62l0.88,-0.37l0.46,-2.78l-0.16,-1.13l-0.85,-1.39l-1.15,-0.22l-3.27,-5.22l-1.04,-1.0l0.75,-2.21l0.65,-0.42l0.41,-0.84l-0.26,-1.77ZM377.29,119.74l-0.18,-0.14l-0.03,-0.35l0.19,0.19l0.03,0.3Z",name:"Colombia"},VE:{path:"M451.67,10.36l0.06,2.29l1.39,2.81l1.8,1.73l-0.62,0.51l0.49,1.94l1.11,1.39l0.04,0.63l-0.8,2.44l-3.51,4.12l-1.87,3.97l1.4,2.05l0.27,1.17l2.47,2.5l-0.19,1.07l0.57,1.54l0.81,0.86l0.95,0.32l1.12,-0.02l2.97,-0.98l0.82,-0.56l1.93,-2.47l0.4,-4.32l-0.36,-1.69l-2.29,-3.98l-1.44,-1.4l-1.54,-4.23l-0.28,-1.64l0.97,-0.9l-0.08,-1.21l2.22,-0.4l5.31,-2.53l3.32,-0.65l3.78,-1.36l2.02,-1.88l2.17,1.0l1.19,-0.57l0.4,-1.09l1.36,1.25l4.73,-0.46l2.15,0.69l2.65,0.35l5.0,3.19l1.34,3.16l-0.53,0.96l0.38,1.55l0.85,1.59l1.36,1.02l3.34,0.25l8.88,-1.19l1.76,-0.49l8.81,-0.26l1.44,0.59l0.26,1.24l2.88,2.62l2.52,0.45l2.03,0.84l4.45,1.1l3.53,-0.39l7.89,-4.33l4.17,0.11l1.46,-0.74l-0.07,-0.7l-1.58,-0.67l-3.12,-0.25l2.84,-0.27l4.51,0.25l3.78,-0.81l2.95,0.02l2.89,-0.51l5.49,0.61l3.11,-0.35l-2.98,0.35l-1.85,1.06l-3.74,-0.19l-2.65,0.38l-0.34,0.36l0.85,0.62l0.19,1.15l0.8,0.28l0.93,1.07l0.25,0.96l-0.89,1.93l0.42,0.22l1.28,-0.28l0.61,-0.56l0.15,-0.95l2.61,4.93l0.92,0.06l0.67,-0.75l0.66,0.39l0.49,-0.5l0.07,-1.45l0.36,0.08l1.86,1.18l0.76,0.95l0.16,0.71l1.52,1.36l0.32,-0.37l0.05,-0.87l-0.36,-0.99l1.26,-0.02l0.61,-0.77l3.03,2.97l3.58,0.95l2.35,2.07l-0.4,0.8l-1.42,0.53l-0.85,0.93l-1.22,3.83l-1.36,2.68l-4.25,0.03l-0.38,0.3l0.19,0.45l3.76,2.25l0.46,0.0l1.23,-0.87l1.95,-0.11l2.67,-1.15l3.78,0.54l1.8,-0.98l1.94,0.13l1.65,0.75l2.11,2.79l-1.52,0.97l-0.82,1.63l-1.68,0.71l-2.36,1.95l-1.73,0.27l-0.6,0.63l-0.63,1.46l-1.23,1.27l-0.07,0.98l1.25,1.92l-0.32,0.81l0.14,0.8l0.82,0.79l2.76,0.04l-0.25,1.24l-0.42,0.56l-3.74,2.04l-1.78,-0.2l-0.95,0.67l-2.64,0.61l-0.76,1.63l0.62,1.69l0.25,2.62l-3.06,3.2l0.19,0.9l7.65,8.53l0.82,0.46l0.73,1.86l-0.23,0.96l-1.25,1.3l-1.96,1.05l-1.21,1.85l-1.0,0.3l-2.38,-0.03l-0.98,0.94l-1.48,0.51l-0.83,1.27l-6.99,2.2l-3.19,-0.67l-2.41,1.37l-1.28,0.33l-0.57,1.26l-0.28,3.07l-0.88,0.76l-1.01,-0.0l-4.47,-4.19l-2.45,0.55l-1.55,-0.55l-4.26,0.14l-1.07,-1.54l-1.06,-0.83l-4.62,-0.17l-1.63,-1.56l-1.35,0.09l-0.33,1.0l1.81,2.68l5.29,4.98l0.04,4.53l2.2,4.98l0.32,1.43l-0.47,1.81l0.15,0.53l1.72,0.71l6.15,0.46l-0.11,1.78l-0.6,0.8l-1.36,0.24l-3.19,1.68l-2.09,0.6l-0.5,0.57l-0.92,3.32l-1.0,0.99l-1.08,0.81l-2.24,0.07l-2.88,2.35l-1.09,-0.01l-3.51,1.83l-1.96,2.15l-1.26,0.87l-1.23,1.95l-0.42,0.02l0.4,-1.64l-0.52,-1.0l-1.81,-0.9l-1.67,0.59l-2.95,1.81l-3.18,0.24l-6.2,-5.36l-0.09,-1.58l-1.14,-2.89l-0.1,-0.97l-1.66,-3.77l0.15,-0.68l-1.18,-2.59l0.18,-0.77l-0.28,-0.89l-4.27,-3.63l-0.63,-1.21l-1.95,-0.59l-0.86,0.26l6.02,-5.53l0.6,-1.29l-2.32,-3.65l-1.29,-1.0l-0.64,-1.04l-1.45,-3.99l-0.37,-3.08l-0.48,-0.67l0.62,-7.4l-0.24,-1.65l0.37,-1.06l1.15,-0.95l0.67,-1.49l0.13,-1.75l0.62,-1.36l1.27,-1.27l0.42,-1.16l-0.66,-2.33l-1.17,-0.81l-1.92,-0.52l-1.68,-0.07l-1.13,0.6l-2.38,0.52l-3.92,0.49l-3.13,-0.0l-2.5,-0.5l-1.84,0.17l-2.0,0.99l-1.1,-0.54l-0.83,0.22l-7.84,-9.65l-0.56,-0.3l-3.16,-0.25l-3.21,-1.33l-1.09,-0.11l-3.46,1.16l-1.32,0.09l-5.9,-0.56l-3.26,0.5l-1.21,-0.45l-0.82,-0.68l-1.44,-3.22l-2.44,-0.76l-0.72,-1.05l0.31,-5.13l1.07,-1.65l-0.4,-2.46l-0.43,-1.36l-2.93,-2.91l-1.55,-5.75l-0.89,-0.58l-1.19,0.02l-0.51,-1.1l-0.81,-0.44l-3.41,1.04l4.24,-6.94l1.67,-8.58l2.13,-4.13l2.81,-3.27l2.52,-1.15l2.87,-4.97ZM545.6,22.4l-0.48,0.2l-0.11,-0.2l0.47,0.01l0.12,-0.01ZM477.95,9.05l-1.38,-0.12l-3.1,0.53l-0.93,-2.76l0.89,-2.29l2.03,-0.82l0.87,0.63l0.89,1.27l0.73,3.57ZM451.82,10.18l0.36,-0.43l0.42,-0.11l-0.29,0.15l-0.5,0.39ZM457.21,8.44l0.52,-0.19l-0.25,0.13l-0.26,0.06ZM583.99,43.13l-0.26,0.09l-0.05,-0.57l1.3,-1.07l0.44,0.72l-1.43,0.84ZM543.68,17.62l0.28,-0.37l1.2,-0.33l1.08,0.82l-2.55,-0.13ZM546.28,17.77l1.28,0.14l0.62,-0.99l1.03,-0.91l0.16,0.14l0.33,1.34l-0.97,1.02l-1.39,0.03l-1.06,-0.78ZM531.54,18.25l0.57,0.0l0.46,0.27l-0.95,-0.22l-0.07,-0.05Z",name:"Venezuela"},CL:{path:"M517.81,894.4l-0.79,0.6l-0.46,-0.09l0.86,-0.87l0.51,0.17l-0.13,0.19ZM421.18,761.07l-2.03,-0.3l-1.45,-0.97l-2.2,-0.83l-0.44,-1.36l0.76,-1.63l-0.34,-0.57l-0.7,0.08l-1.47,1.3l-3.87,0.91l-1.03,0.73l-0.3,0.45l0.13,0.56l1.37,0.37l0.57,1.35l-0.32,0.68l-0.48,0.05l-1.49,-1.05l-0.77,-1.17l0.02,-0.86l0.53,-1.27l4.9,-3.62l2.05,-2.01l1.78,-1.11l0.08,-0.61l-1.69,-2.18l0.07,-1.51l3.28,-0.69l3.63,0.25l3.78,-1.12l0.91,-0.86l0.27,-0.74l-0.46,-2.78l0.79,-0.87l0.81,-0.17l1.1,0.44l-1.54,5.48l-1.13,1.55l0.35,1.85l-0.57,0.88l-3.56,1.23l-0.28,0.59l0.62,0.64l1.97,-0.11l1.65,-0.32l1.47,-1.03l1.2,-4.69l1.18,-0.37l0.27,0.4l-0.15,3.02l-1.2,4.5l-1.44,1.8l-0.25,0.78l0.06,0.58l0.43,0.36l1.46,-0.22l0.97,-1.09l1.32,-3.1l0.41,-4.74l0.46,-1.41l-0.17,-2.14l-1.88,-1.11l-0.21,-0.82l0.49,-1.81l2.11,-0.03l2.03,-1.48l1.21,-0.49l3.23,1.51l0.71,0.07l0.41,-0.46l-0.63,-1.13l-3.04,-2.07l-2.39,-0.3l0.38,-1.57l0.44,-1.61l3.33,-0.88l4.09,-2.77l0.88,-2.38l0.2,-2.34l-0.28,-0.42l-1.91,-0.59l-5.02,-3.18l0.42,-3.5l1.89,-0.74l0.87,-3.39l-1.23,-2.75l0.26,-1.68l1.55,-1.55l0.75,-2.29l1.19,-0.1l0.36,-0.38l-0.1,-1.98l-0.95,-1.54l-0.03,-1.83l0.76,-2.02l1.31,0.11l0.47,-0.71l-1.0,-1.42l-0.67,-1.77l1.28,-0.63l0.77,0.62l1.39,2.52l0.73,-0.07l0.22,-0.66l-1.03,-6.09l-0.51,-0.33l-1.42,0.4l-1.16,-0.19l-0.76,-0.9l0.79,-1.26l0.88,-0.73l1.98,-0.28l1.69,-1.12l0.67,-2.4l-0.55,-0.46l-0.5,0.21l-0.97,1.97l-1.14,0.53l-1.24,-0.38l-1.71,-1.69l-1.92,-0.46l-1.1,0.6l-1.87,2.85l-0.66,0.4l-3.21,0.22l-1.16,-0.32l-0.99,-0.33l0.39,-0.93l0.87,-0.68l0.01,-0.44l-0.36,-0.41l-0.95,-0.1l-1.04,-0.7l-1.79,-5.56l-0.2,-1.9l0.74,-1.44l1.64,-5.77l0.51,-2.94l0.87,-2.54l0.01,-1.61l2.1,-1.43l1.02,-1.12l1.94,-5.2l0.31,-2.9l-3.54,-10.18l-0.14,-1.9l0.81,-4.57l-0.68,-2.04l-1.7,-2.87l-0.03,-1.31l0.71,-1.78l-0.67,-1.8l0.56,-1.65l2.57,0.44l1.43,-0.32l0.79,-0.74l0.54,-1.66l0.63,-4.83l1.36,-0.77l1.6,-3.54l1.14,-5.58l2.26,-2.95l-0.34,-2.53l1.38,-1.84l1.38,-2.73l2.04,-2.14l0.49,-2.37l1.54,-4.22l0.77,-4.4l-0.12,-1.7l2.02,-4.56l2.04,-2.38l0.34,-1.8l-0.71,-1.4l-0.02,-1.86l-0.51,-2.37l1.7,-1.62l1.73,-4.25l-0.08,-1.75l0.47,-1.97l-1.1,-2.58l-0.16,-5.34l-1.63,-8.46l0.09,-2.38l-0.66,-4.75l0.45,-3.75l3.26,-2.6l1.03,-6.55l-0.14,-2.86l-0.39,-1.37l-1.53,-1.91l-0.38,-3.37l0.24,-0.73l1.31,-1.02l0.93,-1.39l0.53,-2.24l0.99,-1.8l0.38,-4.07l0.81,-3.21l0.38,-1.04l1.57,-1.94l0.33,-5.2l3.01,-11.05l-0.16,-1.5l0.32,-2.95l-0.93,-2.7l0.92,-2.9l1.7,-2.14l0.53,-1.81l0.07,-1.15l-1.54,-6.68l0.8,-6.51l0.0,-3.12l1.39,-4.07l-0.39,-0.78l-1.16,-0.66l-0.8,-1.28l-0.06,-1.27l0.35,-2.24l1.28,-0.35l0.8,-0.92l0.72,-1.61l0.87,-3.71l0.38,-4.64l1.7,-8.88l-0.01,-3.08l-1.31,-6.65l0.6,-6.19l-0.12,-6.61l-1.43,-5.53l-0.71,-5.45l-0.02,-2.92l-0.58,-2.84l2.15,-0.1l1.58,-0.56l1.71,-1.07l1.05,-1.4l0.53,-1.52l-0.57,-3.4l1.84,-0.52l1.55,-1.29l0.18,0.86l1.59,1.82l0.67,2.27l2.42,1.24l-0.54,1.06l0.63,1.71l1.55,8.66l1.39,1.64l4.58,3.84l-2.7,3.49l0.06,0.76l1.37,1.39l0.16,1.07l-0.35,0.72l-1.34,0.27l-0.66,0.6l0.3,1.93l0.44,0.84l-0.64,0.6l-0.13,0.91l0.33,0.72l2.88,1.88l-0.85,1.02l0.06,2.43l0.59,0.58l1.03,0.27l2.73,4.21l0.13,3.93l0.9,1.79l0.43,2.87l1.1,1.08l0.45,3.44l0.8,1.96l0.03,4.19l1.15,0.93l1.31,0.22l1.61,0.03l4.44,-0.85l1.92,1.96l-4.06,12.75l-10.62,4.51l-3.31,3.25l-0.66,1.51l0.01,1.51l0.42,0.79l0.74,0.43l0.43,1.46l0.45,0.51l-1.25,0.6l-0.58,1.04l-0.63,2.41l-0.08,1.02l1.07,3.27l1.13,5.09l-1.87,2.49l-0.24,1.73l1.34,2.79l1.95,2.61l0.0,1.02l-0.22,0.48l-2.13,0.68l-0.74,0.72l-1.3,-0.48l-1.76,0.68l-1.3,3.38l-0.74,0.69l-2.09,6.08l-0.88,0.62l-2.14,2.75l-0.79,0.32l-0.43,1.04l-1.62,1.82l-0.36,1.88l-0.59,1.15l-0.1,1.83l-0.98,4.01l-1.97,1.91l-0.45,1.09l1.17,6.05l-0.38,3.95l1.33,1.24l-1.15,2.19l-1.43,0.32l-0.48,-0.28l-0.54,0.14l-0.17,1.2l-2.21,6.04l0.43,1.59l-0.8,1.11l-1.02,-0.06l-0.7,0.73l-0.79,5.6l1.77,3.99l0.68,0.56l0.88,0.06l0.6,0.64l-0.27,0.6l-0.89,0.43l-0.1,0.69l0.53,2.48l0.78,0.71l0.31,1.47l0.71,0.66l-0.06,2.0l0.73,2.44l1.08,1.06l-0.81,1.74l0.11,2.49l1.11,1.24l0.84,0.08l0.71,-0.31l0.57,0.27l0.21,1.22l-0.99,2.68l-0.16,1.85l0.49,6.59l-1.6,0.48l-0.79,0.6l-0.56,1.68l-2.27,4.09l-1.25,5.6l-1.9,1.34l0.2,1.23l0.82,0.44l0.16,0.41l-0.05,1.17l0.45,0.88l0.42,3.31l-0.41,1.53l0.13,2.36l-0.47,0.73l-1.36,0.31l-1.85,1.82l-0.42,1.55l-1.61,0.26l-1.93,1.48l-0.41,0.99l0.05,0.89l-1.48,2.77l0.86,3.83l-0.95,2.47l0.74,2.23l-0.59,2.43l0.22,1.99l1.68,3.94l0.73,5.66l1.42,1.4l-0.51,1.61l-0.53,0.65l-1.61,0.29l-2.37,1.23l-1.52,1.36l-0.39,1.01l0.07,4.14l-1.39,4.21l-1.17,-0.16l-0.98,0.72l0.5,3.12l0.39,0.76l-0.23,1.72l-0.39,0.77l-0.74,0.1l-0.46,0.43l-0.32,1.12l0.35,1.18l1.1,1.06l-1.27,1.28l-1.51,3.54l-0.16,1.56l0.82,1.61l-0.22,7.08l0.24,2.36l-0.44,1.53l1.9,5.57l-0.09,0.53l-0.99,0.56l-0.76,0.21l-0.43,-0.35l-0.83,0.15l-1.13,1.62l-0.22,1.14l0.52,0.81l0.25,1.4l-1.06,1.69l0.36,2.84l-0.39,3.07l0.57,1.33l0.81,0.74l3.12,0.91l0.26,0.72l-0.11,0.56l-1.74,1.02l0.07,1.58l1.83,2.19l0.13,1.3l-0.59,0.61l-0.05,0.49l1.28,2.37l-1.55,2.63l-0.27,3.3l0.19,0.89l0.35,0.31l7.17,0.83l0.53,0.55l-0.08,0.69l-0.75,1.1l-0.42,1.74l-0.81,0.23l-1.26,-0.5l-5.97,0.61l-1.22,-0.28l-0.48,0.33l-0.09,0.89l0.7,1.53l5.17,1.06l1.78,2.71l1.01,0.89l0.04,1.16l-1.57,1.46l-0.28,1.06l-1.95,0.29l-0.97,1.0l-0.32,2.18l0.27,1.84l0.94,0.81l0.45,0.86l-0.5,1.04l-2.29,1.8l-0.03,0.5l1.31,2.28l0.74,4.81l-0.33,0.68l-2.57,2.1l-0.28,2.9l0.11,1.09l0.61,1.37l-1.46,0.58l-0.87,1.63l-2.88,2.26l-0.08,1.42l-2.1,4.61l0.08,1.66l1.34,0.93l0.86,1.31l0.38,1.65l-0.65,1.84l-1.67,0.79l-1.02,0.9l-0.41,0.82l0.23,2.39l-0.31,1.85l-1.23,1.43l-2.97,1.21l-0.76,0.67l-1.48,2.83l0.09,1.55l-3.52,0.18l-0.37,0.32l-0.25,1.21l-0.87,1.16l-0.27,1.86l1.25,3.35l-0.68,1.9l0.33,3.34l1.44,1.86l0.87,1.99l0.74,3.14l1.17,2.79l1.46,0.59l2.56,-1.67l2.76,-0.05l1.43,-0.63l1.1,0.34l0.52,0.62l0.73,3.43l-0.33,1.73l-0.64,0.52l-0.23,0.77l0.21,1.2l0.68,0.92l-0.01,1.01l-1.19,4.16l1.67,2.41l1.69,0.95l2.02,1.99l-0.0,1.56l0.85,0.47l23.55,0.3l5.63,2.04l3.47,0.02l5.87,1.91l2.84,0.53l0.04,0.2l-6.15,-1.37l-1.64,-0.85l-1.48,-0.07l-2.68,1.21l-1.96,3.01l-1.59,0.61l-1.8,0.15l-5.78,2.37l-2.14,0.23l-2.86,1.58l-0.7,2.2l0.19,1.27l-1.54,4.21l-0.41,2.48l0.43,3.31l-0.54,3.2l-0.87,0.63l-2.4,0.89l-4.63,-1.27l-2.09,-1.29l-3.6,-1.46l-2.34,-2.54l-0.37,-1.67l1.08,-1.33l4.07,-0.27l0.81,0.64l0.25,1.57l-0.81,1.43l0.08,0.8l0.57,0.24l1.21,-0.64l0.79,-4.22l3.92,-1.96l1.43,-1.26l1.42,-2.0l0.33,-1.31l-0.18,-0.39l-0.94,-0.61l-2.3,-0.72l-6.12,3.85l-2.82,1.04l-1.86,1.16l-2.23,2.07l-0.46,0.69l-0.63,2.4l-1.65,-0.51l-3.18,-2.06l-0.43,-0.51l1.56,-1.94l0.29,-3.92l1.77,-1.6l0.58,0.04l0.46,0.9l2.09,-0.05l4.17,-2.68l1.49,-0.06l2.3,0.59l2.63,-0.41l1.06,-0.99l-0.16,-0.63l-3.69,-1.13l-5.05,-0.27l-1.38,0.4l-1.23,1.19l-0.65,-0.93l-1.69,-0.5l-0.98,0.09l-0.99,0.78l-0.37,2.24l-1.58,1.18l-1.07,1.8l-0.07,2.14l-0.9,0.62l-2.33,-0.28l-2.01,-2.42l-1.0,-0.65l4.2,-1.87l2.13,-2.89l-0.0,-0.5l-0.61,-0.76l-1.03,-0.15l-0.4,0.42l0.06,1.06l-0.53,0.67l-1.72,-0.36l-2.31,1.39l-1.52,-0.36l-2.3,0.41l-0.94,-0.62l-0.19,-0.73l0.4,-1.18l-0.45,-1.78l-0.85,-0.67l-0.62,-0.01l-1.49,-3.58l5.13,2.0l1.66,-0.6l0.44,-1.81l1.49,1.11l3.29,0.07l1.62,-0.5l2.34,-1.34l1.61,-1.5l0.79,0.35l0.07,0.98l1.27,1.62l0.16,0.7l-0.11,0.66l-1.55,1.66l0.06,0.48l0.87,0.54l1.41,-0.88l0.68,-1.48l0.0,-1.51l-1.1,-2.27l-0.11,-1.11l1.06,-0.78l0.47,-0.84l0.03,-1.75l-0.72,-1.01l-2.64,-2.13l-4.82,-2.19l-0.99,0.71l0.07,0.59l4.91,2.19l2.28,1.79l-0.1,0.52l-3.84,0.97l-5.31,3.29l-1.32,-0.38l-1.5,-2.81l-1.35,-1.12l-0.91,-0.0l-1.21,-0.65l-0.77,0.35l-2.13,-1.26l1.06,-1.13l1.44,0.54l0.54,-0.34l0.41,-4.59l-0.57,-1.26l-2.37,-1.31l-2.61,-0.04l-5.69,-2.07l-2.77,-4.22l-0.32,-1.11l2.64,-0.04l2.1,-0.45l0.47,-1.08l-1.39,-2.21l1.16,-1.24l2.95,1.81l2.09,4.52l0.63,0.67l3.67,2.08l0.71,0.02l0.38,-0.45l-0.2,-1.52l0.92,-2.01l1.15,-0.58l0.45,-0.71l-0.88,-1.08l0.37,-0.98l-0.32,-0.54l-0.63,0.06l-0.94,0.92l-1.66,3.75l-0.65,0.44l-2.31,-3.05l0.1,-1.37l2.41,0.34l0.43,-0.25l-0.15,-0.48l-5.71,-2.55l-2.08,-2.13l3.1,-3.01l3.56,0.71l1.02,-0.49l0.14,-0.55l-0.63,-1.04l-1.07,0.08l-0.96,-0.53l-1.68,-1.78l0.35,-2.4l1.9,-0.61l2.68,1.03l0.67,-0.22l0.23,-0.56l-0.87,-1.53l-2.17,-1.28l0.83,-2.65l0.12,-2.34l0.92,-0.78l0.04,-0.39l-0.43,-0.43l-1.47,0.36l-0.56,2.48l-0.79,1.02l-0.84,3.42l-1.1,-1.04l-0.2,-9.35l0.47,-2.9l1.67,-1.35l1.39,0.12l0.82,-0.53l-0.1,-0.69l-1.96,-0.74l-2.28,0.95l-1.17,-0.33l-0.32,-1.48l-0.88,-1.27l-0.09,-3.66l3.65,0.67l4.67,-0.04l4.11,2.4l1.73,-0.32l0.32,-0.46l-0.31,-0.78l-1.21,-0.55l-1.24,-1.65l-1.24,-5.08l-0.47,-0.28l-0.68,0.36l-1.14,3.03l-0.99,0.83l-1.62,0.36l-1.62,0.21l-1.22,-0.31l-0.37,-1.75l-0.78,-0.53l-1.98,-0.56l-0.36,-0.55l1.14,-1.62l1.18,0.4l1.13,1.08l0.96,0.19l1.41,-0.88l0.35,-0.73l-0.19,-0.5l-2.26,-0.9l-1.6,-1.29l0.74,-1.21l2.85,-2.14l0.17,-0.49l-0.54,-1.37l0.6,-1.84l-0.75,-1.44l-1.48,-1.6l-2.08,-0.19l-0.46,0.65l0.09,1.01ZM510.37,893.33l-0.97,1.27l-1.7,0.73l-0.49,-0.23l-0.73,-1.45l-0.62,-0.23l-1.31,0.26l-2.05,1.11l-3.5,-0.62l-0.57,-0.61l-0.56,-1.81l-1.09,-1.08l1.69,-0.62l2.71,0.0l7.45,0.79l1.47,1.28l0.27,1.2ZM505.41,902.73l1.67,-1.52l1.07,2.27l-0.22,0.12l-2.52,-0.88ZM502.27,905.06l0.32,-0.07l2.45,0.16l-0.62,0.32l-2.15,-0.4ZM476.34,893.09l0.57,-1.17l0.37,-2.55l11.47,2.16l3.11,-1.0l2.05,0.03l0.42,0.83l-2.07,1.26l-0.27,1.07l0.59,0.5l2.35,0.22l0.85,0.75l-0.38,1.45l2.88,2.49l0.31,0.55l0.12,1.69l-1.5,-0.69l-0.72,-1.27l-0.71,-0.43l-3.28,-0.98l-3.12,-0.05l-0.53,-0.99l0.51,-1.73l-0.35,-0.75l-1.46,0.22l-2.11,-1.36l-1.37,-0.13l-0.4,0.25l-0.78,2.38l1.71,2.55l-1.78,-0.47l-1.18,-1.23l-1.47,-0.72l-0.27,-1.64l-0.55,-0.22l-1.56,0.27l-0.57,-0.89l-0.89,-0.4ZM485.33,852.61l1.5,0.19l3.38,-1.53l1.48,0.98l-0.27,35.73l-1.42,0.0l-0.65,0.41l-2.7,0.52l-4.73,-0.83l-2.72,-2.35l-0.53,-0.04l-3.54,1.65l-1.12,0.05l-1.72,-1.11l-2.71,0.93l-5.05,-1.55l-3.67,-0.34l-2.67,-1.25l-4.61,0.11l-0.59,-0.29l-0.11,-1.18l0.84,-0.28l0.4,-0.61l2.12,1.01l2.96,-1.68l2.26,0.88l1.14,-0.08l1.65,-0.58l0.68,-1.21l1.0,-0.14l0.85,0.26l-0.06,1.91l0.32,0.45l3.43,0.29l1.22,0.42l0.52,-0.29l0.04,-1.1l-2.99,-3.08l-1.27,-0.73l-1.32,-0.31l-1.1,-1.92l-0.04,-3.37l2.41,-0.91l0.23,-0.52l-0.53,-1.36l1.25,-1.16l0.95,3.93l0.59,1.21l-2.45,0.15l-0.35,0.59l1.14,2.16l2.0,0.89l1.44,1.43l0.23,1.34l1.09,0.58l2.22,0.03l1.49,-0.23l1.38,-0.98l1.29,0.86l3.01,1.16l0.56,2.06l0.51,0.28l0.89,-0.36l1.4,-1.56l1.03,-0.51l0.18,-0.67l-0.23,-0.37l-11.3,-4.9l-1.08,-1.49l-0.74,-1.91l0.02,-1.85l0.53,-0.49l8.91,-3.99l0.13,-1.39l-0.52,-0.9l-1.74,-0.7l-2.98,-0.08l-1.57,0.25l-2.52,1.07l-1.31,-0.06l-1.25,-0.53l-0.93,-1.07l-0.49,-1.48l0.18,-1.75l0.53,-0.81l2.31,-0.59l0.93,-1.2l-0.47,-0.86l-1.19,-0.72l-1.09,-1.31l1.56,-0.15l2.22,1.5l1.14,0.02l2.18,-1.55l3.08,-3.78l0.68,-0.06l2.85,2.82ZM458.81,889.3l0.04,-0.8l1.28,0.06l-0.34,0.09l-0.98,0.65ZM460.72,888.6l0.33,0.03l1.27,0.37l1.04,0.02l0.74,1.15l1.65,0.51l4.58,-0.94l1.4,2.27l-0.11,0.49l-1.77,0.89l-0.4,-0.13l-0.16,-0.7l-0.67,-0.66l-1.7,0.31l-2.48,-0.71l-0.56,-1.12l-3.17,-1.79ZM458.58,875.06l2.71,1.34l1.54,0.03l0.2,1.77l-1.23,1.74l-4.09,-2.32l-0.93,0.22l-2.48,-0.25l-0.87,0.82l-1.04,0.27l-0.32,-1.34l-2.67,-2.48l0.58,-1.36l1.6,-0.8l5.07,1.12l1.93,1.24ZM438.65,864.65l1.03,0.56l0.79,2.23l2.68,-0.15l2.32,0.47l2.9,3.18l-0.97,0.77l-0.8,1.95l-2.08,1.35l-1.35,0.09l-2.16,0.77l-0.61,-0.39l0.72,-0.36l1.21,-1.44l0.31,-1.69l-0.31,-0.45l-3.75,-0.34l-0.6,1.48l0.13,1.14l-1.08,-0.26l-0.95,-0.58l0.16,-2.27l-0.37,-1.33l-0.41,-0.2l-1.6,0.2l-1.15,-1.14l-0.69,-1.35l-1.99,-0.49l1.28,-1.3l2.55,-0.24l1.05,0.96l3.21,0.69l0.48,-0.46l-0.18,-0.99l0.25,-0.42ZM439.33,729.48l-2.73,1.11l-1.19,-0.32l-0.46,-0.71l-0.5,-1.71l1.87,-2.12l0.27,-1.98l2.3,0.57l2.16,1.05l0.67,0.63l0.08,0.3l-1.49,2.26l-0.98,0.92ZM419.21,853.86l2.7,1.87l0.72,1.21l3.81,0.62l3.46,1.49l1.44,0.21l1.26,0.9l1.17,0.32l3.01,2.72l-4.07,-0.81l-0.51,-1.2l-2.13,-1.78l-0.98,-0.45l-1.61,-0.37l-3.31,0.05l-3.27,-2.45l-0.7,-1.33l-0.99,-1.0ZM427.21,686.6l3.24,1.04l2.21,0.26l0.85,3.61l0.35,0.46l-0.13,0.83l-1.17,0.84l0.1,1.13l0.46,0.84l-2.58,1.0l-0.9,0.6l-0.13,0.52l1.47,1.82l1.25,0.84l1.43,2.3l-1.07,1.68l-2.38,1.18l-0.25,0.4l0.13,1.82l-0.3,0.56l-1.44,0.31l-2.32,-0.2l-2.93,-1.55l1.12,-2.0l0.98,-3.0l0.64,-4.2l-0.5,-1.69l0.34,-3.03l1.17,-2.29l0.64,-3.09l-0.28,-0.96ZM431.41,730.15l-1.49,-2.32l0.34,-0.97l0.45,-0.15l0.56,0.72l0.14,2.72ZM428.94,737.79l-2.39,-0.13l-0.1,-1.99l-1.2,-0.71l-1.78,-3.35l-2.95,-3.65l1.21,-0.69l0.2,-0.41l-0.21,-1.38l1.98,-0.93l1.14,0.42l0.96,-0.16l0.63,-0.49l0.26,-3.05l0.84,-0.54l0.79,-0.05l0.9,1.31l1.3,0.6l-0.33,1.3l-0.44,0.47l-2.38,0.87l-0.37,0.96l-0.07,0.79l1.53,2.24l0.99,3.12l0.08,1.32l0.72,1.35l-0.26,1.83l-0.65,0.11l-0.38,0.86ZM427.8,716.68l-1.72,-0.45l-0.06,-0.22l1.71,-0.05l1.27,-0.44l0.33,0.61l-0.8,-0.1l-0.73,0.66ZM422.28,837.67l0.49,0.19l2.74,2.06l-0.3,0.24l-1.75,-0.62l-0.88,-0.73l-0.3,-1.14ZM423.33,743.11l-0.65,0.64l-0.93,0.26l-1.03,-0.46l-1.22,0.14l-0.08,-0.6l2.3,-3.45l-0.04,-2.1l0.85,-1.09l0.75,-0.25l0.2,1.05l-0.35,2.73l1.02,2.25l-0.82,0.88ZM421.18,796.33l0.11,2.25l-0.66,5.2l0.08,0.57l0.67,0.5l-0.41,2.43l-0.99,2.09l-1.58,0.1l-0.47,-1.05l-0.16,-1.88l-0.67,-1.3l0.2,-1.1l0.62,-0.66l0.08,-1.29l1.01,-1.22l-0.39,-0.76l-0.5,0.04l-2.74,1.88l-0.41,1.25l-0.04,2.29l-0.6,1.25l-2.57,-0.07l-1.74,-1.16l-1.09,0.16l-0.15,-0.91l0.42,-0.83l1.96,0.09l0.41,-0.33l0.38,-2.1l-1.86,-2.16l1.36,-1.04l1.27,0.38l1.58,-0.35l0.31,-0.42l-0.09,-1.32l-1.31,-0.78l0.16,-0.5l2.77,-1.9l0.18,-1.38l-0.4,-1.13l0.82,-0.97l1.46,-0.33l1.08,0.6l1.11,0.15l0.8,5.73ZM417.08,836.08l0.53,2.87l0.6,0.57l1.09,0.2l1.17,1.4l-1.52,2.77l-0.33,1.71l-1.29,-0.09l-1.89,-3.53l-0.98,-3.74l0.82,-0.73l0.92,0.19l0.48,-0.37l0.05,-1.14l0.34,-0.1ZM420.19,829.96l-0.02,1.13l-0.3,0.28l-1.31,-0.42l-1.6,1.06l-2.12,-0.54l-0.48,0.17l-1.18,1.99l-1.08,1.09l1.53,-4.25l1.28,0.47l1.92,-0.62l1.74,-1.13l1.2,-0.01l0.43,0.77ZM420.06,787.59l-1.35,-0.18l-2.34,0.36l-0.88,-1.15l-0.46,-2.14l-1.95,-3.9l-0.34,-1.58l0.38,-0.52l2.56,-0.76l1.01,-1.22l0.23,0.05l-0.15,2.5l1.55,1.86l0.62,2.36l0.62,0.76l-0.08,1.15l0.58,2.42ZM418.79,712.15l-1.08,0.16l-0.14,-0.16l0.73,-0.31l0.49,0.3ZM414.38,813.99l-2.1,1.13l-0.73,-0.45l-1.15,0.0l1.18,-4.31l4.87,1.37l0.26,0.81l-1.27,0.55l-1.07,0.9ZM413.76,775.65l-0.43,0.1l-0.62,-0.81l1.54,-0.76l1.55,0.37l-2.04,1.1ZM414.42,731.21l-0.29,-0.22l-0.04,-0.55l0.22,0.22l0.1,0.54ZM413.58,791.47l-0.09,1.08l-1.69,2.26l-2.78,2.39l-0.89,-0.2l1.64,-1.82l-0.42,-1.3l-1.33,-0.92l0.13,-0.52l0.69,-0.51l0.61,0.14l2.33,-0.62l0.77,-0.49l0.94,-0.06l0.08,0.58ZM411.23,820.33l-0.25,1.09l-0.47,-0.06l-0.54,-1.41l0.6,-2.3l2.67,0.23l-1.89,1.17l-0.11,1.29ZM408.98,789.92l-0.87,0.01l-0.28,-2.31l1.59,-4.01l0.11,-1.51l-0.74,-2.09l1.62,-0.71l2.58,5.86l-0.03,2.8l-0.61,0.58l-2.43,0.75l-0.93,0.64ZM368.15,572.05l0.38,-0.32l0.5,0.2l-0.87,0.12ZM1.37,485.84l-0.92,0.2l0.24,-0.38l0.68,0.18Z",name:"Chile"},SR:{path:"M630.17,84.15l0.35,-0.04l1.45,-4.82l0.82,-0.52l5.91,0.65l2.74,0.63l3.38,1.03l0.43,0.99l0.44,0.23l0.32,-0.38l-0.12,-2.19l0.73,-0.62l2.0,-0.27l3.19,0.4l2.87,-0.49l3.73,0.06l5.71,0.94l3.37,1.1l0.06,2.07l-0.39,1.21l-0.86,1.63l-2.1,2.06l-1.49,2.14l-0.32,1.39l0.03,2.07l0.54,1.95l-0.27,1.27l0.61,3.33l0.66,0.91l-0.03,1.12l1.19,1.9l1.7,1.59l1.37,1.96l-0.2,1.55l-2.31,3.72l0.36,1.9l-0.28,1.97l-2.39,4.14l-0.91,0.49l-0.63,0.83l-1.15,0.19l-0.77,-1.36l-1.74,-0.06l-1.53,-1.83l-1.2,0.61l-1.43,0.03l-1.78,0.68l-0.62,0.59l-3.9,0.38l-2.9,-1.35l-0.63,0.39l-0.4,1.35l-1.23,1.03l-0.21,0.69l2.66,2.86l-0.36,1.71l-0.5,0.13l-5.12,-1.07l-1.35,-0.88l-1.53,-0.33l-2.61,-4.14l-2.1,-4.49l-1.17,-1.15l-0.33,-2.82l-0.58,-0.87l-0.35,-2.56l-1.82,-0.18l-1.43,0.27l-0.9,-0.38l-0.08,-1.49l-2.15,-1.87l-0.91,-2.15l-1.48,-1.73l-0.24,-1.06l-0.0,-0.68l1.22,-2.08l1.28,-3.91l-0.81,-1.91l0.64,-0.92l1.59,-0.82l4.71,-0.47l0.36,-1.17l1.19,-1.16l-0.16,-0.71l-0.8,-0.35l-0.28,-0.65l1.21,-2.21Z",name:"Suriname"},BO:{path:"M481.86,363.93l-0.21,-1.65l-1.26,-1.21l0.02,-0.65l2.3,-1.5l2.8,-3.83l2.14,-1.55l0.02,-0.91l1.11,0.37l0.77,-0.25l0.19,-0.99l-0.51,-0.9l1.73,-0.47l0.58,-0.69l1.21,-0.3l0.26,-0.47l-0.32,-1.04l-2.78,-0.6l-0.49,-0.84l1.01,-1.29l-0.11,-0.53l-0.63,-0.37l-1.83,-0.26l-0.33,-1.39l-3.24,-2.34l-0.58,-1.06l2.22,-3.47l-2.41,-3.34l0.15,-1.72l1.02,-0.74l0.47,-1.71l2.61,-2.67l0.2,-1.48l1.26,-0.63l0.35,-0.61l-2.38,-6.1l1.04,-2.26l0.06,-7.46l1.18,-1.34l1.33,-0.85l0.11,-1.16l0.88,-1.61l-10.45,-18.37l3.51,0.07l4.51,0.67l1.37,1.31l1.63,-0.14l3.87,-1.71l2.83,-3.26l0.83,-0.3l3.51,-0.07l1.61,-2.08l1.92,-1.36l3.68,-1.48l4.62,-3.59l1.77,-0.87l3.72,-0.89l4.04,-0.49l2.49,-0.2l0.99,0.48l0.95,-0.14l0.97,-0.85l0.72,-0.19l0.84,1.57l-0.16,1.89l0.31,1.46l-0.15,1.15l-1.43,2.29l-0.19,0.88l0.1,1.14l1.27,3.72l0.11,1.43l-0.82,1.92l0.03,0.89l0.63,1.05l0.24,1.47l1.7,2.39l-0.1,1.25l0.44,0.48l0.86,-0.25l1.28,2.87l1.94,0.67l2.56,2.08l1.11,0.55l1.33,2.4l5.84,1.11l1.96,-0.72l1.04,0.09l4.11,2.47l1.17,0.34l1.1,-0.52l0.89,-0.03l0.72,1.68l3.03,2.37l1.08,0.03l4.06,1.69l2.55,0.23l0.32,0.99l1.84,2.04l1.92,1.5l3.64,0.25l5.13,-0.61l6.65,3.58l1.09,2.5l-0.82,2.12l0.27,1.16l0.71,0.79l0.67,2.82l0.47,0.65l0.28,5.26l-3.33,0.11l-0.36,0.27l4.1,5.0l0.79,9.64l0.38,0.37l19.75,0.73l1.97,-0.5l-0.1,1.98l-1.37,1.87l-0.16,0.81l0.99,6.73l0.78,0.89l4.27,2.85l1.18,0.31l0.8,-0.18l0.43,1.68l2.34,5.61l0.68,1.01l-0.54,0.67l-2.52,7.93l0.63,0.53l0.1,0.87l-0.91,0.62l-3.99,8.31l0.09,0.47l3.01,2.72l-1.73,0.63l-0.82,1.1l-0.15,-3.41l-0.43,-0.75l-11.19,-6.72l-11.14,0.15l-21.08,4.35l-2.23,5.36l-4.3,6.32l-0.08,6.51l-4.26,14.13l-0.68,-0.53l-1.41,-2.18l-10.12,0.08l-0.61,0.29l-1.77,-0.23l-1.61,1.02l-3.5,6.73l-0.46,2.17l-1.91,-5.07l-1.19,-2.03l-4.8,-1.55l-9.25,-0.11l-3.98,-3.34l-1.59,-0.44l-0.74,0.64l-1.29,3.36l-4.25,1.41l-1.05,2.39l-2.8,1.82l-0.35,1.35l-1.55,1.99l-4.43,0.85l-1.48,-0.03l-0.91,-0.11l-0.84,-0.59l0.02,-3.95l-0.82,-2.06l-0.48,-3.53l-1.09,-1.06l-0.4,-2.73l-0.9,-1.77l-0.19,-4.12l-2.87,-4.43l-1.45,-0.57l-0.05,-1.9l0.83,-0.91l0.04,-0.69l-3.11,-2.12l-0.12,-0.34l0.82,-1.46l-0.77,-2.37l1.56,-0.39l0.8,-1.36l-0.24,-1.54l-1.39,-1.46l2.68,-3.41l0.02,-0.7l-4.8,-4.15l-1.19,-1.38l-1.5,-8.5l-0.6,-1.61l0.58,-1.29l-2.69,-1.51l-0.59,-2.16l-1.57,-1.8l-0.17,-1.28ZM486.75,346.77l0.46,0.22l0.77,0.76l-1.43,-0.14l0.2,-0.84Z",name:"Bolivia"},EC:{path:"M351.85,191.66l1.45,-0.54l2.45,-2.11l2.84,-7.02l-0.16,-1.37l-0.93,-1.61l-0.24,-3.45l-0.73,-0.13l-0.62,0.94l0.09,3.51l-0.46,1.28l-0.51,0.17l0.25,-2.18l-0.2,-0.4l-0.44,0.04l-0.66,0.57l-0.86,1.59l-1.41,1.18l-0.32,0.73l-1.61,-0.8l-2.8,-2.73l-1.94,-0.65l-1.01,-0.87l-0.22,-0.49l2.26,-1.55l0.12,-1.71l-0.06,-1.52l-0.83,-2.2l0.39,-3.03l-1.17,-3.56l0.56,-0.96l2.49,-0.87l0.95,-0.67l1.14,-2.98l1.0,0.37l0.92,-0.06l0.37,-0.34l-0.26,-0.43l-1.09,-0.39l-1.02,-2.17l1.78,-2.24l2.28,-1.95l1.12,-2.03l0.3,-3.34l-0.73,-4.29l0.4,-0.38l1.61,-0.33l1.92,-1.38l1.59,0.04l1.72,-1.04l6.8,-1.76l1.07,-1.21l-0.1,-1.21l1.36,1.47l2.02,1.0l4.03,2.8l4.28,1.74l1.43,-0.1l0.65,1.28l2.05,0.92l0.52,2.44l0.59,0.67l1.33,0.42l2.12,0.08l3.42,1.27l0.96,0.06l0.59,-0.33l2.57,0.42l1.22,-0.63l0.33,-1.5l1.04,-0.35l2.36,1.09l2.19,2.28l1.32,0.81l1.98,0.36l3.17,1.71l-1.28,0.15l-1.85,-0.4l-0.39,0.33l0.12,0.83l1.57,1.0l0.77,1.85l1.95,1.98l-0.28,1.41l0.37,2.77l-0.61,-0.0l-0.67,-0.46l-0.58,0.22l-1.94,7.25l-6.17,7.17l-7.02,5.12l-14.19,5.04l-1.12,0.92l-2.95,3.66l-0.2,0.76l0.39,0.66l-0.22,0.09l-0.77,-1.05l-1.0,-0.0l-0.87,2.64l-0.28,2.18l-1.56,2.57l-1.54,4.05l-0.1,0.81l0.37,0.91l-0.32,1.01l-2.62,1.84l-0.31,0.83l0.1,0.87l-0.66,0.3l-0.63,1.05l-3.05,-0.51l-1.42,-1.84l-0.86,-2.87l-1.45,-1.0l-2.06,0.17l-4.33,-2.15l-0.89,0.3l-1.11,1.23l-0.93,0.48l-0.72,-0.26l1.5,-2.18l-0.31,-0.63l-1.26,-0.29l-0.07,-1.44l0.36,-0.21l1.55,0.28l1.86,-1.75l-0.53,-1.83l0.08,-1.57l-0.86,-2.63ZM367.75,135.25l-0.11,-0.03l0.13,-0.1l-0.01,0.13ZM353.01,186.43l-0.93,0.17l0.51,-2.41l1.47,-0.87l1.33,0.35l-0.78,0.7l-0.97,0.33l-0.64,1.74ZM239.56,161.54l2.01,-1.78l1.29,-0.3l-1.73,1.91l-1.15,0.4l-0.42,-0.23ZM230.19,159.62l-1.94,-0.96l0.08,-0.76l0.56,-0.58l2.12,-0.35l0.7,0.5l-0.07,1.02l-0.66,0.81l-0.8,0.31ZM229.08,166.48l-0.46,-0.21l0.18,-0.33l0.5,0.31l-0.21,0.23ZM227.12,154.48l-0.32,0.21l-2.0,-0.37l-0.4,-0.39l0.64,-0.84l1.09,0.28l1.08,0.84l-0.1,0.27ZM215.69,150.78l0.98,-0.97l1.2,-0.19l1.54,1.76l0.5,2.31l2.33,2.26l0.2,2.12l1.8,1.75l-1.07,1.91l-2.51,0.88l-2.75,-0.03l-1.06,-0.9l-0.09,-0.51l0.33,-0.54l1.4,-1.05l2.24,-0.99l0.5,-1.0l-0.96,-1.14l-0.73,-1.56l-1.32,-0.95l-0.69,-3.03l-0.75,-0.45l-1.09,0.32ZM214.83,154.5l1.78,-0.28l0.48,0.53l-0.01,0.91l-1.08,0.4l-0.8,-0.32l-0.38,-1.24Z",name:"Ecuador"},AR:{path:"M473.96,528.95l0.46,0.15l2.01,-0.59l1.39,-2.75l-0.23,-0.72l-1.1,-0.6l0.35,-3.93l-1.18,-5.81l0.31,-0.8l2.07,-2.06l1.02,-4.17l0.11,-1.86l0.57,-1.07l0.35,-1.83l1.49,-1.59l0.45,-1.02l0.64,-0.19l2.22,-2.83l1.05,-0.85l2.06,-6.05l0.72,-0.66l1.12,-3.14l1.2,-0.48l0.86,0.54l0.72,-0.11l0.82,-0.75l2.23,-0.72l0.55,-0.92l-0.04,-1.64l-2.0,-2.68l-1.22,-2.41l0.17,-1.34l1.97,-2.76l-1.17,-5.37l-1.06,-3.23l0.09,-0.73l1.02,-3.03l1.2,-0.52l0.28,-0.62l-0.98,-2.35l-1.14,-1.13l0.0,-0.97l0.57,-1.31l3.05,-3.0l10.9,-4.77l4.19,-13.16l-2.11,-2.45l1.48,-1.86l0.32,-1.31l2.81,-1.83l0.94,-2.25l4.28,-1.44l1.58,-3.75l1.06,0.33l4.14,3.41l9.37,0.13l4.45,1.42l3.34,7.52l0.68,-0.05l0.74,-2.9l3.44,-6.6l0.54,-0.46l0.95,-0.24l1.32,0.27l0.61,-0.3l9.74,-0.09l1.03,1.86l1.02,0.82l0.51,0.95l3.04,1.88l1.84,2.11l3.5,5.73l3.04,2.7l1.89,1.08l0.22,0.5l3.58,2.1l1.4,1.19l0.75,1.36l2.4,1.34l4.03,1.35l2.97,0.65l1.85,-0.05l2.51,1.03l8.51,6.0l5.59,2.87l2.49,0.74l1.88,1.5l2.78,0.24l3.65,1.96l2.73,3.33l0.17,1.32l-2.12,1.99l-1.73,4.07l-2.27,1.67l-1.21,2.2l-0.31,1.14l0.16,3.0l-0.54,0.62l-0.12,0.78l-0.83,0.78l-0.17,0.89l-1.2,0.66l-1.34,2.09l-0.95,0.79l-0.28,1.07l0.45,1.54l0.42,0.29l5.22,-0.53l4.22,0.55l5.05,1.47l3.42,0.53l1.77,-0.44l1.05,0.05l0.9,0.58l1.08,0.12l1.4,-0.32l0.92,0.21l1.19,0.88l1.05,-0.4l0.7,-1.25l1.58,-1.38l2.31,0.06l2.07,1.19l1.14,-0.1l1.1,-0.88l0.76,-2.58l0.82,-0.47l0.87,-1.35l3.35,-0.94l0.3,-0.78l1.92,-1.53l0.38,-0.77l1.34,-0.71l0.88,-1.61l0.95,-2.96l0.56,-3.95l0.18,-5.15l1.57,0.61l3.51,-1.28l0.68,0.52l0.92,0.15l0.59,0.76l0.76,0.34l0.79,3.64l1.78,3.33l0.02,0.61l-0.51,0.9l-0.51,5.12l0.42,1.72l-1.35,2.85l-3.01,1.84l-0.78,-0.14l-1.97,2.14l-2.74,0.4l-1.41,0.97l-1.88,0.28l-0.78,0.84l-0.43,1.4l-1.48,0.69l-0.64,1.2l-1.73,0.44l-1.24,0.74l-1.56,1.73l-3.02,1.52l-0.41,0.87l0.8,1.42l-1.74,-0.39l-0.79,0.44l-0.2,0.99l-0.87,0.46l-0.66,1.28l-2.26,1.99l-1.22,1.59l-0.83,1.85l-0.91,1.14l-1.07,0.56l-0.89,0.94l-0.49,1.19l-3.15,3.95l-1.76,1.55l-1.69,0.93l-0.92,0.98l-0.28,1.19l-0.96,1.13l-1.88,1.37l-1.05,1.21l-0.15,1.03l-2.07,2.5l-0.58,1.4l0.63,1.84l0.09,1.8l-1.04,1.5l0.33,0.94l-0.26,1.96l-1.64,2.86l-0.3,1.17l0.77,1.71l-0.6,1.84l-1.37,1.24l-0.42,0.89l0.32,1.06l-0.05,2.63l0.53,0.9l-1.2,4.04l0.57,5.32l-0.77,1.29l-1.56,0.0l-0.71,0.77l-1.48,7.43l0.2,1.36l1.47,4.18l0.18,1.62l-0.36,0.56l-1.07,0.61l-0.14,0.44l0.75,2.26l2.24,3.13l6.39,2.98l2.56,1.67l2.88,2.27l1.51,2.24l0.12,1.7l-2.34,3.03l-0.26,2.47l0.5,1.89l0.96,1.8l2.38,2.17l1.86,0.81l2.04,-0.08l0.44,0.8l0.35,4.18l-0.04,1.5l-0.62,1.38l-4.32,6.74l-3.74,4.2l-1.34,2.3l-0.5,2.47l-1.07,1.05l-6.36,3.69l-9.93,3.32l-9.89,2.31l-15.4,2.17l-3.23,-0.17l-2.65,0.25l-5.41,-1.08l-1.39,-1.41l-2.0,-0.3l-0.86,0.93l0.78,2.17l-0.37,2.39l0.52,1.31l2.39,1.35l-0.65,0.04l-0.29,0.65l1.14,1.1l-0.61,4.69l-1.86,1.06l-1.43,4.43l-0.29,2.43l0.44,1.56l1.69,2.93l-0.58,1.74l-1.0,0.98l-6.7,3.09l-2.98,0.6l-4.88,0.1l-1.73,-0.13l-7.32,-3.25l-5.0,-1.43l-0.08,-0.95l-0.88,-0.32l-0.82,-0.01l-1.84,1.06l-0.9,1.19l-0.33,3.53l1.65,6.64l0.13,2.48l-0.62,3.2l0.91,2.16l1.29,1.08l3.25,1.4l1.05,-0.01l-0.58,0.82l-0.04,1.13l0.34,0.38l1.82,0.26l3.99,-0.57l0.71,-0.75l0.1,-1.51l-0.36,-0.4l-1.24,-0.12l4.3,-1.27l1.11,0.91l0.61,1.26l0.39,1.71l-0.25,4.05l-0.77,1.36l-3.88,1.04l-0.91,-0.23l-0.94,-1.35l-0.41,-1.69l-0.92,-1.08l-2.33,-0.99l-1.96,0.26l-2.07,1.51l-2.09,0.67l-0.68,1.35l0.19,0.54l4.86,2.21l3.18,0.66l-0.89,0.79l-3.35,1.1l-1.64,0.86l-1.82,1.6l-3.26,4.16l-0.41,0.97l-0.25,2.32l0.77,3.84l-0.81,1.79l0.49,1.69l-1.06,2.66l-3.52,2.87l-0.61,2.0l1.17,1.45l-0.33,1.41l-6.58,-0.59l-1.94,1.05l-2.77,2.17l-3.52,0.65l-0.85,0.5l-3.91,4.88l-4.18,7.24l-0.14,1.85l0.28,1.65l1.05,2.81l1.48,1.71l7.35,6.86l1.76,0.71l7.78,0.73l1.59,0.87l0.93,1.39l0.33,1.21l-0.43,3.28l-0.42,0.96l-2.56,2.08l-2.17,0.65l-0.12,0.7l0.91,0.55l2.79,-0.45l0.6,0.29l0.41,0.85l-0.86,0.38l-1.39,1.74l-4.48,3.93l-7.74,4.44l-5.32,5.15l-2.69,4.75l-0.11,0.89l0.36,0.73l-1.43,7.88l-0.45,0.84l-0.98,0.95l-2.69,1.62l-1.13,0.18l-1.61,-0.88l-0.93,-0.94l-2.16,-3.52l-0.43,-0.17l-0.36,0.99l0.39,1.16l-0.19,0.77l-2.77,0.48l-0.96,0.6l-0.15,0.47l0.41,0.27l2.68,-0.24l1.75,0.32l0.66,0.35l1.1,1.56l-3.63,1.63l-2.35,1.64l-1.41,2.02l-0.57,1.39l-0.78,4.41l-2.45,2.86l0.68,0.51l1.37,-0.7l1.48,4.57l0.36,2.8l-0.19,0.64l-3.33,0.16l-1.39,0.42l-0.09,0.72l0.94,0.47l1.02,-0.13l1.48,0.91l1.89,-0.33l0.64,0.52l3.27,5.36l2.93,3.8l-2.82,-0.52l-5.89,-1.92l-3.46,-0.02l-5.75,-2.06l-23.82,-0.5l0.07,-1.42l-2.24,-2.22l-1.59,-0.86l-1.49,-2.15l1.2,-3.82l0.02,-1.21l-0.72,-1.02l-0.18,-0.99l0.82,-0.95l0.37,-1.96l-0.78,-3.81l-0.86,-1.01l-1.53,-0.46l-1.45,0.63l-2.26,-0.13l-3.28,1.88l-0.47,-0.19l-1.15,-2.68l-0.74,-3.15l-0.9,-2.07l-1.36,-1.66l-0.32,-3.17l0.68,-1.98l-1.25,-3.28l0.23,-1.63l0.78,-0.95l0.29,-1.18l3.63,-0.19l0.38,-0.44l-0.15,-1.65l1.3,-2.52l0.52,-0.49l3.11,-1.3l1.45,-1.7l0.4,-2.2l-0.26,-2.18l1.14,-1.3l1.89,-1.0l0.74,-2.11l-0.47,-2.19l-0.96,-1.45l-1.17,-0.68l-0.08,-1.18l2.08,-4.55l-0.0,-1.23l2.75,-2.14l0.81,-1.58l1.74,-0.87l0.05,-0.87l-0.66,-1.04l-0.09,-0.95l0.25,-2.56l2.39,-1.85l0.54,-1.11l0.05,-1.2l-0.82,-3.96l-1.24,-2.26l2.0,-1.48l0.79,-1.5l-0.59,-1.49l-0.84,-0.64l-0.23,-1.49l0.29,-2.0l0.45,-0.47l2.1,-0.31l0.33,-0.32l0.19,-0.99l1.61,-1.49l0.07,-1.82l-1.18,-1.19l-2.03,-2.93l-5.17,-1.09l-0.24,-1.12l1.0,0.2l5.95,-0.6l1.34,0.5l1.17,-0.33l0.74,-2.18l0.77,-1.17l-0.0,-1.3l-0.96,-0.9l-7.07,-0.84l0.17,-3.57l1.56,-2.91l-1.25,-2.39l0.59,-0.74l-0.17,-1.81l-1.85,-2.23l0.0,-0.95l1.51,-0.72l0.33,-1.32l-0.66,-1.29l-3.17,-0.91l-0.9,-1.35l0.38,-3.09l-0.34,-2.79l1.06,-1.66l-0.3,-1.67l-0.52,-0.87l1.04,-1.82l0.81,0.36l1.09,-0.32l1.2,-0.67l0.33,-1.08l-1.15,-4.16l-0.76,-1.67l0.46,-1.3l-0.25,-2.38l0.23,-7.15l-0.81,-1.6l0.09,-1.19l1.5,-3.54l1.18,-0.92l0.16,-0.66l-0.38,-0.82l-0.91,-0.79l-0.16,-0.74l0.4,-0.78l0.92,-0.21l0.58,-1.19l0.26,-1.88l-0.94,-3.56l0.36,-0.25l1.46,0.09l0.31,-0.32l1.44,-4.49l-0.06,-4.24l0.23,-0.56l1.26,-1.13l2.32,-1.2l1.81,-0.4l0.72,-0.9l0.62,-2.06l-1.48,-1.62l-0.72,-5.62l-1.66,-3.84l-0.21,-1.7l0.61,-2.54l-0.75,-2.08l0.96,-2.64l-0.86,-3.73l1.39,-2.5l0.17,-1.65l1.68,-1.34l1.87,-0.39l0.51,-1.65l1.76,-1.73l1.41,-0.35l0.63,-0.98l-0.06,-2.7l0.41,-1.58l-0.42,-3.32l-0.49,-1.07l-0.2,-1.79l-0.8,-0.42l-0.14,-0.43l1.89,-1.38l1.26,-5.65l2.24,-4.03l0.58,-1.68l1.82,-0.5l0.63,-0.84l-0.5,-6.64l0.14,-1.69l1.02,-2.88l-0.26,-1.54l-1.15,-0.74l-1.45,0.27l-0.63,-0.75l-0.08,-2.03l0.62,-0.91l0.24,-1.06l-1.17,-1.35l-0.68,-2.27l0.09,-2.0l-0.76,-0.8l-0.31,-1.47l-0.79,-0.73l-0.48,-2.22l0.84,-0.54l0.42,-1.35l-1.02,-1.13l-0.87,-0.06l-0.48,-0.39l-1.55,-3.48l0.76,-5.32l1.29,-0.18l1.15,-1.42l0.08,-0.71l-0.42,-1.13l2.2,-6.0l-0.02,-0.61ZM571.67,647.98l1.23,0.43l0.29,0.6l-1.36,-0.77l-0.16,-0.25ZM541.48,886.55l1.2,0.32l3.93,-0.29l0.99,0.34l2.02,-0.31l-1.35,0.62l-0.7,-0.27l-3.55,0.07l-2.46,0.8l-1.34,0.91l-0.82,-0.48l-0.13,-0.25l0.51,-0.54l0.82,-0.08l0.87,-0.83ZM492.22,887.65l0.26,-34.63l2.78,3.31l0.75,1.5l-0.52,-0.13l-1.18,0.58l-0.75,1.11l-0.56,1.25l0.45,1.58l1.47,0.75l2.65,0.18l1.72,4.11l8.65,8.05l5.23,2.91l4.86,3.63l2.79,1.57l5.91,2.01l4.67,-0.34l1.27,0.09l0.53,0.4l-1.76,2.89l-1.36,0.55l-5.76,0.07l-1.38,0.64l-2.74,0.36l-2.57,0.87l-4.9,-1.76l-2.46,-0.38l-8.05,-0.59l-5.18,-0.86l-4.82,0.28Z",name:"Argentina"},GY:{path:"M598.52,50.1l0.76,0.22l0.42,-0.4l0.34,0.08l5.53,3.44l4.64,4.08l3.57,4.02l0.35,0.75l-0.04,3.3l-1.23,2.39l-0.37,4.09l-0.67,1.27l0.1,0.49l0.5,0.01l0.95,-0.74l0.44,-2.3l1.71,-2.5l1.14,-0.28l3.62,1.06l4.43,3.98l0.78,1.37l2.53,0.88l1.27,1.03l0.38,0.84l0.27,2.46l-0.41,4.02l-1.38,2.79l0.47,1.07l0.8,0.3l-1.11,0.99l-0.16,0.92l-4.43,0.32l-2.29,1.47l-0.51,1.1l0.82,1.74l-1.2,3.69l-1.22,2.07l-0.06,1.16l0.35,1.38l1.48,1.73l0.85,2.07l2.18,1.95l-0.05,1.1l0.3,0.58l1.37,0.55l2.73,-0.29l0.14,2.2l0.56,0.74l0.44,3.14l1.17,1.17l2.07,4.42l2.75,4.35l2.21,0.78l-3.46,0.45l-1.99,-0.46l-1.32,-1.11l-2.68,0.63l-1.31,0.8l-1.51,2.09l-2.8,0.25l-2.26,0.62l-0.77,1.56l-0.96,0.03l-0.44,-0.37l-2.19,-0.49l-0.91,1.33l-1.28,0.56l-0.05,1.78l-1.84,0.03l-1.69,0.96l-1.63,-1.23l-3.07,-0.84l-3.57,-3.8l-1.47,-0.57l-0.22,-1.23l-0.86,-0.46l0.0,-4.44l-1.67,-1.27l-1.21,-3.79l0.26,-3.48l1.71,-4.39l-0.24,-2.7l1.89,-1.21l1.72,-3.26l-2.23,-3.51l0.45,-1.51l-0.18,-0.59l-1.8,-1.24l-3.38,-0.49l1.36,-2.28l0.33,-4.49l-0.98,-0.69l-0.77,-1.12l-1.39,-0.36l-1.34,0.67l-4.68,-0.05l-7.5,-8.41l3.02,-3.15l-0.19,-3.05l-0.61,-1.7l0.53,-0.98l2.28,-0.39l0.88,-0.66l1.99,0.14l3.81,-2.09l0.73,-0.93l0.38,-1.24l-0.19,-0.78l-1.05,-0.46l-2.1,0.14l-0.42,-0.47l0.3,-1.31l-1.33,-2.28l1.23,-1.3l1.02,-1.86l1.67,-0.24l2.39,-1.98l1.71,-0.7l0.91,-1.72l1.48,-0.8l0.2,-1.14Z",name:"Guyana"},BR:{path:"M468.22,283.24l0.06,-13.55l0.81,-1.43l-0.35,-1.23l0.59,-2.44l-0.45,-0.11l-1.19,0.51l-7.26,5.93l-4.28,0.45l-6.49,-0.01l-0.05,-1.87l-0.91,-0.74l-0.72,-2.6l-0.86,-0.74l-5.41,-1.29l-3.99,-0.01l2.34,-2.87l-0.05,-2.06l-2.76,-3.32l-1.21,-0.82l-0.54,-0.87l-0.26,-1.32l-2.07,-1.47l-1.19,-3.29l-1.52,-1.65l0.7,-1.0l-0.23,-1.04l-1.22,-0.54l-1.87,-1.82l0.4,-0.6l-0.07,-1.31l2.23,-0.42l0.71,-0.74l-1.0,-2.74l0.51,-1.93l2.98,-2.61l2.01,-1.21l1.1,-0.18l1.36,-1.31l0.09,-1.76l-1.17,-2.94l3.04,-5.5l1.02,-5.98l2.2,-0.64l4.18,-3.39l6.02,-3.36l3.84,-0.41l3.49,-0.98l3.15,-0.46l2.19,-2.16l4.48,-0.24l1.87,1.73l1.49,-0.08l1.03,0.53l0.8,-0.16l0.53,-0.59l6.88,-37.63l-0.57,-1.26l-0.0,-1.07l-1.18,-1.12l-0.82,-1.85l0.26,-1.39l-0.54,-1.66l-3.58,-2.44l-1.64,-1.93l0.19,-8.2l2.73,-0.33l3.83,-1.42l0.87,0.7l1.46,0.51l1.49,-0.13l0.5,-0.59l-0.22,-2.81l-1.11,-1.78l-0.75,-0.54l-6.33,-0.34l0.04,-6.84l3.26,-0.81l2.7,0.62l13.8,0.02l0.34,-0.62l-0.86,-1.35l0.42,-1.15l1.58,2.21l0.74,0.52l0.75,0.04l1.7,-0.65l3.03,-3.33l1.52,-0.47l0.42,0.27l2.74,4.5l0.32,0.96l-0.04,4.81l0.38,0.68l2.53,-0.39l5.23,4.7l1.68,0.92l3.18,-0.41l4.38,-2.35l1.13,0.57l0.38,0.73l-0.41,0.98l0.05,0.92l0.41,0.36l1.0,-0.04l1.64,-2.26l1.15,-0.76l1.93,-2.12l3.24,-1.69l1.19,-0.02l2.83,-2.34l2.14,-0.04l1.4,-0.97l1.23,-1.28l1.16,-3.58l1.88,-0.49l3.29,-1.72l1.35,-0.23l1.03,-1.32l0.23,-1.57l-0.52,-1.18l-6.42,-0.49l-1.17,-0.4l0.46,-1.94l-0.38,-1.66l-2.14,-4.77l-0.1,-4.77l-0.73,-0.99l-3.5,-2.84l-1.15,-1.28l-1.57,-2.57l0.98,0.35l1.19,1.25l4.64,0.17l1.34,1.77l0.9,0.65l4.37,-0.13l1.72,0.54l2.05,-0.58l4.24,4.08l1.65,0.15l1.51,-1.32l0.55,-3.91l1.13,-0.25l2.2,-1.31l3.0,0.68l4.2,-1.2l3.24,-1.1l1.03,-1.42l1.37,-0.43l0.92,-0.88l1.99,0.13l1.39,-0.41l1.29,-1.9l1.94,-1.04l1.49,-1.58l0.31,-1.39l-0.91,-2.28l2.24,0.35l1.73,-0.2l0.97,-0.61l0.95,0.19l0.73,1.07l0.86,0.61l-0.47,3.84l-1.41,2.53l0.64,0.69l3.42,0.47l1.33,0.96l-0.4,1.85l2.18,3.3l-1.48,2.63l-1.97,1.26l-0.18,0.4l0.28,2.69l-1.37,3.17l-0.62,3.96l0.04,1.08l1.26,3.94l1.62,1.19l0.03,4.46l1.02,0.73l0.25,1.3l1.5,0.54l3.61,3.84l3.24,0.94l1.47,1.26l1.01,-0.07l1.28,-0.86l2.3,-0.24l0.34,-0.87l-0.18,-1.04l0.97,-0.28l0.82,-1.3l2.14,0.88l1.36,-0.04l0.59,-0.46l0.33,-1.1l2.0,-0.61l2.5,-0.08l0.71,-0.35l2.07,-2.51l2.82,-0.81l1.09,1.04l2.18,0.52l2.72,-0.48l0.86,0.13l0.79,-0.35l5.5,1.17l0.87,-0.18l0.7,-0.72l0.08,-2.13l-1.88,-2.35l-0.64,-0.31l1.25,-1.09l0.47,-1.39l2.79,1.36l4.13,-0.41l0.68,-0.61l1.78,-0.68l1.39,-0.01l0.72,-0.46l1.26,1.55l1.84,0.14l0.32,0.95l1.78,0.82l0.52,0.62l2.7,1.11l1.95,0.39l4.41,-2.72l0.4,0.47l2.78,0.68l2.1,-0.96l1.38,1.54l3.31,0.22l3.22,-2.19l0.71,-0.87l1.15,-1.82l0.1,-0.99l1.63,-3.07l1.04,-3.24l1.98,-2.21l2.12,-4.08l1.85,-1.94l0.77,-1.5l1.44,-0.93l1.27,-2.82l0.57,-0.02l1.46,0.97l1.21,1.48l1.69,4.98l0.3,4.74l2.71,7.6l0.46,2.11l1.33,3.2l-0.34,0.58l0.29,0.66l0.96,0.24l0.38,1.2l1.44,2.08l3.49,0.67l2.54,1.38l0.84,2.68l-0.21,2.92l-4.61,3.78l-0.66,1.08l-1.48,1.43l-1.41,2.58l-2.04,2.33l-0.62,0.51l-1.84,0.54l-1.67,1.95l-2.35,0.93l-0.19,1.07l-1.22,2.49l-1.81,1.87l-1.78,2.57l-0.29,3.15l-2.23,1.78l-0.33,1.85l-0.44,0.45l-0.32,0.25l-2.58,-0.38l-5.2,2.27l-0.27,0.44l0.39,0.34l4.14,0.09l1.59,0.97l3.0,-0.64l3.73,-2.35l4.23,-2.07l4.56,-3.3l0.37,0.57l-0.91,1.23l0.88,1.37l0.69,3.11l1.29,1.88l-0.04,1.56l3.48,3.09l0.49,0.04l1.67,-1.09l2.94,-1.05l3.57,1.09l4.03,-1.91l-2.02,5.74l-0.54,2.81l-0.98,1.63l0.06,0.45l0.45,0.1l1.42,-0.76l0.9,-1.21l2.96,-7.06l2.64,-1.06l3.27,-3.98l0.96,0.01l1.6,1.44l0.62,-0.26l0.17,-0.91l0.95,-0.38l0.02,-0.74l-1.2,-0.8l-0.09,-0.64l0.74,-1.01l-0.31,-1.12l1.46,-1.08l0.05,-1.17l1.21,-1.38l0.81,-0.36l0.35,-0.79l0.54,-0.22l0.71,0.64l0.55,-0.01l1.57,-1.14l1.52,0.7l1.44,-0.57l1.61,1.05l0.51,-0.5l-0.41,-0.91l0.34,-0.24l1.37,0.2l1.81,1.22l2.11,-0.01l0.73,0.43l0.79,-0.0l2.44,2.29l2.42,0.73l2.1,0.05l0.33,0.78l1.99,0.08l0.91,0.97l2.27,0.74l1.57,1.13l2.2,0.12l1.16,2.33l0.28,1.75l0.56,0.3l0.74,-0.4l1.17,-2.19l0.89,-0.34l3.58,3.06l-0.25,0.67l1.09,0.13l0.67,-0.4l0.99,1.95l0.09,1.08l-1.32,1.88l-1.09,0.44l-0.1,0.64l1.09,1.25l0.67,-0.03l0.96,-1.65l1.2,-0.56l0.45,1.62l-1.35,0.39l-0.29,1.14l-0.82,1.19l-1.6,6.86l-0.03,0.83l0.62,0.34l1.28,-0.86l2.23,-2.34l1.61,-4.97l0.76,-0.61l0.96,0.17l-0.07,0.78l-1.34,1.87l0.39,1.07l0.62,0.09l2.96,-2.6l0.92,0.07l1.56,-0.89l3.2,-0.19l0.99,-1.51l1.64,0.11l3.44,0.93l3.1,1.48l1.06,0.89l4.15,1.58l3.13,0.2l1.53,-0.68l1.64,0.66l1.1,0.88l1.98,0.47l1.95,0.24l1.63,-0.61l3.83,-0.2l4.79,-0.88l5.98,0.77l11.37,6.33l3.96,3.18l2.53,0.79l5.16,6.0l3.02,2.25l2.17,2.35l3.79,1.42l1.75,2.48l2.61,0.29l1.03,0.33l1.44,1.04l1.89,0.57l5.27,-0.03l2.22,-0.47l5.05,0.88l0.71,0.39l0.99,0.94l1.85,3.72l1.67,7.41l1.3,2.58l0.7,4.67l0.6,1.52l0.04,1.08l0.53,0.5l0.32,2.94l-0.88,5.53l0.53,2.67l-3.86,11.56l-2.17,3.59l-4.98,5.61l-1.61,-0.11l0.35,1.33l-0.35,0.71l-2.0,2.72l-2.07,1.87l-2.04,3.06l-4.4,2.27l-2.1,1.85l-1.92,2.9l-1.17,0.43l0.02,1.32l-0.93,1.32l0.03,-0.87l-0.68,-0.27l-0.45,0.46l-1.02,1.81l0.25,1.44l-0.64,1.78l-2.62,5.41l-3.97,5.99l-2.6,3.03l-1.82,1.39l-0.67,-0.05l-0.4,-2.34l-2.08,-1.75l-0.57,0.19l-0.6,1.43l-1.02,0.36l-0.2,0.71l0.88,1.08l-0.76,1.39l-0.07,1.43l-2.28,2.6l-0.78,2.9l1.18,0.47l-0.6,1.7l-0.07,3.41l0.54,1.02l0.53,-0.05l-1.21,6.7l0.76,7.39l1.38,7.47l-2.18,7.84l-1.69,8.41l-0.15,1.8l0.7,4.67l-1.32,1.59l-1.55,0.84l-0.98,0.94l-2.09,3.47l-1.08,4.92l0.48,7.96l-0.36,2.11l-0.59,1.39l-0.67,0.87l-1.96,1.26l-1.69,2.84l-0.75,2.98l-1.2,1.24l-0.23,1.61l-0.88,1.7l-2.33,2.6l-1.51,0.75l-0.86,0.83l-0.56,1.7l-1.53,2.64l-1.12,3.38l0.58,6.14l-1.29,0.95l-5.5,2.0l-1.63,0.93l-3.42,3.61l-0.08,2.12l0.43,0.62l-0.95,1.59l-6.26,-0.06l-4.45,0.34l-1.24,-0.69l0.23,-1.57l-0.25,-0.6l-1.2,-0.22l-1.28,0.58l-0.16,0.76l0.55,1.71l-0.19,0.34l-5.02,0.85l0.16,-0.43l-0.53,-0.72l-2.18,-0.72l-2.19,0.43l-1.25,0.83l-2.61,-0.07l-3.25,0.64l-0.76,0.8l0.0,1.55l1.06,0.82l-0.7,0.4l-3.56,0.66l-3.11,2.42l-1.42,0.38l-1.18,1.09l-0.44,1.4l-2.19,-0.49l-2.15,-0.01l-1.66,0.42l-10.89,5.67l-3.31,3.32l-5.47,3.68l-3.37,2.71l-1.36,0.52l-0.11,0.63l0.78,0.52l-0.14,0.69l-2.38,2.24l-0.33,-0.59l-2.52,-0.47l-1.02,0.56l0.15,1.38l-0.28,0.25l-1.7,-0.07l-0.97,-0.8l-0.48,-0.02l-0.16,0.45l0.79,1.86l2.19,0.38l0.92,0.58l-1.53,2.47l-1.57,0.57l-0.16,0.4l0.37,0.55l0.56,-0.0l0.26,0.45l-0.47,2.86l-1.5,1.12l-0.03,0.44l1.11,1.72l-0.31,3.7l0.76,2.36l0.72,3.97l-0.47,1.03l0.26,1.31l-0.83,2.49l0.44,3.44l-0.18,3.2l-0.83,2.92l-1.23,1.69l-0.1,1.74l-5.53,3.79l-2.83,2.75l-3.0,3.82l-3.47,5.76l-3.23,8.28l-5.37,8.46l-4.82,5.43l-5.34,4.0l2.3,-2.36l2.19,-1.18l1.24,-1.96l0.17,-2.82l0.38,-0.28l1.76,-0.05l0.48,-2.47l1.91,-1.11l1.11,-1.57l-0.22,-3.55l0.57,0.38l0.83,-0.23l0.61,-1.85l-0.2,-1.03l-1.3,-0.52l-3.62,1.8l-0.68,-0.05l-0.14,-1.1l-1.79,-0.92l-0.93,-2.02l-0.58,-0.33l-0.6,0.36l0.2,2.8l1.4,1.6l-0.96,1.19l-0.49,2.72l-0.25,-0.18l-0.63,0.29l-0.2,2.13l-0.88,0.77l-0.43,1.02l0.2,1.05l-2.83,2.28l-2.5,1.25l-0.67,0.69l-0.73,2.95l-1.14,1.34l-0.89,2.55l0.01,1.3l0.69,2.51l-1.61,1.95l-0.84,1.61l-2.03,5.88l-1.7,3.48l-3.17,3.48l-5.27,4.47l-1.37,-0.72l-0.13,-0.48l0.03,-0.51l0.97,-0.6l0.2,-0.8l-0.17,-1.74l0.49,-2.41l0.56,-0.71l1.62,-0.69l1.14,-2.74l0.59,-0.39l0.68,0.11l1.17,1.27l1.4,-0.15l2.4,-3.78l0.3,-2.0l-1.17,-2.14l-0.02,-1.47l-0.4,-0.71l-0.61,0.0l-0.79,0.94l-0.41,1.7l-1.6,0.91l-0.96,1.78l-1.4,0.79l-2.15,-1.05l-2.73,-2.26l-2.11,-4.77l-1.92,-1.4l-3.56,-1.27l-1.72,-1.41l-2.78,-3.56l-3.64,-1.23l-1.63,-1.44l-0.97,0.31l-0.75,-0.34l-0.87,-0.64l-1.36,-2.39l-2.39,-2.33l-0.55,-0.33l-0.63,0.06l-0.65,0.99l-1.65,1.44l-1.86,0.49l0.2,-2.78l-0.65,-1.1l-1.63,-2.02l-7.93,-6.91l-2.7,-0.05l-1.18,0.49l-1.1,1.8l-3.72,-0.27l-0.4,-0.57l2.25,-1.8l1.06,-1.25l0.27,-1.16l0.79,-0.85l1.65,-0.89l1.86,-1.64l2.03,-2.36l1.67,-2.84l1.9,-1.42l1.0,-1.25l0.89,-1.94l1.11,-1.43l2.32,-2.07l0.52,-1.12l1.06,-0.69l0.16,-0.92l1.65,0.33l0.86,-0.32l0.18,-0.78l-0.79,-1.12l0.11,-0.29l2.93,-1.46l1.59,-1.75l1.12,-0.67l1.83,-0.49l0.69,-1.23l1.62,-0.83l0.21,-0.92l0.73,-1.09l1.87,-0.28l1.27,-0.91l2.9,-0.47l0.93,-0.68l0.94,-1.38l0.64,0.16l0.89,-0.4l2.63,-1.77l1.47,-3.13l-0.4,-1.95l0.49,-4.94l0.46,-0.74l0.03,-1.04l-1.85,-3.55l-0.82,-3.73l-0.9,-0.49l-0.62,-0.8l-2.09,-0.86l-3.5,1.27l-1.6,-0.59l0.05,-1.33l2.08,-3.99l-0.18,-0.87l1.68,-6.76l0.4,-2.89l-0.44,-2.19l0.77,-0.85l-0.03,-0.65l-2.4,-1.86l-2.28,-1.16l-5.75,2.34l-1.28,0.24l-1.89,-0.31l-0.42,-0.36l-0.47,-3.21l-0.96,-1.38l0.24,-2.08l-0.42,-1.26l-0.09,-2.06l-0.51,-0.87l-0.57,-2.57l0.35,-2.84l-1.08,-1.1l-0.42,-0.82l-0.16,-1.44l-0.59,-0.75l-0.88,-0.7l-4.55,-0.49l-1.2,-1.01l-0.47,-0.99l-0.87,-0.42l-1.36,0.47l-1.16,1.51l-3.46,0.47l-3.59,-0.95l-1.19,0.23l-2.73,-0.4l-1.84,-1.03l-1.97,0.44l-0.72,-0.26l-0.24,-0.53l0.58,-1.48l-0.15,-0.96l0.38,-1.8l-0.33,-2.62l0.82,-1.63l-0.18,-0.88l0.79,-2.1l-0.04,-1.71l-0.82,-1.54l0.05,-1.76l-0.29,-0.72l-0.78,-0.47l-0.28,-2.38l-1.47,-2.18l-0.29,-1.14l0.63,-0.26l0.76,-1.06l1.5,-0.41l0.55,-0.68l-0.07,-0.51l-3.04,-2.75l3.85,-8.01l1.06,-0.72l-0.17,-1.54l-0.5,-0.39l2.35,-7.38l0.94,-0.81l-1.1,-1.49l-2.3,-5.53l-0.17,-1.36l-0.53,-0.76l-2.07,-0.13l-4.68,-3.27l-0.97,-6.42l1.54,-2.61l0.06,-2.59l-0.75,-0.37l-1.97,0.55l-19.38,-0.72l-0.78,-9.41l-3.51,-4.3l2.75,-0.09l0.39,-0.42l-0.31,-5.79l-0.5,-0.75l-0.69,-2.85l-0.78,-0.94l-0.14,-0.77l0.82,-2.12l-0.24,-1.09l-1.19,-2.0l-6.9,-3.69l-5.38,0.59l-3.26,-0.18l-1.7,-1.35l-1.73,-1.93l-0.47,-1.18l-0.91,-0.35l-1.98,-0.01l-3.97,-1.67l-1.0,-0.0l-2.8,-2.21l-0.81,-1.79l-0.82,-0.23l-1.57,0.65l-0.94,-0.28l-2.83,-1.94l-1.42,-0.56l-1.39,-0.08l-1.7,0.69l-5.5,-1.03l-1.22,-2.33l-1.15,-0.56l-2.63,-2.12l-1.82,-0.62l-1.2,-2.78l-0.55,-0.26l-0.58,0.22l0.12,-1.08l-1.74,-2.48l-0.26,-1.53l-0.56,-0.8l0.2,-1.42l0.6,-1.23l-0.15,-1.72l-1.33,-4.54l1.56,-2.91l0.23,-1.44l-0.31,-1.56l0.16,-1.96l-0.4,-1.11l-1.0,-1.11l-1.32,0.26l-0.85,0.8l-0.68,0.1l-0.95,-0.48l-2.64,0.21l-4.09,0.49l-3.89,0.94l-1.93,0.96l-4.58,3.55l-0.85,0.46l-1.22,0.15l-1.63,0.87l-2.06,1.47l-1.61,2.04l-1.17,-0.26l-2.96,0.51l-2.98,3.37l-3.62,1.57l-1.1,0.13l-0.57,-0.88l-0.92,-0.45l-4.62,-0.68l-8.83,-0.31l-3.27,1.46l-1.32,0.21l-1.09,-0.43l-0.96,-0.92l-1.19,0.28ZM790.43,433.84l-0.02,0.0l-0.01,-0.01l0.03,0.0ZM696.21,547.6l-2.86,2.1l-1.1,1.28l0.26,-1.22l-0.22,-1.57l1.88,0.51l1.04,-0.9l1.0,-0.2ZM853.5,308.31l0.11,-0.19l0.08,-0.48l0.14,0.42l-0.34,0.25ZM849.97,314.42l-0.36,-0.63l0.15,-0.14l0.39,0.01l-0.18,0.75ZM786.3,434.46l0.48,0.39l-1.39,0.38l0.65,-0.45l0.26,-0.33ZM782.69,186.02l-0.18,-0.98l0.33,-0.72l0.05,0.32l-0.21,1.37ZM777.56,166.79l0.08,-0.36l0.35,0.04l-0.43,0.32ZM773.52,444.28l-1.38,0.1l1.31,-1.56l0.35,0.64l-0.29,0.83ZM734.68,493.07l0.06,-1.19l1.05,-1.79l-0.22,1.43l-0.89,1.54ZM721.16,153.87l2.85,-0.17l1.13,-0.57l2.22,-0.04l6.36,0.82l1.64,0.46l0.51,0.55l-1.36,3.62l-0.86,0.53l0.31,1.32l-0.32,0.92l-1.57,2.51l-1.61,1.42l0.28,1.49l-1.28,1.53l-1.1,0.32l-1.33,-1.09l-0.69,0.22l-0.54,1.9l-1.01,-0.04l-1.91,-0.98l-0.56,0.3l-0.21,1.33l-0.62,0.82l-2.43,0.84l-3.04,-1.01l-0.73,0.54l-2.6,0.09l-1.3,0.52l-0.54,-0.11l-0.97,-0.93l-1.85,-5.31l0.25,-0.95l1.68,0.09l0.21,-0.98l-0.56,-0.58l-1.24,0.05l-0.66,-0.6l-0.13,-1.07l0.27,-2.96l0.63,-0.81l0.31,-2.62l0.5,-0.96l2.06,-1.29l2.43,-0.47l7.4,1.35ZM733.71,476.03l-0.38,-0.82l1.01,-1.02l-0.24,1.09l-0.39,0.75ZM723.29,151.69l-2.97,0.35l-0.92,-0.38l1.02,-0.78l2.31,-0.76l0.97,0.25l0.2,0.4l-0.62,0.92ZM719.68,147.83l0.23,0.29l-1.47,2.18l-0.77,0.3l-0.85,0.06l-1.44,-0.74l-2.34,-0.03l-0.04,-0.67l0.66,-0.89l1.67,0.04l2.89,-0.91l1.46,0.38ZM714.69,145.63l-0.92,0.26l0.24,-1.86l1.84,-0.51l0.03,0.75l-1.2,1.37ZM712.79,127.06l-1.24,0.28l-0.51,-1.16l0.16,-0.87l1.1,-0.17l0.5,1.91ZM711.3,148.79l-0.24,1.48l-1.41,-0.49l0.11,-1.28l0.93,-0.49l1.0,-1.14l0.44,-2.79l0.2,3.38l-1.03,1.32ZM708.5,152.08l-2.92,2.09l-0.9,-0.75l0.37,-1.12l1.64,-0.59l1.72,0.06l0.09,0.32ZM694.54,167.62l-0.4,0.07l1.22,-2.23l1.43,-1.36l0.14,-2.96l1.49,-2.31l1.32,-0.91l1.73,-0.25l0.86,1.15l-1.25,3.83l-2.26,2.38l-2.01,1.52l-2.26,1.07Z",name:"Brazil"},PE:{path:"M375.3,192.04l0.75,1.03l0.88,0.05l0.64,-0.63l-0.35,-1.15l3.74,-4.3l14.18,-5.04l7.27,-5.3l6.25,-7.25l1.89,-6.98l1.43,0.29l0.66,-0.63l-0.4,-2.91l0.24,-1.86l-2.01,-1.96l-0.9,-2.03l-0.91,-0.63l0.92,0.25l1.6,-0.18l1.55,-1.21l0.69,0.08l2.31,1.64l1.68,0.22l0.6,1.11l1.65,0.85l1.75,1.71l0.52,0.69l1.02,3.28l1.1,1.49l2.41,0.8l2.37,2.04l2.28,0.58l1.63,2.33l0.26,0.83l-0.31,1.42l0.35,0.65l1.94,1.26l1.14,-0.09l0.51,0.46l0.8,2.82l-0.52,1.48l0.22,1.04l2.15,0.98l0.71,0.7l1.72,0.15l2.17,-0.63l2.66,0.89l2.35,-0.33l2.01,-0.9l0.96,-0.06l2.54,-2.0l2.14,0.79l2.16,1.38l2.5,-0.26l1.1,-0.84l1.59,-0.42l2.9,1.53l0.88,0.85l2.65,0.99l4.05,2.32l-8.02,12.69l0.24,0.6l2.55,1.04l2.21,-0.61l0.98,0.67l0.86,1.96l1.86,1.42l0.51,0.73l-0.04,0.48l-0.51,0.18l-1.08,-0.54l-1.13,0.16l-2.17,-1.81l-4.78,0.28l-2.22,2.17l-3.12,0.46l-3.39,0.96l-3.98,0.45l-6.23,3.48l-4.04,3.3l-2.31,0.7l-0.41,0.58l-0.91,5.83l-3.08,5.61l1.19,3.22l-0.02,1.21l-1.0,0.96l-1.1,0.17l-2.15,1.3l-3.17,2.79l-0.65,2.46l1.0,2.53l-2.66,0.63l-0.27,0.38l0.09,1.39l-0.47,0.99l2.2,2.25l1.16,0.51l-0.69,1.6l1.63,1.89l1.26,3.43l2.17,1.57l0.05,1.01l0.65,1.06l1.27,0.88l2.64,3.18l0.04,1.25l-2.79,3.43l0.32,0.65l4.71,-0.01l5.12,1.19l0.58,0.44l0.78,2.71l0.88,0.71l-0.09,1.76l0.38,0.41l6.96,0.03l4.52,-0.5l7.47,-6.04l-0.26,1.41l0.35,1.05l-0.81,1.46l-0.07,14.46l0.64,0.32l1.0,-0.61l1.58,1.23l0.83,0.15l1.61,-0.26l3.06,-1.4l4.29,0.27l10.53,18.52l-0.79,1.08l-0.04,1.03l-1.19,0.74l-1.45,1.8l-0.05,7.48l-1.05,2.18l1.17,3.89l1.22,2.28l-1.47,0.89l-0.22,1.5l-2.52,2.55l-0.6,1.9l-1.06,0.81l-0.14,2.32l2.33,3.1l-2.03,2.92l-3.75,-2.91l-1.85,0.58l-1.43,1.2l-0.1,0.39l1.31,2.69l-0.54,-0.27l-0.74,0.13l-0.77,0.93l-0.27,0.96l0.25,1.04l1.74,1.12l0.78,0.04l0.26,-0.33l-0.11,-0.58l2.01,1.5l2.04,0.73l-0.54,1.41l0.4,0.58l2.6,0.85l2.57,-0.4l-0.3,1.9l-0.53,1.18l0.69,0.68l0.16,0.94l-1.99,1.4l-2.93,3.94l-0.73,0.23l-1.58,1.34l-0.25,0.91l1.48,1.75l0.11,1.12l-1.86,1.58l-1.35,0.17l-0.77,0.58l0.46,3.8l-0.41,1.16l-0.96,1.29l-1.5,0.9l-1.4,0.48l-2.65,0.2l-4.66,-3.51l-1.47,-1.48l-4.73,-3.08l-0.74,-3.19l-1.7,-1.69l-3.0,-1.23l-2.33,-1.68l-1.69,-0.74l-4.29,-3.64l-3.99,-1.19l-7.35,-3.85l-3.92,-1.26l-4.97,-3.52l-2.77,-1.01l-2.2,-1.66l-6.57,-3.51l-1.96,-2.76l-1.53,-1.13l-1.61,-2.34l-4.84,-3.31l-2.85,-4.9l-1.35,-1.19l-0.09,-2.09l-0.76,-0.98l1.21,-0.7l0.91,-3.53l-0.48,-1.97l-3.38,-4.81l-0.63,-1.93l-2.47,-3.69l-0.88,-2.16l-2.05,-1.73l-0.92,-1.44l-0.88,-0.46l-0.06,-1.52l-0.81,-3.31l-1.17,-1.69l-3.75,-2.88l-0.37,-3.1l-0.89,-2.35l-5.42,-9.12l-3.13,-8.71l-2.65,-4.89l-1.06,-2.74l-0.17,-1.66l-1.94,-2.54l-1.1,-2.43l-4.35,-4.48l-2.52,-4.98l-0.39,-1.57l-4.6,-6.45l-1.49,-1.52l-8.45,-4.44l-3.84,-2.61l-0.39,-1.17l0.14,-0.58l0.58,-0.5l1.27,0.49l0.96,-0.42l0.63,-1.19l0.01,-1.5l-0.81,-2.17l-2.6,-3.58l0.62,-1.8l-2.68,-4.2l0.61,-3.99l0.55,-0.96l4.07,-4.22l1.13,-1.81l1.74,-1.12l1.77,-1.69l1.9,-1.15l0.24,0.18l0.63,2.19l-0.09,1.48l0.55,1.57l-1.27,1.15l-1.61,-0.26l-0.81,0.6l-0.24,0.97l0.34,1.3l0.42,0.48l0.76,0.15l-1.19,1.62l0.24,1.03l1.53,0.41l2.73,-1.96l3.94,2.09l2.03,-0.17l1.2,0.83l0.15,1.4l0.59,1.29l1.55,2.03l0.9,0.48l2.66,0.4l2.11,-1.91l0.1,-1.58l2.71,-1.94l0.4,-1.46l-0.31,-1.41l1.52,-3.97l1.54,-2.52l0.96,-4.49Z",name:"Peru"},UY:{path:"M649.15,535.28l2.55,2.37l1.33,2.36l1.09,0.85l1.06,0.5l0.8,-0.32l1.59,1.36l3.62,1.22l2.54,3.37l1.86,1.53l3.64,1.33l1.83,1.36l1.97,4.62l2.94,2.44l1.94,0.89l-1.36,1.08l-0.54,2.05l-1.42,0.45l-1.55,1.63l-0.37,0.89l1.1,7.23l0.32,0.56l1.21,0.7l-0.81,1.17l-0.73,2.21l-2.47,3.09l-0.54,1.78l-2.59,1.78l-1.85,2.02l-1.33,0.04l-1.08,0.86l-6.31,2.66l-2.2,-0.49l-1.68,-0.0l-1.69,-1.2l-3.65,-0.44l-2.49,0.51l-3.0,1.29l-1.43,-0.08l-1.51,-0.5l-1.04,-1.21l-4.65,-1.32l-3.99,-3.09l-4.5,-0.06l-3.34,0.38l-1.44,-2.2l-2.95,-2.67l-2.24,-2.57l-0.43,-2.45l1.01,-6.11l-0.09,-0.94l1.58,-0.63l1.66,-2.4l0.11,-1.16l-1.38,-5.53l0.87,-1.86l0.08,-1.13l-0.56,-1.02l0.07,-2.53l-0.31,-0.82l1.66,-1.82l0.72,-2.13l-0.01,-0.86l-0.72,-1.04l1.88,-3.77l0.31,-1.31l-0.33,-1.74l0.73,-0.6l0.28,-0.78l-0.07,-2.1l-0.62,-1.59l0.41,-1.05l1.42,-1.47l0.75,-1.18l0.14,-0.98l0.66,0.72l4.12,0.3l0.7,-0.47l0.74,-1.46l0.87,-0.37l2.16,-0.04l7.77,6.78l1.56,1.95l0.45,0.65l-0.22,1.96l0.21,1.32l0.98,0.24l1.15,-0.2l2.52,-1.93l0.51,-0.88Z",name:"Uruguay"},FK:{path:"M609.94,830.2l1.99,0.93l2.23,-0.32l0.75,0.2l0.23,0.72l-1.24,0.15l-0.28,0.43l0.12,0.96l0.66,0.72l2.54,1.08l0.45,0.06l0.45,-0.47l-0.63,-1.8l0.21,-0.38l3.07,-0.45l1.39,1.46l-0.92,0.3l-0.54,0.79l0.21,0.61l1.59,0.61l-0.34,0.71l-3.51,0.83l-0.97,0.98l-1.32,0.62l-4.16,1.16l-0.25,0.57l0.46,0.88l-0.06,1.06l-5.34,-1.36l-0.96,0.15l-0.26,0.6l1.29,2.11l-2.79,0.17l-0.77,1.58l-1.18,-0.83l-1.28,-1.5l-0.0,-0.64l1.27,-1.61l-0.2,-0.86l3.45,-2.81l2.42,-0.84l0.17,-0.38l-0.48,-1.56l0.03,-1.31l2.39,-2.02l-0.11,-1.3l0.21,-0.01ZM614.6,841.93l0.03,0.54l-0.38,-0.4l0.35,-0.14ZM590.03,837.03l2.86,-0.67l0.53,-0.32l0.11,-0.57l-0.69,-0.94l-1.46,-0.67l-1.0,-0.87l-0.3,-1.2l2.45,1.44l1.86,0.34l2.79,-1.46l1.59,0.91l3.43,-0.77l0.68,0.11l0.74,-0.64l0.91,0.7l-7.63,8.27l-2.3,0.34l-1.44,-0.11l-1.53,2.58l-1.79,0.78l-1.86,-0.09l-1.4,-0.61l-1.36,-1.1l1.87,-1.4l2.17,0.0l3.16,-1.86l1.26,-1.35l-0.19,-0.96l-0.69,-0.33l-2.78,0.48ZM599.15,844.3l0.46,0.33l-0.3,0.48l-0.15,-0.36l-0.01,-0.44ZM594.57,831.41l-1.18,0.0l-0.14,-1.08l0.79,-0.07l0.85,0.38l-0.31,0.77ZM584.01,838.51l1.03,0.14l-0.56,1.58l-0.59,-0.04l-0.95,-1.06l1.07,-0.62Z",name:"Falkland Is."}},height:905.8723093907364,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","th_mill",{insets:[{width:900,top:0,height:1636.6464833349905,bbox:[{y:-2308654.348409153,x:10842604.98396235},{y:-627681.1279581703,x:11766980.476049744}],left:0}],paths:{"TH-57":{path:"M211.11,106.74l2.52,-2.93l0.57,-1.39l-0.01,-0.79l-1.59,-1.98l-1.26,-3.81l-0.75,-0.52l-1.28,-0.14l-0.77,-1.09l-0.96,-2.75l0.09,-1.39l0.73,-1.17l1.05,-0.87l2.7,-1.63l1.38,-2.07l0.9,-0.52l1.55,0.03l0.55,-0.28l1.46,-2.41l1.04,-4.75l1.15,-1.6l0.46,-1.52l0.91,-0.81l2.18,-0.46l0.65,-0.57l-0.62,-3.34l-1.68,-1.32l-0.63,-0.95l-0.46,-2.95l0.75,-1.25l1.4,-1.29l1.49,-4.93l2.91,-1.83l3.23,0.6l2.39,-0.32l2.34,1.15l1.26,3.61l1.41,1.39l0.75,0.25l1.1,-1.0l2.83,-6.04l0.32,-3.7l-0.22,-1.05l-1.09,-0.69l-3.06,-0.5l-2.04,-1.96l-2.38,-1.33l-0.49,-0.76l-0.08,-1.72l3.2,-1.2l2.29,-1.59l0.99,-1.2l0.09,-1.23l-0.55,-0.48l-3.19,-1.05l-2.15,-1.6l1.11,-1.98l0.55,-3.08l-0.83,-1.93l-3.46,-3.68l-1.2,-6.46l-0.96,-2.17l-4.03,-4.2l-0.74,-1.45l1.53,-0.55l1.35,0.5l5.35,3.62l8.33,2.71l4.19,-0.11l2.49,1.47l1.35,0.29l2.18,-0.4l3.99,-1.66l2.16,-0.38l4.36,0.01l2.03,-0.66l2.05,-1.88l1.0,-1.89l1.43,-4.03l1.16,-1.64l1.84,-1.2l2.33,-0.77l6.39,-1.09l1.3,0.84l0.62,0.88l0.64,2.11l2.36,2.55l1.35,0.52l2.82,0.31l1.31,0.79l2.16,3.31l4.55,2.85l-0.19,3.8l0.62,2.22l1.56,1.91l2.08,1.1l2.12,0.04l2.05,-2.04l-0.06,-4.22l1.12,-0.93l3.32,-1.26l1.33,-4.16l2.05,-2.58l3.12,-2.07l3.77,-0.85l3.89,1.04l2.05,2.24l6.18,13.36l2.82,3.69l1.59,3.19l2.61,1.33l1.24,1.6l1.78,1.08l1.86,0.66l1.13,-0.45l0.61,-1.32l0.31,6.24l-0.77,4.44l-5.48,15.17l-0.94,5.74l-0.97,1.6l-3.91,2.09l-0.82,1.11l-1.16,3.08l-3.98,5.2l-0.53,2.42l1.01,2.22l-5.37,5.83l-4.8,1.04l-1.46,0.99l-0.88,1.37l-0.69,0.34l-3.7,-0.15l-1.2,0.33l-3.99,2.62l-2.0,4.18l-0.18,1.18l0.33,1.42l-1.43,1.93l0.15,1.72l-1.76,2.21l-0.11,2.85l-5.44,2.53l-0.41,0.68l-0.23,1.81l-0.75,0.05l-2.77,-1.01l-3.33,0.52l-1.53,0.64l-4.79,4.33l-1.81,0.51l-1.94,-0.72l-0.8,-0.68l-0.04,-2.43l1.18,-4.62l-0.37,-1.44l-1.24,-1.11l-17.96,2.97l-4.38,2.68l-1.6,0.2l-0.38,-1.97l-1.28,-1.47l-1.94,-0.89l-1.43,-3.59l-1.86,-0.88l-1.71,0.74l-2.86,3.97l-0.04,2.18l-1.67,3.07l-0.16,3.23l1.14,2.12l0.22,1.11l-0.27,7.5l-2.74,6.22l-0.14,2.3l-1.24,7.01l0.56,0.97l1.62,0.37l0.03,2.12l-1.75,2.49l-1.34,3.64l-2.95,0.26l-1.64,0.72l-5.37,6.13l-1.42,0.85l-2.58,0.31l-1.64,-6.15l-5.94,-6.93l-2.02,-6.77l-0.12,-0.81l1.08,-4.54l1.96,-2.16l0.4,-1.26l0.09,-2.04l-2.05,-7.06l-0.09,-0.82l0.83,-1.42l0.28,-1.33l-0.73,-3.23l-1.54,-3.94l0.24,-3.49l-0.51,-1.6l-1.58,-2.28Z",name:"Chiang Rai"},"TH-56":{path:"M349.56,106.39l1.25,1.96l0.09,0.66l-2.49,1.4l-2.31,4.5l-3.42,2.87l-0.34,1.28l0.17,1.75l0.71,1.76l0.9,1.27l1.01,0.75l2.16,0.51l1.72,-1.12l1.31,1.52l2.14,0.48l0.33,1.25l-1.41,7.55l1.7,4.44l-0.04,3.24l0.59,1.45l0.42,2.6l1.31,1.21l-0.09,0.31l-2.78,2.59l-3.38,1.03l-1.19,0.82l-1.06,2.28l-0.19,1.22l0.33,0.9l1.8,2.42l-1.58,-0.06l-3.15,-1.97l-1.63,-0.59l-2.55,-0.14l-1.11,0.38l-1.1,1.95l-0.93,2.76l-0.03,1.33l0.59,0.85l2.36,0.11l1.03,0.36l0.44,0.66l-0.08,1.18l-0.98,1.0l-2.55,1.61l-3.57,0.19l-1.49,0.81l-6.48,10.82l-0.84,2.65l-11.71,-0.84l-3.92,0.51l-4.6,-1.41l-3.29,1.05l-1.34,1.02l-2.32,-1.21l-2.28,0.06l-0.43,-1.49l0.27,-2.05l-1.43,-2.59l-1.69,-1.52l-7.29,-4.21l-1.48,-1.17l-1.33,-2.86l-1.2,-1.71l-1.32,-0.68l-3.16,-0.36l-2.12,-0.91l-1.87,0.21l-2.19,-0.57l-0.11,-2.29l-2.04,-3.25l-3.67,-1.1l-0.82,-0.65l-0.89,-2.0l-0.92,-3.51l-3.09,-5.08l-0.74,-2.58l-2.11,-5.01l-0.74,-7.16l0.12,-1.26l0.7,-1.29l0.05,-0.76l-1.34,-3.32l0.01,-2.34l-1.01,-3.57l-0.14,-2.43l1.85,-0.26l4.21,-2.63l17.5,-2.99l0.83,0.75l0.26,1.47l-1.17,4.03l0.07,2.84l1.14,1.08l1.47,0.67l1.55,0.17l1.54,-0.62l4.91,-4.41l1.26,-0.5l3.05,-0.49l2.63,0.98l1.27,-0.09l0.63,-0.87l0.19,-1.74l4.76,-2.0l0.86,-0.74l0.17,-2.98l1.76,-2.22l-0.14,-1.76l1.18,-1.23l0.28,-0.82l-0.33,-1.56l0.15,-0.9l1.8,-3.85l3.72,-2.44l0.96,-0.28l3.84,0.12l1.02,-0.51l0.89,-1.38l1.24,-0.85l4.86,-1.06l5.5,-5.92l1.54,2.32l0.6,5.34l0.66,2.04l3.98,5.62l0.79,5.49l1.41,1.42l1.91,1.18l3.22,1.38l3.25,0.92l1.88,-0.12l0.87,-1.1Z",name:"Phayao"},"TH-55":{path:"M403.15,233.41l-7.26,6.02l-4.11,2.61l-5.13,4.66l-1.67,2.83l0.05,0.57l0.68,0.76l-0.16,1.19l-3.2,2.99l0.04,0.79l1.18,0.83l-0.02,1.02l-2.66,1.85l-2.61,5.5l-3.5,2.17l-5.26,4.49l-4.43,-0.36l-3.12,0.29l-1.93,-1.11l-6.25,-0.34l-2.98,-1.23l-1.08,-0.07l-0.79,0.35l-2.27,2.01l-3.11,0.21l-0.78,1.16l-3.88,0.37l-2.28,-0.31l-2.24,0.68l-0.98,-0.34l0.19,-1.18l-2.03,-11.33l2.74,-1.55l1.7,-0.52l1.15,-1.6l0.96,-2.52l0.85,-4.58l1.2,-2.6l1.98,-2.94l0.11,-1.37l-0.89,-1.68l0.09,-4.11l0.19,-0.5l2.08,-1.91l2.09,-5.03l0.53,-2.38l-0.07,-2.53l-0.25,-1.52l-0.83,-1.56l-3.15,-0.39l-1.72,-1.85l-5.4,-0.18l-2.18,0.85l-0.77,-0.56l-1.0,-6.25l-1.36,-2.12l-0.14,-1.12l0.65,-4.01l1.34,-1.32l0.09,-0.75l-0.99,-0.91l-2.09,-0.42l-0.57,-0.88l-0.54,-2.13l0.47,-2.69l2.44,-3.09l0.42,-1.72l-0.54,-0.67l-1.34,-0.26l-0.73,-0.48l-0.46,-0.89l-0.14,-2.59l-0.43,-0.54l-1.21,-0.49l-0.42,-0.48l-0.04,-0.73l1.31,-4.02l6.31,-10.6l1.1,-0.61l2.81,0.02l0.93,-0.27l2.71,-1.71l1.17,-1.2l0.24,-1.32l-0.52,-1.36l-1.21,-0.64l-2.66,-0.23l-0.1,-0.26l0.03,-0.92l0.9,-2.68l0.93,-1.66l2.88,-0.03l1.46,0.52l3.24,2.01l1.03,0.28l1.25,-0.25l0.41,-0.54l-0.02,-0.59l-2.13,-3.0l1.13,-2.96l4.34,-1.62l2.41,-2.01l0.84,-1.54l-0.31,-0.65l-1.07,-0.86l-0.39,-2.51l-0.58,-1.41l0.04,-3.25l-1.68,-4.33l1.4,-7.38l-0.41,-1.76l-0.82,-0.63l-1.6,-0.15l-0.75,-1.15l-0.77,-0.46l-1.05,0.12l-0.96,0.97l-1.12,-0.16l-1.17,-0.65l-1.5,-2.36l-0.21,-2.52l0.52,-0.87l3.02,-2.36l2.21,-4.39l2.63,-1.56l-0.05,-1.38l-1.54,-2.4l1.04,-1.7l2.12,-1.57l2.64,-0.13l8.73,3.31l1.48,0.83l1.69,2.12l1.0,0.44l0.46,-0.15l1.02,-1.44l4.97,-4.63l4.4,-5.18l1.7,-2.73l0.91,-0.57l10.65,-0.05l2.99,0.32l2.28,0.84l4.8,2.91l2.99,1.11l3.23,0.27l3.12,-0.37l2.68,-0.73l2.29,-1.38l0.98,-0.26l1.7,0.45l1.34,0.74l0.77,0.8l0.88,2.44l0.22,2.65l-0.54,3.07l-1.34,2.29l-2.44,0.67l-2.59,1.71l-1.66,4.11l-0.58,4.72l0.82,3.59l0.87,0.59l1.75,0.36l0.77,1.08l-0.18,1.93l2.19,9.35l-0.33,6.6l0.26,2.65l0.74,1.85l6.1,5.66l2.82,3.16l0.84,3.0l-4.52,4.35l-1.81,5.28l-3.66,4.59l-0.97,2.25l-0.17,2.23l0.57,6.65l-0.48,1.82l-1.59,3.59l-0.38,2.1l0.69,2.21l2.48,2.45l0.51,1.56l-0.52,1.52l-1.33,1.76l-2.95,2.77l-2.76,1.13l-0.89,0.83l-0.4,1.28l0.09,2.55l-0.36,1.07l-1.33,1.29l-7.03,3.87l-0.53,0.71l-0.94,3.14l-3.2,3.32l-0.58,2.25l0.74,2.18l1.62,2.17l2.24,2.09Z",name:"Nan"},"TH-54":{path:"M323.8,286.2l-2.41,-3.74l-1.31,-1.25l-1.35,-1.94l-1.93,-0.1l-2.97,0.67l-1.08,0.61l-1.66,2.59l-2.21,1.9l-3.63,2.3l-2.66,2.47l-1.52,0.9l-6.45,2.33l-2.65,-0.43l-2.55,0.79l-2.27,0.29l-0.61,0.43l-0.23,1.22l-0.42,0.46l-1.93,1.32l-1.71,1.88l-0.81,-0.22l-2.33,-1.82l-1.14,-0.34l-10.34,0.61l-1.21,0.31l-3.54,1.99l-1.96,2.83l-0.65,1.85l-1.67,1.55l-1.67,-0.91l-1.03,-2.12l-1.18,-0.91l-3.61,-4.15l-4.93,-2.0l-2.23,-0.5l-5.22,0.97l-2.79,1.58l-1.67,1.69l-4.43,5.69l-1.01,0.6l-1.48,1.95l-0.79,0.44l-1.74,-0.21l-0.89,0.28l-2.07,1.7l-1.89,0.96l-1.76,-0.01l-0.91,-0.39l-3.96,-5.55l-0.4,-1.48l-0.06,-1.7l0.3,-0.46l3.59,-0.6l1.84,0.14l2.1,-1.66l2.43,-3.91l11.8,-13.29l5.1,-3.79l2.6,-2.71l1.12,-3.4l1.35,-0.61l1.42,0.45l1.13,0.99l1.43,-0.01l2.17,-1.92l2.31,-0.93l1.7,-1.4l1.62,-0.58l0.64,-0.56l3.85,-5.09l0.4,-3.35l5.54,-8.3l2.95,-2.32l2.77,-3.74l3.28,-0.72l1.36,-0.87l3.65,-6.32l1.16,-1.31l1.49,-2.92l2.87,-1.52l1.07,-1.01l3.66,-7.03l1.71,-2.66l0.64,-2.21l0.01,-3.45l0.7,-1.35l2.98,-1.32l1.91,0.22l0.5,-0.34l0.61,-1.47l0.47,-2.88l-0.28,-1.03l-1.26,-2.03l0.89,-4.44l-0.05,-1.88l-1.02,-5.35l2.38,-4.7l0.01,-1.91l-0.94,-1.97l1.17,-0.9l2.89,-0.96l4.59,1.41l3.97,-0.51l11.45,0.83l-0.22,1.93l0.64,0.82l1.44,0.78l0.1,2.45l0.56,1.13l0.63,0.58l1.88,0.6l-0.3,1.08l-2.49,3.18l-0.55,3.07l0.59,2.39l0.78,1.2l2.3,0.55l0.54,0.41l-1.41,1.61l-0.69,4.26l0.17,1.36l1.37,2.13l1.07,6.39l0.59,0.72l0.83,0.25l2.28,-0.86l1.71,0.23l3.03,-0.2l1.98,1.92l3.02,0.31l0.67,1.75l0.16,3.15l-0.48,2.17l-2.03,4.91l-1.96,1.75l-0.41,0.91l-0.09,4.39l0.95,2.18l-2.05,3.28l-1.26,2.72l-0.87,4.66l-0.92,2.42l-0.91,1.28l-1.57,0.45l-2.67,1.48l-0.51,0.6l2.03,11.58l-0.18,1.01l-3.6,1.6l-2.06,2.08l-0.65,1.41l0.01,2.74l-0.41,1.85l-1.27,2.62l-0.86,0.98Z",name:"Phrae"},"TH-53":{path:"M277.08,297.35l1.63,0.22l2.33,1.82l0.67,0.33l0.83,-0.06l0.64,-0.38l1.26,-1.62l2.0,-1.38l1.02,-1.94l2.12,-0.25l2.5,-0.78l2.69,0.42l7.51,-2.86l3.42,-2.98l3.62,-2.29l2.3,-1.97l1.88,-2.8l3.37,-0.86l1.45,0.0l0.38,0.33l4.45,6.39l0.77,0.37l1.39,-1.4l1.37,-2.84l0.45,-2.06l-0.02,-2.66l0.51,-1.06l1.82,-1.85l3.49,-1.54l1.52,0.49l2.29,-0.69l2.15,0.32l4.2,-0.38l0.93,-1.27l3.0,-0.16l2.79,-2.29l0.77,0.03l3.14,1.27l6.14,0.32l2.04,1.13l3.2,-0.29l2.23,0.34l2.57,-0.07l5.35,-4.56l3.65,-2.32l2.61,-5.51l2.37,-1.54l0.53,-0.79l-0.17,-1.44l-1.17,-0.86l2.82,-2.38l0.36,-0.63l0.31,-1.28l-0.81,-1.33l0.12,-0.38l1.34,-2.14l5.07,-4.6l4.07,-2.58l7.37,-6.11l0.67,0.6l6.76,3.09l0.88,1.22l-2.67,3.43l-0.2,5.18l1.34,3.31l2.08,1.6l0.3,0.78l-0.23,1.62l-1.6,4.17l-0.46,2.22l0.39,2.25l1.84,4.14l0.3,1.38l-0.7,1.23l-4.95,3.34l-4.97,8.6l-2.78,2.39l-3.38,1.86l-0.94,1.29l-0.47,2.52l0.33,3.72l-0.49,1.19l-2.16,0.94l-0.78,0.61l-0.34,0.9l0.28,0.99l0.82,1.12l-1.82,1.65l-0.24,1.11l0.45,3.27l-0.62,2.05l-1.6,1.04l-2.84,0.76l-0.92,-0.25l-0.59,-1.28l-0.73,-0.61l-1.12,-0.04l-1.05,0.46l-2.57,3.0l-1.56,3.59l-6.09,4.62l-3.21,5.2l-3.02,2.97l-4.66,2.14l-1.81,1.84l-5.57,4.1l-2.45,3.83l-0.53,0.33l-3.31,1.08l-4.49,0.98l-0.55,-0.02l-0.79,-1.3l-0.61,-0.32l-4.78,0.07l-10.54,3.78l-1.5,1.44l-2.29,-0.39l-1.36,0.21l-0.92,0.53l-3.48,2.94l-1.25,1.81l-0.52,1.63l-0.01,1.1l1.47,5.79l-0.32,1.15l-5.51,4.52l-1.41,0.49l-1.86,-0.94l-2.49,0.27l-12.54,3.8l-0.92,-0.4l-0.82,-0.84l-0.89,-0.21l-2.61,1.06l0.11,-4.38l-0.5,-2.7l-0.89,-2.16l1.02,-1.88l2.48,-2.13l1.38,-4.03l-0.09,-6.05l-0.25,-0.81l-1.15,-1.18l-0.24,-1.21l2.47,-0.91l1.16,-1.57l0.17,-0.87l-1.78,-4.17l-2.43,-2.77l-2.48,-1.78l-1.01,-2.25l-1.5,-0.6l-2.2,-3.22l-0.07,-0.78l0.31,-0.45l2.22,-1.33l1.56,-1.91l1.13,-5.38l-0.06,-1.87l-0.89,-3.39l-2.51,-2.86l-2.12,-1.81l-0.44,-1.14l0.4,-1.39l-0.19,-0.99l-2.29,-2.33Z",name:"Uttaradit"},"TH-52":{path:"M252.91,114.54l0.18,2.91l1.0,3.51l0.0,2.4l1.32,3.19l-0.73,1.81l-0.14,1.44l0.76,7.36l2.14,5.09l0.77,2.65l3.07,5.05l0.89,3.44l0.98,2.2l1.17,0.95l3.38,0.89l1.9,3.01l-0.07,1.9l0.46,0.77l1.92,0.63l2.45,-0.14l2.06,0.89l2.86,0.29l1.31,0.59l2.52,4.57l1.58,1.24l7.26,4.2l1.5,1.34l1.31,2.35l-0.3,1.82l0.47,1.85l0.83,0.49l1.93,-0.17l2.33,1.21l0.98,2.06l-0.03,1.47l-2.24,4.08l-0.19,1.24l0.58,1.97l0.52,4.8l-0.88,4.54l1.32,2.26l0.13,1.56l-0.84,3.03l-2.02,-0.16l-2.71,1.05l-0.65,0.56l-0.85,1.69l-0.02,3.48l-0.59,2.01l-1.67,2.58l-3.6,6.93l-0.85,0.81l-3.09,1.71l-1.53,2.98l-1.16,1.33l-3.5,6.14l-1.09,0.71l-3.45,0.8l-2.92,3.87l-2.99,2.37l-5.61,8.41l-0.32,0.91l-0.08,2.43l-3.7,4.89l-2.11,1.03l-1.7,1.39l-2.33,0.95l-2.05,1.86l-0.82,0.01l-1.05,-0.95l-1.76,-0.55l-1.1,0.23l-0.81,0.56l-0.49,0.68l-0.68,2.76l-2.53,2.66l-5.17,3.85l-11.84,13.33l-2.11,3.47l-1.27,1.36l-0.79,0.49l-1.6,-0.18l-3.25,0.46l-1.22,0.76l-0.21,1.52l0.58,2.7l3.86,5.47l1.07,0.74l2.6,0.12l2.15,-1.07l1.97,-1.64l2.94,-0.17l2.67,-2.73l0.46,1.27l-0.35,4.27l-1.97,2.63l-0.54,1.24l-0.18,2.28l0.37,1.62l-0.38,0.27l-2.2,-0.24l-0.69,0.48l-0.28,0.67l-0.25,3.42l0.53,0.66l0.95,0.48l0.59,2.88l-2.02,1.93l-0.6,5.23l0.14,0.79l1.15,2.06l1.49,1.06l-0.75,2.61l-0.03,1.67l1.32,0.96l1.16,1.35l2.09,0.96l0.59,2.03l-0.07,1.51l-0.47,0.94l-1.19,0.99l-0.7,1.06l-0.38,2.28l0.31,2.6l-0.32,0.74l-0.92,0.87l-0.31,1.48l-2.81,1.48l-1.26,0.29l-1.19,0.81l-1.22,-0.58l-1.42,-2.84l-1.8,-2.02l-0.99,-0.5l-2.32,-0.3l-4.15,-6.82l-0.83,-3.54l0.23,-3.24l-0.33,-1.0l-0.84,-0.7l-3.59,-0.43l-1.66,0.66l-1.36,1.5l-0.72,2.29l-2.92,2.96l-4.22,-2.32l-2.35,-0.06l-2.0,-1.33l-2.75,-0.37l-2.38,-1.31l-1.27,-1.89l-1.45,-0.8l-0.16,-0.4l0.27,-4.26l1.69,-5.16l0.11,-1.35l-0.52,-4.49l-0.39,-1.65l-1.35,-2.6l-0.05,-2.03l2.82,0.09l1.12,-0.64l0.56,-0.74l0.44,-1.72l0.43,-4.9l1.96,-2.1l0.29,-3.22l2.41,-2.1l1.86,-2.97l-0.33,-1.42l-1.2,-1.92l0.06,-0.51l0.72,-0.55l1.61,-0.33l2.98,0.53l0.72,-0.14l0.44,-1.1l-0.85,-2.4l1.59,-0.21l0.58,-1.0l-0.49,-1.41l-4.19,-4.79l-2.8,-1.15l-0.19,-2.58l-1.8,-1.64l0.11,-4.54l-0.86,-2.27l-2.44,-4.61l-0.3,-3.54l0.2,-1.81l-0.54,-3.51l-1.22,-1.92l-0.2,-2.61l-1.97,-3.08l-1.14,-4.27l0.48,-0.79l3.28,-1.66l1.64,0.05l1.75,-0.71l1.27,0.43l0.85,-0.2l0.9,-2.45l0.72,-1.06l0.72,-0.62l2.04,-0.84l0.47,-0.58l1.76,-3.7l0.15,-1.64l2.79,-4.44l3.45,-4.64l1.61,-3.1l2.66,-1.48l3.8,-0.11l1.6,-1.13l0.48,-3.33l0.87,-0.75l0.35,-0.75l0.25,-2.63l1.98,-1.66l0.7,-2.17l0.11,-0.94l-0.37,-1.02l-2.22,-0.74l-0.79,-0.69l0.62,-1.66l1.29,-1.6l-0.99,-2.34l0.31,-1.81l1.45,-4.18l1.61,-2.13l0.31,-1.53l-0.18,-2.58l-1.03,-2.32l-0.82,-5.04l-0.82,-0.58l-1.43,0.27l-0.17,-0.55l1.75,-2.26l2.63,-1.27l0.75,-1.08l0.83,-4.64l-0.81,-3.5l0.44,-0.77l2.37,-1.5l2.89,-0.35l1.22,-0.55l5.6,-6.31l0.89,-0.62l4.12,-0.69l0.69,-1.21l0.8,-2.67l1.56,-2.02l0.36,-1.83l-0.24,-1.49l-0.65,-0.58l-1.28,-0.1l-0.13,-0.24l1.24,-6.94l0.12,-2.22l2.76,-6.32l0.27,-7.63l-0.28,-1.35l-1.1,-1.99l0.16,-2.93l1.64,-2.96l0.01,-2.1l2.71,-3.74l1.12,-0.49l1.29,0.64l0.66,2.31l0.74,1.24l2.14,1.06l1.02,1.21l0.34,2.02Z",name:"Lampang"},"TH-51":{path:"M212.49,215.8l-0.35,2.91l-0.77,0.64l-0.78,0.28l-1.72,-0.24l-1.66,0.24l-1.82,0.76l-1.25,0.98l-1.68,3.2l-3.43,4.62l-2.87,4.58l-0.18,1.72l-1.67,3.5l-3.16,1.95l-0.83,1.23l-0.72,2.2l-1.71,-0.42l-1.76,0.71l-1.8,-0.0l-3.46,1.75l-0.81,1.32l1.19,4.69l1.97,3.09l0.17,2.52l1.22,1.94l0.5,3.29l-0.2,1.82l0.32,3.7l3.3,6.9l-0.08,4.64l1.83,1.71l0.04,2.15l0.43,0.8l2.46,0.82l2.05,2.0l2.47,3.2l-0.04,0.9l-1.51,0.13l-0.44,0.5l0.78,3.05l-4.26,-0.35l-1.48,0.56l-0.65,0.71l-0.04,1.16l1.47,2.77l-1.72,2.7l-2.48,2.2l-0.34,3.34l-1.7,1.51l-0.28,0.63l-0.46,5.03l-0.71,1.95l-1.11,0.56l-2.55,-0.19l-3.46,-2.7l-1.67,-0.76l-3.68,-0.27l-1.97,0.47l-1.5,1.04l-1.11,1.65l-0.44,1.82l-0.0,2.27l-1.47,1.94l-0.63,2.56l-0.5,0.83l-4.52,3.51l-5.25,1.81l-5.2,-0.13l-0.76,-1.55l0.0,-6.83l-1.42,-5.12l0.72,-1.89l-0.75,-1.44l-0.03,-1.34l0.53,-1.13l3.5,-1.13l0.99,-1.45l0.0,-1.52l-0.57,-1.65l-2.92,-4.47l3.64,-0.04l1.61,0.49l4.13,1.99l2.41,1.71l1.35,0.42l4.13,-1.28l1.11,-0.62l1.57,-1.76l0.26,-3.33l1.17,-5.41l-0.29,-0.97l-1.3,-1.41l-0.58,-1.23l-3.83,-12.5l-0.77,-0.69l-0.67,-0.13l-2.77,0.3l-0.44,-0.25l-0.4,-0.9l-0.51,-2.21l1.54,-8.68l-0.2,-7.25l-0.39,-1.51l-1.42,-1.84l-0.4,-5.55l-0.65,-2.48l-1.21,-1.23l-7.02,-4.0l-3.52,-1.31l0.21,-0.79l2.5,-3.17l-1.6,-3.12l1.81,-3.76l-0.06,-1.46l-0.65,-0.95l1.25,-0.67l6.48,-1.41l2.11,-1.19l4.35,-3.5l9.95,-4.94l0.81,-2.03l2.84,-4.18l0.8,-1.97l1.32,-0.75l3.45,-6.67l1.32,-0.11l1.77,1.63l0.79,0.05l2.82,-2.37l3.63,-0.4l2.82,-2.42l1.0,-0.32l3.53,-0.27l0.49,0.2l0.19,2.19l2.19,2.65l1.64,0.95l0.67,1.72l0.02,1.54l-1.4,1.33l0.11,1.56l3.34,2.58l1.76,0.86l3.04,2.67l2.56,1.34Z",name:"Lamphun"},"TH-50":{path:"M221.68,162.82l-2.29,1.45l-0.69,1.13l0.77,3.74l-0.5,3.39l-0.55,1.57l-2.88,1.45l-1.61,1.81l-0.4,0.9l-0.0,0.8l0.54,0.59l1.98,0.03l0.17,2.43l0.6,2.47l1.0,2.24l0.16,2.39l-0.26,1.26l-1.6,2.12l-1.75,5.47l-0.03,1.1l0.95,1.99l-1.19,1.3l-0.57,1.24l-0.09,1.33l1.19,0.89l1.76,0.41l0.37,0.76l-0.68,2.52l-1.44,0.91l-0.59,0.83l-0.32,2.82l-0.33,0.56l-0.49,0.4l-1.92,-0.92l-3.6,-3.02l-1.81,-0.89l-2.93,-2.1l-0.19,-1.1l1.01,-0.78l0.5,-0.96l-0.13,-1.6l-0.81,-2.0l-1.74,-1.05l-2.01,-2.42l0.12,-1.52l-0.46,-0.88l-1.08,-0.42l-3.65,0.29l-1.31,0.46l-2.64,2.32l-2.33,0.06l-1.38,0.37l-2.65,2.31l-2.09,-1.65l-1.16,-0.1l-0.91,0.31l-3.64,6.85l-1.35,0.79l-0.8,1.99l-2.85,4.19l-0.62,1.79l-9.84,4.88l-4.43,3.56l-1.97,1.11l-6.37,1.36l-1.82,0.96l-0.13,0.6l0.78,1.01l0.07,1.1l-1.83,4.09l1.56,3.01l-2.32,2.68l-0.4,1.35l0.21,0.46l3.81,1.45l6.96,3.97l1.21,1.55l0.69,7.2l0.34,0.82l1.15,1.22l0.3,1.18l0.2,7.15l-1.53,8.93l0.82,3.03l0.61,0.7l1.06,0.28l2.34,-0.35l0.83,0.41l3.77,12.37l0.68,1.44l1.37,1.6l0.07,0.73l-1.16,4.85l-0.24,3.24l-1.64,1.63l-4.31,1.45l-1.1,-0.35l-2.37,-1.69l-4.19,-2.01l-1.88,-0.55l-4.43,0.04l-2.51,1.29l-2.73,0.91l-0.97,0.7l-0.85,1.61l0.18,1.64l-0.26,0.78l-3.35,2.81l-0.85,1.48l0.6,3.48l1.16,1.84l-0.08,1.78l-1.52,2.39l-3.26,0.59l-2.62,1.26l-1.1,1.68l-1.17,3.12l-0.41,3.22l0.33,2.92l0.65,1.05l1.99,1.7l0.76,1.49l-0.2,2.94l-1.59,3.67l0.33,0.98l2.03,1.23l0.15,3.18l-0.54,2.26l-1.11,0.67l-5.34,1.51l-3.86,0.19l-4.55,2.21l-1.95,-0.28l-1.29,-1.28l-1.76,-0.86l-1.64,-1.47l-1.85,-0.77l-1.07,-1.11l0.4,-4.16l-1.0,-3.86l-1.73,-2.21l0.32,-0.71l1.68,-1.27l0.31,-0.99l-0.58,-1.31l-1.69,-1.09l1.13,-6.89l-0.26,-1.94l-2.14,-5.47l-2.11,-0.77l-2.02,0.41l-0.54,-0.55l-0.19,-5.77l0.31,-1.62l0.73,-1.05l2.95,-2.27l0.86,-1.96l-0.22,-0.53l-6.08,-2.47l-1.16,-1.02l-0.06,-0.95l-2.26,-4.39l1.36,-1.1l0.09,-1.99l1.71,-1.52l0.17,-1.61l-0.32,-0.81l-1.48,-1.95l-2.15,-1.42l-5.6,-6.95l-3.66,-2.16l-2.13,-1.97l-0.86,-1.2l-1.08,-3.87l-0.02,-0.97l1.29,-4.28l0.99,-1.31l2.05,-1.12l0.42,-1.38l-0.27,-2.05l-1.69,-2.79l-0.44,-1.45l0.48,-2.11l-0.18,-4.12l-0.53,-1.42l-1.19,-1.42l1.41,-5.03l1.52,-3.46l-0.31,-0.95l-1.37,-1.01l-0.4,-2.36l0.66,-1.07l5.05,-4.39l1.75,-4.44l0.51,-0.24l1.11,0.44l1.44,-0.14l0.91,-0.78l0.45,-1.01l-0.18,-0.99l-0.73,-0.62l-1.93,-1.26l-2.86,-1.18l-4.52,-6.01l-0.14,-0.9l0.44,-1.7l-0.06,-3.86l-0.37,-1.63l-1.53,-2.72l1.12,-2.62l-0.18,-7.23l1.16,-3.37l0.14,-1.63l-0.67,-0.91l-1.76,-0.13l-1.39,-3.97l-0.19,-1.69l3.09,-6.77l1.26,-5.4l-0.11,-1.47l-1.54,-4.64l0.12,-0.88l2.42,-4.6l-0.02,-1.18l-1.43,-3.12l0.08,-0.6l3.04,-2.57l1.11,-4.4l1.16,-0.27l1.68,-1.28l1.76,-0.08l0.6,0.18l1.32,1.26l1.73,0.44l0.82,0.59l1.66,1.8l1.34,2.87l2.58,2.07l3.25,4.58l2.12,1.27l4.39,-0.06l3.56,0.53l2.49,1.0l1.73,1.18l0.99,-0.45l1.22,-2.44l0.64,-0.46l6.7,1.4l1.35,-0.29l2.8,-1.28l3.56,-0.49l2.33,-1.45l0.98,-1.45l0.76,-1.95l0.4,-2.15l-0.48,-2.64l-2.88,-4.97l-3.08,-2.82l-0.73,-1.16l1.02,-2.97l1.41,-6.08l-0.64,-7.97l-1.18,-2.06l-0.21,-1.04l0.84,-2.32l0.02,-3.84l0.84,-4.67l-0.91,-1.93l-2.49,-2.05l-0.21,-3.04l-1.69,-2.01l-0.68,-2.31l-0.35,-3.23l-0.69,-0.75l-3.45,-2.16l-2.36,-2.28l-1.15,-2.11l-0.2,-3.18l0.73,-0.07l2.75,2.53l2.24,0.92l0.43,-0.14l0.4,-0.93l0.97,-0.85l2.06,-0.79l2.4,-0.46l0.98,-0.62l2.76,-3.2l1.79,-0.79l9.57,-1.38l2.14,-0.72l6.28,-4.77l3.01,1.36l1.46,1.03l1.31,1.17l2.06,3.08l0.42,0.17l1.84,-0.42l3.84,-2.77l4.27,-1.69l1.59,-1.38l1.43,-2.44l0.91,-3.03l-1.01,-6.93l0.2,-1.01l1.33,-2.11l-0.82,-4.18l1.17,-7.62l2.05,-3.71l3.9,-2.86l4.68,-1.83l4.35,-0.64l2.01,0.19l4.41,1.26l1.82,0.84l4.17,3.41l2.52,1.18l2.82,-0.44l13.03,-3.99l5.12,-4.53l2.0,-1.11l2.41,1.81l3.35,1.16l-0.47,1.12l-2.52,1.86l-3.18,1.14l-0.54,0.83l-0.05,0.83l0.94,2.15l2.45,1.4l1.53,1.63l1.1,0.57l2.72,0.39l0.67,0.39l-0.22,4.17l-0.76,1.97l-0.83,0.91l-1.18,2.95l-0.52,0.53l-1.71,-1.86l-0.34,-2.0l-0.64,-1.14l-2.89,-1.43l-2.41,0.36l-3.35,-0.59l-3.38,2.07l-1.6,5.1l-1.35,1.21l-0.9,1.65l0.5,3.29l0.81,1.23l1.53,1.09l0.6,2.68l-2.43,0.63l-1.25,1.12l-0.5,1.57l-1.19,1.7l-1.0,4.65l-1.27,2.16l-1.76,0.09l-1.22,0.67l-1.46,2.14l-3.77,2.53l-0.71,1.03l-0.37,1.29l0.34,1.95l1.25,2.76l0.73,0.65l1.67,0.39l1.16,3.64l1.55,1.88l-0.47,1.54l-2.64,3.3l0.26,0.87l1.42,1.82l0.44,1.41l-0.25,3.44l1.55,4.02l0.7,3.06l-1.09,2.52l0.08,1.13l2.07,7.66l-0.43,2.2l-2.02,2.32l-1.11,4.65l0.14,1.11l1.69,6.25l6.33,7.64l1.59,6.03Z",name:"Chiang Mai"},"TH-93":{path:"M301.14,1400.47l3.51,0.57l2.28,1.93l1.28,0.48l-4.31,3.8l-1.31,1.57l-0.29,2.33l1.27,9.28l1.96,5.26l0.71,3.98l0.69,1.92l4.34,3.86l3.81,9.3l2.1,3.59l2.82,2.22l5.06,0.37l1.97,0.64l0.79,2.0l-3.17,3.59l-0.71,2.82l-0.96,0.63l-3.64,1.22l-1.64,2.66l-5.37,0.91l-5.5,1.89l-3.08,0.23l-9.0,4.82l-4.23,4.55l-5.47,-6.83l-1.28,-2.02l-2.75,-7.57l0.87,-2.04l-0.56,-3.37l-3.53,-4.47l-0.88,-3.31l-1.9,-1.83l-2.98,-8.98l-0.28,-2.07l-2.83,-3.23l0.08,-2.91l-0.29,-1.13l-2.78,-4.11l-0.44,-1.29l0.16,-3.73l2.06,-1.29l0.46,-1.09l-0.0,-1.59l-0.45,-0.86l-2.28,-2.41l-1.32,-6.38l-4.18,-9.55l0.46,-0.43l4.84,-0.96l2.0,-1.99l15.48,-2.07l4.42,1.89l1.1,1.46l0.58,2.43l1.6,1.11l1.41,1.7l1.79,0.7l5.33,1.06l2.15,0.74Z",name:"Phatthalung"},"TH-92":{path:"M207.17,1416.33l5.7,-4.23l3.12,-5.36l0.02,-1.24l-2.67,-4.61l-0.39,-2.59l-1.87,-2.91l0.11,-0.58l3.85,-3.87l1.21,-2.08l0.41,-1.57l-0.48,-1.85l2.42,1.1l1.56,2.41l2.01,1.89l1.97,0.23l4.93,-0.15l3.76,1.82l1.4,0.08l3.26,-0.86l0.95,-3.05l1.8,-1.66l0.73,-1.71l2.61,-2.01l1.31,-2.57l0.41,-0.28l3.18,0.03l2.93,-0.59l3.88,0.11l2.36,-0.52l0.98,0.45l0.91,1.23l-0.94,2.87l-0.85,4.79l0.47,4.39l0.92,1.45l4.27,9.75l1.33,6.39l2.39,2.61l0.36,0.98l-0.4,1.59l-1.82,0.98l-0.37,0.56l-0.01,4.75l3.1,4.91l0.23,4.1l2.84,3.23l0.23,1.94l3.01,9.05l2.0,2.0l0.81,3.18l2.2,3.11l1.3,1.28l0.51,3.03l-0.76,1.33l-0.1,0.93l2.8,7.73l1.38,2.18l5.77,7.19l1.45,2.61l-2.51,0.66l-1.15,-0.31l-1.78,-1.05l-1.94,-1.69l-3.5,-4.83l-1.25,-0.99l-0.75,0.1l-0.7,0.6l-2.15,5.24l-1.43,1.54l-1.29,-0.35l-3.32,-2.26l-1.34,-2.33l-0.02,-2.73l-0.67,-0.41l-0.96,0.07l-3.32,1.41l-1.25,0.14l-2.46,-0.15l-0.88,-0.8l-1.94,0.61l-3.1,1.62l-1.37,-0.64l-0.52,-1.11l0.05,-3.76l-0.6,-0.35l-3.78,2.16l-1.74,1.46l-0.29,0.02l-0.28,-1.22l-0.39,-0.31l-2.66,-0.55l-2.73,-4.31l-1.87,-4.93l0.51,-2.13l2.3,-1.33l2.04,-3.21l1.43,-3.93l0.58,-3.72l-0.4,-0.46l-1.03,0.21l-3.05,5.83l-1.89,1.99l-2.26,-0.87l-0.38,-1.43l0.52,-4.62l-0.44,-1.64l-0.34,-0.29l-1.81,0.02l-1.18,1.65l-0.76,2.21l-0.32,1.84l0.44,3.77l-0.35,1.26l-1.59,0.52l-2.57,-1.0l-2.65,-1.93l-3.12,-0.55l-1.41,-0.88l-4.32,-6.54l0.94,-1.76l0.17,-2.56l-0.63,-5.85l-1.08,-1.79l-0.48,-1.49l-3.23,-0.25l1.23,-2.11l-0.16,-2.4l-0.8,-2.8l-0.79,-4.91l-1.07,-0.45l-1.9,0.57l-1.77,-1.09l0.92,-0.51l0.45,-0.7l-0.37,-1.26ZM226.87,1460.5l0.31,0.47l-2.1,0.1l-2.21,1.1l-2.48,3.54l-0.26,-5.65l0.68,-2.04l3.32,1.91l2.74,0.58Z",name:"Trang"},"TH-91":{path:"M260.22,1473.8l3.48,-0.03l3.42,-1.44l0.69,-0.0l-0.05,2.53l1.5,2.63l3.53,2.44l1.73,0.47l1.68,-1.34l1.73,-3.35l0.6,-2.09l0.65,-0.7l0.38,0.04l3.22,4.48l2.99,2.85l2.72,1.39l0.76,0.09l2.89,-0.76l0.81,0.7l0.92,1.07l0.39,1.18l0.51,4.39l1.48,2.3l3.94,4.77l1.36,0.81l1.78,0.15l1.27,0.67l2.45,0.57l1.12,0.65l1.79,1.85l0.05,1.6l-0.44,2.36l-1.69,5.32l1.68,5.88l-0.62,3.71l-0.24,0.52l-1.27,-0.61l-1.55,0.5l-0.97,1.19l-1.18,8.24l0.14,1.96l1.05,3.84l-2.31,2.96l0.3,3.83l-0.43,2.63l-1.39,3.18l-0.55,-1.51l-1.28,-1.79l-1.76,-0.61l1.2,-3.22l-0.04,-2.11l-1.41,-0.81l-1.4,0.36l-1.1,1.13l-0.83,1.9l-3.18,-2.69l-3.04,-3.5l-1.23,-3.44l-1.16,-0.49l-1.81,0.82l0.08,-0.66l1.2,-2.13l-1.41,-4.1l-0.9,-0.71l-1.78,-0.05l-0.93,-2.93l-1.25,-1.43l-2.77,-2.11l-2.63,-4.12l-2.11,-1.58l-2.55,0.71l-1.57,-4.04l-1.41,-1.53l-9.41,-3.57l-2.51,-2.35l0.03,-4.15l0.42,-1.72l1.81,-0.16l0.79,-0.9l-0.16,-1.19l-0.62,-1.02l-2.78,-1.4l0.55,-4.03l-0.7,-1.54l2.71,-5.0l1.28,-0.84l3.35,-4.94ZM250.77,1541.97l-0.45,0.28l-1.04,-1.52l-1.47,-4.73l-3.51,-3.27l0.23,-1.15l2.28,-2.91l0.23,-1.23l-0.23,-2.47l2.01,-1.57l1.06,-5.14l2.28,4.95l0.01,5.39l1.7,3.96l0.88,3.08l-0.45,2.44l-2.62,1.04l-0.57,2.47l-0.35,0.37ZM202.06,1534.15l2.62,-0.16l1.79,0.91l-4.29,2.65l-2.26,0.39l-2.07,-0.59l-0.61,-0.61l0.94,0.03l2.02,-2.22l1.86,-0.41Z",name:"Satun"},"TH-90":{path:"M311.59,1520.98l-1.24,-0.03l-1.06,-0.78l0.44,-0.98l0.64,-3.94l-1.68,-5.83l1.67,-5.15l0.46,-2.49l-0.14,-2.03l-2.66,-2.54l-3.13,-0.9l-1.36,-0.7l-1.75,-0.15l-1.25,-0.84l-1.66,-2.35l-1.97,-2.08l-1.42,-2.2l-0.44,-4.18l-0.46,-1.39l-2.03,-2.11l-1.54,-2.78l4.21,-4.55l8.88,-4.76l2.94,-0.19l5.51,-1.89l5.05,-0.7l0.6,-0.33l1.62,-2.65l3.53,-1.16l1.22,-0.82l0.81,-2.96l2.54,-2.85l0.24,2.82l0.54,1.27l0.96,0.85l1.7,0.12l1.45,0.93l-2.97,1.58l-0.46,1.1l0.43,1.38l1.66,1.41l1.42,2.88l1.4,1.32l1.67,0.61l1.67,-0.17l2.05,1.79l1.18,0.44l2.81,0.11l3.94,-1.01l2.86,-2.59l0.91,-1.38l-0.27,-3.94l18.75,25.37l2.16,1.82l4.78,1.75l2.51,-1.03l4.87,4.47l5.61,4.24l5.43,2.66l7.39,-0.06l-0.05,0.74l-1.9,3.06l-0.91,2.13l-0.29,7.32l1.49,2.55l1.13,6.11l1.42,1.01l2.75,0.91l0.45,4.23l-0.21,1.18l-2.28,3.5l-2.24,2.57l-3.42,5.41l-5.81,1.31l-3.25,1.31l-1.63,1.19l-0.72,1.12l-0.69,3.26l-0.16,2.63l0.34,4.43l-0.32,1.31l-0.59,0.77l-0.66,0.59l-2.79,1.32l-5.16,0.13l0.39,-1.62l-1.99,-4.33l-0.54,-6.34l-1.05,-2.24l-2.66,-1.63l-3.4,-0.34l-0.73,-0.54l-0.21,-3.19l-0.56,-0.98l-2.08,0.09l-6.91,4.94l-1.75,0.24l-1.85,-0.45l-3.73,-1.65l-6.59,-1.91l-1.92,-0.89l-3.57,-2.54l-1.76,-0.41l-2.76,0.32l-1.74,-0.14l-2.34,-0.72l-4.11,-1.98l-2.04,-1.79l-1.17,-1.97l-4.01,-12.18l-0.83,-0.95l-1.41,-0.53l-2.32,-0.03l-1.9,1.23ZM326.66,1397.57l7.92,38.09l6.55,15.59l7.23,11.41l0.76,2.1l-0.05,1.05l-2.24,-0.18l-5.17,-4.84l-3.0,-1.84l-3.17,0.05l-1.59,-0.83l1.3,-2.84l-1.07,-3.49l-0.73,-4.72l-1.53,-1.11l0.2,-8.45l-0.43,-7.59l-1.82,-4.33l-3.53,-1.57l-3.82,0.42l-2.73,3.86l-0.78,1.84l-0.39,0.34l-1.44,-1.14l-0.36,-2.59l0.66,-1.93l3.57,-2.19l1.62,-2.14l0.46,-4.44l-0.7,-5.84l-1.48,-5.5l-2.02,-3.42l-2.48,-0.96l-6.41,1.58l-1.07,0.87l-1.52,-0.53l-2.46,-2.02l-3.15,-0.52l1.74,-5.9l0.8,-1.39l4.57,-2.09l5.18,-1.62l3.59,-1.87l6.38,-1.29l2.62,11.97Z",name:"Songkhla"},"TH-96":{path:"M450.09,1607.55l-0.4,-1.27l0.21,-4.54l-1.27,-2.75l0.37,-7.49l-0.22,-0.99l-0.96,-1.7l-2.92,-1.92l-0.93,-3.91l-1.31,-1.73l-3.3,-2.16l-1.88,-4.45l1.81,-1.71l0.53,-1.01l0.32,-4.29l3.25,-16.28l0.62,-0.59l4.34,-1.41l5.49,-0.79l0.97,-0.71l7.73,-9.52l-0.04,-1.04l-1.17,-1.46l0.65,-2.01l-0.19,-1.1l-1.99,-1.41l-0.67,-0.68l-0.08,-0.55l0.91,-0.98l2.48,-0.65l1.39,0.4l1.31,-0.5l2.11,1.22l0.29,2.07l1.52,2.28l1.28,0.41l3.61,0.0l5.05,7.75l4.03,4.0l10.92,6.85l12.04,11.54l5.61,4.05l-0.67,5.58l0.5,8.42l-1.16,3.31l-2.8,2.79l-8.01,6.16l-2.74,3.31l-1.69,4.63l-0.07,4.75l-0.66,3.99l-4.71,3.86l-1.51,2.76l-3.19,1.98l-0.64,0.78l-0.84,2.23l-1.12,1.21l-1.5,0.17l-2.13,-1.15l-2.42,-3.5l-1.63,-0.58l-1.7,0.48l-2.83,2.23l-1.99,-0.42l-1.55,-1.71l-2.06,-4.83l0.35,-2.9l-0.25,-0.36l-3.0,-1.07l-1.05,-2.04l-1.94,-2.43l-2.5,-0.55l-2.58,0.6l-3.39,1.32Z",name:"Narathiwat"},"TH-95":{path:"M376.84,1564.29l5.6,-0.15l3.05,-1.42l0.85,-0.76l0.73,-1.01l0.35,-1.44l-0.33,-4.62l0.79,-5.54l0.6,-0.92l1.35,-0.97l3.17,-1.28l6.11,-1.49l3.52,-5.54l2.23,-2.55l2.4,-3.7l0.24,-1.46l-0.41,-3.79l1.5,0.79l2.52,2.17l1.6,0.83l2.03,-0.03l2.36,0.6l2.22,-0.13l1.94,-0.75l3.04,-2.53l1.15,-1.48l1.45,-3.08l0.92,-0.8l0.0,2.34l0.77,3.13l-0.27,3.0l2.21,3.89l1.08,1.12l1.23,0.25l3.47,-1.35l5.45,-1.05l4.12,0.18l4.28,-2.57l1.19,-0.26l0.68,0.39l2.56,4.05l1.32,1.04l1.41,0.26l3.47,-1.23l1.01,1.27l-0.16,0.64l-6.46,7.97l-1.53,1.5l-5.52,0.81l-4.43,1.44l-0.96,0.87l-3.38,16.61l-0.32,4.25l-2.33,2.65l0.04,0.75l1.8,4.15l4.0,2.97l0.86,1.38l0.82,3.66l0.89,0.87l2.14,1.18l0.78,1.43l-0.2,8.25l1.28,2.82l-0.22,4.41l0.45,1.54l-11.26,4.37l-3.86,2.49l-4.11,1.96l-4.21,0.76l-3.44,1.79l-1.54,5.18l-0.33,2.42l-0.89,2.11l-1.33,1.86l-1.62,1.54l-5.0,3.02l-2.82,0.89l-1.54,-0.72l-2.85,-5.36l-2.18,-2.5l-2.58,-1.69l-3.15,-0.13l-0.89,-0.35l-3.26,-5.41l-0.18,-1.09l0.23,-1.14l5.09,-10.12l1.64,-1.05l4.25,-1.19l1.06,-2.21l0.97,-5.75l0.17,-6.17l0.55,-4.43l-0.91,-2.34l-3.59,-3.0l0.09,-2.19l1.32,-1.64l1.44,-0.69l1.12,-1.19l0.2,-2.65l-0.34,-2.43l-0.72,-1.41l-1.6,-0.67l-5.09,1.04l-1.62,-0.53l-3.77,-2.89l-2.28,0.55l-2.77,2.96l-1.83,0.47l-5.91,-1.3l-1.51,0.45l-0.72,0.74l-0.99,-2.16l0.08,-3.75Z",name:"Yala"},"TH-58":{path:"M60.36,324.25l-14.78,-13.63l-1.62,-2.76l-0.46,-4.0l-0.99,-1.21l-2.56,-2.13l-1.13,-2.79l-2.44,-2.45l-0.53,-0.97l1.91,-0.26l0.33,-0.5l-1.43,-5.17l0.62,-1.51l3.0,-5.22l3.3,-2.27l0.48,-0.98l-0.76,-2.69l-0.83,-1.23l-2.13,-5.58l-2.09,-1.15l-0.72,0.05l-0.02,-1.08l0.59,-1.94l-0.28,-1.32l-0.98,-1.99l-0.39,-3.02l-6.0,-8.38l-1.11,-2.16l0.21,-0.72l1.65,-0.85l0.82,-1.73l0.09,-2.21l-0.7,-1.84l-1.62,-1.02l-5.75,-2.22l-1.23,0.29l-0.42,0.39l-2.07,5.47l-1.15,1.36l-4.24,-2.83l-2.11,-2.11l-1.45,-2.39l-0.6,-2.66l-0.47,-5.22l-2.74,-4.22l-2.47,-5.1l-0.48,-1.71l-1.23,-2.13l-2.64,-2.72l2.26,0.28l0.8,0.52l2.95,5.1l1.31,0.86l1.31,0.21l2.76,-0.48l5.02,0.13l4.44,-2.06l7.5,-4.92l1.99,-0.65l5.79,0.14l5.06,-1.39l0.74,0.06l0.45,-0.36l0.7,-1.39l0.86,-4.66l-0.77,-4.56l-1.23,-4.47l-0.93,-8.67l-1.33,-4.19l0.31,-3.9l-0.55,-1.58l-6.15,-5.46l-0.33,-1.01l3.22,-2.54l1.62,-1.76l0.8,-1.84l0.69,-4.25l1.1,-1.97l6.73,-5.12l1.54,-1.73l0.83,-1.85l0.47,-8.81l-0.31,-2.18l-0.88,-2.25l-3.84,-3.36l-0.47,-0.8l0.29,-0.81l1.91,-0.03l1.22,-0.44l1.06,-2.77l-2.49,-4.04l-1.69,-6.51l3.49,-4.71l3.57,-3.12l1.03,-1.34l0.75,-1.85l-0.84,-2.64l-0.12,-4.1l0.79,-1.15l3.98,-0.59l6.75,-3.33l3.43,-3.48l2.18,-0.32l1.12,-0.54l0.6,-1.57l0.03,-1.99l-0.9,-4.14l-0.11,-1.98l1.43,-7.28l0.61,-1.31l1.89,-0.43l2.95,3.36l1.6,0.48l2.62,-0.43l2.1,1.16l4.28,3.86l4.43,1.55l0.41,0.89l-0.13,2.21l0.28,1.29l2.16,1.63l3.13,-0.55l4.75,-2.23l4.26,-0.07l5.11,0.48l4.9,-0.16l3.65,-1.86l0.26,3.22l1.28,2.38l2.49,2.41l3.92,2.62l0.3,3.04l0.72,2.46l1.66,1.95l0.25,3.15l0.53,0.7l1.35,0.73l1.37,2.05l0.09,0.85l-0.86,3.93l-0.01,3.8l-0.84,2.41l0.28,1.35l1.14,1.93l0.62,7.74l-2.42,9.21l0.94,1.61l3.0,2.72l2.68,4.43l0.55,2.8l-0.38,1.89l-1.12,2.55l-2.44,1.74l-3.49,0.47l-4.05,1.56l-4.4,-1.17l-2.36,-0.23l-1.11,0.76l-1.14,2.34l-0.41,0.22l-1.36,-1.06l-2.71,-1.09l-3.7,-0.55l-3.42,0.18l-1.82,-0.52l-0.76,-0.64l-3.23,-4.56l-2.56,-2.04l-1.28,-2.8l-1.75,-1.9l-1.05,-0.75l-1.67,-0.41l-1.79,-1.46l-2.55,0.04l-1.78,1.32l-1.43,0.47l-1.16,4.49l-3.09,2.67l-0.1,1.18l1.43,3.12l-0.01,0.75l-2.57,5.13l0.17,1.47l1.4,3.87l-0.17,3.11l-0.96,3.32l-3.13,6.95l0.22,1.98l1.49,4.19l0.55,0.44l1.58,0.0l0.19,0.29l-0.13,1.33l-1.17,3.48l0.18,7.2l-1.11,2.08l-0.02,0.7l1.59,2.95l0.31,1.42l0.05,3.73l-0.46,2.17l0.26,0.86l4.69,6.22l3.0,1.28l2.35,1.59l0.08,0.5l-0.57,0.92l-0.59,0.31l-1.85,-0.44l-0.95,0.25l-0.54,0.69l-1.51,4.07l-4.98,4.31l-0.85,1.41l0.03,1.64l0.44,1.33l1.44,1.13l0.13,0.44l-1.48,3.21l-1.45,5.41l1.3,1.72l0.42,1.17l0.16,3.92l-0.49,2.2l0.51,1.72l1.68,2.77l0.21,1.7l-0.19,0.87l-1.98,1.07l-1.19,1.55l-1.36,4.44l-0.0,1.28l1.13,4.08l1.0,1.42l2.3,2.11l3.56,2.08l5.52,6.88l2.23,1.5l0.84,0.96l0.69,1.32l0.04,0.81l-1.86,1.87l-0.11,2.0l-1.25,0.88l-0.03,1.31l1.49,2.44l0.83,2.63l1.46,1.25l4.94,2.0l-4.53,0.96l-1.39,0.61l-2.23,1.71l-1.94,2.13l-7.45,-0.12l-1.11,0.28l-13.36,6.26l-1.93,1.49l-1.16,0.4l-4.61,0.2l-1.71,1.43Z",name:"Mae Hong Son"},"TH-13":{path:"M385.75,696.31l0.22,21.24l-1.02,7.55l-7.08,1.38l-17.07,2.04l-1.58,-0.21l-8.46,-2.48l-3.67,-0.59l-4.89,0.15l-1.28,-0.28l-2.13,-1.34l-7.1,-2.76l-3.11,-0.56l-1.98,-1.15l-2.12,-4.41l-0.35,-3.34l1.4,-3.84l11.43,-0.04l4.12,0.35l3.32,-1.36l2.88,1.13l5.48,-1.16l1.87,-0.75l1.29,-1.65l2.67,-2.25l22.59,-10.52l0.93,0.06l1.89,1.42l1.75,3.4Z",name:"Pathum Thani"},"TH-12":{path:"M324.77,707.41l-0.45,1.77l-0.81,1.5l-0.19,2.53l0.42,1.99l2.47,4.9l2.1,1.1l3.11,0.56l7.04,2.74l2.18,1.36l1.51,0.32l4.31,-0.14l-3.05,10.41l-2.66,2.77l-0.45,2.18l-0.34,0.42l-1.0,0.31l-4.96,-0.6l-10.14,0.17l-3.05,-7.13l-1.8,-3.22l-0.37,-3.62l0.93,-4.34l-0.05,-1.41l-0.71,-1.76l-2.61,-3.7l0.14,-1.42l1.49,-3.42l0.49,-4.53l1.52,-1.81l0.86,-0.14l2.5,0.67l1.58,1.53Z",name:"Nonthaburi"},"TH-11":{path:"M338.21,775.11l-0.71,-7.26l0.28,-1.63l1.88,-0.58l1.48,-1.44l0.79,-4.53l-0.22,-2.63l1.26,0.49l0.82,-0.1l1.9,-1.97l1.39,-0.24l1.28,-2.28l0.87,-0.42l0.76,-0.09l0.71,0.82l0.83,0.37l0.06,0.86l-1.24,2.02l0.13,0.53l2.34,1.23l6.39,0.36l1.8,-0.28l1.13,-1.05l1.79,-4.79l0.7,-0.35l4.57,-0.28l2.64,0.29l1.95,1.14l3.11,1.09l3.03,-0.07l7.15,2.63l1.8,1.03l0.69,2.05l-0.08,0.55l-1.72,1.79l-1.11,1.82l-1.46,0.41l-0.47,0.53l-0.29,2.99l-0.59,0.42l-1.22,0.1l-0.79,0.59l-1.16,2.66l-0.54,3.15l-1.4,1.12l-0.5,0.88l-2.68,-0.79l-4.57,-0.56l-2.39,-0.97l-7.54,-1.02l-3.18,-1.18l-4.24,-2.98l-1.88,-0.75l-0.17,-0.54l0.99,-3.73l-0.11,-1.83l-0.32,-0.36l-0.44,0.2l-1.22,2.33l-0.42,1.87l0.11,4.56l-0.79,1.34l-2.0,0.89l-9.17,1.6Z",name:"Samut Prakan"},"TH-10":{path:"M331.32,775.77l0.76,-1.01l0.16,-1.04l-0.71,-5.31l-1.7,-5.77l-0.62,-1.15l-1.35,-1.4l-2.04,-0.77l-0.72,-1.65l-2.03,-10.3l0.68,-2.42l0.22,-2.44l10.01,-0.17l5.01,0.6l1.43,-0.45l0.63,-0.78l0.4,-2.08l2.71,-2.87l3.13,-10.67l3.3,0.53l8.42,2.47l1.82,0.24l17.15,-2.05l6.9,-1.33l-0.8,10.97l0.52,1.15l1.81,1.31l0.55,1.01l-3.19,3.84l-4.78,7.53l-0.16,0.77l0.49,1.06l-2.26,0.02l-5.94,-2.39l-6.58,0.13l-1.29,0.68l-2.23,5.39l-1.82,0.4l-6.27,-0.35l-1.74,-0.9l1.13,-1.86l-0.14,-1.51l-1.11,-0.65l-0.68,-0.82l-1.48,0.04l-1.16,0.61l-1.3,2.27l-1.26,0.15l-1.84,1.94l-1.59,-0.51l-0.83,0.5l0.17,2.85l-0.73,4.3l-1.19,1.09l-2.18,0.84l-0.34,2.06l0.73,7.38l-3.61,0.63l-2.49,-0.11Z",name:"Bangkok Metropolis"},"TH-17":{path:"M318.74,600.57l-1.51,-3.71l1.39,-0.82l0.75,-0.95l0.33,-1.11l-0.12,-2.29l1.19,-0.7l3.24,0.77l0.57,0.48l0.67,1.57l-0.36,1.89l1.7,3.28l1.86,1.16l6.16,2.5l-0.42,0.63l-0.02,0.93l1.3,1.59l1.24,6.07l-0.8,2.66l-1.91,2.31l-0.05,1.48l1.91,5.8l0.45,0.79l1.71,1.52l0.47,1.05l0.86,6.39l0.9,2.89l-1.51,2.49l-4.6,-0.53l-1.6,-2.26l-2.97,0.04l-1.72,-1.39l-1.92,-0.97l-1.14,-1.96l-0.82,-0.57l-0.93,-0.03l-2.91,0.91l-0.67,-0.06l-1.83,-0.97l-1.29,-0.13l-3.75,0.7l-1.82,-2.55l-0.19,-0.86l0.98,-1.4l0.28,-1.14l0.15,-6.26l-0.24,-0.75l-0.47,-0.27l-1.41,0.33l-0.67,-0.28l-0.51,-0.69l-0.05,-0.69l1.13,-1.47l0.63,-1.43l4.32,0.35l1.68,-0.26l1.85,-1.45l2.19,-3.2l0.32,-1.3l-0.67,-1.16l-1.3,-0.92l-2.19,-0.65l0.36,-1.68l0.55,-0.8l2.27,-0.86l0.67,-2.1l-0.13,-0.44l-1.6,0.48Z",name:"Sing Buri"},"TH-16":{path:"M427.83,575.86l-0.2,2.59l-2.16,4.12l0.22,4.61l-0.33,8.97l0.34,3.36l1.2,0.56l2.39,-0.12l2.79,1.83l1.63,0.57l2.93,0.31l1.56,2.2l1.06,3.64l4.77,9.49l0.44,1.62l0.03,3.24l-0.42,1.12l-4.54,2.93l-1.83,0.74l-1.32,1.22l-3.2,1.42l-0.64,0.9l-0.8,2.8l-0.62,0.84l-2.03,0.95l-1.31,1.32l-1.36,0.43l-0.75,1.17l-4.9,-1.22l-1.3,-1.0l-2.47,-0.61l-0.16,-1.17l-1.0,-2.16l-1.26,-1.13l-2.44,-0.94l-1.31,-3.03l-0.6,-0.75l-5.46,-1.67l-5.07,1.3l-5.3,3.2l-0.64,1.27l0.22,1.29l-0.27,0.88l-3.19,3.55l-3.68,0.02l-1.61,-2.09l-2.24,-0.81l-0.57,-0.65l-0.35,-1.47l-0.02,-4.18l-0.82,-1.37l-2.15,-1.79l0.16,-1.34l-0.31,-0.77l-1.27,-0.37l-3.06,1.23l-1.76,0.01l-0.88,0.45l-0.4,0.62l-0.35,2.05l-2.29,1.04l-0.28,2.06l-2.14,3.13l-1.54,3.0l-10.96,6.73l-0.95,1.13l-1.65,3.7l-3.56,-0.9l-1.62,-1.34l-1.73,-0.17l-4.1,-3.13l-0.97,-1.62l1.36,-2.08l0.28,-1.01l-0.91,-2.88l-0.87,-6.45l-0.61,-1.33l-2.07,-2.16l-1.85,-5.58l-0.01,-1.03l1.81,-2.14l0.56,-1.12l0.41,-1.99l-1.27,-6.35l-1.28,-1.54l0.01,-0.51l1.73,-3.09l2.83,-3.22l1.17,-2.91l0.06,-3.47l0.57,-0.72l2.5,-1.44l0.95,-0.9l0.75,-3.81l2.59,-3.59l1.6,-1.62l1.74,-0.92l3.01,-3.66l11.96,-10.97l1.79,-2.21l0.76,-1.85l-0.12,-1.53l-0.89,-3.08l8.87,1.86l5.34,1.53l5.7,-1.45l2.99,-0.41l2.18,0.06l5.91,4.16l1.47,1.7l1.89,0.49l2.29,-0.25l3.49,2.82l1.27,0.64l3.01,0.35l4.5,-1.37l3.73,0.72l0.93,0.9l0.81,1.72l0.51,3.07l0.96,1.54l3.99,3.29Z",name:"Lop Buri"},"TH-15":{path:"M332.23,637.19l1.06,1.92l0.55,0.34l4.85,0.59l1.09,1.79l2.9,2.33l-0.2,1.24l0.31,1.29l-0.36,3.08l-1.38,5.82l-0.85,1.53l0.63,2.5l0.36,8.04l-0.23,1.59l-2.67,1.6l-2.45,-0.78l-2.14,0.09l-0.12,-5.24l-0.55,-1.25l-0.74,-0.49l-2.68,0.33l-2.17,1.09l-1.77,-0.03l-2.43,0.52l-3.48,-0.64l-2.4,0.93l-3.76,0.11l-2.86,-2.95l-1.8,-5.09l0.08,-0.66l1.48,-1.13l0.59,-1.1l-1.26,-2.45l1.57,-2.2l0.57,-2.44l-0.99,-3.45l0.48,-2.87l-1.08,-4.67l0.56,-1.95l1.63,-1.71l3.71,-0.71l1.13,0.11l1.75,0.94l0.98,0.1l3.58,-0.91l1.65,2.36l2.02,1.05l1.76,1.41l0.91,0.21l2.14,-0.2Z",name:"Ang Thong"},"TH-14":{path:"M318.32,705.83l0.0,-3.26l-0.75,-1.4l-2.08,-0.69l-3.62,-0.46l2.61,-3.51l0.75,-1.57l-0.05,-2.68l2.19,-8.4l0.77,-6.34l0.05,-2.32l-2.58,-4.59l-0.41,-4.24l2.37,-0.19l2.25,-0.92l3.49,0.64l2.5,-0.53l1.79,0.03l2.29,-1.12l2.19,-0.32l0.75,1.1l-0.02,4.57l0.56,1.28l2.38,-0.06l2.64,0.79l3.19,-1.83l0.44,-2.16l-0.36,-8.1l-0.63,-2.36l0.81,-1.36l1.4,-5.91l0.38,-3.23l-0.19,-2.04l0.89,0.55l1.6,0.13l2.2,1.57l2.99,0.67l-1.85,5.28l-0.16,1.77l1.65,1.74l0.86,2.19l1.19,0.87l2.05,0.37l2.84,-0.29l5.77,-2.25l5.02,0.05l1.91,0.65l-0.11,3.17l-0.25,0.45l-1.13,0.63l-0.17,0.6l1.32,3.49l-0.86,4.02l0.36,3.84l0.45,1.05l2.11,1.76l0.61,0.92l-0.37,2.82l-0.94,2.37l0.18,1.21l1.04,0.49l2.19,-0.05l0.81,0.51l0.33,0.73l0.11,6.88l-17.81,8.37l-2.85,2.39l-1.3,1.65l-1.53,0.56l-5.26,1.13l-2.89,-1.13l-3.37,1.37l-4.04,-0.35l-11.59,0.04l-1.8,-1.72l-2.87,-0.77l-1.24,0.21l-1.15,1.21Z",name:"Phra Nakhon Si Ayutthaya"},"TH-71":{path:"M88.91,599.79l-0.77,-2.43l0.46,-1.99l2.22,-3.83l0.58,-2.14l-1.38,-3.48l-0.05,-0.8l3.7,0.17l2.08,-0.92l1.76,-1.7l3.74,-5.31l1.09,-0.24l2.35,0.38l1.9,0.73l3.68,2.23l1.69,0.66l1.02,-0.21l0.56,-1.12l-0.04,-1.85l-0.41,-0.79l-1.38,-0.97l0.54,-1.16l1.76,-1.48l0.13,-1.13l-0.43,-1.82l0.06,-0.65l0.48,-0.33l3.88,-0.83l3.68,-1.69l4.17,2.1l1.48,1.61l0.34,2.29l0.7,0.21l2.86,-3.26l1.08,-5.39l-0.19,-5.68l-2.54,-16.55l0.1,-7.52l3.76,1.53l3.27,2.41l1.46,0.3l1.49,1.0l1.66,0.15l7.72,11.87l0.19,0.73l-1.11,0.68l0.41,1.16l4.29,2.92l1.18,3.75l3.17,2.67l3.17,5.24l4.42,5.5l2.01,4.1l4.93,2.57l4.47,3.48l0.56,2.87l0.09,3.23l0.68,2.72l-0.29,1.76l0.08,2.42l1.17,2.93l6.05,4.91l1.27,2.0l0.65,0.41l2.81,-0.17l3.98,-0.92l2.9,1.29l2.69,-0.2l4.57,1.48l1.0,0.6l1.35,0.13l2.94,-0.7l0.99,0.85l0.85,1.53l0.84,2.69l0.49,4.19l-0.28,1.95l-2.63,3.01l0.06,1.49l0.7,1.93l1.31,0.84l1.56,-0.44l0.88,0.18l4.34,5.61l2.16,1.91l3.63,-0.98l2.28,1.0l0.67,2.11l-0.26,0.82l-0.69,0.73l-0.04,0.86l2.57,3.72l1.01,0.26l4.11,-1.01l0.73,-0.55l0.96,-1.65l1.19,-0.87l0.89,-1.86l0.85,-5.83l1.68,0.76l1.32,-0.11l2.85,0.58l1.32,-0.4l1.97,-1.51l2.99,-0.04l1.94,0.82l6.24,7.45l3.38,2.73l1.96,2.72l3.92,1.86l2.6,0.46l2.32,1.96l-0.29,1.26l-1.78,1.24l-0.23,1.1l0.9,1.42l3.01,2.15l0.87,1.15l-0.89,1.16l-3.3,1.81l-1.93,0.68l-0.91,0.89l-0.78,20.26l0.59,4.34l-0.2,5.46l-1.21,3.97l-4.67,4.34l-0.3,0.82l0.84,7.13l0.51,0.77l1.55,0.21l1.31,1.27l0.8,2.19l-0.39,2.88l0.57,1.57l1.57,2.32l2.43,1.1l1.28,3.05l1.71,0.96l0.22,0.84l-0.88,0.49l-0.56,0.91l-2.9,7.05l-1.46,0.62l-0.8,0.91l-1.23,3.43l-0.82,0.67l-3.58,0.18l-2.07,-0.46l-5.88,-0.49l-1.85,0.28l-6.1,2.51l-4.08,0.78l-3.59,3.45l-0.97,0.36l-2.27,-0.6l-1.55,-0.9l-1.88,-2.65l-1.09,-0.59l-0.73,0.16l-2.32,1.73l-11.31,3.49l-1.83,-0.44l-2.85,-1.62l-2.45,0.97l-2.72,-0.79l-1.13,0.68l-1.1,1.44l-3.09,1.9l-5.78,0.71l-3.98,-4.11l-0.78,-1.68l-1.21,-5.2l0.26,-4.01l-0.29,-0.94l-1.17,-1.39l-2.03,-0.69l-1.41,-2.91l-3.45,-2.59l-0.92,-1.21l-2.43,-4.53l-3.43,-4.12l-0.55,-1.91l-0.24,-2.48l-1.14,-1.96l-2.14,-1.39l-4.83,-1.74l-12.8,-9.64l-2.39,-2.52l-2.88,-5.3l-1.04,-0.15l-1.4,0.43l-1.45,-0.05l-2.69,-2.96l-3.32,-1.12l-2.2,-1.73l-4.89,-6.15l-7.52,-15.33l-2.82,-1.42l-0.7,-1.37l-0.58,-2.63l-0.96,-2.45l-1.46,-2.25l-13.11,-12.63l-5.83,-9.22l-0.8,-2.0l0.34,-2.3l-1.81,-2.19l-0.06,-6.31l-0.76,-2.51l-2.53,-4.85l0.02,-1.29l1.4,-3.12l-0.58,-2.63l-3.39,-3.59Z",name:"Kanchanaburi"},"TH-70":{path:"M195.36,750.7l5.6,-0.7l3.29,-2.02l1.83,-1.95l2.69,0.8l2.23,-0.97l2.68,1.56l2.27,0.49l11.5,-3.54l2.61,-1.83l0.63,0.34l0.91,1.6l1.1,1.16l1.75,1.01l2.62,0.64l1.39,-0.54l3.45,-3.37l3.97,-0.73l6.05,-2.49l1.56,-0.26l5.89,0.49l2.11,0.46l3.91,-0.23l1.24,-1.07l1.41,-3.69l2.01,-1.15l3.29,-7.78l0.94,-0.52l0.89,0.08l4.39,1.17l1.08,0.72l0.51,0.9l0.33,1.23l-0.01,2.8l1.13,3.81l-0.12,1.63l-1.02,3.27l0.47,2.8l-0.76,3.14l0.45,1.21l1.66,2.16l1.46,0.6l1.93,-0.62l2.93,-2.44l0.51,0.23l0.89,1.66l-0.13,2.14l0.31,0.66l0.89,0.45l2.69,0.29l0.55,0.66l-0.23,4.91l-0.11,0.78l-2.2,2.2l-0.64,1.31l-1.21,10.06l-2.71,-0.16l-1.42,0.88l-2.31,0.7l-5.15,-2.14l-1.11,0.18l-0.46,0.47l-2.45,5.3l-0.16,4.4l-2.1,4.37l-1.47,5.43l-6.68,-0.09l-3.22,-0.4l-6.86,2.43l-3.92,4.48l-0.05,4.73l-0.35,1.44l-0.88,0.83l-1.94,0.8l-5.64,0.87l-5.87,-0.72l-1.22,0.52l-1.58,1.55l-2.67,-1.02l-2.23,0.93l-4.43,-1.53l-1.47,-1.22l-2.35,-0.66l-1.69,-1.41l-1.27,-0.42l-0.96,0.04l-2.85,2.88l0.06,3.22l-0.3,0.77l-3.24,2.1l-0.99,0.31l-0.67,-0.26l-1.67,-3.36l-1.4,-1.04l-5.73,-2.69l0.28,-1.86l-1.81,-6.39l-0.06,-1.34l1.53,-3.19l-0.36,-3.2l0.55,-5.46l-0.1,-2.18l-3.89,-17.12l-0.27,-9.21l0.36,-2.54l-0.03,-2.89l-0.36,-0.67Z",name:"Ratchaburi"},"TH-19":{path:"M416.19,636.2l1.52,19.15l-1.73,2.82l-0.43,1.87l0.47,0.95l2.01,1.45l1.29,2.16l2.22,2.31l-0.9,0.89l-0.67,3.36l-1.47,2.02l-0.98,2.75l0.12,2.44l-2.61,2.3l-1.69,0.37l-1.41,-1.94l-2.46,-1.73l-0.96,-0.27l-3.56,-0.0l-2.09,-2.48l-1.05,-0.23l-0.5,0.78l0.04,3.06l-1.99,3.01l0.25,1.32l-0.3,0.99l-1.12,1.37l-3.91,2.78l-1.21,-1.24l-0.65,-0.23l-1.93,0.26l-0.61,0.4l-0.39,0.76l0.46,2.83l-0.58,1.53l-3.11,3.51l-1.57,-3.05l-2.31,-1.74l-1.46,-0.05l-4.08,1.83l-0.32,-7.25l-0.37,-0.59l-1.08,-0.68l-2.37,0.01l-0.54,-0.31l1.16,-3.54l0.2,-2.37l-0.81,-1.33l-2.05,-1.7l-0.29,-0.64l-0.36,-3.72l0.86,-4.1l-1.32,-3.47l1.07,-0.67l0.46,-0.81l0.28,-2.37l-0.33,-1.53l-2.43,-0.92l-5.19,-0.05l-1.65,0.42l-4.2,1.84l-3.5,0.21l-1.79,-0.88l-0.82,-2.14l-1.51,-1.37l0.12,-1.48l1.98,-5.64l1.75,-3.93l0.8,-0.93l9.68,-5.69l1.31,-1.07l1.65,-3.13l2.17,-3.19l0.32,-0.8l-0.07,-1.18l2.19,-0.93l0.54,-2.36l0.41,-0.47l2.03,-0.07l2.48,-1.13l1.09,0.03l0.07,1.99l2.25,1.92l0.66,1.13l-0.04,3.94l0.44,1.78l0.89,0.99l2.15,0.76l1.75,2.2l2.96,0.18l1.51,-0.28l3.44,-3.83l0.38,-1.22l-0.22,-1.28l0.34,-0.71l5.14,-3.09l4.7,-1.23l5.0,1.51l1.79,3.66l2.7,1.13l0.95,0.86l0.9,1.96l0.1,1.23Z",name:"Saraburi"},"TH-72":{path:"M209.52,609.3l1.01,-2.54l0.62,-3.15l1.72,-1.67l0.95,-0.4l2.73,2.35l6.15,1.79l1.35,3.78l10.61,2.23l2.78,1.79l8.04,2.26l2.19,-0.31l0.24,-1.36l-0.68,-3.03l2.22,-0.7l1.79,0.57l3.92,2.12l2.2,0.81l7.76,1.06l7.99,3.29l8.35,0.81l2.41,0.63l2.86,-0.54l3.55,-1.22l1.35,-0.76l0.87,-1.06l-0.47,-1.87l0.28,-0.51l7.31,1.76l2.01,2.05l0.88,0.5l1.83,-0.4l5.02,-2.61l-1.44,2.13l-0.11,0.73l0.2,0.71l1.2,1.23l1.9,-0.14l0.09,0.29l-0.16,6.04l-1.27,2.62l0.3,1.25l1.8,2.53l-1.62,1.76l-0.66,2.25l1.09,4.85l-0.48,2.83l0.98,3.34l-0.49,2.13l-1.5,1.9l-0.16,0.61l1.26,2.36l-0.38,0.69l-1.56,1.23l-0.2,1.19l2.25,5.92l2.79,2.72l1.18,0.22l0.43,4.39l2.58,4.59l-0.82,8.29l-2.2,8.43l0.07,2.57l-0.65,1.37l-2.9,3.9l-5.33,2.5l-1.31,1.44l-3.1,-0.33l-11.46,0.31l-4.15,-0.48l-6.44,3.95l-5.23,4.89l-1.5,0.31l-5.33,0.07l-0.87,-2.27l-1.6,-1.49l-1.53,-0.25l-0.9,-7.06l4.86,-4.8l1.31,-4.27l0.2,-5.6l-0.59,-4.32l0.72,-19.93l5.82,-3.02l1.27,-1.72l-0.37,-1.08l-3.77,-2.94l-0.68,-1.08l0.1,-0.36l1.83,-1.31l0.46,-1.01l-0.12,-1.01l-2.68,-2.33l-2.69,-0.5l-3.7,-1.73l-1.87,-2.64l-3.4,-2.75l-6.29,-7.49l-1.1,-0.69l-1.29,-0.33l-3.3,0.06l-1.88,1.42l-1.23,0.46l-2.76,-0.58l-1.15,0.14l-1.2,-0.69l-1.1,-0.0l-0.69,1.23l0.1,1.77l-1.18,4.64l-1.41,1.15l-1.13,1.82l-4.46,1.05l-2.36,-3.32l1.0,-2.17l-0.21,-1.4l-0.72,-1.38l-1.42,-0.84l-1.37,-0.36l-3.34,1.02l-1.86,-1.66l-4.5,-5.76l-1.4,-0.32l-1.47,0.43l-0.66,-0.45l-0.68,-2.74l2.57,-2.89l0.37,-2.34l-0.5,-4.3l-0.87,-2.81l-0.77,-1.55l-1.09,-0.96Z",name:"Suphan Buri"},"TH-75":{path:"M282.58,797.74l-1.41,0.4l-1.79,1.59l-2.04,-0.32l-0.84,0.31l-1.04,2.73l-0.0,1.12l-1.7,-0.89l-1.51,-2.23l0.62,-4.15l-0.57,-2.27l1.49,-5.54l2.13,-4.44l0.16,-4.39l1.81,-3.51l0.28,-1.13l0.58,-0.7l5.74,2.1l2.62,-0.76l1.33,-0.84l2.69,0.18l4.11,5.31l1.14,2.74l-3.51,1.26l-1.68,1.2l-1.81,3.85l-1.92,-0.52l-0.48,0.25l0.22,0.5l1.29,0.56l-0.15,1.57l-0.77,1.58l-1.23,1.11l-3.34,1.31l-0.41,2.01Z",name:"Samut Songkhram"},"TH-73":{path:"M317.52,707.0l-0.35,3.95l-1.61,3.95l-0.16,1.75l1.03,1.93l1.68,2.05l0.62,1.49l0.06,1.11l-0.94,4.43l0.24,3.21l5.12,11.32l-0.24,2.64l-0.69,2.48l0.48,2.29l-0.81,0.68l-5.36,1.93l-0.23,0.44l0.18,1.22l-1.03,1.23l0.18,1.62l-4.91,0.63l-1.09,-0.51l-1.77,-1.51l-8.6,-0.32l-3.36,-0.58l-0.89,-0.92l-2.85,-0.32l-0.51,-0.36l0.07,-2.38l-1.0,-1.86l-0.76,-0.49l-0.7,0.0l-0.62,0.41l-2.79,2.33l-1.17,0.27l-0.89,-0.38l-1.85,-2.78l0.75,-3.1l-0.47,-2.8l1.0,-3.12l0.14,-1.84l-1.14,-3.94l0.02,-2.73l-0.39,-1.44l-0.65,-1.13l-1.37,-0.93l-5.36,-1.29l-0.47,-1.29l-1.62,-0.85l-1.31,-3.09l-2.45,-1.12l-1.41,-2.09l-0.49,-1.26l0.32,-2.49l5.34,-0.07l1.72,-0.35l5.41,-4.99l6.25,-3.85l3.88,0.53l11.43,-0.31l1.21,0.32l2.1,-0.0l0.72,-0.41l0.86,-1.14l5.21,-2.44l5.75,1.03l0.55,0.94l0.0,4.33Z",name:"Nakhon Pathom"},"TH-77":{path:"M233.08,1050.19l-4.52,0.87l-1.61,1.47l-2.38,0.92l-1.34,1.19l-5.65,-0.35l-1.95,0.27l-1.81,-0.79l-1.39,-0.15l-2.69,0.14l-1.03,0.59l-1.05,0.04l-4.16,-1.1l-7.74,-3.89l-0.57,-0.69l-0.65,-2.68l1.02,-0.82l2.47,-4.28l3.23,-1.31l0.92,-1.03l3.34,-9.9l1.36,-2.39l3.52,-4.25l1.33,-2.5l1.63,-4.37l1.11,-1.63l4.17,-4.56l0.67,-1.82l0.77,-4.62l0.96,-1.66l3.09,-3.11l1.37,-1.88l1.04,-2.24l0.44,-2.02l-0.06,-6.89l0.9,-1.64l1.62,-1.02l2.4,-0.47l4.48,-0.27l1.59,-1.21l7.03,-9.47l0.93,-2.65l1.59,-7.29l-0.5,-1.53l-1.78,-0.51l-3.91,-2.94l-1.28,-1.59l-0.74,-2.27l0.34,-2.13l1.67,-4.39l0.12,-2.54l-0.86,-2.02l-1.63,-1.43l-1.98,-0.64l-1.51,-1.38l0.33,-2.81l2.61,-8.6l-0.47,-1.23l-1.15,-0.62l-1.29,-0.0l-6.11,1.99l-1.16,-0.28l-0.3,-1.57l0.47,-0.87l1.92,-1.84l0.27,-1.9l-1.96,-4.39l0.17,-3.04l-0.3,-1.34l-2.45,-3.33l-0.55,-1.25l-0.66,-8.22l-0.75,-2.49l-2.44,-4.36l-0.43,-2.12l1.85,-4.61l0.32,-2.48l-0.2,-3.74l7.22,-1.96l1.98,-0.27l2.37,0.23l6.28,1.49l2.22,2.2l1.82,0.69l1.52,0.11l1.39,-1.48l2.47,-0.92l1.59,-1.02l4.32,-0.86l3.27,0.47l1.65,-0.11l5.8,-4.5l1.34,-0.63l10.14,-0.05l4.07,-0.82l2.16,10.07l-0.4,6.95l0.41,2.53l3.28,7.89l0.12,1.41l-0.9,1.6l-2.38,8.15l0.1,1.2l2.93,3.39l0.46,1.05l0.65,4.01l-0.42,1.21l-2.21,1.85l-0.81,1.14l-0.73,4.05l-2.77,4.79l-10.82,11.42l-2.67,4.89l-0.91,5.19l1.44,3.91l-0.15,0.28l-1.32,0.13l-0.94,0.53l-0.48,1.16l-0.02,1.31l0.79,4.06l-0.64,2.47l0.43,0.98l-3.63,0.5l-3.17,3.09l-8.81,14.51l-1.03,2.99l-2.13,3.13l-1.07,6.88l-0.67,2.17l-3.52,8.3l-2.03,2.16l-0.58,1.36l-0.33,6.41l0.36,2.37l1.8,4.5l0.0,1.81l-1.26,1.21l-0.58,-1.6l-0.39,-0.26l-1.72,0.05l-2.12,1.34l-2.33,2.82l-1.33,3.32l-0.25,2.19l0.37,2.36l1.58,4.01l0.33,1.84l-0.29,2.08l-0.88,2.17Z",name:"Prachuap Khiri Khan"},"TH-76":{path:"M271.58,794.44l0.49,1.82l-0.57,4.48l1.67,2.48l1.74,1.03l0.68,0.12l0.73,-0.52l-0.07,-1.23l0.82,-2.33l2.52,0.21l0.84,-0.43l1.15,-1.24l1.06,-0.29l0.69,3.4l3.41,4.52l8.14,7.17l1.46,6.13l1.78,4.24l-0.24,1.74l-0.91,1.66l-3.56,4.8l-0.81,1.62l-1.12,3.66l-1.48,7.91l-0.56,1.55l-3.95,6.29l-1.46,4.37l-1.01,4.52l-0.5,4.7l0.03,3.22l-4.1,0.84l-10.33,0.07l-1.57,0.74l-5.63,4.41l-4.64,-0.41l-4.5,0.89l-1.75,1.08l-2.56,0.97l-1.12,1.35l-2.76,-0.7l-2.34,-2.25l-6.46,-1.54l-2.44,-0.24l-2.14,0.28l-7.22,1.96l-0.15,-0.72l-1.17,-1.65l-5.32,-2.95l-2.17,-1.97l-1.53,-2.02l-3.53,-1.33l-0.57,-3.01l-0.63,-1.16l-1.28,-0.79l-3.23,-0.79l-1.01,-1.71l0.03,-4.03l-0.4,-2.27l-0.95,-1.5l-2.93,-3.15l-0.73,-4.45l-1.62,-4.22l0.1,-1.32l1.4,-3.19l-0.32,-2.52l-1.55,-2.19l-6.19,-4.73l-0.47,-1.98l1.5,-4.94l0.32,-2.87l-0.34,-4.52l1.16,-1.64l1.91,-0.72l4.24,-0.47l1.51,-1.25l5.79,2.72l1.24,0.93l1.59,3.28l0.76,0.44l1.03,0.03l4.37,-2.65l0.47,-1.2l-0.12,-2.98l2.62,-2.46l1.4,0.4l1.64,1.38l2.33,0.65l1.55,1.26l4.62,1.58l2.37,-0.93l1.63,0.9l1.24,0.09l1.78,-1.65l0.88,-0.39l5.84,0.72l5.76,-0.89l2.2,-0.91l1.13,-1.1l0.46,-1.78l-0.0,-4.49l1.46,-1.3l1.23,-1.94l0.93,-0.87l6.52,-2.3l3.07,0.41l6.72,0.09Z",name:"Phetchaburi"},"TH-18":{path:"M319.43,601.17l-0.33,1.04l-1.88,0.54l-0.56,0.52l-0.85,2.15l0.02,0.75l0.42,0.6l2.54,0.75l1.18,1.35l-0.21,0.73l-2.14,3.13l-1.57,1.22l-1.3,0.18l-4.78,-0.33l-5.94,3.09l-1.5,0.31l-2.54,-2.46l-4.89,-1.01l-2.16,-0.82l-0.89,0.02l-0.66,0.68l-0.16,0.65l0.45,1.75l-0.48,0.45l-4.7,1.89l-2.53,0.5l-2.4,-0.63l-8.2,-0.78l-7.99,-3.29l-7.33,-1.01l0.34,-1.12l-0.75,-1.75l0.11,-0.82l1.26,-1.66l1.65,-0.52l2.01,-1.92l2.04,-1.18l1.98,-3.55l0.19,-1.22l-1.45,-1.48l-4.51,-7.04l-0.95,-2.53l-0.97,-1.58l-0.73,-4.91l-1.21,-2.79l0.03,-1.18l0.79,-1.17l3.7,-2.31l1.46,0.52l9.19,1.18l0.84,0.41l1.08,1.14l0.9,0.3l5.03,-1.0l1.82,-0.08l2.16,0.39l3.11,-0.24l4.33,1.24l0.9,1.81l1.3,0.24l1.79,-0.87l0.22,-0.44l-0.38,-0.32l-1.25,-0.05l-0.09,-1.26l1.4,-3.19l-0.06,-2.84l-1.93,-3.24l-2.28,-1.79l-0.26,-0.94l0.47,-0.31l2.2,0.04l0.28,-0.47l0.04,-1.64l5.05,0.11l0.99,-0.29l5.42,5.22l3.05,1.17l1.46,0.94l2.14,2.11l3.35,5.07l4.91,12.99l-0.79,0.31l-0.63,0.77l-0.14,3.28l-0.58,0.74l-1.57,0.91l-0.17,0.5l1.82,4.47l0.59,0.19l0.67,-0.34Z",name:"Chai Nat"},"TH-39":{path:"M569.02,362.39l-1.04,0.48l-0.58,0.67l-0.79,2.51l-2.58,1.72l-3.44,0.66l-1.22,1.29l-0.27,1.27l0.27,1.12l3.47,6.99l1.22,1.68l12.84,12.37l-5.1,12.31l-1.68,6.64l-5.35,0.88l-1.47,-1.81l-1.01,-0.72l-3.21,-1.09l-3.87,-0.5l-4.44,1.05l-2.04,-0.38l-1.99,-1.17l-4.56,-1.65l-1.41,-0.21l-1.22,-2.13l-0.36,-1.37l-1.15,-0.6l-0.35,-0.96l-1.56,-1.63l-2.1,-1.06l-1.38,-0.19l-2.0,0.24l-1.29,1.25l-3.17,2.05l-0.95,0.23l-3.44,-0.88l-2.4,-1.28l-3.62,-0.69l-3.7,-0.29l-1.93,-2.89l-1.87,-3.58l-0.02,-0.53l0.93,-0.84l4.48,-1.74l2.45,-2.52l4.37,-1.83l0.36,-1.01l-0.58,-0.74l-1.61,-1.07l-0.77,-1.37l-1.46,-0.99l-0.84,-3.12l-1.39,-1.97l-2.41,-0.77l-2.41,-1.27l-2.15,-0.43l-2.31,-1.4l-1.75,-0.35l-1.24,-0.7l-2.52,-2.88l-0.74,-2.57l0.13,-0.53l3.37,-4.37l0.28,-3.43l3.74,-4.04l0.85,-1.53l-0.46,-2.46l0.19,-2.57l-3.47,-4.26l-0.66,-2.22l0.14,-1.56l0.73,-0.72l1.07,-0.17l4.05,-0.1l2.22,0.35l1.53,-0.33l2.28,-1.21l3.27,-2.36l0.91,-1.96l0.95,-1.21l-0.1,-2.02l-2.04,-6.21l2.54,-3.13l1.23,-0.37l1.52,0.87l1.4,0.01l1.73,-0.97l2.51,-2.38l0.95,-0.06l2.58,1.03l5.91,1.08l1.39,0.84l1.58,0.44l1.51,-0.36l1.64,-0.94l0.37,1.1l-0.16,5.13l1.07,2.58l0.77,4.88l4.03,8.05l0.61,2.08l0.48,3.36l-0.83,2.37l0.31,3.2l0.97,1.33l1.21,0.59l2.7,0.24l0.71,0.87l0.16,1.4l-0.75,1.19l-0.59,2.23l0.05,1.79l2.03,1.19l2.38,3.03l1.1,0.03l2.62,-1.24l2.34,-0.7l2.71,-0.32l0.58,0.22Z",name:"Nong Bua Lam Phu"},"TH-":{path:"M552.96,961.16l0.22,-0.33l0.81,0.05l1.62,-0.91l0.06,-1.02l1.18,0.85l2.43,0.08l-0.12,0.93l-2.01,0.69l-0.23,0.5l0.25,0.74l-1.42,-1.43l-0.99,-0.43l-1.79,0.29ZM370.73,863.12l0.53,-0.04l0.78,-1.14l2.01,-0.04l0.27,1.96l-0.93,0.76l-0.52,1.13l-0.71,0.41l-0.41,-1.36l-1.02,-1.67ZM272.33,1518.77l-1.11,0.22l-0.68,-0.33l0.25,-1.35l0.79,-0.52l0.76,1.98ZM269.27,1152.86l-0.65,-0.54l-0.4,0.12l-0.16,-0.66l1.13,-2.39l-0.08,-0.78l-0.59,-0.91l0.15,-0.93l0.98,0.28l0.58,-0.31l1.21,3.37l-0.51,0.36l-1.2,2.21l-0.45,0.19ZM245.1,1478.26l-3.81,-1.01l-1.52,-2.41l3.13,1.25l2.19,2.17ZM212.15,1540.41l-1.09,0.21l-0.83,-0.59l-1.29,-5.13l0.38,-0.51l3.18,0.64l1.13,1.44l-0.22,2.62l-0.65,1.03l-0.61,0.27ZM176.18,1396.42l0.31,0.3l1.58,0.1l-0.07,1.05l-1.12,1.16l0.5,2.43l-4.2,-5.26l-0.77,-0.45l0.58,-0.85l0.59,-0.2l1.33,0.26l1.14,0.82l0.14,0.64ZM117.95,1179.18l0.92,-0.72l0.17,-1.4l-0.51,-1.24l0.94,-1.04l0.86,0.84l0.82,0.22l-0.64,1.49l0.33,2.21l-0.89,0.49l-0.31,2.06l-0.57,-0.42l-0.6,0.1l-0.38,-0.44l-0.13,-2.14ZM109.71,1423.18l0.14,-1.52l0.57,-0.58l0.7,-0.03l-1.42,2.14ZM100.54,1249.7l-0.84,0.58l-0.21,-0.34l0.08,-2.01l4.19,-6.44l0.42,-0.0l0.24,0.53l-2.61,4.36l0.31,1.31l-1.59,2.02ZM31.4,1308.32l0.13,1.24l-0.98,-2.3l0.92,-0.59l-0.08,1.65Z",name:""},"TH-74":{path:"M317.17,752.8l5.78,-2.2l1.38,7.25l0.87,2.0l2.16,0.86l1.71,2.2l1.68,5.7l0.69,5.19l-0.2,0.82l-0.81,1.1l-4.6,0.12l-2.05,0.82l-4.93,-2.46l-1.57,-1.26l-0.6,0.13l-1.07,2.06l-1.19,1.21l-1.67,0.89l-9.35,3.66l-4.02,0.82l-2.29,1.02l-1.19,-2.84l-4.18,-5.41l1.2,-10.14l0.5,-1.02l2.34,-2.47l0.35,-5.56l3.16,0.54l8.38,0.29l1.61,1.42l1.46,0.63l4.65,-0.47l1.14,-0.67l-0.21,-1.73l0.97,-1.06l-0.09,-1.43Z",name:"Samut Sakhon"},"TH-84":{path:"M296.18,1206.63l0.4,1.17l-1.07,1.19l-0.9,3.1l-0.35,3.52l-0.78,2.64l-2.97,1.41l-0.8,2.37l-0.51,0.27l-1.64,-0.05l-5.88,0.76l-0.5,-1.67l-0.44,-4.02l-1.05,-2.03l1.53,-2.04l-0.2,-2.15l-1.37,-3.65l0.85,-1.0l2.32,-0.31l2.66,0.19l6.53,1.62l2.02,-0.35l1.02,-2.01l1.12,1.04ZM286.82,1182.41l4.07,0.19l3.28,2.08l1.25,3.47l1.04,7.45l-3.23,-1.93l-5.89,-2.45l-0.97,-0.81l0.51,-1.3l-0.37,-1.23l-2.08,-2.41l0.01,-0.46l1.65,-2.93l0.73,0.33ZM194.08,1183.13l0.36,2.31l1.5,4.37l1.2,6.82l0.97,2.48l3.3,4.94l0.58,1.61l0.62,4.43l4.61,8.44l5.94,7.66l-2.94,0.01l-0.32,0.32l-0.12,1.18l-3.65,2.21l-2.21,2.44l-0.59,1.97l0.42,4.54l2.3,5.13l5.35,1.31l5.22,0.37l3.19,2.88l3.53,-0.37l3.61,0.03l3.35,-0.55l3.22,-2.33l2.12,-5.36l1.39,-1.15l1.16,-0.14l5.0,0.9l1.91,-0.38l3.32,-1.81l3.34,-0.81l2.03,-1.47l4.43,0.38l0.92,-0.89l1.15,0.06l1.49,0.59l-1.37,1.64l-0.58,1.26l-0.1,2.38l0.48,3.83l-2.55,8.16l0.35,0.91l1.13,0.74l0.82,1.85l0.92,0.43l1.69,0.11l0.84,0.62l0.28,1.4l-0.03,3.96l-0.4,0.57l-1.07,0.46l-1.46,-0.89l-1.12,0.27l-0.61,3.87l-1.23,3.13l-0.08,1.26l-0.45,0.61l-0.85,0.41l-2.04,0.27l-0.81,0.42l-0.28,0.71l0.76,2.14l-0.36,0.57l-3.29,1.51l-1.9,0.0l-2.06,1.23l-0.46,-0.13l-1.28,-1.44l-2.08,0.42l-0.74,0.91l-2.82,5.54l-0.81,0.84l-1.68,0.01l-0.68,0.49l-0.47,1.62l0.12,2.57l-0.35,2.14l-0.01,1.93l0.43,2.19l-0.58,2.38l-0.58,0.97l-2.38,2.43l-0.61,3.25l-2.43,2.17l-1.52,0.83l-0.39,0.6l-0.24,1.76l0.33,1.26l-0.24,0.69l-2.01,1.47l-2.2,2.63l-4.15,1.7l-4.01,2.83l-1.11,-0.12l-2.93,-2.07l-1.24,0.02l-0.4,1.39l0.64,4.97l-0.18,1.09l-0.95,1.74l-2.21,2.79l-1.72,4.99l0.02,1.08l0.55,1.38l1.88,2.5l-5.33,1.84l-3.17,0.09l-4.26,-1.21l-1.76,-1.11l-4.68,-0.88l-2.43,-0.02l-1.65,1.2l-1.33,1.68l-3.48,1.11l-2.46,-0.57l-3.86,-0.34l-1.31,0.18l-1.77,0.89l-1.07,-2.76l-0.28,-1.68l0.05,-3.6l-0.86,-2.46l0.29,-1.88l1.02,-1.4l0.56,-1.6l0.05,-1.47l-0.37,-0.97l-1.49,-1.88l-0.7,-1.75l1.41,-2.18l3.23,-2.76l0.06,-0.72l-1.17,-2.32l-2.69,-2.69l-2.53,-1.11l-2.0,-2.4l-5.87,-0.63l-2.03,-2.24l-1.53,-0.86l-1.01,0.01l-1.07,0.62l-1.71,4.0l-0.97,0.64l-1.02,0.07l-5.66,-2.06l-4.05,1.64l-4.23,0.37l-3.58,-2.71l-0.27,-0.56l0.2,-0.38l2.51,-0.8l1.28,-2.35l1.65,-1.26l0.44,-0.77l0.03,-4.14l0.46,-3.18l-0.2,-1.56l-0.86,-1.04l-2.3,-0.18l-1.01,-0.49l-3.1,-4.74l-4.13,-3.26l-4.64,-1.11l-0.17,-0.38l0.68,-1.9l-0.87,-3.56l0.67,-1.39l3.38,-1.92l1.24,-0.11l0.41,-0.36l-0.24,-2.27l-2.41,-6.94l1.26,-0.86l0.32,-0.67l-0.8,-5.34l0.29,-1.78l0.99,-0.51l0.59,-1.05l-0.31,-2.92l0.7,-2.71l2.21,-2.73l0.42,-1.21l-0.41,-5.48l-0.5,-0.77l-1.46,-0.78l2.36,-3.55l1.37,-0.87l4.35,-1.26l1.27,1.74l1.63,0.23l5.15,-0.82l1.26,-0.76l0.49,-2.66l-0.65,-0.69l-1.51,0.03l-0.11,-3.79l1.85,0.42l0.56,-0.37l0.8,-1.94l-0.18,-0.68l-0.86,-0.91l0.15,-0.69l2.44,-0.91l5.33,-6.06l2.11,-1.28l0.49,-0.61l0.18,-0.82l-0.85,-1.17l-0.06,-1.39l-1.68,-1.29l-0.15,-1.84l2.27,-3.2l1.57,-5.7l0.44,-0.21l0.72,0.43l0.69,-0.0l7.16,-3.86l3.31,-1.26l0.81,0.01l2.7,0.92l2.97,-0.23l3.73,-1.19l1.69,0.57l1.49,-0.17l1.33,-0.6l1.95,-2.45l3.42,-1.69l1.34,-1.24l4.46,-0.64ZM254.59,1211.99l-1.9,0.74l-0.7,-0.33l2.3,-1.75l0.3,1.34Z",name:"Surat Thani"},"TH-85":{path:"M113.11,1231.01l0.67,-3.06l3.08,-5.92l1.91,-9.61l1.29,-2.57l2.83,1.97l0.48,-0.01l3.58,-2.81l1.27,-1.4l-0.19,-1.44l-0.3,-0.29l-3.67,0.01l-1.01,-2.13l-1.92,-0.83l0.67,-1.36l1.82,-1.37l1.33,-0.16l1.49,-2.24l-0.33,-1.21l-1.49,-1.99l1.38,-0.31l0.31,-1.26l-0.71,-1.18l-1.09,-0.73l3.29,1.5l1.59,-0.26l0.78,-1.93l1.31,-1.1l0.56,-1.15l-0.13,-0.49l-0.71,-0.5l-2.41,-0.1l-1.77,-0.73l-0.53,0.13l-0.55,0.88l-0.09,-2.71l0.68,-0.69l2.64,-0.56l1.69,-1.19l1.21,-1.37l1.85,-3.64l-0.13,-0.49l-0.5,0.03l-2.67,3.04l-0.83,0.51l-0.67,-0.13l-1.07,-1.57l-1.62,-1.05l0.71,-1.56l2.64,-2.81l1.28,0.96l0.98,-0.06l0.95,-0.48l0.13,-0.62l-0.34,-0.4l1.27,-0.92l0.61,-1.32l-0.44,-0.84l-1.42,-0.59l2.01,-2.52l0.69,-0.48l2.48,-0.02l1.15,-0.8l0.25,-1.12l-0.23,-0.45l-1.25,-0.5l-1.5,0.37l-0.65,-0.84l0.39,-1.87l4.77,-8.21l1.6,-1.85l2.96,-8.38l2.51,-4.73l0.85,-2.52l1.13,-7.0l1.66,-4.05l0.15,-2.44l2.05,-6.6l1.1,-5.59l1.51,-4.27l0.09,-2.31l-1.52,-6.89l-0.84,-1.4l-1.99,-1.72l-0.33,-1.19l0.94,-4.57l1.04,-2.41l4.74,-6.28l1.98,-1.77l4.05,-0.67l1.26,-1.76l1.43,1.04l1.36,2.14l1.48,0.8l-1.93,4.68l-0.06,1.14l0.32,0.8l1.24,0.35l0.63,1.13l1.64,0.6l0.4,1.92l1.87,1.59l0.52,2.15l0.98,1.36l-0.82,2.23l-1.4,1.88l0.27,1.3l1.02,1.25l-0.0,0.44l-1.91,2.56l-1.64,0.67l-2.31,2.48l-1.04,3.25l0.23,4.49l1.0,1.03l0.57,1.28l2.08,0.74l0.56,0.64l0.27,1.73l0.64,1.47l-0.22,1.09l-2.51,4.32l-1.42,1.15l-0.06,1.87l0.35,1.95l-1.89,3.06l-0.67,2.42l0.34,2.33l4.5,6.78l-0.03,1.67l-0.86,4.28l-1.63,2.18l-0.33,1.82l-0.85,1.51l-1.26,1.1l-2.61,0.59l-1.63,1.2l-3.7,5.07l-2.99,-0.38l-2.18,1.07l-1.84,2.54l-2.29,1.98l-1.33,4.37l-2.24,2.65l-2.32,1.02l-3.65,3.49l-1.11,2.65l0.19,1.83l2.86,8.48l-0.32,1.45l0.27,0.66l3.63,1.53l3.47,2.12l2.29,2.56l0.23,2.16l1.67,1.29l0.02,1.27l0.76,0.91l-0.01,0.46l-2.49,1.76l-5.25,5.98l-2.07,0.63l-0.52,0.45l-0.26,1.37l1.01,1.32l-0.6,1.46l-1.59,-0.43l-0.86,0.41l-0.24,0.98l0.22,3.54l0.54,0.58l1.61,0.05l-0.22,1.48l-0.46,0.78l-6.19,0.99l-0.75,-0.46l-0.88,-1.36l-1.15,-0.07l-5.05,1.78l-1.94,2.11l-1.22,2.19l-3.43,-0.94l-3.29,-3.31l-1.65,-1.16l-0.99,-0.01l-3.08,1.16ZM114.74,1185.87l0.49,1.71l-0.11,1.31l-1.6,2.37l-1.01,-1.68l0.43,-1.33l1.8,-2.38Z",name:"Ranong"},"TH-86":{path:"M194.11,1182.33l-4.0,0.39l-0.9,0.36l-1.36,1.25l-3.47,1.72l-2.05,2.54l-0.94,0.38l-1.22,0.14l-1.92,-0.55l-3.72,1.2l-2.8,0.21l-2.5,-0.9l-1.21,-0.01l-3.47,1.31l-7.08,3.82l-0.9,-0.43l-0.79,0.03l-1.01,1.28l-0.65,3.75l-0.54,1.26l-1.99,2.79l-2.18,-2.42l-3.59,-2.19l-3.44,-1.46l0.27,-1.7l-3.02,-9.4l0.71,-2.53l3.7,-3.62l2.51,-1.19l2.31,-2.75l1.34,-4.39l2.16,-1.81l1.84,-2.54l1.64,-0.81l2.6,0.5l0.79,-0.27l3.79,-5.14l1.4,-1.05l2.65,-0.6l1.53,-1.32l0.71,-1.0l0.57,-2.48l1.64,-2.2l0.92,-4.49l-0.03,-2.15l-4.52,-6.79l-0.25,-1.92l0.6,-2.13l1.94,-3.19l-0.31,-3.76l1.35,-1.01l2.54,-4.37l0.29,-1.48l-1.07,-3.64l-0.79,-0.85l-1.93,-0.63l-0.48,-1.18l-0.91,-0.88l-0.16,-4.1l1.01,-3.0l2.02,-2.15l1.74,-0.76l2.01,-2.68l0.09,-1.13l-1.06,-1.34l-0.21,-0.83l1.32,-1.66l0.91,-2.61l-0.21,-0.81l-0.81,-0.78l-0.61,-2.33l-1.85,-1.56l-0.42,-1.95l-1.87,-0.82l-0.68,-1.18l-0.96,-0.09l-0.17,-1.24l1.93,-4.36l0.04,-0.66l-0.45,-0.69l-1.47,-0.78l-1.2,-1.97l-1.65,-1.2l1.15,-1.76l1.25,-0.56l1.88,0.67l1.17,0.04l4.69,-1.94l1.32,-1.85l0.44,-2.32l-0.03,-1.83l-1.07,-3.44l0.31,-2.2l0.98,-1.95l1.08,-1.01l4.33,1.43l1.4,-0.14l0.99,-1.45l1.38,-4.17l1.68,-1.71l4.75,-2.57l0.54,2.4l0.89,1.12l7.86,3.95l4.4,1.16l1.38,-0.08l0.88,-0.56l2.6,-0.13l1.17,0.12l1.97,0.81l2.02,-0.27l5.83,0.34l1.49,-1.25l2.47,-0.97l1.53,-1.43l3.84,-0.74l-0.77,2.65l0.2,2.68l1.69,4.66l0.39,2.17l-0.31,1.26l-0.42,-0.03l-1.14,-1.25l-2.04,-0.08l-2.67,0.4l-1.21,0.8l-0.4,1.16l0.0,4.45l-0.47,1.89l-6.51,9.87l-0.42,1.21l0.47,1.91l-3.21,0.65l-1.97,1.45l-2.76,3.68l-0.69,2.26l-0.84,5.19l-0.99,1.67l-2.44,0.63l-1.3,0.77l-0.46,1.45l0.25,1.05l0.98,0.76l1.5,0.22l-2.31,3.29l-0.4,2.08l0.83,1.59l3.32,2.2l1.08,1.14l0.04,3.17l-0.43,1.66l-0.55,0.58l-2.26,0.14l-2.09,1.16l-0.32,-1.05l-0.89,-1.05l-2.92,-1.46l-1.59,0.76l-2.59,0.36l-1.3,1.55l0.75,6.06l1.2,1.81l4.09,3.71l1.97,2.38l1.45,0.47l1.21,-0.28l-0.73,1.14l-4.49,0.6l-1.0,1.69l-0.61,2.55l-2.92,4.86l-0.9,2.72l0.23,3.34l2.21,3.6l0.48,1.76l-0.27,1.05l-1.57,1.26l-0.35,1.56l0.74,4.8l0.0,8.6l0.76,1.21l-0.02,0.56l-2.21,2.3l-0.72,3.91Z",name:"Chumphon"},"TH-80":{path:"M279.52,1268.95l-1.12,1.49l-0.33,0.98l0.0,2.71l1.26,8.3l-0.49,1.89l1.38,3.32l2.16,21.23l0.87,3.55l2.03,3.11l6.06,3.65l0.88,1.46l0.46,1.92l2.41,4.72l1.75,2.61l0.67,2.13l0.68,1.06l3.73,1.88l0.84,1.44l1.63,0.34l1.73,-0.4l1.51,-0.91l0.17,-0.46l-0.98,-3.12l-0.22,-4.34l-1.13,-3.9l-2.99,-1.34l1.02,-0.44l3.05,2.21l2.93,3.38l1.28,2.23l5.51,14.3l3.4,21.63l4.21,19.24l-6.5,1.33l-3.62,1.88l-5.17,1.62l-4.69,2.14l-1.13,1.81l-1.76,5.98l-8.69,-2.28l-1.34,-1.65l-1.46,-0.96l-0.5,-2.28l-1.29,-1.74l-0.97,-0.65l-3.99,-1.46l-15.62,2.09l-0.75,0.32l-1.49,1.75l-4.72,0.9l-0.61,0.49l-0.56,-0.85l-0.45,-4.09l0.84,-4.72l0.95,-3.09l-0.14,-0.69l-1.03,-1.08l-1.37,-0.64l-2.55,0.51l-3.91,-0.11l-2.91,0.59l-2.65,-0.21l-1.15,0.43l-1.71,2.95l-2.45,1.84l-0.88,1.89l-1.8,1.66l-0.66,1.41l-0.23,1.55l-0.39,0.18l-2.97,0.44l-4.34,-1.92l-6.8,-0.07l-1.59,-1.59l-1.64,-2.51l-3.49,-1.63l-1.17,-1.35l1.29,-1.52l0.75,-1.85l-0.04,-1.06l-1.43,-3.66l-2.25,-1.88l-2.49,-5.26l-0.04,-0.34l0.97,-0.98l0.22,-1.84l-0.57,-3.23l0.81,-1.21l0.33,-1.39l1.54,-2.3l0.05,-8.83l-0.29,-1.4l-4.12,-3.35l-3.44,-4.78l-0.51,-1.26l0.18,-1.62l1.47,-3.87l2.15,-2.69l1.06,-1.98l0.21,-1.31l-0.59,-5.59l0.74,0.08l2.99,2.08l1.41,-0.01l4.11,-2.88l4.23,-1.75l2.28,-2.7l2.0,-1.46l0.5,-1.24l-0.33,-1.86l0.36,-1.19l1.5,-0.81l2.58,-2.32l0.47,-1.03l0.2,-2.31l2.26,-2.27l0.74,-1.22l0.63,-2.6l-0.42,-4.16l0.35,-2.15l-0.12,-2.51l0.35,-1.27l1.97,-0.18l1.15,-1.09l3.35,-6.28l1.49,-0.32l0.91,1.25l1.06,0.34l0.89,-0.26l1.35,-1.01l1.88,0.0l3.62,-1.7l0.61,-1.1l-0.7,-2.35l2.59,-0.52l1.05,-0.53l0.69,-0.95l0.1,-1.33l1.23,-3.13l0.46,-3.56l1.97,0.9l1.51,-0.59l0.52,-0.56l0.26,-4.63l-0.38,-1.78l-0.99,-0.9l-2.65,-0.5l-0.64,-1.64l-1.37,-1.25l2.54,-8.08l-0.48,-3.95l0.07,-2.14l1.96,-2.8l1.19,0.25l2.08,-1.34l1.18,1.1l3.92,1.71l-0.05,2.14l0.71,1.78l1.99,3.47l0.84,-0.09l0.06,7.49l0.59,2.25l2.65,3.91l0.32,1.58l0.01,5.3l1.43,3.82Z",name:"Nakhon Si Thammarat"},"TH-81":{path:"M140.98,1338.59l0.72,-0.18l1.23,-1.57l-0.52,-2.8l1.73,-4.83l-1.1,-1.63l-0.21,-0.98l-0.44,-6.02l0.19,-2.62l2.82,-0.74l1.21,-0.86l1.04,-1.73l0.43,-4.06l0.94,-0.08l1.16,-0.61l1.51,-3.71l0.54,-0.69l0.82,-0.3l1.03,0.33l2.72,2.77l5.77,0.59l1.91,2.33l3.02,1.52l2.07,2.16l1.03,2.06l-3.15,2.74l-1.58,2.59l0.81,2.22l1.76,2.57l-0.52,2.58l-1.19,1.84l-0.21,1.84l0.86,2.53l-0.05,3.56l0.3,1.77l1.24,3.17l0.86,0.26l1.83,-0.97l1.02,-0.13l6.5,0.89l3.67,-1.18l1.51,-1.81l1.27,-0.99l0.78,-0.04l5.98,0.93l1.64,1.07l4.52,1.26l3.39,-0.11l5.65,-1.93l1.52,2.11l3.48,2.65l0.54,3.11l-0.2,6.85l-1.46,2.05l-0.33,1.39l-0.86,1.34l0.53,3.47l-0.11,1.16l-1.1,1.51l0.44,1.76l1.77,3.7l0.57,0.86l2.13,1.72l1.35,3.49l-0.67,2.34l-1.15,1.17l-0.22,0.76l1.4,1.8l0.77,2.35l-0.32,1.27l-1.14,1.96l-3.85,3.87l-0.25,0.62l0.35,1.54l1.67,2.44l0.51,2.9l2.5,4.17l-0.5,1.42l-2.54,4.11l-5.48,4.06l-1.45,-1.66l-1.55,-0.73l-1.65,-0.23l-0.75,-0.55l-1.53,-2.13l-4.28,-2.79l-1.57,-1.39l-0.73,-2.39l-0.38,-0.28l-0.68,0.0l-0.4,0.37l-0.25,3.67l-1.0,2.83l-1.99,1.33l-3.56,-0.71l-2.29,-2.41l-0.59,-7.07l-1.33,-2.7l4.25,-3.33l0.79,-1.44l0.91,-5.4l-0.07,-1.95l-0.68,-0.26l-2.03,2.06l-0.86,0.33l-1.12,-0.17l-2.94,-4.14l-3.48,-1.49l-0.71,-1.97l0.36,-2.31l-0.4,-1.11l-0.94,-1.15l-2.48,-1.6l-0.72,-1.74l-0.62,-0.55l-1.87,0.35l-0.79,0.77l-1.02,2.16l-4.64,1.92l-1.26,-0.35l-1.72,-4.03l-1.49,-0.95l-1.05,0.45l-0.74,1.57l-1.33,1.08l-0.49,-2.29l-1.95,-2.33l-0.23,-1.98l0.25,-5.31l-0.37,-1.5l0.37,-5.35l-0.36,-1.8l-1.88,-4.33l-0.72,-0.02l-1.49,2.83l-0.42,-7.75l-0.74,-1.09l-0.44,-0.16l-2.17,0.63l-3.0,1.9l-1.82,-0.31l-0.4,0.75l0.29,-6.56l0.49,-0.76l1.86,-1.46ZM191.26,1422.18l-1.48,-0.09l-0.62,-0.42l-0.65,-1.22l-1.9,-1.11l-2.44,-4.01l1.94,-1.03l3.85,0.6l1.94,1.18l0.29,3.22l-0.35,1.89l-0.59,0.98ZM190.96,1435.15l-1.37,0.94l-2.19,-1.26l-2.09,-2.49l-3.09,-7.22l0.1,-3.75l-0.21,-1.82l-0.61,-1.38l0.52,-0.51l0.38,0.0l4.2,3.68l0.02,3.78l1.1,4.0l1.68,3.66l1.55,2.38Z",name:"Krabi"},"TH-82":{path:"M105.72,1247.38l1.33,0.41l1.14,-0.34l2.65,-2.7l-0.11,-0.62l-1.79,-0.92l-0.04,-1.35l0.95,-1.75l0.34,-1.5l1.3,-1.82l1.44,-4.92l3.94,-1.27l1.42,1.0l3.35,3.37l3.97,1.14l1.68,0.9l0.41,1.18l0.19,4.3l-0.31,0.91l-2.29,2.92l-0.73,2.88l0.3,2.87l-0.3,0.54l-1.17,0.72l-0.38,2.07l0.79,5.37l-1.28,0.89l-0.3,0.64l0.09,0.96l2.34,6.27l0.25,1.63l-1.27,0.22l-3.15,1.78l-0.87,0.85l-0.44,1.41l0.87,3.6l-0.59,1.37l-0.02,0.9l0.54,0.66l4.56,1.05l3.98,3.13l2.54,4.09l1.14,1.15l2.73,0.31l0.68,0.58l0.17,1.35l-0.46,3.13l0.02,3.91l-1.98,1.81l-1.19,2.26l-2.57,0.86l-0.4,0.94l0.46,1.05l4.03,2.98l4.57,-0.37l1.84,-0.54l1.97,-1.08l5.24,1.9l-0.4,3.96l-0.9,1.47l-0.86,0.6l-2.74,0.68l-0.56,0.51l-0.22,2.95l0.44,6.07l0.32,1.31l0.98,1.22l-1.7,4.65l0.51,2.8l-0.4,0.46l-0.15,-0.48l-1.45,-0.69l-2.39,-0.49l-1.82,-0.75l-0.54,0.29l-0.46,2.23l-1.24,0.54l-1.99,0.16l-1.69,0.86l-2.83,2.59l-1.36,0.46l-0.9,-1.11l-1.05,-0.15l-0.4,0.34l-0.17,1.19l-0.36,0.44l-0.34,-0.04l-0.62,-0.94l-1.07,-0.18l-0.4,0.4l0.0,0.97l-2.01,-0.17l-1.89,0.89l-0.83,1.33l0.2,0.57l3.16,1.27l0.34,1.55l-0.03,2.05l0.66,1.72l0.03,2.81l-1.77,4.35l-1.95,2.48l-1.13,-1.37l-0.97,-0.15l-0.4,0.37l-0.32,1.51l-0.86,1.0l-1.38,-1.24l-2.16,-3.85l-2.63,-1.04l-0.98,-1.66l-3.27,-0.67l-1.09,-0.92l-0.38,-1.47l-0.03,-4.78l-1.64,-3.19l-2.19,-10.16l-4.61,-13.96l-0.15,-2.25l0.73,-2.06l0.39,2.36l0.86,1.56l2.67,2.9l0.68,-0.16l0.57,-2.54l-0.95,-1.33l-1.59,-1.13l-0.99,-1.23l-0.04,-0.47l0.76,-1.41l0.02,-2.35l1.49,-4.6l-0.24,-2.51l-1.97,-5.62l0.36,-0.79l1.63,-1.12l1.31,-1.71l0.64,-7.56l0.52,-2.31l2.35,-3.69l1.03,-4.36l2.06,-2.88l1.35,-2.56l0.57,-0.34l1.92,0.6l1.46,-0.0l0.37,-0.53l-0.6,-2.19l3.47,-4.11l0.03,-0.5l-0.48,-0.14l-5.05,1.8l-0.77,-0.63l-0.27,-2.47l1.06,-0.95l2.61,-0.15l1.74,-0.88l0.2,-0.49l-1.28,-3.57l-3.16,-4.16l-1.38,-2.39l-0.6,-3.75ZM137.33,1367.18l-0.05,0.9l-3.83,-1.51l-0.8,-1.08l0.24,-0.31l2.24,-0.55l0.29,-0.49l-0.43,-1.63l2.48,-3.09l0.74,-1.42l0.69,0.4l0.16,1.34l-1.73,7.45ZM128.02,1365.94l0.56,1.22l5.15,2.96l1.57,1.61l0.82,2.99l0.16,11.73l-0.77,2.08l-1.18,-0.09l-1.04,-1.4l-1.53,-6.25l0.39,-1.24l1.5,-0.59l0.29,-1.29l-0.39,-2.02l-0.82,-1.06l-2.01,-0.54l-0.27,-0.4l-2.17,-4.97l-0.28,-2.76ZM102.12,1264.33l-2.1,0.59l-1.96,-0.08l-1.26,-1.12l0.85,-10.75l1.08,-0.61l1.19,-0.18l0.81,0.3l2.67,2.49l0.98,1.65l0.55,1.99l0.02,2.16l-2.16,2.19l0.03,0.59l0.33,0.28l-1.04,0.52ZM101.86,1276.2l-2.44,6.03l-0.44,-0.07l-0.81,-1.85l-0.22,-2.12l0.51,-2.35l-0.37,-6.18l0.74,-1.37l1.65,0.32l1.99,1.21l1.15,1.89l-0.38,2.0l-1.38,2.49ZM58.92,1220.45l-0.24,0.44l-1.73,-0.38l-0.79,0.15l-0.33,0.4l0.0,0.83l-1.37,-1.14l0.32,-1.7l1.72,-1.09l2.22,0.55l0.31,0.47l-0.12,1.49ZM56.5,1226.52l-0.23,0.58l-2.97,-2.33l-0.38,-0.63l0.18,-0.53l0.52,-0.5l1.13,-0.34l1.01,0.76l0.61,1.45l0.14,1.54Z",name:"Phangnga"},"TH-83":{path:"M101.35,1358.04l0.81,0.55l1.04,-0.24l0.73,0.22l1.85,1.51l0.56,1.41l0.84,5.11l0.39,0.34l0.93,-0.11l0.92,-0.85l1.17,0.69l3.45,3.09l0.59,-0.1l0.74,-1.19l0.81,-0.42l0.72,0.26l0.64,1.23l-0.06,1.65l-2.15,4.24l0.02,3.58l-1.77,1.34l-0.48,1.07l-0.07,1.92l0.45,2.2l0.87,2.12l1.05,1.52l0.66,0.0l1.0,-1.01l0.55,1.08l0.02,1.45l-0.72,1.06l-3.61,1.35l-0.48,1.68l0.25,3.17l-3.42,-1.63l-1.99,-0.05l-0.39,0.26l-0.87,2.44l-0.38,2.68l-0.89,1.43l-1.2,0.28l-1.61,-0.92l-0.5,-1.36l-0.56,-6.95l-1.35,-2.61l-0.11,-0.91l1.23,-0.68l0.57,-0.75l-0.36,-1.84l-0.89,-0.67l-1.93,-0.6l1.94,-2.32l-0.75,-2.47l1.64,-3.22l-0.57,-3.37l-0.18,-3.81l1.48,-4.26l0.23,-2.41l-0.85,-6.19Z",name:"Phuket"},"TH-32":{path:"M627.37,562.38l-0.59,-0.31l-1.26,0.63l-1.5,-1.32l-0.2,-0.74l0.98,-1.5l0.59,-2.97l12.06,3.47l1.24,0.74l2.69,0.88l2.49,1.63l5.95,2.11l1.95,-0.35l6.19,-2.57l3.62,-1.96l1.59,-0.07l5.09,1.22l1.29,0.03l1.77,-0.62l2.35,-1.95l1.27,-0.53l2.34,-0.17l4.64,1.73l15.82,1.18l3.59,-1.09l3.02,-1.62l3.08,-0.04l1.4,-0.82l0.42,0.09l0.21,1.46l0.41,0.69l1.08,0.73l0.92,0.37l2.22,-0.05l-0.44,1.05l0.18,0.51l1.03,0.54l2.02,-0.17l1.18,-0.43l0.22,1.16l1.12,0.76l6.87,0.29l0.99,0.5l0.72,2.7l0.89,1.38l-0.28,1.61l-0.53,0.59l-2.55,0.97l-1.22,0.97l-0.75,1.68l-1.06,0.77l-0.72,1.75l-1.02,0.61l-0.68,1.21l-1.36,0.28l-0.52,0.68l0.04,0.65l1.02,1.59l0.17,0.85l-1.29,3.46l-0.53,4.41l0.54,1.15l1.47,1.13l0.28,0.73l1.43,7.26l1.05,1.26l0.15,2.3l-0.25,1.32l-1.6,1.91l-0.52,2.34l-1.76,1.36l-0.82,2.22l-1.93,2.03l-1.24,1.98l-2.81,6.85l0.17,1.28l1.37,1.9l3.81,1.98l3.09,0.6l0.63,0.51l0.78,1.8l-0.1,5.5l0.22,0.86l0.84,1.52l4.57,5.79l0.39,0.91l0.0,3.1l-1.08,6.59l-0.62,1.4l-0.07,1.03l0.46,4.28l1.3,5.71l-1.75,10.44l-4.34,1.19l-3.09,-2.43l-5.87,0.3l-1.26,1.02l-0.77,1.45l-1.69,0.2l-1.48,-0.29l-3.4,-2.19l-1.64,-0.55l-3.35,0.33l-1.99,-0.23l-6.34,-1.6l-3.73,-0.26l-0.56,-0.21l-0.26,-0.75l0.23,-2.54l-0.36,-1.44l-1.63,-1.35l-1.33,-0.38l-1.27,0.13l-1.04,0.61l-1.22,2.6l-2.03,1.02l-1.37,-0.3l-1.49,-0.95l-1.94,-0.65l-2.02,0.29l-4.29,2.15l-4.77,3.09l-0.94,-0.12l-2.06,-1.32l-1.69,0.51l-2.99,2.16l-1.79,0.8l-2.25,0.27l-7.32,-0.02l-2.97,0.89l-0.22,-2.54l0.61,-2.11l-0.33,-2.24l1.21,-2.85l0.31,-1.74l-0.94,-3.13l-1.2,-2.52l-0.72,-3.63l0.22,-6.93l1.67,-1.89l0.67,-2.96l2.12,-4.13l1.61,-6.62l-0.31,-2.52l0.17,-0.89l1.05,-0.98l1.64,-2.75l1.3,-0.77l1.78,-1.74l1.96,-1.15l3.9,-3.31l2.55,-4.76l1.66,-1.21l0.99,-1.48l-0.32,-7.71l0.46,-0.92l1.99,-1.44l0.38,-1.15l-0.3,-1.25l-1.18,-1.83l0.79,-2.45l-1.09,-2.87l-0.52,-8.51l1.83,-5.59l1.98,-1.34l2.15,-5.64l-0.4,-1.61l-1.78,-0.55l-1.42,-1.95l-1.59,-0.76l-2.15,-0.71l-0.52,0.38l0.0,0.69l0.39,0.39l-0.76,1.13l-1.48,0.04l-0.55,-0.51l0.9,-0.75l-0.15,-0.69l-0.53,-0.11l-0.39,-0.59l-0.87,0.05l-0.87,0.48l-2.73,-1.28l-1.52,0.4l-2.28,1.48l-1.85,0.73l-1.33,1.62l-0.77,0.27l-1.41,-0.89l-1.21,-0.2l-1.27,0.88l-0.52,-1.0l-1.9,-1.01l-0.39,-1.25l-0.38,-0.28l-1.64,0.16l-0.81,-1.4l-1.37,-1.46l-2.56,0.35l-1.83,-4.08l-0.28,-1.64l-0.39,-0.33l-0.74,0.0l-0.38,0.38Z",name:"Surin"},"TH-40":{path:"M624.7,396.97l1.66,1.8l0.31,0.82l-1.11,3.39l-0.04,1.98l0.52,1.39l1.16,0.17l1.47,-0.9l1.02,-1.23l0.3,-1.92l0.46,-0.07l1.4,0.46l0.34,0.47l1.03,3.29l-0.57,3.88l-0.68,1.28l-1.06,1.09l-0.45,1.15l-0.08,8.88l-0.6,3.56l0.05,2.93l-1.18,1.56l-2.08,1.64l-1.27,3.2l-1.68,2.93l-1.47,2.04l-1.04,0.88l-1.57,0.78l-2.52,0.35l-1.65,2.12l-1.06,0.86l-8.35,2.44l-0.11,0.69l1.41,2.4l0.14,0.69l-0.3,1.17l-1.27,2.36l-2.21,2.63l-2.36,4.82l-4.29,3.42l-0.94,1.74l-0.04,6.21l1.5,5.24l-0.1,1.77l0.43,3.81l-0.11,1.37l-0.82,1.88l0.07,1.7l0.5,1.84l0.86,1.3l2.45,1.53l1.78,3.94l0.11,2.59l-0.52,2.08l-0.08,2.64l3.29,7.29l-0.08,4.77l0.94,3.24l-3.68,1.29l-0.79,0.5l-0.82,1.18l-0.55,1.58l-0.17,6.49l-1.19,4.2l-1.02,1.69l-0.99,0.52l-3.35,1.04l-1.63,-0.14l-5.27,-4.21l-3.93,-0.94l-2.07,-2.88l-0.42,-2.06l-1.06,-0.65l-3.04,1.13l-4.02,-0.84l-1.84,-0.08l-1.73,1.38l-9.46,-1.28l-4.76,0.81l-2.53,1.24l-1.31,0.34l-0.63,-0.17l-2.17,-2.26l-3.13,-1.87l-0.11,-3.06l-2.32,-2.03l-1.69,-2.57l0.52,-1.21l-0.57,-3.64l0.31,-1.4l1.47,-1.76l0.39,-1.21l1.4,-1.93l0.73,-1.6l-0.19,-0.89l1.3,-5.08l0.93,-0.67l0.18,-0.56l-0.64,-1.15l-1.99,-0.76l-2.55,-2.24l-5.32,-2.1l-1.79,-1.13l-1.28,-2.08l2.69,-2.09l4.08,-4.27l2.28,-4.39l2.64,-3.04l3.12,-4.66l1.77,-6.05l1.44,-3.24l2.02,-6.92l0.17,-2.76l-3.74,-2.51l-0.86,-2.84l-0.78,-0.75l-1.51,0.11l-0.46,0.63l0.07,1.08l-1.82,0.47l-2.39,-1.55l-3.03,0.56l-2.21,-0.46l-1.41,-1.08l-3.08,-1.08l-2.0,-2.11l-4.13,-1.79l-1.04,-0.08l-1.79,0.63l-1.75,-0.33l-9.09,-0.08l-2.31,-1.49l-3.78,-4.84l-2.85,-1.08l-0.75,-0.62l-0.64,-0.95l-1.47,-4.07l-1.36,-1.34l-1.87,-0.3l-3.07,0.08l-6.3,-2.55l-1.98,-0.31l-1.4,0.17l-3.37,1.79l-0.57,-0.07l-3.27,-2.72l0.42,-0.92l1.91,-2.13l1.38,-2.77l0.41,-4.51l8.48,-3.24l9.23,-5.72l0.97,-0.07l2.04,0.56l0.75,-0.15l2.88,-1.82l3.18,-0.63l2.68,-2.07l7.25,0.96l2.3,1.25l3.74,0.94l1.36,-0.35l3.27,-2.12l1.08,-1.13l1.68,-0.18l1.22,0.18l1.96,1.06l1.25,1.35l0.45,1.06l1.07,0.52l0.26,1.2l1.52,2.47l1.6,0.29l4.48,1.63l2.03,1.19l2.42,0.42l4.34,-1.04l3.7,0.48l2.97,1.0l0.87,0.61l1.23,1.72l0.69,0.31l5.68,-0.9l0.72,-0.94l1.49,-6.2l5.97,-14.11l0.94,-5.34l0.07,-3.27l2.33,-4.13l0.46,2.25l0.64,1.13l6.31,3.33l1.39,1.01l1.11,1.56l2.2,1.53l0.07,0.33l-1.03,0.83l-0.15,0.54l0.85,2.16l-0.17,2.78l0.51,4.34l0.67,0.52l4.25,-0.53l1.45,0.11l2.23,1.14l2.31,2.48l1.27,0.45l1.47,0.05l17.0,-7.92Z",name:"Khon Kaen"},"TH-41":{path:"M519.74,275.11l0.83,0.99l0.79,0.09l1.03,-0.56l1.5,-1.74l2.2,-0.6l1.07,1.13l3.12,0.91l2.09,1.7l3.42,1.35l3.53,2.58l1.29,2.32l3.06,1.72l1.04,1.37l1.79,1.26l0.98,1.89l0.51,3.12l1.84,2.36l1.98,0.99l-0.42,2.61l2.64,3.66l1.35,0.64l7.02,0.41l3.47,3.56l1.73,0.97l2.22,2.04l-0.37,1.97l0.55,3.31l-0.44,2.38l0.78,0.53l3.99,0.77l0.82,1.38l1.01,0.37l5.66,-0.83l2.2,0.34l1.81,-0.77l2.75,-2.11l0.95,-3.58l1.09,-1.27l5.33,-3.03l0.68,-1.86l1.29,-1.44l-0.25,-1.79l0.52,-1.16l0.17,-2.25l-1.74,-4.19l1.53,-2.77l1.4,-1.13l0.91,-1.78l-0.36,-2.06l0.22,-0.7l1.79,-0.12l4.75,1.02l2.19,3.25l0.95,2.53l0.76,0.38l1.98,-0.84l1.36,-1.31l1.81,-2.88l2.24,-0.83l0.69,-1.21l1.62,1.28l0.81,1.13l1.79,0.65l0.79,0.96l0.88,0.45l0.64,1.07l2.66,1.18l1.08,1.46l1.08,1.02l0.61,0.19l0.81,-0.17l1.09,-0.99l1.1,-3.54l0.96,-1.22l6.22,-2.68l1.15,0.79l2.22,3.43l1.62,0.96l1.34,-0.25l2.24,-1.64l1.39,-0.61l4.4,-1.18l-0.3,1.72l1.21,0.88l-0.95,0.28l-1.14,-0.63l-0.67,0.45l-0.66,2.51l-0.17,2.38l-0.62,0.86l0.34,1.49l1.07,1.72l0.77,0.71l1.09,0.38l0.32,1.06l0.21,2.85l-0.84,3.25l0.28,2.26l-0.28,2.14l0.23,4.96l-1.27,0.24l-1.46,1.18l-2.3,-0.2l-1.35,0.78l-1.0,1.41l-0.49,1.8l-1.05,1.19l-0.85,2.72l-1.73,1.72l-1.03,2.36l-0.2,2.18l-1.01,3.12l0.75,2.34l1.58,2.51l0.06,0.55l-1.7,1.79l-1.58,4.27l-1.62,1.74l0.02,1.06l0.62,1.55l2.4,3.45l7.13,1.59l6.96,3.74l1.96,-0.16l2.29,0.39l1.4,-0.54l1.06,-0.93l1.06,1.22l5.74,3.07l3.62,3.08l0.7,0.18l1.53,-0.5l0.91,0.39l2.42,2.41l1.64,2.63l1.25,0.77l1.18,0.23l0.42,1.53l0.12,4.55l-1.03,-0.91l-2.68,-3.75l-3.74,-1.37l-2.17,0.62l-3.91,2.41l-2.76,3.51l0.42,2.15l-0.14,3.28l-2.65,4.11l-0.44,2.68l0.14,3.45l-3.38,4.54l-1.33,3.58l-1.01,-2.76l0.17,-2.7l-1.14,-1.5l-1.6,-1.29l-5.42,-2.5l-5.52,-1.22l-2.22,-1.53l-2.08,-0.87l-2.56,-0.56l-2.37,0.78l-4.18,0.3l-3.86,-0.61l-1.03,1.09l-2.37,4.03l-16.91,7.91l-2.26,-0.4l-2.2,-2.41l-2.52,-1.29l-1.7,-0.14l-3.93,0.57l-0.65,-4.13l0.16,-2.89l-0.84,-2.0l1.13,-1.1l-0.12,-1.03l-2.38,-1.75l-1.06,-1.51l-1.53,-1.11l-6.17,-3.22l-0.44,-0.78l-0.22,-1.98l-0.89,-0.86l-1.01,0.58l-2.1,3.76l-0.2,3.76l-0.7,4.47l-0.71,1.73l-12.57,-12.1l-1.13,-1.54l-3.46,-6.96l-0.2,-1.35l1.14,-1.33l3.3,-0.58l2.87,-1.94l0.48,-0.68l0.4,-1.93l1.54,-0.97l0.21,-0.87l-1.41,-0.76l-2.84,0.34l-2.53,0.75l-2.55,1.21l-0.6,-0.05l-2.11,-2.87l-1.79,-0.88l-0.03,-1.32l0.57,-2.13l0.8,-1.41l-0.19,-1.66l-0.97,-1.3l-3.06,-0.4l-0.9,-0.47l-0.65,-0.9l-0.29,-2.85l0.71,-1.52l0.06,-2.31l-1.09,-4.41l-3.98,-7.91l-0.76,-4.86l-1.06,-2.54l0.17,-4.98l-0.29,-1.37l-1.02,-0.59l-2.92,1.34l-1.32,-0.35l-1.52,-0.89l-5.99,-1.1l-2.51,-1.02l-1.34,0.05l-1.2,0.79l-1.63,1.74l-1.49,0.84l-0.93,-0.01l-1.79,-0.93l-1.54,0.46l-2.64,3.14l-1.33,-2.37l-1.59,-1.55l-0.7,-1.65l-1.1,-4.45l-0.78,-1.61l-0.6,-0.05l-0.32,0.37l-1.17,3.18l-0.56,0.06l-0.5,-0.67l-1.41,-8.0l0.88,-3.69l1.34,-1.39l-0.11,-2.18l0.75,-2.44l0.09,-1.34l-0.35,-3.16l-1.19,-2.82l-1.52,-9.76l1.24,-0.8l0.34,-0.81l0.41,-2.73l1.42,-3.9l0.29,-3.25l2.86,2.78l2.57,-0.05l1.26,2.41l1.95,1.11l-0.33,1.32l0.68,1.56Z",name:"Udon Thani"},"TH-42":{path:"M398.73,386.93l1.48,-1.95l0.55,-6.16l1.52,-4.22l1.02,-6.1l0.38,-1.08l1.82,-2.65l0.61,-1.96l0.02,-1.39l-2.76,-4.74l-0.86,-0.44l-2.57,-0.36l-1.48,-2.39l-2.1,-1.11l-1.8,-2.48l-1.47,-0.3l-2.25,0.26l-2.38,-0.57l-1.57,0.35l-1.1,-0.7l-0.42,-2.07l0.78,-4.05l-0.79,-4.66l-0.37,-0.95l-1.43,-1.68l-0.21,-0.81l2.04,-2.62l0.17,-2.53l0.39,-0.91l2.12,-1.46l1.09,-2.02l4.37,0.81l3.95,2.28l3.44,3.53l1.76,0.38l3.18,1.86l3.54,1.56l0.66,0.01l1.17,-0.66l2.55,-3.31l0.31,-1.64l3.8,-1.41l2.89,-5.09l1.95,-2.58l11.86,-9.64l2.99,-0.77l1.97,-2.5l0.3,-1.12l-0.28,-0.44l-1.92,-0.36l0.32,-0.46l1.29,-0.43l3.26,0.01l2.26,-1.89l1.28,3.14l0.66,0.1l1.63,-2.88l2.04,-2.09l3.59,-1.51l2.21,-1.49l0.03,-0.64l-1.86,-1.51l2.59,-0.96l0.89,-1.1l0.56,-1.38l0.28,-2.52l1.87,1.16l0.5,-0.07l1.24,-1.36l0.9,-2.03l1.61,-1.03l9.99,-1.93l3.32,-9.84l0.97,-4.77l0.84,-1.93l1.61,-1.52l0.33,0.0l1.11,1.24l4.19,1.14l4.14,2.36l2.54,-0.67l18.25,-19.28l0.64,-0.49l2.71,0.14l-0.21,3.59l-1.14,1.29l-1.79,1.19l-0.79,1.6l-1.48,5.73l-0.49,4.66l-1.28,3.26l-0.41,2.73l-0.16,0.48l-1.14,0.6l-0.28,0.6l1.52,10.03l1.2,2.9l0.33,2.98l-0.84,3.7l0.13,2.04l-1.29,1.27l-0.95,4.03l1.5,8.34l0.86,1.02l0.89,0.11l0.51,-0.25l1.32,-3.14l1.41,5.32l0.76,1.78l1.66,1.64l1.59,2.7l2.07,6.3l0.07,1.69l-2.26,3.37l-4.62,2.74l-1.24,0.29l-2.21,-0.35l-4.18,0.11l-1.36,0.26l-1.04,1.03l-0.23,2.03l0.74,2.48l3.43,4.18l-0.23,2.38l0.46,2.32l-0.64,1.08l-2.84,2.79l-1.01,1.4l-0.32,3.53l-2.87,3.41l-0.68,1.7l0.83,3.02l2.79,3.18l1.42,0.78l2.42,0.63l1.93,1.23l1.89,0.32l2.32,1.23l2.22,0.65l1.16,1.66l0.98,3.35l1.49,1.02l1.0,1.59l1.75,1.23l-4.4,1.96l-2.44,2.52l-4.41,1.7l-1.27,1.15l-0.02,1.26l1.92,3.68l1.85,2.74l-2.41,1.88l-3.1,0.59l-2.83,1.8l-1.19,0.03l-1.57,-0.52l-1.09,0.18l-9.23,5.73l-8.63,3.3l-6.18,0.84l-0.58,-0.28l-0.53,-1.02l0.56,-3.42l-0.97,-3.16l0.42,-6.18l-0.6,-3.59l-0.58,-1.51l-2.78,-3.08l-3.13,-6.78l-0.66,-2.32l-0.79,-0.71l-1.04,-0.02l-1.37,0.93l-2.32,3.82l-2.02,0.93l-2.07,0.24l-1.91,-0.73l-2.4,-5.1l-2.51,-0.98l-4.13,-2.44l-0.97,-0.15l-2.37,1.17l-2.96,-0.98l-0.73,-0.01l-1.2,0.67l-3.58,-0.52l-3.42,1.06l-1.72,-1.58l-3.26,-1.11l-4.06,-1.97l-3.14,-1.0l-1.28,0.41l-0.63,0.55l-0.15,3.02l-2.44,4.02l-1.11,0.6l-2.6,0.19l-1.05,0.92l-0.27,2.0l0.74,2.62l-0.93,3.73l0.05,2.66l-0.2,0.41l-1.38,0.63l-0.87,1.37l-3.04,0.25l-0.2,-1.44l-0.69,-0.87l-2.91,-1.49l-0.28,-0.48l1.11,-1.29l0.15,-1.4l-1.56,-2.89Z",name:"Loei"},"TH-43":{path:"M516.24,251.63l4.39,0.22l1.8,0.99l1.06,3.38l1.03,1.92l4.59,3.25l2.55,3.37l5.52,4.83l3.23,1.61l3.23,-0.14l1.96,2.44l3.01,2.5l3.72,1.88l4.03,0.75l9.17,0.03l3.24,1.63l1.3,4.2l-1.83,8.31l0.29,0.4l1.5,0.42l5.66,2.72l2.4,0.31l0.45,-0.4l-0.06,-1.03l-1.01,-1.57l-0.57,-1.87l0.49,-1.45l1.31,-0.81l3.78,-0.91l1.76,-1.01l4.01,-3.63l6.23,-3.38l0.77,-1.25l1.48,-0.86l9.25,-4.1l1.64,-0.33l1.8,0.45l3.3,2.11l1.92,0.54l2.31,-0.86l2.19,-3.16l1.14,-0.84l0.53,-1.09l-0.85,-6.74l0.16,-1.94l0.49,-1.37l1.26,-1.14l0.45,0.27l2.28,-0.79l1.88,-1.16l1.4,-1.76l0.78,-2.56l0.62,-3.71l0.66,-1.64l1.1,-1.33l1.68,-0.81l9.61,-2.06l1.39,-0.48l0.77,-0.62l0.2,1.24l-1.01,2.33l1.08,1.87l3.49,0.56l3.05,1.4l1.15,3.06l-0.97,2.35l-3.48,2.16l-1.63,3.36l0.69,4.72l4.09,4.14l4.75,2.84l3.23,2.71l-0.83,0.68l-1.97,-0.55l-1.34,0.06l-1.51,0.94l0.1,1.4l2.16,3.55l-0.77,0.41l-0.35,0.87l0.79,2.34l0.83,1.19l0.09,1.36l-0.72,1.27l-4.96,1.33l-1.54,0.69l-2.1,1.57l-0.96,0.19l-1.11,-0.7l-2.5,-3.76l-0.92,-0.69l-0.75,-0.02l-4.79,1.84l-1.73,0.99l-1.18,1.49l-1.03,3.4l-1.18,0.84l-1.21,-0.97l-1.15,-1.52l-2.66,-1.17l-0.84,-1.26l-0.71,-0.29l-1.08,-1.16l-1.52,-0.46l-0.7,-1.04l-2.06,-1.57l-0.71,0.18l-0.56,1.25l-2.1,0.69l-2.31,3.4l-1.4,1.19l-1.09,0.42l-1.08,-2.54l-2.45,-3.51l-2.06,-0.68l-3.0,-0.44l-2.19,0.17l-0.67,1.04l0.39,2.17l-0.8,1.59l-1.41,1.15l-1.68,3.1l0.71,2.49l1.02,1.83l-0.15,2.08l-0.54,1.29l0.29,1.59l-1.21,1.27l-0.3,1.34l-0.98,0.94l-4.28,2.2l-1.12,1.03l-0.51,0.82l-0.86,3.39l-2.48,1.85l-1.55,0.67l-2.09,-0.35l-5.51,0.84l-0.48,-0.1l-1.12,-1.58l-4.4,-0.97l0.52,-1.97l-0.55,-3.34l0.31,-2.28l-2.48,-2.36l-1.7,-0.95l-3.45,-3.57l-7.45,-0.58l-0.89,-0.41l-2.46,-3.39l0.55,-2.08l-0.16,-0.58l-0.6,-0.58l-1.55,-0.62l-1.68,-2.15l-0.44,-2.93l-1.1,-2.14l-1.92,-1.42l-1.1,-1.42l-3.02,-1.68l-1.26,-2.3l-3.66,-2.67l-3.46,-1.37l-2.12,-1.72l-3.06,-0.88l-1.23,-1.22l-2.85,0.68l-1.62,1.83l-0.91,0.36l-1.1,-1.87l0.27,-1.61l-0.38,-0.49l-1.74,-0.87l-1.17,-2.32l-0.84,-0.43l-2.1,0.21l-3.03,-3.03l1.41,-5.47l0.68,-1.36l1.67,-1.07l1.34,-1.57l0.28,-3.87Z",name:"Nong Khai"},"TH-44":{path:"M606.82,448.71l7.82,-2.24l1.05,-0.75l1.72,-2.25l2.33,-0.27l1.86,-0.93l1.16,-1.0l1.56,-2.16l1.7,-2.97l1.23,-3.13l2.77,-2.37l0.72,-1.78l-0.09,-1.79l2.57,0.37l0.51,0.35l0.01,1.04l-1.57,1.4l-0.34,0.97l0.46,3.92l0.91,2.22l-2.05,6.18l0.39,2.38l2.02,3.81l-2.17,4.39l0.61,2.79l1.15,0.85l3.1,0.38l6.76,-1.88l0.73,-0.61l1.07,-1.83l0.48,0.82l0.25,2.0l0.34,0.55l0.69,0.47l2.79,0.46l1.49,2.09l1.62,3.84l2.05,1.81l2.88,1.33l0.73,2.46l-0.21,1.58l2.87,3.83l0.7,2.12l0.6,0.26l0.89,-0.34l1.32,-1.85l4.49,-0.01l-4.97,8.18l-0.83,2.91l-0.15,3.17l1.46,4.04l0.13,6.92l1.22,4.05l0.21,1.97l-0.2,0.82l-1.54,2.04l-1.17,3.61l-3.54,16.96l-1.1,0.49l-4.94,-0.49l-2.7,1.13l-1.71,2.0l-2.63,6.24l-1.73,2.17l-0.27,0.82l0.35,1.06l1.79,0.99l0.33,1.93l0.51,0.83l1.88,1.37l2.87,1.17l1.54,1.49l0.74,0.11l1.64,-0.79l1.23,-0.12l1.23,0.17l1.06,0.75l0.42,2.16l-2.48,7.99l-5.97,2.48l-1.69,0.3l-5.62,-2.04l-2.45,-1.61l-2.72,-0.9l-1.28,-0.76l-12.47,-3.59l-3.05,-2.16l-0.64,-0.87l0.06,-0.76l1.06,-1.08l-0.25,-2.41l-3.63,-2.93l-0.89,-3.14l-2.41,-1.61l-4.95,-5.34l0.05,-0.6l2.66,-1.72l0.74,-0.89l0.21,-1.13l-0.36,-2.11l-2.38,-3.14l-2.1,-1.31l-2.3,-2.71l-0.92,-2.89l-0.02,-5.39l-3.28,-7.2l0.08,-2.42l0.53,-2.12l-0.15,-2.91l-1.86,-4.11l-2.49,-1.59l-0.74,-1.08l-0.46,-1.7l-0.07,-1.42l0.9,-2.52l-0.3,-6.47l-1.51,-5.32l-0.07,-4.76l0.42,-2.03l4.81,-4.04l2.37,-4.85l2.16,-2.56l1.35,-2.5l0.37,-1.4l-0.16,-1.0l-1.21,-2.36Z",name:"Maha Sarakham"},"TH-45":{path:"M725.08,449.45l0.52,3.94l0.64,0.82l1.25,0.3l8.71,-3.94l2.73,-1.54l1.1,-0.0l0.89,0.84l0.8,0.26l3.13,-0.21l2.54,0.45l0.83,-0.22l3.65,-1.51l0.61,-0.65l0.77,-1.76l0.45,-0.24l0.74,1.8l0.85,4.92l0.99,6.08l-0.07,1.98l0.69,1.03l2.09,0.61l-3.02,6.77l-1.14,0.51l-2.22,-0.08l-1.97,1.44l-2.01,2.74l-1.54,3.7l-1.22,1.75l-0.7,0.56l-1.73,0.33l-1.48,1.17l-1.79,0.69l-3.1,3.11l-3.34,1.08l-1.77,1.61l-0.47,0.79l-0.04,1.25l1.84,3.99l-0.95,5.99l-1.17,0.33l-2.99,-0.57l-3.01,0.02l-2.13,0.67l-0.55,1.13l0.06,4.9l-0.83,1.71l0.34,1.62l2.39,3.1l-1.89,1.33l-0.49,0.96l0.38,1.42l-0.93,0.55l-0.47,0.9l-0.01,1.38l0.64,1.45l0.49,0.21l4.89,-1.23l2.09,-1.27l0.06,-2.53l3.56,2.16l2.08,3.78l0.42,4.55l-0.91,4.77l0.39,0.47l0.67,0.0l1.19,-0.62l0.94,0.57l1.09,1.52l3.1,6.45l1.53,2.16l-6.07,2.36l-1.17,0.72l-1.28,1.42l-2.52,1.62l-0.62,0.8l-1.78,0.74l-3.94,5.66l-2.25,1.74l-3.84,4.87l-0.54,1.38l-0.37,-0.27l-0.08,-1.21l-0.54,-0.35l-1.54,0.58l-1.62,0.19l-0.59,-0.31l0.55,-1.32l-0.4,-0.55l-1.81,0.15l-1.51,-0.31l-1.11,-0.92l-0.35,-1.78l-1.06,-0.4l-1.6,0.85l-3.17,0.06l-3.1,1.66l-3.27,1.02l-15.66,-1.17l-3.71,-1.51l-1.67,-0.27l-3.03,0.66l-2.73,2.17l-1.46,0.51l-7.11,-1.31l-1.04,0.18l-2.83,1.47l2.28,-7.29l0.01,-1.14l-0.56,-1.61l-1.44,-1.05l-1.46,-0.22l-1.49,0.14l-1.79,0.75l-1.48,-1.45l-4.16,-1.99l-0.79,-0.97l-0.42,-2.12l-0.68,-0.65l-1.05,-0.35l-0.28,-0.58l1.91,-2.66l2.6,-6.2l1.55,-1.81l1.53,-0.79l1.61,-0.24l4.12,0.57l1.54,-0.72l0.5,-1.24l3.21,-16.04l1.13,-3.51l1.52,-2.0l0.29,-1.1l-0.23,-2.21l-1.21,-3.97l-0.14,-6.96l-1.45,-4.01l0.13,-2.92l0.76,-2.71l5.25,-8.64l2.39,-1.09l0.68,-0.23l1.09,1.85l2.28,0.51l2.15,-0.54l0.29,-0.38l0.02,-1.25l0.57,0.32l1.78,2.31l1.6,0.2l1.46,-0.67l0.62,0.51l0.54,-0.03l0.74,-0.76l0.01,-0.55l-1.37,-1.57l3.15,0.63l0.55,-0.37l0.0,-1.12l2.89,0.98l0.47,-0.25l0.9,-3.12l1.3,-1.94l0.48,-4.22l-0.44,-1.04l-2.34,-2.02l-0.42,-2.36l-1.57,-2.05l-0.21,-1.07l10.71,-8.22l1.95,-0.94l4.58,-0.27l2.48,1.44l2.17,0.31l0.97,0.84l1.0,0.34l4.44,0.33l4.17,-0.64l3.2,0.43Z",name:"Roi Et"},"TH-46":{path:"M682.59,381.86l-0.63,1.81l0.57,1.03l2.08,0.33l2.2,-0.57l1.37,0.55l8.96,6.89l0.27,0.64l-0.64,2.26l0.15,1.44l1.49,2.83l4.17,2.6l1.39,2.84l3.43,2.34l3.21,1.42l3.49,3.41l0.96,-0.04l0.76,-0.84l0.93,-3.14l1.73,-0.18l0.93,-1.48l2.97,-1.45l0.95,-1.15l3.66,1.2l1.58,1.11l4.93,6.94l1.44,1.48l3.71,6.28l0.61,1.93l1.26,1.59l-0.59,1.98l0.5,3.64l4.13,6.41l1.77,3.53l0.72,10.02l-2.15,-0.39l-3.13,0.21l-1.46,-1.05l-1.55,-0.04l-11.38,5.47l-0.67,-0.15l-0.38,-0.48l-0.48,-3.81l-0.56,-0.59l-3.36,-0.45l-4.27,0.64l-4.29,-0.33l-1.78,-1.13l-2.13,-0.29l-2.33,-1.46l-5.32,0.24l-2.17,1.05l-10.96,8.49l-0.0,1.4l1.62,2.13l0.58,2.71l2.46,2.18l0.23,0.57l-0.45,3.91l-1.27,1.87l-0.79,2.83l-2.4,-0.92l-0.74,0.0l-0.4,0.4l0.0,0.92l-3.27,-0.49l-0.43,0.4l0.0,0.69l1.33,1.58l-0.22,0.22l-0.92,-0.49l-1.45,0.7l-1.05,-0.06l-1.69,-2.22l-1.33,-0.78l-0.6,0.34l-0.03,1.62l-1.57,0.43l-1.99,-0.45l-0.9,-1.78l-0.48,-0.2l-3.63,1.5l-5.17,0.0l-0.83,0.51l-1.08,1.66l-0.76,-2.0l-2.79,-3.72l0.26,-1.33l-0.83,-2.79l-0.67,-0.58l-2.52,-1.05l-1.87,-1.67l-1.5,-3.68l-1.72,-2.36l-3.33,-0.79l-0.43,-2.25l-0.63,-1.17l-0.66,-0.24l-0.51,0.22l-1.16,1.96l-0.73,0.5l-6.27,1.66l-2.7,-0.36l-0.75,-0.56l-0.4,-2.48l1.87,-3.18l0.25,-1.02l-2.08,-4.13l-0.31,-1.64l0.11,-1.29l1.91,-5.33l-0.93,-2.4l-0.45,-3.73l0.35,-0.68l1.3,-0.99l0.35,-1.13l-0.12,-0.86l-0.58,-0.66l-3.31,-0.66l0.57,-3.28l0.07,-8.76l2.15,-3.41l0.62,-4.26l-1.15,-3.62l-0.61,-0.73l-1.7,-0.55l-0.81,0.08l-0.49,0.41l-0.2,1.63l-0.42,0.84l-1.29,1.04l-0.72,0.16l-0.31,-0.94l0.05,-1.76l1.1,-3.67l-0.45,-1.13l-1.71,-1.85l2.87,-4.59l3.62,0.63l4.34,-0.31l1.6,-0.71l1.93,0.18l3.43,1.35l1.79,1.32l5.56,1.23l5.22,2.39l1.48,1.19l0.99,1.28l-0.15,2.96l0.88,2.36l0.88,0.68l0.95,-0.91l0.29,-1.63l0.87,-1.73l3.31,-4.42l0.19,-0.9l-0.28,-2.82l0.42,-2.49l2.66,-4.17l0.15,-3.5l-0.43,-1.88l2.56,-3.15l3.71,-2.26l1.61,-0.54l3.44,1.21l3.41,4.67Z",name:"Kalasin"},"TH-47":{path:"M644.39,331.02l1.7,-1.68l0.9,-2.81l1.01,-1.1l0.52,-1.86l0.83,-1.18l1.21,-0.61l1.28,0.34l0.89,-0.14l1.58,-1.23l1.26,-0.22l0.44,-0.69l-0.24,-4.99l0.28,-2.13l-0.28,-2.27l0.84,-3.18l-0.22,-3.08l-0.5,-1.46l-1.82,-1.03l-0.98,-1.56l-0.27,-1.05l0.6,-0.82l0.7,-4.59l1.44,0.48l1.52,-0.45l0.33,-0.47l-0.24,-0.55l-1.39,-0.76l0.46,-1.84l0.88,-1.69l-0.1,-1.59l-0.91,-1.38l-0.7,-2.02l0.96,-0.71l0.13,-0.77l-2.19,-3.64l-0.07,-0.81l1.64,-0.51l2.49,0.58l1.93,-1.23l1.76,-0.19l1.41,-1.15l1.25,-1.6l0.32,-1.02l-0.34,-2.17l0.19,-0.3l1.38,-0.56l1.37,-1.1l3.47,0.21l2.08,1.04l1.08,0.89l1.66,0.24l2.59,2.98l2.68,0.58l-1.71,0.73l-0.39,0.99l0.43,2.11l1.6,1.22l2.38,0.36l0.6,1.27l2.67,0.6l1.93,0.96l2.27,2.12l1.6,0.76l0.97,-0.51l0.48,-2.27l0.7,-0.8l-0.03,1.38l1.49,1.13l-0.25,1.06l0.47,1.56l-1.61,1.23l-0.17,1.26l0.81,1.24l2.07,1.79l1.75,0.64l0.82,-0.32l0.09,-0.9l-0.74,-1.29l0.26,-0.31l3.34,0.28l2.02,-1.07l0.62,1.48l0.95,0.52l0.67,-0.29l0.76,-1.08l1.97,-0.63l-0.48,1.02l-0.12,2.03l0.54,0.55l0.58,0.09l1.47,-0.97l-0.19,3.64l0.59,0.97l1.08,0.7l0.06,1.17l0.46,0.64l2.08,0.87l1.69,1.24l1.33,-1.18l1.24,-0.48l0.51,-1.44l0.99,-0.46l0.62,3.26l0.65,1.43l0.77,0.23l1.19,-0.35l0.75,0.79l0.42,1.49l1.21,0.48l0.88,3.15l-0.42,1.89l0.88,1.12l-1.79,3.12l-2.39,0.65l-0.61,0.68l-0.06,0.75l0.77,2.39l0.9,1.25l0.18,1.11l-1.25,3.32l-0.44,4.1l-2.24,4.02l-0.32,1.33l4.73,9.44l0.95,0.61l3.39,0.97l1.2,-0.71l-0.15,-1.72l2.45,1.62l1.39,0.25l0.81,-0.6l1.05,-2.15l0.75,-0.42l7.29,0.61l4.35,-0.6l1.5,-0.7l3.37,-0.55l5.17,0.34l5.65,-0.27l0.2,6.75l1.15,1.98l-0.01,2.8l0.7,1.97l-0.05,2.6l1.26,2.92l-0.32,1.01l-2.29,2.58l-1.65,4.16l-0.56,3.21l0.0,2.47l-3.4,3.43l-0.73,1.47l-0.15,1.95l0.42,1.36l3.29,2.0l-0.08,1.34l-1.05,1.16l-6.47,3.84l-2.17,4.6l-2.85,1.29l-4.02,2.96l-4.47,1.02l-1.37,-0.01l-2.52,-0.72l-2.64,0.08l-1.16,1.54l-0.76,2.46l-2.05,2.17l-2.8,0.5l-1.63,-1.13l-3.08,-1.22l-1.31,0.04l-1.03,1.21l-3.04,1.51l-0.86,1.41l-0.96,-0.11l-0.86,0.38l-1.04,3.27l-0.74,0.58l-3.32,-3.3l-3.29,-1.47l-3.34,-2.28l-1.3,-2.76l-4.15,-2.57l-0.94,-1.41l-0.5,-1.86l0.61,-3.18l-1.07,-1.33l-9.41,-6.89l-0.96,-0.23l-3.06,0.61l-0.74,-0.24l-0.07,-0.97l0.45,-0.9l0.85,-0.7l-0.37,-6.1l-0.51,-0.87l-1.37,-0.31l-0.98,-0.6l-1.57,-2.55l-2.54,-2.53l-1.3,-0.56l-2.0,0.39l-3.52,-3.02l-5.75,-3.07l-1.5,-1.51l-1.49,1.2l-1.14,0.43l-2.05,-0.4l-1.85,0.18l-6.81,-3.68l-7.33,-1.74l-1.86,-3.01l-0.58,-1.71l1.61,-1.87l1.69,-4.45l1.63,-1.72l-0.09,-1.09l-1.6,-2.56l-0.67,-2.03l0.99,-2.93l0.17,-2.06l0.99,-2.24Z",name:"Sakon Nakhon"},"TH-48":{path:"M734.77,275.33l4.84,0.13l3.27,-2.05l5.37,11.24l0.99,3.37l0.73,1.33l1.98,2.02l6.99,4.15l1.57,2.01l2.43,4.82l2.02,2.63l1.46,3.8l3.27,3.85l3.29,2.95l16.83,8.72l2.04,0.72l5.08,3.17l1.23,1.28l2.11,3.12l1.71,3.26l0.84,0.98l2.7,1.64l1.08,1.18l2.54,5.6l0.3,1.24l-0.32,6.77l0.21,6.66l-0.9,7.55l-6.99,16.35l-0.56,2.55l1.0,10.36l1.82,4.79l0.07,1.25l-0.95,3.89l-1.69,0.65l-0.89,1.18l0.02,1.71l1.28,2.33l-0.05,1.28l-0.44,0.39l-1.34,-0.07l-4.19,-2.21l-0.35,-0.69l0.37,-2.07l-0.35,-2.6l-1.8,-0.97l-2.47,-0.43l-5.36,-0.27l-4.12,0.99l-1.98,1.15l-1.01,-0.06l-1.14,-0.72l-1.3,-2.19l-1.11,-0.92l-2.41,0.73l-3.78,-2.12l-2.99,1.33l-1.07,-0.23l-2.58,-1.67l-1.6,-0.43l-2.6,0.18l-3.95,1.76l-1.66,-0.4l-2.0,-1.14l-2.75,-2.81l3.64,-2.69l2.9,-1.32l0.92,-1.38l1.41,-3.36l6.33,-3.71l1.27,-1.38l0.04,-2.27l-3.44,-2.3l0.03,-2.39l0.53,-1.04l3.53,-3.63l0.07,-2.73l0.52,-3.06l1.25,-3.4l2.58,-3.12l0.45,-1.7l-1.26,-2.83l0.05,-2.55l-0.7,-1.98l-0.0,-2.87l-1.15,-2.0l-0.11,-6.3l-0.51,-1.01l-6.04,0.22l-5.23,-0.34l-3.53,0.57l-1.41,0.68l-4.24,0.59l-2.14,-0.38l-5.24,-0.22l-1.23,0.67l-1.41,2.51l-0.91,-0.19l-2.05,-1.49l-0.86,-0.23l-0.67,0.54l0.23,1.62l-0.96,0.29l-2.66,-0.91l-1.03,-0.85l-0.58,-1.75l-3.49,-6.43l0.17,-1.24l2.3,-4.18l0.44,-4.1l1.27,-3.43l-0.1,-1.19l-1.03,-1.55l-0.72,-2.57l2.81,-1.04l2.04,-3.66l-0.16,-0.67l-0.77,-0.74l0.45,-1.73l-0.96,-3.42l-0.38,-0.45l-0.85,-0.09l-0.43,-1.5l-0.93,-0.98l-0.63,-0.21l-1.17,0.38l-0.28,-0.3l-1.01,-4.42l0.29,-2.51l-0.24,-1.15l-2.23,-3.17l-0.2,-1.03l0.77,-1.58l0.49,-2.76l0.49,-1.12l3.39,-1.2l0.4,0.19l0.59,1.82l1.37,1.75l0.68,2.23l3.11,1.92l1.24,0.06l0.58,-0.34l2.71,-5.24l-0.42,-2.1l0.16,-3.15l-0.39,-0.75l-0.96,-0.69l-0.19,-0.59l0.62,-2.47Z",name:"Nakhon Phanom"},"TH-49":{path:"M802.64,407.6l0.01,1.73l2.4,10.32l-2.81,10.01l-0.5,4.84l0.13,2.59l0.59,2.38l1.24,2.06l1.91,1.59l6.12,3.29l1.75,1.47l2.53,3.5l1.89,5.44l1.23,2.23l1.14,0.99l2.87,1.62l2.91,2.89l1.31,0.91l-2.14,2.65l-5.39,3.6l-2.85,2.47l-5.48,2.19l-2.24,0.15l-1.23,-0.83l-9.56,-1.65l-2.22,-1.21l-0.98,-1.55l-0.71,-0.33l-1.27,0.5l-0.65,1.62l-0.72,0.58l-1.28,0.29l-0.99,-0.14l-1.56,-1.71l-3.11,-2.25l-3.01,-6.18l-1.12,-0.55l-3.08,-0.29l-1.09,-1.86l-1.64,-1.24l-3.09,0.39l-3.9,-0.64l-4.19,-0.08l-2.08,0.62l-2.29,1.69l-2.18,-0.64l-0.27,-0.52l0.08,-1.83l-1.0,-6.13l-1.38,-6.47l-0.8,-0.94l-0.87,0.16l-1.64,2.65l-3.54,1.43l-0.73,-10.09l-1.86,-3.77l-4.08,-6.31l-0.44,-3.37l0.58,-2.14l-1.34,-1.75l-0.63,-1.97l-3.73,-6.31l-1.49,-1.55l-4.59,-6.44l2.46,-0.44l1.33,-1.09l1.41,-1.83l0.56,-2.14l0.75,-1.13l2.22,-0.02l2.53,0.73l1.5,0.01l4.47,-1.01l2.95,3.02l2.29,1.3l2.08,0.42l3.99,-1.78l2.36,-0.15l1.34,0.38l2.48,1.63l1.36,0.32l0.96,-0.16l2.21,-1.16l3.48,2.1l2.32,-0.75l0.78,0.62l1.31,2.2l1.63,1.02l1.4,0.04l2.05,-1.18l3.9,-0.93l5.2,0.28l2.35,0.42l1.26,0.57l0.28,2.18l-0.37,2.19l0.58,1.15l4.46,2.38l1.09,0.21l1.01,-0.21l0.74,-0.76l0.08,-1.76l-1.06,-1.79l-0.33,-1.3l0.44,-1.11l1.28,-0.57Z",name:"Mukdahan"},"TH-26":{path:"M402.13,675.17l2.16,2.49l1.33,0.38l3.13,-0.09l2.64,1.75l1.51,2.02l1.22,0.15l0.84,-0.28l3.43,-2.96l-0.11,-2.49l0.93,-2.62l1.49,-2.08l0.62,-3.23l0.93,-0.94l1.91,0.32l0.58,-0.61l0.37,-1.24l1.05,-1.09l2.83,1.15l1.42,1.72l9.38,5.68l0.98,1.16l1.19,2.41l0.89,0.79l3.82,1.43l0.78,0.58l1.05,2.37l0.97,0.65l0.45,1.36l1.19,1.75l-0.09,2.55l-0.8,1.23l-3.25,0.5l-3.72,1.26l-1.59,-0.22l-2.28,-1.43l-0.93,0.34l-0.42,1.12l-0.29,3.77l-0.83,0.89l-7.59,5.47l-1.44,2.54l-0.0,1.56l1.24,1.82l0.18,1.82l1.29,2.24l0.06,1.16l-0.85,0.7l-2.9,0.78l-1.14,-0.73l-1.39,-0.24l-4.86,0.93l-2.82,3.23l-1.57,1.16l-4.89,1.89l-0.35,0.89l0.51,1.97l-7.63,-0.62l-13.14,0.66l-3.74,1.19l0.9,-6.57l-0.22,-21.21l3.56,-4.08l0.62,-1.71l-0.33,-3.1l1.84,-0.47l1.5,1.43l0.79,0.01l4.19,-2.95l1.24,-1.5l0.46,-1.48l-0.3,-1.01l2.01,-3.11l0.0,-3.22Z",name:"Nakhon Nayok"},"TH-27":{path:"M539.35,800.18l-0.86,1.12l-3.71,2.35l-1.52,3.82l-0.87,0.68l-1.42,0.12l-2.22,-0.71l-2.14,-1.8l-1.34,-2.49l-0.62,-0.34l-1.64,-0.08l-1.45,1.06l-2.31,3.91l-0.98,0.88l-1.99,0.81l-3.42,0.57l-3.08,2.1l-1.17,-0.01l-0.47,-1.61l-0.34,-4.52l0.48,-3.77l-0.14,-1.1l-2.15,-2.37l-0.59,-1.22l-3.42,-12.3l-2.63,-3.16l-0.76,-2.08l-0.05,-2.27l0.36,-0.94l3.87,-0.58l0.98,-1.62l0.3,-4.44l-0.65,-4.03l-0.32,-0.77l-0.7,-0.45l-4.66,0.75l-1.81,-0.3l-0.6,-0.58l0.63,-2.59l-0.09,-1.89l-0.55,-0.89l-2.77,-2.55l-1.41,-6.3l3.05,-3.61l0.34,-1.64l-0.15,-4.33l-0.74,-1.21l-4.13,-1.26l-0.63,-0.82l-0.08,-1.2l1.03,-3.01l-0.05,-4.57l0.53,-1.46l4.53,-3.75l0.06,-1.81l-0.53,-2.6l0.03,-1.74l0.55,-1.42l1.82,-1.26l1.3,-0.43l2.56,0.02l1.42,-0.49l1.34,-1.24l1.12,-2.72l4.06,-3.43l0.74,-0.99l0.81,-5.47l3.2,2.61l5.59,2.08l1.84,0.4l1.44,-0.24l0.72,-0.61l0.27,-1.0l-0.12,-2.26l0.67,-0.75l1.29,-0.61l0.7,0.1l1.81,1.57l0.52,2.29l0.81,0.83l1.23,0.38l3.47,-0.06l1.96,1.27l1.88,-0.28l1.71,-1.87l1.63,-0.15l2.62,-0.84l3.76,1.12l0.72,0.02l2.84,-1.05l2.92,1.61l3.66,-0.26l0.73,0.87l-0.15,1.6l0.36,2.23l0.92,1.17l1.12,0.33l2.36,-0.18l1.35,-0.49l0.47,-0.61l-0.06,-0.58l-1.7,-0.94l0.25,-1.0l2.95,-0.84l2.65,-2.09l1.64,1.25l1.16,-0.4l1.0,-1.33l2.49,1.8l6.77,0.42l5.68,-1.29l2.19,-0.86l0.94,-0.77l2.63,-0.74l5.98,1.14l3.81,-1.03l-0.27,3.05l-3.78,6.67l-0.7,5.57l-1.52,1.74l-6.21,4.84l-2.77,2.76l-2.03,3.61l-2.7,7.86l-2.46,3.35l-0.46,3.5l-0.37,0.89l-2.46,2.1l-10.86,5.28l-3.54,2.71l-0.18,2.93l2.39,2.32l3.08,2.01l-1.21,0.35l-5.07,2.93l-2.01,0.71l-6.53,0.54l-8.74,-0.74l-4.31,0.48l-2.31,2.76l0.06,1.47l1.21,2.0l0.45,1.71l0.38,9.93l-0.71,6.73l0.2,8.01Z",name:"Sa Kaeo"},"TH-24":{path:"M379.0,777.27l1.87,-1.94l0.56,-3.22l1.09,-2.47l1.6,-0.35l0.95,-0.66l0.36,-3.11l1.78,-0.75l3.14,-4.32l-0.96,-3.09l-2.0,-1.14l-7.13,-2.62l-0.6,-1.09l4.78,-7.8l2.96,-3.28l0.37,-0.85l-0.3,-1.17l-2.23,-1.83l-0.35,-0.79l0.88,-11.68l3.95,-1.32l13.07,-0.66l7.87,0.64l1.44,3.51l0.15,1.2l-1.48,5.01l0.16,0.78l0.97,1.03l-0.16,1.13l0.36,0.37l1.59,-0.15l1.76,-1.37l3.13,-1.16l3.3,1.14l0.76,0.0l1.62,-0.69l7.75,1.33l1.92,-0.14l20.99,9.81l1.13,1.96l0.82,0.38l0.91,-0.6l1.03,-2.6l0.79,-0.36l1.04,0.18l6.25,2.67l1.91,0.41l1.74,-0.35l1.03,-0.82l0.12,-2.39l0.4,-0.7l5.42,-1.12l3.28,3.02l1.54,3.93l1.8,1.84l1.79,0.55l4.43,-0.68l1.45,6.36l3.28,3.32l0.06,1.61l-0.68,2.39l0.32,0.98l0.81,0.59l1.13,0.29l2.05,0.02l3.19,-0.73l0.43,0.12l0.24,0.56l0.62,3.85l-0.26,4.15l-0.6,1.16l-3.2,0.29l-0.76,0.36l-0.59,0.89l-0.12,1.51l0.1,1.62l0.83,2.28l2.62,3.15l1.89,7.42l-4.17,3.99l-1.65,1.08l-2.37,0.92l-1.17,0.96l-1.49,4.39l-0.78,1.27l-0.5,0.06l-0.3,-0.99l-0.61,-0.73l-1.64,-0.33l-2.41,0.92l-2.29,2.32l-4.07,2.64l-0.66,0.31l-2.66,0.09l-2.57,0.85l-0.27,-1.75l-3.85,-6.65l-4.87,-4.86l-3.31,-1.37l-2.65,-2.14l-2.06,-1.01l-1.56,-3.34l-2.82,-3.93l-2.02,-1.26l-1.57,-0.57l-0.97,0.09l-1.71,0.8l-1.18,-0.2l-1.25,-0.58l-1.83,-1.55l-1.32,-2.28l-0.93,-0.85l-1.58,-0.12l-1.69,0.4l-0.92,-0.23l-2.61,-2.6l-2.57,-1.83l-1.87,-3.38l-1.22,-1.48l-1.41,-1.05l-8.4,-2.0l-4.94,-2.19l-1.53,-0.1l-0.92,0.52l-1.78,2.46l-1.72,0.24l-1.67,1.25l-2.65,-0.01l-0.96,0.4l-0.55,1.25l0.52,2.05l-0.13,0.83l-0.79,0.56l-0.57,0.98l-1.39,0.61l-0.93,1.66l-1.85,1.0l-1.27,0.2l1.35,-2.51l0.0,-0.75l-0.63,-0.33l-3.45,2.69l-1.25,0.32l-6.62,0.0l-4.64,-0.94Z",name:"Chachoengsao"},"TH-25":{path:"M412.54,736.06l0.1,-1.1l-1.08,-1.51l1.48,-5.03l-0.19,-1.42l-1.54,-3.76l-0.47,-2.63l1.5,-0.35l3.24,-1.44l1.67,-1.24l2.15,-2.6l0.95,-0.71l4.43,-0.62l1.63,0.83l0.86,0.11l2.82,-0.8l1.1,-0.73l0.32,-0.82l-0.12,-1.28l-1.31,-2.29l-0.22,-1.91l-1.2,-1.76l0.02,-1.02l1.24,-2.22l8.17,-6.04l0.64,-1.51l0.32,-3.71l2.39,1.29l1.91,0.25l3.83,-1.28l2.44,-0.21l1.06,-0.41l0.87,-0.91l0.36,-1.32l-0.0,-2.39l-1.25,-1.91l-0.52,-1.48l-0.97,-0.65l-0.67,-1.78l-0.78,-0.97l-4.92,-2.2l-1.82,-3.27l2.49,-0.16l0.8,-0.65l0.77,-1.31l1.55,-1.26l1.45,-0.62l0.89,0.33l1.3,1.68l1.33,0.91l2.75,0.83l5.64,-0.81l2.82,0.29l1.11,0.55l0.92,1.24l1.77,1.11l1.09,1.57l4.63,3.54l2.71,3.37l1.63,1.28l0.65,0.16l0.57,-0.13l0.45,-0.56l0.17,-2.23l0.32,-0.57l2.04,-0.35l1.52,-0.88l3.56,0.2l3.84,-0.85l0.83,-0.46l1.73,-2.74l0.6,0.18l2.03,2.64l1.18,0.78l1.14,-0.03l2.29,-1.9l2.44,1.44l0.01,1.72l-1.99,3.45l-1.66,1.98l-0.23,1.89l1.83,3.41l3.4,2.89l4.34,2.81l1.71,1.49l-0.8,5.74l-4.71,4.3l-1.12,2.71l-1.09,1.04l-1.07,0.41l-2.76,0.01l-1.5,0.51l-1.97,1.36l-0.79,1.92l0.44,6.03l-4.45,3.58l-0.62,1.75l0.06,4.53l-1.01,2.88l0.06,1.63l1.09,1.38l3.03,0.74l0.98,0.45l0.38,0.63l0.15,4.25l-0.3,1.37l-2.9,3.34l-4.61,0.68l-1.32,-0.43l-1.54,-1.57l-1.61,-4.03l-2.87,-2.82l-0.89,-0.49l-1.62,0.08l-4.39,1.17l-0.63,0.78l-0.18,2.64l-0.53,0.38l-1.47,0.31l-1.74,-0.38l-6.14,-2.63l-1.4,-0.24l-1.4,0.7l-1.21,2.85l-0.67,-0.59l-0.91,-1.63l-21.25,-9.92l-2.05,0.12l-7.77,-1.33l-2.33,0.7l-2.05,-0.93l-1.38,-0.21l-1.73,0.44l-1.8,0.85l-1.66,1.32l-0.8,0.17Z",name:"Prachin Buri"},"TH-22":{path:"M481.77,863.4l0.43,-2.24l0.91,-1.24l0.03,-1.93l1.7,-1.57l0.04,-1.73l1.19,-6.5l-0.49,-5.85l-0.45,-0.71l-1.65,-0.31l-1.15,-3.75l-0.83,-1.22l-1.85,-1.13l-2.2,0.48l-1.06,-1.47l-0.03,-2.47l1.08,-1.37l0.02,-1.06l-1.27,-1.84l-2.55,-0.76l-2.41,-5.96l-0.65,-2.71l1.01,-4.12l2.1,-2.27l2.88,-0.95l2.61,-0.07l0.86,-0.38l4.23,-2.74l2.23,-2.28l2.12,-0.8l1.24,0.39l0.62,1.5l1.08,0.22l0.88,-0.76l0.56,-1.08l0.48,-1.95l1.25,-2.65l2.98,-1.31l1.71,-1.13l3.95,-3.77l1.9,5.29l2.07,2.21l-0.37,4.65l0.35,4.58l0.59,1.99l0.83,0.48l1.39,-0.23l3.0,-2.06l3.35,-0.55l2.2,-0.9l1.21,-1.1l2.28,-3.87l0.94,-0.77l1.66,0.26l1.2,2.36l2.41,2.01l2.45,0.78l1.82,-0.16l1.28,-1.01l1.42,-3.69l1.02,-0.85l2.03,-0.99l1.31,-1.21l5.45,14.24l2.19,3.77l4.89,5.72l1.7,3.43l1.12,1.51l1.75,1.09l-0.27,0.76l-1.85,1.19l-0.32,0.61l0.21,0.77l1.01,1.12l-1.24,1.46l-0.25,1.52l1.01,2.49l1.0,6.75l0.73,2.36l1.55,2.52l0.23,1.22l-1.15,4.24l-2.37,1.32l-2.48,0.26l-0.83,0.37l-1.54,2.2l-2.1,1.85l-1.35,1.91l-0.32,1.3l0.15,4.04l0.59,1.55l-0.72,1.56l0.66,1.45l1.24,1.46l0.08,0.61l-0.77,-0.05l-2.92,-2.59l-1.29,-0.4l-1.56,0.93l-2.53,3.37l0.01,2.15l1.93,5.22l-0.4,2.03l-1.18,1.62l-0.06,0.98l1.95,3.61l2.71,1.7l-0.09,0.91l-1.59,2.77l-1.85,-1.38l-0.47,0.04l-1.39,1.19l0.1,0.67l1.37,0.8l0.56,1.01l-1.36,1.63l-2.05,1.18l-1.63,-0.16l-0.77,-2.25l0.28,-4.76l0.64,-2.25l1.26,-2.22l-0.35,-0.6l-0.98,0.15l-2.42,3.68l-0.59,-2.35l0.56,-2.82l-0.5,-0.01l-1.2,0.9l-1.6,0.57l-1.22,-0.13l-0.57,-1.19l-0.47,-0.21l-2.36,0.78l-0.04,0.7l0.94,0.58l0.31,0.68l-0.59,1.99l0.36,0.57l0.89,-0.07l1.95,-1.34l0.49,0.82l0.52,1.89l-0.51,1.13l0.12,0.49l2.11,1.59l1.04,3.13l-0.71,1.67l-3.52,-1.71l-6.61,-6.78l-4.46,-2.63l0.06,-1.09l-4.21,-4.94l-1.53,-2.43l0.32,-1.1l2.03,0.77l0.47,-0.22l-0.14,-0.5l-1.07,-0.72l1.97,-1.79l0.72,-1.58l-0.36,-0.57l-1.17,0.21l-1.02,1.3l-0.89,-0.31l1.73,-1.1l0.25,-0.45l-0.4,-0.33l-5.26,0.12l-0.23,-0.42l2.08,-2.02l0.09,-0.45l-0.39,-0.24l-4.58,0.24l-1.5,0.46l-0.28,0.38l0.17,1.15l1.37,0.98l1.0,1.51l1.53,1.28l1.74,0.05l-0.58,2.39l-0.04,1.95l-3.03,-4.56l-1.5,-1.65l-2.08,-0.76l-2.03,-0.18l-1.01,0.3l-0.01,-4.29l-0.24,-1.26l-1.04,-1.77l-0.67,0.1l-0.41,1.1l-1.28,1.38l1.39,5.29l-4.46,-3.8l-0.32,-0.66l1.34,0.41l0.51,-0.47l-0.6,-2.1l-0.74,-0.4l-1.83,-0.04l-0.75,-0.7l-1.3,-2.86l-1.86,-2.57l-2.07,-2.06l-4.15,-2.6Z",name:"Chanthaburi"},"TH-23":{path:"M543.09,901.0l1.95,-3.41l0.17,-1.35l-0.71,-0.88l-2.23,-1.25l-1.75,-3.24l0.02,-0.49l1.18,-1.63l0.46,-2.37l-1.95,-5.36l-0.01,-1.78l2.33,-3.01l1.03,-0.67l0.76,0.25l3.0,2.65l0.95,0.24l0.88,-0.43l0.19,-0.57l-0.23,-0.89l-1.79,-2.57l0.7,-1.58l-0.6,-1.53l-0.08,-4.53l1.36,-2.09l2.12,-1.86l1.42,-2.1l2.75,-0.43l0.94,-0.43l-0.42,1.45l-0.14,2.41l0.31,2.47l0.9,1.91l1.78,1.32l6.11,2.02l3.17,2.3l8.25,8.3l3.41,2.28l0.83,3.5l1.56,1.73l3.53,1.91l1.12,1.28l0.29,1.92l-0.83,1.38l-2.84,2.51l-1.15,2.08l-0.58,2.19l-2.49,18.06l0.84,4.5l5.62,8.7l2.15,2.59l1.7,3.73l1.11,5.52l4.98,9.56l7.66,11.03l1.2,4.27l0.39,6.1l-1.14,1.73l-0.52,-1.41l0.29,-5.61l-0.21,-2.63l-1.49,-3.24l-7.4,-9.8l-4.57,-3.78l-0.6,-0.97l0.0,-7.02l-1.15,-5.08l-1.94,-3.22l-12.69,-12.21l-0.07,-0.38l2.02,0.19l0.36,-0.64l-1.4,-1.87l-3.82,-2.99l0.11,-1.73l-0.6,-0.35l-4.76,2.11l-0.69,2.27l1.55,10.36l1.36,2.69l0.17,0.62l-0.26,0.82l-2.8,-1.05l0.03,-3.17l-2.06,-2.71l-3.12,-2.25l-3.37,-1.75l-11.66,-4.08l-1.84,-1.1l-1.92,-0.03l-1.15,1.72l-3.16,-1.36l-0.34,-0.75l0.4,-2.12l-0.78,-2.29l-1.92,-3.24l-0.16,-1.33l2.57,0.58l2.85,-0.98l2.29,-1.78l1.83,-1.97l0.86,-2.58l-0.41,-1.32ZM565.51,970.96l-0.61,1.36l0.4,0.56l2.52,-0.21l1.59,2.51l0.23,3.76l-1.79,3.36l0.0,0.75l0.4,0.4l0.81,0.0l-0.87,2.01l0.33,2.5l-0.69,-0.45l-0.8,-1.7l-0.77,-0.88l-4.03,-1.37l0.99,-1.23l0.29,-0.88l-0.07,-1.47l-1.38,-3.48l-0.08,-0.93l2.44,-8.28l0.53,0.28l0.4,1.05l0.17,2.33ZM532.51,923.99l3.27,0.77l1.9,-0.07l3.32,2.38l1.31,1.31l1.15,1.43l2.21,4.34l1.36,0.99l0.12,0.75l4.58,6.35l-0.17,1.42l-1.08,0.49l-1.57,-0.98l-3.42,-3.41l-0.67,0.18l-0.34,1.28l0.06,2.01l-1.2,0.3l-1.3,-0.15l-4.11,-1.33l-0.52,0.38l0.07,0.87l-1.49,-0.49l0.41,-1.87l0.01,-6.83l-1.09,-1.33l-2.8,-6.54l0.88,0.0l0.35,-0.6l-1.21,-1.67Z",name:"Trat"},"TH-20":{path:"M381.55,867.91l0.55,-1.62l-0.39,-0.48l-1.52,0.0l1.13,-2.42l-0.34,-0.59l-2.44,-0.59l1.72,-4.46l1.2,-1.76l1.64,0.8l1.18,-0.15l2.55,-3.42l0.52,-2.04l-0.15,-1.83l-0.61,-1.71l-4.82,-7.24l-0.38,-1.28l0.3,-0.81l2.64,-2.22l0.66,-3.3l0.88,0.3l1.27,-0.63l1.11,-1.21l0.61,-1.32l-0.11,-2.81l-2.34,-3.36l-0.63,-1.95l-0.67,-0.85l-1.84,-0.71l-0.34,-0.8l2.2,-2.88l1.74,-3.2l2.33,-3.26l0.92,-2.05l-0.09,-2.21l-1.18,-3.97l-2.26,-4.1l0.2,-0.96l1.01,-1.26l0.85,-2.32l3.48,-1.12l1.89,-1.38l0.46,-1.62l0.19,-2.55l-0.22,-2.45l-1.5,-2.18l0.73,-2.16l2.15,-0.47l2.0,-1.08l1.0,-1.71l1.39,-0.62l0.6,-1.0l0.81,-0.58l0.37,-1.07l-0.53,-2.36l0.28,-0.67l3.25,-0.21l1.78,-1.28l1.78,-0.27l2.05,-2.67l0.79,-0.28l5.78,2.31l8.3,1.97l2.31,2.28l1.93,3.45l2.6,1.85l2.74,2.7l1.37,0.35l2.84,-0.38l2.09,3.01l1.9,1.61l1.47,0.69l1.53,0.24l2.45,-0.9l3.19,1.62l2.69,3.78l1.68,3.48l2.19,1.11l2.7,2.17l3.24,1.33l4.7,4.71l3.72,6.46l0.25,1.82l-2.11,2.28l-0.44,1.46l-3.1,-1.37l-2.59,-0.34l-0.81,0.26l-1.32,1.05l-3.32,1.05l-1.12,0.95l-0.48,3.2l-1.13,1.32l-2.83,1.7l-3.18,-0.69l-0.9,0.21l-2.12,2.68l-1.81,1.45l-0.71,-0.0l-2.04,-0.88l-0.63,0.08l-2.93,2.06l-1.06,0.33l-0.77,-0.44l-2.64,-2.95l-2.07,-1.57l-1.24,-0.55l-1.62,-0.42l-1.13,0.1l-3.0,2.44l-0.55,0.08l-2.09,-0.96l-2.46,-0.53l-1.66,-0.93l-3.7,-0.83l-1.42,0.55l-1.28,1.57l0.13,1.47l1.53,1.75l-0.63,0.8l-1.18,0.31l-6.31,-0.98l-1.6,0.58l-1.85,1.75l-0.26,0.97l2.01,1.87l0.43,0.87l0.27,1.08l-0.35,2.59l0.72,2.22l-0.07,1.15l-0.96,1.71l-2.79,2.44l-0.4,3.1l-0.67,1.16l-4.45,3.47l-0.76,0.96l-0.4,4.54l-1.19,2.46l-1.59,6.72l0.03,2.43l0.37,1.2l-0.32,3.76l-4.44,-1.97l1.43,-1.32l0.13,-0.46l-0.85,-2.03l-1.84,-1.07l-2.16,0.98l-1.21,-0.61l-2.0,0.44Z",name:"Chon Buri"},"TH-21":{path:"M393.32,869.39l-0.13,-2.71l1.56,-6.6l1.2,-2.49l0.36,-4.41l5.11,-4.27l0.82,-1.49l0.29,-2.83l2.7,-2.32l1.16,-2.07l0.08,-1.44l-0.72,-2.2l0.35,-2.52l-0.3,-1.29l-0.57,-1.15l-1.84,-1.66l1.81,-1.8l1.14,-0.41l6.2,0.98l1.67,-0.42l0.79,-0.76l0.22,-0.86l-1.46,-1.71l-0.27,-0.89l0.34,-0.76l1.25,-1.0l0.88,-0.05l2.96,0.78l1.63,0.92l2.08,0.42l3.02,1.14l0.75,-0.25l2.76,-2.32l2.28,0.32l3.03,1.98l2.58,2.89l1.37,0.68l1.39,-0.41l2.75,-2.0l1.04,0.1l1.62,0.77l0.84,-0.11l2.08,-1.63l2.09,-2.61l3.16,0.65l1.3,-0.29l2.4,-1.57l1.18,-1.19l0.9,-3.87l3.84,-1.37l1.78,-1.23l2.33,0.29l3.16,1.4l-0.48,2.51l0.68,2.82l2.15,5.53l0.87,1.04l2.21,0.53l1.0,1.47l-1.24,2.62l0.0,1.48l0.48,1.55l1.23,1.2l0.99,0.03l1.4,-0.46l1.38,0.93l0.61,0.88l1.25,3.96l1.97,0.73l0.47,5.62l-1.18,6.41l-0.02,1.61l-1.68,1.54l-0.07,2.02l-0.86,1.11l-0.41,2.19l-2.32,-0.75l-6.69,-0.22l-2.1,0.66l-1.32,1.63l-1.7,3.07l-1.73,0.88l-2.09,0.18l-4.59,-0.3l-1.07,0.6l-0.11,1.51l-0.28,0.21l-2.91,-0.05l-3.36,-0.79l-4.83,0.75l-2.56,0.92l-1.15,1.23l-0.41,1.77l-0.74,0.09l-2.67,-1.72l-7.6,-3.38l-8.14,-1.98l-17.47,-2.26l-2.53,0.53l-3.69,2.09l-4.64,0.83l-1.03,0.88Z",name:"Rayong"},"TH-62":{path:"M276.4,421.67l-1.15,4.48l-0.05,1.64l0.93,2.35l1.77,2.95l1.03,0.69l1.73,0.01l2.62,1.45l2.22,0.46l1.43,0.9l2.16,2.31l1.18,3.99l-4.15,11.18l-1.67,3.09l0.12,1.19l1.58,2.1l-4.32,4.87l-1.16,1.88l-0.26,2.8l0.31,1.86l-1.18,4.2l-3.91,8.64l-0.52,4.76l-6.83,5.91l-2.71,3.8l-1.85,3.8l-2.54,3.67l-0.61,3.16l-3.4,7.67l-1.58,0.52l-3.8,3.33l-0.86,0.3l-1.65,-1.52l-0.74,-1.23l-1.21,-4.76l-0.6,-1.52l-1.15,-1.58l-1.65,-1.05l-3.74,-1.2l-2.52,-1.7l-1.94,0.01l-1.7,-0.39l-3.4,0.48l-1.96,2.18l-4.34,-1.46l-2.03,0.2l-5.37,-0.91l-2.91,0.9l-1.34,-0.28l-0.9,0.16l-2.93,2.23l-1.16,-1.42l-2.03,-1.08l-2.89,-2.25l-1.93,-0.46l-2.29,0.41l-0.6,0.44l-2.15,0.11l-2.78,2.58l-1.86,0.13l-0.9,0.39l-2.65,2.69l-0.27,-2.81l0.46,-2.67l-1.67,-3.03l0.58,-3.22l-0.08,-1.57l-1.09,-1.45l-2.19,-0.56l-1.12,-1.22l-1.97,-10.71l0.16,-1.64l1.38,-3.61l0.06,-2.02l-0.28,-1.59l-1.32,-1.01l-0.62,-1.07l-0.8,-5.36l0.03,-1.4l1.11,-4.58l0.7,-7.37l-0.28,-1.81l-1.62,-1.85l-0.89,-2.64l-0.03,-1.63l0.66,-1.27l0.65,-0.53l2.41,0.43l2.91,-0.41l3.17,0.99l2.35,-0.16l1.25,-0.4l5.51,-3.3l1.63,-2.42l4.9,-0.6l2.11,-1.53l1.12,-2.07l0.36,-1.54l-0.96,-5.37l0.26,-3.19l2.18,-2.19l1.3,-3.38l1.67,-2.31l0.4,-1.48l-0.44,-3.17l0.24,-2.13l1.92,-1.39l1.1,-1.84l0.39,-1.38l-0.03,-2.7l1.52,-3.75l2.77,1.86l1.44,0.37l5.85,-1.51l5.89,-0.46l2.44,0.29l1.06,0.61l1.34,1.48l0.38,1.0l0.25,2.79l0.89,1.43l14.96,9.28l1.74,0.25l3.96,-0.58l11.54,-0.07l0.82,0.34l4.62,4.75Z",name:"Kamphaeng Phet"},"TH-63":{path:"M60.95,324.79l1.3,-1.18l4.52,-0.2l1.46,-0.48l1.92,-1.49l13.21,-6.2l0.95,-0.25l7.67,0.07l1.07,-0.8l1.14,-1.5l2.06,-1.59l1.2,-0.54l5.02,-1.06l-0.51,1.16l-2.76,2.05l-0.94,1.33l-0.39,1.94l0.05,4.44l0.18,1.6l0.6,0.92l1.13,0.16l1.5,-0.38l1.83,0.74l1.75,4.94l0.22,1.66l-1.12,7.04l0.4,0.79l1.49,0.74l0.38,0.73l-0.32,0.76l-1.5,1.04l-0.48,1.28l1.79,2.46l0.95,3.7l-0.03,1.63l-0.47,1.5l0.11,1.1l1.4,1.55l2.18,0.98l1.29,1.24l1.75,0.85l1.36,1.32l1.01,0.38l1.53,-0.0l4.29,-2.13l4.04,-0.26l2.84,-0.68l3.49,-1.21l0.73,-0.73l0.62,-2.51l-0.18,-3.53l-0.58,-0.82l-1.64,-0.74l-0.11,-0.44l1.57,-3.46l0.22,-3.26l-0.93,-1.88l-2.01,-1.73l-0.49,-0.79l-0.28,-2.61l0.39,-3.08l1.1,-2.94l0.94,-1.45l2.29,-1.07l3.44,-0.67l1.8,-2.69l0.31,-1.42l-0.16,-0.93l-1.19,-1.94l-0.55,-3.06l0.64,-1.07l3.42,-2.89l0.41,-1.25l-0.19,-1.5l0.45,-0.94l0.96,-0.8l2.67,-0.88l2.08,-1.09l3.08,4.72l0.47,1.32l0.0,1.32l-0.74,0.98l-3.42,1.07l-0.86,1.73l0.04,1.55l0.73,1.21l-0.7,2.02l1.42,5.12l0.0,6.89l1.26,2.23l2.69,0.28l2.96,-0.14l6.13,-2.29l4.34,-3.63l1.0,-3.24l1.39,-1.68l0.38,-4.04l1.11,-1.76l1.2,-0.83l1.26,-0.37l3.98,0.22l1.34,0.62l3.36,2.62l-0.13,1.57l1.56,3.57l0.86,5.87l-0.08,1.1l-1.7,5.19l-0.43,3.61l0.41,1.69l1.57,0.92l1.34,1.96l2.97,1.56l2.34,0.23l2.1,1.36l2.31,0.05l3.89,2.19l0.82,0.17l3.32,-3.3l0.78,-2.38l1.1,-1.22l1.22,-0.53l2.39,0.14l1.38,0.65l0.26,1.05l-0.3,2.77l0.89,3.79l4.25,7.0l-0.36,12.07l0.08,1.55l0.92,1.81l-0.39,1.2l-2.29,1.95l-2.04,3.71l-0.15,0.77l0.51,4.4l-0.35,2.75l-1.05,2.91l0.05,1.32l1.06,2.73l3.16,1.04l2.64,2.89l1.13,0.62l-1.13,2.25l-0.47,1.7l0.02,2.76l-0.33,1.18l-0.94,1.59l-1.6,0.95l-0.49,0.72l-0.29,2.4l0.44,3.11l-0.35,1.25l-1.64,2.26l-1.26,3.3l-0.72,0.87l-0.81,0.4l-0.71,1.07l-0.3,3.46l0.97,5.29l-0.3,1.29l-1.0,1.87l-1.46,1.16l-5.3,0.77l-0.68,0.57l-1.07,1.91l-5.33,3.2l-3.25,0.51l-3.14,-0.98l-2.97,0.41l-2.56,-0.42l-1.15,0.81l-0.85,1.67l0.05,1.95l0.92,2.73l1.49,1.66l0.29,0.82l-0.0,2.88l-0.63,5.26l-1.1,4.52l-0.05,1.57l0.84,5.59l0.73,1.3l1.26,0.92l0.13,0.42l0.03,2.65l-1.36,3.52l-0.21,1.49l1.76,10.74l1.18,1.88l1.17,0.65l1.3,0.14l0.98,1.09l0.07,1.32l-0.59,3.4l1.68,3.08l-0.47,2.53l0.91,7.29l0.59,1.46l3.32,2.69l0.23,0.84l-0.11,5.32l0.42,2.34l-1.64,4.48l-0.72,6.19l-1.78,2.72l-1.5,3.13l-2.83,1.95l-0.39,0.66l0.09,4.36l0.52,0.81l1.57,1.08l0.35,0.66l-1.26,3.65l-0.35,4.69l0.53,2.27l-1.71,2.98l-1.79,6.27l-0.32,3.03l-0.58,1.67l-2.05,3.52l-1.42,1.21l-4.4,-3.42l-4.75,-2.42l-1.94,-4.0l-4.46,-5.56l-3.15,-5.21l-3.18,-2.68l-0.52,-2.32l-0.68,-1.45l-4.29,-2.93l-0.21,-0.32l1.06,-0.75l-0.23,-1.31l-7.31,-11.53l-0.84,-0.77l-1.69,-0.16l-1.41,-0.96l-2.16,-0.62l-2.58,-2.08l-4.19,-1.71l-0.38,-3.82l0.29,-2.52l3.4,-11.21l0.24,-2.14l-0.79,-4.64l-0.08,-2.58l1.64,-6.3l-0.81,-2.51l-2.87,-4.08l-0.27,-1.17l0.66,-0.61l3.58,1.06l2.38,-0.13l0.96,-0.5l1.33,-1.12l1.51,-2.18l1.55,-4.0l2.07,-1.0l1.79,-0.08l6.55,0.84l2.83,1.87l1.67,-0.22l1.19,-0.8l2.56,-2.79l0.57,-1.08l0.17,-5.05l0.66,-2.1l4.42,-5.62l0.55,-1.84l0.51,-5.02l1.07,-4.83l-0.15,-2.34l-1.87,-2.73l-2.59,-1.7l-1.9,-1.85l-0.4,-3.65l-0.65,-0.26l-2.37,2.0l-0.93,1.89l-0.9,4.54l-1.39,2.52l-6.48,5.1l-3.28,4.85l-1.45,1.06l-1.74,-1.23l-0.62,-1.52l-1.57,-7.98l-1.4,-3.26l-0.12,-1.04l1.04,-2.22l0.2,-1.29l-0.91,-2.24l-7.28,-9.85l0.38,-3.27l-0.75,-2.4l-1.66,-2.14l-3.72,-2.54l-1.42,-2.01l-1.31,-4.29l-3.2,-2.53l-0.18,-1.71l0.8,-2.0l1.19,-1.69l1.56,-0.46l1.76,-1.11l1.49,-1.61l0.24,-1.61l-0.95,-1.01l-1.86,-0.9l-0.39,-1.11l0.22,-1.3l0.57,-0.35l2.77,1.21l0.15,-0.44l-1.66,-4.76l-2.73,-1.59l-0.38,-3.22l-0.67,-1.62l-1.21,-1.53l-2.99,-5.36l-2.04,-2.01l-2.02,-1.29l-2.29,-0.68l-5.37,-0.14l-1.74,-0.53l-1.37,-1.31l-1.27,-2.2l0.83,-1.27l-0.05,-1.11l-0.39,-0.35l-2.51,-0.02l-0.13,-0.54l0.43,-1.09l0.84,-0.93l-0.07,-0.6l-2.4,-1.64l-3.86,-5.51l-3.79,-2.63l-9.22,-8.7l-0.78,-0.97l-0.21,-1.29l0.45,-3.71l-0.68,-1.75l-1.45,-1.0l-3.02,-1.27l-1.35,-1.41l-1.87,-4.72l-2.37,-3.68l-0.55,-1.77l-0.96,-1.09l-5.36,-3.0l-2.45,-2.26Z",name:"Tak"},"TH-60":{path:"M368.73,506.32l0.23,2.87l0.55,1.18l2.46,1.17l0.93,0.87l0.5,1.04l-0.52,3.44l0.22,3.15l1.34,6.79l1.05,3.43l1.34,2.97l-1.12,2.49l1.21,2.83l0.16,1.1l-3.06,3.58l-0.89,4.19l-0.68,1.2l-1.21,1.24l-2.39,0.99l-0.98,0.9l-0.85,2.33l1.06,3.68l0.09,1.34l-0.64,1.44l-1.67,2.06l-11.97,10.98l-2.99,3.64l-1.69,0.88l-1.75,1.77l-2.66,3.7l-0.7,3.75l-3.25,2.14l-0.82,1.0l-0.14,3.7l-1.11,2.73l-2.73,3.04l-1.03,2.05l-6.27,-2.54l-1.68,-1.05l-1.44,-2.87l0.38,-1.76l-0.84,-1.98l-0.87,-0.71l-3.27,-0.79l-5.0,-13.23l-3.5,-5.29l-3.11,-2.85l-3.69,-1.49l-5.56,-5.32l-1.29,0.25l-5.19,-0.11l-1.22,-2.84l-8.05,-6.73l-2.2,-0.89l-1.88,0.71l-2.97,-1.44l-3.82,-4.73l-0.94,-5.9l-0.44,-1.48l-0.52,-0.53l-1.41,-0.17l-1.2,0.39l-1.17,0.83l-1.35,-0.08l-3.51,-1.42l-3.56,-3.47l-1.69,-1.1l-3.61,0.09l-4.09,1.71l-3.86,3.33l-4.16,1.53l-3.21,3.99l-3.75,2.26l-0.97,0.31l-4.03,-0.29l-4.8,-3.95l-5.31,-2.73l-1.34,-3.3l-9.43,-4.52l-1.1,-0.97l-2.92,-1.5l-0.82,-0.72l-0.75,-1.41l-2.85,-2.18l-2.32,-1.34l-2.04,-0.73l-4.08,0.37l0.06,-2.14l-0.28,-1.09l-3.48,-2.94l-0.9,-4.34l2.97,-3.1l2.7,-0.49l2.77,-2.57l1.99,-0.04l0.64,-0.46l2.14,-0.38l1.37,0.32l2.88,2.24l1.99,1.05l0.82,1.19l0.79,0.41l0.81,-0.25l2.55,-2.06l1.98,0.19l2.87,-0.89l5.22,0.91l1.88,-0.23l4.21,1.5l1.15,-0.28l1.58,-2.01l2.0,-0.38l2.62,0.39l1.48,-0.11l2.66,1.71l3.8,1.23l1.44,0.91l0.98,1.37l1.45,5.5l1.13,2.07l2.03,1.83l1.57,-0.37l3.57,-3.17l1.71,-0.61l0.75,-0.81l3.11,-7.37l0.56,-3.05l2.5,-3.62l1.85,-3.8l1.9,-2.89l7.44,-6.46l0.47,-1.13l0.32,-4.13l3.9,-8.62l1.23,-4.37l-0.3,-2.02l0.24,-2.57l1.0,-1.57l4.22,-4.76l1.37,1.06l1.39,2.36l0.97,4.88l-0.49,1.02l0.24,2.14l1.54,6.17l3.77,2.52l1.3,1.39l0.03,2.88l2.89,4.36l2.19,6.9l3.26,6.37l2.97,1.55l2.33,1.96l1.11,0.27l1.36,-0.48l2.61,1.91l2.14,0.27l1.94,-0.44l0.3,-0.35l0.26,-2.74l1.04,-0.4l1.46,0.18l2.74,0.95l2.53,-0.26l3.7,1.39l1.11,0.14l4.31,-0.55l5.14,0.26l1.66,-0.88l2.38,0.12l2.02,-1.06l4.34,-1.1l2.74,0.57l3.93,0.12l5.62,1.6l3.82,0.15Z",name:"Nakhon Sawan"},"TH-61":{path:"M293.01,564.46l-2.18,-0.11l-0.78,0.95l0.42,1.49l2.3,1.81l1.78,2.92l0.06,2.47l-1.43,3.33l0.12,1.73l0.4,0.37l-0.28,0.14l-0.45,-0.06l-0.43,-1.28l-0.66,-0.66l-4.58,-1.32l-3.19,0.23l-2.14,-0.38l-1.95,0.08l-4.91,1.0l-2.65,-1.83l-9.24,-1.2l-1.51,-0.53l-0.97,0.2l-1.25,1.17l-2.47,1.47l-0.69,1.25l-0.04,1.48l1.23,2.89l0.74,4.94l1.0,1.65l0.99,2.61l4.56,7.12l1.29,1.15l-0.15,0.79l-1.82,3.29l-1.92,1.07l-1.99,1.91l-1.68,0.54l-1.46,1.89l-0.22,1.38l0.74,1.71l-0.32,0.83l-5.7,-2.77l-2.13,-0.64l-2.43,0.7l-0.56,0.52l0.68,4.02l-1.5,0.17l-5.54,-1.44l-2.64,-0.91l-2.52,-1.68l-10.46,-2.19l-0.73,-2.8l-0.53,-0.89l-6.31,-1.88l-2.11,-2.04l-0.98,-0.38l-1.41,0.57l-1.97,1.98l-0.65,3.24l-0.92,2.33l-3.12,0.74l-1.05,-0.12l-0.84,-0.55l-4.73,-1.54l-2.67,0.21l-3.08,-1.31l-4.12,0.93l-2.43,0.2l-1.61,-2.21l-6.01,-4.87l-0.81,-1.77l-0.24,-3.03l0.29,-1.82l-0.69,-2.79l-0.09,-3.21l-0.55,-2.86l1.61,-1.39l2.14,-3.69l0.64,-1.85l0.3,-2.99l1.77,-6.19l1.41,-2.33l0.39,-1.27l-0.58,-1.9l0.35,-4.59l1.26,-3.88l-0.58,-1.1l-1.89,-1.56l-0.23,-3.31l0.33,-0.89l2.92,-2.06l1.51,-3.15l1.86,-2.91l0.74,-6.25l1.66,-4.55l-0.41,-2.52l0.04,-2.35l3.98,-0.37l4.05,1.95l2.69,2.05l0.7,1.35l1.02,0.91l2.94,1.51l1.13,0.99l9.25,4.4l1.37,3.31l5.42,2.81l4.4,3.74l1.3,0.45l3.6,0.16l1.34,-0.42l3.86,-2.33l3.16,-3.95l4.07,-1.48l3.89,-3.35l3.82,-1.61l3.24,-0.1l0.57,0.27l4.44,4.17l3.76,1.53l1.44,0.18l1.96,-1.13l1.38,-0.2l0.36,0.27l0.4,1.34l0.99,6.03l2.93,3.87l1.82,1.69l2.55,1.04l0.69,-0.0l1.38,-0.68l1.82,0.76l7.89,6.6l1.14,2.76l-0.04,1.78Z",name:"Uthai Thani"},"TH-66":{path:"M359.33,459.76l1.94,5.06l1.25,5.3l-0.31,1.47l-0.86,1.69l-5.38,7.17l-0.48,2.29l0.5,4.58l-0.85,4.8l0.54,0.72l7.97,2.32l3.62,2.1l2.85,2.26l0.17,1.68l-1.48,4.29l-3.73,-0.12l-5.65,-1.61l-3.98,-0.13l-2.85,-0.57l-4.55,1.14l-1.94,1.04l-2.47,-0.1l-1.53,0.85l-5.02,-0.27l-4.32,0.55l-4.63,-1.52l-2.61,0.24l-2.67,-0.94l-1.66,-0.19l-1.72,0.81l-0.32,2.78l-2.76,0.34l-3.17,-2.13l-0.61,-0.1l-1.09,0.52l-0.71,-0.18l-2.27,-1.92l-2.74,-1.33l-3.18,-6.22l-2.2,-6.92l-2.87,-4.29l0.21,-2.17l-0.27,-0.79l-1.53,-1.67l-3.55,-2.26l-1.46,-5.91l-0.21,-1.95l0.48,-1.16l-1.01,-5.07l-1.51,-2.59l-1.73,-1.36l-0.46,-1.01l-1.31,-1.5l0.32,-1.12l1.36,-2.25l4.12,-11.12l2.7,-0.43l3.39,-1.16l2.76,-0.36l5.04,-5.16l1.18,-0.85l2.51,-1.44l4.31,-1.41l1.59,0.95l0.78,3.44l0.0,1.37l0.57,0.36l1.14,-0.57l0.4,0.89l0.11,1.97l0.92,0.87l2.16,-0.7l0.89,-1.01l2.45,0.79l8.91,-2.16l4.46,0.97l6.12,-1.05l1.46,0.09l0.74,0.4l0.8,0.69l0.91,1.66l0.76,2.42l1.79,3.84l0.17,3.04l1.77,2.07l7.55,6.95Z",name:"Phichit"},"TH-67":{path:"M480.91,413.28l-0.32,4.01l-1.33,2.66l-1.85,2.04l-0.57,1.2l-1.42,0.71l-0.86,0.89l-1.29,-0.73l-2.42,-2.41l-2.08,-0.55l-1.54,-0.03l-3.31,0.55l-1.19,-0.6l-1.27,-1.42l-0.82,-0.27l-2.84,1.59l-1.9,2.01l-0.59,0.04l-3.0,-1.14l-1.59,0.84l-0.37,1.4l0.11,1.26l0.91,2.05l-0.5,1.23l-1.41,0.97l-0.35,3.86l0.28,1.68l1.42,1.39l0.0,0.41l-5.08,3.67l-0.22,1.31l0.49,2.08l-0.38,1.15l-1.29,1.64l-0.99,1.95l-4.38,4.06l-0.28,0.82l0.19,1.71l-2.54,2.95l-1.81,8.4l-1.53,2.56l0.56,1.14l1.29,1.04l0.08,0.56l-2.36,3.69l0.17,2.76l-2.35,12.24l0.57,5.89l1.33,3.84l1.38,1.05l2.91,0.69l0.41,0.63l-1.2,2.89l-1.27,4.77l-3.33,3.13l-0.43,0.87l-0.1,1.38l0.37,9.76l0.4,1.43l3.12,2.81l2.88,0.44l0.74,1.41l-0.33,1.91l-1.7,4.99l-0.78,4.01l-0.47,4.73l0.94,6.41l-0.14,9.44l-3.26,7.3l-0.94,1.24l-3.29,3.45l-3.72,-3.05l-0.8,-1.2l-0.57,-3.22l-0.9,-1.89l-1.19,-1.13l-4.09,-0.81l-4.65,1.38l-2.59,-0.31l-4.81,-3.48l-2.52,0.21l-1.45,-0.35l-1.41,-1.65l-6.21,-4.32l-2.42,-0.09l-3.1,0.42l-5.52,1.44l-5.2,-1.51l-9.07,-1.9l0.63,-1.54l0.61,-0.56l2.2,-0.85l1.7,-1.63l0.81,-1.47l0.83,-4.05l3.09,-3.61l-0.14,-1.65l-1.17,-2.61l1.11,-1.88l0.0,-0.7l-1.38,-3.12l-1.04,-3.39l-1.32,-6.71l-0.21,-2.99l0.54,-2.62l-0.23,-1.62l-1.51,-1.75l-2.35,-1.08l-0.39,-0.79l-0.26,-3.16l1.55,-4.49l0.01,-1.95l-2.18,-2.06l-4.88,-2.95l-7.99,-2.35l0.76,-4.77l-0.5,-5.02l0.43,-1.57l0.72,-1.22l4.56,-5.77l1.15,-2.51l0.08,-2.38l-1.19,-4.3l-1.9,-4.96l2.55,-3.34l1.05,-3.71l2.37,-0.65l4.84,-3.2l2.68,-0.97l1.18,-3.25l3.6,-5.43l0.67,-1.57l0.16,-1.5l-0.8,-4.07l1.96,-5.22l1.8,-1.89l3.7,-0.9l2.11,-2.12l-0.02,-0.79l-1.21,-1.69l0.04,-2.07l-0.82,-1.72l-0.01,-1.05l-1.46,-2.12l0.42,-2.36l0.76,-0.46l1.69,-0.03l0.92,-0.5l5.02,-5.1l2.3,-1.27l4.04,-4.94l6.69,-0.34l0.9,-0.83l0.28,-0.74l1.41,-0.66l0.42,-0.86l-0.05,-2.66l0.94,-3.8l-0.75,-2.74l0.2,-1.55l0.94,-0.6l2.2,-0.09l1.49,-0.83l2.6,-4.29l0.23,-1.04l-0.15,-1.82l1.34,-0.6l10.04,4.02l1.82,1.63l2.88,-0.95l1.25,-0.09l3.13,0.52l1.39,-0.7l3.5,1.02l2.23,-1.1l0.8,0.03l4.05,2.41l2.36,0.89l2.31,5.02l2.35,0.96l2.43,-0.26l2.26,-1.03l0.64,-0.65l0.94,-2.14l0.86,-1.15l1.06,-0.74l0.47,0.0l0.37,0.31l0.66,2.29l3.16,6.84l2.82,3.15l0.49,1.32l0.55,3.32l-0.42,6.26l0.97,3.11l-0.57,2.98l0.37,1.53l0.48,0.57l1.03,0.45l5.86,-0.77Z",name:"Phetchabun"},"TH-64":{path:"M275.88,297.37l2.59,2.32l0.29,0.93l-0.39,1.35l0.13,0.9l0.85,1.23l1.81,1.45l2.38,2.68l0.8,3.11l0.06,1.65l-1.07,5.18l-1.31,1.59l-2.56,1.71l-0.27,0.56l0.09,1.15l2.38,3.55l1.49,0.59l1.03,2.26l2.54,1.83l2.32,2.66l1.6,3.72l-1.04,1.77l-2.1,0.6l-0.64,0.7l0.29,1.77l1.34,1.8l0.08,5.81l-1.26,3.67l-2.43,2.06l-1.19,2.25l0.08,0.96l0.83,1.53l0.49,2.62l-0.13,4.67l-1.12,0.37l-2.07,-0.54l-3.28,0.16l-0.89,0.69l-0.11,0.89l1.74,4.03l2.36,1.42l1.6,3.01l5.01,4.33l4.44,2.81l3.66,1.87l4.24,3.15l0.59,1.38l-1.0,3.57l0.81,2.07l-0.96,0.74l-5.73,-0.15l-3.53,0.7l-0.92,1.12l-0.39,2.68l-2.36,-0.67l-2.04,0.17l-2.18,-0.45l-0.73,0.21l-3.99,9.35l-0.55,0.93l-1.06,0.41l-1.21,0.96l-0.53,1.12l-0.02,1.57l0.56,0.74l4.45,1.27l0.5,0.6l-0.48,1.19l-2.82,1.33l-4.58,-4.7l-1.22,-0.56l-11.72,0.05l-3.51,0.57l-1.8,-0.15l-14.8,-9.17l-0.65,-1.06l-0.23,-2.67l-0.46,-1.23l-0.98,-1.24l-1.33,-0.99l-3.27,-0.59l-5.96,0.46l-5.66,1.5l-1.14,-0.28l-4.47,-2.73l-2.73,-2.96l-3.07,-0.98l-0.88,-2.82l1.22,-4.06l0.21,-2.18l-0.39,-4.98l1.94,-3.5l2.22,-1.86l0.5,-1.01l0.07,-1.23l-0.91,-1.44l-0.08,-1.42l0.35,-11.7l2.01,0.26l0.69,0.37l1.61,1.83l1.54,2.99l1.61,0.77l0.85,-0.17l0.82,-0.71l1.94,-0.61l2.49,-1.5l0.33,-1.52l0.85,-0.74l0.45,-1.05l-0.29,-2.77l0.33,-1.97l1.78,-1.85l0.59,-1.18l0.09,-1.89l-0.75,-2.38l-2.25,-1.12l-1.13,-1.33l-1.11,-0.71l0.85,-4.15l-1.6,-1.25l-1.17,-2.36l0.56,-5.04l1.74,-1.35l0.32,-0.74l-0.69,-3.39l-1.4,-0.99l0.27,-2.97l0.49,-0.59l2.13,0.26l0.92,-0.77l-0.33,-1.92l0.15,-2.06l2.54,-4.0l-0.05,-1.72l0.42,-2.13l-0.62,-2.28l5.83,-7.1l2.57,-1.47l3.83,-0.81l1.07,-0.13l2.05,0.46l4.48,1.72l3.76,4.24l1.15,0.88l1.04,2.14l1.79,1.15l1.16,-0.17l1.6,-1.66l0.91,-2.26l2.28,-2.88l3.64,-1.56l8.16,-0.56Z",name:"Sukhothai"},"TH-65":{path:"M359.52,331.13l1.34,-1.16l4.72,-2.18l3.11,-3.06l3.18,-5.17l6.11,-4.64l1.65,-3.71l2.38,-2.8l0.72,-0.31l0.88,0.1l0.87,1.64l1.42,0.46l4.11,-1.28l-1.96,4.39l-3.59,4.16l-1.59,2.63l0.2,2.78l1.9,1.4l3.4,0.63l-0.87,1.62l-2.42,1.84l-0.42,3.33l-2.1,2.87l0.29,1.18l1.75,2.47l0.77,4.52l-0.69,3.02l0.09,2.66l0.46,0.96l1.49,0.93l1.78,-0.33l2.3,0.56l2.33,-0.26l1.05,0.19l1.66,2.38l2.03,1.03l1.64,2.53l3.34,0.73l2.52,4.31l-0.0,1.05l-0.59,1.88l-1.77,2.54l-0.46,1.3l-1.01,6.05l-1.53,4.24l-0.53,6.1l-1.55,2.18l1.6,3.07l-0.31,1.31l-0.86,0.77l0.01,0.94l1.65,1.39l1.72,0.71l0.43,0.48l0.17,1.21l-2.18,-0.08l-0.87,0.27l-4.17,5.05l-2.26,1.24l-5.03,5.1l-0.96,0.39l-0.84,-0.14l-1.06,0.29l-0.67,0.64l-0.59,2.12l0.09,0.9l1.36,1.85l0.1,1.27l0.81,1.68l-0.02,2.15l1.24,1.95l-1.82,1.76l-3.63,0.85l-2.12,2.21l-2.05,5.51l0.8,4.26l-0.13,1.19l-0.58,1.38l-3.61,5.46l-1.08,2.39l0.01,0.68l-2.46,0.82l-4.8,3.18l-2.26,0.51l-0.75,1.02l-0.77,3.14l-2.38,3.11l-7.28,-6.7l-1.63,-1.91l-0.1,-2.85l-1.81,-3.9l-0.77,-2.46l-1.07,-1.89l-1.94,-1.32l-1.71,-0.11l-6.02,1.04l-4.55,-0.97l-8.88,2.14l-2.54,-0.8l-1.21,1.16l-1.63,0.56l-0.35,-2.21l-0.75,-1.48l-0.55,-0.1l-0.78,0.45l-0.81,-4.46l-1.7,-1.25l-0.93,-0.21l-4.34,1.46l-2.66,1.52l-1.29,0.93l-4.86,5.03l-2.56,0.28l-3.44,1.18l-2.48,0.4l-1.19,-3.96l-2.31,-2.51l-1.67,-1.06l-2.21,-0.45l-2.66,-1.47l-2.08,-0.15l-2.01,-3.1l-0.85,-2.04l0.03,-1.44l1.15,-4.49l2.98,-1.41l0.93,-1.63l-0.35,-1.02l-0.65,-0.54l-4.28,-1.15l-0.34,-0.4l0.03,-1.16l0.79,-1.19l1.85,-0.92l0.64,-1.08l3.86,-9.13l2.28,0.43l2.02,-0.18l1.54,0.61l1.11,0.05l0.61,-0.57l0.34,-2.66l0.47,-0.61l3.24,-0.65l6.04,0.09l0.92,-0.52l0.49,-0.75l0.06,-0.66l-0.85,-1.65l1.0,-3.6l-0.36,-1.29l-0.54,-0.66l-4.29,-3.19l-3.69,-1.9l-4.4,-2.78l-4.92,-4.26l-1.53,-2.95l-2.49,-1.62l-1.02,-2.1l-0.37,-1.72l2.03,-0.46l4.02,0.54l3.97,-1.77l0.62,0.15l1.41,1.19l0.81,0.09l12.55,-3.81l2.13,-0.26l0.8,0.62l1.15,0.33l1.88,-0.57l5.04,-3.87l0.83,-1.0l0.39,-1.67l-1.47,-6.51l0.48,-1.52l1.13,-1.63l3.31,-2.79l1.88,-0.61l2.47,0.38l1.61,-1.49l10.37,-3.72l4.47,-0.07l1.02,1.44l0.64,0.23l7.56,-1.74l1.84,-0.97l2.32,-3.7l5.6,-4.13l0.39,-0.61Z",name:"Phitsanulok"},"TH-35":{path:"M767.78,567.63l0.35,2.7l-1.03,2.67l-1.05,4.1l-1.39,-0.61l-0.66,-2.17l-0.9,-0.91l-1.54,0.02l-2.1,-1.41l-1.6,-0.62l-4.06,-0.26l-2.89,-2.04l-2.13,-1.07l-8.55,-12.06l-2.49,-2.54l-0.55,-3.13l-1.69,-3.7l1.11,-1.22l1.01,-0.6l5.09,-1.85l1.38,-0.71l0.14,-0.59l-1.74,-2.45l-3.1,-6.45l-1.19,-1.68l-1.33,-0.84l-1.59,0.62l0.83,-4.46l-0.48,-4.84l-2.32,-4.1l-4.3,-2.61l-0.61,0.36l0.15,2.69l-1.68,1.05l-4.6,1.13l-0.45,-1.89l0.36,-0.7l1.08,-0.79l-0.37,-1.49l0.36,-0.71l1.99,-1.22l0.17,-0.6l-2.62,-3.41l-0.24,-1.22l0.58,-0.72l0.22,-0.9l0.05,-5.41l2.8,-0.7l5.49,0.61l0.94,-0.3l0.72,-0.97l0.76,-5.86l-0.23,-1.02l-1.62,-3.06l0.02,-0.92l0.35,-0.54l1.78,-1.51l3.12,-0.98l3.05,-3.07l1.82,-0.71l1.38,-1.11l2.14,-0.57l1.86,-2.37l1.56,-3.74l1.89,-2.58l1.61,-1.22l2.11,0.11l1.36,-0.51l0.57,-0.69l3.0,-6.89l2.22,-1.66l2.66,-0.6l3.2,0.14l3.95,0.65l2.87,-0.42l1.27,1.0l1.24,2.01l3.73,0.49l0.87,1.08l2.4,5.23l3.26,2.41l1.75,1.84l1.34,0.2l1.61,-0.38l1.05,-0.87l0.52,-1.46l0.68,-0.29l0.8,1.3l1.71,1.33l10.78,2.07l0.91,0.66l-0.35,2.6l-0.94,0.77l-3.26,0.8l-10.01,1.39l-6.43,1.65l-2.2,1.16l-2.29,1.7l-1.56,2.08l-3.0,7.25l-2.53,2.68l-1.14,3.76l-4.06,5.1l-0.87,3.94l0.02,3.48l-1.74,2.51l-0.62,5.92l-0.73,1.32l-0.01,2.3l-0.36,1.67l0.37,0.99l1.01,1.26l0.36,1.39l0.32,5.99l0.63,0.51l1.28,0.06l0.35,2.57l0.86,0.95l4.37,1.8l0.76,2.08l-0.19,0.61l-1.71,0.91l-1.29,1.31l-4.94,0.09l-1.75,0.69l-1.93,-0.4l-0.74,0.38l-0.49,2.16l-0.45,5.1l-1.39,3.15l0.03,1.86l0.52,2.09l0.6,0.74l3.54,2.45l1.05,-0.33Z",name:"Yasothon"},"TH-34":{path:"M792.56,582.28l-1.26,-1.28l-2.97,-0.07l-2.13,-0.45l-0.87,0.26l-1.8,1.53l-2.47,-1.25l-2.26,0.36l-3.52,-1.39l-3.45,-0.02l-3.31,-2.23l-1.71,-0.49l2.09,-6.8l-0.29,-4.19l-0.28,-0.39l-0.46,0.16l-0.66,1.0l-0.65,-0.09l-3.24,-2.46l-0.48,-1.96l-0.07,-1.41l1.42,-3.28l0.84,-6.97l2.1,0.35l1.72,-0.69l4.51,-0.05l1.08,-0.27l1.09,-1.27l1.87,-1.1l0.29,-1.3l-0.63,-1.51l8.51,2.61l3.37,-0.07l1.39,-0.83l2.6,-3.5l0.24,-1.16l-0.19,-0.97l-1.99,-1.51l1.67,-1.09l1.03,0.24l1.24,0.92l4.28,5.65l1.28,0.97l1.61,0.37l2.45,-0.28l1.69,0.61l1.27,2.59l0.54,2.33l0.97,1.36l1.22,0.68l1.43,0.05l2.4,-0.82l0.67,0.11l0.51,0.36l0.63,1.74l0.74,1.04l1.49,0.83l1.64,-0.37l1.64,-1.45l1.47,-2.88l0.62,-3.31l-0.06,-2.06l-0.64,-3.32l0.44,-2.74l4.82,-13.83l2.68,-3.89l1.34,-3.47l0.14,-2.08l-0.52,-3.4l0.17,-1.2l1.41,-1.8l2.13,-1.65l0.61,-1.11l-0.53,-2.85l-2.0,-1.83l-0.49,-1.13l-0.02,-1.75l0.56,-2.78l6.04,-6.02l1.13,-4.03l0.39,-0.38l13.89,4.93l5.64,0.4l12.56,3.16l1.63,0.85l0.12,0.53l-0.46,0.61l-3.46,1.59l-2.61,2.89l-0.3,4.18l1.33,4.33l4.31,9.21l1.24,1.82l1.37,1.36l1.42,0.82l1.79,0.28l4.41,-0.37l2.31,0.29l4.59,1.54l4.7,3.03l2.95,4.25l1.06,5.11l-1.08,5.58l-2.67,6.93l-0.47,2.48l-0.18,4.64l-0.61,1.85l-1.63,1.61l-3.77,2.36l-5.01,1.59l-2.26,1.45l-1.11,2.64l0.62,2.29l1.87,1.31l2.43,0.46l4.02,-0.41l0.5,2.44l-0.08,2.7l-3.34,2.11l-3.03,2.45l-4.52,4.72l-0.98,1.63l-0.74,2.3l-0.43,2.45l0.02,2.67l0.9,1.84l2.54,0.65l2.56,2.63l0.93,0.25l1.52,-0.19l0.33,2.12l3.17,4.5l1.45,1.13l2.48,0.53l-0.63,0.9l-4.23,2.67l-1.2,2.27l1.71,3.73l-0.71,2.12l-2.07,0.07l-0.73,0.38l-0.11,2.49l0.8,1.94l-1.79,0.59l-0.65,0.52l-0.86,2.11l-0.51,2.51l0.16,2.6l1.55,3.05l-0.82,4.99l-0.18,3.43l1.55,7.39l-0.27,3.14l-1.27,2.88l-3.4,4.49l-3.3,3.2l-1.86,4.27l-0.96,0.49l-4.12,0.94l-3.53,3.16l-1.13,-0.06l-2.0,-1.31l-1.37,-0.01l-0.85,0.75l-1.96,3.06l-1.85,0.75l-5.58,1.3l-1.66,-0.01l-3.18,1.69l-2.64,5.67l-3.25,5.4l-5.57,1.73l-2.17,-1.04l-1.83,-2.06l-3.39,-6.24l0.32,-7.33l-0.56,-1.48l-2.28,-0.86l-3.88,-0.7l0.12,-0.81l-2.24,-3.62l-1.13,-1.01l-1.14,-0.2l-1.8,0.27l-0.74,-0.38l1.59,-2.04l0.51,-1.54l-0.43,-2.72l-0.63,-1.69l-2.75,-3.19l-0.42,-1.22l1.86,-7.93l1.05,-1.82l1.39,-0.89l1.41,-0.06l2.19,1.33l0.93,-0.42l0.03,-0.76l-2.33,-5.41l-0.75,-0.62l-1.81,-0.67l-0.63,-0.65l-5.0,-10.05l-0.27,-1.65l0.4,-0.95l0.89,-0.95l0.31,-1.04l-0.21,-1.06l-1.68,-3.4l-0.85,-0.91l-1.89,-1.17l-2.55,-1.19l-4.46,-0.79l-0.75,-0.63l-2.33,-3.99l-0.51,-6.15l0.66,-2.7l-0.85,-5.41l0.07,-3.5l0.36,-0.54l1.71,0.78l1.34,-0.76l0.94,-0.87l0.65,-1.25l0.23,-1.62l-0.37,-0.45l-1.44,-0.08l-1.55,-0.62l0.92,-0.47l0.1,-1.42l-1.44,-1.44l-2.09,-3.93l-1.01,-1.05l-1.42,-0.22l-0.37,0.25l-0.03,1.53Z",name:"Ubon Ratchathani"},"TH-37":{path:"M840.27,487.64l-1.32,4.22l-6.16,6.23l-0.59,2.94l0.02,2.02l0.65,1.48l1.92,1.71l0.43,2.42l-1.0,1.23l-2.31,1.86l-0.82,1.34l-0.18,1.46l0.51,3.33l-0.11,1.86l-1.26,3.28l-2.73,3.99l-4.85,13.92l-0.47,2.99l0.7,5.34l-0.6,3.12l-1.37,2.65l-1.41,1.21l-1.19,0.23l-1.0,-0.64l-1.16,-2.54l-1.0,-0.75l-1.06,-0.13l-2.28,0.81l-1.25,-0.05l-0.86,-0.52l-0.75,-1.11l-1.18,-3.96l-0.84,-1.21l-0.94,-0.57l-1.18,-0.2l-2.54,0.28l-1.18,-0.26l-1.06,-0.78l-4.32,-5.69l-1.56,-1.14l-1.52,-0.26l-1.55,0.77l-0.63,0.75l0.2,1.1l1.77,1.07l-0.06,1.57l-2.42,3.21l-1.11,0.64l-2.89,0.04l-9.13,-2.8l-4.3,-1.73l-0.66,-0.73l0.08,-1.04l-0.51,-1.62l-0.82,-0.45l-0.95,0.07l-0.12,-0.27l-0.14,-1.89l0.28,-1.35l-0.33,-2.35l-0.44,-1.62l-1.29,-1.98l0.36,-1.47l0.0,-2.25l0.74,-1.37l0.51,-5.45l1.72,-2.46l0.11,-4.0l0.81,-3.72l4.03,-5.05l1.14,-3.75l2.5,-2.62l3.03,-7.32l1.34,-1.82l4.22,-2.72l6.32,-1.63l10.01,-1.39l3.88,-1.05l0.96,-1.08l0.37,-2.65l2.22,-0.16l5.65,-2.27l2.91,-2.51l5.45,-3.64l2.42,-2.82l2.64,1.71l1.11,2.0l0.35,2.3l-0.09,4.99l0.4,2.92l1.1,2.75l1.83,2.42l2.3,1.75l2.5,0.91Z",name:"Amnat Charoen"},"TH-33":{path:"M721.34,578.42l1.05,-0.65l0.76,-1.8l1.1,-0.83l0.59,-1.49l1.03,-0.83l3.1,-1.43l0.7,-1.37l0.0,-1.23l-0.91,-1.48l-0.99,-3.11l-1.34,-0.65l-6.42,-0.22l0.47,-1.24l3.77,-4.78l2.26,-1.75l3.39,-5.12l2.17,-1.13l0.69,-0.86l2.08,-1.35l1.59,3.49l0.64,3.32l2.51,2.55l8.64,12.16l2.25,1.15l2.31,1.76l1.65,0.56l3.26,0.1l1.39,0.54l2.13,1.43l1.6,0.01l0.45,0.49l0.48,1.87l0.77,0.88l3.66,1.06l3.45,2.29l3.54,0.04l3.54,1.4l2.21,-0.37l2.62,1.27l0.94,-0.32l1.72,-1.47l2.04,0.44l2.83,0.04l0.95,1.1l0.85,0.26l0.44,-0.39l-0.06,-1.44l0.67,0.07l0.82,0.83l2.1,3.94l1.33,1.21l0.07,0.63l-1.23,0.63l-0.06,0.67l1.15,0.86l2.34,0.37l-0.63,2.01l-0.85,0.78l-1.02,0.57l-1.42,-0.84l-0.52,0.1l-0.74,1.16l-0.08,3.75l0.85,5.32l-0.66,2.64l0.55,6.45l2.45,4.22l0.94,0.8l1.22,0.47l1.85,-0.03l1.52,0.42l2.46,1.15l2.48,1.83l1.75,4.01l-1.57,2.74l0.31,2.19l5.03,10.11l0.93,0.96l2.32,1.08l2.19,5.1l-0.29,0.17l-1.44,-1.08l-1.38,-0.27l-0.99,0.21l-1.69,1.12l-1.19,2.09l-1.89,8.23l0.58,1.62l2.68,3.07l0.93,3.24l-0.01,1.37l-1.84,2.25l-0.14,1.09l0.77,0.78l3.21,-0.12l0.93,0.81l2.11,3.41l-0.13,0.41l-1.49,-0.27l-3.4,-1.92l-3.86,0.2l-4.57,-2.87l-1.97,-0.24l-1.78,0.84l-3.18,2.5l-1.36,0.28l-0.48,-0.4l-0.53,-1.85l-1.09,-0.68l-1.41,0.53l-1.57,2.13l-1.62,0.07l-2.77,-1.14l-1.94,0.09l-1.83,1.09l-3.37,4.5l-1.97,0.81l-5.51,-1.48l-1.28,0.37l-2.05,1.49l-0.86,0.02l-1.45,-0.49l-12.29,-1.79l-5.83,-2.36l-2.69,-0.25l-3.29,2.05l-1.74,0.48l-1.06,-0.39l-0.5,-0.81l0.15,-1.0l-0.3,-0.66l-0.94,-0.03l-3.35,3.9l-0.66,0.32l-1.14,-0.03l-1.28,-1.19l-0.93,-0.36l-3.96,1.07l-2.41,1.17l1.67,-9.94l-1.31,-5.9l-0.45,-4.14l0.67,-2.26l1.1,-6.67l-0.02,-3.42l-0.52,-1.16l-4.57,-5.79l-0.76,-1.39l-0.05,-6.11l-0.92,-2.17l-1.0,-0.8l-3.07,-0.59l-3.68,-1.92l-1.15,-2.05l2.68,-6.9l1.16,-1.86l2.02,-2.15l0.79,-2.17l1.79,-1.4l0.57,-2.45l1.31,-1.23l0.6,-2.21l-0.17,-2.6l-1.08,-1.38l-1.42,-7.21l-0.51,-1.1l-1.36,-1.0l-0.45,-1.31l0.6,-3.56l1.0,-2.15l0.32,-1.48l-0.07,-0.79l-1.16,-2.19l1.55,-0.45l0.8,-1.32Z",name:"Si Sa Ket"},"TH-38":{path:"M699.43,292.16l-1.44,-0.45l-2.58,-2.57l0.07,-0.65l1.32,-0.78l0.41,-0.78l-0.47,-1.69l0.26,-1.15l-0.49,-0.82l-1.12,-0.6l0.08,-1.62l-0.87,-0.22l-1.0,0.86l-0.86,2.82l-1.27,-0.6l-2.38,-2.19l-2.07,-1.01l-2.44,-0.49l-0.15,-0.81l-0.55,-0.51l-2.38,-0.36l-1.13,-0.66l-0.48,-1.95l0.24,-0.47l1.66,-0.7l0.1,-0.95l-0.86,-0.56l-2.18,-0.35l-2.62,-3.0l-1.64,-0.23l-0.99,-0.85l-2.25,-1.12l-4.01,-0.19l-3.3,2.17l0.14,2.94l-1.28,1.8l-1.21,1.0l-1.85,0.23l-3.52,-2.94l-4.66,-2.78l-3.85,-3.8l-0.68,-4.23l1.52,-3.14l3.5,-2.18l1.09,-2.91l-1.47,-3.59l-3.25,-1.49l-3.18,-0.38l-0.87,-1.5l1.02,-2.11l-0.48,-3.09l-0.76,-1.02l-5.36,-3.43l-0.49,-0.93l-0.1,-0.9l1.05,-2.6l1.74,-2.17l2.29,-1.67l2.55,-1.1l9.57,-1.75l7.92,2.17l3.02,-0.19l2.73,0.67l2.8,0.26l6.23,1.66l3.37,2.49l6.28,2.82l1.55,0.41l6.28,0.34l3.6,0.91l3.22,1.9l2.97,3.92l1.75,0.36l1.08,-0.18l3.18,-3.51l1.99,-1.31l2.25,-0.57l2.48,0.25l2.54,1.3l1.94,2.08l5.36,9.32l4.6,11.27l1.26,2.21l1.53,1.85l6.99,6.38l-2.96,1.93l-4.52,-0.18l-0.8,0.33l-0.77,3.06l0.36,1.0l1.21,1.17l-0.19,2.99l0.41,2.0l-2.65,4.83l-0.83,-0.04l-2.77,-1.7l-0.54,-2.04l-1.39,-1.78l-0.45,-1.52l-0.55,-0.72l-1.55,-0.13l-3.17,1.42l-0.63,1.39l-0.49,2.76l-0.78,1.6l-0.03,0.7l0.3,0.94l2.17,3.03l0.2,0.87l-0.27,2.3l-1.37,0.63l-0.46,1.42l-1.22,0.48l-0.87,1.01l-1.33,-1.13l-1.9,-0.74l-0.38,-1.65l-1.5,-1.22l-0.16,-0.83l0.39,-2.26l-0.23,-1.05l-0.78,-0.34l-1.46,0.99l-0.25,-0.16l0.16,-1.59l0.51,-1.1l-0.37,-0.74l-1.1,-0.1l-1.22,0.44l-1.53,1.53l-0.37,-0.26l-0.49,-1.4l-0.64,-0.33l-2.17,1.08l-3.42,-0.28l-0.91,0.8l0.1,0.79l0.7,1.19Z",name:"Bueng Kan"},"TH-36":{path:"M477.05,423.96l4.0,3.04l0.72,-0.07l3.31,-1.78l1.11,-0.13l1.75,0.27l6.4,2.57l4.78,0.16l1.31,1.59l1.12,3.41l0.79,1.18l0.98,0.79l2.71,0.99l3.68,4.75l2.65,1.7l9.3,0.12l1.81,0.33l1.54,-0.57l1.08,-0.0l3.89,1.69l1.97,2.09l1.07,0.6l2.14,0.55l1.48,1.11l2.46,0.5l2.86,-0.58l1.56,1.25l0.91,0.31l2.37,-0.6l0.38,-0.49l-0.09,-1.15l1.03,-0.0l1.0,3.06l3.72,2.46l0.04,0.73l-0.19,1.56l-2.0,6.87l-1.44,3.25l-1.49,5.39l-3.26,5.07l-2.67,3.08l-2.26,4.36l-3.99,4.16l-2.8,2.09l-0.15,0.59l0.16,0.72l1.46,2.01l1.95,1.22l5.24,2.06l2.45,2.18l1.87,0.67l0.35,0.62l-0.95,0.91l-1.36,5.28l0.2,0.82l-2.08,3.39l-0.32,1.08l-1.56,1.94l-0.35,1.7l0.56,3.56l-0.4,0.86l-0.84,-0.06l-1.67,0.58l-3.38,1.91l-2.62,2.63l-1.29,0.88l-1.59,0.2l-0.68,-1.27l-0.44,-0.2l-0.34,0.77l-0.6,0.19l0.39,0.82l-0.69,0.36l-2.91,-0.07l-1.88,1.0l-0.19,0.43l0.23,1.08l-0.32,0.8l-1.39,1.82l0.01,2.13l-1.32,0.65l-1.55,3.1l-3.34,2.78l-0.62,-1.06l-4.08,-3.01l-0.58,0.11l-3.92,7.27l-4.43,3.06l-0.83,1.5l-0.53,2.07l0.04,1.04l1.27,3.84l0.11,1.71l-4.76,2.55l-1.9,1.94l-1.07,2.21l-0.97,3.44l-1.86,0.01l-2.92,-0.93l-3.86,0.97l-1.66,0.67l-6.71,3.86l-4.25,1.83l-5.14,1.45l-4.27,4.03l-3.64,2.29l-15.0,4.22l-1.98,0.14l-0.83,-0.62l-1.83,-3.77l-1.2,-1.59l-7.07,-3.51l4.18,-4.66l3.38,-7.57l0.29,-5.34l-0.13,-4.33l-0.94,-6.29l0.47,-4.69l0.76,-3.92l1.69,-4.94l0.37,-2.12l-0.47,-1.4l-0.59,-0.67l-3.28,-0.66l-2.34,-2.1l-0.47,-1.34l-0.31,-10.84l0.75,-1.15l2.5,-2.0l0.46,-0.72l1.33,-4.92l1.23,-3.06l-0.15,-0.76l-0.68,-0.63l-2.98,-0.73l-0.79,-0.49l-1.01,-2.07l-0.42,-1.74l-0.55,-6.62l2.35,-11.22l-0.18,-2.72l1.57,-2.06l0.8,-1.68l-0.21,-1.15l-1.69,-1.67l1.48,-2.39l1.8,-8.38l2.5,-2.85l0.04,-2.45l4.31,-3.96l1.04,-2.01l1.33,-1.7l0.48,-1.53l-0.49,-2.16l0.1,-0.81l4.3,-2.82l0.88,-1.06l-0.12,-1.11l-1.33,-1.22l-0.23,-1.4l0.28,-3.5l1.35,-0.88l0.63,-1.61l-0.91,-2.24l0.09,-2.03l1.31,-0.52l2.44,1.09l1.04,-0.04l2.14,-2.12l2.35,-1.44l1.87,1.72l1.26,0.54l3.5,-0.53l3.28,0.52l2.22,2.29l1.5,0.9l0.87,-0.18l0.79,-0.87l1.13,-0.56Z",name:"Chaiyaphum"},"TH-31":{path:"M552.57,626.46l3.66,1.55l1.36,2.02l1.07,0.78l2.99,0.24l4.28,-1.04l0.77,-0.9l0.3,-1.58l-2.43,-4.45l-0.63,-2.58l1.17,-3.51l-0.03,-0.86l-0.56,-0.72l-2.75,-1.57l-0.62,-0.75l0.89,-0.02l3.95,1.15l3.59,1.64l1.79,0.4l5.68,-0.24l3.89,-1.27l5.26,-3.76l1.74,-4.76l1.5,-2.2l0.06,-1.3l-0.44,-1.64l1.5,-1.36l3.77,-4.83l2.59,-2.49l6.87,-3.02l2.4,0.73l2.96,-0.72l1.89,-1.58l0.22,-1.1l-0.93,-1.66l-0.18,-4.51l0.5,-3.39l-0.52,-1.98l0.05,-2.55l0.33,-0.87l2.09,-0.99l0.44,-1.28l-0.34,-0.63l-0.95,-0.59l-3.38,-0.77l-0.52,-1.1l2.26,-4.45l1.02,0.74l0.95,0.11l0.93,-1.11l1.67,-1.17l0.21,-0.89l-0.67,-1.39l-1.18,-1.48l-1.06,-0.54l-3.11,0.13l-0.71,-1.2l-1.12,-0.7l-0.65,-1.49l-2.54,-1.06l-3.18,-0.1l-2.61,0.76l-1.67,-0.44l-1.79,0.25l-2.1,-2.09l-1.38,-1.78l-0.24,-0.89l-0.08,-3.25l-0.66,-5.05l1.27,0.96l1.88,0.37l4.01,-1.13l1.32,-0.75l1.16,-1.93l1.11,-3.55l0.36,-7.64l0.81,-1.64l1.34,-0.92l3.2,-1.04l2.21,2.61l2.07,1.27l2.22,2.88l0.22,2.59l-3.32,2.47l-0.35,0.64l0.18,0.8l5.12,5.59l2.38,1.59l0.81,3.04l1.55,1.53l2.08,1.4l0.14,1.77l-1.0,0.93l-0.06,1.46l0.86,1.14l2.94,2.08l-0.59,2.99l-1.01,1.59l0.24,1.26l1.95,1.79l1.39,-0.37l0.4,0.45l0.74,0.0l0.4,-0.76l0.27,1.49l1.44,2.77l0.46,1.58l0.47,0.28l2.33,-0.5l1.18,1.26l0.87,1.52l1.9,0.0l0.54,1.36l1.92,1.02l0.48,1.16l0.62,0.16l1.26,-1.02l0.74,0.09l1.62,0.98l1.34,-0.35l1.41,-1.67l1.79,-0.69l2.27,-1.48l1.2,-0.29l2.59,1.29l1.39,-0.55l0.33,0.53l-0.59,0.5l-0.01,0.6l1.29,1.03l2.16,-0.23l1.2,-2.09l2.38,0.99l0.8,1.43l0.73,0.58l1.64,0.5l-0.11,1.99l-1.78,4.19l-1.99,1.37l-1.92,5.86l0.52,8.72l1.09,2.79l-0.77,2.62l1.24,1.97l0.23,0.93l-0.24,0.69l-1.94,1.39l-0.63,1.27l0.35,7.6l-0.83,1.21l-1.76,1.34l-2.47,4.65l-3.77,3.19l-1.96,1.15l-1.82,1.76l-1.28,0.76l-1.78,2.88l-1.07,1.0l-0.32,1.41l0.31,2.4l-1.58,6.45l-2.1,4.08l-0.64,2.89l-1.73,2.03l-0.23,7.25l0.73,3.72l1.22,2.59l0.89,2.9l-0.26,1.42l-1.26,3.08l0.33,2.25l-0.6,2.06l0.24,2.85l-4.49,1.38l-6.58,0.98l-2.26,0.75l-3.58,1.93l-8.73,7.44l-1.78,1.04l-3.95,1.13l-2.0,0.95l-1.68,1.71l-0.62,2.22l-3.83,1.04l-6.12,-1.13l-2.79,0.78l-1.02,0.8l-2.03,0.8l-5.52,1.26l-6.51,-0.4l-2.6,-1.82l-0.69,0.13l-1.25,1.6l-1.54,-1.17l-0.89,-5.04l0.03,-1.56l2.82,-5.62l0.57,-1.47l-0.0,-1.29l-0.48,-0.55l-1.03,-0.42l-0.24,-0.46l-0.86,-5.66l-1.87,-2.37l0.55,-3.91l-1.01,-3.29l-1.46,-2.3l-4.77,-3.85l-1.19,-2.17l-1.82,-5.18l-0.16,-1.4l2.43,-6.41l0.22,-2.68l-2.01,-4.14l-0.92,-2.89l0.02,-3.96l-1.98,-2.51l-2.26,-7.62Z",name:"Buri Ram"},"TH-94":{path:"M473.44,1533.56l-3.05,-0.02l-0.9,-0.3l-1.2,-1.88l-0.18,-1.78l-0.55,-0.84l-2.24,-1.18l-1.52,0.49l-1.44,-0.39l-2.91,0.79l-1.1,1.27l0.15,1.41l2.56,1.92l0.15,0.65l-0.62,1.94l-2.3,0.97l-1.49,0.23l-1.24,-0.67l-2.91,-4.4l-1.26,-0.67l-1.56,0.34l-4.17,2.52l-4.03,-0.2l-5.49,1.06l-3.75,1.32l-1.17,-1.03l-2.11,-3.67l0.3,-2.85l-0.77,-3.13l-0.04,-2.54l-0.65,-0.51l-0.62,0.12l-1.05,1.03l-1.51,3.17l-1.0,1.29l-2.9,2.42l-2.73,0.79l-3.86,-0.68l-1.36,0.11l-1.34,-0.71l-2.56,-2.19l-6.19,-2.76l-1.09,-5.99l-1.48,-2.53l0.28,-6.93l0.85,-1.98l1.92,-3.08l0.12,-1.11l13.17,-0.48l4.35,-2.01l1.42,-2.29l3.25,0.56l1.42,1.18l2.82,1.0l3.89,0.06l0.4,-0.54l-0.84,-2.2l-1.7,-2.45l-6.32,-2.66l2.05,-0.69l2.95,0.54l2.77,2.22l4.18,2.55l3.82,1.22l7.34,1.73l7.46,3.94l0.89,0.96l11.04,18.87l5.66,8.68Z",name:"Pattani"},"TH-30":{path:"M527.68,525.72l0.58,0.54l2.14,-0.31l1.46,-1.01l2.52,-2.56l3.23,-1.84l1.55,-0.54l0.66,0.08l1.79,2.71l2.19,1.84l0.06,2.94l0.46,0.65l2.97,1.64l2.12,2.22l0.63,0.3l2.11,-0.31l2.09,-1.14l4.97,-0.88l9.52,1.28l1.86,-1.4l5.68,0.94l3.16,-1.07l0.62,2.19l1.94,2.85l1.14,0.69l3.29,0.65l2.88,2.23l0.97,10.11l3.31,4.18l0.87,0.48l1.89,-0.24l1.72,0.44l1.33,-0.16l1.39,-0.61l2.84,0.08l2.32,0.97l0.42,1.24l1.21,0.81l0.91,1.35l2.74,-0.16l1.32,0.48l1.56,2.44l-1.59,1.25l-0.64,0.93l-1.51,-0.89l-0.85,0.28l-2.45,4.91l0.45,1.42l0.46,0.47l3.49,0.83l0.81,0.65l-0.17,0.5l-2.12,1.02l-0.58,1.39l-0.05,2.7l0.52,1.91l-0.5,3.33l0.18,4.61l0.94,1.96l-0.76,1.03l-0.8,0.53l-2.71,0.68l-1.64,-0.71l-1.03,0.03l-7.14,3.17l-2.64,2.53l-3.81,4.88l-1.61,1.5l-0.12,0.77l0.5,1.38l-0.04,0.94l-1.43,2.03l-1.72,4.72l-4.91,3.46l-3.64,1.2l-5.52,0.24l-3.03,-0.9l-2.16,-1.1l-4.02,-1.17l-1.04,-0.06l-0.66,0.33l-0.18,0.9l0.52,0.69l3.45,2.25l-1.13,3.31l0.0,1.58l0.64,2.11l2.29,3.91l0.08,0.78l-0.75,1.27l-3.85,0.89l-2.71,-0.21l-2.23,-2.71l-2.75,-0.96l-1.55,-1.26l-0.45,-0.11l-0.25,0.39l0.26,2.06l2.17,6.94l1.98,2.51l-0.07,3.75l0.96,3.04l1.97,3.99l-0.18,2.31l-2.45,6.48l0.18,1.81l1.84,5.23l1.3,2.38l4.86,3.95l1.28,2.06l0.93,2.98l-0.62,3.04l0.11,1.09l1.89,2.43l0.87,5.69l0.56,0.83l1.14,0.5l-0.01,0.94l-0.51,1.27l-2.88,5.85l-0.03,1.74l0.88,4.97l-2.62,2.07l-3.2,1.05l-0.45,1.21l0.14,0.71l1.66,0.88l-1.18,0.52l-2.18,0.17l-1.12,-0.66l-0.45,-1.13l0.06,-2.95l-0.84,-1.27l-1.15,-0.23l-3.0,0.32l-2.99,-1.62l-0.82,0.06l-2.29,1.0l-4.51,-1.13l-4.73,1.18l-1.44,1.77l-0.96,0.24l-2.24,-1.3l-3.67,0.03l-0.86,-0.28l-0.65,-0.87l-0.25,-1.79l-2.16,-1.97l-0.69,-0.25l-1.66,0.39l-1.08,0.77l-0.64,1.53l0.21,2.01l-0.75,0.68l-2.43,-0.26l-5.53,-2.06l-5.45,-4.66l-4.36,-2.83l-3.45,-2.97l-0.47,-1.44l-0.9,-1.19l-0.17,-0.91l3.73,-5.8l0.39,-1.4l-0.51,-1.72l-2.1,-1.38l-1.09,-0.1l-2.14,1.81l-0.78,0.12l-0.84,-0.57l-2.33,-2.9l-1.08,-0.14l-0.81,0.59l-0.94,1.9l-0.87,0.73l-3.7,0.81l-3.55,-0.2l-1.69,0.92l-2.13,0.38l-0.65,0.76l-0.07,2.13l-0.23,0.46l-0.45,-0.01l-1.46,-1.16l-2.72,-3.39l-4.65,-3.56l-1.04,-1.53l-1.85,-1.18l-0.89,-1.21l-1.34,-0.68l-3.1,-0.34l-5.49,0.83l-2.52,-0.75l-1.15,-0.79l-1.37,-1.74l-1.33,-0.5l-1.97,0.78l-1.63,1.32l-1.36,1.81l-2.97,0.12l-9.27,-5.61l-1.47,-1.76l-3.07,-1.27l-1.16,0.44l-1.35,2.57l-1.63,-0.41l-2.25,-2.33l-1.35,-2.23l-2.03,-1.47l-0.22,-0.49l0.37,-1.4l1.81,-3.07l-1.5,-18.74l2.14,0.53l1.69,1.14l1.43,0.14l3.05,1.01l0.72,-0.1l0.84,-1.22l1.31,-0.4l1.33,-1.34l2.4,-1.26l1.75,-4.27l3.13,-1.37l1.32,-1.22l1.81,-0.74l4.11,-2.54l0.86,-0.83l0.37,-1.24l-0.19,-4.41l-5.11,-10.4l-1.06,-3.64l-1.12,-1.71l-1.01,-1.06l-2.15,-0.06l-2.26,-0.67l-2.9,-1.87l-3.05,-0.04l-0.29,-3.01l0.34,-8.95l-0.22,-4.54l2.12,-3.92l0.25,-2.43l6.85,3.39l0.98,1.34l0.92,2.34l1.58,2.09l0.75,0.36l2.2,-0.15l15.22,-4.28l3.8,-2.4l4.13,-3.93l5.07,-1.42l4.3,-1.85l8.32,-4.51l3.62,-0.92l2.72,0.92l2.1,0.09l0.79,-0.78l0.62,-2.52l1.04,-2.49l1.08,-1.32l0.75,-0.68l4.36,-2.18l0.72,-0.71l0.13,-1.44l-1.44,-4.53l0.44,-2.74l0.65,-1.21l2.74,-1.66l1.78,-1.51l3.73,-6.95l3.66,2.7l0.69,1.25l0.59,0.13l3.8,-3.13l1.53,-3.06l0.9,-0.23l0.57,-0.61l0.06,-2.28l1.35,-1.72l0.39,-0.97l-0.17,-1.14l1.32,-0.75l3.1,0.03l1.23,-0.65l0.09,-0.5Z",name:"Nakhon Ratchasima"}},height:1636.6464833349905,projection:{type:"mill",centralMeridian:0},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","us_aea",{insets:[{width:220,top:440,height:172.39541268576795,bbox:[{y:-8441276.54251503,x:-4774054.664881942},{y:-6227982.667213126,x:-1949590.5739843722}],left:0},{width:80,top:460,height:151.48337407091987,bbox:[{y:-4196208.652471859,x:-5906305.806252358},{y:-3657293.3059425415,x:-5621698.812337889}],left:245},{width:900,top:0,height:550.1122047105795,bbox:[{y:-5490816.561605522,x:-2029882.6485830692},{y:-2690009.0242363815,x:2552322.14899711}],left:0}],paths:{"US-VA":{path:"M682.42,289.98l1.61,-0.93l1.65,-0.48l1.12,-0.95l3.57,-1.69l0.74,-2.33l0.82,-0.19l2.32,-1.53l0.05,-1.81l2.04,-1.86l-0.13,-1.58l0.26,-0.41l5.0,-4.09l4.76,-6.0l0.09,0.63l0.96,0.54l0.33,1.37l1.32,0.74l0.71,0.81l1.46,0.09l2.09,1.13l1.41,-0.09l0.79,-0.41l0.76,-1.22l1.17,-0.57l0.53,-1.38l2.72,1.49l1.42,-1.1l2.25,-0.99l0.76,0.06l1.08,-0.97l0.33,-0.82l-0.48,-0.96l0.23,-0.42l1.9,0.58l3.26,-2.62l0.3,-0.1l0.51,0.73l0.66,-0.07l2.38,-2.34l0.17,-0.85l-0.49,-0.51l0.99,-1.12l0.1,-0.6l-0.28,-0.51l-1.0,-0.46l0.71,-3.03l2.6,-4.8l0.55,-2.15l-0.01,-1.91l1.61,-2.55l-0.22,-0.94l0.24,-0.84l0.5,-0.48l0.39,-1.7l-0.0,-3.18l1.22,0.19l1.18,1.73l3.8,0.43l0.59,-0.28l1.05,-2.52l0.2,-2.36l0.71,-1.05l-0.04,-1.61l0.76,-2.3l1.78,0.75l0.65,-0.17l1.3,-3.3l0.57,0.05l0.59,-0.39l0.52,-1.2l0.81,-0.68l0.44,-1.8l1.38,-2.43l-0.35,-2.57l0.54,-1.76l-0.3,-2.01l9.18,4.57l0.59,-0.29l0.63,-4.0l2.6,-0.07l0.63,0.57l1.05,0.23l-0.5,1.74l0.6,0.88l1.61,0.85l2.52,-0.04l1.03,1.18l1.49,0.13l2.24,1.73l-0.0,1.31l0.44,1.27l-1.67,0.96l-0.12,0.65l-0.64,0.14l-0.27,0.45l-0.47,5.03l-0.36,0.13l-0.04,0.48l1.17,0.97l-0.29,0.11l-0.04,0.76l2.03,-0.01l2.41,-1.45l0.49,-0.72l0.34,0.74l-0.52,0.63l1.21,0.88l0.69,0.13l0.42,1.11l1.62,0.52l1.94,-0.2l0.84,0.43l0.82,-0.65l0.89,0.02l0.23,0.6l1.33,0.48l0.46,1.1l1.12,-0.05l0.02,0.3l1.18,0.42l2.84,0.65l0.4,1.01l-0.85,-0.41l-0.57,0.45l0.89,1.74l-0.35,0.57l0.62,0.79l-0.43,0.89l0.24,0.59l-1.36,-0.36l-0.59,-0.72l-0.67,0.18l-0.1,0.43l-2.44,-2.29l-0.56,0.05l-0.37,-0.56l-0.52,0.32l-1.47,-1.32l-1.19,-0.38l-0.43,-0.64l-0.9,-0.39l-0.7,-1.29l-0.77,-0.64l-1.34,-0.12l-1.11,-0.81l-1.17,0.05l-0.39,0.52l0.47,0.71l1.1,-0.01l0.63,0.68l1.33,0.07l0.59,0.42l0.38,1.52l2.73,1.56l1.86,1.88l1.95,0.61l1.59,2.1l0.98,0.24l1.35,-0.45l1.28,0.47l-0.61,0.7l0.3,0.49l2.03,0.34l0.26,0.72l0.47,0.12l0.31,1.96l-0.57,-0.83l-0.52,-0.22l-0.39,0.21l-1.13,-1.0l-0.58,0.3l0.1,0.82l-0.31,0.68l0.7,0.7l-0.18,0.59l0.51,0.28l0.43,-0.14l0.28,0.35l-1.39,0.72l-6.15,-4.74l-0.58,0.11l-0.19,0.81l0.24,0.54l2.28,1.53l2.09,2.14l2.77,1.18l1.26,-0.68l0.45,1.05l1.27,0.26l-0.44,0.67l0.29,0.56l0.93,-0.19l-0.0,1.24l-0.92,0.41l-0.57,0.73l-0.64,-0.88l-3.14,-1.26l-0.42,-1.53l-0.59,-0.59l-0.87,-0.12l-1.2,0.67l-1.71,-0.44l-0.36,-1.15l-0.71,-0.05l-0.05,1.31l-0.33,0.41l-1.42,-1.32l-0.51,0.09l-0.49,0.57l-0.64,-0.4l-0.99,0.45l-2.23,-0.1l-0.37,0.94l0.34,0.46l1.9,0.22l1.4,-0.31l0.85,0.24l0.56,-0.69l0.63,0.88l1.34,0.43l1.95,-0.31l0.82,0.72l0.84,0.12l0.51,-0.55l0.77,2.44l1.35,0.13l0.23,0.43l1.68,0.71l0.45,0.68l-0.57,1.03l0.56,0.44l1.72,-1.32l0.88,-0.02l0.83,0.65l0.8,-0.26l-0.61,-0.9l0.0,-0.82l-0.46,-0.34l3.99,0.08l0.93,-0.73l2.07,3.53l-0.4,0.7l0.65,3.09l-1.19,-0.58l-0.02,0.88l-30.94,7.83l-37.18,8.41l-19.51,3.35l-11.78,1.24l-0.82,0.62l-28.2,5.01ZM781.17,223.48l0.11,0.08l-0.08,0.06l0.0,-0.03l-0.03,-0.11ZM808.02,244.55l0.53,-1.15l-0.62,-0.62l0.58,-0.97l-0.39,-0.71l-0.03,-0.49l0.44,-0.35l-0.17,-0.73l0.62,-0.3l0.23,-0.6l0.14,-2.33l1.01,-0.39l-0.12,-0.9l0.48,-0.14l-0.26,-1.53l-0.79,-0.4l0.87,-0.57l0.1,-0.96l2.64,-1.01l0.31,2.47l-0.97,2.12l-2.32,7.36l-0.58,1.0l0.17,1.12l-0.48,0.31l-0.33,1.09l0.25,4.27l-1.1,-1.81l0.23,-0.94l-0.33,-1.57l0.28,-0.97l-0.38,-0.29Z",name:"Virginia"},"US-PA":{path:"M716.45,159.95l0.63,-0.19l4.3,-3.73l1.12,5.19l0.48,0.31l34.84,-7.93l34.27,-8.64l1.42,0.58l0.71,1.39l0.63,0.13l0.77,-0.33l1.24,0.59l0.14,0.85l0.81,0.41l-0.16,0.58l0.89,2.69l1.9,2.07l2.12,0.75l2.2,-0.2l0.72,0.79l-0.89,0.87l-0.73,1.48l-0.17,2.25l-1.41,3.35l-1.37,1.58l0.04,0.79l1.79,1.72l-0.31,1.65l-0.84,0.43l-0.22,0.66l0.14,1.48l1.04,2.87l0.52,0.25l1.2,-0.18l1.18,2.39l0.95,0.58l0.66,-0.26l0.6,0.9l4.23,2.75l0.12,0.41l-1.29,0.93l-3.71,4.22l-0.23,0.75l0.17,0.9l-1.36,1.13l-0.84,0.15l-1.33,1.08l-0.31,0.66l-1.72,-0.12l-2.03,0.84l-1.15,1.37l-0.41,1.39l-37.22,9.21l-39.1,8.66l-10.03,-48.2l1.92,-1.22l3.07,-3.04Z",name:"Pennsylvania"},"US-TN":{path:"M571.74,341.02l0.86,-0.84l0.29,-1.37l1.0,0.04l0.65,-0.79l-0.99,-4.89l1.41,-1.93l0.06,-1.32l1.18,-0.46l0.36,-0.48l-0.63,-1.31l0.57,-1.21l-0.89,-1.33l2.55,-1.57l1.09,-1.13l-0.14,-0.84l-0.85,-0.53l0.14,-0.19l0.34,-0.16l0.85,0.37l0.46,-0.33l-0.27,-1.31l-0.85,-0.9l0.06,-0.71l0.51,-1.43l1.0,-1.11l-1.35,-2.06l1.37,-0.21l0.61,-0.55l-0.13,-0.64l-1.17,-0.82l0.82,-0.15l0.58,-0.54l0.13,-0.69l-0.58,-1.38l0.02,-0.36l0.37,0.53l0.47,0.08l1.18,-1.15l23.66,-2.81l0.35,-0.41l-0.1,-1.34l-0.84,-2.39l2.98,-0.08l0.82,0.58l22.78,-3.54l7.64,-0.46l7.5,-0.86l8.82,-1.42l24.01,-3.09l1.11,-0.6l29.29,-5.2l0.73,-0.6l3.56,-0.54l-0.4,1.44l0.43,0.85l-0.4,2.0l0.36,0.82l-1.15,-0.03l-1.71,1.79l-1.21,3.89l-0.55,0.7l-0.56,0.08l-0.63,-0.74l-1.44,-0.02l-2.66,1.73l-1.42,2.73l-0.96,0.89l-0.34,-0.34l-0.13,-1.05l-0.73,-0.54l-0.53,0.15l-2.3,1.81l-0.29,1.32l-0.93,-0.24l-0.9,0.48l-0.16,0.77l0.32,0.73l-0.85,2.18l-1.28,0.06l-1.75,1.14l-1.89,2.3l-0.78,0.27l-2.28,2.46l-4.04,0.78l-2.58,1.7l-0.49,1.09l-0.88,0.55l-0.55,0.81l-0.18,2.88l-0.35,0.6l-1.65,0.52l-0.89,-0.16l-1.06,1.14l0.21,5.24l-20.21,3.32l-21.61,3.04l-25.56,2.95l-0.34,0.31l-7.39,0.9l-28.72,3.17Z",name:"Tennessee"},"US-WV":{path:"M693.03,248.37l3.95,-1.54l0.35,-0.71l0.12,-2.77l1.15,-0.22l0.4,-0.61l-0.57,-2.49l-0.61,-1.24l0.49,-0.64l0.36,-2.77l0.68,-1.66l0.45,-0.39l1.24,0.55l0.41,0.71l-0.14,1.13l0.71,0.46l0.78,-0.44l0.48,-1.42l0.49,0.21l0.57,-0.2l0.2,-0.44l-0.63,-2.09l-0.75,-0.55l0.81,-0.79l-0.26,-1.71l0.74,-2.0l1.65,-0.51l0.17,-1.6l1.02,-1.42l0.43,-0.08l0.65,0.79l0.67,0.19l2.28,-1.59l1.5,-1.64l0.79,-1.83l2.45,-2.67l0.37,-2.41l-0.73,-1.0l0.71,-2.33l-0.25,-0.76l0.59,-0.58l-0.27,-3.43l0.47,-3.93l0.53,-0.8l0.08,-1.11l-0.38,-1.21l-0.39,-0.33l-0.04,-2.0l-1.57,-1.9l0.44,-0.54l0.85,-0.1l0.3,-0.33l4.03,19.33l0.47,0.31l16.59,-3.55l2.17,10.68l0.5,0.37l2.06,-2.5l0.97,-0.56l0.34,-1.03l1.63,-1.99l0.25,-1.05l0.52,-0.4l1.19,0.45l0.74,-0.32l1.32,-2.6l0.6,-0.46l-0.04,-0.85l0.42,0.59l1.81,0.52l3.2,-0.57l0.78,-0.86l0.08,-1.46l2.0,-0.74l1.02,-1.69l0.67,-0.1l3.16,1.5l1.8,-0.71l-0.45,1.02l0.56,0.92l1.27,0.42l0.09,0.96l1.13,0.43l0.09,1.2l0.33,0.42l-0.58,3.64l-9.0,-4.48l-0.64,0.24l-0.31,1.14l0.38,1.61l-0.52,1.62l0.41,2.28l-1.36,2.4l-0.42,1.76l-0.72,0.53l-0.42,1.11l-0.27,0.21l-0.61,-0.23l-0.37,0.33l-1.25,3.28l-1.84,-0.78l-0.64,0.25l-0.94,2.77l0.08,1.46l-0.73,1.14l-0.19,2.33l-0.89,2.2l-3.25,-0.36l-1.44,-1.76l-1.71,-0.24l-0.5,0.41l-0.26,2.17l0.19,1.3l-0.32,1.45l-0.49,0.45l-0.31,1.04l0.23,0.92l-1.58,2.44l-0.04,2.1l-0.52,2.0l-2.58,4.73l-0.75,3.16l0.14,0.76l1.13,0.55l-1.08,1.38l0.06,0.6l0.45,0.4l-2.16,2.13l-0.55,-0.7l-0.84,0.15l-3.12,2.53l-1.03,-0.56l-1.32,0.26l-0.44,0.91l0.45,1.17l-0.91,0.91l-0.73,-0.05l-2.27,1.0l-1.21,0.96l-2.18,-1.36l-0.73,-0.01l-0.82,1.58l-1.1,0.49l-1.22,1.46l-1.08,0.08l-1.98,-1.09l-1.3,-0.01l-0.61,-0.74l-1.19,-0.6l-0.31,-1.33l-0.89,-0.55l0.36,-0.67l-0.3,-0.81l-0.85,-0.37l-0.84,0.25l-1.33,-0.17l-1.26,-1.19l-2.06,-0.79l-0.76,-1.43l-1.58,-1.24l-0.7,-1.49l-1.0,-0.6l-0.12,-1.09l-1.38,-0.95l-2.0,-2.27l0.71,-2.03l-0.25,-1.62l-0.66,-1.46Z",name:"West Virginia"},"US-NV":{path:"M139.46,329.14l-12.69,-16.93l-36.58,-51.09l-25.34,-34.51l13.7,-64.18l46.88,9.24l46.98,7.74l-18.71,125.81l-0.9,1.16l-0.99,2.19l-0.44,0.17l-1.34,-0.22l-0.98,-2.24l-0.7,-0.63l-1.41,0.22l-1.95,-1.02l-1.6,0.23l-1.78,0.96l-0.76,2.48l0.88,2.59l-0.6,0.97l-0.24,1.3l0.38,3.12l-0.76,2.54l0.77,3.71l-0.13,3.07l-0.3,1.07l-1.04,0.31l0.2,1.31l-0.52,0.62Z",name:"Nevada"},"US-TX":{path:"M276.24,412.51l33.07,1.98l32.79,1.35l0.41,-0.39l3.6,-98.69l25.86,0.61l26.29,0.22l0.05,42.08l0.44,0.4l1.02,-0.13l0.78,0.28l3.74,3.82l1.66,0.21l0.88,-0.58l2.49,0.64l0.6,-0.68l0.11,-1.05l0.6,0.76l0.92,0.22l0.38,0.93l0.77,0.78l-0.01,1.64l0.52,0.83l2.85,0.42l1.25,-0.2l1.38,0.89l2.78,0.69l1.82,-0.56l0.62,0.1l1.89,1.8l1.4,-0.11l1.25,-1.43l2.43,0.26l1.67,-0.46l0.1,2.28l0.91,0.67l1.62,0.4l-0.04,2.08l1.56,0.79l1.82,-0.66l1.57,-1.67l1.02,-0.65l0.41,0.19l0.45,1.64l2.01,0.2l0.24,1.05l0.72,0.48l1.47,-0.21l0.88,-0.93l0.39,0.33l0.59,-0.08l0.61,-0.99l0.26,0.41l-0.45,1.23l0.14,0.76l0.67,1.14l0.78,0.42l0.57,-0.04l0.6,-0.5l0.68,-2.36l0.91,-0.65l0.35,-1.54l0.57,-0.14l0.4,0.14l0.29,0.99l0.57,0.64l1.21,0.02l0.83,0.5l1.25,-0.2l0.68,-1.34l0.48,0.15l-0.13,0.7l0.49,0.69l1.21,0.45l0.49,0.72l1.52,-0.05l1.49,1.74l0.52,0.02l0.63,-0.62l0.08,-0.71l1.49,-0.1l0.93,-1.43l1.88,-0.41l1.66,-1.13l1.52,0.83l1.51,-0.22l0.29,-0.83l2.29,-0.73l0.52,-0.55l0.5,0.32l0.38,0.88l1.82,0.42l1.69,-0.06l1.86,-1.14l0.41,-1.05l1.06,0.31l2.24,1.56l1.16,0.17l1.79,2.08l2.14,0.41l1.04,0.92l0.76,-0.11l2.48,0.85l1.04,0.04l0.37,0.79l1.38,0.97l1.45,-0.12l0.39,-0.72l0.8,0.36l0.88,-0.4l0.92,0.35l0.76,-0.15l0.64,0.36l2.22,34.02l1.51,1.67l1.3,0.82l1.25,1.87l0.57,1.63l-0.1,2.64l1.0,1.21l0.85,0.4l-0.12,0.85l0.75,0.54l0.28,0.87l0.65,0.7l-0.19,1.17l1.0,1.02l0.59,1.63l0.5,0.34l0.55,-0.1l-0.16,1.71l0.81,1.22l-0.64,0.25l-0.35,0.68l0.77,1.27l-0.55,0.89l0.19,1.39l-0.75,2.69l-0.74,0.85l-0.36,1.54l-0.79,1.13l0.64,2.0l-0.83,2.28l0.17,1.07l0.83,1.2l-0.19,1.01l0.49,1.6l-0.24,1.41l-1.18,1.78l-1.18,0.4l-1.16,2.72l-0.03,2.1l1.39,1.67l-3.43,0.08l-7.37,3.78l-0.02,-0.43l-0.69,-0.24l-0.23,0.23l-0.78,-0.43l-3.38,1.13l0.65,-1.31l0.35,-2.04l-0.34,-1.36l-0.8,-0.78l-1.79,0.16l-1.18,2.58l-0.42,0.15l-0.36,-0.65l-2.38,-1.23l-0.4,0.31l-0.18,0.82l0.23,0.45l1.07,0.38l-0.3,0.82l0.54,0.81l-0.47,0.64l0.04,0.99l1.48,0.76l-0.44,0.47l0.5,1.12l0.91,0.23l0.28,0.37l-0.4,1.25l-0.45,-0.12l-0.97,0.81l-1.72,2.25l-1.18,-0.4l-0.49,0.12l0.32,1.0l0.08,2.54l-1.85,1.49l-1.91,2.11l-0.96,0.37l-4.1,2.9l-3.3,0.44l-2.54,1.07l-0.2,1.12l-0.75,-0.34l-2.04,0.89l-0.33,-0.34l-1.11,0.18l0.43,-0.87l-0.52,-0.6l-1.43,0.22l-1.22,1.08l-0.6,-0.62l-0.11,-1.2l-1.38,-0.81l-0.5,0.44l0.65,1.44l0.01,1.12l-0.71,0.09l-0.54,-0.44l-0.75,-0.0l-0.55,-1.34l-1.46,-0.37l-0.58,0.39l0.04,0.54l0.94,1.7l0.03,1.23l0.58,0.37l0.37,-0.16l1.13,0.78l-0.75,0.37l-0.12,0.9l0.7,0.23l1.08,-0.55l0.96,0.6l-4.27,2.42l-0.57,-0.13l-0.37,-1.44l-0.5,-0.19l-1.13,-1.47l-0.48,-0.03l-1.05,1.99l1.19,1.61l-0.31,1.04l0.33,0.85l-1.66,1.79l-0.37,0.2l0.37,-0.63l-0.18,-0.72l0.25,-0.73l-0.46,-0.67l-0.52,0.17l-0.71,1.1l0.26,0.72l-0.39,0.95l-0.07,-1.13l-0.52,-0.55l-1.95,1.29l-0.78,-0.33l-0.69,0.51l0.07,0.75l-0.81,0.99l0.02,0.49l1.25,0.63l0.03,0.56l0.78,0.29l0.7,-1.41l0.86,-0.41l0.01,0.62l-2.82,4.36l-1.23,-1.0l-1.36,0.39l-0.32,-0.34l-2.4,0.39l-0.46,-0.31l-0.65,0.16l-0.18,0.58l0.41,0.61l0.55,0.38l1.53,0.03l0.54,1.55l2.07,1.03l-2.7,7.63l-0.2,0.1l-0.39,-0.54l-0.33,0.1l0.18,-0.75l-0.57,-0.43l-2.35,1.95l-1.67,-2.31l-1.23,-0.97l-0.61,0.4l0.09,0.52l1.44,2.0l-0.24,0.46l0.36,0.47l-1.17,-0.21l-0.33,0.63l0.5,0.56l0.89,0.23l1.12,-0.16l0.66,0.62l1.37,0.18l1.0,-0.03l0.99,-0.62l-0.34,1.59l0.24,0.77l-0.98,0.7l0.37,1.59l-1.12,0.14l-0.43,0.41l0.4,2.11l-0.33,1.6l0.45,0.64l0.84,0.24l0.87,2.86l0.71,2.8l-0.91,0.82l0.62,0.49l-0.08,1.28l0.71,0.3l0.18,0.61l0.58,0.29l0.4,1.79l0.68,0.31l0.45,3.21l1.46,0.62l-0.52,1.1l0.31,1.08l-0.62,0.77l-0.84,-0.05l-0.54,0.44l0.09,1.3l-0.49,-0.33l-0.49,0.25l-0.39,-0.67l-1.49,-0.45l-2.92,-2.53l-2.2,-0.18l-0.81,-0.51l-4.2,0.09l-0.9,0.42l-0.79,-0.62l-1.64,0.24l-2.12,-0.89l-0.73,-0.97l-0.6,-0.14l-0.21,-0.72l-1.17,-0.49l-0.99,-0.02l-1.98,-0.87l-1.45,0.39l-0.83,-1.09l-0.6,-0.21l-1.43,-1.38l-1.96,0.01l-1.47,-0.64l-0.86,0.11l-1.62,-0.41l0.35,-0.9l-0.3,-0.97l-1.11,-0.7l0.3,-0.29l-0.26,-1.44l0.56,-1.21l-0.35,-0.67l0.88,-0.38l0.12,-0.54l-1.04,-0.54l-0.91,0.67l-0.32,-0.31l0.03,-1.09l-0.59,-0.83l0.31,-0.09l0.53,-1.43l-0.22,-0.71l-0.71,0.09l-1.03,0.96l-0.57,-0.89l-0.85,-0.28l-0.26,-1.34l-1.51,-0.77l0.29,-0.65l-0.24,-0.76l0.34,-2.18l-0.45,-0.96l-1.04,-1.01l0.65,-1.99l0.05,-1.19l-0.18,-0.7l-0.54,-0.33l-0.15,-1.81l-1.85,-1.44l-0.86,0.21l-0.3,-0.41l-0.81,-0.11l-0.74,-1.31l-2.22,-1.71l0.01,-0.69l-0.51,-0.58l0.12,-0.87l-0.97,-0.92l-0.08,-0.75l-1.12,-0.61l-1.3,-2.88l-2.66,-1.48l-0.38,-0.91l-1.13,-0.59l-0.06,-1.16l-0.82,-1.19l-0.59,-1.95l0.41,-0.22l-0.04,-0.72l-1.03,-0.49l-0.26,-1.29l-0.82,-0.58l-0.94,-1.73l-0.61,-2.38l-1.85,-2.36l-0.87,-4.24l-1.81,-1.34l0.05,-0.7l-0.75,-1.21l-4.07,-2.82l-0.29,-1.39l1.68,-0.02l0.79,-0.84l-0.29,-0.39l-0.65,-0.06l-0.09,-0.72l0.08,-0.89l0.64,-0.7l-0.11,-0.74l-0.48,0.05l-0.77,0.72l-0.45,0.69l0.01,0.66l-0.88,0.15l-0.39,1.07l-0.54,-0.04l-1.81,-1.75l0.06,-0.67l-0.41,-0.68l-0.77,-0.2l-0.64,0.29l-0.33,-0.53l-0.73,-0.13l-0.89,-2.16l-1.49,-0.8l-0.85,0.27l-0.44,-0.87l-0.61,0.1l-0.25,0.61l-1.05,0.16l-2.88,-0.47l-0.39,-0.38l-1.48,-0.03l-0.79,0.29l-0.77,-0.44l-2.66,0.27l-2.42,-1.08l-1.14,-0.89l-0.68,-0.07l-1.03,0.82l-0.64,1.61l-1.99,-0.17l-0.51,0.44l-0.49,-0.17l-2.52,0.78l-3.07,6.25l-0.18,1.77l-0.76,0.67l-0.38,1.8l0.35,0.59l-1.97,0.98l-0.75,1.32l-1.07,0.61l-0.62,0.83l-0.29,1.09l-2.91,-0.34l-1.04,-0.87l-0.54,0.3l-1.69,-1.21l-1.31,-1.63l-2.9,-0.85l-1.15,-0.95l-0.02,-0.67l-0.42,-0.4l-2.75,-0.51l-2.28,-1.03l-1.89,-1.75l-0.91,-1.53l-0.96,-0.91l-1.53,-0.29l-1.76,-1.26l-0.22,-0.56l-1.14,-0.97l-0.83,-2.9l-0.86,-1.01l-0.24,-1.1l-0.76,-1.27l-0.26,-2.34l0.52,-3.04l-3.0,-5.07l-0.06,-1.94l-1.26,-2.51l-0.99,-0.44l-0.43,-1.24l-1.43,-0.81l-2.15,-2.17l-1.02,-0.1l-2.01,-1.25l-3.18,-3.35l-0.59,-1.55l-3.13,-2.55l-1.59,-2.45l-1.19,-0.95l-0.61,-1.05l-4.42,-2.6l-2.4,-5.42l-1.37,-1.08l-1.12,-0.08l-1.76,-1.68l-0.79,-3.05ZM502.12,468.09l-0.33,0.17l0.18,-0.16l0.15,-0.02ZM498.72,470.76l-0.09,0.12l-0.04,0.02l0.13,-0.14ZM467.58,489.09l0.03,0.02l-0.02,0.02l-0.0,-0.03ZM453.97,547.08l0.76,-0.5l0.25,-0.68l0.11,1.08l-1.11,0.1Z",name:"Texas"},"US-NH":{path:"M829.91,105.39l0.2,-1.33l-1.43,-5.38l0.53,-1.45l-0.28,-2.22l1.0,-1.86l-0.13,-2.3l0.64,-2.28l-0.44,-0.62l0.29,-2.3l-0.93,-3.8l0.08,-0.7l0.3,-0.45l1.83,-0.8l0.7,-1.39l1.43,-1.62l0.74,-1.8l-0.25,-1.13l0.52,-0.62l-2.34,-3.49l0.87,-3.26l-0.11,-0.78l-0.81,-1.29l0.28,-0.59l-0.23,-0.7l0.48,-3.2l-0.36,-0.82l0.91,-1.49l2.44,0.33l0.65,-0.86l12.99,34.86l0.84,3.65l2.6,2.21l0.88,0.34l0.36,1.6l1.71,1.31l0.0,0.35l0.77,0.23l-0.06,0.58l-0.46,3.09l-1.57,0.24l-1.32,1.19l-0.51,0.94l-0.96,0.37l-0.5,1.68l-1.1,1.44l-17.61,4.74l-1.7,-1.43l-0.41,-0.89l-0.1,-2.0l0.54,-0.59l0.03,-0.52l-1.02,-5.18Z",name:"New Hampshire"},"US-NY":{path:"M821.95,168.59l-0.84,-0.72l0.83,-3.23l1.03,-0.3l0.37,-0.48l0.74,0.21l0.64,-0.32l-0.06,-0.58l0.43,-0.05l0.28,-0.66l0.72,-0.32l-0.21,-1.42l0.73,-0.47l0.35,0.56l1.04,-0.16l0.49,-0.33l0.01,-0.54l1.46,-0.18l0.24,-0.74l1.66,0.02l0.91,-0.54l0.45,-1.21l0.62,0.24l0.43,-0.5l4.32,-1.28l2.35,-1.12l2.36,-2.84l0.18,0.17l-2.53,3.41l-0.01,0.46l0.56,0.38l1.59,-0.33l0.28,0.61l-1.3,1.19l-2.05,0.53l-0.37,0.58l-1.16,0.41l0.23,0.43l-0.24,0.3l-0.68,-0.16l-0.74,0.7l-1.04,0.17l-0.37,0.55l-1.42,0.45l-0.26,0.67l-1.34,0.19l-0.44,0.7l-1.35,0.96l-2.77,1.33l-1.02,0.88l-1.04,0.09l-0.32,0.93l-0.28,0.03l-0.26,-0.68l-1.45,-0.25l-0.88,0.74l0.07,0.96l-0.94,0.56ZM844.29,155.03l0.88,-2.14l1.18,-0.48l0.6,-0.93l0.81,0.34l0.13,-0.83l0.75,0.63l-3.84,3.68l-0.51,-0.28ZM845.16,149.15l0.06,-0.06l0.18,-0.06l-0.11,0.19l-0.13,-0.07ZM722.08,155.52l3.76,-3.85l1.27,-2.19l1.75,-1.86l1.16,-0.78l1.28,-3.35l2.09,-2.13l-0.21,-1.84l-1.61,-2.42l0.42,-1.13l-0.17,-0.78l-0.83,-0.53l-2.09,-0.0l0.04,-0.99l-0.58,-2.23l4.98,-2.94l4.48,-1.79l2.38,-0.2l1.84,-0.74l5.64,-0.24l3.12,1.25l3.16,-1.68l5.49,-1.06l0.59,0.45l0.68,-0.2l0.12,-0.99l3.23,-1.85l0.69,-2.05l1.87,-1.76l0.78,-1.26l1.12,0.03l1.13,-0.52l1.07,-1.63l-0.46,-0.69l0.36,-1.2l-0.25,-0.51l-0.64,0.02l-0.17,-1.18l-0.94,-1.58l-1.01,-0.62l0.12,-0.18l0.59,0.39l0.53,-0.27l0.75,-1.43l-0.01,-0.92l0.81,-0.64l-0.01,-0.98l-0.93,-0.19l-0.6,0.7l-0.28,0.12l0.56,-1.3l-0.81,-0.63l-1.26,0.05l-0.87,0.77l-0.98,-0.7l2.05,-2.51l1.78,-1.47l1.67,-2.63l0.7,-0.56l0.89,-1.54l0.07,-0.56l-0.49,-0.94l0.78,-1.9l4.82,-7.61l4.76,-4.5l2.84,-0.51l19.65,-5.66l0.4,0.87l-0.08,2.01l1.02,1.22l0.43,3.79l2.29,3.25l-0.09,1.89l0.85,2.41l-0.59,1.07l-0.0,3.41l0.71,0.89l1.32,2.76l0.19,1.09l0.62,0.84l0.12,3.92l0.55,0.85l0.54,0.07l0.53,-0.61l0.06,-0.87l0.33,-0.07l1.05,1.12l3.87,14.48l0.11,1.59l0.62,1.09l0.33,14.92l0.6,0.62l3.57,16.23l1.26,1.34l-2.82,3.18l0.03,0.54l1.74,1.62l-1.86,3.37l0.21,1.06l-1.03,0.45l-0.24,-4.26l-0.56,-2.23l-0.74,-1.62l-1.46,-1.1l-0.17,-1.13l-0.7,-0.09l-0.42,1.33l0.8,1.45l0.94,0.69l0.95,2.79l-13.74,-4.06l-1.28,-1.47l-2.39,0.24l-0.63,-0.43l-1.06,-0.15l-1.74,-1.91l-0.75,-2.33l0.12,-0.72l-0.36,-0.63l-0.56,-0.21l0.09,-0.46l-0.35,-0.42l-1.64,-0.68l-1.08,0.32l-0.53,-1.22l-1.92,-0.93l-34.6,8.73l-34.43,7.84l-1.11,-5.15Z",name:"New York"},"US-HI":{path:"M293.44,610.32l-0.16,-1.33l-1.79,-3.5l-1.21,-1.37l0.23,-0.95l-0.21,-0.49l0.64,-1.68l4.55,-5.05l0.88,-5.09l0.45,-0.65l0.48,-2.22l-0.34,-2.5l0.41,-1.79l1.19,-0.79l1.55,-0.08l1.27,-0.5l1.51,0.3l2.68,-1.18l1.51,-0.07l1.15,-1.13l-0.03,-3.17l0.35,-1.25l0.99,-1.6l1.21,-0.53l2.67,2.45l-0.1,1.68l1.07,1.67l0.81,2.19l1.64,1.05l2.04,2.64l3.96,7.75l0.59,3.31l-2.1,3.31l0.14,0.54l0.73,0.44l1.2,0.23l0.29,0.68l-0.01,0.53l-0.8,1.13l-0.09,1.86l0.56,2.06l1.01,1.51l0.17,1.18l-0.37,0.44l-2.35,0.67l-1.45,-0.32l-2.49,0.4l-1.2,-0.39l-2.49,-0.11l-3.15,-1.01l-0.9,-0.94l-1.39,-0.68l-2.87,0.15l-4.73,-0.64l-1.91,0.32l-1.08,1.21l-1.89,0.33l-1.22,0.8l-1.62,0.21ZM302.97,554.35l1.47,-2.4l0.62,-1.93l-0.3,-0.8l-0.55,-0.42l-1.1,0.04l-1.49,-2.22l-0.31,-2.64l0.31,-0.99l0.92,-0.89l0.88,-0.53l1.05,-0.12l0.9,0.44l0.73,1.4l0.05,3.78l1.07,0.23l1.89,1.04l1.66,0.12l1.88,1.67l0.65,3.28l0.56,0.34l0.11,1.09l2.18,2.69l-0.14,1.17l-1.45,1.15l-0.84,-0.19l-0.81,0.3l-0.68,-0.4l-1.7,-0.23l-1.91,-1.3l-3.1,-0.5l-0.96,-1.02l-1.42,-0.79l-0.16,-1.4ZM273.53,509.24l-0.16,-0.35l0.54,-1.85l-0.3,-1.63l0.39,-1.12l-0.31,-1.61l0.83,-1.4l-0.26,-1.26l3.14,2.06l2.55,-0.17l1.08,-0.64l1.25,-0.12l0.77,0.28l0.39,1.22l-0.11,1.03l-0.4,0.54l0.01,2.42l0.41,1.21l-0.78,0.43l-0.61,1.27l0.64,2.46l0.61,0.41l0.56,-0.16l-0.24,0.78l0.3,0.88l-0.35,0.37l-0.14,1.04l0.56,1.3l-1.15,0.14l-0.29,-0.77l-2.67,-0.85l-0.05,-0.86l-0.79,-1.25l0.15,-0.76l-0.26,-0.63l-1.05,0.24l-0.45,-0.78l0.16,-0.27l1.0,0.06l0.45,-0.62l-0.42,-0.96l-0.64,-0.2l-0.35,-0.61l-0.47,0.25l-0.47,-0.55l-0.38,0.32l0.14,1.95l-2.85,-1.22ZM284.15,511.85l0.1,-0.21l-0.0,-0.01l0.1,0.09l-0.19,0.14ZM246.14,461.52l2.01,-0.42l1.12,-0.67l1.33,0.51l3.66,0.37l0.71,1.4l1.04,-0.06l1.12,1.14l0.89,0.21l0.72,0.89l0.28,1.56l-0.23,1.15l-0.51,0.62l-2.05,0.87l-1.37,1.99l-0.6,-0.19l-0.46,0.49l-2.84,0.16l-3.61,-3.83l-0.24,-1.91l-1.68,-2.24l0.05,-1.26l0.66,-0.81Z",name:"Hawaii"},"US-VT":{path:"M805.54,72.68l26.02,-7.96l0.89,1.85l-0.74,2.37l-0.03,1.54l2.22,2.75l-0.51,0.58l0.26,1.13l-0.67,1.6l-1.35,1.49l-0.64,1.32l-1.72,0.7l-0.62,0.92l-0.1,0.98l0.93,3.74l-0.29,2.44l0.4,0.54l-0.6,2.11l0.15,2.19l-1.0,1.87l0.27,2.36l-0.53,1.54l1.43,5.44l-0.22,1.22l1.05,5.3l-0.58,0.85l0.11,2.31l0.6,1.26l1.51,1.1l-11.72,3.08l-4.31,-16.79l-1.72,-1.59l-0.91,0.25l-0.3,1.19l-0.12,-0.26l-0.11,-3.91l-0.68,-1.0l-0.14,-0.98l-1.37,-2.85l-0.63,-0.68l0.01,-3.15l0.6,-1.15l-0.86,-2.57l0.08,-1.93l-0.39,-0.91l-1.55,-1.63l-0.38,-0.81l-0.41,-3.71l-1.03,-1.27l0.11,-1.87l-0.42,-1.0Z",name:"Vermont"},"US-NM":{path:"M230.94,422.8l11.82,-123.64l25.66,2.24l26.09,1.86l26.12,1.45l25.74,1.02l-0.31,10.24l-0.74,0.39l-3.59,98.67l-32.38,-1.34l-33.52,-2.02l-0.44,0.76l0.54,2.31l0.44,1.26l1.0,0.77l-30.53,-2.46l-0.43,0.36l-0.81,9.46l-14.64,-1.33Z",name:"New Mexico"},"US-NC":{path:"M676.72,321.71l0.92,0.17l1.52,-0.39l0.42,-0.39l0.52,-0.97l0.13,-2.7l1.34,-1.19l0.47,-1.05l2.24,-1.47l2.12,-0.52l0.76,0.18l1.32,-0.52l2.36,-2.52l0.78,-0.25l1.84,-2.29l1.48,-1.0l1.55,-0.19l1.15,-2.65l-0.28,-1.22l1.65,0.06l0.51,-1.65l0.93,-0.77l1.08,-0.77l0.51,1.52l1.07,0.33l1.34,-1.17l1.35,-2.64l2.49,-1.59l0.79,0.08l0.82,0.8l1.06,-0.21l0.84,-1.07l1.47,-4.18l1.08,-1.1l1.47,0.09l0.44,-0.31l-0.69,-1.26l0.4,-2.0l-0.42,-0.9l0.38,-1.25l7.42,-0.86l19.54,-3.36l37.21,-8.42l31.11,-7.87l0.4,1.21l3.54,3.24l1.0,1.53l-1.2,-1.0l-0.16,-0.63l-0.92,-0.41l-0.52,0.05l-0.24,0.65l0.66,0.54l0.59,1.56l-0.53,0.01l-0.91,-0.75l-2.31,-0.8l-0.4,-0.48l-0.55,0.13l-0.31,0.69l0.14,0.64l1.37,0.44l1.69,1.38l-1.1,0.66l-2.49,-1.2l-0.35,0.5l0.14,0.42l1.6,1.18l-1.84,-0.33l-2.23,-0.87l-0.46,0.14l0.01,0.48l0.6,0.7l1.7,0.83l-0.97,0.58l0.0,0.6l-0.43,0.53l-1.48,0.75l-0.89,-0.77l-0.61,0.22l-0.1,0.35l-0.2,-0.13l-1.31,-2.32l0.21,-2.63l-0.42,-0.48l-0.89,-0.22l-0.37,0.64l0.62,0.71l-0.43,0.99l-0.02,1.03l0.49,1.73l1.6,2.2l-0.31,1.28l0.48,0.29l2.97,-0.59l2.1,-1.49l0.27,0.01l0.37,0.79l0.76,-0.34l1.56,0.05l0.16,-0.72l-0.57,-0.32l1.29,-0.76l2.04,-0.46l-0.1,1.19l0.64,0.29l-0.6,0.88l0.88,1.19l-0.84,0.1l-0.19,0.66l1.38,0.46l0.26,0.94l-1.21,0.05l-0.19,0.66l0.66,0.59l1.25,-0.16l0.52,0.26l0.41,-0.38l0.18,-1.95l-0.75,-3.33l0.41,-0.48l0.56,0.43l0.94,0.06l0.28,-0.58l-0.29,-0.44l0.48,-0.57l1.71,1.84l-0.01,1.4l0.62,0.9l-0.78,0.65l0.9,1.14l-0.08,0.37l-0.42,0.55l-0.78,0.09l-0.91,-0.86l-0.32,0.34l0.13,1.26l-1.08,1.62l0.2,0.57l-0.33,0.22l-0.15,0.98l-0.74,0.55l0.1,0.91l-0.9,0.97l-1.06,0.21l-0.6,-0.37l-0.52,0.52l-0.93,-0.81l-0.86,0.1l-0.4,-0.82l-0.59,-0.21l-0.52,0.38l0.08,0.94l-0.52,0.22l-1.42,-1.24l1.31,-0.4l0.23,-0.88l-0.57,-0.42l-2.02,0.31l-1.14,1.01l0.29,0.67l0.44,0.16l-0.06,0.39l0.15,0.43l0.35,0.25l-0.03,0.12l-0.57,-0.34l-1.69,0.83l-1.12,-0.43l-1.45,0.06l-3.32,-0.7l0.42,1.08l0.97,0.45l0.36,0.64l1.51,-0.21l4.03,1.02l3.51,0.11l0.47,0.42l-0.06,0.52l-0.99,0.05l-0.25,0.72l-1.62,1.44l0.32,0.58l1.85,0.01l-2.56,3.5l-1.67,0.04l-1.6,-0.98l-0.9,-0.19l-1.21,-1.02l-1.12,0.07l0.07,0.47l1.04,1.14l2.32,2.09l2.68,0.26l1.31,0.49l1.7,-2.16l0.51,0.47l1.17,0.33l0.4,-0.57l-0.55,-0.9l0.87,0.16l0.19,0.57l0.66,0.23l1.63,-1.2l-0.18,0.61l0.29,0.57l-0.29,0.38l-0.43,-0.21l-0.41,0.37l0.03,0.9l-0.97,1.72l0.01,0.78l-0.71,-0.07l-0.06,-0.74l-1.12,-0.61l-0.42,0.47l0.27,1.45l-0.52,-1.1l-0.65,-0.15l-1.22,1.08l-0.21,0.53l0.25,0.27l-2.03,0.32l-2.75,1.84l-0.67,-1.03l-0.75,-0.3l-0.37,0.49l0.43,1.26l-0.57,-0.01l-0.09,0.82l-0.94,1.73l-0.91,0.84l-0.59,-0.26l0.49,-0.69l-0.02,-0.77l-1.06,-0.93l-0.08,-0.52l-1.69,-0.41l-0.16,0.47l0.43,1.16l0.2,0.33l0.58,0.07l0.3,0.61l-0.88,0.37l-0.08,0.71l0.65,0.64l0.77,0.18l-0.01,0.37l-2.12,1.67l-1.91,2.65l-2.0,4.31l-0.34,2.13l0.12,1.33l-0.15,-1.03l-1.0,-1.6l-0.55,-0.17l-0.3,0.48l1.17,3.95l-0.63,2.27l-3.9,0.19l-1.43,0.65l-0.35,-0.52l-0.58,-0.18l-0.54,1.07l-1.9,1.14l-0.61,-0.02l-23.25,-15.36l-1.05,-0.02l-18.68,3.49l-0.65,-2.77l-3.25,-2.84l-0.47,0.08l-1.23,1.31l-0.01,-1.29l-0.82,-0.54l-22.82,3.35l-0.64,-0.27l-0.62,0.46l-0.25,0.65l-3.98,1.92l-0.89,1.23l-1.01,0.08l-4.78,2.66l-20.95,3.93l-0.34,-4.55l0.7,-0.95ZM816.97,271.42l0.19,0.35l0.24,0.38l-0.45,-0.41l0.02,-0.32ZM807.5,290.22l0.2,0.32l-0.16,-0.09l-0.04,-0.24ZM815.28,299.09l0.16,-0.36l0.16,0.07l-0.13,0.29l-0.19,0.01ZM812.72,299.05l-0.06,-0.29l-0.03,-0.11l0.3,0.26l-0.21,0.13Z",name:"North Carolina"},"US-ND":{path:"M438.58,42.78l2.06,6.89l-0.73,2.53l0.57,2.36l-0.27,1.17l0.47,1.99l0.01,3.26l1.42,3.95l0.45,0.54l-0.08,0.97l0.39,1.52l0.62,0.74l1.48,3.74l-0.06,3.9l0.42,0.7l0.5,8.35l0.51,1.54l0.51,0.25l-0.47,2.64l0.36,1.63l-0.14,1.75l0.69,1.1l0.2,2.16l0.49,1.13l1.8,2.56l0.15,2.2l0.51,1.08l0.17,1.39l-0.24,1.36l0.28,1.74l-27.89,0.73l-28.38,0.19l-28.38,-0.37l-28.48,-0.93l2.75,-65.45l23.09,0.78l25.56,0.42l25.56,-0.06l24.09,-0.49Z",name:"North Dakota"},"US-NE":{path:"M422.62,173.98l3.92,2.71l3.93,1.9l1.33,-0.22l0.51,-0.47l0.36,-1.08l0.48,-0.2l2.49,0.34l1.32,-0.47l1.58,0.25l3.45,-0.65l2.37,1.98l1.4,0.14l1.55,0.77l1.45,0.08l0.88,1.1l1.49,0.17l-0.06,0.98l1.68,2.08l3.32,0.6l-0.02,2.55l1.13,1.94l0.01,2.29l1.15,1.07l0.34,1.72l1.73,1.46l0.07,1.88l1.5,2.11l-0.49,2.33l0.44,3.09l0.52,0.54l0.93,-0.2l-0.04,1.25l1.21,0.5l-0.41,2.36l0.21,0.44l1.12,0.4l-0.6,0.77l-0.09,1.01l0.13,0.59l0.82,0.5l0.16,1.45l-0.26,0.92l0.26,1.27l0.55,0.61l0.3,1.93l-0.22,1.33l0.23,0.72l-0.57,0.92l0.02,0.79l0.45,0.88l1.23,0.63l0.25,2.5l1.1,0.51l0.03,0.79l1.18,2.75l-0.23,0.96l1.16,0.21l0.8,0.99l1.1,0.24l-0.15,0.96l1.31,1.68l-0.21,1.12l0.51,0.91l-26.14,1.05l-27.83,0.63l-27.84,0.14l-27.88,-0.35l0.46,-21.65l-0.39,-0.41l-32.35,-1.04l1.85,-43.23l43.35,1.22l44.66,-0.04Z",name:"Nebraska"},"US-LA":{path:"M509.0,412.88l-1.33,-21.76l51.43,-4.07l0.34,0.83l1.48,0.65l-0.92,1.35l-0.25,2.13l0.49,0.72l1.18,0.31l-1.21,0.47l-0.45,0.78l0.45,1.36l1.04,0.84l0.08,2.15l0.46,0.54l1.51,0.74l0.45,1.05l1.42,0.44l-0.87,1.22l-0.85,2.34l-0.75,0.04l-0.52,0.51l-0.02,0.73l0.63,0.72l-0.22,1.16l-1.34,0.96l-1.08,1.89l-1.37,0.67l-0.68,0.83l-0.79,2.42l-0.25,3.52l-1.55,1.74l0.13,1.2l0.62,0.96l-0.35,2.38l-1.61,0.29l-0.6,0.57l0.28,0.97l0.64,0.59l-0.26,1.41l0.98,1.51l-1.18,1.18l-0.08,0.45l0.4,0.23l6.18,-0.55l29.23,-2.92l-0.68,3.47l-0.52,1.02l-0.2,2.24l0.69,0.98l-0.09,0.66l0.6,1.0l1.31,0.7l1.22,1.42l0.14,0.88l0.89,1.39l0.14,1.05l1.11,1.84l-1.85,0.39l-0.38,-0.08l-0.01,-0.56l-0.53,-0.57l-1.28,0.27l-1.18,-0.59l-1.51,0.17l-0.61,-0.98l-1.24,-0.86l-2.84,-0.47l-1.24,0.63l-1.39,2.3l-1.3,1.42l-0.42,0.91l0.07,1.2l0.55,0.89l0.82,0.57l4.25,0.82l3.35,-1.0l1.32,-1.19l0.68,-1.2l0.34,0.59l1.08,0.43l0.59,-0.4l0.81,0.03l0.51,-0.46l-0.76,1.21l-1.12,-0.12l-0.57,0.32l-0.38,0.62l0.0,0.83l0.76,1.22l1.48,-0.02l0.65,0.89l1.1,0.48l1.44,-0.66l0.46,-1.11l-0.02,-1.37l0.93,-0.57l0.42,-0.99l0.23,0.05l0.1,1.16l-0.24,0.25l0.19,0.57l0.42,0.15l-0.07,0.75l1.34,1.08l0.35,-0.16l-0.48,0.59l0.18,0.63l-0.24,0.17l-0.84,-0.72l-0.71,-0.08l-1.0,1.89l-0.84,0.14l-0.46,0.53l0.16,1.19l-1.59,-0.6l-0.43,0.19l0.04,0.46l1.14,1.06l-1.17,-0.14l-0.92,0.6l0.68,0.43l1.26,2.04l2.74,0.97l-0.08,1.2l0.33,0.4l2.07,-0.31l0.77,0.17l0.17,0.53l0.73,0.32l1.35,-0.34l0.53,0.78l1.08,-0.46l1.13,0.73l0.14,0.3l-0.41,0.63l1.54,0.86l-0.39,0.65l0.39,0.58l-0.18,0.62l-0.95,1.49l-1.3,-1.56l-0.68,0.34l0.1,0.66l-0.38,0.12l0.41,-1.88l-1.32,-0.76l-0.51,0.5l0.2,1.17l-0.54,0.45l-0.27,-1.02l-0.57,-0.25l-0.89,-1.27l0.03,-0.77l-0.96,-0.14l-0.47,0.5l-1.41,-0.17l-0.74,-0.77l-2.31,-0.09l0.38,-0.86l-0.13,-0.66l-0.64,-0.69l-0.91,0.04l0.1,-0.96l-0.37,-0.36l-0.91,-0.03l-0.22,0.59l-0.85,-0.38l-0.48,0.27l-2.61,-1.26l-1.24,-0.02l-0.67,-0.64l-0.61,0.18l-0.3,0.56l-0.05,1.25l1.72,0.94l1.67,0.35l-0.16,0.92l0.28,0.4l-0.34,0.34l0.23,0.68l-0.76,0.94l-0.03,0.66l0.81,0.97l-0.95,1.43l-1.33,0.94l-0.76,-1.15l0.22,-1.5l-0.35,-0.92l-0.49,-0.18l-0.4,0.36l-1.15,-1.08l-0.6,0.42l-0.76,-1.05l-0.62,-0.2l-0.64,1.33l-0.85,0.26l-0.89,-0.53l-0.85,0.53l-0.1,0.62l0.48,0.41l-0.67,0.56l-0.13,1.44l-0.46,0.13l-0.4,0.84l-0.92,0.08l-0.11,-0.68l-1.6,-0.4l-0.76,0.97l-1.92,-0.93l-0.3,-0.54l-0.99,0.01l-0.35,0.6l-1.15,-0.51l0.42,-0.4l0.0,-1.46l-0.38,-0.57l-1.9,-1.19l-0.08,-0.54l-0.83,-0.71l-0.09,-0.91l0.73,-1.15l-0.34,-1.14l-0.88,-0.19l-0.34,0.57l0.16,0.43l-0.58,0.81l0.04,0.91l-1.8,-0.4l0.07,-0.39l-0.47,-0.54l-1.97,0.76l-0.7,-2.22l-1.32,0.23l-0.18,-2.12l-1.31,-0.35l-1.89,0.3l-1.08,0.66l-0.21,-0.71l0.84,-0.26l-0.05,-0.8l-0.6,-0.58l-1.03,-0.1l-0.85,0.42l-0.94,-0.15l-0.4,0.8l-2.0,1.11l-0.63,-0.31l-1.29,0.71l0.54,1.37l0.81,0.31l1.04,1.55l-1.27,0.36l-1.82,1.06l-7.63,-0.92l-6.7,-2.31l-3.46,-0.65l-6.85,0.69l-3.41,0.8l-1.57,0.73l-0.91,-1.41l1.2,-0.46l0.79,-0.98l0.27,-2.3l-0.59,-0.84l1.15,-1.62l0.23,-1.59l-0.5,-1.83l0.07,-1.46l-0.66,-0.7l-0.21,-1.04l0.83,-2.21l-0.64,-1.95l0.76,-0.84l0.3,-1.49l0.78,-0.94l0.79,-2.83l-0.18,-1.42l0.58,-0.97l-0.75,-1.33l0.84,-0.39l0.2,-0.44l-0.89,-1.36l0.03,-2.13l-1.07,-0.23l-0.57,-1.57l-0.92,-0.84l0.28,-1.27l-0.81,-0.76l-0.33,-0.95l-0.64,-0.34l0.22,-0.98l-1.16,-0.58l-0.81,-0.93l0.16,-2.46l-0.68,-1.93l-1.33,-1.98l-2.63,-2.21ZM548.97,462.65l0.0,-0.0l0.0,0.0l-0.0,0.0ZM607.49,467.36l-0.03,-0.03l-0.08,-0.04l0.13,-0.01l-0.03,0.08ZM607.51,465.75l-0.02,-0.01l0.03,-0.01l-0.02,0.02ZM567.05,468.89l-2.0,-0.42l-0.66,-0.5l0.73,-0.43l0.35,-0.75l0.39,0.49l0.83,0.21l-0.14,0.6l0.5,0.81Z",name:"Louisiana"},"US-SD":{path:"M336.43,128.81l0.3,-0.53l0.75,-19.92l28.49,0.93l28.39,0.37l28.39,-0.19l27.77,-0.73l-0.18,1.71l-0.73,1.71l-2.9,2.46l-0.42,1.27l1.59,2.13l1.06,2.06l0.55,0.36l1.74,0.24l1.01,0.84l0.57,1.02l1.45,38.83l-1.84,0.09l-0.42,0.56l0.24,1.44l0.88,1.14l0.01,1.45l-0.65,0.36l0.17,1.48l0.48,0.43l1.09,0.04l0.34,1.68l-0.16,0.91l-0.62,0.83l0.02,1.73l-0.68,2.45l-0.49,0.44l-0.67,1.88l0.5,1.1l1.33,1.08l-0.16,0.62l0.64,0.66l0.35,1.15l-1.65,-0.28l-0.34,-0.94l-0.85,-0.73l0.19,-0.61l-0.28,-0.59l-1.58,-0.23l-1.03,-1.18l-1.57,-0.11l-1.51,-0.75l-1.34,-0.12l-2.38,-1.99l-3.78,0.6l-1.65,-0.25l-1.19,0.46l-2.62,-0.33l-0.98,0.48l-0.76,1.45l-0.72,0.05l-3.66,-1.82l-4.13,-2.8l-44.82,0.05l-43.33,-1.22l1.79,-43.19Z",name:"South Dakota"},"US-DC":{path:"M783.1,218.48l-0.45,-0.64l-1.55,-0.67l0.58,-1.01l2.03,1.26l-0.61,1.06Z",name:"District of Columbia"},"US-DE":{path:"M798.42,195.12l0.48,-1.56l0.92,-1.11l1.72,-0.71l1.12,0.06l-0.33,0.56l-0.08,1.38l-0.46,1.09l-0.6,0.54l-0.09,0.77l0.13,0.61l1.03,0.85l0.11,2.31l3.98,3.32l1.13,3.99l1.96,1.68l0.47,1.26l3.17,2.27l1.35,-0.08l0.48,1.21l-0.58,0.27l-0.31,0.67l0.03,0.76l0.36,0.19l-0.82,0.57l-0.08,1.21l0.66,0.21l0.85,-0.73l0.72,0.34l0.3,-0.21l0.59,1.55l-9.84,2.64l-8.37,-25.89Z",name:"Delaware"},"US-FL":{path:"M630.29,423.61l47.18,-6.86l1.52,1.91l0.86,2.72l1.47,1.0l48.78,-5.11l1.03,1.38l0.03,1.09l0.55,1.05l1.04,0.48l1.64,-0.28l0.85,-0.75l-0.14,-4.57l-0.98,-1.49l-0.22,-1.77l0.28,-0.74l0.62,-0.3l0.12,-0.7l5.59,0.96l4.03,-0.16l0.14,1.24l-0.75,-0.12l-0.32,0.43l0.25,1.54l2.11,1.81l0.22,1.01l0.42,0.38l0.3,1.92l5.3,11.5l1.81,3.07l7.14,10.22l0.63,0.36l6.82,7.53l-0.48,-0.02l-0.27,0.61l-1.35,-0.02l-0.34,-0.65l0.38,-1.38l-0.16,-0.56l-2.3,-0.92l-0.46,0.53l1.0,2.8l0.78,0.97l2.14,4.77l9.92,13.71l1.37,3.11l3.66,5.34l-1.38,-0.35l-0.43,0.74l0.8,0.65l0.85,0.24l0.56,-0.22l1.46,0.94l2.05,3.05l-0.5,0.34l-0.12,0.53l1.16,0.53l0.89,1.83l-0.08,1.06l0.59,0.95l0.61,2.64l-0.27,0.75l0.93,8.98l-0.31,1.07l0.46,0.67l0.5,3.1l-0.78,1.26l0.03,2.43l-0.84,0.74l-0.22,1.8l-0.48,0.85l0.21,1.47l-0.31,1.74l0.54,1.74l0.45,0.23l-1.15,1.8l-0.39,1.28l-0.94,0.24l-0.53,-0.22l-1.37,0.45l-0.35,1.06l-0.89,0.3l-0.18,0.58l-0.85,0.67l-1.44,0.14l-0.27,-0.32l-1.23,-0.1l-0.9,1.05l-3.17,1.13l-1.06,-0.59l-0.7,-1.04l0.06,-1.8l1.0,0.84l1.64,0.47l0.26,0.63l0.52,0.07l1.35,-0.72l0.2,-0.69l-0.26,-0.64l-1.58,-1.11l-2.4,-0.26l-0.91,-0.46l-0.85,-1.67l-0.89,-0.72l0.22,-0.98l-0.48,-0.28l-0.53,0.15l-1.38,-2.51l-0.44,-0.3l-0.64,0.07l-0.44,-0.61l0.22,-0.89l-0.7,-0.65l-1.21,-0.6l-1.06,-0.08l-0.75,-0.54l-0.57,0.18l-2.8,-0.59l-0.5,0.64l0.25,-0.91l-0.46,-0.42l-0.87,0.12l-0.26,-0.72l-0.88,-0.65l-0.61,-1.41l-0.55,-0.11l-0.73,-2.95l-0.77,-0.98l-0.16,-1.52l-0.44,-0.83l-0.71,-0.89l-0.49,-0.15l-0.12,0.93l-1.29,-0.26l1.07,-1.3l0.18,-1.37l0.86,-1.46l0.65,-0.34l0.28,-0.83l-0.61,-0.38l-1.42,0.93l-1.03,1.67l-0.28,1.79l-1.37,0.35l-0.2,-1.33l-0.79,-1.33l-0.27,-4.04l-0.86,-0.6l1.63,-1.33l0.22,-0.97l-0.58,-0.42l-3.05,1.92l-0.75,-0.66l-0.4,0.26l-1.27,-0.89l-0.37,0.74l1.13,1.09l0.52,0.1l1.26,2.0l-1.04,0.24l-1.43,-0.38l-0.84,-1.6l-1.13,-0.6l-1.94,-2.54l-1.04,-2.28l-1.28,-0.87l0.1,-0.87l-0.97,-1.8l-1.77,-0.98l0.09,-0.67l0.99,-0.41l-0.35,-0.49l0.44,-0.73l-0.39,-0.35l0.4,-1.21l2.47,-4.47l-1.05,-2.41l-0.68,-0.46l-0.92,0.42l-0.28,0.93l0.29,1.19l-0.24,0.03l-0.73,-2.44l-0.99,-0.28l-1.18,-0.87l-1.52,-0.31l0.29,1.94l-0.48,0.61l0.27,0.59l2.21,0.56l0.24,0.97l-0.37,2.46l-0.31,-0.58l-0.8,-0.21l-2.13,-1.53l-0.41,0.2l-0.29,-0.62l0.59,-2.11l0.07,-2.97l-0.66,-1.97l0.42,-0.51l0.48,-1.91l-0.24,-0.54l0.66,-3.04l-0.37,-5.41l-0.69,-1.56l0.35,-0.47l-0.47,-2.18l-2.1,-1.33l-0.05,-0.53l-0.55,-0.43l-0.1,-1.01l-0.92,-0.73l-0.55,-1.51l-0.64,-0.25l-1.44,0.32l-1.02,-0.2l-1.57,0.54l-1.15,-1.74l-1.5,-0.47l-0.19,-0.6l-1.35,-1.51l-3.81,-1.88l-0.51,-2.75l-3.06,-1.14l-0.65,-0.59l-0.52,-1.23l-2.15,-1.93l-2.19,-1.09l-1.45,-0.12l-3.44,-1.68l-2.85,0.98l-1.01,-0.4l-1.04,0.42l-0.36,0.68l-1.33,0.68l-0.5,0.71l0.03,0.64l-0.73,-0.22l-0.59,0.6l0.67,0.94l1.51,0.08l0.41,0.21l-3.03,0.23l-1.58,1.51l-0.91,0.45l-1.3,1.56l-1.56,1.03l-0.32,0.13l0.2,-0.48l-0.26,-0.54l-0.67,-0.04l-2.07,2.24l-2.2,0.23l-2.11,1.06l-0.78,0.03l-0.27,-2.03l-1.71,-2.23l-2.21,-1.0l-0.18,-0.41l-2.51,-1.5l2.8,1.33l1.21,-0.74l-0.0,-0.74l-1.32,-0.34l-0.35,0.55l-0.21,-1.01l-0.34,-0.1l0.12,-0.52l-0.49,-0.33l-1.4,0.61l-2.3,-0.76l0.65,-1.08l0.83,-0.1l1.03,-1.45l-0.91,-0.96l-0.46,0.13l-0.49,1.02l-0.44,-0.04l-0.81,0.56l-0.72,-0.9l-0.7,0.09l-0.17,0.38l-1.34,0.73l-0.14,0.68l0.28,0.46l-3.95,-1.35l-5.05,-0.71l0.11,-0.24l1.27,0.29l0.61,-0.53l2.1,0.39l0.23,-0.78l-0.94,-1.02l0.09,-0.69l-0.62,-0.29l-0.5,0.32l-0.28,-0.47l-1.9,0.19l-2.25,1.1l0.3,-0.64l-0.41,-0.58l-0.96,0.35l-0.58,-0.25l-0.23,0.44l0.2,0.71l-1.45,0.79l-0.4,0.64l-5.17,0.97l0.32,-0.52l-0.4,-0.52l-1.35,-0.28l-0.72,-0.53l0.69,-0.53l0.01,-0.78l-0.68,-0.13l-0.81,-0.66l-0.46,0.11l0.14,0.76l-0.42,1.77l-1.05,-1.39l-0.69,-0.45l-0.55,0.07l-0.3,0.71l0.82,1.77l-0.25,0.79l-1.39,0.99l-0.05,1.04l-0.6,0.22l-0.17,0.57l-1.48,0.55l0.28,-0.66l-0.22,-0.45l1.14,-1.03l0.07,-0.74l-0.4,-0.58l-1.18,-0.24l-0.42,-0.84l0.3,-1.7l-0.18,-1.61l-2.17,-1.12l-2.39,-2.46l0.32,-1.44l-0.15,-1.04ZM644.36,434.04l-0.94,0.26l0.4,-0.44l0.53,0.18ZM665.13,435.61l0.98,-0.28l0.35,0.31l0.08,0.72l-1.42,-0.75ZM770.53,454.92l0.42,0.56l-0.43,0.75l0.0,-1.31Z",name:"Florida"},"US-CT":{path:"M823.41,156.51l2.83,-3.23l-0.07,-0.54l-1.31,-1.25l-3.5,-15.89l9.81,-2.41l0.6,0.46l0.65,-0.26l0.23,-0.58l14.16,-4.0l3.2,10.18l0.47,1.96l-0.04,1.69l-1.66,0.32l-0.92,0.81l-0.69,-0.36l-0.5,0.1l-0.18,0.91l-1.14,0.07l-1.27,1.27l-0.62,-0.14l-0.56,-1.02l-0.89,-0.09l-0.21,0.67l0.75,0.64l0.08,0.54l-0.89,-0.02l-1.02,0.87l-1.65,0.07l-1.15,0.94l-1.44,0.13l-1.21,0.93l-0.65,-1.0l-0.61,0.11l-1.01,2.46l-1.06,0.61l-0.25,1.02l-0.77,-0.26l-0.96,0.56l-0.09,0.85l-1.72,0.98l-1.94,2.27l-1.19,0.46l-0.24,0.38l-1.4,-1.23Z",name:"Connecticut"},"US-WA":{path:"M38.51,55.06l0.37,-1.08l0.93,0.65l0.55,-0.14l0.54,-0.65l0.49,0.67l0.71,-0.01l0.17,-0.77l-0.98,-1.47l0.85,-0.83l-0.09,-1.36l0.49,-0.39l-0.1,-1.03l0.81,-0.27l0.05,0.5l0.48,0.41l0.95,-0.31l-0.09,-0.68l-1.44,-1.82l-1.84,-0.1l-0.15,0.32l-0.78,-0.82l0.26,-1.62l0.66,0.53l0.52,-0.07l0.29,-0.56l-0.17,-0.68l3.33,-0.52l0.25,-0.68l-2.59,-1.29l-0.05,-0.79l-0.67,-0.57l-1.3,-0.31l0.37,-4.73l-0.5,-1.29l0.25,-0.72l-0.52,-0.48l0.55,-3.93l0.04,-4.38l-0.56,-1.02l-0.04,-0.98l-1.56,-2.34l0.33,-4.24l-0.21,-1.29l0.78,-0.79l0.04,-0.71l0.97,-1.44l-0.6,-1.43l1.04,0.8l0.44,0.0l3.35,3.31l0.99,0.35l2.18,2.41l3.73,1.49l1.21,0.07l0.79,0.71l0.67,0.31l0.6,-0.15l1.57,1.07l1.49,0.47l1.28,0.28l1.22,-0.61l0.53,0.31l0.46,0.71l-0.05,1.24l0.55,0.74l0.8,-0.24l0.07,-0.75l0.44,0.03l0.63,1.39l-0.4,0.58l0.34,0.49l0.56,-0.04l0.73,-0.84l-0.38,-1.7l1.03,-0.24l-0.44,0.23l-0.22,0.69l1.27,4.41l-0.46,0.1l-1.67,1.72l0.22,-1.29l-0.22,-0.41l-1.31,0.31l-0.38,0.81l0.09,0.95l-1.37,1.7l-1.98,1.38l-1.06,1.41l-0.96,0.69l-1.1,1.67l-0.06,0.71l0.62,0.6l0.96,0.12l2.77,-0.48l1.22,-0.58l-0.03,-0.7l-0.64,-0.23l-2.94,0.79l-0.35,-0.3l3.23,-3.42l3.06,-0.88l0.89,-1.51l1.73,-1.54l0.53,0.57l0.54,-0.19l0.22,-1.81l-0.06,2.25l0.26,0.91l-0.98,-0.21l-0.64,0.77l-0.41,-0.73l-0.53,-0.19l-0.39,0.64l0.32,2.34l-0.21,-1.07l-0.67,-0.21l-0.46,0.69l-0.07,0.75l0.46,0.66l-0.63,0.58l-0.0,0.45l0.42,0.17l1.67,-0.57l0.25,1.09l-1.08,1.79l-0.08,1.05l-0.83,0.7l0.13,1.0l-0.85,-0.68l1.12,-1.44l-0.23,-0.96l-1.96,1.08l-0.38,0.64l-0.05,-2.11l-0.52,0.02l-1.03,1.59l-1.26,0.53l-1.14,1.87l-1.51,0.3l-0.46,0.44l-0.21,1.18l1.11,-0.03l-0.25,0.36l0.27,0.37l0.93,0.02l0.06,0.68l0.53,0.47l0.52,-0.27l0.35,-1.76l0.15,0.42l0.83,-0.15l1.11,1.48l1.31,-0.61l1.64,-1.48l0.98,-1.56l0.63,0.78l0.73,0.14l0.44,-0.23l-0.06,-0.86l1.56,-0.55l0.35,-0.94l-0.33,-1.26l0.22,-1.19l-0.18,-1.35l0.83,0.2l0.3,-0.92l-0.19,-0.75l-0.72,-0.63l0.89,-1.13l0.07,-1.75l1.24,-1.24l0.61,-1.37l1.61,-0.49l0.78,-1.15l-0.45,-0.66l-0.51,-0.02l-0.86,-1.3l0.16,-2.09l-0.26,-0.87l0.49,-0.79l0.06,-0.84l-1.15,-1.73l-0.63,-0.4l-0.17,-0.64l0.18,-0.5l0.59,0.24l0.53,-0.33l0.24,-1.8l0.79,-0.24l0.3,-1.0l-0.61,-2.32l0.44,-0.53l-0.03,-0.86l-0.96,-0.88l-0.95,0.3l-1.09,-2.65l0.93,-1.82l41.31,9.4l38.95,7.65l-10.13,55.39l1.04,3.0l0.13,2.0l-1.0,1.3l0.73,1.88l-31.18,-5.92l-1.67,0.79l-7.24,-1.02l-1.68,0.92l-4.19,-0.12l-3.18,0.45l-1.64,0.75l-0.88,-0.26l-1.2,0.3l-1.51,-0.23l-2.43,-0.94l-0.91,0.46l-3.45,0.51l-2.11,-0.71l-1.65,0.3l-0.31,-1.36l-1.09,-0.88l-4.34,-1.46l-2.32,-0.11l-1.15,-0.51l-1.27,0.21l-1.89,0.86l-4.49,0.58l-2.26,-1.01l-1.61,-1.15l-1.84,-0.51l-0.63,-0.81l0.64,-6.82l-0.46,-0.95l-0.22,-1.9l-0.98,-1.35l-1.96,-1.67l-1.59,-0.23l-1.31,0.28l-1.95,-3.24l-2.07,-0.23l-0.56,-0.3l-0.1,-0.52l-0.55,-0.47l-1.22,0.28l-0.81,-0.15l-1.0,0.52l-1.03,-1.77l-0.93,-0.23ZM61.97,39.77l0.16,0.74l-0.42,0.48l0.0,-0.91l0.26,-0.31ZM71.38,20.37l-0.61,0.87l-0.15,0.52l0.18,-1.38l0.58,-0.01ZM71.25,15.62l-0.09,-0.05l0.05,-0.04l0.04,0.1ZM70.48,15.47l-0.77,0.39l0.37,-0.68l-0.07,-0.6l0.22,-0.07l0.25,0.97ZM57.68,42.43l0.04,-0.02l-0.01,0.0l-0.03,0.01Z",name:"Washington"},"US-KS":{path:"M477.93,239.62l0.44,0.63l0.76,0.18l1.04,0.8l2.19,-1.08l-0.0,0.75l1.08,0.79l0.23,1.44l-0.95,-0.15l-0.6,0.31l-0.17,0.97l-1.14,1.37l-0.06,1.14l-0.79,0.5l0.04,0.64l1.56,2.1l2.0,1.49l0.2,1.13l0.42,0.86l0.74,0.56l0.32,1.11l1.89,0.91l1.54,0.26l2.67,46.81l-31.54,1.48l-31.97,0.88l-31.98,0.26l-32.04,-0.37l1.21,-65.46l27.89,0.35l27.85,-0.14l27.84,-0.64l27.67,-1.12l1.65,1.23Z",name:"Kansas"},"US-WI":{path:"M510.09,124.06l0.41,-0.27l0.28,-0.9l-0.45,-1.48l0.04,-1.91l0.7,-1.16l0.53,-2.25l-1.61,-2.91l-0.83,-0.36l-1.28,-0.01l-0.21,-2.31l1.67,-2.26l-0.05,-0.77l0.77,-1.55l1.95,-1.09l0.48,-0.75l0.97,-0.25l0.45,-0.75l1.16,-0.14l1.04,-1.56l-0.97,-12.11l1.03,-0.35l0.22,-1.1l0.73,-0.97l0.78,0.7l1.68,0.64l2.61,-0.56l3.27,-1.57l2.65,-0.82l2.22,-2.12l0.31,0.29l1.39,-0.11l1.25,-1.48l0.79,-0.58l1.04,-0.1l0.4,-0.52l1.07,0.99l-0.48,1.68l-0.67,1.01l0.23,1.61l-1.21,2.21l0.64,0.66l2.5,-1.09l0.72,-0.87l2.15,1.22l2.34,0.47l0.44,0.53l0.86,-0.13l1.6,0.7l2.23,3.54l15.47,2.52l4.65,1.96l1.67,-0.16l1.63,0.42l1.33,-0.59l3.17,0.71l2.18,0.09l0.85,0.41l0.56,0.89l-0.42,1.09l0.41,0.77l3.4,0.63l1.4,1.13l-0.16,0.71l0.59,1.11l-0.36,0.81l0.43,1.25l-0.78,1.25l-0.03,1.76l0.91,0.63l1.38,-0.26l1.02,-0.72l0.2,0.26l-0.79,2.44l0.04,1.31l1.32,1.46l0.84,0.35l-0.24,2.02l-2.42,1.2l-0.51,0.78l0.04,1.26l-1.61,3.49l-0.4,3.5l1.11,0.83l0.91,-0.04l0.5,-0.37l0.49,-1.37l1.82,-1.47l0.66,-2.54l1.06,-1.7l0.59,0.18l0.58,-0.71l0.87,-0.4l1.12,1.12l0.59,0.2l-0.28,2.18l-1.19,2.85l-0.57,5.58l0.23,1.11l0.8,0.93l0.07,0.52l-0.51,0.98l-1.3,1.34l-0.86,3.88l0.15,2.57l0.72,1.2l0.06,1.24l-1.07,3.23l0.12,2.11l-0.73,2.11l-0.28,2.46l0.59,2.02l-0.04,1.32l0.49,0.53l-0.21,1.7l0.92,0.78l0.54,2.44l1.2,1.54l0.08,1.69l-0.33,1.45l0.48,2.95l-44.2,4.6l-0.19,-0.79l-1.56,-2.19l-4.94,-0.84l-1.06,-1.35l-0.36,-1.68l-0.9,-1.21l-0.86,-4.89l1.04,-2.61l-0.09,-0.99l-0.71,-0.79l-1.44,-0.48l-0.71,-1.76l-0.47,-6.02l-0.7,-1.4l-0.52,-2.56l-1.15,-0.6l-1.1,-1.56l-0.93,-0.11l-1.17,-0.75l-1.71,0.09l-2.67,-1.79l-2.3,-3.5l-2.64,-2.1l-2.94,-0.53l-0.73,-1.24l-1.12,-1.0l-3.12,-0.45l-3.53,-2.74l0.45,-1.24l-0.12,-1.61l0.25,-0.81l-0.88,-3.11Z",name:"Wisconsin"},"US-OR":{path:"M10.81,140.09l0.63,-3.94l1.32,-2.52l0.23,-1.22l-0.01,-1.26l-0.46,-0.66l-0.14,-1.12l-0.42,-0.32l-0.11,-1.85l2.73,-3.63l2.2,-4.73l0.1,-1.09l0.42,-0.27l0.01,0.79l0.73,0.1l0.42,-1.11l0.88,-0.84l0.23,0.94l1.39,0.27l-0.51,-2.64l-0.92,0.08l2.09,-3.81l1.11,-0.76l0.8,0.4l0.55,-0.33l-0.66,-1.35l-0.6,-0.3l1.71,-4.39l0.41,-0.38l0.04,-0.96l1.74,-5.49l0.97,-1.98l0.4,0.33l0.67,-0.29l-0.12,-0.97l-0.56,-0.32l0.96,-2.74l0.81,0.17l0.23,-0.45l-0.16,-0.52l-0.52,-0.28l0.54,-2.86l1.58,-2.7l0.83,-3.02l1.14,-1.76l0.97,-3.1l-0.08,-1.04l1.21,-1.1l0.04,-0.6l-0.46,-0.65l0.14,-0.52l0.51,0.64l0.45,0.05l0.39,-0.63l0.17,-1.39l-0.74,-0.72l0.5,-1.2l1.28,-0.78l0.05,-0.46l-0.86,-0.5l-0.26,-1.11l0.86,-2.17l-0.06,-1.44l0.92,-0.59l0.4,-0.85l0.07,-3.75l0.49,0.86l0.9,0.41l-0.04,0.91l0.55,0.53l0.43,-0.82l0.39,-0.14l-0.27,-0.98l1.12,0.84l1.53,0.0l1.45,-0.68l1.44,2.36l1.99,0.78l1.39,-0.67l0.91,0.06l1.72,1.51l0.77,1.04l0.21,1.9l0.43,0.78l-0.03,2.05l-0.39,1.24l0.19,0.93l-0.43,1.74l0.26,1.45l0.79,0.85l1.94,0.56l1.44,1.05l2.4,1.1l4.98,-0.53l2.9,-1.06l1.14,0.51l2.23,0.09l4.24,1.43l0.69,0.54l0.19,1.15l0.57,0.58l1.86,-0.27l2.11,0.71l3.79,-0.55l0.69,-0.42l2.19,0.93l1.64,0.24l1.19,-0.3l0.88,0.26l1.89,-0.78l3.07,-0.43l4.16,0.13l1.61,-0.91l7.16,1.02l0.96,-0.19l0.79,-0.58l31.27,5.93l0.23,1.81l0.93,1.82l1.16,0.63l1.96,1.86l0.57,2.45l-0.16,1.0l-3.69,4.54l-0.4,1.41l-1.39,2.63l-2.21,2.42l-0.65,2.68l-1.49,1.84l-2.23,1.5l-1.92,3.35l-1.49,1.27l-0.62,2.02l-0.12,1.87l0.28,0.92l0.56,0.61l0.54,0.04l0.39,-0.35l0.63,0.76l0.89,-0.05l0.07,0.88l0.8,0.95l-0.46,1.0l-0.65,0.06l-0.33,0.4l0.21,1.8l-1.03,2.56l-1.22,1.41l-6.86,39.15l-26.21,-4.99l-28.89,-6.05l-28.8,-6.61l-28.87,-7.22l-1.54,-2.51l0.26,-2.47l-0.29,-0.87Z",name:"Oregon"},"US-KY":{path:"M583.03,306.53l0.35,-2.18l1.13,0.96l0.72,0.2l0.75,-0.36l0.46,-0.88l0.87,-3.55l-0.54,-1.75l0.38,-0.86l-0.1,-1.87l-1.27,-2.04l1.79,-3.21l1.24,-0.51l0.73,0.06l7.03,2.56l0.81,-0.2l0.65,-0.72l0.24,-1.93l-1.48,-2.14l-0.24,-1.44l0.2,-0.87l0.4,-0.52l1.1,-0.18l1.24,-0.83l3.0,-0.95l0.64,-0.51l0.15,-1.13l-1.53,-2.05l-0.08,-0.68l1.33,-1.97l0.14,-1.16l1.25,0.42l1.12,-1.33l-0.68,-2.0l1.92,0.9l1.72,-0.84l0.03,1.18l1.0,0.46l0.99,-0.94l0.02,-1.36l0.51,0.16l1.9,-0.96l4.41,1.52l0.64,0.94l0.86,0.18l0.59,-0.59l0.73,-2.53l1.38,-0.55l1.39,-1.34l0.86,1.29l0.77,0.42l1.16,-0.13l0.11,0.75l0.95,0.19l0.67,-0.62l0.03,-1.0l0.84,-0.38l0.26,-0.48l-0.25,-2.09l0.84,-0.4l0.34,-0.56l-0.06,-0.69l1.25,-0.56l0.34,-0.72l0.38,1.47l0.61,0.6l1.46,0.64l1.25,-0.0l1.11,0.81l0.53,-0.11l0.26,-0.55l1.1,-0.46l0.53,-0.69l0.04,-3.47l0.85,-2.18l1.02,0.18l1.55,-1.19l0.75,-3.46l1.04,-0.37l1.65,-2.23l0.0,-0.81l-1.18,-2.88l2.78,-0.59l1.54,0.81l3.85,-2.82l2.23,-0.46l-0.18,-1.07l0.36,-1.47l-0.32,-0.36l-1.22,-0.04l0.58,-1.39l-1.09,-1.54l1.65,-1.83l1.81,1.18l0.92,-0.11l1.93,-1.01l0.78,0.88l1.75,0.54l0.57,1.28l0.94,0.92l0.79,1.84l2.6,0.67l1.87,-0.57l1.63,0.27l2.18,1.85l0.96,0.43l1.28,-0.18l0.61,-1.31l0.99,-0.54l1.35,0.5l1.34,0.04l1.33,1.09l1.26,-0.69l1.41,-0.15l1.81,-2.55l1.72,-1.03l0.92,2.35l0.7,0.83l2.45,0.81l1.35,0.97l0.75,1.05l0.93,3.35l-0.37,0.45l0.09,0.72l-0.44,0.61l0.02,0.53l2.24,2.62l1.35,0.92l-0.08,0.89l1.34,0.97l0.58,1.35l1.55,1.2l0.98,1.62l2.14,0.84l1.09,1.12l2.14,0.25l-4.86,6.13l-5.06,4.15l-0.42,0.86l0.22,1.25l-2.07,1.93l0.04,1.64l-3.06,1.63l-0.8,2.38l-1.71,0.6l-2.7,1.83l-1.66,0.48l-3.39,2.42l-23.95,3.09l-8.8,1.42l-7.47,0.86l-7.68,0.46l-22.71,3.52l-0.64,-0.56l-3.63,0.09l-0.41,0.6l1.03,3.57l-22.99,2.73Z",name:"Kentucky"},"US-ME":{path:"M837.01,56.27l0.87,-1.15l1.42,1.7l0.84,0.04l0.39,-2.12l-0.46,-2.19l1.7,0.36l0.73,-0.42l0.21,-0.52l-0.32,-0.7l-1.18,-0.47l-0.44,-0.62l0.19,-1.42l0.86,-2.02l2.08,-2.25l0.01,-0.98l-0.52,-0.93l1.02,-1.64l0.39,-1.51l-0.22,-0.92l-1.02,-0.35l-0.07,-1.42l-0.4,-0.43l0.55,-0.96l-0.04,-0.63l-1.0,-1.26l0.13,-1.73l0.37,-0.63l-0.15,-0.97l1.22,-1.93l-0.96,-6.17l5.58,-18.87l2.25,-0.23l1.14,3.18l0.55,0.43l2.54,0.56l1.83,-1.73l1.68,-0.83l1.24,-1.72l1.25,-0.12l0.64,-0.47l0.25,-1.43l0.42,-0.3l1.36,0.04l3.68,1.41l1.14,0.96l2.36,1.05l8.38,22.7l0.64,0.65l-0.19,1.26l0.64,0.86l-0.1,1.52l-0.33,0.05l-0.24,0.66l1.72,1.13l1.79,0.22l0.82,0.41l1.88,-0.19l1.25,-0.64l0.34,0.86l-0.59,1.43l1.69,1.86l0.28,2.69l2.72,1.68l0.98,-0.1l0.47,-0.74l-0.06,-0.5l0.36,0.08l0.25,0.49l0.64,0.07l1.41,1.11l0.27,0.75l1.27,0.94l0.04,0.47l-0.52,-0.14l-0.39,0.41l0.18,0.77l-0.76,-0.15l-0.35,0.4l0.16,0.63l0.81,0.53l0.55,0.92l0.48,0.17l0.16,-0.88l0.39,-0.17l0.8,0.32l0.25,-0.83l0.34,0.41l-0.31,0.85l-0.53,0.19l-1.21,3.24l-0.63,-0.04l-0.31,0.44l-0.55,-1.05l-0.72,0.03l-0.3,0.5l-0.56,0.06l-0.02,0.49l0.58,0.85l-0.9,-0.45l-0.33,0.63l0.26,0.52l-1.2,-0.28l-0.36,0.3l-0.37,0.78l0.07,0.45l0.44,0.08l0.07,1.21l-0.37,-0.57l-0.55,-0.06l-0.39,0.45l-0.2,1.09l-0.48,-1.53l-1.14,0.01l-0.68,0.75l-0.36,1.48l0.59,0.63l-0.83,0.63l-0.69,-0.46l-0.73,1.04l0.1,0.64l0.99,0.63l-0.35,0.21l-0.1,0.82l-0.46,-0.21l-0.85,-1.82l-1.03,-0.46l-0.39,0.22l-0.45,-0.41l-0.57,0.63l-1.24,-0.19l-0.26,0.85l0.78,0.4l0.01,0.37l-0.51,-0.05l-0.56,0.4l-0.09,0.7l-0.49,-1.02l-1.17,-0.02l-0.16,0.64l0.52,0.88l-1.44,0.96l0.84,1.11l0.08,1.06l0.53,0.65l-0.97,-0.41l-0.96,0.22l-1.2,-0.42l-0.17,-0.91l0.74,-0.28l-0.08,-0.56l-0.42,-0.49l-0.67,-0.12l-0.3,0.33l-0.23,-2.37l-0.37,-0.22l-1.1,0.27l0.04,1.96l-1.85,1.92l0.02,0.49l1.25,1.47l-0.64,0.96l-0.19,3.87l0.77,1.41l-1.08,1.72l-0.8,-0.19l-0.45,0.93l-0.62,-0.06l-0.41,-1.15l-0.73,-0.21l-0.52,1.03l0.11,0.69l-0.45,0.59l0.12,2.41l-0.95,-1.01l0.14,-1.28l-0.24,-0.59l-0.82,0.29l-0.08,2.01l-0.44,-0.25l0.15,-1.54l-0.47,-0.4l-0.68,0.49l-0.76,3.04l-0.77,-1.97l0.17,-1.21l-0.4,-0.27l-0.46,0.21l-1.05,2.59l0.35,0.53l0.85,-0.15l0.95,2.08l-0.28,-0.59l-0.51,-0.23l-0.66,0.3l-0.07,0.64l-1.38,-0.1l-2.16,3.17l-0.53,1.86l0.29,0.6l-0.68,0.65l0.51,0.43l0.91,-0.21l0.37,0.92l-0.77,0.3l-0.2,0.39l-0.4,-0.04l-0.51,0.57l-0.14,1.03l0.67,1.37l-0.08,0.68l-0.79,1.29l-0.94,0.61l-0.54,1.29l0.44,1.56l-0.4,2.81l-0.8,-0.33l-0.42,0.59l-1.02,-0.76l-0.57,-1.85l-0.93,-0.37l-2.36,-1.99l-0.76,-3.45l-13.24,-35.53ZM863.91,81.24l0.08,0.26l-0.08,0.23l0.03,-0.29l-0.04,-0.2ZM865.32,81.46l0.47,0.7l-0.04,0.47l-0.32,-0.25l-0.1,-0.93ZM867.66,78.32l0.42,0.82l-0.16,0.14l-0.42,-0.19l0.16,-0.77ZM877.03,64.89l-0.14,0.2l-0.03,-0.24l0.17,0.04ZM873.08,75.23l0.01,0.02l-0.03,0.03l0.01,-0.06Z",name:"Maine"},"US-OH":{path:"M665.07,178.88l1.66,0.36l0.97,-0.31l1.75,1.07l2.07,0.26l1.47,1.17l1.7,0.24l-2.17,1.18l-0.12,0.47l0.42,0.24l2.45,0.19l1.39,-1.1l1.76,-0.25l3.39,0.96l0.92,-0.08l1.48,-1.3l1.73,-0.59l1.15,-0.97l1.91,-0.97l2.61,-0.03l1.09,-0.62l1.24,-0.06l1.07,-0.8l4.24,-5.46l4.53,-3.47l6.92,-4.36l5.83,28.04l-0.51,0.54l-1.28,0.43l-0.41,0.95l1.65,2.23l0.02,2.11l0.41,0.26l0.31,0.94l-0.04,0.76l-0.54,0.83l-0.5,4.08l0.18,3.21l-0.58,0.41l0.34,1.11l-0.35,1.74l-0.39,0.54l0.76,1.23l-0.25,1.87l-2.41,2.65l-0.82,1.86l-1.37,1.5l-1.24,0.67l-0.6,0.7l-0.87,-0.92l-1.18,0.14l-1.32,1.74l-0.09,1.32l-1.78,0.85l-0.78,2.25l0.28,1.58l-0.94,0.85l0.3,0.67l0.63,0.41l0.27,1.3l-0.8,0.17l-0.5,1.6l0.06,-0.93l-0.91,-1.26l-1.53,-0.55l-1.07,0.71l-0.82,1.98l-0.34,2.69l-0.53,0.82l1.22,3.58l-1.27,0.39l-0.28,0.42l-0.25,3.12l-2.66,1.2l-1.0,0.05l-0.76,-1.06l-1.51,-1.1l-2.34,-0.73l-1.16,-1.92l-0.31,-1.14l-0.42,-0.33l-0.73,0.13l-1.84,1.17l-1.1,1.28l-0.4,1.05l-1.43,0.15l-0.87,0.61l-1.11,-1.0l-3.14,-0.59l-1.37,0.72l-0.53,1.25l-0.71,0.05l-3.04,-2.26l-1.93,-0.29l-1.77,0.56l-2.14,-0.52l-0.55,-1.54l-0.96,-0.97l-0.63,-1.38l-2.03,-0.76l-1.14,-1.01l-0.97,0.26l-1.31,0.89l-0.46,0.03l-1.79,-1.23l-0.61,0.2l-0.6,0.7l-8.67,-55.57l20.65,-4.25ZM675.61,181.3l0.53,-0.79l0.67,0.41l-0.48,0.35l-0.72,0.03Z",name:"Ohio"},"US-OK":{path:"M399.11,359.23l-0.05,-42.02l-0.39,-0.4l-51.81,-0.82l0.31,-10.23l36.69,0.74l35.99,-0.07l35.98,-0.86l35.56,-1.62l0.6,10.68l4.55,24.34l1.41,37.87l-1.2,-0.22l-0.29,-0.36l-2.13,-0.21l-0.82,-0.79l-2.11,-0.39l-1.77,-2.05l-1.23,-0.22l-2.25,-1.56l-1.5,-0.4l-0.8,0.46l-0.23,0.88l-0.82,0.24l-0.46,0.62l-2.47,-0.14l-1.79,-1.48l-2.3,1.29l-1.16,0.2l-0.19,0.56l-0.63,0.28l-2.12,-0.77l-1.7,1.18l-2.06,0.51l-0.83,1.37l-1.48,0.06l-0.57,1.25l-1.26,-1.55l-1.7,-0.1l-0.32,-0.58l-1.21,-0.46l-0.02,-0.96l-0.44,-0.5l-1.24,-0.18l-0.73,1.38l-0.66,0.11l-0.84,-0.5l-0.97,0.07l-0.71,-1.51l-1.09,-0.35l-1.17,0.57l-0.45,1.7l-0.7,-0.08l-0.49,0.43l0.29,0.73l-0.51,1.68l-0.43,0.19l-0.86,-1.45l0.39,-1.65l-0.75,-0.86l-0.8,0.18l-0.49,0.76l-0.84,-0.18l-0.92,0.98l-1.07,0.13l-0.53,-1.36l-1.99,-0.19l-0.3,-1.48l-1.19,-0.53l-0.82,0.33l-2.12,2.15l-1.21,0.51l-0.97,-0.38l0.19,-1.25l-0.28,-1.13l-2.33,-0.67l-0.07,-2.18l-0.43,-0.55l-2.11,0.39l-2.52,-0.25l-0.64,0.26l-0.81,1.21l-0.95,0.06l-1.76,-1.77l-0.97,-0.12l-1.5,0.56l-2.68,-0.63l-1.86,-1.0l-1.05,0.25l-2.46,-0.3l-0.17,-2.12l-0.85,-0.87l-0.43,-1.02l-1.16,-0.41l-0.7,-0.83l-0.83,0.08l-0.44,1.64l-2.22,-0.68l-1.07,0.6l-0.96,-0.09l-3.79,-3.78l-1.12,-0.43l-0.8,0.08Z",name:"Oklahoma"},"US-ID":{path:"M132.48,121.36l-0.34,-0.44l0.08,-1.99l0.53,-1.74l1.42,-1.22l2.11,-3.59l1.68,-0.92l1.39,-1.52l1.08,-2.15l0.05,-1.22l2.21,-2.41l1.43,-2.7l0.37,-1.37l2.04,-2.26l1.89,-2.81l0.03,-1.01l-0.79,-2.95l-2.13,-1.94l-0.87,-0.36l-0.85,-1.61l-0.41,-3.02l-0.59,-1.19l0.94,-1.19l-0.12,-2.35l-1.04,-2.69l10.12,-55.42l13.39,2.35l-3.54,20.71l1.29,2.89l1.0,1.27l0.27,1.55l1.17,1.76l-0.12,0.83l0.39,1.14l-0.99,0.95l0.83,1.76l-0.83,0.11l-0.28,0.71l1.93,1.68l1.03,2.04l2.24,1.22l0.54,1.58l1.09,1.33l1.49,2.79l0.08,0.68l1.64,1.81l0.01,1.88l1.79,1.71l-0.07,1.35l0.74,0.19l0.9,-0.58l0.36,0.46l-0.36,0.55l0.07,0.54l1.11,0.96l1.61,0.15l1.81,-0.36l-0.63,2.61l-0.99,0.54l0.25,1.14l-1.83,3.73l0.06,1.72l-0.81,0.07l-0.37,0.54l0.6,1.33l-0.62,0.9l-0.03,1.16l0.96,0.93l-0.37,0.81l0.28,1.01l-1.57,0.43l-1.21,1.41l0.1,1.11l0.46,0.77l-0.13,0.73l-0.83,0.77l-0.2,1.52l1.48,0.63l1.38,1.79l0.78,0.27l1.08,-0.35l0.56,-0.8l1.85,-0.41l1.21,-1.28l0.81,-0.29l0.15,-0.76l0.78,0.81l0.23,0.71l1.05,0.64l-0.42,1.23l0.73,0.95l-0.34,1.38l0.57,1.34l-0.21,1.61l1.54,2.64l0.31,1.73l0.82,0.37l0.67,2.08l-0.18,0.98l-0.76,0.64l0.51,1.89l1.24,1.16l0.3,0.79l0.81,0.08l0.86,-0.37l1.04,0.93l1.06,2.79l-0.5,0.81l0.89,1.83l-0.28,0.6l0.11,0.98l2.29,2.41l0.97,-0.14l-0.01,-1.14l1.07,-0.89l0.93,-0.22l4.53,1.62l0.69,-0.32l0.67,-1.35l1.19,-0.39l2.25,0.93l3.3,-0.1l0.96,0.88l2.29,-0.58l3.23,0.78l0.45,-0.49l-0.67,-0.76l0.26,-1.06l0.74,-0.48l-0.07,-0.96l1.23,-0.51l0.48,0.37l1.07,2.11l0.12,1.11l1.36,1.95l0.73,0.45l-6.27,53.85l-47.47,-6.31l-46.96,-7.72l6.88,-39.16l1.12,-1.18l1.07,-2.67l-0.21,-1.74l0.74,-0.15l0.77,-1.62l-0.9,-1.27l-0.18,-1.2l-1.24,-0.08l-0.64,-0.81l-0.88,0.29Z",name:"Idaho"},"US-WY":{path:"M218.62,206.98l10.1,-86.59l25.45,2.74l26.79,2.4l26.83,1.91l27.84,1.46l-3.67,87.1l-27.31,-1.41l-28.2,-1.97l-29.69,-2.63l-28.14,-3.02Z",name:"Wyoming"},"US-UT":{path:"M220.28,185.78l-2.51,21.5l0.35,0.45l32.23,3.42l-8.32,87.13l-42.53,-4.67l-42.4,-5.77l16.08,-108.32l47.1,6.26Z",name:"Utah"},"US-IN":{path:"M600.87,189.59l1.42,0.87l2.1,0.15l1.52,-0.38l2.63,-1.39l2.73,-2.1l32.14,-4.8l8.96,57.41l-0.66,1.15l0.3,0.92l0.81,0.79l-0.66,1.14l0.49,0.8l1.12,0.04l-0.36,1.14l0.18,0.51l-1.81,0.29l-3.18,2.55l-0.43,0.17l-1.4,-0.81l-3.46,0.91l-0.09,0.78l1.19,3.1l-1.4,1.88l-1.18,0.49l-0.45,0.89l-0.31,2.6l-1.11,0.88l-1.06,-0.24l-0.47,0.47l-0.85,1.95l0.05,3.13l-0.39,1.0l-1.38,0.85l-0.93,-0.68l-1.24,0.01l-1.47,-0.69l-0.62,-1.84l-1.89,-0.73l-0.44,0.3l-0.04,0.5l0.83,0.68l-0.62,0.31l-0.89,-0.35l-0.36,0.29l0.5,1.42l-1.08,0.68l0.14,2.37l-1.06,0.65l-0.0,0.83l-0.16,0.37l-0.25,-1.01l-1.6,0.18l-1.4,-1.69l-0.5,-0.08l-1.67,1.5l-1.57,0.69l-1.07,2.89l-0.81,-1.07l-2.79,-0.77l-1.11,-0.61l-1.08,-0.18l-1.76,0.92l-0.64,-1.02l-0.58,-0.18l-0.53,0.56l0.64,1.86l-0.34,0.84l-0.28,0.09l-0.02,-1.18l-0.42,-0.4l-0.58,0.01l-1.46,0.79l-1.41,-0.84l-0.85,0.0l-0.48,0.95l0.71,1.55l-0.49,0.74l-1.15,-0.39l-0.07,-0.54l-0.53,-0.44l0.55,-0.63l-0.35,-3.09l0.96,-0.78l-0.07,-0.58l-0.44,-0.23l0.69,-0.46l0.25,-0.61l-1.17,-1.47l0.46,-1.16l0.32,0.19l1.39,-0.55l0.33,-1.8l0.55,-0.4l0.44,-0.92l-0.06,-0.83l1.52,-1.07l0.06,-0.69l-0.41,-0.93l0.57,-0.86l0.14,-1.29l0.87,-0.51l0.4,-1.91l-1.08,-2.54l0.06,-1.91l-0.93,-0.91l-0.61,-1.5l-1.05,-0.78l-0.04,-0.58l0.92,-1.39l-0.63,-2.25l1.27,-1.31l-6.5,-50.67Z",name:"Indiana"},"US-IL":{path:"M540.1,225.5l0.86,-0.35l0.37,-0.67l-0.23,-2.33l-0.73,-0.93l0.15,-0.41l0.72,-0.69l2.42,-0.98l0.71,-0.65l0.63,-1.68l0.17,-2.11l1.65,-2.47l0.27,-0.94l-0.03,-1.22l-0.59,-1.95l-2.23,-1.88l-0.11,-1.77l0.67,-2.38l0.45,-0.37l4.6,-0.85l0.81,-0.41l0.82,-1.12l2.55,-1.0l1.43,-1.56l0.39,-3.28l1.42,-1.46l0.29,-0.74l0.33,-4.37l-0.76,-2.14l-4.02,-2.47l-0.28,-1.5l-0.48,-0.82l-3.64,-2.48l44.57,-4.64l-0.01,2.65l0.57,2.59l1.38,2.49l1.3,0.95l0.76,2.6l1.26,2.71l1.42,1.85l6.6,51.47l-1.22,1.13l-0.1,0.69l0.67,1.76l-0.84,1.09l-0.03,1.11l1.19,1.09l0.56,1.41l0.89,0.82l-0.1,1.8l1.06,2.31l-0.28,1.49l-0.87,0.56l-0.21,1.47l-0.59,0.93l0.34,1.2l-1.48,1.13l-0.23,0.41l0.28,0.7l-0.93,1.17l-0.31,1.19l-1.64,0.67l-0.63,1.67l0.15,0.8l0.97,0.83l-1.27,1.15l0.42,0.76l-0.49,0.23l-0.13,0.54l0.43,2.94l-1.15,0.19l0.08,0.45l0.91,0.78l-0.48,0.17l-0.03,0.64l0.83,0.29l0.04,0.42l-1.31,1.97l-0.25,1.19l0.59,1.22l0.7,0.64l0.37,1.08l-3.31,1.22l-1.19,0.82l-1.24,0.24l-0.77,1.01l-0.18,2.04l1.7,2.81l0.07,0.54l-0.53,1.19l-0.96,0.03l-6.3,-2.43l-1.08,-0.08l-1.57,0.64l-0.68,0.72l-1.44,2.95l0.06,0.66l-1.18,-1.2l-0.79,0.14l-0.35,0.47l0.59,1.13l-1.24,-0.79l-0.01,-0.68l-1.6,-2.21l-0.4,-1.12l-0.75,-0.37l-0.05,-0.49l0.94,-1.35l0.2,-1.03l-0.32,-1.01l-1.44,-2.02l-0.47,-3.18l-2.26,-0.99l-1.55,-2.14l-1.95,-0.82l-1.72,-1.34l-1.56,-0.14l-1.82,-0.96l-2.32,-1.78l-2.34,-2.44l-0.36,-1.95l2.37,-6.85l-0.25,-2.32l0.98,-2.06l-0.38,-0.84l-2.66,-1.45l-2.59,-0.67l-1.29,0.45l-0.86,1.45l-0.9,0.15l-1.3,-1.9l-0.43,-1.52l0.16,-0.87l-0.54,-0.91l-0.29,-1.65l-0.83,-1.36l-0.94,-0.9l-4.11,-2.52l-1.01,-1.64l-4.53,-3.53l-0.73,-1.9l-1.04,-1.21l-0.04,-1.6l-0.96,-1.48l-0.75,-3.54l0.1,-2.94l0.6,-1.28ZM585.53,295.46l0.05,0.05l0.04,0.04l-0.05,-0.0l-0.04,-0.09Z",name:"Illinois"},"US-AK":{path:"M64.88,530.75l0.06,-0.04l0.04,0.06l-0.06,-0.01l-0.05,-0.0ZM66.64,530.24l1.13,0.16l0.11,0.52l-1.21,0.78l-0.23,-0.24l0.3,-0.47l-0.09,-0.76ZM69.51,530.52l0.7,-0.13l0.3,-0.66l2.1,-0.44l2.68,0.09l1.86,0.74l0.99,0.81l0.04,2.23l0.65,0.89l0.77,-0.37l-0.07,-0.76l0.56,0.36l-0.1,0.53l1.05,1.08l-1.24,-0.51l-0.68,0.56l-0.08,-0.76l-1.26,-0.01l-0.76,-0.43l-0.82,0.28l-1.12,-0.26l-0.44,-0.54l0.4,-0.34l0.95,0.84l0.47,-0.03l0.2,-0.5l-0.7,-1.62l-1.11,-0.6l-1.17,0.32l-0.66,0.82l-1.29,0.37l-0.52,-0.37l-0.59,0.38l-0.74,-0.26l-0.58,0.37l0.21,-2.07ZM81.1,534.87l0.81,-0.72l-0.68,-1.59l0.14,-0.29l1.83,-1.05l3.86,-0.11l2.68,0.81l0.57,-0.32l1.04,0.3l0.88,1.1l0.7,-0.06l0.9,-1.66l2.68,-0.78l1.06,0.33l1.28,-0.46l0.86,0.05l-0.14,0.54l0.5,0.59l1.15,0.33l0.6,-0.91l-0.56,-0.35l-0.31,0.15l0.28,-0.7l-0.2,-0.46l2.24,-2.37l1.05,0.07l0.63,0.82l0.66,-0.29l-0.11,-0.63l-1.04,-0.94l0.19,-0.63l0.96,-0.57l3.31,-0.22l-0.15,-0.63l0.81,-0.73l0.76,-0.04l1.14,-1.23l-0.94,-0.25l-0.69,0.62l-0.61,-0.12l-0.59,0.33l-5.45,-1.21l0.08,-1.16l-0.36,-0.69l0.61,-0.46l0.52,-0.18l0.49,0.51l-0.04,1.27l0.91,-0.05l0.15,-0.75l-0.06,-0.85l-0.98,-1.22l0.01,-0.82l-0.67,-0.19l-0.29,0.86l-0.73,0.37l-0.19,0.06l0.24,-0.27l-0.27,-0.52l-0.4,-0.11l-0.76,0.98l-0.97,0.24l-0.67,2.38l-0.33,0.05l-0.36,-0.33l0.03,-4.92l-0.66,-0.64l-1.23,0.46l0.07,-0.72l-0.68,-0.92l0.27,-0.42l-0.12,-1.01l-2.89,-0.21l-0.54,-0.39l-1.37,-0.13l-0.43,-0.56l-1.2,0.69l-0.99,-0.27l-0.29,-0.65l1.23,-0.02l-0.05,-0.92l0.46,-0.72l1.47,-0.11l-0.03,-0.81l-1.33,-0.74l0.14,-0.43l0.85,-0.72l1.34,-0.01l0.43,-0.43l0.58,-4.63l1.27,-1.41l-0.84,-0.73l1.97,-1.03l1.58,0.21l0.44,-0.55l-0.81,-0.46l-0.34,-0.75l-0.6,0.5l-0.57,-0.1l-1.3,0.72l-2.17,0.25l-0.12,0.5l0.5,0.82l-0.72,0.78l-0.48,-0.47l-2.21,-0.3l-2.19,-1.17l-1.56,-1.56l0.03,-0.37l0.7,-0.05l0.04,-0.67l-0.61,-1.28l-0.09,-1.54l0.39,-0.61l-0.72,-0.34l-0.58,-1.19l0.93,-0.28l0.14,-0.6l-1.09,-0.61l1.52,0.14l0.51,-0.46l0.88,0.03l0.05,0.6l1.07,1.2l-1.21,0.44l-0.39,0.39l0.31,0.47l1.11,-0.1l0.47,0.28l1.12,-0.22l0.18,0.15l-0.72,1.13l0.74,0.73l1.63,0.09l0.68,-0.64l-0.26,-0.92l0.44,-0.39l-0.14,-1.27l-0.59,-0.28l-1.31,0.1l-1.81,-1.44l0.01,-0.63l-0.97,-1.12l0.81,0.16l0.53,-0.4l-1.18,-1.08l0.63,-0.51l-0.14,-0.67l1.25,-0.21l0.53,0.32l0.83,-0.05l0.73,-0.46l-0.08,-0.52l-3.03,-0.29l-1.91,0.63l-0.4,0.68l-0.19,-0.22l0.72,-1.02l-0.63,-1.4l0.68,0.09l0.47,-0.54l-0.48,-1.21l0.96,0.46l0.42,-0.51l-0.63,-0.98l1.73,1.01l0.42,-1.53l0.59,-0.35l3.77,-0.6l0.5,0.35l0.25,0.85l-0.36,0.21l0.14,0.47l1.2,0.19l0.3,-0.42l-0.18,-1.0l1.6,-0.11l0.29,-0.63l-1.51,-0.29l0.59,-0.27l0.16,-0.74l0.9,-0.32l1.37,1.16l0.47,-0.57l-0.32,-0.84l0.37,-0.03l1.02,0.42l1.03,1.2l-0.04,0.6l-0.87,-0.06l-0.35,0.64l1.72,0.3l0.1,0.67l1.21,0.8l3.02,0.17l1.92,-0.37l0.11,0.59l2.89,1.88l2.0,0.37l1.83,-0.33l0.67,-0.63l0.41,-1.78l0.72,-1.29l-0.14,-1.81l0.74,0.39l1.24,-0.12l0.86,-0.71l-0.17,-1.62l0.3,-0.04l0.11,-0.44l-0.25,-0.34l-0.83,-0.45l-1.45,0.34l-0.98,-1.22l-1.22,0.1l-0.5,-0.38l-2.79,-0.15l-0.75,0.51l0.35,-0.85l-0.56,-1.94l-1.57,-0.24l-3.01,-2.71l-1.14,-0.28l-0.95,-0.93l-0.77,0.17l-3.27,-3.98l-0.31,-1.07l0.73,-0.34l0.39,-0.82l-0.53,-1.14l0.14,-0.32l0.52,0.26l1.05,-0.26l1.2,1.12l0.36,-0.78l-2.39,-3.21l-1.44,-1.39l-1.03,-2.33l0.73,0.11l1.02,0.72l1.24,-0.42l0.31,0.63l0.57,0.29l1.08,0.2l0.98,-0.22l1.81,0.53l1.37,1.81l1.19,0.53l0.56,-0.47l-0.6,-1.16l1.94,0.62l0.58,0.79l2.66,0.53l1.79,1.18l0.34,0.64l-0.69,0.11l-0.63,0.77l-1.35,-0.42l-0.12,0.69l0.75,0.66l0.19,1.01l2.13,1.87l1.3,0.71l-0.16,0.68l2.13,1.1l0.66,1.36l0.45,0.21l2.16,-0.88l0.7,1.0l-0.4,0.08l0.01,0.51l0.87,0.33l0.96,-0.71l-0.06,-1.11l-0.58,-0.85l0.4,0.0l1.01,2.11l1.88,1.12l0.85,-0.28l0.74,-1.61l-0.17,-0.25l-1.34,-0.47l-0.61,-1.11l-1.03,-0.61l-1.16,0.14l-0.44,-0.38l-0.48,-1.61l1.18,-0.54l0.78,0.4l0.37,-0.59l-0.87,-1.38l-1.35,-0.8l0.0,-1.23l-0.47,-0.25l-1.01,0.43l-3.2,-3.27l0.71,-1.39l0.04,-2.41l-2.35,-5.81l-1.25,-1.7l-0.54,-1.91l1.29,-0.66l1.24,-1.29l3.37,2.86l2.53,1.62l1.6,0.63l4.17,0.25l2.43,-1.65l1.96,0.17l1.51,-0.27l4.46,2.3l3.16,0.43l0.14,0.68l-0.34,0.08l-0.14,0.66l0.53,0.23l0.34,1.4l0.55,-0.29l0.38,-1.21l1.25,0.75l0.88,0.14l0.29,-0.35l-0.22,-0.39l-1.5,-1.03l0.05,-0.38l0.97,-0.06l0.34,0.13l0.34,1.14l0.55,0.33l0.18,-0.22l0.76,0.21l3.84,2.25l2.9,0.43l2.71,-0.19l0.31,0.85l0.85,0.61l0.02,0.66l1.47,0.88l-0.91,-0.04l-0.91,-0.49l-0.93,0.25l0.42,0.83l-0.26,0.43l0.18,0.59l0.73,-0.04l1.12,0.51l1.03,-0.39l1.07,0.65l0.92,-0.02l0.21,0.47l-0.71,0.01l-0.29,0.34l1.75,2.14l1.64,0.18l2.21,1.14l1.47,1.72l0.67,-0.07l0.41,0.37l-1.57,0.55l-0.18,0.63l2.16,1.28l-0.22,0.75l1.74,1.13l0.58,0.79l0.82,-0.05l1.56,0.52l0.51,0.45l0.14,0.61l2.14,0.56l1.96,1.16l1.82,1.63l0.39,0.96l1.19,0.37l1.05,0.92l-0.12,0.41l0.45,0.47l1.93,1.39l4.48,2.43l1.5,1.94l1.21,0.76l1.38,0.67l0.93,0.04l0.77,0.37l0.03,0.38l1.6,0.03l1.23,0.61l0.47,0.58l0.29,-0.26l1.69,1.44l1.68,2.36l1.24,0.84l0.65,1.11l1.25,0.49l-27.91,60.77l0.17,0.48l1.69,1.44l0.83,-0.19l1.44,1.5l2.05,-0.3l2.16,0.82l-0.98,1.08l-0.15,0.61l0.53,1.11l1.01,1.05l0.05,1.28l2.81,5.56l-0.47,2.71l0.54,0.33l1.98,-0.35l0.06,0.23l-1.19,0.71l0.29,0.54l0.84,-0.22l1.03,0.71l0.36,1.46l-0.28,0.03l-0.1,0.51l0.26,0.36l1.11,0.26l-0.24,0.59l0.49,0.49l-0.11,0.51l-0.36,-0.03l-0.12,-0.59l-0.85,-0.8l-0.47,-0.03l-1.0,0.68l-0.32,-0.86l-1.11,-0.57l-1.15,-1.83l0.58,-0.48l-0.09,-0.3l-0.99,-0.27l-0.56,-1.13l-0.02,-1.29l-1.34,-2.12l0.09,-0.76l-1.17,-0.46l-1.47,-1.72l-0.33,-0.8l-1.65,-1.66l1.58,-0.72l-0.4,0.98l0.71,0.53l0.48,-0.34l0.48,-1.49l0.98,0.8l0.73,-0.31l-0.53,-0.92l-0.81,-0.46l-0.73,-1.81l-0.41,-0.17l-2.16,1.02l-2.27,-0.06l-1.73,-1.01l-1.8,-1.85l0.52,-0.4l0.26,-0.96l-0.45,-1.04l-0.92,0.09l-0.12,0.64l-0.81,-0.05l-1.0,-1.05l-3.3,-2.31l-5.2,-1.56l-0.48,-1.29l0.16,-0.55l-1.83,-0.99l-0.64,-1.23l0.85,-0.63l0.26,-0.77l1.16,-0.21l0.15,-0.7l-0.98,-0.3l-2.56,1.0l-1.03,-0.01l-0.22,-0.7l-0.85,-0.75l1.1,-0.51l0.19,-0.4l-0.31,-0.45l-0.64,-0.02l-0.47,-0.8l0.14,-0.59l-0.49,-1.17l-0.45,-0.22l-0.62,0.19l-0.57,-0.49l0.25,-0.73l0.46,-0.09l1.22,0.53l0.42,-0.5l-0.16,-0.48l-1.49,-0.88l-1.82,0.34l-0.6,-0.61l-1.17,-0.28l-0.22,-0.32l0.32,-1.1l-0.72,-0.3l0.35,-0.97l-0.33,-0.29l-2.04,0.78l-0.28,-0.64l-1.38,-0.22l-0.75,0.57l0.31,0.89l-1.75,-0.34l-0.8,0.99l0.26,0.62l0.9,-0.03l-0.2,0.34l-1.52,0.34l-0.23,0.63l0.38,0.29l1.02,-0.16l0.49,0.83l-0.47,0.61l-0.59,-0.24l-0.7,0.58l0.05,0.63l-0.31,0.35l-0.27,-0.15l-0.68,0.39l-1.38,-1.05l0.03,-0.72l-1.08,-0.12l0.11,-0.8l-0.55,-0.46l-1.0,1.06l-1.09,-0.68l-0.44,0.5l-0.48,-0.1l-0.2,0.41l-0.8,-0.43l-0.29,0.55l-0.7,-0.52l-1.3,0.56l-0.16,-0.45l-0.91,-0.04l-0.56,0.81l-1.73,0.25l-1.02,-0.92l-0.6,0.32l-0.44,-0.36l-1.29,0.01l-0.44,-1.08l0.64,0.17l0.17,-0.48l0.68,0.04l0.89,0.91l0.56,-0.11l0.11,-0.54l0.9,0.16l1.67,-0.74l0.32,-0.52l-0.22,-0.4l-2.72,-0.16l-0.79,-1.25l1.54,-1.19l1.91,-0.52l0.81,-0.85l0.52,-0.09l0.76,-1.03l0.15,-1.27l1.37,0.34l3.53,-0.14l0.24,1.07l0.66,0.57l1.41,0.31l2.69,2.59l0.5,-0.37l-0.13,-0.93l-0.99,-0.67l-1.76,-2.54l1.94,-0.66l2.25,0.33l0.05,-0.75l-1.75,-0.86l-1.62,0.15l-0.71,0.63l-1.07,-0.92l-0.7,-0.18l0.17,-0.32l-0.28,-0.7l-1.24,0.32l-1.57,-0.23l-0.99,0.48l-1.49,-0.52l-1.37,0.05l-0.78,0.4l-0.2,0.55l-1.24,-0.08l-1.92,0.49l-0.59,0.81l-0.62,0.26l-0.75,-0.02l-0.97,-1.32l-1.1,-0.29l-0.3,0.28l0.16,0.51l0.44,0.07l0.66,2.11l-0.91,0.44l-2.4,-0.95l-0.46,0.21l0.03,0.68l0.78,0.42l-0.2,0.15l-0.56,0.01l-0.54,-1.57l-0.76,0.74l-0.24,-0.5l-0.88,0.16l-0.13,0.57l-0.85,-0.44l-0.36,0.28l0.3,0.67l-1.93,-0.49l-0.81,1.18l-0.83,0.28l-0.17,1.22l0.33,0.36l0.71,-0.05l1.13,0.82l0.76,1.64l-0.81,0.65l-1.11,0.16l-1.09,-0.54l-0.98,0.53l-0.75,-0.18l-0.37,0.73l-1.4,-0.13l-0.46,0.82l-0.5,-0.62l-0.4,0.44l-1.47,0.04l-1.12,-0.71l-1.09,0.61l-0.67,-0.22l-0.91,0.37l-0.64,-0.78l-0.94,0.73l-0.49,-0.21l-0.32,0.36l-0.62,-0.1l-0.41,-0.5l-0.83,0.37l-2.51,-0.14l-0.57,0.44l0.28,1.17l-0.59,0.14l-1.31,-0.59l-0.58,0.52l-0.3,-0.46l-2.04,0.38l-0.15,-0.68l-0.48,-0.37l-0.79,0.47l-0.83,0.0l-0.29,0.61l-0.03,-0.62l-0.42,-0.3l-1.95,-0.18l-0.77,0.39l-0.34,-0.37l-0.72,-0.1l-1.8,0.43l-0.28,0.75l-0.4,-0.03l-0.82,0.77l-2.9,-0.76l-0.87,-0.79l-0.66,0.16l-0.84,-0.82l-1.36,-0.26l-0.93,0.26ZM89.01,536.65l-0.02,0.01l-0.0,0.03l0.02,-0.04ZM89.06,536.61l0.02,-0.01l-0.01,0.01l-0.0,0.01ZM91.61,484.22l-0.0,0.01l-0.0,-0.01l0.01,0.0ZM87.17,484.0l-0.0,-0.0l0.01,-0.0l-0.0,0.01l-0.01,-0.0ZM186.66,475.29l-0.0,0.02l-0.01,-0.01l0.01,-0.0ZM156.69,531.75l-0.95,1.06l-0.87,0.02l-0.13,-0.28l0.69,-0.51l1.26,-0.28ZM151.45,532.97l-0.11,0.02l0.12,-0.04l-0.01,0.02ZM152.06,535.54l-0.09,-0.14l0.41,-0.11l-0.1,0.3l-0.22,-0.05ZM116.92,535.18l-0.13,0.11l-0.06,-0.02l0.04,-0.19l0.16,0.1ZM90.72,536.66l0.27,-0.19l0.07,0.3l-0.17,0.07l-0.17,-0.19ZM121.46,528.8l-0.0,-0.02l0.04,0.01l-0.03,0.01ZM186.96,558.95l-0.09,-1.09l0.4,-0.11l0.13,0.57l-0.44,0.62ZM196.09,568.76l2.06,0.17l0.88,-0.72l0.4,-0.93l0.62,0.05l0.66,-0.45l0.12,-0.56l3.59,0.11l1.22,2.1l-0.59,0.6l0.11,1.69l1.05,0.86l0.25,0.97l0.46,0.34l0.11,1.76l1.72,2.25l0.24,1.0l-1.26,-0.23l-0.94,0.69l-0.72,1.06l-0.71,-1.34l-1.02,-0.73l0.15,-0.58l-0.32,-1.25l0.48,-1.41l-0.8,-0.55l0.41,-2.32l-0.18,-1.24l0.62,-1.53l-0.66,-0.25l-0.62,0.87l-0.78,-0.09l0.03,0.58l-0.38,0.41l0.37,1.24l-0.41,0.99l0.15,1.56l-0.41,1.27l0.03,2.19l-0.37,0.45l-0.41,-0.46l0.02,-1.59l-0.29,-0.45l-0.66,0.28l-1.11,-0.29l0.47,-0.38l0.24,-0.99l-0.35,-1.47l1.14,0.14l0.45,-0.45l-0.11,-0.36l-0.86,-0.52l-0.27,0.12l-0.01,-1.01l-0.61,-0.4l-0.96,1.15l0.46,0.38l-0.33,0.4l-0.04,-0.54l-0.68,-0.29l0.29,-0.67l-0.28,-0.54l-0.39,-0.02l-0.2,-0.62l-0.47,-0.15l-0.26,0.42l-0.35,-0.7ZM209.19,578.54l0.61,1.19l-0.23,0.77l0.66,1.82l0.05,1.22l1.73,7.29l-0.66,0.56l0.03,0.64l1.0,0.69l-0.59,0.84l0.05,0.52l0.72,0.67l-0.2,1.56l0.37,0.44l1.07,0.31l1.71,2.17l1.4,0.95l0.39,0.88l0.67,0.5l0.09,0.91l1.53,1.02l-0.19,0.84l-1.17,1.01l-0.41,1.68l-0.0,2.19l-2.07,1.87l-1.09,0.57l-0.63,-0.13l-0.02,-1.13l-0.64,0.07l-0.3,1.04l-0.22,0.05l0.16,-1.54l1.09,0.23l2.31,-1.69l-0.23,-0.63l-0.64,0.13l-0.33,-0.61l-0.71,0.13l0.71,-2.09l0.22,-1.84l-0.43,-0.29l-0.4,-1.06l0.62,-0.2l0.58,-0.88l-0.43,-0.27l-1.78,0.52l-0.59,-0.36l-2.75,0.29l-0.13,0.71l0.35,0.37l-0.57,0.72l-0.64,-0.46l-0.2,1.01l-0.3,-0.39l0.1,-0.81l0.89,-0.27l0.51,-0.97l0.54,-0.2l0.43,-1.37l1.49,0.53l1.01,-0.36l-0.17,-0.59l-1.8,-0.6l0.03,-1.02l-0.82,-0.63l0.03,-0.53l-0.51,-0.72l0.35,-0.41l-0.16,-0.68l-0.59,-0.0l0.81,-0.68l0.22,-0.62l-0.41,-0.27l-0.79,0.23l-0.68,-1.21l0.4,-0.26l0.21,-1.19l-0.39,-0.3l-0.8,0.09l-0.48,-1.2l-0.52,-0.26l-0.49,0.27l-0.37,-0.39l0.13,-0.25l1.84,0.29l0.62,-0.37l-0.23,-0.67l-1.19,-0.13l0.23,-0.72l-0.6,-0.28l0.07,-0.27l0.81,-0.01l0.81,1.13l0.62,-0.14l0.04,-0.52l-1.77,-2.58l0.17,-0.56l1.59,1.01l0.37,-0.69l-0.4,-0.48l-1.89,-0.89l0.24,-0.34l-0.2,-0.47l0.54,-0.81l-0.81,-0.3l-0.88,0.87l-0.2,-0.58l0.08,-0.72l0.74,-0.62l0.17,-0.66l0.54,-0.5l0.92,-0.14ZM214.84,608.68l-0.72,0.37l-0.3,-0.26l-0.82,0.1l0.74,-0.58l1.09,0.36ZM207.55,585.56l-0.21,-0.06l0.0,-0.24l0.08,0.17l0.13,0.13ZM124.33,461.82l-0.72,-0.79l0.08,-0.62l0.61,0.33l0.02,1.08ZM96.68,478.86l-0.08,-0.01l0.0,-0.01l0.08,0.02ZM87.61,480.71l-0.14,-0.07l0.02,0.0l0.12,0.07ZM87.75,487.21l-0.01,0.0l-0.04,-0.04l0.05,0.04ZM210.21,605.25l0.95,-0.39l0.15,-0.88l1.01,-0.37l0.59,-1.12l0.76,0.04l0.47,2.53l-1.46,2.49l0.34,-0.93l-0.25,-0.46l0.16,-1.74l-0.39,-0.42l-0.42,0.19l-0.21,0.58l-0.85,0.26l-0.29,1.23l-0.57,-1.01ZM204.53,604.41l0.23,-0.52l-0.58,-0.47l0.16,-0.56l-0.41,-0.26l1.05,-0.38l0.21,-0.67l-2.13,-0.56l1.59,-0.9l0.16,-0.86l-0.36,-0.08l0.35,-1.05l0.21,0.49l1.38,0.95l0.65,1.87l-0.18,0.82l-0.68,0.31l-0.12,0.51l-0.79,0.23l-0.06,0.42l0.07,0.51l0.76,-0.09l-0.11,0.29l0.38,0.45l0.87,0.16l0.31,0.67l-0.54,-0.15l-0.4,0.8l0.23,0.39l0.85,0.22l-1.39,0.74l0.11,0.7l0.57,0.32l-0.22,0.31l0.26,0.63l-0.39,0.4l-0.4,-0.2l0.24,-0.39l-0.45,-1.27l0.19,-0.92l-0.49,-0.5l-0.25,-1.87l-0.67,0.18l-0.2,-0.66ZM204.7,605.12l-0.02,0.03l0.0,-0.0l0.02,-0.03ZM204.91,597.51l-0.15,-0.81l-1.16,-0.79l0.71,0.03l0.44,0.61l0.43,-0.21l0.17,0.98l-0.44,0.18ZM204.03,589.42l1.73,1.0l0.58,0.52l0.11,0.57l0.56,0.15l0.24,-0.39l0.54,0.65l-0.54,1.63l-0.36,-1.55l-0.5,-0.5l-0.56,0.05l-0.21,0.96l0.31,0.54l-0.25,0.39l0.51,0.85l-0.29,0.21l-0.99,-0.68l-0.46,0.33l-0.4,-0.11l0.95,-2.9l-0.98,-1.74ZM204.3,590.82l0.01,0.01l0.01,0.01l-0.01,-0.0l-0.01,-0.01ZM201.28,587.91l0.24,-0.68l0.52,-0.17l-0.03,-0.45l0.42,-0.22l0.35,0.32l0.6,-0.35l-0.0,-0.8l-0.62,-0.4l0.7,-0.07l0.24,-0.65l-1.03,-0.28l-0.02,-1.43l0.48,-2.46l0.45,-0.43l0.87,0.22l0.37,0.4l-0.69,2.23l0.41,0.23l0.08,1.49l0.51,0.53l-0.12,0.39l-0.62,-0.22l-0.31,0.8l-0.69,0.34l0.04,0.32l-0.11,0.42l-0.22,0.32l-1.81,0.61ZM204.42,586.23l0.02,0.16l-0.19,-0.27l0.07,0.06l0.09,0.05ZM203.16,578.77l0.02,-0.02l0.01,0.06l-0.01,0.0l-0.03,-0.05ZM202.08,593.81l-0.03,-0.32l0.05,-0.01l0.09,0.19l-0.11,0.14ZM202.25,593.0l-0.25,-0.54l0.16,-0.07l0.34,0.48l-0.24,0.13ZM201.87,592.45l-0.2,-0.02l-0.02,-0.03l0.04,-0.01l0.17,0.06ZM201.97,591.45l-0.19,-0.44l-0.52,-0.05l0.08,-0.24l1.42,-0.09l-0.01,0.81l-0.39,0.25l-0.38,-0.25ZM195.26,578.67l0.22,-0.17l0.78,1.25l0.56,-0.45l-0.67,-1.58l0.86,0.26l0.05,-1.05l0.36,0.52l1.18,-0.42l0.77,0.97l-0.44,0.2l-0.8,-0.21l-0.17,0.33l-0.79,0.06l0.06,0.48l1.78,2.24l-0.07,0.74l0.9,0.5l1.08,0.01l-0.34,1.59l-0.43,-0.2l-2.75,-3.68l-0.61,0.35l0.09,0.44l-0.28,0.18l0.52,0.86l-0.19,0.56l0.29,0.37l-0.52,0.14l-0.52,-1.4l0.33,-0.19l-0.16,-0.49l-1.1,-2.22ZM197.81,583.65l0.03,-0.01l-0.01,0.04l-0.02,-0.02l-0.0,-0.0ZM197.98,583.86l0.65,0.02l0.94,0.95l0.23,2.78l-0.4,2.69l-0.3,0.89l-0.47,0.37l-0.63,1.95l-0.37,-2.3l1.14,-0.59l-0.06,-0.73l-0.28,-0.06l0.01,-0.56l-0.47,-0.3l-0.19,-0.68l-0.71,-0.04l0.39,-0.63l0.81,-0.06l0.22,-0.32l-0.13,-0.54l-0.66,-0.34l0.68,-0.34l-0.35,-1.27l-0.73,-0.27l0.59,-0.15l0.09,-0.48ZM196.56,583.11l-0.06,-0.04l0.15,-0.08l-0.09,0.12ZM199.05,579.52l1.11,-0.49l0.92,0.47l0.59,0.75l-0.17,0.31l-0.56,-0.63l-0.63,-0.07l-0.13,0.57l0.35,0.67l-1.49,-1.58ZM121.86,538.8l-0.0,-0.01l0.02,0.02l-0.02,-0.01ZM122.16,539.2l0.38,0.41l0.59,-0.1l-0.04,-0.62l0.83,0.53l0.61,-1.11l0.62,0.04l-0.13,0.7l0.46,0.88l-0.67,0.48l-0.23,-0.84l-0.37,-0.03l-0.81,0.68l-0.2,-0.29l-0.67,0.31l-0.36,-1.02ZM125.68,539.91l0.02,-0.0l-0.01,0.0l-0.01,-0.0ZM126.24,540.18l-0.05,-0.09l0.07,0.07l-0.02,0.02ZM126.1,539.97l-0.36,-0.07l0.27,-0.16l0.09,0.23ZM111.97,541.9l0.13,-1.11l-0.41,-0.51l0.57,-0.47l0.58,-0.31l0.5,0.27l1.58,-0.22l0.55,0.47l-0.75,0.07l0.02,0.5l0.56,0.37l-0.31,0.99l0.56,1.75l0.45,0.16l0.28,-0.39l-0.23,-0.7l0.33,-1.09l0.38,0.2l0.37,-0.33l1.06,0.15l0.41,-0.28l0.62,0.17l0.21,0.41l0.91,-0.72l0.49,0.31l-0.22,0.73l0.26,0.4l0.49,-0.02l0.33,-0.47l1.39,0.19l-0.09,0.39l-0.85,0.24l-0.21,0.41l0.21,1.1l0.75,0.33l-0.77,0.3l-2.35,-2.03l-0.88,0.42l-0.02,0.69l-0.56,-0.49l-0.44,0.12l-0.27,0.58l-1.74,-0.5l-0.49,0.58l-0.32,-0.15l-0.13,-0.86l-0.79,-0.03l-1.07,-1.18l-1.1,-0.44ZM119.11,544.38l0.82,0.17l0.33,0.72l-0.52,-0.07l-0.2,-0.66l-0.42,-0.16ZM117.78,540.47l-0.76,-0.83l0.17,-0.28l0.83,0.02l-0.24,1.09ZM121.13,540.99l0.32,0.07l-0.59,0.51l0.31,-0.44l-0.03,-0.14ZM113.0,545.5l-0.71,0.24l-0.07,-0.11l0.36,-0.03l0.42,-0.1ZM111.68,543.33l0.69,-0.15l0.23,0.13l-0.51,0.43l-0.41,-0.41ZM76.93,452.59l0.44,-0.56l0.74,-0.21l0.04,0.98l0.81,0.62l0.81,1.25l1.59,0.48l1.11,0.77l0.29,0.97l-0.62,0.7l1.28,1.78l-0.03,0.76l0.83,0.73l0.06,0.6l-0.76,-0.35l-1.49,0.03l-0.08,-1.15l-0.71,-1.29l0.16,-0.62l-1.2,-2.9l-0.96,-0.77l-1.79,-0.42l-0.51,-1.4ZM84.52,461.74l0.69,0.18l0.56,0.73l-0.43,0.12l-0.82,-1.03ZM75.58,485.5l0.07,-0.44l1.7,1.61l0.78,-0.27l0.53,0.4l0.88,-0.0l-0.06,0.37l0.83,0.24l0.29,0.89l1.02,0.89l-0.67,0.62l-0.55,1.49l-2.66,-1.39l-0.92,-0.99l-0.64,-2.06l-0.55,-0.58l-0.06,-0.77ZM55.82,528.18l0.22,-0.57l1.29,0.26l2.05,-0.81l0.73,0.9l0.76,-0.1l1.99,0.58l0.55,0.5l0.05,0.8l-0.49,1.14l-1.03,0.31l-2.5,-1.87l-2.52,0.16l-1.15,-0.81l0.05,-0.5ZM37.73,525.86l0.44,0.13l0.4,0.44l-0.66,-0.33l-0.17,-0.24ZM43.99,527.71l-0.32,-0.33l-0.55,0.04l0.82,-0.2l0.41,-0.61l-1.11,-1.43l0.35,-0.53l1.55,0.81l-0.4,0.52l0.03,0.83l-0.39,0.13l-0.39,0.76ZM42.84,527.18l-0.0,-0.0l0.0,0.0l0.0,0.0ZM43.98,526.54l0.02,-0.01l0.01,0.01l-0.02,0.0l-0.0,-0.0ZM42.63,527.12l-0.35,0.44l-0.22,-0.21l0.3,-0.36l-0.18,-0.32l0.39,-0.07l0.05,0.51ZM42.72,526.39l-0.0,-0.06l0.01,0.01l-0.01,0.05ZM31.87,524.21l0.91,-0.8l0.8,0.02l0.72,0.69l-1.15,0.35l-1.28,-0.25ZM35.31,524.02l0.44,-0.89l0.8,-0.04l0.97,0.45l0.25,0.65l-0.43,0.37l-2.04,-0.54ZM4.9,508.63l0.28,0.1l-0.04,0.24l-0.12,0.03l-0.12,-0.37ZM6.12,508.53l-0.05,-0.66l0.53,0.07l0.12,0.71l-0.59,-0.13Z",name:"Alaska"},"US-NJ":{path:"M801.65,165.2l1.31,-1.55l0.48,-1.57l0.5,-0.62l0.54,-1.45l0.11,-2.05l0.67,-1.35l0.92,-0.71l14.12,4.16l-0.4,6.03l-0.35,0.55l-0.23,-0.44l-0.7,0.11l-0.26,1.18l-0.76,0.97l0.12,1.42l-0.46,0.6l0.08,1.71l0.58,0.62l1.2,0.29l1.38,-0.43l2.3,0.24l0.9,6.92l-0.56,0.39l0.18,0.66l-0.61,0.95l0.46,0.58l-0.21,0.6l0.53,1.94l-0.47,2.0l0.11,0.61l0.62,0.64l-0.39,1.13l-0.49,0.45l-0.01,0.59l-0.93,1.13l0.02,0.52l-1.07,0.1l0.09,1.21l0.64,0.83l-0.82,0.56l-0.18,1.15l1.05,0.77l-0.31,0.29l-0.17,-0.44l-0.53,-0.18l-0.5,0.22l-0.44,1.51l-1.28,0.61l-0.2,0.45l0.46,0.55l0.8,0.06l-0.66,1.26l-0.26,1.5l-0.68,0.65l0.19,0.48l0.4,0.04l-0.89,1.57l0.07,0.95l-1.65,1.72l-0.12,-1.34l0.36,-2.44l-0.11,-0.87l-0.58,-0.82l-0.89,-0.28l-1.11,0.34l-0.81,-0.35l-1.51,0.88l-0.31,-0.7l-1.62,-0.96l-1.0,0.04l-0.65,-0.71l-0.7,0.07l-3.24,-2.03l-0.06,-1.73l-1.02,-0.94l0.48,-0.68l0.0,-0.87l0.43,-0.83l-0.12,-0.73l0.51,-1.18l1.2,-1.16l2.6,-1.49l0.54,-0.86l-0.38,-0.85l0.5,-0.37l0.47,-1.44l1.24,-1.7l2.52,-2.22l0.18,-0.67l-0.47,-0.82l-4.26,-2.78l-0.75,-1.05l-0.9,0.24l-0.48,-0.33l-1.24,-2.46l-1.62,-0.02l-1.0,-3.44l1.02,-1.03l0.36,-2.23l-1.87,-1.91Z",name:"New Jersey"},"US-CO":{path:"M364.23,239.52l-1.22,65.86l-29.29,-0.9l-29.38,-1.43l-29.35,-1.95l-32.17,-2.75l8.32,-87.13l27.79,2.39l28.22,1.92l29.58,1.46l27.95,0.87l-0.46,21.65Z",name:"Colorado"},"US-MD":{path:"M740.67,219.62l-2.04,-10.06l19.85,-4.49l-0.66,1.29l-0.94,0.08l-1.54,0.81l0.16,0.7l-0.42,0.49l0.23,0.78l-1.76,0.5l-1.48,0.03l-1.14,-0.39l0.21,-0.36l-0.3,-0.49l-1.11,-0.31l-0.47,1.8l-1.63,2.84l-1.37,-0.39l-1.03,0.62l-0.41,1.26l-1.6,1.93l-0.36,1.04l-0.88,0.45l-1.3,1.87ZM760.74,204.54l36.93,-9.13l8.48,26.19l0.45,0.26l1.06,-0.21l8.18,-2.08l-0.9,0.53l0.31,0.64l0.52,0.01l0.37,0.76l0.52,-0.05l-0.38,1.96l-0.12,-0.26l-0.47,0.07l-0.73,0.86l-0.17,2.7l-0.6,0.19l-0.36,0.71l-0.02,1.66l-3.62,1.37l-0.45,0.7l-2.2,0.43l-0.56,0.65l-0.3,-1.09l0.5,-0.31l0.86,-1.84l-0.4,-0.51l-0.45,0.12l0.08,-0.5l-0.44,-0.42l-2.29,0.63l0.3,-0.6l1.15,-0.83l-0.17,-0.69l-1.36,-0.18l0.38,-2.24l-0.18,-1.02l-0.91,0.16l-0.53,1.76l-0.34,-0.68l-0.62,-0.07l-0.44,0.47l-0.5,1.39l0.53,1.02l-2.87,-2.14l-0.43,-0.19l-0.61,0.36l-0.73,-0.76l0.33,-1.67l0.76,-0.6l-0.08,-1.35l2.55,0.23l0.78,-1.5l-0.32,-1.42l-0.72,0.27l-0.28,1.29l-0.98,-0.25l-0.38,-1.07l-0.52,-0.28l-0.55,0.23l-0.22,-0.68l-0.63,0.08l1.0,-0.82l0.22,-1.04l-0.54,-0.55l-0.75,0.83l-0.21,-0.61l1.06,-0.92l-0.25,-0.65l-0.54,-0.08l-0.51,-0.75l-0.42,0.22l-0.53,-0.37l0.83,-1.03l-0.24,-1.02l0.84,-1.95l-0.07,-0.86l-0.46,0.02l-0.66,0.66l-0.56,-0.16l-0.48,0.45l-0.19,0.97l-0.95,-1.2l0.75,-3.46l0.59,-0.51l0.07,-0.74l3.89,-0.78l0.49,-0.41l-0.23,-0.67l-0.45,-0.07l-2.38,0.56l0.88,-1.55l1.42,-0.05l0.35,-0.5l-0.99,-0.67l0.44,-1.9l-0.63,-0.32l-0.48,0.39l-0.87,1.96l0.21,-2.02l-0.59,-0.34l-0.88,1.43l-1.42,0.34l-0.31,1.65l0.39,0.53l0.65,0.12l-1.45,1.92l-0.2,-1.64l-0.64,-0.42l-0.61,0.73l0.07,1.45l-0.85,-0.29l-1.16,0.64l0.02,0.71l1.01,0.27l-0.37,0.54l-0.83,0.22l-0.05,0.34l-0.44,-0.04l-0.35,0.64l1.2,1.22l-0.29,0.17l-1.52,-0.76l-1.33,0.48l0.16,0.69l0.82,0.1l1.26,1.21l1.49,0.58l0.1,0.28l-0.44,0.33l-1.37,0.5l-0.12,1.19l1.83,1.04l0.47,0.63l-0.66,-0.43l-1.05,0.29l0.2,0.64l0.92,0.48l-0.34,0.47l0.4,1.15l0.6,0.09l-0.63,1.26l0.13,0.43l0.63,0.65l1.28,4.18l2.83,2.58l-0.01,0.35l-0.38,0.54l-0.67,-1.23l-1.21,-0.22l-1.69,-0.87l-1.51,-3.64l-0.74,-0.68l-0.28,0.69l1.17,3.94l0.65,0.92l1.45,0.81l1.3,0.31l1.49,1.39l0.89,-0.33l0.37,1.32l1.47,1.47l0.1,1.07l-1.08,-0.68l-0.33,-1.23l-0.63,-0.45l-0.45,0.04l-0.13,0.44l0.27,0.78l-0.74,0.13l-0.62,-0.73l-1.16,-0.38l-1.53,0.0l-0.92,0.43l-0.55,-0.2l-1.0,-2.19l-1.26,-0.71l-0.46,0.14l0.01,0.48l1.19,2.0l-0.67,-0.12l-0.28,-0.5l-0.89,-0.4l-1.61,-2.6l-0.48,-0.14l-0.43,1.47l-0.25,-0.74l-0.62,-0.04l-0.4,0.46l0.33,0.72l-0.18,0.69l-0.64,0.59l-0.57,-0.26l-0.63,-1.86l0.25,-1.14l0.71,-0.37l0.2,-0.51l-0.37,-0.52l0.83,-0.52l0.21,-1.61l1.06,-0.35l0.07,-0.66l-0.33,-0.42l0.23,-0.42l-0.38,-0.38l-0.04,-0.7l1.27,-2.2l-0.14,-0.54l-2.72,-1.68l-0.56,0.14l-0.69,1.19l-1.81,-0.37l-1.09,-1.19l-2.96,-0.09l-1.25,-0.91l0.61,-1.35l-0.4,-0.97l-1.19,-0.3l-0.89,-0.66l-2.69,0.07l-0.36,-0.23l-0.11,-1.26l-1.04,-0.6l0.09,-1.2l-0.51,-0.29l-0.49,0.19l-0.23,-0.64l-0.52,-0.13l0.26,-0.83l-0.45,-0.58l-0.69,-0.12l-1.81,0.67l-2.24,-1.27ZM790.07,212.25l0.29,-0.0l0.93,0.21l-0.44,0.4l-0.78,-0.61ZM796.79,218.15l0.0,0.16l-0.13,-0.11l0.13,-0.06ZM803.02,225.62l-0.02,0.33l-0.21,-0.15l0.23,-0.19ZM806.99,229.08l-0.16,0.3l-0.12,0.07l0.02,-0.25l0.26,-0.12ZM797.54,220.57l-0.06,0.01l-0.09,0.03l0.12,-0.06l0.03,0.02ZM797.21,220.69l-0.26,0.57l-0.18,0.12l0.15,-0.61l0.29,-0.07ZM796.09,217.04l-0.61,0.32l-0.58,-0.42l0.02,-0.53l0.16,-0.23l0.68,0.3l0.32,0.56ZM794.46,213.09l-0.25,0.5l-0.8,0.39l0.15,-1.17l0.9,0.27Z",name:"Maryland"},"US-MA":{path:"M820.4,120.02l30.04,-8.0l1.53,-1.8l0.34,-1.48l0.95,-0.35l0.61,-1.04l1.17,-1.05l1.35,-0.1l-0.44,1.05l1.03,0.32l0.21,1.55l1.17,0.55l-0.06,0.32l0.39,0.28l1.31,0.19l-0.17,0.56l-2.29,1.79l-0.05,1.07l0.45,0.16l-1.11,1.41l0.23,1.08l-1.01,0.96l0.58,1.41l1.4,0.45l0.5,0.63l1.36,-0.57l0.33,-0.59l1.2,0.09l0.79,0.47l0.23,0.68l1.79,1.37l-0.07,1.25l-0.56,0.55l0.12,0.6l1.23,0.66l1.73,-0.23l0.68,1.2l0.21,1.14l0.89,0.68l1.33,0.41l1.48,-0.12l0.43,0.38l1.05,-0.23l2.92,-2.34l0.82,-1.11l0.54,0.02l0.56,1.86l-3.32,1.52l-0.94,0.82l-2.75,0.98l-0.49,1.64l-1.93,1.37l-0.82,-2.64l0.11,-1.34l-0.55,-0.31l-0.5,0.39l-0.93,-0.1l-0.3,0.51l0.25,0.92l-0.26,0.79l-0.4,0.06l-0.63,1.1l-0.6,-0.2l-0.5,0.48l0.22,1.86l-0.9,0.87l-0.63,-0.8l-0.47,0.01l-0.11,0.55l-0.26,0.03l-0.71,-2.03l-1.02,-0.35l0.44,-2.5l-0.21,-0.4l-0.78,0.4l-0.29,1.47l-0.69,0.2l-1.4,-0.64l-0.78,-2.12l-0.8,-0.22l-0.78,-2.15l-0.49,-0.24l-6.13,2.0l-0.3,-0.15l-14.84,4.19l-0.28,0.5l-0.46,-0.28l-0.86,0.17l-9.54,2.36l-0.25,-0.18l-0.32,-14.66ZM860.63,110.12l-0.02,-0.37l-0.14,-0.48l0.51,0.23l-0.35,0.62ZM876.24,122.86l-0.12,-0.42l0.25,0.35l-0.13,0.06ZM875.23,121.15l-0.78,0.0l-0.55,-1.2l0.56,0.44l0.77,0.76ZM871.43,119.57l-0.08,0.14l-0.09,-0.07l0.0,-0.0l0.17,-0.07Z",name:"Massachusetts"},"US-AL":{path:"M608.67,337.4l25.17,-2.91l19.4,-2.75l14.04,43.29l1.01,2.45l1.17,1.59l0.59,1.87l2.24,2.5l0.92,1.8l-0.11,2.13l1.8,1.13l-0.17,0.74l-0.63,0.1l-0.16,0.7l-0.98,0.84l-0.22,2.29l0.25,1.48l-0.76,2.3l-0.14,1.84l1.1,2.94l1.21,1.52l0.53,1.6l-0.08,5.02l-0.25,0.81l0.48,2.03l1.35,1.16l1.14,2.07l-47.64,6.92l-0.42,0.61l-0.08,2.99l2.64,2.75l2.0,0.96l-0.34,2.7l0.56,1.61l0.43,0.39l-0.94,1.69l-1.24,1.0l-1.13,-0.75l-0.34,0.49l0.66,1.46l-2.81,1.05l0.29,-0.63l-0.45,-0.86l-0.99,-0.76l-0.1,-1.11l-0.57,-0.22l-0.52,0.61l-0.32,-0.1l-0.89,-1.53l0.41,-1.67l-0.97,-2.21l-1.32,-0.65l-0.3,-0.89l-0.56,-0.17l-0.37,0.61l0.15,0.35l-0.77,3.1l-0.01,5.08l-0.59,0.0l-0.24,-0.71l-2.22,-0.44l-1.64,0.31l-5.46,-31.98l-0.99,-66.48l-0.02,-0.37l-1.07,-0.63l-0.69,-1.02Z",name:"Alabama"},"US-MO":{path:"M468.72,225.49l24.71,-0.73l18.94,-1.42l22.1,-2.58l0.42,0.35l0.39,0.91l2.43,1.65l0.29,0.74l1.21,0.87l-0.51,1.36l-0.1,3.21l0.78,3.65l0.95,1.44l0.03,1.59l1.11,1.37l0.46,1.55l4.96,4.1l1.06,1.69l4.93,3.31l0.7,1.15l0.27,1.62l0.5,0.82l-0.18,0.69l0.47,1.8l0.97,1.63l0.77,0.73l1.04,0.16l0.83,-0.56l0.84,-1.4l0.57,-0.19l2.41,0.61l1.68,0.76l0.84,0.77l-0.97,1.95l0.26,2.28l-2.37,6.86l0.01,1.02l0.7,1.92l4.67,4.05l1.99,1.05l1.46,0.09l1.66,1.3l1.92,0.8l1.5,2.11l2.04,0.83l0.42,2.96l1.72,2.9l-1.1,1.94l0.18,1.38l0.75,0.33l2.31,4.25l1.94,0.92l0.55,-0.32l0.0,-0.65l0.87,1.1l1.07,-0.08l0.14,1.85l-0.37,1.07l0.53,1.59l-1.07,3.86l-0.51,0.07l-1.37,-1.13l-0.65,0.13l-0.78,3.34l-0.52,0.74l0.13,-1.06l-0.56,-1.09l-0.97,-0.2l-0.74,0.63l0.02,1.05l0.53,0.66l-0.04,0.7l0.58,1.34l-0.2,0.4l-1.2,0.39l-0.17,0.41l0.15,0.55l0.86,0.84l-1.71,0.37l-0.14,0.62l1.53,1.97l-0.89,0.75l-0.63,2.13l-10.61,1.42l1.06,-2.28l0.87,-0.61l0.18,-0.87l1.43,-0.96l0.25,-0.96l0.63,-0.37l0.29,-0.59l-0.22,-2.28l-1.05,-0.75l-0.2,-0.77l-1.09,-1.18l-39.24,3.6l-37.71,2.58l-3.21,-58.18l-1.03,-0.63l-1.2,-0.02l-1.52,-0.73l-0.19,-0.93l-1.11,-1.3l-0.36,-1.55l-0.55,-0.09l-0.3,-0.56l-1.13,-0.66l-1.4,-1.84l0.73,-0.51l0.09,-1.24l1.12,-1.27l0.09,-0.79l1.01,0.16l0.56,-0.43l-0.2,-2.24l-1.02,-0.74l-0.32,-1.1l-1.17,-0.01l-1.31,0.96l-0.81,-0.7l-0.73,-0.17l-2.67,-2.35l-1.05,-0.28l0.13,-1.6l-1.32,-1.72l0.1,-1.01l-0.37,-0.36l-1.01,-0.18l-0.59,-0.85l-0.84,-0.26l0.07,-0.52l-1.24,-2.88l-0.0,-0.74l-0.4,-0.49l-0.85,-0.29l-0.05,-0.54ZM583.78,294.53l-0.1,-0.1l-0.08,-0.15l0.11,-0.01l0.07,0.26Z",name:"Missouri"},"US-MN":{path:"M443.67,67.68l-0.4,-1.37l0.05,-1.19l-0.48,-0.53l-1.36,-3.77l0.0,-3.22l-0.47,-1.97l0.27,-1.12l-0.57,-2.32l0.73,-2.56l-2.06,-6.89l29.55,-1.22l0.47,-0.81l-0.38,-7.12l2.84,0.15l1.24,0.82l0.38,2.69l1.73,5.31l0.13,2.3l0.52,0.86l1.46,1.05l1.3,0.49l3.23,-0.36l0.39,0.85l0.54,0.38l5.25,0.04l0.38,0.24l0.54,1.58l0.72,0.61l4.27,-0.78l0.77,-0.65l0.07,-0.69l0.69,-0.35l1.74,-0.44l3.97,-0.02l1.42,0.7l3.38,0.66l-1.01,0.79l0.0,0.82l0.51,0.45l2.91,-0.06l0.52,2.08l1.58,2.29l0.71,0.05l1.03,-0.78l-0.04,-1.73l2.67,-0.46l1.43,2.16l2.01,0.79l1.54,0.18l0.54,0.57l-0.03,0.83l0.58,0.35l1.32,0.06l0.19,0.75l0.41,0.1l1.2,-0.22l1.12,0.22l2.21,-0.85l2.78,-2.55l2.49,-1.54l1.24,2.52l0.96,0.51l2.23,-0.66l0.87,0.36l5.98,-1.3l0.56,0.18l1.32,1.64l1.24,0.59l0.62,-0.01l1.61,-0.83l1.3,0.1l-0.89,1.0l-4.69,3.07l-6.35,2.82l-3.68,2.47l-2.15,2.49l-0.96,0.57l-6.62,8.67l-0.95,0.61l-1.07,1.56l-1.96,1.97l-4.18,3.55l-0.86,1.78l-0.55,0.44l-0.14,0.96l-0.78,-0.01l-0.46,0.51l0.98,12.22l-0.79,1.2l-1.04,0.08l-0.52,0.82l-0.83,0.15l-0.61,0.83l-2.06,1.19l-0.94,1.86l0.06,0.72l-1.69,2.39l-0.01,2.06l0.38,0.91l2.15,0.39l1.42,2.49l-0.52,1.92l-0.71,1.25l-0.05,2.12l0.45,1.32l-0.71,1.23l0.91,3.14l-0.51,4.08l3.95,3.03l3.02,0.4l1.89,2.25l2.87,0.5l2.45,1.93l2.39,3.59l2.63,1.8l2.09,0.09l1.07,0.71l0.88,0.1l0.82,1.36l1.26,0.84l0.28,2.03l0.68,1.3l0.39,4.82l-40.62,3.2l-40.63,2.09l-1.46,-38.98l-1.52,-2.05l-2.57,-0.79l-0.94,-1.91l-1.46,-1.79l0.21,-0.68l2.82,-2.34l0.93,-2.03l0.43,-2.53l-0.35,-1.58l0.23,-1.86l-0.18,-1.51l-0.5,-1.03l-0.18,-2.33l-1.81,-2.59l-0.47,-1.13l-0.21,-2.16l-0.66,-0.98l0.15,-1.66l-0.35,-1.52l0.53,-2.69l-1.08,-1.85l-0.49,-8.32l-0.42,-0.79l0.06,-3.92l-1.58,-3.95l-0.53,-0.65Z",name:"Minnesota"},"US-CA":{path:"M3.07,175.36l0.87,-1.1l0.96,0.24l1.21,-2.15l0.92,0.12l0.64,-0.23l0.41,-0.57l-0.27,-0.82l-0.71,-0.36l1.52,-2.68l0.12,-0.78l-0.43,-0.48l0.1,-1.34l0.85,-0.88l1.17,-2.25l1.26,-3.01l0.39,-2.1l-0.28,-1.0l0.05,-3.89l-1.25,-1.24l0.92,-1.24l0.94,-2.81l32.73,8.13l32.57,7.34l-13.67,64.67l25.44,34.66l36.59,51.09l13.3,17.72l-0.19,2.73l0.73,0.94l0.21,1.71l0.85,0.63l0.81,2.56l-0.07,0.91l0.63,1.46l-0.16,1.36l3.8,3.82l0.01,0.5l-1.95,1.53l-3.11,1.26l-1.2,1.99l-1.72,1.14l-0.33,0.81l0.38,1.03l-0.51,0.51l-0.1,0.9l0.08,2.29l-0.6,0.72l-0.64,2.44l-2.02,2.47l-1.6,0.14l-0.42,0.51l0.33,0.89l-0.59,1.34l0.54,1.11l-0.01,1.19l-0.78,2.68l0.57,1.02l2.74,1.13l0.34,0.83l-0.19,2.4l-1.18,0.78l-0.42,1.37l-2.27,-0.62l-1.26,0.61l-43.36,-3.35l0.04,-0.76l0.39,-0.07l0.3,-0.56l-0.12,-1.38l-1.1,-1.65l-1.08,0.02l0.16,-1.13l-0.24,-1.11l0.35,-0.13l0.36,-0.93l0.05,-2.47l-0.39,-2.64l-2.46,-5.66l-3.47,-4.07l-1.29,-1.98l-2.42,-2.12l-2.07,-2.86l-2.01,-1.04l-1.23,0.18l-0.29,0.88l-1.56,-0.95l-0.11,-0.38l0.63,-0.52l0.22,-0.95l-0.46,-2.65l-1.0,-1.95l-0.7,-0.58l-2.17,-0.43l-1.45,-0.13l-1.11,0.3l-0.49,-0.59l-1.66,-0.65l-3.05,-1.95l-1.24,-1.35l-0.54,-2.64l-0.89,-0.66l-1.77,-2.24l-1.66,-1.3l-1.92,-0.51l-1.09,0.24l-1.1,-0.72l-1.51,-0.14l-2.0,-1.52l-2.34,-0.84l-5.72,-0.67l-0.4,-1.69l-1.01,-0.93l-0.92,-0.35l1.28,-2.62l-0.33,-1.38l0.84,-2.21l-0.65,-1.27l1.18,-2.39l0.32,-2.41l-0.99,-1.24l-1.32,-0.26l-1.34,-1.39l-0.08,-0.75l1.44,-1.4l-0.5,-2.3l-0.34,-0.54l-1.68,-0.76l-1.88,-4.27l-1.79,-1.16l-0.32,-2.63l-1.62,-2.61l-0.22,-2.75l-1.01,-0.76l-1.13,-3.38l-2.16,-2.3l-0.75,-1.6l0.04,-3.93l0.55,-1.46l-0.54,-0.6l0.52,-0.53l0.56,0.71l0.58,-0.1l0.8,-0.59l0.9,-1.64l0.83,0.01l0.08,-0.52l-0.51,-0.5l0.4,-0.88l-0.05,-0.93l-0.49,-2.22l-0.61,-1.2l-0.6,-0.44l-0.92,0.25l-2.02,-0.43l-1.45,-1.81l-0.86,-2.15l-0.53,-0.38l-0.32,-1.18l-0.46,-0.5l0.04,-1.12l0.85,-2.26l-0.21,-2.94l-0.89,-1.29l1.1,-2.74l0.21,-2.34l1.33,-0.2l0.23,1.52l-0.62,0.31l-0.1,2.71l1.73,1.17l0.7,1.42l1.0,0.72l0.4,1.01l0.89,0.41l0.85,-0.4l-0.19,-1.18l-0.68,-0.51l-0.37,-1.53l0.13,-1.99l-0.54,-1.26l-0.37,-0.02l-0.11,-0.14l0.62,-0.35l-0.0,-0.34l-1.62,-1.2l0.69,-0.67l-0.17,-1.88l-0.94,-0.36l-0.3,-0.61l1.07,-0.66l0.99,-0.01l0.96,-0.71l1.25,1.03l2.63,-0.1l5.01,2.23l0.53,-0.22l0.04,-0.59l0.61,-0.67l-0.3,0.75l0.39,0.76l0.81,-0.06l0.35,-0.49l1.35,1.6l0.7,-0.16l0.02,-0.38l-0.53,-1.14l-0.97,-0.74l-0.27,-0.8l-0.66,-0.38l-1.09,-0.07l0.27,-0.58l-0.25,-0.54l-2.48,1.29l-0.7,-0.34l-0.75,0.18l-0.18,-0.55l-1.09,-0.25l0.28,-0.66l-0.36,-0.69l-1.09,-0.17l-1.86,1.57l-0.34,-0.46l-1.36,-0.54l-0.36,-0.88l-1.36,-1.35l-2.59,0.52l0.1,0.92l-0.7,1.21l0.53,0.72l-0.88,0.92l-0.07,2.28l-0.37,-0.09l-1.52,-2.07l-1.18,-0.34l-1.16,-2.44l-1.41,-1.2l0.09,-0.69l-0.68,-0.18l0.73,-1.18l0.93,2.05l0.44,0.25l0.33,-0.38l-1.77,-5.65l-0.41,-0.59l-0.57,-0.2l0.2,-0.84l-0.53,-2.28l-2.72,-3.32l-1.0,-2.99l-3.45,-6.17l-0.03,-0.38l1.14,-1.43l0.12,-0.85l-0.51,-6.75l0.61,-1.87l1.33,-2.02l0.4,-3.04l-0.36,-1.21l0.19,-2.39l-0.7,-1.04l-1.24,-3.68l-0.57,-0.53l0.1,-0.93l-0.32,-0.88l-1.04,-0.88l-2.01,-3.32l0.52,-1.23l-0.26,-2.71l2.38,-3.44ZM33.36,240.61l0.01,-0.01l0.01,0.01l-0.02,-0.01ZM45.67,326.22l-0.02,0.03l0.02,-0.03l0.01,0.01ZM31.63,240.38l-0.09,0.14l-0.63,0.23l-0.2,-0.07l0.92,-0.3Z",name:"California"},"US-IA":{path:"M452.94,162.22l42.82,-2.19l40.55,-3.19l0.96,2.52l2.0,1.0l0.08,0.59l-0.9,1.8l-0.16,1.04l0.9,5.09l0.92,1.26l0.39,1.75l1.46,1.72l4.94,0.85l1.27,2.03l-0.3,1.03l0.29,0.66l3.61,2.37l0.85,2.41l3.84,2.31l0.62,1.68l-0.31,4.21l-1.64,1.98l-0.5,1.94l0.13,1.28l-1.26,1.36l-2.51,0.97l-0.89,1.18l-0.55,0.25l-4.56,0.83l-0.89,0.73l-0.61,1.71l-0.15,2.55l0.4,1.08l2.01,1.47l0.54,2.65l-1.87,3.25l-0.22,2.24l-0.52,1.42l-2.88,1.39l-1.02,1.02l-0.2,0.99l0.72,0.87l0.2,2.15l-0.58,0.23l-1.34,-0.82l-0.31,-0.76l-1.29,-0.82l-0.29,-0.51l-0.88,-0.36l-0.3,-0.82l-0.95,-0.68l-22.3,2.61l-15.12,1.17l-7.59,0.51l-20.78,0.47l-0.22,-1.06l-1.3,-0.73l-0.33,-0.67l0.58,-1.16l-0.21,-0.95l0.22,-1.39l-0.36,-2.19l-0.6,-0.73l0.07,-3.65l-1.05,-0.5l0.05,-0.91l0.71,-1.02l-0.05,-0.44l-1.31,-0.56l0.33,-2.54l-0.41,-0.45l-0.89,-0.16l0.23,-0.8l-0.3,-0.58l-0.51,-0.25l-0.74,0.23l-0.42,-2.81l0.5,-2.36l-0.2,-0.67l-1.36,-1.71l-0.08,-1.92l-1.78,-1.54l-0.36,-1.74l-1.09,-0.94l0.03,-2.18l-1.1,-1.87l0.21,-1.7l-0.27,-1.08l-1.38,-0.67l-0.87,-2.17l0.05,-0.63l-1.81,-1.82l0.56,-1.61l0.54,-0.47l0.73,-2.68l0.0,-1.68l0.55,-0.69l0.21,-1.19l-0.51,-2.24l-1.33,-0.29l-0.05,-0.73l0.45,-0.56l-0.0,-1.71l-0.95,-1.42l-0.05,-0.87Z",name:"Iowa"},"US-MI":{path:"M612.25,185.8l1.83,-2.17l0.7,-1.59l1.18,-4.4l1.43,-3.05l1.01,-5.05l0.09,-5.37l-0.86,-5.54l-2.4,-5.17l0.6,-0.5l0.3,-0.79l-0.57,-0.42l-1.08,0.55l-3.82,-7.03l-0.21,-1.1l1.13,-2.68l-0.01,-0.97l-0.74,-3.13l-1.29,-1.65l-0.05,-0.62l1.73,-2.73l1.22,-4.14l-0.21,-5.35l-0.77,-1.59l1.09,-1.15l0.81,-0.02l0.56,-0.47l-0.27,-3.49l1.08,-0.11l0.67,-1.43l1.18,0.47l0.66,-0.33l0.76,-2.59l0.82,-1.2l0.56,-1.68l0.55,-0.18l-0.58,0.87l0.6,1.65l-0.71,1.8l0.71,0.42l-0.48,2.61l0.88,1.43l0.73,-0.05l0.52,0.56l0.64,-0.24l0.89,-2.26l0.67,-3.51l-0.08,-2.07l-0.76,-3.42l0.58,-1.02l2.13,-1.64l2.74,-0.55l0.98,-0.63l0.28,-0.64l-0.25,-0.54l-1.76,-0.11l-0.96,-0.86l-0.52,-1.98l1.85,-2.98l-0.1,-0.73l1.72,-0.23l0.74,-0.94l4.16,2.0l0.83,0.12l1.98,-0.4l1.37,0.4l1.19,1.04l0.53,1.15l0.77,0.49l2.41,-0.29l1.7,1.01l1.92,0.09l0.8,0.64l3.27,0.45l1.1,0.77l-0.01,1.12l1.04,1.31l0.64,0.21l0.37,0.91l-0.14,0.55l-0.67,-0.25l-0.94,0.57l-0.23,1.83l0.81,1.29l1.6,0.98l0.69,1.37l0.65,2.26l-0.12,1.73l0.77,5.57l-0.14,0.59l-0.58,0.21l-0.48,0.96l-0.74,0.07l-0.8,0.81l-0.17,4.47l-1.12,0.49l-0.18,0.82l-1.86,0.43l-0.72,0.6l-0.58,2.61l0.26,0.45l-0.21,0.52l0.25,2.57l1.38,1.31l2.89,0.84l0.91,-0.08l1.08,-1.23l0.6,-1.44l0.62,0.19l0.39,-0.24l1.01,-3.59l0.6,-1.06l-0.08,-0.51l0.97,-1.45l1.39,-0.39l1.07,-0.69l0.83,-1.1l0.87,-0.44l2.06,0.59l1.13,0.7l1.0,1.09l1.21,2.16l2.01,5.91l0.82,1.6l1.03,3.71l1.49,3.63l1.29,1.74l-0.34,3.92l0.45,2.48l-0.48,2.79l-0.36,0.45l-0.57,-1.21l0.03,-0.85l-1.46,-0.52l-0.47,0.08l-1.48,1.36l-0.06,0.83l0.55,0.67l-0.82,0.57l-0.29,0.79l0.28,2.94l-0.48,0.75l-1.62,0.92l-1.06,1.85l-0.43,3.73l0.27,1.56l-0.33,0.93l-0.42,0.19l0.02,0.91l-0.64,0.3l-0.89,1.6l-0.5,1.29l-0.02,1.05l-0.52,0.91l-20.5,4.22l-0.15,-0.92l-0.45,-0.33l-31.44,4.71ZM621.47,115.84l0.0,-0.07l0.11,-0.12l-0.01,0.03l-0.11,0.16ZM621.73,114.93l-0.07,-0.16l0.07,-0.14l-0.0,0.3ZM543.5,88.02l4.87,-2.38l3.55,-3.62l5.77,-1.36l1.39,-0.84l2.36,-2.71l0.98,0.04l1.52,-0.73l1.0,-2.24l2.82,-2.85l0.23,1.72l1.85,0.59l0.05,1.44l0.67,0.14l0.51,0.6l-0.17,3.14l0.44,0.95l-0.34,0.47l0.2,0.47l0.74,-0.02l1.08,-2.21l1.08,-0.89l-0.42,1.15l0.58,0.45l0.83,-0.67l0.52,-1.22l1.0,-0.43l3.09,-0.25l1.5,0.21l1.18,0.93l1.54,0.44l0.47,1.05l2.31,2.58l1.17,0.55l0.53,1.55l0.73,0.34l1.87,0.07l0.73,-0.4l1.06,-0.06l1.4,-1.09l1.0,1.11l1.1,0.64l1.01,-0.25l0.68,-0.82l1.87,1.06l0.64,-0.34l1.65,-2.58l2.81,-1.89l1.7,-1.65l0.92,0.11l3.27,-1.21l5.17,-0.25l3.25,-2.09l2.28,-0.88l1.52,-0.11l-0.01,3.24l0.29,0.71l-0.36,1.1l0.46,0.7l0.68,0.28l0.91,-0.41l2.2,0.7l1.14,-0.43l1.03,-0.87l0.66,0.48l0.21,0.7l0.85,0.22l1.22,-0.76l0.79,-1.57l0.69,-0.28l1.06,0.23l1.35,-1.15l0.53,-0.01l0.22,0.08l-0.3,2.02l0.75,1.32l-1.11,-0.04l-0.36,0.5l0.84,1.83l-0.87,1.04l0.12,0.45l0.83,0.79l1.37,-0.42l0.6,0.47l0.62,0.04l0.18,1.19l0.98,0.87l1.53,0.51l-1.17,0.68l-4.96,-0.15l-0.53,0.3l-1.35,-0.17l-0.88,0.41l-0.66,-0.75l-1.63,-0.07l-0.59,0.47l-0.07,1.22l-0.49,0.76l0.38,2.05l-0.92,-0.22l-0.89,-0.92l-0.77,-0.13l-1.96,-1.65l-2.41,-0.6l-1.6,0.04l-1.04,-0.5l-2.89,0.47l-0.61,0.45l-1.18,2.52l-3.47,0.73l-0.57,0.77l-2.06,-0.33l-2.82,0.93l-0.68,0.83l-0.56,2.51l-0.78,0.28l-0.81,0.87l-0.65,0.28l0.16,-1.95l-0.74,-0.91l-1.02,0.34l-0.77,0.92l-0.97,-0.39l-0.68,0.17l-0.37,0.4l0.1,0.82l-0.73,2.01l-1.2,0.59l-0.1,-1.37l-0.46,-1.06l0.34,-1.69l-0.17,-0.37l-0.66,-0.17l-0.45,0.57l-0.6,2.13l-0.22,2.57l-1.12,0.91l-1.26,3.03l-0.62,2.65l-2.55,5.33l-0.69,0.73l0.12,0.91l-1.4,-1.28l0.18,-1.74l0.63,-1.69l-0.41,-0.81l-0.62,-0.31l-1.36,0.85l-1.16,0.1l0.04,-1.29l0.81,-1.45l-0.41,-1.34l0.3,-1.09l-0.58,-0.98l0.15,-0.83l-1.9,-1.55l-1.1,-0.06l-0.59,-0.44l-1.48,-0.0l0.3,-1.36l-0.94,-1.45l-1.13,-0.51l-2.23,-0.1l-3.2,-0.71l-1.55,0.59l-1.43,-0.42l-1.62,0.17l-4.56,-1.94l-15.37,-2.5l-1.99,-3.39l-1.88,-0.96l-0.76,0.26l-0.1,-0.29ZM603.39,98.63l-0.0,0.52l-0.46,0.32l-0.7,1.39l0.08,0.57l-0.65,-0.58l0.91,-2.15l0.83,-0.06ZM570.53,72.73l-0.51,-0.27l-1.16,0.06l-0.04,-1.56l1.0,-1.02l1.18,-2.09l1.83,-1.5l0.63,-0.0l0.53,-0.58l2.08,-0.89l3.34,-0.42l1.1,0.66l-0.54,0.38l-1.32,-0.12l-2.26,0.78l0.15,0.87l0.71,0.13l-1.19,0.98l-1.4,1.89l-0.69,0.28l-0.36,1.45l-1.15,1.36l-0.66,2.04l-0.67,-0.87l0.75,-0.97l0.14,-1.95l-0.84,-0.23l-0.6,0.92l-0.05,0.67Z",name:"Michigan"},"US-GA":{path:"M654.05,331.64l22.02,-3.57l20.65,-3.86l-0.07,0.58l-2.59,3.35l-0.41,1.73l0.11,1.23l0.82,0.78l1.84,0.8l1.03,0.12l2.7,2.03l0.84,0.24l1.9,-0.37l0.6,0.25l0.8,1.64l1.51,1.6l1.04,2.5l1.33,0.82l0.84,1.16l0.56,0.26l1.0,1.77l1.07,0.3l1.17,0.99l3.81,1.85l2.41,3.16l2.25,0.58l2.53,1.67l0.5,2.34l1.25,1.01l0.47,-0.16l0.31,0.49l-0.1,0.62l0.79,0.73l0.79,0.09l0.56,1.2l4.99,1.88l0.4,1.78l1.54,1.73l1.02,2.01l-0.07,0.8l0.48,0.69l0.11,1.24l1.04,0.79l1.16,0.17l1.25,0.62l0.28,0.53l0.57,0.23l1.12,2.56l0.76,0.57l0.08,2.68l0.77,1.48l1.38,0.9l1.52,-0.27l1.44,0.76l1.45,0.12l-0.59,0.78l-0.55,-0.35l-0.47,0.28l-0.4,0.99l0.62,0.91l-0.38,0.48l-1.38,-0.16l-0.77,-0.55l-0.65,0.44l0.26,0.71l-0.49,0.52l0.36,0.6l1.44,0.25l-0.58,1.35l-1.43,0.27l-1.08,-0.44l-0.6,0.21l0.03,0.82l1.45,0.6l-1.76,3.73l0.36,1.73l-0.48,0.97l0.85,1.48l-2.29,-0.19l-0.46,0.29l0.06,0.63l0.55,0.34l2.76,0.24l1.07,0.66l-0.02,0.34l-0.56,0.22l-0.88,1.95l-0.5,-1.41l-0.45,-0.13l-0.6,0.33l-0.15,0.84l0.34,0.96l-0.6,0.12l-0.03,0.84l-0.3,0.16l0.07,0.46l1.34,1.15l-1.09,1.03l0.32,0.47l0.77,0.08l-0.39,0.92l0.06,0.88l-0.46,0.51l1.1,1.66l0.03,0.76l-0.79,0.33l-2.64,-0.17l-4.06,-0.96l-1.31,0.35l-0.18,0.74l-0.68,0.26l-0.35,1.25l0.28,2.08l0.95,1.36l0.13,4.25l-1.97,0.4l-0.54,-0.92l-0.12,-1.3l-1.33,-1.82l-49.21,5.14l-0.72,-0.56l-0.86,-2.7l-0.94,-1.51l-0.56,-0.38l0.16,-0.68l-0.73,-1.51l-1.82,-1.81l-0.43,-1.75l0.25,-0.8l0.06,-5.18l-0.6,-1.81l-1.19,-1.47l-1.03,-2.65l0.12,-1.65l0.78,-2.36l-0.25,-1.53l0.19,-2.11l1.62,-1.33l0.46,-1.47l-0.55,-0.61l-1.42,-0.69l0.09,-2.15l-0.97,-1.87l-2.18,-2.42l-1.03,-2.81l-0.75,-0.68l-0.17,-0.96l-0.77,-1.37l-13.99,-43.11Z",name:"Georgia"},"US-AZ":{path:"M128.51,384.14l0.44,-1.81l1.29,-1.29l0.53,-1.12l0.48,-0.25l1.66,0.62l0.96,-0.03l0.52,-0.46l0.28,-1.17l1.31,-1.0l0.24,-2.73l-0.46,-1.24l-0.84,-0.66l-2.07,-0.66l-0.3,-0.61l0.8,-2.4l0.0,-1.39l-0.52,-1.19l0.57,-0.86l-0.2,-0.87l1.57,-0.27l2.29,-2.81l0.65,-2.43l0.65,-0.81l0.02,-3.17l0.55,-0.62l-0.29,-1.43l1.71,-1.14l1.03,-1.85l3.16,-1.29l2.03,-1.58l0.26,-0.53l-0.13,-1.04l-3.25,-3.49l-0.51,-0.22l0.22,-1.26l-0.66,-1.46l0.07,-0.91l-0.88,-2.76l-0.84,-0.56l-0.19,-1.65l-0.69,-0.8l0.19,-3.54l0.58,-0.87l-0.3,-0.86l1.03,-0.4l0.4,-1.42l0.14,-3.2l-0.76,-3.66l0.76,-2.55l-0.4,-3.0l0.85,-2.56l-0.8,-1.87l-0.03,-0.92l0.78,-1.88l2.54,-0.63l1.75,0.99l1.43,-0.19l0.96,2.24l0.79,0.71l1.54,0.14l1.01,-0.5l1.02,-2.27l0.94,-1.19l2.57,-16.94l42.42,5.78l42.56,4.67l-11.82,123.64l-36.87,-4.05l-36.33,-18.97l-28.43,-15.56Z",name:"Arizona"},"US-MT":{path:"M166.39,57.3l0.69,-0.1l0.33,-0.38l-0.9,-1.99l0.83,-0.96l-0.39,-1.3l0.09,-0.96l-1.24,-1.93l-0.24,-1.49l-1.03,-1.33l-1.19,-2.44l3.53,-20.64l43.67,6.71l43.04,5.23l42.75,3.84l43.13,2.53l-3.53,86.04l-28.1,-1.47l-26.82,-1.91l-26.78,-2.4l-25.83,-2.79l-0.44,0.35l-1.22,10.41l-1.51,-2.01l-0.03,-0.91l-1.18,-2.35l-1.25,-0.74l-1.8,0.92l0.03,1.05l-0.72,0.42l-0.34,1.56l-2.42,-0.41l-1.91,0.57l-0.92,-0.85l-3.36,0.09l-2.38,-0.96l-1.68,0.58l-0.84,1.49l-4.66,-1.6l-1.3,0.37l-1.12,0.9l-0.31,0.67l-1.65,-1.4l0.22,-1.43l-0.9,-1.71l0.4,-0.36l0.07,-0.62l-1.17,-3.08l-1.45,-1.25l-1.44,0.36l-0.21,-0.64l-1.08,-0.9l-0.41,-1.37l0.68,-0.61l0.2,-1.41l-0.77,-2.38l-0.77,-0.35l-0.31,-1.58l-1.51,-2.54l0.23,-1.51l-0.56,-1.26l0.34,-1.4l-0.73,-0.86l0.48,-0.98l-0.21,-0.74l-1.14,-0.75l-0.13,-0.59l-0.85,-0.91l-0.8,-0.4l-0.51,0.37l-0.07,0.74l-0.7,0.27l-1.13,1.22l-1.75,0.37l-1.21,1.07l-1.08,-0.85l-0.64,-1.01l-1.06,-0.44l0.02,-0.86l0.74,-0.63l0.24,-1.06l-0.61,-1.6l0.9,-1.09l1.07,-0.08l0.83,-0.8l-0.26,-1.14l0.38,-1.07l-0.95,-0.81l-0.04,-0.81l0.66,-1.28l-0.59,-1.07l0.74,-0.07l0.38,-0.42l-0.04,-1.77l1.83,-3.73l-0.14,-1.05l0.89,-0.62l0.6,-3.16l-0.78,-0.5l-1.8,0.37l-1.33,-0.11l-0.64,-0.55l0.37,-0.83l-0.62,-0.97l-0.66,-0.23l-0.72,0.35l-0.07,-0.95l-1.74,-1.62l0.04,-1.84l-1.68,-1.82l-0.08,-0.69l-1.55,-2.88l-1.07,-1.29l-0.57,-1.63l-2.35,-1.34l-0.95,-1.95l-1.43,-1.19Z",name:"Montana"},"US-MS":{path:"M555.51,431.02l0.67,-0.97l-1.05,-1.76l0.18,-1.63l-0.81,-0.87l1.69,-0.25l0.47,-0.54l0.4,-2.74l-0.77,-1.82l1.56,-1.79l0.25,-3.58l0.74,-2.26l1.89,-1.25l1.15,-1.97l1.4,-1.04l0.34,-0.78l-0.04,-0.99l-0.63,-0.96l1.14,-0.28l0.96,-2.58l0.91,-1.31l-0.16,-0.86l-1.54,-0.43l-0.35,-0.96l-1.83,-1.04l-0.07,-2.14l-0.93,-0.74l-0.45,-0.84l-0.02,-0.37l1.14,-0.29l0.46,-0.69l-0.26,-0.89l-1.41,-0.49l0.23,-1.77l0.98,-1.54l-0.77,-1.06l-1.08,-0.31l-0.15,-2.82l0.9,-0.54l0.23,-0.8l-0.62,-2.52l-1.25,-0.66l0.7,-1.33l-0.07,-2.22l-2.02,-1.52l1.13,-0.47l0.12,-1.41l-1.34,-0.89l1.58,-2.04l0.93,-0.31l0.36,-0.69l-0.52,-1.56l0.42,-1.35l-0.9,-0.89l2.84,-1.1l0.59,-0.76l-0.09,-1.07l-1.41,-0.95l1.39,-1.08l0.62,-1.77l0.94,-0.17l0.34,-0.97l-0.2,-0.77l1.48,-0.43l1.22,-1.21l0.07,-3.53l-0.46,-1.53l0.36,-1.78l0.73,0.09l0.68,-0.33l0.42,-0.87l-0.41,-1.06l2.72,-1.71l0.58,-1.06l-0.29,-1.28l36.44,-4.1l0.86,1.26l0.85,0.45l0.99,66.49l5.52,32.95l-0.73,0.69l-1.53,-0.3l-0.9,-0.94l-1.32,1.06l-1.23,0.17l-2.17,-1.26l-1.85,-0.19l-0.83,0.36l-0.34,0.44l0.32,0.41l-0.56,0.36l-3.96,1.66l-0.05,-0.5l-0.96,-0.52l-1.0,0.05l-0.58,1.0l0.76,0.61l-1.59,1.21l-0.33,1.28l-0.69,0.3l-1.33,-0.06l-1.16,-1.86l-0.08,-0.89l-0.92,-1.47l-0.21,-1.0l-1.4,-1.63l-1.16,-0.54l-0.47,-0.77l0.1,-0.62l-0.69,-0.92l0.21,-1.99l0.5,-0.93l0.66,-2.98l-0.06,-1.22l-0.43,-0.29l-34.66,3.41Z",name:"Mississippi"},"US-SC":{path:"M697.55,324.05l4.86,-2.69l1.02,-0.05l1.11,-1.38l3.93,-1.9l0.45,-0.88l0.63,0.22l22.71,-3.36l0.07,1.22l0.42,0.57l0.71,0.01l1.21,-1.3l2.82,2.54l0.46,2.48l0.55,0.52l19.74,-3.49l22.74,15.07l0.02,0.55l-2.48,2.18l-2.44,3.67l-2.41,5.72l-0.09,2.74l-1.08,-0.21l0.85,-2.72l-0.63,-0.23l-0.76,0.87l-0.56,1.38l-0.11,1.55l0.83,0.95l1.05,0.23l0.44,0.91l-0.75,0.08l-0.41,0.56l-0.87,0.02l-0.24,0.68l0.94,0.45l-1.1,1.13l-0.07,1.02l-1.34,0.63l-0.5,-0.61l-0.5,-0.08l-1.06,0.87l-0.56,1.77l0.43,0.87l-1.19,1.23l-0.61,1.44l-1.2,1.01l-0.9,-0.4l0.27,-0.6l-0.53,-0.74l-1.37,0.31l0.25,1.2l-0.52,0.03l0.05,0.76l2.02,1.01l-0.12,0.39l-0.88,0.94l-1.22,0.23l-0.24,0.51l0.33,0.45l-2.29,1.34l-1.42,-0.84l-0.56,0.11l-0.1,0.67l1.19,0.78l-1.54,1.57l-0.72,-0.75l-0.5,0.52l-0.0,0.74l-1.54,-0.37l-1.34,-0.84l-0.44,0.5l0.16,0.53l-1.73,0.17l-0.44,0.37l-0.06,0.78l2.07,0.05l-0.26,0.55l0.42,0.25l1.91,-0.15l0.11,0.22l-0.97,0.86l-0.32,0.78l0.57,0.49l0.94,-0.53l0.03,0.21l-1.12,1.09l-0.99,0.43l-0.21,-2.04l-0.69,-0.27l-0.22,-1.54l-0.88,-0.15l-0.3,0.58l0.86,2.69l-1.12,-0.66l-0.63,-1.0l-0.39,-1.76l-0.65,-0.21l-0.52,-0.63l-0.69,0.0l-0.27,0.6l0.84,1.02l0.01,0.68l1.11,1.83l-0.02,0.86l1.22,1.17l-0.62,0.35l0.03,0.98l-1.2,3.56l-1.51,-0.78l-1.52,0.26l-0.97,-0.68l-0.54,-1.03l-0.17,-2.93l-0.86,-0.75l-1.06,-2.47l-1.04,-0.95l-3.23,-1.33l-0.49,-2.65l-1.12,-2.17l-1.43,-1.58l-0.06,-1.07l-0.76,-1.21l-4.81,-1.69l-0.58,-1.27l-1.21,-0.37l0.02,-0.7l-0.53,-0.87l-0.87,0.0l-0.73,-0.61l0.03,-1.21l-0.66,-1.26l-2.7,-1.78l-2.16,-0.52l-2.36,-3.12l-3.93,-1.93l-1.22,-1.03l-0.83,-0.12l-1.04,-1.81l-0.51,-0.22l-0.91,-1.21l-1.18,-0.68l-0.99,-2.42l-1.54,-1.65l-1.02,-1.87l-1.06,-0.37l-1.93,0.37l-0.46,-0.16l-2.75,-2.19l-1.06,0.02l-2.23,-1.27l0.36,-2.22l2.6,-3.31l0.15,-1.07ZM750.36,375.19l0.73,-0.08l0.51,0.45l-1.23,1.9l0.28,-1.22l-0.3,-1.06Z",name:"South Carolina"},"US-RI":{path:"M851.1,141.46l0.22,-0.46l-0.53,-2.22l-3.14,-10.0l5.61,-1.84l0.76,2.06l0.8,0.25l0.19,0.73l0.08,0.42l-0.77,0.25l0.03,0.29l0.51,1.45l0.59,0.5l-0.75,0.28l-0.3,0.6l0.87,0.97l-0.14,1.23l0.89,1.9l0.03,1.67l-0.27,0.71l-0.9,0.16l-3.59,2.35l-0.18,-1.31ZM855.89,131.53l0.26,0.1l0.01,0.1l-0.17,-0.08l-0.1,-0.12ZM857.28,132.21l0.25,0.54l-0.05,0.32l-0.15,0.01l-0.05,-0.87Z",name:"Rhode Island"},"US-AR":{path:"M498.76,376.91l-1.42,-38.01l-4.48,-23.98l37.68,-2.58l39.02,-3.58l0.8,1.6l1.01,0.7l0.11,1.77l-0.77,0.57l-0.22,0.94l-1.42,0.93l-0.29,1.04l-0.83,0.54l-1.19,2.59l0.02,0.7l0.53,0.26l10.94,-1.46l0.86,0.93l-1.18,0.37l-0.52,0.96l0.25,0.49l0.84,0.41l-3.6,2.7l0.02,0.84l0.83,1.04l-0.6,1.15l0.62,0.97l-1.42,0.74l-0.11,1.44l-1.45,2.09l0.12,1.64l0.91,3.1l-0.15,0.27l-1.08,-0.01l-0.33,0.26l-0.51,1.73l-1.52,0.95l-0.04,0.51l0.79,0.91l0.05,0.65l-1.11,1.21l-2.02,1.13l-0.21,0.62l0.43,1.0l-0.19,0.27l-1.23,0.03l-0.42,0.67l-0.32,1.89l0.47,1.57l0.02,3.08l-1.27,1.09l-1.54,0.13l0.23,1.49l-0.21,0.48l-0.93,0.25l-0.59,1.77l-1.49,1.19l-0.02,0.93l1.39,0.76l-0.03,0.7l-1.23,0.3l-2.24,1.23l0.03,0.67l0.99,0.82l-0.45,1.14l0.53,1.38l-1.09,0.62l-1.9,2.57l0.52,0.7l1.0,0.49l0.01,0.58l-0.98,0.29l-0.42,0.64l0.51,0.84l1.63,1.01l0.06,1.77l-0.59,0.98l-0.09,0.84l1.34,0.79l0.5,2.17l-1.09,1.01l0.06,2.11l-51.45,4.07l-0.83,-11.53l-1.18,-0.85l-0.9,0.16l-0.83,-0.35l-0.93,0.39l-1.22,-0.33l-0.57,0.72l-0.47,0.01l-0.49,-0.48l-0.82,-0.15l-0.63,-1.0Z",name:"Arkansas"}},height:612.395412685768,projection:{type:"aea",centralMeridian:-100},width:900})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","vietnam",{width:"210",height:"297",paths:{1:{name:"An Giang",path:"m70.81 255.70l0.57 -0.74c0.38 0.04 0.38 0.07 0.64 -0.26c0.25 -0.31 0.38 -0.03 0.51 0.01c-0.30 0.59 1.56 0.12 1.80 0.00c0.17 -0.08 -0.02 -0.34 0.04 -0.48c0.09 -0.24 0.38 -0.07 0.58 -0.14c0.12 -0.04 0.44 -0.34 0.57 -0.48l0.15 -0.14l0.00 0.00c0.00 -0.21 -0.06 -0.37 0.14 -0.51c0.20 -0.13 0.34 -0.08 0.30 -0.39c-0.02 -0.20 0.02 -0.24 0.19 -0.35c0.19 -0.11 0.17 -0.32 0.25 -0.50c0.12 -0.25 0.55 0.08 0.55 -0.43c0.05 -0.43 -0.25 -0.97 -0.58 -1.23c-0.57 -0.44 -0.78 -0.39 -1.50 -0.42c-0.60 -0.02 -0.71 -0.33 -1.19 -0.48c-0.72 -0.23 -0.60 -1.21 -0.85 -1.74c0.02 -0.19 0.33 -0.86 0.02 -0.95c-0.22 -0.06 -1.30 0.27 -0.82 -0.38c0.23 -0.31 0.30 -0.39 -0.18 -0.47c-0.50 -0.07 -0.10 -0.44 -0.48 -0.61c-0.18 -0.08 -0.35 0.02 -0.38 -0.23c-0.03 -0.27 -0.32 -0.25 -0.42 -0.48l-0.22 -0.71l0.00 0.00c-0.85 -0.11 -1.66 -0.20 -1.80 -0.43c-0.19 -0.31 0.28 -0.57 -0.32 -0.57l-0.47 0.35c0.08 0.23 0.00 0.48 -0.12 0.76c-0.24 0.55 0.24 1.62 0.69 1.92c0.18 0.12 0.27 0.32 0.33 0.53l-0.49 0.48c-0.34 0.42 -0.59 0.52 -1.02 0.74c-0.43 0.21 -1.05 0.73 -1.33 1.10c-0.61 0.49 -0.91 1.92 -1.74 1.98c-0.32 0.02 -0.66 -0.00 -1.00 -0.06l0.00 0.00l0.11 0.44l1.30 2.16l2.60 0.55l1.94 1.34l1.37 1.16l0.25 -0.35l0.00 0.00z"},2:{name:"B\xe0 R\u1ecba - V\u0169ng T\xe0u",path:"m110.30 245.89l0.01 0.49c0.19 0.15 0.46 0.36 0.54 0.60c0.14 0.45 0.15 0.79 0.40 1.22c0.22 0.38 0.35 0.92 0.35 1.36l0.00 0.00c-0.66 0.52 -1.11 1.28 -1.52 1.28c-0.61 0.00 -1.01 0.49 -1.32 0.43c-0.51 -0.10 -0.78 0.08 -1.33 0.12c-0.36 0.03 -0.55 0.51 -0.75 0.54l-0.05 0.13c-0.40 0.10 -0.64 1.06 -1.04 0.84c-0.54 -0.30 -0.21 -0.52 -1.01 -0.21c-0.65 0.25 -1.78 1.89 -2.10 0.69c-0.15 -0.56 -0.57 -0.73 0.33 -1.03c0.00 -0.20 -0.58 -0.63 -0.76 -0.81c-0.38 -0.38 0.10 -0.87 -0.04 -1.28l0.00 0.00c0.00 -0.09 -0.13 -0.34 -0.15 -0.42c-0.02 -0.10 -0.08 -0.16 -0.11 -0.25c-0.09 -0.23 0.28 -0.37 0.18 -0.64l-0.43 -0.30l0.00 0.00c0.17 -0.59 -0.08 -0.44 0.57 -0.69c0.77 -0.30 1.54 0.20 1.76 -0.93c0.04 -0.20 -0.02 -0.79 0.28 -0.79c0.29 0.00 0.38 -0.33 0.64 -0.33c0.24 0.37 1.28 0.27 1.72 0.25c0.73 -0.04 -0.13 1.70 0.80 1.37c0.29 -0.09 0.39 -0.60 0.55 -0.86c0.11 -0.17 0.41 -0.58 0.57 -0.68c0.20 -0.12 0.41 -0.22 0.57 -0.41c0.59 -0.75 0.72 0.19 1.37 0.32l0.00 0.00z"},3:{name:"B\u1ea1c Li\xeau",path:"m73.38 266.59c0.25 -0.05 0.66 -0.01 0.85 -0.16c0.02 0.02 0.54 0.08 0.57 0.08c0.04 0.13 0.64 0.19 0.79 0.19c0.38 0.00 0.66 -0.27 1.01 -0.35l0.00 0.00l-0.11 2.47c0.02 0.01 0.01 0.01 0.01 0.04c0.21 0.07 0.11 0.74 0.64 0.74c0.36 0.00 0.45 -0.24 0.77 0.08c0.29 0.29 0.35 0.05 0.63 0.18c0.22 0.10 0.35 0.39 0.62 0.43c0.25 0.04 0.38 -0.17 0.57 -0.31c0.15 -0.11 0.91 -0.19 1.04 -0.07c0.17 0.15 0.08 0.67 0.46 0.32c0.35 -0.32 0.87 -0.09 0.64 0.36c-0.09 0.19 -0.38 0.11 -0.51 0.21c-0.25 0.19 -0.07 0.29 -0.18 0.54l0.17 1.30l0.00 0.00c-1.25 0.44 -2.45 0.93 -3.65 1.62c-1.74 0.87 -2.59 1.14 -3.34 2.22l0.00 0.00c-0.24 -0.41 -0.82 -0.81 -1.32 -0.69c-0.72 0.17 -0.66 -0.40 -1.16 -0.53c-0.34 -0.09 -0.56 0.02 -0.56 -0.45l-0.01 -1.17c-0.69 -0.69 0.18 -0.93 0.61 -1.41c0.45 -0.50 -0.73 -0.68 -0.49 -1.36c0.13 -0.35 0.46 -0.46 0.68 -0.75l0.00 0.00l0.38 -0.12l-0.45 -1.05c0.00 -0.60 0.12 -0.79 0.52 -1.19c0.37 -0.37 -0.33 -0.91 -0.50 -1.24c-0.07 -0.15 -0.13 -0.78 0.14 -0.61c0.33 0.21 0.34 0.30 0.76 0.36c0.05 0.01 0.15 0.11 0.15 0.11c0.02 0.10 0.14 0.17 0.24 0.20l0.00 0.00z"},4:{name:"B\u1eafc K\u1ea1n",path:"m75.98 31.35c0.00 0.03 0.02 0.17 -0.01 0.19c0.01 0.03 0.06 0.18 0.06 0.20c0.47 0.16 1.06 1.41 1.06 1.91c-0.02 0.01 -0.02 0.02 -0.02 0.05c-0.02 0.01 -0.01 -0.00 -0.01 0.02c-0.95 0.32 -0.32 1.30 -0.58 1.68c-0.16 0.23 -0.55 -0.09 -0.75 0.47c-0.10 0.29 0.02 0.58 -0.06 0.88c-0.50 0.10 -0.43 0.81 -0.51 1.15c-1.12 0.22 -0.73 0.99 -0.46 1.73c0.17 0.33 0.18 0.39 0.54 0.48c0.00 0.38 -0.35 0.61 -0.32 1.05c0.02 0.29 0.13 0.43 0.06 0.74c-0.13 0.56 0.28 0.71 0.46 1.12c0.08 0.18 0.22 0.37 0.33 0.51c0.07 0.09 0.51 0.44 0.52 0.49l0.00 0.00c0.80 -0.43 0.62 -1.05 1.57 -1.22c0.96 -0.16 0.45 -0.89 1.50 -0.05c0.60 0.48 0.67 0.01 0.67 0.95c0.00 0.74 0.21 1.20 0.07 2.04c-0.13 0.77 0.28 1.54 0.86 0.49c0.33 -0.60 0.82 -0.35 1.31 -0.72c0.49 -0.37 1.49 -1.34 1.99 -1.27c0.35 0.05 0.23 -0.53 0.74 -0.36c0.37 0.13 0.55 0.22 0.97 0.27l0.00 0.00l0.14 -0.30c0.44 -0.73 -1.05 -2.35 0.51 -2.35c0.44 0.00 1.65 -1.87 1.61 -1.98c-0.26 -0.67 0.49 -1.20 0.01 -1.67c0.03 -0.01 -0.22 -0.24 -0.30 -0.30c-0.13 -0.09 -0.28 -0.18 -0.30 -0.36c-0.04 -0.39 0.41 -0.44 0.23 -0.92l-0.50 -0.54l0.00 0.00c-0.06 -0.06 -0.29 -0.14 -0.29 -0.23c-0.36 -0.12 -0.76 0.34 -1.14 0.06c-0.30 -0.22 -0.06 -0.95 0.01 -1.23c0.12 -0.47 0.01 -1.73 -0.64 -1.84c-0.74 -0.13 -1.05 0.79 -1.76 0.79c-0.78 0.00 -0.79 0.86 -1.76 0.37c-0.17 -0.08 -0.26 -0.31 -0.46 -0.33c-0.51 -0.06 -0.53 -0.06 -0.95 -0.37c-0.33 -0.24 -0.00 -0.76 -0.49 -0.76c-0.15 -0.45 0.02 -0.40 -0.37 -0.82c-0.02 -0.03 -0.02 -0.04 -0.02 -0.07c-0.08 -0.03 0.07 -0.21 0.11 -0.24c0.11 -0.09 0.25 -0.16 0.35 -0.26c0.16 -0.16 0.23 -0.35 0.13 -0.56c-0.17 -0.34 0.09 -0.97 -0.61 -0.72c-0.32 0.12 -0.55 0.14 -0.87 0.18c-0.22 0.03 -0.95 0.58 -0.98 0.47l-0.02 0.00c-0.07 -0.29 -0.36 0.17 -0.39 0.26c-0.09 0.23 -0.02 0.29 -0.30 0.31c-0.53 0.03 -0.53 0.33 -0.91 0.58l0.00 0.00z"},5:{name:"B\u1eafc Giang",path:"m82.24 55.59l0.38 0.36c0.08 0.14 0.23 0.22 0.33 0.36c0.12 0.17 0.03 0.31 0.09 0.48c0.06 0.16 0.13 0.32 0.13 0.50l0.00 0.00c0.10 0.01 0.46 0.11 0.55 0.16c0.23 -0.13 0.22 -0.07 0.27 -0.38c0.06 -0.30 0.53 -0.26 0.74 -0.13c0.26 0.16 0.02 0.67 0.24 0.77c0.12 0.05 0.37 -0.15 0.58 -0.10c0.16 0.04 0.24 0.23 0.43 0.27c0.28 0.06 0.48 -0.25 0.71 -0.18c0.19 0.06 0.36 0.29 0.51 0.44c0.26 0.27 0.40 0.09 0.70 0.20c-0.00 0.01 0.13 0.27 0.13 0.27c0.10 0.45 0.54 -0.31 0.80 0.14c0.17 0.28 0.34 0.32 0.54 0.53l0.00 0.00c0.12 -0.19 0.28 -0.03 0.35 -0.39c0.04 -0.20 -0.06 -1.28 0.33 -0.86c0.29 0.31 0.42 0.41 0.74 0.06c0.17 -0.19 0.37 -0.13 0.54 -0.27c0.28 -0.24 0.27 -0.55 0.76 -0.49c0.31 0.04 0.60 -0.05 0.90 -0.05l0.00 0.00c0.58 0.02 0.43 0.63 1.17 0.67c0.25 0.01 0.35 0.21 0.55 0.31c0.33 0.17 1.15 0.05 1.57 0.12c0.72 0.12 1.37 0.31 2.12 0.31c0.51 0.00 0.27 -0.34 0.35 -0.61c0.06 -0.21 0.51 0.05 0.65 0.10c0.02 0.00 0.06 0.00 0.07 0.01c0.16 -0.04 0.25 -0.15 0.44 -0.09c0.28 0.09 0.45 0.31 0.70 -0.03c0.37 -0.51 0.68 -0.81 0.56 -1.49c-0.14 -0.77 0.53 -0.55 0.91 -0.77l0.12 -0.26l0.00 0.00c0.00 -0.14 -0.37 -0.32 -0.42 -0.51c-0.07 -0.31 -0.22 -0.37 -0.48 -0.54c-0.36 -0.37 0.49 -0.68 0.21 -1.04c-0.29 -0.37 -0.61 0.40 -1.06 0.10c-0.37 -0.25 0.00 -0.18 -0.45 -0.18c-0.13 -0.41 -0.10 -0.86 -0.61 -0.99c-0.70 -0.17 -0.62 -0.03 -0.62 -0.82c-0.35 -0.12 -0.84 -1.13 -1.35 -0.37c-0.68 1.02 -0.75 -0.22 -1.28 -0.68c-0.35 -0.31 -0.96 -0.11 -1.39 -0.23c-0.82 -0.23 -1.06 0.73 -1.39 1.25c-0.10 0.21 -0.31 0.32 -0.31 0.58c0.00 0.18 0.24 0.32 0.11 0.45c-0.25 0.25 -0.75 0.35 -0.75 0.74c0.00 0.32 -0.39 0.22 -0.56 0.16c-0.29 -0.11 -0.54 0.29 -0.56 0.51c-0.05 0.59 -0.57 0.37 -0.97 0.29c-0.62 -0.13 -0.13 -1.02 -0.88 -0.95c-0.47 -0.10 0.05 -0.66 -0.27 -0.78c-0.34 -0.12 -0.80 0.16 -1.10 -0.02c-0.30 -0.18 -0.25 -0.19 -0.63 -0.19c-0.46 0.00 -0.30 -0.51 -0.46 -0.56c0.00 -0.25 0.09 -0.45 0.07 -0.70c-0.03 -0.35 0.10 -0.37 0.27 -0.62l0.00 0.00c-0.37 -0.37 -0.86 -0.13 -1.19 -0.43c-0.46 -0.41 -0.85 0.27 -1.01 0.68c-0.44 1.11 -0.03 2.23 -0.52 3.34c-0.35 0.79 -1.25 -0.98 -1.25 0.12c0.00 0.45 -0.02 0.71 -0.51 0.55c-0.02 0.05 -0.13 0.27 -0.17 0.39c-0.07 0.20 -0.34 0.07 -0.38 0.14c-0.07 0.12 0.04 0.21 -0.05 0.37l0.00 0.00z"},6:{name:"B\u1eafc Ninh",path:"m86.48 61.94l0.17 -0.33c0.48 0.15 0.44 0.62 1.01 0.38c0.42 -0.18 0.70 -0.37 1.14 -0.24c0.32 0.10 0.36 -0.12 0.44 -0.34c0.05 -0.15 0.31 -0.18 0.24 -0.41c-0.12 -0.39 0.19 -0.50 0.11 -0.79c-0.06 -0.24 -0.15 -0.41 -0.20 -0.67l-0.03 -0.27l0.00 0.00c-0.20 -0.20 -0.38 -0.24 -0.54 -0.53c-0.27 -0.45 -0.71 0.31 -0.80 -0.14c0.00 0.00 -0.13 -0.26 -0.13 -0.27c-0.30 -0.11 -0.44 0.07 -0.70 -0.20c-0.14 -0.14 -0.31 -0.37 -0.51 -0.44c-0.23 -0.08 -0.43 0.24 -0.71 0.18c-0.19 -0.04 -0.27 -0.23 -0.43 -0.27c-0.21 -0.05 -0.46 0.15 -0.58 0.10c-0.22 -0.10 0.02 -0.61 -0.24 -0.77c-0.21 -0.13 -0.68 -0.17 -0.74 0.13c-0.06 0.30 -0.05 0.24 -0.27 0.38c-0.08 -0.05 -0.45 -0.14 -0.55 -0.16l0.00 0.00l-0.45 0.16c0.01 0.23 0.07 0.24 0.01 0.48c-0.03 0.13 0.10 0.20 0.17 0.30c0.16 0.23 0.05 0.56 0.11 0.82c0.08 0.35 0.13 0.96 0.54 1.12c0.21 0.08 0.50 0.03 0.74 0.10c0.28 0.09 0.31 0.35 0.40 0.58l-0.31 0.76l0.00 0.00c0.19 0.08 0.33 0.09 0.53 0.03c0.29 -0.08 0.58 0.02 0.86 -0.09c0.17 -0.06 0.54 0.23 0.71 0.39l0.00 0.00z"},7:{name:"B\u1ebfn Tre",path:"m84.90 253.99c-0.18 0.82 -0.06 0.68 0.71 0.90c0.35 0.10 0.80 -0.08 1.13 0.25c0.25 0.25 0.30 0.57 0.52 0.81c0.31 0.34 0.76 0.44 1.10 0.78c0.34 0.34 0.54 0.55 0.79 1.04l0.35 0.44l0.00 0.00l1.62 1.48l2.23 1.53l0.64 1.19l0.00 0.00c0.43 0.22 0.50 1.38 1.22 0.42l0.31 -0.30c0.37 -0.35 0.61 -0.94 0.55 -1.47c-0.04 -0.32 -1.01 -0.79 -0.76 -0.99c0.24 -0.42 0.47 -0.36 0.68 -0.94c0.14 -0.39 0.42 -0.19 0.73 -0.21c0.40 -0.03 1.12 -1.11 1.16 -1.47c0.05 -0.52 -0.21 -0.63 -0.26 -1.07l0.00 0.00c-0.23 -0.19 -0.57 -0.46 -0.77 -0.66c-0.16 -0.16 -0.36 -0.31 -0.55 -0.43c-0.47 -0.29 -1.09 -0.32 -1.63 -0.50c-0.35 -0.11 -0.91 -0.38 -1.26 -0.29c-0.39 -0.17 -0.82 -0.19 -1.16 -0.49c-0.19 -0.17 -0.50 -0.41 -0.74 -0.50c-0.95 -0.36 -0.84 -0.11 -1.70 0.16c-0.28 0.09 -0.80 -0.09 -1.19 0.00c-0.58 0.13 -1.20 0.44 -1.79 0.62c-1.09 0.34 -1.05 -0.20 -1.91 -0.29l0.00 0.00z"},8:{name:"B\xecnh D\u01b0\u01a1ng",path:"m91.88 239.48l0.39 -0.40c0.24 0.15 0.47 0.16 0.71 0.31c0.39 0.25 0.17 0.39 0.26 0.64c0.14 0.00 0.12 0.54 0.29 0.69c0.22 0.21 0.29 0.28 0.61 0.23c0.65 -0.12 0.37 0.35 0.52 0.62c0.05 0.09 0.23 0.04 0.31 0.20c0.10 0.22 0.03 0.20 0.24 0.33c0.44 0.14 0.08 0.82 0.64 1.00c0.42 0.14 0.27 0.52 0.49 0.82c0.22 0.30 0.41 -0.40 0.66 -0.08c0.15 0.19 0.21 0.47 0.44 0.16c0.24 -0.31 0.38 0.10 0.65 -0.03c0.20 -0.09 0.36 -0.34 0.55 -0.38l0.00 0.00c-0.06 -0.20 -0.92 -0.52 -1.16 -0.87c-0.24 -0.35 0.38 -0.15 0.36 -0.42c-0.03 -0.34 -0.17 -0.34 -0.08 -0.72c0.37 -0.12 0.22 -0.33 0.27 -0.62c0.17 -0.06 0.28 -0.32 0.50 -0.10c0.23 0.24 0.93 0.74 1.29 0.54c0.37 -0.21 0.20 -0.48 0.60 -0.65c0.02 -0.01 0.38 -0.89 0.38 -0.99c0.00 -0.39 -0.02 -0.63 -0.17 -1.02c-0.03 -0.26 -1.02 -0.51 -0.74 -0.92c0.13 -0.19 0.21 -0.16 0.25 -0.41c0.04 -0.21 0.08 -0.35 0.18 -0.53l0.13 -0.50l0.00 0.00c-0.19 -0.19 0.36 -0.44 0.15 -0.73c-0.13 -0.18 -0.81 0.03 -0.96 0.14c-0.13 0.09 -0.38 0.51 -0.51 0.47c-0.28 -0.08 -0.14 -0.57 -0.20 -0.78c-0.12 -0.43 -0.69 -0.32 -1.07 -0.35c-0.23 -0.02 -0.18 -0.37 -0.29 -0.54c-0.26 -0.39 1.35 -1.53 0.14 -1.39c-0.46 0.05 -0.27 0.52 -0.60 0.78c-0.40 0.30 -0.56 0.68 -1.05 0.89c-0.22 0.09 -0.12 0.45 -0.18 0.64c-0.29 0.07 -0.67 -0.27 -0.92 -0.19c-0.20 -0.04 -0.28 -0.25 -0.38 -0.28c-0.08 -0.34 -0.78 0.43 -0.97 0.01c-0.03 -0.06 0.01 -0.85 0.04 -0.93c0.07 -0.16 0.48 -0.19 0.39 -0.41c-0.16 -0.38 -0.05 -0.53 -0.53 -0.38c-0.58 0.19 -0.60 -0.33 -1.12 -0.35c-0.31 -0.01 -0.56 -0.01 -0.85 0.11l0.00 0.00l-0.36 0.47c-0.37 0.31 -0.66 0.27 -0.73 0.87c-0.05 0.36 -0.19 0.68 -0.24 1.03c-0.05 0.28 0.03 0.43 -0.06 0.72c-0.14 0.45 0.25 0.49 0.14 0.96c-0.10 0.41 0.61 0.34 0.61 0.79c0.00 0.20 -0.01 0.42 0.14 0.56c0.15 0.13 0.61 0.15 0.63 0.40c0.01 0.10 0.01 0.21 0.04 0.32c0.03 0.10 0.14 0.19 0.15 0.26l0.00 0.00z"},9:{name:"B\xecnh \u0110\u1ecbnh",path:"m129.54 178.81c0.12 0.30 -0.10 0.49 0.01 0.76c0.05 0.13 0.38 1.06 -0.02 0.91c-0.14 -0.06 -0.28 -0.21 -0.34 0.00c-0.07 0.26 0.05 0.41 0.08 0.66c0.05 0.21 0.26 0.40 0.28 0.62c0.05 0.75 0.47 1.25 0.51 1.99c0.03 0.49 0.34 0.74 0.41 1.16c0.04 0.28 -0.20 0.35 -0.15 0.73c0.19 0.44 0.45 0.76 0.69 1.15c0.21 0.34 0.23 0.44 0.57 0.66c0.31 0.21 0.29 0.88 0.29 1.24c0.00 0.25 -0.04 0.38 -0.16 0.59c-0.12 0.21 -0.09 0.42 -0.13 0.64c0.18 0.34 0.40 0.77 0.69 1.06c0.29 0.29 0.17 0.59 0.36 0.85c0.36 0.48 0.51 0.70 0.54 1.37c0.02 0.44 -0.31 0.59 -0.24 1.12c0.09 0.42 0.19 0.86 0.40 1.24c0.09 0.15 0.22 0.57 0.10 0.73l0.00 0.00c0.55 0.85 1.05 0.08 1.74 0.69c0.39 0.34 1.10 -0.02 1.45 -0.27c0.27 -0.19 0.35 -0.57 0.80 -0.57c0.86 0.00 0.38 -0.83 0.66 -1.18c0.18 -0.22 0.59 -0.03 0.63 -0.41c0.05 -0.44 0.40 -0.47 0.46 -0.66c0.36 0.00 0.61 0.14 0.86 0.39l0.00 0.00c0.16 -0.31 -0.33 -1.54 0.23 -1.54c0.06 0.25 1.00 0.64 0.95 0.14c-0.03 -0.31 -0.38 -0.53 -0.41 -0.92c-0.04 -0.60 0.10 -1.01 -0.14 -1.55c-0.23 -0.53 -0.67 -0.48 -0.35 -1.34c0.07 -0.69 -0.03 -1.09 -0.48 -1.60c-0.59 -0.67 -0.25 -0.76 0.11 -1.23c-0.20 -0.27 -0.63 -0.63 -0.76 -0.93c-0.32 -0.73 0.15 -1.31 -0.41 -2.05c-0.21 -0.28 -0.55 -0.64 -0.69 -0.93c-0.19 -0.39 0.15 -1.04 0.11 -1.53c-0.25 -0.43 -1.12 -1.99 -1.02 -2.39c0.09 -0.02 0.13 -0.13 0.12 -0.28l0.00 0.00l-0.51 -0.36c0.10 -0.23 -0.21 -0.96 -0.43 -1.06l-1.40 -0.61c-0.41 -0.18 -2.98 0.46 -3.04 0.68c-0.27 1.01 0.39 1.07 -0.89 1.03c-0.49 -0.02 -0.48 0.15 -0.85 0.40l-0.61 0.58l0.00 0.00z"},10:{name:"B\xecnh Ph\u01b0\u1edbc",path:"m100.45 236.40c0.81 0.07 2.37 -1.43 2.45 -2.22c0.02 -0.21 -0.28 -0.41 0.06 -0.57c0.44 -0.20 0.48 -0.62 1.02 -0.73l1.74 -0.34l1.55 -0.24l0.00 0.00c-0.06 -0.25 -0.46 -0.36 -0.54 -0.58c-0.14 -0.39 0.12 -0.67 -0.26 -0.98c-0.28 -0.23 -0.43 -0.41 -0.20 -0.78c0.18 -0.28 0.10 -0.62 0.28 -0.90c0.26 -0.40 0.68 -0.28 0.99 -0.54l0.66 -0.14l0.00 0.00c0.09 -0.74 0.72 -0.77 0.79 -1.35c0.04 -0.36 -0.62 -1.27 -0.95 -1.49c-0.52 -0.35 -0.59 -0.64 -0.87 -1.15c-0.34 -0.61 -0.76 -0.45 -1.33 -0.70c-0.34 -0.15 -0.16 -0.62 -0.30 -0.80c0.27 -0.36 -0.12 -0.73 -0.12 -1.00l-0.33 -2.88l0.00 0.00c-0.26 0.09 -0.54 0.17 -0.84 0.25c-0.18 0.00 -0.91 1.21 -0.98 1.44c-0.01 0.04 -1.30 0.99 -1.25 1.19c-0.79 0.11 -2.27 2.00 -3.42 0.97c-1.04 -0.94 -1.53 1.95 -2.73 1.91l-2.38 -0.08c-1.64 -0.06 -2.78 -0.74 -1.64 1.31c0.26 0.47 -0.13 1.15 -0.26 1.73c-0.98 0.24 0.59 1.83 0.25 2.14l0.00 0.00l0.40 0.54c0.03 0.17 -0.00 0.31 0.14 0.44c0.48 0.44 0.45 1.06 -0.21 1.26c-0.46 0.14 -0.58 0.55 -0.58 1.00l0.00 0.00c0.28 -0.13 0.54 -0.13 0.85 -0.11c0.52 0.02 0.54 0.54 1.12 0.35c0.48 -0.16 0.37 -0.01 0.53 0.38c0.09 0.22 -0.32 0.25 -0.39 0.41c-0.03 0.07 -0.07 0.86 -0.04 0.92c0.19 0.43 0.88 -0.34 0.97 -0.01c0.10 0.03 0.18 0.24 0.38 0.28c0.25 -0.08 0.63 0.26 0.92 0.19c0.06 -0.19 -0.04 -0.54 0.18 -0.64c0.49 -0.21 0.65 -0.58 1.05 -0.89c0.33 -0.25 0.14 -0.72 0.60 -0.78c1.21 -0.14 -0.40 1.00 -0.14 1.39c0.11 0.16 0.05 0.52 0.29 0.54c0.39 0.03 0.95 -0.08 1.07 0.35c0.06 0.21 -0.09 0.70 0.20 0.78c0.13 0.04 0.38 -0.39 0.51 -0.47c0.15 -0.10 0.83 -0.32 0.96 -0.14c0.21 0.29 -0.34 0.53 -0.15 0.73l0.00 0.00z"},11:{name:"B\xecnh Thu\u1eadn",path:"m134.83 250.43c-0.12 -0.18 -0.22 -0.36 -0.19 -0.59c0.04 -0.38 0.51 0.20 0.56 0.30c0.06 0.10 0.16 0.27 0.17 0.38c0.01 0.16 -0.33 0.09 -0.41 0.06l-0.13 -0.14zm-24.52 -4.54l0.89 -0.58c0.50 -0.45 0.01 -0.80 -0.01 -1.28c-0.04 -0.86 -0.09 -1.90 -0.97 -2.29l-1.10 -0.48l-0.41 -0.16c-0.30 -0.12 0.06 -0.20 0.09 -0.35c0.11 -0.04 0.09 -0.18 0.13 -0.28c0.06 -0.17 0.36 -0.20 0.36 -0.42c0.00 -0.16 -0.09 -0.28 -0.18 -0.40c-0.16 -0.22 0.26 -0.30 0.32 -0.55c0.03 -0.12 0.01 -0.23 0.07 -0.35c0.09 -0.20 0.26 -0.34 0.35 -0.54c0.06 -0.21 0.09 -0.38 0.30 -0.49c0.25 -0.12 0.44 -0.36 0.38 -0.66c-0.07 -0.36 -0.26 -0.44 0.07 -0.76l0.21 -0.67l0.00 0.00c0.49 -0.30 0.32 -0.84 0.89 -0.13c0.18 0.22 0.83 0.34 1.13 0.54c0.83 0.56 1.00 -0.54 1.69 -0.69c0.66 -0.13 1.56 -0.12 2.23 -0.04c0.66 0.19 1.93 0.36 2.43 0.83c0.41 0.39 0.24 0.95 0.35 1.40c0.11 0.47 0.61 -0.29 0.80 -0.42c0.71 -0.46 1.70 -0.62 2.26 -1.19c0.36 -0.36 1.23 -1.13 1.40 -1.58c-0.35 -0.58 -0.93 -0.54 -0.49 -1.42c0.45 -0.24 1.05 -0.78 1.45 -0.17c0.21 0.32 0.66 -0.26 1.08 -0.10c0.31 0.12 0.80 -0.15 1.14 -0.14c0.68 0.02 1.45 0.70 1.45 -0.47l0.00 0.00l1.19 0.05c0.35 0.32 0.25 1.48 0.97 1.36c1.59 -0.26 0.53 0.87 1.63 1.42c0.41 0.20 1.55 0.54 1.32 1.11l0.00 0.00c-0.20 -0.05 -0.40 0.00 -0.62 0.16l-0.64 0.13c-0.26 0.05 -0.29 0.39 -0.62 0.39c-0.03 0.10 -0.16 0.27 -0.05 0.42c-0.45 0.59 -0.30 0.68 -0.49 1.36c-0.11 0.40 -1.12 -0.23 -1.23 0.11c-0.06 0.00 -0.02 0.00 -0.13 0.06c-0.33 0.00 -0.84 0.53 -0.97 0.02c-0.23 0.00 -1.57 1.24 -1.69 1.60c-0.34 1.02 -0.71 1.23 -1.75 1.06c-0.35 -0.06 -0.29 0.18 -0.58 0.32c-0.67 0.34 0.08 1.31 -0.88 0.94c-0.43 -0.17 -0.32 0.64 -0.43 0.75c-0.14 0.14 -0.19 -0.07 -0.23 -0.19c-0.19 -0.66 -2.59 -0.30 -3.05 0.02c-0.79 0.55 -0.64 1.16 -1.12 1.83c-0.83 0.83 0.37 2.96 -1.92 2.03c-1.74 -0.71 -2.33 1.29 -3.88 1.42c-0.33 0.03 -0.34 0.58 -0.75 0.61c-0.43 0.03 -0.80 0.22 -1.11 0.47l0.00 0.00c0.00 -0.44 -0.13 -0.98 -0.35 -1.36c-0.25 -0.43 -0.26 -0.77 -0.40 -1.22c-0.07 -0.24 -0.34 -0.45 -0.54 -0.60l-0.01 -0.49l0.00 0.00z"},12:{name:"C\xe0 Mau",path:"m63.85 267.31l1.19 0.88l0.51 -1.23l0.45 0.51l0.24 -0.24l0.57 0.16l0.30 -0.31l3.80 2.39l1.22 0.67l0.00 0.00c-0.22 0.29 -0.55 0.40 -0.68 0.75c-0.24 0.68 0.94 0.86 0.49 1.36c-0.43 0.48 -1.30 0.72 -0.61 1.41l0.01 1.17c0.00 0.47 0.22 0.37 0.56 0.45c0.50 0.13 0.44 0.70 1.16 0.53c0.50 -0.12 1.08 0.28 1.32 0.69l0.00 0.00c-0.25 0.36 -0.49 0.80 -0.74 1.38c-1.06 2.39 -1.05 2.21 -3.15 3.45c-1.13 0.67 -1.53 1.82 -2.76 2.54c-1.40 0.82 -3.61 0.80 -4.92 0.32c-0.78 -0.28 -1.44 -0.86 -0.26 -0.86c0.01 -0.03 0.04 -0.04 0.05 -0.07c1.30 0.00 0.20 -1.66 0.91 -1.37c0.10 0.04 1.07 -0.33 1.29 -0.81c0.30 -0.69 -0.56 -0.31 -1.11 -0.31c-1.24 0.00 0.06 -5.60 -0.17 -6.76c0.00 -1.28 0.32 -2.50 0.32 -3.81c0.00 -0.64 -0.09 -2.02 0.02 -2.90l0.00 0.00z"},13:{name:"Cao B\u1eb1ng",path:"m93.89 35.08c-0.22 -0.74 0.22 -0.48 0.29 -1.26c0.04 -0.44 0.24 -0.49 0.35 -0.95l0.21 -0.99c0.24 0.00 2.25 1.14 1.76 -0.21c-0.13 -0.36 0.23 -0.62 0.39 -0.93c0.15 -0.17 0.17 -0.42 0.32 -0.55c0.09 -0.08 0.39 -0.14 0.41 -0.27c0.03 -0.29 -0.17 -0.53 -0.02 -0.90c0.11 -0.28 1.53 -1.15 0.51 -1.23c-0.90 -0.07 -0.53 -0.05 -1.02 -0.55c-0.16 -0.16 -0.62 -0.01 -0.66 -0.35c-0.06 -0.49 -0.01 -0.31 -0.46 -0.42c-0.32 -0.07 -0.63 -0.10 -0.74 0.32c-0.41 0.00 -0.45 -0.51 -0.61 -0.82c-0.29 -0.59 -0.80 0.09 -1.04 -0.25c-0.76 -1.09 -0.57 0.56 -1.43 0.41c-0.23 0.03 -0.94 0.27 -1.00 0.50c-0.36 0.00 -0.70 -0.23 -0.91 0.14c-0.25 0.45 -0.49 0.12 -0.82 -0.01c-0.04 -0.02 -0.41 0.14 -0.56 0.14c-0.43 0.00 -0.38 -0.53 -0.36 -0.80c0.02 -0.25 -0.20 -0.37 -0.26 -0.60c-0.24 -0.17 -0.34 -0.55 -0.63 -0.69c-0.24 -0.12 -0.49 0.06 -0.72 -0.07c-0.55 -0.34 -0.64 0.16 -1.23 -0.20c-0.38 -0.23 -0.53 0.24 -0.95 0.10c-0.86 -0.29 -0.41 0.57 -0.62 0.74c-0.21 0.17 -0.41 0.01 -0.67 0.01c-0.09 0.00 -0.33 0.18 -0.36 0.17c-0.22 0.33 -0.38 -0.30 -0.61 -0.13c-0.29 0.22 -0.22 0.43 -0.66 0.43c-0.14 -0.57 -1.02 -1.18 -1.30 -1.59c-0.18 -0.26 -1.46 -1.06 -1.72 -0.99c-0.59 0.17 -0.92 -0.75 -1.22 -0.41c-0.12 0.14 -0.52 0.02 -0.64 0.06c-0.06 0.02 -0.05 0.16 -0.15 -0.01c-0.07 -0.13 -0.15 -0.38 -0.20 -0.62l0.00 0.00l-0.69 0.34c-0.01 0.32 -0.53 1.49 -0.82 1.67c-0.35 0.22 -2.03 0.39 -1.97 0.70c0.15 0.70 -1.05 0.65 -1.05 1.49c-0.80 0.27 -0.29 0.64 0.23 0.81c0.00 0.10 1.47 1.37 1.67 1.48c1.06 0.56 1.31 0.73 1.31 1.97l-0.01 0.51l0.00 0.00l0.73 0.08l0.00 0.00c0.37 -0.25 0.37 -0.55 0.91 -0.58c0.28 -0.02 0.21 -0.08 0.30 -0.31c0.03 -0.09 0.32 -0.55 0.39 -0.26l0.02 0.00c0.03 0.12 0.75 -0.44 0.98 -0.47c0.32 -0.04 0.55 -0.06 0.87 -0.18c0.70 -0.25 0.44 0.37 0.61 0.72c0.10 0.21 0.03 0.40 -0.13 0.56c-0.10 0.10 -0.23 0.17 -0.35 0.26c-0.04 0.03 -0.19 0.21 -0.11 0.24c0.00 0.03 0.01 0.05 0.02 0.07c0.39 0.43 0.22 0.37 0.37 0.82c0.49 0.00 0.16 0.53 0.49 0.76c0.43 0.31 0.45 0.31 0.95 0.37c0.21 0.03 0.30 0.25 0.46 0.33c0.97 0.49 0.98 -0.37 1.76 -0.37c0.71 0.00 1.02 -0.91 1.76 -0.79c0.65 0.11 0.76 1.37 0.64 1.84c-0.07 0.28 -0.31 1.01 -0.01 1.23c0.39 0.28 0.79 -0.18 1.14 -0.06c0.00 0.09 0.22 0.17 0.29 0.23l0.00 0.00l0.21 -0.62c0.06 -0.08 0.36 -0.39 0.37 -0.43c0.12 0.06 0.44 -0.39 0.66 -0.07c0.34 0.50 0.76 0.49 1.26 0.74c0.33 0.17 0.17 0.69 0.57 0.90c0.21 0.10 0.58 -0.11 0.85 -0.08c0.65 0.08 0.62 0.47 1.12 -0.18c0.41 -0.53 0.94 -0.61 1.49 -0.94l0.00 0.00z"},14:{name:"C\u1ea7n Th\u01a1",path:"m78.85 256.88l1.22 0.87c0.16 0.18 0.42 0.34 0.62 0.48c0.18 0.13 0.48 0.50 0.55 0.68c0.05 0.14 0.24 0.63 0.39 0.67l0.00 0.00l-0.43 0.37c-0.54 0.11 -0.63 0.04 -1.11 -0.07c-0.52 -0.12 -0.62 0.29 -1.07 0.36c-0.19 0.03 -0.46 -0.07 -0.35 -0.31c-0.48 -0.16 -0.34 0.24 -0.75 0.24c-0.17 0.00 -0.51 -0.49 -0.66 -0.63c-0.36 -0.36 -0.75 1.01 -1.01 1.17l0.00 0.00l-3.04 -2.90l-0.17 -0.54l-0.49 -0.53l-0.35 0.14l-1.41 -1.18l0.00 0.00l0.57 -0.74c0.38 0.04 0.38 0.07 0.64 -0.26c0.25 -0.31 0.38 -0.03 0.51 0.01c-0.30 0.59 1.56 0.12 1.80 0.00c0.17 -0.08 -0.02 -0.34 0.04 -0.48c0.09 -0.24 0.38 -0.07 0.58 -0.14c0.12 -0.04 0.44 -0.34 0.57 -0.48l0.15 -0.14l0.00 0.00l1.35 1.24c0.21 0.18 0.35 0.40 0.51 0.62c0.21 0.29 0.30 0.68 0.55 0.93c0.19 0.19 0.49 0.55 0.76 0.62l0.00 0.00z"},15:{name:"\u0110\xe0 N\u1eb5ng",path:"m123.56 153.34c-0.65 -0.94 -1.17 -2.08 0.04 -2.22c0.68 -0.08 0.84 -0.75 0.51 -0.53c-0.49 0.34 -0.77 -0.54 -1.36 -0.32c-0.29 0.10 -0.25 0.88 -0.49 1.12c-0.50 0.51 -1.93 -0.95 -1.08 -1.25c0.64 -0.23 0.99 -1.15 0.32 -0.97c-0.20 0.06 -0.35 0.01 -0.47 -0.07l0.00 0.00c-0.43 0.16 -1.51 0.48 -1.94 0.34c-0.41 -0.13 -0.89 -0.52 -1.27 -0.33c-0.34 0.17 -0.28 0.44 -0.74 0.05c-0.36 -0.31 -0.75 -0.00 -0.81 0.42c-0.03 0.20 -0.48 1.14 -0.44 1.25c-0.12 0.12 -0.25 0.25 -0.33 0.39c-0.10 0.19 -0.00 0.40 -0.10 0.56l0.00 0.00l0.75 -0.02c0.87 0.73 0.82 -0.14 1.53 -0.14l0.01 0.01c0.00 0.41 0.21 0.55 0.32 0.91c0.20 0.66 -0.50 0.81 0.14 1.60c0.15 0.19 0.49 -0.04 0.69 -0.08c0.33 -0.06 0.47 0.06 0.77 0.12c0.23 0.05 0.37 -0.17 0.58 -0.20c0.19 -0.03 0.30 0.11 0.46 0.11c0.17 0.00 0.21 -0.24 0.36 -0.30c0.31 -0.12 0.24 0.35 0.55 -0.16c0.34 -0.55 0.46 0.70 0.84 -0.07c0.19 -0.39 0.81 -0.09 1.17 -0.21l0.00 0.00z"},16:{name:"\u0110\u1eafk L\u1eafk",path:"m130.42 218.48c0.11 -0.60 -0.27 -1.71 0.07 -2.14c0.10 -0.13 0.23 -0.64 0.50 -0.54c0.58 0.22 0.58 -0.88 1.26 -0.19c0.25 0.25 0.83 0.41 1.16 0.50c0.77 0.21 0.26 -0.47 0.14 -0.68c-0.07 -0.12 0.21 -1.17 0.26 -1.37c0.14 -0.60 0.61 -0.47 1.18 -0.58c0.14 0.00 0.43 0.01 0.47 -0.14c0.04 -0.13 0.01 -0.28 -0.05 -0.41c-0.06 -0.14 0.16 -0.38 0.18 -0.54c0.05 -0.27 -0.11 -0.37 0.11 -0.64l0.14 -0.21l0.00 0.00c-0.31 -0.52 0.13 -1.10 -0.30 -1.72c-0.39 -0.56 -1.71 0.25 -2.00 -0.48c-0.34 -0.82 -0.32 -0.51 -1.06 -0.66c-0.10 -0.42 -0.64 -0.87 -0.83 -1.25c-0.27 -0.54 -0.96 0.07 -0.80 -0.49l-0.55 -0.64l0.00 0.00c-0.80 0.00 -1.18 -0.61 -1.82 -0.56c-1.46 0.11 -0.52 -0.75 -1.28 -1.30c-0.90 -0.65 -0.85 -2.47 -2.04 -2.77c0.00 -2.01 -2.10 -1.77 -3.53 -2.33c-0.63 -0.21 -1.17 -0.40 -1.84 -0.18c-0.56 0.18 -1.64 0.67 -2.15 0.33c-0.28 -0.18 -1.18 -0.21 -1.56 -0.29c-0.76 -0.15 -1.26 0.67 -1.92 0.67c-0.27 0.00 -0.43 -0.34 -0.69 -0.25c-0.42 0.14 -0.43 0.35 -0.74 0.62l-0.89 0.62l0.00 0.00l-1.40 3.68c-0.17 0.34 -0.43 0.77 -0.45 1.13c-0.01 0.16 0.07 0.83 -0.01 0.94c0.09 0.12 -0.64 0.89 0.05 1.12c0.00 0.59 -0.38 0.68 0.30 1.22c0.30 0.24 0.49 0.79 0.54 1.25l0.00 0.00l1.88 -0.04c1.04 0.20 1.67 0.41 2.65 0.21c0.08 -0.30 1.43 -0.69 1.01 0.07c-0.27 0.49 0.22 0.90 0.68 1.05c0.00 0.52 -0.13 0.62 0.04 1.12c0.08 0.24 0.13 0.69 0.20 0.98c0.15 0.57 -0.86 1.00 -0.33 1.30c0.24 0.14 0.61 -0.08 0.88 0.07c0.29 0.16 0.36 0.33 0.57 0.55c0.64 0.93 -0.35 0.77 -0.79 1.12c-0.65 0.53 -0.03 0.87 0.10 1.40c0.27 1.14 1.63 0.51 2.12 1.31c0.20 0.33 0.25 0.63 0.50 0.92c0.12 0.14 0.55 0.68 0.39 0.90l0.00 0.00c0.34 -0.07 0.60 -0.42 0.98 -0.23c0.29 0.14 0.84 0.49 1.17 0.38c0.30 -0.09 0.76 -1.19 1.07 -0.95c0.29 -0.21 0.69 -0.45 0.98 -0.67c0.60 0.44 0.85 -0.01 1.35 -0.29c0.18 -0.10 0.45 -0.58 0.63 -0.56c0.28 0.03 0.33 0.64 0.79 0.36c0.54 -0.33 0.86 0.19 1.35 0.04c0.43 -0.13 0.97 -0.51 1.32 -0.78l0.00 0.00z"},17:{name:"\u0110\u1eafk N\xf4ng",path:"m105.08 219.01l0.33 2.88c0.00 0.27 0.39 0.64 0.12 1.00c0.14 0.18 -0.04 0.65 0.30 0.80c0.57 0.25 1.00 0.09 1.33 0.70c0.28 0.51 0.35 0.80 0.87 1.15c0.33 0.22 0.99 1.14 0.95 1.49c-0.07 0.58 -0.70 0.61 -0.79 1.35l0.00 0.00c0.19 -0.01 0.28 0.14 0.49 0.14c0.16 0.00 0.21 -0.14 0.31 -0.14c0.01 -0.02 0.46 -0.03 0.62 -0.39c0.21 -0.48 1.10 0.13 1.42 -0.27c0.42 -0.52 0.99 -0.64 1.39 -1.07c0.24 -0.26 1.36 -1.54 1.57 -0.76c0.32 1.15 0.83 0.98 1.94 0.56c0.24 0.00 0.89 -0.11 1.04 0.13c0.12 0.19 -0.06 0.59 -0.01 0.84c0.08 0.35 0.45 0.17 0.62 0.04c0.27 -0.22 0.46 0.54 1.10 0.20c0.53 -0.28 1.61 -0.84 1.78 -1.48c0.04 -0.15 -0.62 -1.13 -0.77 -1.21c-0.14 -0.07 -0.45 -0.78 -0.58 -0.99c-0.24 -0.40 -0.01 -0.37 -0.44 -0.62c-0.92 -0.55 -0.06 -0.90 0.12 -1.37c0.30 -0.77 1.08 0.08 1.53 -0.19l0.49 -0.61l0.00 0.00c0.16 -0.22 -0.27 -0.76 -0.39 -0.90c-0.25 -0.29 -0.30 -0.59 -0.50 -0.92c-0.49 -0.80 -1.85 -0.17 -2.12 -1.31c-0.13 -0.53 -0.74 -0.87 -0.10 -1.40c0.43 -0.35 1.43 -0.19 0.79 -1.12c-0.22 -0.22 -0.28 -0.39 -0.57 -0.55c-0.27 -0.15 -0.64 0.06 -0.88 -0.07c-0.53 -0.30 0.48 -0.73 0.33 -1.30c-0.07 -0.29 -0.12 -0.74 -0.20 -0.98c-0.17 -0.50 -0.04 -0.60 -0.04 -1.12c-0.46 -0.15 -0.95 -0.56 -0.68 -1.05c0.42 -0.76 -0.94 -0.38 -1.01 -0.07c-0.97 0.20 -1.60 -0.02 -2.65 -0.21l-1.88 0.04l0.00 0.00c0.01 0.07 0.01 0.13 0.01 0.19c0.00 1.21 0.52 1.88 0.52 3.03c0.13 0.04 0.01 0.52 -0.04 0.61c0.16 0.43 -0.49 0.50 -0.24 0.95c0.37 0.67 0.07 0.11 -0.02 0.70c-0.04 0.22 0.17 0.34 0.01 0.56c-0.11 0.16 -0.49 0.53 -0.49 0.69c0.00 0.36 0.30 0.44 0.04 0.92c-0.20 0.37 -1.03 0.61 -1.10 0.87c-0.23 0.00 -1.03 2.32 -1.60 0.60c-0.30 -0.90 -1.28 -1.27 -2.09 -0.73c-0.28 0.18 -0.55 0.30 -0.83 0.40l0.00 0.00z"},18:{name:"\u0110\u1ed3ng Nai",path:"m101.49 248.64c0.17 -0.59 -0.08 -0.44 0.57 -0.69c0.77 -0.30 1.54 0.20 1.76 -0.93c0.04 -0.20 -0.02 -0.79 0.28 -0.79c0.29 0.00 0.38 -0.33 0.64 -0.33c0.24 0.37 1.28 0.27 1.72 0.25c0.73 -0.04 -0.13 1.70 0.80 1.37c0.29 -0.09 0.39 -0.60 0.55 -0.86c0.11 -0.17 0.41 -0.58 0.57 -0.68c0.20 -0.12 0.41 -0.22 0.57 -0.41c0.59 -0.75 0.72 0.19 1.37 0.32l0.00 0.00l0.89 -0.58c0.50 -0.45 0.01 -0.80 -0.01 -1.28c-0.04 -0.86 -0.09 -1.90 -0.97 -2.29l-1.10 -0.48l-0.41 -0.16c-0.30 -0.12 0.06 -0.20 0.09 -0.35c0.11 -0.04 0.09 -0.18 0.13 -0.28c0.06 -0.17 0.36 -0.20 0.36 -0.42c0.00 -0.16 -0.09 -0.28 -0.18 -0.40c-0.16 -0.22 0.26 -0.30 0.32 -0.55c0.03 -0.12 0.01 -0.23 0.07 -0.35c0.09 -0.20 0.26 -0.34 0.35 -0.54c0.06 -0.21 0.09 -0.38 0.30 -0.49c0.25 -0.12 0.44 -0.36 0.38 -0.66c-0.07 -0.36 -0.26 -0.44 0.07 -0.76l0.21 -0.67l0.00 0.00c-0.18 -0.18 -0.34 -0.64 -0.62 -0.70c0.01 -0.01 -0.12 -0.21 -0.13 -0.30c-0.02 -0.14 -0.06 -0.25 -0.18 -0.33c-0.18 -0.12 -0.69 -0.04 -0.69 -0.23c0.00 -0.22 0.27 -0.26 0.30 -0.43c0.26 -0.41 0.05 -0.32 -0.18 -0.60c-0.20 -0.24 -0.49 -0.17 -0.67 -0.37c-0.14 -0.15 -0.26 -0.10 -0.45 -0.02c-0.23 0.10 -0.24 -0.40 -0.27 -0.56c-0.09 -0.63 -0.39 0.24 -0.64 0.20l0.00 0.00l-1.55 0.24l-1.74 0.34c-0.54 0.11 -0.58 0.52 -1.02 0.73c-0.34 0.16 -0.04 0.36 -0.06 0.57c-0.09 0.79 -1.65 2.29 -2.45 2.22l0.00 0.00l-0.13 0.50c-0.11 0.18 -0.15 0.32 -0.18 0.53c-0.04 0.24 -0.12 0.21 -0.25 0.41c-0.28 0.41 0.71 0.66 0.74 0.92c0.15 0.39 0.17 0.63 0.17 1.02c0.00 0.10 -0.36 0.98 -0.38 0.99c-0.40 0.17 -0.23 0.44 -0.60 0.65c-0.36 0.20 -1.05 -0.31 -1.29 -0.54c-0.22 -0.22 -0.33 0.04 -0.50 0.10c-0.06 0.29 0.09 0.50 -0.27 0.62c-0.09 0.37 0.05 0.38 0.08 0.72c0.02 0.28 -0.60 0.08 -0.36 0.42c0.24 0.35 1.10 0.67 1.16 0.87l0.00 0.00l0.33 0.84c0.08 0.15 0.72 1.24 0.30 1.34c-0.01 0.04 -0.31 -0.03 -0.41 0.05c-0.38 0.30 -0.29 -0.21 -0.62 0.00c-0.42 0.27 -1.18 0.84 -0.94 1.42c0.09 0.22 0.91 0.75 1.14 0.97c0.34 0.34 0.62 -0.21 1.02 -0.16c0.27 0.03 0.35 0.35 0.52 0.52c0.14 0.14 0.72 0.38 0.94 0.51c0.29 0.17 0.57 -0.21 0.57 -0.46l0.00 0.00z"},19:{name:"\u0110\u1ed3ng Th\xe1p",path:"m70.52 243.60l0.22 0.71c0.10 0.23 0.38 0.21 0.42 0.48c0.03 0.24 0.20 0.15 0.38 0.23c0.38 0.17 -0.01 0.54 0.48 0.61c0.49 0.07 0.42 0.15 0.18 0.47c-0.48 0.64 0.60 0.31 0.82 0.38c0.30 0.09 -0.00 0.76 -0.02 0.95c0.25 0.54 0.14 1.51 0.85 1.74c0.48 0.15 0.59 0.46 1.19 0.48c0.71 0.03 0.92 -0.02 1.50 0.42c0.34 0.26 0.64 0.80 0.58 1.23c0.00 0.51 -0.43 0.18 -0.55 0.43c-0.08 0.17 -0.06 0.38 -0.25 0.50c-0.18 0.10 -0.21 0.15 -0.19 0.35c0.04 0.32 -0.11 0.26 -0.30 0.39c-0.20 0.14 -0.14 0.29 -0.14 0.51l0.00 0.00l1.35 1.24c0.21 0.18 0.35 0.40 0.51 0.62c0.21 0.29 0.30 0.68 0.55 0.93c0.19 0.19 0.49 0.55 0.76 0.62l0.00 0.00l0.82 -1.21c0.24 0.10 0.35 0.06 0.46 0.30c0.10 0.20 0.23 0.16 0.38 0.05c0.25 0.19 0.40 0.46 0.79 0.60c0.39 0.14 0.48 -0.03 0.74 -0.29c0.29 -0.29 0.95 -0.11 0.95 -0.68c0.00 -0.42 -0.81 -0.65 -0.60 -0.94l0.03 -0.30l0.00 0.00c-0.02 -0.05 -0.13 -0.15 -0.17 -0.19c-0.08 -0.06 -0.22 -0.10 -0.32 -0.14c-0.13 -0.06 -0.26 -0.14 -0.37 -0.22l-0.46 -0.43l0.10 -0.72l0.47 -0.12l0.25 -0.62l0.63 -0.66l0.68 -0.79l0.04 -0.66l0.00 0.00l-0.64 -0.13l-1.42 -1.89l-0.71 -0.16l-1.72 -1.59l-1.47 -1.52l0.28 -0.10l-0.39 -1.12l-1.08 -0.07l-0.28 -0.63l0.00 0.00c-0.38 -0.02 -0.82 -0.08 -0.81 -0.07c-0.92 0.00 -0.48 -0.27 -1.31 0.48c-0.26 0.23 -0.87 1.39 -1.22 1.09c-0.35 -0.31 -1.19 -0.45 -1.99 -0.55l0.00 0.00z"},20:{name:"\u0110i\u1ec7n Bi\xean",path:"m20.46 32.79c-0.25 0.29 -0.40 0.61 -0.61 1.02c-0.11 0.22 -0.63 0.71 -0.57 0.85c0.06 0.15 0.39 0.61 0.15 0.58l-1.68 -0.20l-0.30 0.60l0.00 0.00l0.30 0.51c0.14 0.36 0.09 0.54 0.37 0.82c0.29 0.29 -0.06 0.49 0.41 0.81c0.31 0.21 0.28 0.53 0.62 0.79c0.26 -0.20 0.60 0.11 0.66 0.35c0.24 0.91 0.44 0.10 0.83 0.58c0.09 0.11 -0.02 0.48 0.23 0.48c0.29 0.00 0.33 0.04 0.56 0.10c0.00 0.40 0.10 0.55 0.38 0.76c0.33 -0.25 0.61 0.46 0.66 0.66c0.15 0.42 0.75 0.56 0.75 0.81c1.23 0.30 -0.71 1.67 1.49 1.85c0.82 0.07 1.00 1.51 1.43 2.09c-0.17 0.23 0.35 1.18 0.04 1.60c0.14 0.19 0.21 1.58 0.39 1.60c0.71 0.08 2.56 -0.52 2.56 -1.42c0.00 -0.53 -0.37 -1.94 0.35 -2.02c0.82 -0.09 -0.51 3.08 1.02 2.39c1.01 -0.45 0.53 0.41 1.13 0.41c0.63 0.00 0.14 0.82 0.35 1.36c-0.15 0.57 0.16 0.84 -0.37 1.27c-0.12 0.10 -0.79 0.72 -0.79 0.84c-0.02 0.01 -0.02 0.03 -0.02 0.06c-0.41 0.14 -0.75 1.01 -0.60 1.47l0.05 0.00c0.15 -0.46 1.01 -0.10 0.68 -0.01c-0.02 0.09 -0.48 0.77 -0.50 0.78c0.00 0.03 0.01 0.06 -0.01 0.08c0.53 0.71 -0.80 1.75 -1.19 1.95c-0.92 0.46 0.74 0.46 0.80 0.48c0.54 0.13 0.86 0.48 0.64 1.06l0.05 0.64c0.88 0.22 0.54 0.88 0.88 1.56c0.24 0.49 0.91 -0.04 1.38 0.91c0.51 1.04 0.95 1.98 1.60 2.65l0.00 0.00l1.35 -0.40c0.19 -0.07 0.25 -0.04 0.44 -0.04c0.19 0.00 0.16 -0.19 0.24 -0.21c-0.20 -0.79 -0.14 -0.18 0.15 -0.78c0.10 -0.20 -0.01 -0.61 -0.15 -0.78c-0.22 -0.25 0.23 -0.29 0.08 -0.62c-0.06 -0.14 -0.41 -0.79 -0.01 -0.66c0.31 0.11 -0.19 -0.91 0.71 -0.45c0.36 0.18 0.46 0.55 0.98 0.55c1.35 0.00 0.24 -0.68 0.19 -1.23c-0.03 -0.28 0.35 -0.50 0.52 -0.64c0.17 -0.14 0.20 -0.97 0.20 -1.21c0.18 -0.41 0.05 -2.26 -0.74 -1.67c-0.04 -0.03 -0.59 -0.22 -0.46 -0.42c0.04 -0.06 0.65 -0.54 0.42 -0.54c-0.03 -0.13 -0.58 -0.59 -0.70 -0.76c-0.49 -0.70 1.46 -0.25 1.75 -0.47c0.43 -0.32 -0.02 -0.77 0.01 -1.23c0.04 -0.53 0.37 -0.33 0.69 -0.33c0.20 0.00 0.90 -0.90 0.86 -1.04c-0.09 -0.33 0.34 -0.47 0.32 -0.79c-0.02 -0.39 -0.25 -0.62 0.20 -0.87c0.15 -0.19 0.03 -0.29 0.31 -0.29c0.11 0.00 0.33 -0.04 0.33 -0.17c-0.02 -0.01 -0.00 -0.00 -0.02 -0.01c0.00 -0.24 -0.57 -0.46 -0.57 -0.90c0.00 -0.29 -0.26 -0.68 -0.38 -0.95c-0.21 -0.47 -0.21 -1.04 -0.58 -1.46c-0.14 -0.16 -0.24 -0.36 -0.41 -0.53c-0.37 -0.37 -0.11 -0.48 -0.11 -0.86l0.01 -0.01l0.29 -0.53l0.00 0.00c-0.42 -0.19 -0.95 -0.46 -0.77 -1.02c0.22 -0.72 -0.32 -0.66 -0.64 -1.23c-0.19 -0.34 -0.27 -0.75 -0.48 -1.07c-0.16 -0.26 -1.13 -0.14 -1.28 0.10c-0.14 0.23 -0.21 0.51 -0.49 0.62c-0.08 0.31 -0.29 0.36 -0.09 0.76c0.10 0.21 0.23 0.54 -0.20 0.48c-0.52 -0.07 -1.01 -0.59 -1.56 -0.59c-0.40 0.00 -0.57 0.13 -0.91 -0.12c-0.51 -0.58 -0.44 -0.42 -0.64 0.32c-0.05 0.17 -0.94 0.14 -1.13 0.15c-0.34 0.02 -0.56 0.42 -0.79 0.42c-0.34 0.00 -0.59 -0.63 -0.69 -0.89c-0.26 -0.70 -0.81 -0.03 -1.35 0.02c-1.14 0.12 -0.89 -0.09 -1.67 -0.78c-0.86 -0.77 0.13 -0.98 -0.17 -1.80c-0.09 -0.25 -1.14 -0.92 -1.26 -0.66c-0.12 0.27 0.24 0.75 0.24 1.06c0.00 0.77 -0.87 0.19 -1.09 -0.09c-0.28 -0.35 -0.13 -1.43 -1.05 -1.18c-0.52 0.14 -0.47 0.42 -0.93 -0.17c-0.18 -0.23 -0.66 -1.02 -0.69 -1.31c-0.30 -0.37 -0.50 -0.64 -0.88 -0.92c-0.32 -0.24 -0.45 -0.47 -0.35 -0.87c0.23 -0.91 -0.74 -0.86 -0.89 -1.67l-0.29 -0.41l0.00 0.00z"},21:{name:"Gia Lai",path:"m130.31 206.29l0.75 -0.31c0.13 -0.01 0.66 -0.11 0.57 -0.33l0.14 -0.95c0.04 -0.24 0.11 -0.69 0.25 -0.88c0.26 -0.36 0.90 0.15 1.26 -0.62c0.13 -0.27 0.49 -1.87 0.35 -2.10c-0.09 -0.14 -0.61 -0.86 -0.71 -0.91c-0.78 -0.32 -0.49 -0.40 -0.49 -1.16c0.15 -0.21 0.08 -0.48 0.08 -0.73c0.00 -0.53 -0.47 -0.14 -0.81 -0.14c-0.32 0.00 -0.56 0.01 -0.69 -0.32c-0.27 -0.67 0.48 -0.74 0.54 -1.29c0.02 -0.23 0.17 -0.43 0.42 -0.43c0.13 0.00 0.26 0.01 0.39 0.01c0.18 0.00 0.29 0.11 0.44 0.13l0.60 0.05l0.00 0.00c0.12 -0.16 -0.01 -0.58 -0.10 -0.73c-0.21 -0.38 -0.31 -0.83 -0.40 -1.24c-0.06 -0.52 0.27 -0.68 0.24 -1.12c-0.03 -0.66 -0.18 -0.89 -0.54 -1.37c-0.19 -0.26 -0.07 -0.56 -0.36 -0.85c-0.29 -0.29 -0.50 -0.72 -0.69 -1.06c0.04 -0.22 0.01 -0.44 0.13 -0.64c0.12 -0.21 0.16 -0.35 0.16 -0.59c0.00 -0.37 0.03 -1.03 -0.29 -1.24c-0.34 -0.23 -0.35 -0.32 -0.57 -0.66c-0.24 -0.39 -0.50 -0.72 -0.69 -1.15c-0.05 -0.38 0.20 -0.46 0.15 -0.73c-0.07 -0.42 -0.38 -0.67 -0.41 -1.16c-0.04 -0.74 -0.46 -1.25 -0.51 -1.99c-0.02 -0.22 -0.23 -0.41 -0.28 -0.62c-0.04 -0.25 -0.16 -0.39 -0.08 -0.66c0.06 -0.21 0.19 -0.06 0.34 0.00c0.40 0.15 0.07 -0.78 0.02 -0.91c-0.10 -0.27 0.12 -0.47 -0.01 -0.76l0.00 0.00c-0.03 0.08 -0.35 0.13 -0.43 0.12c-0.16 -0.03 -0.21 -0.22 -0.26 -0.35c-0.14 -0.35 -0.41 -0.51 -0.79 -0.54l0.00 0.00l-0.39 0.31c-0.46 0.46 -0.74 0.76 -1.32 0.23c-0.22 -0.20 -1.30 -1.30 -1.46 -0.64c-0.11 0.45 0.17 0.63 0.32 0.98c0.21 0.46 -0.22 0.78 -0.55 1.04c-0.44 0.35 -0.61 1.23 -1.07 1.52c-0.46 0.19 -0.70 -0.04 -1.11 0.07c-0.42 0.11 -0.69 0.62 -1.16 0.56c-0.27 -0.04 -0.59 0.03 -0.83 0.16c-0.27 0.14 -0.54 0.65 -0.58 0.94c-0.11 0.69 -0.65 0.40 -0.78 0.81c-0.11 0.32 -0.21 0.21 -0.46 0.22c-0.13 0.01 -0.17 0.15 -0.29 0.19c-0.74 0.07 -0.88 -0.46 -1.45 -0.81c-0.62 -0.38 -0.94 0.78 -1.33 1.01c-0.34 0.20 -0.59 -0.09 -0.95 0.21c-0.27 0.22 -0.88 -0.14 -1.19 -0.21c-0.00 -0.01 -0.00 -0.01 -0.01 -0.01c-0.11 -0.42 0.01 -0.74 -0.18 -1.19c0.00 -0.79 0.47 -0.64 0.88 -1.10c0.19 -0.21 -0.42 -1.05 -0.52 -1.29c-0.11 -0.24 0.09 -0.87 -0.36 -0.84c-0.48 0.03 -0.79 0.40 -1.22 0.48c-0.39 0.08 -0.71 -0.23 -1.05 -0.23l-1.14 -0.08l0.00 0.00c-0.08 0.49 0.24 1.35 -0.56 1.12c-0.47 -0.13 -0.20 0.46 -0.60 0.57c-0.19 0.05 -0.60 0.97 -0.55 1.19c0.07 0.29 0.20 0.43 0.20 0.79c0.00 0.98 -0.53 1.29 -0.98 2.18c-0.20 0.57 -0.08 0.66 0.33 0.90c0.28 0.16 -0.06 0.67 -0.12 0.88c-0.26 1.00 0.63 0.79 1.22 0.79c0.58 0.00 0.22 0.70 0.37 1.00c0.07 0.15 0.32 0.26 0.44 0.42c-0.10 0.13 -0.54 0.76 -0.32 0.81c0.00 0.47 -0.24 1.28 0.21 1.50c0.66 0.33 1.18 0.70 1.36 1.44c0.09 0.40 0.15 1.18 0.39 1.50l0.82 1.75l0.02 3.04l-0.23 0.62l0.00 0.00l0.89 -0.62c0.30 -0.27 0.32 -0.48 0.74 -0.62c0.26 -0.09 0.42 0.25 0.69 0.25c0.66 0.00 1.16 -0.81 1.92 -0.67c0.38 0.07 1.28 0.10 1.56 0.29c0.50 0.33 1.58 -0.15 2.15 -0.33c0.67 -0.22 1.20 -0.03 1.84 0.18c1.43 0.55 3.53 0.32 3.53 2.33c1.19 0.29 1.14 2.12 2.04 2.77c0.75 0.55 -0.18 1.41 1.28 1.30c0.64 -0.05 1.03 0.56 1.82 0.56l0.00 0.00z"},22:{name:"H\xe0 Giang",path:"m76.59 22.29l-0.69 0.34c-0.01 0.32 -0.53 1.49 -0.82 1.67c-0.35 0.22 -2.03 0.39 -1.97 0.70c0.15 0.70 -1.05 0.65 -1.05 1.49c-0.80 0.27 -0.29 0.64 0.23 0.81c0.00 0.10 1.47 1.37 1.67 1.48c1.06 0.56 1.31 0.73 1.31 1.97l-0.01 0.51l0.00 0.00c0.07 0.02 -0.16 0.26 -0.19 0.29c-0.11 0.08 -0.22 0.14 -0.33 0.20c-0.22 0.13 -0.45 0.12 -0.69 0.06c-0.56 -0.13 -0.82 -0.51 -1.24 -0.67c-0.38 -0.14 -0.52 0.51 -0.89 0.45c-0.49 -0.08 -0.56 -0.62 -1.10 -0.78c-0.34 -0.10 -1.49 -0.63 -1.70 -0.38c-0.16 0.18 0.27 0.88 0.21 1.19c-0.07 0.40 -0.55 0.49 -0.56 0.87l-0.02 1.35l-0.04 0.12c0.22 0.52 -0.35 0.76 -0.35 1.16c0.00 0.51 0.31 0.44 -0.26 0.58c-0.07 0.34 0.19 0.90 -0.37 0.78c-0.45 -0.10 0.04 0.68 -0.08 0.98c-0.02 -0.01 -0.11 0.18 -0.14 0.23c-0.06 0.09 -0.15 0.14 -0.26 0.14c-0.23 0.02 -0.44 -0.05 -0.57 -0.23c-0.25 -0.35 -0.38 -0.56 -0.85 -0.49c-0.38 0.06 -0.43 -0.31 -0.75 -0.31c-0.11 0.32 0.15 0.46 0.17 0.75c0.02 0.36 -0.17 0.36 -0.33 0.62c-0.16 0.25 0.97 1.12 -0.11 1.46c-0.49 0.15 -0.42 -0.50 -0.93 0.17l0.00 0.00c-0.23 0.00 -1.30 0.31 -1.36 0.25c-0.34 0.17 -0.44 -1.26 -0.45 -1.41c-0.04 -0.49 -0.84 -0.52 -1.20 -0.57c-0.34 -0.05 -0.41 -0.26 -0.66 -0.32c-0.34 -0.09 -0.73 0.55 -0.92 0.78l0.00 0.00l-0.45 -0.14c-0.04 -0.21 -0.32 -0.30 -0.07 -0.47c0.23 -0.15 0.39 -0.12 0.39 -0.47c0.00 -0.18 0.05 -0.16 0.13 -0.29c0.12 -0.19 0.01 -0.46 -0.19 -0.55c-0.53 -0.24 0.02 -0.20 -0.27 -0.49c-0.14 -0.14 -0.37 -0.25 -0.55 -0.32c-0.40 -0.23 -0.41 -0.32 -0.58 -0.68c-0.11 -0.22 -0.43 -0.16 -0.51 -0.42c-0.21 -0.69 0.37 -0.75 -0.41 -1.18c-0.35 -0.20 -0.07 -0.60 -0.07 -0.90c0.41 -0.14 1.20 -0.22 0.56 -0.80c-0.50 -0.45 -0.57 -0.54 -0.87 -1.11c-0.13 -0.24 -0.79 -0.08 -1.07 -0.33l0.14 -0.42l0.00 0.00c0.14 0.20 0.31 0.34 0.61 0.21c0.55 -0.25 3.31 -3.07 3.56 -2.98l0.00 0.02c0.12 0.04 0.23 1.03 0.66 0.44c0.33 -0.46 0.53 -0.10 0.82 0.12c0.21 -0.01 0.38 -0.10 0.58 -0.10c0.14 0.00 0.23 0.18 0.37 0.18c0.12 -0.37 0.61 -1.28 0.95 -1.49c0.41 -0.25 1.24 -0.58 1.24 -1.12c-0.22 -0.07 -0.20 -0.54 -0.20 -0.73c-0.06 -0.02 -0.14 -0.18 -0.27 -0.20c-0.10 -0.42 0.21 -0.81 0.01 -1.13c-0.20 -0.32 -0.19 -0.73 -0.10 -1.03c0.37 0.00 0.88 0.09 0.88 -0.39c0.00 -0.39 0.21 -0.90 0.66 -0.90c0.06 0.18 0.39 0.29 0.58 0.29c0.08 -0.24 -0.06 -0.52 0.21 -0.60c0.35 -0.10 0.44 0.30 0.74 -0.07c0.21 -0.11 0.82 -0.57 0.95 -0.75c0.42 -0.59 0.44 -0.20 0.75 -0.20c0.01 0.05 0.24 -0.03 0.31 0.00c0.62 0.28 0.62 -0.38 1.31 -0.32c0.40 0.03 0.93 -0.17 0.93 -0.58c0.00 -0.78 0.19 -0.35 0.58 -0.66c0.31 -0.24 0.68 -1.65 1.20 -0.55l0.63 1.34c0.26 0.55 0.70 -0.28 1.01 0.12c0.33 0.42 0.54 1.14 0.82 1.60c0.27 0.44 1.29 0.34 1.29 1.22c-0.03 0.11 -0.01 0.35 0.04 0.59l0.00 0.00z"},23:{name:"H\xe0 Nam",path:"m81.79 72.24c0.11 0.09 0.25 0.22 0.33 0.33c0.14 0.19 0.21 0.31 0.41 0.46c0.14 0.10 0.37 0.17 0.55 0.17l0.01 0.01l0.00 0.00c0.09 -0.14 -0.09 -0.35 -0.04 -0.56c0.33 0.00 0.79 -1.08 0.88 -0.40c0.08 0.70 0.68 0.24 0.86 -0.14c0.13 -0.27 0.08 -0.73 0.46 -0.82c0.26 -0.06 0.34 0.26 0.62 0.26c0.33 0.00 0.18 -0.65 0.63 -0.68c0.24 -0.02 0.25 0.46 0.63 0.46l0.46 -0.08l0.00 0.00c0.00 -0.38 -0.08 -0.74 -0.20 -1.10c-0.13 -0.40 -0.67 -0.56 -0.76 -0.88c-0.10 -0.34 -0.14 -0.43 -0.48 -0.61l0.00 0.00c-0.42 0.10 -0.65 0.49 -1.02 0.08c-0.23 -0.25 -0.37 -0.97 -0.30 -1.33l-0.55 -0.37l0.00 0.00c0.00 0.13 -0.14 0.45 -0.21 0.57c-0.08 0.14 -0.50 0.54 -0.66 0.37c-0.10 -0.10 -0.07 -0.28 -0.18 -0.38c-0.13 -0.12 -0.47 0.14 -0.60 0.19c-0.17 0.17 -0.19 0.32 -0.42 0.38c-0.14 0.04 -0.43 -0.13 -0.56 -0.20c-0.63 -0.37 -0.36 0.31 -0.54 0.56c-0.21 0.29 -0.17 0.30 -0.25 0.63c-0.08 0.35 -0.20 0.57 -0.58 0.64l0.00 0.00l0.36 0.58c0.08 0.11 0.07 0.23 0.20 0.30c0.16 0.09 0.35 0.11 0.46 0.27c0.15 0.22 0.36 0.34 0.39 0.61c0.03 0.24 0.04 0.45 0.10 0.68l0.00 0.00z"},24:{name:"H\xe0 N\u1ed9i",path:"m80.28 69.80c0.38 -0.07 0.50 -0.29 0.58 -0.64c0.08 -0.33 0.04 -0.34 0.25 -0.63c0.18 -0.25 -0.09 -0.92 0.54 -0.56c0.13 0.08 0.42 0.24 0.56 0.20c0.23 -0.06 0.25 -0.22 0.42 -0.38c0.13 -0.05 0.47 -0.31 0.60 -0.19c0.11 0.10 0.08 0.27 0.18 0.38c0.17 0.17 0.58 -0.23 0.66 -0.37c0.07 -0.12 0.21 -0.44 0.21 -0.57l0.00 0.00l-0.54 -0.78c0.00 -0.17 -0.07 -0.34 -0.07 -0.49c-0.05 -0.02 -0.24 -0.27 -0.36 -0.32c-0.11 -0.05 -0.29 -0.01 -0.36 -0.11c-0.13 -0.19 -0.10 -1.02 0.15 -1.10c0.00 -0.37 -0.11 -0.40 -0.43 -0.53c-0.38 -0.15 0.11 -0.46 0.18 -0.60c0.10 -0.20 -0.23 -0.32 -0.23 -0.43c-0.13 -0.04 0.22 -0.38 0.24 -0.42c0.47 0.00 0.97 0.18 0.83 -0.50l0.67 -0.17l0.00 0.00l0.31 -0.76c-0.09 -0.23 -0.12 -0.49 -0.40 -0.58c-0.24 -0.07 -0.53 -0.02 -0.74 -0.10c-0.41 -0.16 -0.46 -0.77 -0.54 -1.12c-0.06 -0.25 0.05 -0.58 -0.11 -0.82c-0.07 -0.10 -0.20 -0.17 -0.17 -0.30c0.06 -0.24 -0.00 -0.25 -0.01 -0.48l0.45 -0.16l0.00 0.00c0.00 -0.18 -0.07 -0.34 -0.13 -0.50c-0.06 -0.17 0.03 -0.31 -0.09 -0.48c-0.09 -0.14 -0.25 -0.22 -0.33 -0.36l-0.38 -0.36l0.00 0.00l-0.01 0.01c-0.22 0.00 -0.21 0.01 -0.39 -0.11c-0.06 -0.04 -0.16 -0.20 -0.18 -0.27c-0.06 -0.27 0.05 -0.47 -0.25 -0.58c-0.08 -0.03 -0.38 0.03 -0.41 -0.05c-0.44 0.00 -0.37 0.16 -0.61 0.45l0.00 0.00l-0.33 0.72c-0.36 0.60 -1.13 0.94 -0.13 1.58c0.78 0.50 0.40 1.18 0.02 1.72c-0.19 0.28 -0.31 1.10 -0.63 0.45c-0.39 -0.77 -0.95 -0.24 -1.49 -0.64c-0.83 -0.63 -1.36 0.32 -2.17 -0.08c-0.39 -0.20 -0.72 -0.48 -0.95 -0.86c-0.38 -0.62 -0.24 -0.66 -0.18 -1.36l0.00 0.00l-0.75 -0.28c-0.24 -0.05 -0.62 -0.33 -0.72 0.09c-0.11 0.47 -0.09 1.30 -0.51 1.59c-0.22 0.15 -0.44 0.20 -0.55 0.47c-0.14 0.38 0.01 0.38 0.06 0.70c0.60 0.65 -0.33 1.23 -0.01 1.89l0.21 0.50l0.00 0.00l0.55 0.04c0.40 -0.08 0.63 -0.21 1.01 -0.14c0.32 0.06 0.70 0.03 1.01 0.11c0.25 0.07 0.70 0.48 0.90 0.66c0.33 0.30 -0.24 0.95 0.17 0.92c0.20 -0.01 1.06 -0.19 0.94 0.10c-0.17 0.41 -0.86 0.59 -0.11 0.96c0.10 -0.01 0.04 0.00 0.10 0.02c0.04 0.15 0.06 0.56 0.26 0.56c0.09 0.00 0.14 -0.09 0.26 -0.06c0.08 0.02 0.11 0.13 0.21 0.13c0.15 0.00 0.38 -0.15 0.36 0.11c-0.01 0.15 -0.07 0.35 -0.02 0.50c0.10 0.28 0.23 0.21 0.15 0.63c-0.12 0.63 0.36 0.71 0.61 1.15c0.15 0.27 -0.04 0.27 -0.11 0.52c-0.02 0.08 0.23 0.35 0.20 0.57c0.00 0.16 -0.50 0.41 -0.07 0.51c0.09 0.02 0.21 -0.01 0.32 0.01c0.14 0.02 0.07 0.24 0.30 0.24c0.29 0.00 0.48 0.11 0.67 0.30c0.07 0.07 0.30 0.39 0.30 0.48l0.00 0.00z"},25:{name:"H\xe0 T\u0129nh",path:"m78.03 116.99l1.23 -0.45c0.14 -0.16 0.37 -0.68 0.60 -0.68c0.16 0.00 0.26 0.31 0.43 0.31c0.25 0.00 2.03 0.05 1.55 -0.58c0.42 -0.14 0.80 -1.01 1.50 -0.50c0.48 0.34 1.82 0.70 1.94 1.19c0.18 0.69 -0.50 1.43 0.88 1.43c1.04 0.00 2.60 0.73 3.43 -0.31c1.42 -1.76 1.76 0.27 2.92 -0.16l0.00 0.00c-0.12 -0.13 -0.23 -0.27 -0.30 -0.41c-0.27 -0.52 -0.35 -1.05 -0.55 -1.59c-0.21 -0.59 -1.52 -0.34 -2.06 -1.18c-0.54 -0.86 -1.09 -1.35 -2.03 -1.81c-0.60 -0.43 -0.97 -0.15 -1.49 -0.38c-1.03 -0.46 -2.96 -2.29 -2.96 -3.47c-0.02 -0.01 -0.03 -0.02 -0.04 -0.04c-0.06 0.00 -0.23 0.16 -0.29 0.20c-1.33 -1.00 -1.54 -2.82 -2.23 -4.20c-0.05 -0.26 -0.27 -1.44 -0.36 -1.44c-0.02 -0.05 -0.20 -0.05 -0.37 -0.09l0.00 0.00c-0.16 0.75 0.44 1.48 -0.34 1.78c-0.27 0.10 -0.25 0.06 -0.42 0.31c-0.19 0.29 -0.11 0.62 -0.36 0.94c-0.76 0.76 -1.18 -0.01 -1.74 0.39c-1.05 0.76 -0.74 -0.23 -1.44 -0.66c-0.36 -0.22 -0.62 0.08 -0.95 0.20c-0.70 0.27 -1.37 0.27 -2.04 -0.10c-0.82 -0.45 -0.76 -0.50 -1.58 0.10l-0.94 -0.29l0.00 0.00c-0.09 0.08 -0.22 0.13 -0.41 0.15c-0.60 0.04 -0.62 0.64 -0.62 1.06c-0.32 0.08 -0.20 0.84 -0.21 1.07c-0.05 0.65 -0.20 0.68 0.24 1.31c0.38 0.27 1.10 0.57 1.10 0.99c0.00 0.86 0.71 1.70 1.50 2.14c0.29 0.16 0.67 -0.37 0.73 -0.21c0.22 0.58 -0.23 1.17 0.52 1.55c0.27 0.13 0.88 0.64 1.00 0.27c0.36 -1.10 0.50 -1.01 1.44 -0.60c0.63 0.28 -0.45 1.48 0.68 1.48c0.14 0.57 0.17 0.46 0.66 0.51c0.27 0.03 0.00 1.27 0.82 1.48c0.30 0.08 0.46 0.17 0.54 0.27l0.00 0.00z"},26:{name:"H\u1ea3i D\u01b0\u01a1ng",path:"m86.48 61.94l0.17 -0.33c0.48 0.15 0.44 0.62 1.01 0.38c0.42 -0.18 0.70 -0.37 1.14 -0.24c0.32 0.10 0.36 -0.12 0.44 -0.34c0.05 -0.15 0.31 -0.18 0.24 -0.41c-0.12 -0.39 0.19 -0.50 0.11 -0.79c-0.06 -0.24 -0.15 -0.41 -0.20 -0.67l-0.03 -0.27l0.00 0.00c0.12 -0.19 0.28 -0.03 0.35 -0.39c0.04 -0.20 -0.06 -1.28 0.33 -0.86c0.29 0.31 0.42 0.41 0.74 0.06c0.17 -0.19 0.37 -0.13 0.54 -0.27c0.28 -0.24 0.27 -0.55 0.76 -0.49c0.31 0.04 0.60 -0.05 0.90 -0.05l0.00 0.00l-0.23 0.88c-0.03 0.26 0.03 0.69 -0.13 0.92c-0.07 0.11 -0.78 0.56 -0.53 0.62c0.00 0.01 0.00 0.01 0.01 0.01c0.11 0.42 -0.11 0.69 0.49 0.56c0.31 -0.07 0.37 0.25 0.68 0.23c0.37 -0.03 0.84 -0.22 1.17 -0.01c0.25 0.16 0.32 0.39 0.48 0.61l0.00 0.00l-0.41 0.12c-1.17 0.00 0.18 0.84 -0.09 1.28c-0.13 0.21 -0.36 0.13 -0.53 0.21c-0.26 0.12 0.05 0.63 -0.08 0.84c0.00 0.35 0.10 0.50 -0.32 0.57c-0.16 0.03 -0.65 -0.25 -0.67 0.10c-0.01 0.16 0.19 0.23 0.14 0.36c-0.09 0.25 0.07 0.18 0.21 0.36c0.19 0.24 -0.43 0.26 -0.21 0.65c0.30 0.56 -0.46 0.43 -0.58 0.68c-0.03 0.06 0.01 0.58 -0.24 0.33c-0.10 -0.10 -0.07 0.07 -0.14 0.07c-0.11 0.00 -0.18 -0.11 -0.28 -0.15l-0.42 0.10l0.00 0.00c-0.02 0.00 -0.04 0.02 -0.05 0.04c-0.10 0.02 -0.39 0.27 -0.51 0.33c-0.28 0.14 -0.51 0.03 -0.78 0.07c-0.13 0.02 -0.24 0.12 -0.36 0.17c-0.22 0.10 -0.29 -0.20 -0.46 -0.18c-0.17 0.01 -0.20 0.18 -0.34 0.20l0.00 0.00c-0.10 -0.18 -0.27 -0.43 -0.45 -0.48c0.00 -1.21 -2.36 -0.89 -1.49 -2.63c0.20 -0.41 -0.37 -0.58 0.04 -0.99c0.20 -0.20 0.06 -0.40 0.01 -0.63l-0.43 -0.55l0.00 0.00z"},27:{name:"H\u1ea3i Ph\xf2ng",path:"m103.43 68.81c0.00 -0.27 -0.00 -1.17 0.48 -0.72c0.19 0.18 0.56 0.29 0.82 0.32c0.25 0.03 0.57 0.05 0.69 0.32c0.07 0.17 -0.02 0.32 -0.21 0.32c-0.37 0.00 -1.47 0.45 -1.72 0.10l-0.06 -0.33zm-2.11 -4.51c-0.18 0.00 -0.35 0.12 -0.48 0.24c-0.28 0.25 -0.93 0.02 -0.91 0.54c0.02 0.40 0.57 0.37 0.79 0.62c0.11 0.13 0.00 0.65 0.19 0.64c0.42 -0.03 0.82 0.12 1.19 0.38c0.11 0.08 0.30 0.27 0.41 0.08c0.07 -0.13 -0.52 -0.83 -0.08 -0.83c0.24 0.00 0.39 -0.10 0.44 -0.34c0.07 -0.36 -0.38 -0.42 -0.63 -0.57c-0.22 -0.14 -0.01 -0.86 -0.48 -0.70l-0.43 -0.06zm-10.02 2.30l0.42 -0.10c0.10 0.04 0.17 0.15 0.28 0.15c0.08 0.00 0.04 -0.17 0.14 -0.07c0.26 0.26 0.21 -0.27 0.24 -0.33c0.12 -0.25 0.89 -0.12 0.58 -0.68c-0.21 -0.39 0.41 -0.41 0.21 -0.65c-0.14 -0.18 -0.30 -0.11 -0.21 -0.36c0.05 -0.13 -0.15 -0.21 -0.14 -0.36c0.02 -0.35 0.50 -0.07 0.67 -0.10c0.42 -0.07 0.32 -0.22 0.32 -0.57c0.13 -0.21 -0.18 -0.72 0.08 -0.84c0.17 -0.08 0.40 -0.00 0.53 -0.21c0.27 -0.44 -1.09 -1.28 0.09 -1.28l0.41 -0.12l0.00 0.00c0.19 0.22 0.24 0.20 0.49 0.09c0.31 -0.14 0.67 0.21 0.98 0.27c0.53 0.11 1.10 -0.06 1.30 0.60c0.08 0.26 0.07 0.48 0.07 0.75c0.00 0.27 -0.23 0.49 -0.23 0.76c0.12 0.16 0.04 0.41 0.22 0.58c0.36 0.36 1.06 0.63 1.06 1.26l0.00 0.00c-0.19 -0.06 -0.38 -0.24 -0.38 -0.53c-0.12 -0.03 -0.65 -0.04 -0.69 -0.07c-0.16 -0.10 -0.35 -0.50 -0.55 -0.30c-0.19 0.19 0.09 1.17 0.23 1.36c-0.24 0.32 0.18 0.88 0.29 1.17c0.27 0.74 -0.46 -0.22 -0.69 0.14c-0.19 0.30 -0.36 0.38 -0.71 0.38c-0.12 0.49 -0.15 1.02 -0.61 1.21l0.00 0.00c-0.17 -0.17 -0.68 -0.43 -0.92 -0.51c-0.13 -0.05 -0.31 0.08 -0.42 0.13c-0.26 0.12 -0.77 0.49 -1.05 0.35c-0.41 -0.19 -0.27 -0.19 -0.69 0.01c-0.19 0.09 -0.48 -0.50 -0.55 -0.66c-0.11 -0.27 -0.68 -0.76 -0.63 -0.98c0.08 -0.34 0.20 -0.31 -0.14 -0.53l0.00 0.00z"},28:{name:"H\xf2a B\xecnh",path:"m76.44 73.20c0.36 0.15 0.40 -0.02 0.73 0.05c0.59 0.14 0.96 0.66 1.43 1.00c0.31 0.23 0.51 -0.09 0.80 -0.26c0.39 -0.23 -0.30 -0.97 -0.37 -1.27c-0.25 -1.06 0.98 0.35 1.01 0.38c0.03 -0.02 0.14 -0.01 0.15 -0.07c0.07 -0.02 -0.04 -0.28 -0.06 -0.33c-0.07 -0.19 -0.15 -0.51 -0.07 -0.72c0.01 -0.03 0.55 -0.33 0.61 -0.33c0.33 0.03 0.29 0.60 0.66 0.65l0.48 -0.07l0.00 0.00c-0.05 -0.23 -0.07 -0.44 -0.10 -0.68c-0.03 -0.27 -0.24 -0.39 -0.39 -0.61c-0.11 -0.16 -0.30 -0.18 -0.46 -0.27c-0.13 -0.07 -0.11 -0.19 -0.20 -0.30l-0.36 -0.58l0.00 0.00c0.00 -0.09 -0.23 -0.40 -0.30 -0.48c-0.19 -0.19 -0.39 -0.30 -0.67 -0.30c-0.23 0.00 -0.16 -0.22 -0.30 -0.24c-0.10 -0.02 -0.22 0.02 -0.32 -0.01c-0.42 -0.10 0.07 -0.35 0.07 -0.51c0.03 -0.21 -0.23 -0.48 -0.20 -0.57c0.07 -0.25 0.26 -0.25 0.11 -0.52c-0.25 -0.44 -0.73 -0.51 -0.61 -1.15c0.08 -0.42 -0.05 -0.35 -0.15 -0.63c-0.05 -0.15 0.00 -0.34 0.02 -0.50c0.02 -0.26 -0.21 -0.11 -0.36 -0.11c-0.10 0.00 -0.13 -0.10 -0.21 -0.13c-0.11 -0.03 -0.17 0.06 -0.26 0.06c-0.20 0.00 -0.22 -0.41 -0.26 -0.56c-0.06 -0.01 -0.01 -0.02 -0.10 -0.02c-0.75 -0.37 -0.06 -0.55 0.11 -0.96c0.12 -0.29 -0.75 -0.11 -0.94 -0.10c-0.41 0.03 0.16 -0.63 -0.17 -0.92c-0.20 -0.18 -0.65 -0.59 -0.90 -0.66c-0.31 -0.08 -0.69 -0.05 -1.01 -0.11c-0.38 -0.07 -0.61 0.06 -1.01 0.14l-0.55 -0.04l0.00 0.00c0.08 0.33 0.75 0.91 0.60 1.19c-0.32 0.58 -1.18 0.27 -1.60 0.18c-0.42 -0.10 -0.52 0.36 -0.86 0.36c-0.07 -0.22 -0.30 -0.60 -0.46 -0.73c-0.08 0.05 -1.00 0.41 -1.05 0.25c-0.25 0.00 -0.91 -1.00 -1.23 -1.19c-0.48 -0.30 -1.04 -0.68 -1.57 -0.82c-0.59 -0.16 -0.71 0.11 -0.71 -0.54l-0.20 -0.48l0.00 0.00l-0.66 0.23c-0.03 0.12 -0.29 0.44 -0.26 0.49c-0.11 0.03 0.19 0.44 0.23 0.51c0.28 0.58 1.08 1.96 1.63 2.30c0.61 0.38 0.20 1.62 0.56 1.80c0.97 0.48 -0.11 0.51 -0.02 1.03c0.06 0.34 0.37 0.74 -0.33 0.50c-0.45 -0.15 -1.26 -0.46 -1.74 -0.33c-1.08 0.28 -0.29 0.75 -0.48 1.18l-0.25 0.80l0.00 0.00l0.91 -0.38c0.64 -0.21 0.87 -0.13 1.47 0.31c0.27 0.19 0.36 0.83 0.52 1.10c0.03 0.05 0.78 0.40 0.86 0.38c0.26 -0.07 0.56 -0.34 0.83 -0.34c0.20 0.00 0.82 0.33 1.01 0.45c0.45 0.28 0.20 0.72 0.82 0.72c0.63 0.06 1.15 0.50 1.30 1.15c0.17 0.75 1.87 1.34 2.58 1.34c0.68 0.00 0.70 0.01 1.32 0.25c0.28 0.11 0.82 -0.19 0.97 -0.04l0.00 0.00z"},29:{name:"H\u1eadu Giang",path:"m82.60 260.37l-0.97 -0.80l0.00 0.00l-0.43 0.37c-0.54 0.11 -0.63 0.04 -1.11 -0.07c-0.52 -0.12 -0.62 0.29 -1.07 0.36c-0.19 0.03 -0.46 -0.07 -0.35 -0.31c-0.48 -0.16 -0.34 0.24 -0.75 0.24c-0.17 0.00 -0.51 -0.49 -0.66 -0.63c-0.36 -0.36 -0.75 1.01 -1.01 1.17l0.00 0.00c0.32 0.82 -0.35 1.23 -0.97 1.54c-0.18 0.09 -0.56 0.03 -0.67 0.24c-0.09 0.17 0.10 0.36 -0.08 0.55c-0.13 0.13 -0.38 0.09 -0.45 0.24c-0.06 0.12 0.07 0.19 -0.04 0.36c-0.20 0.33 -1.28 0.63 -1.28 1.05c0.00 0.33 0.44 0.35 0.68 0.42c0.38 0.11 0.35 0.27 0.54 0.53c-0.11 0.15 -0.23 0.44 -0.46 0.50c-0.03 0.15 -0.14 0.30 -0.14 0.48l0.00 0.00c0.25 -0.05 0.66 -0.01 0.85 -0.16c0.02 0.02 0.54 0.08 0.57 0.08c0.04 0.13 0.64 0.19 0.79 0.19c0.38 0.00 0.66 -0.27 1.01 -0.35l0.00 0.00l0.69 -0.26c0.57 -0.22 1.76 -0.40 2.16 -0.90c0.58 -0.72 1.92 -0.95 2.22 -1.85c0.15 -0.44 0.55 -2.86 0.93 -2.98l0.00 0.00z"},30:{name:"H\u01b0ng Y\xean",path:"m84.28 67.05l0.55 0.37c-0.07 0.36 0.08 1.08 0.30 1.33c0.37 0.42 0.60 0.02 1.02 -0.08l0.00 0.00c0.07 -0.08 0.29 -0.08 0.29 -0.16c-0.04 -0.01 -0.06 -0.23 -0.04 -0.27c0.07 -0.18 0.30 -0.38 0.47 -0.24c0.19 0.15 0.20 0.17 0.42 0.05c0.30 -0.17 0.50 0.19 0.76 0.13c0.21 -0.05 0.48 -0.40 0.66 -0.55l0.09 -0.41l0.00 0.00c-0.10 -0.18 -0.27 -0.43 -0.45 -0.48c0.00 -1.21 -2.36 -0.89 -1.49 -2.63c0.20 -0.41 -0.37 -0.58 0.04 -0.99c0.20 -0.20 0.06 -0.40 0.01 -0.63l-0.43 -0.55l0.00 0.00c-0.17 -0.16 -0.54 -0.45 -0.71 -0.39c-0.29 0.11 -0.57 0.01 -0.86 0.09c-0.20 0.06 -0.34 0.05 -0.53 -0.03l0.00 0.00l-0.67 0.17c0.13 0.68 -0.37 0.50 -0.83 0.50c-0.01 0.04 -0.37 0.37 -0.24 0.42c0.00 0.11 0.32 0.23 0.23 0.43c-0.07 0.14 -0.55 0.45 -0.18 0.60c0.32 0.12 0.43 0.15 0.43 0.53c-0.25 0.08 -0.29 0.91 -0.15 1.10c0.07 0.10 0.25 0.05 0.36 0.11c0.11 0.06 0.31 0.31 0.36 0.32c0.00 0.15 0.07 0.32 0.07 0.49l0.54 0.78l0.00 0.00z"},31:{name:"TP. H\u1ed3 Ch\xed Minh",path:"m101.49 248.64l0.43 0.30c0.11 0.28 -0.27 0.41 -0.18 0.64c0.03 0.09 0.09 0.15 0.11 0.25c0.02 0.09 0.15 0.33 0.15 0.42l0.00 0.00c-0.49 0.00 -0.66 0.85 -1.23 1.04c-0.81 0.26 0.95 0.78 0.04 1.16c-0.38 0.15 -0.62 0.04 -0.98 0.35c-0.81 0.69 -0.47 -0.29 -0.91 -0.29c-0.24 0.70 -1.04 -0.72 -1.25 -0.50l0.00 0.00l-0.85 -1.24l0.00 0.00c0.28 -0.38 0.27 -1.07 0.16 -1.48c0.00 -0.33 -0.54 -0.25 -0.30 -0.69c0.24 -0.45 0.02 -0.32 -0.28 -0.60c-0.59 -0.54 -0.84 0.82 -1.52 -0.01c-0.30 -0.37 -0.95 0.21 -1.12 -0.30c-0.14 -0.42 -0.32 -0.98 -0.76 -0.98c-0.41 0.00 -0.41 -0.54 -0.75 -0.63c0.00 -0.13 0.35 -0.35 0.44 -0.45c0.21 -0.23 0.14 -0.46 0.27 -0.69c0.12 -0.33 0.15 -0.70 0.24 -1.03c0.08 -0.29 0.17 -0.47 -0.14 -0.59c-0.44 -0.17 -1.14 -0.51 -1.51 -0.84c-0.45 -0.39 -0.89 -0.01 -1.10 -0.60l0.00 0.00c0.10 -0.04 0.17 -0.11 0.28 -0.13c0.53 -0.09 0.63 -0.10 0.63 -0.68c0.00 -0.36 0.28 -0.80 0.43 -1.13l0.07 -0.47l0.00 0.00l0.39 -0.40c0.24 0.15 0.47 0.16 0.71 0.31c0.39 0.25 0.17 0.39 0.26 0.64c0.14 0.00 0.12 0.54 0.29 0.69c0.22 0.21 0.29 0.28 0.61 0.23c0.65 -0.12 0.37 0.35 0.52 0.62c0.05 0.09 0.23 0.04 0.31 0.20c0.10 0.22 0.03 0.20 0.24 0.33c0.44 0.14 0.08 0.82 0.64 1.00c0.42 0.14 0.27 0.52 0.49 0.82c0.22 0.30 0.41 -0.40 0.66 -0.08c0.15 0.19 0.21 0.47 0.44 0.16c0.24 -0.31 0.38 0.10 0.65 -0.03c0.20 -0.09 0.36 -0.34 0.55 -0.38l0.00 0.00l0.33 0.84c0.08 0.15 0.72 1.24 0.30 1.34c-0.01 0.04 -0.31 -0.03 -0.41 0.05c-0.38 0.30 -0.29 -0.21 -0.62 0.00c-0.42 0.27 -1.18 0.84 -0.94 1.42c0.09 0.22 0.91 0.75 1.14 0.97c0.34 0.34 0.62 -0.21 1.02 -0.16c0.27 0.03 0.35 0.35 0.52 0.52c0.14 0.14 0.72 0.38 0.94 0.51c0.29 0.17 0.57 -0.21 0.57 -0.46l0.00 0.00z"},32:{name:"Kh\xe1nh H\xf2a",path:"m142.53 213.35c-0.26 -0.20 -0.72 -0.47 -1.02 -0.17c-0.22 0.22 -0.10 0.50 0.15 0.57c0.36 0.11 0.64 0.40 0.94 0.58c0.07 0.04 0.30 0.19 0.36 0.06c0.09 -0.20 -0.17 -0.47 -0.31 -0.61l-0.12 -0.44zm-1.99 7.39c-0.17 -0.09 -0.40 -0.35 -0.08 -0.39c0.09 -0.01 0.19 0.00 0.28 -0.03c0.07 -0.02 0.14 -0.07 0.21 -0.01c0.15 0.13 0.30 -0.02 0.47 -0.02c0.23 0.00 0.37 0.35 0.13 0.46c-0.11 0.05 -0.22 0.12 -0.34 0.16c-0.16 0.06 -0.32 -0.01 -0.48 0.00l-0.18 -0.16zm-9.40 0.69l0.64 0.01c0.13 -0.03 0.43 -0.03 0.53 -0.10c0.07 0.20 -0.13 0.50 -0.05 0.76c0.07 0.25 0.24 1.08 0.35 1.26c0.17 0.25 0.73 0.29 0.89 0.61c0.12 0.24 -0.21 0.59 0.20 0.76c0.29 0.12 1.09 0.37 1.27 0.56c0.43 0.43 0.89 0.13 1.36 0.37c0.37 0.21 0.70 0.70 0.84 1.12c0.17 0.51 0.32 0.67 0.76 0.88c0.15 0.08 0.30 0.17 0.48 0.16c0.27 -0.02 0.66 -0.38 0.89 -0.42l0.00 0.00c-0.12 -0.43 0.07 -1.02 -0.21 -0.60c-0.13 0.19 -0.43 0.81 -0.74 0.69c-0.22 -0.09 -0.50 -0.29 -0.32 -0.54c0.21 -0.29 0.13 -0.35 0.13 -0.68c0.00 -0.30 0.38 -0.22 0.56 -0.33c0.14 -0.09 0.62 -1.12 0.82 -0.84c0.49 0.70 -0.61 1.06 0.88 1.48c0.43 0.12 0.42 -0.24 0.25 -0.51c-0.37 -0.60 0.04 -0.71 -0.44 -1.37c-0.39 -0.55 -0.60 -1.23 -0.88 -1.86c-0.21 -0.47 -0.08 -0.69 0.36 -0.88c0.50 -0.22 -0.15 -0.60 -0.15 -0.80c-0.05 -0.28 -0.14 -0.79 -0.01 -1.01c0.22 -0.37 -0.19 -0.62 -0.08 -0.91c0.09 -0.22 0.61 -0.06 0.50 -0.54c-0.10 -0.44 -1.31 -1.98 -1.16 -2.18c0.45 -0.57 0.95 0.23 1.23 0.57c0.21 0.26 0.89 0.56 1.19 0.79c0.13 -0.20 0.57 -0.45 0.37 -0.81c-0.18 -0.33 -0.54 -0.35 -0.77 -0.58c-0.24 -0.24 0.18 -0.72 -0.32 -1.17c-0.32 -0.29 -0.63 -0.29 -0.63 -0.76c0.00 -0.14 0.30 -0.82 -0.04 -0.55c-0.52 0.41 -0.78 -0.23 -0.44 -0.69c0.19 -0.26 0.21 -0.29 0.18 -0.58c-0.04 -0.38 0.23 -0.42 0.41 -0.73c0.43 -0.29 0.74 -0.68 1.13 -0.97c0.33 -0.24 0.57 -0.55 0.85 -0.84c0.22 -0.22 0.11 0.49 0.15 0.64c0.26 0.93 0.23 0.70 -0.35 1.50c-0.47 0.66 0.94 -0.28 0.98 0.07c0.04 0.38 -0.23 0.79 -0.02 0.97c0.26 0.23 0.34 0.54 0.55 0.78c0.08 0.09 0.30 0.09 0.30 -0.07c0.00 -0.42 -0.62 -0.84 -0.12 -1.24c0.34 -0.27 -0.47 -1.00 -0.71 -1.30c-0.17 -0.21 -0.66 -1.45 -0.50 -1.77c0.13 -0.27 0.38 -0.44 0.62 -0.65l0.00 0.00c-0.02 -0.10 -0.21 -0.44 -0.31 -0.44c-0.08 -0.24 -0.55 0.08 -0.62 0.18c-0.29 0.41 -0.57 0.27 -0.99 0.37c-0.89 0.21 -1.37 -0.20 -2.00 0.56c-0.30 0.37 -0.79 0.28 -1.17 0.36c-0.08 0.41 -0.28 0.74 -0.73 0.74c-0.55 0.00 -0.72 0.51 -1.18 0.64l0.00 0.00l-0.14 0.21c-0.21 0.27 -0.06 0.37 -0.11 0.64c-0.03 0.17 -0.25 0.40 -0.18 0.54c0.06 0.13 0.08 0.27 0.05 0.41c-0.04 0.16 -0.33 0.14 -0.47 0.14c-0.57 0.11 -1.04 -0.01 -1.18 0.58c-0.05 0.20 -0.33 1.25 -0.26 1.37c0.12 0.21 0.62 0.89 -0.14 0.68c-0.33 -0.09 -0.91 -0.25 -1.16 -0.50c-0.68 -0.69 -0.68 0.42 -1.26 0.19c-0.27 -0.10 -0.40 0.41 -0.50 0.54c-0.34 0.42 0.03 1.53 -0.07 2.14l0.00 0.00c0.16 0.22 0.42 0.39 0.50 0.67c0.04 0.14 -0.10 0.50 -0.02 0.61c-0.02 0.02 0.00 0.06 0.00 0.10c0.09 0.03 0.18 0.63 0.23 0.75c0.06 0.19 -0.08 0.69 0.01 0.82l0.00 0.00z"},33:{name:"Ki\xean Giang",path:"m49.16 257.52c-0.21 -0.94 -0.28 -2.23 -1.07 -2.84c-0.64 -0.49 -1.56 -0.60 -1.26 -1.83c0.49 0.00 0.97 0.41 1.45 0.02c0.58 -0.46 0.87 -1.77 1.51 -0.81c0.24 0.36 0.67 0.37 0.87 0.78c0.30 0.60 0.24 1.79 0.24 2.48c0.00 0.59 -0.50 0.93 -0.61 1.48c-0.11 0.59 -0.18 1.32 -0.18 1.91c0.00 0.24 0.07 0.61 -0.30 0.58c-0.51 -0.04 -0.31 -0.77 -0.56 -1.01l-0.10 -0.76zm10.91 5.43c0.09 -0.12 0.23 -0.24 0.38 -0.28c0.11 -0.03 0.25 -0.01 0.35 0.05c0.20 0.14 -0.07 0.27 -0.19 0.29c-0.10 0.02 -0.18 0.07 -0.28 0.10c-0.13 0.05 -0.20 0.01 -0.32 -0.02l0.07 -0.15zm3.17 -12.55c-0.65 -0.10 -1.31 -0.30 -1.90 -0.41c-0.38 -0.07 -0.77 0.25 -1.07 0.02c-0.13 0.10 -0.87 0.60 -1.00 0.60c-0.00 0.01 -0.05 0.05 -0.06 0.06c0.00 0.02 0.01 0.02 -0.01 0.02c0.00 0.30 -0.22 0.56 -0.29 0.76c-0.03 0.00 -0.05 -0.00 -0.06 0.02c-0.19 0.00 -0.65 0.58 -0.70 0.75c-0.15 0.00 -0.30 -0.21 -0.42 -0.31l-0.65 0.10l0.00 0.00c0.11 0.24 0.13 0.50 0.40 0.72c0.51 0.41 0.87 0.88 1.07 1.49c0.19 0.58 1.11 0.42 1.11 1.25c0.07 0.74 0.00 1.80 0.99 1.55c0.00 -0.60 1.77 -1.55 2.35 -1.21c0.85 0.50 0.86 1.35 1.49 1.98c0.39 0.39 0.39 1.00 0.85 0.37c1.14 -1.58 3.37 1.58 3.15 2.49c-0.54 0.00 -0.76 -0.34 -1.29 0.13c-0.60 0.53 -0.80 1.49 -1.80 1.35c-0.72 -0.10 -0.86 1.32 -1.17 1.87c0.05 0.56 -0.56 2.28 -0.24 2.71c-0.06 0.14 -0.10 0.33 -0.13 0.56l0.00 0.00l1.19 0.88l0.51 -1.23l0.45 0.51l0.24 -0.24l0.57 0.16l0.30 -0.31l3.80 2.39l1.22 0.67l0.00 0.00l0.38 -0.12l-0.45 -1.05c0.00 -0.60 0.12 -0.79 0.52 -1.19c0.37 -0.37 -0.33 -0.91 -0.50 -1.24c-0.07 -0.15 -0.13 -0.78 0.14 -0.61c0.33 0.21 0.34 0.30 0.76 0.36c0.05 0.01 0.15 0.11 0.15 0.11c0.02 0.10 0.14 0.17 0.24 0.20l0.00 0.00c0.00 -0.17 0.11 -0.33 0.14 -0.48c0.24 -0.06 0.35 -0.35 0.46 -0.50c-0.19 -0.25 -0.15 -0.42 -0.54 -0.53c-0.24 -0.07 -0.68 -0.09 -0.68 -0.42c0.00 -0.42 1.07 -0.72 1.28 -1.05c0.10 -0.17 -0.02 -0.24 0.04 -0.36c0.08 -0.15 0.32 -0.11 0.45 -0.24c0.18 -0.18 -0.00 -0.38 0.08 -0.55c0.10 -0.21 0.49 -0.15 0.67 -0.24c0.62 -0.31 1.28 -0.71 0.97 -1.54l0.00 0.00l-3.04 -2.90l-0.17 -0.54l-0.49 -0.53l-0.35 0.14l-1.41 -1.18l0.00 0.00l-0.25 0.35l-1.37 -1.16l-1.94 -1.34l-2.60 -0.55l-1.30 -2.16l-0.11 -0.44l0.00 0.00z"},34:{name:"Kon Tum",path:"m109.85 180.33l1.14 0.08c0.34 0.00 0.66 0.31 1.05 0.23c0.42 -0.09 0.73 -0.45 1.22 -0.48c0.45 -0.03 0.26 0.60 0.36 0.84c0.11 0.25 0.71 1.08 0.52 1.29c-0.41 0.46 -0.88 0.31 -0.88 1.10c0.19 0.45 0.07 0.77 0.18 1.19c0.01 0.00 0.01 0.00 0.01 0.01c0.30 0.08 0.91 0.44 1.19 0.21c0.36 -0.30 0.62 -0.01 0.95 -0.21c0.39 -0.23 0.72 -1.39 1.33 -1.01c0.57 0.35 0.71 0.88 1.45 0.81c0.12 -0.03 0.16 -0.18 0.29 -0.18c0.26 -0.01 0.36 0.10 0.46 -0.22c0.13 -0.41 0.67 -0.12 0.78 -0.81c0.05 -0.28 0.32 -0.80 0.58 -0.94c0.24 -0.13 0.56 -0.19 0.83 -0.16c0.48 0.06 0.74 -0.44 1.16 -0.56c0.41 -0.11 0.65 0.13 1.11 -0.07c0.46 -0.28 0.64 -1.16 1.07 -1.52c0.33 -0.27 0.76 -0.59 0.55 -1.04c-0.16 -0.35 -0.43 -0.53 -0.32 -0.98c0.15 -0.66 1.24 0.44 1.46 0.64c0.57 0.53 0.86 0.23 1.32 -0.23l0.39 -0.31l0.00 0.00c0.00 -0.41 -0.26 -0.62 -0.66 -0.62c-0.68 0.00 0.04 -0.79 0.11 -0.97c0.10 -0.25 -0.29 -0.42 -0.18 -0.62c0.25 -0.44 0.29 -0.34 0.12 -0.90c-0.30 -0.97 -0.44 -0.24 -1.07 -0.63c-0.87 -0.54 -0.80 -0.69 -1.30 -1.48c-0.06 -0.09 -0.45 -0.32 -0.44 -0.35l-1.28 -1.42l-0.42 -0.91l0.00 0.00c-0.66 0.17 -0.78 -0.37 -1.30 -0.37c-0.91 0.00 -0.20 1.04 -0.39 1.48c-0.14 0.33 -0.84 0.10 -1.12 0.10c-0.54 0.00 -0.56 -0.71 -1.29 -0.64c-0.41 0.00 -0.92 -0.49 -0.86 -0.91c0.07 -0.49 0.50 -0.68 0.69 -1.10c0.29 -0.66 -0.73 -1.66 -1.35 -1.62c-0.86 0.05 -1.27 -0.26 -2.01 -0.35c-1.49 -0.18 -0.65 -0.73 -1.36 -1.43c-0.37 -0.37 -0.60 -0.02 -0.89 -0.67c-0.12 -0.27 -0.24 -1.52 -0.79 -1.15l-0.66 0.58l0.00 0.00c0.50 0.55 1.21 1.46 1.32 1.70c0.34 0.72 0.02 0.87 0.18 1.49c0.09 0.36 -0.28 0.27 -0.46 0.32c-0.47 0.12 -0.05 0.35 -0.15 0.49c0.10 0.14 -0.02 0.39 -0.08 0.55c-0.19 0.38 -0.64 0.36 -0.46 0.88c0.08 0.24 0.21 0.51 -0.14 0.55c-0.63 0.07 -0.07 0.29 -0.85 0.01c-0.30 -0.11 -0.48 0.17 -0.68 0.32c-0.11 -0.08 -0.71 0.08 -0.77 0.24c-0.18 0.47 0.85 1.30 1.11 1.50c0.35 0.27 0.53 0.55 0.98 0.82c0.29 0.18 -0.83 0.95 -1.01 1.22c-0.14 0.20 -0.60 0.54 -0.18 0.78c0.45 0.25 -0.14 0.69 0.06 0.69c0.00 0.01 0.12 0.14 0.14 0.18l0.07 0.45l0.00 0.00c0.56 0.00 0.03 1.58 -0.39 1.83c0.01 0.02 0.02 0.79 0.08 1.01c0.08 0.30 -0.22 0.76 -0.43 0.99c-0.05 0.06 -0.08 0.14 -0.09 0.23l0.00 0.00z"},35:{name:"Lai Ch\xe2u",path:"m47.66 48.82c0.04 -0.21 -0.12 -0.63 0.04 -0.74c0.34 -0.24 1.04 -0.14 0.77 -0.82c-0.19 -0.50 -0.81 -1.05 -1.11 -1.53c-0.20 -0.31 -0.31 -0.84 -0.13 -1.21c0.16 -0.31 0.52 -0.08 0.79 -0.08c0.08 0.25 0.53 -0.28 0.58 -0.32l0.26 -0.41l0.00 0.00c-0.03 -0.17 -0.20 -0.63 -0.39 -0.68c-0.07 -0.34 0.02 -0.43 0.02 -0.74c0.00 -0.33 -0.28 -0.41 -0.38 -0.67c-0.20 -0.48 0.24 -1.05 -0.27 -1.46c-0.24 -0.19 -0.79 -0.23 -0.93 -0.42c0.16 -0.22 -0.20 -0.51 -0.20 -0.68c-0.03 -0.01 -0.09 -0.13 -0.10 -0.14c-0.21 -0.37 -0.25 -0.91 -0.58 -1.13c-0.22 -0.15 -0.85 -0.24 -0.88 -0.50c-0.04 -0.34 0.35 -0.53 0.35 -0.75c0.00 -1.71 -2.08 -0.95 -2.97 -0.95c-0.09 -0.28 -0.28 -0.87 -0.61 -0.97c-0.44 -0.14 -0.37 -0.52 -0.11 -0.81c0.70 -0.79 0.40 -0.94 -0.29 -1.64l-0.56 -0.46l0.00 0.00c-0.03 -0.08 -0.39 -0.42 -0.49 -0.42c-0.00 -0.01 -0.09 -0.09 -0.10 -0.10c0.00 -0.09 -0.08 -0.19 -0.08 -0.27c-0.02 -0.01 -0.02 -0.03 -0.02 -0.06c-0.02 -0.01 -0.38 -0.70 -0.50 -0.81c-0.36 -0.36 -0.07 -0.37 0.02 -0.79c0.10 -0.45 -1.21 -0.99 -1.54 -1.12c-0.07 -0.03 -0.39 -0.21 -0.41 -0.17l-0.02 0.00l-0.50 1.78c-0.31 1.08 -1.46 0.90 -2.11 1.50c-0.85 0.85 0.64 1.08 -0.26 1.64c-0.39 0.24 -1.53 0.75 -1.42 1.28c0.09 0.43 -0.22 1.00 -0.70 0.63c-0.08 0.05 -0.65 -0.06 -0.68 -0.18c-0.04 -0.01 -0.20 -0.36 -0.21 -0.42c-0.03 -0.01 -0.03 -0.03 -0.06 -0.04c-0.09 -0.37 -1.06 0.35 -1.16 -0.61c-0.03 -0.25 -0.19 -0.30 -0.33 -0.48c-0.16 -1.27 -0.71 -1.62 -1.92 -1.62c-0.10 -0.39 -1.59 -1.53 -1.89 -1.46c-0.34 0.09 -0.55 0.23 -0.76 -0.20c-0.28 -0.56 -0.43 -0.32 -0.77 0.02c-0.31 0.31 -0.97 -0.80 -1.08 -1.05c-0.43 -0.97 -1.26 0.60 -1.38 1.00c-0.21 0.69 -0.81 0.49 -0.92 0.68c-0.11 0.19 0.10 0.42 0.18 0.63c0.00 0.27 -0.76 1.18 -1.00 1.36c-0.15 0.11 -0.27 0.22 -0.38 0.34l0.00 0.00l0.29 0.41c0.16 0.81 1.12 0.76 0.89 1.67c-0.10 0.40 0.03 0.63 0.35 0.87c0.39 0.29 0.58 0.55 0.88 0.92c0.03 0.29 0.51 1.07 0.69 1.31c0.46 0.59 0.41 0.31 0.93 0.17c0.92 -0.25 0.78 0.82 1.05 1.18c0.22 0.28 1.09 0.86 1.09 0.09c0.00 -0.31 -0.37 -0.79 -0.24 -1.06c0.11 -0.26 1.17 0.40 1.26 0.66c0.29 0.81 -0.69 1.02 0.17 1.80c0.79 0.69 0.53 0.90 1.67 0.78c0.54 -0.06 1.08 -0.72 1.35 -0.02c0.10 0.26 0.34 0.89 0.69 0.89c0.22 0.00 0.44 -0.40 0.79 -0.42c0.20 -0.01 1.09 0.02 1.13 -0.15c0.20 -0.75 0.13 -0.91 0.64 -0.32c0.33 0.25 0.51 0.12 0.91 0.12c0.55 0.00 1.04 0.52 1.56 0.59c0.43 0.06 0.30 -0.27 0.20 -0.48c-0.20 -0.41 0.01 -0.46 0.09 -0.76c0.28 -0.11 0.34 -0.39 0.49 -0.62c0.15 -0.24 1.11 -0.36 1.28 -0.10c0.20 0.32 0.29 0.74 0.48 1.07c0.32 0.57 0.86 0.51 0.64 1.23c-0.17 0.56 0.35 0.83 0.77 1.02l0.00 0.00c0.43 -0.60 0.49 -1.61 1.43 -0.84c0.30 0.25 0.75 0.25 1.04 0.48c0.15 0.12 0.28 0.19 0.43 0.36c0.04 0.04 0.05 0.19 0.06 0.26c0.01 0.06 0.08 0.27 0.06 0.27c0.17 0.14 0.80 1.22 0.73 1.47c-0.22 0.73 -0.57 0.97 0.32 1.18c0.38 0.09 0.40 0.35 0.57 0.62c0.35 0.54 0.89 0.33 1.23 1.13c0.37 0.88 0.75 0.27 1.30 0.27l0.00 0.00z"},36:{name:"L\xe0o Cai",path:"m48.86 43.72l0.25 0.43c-0.06 0.58 1.17 0.87 1.48 0.70c0.53 -0.30 1.13 0.14 1.66 0.35c1.53 0.59 -0.15 -1.71 1.24 -0.79c0.10 0.06 0.95 0.10 1.13 0.14c0.27 0.06 0.42 0.86 0.67 0.86c0.06 0.17 0.35 -0.24 0.38 -0.27c0.06 -0.09 0.37 -0.38 0.38 -0.44c1.72 -0.34 -0.35 -2.87 -0.15 -3.31c0.14 -0.31 0.38 -0.37 0.25 -0.78c-0.17 -0.52 -0.16 -0.88 0.37 -1.07c0.58 -0.21 0.93 0.62 1.26 0.95c0.21 0.16 0.57 0.33 0.71 0.54c0.08 0.11 0.29 0.36 0.43 0.36c0.01 0.02 0.07 0.02 0.10 0.02c0.04 0.12 0.32 -0.35 0.32 -0.50c0.00 -0.32 -0.19 -0.97 0.29 -1.00c0.43 -0.03 0.60 -0.22 0.60 -0.68c-0.41 -0.14 -0.94 0.04 -0.94 -0.69l0.00 0.00l-0.45 -0.14c-0.04 -0.21 -0.32 -0.30 -0.07 -0.47c0.23 -0.15 0.39 -0.12 0.39 -0.47c0.00 -0.18 0.05 -0.16 0.13 -0.29c0.12 -0.19 0.01 -0.46 -0.19 -0.55c-0.53 -0.24 0.02 -0.20 -0.27 -0.49c-0.14 -0.14 -0.37 -0.25 -0.55 -0.32c-0.40 -0.23 -0.41 -0.32 -0.58 -0.68c-0.11 -0.22 -0.43 -0.16 -0.51 -0.42c-0.21 -0.69 0.37 -0.75 -0.41 -1.18c-0.35 -0.20 -0.07 -0.60 -0.07 -0.90c0.41 -0.14 1.20 -0.22 0.56 -0.80c-0.50 -0.45 -0.57 -0.54 -0.87 -1.11c-0.13 -0.24 -0.79 -0.08 -1.07 -0.33l0.14 -0.42l0.00 0.00c-0.16 -0.23 -0.26 -0.54 -0.45 -0.63c-1.04 -0.52 -0.99 -0.06 -0.80 -1.52c0.10 -0.75 -1.84 0.16 -2.31 0.16c-0.86 0.00 -0.66 0.67 -1.20 1.04c-0.13 0.08 -0.65 0.55 -0.56 0.68c-0.52 0.52 -0.30 2.88 -0.54 3.70l-0.94 0.33c-0.89 -1.02 -1.73 -2.12 -2.75 -2.90c-0.98 -0.74 -1.83 -1.65 -2.65 -2.55l-0.45 0.45c-0.27 0.34 -0.16 0.69 -0.58 0.95c-0.25 0.16 -0.09 0.56 -0.11 0.81c-0.04 0.72 -0.42 1.21 -1.14 1.21l0.00 0.00l0.56 0.46c0.69 0.70 0.99 0.85 0.29 1.64c-0.26 0.29 -0.34 0.68 0.11 0.81c0.33 0.10 0.52 0.69 0.61 0.97c0.89 0.00 2.97 -0.76 2.97 0.95c0.00 0.23 -0.38 0.41 -0.35 0.75c0.03 0.27 0.66 0.35 0.88 0.50c0.34 0.23 0.37 0.77 0.58 1.13c0.01 0.01 0.06 0.13 0.10 0.14c0.00 0.17 0.37 0.46 0.20 0.68c0.14 0.19 0.68 0.22 0.93 0.42c0.51 0.41 0.08 0.97 0.27 1.46c0.10 0.25 0.38 0.34 0.38 0.67c0.00 0.31 -0.09 0.40 -0.02 0.74c0.19 0.05 0.36 0.51 0.39 0.68l0.00 0.00z"},37:{name:"L\u1ea1ng S\u01a1n",path:"m85.96 44.18l0.49 0.31c-0.12 0.32 -0.10 0.35 -0.30 0.61c-0.18 0.24 0.35 0.54 0.10 0.87c-0.14 0.18 -0.38 0.76 -0.14 0.99c-0.02 0.01 0.15 0.12 0.18 0.14c0.26 0.21 0.54 0.62 0.80 0.78c0.20 0.13 1.55 0.39 1.13 0.81c-0.38 0.38 -0.34 0.86 -0.54 1.32l-0.35 0.41l0.00 0.00c-0.18 0.25 -0.31 0.27 -0.27 0.62c0.02 0.25 -0.07 0.45 -0.07 0.70c0.16 0.05 0.01 0.56 0.46 0.56c0.38 0.00 0.34 0.01 0.63 0.19c0.30 0.18 0.76 -0.09 1.10 0.02c0.32 0.11 -0.19 0.68 0.27 0.78c0.75 -0.07 0.26 0.83 0.88 0.95c0.39 0.08 0.92 0.30 0.97 -0.29c0.02 -0.22 0.27 -0.62 0.56 -0.51c0.17 0.06 0.56 0.17 0.56 -0.16c0.00 -0.39 0.50 -0.49 0.75 -0.74c0.13 -0.13 -0.11 -0.28 -0.11 -0.45c0.00 -0.26 0.21 -0.37 0.31 -0.58c0.33 -0.52 0.57 -1.48 1.39 -1.25c0.43 0.12 1.04 -0.08 1.39 0.23c0.52 0.46 0.60 1.70 1.28 0.68c0.51 -0.76 0.99 0.25 1.35 0.37c0.00 0.79 -0.08 0.65 0.62 0.82c0.50 0.13 0.47 0.58 0.61 0.99c0.46 0.00 0.08 -0.07 0.45 0.18c0.46 0.30 0.78 -0.47 1.06 -0.10c0.27 0.36 -0.58 0.67 -0.21 1.04c0.25 0.17 0.41 0.23 0.48 0.54c0.04 0.19 0.42 0.37 0.42 0.51l0.00 0.00c0.08 -0.10 0.33 -0.51 0.48 -0.51c0.01 -0.02 0.44 -0.09 0.55 -0.36c0.26 -0.67 0.68 0.07 0.99 -0.02c0.23 -0.07 0.30 -0.27 0.57 -0.27c0.27 0.00 0.36 0.08 0.57 0.12c0.06 0.24 0.56 -0.09 0.63 -0.21c0.12 -0.22 -0.00 -0.58 -0.07 -0.80c-0.14 -0.44 -0.30 -0.77 -0.17 -1.28c-0.00 -0.03 -0.01 -0.19 -0.06 -0.20c0.00 -0.12 -0.22 -0.36 -0.26 -0.50c-0.16 -0.53 0.30 -0.35 0.55 -0.39c0.34 -0.05 0.34 -0.53 0.66 -0.53c0.02 -0.05 0.22 -0.02 0.27 -0.02c0.14 0.00 0.61 -0.19 0.75 -0.19l0.00 0.00c-0.13 -0.25 -0.18 -0.75 -0.27 -1.22c-0.69 -0.17 -0.04 -1.40 -1.26 -0.99c-0.48 0.16 -1.31 0.74 -1.53 -0.13c-0.73 -0.19 -0.77 -0.71 -1.28 -1.07c-0.43 -0.31 -1.43 -0.27 -1.51 -0.78c0.00 -0.28 -0.30 -0.44 0.01 -0.67c0.29 -0.21 0.44 -0.30 0.56 -0.62c0.15 -0.40 -0.84 -0.61 -0.92 -0.85l-0.07 0.00c-0.41 1.25 -1.14 -0.00 -1.47 -0.25c-0.56 -0.43 -1.58 -0.16 -2.23 -0.26c-0.41 -0.06 -1.13 -0.58 -1.39 0.20c-0.72 0.00 0.33 -2.77 -0.23 -3.38c-0.52 -0.57 0.14 -0.93 0.10 -1.38c-0.03 -0.15 -0.21 -0.81 -0.27 -0.94c-0.22 -0.45 -0.47 -0.05 -0.42 -0.74c0.07 -0.95 -1.36 -0.21 -1.57 -0.75c-0.14 -0.37 0.17 -0.90 0.02 -1.32c-0.01 -0.04 -0.03 -0.08 -0.04 -0.12l0.00 0.00c-0.55 0.33 -1.08 0.41 -1.49 0.94c-0.50 0.64 -0.47 0.26 -1.12 0.18c-0.27 -0.03 -0.64 0.19 -0.85 0.08c-0.40 -0.20 -0.24 -0.73 -0.57 -0.90c-0.50 -0.25 -0.92 -0.24 -1.26 -0.74c-0.22 -0.32 -0.53 0.13 -0.66 0.07c-0.01 0.04 -0.31 0.35 -0.37 0.43l-0.21 0.62l0.00 0.00l0.50 0.54c0.18 0.48 -0.27 0.53 -0.23 0.92c0.02 0.18 0.16 0.27 0.30 0.36c0.08 0.06 0.33 0.28 0.30 0.30c0.47 0.47 -0.27 1.00 -0.01 1.67c0.04 0.11 -1.17 1.98 -1.61 1.98c-1.56 0.00 -0.08 1.62 -0.51 2.35l-0.14 0.30l0.00 0.00z"},38:{name:"L\xe2m \u0110\u1ed3ng",path:"m130.42 218.48c0.16 0.22 0.42 0.39 0.50 0.67c0.04 0.14 -0.10 0.50 -0.02 0.61c-0.02 0.02 0.00 0.06 0.00 0.10c0.09 0.03 0.18 0.63 0.23 0.75c0.06 0.19 -0.08 0.69 0.01 0.82l0.00 0.00l-0.30 0.05c-0.12 -0.03 -0.24 0.22 -0.26 0.32c-0.03 0.17 0.07 0.28 0.10 0.42c0.06 0.02 0.17 0.32 0.19 0.39c0.04 0.14 0.02 0.34 -0.04 0.47c-0.15 0.56 -0.64 1.09 -0.70 1.62c-0.07 0.61 -0.11 1.17 -0.11 1.80c0.00 0.60 -0.22 0.35 -0.48 0.79c-0.21 0.35 0.59 0.58 0.64 0.79c0.09 0.32 0.04 1.22 0.46 1.32c0.00 1.41 -2.89 0.16 -2.24 2.01l0.22 0.68l0.00 0.00c0.00 1.17 -0.78 0.49 -1.45 0.47c-0.35 -0.01 -0.84 0.25 -1.14 0.14c-0.42 -0.16 -0.87 0.42 -1.08 0.10c-0.40 -0.61 -1.00 -0.08 -1.45 0.17c-0.44 0.89 0.14 0.84 0.49 1.42c-0.17 0.44 -1.04 1.21 -1.40 1.58c-0.57 0.57 -1.56 0.72 -2.26 1.19c-0.20 0.13 -0.70 0.89 -0.80 0.42c-0.10 -0.46 0.06 -1.02 -0.35 -1.40c-0.50 -0.47 -1.77 -0.64 -2.43 -0.83c-0.67 -0.07 -1.57 -0.09 -2.23 0.04c-0.69 0.14 -0.87 1.25 -1.69 0.69c-0.30 -0.20 -0.95 -0.31 -1.13 -0.54c-0.57 -0.72 -0.40 -0.18 -0.89 0.13l0.00 0.00c-0.18 -0.18 -0.34 -0.64 -0.62 -0.70c0.01 -0.01 -0.12 -0.21 -0.13 -0.30c-0.02 -0.14 -0.06 -0.25 -0.18 -0.33c-0.18 -0.12 -0.69 -0.04 -0.69 -0.23c0.00 -0.22 0.27 -0.26 0.30 -0.43c0.26 -0.41 0.05 -0.32 -0.18 -0.60c-0.20 -0.24 -0.49 -0.17 -0.67 -0.37c-0.14 -0.15 -0.26 -0.10 -0.45 -0.02c-0.23 0.10 -0.24 -0.40 -0.27 -0.56c-0.09 -0.63 -0.39 0.24 -0.64 0.20l0.00 0.00c-0.06 -0.25 -0.46 -0.36 -0.54 -0.58c-0.14 -0.39 0.12 -0.67 -0.26 -0.98c-0.28 -0.23 -0.43 -0.41 -0.20 -0.78c0.18 -0.28 0.10 -0.62 0.28 -0.90c0.26 -0.40 0.68 -0.28 0.99 -0.54l0.66 -0.14l0.00 0.00c0.19 -0.01 0.28 0.14 0.49 0.14c0.16 0.00 0.21 -0.14 0.31 -0.14c0.01 -0.02 0.46 -0.03 0.62 -0.39c0.22 -0.48 1.10 0.13 1.42 -0.27c0.42 -0.52 0.99 -0.64 1.39 -1.07c0.24 -0.26 1.36 -1.54 1.57 -0.76c0.32 1.15 0.83 0.98 1.94 0.56c0.24 0.00 0.89 -0.11 1.04 0.13c0.12 0.19 -0.06 0.59 -0.01 0.84c0.08 0.35 0.45 0.17 0.62 0.04c0.27 -0.22 0.46 0.54 1.10 0.20c0.53 -0.28 1.61 -0.84 1.78 -1.48c0.04 -0.15 -0.62 -1.13 -0.77 -1.21c-0.14 -0.07 -0.45 -0.78 -0.58 -0.99c-0.24 -0.40 -0.01 -0.37 -0.44 -0.62c-0.92 -0.55 -0.06 -0.90 0.12 -1.37c0.30 -0.77 1.08 0.08 1.53 -0.19l0.49 -0.61l0.00 0.00c0.34 -0.07 0.60 -0.42 0.98 -0.23c0.29 0.14 0.84 0.49 1.17 0.38c0.30 -0.09 0.76 -1.19 1.07 -0.95c0.29 -0.21 0.69 -0.45 0.98 -0.67c0.60 0.44 0.85 -0.01 1.35 -0.29c0.18 -0.10 0.45 -0.58 0.63 -0.56c0.28 0.03 0.33 0.64 0.79 0.36c0.54 -0.33 0.86 0.19 1.35 0.04c0.43 -0.13 0.97 -0.51 1.32 -0.78l0.00 0.00z"},39:{name:"Long An",path:"m75.84 242.66l0.28 0.63l1.08 0.07l0.39 1.12l-0.28 0.10l1.47 1.52l1.72 1.59l0.71 0.16l1.42 1.89l0.64 0.13l0.00 0.00l1.97 0.21c0.38 -0.02 0.79 0.01 0.70 -0.44c-0.12 -0.57 0.27 -0.38 0.66 -0.41l2.49 -0.18c0.86 -0.06 1.32 1.88 2.08 1.94c1.65 0.12 -0.31 0.93 0.49 1.10c0.28 0.06 0.86 0.36 0.95 0.07c0.40 -0.40 0.56 -0.36 1.07 -0.17c0.59 0.22 0.39 0.08 0.80 -0.26c0.22 -0.18 0.48 -0.10 0.66 -0.38c0.38 -0.62 0.37 0.05 0.57 0.39c0.19 0.31 0.71 -0.64 0.88 -0.72c0.10 -0.05 0.18 -0.12 0.24 -0.21l0.00 0.00c0.28 -0.38 0.27 -1.07 0.16 -1.48c0.00 -0.33 -0.54 -0.25 -0.30 -0.69c0.24 -0.45 0.02 -0.32 -0.28 -0.60c-0.59 -0.54 -0.84 0.82 -1.52 -0.01c-0.30 -0.37 -0.95 0.21 -1.12 -0.30c-0.14 -0.42 -0.32 -0.98 -0.76 -0.98c-0.41 0.00 -0.41 -0.54 -0.75 -0.63c0.00 -0.13 0.35 -0.35 0.44 -0.45c0.21 -0.23 0.14 -0.46 0.27 -0.69c0.12 -0.33 0.15 -0.70 0.24 -1.03c0.08 -0.29 0.17 -0.47 -0.14 -0.59c-0.44 -0.17 -1.14 -0.51 -1.51 -0.84c-0.45 -0.39 -0.89 -0.01 -1.10 -0.60l0.00 0.00c-0.05 0.01 -0.09 -0.02 -0.13 -0.05c0.01 -0.04 -0.25 -0.15 -0.30 -0.17c-0.13 -0.08 -0.24 -0.17 -0.36 -0.26c-0.25 -0.18 -0.54 -0.10 -0.72 0.14c-0.12 0.17 0.15 0.35 0.06 0.47c-0.13 0.18 -0.47 0.09 -0.67 0.15l-0.89 0.13l0.00 0.00c-0.38 0.09 -0.79 -0.34 -0.75 0.21c0.03 0.39 -0.34 0.68 -0.07 1.03c0.24 0.31 1.43 1.60 0.66 1.60c-0.46 0.00 -0.97 -0.01 -1.41 0.08c-0.75 0.16 -1.26 -0.40 -1.78 -0.92l-0.91 -0.91c-0.16 -0.16 -0.14 1.18 -0.46 1.18c-0.04 0.16 -0.44 -0.11 -0.51 -0.14c-0.19 -0.09 -0.57 -0.03 -0.70 -0.16c-0.28 -0.25 0.24 -0.78 -0.31 -1.30c-0.33 -0.41 -0.66 -0.90 -0.82 -1.38c-0.04 -0.11 -0.16 -0.20 -0.17 -0.23c-0.34 0.09 -0.67 0.19 -1.02 0.23c-0.09 0.01 -1.03 0.53 -1.04 0.55c-0.55 0.00 -1.34 0.37 -1.88 0.50c-0.10 0.02 -0.27 0.02 -0.45 0.01l0.00 0.00z"},40:{name:"Nam \u0110\u1ecbnh",path:"m83.09 73.21c0.13 0.18 0.45 0.26 0.21 0.50c-0.33 0.33 0.59 0.49 0.67 0.90c0.13 0.64 0.16 0.48 0.80 0.52c0.40 0.02 0.04 0.63 0.30 0.80c0.27 0.18 0.48 -0.30 0.65 -0.44c0.38 -0.30 0.10 0.58 0.63 0.36c0.49 -0.21 0.40 0.06 0.63 0.34c-0.04 0.47 0.13 0.95 0.01 1.47c-0.07 0.30 -0.20 0.56 -0.27 0.88c-0.06 0.26 -0.20 0.37 -0.36 0.55c-0.24 0.25 -0.14 0.64 -0.32 0.91c-0.16 0.24 -0.06 0.68 0.04 0.93l-0.25 0.69l0.00 0.00c0.07 0.08 0.12 0.24 0.18 0.46c0.48 0.00 1.53 -2.03 2.00 -2.36c0.44 -1.04 1.82 -2.33 2.78 -2.92c0.52 -0.32 1.77 -0.81 2.36 -0.81c0.43 0.00 0.25 0.79 1.10 0.23c0.14 -0.09 0.16 -0.68 0.14 -1.23l0.00 0.00c-0.30 -0.23 -0.75 -0.48 -1.05 -0.72c-0.39 -0.32 -0.88 0.40 -1.26 0.39c-0.31 -0.01 -0.56 -0.40 -0.69 -0.64c-0.14 -0.03 -0.24 -0.36 -0.46 -0.42c-0.18 -0.04 -0.48 -0.09 -0.57 -0.28c-0.26 -0.53 -0.90 0.37 -1.32 0.46c-0.44 0.10 -0.47 -0.29 -0.29 -0.60c0.15 -0.25 0.86 -0.75 0.04 -0.78c-0.84 -0.04 -1.05 0.07 -0.78 -0.79c0.13 -0.41 -0.21 -0.29 -0.41 -0.35l0.00 0.00l-0.46 0.08c-0.38 0.00 -0.39 -0.48 -0.63 -0.46c-0.45 0.03 -0.30 0.68 -0.63 0.68c-0.28 0.00 -0.36 -0.32 -0.62 -0.26c-0.38 0.10 -0.33 0.55 -0.46 0.82c-0.18 0.37 -0.77 0.84 -0.86 0.14c-0.08 -0.68 -0.54 0.40 -0.88 0.40c-0.05 0.21 0.13 0.41 0.04 0.56l0.00 0.00z"},41:{name:"Ngh\u1ec7 An",path:"m70.04 105.50l0.94 0.29c0.83 -0.60 0.77 -0.55 1.58 -0.10c0.67 0.37 1.33 0.36 2.04 0.10c0.33 -0.13 0.60 -0.42 0.95 -0.20c0.70 0.43 0.39 1.41 1.44 0.66c0.56 -0.40 0.98 0.37 1.74 -0.39c0.25 -0.32 0.17 -0.66 0.36 -0.94c0.17 -0.26 0.15 -0.21 0.42 -0.31c0.79 -0.30 0.18 -1.04 0.34 -1.78l0.00 0.00c-0.14 -0.03 -0.27 -0.08 -0.32 -0.20c-0.20 -0.45 -0.32 -0.97 -0.49 -1.46c-0.28 -0.78 -1.20 -0.22 -1.31 -1.54c-0.07 -0.80 -0.37 -1.71 0.19 -2.41c0.27 -0.36 0.78 -0.44 1.20 -0.44c0.49 0.00 0.59 -0.01 0.29 -0.47c-0.22 -0.33 -0.08 -1.28 0.14 -1.64c0.15 -0.25 0.05 -0.55 0.38 -0.67c0.31 -0.11 0.41 -0.17 0.56 -0.43c-0.10 -0.13 0.33 -0.39 0.49 -0.67l0.00 0.00c-0.46 0.00 -0.96 -0.30 -1.46 -0.30c-0.74 0.00 -0.56 0.32 -1.01 -0.49c-0.56 -1.00 -1.19 -0.33 -1.76 -1.62c-0.45 -1.01 -0.74 -0.53 -1.55 -0.33c-0.40 0.10 -1.68 -0.52 -1.81 -0.94c-0.13 -0.42 -0.05 -1.14 -0.62 -0.73c-0.31 0.23 -0.71 1.76 -0.95 0.62c-0.11 -0.52 0.10 -1.29 -0.06 -1.74c-0.36 -1.05 0.20 -0.74 -0.88 -1.04c-0.36 -0.10 -0.41 -0.57 -0.83 -0.66c-0.17 -0.24 -0.43 -0.21 -0.27 -0.60c0.07 -0.18 0.22 -0.43 -0.02 -0.55c-0.52 -0.26 -0.48 -0.47 -0.48 -1.11c0.00 -0.33 0.25 -0.51 0.25 -0.78c0.14 -0.04 0.51 -0.33 0.77 -0.39c0.00 -0.21 0.01 -0.82 -0.33 -0.85c-0.42 -0.03 -0.76 -0.31 -1.08 -0.33c-0.21 -0.02 -0.45 0.02 -0.68 0.02c-0.33 0.00 -0.58 -0.19 -0.87 -0.20l-1.12 -0.73l0.00 0.00c-0.10 0.14 -0.32 0.19 -0.71 0.06c-0.38 -0.13 -1.53 0.82 -1.91 1.21c-1.36 1.36 -0.46 0.63 0.36 1.46c-0.42 0.83 0.40 1.18 -1.11 1.18l-0.27 0.67c-1.18 0.00 -0.66 0.17 -1.73 0.99c0.33 0.61 -0.23 0.46 -0.07 0.92c0.08 0.24 -0.17 0.49 -0.41 0.38c-0.58 -0.26 -0.51 -0.04 -0.97 0.19c-0.33 0.17 -0.95 -0.14 -0.99 -0.12c-0.18 -0.24 -0.25 -0.60 -0.57 -0.51c-0.70 0.19 -0.79 -0.35 -1.08 -0.84c-0.26 -0.42 -1.06 0.10 -1.28 0.31l-0.43 0.22c0.00 -0.09 -0.00 -0.19 -0.01 -0.29c-0.00 -0.02 -0.08 -0.11 -0.08 -0.11c-0.42 -0.00 -1.00 -0.33 -1.35 -0.20c-0.18 0.07 -0.34 0.23 -0.55 0.23c-0.41 0.00 -0.61 -0.29 -0.85 0.30c-0.24 0.58 -1.12 -0.13 -1.44 -0.29c-0.24 -0.12 -0.42 -0.04 -0.60 0.13c-0.07 0.07 -0.17 0.11 -0.27 0.12l0.21 0.51c-0.20 1.05 1.26 1.22 1.26 1.62c0.00 0.22 0.15 0.92 0.12 0.99c-0.07 0.20 -0.41 0.38 -0.51 0.78c-0.51 0.00 -0.18 0.31 -0.36 0.63c-0.11 0.20 -0.26 0.10 -0.42 0.02c-0.22 -0.11 -0.17 0.15 -0.31 0.19c0.00 0.18 -0.50 0.19 -0.66 0.19c-0.51 0.00 -0.83 1.43 -1.58 1.43c-0.01 0.04 -0.62 0.54 0.02 0.49c0.47 -0.04 0.95 0.36 1.18 0.73c0.75 1.19 1.73 -0.37 2.23 0.55c0.08 0.14 0.85 0.69 0.95 0.66c0.70 -0.24 0.56 0.08 0.91 0.54c0.57 0.62 0.06 1.03 1.28 0.90c0.15 -0.02 2.11 1.17 2.20 1.42c0.12 0.31 0.49 0.81 0.88 0.81c0.22 0.00 0.49 -0.25 0.63 -0.20c0.21 0.07 0.15 0.39 0.41 0.39l0.75 1.01c0.68 0.93 2.74 1.36 3.00 2.15c0.42 0.00 0.42 0.19 0.95 0.19c0.55 0.00 1.07 0.56 1.75 0.32c1.17 -0.41 0.63 1.22 1.60 0.74c0.48 0.12 0.55 -0.20 0.87 0.29c0.15 0.23 0.43 0.09 0.67 0.36c0.22 0.25 1.26 -0.30 1.26 0.08c0.00 0.59 0.14 0.39 0.58 0.70c0.38 0.28 0.47 0.64 0.24 0.85l0.00 0.00z"},42:{name:"Ninh B\xecnh",path:"m84.60 81.10c0.28 0.05 0.27 0.48 0.58 0.72c0.34 -0.26 0.51 -0.32 0.63 -0.19l0.00 0.00l0.25 -0.69c-0.09 -0.25 -0.19 -0.69 -0.04 -0.93c0.18 -0.27 0.09 -0.66 0.32 -0.91c0.16 -0.18 0.30 -0.29 0.36 -0.55c0.07 -0.32 0.20 -0.58 0.27 -0.88c0.12 -0.52 -0.06 -1.01 -0.01 -1.47c-0.22 -0.28 -0.13 -0.55 -0.63 -0.34c-0.53 0.22 -0.25 -0.66 -0.63 -0.36c-0.17 0.14 -0.38 0.61 -0.65 0.44c-0.25 -0.17 0.10 -0.78 -0.30 -0.80c-0.64 -0.04 -0.67 0.12 -0.80 -0.52c-0.08 -0.41 -1.00 -0.57 -0.67 -0.90c0.24 -0.24 -0.08 -0.32 -0.21 -0.50l0.00 0.00l-0.01 -0.01c-0.18 0.00 -0.41 -0.07 -0.55 -0.17c-0.21 -0.15 -0.27 -0.27 -0.41 -0.46c-0.08 -0.12 -0.22 -0.24 -0.33 -0.33l0.00 0.00l-0.48 0.07c-0.36 -0.05 -0.32 -0.62 -0.66 -0.65c-0.06 -0.01 -0.60 0.30 -0.61 0.33c-0.08 0.20 0.00 0.52 0.07 0.72c0.02 0.05 0.13 0.32 0.06 0.33c-0.01 0.06 -0.12 0.05 -0.15 0.07c-0.03 -0.02 -1.26 -1.44 -1.01 -0.38c0.07 0.29 0.76 1.03 0.37 1.27c-0.29 0.17 -0.48 0.48 -0.80 0.26c-0.47 -0.34 -0.84 -0.86 -1.43 -1.00c-0.32 -0.08 -0.37 0.09 -0.73 -0.05l0.00 0.00l-0.07 0.39c0.10 0.54 0.50 0.52 0.91 0.71c0.32 0.15 0.59 0.48 0.88 0.66c0.50 0.06 0.94 1.12 1.44 1.39c0.63 0.35 1.23 0.36 1.81 0.94c0.31 0.31 0.97 0.24 1.13 0.72c0.43 0.31 0.97 0.74 1.51 0.77c0.52 0.03 0.98 -0.08 1.45 -0.08c0.11 0.33 -0.06 0.65 -0.22 0.98c-0.15 0.33 -0.46 0.45 -0.55 0.79l-0.11 0.63l0.00 0.00z"},43:{name:"Ninh Thu\u1eadn",path:"m128.63 232.09l-0.22 -0.68c-0.65 -1.85 2.24 -0.60 2.24 -2.01c-0.42 -0.11 -0.38 -1.01 -0.46 -1.32c-0.06 -0.21 -0.85 -0.44 -0.64 -0.79c0.26 -0.44 0.48 -0.19 0.48 -0.79c0.00 -0.63 0.04 -1.19 0.11 -1.80c0.06 -0.53 0.55 -1.06 0.70 -1.62c0.06 -0.12 0.07 -0.32 0.04 -0.47c-0.02 -0.07 -0.13 -0.38 -0.19 -0.39c-0.02 -0.14 -0.13 -0.25 -0.10 -0.42c0.02 -0.11 0.14 -0.35 0.26 -0.32l0.30 -0.05l0.00 0.00l0.64 0.01c0.13 -0.03 0.43 -0.03 0.53 -0.10c0.07 0.20 -0.13 0.50 -0.05 0.76c0.07 0.25 0.24 1.08 0.35 1.26c0.17 0.25 0.73 0.29 0.89 0.61c0.12 0.24 -0.21 0.59 0.20 0.76c0.29 0.12 1.09 0.37 1.27 0.55c0.43 0.43 0.89 0.13 1.36 0.37c0.37 0.21 0.70 0.70 0.84 1.12c0.17 0.51 0.32 0.67 0.76 0.88c0.15 0.08 0.30 0.17 0.48 0.16c0.27 -0.02 0.66 -0.38 0.89 -0.42l0.00 0.00c0.04 0.14 0.11 0.27 0.25 0.34c0.59 0.29 0.68 1.36 -0.08 1.55c0.00 0.14 -0.07 0.39 -0.17 0.51c-0.29 0.29 -0.38 0.75 -0.38 1.13c-0.73 0.24 -0.26 1.08 -0.99 0.90c-0.33 -0.09 -1.49 -0.72 -1.49 0.10c0.00 1.28 -0.70 2.74 -0.18 3.68c0.13 0.23 -1.58 1.21 -2.12 0.67c-0.13 -0.13 -0.26 -0.21 -0.39 -0.25l0.00 0.00c0.23 -0.57 -0.92 -0.91 -1.32 -1.11c-1.10 -0.55 -0.05 -1.68 -1.63 -1.42c-0.73 0.12 -0.62 -1.04 -0.97 -1.36l-1.19 -0.05l0.00 0.00z"},44:{name:"Ph\xfa Th\u1ecd",path:"m74.53 56.56l-0.75 -0.28c-0.24 -0.05 -0.62 -0.33 -0.72 0.09c-0.11 0.47 -0.09 1.30 -0.51 1.59c-0.22 0.15 -0.44 0.20 -0.55 0.47c-0.14 0.38 0.01 0.38 0.06 0.70c0.60 0.65 -0.33 1.23 -0.01 1.89l0.21 0.50l0.00 0.00c0.08 0.33 0.75 0.91 0.60 1.19c-0.32 0.58 -1.18 0.27 -1.60 0.18c-0.42 -0.10 -0.52 0.36 -0.86 0.36c-0.07 -0.22 -0.30 -0.60 -0.46 -0.73c-0.08 0.05 -1.00 0.41 -1.05 0.25c-0.25 0.00 -0.91 -1.00 -1.23 -1.19c-0.48 -0.30 -1.04 -0.68 -1.57 -0.82c-0.59 -0.16 -0.71 0.11 -0.71 -0.54l-0.20 -0.48l0.00 0.00c0.00 -0.12 -0.27 -0.23 -0.30 -0.36c-0.01 -0.04 -0.38 -0.25 -0.37 -0.27c-0.12 -0.03 -0.22 -0.30 -0.31 -0.39c-0.16 -0.16 0.11 -0.44 0.06 -0.66c-0.11 -0.49 -0.18 -0.95 -0.18 -1.48c0.00 -0.40 -0.32 -0.61 -0.55 -0.91l0.00 0.00l0.27 -0.20c0.54 0.41 0.29 -0.49 0.55 -0.39c0.16 0.06 0.49 0.41 0.60 0.14c0.04 -0.10 -0.31 -0.54 -0.36 -0.68c-0.03 -0.08 0.42 -0.44 0.43 -0.74l0.01 -0.61c0.00 -0.20 -0.12 -0.36 -0.12 -0.55c0.00 -0.39 -0.78 -0.99 -0.31 -1.27c0.44 -0.26 0.17 -1.15 0.45 -1.21c0.02 -0.09 0.48 -0.29 0.55 -0.24c0.05 -0.03 0.09 -0.04 0.14 -0.08c-0.12 -0.25 0.74 -0.37 0.82 -0.41c0.34 -0.15 0.21 -0.81 0.91 -0.49c0.11 0.05 0.46 0.22 0.57 0.12c0.09 -0.08 0.17 -0.53 0.11 -0.62l0.00 0.00c0.63 -0.06 0.97 0.48 1.63 0.57c0.29 0.04 0.86 0.40 1.08 0.56c0.31 0.22 -0.37 0.56 -0.01 0.78c0.56 0.33 0.28 0.85 0.73 1.19c0.50 0.39 0.28 0.76 1.08 0.76l0.00 0.00c-0.08 0.42 -0.17 0.86 -0.05 1.29c0.15 0.53 0.55 -0.02 0.97 0.36c0.24 0.22 0.08 0.82 0.08 1.09c0.09 0.02 0.51 0.53 0.64 0.66c0.21 0.21 0.39 0.55 0.21 0.86l0.00 0.00z"},45:{name:"Ph\xfa Y\xean",path:"m135.85 211.53c0.46 -0.13 0.63 -0.64 1.18 -0.64c0.45 0.00 0.65 -0.33 0.73 -0.74c0.38 -0.08 0.86 0.01 1.17 -0.36c0.63 -0.77 1.11 -0.35 2.00 -0.56c0.42 -0.10 0.70 0.04 0.99 -0.37c0.07 -0.10 0.54 -0.42 0.62 -0.18c0.10 0.00 0.29 0.34 0.31 0.44l0.00 0.00c0.08 -0.07 0.16 -0.14 0.24 -0.21c0.06 -0.06 0.52 -0.42 0.49 -0.18c-0.02 0.20 -0.25 0.34 -0.20 0.51c1.24 0.00 0.30 -1.19 -0.06 -1.77c0.03 -0.43 -0.77 -1.38 -1.02 -1.79c-0.47 -0.77 -0.49 -0.29 -1.04 -0.69c-0.22 -0.16 0.14 -0.73 0.14 -0.97c0.00 -0.43 -0.50 -0.81 -0.31 -1.31c0.04 -0.11 0.54 -1.13 0.15 -1.13c-0.03 -0.09 -0.21 0.15 -0.24 0.20c-0.05 0.09 -0.12 0.26 -0.24 0.26c-0.06 -0.19 -0.18 -0.40 -0.24 -0.62c-0.06 -0.20 0.77 -0.01 0.41 -0.42c-0.43 -0.48 -0.05 -0.30 -0.05 -0.72c-0.01 -0.00 -0.04 -0.04 -0.05 -0.05c-0.25 0.00 -0.92 -0.05 -0.75 -0.49c0.22 -0.57 -0.30 -0.85 -0.12 -1.55c0.10 -0.40 0.46 -0.33 0.69 -0.02c0.39 0.52 -0.29 0.42 -0.29 0.76c1.05 0.35 1.09 0.39 0.80 -0.78c0.07 -0.37 -0.18 -0.51 -0.31 -0.80c-0.22 -0.50 0.45 -0.55 -0.26 -1.21c-0.67 -0.62 -1.03 -0.99 -0.60 -1.86l0.00 0.00c-0.25 -0.25 -0.50 -0.39 -0.86 -0.39c-0.06 0.19 -0.42 0.21 -0.46 0.66c-0.04 0.37 -0.45 0.18 -0.63 0.41c-0.28 0.35 0.20 1.18 -0.66 1.18c-0.44 0.00 -0.53 0.38 -0.80 0.57c-0.35 0.25 -1.07 0.62 -1.45 0.27c-0.69 -0.61 -1.19 0.15 -1.74 -0.69l0.00 0.00l-0.60 -0.05c-0.15 -0.02 -0.26 -0.13 -0.44 -0.13c-0.13 0.00 -0.26 -0.01 -0.39 -0.01c-0.25 0.00 -0.39 0.20 -0.42 0.43c-0.06 0.55 -0.81 0.62 -0.54 1.29c0.13 0.33 0.37 0.32 0.69 0.32c0.34 0.00 0.81 -0.39 0.81 0.14c0.00 0.25 0.07 0.52 -0.08 0.73c0.00 0.76 -0.29 0.84 0.49 1.16c0.10 0.04 0.63 0.77 0.71 0.91c0.15 0.23 -0.22 1.83 -0.35 2.10c-0.36 0.77 -1.00 0.26 -1.26 0.62c-0.14 0.20 -0.21 0.64 -0.25 0.88l-0.14 0.95c0.09 0.22 -0.45 0.32 -0.57 0.33l-0.75 0.31l0.00 0.00l0.55 0.64c-0.16 0.56 0.53 -0.05 0.80 0.49c0.19 0.38 0.73 0.84 0.83 1.25c0.74 0.15 0.72 -0.17 1.06 0.66c0.30 0.72 1.61 -0.09 2.00 0.48c0.43 0.62 -0.01 1.20 0.30 1.72l0.00 0.00z"},46:{name:"Qu\u1ea3ng B\xecnh",path:"m93.62 134.98l0.86 0.16c0.33 1.63 1.03 0.20 1.70 0.50c0.38 0.17 1.05 1.03 1.37 0.25c0.10 -0.25 0.09 -0.50 0.29 -0.69c0.14 -0.14 0.31 -0.12 0.44 -0.29c0.18 -0.23 -0.15 -0.87 0.43 -0.87c0.70 0.00 0.28 -0.75 0.99 -0.88c0.35 -0.07 1.43 -0.86 1.51 -1.21l0.00 0.00c-0.31 -0.26 -0.60 -0.52 -0.84 -0.78c-0.83 -0.92 -2.45 -1.35 -3.11 -2.41c0.00 -0.31 -1.38 -1.69 -1.73 -1.86c-0.79 -0.38 -1.12 -2.26 -1.62 -2.98c-0.17 -0.24 -0.48 -0.27 -0.64 -0.47c-0.48 -0.58 -0.99 -2.26 -1.24 -3.06c-0.17 -0.40 -0.17 -0.82 -0.17 -1.25c0.00 -0.39 0.55 -0.47 0.55 -0.86c0.80 -0.26 0.44 -0.64 0.10 -1.04l0.00 0.00c-1.16 0.43 -1.50 -1.60 -2.92 0.16c-0.83 1.04 -2.40 0.31 -3.43 0.31c-1.38 0.00 -0.71 -0.74 -0.88 -1.43c-0.13 -0.50 -1.47 -0.85 -1.94 -1.19c-0.70 -0.51 -1.08 0.36 -1.50 0.50c0.48 0.64 -1.29 0.58 -1.55 0.58c-0.17 0.00 -0.27 -0.31 -0.43 -0.31c-0.22 0.00 -0.46 0.52 -0.60 0.68l-1.23 0.45l0.00 0.00c0.25 0.33 -0.43 0.77 -0.48 1.14c-0.15 0.57 0.02 0.56 0.12 0.98c0.86 0.22 0.92 1.39 1.62 2.10c0.31 0.31 0.38 0.82 0.58 1.22c0.36 0.70 0.32 0.29 0.97 0.45c0.01 0.03 0.02 0.03 0.05 0.04c0.07 0.29 1.48 1.62 1.75 1.97l2.20 2.84l3.44 2.70c0.11 -0.05 0.33 -0.14 0.45 -0.14c0.06 -0.19 0.13 -0.36 0.13 -0.58c0.02 -0.01 0.01 -0.02 0.01 -0.05c0.55 -0.18 0.54 -0.31 0.54 0.26c0.00 0.44 0.48 0.48 0.48 0.81c-1.03 0.34 0.23 1.04 0.44 1.31c0.14 0.18 0.09 0.40 0.15 0.60c0.12 0.36 0.57 0.36 0.68 0.84c0.12 0.51 0.24 1.25 0.73 1.60c0.80 0.58 0.95 -0.10 1.72 -0.10l0.01 0.01z"},47:{name:"Qu\u1ea3ng Nam",path:"m127.36 153.78c-0.06 -0.07 -0.21 -0.41 -0.04 -0.41c0.21 0.00 0.38 0.30 0.49 0.46c0.04 0.07 0.17 0.22 0.14 0.30c-0.05 0.16 -0.35 -0.06 -0.42 -0.09l-0.17 -0.27zm-4.41 16.38c-0.03 -0.28 -0.25 -0.54 -0.12 -0.84c0.32 -0.73 0.99 -1.25 0.99 -2.08c-0.04 -0.01 -0.11 -0.19 -0.15 -0.20c0.00 -0.15 0.24 -0.20 0.35 -0.32c0.00 -0.00 -0.48 -0.21 -0.17 -0.57c0.32 -0.37 0.40 -0.94 1.18 -0.68c0.67 0.22 0.86 -0.35 1.45 -0.35c1.18 0.00 1.78 -0.51 2.87 -0.72c0.93 -0.18 1.33 -0.10 2.08 -0.86l0.00 0.00c-0.18 -0.08 -0.36 -0.19 -0.47 -0.30c-0.30 -0.30 -0.02 -0.86 -0.33 -1.18c-0.85 -0.36 -1.22 -0.13 -1.87 -1.03c-0.74 -1.02 -1.51 -1.86 -2.07 -2.97c-0.24 -0.48 -0.40 -1.04 -0.70 -1.47c-0.15 -0.21 -0.31 -0.55 -0.31 -0.81c0.00 -0.12 0.20 -0.72 0.06 -0.76l-1.24 -0.50c-0.16 -0.19 -0.56 -0.65 -0.92 -1.18l0.00 0.00c-0.36 0.12 -0.98 -0.17 -1.17 0.21c-0.39 0.77 -0.50 -0.48 -0.84 0.07c-0.31 0.51 -0.24 0.04 -0.55 0.16c-0.15 0.06 -0.20 0.30 -0.36 0.30c-0.16 0.00 -0.27 -0.14 -0.46 -0.11c-0.21 0.03 -0.35 0.25 -0.58 0.20c-0.30 -0.06 -0.44 -0.18 -0.77 -0.12c-0.19 0.03 -0.54 0.26 -0.69 0.08c-0.63 -0.79 0.07 -0.94 -0.14 -1.60c-0.11 -0.35 -0.32 -0.50 -0.32 -0.91l-0.01 -0.01c-0.71 0.00 -0.66 0.87 -1.53 0.14l-0.75 0.02l0.00 0.00c-0.18 0.00 -0.32 0.07 -0.51 0.02c-0.25 -0.07 -0.33 0.02 -0.49 0.20c-0.52 0.19 -0.69 1.02 -1.01 1.02c-0.41 0.00 -0.66 -0.54 -1.11 -0.67c-0.37 -0.11 -0.08 -0.64 -0.48 -0.54c-0.27 0.07 -1.02 0.20 -1.02 0.52c0.00 0.85 -0.74 -0.09 -0.99 -0.10l-0.54 0.25l0.00 0.00c-0.05 0.61 -0.63 1.99 -0.79 2.25c-0.21 0.33 -0.65 0.08 -0.94 0.06c-0.35 -0.03 -0.48 0.35 -0.62 0.57c-0.08 0.13 -0.55 0.04 -0.72 0.04c-0.25 0.00 -0.25 0.19 -0.39 0.33c-0.14 0.14 -0.88 -0.20 -0.63 0.49c0.21 0.59 -0.38 1.21 -0.05 1.59c0.16 0.19 1.74 0.08 0.86 0.95c0.21 1.08 0.65 0.31 1.20 0.93c0.25 0.28 0.25 0.68 0.37 1.03c0.46 1.34 1.59 1.36 2.78 1.60c0.15 0.61 0.01 1.32 0.86 1.32c0.06 0.00 0.24 0.17 0.46 0.42l0.00 0.00l0.66 -0.58c0.55 -0.37 0.67 0.88 0.79 1.15c0.29 0.65 0.52 0.29 0.89 0.67c0.71 0.71 -0.13 1.25 1.36 1.43c0.74 0.09 1.16 0.39 2.01 0.35c0.62 -0.04 1.64 0.96 1.35 1.62c-0.19 0.42 -0.62 0.61 -0.69 1.10c-0.06 0.42 0.45 0.91 0.86 0.91c0.72 -0.07 0.75 0.64 1.29 0.64c0.28 0.00 0.98 0.23 1.12 -0.10c0.19 -0.44 -0.51 -1.48 0.39 -1.48c0.52 0.00 0.64 0.54 1.30 0.37l0.00 0.00z"},48:{name:"Qu\u1ea3ng Ng\xe3i",path:"m137.18 163.18c-0.03 -0.07 -0.07 -0.36 0.05 -0.36c0.05 0.00 0.09 0.02 0.14 0.02c0.12 0.01 0.24 -0.02 0.36 -0.02c0.15 0.01 0.09 0.23 0.05 0.31c-0.10 0.17 -0.34 0.20 -0.52 0.20l-0.09 -0.16zm0.89 1.06c-0.01 0.00 -0.05 0.02 -0.05 0.02c-0.13 0.00 -0.58 -0.05 -0.52 -0.28c0.07 -0.25 0.76 -0.31 0.97 -0.27c0.12 0.03 0.34 0.18 0.42 0.27c0.16 0.16 -0.41 0.21 -0.48 0.23l-0.34 0.03zm-8.53 14.58l0.61 -0.58c0.36 -0.25 0.36 -0.42 0.85 -0.40c1.28 0.05 0.62 -0.02 0.89 -1.03c0.06 -0.22 2.63 -0.86 3.04 -0.68l1.40 0.61c0.23 0.10 0.53 0.83 0.43 1.06l0.51 0.36l0.00 0.00c-0.00 -0.34 -0.20 -0.90 -0.20 -1.07c0.00 -0.44 0.25 -0.71 -0.06 -1.15c-0.42 -0.58 -0.75 -1.16 -1.10 -1.79c-0.42 -0.76 -0.39 -1.59 -0.76 -2.34c0.07 -0.70 -0.67 -1.65 -0.73 -2.48c-0.04 -0.52 -0.27 -1.00 -0.30 -1.54c-0.03 -0.49 0.73 -0.56 0.73 -1.00c-0.01 -0.00 -0.11 -0.08 -0.12 -0.10c-0.51 -0.10 -1.01 -0.70 -1.01 -1.21c0.00 -0.56 -0.19 -0.55 -0.62 -0.93c-0.25 -0.22 -0.06 -0.85 -0.36 -0.98c-0.24 -0.11 -0.53 0.22 -0.79 0.16c-0.15 -0.04 -0.35 -0.10 -0.53 -0.19l0.00 0.00c-0.76 0.76 -1.15 0.68 -2.08 0.86c-1.09 0.21 -1.69 0.72 -2.87 0.72c-0.60 0.00 -0.78 0.57 -1.45 0.35c-0.78 -0.26 -0.86 0.31 -1.18 0.68c-0.31 0.37 0.17 0.57 0.17 0.57c-0.10 0.12 -0.35 0.17 -0.35 0.32c0.04 0.01 0.12 0.19 0.15 0.20c0.00 0.83 -0.67 1.35 -0.99 2.08c-0.13 0.30 0.09 0.55 0.12 0.84l0.00 0.00l0.42 0.91l1.28 1.42c-0.01 0.02 0.39 0.26 0.44 0.35c0.50 0.79 0.43 0.94 1.30 1.48c0.64 0.39 0.77 -0.34 1.07 0.63c0.17 0.55 0.13 0.46 -0.12 0.90c-0.11 0.20 0.28 0.37 0.18 0.62c-0.07 0.17 -0.79 0.97 -0.11 0.97c0.40 0.00 0.66 0.21 0.66 0.62l0.00 0.00c0.38 0.03 0.64 0.19 0.79 0.54c0.05 0.13 0.10 0.32 0.26 0.35c0.08 0.01 0.40 -0.03 0.43 -0.12l0.00 0.00z"},49:{name:"Qu\u1ea3ng Ninh",path:"m114.37 55.63c0.22 -0.07 0.80 -0.61 0.99 -0.54c0.00 0.21 -0.61 0.61 -0.79 0.70c-0.13 0.07 -0.24 0.18 -0.39 0.24c-0.27 0.10 -0.16 -0.04 -0.09 -0.23l0.27 -0.17zm2.66 -0.66c-0.20 0.12 -0.77 0.32 -0.92 0.07c-0.20 -0.33 0.60 -0.35 0.77 -0.38c0.33 -0.05 0.69 -0.17 1.02 -0.24c0.11 -0.03 0.53 -0.20 0.61 -0.10c0.15 0.18 -0.39 0.37 -0.49 0.41c-0.09 0.03 -0.21 0.14 -0.29 0.21c-0.07 0.07 -0.30 0.04 -0.41 0.08l-0.30 -0.04zm-9.27 7.48c-0.18 0.23 -0.24 0.10 -0.47 0.10c-0.41 0.00 -0.55 0.78 0.13 0.39c0.17 -0.09 0.38 -0.08 0.52 -0.19c0.16 -0.12 0.21 -0.21 -0.01 -0.30l-0.17 -0.01zm0.80 2.93c-0.14 -0.26 -0.34 -0.01 -0.31 0.20c0.01 0.10 0.10 0.24 0.20 0.26c0.10 0.02 0.18 -0.13 0.18 -0.20l-0.07 -0.26zm-0.96 -0.53c-0.06 -0.04 -0.10 -0.10 -0.17 -0.12c-0.14 -0.03 -0.35 0.08 -0.26 0.24c0.05 0.08 0.18 0.13 0.26 0.20c0.08 0.07 0.21 0.26 0.33 0.22c0.12 -0.04 0.12 -0.28 0.06 -0.36l-0.22 -0.17zm0.01 -1.07c-0.13 -0.06 -0.43 -0.14 -0.56 -0.07c-0.06 0.04 0.15 0.30 0.18 0.35c0.07 0.09 0.16 0.08 0.26 0.06c0.05 -0.01 0.16 0.05 0.21 0.06c0.10 0.03 0.27 0.03 0.35 -0.05c0.11 -0.09 0.09 -0.27 -0.07 -0.29l-0.39 -0.07zm3.12 -0.94c-0.10 0.21 -0.15 0.39 -0.32 0.58c-0.30 0.34 -0.61 0.36 -0.64 0.91c-0.01 0.11 -0.02 0.28 -0.06 0.38c-0.20 0.48 -0.08 0.41 0.14 0.02c0.14 -0.25 0.23 -0.53 0.41 -0.76c0.19 -0.25 0.37 -0.55 0.57 -0.80c0.06 -0.08 0.24 -0.45 0.02 -0.42l-0.11 0.08zm-1.42 0.08c0.42 -0.50 0.73 -1.10 1.17 -1.58c0.52 -0.56 0.28 0.44 0.24 0.69c-0.04 0.26 -0.05 0.63 -0.22 0.85c-0.13 0.16 -0.65 0.23 -0.87 0.32c-0.09 0.04 -0.98 0.44 -0.61 -0.02l0.29 -0.25zm1.37 -2.87c0.09 -0.20 0.28 -0.38 0.47 -0.50c0.13 -0.08 0.24 -0.07 0.22 0.10c-0.02 0.22 -0.20 0.45 -0.33 0.63c-0.10 0.13 -0.39 0.31 -0.39 0.03l0.02 -0.26zm0.70 1.21c0.06 -0.24 0.02 -0.64 0.14 -0.85c0.09 -0.16 0.38 -0.83 0.57 -0.83l0.01 0.01c0.00 0.29 -0.18 0.67 -0.24 0.97c-0.08 0.38 -0.29 0.75 -0.39 1.12c-0.04 0.14 -0.07 0.38 -0.18 0.47c-0.21 0.19 -0.00 -0.43 -0.01 -0.49l0.11 -0.39zm-3.32 -0.89c0.00 -0.68 0.60 -0.82 0.71 -1.32c0.03 -0.14 -0.08 -0.44 0.01 -0.53c0.26 -0.26 0.34 -0.53 0.43 -0.88c0.05 -0.17 0.15 -0.91 0.33 -0.90c0.40 0.03 0.68 1.33 1.23 1.33c0.33 0.00 1.14 -0.59 1.00 -0.01c-0.11 0.44 -1.80 1.43 -2.23 1.71c-0.31 0.20 -1.04 1.18 -1.39 0.97l-0.08 -0.39zm0.53 -2.83c0.27 -0.39 -0.35 -0.72 -0.29 -0.14c0.02 0.20 -0.03 0.27 -0.11 0.45c-0.03 0.06 -0.08 0.16 -0.08 0.23c0.00 0.08 0.04 0.11 0.06 0.17c0.12 0.03 0.35 -0.28 0.41 -0.40l0.02 -0.30zm6.85 4.02c0.03 -0.14 0.31 -0.47 0.43 -0.54c0.13 -0.07 0.36 -0.09 0.26 0.13c-0.07 0.16 -0.20 0.31 -0.31 0.44c-0.10 0.12 -0.15 0.31 -0.27 0.41c-0.05 0.04 -0.17 0.15 -0.24 0.12c-0.07 -0.04 0.01 -0.14 0.01 -0.20l0.11 -0.36zm-1.11 0.41c-0.08 -0.02 -0.41 -0.63 -0.23 -0.63c0.10 0.00 0.17 0.14 0.25 0.19c0.20 0.12 0.48 -0.02 0.48 0.33c0.00 0.33 -0.11 0.56 -0.30 0.81c-0.07 0.09 -0.33 0.14 -0.26 -0.01c0.06 -0.13 0.26 -0.29 0.12 -0.43l-0.05 -0.26zm-14.25 1.05c-0.03 -0.12 -0.17 -0.22 -0.29 -0.18c-0.13 0.03 -0.12 0.12 -0.14 0.23c-0.01 0.10 0.19 0.24 0.24 0.32c0.09 0.13 0.32 0.15 0.32 -0.05l-0.13 -0.32zm-7.07 -5.76c0.58 0.02 0.43 0.63 1.17 0.67c0.25 0.01 0.35 0.21 0.55 0.31c0.33 0.17 1.15 0.05 1.57 0.12c0.72 0.12 1.37 0.31 2.12 0.31c0.51 0.00 0.27 -0.34 0.35 -0.61c0.06 -0.21 0.51 0.05 0.65 0.10c0.02 0.00 0.06 0.00 0.07 0.01c0.16 -0.04 0.25 -0.15 0.44 -0.09c0.28 0.09 0.45 0.31 0.70 -0.03c0.37 -0.51 0.68 -0.81 0.56 -1.49c-0.14 -0.77 0.53 -0.55 0.91 -0.77l0.12 -0.26l0.00 0.00c0.08 -0.10 0.33 -0.51 0.48 -0.51c0.01 -0.02 0.44 -0.09 0.55 -0.36c0.26 -0.67 0.68 0.07 0.99 -0.02c0.23 -0.07 0.30 -0.27 0.57 -0.27c0.27 0.00 0.36 0.08 0.57 0.12c0.06 0.24 0.56 -0.09 0.63 -0.21c0.12 -0.22 -0.00 -0.58 -0.07 -0.80c-0.14 -0.44 -0.30 -0.77 -0.17 -1.28c-0.00 -0.03 -0.01 -0.19 -0.06 -0.20c0.00 -0.12 -0.22 -0.36 -0.26 -0.50c-0.16 -0.53 0.30 -0.35 0.55 -0.39c0.34 -0.05 0.34 -0.53 0.66 -0.53c0.02 -0.05 0.22 -0.02 0.27 -0.02c0.14 0.00 0.61 -0.19 0.75 -0.19l0.00 0.00c0.14 0.26 0.39 0.23 0.89 -0.43c1.07 -1.40 1.16 -0.04 1.35 0.72c0.20 0.05 0.82 0.35 0.91 0.10c0.05 -0.15 0.57 -0.97 0.70 -0.45c0.32 0.08 0.40 0.28 0.85 0.23c0.67 -0.06 2.89 -1.33 3.32 -0.73c0.40 0.55 0.81 -0.65 1.00 0.60c0.08 0.52 0.91 0.37 0.91 0.80c0.03 0.01 0.05 0.40 0.23 0.49c0.28 0.14 0.86 -0.19 1.17 -0.19c0.48 0.00 0.75 0.66 1.07 0.73l0.00 0.00c-0.56 0.22 -1.12 0.49 -1.38 0.41c-0.81 -0.26 -0.53 0.03 -0.87 0.55c-0.06 0.09 -0.37 0.63 -0.45 0.38c-0.04 -0.10 -0.03 -0.60 -0.12 -0.63c1.09 -1.47 -1.21 -0.68 -1.78 -0.60c-0.21 0.03 -0.67 -0.29 -0.75 0.01c-0.13 0.45 0.31 0.59 -0.04 1.11c-0.54 0.81 -0.69 0.91 -1.56 0.91c-0.34 0.00 -0.44 0.59 -0.77 0.78c-0.29 0.29 -0.17 0.67 -0.41 0.93c-0.24 0.27 -0.50 0.09 -0.70 0.32c-0.59 0.67 -0.42 -0.75 -1.07 -0.50c-0.37 0.14 -0.89 0.91 -1.28 0.82c-0.28 -0.06 -0.40 -0.17 -0.68 0.02c-0.43 0.30 -0.10 0.53 -0.10 0.87c0.00 0.39 -0.42 0.37 -0.20 0.80c0.14 0.28 0.49 0.38 0.29 0.75c-0.22 0.41 -0.09 0.65 -0.38 1.09c-0.23 0.35 -0.07 0.84 -0.15 1.29c-0.65 0.65 -0.92 0.15 -1.58 0.23c-0.73 0.08 -0.46 0.85 -1.00 1.18c-0.51 0.32 -0.52 0.02 -0.97 0.02c-0.19 0.00 -0.44 0.18 -0.61 0.12c-0.68 -0.24 -0.64 -0.67 -0.64 -1.30c0.00 -0.21 -0.72 -0.02 -0.83 0.06c-0.21 0.14 0.07 0.79 -0.25 0.64c-0.21 -0.09 -0.76 -0.30 -0.95 -0.20c-0.43 0.22 -0.64 0.60 -1.16 0.21c-0.07 0.21 -0.30 0.19 -0.30 0.66c0.07 0.15 0.03 0.18 0.00 0.29c-0.32 0.00 -0.63 -0.34 -0.50 0.35c0.04 0.19 0.12 0.82 0.20 0.93c0.46 0.59 0.11 0.81 -0.22 0.71l0.00 0.00c0.00 -0.63 -0.70 -0.90 -1.06 -1.26c-0.18 -0.18 -0.10 -0.42 -0.22 -0.58c0.00 -0.27 0.23 -0.49 0.23 -0.76c0.00 -0.26 0.01 -0.49 -0.07 -0.75c-0.20 -0.66 -0.76 -0.50 -1.30 -0.60c-0.31 -0.06 -0.67 -0.41 -0.98 -0.27c-0.25 0.11 -0.30 0.13 -0.49 -0.09l0.00 0.00c-0.16 -0.22 -0.22 -0.45 -0.48 -0.61c-0.32 -0.21 -0.80 -0.01 -1.17 0.01c-0.31 0.02 -0.37 -0.30 -0.68 -0.23c-0.60 0.13 -0.38 -0.14 -0.49 -0.56c-0.01 -0.00 -0.01 -0.00 -0.01 -0.01c-0.25 -0.06 0.46 -0.51 0.53 -0.62c0.15 -0.23 0.09 -0.66 0.13 -0.92l0.23 -0.88l0.00 0.00z"},50:{name:"Qu\u1ea3ng Tr\u1ecb",path:"m102.02 147.43l0.02 -0.86c0.52 -0.57 0.40 -0.58 0.51 -1.31c0.06 -0.43 0.62 -0.18 0.86 -0.20c0.92 -0.07 -0.79 -1.31 -0.73 -1.58c0.07 -0.28 0.37 -0.42 0.62 -0.33c0.43 0.15 0.94 -0.70 1.55 -0.70c0.69 0.00 1.90 0.66 2.20 -0.43c0.12 -0.44 -0.32 -0.64 0.02 -1.18c0.15 -0.24 0.62 -1.06 0.80 -1.24l0.00 0.00c-1.02 -0.94 -1.78 -2.13 -2.90 -2.83c-0.45 -0.63 -1.04 -1.08 -1.47 -1.69c-0.33 -0.47 0.30 -1.59 -0.27 -1.84c-0.64 -0.28 -1.40 -0.76 -2.04 -1.28l0.00 0.00c-0.09 0.35 -1.17 1.14 -1.51 1.21c-0.71 0.14 -0.29 0.88 -0.99 0.88c-0.58 0.00 -0.25 0.65 -0.43 0.87c-0.13 0.17 -0.30 0.14 -0.44 0.29c-0.20 0.20 -0.18 0.44 -0.29 0.69c-0.32 0.78 -0.99 -0.08 -1.37 -0.25c-0.68 -0.30 -1.37 1.13 -1.70 -0.50l-0.86 -0.16l-0.01 -0.01l0.01 0.01l-0.05 5.37c0.22 0.83 0.92 1.50 1.62 1.84c0.84 0.41 0.09 0.72 0.00 1.12c-0.10 0.43 0.75 1.37 0.97 1.69c0.70 1.06 1.41 -0.44 1.87 -0.56c0.00 -0.36 0.45 -1.76 0.87 -1.16c0.14 0.20 0.54 0.22 0.54 0.53c0.00 0.17 -0.35 0.43 -0.32 0.54c0.11 0.42 0.45 1.78 1.04 1.93c0.74 0.19 0.80 1.95 1.69 1.06c0.06 0.04 0.12 0.06 0.18 0.09l0.00 0.00z"},51:{name:"S\xf3c Tr\u0103ng",path:"m94.07 283.03c-0.01 -0.01 -0.03 -0.02 -0.04 -0.04c-0.11 -0.05 -0.15 -0.48 -0.09 -0.58c0.10 -0.15 0.28 -0.26 0.39 -0.41c0.24 -0.32 0.51 -0.76 0.97 -0.76c0.45 0.00 0.00 0.42 -0.10 0.52c-0.20 0.20 -0.13 0.21 -0.06 0.42c0.05 0.16 -0.49 0.22 -0.54 0.46c-0.05 0.25 0.15 0.49 -0.33 0.49l-0.21 -0.10zm-12.69 -10.38c0.85 -0.30 1.73 -0.58 2.64 -0.87l2.72 -0.88c0.21 -0.07 1.18 -0.57 0.75 -0.84c-0.32 -0.20 -0.78 -0.47 -0.24 -0.86c0.43 -0.22 0.31 -0.65 0.62 -0.82c0.42 -0.23 1.11 0.00 1.11 -0.91c0.00 -0.44 0.27 -0.67 0.56 -0.64l0.00 0.00c-0.09 -0.35 -1.20 -1.16 -1.48 -1.34c-0.65 -0.40 -1.07 -1.16 -1.79 -1.60c-0.46 -0.29 -1.03 -1.07 -1.38 -1.53l-1.01 -1.22l0.00 0.00l-1.28 -0.78l0.00 0.00c-0.38 0.13 -0.78 2.54 -0.93 2.98c-0.30 0.90 -1.64 1.13 -2.22 1.85c-0.40 0.50 -1.58 0.68 -2.16 0.90l-0.69 0.26l0.00 0.00l-0.11 2.47c0.02 0.01 0.01 0.01 0.01 0.04c0.21 0.07 0.11 0.74 0.64 0.74c0.36 0.00 0.45 -0.24 0.77 0.08c0.29 0.29 0.35 0.05 0.63 0.18c0.22 0.10 0.35 0.39 0.62 0.43c0.25 0.04 0.38 -0.17 0.57 -0.31c0.15 -0.11 0.91 -0.19 1.04 -0.07c0.17 0.15 0.08 0.67 0.46 0.32c0.35 -0.32 0.87 -0.09 0.64 0.36c-0.09 0.19 -0.38 0.11 -0.51 0.21c-0.25 0.19 -0.07 0.29 -0.18 0.54l0.17 1.30l0.00 0.00z"},52:{name:"S\u01a1n La",path:"m65.17 59.73l-0.66 0.23c-0.03 0.12 -0.29 0.44 -0.26 0.49c-0.11 0.03 0.19 0.44 0.23 0.51c0.28 0.58 1.08 1.96 1.63 2.30c0.61 0.38 0.20 1.62 0.56 1.80c0.97 0.48 -0.11 0.51 -0.02 1.03c0.06 0.34 0.37 0.74 -0.33 0.50c-0.45 -0.15 -1.26 -0.46 -1.74 -0.33c-1.08 0.28 -0.29 0.75 -0.48 1.18l-0.25 0.80l0.00 0.00l-0.39 0.21c-0.28 0.22 -0.30 0.49 -0.32 0.81c-0.02 0.19 -0.24 0.30 -0.41 0.30c-0.10 0.00 -0.18 -0.04 -0.27 -0.05c-0.07 -0.01 -0.48 -0.11 -0.49 -0.16c-0.13 0.00 -0.41 -0.22 -0.54 -0.29c-0.54 -0.30 -0.71 -0.58 -1.04 -1.09l0.00 0.00c0.00 -0.05 0.01 -0.09 0.01 -0.12l-0.01 -0.01c-0.07 0.00 -0.19 -0.03 -0.25 -0.06c-0.03 -0.02 -0.22 -0.03 -0.23 -0.05c-0.50 0.00 -1.73 -1.01 -1.89 -1.52c-0.15 -0.59 -1.14 -0.06 -1.47 -0.42c-0.51 -0.57 0.11 -0.79 -0.82 -1.05c-0.64 -0.18 -0.70 -2.21 -1.99 -1.23c-0.39 -0.30 -0.71 -1.17 -1.54 -0.95c-0.75 0.19 -0.70 -1.17 -1.70 -0.04c-0.14 0.16 -0.06 0.47 -0.26 0.67c-0.40 0.41 -1.05 0.00 -1.61 0.32c-0.50 0.50 -0.64 0.03 -1.10 0.25c-0.11 0.06 -0.71 1.31 -0.89 0.57c-0.16 0.00 -0.33 0.04 -0.48 0.04c-0.06 0.22 0.07 0.56 -0.14 0.72c-0.31 0.22 -0.30 0.23 -0.26 0.62c0.10 1.04 -0.83 0.62 -0.92 1.05c-0.06 0.28 0.36 0.89 -0.06 1.05c-0.78 0.30 -0.71 0.11 -1.10 -0.51c-0.22 -0.35 -0.42 -0.32 -0.75 -0.47c-0.45 -0.20 -0.06 -0.46 -0.81 -0.38c-0.51 0.00 -1.18 0.03 -1.38 -0.58c-0.11 -0.32 -0.66 -1.71 -0.98 -0.53c-0.22 0.82 -2.04 -0.45 -2.57 -0.45c-1.22 0.00 -2.01 -0.39 -2.62 -1.02l0.00 0.00l1.35 -0.40c0.19 -0.07 0.25 -0.04 0.44 -0.04c0.19 0.00 0.16 -0.19 0.24 -0.21c-0.20 -0.79 -0.14 -0.18 0.15 -0.78c0.10 -0.20 -0.01 -0.61 -0.15 -0.78c-0.22 -0.25 0.23 -0.29 0.08 -0.62c-0.06 -0.14 -0.41 -0.79 -0.01 -0.66c0.31 0.11 -0.19 -0.91 0.71 -0.45c0.36 0.18 0.46 0.55 0.98 0.55c1.35 0.00 0.24 -0.68 0.19 -1.23c-0.03 -0.28 0.35 -0.50 0.52 -0.64c0.17 -0.14 0.20 -0.97 0.20 -1.21c0.18 -0.41 0.05 -2.26 -0.74 -1.67c-0.04 -0.03 -0.59 -0.22 -0.46 -0.42c0.04 -0.06 0.65 -0.54 0.42 -0.54c-0.03 -0.13 -0.58 -0.59 -0.70 -0.76c-0.49 -0.70 1.46 -0.25 1.75 -0.47c0.43 -0.32 -0.02 -0.77 0.01 -1.23c0.04 -0.53 0.37 -0.33 0.69 -0.33c0.20 0.00 0.90 -0.90 0.86 -1.04c-0.09 -0.33 0.34 -0.47 0.32 -0.79c-0.02 -0.39 -0.25 -0.62 0.20 -0.87c0.15 -0.19 0.03 -0.29 0.31 -0.29c0.11 0.00 0.33 -0.04 0.33 -0.17c-0.02 -0.01 -0.00 -0.00 -0.02 -0.01c0.00 -0.24 -0.57 -0.46 -0.57 -0.90c0.00 -0.29 -0.26 -0.68 -0.38 -0.95c-0.21 -0.47 -0.21 -1.04 -0.58 -1.46c-0.14 -0.16 -0.24 -0.36 -0.41 -0.53c-0.37 -0.37 -0.11 -0.48 -0.11 -0.86l0.01 -0.01l0.29 -0.53l0.00 0.00c0.43 -0.60 0.49 -1.61 1.43 -0.84c0.30 0.25 0.75 0.25 1.04 0.48c0.15 0.12 0.28 0.19 0.43 0.36c0.04 0.04 0.05 0.19 0.06 0.26c0.01 0.06 0.08 0.27 0.06 0.27c0.17 0.14 0.80 1.22 0.73 1.47c-0.22 0.73 -0.57 0.97 0.32 1.18c0.38 0.09 0.40 0.35 0.57 0.62c0.35 0.54 0.89 0.33 1.23 1.13c0.37 0.88 0.75 0.27 1.30 0.27l0.00 0.00c0.37 0.05 0.33 0.36 0.62 0.48c0.42 0.17 0.88 -0.20 1.37 0.10c0.33 0.20 0.47 0.29 0.86 0.37c0.33 0.07 0.64 -0.03 0.95 -0.13c0.22 -0.07 0.46 0.01 0.69 0.10c0.27 0.10 0.61 -0.17 0.87 -0.27c0.34 -0.14 0.55 0.00 0.88 0.00c0.31 -0.04 1.22 0.05 1.22 0.42c-0.84 0.27 -0.77 0.70 -0.77 1.25c-0.63 0.21 0.09 2.03 0.27 2.45c0.29 0.66 0.48 0.48 1.06 0.61c0.80 0.18 0.99 1.34 1.86 0.95c0.55 -0.24 0.76 -1.23 1.41 -0.97c0.43 0.18 0.76 -0.27 1.20 0.13c0.97 0.87 1.19 -0.50 1.75 0.06c0.24 0.24 0.46 1.28 0.86 1.28c0.04 0.12 0.67 0.02 0.77 0.02l0.00 0.00c0.23 0.30 0.55 0.50 0.55 0.91c0.00 0.53 0.07 0.99 0.18 1.48c0.05 0.22 -0.22 0.50 -0.06 0.66c0.09 0.09 0.19 0.36 0.31 0.39c-0.01 0.02 0.36 0.24 0.37 0.27c0.03 0.12 0.30 0.24 0.30 0.36l0.00 0.00z"},53:{name:"T\xe2y Ninh",path:"m87.47 242.30l0.89 -0.13c0.20 -0.06 0.54 0.03 0.67 -0.15c0.09 -0.13 -0.18 -0.30 -0.06 -0.47c0.18 -0.24 0.47 -0.33 0.72 -0.14c0.12 0.09 0.23 0.19 0.36 0.26c0.05 0.03 0.31 0.14 0.30 0.17c0.04 0.03 0.08 0.06 0.13 0.05l0.00 0.00c0.10 -0.04 0.17 -0.11 0.28 -0.13c0.53 -0.09 0.63 -0.10 0.63 -0.68c0.00 -0.36 0.28 -0.80 0.43 -1.13l0.07 -0.47l0.00 0.00c-0.02 -0.07 -0.13 -0.16 -0.15 -0.26c-0.03 -0.10 -0.04 -0.21 -0.04 -0.32c-0.01 -0.25 -0.48 -0.27 -0.63 -0.40c-0.15 -0.14 -0.14 -0.36 -0.14 -0.56c0.00 -0.45 -0.71 -0.38 -0.61 -0.79c0.11 -0.47 -0.28 -0.51 -0.14 -0.96c0.09 -0.29 0.01 -0.44 0.06 -0.72c0.06 -0.34 0.20 -0.67 0.24 -1.03c0.08 -0.59 0.36 -0.56 0.73 -0.87l0.36 -0.47l0.00 0.00c0.00 -0.45 0.12 -0.85 0.58 -1.00c0.66 -0.20 0.70 -0.82 0.21 -1.26c-0.14 -0.13 -0.10 -0.26 -0.14 -0.44l-0.40 -0.54l0.00 0.00c-0.45 0.40 -1.37 -0.40 -2.05 -0.16c-0.92 0.33 -0.58 -0.09 -1.13 -0.43c-0.32 -0.20 -1.42 -0.60 -1.74 -0.49c-0.48 0.17 -0.78 0.05 -1.12 -0.29c-0.20 -0.20 -0.98 -0.67 -1.22 -0.29c-0.63 1.03 -0.65 2.63 -2.17 1.96c-0.58 -0.26 -1.26 0.38 -1.45 0.85c0.17 0.12 -0.12 0.66 0.25 0.84c0.18 0.09 0.53 0.10 0.63 0.31c0.17 0.35 0.07 1.57 0.25 1.60c0.75 0.11 0.09 0.48 -0.07 0.81c-0.28 0.57 0.01 0.95 -0.12 1.60c0.00 0.30 -0.37 0.90 0.20 0.95c0.35 0.04 0.50 -0.01 0.50 0.42c0.00 0.69 0.91 0.88 1.41 0.88c0.60 0.00 0.98 2.49 2.42 1.95c0.78 -0.30 1.06 1.26 1.06 1.91l0.00 0.00z"},54:{name:"Th\xe1i B\xecnh",path:"m87.58 71.26c0.20 0.06 0.54 -0.06 0.41 0.35c-0.27 0.86 -0.06 0.76 0.78 0.79c0.82 0.04 0.11 0.53 -0.04 0.78c-0.18 0.30 -0.15 0.70 0.29 0.60c0.42 -0.09 1.06 -0.99 1.32 -0.46c0.09 0.19 0.40 0.24 0.57 0.28c0.22 0.06 0.32 0.38 0.46 0.42c0.13 0.24 0.38 0.63 0.69 0.64c0.39 0.02 0.87 -0.71 1.26 -0.39c0.29 0.24 0.75 0.49 1.05 0.72l0.00 0.00c-0.02 -0.40 -0.06 -0.78 -0.11 -0.92c-0.11 -0.36 -0.05 -0.79 -0.14 -1.17c-0.11 -0.43 0.40 -0.57 0.32 -0.88c-0.31 0.00 0.02 -0.60 -0.06 -0.76c-0.24 -0.47 -0.44 -0.52 -0.14 -1.18c0.35 -0.31 0.74 -1.18 1.17 -1.22c0.12 -0.01 0.22 -0.04 0.30 -0.07l0.00 0.00c-0.17 -0.17 -0.68 -0.43 -0.92 -0.51c-0.13 -0.05 -0.31 0.08 -0.42 0.13c-0.26 0.12 -0.77 0.49 -1.05 0.35c-0.41 -0.19 -0.27 -0.19 -0.69 0.01c-0.19 0.09 -0.48 -0.50 -0.55 -0.66c-0.11 -0.27 -0.68 -0.76 -0.63 -0.98c0.08 -0.34 0.20 -0.31 -0.14 -0.53l0.00 0.00c-0.02 0.00 -0.04 0.02 -0.05 0.04c-0.10 0.02 -0.39 0.27 -0.51 0.33c-0.28 0.14 -0.51 0.03 -0.78 0.07c-0.13 0.02 -0.24 0.12 -0.36 0.17c-0.22 0.10 -0.29 -0.20 -0.46 -0.18c-0.17 0.01 -0.20 0.18 -0.34 0.20l0.00 0.00l-0.09 0.41c-0.18 0.14 -0.45 0.50 -0.66 0.55c-0.26 0.07 -0.46 -0.29 -0.76 -0.13c-0.22 0.12 -0.23 0.10 -0.42 -0.05c-0.17 -0.14 -0.40 0.06 -0.47 0.24c-0.02 0.05 -0.01 0.26 0.04 0.27c0.00 0.07 -0.22 0.08 -0.29 0.16l0.00 0.00c0.33 0.18 0.38 0.27 0.48 0.61c0.09 0.31 0.63 0.48 0.76 0.88c0.12 0.36 0.20 0.72 0.20 1.10l0.00 0.00z"},55:{name:"Th\xe1i Nguy\xean",path:"m82.24 55.59c0.09 -0.16 -0.02 -0.25 0.05 -0.37c0.04 -0.08 0.31 0.06 0.38 -0.14c0.04 -0.12 0.15 -0.34 0.17 -0.39c0.49 0.16 0.51 -0.10 0.51 -0.55c0.00 -1.10 0.90 0.67 1.25 -0.12c0.49 -1.11 0.09 -2.23 0.52 -3.34c0.16 -0.41 0.55 -1.09 1.01 -0.68c0.34 0.30 0.82 0.06 1.19 0.43l0.00 0.00l0.35 -0.41c0.20 -0.47 0.15 -0.94 0.54 -1.32c0.42 -0.42 -0.93 -0.69 -1.13 -0.81c-0.26 -0.16 -0.53 -0.57 -0.80 -0.78c-0.03 -0.02 -0.20 -0.13 -0.18 -0.14c-0.23 -0.23 0.00 -0.81 0.14 -0.99c0.25 -0.33 -0.28 -0.63 -0.10 -0.87c0.20 -0.26 0.17 -0.29 0.30 -0.61l-0.49 -0.31l0.00 0.00c-0.42 -0.06 -0.60 -0.15 -0.97 -0.27c-0.51 -0.18 -0.39 0.41 -0.74 0.36c-0.50 -0.08 -1.50 0.90 -1.99 1.27c-0.50 0.37 -0.98 0.12 -1.31 0.72c-0.58 1.05 -0.99 0.28 -0.86 -0.49c0.14 -0.84 -0.07 -1.30 -0.07 -2.04c0.00 -0.94 -0.07 -0.48 -0.67 -0.95c-1.05 -0.84 -0.54 -0.12 -1.50 0.05c-0.96 0.16 -0.77 0.79 -1.57 1.22l0.00 0.00c0.32 1.01 -0.62 0.95 -0.43 1.64c0.17 0.60 -0.55 0.24 -0.55 0.95c0.00 0.66 0.64 0.51 0.64 0.90c0.00 0.26 -0.54 1.11 -0.66 1.43c-0.21 0.59 0.25 1.25 0.55 1.73l0.46 0.43l0.00 0.00c0.04 0.00 1.17 0.89 1.22 0.97c0.23 0.43 0.24 0.84 0.76 1.05c0.24 0.10 0.54 0.14 0.73 0.35c0.15 0.17 0.10 0.55 0.39 0.58c1.03 0.11 0.44 0.35 0.99 0.99l0.00 0.00c0.23 -0.30 0.17 -0.45 0.61 -0.45c0.03 0.08 0.33 0.02 0.41 0.05c0.30 0.11 0.19 0.32 0.25 0.58c0.02 0.08 0.12 0.24 0.18 0.27c0.18 0.11 0.18 0.11 0.39 0.11l0.01 -0.01l0.00 0.00z"},56:{name:"Thanh H\xf3a",path:"m82.67 91.85c-0.06 -0.13 -0.04 -0.53 0.19 -0.38c0.08 0.06 0.17 0.21 0.18 0.31c0.03 0.14 -0.17 0.20 -0.27 0.21l-0.11 -0.14zm-16.46 -11.69l1.12 0.73c0.29 0.01 0.54 0.20 0.87 0.20c0.23 0.00 0.47 -0.04 0.68 -0.02c0.32 0.03 0.67 0.30 1.08 0.33c0.35 0.03 0.33 0.64 0.33 0.85c-0.26 0.07 -0.63 0.36 -0.77 0.39c0.00 0.27 -0.25 0.45 -0.25 0.78c0.00 0.64 -0.04 0.85 0.48 1.11c0.24 0.12 0.10 0.37 0.02 0.55c-0.16 0.38 0.10 0.35 0.27 0.60c0.42 0.08 0.48 0.56 0.83 0.66c1.08 0.30 0.52 -0.01 0.88 1.04c0.16 0.46 -0.05 1.22 0.06 1.74c0.25 1.14 0.64 -0.39 0.95 -0.62c0.57 -0.41 0.49 0.31 0.62 0.73c0.13 0.42 1.41 1.04 1.81 0.94c0.81 -0.19 1.10 -0.68 1.55 0.33c0.57 1.30 1.21 0.62 1.76 1.62c0.45 0.81 0.27 0.49 1.01 0.49c0.50 0.00 1.00 0.30 1.46 0.30l0.00 0.00c0.11 -0.18 0.11 -0.36 -0.21 -0.51c-0.44 -0.22 -0.54 -1.56 -0.46 -1.58c0.02 -0.10 0.56 -0.00 0.56 -0.26c0.00 -0.77 -0.46 -1.30 -0.12 -2.22c0.18 -0.43 0.98 -2.88 1.24 -2.97c0.50 -0.18 0.31 -0.94 0.74 -1.37c0.34 -0.34 -0.04 -0.70 0.15 -1.05c0.18 -0.33 0.48 -0.41 0.48 -0.84c0.00 -0.93 0.24 -0.65 0.92 -0.94c0.14 -0.06 0.24 -0.08 0.31 -0.06l0.00 0.00l0.11 -0.63c0.10 -0.34 0.40 -0.46 0.55 -0.79c0.16 -0.34 0.33 -0.66 0.22 -0.98c-0.47 0.00 -0.93 0.11 -1.45 0.08c-0.53 -0.03 -1.08 -0.46 -1.51 -0.77c-0.15 -0.48 -0.82 -0.41 -1.13 -0.72c-0.58 -0.58 -1.18 -0.59 -1.81 -0.94c-0.50 -0.27 -0.93 -1.33 -1.44 -1.39c-0.29 -0.17 -0.56 -0.50 -0.88 -0.66c-0.40 -0.19 -0.80 -0.17 -0.91 -0.71l0.07 -0.39l0.00 0.00c-0.15 -0.15 -0.69 0.14 -0.97 0.04c-0.62 -0.24 -0.64 -0.25 -1.32 -0.25c-0.71 0.00 -2.41 -0.59 -2.58 -1.34c-0.14 -0.65 -0.67 -1.10 -1.30 -1.15c-0.62 0.00 -0.36 -0.44 -0.82 -0.72c-0.19 -0.12 -0.80 -0.45 -1.01 -0.45c-0.27 0.00 -0.57 0.27 -0.83 0.34c-0.08 0.02 -0.83 -0.33 -0.86 -0.38c-0.17 -0.27 -0.26 -0.91 -0.52 -1.10c-0.60 -0.44 -0.83 -0.52 -1.47 -0.31l-0.91 0.38l0.00 0.00l-0.39 0.21c-0.28 0.22 -0.30 0.49 -0.32 0.81c-0.02 0.19 -0.24 0.30 -0.41 0.30c-0.10 0.00 -0.18 -0.04 -0.27 -0.05c-0.07 -0.01 -0.48 -0.11 -0.49 -0.16c-0.13 0.00 -0.41 -0.22 -0.54 -0.29c-0.54 -0.30 -0.71 -0.58 -1.04 -1.09l0.00 0.00c-0.02 0.21 -0.07 0.58 -0.16 0.61c0.00 0.44 -0.69 0.41 -0.69 0.95c0.00 0.41 -0.72 1.08 -1.17 0.95c-0.21 -0.06 -0.74 -0.33 -0.88 -0.19c-0.22 0.22 -0.20 0.45 -0.61 0.45c-0.01 0.04 -0.04 0.05 -0.04 0.12c-0.07 0.02 -0.09 0.23 -0.32 0.23c-0.01 0.04 -0.14 0.05 -0.19 0.05c-0.01 0.02 -0.00 0.00 -0.01 0.02l-0.02 0.00c-0.13 0.39 -0.64 0.73 0.15 0.94c0.61 0.16 1.60 0.84 2.22 0.60c0.80 -0.32 1.51 -0.48 1.80 0.41l1.02 0.53c0.45 0.23 0.36 0.59 0.24 0.95c-0.57 0.00 -0.43 0.22 -0.66 0.60l0.00 0.82c0.44 0.15 0.94 0.56 1.41 0.61c0.31 0.03 0.61 -0.67 1.29 -0.67c0.01 0.04 0.07 0.01 0.08 0.05c0.15 0.00 1.15 0.59 1.19 0.72c1.07 0.00 0.45 0.43 0.45 0.91c0.24 0.08 0.63 0.77 0.93 0.87c0.00 0.26 -0.52 0.19 -0.33 0.61c0.18 0.40 0.27 0.82 0.12 1.03l0.00 0.00z"},57:{name:"Th\u1eeba Thi\xean - Hu\u1ebf",path:"m115.40 151.78c0.09 -0.16 -0.01 -0.37 0.10 -0.56c0.08 -0.14 0.22 -0.28 0.33 -0.39c-0.04 -0.10 0.41 -1.05 0.44 -1.25c0.06 -0.42 0.45 -0.73 0.81 -0.42c0.45 0.39 0.40 0.12 0.74 -0.05c0.38 -0.19 0.86 0.20 1.27 0.33c0.44 0.13 1.51 -0.18 1.94 -0.34l0.00 0.00c-0.23 -0.15 -0.37 -0.43 -0.62 -0.35c-0.25 0.09 -0.60 0.34 -0.83 0.08c-0.62 -0.69 0.35 0.05 0.07 -0.74c-0.11 -0.32 -0.41 -1.08 -0.66 -1.27c-1.34 1.60 -5.05 -4.14 -6.74 -4.14c0.00 0.17 1.73 1.51 1.99 1.71c0.54 0.40 0.93 1.31 1.47 1.78c0.44 0.39 1.33 0.42 1.47 1.06c0.18 0.86 -0.70 0.08 -1.02 0.27c-0.38 0.24 -1.15 -0.29 -0.54 -0.79c0.41 -0.33 -2.00 -2.61 -2.41 -2.94c-0.33 -0.27 -0.59 0.35 -0.64 -0.43c-0.05 -0.82 -1.78 -0.98 -2.50 -1.18c-0.18 -0.32 -1.31 -0.59 -1.18 -1.10c0.04 -0.14 0.48 0.16 0.54 0.19l1.49 0.90c0.15 0.09 1.30 0.32 1.31 0.41c0.12 -0.09 -0.67 -0.48 -0.80 -0.57c-0.44 -0.32 -1.05 -0.66 -1.42 -1.04c-0.38 -0.38 -0.88 -0.45 -1.32 -0.74c-0.28 -0.19 -0.55 -0.40 -0.79 -0.63l0.00 0.00c-0.18 0.18 -0.65 1.00 -0.80 1.24c-0.34 0.54 0.10 0.74 -0.02 1.18c-0.30 1.09 -1.51 0.43 -2.20 0.43c-0.61 0.00 -1.12 0.85 -1.55 0.70c-0.25 -0.09 -0.55 0.06 -0.62 0.33c-0.06 0.26 1.64 1.51 0.73 1.58c-0.24 0.02 -0.79 -0.22 -0.86 0.20c-0.11 0.73 0.01 0.75 -0.51 1.31l-0.02 0.86l0.00 0.00c0.90 0.35 2.22 -0.27 1.99 1.59c-0.20 0.59 0.40 1.62 1.04 1.15c0.25 0.19 0.68 -0.01 1.11 0.48c0.30 0.35 0.94 1.36 1.43 1.16c0.54 -0.22 0.37 -0.10 0.80 -0.10c0.23 0.00 0.46 -0.39 0.79 -0.39c0.01 0.02 -0.00 0.01 0.02 0.01c0.09 0.26 -0.04 0.58 -0.04 0.87c0.07 0.02 0.09 0.13 0.08 0.28l0.00 0.00l0.54 -0.25c0.25 0.01 0.99 0.94 0.99 0.10c0.00 -0.31 0.76 -0.45 1.02 -0.52c0.40 -0.10 0.11 0.43 0.48 0.54c0.45 0.14 0.70 0.67 1.11 0.67c0.33 0.00 0.50 -0.83 1.01 -1.02c0.16 -0.18 0.24 -0.27 0.49 -0.20c0.19 0.05 0.33 -0.02 0.51 -0.02l0.00 0.00z"},58:{name:"Ti\u1ec1n Giang",path:"m83.28 249.85l-0.04 0.66l-0.68 0.79l-0.63 0.66l-0.25 0.62l-0.47 0.12l-0.10 0.72l0.46 0.43c0.11 0.09 0.24 0.16 0.37 0.22c0.10 0.04 0.24 0.08 0.32 0.14c0.05 0.04 0.16 0.13 0.17 0.19l0.00 0.00c0.24 -0.05 0.42 -0.01 0.64 -0.15c0.24 -0.15 0.45 -0.41 0.69 -0.56c0.12 -0.07 0.61 -0.14 0.67 0.02c0.07 0.00 0.40 0.21 0.46 0.27l0.00 0.00c0.86 0.08 0.82 0.62 1.91 0.29c0.59 -0.18 1.20 -0.49 1.79 -0.62c0.39 -0.09 0.91 0.09 1.19 0.00c0.86 -0.27 0.76 -0.52 1.70 -0.16c0.24 0.09 0.55 0.33 0.74 0.50c0.33 0.30 0.77 0.32 1.16 0.49c0.35 -0.09 0.91 0.17 1.26 0.29c0.54 0.18 1.17 0.21 1.63 0.50c0.19 0.12 0.39 0.27 0.55 0.43c0.20 0.20 0.54 0.47 0.77 0.66l0.00 0.00c-0.03 -0.26 0.74 -0.21 0.46 -0.61c-0.33 -0.48 -0.72 -0.20 -0.44 -0.98c0.18 -0.51 -0.07 -1.13 0.12 -1.64c0.10 -0.35 -0.11 -0.58 -0.11 -0.90c0.00 -0.13 0.02 -0.20 0.05 -0.23l0.00 0.00l-0.85 -1.24l0.00 0.00c-0.06 0.09 -0.15 0.16 -0.24 0.21c-0.17 0.08 -0.70 1.04 -0.88 0.72c-0.20 -0.34 -0.19 -1.00 -0.57 -0.39c-0.17 0.28 -0.44 0.20 -0.66 0.38c-0.41 0.34 -0.22 0.48 -0.80 0.26c-0.51 -0.19 -0.67 -0.23 -1.07 0.17c-0.09 0.30 -0.67 -0.01 -0.95 -0.07c-0.81 -0.17 1.16 -0.98 -0.49 -1.10c-0.76 -0.05 -1.21 -2.00 -2.08 -1.94l-2.49 0.18c-0.39 0.03 -0.78 -0.17 -0.66 0.41c0.09 0.45 -0.32 0.42 -0.70 0.44l-1.97 -0.21l0.00 0.00z"},59:{name:"Tr\xe0 Vinh",path:"m89.50 258.20l1.62 1.48l2.23 1.53l0.64 1.19l0.00 0.00c-0.57 -0.29 -1.05 0.97 -0.23 1.48c0.39 0.24 0.31 0.56 0.36 1.03c0.21 1.89 -3.00 4.04 -4.10 2.26c-0.13 -0.21 -0.31 -0.32 -0.48 -0.33l0.00 0.00c-0.09 -0.35 -1.20 -1.16 -1.48 -1.34c-0.65 -0.40 -1.07 -1.16 -1.79 -1.60c-0.46 -0.29 -1.03 -1.07 -1.38 -1.53l-1.01 -1.22l0.00 0.00c0.28 -0.18 0.70 -0.18 0.91 -0.47c0.28 -0.39 0.31 -0.20 0.68 -0.30c0.20 -0.05 0.32 -0.32 0.52 -0.35c0.50 -0.06 0.55 0.50 0.77 -0.23c0.10 -0.32 0.09 -0.68 0.37 -0.90c0.30 -0.23 0.65 0.15 1.07 0.11c0.17 -0.02 0.17 -0.42 0.25 -0.55c0.11 -0.19 0.42 -0.34 0.43 -0.36c0.13 0.10 0.45 0.10 0.62 0.08l0.00 0.00z"},60:{name:"Tuy\xean Quang",path:"m72.67 52.31c0.37 -0.22 0.55 -0.51 0.97 -0.14c0.18 0.16 0.46 0.21 0.68 0.07c0.28 -0.17 0.35 -0.21 0.66 -0.29c0.30 -0.08 0.58 0.10 0.82 -0.20c0.10 -0.13 0.51 -0.48 0.51 -0.64l0.00 0.00l-0.46 -0.43c-0.30 -0.48 -0.76 -1.15 -0.55 -1.73c0.11 -0.32 0.66 -1.18 0.66 -1.43c0.00 -0.39 -0.64 -0.24 -0.64 -0.90c0.00 -0.71 0.72 -0.35 0.55 -0.95c-0.19 -0.69 0.75 -0.63 0.43 -1.64l0.00 0.00c-0.01 -0.05 -0.45 -0.40 -0.52 -0.49c-0.12 -0.15 -0.25 -0.33 -0.33 -0.51c-0.19 -0.41 -0.60 -0.56 -0.46 -1.12c0.07 -0.31 -0.04 -0.45 -0.06 -0.74c-0.03 -0.44 0.32 -0.67 0.32 -1.05c-0.35 -0.09 -0.37 -0.15 -0.54 -0.48c-0.27 -0.74 -0.66 -1.51 0.46 -1.73c0.08 -0.34 0.01 -1.05 0.51 -1.15c0.08 -0.30 -0.04 -0.59 0.06 -0.88c0.20 -0.55 0.59 -0.23 0.75 -0.47c0.26 -0.38 -0.37 -1.37 0.58 -1.68c0.00 -0.02 -0.01 -0.02 0.01 -0.02c0.00 -0.02 0.00 -0.04 0.02 -0.05c0.00 -0.50 -0.59 -1.75 -1.06 -1.91c0.00 -0.03 -0.05 -0.17 -0.06 -0.20c0.03 -0.02 0.02 -0.16 0.01 -0.19l-0.73 -0.08c0.07 0.02 -0.16 0.26 -0.19 0.29c-0.11 0.08 -0.22 0.14 -0.33 0.20c-0.22 0.13 -0.45 0.12 -0.69 0.06c-0.56 -0.13 -0.82 -0.51 -1.24 -0.67c-0.38 -0.14 -0.52 0.51 -0.89 0.45c-0.49 -0.08 -0.56 -0.62 -1.10 -0.78c-0.34 -0.10 -1.49 -0.63 -1.70 -0.38c-0.16 0.18 0.27 0.88 0.21 1.19c-0.07 0.40 -0.55 0.49 -0.56 0.87l-0.02 1.35l-0.04 0.12c0.22 0.52 -0.35 0.76 -0.35 1.16c0.00 0.51 0.31 0.44 -0.26 0.58c-0.07 0.34 0.19 0.90 -0.37 0.78c-0.45 -0.10 0.04 0.68 -0.08 0.98c-0.02 -0.01 -0.11 0.18 -0.14 0.23c-0.06 0.09 -0.15 0.14 -0.26 0.14c-0.23 0.02 -0.44 -0.05 -0.57 -0.23c-0.25 -0.35 -0.38 -0.56 -0.85 -0.49c-0.38 0.06 -0.43 -0.31 -0.75 -0.31c-0.11 0.32 0.15 0.46 0.17 0.75c0.02 0.36 -0.17 0.36 -0.33 0.62c-0.16 0.25 0.97 1.12 -0.11 1.46c-0.49 0.15 -0.42 -0.50 -0.93 0.17l0.00 0.00c0.51 0.27 0.42 2.02 1.00 2.02c0.41 0.00 0.51 0.32 0.70 0.63c0.20 0.33 0.61 -0.09 0.93 -0.01c0.00 0.28 0.06 0.63 0.11 0.91c0.04 0.25 -0.20 1.23 0.07 1.07c0.69 -0.39 0.29 0.73 0.51 0.73c0.10 0.21 0.24 0.29 0.37 0.45c0.19 0.24 0.09 0.58 0.29 0.80c0.19 0.21 0.79 0.51 0.48 0.87c-0.25 0.28 -0.42 0.41 -0.42 0.81l0.25 0.35l0.00 0.00c0.63 -0.06 0.97 0.48 1.63 0.57c0.29 0.04 0.86 0.40 1.08 0.56c0.31 0.22 -0.37 0.56 -0.01 0.78c0.56 0.33 0.28 0.85 0.73 1.19c0.50 0.39 0.28 0.76 1.08 0.76l0.00 0.00z"},61:{name:"V\u0129nh Long",path:"m82.60 260.37l-0.97 -0.80l0.00 0.00c-0.16 -0.04 -0.34 -0.53 -0.39 -0.67c-0.07 -0.18 -0.37 -0.55 -0.55 -0.68c-0.20 -0.14 -0.46 -0.30 -0.62 -0.48l-1.22 -0.87l0.00 0.00l0.82 -1.21c0.24 0.10 0.35 0.06 0.46 0.30c0.10 0.20 0.23 0.16 0.38 0.05c0.25 0.19 0.40 0.46 0.79 0.60c0.39 0.14 0.48 -0.03 0.74 -0.29c0.29 -0.29 0.95 -0.11 0.95 -0.68c0.00 -0.42 -0.81 -0.65 -0.60 -0.94l0.03 -0.30l0.00 0.00c0.24 -0.05 0.42 -0.01 0.64 -0.15c0.24 -0.15 0.45 -0.41 0.69 -0.56c0.12 -0.07 0.61 -0.14 0.67 0.02c0.07 0.00 0.40 0.21 0.46 0.27l0.00 0.00c-0.18 0.82 -0.06 0.68 0.71 0.90c0.35 0.10 0.80 -0.08 1.13 0.25c0.25 0.25 0.30 0.57 0.52 0.81c0.31 0.34 0.76 0.44 1.10 0.78c0.34 0.34 0.54 0.55 0.79 1.04l0.35 0.44l0.00 0.00c-0.17 0.02 -0.49 0.01 -0.62 -0.08c-0.01 0.02 -0.32 0.17 -0.43 0.36c-0.08 0.13 -0.08 0.53 -0.25 0.55c-0.42 0.05 -0.77 -0.34 -1.07 -0.11c-0.28 0.21 -0.27 0.58 -0.37 0.90c-0.23 0.72 -0.28 0.17 -0.77 0.23c-0.20 0.02 -0.32 0.29 -0.52 0.35c-0.37 0.09 -0.40 -0.09 -0.68 0.30c-0.21 0.29 -0.62 0.29 -0.91 0.47l0.00 0.00l-1.28 -0.78l0.00 0.00z"},62:{name:"V\u0129nh Ph\xfac",path:"m74.53 56.56c-0.06 0.70 -0.20 0.75 0.18 1.36c0.23 0.38 0.56 0.66 0.95 0.86c0.81 0.41 1.34 -0.54 2.17 0.08c0.54 0.41 1.10 -0.13 1.49 0.64c0.32 0.65 0.44 -0.18 0.63 -0.45c0.38 -0.54 0.75 -1.22 -0.02 -1.72c-0.99 -0.64 -0.23 -0.97 0.13 -1.58l0.33 -0.72l0.00 0.00c-0.55 -0.64 0.04 -0.88 -0.99 -0.99c-0.30 -0.03 -0.24 -0.42 -0.39 -0.58c-0.19 -0.21 -0.48 -0.25 -0.73 -0.35c-0.52 -0.21 -0.53 -0.62 -0.76 -1.05c-0.04 -0.08 -1.17 -0.97 -1.22 -0.97l0.00 0.00c0.00 0.16 -0.41 0.52 -0.51 0.64c-0.24 0.30 -0.52 0.13 -0.82 0.20c-0.30 0.08 -0.38 0.12 -0.66 0.29c-0.22 0.14 -0.50 0.09 -0.68 -0.07c-0.41 -0.37 -0.60 -0.07 -0.97 0.14l0.00 0.00c-0.08 0.42 -0.17 0.86 -0.05 1.29c0.15 0.53 0.55 -0.02 0.97 0.36c0.24 0.22 0.08 0.82 0.08 1.09c0.09 0.02 0.51 0.53 0.64 0.66c0.21 0.21 0.39 0.55 0.21 0.86l0.00 0.00z"},63:{name:"Y\xean B\xe1i",path:"m59.28 38.54c0.19 -0.22 0.58 -0.86 0.92 -0.78c0.25 0.06 0.32 0.27 0.66 0.32c0.36 0.06 1.17 0.08 1.20 0.57c0.01 0.15 0.11 1.58 0.45 1.41c0.06 0.06 1.13 -0.25 1.36 -0.25l0.00 0.00c0.51 0.27 0.42 2.02 1.00 2.02c0.41 0.00 0.51 0.32 0.70 0.63c0.20 0.33 0.61 -0.09 0.93 -0.01c0.00 0.28 0.06 0.63 0.11 0.91c0.04 0.25 -0.20 1.23 0.07 1.07c0.69 -0.39 0.29 0.73 0.51 0.73c0.10 0.21 0.24 0.29 0.37 0.45c0.19 0.24 0.09 0.58 0.29 0.80c0.19 0.21 0.79 0.51 0.48 0.87c-0.25 0.28 -0.42 0.41 -0.42 0.81l0.25 0.35l0.00 0.00c0.07 0.09 -0.01 0.54 -0.11 0.62c-0.11 0.10 -0.47 -0.07 -0.57 -0.12c-0.70 -0.32 -0.56 0.34 -0.91 0.49c-0.09 0.04 -0.95 0.16 -0.82 0.41c-0.05 0.05 -0.09 0.05 -0.14 0.08c-0.07 -0.05 -0.53 0.15 -0.55 0.24c-0.28 0.06 -0.01 0.94 -0.45 1.21c-0.47 0.28 0.31 0.87 0.31 1.27c0.00 0.19 0.12 0.35 0.12 0.55l-0.01 0.61c-0.01 0.30 -0.46 0.66 -0.43 0.74c0.05 0.14 0.40 0.58 0.36 0.68c-0.10 0.26 -0.44 -0.08 -0.60 -0.14c-0.26 -0.10 -0.00 0.80 -0.55 0.39l-0.27 0.20l0.00 0.00c-0.11 0.00 -0.74 0.09 -0.77 -0.02c-0.40 0.00 -0.62 -1.04 -0.86 -1.28c-0.56 -0.56 -0.78 0.81 -1.75 -0.06c-0.44 -0.40 -0.77 0.05 -1.20 -0.13c-0.64 -0.26 -0.86 0.73 -1.41 0.97c-0.87 0.38 -1.06 -0.78 -1.86 -0.95c-0.59 -0.13 -0.77 0.05 -1.06 -0.61c-0.19 -0.42 -0.91 -2.23 -0.27 -2.45c0.00 -0.56 -0.06 -0.98 0.77 -1.25c0.00 -0.37 -0.91 -0.46 -1.22 -0.42c-0.33 0.00 -0.54 -0.14 -0.88 0.00c-0.26 0.10 -0.60 0.38 -0.87 0.27c-0.23 -0.08 -0.47 -0.17 -0.69 -0.10c-0.31 0.10 -0.62 0.20 -0.95 0.13c-0.38 -0.08 -0.53 -0.17 -0.86 -0.37c-0.49 -0.30 -0.95 0.08 -1.37 -0.10c-0.29 -0.12 -0.25 -0.43 -0.62 -0.48l0.00 0.00c0.04 -0.21 -0.12 -0.63 0.04 -0.74c0.34 -0.24 1.04 -0.14 0.77 -0.82c-0.19 -0.50 -0.81 -1.05 -1.11 -1.53c-0.20 -0.31 -0.31 -0.84 -0.13 -1.21c0.16 -0.31 0.52 -0.08 0.79 -0.08c0.08 0.25 0.53 -0.28 0.58 -0.32l0.26 -0.41l0.00 0.00l0.25 0.43c-0.06 0.58 1.17 0.87 1.48 0.70c0.53 -0.30 1.13 0.14 1.66 0.35c1.53 0.59 -0.15 -1.71 1.24 -0.79c0.10 0.06 0.95 0.10 1.13 0.14c0.27 0.06 0.42 0.86 0.67 0.86c0.06 0.17 0.35 -0.24 0.38 -0.27c0.06 -0.09 0.37 -0.38 0.38 -0.44c1.72 -0.34 -0.35 -2.87 -0.15 -3.31c0.14 -0.31 0.38 -0.37 0.25 -0.78c-0.17 -0.52 -0.16 -0.88 0.37 -1.07c0.58 -0.21 0.93 0.62 1.26 0.95c0.21 0.16 0.57 0.33 0.71 0.54c0.08 0.11 0.29 0.36 0.43 0.36c0.01 0.02 0.07 0.02 0.10 0.02c0.04 0.12 0.32 -0.35 0.32 -0.50c0.00 -0.32 -0.19 -0.97 0.29 -1.00c0.43 -0.03 0.60 -0.22 0.60 -0.68c-0.41 -0.14 -0.94 0.04 -0.94 -0.69l0.00 0.00z"}}})}).call(e,t(0))},function(l,e,t){(function(l){l.fn.vectorMap("addMap","world_mill",{insets:[{width:900,top:0,height:440.7063107441331,bbox:[{y:-12671671.123330014,x:-20004297.151525836},{y:6930392.025135122,x:20026572.394749384}],left:0}],paths:{BD:{path:"M651.84,230.21l-0.6,-2.0l-1.36,-1.71l-2.31,-0.11l-0.41,0.48l0.2,0.94l-0.53,0.99l-0.72,-0.36l-0.68,0.35l-1.2,-0.36l-0.37,-2.0l-0.81,-1.86l0.39,-1.46l-0.22,-0.47l-1.14,-0.53l0.29,-0.5l1.48,-0.94l0.03,-0.65l-1.55,-1.22l0.55,-1.14l1.61,0.94l1.04,0.15l0.18,1.54l0.34,0.35l5.64,0.63l-0.84,1.64l-1.22,0.34l-0.77,1.51l0.07,0.47l1.37,1.37l0.67,-0.19l0.42,-1.39l1.21,3.84l-0.03,1.21l-0.33,-0.15l-0.4,0.28Z",name:"Bangladesh"},BE:{path:"M429.29,144.05l1.91,0.24l2.1,-0.63l2.63,1.99l-0.21,1.66l-0.69,0.4l-0.18,1.2l-1.66,-1.13l-1.39,0.15l-2.73,-2.7l-1.17,-0.18l-0.16,-0.52l1.54,-0.5Z",name:"Belgium"},BF:{path:"M421.42,247.64l-0.11,0.95l0.34,1.16l1.4,1.71l0.07,1.1l0.32,0.37l2.55,0.51l-0.04,1.28l-0.38,0.53l-1.07,0.21l-0.72,1.18l-0.63,0.21l-3.22,-0.25l-0.94,0.39l-5.4,-0.05l-0.39,0.38l0.16,2.73l-1.23,-0.43l-1.17,0.1l-0.89,0.57l-2.27,-1.72l-0.13,-1.11l0.61,-0.96l0.02,-0.93l1.87,-1.98l0.44,-1.81l0.43,-0.39l1.28,0.26l1.05,-0.52l0.47,-0.73l1.84,-1.09l0.55,-0.83l2.2,-1.0l1.15,-0.3l0.72,0.45l1.13,-0.01Z",name:"Burkina Faso"},BG:{path:"M491.65,168.18l-0.86,0.88l-0.91,2.17l0.48,1.34l-1.6,-0.24l-2.55,0.95l-0.28,1.51l-1.8,0.22l-2.0,-1.0l-1.92,0.79l-1.42,-0.07l-0.15,-1.63l-1.05,-0.97l0.0,-0.8l1.2,-1.57l0.01,-0.56l-1.14,-1.23l-0.05,-0.94l0.88,0.97l0.88,-0.2l1.91,0.47l3.68,0.16l1.42,-0.81l2.72,-0.66l2.55,1.24Z",name:"Bulgaria"},BA:{path:"M463.49,163.65l2.1,0.5l1.72,-0.03l1.52,0.68l-0.36,0.78l0.08,0.45l1.04,1.02l-0.25,0.98l-1.81,1.15l-0.38,1.38l-1.67,-0.87l-0.89,-1.2l-2.11,-1.83l-1.63,-2.22l0.23,-0.57l0.48,0.38l0.55,-0.06l0.43,-0.51l0.94,-0.06Z",name:"Bosnia and Herz."},BN:{path:"M707.48,273.58l0.68,-0.65l1.41,-0.91l-0.15,1.63l-0.81,-0.05l-0.61,0.58l-0.53,-0.6Z",name:"Brunei"},BO:{path:"M263.83,340.69l-3.09,-0.23l-0.38,0.23l-0.7,1.52l-1.31,-1.53l-3.28,-0.64l-2.37,2.4l-1.31,0.26l-0.88,-3.26l-1.3,-2.86l0.74,-2.37l-0.13,-0.43l-1.2,-1.01l-0.37,-1.89l-1.08,-1.55l1.45,-2.56l-0.96,-2.33l0.47,-1.06l-0.34,-0.73l0.91,-1.32l0.16,-3.84l0.5,-1.18l-1.81,-3.41l2.46,0.07l0.8,-0.85l3.4,-1.91l2.66,-0.35l-0.19,1.38l0.3,1.07l-0.05,1.97l2.72,2.27l2.88,0.49l0.89,0.86l1.79,0.58l0.98,0.7l1.71,0.05l1.17,0.61l0.6,2.7l-0.7,0.54l0.96,2.99l0.37,0.28l4.3,0.1l-0.25,1.2l0.27,1.02l1.43,0.9l0.5,1.35l-0.41,1.86l-0.65,1.08l0.12,1.35l-2.69,-1.65l-2.4,-0.03l-4.36,0.76l-1.49,2.5l-0.11,1.52l-0.75,2.37Z",name:"Bolivia"},JP:{path:"M781.12,166.87l1.81,0.68l1.62,-0.97l0.39,2.42l-3.35,0.75l-2.23,2.88l-3.63,-1.9l-0.56,0.2l-1.26,3.05l-2.16,0.03l-0.29,-2.51l1.08,-2.03l2.45,-0.16l0.37,-0.33l1.25,-5.94l2.47,2.71l2.03,1.12ZM773.56,187.34l-0.91,2.22l0.37,1.52l-1.14,1.75l-3.02,1.26l-4.58,0.27l-3.34,3.01l-1.25,-0.8l-0.09,-1.9l-0.46,-0.38l-4.35,0.62l-3.0,1.32l-2.85,0.05l-0.37,0.27l0.13,0.44l2.32,1.89l-1.54,4.34l-1.26,0.9l-0.79,-0.7l0.56,-2.27l-0.21,-0.45l-1.47,-0.75l-0.74,-1.4l2.12,-0.84l1.26,-1.7l2.45,-1.42l1.83,-1.91l4.78,-0.81l2.6,0.57l0.44,-0.21l2.39,-4.66l1.29,1.06l0.5,0.01l5.1,-4.02l1.69,-3.73l-0.38,-3.4l0.9,-1.61l2.14,-0.44l1.23,3.72l-0.07,2.18l-2.23,2.84l-0.04,3.16ZM757.78,196.26l0.19,0.56l-1.01,1.21l-1.16,-0.68l-1.28,0.65l-0.69,1.45l-1.02,-0.5l0.01,-0.93l1.14,-1.38l1.57,0.14l0.85,-0.98l1.4,0.46Z",name:"Japan"},BI:{path:"M495.45,295.49l-1.08,-2.99l1.14,-0.11l0.64,-1.19l0.76,0.09l0.65,1.83l-2.1,2.36Z",name:"Burundi"},BJ:{path:"M429.57,255.75l-0.05,0.8l0.5,1.34l-0.42,0.86l0.17,0.79l-1.81,2.12l-0.57,1.76l-0.08,5.42l-1.41,0.2l-0.48,-1.36l0.11,-5.71l-0.52,-0.7l-0.2,-1.35l-1.48,-1.48l0.21,-0.9l0.89,-0.43l0.42,-0.92l1.27,-0.36l1.22,-1.34l0.61,-0.0l1.62,1.24Z",name:"Benin"},BT:{path:"M650.32,213.86l0.84,0.71l-0.12,1.1l-3.76,-0.11l-1.57,0.4l-1.93,-0.87l1.48,-1.96l1.13,-0.57l1.63,0.57l1.33,0.08l0.99,0.65Z",name:"Bhutan"},JM:{path:"M228.38,239.28l-0.8,0.4l-2.26,-1.06l0.84,-0.23l2.14,0.3l1.17,0.56l-1.08,0.03Z",name:"Jamaica"},BW:{path:"M483.92,330.07l2.27,4.01l2.83,2.86l0.96,0.31l0.78,2.43l2.13,0.61l1.02,0.76l-3.0,1.64l-2.32,2.02l-1.54,2.69l-1.52,0.45l-0.64,1.94l-1.34,0.52l-1.85,-0.12l-1.21,-0.74l-1.35,-0.3l-1.22,0.62l-0.75,1.37l-2.31,1.9l-1.4,0.21l-0.35,-0.59l0.16,-1.75l-1.48,-2.54l-0.62,-0.43l-0.0,-7.1l2.08,-0.08l0.39,-0.4l0.07,-8.9l5.19,-0.93l0.8,0.89l0.51,0.07l1.5,-0.95l2.21,-0.49Z",name:"Botswana"},BR:{path:"M259.98,275.05l3.24,0.7l0.65,-0.53l4.55,-1.32l1.08,-1.06l-0.02,-0.63l0.55,-0.05l0.28,0.28l-0.26,0.87l0.22,0.48l0.73,0.32l0.4,0.81l-0.62,0.86l-0.4,2.13l0.82,2.56l1.69,1.43l1.43,0.2l3.17,-1.68l3.18,0.3l0.65,-0.75l-0.27,-0.92l1.9,-0.09l2.39,0.99l1.06,-0.61l0.84,0.78l1.2,-0.18l1.18,-1.06l0.84,-1.94l1.36,-2.11l0.37,-0.05l1.89,5.45l1.33,0.59l0.05,1.28l-1.77,1.94l0.02,0.56l1.02,0.87l4.07,0.36l0.08,2.16l0.66,0.29l1.74,-1.5l6.97,2.32l1.02,1.22l-0.35,1.18l0.49,0.5l2.81,-0.74l4.77,1.3l3.75,-0.08l3.57,2.0l3.29,2.86l1.93,0.72l2.12,0.12l0.71,0.62l1.21,4.51l-0.95,3.98l-4.72,5.06l-1.64,2.92l-1.72,2.05l-0.8,0.3l-0.72,2.03l0.18,4.75l-0.94,5.53l-0.81,1.13l-0.43,3.36l-2.55,3.5l-0.4,2.51l-1.86,1.04l-0.67,1.53l-2.54,0.01l-3.94,1.01l-1.83,1.2l-2.87,0.82l-3.03,2.19l-2.2,2.83l-0.36,2.0l0.4,1.58l-0.44,2.6l-0.51,1.2l-1.77,1.54l-2.75,4.78l-3.83,3.42l-1.24,2.74l-1.18,1.15l-0.36,-0.83l0.95,-1.14l0.01,-0.5l-1.52,-1.97l-4.56,-3.32l-1.03,-0.0l-2.38,-2.02l-0.81,-0.0l5.34,-5.45l3.77,-2.58l0.22,-2.46l-1.35,-1.81l-0.91,0.07l0.58,-2.33l0.01,-1.54l-1.11,-0.83l-1.75,0.3l-0.44,-3.11l-0.52,-0.95l-1.88,-0.88l-1.24,0.47l-2.17,-0.41l0.15,-3.21l-0.62,-1.34l0.66,-0.73l-0.22,-1.34l0.66,-1.13l0.44,-2.04l-0.61,-1.83l-1.4,-0.86l-0.2,-0.75l0.34,-1.39l-0.38,-0.5l-4.52,-0.1l-0.72,-2.22l0.59,-0.42l-0.03,-1.1l-0.5,-0.87l-0.32,-1.7l-1.45,-0.76l-1.63,-0.02l-1.05,-0.72l-1.6,-0.48l-1.13,-0.99l-2.69,-0.4l-2.47,-2.06l0.13,-4.35l-0.45,-0.45l-3.46,0.5l-3.44,1.94l-0.6,0.74l-2.9,-0.17l-1.47,0.42l-0.72,-0.18l0.15,-3.52l-0.63,-0.34l-1.94,1.41l-1.87,-0.06l-0.83,-1.18l-1.37,-0.26l0.21,-1.01l-1.35,-1.49l-0.88,-1.91l0.56,-0.6l-0.0,-0.81l1.29,-0.62l0.22,-0.43l-0.22,-1.19l0.61,-0.91l0.15,-0.99l2.65,-1.58l1.99,-0.47l0.42,-0.36l2.06,0.11l0.42,-0.33l1.19,-8.0l-0.41,-1.56l-1.1,-1.0l0.01,-1.33l1.91,-0.42l0.08,-0.96l-0.33,-0.43l-1.14,-0.2l-0.02,-0.83l4.47,0.05l0.82,-0.67l0.82,1.81l0.8,0.07l1.15,1.1l2.26,-0.05l0.71,-0.83l2.78,-0.96l0.48,-1.13l1.6,-0.64l0.24,-0.47l-0.48,-0.82l-1.83,-0.19l-0.36,-3.22Z",name:"Brazil"},BS:{path:"M226.4,223.87l-0.48,-1.15l-0.84,-0.75l0.36,-1.11l0.95,1.95l0.01,1.06ZM225.56,216.43l-1.87,0.29l-0.04,-0.22l0.74,-0.14l1.17,0.06Z",name:"Bahamas"},BY:{path:"M493.84,128.32l0.29,0.7l0.49,0.23l1.19,-0.38l2.09,0.72l0.19,1.26l-0.45,1.24l1.57,2.26l0.89,0.59l0.17,0.81l1.58,0.56l0.4,0.5l-0.53,0.41l-1.87,-0.11l-0.73,0.38l-0.13,0.52l1.04,2.74l-1.91,0.26l-0.89,0.99l-0.11,1.18l-2.73,-0.04l-0.53,-0.62l-0.52,-0.08l-0.75,0.46l-0.91,-0.42l-1.92,-0.07l-2.75,-0.79l-2.6,-0.28l-2.0,0.07l-1.5,0.92l-0.67,0.07l-0.08,-1.22l-0.59,-1.19l1.36,-0.88l0.01,-1.35l-0.7,-1.41l-0.07,-1.0l2.16,-0.02l2.72,-1.3l0.75,-2.04l1.91,-1.04l0.2,-0.41l-0.19,-1.25l3.8,-1.78l2.3,0.77Z",name:"Belarus"},BZ:{path:"M198.03,244.38l0.1,-4.49l0.69,-0.06l0.74,-1.3l0.34,0.28l-0.4,1.3l0.17,0.58l-0.34,2.25l-1.3,1.42Z",name:"Belize"},RU:{path:"M491.55,115.25l2.55,-1.85l-0.01,-0.65l-2.2,-1.5l7.32,-6.76l1.03,-2.11l-0.13,-0.49l-3.46,-2.52l0.86,-2.7l-2.11,-2.81l1.56,-3.67l-2.77,-4.52l2.15,-2.99l-0.08,-0.55l-3.65,-2.73l0.3,-2.54l1.81,-0.37l4.26,-1.77l2.42,-1.45l4.06,2.61l6.79,1.04l9.34,4.85l1.78,1.88l0.14,2.46l-2.55,2.02l-3.9,1.06l-11.07,-3.14l-2.06,0.53l-0.13,0.7l3.94,2.94l0.31,5.86l0.26,0.36l5.14,2.24l0.58,-0.29l0.32,-1.94l-1.35,-1.78l1.13,-1.09l6.13,2.42l2.11,-0.98l0.18,-0.56l-1.51,-2.67l5.41,-3.76l2.07,0.22l2.26,1.41l0.57,-0.16l1.46,-2.87l-0.05,-0.44l-1.92,-2.32l1.12,-2.32l-1.32,-2.27l5.87,1.16l1.04,1.75l-2.59,0.43l-0.33,0.4l0.02,2.36l2.46,1.83l3.87,-0.91l0.86,-2.8l13.69,-5.65l0.99,0.11l-1.92,2.06l0.23,0.67l3.11,0.45l2.0,-1.48l4.56,-0.12l3.64,-1.73l2.65,2.44l0.56,-0.01l2.85,-2.88l-0.01,-0.57l-2.35,-2.29l0.9,-1.01l7.14,1.3l3.41,1.36l9.05,4.97l0.51,-0.11l1.67,-2.27l-0.05,-0.53l-2.43,-2.21l-0.06,-0.78l-0.34,-0.36l-2.52,-0.36l0.64,-1.93l-1.32,-3.46l-0.06,-1.21l4.48,-4.06l1.69,-4.29l1.6,-0.81l6.23,1.18l0.44,2.21l-2.29,3.64l0.06,0.5l1.47,1.39l0.76,3.0l-0.56,6.03l2.69,2.82l-0.96,2.57l-4.86,5.95l0.23,0.64l2.86,0.61l0.42,-0.17l0.93,-1.4l2.64,-1.03l0.87,-2.24l2.09,-1.96l0.07,-0.5l-1.36,-2.28l1.09,-2.69l-0.32,-0.55l-2.47,-0.33l-0.5,-2.06l1.94,-4.38l-0.06,-0.42l-2.96,-3.4l4.12,-2.88l0.16,-0.4l-0.51,-2.93l0.54,-0.05l1.13,2.25l-0.96,4.35l0.27,0.47l2.68,0.84l0.5,-0.51l-1.02,-2.99l3.79,-1.66l5.01,-0.24l4.53,2.61l0.48,-0.06l0.07,-0.48l-2.18,-3.82l-0.23,-4.67l3.98,-0.9l5.97,0.21l5.49,-0.64l0.27,-0.65l-1.83,-2.31l2.56,-2.9l2.87,-0.17l4.8,-2.47l6.54,-0.67l1.03,-1.42l6.25,-0.45l2.32,1.11l5.53,-2.7l4.5,0.08l0.39,-0.28l0.66,-2.15l2.26,-2.12l5.69,-2.11l3.21,1.29l-2.46,0.94l-0.25,0.42l0.34,0.35l5.41,0.77l0.61,2.33l0.58,0.25l2.2,-1.22l7.13,0.07l5.51,2.47l1.79,1.72l-0.53,2.24l-9.16,4.15l-1.97,1.52l0.16,0.71l6.77,1.91l2.16,-0.78l1.13,2.74l0.67,0.11l1.01,-1.15l3.81,-0.73l7.7,0.77l0.54,1.99l0.36,0.29l10.47,0.71l0.43,-0.38l0.13,-3.23l4.87,0.78l3.95,-0.02l3.83,2.4l1.03,2.71l-1.35,1.79l0.02,0.5l3.15,3.64l4.07,1.96l0.53,-0.18l2.23,-4.47l3.95,1.93l4.16,-1.21l4.73,1.39l2.05,-1.26l3.94,0.62l0.43,-0.55l-1.68,-4.02l2.89,-1.8l22.31,3.03l2.16,2.75l6.55,3.51l10.29,-0.81l4.82,0.73l1.85,1.66l-0.29,3.08l0.25,0.41l3.08,1.26l3.56,-0.88l4.35,-0.11l4.8,0.87l4.57,-0.47l4.23,3.79l0.43,0.07l3.1,-1.4l0.16,-0.6l-1.88,-2.62l0.85,-1.52l7.71,1.21l5.22,-0.26l7.09,2.09l9.59,5.22l6.35,4.11l-0.2,2.38l1.88,1.41l0.6,-0.42l-0.48,-2.53l6.15,0.57l4.4,3.51l-1.97,1.43l-4.0,0.41l-0.36,0.39l-0.06,3.79l-0.74,0.62l-2.07,-0.11l-1.91,-1.39l-3.14,-1.11l-0.78,-1.85l-2.72,-0.68l-2.63,0.49l-1.04,-1.1l0.46,-1.31l-0.5,-0.51l-3.0,0.98l-0.22,0.58l0.99,1.7l-1.21,1.48l-3.04,1.68l-3.12,-0.28l-0.4,0.23l0.09,0.46l2.2,2.09l1.46,3.2l1.15,1.1l0.24,1.33l-0.42,0.67l-4.63,-0.77l-6.96,2.9l-2.19,0.44l-7.6,5.06l-0.84,1.45l-3.61,-2.37l-6.24,2.82l-0.94,-1.15l-0.53,-0.08l-2.28,1.52l-3.2,-0.49l-0.44,0.27l-0.78,2.37l-3.05,3.78l0.09,1.47l0.29,0.36l2.54,0.72l-0.29,4.53l-1.97,0.11l-0.35,0.26l-1.07,2.94l0.8,1.45l-3.91,1.58l-1.05,3.95l-3.48,0.77l-0.3,0.3l-0.72,3.29l-3.09,2.65l-0.7,-1.74l-2.44,-12.44l1.16,-4.71l2.04,-2.06l0.22,-1.64l3.8,-0.86l4.46,-4.61l4.28,-3.81l4.48,-3.01l2.17,-5.63l-0.42,-0.54l-3.04,0.33l-1.77,3.31l-5.86,3.86l-1.86,-4.25l-0.45,-0.23l-6.46,1.3l-6.47,6.44l-0.01,0.55l1.58,1.74l-8.24,1.17l0.15,-2.2l-0.34,-0.42l-3.89,-0.56l-3.25,1.81l-7.62,-0.62l-8.45,1.19l-17.71,15.41l0.22,0.7l3.74,0.41l1.36,2.17l2.43,0.76l1.88,-1.68l2.4,0.2l3.4,3.54l0.08,2.6l-1.95,3.42l-0.21,3.9l-1.1,5.06l-3.71,4.54l-0.87,2.21l-8.29,8.89l-3.19,1.7l-1.32,0.03l-1.45,-1.36l-0.49,-0.04l-2.27,1.5l0.41,-3.65l-0.59,-2.47l1.75,-0.89l2.91,0.53l0.42,-0.2l1.68,-3.03l0.87,-3.46l0.97,-1.18l1.32,-2.88l-0.45,-0.56l-4.14,0.95l-2.19,1.25l-3.41,-0.0l-1.06,-2.93l-2.97,-2.3l-4.28,-1.06l-1.75,-5.07l-2.66,-5.01l-2.29,-1.29l-3.75,-1.01l-3.44,0.08l-3.18,0.62l-2.24,1.77l0.05,0.66l1.18,0.69l0.02,1.43l-1.33,1.05l-2.26,3.51l-0.04,1.43l-3.16,1.84l-2.82,-1.16l-3.01,0.23l-1.35,-1.07l-1.5,-0.35l-3.9,2.31l-3.22,0.52l-2.27,0.79l-3.05,-0.51l-2.21,0.03l-1.48,-1.6l-2.6,-1.63l-2.63,-0.43l-5.46,1.01l-3.23,-1.25l-0.72,-2.57l-5.2,-1.24l-2.75,-1.36l-0.5,0.12l-2.59,3.45l0.84,2.1l-2.06,1.93l-3.41,-0.77l-2.42,-0.12l-1.83,-1.54l-2.53,-0.05l-2.42,-0.98l-3.86,1.57l-4.72,2.78l-3.3,0.75l-1.55,-1.92l-3.0,0.41l-1.11,-1.33l-1.62,-0.59l-1.31,-1.94l-1.38,-0.6l-3.7,0.79l-3.31,-1.83l-0.51,0.11l-0.99,1.29l-5.29,-8.05l-2.96,-2.48l0.65,-0.77l0.01,-0.51l-0.5,-0.11l-6.2,3.21l-1.84,0.15l0.15,-1.39l-0.26,-0.42l-3.22,-1.17l-2.46,0.7l-0.69,-3.16l-0.32,-0.31l-4.5,-0.75l-2.47,1.47l-6.19,1.27l-1.29,0.86l-9.51,1.3l-1.15,1.17l-0.03,0.53l1.47,1.9l-1.89,0.69l-0.22,0.56l0.31,0.6l-2.11,1.44l0.03,0.68l3.75,2.12l-0.39,0.98l-3.23,-0.13l-0.86,0.86l-3.09,-1.59l-3.97,0.07l-2.66,1.35l-8.32,-3.56l-4.07,0.06l-5.39,3.68l-0.39,2.0l-2.03,-1.5l-0.59,0.13l-2.0,3.59l0.57,0.93l-1.28,2.16l0.06,0.48l2.13,2.17l1.95,0.04l1.37,1.82l-0.23,1.46l0.25,0.43l0.83,0.33l-0.8,1.31l-2.49,0.62l-2.49,3.2l0.0,0.49l2.17,2.78l-0.15,2.18l2.5,3.24l-1.58,1.59l-0.7,-0.13l-1.63,-1.72l-2.29,-0.84l-0.94,-1.31l-2.34,-0.63l-1.48,0.4l-0.43,-0.47l-3.51,-1.48l-5.76,-1.01l-0.45,0.19l-2.89,-2.34l-2.9,-1.2l-1.53,-1.29l1.29,-0.43l2.08,-2.61l-0.05,-0.55l-0.89,-0.79l3.05,-1.06l0.27,-0.42l-0.07,-0.69l-0.49,-0.35l-1.73,0.39l0.04,-0.68l1.04,-0.72l2.66,-0.48l0.4,-1.32l-0.5,-1.6l0.92,-1.54l0.03,-1.17l-0.29,-0.37l-3.69,-1.06l-1.41,0.02l-1.42,-1.41l-2.19,0.38l-2.77,-1.01l-0.03,-0.59l-0.89,-1.43l-2.0,-0.32l-0.11,-0.54l0.49,-0.53l0.01,-0.53l-1.6,-1.9l-3.58,0.02l-0.88,0.73l-0.46,-0.07l-1.0,-2.79l2.22,-0.02l0.97,-0.74l0.07,-0.57l-0.9,-1.04l-1.35,-0.48l-0.11,-0.7l-0.95,-0.58l-1.38,-1.99l0.46,-0.98l-0.51,-1.96l-2.45,-0.84l-1.21,0.3l-0.46,-0.76l-2.46,-0.83l-0.72,-1.87l-0.21,-1.69l-0.99,-0.85l0.85,-1.17l-0.7,-3.21l1.66,-1.97l-0.16,-0.79ZM749.2,170.72l-0.6,0.4l-0.13,0.16l-0.01,-0.51l0.74,-0.05ZM871.88,65.81l2.17,-0.13l3.19,1.16l-2.39,1.09l-5.63,0.48l-0.26,-0.84l2.92,-1.76ZM797.39,48.49l-2.0,1.36l-3.8,-0.42l-4.25,-1.8l0.35,-0.97l9.69,1.83ZM783.67,46.12l-1.63,3.09l-8.98,-0.13l-4.09,1.14l-4.54,-2.97l1.16,-3.01l3.05,-0.89l6.5,0.22l8.54,2.56ZM778.2,134.98l-0.56,-0.9l0.27,-0.12l0.29,1.01ZM778.34,135.48l0.94,3.53l-0.05,3.38l1.05,3.39l2.18,5.0l-2.89,-0.83l-0.49,0.26l-1.54,4.65l2.42,3.5l-0.04,1.13l-1.24,-1.24l-0.61,0.06l-1.09,1.61l-0.28,-1.61l0.27,-3.1l-0.28,-3.4l0.58,-2.47l0.11,-4.39l-1.46,-3.36l0.21,-4.32l2.15,-1.46l0.07,-0.34ZM771.95,56.61l1.76,-1.42l2.89,-0.42l3.28,1.71l0.14,0.6l-3.27,0.03l-4.81,-0.5ZM683.76,31.09l-13.01,1.93l4.03,-6.35l1.82,-0.56l1.73,0.34l5.99,2.98l-0.56,1.66ZM670.85,27.93l-5.08,0.64l-6.86,-1.57l-3.99,-2.05l-2.1,-4.16l-2.6,-0.87l5.72,-3.5l5.2,-1.28l4.69,2.85l5.59,5.4l-0.56,4.53ZM564.15,68.94l-0.64,0.17l-7.85,-0.57l-0.86,-2.04l-4.28,-1.17l-0.28,-1.94l2.27,-0.89l0.25,-0.39l-0.08,-2.38l4.81,-3.97l-0.15,-0.7l-1.47,-0.38l5.3,-3.81l0.15,-0.44l-0.58,-1.94l5.28,-2.51l8.21,-3.27l8.28,-0.96l4.35,-1.94l4.6,-0.64l1.36,1.61l-1.34,1.28l-16.43,4.94l-7.97,4.88l-7.74,9.63l0.66,4.14l4.16,3.27ZM548.81,18.48l-5.5,1.18l-0.58,1.02l-2.59,0.84l-2.13,-1.07l1.12,-1.42l-0.3,-0.65l-2.33,-0.07l1.68,-0.36l3.47,-0.06l0.42,1.29l0.66,0.16l1.38,-1.34l2.15,-0.88l2.94,1.01l-0.39,0.36ZM477.37,133.15l-4.08,0.05l-2.56,-0.32l0.33,-0.87l3.17,-1.03l3.24,0.96l-0.09,1.23Z",name:"Russia"},RW:{path:"M497.0,288.25l0.71,1.01l-0.11,1.09l-1.63,0.03l-1.04,1.39l-0.83,-0.11l0.51,-1.2l0.08,-1.34l0.42,-0.41l0.7,0.14l1.19,-0.61Z",name:"Rwanda"},RS:{path:"M469.4,163.99l0.42,-0.5l-0.01,-0.52l-1.15,-1.63l1.43,-0.62l1.33,0.12l1.17,1.06l0.46,1.13l1.34,0.64l0.35,1.35l1.46,0.9l0.76,-0.29l0.2,0.69l-0.48,0.78l0.22,1.12l1.05,1.22l-0.77,0.8l-0.37,1.52l-1.21,0.08l0.24,-0.64l-0.39,-0.54l-2.08,-1.64l-0.9,0.05l-0.48,0.94l-2.12,-1.37l0.53,-1.6l-1.11,-1.37l0.51,-1.1l-0.41,-0.57Z",name:"Serbia"},TL:{path:"M734.55,307.93l-0.1,-0.97l4.5,-0.86l-2.82,1.28l-1.59,0.55Z",name:"Timor-Leste"},TM:{path:"M553.03,173.76l-0.04,0.34l-0.09,-0.22l0.13,-0.12ZM555.87,172.66l0.45,-0.1l1.48,0.74l2.06,2.43l4.07,-0.18l0.38,-0.51l-0.32,-1.19l1.92,-0.94l1.91,-1.59l2.94,1.39l0.43,2.47l1.19,0.67l2.58,-0.13l0.62,0.4l1.32,3.12l4.54,3.44l2.67,1.45l3.06,1.14l-0.04,1.05l-1.33,-0.75l-0.59,0.19l-0.32,0.84l-2.2,0.81l-0.46,2.13l-1.21,0.74l-1.91,0.42l-0.73,1.33l-1.56,0.31l-2.22,-0.94l-0.2,-2.17l-0.38,-0.36l-1.73,-0.09l-2.76,-2.46l-2.14,-0.4l-2.84,-1.48l-1.78,-0.27l-1.24,0.53l-1.57,-0.08l-2.0,1.69l-1.7,0.43l-0.36,-1.58l0.36,-2.98l-0.22,-0.4l-1.65,-0.84l0.54,-1.69l-0.34,-0.52l-1.22,-0.13l0.36,-1.64l2.22,0.59l2.2,-0.95l0.12,-0.65l-1.77,-1.74l-0.66,-1.57Z",name:"Turkmenistan"},TJ:{path:"M597.75,178.82l-2.54,-0.44l-0.47,0.34l-0.24,1.7l0.43,0.45l2.64,-0.22l3.18,0.95l4.39,-0.41l0.56,2.37l0.52,0.29l0.67,-0.24l1.11,0.49l0.21,2.13l-3.76,-0.21l-1.8,1.32l-1.76,0.74l-0.61,-0.58l0.21,-2.23l-0.64,-0.49l-0.07,-0.93l-1.36,-0.66l-0.45,0.07l-1.08,1.01l-0.55,1.48l-1.31,-0.05l-0.95,1.16l-0.9,-0.35l-1.86,0.74l1.26,-2.83l-0.54,-2.17l-1.67,-0.82l0.33,-0.66l2.18,-0.04l1.19,-1.63l0.76,-1.79l2.43,-0.5l-0.26,1.0l0.73,1.05Z",name:"Tajikistan"},RO:{path:"M487.53,154.23l0.6,0.24l2.87,3.98l-0.17,2.69l0.45,1.42l1.32,0.81l1.35,-0.42l0.76,0.36l0.02,0.31l-0.83,0.45l-0.59,-0.22l-0.54,0.3l-0.62,3.3l-1.0,-0.22l-2.07,-1.13l-2.95,0.71l-1.25,0.76l-3.51,-0.15l-1.89,-0.47l-0.87,0.16l-0.82,-1.3l0.29,-0.26l-0.06,-0.64l-1.09,-0.34l-0.56,0.5l-1.05,-0.64l-0.39,-1.39l-1.36,-0.65l-0.35,-1.0l-0.83,-0.75l1.54,-0.54l2.66,-4.21l2.4,-1.24l2.96,0.34l1.48,0.73l0.79,-0.45l1.78,-0.3l0.75,-0.74l0.79,0.0Z",name:"Romania"},GW:{path:"M386.23,253.6l-0.29,0.84l0.15,0.6l-2.21,0.59l-0.86,0.96l-1.04,-0.83l-1.09,-0.23l-0.54,-1.06l-0.66,-0.49l2.41,-0.48l4.13,0.1Z",name:"Guinea-Bissau"},GT:{path:"M195.08,249.77l-2.48,-0.37l-1.03,-0.45l-1.14,-0.89l0.3,-0.99l-0.24,-0.68l0.96,-1.66l2.98,-0.01l0.4,-0.37l-0.19,-1.28l-1.67,-1.4l0.51,-0.4l0.0,-1.05l3.85,0.02l-0.21,4.53l0.4,0.43l1.46,0.38l-1.48,0.98l-0.35,0.7l0.12,0.57l-2.2,1.96Z",name:"Guatemala"},GR:{path:"M487.07,174.59l-0.59,1.43l-0.37,0.21l-2.84,-0.35l-3.03,0.77l-0.18,0.68l1.28,1.23l-0.61,0.23l-1.14,0.0l-1.2,-1.39l-0.63,0.03l-0.53,1.01l0.56,1.76l1.03,1.19l-0.56,0.38l-0.05,0.62l2.52,2.12l0.02,0.87l-1.78,-0.59l-0.48,0.56l0.5,1.0l-1.07,0.2l-0.3,0.53l0.75,2.01l-0.98,0.02l-1.84,-1.12l-1.37,-4.2l-2.21,-2.95l-0.11,-0.56l1.04,-1.28l0.2,-0.95l0.85,-0.66l0.03,-0.46l1.32,-0.21l1.01,-0.64l1.22,0.05l0.65,-0.56l2.26,-0.0l1.82,-0.75l1.85,1.0l2.28,-0.28l0.35,-0.39l0.01,-0.77l0.34,0.22ZM480.49,192.16l0.58,0.4l-0.68,-0.12l0.11,-0.28ZM482.52,192.82l2.51,0.06l0.24,0.32l-1.99,0.13l-0.77,-0.51Z",name:"Greece"},GQ:{path:"M448.79,279.62l0.02,2.22l-4.09,0.0l0.69,-2.27l3.38,0.05Z",name:"Eq. Guinea"},GY:{path:"M277.42,270.07l-0.32,1.83l-1.32,0.57l-0.23,0.46l-0.28,2.0l1.11,1.82l0.83,0.19l0.32,1.25l1.13,1.62l-1.21,-0.19l-1.08,0.71l-1.77,0.5l-0.44,0.46l-0.86,-0.09l-1.32,-1.01l-0.77,-2.27l0.36,-1.9l0.68,-1.23l-0.57,-1.17l-0.74,-0.43l0.12,-1.16l-0.9,-0.69l-1.1,0.09l-1.31,-1.48l0.53,-0.72l-0.04,-0.84l1.99,-0.86l0.05,-0.59l-0.71,-0.78l0.14,-0.57l1.66,-1.24l1.36,0.77l1.41,1.49l0.06,1.15l0.37,0.38l0.8,0.05l2.06,1.86Z",name:"Guyana"},GE:{path:"M521.71,168.93l5.29,0.89l4.07,2.01l1.41,-0.44l2.07,0.56l0.68,1.1l1.07,0.55l-0.12,0.59l0.98,1.29l-1.01,-0.13l-1.81,-0.83l-0.94,0.47l-3.23,0.43l-2.29,-1.39l-2.33,0.05l0.21,-0.97l-0.76,-2.26l-1.45,-1.12l-1.43,-0.39l-0.41,-0.42Z",name:"Georgia"},GB:{path:"M412.61,118.72l-2.19,3.22l-0.0,0.45l5.13,-0.3l-0.53,2.37l-2.2,3.12l0.29,0.63l2.37,0.21l2.33,4.3l1.76,0.69l2.2,5.12l2.94,0.77l-0.23,1.62l-1.15,0.88l-0.1,0.52l0.82,1.42l-1.86,1.43l-3.3,-0.02l-4.12,0.87l-1.04,-0.58l-0.47,0.06l-1.51,1.41l-2.12,-0.34l-1.86,1.18l-0.6,-0.29l3.19,-3.0l2.16,-0.69l0.28,-0.41l-0.34,-0.36l-3.73,-0.53l-0.4,-0.76l2.2,-0.87l0.17,-0.61l-1.26,-1.67l0.36,-1.7l3.38,0.28l0.43,-0.33l0.37,-1.99l-1.79,-2.49l-3.11,-0.72l-0.38,-0.59l0.79,-1.35l-0.04,-0.46l-0.82,-0.97l-0.61,0.01l-0.68,0.84l-0.1,-2.34l-1.23,-1.88l0.85,-3.47l1.77,-2.68l1.85,0.26l2.17,-0.22ZM406.26,132.86l-1.01,1.77l-1.57,-0.59l-1.16,0.01l0.37,-1.54l-0.39,-1.39l1.45,-0.1l2.3,1.84Z",name:"United Kingdom"},GA:{path:"M453.24,279.52l-0.08,0.98l0.7,1.29l2.36,0.24l-0.98,2.63l1.18,1.79l0.25,1.78l-0.29,1.52l-0.6,0.93l-1.84,-0.09l-1.23,-1.11l-0.66,0.23l-0.15,0.84l-1.42,0.26l-1.02,0.7l-0.11,0.52l0.77,1.35l-1.34,0.97l-3.94,-4.3l-1.44,-2.45l0.06,-0.6l0.54,-0.81l1.05,-3.46l4.17,-0.07l0.4,-0.4l-0.02,-2.66l2.39,0.21l1.25,-0.27Z",name:"Gabon"},GN:{path:"M391.8,254.11l0.47,0.8l1.11,-0.32l0.98,0.7l1.07,0.2l2.26,-1.22l0.64,0.44l1.13,1.56l-0.48,1.4l0.8,0.3l-0.08,0.48l0.46,0.68l-0.35,1.36l1.05,2.61l-1.0,0.69l0.03,1.41l-0.72,-0.06l-1.08,1.0l-0.24,-0.27l0.07,-1.11l-1.05,-1.54l-1.79,0.21l-0.35,-2.01l-1.6,-2.18l-2.0,-0.0l-1.31,0.54l-1.95,2.18l-1.86,-2.19l-1.2,-0.78l-0.3,-1.11l-0.8,-0.85l0.65,-0.72l0.81,-0.03l1.64,-0.8l0.23,-1.87l2.67,0.64l0.89,-0.3l1.21,0.15Z",name:"Guinea"},GM:{path:"M379.31,251.39l0.1,-0.35l2.43,-0.07l0.74,-0.61l0.51,-0.03l0.77,0.49l-1.03,-0.3l-1.87,0.9l-1.65,-0.04ZM384.03,250.91l0.91,0.05l0.75,-0.24l-0.59,0.31l-1.08,-0.13Z",name:"Gambia"},GL:{path:"M353.02,1.2l14.69,4.67l-3.68,1.89l-22.97,0.86l-0.36,0.27l0.12,0.43l1.55,1.18l8.79,-0.66l7.48,2.07l4.86,-1.77l1.66,1.73l-2.53,3.19l-0.01,0.48l0.46,0.15l6.35,-2.2l12.06,-2.31l7.24,1.13l1.09,1.99l-9.79,4.01l-1.44,1.32l-7.87,0.98l-0.35,0.41l0.38,0.38l5.07,0.24l-2.53,3.58l-2.07,3.81l0.08,6.05l2.57,3.11l-3.22,0.2l-4.12,1.66l-0.05,0.72l4.45,2.65l0.51,3.75l-2.3,0.4l-0.25,0.64l2.79,3.69l-4.82,0.31l-0.36,0.29l0.16,0.44l2.62,1.8l-0.59,1.22l-3.3,0.7l-3.45,0.01l-0.29,0.68l3.03,3.12l0.02,1.34l-4.4,-1.73l-1.72,1.35l0.15,0.66l3.31,1.15l3.13,2.71l0.81,3.16l-3.85,0.75l-4.89,-4.26l-0.47,-0.03l-0.17,0.44l0.79,2.86l-2.71,2.21l-0.13,0.44l0.37,0.27l8.73,0.34l-12.32,6.64l-7.24,1.48l-2.94,0.08l-2.69,1.75l-3.43,4.41l-5.24,2.84l-1.73,0.18l-7.12,2.1l-2.15,2.52l-0.13,2.99l-1.19,2.45l-4.01,3.09l-0.14,0.44l0.97,2.9l-2.28,6.48l-3.1,0.2l-3.83,-3.07l-4.86,-0.02l-2.25,-1.93l-1.7,-3.79l-4.3,-4.84l-1.21,-2.49l-0.44,-3.8l-3.32,-3.63l0.84,-2.86l-1.56,-1.7l2.28,-4.6l3.83,-1.74l1.03,-1.96l0.52,-3.47l-0.59,-0.41l-4.17,2.21l-2.07,0.58l-2.72,-1.28l-0.15,-2.71l0.85,-2.09l2.01,-0.06l5.06,1.2l0.46,-0.23l-0.14,-0.49l-6.54,-4.47l-2.67,0.55l-1.58,-0.86l2.56,-4.01l-0.03,-0.48l-1.5,-1.74l-4.98,-8.5l-3.13,-1.96l0.03,-1.88l-0.24,-0.37l-6.85,-3.02l-5.36,-0.38l-12.7,0.58l-2.78,-1.57l-3.66,-2.77l5.73,-1.45l5.0,-0.28l0.38,-0.38l-0.35,-0.41l-10.67,-1.38l-5.3,-2.06l0.25,-1.54l18.41,-5.26l1.22,-2.27l-0.25,-0.55l-6.14,-1.86l1.68,-1.77l8.55,-4.03l3.59,-0.63l0.3,-0.54l-0.88,-2.27l5.47,-1.47l7.65,-0.95l7.55,-0.05l3.04,1.85l6.48,-3.27l5.81,2.22l3.56,0.5l5.16,1.94l0.5,-0.21l-0.17,-0.52l-5.71,-3.13l0.28,-2.13l8.12,-3.6l8.7,0.28l3.35,-2.34l8.71,-0.6l19.93,0.8Z",name:"Greenland"},GH:{path:"M420.53,257.51l-0.01,0.72l0.96,1.2l0.24,3.73l0.59,0.95l-0.51,2.1l0.19,1.41l1.02,2.21l-6.97,2.84l-1.8,-0.57l0.04,-0.89l-1.02,-2.04l0.61,-2.65l1.07,-2.32l-0.96,-6.47l5.01,0.07l0.94,-0.39l0.61,0.11Z",name:"Ghana"},OM:{path:"M568.09,230.93l-0.91,1.67l-1.22,0.04l-0.6,0.76l-0.41,1.51l0.27,1.58l-1.16,0.05l-1.56,0.97l-0.76,1.74l-1.62,0.05l-0.98,0.65l-0.17,1.15l-0.89,0.52l-1.49,-0.18l-2.4,0.94l-2.47,-5.4l7.35,-2.71l1.67,-5.23l-1.12,-2.09l0.05,-0.83l0.67,-1.0l0.07,-1.05l0.9,-0.42l-0.05,-2.07l0.7,-0.01l1.0,1.62l1.51,1.08l3.3,0.84l1.73,2.29l0.81,0.37l-1.23,2.35l-0.99,0.79Z",name:"Oman"},TN:{path:"M448.1,188.24l-1.0,1.27l-0.02,1.32l0.84,0.88l-0.28,2.09l-1.53,1.32l-0.12,0.42l0.48,1.54l1.42,0.32l0.53,1.11l0.9,0.52l-0.11,1.67l-3.54,2.64l-0.1,2.38l-0.58,0.3l-0.96,-4.45l-1.54,-1.25l-0.16,-0.78l-1.92,-1.56l-0.18,-1.76l1.51,-1.62l0.59,-2.34l-0.38,-2.78l0.42,-1.21l2.45,-1.05l1.29,0.26l-0.06,1.11l0.58,0.38l1.47,-0.73Z",name:"Tunisia"},JO:{path:"M518.64,201.38l-5.14,1.56l-0.19,0.65l2.16,2.39l-0.89,1.14l-1.71,0.34l-1.71,1.8l-2.34,-0.37l1.21,-4.32l0.56,-4.07l2.8,0.94l4.46,-2.71l0.79,2.66Z",name:"Jordan"},HR:{path:"M455.59,162.84l1.09,0.07l-0.82,0.94l-0.27,-1.01ZM456.96,162.92l0.62,-0.41l1.73,0.45l0.42,-0.4l-0.01,-0.59l0.86,-0.52l0.2,-1.05l1.63,-0.68l2.57,1.68l2.07,0.6l0.87,-0.31l1.05,1.57l-0.52,0.63l-1.05,-0.56l-1.68,0.04l-2.1,-0.5l-1.29,0.06l-0.57,0.49l-0.59,-0.47l-0.62,0.16l-0.46,1.7l1.79,2.42l2.79,2.75l-1.18,-0.87l-2.21,-0.87l-1.67,-1.78l0.13,-0.63l-1.05,-1.19l-0.32,-1.27l-1.42,-0.43Z",name:"Croatia"},HT:{path:"M237.05,238.38l-1.16,0.43l-0.91,-0.55l0.05,-0.2l2.02,0.31ZM237.53,238.43l1.06,0.12l-0.05,0.01l-1.01,-0.12ZM239.25,238.45l0.79,-0.51l0.06,-0.62l-1.02,-1.0l0.02,-0.82l-0.3,-0.4l-0.93,-0.32l3.16,0.45l0.02,1.84l-0.48,0.34l-0.08,0.58l0.54,0.72l-1.78,-0.26Z",name:"Haiti"},HU:{path:"M462.08,157.89l0.65,-1.59l-0.09,-0.44l0.64,-0.0l0.39,-0.34l0.1,-0.69l1.75,0.87l2.32,-0.37l0.43,-0.66l3.49,-0.78l0.69,-0.78l0.57,-0.14l2.57,0.93l0.67,-0.23l1.03,0.65l0.08,0.37l-1.42,0.71l-2.59,4.14l-1.8,0.53l-1.68,-0.1l-2.74,1.23l-1.85,-0.54l-2.54,-1.66l-0.66,-1.1Z",name:"Hungary"},HN:{path:"M199.6,249.52l-1.7,-1.21l0.06,-0.94l3.04,-2.14l2.37,0.28l1.27,-0.09l1.1,-0.52l1.3,0.28l1.14,-0.25l1.38,0.37l2.23,1.37l-2.36,0.93l-1.23,-0.39l-0.88,1.3l-1.28,0.99l-0.98,-0.22l-0.42,0.52l-0.96,0.05l-0.36,0.41l0.04,0.88l-0.52,0.6l-0.3,0.04l-0.3,-0.55l-0.66,-0.31l0.11,-0.67l-0.48,-0.65l-0.87,-0.26l-0.73,0.2Z",name:"Honduras"},PR:{path:"M256.17,238.73l-0.26,0.27l-2.83,0.05l-0.07,-0.55l1.95,-0.1l1.22,0.33Z",name:"Puerto Rico"},PS:{path:"M509.21,203.07l0.1,-0.06l-0.02,0.03l-0.09,0.03ZM509.36,202.91l-0.02,-0.63l-0.33,-0.16l0.31,-1.09l0.24,0.1l-0.2,1.78Z",name:"Palestine"},PT:{path:"M401.84,187.38l-0.64,0.47l-1.13,-0.35l-0.91,0.17l0.28,-1.78l-0.24,-1.78l-1.25,-0.56l-0.45,-0.84l0.17,-1.66l1.01,-1.18l0.69,-2.92l-0.04,-1.39l-0.59,-1.9l1.3,-0.85l0.84,1.35l3.1,-0.3l0.46,0.99l-1.05,0.94l-0.03,2.16l-0.41,0.57l-0.08,1.1l-0.79,0.18l-0.26,0.59l0.91,1.6l-0.63,1.75l0.76,1.09l-1.1,1.52l0.07,1.05Z",name:"Portugal"},PY:{path:"M274.9,336.12l0.74,1.52l-0.16,3.45l0.32,0.41l2.64,0.5l1.11,-0.47l1.4,0.59l0.36,0.6l0.53,3.42l1.27,0.4l0.98,-0.38l0.51,0.27l-0.0,1.18l-1.21,5.32l-2.09,1.9l-1.8,0.4l-4.71,-0.98l2.2,-3.63l-0.32,-1.5l-2.78,-1.28l-3.03,-1.94l-2.07,-0.44l-4.34,-4.06l0.91,-2.9l0.08,-1.42l1.07,-2.04l4.13,-0.72l2.18,0.03l2.05,1.17l0.03,0.59Z",name:"Paraguay"},PA:{path:"M213.8,263.68l0.26,-1.52l-0.36,-0.26l-0.01,-0.49l0.44,-0.1l0.93,1.4l1.26,0.03l0.77,0.49l1.38,-0.23l2.51,-1.11l0.86,-0.72l3.45,0.85l1.4,1.18l0.41,1.74l-0.21,0.34l-0.53,-0.12l-0.47,0.29l-0.16,0.6l-0.68,-1.28l0.45,-0.49l-0.19,-0.66l-0.47,-0.13l-0.54,-0.84l-1.5,-0.75l-1.1,0.16l-0.75,0.99l-1.62,0.84l-0.18,0.96l0.85,0.97l-0.58,0.45l-0.69,0.08l-0.34,-1.18l-1.27,0.03l-0.71,-1.05l-2.59,-0.46Z",name:"Panama"},PG:{path:"M808.58,298.86l2.54,2.56l-0.13,0.26l-0.33,0.12l-0.87,-0.78l-1.22,-2.16ZM801.41,293.04l0.5,0.29l0.26,0.27l-0.49,-0.35l-0.27,-0.21ZM803.17,294.58l0.59,0.5l0.08,1.06l-0.29,-0.91l-0.38,-0.65ZM796.68,298.41l0.52,0.75l1.43,-0.19l2.27,-1.81l-0.01,-1.43l1.12,0.16l-0.04,1.1l-0.7,1.28l-1.12,0.18l-0.62,0.79l-2.46,1.11l-1.17,-0.0l-3.08,-1.25l3.41,0.0l0.45,-0.68ZM789.15,303.55l2.31,1.8l1.59,2.61l1.34,0.13l-0.06,0.66l0.31,0.43l1.06,0.24l0.06,0.65l2.25,1.05l-1.22,0.13l-0.72,-0.63l-4.56,-0.65l-3.22,-2.87l-1.49,-2.34l-3.27,-1.1l-2.38,0.72l-1.59,0.86l-0.2,0.42l0.27,1.55l-1.55,0.68l-1.36,-0.4l-2.21,-0.09l-0.08,-15.41l8.39,2.93l2.95,2.4l0.6,1.64l4.02,1.49l0.31,0.68l-1.76,0.21l-0.33,0.52l0.55,1.68Z",name:"Papua New Guinea"},PE:{path:"M244.96,295.21l-1.26,-0.07l-0.57,0.42l-1.93,0.45l-2.98,1.75l-0.36,1.36l-0.58,0.8l0.12,1.37l-1.24,0.59l-0.22,1.22l-0.62,0.84l1.04,2.27l1.28,1.44l-0.41,0.84l0.32,0.57l1.48,0.13l1.16,1.37l2.21,0.07l1.63,-1.08l-0.13,3.02l0.3,0.4l1.14,0.29l1.31,-0.34l1.9,3.59l-0.48,0.85l-0.17,3.85l-0.94,1.59l0.35,0.75l-0.47,1.07l0.98,1.97l-2.1,3.82l-0.98,0.5l-2.17,-1.28l-0.39,-1.16l-4.95,-2.58l-4.46,-2.79l-1.84,-1.51l-0.91,-1.84l0.3,-0.96l-2.11,-3.33l-4.82,-9.68l-1.04,-1.2l-0.87,-1.94l-3.4,-2.48l0.58,-1.18l-1.13,-2.23l0.66,-1.49l1.45,-1.15l-0.6,0.98l0.07,0.92l0.47,0.36l1.74,0.03l0.97,1.17l0.54,0.07l1.42,-1.03l0.6,-1.84l1.42,-2.02l3.04,-1.04l2.73,-2.62l0.86,-1.74l-0.1,-1.87l1.44,1.02l0.9,1.25l1.06,0.59l1.7,2.73l1.86,0.31l1.45,-0.61l0.96,0.39l1.36,-0.19l1.45,0.89l-1.4,2.21l0.31,0.61l0.59,0.05l0.47,0.5Z",name:"Peru"},PK:{path:"M615.09,192.34l-1.83,1.81l-2.6,0.39l-3.73,-0.68l-1.58,1.33l-0.09,0.42l1.77,4.39l1.7,1.23l-1.69,1.27l-0.12,2.14l-2.33,2.64l-1.6,2.8l-2.46,2.67l-3.03,-0.07l-2.76,2.83l0.05,0.6l1.5,1.11l0.26,1.9l1.44,1.5l0.37,1.68l-5.01,-0.01l-1.78,1.7l-1.42,-0.52l-0.76,-1.87l-2.27,-2.15l-11.61,0.86l0.71,-2.34l3.43,-1.32l0.25,-0.44l-0.21,-1.24l-1.2,-0.65l-0.28,-2.46l-2.29,-1.14l-1.28,-1.94l2.82,0.94l2.62,-0.38l1.42,0.33l0.76,-0.56l1.71,0.19l3.25,-1.14l0.27,-0.36l0.08,-2.19l1.18,-1.32l1.68,0.0l0.58,-0.82l1.6,-0.3l1.19,0.16l0.98,-0.78l0.02,-1.88l0.93,-1.47l1.48,-0.66l0.19,-0.55l-0.66,-1.25l2.04,-0.11l0.69,-1.01l-0.02,-1.16l1.11,-1.06l-0.17,-1.78l-0.49,-1.03l1.15,-0.98l5.42,-0.91l2.6,-0.82l1.6,1.16l0.97,2.34l3.45,0.97Z",name:"Pakistan"},PH:{path:"M737.01,263.84l0.39,2.97l-0.44,1.18l-0.55,-1.53l-0.67,-0.14l-1.17,1.28l0.65,2.09l-0.42,0.69l-2.48,-1.23l-0.57,-1.49l0.65,-1.03l-0.1,-0.54l-1.59,-1.19l-0.56,0.08l-0.65,0.87l-1.23,0.0l-1.58,0.97l0.83,-1.8l2.56,-1.42l0.65,0.84l0.45,0.13l1.9,-0.69l0.56,-1.11l1.5,-0.06l0.38,-0.43l-0.09,-1.19l1.21,0.71l0.36,2.02ZM733.59,256.58l0.05,0.75l0.08,0.26l-0.8,-0.42l-0.18,-0.71l0.85,0.12ZM734.08,256.1l-0.12,-1.12l-1.0,-1.27l1.36,0.03l0.53,0.73l0.51,2.04l-1.27,-0.4ZM733.76,257.68l0.38,0.98l-0.32,0.15l-0.07,-1.13ZM724.65,238.43l1.46,0.7l0.72,-0.31l-0.32,1.17l0.79,1.71l-0.57,1.84l-1.53,1.04l-0.39,2.25l0.56,2.04l1.63,0.57l1.16,-0.27l2.71,1.23l-0.19,1.08l0.76,0.84l-0.08,0.36l-1.4,-0.9l-0.88,-1.27l-0.66,0.0l-0.38,0.55l-1.6,-1.31l-2.15,0.36l-0.87,-0.39l0.07,-0.61l0.66,-0.55l-0.01,-0.62l-0.75,-0.59l-0.72,0.44l-0.74,-0.87l-0.39,-2.49l0.32,0.27l0.66,-0.28l0.26,-3.97l0.7,-2.02l1.14,0.0ZM731.03,258.87l-0.88,0.85l-1.19,1.94l-1.05,-1.19l0.93,-1.1l0.32,-1.47l0.52,-0.06l-0.27,1.15l0.22,0.45l0.49,-0.12l1.0,-1.32l-0.08,0.85ZM726.83,255.78l0.83,0.38l1.17,-0.0l-0.02,0.48l-2.0,1.4l0.03,-2.26ZM724.81,252.09l-0.38,1.27l-1.42,-1.95l1.2,0.05l0.6,0.63ZM716.55,261.82l1.1,-0.95l0.03,-0.03l-0.28,0.36l-0.85,0.61ZM719.22,259.06l0.04,-0.06l0.8,-1.53l0.16,0.75l-1.0,0.84Z",name:"Philippines"},PL:{path:"M468.44,149.42l-1.11,-1.54l-1.86,-0.33l-0.48,-1.05l-1.72,-0.37l-0.65,0.69l-0.72,-0.36l0.11,-0.61l-0.33,-0.46l-1.75,-0.27l-1.04,-0.93l-0.94,-1.94l0.16,-1.22l-0.62,-1.8l-0.78,-1.07l0.57,-1.04l-0.48,-1.43l1.41,-0.83l6.91,-2.71l2.14,0.5l0.52,0.91l5.51,0.44l4.55,-0.05l1.07,0.31l0.48,0.84l0.15,1.58l0.65,1.2l-0.01,0.99l-1.27,0.58l-0.19,0.54l0.73,1.48l0.08,1.55l1.2,2.76l-0.17,0.58l-1.23,0.44l-2.27,2.72l0.18,0.95l-1.97,-1.03l-1.98,0.4l-1.36,-0.28l-1.24,0.58l-1.07,-0.97l-1.16,0.24Z",name:"Poland"},ZM:{path:"M481.47,313.3l0.39,0.31l2.52,0.14l0.99,1.17l2.01,0.35l1.4,-0.64l0.69,1.17l1.78,0.33l1.84,2.35l2.23,0.18l0.4,-0.43l-0.21,-2.74l-0.62,-0.3l-0.48,0.32l-1.98,-1.17l0.72,-5.29l-0.51,-1.18l0.57,-1.3l3.68,-0.62l0.26,0.63l1.21,0.63l0.9,-0.22l2.16,0.67l1.33,0.71l1.07,1.02l0.56,1.87l-0.88,2.7l0.43,2.09l-0.73,0.87l-0.76,2.37l0.59,0.68l-6.6,1.83l-0.29,0.44l0.19,1.45l-1.68,0.35l-1.43,1.02l-0.38,0.87l-0.87,0.26l-3.48,3.69l-4.16,-0.53l-1.52,-1.0l-1.77,-0.13l-1.83,0.52l-3.04,-3.4l0.11,-7.59l4.82,0.03l0.39,-0.49l-0.18,-0.76l0.33,-0.83l-0.4,-1.36l0.24,-1.05Z",name:"Zambia"},EH:{path:"M384.42,230.28l0.25,-0.79l1.06,-1.29l0.8,-3.51l3.38,-2.78l0.7,-1.81l0.06,4.84l-1.98,0.2l-0.94,1.59l0.39,3.56l-3.7,-0.01ZM392.01,218.1l0.7,-1.8l1.77,-0.24l2.09,0.34l0.95,-0.62l1.28,-0.07l-0.0,2.51l-6.79,-0.12Z",name:"W. Sahara"},EE:{path:"M485.71,115.04l2.64,0.6l2.56,0.11l-1.6,1.91l0.61,3.54l-0.81,0.87l-1.78,-0.01l-3.22,-1.76l-1.8,0.45l0.21,-1.53l-0.58,-0.41l-0.69,0.34l-1.26,-1.03l-0.17,-1.63l2.83,-0.92l3.05,-0.52Z",name:"Estonia"},EG:{path:"M492.06,205.03l1.46,0.42l2.95,-1.64l2.04,-0.21l1.53,0.3l0.59,1.19l0.69,0.04l0.41,-0.64l1.81,0.58l1.95,0.16l1.04,-0.51l1.42,4.08l-2.03,4.54l-1.66,-1.77l-1.76,-3.85l-0.64,-0.12l-0.36,0.67l1.04,2.88l3.44,6.95l1.78,3.04l2.03,2.65l-0.36,0.53l0.23,2.01l2.7,2.19l-28.41,0.0l0.0,-18.96l-0.73,-2.2l0.59,-1.56l-0.32,-1.26l0.68,-0.99l3.06,-0.04l4.82,1.52Z",name:"Egypt"},ZA:{path:"M467.14,373.21l-0.13,-1.96l-0.68,-1.56l0.7,-0.68l-0.13,-2.33l-4.56,-8.19l0.77,-0.86l0.6,0.45l0.69,1.31l2.83,0.72l1.5,-0.26l2.24,-1.39l0.19,-9.55l1.35,2.3l-0.21,1.5l0.61,1.2l0.4,0.19l1.79,-0.27l2.6,-2.07l0.69,-1.32l0.96,-0.48l2.19,1.04l2.04,0.13l1.77,-0.65l0.85,-2.12l1.38,-0.33l1.59,-2.76l2.15,-1.89l3.41,-1.87l2.0,0.45l1.02,-0.28l0.99,0.2l1.75,5.29l-0.38,3.25l-0.81,-0.23l-1.0,0.46l-0.87,1.68l-0.05,1.16l1.97,1.84l1.47,-0.29l0.69,-1.18l1.09,0.01l-0.76,3.69l-0.58,1.09l-2.2,1.79l-3.17,4.76l-2.8,2.83l-3.57,2.88l-2.53,1.05l-1.22,0.14l-0.51,0.7l-1.18,-0.32l-1.39,0.5l-2.59,-0.52l-1.61,0.33l-1.18,-0.11l-2.55,1.1l-2.1,0.44l-1.6,1.07l-0.85,0.05l-0.93,-0.89l-0.93,-0.15l-0.97,-1.13l-0.25,0.05ZM491.45,364.19l0.62,-0.93l1.48,-0.59l1.18,-2.19l-0.07,-0.49l-1.99,-1.69l-1.66,0.56l-1.43,1.14l-1.34,1.73l0.02,0.51l1.88,2.11l1.31,-0.16Z",name:"South Africa"},EC:{path:"M231.86,285.53l0.29,1.59l-0.69,1.45l-2.61,2.51l-3.13,1.11l-1.53,2.18l-0.49,1.68l-1.0,0.73l-1.02,-1.11l-1.78,-0.16l0.67,-1.15l-0.24,-0.86l1.25,-2.13l-0.54,-1.09l-0.67,-0.08l-0.72,0.87l-0.87,-0.64l0.35,-0.69l-0.36,-1.96l0.81,-0.51l0.45,-1.51l0.92,-1.57l-0.07,-0.97l2.65,-1.33l2.75,1.35l0.77,1.05l2.12,0.35l0.76,-0.32l1.96,1.21Z",name:"Ecuador"},IT:{path:"M451.59,158.63l3.48,0.94l-0.21,1.17l0.3,0.83l-1.49,-0.24l-2.04,1.1l-0.21,0.39l0.13,1.45l-0.25,1.12l0.82,1.57l2.39,1.63l1.31,2.54l2.79,2.43l2.05,0.08l0.21,0.23l-0.39,0.33l0.09,0.67l4.05,1.97l2.17,1.76l-0.16,0.36l-1.17,-1.08l-2.18,-0.49l-0.44,0.2l-1.05,1.91l0.14,0.54l1.57,0.95l-0.19,0.98l-1.06,0.33l-1.25,2.34l-0.37,0.08l0.0,-0.33l1.0,-2.45l-1.73,-3.17l-1.12,-0.51l-0.88,-1.33l-1.51,-0.51l-1.27,-1.25l-1.75,-0.18l-4.12,-3.21l-1.62,-1.65l-1.03,-3.19l-3.53,-1.36l-1.3,0.51l-1.69,1.41l0.16,-0.72l-0.28,-0.47l-1.14,-0.33l-0.53,-1.96l0.72,-0.78l0.04,-0.48l-0.65,-1.17l0.8,0.39l1.4,-0.23l1.11,-0.84l0.52,0.35l1.19,-0.1l0.75,-1.2l1.53,0.33l1.36,-0.56l0.35,-1.14l1.08,0.32l0.68,-0.64l1.98,-0.44l0.42,0.82ZM459.19,184.75l-0.65,1.65l0.32,1.05l-0.31,0.89l-1.5,-0.85l-4.5,-1.67l0.19,-0.82l2.67,0.23l3.78,-0.48ZM443.93,176.05l1.18,1.66l-0.3,3.32l-1.06,-0.01l-0.77,0.73l-0.53,-0.44l-0.1,-3.37l-0.39,-1.22l1.04,0.01l0.92,-0.68Z",name:"Italy"},VN:{path:"M690.56,230.25l-2.7,1.82l-2.09,2.46l-0.63,1.95l4.31,6.45l2.32,1.65l1.43,1.94l1.11,4.59l-0.32,4.24l-1.93,1.54l-2.84,1.61l-2.11,2.15l-2.73,2.06l-0.59,-1.05l0.63,-1.53l-0.13,-0.47l-1.34,-1.04l1.51,-0.71l2.55,-0.18l0.3,-0.63l-0.82,-1.14l4.0,-2.07l0.31,-3.05l-0.57,-1.77l0.42,-2.66l-0.73,-1.97l-1.86,-1.76l-3.63,-5.29l-2.72,-1.46l0.36,-0.47l1.5,-0.64l0.21,-0.52l-0.97,-2.27l-0.37,-0.24l-2.83,-0.02l-2.24,-3.9l0.83,-0.4l4.39,-0.29l2.06,-1.31l1.15,0.89l1.88,0.4l-0.17,1.51l1.35,1.16l1.67,0.45Z",name:"Vietnam"},SB:{path:"M826.69,311.6l-0.61,0.09l-0.2,-0.33l0.37,0.15l0.44,0.09ZM824.18,307.38l-0.26,-0.3l-0.31,-0.91l0.03,0.0l0.54,1.21ZM823.04,309.33l-1.66,-0.22l-0.2,-0.52l1.16,0.28l0.69,0.46ZM819.28,304.68l1.14,0.65l0.02,0.03l-0.81,-0.44l-0.35,-0.23Z",name:"Solomon Is."},ET:{path:"M516.04,247.79l1.1,0.84l1.63,-0.45l0.68,0.47l1.63,0.03l2.01,0.94l1.73,1.66l1.64,2.07l-1.52,2.04l0.16,1.72l0.39,0.38l2.05,0.0l-0.36,1.03l2.86,3.58l8.32,3.08l1.31,0.02l-6.32,6.75l-3.1,0.11l-2.36,1.77l-1.47,0.04l-0.86,0.79l-1.38,-0.0l-1.32,-0.81l-2.29,1.05l-0.76,0.98l-3.29,-0.41l-3.07,-2.07l-1.8,-0.07l-0.62,-0.6l0.0,-1.24l-0.28,-0.38l-1.15,-0.37l-1.4,-2.59l-1.19,-0.68l-0.47,-1.0l-1.27,-1.23l-1.16,-0.22l0.43,-0.72l1.45,-0.28l0.41,-0.95l-0.03,-2.21l0.68,-2.44l1.05,-0.63l1.43,-3.06l1.57,-1.37l1.02,-2.51l0.35,-1.88l2.52,0.46l0.44,-0.24l0.58,-1.43Z",name:"Ethiopia"},SO:{path:"M525.13,288.48l-1.13,-1.57l-0.03,-8.86l2.66,-3.38l1.67,-0.13l2.13,-1.69l3.41,-0.23l7.08,-7.55l2.91,-3.69l0.08,-4.82l2.98,-0.67l1.24,-0.86l0.45,-0.0l-0.2,3.0l-1.21,3.62l-2.73,5.97l-2.13,3.65l-5.03,6.16l-8.56,6.4l-2.78,3.08l-0.8,1.56Z",name:"Somalia"},ZW:{path:"M498.91,341.09l-1.11,-0.22l-0.92,0.28l-2.09,-0.44l-1.5,-1.11l-1.89,-0.43l-0.62,-1.4l-0.01,-0.84l-0.3,-0.38l-0.97,-0.25l-2.71,-2.74l-1.92,-3.32l3.83,0.45l3.73,-3.82l1.08,-0.44l0.26,-0.77l1.25,-0.9l1.41,-0.26l0.5,0.89l1.99,-0.05l1.72,1.17l1.11,0.17l1.05,0.66l0.01,2.99l-0.59,3.76l0.38,0.86l-0.23,1.23l-0.39,0.35l-0.63,1.81l-2.43,2.75Z",name:"Zimbabwe"},ES:{path:"M416.0,169.21l1.07,1.17l4.61,1.38l1.06,-0.57l2.6,1.26l2.71,-0.3l0.09,1.12l-2.14,1.8l-3.11,0.61l-0.31,0.31l-0.2,0.89l-1.54,1.69l-0.97,2.4l0.84,1.74l-1.32,1.27l-0.48,1.68l-1.88,0.65l-1.66,2.07l-5.36,-0.01l-1.79,1.08l-0.89,0.98l-0.88,-0.17l-0.79,-0.82l-0.68,-1.59l-2.37,-0.63l-0.11,-0.5l1.21,-1.82l-0.77,-1.13l0.61,-1.68l-0.76,-1.62l0.87,-0.49l0.09,-1.25l0.42,-0.6l0.03,-2.11l0.99,-0.69l0.13,-0.5l-1.03,-1.73l-1.46,-0.11l-0.61,0.38l-1.06,0.0l-0.52,-1.23l-0.53,-0.21l-1.32,0.67l-0.01,-1.49l-0.75,-0.96l3.03,-1.88l2.99,0.53l3.32,-0.02l2.63,0.51l6.01,-0.06Z",name:"Spain"},ER:{path:"M520.38,246.23l3.42,2.43l3.5,3.77l0.84,0.54l-0.95,-0.01l-3.51,-3.89l-2.33,-1.15l-1.73,-0.07l-0.91,-0.51l-1.26,0.51l-1.34,-1.02l-0.61,0.17l-0.66,1.61l-2.35,-0.43l-0.17,-0.67l1.29,-5.29l0.61,-0.61l1.95,-0.53l0.87,-1.01l1.17,2.41l0.68,2.33l1.49,1.43Z",name:"Eritrea"},ME:{path:"M468.91,172.53l-1.22,-1.02l0.47,-1.81l0.89,-0.72l2.26,1.51l-0.5,0.57l-0.75,-0.27l-1.14,1.73Z",name:"Montenegro"},MD:{path:"M488.41,153.73l1.4,-0.27l1.72,0.93l1.07,0.15l0.85,0.65l-0.14,0.84l0.96,0.85l1.12,2.47l-1.15,-0.07l-0.66,-0.41l-0.52,0.25l-0.09,0.86l-1.08,1.89l-0.27,-0.86l0.25,-1.34l-0.16,-1.6l-3.29,-4.34Z",name:"Moldova"},MG:{path:"M545.91,319.14l0.4,3.03l0.62,1.21l-0.21,1.02l-0.57,-0.8l-0.69,-0.01l-0.47,0.76l0.41,2.12l-0.18,0.87l-0.73,0.78l-0.15,2.14l-4.71,15.2l-1.06,2.88l-3.92,1.64l-3.12,-1.49l-0.6,-1.21l-0.19,-2.4l-0.86,-2.05l-0.21,-1.77l0.38,-1.62l1.21,-0.75l0.01,-0.76l1.19,-2.04l0.23,-1.66l-1.06,-2.99l-0.19,-2.21l0.81,-1.33l0.32,-1.46l4.63,-1.22l3.44,-3.0l0.85,-1.4l-0.08,-0.7l0.78,-0.04l1.38,-1.77l0.13,-1.64l0.45,-0.61l1.16,1.69l0.59,1.6Z",name:"Madagascar"},MA:{path:"M378.78,230.02l0.06,-0.59l0.92,-0.73l0.82,-1.37l-0.09,-1.04l0.79,-1.7l1.31,-1.58l0.96,-0.59l0.66,-1.55l0.09,-1.47l0.81,-1.48l1.72,-1.07l1.55,-2.69l1.16,-0.96l2.44,-0.39l1.94,-1.82l1.31,-0.78l2.09,-2.28l-0.51,-3.65l1.24,-3.7l1.5,-1.75l4.46,-2.57l2.37,-4.47l1.44,0.01l1.68,1.21l2.32,-0.19l3.47,0.65l0.8,1.54l0.16,1.71l0.86,2.96l0.56,0.59l-0.26,0.61l-3.05,0.44l-1.26,1.05l-1.33,0.22l-0.33,0.37l-0.09,1.78l-2.68,1.0l-1.07,1.42l-4.47,1.13l-4.04,2.01l-0.54,4.64l-1.15,0.06l-0.92,0.61l-1.96,-0.35l-2.42,0.54l-0.74,1.9l-0.86,0.4l-1.14,3.26l-3.53,3.01l-0.8,3.55l-0.96,1.1l-0.29,0.82l-4.95,0.18Z",name:"Morocco"},UZ:{path:"M598.64,172.75l-1.63,1.52l0.06,0.64l1.85,1.12l1.97,-0.64l2.21,1.17l-2.52,1.68l-2.59,-0.22l-0.18,-0.41l0.46,-1.23l-0.45,-0.53l-3.35,0.69l-2.1,3.51l-1.87,-0.12l-1.03,1.51l0.22,0.55l1.64,0.62l0.46,1.83l-1.19,2.49l-2.66,-0.53l0.05,-1.36l-0.26,-0.39l-3.3,-1.23l-2.56,-1.4l-4.4,-3.34l-1.34,-3.14l-1.08,-0.6l-2.58,0.13l-0.69,-0.44l-0.47,-2.52l-3.37,-1.6l-0.43,0.05l-2.07,1.72l-2.1,1.01l-0.21,0.47l0.28,1.01l-1.91,0.03l-0.09,-10.5l5.99,-1.7l6.19,3.54l2.71,2.84l7.05,-0.67l2.71,2.01l-0.17,2.81l0.39,0.42l0.9,0.02l0.44,2.14l0.38,0.32l2.94,0.09l0.95,1.42l1.28,-0.24l1.05,-2.04l4.43,-2.5Z",name:"Uzbekistan"},MM:{path:"M673.9,230.21l-1.97,1.57l-0.57,0.96l-1.4,0.6l-1.36,1.05l-1.99,0.36l-1.08,2.66l-0.91,0.4l-0.19,0.55l1.21,2.27l2.52,3.43l-0.79,1.91l-0.74,0.41l-0.17,0.52l0.65,1.37l1.61,1.95l0.25,2.58l0.9,2.13l-1.92,3.57l0.68,-2.25l-0.81,-1.74l0.19,-2.65l-1.05,-1.53l-1.24,-6.17l-1.12,-2.26l-0.6,-0.13l-4.34,3.02l-2.39,-0.65l0.77,-2.84l-0.52,-2.61l-1.91,-2.96l0.25,-0.75l-0.29,-0.51l-1.33,-0.3l-1.61,-1.93l-0.1,-1.3l0.82,-0.24l0.04,-1.64l1.02,-0.52l0.21,-0.45l-0.23,-0.95l0.54,-0.96l0.08,-2.22l1.46,0.45l0.47,-0.2l1.12,-2.19l0.16,-1.35l1.33,-2.16l-0.0,-1.52l2.89,-1.66l1.63,0.44l0.5,-0.44l-0.17,-1.4l0.64,-0.36l0.08,-1.04l0.77,-0.11l0.71,1.35l1.06,0.69l-0.03,3.86l-2.38,2.37l-0.3,3.15l0.46,0.43l2.28,-0.38l0.51,2.08l1.47,0.67l-0.6,1.8l0.19,0.48l2.97,1.48l1.64,-0.55l0.02,0.32Z",name:"Myanmar"},ML:{path:"M392.61,254.08l-0.19,-2.37l-0.99,-0.87l-0.44,-1.3l-0.09,-1.28l0.81,-0.58l0.35,-1.24l2.37,0.65l1.31,-0.47l0.86,0.15l0.66,-0.56l9.83,-0.04l0.38,-0.28l0.56,-1.8l-0.44,-0.65l-2.35,-21.95l3.27,-0.04l16.7,11.38l0.74,1.31l2.5,1.09l0.02,1.38l0.44,0.39l2.34,-0.21l0.01,5.38l-1.28,1.61l-0.26,1.49l-5.31,0.57l-1.07,0.92l-2.9,0.1l-0.86,-0.48l-1.38,0.36l-2.4,1.08l-0.6,0.87l-1.85,1.09l-0.43,0.7l-0.79,0.39l-1.44,-0.21l-0.81,0.84l-0.34,1.64l-1.91,2.02l-0.06,1.03l-0.67,1.22l0.13,1.16l-0.97,0.39l-0.23,-0.64l-0.52,-0.24l-1.35,0.4l-0.34,0.55l-2.69,-0.28l-0.37,-0.35l-0.02,-0.9l-0.65,-0.35l0.45,-0.64l-0.03,-0.53l-2.12,-2.44l-0.76,-0.01l-2.0,1.16l-0.78,-0.15l-0.8,-0.67l-1.21,0.23Z",name:"Mali"},MN:{path:"M676.61,146.48l3.81,1.68l5.67,-1.0l2.37,0.41l2.34,1.5l1.79,1.75l2.29,-0.03l3.12,0.52l2.47,-0.81l3.41,-0.59l3.53,-2.21l1.25,0.29l1.53,1.13l2.27,-0.21l-2.66,5.01l0.64,1.68l0.47,0.21l1.32,-0.38l2.38,0.48l2.02,-1.11l1.76,0.89l2.06,2.02l-0.13,0.53l-1.72,-0.29l-3.77,0.46l-1.88,0.99l-1.76,1.99l-3.71,1.17l-2.45,1.6l-3.83,-0.87l-0.41,0.17l-1.31,1.99l1.04,2.24l-1.52,0.9l-1.74,1.57l-2.79,1.02l-3.78,0.13l-4.05,1.05l-2.77,1.52l-1.16,-0.85l-2.94,0.0l-3.62,-1.79l-2.58,-0.49l-3.4,0.41l-5.12,-0.67l-2.63,0.06l-1.31,-1.6l-1.4,-3.0l-1.48,-0.33l-3.13,-1.94l-6.16,-0.93l-0.71,-1.06l0.86,-3.82l-1.93,-2.71l-3.5,-1.18l-1.95,-1.58l-0.5,-1.72l2.34,-0.52l4.75,-2.8l3.62,-1.47l2.18,0.97l2.46,0.05l1.81,1.53l2.46,0.12l3.95,0.71l2.43,-2.28l0.08,-0.48l-0.9,-1.72l2.24,-2.98l2.62,1.27l4.94,1.17l0.43,2.24Z",name:"Mongolia"},MK:{path:"M472.8,173.98l0.49,-0.71l3.57,-0.71l1.0,0.77l0.13,1.45l-0.65,0.53l-1.15,-0.05l-1.12,0.67l-1.39,0.22l-0.79,-0.55l-0.29,-1.03l0.19,-0.6Z",name:"Macedonia"},MW:{path:"M505.5,309.31l0.85,1.95l0.15,2.86l-0.69,1.65l0.71,1.8l0.06,1.28l0.49,0.64l0.07,1.06l0.4,0.55l0.8,-0.23l0.55,0.61l0.69,-0.21l0.34,0.6l0.19,2.94l-1.04,0.62l-0.54,1.25l-1.11,-1.08l-0.16,-1.56l0.51,-1.31l-0.32,-1.3l-0.99,-0.65l-0.82,0.12l-2.36,-1.64l0.63,-1.96l0.82,-1.18l-0.46,-2.01l0.9,-2.86l-0.94,-2.51l0.96,0.18l0.29,0.4Z",name:"Malawi"},MR:{path:"M407.36,220.66l-2.58,0.03l-0.39,0.44l2.42,22.56l0.36,0.43l-0.39,1.24l-9.75,0.04l-0.56,0.53l-0.91,-0.11l-1.27,0.45l-1.61,-0.66l-0.97,0.03l-0.36,0.29l-0.38,1.35l-0.42,0.23l-2.93,-3.4l-2.96,-1.52l-1.62,-0.03l-1.27,0.54l-1.12,-0.2l-0.65,0.4l-0.08,-0.49l0.68,-1.29l0.31,-2.43l-0.57,-3.91l0.23,-1.21l-0.69,-1.5l-1.15,-1.02l0.25,-0.39l9.58,0.02l0.4,-0.45l-0.46,-3.68l0.47,-1.04l2.12,-0.21l0.36,-0.4l-0.08,-6.4l7.81,0.13l0.41,-0.4l0.01,-3.31l7.76,5.35Z",name:"Mauritania"},UG:{path:"M498.55,276.32l0.7,-0.46l1.65,0.5l1.96,-0.57l1.7,0.01l1.45,-0.98l0.91,1.33l1.33,3.95l-2.57,4.03l-1.46,-0.4l-2.54,0.91l-1.37,1.61l-0.01,0.81l-2.42,-0.01l-2.26,1.01l-0.17,-1.59l0.58,-1.04l0.14,-1.94l1.37,-2.28l1.78,-1.58l-0.17,-0.65l-0.72,-0.24l0.13,-2.43Z",name:"Uganda"},MY:{path:"M717.47,273.46l-1.39,0.65l-2.12,-0.41l-2.88,-0.0l-0.38,0.28l-0.84,2.75l-0.99,0.96l-1.21,3.29l-1.73,0.45l-2.45,-0.68l-1.39,0.31l-1.33,1.15l-1.59,-0.14l-1.41,0.44l-1.44,-1.19l-0.18,-0.73l1.34,0.53l1.93,-0.47l0.75,-2.22l4.02,-1.03l2.75,-3.21l0.82,0.94l0.64,-0.05l0.4,-0.65l0.96,0.06l0.42,-0.36l0.24,-2.68l1.81,-1.64l1.21,-1.86l0.63,-0.01l1.07,1.05l0.34,1.28l3.44,1.35l-0.06,0.35l-1.37,0.1l-0.35,0.54l0.32,0.88ZM673.68,269.59l0.17,1.09l0.47,0.33l1.65,-0.3l0.87,-0.94l1.61,1.52l0.98,1.56l-0.12,2.81l0.41,2.29l0.95,0.9l0.88,2.44l-1.27,0.12l-5.1,-3.67l-0.34,-1.29l-1.37,-1.59l-0.33,-1.97l-0.88,-1.4l0.25,-1.68l-0.46,-1.05l1.63,0.84Z",name:"Malaysia"},MX:{path:"M133.12,200.41l0.2,0.47l9.63,3.33l6.96,-0.02l0.4,-0.4l0.0,-0.74l3.77,0.0l3.55,2.93l1.39,2.83l1.52,1.04l2.08,0.82l0.47,-0.14l1.46,-2.0l1.73,-0.04l1.59,0.98l2.05,3.35l1.47,1.56l1.26,3.14l2.18,1.02l2.26,0.58l-1.18,3.72l-0.42,5.04l1.79,4.89l1.62,1.89l0.61,1.52l1.2,1.42l2.55,0.66l1.37,1.1l7.54,-1.89l1.86,-1.3l1.14,-4.3l4.1,-1.21l3.57,-0.11l0.32,0.3l-0.06,0.94l-1.26,1.45l-0.67,1.71l0.38,0.7l-0.72,2.27l-0.49,-0.3l-1.0,0.08l-1.0,1.39l-0.47,-0.11l-0.53,0.47l-4.26,-0.02l-0.4,0.4l-0.0,1.06l-1.1,0.26l0.1,0.44l1.82,1.44l0.56,0.91l-3.19,0.21l-1.21,2.09l0.24,0.72l-0.2,0.44l-2.24,-2.18l-1.45,-0.93l-2.22,-0.69l-1.52,0.22l-3.07,1.16l-10.55,-3.85l-2.86,-1.96l-3.78,-0.92l-1.08,-1.19l-2.62,-1.43l-1.18,-1.54l-0.38,-0.81l0.66,-0.63l-0.18,-0.53l0.52,-0.76l0.01,-0.91l-2.0,-3.82l-2.21,-2.63l-2.53,-2.09l-1.19,-1.62l-2.2,-1.17l-0.3,-0.43l0.34,-1.48l-0.21,-0.45l-1.23,-0.6l-1.36,-1.2l-0.59,-1.78l-1.54,-0.47l-2.44,-2.55l-0.16,-0.9l-1.33,-2.03l-0.84,-1.99l-0.16,-1.33l-1.81,-1.1l-0.97,0.05l-1.31,-0.7l-0.57,0.22l-0.4,1.12l0.72,3.77l3.51,3.89l0.28,0.78l0.53,0.26l0.41,1.43l1.33,1.73l1.58,1.41l0.8,2.39l1.43,2.41l0.13,1.32l0.37,0.36l1.04,0.08l1.67,2.28l-0.85,0.76l-0.66,-1.51l-1.68,-1.54l-2.91,-1.87l0.06,-1.82l-0.54,-1.68l-2.91,-2.03l-0.55,0.09l-1.95,-1.1l-0.88,-0.94l0.68,-0.08l0.93,-1.01l0.08,-1.78l-1.93,-1.94l-1.46,-0.77l-3.75,-7.56l4.88,-0.42Z",name:"Mexico"},IL:{path:"M507.76,203.05l0.4,-0.78l0.18,0.4l-0.33,1.03l0.52,0.44l0.68,-0.22l-0.86,3.6l-1.16,-3.32l0.59,-0.74l-0.03,-0.41ZM508.73,200.34l0.37,-1.02l0.64,0.0l0.52,-0.51l-0.49,1.53l-0.56,-0.24l-0.48,0.23Z",name:"Israel"},FR:{path:"M444.48,172.62l-0.64,1.78l-0.58,-0.31l-0.49,-1.72l0.4,-0.89l1.0,-0.72l0.3,1.85ZM429.64,147.1l1.78,1.58l1.46,-0.13l2.1,1.42l1.35,0.27l1.23,0.83l3.04,0.5l-1.03,1.85l-0.3,2.12l-0.41,0.32l-0.95,-0.24l-0.5,0.43l0.06,0.61l-1.81,1.92l-0.04,1.42l0.55,0.38l0.88,-0.36l0.61,0.97l-0.03,1.0l0.57,0.91l-0.75,1.09l0.65,2.39l1.27,0.57l-0.18,0.82l-2.01,1.53l-4.77,-0.8l-3.82,1.0l-0.53,1.85l-2.49,0.34l-2.71,-1.31l-1.16,0.57l-4.31,-1.29l-0.72,-0.86l1.19,-1.78l0.39,-6.45l-2.58,-3.3l-1.9,-1.66l-3.72,-1.23l-0.19,-1.72l2.81,-0.61l4.12,0.81l0.47,-0.48l-0.6,-2.77l1.94,0.95l5.83,-2.54l0.92,-2.74l1.6,-0.49l0.24,0.78l1.36,0.33l1.05,1.19ZM289.01,278.39l-0.81,0.8l-0.78,0.12l-0.5,-0.66l-0.56,-0.1l-0.91,0.6l-0.46,-0.22l1.09,-2.96l-0.96,-1.77l-0.17,-1.49l1.07,-1.77l2.32,0.75l2.51,2.01l0.3,0.74l-2.14,3.96Z",name:"France"},XS:{path:"M531.15,258.94l1.51,0.12l5.13,-0.95l5.3,-1.48l-0.01,4.4l-2.67,3.39l-1.85,0.01l-8.04,-2.94l-2.55,-3.17l1.12,-1.71l2.04,2.34Z",name:"Somaliland"},FI:{path:"M492.17,76.39l-0.23,3.5l3.52,2.63l-2.08,2.88l-0.02,0.44l2.8,4.56l-1.59,3.31l2.16,3.24l-0.94,2.39l0.14,0.47l3.44,2.51l-0.77,1.62l-7.52,6.95l-4.5,0.31l-4.38,1.37l-3.8,0.74l-1.44,-1.96l-2.17,-1.11l0.5,-3.66l-1.16,-3.33l1.09,-2.08l2.21,-2.42l5.67,-4.32l1.64,-0.83l0.21,-0.42l-0.46,-2.02l-3.38,-1.89l-0.75,-1.43l-0.22,-6.74l-6.79,-4.8l0.8,-0.62l2.54,2.12l3.46,-0.12l3.0,0.96l2.51,-2.11l1.17,-3.08l3.55,-1.38l2.76,1.53l-0.95,2.79Z",name:"Finland"},FJ:{path:"M869.95,326.98l-1.21,0.41l-0.08,-0.23l2.97,-1.21l-0.14,0.42l-1.54,0.61ZM867.58,329.25l0.43,0.37l-0.27,0.88l-1.24,0.28l-1.04,-0.24l-0.14,-0.66l0.63,-0.58l0.92,0.26l0.7,-0.31Z",name:"Fiji"},FK:{path:"M274.36,425.85l1.44,1.08l-0.47,0.73l-3.0,0.89l-0.96,-1.0l-0.52,-0.05l-1.83,1.29l-0.73,-0.88l2.46,-1.64l1.93,0.76l1.67,-1.19Z",name:"Falkland Is."},NI:{path:"M202.33,252.67l0.81,-0.18l1.03,-1.02l-0.04,-0.88l0.68,-0.0l0.63,-0.54l0.97,0.22l1.53,-1.26l0.58,-0.99l1.17,0.34l2.41,-0.94l0.13,1.32l-0.81,1.94l0.1,2.74l-0.36,0.37l-0.11,1.75l-0.47,0.81l0.18,1.14l-1.73,-0.85l-0.71,0.27l-1.47,-0.6l-0.52,0.16l-4.01,-3.81Z",name:"Nicaragua"},NL:{path:"M430.31,143.39l0.6,-0.5l2.13,-4.8l3.2,-1.33l1.74,0.08l0.33,0.8l-0.59,2.92l-0.5,0.99l-1.26,0.0l-0.4,0.45l0.33,2.7l-2.2,-1.78l-2.62,0.58l-0.75,-0.11Z",name:"Netherlands"},NO:{path:"M491.44,67.41l6.8,2.89l-2.29,0.86l-0.15,0.65l2.33,2.38l-4.98,1.79l0.84,-2.45l-0.18,-0.48l-3.55,-1.8l-3.89,1.52l-1.42,3.38l-2.12,1.72l-2.64,-1.0l-3.11,0.21l-2.66,-2.22l-0.5,-0.01l-1.41,1.1l-1.44,0.17l-0.35,0.35l-0.32,2.47l-4.32,-0.64l-0.44,0.29l-0.58,2.11l-2.45,0.2l-4.15,7.68l-3.88,5.76l0.78,1.62l-0.64,1.16l-2.24,-0.06l-0.38,0.24l-1.66,3.89l0.15,5.17l1.57,2.04l-0.78,4.16l-2.02,2.48l-0.85,1.63l-1.3,-1.75l-0.58,-0.07l-4.87,4.19l-3.1,0.79l-3.16,-1.7l-0.85,-3.77l-0.77,-8.55l2.14,-2.31l6.55,-3.27l5.02,-4.17l10.63,-13.84l10.98,-8.7l5.35,-1.91l4.34,0.12l3.69,-3.64l4.49,0.19l4.37,-0.89ZM484.55,20.04l4.26,1.75l-3.1,2.55l-7.1,0.65l-7.08,-0.9l-0.37,-1.31l-0.37,-0.29l-3.44,-0.1l-2.08,-2.0l6.87,-1.44l3.9,1.31l2.39,-1.64l6.13,1.4ZM481.69,33.93l-4.45,1.74l-3.54,-0.99l1.12,-0.9l0.05,-0.58l-1.06,-1.22l4.22,-0.89l1.09,1.97l2.57,0.87ZM466.44,24.04l7.43,3.77l-5.41,1.86l-1.58,4.08l-2.26,1.2l-1.12,4.11l-2.61,0.18l-4.79,-2.86l1.84,-1.54l-0.1,-0.68l-3.69,-1.53l-4.77,-4.51l-1.73,-3.89l6.11,-1.82l1.54,1.92l3.57,-0.08l1.2,-1.96l3.32,-0.18l3.05,1.92Z",name:"Norway"},NA:{path:"M474.26,330.66l-0.97,0.04l-0.38,0.4l-0.07,8.9l-2.09,0.08l-0.39,0.4l-0.0,17.42l-1.98,1.23l-1.17,0.17l-2.44,-0.66l-0.48,-1.13l-0.99,-0.74l-0.54,0.05l-0.9,1.01l-1.53,-1.68l-0.93,-1.88l-1.99,-8.56l-0.06,-3.12l-0.33,-1.52l-2.3,-3.34l-1.91,-4.83l-1.96,-2.43l-0.12,-1.57l2.33,-0.79l1.43,0.07l1.81,1.13l10.23,-0.25l1.84,1.23l5.87,0.35ZM474.66,330.64l6.51,-1.6l1.9,0.39l-1.69,0.4l-1.31,0.83l-1.12,-0.94l-4.29,0.92Z",name:"Namibia"},VU:{path:"M839.04,322.8l0.22,1.14l-0.44,0.03l-0.2,-1.45l0.42,0.27Z",name:"Vanuatu"},NC:{path:"M838.78,341.24l-0.33,0.22l-2.9,-1.75l-3.26,-3.37l1.65,0.83l4.85,4.07Z",name:"New Caledonia"},NE:{path:"M454.75,226.53l1.33,1.37l0.48,0.07l1.27,-0.7l0.53,3.52l0.94,0.83l0.17,0.92l0.81,0.69l-0.44,0.95l-0.96,5.26l-0.13,3.22l-3.04,2.31l-1.22,3.57l1.02,1.24l-0.0,1.46l0.39,0.4l1.13,0.04l-0.9,1.25l-1.47,-2.42l-0.86,-0.29l-2.09,1.37l-1.74,-0.67l-1.45,-0.17l-0.85,0.35l-1.36,-0.07l-1.64,1.09l-1.06,0.05l-2.94,-1.28l-1.44,0.59l-1.01,-0.03l-0.97,-0.94l-2.7,-0.98l-2.69,0.3l-0.87,0.64l-0.47,1.6l-0.75,1.16l-0.12,1.53l-1.57,-1.1l-1.31,0.24l0.03,-0.81l-0.32,-0.41l-2.59,-0.52l-0.15,-1.16l-1.35,-1.6l-0.29,-1.0l0.13,-0.84l1.29,-0.08l1.08,-0.92l3.31,-0.22l2.22,-0.41l0.32,-0.34l0.2,-1.47l1.39,-1.88l-0.01,-5.66l3.36,-1.12l7.24,-5.12l8.42,-4.92l3.69,1.06Z",name:"Niger"},NG:{path:"M456.32,253.89l0.64,0.65l-0.28,1.04l-2.11,2.01l-2.03,5.18l-1.37,1.16l-1.15,3.18l-1.33,0.66l-1.46,-0.97l-1.21,0.16l-1.38,1.36l-0.91,0.24l-1.79,4.06l-2.33,0.81l-1.11,-0.07l-0.86,0.5l-1.71,-0.05l-1.19,-1.39l-0.89,-1.89l-1.77,-1.66l-3.95,-0.08l0.07,-5.21l0.42,-1.43l1.95,-2.3l-0.14,-0.91l0.43,-1.18l-0.53,-1.41l0.25,-2.92l0.72,-1.07l0.32,-1.34l0.46,-0.39l2.47,-0.28l2.34,0.89l1.15,1.02l1.28,0.04l1.22,-0.58l3.03,1.27l1.49,-0.14l1.36,-1.0l1.33,0.07l0.82,-0.35l3.45,0.8l1.82,-1.32l1.84,2.67l0.66,0.16Z",name:"Nigeria"},NZ:{path:"M857.8,379.65l1.86,3.12l0.44,0.18l0.3,-0.38l0.03,-1.23l0.38,0.27l0.57,2.31l2.02,0.94l1.81,0.27l1.57,-1.06l0.7,0.18l-1.15,3.59l-1.98,0.11l-0.74,1.2l0.2,1.11l-2.42,3.98l-1.49,0.92l-1.04,-0.85l1.21,-2.05l-0.81,-2.01l-2.63,-1.25l0.04,-0.57l1.82,-1.19l0.43,-2.34l-0.16,-2.03l-0.95,-1.82l-0.06,-0.72l-3.11,-3.64l-0.79,-1.52l1.56,1.45l1.76,0.66l0.65,2.34ZM853.83,393.59l0.57,1.24l0.59,0.16l1.42,-0.97l0.46,0.79l0.0,1.03l-2.47,3.48l-1.26,1.2l-0.06,0.5l0.55,0.87l-1.41,0.07l-2.33,1.38l-2.03,5.02l-3.02,2.16l-2.06,-0.06l-1.71,-1.04l-2.47,-0.2l-0.27,-0.73l1.22,-2.1l3.05,-2.94l1.62,-0.59l4.02,-2.82l1.57,-1.67l1.07,-2.16l0.88,-0.7l0.48,-1.75l1.24,-0.97l0.35,0.79Z",name:"New Zealand"},NP:{path:"M641.14,213.62l0.01,3.19l-1.74,0.04l-4.8,-0.86l-1.58,-1.39l-3.37,-0.34l-7.65,-3.7l0.8,-2.09l2.33,-1.7l1.77,0.75l2.49,1.76l1.38,0.41l0.99,1.35l1.9,0.52l1.99,1.17l5.49,0.9Z",name:"Nepal"},XK:{path:"M472.77,172.64l-1.08,-1.29l0.96,-0.77l0.29,-0.83l1.98,1.64l-0.36,0.67l-1.79,0.58Z",name:"Kosovo"},CI:{path:"M407.4,259.27l0.86,0.42l0.56,0.9l1.13,0.53l1.19,-0.61l0.97,-0.08l1.42,0.54l0.6,3.24l-1.03,2.08l-0.65,2.84l1.06,2.33l-0.06,0.53l-2.54,-0.47l-1.66,0.03l-3.06,0.46l-4.11,1.6l0.32,-3.06l-1.18,-1.31l-1.32,-0.66l0.42,-0.85l-0.2,-1.4l0.5,-0.67l0.01,-1.59l0.84,-0.32l0.26,-0.5l-1.15,-3.01l0.12,-0.5l0.51,-0.25l0.66,0.31l1.93,0.02l0.67,-0.71l0.71,-0.14l0.25,0.69l0.57,0.22l1.4,-0.61Z",name:"C\xf4te d'Ivoire"},CH:{path:"M444.62,156.35l-0.29,0.87l0.18,0.53l1.13,0.58l1.0,0.1l-0.1,0.65l-0.79,0.38l-1.72,-0.37l-0.45,0.23l-0.45,1.04l-0.75,0.06l-0.84,-0.4l-1.32,1.0l-0.96,0.12l-0.88,-0.55l-0.81,-1.3l-0.49,-0.16l-0.63,0.26l0.02,-0.65l1.71,-1.66l0.1,-0.56l0.93,0.08l0.58,-0.46l1.99,0.02l0.66,-0.61l2.19,0.79Z",name:"Switzerland"},CO:{path:"M242.07,254.93l-1.7,0.59l-0.59,1.18l-1.7,1.69l-0.38,1.93l-0.67,1.43l0.31,0.57l1.03,0.13l0.25,0.9l0.57,0.64l-0.04,2.34l1.64,1.42l3.16,-0.24l1.26,0.28l1.67,2.06l0.41,0.13l4.09,-0.39l0.45,0.22l-0.92,1.95l-0.2,1.8l0.52,1.83l0.75,1.05l-1.12,1.1l0.07,0.63l0.84,0.51l0.74,1.29l-0.39,-0.45l-0.59,-0.01l-0.71,0.74l-4.71,-0.05l-0.4,0.41l0.03,1.57l0.33,0.39l1.11,0.2l-1.68,0.4l-0.29,0.38l-0.01,1.82l1.16,1.14l0.34,1.25l-1.05,7.05l-1.04,-0.87l1.26,-1.99l-0.13,-0.56l-2.18,-1.23l-1.38,0.2l-1.14,-0.38l-1.27,0.61l-1.55,-0.26l-1.38,-2.46l-1.23,-0.75l-0.85,-1.2l-1.67,-1.19l-0.86,0.13l-2.11,-1.32l-1.01,0.31l-1.8,-0.29l-0.52,-0.91l-3.09,-1.68l0.77,-0.52l-0.1,-1.12l0.41,-0.64l1.34,-0.32l2.0,-2.88l-0.11,-0.57l-0.66,-0.43l0.39,-1.38l-0.52,-2.1l0.49,-0.83l-0.4,-2.13l-0.97,-1.35l0.17,-0.66l0.86,-0.08l0.47,-0.75l-0.46,-1.63l1.41,-0.07l1.8,-1.69l0.93,-0.24l0.3,-0.38l0.45,-2.76l1.22,-1.0l1.44,-0.04l0.45,-0.5l1.91,0.12l2.93,-1.84l1.15,-1.14l0.91,0.46l-0.25,0.45Z",name:"Colombia"},CN:{path:"M740.23,148.97l4.57,1.3l2.8,2.17l0.98,2.9l0.38,0.27l3.8,0.0l2.32,-1.28l3.29,-0.75l-0.96,2.09l-1.02,1.28l-0.85,3.4l-1.52,2.73l-2.76,-0.5l-2.4,1.13l-0.21,0.45l0.64,2.57l-0.32,3.2l-0.94,0.06l-0.37,0.89l-0.91,-1.01l-0.64,0.07l-0.92,1.57l-3.73,1.25l-0.26,0.48l0.26,1.06l-1.5,-0.08l-1.09,-0.86l-0.56,0.06l-1.67,2.06l-2.7,1.56l-2.03,1.88l-3.4,0.83l-1.93,1.4l-1.15,0.34l0.33,-0.7l-0.41,-0.89l1.79,-1.79l0.02,-0.54l-1.32,-1.56l-0.48,-0.1l-2.24,1.09l-2.83,2.06l-1.51,1.83l-2.28,0.13l-1.55,1.49l-0.04,0.5l1.32,1.97l2.0,0.58l0.31,1.35l1.98,0.84l3.0,-1.96l2.0,1.02l1.49,0.11l0.22,0.83l-3.37,0.86l-1.12,1.48l-2.5,1.52l-1.29,1.99l0.14,0.56l2.57,1.48l0.97,2.7l3.17,4.63l-0.03,1.66l-1.35,0.65l-0.2,0.51l0.6,1.47l1.4,0.91l-0.89,3.82l-1.43,0.38l-3.85,6.44l-2.27,3.11l-6.78,4.57l-2.73,0.29l-1.45,1.04l-0.62,-0.61l-0.55,-0.01l-1.36,1.25l-3.39,1.27l-2.61,0.4l-1.1,2.79l-0.81,0.09l-0.49,-1.42l0.5,-0.85l-0.25,-0.59l-3.36,-0.84l-1.3,0.4l-2.31,-0.62l-0.94,-0.84l0.33,-1.28l-0.3,-0.49l-2.19,-0.46l-1.13,-0.93l-0.47,-0.02l-2.06,1.36l-4.29,0.28l-2.76,1.05l-0.28,0.43l0.32,2.53l-0.59,-0.03l-0.19,-1.34l-0.55,-0.34l-1.68,0.7l-2.46,-1.23l0.62,-1.87l-0.26,-0.51l-1.37,-0.44l-0.54,-2.22l-0.45,-0.3l-2.13,0.35l0.24,-2.48l2.39,-2.4l0.03,-4.31l-1.19,-0.92l-0.78,-1.49l-0.41,-0.21l-1.41,0.19l-1.98,-0.3l0.46,-1.07l-1.17,-1.7l-0.55,-0.11l-1.63,1.05l-2.25,-0.57l-2.89,1.73l-2.25,1.98l-1.75,0.29l-1.17,-0.71l-3.31,-0.65l-1.48,0.79l-1.04,1.27l-0.12,-1.17l-0.54,-0.34l-1.44,0.54l-5.55,-0.86l-1.98,-1.16l-1.89,-0.54l-0.99,-1.35l-1.34,-0.37l-2.55,-1.79l-2.01,-0.84l-1.21,0.56l-5.57,-3.45l-0.53,-2.31l1.19,0.25l0.48,-0.37l0.08,-1.42l-0.98,-1.56l0.15,-2.44l-2.69,-3.32l-4.12,-1.23l-0.67,-2.0l-1.92,-1.48l-0.38,-0.7l-0.51,-3.01l-1.52,-0.66l-0.7,0.13l-0.48,-2.05l0.55,-0.51l-0.09,-0.82l2.03,-1.19l1.6,-0.54l2.56,0.38l0.42,-0.22l0.85,-1.7l3.0,-0.33l1.1,-1.26l4.05,-1.77l0.39,-0.91l-0.17,-1.44l1.45,-0.67l0.2,-0.52l-2.07,-4.9l4.51,-1.12l1.37,-0.73l1.89,-5.51l4.98,0.86l1.51,-1.7l0.11,-2.87l1.99,-0.38l1.83,-2.06l0.49,-0.13l0.68,2.08l2.23,1.77l3.44,1.16l1.55,2.29l-0.92,3.49l0.96,1.67l6.54,1.13l2.95,1.87l1.47,0.35l1.06,2.62l1.53,1.91l3.05,0.08l5.14,0.67l3.37,-0.41l2.36,0.43l3.65,1.8l3.06,0.04l1.45,0.88l2.87,-1.59l3.95,-1.02l3.83,-0.14l3.06,-1.14l1.77,-1.6l1.72,-1.01l0.17,-0.49l-1.1,-2.05l1.02,-1.54l4.02,0.8l2.45,-1.61l3.76,-1.19l1.96,-2.13l1.63,-0.83l3.51,-0.4l1.92,0.34l0.46,-0.3l0.17,-1.5l-2.27,-2.22l-2.11,-1.09l-2.18,1.11l-2.32,-0.47l-1.29,0.32l-0.4,-0.82l2.73,-5.16l3.02,1.06l3.53,-2.06l0.18,-1.68l2.16,-3.35l1.49,-1.35l-0.03,-1.85l-1.07,-0.85l1.54,-1.26l2.98,-0.59l3.23,-0.09l3.64,0.99l2.04,1.16l3.29,6.71l0.92,3.19ZM696.92,237.31l-1.87,1.08l-1.63,-0.64l-0.06,-1.79l1.03,-0.98l2.58,-0.69l1.16,0.05l0.3,0.54l-0.98,1.06l-0.53,1.37Z",name:"China"},CM:{path:"M457.92,257.49l1.05,1.91l-1.4,0.16l-1.05,-0.23l-0.45,0.22l-0.54,1.19l0.08,0.45l1.48,1.47l1.05,0.45l1.01,2.46l-1.52,2.99l-0.68,0.68l-0.13,3.69l2.38,3.84l1.09,0.8l0.24,2.48l-3.67,-1.14l-11.27,-0.13l0.23,-1.79l-0.98,-1.66l-1.19,-0.54l-0.44,-0.97l-0.6,-0.42l1.71,-4.27l0.75,-0.13l1.38,-1.36l0.65,-0.03l1.71,0.99l1.93,-1.12l1.14,-3.18l1.38,-1.17l2.0,-5.14l2.17,-2.13l0.3,-1.64l-0.86,-0.88l0.03,-0.33l0.94,1.28l0.07,3.22Z",name:"Cameroon"},CL:{path:"M246.5,429.18l-3.14,1.83l-0.57,3.16l-0.64,0.05l-2.68,-1.06l-2.82,-2.33l-3.04,-1.89l-0.69,-1.85l0.63,-2.14l-1.21,-2.11l-0.31,-5.37l1.01,-2.91l2.57,-2.38l-0.18,-0.68l-3.16,-0.77l2.05,-2.47l0.77,-4.65l2.32,0.9l0.54,-0.29l1.31,-6.31l-0.22,-0.44l-1.68,-0.8l-0.56,0.28l-0.7,3.36l-0.81,-0.22l1.56,-9.41l1.15,-2.24l-0.71,-2.82l-0.18,-2.84l1.01,-0.33l3.26,-9.14l1.07,-4.22l-0.56,-4.21l0.74,-2.34l-0.29,-3.27l1.46,-3.34l2.04,-16.59l-0.66,-7.76l1.03,-0.53l0.54,-0.9l0.79,1.14l0.32,1.78l1.25,1.16l-0.69,2.55l1.33,2.9l0.97,3.59l0.46,0.29l1.5,-0.3l0.11,0.23l-0.76,2.44l-2.57,1.23l-0.23,0.37l0.08,4.33l-0.46,0.77l0.56,1.21l-1.58,1.51l-1.68,2.62l-0.89,2.47l0.2,2.7l-1.48,2.73l1.12,5.09l0.64,0.61l-0.01,2.29l-1.38,2.68l0.01,2.4l-1.89,2.04l0.02,2.75l0.69,2.57l-1.43,1.13l-1.26,5.68l0.39,3.51l-0.97,0.89l0.58,3.5l1.02,1.14l-0.65,1.02l0.15,0.57l1.0,0.53l0.16,0.69l-1.03,0.85l0.26,1.75l-0.89,4.03l-1.31,2.66l0.24,1.75l-0.71,1.83l-1.99,1.7l0.3,3.67l0.88,1.19l1.58,0.01l0.01,2.21l1.04,1.95l5.98,0.63ZM248.69,430.79l0.0,7.33l0.4,0.4l3.52,0.05l-0.44,0.75l-1.94,0.98l-2.49,-0.37l-1.88,-1.06l-2.55,-0.49l-5.59,-3.71l-2.38,-2.63l4.1,2.48l3.32,1.23l0.45,-0.12l1.29,-1.57l0.83,-2.32l2.05,-1.24l1.31,0.29Z",name:"Chile"},XC:{path:"M504.91,192.87l0.34,0.01l0.27,-0.07l-0.29,0.26l-0.31,-0.2Z",name:"N. Cyprus"},CA:{path:"M280.06,145.6l-1.67,2.88l0.07,0.49l0.5,0.04l1.46,-0.98l1.0,0.42l-0.56,0.72l0.17,0.62l2.22,0.89l1.35,-0.71l1.95,0.78l-0.66,2.01l0.5,0.51l1.32,-0.42l0.98,3.17l-0.91,2.41l-0.8,0.08l-1.23,-0.45l0.47,-2.25l-0.89,-0.83l-0.48,0.06l-2.78,2.63l-0.34,-0.02l1.02,-0.85l-0.14,-0.69l-2.4,-0.77l-7.4,0.08l-0.17,-0.41l1.3,-0.94l0.02,-0.64l-0.73,-0.58l1.85,-1.74l2.57,-5.16l1.47,-1.79l1.99,-1.05l0.46,0.06l-1.53,2.45ZM68.32,74.16l4.13,0.95l4.02,2.14l2.61,0.4l2.47,-1.89l2.88,-1.31l3.85,0.48l3.71,-1.94l3.82,-1.04l1.56,1.68l0.49,0.08l1.87,-1.04l0.65,-1.98l1.24,0.35l4.16,3.94l0.54,0.01l2.75,-2.49l0.26,2.59l0.49,0.35l3.08,-0.73l1.04,-1.27l2.73,0.23l3.83,1.86l5.86,1.61l3.47,0.75l2.44,-0.26l2.73,1.78l-2.98,1.81l-0.19,0.41l0.31,0.32l4.53,0.92l6.87,-0.5l2.0,-0.69l2.49,2.39l0.53,0.02l2.72,-2.16l-0.02,-0.64l-2.16,-1.54l1.15,-1.06l4.83,-0.61l1.84,0.95l2.48,2.31l3.01,-0.23l4.55,1.92l3.85,-0.67l3.61,0.1l0.41,-0.44l-0.25,-2.36l1.79,-0.61l3.49,1.32l-0.01,3.77l0.31,0.39l0.45,-0.22l1.48,-3.16l1.74,0.1l0.41,-0.3l1.13,-4.37l-2.78,-3.11l-2.8,-1.74l0.19,-4.64l2.71,-3.07l2.98,0.67l2.41,1.95l3.19,4.8l-1.99,1.97l0.21,0.68l4.33,0.84l-0.01,4.15l0.25,0.37l0.44,-0.09l3.07,-3.15l2.54,2.39l-0.61,3.33l2.42,2.88l0.61,0.0l2.61,-3.08l1.88,-3.82l0.17,-4.58l6.72,0.94l3.13,2.04l0.13,1.82l-1.76,2.19l-0.01,0.49l1.66,2.16l-0.26,1.71l-4.68,2.8l-3.28,0.61l-2.47,-1.2l-0.55,0.23l-0.73,2.04l-2.38,3.43l-0.74,1.77l-2.74,2.57l-3.44,0.25l-2.21,1.78l-0.28,2.53l-2.82,0.55l-3.12,3.22l-2.72,4.31l-1.03,3.17l-0.14,4.31l0.33,0.41l3.44,0.57l2.24,5.95l0.45,0.23l3.4,-0.69l4.52,1.51l2.43,1.31l1.91,1.73l3.1,0.96l2.62,1.46l6.6,0.54l-0.35,2.74l0.81,3.53l1.81,3.78l3.83,3.3l0.45,0.04l2.1,-1.28l1.37,-3.69l-1.31,-5.38l-1.45,-1.58l3.57,-1.47l2.84,-2.46l1.52,-2.8l-0.25,-2.55l-1.7,-3.07l-2.85,-2.61l2.8,-3.95l-1.08,-3.37l-0.79,-5.67l1.36,-0.7l6.76,1.41l2.12,-0.96l5.12,3.36l1.05,1.61l4.08,0.26l-0.06,2.87l0.83,4.7l0.3,0.32l2.16,0.54l1.73,2.06l0.5,0.09l3.63,-2.03l2.52,-4.19l1.26,-1.32l7.6,11.72l-0.92,2.04l0.16,0.51l3.3,1.97l2.22,1.98l4.1,0.98l1.43,0.99l0.95,2.79l2.1,0.68l0.84,1.08l0.17,3.45l-3.37,2.26l-4.22,1.24l-3.06,2.63l-4.06,0.51l-5.35,-0.69l-6.39,0.2l-2.3,2.41l-3.26,1.51l-6.47,7.15l-0.06,0.48l0.44,0.19l2.13,-0.52l4.17,-4.24l5.12,-2.62l3.52,-0.3l1.69,1.21l-2.12,2.21l0.81,3.47l1.02,2.61l3.47,1.6l4.14,-0.45l2.15,-2.8l0.26,1.48l1.14,0.8l-2.56,1.69l-5.5,1.82l-2.54,1.27l-2.74,2.15l-1.4,-0.16l-0.07,-2.01l4.14,-2.44l0.18,-0.45l-0.39,-0.29l-6.63,0.45l-1.39,-1.49l-0.14,-4.43l-1.11,-0.91l-1.82,0.39l-0.66,-0.66l-0.6,0.03l-1.91,2.39l-0.82,2.52l-0.8,1.27l-1.67,0.56l-0.46,0.76l-8.31,0.07l-1.21,0.62l-2.35,1.97l-0.71,-0.14l-1.37,0.96l-1.12,-0.48l-4.74,1.26l-0.9,1.17l0.21,0.62l1.73,0.3l-1.81,0.31l-1.85,0.81l-2.11,-0.13l-2.95,1.78l-0.69,-0.09l1.39,-2.1l1.73,-1.21l0.1,-2.29l1.16,-1.99l0.49,0.53l2.03,0.42l1.2,-1.16l0.02,-0.47l-2.66,-3.51l-2.28,-0.61l-5.64,-0.71l-0.4,-0.57l-0.79,0.13l0.2,-0.41l-0.22,-0.55l-0.68,-0.26l0.19,-1.26l-0.78,-0.73l0.31,-0.64l-0.29,-0.57l-2.6,-0.44l-0.75,-1.63l-0.94,-0.66l-4.31,-0.65l-1.13,1.19l-1.48,0.59l-0.85,1.06l-2.83,-0.76l-2.09,0.39l-2.39,-0.97l-4.24,-0.7l-0.57,-0.4l-0.41,-1.63l-0.4,-0.3l-0.85,0.02l-0.39,0.4l-0.01,0.85l-69.13,-0.01l-6.51,-4.52l-4.5,-1.38l-1.26,-2.66l0.33,-1.93l-0.23,-0.43l-3.01,-1.35l-0.55,-2.77l-2.89,-2.38l-0.04,-1.45l1.39,-1.83l-0.28,-2.55l-4.16,-2.2l-4.07,-6.6l-4.02,-3.22l-1.3,-1.88l-0.5,-0.13l-2.51,1.21l-2.23,1.87l-3.85,-3.88l-2.44,-1.04l-2.22,-0.13l0.03,-37.49ZM260.37,148.65l3.04,0.76l2.26,1.2l-3.78,-0.95l-1.53,-1.01ZM249.4,3.81l6.68,0.49l5.32,0.79l4.26,1.57l-0.07,1.1l-5.85,2.53l-6.02,1.21l-2.39,1.39l-0.18,0.45l0.39,0.29l4.01,-0.02l-4.65,2.82l-4.2,1.74l-4.19,4.59l-5.03,0.92l-1.67,1.15l-7.47,0.59l-0.37,0.37l0.32,0.42l2.41,0.49l-0.81,0.47l-0.12,0.59l1.83,2.41l-2.02,1.59l-3.81,1.51l-1.32,2.16l-3.38,1.53l-0.22,0.48l0.35,1.19l0.4,0.29l3.88,-0.18l0.03,0.61l-6.33,2.95l-6.41,-1.4l-7.43,0.79l-3.72,-0.62l-4.4,-0.25l-0.23,-1.83l4.29,-1.11l0.28,-0.51l-1.1,-3.45l1.0,-0.25l6.58,2.28l0.47,-0.16l-0.05,-0.49l-3.41,-3.45l-3.58,-0.98l1.48,-1.55l4.34,-1.29l0.97,-2.19l-0.16,-0.48l-3.42,-2.13l-0.81,-2.26l6.2,0.22l2.24,0.58l3.91,-2.1l0.2,-0.43l-0.35,-0.32l-5.64,-0.67l-8.73,0.36l-4.26,-1.9l-2.12,-2.4l-2.78,-1.66l-0.41,-1.52l3.31,-1.03l2.93,-0.2l4.91,-0.99l3.7,-2.27l2.87,0.3l2.62,1.67l0.56,-0.14l1.82,-3.2l3.13,-0.94l4.44,-0.69l7.53,-0.26l1.48,0.67l7.19,-1.06l10.8,0.79ZM203.85,57.54l0.01,0.42l1.97,2.97l0.68,-0.02l2.24,-3.72l5.95,-1.86l4.01,4.64l-0.35,2.91l0.5,0.43l4.95,-1.36l2.32,-1.8l5.31,2.28l3.27,2.11l0.3,1.84l0.48,0.33l4.42,-0.99l2.64,2.87l5.97,1.77l2.06,1.72l2.11,3.71l-4.19,1.86l-0.01,0.73l5.9,2.83l3.94,0.94l3.78,3.95l3.46,0.25l-0.63,2.37l-4.11,4.47l-2.76,-1.56l-3.9,-3.94l-3.59,0.41l-0.33,0.34l-0.19,2.72l2.63,2.38l3.42,1.89l0.94,0.97l1.55,3.75l-0.7,2.29l-2.74,-0.92l-6.25,-3.15l-0.51,0.13l0.05,0.52l6.07,5.69l0.18,0.59l-6.09,-1.39l-5.31,-2.24l-2.63,-1.66l0.6,-0.77l-0.12,-0.6l-7.39,-4.01l-0.59,0.37l0.03,0.79l-6.73,0.6l-1.69,-1.1l1.36,-2.46l4.51,-0.07l5.15,-0.52l0.31,-0.6l-0.74,-1.3l0.78,-1.84l3.21,-4.05l-0.67,-2.35l-1.11,-1.6l-3.84,-2.1l-4.35,-1.28l0.91,-0.63l0.06,-0.61l-2.65,-2.75l-2.34,-0.36l-1.89,-1.46l-0.53,0.03l-1.24,1.23l-4.36,0.55l-9.04,-0.99l-9.26,-1.98l-1.6,-1.22l2.22,-1.77l0.13,-0.44l-0.38,-0.27l-3.22,-0.02l-0.72,-4.25l1.83,-4.04l2.42,-1.85l5.5,-1.1l-1.39,2.35ZM261.19,159.33l2.07,0.61l1.44,-0.04l-1.15,0.63l-2.94,-1.23l-0.4,-0.68l0.36,-0.37l0.61,1.07ZM230.83,84.39l-2.37,0.18l-0.49,-1.63l0.93,-2.09l1.94,-0.51l1.62,0.99l0.02,1.52l-1.66,1.54ZM229.43,58.25l0.11,0.65l-4.87,-0.21l-2.72,0.62l-3.1,-2.57l0.08,-1.26l0.86,-0.23l5.57,0.51l4.08,2.5ZM222.0,105.02l-0.72,1.49l-0.63,-0.19l-0.48,-0.84l0.81,-0.99l0.65,0.05l0.37,0.46ZM183.74,38.32l2.9,1.7l4.79,-0.01l1.84,1.46l-0.49,1.68l0.23,0.48l2.82,1.14l1.76,1.26l7.01,0.65l4.1,-1.1l5.03,-0.43l3.93,0.35l2.48,1.77l0.46,1.7l-1.3,1.1l-3.56,1.01l-3.23,-0.59l-7.17,0.76l-5.09,0.09l-3.99,-0.6l-6.42,-1.54l-0.79,-2.51l-0.3,-2.49l-2.64,-2.5l-5.32,-0.72l-2.52,-1.4l0.68,-1.57l4.78,0.31ZM207.38,91.35l0.4,1.56l0.56,0.26l1.06,-0.52l1.32,0.96l5.42,2.57l0.2,1.68l0.46,0.35l1.68,-0.28l1.15,0.85l-1.55,0.87l-3.61,-0.88l-1.32,-1.69l-0.57,-0.06l-2.45,2.1l-3.12,1.79l-0.7,-1.87l-0.42,-0.26l-2.16,0.24l1.39,-1.39l0.32,-3.14l0.76,-3.35l1.18,0.22ZM215.49,102.6l-2.67,1.95l-1.4,-0.07l-0.3,-0.58l1.53,-1.48l2.84,0.18ZM202.7,24.12l2.53,1.59l-2.87,1.4l-4.53,4.05l-4.25,0.38l-5.03,-0.68l-2.45,-2.04l0.03,-1.62l1.82,-1.37l0.14,-0.45l-0.38,-0.27l-4.45,0.04l-2.59,-1.76l-1.41,-2.29l1.57,-2.32l1.62,-1.66l2.44,-0.39l0.25,-0.65l-0.6,-0.74l4.86,-0.25l3.24,3.11l8.16,2.3l1.9,3.61ZM187.47,59.2l-2.76,3.49l-2.38,-0.15l-1.44,-3.84l0.04,-2.2l1.19,-1.88l2.3,-1.23l5.07,0.17l4.11,1.02l-3.24,3.72l-2.88,0.89ZM186.07,48.79l-1.08,1.53l-3.34,-0.34l-2.56,-1.1l1.03,-1.75l3.25,-1.23l1.95,1.58l0.75,1.3ZM185.71,35.32l-5.3,-0.2l-0.32,-0.71l4.31,0.07l1.3,0.84ZM180.68,32.48l-3.34,1.0l-1.79,-1.1l-0.98,-1.87l-0.15,-1.73l4.1,0.53l2.67,1.7l-0.51,1.47ZM180.9,76.31l-1.1,1.08l-3.13,-1.23l-2.12,0.43l-2.71,-1.57l1.72,-1.09l1.55,-1.72l3.81,1.9l1.98,2.2ZM169.74,54.87l2.96,0.97l4.17,-0.57l0.41,0.88l-2.14,2.11l0.09,0.64l3.55,1.92l-0.4,3.72l-3.79,1.65l-2.17,-0.35l-1.72,-1.74l-6.02,-3.5l0.03,-0.85l4.68,0.54l0.4,-0.21l-0.05,-0.45l-2.48,-2.81l2.46,-1.95ZM174.45,40.74l1.37,1.73l0.07,2.44l-1.05,3.45l-3.79,0.47l-2.32,-0.69l0.05,-2.64l-0.44,-0.41l-3.68,0.35l-0.12,-3.1l2.45,0.1l3.67,-1.73l3.41,0.29l0.37,-0.26ZM170.05,31.55l0.67,1.56l-3.33,-0.49l-4.22,-1.77l-4.35,-0.16l1.4,-0.94l-0.06,-0.7l-2.81,-1.23l-0.12,-1.39l4.39,0.68l6.62,1.98l1.81,2.47ZM134.5,58.13l-1.02,1.82l0.45,0.58l5.4,-1.39l3.33,2.29l0.49,-0.03l2.6,-2.23l1.94,1.32l2.0,4.5l0.7,0.06l1.3,-2.29l-1.63,-4.46l1.69,-0.54l2.31,0.71l2.65,1.81l2.49,7.92l8.48,4.27l-0.19,1.35l-3.79,0.33l-0.26,0.67l1.4,1.49l-0.58,1.1l-4.23,-0.64l-4.43,-1.19l-3.0,0.28l-4.66,1.47l-10.52,1.04l-1.43,-2.02l-3.42,-1.2l-2.21,0.43l-2.51,-2.86l4.84,-1.05l3.6,0.19l3.27,-0.78l0.31,-0.39l-0.31,-0.39l-4.84,-1.06l-8.79,0.27l-0.85,-1.07l5.26,-1.66l0.27,-0.45l-0.4,-0.34l-3.8,0.06l-3.81,-1.06l1.81,-3.01l1.66,-1.79l6.48,-2.81l1.97,0.71ZM158.7,56.61l-1.7,2.44l-3.2,-2.75l0.37,-0.3l3.11,-0.18l1.42,0.79ZM149.61,42.73l1.01,1.89l0.5,0.18l2.14,-0.82l2.23,0.19l0.36,2.04l-1.33,2.09l-8.28,0.76l-6.35,2.15l-3.41,0.1l-0.19,-0.96l4.9,-2.08l0.23,-0.46l-0.41,-0.31l-11.25,0.59l-2.89,-0.74l3.04,-4.44l2.14,-1.32l6.81,1.69l4.58,3.06l4.37,0.39l0.36,-0.63l-3.36,-4.6l1.85,-1.53l2.18,0.51l0.77,2.26ZM144.76,34.41l-4.36,1.44l-3.0,-1.4l1.46,-1.24l3.47,-0.52l2.96,0.71l-0.52,1.01ZM145.13,29.83l-1.9,0.66l-3.67,-0.0l2.27,-1.61l3.3,0.95ZM118.92,65.79l-6.03,2.02l-1.33,-1.9l-5.38,-2.28l2.59,-5.05l2.16,-3.14l-0.02,-0.48l-1.97,-2.41l7.64,-0.7l3.6,1.02l6.3,0.27l4.42,2.95l-2.53,0.98l-6.24,3.43l-3.1,3.28l-0.11,2.01ZM129.54,35.53l-0.28,3.37l-1.72,1.62l-2.33,0.28l-4.61,2.19l-3.86,0.76l-2.64,-0.87l3.72,-3.4l5.01,-3.34l3.72,0.07l3.0,-0.67ZM111.09,152.69l-0.67,0.24l-3.85,-1.37l-0.83,-1.17l-2.12,-1.07l-0.66,-1.02l-2.4,-0.55l-0.74,-1.71l6.02,1.45l2.0,2.55l2.52,1.39l0.73,1.27ZM87.8,134.64l0.89,0.29l1.86,-0.21l-0.65,3.34l1.69,2.33l-1.31,-1.33l-0.99,-1.62l-1.17,-0.98l-0.33,-1.82Z",name:"Canada"},CG:{path:"M466.72,276.48l-0.1,1.03l-1.25,2.97l-0.19,3.62l-0.46,1.78l-0.23,0.63l-1.61,1.19l-1.21,1.39l-1.09,2.43l0.04,2.09l-3.25,3.24l-0.5,-0.24l-0.5,-0.83l-1.36,-0.02l-0.98,0.89l-1.68,-0.99l-1.54,1.24l-1.52,-1.96l1.57,-1.14l0.11,-0.52l-0.77,-1.35l2.1,-0.66l0.39,-0.73l1.05,0.82l2.21,0.11l1.12,-1.37l0.37,-1.81l-0.27,-2.09l-1.13,-1.5l1.0,-2.69l-0.13,-0.45l-0.92,-0.58l-1.6,0.17l-0.51,-0.94l0.1,-0.61l2.75,0.09l3.97,1.24l0.51,-0.33l0.17,-1.28l1.24,-2.21l1.28,-1.14l2.76,0.49Z",name:"Congo"},CF:{path:"M461.16,278.2l-0.26,-1.19l-1.09,-0.77l-0.84,-1.17l-0.29,-1.0l-1.04,-1.15l0.08,-3.43l0.58,-0.49l1.16,-2.35l1.85,-0.17l0.61,-0.62l0.97,0.58l3.15,-0.96l2.48,-1.92l0.02,-0.96l2.81,0.02l2.36,-1.17l1.93,-2.85l1.16,-0.93l1.11,-0.3l0.27,0.86l1.34,1.47l-0.39,2.01l0.3,1.01l4.01,2.75l0.17,0.93l2.63,2.31l0.6,1.44l2.08,1.4l-3.84,-0.21l-1.94,0.88l-1.23,-0.49l-2.67,1.2l-1.29,-0.18l-0.51,0.36l-0.6,1.22l-3.35,-0.65l-1.57,-0.91l-2.42,-0.83l-1.45,0.91l-0.97,1.27l-0.26,1.56l-3.22,-0.43l-1.49,1.33l-0.94,1.62Z",name:"Central African Rep."},CD:{path:"M487.01,272.38l2.34,-0.14l1.35,1.84l1.34,0.45l0.86,-0.39l1.21,0.12l1.07,-0.41l0.54,0.89l2.04,1.54l-0.14,2.72l0.7,0.54l-1.38,1.13l-1.53,2.54l-0.17,2.05l-0.59,1.08l-0.02,1.72l-0.72,0.84l-0.66,3.01l0.63,1.32l-0.44,4.26l0.64,1.47l-0.37,1.22l0.86,1.8l1.53,1.41l0.3,1.26l0.44,0.5l-4.08,0.75l-0.92,1.81l0.51,1.34l-0.74,5.43l0.17,0.38l2.45,1.46l0.54,-0.1l0.12,1.62l-1.28,-0.01l-1.85,-2.35l-1.94,-0.45l-0.48,-1.13l-0.55,-0.2l-1.41,0.74l-1.71,-0.3l-1.01,-1.18l-2.49,-0.19l-0.44,-0.77l-1.98,-0.21l-2.88,0.36l0.11,-2.41l-0.85,-1.13l-0.16,-1.36l0.32,-1.73l-0.46,-0.89l-0.04,-1.49l-0.4,-0.39l-2.53,0.02l0.1,-0.41l-0.39,-0.49l-1.28,0.01l-0.43,0.45l-1.62,0.32l-0.83,1.79l-1.09,-0.28l-2.4,0.52l-1.37,-1.91l-1.3,-3.3l-0.38,-0.27l-7.39,-0.03l-2.46,0.42l0.5,-0.45l0.37,-1.47l0.66,-0.38l0.92,0.08l0.73,-0.82l0.87,0.02l0.31,0.68l1.4,0.36l3.59,-3.63l0.01,-2.23l1.02,-2.29l2.69,-2.39l0.43,-0.99l0.49,-1.96l0.17,-3.51l1.25,-2.95l0.36,-3.14l0.86,-1.13l1.1,-0.66l3.57,1.73l3.65,0.73l0.46,-0.21l0.8,-1.46l1.24,0.19l2.61,-1.17l0.81,0.44l1.04,-0.03l0.59,-0.66l0.7,-0.16l1.81,0.25Z",name:"Dem. Rep. Congo"},CZ:{path:"M458.46,144.88l1.22,1.01l1.47,0.23l0.13,0.93l1.36,0.68l0.54,-0.2l0.24,-0.55l1.15,0.25l0.53,1.09l1.68,0.18l0.6,0.84l-1.04,0.73l-0.96,1.28l-1.6,0.17l-0.55,0.56l-1.04,-0.46l-1.05,0.15l-2.12,-0.96l-1.05,0.34l-1.2,1.12l-1.56,-0.87l-2.57,-2.1l-0.53,-1.88l4.7,-2.52l0.71,0.26l0.9,-0.28Z",name:"Czech Rep."},CY:{path:"M504.36,193.47l0.43,0.28l-1.28,0.57l-0.92,-0.28l-0.24,-0.46l2.01,-0.13Z",name:"Cyprus"},CR:{path:"M211.34,258.05l0.48,0.99l1.6,1.6l-0.54,0.45l0.29,1.42l-0.25,1.19l-1.09,-0.59l-0.05,-1.25l-2.46,-1.42l-0.28,-0.77l-0.66,-0.45l-0.45,-0.0l-0.11,1.04l-1.32,-0.95l0.31,-1.3l-0.36,-0.6l0.31,-0.27l1.42,0.58l1.29,-0.14l0.56,0.56l0.74,0.17l0.55,-0.27Z",name:"Costa Rica"},CU:{path:"M221.21,227.25l1.27,1.02l2.19,-0.28l4.43,3.33l2.08,0.43l-0.1,0.38l0.36,0.5l1.75,0.1l1.48,0.84l-3.11,0.51l-4.15,-0.03l0.77,-0.67l-0.04,-0.64l-1.2,-0.74l-1.49,-0.16l-0.7,-0.61l-0.56,-1.4l-0.4,-0.25l-1.34,0.1l-2.2,-0.66l-0.88,-0.58l-3.18,-0.4l-0.27,-0.16l0.58,-0.74l-0.36,-0.29l-2.72,-0.05l-1.7,1.29l-0.91,0.03l-0.61,0.69l-1.01,0.22l1.11,-1.29l1.01,-0.52l3.69,-1.01l3.98,0.21l2.21,0.84Z",name:"Cuba"},SZ:{path:"M500.35,351.36l0.5,2.04l-0.38,0.89l-1.05,0.21l-1.23,-1.2l-0.02,-0.64l0.83,-1.57l1.34,0.27Z",name:"Swaziland"},SY:{path:"M511.0,199.79l0.05,-1.33l0.54,-1.36l1.28,-0.99l0.13,-0.45l-0.41,-1.11l-1.14,-0.36l-0.19,-1.74l0.52,-1.0l1.29,-1.21l0.2,-1.18l0.59,0.23l2.62,-0.76l1.36,0.52l2.06,-0.01l2.95,-1.08l3.25,-0.26l-0.67,0.94l-1.28,0.66l-0.21,0.4l0.23,2.01l-0.88,3.19l-10.15,5.73l-2.15,-0.85Z",name:"Syria"},KG:{path:"M621.35,172.32l-3.87,1.69l-0.96,1.18l-3.04,0.34l-1.13,1.86l-2.36,-0.35l-1.99,0.63l-2.39,1.4l0.06,0.95l-0.4,0.37l-4.52,0.43l-3.02,-0.93l-2.37,0.17l0.11,-0.79l2.32,0.42l1.13,-0.88l1.99,0.2l3.21,-2.14l-0.03,-0.69l-2.97,-1.57l-1.94,0.65l-1.22,-0.74l1.71,-1.58l-0.12,-0.67l-0.36,-0.15l0.32,-0.77l1.36,-0.35l4.02,1.02l0.49,-0.3l0.35,-1.59l1.09,-0.48l3.42,1.22l1.11,-0.31l7.64,0.39l1.16,1.0l1.23,0.39Z",name:"Kyrgyzstan"},KE:{path:"M506.26,284.69l1.87,-2.56l0.93,-2.15l-1.38,-4.08l-1.06,-1.6l2.82,-2.75l0.79,0.26l0.12,1.41l0.86,0.83l1.9,0.11l3.28,2.13l3.57,0.44l1.05,-1.12l1.96,-0.9l0.82,0.68l1.16,0.09l-1.78,2.45l0.03,9.12l1.3,1.94l-1.37,0.78l-0.67,1.03l-1.08,0.46l-0.34,1.67l-0.81,1.07l-0.45,1.55l-0.68,0.56l-3.2,-2.23l-0.35,-1.58l-8.86,-4.98l0.14,-1.6l-0.57,-1.04Z",name:"Kenya"},SS:{path:"M481.71,263.34l1.07,-0.72l1.2,-3.18l1.36,-0.26l1.61,1.99l0.87,0.34l1.1,-0.41l1.5,0.07l0.57,0.53l2.49,0.0l0.44,-0.63l1.07,-0.4l0.45,-0.84l0.59,-0.33l1.9,1.33l1.6,-0.2l2.83,-3.33l-0.32,-2.21l1.59,-0.52l-0.24,1.6l0.3,1.83l1.35,1.18l0.2,1.87l0.35,0.41l0.02,1.53l-0.23,0.47l-1.42,0.25l-0.85,1.44l0.3,0.6l1.4,0.16l1.11,1.08l0.59,1.13l1.03,0.53l1.28,2.36l-4.41,3.98l-1.74,0.01l-1.89,0.55l-1.47,-0.52l-1.15,0.57l-2.96,-2.62l-1.3,0.49l-1.06,-0.15l-0.79,0.39l-0.82,-0.22l-1.8,-2.7l-1.91,-1.1l-0.66,-1.5l-2.62,-2.32l-0.18,-0.94l-2.37,-1.6Z",name:"S. Sudan"},SR:{path:"M283.12,270.19l2.1,0.53l-1.08,1.95l0.2,1.72l0.93,1.49l-0.59,2.03l-0.43,0.71l-1.12,-0.42l-1.32,0.22l-0.93,-0.2l-0.46,0.26l-0.25,0.73l0.33,0.7l-0.89,-0.13l-1.39,-1.97l-0.31,-1.34l-0.97,-0.31l-0.89,-1.47l0.35,-1.61l1.45,-0.82l0.33,-1.87l2.61,0.44l0.57,-0.47l1.75,-0.16Z",name:"Suriname"},KH:{path:"M689.52,249.39l0.49,1.45l-0.28,2.74l-4.0,1.86l-0.16,0.6l0.68,0.95l-2.06,0.17l-2.05,0.97l-1.82,-0.32l-2.12,-3.7l-0.55,-2.85l1.4,-1.85l3.02,-0.45l2.23,0.35l2.01,0.98l0.51,-0.14l0.95,-1.48l1.74,0.74Z",name:"Cambodia"},SV:{path:"M195.8,250.13l1.4,-1.19l2.24,1.45l0.98,-0.27l0.44,0.2l-0.27,1.05l-1.14,-0.03l-3.64,-1.21Z",name:"El Salvador"},SK:{path:"M476.82,151.17l-1.14,1.9l-2.73,-0.92l-0.82,0.2l-0.74,0.8l-3.46,0.73l-0.47,0.69l-1.76,0.33l-1.88,-1.0l-0.18,-0.81l0.38,-0.75l1.87,-0.32l1.74,-1.89l0.83,0.16l0.79,-0.34l1.51,1.04l1.34,-0.63l1.25,0.3l1.65,-0.42l1.81,0.95Z",name:"Slovakia"},KR:{path:"M737.51,185.84l0.98,-0.1l0.87,-1.17l2.69,-0.32l0.33,-0.29l1.76,2.79l0.58,1.76l0.02,3.12l-0.8,1.32l-2.21,0.55l-1.93,1.13l-1.8,0.19l-0.2,-1.1l0.43,-2.28l-0.95,-2.56l1.43,-0.37l0.23,-0.62l-1.43,-2.06Z",name:"Korea"},SI:{path:"M456.18,162.07l-0.51,-1.32l0.18,-1.05l1.69,0.2l1.42,-0.71l2.09,-0.07l0.62,-0.51l0.21,0.47l-1.61,0.67l-0.44,1.34l-0.66,0.24l-0.26,0.82l-1.22,-0.49l-0.84,0.46l-0.69,-0.04Z",name:"Slovenia"},KP:{path:"M736.77,185.16l-0.92,-0.42l-0.88,0.62l-1.21,-0.88l0.96,-1.15l0.59,-2.59l-0.46,-0.74l-2.09,-0.77l1.64,-1.52l2.72,-1.58l1.58,-1.91l1.11,0.78l2.17,0.11l0.41,-0.5l-0.3,-1.22l3.52,-1.18l0.94,-1.4l0.98,1.08l-2.19,2.18l0.01,2.14l-1.06,0.54l-1.41,1.4l-1.7,0.52l-1.25,1.09l-0.14,1.98l0.94,0.45l1.15,1.04l-0.13,0.26l-2.6,0.29l-1.13,1.29l-1.22,0.08Z",name:"Dem. Rep. Korea"},KW:{path:"M540.81,207.91l0.37,0.86l-0.17,0.76l0.6,1.53l-0.95,0.04l-0.82,-1.28l-1.57,-0.18l1.31,-1.88l1.22,0.17Z",name:"Kuwait"},SN:{path:"M390.09,248.21l0.12,1.55l0.49,1.46l0.96,0.82l0.05,1.28l-1.26,-0.19l-0.75,0.33l-1.84,-0.61l-5.84,-0.13l-2.54,0.51l-0.22,-1.03l1.77,0.04l2.01,-0.91l1.03,0.48l1.09,0.04l1.29,-0.62l0.14,-0.58l-0.51,-0.74l-1.81,0.25l-1.13,-0.63l-0.79,0.04l-0.72,0.61l-2.31,0.06l-0.92,-1.77l-0.81,-0.64l0.64,-0.35l2.46,-3.74l1.04,0.19l1.38,-0.56l1.19,-0.02l2.72,1.37l3.03,3.48Z",name:"Senegal"},SL:{path:"M394.46,264.11l-1.73,1.98l-0.58,1.33l-2.07,-1.06l-1.22,-1.26l-0.65,-2.39l1.16,-0.96l0.67,-1.17l1.21,-0.52l1.66,0.0l1.03,1.64l0.52,2.41Z",name:"Sierra Leone"},KZ:{path:"M552.8,172.89l0.46,-1.27l-0.48,-1.05l-2.96,-1.19l-1.06,-2.58l-1.37,-0.87l-0.03,-0.3l1.95,0.23l0.45,-0.38l0.08,-1.96l1.75,-0.41l2.1,0.45l0.48,-0.33l0.45,-3.04l-0.45,-2.09l-0.41,-0.31l-2.42,0.15l-2.36,-0.73l-2.87,1.37l-2.17,0.61l-0.85,-0.34l0.13,-1.61l-1.6,-2.12l-2.02,-0.08l-1.78,-1.82l1.29,-2.18l-0.57,-0.95l1.62,-2.91l2.21,1.63l0.63,-0.27l0.29,-2.22l4.92,-3.43l3.71,-0.08l8.4,3.6l2.92,-1.36l3.77,-0.06l3.11,1.66l0.51,-0.11l0.6,-0.81l3.31,0.13l0.39,-0.25l0.63,-1.57l-0.17,-0.5l-3.5,-1.98l1.87,-1.27l-0.13,-1.03l1.98,-0.72l0.18,-0.62l-1.59,-2.06l0.81,-0.82l9.23,-1.18l1.33,-0.88l6.18,-1.26l2.26,-1.42l4.08,0.68l0.73,3.33l0.51,0.3l2.48,-0.8l2.79,1.02l-0.17,1.56l0.43,0.44l2.55,-0.24l4.89,-2.53l0.03,0.32l3.15,2.61l5.56,8.47l0.65,0.02l1.12,-1.46l3.15,1.74l3.76,-0.78l1.15,0.49l1.14,1.8l1.84,0.76l0.99,1.29l3.35,-0.25l1.02,1.52l-1.6,1.81l-1.93,0.28l-0.34,0.38l-0.11,3.05l-1.13,1.16l-4.75,-1.0l-0.46,0.27l-1.76,5.47l-1.1,0.59l-4.91,1.23l-0.27,0.54l2.1,4.97l-1.37,0.63l-0.23,0.41l0.13,1.13l-0.88,-0.25l-1.42,-1.13l-7.89,-0.4l-0.92,0.31l-3.73,-1.22l-1.42,0.63l-0.53,1.66l-3.72,-0.94l-1.85,0.43l-0.76,1.4l-4.65,2.62l-1.13,2.08l-0.44,0.01l-0.92,-1.4l-2.87,-0.09l-0.45,-2.14l-0.38,-0.32l-0.8,-0.01l0.0,-2.96l-3.0,-2.22l-7.31,0.58l-2.35,-2.68l-6.71,-3.69l-6.45,1.83l-0.29,0.39l0.1,10.85l-0.7,0.08l-1.62,-2.17l-1.83,-0.96l-3.11,0.59l-0.64,0.51Z",name:"Kazakhstan"},SA:{path:"M537.53,210.34l2.0,0.24l0.9,1.32l1.49,-0.06l0.87,2.08l1.29,0.76l0.51,0.99l1.56,1.03l-0.1,1.9l0.32,0.9l1.58,2.47l0.76,0.53l0.7,-0.04l1.68,4.23l7.53,1.33l0.51,-0.29l0.77,1.25l-1.55,4.87l-7.29,2.52l-7.3,1.03l-2.34,1.17l-1.88,2.74l-0.76,0.28l-0.82,-0.78l-0.91,0.12l-2.88,-0.51l-3.51,0.25l-0.86,-0.56l-0.57,0.15l-0.66,1.27l0.16,1.11l-0.43,0.32l-0.93,-1.4l-0.33,-1.16l-1.23,-0.88l-1.27,-2.06l-0.78,-2.22l-1.73,-1.79l-1.14,-0.48l-1.54,-2.31l-0.21,-3.41l-1.44,-2.93l-1.27,-1.16l-1.33,-0.57l-1.31,-3.37l-0.77,-0.67l-0.97,-1.97l-2.8,-4.03l-1.06,-0.17l0.37,-1.96l0.2,-0.72l2.74,0.3l1.08,-0.84l0.6,-0.94l1.74,-0.35l0.65,-1.03l0.71,-0.4l0.1,-0.62l-2.06,-2.28l4.39,-1.22l0.48,-0.37l2.77,0.69l3.66,1.9l7.03,5.5l4.87,0.3Z",name:"Saudi Arabia"},SE:{path:"M480.22,89.3l-4.03,1.17l-2.43,2.86l0.26,2.57l-8.77,6.64l-1.78,5.79l1.78,2.68l2.22,1.96l-2.07,3.77l-2.72,1.13l-0.95,6.04l-1.29,3.01l-2.74,-0.31l-0.4,0.22l-1.31,2.59l-2.34,0.13l-0.75,-3.09l-2.08,-4.03l-1.83,-4.96l1.0,-1.93l2.14,-2.7l0.83,-4.45l-1.6,-2.17l-0.15,-4.94l1.48,-3.39l2.58,-0.15l0.87,-1.59l-0.78,-1.57l3.76,-5.59l4.04,-7.48l2.17,0.01l0.39,-0.29l0.57,-2.07l4.37,0.64l0.46,-0.34l0.33,-2.56l1.1,-0.13l6.94,4.87l0.06,6.32l0.66,1.36Z",name:"Sweden"},SD:{path:"M505.98,259.4l-0.34,-0.77l-1.17,-0.9l-0.26,-1.61l0.29,-1.81l-0.34,-0.46l-1.16,-0.17l-0.54,0.59l-1.23,0.11l-0.28,0.65l0.53,0.65l0.17,1.22l-2.44,3.0l-0.96,0.19l-2.39,-1.4l-0.95,0.52l-0.38,0.78l-1.11,0.41l-0.29,0.5l-1.94,0.0l-0.54,-0.52l-1.81,-0.09l-0.95,0.4l-2.45,-2.35l-2.07,0.54l-0.73,1.26l-0.6,2.1l-1.25,0.58l-0.75,-0.62l0.27,-2.65l-1.48,-1.78l-0.22,-1.48l-0.92,-0.96l-0.02,-1.29l-0.57,-1.16l-0.68,-0.16l0.69,-1.29l-0.18,-1.14l0.65,-0.62l0.03,-0.55l-0.36,-0.41l1.55,-2.97l1.91,0.16l0.43,-0.4l-0.1,-10.94l2.49,-0.01l0.4,-0.4l-0.0,-4.82l29.02,0.0l0.64,2.04l-0.49,0.66l0.36,2.69l0.93,3.16l2.12,1.55l-0.89,1.04l-1.72,0.39l-0.98,0.9l-1.43,5.65l0.24,1.15l-0.38,2.06l-0.96,2.38l-1.53,1.31l-1.32,2.91l-1.22,0.86l-0.37,1.34Z",name:"Sudan"},DO:{path:"M241.8,239.2l0.05,-0.65l-0.46,-0.73l0.42,-0.44l0.19,-1.0l-0.09,-1.53l1.66,0.01l1.99,0.63l0.33,0.67l1.28,0.19l0.33,0.76l1.0,0.08l0.8,0.62l-0.45,0.51l-1.13,-0.47l-1.88,-0.01l-1.27,0.59l-0.75,-0.55l-1.01,0.54l-0.79,1.4l-0.23,-0.61Z",name:"Dominican Rep."},DJ:{path:"M528.43,256.18l-0.45,0.66l-0.58,-0.25l-1.51,0.13l-0.18,-1.01l1.45,-1.95l0.83,0.17l0.77,-0.44l0.2,1.0l-1.2,0.51l-0.06,0.7l0.73,0.47Z",name:"Djibouti"},DK:{path:"M452.28,129.07l-1.19,2.24l-2.13,-1.6l-0.23,-0.95l2.98,-0.95l0.57,1.26ZM447.74,126.31l-0.26,0.57l-0.88,-0.07l-1.8,2.53l0.48,1.69l-1.09,0.36l-1.61,-0.39l-0.89,-1.69l-0.07,-3.43l0.96,-1.73l2.02,-0.2l1.09,-1.07l1.33,-0.67l-0.05,1.06l-0.73,1.41l0.3,1.0l1.2,0.64Z",name:"Denmark"},DE:{path:"M453.14,155.55l-0.55,-0.36l-1.2,-0.1l-1.87,0.57l-2.13,-0.13l-0.56,0.63l-0.86,-0.6l-0.96,0.09l-2.57,-0.93l-0.85,0.67l-1.47,-0.02l0.24,-1.75l1.23,-2.14l-0.28,-0.59l-3.52,-0.58l-0.92,-0.66l0.12,-1.2l-0.48,-0.88l0.27,-2.17l-0.37,-3.03l1.41,-0.22l0.63,-1.26l0.66,-3.19l-0.41,-1.18l0.26,-0.39l1.66,-0.15l0.33,0.54l0.62,0.07l1.7,-1.69l-0.54,-3.02l1.37,0.33l1.31,-0.37l0.31,1.18l2.25,0.71l-0.02,0.92l0.5,0.4l2.55,-0.65l1.34,-0.87l2.57,1.24l1.06,0.98l0.48,1.44l-0.57,0.74l-0.0,0.48l0.87,1.15l0.57,1.64l-0.14,1.29l0.82,1.7l-1.5,-0.07l-0.56,0.57l-4.47,2.15l-0.22,0.54l0.68,2.26l2.58,2.16l-0.66,1.11l-0.79,0.36l-0.23,0.43l0.32,1.87Z",name:"Germany"},YE:{path:"M528.27,246.72l0.26,-0.42l-0.22,-1.01l0.19,-1.5l0.92,-0.69l-0.07,-1.35l0.39,-0.75l1.01,0.47l3.34,-0.27l3.76,0.41l0.95,0.81l1.36,-0.58l1.74,-2.62l2.18,-1.09l6.86,-0.94l2.48,5.41l-1.64,0.76l-0.56,1.9l-6.23,2.16l-2.29,1.8l-1.93,0.05l-1.41,1.02l-4.24,0.74l-1.72,1.49l-3.28,0.19l-0.52,-1.18l0.02,-1.51l-1.34,-3.29Z",name:"Yemen"},DZ:{path:"M441.46,188.44l-0.32,1.07l0.39,2.64l-0.54,2.16l-1.58,1.82l0.37,2.39l1.91,1.55l0.18,0.8l1.42,1.03l1.84,7.23l0.12,1.16l-0.57,5.0l0.2,1.51l-0.87,0.99l-0.02,0.51l1.41,1.86l0.14,1.2l0.89,1.48l0.5,0.16l0.98,-0.41l1.73,1.08l0.82,1.23l-8.22,4.81l-7.23,5.11l-3.43,1.13l-2.3,0.21l-0.28,-1.59l-2.56,-1.09l-0.67,-1.25l-26.12,-17.86l0.01,-3.47l3.77,-1.88l2.44,-0.41l2.12,-0.75l1.08,-1.42l2.81,-1.05l0.35,-2.08l1.33,-0.29l1.04,-0.94l3.47,-0.69l0.46,-1.08l-0.1,-0.45l-0.58,-0.52l-0.82,-2.81l-0.19,-1.83l-0.78,-1.49l2.03,-1.31l2.63,-0.48l1.7,-1.22l2.31,-0.84l8.24,-0.73l1.49,0.38l2.28,-1.1l2.46,-0.02l0.92,0.6l1.35,-0.05Z",name:"Algeria"},US:{path:"M892.72,99.2l1.31,0.53l1.41,-0.37l1.89,0.98l1.89,0.42l-1.32,0.58l-2.9,-1.53l-2.08,0.22l-0.26,-0.15l0.07,-0.67ZM183.22,150.47l0.37,1.47l1.12,0.85l4.23,0.7l2.39,0.98l2.17,-0.38l1.85,0.5l-1.55,0.65l-3.49,2.61l-0.16,0.77l0.5,0.39l2.33,-0.61l1.77,1.02l5.15,-2.4l-0.31,0.65l0.25,0.56l1.36,0.38l1.71,1.16l4.7,-0.88l0.67,0.85l1.31,0.21l0.58,0.58l-1.34,0.17l-2.18,-0.32l-3.6,0.89l-2.71,3.25l0.35,0.9l0.59,-0.0l0.55,-0.6l-1.36,4.65l0.29,3.09l0.67,1.58l0.61,0.45l1.77,-0.44l1.6,-1.96l0.14,-2.21l-0.82,-1.96l0.11,-1.13l1.19,-2.37l0.44,-0.33l0.48,0.75l0.4,-0.29l0.4,-1.37l0.6,-0.47l0.24,-0.8l1.69,0.49l1.65,1.08l-0.03,2.37l-1.27,1.13l-0.0,1.13l0.87,0.36l1.66,-1.29l0.5,0.17l0.5,2.6l-2.49,3.75l0.17,0.61l1.54,0.62l1.48,0.17l1.92,-0.44l4.72,-2.15l2.16,-1.8l-0.05,-1.24l0.75,-0.22l3.92,0.36l2.12,-1.05l0.21,-0.4l-0.28,-1.48l3.27,-2.4l8.32,-0.02l0.56,-0.82l1.9,-0.77l0.93,-1.51l0.74,-2.37l1.58,-1.98l0.92,0.62l1.47,-0.47l0.8,0.66l-0.0,4.09l1.96,2.6l-2.34,1.31l-5.37,2.09l-1.83,2.72l0.02,1.79l0.83,1.59l0.54,0.23l-6.19,0.94l-2.2,0.89l-0.23,0.48l0.45,0.29l2.99,-0.46l-2.19,0.56l-1.13,0.0l-0.15,-0.32l-0.48,0.08l-0.76,0.82l0.22,0.67l0.32,0.06l-0.41,1.62l-1.27,1.58l-1.48,-1.07l-0.49,-0.04l-0.16,0.46l0.52,1.58l0.61,0.59l0.03,0.79l-0.95,1.38l-1.21,-1.22l-0.27,-2.27l-0.35,-0.35l-0.42,0.25l-0.48,1.27l0.33,1.41l-0.97,-0.27l-0.48,0.24l0.18,0.5l1.52,0.83l0.1,2.52l0.79,0.51l0.52,3.42l-1.42,1.88l-2.47,0.8l-1.71,1.66l-1.31,0.25l-1.27,1.03l-0.43,0.99l-2.69,1.78l-2.64,3.03l-0.45,2.12l0.45,2.08l0.85,2.38l1.09,1.9l0.04,1.2l1.16,3.06l-0.18,2.69l-0.55,1.43l-0.47,0.21l-0.89,-0.23l-0.49,-1.18l-0.87,-0.56l-2.75,-5.16l0.48,-1.68l-0.72,-1.78l-2.01,-2.38l-1.12,-0.53l-2.72,1.18l-1.47,-1.35l-1.57,-0.68l-2.99,0.31l-2.17,-0.3l-2.0,0.19l-1.15,0.46l-0.19,0.58l0.39,0.63l0.14,1.34l-0.84,-0.2l-0.84,0.46l-1.58,-0.07l-2.08,-1.44l-2.09,0.33l-1.91,-0.62l-3.73,0.84l-2.39,2.07l-2.54,1.22l-1.45,1.41l-0.61,1.38l0.34,3.71l-0.29,0.02l-3.5,-1.33l-1.25,-3.11l-1.44,-1.5l-2.24,-3.56l-1.76,-1.09l-2.27,-0.01l-1.71,2.07l-1.76,-0.69l-1.16,-0.74l-1.52,-2.98l-3.93,-3.16l-4.34,-0.0l-0.4,0.4l-0.0,0.74l-6.5,0.02l-9.02,-3.14l-0.34,-0.71l-5.7,0.49l-0.43,-1.29l-1.62,-1.61l-1.14,-0.38l-0.55,-0.88l-1.28,-0.13l-1.01,-0.77l-2.22,-0.27l-0.43,-0.3l-0.36,-1.58l-2.4,-2.83l-2.01,-3.85l-0.06,-0.9l-2.92,-3.26l-0.33,-2.29l-1.3,-1.66l0.52,-2.37l-0.09,-2.57l-0.78,-2.3l0.95,-2.82l0.61,-5.68l-0.47,-4.27l-1.46,-4.08l3.19,0.79l1.26,2.83l0.69,0.08l0.69,-1.14l-1.1,-4.79l68.76,-0.0l0.4,-0.4l0.14,-0.86ZM32.44,67.52l1.73,1.97l0.55,0.05l0.99,-0.79l3.65,0.24l-0.09,0.62l0.32,0.45l3.83,0.77l2.61,-0.43l5.19,1.4l4.84,0.43l1.89,0.57l3.42,-0.7l6.14,1.87l-0.03,38.06l0.38,0.4l2.39,0.11l2.31,0.98l3.9,3.99l0.55,0.04l2.4,-2.03l2.16,-1.04l1.2,1.71l3.95,3.14l4.09,6.63l4.2,2.29l0.06,1.83l-1.02,1.23l-1.16,-1.08l-2.04,-1.03l-0.67,-2.89l-3.28,-3.03l-1.65,-3.57l-6.35,-0.32l-2.82,-1.01l-5.26,-3.85l-6.77,-2.04l-3.53,0.3l-4.81,-1.69l-3.25,-1.63l-2.78,0.8l-0.28,0.46l0.44,2.21l-3.91,0.96l-2.26,1.27l-2.3,0.65l-0.27,-1.65l1.05,-3.42l2.49,-1.09l0.16,-0.6l-0.69,-0.96l-0.55,-0.1l-3.19,2.12l-1.78,2.56l-3.55,2.61l-0.04,0.61l1.56,1.52l-2.07,2.29l-5.11,2.57l-0.77,1.66l-3.76,1.77l-0.92,1.73l-2.69,1.38l-1.81,-0.22l-6.95,3.32l-3.97,0.91l4.85,-2.5l2.59,-1.86l3.26,-0.52l1.19,-1.4l3.42,-2.1l2.59,-2.27l0.42,-2.68l1.23,-2.1l-0.04,-0.46l-0.45,-0.11l-2.68,1.03l-0.63,-0.49l-0.53,0.03l-1.05,1.04l-1.36,-1.54l-0.66,0.08l-0.32,0.62l-0.58,-1.14l-0.56,-0.16l-2.41,1.42l-1.07,-0.0l-0.17,-1.75l0.3,-1.71l-1.61,-1.33l-3.41,0.59l-1.96,-1.63l-1.57,-0.84l-0.15,-2.21l-1.7,-1.43l0.82,-1.88l1.99,-2.12l0.88,-1.92l1.71,-0.24l2.04,0.51l1.87,-1.77l1.91,0.25l1.91,-1.23l0.17,-0.43l-0.47,-1.82l-1.07,-0.7l1.39,-1.17l0.12,-0.45l-0.39,-0.26l-1.65,0.07l-2.66,0.88l-0.75,0.78l-1.92,-0.8l-3.46,0.44l-3.44,-0.91l-1.06,-1.61l-2.65,-1.99l2.91,-1.43l5.5,-2.0l1.52,0.0l-0.26,1.62l0.41,0.46l5.29,-0.16l0.3,-0.65l-2.03,-2.59l-3.14,-1.68l-1.79,-2.12l-2.4,-1.83l-3.09,-1.24l1.04,-1.69l4.23,-0.14l3.36,-2.07l0.73,-2.27l2.39,-1.99l2.42,-0.52l4.65,-1.97l2.46,0.23l3.71,-2.35l3.5,0.89ZM37.6,123.41l-2.25,1.23l-0.95,-0.69l-0.29,-1.24l3.21,-1.63l1.42,0.21l0.67,0.7l-1.8,1.42ZM31.06,234.03l0.98,0.47l0.74,0.87l-1.77,1.07l-0.44,-1.53l0.49,-0.89ZM29.34,232.07l0.18,0.05l0.08,0.05l-0.16,0.03l-0.11,-0.14ZM25.16,230.17l0.05,-0.03l0.18,0.22l-0.13,-0.01l-0.1,-0.18ZM5.89,113.26l-1.08,0.41l-2.21,-1.12l1.53,-0.4l1.62,0.28l0.14,0.83Z",name:"United States"},UY:{path:"M286.85,372.74l-0.92,1.5l-2.59,1.44l-1.69,-0.52l-1.42,0.26l-2.39,-1.19l-1.52,0.08l-1.27,-1.3l0.16,-1.5l0.56,-0.79l-0.02,-2.73l1.21,-4.74l1.19,-0.21l2.37,2.0l1.08,0.03l4.36,3.17l1.22,1.6l-0.96,1.5l0.61,1.4Z",name:"Uruguay"},LB:{path:"M510.37,198.01l-0.88,0.51l1.82,-3.54l0.62,0.08l0.22,0.61l-1.13,0.88l-0.65,1.47Z",name:"Lebanon"},LA:{path:"M689.54,248.53l-1.76,-0.74l-0.49,0.15l-0.94,1.46l-1.32,-0.64l0.62,-0.98l0.11,-2.17l-2.04,-2.42l-0.25,-2.65l-1.9,-2.1l-2.15,-0.31l-0.78,0.91l-1.12,0.06l-1.05,-0.4l-2.06,1.2l-0.04,-1.59l0.61,-2.68l-0.36,-0.49l-1.35,-0.1l-0.11,-1.23l-0.96,-0.88l1.96,-1.89l0.39,0.36l1.33,0.07l0.42,-0.45l-0.34,-2.66l0.7,-0.21l1.28,1.81l1.11,2.35l0.36,0.23l2.82,0.02l0.71,1.67l-1.39,0.65l-0.72,0.93l0.13,0.6l2.91,1.51l3.6,5.25l1.88,1.78l0.56,1.62l-0.35,1.96Z",name:"Lao PDR"},TW:{path:"M724.01,226.68l-0.74,1.48l-0.9,-1.52l-0.25,-1.74l1.38,-2.44l1.73,-1.74l0.64,0.44l-1.85,5.52Z",name:"Taiwan"},TT:{path:"M266.64,259.32l0.28,-1.16l1.13,-0.22l-0.06,1.2l-1.35,0.18Z",name:"Trinidad and Tobago"},TR:{path:"M513.21,175.47l3.64,1.17l3.05,-0.44l2.1,0.26l3.11,-1.56l2.46,-0.13l2.19,1.33l0.33,0.82l-0.22,1.33l0.25,0.44l2.28,1.13l-1.17,0.57l-0.21,0.45l0.75,3.2l-0.41,1.16l1.13,1.92l-0.55,0.22l-0.9,-0.67l-2.91,-0.37l-1.24,0.46l-4.23,0.41l-2.81,1.05l-1.91,0.01l-1.52,-0.53l-2.58,0.75l-0.66,-0.45l-0.62,0.3l-0.12,1.45l-0.89,0.84l-0.47,-0.67l0.79,-1.3l-0.41,-0.2l-1.43,0.23l-2.0,-0.63l-2.02,1.65l-3.51,0.3l-2.13,-1.53l-2.7,-0.1l-0.86,1.24l-1.38,0.27l-2.29,-1.44l-2.71,-0.01l-1.37,-2.65l-1.68,-1.52l1.07,-1.99l-0.09,-0.49l-1.27,-1.12l2.37,-2.41l3.7,-0.11l1.28,-2.24l4.49,0.37l3.21,-1.97l2.81,-0.82l3.99,-0.06l4.29,2.07ZM488.79,176.72l-1.72,1.31l-0.5,-0.88l1.37,-2.57l-0.7,-0.85l1.7,-0.63l1.8,0.34l0.46,1.17l1.76,0.78l-2.87,0.32l-1.3,1.01Z",name:"Turkey"},LK:{path:"M624.16,268.99l-1.82,0.48l-0.99,-1.67l-0.42,-3.46l0.95,-3.43l1.21,0.98l2.26,4.19l-0.34,2.33l-0.85,0.58Z",name:"Sri Lanka"},LV:{path:"M489.16,122.85l0.96,0.66l0.22,1.65l0.68,1.76l-3.65,1.7l-2.23,-1.58l-1.29,-0.26l-0.68,-0.77l-2.42,0.34l-4.16,-0.23l-2.47,0.9l0.06,-1.98l1.13,-2.06l1.95,-1.02l2.12,2.58l2.01,-0.07l0.38,-0.33l0.44,-2.52l1.76,-0.53l3.06,1.7l2.15,0.07Z",name:"Latvia"},LT:{path:"M486.93,129.3l0.17,1.12l-1.81,0.98l-0.72,2.02l-2.47,1.18l-2.1,-0.02l-0.73,-1.05l-1.06,-0.3l-0.09,-1.87l-3.56,-1.13l-0.43,-2.36l2.48,-0.94l4.12,0.22l2.25,-0.31l0.52,0.69l1.24,0.21l2.19,1.56Z",name:"Lithuania"},LU:{path:"M436.08,149.45l-0.48,-0.07l0.3,-1.28l0.27,0.4l-0.09,0.96Z",name:"Luxembourg"},LR:{path:"M399.36,265.97l0.18,1.54l-0.48,0.99l0.08,0.47l2.47,1.8l-0.33,2.8l-2.65,-1.13l-5.78,-4.61l0.58,-1.32l2.1,-2.33l0.86,-0.22l0.77,1.14l-0.14,0.85l0.59,0.87l1.0,0.14l0.76,-0.99Z",name:"Liberia"},LS:{path:"M491.06,363.48l-0.49,0.15l-1.49,-1.67l1.1,-1.43l2.19,-1.44l1.51,1.27l-0.98,1.82l-1.23,0.38l-0.62,0.93Z",name:"Lesotho"},TH:{path:"M670.27,255.86l-1.41,3.87l0.15,2.0l0.38,0.36l1.38,0.07l0.9,2.04l0.55,2.34l1.4,1.44l1.61,0.38l0.96,0.97l-0.5,0.64l-1.1,0.2l-0.34,-1.18l-2.04,-1.1l-0.63,0.23l-0.63,-0.62l-0.48,-1.3l-2.56,-2.63l-0.73,0.41l0.95,-3.89l2.16,-4.22ZM670.67,254.77l-0.92,-2.18l-0.26,-2.61l-2.14,-3.06l0.71,-0.49l0.89,-2.59l-3.61,-5.45l0.87,-0.51l1.05,-2.58l1.74,-0.18l2.6,-1.59l0.76,0.56l0.13,1.39l0.37,0.36l1.23,0.09l-0.51,2.28l0.05,2.42l0.6,0.34l2.43,-1.42l0.77,0.39l1.47,-0.07l0.71,-0.88l1.48,0.14l1.71,1.88l0.25,2.65l1.92,2.11l-0.1,1.89l-0.61,0.86l-2.22,-0.33l-3.5,0.64l-1.6,2.12l0.36,2.58l-1.51,-0.79l-1.84,-0.01l0.28,-1.52l-0.4,-0.47l-2.21,0.01l-0.4,0.37l-0.19,2.74l-0.34,0.93Z",name:"Thailand"},TF:{path:"M596.68,420.38l-3.2,0.18l-0.05,-1.26l0.39,-1.41l1.3,0.78l2.08,0.35l-0.52,1.36Z",name:"Fr. S. Antarctic Lands"},TG:{path:"M422.7,257.63l-0.09,1.23l1.53,1.52l0.08,1.09l0.5,0.65l-0.11,5.62l0.49,1.47l-1.31,0.35l-1.02,-2.13l-0.18,-1.12l0.53,-2.19l-0.63,-1.16l-0.22,-3.68l-1.01,-1.4l0.07,-0.28l1.37,0.03Z",name:"Togo"},TD:{path:"M480.25,235.49l0.12,9.57l-2.1,0.05l-1.14,1.89l-0.69,1.63l0.34,0.73l-0.66,0.91l0.24,0.89l-0.86,1.95l0.45,0.5l0.6,-0.1l0.34,0.64l0.03,1.38l0.9,1.04l-1.45,0.43l-1.27,1.03l-1.83,2.76l-2.16,1.07l-2.31,-0.15l-0.86,0.25l-0.26,0.49l0.17,0.61l-2.11,1.68l-2.85,0.87l-1.09,-0.57l-0.73,0.66l-1.12,0.1l-1.1,-3.12l-1.25,-0.64l-1.22,-1.22l0.29,-0.64l3.01,0.04l0.35,-0.6l-1.3,-2.2l-0.08,-3.31l-0.97,-1.66l0.22,-1.04l-0.38,-0.48l-1.22,-0.04l0.0,-1.25l-0.98,-1.07l0.96,-3.01l3.25,-2.65l0.13,-3.33l0.95,-5.18l0.52,-1.07l-0.1,-0.48l-0.91,-0.78l-0.2,-0.96l-0.8,-0.58l-0.55,-3.65l2.1,-1.2l19.57,9.83Z",name:"Chad"},LY:{path:"M483.48,203.15l-0.75,1.1l0.29,1.39l-0.6,1.83l0.73,2.14l0.0,24.12l-2.48,0.01l-0.41,0.85l-19.41,-9.76l-4.41,2.28l-1.37,-1.33l-3.82,-1.1l-1.14,-1.65l-1.98,-1.23l-1.22,0.32l-0.66,-1.11l-0.17,-1.26l-1.28,-1.69l0.87,-1.19l-0.07,-4.34l0.43,-2.27l-0.86,-3.45l1.13,-0.76l0.22,-1.16l-0.2,-1.03l3.48,-2.61l0.29,-1.94l2.45,0.8l1.18,-0.21l1.98,0.44l3.15,1.18l1.37,2.54l5.72,1.67l2.64,1.35l1.61,-0.72l1.29,-1.34l-0.44,-2.34l0.66,-1.13l1.67,-1.21l1.57,-0.35l3.14,0.53l1.08,1.28l3.99,0.78l0.36,0.54Z",name:"Libya"},AE:{path:"M550.76,223.97l1.88,-0.4l3.84,0.02l4.78,-4.75l0.19,0.36l0.26,1.58l-0.81,0.01l-0.39,0.35l-0.08,2.04l-0.81,0.63l-0.01,0.96l-0.66,0.99l-0.39,1.41l-7.08,-1.25l-0.7,-1.96Z",name:"United Arab Emirates"},VE:{path:"M240.68,256.69l0.53,0.75l-0.02,1.06l-1.07,1.78l0.95,2.0l0.42,0.22l1.4,-0.44l0.56,-1.83l-0.77,-1.17l-0.1,-1.47l2.82,-0.93l0.26,-0.49l-0.28,-0.96l0.3,-0.28l0.66,1.31l1.96,0.26l1.4,1.22l0.08,0.68l0.39,0.35l4.81,-0.22l1.49,1.11l1.92,0.31l1.67,-0.84l0.22,-0.6l3.44,-0.14l-0.17,0.55l0.86,1.19l2.19,0.35l1.67,1.1l0.37,1.86l0.41,0.32l1.55,0.17l-1.66,1.35l-0.22,0.92l0.65,0.97l-1.67,0.54l-0.3,0.4l0.04,0.99l-0.56,0.57l-0.01,0.55l1.85,2.27l-0.66,0.69l-4.47,1.29l-0.72,0.54l-3.69,-0.9l-0.71,0.27l-0.02,0.7l0.91,0.53l-0.08,1.54l0.35,1.58l0.35,0.31l1.66,0.17l-1.3,0.52l-0.48,1.13l-2.68,0.91l-0.6,0.77l-1.57,0.13l-1.17,-1.13l-0.8,-2.52l-1.25,-1.26l1.02,-1.23l-1.29,-2.95l0.18,-1.62l1.0,-2.21l-0.2,-0.49l-1.14,-0.46l-4.02,0.36l-1.82,-2.1l-1.57,-0.33l-2.99,0.22l-1.06,-0.97l0.25,-1.23l-0.2,-1.01l-0.59,-0.69l-0.29,-1.06l-1.08,-0.39l0.78,-2.79l1.9,-2.11Z",name:"Venezuela"},AF:{path:"M600.7,188.88l-1.57,1.3l-0.1,0.48l0.8,2.31l-1.09,1.04l-0.03,1.27l-0.48,0.71l-2.16,-0.08l-0.37,0.59l0.78,1.48l-1.38,0.69l-1.06,1.69l0.06,1.7l-0.65,0.52l-0.91,-0.21l-1.91,0.36l-0.48,0.77l-1.88,0.13l-1.4,1.56l-0.18,2.32l-2.91,1.02l-1.65,-0.23l-0.71,0.55l-1.41,-0.3l-2.41,0.39l-3.52,-1.17l1.96,-2.35l-0.21,-1.78l-0.3,-0.34l-1.63,-0.4l-0.19,-1.58l-0.75,-2.03l0.95,-1.36l-0.19,-0.6l-0.73,-0.28l1.47,-4.8l2.14,0.9l2.12,-0.36l0.74,-1.34l1.77,-0.39l1.54,-0.92l0.63,-2.31l1.87,-0.5l0.49,-0.81l0.94,0.56l2.13,0.11l2.55,0.92l1.95,-0.83l0.65,0.43l0.56,-0.13l0.69,-1.12l1.57,-0.08l0.72,-1.66l0.79,-0.74l0.8,0.39l-0.17,0.56l0.71,0.58l-0.08,2.39l1.11,0.95ZM601.37,188.71l1.73,-0.71l1.43,-1.18l4.03,0.35l-2.23,0.74l-4.95,0.8Z",name:"Afghanistan"},IQ:{path:"M530.82,187.47l0.79,0.66l1.26,-0.28l1.46,3.08l1.63,0.94l0.14,1.23l-1.22,1.05l-0.53,2.52l1.73,2.67l3.12,1.62l1.15,1.88l-0.38,1.85l0.39,0.48l0.41,-0.0l0.02,1.07l0.76,0.94l-2.47,-0.1l-1.71,2.44l-4.31,-0.2l-7.02,-5.48l-3.73,-1.94l-2.88,-0.73l-0.85,-2.87l5.45,-3.02l0.95,-3.43l-0.19,-1.96l1.27,-0.7l1.22,-1.7l0.87,-0.36l2.69,0.34Z",name:"Iraq"},IS:{path:"M384.14,88.06l-0.37,2.61l2.54,2.51l-2.9,2.75l-9.19,3.4l-9.25,-1.66l1.7,-1.22l-0.1,-0.7l-4.05,-1.47l2.96,-0.53l0.33,-0.43l-0.11,-1.2l-0.33,-0.36l-4.67,-0.85l1.28,-2.04l3.45,-0.56l3.77,2.72l0.44,0.02l3.64,-2.16l3.3,1.08l3.98,-2.16l3.58,0.26Z",name:"Iceland"},IR:{path:"M533.43,187.16l-1.27,-2.15l0.42,-0.98l-0.71,-3.04l1.03,-0.5l0.33,0.83l1.26,1.35l2.05,0.51l1.11,-0.16l2.89,-2.11l0.62,-0.14l0.39,0.46l-0.72,1.2l0.06,0.49l1.56,1.53l0.65,0.04l0.67,1.81l2.56,0.83l1.87,1.48l3.69,0.49l3.91,-0.76l0.47,-0.73l2.17,-0.6l1.66,-1.54l1.51,0.08l1.18,-0.53l1.59,0.24l2.83,1.48l1.88,0.3l2.77,2.47l1.77,0.18l0.18,1.99l-1.68,5.49l0.24,0.5l0.61,0.23l-0.82,1.48l0.8,2.18l0.19,1.71l0.3,0.34l1.63,0.4l0.15,1.32l-2.15,2.35l-0.01,0.53l2.21,3.03l2.34,1.24l0.06,2.14l1.24,0.72l0.11,0.69l-3.31,1.27l-1.08,3.03l-9.68,-1.68l-0.99,-3.05l-1.43,-0.73l-2.17,0.46l-2.47,1.26l-2.83,-0.82l-2.46,-2.02l-2.41,-0.8l-3.42,-6.06l-0.48,-0.2l-1.18,0.39l-1.44,-0.82l-0.5,0.08l-0.65,0.74l-0.97,-1.01l-0.02,-1.31l-0.71,-0.39l0.26,-1.81l-1.29,-2.11l-3.13,-1.63l-1.58,-2.43l0.5,-1.9l1.31,-1.26l-0.19,-1.66l-1.74,-1.1l-1.57,-3.3Z",name:"Iran"},AM:{path:"M536.99,182.33l-0.28,0.03l-1.23,-2.13l-0.93,0.01l-0.62,-0.66l-0.69,-0.07l-0.96,-0.81l-1.56,-0.62l0.19,-1.12l-0.26,-0.79l2.72,-0.36l1.09,1.01l-0.17,0.92l1.02,0.78l-0.47,0.62l0.08,0.56l2.04,1.23l0.04,1.4Z",name:"Armenia"},AL:{path:"M470.32,171.8l0.74,0.03l0.92,0.89l-0.17,1.95l0.36,1.28l1.01,0.82l-1.82,2.83l-0.19,-0.61l-1.25,-0.89l-0.18,-1.2l0.53,-2.82l-0.54,-1.47l0.6,-0.83Z",name:"Albania"},AO:{path:"M461.55,300.03l1.26,3.15l1.94,2.36l2.47,-0.53l1.25,0.32l0.44,-0.18l0.93,-1.92l1.31,-0.08l0.41,-0.44l0.47,-0.0l-0.1,0.41l0.39,0.49l2.65,-0.02l0.03,1.19l0.48,1.01l-0.34,1.52l0.18,1.55l0.83,1.04l-0.13,2.85l0.54,0.39l3.96,-0.41l-0.1,1.79l0.39,1.05l-0.24,1.43l-4.7,-0.03l-0.4,0.39l-0.12,8.13l2.92,3.49l-3.83,0.88l-5.89,-0.36l-1.88,-1.24l-10.47,0.22l-1.3,-1.01l-1.85,-0.16l-2.4,0.77l-0.15,-1.06l0.33,-2.16l1.0,-3.45l1.35,-3.2l2.24,-2.8l0.33,-2.06l-0.13,-1.53l-0.8,-1.08l-1.21,-2.87l0.87,-1.62l-1.27,-4.12l-1.17,-1.53l2.47,-0.63l7.03,0.03ZM451.71,298.87l-0.47,-1.25l1.25,-1.11l0.32,0.3l-0.99,1.03l-0.12,1.03Z",name:"Angola"},AR:{path:"M249.29,428.93l-2.33,-0.52l-5.83,-0.43l-0.89,-1.66l0.05,-2.37l-0.45,-0.4l-1.43,0.18l-0.67,-0.91l-0.2,-3.13l1.88,-1.47l0.79,-2.04l-0.25,-1.7l1.3,-2.68l0.91,-4.15l-0.22,-1.69l0.85,-0.45l0.2,-0.44l-0.27,-1.16l-0.98,-0.68l0.59,-0.92l-0.05,-0.5l-1.04,-1.07l-0.52,-3.1l0.97,-0.86l-0.42,-3.58l1.2,-5.43l1.38,-0.98l0.16,-0.43l-0.75,-2.79l-0.01,-2.43l1.78,-1.75l0.06,-2.57l1.43,-2.85l0.01,-2.58l-0.69,-0.74l-1.09,-4.52l1.47,-2.7l-0.18,-2.79l0.85,-2.35l1.59,-2.46l1.73,-1.64l0.05,-0.52l-0.6,-0.84l0.44,-0.85l-0.07,-4.19l2.7,-1.44l0.86,-2.75l-0.21,-0.71l1.76,-2.01l2.9,0.57l1.38,1.78l0.68,-0.08l0.87,-1.87l2.39,0.09l4.95,4.77l2.17,0.49l3.0,1.92l2.47,1.0l0.25,0.82l-2.37,3.93l0.23,0.59l5.39,1.16l2.12,-0.44l2.45,-2.16l0.5,-2.38l0.76,-0.31l0.98,1.2l-0.04,1.8l-3.67,2.51l-2.85,2.66l-3.43,3.88l-1.3,5.07l0.01,2.72l-0.54,0.73l-0.36,3.28l3.14,2.64l-0.16,2.11l1.4,1.11l-0.1,1.09l-2.29,3.52l-3.55,1.49l-4.92,0.6l-2.71,-0.29l-0.43,0.51l0.5,1.65l-0.49,2.1l0.38,1.42l-1.19,0.83l-2.36,0.38l-2.3,-1.04l-1.38,0.83l0.41,3.64l1.69,0.91l1.4,-0.71l0.36,0.76l-2.04,0.86l-2.01,1.89l-0.97,4.63l-2.34,0.1l-2.09,1.78l-0.61,2.75l2.46,2.31l2.17,0.63l-0.7,2.32l-2.83,1.73l-1.73,3.86l-2.17,1.22l-1.16,1.67l0.75,3.76l1.04,1.28ZM256.71,438.88l-2.0,0.15l-1.4,-1.22l-3.82,-0.1l-0.0,-5.83l1.6,3.05l3.26,2.07l3.08,0.78l-0.71,1.1Z",name:"Argentina"},AU:{path:"M705.8,353.26l0.26,0.04l0.17,-0.47l-0.48,-1.42l0.92,1.11l0.45,0.15l0.27,-0.39l-0.1,-1.56l-1.98,-3.63l1.09,-3.31l-0.24,-1.57l0.34,-0.62l0.38,1.06l0.43,-0.19l0.99,-1.7l1.91,-0.83l1.29,-1.15l1.81,-0.91l0.96,-0.17l0.92,0.26l1.92,-0.95l1.47,-0.28l1.03,-0.8l1.43,0.04l2.78,-0.84l1.36,-1.15l0.71,-1.45l1.41,-1.26l0.3,-2.58l1.27,-1.59l0.78,1.65l0.54,0.19l1.07,-0.51l0.15,-0.6l-0.73,-1.0l0.45,-0.71l0.78,0.39l0.58,-0.3l0.28,-1.82l1.87,-2.14l1.12,-0.39l0.28,-0.58l0.62,0.17l0.53,-0.73l1.87,-0.57l1.65,1.05l1.35,1.48l3.39,0.38l0.43,-0.54l-0.46,-1.23l1.05,-1.79l1.04,-0.61l0.14,-0.55l-0.25,-0.41l0.88,-1.17l1.31,-0.77l1.3,0.27l2.1,-0.48l0.31,-0.4l-0.05,-1.3l-0.92,-0.77l1.48,0.56l1.41,1.07l2.11,0.65l0.81,-0.2l1.4,0.7l1.69,-0.66l0.8,0.19l0.64,-0.33l0.71,0.77l-1.33,1.94l-0.71,0.07l-0.35,0.51l0.24,0.86l-1.52,2.35l0.12,1.05l2.15,1.65l1.97,0.85l3.04,2.36l1.97,0.65l0.55,0.88l2.72,0.85l1.84,-1.1l2.07,-5.97l-0.42,-3.59l0.3,-1.73l0.47,-0.87l-0.31,-0.68l1.09,-3.28l0.46,-0.47l0.4,0.71l0.16,1.51l0.65,0.52l0.16,1.04l0.85,1.21l0.12,2.38l0.9,2.0l0.57,0.18l1.3,-0.78l1.69,1.7l-0.2,1.08l0.53,2.2l0.39,1.3l0.68,0.48l0.6,1.95l-0.19,1.48l0.81,1.76l6.01,3.69l-0.11,0.76l1.38,1.58l0.95,2.77l0.58,0.22l0.72,-0.41l0.8,0.9l0.61,0.01l0.46,2.41l4.81,4.71l0.66,2.02l-0.07,3.31l1.14,2.2l-0.13,2.24l-1.1,3.68l0.03,1.64l-0.47,1.89l-1.05,2.4l-1.9,1.47l-1.72,3.51l-2.38,6.09l-0.24,2.82l-1.14,0.8l-2.85,0.15l-2.31,1.19l-2.51,2.25l-3.09,-1.57l0.3,-1.15l-0.54,-0.47l-1.5,0.63l-2.01,1.94l-7.12,-2.18l-1.48,-1.63l-1.14,-3.74l-1.45,-1.26l-1.81,-0.26l0.56,-1.18l-0.61,-2.1l-0.72,-0.1l-1.14,1.82l-0.9,0.21l0.63,-0.82l0.36,-1.55l0.92,-1.31l-0.13,-2.34l-0.7,-0.22l-2.0,2.34l-1.51,0.93l-0.94,2.01l-1.35,-0.81l-0.02,-1.52l-1.57,-2.04l-1.09,-0.88l0.24,-0.33l-0.14,-0.59l-3.21,-1.69l-1.83,-0.12l-2.54,-1.35l-4.58,0.28l-6.02,1.9l-2.53,-0.13l-2.62,1.41l-2.13,0.63l-1.49,2.6l-3.49,0.31l-2.29,-0.5l-3.48,0.43l-1.6,1.47l-0.81,-0.04l-2.37,1.63l-3.26,-0.1l-3.72,-2.21l0.04,-1.05l1.19,-0.46l0.49,-0.89l0.21,-2.97l-0.28,-1.64l-1.34,-2.86l-0.38,-1.47l0.05,-1.72l-0.95,-1.7l-0.18,-0.97l-1.01,-0.99l-0.29,-1.98l-1.13,-1.75ZM784.92,393.44l2.65,1.02l3.23,-0.96l1.09,0.14l0.15,3.06l-0.85,1.13l-0.17,1.63l-0.87,-0.24l-1.57,1.91l-1.68,-0.18l-1.4,-2.36l-0.37,-2.04l-1.39,-2.51l0.04,-0.8l1.15,0.18Z",name:"Australia"},AT:{path:"M462.89,152.8l0.04,2.25l-1.07,0.0l-0.33,0.63l0.36,0.51l-1.04,2.13l-2.02,0.07l-1.33,0.7l-5.29,-0.99l-0.47,-0.93l-0.44,-0.21l-2.47,0.55l-0.42,0.51l-3.18,-0.81l0.43,-0.91l1.12,0.78l0.6,-0.17l0.25,-0.58l1.93,0.12l1.86,-0.56l1.0,0.08l0.68,0.57l0.62,-0.15l0.26,-0.77l-0.3,-1.78l0.8,-0.44l0.68,-1.15l1.52,0.85l0.47,-0.06l1.34,-1.25l0.64,-0.17l1.81,0.92l1.28,-0.11l0.7,0.37Z",name:"Austria"},IN:{path:"M623.34,207.03l-1.24,1.04l-0.97,2.55l0.22,0.51l8.04,3.87l3.42,0.37l1.57,1.38l4.92,0.88l2.18,-0.04l0.38,-0.3l0.29,-1.24l-0.32,-1.64l0.14,-0.87l0.82,-0.31l0.45,2.48l2.28,1.02l1.77,-0.38l4.14,0.1l0.38,-0.36l0.18,-1.66l-0.5,-0.65l1.37,-0.29l2.25,-1.99l2.7,-1.62l1.93,0.62l1.8,-0.98l0.79,1.14l-0.68,0.91l0.26,0.63l2.42,0.36l0.09,0.47l-0.83,0.75l0.13,1.07l-1.52,-0.29l-3.24,1.86l-0.13,1.78l-1.32,2.14l-0.18,1.39l-0.93,1.82l-1.64,-0.5l-0.52,0.37l-0.09,2.63l-0.56,1.11l0.19,0.81l-0.53,0.27l-1.18,-3.73l-1.08,-0.27l-0.38,0.31l-0.24,1.0l-0.66,-0.66l0.54,-1.06l1.22,-0.34l1.15,-2.25l-0.24,-0.56l-1.57,-0.47l-4.34,-0.28l-0.18,-1.56l-0.35,-0.35l-1.11,-0.12l-1.91,-1.12l-0.56,0.17l-0.88,1.82l0.11,0.49l1.36,1.07l-1.09,0.69l-0.69,1.11l0.18,0.56l1.24,0.57l-0.32,1.54l0.85,1.94l0.36,2.01l-0.22,0.59l-4.58,0.52l-0.33,0.42l0.13,1.8l-1.17,1.36l-3.65,1.81l-2.79,3.03l-4.32,3.28l-0.18,1.27l-4.65,1.79l-0.77,2.16l0.64,5.3l-1.06,2.49l-0.01,3.94l-1.24,0.28l-1.14,1.93l0.39,0.84l-1.68,0.53l-1.04,1.83l-0.65,0.47l-2.06,-2.05l-2.1,-6.02l-2.2,-3.64l-1.05,-4.75l-2.29,-3.57l-1.76,-8.2l0.01,-3.11l-0.49,-2.53l-0.55,-0.29l-3.53,1.52l-1.53,-0.27l-2.86,-2.77l0.85,-0.67l0.08,-0.55l-0.74,-1.03l-2.67,-2.06l1.24,-1.32l5.34,0.01l0.39,-0.49l-0.5,-2.29l-1.42,-1.46l-0.27,-1.93l-1.43,-1.2l2.31,-2.37l3.05,0.06l2.62,-2.85l1.6,-2.81l2.4,-2.73l0.07,-2.04l1.97,-1.48l-0.02,-0.65l-1.93,-1.31l-0.82,-1.78l-0.8,-2.21l0.9,-0.89l3.59,0.65l2.92,-0.42l2.33,-2.19l2.31,2.85l-0.24,2.13l0.99,1.59l-0.05,0.82l-1.34,-0.28l-0.47,0.48l0.7,3.06l2.62,1.99l2.99,1.65Z",name:"India"},TZ:{path:"M495.56,296.42l2.8,-3.12l-0.02,-0.81l-0.64,-1.3l0.68,-0.52l0.14,-1.47l-0.76,-1.25l0.31,-0.11l2.26,0.03l-0.51,2.76l0.76,1.3l0.5,0.12l1.05,-0.53l1.19,-0.12l0.61,0.24l1.43,-0.62l0.1,-0.67l-0.71,-0.62l1.57,-1.7l8.65,4.86l0.32,1.53l3.34,2.33l-1.05,2.8l0.13,1.61l1.63,1.12l-0.6,1.76l-0.01,2.33l1.89,4.03l0.57,0.43l-1.46,1.08l-2.61,0.94l-1.43,-0.04l-1.06,0.77l-2.29,0.36l-2.87,-0.68l-0.83,0.07l-0.63,-0.75l-0.31,-2.78l-1.32,-1.35l-3.25,-0.77l-3.96,-1.58l-1.18,-2.41l-0.32,-1.75l-1.76,-1.49l0.42,-1.05l-0.44,-0.89l0.08,-0.96l-0.46,-0.58l0.06,-0.56Z",name:"Tanzania"},AZ:{path:"M539.29,175.73l1.33,0.32l1.94,-1.8l2.3,3.34l1.43,0.43l-1.26,0.15l-0.35,0.32l-0.8,3.14l-0.99,0.96l0.05,1.11l-1.26,-1.13l0.7,-1.18l-0.04,-0.47l-0.74,-0.86l-1.48,0.15l-2.34,1.71l-0.03,-1.27l-2.03,-1.35l0.47,-0.62l-0.08,-0.56l-1.03,-0.79l0.29,-0.43l-0.14,-0.58l-1.13,-0.86l1.89,0.68l1.69,0.06l0.37,-0.87l-0.81,-1.37l0.42,0.06l1.63,1.72ZM533.78,180.57l0.61,0.46l0.69,-0.0l0.59,1.15l-0.68,-0.15l-1.21,-1.45Z",name:"Azerbaijan"},IE:{path:"M405.08,135.42l0.35,2.06l-1.75,2.78l-4.22,1.88l-2.84,-0.4l1.73,-3.0l-1.18,-3.53l4.6,-3.74l0.32,1.15l-0.49,1.74l0.4,0.51l1.47,-0.04l1.6,0.6Z",name:"Ireland"},ID:{path:"M756.47,287.89l0.69,4.01l2.79,1.78l0.51,-0.1l2.04,-2.59l2.71,-1.43l2.05,-0.0l3.9,1.73l2.46,0.45l0.08,15.12l-1.75,-1.54l-2.54,-0.51l-0.88,0.71l-2.32,0.06l0.69,-1.33l1.45,-0.64l0.23,-0.46l-0.65,-2.74l-1.24,-2.21l-5.04,-2.29l-2.09,-0.23l-3.68,-2.27l-0.55,0.13l-0.65,1.07l-0.52,0.12l-0.55,-1.89l-1.21,-0.78l1.84,-0.62l1.72,0.05l0.39,-0.52l-0.21,-0.66l-0.38,-0.28l-3.45,-0.0l-1.13,-1.48l-2.1,-0.43l-0.52,-0.6l2.69,-0.48l1.28,-0.78l3.66,0.94l0.3,0.71ZM757.91,300.34l-0.62,0.82l-0.1,-0.8l0.59,-1.12l0.13,1.1ZM747.38,292.98l0.34,0.72l-1.22,-0.57l-4.68,-0.1l0.27,-0.62l2.78,-0.09l2.52,0.67ZM741.05,285.25l-0.67,-2.88l0.64,-2.01l0.41,0.86l1.21,0.18l0.16,0.7l-0.1,1.68l-0.84,-0.16l-0.46,0.3l-0.34,1.34ZM739.05,293.5l-0.5,0.44l-1.34,-0.36l-0.17,-0.37l1.73,-0.08l0.27,0.36ZM721.45,284.51l-0.19,1.97l2.24,2.23l0.54,0.02l1.27,-1.07l2.75,-0.5l-0.9,1.21l-2.11,0.93l-0.16,0.6l2.22,3.01l-0.3,1.07l1.36,1.74l-2.26,0.85l-0.28,-0.31l0.12,-1.19l-1.64,-1.34l0.17,-2.23l-0.56,-0.39l-1.67,0.76l-0.23,0.39l0.3,6.17l-1.1,0.25l-0.69,-0.47l0.64,-2.21l-0.39,-2.42l-0.39,-0.34l-0.8,-0.01l-0.58,-1.29l0.98,-1.6l0.35,-1.96l1.32,-3.87ZM728.59,296.27l0.38,0.49l-0.02,1.28l-0.88,0.49l-0.53,-0.47l1.04,-1.79ZM729.04,286.98l0.27,-0.05l-0.02,0.13l-0.24,-0.08ZM721.68,284.05l0.16,-0.32l1.89,-1.65l1.83,0.68l3.16,0.35l2.94,-0.1l2.39,-1.66l-1.73,2.13l-1.66,0.43l-2.41,-0.48l-4.17,0.13l-2.39,0.51ZM730.55,310.47l1.11,-1.93l2.03,-0.82l0.08,0.62l-1.45,1.67l-1.77,0.46ZM728.12,305.88l-0.1,0.38l-3.46,0.66l-2.91,-0.27l-0.0,-0.25l1.54,-0.41l1.66,0.73l1.67,-0.19l1.61,-0.65ZM722.9,310.24l-0.64,0.03l-2.26,-1.2l1.11,-0.24l1.78,1.41ZM716.26,305.77l0.88,0.51l1.28,-0.17l0.2,0.35l-4.65,0.73l0.39,-0.67l1.15,-0.02l0.75,-0.73ZM711.66,293.84l-0.38,-0.16l-2.54,1.01l-1.12,-1.44l-1.69,-0.13l-1.16,-0.75l-3.04,0.77l-1.1,-1.15l-3.31,-0.11l-0.35,-3.05l-1.35,-0.95l-1.11,-1.98l-0.33,-2.06l0.27,-2.14l0.9,-1.01l0.37,1.15l2.09,1.49l1.53,-0.48l1.82,0.08l1.38,-1.19l1.0,-0.18l2.28,0.67l2.26,-0.53l1.52,-3.64l1.01,-0.99l0.78,-2.57l4.1,0.3l-1.11,1.77l0.02,0.46l1.7,2.2l-0.23,1.39l2.07,1.71l-2.33,0.42l-0.88,1.9l0.1,2.05l-2.4,1.9l-0.06,2.45l-0.7,2.79ZM692.58,302.03l0.35,0.26l4.8,0.25l0.78,-0.97l4.17,1.09l1.13,1.68l3.69,0.45l2.13,1.04l-1.8,0.6l-2.77,-0.99l-4.8,-0.12l-5.24,-1.41l-1.84,-0.25l-1.11,0.3l-4.26,-0.97l-0.7,-1.14l-1.59,-0.13l1.18,-1.65l2.74,0.13l2.87,1.13l0.26,0.68ZM685.53,299.17l-2.22,0.04l-2.06,-2.03l-3.15,-2.01l-2.93,-3.51l-3.11,-5.33l-2.2,-2.12l-1.64,-4.06l-2.32,-1.69l-1.27,-2.07l-1.96,-1.5l-2.51,-2.65l-0.11,-0.66l4.81,0.53l2.15,2.38l3.31,2.74l2.35,2.66l2.7,0.17l1.95,1.59l1.54,2.17l1.59,0.95l-0.84,1.71l0.15,0.52l1.44,0.87l0.79,0.1l0.4,1.58l0.87,1.4l1.96,0.39l1.0,1.31l-0.6,3.01l-0.09,3.5Z",name:"Indonesia"},UA:{path:"M492.5,162.44l1.28,-2.49l1.82,0.19l0.66,-0.23l0.09,-0.71l-0.25,-0.75l-0.79,-0.72l-0.33,-1.21l-0.86,-0.62l-0.02,-1.19l-1.13,-0.86l-1.15,-0.19l-2.04,-1.0l-1.66,0.32l-0.66,0.47l-0.92,-0.0l-0.84,0.78l-2.48,0.7l-1.18,-0.71l-3.07,-0.36l-0.89,0.43l-0.24,-0.55l-1.11,-0.7l0.35,-0.93l1.26,-1.02l-0.54,-1.23l2.04,-2.43l1.4,-0.62l0.25,-1.19l-1.04,-2.39l0.83,-0.13l1.28,-0.84l1.8,-0.07l2.47,0.26l2.86,0.81l1.88,0.06l0.86,0.44l1.04,-0.41l0.77,0.66l2.18,-0.15l0.92,0.3l0.52,-0.34l0.15,-1.53l0.56,-0.54l2.85,-0.05l0.84,-0.72l3.04,-0.18l1.23,1.46l-0.48,0.77l0.21,1.03l0.36,0.32l1.8,0.14l0.93,2.08l3.18,1.15l1.94,-0.45l1.67,1.49l1.4,-0.03l3.35,0.96l0.02,0.54l-0.96,1.59l0.47,1.97l-0.26,0.7l-2.36,0.28l-1.29,0.89l-0.23,1.38l-1.83,0.27l-1.58,0.97l-2.41,0.21l-2.16,1.17l-0.21,0.38l0.34,2.26l1.23,0.75l2.13,-0.08l-0.14,0.31l-2.65,0.53l-3.23,1.69l-0.87,-0.39l0.42,-1.1l-0.25,-0.52l-2.21,-0.73l2.35,-1.06l0.12,-0.65l-0.93,-0.82l-3.62,-0.74l-0.13,-0.89l-0.46,-0.34l-2.61,0.59l-0.91,1.69l-1.71,2.04l-0.86,-0.4l-1.62,0.27Z",name:"Ukraine"},QA:{path:"M549.33,221.64l-0.76,-0.23l-0.14,-1.64l0.84,-1.29l0.47,0.52l0.04,1.34l-0.45,1.3Z",name:"Qatar"},MZ:{path:"M508.58,318.75l-0.34,-2.57l0.51,-2.05l3.55,0.63l2.5,-0.38l1.02,-0.76l1.49,0.01l2.74,-0.98l1.66,-1.2l0.5,9.24l0.41,1.23l-0.68,1.67l-0.93,1.71l-1.5,1.5l-5.16,2.28l-2.78,2.73l-1.02,0.53l-1.71,1.8l-0.98,0.57l-0.35,2.41l1.16,1.94l0.49,2.17l0.43,0.31l-0.06,2.06l-0.39,1.17l0.5,0.72l-0.25,0.73l-0.92,0.83l-5.12,2.39l-1.22,1.36l0.21,1.13l0.58,0.39l-0.11,0.72l-1.22,-0.01l-0.73,-2.97l0.42,-3.09l-1.78,-5.37l2.49,-2.81l0.69,-1.89l0.44,-0.43l0.28,-1.53l-0.39,-0.93l0.59,-3.65l-0.01,-3.26l-1.49,-1.16l-1.2,-0.22l-1.74,-1.17l-1.92,0.01l-0.29,-2.08l7.06,-1.96l1.28,1.09l0.89,-0.1l0.67,0.44l0.1,0.73l-0.51,1.29l0.19,1.81l1.75,1.83l0.65,-0.13l0.71,-1.65l1.17,-0.86l-0.26,-3.47l-1.05,-1.85l-1.04,-0.94Z",name:"Mozambique"}},height:440.7063107441331,projection:{type:"mill",centralMeridian:11.5},width:900})}).call(e,t(0))},function(l,e,t){t(0),t(34),l.exports=t(35)},function(l,e,t){(function(a,n){var i,c,r;!function(l){var e={set:{colors:1,values:1,backgroundColor:1,scaleColors:1,normalizeFunction:1,focus:1},get:{selectedRegions:1,selectedMarkers:1,mapObject:1,regionName:1}};l.fn.vectorMap=function(l){var t,a,t=this.children(".jvectormap-container").data("mapObject");if("addMap"===l)o.Map.maps[arguments[1]]=arguments[2];else{if(("set"===l||"get"===l)&&e[l][arguments[1]])return a=arguments[1].charAt(0).toUpperCase()+arguments[1].substr(1),t[l+a].apply(t,Array.prototype.slice.call(arguments,2));l=l||{},l.container=this,t=new o.Map(l)}return this}}(a),function(a){c=[t(0)],i=a,void 0!==(r="function"===typeof i?i.apply(e,c):i)&&(l.exports=r)}(function(l){function e(e){var c=e||window.event,r=o.call(arguments,1),s=0,h=0,p=0,M=0;if(e=l.event.fix(c),e.type="mousewheel","detail"in c&&(p=-1*c.detail),"wheelDelta"in c&&(p=c.wheelDelta),"wheelDeltaY"in c&&(p=c.wheelDeltaY),"wheelDeltaX"in c&&(h=-1*c.wheelDeltaX),"axis"in c&&c.axis===c.HORIZONTAL_AXIS&&(h=-1*p,p=0),s=0===p?h:p,"deltaY"in c&&(p=-1*c.deltaY,s=p),"deltaX"in c&&(h=c.deltaX,0===p&&(s=-1*h)),0!==p||0!==h){if(1===c.deltaMode){var u=l.data(this,"mousewheel-line-height");s*=u,p*=u,h*=u}else if(2===c.deltaMode){var Z=l.data(this,"mousewheel-page-height");s*=Z,p*=Z,h*=Z}return M=Math.max(Math.abs(p),Math.abs(h)),(!i||i>M)&&(i=M,a(c,M)&&(i/=40)),a(c,M)&&(s/=40,h/=40,p/=40),s=Math[s>=1?"floor":"ceil"](s/i),h=Math[h>=1?"floor":"ceil"](h/i),p=Math[p>=1?"floor":"ceil"](p/i),e.deltaX=h,e.deltaY=p,e.deltaFactor=i,e.deltaMode=0,r.unshift(e,s,h,p),n&&clearTimeout(n),n=setTimeout(t,200),(l.event.dispatch||l.event.handle).apply(this,r)}}function t(){i=null}function a(l,e){return h.settings.adjustOldDeltas&&"mousewheel"===l.type&&e%120===0}var n,i,c=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],r="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],o=Array.prototype.slice;if(l.event.fixHooks)for(var s=c.length;s;)l.event.fixHooks[c[--s]]=l.event.mouseHooks;var h=l.event.special.mousewheel={version:"3.1.9",setup:function(){if(this.addEventListener)for(var t=r.length;t;)this.addEventListener(r[--t],e,!1);else this.onmousewheel=e;l.data(this,"mousewheel-line-height",h.getLineHeight(this)),l.data(this,"mousewheel-page-height",h.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var l=r.length;l;)this.removeEventListener(r[--l],e,!1);else this.onmousewheel=null},getLineHeight:function(e){return parseInt(l(e)["offsetParent"in l.fn?"offsetParent":"parent"]().css("fontSize"),10)},getPageHeight:function(e){return l(e).height()},settings:{adjustOldDeltas:!0}};l.fn.extend({mousewheel:function(l){return l?this.bind("mousewheel",l):this.trigger("mousewheel")},unmousewheel:function(l){return this.unbind("mousewheel",l)}})});var o={inherits:function(l,e){function t(){}t.prototype=e.prototype,l.prototype=new t,l.prototype.constructor=l,l.parentClass=e},mixin:function(l,e){var t;for(t in e.prototype)e.prototype.hasOwnProperty(t)&&(l.prototype[t]=e.prototype[t])},min:function(l){var e,t=Number.MAX_VALUE;if(l instanceof Array)for(e=0;e<l.length;e++)l[e]<t&&(t=l[e]);else for(e in l)l[e]<t&&(t=l[e]);return t},max:function(l){var e,t=Number.MIN_VALUE;if(l instanceof Array)for(e=0;e<l.length;e++)l[e]>t&&(t=l[e]);else for(e in l)l[e]>t&&(t=l[e]);return t},keys:function(l){var e,t=[];for(e in l)t.push(e);return t},values:function(l){var e,t,a=[];for(t=0;t<arguments.length;t++){l=arguments[t];for(e in l)a.push(l[e])}return a},whenImageLoaded:function(l){var e=new o.$.Deferred,t=o.$("<img/>");return t.error(function(){e.reject()}).load(function(){e.resolve(t)}),t.attr("src",l),e},isImageUrl:function(l){return/\.\w{3,4}$/.test(l)}};o.$=a,Array.prototype.indexOf||(Array.prototype.indexOf=function(l,e){var t;if(null==this)throw new TypeError('"this" is null or not defined');var a=Object(this),n=a.length>>>0;if(0===n)return-1;var i=+e||0;if(Math.abs(i)===1/0&&(i=0),i>=n)return-1;for(t=Math.max(i>=0?i:n-Math.abs(i),0);n>t;){if(t in a&&a[t]===l)return t;t++}return-1}),o.AbstractElement=function(l,e){this.node=this.createElement(l),this.name=l,this.properties={},e&&this.set(e)},o.AbstractElement.prototype.set=function(l,e){var t;if("object"==typeof l)for(t in l)this.properties[t]=l[t],this.applyAttr(t,l[t]);else this.properties[l]=e,this.applyAttr(l,e)},o.AbstractElement.prototype.get=function(l){return this.properties[l]},o.AbstractElement.prototype.applyAttr=function(l,e){this.node.setAttribute(l,e)},o.AbstractElement.prototype.remove=function(){o.$(this.node).remove()},o.AbstractCanvasElement=function(l,e,t){this.container=l,this.setSize(e,t),this.rootElement=new o[this.classPrefix+"GroupElement"],this.node.appendChild(this.rootElement.node),this.container.appendChild(this.node)},o.AbstractCanvasElement.prototype.add=function(l,e){e=e||this.rootElement,e.add(l),l.canvas=this},o.AbstractCanvasElement.prototype.addPath=function(l,e,t){var a=new o[this.classPrefix+"PathElement"](l,e);return this.add(a,t),a},o.AbstractCanvasElement.prototype.addCircle=function(l,e,t){var a=new o[this.classPrefix+"CircleElement"](l,e);return this.add(a,t),a},o.AbstractCanvasElement.prototype.addImage=function(l,e,t){var a=new o[this.classPrefix+"ImageElement"](l,e);return this.add(a,t),a},o.AbstractCanvasElement.prototype.addText=function(l,e,t){var a=new o[this.classPrefix+"TextElement"](l,e);return this.add(a,t),a},o.AbstractCanvasElement.prototype.addGroup=function(l){var e=new o[this.classPrefix+"GroupElement"];return l?l.node.appendChild(e.node):this.node.appendChild(e.node),e.canvas=this,e},o.AbstractShapeElement=function(l,e,t){this.style=t||{},this.style.current=this.style.current||{},this.isHovered=!1,this.isSelected=!1,this.updateStyle()},o.AbstractShapeElement.prototype.setStyle=function(l,e){var t={};"object"==typeof l?t=l:t[l]=e,o.$.extend(this.style.current,t),this.updateStyle()},o.AbstractShapeElement.prototype.updateStyle=function(){var l={};o.AbstractShapeElement.mergeStyles(l,this.style.initial),o.AbstractShapeElement.mergeStyles(l,this.style.current),this.isHovered&&o.AbstractShapeElement.mergeStyles(l,this.style.hover),this.isSelected&&(o.AbstractShapeElement.mergeStyles(l,this.style.selected),this.isHovered&&o.AbstractShapeElement.mergeStyles(l,this.style.selectedHover)),this.set(l)},o.AbstractShapeElement.mergeStyles=function(l,e){var t;e=e||{};for(t in e)null===e[t]?delete l[t]:l[t]=e[t]},o.SVGElement=function(){o.SVGElement.parentClass.apply(this,arguments)},o.inherits(o.SVGElement,o.AbstractElement),o.SVGElement.svgns="http://www.w3.org/2000/svg",o.SVGElement.prototype.createElement=function(l){return document.createElementNS(o.SVGElement.svgns,l)},o.SVGElement.prototype.addClass=function(l){this.node.setAttribute("class",l)},o.SVGElement.prototype.getElementCtr=function(l){return o["SVG"+l]},o.SVGElement.prototype.getBBox=function(){return this.node.getBBox()},o.SVGGroupElement=function(){o.SVGGroupElement.parentClass.call(this,"g")},o.inherits(o.SVGGroupElement,o.SVGElement),o.SVGGroupElement.prototype.add=function(l){this.node.appendChild(l.node)},o.SVGCanvasElement=function(){this.classPrefix="SVG",o.SVGCanvasElement.parentClass.call(this,"svg"),this.defsElement=new o.SVGElement("defs"),this.node.appendChild(this.defsElement.node),o.AbstractCanvasElement.apply(this,arguments)},o.inherits(o.SVGCanvasElement,o.SVGElement),o.mixin(o.SVGCanvasElement,o.AbstractCanvasElement),o.SVGCanvasElement.prototype.setSize=function(l,e){this.width=l,this.height=e,this.node.setAttribute("width",l),this.node.setAttribute("height",e)},o.SVGCanvasElement.prototype.applyTransformParams=function(l,e,t){this.scale=l,this.transX=e,this.transY=t,this.rootElement.node.setAttribute("transform","scale("+l+") translate("+e+", "+t+")")},o.SVGShapeElement=function(l,e){o.SVGShapeElement.parentClass.call(this,l,e),o.AbstractShapeElement.apply(this,arguments)},o.inherits(o.SVGShapeElement,o.SVGElement),o.mixin(o.SVGShapeElement,o.AbstractShapeElement),o.SVGShapeElement.prototype.applyAttr=function(l,e){var t,a,n=this;"fill"===l&&o.isImageUrl(e)?o.SVGShapeElement.images[e]?this.applyAttr("fill","url(#image"+o.SVGShapeElement.images[e]+")"):o.whenImageLoaded(e).then(function(l){a=new o.SVGElement("image"),a.node.setAttributeNS("http://www.w3.org/1999/xlink","href",e),a.applyAttr("x","0"),a.applyAttr("y","0"),a.applyAttr("width",l[0].width),a.applyAttr("height",l[0].height),t=new o.SVGElement("pattern"),t.applyAttr("id","image"+o.SVGShapeElement.imageCounter),t.applyAttr("x",0),t.applyAttr("y",0),t.applyAttr("width",l[0].width/2),t.applyAttr("height",l[0].height/2),t.applyAttr("viewBox","0 0 "+l[0].width+" "+l[0].height),t.applyAttr("patternUnits","userSpaceOnUse"),t.node.appendChild(a.node),n.canvas.defsElement.node.appendChild(t.node),o.SVGShapeElement.images[e]=o.SVGShapeElement.imageCounter++,n.applyAttr("fill","url(#image"+o.SVGShapeElement.images[e]+")")}):o.SVGShapeElement.parentClass.prototype.applyAttr.apply(this,arguments)},o.SVGShapeElement.imageCounter=1,o.SVGShapeElement.images={},o.SVGPathElement=function(l,e){o.SVGPathElement.parentClass.call(this,"path",l,e),this.node.setAttribute("fill-rule","evenodd")},o.inherits(o.SVGPathElement,o.SVGShapeElement),o.SVGCircleElement=function(l,e){o.SVGCircleElement.parentClass.call(this,"circle",l,e)},o.inherits(o.SVGCircleElement,o.SVGShapeElement),o.SVGImageElement=function(l,e){o.SVGImageElement.parentClass.call(this,"image",l,e)},o.inherits(o.SVGImageElement,o.SVGShapeElement),o.SVGImageElement.prototype.applyAttr=function(l,e){var t=this;"image"==l?o.whenImageLoaded(e).then(function(l){t.node.setAttributeNS("http://www.w3.org/1999/xlink","href",e),t.width=l[0].width,t.height=l[0].height,t.applyAttr("width",t.width),t.applyAttr("height",t.height),t.applyAttr("x",t.cx-t.width/2),t.applyAttr("y",t.cy-t.height/2),o.$(t.node).trigger("imageloaded",[l])}):"cx"==l?(this.cx=e,this.width&&this.applyAttr("x",e-this.width/2)):"cy"==l?(this.cy=e,this.height&&this.applyAttr("y",e-this.height/2)):o.SVGImageElement.parentClass.prototype.applyAttr.apply(this,arguments)},o.SVGTextElement=function(l,e){o.SVGTextElement.parentClass.call(this,"text",l,e)},o.inherits(o.SVGTextElement,o.SVGShapeElement),o.SVGTextElement.prototype.applyAttr=function(l,e){"text"===l?this.node.textContent=e:o.SVGTextElement.parentClass.prototype.applyAttr.apply(this,arguments)},o.VMLElement=function(){o.VMLElement.VMLInitialized||o.VMLElement.initializeVML(),o.VMLElement.parentClass.apply(this,arguments)},o.inherits(o.VMLElement,o.AbstractElement),o.VMLElement.VMLInitialized=!1,o.VMLElement.initializeVML=function(){try{document.namespaces.rvml||document.namespaces.add("rvml","urn:schemas-microsoft-com:vml"),o.VMLElement.prototype.createElement=function(l){return document.createElement("<rvml:"+l+' class="rvml">')}}catch(l){o.VMLElement.prototype.createElement=function(l){return document.createElement("<"+l+' xmlns="urn:schemas-microsoft.com:vml" class="rvml">')}}document.createStyleSheet().addRule(".rvml","behavior:url(#default#VML)"),o.VMLElement.VMLInitialized=!0},o.VMLElement.prototype.getElementCtr=function(l){return o["VML"+l]},o.VMLElement.prototype.addClass=function(l){o.$(this.node).addClass(l)},o.VMLElement.prototype.applyAttr=function(l,e){this.node[l]=e},o.VMLElement.prototype.getBBox=function(){var l=o.$(this.node);return{x:l.position().left/this.canvas.scale,y:l.position().top/this.canvas.scale,width:l.width()/this.canvas.scale,height:l.height()/this.canvas.scale}},o.VMLGroupElement=function(){o.VMLGroupElement.parentClass.call(this,"group"),this.node.style.left="0px",this.node.style.top="0px",this.node.coordorigin="0 0"},o.inherits(o.VMLGroupElement,o.VMLElement),o.VMLGroupElement.prototype.add=function(l){this.node.appendChild(l.node)},o.VMLCanvasElement=function(){this.classPrefix="VML",o.VMLCanvasElement.parentClass.call(this,"group"),o.AbstractCanvasElement.apply(this,arguments),this.node.style.position="absolute"},o.inherits(o.VMLCanvasElement,o.VMLElement),o.mixin(o.VMLCanvasElement,o.AbstractCanvasElement),o.VMLCanvasElement.prototype.setSize=function(l,e){var t,a,n,i;if(this.width=l,this.height=e,this.node.style.width=l+"px",this.node.style.height=e+"px",this.node.coordsize=l+" "+e,this.node.coordorigin="0 0",this.rootElement){for(t=this.rootElement.node.getElementsByTagName("shape"),n=0,i=t.length;i>n;n++)t[n].coordsize=l+" "+e,t[n].style.width=l+"px",t[n].style.height=e+"px";for(a=this.node.getElementsByTagName("group"),n=0,i=a.length;i>n;n++)a[n].coordsize=l+" "+e,a[n].style.width=l+"px",a[n].style.height=e+"px"}},o.VMLCanvasElement.prototype.applyTransformParams=function(l,e,t){this.scale=l,this.transX=e,this.transY=t,this.rootElement.node.coordorigin=this.width-e-this.width/100+","+(this.height-t-this.height/100),this.rootElement.node.coordsize=this.width/l+","+this.height/l},o.VMLShapeElement=function(l,e){o.VMLShapeElement.parentClass.call(this,l,e),this.fillElement=new o.VMLElement("fill"),this.strokeElement=new o.VMLElement("stroke"),this.node.appendChild(this.fillElement.node),this.node.appendChild(this.strokeElement.node),this.node.stroked=!1,o.AbstractShapeElement.apply(this,arguments)},o.inherits(o.VMLShapeElement,o.VMLElement),o.mixin(o.VMLShapeElement,o.AbstractShapeElement),o.VMLShapeElement.prototype.applyAttr=function(l,e){switch(l){case"fill":this.node.fillcolor=e;break;case"fill-opacity":this.fillElement.node.opacity=Math.round(100*e)+"%";break;case"stroke":this.node.stroked="none"!==e,this.node.strokecolor=e;break;case"stroke-opacity":this.strokeElement.node.opacity=Math.round(100*e)+"%";break;case"stroke-width":this.node.stroked=0!==parseInt(e,10),this.node.strokeweight=e;break;case"d":this.node.path=o.VMLPathElement.pathSvgToVml(e);break;default:o.VMLShapeElement.parentClass.prototype.applyAttr.apply(this,arguments)}},o.VMLPathElement=function(l,e){var t=new o.VMLElement("skew");o.VMLPathElement.parentClass.call(this,"shape",l,e),this.node.coordorigin="0 0",t.node.on=!0,t.node.matrix="0.01,0,0,0.01,0,0",t.node.offset="0,0",this.node.appendChild(t.node)},o.inherits(o.VMLPathElement,o.VMLShapeElement),o.VMLPathElement.prototype.applyAttr=function(l,e){"d"===l?this.node.path=o.VMLPathElement.pathSvgToVml(e):o.VMLShapeElement.prototype.applyAttr.call(this,l,e)},o.VMLPathElement.pathSvgToVml=function(l){var e,t,a=0,n=0;return l=l.replace(/(-?\d+)e(-?\d+)/g,"0"),l.replace(/([MmLlHhVvCcSs])\s*((?:-?\d*(?:\.\d+)?\s*,?\s*)+)/g,function(l,i,c){c=c.replace(/(\d)-/g,"$1,-").replace(/^\s+/g,"").replace(/\s+$/g,"").replace(/\s+/g,",").split(","),c[0]||c.shift();for(var r=0,o=c.length;o>r;r++)c[r]=Math.round(100*c[r]);switch(i){case"m":return a+=c[0],n+=c[1],"t"+c.join(",");case"M":return a=c[0],n=c[1],"m"+c.join(",");case"l":return a+=c[0],n+=c[1],"r"+c.join(",");case"L":return a=c[0],n=c[1],"l"+c.join(",");case"h":return a+=c[0],"r"+c[0]+",0";case"H":return"l"+(a=c[0])+","+n;case"v":return n+=c[0],"r0,"+c[0];case"V":return n=c[0],"l"+a+","+n;case"c":return e=a+c[c.length-4],t=n+c[c.length-3],a+=c[c.length-2],n+=c[c.length-1],"v"+c.join(",");case"C":return e=c[c.length-4],t=c[c.length-3],a=c[c.length-2],n=c[c.length-1],"c"+c.join(",");case"s":return c.unshift(n-t),c.unshift(a-e),e=a+c[c.length-4],t=n+c[c.length-3],a+=c[c.length-2],n+=c[c.length-1],"v"+c.join(",");case"S":return c.unshift(n+n-t),c.unshift(a+a-e),e=c[c.length-4],t=c[c.length-3],a=c[c.length-2],n=c[c.length-1],"c"+c.join(",")}return""}).replace(/z/g,"e")},o.VMLCircleElement=function(l,e){o.VMLCircleElement.parentClass.call(this,"oval",l,e)},o.inherits(o.VMLCircleElement,o.VMLShapeElement),o.VMLCircleElement.prototype.applyAttr=function(l,e){switch(l){case"r":this.node.style.width=2*e+"px",this.node.style.height=2*e+"px",this.applyAttr("cx",this.get("cx")||0),this.applyAttr("cy",this.get("cy")||0);break;case"cx":if(!e)return;this.node.style.left=e-(this.get("r")||0)+"px";break;case"cy":if(!e)return;this.node.style.top=e-(this.get("r")||0)+"px";break;default:o.VMLCircleElement.parentClass.prototype.applyAttr.call(this,l,e)}},o.VectorCanvas=function(l,e,t){return this.mode=window.SVGAngle?"svg":"vml",this.impl="svg"==this.mode?new o.SVGCanvasElement(l,e,t):new o.VMLCanvasElement(l,e,t),this.impl.mode=this.mode,this.impl},o.SimpleScale=function(l){this.scale=l},o.SimpleScale.prototype.getValue=function(l){return l},o.OrdinalScale=function(l){this.scale=l},o.OrdinalScale.prototype.getValue=function(l){return this.scale[l]},o.OrdinalScale.prototype.getTicks=function(){var l,e=[];for(l in this.scale)e.push({label:l,value:this.scale[l]});return e},o.NumericScale=function(l,e,t,a){this.scale=[],e=e||"linear",l&&this.setScale(l),e&&this.setNormalizeFunction(e),"undefined"!=typeof t&&this.setMin(t),"undefined"!=typeof a&&this.setMax(a)},o.NumericScale.prototype={setMin:function(l){this.clearMinValue=l,this.minValue="function"==typeof this.normalize?this.normalize(l):l},setMax:function(l){this.clearMaxValue=l,this.maxValue="function"==typeof this.normalize?this.normalize(l):l},setScale:function(l){var e;for(this.scale=[],e=0;e<l.length;e++)this.scale[e]=[l[e]]},setNormalizeFunction:function(l){"polynomial"===l?this.normalize=function(l){return Math.pow(l,.2)}:"linear"===l?delete this.normalize:this.normalize=l,this.setMin(this.clearMinValue),this.setMax(this.clearMaxValue)},getValue:function(l){var e,t,a=[],n=0,i=0;for("function"==typeof this.normalize&&(l=this.normalize(l)),i=0;i<this.scale.length-1;i++)e=this.vectorLength(this.vectorSubtract(this.scale[i+1],this.scale[i])),a.push(e),n+=e;for(t=(this.maxValue-this.minValue)/n,i=0;i<a.length;i++)a[i]*=t;for(i=0,l-=this.minValue;l-a[i]>=0;)l-=a[i],i++;return l=this.vectorToNum(i==this.scale.length-1?this.scale[i]:this.vectorAdd(this.scale[i],this.vectorMult(this.vectorSubtract(this.scale[i+1],this.scale[i]),l/a[i])))},vectorToNum:function(l){var e,t=0;for(e=0;e<l.length;e++)t+=Math.round(l[e])*Math.pow(256,l.length-e-1);return t},vectorSubtract:function(l,e){var t,a=[];for(t=0;t<l.length;t++)a[t]=l[t]-e[t];return a},vectorAdd:function(l,e){var t,a=[];for(t=0;t<l.length;t++)a[t]=l[t]+e[t];return a},vectorMult:function(l,e){var t,a=[];for(t=0;t<l.length;t++)a[t]=l[t]*e;return a},vectorLength:function(l){var e,t=0;for(e=0;e<l.length;e++)t+=l[e]*l[e];return Math.sqrt(t)},getTicks:function(){var l,e,t=[this.clearMinValue,this.clearMaxValue],a=t[1]-t[0],n=Math.pow(10,Math.floor(Math.log(a/5)/Math.LN10)),i=5/a*n,c=[];for(.15>=i?n*=10:.35>=i?n*=5:.75>=i&&(n*=2),t[0]=Math.floor(t[0]/n)*n,t[1]=Math.ceil(t[1]/n)*n,l=t[0];l<=t[1];)e=l==t[0]?this.clearMinValue:l==t[1]?this.clearMaxValue:l,c.push({label:l,value:this.getValue(e)}),l+=n;return c}},o.ColorScale=function(){o.ColorScale.parentClass.apply(this,arguments)},o.inherits(o.ColorScale,o.NumericScale),o.ColorScale.prototype.setScale=function(l){var e;for(e=0;e<l.length;e++)this.scale[e]=o.ColorScale.rgbToArray(l[e])},o.ColorScale.prototype.getValue=function(l){return o.ColorScale.numToRgb(o.ColorScale.parentClass.prototype.getValue.call(this,l))},o.ColorScale.arrayToRgb=function(l){var e,t,a="#";for(t=0;t<l.length;t++)e=l[t].toString(16),a+=1==e.length?"0"+e:e;return a},o.ColorScale.numToRgb=function(l){for(l=l.toString(16);l.length<6;)l="0"+l;return"#"+l},o.ColorScale.rgbToArray=function(l){return l=l.substr(1),[parseInt(l.substr(0,2),16),parseInt(l.substr(2,2),16),parseInt(l.substr(4,2),16)]},o.Legend=function(l){this.params=l||{},this.map=this.params.map,this.series=this.params.series,this.body=o.$("<div/>"),this.body.addClass("jvectormap-legend"),this.params.cssClass&&this.body.addClass(this.params.cssClass),l.vertical?this.map.legendCntVertical.append(this.body):this.map.legendCntHorizontal.append(this.body),this.render()},o.Legend.prototype.render=function(){var l,e,t,a,n=this.series.scale.getTicks(),i=o.$("<div/>").addClass("jvectormap-legend-inner");for(this.body.html(""),this.params.title&&this.body.append(o.$("<div/>").addClass("jvectormap-legend-title").html(this.params.title)),this.body.append(i),l=0;l<n.length;l++){switch(e=o.$("<div/>").addClass("jvectormap-legend-tick"),t=o.$("<div/>").addClass("jvectormap-legend-tick-sample"),this.series.params.attribute){case"fill":o.isImageUrl(n[l].value)?t.css("background","url("+n[l].value+")"):t.css("background",n[l].value);break;case"stroke":t.css("background",n[l].value);break;case"image":t.css("background","url("+n[l].value+") no-repeat center center");break;case"r":o.$("<div/>").css({"border-radius":n[l].value,border:this.map.params.markerStyle.initial["stroke-width"]+"px "+this.map.params.markerStyle.initial.stroke+" solid",width:2*n[l].value+"px",height:2*n[l].value+"px",background:this.map.params.markerStyle.initial.fill}).appendTo(t)}e.append(t),a=n[l].label,this.params.labelRender&&(a=this.params.labelRender(a)),e.append(o.$("<div>"+a+" </div>").addClass("jvectormap-legend-tick-text")),i.append(e)}i.append(o.$("<div/>").css("clear","both"))},o.DataSeries=function(l,e,t){var a;l=l||{},l.attribute=l.attribute||"fill",this.elements=e,this.params=l,this.map=t,l.attributes&&this.setAttributes(l.attributes),o.$.isArray(l.scale)?(a="fill"===l.attribute||"stroke"===l.attribute?o.ColorScale:o.NumericScale,this.scale=new a(l.scale,l.normalizeFunction,l.min,l.max)):this.scale=l.scale?new o.OrdinalScale(l.scale):new o.SimpleScale(l.scale),this.values=l.values||{},this.setValues(this.values),this.params.legend&&(this.legend=new o.Legend(n.extend({map:this.map,series:this},this.params.legend)))},o.DataSeries.prototype={setAttributes:function(l,e){var t,a=l;if("string"==typeof l)this.elements[l]&&this.elements[l].setStyle(this.params.attribute,e);else for(t in a)this.elements[t]&&this.elements[t].element.setStyle(this.params.attribute,a[t])},setValues:function(l){var e,t,a=-Number.MAX_VALUE,n=Number.MAX_VALUE,i={};if(this.scale instanceof o.OrdinalScale||this.scale instanceof o.SimpleScale)for(t in l)i[t]=l[t]?this.scale.getValue(l[t]):this.elements[t].element.style.initial[this.params.attribute];else{if("undefined"==typeof this.params.min||"undefined"==typeof this.params.max)for(t in l)e=parseFloat(l[t]),e>a&&(a=e),n>e&&(n=e);"undefined"==typeof this.params.min?(this.scale.setMin(n),this.params.min=n):this.scale.setMin(this.params.min),"undefined"==typeof this.params.max?(this.scale.setMax(a),this.params.max=a):this.scale.setMax(this.params.max);for(t in l)"indexOf"!=t&&(e=parseFloat(l[t]),i[t]=isNaN(e)?this.elements[t].element.style.initial[this.params.attribute]:this.scale.getValue(e))}this.setAttributes(i),o.$.extend(this.values,l)},clear:function(){var l,e={};for(l in this.values)this.elements[l]&&(e[l]=this.elements[l].element.shape.style.initial[this.params.attribute]);this.setAttributes(e),this.values={}},setScale:function(l){this.scale.setScale(l),this.values&&this.setValues(this.values)},setNormalizeFunction:function(l){this.scale.setNormalizeFunction(l),this.values&&this.setValues(this.values)}},o.Proj={degRad:180/Math.PI,radDeg:Math.PI/180,radius:6381372,sgn:function(l){return l>0?1:0>l?-1:l},mill:function(l,e,t){return{x:this.radius*(e-t)*this.radDeg,y:-this.radius*Math.log(Math.tan((45+.4*l)*this.radDeg))/.8}},mill_inv:function(l,e,t){return{lat:(2.5*Math.atan(Math.exp(.8*e/this.radius))-5*Math.PI/8)*this.degRad,lng:(t*this.radDeg+l/this.radius)*this.degRad}},merc:function(l,e,t){return{x:this.radius*(e-t)*this.radDeg,y:-this.radius*Math.log(Math.tan(Math.PI/4+l*Math.PI/360))}},merc_inv:function(l,e,t){return{lat:(2*Math.atan(Math.exp(e/this.radius))-Math.PI/2)*this.degRad,lng:(t*this.radDeg+l/this.radius)*this.degRad}},aea:function(l,e,t){var a=t*this.radDeg,n=29.5*this.radDeg,i=45.5*this.radDeg,c=l*this.radDeg,r=e*this.radDeg,o=(Math.sin(n)+Math.sin(i))/2,s=Math.cos(n)*Math.cos(n)+2*o*Math.sin(n),h=o*(r-a),p=Math.sqrt(s-2*o*Math.sin(c))/o,M=Math.sqrt(s-2*o*Math.sin(0))/o;return{x:p*Math.sin(h)*this.radius,y:-(M-p*Math.cos(h))*this.radius}},aea_inv:function(l,e,t){var a=l/this.radius,n=e/this.radius,i=t*this.radDeg,c=29.5*this.radDeg,r=45.5*this.radDeg,o=(Math.sin(c)+Math.sin(r))/2,s=Math.cos(c)*Math.cos(c)+2*o*Math.sin(c),h=Math.sqrt(s-2*o*Math.sin(0))/o,p=Math.sqrt(a*a+(h-n)*(h-n)),M=Math.atan(a/(h-n));return{lat:Math.asin((s-p*p*o*o)/(2*o))*this.degRad,lng:(i+M/o)*this.degRad}},lcc:function(l,e,t){var a=t*this.radDeg,n=e*this.radDeg,i=33*this.radDeg,c=45*this.radDeg,r=l*this.radDeg,o=Math.log(Math.cos(i)*(1/Math.cos(c)))/Math.log(Math.tan(Math.PI/4+c/2)*(1/Math.tan(Math.PI/4+i/2))),s=Math.cos(i)*Math.pow(Math.tan(Math.PI/4+i/2),o)/o,h=s*Math.pow(1/Math.tan(Math.PI/4+r/2),o),p=s*Math.pow(1/Math.tan(Math.PI/4+0),o);return{x:h*Math.sin(o*(n-a))*this.radius,y:-(p-h*Math.cos(o*(n-a)))*this.radius}},lcc_inv:function(l,e,t){var a=l/this.radius,n=e/this.radius,i=t*this.radDeg,c=33*this.radDeg,r=45*this.radDeg,o=Math.log(Math.cos(c)*(1/Math.cos(r)))/Math.log(Math.tan(Math.PI/4+r/2)*(1/Math.tan(Math.PI/4+c/2))),s=Math.cos(c)*Math.pow(Math.tan(Math.PI/4+c/2),o)/o,h=s*Math.pow(1/Math.tan(Math.PI/4+0),o),p=this.sgn(o)*Math.sqrt(a*a+(h-n)*(h-n)),M=Math.atan(a/(h-n));return{lat:(2*Math.atan(Math.pow(s/p,1/o))-Math.PI/2)*this.degRad,lng:(i+M/o)*this.degRad}}},o.MapObject=function(){},o.MapObject.prototype.getLabelText=function(l){return this.config.label?"function"==typeof this.config.label.render?this.config.label.render(l):l:null},o.MapObject.prototype.getLabelOffsets=function(l){var e;return this.config.label&&("function"==typeof this.config.label.offsets?e=this.config.label.offsets(l):"object"==typeof this.config.label.offsets&&(e=this.config.label.offsets[l])),e||[0,0]},o.MapObject.prototype.setHovered=function(l){this.isHovered!==l&&(this.isHovered=l,this.shape.isHovered=l,this.shape.updateStyle(),this.label&&(this.label.isHovered=l,this.label.updateStyle()))},o.MapObject.prototype.setSelected=function(l){this.isSelected!==l&&(this.isSelected=l,this.shape.isSelected=l,this.shape.updateStyle(),this.label&&(this.label.isSelected=l,this.label.updateStyle()),o.$(this.shape).trigger("selected",[l]))},o.MapObject.prototype.setStyle=function(){this.shape.setStyle.apply(this.shape,arguments)},o.MapObject.prototype.remove=function(){this.shape.remove(),this.label&&this.label.remove()},o.Region=function(l){var e,t,a,n;this.config=l,this.map=this.config.map,n=l.canvas.addGroup(l.canvas.rootElement),this.shape=l.canvas.addPath({d:l.path},l.style,n),l.canvas.addPath({d:l.path,"data-code":l.code},{initial:{fill:"transparent",stroke:"transparent","stroke-width":l.margin}},n).addClass("jvectormap-region jvectormap-element"),e=this.shape.getBBox(),t=this.getLabelText(l.code),this.config.label&&t&&(a=this.getLabelOffsets(l.code),this.labelX=e.x+e.width/2+a[0],this.labelY=e.y+e.height/2+a[1],this.label=l.canvas.addText({text:t,"text-anchor":"middle","alignment-baseline":"central",x:this.labelX,y:this.labelY,"data-code":l.code},l.labelStyle,l.labelsGroup),this.label.addClass("jvectormap-region jvectormap-element"))},o.inherits(o.Region,o.MapObject),o.Region.prototype.updateLabelPosition=function(){this.label&&this.label.set({x:this.labelX*this.map.scale+this.map.transX*this.map.scale,y:this.labelY*this.map.scale+this.map.transY*this.map.scale})},o.Marker=function(l){var e;this.config=l,this.map=this.config.map,this.isImage=!!this.config.style.initial.image,this.createShape(),e=this.getLabelText(l.index),this.config.label&&e&&(this.offsets=this.getLabelOffsets(l.index),this.labelX=l.cx/this.map.scale-this.map.transX,this.labelY=l.cy/this.map.scale-this.map.transY,this.label=l.canvas.addText({text:e,"data-index":l.index,dy:"0.6ex",x:this.labelX,y:this.labelY},l.labelStyle,l.labelsGroup),this.label.addClass("jvectormap-marker jvectormap-element"))},o.inherits(o.Marker,o.MapObject),o.Marker.prototype.createShape=function(){var l=this;this.shape&&this.shape.remove(),this.shape=this.config.canvas[this.isImage?"addImage":"addCircle"]({"data-index":this.config.index,cx:this.config.cx,cy:this.config.cy},this.config.style,this.config.group),this.shape.addClass("jvectormap-marker jvectormap-element"),this.isImage&&o.$(this.shape.node).on("imageloaded",function(){l.updateLabelPosition()})},o.Marker.prototype.updateLabelPosition=function(){this.label&&this.label.set({x:this.labelX*this.map.scale+this.offsets[0]+this.map.transX*this.map.scale+5+(this.isImage?(this.shape.width||0)/2:this.shape.properties.r),y:this.labelY*this.map.scale+this.map.transY*this.map.scale+this.offsets[1]})},o.Marker.prototype.setStyle=function(l){var e;o.Marker.parentClass.prototype.setStyle.apply(this,arguments),"r"===l&&this.updateLabelPosition(),(e=!!this.shape.get("image"))!=this.isImage&&(this.isImage=e,this.config.style=o.$.extend(!0,{},this.shape.style),this.createShape())},o.Map=function(l){var e,t=this;if(this.params=o.$.extend(!0,{},o.Map.defaultParams,l),!o.Map.maps[this.params.map])throw new Error("Attempt to use map which was not loaded: "+this.params.map);this.mapData=o.Map.maps[this.params.map],this.markers={},this.regions={},this.regionsColors={},this.regionsData={},this.container=o.$("<div>").addClass("jvectormap-container"),this.params.container&&this.params.container.append(this.container),this.container.data("mapObject",this),this.defaultWidth=this.mapData.width,this.defaultHeight=this.mapData.height,this.setBackgroundColor(this.params.backgroundColor),this.onResize=function(){t.updateSize()},o.$(window).resize(this.onResize);for(e in o.Map.apiEvents)this.params[e]&&this.container.bind(o.Map.apiEvents[e]+".jvectormap",this.params[e]);this.canvas=new o.VectorCanvas(this.container[0],this.width,this.height),this.params.bindTouchEvents&&("ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch?this.bindContainerTouchEvents():window.MSGesture&&this.bindContainerPointerEvents()),this.bindContainerEvents(),this.bindElementEvents(),this.createTip(),this.params.zoomButtons&&this.bindZoomButtons(),this.createRegions(),this.createMarkers(this.params.markers||{}),this.updateSize(),this.params.focusOn&&("string"==typeof this.params.focusOn?this.params.focusOn={region:this.params.focusOn}:o.$.isArray(this.params.focusOn)&&(this.params.focusOn={regions:this.params.focusOn}),this.setFocus(this.params.focusOn)),this.params.selectedRegions&&this.setSelectedRegions(this.params.selectedRegions),this.params.selectedMarkers&&this.setSelectedMarkers(this.params.selectedMarkers),this.legendCntHorizontal=o.$("<div/>").addClass("jvectormap-legend-cnt jvectormap-legend-cnt-h"),this.legendCntVertical=o.$("<div/>").addClass("jvectormap-legend-cnt jvectormap-legend-cnt-v"),this.container.append(this.legendCntHorizontal),this.container.append(this.legendCntVertical),this.params.series&&this.createSeries()},o.Map.prototype={transX:0,transY:0,scale:1,baseTransX:0,baseTransY:0,baseScale:1,width:0,height:0,setBackgroundColor:function(l){this.container.css("background-color",l)},resize:function(){var l=this.baseScale;this.width/this.height>this.defaultWidth/this.defaultHeight?(this.baseScale=this.height/this.defaultHeight,this.baseTransX=Math.abs(this.width-this.defaultWidth*this.baseScale)/(2*this.baseScale)):(this.baseScale=this.width/this.defaultWidth,this.baseTransY=Math.abs(this.height-this.defaultHeight*this.baseScale)/(2*this.baseScale)),this.scale*=this.baseScale/l,this.transX*=this.baseScale/l,this.transY*=this.baseScale/l},updateSize:function(){this.width=this.container.width(),this.height=this.container.height(),this.resize(),this.canvas.setSize(this.width,this.height),this.applyTransform()},reset:function(){var l,e;for(l in this.series)for(e=0;e<this.series[l].length;e++)this.series[l][e].clear();this.scale=this.baseScale,this.transX=this.baseTransX,this.transY=this.baseTransY,this.applyTransform()},applyTransform:function(){var l,e,t,a;this.defaultWidth*this.scale<=this.width?(l=(this.width-this.defaultWidth*this.scale)/(2*this.scale),t=(this.width-this.defaultWidth*this.scale)/(2*this.scale)):(l=0,t=(this.width-this.defaultWidth*this.scale)/this.scale),this.defaultHeight*this.scale<=this.height?(e=(this.height-this.defaultHeight*this.scale)/(2*this.scale),a=(this.height-this.defaultHeight*this.scale)/(2*this.scale)):(e=0,a=(this.height-this.defaultHeight*this.scale)/this.scale),this.transY>e?this.transY=e:this.transY<a&&(this.transY=a),this.transX>l?this.transX=l:this.transX<t&&(this.transX=t),this.canvas.applyTransformParams(this.scale,this.transX,this.transY),this.markers&&this.repositionMarkers(),this.repositionLabels(),this.container.trigger("viewportChange",[this.scale/this.baseScale,this.transX,this.transY])},bindContainerEvents:function(){var l,e,t=!1,a=this;this.params.panOnDrag&&(this.container.mousemove(function(n){return t&&(a.transX-=(l-n.pageX)/a.scale,a.transY-=(e-n.pageY)/a.scale,a.applyTransform(),l=n.pageX,e=n.pageY),!1}).mousedown(function(a){return t=!0,l=a.pageX,e=a.pageY,!1}),this.onContainerMouseUp=function(){t=!1},o.$("body").mouseup(this.onContainerMouseUp)),this.params.zoomOnScroll&&this.container.mousewheel(function(l){var e=o.$(a.container).offset(),t=l.pageX-e.left,n=l.pageY-e.top,i=Math.pow(1+a.params.zoomOnScrollSpeed/1e3,l.deltaFactor*l.deltaY);a.tip.hide(),a.setScale(a.scale*i,t,n),l.preventDefault()})},bindContainerTouchEvents:function(){var l,e,t,a,n,i,c,r=this,s=function(s){var h,p,M,u,Z=s.originalEvent.touches;"touchstart"==s.type&&(c=0),1==Z.length?(1==c&&(M=r.transX,u=r.transY,r.transX-=(t-Z[0].pageX)/r.scale,r.transY-=(a-Z[0].pageY)/r.scale,r.applyTransform(),r.tip.hide(),(M!=r.transX||u!=r.transY)&&s.preventDefault()),t=Z[0].pageX,a=Z[0].pageY):2==Z.length&&(2==c?(p=Math.sqrt(Math.pow(Z[0].pageX-Z[1].pageX,2)+Math.pow(Z[0].pageY-Z[1].pageY,2))/e,r.setScale(l*p,n,i),r.tip.hide(),s.preventDefault()):(h=o.$(r.container).offset(),n=Z[0].pageX>Z[1].pageX?Z[1].pageX+(Z[0].pageX-Z[1].pageX)/2:Z[0].pageX+(Z[1].pageX-Z[0].pageX)/2,i=Z[0].pageY>Z[1].pageY?Z[1].pageY+(Z[0].pageY-Z[1].pageY)/2:Z[0].pageY+(Z[1].pageY-Z[0].pageY)/2,n-=h.left,i-=h.top,l=r.scale,e=Math.sqrt(Math.pow(Z[0].pageX-Z[1].pageX,2)+Math.pow(Z[0].pageY-Z[1].pageY,2)))),c=Z.length};o.$(this.container).bind("touchstart",s),o.$(this.container).bind("touchmove",s)},bindContainerPointerEvents:function(){var l=this,e=new MSGesture,t=this.container[0],a=function(l){e.addPointer(l.pointerId)},n=function(e){var t,a;(0!=e.translationX||0!=e.translationY)&&(t=l.transX,a=l.transY,l.transX+=e.translationX/l.scale,l.transY+=e.translationY/l.scale,l.applyTransform(),l.tip.hide(),(t!=l.transX||a!=l.transY)&&e.preventDefault()),1!=e.scale&&(l.setScale(l.scale*e.scale,e.offsetX,e.offsetY),l.tip.hide(),e.preventDefault())};e.target=t,t.addEventListener("MSGestureChange",n,!1),t.addEventListener("pointerdown",a,!1)},bindElementEvents:function(){var l,e,t,a=this;this.container.mousemove(function(a){Math.abs(l-a.pageX)+Math.abs(e-a.pageY)>2&&(t=!0)}),this.container.delegate("[class~='jvectormap-element']","mouseover mouseout",function(l){var e=o.$(this).attr("class").baseVal||o.$(this).attr("class"),t=-1===e.indexOf("jvectormap-region")?"marker":"region",n=o.$(this).attr("region"==t?"data-code":"data-index"),i="region"==t?a.regions[n].element:a.markers[n].element,c="region"==t?a.mapData.paths[n].name:a.markers[n].config.name||"",r=o.$.Event(t+"TipShow.jvectormap"),s=o.$.Event(t+"Over.jvectormap");"mouseover"==l.type?(a.container.trigger(s,[n]),s.isDefaultPrevented()||i.setHovered(!0),a.tip.text(c),a.container.trigger(r,[a.tip,n]),r.isDefaultPrevented()||(a.tip.show(),a.tipWidth=a.tip.width(),a.tipHeight=a.tip.height())):(i.setHovered(!1),a.tip.hide(),a.container.trigger(t+"Out.jvectormap",[n]))}),this.container.delegate("[class~='jvectormap-element']","mousedown",function(a){l=a.pageX,e=a.pageY,t=!1}),this.container.delegate("[class~='jvectormap-element']","mouseup",function(){var l=o.$(this).attr("class").baseVal?o.$(this).attr("class").baseVal:o.$(this).attr("class"),e=-1===l.indexOf("jvectormap-region")?"marker":"region",n=o.$(this).attr("region"==e?"data-code":"data-index"),i=o.$.Event(e+"Click.jvectormap"),c="region"==e?a.regions[n].element:a.markers[n].element;t||(a.container.trigger(i,[n]),("region"===e&&a.params.regionsSelectable||"marker"===e&&a.params.markersSelectable)&&(i.isDefaultPrevented()||(a.params[e+"sSelectableOne"]&&a.clearSelected(e+"s"),c.setSelected(!c.isSelected))))})},bindZoomButtons:function(){var l=this;o.$("<div/>").addClass("jvectormap-zoomin").text("+").appendTo(this.container),o.$("<div/>").addClass("jvectormap-zoomout").html("&#x2212;").appendTo(this.container),this.container.find(".jvectormap-zoomin").click(function(){l.setScale(l.scale*l.params.zoomStep,l.width/2,l.height/2,!1,l.params.zoomAnimate)}),this.container.find(".jvectormap-zoomout").click(function(){l.setScale(l.scale/l.params.zoomStep,l.width/2,l.height/2,!1,l.params.zoomAnimate)})},createTip:function(){var l=this;this.tip=o.$("<div/>").addClass("jvectormap-tip").appendTo(o.$("body")),this.container.mousemove(function(e){var t=e.pageX-15-l.tipWidth,a=e.pageY-15-l.tipHeight;5>t&&(t=e.pageX+15),5>a&&(a=e.pageY+15),l.tip.css({left:t,top:a})})},setScale:function(l,e,t,a,n){var i,c,r,s,h,p,M,u,Z,m=o.$.Event("zoom.jvectormap"),d=this,f=0,g=Math.abs(Math.round(60*(l-this.scale)/Math.max(l,this.scale))),y=new o.$.Deferred;return l>this.params.zoomMax*this.baseScale?l=this.params.zoomMax*this.baseScale:l<this.params.zoomMin*this.baseScale&&(l=this.params.zoomMin*this.baseScale),"undefined"!=typeof e&&"undefined"!=typeof t&&(zoomStep=l/this.scale,a?(u=e+this.defaultWidth*(this.width/(this.defaultWidth*l))/2,Z=t+this.defaultHeight*(this.height/(this.defaultHeight*l))/2):(u=this.transX-(zoomStep-1)/l*e,Z=this.transY-(zoomStep-1)/l*t)),n&&g>0?(c=this.scale,r=(l-c)/g,s=this.transX*this.scale,p=this.transY*this.scale,h=(u*l-s)/g,M=(Z*l-p)/g,i=setInterval(function(){f+=1,d.scale=c+r*f,d.transX=(s+h*f)/d.scale,d.transY=(p+M*f)/d.scale,d.applyTransform(),f==g&&(clearInterval(i),d.container.trigger(m,[l/d.baseScale]),y.resolve())},10)):(this.transX=u,this.transY=Z,this.scale=l,this.applyTransform(),this.container.trigger(m,[l/this.baseScale]),y.resolve()),y},setFocus:function(l){var e,t,a,n,i,c;if(l=l||{},l.region?n=[l.region]:l.regions&&(n=l.regions),n){for(i=0;i<n.length;i++)this.regions[n[i]]&&(t=this.regions[n[i]].element.shape.getBBox())&&("undefined"==typeof e?e=t:(a={x:Math.min(e.x,t.x),y:Math.min(e.y,t.y),width:Math.max(e.x+e.width,t.x+t.width)-Math.min(e.x,t.x),height:Math.max(e.y+e.height,t.y+t.height)-Math.min(e.y,t.y)},e=a));return this.setScale(Math.min(this.width/e.width,this.height/e.height),-(e.x+e.width/2),-(e.y+e.height/2),!0,l.animate)}return l.lat&&l.lng?(c=this.latLngToPoint(l.lat,l.lng),l.x=this.transX-c.x/this.scale,l.y=this.transY-c.y/this.scale):l.x&&l.y&&(l.x*=-this.defaultWidth,l.y*=-this.defaultHeight),this.setScale(l.scale*this.baseScale,l.x,l.y,!0,l.animate)},getSelected:function(l){var e,t=[];for(e in this[l])this[l][e].element.isSelected&&t.push(e);return t},getSelectedRegions:function(){return this.getSelected("regions")},getSelectedMarkers:function(){return this.getSelected("markers")},setSelected:function(l,e){var t;if("object"!=typeof e&&(e=[e]),o.$.isArray(e))for(t=0;t<e.length;t++)this[l][e[t]].element.setSelected(!0);else for(t in e)this[l][t].element.setSelected(!!e[t])},setSelectedRegions:function(l){this.setSelected("regions",l)},setSelectedMarkers:function(l){this.setSelected("markers",l)},clearSelected:function(l){var e,t={},a=this.getSelected(l);for(e=0;e<a.length;e++)t[a[e]]=!1;this.setSelected(l,t)},clearSelectedRegions:function(){this.clearSelected("regions")},clearSelectedMarkers:function(){this.clearSelected("markers")},getMapObject:function(){return this},getRegionName:function(l){return this.mapData.paths[l].name},createRegions:function(){var l,e,t=this;this.regionLabelsGroup=this.regionLabelsGroup||this.canvas.addGroup();for(l in this.mapData.paths)e=new o.Region({map:this,path:this.mapData.paths[l].path,code:l,style:o.$.extend(!0,{},this.params.regionStyle),margin:this.params.regionMargin,labelStyle:o.$.extend(!0,{},this.params.regionLabelStyle),canvas:this.canvas,labelsGroup:this.regionLabelsGroup,label:"vml"!=this.canvas.mode?this.params.labels&&this.params.labels.regions:null}),o.$(e.shape).bind("selected",function(l,e){t.container.trigger("regionSelected.jvectormap",[o.$(this.node).attr("data-code"),e,t.getSelectedRegions()])}),this.regions[l]={element:e,config:this.mapData.paths[l]}},createMarkers:function(l){var e,t,a,n,i,c=this;if(this.markersGroup=this.markersGroup||this.canvas.addGroup(),this.markerLabelsGroup=this.markerLabelsGroup||this.canvas.addGroup(),o.$.isArray(l))for(i=l.slice(),l={},e=0;e<i.length;e++)l[e]=i[e];for(e in l)n=l[e]instanceof Array?{latLng:l[e]}:l[e],!1!==(a=this.getMarkerPosition(n))&&(t=new o.Marker({map:this,style:o.$.extend(!0,{},this.params.markerStyle,{initial:n.style||{}}),labelStyle:o.$.extend(!0,{},this.params.markerLabelStyle),index:e,cx:a.x,cy:a.y,group:this.markersGroup,canvas:this.canvas,labelsGroup:this.markerLabelsGroup,label:"vml"!=this.canvas.mode?this.params.labels&&this.params.labels.markers:null}),o.$(t.shape).bind("selected",function(l,e){c.container.trigger("markerSelected.jvectormap",[o.$(this.node).attr("data-index"),e,c.getSelectedMarkers()])}),this.markers[e]&&this.removeMarkers([e]),this.markers[e]={element:t,config:n})},repositionMarkers:function(){var l,e;for(l in this.markers)!1!==(e=this.getMarkerPosition(this.markers[l].config))&&this.markers[l].element.setStyle({cx:e.x,cy:e.y})},repositionLabels:function(){var l;for(l in this.regions)this.regions[l].element.updateLabelPosition();for(l in this.markers)this.markers[l].element.updateLabelPosition()},getMarkerPosition:function(l){return o.Map.maps[this.params.map].projection?this.latLngToPoint.apply(this,l.latLng||[0,0]):{x:l.coords[0]*this.scale+this.transX*this.scale,y:l.coords[1]*this.scale+this.transY*this.scale}},addMarker:function(l,e,t){var a,n,i={},c=[],t=t||[];for(i[l]=e,n=0;n<t.length;n++)a={},"undefined"!=typeof t[n]&&(a[l]=t[n]),c.push(a);this.addMarkers(i,c)},addMarkers:function(l,e){var t;for(e=e||[],this.createMarkers(l),t=0;t<e.length;t++)this.series.markers[t].setValues(e[t]||{})},removeMarkers:function(l){var e;for(e=0;e<l.length;e++)this.markers[l[e]].element.remove(),delete this.markers[l[e]]},removeAllMarkers:function(){var l,e=[];for(l in this.markers)e.push(l);this.removeMarkers(e)},latLngToPoint:function(l,e){var t,a,n,i=o.Map.maps[this.params.map].projection,c=i.centralMeridian;return-180+c>e&&(e+=360),t=o.Proj[i.type](l,e,c),!!(a=this.getInsetForPoint(t.x,t.y))&&(n=a.bbox,t.x=(t.x-n[0].x)/(n[1].x-n[0].x)*a.width*this.scale,t.y=(t.y-n[0].y)/(n[1].y-n[0].y)*a.height*this.scale,{x:t.x+this.transX*this.scale+a.left*this.scale,y:t.y+this.transY*this.scale+a.top*this.scale})},pointToLatLng:function(l,e){var t,a,n,i,c,r=o.Map.maps[this.params.map].projection,s=r.centralMeridian,h=o.Map.maps[this.params.map].insets;for(t=0;t<h.length;t++)if(a=h[t],n=a.bbox,i=l-(this.transX*this.scale+a.left*this.scale),c=e-(this.transY*this.scale+a.top*this.scale),i=i/(a.width*this.scale)*(n[1].x-n[0].x)+n[0].x,c=c/(a.height*this.scale)*(n[1].y-n[0].y)+n[0].y,i>n[0].x&&i<n[1].x&&c>n[0].y&&c<n[1].y)return o.Proj[r.type+"_inv"](i,-c,s);return!1},getInsetForPoint:function(l,e){var t,a,n=o.Map.maps[this.params.map].insets;for(t=0;t<n.length;t++)if(a=n[t].bbox,l>a[0].x&&l<a[1].x&&e>a[0].y&&e<a[1].y)return n[t]},createSeries:function(){var l,e;this.series={markers:[],regions:[]};for(e in this.params.series)for(l=0;l<this.params.series[e].length;l++)this.series[e][l]=new o.DataSeries(this.params.series[e][l],this[e],this)},remove:function(){this.tip.remove(),this.container.remove(),o.$(window).unbind("resize",this.onResize),o.$("body").unbind("mouseup",this.onContainerMouseUp)}},o.Map.maps={},o.Map.defaultParams={map:"world_mill_en",backgroundColor:"#505050",zoomButtons:!0,zoomOnScroll:!0,zoomOnScrollSpeed:3,panOnDrag:!0,zoomMax:8,zoomMin:1,zoomStep:1.6,zoomAnimate:!0,regionsSelectable:!1,markersSelectable:!1,bindTouchEvents:!0,regionStyle:{initial:{fill:"white","fill-opacity":1,stroke:"none","stroke-width":0,"stroke-opacity":1},hover:{"fill-opacity":.8,cursor:"pointer"},selected:{fill:"yellow"},selectedHover:{}},regionMargin:0,regionLabelStyle:{initial:{"font-family":"Verdana","font-size":"12","font-weight":"bold",cursor:"default",fill:"black"},hover:{cursor:"pointer"}},markerStyle:{initial:{fill:"grey",stroke:"#505050","fill-opacity":1,"stroke-width":1,"stroke-opacity":1,r:5},hover:{stroke:"black","stroke-width":2,cursor:"pointer"},selected:{fill:"blue"},selectedHover:{}},markerLabelStyle:{initial:{"font-family":"Verdana","font-size":"12","font-weight":"bold",cursor:"default",fill:"black"},hover:{cursor:"pointer"}}},o.Map.apiEvents={onRegionTipShow:"regionTipShow",onRegionOver:"regionOver",onRegionOut:"regionOut",onRegionClick:"regionClick",onRegionSelected:"regionSelected",onMarkerTipShow:"markerTipShow",onMarkerOver:"markerOver",onMarkerOut:"markerOut",onMarkerClick:"markerClick",onMarkerSelected:"markerSelected",onViewportChange:"viewportChange"},o.MultiMap=function(l){var e=this;this.maps={},this.params=o.$.extend(!0,{},o.MultiMap.defaultParams,l),this.params.maxLevel=this.params.maxLevel||Number.MAX_VALUE,this.params.main=this.params.main||{},this.params.main.multiMapLevel=0,this.history=[this.addMap(this.params.main.map,this.params.main)],this.defaultProjection=this.history[0].mapData.projection.type,this.mapsLoaded={},this.params.container.css({position:"relative"}),this.backButton=o.$("<div/>").addClass("jvectormap-goback").text("Back").appendTo(this.params.container),this.backButton.hide(),this.backButton.click(function(){e.goBack()}),this.spinner=o.$("<div/>").addClass("jvectormap-spinner").appendTo(this.params.container),this.spinner.hide()},o.MultiMap.prototype={addMap:function(l,e){var t=o.$("<div/>").css({width:"100%",height:"100%"});return this.params.container.append(t),this.maps[l]=new o.Map(o.$.extend(e,{container:t})),this.params.maxLevel>e.multiMapLevel&&this.maps[l].container.on("regionClick.jvectormap",{scope:this},function(l,e){var t=l.data.scope,a=t.params.mapNameByCode(e,t);t.drillDownPromise&&"pending"===t.drillDownPromise.state()||t.drillDown(a,e)}),this.maps[l]},downloadMap:function(l){var e=this,t=o.$.Deferred();return this.mapsLoaded[l]?t.resolve():o.$.get(this.params.mapUrlByCode(l,this)).then(function(){e.mapsLoaded[l]=!0,t.resolve()},function(){t.reject()}),t},drillDown:function(l,e){var t=this.history[this.history.length-1],a=this,n=t.setFocus({region:e,animate:!0}),i=this.downloadMap(e);n.then(function(){"pending"===i.state()&&a.spinner.show()}),i.always(function(){a.spinner.hide()}),this.drillDownPromise=o.$.when(i,n),this.drillDownPromise.then(function(){t.params.container.hide(),a.maps[l]?a.maps[l].params.container.show():a.addMap(l,{map:l,multiMapLevel:t.params.multiMapLevel+1}),a.history.push(a.maps[l]),a.backButton.show()})},goBack:function(){var l=this.history.pop(),e=this.history[this.history.length-1],t=this;l.setFocus({scale:1,x:.5,y:.5,animate:!0}).then(function(){l.params.container.hide(),e.params.container.show(),e.updateSize(),1===t.history.length&&t.backButton.hide(),e.setFocus({scale:1,x:.5,y:.5,animate:!0})})}},o.MultiMap.defaultParams={mapNameByCode:function(l,e){return l.toLowerCase()+"_"+e.defaultProjection+"_en"},mapUrlByCode:function(l,e){return"jquery-jvectormap-data-"+l.toLowerCase()+"-"+e.defaultProjection+"-en.js"}}}).call(e,t(0),t(0))},function(l,e,t){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var a=t(36);t.d(e,"VectorMap",function(){return a.a})},function(l,e,t){"use strict";(function(l){function a(l,e){if(!(l instanceof e))throw new TypeError("Cannot call a class as a function")}function n(l,e){if(!l)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!==typeof e&&"function"!==typeof e?l:e}function i(l,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);l.prototype=Object.create(e&&e.prototype,{constructor:{value:l,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(l,e):l.__proto__=e)}var c=t(37),r=t.n(c),o=t(38),s=(t.n(o),t(43)),h=t.n(s),p=t(2),M=function(){function l(l,e){for(var t=0;t<e.length;t++){var a=e[t];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(l,a.key,a)}}return function(e,t,a){return t&&l(e.prototype,t),a&&l(e,a),e}}(),u=l,Z=function(l){function e(l){a(this,e);var t=n(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,l));return t.$node=null,t.$mapObject=null,t}return i(e,l),M(e,[{key:"componentWillMount",value:function(){var l=this.props.map;if(!l||-1===p.default.indexOf(l))throw new Error("No such map, please select one of the following: "+p.default.join());t(48)("./"+l)}},{key:"componentDidMount",value:function(){var l=this.props.map;this.$node=u(this.refs.map),l&&(this.$node.vectorMap(Object.assign({},this.props)),this.$mapObject=this.$node.vectorMap("get","mapObject"))}},{key:"componentDidUpdate",value:function(){var l=this.props.map;this.$node=u(this.refs.map),this.$node.empty(),l&&(this.$node.vectorMap(Object.assign({},this.props)),this.$mapObject=this.$node.vectorMap("get","mapObject"))}},{key:"setBackgroundColor",value:function(l){this.$mapObject.setBackgroundColor(l)}},{key:"getMapObject",value:function(){return this.$mapObject}},{key:"render",value:function(){var l={},e=this.props,t=e.containerStyle,a=e.containerClassName;return t&&(l.style=t),a&&(l.className=a),r.a.createElement("div",Object.assign({ref:"map"},l))}}]),e}(r.a.PureComponent);Z.propTypes={containerStyle:h.a.object,containerClassName:h.a.string,map:h.a.oneOf(p.default).isRequired,backgroundColor:h.a.string,zoomOnScroll:h.a.bool,zoomOnScrollSpeed:h.a.bool,panOnDrag:h.a.bool,zoomMax:h.a.number,zoomMin:h.a.number,zoomStep:h.a.number,zoomAnimate:h.a.bool,regionsSelectable:h.a.bool,regionsSelectableOne:h.a.bool,markersSelectable:h.a.bool,markersSelectableOne:h.a.bool,regionStyle:h.a.object,regionLabelStyle:h.a.object,markerStyle:h.a.object,markerLabelStyle:h.a.object,markers:h.a.oneOfType([h.a.object,h.a.array]),series:h.a.object,focusOn:h.a.oneOfType([h.a.string,h.a.object]),labels:h.a.object,selectedRegions:h.a.oneOfType([h.a.array,h.a.object,h.a.string]),selectedMarkers:h.a.oneOfType([h.a.array,h.a.object,h.a.string]),onRegionTipShow:h.a.func,onRegionOver:h.a.func,onRegionOut:h.a.func,onRegionClick:h.a.func,onRegionSelected:h.a.func,onMarkerTipShow:h.a.func,onMarkerOver:h.a.func,onMarkerOut:h.a.func,onMarkerClick:h.a.func,onMarkerSelected:h.a.func,onViewportChange:h.a.func,zoomButtons:h.a.bool},e.a=Z}).call(e,t(0))},function(e,t){e.exports=l},function(l,e,t){var a=t(39);"string"===typeof a&&(a=[[l.i,a,""]]);var n={};n.transform=void 0;t(41)(a,n);a.locals&&(l.exports=a.locals)},function(l,e,t){e=l.exports=t(40)(!1),e.push([l.i,".SecondExample {\n  text-align: center;\n  width: 100%; }\n\n.SecondExample-text {\n  color: #4b5658;\n  font-size: 20px; }\n\n.SecondExample-link {\n  color: #4b5658;\n  text-decoration: none; }\n  .SecondExample-link:hover {\n    border-bottom: 1px solid #4b5658; }\n\n.SecondExample-github-link {\n  color: #3079ab;\n  font-size: 22px;\n  text-decoration: none; }\n  .SecondExample-github-link:hover {\n    border-bottom: 1px solid #3079ab; }\n",""])},function(l,e,t){"use strict";function a(l,e){var t=l[1]||"",a=l[3];if(!a)return t;if(e&&"function"===typeof btoa){var i=n(a);return[t].concat(a.sources.map(function(l){return"/*# sourceURL="+a.sourceRoot+l+" */"})).concat([i]).join("\n")}return[t].join("\n")}function n(l){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(l))))+" */"}l.exports=function(l){var e=[];return e.toString=function(){return this.map(function(e){var t=a(e,l);return e[2]?"@media "+e[2]+"{"+t+"}":t}).join("")},e.i=function(l,t){"string"===typeof l&&(l=[[null,l,""]]);for(var a={},n=0;n<this.length;n++){var i=this[n][0];null!=i&&(a[i]=!0)}for(n=0;n<l.length;n++){var c=l[n];null!=c[0]&&a[c[0]]||(t&&!c[2]?c[2]=t:t&&(c[2]="("+c[2]+") and ("+t+")"),e.push(c))}},e}},function(l,e,t){function a(l,e){for(var t=0;t<l.length;t++){var a=l[t],n=Z[a.id];if(n){n.refs++;for(var i=0;i<n.parts.length;i++)n.parts[i](a.parts[i]);for(;i<a.parts.length;i++)n.parts.push(h(a.parts[i],e))}else{for(var c=[],i=0;i<a.parts.length;i++)c.push(h(a.parts[i],e));Z[a.id]={id:a.id,refs:1,parts:c}}}}function n(l,e){for(var t=[],a={},n=0;n<l.length;n++){var i=l[n],c=e.base?i[0]+e.base:i[0],r=i[1],o=i[2],s=i[3],h={css:r,media:o,sourceMap:s};a[c]?a[c].parts.push(h):t.push(a[c]={id:c,parts:[h]})}return t}function i(l,e){var t=d(l.insertInto);if(!t)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var a=y[y.length-1];if("top"===l.insertAt)a?a.nextSibling?t.insertBefore(e,a.nextSibling):t.appendChild(e):t.insertBefore(e,t.firstChild),y.push(e);else{if("bottom"!==l.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");t.appendChild(e)}}function c(l){if(null===l.parentNode)return!1;l.parentNode.removeChild(l);var e=y.indexOf(l);e>=0&&y.splice(e,1)}function r(l){var e=document.createElement("style");return l.attrs.type="text/css",s(e,l.attrs),i(l,e),e}function o(l){var e=document.createElement("link");return l.attrs.type="text/css",l.attrs.rel="stylesheet",s(e,l.attrs),i(l,e),e}function s(l,e){Object.keys(e).forEach(function(t){l.setAttribute(t,e[t])})}function h(l,e){var t,a,n,i;if(e.transform&&l.css){if(!(i=e.transform(l.css)))return function(){};l.css=i}if(e.singleton){var s=g++;t=f||(f=r(e)),a=p.bind(null,t,s,!1),n=p.bind(null,t,s,!0)}else l.sourceMap&&"function"===typeof URL&&"function"===typeof URL.createObjectURL&&"function"===typeof URL.revokeObjectURL&&"function"===typeof Blob&&"function"===typeof btoa?(t=o(e),a=u.bind(null,t,e),n=function(){c(t),t.href&&URL.revokeObjectURL(t.href)}):(t=r(e),a=M.bind(null,t),n=function(){c(t)});return a(l),function(e){if(e){if(e.css===l.css&&e.media===l.media&&e.sourceMap===l.sourceMap)return;a(l=e)}else n()}}function p(l,e,t,a){var n=t?"":a.css;if(l.styleSheet)l.styleSheet.cssText=b(e,n);else{var i=document.createTextNode(n),c=l.childNodes;c[e]&&l.removeChild(c[e]),c.length?l.insertBefore(i,c[e]):l.appendChild(i)}}function M(l,e){var t=e.css,a=e.media;if(a&&l.setAttribute("media",a),l.styleSheet)l.styleSheet.cssText=t;else{for(;l.firstChild;)l.removeChild(l.firstChild);l.appendChild(document.createTextNode(t))}}function u(l,e,t){var a=t.css,n=t.sourceMap,i=void 0===e.convertToAbsoluteUrls&&n;(e.convertToAbsoluteUrls||i)&&(a=v(a)),n&&(a+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */");var c=new Blob([a],{type:"text/css"}),r=l.href;l.href=URL.createObjectURL(c),r&&URL.revokeObjectURL(r)}var Z={},m=function(l){var e;return function(){return"undefined"===typeof e&&(e=l.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),d=function(l){var e={};return function(t){return"undefined"===typeof e[t]&&(e[t]=l.call(this,t)),e[t]}}(function(l){return document.querySelector(l)}),f=null,g=0,y=[],v=t(42);l.exports=function(l,e){if("undefined"!==typeof DEBUG&&DEBUG&&"object"!==typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"===typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=m()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var t=n(l,e);return a(t,e),function(l){for(var i=[],c=0;c<t.length;c++){var r=t[c],o=Z[r.id];o.refs--,i.push(o)}if(l){a(n(l,e),e)}for(var c=0;c<i.length;c++){var o=i[c];if(0===o.refs){for(var s=0;s<o.parts.length;s++)o.parts[s]();delete Z[o.id]}}}};var b=function(){var l=[];return function(e,t){return l[e]=t,l.filter(Boolean).join("\n")}}()},function(l,e){l.exports=function(l){var e="undefined"!==typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!l||"string"!==typeof l)return l;var t=e.protocol+"//"+e.host,a=t+e.pathname.replace(/\/[^\/]*$/,"/");return l.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(l,e){var n=e.trim().replace(/^"(.*)"$/,function(l,e){return e}).replace(/^'(.*)'$/,function(l,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(n))return l;var i;return i=0===n.indexOf("//")?n:0===n.indexOf("/")?t+n:a+n.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(l,e,t){(function(e){if("production"!==e.env.NODE_ENV){var a="function"===typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,n=function(l){return"object"===typeof l&&null!==l&&l.$$typeof===a};l.exports=t(44)(n,!0)}else l.exports=t(47)()}).call(e,t(1))},function(l,e,t){"use strict";(function(e){var a=t(3),n=t(4),i=t(6),c=t(45),r=t(5),o=t(46);l.exports=function(l,t){function s(l){var e=l&&(T&&l[T]||l[k]);if("function"===typeof e)return e}function h(l,e){return l===e?0!==l||1/l===1/e:l!==l&&e!==e}function p(l){this.message=l,this.stack=""}function M(l){function a(a,s,h,M,u,Z,m){if(M=M||z,Z=Z||h,m!==r)if(t)n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==e.env.NODE_ENV&&"undefined"!==typeof console){var d=M+":"+h;!c[d]&&o<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",Z,M),c[d]=!0,o++)}return null==s[h]?a?new p(null===s[h]?"The "+u+" `"+Z+"` is marked as required in `"+M+"`, but its value is `null`.":"The "+u+" `"+Z+"` is marked as required in `"+M+"`, but its value is `undefined`."):null:l(s,h,M,u,Z)}if("production"!==e.env.NODE_ENV)var c={},o=0;var s=a.bind(null,!1);return s.isRequired=a.bind(null,!0),s}function u(l){function e(e,t,a,n,i,c){var r=e[t];if(x(r)!==l)return new p("Invalid "+n+" `"+i+"` of type `"+w(r)+"` supplied to `"+a+"`, expected `"+l+"`.");return null}return M(e)}function Z(l){function e(e,t,a,n,i){if("function"!==typeof l)return new p("Property `"+i+"` of component `"+a+"` has invalid PropType notation inside arrayOf.");var c=e[t];if(!Array.isArray(c)){return new p("Invalid "+n+" `"+i+"` of type `"+x(c)+"` supplied to `"+a+"`, expected an array.")}for(var o=0;o<c.length;o++){var s=l(c,o,a,n,i+"["+o+"]",r);if(s instanceof Error)return s}return null}return M(e)}function m(l){function e(e,t,a,n,i){if(!(e[t]instanceof l)){var c=l.name||z;return new p("Invalid "+n+" `"+i+"` of type `"+E(e[t])+"` supplied to `"+a+"`, expected instance of `"+c+"`.")}return null}return M(e)}function d(l){function t(e,t,a,n,i){for(var c=e[t],r=0;r<l.length;r++)if(h(c,l[r]))return null;return new p("Invalid "+n+" `"+i+"` of value `"+c+"` supplied to `"+a+"`, expected one of "+JSON.stringify(l)+".")}return Array.isArray(l)?M(t):("production"!==e.env.NODE_ENV&&i(!1,"Invalid argument supplied to oneOf, expected an instance of array."),a.thatReturnsNull)}function f(l){function e(e,t,a,n,i){if("function"!==typeof l)return new p("Property `"+i+"` of component `"+a+"` has invalid PropType notation inside objectOf.");var c=e[t],o=x(c);if("object"!==o)return new p("Invalid "+n+" `"+i+"` of type `"+o+"` supplied to `"+a+"`, expected an object.");for(var s in c)if(c.hasOwnProperty(s)){var h=l(c,s,a,n,i+"."+s,r);if(h instanceof Error)return h}return null}return M(e)}function g(l){function t(e,t,a,n,i){for(var c=0;c<l.length;c++){if(null==(0,l[c])(e,t,a,n,i,r))return null}return new p("Invalid "+n+" `"+i+"` supplied to `"+a+"`.")}if(!Array.isArray(l))return"production"!==e.env.NODE_ENV&&i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."),a.thatReturnsNull;for(var n=0;n<l.length;n++){var c=l[n];if("function"!==typeof c)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",C(c),n),a.thatReturnsNull}return M(t)}function y(l){function e(e,t,a,n,i){var c=e[t],o=x(c);if("object"!==o)return new p("Invalid "+n+" `"+i+"` of type `"+o+"` supplied to `"+a+"`, expected `object`.");for(var s in l){var h=l[s];if(h){var M=h(c,s,a,n,i+"."+s,r);if(M)return M}}return null}return M(e)}function v(l){function e(e,t,a,n,i){var o=e[t],s=x(o);if("object"!==s)return new p("Invalid "+n+" `"+i+"` of type `"+s+"` supplied to `"+a+"`, expected `object`.");var h=c({},e[t],l);for(var M in h){var u=l[M];if(!u)return new p("Invalid "+n+" `"+i+"` key `"+M+"` supplied to `"+a+"`.\nBad object: "+JSON.stringify(e[t],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(l),null,"  "));var Z=u(o,M,a,n,i+"."+M,r);if(Z)return Z}return null}return M(e)}function b(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(b);if(null===e||l(e))return!0;var t=s(e);if(!t)return!1;var a,n=t.call(e);if(t!==e.entries){for(;!(a=n.next()).done;)if(!b(a.value))return!1}else for(;!(a=n.next()).done;){var i=a.value;if(i&&!b(i[1]))return!1}return!0;default:return!1}}function S(l,e){return"symbol"===l||("Symbol"===e["@@toStringTag"]||"function"===typeof Symbol&&e instanceof Symbol)}function x(l){var e=typeof l;return Array.isArray(l)?"array":l instanceof RegExp?"object":S(e,l)?"symbol":e}function w(l){if("undefined"===typeof l||null===l)return""+l;var e=x(l);if("object"===e){if(l instanceof Date)return"date";if(l instanceof RegExp)return"regexp"}return e}function C(l){var e=w(l);switch(e){case"array":case"object":return"an "+e;case"boolean":case"date":case"regexp":return"a "+e;default:return e}}function E(l){return l.constructor&&l.constructor.name?l.constructor.name:z}var T="function"===typeof Symbol&&Symbol.iterator,k="@@iterator",z="<<anonymous>>",A={array:u("array"),bool:u("boolean"),func:u("function"),number:u("number"),object:u("object"),string:u("string"),symbol:u("symbol"),any:function(){return M(a.thatReturnsNull)}(),arrayOf:Z,element:function(){function e(e,t,a,n,i){var c=e[t];if(!l(c)){return new p("Invalid "+n+" `"+i+"` of type `"+x(c)+"` supplied to `"+a+"`, expected a single ReactElement.")}return null}return M(e)}(),instanceOf:m,node:function(){function l(l,e,t,a,n){return b(l[e])?null:new p("Invalid "+a+" `"+n+"` supplied to `"+t+"`, expected a ReactNode.")}return M(l)}(),objectOf:f,oneOf:d,oneOfType:g,shape:y,exact:v};return p.prototype=Error.prototype,A.checkPropTypes=o,A.PropTypes=A,A}}).call(e,t(1))},function(l,e,t){"use strict";function a(l){if(null===l||void 0===l)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(l)}var n=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable;l.exports=function(){try{if(!Object.assign)return!1;var l=new String("abc");if(l[5]="de","5"===Object.getOwnPropertyNames(l)[0])return!1;for(var e={},t=0;t<10;t++)e["_"+String.fromCharCode(t)]=t;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(l){return e[l]}).join(""))return!1;var a={};return"abcdefghijklmnopqrst".split("").forEach(function(l){a[l]=l}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},a)).join("")}catch(l){return!1}}()?Object.assign:function(l,e){for(var t,r,o=a(l),s=1;s<arguments.length;s++){t=Object(arguments[s]);for(var h in t)i.call(t,h)&&(o[h]=t[h]);if(n){r=n(t);for(var p=0;p<r.length;p++)c.call(t,r[p])&&(o[r[p]]=t[r[p]])}}return o}},function(l,e,t){"use strict";(function(e){function a(l,t,a,o,s){if("production"!==e.env.NODE_ENV)for(var h in l)if(l.hasOwnProperty(h)){var p;try{n("function"===typeof l[h],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",o||"React class",a,h,typeof l[h]),p=l[h](t,h,o,a,null,c)}catch(l){p=l}if(i(!p||p instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",o||"React class",a,h,typeof p),p instanceof Error&&!(p.message in r)){r[p.message]=!0;var M=s?s():"";i(!1,"Failed %s type: %s%s",a,p.message,null!=M?M:"")}}}if("production"!==e.env.NODE_ENV)var n=t(4),i=t(6),c=t(5),r={};l.exports=a}).call(e,t(1))},function(l,e,t){"use strict";var a=t(3),n=t(4),i=t(5);l.exports=function(){function l(l,e,t,a,c,r){r!==i&&n(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function e(){return l}l.isRequired=l;var t={array:l,bool:l,func:l,number:l,object:l,string:l,symbol:l,any:l,arrayOf:e,element:l,instanceOf:e,node:l,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e};return t.checkPropTypes=a,t.PropTypes=t,t}},function(l,e,t){function a(l){return t(n(l))}function n(l){var e=i[l];if(!(e+1))throw new Error("Cannot find module '"+l+"'.");return e}var i={"./":2,"./africa_mill":7,"./africa_mill.js":7,"./ar_mill":8,"./ar_mill.js":8,"./asia_mill":9,"./asia_mill.js":9,"./au_mill":10,"./au_mill.js":10,"./brazil":11,"./brazil.js":11,"./ca_lcc":12,"./ca_lcc.js":12,"./ch_mill":13,"./ch_mill.js":13,"./co_mill":14,"./co_mill.js":14,"./continents_mill":15,"./continents_mill.js":15,"./de_mill":16,"./de_mill.js":16,"./es_mill":17,"./es_mill.js":17,"./europe_mill":18,"./europe_mill.js":18,"./fr_mill":19,"./fr_mill.js":19,"./fr_regions_mill":20,"./fr_regions_mill.js":20,"./in_mill":21,"./in_mill.js":21,"./index":2,"./index.js":2,"./indonesia":22,"./indonesia.js":22,"./kr_mill":23,"./kr_mill.js":23,"./north_america_mill":24,"./north_america_mill.js":24,"./oceania_mill":25,"./oceania_mill.js":25,"./ru_mill":26,"./ru_mill.js":26,"./se_mill":27,"./se_mill.js":27,"./south_america_mill":28,"./south_america_mill.js":28,"./th_mill":29,"./th_mill.js":29,"./us_aea":30,"./us_aea.js":30,"./vietnam":31,"./vietnam.js":31,"./world_mill":32,"./world_mill.js":32};a.keys=function(){return Object.keys(i)},a.resolve=n,l.exports=a,a.id=48}])});

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartist__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_views_chartsStyle_jsx__ = __webpack_require__(1100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react plugin for creating charts
// @material-ui/core components
// @material-ui/icons
// core components
var Charts=function(_React$Component){_inherits(Charts,_React$Component);function Charts(){_classCallCheck(this,Charts);return _possibleConstructorReturn(this,(Charts.__proto__||Object.getPrototypeOf(Charts)).apply(this,arguments));}_createClass(Charts,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Heading_Heading_jsx__["a" /* default */],{textAlign:"center",title:"React Chartist",category:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"A react wrapper for"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:"https://gionkunz.github.io/chartist-js/",rel:"noopener noreferrer"},"Chartist.js"),". Please checkout the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://gionkunz.github.io/chartist-js/getting-started.html",target:"_blank",rel:"noopener noreferrer"},"full documentation of Chartist.js")," ","and"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://fraserxu.me/react-chartist/",target:"_blank",rel:"noopener noreferrer"},"full documentation of react-chartist"),".")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],{chart:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{className:"ct-chart-white-colors",data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["roundedLineChart"].data,type:"Line",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["roundedLineChart"].options,listener:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["roundedLineChart"].animation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Rounded Line Chart"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Line Chart")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],{chart:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{className:"ct-chart-white-colors",data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["straightLinesChart"].data,type:"Line",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["straightLinesChart"].options,listener:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["straightLinesChart"].animation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Straight Lines Chart"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Line Chart with Points")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],{chart:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{className:"ct-chart-white-colors",data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["simpleBarChart"].data,type:"Bar",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["simpleBarChart"].options,responsiveOptions:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["simpleBarChart"].responsiveOptions,listener:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["simpleBarChart"].animation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Simple Bar Chart"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"Bar Chart"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"info",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardIcon_jsx__["a" /* default */],{color:"info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Coloured Line Chart ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"- Rounded"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["colouredLineChart"].data,type:"Line",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["colouredLineChart"].options,listener:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["colouredLineChart"].animation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Multiple Bars Chart ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"- Bar Chart"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["multipleBarsChart"].data,type:"Bar",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["multipleBarsChart"].options,listener:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["multipleBarsChart"].animation}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"warning",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardIcon_jsx__["a" /* default */],{color:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Coloured Lines Chart ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"- Rounded"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["colouredLinesChart"].data,type:"Line",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["colouredLinesChart"].options,listener:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["colouredLinesChart"].animation})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardHeader_jsx__["a" /* default */],{color:"danger",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardIcon_jsx__["a" /* default */],{color:"danger"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Timeline___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Pie Chart")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_chartist___default.a,{data:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["pieChart"].data,type:"Pie",options:__WEBPACK_IMPORTED_MODULE_12_variables_charts_jsx__["pieChart"].options})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardFooter_jsx__["a" /* default */],{stats:true,className:classes.cardFooter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.legendTitle},"Legend"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-circle "+classes.info})," Apple"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-circle "+classes.warning})," Samsung"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-circle "+classes.danger})," Windows Phone"," ")))));}}]);return Charts;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_13_assets_jss_material_dashboard_pro_react_views_chartsStyle_jsx__["a" /* default */])(Charts));

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartistGraph = function (_Component) {
  _inherits(ChartistGraph, _Component);

  function ChartistGraph() {
    _classCallCheck(this, ChartistGraph);

    return _possibleConstructorReturn(this, (ChartistGraph.__proto__ || Object.getPrototypeOf(ChartistGraph)).apply(this, arguments));
  }

  _createClass(ChartistGraph, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.updateChart(newProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.chartist) {
        try {
          this.chartist.detach();
        } catch (err) {
          throw new Error('Internal chartist error', err);
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateChart(this.props);
    }
  }, {
    key: 'updateChart',
    value: function updateChart(config) {
      var Chartist = __webpack_require__(465);

      var type = config.type,
          data = config.data;

      var options = config.options || {};
      var responsiveOptions = config.responsiveOptions || [];
      var event = void 0;

      if (this.chartist) {
        this.chartist.update(data, options, responsiveOptions);
      } else {
        this.chartist = new Chartist[type](this.refs.chart, data, options, responsiveOptions);

        if (config.listener) {
          for (event in config.listener) {
            if (config.listener.hasOwnProperty(event)) {
              this.chartist.on(event, config.listener[event]);
            }
          }
        }
      }

      return this.chartist;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          children = _props.children,
          data = _props.data,
          type = _props.type;

      var childrenWithProps = children && _react.Children.map(children, function (child) {
        return (0, _react.cloneElement)(child, {
          type: type,
          data: data
        });
      });
      return _react2.default.createElement(
        'div',
        { className: 'ct-chart ' + (className || ''), ref: 'chart', style: style },
        childrenWithProps
      );
    }
  }]);

  return ChartistGraph;
}(_react.Component);

ChartistGraph.propTypes = {
  type: _propTypes2.default.oneOf(['Line', 'Bar', 'Pie']).isRequired,
  data: _propTypes2.default.object.isRequired,
  className: _propTypes2.default.string,
  options: _propTypes2.default.object,
  responsiveOptions: _propTypes2.default.array,
  style: _propTypes2.default.object
};

exports.default = ChartistGraph;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// ##############################
// // // javascript library for creating charts
// #############################
var Chartist=__webpack_require__(465);// ##############################
// // // Charts used in Dahsboard view
// #############################
// ##############################
// // // variables used to create animation on charts
// #############################
var delays=80,durations=500;var delays2=80,durations2=500;// ##############################
// // // Daily Sales
// #############################
var dailySalesChart={data:{labels:["M","T","W","T","F","S","S"],series:[[12,17,7,17,23,18,38]]},options:{lineSmooth:Chartist.Interpolation.cardinal({tension:0}),low:0,high:50,// creative tim: we recommend you to set the high sa the biggest value + something for a better look
chartPadding:{top:0,right:0,bottom:0,left:0}},// for animation
animation:{draw:function draw(data){if(data.type==="line"||data.type==="area"){data.element.animate({d:{begin:600,dur:700,from:data.path.clone().scale(1,0).translate(0,data.chartRect.height()).stringify(),to:data.path.clone().stringify(),easing:Chartist.Svg.Easing.easeOutQuint}});}else if(data.type==="point"){data.element.animate({opacity:{begin:(data.index+1)*delays,dur:durations,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Email Subscriptions
// #############################
var emailsSubscriptionChart={data:{labels:["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],series:[[542,443,320,780,553,453,326,434,568,610,756,895]]},options:{axisX:{showGrid:false},low:0,high:1000,chartPadding:{top:0,right:5,bottom:0,left:0}},responsiveOptions:[["screen and (max-width: 640px)",{seriesBarDistance:5,axisX:{labelInterpolationFnc:function labelInterpolationFnc(value){return value[0];}}}]],animation:{draw:function draw(data){if(data.type==="bar"){data.element.animate({opacity:{begin:(data.index+1)*delays2,dur:durations2,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Completed Tasks
// #############################
var completedTasksChart={data:{labels:["12am","3pm","6pm","9pm","12pm","3am","6am","9am"],series:[[230,750,450,300,280,240,200,190]]},options:{lineSmooth:Chartist.Interpolation.cardinal({tension:0}),low:0,high:1000,// creative tim: we recommend you to set the high sa the biggest value + something for a better look
chartPadding:{top:0,right:0,bottom:0,left:0}},animation:{draw:function draw(data){if(data.type==="line"||data.type==="area"){data.element.animate({d:{begin:600,dur:700,from:data.path.clone().scale(1,0).translate(0,data.chartRect.height()).stringify(),to:data.path.clone().stringify(),easing:Chartist.Svg.Easing.easeOutQuint}});}else if(data.type==="point"){data.element.animate({opacity:{begin:(data.index+1)*delays,dur:durations,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Rounded Line Chart
// #############################
var roundedLineChart={data:{labels:["M","T","W","T","F","S","S"],series:[[12,17,7,17,23,18,38]]},options:{lineSmooth:Chartist.Interpolation.cardinal({tension:10}),axisX:{showGrid:false},low:0,high:50,// creative tim: we recommend you to set the high sa the biggest value + something for a better look
chartPadding:{top:0,right:0,bottom:0,left:0},showPoint:false},animation:{draw:function draw(data){if(data.type==="line"||data.type==="area"){data.element.animate({d:{begin:600,dur:700,from:data.path.clone().scale(1,0).translate(0,data.chartRect.height()).stringify(),to:data.path.clone().stringify(),easing:Chartist.Svg.Easing.easeOutQuint}});}else if(data.type==="point"){data.element.animate({opacity:{begin:(data.index+1)*delays,dur:durations,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Straight Lines Chart
// #############################
var straightLinesChart={data:{labels:["'07","'08","'09","'10","'11","'12","'13","'14","'15"],series:[[10,16,8,13,20,15,20,34,30]]},options:{lineSmooth:Chartist.Interpolation.cardinal({tension:0}),low:0,high:50,// creative tim: we recommend you to set the high sa the biggest value + something for a better look
chartPadding:{top:0,right:0,bottom:0,left:0},classNames:{point:"ct-point ct-white",line:"ct-line ct-white"}},animation:{draw:function draw(data){if(data.type==="line"||data.type==="area"){data.element.animate({d:{begin:600,dur:700,from:data.path.clone().scale(1,0).translate(0,data.chartRect.height()).stringify(),to:data.path.clone().stringify(),easing:Chartist.Svg.Easing.easeOutQuint}});}else if(data.type==="point"){data.element.animate({opacity:{begin:(data.index+1)*delays,dur:durations,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Simple Bar Chart
// #############################
var simpleBarChart={data:{labels:["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],series:[[542,443,320,780,553,453,326,434,568,610,756,895]]},options:{seriesBarDistance:10,axisX:{showGrid:false}},responsiveOptions:[["screen and (max-width: 640px)",{seriesBarDistance:5,axisX:{labelInterpolationFnc:function labelInterpolationFnc(value){return value[0];}}}]],animation:{draw:function draw(data){if(data.type==="bar"){data.element.animate({opacity:{begin:(data.index+1)*delays2,dur:durations2,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Coloured Line Chart
// #############################
var colouredLineChart={data:{labels:["'06","'07","'08","'09","'10","'11","'12","'13","'14","'15"],series:[[287,480,290,554,690,690,500,752,650,900,944]]},options:{lineSmooth:Chartist.Interpolation.cardinal({tension:10}),axisY:{showGrid:true,offset:40},axisX:{showGrid:false},low:0,high:1000,showPoint:true,height:"300px"},animation:{draw:function draw(data){if(data.type==="line"||data.type==="area"){data.element.animate({d:{begin:600,dur:700,from:data.path.clone().scale(1,0).translate(0,data.chartRect.height()).stringify(),to:data.path.clone().stringify(),easing:Chartist.Svg.Easing.easeOutQuint}});}else if(data.type==="point"){data.element.animate({opacity:{begin:(data.index+1)*delays,dur:durations,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Multiple Bars Chart
// #############################
var multipleBarsChart={data:{labels:["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],series:[[542,443,320,780,553,453,326,434,568,610,756,895],[412,243,280,580,453,353,300,364,368,410,636,695]]},options:{seriesBarDistance:10,axisX:{showGrid:false},height:"300px"},responsiveOptions:[["screen and (max-width: 640px)",{seriesBarDistance:5,axisX:{labelInterpolationFnc:function labelInterpolationFnc(value){return value[0];}}}]],animation:{draw:function draw(data){if(data.type==="bar"){data.element.animate({opacity:{begin:(data.index+1)*delays2,dur:durations2,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Coloured Lines Chart
// #############################
var colouredLinesChart={data:{labels:["'06","'07","'08","'09","'10","'11","'12","'13","'14","'15"],series:[[287,385,490,554,586,698,695,752,788,846,944],[67,152,143,287,335,435,437,539,542,544,647],[23,113,67,190,239,307,308,439,410,410,509]]},options:{lineSmooth:Chartist.Interpolation.cardinal({tension:10}),axisY:{showGrid:true,offset:40},axisX:{showGrid:false},low:0,high:1000,showPoint:true,height:"300px"},animation:{draw:function draw(data){if(data.type==="line"||data.type==="area"){data.element.animate({d:{begin:600,dur:700,from:data.path.clone().scale(1,0).translate(0,data.chartRect.height()).stringify(),to:data.path.clone().stringify(),easing:Chartist.Svg.Easing.easeOutQuint}});}else if(data.type==="point"){data.element.animate({opacity:{begin:(data.index+1)*delays,dur:durations,from:0,to:1,easing:"ease"}});}}}};// ##############################
// // // Pie Chart
// #############################
var pieChart={data:{labels:["62%","32%","6%"],series:[62,32,6]},options:{height:"230px"}};module.exports={// Charts used in Dahsboard view
dailySalesChart:dailySalesChart,emailsSubscriptionChart:emailsSubscriptionChart,completedTasksChart:completedTasksChart,// Charts used in Charts view
roundedLineChart:roundedLineChart,straightLinesChart:straightLinesChart,simpleBarChart:simpleBarChart,colouredLineChart:colouredLineChart,multipleBarsChart:multipleBarsChart,colouredLinesChart:colouredLinesChart,pieChart:pieChart};

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // IconCard styles
// #############################
var chartsStyle={cardTitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],cardCategory:{margin:"0",color:"#999999"},cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),legendTitle:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],margin:"10px 0 !important",display:"flex"},primary:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},warning:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]},danger:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]},success:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},info:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]},rose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},gray:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]},cardFooter:{display:"block"}};/* harmony default export */ __webpack_exports__["a"] = (chartsStyle);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_big_calendar__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_big_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_big_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_variables_general_jsx__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react component used to create a calendar with events on it
// dependency plugin for react-big-calendar
// react component used to create alerts
// @material-ui/core components
// core components
var localizer=__WEBPACK_IMPORTED_MODULE_1_react_big_calendar___default.a.momentLocalizer(__WEBPACK_IMPORTED_MODULE_2_moment___default.a);var Calendar=function(_React$Component){_inherits(Calendar,_React$Component);function Calendar(props){_classCallCheck(this,Calendar);var _this=_possibleConstructorReturn(this,(Calendar.__proto__||Object.getPrototypeOf(Calendar)).call(this,props));_this.state={events:__WEBPACK_IMPORTED_MODULE_11_variables_general_jsx__["d" /* events */],alert:null};_this.hideAlert=_this.hideAlert.bind(_this);return _this;}_createClass(Calendar,[{key:"selectedEvent",value:function selectedEvent(event){alert(event.title);}},{key:"addNewEventAlert",value:function addNewEventAlert(slotInfo){var _this2=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_sweetalert___default.a,{input:true,showCancel:true,style:{display:"block",marginTop:"-100px"},title:"Input something",onConfirm:function onConfirm(e){return _this2.addNewEvent(e,slotInfo);},onCancel:function onCancel(){return _this2.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger})});}},{key:"addNewEvent",value:function addNewEvent(e,slotInfo){var newEvents=this.state.events;newEvents.push({title:e,start:slotInfo.start,end:slotInfo.end});this.setState({alert:null,events:newEvents});}},{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"eventColors",value:function eventColors(event,start,end,isSelected){var backgroundColor="event-";event.color?backgroundColor=backgroundColor+event.color:backgroundColor=backgroundColor+"default";return{className:backgroundColor};}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Heading_Heading_jsx__["a" /* default */],{textAlign:"center",title:"React Big Calendar",category:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"A beautiful react component made by"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://github.com/intljusticemission",target:"_blank",rel:"noopener noreferrer"},"International Justice Mission"),". Please checkout their"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://github.com/intljusticemission/react-big-calendar",target:"_blank",rel:"noopener noreferrer"},"full documentation."))}),this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_CardBody_jsx__["a" /* default */],{calendar:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_big_calendar___default.a,{selectable:true,localizer:localizer,events:this.state.events,defaultView:"month",scrollToTime:new Date(1970,1,1,6),defaultDate:new Date(),onSelectEvent:function onSelectEvent(event){return _this3.selectedEvent(event);},onSelectSlot:function onSelectSlot(slotInfo){return _this3.addNewEventAlert(slotInfo);},eventPropGetter:this.eventColors}))))));}}]);return Calendar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_components_buttonStyle_jsx__["a" /* default */])(Calendar));

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _Calendar = _interopRequireDefault(__webpack_require__(1103));

var _EventWrapper = _interopRequireDefault(__webpack_require__(1189));

var _BackgroundWrapper = _interopRequireDefault(__webpack_require__(480));

var _moment = _interopRequireDefault(__webpack_require__(1190));

var _globalize = _interopRequireDefault(__webpack_require__(1191));

var _move = _interopRequireDefault(__webpack_require__(467));

var _constants = __webpack_require__(52);

(0, _extends2.default)(_Calendar.default, {
  globalizeLocalizer: _globalize.default,
  momentLocalizer: _moment.default,
  Views: _constants.views,
  Navigate: _constants.navigate,
  move: _move.default,
  components: {
    eventWrapper: _EventWrapper.default,
    dayWrapper: _BackgroundWrapper.default,
    dateCellWrapper: _BackgroundWrapper.default
  }
});
var _default = _Calendar.default;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _uncontrollable = _interopRequireDefault(__webpack_require__(1104));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _propTypes2 = __webpack_require__(1106);

var _warning = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(116);

var _constants = __webpack_require__(52);

var _localizer = __webpack_require__(202);

var _messages = _interopRequireDefault(__webpack_require__(1108));

var _move = _interopRequireDefault(__webpack_require__(467));

var _Views = _interopRequireDefault(__webpack_require__(468));

var _Toolbar = _interopRequireDefault(__webpack_require__(1157));

var _NoopWrapper = _interopRequireDefault(__webpack_require__(302));

var _omit = _interopRequireDefault(__webpack_require__(1158));

var _defaults = _interopRequireDefault(__webpack_require__(1185));

var _transform = _interopRequireDefault(__webpack_require__(1186));

var _mapValues = _interopRequireDefault(__webpack_require__(1187));

var _accessors = __webpack_require__(1188);

function viewNames(_views) {
  return !Array.isArray(_views) ? Object.keys(_views) : _views;
}

function isValidView(view, _ref) {
  var _views = _ref.views;
  var names = viewNames(_views);
  return names.indexOf(view) !== -1;
}
/**
 * react-big-calendar is a full featured Calendar component for managing events and dates. It uses
 * modern `flexbox` for layout, making it super responsive and performant. Leaving most of the layout heavy lifting
 * to the browser. __note:__ The default styles use `height: 100%` which means your container must set an explicit
 * height (feel free to adjust the styles to suit your specific needs).
 *
 * Big Calendar is unopiniated about editing and moving events, preferring to let you implement it in a way that makes
 * the most sense to your app. It also tries not to be prescriptive about your event data structures, just tell it
 * how to find the start and end datetimes and you can pass it whatever you want.
 *
 * One thing to note is that, `react-big-calendar` treats event start/end dates as an _exclusive_ range.
 * which means that the event spans up to, but not including, the end date. In the case
 * of displaying events on whole days, end dates are rounded _up_ to the next day. So an
 * event ending on `Apr 8th 12:00:00 am` will not appear on the 8th, whereas one ending
 * on `Apr 8th 12:01:00 am` will. If you want _inclusive_ ranges consider providing a
 * function `endAccessor` that returns the end date + 1 day for those events that end at midnight.
 */

/**
 *
 *
 * @static
 * @memberof Calendar
 */


var Calendar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Calendar, _React$Component);

  function Calendar() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.getViews = function () {
      var views = _this.props.views;

      if (Array.isArray(views)) {
        return (0, _transform.default)(views, function (obj, name) {
          return obj[name] = _Views.default[name];
        }, {});
      }

      if (typeof views === 'object') {
        return (0, _mapValues.default)(views, function (value, key) {
          if (value === true) {
            return _Views.default[key];
          }

          return value;
        });
      }

      return _Views.default;
    };

    _this.getView = function () {
      var views = _this.getViews();

      return views[_this.props.view];
    };

    _this.getDrilldownView = function (date) {
      var _this$props = _this.props,
          view = _this$props.view,
          drilldownView = _this$props.drilldownView,
          getDrilldownView = _this$props.getDrilldownView;
      if (!getDrilldownView) return drilldownView;
      return getDrilldownView(date, view, Object.keys(_this.getViews()));
    };

    _this.handleRangeChange = function (date, view) {
      var onRangeChange = _this.props.onRangeChange;

      if (onRangeChange) {
        if (view.range) {
          onRangeChange(view.range(date, {}));
        } else {
           false ? (0, _warning.default)(true, 'onRangeChange prop not supported for this view') : void 0;
        }
      }
    };

    _this.handleNavigate = function (action, newDate) {
      var _this$props2 = _this.props,
          view = _this$props2.view,
          date = _this$props2.date,
          getNow = _this$props2.getNow,
          onNavigate = _this$props2.onNavigate,
          props = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["view", "date", "getNow", "onNavigate"]);

      var ViewComponent = _this.getView();

      var today = getNow();
      date = (0, _move.default)(ViewComponent, (0, _extends2.default)({}, props, {
        action: action,
        date: newDate || date || today,
        today: today
      }));
      onNavigate(date, view, action);

      _this.handleRangeChange(date, ViewComponent);
    };

    _this.handleViewChange = function (view) {
      if (view !== _this.props.view && isValidView(view, _this.props)) {
        _this.props.onView(view);
      }

      var views = _this.getViews();

      _this.handleRangeChange(_this.props.date, views[view]);
    };

    _this.handleSelectEvent = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (0, _helpers.notify)(_this.props.onSelectEvent, args);
    };

    _this.handleDoubleClickEvent = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (0, _helpers.notify)(_this.props.onDoubleClickEvent, args);
    };

    _this.handleSelectSlot = function (slotInfo) {
      (0, _helpers.notify)(_this.props.onSelectSlot, slotInfo);
    };

    _this.handleDrillDown = function (date, view) {
      var onDrillDown = _this.props.onDrillDown;

      if (onDrillDown) {
        onDrillDown(date, view, _this.drilldownView);
        return;
      }

      if (view) _this.handleViewChange(view);

      _this.handleNavigate(_constants.navigate.DATE, date);
    };

    _this.state = {
      context: _this.getContext(_this.props)
    };
    return _this;
  }

  var _proto = Calendar.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      context: this.getContext(nextProps)
    });
  };

  _proto.getContext = function getContext(_ref2) {
    var startAccessor = _ref2.startAccessor,
        endAccessor = _ref2.endAccessor,
        allDayAccessor = _ref2.allDayAccessor,
        tooltipAccessor = _ref2.tooltipAccessor,
        titleAccessor = _ref2.titleAccessor,
        resourceAccessor = _ref2.resourceAccessor,
        resourceIdAccessor = _ref2.resourceIdAccessor,
        resourceTitleAccessor = _ref2.resourceTitleAccessor,
        eventPropGetter = _ref2.eventPropGetter,
        slotPropGetter = _ref2.slotPropGetter,
        dayPropGetter = _ref2.dayPropGetter,
        view = _ref2.view,
        views = _ref2.views,
        localizer = _ref2.localizer,
        culture = _ref2.culture,
        _ref2$messages = _ref2.messages,
        messages = _ref2$messages === void 0 ? {} : _ref2$messages,
        _ref2$components = _ref2.components,
        components = _ref2$components === void 0 ? {} : _ref2$components,
        _ref2$formats = _ref2.formats,
        formats = _ref2$formats === void 0 ? {} : _ref2$formats;
    var names = viewNames(views);
    var msgs = (0, _messages.default)(messages);
    return {
      viewNames: names,
      localizer: (0, _localizer.mergeWithDefaults)(localizer, culture, formats, msgs),
      getters: {
        eventProp: function eventProp() {
          return eventPropGetter && eventPropGetter.apply(void 0, arguments) || {};
        },
        slotProp: function slotProp() {
          return slotPropGetter && slotPropGetter.apply(void 0, arguments) || {};
        },
        dayProp: function dayProp() {
          return dayPropGetter && dayPropGetter.apply(void 0, arguments) || {};
        }
      },
      components: (0, _defaults.default)(components[view] || {}, (0, _omit.default)(components, names), {
        eventWrapper: _NoopWrapper.default,
        eventContainerWrapper: _NoopWrapper.default,
        dayWrapper: _NoopWrapper.default,
        dateCellWrapper: _NoopWrapper.default,
        weekWrapper: _NoopWrapper.default,
        timeSlotWrapper: _NoopWrapper.default
      }),
      accessors: {
        start: (0, _accessors.wrapAccessor)(startAccessor),
        end: (0, _accessors.wrapAccessor)(endAccessor),
        allDay: (0, _accessors.wrapAccessor)(allDayAccessor),
        tooltip: (0, _accessors.wrapAccessor)(tooltipAccessor),
        title: (0, _accessors.wrapAccessor)(titleAccessor),
        resource: (0, _accessors.wrapAccessor)(resourceAccessor),
        resourceId: (0, _accessors.wrapAccessor)(resourceIdAccessor),
        resourceTitle: (0, _accessors.wrapAccessor)(resourceTitleAccessor)
      }
    };
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        view = _this$props3.view,
        toolbar = _this$props3.toolbar,
        events = _this$props3.events,
        style = _this$props3.style,
        className = _this$props3.className,
        elementProps = _this$props3.elementProps,
        current = _this$props3.date,
        getNow = _this$props3.getNow,
        length = _this$props3.length,
        showMultiDayTimes = _this$props3.showMultiDayTimes,
        _0 = _this$props3.components,
        _1 = _this$props3.formats,
        _2 = _this$props3.messages,
        _3 = _this$props3.culture,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props3, ["view", "toolbar", "events", "style", "className", "elementProps", "date", "getNow", "length", "showMultiDayTimes", "components", "formats", "messages", "culture"]);
    current = current || getNow();
    var View = this.getView();
    var _this$state$context = this.state.context,
        accessors = _this$state$context.accessors,
        components = _this$state$context.components,
        getters = _this$state$context.getters,
        localizer = _this$state$context.localizer,
        viewNames = _this$state$context.viewNames;
    var CalToolbar = components.toolbar || _Toolbar.default;
    var label = View.title(current, {
      localizer: localizer,
      length: length
    });
    return _react.default.createElement("div", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, 'rbc-calendar', props.rtl && 'rbc-is-rtl'),
      style: style
    }), toolbar && _react.default.createElement(CalToolbar, {
      date: current,
      view: view,
      views: viewNames,
      label: label,
      onView: this.handleViewChange,
      onNavigate: this.handleNavigate,
      localizer: localizer
    }), _react.default.createElement(View, (0, _extends2.default)({
      ref: "view"
    }, props, {
      events: events,
      date: current,
      getNow: getNow,
      length: length,
      localizer: localizer,
      getters: getters,
      components: components,
      accessors: accessors,
      showMultiDayTimes: showMultiDayTimes,
      getDrilldownView: this.getDrilldownView,
      onNavigate: this.handleNavigate,
      onDrillDown: this.handleDrillDown,
      onSelectEvent: this.handleSelectEvent,
      onDoubleClickEvent: this.handleDoubleClickEvent,
      onSelectSlot: this.handleSelectSlot,
      onShowMore: this._showMore
    })));
  };

  return Calendar;
}(_react.default.Component);

Calendar.propTypes = {
  localizer: _propTypes.default.object.isRequired,

  /**
   * Props passed to main calendar `<div>`.
   *
   */
  elementProps: _propTypes.default.object,

  /**
   * The current date value of the calendar. Determines the visible view range.
   * If `date` is omitted then the result of `getNow` is used; otherwise the
   * current date is used.
   *
   * @controllable onNavigate
   */
  date: _propTypes.default.instanceOf(Date),

  /**
   * The current view of the calendar.
   *
   * @default 'month'
   * @controllable onView
   */
  view: _propTypes.default.string,

  /**
   * The initial view set for the Calendar.
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @default 'month'
   */
  defaultView: _propTypes.default.string,

  /**
   * An array of event objects to display on the calendar. Events objects
   * can be any shape, as long as the Calendar knows how to retrieve the
   * following details of the event:
   *
   *  - start time
   *  - end time
   *  - title
   *  - whether its an "all day" event or not
   *  - any resource the event may be a related too
   *
   * Each of these properties can be customized or generated dynamically by
   * setting the various "accessor" props. Without any configuration the default
   * event should look like:
   *
   * ```js
   * Event {
   *   title: string,
   *   start: Date,
   *   end: Date,
   *   allDay?: boolean
   *   resource?: any,
   * }
   * ```
   */
  events: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Accessor for the event title, used to display event information. Should
   * resolve to a `renderable` value.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  titleAccessor: _propTypes2.accessor,

  /**
   * Accessor for the event tooltip. Should
   * resolve to a `renderable` value. Removes the tooltip if null.
   *
   * ```js
   * string | (event: Object) => string
   * ```
   *
   * @type {(func|string)}
   */
  tooltipAccessor: _propTypes2.accessor,

  /**
   * Determines whether the event should be considered an "all day" event and ignore time.
   * Must resolve to a `boolean` value.
   *
   * ```js
   * string | (event: Object) => boolean
   * ```
   *
   * @type {(func|string)}
   */
  allDayAccessor: _propTypes2.accessor,

  /**
   * The start date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  startAccessor: _propTypes2.accessor,

  /**
   * The end date/time of the event. Must resolve to a JavaScript `Date` object.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  endAccessor: _propTypes2.accessor,

  /**
   * Returns the id of the `resource` that the event is a member of. This
   * id should match at least one resource in the `resources` array.
   *
   * ```js
   * string | (event: Object) => Date
   * ```
   *
   * @type {(func|string)}
   */
  resourceAccessor: _propTypes2.accessor,

  /**
   * An array of resource objects that map events to a specific resource.
   * Resource objects, like events, can be any shape or have any properties,
   * but should be uniquly identifiable via the `resourceIdAccessor`, as
   * well as a "title" or name as provided by the `resourceTitleAccessor` prop.
   */
  resources: _propTypes.default.arrayOf(_propTypes.default.object),

  /**
   * Provides a unique identifier for each resource in the `resources` array
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceIdAccessor: _propTypes2.accessor,

  /**
   * Provides a human readable name for the resource object, used in headers.
   *
   * ```js
   * string | (resource: Object) => any
   * ```
   *
   * @type {(func|string)}
   */
  resourceTitleAccessor: _propTypes2.accessor,

  /**
   * Determines the current date/time which is highlighted in the views.
   *
   * The value affects which day is shaded and which time is shown as
   * the current time. It also affects the date used by the Today button in
   * the toolbar.
   *
   * Providing a value here can be useful when you are implementing time zones
   * using the `startAccessor` and `endAccessor` properties.
   *
   * @type {func}
   * @default () => new Date()
   */
  getNow: _propTypes.default.func,

  /**
   * Callback fired when the `date` value changes.
   *
   * @controllable date
   */
  onNavigate: _propTypes.default.func,

  /**
   * Callback fired when the `view` value changes.
   *
   * @controllable view
   */
  onView: _propTypes.default.func,

  /**
   * Callback fired when date header, or the truncated events links are clicked
   *
   */
  onDrillDown: _propTypes.default.func,

  /**
   * Callback fired when the visible date range changes. Returns an Array of dates
   * or an object with start and end dates for BUILTIN views.
   *
   * Cutom views may return something different.
   */
  onRangeChange: _propTypes.default.func,

  /**
   * A callback fired when a date selection is made. Only fires when `selectable` is `true`.
   *
   * ```js
   * (
   *   slotInfo: {
   *     start: Date,
   *     end: Date,
   *     slots: Array<Date>,
   *     action: "select" | "click" | "doubleClick",
   *     bounds: ?{ // For "select" action
   *       x: number,
   *       y: number,
   *       top: number,
   *       right: number,
   *       left: number,
   *       bottom: number,
   *     },
   *     box: ?{ // For "click" or "doubleClick" actions
   *       clientX: number,
   *       clientY: number,
   *       x: number,
   *       y: number,
   *     },
   *   }
   * ) => any
   * ```
   */
  onSelectSlot: _propTypes.default.func,

  /**
   * Callback fired when a calendar event is selected.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => any
   * ```
   *
   * @controllable selected
   */
  onSelectEvent: _propTypes.default.func,

  /**
   * Callback fired when a calendar event is clicked twice.
   *
   * ```js
   * (event: Object, e: SyntheticEvent) => void
   * ```
   */
  onDoubleClickEvent: _propTypes.default.func,

  /**
   * Callback fired when dragging a selection in the Time views.
   *
   * Returning `false` from the handler will prevent a selection.
   *
   * ```js
   * (range: { start: Date, end: Date }) => ?boolean
   * ```
   */
  onSelecting: _propTypes.default.func,

  /**
   * The selected event, if any.
   */
  selected: _propTypes.default.object,

  /**
   * An array of built-in view names to allow the calendar to display.
   * accepts either an array of builtin view names,
   *
   * ```jsx
   * views={['month', 'day', 'agenda']}
   * ```
   * or an object hash of the view name and the component (or boolean for builtin).
   *
   * ```jsx
   * views={{
   *   month: true,
   *   week: false,
   *   myweek: WorkWeekViewComponent,
   * }}
   * ```
   *
   * Custom views can be any React component, that implements the following
   * interface:
   *
   * ```js
   * interface View {
   *   static title(date: Date, { formats: DateFormat[], culture: string?, ...props }): string
   *   static navigate(date: Date, action: 'PREV' | 'NEXT' | 'DATE'): Date
   * }
   * ```
   *
   * @type Calendar.Views ('month'|'week'|'work_week'|'day'|'agenda')
   * @View
   ['month', 'week', 'day', 'agenda']
   */
  views: _propTypes2.views,

  /**
   * The string name of the destination view for drill-down actions, such
   * as clicking a date header, or the truncated events links. If
   * `getDrilldownView` is also specified it will be used instead.
   *
   * Set to `null` to disable drill-down actions.
   *
   * ```js
   * <BigCalendar
   *   drilldownView="agenda"
   * />
   * ```
   */
  drilldownView: _propTypes.default.string,

  /**
   * Functionally equivalent to `drilldownView`, but accepts a function
   * that can return a view name. It's useful for customizing the drill-down
   * actions depending on the target date and triggering view.
   *
   * Return `null` to disable drill-down actions.
   *
   * ```js
   * <BigCalendar
   *   getDrilldownView={(targetDate, currentViewName, configuredViewNames) =>
   *     if (currentViewName === 'month' && configuredViewNames.includes('week'))
   *       return 'week'
   *
   *     return null;
   *   }}
   * />
   * ```
   */
  getDrilldownView: _propTypes.default.func,

  /**
   * Determines the end date from date prop in the agenda view
   * date prop + length (in number of days) = end date
   */
  length: _propTypes.default.number,

  /**
   * Determines whether the toolbar is displayed
   */
  toolbar: _propTypes.default.bool,

  /**
   * Show truncated events in an overlay when you click the "+_x_ more" link.
   */
  popup: _propTypes.default.bool,

  /**
   * Distance in pixels, from the edges of the viewport, the "show more" overlay should be positioned.
   *
   * ```jsx
   * <BigCalendar popupOffset={30}/>
   * <BigCalendar popupOffset={{x: 30, y: 20}}/>
   * ```
   */
  popupOffset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })]),

  /**
   * Allows mouse selection of ranges of dates/times.
   *
   * The 'ignoreEvents' option prevents selection code from running when a
   * drag begins over an event. Useful when you want custom event click or drag
   * logic
   */
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),

  /**
   * Specifies the number of miliseconds the user must press and hold on the screen for a touch
   * to be considered a "long press." Long presses are used for time slot selection on touch
   * devices.
   *
   * @type {number}
   * @default 250
   */
  longPressThreshold: _propTypes.default.number,

  /**
   * Determines the selectable time increments in week and day views
   */
  step: _propTypes.default.number,

  /**
   * The number of slots per "section" in the time grid views. Adjust with `step`
   * to change the default of 1 hour long groups, with 30 minute slots.
   */
  timeslots: _propTypes.default.number,

  /**
   *Switch the calendar to a `right-to-left` read direction.
   */
  rtl: _propTypes.default.bool,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the event node.
   *
   * ```js
   * (
   * 	event: Object,
   * 	start: Date,
   * 	end: Date,
   * 	isSelected: boolean
   * ) => { className?: string, style?: Object }
   * ```
   */
  eventPropGetter: _propTypes.default.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the time-slot node. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  slotPropGetter: _propTypes.default.func,

  /**
   * Optionally provide a function that returns an object of className or style props
   * to be applied to the the day background. Caution! Styles that change layout or
   * position may break the calendar in unexpected ways.
   *
   * ```js
   * (date: Date) => { className?: string, style?: Object }
   * ```
   */
  dayPropGetter: _propTypes.default.func,

  /**
   * Support to show multi-day events with specific start and end times in the
   * main time grid (rather than in the all day header).
   *
   * **Note: This may cause calendars with several events to look very busy in
   * the week and day views.**
   */
  showMultiDayTimes: _propTypes.default.bool,

  /**
   * Constrains the minimum _time_ of the Day and Week views.
   */
  min: _propTypes.default.instanceOf(Date),

  /**
   * Constrains the maximum _time_ of the Day and Week views.
   */
  max: _propTypes.default.instanceOf(Date),

  /**
   * Determines how far down the scroll pane is initially scrolled down.
   */
  scrollToTime: _propTypes.default.instanceOf(Date),

  /**
   * Specify a specific culture code for the Calendar.
   *
   * **Note: it's generally better to handle this globally via your i18n library.**
   */
  culture: _propTypes.default.string,

  /**
   * Localizer specific formats, tell the Calendar how to format and display dates.
   *
   * `format` types are dependent on the configured localizer; both Moment and Globalize
   * accept strings of tokens according to their own specification, such as: `'DD mm yyyy'`.
   *
   * ```jsx
   * let formats = {
   *   dateFormat: 'dd',
   *
   *   dayFormat: (date, , localizer) =>
   *     localizer.format(date, 'DDD', culture),
   *
   *   dayRangeHeaderFormat: ({ start, end }, culture, localizer) =>
   *     localizer.format(start, { date: 'short' }, culture) + ' — ' +
   *     localizer.format(end, { date: 'short' }, culture)
   * }
   *
   * <Calendar formats={formats} />
   * ```
   *
   * All localizers accept a function of
   * the form `(date: Date, culture: ?string, localizer: Localizer) -> string`
   */
  formats: _propTypes.default.shape({
    /**
     * Format for the day of the month heading in the Month view.
     * e.g. "01", "02", "03", etc
     */
    dateFormat: _propTypes2.dateFormat,

    /**
     * A day of the week format for Week and Day headings,
     * e.g. "Wed 01/04"
     *
     */
    dayFormat: _propTypes2.dateFormat,

    /**
     * Week day name format for the Month week day headings,
     * e.g: "Sun", "Mon", "Tue", etc
     *
     */
    weekdayFormat: _propTypes2.dateFormat,

    /**
     * The timestamp cell formats in Week and Time views, e.g. "4:00 AM"
     */
    timeGutterFormat: _propTypes2.dateFormat,

    /**
     * Toolbar header format for the Month view, e.g "2015 April"
     *
     */
    monthHeaderFormat: _propTypes2.dateFormat,

    /**
     * Toolbar header format for the Week views, e.g. "Mar 29 - Apr 04"
     */
    dayRangeHeaderFormat: _propTypes2.dateRangeFormat,

    /**
     * Toolbar header format for the Day view, e.g. "Wednesday Apr 01"
     */
    dayHeaderFormat: _propTypes2.dateFormat,

    /**
     * Toolbar header format for the Agenda view, e.g. "4/1/2015 — 5/1/2015"
     */
    agendaHeaderFormat: _propTypes2.dateRangeFormat,

    /**
     * A time range format for selecting time slots, e.g "8:00am — 2:00pm"
     */
    selectRangeFormat: _propTypes2.dateRangeFormat,
    agendaDateFormat: _propTypes2.dateFormat,
    agendaTimeFormat: _propTypes2.dateFormat,
    agendaTimeRangeFormat: _propTypes2.dateRangeFormat,

    /**
     * Time range displayed on events.
     */
    eventTimeRangeFormat: _propTypes2.dateRangeFormat,

    /**
     * An optional event time range for events that continue onto another day
     */
    eventTimeRangeStartFormat: _propTypes2.dateFormat,

    /**
     * An optional event time range for events that continue from another day
     */
    eventTimeRangeEndFormat: _propTypes2.dateFormat
  }),

  /**
   * Customize how different sections of the calendar render by providing custom Components.
   * In particular the `Event` component can be specified for the entire calendar, or you can
   * provide an individual component for each view type.
   *
   * ```jsx
   * let components = {
   *   event: MyEvent, // used by each view (Month, Day, Week)
   *   toolbar: MyToolbar,
   *   agenda: {
   *   	 event: MyAgendaEvent // with the agenda view use a different component to render events
   *   }
   * }
   * <Calendar components={components} />
   * ```
   */
  components: _propTypes.default.shape({
    event: _propTypes2.elementType,
    eventWrapper: _propTypes2.elementType,
    eventContainerWrapper: _propTypes2.elementType,
    dayWrapper: _propTypes2.elementType,
    dateCellWrapper: _propTypes2.elementType,
    timeSlotWrapper: _propTypes2.elementType,
    timeGutterHeader: _propTypes2.elementType,
    toolbar: _propTypes2.elementType,
    agenda: _propTypes.default.shape({
      date: _propTypes2.elementType,
      time: _propTypes2.elementType,
      event: _propTypes2.elementType
    }),
    day: _propTypes.default.shape({
      header: _propTypes2.elementType,
      event: _propTypes2.elementType
    }),
    week: _propTypes.default.shape({
      header: _propTypes2.elementType,
      event: _propTypes2.elementType
    }),
    month: _propTypes.default.shape({
      header: _propTypes2.elementType,
      dateHeader: _propTypes2.elementType,
      event: _propTypes2.elementType
    })
  }),

  /**
   * String messages used throughout the component, override to provide localizations
   */
  messages: _propTypes.default.shape({
    allDay: _propTypes.default.node,
    previous: _propTypes.default.node,
    next: _propTypes.default.node,
    today: _propTypes.default.node,
    month: _propTypes.default.node,
    week: _propTypes.default.node,
    day: _propTypes.default.node,
    agenda: _propTypes.default.node,
    date: _propTypes.default.node,
    time: _propTypes.default.node,
    event: _propTypes.default.node,
    noEventsInRange: _propTypes.default.node,
    showMore: _propTypes.default.func
  })
};
Calendar.defaultProps = {
  elementProps: {},
  popup: false,
  toolbar: true,
  view: _constants.views.MONTH,
  views: [_constants.views.MONTH, _constants.views.WEEK, _constants.views.DAY, _constants.views.AGENDA],
  step: 30,
  length: 30,
  drilldownView: _constants.views.DAY,
  titleAccessor: 'title',
  tooltipAccessor: 'title',
  allDayAccessor: 'allDay',
  startAccessor: 'start',
  endAccessor: 'end',
  resourceAccessor: 'resourceId',
  resourceIdAccessor: 'id',
  resourceTitleAccessor: 'title',
  longPressThreshold: 250,
  getNow: function getNow() {
    return new Date();
  }
};

var _default = (0, _uncontrollable.default)(Calendar, {
  view: 'onView',
  date: 'onNavigate',
  selected: 'onSelectEvent'
});

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(23));

var Utils = _interopRequireWildcard(__webpack_require__(1105));

var _jsxFileName = "src/index.js";

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype.__proto__ = superClass && superClass.prototype; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = Utils.canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = _objectWithoutProperties(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = _extends({
    innerRef: function innerRef() {}
  }, Utils.uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (_react.default.forwardRef) {
    WrappedComponent = _react.default.forwardRef(function (props, ref) {
      return _react.default.createElement(UncontrolledComponent, _extends({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}

module.exports = exports["default"];

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.canAcceptRef = canAcceptRef;

var _invariant = _interopRequireDefault(__webpack_require__(23));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.views = exports.dateRangeFormat = exports.dateFormat = exports.accessor = exports.eventComponent = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _elementType = _interopRequireDefault(__webpack_require__(466));

exports.elementType = _elementType.default;

var _all = _interopRequireDefault(__webpack_require__(1107));

var _constants = __webpack_require__(52);

var eventComponent = _propTypes.default.oneOfType([_elementType.default, _propTypes.default.shape({
  month: _elementType.default,
  week: _elementType.default,
  day: _elementType.default,
  agenda: _elementType.default
})]);

exports.eventComponent = eventComponent;
var viewNames = Object.keys(_constants.views).map(function (k) {
  return _constants.views[k];
});

var accessor = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]);

exports.accessor = accessor;
var dateFormat = _propTypes.default.any;
exports.dateFormat = dateFormat;
var dateRangeFormat = _propTypes.default.func;
/**
 * accepts either an array of builtin view names:
 *
 * ```
 * views={['month', 'day', 'agenda']}
 * ```
 *
 * or an object hash of the view name and the component (or boolean for builtin)
 *
 * ```
 * views={{
 *   month: true,
 *   week: false,
 *   workweek: WorkWeekViewComponent,
 * }}
 * ```
 */

exports.dateRangeFormat = dateRangeFormat;

var views = _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(viewNames)), (0, _all.default)(_propTypes.default.object, function (props, name) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var prop = props[name],
      err;
  Object.keys(prop).every(function (key) {
    var isBuiltinView = viewNames.indexOf(key) !== -1 && typeof prop[key] === 'boolean';
    return isBuiltinView || !(err = _elementType.default.apply(void 0, [prop, key].concat(args)));
  });
  return err || null;
})]);

exports.views = views;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(295);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = messages;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var defaultMessages = {
  date: 'Date',
  time: 'Time',
  event: 'Event',
  allDay: 'All Day',
  week: 'Week',
  work_week: 'Work Week',
  day: 'Day',
  month: 'Month',
  previous: 'Back',
  next: 'Next',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  today: 'Today',
  agenda: 'Agenda',
  noEventsInRange: 'There are no events in this range.',
  showMore: function showMore(total) {
    return "+" + total + " more";
  }
};

function messages(msgs) {
  return (0, _extends2.default)({}, defaultMessages, msgs);
}

module.exports = exports["default"];

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(21);

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _chunk = _interopRequireDefault(__webpack_require__(1111));

var _constants = __webpack_require__(52);

var _helpers = __webpack_require__(116);

var _position = _interopRequireDefault(__webpack_require__(469));

var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(471));

var _Popup = _interopRequireDefault(__webpack_require__(1114));

var _Overlay = _interopRequireDefault(__webpack_require__(1115));

var _DateContentRow = _interopRequireDefault(__webpack_require__(473));

var _Header = _interopRequireDefault(__webpack_require__(476));

var _DateHeader = _interopRequireDefault(__webpack_require__(1137));

var _eventLevels = __webpack_require__(149);

var eventsForWeek = function eventsForWeek(evts, start, end, accessors) {
  return evts.filter(function (e) {
    return (0, _eventLevels.inRange)(e, start, end, accessors);
  });
};

var propTypes = {
  events: _propTypes.default.array.isRequired,
  date: _propTypes.default.instanceOf(Date),
  min: _propTypes.default.instanceOf(Date),
  max: _propTypes.default.instanceOf(Date),
  step: _propTypes.default.number,
  getNow: _propTypes.default.func.isRequired,
  scrollToTime: _propTypes.default.instanceOf(Date),
  rtl: _propTypes.default.bool,
  width: _propTypes.default.number,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  selected: _propTypes.default.object,
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes.default.number,
  onNavigate: _propTypes.default.func,
  onSelectSlot: _propTypes.default.func,
  onSelectEvent: _propTypes.default.func,
  onDoubleClickEvent: _propTypes.default.func,
  onShowMore: _propTypes.default.func,
  onDrillDown: _propTypes.default.func,
  getDrilldownView: _propTypes.default.func.isRequired,
  popup: _propTypes.default.bool,
  popupOffset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })])
};

var MonthView =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MonthView, _React$Component);

  function MonthView() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.getContainer = function () {
      return (0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    };

    _this.renderWeek = function (week, weekIdx) {
      var _this$props = _this.props,
          events = _this$props.events,
          components = _this$props.components,
          selectable = _this$props.selectable,
          getNow = _this$props.getNow,
          selected = _this$props.selected,
          date = _this$props.date,
          localizer = _this$props.localizer,
          longPressThreshold = _this$props.longPressThreshold,
          accessors = _this$props.accessors,
          getters = _this$props.getters;
      var _this$state = _this.state,
          needLimitMeasure = _this$state.needLimitMeasure,
          rowLimit = _this$state.rowLimit;
      events = eventsForWeek(events, week[0], week[week.length - 1], accessors);
      events.sort(function (a, b) {
        return (0, _eventLevels.sortEvents)(a, b, accessors);
      });
      return _react.default.createElement(_DateContentRow.default, {
        key: weekIdx,
        ref: weekIdx === 0 ? 'slotRow' : undefined,
        container: _this.getContainer,
        className: "rbc-month-row",
        getNow: getNow,
        date: date,
        range: week,
        events: events,
        maxRows: rowLimit,
        selected: selected,
        selectable: selectable,
        components: components,
        accessors: accessors,
        getters: getters,
        localizer: localizer,
        renderHeader: _this.readerDateHeading,
        renderForMeasure: needLimitMeasure,
        onShowMore: _this.handleShowMore,
        onSelect: _this.handleSelectEvent,
        onDoubleClick: _this.handleDoubleClickEvent,
        onSelectSlot: _this.handleSelectSlot,
        longPressThreshold: longPressThreshold,
        rtl: _this.props.rtl
      });
    };

    _this.readerDateHeading = function (_ref) {
      var date = _ref.date,
          className = _ref.className,
          props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["date", "className"]);
      var _this$props2 = _this.props,
          currentDate = _this$props2.date,
          getDrilldownView = _this$props2.getDrilldownView,
          localizer = _this$props2.localizer;

      var isOffRange = _dates.default.month(date) !== _dates.default.month(currentDate);

      var isCurrent = _dates.default.eq(date, currentDate, 'day');

      var drilldownView = getDrilldownView(date);
      var label = localizer.format(date, 'dateFormat');
      var DateHeaderComponent = _this.props.components.dateHeader || _DateHeader.default;
      return _react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current')
      }), _react.default.createElement(DateHeaderComponent, {
        label: label,
        date: date,
        drilldownView: drilldownView,
        isOffRange: isOffRange,
        onDrillDown: function onDrillDown(e) {
          return _this.handleHeadingClick(date, drilldownView, e);
        }
      }));
    };

    _this.handleSelectSlot = function (range, slotInfo) {
      _this._pendingSelection = _this._pendingSelection.concat(range);
      clearTimeout(_this._selectTimer);
      _this._selectTimer = setTimeout(function () {
        return _this.selectDates(slotInfo);
      });
    };

    _this.handleHeadingClick = function (date, view, e) {
      e.preventDefault();

      _this.clearSelection();

      (0, _helpers.notify)(_this.props.onDrillDown, [date, view]);
    };

    _this.handleSelectEvent = function () {
      _this.clearSelection();

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (0, _helpers.notify)(_this.props.onSelectEvent, args);
    };

    _this.handleDoubleClickEvent = function () {
      _this.clearSelection();

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (0, _helpers.notify)(_this.props.onDoubleClickEvent, args);
    };

    _this.handleShowMore = function (events, date, cell, slot) {
      var _this$props3 = _this.props,
          popup = _this$props3.popup,
          onDrillDown = _this$props3.onDrillDown,
          onShowMore = _this$props3.onShowMore,
          getDrilldownView = _this$props3.getDrilldownView; //cancel any pending selections so only the event click goes through.

      _this.clearSelection();

      if (popup) {
        var position = (0, _position.default)(cell, (0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))));

        _this.setState({
          overlay: {
            date: date,
            events: events,
            position: position
          }
        });
      } else {
        (0, _helpers.notify)(onDrillDown, [date, getDrilldownView(date) || _constants.views.DAY]);
      }

      (0, _helpers.notify)(onShowMore, [events, date, slot]);
    };

    _this._bgRows = [];
    _this._pendingSelection = [];
    _this.state = {
      rowLimit: 5,
      needLimitMeasure: true
    };
    return _this;
  }

  var _proto = MonthView.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {
    var date = _ref2.date;
    this.setState({
      needLimitMeasure: !_dates.default.eq(date, this.props.date)
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var running;
    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
    window.addEventListener('resize', this._resizeListener = function () {
      if (!running) {
        (0, _requestAnimationFrame.default)(function () {
          running = false;

          _this2.setState({
            needLimitMeasure: true
          }); //eslint-disable-line

        });
      }
    }, false);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.needLimitMeasure) this.measureRowLimit(this.props);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._resizeListener, false);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        date = _this$props4.date,
        localizer = _this$props4.localizer,
        className = _this$props4.className,
        month = _dates.default.visibleDays(date, localizer),
        weeks = (0, _chunk.default)(month, 7);

    this._weekCount = weeks.length;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)('rbc-month-view', className)
    }, _react.default.createElement("div", {
      className: "rbc-row rbc-month-header"
    }, this.renderHeaders(weeks[0])), weeks.map(this.renderWeek), this.props.popup && this.renderOverlay());
  };

  _proto.renderHeaders = function renderHeaders(row) {
    var _this$props5 = this.props,
        localizer = _this$props5.localizer,
        components = _this$props5.components;
    var first = row[0];
    var last = row[row.length - 1];
    var HeaderComponent = components.header || _Header.default;
    return _dates.default.range(first, last, 'day').map(function (day, idx) {
      return _react.default.createElement("div", {
        key: 'header_' + idx,
        className: "rbc-header"
      }, _react.default.createElement(HeaderComponent, {
        date: day,
        localizer: localizer,
        label: localizer.format(day, 'weekdayFormat')
      }));
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    var _this3 = this;

    var overlay = this.state && this.state.overlay || {};
    var _this$props6 = this.props,
        accessors = _this$props6.accessors,
        localizer = _this$props6.localizer,
        components = _this$props6.components,
        getters = _this$props6.getters,
        selected = _this$props6.selected;
    return _react.default.createElement(_Overlay.default, {
      rootClose: true,
      placement: "bottom",
      container: this,
      show: !!overlay.position,
      onHide: function onHide() {
        return _this3.setState({
          overlay: null
        });
      }
    }, _react.default.createElement(_Popup.default, {
      accessors: accessors,
      getters: getters,
      selected: selected,
      components: components,
      localizer: localizer,
      position: overlay.position,
      events: overlay.events,
      slotStart: overlay.date,
      slotEnd: overlay.end,
      onSelect: this.handleSelectEvent,
      onDoubleClick: this.handleDoubleClickEvent
    }));
  };

  _proto.measureRowLimit = function measureRowLimit() {
    this.setState({
      needLimitMeasure: false,
      rowLimit: this.refs.slotRow.getRowLimit()
    });
  };

  _proto.selectDates = function selectDates(slotInfo) {
    var slots = this._pendingSelection.slice();

    this._pendingSelection = [];
    slots.sort(function (a, b) {
      return +a - +b;
    });
    (0, _helpers.notify)(this.props.onSelectSlot, {
      slots: slots,
      start: slots[0],
      end: slots[slots.length - 1],
      action: slotInfo.action
    });
  };

  _proto.clearSelection = function clearSelection() {
    clearTimeout(this._selectTimer);
    this._pendingSelection = [];
  };

  return MonthView;
}(_react.default.Component);

MonthView.displayName = 'MonthView';
MonthView.propTypes = propTypes;

MonthView.range = function (date, _ref3) {
  var localizer = _ref3.localizer;

  var start = _dates.default.firstVisibleDay(date, localizer);

  var end = _dates.default.lastVisibleDay(date, localizer);

  return {
    start: start,
    end: end
  };
};

MonthView.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates.default.add(date, -1, 'month');

    case _constants.navigate.NEXT:
      return _dates.default.add(date, 1, 'month');

    default:
      return date;
  }
};

MonthView.title = function (date, _ref4) {
  var localizer = _ref4.localizer;
  return localizer.format(date, 'monthHeaderFormat');
};

var _default = MonthView;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

var MILI    = 'milliseconds'
  , SECONDS = 'seconds'
  , MINUTES = 'minutes'
  , HOURS   = 'hours'
  , DAY     = 'day'
  , WEEK    = 'week'
  , MONTH   = 'month'
  , YEAR    = 'year'
  , DECADE  = 'decade'
  , CENTURY = 'century';

var dates = module.exports = {

  add: function(date, num, unit) {
    date = new Date(date)

    switch (unit){
      case MILI:
      case SECONDS:
      case MINUTES:
      case HOURS:
      case YEAR:
        return dates[unit](date, dates[unit](date) + num)
      case DAY:
        return dates.date(date, dates.date(date) + num)
      case WEEK:
        return dates.date(date, dates.date(date) + (7 * num)) 
      case MONTH:
        return monthMath(date, num)
      case DECADE:
        return dates.year(date, dates.year(date) + (num * 10))
      case CENTURY:
        return dates.year(date, dates.year(date) + (num * 100))
    }

    throw new TypeError('Invalid units: "' + unit + '"')
  },

  subtract: function(date, num, unit) {
    return dates.add(date, -num, unit)
  },

  startOf: function(date, unit, firstOfWeek) {
    date = new Date(date)

    switch (unit) {
      case 'century':
      case 'decade':
      case 'year':
          date = dates.month(date, 0);
      case 'month':
          date = dates.date(date, 1);
      case 'week':
      case 'day':
          date = dates.hours(date, 0);
      case 'hours':
          date = dates.minutes(date, 0);
      case 'minutes':
          date = dates.seconds(date, 0);
      case 'seconds':
          date = dates.milliseconds(date, 0);
    }

    if (unit === DECADE) 
      date = dates.subtract(date, dates.year(date) % 10, 'year')
    
    if (unit === CENTURY) 
      date = dates.subtract(date, dates.year(date) % 100, 'year')

    if (unit === WEEK) 
      date = dates.weekday(date, 0, firstOfWeek);

    return date
  },


  endOf: function(date, unit, firstOfWeek){
    date = new Date(date)
    date = dates.startOf(date, unit, firstOfWeek)
    date = dates.add(date, 1, unit)
    date = dates.subtract(date, 1, MILI)
    return date
  },

  eq:  createComparer(function(a, b){ return a === b }),
  neq: createComparer(function(a, b){ return a !== b }),
  gt:  createComparer(function(a, b){ return a > b }),
  gte: createComparer(function(a, b){ return a >= b }),
  lt:  createComparer(function(a, b){ return a < b }),
  lte: createComparer(function(a, b){ return a <= b }),

  min: function(){
    return new Date(Math.min.apply(Math, arguments))
  },

  max: function(){
    return new Date(Math.max.apply(Math, arguments))
  },
  
  inRange: function(day, min, max, unit){
    unit = unit || 'day'

    return (!min || dates.gte(day, min, unit))
        && (!max || dates.lte(day, max, unit))
  },

  milliseconds:   createAccessor('Milliseconds'),
  seconds:        createAccessor('Seconds'),
  minutes:        createAccessor('Minutes'),
  hours:          createAccessor('Hours'),
  day:            createAccessor('Day'),
  date:           createAccessor('Date'),
  month:          createAccessor('Month'),
  year:           createAccessor('FullYear'),

  decade: function (date, val) {
    return val === undefined 
      ? dates.year(dates.startOf(date, DECADE))
      : dates.add(date, val + 10, YEAR);
  },

  century: function (date, val) {
    return val === undefined 
      ? dates.year(dates.startOf(date, CENTURY))
      : dates.add(date, val + 100, YEAR);
  },

  weekday: function (date, val, firstDay) {
      var weekday = (dates.day(date) + 7 - (firstDay || 0) ) % 7;

      return val === undefined 
        ? weekday 
        : dates.add(date, val - weekday, DAY);
  },

  diff: function (date1, date2, unit, asFloat) {
    var dividend, divisor, result;

    switch (unit) {
      case MILI:
      case SECONDS:
      case MINUTES:
      case HOURS:
      case DAY:
      case WEEK:
        dividend = date2.getTime() - date1.getTime(); break;
      case MONTH:
      case YEAR:
      case DECADE:
      case CENTURY:
        dividend = (dates.year(date2) - dates.year(date1)) * 12 + dates.month(date2) - dates.month(date1); break;
      default:
        throw new TypeError('Invalid units: "' + unit + '"');
    }

    switch (unit) {
      case MILI:
          divisor = 1; break;
      case SECONDS:
          divisor = 1000; break;
      case MINUTES:
          divisor = 1000 * 60; break;
      case HOURS:
          divisor = 1000 * 60 * 60; break;
      case DAY:
          divisor = 1000 * 60 * 60 * 24; break;
      case WEEK:
          divisor = 1000 * 60 * 60 * 24 * 7; break;
      case MONTH:
          divisor = 1; break;
      case YEAR:
          divisor = 12; break;
      case DECADE:
          divisor = 120; break;
      case CENTURY:
          divisor = 1200; break;
      default:
        throw new TypeError('Invalid units: "' + unit + '"');
    }

    result = dividend / divisor;

    return asFloat ? result : absoluteFloor(result);
  }
};

function absoluteFloor(number) {
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function monthMath(date, val){
  var current = dates.month(date)
    , newMonth  = (current + val);

    date = dates.month(date, newMonth)

    while (newMonth < 0 ) newMonth = 12 + newMonth
      
    //month rollover
    if ( dates.month(date) !== ( newMonth % 12))
      date = dates.date(date, 0) //move to last of month

    return date
}

function createAccessor(method){
  return function(date, val){
    if (val === undefined)
      return date['get' + method]()

    date = new Date(date)
    date['set' + method](val)
    return date
  }
}

function createComparer(operator) {
  return function (a, b, unit) {
    return operator(+dates.startOf(a, unit), +dates.startOf(b, unit))
  };
}


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(291),
    isIterateeCall = __webpack_require__(145),
    toInteger = __webpack_require__(277);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(296));

var _style = _interopRequireDefault(__webpack_require__(218));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _offset = _interopRequireDefault(__webpack_require__(146));

var _scrollTop = _interopRequireDefault(__webpack_require__(297));

var _scrollLeft = _interopRequireDefault(__webpack_require__(470));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _EventCell = _interopRequireDefault(__webpack_require__(472));

var _selection = __webpack_require__(147);

var propTypes = {
  position: _propTypes.default.object,
  popupOffset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })]),
  events: _propTypes.default.array,
  selected: _propTypes.default.object,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  onSelect: _propTypes.default.func,
  onDoubleClick: _propTypes.default.func,
  slotStart: _propTypes.default.number,
  slotEnd: _propTypes.default.number
};

var Popup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Popup, _React$Component);

  function Popup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props$popupOffs = this.props.popupOffset,
        popupOffset = _this$props$popupOffs === void 0 ? 5 : _this$props$popupOffs,
        _getOffset = (0, _offset.default)(this.refs.root),
        top = _getOffset.top,
        left = _getOffset.left,
        width = _getOffset.width,
        height = _getOffset.height,
        viewBottom = window.innerHeight + (0, _scrollTop.default)(window),
        viewRight = window.innerWidth + (0, _scrollLeft.default)(window),
        bottom = top + height,
        right = left + width;

    if (bottom > viewBottom || right > viewRight) {
      var topOffset, leftOffset;
      if (bottom > viewBottom) topOffset = bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
      if (right > viewRight) leftOffset = right - viewRight + (popupOffset.x || +popupOffset || 0);
      this.setState({
        topOffset: topOffset,
        leftOffset: leftOffset
      }); //eslint-disable-line
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        events = _this$props.events,
        selected = _this$props.selected,
        getters = _this$props.getters,
        accessors = _this$props.accessors,
        components = _this$props.components,
        onSelect = _this$props.onSelect,
        onDoubleClick = _this$props.onDoubleClick,
        slotStart = _this$props.slotStart,
        slotEnd = _this$props.slotEnd,
        localizer = _this$props.localizer;
    var _this$props$position = this.props.position,
        left = _this$props$position.left,
        width = _this$props$position.width,
        top = _this$props$position.top,
        topOffset = (this.state || {}).topOffset || 0,
        leftOffset = (this.state || {}).leftOffset || 0;
    var style = {
      top: Math.max(0, top - topOffset),
      left: left - leftOffset,
      minWidth: width + width / 2
    };
    return _react.default.createElement("div", {
      ref: "root",
      style: style,
      className: "rbc-overlay"
    }, _react.default.createElement("div", {
      className: "rbc-overlay-header"
    }, localizer.format(slotStart, 'dayHeaderFormat')), events.map(function (event, idx) {
      return _react.default.createElement(_EventCell.default, {
        key: idx,
        type: "popup",
        event: event,
        getters: getters,
        onSelect: onSelect,
        accessors: accessors,
        components: components,
        onDoubleClick: onDoubleClick,
        continuesPrior: _dates.default.lt(accessors.end(event), slotStart, 'day'),
        continuesAfter: _dates.default.gte(accessors.start(event), slotEnd, 'day'),
        selected: (0, _selection.isSelected)(event, selected)
      });
    }));
  };

  return Popup;
}(_react.default.Component);

Popup.propTypes = propTypes;
var _default = Popup;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(466);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(1116);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1118);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(1120);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(298);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(299);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(148);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1117);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(298);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(299);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(148);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(298);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1119);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(299);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(148);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(146);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(469);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(297);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(148);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(203);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(1121);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(148);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(171);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(172);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = height;

var _offset = _interopRequireDefault(__webpack_require__(146));

var _isWindow = _interopRequireDefault(__webpack_require__(92));

function height(node, client) {
  var win = (0, _isWindow.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
}

module.exports = exports["default"];

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(21);

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _helpers = __webpack_require__(116);

var _selection = __webpack_require__(147);

var _Selection = _interopRequireWildcard(__webpack_require__(474));

var BackgroundCells =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(BackgroundCells, _React$Component);

  function BackgroundCells(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.state = {
      selecting: false
    };
    return _this;
  }

  var _proto = BackgroundCells.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();
    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        range = _this$props.range,
        getNow = _this$props.getNow,
        getters = _this$props.getters,
        currentDate = _this$props.date,
        Wrapper = _this$props.components.dateCellWrapper;
    var _this$state = this.state,
        selecting = _this$state.selecting,
        startIdx = _this$state.startIdx,
        endIdx = _this$state.endIdx;
    var current = getNow();
    return _react.default.createElement("div", {
      className: "rbc-row-bg"
    }, range.map(function (date, index) {
      var selected = selecting && index >= startIdx && index <= endIdx;

      var _getters$dayProp = getters.dayProp(date),
          className = _getters$dayProp.className,
          style = _getters$dayProp.style;

      return _react.default.createElement(Wrapper, {
        key: index,
        value: date,
        range: range
      }, _react.default.createElement("div", {
        style: style,
        className: (0, _classnames.default)('rbc-day-bg', className, selected && 'rbc-selected-cell', _dates.default.eq(date, current, 'day') && 'rbc-today', currentDate && _dates.default.month(currentDate) !== _dates.default.month(date) && 'rbc-off-range-bg')
      }));
    }));
  };

  _proto._selectable = function _selectable() {
    var _this2 = this;

    var node = (0, _reactDom.findDOMNode)(this);
    var selector = this._selector = new _Selection.default(this.props.container, {
      longPressThreshold: this.props.longPressThreshold
    });

    var selectorClicksHandler = function selectorClicksHandler(point, actionType) {
      if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), point)) {
        var rowBox = (0, _Selection.getBoundsForNode)(node);
        var _this2$props = _this2.props,
            range = _this2$props.range,
            rtl = _this2$props.rtl;

        if ((0, _selection.pointInBox)(rowBox, point)) {
          var currentCell = (0, _selection.getSlotAtX)(rowBox, point.x, rtl, range.length);

          _this2._selectSlot({
            startIdx: currentCell,
            endIdx: currentCell,
            action: actionType,
            box: point
          });
        }
      }

      _this2._initial = {};

      _this2.setState({
        selecting: false
      });
    };

    selector.on('selecting', function (box) {
      var _this2$props2 = _this2.props,
          range = _this2$props2.range,
          rtl = _this2$props2.rtl;
      var startIdx = -1;
      var endIdx = -1;

      if (!_this2.state.selecting) {
        (0, _helpers.notify)(_this2.props.onSelectStart, [box]);
        _this2._initial = {
          x: box.x,
          y: box.y
        };
      }

      if (selector.isSelected(node)) {
        var nodeBox = (0, _Selection.getBoundsForNode)(node);

        var _dateCellSelection = (0, _selection.dateCellSelection)(_this2._initial, nodeBox, box, range.length, rtl);

        startIdx = _dateCellSelection.startIdx;
        endIdx = _dateCellSelection.endIdx;
      }

      _this2.setState({
        selecting: true,
        startIdx: startIdx,
        endIdx: endIdx
      });
    });
    selector.on('beforeSelect', function (box) {
      if (_this2.props.selectable !== 'ignoreEvents') return;
      return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)(_this2), box);
    });
    selector.on('click', function (point) {
      return selectorClicksHandler(point, 'click');
    });
    selector.on('doubleClick', function (point) {
      return selectorClicksHandler(point, 'doubleClick');
    });
    selector.on('select', function (bounds) {
      _this2._selectSlot((0, _extends2.default)({}, _this2.state, {
        action: 'select',
        bounds: bounds
      }));

      _this2._initial = {};

      _this2.setState({
        selecting: false
      });

      (0, _helpers.notify)(_this2.props.onSelectEnd, [_this2.state]);
    });
  };

  _proto._teardownSelectable = function _teardownSelectable() {
    if (!this._selector) return;

    this._selector.teardown();

    this._selector = null;
  };

  _proto._selectSlot = function _selectSlot(_ref) {
    var endIdx = _ref.endIdx,
        startIdx = _ref.startIdx,
        action = _ref.action,
        bounds = _ref.bounds,
        box = _ref.box;
    if (endIdx !== -1 && startIdx !== -1) this.props.onSelectSlot && this.props.onSelectSlot({
      start: startIdx,
      end: endIdx,
      action: action,
      bounds: bounds,
      box: box
    });
  };

  return BackgroundCells;
}(_react.default.Component);

BackgroundCells.propTypes = {
  date: _propTypes.default.instanceOf(Date),
  getNow: _propTypes.default.func.isRequired,
  getters: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  container: _propTypes.default.func,
  dayPropGetter: _propTypes.default.func,
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes.default.number,
  onSelectSlot: _propTypes.default.func.isRequired,
  onSelectEnd: _propTypes.default.func,
  onSelectStart: _propTypes.default.func,
  range: _propTypes.default.arrayOf(_propTypes.default.instanceOf(Date)),
  rtl: _propTypes.default.bool,
  type: _propTypes.default.string
};
var _default = BackgroundCells;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = closest;

var _matches = _interopRequireDefault(__webpack_require__(1125));

var isDoc = function isDoc(obj) {
  return obj != null && obj.nodeType === obj.DOCUMENT_NODE;
};

function closest(node, selector, context) {
  while (node && (isDoc(node) || !(0, _matches.default)(node, selector))) {
    node = node !== context && !isDoc(node) ? node.parentNode : undefined;
  }

  return node;
}

module.exports = exports["default"];

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = matches;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(300));

var matchesCache;

function matches(node, selector) {
  if (!matchesCache && _inDOM.default) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
    matchesCache = nativeMatch ? function (node, selector) {
      return nativeMatch.call(node, selector);
    } : ie8MatchesSelector;
  }

  return matchesCache ? matchesCache(node, selector) : null;
}

function ie8MatchesSelector(node, selector) {
  var matches = (0, _querySelectorAll.default)(node.document || node.ownerDocument, selector),
      i = 0;

  while (matches[i] && matches[i] !== node) {
    i++;
  }

  return !!matches[i];
}

module.exports = exports["default"];

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(171));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(172));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1127));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1128));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(203));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(300));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(67));

var _on = _interopRequireDefault(__webpack_require__(171));

var _off = _interopRequireDefault(__webpack_require__(172));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _EventRowMixin = _interopRequireDefault(__webpack_require__(475));

var EventRow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(EventRow, _React$Component);

  function EventRow() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EventRow.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        segments = _this$props.segments,
        slots = _this$props.slotMetrics.slots,
        className = _this$props.className;
    var lastEnd = 1;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)(className, 'rbc-row')
    }, segments.reduce(function (row, _ref, li) {
      var event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span;
      var key = '_lvl_' + li;
      var gap = left - lastEnd;

      var content = _EventRowMixin.default.renderEvent(_this.props, event);

      if (gap) row.push(_EventRowMixin.default.renderSpan(slots, gap, key + "_gap"));
      row.push(_EventRowMixin.default.renderSpan(slots, span, key, content));
      lastEnd = right + 1;
      return row;
    }, []));
  };

  return EventRow;
}(_react.default.Component);

EventRow.propTypes = (0, _extends2.default)({
  segments: _propTypes.default.array
}, _EventRowMixin.default.propTypes);
EventRow.defaultProps = (0, _extends2.default)({}, _EventRowMixin.default.defaultProps);
var _default = EventRow;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _EventRowMixin = _interopRequireDefault(__webpack_require__(475));

var _eventLevels = __webpack_require__(149);

var _range = _interopRequireDefault(__webpack_require__(1132));

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};

var eventsInSlot = function eventsInSlot(segments, slot) {
  return segments.filter(function (seg) {
    return isSegmentInSlot(seg, slot);
  }).length;
};

var EventEndingRow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(EventEndingRow, _React$Component);

  function EventEndingRow() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = EventEndingRow.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        segments = _this$props.segments,
        slots = _this$props.slotMetrics.slots;
    var rowSegments = (0, _eventLevels.eventLevels)(segments).levels[0];
    var current = 1,
        lastEnd = 1,
        row = [];

    while (current <= slots) {
      var key = '_lvl_' + current;

      var _ref = rowSegments.filter(function (seg) {
        return isSegmentInSlot(seg, current);
      })[0] || {},
          event = _ref.event,
          left = _ref.left,
          right = _ref.right,
          span = _ref.span; //eslint-disable-line


      if (!event) {
        current++;
        continue;
      }

      var gap = Math.max(0, left - lastEnd);

      if (this.canRenderSlotEvent(left, span)) {
        var content = _EventRowMixin.default.renderEvent(this.props, event);

        if (gap) {
          row.push(_EventRowMixin.default.renderSpan(slots, gap, key + '_gap'));
        }

        row.push(_EventRowMixin.default.renderSpan(slots, span, key, content));
        lastEnd = current = right + 1;
      } else {
        if (gap) {
          row.push(_EventRowMixin.default.renderSpan(slots, gap, key + '_gap'));
        }

        row.push(_EventRowMixin.default.renderSpan(slots, 1, key, this.renderShowMore(segments, current)));
        lastEnd = current = current + 1;
      }
    }

    return _react.default.createElement("div", {
      className: "rbc-row"
    }, row);
  };

  _proto.canRenderSlotEvent = function canRenderSlotEvent(slot, span) {
    var segments = this.props.segments;
    return (0, _range.default)(slot, slot + span).every(function (s) {
      var count = eventsInSlot(segments, s);
      return count === 1;
    });
  };

  _proto.renderShowMore = function renderShowMore(segments, slot) {
    var _this = this;

    var localizer = this.props.localizer;
    var count = eventsInSlot(segments, slot);
    return count ? _react.default.createElement("a", {
      key: 'sm_' + slot,
      href: "#",
      className: 'rbc-show-more',
      onClick: function onClick(e) {
        return _this.showMore(slot, e);
      }
    }, localizer.messages.showMore(count)) : false;
  };

  _proto.showMore = function showMore(slot, e) {
    e.preventDefault();
    this.props.onShowMore(slot);
  };

  return EventEndingRow;
}(_react.default.Component);

EventEndingRow.propTypes = (0, _extends2.default)({
  segments: _propTypes.default.array,
  slots: _propTypes.default.number,
  onShowMore: _propTypes.default.func
}, _EventRowMixin.default.propTypes);
EventEndingRow.defaultProps = (0, _extends2.default)({}, _EventRowMixin.default.defaultProps);
var _default = EventEndingRow;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(445),
    baseIteratee = __webpack_require__(142),
    toInteger = __webpack_require__(277);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1133);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1134),
    isIterateeCall = __webpack_require__(145),
    toFinite = __webpack_require__(446);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.getSlotMetrics = getSlotMetrics;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _memoizeOne = _interopRequireDefault(__webpack_require__(1136));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _eventLevels2 = __webpack_require__(149);

var isSegmentInSlot = function isSegmentInSlot(seg, slot) {
  return seg.left <= slot && seg.right >= slot;
};

var isEqual = function isEqual(a, b) {
  return a.range === b.range && a.events === b.events;
};

function getSlotMetrics() {
  return (0, _memoizeOne.default)(function (options) {
    var range = options.range,
        events = options.events,
        maxRows = options.maxRows,
        minRows = options.minRows,
        accessors = options.accessors;

    var _endOfRange = (0, _eventLevels2.endOfRange)(range),
        first = _endOfRange.first,
        last = _endOfRange.last;

    var segments = events.map(function (evt) {
      return (0, _eventLevels2.eventSegments)(evt, range, accessors);
    });

    var _eventLevels = (0, _eventLevels2.eventLevels)(segments, Math.max(maxRows - 1, 1)),
        levels = _eventLevels.levels,
        extra = _eventLevels.extra;

    while (levels.length < minRows) {
      levels.push([]);
    }

    return {
      first: first,
      last: last,
      levels: levels,
      extra: extra,
      range: range,
      slots: range.length,
      clone: function clone(args) {
        var metrics = getSlotMetrics();
        return metrics((0, _extends2.default)({}, options, args));
      },
      getDateForSlot: function getDateForSlot(slotNumber) {
        return range[slotNumber];
      },
      getSlotForDate: function getSlotForDate(date) {
        return range.find(function (r) {
          return _dates.default.eq(r, date, 'day');
        });
      },
      getEventsForSlot: function getEventsForSlot(slot) {
        return segments.filter(function (seg) {
          return isSegmentInSlot(seg, slot);
        }).map(function (seg) {
          return seg.event;
        });
      },
      continuesPrior: function continuesPrior(event) {
        return _dates.default.lt(accessors.start(event), first, 'day');
      },
      continuesAfter: function continuesAfter(event) {
        var eventEnd = accessors.end(event);

        var singleDayDuration = _dates.default.eq(accessors.start(event), eventEnd, 'minutes');

        return singleDayDuration ? _dates.default.gte(eventEnd, last, 'minutes') : _dates.default.gt(eventEnd, last, 'minutes');
      }
    };
  }, isEqual);
}

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var DateHeader = function DateHeader(_ref) {
  var label = _ref.label,
      drilldownView = _ref.drilldownView,
      onDrillDown = _ref.onDrillDown;

  if (!drilldownView) {
    return _react.default.createElement("span", null, label);
  }

  return _react.default.createElement("a", {
    href: "#",
    onClick: onDrillDown
  }, label);
};

DateHeader.propTypes = {
  label: _propTypes.default.node,
  date: _propTypes.default.instanceOf(Date),
  drilldownView: _propTypes.default.string,
  onDrillDown: _propTypes.default.func,
  isOffRange: _propTypes.default.bool
};
var _default = DateHeader;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _constants = __webpack_require__(52);

var _TimeGrid = _interopRequireDefault(__webpack_require__(301));

var Day =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Day, _React$Component);

  function Day() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Day.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        date = _this$props.date,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["date"]);
    var range = Day.range(date);
    return _react.default.createElement(_TimeGrid.default, (0, _extends2.default)({}, props, {
      range: range,
      eventOffset: 10
    }));
  };

  return Day;
}(_react.default.Component);

Day.propTypes = {
  date: _propTypes.default.instanceOf(Date).isRequired
};

Day.range = function (date) {
  return [_dates.default.startOf(date, 'day')];
};

Day.navigate = function (date, action) {
  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates.default.add(date, -1, 'day');

    case _constants.navigate.NEXT:
      return _dates.default.add(date, 1, 'day');

    default:
      return date;
  }
};

Day.title = function (date, _ref) {
  var localizer = _ref.localizer;
  return localizer.format(date, 'dayHeaderFormat');
};

var _default = Day;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(63));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(21);

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Selection = _interopRequireWildcard(__webpack_require__(474));

var _dates = _interopRequireDefault(__webpack_require__(32));

var TimeSlotUtils = _interopRequireWildcard(__webpack_require__(477));

var _selection = __webpack_require__(147);

var _helpers = __webpack_require__(116);

var DayEventLayout = _interopRequireWildcard(__webpack_require__(1140));

var _TimeSlotGroup = _interopRequireDefault(__webpack_require__(479));

var _TimeGridEvent = _interopRequireDefault(__webpack_require__(1148));

var DayColumn =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DayColumn, _React$Component);

  function DayColumn() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.state = {
      selecting: false
    };

    _this.renderEvents = function () {
      var _this$props = _this.props,
          events = _this$props.events,
          isRtl = _this$props.rtl,
          selected = _this$props.selected,
          accessors = _this$props.accessors,
          localizer = _this$props.localizer,
          getters = _this$props.getters,
          components = _this$props.components,
          step = _this$props.step,
          timeslots = _this$props.timeslots;

      var _assertThisInitialize = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)),
          slotMetrics = _assertThisInitialize.slotMetrics;

      var messages = localizer.messages;
      var styledEvents = DayEventLayout.getStyledEvents({
        events: events,
        accessors: accessors,
        slotMetrics: slotMetrics,
        minimumStartDifference: Math.ceil(step * timeslots / 2)
      });
      return styledEvents.map(function (_ref, idx) {
        var _React$createElement;

        var event = _ref.event,
            style = _ref.style;
        var end = accessors.end(event);
        var start = accessors.start(event);
        var format = 'eventTimeRangeFormat';
        var label;
        var startsBeforeDay = slotMetrics.startsBeforeDay(start);
        var startsAfterDay = slotMetrics.startsAfterDay(end);
        if (startsBeforeDay) format = 'eventTimeRangeEndFormat';else if (startsAfterDay) format = 'eventTimeRangeStartFormat';
        if (startsBeforeDay && startsAfterDay) label = messages.allDay;else label = localizer.format({
          start: start,
          end: end
        }, format);
        var continuesEarlier = startsBeforeDay || slotMetrics.startsBefore(start);
        var continuesLater = startsAfterDay || slotMetrics.startsAfter(end);
        return _react.default.createElement(_TimeGridEvent.default, (_React$createElement = {
          style: style,
          event: event,
          label: label,
          key: 'evt_' + idx,
          getters: getters,
          isRtl: isRtl
        }, _React$createElement["getters"] = getters, _React$createElement.components = components, _React$createElement.continuesEarlier = continuesEarlier, _React$createElement.continuesLater = continuesLater, _React$createElement.accessors = accessors, _React$createElement.selected = (0, _selection.isSelected)(event, selected), _React$createElement.onClick = function onClick(e) {
          return _this._select(event, e);
        }, _React$createElement.onDoubleClick = function onDoubleClick(e) {
          return _this._doubleClick(event, e);
        }, _React$createElement));
      });
    };

    _this._selectable = function () {
      var node = (0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      var selector = _this._selector = new _Selection.default(function () {
        return (0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      }, {
        longPressThreshold: _this.props.longPressThreshold
      });

      var maybeSelect = function maybeSelect(box) {
        var onSelecting = _this.props.onSelecting;
        var current = _this.state || {};
        var state = selectionState(box);
        var start = state.startDate,
            end = state.endDate;

        if (onSelecting) {
          if (_dates.default.eq(current.startDate, start, 'minutes') && _dates.default.eq(current.endDate, end, 'minutes') || onSelecting({
            start: start,
            end: end
          }) === false) return;
        }

        if (_this.state.start !== state.start || _this.state.end !== state.end || _this.state.selecting !== state.selecting) {
          _this.setState(state);
        }
      };

      var selectionState = function selectionState(point) {
        var currentSlot = _this.slotMetrics.closestSlotFromPoint(point, (0, _Selection.getBoundsForNode)(node));

        if (!_this.state.selecting) _this._initialSlot = currentSlot;
        var initialSlot = _this._initialSlot;
        if (initialSlot === currentSlot) currentSlot = _this.slotMetrics.nextSlot(initialSlot);

        var selectRange = _this.slotMetrics.getRange(_dates.default.min(initialSlot, currentSlot), _dates.default.max(initialSlot, currentSlot));

        return (0, _extends2.default)({}, selectRange, {
          selecting: true,
          top: selectRange.top + "%",
          height: selectRange.height + "%"
        });
      };

      var selectorClicksHandler = function selectorClicksHandler(box, actionType) {
        if (!(0, _Selection.isEvent)((0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))), box)) {
          var _selectionState = selectionState(box),
              startDate = _selectionState.startDate,
              endDate = _selectionState.endDate;

          _this._selectSlot({
            startDate: startDate,
            endDate: endDate,
            action: actionType,
            box: box
          });
        }

        _this.setState({
          selecting: false
        });
      };

      selector.on('selecting', maybeSelect);
      selector.on('selectStart', maybeSelect);
      selector.on('beforeSelect', function (box) {
        if (_this.props.selectable !== 'ignoreEvents') return;
        return !(0, _Selection.isEvent)((0, _reactDom.findDOMNode)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))), box);
      });
      selector.on('click', function (box) {
        return selectorClicksHandler(box, 'click');
      });
      selector.on('doubleClick', function (box) {
        return selectorClicksHandler(box, 'doubleClick');
      });
      selector.on('select', function (bounds) {
        if (_this.state.selecting) {
          _this._selectSlot((0, _extends2.default)({}, _this.state, {
            action: 'select',
            bounds: bounds
          }));

          _this.setState({
            selecting: false
          });
        }
      });
    };

    _this._teardownSelectable = function () {
      if (!_this._selector) return;

      _this._selector.teardown();

      _this._selector = null;
    };

    _this._selectSlot = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate,
          action = _ref2.action,
          bounds = _ref2.bounds,
          box = _ref2.box;
      var current = startDate,
          slots = [];

      while (_dates.default.lte(current, endDate)) {
        slots.push(current);
        current = _dates.default.add(current, _this.props.step, 'minutes');
      }

      (0, _helpers.notify)(_this.props.onSelectSlot, {
        slots: slots,
        start: startDate,
        end: endDate,
        resourceId: _this.props.resource,
        action: action,
        bounds: bounds,
        box: box
      });
    };

    _this._select = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (0, _helpers.notify)(_this.props.onSelectEvent, args);
    };

    _this._doubleClick = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (0, _helpers.notify)(_this.props.onDoubleClickEvent, args);
    };

    _this.slotMetrics = TimeSlotUtils.getSlotMetrics(_this.props);
    return _this;
  }

  var _proto = DayColumn.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.selectable && this._selectable();

    if (this.props.isNow) {
      this.positionTimeIndicator();
      this.triggerTimeIndicatorUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._teardownSelectable();

    window.clearTimeout(this._timeIndicatorTimeout);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.selectable && !this.props.selectable) this._selectable();
    if (!nextProps.selectable && this.props.selectable) this._teardownSelectable();
    this.slotMetrics = this.slotMetrics.update(nextProps);
  };

  _proto.triggerTimeIndicatorUpdate = function triggerTimeIndicatorUpdate() {
    var _this2 = this;

    // Update the position of the time indicator every minute
    this._timeIndicatorTimeout = window.setTimeout(function () {
      _this2.positionTimeIndicator();

      _this2.triggerTimeIndicatorUpdate();
    }, 60000);
  };

  _proto.positionTimeIndicator = function positionTimeIndicator() {
    var _this$props2 = this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        getNow = _this$props2.getNow;
    var current = getNow();
    var timeIndicator = this.refs.timeIndicator;

    if (current >= min && current <= max) {
      var _this$slotMetrics$get = this.slotMetrics.getRange(current, current),
          top = _this$slotMetrics$get.top;

      timeIndicator.style.top = top + "%";
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        max = _this$props3.max,
        rtl = _this$props3.rtl,
        isNow = _this$props3.isNow,
        resource = _this$props3.resource,
        accessors = _this$props3.accessors,
        localizer = _this$props3.localizer,
        _this$props3$getters = _this$props3.getters,
        dayProp = _this$props3$getters.dayProp,
        getters = (0, _objectWithoutPropertiesLoose2.default)(_this$props3$getters, ["dayProp"]),
        _this$props3$componen = _this$props3.components,
        EventContainer = _this$props3$componen.eventContainerWrapper,
        components = (0, _objectWithoutPropertiesLoose2.default)(_this$props3$componen, ["eventContainerWrapper"]);
    var slotMetrics = this.slotMetrics;
    var _this$state = this.state,
        selecting = _this$state.selecting,
        top = _this$state.top,
        height = _this$state.height,
        startDate = _this$state.startDate,
        endDate = _this$state.endDate;
    var selectDates = {
      start: startDate,
      end: endDate
    };

    var _dayProp = dayProp(max),
        className = _dayProp.className,
        style = _dayProp.style;

    return _react.default.createElement("div", {
      style: style,
      className: (0, _classnames.default)(className, 'rbc-day-slot', 'rbc-time-column', isNow && 'rbc-now', isNow && 'rbc-today', // WHY
      selecting && 'rbc-slot-selecting')
    }, slotMetrics.groups.map(function (grp, idx) {
      return _react.default.createElement(_TimeSlotGroup.default, {
        key: idx,
        group: grp,
        resource: resource,
        getters: getters,
        components: components
      });
    }), _react.default.createElement(EventContainer, {
      localizer: localizer,
      resource: resource,
      accessors: accessors,
      getters: getters,
      components: components,
      slotMetrics: slotMetrics
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)('rbc-events-container', rtl && 'rtl')
    }, this.renderEvents())), selecting && _react.default.createElement("div", {
      className: "rbc-slot-selection",
      style: {
        top: top,
        height: height
      }
    }, _react.default.createElement("span", null, localizer.format(selectDates, 'selectRangeFormat'))), isNow && _react.default.createElement("div", {
      ref: "timeIndicator",
      className: "rbc-current-time-indicator"
    }));
  };

  return DayColumn;
}(_react.default.Component);

DayColumn.propTypes = {
  events: _propTypes.default.array.isRequired,
  step: _propTypes.default.number.isRequired,
  date: _propTypes.default.instanceOf(Date).isRequired,
  min: _propTypes.default.instanceOf(Date).isRequired,
  max: _propTypes.default.instanceOf(Date).isRequired,
  getNow: _propTypes.default.func.isRequired,
  isNow: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  showMultiDayTimes: _propTypes.default.bool,
  culture: _propTypes.default.string,
  timeslots: _propTypes.default.number,
  selected: _propTypes.default.object,
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),
  eventOffset: _propTypes.default.number,
  longPressThreshold: _propTypes.default.number,
  onSelecting: _propTypes.default.func,
  onSelectSlot: _propTypes.default.func.isRequired,
  onSelectEvent: _propTypes.default.func.isRequired,
  onDoubleClickEvent: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  dragThroughEvents: _propTypes.default.bool,
  resource: _propTypes.default.any
};
DayColumn.defaultProps = {
  dragThroughEvents: true,
  timeslots: 2
};
var _default = DayColumn;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.getStyledEvents = getStyledEvents;

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _sortBy = _interopRequireDefault(__webpack_require__(1141));

var Event =
/*#__PURE__*/
function () {
  function Event(data, _ref) {
    var accessors = _ref.accessors,
        slotMetrics = _ref.slotMetrics;

    var _slotMetrics$getRange = slotMetrics.getRange(accessors.start(data), accessors.end(data)),
        start = _slotMetrics$getRange.start,
        startDate = _slotMetrics$getRange.startDate,
        end = _slotMetrics$getRange.end,
        endDate = _slotMetrics$getRange.endDate,
        top = _slotMetrics$getRange.top,
        height = _slotMetrics$getRange.height;

    this.start = start;
    this.end = end;
    this.startMs = +startDate;
    this.endMs = +endDate;
    this.top = top;
    this.height = height;
    this.data = data;
  }
  /**
   * The event's width without any overlap.
   */


  (0, _createClass2.default)(Event, [{
    key: "_width",
    get: function get() {
      // The container event's width is determined by the maximum number of
      // events in any of its rows.
      if (this.rows) {
        var columns = this.rows.reduce(function (max, row) {
          return Math.max(max, row.leaves.length + 1);
        }, // add itself
        0) + 1; // add the container

        return 100 / columns;
      }

      var availableWidth = 100 - this.container._width; // The row event's width is the space left by the container, divided
      // among itself and its leaves.

      if (this.leaves) {
        return availableWidth / (this.leaves.length + 1);
      } // The leaf event's width is determined by its row's width


      return this.row._width;
    }
    /**
     * The event's calculated width, possibly with extra width added for
     * overlapping effect.
     */

  }, {
    key: "width",
    get: function get() {
      var noOverlap = this._width;
      var overlap = Math.min(100, this._width * 1.7); // Containers can always grow.

      if (this.rows) {
        return overlap;
      } // Rows can grow if they have leaves.


      if (this.leaves) {
        return this.leaves.length > 0 ? overlap : noOverlap;
      } // Leaves can grow unless they're the last item in a row.


      var leaves = this.row.leaves;
      var index = leaves.indexOf(this);
      return index === leaves.length - 1 ? noOverlap : overlap;
    }
  }, {
    key: "xOffset",
    get: function get() {
      // Containers have no offset.
      if (this.rows) return 0; // Rows always start where their container ends.

      if (this.leaves) return this.container._width; // Leaves are spread out evenly on the space left by its row.

      var _this$row = this.row,
          leaves = _this$row.leaves,
          xOffset = _this$row.xOffset,
          _width = _this$row._width;
      var index = leaves.indexOf(this) + 1;
      return xOffset + index * _width;
    }
  }]);
  return Event;
}();
/**
 * Return true if event a and b is considered to be on the same row.
 */


function onSameRow(a, b, minimumStartDifference) {
  return (// Occupies the same start slot.
    Math.abs(b.start - a.start) < minimumStartDifference || // A's start slot overlaps with b's end slot.
    b.start > a.start && b.start < a.end
  );
}

function sortByRender(events) {
  var sortedByTime = (0, _sortBy.default)(events, ['startMs', function (e) {
    return -e.endMs;
  }]);
  var sorted = [];

  while (sortedByTime.length > 0) {
    var event = sortedByTime.shift();
    sorted.push(event);

    for (var i = 0; i < sortedByTime.length; i++) {
      var test = sortedByTime[i]; // Still inside this event, look for next.

      if (event.endMs > test.startMs) continue; // We've found the first event of the next event group.
      // If that event is not right next to our current event, we have to
      // move it here.

      if (i > 0) {
        var _event = sortedByTime.splice(i, 1)[0];
        sorted.push(_event);
      } // We've already found the next event group, so stop looking.


      break;
    }
  }

  return sorted;
}

function getStyledEvents(_ref2) {
  var events = _ref2.events,
      minimumStartDifference = _ref2.minimumStartDifference,
      slotMetrics = _ref2.slotMetrics,
      accessors = _ref2.accessors;
  // Create proxy events and order them so that we don't have
  // to fiddle with z-indexes.
  var proxies = events.map(function (event) {
    return new Event(event, {
      slotMetrics: slotMetrics,
      accessors: accessors
    });
  });
  var eventsInRenderOrder = sortByRender(proxies); // Group overlapping events, while keeping order.
  // Every event is always one of: container, row or leaf.
  // Containers can contain rows, and rows can contain leaves.

  var containerEvents = [];

  var _loop = function _loop(i) {
    var event = eventsInRenderOrder[i]; // Check if this event can go into a container event.

    var container = containerEvents.find(function (c) {
      return c.end > event.start || Math.abs(event.start - c.start) < minimumStartDifference;
    }); // Couldn't find a container — that means this event is a container.

    if (!container) {
      event.rows = [];
      containerEvents.push(event);
      return "continue";
    } // Found a container for the event.


    event.container = container; // Check if the event can be placed in an existing row.
    // Start looking from behind.

    var row = null;

    for (var j = container.rows.length - 1; !row && j >= 0; j--) {
      if (onSameRow(container.rows[j], event, minimumStartDifference)) {
        row = container.rows[j];
      }
    }

    if (row) {
      // Found a row, so add it.
      row.leaves.push(event);
      event.row = row;
    } else {
      // Couldn't find a row – that means this event is a row.
      event.leaves = [];
      container.rows.push(event);
    }
  };

  for (var i = 0; i < eventsInRenderOrder.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  } // Return the original events, along with their styles.


  return eventsInRenderOrder.map(function (event) {
    return {
      event: event.data,
      style: {
        top: event.top,
        height: event.height,
        width: event.width,
        xOffset: event.xOffset
      }
    };
  });
}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(478),
    baseOrderBy = __webpack_require__(1143),
    baseRest = __webpack_require__(138),
    isIterateeCall = __webpack_require__(145);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112),
    isArguments = __webpack_require__(280),
    isArray = __webpack_require__(37);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(290),
    baseGet = __webpack_require__(200),
    baseIteratee = __webpack_require__(142),
    baseMap = __webpack_require__(1144),
    baseSortBy = __webpack_require__(1145),
    baseUnary = __webpack_require__(193),
    compareMultiple = __webpack_require__(1146),
    identity = __webpack_require__(110),
    isArray = __webpack_require__(37);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(278),
    isArrayLike = __webpack_require__(114);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1147);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(141);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

/* eslint-disable react/prop-types */
function TimeGridEvent(props) {
  var _extends2;

  var style = props.style,
      className = props.className,
      event = props.event,
      accessors = props.accessors,
      isRtl = props.isRtl,
      selected = props.selected,
      label = props.label,
      continuesEarlier = props.continuesEarlier,
      continuesLater = props.continuesLater,
      getters = props.getters,
      onClick = props.onClick,
      onDoubleClick = props.onDoubleClick,
      _props$components = props.components,
      Event = _props$components.event,
      EventWrapper = _props$components.eventWrapper;
  var title = accessors.title(event);
  var tooltip = accessors.tooltip(event);
  var end = accessors.end(event);
  var start = accessors.start(event);
  var userProps = getters.eventProp(event, start, end, selected);
  var height = style.height,
      top = style.top,
      width = style.width,
      xOffset = style.xOffset;
  var inner = [_react.default.createElement("div", {
    key: "1",
    className: "rbc-event-label"
  }, label), _react.default.createElement("div", {
    key: "2",
    className: "rbc-event-content"
  }, Event ? _react.default.createElement(Event, {
    event: event,
    title: title
  }) : title)];
  return _react.default.createElement(EventWrapper, (0, _extends3.default)({
    type: "time"
  }, props), _react.default.createElement("div", {
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    style: (0, _extends3.default)({}, userProps.style, (_extends2 = {
      top: top + "%",
      height: height + "%"
    }, _extends2[isRtl ? 'right' : 'left'] = Math.max(0, xOffset) + "%", _extends2.width = width + "%", _extends2)),
    title: tooltip ? (typeof label === 'string' ? label + ': ' : '') + tooltip : undefined,
    className: (0, _classnames.default)('rbc-event', className, userProps.className, {
      'rbc-selected': selected,
      'rbc-event-continues-earlier': continuesEarlier,
      'rbc-event-continues-later': continuesLater
    })
  }, inner));
}

var _default = TimeGridEvent;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireWildcard(__webpack_require__(0));

var TimeSlotUtils = _interopRequireWildcard(__webpack_require__(477));

var _TimeSlotGroup = _interopRequireDefault(__webpack_require__(479));

var TimeGutter =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TimeGutter, _Component);

  function TimeGutter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.renderSlot = function (value, idx) {
      if (idx !== 0) return null;
      var _this$props = _this.props,
          localizer = _this$props.localizer,
          getNow = _this$props.getNow;

      var isNow = _this.slotMetrics.dateIsInGroup(getNow(), idx);

      return _react.default.createElement("span", {
        className: (0, _classnames.default)('rbc-label', isNow && 'rbc-now')
      }, localizer.format(value, 'timeGutterFormat'));
    };

    var _this$props2 = _this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        timeslots = _this$props2.timeslots,
        step = _this$props2.step;
    _this.slotMetrics = TimeSlotUtils.getSlotMetrics({
      min: min,
      max: max,
      timeslots: timeslots,
      step: step
    });
    return _this;
  }

  var _proto = TimeGutter.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var min = nextProps.min,
        max = nextProps.max,
        timeslots = nextProps.timeslots,
        step = nextProps.step;
    this.slotMetrics = this.slotMetrics.update({
      min: min,
      max: max,
      timeslots: timeslots,
      step: step
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        resource = _this$props3.resource,
        components = _this$props3.components;
    return _react.default.createElement("div", {
      className: "rbc-time-gutter rbc-time-column"
    }, this.slotMetrics.groups.map(function (grp, idx) {
      return _react.default.createElement(_TimeSlotGroup.default, {
        key: idx,
        group: grp,
        resource: resource,
        components: components,
        renderSlot: _this2.renderSlot
      });
    }));
  };

  return TimeGutter;
}(_react.Component);

exports.default = TimeGutter;
TimeGutter.propTypes = {
  min: _propTypes.default.instanceOf(Date).isRequired,
  max: _propTypes.default.instanceOf(Date).isRequired,
  timeslots: _propTypes.default.number.isRequired,
  step: _propTypes.default.number.isRequired,
  getNow: _propTypes.default.func.isRequired,
  components: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired,
  resource: _propTypes.default.string
};
module.exports = exports["default"];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(157));

var _react = _interopRequireDefault(__webpack_require__(0));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _DateContentRow = _interopRequireDefault(__webpack_require__(473));

var _Header = _interopRequireDefault(__webpack_require__(476));

var _helpers = __webpack_require__(116);

var TimeGridHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(TimeGridHeader, _React$Component);

  function TimeGridHeader() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleHeaderClick = function (date, view, e) {
      e.preventDefault();
      (0, _helpers.notify)(_this.props.onDrillDown, [date, view]);
    };

    _this.renderRow = function (resource) {
      var _this$props = _this.props,
          events = _this$props.events,
          rtl = _this$props.rtl,
          selectable = _this$props.selectable,
          getNow = _this$props.getNow,
          range = _this$props.range,
          getters = _this$props.getters,
          localizer = _this$props.localizer,
          accessors = _this$props.accessors,
          components = _this$props.components;
      var resourceId = accessors.resourceId(resource);
      var eventsToDisplay = resource ? events.filter(function (event) {
        return accessors.resource(event) === resourceId;
      }) : events;
      return _react.default.createElement(_DateContentRow.default, {
        isAllDay: true,
        rtl: rtl,
        getNow: getNow,
        minRows: 2,
        range: range,
        events: eventsToDisplay,
        resourceId: resourceId,
        className: "rbc-allday-cell",
        selectable: selectable,
        selected: _this.props.selected,
        components: components,
        accessors: accessors,
        getters: getters,
        localizer: localizer,
        onSelect: _this.props.onSelectEvent,
        onDoubleClick: _this.props.onDoubleClickEvent,
        onSelectSlot: _this.props.onSelectSlot,
        longPressThreshold: _this.props.longPressThreshold
      });
    };

    return _this;
  }

  var _proto = TimeGridHeader.prototype;

  _proto.renderHeaderCells = function renderHeaderCells(range) {
    var _this2 = this;

    var _this$props2 = this.props,
        localizer = _this$props2.localizer,
        getDrilldownView = _this$props2.getDrilldownView,
        getNow = _this$props2.getNow,
        dayProp = _this$props2.getters.dayProp,
        _this$props2$componen = _this$props2.components.header,
        HeaderComponent = _this$props2$componen === void 0 ? _Header.default : _this$props2$componen;
    var today = getNow();
    return range.map(function (date, i) {
      var drilldownView = getDrilldownView(date);
      var label = localizer.format(date, 'dayFormat');

      var _dayProp = dayProp(date),
          className = _dayProp.className,
          style = _dayProp.style;

      var header = _react.default.createElement(HeaderComponent, {
        date: date,
        label: label,
        localizer: localizer
      });

      return _react.default.createElement("div", {
        key: i,
        style: style,
        className: (0, _classnames.default)('rbc-header', className, _dates.default.eq(date, today, 'day') && 'rbc-today')
      }, drilldownView ? _react.default.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          return _this2.handleHeaderClick(date, drilldownView, e);
        }
      }, header) : _react.default.createElement("span", null, header));
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props3 = this.props,
        width = _this$props3.width,
        rtl = _this$props3.rtl,
        resources = _this$props3.resources,
        range = _this$props3.range,
        events = _this$props3.events,
        getNow = _this$props3.getNow,
        accessors = _this$props3.accessors,
        selectable = _this$props3.selectable,
        components = _this$props3.components,
        getters = _this$props3.getters,
        scrollRef = _this$props3.scrollRef,
        localizer = _this$props3.localizer,
        isOverflowing = _this$props3.isOverflowing,
        TimeGutterHeader = _this$props3.components.timeGutterHeader;
    var style = {};

    if (isOverflowing) {
      style[rtl ? 'marginLeft' : 'marginRight'] = (0, _scrollbarSize.default)() + "px";
    }

    var groupedEvents = resources.groupEvents(events);
    return _react.default.createElement("div", {
      style: style,
      ref: scrollRef,
      className: (0, _classnames.default)('rbc-time-header', isOverflowing && 'rbc-overflowing')
    }, _react.default.createElement("div", {
      className: "rbc-label rbc-time-header-gutter",
      style: {
        width: width,
        minWidth: width,
        maxWidth: width
      }
    }, TimeGutterHeader && _react.default.createElement(TimeGutterHeader, null)), resources.map(function (_ref, idx) {
      var id = _ref[0],
          resource = _ref[1];
      return _react.default.createElement("div", {
        className: "rbc-time-header-content",
        key: id || idx
      }, resource && _react.default.createElement("div", {
        className: "rbc-row rbc-row-resource"
      }, _react.default.createElement("div", {
        key: "resource_" + idx,
        className: "rbc-header"
      }, accessors.resourceTitle(resource))), range.length > 1 && _react.default.createElement("div", {
        className: "rbc-row rbc-time-header-cell"
      }, _this3.renderHeaderCells(range)), _react.default.createElement(_DateContentRow.default, {
        isAllDay: true,
        rtl: rtl,
        getNow: getNow,
        minRows: 2,
        range: range,
        events: groupedEvents.get(id) || [],
        resourceId: resource && id,
        className: "rbc-allday-cell",
        selectable: selectable,
        selected: _this3.props.selected,
        components: components,
        accessors: accessors,
        getters: getters,
        localizer: localizer,
        onSelect: _this3.props.onSelectEvent,
        onDoubleClick: _this3.props.onDoubleClickEvent,
        onSelectSlot: _this3.props.onSelectSlot,
        longPressThreshold: _this3.props.longPressThreshold
      }));
    }));
  };

  return TimeGridHeader;
}(_react.default.Component);

TimeGridHeader.propTypes = {
  range: _propTypes.default.array.isRequired,
  events: _propTypes.default.array.isRequired,
  resources: _propTypes.default.object,
  getNow: _propTypes.default.func.isRequired,
  isOverflowing: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  width: _propTypes.default.number,
  localizer: _propTypes.default.object.isRequired,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  selected: _propTypes.default.object,
  selectable: _propTypes.default.oneOf([true, false, 'ignoreEvents']),
  longPressThreshold: _propTypes.default.number,
  onSelectSlot: _propTypes.default.func,
  onSelectEvent: _propTypes.default.func,
  onDoubleClickEvent: _propTypes.default.func,
  onDrillDown: _propTypes.default.func,
  getDrilldownView: _propTypes.default.func.isRequired,
  scrollRef: _propTypes.default.any
};
var _default = TimeGridHeader;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = Resources;
exports.NONE = void 0;
var NONE = {};
exports.NONE = NONE;

function Resources(resources, accessors) {
  return {
    map: function map(fn) {
      if (!resources) return [fn([NONE, null], 0)];
      return resources.map(function (resource, idx) {
        return fn([accessors.resourceId(resource), resource], idx);
      });
    },
    groupEvents: function groupEvents(events) {
      var eventsByResource = new window.Map();
      events.forEach(function (event) {
        var id = accessors.resource(event) || NONE;
        var resourceEvents = eventsByResource.get(id) || [];
        resourceEvents.push(event);
        eventsByResource.set(id, resourceEvents);
      });
      return eventsByResource;
    }
  };
}

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(53));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Week = _interopRequireDefault(__webpack_require__(482));

var _TimeGrid = _interopRequireDefault(__webpack_require__(301));

function workWeekRange(date, options) {
  return _Week.default.range(date, options).filter(function (d) {
    return [6, 0].indexOf(d.getDay()) === -1;
  });
}

var WorkWeek =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(WorkWeek, _React$Component);

  function WorkWeek() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = WorkWeek.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        date = _this$props.date,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["date"]);
    var range = workWeekRange(date, this.props);
    return _react.default.createElement(_TimeGrid.default, (0, _extends2.default)({}, props, {
      range: range,
      eventOffset: 15
    }));
  };

  return WorkWeek;
}(_react.default.Component);

WorkWeek.propTypes = {
  date: _propTypes.default.instanceOf(Date).isRequired
};
WorkWeek.defaultProps = _TimeGrid.default.defaultProps;
WorkWeek.range = workWeekRange;
WorkWeek.navigate = _Week.default.navigate;

WorkWeek.title = function (date, _ref) {
  var localizer = _ref.localizer;

  var _workWeekRange = workWeekRange(date, {
    localizer: localizer
  }),
      start = _workWeekRange[0],
      rest = _workWeekRange.slice(1);

  return localizer.format({
    start: start,
    end: rest.pop()
  }, 'dayRangeHeaderFormat');
};

var _default = WorkWeek;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _class = _interopRequireDefault(__webpack_require__(1154));

var _width = _interopRequireDefault(__webpack_require__(481));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(157));

var _dates = _interopRequireDefault(__webpack_require__(32));

var _constants = __webpack_require__(52);

var _eventLevels = __webpack_require__(149);

var _selection = __webpack_require__(147);

var Agenda =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Agenda, _React$Component);

  function Agenda() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderDay = function (day, events, dayKey) {
      var _this$props = _this.props,
          selected = _this$props.selected,
          getters = _this$props.getters,
          accessors = _this$props.accessors,
          localizer = _this$props.localizer,
          _this$props$component = _this$props.components,
          Event = _this$props$component.event,
          AgendaDate = _this$props$component.date;
      events = events.filter(function (e) {
        return (0, _eventLevels.inRange)(e, _dates.default.startOf(day, 'day'), _dates.default.endOf(day, 'day'), accessors);
      });
      return events.map(function (event, idx) {
        var title = accessors.title(event);
        var end = accessors.end(event);
        var start = accessors.start(event);
        var userProps = getters.eventProp(event, start, end, (0, _selection.isSelected)(event, selected));
        var dateLabel = idx === 0 && localizer.format(day, 'agendaDateFormat');
        var first = idx === 0 ? _react.default.createElement("td", {
          rowSpan: events.length,
          className: "rbc-agenda-date-cell"
        }, AgendaDate ? _react.default.createElement(AgendaDate, {
          day: day,
          label: dateLabel
        }) : dateLabel) : false;
        return _react.default.createElement("tr", {
          key: dayKey + '_' + idx,
          className: userProps.className,
          style: userProps.style
        }, first, _react.default.createElement("td", {
          className: "rbc-agenda-time-cell"
        }, _this.timeRangeLabel(day, event)), _react.default.createElement("td", {
          className: "rbc-agenda-event-cell"
        }, Event ? _react.default.createElement(Event, {
          event: event,
          title: title
        }) : title));
      }, []);
    };

    _this.timeRangeLabel = function (day, event) {
      var _this$props2 = _this.props,
          accessors = _this$props2.accessors,
          localizer = _this$props2.localizer,
          components = _this$props2.components;
      var labelClass = '',
          TimeComponent = components.time,
          label = localizer.messages.allDay;
      var end = accessors.end(event);
      var start = accessors.start(event);

      if (!accessors.allDay(event)) {
        if (_dates.default.eq(start, end, 'day')) {
          label = localizer.format({
            start: start,
            end: end
          }, 'agendaTimeRangeFormat');
        } else if (_dates.default.eq(day, start, 'day')) {
          label = localizer.format(start, 'agendaTimeFormat');
        } else if (_dates.default.eq(day, end, 'day')) {
          label = localizer.format(end, 'agendaTimeFormat');
        }
      }

      if (_dates.default.gt(day, start, 'day')) labelClass = 'rbc-continues-prior';
      if (_dates.default.lt(day, end, 'day')) labelClass += ' rbc-continues-after';
      return _react.default.createElement("span", {
        className: labelClass.trim()
      }, TimeComponent ? _react.default.createElement(TimeComponent, {
        event: event,
        day: day,
        label: label
      }) : label);
    };

    _this._adjustHeader = function () {
      if (!_this.refs.tbody) return;
      var header = _this.refs.header;
      var firstRow = _this.refs.tbody.firstChild;
      if (!firstRow) return;
      var isOverflowing = _this.refs.content.scrollHeight > _this.refs.content.clientHeight;
      var widths = _this._widths || [];
      _this._widths = [(0, _width.default)(firstRow.children[0]), (0, _width.default)(firstRow.children[1])];

      if (widths[0] !== _this._widths[0] || widths[1] !== _this._widths[1]) {
        _this.refs.dateCol.style.width = _this._widths[0] + 'px';
        _this.refs.timeCol.style.width = _this._widths[1] + 'px';
      }

      if (isOverflowing) {
        _class.default.addClass(header, 'rbc-header-overflowing');

        header.style.marginRight = (0, _scrollbarSize.default)() + 'px';
      } else {
        _class.default.removeClass(header, 'rbc-header-overflowing');
      }
    };

    return _this;
  }

  var _proto = Agenda.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._adjustHeader();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._adjustHeader();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        length = _this$props3.length,
        date = _this$props3.date,
        events = _this$props3.events,
        accessors = _this$props3.accessors,
        localizer = _this$props3.localizer;
    var messages = localizer.messages;

    var end = _dates.default.add(date, length, 'day');

    var range = _dates.default.range(date, end, 'day');

    events = events.filter(function (event) {
      return (0, _eventLevels.inRange)(event, date, end, accessors);
    });
    events.sort(function (a, b) {
      return +accessors.start(a) - +accessors.start(b);
    });
    return _react.default.createElement("div", {
      className: "rbc-agenda-view"
    }, events.length !== 0 ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("table", {
      ref: "header",
      className: "rbc-agenda-table"
    }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
      className: "rbc-header",
      ref: "dateCol"
    }, messages.date), _react.default.createElement("th", {
      className: "rbc-header",
      ref: "timeCol"
    }, messages.time), _react.default.createElement("th", {
      className: "rbc-header"
    }, messages.event)))), _react.default.createElement("div", {
      className: "rbc-agenda-content",
      ref: "content"
    }, _react.default.createElement("table", {
      className: "rbc-agenda-table"
    }, _react.default.createElement("tbody", {
      ref: "tbody"
    }, range.map(function (day, idx) {
      return _this2.renderDay(day, events, idx);
    }))))) : _react.default.createElement("span", {
      className: "rbc-agenda-empty"
    }, messages.noEventsInRange));
  };

  return Agenda;
}(_react.default.Component);

Agenda.propTypes = {
  events: _propTypes.default.array,
  date: _propTypes.default.instanceOf(Date),
  length: _propTypes.default.number.isRequired,
  selected: _propTypes.default.object,
  accessors: _propTypes.default.object.isRequired,
  components: _propTypes.default.object.isRequired,
  getters: _propTypes.default.object.isRequired,
  localizer: _propTypes.default.object.isRequired
};
Agenda.defaultProps = {
  length: 30
};

Agenda.range = function (start, _ref) {
  var _ref$length = _ref.length,
      length = _ref$length === void 0 ? Agenda.defaultProps.length : _ref$length;

  var end = _dates.default.add(start, length, 'day');

  return {
    start: start,
    end: end
  };
};

Agenda.navigate = function (date, action, _ref2) {
  var _ref2$length = _ref2.length,
      length = _ref2$length === void 0 ? Agenda.defaultProps.length : _ref2$length;

  switch (action) {
    case _constants.navigate.PREVIOUS:
      return _dates.default.add(date, -length, 'day');

    case _constants.navigate.NEXT:
      return _dates.default.add(date, length, 'day');

    default:
      return date;
  }
};

Agenda.title = function (start, _ref3) {
  var _ref3$length = _ref3.length,
      length = _ref3$length === void 0 ? Agenda.defaultProps.length : _ref3$length,
      localizer = _ref3.localizer;

  var end = _dates.default.add(start, length, 'day');

  return localizer.format({
    start: start,
    end: end
  }, 'agendaHeaderFormat');
};

var _default = Agenda;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(1155));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(1156));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(483));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(22);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(483));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(24));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _constants = __webpack_require__(52);

var Toolbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Toolbar, _React$Component);

  function Toolbar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.navigate = function (action) {
      _this.props.onNavigate(action);
    };

    _this.view = function (view) {
      _this.props.onView(view);
    };

    return _this;
  }

  var _proto = Toolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        messages = _this$props.localizer.messages,
        label = _this$props.label;
    return _react.default.createElement("div", {
      className: "rbc-toolbar"
    }, _react.default.createElement("span", {
      className: "rbc-btn-group"
    }, _react.default.createElement("button", {
      type: "button",
      onClick: this.navigate.bind(null, _constants.navigate.TODAY)
    }, messages.today), _react.default.createElement("button", {
      type: "button",
      onClick: this.navigate.bind(null, _constants.navigate.PREVIOUS)
    }, messages.previous), _react.default.createElement("button", {
      type: "button",
      onClick: this.navigate.bind(null, _constants.navigate.NEXT)
    }, messages.next)), _react.default.createElement("span", {
      className: "rbc-toolbar-label"
    }, label), _react.default.createElement("span", {
      className: "rbc-btn-group"
    }, this.viewNamesGroup(messages)));
  };

  _proto.viewNamesGroup = function viewNamesGroup(messages) {
    var _this2 = this;

    var viewNames = this.props.views;
    var view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map(function (name) {
        return _react.default.createElement("button", {
          type: "button",
          key: name,
          className: (0, _classnames.default)({
            'rbc-active': view === name
          }),
          onClick: _this2.view.bind(null, name)
        }, messages[name]);
      });
    }
  };

  return Toolbar;
}(_react.default.Component);

Toolbar.propTypes = {
  view: _propTypes.default.string.isRequired,
  views: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  label: _propTypes.default.node.isRequired,
  localizer: _propTypes.default.object,
  onNavigate: _propTypes.default.func.isRequired,
  onView: _propTypes.default.func.isRequired
};
var _default = Toolbar;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(290),
    baseClone = __webpack_require__(1159),
    baseUnset = __webpack_require__(1178),
    castPath = __webpack_require__(201),
    copyObject = __webpack_require__(115),
    customOmitClone = __webpack_require__(1181),
    flatRest = __webpack_require__(1183),
    getAllKeysIn = __webpack_require__(485);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(284),
    arrayEach = __webpack_require__(189),
    assignValue = __webpack_require__(292),
    baseAssign = __webpack_require__(1160),
    baseAssignIn = __webpack_require__(1161),
    cloneBuffer = __webpack_require__(1164),
    copyArray = __webpack_require__(275),
    copySymbols = __webpack_require__(1165),
    copySymbolsIn = __webpack_require__(1166),
    getAllKeys = __webpack_require__(456),
    getAllKeysIn = __webpack_require__(485),
    getTag = __webpack_require__(199),
    initCloneArray = __webpack_require__(1167),
    initCloneByTag = __webpack_require__(1168),
    initCloneObject = __webpack_require__(1173),
    isArray = __webpack_require__(37),
    isBuffer = __webpack_require__(192),
    isMap = __webpack_require__(1174),
    isObject = __webpack_require__(51),
    isSet = __webpack_require__(1176),
    keys = __webpack_require__(113),
    keysIn = __webpack_require__(204);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(115),
    keys = __webpack_require__(113);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(115),
    keysIn = __webpack_require__(204);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(51),
    isPrototype = __webpack_require__(194),
    nativeKeysIn = __webpack_require__(1163);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)(module)))

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(115),
    getSymbols = __webpack_require__(288);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(115),
    getSymbolsIn = __webpack_require__(484);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(303),
    cloneDataView = __webpack_require__(1169),
    cloneRegExp = __webpack_require__(1170),
    cloneSymbol = __webpack_require__(1171),
    cloneTypedArray = __webpack_require__(1172);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(303);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(112);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(303);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(140),
    getPrototype = __webpack_require__(205),
    isPrototype = __webpack_require__(194);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1175),
    baseUnary = __webpack_require__(193),
    nodeUtil = __webpack_require__(283);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(199),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1177),
    baseUnary = __webpack_require__(193),
    nodeUtil = __webpack_require__(283);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(199),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(201),
    last = __webpack_require__(1179),
    parent = __webpack_require__(1180),
    toKey = __webpack_require__(144);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1179 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(200),
    baseSlice = __webpack_require__(291);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(1182);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(111),
    getPrototype = __webpack_require__(205),
    isObjectLike = __webpack_require__(61);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1184),
    overRest = __webpack_require__(429),
    setToString = __webpack_require__(272);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(478);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(138),
    eq = __webpack_require__(143),
    isIterateeCall = __webpack_require__(145),
    keysIn = __webpack_require__(204);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    baseCreate = __webpack_require__(140),
    baseForOwn = __webpack_require__(279),
    baseIteratee = __webpack_require__(142),
    getPrototype = __webpack_require__(205),
    isArray = __webpack_require__(37),
    isBuffer = __webpack_require__(192),
    isFunction = __webpack_require__(139),
    isObject = __webpack_require__(51),
    isTypedArray = __webpack_require__(281);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(293),
    baseForOwn = __webpack_require__(279),
    baseIteratee = __webpack_require__(142);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.accessor = accessor;
exports.wrapAccessor = void 0;

/**
 * Retrieve via an accessor-like property
 *
 *    accessor(obj, 'name')   // => retrieves obj['name']
 *    accessor(data, func)    // => retrieves func(data)
 *    ... otherwise null
 */
function accessor(data, field) {
  var value = null;
  if (typeof field === 'function') value = field(data);else if (typeof field === 'string' && typeof data === 'object' && data != null && field in data) value = data[field];
  return value;
}

var wrapAccessor = function wrapAccessor(acc) {
  return function (data) {
    return accessor(data, acc);
  };
};

exports.wrapAccessor = wrapAccessor;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = void 0;

var _NoopWrapper = _interopRequireDefault(__webpack_require__(302));

var _default = _NoopWrapper.default;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = _default;
exports.formats = void 0;

var _dates = _interopRequireDefault(__webpack_require__(32));

var _localizer = __webpack_require__(202);

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'L', culture) + ' — ' + local.format(end, 'L', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 'LT', culture) + ' — ' + local.format(end, 'LT', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start;
  return local.format(start, 'LT', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var end = _ref4.end;
  return ' — ' + local.format(end, 'LT', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMMM DD', culture) + ' - ' + local.format(end, _dates.default.eq(start, end, 'month') ? 'DD' : 'MMMM DD', culture);
};

var formats = {
  dateFormat: 'DD',
  dayFormat: 'DD ddd',
  weekdayFormat: 'ddd',
  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,
  timeGutterFormat: 'LT',
  monthHeaderFormat: 'MMMM YYYY',
  dayHeaderFormat: 'dddd MMM DD',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,
  agendaDateFormat: 'ddd MMM DD',
  agendaTimeFormat: 'LT',
  agendaTimeRangeFormat: timeRangeFormat
};
exports.formats = formats;

function _default(moment) {
  var locale = function locale(m, c) {
    return c ? m.locale(c) : m;
  };

  return new _localizer.DateLocalizer({
    formats: formats,
    firstOfWeek: function firstOfWeek(culture) {
      var data = culture ? moment.localeData(culture) : moment.localeData();
      return data ? data.firstDayOfWeek() : 0;
    },
    format: function format(value, _format, culture) {
      return locale(moment(value), culture).format(_format);
    }
  });
}

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = _default;
exports.formats = void 0;

var _dates = _interopRequireDefault(__webpack_require__(32));

var _oldGlobalize = _interopRequireDefault(__webpack_require__(1192));

var _localizer = __webpack_require__(202);

var _warning = _interopRequireDefault(__webpack_require__(17));

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, {
    date: 'short'
  }, culture) + ' — ' + local.format(end, {
    date: 'short'
  }, culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, {
    time: 'short'
  }, culture) + ' — ' + local.format(end, {
    time: 'short'
  }, culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start;
  return local.format(start, {
    time: 'short'
  }, culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var end = _ref4.end;
  return ' — ' + local.format(end, {
    time: 'short'
  }, culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' — ' + local.format(end, _dates.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = {
  dateFormat: 'dd',
  dayFormat: 'eee dd/MM',
  weekdayFormat: 'eee',
  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,
  timeGutterFormat: {
    time: 'short'
  },
  monthHeaderFormat: 'MMMM yyyy',
  dayHeaderFormat: 'eeee MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,
  agendaDateFormat: 'eee MMM dd',
  agendaTimeFormat: {
    time: 'short'
  },
  agendaTimeRangeFormat: timeRangeFormat
};
exports.formats = formats;

function _default(globalize) {
  var locale = function locale(culture) {
    return culture ? globalize(culture) : globalize;
  }; // return the first day of the week from the locale data. Defaults to 'world'
  // territory if no territory is derivable from CLDR.
  // Failing to use CLDR supplemental (not loaded?), revert to the original
  // method of getting first day of week.


  function firstOfWeek(culture) {
    try {
      var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var cldr = locale(culture).cldr;
      var territory = cldr.attributes.territory;
      var weekData = cldr.get('supplemental').weekData;
      var firstDay = weekData.firstDay[territory || '001'];
      return days.indexOf(firstDay);
    } catch (e) {
       false ? (0, _warning.default)(true, "Failed to accurately determine first day of the week.\n            Is supplemental data loaded into CLDR?") : void 0; // maybe cldr supplemental is not loaded? revert to original method

      var date = new Date(); //cldr-data doesn't seem to be zero based

      var localeDay = Math.max(parseInt(locale(culture).formatDate(date, {
        raw: 'e'
      }), 10) - 1, 0);
      return Math.abs(date.getDay() - localeDay);
    }
  }

  if (!globalize.load) return (0, _oldGlobalize.default)(globalize);
  return new _localizer.DateLocalizer({
    firstOfWeek: firstOfWeek,
    formats: formats,
    format: function format(value, _format, culture) {
      _format = typeof _format === 'string' ? {
        raw: _format
      } : _format;
      return locale(culture).formatDate(value, _format);
    }
  });
}

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

exports.__esModule = true;
exports.default = _default;
exports.formats = void 0;

var _dates = _interopRequireDefault(__webpack_require__(32));

var _localizer = __webpack_require__(202);

var dateRangeFormat = function dateRangeFormat(_ref, culture, local) {
  var start = _ref.start,
      end = _ref.end;
  return local.format(start, 'd', culture) + ' — ' + local.format(end, 'd', culture);
};

var timeRangeFormat = function timeRangeFormat(_ref2, culture, local) {
  var start = _ref2.start,
      end = _ref2.end;
  return local.format(start, 't', culture) + ' — ' + local.format(end, 't', culture);
};

var timeRangeStartFormat = function timeRangeStartFormat(_ref3, culture, local) {
  var start = _ref3.start;
  return local.format(start, 't', culture) + ' — ';
};

var timeRangeEndFormat = function timeRangeEndFormat(_ref4, culture, local) {
  var end = _ref4.end;
  return ' — ' + local.format(end, 't', culture);
};

var weekRangeFormat = function weekRangeFormat(_ref5, culture, local) {
  var start = _ref5.start,
      end = _ref5.end;
  return local.format(start, 'MMM dd', culture) + ' - ' + local.format(end, _dates.default.eq(start, end, 'month') ? 'dd' : 'MMM dd', culture);
};

var formats = {
  dateFormat: 'dd',
  dayFormat: 'ddd dd/MM',
  weekdayFormat: 'ddd',
  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,
  timeGutterFormat: 't',
  monthHeaderFormat: 'Y',
  dayHeaderFormat: 'dddd MMM dd',
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,
  agendaDateFormat: 'ddd MMM dd',
  agendaTimeFormat: 't',
  agendaTimeRangeFormat: timeRangeFormat
};
exports.formats = formats;

function _default(globalize) {
  function getCulture(culture) {
    return culture ? globalize.findClosestCulture(culture) : globalize.culture();
  }

  function firstOfWeek(culture) {
    culture = getCulture(culture);
    return culture && culture.calendar.firstDay || 0;
  }

  return new _localizer.DateLocalizer({
    firstOfWeek: firstOfWeek,
    formats: formats,
    format: function format(value, _format, culture) {
      return globalize.format(value, _format, culture);
    }
  });
}

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Timeline_Timeline_jsx__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomTabs_CustomTabs_jsx__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Card_CardAvatar_jsx__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
// core components
var styles={cardTitle:__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],cardTitleWhite:Object.assign({},__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{color:"#FFFFFF",marginTop:"0"}),cardCategoryWhite:{margin:"0",color:"rgba(255, 255, 255, 0.8)",fontSize:".875rem"},cardCategory:{color:"#999999",marginTop:"10px"},icon:{color:"#333333",margin:"10px auto 0",width:"130px",height:"130px",border:"1px solid #E5E5E5",borderRadius:"50%",lineHeight:"174px","& svg":{width:"55px",height:"55px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"55px",fontSize:"55px"}},iconRose:{color:__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},marginTop30:{marginTop:"30px"},testimonialIcon:{marginTop:"30px","& svg":{width:"40px",height:"40px"}},cardTestimonialDescription:{fontStyle:"italic",color:"#999999"}};var Widgets=function(_React$Component){_inherits(Widgets,_React$Component);function Widgets(){_classCallCheck(this,Widgets);return _possibleConstructorReturn(this,(Widgets.__proto__||Object.getPrototypeOf(Widgets)).apply(this,arguments));}_createClass(Widgets,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardHeader_jsx__["a" /* default */],{color:"warning",text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__["a" /* default */],{color:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitleWhite},"Employees Stats"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardCategoryWhite},"New employees on 15th September, 2016"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__["a" /* default */],{hover:true,tableHeaderColor:"warning",tableHead:["ID","Name","Salary","Country"],tableData:[["1","Dakota Rice","$36,738","Niger"],["2","Minerva Hooper","$23,789","Curaçao"],["3","Sage Rodriguez","$56,142","Netherlands"],["4","Philip Chaney","$38,735","Korea, South"]]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomTabs_CustomTabs_jsx__["a" /* default */],{title:"Tasks:",headerColor:"rose",tabs:[{tabName:"Bugs",tabIcon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__["a" /* default */],{checkedIndexes:[0,3],tasksIndexes:[0,1,2,3],tasks:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["a" /* bugs */]})},{tabName:"Website",tabIcon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__["a" /* default */],{checkedIndexes:[0],tasksIndexes:[0,1],tasks:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["k" /* website */]})},{tabName:"Server",tabIcon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__["a" /* default */],{checkedIndexes:[1],tasksIndexes:[0,1,2],tasks:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["i" /* server */]})}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],{pricing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],{pricing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"SMALL COMPANY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home___default.a,{className:classes.iconRose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle+" "+classes.marginTop30},"$29"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardDescription},"This is good if your company size is between 2 and 10 Persons."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"rose"},"Choose plan")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"Freelancer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon___default.a,{className:classes.iconWhite},"weekend")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle+" "+classes.marginTop30},"FREE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"This is good if your company size is between 2 and 10 Persons."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"white"},"Choose plan")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],{testimonial:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.testimonialIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:classes.cardTestimonialDescription},"Your products, all the kits that I have downloaded from your site and worked with are sooo cool! I love the color mixtures, cards... everything. Keep up the great work!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardFooter_jsx__["a" /* default */],{testimonial:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Alec Thompson"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"@ALECTHOMPSON"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardAvatar_jsx__["a" /* default */],{testimonial:true,testimonialFooter:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo",onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg___default.a,alt:"..."})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Timeline_Timeline_jsx__["a" /* default */],{simple:true,stories:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["l" /* widgetStories */]}))));}}]);return Widgets;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(styles)(Widgets));

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_badgeStyle_jsx__ = __webpack_require__(1195);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function Badge(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,color=props.color,children=props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:classes.badge+" "+classes[color]},children);}Badge.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose","gray"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_badgeStyle_jsx__["a" /* default */])(Badge));

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Badge component styles
// #############################
var badgeStyle={badge:{borderRadius:"12px",padding:"5px 12px",textTransform:"uppercase",fontSize:"10px",fontWeight:"700",lineHeight:"1",color:"#fff",textAlign:"center",verticalAlign:"baseline",display:"inline-block"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]},rose:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},gray:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]}};/* harmony default export */ __webpack_exports__["a"] = (badgeStyle);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // Timeline component styles
// #############################
var timelineStyle=function timelineStyle(theme){var _timeline,_timelineBadge,_timelinePanel;return{timeline:(_timeline={},_defineProperty(_timeline,theme.breakpoints.down("sm"),{"&:before":{left:"5% !important"}}),_defineProperty(_timeline,"listStyle","none"),_defineProperty(_timeline,"padding","20px 0 20px"),_defineProperty(_timeline,"position","relative"),_defineProperty(_timeline,"marginTop","30px"),_defineProperty(_timeline,"&:before",{top:"50px",bottom:"0",position:"absolute",content:'" "',width:"3px",backgroundColor:"#E5E5E5",left:"50%",marginLeft:"-1px"}),_timeline),timelineSimple:{marginTop:"30px",padding:"0 0 20px","&:before":{left:"5%"}},item:{marginBottom:"20px",position:"relative","&:before,&:after":{content:'" "',display:"table"},"&:after":{clear:"both"}},timelineBadge:(_timelineBadge={},_defineProperty(_timelineBadge,theme.breakpoints.down("sm"),{left:"5% !important"}),_defineProperty(_timelineBadge,"color","#FFFFFF"),_defineProperty(_timelineBadge,"width","50px"),_defineProperty(_timelineBadge,"height","50px"),_defineProperty(_timelineBadge,"lineHeight","51px"),_defineProperty(_timelineBadge,"fontSize","1.4em"),_defineProperty(_timelineBadge,"textAlign","center"),_defineProperty(_timelineBadge,"position","absolute"),_defineProperty(_timelineBadge,"top","16px"),_defineProperty(_timelineBadge,"left","50%"),_defineProperty(_timelineBadge,"marginLeft","-24px"),_defineProperty(_timelineBadge,"zIndex","100"),_defineProperty(_timelineBadge,"borderTopRightRadius","50%"),_defineProperty(_timelineBadge,"borderTopLeftRadius","50%"),_defineProperty(_timelineBadge,"borderBottomRightRadius","50%"),_defineProperty(_timelineBadge,"borderBottomLeftRadius","50%"),_timelineBadge),timelineSimpleBadge:{left:"5%"},info:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(0, 188, 212, 0.4)"},success:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(76, 175, 80, 0.4)"},danger:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(244, 67, 54, 0.4)"},warning:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(255, 152, 0, 0.4)"},primary:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(156, 39, 176, 0.4)"},badgeIcon:{width:"24px",height:"51px"},timelinePanel:(_timelinePanel={},_defineProperty(_timelinePanel,theme.breakpoints.down("sm"),{float:"right !important",width:"86% !important","&:before":{borderLeftWidth:"0 !important",borderRightWidth:"15px !important",left:"-15px !important",right:"auto !important"},"&:after":{borderLeftWidth:"0 !important",borderRightWidth:"14px !important",left:"-14px !important",right:"auto !important"}}),_defineProperty(_timelinePanel,"width","45%"),_defineProperty(_timelinePanel,"float","left"),_defineProperty(_timelinePanel,"padding","20px"),_defineProperty(_timelinePanel,"marginBottom","20px"),_defineProperty(_timelinePanel,"position","relative"),_defineProperty(_timelinePanel,"boxShadow","0 1px 4px 0 rgba(0, 0, 0, 0.14)"),_defineProperty(_timelinePanel,"borderRadius","6px"),_defineProperty(_timelinePanel,"color","rgba(0, 0, 0, 0.87)"),_defineProperty(_timelinePanel,"background","#fff"),_defineProperty(_timelinePanel,"&:before",{position:"absolute",top:"26px",right:"-15px",display:"inline-block",borderTop:"15px solid transparent",borderLeft:"15px solid #e4e4e4",borderRight:"0 solid #e4e4e4",borderBottom:"15px solid transparent",content:'" "'}),_defineProperty(_timelinePanel,"&:after",{position:"absolute",top:"27px",right:"-14px",display:"inline-block",borderTop:"14px solid transparent",borderLeft:"14px solid #FFFFFF",borderRight:"0 solid #FFFFFF",borderBottom:"14px solid transparent",content:'" "'}),_timelinePanel),timelineSimplePanel:{width:"86%"},timelinePanelInverted:_defineProperty({},theme.breakpoints.up("sm"),{float:"right",backgroundColor:"#FFFFFF","&:before":{borderLeftWidth:"0",borderRightWidth:"15px",left:"-15px",right:"auto"},"&:after":{borderLeftWidth:"0",borderRightWidth:"14px",left:"-14px",right:"auto"}}),timelineHeading:{marginBottom:"15px"},timelineBody:{fontSize:"14px",lineHeight:"21px"},timelineFooter:{zIndex:"1000",position:"relative",float:"left"},footerTitle:{color:"#333333",fontWeight:"400",margin:"10px 0px 0px"},footerLine:{marginTop:"10px",marginBottom:"5px"}};};/* harmony default export */ __webpack_exports__["a"] = (timelineStyle);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var customTabsStyle={cardTitle:{float:"left",padding:"10px 10px 10px 0px",lineHeight:"24px"},cardTitleRTL:{float:"right",padding:"10px 0px 10px 10px !important"},displayNone:{display:"none !important"},tabsRoot:{minHeight:"unset !important","& $tabRootButton":{fontSize:"0.875rem"}},tabRootButton:{minHeight:"unset !important",minWidth:"unset !important",width:"unset !important",height:"unset !important",maxWidth:"unset !important",maxHeight:"unset !important",padding:"10px 15px",borderRadius:"3px",lineHeight:"24px",border:"0 !important",color:"#fff !important",marginLeft:"4px","&:last-child":{marginLeft:"0px"}},tabLabelContainer:{padding:"0px"},tabLabel:{fontWeight:"500",fontSize:"12px"},tabSelected:{backgroundColor:"rgba(255, 255, 255, 0.2)",transition:"0.2s background-color 0.1s"},tabWrapper:{display:"inline-block",minHeight:"unset !important",minWidth:"unset !important",width:"unset !important",height:"unset !important",maxWidth:"unset !important",maxHeight:"unset !important","& > svg,& > .fab,& > .fas,& > .far,& > .fal,& > .material-icons":{verticalAlign:"middle",margin:"-1px 5px 0 0"}}};/* harmony default export */ __webpack_exports__["a"] = (customTabsStyle);

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(__webpack_require__(1199));

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _RootRef = _interopRequireDefault(__webpack_require__(329));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _helpers = __webpack_require__(25);

var _exactProp = _interopRequireDefault(__webpack_require__(123));

var _Grow = _interopRequireDefault(__webpack_require__(170));

var _Popper = _interopRequireDefault(__webpack_require__(249));

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      opacity: 0.9
    },

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
      maxWidth: 300
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: (0, _defineProperty2.default)({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: (0, _defineProperty2.default)({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: (0, _defineProperty2.default)({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: (0, _defineProperty2.default)({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};

exports.styles = styles;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tooltip).call(this));
    _this.childrenRef = null;
    _this.closeTimer = null;
    _this.defaultId = null;
    _this.enterTimer = null;
    _this.focusTimer = null;
    _this.ignoreNonTouchEvents = false;
    _this.isControlled = null;
    _this.leaveTimer = null;
    _this.touchTimer = null;

    _this.onRootRef = function (ref) {
      _this.childrenRef = ref;
    };

    _this.handleFocus = function (event) {
      event.persist(); // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.

      _this.focusTimer = setTimeout(function () {
        // We need to make sure the focus hasn't moved since the event was triggered.
        if (_this.childrenRef === document.activeElement) {
          _this.handleEnter(event);
        }
      }, 0);
      var childrenProps = _this.props.children.props;

      if (childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }
    };

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      _this.childrenRef.setAttribute('title', '');

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      // The mouseover event will trigger for every nested element in the tooltip.
      // We can skip rerendering when the tooltip is already open.
      // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
      if (!_this.isControlled && !_this.state.open) {
        _this.setState({
          open: true
        });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          open: false
        });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _this.props.theme.transitions.duration.shortest);
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;

      if (children.props.onTouchStart) {
        children.props.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;

      if (children.props.onTouchEnd) {
        children.props.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;
    _this.state = {
      open: null
    };

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
       false ? (0, _warning.default)(!this.childrenRef.disabled || !this.childrenRef.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0; // Fallback to this default id when possible.
      // Use the random value for client side rendering only.
      // We can't use it server side.

      this.defaultId = "mui-tooltip-".concat(Math.round(Math.random() * 1e5)); // Rerender with this.defaultId and this.childrenRef.

      if (this.props.open) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
      clearTimeout(this.enterTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          classes = _this$props5.classes,
          disableFocusListener = _this$props5.disableFocusListener,
          disableHoverListener = _this$props5.disableHoverListener,
          disableTouchListener = _this$props5.disableTouchListener,
          id = _this$props5.id,
          openProp = _this$props5.open,
          placement = _this$props5.placement,
          PopperProps = _this$props5.PopperProps,
          theme = _this$props5.theme,
          title = _this$props5.title,
          TransitionComponent = _this$props5.TransitionComponent,
          TransitionProps = _this$props5.TransitionProps;
      var open = this.isControlled ? openProp : this.state.open; // There is no point at displaying an empty tooltip.

      if (title === '') {
        open = false;
      }

      var childrenProps = {
        'aria-describedby': open ? id || this.defaultId : null,
        title: !open && typeof title === 'string' ? title : null
      };

      if (!disableTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableFocusListener) {
        childrenProps.onFocus = this.handleFocus;
        childrenProps.onBlur = this.handleLeave;
      }

       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have provided a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childrenProps)), _react.default.createElement(_Popper.default, (0, _extends2.default)({
        className: classes.popper,
        placement: placement,
        anchorEl: this.childrenRef,
        open: open,
        id: childrenProps['aria-describedby'],
        transition: true
      }, PopperProps), function (_ref) {
        var placementInner = _ref.placement,
            TransitionPropsInner = _ref.TransitionProps;
        return _react.default.createElement(TransitionComponent, (0, _extends2.default)({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(placementInner.split('-')[0]))])
        }, title));
      }));
    }
  }]);
  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes.default.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes.default.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes.default.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes.default.number,

  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * This property is used with aria-describedby to solve the accessibility issue.
   * If you don't provide this property. It fallback to a random generated id.
   */
  id: _propTypes.default.string,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes.default.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes.default.number,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes.default.bool,

  /**
   * Tooltip placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Properties applied to the [`Popper`](/api/popper) element.
   */
  PopperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Tooltip.propTypes =  false ? (0, _exactProp.default)(Tooltip.propTypes) : {};
Tooltip.defaultProps = {
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  TransitionComponent: _Grow.default
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltip',
  withTheme: true
})(Tooltip);

exports.default = _default;

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
var tasksStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],{table:{marginBottom:"0"},tableRow:{position:"relative",borderBottom:"1px solid #dddddd"},tableActions:{border:"none",padding:"12px 8px !important",verticalAlign:"middle"},tableCell:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{padding:"0",verticalAlign:"middle",border:"none",lineHeight:"1.42857143",fontSize:"14px"}),tableActionButton:{width:"27px",height:"27px",padding:"0"},tableActionButtonIcon:{width:"17px",height:"17px"},edit:{backgroundColor:"transparent",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */],boxShadow:"none"},close:{backgroundColor:"transparent",color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */],boxShadow:"none"},tooltip:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["A" /* tooltip */]});/* harmony default export */ __webpack_exports__["a"] = (tasksStyle);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cardAvatarStyle={cardAvatar:{"&$cardAvatarProfile img,&$cardAvatarTestimonial img":{width:"100%",height:"auto"}},cardAvatarProfile:{maxWidth:"130px",maxHeight:"130px",margin:"-50px auto 0",borderRadius:"50%",overflow:"hidden",padding:"0",boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)","&$cardAvatarPlain":{marginTop:"0"}},cardAvatarPlain:{},cardAvatarTestimonial:{margin:"-50px auto 0",maxWidth:"100px",maxHeight:"100px",borderRadius:"50%",overflow:"hidden",padding:"0",boxShadow:"0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)","&$cardAvatarPlain":{marginTop:"0"}},cardAvatarTestimonialFooter:{marginBottom:"-50px",marginTop:"10px"}};/* harmony default export */ __webpack_exports__["a"] = (cardAvatarStyle);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_PermIdentity__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_PermIdentity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Clearfix_Clearfix_jsx__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardIcon_jsx__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardAvatar_jsx__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_img_faces_marc_jpg__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_img_faces_marc_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_assets_img_faces_marc_jpg__);
// @material-ui/core components
// @material-ui/icons
// core components
function UserProfile(props){var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardHeader_jsx__["a" /* default */],{color:"rose",icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardIcon_jsx__["a" /* default */],{color:"rose"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_PermIdentity___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardIconTitle},"Edit Profile - ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Complete your profile"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Company (disabled)",id:"company-disabled",formControlProps:{fullWidth:true},inputProps:{disabled:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Username",id:"username",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Email address",id:"email-address",formControlProps:{fullWidth:true}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"First Name",id:"first-name",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Last Name",id:"last-name",formControlProps:{fullWidth:true}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"City",id:"city",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Country",id:"country",formControlProps:{fullWidth:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Postal Code",id:"postal-code",formControlProps:{fullWidth:true}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel___default.a,{style:{color:"#AAAAAA"}},"About me"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.",id:"about-me",formControlProps:{fullWidth:true},inputProps:{multiline:true,rows:5}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",className:classes.updateProfileButton},"Update Profile"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Clearfix_Clearfix_jsx__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Card_Card_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardAvatar_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo",onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15_assets_img_faces_marc_jpg___default.a,alt:"..."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_CardBody_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"CEO / CO-FOUNDER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Alec Thompson"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.description},"Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens\u2019 bed design but the back is..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",round:true},"Follow"))))));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_14_assets_jss_material_dashboard_pro_react_views_userProfileStyles_jsx__["a" /* default */])(UserProfile));

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'PermIdentity');

exports.default = _default;

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// mterial-ui components
var style={clearfix:{"&:after,&:before":{display:"table",content:'" "'},"&:after":{clear:"both"}}};function Clearfix(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.clearfix});}Clearfix.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(Clearfix));

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var userProfileStyles={cardTitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px","& small":{fontSize:"80%",fontWeight:"400"}}),cardCategory:{marginTop:"10px",color:"#999999 !important",textAlign:"center"},description:{color:"#999999"},updateProfileButton:{float:"right"}};/* harmony default export */ __webpack_exports__["a"] = (userProfileStyles);

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/marc.aba54d65.jpg";

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Heading_Heading_jsx__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Timeline_Timeline_jsx__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_variables_general_jsx__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// core components
var TimelinePage=function(_React$Component){_inherits(TimelinePage,_React$Component);function TimelinePage(){_classCallCheck(this,TimelinePage);return _possibleConstructorReturn(this,(TimelinePage.__proto__||Object.getPrototypeOf(TimelinePage)).apply(this,arguments));}_createClass(TimelinePage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Heading_Heading_jsx__["a" /* default */],{title:"Timeline",textAlign:"center"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Timeline_Timeline_jsx__["a" /* default */],{stories:__WEBPACK_IMPORTED_MODULE_7_variables_general_jsx__["j" /* stories */]}))))));}}]);return TimelinePage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TimelinePage);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Timeline_Timeline_jsx__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomTabs_CustomTabs_jsx__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Card_CardAvatar_jsx__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
// core components
var styles={cardTitle:__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],cardTitleWhite:Object.assign({},__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{color:"#FFFFFF",marginTop:"0"}),cardCategoryWhite:{margin:"0",color:"rgba(255, 255, 255, 0.8)",fontSize:".875rem"},cardCategory:{color:"#999999",marginTop:"10px"},icon:{color:"#333333",margin:"10px auto 0",width:"130px",height:"130px",border:"1px solid #E5E5E5",borderRadius:"50%",lineHeight:"174px","& svg":{width:"55px",height:"55px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"55px",fontSize:"55px"}},iconRose:{color:__WEBPACK_IMPORTED_MODULE_23_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},marginTop30:{marginTop:"30px"},testimonialIcon:{marginTop:"30px","& svg":{width:"40px",height:"40px"}},cardTestimonialDescription:{fontStyle:"italic",color:"#999999"}};var RTLSupport=function(_React$Component){_inherits(RTLSupport,_React$Component);function RTLSupport(){_classCallCheck(this,RTLSupport);return _possibleConstructorReturn(this,(RTLSupport.__proto__||Object.getPrototypeOf(RTLSupport)).apply(this,arguments));}_createClass(RTLSupport,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Card_CardHeader_jsx__["a" /* default */],{color:"warning",text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_CardText_jsx__["a" /* default */],{color:"warning"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitleWhite},"\u0644\u062A\u0643\u0627\u0644\u064A\u0641 \u064A\u0628\u0642"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardCategoryWhite},"\u0628\u0627\u0644\u0625\u0646\u0632\u0627\u0644 \u0648\u0641\u064A. \u062E\u064A\u0627\u0631 \u0648\u0645\u0636\u0649 \u0627\u0644\u0639\u0645\u0644\u064A\u0627\u062A \u062A\u0645 \u0630\u0644\u0643, \u062A\u0645 \u0645\u0639\u0642\u0644 \u0645\u0631\u0645\u0649"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Table_Table_jsx__["a" /* default */],{hover:true,tableHeaderColor:"warning",tableHead:["وتم","لأمريكية هذا","شاسعالأمريكية","الأمريكية "],tableData:[["وا حد","السبب وفرنسا الصينية ","$36,738","تكاليف"],["إثنان","بمباركة بها ","$23,789","الأمريكية من"],["ثلاثة"," شاسعالأمريكية ","$56,142","السفن وعُرفت"],["أربعة"," الاندونيسية","$38,735"," فصل."]]})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomTabs_CustomTabs_jsx__["a" /* default */],{rtlActive:true,title:"\u0645\u0646\u062A\u0635\u0641:",headerColor:"rose",tabs:[{tabName:"ضرب",tabIcon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_BugReport___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__["a" /* default */],{checkedIndexes:[0,3],tasksIndexes:[0,1,2,3],tasks:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["e" /* rtlBugs */]})},{tabName:"السفن",tabIcon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Code___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__["a" /* default */],{checkedIndexes:[0],tasksIndexes:[0,1],tasks:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["h" /* rtlWebsite */]})},{tabName:"فصل.",tabIcon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Cloud___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Tasks_Tasks_jsx__["a" /* default */],{checkedIndexes:[1],tasksIndexes:[0,1,2],tasks:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["f" /* rtlServer */]})}]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],{pricing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],{pricing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"\u062C\u064A\u0648\u0628 \u0633\u0644\u064A\u0645\u0627\u0646\u060C \u0627\u0644\u0625\u0646\u0632\u0627\u0644"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Home___default.a,{className:classes.iconRose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle+" "+classes.marginTop30},"$29"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardDescription},"\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u0645\u062A\u0633\u0627\u0642\u0637\u0629\u060C \u0645\u0646. \u0639\u0631\u0636 \u0628\u0633\u0628\u0628 \u0648\u0623\u0643\u062B\u0631\u0647\u0627 \u0627\u0644\u0627\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0629 \u0628\u0640."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"rose"},"\u062D\u0627\u0645\u0644\u0627\u062A \u0641\u0639\u0644")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"\u0627\u0644\u0645\u062A\u062D\u062F\u0629 \u0644\u062A\u0642\u0644\u064A\u0639\u0629"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Icon___default.a,{className:classes.iconWhite},"weekend")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle+" "+classes.marginTop30},"\u0642\u0627\u0626\u0645\u0629"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"\u0627\u0644\u0623\u062C\u0644 \u0627\u0644\u0645\u062A\u0633\u0627\u0642\u0637\u0629\u060C \u0645\u0646. \u0639\u0631\u0636 \u0628\u0633\u0628\u0628 \u0648\u0623\u0643\u062B\u0631\u0647\u0627 \u0627\u0644\u0627\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0629 \u0628\u0640."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"white"},"\u062D\u0627\u0645\u0644\u0627\u062A \u0641\u0639\u0644")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Card_Card_jsx__["a" /* default */],{testimonial:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.testimonialIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_FormatQuote___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:classes.cardTestimonialDescription},"\u0628\u0639\u062F \u0648 \u0648\u0633\u0648\u0621 \u0627\u0644\u0623\u062D\u0645\u0631, \u062F\u0648\u0646 \u0639\u0642\u0628\u062A \u0627\u0644\u0647\u0627\u062F\u064A \u0623\u0645, \u0642\u062F \u062D\u0648\u0644 \u0642\u0627\u062F\u0629 \u062D\u0643\u0648\u0645\u0629 \u064A\u062A\u0639\u0644\u0651\u0642. \u0623\u062E\u0630 \u062D\u0635\u062F\u062A \u0627\u0648\u0631\u0648\u0628\u0627 \u0623\u0646, \u0643\u0644\u0627 \u0645\u0647\u0645\u0651\u0627\u062A \u0627\u0633\u0628\u0648\u0639\u064A\u0646 \u0627\u0644\u062A\u062E\u0637\u064A\u0637 \u0639\u0644. \u0648\u0625\u064A\u0637\u0627\u0644\u064A \u0627\u0644\u0623\u0648\u0631\u0648\u0628\u064A \u0648 \u0646\u0641\u0633. \u0635\u0641\u062D\u0629 \u0627\u062D\u062F\u0627\u062B \u0623\u0636\u0641 \u0627\u0646, \u0647\u0648 \u0645\u0631\u062C\u0639 \u0646\u0647\u0627\u064A\u0629 \u0644\u0647\u064A\u0645\u0646\u0629 \u0643\u0645\u0627. \u062A\u0645 \u0645\u0627\u064A\u0648 \u0644\u0641\u0634\u0644 \u0627\u0644\u0645\u062F\u0646 \u062F\u0648\u0644, \u062C\u0639\u0644 \u0623\u0646 \u0639\u0633\u0643\u0631\u064A\u0627\u064B \u0627\u0644\u062A\u0651\u062D\u0648\u0644 \u0627\u0633\u062A\u0631\u062C\u0627\u0639.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Card_CardFooter_jsx__["a" /* default */],{testimonial:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"\u0623\u0644\u064A\u0643 \u0637\u0648\u0645\u0633\u0648\u0646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"\u0623\u0644\u064A\u0643 \u0637\u0648\u0645\u0633\u0648\u0646@"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Card_CardAvatar_jsx__["a" /* default */],{testimonial:true,testimonialFooter:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo",onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_22_assets_img_faces_card_profile1_square_jpg___default.a,alt:"..."})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Timeline_Timeline_jsx__["a" /* default */],{simple:true,stories:__WEBPACK_IMPORTED_MODULE_21_variables_general_jsx__["g" /* rtlStories */]}))));}}]);return RTLSupport;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(styles)(RTLSupport));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Home__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Business__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AccountBalance__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AccountBalance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AccountBalance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_views_pricingPageStyle_jsx__ = __webpack_require__(1211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
// core components
var PricingPage=function(_React$Component){_inherits(PricingPage,_React$Component);function PricingPage(){_classCallCheck(this,PricingPage);return _possibleConstructorReturn(this,(PricingPage.__proto__||Object.getPrototypeOf(PricingPage)).apply(this,arguments));}_createClass(PricingPage,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:classes.title},"Pick the best plan for you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:classes.description},"You have Free Unlimited Updates and Premium Support on each package."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"Freelancer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Icon___default.a,{className:classes.iconWhite},"weekend")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitleWhite+" "+classes.marginTop30},"FREE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"This is good if your company size is between 2 and 10 Persons."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"white"},"Choose plan")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__["a" /* default */],{pricing:true,raised:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__["a" /* default */],{pricing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"SMALL COMPANY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Home___default.a,{className:classes.iconRose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitle+" "+classes.marginTop30},"$29"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardDescription},"This is good if your company size is between 2 and 10 Persons."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"rose"},"Choose plan")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"MEDIUM COMPANY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Business___default.a,{className:classes.iconWhite})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitleWhite+" "+classes.marginTop30},"$69"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"This is good if your company size is between 11 and 99 Persons."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"white"},"Choose plan")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Card_Card_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_CardBody_jsx__["a" /* default */],{pricing:true,plain:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:classes.cardCategory},"ENTERPRISE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AccountBalance___default.a,{className:classes.iconWhite})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:classes.cardTitleWhite+" "+classes.marginTop30},"$159"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.cardCategory},"This is good if your company size is 99+ persons."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"white"},"Choose plan"))))));}}]);return PricingPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PricingPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_12_assets_jss_material_dashboard_pro_react_views_pricingPageStyle_jsx__["a" /* default */])(PricingPage));

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"
})), 'AccountBalance');

exports.default = _default;

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // PricingPage Pages View styles
// #############################
var pricingPageStyle=function pricingPageStyle(theme){return{container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* container */],_defineProperty({zIndex:"4"},theme.breakpoints.down("sm"),{paddingBottom:"100px"})),title:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["k" /* defaultFont */],{color:"#FFFFFF",marginTop:"5vh",marginBottom:"30px",textAlign:"center"}),description:{fontSize:"18px",color:"#FFFFFF",textAlign:"center"},cardTitleWhite:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{color:"#FFFFFF !important"}),cardCategory:{color:"#999999",marginTop:"10px"},cardCategoryWhite:{color:"#FFFFFF",marginTop:"10px"},icon:{color:"rgba(255, 255, 255, 0.76)",margin:"10px auto 0",width:"130px",height:"130px",border:"1px solid #E5E5E5",borderRadius:"50%",lineHeight:"174px","& svg":{width:"55px",height:"55px"},"& .fab,& .fas,& .far,& .fal,& .material-icons":{width:"55px",fontSize:"55px"}},iconWhite:{color:"#FFFFFF"},iconRose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},marginTop30:{marginTop:"30px"}};};/* harmony default export */ __webpack_exports__["a"] = (pricingPageStyle);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControlLabel__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Icon__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Timeline__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Code__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Group__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Face__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Face___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Face__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_InfoArea_InfoArea_jsx__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_jss_material_dashboard_pro_react_views_registerPageStyle__ = __webpack_require__(1216);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// @material-ui/icons
// import LockOutline from "@material-ui/icons/LockOutline";
// core components
var RegisterPage=function(_React$Component){_inherits(RegisterPage,_React$Component);function RegisterPage(props){_classCallCheck(this,RegisterPage);var _this=_possibleConstructorReturn(this,(RegisterPage.__proto__||Object.getPrototypeOf(RegisterPage)).call(this,props));_this.state={checked:[]};_this.handleToggle=_this.handleToggle.bind(_this);return _this;}_createClass(RegisterPage,[{key:"handleToggle",value:function handleToggle(value){var checked=this.state.checked;var currentIndex=checked.indexOf(value);var newChecked=[].concat(_toConsumableArray(checked));if(currentIndex===-1){newChecked.push(value);}else{newChecked.splice(currentIndex,1);}this.setState({checked:newChecked});}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Card_Card_jsx__["a" /* default */],{className:classes.cardSignup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:classes.cardTitle},"Register"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_InfoArea_InfoArea_jsx__["a" /* default */],{title:"Marketing",description:"We've created the marketing campaign of the website. It was a very interesting collaboration.",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Timeline___default.a,iconColor:"rose"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_InfoArea_InfoArea_jsx__["a" /* default */],{title:"Fully Coded in HTML5",description:"We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub.",icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Code___default.a,iconColor:"primary"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_InfoArea_InfoArea_jsx__["a" /* default */],{title:"Built Audience",description:"There is also a Fully Customizable CMS Admin Dashboard for this product.",icon:__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Group___default.a,iconColor:"info"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:8,md:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"twitter"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-twitter"}))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"dribbble"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-dribbble"}))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,color:"facebook"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fab fa-facebook-f"}))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.socialTitle},"or be classical")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{className:classes.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true,className:classes.customFormControlClasses},inputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputAdornment___default.a,{position:"start",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Face___default.a,{className:classes.inputAdornmentIcon})),placeholder:"First Name..."}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true,className:classes.customFormControlClasses},inputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputAdornment___default.a,{position:"start",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon})),placeholder:"Email..."}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CustomInput_CustomInput_jsx__["a" /* default */],{formControlProps:{fullWidth:true,className:classes.customFormControlClasses},inputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_InputAdornment___default.a,{position:"start",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Icon___default.a,{className:classes.inputAdornmentIcon},"lock_outline")),placeholder:"Password..."}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControlLabel___default.a,{classes:{root:classes.checkboxLabelControl,label:classes.checkboxLabel},control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Checkbox___default.a,{tabIndex:-1,onClick:function onClick(){return _this2.handleToggle(1);},checkedIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check___default.a,{className:classes.checkedIcon}),icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Check___default.a,{className:classes.uncheckedIcon}),classes:{checked:classes.checked,root:classes.checkRoot}}),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"I agree to the"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo"},"terms and conditions"),".")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CustomButtons_Button_jsx__["a" /* default */],{round:true,color:"primary"},"Get started"))))))))));}}]);return RegisterPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);RegisterPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_20_assets_jss_material_dashboard_pro_react_views_registerPageStyle__["a" /* default */])(RegisterPage));

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'Group');

exports.default = _default;

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_infoStyle__ = __webpack_require__(1215);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @material-ui/core components
function InfoArea(_ref){var props=_objectWithoutProperties(_ref,[]);var classes=props.classes,title=props.title,description=props.description,iconColor=props.iconColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.infoArea},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.iconWrapper+" "+classes[iconColor]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(props.icon,{className:classes.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.descriptionWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.title},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:classes.description},description)));}InfoArea.defaultProps={iconColor:"gray"};InfoArea.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,iconColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["primary","warning","danger","success","info","rose","gray"])};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3_assets_jss_material_dashboard_pro_react_components_infoStyle__["a" /* default */])(InfoArea));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
// ##############################
// // // Info component styles
// #############################
var infoStyle={infoArea:{maxWidth:"360px",margin:"0 auto",padding:"0px"},iconWrapper:{float:"left",marginTop:"24px",marginRight:"10px"},primary:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["t" /* primaryColor */]},warning:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["E" /* warningColor */]},danger:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["i" /* dangerColor */]},success:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["z" /* successColor */]},info:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["q" /* infoColor */]},rose:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["w" /* roseColor */]},gray:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */]},icon:{width:"36px",height:"36px"},descriptionWrapper:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],overflow:"hidden"},title:{color:"#3C4858",margin:"30px 0 15px",textDecoration:"none",fontSize:"18px"},description:{color:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["n" /* grayColor */],overflow:"hidden",marginTop:"0px",fontSize:"14px"}};/* harmony default export */ __webpack_exports__["a"] = (infoStyle);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__ = __webpack_require__(84);
// ##############################
// // // RegisterPage view styles
// #############################
var registerPageStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_assets_jss_material_dashboard_pro_react_customCheckboxRadioSwitch_jsx__["a" /* default */],{cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{textAlign:"center"}),container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* container */],{position:"relative",zIndex:"3"// paddingTop: "23vh"
}),cardSignup:{borderRadius:"6px",boxShadow:"0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",marginBottom:"100px",padding:"40px 0px",marginTop:"15vh"},center:{textAlign:"center"},right:{textAlign:"right"},left:{textAlign:"left"},form:{padding:"0 20px",position:"relative"},socialTitle:{fontSize:"18px"},inputAdornment:{marginRight:"18px",position:"relative"},inputAdornmentIcon:{color:"#555"},customFormControlClasses:{margin:"0 12px"},checkboxLabelControl:{margin:"0"},checkboxLabel:{marginLeft:"6px",color:"rgba(0, 0, 0, 0.26)"}});/* harmony default export */ __webpack_exports__["a"] = (registerPageStyle);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card_CardAvatar_jsx__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Card_CardFooter_jsx__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_faces_avatar_jpg__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_img_faces_avatar_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_img_faces_avatar_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_views_lockScreenPageStyle_jsx__ = __webpack_require__(1218);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var LockScreenPage=function(_React$Component){_inherits(LockScreenPage,_React$Component);function LockScreenPage(props){_classCallCheck(this,LockScreenPage);// we use this to make the card to appear after the page has been rendered
var _this=_possibleConstructorReturn(this,(LockScreenPage.__proto__||Object.getPrototypeOf(LockScreenPage)).call(this,props));_this.state={cardAnimaton:"cardHidden"};return _this;}_createClass(LockScreenPage,[{key:"componentDidMount",value:function componentDidMount(){// we add a hidden class to the card and after 700 ms we delete it and the transition appears
this.timeOutFunction=setTimeout(function(){this.setState({cardAnimaton:""});}.bind(this),700);}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timeOutFunction);this.timeOutFunction=null;}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],{profile:true,className:classes.customCardClass+" "+classes[this.state.cardAnimaton]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card_CardAvatar_jsx__["a" /* default */],{profile:true,className:classes.cardAvatar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#pablo",onClick:function onClick(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9_assets_img_faces_avatar_jpg___default.a,alt:"..."}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],{profile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:classes.cardTitle},"Tania Andrew"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:"Enter Password",id:"company-disabled",formControlProps:{fullWidth:true},inputProps:{type:"password"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Card_CardFooter_jsx__["a" /* default */],{className:classes.justifyContentCenter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",round:true},"Unlock")))));}}]);return LockScreenPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);LockScreenPage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_views_lockScreenPageStyle_jsx__["a" /* default */])(LockScreenPage));

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // LockScreenPage view styles
// #############################
var lockScreenPageStyle=function lockScreenPageStyle(theme){return{cardTitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["e" /* container */],_defineProperty({zIndex:"4"},theme.breakpoints.down("sm"),{paddingBottom:"100px"})),customCardClass:{width:"240px",margin:"60px auto 0",color:"#FFFFFF",display:"block",transform:"translate3d(0, 0, 0)",transition:"all 300ms linear"},cardHidden:{opacity:"0",transform:"translate3d(0, -60px, 0)"},cardAvatar:{maxWidth:"90px",maxHeight:"90px",marginTop:"-45px"},customCardFooterClass:{border:"none",paddingTop:"0"},justifyContentCenter:{justifyContent:"center !important"}};};/* harmony default export */ __webpack_exports__["a"] = (lockScreenPageStyle);

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'Image');

exports.default = _default;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Apps');

exports.default = _default;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
})), 'GridOn');

exports.default = _default;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Widgets');

exports.default = _default;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'DateRange');

exports.default = _default;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'MonetizationOn');

exports.default = _default;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
})), 'LockOpen');

exports.default = _default;

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // App styles
// #############################
var appStyle=function appStyle(theme){var _Object$assign;return{wrapper:{direction:"rtl",position:"relative",top:"0",height:"100vh","&:after":{display:"table",clear:"both",content:'" "'}},mainPanel:Object.assign((_Object$assign={transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */]+"px)"}),_defineProperty(_Object$assign,"overflow","auto"),_defineProperty(_Object$assign,"position","relative"),_defineProperty(_Object$assign,"float","left"),_Object$assign),__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* transition */],{maxHeight:"100%",width:"100%",overflowScrolling:"touch"}),content:{marginTop:"70px",padding:"30px 15px",minHeight:"calc(100% - 123px)"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* containerFluid */]),mainPanelSidebarMini:_defineProperty({},theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerMiniWidth */]+"px)"})};};/* harmony default export */ __webpack_exports__["a"] = (appStyle);

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sidebar-2.d30c9e30.jpg";

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_layouts_Dashboard_jsx__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
var mapStateToProps=function mapStateToProps(state){return{user:state.user};};var container=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0_layouts_Dashboard_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Header_Header_jsx__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Sidebar_Sidebar_jsx__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_routes_dashboard_jsx__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_img_logo_png__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_img_logo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// creates a beautiful scrollbar
// @material-ui/core components
// core components
//import Footer from "components/Footer/Footer.jsx";
// import image from "assets/img/sidebar-2.jpg";
var switchRoutes=function switchRoutes(user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_9_routes_dashboard_jsx__["a" /* default */].map(function(prop,key){if(user===null&&prop.secure){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{from:prop.path,to:"/pages",key:key});}if(prop.redirect)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{from:prop.path,to:prop.pathTo,key:key});if(prop.collapse)return prop.views.map(function(prop,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:prop.path,component:prop.component,key:key});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:prop.path,component:prop.component,key:key});}));};var ps;var Dashboard=function(_React$Component){_inherits(Dashboard,_React$Component);function Dashboard(props){_classCallCheck(this,Dashboard);var _this=_possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call(this,props));_this.handleDrawerToggle=function(){_this.setState({mobileOpen:!_this.state.mobileOpen});};_this.state={mobileOpen:false,miniActive:false};_this.resizeFunction=_this.resizeFunction.bind(_this);return _this;}_createClass(Dashboard,[{key:"componentDidMount",value:function componentDidMount(){if(navigator.platform.indexOf("Win")>-1){ps=new __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__["a" /* default */](this.refs.mainPanel,{suppressScrollX:true,suppressScrollY:false});document.body.style.overflow="hidden";}window.addEventListener("resize",this.resizeFunction);}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(navigator.platform.indexOf("Win")>-1){ps.destroy();}window.removeEventListener("resize",this.resizeFunction);}},{key:"componentDidUpdate",value:function componentDidUpdate(e){if(e.history.location.pathname!==e.location.pathname){this.refs.mainPanel.scrollTop=0;if(this.state.mobileOpen){this.setState({mobileOpen:false});}}}},{key:"getRoute",value:function getRoute(){return this.props.location.pathname!=="/maps/full-screen-maps";}},{key:"sidebarMinimize",value:function sidebarMinimize(){this.setState({miniActive:!this.state.miniActive});}},{key:"resizeFunction",value:function resizeFunction(){if(window.innerWidth>=960){this.setState({mobileOpen:false});}}},{key:"render",value:function render(){var _cx;var _props=this.props,classes=_props.classes,user=_props.user,rest=_objectWithoutProperties(_props,["classes","user"]);var mainPanel=classes.mainPanel+" "+__WEBPACK_IMPORTED_MODULE_1_classnames___default()((_cx={},_defineProperty(_cx,classes.mainPanelSidebarMini,this.state.miniActive),_defineProperty(_cx,classes.mainPanelWithPerfectScrollbar,navigator.platform.indexOf("Win")>-1),_cx));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Sidebar_Sidebar_jsx__["a" /* default */],Object.assign({routes:__WEBPACK_IMPORTED_MODULE_9_routes_dashboard_jsx__["a" /* default */],logoText:"Trivaj Leads",logo:__WEBPACK_IMPORTED_MODULE_11_assets_img_logo_png___default.a,image:null,handleDrawerToggle:this.handleDrawerToggle,open:this.state.mobileOpen,color:"blue",bgColor:"black",miniActive:this.state.miniActive},rest)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:mainPanel,ref:"mainPanel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Header_Header_jsx__["a" /* default */],Object.assign({sidebarMinimize:this.sidebarMinimize.bind(this),miniActive:this.state.miniActive,routes:__WEBPACK_IMPORTED_MODULE_9_routes_dashboard_jsx__["a" /* default */],handleDrawerToggle:this.handleDrawerToggle},rest)),this.getRoute()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.content},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.container},switchRoutes(user))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.map},switchRoutes)));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Dashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_layouts_dashboardStyle_jsx__["a" /* default */])(Dashboard));

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_Dashboard_Dashboard_jsx__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_views_Dashboard_Settings_jsx__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_Dashboard_LeadsDashboard_jsx__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_Dashboard_CampaignLeads_jsx__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Tables_Campaigns__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Dashboard__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Search__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ViewList__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ViewList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ViewList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Settings__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Settings__);
// @material-ui/icons
var dashRoutes=[{secure:true,path:"/dashboard",name:"Dashboard",icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Dashboard___default.a,component:__WEBPACK_IMPORTED_MODULE_0_containers_Dashboard_Dashboard_jsx__["a" /* default */]},{secure:true,path:"/search",name:"Search Leads",icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Search___default.a,component:__WEBPACK_IMPORTED_MODULE_2_containers_Dashboard_LeadsDashboard_jsx__["a" /* default */]},{secure:true,hidden:true,path:"/campaigns/:id",name:"Campaigns",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ViewList___default.a,component:__WEBPACK_IMPORTED_MODULE_3_views_Dashboard_CampaignLeads_jsx__["a" /* default */]},{secure:true,path:"/campaigns",name:"Campaigns",icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ViewList___default.a,component:__WEBPACK_IMPORTED_MODULE_4_views_Tables_Campaigns__["a" /* default */]},{secure:true,path:"/settings",hidden:false,name:"Settings",icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Settings___default.a,component:__WEBPACK_IMPORTED_MODULE_1_views_Dashboard_Settings_jsx__["a" /* default */]},{redirect:true,path:"/",pathTo:"/dashboard",name:"Dashboard"}];/* harmony default export */ __webpack_exports__["a"] = (dashRoutes);

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
var mapStateToProps=function mapStateToProps(state){return{leads:state.leads.length,campaigns:state.campaigns.length};};var container=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0_views_Dashboard_Dashboard_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_NavPills_NavPills_jsx__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_Components_SMTPNav_jsx__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Components_ApiNav_jsx__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Components_PasswordNav__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap_sweetalert__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_VerifiedUser__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_VerifiedUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_VerifiedUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_VpnKey__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_VpnKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_VpnKey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
//import CardHeader from "components/Card/CardHeader.jsx";
//icons
var styles=Object.assign({cardTitle:__WEBPACK_IMPORTED_MODULE_9_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],pageSubcategoriesTitle:{color:"#3C4858",textDecoration:"none",textAlign:"center"},cardCategory:{margin:"0",color:"#999999"}},__WEBPACK_IMPORTED_MODULE_15_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */]);var Settings=function(_React$Component){_inherits(Settings,_React$Component);function Settings(props){_classCallCheck(this,Settings);var _this=_possibleConstructorReturn(this,(Settings.__proto__||Object.getPrototypeOf(Settings)).call(this,props));_this.showErrorMessage=function(title,errorMessage){_this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap_sweetalert___default.a,{danger:true,style:{display:"block",marginTop:"-100px"},title:title,onConfirm:function onConfirm(){return _this.hideAlert();},onCancel:function onCancel(){return _this.hideAlert();},confirmBtnCssClass:_this.props.classes.button+" "+_this.props.classes.success},errorMessage)});};_this.showSuccessMessage=function(title,message){_this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_bootstrap_sweetalert___default.a,{success:true,style:{display:"block",marginTop:"-100px"},title:title,onConfirm:function onConfirm(){return _this.hideAlert();},onCancel:function onCancel(){return _this.hideAlert();},confirmBtnCssClass:_this.props.classes.button+" "+_this.props.classes.success},message)});};_this.state={alert:null,show:false};return _this;}_createClass(Settings,[{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"render",value:function render(){//const { classes } = this.props;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_NavPills_NavPills_jsx__["a" /* default */],{color:"rose",tabs:[{tabButton:"SMTP",tabIcon:__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Email___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_views_Components_SMTPNav_jsx__["a" /* default */],null)},{tabButton:"API Keys",tabIcon:__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_VpnKey___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_views_Components_ApiNav_jsx__["a" /* default */],null)},{tabButton:"Password",tabIcon:__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_VerifiedUser___default.a,tabContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_views_Components_PasswordNav__["a" /* default */],{showSuccessMessage:this.showSuccessMessage.bind(this),showErrorMessage:this.showErrorMessage.bind(this)})}]}))))));}}]);return Settings;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles_withStyles___default()(styles)(Settings));

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_store_Actions_js__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
var style=Object.assign({infoText:{fontWeight:"300",margin:"10px 0 30px",textAlign:"center"},inputAdornmentIcon:{color:"#555"},inputAdornment:{position:"relative"}},__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */],{right:{float:"right!important"}});var SMTPNav=function(_Component){_inherits(SMTPNav,_Component);function SMTPNav(props){_classCallCheck(this,SMTPNav);var _this=_possibleConstructorReturn(this,(SMTPNav.__proto__||Object.getPrototypeOf(SMTPNav)).call(this,props));_this.handleSimpleSelect=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.state={encryption_select:"",email:"",host:"",port:"",username:"",password:""};_this.handleSimpleSelect=_this.handleSimpleSelect.bind(_this);_this.change=_this.change.bind(_this);return _this;}_createClass(SMTPNav,[{key:"componentDidMount",value:function componentDidMount(){var smtp=this.props.smtp;if(smtp!=null){this.setState({email:smtp.email,host:smtp.host,port:smtp.port,username:smtp.username,password:smtp.password,encryption_select:smtp.encryption});}}},{key:"change",value:function change(event,stateName){this.setState(_defineProperty({},stateName,event.target.value));}},{key:"saveSmtp",value:function saveSmtp(){this.props.setSMTP(this.state.email,this.state.host,this.state.port,this.state.username,this.state.password,this.state.encryption_select);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,smtp=_props.smtp;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Email ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"email",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"email","email");},defaultValue:smtp!=null?smtp.email:"",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Host ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"host",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"host","host");},defaultValue:smtp!=null?smtp.host:"",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Port ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"port",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"port","port");},defaultValue:smtp!=null?smtp.port:"",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Username ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"username",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"username","username");},defaultValue:smtp!=null?smtp.username:"",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Password ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"password_smtp",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"password","password");},defaultValue:smtp!=null?smtp.password:"",type:"password",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{fullWidth:true,className:classes.selectFormControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:"simple-select",className:classes.selectLabel},"Encryption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{MenuProps:{className:classes.selectMenu},classes:{select:classes.select},value:this.state.encryption_select,onChange:this.handleSimpleSelect,inputProps:{name:"encryption_select",id:"encryption_select"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{disabled:true,classes:{root:classes.selectMenuItem}},"Encryption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"tls"},"TLS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{classes:{root:classes.selectMenuItem,selected:classes.selectMenuItemSelected},value:"ssl"},"SSL")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.right},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:function onClick(){return _this2.saveSmtp();}},"Save")))));}}]);return SMTPNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SMTPNav.propTypes={setSMTP:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,smtp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{smtp:state.smtp};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSMTP:function setSMTP(email,host,port,username,password,encryption){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_store_Actions_js__["l" /* setSMTP */])(email,host,port,username,password,encryption));},removeSMTP:function removeSMTP(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_store_Actions_js__["i" /* removeSMTP */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(style)(SMTPNav)));

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_store_Actions_js__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
var style=Object.assign({infoText:{fontWeight:"300",margin:"10px 0 30px",textAlign:"center"},inputAdornmentIcon:{color:"#555"},inputAdornment:{position:"relative"}},__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */],{right:{float:"right!important"}});var ApiNav=function(_Component){_inherits(ApiNav,_Component);function ApiNav(props){_classCallCheck(this,ApiNav);var _this=_possibleConstructorReturn(this,(ApiNav.__proto__||Object.getPrototypeOf(ApiNav)).call(this,props));_this.state={apiKey:""};_this.change=_this.change.bind(_this);return _this;}_createClass(ApiNav,[{key:"componentDidMount",value:function componentDidMount(){var apiKey=this.props.apiKey;if(apiKey!=null){this.setState({apiKey:apiKey});}}},{key:"change",value:function change(event,stateName){this.setState(_defineProperty({},stateName,event.target.value));}},{key:"saveApiKey",value:function saveApiKey(){this.props.saveApiKey(this.state.apiKey);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,apiKey=_props.apiKey;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center",alignItems:"baseline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:7,sm:7,md:7,lg:7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"API Key")//id="email"
,formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this2.change(event,"apiKey","apiKey");},defaultValue:apiKey!=null?apiKey:"",type:"password",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:4,sm:4,md:4,lg:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:function onClick(){return _this2.saveApiKey();}},"Save"))));}}]);return ApiNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ApiNav.propTypes={saveApiKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,apiKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(state){return{apiKey:state.apiKey};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{saveApiKey:function saveApiKey(key){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_store_Actions_js__["k" /* setApiKey */])(key));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(style)(ApiNav)));

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_app__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase_auth__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_store_Actions_js__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
var style=Object.assign({infoText:{fontWeight:"300",margin:"10px 0 30px",textAlign:"center"},inputAdornmentIcon:{color:"#555"},inputAdornment:{position:"relative"}},__WEBPACK_IMPORTED_MODULE_6_assets_jss_material_dashboard_pro_react_customSelectStyle_jsx__["a" /* default */],{right:{float:"right!important"}});var PasswordNav=function(_Component){_inherits(PasswordNav,_Component);function PasswordNav(props){_classCallCheck(this,PasswordNav);var _this=_possibleConstructorReturn(this,(PasswordNav.__proto__||Object.getPrototypeOf(PasswordNav)).call(this,props));_this.handleSimpleSelect=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.reauthenticate=function(currentPassword){var user=__WEBPACK_IMPORTED_MODULE_10_firebase_app___default.a.auth().currentUser;var cred=__WEBPACK_IMPORTED_MODULE_10_firebase_app___default.a.auth.EmailAuthProvider.credential(user.email,currentPassword);return user.reauthenticateAndRetrieveDataWithCredential(cred);};_this.state={current_password:"",confirm_password:"",password:""};_this.handleSimpleSelect=_this.handleSimpleSelect.bind(_this);_this.change=_this.change.bind(_this);return _this;}_createClass(PasswordNav,[{key:"change",value:function change(event,stateName){this.setState(_defineProperty({},stateName,event.target.value));}},{key:"changePassword",value:function changePassword(){var _this2=this;if(this.state.password!==this.state.confirm_password){this.props.showErrorMessage("Password Mismatch","Password do not match");}else{this.reauthenticate(this.state.current_password).then(function(){var user=__WEBPACK_IMPORTED_MODULE_10_firebase_app___default.a.auth().currentUser;user.updatePassword(_this2.state.password).then(function(){_this2.props.showSuccessMessage("Successfull","Password Updated");}).catch(function(error){_this2.props.showErrorMessage("Error",error.message);});}).catch(function(error){_this2.props.showErrorMessage("Error",error.message);});}}},{key:"render",value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_GridContainer_jsx__["a" /* default */],{justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Current Password ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"current_password",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this3.change(event,"current_password","current_password");},type:"password",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Password ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this3.change(event,"password","password");},type:"password",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_CustomInput_CustomInput_jsx__["a" /* default */],{labelText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Confirm Password ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"(required)")),id:"confirm_password",formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this3.change(event,"confirm_password","confirm_password");},type:"password",endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_InputAdornment___default.a,{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Email___default.a,{className:classes.inputAdornmentIcon}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.right},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:function onClick(){return _this3.changePassword();}},"Save")))));}}]);return PasswordNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PasswordNav.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,showSuccessMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,showErrorMessage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,setSMTP:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,smtp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{smtp:state.smtp};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSMTP:function setSMTP(email,host,port,username,password,encryption){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_store_Actions_js__["l" /* setSMTP */])(email,host,port,username,password,encryption));},removeSMTP:function removeSMTP(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_store_Actions_js__["i" /* removeSMTP */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles_withStyles___default()(style)(PasswordNav)));

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
})), 'VerifiedUser');

exports.default = _default;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'VpnKey');

exports.default = _default;

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_views_Dashboard_LeadsDashboard_jsx__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_Actions__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state){return{leads:state.tempLeads,fetching:state.fetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{addLeads:function addLeads(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_Actions__["j" /* searchLeads */])());}};};var container=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0_views_Dashboard_LeadsDashboard_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_csv__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardList_jsx__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_Headers_LeadHeader_jsx__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomLinearProgress_CustomLinearProgress_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Components_ReviewsModal_jsx__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Components_EmailModal_jsx__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_jss_material_dashboard_pro_react_views_dashboardStyle__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_variables_general_jsx__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
var LeadsDashboard=function(_React$Component){_inherits(LeadsDashboard,_React$Component);function LeadsDashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LeadsDashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LeadsDashboard.__proto__||Object.getPrototypeOf(LeadsDashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={emailState:false,value:0,noticeModal:false,emailModal:false,reviews:[],lead:{},csvData:[],filename:"data.csv"},_this.handleChange=function(event,value){_this.setState({value:value});},_this.handleChangeIndex=function(index){_this.setState({value:index});},_this.showReview=function(lead,reviews){_this.setState({reviews:reviews,lead:lead},function(){_this.openModal();});},_this.sendEmail=function(lead){_this.setState({lead:lead},function(){_this.setState({emailModal:true});});},_this.handleModalClose=function(){_this.setState({noticeModal:false,reviews:[],lead:{}});},_this.handleEmailModalClose=function(){_this.setState({emailModal:false});},_this.exportAsCSV=function(keyword,place){var data=[];_this.props.leads.forEach(function(lead){var obj={name:lead.name,formatted_address:lead.formatted_address,formatted_phone_number:lead.formatted_phone_number,rating:lead.rating,url:lead.url,website:lead.website};data.push(obj);});_this.setState({csvData:data,filename:(keyword+"_"+place).replace(/[^a-zA-Z0-9]/g,"_").toLowerCase()},function(){_this.csvLink.link.click();});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LeadsDashboard,[{key:"openModal",value:function openModal(){this.setState({noticeModal:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.emailModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_views_Components_EmailModal_jsx__["a" /* default */],{emailModal:this.state.emailModal,handleClose:this.handleEmailModalClose,lead:this.state.lead}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_csv__["CSVLink"],{data:this.state.csvData,headers:__WEBPACK_IMPORTED_MODULE_12_variables_general_jsx__["b" /* csvHeaders */],filename:this.state.filename,className:"hidden",ref:function ref(r){return _this2.csvLink=r;},target:"_blank"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_views_Components_ReviewsModal_jsx__["a" /* default */],{noticeModal:this.state.noticeModal,handleClose:this.handleModalClose,reviews:this.state.reviews,lead:this.state.lead}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers_Headers_LeadHeader_jsx__["a" /* default */],{exportData:this.exportAsCSV})),this.props.fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"indeterminate",color:"primary",value:30})):null,this.props.leads.map(function(lead,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:12,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardList_jsx__["a" /* default */],{lead:lead,showReview:_this2.showReview,sendEmail:_this2.sendEmail}));})));}}]);return LeadsDashboard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);LeadsDashboard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,leads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,addLeads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_11_assets_jss_material_dashboard_pro_react_views_dashboardStyle__["a" /* default */])(LeadsDashboard));

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1241);


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSVLink = exports.CSVDownload = undefined;

var _Download = __webpack_require__(1242);

var _Download2 = _interopRequireDefault(_Download);

var _Link = __webpack_require__(1243);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSVDownload = exports.CSVDownload = _Download2.default;
var CSVLink = exports.CSVLink = _Link2.default;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(493);

var _metaProps = __webpack_require__(494);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  target: '_blank'
};

var CSVDownload = function (_React$Component) {
  _inherits(CSVDownload, _React$Component);

  function CSVDownload(props) {
    _classCallCheck(this, CSVDownload);

    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(CSVDownload, [{
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          uFEFF = _props.uFEFF,
          target = _props.target,
          specs = _props.specs,
          replace = _props.replace;

      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator), target, specs, replace);
    }
  }, {
    key: 'getWindow',
    value: function getWindow() {
      return this.state.page;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return CSVDownload;
}(_react2.default.Component);

CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
CSVDownload.propTypes = _metaProps.propTypes;
exports.default = CSVDownload;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(493);

var _metaProps = __webpack_require__(494);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSVLink = function (_React$Component) {
  _inherits(CSVLink, _React$Component);

  function CSVLink(props) {
    _classCallCheck(this, CSVLink);

    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));

    _this.buildURI = _this.buildURI.bind(_this);
    _this.state = { href: '' };
    return _this;
  }

  _createClass(CSVLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          uFEFF = _props.uFEFF;

      this.setState({ href: this.buildURI(data, uFEFF, headers, separator) });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = nextProps.data,
          headers = nextProps.headers,
          separator = nextProps.separator,
          uFEFF = nextProps.uFEFF;

      this.setState({ href: this.buildURI(data, uFEFF, headers, separator) });
    }
  }, {
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'handleLegacy',
    value: function handleLegacy(event, data, headers, separator, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        event.preventDefault();

        var blob = new Blob([(0, _core.toCSV)(data, headers, separator)]);
        window.navigator.msSaveBlob(blob, filename);

        return false;
      }
    }
  }, {
    key: 'handleAsyncClick',
    value: function handleAsyncClick(event) {
      var _this2 = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var done = function done(proceed) {
        if (proceed === false) {
          event.preventDefault();
          return;
        }
        _this2.handleLegacy.apply(_this2, [event].concat(args));
      };

      this.props.onClick(event, done);
    }
  }, {
    key: 'handleSyncClick',
    value: function handleSyncClick(event) {
      var stopEvent = this.props.onClick(event) === false;
      if (stopEvent) {
        event.preventDefault();
        return;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this.handleLegacy.apply(this, [event].concat(args));
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _this3 = this;

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return function (event) {
        if (typeof _this3.props.onClick === 'function') {
          return _this3.props.asyncOnClick ? _this3.handleAsyncClick.apply(_this3, [event].concat(args)) : _this3.handleSyncClick.apply(_this3, [event].concat(args));
        }
        _this3.handleLegacy.apply(_this3, [event].concat(args));
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          data = _props2.data,
          headers = _props2.headers,
          separator = _props2.separator,
          filename = _props2.filename,
          uFEFF = _props2.uFEFF,
          children = _props2.children,
          onClick = _props2.onClick,
          asyncOnClick = _props2.asyncOnClick,
          rest = _objectWithoutProperties(_props2, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick']);

      var href = this.state.href;

      return _react2.default.createElement(
        'a',
        _extends({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this4.link = link;
          },
          href: href,
          onClick: this.handleClick(data, headers, separator, filename)
        }),
        children
      );
    }
  }]);

  return CSVLink;
}(_react2.default.Component);

CSVLink.defaultProps = _metaProps.defaultProps;
CSVLink.propTypes = _metaProps.propTypes;
exports.default = CSVLink;

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
var cardListStyle={cardTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"0px",marginBottom:"3px"}),cardSubtitle:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["c" /* cardSubtitle */],cardLink:__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["b" /* cardLink */],cardImage:{width:"100%",padding:"10px",verticalAlign:"middle"},cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{textAlign:"left",marginTop:"15px",marginBottom:"0px"}),cardProductTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"0px",marginBottom:"3px",textAlign:"center"}),cardCategory:{color:"#999999",fontSize:"14px",paddingTop:"10px",marginBottom:"0",marginTop:"0",margin:"0"},cardDetails:{color:"#999999",fontSize:"14px",//paddingTop: "10px",
marginBottom:"0",marginTop:"0",margin:"0",textTransform:"none"},cardProductDesciprion:{textAlign:"center",color:"#999999"}};/* harmony default export */ __webpack_exports__["a"] = (cardListStyle);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Header_LeadHeader_jsx__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_Actions__ = __webpack_require__(49);
var mapStateToProps=function mapStateToProps(state){return{leads:state.tempLeads};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{changeSuggestions:function changeSuggestions(keyword){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_Actions__["c" /* changeSuggestions */])(keyword));},searchLeads:function searchLeads(keyword,place){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_Actions__["j" /* searchLeads */])(keyword,place));},clearLeads:function clearLeads(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_Actions__["d" /* clearLeads */])());},stopSearch:function stopSearch(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_store_Actions__["m" /* stopSearch */])());}};};var container=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0_components_Header_LeadHeader_jsx__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Google_Search_jsx__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Components_CampaignModal_jsx__ = __webpack_require__(1249);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
var style={typo:{paddingLeft:"0%",marginBottom:"10px",color:"#c0c1c2",position:"relative"},note:{fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif',bottom:"10px",color:"#c0c1c2",display:"block",fontWeight:"400",fontSize:"13px",lineHeight:"13px",left:"0",marginLeft:"20px",position:"absolute",width:"260px"}};var LeadHeader=function(_Component){_inherits(LeadHeader,_Component);function LeadHeader(props){_classCallCheck(this,LeadHeader);var _this=_possibleConstructorReturn(this,(LeadHeader.__proto__||Object.getPrototypeOf(LeadHeader)).call(this,props));_this.handlePlaceChange=function(value){_this.setState({place:value});};_this.state={campaignModalOpen:false,alert:null,keyword:"",place:"",keywordState:"",placeState:""};_this.changeSuggestions=_this.changeSuggestions.bind(_this);_this.searchLeads=_this.searchLeads.bind(_this);_this.validateFeids=_this.validateFeids.bind(_this);_this.handlePlaceChange=_this.handlePlaceChange.bind(_this);return _this;}_createClass(LeadHeader,[{key:"campaignAlert",value:function campaignAlert(){this.setState({campaignModalOpen:true});}},{key:"change",value:function change(event,type){var _this2=this;switch(type){case"keyword":this.setState({keyword:event.target.value},function(){return _this2.validateKeyword();});break;case"place":this.setState({place:event.target.value},function(){_this2.validatePlace();});break;default:break;}}},{key:"validateFeids",value:function validateFeids(){if(this.state.keyword.length>0&&this.state.place.length>0){return true;}else{return false;}}},{key:"validateKeyword",value:function validateKeyword(){this.state.keyword.length>0?this.setState({keywordState:"true"}):this.setState({keywordState:"false"});}},{key:"validatePlace",value:function validatePlace(){this.state.place.length>0?this.setState({placeState:"true"}):this.setState({placeState:"false"});}},{key:"changeSuggestions",value:function changeSuggestions(){this.props.changeSuggestions("las");}},{key:"searchLeads",value:function searchLeads(){if(this.validateFeids()){this.props.searchLeads(this.state.keyword,this.state.place);}}},{key:"render",value:function render(){var _this3=this;var _props=this.props,leads=_props.leads,exportData=_props.exportData,classes=_props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_views_Components_CampaignModal_jsx__["a" /* default */],{open:this.state.campaignModalOpen,closeModal:function closeModal(){return _this3.setState({campaignModalOpen:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],{alignItems:"baseline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classes.typo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"Total Leads: ",leads.length))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"keyword",success:this.state.keywordState==="true",error:this.state.keywordState==="false",labelText:"Enter Keyword *",value:this.state.keyword,formControlProps:{fullWidth:true},inputProps:{onChange:function onChange(event){return _this3.change(event,"keyword");}}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Google_Search_jsx__["a" /* default */],{labelText:"Enter Place *",handleChange:this.handlePlaceChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"primary",onClick:this.searchLeads},"Search")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"rose",onClick:this.props.stopSearch},"Stop")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"danger",onClick:this.props.clearLeads},"Clear")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"success",disabled:leads.length===0,onClick:function onClick(){return exportData(_this3.state.keyword,_this3.state.place);}},"Export CSV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{color:"success",disabled:leads.length===0,onClick:this.campaignAlert.bind(this)},"Add To Campaign")))));}}]);return LeadHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LeadHeader.propTypes={changeSuggestions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,clearLeads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,searchLeads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,stopSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,leads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,exportData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles_withStyles___default()(style)(LeadHeader));

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_load_script__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_load_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_load_script__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CustomInput_CustomInput_jsx__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Imports
// Import Search Bar Components
//import SearchBar from "material-ui-search-bar";
//import SearchBar from '@material-ui/AutoComplete';
// Import React Scrit Libraray to load Google object
//const API_KEY = process.env.REACT_APP_api_key;
// const url =
//   "https://maps.googleapis.com/maps/api/js?key=" +
//   API_KEY +
//   "&libraries=places";
var Search=function(_Component){_inherits(Search,_Component);// Define Constructor
function Search(props){_classCallCheck(this,Search);// Declare State
var _this=_possibleConstructorReturn(this,(Search.__proto__||Object.getPrototypeOf(Search)).call(this,props));_this.handleChange=function(e){_this.setState({query:e.target.value,searchText:e.target.value});};_this.state={city:"",query:"",searchText:"",url:""};// Bind Functions
_this.handleScriptLoad=_this.handleScriptLoad.bind(_this);_this.handlePlaceSelect=_this.handlePlaceSelect.bind(_this);return _this;}_createClass(Search,[{key:"handleScriptLoad",value:function handleScriptLoad(){// Declare Options For Autocomplete
// var options = {
//   types: ["(cities)"]
// }; // To disable any eslint 'google not defined' errors
// Initialize Google Autocomplete
/*global google*/this.autocomplete=new google.maps.places.Autocomplete(document.getElementById("autocomplete")//,options
);// Fire Event when a suggested name is selected
this.autocomplete.addListener("place_changed",this.handlePlaceSelect);}},{key:"handlePlaceSelect",value:function handlePlaceSelect(){// Extract City From Address Object
var addressObject=this.autocomplete.getPlace();var address=addressObject.address_components;// Check if address is valid
if(address){this.props.handleChange(addressObject.formatted_address);// Set State
this.setState({city:address[0].long_name,query:addressObject.formatted_address});}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,labelText=_props.labelText,apiKey=_props.apiKey;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_load_script___default.a,{url:"https://maps.googleapis.com/maps/api/js?key="+apiKey+"&libraries=places",onLoad:this.handleScriptLoad}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CustomInput_CustomInput_jsx__["a" /* default */],{id:"autocomplete"//success={this.state.searchText.length > 0}
//error={this.state.searchText.length === 0}
,labelText:labelText,value:this.state.query,formControlProps:{fullWidth:true},inputProps:{placeholder:"",onChange:function onChange(){return _this2.handleChange;}}}));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Search.propTypes={labelText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,apiKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,handleChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{apiKey:state.apiKey};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var container=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Search);/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_React$Component) {
  _inherits(Script, _React$Component);

  // A dictionary mapping script URL to a boolean value indicating if the script
  // has failed to load.


  // A dictionary mapping script URLs to a dictionary mapping
  // component key to component for all components that are waiting
  // for the script to load.
  function Script(props) {
    _classCallCheck(this, Script);

    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));

    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
    return _this;
  }

  // A counter used to generate a unique id for each component that uses
  // ScriptLoaderMixin.


  // A dictionary mapping script URL to a boolean value indicating if the script
  // has already been loaded.


  _createClass(Script, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onError = _props.onError,
          onLoad = _props.onLoad,
          url = _props.url;


      if (this.constructor.loadedScripts[url]) {
        onLoad();
        return;
      }

      if (this.constructor.erroredScripts[url]) {
        onError();
        return;
      }

      // If the script is loading, add the component to the script's observers
      // and return. Otherwise, initialize the script's observers with the component
      // and start loading the script.
      if (this.constructor.scriptObservers[url]) {
        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
        return;
      }

      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);

      this.createScript();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var url = this.props.url;

      var observers = this.constructor.scriptObservers[url];

      // If the component is waiting for the script to load, remove the
      // component from the script's observers before unmounting the component.
      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: 'createScript',
    value: function createScript() {
      var _this2 = this;

      var _props2 = this.props,
          onCreate = _props2.onCreate,
          url = _props2.url,
          attributes = _props2.attributes;

      var script = document.createElement('script');

      onCreate();

      // add 'data-' or non standard attributes to the script tag
      if (attributes) {
        Object.keys(attributes).forEach(function (prop) {
          return script.setAttribute(prop, attributes[prop]);
        });
      }

      script.src = url;

      // default async to true if not set with custom attributes
      if (!script.hasAttribute('async')) {
        script.async = 1;
      }

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = _this2.constructor.scriptObservers[url];
        Object.keys(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };
      script.onload = function () {
        _this2.constructor.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onLoad();
          return true;
        });
      };

      script.onerror = function () {
        _this2.constructor.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onError();
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Script;
}(_react2.default.Component);

Script.propTypes = {
  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onCreate: _propTypes.PropTypes.func,
  onError: _propTypes.PropTypes.func.isRequired,
  onLoad: _propTypes.PropTypes.func.isRequired,
  url: _propTypes.PropTypes.string.isRequired
};
Script.defaultProps = {
  attributes: {},
  onCreate: function onCreate() {},
  onError: function onError() {},
  onLoad: function onLoad() {} };
Script.scriptObservers = {};
Script.loadedScripts = {};
Script.erroredScripts = {};
Script.idCount = 0;
exports.default = Script;
module.exports = exports['default'];

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_Actions_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogActions__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContent__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControl__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuItem__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import DialogContentText from "@material-ui/core/DialogContentText";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
//import Switch from "@material-ui/core/Switch";
var styles=function styles(theme){return{form:{display:"flex",flexDirection:"column",margin:"auto",width:"fit-content"},formControl:{marginTop:theme.spacing.unit*2,minWidth:160},formControlLabel:{marginTop:theme.spacing.unit},container:{display:"flex",flexWrap:"wrap"},buttonAddCampaign:{display:"flex",marginTop:theme.spacing.unit,margin:"auto"}};};var CampaignModal=function(_Component){_inherits(CampaignModal,_Component);function CampaignModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CampaignModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CampaignModal.__proto__||Object.getPrototypeOf(CampaignModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={fullWidth:true,maxWidth:"md",seletedCampaign:""},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.props.closeModal();},_this.handleCampaignChange=function(event){_this.setState({seletedCampaign:event.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CampaignModal,[{key:"render",value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,open=_props.open,closeModal=_props.closeModal,campaigns=_props.campaigns;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default.a,{fullWidth:this.state.fullWidth,maxWidth:this.state.maxWidth,open:open,onClose:function onClose(){return closeModal();},"aria-labelledby":"max-width-dialog-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle___default.a,{id:"max-width-dialog-title"},"Select Campaign"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridContainer_jsx__["a" /* default */],{alignItems:"baseline",justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{className:classes.form,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default.a,{htmlFor:"max-width"},"Select Campaign"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:this.state.seletedCampaign,onChange:this.handleCampaignChange,inputProps:{name:"Select Campaign",id:"max-width"}},campaigns.map(function(campaign,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuItem___default.a,{value:campaign.id,key:key},campaign.name);}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:this.handleClose,color:"danger"},"Close"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomButtons_Button_jsx__["a" /* default */],{onClick:function onClick(){_this2.props.addToCampaign(_this2.state.seletedCampaign);closeModal();},color:"success"},"Add"))));}}]);return CampaignModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CampaignModal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,open:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,closeModal:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,campaigns:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,addToCampaign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{campaigns:state.campaigns};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{addCampaign:function addCampaign(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_store_Actions_js__["a" /* addCampaign */])(name));},addToCampaign:function addToCampaign(campaignId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_store_Actions_js__["b" /* addLeadsToCampaign */])(campaignId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(CampaignModal)));

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(324));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(215));

var _jssPreset = _interopRequireDefault(__webpack_require__(321));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(1251));

var _createStyles = _interopRequireDefault(__webpack_require__(1253));

var _withStyles = _interopRequireDefault(__webpack_require__(3));

var _withTheme = _interopRequireDefault(__webpack_require__(91));

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(47);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(13));

var _createClass2 = _interopRequireDefault(__webpack_require__(10));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(16));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(17));

var _brcast = _interopRequireDefault(__webpack_require__(1252));

var _themeListener = _interopRequireWildcard(__webpack_require__(216));

var _exactProp = _interopRequireDefault(__webpack_require__(123));

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProvider, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProvider(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProvider).call(this)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _this$props = this.props,
          sheetsManager = _this$props.sheetsManager,
          disableStylesGeneration = _this$props.disableStylesGeneration;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : {};
MuiThemeProvider.propTypes =  false ? (0, _exactProp.default)(MuiThemeProvider.propTypes) : {};
MuiThemeProvider.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProvider.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
var _default = MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Editor__ = __webpack_require__(1255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Editor__["a"]; });
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */




/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Editor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TinyMCE__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditorPropTypes__ = __webpack_require__(499);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};





var scriptState = __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__["a" /* create */]();
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.initialise = function () {
            var finalInit = __assign({}, _this.props.init, { target: _this.element, readonly: _this.props.disabled, inline: _this.inline, plugins: Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["d" /* mergePlugins */])(_this.props.init && _this.props.init.plugins, _this.props.plugins), toolbar: _this.props.toolbar || (_this.props.init && _this.props.init.toolbar), setup: function (editor) {
                    _this.editor = editor;
                    editor.on('init', function (e) {
                        _this.initEditor(e, editor);
                    });
                    if (_this.props.init && typeof _this.props.init.setup === 'function') {
                        _this.props.init.setup(editor);
                    }
                } });
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["c" /* isTextarea */])(_this.element)) {
                _this.element.style.visibility = '';
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])().init(finalInit);
        };
        return _this;
    }
    Editor.prototype.componentWillMount = function () {
        this.id = this.id || this.props.id || Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["e" /* uuid */])('tiny-react');
        this.inline = this.props.inline ? this.props.inline : this.props.init && this.props.init.inline;
    };
    Editor.prototype.componentDidMount = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])() !== null) {
            this.initialise();
        }
        else if (this.element && this.element.ownerDocument) {
            var doc = this.element.ownerDocument;
            var channel = this.props.cloudChannel ? this.props.cloudChannel : 'stable';
            var apiKey = this.props.apiKey ? this.props.apiKey : '';
            __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__["b" /* load */](scriptState, doc, "https://cloud.tinymce.com/" + channel + "/tinymce.min.js?apiKey=" + apiKey, this.initialise);
        }
    };
    Editor.prototype.componentWillUnmount = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])() !== null) {
            Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])().remove(this.editor);
        }
    };
    Editor.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.editor && this.editor.initialized) {
            this.currentContent = this.currentContent || this.editor.getContent();
            if (typeof nextProps.value === 'string' && nextProps.value !== this.props.value && nextProps.value !== this.currentContent) {
                this.editor.setContent(nextProps.value);
            }
            if (typeof nextProps.disabled === 'boolean' && nextProps.disabled !== this.props.disabled) {
                this.editor.setMode(nextProps.disabled ? 'readonly' : 'design');
            }
        }
    };
    Editor.prototype.render = function () {
        return this.inline ? this.renderInline() : this.renderIframe();
    };
    Editor.prototype.initEditor = function (initEvent, editor) {
        var _this = this;
        var value = typeof this.props.value === 'string' ? this.props.value : typeof this.props.initialValue === 'string' ? this.props.initialValue : '';
        editor.setContent(value);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["b" /* isFunction */])(this.props.onEditorChange)) {
            editor.on('change keyup setcontent', function (e) {
                _this.currentContent = editor.getContent();
                if (Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["b" /* isFunction */])(_this.props.onEditorChange)) {
                    _this.props.onEditorChange(_this.currentContent);
                }
            });
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* bindHandlers */])(this.props, editor, initEvent);
    };
    Editor.prototype.renderInline = function () {
        var _this = this;
        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](tagName, {
            ref: function (elm) { return (_this.element = elm); },
            id: this.id
        });
    };
    Editor.prototype.renderIframe = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { ref: function (elm) { return (_this.element = elm); }, style: { visibility: 'hidden' }, id: this.id, name: this.props.textareaName });
    };
    Editor.propTypes = __WEBPACK_IMPORTED_MODULE_4__EditorPropTypes__["a" /* EditorPropTypes */];
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return load; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(498);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var injectScriptTag = function (scriptId, doc, url, callback) {
    var scriptTag = doc.createElement('script');
    scriptTag.type = 'application/javascript';
    scriptTag.id = scriptId;
    scriptTag.addEventListener('load', callback);
    scriptTag.src = url;
    if (doc.head) {
        doc.head.appendChild(scriptTag);
    }
};
var create = function () {
    return {
        listeners: [],
        scriptId: Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* uuid */])('tiny-script'),
        scriptLoaded: false
    };
};
var load = function (state, doc, url, callback) {
    if (state.scriptLoaded) {
        callback();
    }
    else {
        state.listeners.push(callback);
        if (!doc.getElementById(state.scriptId)) {
            injectScriptTag(state.scriptId, doc, url, function () {
                state.listeners.forEach(function (fn) { return fn(); });
                state.scriptLoaded = true;
            });
        }
    }
};


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTinymce; });
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
var getTinymce = function () {
    var global = getGlobal();
    return global && global.tinymce ? global.tinymce : null;
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41)))

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card_CardList_jsx__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CustomLinearProgress_CustomLinearProgress_jsx__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Components_ReviewsModal_jsx__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Components_EmailModal_jsx__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_views_dashboardStyle__ = __webpack_require__(250);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @material-ui/core components
// core components
//import LeadHeader from "containers/Headers/LeadHeader.jsx";
var CampaignLeads=function(_React$Component){_inherits(CampaignLeads,_React$Component);function CampaignLeads(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CampaignLeads);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CampaignLeads.__proto__||Object.getPrototypeOf(CampaignLeads)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:0,noticeModal:false,reviews:[],lead:{},emailModal:false},_this.handleChange=function(event,value){_this.setState({value:value});},_this.handleChangeIndex=function(index){_this.setState({value:index});},_this.showReview=function(lead,reviews){_this.setState({reviews:reviews,lead:lead},function(){_this.openModal();});},_this.sendEmail=function(lead){_this.setState({lead:lead},function(){_this.setState({emailModal:true});});},_this.handleModalClose=function(){_this.setState({noticeModal:false,reviews:[],lead:{}});},_this.handleEmailModalClose=function(){_this.setState({emailModal:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CampaignLeads,[{key:"openModal",value:function openModal(){this.setState({noticeModal:true});}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.emailModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_views_Components_EmailModal_jsx__["a" /* default */],{emailModal:this.state.emailModal,handleClose:this.handleEmailModalClose,lead:this.state.lead}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_views_Components_ReviewsModal_jsx__["a" /* default */],{noticeModal:this.state.noticeModal,handleClose:this.handleModalClose,reviews:this.state.reviews,lead:this.state.lead}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_GridContainer_jsx__["a" /* default */],null,this.props.fetching?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CustomLinearProgress_CustomLinearProgress_jsx__["a" /* default */],{variant:"indeterminate",color:"primary",value:30})):null,this.props.leads.map(function(lead,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Grid_GridItem_jsx__["a" /* default */],{xs:12,sm:12,md:12,lg:12,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card_CardList_jsx__["a" /* default */],{lead:lead,showReview:_this2.showReview,sendEmail:_this2.sendEmail}));})));}}]);return CampaignLeads;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CampaignLeads.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,fetching:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,leads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,addLeads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state,props){var id=props.match.params.id;var campaignLeads=state.leads.filter(function(lead){return lead.campaignId===id;});return{leads:campaignLeads,campaigns:state.campaigns};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{addCampaign:function addCampaign(name){//dispatch(addCampaign(name));
},removeCampaign:function removeCampaign(id){//dispatch(removeCampaign(id));
}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_10_assets_jss_material_dashboard_pro_react_views_dashboardStyle__["a" /* default */])(CampaignLeads)));

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_table__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Add__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Dvr__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Dvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Dvr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Close__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_store_Actions_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_jss_material_dashboard_pro_react_views_buttonsStyle_jsx__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// react component for creating dynamic tables
// @material-ui/core components
// @material-ui/icons
//import Assignment from "@material-ui/icons/Assignment";
//import Favorite from "@material-ui/icons/Favorite";
// core components
//import CardIcon from "components/Card/CardIcon.jsx";
//import { dataTable } from "variables/general.jsx";
var styles=Object.assign({cardIconTitle:Object.assign({},__WEBPACK_IMPORTED_MODULE_16_assets_jss_material_dashboard_pro_react_jsx__["d" /* cardTitle */],{marginTop:"15px",marginBottom:"0px"}),cardIconButton:{float:"right"}},__WEBPACK_IMPORTED_MODULE_17_assets_jss_material_dashboard_pro_react_views_buttonsStyle_jsx__["a" /* default */],__WEBPACK_IMPORTED_MODULE_18_assets_jss_material_dashboard_pro_react_views_sweetAlertStyle_jsx__["a" /* default */]);var Campaigns=function(_React$Component){_inherits(Campaigns,_React$Component);function Campaigns(props){_classCallCheck(this,Campaigns);var _this=_possibleConstructorReturn(this,(Campaigns.__proto__||Object.getPrototypeOf(Campaigns)).call(this,props));_this.state={alert:null,show:false};_this.warningWithConfirmMessage=_this.warningWithConfirmMessage.bind(_this);_this.hideAlert=_this.hideAlert.bind(_this);_this.successDelete=_this.successDelete.bind(_this);_this.deleteCampaign=_this.deleteCampaign.bind(_this);//this.cancelDetele = this.cancelDetele.bind(this);
_this.inputConfirmAlert=_this.inputConfirmAlert.bind(_this);_this.inputConfirmAlertNext=_this.inputConfirmAlertNext.bind(_this);return _this;}_createClass(Campaigns,[{key:"getData",value:function getData(){var _this2=this;return this.props.campaigns.map(function(prop){var campaignLeads=_this2.props.leads.filter(function(lead){return lead.campaignId===prop.id;});return{id:prop.id,name:prop.name,leads:campaignLeads.length,created:prop.created,actions:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"actions-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,simple:true,onClick:function onClick(){_this2.props.history.push("/campaigns/"+prop.id);},color:"warning",className:"edit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Dvr___default.a,null))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__["a" /* default */],{justIcon:true,round:true,simple:true,onClick:function onClick(){//this.props.removeCampaign(prop.id);
_this2.warningWithConfirmMessage(prop.id,prop.name);}//onClick={this.warningWithConfirmMessage.bind(this)}
,color:"danger",className:"remove"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Close___default.a,null))," ")};});}},{key:"inputAlert",value:function inputAlert(){var _this3=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{input:true,showCancel:true,validationMsg:"Enter Campaign Name",style:{display:"block",marginTop:"-100px"},title:"Enter Name of Campaign",onConfirm:function onConfirm(e){return _this3.inputConfirmAlert(e);},onCancel:function onCancel(){return _this3.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.info,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger})});}},{key:"inputConfirmAlert",value:function inputConfirmAlert(e){this.setState({alert:e});setTimeout(this.inputConfirmAlertNext,200);}},{key:"inputConfirmAlertNext",value:function inputConfirmAlertNext(){var inputValue=this.state.alert;this.props.addCampaign(inputValue);}},{key:"warningWithConfirmMessage",value:function warningWithConfirmMessage(campaignId,name){var _this4=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{warning:true,style:{display:"block",marginTop:"-100px"},title:"Delete Campaign ?",onConfirm:function onConfirm(){return _this4.deleteCampaign(campaignId);},onCancel:function onCancel(){return _this4.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success,cancelBtnCssClass:this.props.classes.button+" "+this.props.classes.danger,confirmBtnText:"Yes, delete it!",cancelBtnText:"Cancel",showCancel:true},name," will be deleted!")});}},{key:"deleteCampaign",value:function deleteCampaign(campaignID){this.props.removeCampaign(campaignID);this.successDelete();}},{key:"successDelete",value:function successDelete(){var _this5=this;this.setState({alert:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap_sweetalert___default.a,{success:true,style:{display:"block",marginTop:"-100px"},title:"Deleted!",onConfirm:function onConfirm(){return _this5.hideAlert();},onCancel:function onCancel(){return _this5.hideAlert();},confirmBtnCssClass:this.props.classes.button+" "+this.props.classes.success},"Campaign has been delted!")});}},{key:"hideAlert",value:function hideAlert(){this.setState({alert:null});}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Grid_GridContainer_jsx__["a" /* default */],null,this.state.alert,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Grid_GridItem_jsx__["a" /* default */],{xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Card_Card_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Card_CardHeader_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CustomButtons_Button_jsx__["a" /* default */],{className:classes.cardIconButton,color:"success",onClick:this.inputAlert.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Add___default.a,null)," Create Campaign")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Card_CardBody_jsx__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_table__["a" /* default */],{data:this.getData()//filterable
,columns:[{Header:"Name",accessor:"name"},{Header:"ID",accessor:"id"},{Header:"Leads",accessor:"leads"},{Header:"Created",accessor:"created"},{Header:"Actions",accessor:"actions",sortable:false,filterable:false}],defaultPageSize:10//showPaginationTop
//showPaginationBottom={false}
,className:"-striped -highlight"})))));}}]);return Campaigns;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Campaigns.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,campaigns:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,leads:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,removeCampaign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,addCampaign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{leads:state.leads,campaigns:state.campaigns};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{addCampaign:function addCampaign(name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_store_Actions_js__["a" /* addCampaign */])(name));},removeCampaign:function removeCampaign(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_store_Actions_js__["h" /* removeCampaign */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(styles)(Campaigns)));

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Search');

exports.default = _default;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(7));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  transform: "scale(1.2, 1.2)",
  fill: "none",
  d: "M0 0h20v20H0V0z"
}), _react.default.createElement("path", {
  transform: "scale(1.2, 1.2)",
  d: "M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
})), 'Settings');

exports.default = _default;

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__ = __webpack_require__(8);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ##############################
// // // App styles
// #############################
var appStyle=function appStyle(theme){var _Object$assign;return{wrapper:{position:"relative",top:"0",height:"100vh","&:after":{display:"table",clear:"both",content:'" "'}},mainPanel:Object.assign((_Object$assign={transitionProperty:"top, bottom, width",transitionDuration:".2s, .2s, .35s",transitionTimingFunction:"linear, linear, ease"},_defineProperty(_Object$assign,theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["m" /* drawerWidth */]+"px)"}),_defineProperty(_Object$assign,"overflow","auto"),_defineProperty(_Object$assign,"position","relative"),_defineProperty(_Object$assign,"float","right"),_Object$assign),__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["B" /* transition */],{maxHeight:"100%",width:"100%",overflowScrolling:"touch"}),content:{marginTop:"70px",padding:"30px 15px",minHeight:"calc(100vh - 123px)"},container:Object.assign({},__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["f" /* containerFluid */]),map:{marginTop:"70px"},mainPanelSidebarMini:_defineProperty({},theme.breakpoints.up("md"),{width:"calc(100% - "+__WEBPACK_IMPORTED_MODULE_0_assets_jss_material_dashboard_pro_react_jsx__["l" /* drawerMiniWidth */]+"px)"}),mainPanelWithPerfectScrollbar:{overflow:"hidden !important"}};};/* harmony default export */ __webpack_exports__["a"] = (appStyle);

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export user */
/* unused harmony export apiKey */
/* unused harmony export smtp */
/* unused harmony export tempLeads */
/* unused harmony export leads */
/* unused harmony export campaigns */
/* unused harmony export goal */
/* unused harmony export errors */
/* unused harmony export fetching */
/* unused harmony export suggestions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(243);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var user=function user(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].LOGIN_USER:return action.payload;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].LOGOUT_USER:return null;default:return state;}};var apiKey=function apiKey(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_API_KEY:return action.payload;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_API_KEY:return"";default:return state;}};var smtp=function smtp(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_SMTP:return action.payload;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_SMTP:return null;default:return state;}};var tempLeads=function tempLeads(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_TEMP_LEAD:return[].concat(_toConsumableArray(state),[action.payload]);case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_TEMP_LEAD:return state.filter(function(lead,index){return index!==action.payload;});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_TEMP_LEADS:return[];default:return state;}};var leads=function leads(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_LEAD:return[].concat(_toConsumableArray(state),[action.payload]);case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_LEADS:return action.payload;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_LEAD:return state.filter(function(lead){return lead.id!==action.payload;});case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_LEADS:return[];default:return state;}};var campaigns=function campaigns(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_CAMPAIGN:return[].concat(_toConsumableArray(state),[action.payload]);case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_CAMPAIGN:return action.payload;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].REMOVE_CAMPAIGN:return state.filter(function(campaign){return campaign.id!==action.payload;});default:return state;}};var goal=function goal(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var action=arguments[1];return action.type===__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].SET_GOAL?parseInt(action.payload,10):state;};var errors=function errors(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].ADD_ERROR:return[].concat(_toConsumableArray(state),[action.payload]);case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_ERROR:return state.filter(function(message,index){return index!==action.payload;});default:return state;}};var fetching=function fetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].FETCH_LEADS:return true;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CANCEL_FETCHING:return false;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CHANGE_SUGGESTIONS:return false;default:return state;}};var suggestions=function suggestions(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CANCEL_FETCHING:return[];case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CHANGE_SUGGESTIONS:return action.payload;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].CLEAR_SUGGESTIONS:return[];default:return state;}};var appReducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({smtp:smtp,apiKey:apiKey,user:user,tempLeads:tempLeads,leads:leads,campaigns:campaigns,errors:errors,goal:goal,fetching:fetching,resortNames:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({fetching:fetching,suggestions:suggestions})});var rootReducer=function rootReducer(state,action){if(action.type===__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */].USER_LOGOUT){state=undefined;}return appReducer(state,action);};/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(1267);
var config={apiKey:"AIzaSyD7KUktZ06vZ70FnVGbnwOPEUqZuebwYlA",authDomain:"busineistdirect.firebaseapp.com",databaseURL:"https://busineistdirect.firebaseio.com",projectId:"busineistdirect",storageBucket:"busineistdirect.appspot.com",messagingSenderId:"246018845513"};__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(config);// const firestore = firebase.firestore();
// const settings = { timestampsInSnapshots: true };
// firestore.settings(settings);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firestore__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_firestore__);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(238));
var logger = __webpack_require__(1269);
var tslib_1 = __webpack_require__(358);
var webchannelWrapper = __webpack_require__(1270);
var util = __webpack_require__(357);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = firebase.SDK_VERSION;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/firestore');
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
})(LogLevel || (LogLevel = {}));
// Helper methods are needed because variables can't be exported as read/write
function getLogLevel() {
    if (logClient.logLevel === logger.LogLevel.DEBUG) {
        return LogLevel.DEBUG;
    }
    else if (logClient.logLevel === logger.LogLevel.SILENT) {
        return LogLevel.SILENT;
    }
    else {
        return LogLevel.ERROR;
    }
}
function setLogLevel(newLevel) {
    /**
     * Map the new log level to the associated Firebase Log Level
     */
    switch (newLevel) {
        case LogLevel.DEBUG:
            logClient.logLevel = logger.LogLevel.DEBUG;
            break;
        case LogLevel.ERROR:
            logClient.logLevel = logger.LogLevel.ERROR;
            break;
        case LogLevel.SILENT:
            logClient.logLevel = logger.LogLevel.SILENT;
            break;
        default:
            logClient.error("Firestore (" + SDK_VERSION + "): Invalid value passed to `setLogLevel`");
    }
}
function debug(tag, msg) {
    var obj = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        obj[_i - 2] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.DEBUG) {
        var args = obj.map(argToString);
        logClient.debug.apply(logClient, ["Firestore (" + SDK_VERSION + ") [" + tag + "]: " + msg].concat(args));
    }
}
function error(msg) {
    var obj = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        obj[_i - 1] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.ERROR) {
        var args = obj.map(argToString);
        logClient.error.apply(logClient, ["Firestore (" + SDK_VERSION + "): " + msg].concat(args));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */
function argToString(obj) {
    if (typeof obj === 'string') {
        return obj;
    }
    else {
        var platform = PlatformSupport.getPlatform();
        try {
            return platform.formatJSON(obj);
        }
        catch (e) {
            // Converting to JSON failed, just log the object directly
            return obj;
        }
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unconditionally fails, throwing an Error with the given message.
 *
 * Returns any so it can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */
function fail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
    error(message);
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 */
function assert(assertion, message) {
    if (!assertion) {
        fail(message);
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */
var PlatformSupport = /** @class */ (function () {
    function PlatformSupport() {
    }
    PlatformSupport.setPlatform = function (platform) {
        if (PlatformSupport.platform) {
            fail('Platform already defined');
        }
        PlatformSupport.platform = platform;
    };
    PlatformSupport.getPlatform = function () {
        if (!PlatformSupport.platform) {
            fail('Platform not set');
        }
        return PlatformSupport.platform;
    };
    return PlatformSupport;
}());
/**
 * Returns the representation of an empty "proto" byte string for the
 * platform.
 */
function emptyByteString() {
    return PlatformSupport.getPlatform().emptyByteString;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
var Code = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */
    OK: 'ok',
    /** The operation was cancelled (typically by the caller). */
    CANCELLED: 'cancelled',
    /** Unknown error or an error from a different error domain. */
    UNKNOWN: 'unknown',
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */
    INVALID_ARGUMENT: 'invalid-argument',
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    /** Some requested entity (e.g., file or directory) was not found. */
    NOT_FOUND: 'not-found',
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */
    ALREADY_EXISTS: 'already-exists',
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */
    PERMISSION_DENIED: 'permission-denied',
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */
    UNAUTHENTICATED: 'unauthenticated',
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */
    FAILED_PRECONDITION: 'failed-precondition',
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    ABORTED: 'aborted',
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */
    OUT_OF_RANGE: 'out-of-range',
    /** Operation is not implemented or not supported/enabled in this service. */
    UNIMPLEMENTED: 'unimplemented',
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */
    INTERNAL: 'internal',
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    UNAVAILABLE: 'unavailable',
    /** Unrecoverable data loss or corruption. */
    DATA_LOSS: 'data-loss'
};
/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */
var FirestoreError = /** @class */ (function (_super) {
    tslib_1.__extends(FirestoreError, _super);
    function FirestoreError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        _this.name = 'FirebaseError';
        // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
        return _this;
    }
    return FirestoreError;
}(Error));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */
function makeConstructorPrivate(cls, optionalMessage) {
    function PublicConstructor() {
        var error = 'This constructor is private.';
        if (optionalMessage) {
            error += ' ';
            error += optionalMessage;
        }
        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
    }
    // Make sure instanceof checks work and all methods are exposed on the public
    // constructor
    PublicConstructor.prototype = cls.prototype;
    // Copy any static methods/members
    for (var staticProperty in cls) {
        if (cls.hasOwnProperty(staticProperty)) {
            PublicConstructor[staticProperty] = cls[staticProperty];
        }
    }
    return PublicConstructor;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/** Returns the given value if it's defined or the defaultValue otherwise. */
function defaulted(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
function forEachNumber(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var num = Number(key);
            if (!isNaN(num)) {
                fn(num, obj[key]);
            }
        }
    }
}
function values(obj) {
    var vs = [];
    forEach(obj, function (_, v) { return vs.push(v); });
    return vs;
}
function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
}
function isEmpty(obj) {
    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function shallowCopy(obj) {
    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
    var result = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    }
    return result;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */
function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
    if (args.length !== numberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
            formatPlural(numberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */
function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
    if (args.length < minNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
            formatPlural(minNumberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */
function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
            (maxNumberOfArgs + " arguments, but was called with ") +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */
function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
    if (!(value instanceof Array) || value.length < minNumberOfElements) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
            'array with at least ' +
            (formatPlural(minNumberOfElements, 'element') + "."));
    }
}
/**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */
function validateArgType(functionName, type, position, argument) {
    validateType(functionName, type, ordinal(position) + " argument", argument);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateOptionalArgType(functionName, type, position, argument) {
    if (argument !== undefined) {
        validateArgType(functionName, type, position, argument);
    }
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */
function validateNamedType(functionName, type, optionName, argument) {
    validateType(functionName, type, optionName + " option", argument);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateNamedOptionalType(functionName, type, optionName, argument) {
    if (argument !== undefined) {
        validateNamedType(functionName, type, optionName, argument);
    }
}
function validateArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (!(argument instanceof Array)) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + optionName + " " +
            ("option to be an array, but it was: " + valueDescription(argument)));
    }
    for (var i = 0; i < argument.length; ++i) {
        if (!validator(argument[i])) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires all " + optionName + " " +
                ("elements to be " + typeDescription + ", but the value at index " + i + " ") +
                ("was: " + valueDescription(argument[i])));
        }
    }
}
function validateOptionalArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (argument !== undefined) {
        validateArrayElements(functionName, optionName, typeDescription, argument, validator);
    }
}
/**
 * Validates that the provided named option equals one of the expected values.
 */
function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
    var expectedDescription = [];
    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
        var val = expected_1[_i];
        if (val === input) {
            return;
        }
        expectedDescription.push(valueDescription(val));
    }
    var actualDescription = valueDescription(input);
    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option " +
        ("\"" + optionName + "\". Acceptable values: " + expectedDescription.join(', ')));
}
/**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */
function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
    if (input !== undefined) {
        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
    }
}
/** Helper to validate the type of a provided input. */
function validateType(functionName, type, inputName, input) {
    var valid = false;
    if (type === 'object') {
        valid = isPlainObject(input);
    }
    else if (type === 'non-empty string') {
        valid = typeof input === 'string' && input !== '';
    }
    else {
        valid = typeof input === type;
    }
    if (!valid) {
        var description = valueDescription(input);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
            ("to be of type " + type + ", but it was: " + description));
    }
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */
function isPlainObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        (Object.getPrototypeOf(input) === Object.prototype ||
            Object.getPrototypeOf(input) === null));
}
/** Returns a string describing the type / value of the provided input. */
function valueDescription(input) {
    if (input === undefined) {
        return 'undefined';
    }
    else if (input === null) {
        return 'null';
    }
    else if (typeof input === 'string') {
        if (input.length > 20) {
            input = input.substring(0, 20) + "...";
        }
        return JSON.stringify(input);
    }
    else if (typeof input === 'number' || typeof input === 'boolean') {
        return '' + input;
    }
    else if (typeof input === 'object') {
        if (input instanceof Array) {
            return 'an array';
        }
        else {
            var customObjectName = tryGetCustomObjectType(input);
            if (customObjectName) {
                return "a custom " + customObjectName + " object";
            }
            else {
                return 'an object';
            }
        }
    }
    else if (typeof input === 'function') {
        return 'a function';
    }
    else {
        return fail('Unknown wrong type: ' + typeof input);
    }
}
/** Hacky method to try to get the constructor name for an object. */
function tryGetCustomObjectType(input) {
    if (input.constructor) {
        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
        var results = funcNameRegex.exec(input.constructor.toString());
        if (results && results.length > 1) {
            return results[1];
        }
    }
    return null;
}
/** Validates the provided argument is defined. */
function validateDefined(functionName, position, argument) {
    if (argument === undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
            "argument, but it was undefined.");
    }
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */
function validateOptionNames(functionName, options, optionNames) {
    forEach(options, function (key, _) {
        if (optionNames.indexOf(key) < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
                'Available options: ' +
                optionNames.join(', '));
        }
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */
function invalidClassError(functionName, type, position, argument) {
    var description = valueDescription(argument);
    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
        ("argument to be a " + type + ", but it was: " + description));
}
/** Converts a number to its english word representation */
function ordinal(num) {
    switch (num) {
        case 1:
            return 'first';
        case 2:
            return 'second';
        case 3:
            return 'third';
        default:
            return num + 'th';
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */
function formatPlural(num, str) {
    return num + " " + str + (num === 1 ? '' : 's');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// tslint:disable-next-line:class-as-namespace
var AutoId = /** @class */ (function () {
    function AutoId() {
    }
    AutoId.newId = function () {
        // Alphanumeric characters
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var autoId = '';
        for (var i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
        return autoId;
    };
    return AutoId;
}());
function primitiveComparator(left, right) {
    if (left < right)
        return -1;
    if (left > right)
        return 1;
    return 0;
}
/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
function equals(left, right) {
    if (left !== null && left !== undefined) {
        return !!(right && left.isEqual(right));
    }
    else {
        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
        // smart enough.
        return left === right;
    }
}
/** Helper to compare arrays using isEqual(). */
function arrayEquals(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (!left[i].isEqual(right[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */
function immediateSuccessor(s) {
    // Return the input string, with an additional NUL byte appended.
    return s + '\0';
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Helper function to assert Uint8Array is available at runtime. */
function assertUint8ArrayAvailable() {
    if (typeof Uint8Array === 'undefined') {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
    }
}
/** Helper function to assert Base64 functions are available at runtime. */
function assertBase64Available() {
    if (!PlatformSupport.getPlatform().base64Available) {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
    }
}
/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */
var Blob = /** @class */ (function () {
    function Blob(binaryString) {
        assertBase64Available();
        this._binaryString = binaryString;
    }
    Blob.fromBase64String = function (base64) {
        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
        validateArgType('Blob.fromBase64String', 'string', 1, base64);
        assertBase64Available();
        try {
            var binaryString = PlatformSupport.getPlatform().atob(base64);
            return new Blob(binaryString);
        }
        catch (e) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
        }
    };
    Blob.fromUint8Array = function (array) {
        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
        assertUint8ArrayAvailable();
        if (!(array instanceof Uint8Array)) {
            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
        }
        // We can't call array.map directly because it expects the return type to
        // be a Uint8Array, whereas we can convert it to a regular array by invoking
        // map on the Array prototype.
        var binaryString = Array.prototype.map
            .call(array, function (char) {
            return String.fromCharCode(char);
        })
            .join('');
        return new Blob(binaryString);
    };
    Blob.prototype.toBase64 = function () {
        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
        assertBase64Available();
        return PlatformSupport.getPlatform().btoa(this._binaryString);
    };
    Blob.prototype.toUint8Array = function () {
        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
        assertUint8ArrayAvailable();
        var buffer = new Uint8Array(this._binaryString.length);
        for (var i = 0; i < this._binaryString.length; i++) {
            buffer[i] = this._binaryString.charCodeAt(i);
        }
        return buffer;
    };
    Blob.prototype.toString = function () {
        return 'Blob(base64: ' + this.toBase64() + ')';
    };
    Blob.prototype.isEqual = function (other) {
        return this._binaryString === other._binaryString;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    Blob.prototype._compareTo = function (other) {
        return primitiveComparator(this._binaryString, other._binaryString);
    };
    return Blob;
}());
// Public instance that disallows construction at runtime. This constructor is
// used when exporting Blob on firebase.firestore.Blob and will be called Blob
// publicly. Internally we still use Blob which has a type checked private
// constructor. Note that Blob and PublicBlob can be used interchangeably in
// instanceof checks.
// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
// we need to use Blob as type and export it too.
// tslint:disable-next-line:variable-name We're treating this as a class name.
var PublicBlob = makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Immutable class representing a geo point as latitude-longitude pair.
 * This class is directly exposed in the public API, including its constructor.
 */
var GeoPoint = /** @class */ (function () {
    function GeoPoint(latitude, longitude) {
        validateExactNumberOfArgs('GeoPoint', arguments, 2);
        validateArgType('GeoPoint', 'number', 1, latitude);
        validateArgType('GeoPoint', 'number', 2, longitude);
        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
        }
        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
        }
        this._lat = latitude;
        this._long = longitude;
    }
    Object.defineProperty(GeoPoint.prototype, "latitude", {
        /**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */
        get: function () {
            return this._lat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeoPoint.prototype, "longitude", {
        /**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */
        get: function () {
            return this._long;
        },
        enumerable: true,
        configurable: true
    });
    GeoPoint.prototype.isEqual = function (other) {
        return this._lat === other._lat && this._long === other._long;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    GeoPoint.prototype._compareTo = function (other) {
        return (primitiveComparator(this._lat, other._lat) ||
            primitiveComparator(this._long, other._long));
    };
    return GeoPoint;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Timestamp = /** @class */ (function () {
    function Timestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
        if (nanoseconds < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        if (nanoseconds >= 1e9) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
        if (seconds < -62135596800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
        // This will break in the year 10,000.
        if (seconds >= 253402300800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
    }
    Timestamp.now = function () {
        return Timestamp.fromMillis(Date.now());
    };
    Timestamp.fromDate = function (date) {
        return Timestamp.fromMillis(date.getTime());
    };
    Timestamp.fromMillis = function (milliseconds) {
        var seconds = Math.floor(milliseconds / 1000);
        var nanos = (milliseconds - seconds * 1000) * 1e6;
        return new Timestamp(seconds, nanos);
    };
    Timestamp.prototype.toDate = function () {
        return new Date(this.toMillis());
    };
    Timestamp.prototype.toMillis = function () {
        return this.seconds * 1000 + this.nanoseconds / 1e6;
    };
    Timestamp.prototype._compareTo = function (other) {
        if (this.seconds === other.seconds) {
            return primitiveComparator(this.nanoseconds, other.nanoseconds);
        }
        return primitiveComparator(this.seconds, other.seconds);
    };
    Timestamp.prototype.isEqual = function (other) {
        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
    };
    Timestamp.prototype.toString = function () {
        return ('Timestamp(seconds=' +
            this.seconds +
            ', nanoseconds=' +
            this.nanoseconds +
            ')');
    };
    return Timestamp;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DatabaseInfo = /** @class */ (function () {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     */
    function DatabaseInfo(databaseId, persistenceKey, host, ssl) {
        this.databaseId = databaseId;
        this.persistenceKey = persistenceKey;
        this.host = host;
        this.ssl = ssl;
    }
    return DatabaseInfo;
}());
/** The default database name for a project. */
var DEFAULT_DATABASE_NAME = '(default)';
/** Represents the database ID a Firestore client is associated with. */
var DatabaseId = /** @class */ (function () {
    function DatabaseId(projectId, database) {
        this.projectId = projectId;
        this.database = database ? database : DEFAULT_DATABASE_NAME;
    }
    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
        get: function () {
            return this.database === DEFAULT_DATABASE_NAME;
        },
        enumerable: true,
        configurable: true
    });
    DatabaseId.prototype.isEqual = function (other) {
        return (other instanceof DatabaseId &&
            other.projectId === this.projectId &&
            other.database === this.database);
    };
    DatabaseId.prototype.compareTo = function (other) {
        return (primitiveComparator(this.projectId, other.projectId) ||
            primitiveComparator(this.database, other.database));
    };
    return DatabaseId;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DOCUMENT_KEY_NAME = '__name__';
/**
 * Path represents an ordered sequence of string segments.
 */
var Path = /** @class */ (function () {
    function Path(segments, offset, length) {
        this.init(segments, offset, length);
    }
    /**
     * An initialization method that can be called from outside the constructor.
     * We need this so that we can have a non-static construct method that returns
     * the polymorphic `this` type.
     */
    Path.prototype.init = function (segments, offset, length) {
        if (offset === undefined) {
            offset = 0;
        }
        else if (offset > segments.length) {
            fail('offset ' + offset + ' out of range ' + segments.length);
        }
        if (length === undefined) {
            length = segments.length - offset;
        }
        else if (length > segments.length - offset) {
            fail('length ' + length + ' out of range ' + (segments.length - offset));
        }
        this.segments = segments;
        this.offset = offset;
        this.len = length;
    };
    /**
     * Constructs a new instance of Path using the same concrete type as `this`.
     * We need this instead of using the normal constructor, because polymorphic
     * `this` doesn't work on static methods.
     */
    Path.prototype.construct = function (segments, offset, length) {
        var path = Object.create(Object.getPrototypeOf(this));
        path.init(segments, offset, length);
        return path;
    };
    Object.defineProperty(Path.prototype, "length", {
        get: function () {
            return this.len;
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.isEqual = function (other) {
        return Path.comparator(this, other) === 0;
    };
    Path.prototype.child = function (nameOrPath) {
        var segments = this.segments.slice(this.offset, this.limit());
        if (nameOrPath instanceof Path) {
            nameOrPath.forEach(function (segment) {
                segments.push(segment);
            });
        }
        else if (typeof nameOrPath === 'string') {
            segments.push(nameOrPath);
        }
        else {
            fail('Unknown parameter type for Path.child(): ' + nameOrPath);
        }
        return this.construct(segments);
    };
    /** The index of one past the last segment of the path. */
    Path.prototype.limit = function () {
        return this.offset + this.length;
    };
    Path.prototype.popFirst = function (size) {
        size = size === undefined ? 1 : size;
        assert(this.length >= size, "Can't call popFirst() with less segments");
        return this.construct(this.segments, this.offset + size, this.length - size);
    };
    Path.prototype.popLast = function () {
        assert(!this.isEmpty(), "Can't call popLast() on empty path");
        return this.construct(this.segments, this.offset, this.length - 1);
    };
    Path.prototype.firstSegment = function () {
        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
        return this.segments[this.offset];
    };
    Path.prototype.lastSegment = function () {
        assert(!this.isEmpty(), "Can't call lastSegment() on empty path");
        return this.segments[this.limit() - 1];
    };
    Path.prototype.get = function (index) {
        assert(index < this.length, 'Index out of range');
        return this.segments[this.offset + index];
    };
    Path.prototype.isEmpty = function () {
        return this.length === 0;
    };
    Path.prototype.isPrefixOf = function (other) {
        if (other.length < this.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== other.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.isImmediateParentOf = function (potentialChild) {
        if (this.length + 1 !== potentialChild.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== potentialChild.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.forEach = function (fn) {
        for (var i = this.offset, end = this.limit(); i < end; i++) {
            fn(this.segments[i]);
        }
    };
    Path.prototype.toArray = function () {
        return this.segments.slice(this.offset, this.limit());
    };
    Path.comparator = function (p1, p2) {
        var len = Math.min(p1.length, p2.length);
        for (var i = 0; i < len; i++) {
            var left = p1.get(i);
            var right = p2.get(i);
            if (left < right)
                return -1;
            if (left > right)
                return 1;
        }
        if (p1.length < p2.length)
            return -1;
        if (p1.length > p2.length)
            return 1;
        return 0;
    };
    return Path;
}());
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */
var ResourcePath = /** @class */ (function (_super) {
    tslib_1.__extends(ResourcePath, _super);
    function ResourcePath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourcePath.prototype.canonicalString = function () {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join('/');
    };
    ResourcePath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Creates a resource path from the given slash-delimited string.
     */
    ResourcePath.fromString = function (path) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        if (path.indexOf('//') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
        }
        // We may still have an empty segment at the beginning or end if they had a
        // leading or trailing slash (which we allow).
        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
        return new ResourcePath(segments);
    };
    ResourcePath.EMPTY_PATH = new ResourcePath([]);
    return ResourcePath;
}(Path));
var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/** A dot-separated path for navigating sub-objects within a document. */
var FieldPath = /** @class */ (function (_super) {
    tslib_1.__extends(FieldPath, _super);
    function FieldPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */
    FieldPath.isValidIdentifier = function (segment) {
        return identifierRegExp.test(segment);
    };
    FieldPath.prototype.canonicalString = function () {
        return this.toArray()
            .map(function (str) {
            str = str.replace('\\', '\\\\').replace('`', '\\`');
            if (!FieldPath.isValidIdentifier(str)) {
                str = '`' + str + '`';
            }
            return str;
        })
            .join('.');
    };
    FieldPath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Returns true if this field references the key of a document.
     */
    FieldPath.prototype.isKeyField = function () {
        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
    };
    /**
     * The field designating the key of a document.
     */
    FieldPath.keyField = function () {
        return new FieldPath([DOCUMENT_KEY_NAME]);
    };
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */
    FieldPath.fromServerFormat = function (path) {
        var segments = [];
        var current = '';
        var i = 0;
        var addCurrentSegment = function () {
            if (current.length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
                    "with '.', end with '.', or contain '..'");
            }
            segments.push(current);
            current = '';
        };
        var inBackticks = false;
        while (i < path.length) {
            var c = path[i];
            if (c === '\\') {
                if (i + 1 === path.length) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
                }
                var next = path[i + 1];
                if (!(next === '\\' || next === '.' || next === '`')) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
                }
                current += next;
                i += 2;
            }
            else if (c === '`') {
                inBackticks = !inBackticks;
                i++;
            }
            else if (c === '.' && !inBackticks) {
                addCurrentSegment();
                i++;
            }
            else {
                current += c;
                i++;
            }
        }
        addCurrentSegment();
        if (inBackticks) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
        }
        return new FieldPath(segments);
    };
    FieldPath.EMPTY_PATH = new FieldPath([]);
    return FieldPath;
}(Path));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DocumentKey = /** @class */ (function () {
    function DocumentKey(path) {
        this.path = path;
        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
            path.toArray().join('/'));
    }
    DocumentKey.prototype.isEqual = function (other) {
        return (other !== null && ResourcePath.comparator(this.path, other.path) === 0);
    };
    DocumentKey.prototype.toString = function () {
        return this.path.toString();
    };
    DocumentKey.comparator = function (k1, k2) {
        return ResourcePath.comparator(k1.path, k2.path);
    };
    DocumentKey.isDocumentKey = function (path) {
        return path.length % 2 === 0;
    };
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param path The segments of the path to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromSegments = function (segments) {
        return new DocumentKey(new ResourcePath(segments.slice()));
    };
    /**
     * Creates and returns a new document key using '/' to split the string into
     * segments.
     *
     * @param path The slash-separated path string to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromPathString = function (path) {
        return new DocumentKey(ResourcePath.fromString(path));
    };
    DocumentKey.EMPTY = new DocumentKey(new ResourcePath([]));
    return DocumentKey;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The result of a lookup for a given path may be an existing document or a
 * marker that this document does not exist at a given version.
 */
var MaybeDocument = /** @class */ (function () {
    function MaybeDocument(key, version) {
        this.key = key;
        this.version = version;
    }
    MaybeDocument.compareByKey = function (d1, d2) {
        return DocumentKey.comparator(d1.key, d2.key);
    };
    return MaybeDocument;
}());
/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */
var Document = /** @class */ (function (_super) {
    tslib_1.__extends(Document, _super);
    function Document(key, version, data, options, 
    /**
     * Memoized serialized form of the document for optimization purposes (avoids repeated
     * serialization). Might be undefined.
     */
    proto) {
        var _this = _super.call(this, key, version) || this;
        _this.data = data;
        _this.proto = proto;
        _this.hasLocalMutations = !!options.hasLocalMutations;
        _this.hasCommittedMutations = !!options.hasCommittedMutations;
        return _this;
    }
    Document.prototype.field = function (path) {
        return this.data.field(path);
    };
    Document.prototype.fieldValue = function (path) {
        var field = this.field(path);
        return field ? field.value() : undefined;
    };
    Document.prototype.value = function () {
        return this.data.value();
    };
    Document.prototype.isEqual = function (other) {
        return (other instanceof Document &&
            this.key.isEqual(other.key) &&
            this.version.isEqual(other.version) &&
            this.data.isEqual(other.data) &&
            this.hasLocalMutations === other.hasLocalMutations &&
            this.hasCommittedMutations === other.hasCommittedMutations);
    };
    Document.prototype.toString = function () {
        return ("Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " +
            ("{hasLocalMutations: " + this.hasLocalMutations + "}), ") +
            ("{hasCommittedMutations: " + this.hasCommittedMutations + "})"));
    };
    Object.defineProperty(Document.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasLocalMutations || this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    Document.compareByField = function (field, d1, d2) {
        var v1 = d1.field(field);
        var v2 = d2.field(field);
        if (v1 !== undefined && v2 !== undefined) {
            return v1.compareTo(v2);
        }
        else {
            return fail("Trying to compare documents on fields that don't exist");
        }
    };
    return Document;
}(MaybeDocument));
/**
 * A class representing a deleted document.
 * Version is set to 0 if we don't point to any specific time, otherwise it
 * denotes time we know it didn't exist at.
 */
var NoDocument = /** @class */ (function (_super) {
    tslib_1.__extends(NoDocument, _super);
    function NoDocument(key, version, options) {
        var _this = _super.call(this, key, version) || this;
        _this.hasCommittedMutations = !!(options && options.hasCommittedMutations);
        return _this;
    }
    NoDocument.prototype.toString = function () {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(NoDocument.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    NoDocument.prototype.isEqual = function (other) {
        return (other instanceof NoDocument &&
            other.hasCommittedMutations === this.hasCommittedMutations &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return NoDocument;
}(MaybeDocument));
/**
 * A class representing an existing document whose data is unknown (e.g. a
 * document that was updated without a known base document).
 */
var UnknownDocument = /** @class */ (function (_super) {
    tslib_1.__extends(UnknownDocument, _super);
    function UnknownDocument(key, version) {
        return _super.call(this, key, version) || this;
    }
    UnknownDocument.prototype.toString = function () {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(UnknownDocument.prototype, "hasPendingWrites", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    UnknownDocument.prototype.isEqual = function (other) {
        return (other instanceof UnknownDocument &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return UnknownDocument;
}(MaybeDocument));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap = /** @class */ (function () {
    function SortedMap(comparator, root) {
        this.comparator = comparator;
        this.root = root ? root : LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator, this.root
            .insert(key, value, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns a copy of the map, with the specified key removed.
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator, this.root
            .remove(key, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns the value of the node with the given key, or null.
    SortedMap.prototype.get = function (key) {
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    SortedMap.prototype.indexOf = function (key) {
        // Number of nodes that were pruned when descending right
        var prunedNodes = 0;
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return prunedNodes + node.left.size;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else {
                // Count all nodes left of the node plus the node itself
                prunedNodes += node.left.size + 1;
                node = node.right;
            }
        }
        // Node not found
        return -1;
    };
    SortedMap.prototype.isEmpty = function () {
        return this.root.isEmpty();
    };
    Object.defineProperty(SortedMap.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function () {
            return this.root.size;
        },
        enumerable: true,
        configurable: true
    });
    // Returns the minimum key in the map.
    SortedMap.prototype.minKey = function () {
        return this.root.minKey();
    };
    // Returns the maximum key in the map.
    SortedMap.prototype.maxKey = function () {
        return this.root.maxKey();
    };
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root.inorderTraversal(action);
    };
    SortedMap.prototype.forEach = function (fn) {
        this.inorderTraversal(function (k, v) {
            fn(k, v);
            return false;
        });
    };
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root.reverseTraversal(action);
    };
    // Returns an iterator over the SortedMap.
    SortedMap.prototype.getIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, false);
    };
    SortedMap.prototype.getIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, false);
    };
    SortedMap.prototype.getReverseIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, true);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, true);
    };
    return SortedMap;
}()); // end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator = /** @class */ (function () {
    function SortedMapIterator(node, startKey, comparator, isReverse) {
        this.isReverse = isReverse;
        this.nodeStack = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move
                // to the next one
                this.nodeStack.push(node);
                if (this.isReverse) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
        var node = this.nodeStack.pop();
        var result = { key: node.key, value: node.value };
        if (this.isReverse) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack.length === 0)
            return null;
        var node = this.nodeStack[this.nodeStack.length - 1];
        return { key: node.key, value: node.value };
    };
    return SortedMapIterator;
}()); // end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode = /** @class */ (function () {
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : LLRBNode.EMPTY;
        this.right = right != null ? right : LLRBNode.EMPTY;
        this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    // Returns the minimum node in the tree.
    LLRBNode.prototype.min = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min();
        }
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.minKey = function () {
        return this.min().key;
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    // Returns new tree, with the key/value added.
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.removeMin = function () {
        if (this.left.isEmpty()) {
            return LLRBNode.EMPTY;
        }
        var n = this;
        if (!n.left.isRed() && !n.left.left.isRed())
            n = n.moveRedLeft();
        n = n.copy(null, null, null, n.left.removeMin(), null);
        return n.fixUp();
    };
    // Returns new tree, with the specified item removed.
    LLRBNode.prototype.remove = function (key, comparator) {
        var smallest;
        var n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
                n = n.moveRedLeft();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed())
                n = n.rotateRight();
            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
                n = n.moveRedRight();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return LLRBNode.EMPTY;
                }
                else {
                    smallest = n.right.min();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.isRed = function () {
        return this.color;
    };
    // Returns new tree after performing any needed rotations.
    LLRBNode.prototype.fixUp = function () {
        var n = this;
        if (n.right.isRed() && !n.left.isRed())
            n = n.rotateLeft();
        if (n.left.isRed() && n.left.left.isRed())
            n = n.rotateRight();
        if (n.left.isRed() && n.right.isRed())
            n = n.colorFlip();
        return n;
    };
    LLRBNode.prototype.moveRedLeft = function () {
        var n = this.colorFlip();
        if (n.right.left.isRed()) {
            n = n.copy(null, null, null, null, n.right.rotateRight());
            n = n.rotateLeft();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.moveRedRight = function () {
        var n = this.colorFlip();
        if (n.left.left.isRed()) {
            n = n.rotateRight();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.rotateLeft = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    LLRBNode.prototype.rotateRight = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    LLRBNode.prototype.colorFlip = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    // For testing.
    LLRBNode.prototype.checkMaxDepth = function () {
        var blackDepth = this.check();
        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
            return true;
        }
        else {
            return false;
        }
    };
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    LLRBNode.prototype.check = function () {
        if (this.isRed() && this.left.isRed()) {
            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed()) {
            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        var blackDepth = this.left.check();
        if (blackDepth !== this.right.check()) {
            throw fail('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed() ? 0 : 1);
        }
    };
    // tslint:disable-next-line:no-any Empty node is shared between all LLRB trees.
    LLRBNode.EMPTY = null;
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}()); // end LLRBNode
// Represents an empty node (a leaf node in the Red-Black Tree).
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
        this.size = 0;
    }
    // Returns a copy of the current node.
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    // Returns a copy of the tree, with the specified key/value added.
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value);
    };
    // Returns a copy of the tree, with the specified key removed.
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.isRed = function () {
        return false;
    };
    // For testing.
    LLRBEmptyNode.prototype.checkMaxDepth = function () {
        return true;
    };
    LLRBEmptyNode.prototype.check = function () {
        return 0;
    };
    return LLRBEmptyNode;
}()); // end LLRBEmptyNode
LLRBNode.EMPTY = new LLRBEmptyNode();

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TypeOrder;
(function (TypeOrder) {
    // This order is defined by the backend.
    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
})(TypeOrder || (TypeOrder = {}));
/** Defines the return value for pending server timestamps. */
var ServerTimestampBehavior;
(function (ServerTimestampBehavior) {
    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
})(ServerTimestampBehavior || (ServerTimestampBehavior = {}));
/** Holds properties that define field value deserialization options. */
var FieldValueOptions = /** @class */ (function () {
    function FieldValueOptions(serverTimestampBehavior, timestampsInSnapshots) {
        this.serverTimestampBehavior = serverTimestampBehavior;
        this.timestampsInSnapshots = timestampsInSnapshots;
    }
    FieldValueOptions.fromSnapshotOptions = function (options, timestampsInSnapshots) {
        switch (options.serverTimestamps) {
            case 'estimate':
                return new FieldValueOptions(ServerTimestampBehavior.Estimate, timestampsInSnapshots);
            case 'previous':
                return new FieldValueOptions(ServerTimestampBehavior.Previous, timestampsInSnapshots);
            case 'none': // Fall-through intended.
            case undefined:
                return new FieldValueOptions(ServerTimestampBehavior.Default, timestampsInSnapshots);
            default:
                return fail('fromSnapshotOptions() called with invalid options.');
        }
    };
    return FieldValueOptions;
}());
/**
 * A field value represents a datatype as stored by Firestore.
 */
var FieldValue = /** @class */ (function () {
    function FieldValue() {
    }
    FieldValue.prototype.toString = function () {
        var val = this.value();
        return val === null ? 'null' : val.toString();
    };
    FieldValue.prototype.defaultCompareTo = function (other) {
        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
        return cmp;
    };
    return FieldValue;
}());
var NullValue = /** @class */ (function (_super) {
    tslib_1.__extends(NullValue, _super);
    function NullValue() {
        var _this = _super.call(this) || this;
        _this.typeOrder = TypeOrder.NullValue;
        // internalValue is unused but we add it to work around
        // https://github.com/Microsoft/TypeScript/issues/15585
        _this.internalValue = null;
        return _this;
    }
    NullValue.prototype.value = function (options) {
        return null;
    };
    NullValue.prototype.isEqual = function (other) {
        return other instanceof NullValue;
    };
    NullValue.prototype.compareTo = function (other) {
        if (other instanceof NullValue) {
            return 0;
        }
        return this.defaultCompareTo(other);
    };
    NullValue.INSTANCE = new NullValue();
    return NullValue;
}(FieldValue));
var BooleanValue = /** @class */ (function (_super) {
    tslib_1.__extends(BooleanValue, _super);
    function BooleanValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BooleanValue;
        return _this;
    }
    BooleanValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BooleanValue.prototype.isEqual = function (other) {
        return (other instanceof BooleanValue &&
            this.internalValue === other.internalValue);
    };
    BooleanValue.prototype.compareTo = function (other) {
        if (other instanceof BooleanValue) {
            return primitiveComparator(this, other);
        }
        return this.defaultCompareTo(other);
    };
    BooleanValue.of = function (value) {
        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
    };
    BooleanValue.TRUE = new BooleanValue(true);
    BooleanValue.FALSE = new BooleanValue(false);
    return BooleanValue;
}(FieldValue));
/** Base class for IntegerValue and DoubleValue. */
var NumberValue = /** @class */ (function (_super) {
    tslib_1.__extends(NumberValue, _super);
    function NumberValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.NumberValue;
        return _this;
    }
    NumberValue.prototype.value = function (options) {
        return this.internalValue;
    };
    NumberValue.prototype.compareTo = function (other) {
        if (other instanceof NumberValue) {
            return numericComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return NumberValue;
}(FieldValue));
/** Utility function to compare doubles (using Firestore semantics for NaN). */
function numericComparator(left, right) {
    if (left < right) {
        return -1;
    }
    else if (left > right) {
        return 1;
    }
    else if (left === right) {
        return 0;
    }
    else {
        // one or both are NaN.
        if (isNaN(left)) {
            return isNaN(right) ? 0 : -1;
        }
        else {
            return 1;
        }
    }
}
/**
 * Utility function to check numbers for equality using Firestore semantics
 * (NaN === NaN, -0.0 !== 0.0).
 */
function numericEquals(left, right) {
    // Implemented based on Object.is() polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    if (left === right) {
        // +0 != -0
        return left !== 0 || 1 / left === 1 / right;
    }
    else {
        // NaN == NaN
        return left !== left && right !== right;
    }
}
var IntegerValue = /** @class */ (function (_super) {
    tslib_1.__extends(IntegerValue, _super);
    function IntegerValue(internalValue) {
        return _super.call(this, internalValue) || this;
    }
    IntegerValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof IntegerValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    return IntegerValue;
}(NumberValue));
var DoubleValue = /** @class */ (function (_super) {
    tslib_1.__extends(DoubleValue, _super);
    function DoubleValue(internalValue) {
        var _this = _super.call(this, internalValue) || this;
        _this.internalValue = internalValue;
        return _this;
    }
    DoubleValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof DoubleValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    DoubleValue.NAN = new DoubleValue(NaN);
    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
    return DoubleValue;
}(NumberValue));
// TODO(b/37267885): Add truncation support
var StringValue = /** @class */ (function (_super) {
    tslib_1.__extends(StringValue, _super);
    function StringValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.StringValue;
        return _this;
    }
    StringValue.prototype.value = function (options) {
        return this.internalValue;
    };
    StringValue.prototype.isEqual = function (other) {
        return (other instanceof StringValue && this.internalValue === other.internalValue);
    };
    StringValue.prototype.compareTo = function (other) {
        if (other instanceof StringValue) {
            return primitiveComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return StringValue;
}(FieldValue));
var TimestampValue = /** @class */ (function (_super) {
    tslib_1.__extends(TimestampValue, _super);
    function TimestampValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    TimestampValue.prototype.value = function (options) {
        if (!options || options.timestampsInSnapshots) {
            return this.internalValue;
        }
        else {
            return this.internalValue.toDate();
        }
    };
    TimestampValue.prototype.isEqual = function (other) {
        return (other instanceof TimestampValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    TimestampValue.prototype.compareTo = function (other) {
        if (other instanceof TimestampValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        else if (other instanceof ServerTimestampValue) {
            // Concrete timestamps come before server timestamps.
            return -1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    return TimestampValue;
}(FieldValue));
/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */
var ServerTimestampValue = /** @class */ (function (_super) {
    tslib_1.__extends(ServerTimestampValue, _super);
    function ServerTimestampValue(localWriteTime, previousValue) {
        var _this = _super.call(this) || this;
        _this.localWriteTime = localWriteTime;
        _this.previousValue = previousValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    ServerTimestampValue.prototype.value = function (options) {
        if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
            return new TimestampValue(this.localWriteTime).value(options);
        }
        else if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
            return this.previousValue ? this.previousValue.value(options) : null;
        }
        else {
            return null;
        }
    };
    ServerTimestampValue.prototype.isEqual = function (other) {
        return (other instanceof ServerTimestampValue &&
            this.localWriteTime.isEqual(other.localWriteTime));
    };
    ServerTimestampValue.prototype.compareTo = function (other) {
        if (other instanceof ServerTimestampValue) {
            return this.localWriteTime._compareTo(other.localWriteTime);
        }
        else if (other instanceof TimestampValue) {
            // Server timestamps come after all concrete timestamps.
            return 1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ServerTimestampValue.prototype.toString = function () {
        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
    };
    return ServerTimestampValue;
}(FieldValue));
var BlobValue = /** @class */ (function (_super) {
    tslib_1.__extends(BlobValue, _super);
    function BlobValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BlobValue;
        return _this;
    }
    BlobValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BlobValue.prototype.isEqual = function (other) {
        return (other instanceof BlobValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    BlobValue.prototype.compareTo = function (other) {
        if (other instanceof BlobValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return BlobValue;
}(FieldValue));
var RefValue = /** @class */ (function (_super) {
    tslib_1.__extends(RefValue, _super);
    function RefValue(databaseId, key) {
        var _this = _super.call(this) || this;
        _this.databaseId = databaseId;
        _this.key = key;
        _this.typeOrder = TypeOrder.RefValue;
        return _this;
    }
    RefValue.prototype.value = function (options) {
        return this.key;
    };
    RefValue.prototype.isEqual = function (other) {
        if (other instanceof RefValue) {
            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
        }
        else {
            return false;
        }
    };
    RefValue.prototype.compareTo = function (other) {
        if (other instanceof RefValue) {
            var cmp = this.databaseId.compareTo(other.databaseId);
            return cmp !== 0 ? cmp : DocumentKey.comparator(this.key, other.key);
        }
        return this.defaultCompareTo(other);
    };
    return RefValue;
}(FieldValue));
var GeoPointValue = /** @class */ (function (_super) {
    tslib_1.__extends(GeoPointValue, _super);
    function GeoPointValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.GeoPointValue;
        return _this;
    }
    GeoPointValue.prototype.value = function (options) {
        return this.internalValue;
    };
    GeoPointValue.prototype.isEqual = function (other) {
        return (other instanceof GeoPointValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    GeoPointValue.prototype.compareTo = function (other) {
        if (other instanceof GeoPointValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return GeoPointValue;
}(FieldValue));
var ObjectValue = /** @class */ (function (_super) {
    tslib_1.__extends(ObjectValue, _super);
    function ObjectValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ObjectValue;
        return _this;
    }
    ObjectValue.prototype.value = function (options) {
        var result = {};
        this.internalValue.inorderTraversal(function (key, val) {
            result[key] = val.value(options);
        });
        return result;
    };
    ObjectValue.prototype.forEach = function (action) {
        this.internalValue.inorderTraversal(action);
    };
    ObjectValue.prototype.isEqual = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
                    return false;
                }
            }
            return !it1.hasNext() && !it2.hasNext();
        }
        return false;
    };
    ObjectValue.prototype.compareTo = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                var cmp = primitiveComparator(next1.key, next2.key) ||
                    next1.value.compareTo(next2.value);
                if (cmp) {
                    return cmp;
                }
            }
            // Only equal if both iterators are exhausted
            return primitiveComparator(it1.hasNext(), it2.hasNext());
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ObjectValue.prototype.set = function (path, to) {
        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
        if (path.length === 1) {
            return this.setChild(path.firstSegment(), to);
        }
        else {
            var child = this.child(path.firstSegment());
            if (!(child instanceof ObjectValue)) {
                child = ObjectValue.EMPTY;
            }
            var newChild = child.set(path.popFirst(), to);
            return this.setChild(path.firstSegment(), newChild);
        }
    };
    ObjectValue.prototype.delete = function (path) {
        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
        if (path.length === 1) {
            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
        }
        else {
            // nested field
            var child = this.child(path.firstSegment());
            if (child instanceof ObjectValue) {
                var newChild = child.delete(path.popFirst());
                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
            }
            else {
                // Don't actually change a primitive value to an object for a delete
                return this;
            }
        }
    };
    ObjectValue.prototype.contains = function (path) {
        return this.field(path) !== undefined;
    };
    ObjectValue.prototype.field = function (path) {
        assert(!path.isEmpty(), "Can't get field of empty path");
        var field = this;
        path.forEach(function (pathSegment) {
            if (field instanceof ObjectValue) {
                field = field.internalValue.get(pathSegment) || undefined;
            }
            else {
                field = undefined;
            }
        });
        return field;
    };
    ObjectValue.prototype.toString = function () {
        return JSON.stringify(this.value());
    };
    ObjectValue.prototype.child = function (childName) {
        return this.internalValue.get(childName) || undefined;
    };
    ObjectValue.prototype.setChild = function (childName, value) {
        return new ObjectValue(this.internalValue.insert(childName, value));
    };
    ObjectValue.EMPTY = new ObjectValue(new SortedMap(primitiveComparator));
    return ObjectValue;
}(FieldValue));
var ArrayValue = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayValue, _super);
    function ArrayValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ArrayValue;
        return _this;
    }
    ArrayValue.prototype.value = function (options) {
        return this.internalValue.map(function (v) { return v.value(options); });
    };
    ArrayValue.prototype.forEach = function (action) {
        this.internalValue.forEach(action);
    };
    ArrayValue.prototype.isEqual = function (other) {
        if (other instanceof ArrayValue) {
            if (this.internalValue.length !== other.internalValue.length) {
                return false;
            }
            for (var i = 0; i < this.internalValue.length; i++) {
                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };
    ArrayValue.prototype.compareTo = function (other) {
        if (other instanceof ArrayValue) {
            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
            for (var i = 0; i < minLength; i++) {
                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
                if (cmp) {
                    return cmp;
                }
            }
            return primitiveComparator(this.internalValue.length, other.internalValue.length);
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ArrayValue.prototype.toString = function () {
        return JSON.stringify(this.value());
    };
    return ArrayValue;
}(FieldValue));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Untyped Number alias we can use to check for ES6 methods / properties.
// tslint:disable-next-line:no-any variable-name
var NumberAsAny = Number;
/**
 * Minimum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
/**
 * Maximum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * Returns whether an number is an integer, uses native implementation if
 * available.
 * Added to not rely on ES6 features.
 * @param value The value to test for being an integer
 */
var isInteger = NumberAsAny.isInteger ||
    (function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    });
/**
 * Returns whether a variable is either undefined or null.
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */
function isSafeInteger(value) {
    return (isInteger(value) &&
        value <= MAX_SAFE_INTEGER &&
        value >= MIN_SAFE_INTEGER);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Query = /** @class */ (function () {
    function Query(path, explicitOrderBy, filters, limit, startAt, endAt) {
        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
        if (filters === void 0) { filters = []; }
        if (limit === void 0) { limit = null; }
        if (startAt === void 0) { startAt = null; }
        if (endAt === void 0) { endAt = null; }
        this.path = path;
        this.explicitOrderBy = explicitOrderBy;
        this.filters = filters;
        this.limit = limit;
        this.startAt = startAt;
        this.endAt = endAt;
        this.memoizedCanonicalId = null;
        this.memoizedOrderBy = null;
        if (this.startAt) {
            this.assertValidBound(this.startAt);
        }
        if (this.endAt) {
            this.assertValidBound(this.endAt);
        }
    }
    Query.atPath = function (path) {
        return new Query(path);
    };
    Object.defineProperty(Query.prototype, "orderBy", {
        get: function () {
            if (this.memoizedOrderBy === null) {
                var inequalityField = this.getInequalityFilterField();
                var firstOrderByField = this.getFirstOrderByField();
                if (inequalityField !== null && firstOrderByField === null) {
                    // In order to implicitly add key ordering, we must also add the
                    // inequality filter field for it to be a valid query.
                    // Note that the default inequality field and key ordering is ascending.
                    if (inequalityField.isKeyField()) {
                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
                    }
                    else {
                        this.memoizedOrderBy = [
                            new OrderBy(inequalityField),
                            KEY_ORDERING_ASC
                        ];
                    }
                }
                else {
                    assert(inequalityField === null ||
                        (firstOrderByField !== null &&
                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
                    this.memoizedOrderBy = [];
                    var foundKeyOrdering = false;
                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
                        var orderBy = _a[_i];
                        this.memoizedOrderBy.push(orderBy);
                        if (orderBy.field.isKeyField()) {
                            foundKeyOrdering = true;
                        }
                    }
                    if (!foundKeyOrdering) {
                        // The order of the implicit key ordering always matches the last
                        // explicit order by
                        var lastDirection = this.explicitOrderBy.length > 0
                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
                            : Direction.ASCENDING;
                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
                            ? KEY_ORDERING_ASC
                            : KEY_ORDERING_DESC);
                    }
                }
            }
            return this.memoizedOrderBy;
        },
        enumerable: true,
        configurable: true
    });
    Query.prototype.addFilter = function (filter) {
        assert(this.getInequalityFilterField() == null ||
            !(filter instanceof RelationFilter) ||
            !filter.isInequality() ||
            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
        assert(!DocumentKey.isDocumentKey(this.path), 'No filtering allowed for document query');
        var newFilters = this.filters.concat([filter]);
        return new Query(this.path, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
    };
    Query.prototype.addOrderBy = function (orderBy) {
        assert(!DocumentKey.isDocumentKey(this.path), 'No ordering allowed for document query');
        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
        return new Query(this.path, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
    };
    Query.prototype.withLimit = function (limit) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
    };
    Query.prototype.withStartAt = function (bound) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
    };
    Query.prototype.withEndAt = function (bound) {
        return new Query(this.path, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
    };
    // TODO(b/29183165): This is used to get a unique string from a query to, for
    // example, use as a dictionary key, but the implementation is subject to
    // collisions. Make it collision-free.
    Query.prototype.canonicalId = function () {
        if (this.memoizedCanonicalId === null) {
            var canonicalId = this.path.canonicalString();
            canonicalId += '|f:';
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                canonicalId += filter.canonicalId();
                canonicalId += ',';
            }
            canonicalId += '|ob:';
            // TODO(dimond): make this collision resistant
            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
                var orderBy = _c[_b];
                canonicalId += orderBy.canonicalId();
                canonicalId += ',';
            }
            if (!isNullOrUndefined(this.limit)) {
                canonicalId += '|l:';
                canonicalId += this.limit;
            }
            if (this.startAt) {
                canonicalId += '|lb:';
                canonicalId += this.startAt.canonicalId();
            }
            if (this.endAt) {
                canonicalId += '|ub:';
                canonicalId += this.endAt.canonicalId();
            }
            this.memoizedCanonicalId = canonicalId;
        }
        return this.memoizedCanonicalId;
    };
    Query.prototype.toString = function () {
        var str = 'Query(' + this.path.canonicalString();
        if (this.filters.length > 0) {
            str += ", filters: [" + this.filters.join(', ') + "]";
        }
        if (!isNullOrUndefined(this.limit)) {
            str += ', limit: ' + this.limit;
        }
        if (this.explicitOrderBy.length > 0) {
            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
        }
        if (this.startAt) {
            str += ', startAt: ' + this.startAt.canonicalId();
        }
        if (this.endAt) {
            str += ', endAt: ' + this.endAt.canonicalId();
        }
        return str + ')';
    };
    Query.prototype.isEqual = function (other) {
        if (this.limit !== other.limit) {
            return false;
        }
        if (this.orderBy.length !== other.orderBy.length) {
            return false;
        }
        for (var i = 0; i < this.orderBy.length; i++) {
            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
                return false;
            }
        }
        if (this.filters.length !== other.filters.length) {
            return false;
        }
        for (var i = 0; i < this.filters.length; i++) {
            if (!this.filters[i].isEqual(other.filters[i])) {
                return false;
            }
        }
        if (!this.path.isEqual(other.path)) {
            return false;
        }
        if (this.startAt !== null
            ? !this.startAt.isEqual(other.startAt)
            : other.startAt !== null) {
            return false;
        }
        return this.endAt !== null
            ? this.endAt.isEqual(other.endAt)
            : other.endAt === null;
    };
    Query.prototype.docComparator = function (d1, d2) {
        var comparedOnKeyField = false;
        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            var comp = orderBy.compare(d1, d2);
            if (comp !== 0)
                return comp;
            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
        }
        // Assert that we actually compared by key
        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
        return 0;
    };
    Query.prototype.matches = function (doc) {
        return (this.matchesAncestor(doc) &&
            this.matchesOrderBy(doc) &&
            this.matchesFilters(doc) &&
            this.matchesBounds(doc));
    };
    Query.prototype.hasLimit = function () {
        return !isNullOrUndefined(this.limit);
    };
    Query.prototype.getFirstOrderByField = function () {
        return this.explicitOrderBy.length > 0
            ? this.explicitOrderBy[0].field
            : null;
    };
    Query.prototype.getInequalityFilterField = function () {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof RelationFilter && filter.isInequality()) {
                return filter.field;
            }
        }
        return null;
    };
    Query.prototype.hasArrayContainsFilter = function () {
        return (this.filters.find(function (filter) {
            return filter instanceof RelationFilter &&
                filter.op === RelationOp.ARRAY_CONTAINS;
        }) !== undefined);
    };
    Query.prototype.isDocumentQuery = function () {
        return DocumentKey.isDocumentKey(this.path) && this.filters.length === 0;
    };
    Query.prototype.matchesAncestor = function (doc) {
        var docPath = doc.key.path;
        if (DocumentKey.isDocumentKey(this.path)) {
            // exact match for document queries
            return this.path.isEqual(docPath);
        }
        else {
            // shallow ancestor queries by default
            return (this.path.isPrefixOf(docPath) && this.path.length === docPath.length - 1);
        }
    };
    /**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */
    Query.prototype.matchesOrderBy = function (doc) {
        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            // order by key always matches
            if (!orderBy.field.isKeyField() &&
                doc.field(orderBy.field) === undefined) {
                return false;
            }
        }
        return true;
    };
    Query.prototype.matchesFilters = function (doc) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (!filter.matches(doc)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Makes sure a document is within the bounds, if provided.
     */
    Query.prototype.matchesBounds = function (doc) {
        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        return true;
    };
    Query.prototype.assertValidBound = function (bound) {
        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
    };
    return Query;
}());
var Filter = /** @class */ (function () {
    function Filter() {
    }
    /**
     * Creates a filter based on the provided arguments.
     */
    Filter.create = function (field, op, value) {
        if (value.isEqual(NullValue.INSTANCE)) {
            if (op !== RelationOp.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals comparisons on null.');
            }
            return new NullFilter(field);
        }
        else if (value.isEqual(DoubleValue.NAN)) {
            if (op !== RelationOp.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals comparisons on NaN.');
            }
            return new NanFilter(field);
        }
        else {
            return new RelationFilter(field, op, value);
        }
    };
    return Filter;
}());
var RelationOp = /** @class */ (function () {
    function RelationOp(name) {
        this.name = name;
    }
    RelationOp.fromString = function (op) {
        switch (op) {
            case '<':
                return RelationOp.LESS_THAN;
            case '<=':
                return RelationOp.LESS_THAN_OR_EQUAL;
            case '==':
                return RelationOp.EQUAL;
            case '>=':
                return RelationOp.GREATER_THAN_OR_EQUAL;
            case '>':
                return RelationOp.GREATER_THAN;
            case 'array-contains':
                return RelationOp.ARRAY_CONTAINS;
            default:
                return fail('Unknown relation: ' + op);
        }
    };
    RelationOp.prototype.toString = function () {
        return this.name;
    };
    RelationOp.prototype.isEqual = function (other) {
        return this.name === other.name;
    };
    RelationOp.LESS_THAN = new RelationOp('<');
    RelationOp.LESS_THAN_OR_EQUAL = new RelationOp('<=');
    RelationOp.EQUAL = new RelationOp('==');
    RelationOp.GREATER_THAN = new RelationOp('>');
    RelationOp.GREATER_THAN_OR_EQUAL = new RelationOp('>=');
    RelationOp.ARRAY_CONTAINS = new RelationOp('array-contains');
    return RelationOp;
}());
var RelationFilter = /** @class */ (function (_super) {
    tslib_1.__extends(RelationFilter, _super);
    function RelationFilter(field, op, value) {
        var _this = _super.call(this) || this;
        _this.field = field;
        _this.op = op;
        _this.value = value;
        return _this;
    }
    RelationFilter.prototype.matches = function (doc) {
        if (this.field.isKeyField()) {
            assert(this.value instanceof RefValue, 'Comparing on key, but filter value not a RefValue');
            assert(this.op !== RelationOp.ARRAY_CONTAINS, "array-contains queries don't make sense on document keys.");
            var refValue = this.value;
            var comparison = DocumentKey.comparator(doc.key, refValue.key);
            return this.matchesComparison(comparison);
        }
        else {
            var val = doc.field(this.field);
            return val !== undefined && this.matchesValue(val);
        }
    };
    RelationFilter.prototype.matchesValue = function (value) {
        var _this = this;
        if (this.op === RelationOp.ARRAY_CONTAINS) {
            return (value instanceof ArrayValue &&
                value.internalValue.find(function (element) { return element.isEqual(_this.value); }) !==
                    undefined);
        }
        else {
            // Only compare types with matching backend order (such as double and int).
            return (this.value.typeOrder === value.typeOrder &&
                this.matchesComparison(value.compareTo(this.value)));
        }
    };
    RelationFilter.prototype.matchesComparison = function (comparison) {
        switch (this.op) {
            case RelationOp.LESS_THAN:
                return comparison < 0;
            case RelationOp.LESS_THAN_OR_EQUAL:
                return comparison <= 0;
            case RelationOp.EQUAL:
                return comparison === 0;
            case RelationOp.GREATER_THAN:
                return comparison > 0;
            case RelationOp.GREATER_THAN_OR_EQUAL:
                return comparison >= 0;
            default:
                return fail('Unknown relation op' + this.op);
        }
    };
    RelationFilter.prototype.isInequality = function () {
        return (this.op !== RelationOp.EQUAL && this.op !== RelationOp.ARRAY_CONTAINS);
    };
    RelationFilter.prototype.canonicalId = function () {
        // TODO(b/29183165): Technically, this won't be unique if two values have
        // the same description, such as the int 3 and the string "3". So we should
        // add the types in here somehow, too.
        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
    };
    RelationFilter.prototype.isEqual = function (other) {
        if (other instanceof RelationFilter) {
            return (this.op.isEqual(other.op) &&
                this.field.isEqual(other.field) &&
                this.value.isEqual(other.value));
        }
        else {
            return false;
        }
    };
    RelationFilter.prototype.toString = function () {
        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
    };
    return RelationFilter;
}(Filter));
/**
 * Filter that matches 'null' values.
 */
var NullFilter = /** @class */ (function (_super) {
    tslib_1.__extends(NullFilter, _super);
    function NullFilter(field) {
        var _this = _super.call(this) || this;
        _this.field = field;
        return _this;
    }
    NullFilter.prototype.matches = function (doc) {
        var val = doc.field(this.field);
        return val !== undefined && val.value() === null;
    };
    NullFilter.prototype.canonicalId = function () {
        return this.field.canonicalString() + ' IS null';
    };
    NullFilter.prototype.toString = function () {
        return this.field.canonicalString() + " IS null";
    };
    NullFilter.prototype.isEqual = function (other) {
        if (other instanceof NullFilter) {
            return this.field.isEqual(other.field);
        }
        else {
            return false;
        }
    };
    return NullFilter;
}(Filter));
/**
 * Filter that matches 'NaN' values.
 */
var NanFilter = /** @class */ (function (_super) {
    tslib_1.__extends(NanFilter, _super);
    function NanFilter(field) {
        var _this = _super.call(this) || this;
        _this.field = field;
        return _this;
    }
    NanFilter.prototype.matches = function (doc) {
        var field = doc.field(this.field);
        var val = field && field.value();
        return typeof val === 'number' && isNaN(val);
    };
    NanFilter.prototype.canonicalId = function () {
        return this.field.canonicalString() + ' IS NaN';
    };
    NanFilter.prototype.toString = function () {
        return this.field.canonicalString() + " IS NaN";
    };
    NanFilter.prototype.isEqual = function (other) {
        if (other instanceof NanFilter) {
            return this.field.isEqual(other.field);
        }
        else {
            return false;
        }
    };
    return NanFilter;
}(Filter));
/**
 * The direction of sorting in an order by.
 */
var Direction = /** @class */ (function () {
    function Direction(name) {
        this.name = name;
    }
    Direction.prototype.toString = function () {
        return this.name;
    };
    Direction.ASCENDING = new Direction('asc');
    Direction.DESCENDING = new Direction('desc');
    return Direction;
}());
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */
var Bound = /** @class */ (function () {
    function Bound(position, before) {
        this.position = position;
        this.before = before;
    }
    Bound.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        var canonicalId = this.before ? 'b:' : 'a:';
        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
            var component = _a[_i];
            canonicalId += component.toString();
        }
        return canonicalId;
    };
    /**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */
    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
        var comparison = 0;
        for (var i = 0; i < this.position.length; i++) {
            var orderByComponent = orderBy[i];
            var component = this.position[i];
            if (orderByComponent.field.isKeyField()) {
                assert(component instanceof RefValue, 'Bound has a non-key value where the key path is being used.');
                comparison = DocumentKey.comparator(component.key, doc.key);
            }
            else {
                var docValue = doc.field(orderByComponent.field);
                assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
                comparison = component.compareTo(docValue);
            }
            if (orderByComponent.dir === Direction.DESCENDING) {
                comparison = comparison * -1;
            }
            if (comparison !== 0) {
                break;
            }
        }
        return this.before ? comparison <= 0 : comparison < 0;
    };
    Bound.prototype.isEqual = function (other) {
        if (other === null) {
            return false;
        }
        if (this.before !== other.before ||
            this.position.length !== other.position.length) {
            return false;
        }
        for (var i = 0; i < this.position.length; i++) {
            var thisPosition = this.position[i];
            var otherPosition = other.position[i];
            return thisPosition.isEqual(otherPosition);
        }
        return true;
    };
    return Bound;
}());
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */
var OrderBy = /** @class */ (function () {
    function OrderBy(field, dir) {
        this.field = field;
        if (dir === undefined) {
            dir = Direction.ASCENDING;
        }
        this.dir = dir;
        this.isKeyOrderBy = field.isKeyField();
    }
    OrderBy.prototype.compare = function (d1, d2) {
        var comparison = this.isKeyOrderBy
            ? Document.compareByKey(d1, d2)
            : Document.compareByField(this.field, d1, d2);
        switch (this.dir) {
            case Direction.ASCENDING:
                return comparison;
            case Direction.DESCENDING:
                return -1 * comparison;
            default:
                return fail('Unknown direction: ' + this.dir);
        }
    };
    OrderBy.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        return this.field.canonicalString() + this.dir.toString();
    };
    OrderBy.prototype.toString = function () {
        return this.field.canonicalString() + " (" + this.dir + ")";
    };
    OrderBy.prototype.isEqual = function (other) {
        return this.dir === other.dir && this.field.isEqual(other.field);
    };
    return OrderBy;
}());
var KEY_ORDERING_ASC = new OrderBy(FieldPath.keyField(), Direction.ASCENDING);
var KEY_ORDERING_DESC = new OrderBy(FieldPath.keyField(), Direction.DESCENDING);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */
var SnapshotVersion = /** @class */ (function () {
    function SnapshotVersion(timestamp) {
        this.timestamp = timestamp;
    }
    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
    // delete this constructor and use a timestamp-backed version everywhere.
    SnapshotVersion.fromMicroseconds = function (value) {
        var seconds = Math.floor(value / 1e6);
        var nanos = (value % 1e6) * 1e3;
        return new SnapshotVersion(new Timestamp(seconds, nanos));
    };
    SnapshotVersion.fromTimestamp = function (value) {
        return new SnapshotVersion(value);
    };
    SnapshotVersion.forDeletedDoc = function () {
        return SnapshotVersion.MIN;
    };
    SnapshotVersion.prototype.compareTo = function (other) {
        return this.timestamp._compareTo(other.timestamp);
    };
    SnapshotVersion.prototype.isEqual = function (other) {
        return this.timestamp.isEqual(other.timestamp);
    };
    /** Returns a number representation of the version for use in spec tests. */
    SnapshotVersion.prototype.toMicroseconds = function () {
        // Convert to microseconds.
        return this.timestamp.seconds * 1e6 + this.timestamp.nanoseconds / 1000;
    };
    SnapshotVersion.prototype.toString = function () {
        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
    };
    SnapshotVersion.prototype.toTimestamp = function () {
        return this.timestamp;
    };
    SnapshotVersion.MIN = new SnapshotVersion(new Timestamp(0, 0));
    return SnapshotVersion;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** An enumeration of the different purposes we have for queries. */
var QueryPurpose;
(function (QueryPurpose) {
    /** A regular, normal query. */
    QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
    /**
     * The query was used to refill a query after an existence filter mismatch.
     */
    QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
    /** The query was used to resolve a limbo document. */
    QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
})(QueryPurpose || (QueryPurpose = {}));
/**
 * An immutable set of metadata that the local store tracks for each query.
 */
var QueryData = /** @class */ (function () {
    function QueryData(
    /** The query being listened to. */
    query, 
    /**
     * The target ID to which the query corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */
    targetId, 
    /** The purpose of the query. */
    purpose, 
    /** The sequence number of the last transaction during which this query data was modified */
    sequenceNumber, 
    /** The latest snapshot version seen for this target. */
    snapshotVersion, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken) {
        if (snapshotVersion === void 0) { snapshotVersion = SnapshotVersion.MIN; }
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        this.query = query;
        this.targetId = targetId;
        this.purpose = purpose;
        this.sequenceNumber = sequenceNumber;
        this.snapshotVersion = snapshotVersion;
        this.resumeToken = resumeToken;
    }
    /**
     * Creates a new query data instance with an updated snapshot version and
     * resume token.
     */
    QueryData.prototype.copy = function (overwrite) {
        return new QueryData(this.query, this.targetId, this.purpose, overwrite.sequenceNumber === undefined
            ? this.sequenceNumber
            : overwrite.sequenceNumber, overwrite.snapshotVersion === undefined
            ? this.snapshotVersion
            : overwrite.snapshotVersion, overwrite.resumeToken === undefined
            ? this.resumeToken
            : overwrite.resumeToken);
    };
    QueryData.prototype.isEqual = function (other) {
        return (this.targetId === other.targetId &&
            this.purpose === other.purpose &&
            this.sequenceNumber === other.sequenceNumber &&
            this.snapshotVersion.isEqual(other.snapshotVersion) &&
            this.resumeToken === other.resumeToken &&
            this.query.isEqual(other.query));
    };
    return QueryData;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */
var SortedSet = /** @class */ (function () {
    function SortedSet(comparator) {
        this.comparator = comparator;
        this.data = new SortedMap(this.comparator);
    }
    /**
     * Creates a SortedSet from the keys of the map.
     * This is currently implemented as an O(n) copy.
     */
    SortedSet.fromMapKeys = function (map) {
        var keys = new SortedSet(map.comparator);
        map.forEach(function (key) {
            keys = keys.add(key);
        });
        return keys;
    };
    SortedSet.prototype.has = function (elem) {
        return this.data.get(elem) !== null;
    };
    SortedSet.prototype.first = function () {
        return this.data.minKey();
    };
    SortedSet.prototype.last = function () {
        return this.data.maxKey();
    };
    Object.defineProperty(SortedSet.prototype, "size", {
        get: function () {
            return this.data.size;
        },
        enumerable: true,
        configurable: true
    });
    SortedSet.prototype.indexOf = function (elem) {
        return this.data.indexOf(elem);
    };
    /** Iterates elements in order defined by "comparator" */
    SortedSet.prototype.forEach = function (cb) {
        this.data.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
    SortedSet.prototype.forEachInRange = function (range, cb) {
        var iter = this.data.getIteratorFrom(range[0]);
        while (iter.hasNext()) {
            var elem = iter.getNext();
            if (this.comparator(elem.key, range[1]) >= 0)
                return;
            cb(elem.key);
        }
    };
    /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */
    SortedSet.prototype.forEachWhile = function (cb, start) {
        var iter;
        if (start !== undefined) {
            iter = this.data.getIteratorFrom(start);
        }
        else {
            iter = this.data.getIterator();
        }
        while (iter.hasNext()) {
            var elem = iter.getNext();
            var result = cb(elem.key);
            if (!result)
                return;
        }
    };
    /** Finds the least element greater than or equal to `elem`. */
    SortedSet.prototype.firstAfterOrEqual = function (elem) {
        var iter = this.data.getIteratorFrom(elem);
        return iter.hasNext() ? iter.getNext().key : null;
    };
    SortedSet.prototype.getIterator = function () {
        return new SortedSetIterator(this.data.getIterator());
    };
    SortedSet.prototype.getIteratorFrom = function (key) {
        return new SortedSetIterator(this.data.getIteratorFrom(key));
    };
    /** Inserts or updates an element */
    SortedSet.prototype.add = function (elem) {
        return this.copy(this.data.remove(elem).insert(elem, true));
    };
    /** Deletes an element */
    SortedSet.prototype.delete = function (elem) {
        if (!this.has(elem))
            return this;
        return this.copy(this.data.remove(elem));
    };
    SortedSet.prototype.isEmpty = function () {
        return this.data.isEmpty();
    };
    SortedSet.prototype.unionWith = function (other) {
        var result = this;
        other.forEach(function (elem) {
            result = result.add(elem);
        });
        return result;
    };
    SortedSet.prototype.isEqual = function (other) {
        if (!(other instanceof SortedSet))
            return false;
        if (this.size !== other.size)
            return false;
        var thisIt = this.data.getIterator();
        var otherIt = other.data.getIterator();
        while (thisIt.hasNext()) {
            var thisElem = thisIt.getNext().key;
            var otherElem = otherIt.getNext().key;
            if (this.comparator(thisElem, otherElem) !== 0)
                return false;
        }
        return true;
    };
    SortedSet.prototype.toArray = function () {
        var res = [];
        this.forEach(function (targetId) {
            res.push(targetId);
        });
        return res;
    };
    SortedSet.prototype.toString = function () {
        var result = [];
        this.forEach(function (elem) { return result.push(elem); });
        return 'SortedSet(' + result.toString() + ')';
    };
    SortedSet.prototype.copy = function (data) {
        var result = new SortedSet(this.comparator);
        result.data = data;
        return result;
    };
    return SortedSet;
}());
var SortedSetIterator = /** @class */ (function () {
    function SortedSetIterator(iter) {
        this.iter = iter;
    }
    SortedSetIterator.prototype.getNext = function () {
        return this.iter.getNext().key;
    };
    SortedSetIterator.prototype.hasNext = function () {
        return this.iter.hasNext();
    };
    return SortedSetIterator;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */
var FieldMask = /** @class */ (function () {
    function FieldMask(fields) {
        this.fields = fields;
        // TODO(dimond): validation of FieldMask
    }
    FieldMask.fromSet = function (fields) {
        return new FieldMask(fields);
    };
    FieldMask.fromArray = function (fields) {
        var fieldsAsSet = new SortedSet(FieldPath.comparator);
        fields.forEach(function (fieldPath) { return (fieldsAsSet = fieldsAsSet.add(fieldPath)); });
        return new FieldMask(fieldsAsSet);
    };
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */
    FieldMask.prototype.covers = function (fieldPath) {
        var found = false;
        this.fields.forEach(function (fieldMaskPath) {
            if (fieldMaskPath.isPrefixOf(fieldPath)) {
                found = true;
            }
        });
        return found;
    };
    FieldMask.prototype.isEqual = function (other) {
        return this.fields.isEqual(other.fields);
    };
    return FieldMask;
}());
/** A field path and the TransformOperation to perform upon it. */
var FieldTransform = /** @class */ (function () {
    function FieldTransform(field, transform) {
        this.field = field;
        this.transform = transform;
    }
    FieldTransform.prototype.isEqual = function (other) {
        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
    };
    return FieldTransform;
}());
/** The result of successfully applying a mutation to the backend. */
var MutationResult = /** @class */ (function () {
    function MutationResult(
    /**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */
    version, 
    /**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */
    transformResults) {
        this.version = version;
        this.transformResults = transformResults;
    }
    return MutationResult;
}());
var MutationType;
(function (MutationType) {
    MutationType[MutationType["Set"] = 0] = "Set";
    MutationType[MutationType["Patch"] = 1] = "Patch";
    MutationType[MutationType["Transform"] = 2] = "Transform";
    MutationType[MutationType["Delete"] = 3] = "Delete";
})(MutationType || (MutationType = {}));
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */
var Precondition = /** @class */ (function () {
    function Precondition(updateTime, exists) {
        this.updateTime = updateTime;
        this.exists = exists;
        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
    }
    /** Creates a new Precondition with an exists flag. */
    Precondition.exists = function (exists) {
        return new Precondition(undefined, exists);
    };
    /** Creates a new Precondition based on a version a document exists at. */
    Precondition.updateTime = function (version) {
        return new Precondition(version);
    };
    Object.defineProperty(Precondition.prototype, "isNone", {
        /** Returns whether this Precondition is empty. */
        get: function () {
            return this.updateTime === undefined && this.exists === undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */
    Precondition.prototype.isValidFor = function (maybeDoc) {
        if (this.updateTime !== undefined) {
            return (maybeDoc instanceof Document &&
                maybeDoc.version.isEqual(this.updateTime));
        }
        else if (this.exists !== undefined) {
            return this.exists === maybeDoc instanceof Document;
        }
        else {
            assert(this.isNone, 'Precondition should be empty');
            return true;
        }
    };
    Precondition.prototype.isEqual = function (other) {
        return (equals(this.updateTime, other.updateTime) &&
            this.exists === other.exists);
    };
    Precondition.NONE = new Precondition();
    return Precondition;
}());
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also it version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set, Patch, and Transform mutations. For Delete
 * mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set, Patch, and Transform mutations. As deletes
 * have no explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we return an `UnknownDocument` and rely on Watch to send us the
 * updated version.
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */
var Mutation = /** @class */ (function () {
    function Mutation() {
    }
    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
        if (maybeDoc != null) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
        }
    };
    /**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.MIN.
     */
    Mutation.getPostMutationVersion = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            return maybeDoc.version;
        }
        else {
            return SnapshotVersion.MIN;
        }
    };
    return Mutation;
}());
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */
var SetMutation = /** @class */ (function (_super) {
    tslib_1.__extends(SetMutation, _super);
    function SetMutation(key, value, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.value = value;
        _this.precondition = precondition;
        _this.type = MutationType.Set;
        return _this;
    }
    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        var version = mutationResult.version;
        return new Document(this.key, version, this.value, {
            hasCommittedMutations: true
        });
    };
    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        return new Document(this.key, version, this.value, {
            hasLocalMutations: true
        });
    };
    SetMutation.prototype.isEqual = function (other) {
        return (other instanceof SetMutation &&
            this.key.isEqual(other.key) &&
            this.value.isEqual(other.value) &&
            this.precondition.isEqual(other.precondition));
    };
    return SetMutation;
}(Mutation));
/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */
var PatchMutation = /** @class */ (function (_super) {
    tslib_1.__extends(PatchMutation, _super);
    function PatchMutation(key, data, fieldMask, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.data = data;
        _this.fieldMask = fieldMask;
        _this.precondition = precondition;
        _this.type = MutationType.Patch;
        return _this;
    }
    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, mutationResult.version, newData, {
            hasCommittedMutations: true
        });
    };
    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, version, newData, {
            hasLocalMutations: true
        });
    };
    PatchMutation.prototype.isEqual = function (other) {
        return (other instanceof PatchMutation &&
            this.key.isEqual(other.key) &&
            this.fieldMask.isEqual(other.fieldMask) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */
    PatchMutation.prototype.patchDocument = function (maybeDoc) {
        var data;
        if (maybeDoc instanceof Document) {
            data = maybeDoc.data;
        }
        else {
            data = ObjectValue.EMPTY;
        }
        return this.patchObject(data);
    };
    PatchMutation.prototype.patchObject = function (data) {
        var _this = this;
        this.fieldMask.fields.forEach(function (fieldPath) {
            if (!fieldPath.isEmpty()) {
                var newValue = _this.data.field(fieldPath);
                if (newValue !== undefined) {
                    data = data.set(fieldPath, newValue);
                }
                else {
                    data = data.delete(fieldPath);
                }
            }
        });
        return data;
    };
    return PatchMutation;
}(Mutation));
/**
 * A mutation that modifies specific fields of the document with transform
 * operations. Currently the only supported transform is a server timestamp, but
 * IP Address, increment(n), etc. could be supported in the future.
 *
 * It is somewhat similar to a PatchMutation in that it patches specific fields
 * and has no effect when applied to a null or NoDocument (see comment on
 * Mutation for rationale).
 */
var TransformMutation = /** @class */ (function (_super) {
    tslib_1.__extends(TransformMutation, _super);
    function TransformMutation(key, fieldTransforms) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.fieldTransforms = fieldTransforms;
        _this.type = MutationType.Transform;
        // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        _this.precondition = Precondition.exists(true);
        return _this;
    }
    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.serverTransformResults(maybeDoc, mutationResult.transformResults);
        var version = mutationResult.version;
        var newData = this.transformObject(doc.data, transformResults);
        return new Document(this.key, version, newData, {
            hasCommittedMutations: true
        });
    };
    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.localTransformResults(localWriteTime, baseDoc);
        var newData = this.transformObject(doc.data, transformResults);
        return new Document(this.key, doc.version, newData, {
            hasLocalMutations: true
        });
    };
    TransformMutation.prototype.isEqual = function (other) {
        return (other instanceof TransformMutation &&
            this.key.isEqual(other.key) &&
            arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */
    TransformMutation.prototype.requireDocument = function (maybeDoc) {
        assert(maybeDoc instanceof Document, 'Unknown MaybeDocument type ' + maybeDoc);
        var doc = maybeDoc;
        assert(doc.key.isEqual(this.key), 'Can only transform a document with the same key');
        return doc;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use after a
     * TransformMutation has been acknowledged by the server.
     *
     * @param baseDoc The document prior to applying this mutation batch.
     * @param serverTransformResults The transform results received by the server.
     * @return The transform results list.
     */
    TransformMutation.prototype.serverTransformResults = function (baseDoc, serverTransformResults) {
        var transformResults = [];
        assert(this.fieldTransforms.length === serverTransformResults.length, "server transform result count (" + serverTransformResults.length + ") " +
            ("should match field transform count (" + this.fieldTransforms.length + ")"));
        for (var i = 0; i < serverTransformResults.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field) || null;
            }
            transformResults.push(transform.applyToRemoteDocument(previousValue, serverTransformResults[i]));
        }
        return transformResults;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @param baseDoc The document prior to applying this mutation batch.
     * @return The transform results list.
     */
    TransformMutation.prototype.localTransformResults = function (localWriteTime, baseDoc) {
        var transformResults = [];
        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
            var fieldTransform = _a[_i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field) || null;
            }
            transformResults.push(transform.applyToLocalView(previousValue, localWriteTime));
        }
        return transformResults;
    };
    TransformMutation.prototype.transformObject = function (data, transformResults) {
        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
        for (var i = 0; i < this.fieldTransforms.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var fieldPath = fieldTransform.field;
            data = data.set(fieldPath, transformResults[i]);
        }
        return data;
    };
    return TransformMutation;
}(Mutation));
/** A mutation that deletes the document at the given key. */
var DeleteMutation = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteMutation, _super);
    function DeleteMutation(key, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.precondition = precondition;
        _this.type = MutationType.Delete;
        return _this;
    }
    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return new NoDocument(this.key, mutationResult.version, {
            hasCommittedMutations: true
        });
    };
    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
        }
        return new NoDocument(this.key, SnapshotVersion.forDeletedDoc());
    };
    DeleteMutation.prototype.isEqual = function (other) {
        return (other instanceof DeleteMutation &&
            this.key.isEqual(other.key) &&
            this.precondition.isEqual(other.precondition));
    };
    return DeleteMutation;
}(Mutation));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Transforms a value into a server-generated timestamp. */
var ServerTimestampTransform = /** @class */ (function () {
    function ServerTimestampTransform() {
    }
    ServerTimestampTransform.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return new ServerTimestampValue(localWriteTime, previousValue);
    };
    ServerTimestampTransform.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        return transformResult;
    };
    ServerTimestampTransform.prototype.isEqual = function (other) {
        return other instanceof ServerTimestampTransform;
    };
    ServerTimestampTransform.instance = new ServerTimestampTransform();
    return ServerTimestampTransform;
}());
/** Transforms an array value via a union operation. */
var ArrayUnionTransformOperation = /** @class */ (function () {
    function ArrayUnionTransformOperation(elements) {
        this.elements = elements;
    }
    ArrayUnionTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_1 = function (toUnion) {
            if (!result.find(function (element) { return element.isEqual(toUnion); })) {
                result.push(toUnion);
            }
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toUnion = _a[_i];
            _loop_1(toUnion);
        }
        return new ArrayValue(result);
    };
    ArrayUnionTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayUnionTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayUnionTransformOperation;
}());
/** Transforms an array value via a remove operation. */
var ArrayRemoveTransformOperation = /** @class */ (function () {
    function ArrayRemoveTransformOperation(elements) {
        this.elements = elements;
    }
    ArrayRemoveTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_2 = function (toRemove) {
            result = result.filter(function (element) { return !element.isEqual(toRemove); });
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toRemove = _a[_i];
            _loop_2(toRemove);
        }
        return new ArrayValue(result);
    };
    ArrayRemoveTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayRemoveTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayRemoveTransformOperation;
}());
function coercedFieldValuesArray(value) {
    if (value instanceof ArrayValue) {
        return value.internalValue.slice();
    }
    else {
        // coerce to empty array.
        return [];
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistenceFilter = /** @class */ (function () {
    // TODO(b/33078163): just use simplest form of existence filter for now
    function ExistenceFilter(count) {
        this.count = count;
    }
    ExistenceFilter.prototype.isEqual = function (other) {
        return other && other.count === this.count;
    };
    return ExistenceFilter;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers.
 */
var RpcCode;
(function (RpcCode) {
    RpcCode[RpcCode["OK"] = 0] = "OK";
    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
})(RpcCode || (RpcCode = {}));
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */
function isPermanentError(code) {
    switch (code) {
        case Code.OK:
            return fail('Treated status OK as error');
        case Code.CANCELLED:
        case Code.UNKNOWN:
        case Code.DEADLINE_EXCEEDED:
        case Code.RESOURCE_EXHAUSTED:
        case Code.INTERNAL:
        case Code.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case Code.UNAUTHENTICATED:
            return false;
        case Code.INVALID_ARGUMENT:
        case Code.NOT_FOUND:
        case Code.ALREADY_EXISTS:
        case Code.PERMISSION_DENIED:
        case Code.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case Code.ABORTED:
        case Code.OUT_OF_RANGE:
        case Code.UNIMPLEMENTED:
        case Code.DATA_LOSS:
            return true;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */
function isPermanentWriteError(code) {
    return isPermanentError(code) && code !== Code.ABORTED;
}
/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */
function mapCodeFromRpcStatus(status) {
    // tslint:disable-next-line:no-any lookup by string
    var code = RpcCode[status];
    if (code === undefined) {
        return undefined;
    }
    return mapCodeFromRpcCode(code);
}
/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */
function mapCodeFromRpcCode(code) {
    if (code === undefined) {
        // This shouldn't normally happen, but in certain error cases (like trying
        // to send invalid proto messages) we may get an error with no GRPC code.
        error('GRPC error has no .code');
        return Code.UNKNOWN;
    }
    switch (code) {
        case RpcCode.OK:
            return Code.OK;
        case RpcCode.CANCELLED:
            return Code.CANCELLED;
        case RpcCode.UNKNOWN:
            return Code.UNKNOWN;
        case RpcCode.DEADLINE_EXCEEDED:
            return Code.DEADLINE_EXCEEDED;
        case RpcCode.RESOURCE_EXHAUSTED:
            return Code.RESOURCE_EXHAUSTED;
        case RpcCode.INTERNAL:
            return Code.INTERNAL;
        case RpcCode.UNAVAILABLE:
            return Code.UNAVAILABLE;
        case RpcCode.UNAUTHENTICATED:
            return Code.UNAUTHENTICATED;
        case RpcCode.INVALID_ARGUMENT:
            return Code.INVALID_ARGUMENT;
        case RpcCode.NOT_FOUND:
            return Code.NOT_FOUND;
        case RpcCode.ALREADY_EXISTS:
            return Code.ALREADY_EXISTS;
        case RpcCode.PERMISSION_DENIED:
            return Code.PERMISSION_DENIED;
        case RpcCode.FAILED_PRECONDITION:
            return Code.FAILED_PRECONDITION;
        case RpcCode.ABORTED:
            return Code.ABORTED;
        case RpcCode.OUT_OF_RANGE:
            return Code.OUT_OF_RANGE;
        case RpcCode.UNIMPLEMENTED:
            return Code.UNIMPLEMENTED;
        case RpcCode.DATA_LOSS:
            return Code.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Maps an RPC code from a Code. This is the reverse operation from
 * mapCodeFromRpcCode and should really only be used in tests.
 */
function mapRpcCodeFromCode(code) {
    if (code === undefined) {
        return RpcCode.OK;
    }
    switch (code) {
        case Code.OK:
            return RpcCode.OK;
        case Code.CANCELLED:
            return RpcCode.CANCELLED;
        case Code.UNKNOWN:
            return RpcCode.UNKNOWN;
        case Code.DEADLINE_EXCEEDED:
            return RpcCode.DEADLINE_EXCEEDED;
        case Code.RESOURCE_EXHAUSTED:
            return RpcCode.RESOURCE_EXHAUSTED;
        case Code.INTERNAL:
            return RpcCode.INTERNAL;
        case Code.UNAVAILABLE:
            return RpcCode.UNAVAILABLE;
        case Code.UNAUTHENTICATED:
            return RpcCode.UNAUTHENTICATED;
        case Code.INVALID_ARGUMENT:
            return RpcCode.INVALID_ARGUMENT;
        case Code.NOT_FOUND:
            return RpcCode.NOT_FOUND;
        case Code.ALREADY_EXISTS:
            return RpcCode.ALREADY_EXISTS;
        case Code.PERMISSION_DENIED:
            return RpcCode.PERMISSION_DENIED;
        case Code.FAILED_PRECONDITION:
            return RpcCode.FAILED_PRECONDITION;
        case Code.ABORTED:
            return RpcCode.ABORTED;
        case Code.OUT_OF_RANGE:
            return RpcCode.OUT_OF_RANGE;
        case Code.UNIMPLEMENTED:
            return RpcCode.UNIMPLEMENTED;
        case Code.DATA_LOSS:
            return RpcCode.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Converts an HTTP Status Code to the equivalent error code.
 *
 * @param status An HTTP Status Code, like 200, 404, 503, etc.
 * @returns The equivalent Code. Unknown status codes are mapped to
 *     Code.UNKNOWN.
 */
function mapCodeFromHttpStatus(status) {
    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
    // status codes but the mapping is not bijective. In each case of ambiguity
    // this function chooses a primary error.
    //
    // [1]
    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
    switch (status) {
        case 200: // OK
            return Code.OK;
        case 400: // Bad Request
            return Code.INVALID_ARGUMENT;
        // Other possibilities based on the forward mapping
        // return Code.FAILED_PRECONDITION;
        // return Code.OUT_OF_RANGE;
        case 401: // Unauthorized
            return Code.UNAUTHENTICATED;
        case 403: // Forbidden
            return Code.PERMISSION_DENIED;
        case 404: // Not Found
            return Code.NOT_FOUND;
        case 409: // Conflict
            return Code.ABORTED;
        // Other possibilities:
        // return Code.ALREADY_EXISTS;
        case 416: // Range Not Satisfiable
            return Code.OUT_OF_RANGE;
        case 429: // Too Many Requests
            return Code.RESOURCE_EXHAUSTED;
        case 499: // Client Closed Request
            return Code.CANCELLED;
        case 500: // Internal Server Error
            return Code.UNKNOWN;
        // Other possibilities:
        // return Code.INTERNAL;
        // return Code.DATA_LOSS;
        case 501: // Unimplemented
            return Code.UNIMPLEMENTED;
        case 503: // Service Unavailable
            return Code.UNAVAILABLE;
        case 504: // Gateway Timeout
            return Code.DEADLINE_EXCEEDED;
        default:
            if (status >= 200 && status < 300)
                return Code.OK;
            if (status >= 400 && status < 500)
                return Code.FAILED_PRECONDITION;
            if (status >= 500 && status < 600)
                return Code.INTERNAL;
            return Code.UNKNOWN;
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EMPTY_MAYBE_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function maybeDocumentMap() {
    return EMPTY_MAYBE_DOCUMENT_MAP;
}
function nullableMaybeDocumentMap() {
    return maybeDocumentMap();
}
var EMPTY_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function documentMap() {
    return EMPTY_DOCUMENT_MAP;
}
var EMPTY_DOCUMENT_VERSION_MAP = new SortedMap(DocumentKey.comparator);
function documentVersionMap() {
    return EMPTY_DOCUMENT_VERSION_MAP;
}
var EMPTY_DOCUMENT_KEY_SET = new SortedSet(DocumentKey.comparator);
function documentKeySet() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    var set = EMPTY_DOCUMENT_KEY_SET;
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        set = set.add(key);
    }
    return set;
}
var EMPTY_TARGET_ID_SET = new SortedSet(primitiveComparator);
function targetIdSet() {
    return EMPTY_TARGET_ID_SET;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */
var DocumentSet = /** @class */ (function () {
    /** The default ordering is by key if the comparator is omitted */
    function DocumentSet(comp) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        if (comp) {
            this.comparator = function (d1, d2) {
                return comp(d1, d2) || DocumentKey.comparator(d1.key, d2.key);
            };
        }
        else {
            this.comparator = function (d1, d2) {
                return DocumentKey.comparator(d1.key, d2.key);
            };
        }
        this.keyedMap = documentMap();
        this.sortedSet = new SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */
    DocumentSet.emptySet = function (oldSet) {
        return new DocumentSet(oldSet.comparator);
    };
    DocumentSet.prototype.has = function (key) {
        return this.keyedMap.get(key) != null;
    };
    DocumentSet.prototype.get = function (key) {
        return this.keyedMap.get(key);
    };
    DocumentSet.prototype.first = function () {
        return this.sortedSet.minKey();
    };
    DocumentSet.prototype.last = function () {
        return this.sortedSet.maxKey();
    };
    DocumentSet.prototype.isEmpty = function () {
        return this.sortedSet.isEmpty();
    };
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */
    DocumentSet.prototype.indexOf = function (key) {
        var doc = this.keyedMap.get(key);
        return doc ? this.sortedSet.indexOf(doc) : -1;
    };
    Object.defineProperty(DocumentSet.prototype, "size", {
        get: function () {
            return this.sortedSet.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Iterates documents in order defined by "comparator" */
    DocumentSet.prototype.forEach = function (cb) {
        this.sortedSet.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Inserts or updates a document with the same key */
    DocumentSet.prototype.add = function (doc) {
        // First remove the element if we have it.
        var set = this.delete(doc.key);
        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
    };
    /** Deletes a document with a given key */
    DocumentSet.prototype.delete = function (key) {
        var doc = this.get(key);
        if (!doc) {
            return this;
        }
        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
    };
    DocumentSet.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSet))
            return false;
        if (this.size !== other.size)
            return false;
        var thisIt = this.sortedSet.getIterator();
        var otherIt = other.sortedSet.getIterator();
        while (thisIt.hasNext()) {
            var thisDoc = thisIt.getNext().key;
            var otherDoc = otherIt.getNext().key;
            if (!thisDoc.isEqual(otherDoc))
                return false;
        }
        return true;
    };
    DocumentSet.prototype.toString = function () {
        var docStrings = [];
        this.forEach(function (doc) {
            docStrings.push(doc.toString());
        });
        if (docStrings.length === 0) {
            return 'DocumentSet ()';
        }
        else {
            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
        }
    };
    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
        var newSet = new DocumentSet();
        newSet.comparator = this.comparator;
        newSet.keyedMap = keyedMap;
        newSet.sortedSet = sortedSet;
        return newSet;
    };
    return DocumentSet;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Added"] = 0] = "Added";
    ChangeType[ChangeType["Removed"] = 1] = "Removed";
    ChangeType[ChangeType["Modified"] = 2] = "Modified";
    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
})(ChangeType || (ChangeType = {}));
var SyncState;
(function (SyncState) {
    SyncState[SyncState["Local"] = 0] = "Local";
    SyncState[SyncState["Synced"] = 1] = "Synced";
})(SyncState || (SyncState = {}));
/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */
var DocumentChangeSet = /** @class */ (function () {
    function DocumentChangeSet() {
        this.changeMap = new SortedMap(DocumentKey.comparator);
    }
    DocumentChangeSet.prototype.track = function (change) {
        var key = change.doc.key;
        var oldChange = this.changeMap.get(key);
        if (!oldChange) {
            this.changeMap = this.changeMap.insert(key, change);
            return;
        }
        // Merge the new change with the existing change.
        if (change.type !== ChangeType.Added &&
            oldChange.type === ChangeType.Metadata) {
            this.changeMap = this.changeMap.insert(key, change);
        }
        else if (change.type === ChangeType.Metadata &&
            oldChange.type !== ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: oldChange.type,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Added,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.remove(key);
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Removed,
                doc: oldChange.doc
            });
        }
        else if (change.type === ChangeType.Added &&
            oldChange.type === ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else {
            // This includes these cases, which don't make sense:
            // Added->Added
            // Removed->Removed
            // Modified->Added
            // Removed->Modified
            // Metadata->Added
            // Removed->Metadata
            fail('unsupported combination of changes: ' +
                JSON.stringify(change) +
                ' after ' +
                JSON.stringify(oldChange));
        }
    };
    DocumentChangeSet.prototype.getChanges = function () {
        var changes = [];
        this.changeMap.inorderTraversal(function (key, change) {
            changes.push(change);
        });
        return changes;
    };
    return DocumentChangeSet;
}());
var ViewSnapshot = /** @class */ (function () {
    function ViewSnapshot(query, docs, oldDocs, docChanges, mutatedKeys, fromCache, syncStateChanged, excludesMetadataChanges) {
        this.query = query;
        this.docs = docs;
        this.oldDocs = oldDocs;
        this.docChanges = docChanges;
        this.mutatedKeys = mutatedKeys;
        this.fromCache = fromCache;
        this.syncStateChanged = syncStateChanged;
        this.excludesMetadataChanges = excludesMetadataChanges;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */
    ViewSnapshot.fromInitialDocuments = function (query, documents, mutatedKeys, fromCache) {
        var changes = [];
        documents.forEach(function (doc) {
            changes.push({ type: ChangeType.Added, doc: doc });
        });
        return new ViewSnapshot(query, documents, DocumentSet.emptySet(documents), changes, mutatedKeys, fromCache, true, false);
    };
    Object.defineProperty(ViewSnapshot.prototype, "hasPendingWrites", {
        get: function () {
            return !this.mutatedKeys.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    ViewSnapshot.prototype.isEqual = function (other) {
        if (this.fromCache !== other.fromCache ||
            this.syncStateChanged !== other.syncStateChanged ||
            !this.mutatedKeys.isEqual(other.mutatedKeys) ||
            !this.query.isEqual(other.query) ||
            !this.docs.isEqual(other.docs) ||
            !this.oldDocs.isEqual(other.oldDocs)) {
            return false;
        }
        var changes = this.docChanges;
        var otherChanges = other.docChanges;
        if (changes.length !== otherChanges.length) {
            return false;
        }
        for (var i = 0; i < changes.length; i++) {
            if (changes[i].type !== otherChanges[i].type ||
                !changes[i].doc.isEqual(otherChanges[i].doc)) {
                return false;
            }
        }
        return true;
    };
    return ViewSnapshot;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */
var RemoteEvent = /** @class */ (function () {
    function RemoteEvent(
    /**
     * The snapshot version this event brings us up to, or MIN if not set.
     */
    snapshotVersion, 
    /**
     * A map from target to changes to the target. See TargetChange.
     */
    targetChanges, 
    /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */
    targetMismatches, 
    /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */
    documentUpdates, 
    /**
     * A set of which document updates are due only to limbo resolution targets.
     */
    resolvedLimboDocuments) {
        this.snapshotVersion = snapshotVersion;
        this.targetChanges = targetChanges;
        this.targetMismatches = targetMismatches;
        this.documentUpdates = documentUpdates;
        this.resolvedLimboDocuments = resolvedLimboDocuments;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    RemoteEvent.createSynthesizedRemoteEventForCurrentChange = function (targetId, current) {
        var targetChanges = (_a = {}, _a[targetId] = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current), _a);
        return new RemoteEvent(SnapshotVersion.MIN, targetChanges, targetIdSet(), maybeDocumentMap(), documentKeySet());
        var _a;
    };
    return RemoteEvent;
}());
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */
var TargetChange = /** @class */ (function () {
    function TargetChange(
    /**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */
    resumeToken, 
    /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */
    current, 
    /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */
    addedDocuments, 
    /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */
    modifiedDocuments, 
    /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */
    removedDocuments) {
        this.resumeToken = resumeToken;
        this.current = current;
        this.addedDocuments = addedDocuments;
        this.modifiedDocuments = modifiedDocuments;
        this.removedDocuments = removedDocuments;
    }
    /**
     * HACK: Views require TargetChanges in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized TargetChanges that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    TargetChange.createSynthesizedTargetChangeForCurrentChange = function (targetId, current) {
        return new TargetChange(emptyByteString(), current, documentKeySet(), documentKeySet(), documentKeySet());
    };
    return TargetChange;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */
var DocumentWatchChange = /** @class */ (function () {
    function DocumentWatchChange(
    /** The new document applies to all of these targets. */
    updatedTargetIds, 
    /** The new document is removed from all of these targets. */
    removedTargetIds, 
    /** The key of the document for this change. */
    key, 
    /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */
    newDoc) {
        this.updatedTargetIds = updatedTargetIds;
        this.removedTargetIds = removedTargetIds;
        this.key = key;
        this.newDoc = newDoc;
    }
    return DocumentWatchChange;
}());
var ExistenceFilterChange = /** @class */ (function () {
    function ExistenceFilterChange(targetId, existenceFilter) {
        this.targetId = targetId;
        this.existenceFilter = existenceFilter;
    }
    return ExistenceFilterChange;
}());
var WatchTargetChangeState;
(function (WatchTargetChangeState) {
    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
})(WatchTargetChangeState || (WatchTargetChangeState = {}));
var WatchTargetChange = /** @class */ (function () {
    function WatchTargetChange(
    /** What kind of change occurred to the watch target. */
    state, 
    /** The target IDs that were added/removed/set. */
    targetIds, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken, 
    /** An RPC error indicating why the watch failed. */
    cause) {
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        if (cause === void 0) { cause = null; }
        this.state = state;
        this.targetIds = targetIds;
        this.resumeToken = resumeToken;
        this.cause = cause;
    }
    return WatchTargetChange;
}());
/** Tracks the internal state of a Watch target. */
var TargetState = /** @class */ (function () {
    function TargetState() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */
        this.pendingResponses = 0;
        /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */
        this.documentChanges = snapshotChangesMap();
        /** See public getters for explanations of these fields. */
        this._resumeToken = emptyByteString();
        this._current = false;
        /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */
        this._hasPendingChanges = true;
    }
    Object.defineProperty(TargetState.prototype, "current", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */
        get: function () {
            return this._current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */
        get: function () {
            return this._resumeToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "isPending", {
        /** Whether this target has pending target adds or target removes. */
        get: function () {
            return this.pendingResponses !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "hasPendingChanges", {
        /** Whether we have modified any state that should trigger a snapshot. */
        get: function () {
            return this._hasPendingChanges;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */
    TargetState.prototype.updateResumeToken = function (resumeToken) {
        if (resumeToken.length > 0) {
            this._hasPendingChanges = true;
            this._resumeToken = resumeToken;
        }
    };
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */
    TargetState.prototype.toTargetChange = function () {
        var addedDocuments = documentKeySet();
        var modifiedDocuments = documentKeySet();
        var removedDocuments = documentKeySet();
        this.documentChanges.forEach(function (key, changeType) {
            switch (changeType) {
                case ChangeType.Added:
                    addedDocuments = addedDocuments.add(key);
                    break;
                case ChangeType.Modified:
                    modifiedDocuments = modifiedDocuments.add(key);
                    break;
                case ChangeType.Removed:
                    removedDocuments = removedDocuments.add(key);
                    break;
                default:
                    fail('Encountered invalid change type: ' + changeType);
            }
        });
        return new TargetChange(this._resumeToken, this._current, addedDocuments, modifiedDocuments, removedDocuments);
    };
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */
    TargetState.prototype.clearPendingChanges = function () {
        this._hasPendingChanges = false;
        this.documentChanges = snapshotChangesMap();
    };
    TargetState.prototype.addDocumentChange = function (key, changeType) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.insert(key, changeType);
    };
    TargetState.prototype.removeDocumentChange = function (key) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.remove(key);
    };
    TargetState.prototype.recordPendingTargetRequest = function () {
        this.pendingResponses += 1;
    };
    TargetState.prototype.recordTargetResponse = function () {
        this.pendingResponses -= 1;
    };
    TargetState.prototype.markCurrent = function () {
        this._hasPendingChanges = true;
        this._current = true;
    };
    return TargetState;
}());
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */
var WatchChangeAggregator = /** @class */ (function () {
    function WatchChangeAggregator(metadataProvider) {
        this.metadataProvider = metadataProvider;
        /** The internal state of all tracked targets. */
        this.targetStates = {};
        /** Keeps track of the documents to update since the last raised snapshot. */
        this.pendingDocumentUpdates = maybeDocumentMap();
        /** A mapping of document keys to their set of target IDs. */
        this.pendingDocumentTargetMapping = documentTargetMap();
        /**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */
        this.pendingTargetResets = new SortedSet(primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */
    WatchChangeAggregator.prototype.handleDocumentChange = function (docChange) {
        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
            var targetId = _a[_i];
            if (docChange.newDoc instanceof Document) {
                this.addDocumentToTarget(targetId, docChange.newDoc);
            }
            else if (docChange.newDoc instanceof NoDocument) {
                this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
            }
        }
        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
            var targetId = _c[_b];
            this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
        }
    };
    /** Processes and adds the WatchTargetChange to the current set of changes. */
    WatchChangeAggregator.prototype.handleTargetChange = function (targetChange) {
        var _this = this;
        this.forEachTarget(targetChange, function (targetId) {
            var targetState = _this.ensureTargetState(targetId);
            switch (targetChange.state) {
                case WatchTargetChangeState.NoChange:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Added:
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        // We have a freshly added target, so we need to reset any state
                        // that we had previously. This can happen e.g. when remove and add
                        // back a target for existence filter mismatches.
                        targetState.clearPendingChanges();
                    }
                    targetState.updateResumeToken(targetChange.resumeToken);
                    break;
                case WatchTargetChangeState.Removed:
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        _this.removeTarget(targetId);
                    }
                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
                    break;
                case WatchTargetChangeState.Current:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.markCurrent();
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Reset:
                    if (_this.isActiveTarget(targetId)) {
                        // Reset the target and synthesizes removes for all existing
                        // documents. The backend will re-add any documents that still
                        // match the target before it sends the next global snapshot.
                        _this.resetTarget(targetId);
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                default:
                    fail('Unknown target watch change state: ' + targetChange.state);
            }
        });
    };
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */
    WatchChangeAggregator.prototype.forEachTarget = function (targetChange, fn) {
        if (targetChange.targetIds.length > 0) {
            targetChange.targetIds.forEach(fn);
        }
        else {
            forEachNumber(this.targetStates, fn);
        }
    };
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */
    WatchChangeAggregator.prototype.handleExistenceFilter = function (watchChange) {
        var targetId = watchChange.targetId;
        var expectedCount = watchChange.existenceFilter.count;
        var queryData = this.queryDataForActiveTarget(targetId);
        if (queryData) {
            var query = queryData.query;
            if (query.isDocumentQuery()) {
                if (expectedCount === 0) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var key = new DocumentKey(query.path);
                    this.removeDocumentFromTarget(targetId, key, new NoDocument(key, SnapshotVersion.forDeletedDoc()));
                }
                else {
                    assert(expectedCount === 1, 'Single document existence filter with count: ' + expectedCount);
                }
            }
            else {
                var currentSize = this.getCurrentDocumentCountForTarget(targetId);
                if (currentSize !== expectedCount) {
                    // Existence filter mismatch: We reset the mapping and raise a new
                    // snapshot with `isFromCache:true`.
                    this.resetTarget(targetId);
                    this.pendingTargetResets = this.pendingTargetResets.add(targetId);
                }
            }
        }
    };
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */
    WatchChangeAggregator.prototype.createRemoteEvent = function (snapshotVersion) {
        var _this = this;
        var targetChanges = {};
        forEachNumber(this.targetStates, function (targetId, targetState) {
            var queryData = _this.queryDataForActiveTarget(targetId);
            if (queryData) {
                if (targetState.current && queryData.query.isDocumentQuery()) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    //
                    // TODO(dimond): Ideally we would have an explicit lookup query
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var key = new DocumentKey(queryData.query.path);
                    if (_this.pendingDocumentUpdates.get(key) === null &&
                        !_this.targetContainsDocument(targetId, key)) {
                        _this.removeDocumentFromTarget(targetId, key, new NoDocument(key, snapshotVersion));
                    }
                }
                if (targetState.hasPendingChanges) {
                    targetChanges[targetId] = targetState.toTargetChange();
                    targetState.clearPendingChanges();
                }
            }
        });
        var resolvedLimboDocuments = documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the query cache.
        //
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.pendingDocumentTargetMapping.forEach(function (key, targets) {
            var isOnlyLimboTarget = true;
            targets.forEachWhile(function (targetId) {
                var queryData = _this.queryDataForActiveTarget(targetId);
                if (queryData && queryData.purpose !== QueryPurpose.LimboResolution) {
                    isOnlyLimboTarget = false;
                    return false;
                }
                return true;
            });
            if (isOnlyLimboTarget) {
                resolvedLimboDocuments = resolvedLimboDocuments.add(key);
            }
        });
        var remoteEvent = new RemoteEvent(snapshotVersion, targetChanges, this.pendingTargetResets, this.pendingDocumentUpdates, resolvedLimboDocuments);
        this.pendingDocumentUpdates = maybeDocumentMap();
        this.pendingDocumentTargetMapping = documentTargetMap();
        this.pendingTargetResets = new SortedSet(primitiveComparator);
        return remoteEvent;
    };
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.addDocumentToTarget = function (targetId, document) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var changeType = this.targetContainsDocument(targetId, document.key)
            ? ChangeType.Modified
            : ChangeType.Added;
        var targetState = this.ensureTargetState(targetId);
        targetState.addDocumentChange(document.key, changeType);
        this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(document.key, document);
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(document.key, this.ensureDocumentTargetMapping(document.key).add(targetId));
    };
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.removeDocumentFromTarget = function (targetId, key, updatedDocument) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var targetState = this.ensureTargetState(targetId);
        if (this.targetContainsDocument(targetId, key)) {
            targetState.addDocumentChange(key, ChangeType.Removed);
        }
        else {
            // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            targetState.removeDocumentChange(key);
        }
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, this.ensureDocumentTargetMapping(key).delete(targetId));
        if (updatedDocument) {
            this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(key, updatedDocument);
        }
    };
    WatchChangeAggregator.prototype.removeTarget = function (targetId) {
        delete this.targetStates[targetId];
    };
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */
    WatchChangeAggregator.prototype.getCurrentDocumentCountForTarget = function (targetId) {
        var targetState = this.ensureTargetState(targetId);
        var targetChange = targetState.toTargetChange();
        return (this.metadataProvider.getRemoteKeysForTarget(targetId).size +
            targetChange.addedDocuments.size -
            targetChange.removedDocuments.size);
    };
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */
    WatchChangeAggregator.prototype.recordPendingTargetRequest = function (targetId) {
        // For each request we get we need to record we need a response for it.
        var targetState = this.ensureTargetState(targetId);
        targetState.recordPendingTargetRequest();
    };
    WatchChangeAggregator.prototype.ensureTargetState = function (targetId) {
        if (!this.targetStates[targetId]) {
            this.targetStates[targetId] = new TargetState();
        }
        return this.targetStates[targetId];
    };
    WatchChangeAggregator.prototype.ensureDocumentTargetMapping = function (key) {
        var targetMapping = this.pendingDocumentTargetMapping.get(key);
        if (!targetMapping) {
            targetMapping = new SortedSet(primitiveComparator);
            this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, targetMapping);
        }
        return targetMapping;
    };
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getQueryDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */
    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
        return this.queryDataForActiveTarget(targetId) !== null;
    };
    /**
     * Returns the QueryData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */
    WatchChangeAggregator.prototype.queryDataForActiveTarget = function (targetId) {
        var targetState = this.targetStates[targetId];
        return targetState && targetState.isPending
            ? null
            : this.metadataProvider.getQueryDataForTarget(targetId);
    };
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */
    WatchChangeAggregator.prototype.resetTarget = function (targetId) {
        var _this = this;
        assert(!this.targetStates[targetId].isPending, 'Should only reset active targets');
        this.targetStates[targetId] = new TargetState();
        // Trigger removal for any documents currently mapped to this target.
        // These removals will be part of the initial snapshot if Watch does not
        // resend these documents.
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        existingKeys.forEach(function (key) {
            _this.removeDocumentFromTarget(targetId, key, /*updatedDocument=*/ null);
        });
    };
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */
    WatchChangeAggregator.prototype.targetContainsDocument = function (targetId, key) {
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        return existingKeys.has(key);
    };
    return WatchChangeAggregator;
}());
function documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DIRECTIONS = (function () {
    var dirs = {};
    dirs[Direction.ASCENDING.name] = 'ASCENDING';
    dirs[Direction.DESCENDING.name] = 'DESCENDING';
    return dirs;
})();
var OPERATORS = (function () {
    var ops = {};
    ops[RelationOp.LESS_THAN.name] = 'LESS_THAN';
    ops[RelationOp.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
    ops[RelationOp.GREATER_THAN.name] = 'GREATER_THAN';
    ops[RelationOp.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
    ops[RelationOp.EQUAL.name] = 'EQUAL';
    ops[RelationOp.ARRAY_CONTAINS.name] = 'ARRAY_CONTAINS';
    return ops;
})();
// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var ISO_REG_EXP = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function assertPresent(value, description) {
    assert(!isNullOrUndefined(value), description + ' is missing');
}
function parseInt64(value) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    if (typeof value === 'number') {
        return value;
    }
    else if (typeof value === 'string') {
        return Number(value);
    }
    else {
        return fail("can't parse " + value);
    }
}
/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */
var JsonProtoSerializer = /** @class */ (function () {
    function JsonProtoSerializer(databaseId, options) {
        this.databaseId = databaseId;
        this.options = options;
    }
    JsonProtoSerializer.prototype.emptyByteString = function () {
        if (this.options.useProto3Json) {
            return '';
        }
        else {
            return new Uint8Array(0);
        }
    };
    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
        // byteStrings can be either string or UInt8Array, but the typings say
        // it's always a string. Cast as string to avoid type check failing
        return byteString;
    };
    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
        var code = status.code === undefined
            ? Code.UNKNOWN
            : mapCodeFromRpcCode(status.code);
        return new FirestoreError(code, status.message || '');
    };
    /**
     * Returns a value for a number (or undefined) that's appropriate to put into
     * a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "number" because that's what
     * our generated proto interfaces say Int32Value must be. But GRPC actually
     * expects a { value: <number> } struct.
     */
    JsonProtoSerializer.prototype.toInt32Value = function (val) {
        if (!isNullOrUndefined(val)) {
            // tslint:disable-next-line:no-any We need to match generated Proto types.
            return { value: val };
        }
        else {
            return undefined;
        }
    };
    /**
     * Returns a number (or null) from a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as accepting "number" because that's what
     * our generated proto interfaces say Int32Value must be, but it actually
     * accepts { value: number } to match our serialization in toInt32Value().
     */
    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
        var result;
        if (typeof val === 'object') {
            // tslint:disable-next-line:no-any We need to match generated Proto types.
            result = val.value;
        }
        else {
            // We accept raw numbers (without the {value: ... } wrapper) for
            // compatibility with legacy persisted data.
            result = val;
        }
        return isNullOrUndefined(result) ? null : result;
    };
    /**
     * Returns a value for a Date that's appropriate to put into a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say dates must be. But it's easier and safer
     * to actually return a Timestamp proto.
     */
    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
        return {
            seconds: timestamp.seconds,
            nanos: timestamp.nanoseconds
            // tslint:disable-next-line:no-any
        };
    };
    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
        // The json interface (for the browser) will return an iso timestamp string,
        // while the proto js library (for node) will return a
        // google.protobuf.Timestamp instance.
        if (typeof date === 'string') {
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(this.options.useProto3Json,
            //   'The timestamp string format requires Proto3.');
            return this.fromIso8601String(date);
        }
        else {
            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(!this.options.useProto3Json,
            //   'The timestamp instance format requires Proto JS.');
            var seconds = parseInt64(date.seconds || '0');
            var nanos = date.nanos || 0;
            return new Timestamp(seconds, nanos);
        }
    };
    JsonProtoSerializer.prototype.fromIso8601String = function (utc) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var nanos = 0;
        var fraction = ISO_REG_EXP.exec(utc);
        assert(!!fraction, 'invalid timestamp: ' + utc);
        if (fraction[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var nanoStr = fraction[1];
            nanoStr = (nanoStr + '000000000').substr(0, 9);
            nanos = Number(nanoStr);
        }
        // Parse the date to get the seconds.
        var date = new Date(utc);
        var seconds = Math.floor(date.getTime() / 1000);
        return new Timestamp(seconds, nanos);
    };
    /**
     * Returns a value for bytes that's appropriate to put in a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say bytes must be. But it should return
     * an Uint8Array in Node.
     */
    JsonProtoSerializer.prototype.toBytes = function (bytes) {
        if (this.options.useProto3Json) {
            return bytes.toBase64();
        }
        else {
            // The typings say it's a string, but it needs to be a Uint8Array in Node.
            return this.unsafeCastProtoByteString(bytes.toUint8Array());
        }
    };
    /**
     * Parse the blob from the protos into the internal Blob class. Note that the
     * typings assume all blobs are strings, but they are actually Uint8Arrays
     * on Node.
     */
    JsonProtoSerializer.prototype.fromBlob = function (blob) {
        if (typeof blob === 'string') {
            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return Blob.fromBase64String(blob);
        }
        else {
            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as string, but got something else instead.');
            return Blob.fromUint8Array(blob);
        }
    };
    JsonProtoSerializer.prototype.toVersion = function (version) {
        return this.toTimestamp(version.toTimestamp());
    };
    JsonProtoSerializer.prototype.fromVersion = function (version) {
        assert(!!version, "Trying to deserialize version that isn't set");
        return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
    };
    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
        return this.fullyQualifiedPrefixPath(databaseId)
            .child('documents')
            .child(path)
            .canonicalString();
    };
    JsonProtoSerializer.prototype.fromResourceName = function (name) {
        var resource = ResourcePath.fromString(name);
        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
        return resource;
    };
    JsonProtoSerializer.prototype.toName = function (key) {
        return this.toResourceName(this.databaseId, key.path);
    };
    JsonProtoSerializer.prototype.fromName = function (name) {
        var resource = this.fromResourceName(name);
        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
            resource.get(1) +
            ' vs ' +
            this.databaseId.projectId);
        assert((!resource.get(3) && !this.databaseId.database) ||
            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
            resource.get(3) +
            ' vs ' +
            this.databaseId.database);
        return new DocumentKey(this.extractLocalPathFromResourceName(resource));
    };
    JsonProtoSerializer.prototype.toQueryPath = function (path) {
        return this.toResourceName(this.databaseId, path);
    };
    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
        var resourceName = this.fromResourceName(name);
        // In v1beta1 queries for collections at the root did not have a trailing
        // "/documents". In v1 all resource paths contain "/documents". Preserve the
        // ability to read the v1beta1 form for compatibility with queries persisted
        // in the local query cache.
        if (resourceName.length === 4) {
            return ResourcePath.EMPTY_PATH;
        }
        return this.extractLocalPathFromResourceName(resourceName);
    };
    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
        get: function () {
            var path = new ResourcePath([
                'projects',
                this.databaseId.projectId,
                'databases',
                this.databaseId.database
            ]);
            return path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
        return new ResourcePath([
            'projects',
            databaseId.projectId,
            'databases',
            databaseId.database
        ]);
    };
    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
        return resourceName.popFirst(5);
    };
    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
        // Resource names have at least 4 components (project ID, database ID)
        return (path.length >= 4 &&
            path.get(0) === 'projects' &&
            path.get(2) === 'databases');
    };
    JsonProtoSerializer.prototype.toValue = function (val) {
        if (val instanceof NullValue) {
            return { nullValue: 'NULL_VALUE' };
        }
        else if (val instanceof BooleanValue) {
            return { booleanValue: val.value() };
        }
        else if (val instanceof IntegerValue) {
            return { integerValue: '' + val.value() };
        }
        else if (val instanceof DoubleValue) {
            var doubleValue = val.value();
            if (this.options.useProto3Json) {
                // Proto 3 let's us encode NaN and Infinity as string values as
                // expected by the backend. This is currently not checked by our unit
                // tests because they rely on protobuf.js.
                if (isNaN(doubleValue)) {
                    return { doubleValue: 'NaN' };
                }
                else if (doubleValue === Infinity) {
                    return { doubleValue: 'Infinity' };
                }
                else if (doubleValue === -Infinity) {
                    return { doubleValue: '-Infinity' };
                }
            }
            return { doubleValue: val.value() };
        }
        else if (val instanceof StringValue) {
            return { stringValue: val.value() };
        }
        else if (val instanceof ObjectValue) {
            return { mapValue: this.toMapValue(val) };
        }
        else if (val instanceof ArrayValue) {
            return { arrayValue: this.toArrayValue(val) };
        }
        else if (val instanceof TimestampValue) {
            return {
                timestampValue: this.toTimestamp(val.internalValue)
            };
        }
        else if (val instanceof GeoPointValue) {
            return {
                geoPointValue: {
                    latitude: val.value().latitude,
                    longitude: val.value().longitude
                }
            };
        }
        else if (val instanceof BlobValue) {
            return {
                bytesValue: this.toBytes(val.value())
            };
        }
        else if (val instanceof RefValue) {
            return {
                referenceValue: this.toResourceName(val.databaseId, val.key.path)
            };
        }
        else {
            return fail('Unknown FieldValue ' + JSON.stringify(val));
        }
    };
    JsonProtoSerializer.prototype.fromValue = function (obj) {
        var _this = this;
        // tslint:disable-next-line:no-any
        var type = obj['value_type'];
        if (hasTag(obj, type, 'nullValue')) {
            return NullValue.INSTANCE;
        }
        else if (hasTag(obj, type, 'booleanValue')) {
            return BooleanValue.of(obj.booleanValue);
        }
        else if (hasTag(obj, type, 'integerValue')) {
            return new IntegerValue(parseInt64(obj.integerValue));
        }
        else if (hasTag(obj, type, 'doubleValue')) {
            if (this.options.useProto3Json) {
                // Proto 3 uses the string values 'NaN' and 'Infinity'.
                if (obj.doubleValue === 'NaN') {
                    return DoubleValue.NAN;
                }
                else if (obj.doubleValue === 'Infinity') {
                    return DoubleValue.POSITIVE_INFINITY;
                }
                else if (obj.doubleValue === '-Infinity') {
                    return DoubleValue.NEGATIVE_INFINITY;
                }
            }
            return new DoubleValue(obj.doubleValue);
        }
        else if (hasTag(obj, type, 'stringValue')) {
            return new StringValue(obj.stringValue);
        }
        else if (hasTag(obj, type, 'mapValue')) {
            return this.fromFields(obj.mapValue.fields || {});
        }
        else if (hasTag(obj, type, 'arrayValue')) {
            // "values" is not present if the array is empty
            assertPresent(obj.arrayValue, 'arrayValue');
            var values$$1 = obj.arrayValue.values || [];
            return new ArrayValue(values$$1.map(function (v) { return _this.fromValue(v); }));
        }
        else if (hasTag(obj, type, 'timestampValue')) {
            assertPresent(obj.timestampValue, 'timestampValue');
            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
        }
        else if (hasTag(obj, type, 'geoPointValue')) {
            assertPresent(obj.geoPointValue, 'geoPointValue');
            var latitude = obj.geoPointValue.latitude || 0;
            var longitude = obj.geoPointValue.longitude || 0;
            return new GeoPointValue(new GeoPoint(latitude, longitude));
        }
        else if (hasTag(obj, type, 'bytesValue')) {
            assertPresent(obj.bytesValue, 'bytesValue');
            var blob = this.fromBlob(obj.bytesValue);
            return new BlobValue(blob);
        }
        else if (hasTag(obj, type, 'referenceValue')) {
            assertPresent(obj.referenceValue, 'referenceValue');
            var resourceName = this.fromResourceName(obj.referenceValue);
            var dbId = new DatabaseId(resourceName.get(1), resourceName.get(3));
            var key = new DocumentKey(this.extractLocalPathFromResourceName(resourceName));
            return new RefValue(dbId, key);
        }
        else {
            return fail('Unknown Value proto ' + JSON.stringify(obj));
        }
    };
    /** Creates an api.Document from key and fields (but no create/update time) */
    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
        return {
            name: this.toName(key),
            fields: this.toFields(fields)
        };
    };
    JsonProtoSerializer.prototype.toDocument = function (document) {
        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
        return {
            name: this.toName(document.key),
            fields: this.toFields(document.data),
            updateTime: this.toTimestamp(document.version.toTimestamp())
        };
    };
    JsonProtoSerializer.prototype.fromDocument = function (document, hasCommittedMutations) {
        return new Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasCommittedMutations: !!hasCommittedMutations });
    };
    JsonProtoSerializer.prototype.toFields = function (fields) {
        var _this = this;
        var result = {};
        fields.forEach(function (key, value) {
            result[key] = _this.toValue(value);
        });
        return result;
    };
    JsonProtoSerializer.prototype.fromFields = function (object) {
        var _this = this;
        // Proto map<string, Value> gets mapped to Object, so cast it.
        var map = object;
        var result = ObjectValue.EMPTY;
        forEach(map, function (key, value) {
            result = result.set(new FieldPath([key]), _this.fromValue(value));
        });
        return result;
    };
    JsonProtoSerializer.prototype.toMapValue = function (map) {
        return {
            fields: this.toFields(map)
        };
    };
    JsonProtoSerializer.prototype.toArrayValue = function (array) {
        var _this = this;
        var result = [];
        array.forEach(function (value) {
            result.push(_this.toValue(value));
        });
        return { values: result };
    };
    JsonProtoSerializer.prototype.fromFound = function (doc) {
        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
        assertPresent(doc.found.name, 'doc.found.name');
        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
        var key = this.fromName(doc.found.name);
        var version = this.fromVersion(doc.found.updateTime);
        var fields = this.fromFields(doc.found.fields || {});
        return new Document(key, version, fields, {}, doc.found);
    };
    JsonProtoSerializer.prototype.fromMissing = function (result) {
        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
        var key = this.fromName(result.missing);
        var version = this.fromVersion(result.readTime);
        return new NoDocument(key, version);
    };
    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
        // tslint:disable-next-line:no-any
        var type = result['result'];
        if (hasTag(result, type, 'found')) {
            return this.fromFound(result);
        }
        else if (hasTag(result, type, 'missing')) {
            return this.fromMissing(result);
        }
        return fail('invalid batch get response: ' + JSON.stringify(result));
    };
    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
        switch (state) {
            case WatchTargetChangeState.Added:
                return 'ADD';
            case WatchTargetChangeState.Current:
                return 'CURRENT';
            case WatchTargetChangeState.NoChange:
                return 'NO_CHANGE';
            case WatchTargetChangeState.Removed:
                return 'REMOVE';
            case WatchTargetChangeState.Reset:
                return 'RESET';
            default:
                return fail('Unknown WatchTargetChangeState: ' + state);
        }
    };
    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
        if (watchChange instanceof ExistenceFilterChange) {
            return {
                filter: {
                    count: watchChange.existenceFilter.count,
                    targetId: watchChange.targetId
                }
            };
        }
        if (watchChange instanceof DocumentWatchChange) {
            if (watchChange.newDoc instanceof Document) {
                var doc = watchChange.newDoc;
                return {
                    documentChange: {
                        document: {
                            name: this.toName(doc.key),
                            fields: this.toFields(doc.data),
                            updateTime: this.toVersion(doc.version)
                        },
                        targetIds: watchChange.updatedTargetIds,
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc instanceof NoDocument) {
                var doc = watchChange.newDoc;
                return {
                    documentDelete: {
                        document: this.toName(doc.key),
                        readTime: this.toVersion(doc.version),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc === null) {
                return {
                    documentRemove: {
                        document: this.toName(watchChange.key),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
        }
        if (watchChange instanceof WatchTargetChange) {
            var cause = undefined;
            if (watchChange.cause) {
                cause = {
                    code: mapRpcCodeFromCode(watchChange.cause.code),
                    message: watchChange.cause.message
                };
            }
            return {
                targetChange: {
                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
                    targetIds: watchChange.targetIds,
                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
                    cause: cause
                }
            };
        }
        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
    };
    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
        // tslint:disable-next-line:no-any
        var type = change['response_type'];
        var watchChange;
        if (hasTag(change, type, 'targetChange')) {
            assertPresent(change.targetChange, 'targetChange');
            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
            // if unset
            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
            var targetIds = change.targetChange.targetIds || [];
            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
            var causeProto = change.targetChange.cause;
            var cause = causeProto && this.fromRpcStatus(causeProto);
            watchChange = new WatchTargetChange(state, targetIds, resumeToken, cause || null);
        }
        else if (hasTag(change, type, 'documentChange')) {
            assertPresent(change.documentChange, 'documentChange');
            assertPresent(change.documentChange.document, 'documentChange.name');
            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
            var entityChange = change.documentChange;
            var key = this.fromName(entityChange.document.name);
            var version = this.fromVersion(entityChange.document.updateTime);
            var fields = this.fromFields(entityChange.document.fields || {});
            // The document may soon be re-serialized back to protos in order to store it in local
            // persistence. Memoize the encoded form to avoid encoding it again.
            var doc = new Document(key, version, fields, {}, entityChange.document);
            var updatedTargetIds = entityChange.targetIds || [];
            var removedTargetIds = entityChange.removedTargetIds || [];
            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
        }
        else if (hasTag(change, type, 'documentDelete')) {
            assertPresent(change.documentDelete, 'documentDelete');
            assertPresent(change.documentDelete.document, 'documentDelete.document');
            var docDelete = change.documentDelete;
            var key = this.fromName(docDelete.document);
            var version = docDelete.readTime
                ? this.fromVersion(docDelete.readTime)
                : SnapshotVersion.forDeletedDoc();
            var doc = new NoDocument(key, version);
            var removedTargetIds = docDelete.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
        }
        else if (hasTag(change, type, 'documentRemove')) {
            assertPresent(change.documentRemove, 'documentRemove');
            assertPresent(change.documentRemove.document, 'documentRemove');
            var docRemove = change.documentRemove;
            var key = this.fromName(docRemove.document);
            var removedTargetIds = docRemove.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
        }
        else if (hasTag(change, type, 'filter')) {
            // TODO(dimond): implement existence filter parsing with strategy.
            assertPresent(change.filter, 'filter');
            assertPresent(change.filter.targetId, 'filter.targetId');
            var filter = change.filter;
            var count = filter.count || 0;
            var existenceFilter = new ExistenceFilter(count);
            var targetId = filter.targetId;
            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
        }
        else {
            return fail('Unknown change type ' + JSON.stringify(change));
        }
        return watchChange;
    };
    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
        if (state === 'NO_CHANGE') {
            return WatchTargetChangeState.NoChange;
        }
        else if (state === 'ADD') {
            return WatchTargetChangeState.Added;
        }
        else if (state === 'REMOVE') {
            return WatchTargetChangeState.Removed;
        }
        else if (state === 'CURRENT') {
            return WatchTargetChangeState.Current;
        }
        else if (state === 'RESET') {
            return WatchTargetChangeState.Reset;
        }
        else {
            return fail('Got unexpected TargetChange.state: ' + state);
        }
    };
    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        // tslint:disable-next-line:no-any
        var type = change['response_type'];
        if (!hasTag(change, type, 'targetChange')) {
            return SnapshotVersion.MIN;
        }
        var targetChange = change.targetChange;
        if (targetChange.targetIds && targetChange.targetIds.length) {
            return SnapshotVersion.MIN;
        }
        if (!targetChange.readTime) {
            return SnapshotVersion.MIN;
        }
        return this.fromVersion(targetChange.readTime);
    };
    JsonProtoSerializer.prototype.toMutation = function (mutation) {
        var _this = this;
        var result;
        if (mutation instanceof SetMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.value)
            };
        }
        else if (mutation instanceof DeleteMutation) {
            result = { delete: this.toName(mutation.key) };
        }
        else if (mutation instanceof PatchMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.data),
                updateMask: this.toDocumentMask(mutation.fieldMask)
            };
        }
        else if (mutation instanceof TransformMutation) {
            result = {
                transform: {
                    document: this.toName(mutation.key),
                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
                        return _this.toFieldTransform(transform);
                    })
                }
            };
        }
        else {
            return fail('Unknown mutation type ' + mutation.type);
        }
        if (!mutation.precondition.isNone) {
            result.currentDocument = this.toPrecondition(mutation.precondition);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromMutation = function (proto) {
        var _this = this;
        var precondition = proto.currentDocument
            ? this.fromPrecondition(proto.currentDocument)
            : Precondition.NONE;
        if (proto.update) {
            assertPresent(proto.update.name, 'name');
            var key = this.fromName(proto.update.name);
            var value = this.fromFields(proto.update.fields || {});
            if (proto.updateMask) {
                var fieldMask = this.fromDocumentMask(proto.updateMask);
                return new PatchMutation(key, value, fieldMask, precondition);
            }
            else {
                return new SetMutation(key, value, precondition);
            }
        }
        else if (proto.delete) {
            var key = this.fromName(proto.delete);
            return new DeleteMutation(key, precondition);
        }
        else if (proto.transform) {
            var key = this.fromName(proto.transform.document);
            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
                return _this.fromFieldTransform(transform);
            });
            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
            return new TransformMutation(key, fieldTransforms);
        }
        else {
            return fail('unknown mutation proto: ' + JSON.stringify(proto));
        }
    };
    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
        assert(!precondition.isNone, "Can't serialize an empty precondition");
        if (precondition.updateTime !== undefined) {
            return {
                updateTime: this.toVersion(precondition.updateTime)
            };
        }
        else if (precondition.exists !== undefined) {
            return { exists: precondition.exists };
        }
        else {
            return fail('Unknown precondition');
        }
    };
    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
        if (precondition.updateTime !== undefined) {
            return Precondition.updateTime(this.fromVersion(precondition.updateTime));
        }
        else if (precondition.exists !== undefined) {
            return Precondition.exists(precondition.exists);
        }
        else {
            return Precondition.NONE;
        }
    };
    JsonProtoSerializer.prototype.fromWriteResult = function (proto, commitTime) {
        var _this = this;
        // NOTE: Deletes don't have an updateTime.
        var version = proto.updateTime
            ? this.fromVersion(proto.updateTime)
            : this.fromVersion(commitTime);
        var transformResults = null;
        if (proto.transformResults && proto.transformResults.length > 0) {
            transformResults = proto.transformResults.map(function (result) {
                return _this.fromValue(result);
            });
        }
        return new MutationResult(version, transformResults);
    };
    JsonProtoSerializer.prototype.fromWriteResults = function (protos, commitTime) {
        var _this = this;
        if (protos && protos.length > 0) {
            assert(commitTime !== undefined, 'Received a write result without a commit time');
            return protos.map(function (proto) { return _this.fromWriteResult(proto, commitTime); });
        }
        else {
            return [];
        }
    };
    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
        var _this = this;
        var transform = fieldTransform.transform;
        if (transform instanceof ServerTimestampTransform) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                setToServerValue: 'REQUEST_TIME'
            };
        }
        else if (transform instanceof ArrayUnionTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                appendMissingElements: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else if (transform instanceof ArrayRemoveTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                removeAllFromArray: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else {
            throw fail('Unknown transform: ' + fieldTransform.transform);
        }
    };
    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
        var _this = this;
        // tslint:disable-next-line:no-any We need to match generated Proto types.
        var type = proto['transform_type'];
        var transform = null;
        if (hasTag(proto, type, 'setToServerValue')) {
            assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown server value transform proto: ' + JSON.stringify(proto));
            transform = ServerTimestampTransform.instance;
        }
        else if (hasTag(proto, type, 'appendMissingElements')) {
            var values$$1 = proto.appendMissingElements.values || [];
            transform = new ArrayUnionTransformOperation(values$$1.map(function (v) { return _this.fromValue(v); }));
        }
        else if (hasTag(proto, type, 'removeAllFromArray')) {
            var values$$1 = proto.removeAllFromArray.values || [];
            transform = new ArrayRemoveTransformOperation(values$$1.map(function (v) { return _this.fromValue(v); }));
        }
        else {
            fail('Unknown transform proto: ' + JSON.stringify(proto));
        }
        var fieldPath = FieldPath.fromServerFormat(proto.fieldPath);
        return new FieldTransform(fieldPath, transform);
    };
    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
        return { documents: [this.toQueryPath(query.path)] };
    };
    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
        var count = documentsTarget.documents.length;
        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
        var name = documentsTarget.documents[0];
        return Query.atPath(this.fromQueryPath(name));
    };
    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
        // Dissect the path into parent, collectionId, and optional key filter.
        var result = { structuredQuery: {} };
        if (query.path.isEmpty()) {
            result.parent = this.toQueryPath(ResourcePath.EMPTY_PATH);
        }
        else {
            var path = query.path;
            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
            result.parent = this.toQueryPath(path.popLast());
            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
        }
        var where = this.toFilter(query.filters);
        if (where) {
            result.structuredQuery.where = where;
        }
        var orderBy = this.toOrder(query.orderBy);
        if (orderBy) {
            result.structuredQuery.orderBy = orderBy;
        }
        var limit = this.toInt32Value(query.limit);
        if (limit !== undefined) {
            result.structuredQuery.limit = limit;
        }
        if (query.startAt) {
            result.structuredQuery.startAt = this.toCursor(query.startAt);
        }
        if (query.endAt) {
            result.structuredQuery.endAt = this.toCursor(query.endAt);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
        var path = this.fromQueryPath(target.parent);
        var query = target.structuredQuery;
        var fromCount = query.from ? query.from.length : 0;
        if (fromCount > 0) {
            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
            var from = query.from[0];
            path = path.child(from.collectionId);
        }
        var filterBy = [];
        if (query.where) {
            filterBy = this.fromFilter(query.where);
        }
        var orderBy = [];
        if (query.orderBy) {
            orderBy = this.fromOrder(query.orderBy);
        }
        var limit = null;
        if (query.limit) {
            limit = this.fromInt32Value(query.limit);
        }
        var startAt = null;
        if (query.startAt) {
            startAt = this.fromCursor(query.startAt);
        }
        var endAt = null;
        if (query.endAt) {
            endAt = this.fromCursor(query.endAt);
        }
        return new Query(path, orderBy, filterBy, limit, startAt, endAt);
    };
    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
        var value = this.toLabel(queryData.purpose);
        if (value == null) {
            return null;
        }
        else {
            return {
                'goog-listen-tags': value
            };
        }
    };
    JsonProtoSerializer.prototype.toLabel = function (purpose) {
        switch (purpose) {
            case QueryPurpose.Listen:
                return null;
            case QueryPurpose.ExistenceFilterMismatch:
                return 'existence-filter-mismatch';
            case QueryPurpose.LimboResolution:
                return 'limbo-document';
            default:
                return fail('Unrecognized query purpose: ' + purpose);
        }
    };
    JsonProtoSerializer.prototype.toTarget = function (queryData) {
        var result;
        var query = queryData.query;
        if (query.isDocumentQuery()) {
            result = { documents: this.toDocumentsTarget(query) };
        }
        else {
            result = { query: this.toQueryTarget(query) };
        }
        result.targetId = queryData.targetId;
        if (queryData.resumeToken.length > 0) {
            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
        }
        return result;
    };
    JsonProtoSerializer.prototype.toFilter = function (filters) {
        var _this = this;
        if (filters.length === 0)
            return;
        var protos = filters.map(function (filter) {
            return filter instanceof RelationFilter
                ? _this.toRelationFilter(filter)
                : _this.toUnaryFilter(filter);
        });
        if (protos.length === 1) {
            return protos[0];
        }
        return { compositeFilter: { op: 'AND', filters: protos } };
    };
    JsonProtoSerializer.prototype.fromFilter = function (filter) {
        var _this = this;
        if (!filter) {
            return [];
        }
        else if (filter.unaryFilter !== undefined) {
            return [this.fromUnaryFilter(filter)];
        }
        else if (filter.fieldFilter !== undefined) {
            return [this.fromRelationFilter(filter)];
        }
        else if (filter.compositeFilter !== undefined) {
            return filter.compositeFilter
                .filters.map(function (f) { return _this.fromFilter(f); })
                .reduce(function (accum, current) { return accum.concat(current); });
        }
        else {
            return fail('Unknown filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
        var _this = this;
        if (orderBys.length === 0)
            return;
        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
        var _this = this;
        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.toCursor = function (cursor) {
        var _this = this;
        return {
            before: cursor.before,
            values: cursor.position.map(function (component) { return _this.toValue(component); })
        };
    };
    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
        var _this = this;
        var before = !!cursor.before;
        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
        return new Bound(position, before);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toDirection = function (dir) {
        return DIRECTIONS[dir.name];
    };
    // visible for testing
    JsonProtoSerializer.prototype.fromDirection = function (dir) {
        switch (dir) {
            case 'ASCENDING':
                return Direction.ASCENDING;
            case 'DESCENDING':
                return Direction.DESCENDING;
            default:
                return undefined;
        }
    };
    // visible for testing
    JsonProtoSerializer.prototype.toOperatorName = function (op) {
        return OPERATORS[op.name];
    };
    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
        switch (op) {
            case 'EQUAL':
                return RelationOp.EQUAL;
            case 'GREATER_THAN':
                return RelationOp.GREATER_THAN;
            case 'GREATER_THAN_OR_EQUAL':
                return RelationOp.GREATER_THAN_OR_EQUAL;
            case 'LESS_THAN':
                return RelationOp.LESS_THAN;
            case 'LESS_THAN_OR_EQUAL':
                return RelationOp.LESS_THAN_OR_EQUAL;
            case 'ARRAY_CONTAINS':
                return RelationOp.ARRAY_CONTAINS;
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified relation');
            default:
                return fail('Unknown relation');
        }
    };
    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
        return { fieldPath: path.canonicalString() };
    };
    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
        return FieldPath.fromServerFormat(fieldReference.fieldPath);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
        return {
            field: this.toFieldPathReference(orderBy.field),
            direction: this.toDirection(orderBy.dir)
        };
    };
    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
        return new OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toRelationFilter = function (filter) {
        if (filter instanceof RelationFilter) {
            return {
                fieldFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: this.toOperatorName(filter.op),
                    value: this.toValue(filter.value)
                }
            };
        }
        else {
            return fail('Unrecognized filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.fromRelationFilter = function (filter) {
        return new RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toUnaryFilter = function (filter) {
        if (filter instanceof NanFilter) {
            return {
                unaryFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: 'IS_NAN'
                }
            };
        }
        else if (filter instanceof NullFilter) {
            return {
                unaryFilter: {
                    field: this.toFieldPathReference(filter.field),
                    op: 'IS_NULL'
                }
            };
        }
        else {
            return fail('Unrecognized filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
        switch (filter.unaryFilter.op) {
            case 'IS_NAN':
                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
                return new NanFilter(nanField);
            case 'IS_NULL':
                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
                return new NullFilter(nullField);
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified filter');
            default:
                return fail('Unknown filter');
        }
    };
    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
        var canonicalFields = [];
        fieldMask.fields.forEach(function (field) {
            return canonicalFields.push(field.canonicalString());
        });
        return {
            fieldPaths: canonicalFields
        };
    };
    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
        var paths = proto.fieldPaths || [];
        var fields = paths.map(function (path) { return FieldPath.fromServerFormat(path); });
        return FieldMask.fromArray(fields);
    };
    return JsonProtoSerializer;
}());
/**
 * Checks for a specific oneof tag in a protocol buffer message.
 *
 * This intentionally accommodates two distinct cases:
 *
 * 1) Messages containing a type tag: these are the format produced by GRPC in
 * return values. These may contain default-value mappings for all tags in the
 * oneof but the type tag specifies which one was actually set.
 *
 * 2) Messages that don't contain a type tag: these are the format required by
 * GRPC as inputs. If we emitted objects with type tags, ProtoBuf.js would
 * choke claiming that the tags aren't fields in the Message.
 *
 * Allowing both formats here makes the serializer able to consume the outputs
 * it produces: for all messages it supports, fromX(toX(value)) == value.
 *
 * Note that case 2 suffers from ambiguity: if multiple tags are present
 * without a type tag then the callers are structured in such a way that the
 * first invocation will win. Since we only parse in this mode when parsing
 * the output of a serialize method this works, but it's not a general
 * solution.
 *
 * Unfortunately there is no general solution here because proto3 makes it
 * impossible to distinguish unset from explicitly set fields: both have the
 * default value for the type. Without the type tag but multiple value tags
 * it's possible to have default values for each tag in the oneof and not be
 * able to know which was actually in effect.
 */
function hasTag(obj, type, tag) {
    return type === tag || (!type && tag in obj);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */
var StreamBridge = /** @class */ (function () {
    function StreamBridge(args) {
        this.sendFn = args.sendFn;
        this.closeFn = args.closeFn;
    }
    StreamBridge.prototype.onOpen = function (callback) {
        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
        this.wrappedOnOpen = callback;
    };
    StreamBridge.prototype.onClose = function (callback) {
        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
        this.wrappedOnClose = callback;
    };
    StreamBridge.prototype.onMessage = function (callback) {
        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
        this.wrappedOnMessage = callback;
    };
    StreamBridge.prototype.close = function () {
        this.closeFn();
    };
    StreamBridge.prototype.send = function (msg) {
        this.sendFn(msg);
    };
    StreamBridge.prototype.callOnOpen = function () {
        assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
        this.wrappedOnOpen();
    };
    StreamBridge.prototype.callOnClose = function (err) {
        assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
        this.wrappedOnClose(err);
    };
    StreamBridge.prototype.callOnMessage = function (msg) {
        assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
        this.wrappedOnMessage(msg);
    };
    return StreamBridge;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG = 'Connection';
var RPC_STREAM_SERVICE = 'google.firestore.v1.Firestore';
var RPC_URL_VERSION = 'v1';
/** Maps RPC names to the corresponding REST endpoint name. */
var RPC_NAME_REST_MAPPING = {
    BatchGetDocuments: 'batchGet',
    Commit: 'commit'
};
// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
// we are doing out-of-band releases. Once we release as part of Firebase, we
// should use the Firebase version instead.
var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
var XHR_TIMEOUT_SECS = 15;
var WebChannelConnection = /** @class */ (function () {
    function WebChannelConnection(info) {
        this.databaseId = info.databaseId;
        this.pool = new webchannelWrapper.XhrIoPool();
        var proto = info.ssl ? 'https' : 'http';
        this.baseUrl = proto + '://' + info.host;
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */
    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
        if (token) {
            for (var header in token.authHeaders) {
                if (token.authHeaders.hasOwnProperty(header)) {
                    headers[header] = token.authHeaders[header];
                }
            }
        }
        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
    };
    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
        var _this = this;
        var url = this.makeUrl(rpcName);
        return new Promise(function (resolve, reject) {
            // tslint:disable-next-line:no-any XhrIoPool doesn't have TS typings.
            _this.pool.getObject(function (xhr) {
                xhr.listenOnce(webchannelWrapper.EventType.COMPLETE, function () {
                    try {
                        switch (xhr.getLastErrorCode()) {
                            case webchannelWrapper.ErrorCode.NO_ERROR:
                                var json = xhr.getResponseJson();
                                debug(LOG_TAG, 'XHR received:', JSON.stringify(json));
                                resolve(json);
                                break;
                            case webchannelWrapper.ErrorCode.TIMEOUT:
                                debug(LOG_TAG, 'RPC "' + rpcName + '" timed out');
                                reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
                                break;
                            case webchannelWrapper.ErrorCode.HTTP_ERROR:
                                var status_1 = xhr.getStatus();
                                debug(LOG_TAG, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
                                if (status_1 > 0) {
                                    reject(new FirestoreError(mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
                                }
                                else {
                                    // If we received an HTTP_ERROR but there's no status code,
                                    // it's most probably a connection issue
                                    debug(LOG_TAG, 'RPC "' + rpcName + '" failed');
                                    reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
                                }
                                break;
                            default:
                                fail('RPC "' +
                                    rpcName +
                                    '" failed with unanticipated ' +
                                    'webchannel error ' +
                                    xhr.getLastErrorCode() +
                                    ': ' +
                                    xhr.getLastError() +
                                    ', giving up.');
                        }
                    }
                    finally {
                        debug(LOG_TAG, 'RPC "' + rpcName + '" completed.');
                        _this.pool.releaseObject(xhr);
                    }
                });
                var requestString = JSON.stringify(request);
                debug(LOG_TAG, 'XHR sending: ', url + ' ' + requestString);
                // Content-Type: text/plain will avoid preflight requests which might
                // mess with CORS and redirects by proxies. If we add custom headers
                // we will need to change this code to potentially use the
                // $httpOverwrite parameter supported by ESF to avoid
                // triggering preflight requests.
                var headers = { 'Content-Type': 'text/plain' };
                _this.modifyHeadersForRequest(headers, token);
                xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
            });
        });
    };
    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.invokeRPC(rpcName, request, token);
    };
    WebChannelConnection.prototype.openStream = function (rpcName, token) {
        var urlParts = [
            this.baseUrl,
            '/',
            RPC_STREAM_SERVICE,
            '/',
            rpcName,
            '/channel'
        ];
        var webchannelTransport = webchannelWrapper.createWebChannelTransport();
        var request = {
            // Background channel test avoids the initial two test calls and decreases
            // initial cold start time.
            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
            // we should monitor closely for any reports.
            backgroundChannelTest: true,
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: 'gsessionid',
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
            },
            sendRawJson: true,
            supportsCrossDomainXhr: true
        };
        this.modifyHeadersForRequest(request.initMessageHeaders, token);
        // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        //
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        //
        // But for some unclear reason (see
        // https://github.com/firebase/firebase-js-sdk/issues/703), this breaks
        // ReactNative and so we exclude it, which just means ReactNative may be
        // subject to the extra network roundtrip for CORS preflight.
        if (!util.isReactNative()) {
            request['httpHeadersOverwriteParam'] = '$httpHeaders';
        }
        var url = urlParts.join('');
        debug(LOG_TAG, 'Creating WebChannel: ' + url + ' ' + request);
        // tslint:disable-next-line:no-any Because listen isn't defined on it.
        var channel = webchannelTransport.createWebChannel(url, request);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        var opened = false;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        var closed = false;
        var streamBridge = new StreamBridge({
            sendFn: function (msg) {
                if (!closed) {
                    if (!opened) {
                        debug(LOG_TAG, 'Opening WebChannel transport.');
                        channel.open();
                        opened = true;
                    }
                    debug(LOG_TAG, 'WebChannel sending:', msg);
                    channel.send(msg);
                }
                else {
                    debug(LOG_TAG, 'Not sending because WebChannel is closed:', msg);
                }
            },
            closeFn: function () { return channel.close(); }
        });
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        var unguardedEventListen = function (type, fn) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            channel.listen(type, function (param) {
                try {
                    fn(param);
                }
                catch (e) {
                    setTimeout(function () {
                        throw e;
                    }, 0);
                }
            });
        };
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN, function () {
            if (!closed) {
                debug(LOG_TAG, 'WebChannel transport opened.');
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE, function () {
            if (!closed) {
                closed = true;
                debug(LOG_TAG, 'WebChannel transport closed');
                streamBridge.callOnClose();
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR, function (err) {
            if (!closed) {
                closed = true;
                debug(LOG_TAG, 'WebChannel transport errored:', err);
                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE, function (msg) {
            if (!closed) {
                var msgData = msg.data[0];
                assert(!!msgData, 'Got a webchannel message without data.');
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                var error$$1 = 
                // tslint:disable-next-line:no-any msgData.error is not typed.
                msgData.error || (msgData[0] && msgData[0].error);
                if (error$$1) {
                    debug(LOG_TAG, 'WebChannel received error:', error$$1);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var status_2 = error$$1.status;
                    var code = mapCodeFromRpcStatus(status_2);
                    var message = error$$1.message;
                    if (code === undefined) {
                        code = Code.INTERNAL;
                        message =
                            'Unknown error status: ' +
                                status_2 +
                                ' with message ' +
                                error$$1.message;
                    }
                    // Mark closed so no further events are propagated
                    closed = true;
                    streamBridge.callOnClose(new FirestoreError(code, message));
                    channel.close();
                }
                else {
                    debug(LOG_TAG, 'WebChannel received:', msgData);
                    streamBridge.callOnMessage(msgData);
                }
            }
        });
        setTimeout(function () {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            streamBridge.callOnOpen();
        }, 0);
        return streamBridge;
    };
    // visible for testing
    WebChannelConnection.prototype.makeUrl = function (rpcName) {
        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
        assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
        var url = [this.baseUrl, '/', RPC_URL_VERSION];
        url.push('/projects/');
        url.push(this.databaseId.projectId);
        url.push('/databases/');
        url.push(this.databaseId.database);
        url.push('/documents');
        url.push(':');
        url.push(urlRpcName);
        return url.join('');
    };
    return WebChannelConnection;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BrowserPlatform = /** @class */ (function () {
    function BrowserPlatform() {
        this.emptyByteString = '';
        this.base64Available = typeof atob !== 'undefined';
    }
    Object.defineProperty(BrowserPlatform.prototype, "document", {
        get: function () {
            return typeof document !== 'undefined' ? document : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatform.prototype, "window", {
        get: function () {
            return typeof window !== 'undefined' ? window : null;
        },
        enumerable: true,
        configurable: true
    });
    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
        return Promise.resolve(new WebChannelConnection(databaseInfo));
    };
    BrowserPlatform.prototype.newSerializer = function (databaseId) {
        return new JsonProtoSerializer(databaseId, { useProto3Json: true });
    };
    BrowserPlatform.prototype.formatJSON = function (value) {
        return JSON.stringify(value);
    };
    BrowserPlatform.prototype.atob = function (encoded) {
        return atob(encoded);
    };
    BrowserPlatform.prototype.btoa = function (raw) {
        return btoa(raw);
    };
    return BrowserPlatform;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This code needs to run before Firestore is used. This can be achieved in
 * several ways:
 *   1) Through the JSCompiler compiling this code and then (automatically)
 *      executing it before exporting the Firestore symbols.
 *   2) Through importing this module first in a Firestore main module
 */
PlatformSupport.setPlatform(new BrowserPlatform());

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */
var ListenSequence = /** @class */ (function () {
    function ListenSequence(previousValue, sequenceNumberSyncer) {
        var _this = this;
        this.previousValue = previousValue;
        if (sequenceNumberSyncer) {
            sequenceNumberSyncer.sequenceNumberHandler = function (sequenceNumber) {
                return _this.setPreviousValue(sequenceNumber);
            };
            this.writeNewSequenceNumber = function (sequenceNumber) {
                return sequenceNumberSyncer.writeSequenceNumber(sequenceNumber);
            };
        }
    }
    ListenSequence.prototype.setPreviousValue = function (externalPreviousValue) {
        this.previousValue = Math.max(externalPreviousValue, this.previousValue);
        return this.previousValue;
    };
    ListenSequence.prototype.next = function () {
        var nextValue = ++this.previousValue;
        if (this.writeNewSequenceNumber) {
            this.writeNewSequenceNumber(nextValue);
        }
        return nextValue;
    };
    ListenSequence.INVALID = -1;
    return ListenSequence;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Deferred;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wellknown "timer" IDs used when scheduling delayed operations on the
 * AsyncQueue. These IDs can then be used from tests to check for the presence
 * of operations or to run them early.
 *
 * The string values are used when encoding these timer IDs in JSON spec tests.
 */
var TimerId;
(function (TimerId) {
    /** All can be used with runDelayedOperationsEarly() to run all timers. */
    TimerId["All"] = "all";
    /**
     * The following 4 timers are used in persistent_stream.ts for the listen and
     * write streams. The "Idle" timer is used to close the stream due to
     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
     * the appropriate backoff delay has elapsed.
     */
    TimerId["ListenStreamIdle"] = "listen_stream_idle";
    TimerId["ListenStreamConnectionBackoff"] = "listen_stream_connection_backoff";
    TimerId["WriteStreamIdle"] = "write_stream_idle";
    TimerId["WriteStreamConnectionBackoff"] = "write_stream_connection_backoff";
    /**
     * A timer used in online_state_tracker.ts to transition from
     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
     * indefinitely for success or failure.
     */
    TimerId["OnlineStateTimeout"] = "online_state_timeout";
    /**
     * A timer used to update the client metadata in IndexedDb, which is used
     * to determine the primary leaseholder.
     */
    TimerId["ClientMetadataRefresh"] = "client_metadata_refresh";
    /** A timer used to periodically attempt LRU Garbage collection */
    TimerId["LruGarbageCollection"] = "lru_garbage_collection";
})(TimerId || (TimerId = {}));
/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 */
var DelayedOperation = /** @class */ (function () {
    function DelayedOperation(asyncQueue, timerId, targetTimeMs, op, removalCallback) {
        this.asyncQueue = asyncQueue;
        this.timerId = timerId;
        this.targetTimeMs = targetTimeMs;
        this.op = op;
        this.removalCallback = removalCallback;
        this.deferred = new Deferred();
        this.then = this.deferred.promise.then.bind(this.deferred.promise);
        this.catch = this.deferred.promise.catch.bind(this.deferred.promise);
        // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function (err) { });
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue The queue to schedule the operation on.
     * @param id A Timer ID identifying the type of operation this is.
     * @param delayMs The delay (ms) before the operation should be scheduled.
     * @param op The operation to run.
     * @param removalCallback A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */
    DelayedOperation.createAndSchedule = function (asyncQueue, timerId, delayMs, op, removalCallback) {
        var targetTime = Date.now() + delayMs;
        var delayedOp = new DelayedOperation(asyncQueue, timerId, targetTime, op, removalCallback);
        delayedOp.start(delayMs);
        return delayedOp;
    };
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */
    DelayedOperation.prototype.start = function (delayMs) {
        var _this = this;
        this.timerHandle = setTimeout(function () { return _this.handleDelayElapsed(); }, delayMs);
    };
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */
    DelayedOperation.prototype.skipDelay = function () {
        return this.handleDelayElapsed();
    };
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */
    DelayedOperation.prototype.cancel = function (reason) {
        if (this.timerHandle !== null) {
            this.clearTimeout();
            this.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled' + (reason ? ': ' + reason : '')));
        }
    };
    DelayedOperation.prototype.handleDelayElapsed = function () {
        var _this = this;
        this.asyncQueue.enqueueAndForget(function () {
            if (_this.timerHandle !== null) {
                _this.clearTimeout();
                return _this.op().then(function (result) {
                    return _this.deferred.resolve(result);
                });
            }
            else {
                return Promise.resolve();
            }
        });
    };
    DelayedOperation.prototype.clearTimeout = function () {
        if (this.timerHandle !== null) {
            this.removalCallback(this);
            clearTimeout(this.timerHandle);
            this.timerHandle = null;
        }
    };
    return DelayedOperation;
}());
var AsyncQueue = /** @class */ (function () {
    function AsyncQueue() {
        // The last promise in the queue.
        this.tail = Promise.resolve();
        // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.delayedOperations = [];
        // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.operationInProgress = false;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */
    AsyncQueue.prototype.enqueueAndForget = function (op) {
        // tslint:disable-next-line:no-floating-promises
        this.enqueue(op);
    };
    /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */
    AsyncQueue.prototype.enqueue = function (op) {
        var _this = this;
        this.verifyNotFailed();
        var newTail = this.tail.then(function () {
            _this.operationInProgress = true;
            return op()
                .catch(function (error$$1) {
                _this.failure = error$$1;
                _this.operationInProgress = false;
                var message = error$$1.stack || error$$1.message || '';
                error('INTERNAL UNHANDLED ERROR: ', message);
                // Escape the promise chain and throw the error globally so that
                // e.g. any global crash reporting library detects and reports it.
                // (but not for simulated errors in our tests since this breaks mocha)
                if (message.indexOf('Firestore Test Simulated Error') < 0) {
                    setTimeout(function () {
                        throw error$$1;
                    }, 0);
                }
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw error$$1;
            })
                .then(function (result) {
                _this.operationInProgress = false;
                return result;
            });
        });
        this.tail = newTail;
        return newTail;
    };
    /**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
     * the operation prior to its running.
     */
    AsyncQueue.prototype.enqueueAfterDelay = function (timerId, delayMs, op) {
        var _this = this;
        this.verifyNotFailed();
        assert(delayMs >= 0, "Attempted to schedule an operation with a negative delay of " + delayMs);
        // While not necessarily harmful, we currently don't expect to have multiple
        // ops with the same timer id in the queue, so defensively reject them.
        assert(!this.containsDelayedOperation(timerId), "Attempted to schedule multiple operations with timer id " + timerId + ".");
        var delayedOp = DelayedOperation.createAndSchedule(this, timerId, delayMs, op, function (op) { return _this.removeDelayedOperation(op); });
        this.delayedOperations.push(delayedOp);
        return delayedOp;
    };
    AsyncQueue.prototype.verifyNotFailed = function () {
        if (this.failure) {
            fail('AsyncQueue is already failed: ' +
                (this.failure.stack || this.failure.message));
        }
    };
    /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */
    AsyncQueue.prototype.verifyOperationInProgress = function () {
        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
    };
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */
    AsyncQueue.prototype.drain = function () {
        return this.enqueue(function () { return Promise.resolve(); });
    };
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */
    AsyncQueue.prototype.containsDelayedOperation = function (timerId) {
        for (var _i = 0, _a = this.delayedOperations; _i < _a.length; _i++) {
            var op = _a[_i];
            if (op.timerId === timerId) {
                return true;
            }
        }
        return false;
    };
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
     *  all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */
    AsyncQueue.prototype.runDelayedOperationsEarly = function (lastTimerId) {
        var _this = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.drain().then(function () {
            assert(lastTimerId === TimerId.All ||
                _this.containsDelayedOperation(lastTimerId), "Attempted to drain to missing operation " + lastTimerId);
            // Run ops in the same order they'd run if they ran naturally.
            _this.delayedOperations.sort(function (a, b) { return a.targetTimeMs - b.targetTimeMs; });
            for (var _i = 0, _a = _this.delayedOperations; _i < _a.length; _i++) {
                var op = _a[_i];
                op.skipDelay();
                if (lastTimerId !== TimerId.All && op.timerId === lastTimerId) {
                    break;
                }
            }
            return _this.drain();
        });
    };
    /** Called once a DelayedOperation is run or canceled. */
    AsyncQueue.prototype.removeDelayedOperation = function (op) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var index = this.delayedOperations.indexOf(op);
        assert(index >= 0, 'Delayed operation not found.');
        this.delayedOperations.splice(index, 1);
    };
    return AsyncQueue;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var escapeChar = '\u0001';
var encodedSeparatorChar = '\u0001';
var encodedNul = '\u0010';
var encodedEscape = '\u0011';
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */
function encode(path) {
    var result = '';
    for (var i = 0; i < path.length; i++) {
        if (result.length > 0) {
            result = encodeSeparator(result);
        }
        result = encodeSegment(path.get(i), result);
    }
    return encodeSeparator(result);
}
/** Encodes a single segment of a resource path into the given result */
function encodeSegment(segment, resultBuf) {
    var result = resultBuf;
    var length = segment.length;
    for (var i = 0; i < length; i++) {
        var c = segment.charAt(i);
        switch (c) {
            case '\0':
                result += escapeChar + encodedNul;
                break;
            case escapeChar:
                result += escapeChar + encodedEscape;
                break;
            default:
                result += c;
        }
    }
    return result;
}
/** Encodes a path separator into the given result */
function encodeSeparator(result) {
    return result + escapeChar + encodedSeparatorChar;
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */
function decode(path) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var length = path.length;
    assert(length >= 2, 'Invalid path ' + path);
    if (length === 2) {
        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
        return ResourcePath.EMPTY_PATH;
    }
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var lastReasonableEscapeIndex = length - 2;
    var segments = [];
    var segmentBuilder = '';
    for (var start = 0; start < length;) {
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var end = path.indexOf(escapeChar, start);
        if (end < 0 || end > lastReasonableEscapeIndex) {
            fail('Invalid encoded resource path: "' + path + '"');
        }
        var next = path.charAt(end + 1);
        switch (next) {
            case encodedSeparatorChar:
                var currentPiece = path.substring(start, end);
                var segment = void 0;
                if (segmentBuilder.length === 0) {
                    // Avoid copying for the common case of a segment that excludes \0
                    // and \001
                    segment = currentPiece;
                }
                else {
                    segmentBuilder += currentPiece;
                    segment = segmentBuilder;
                    segmentBuilder = '';
                }
                segments.push(segment);
                break;
            case encodedNul:
                segmentBuilder += path.substring(start, end);
                segmentBuilder += '\0';
                break;
            case encodedEscape:
                // The escape character can be used in the output to encode itself.
                segmentBuilder += path.substring(start, end + 1);
                break;
            default:
                fail('Invalid encoded resource path: "' + path + '"');
        }
        start = end + 2;
    }
    return new ResourcePath(segments);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BATCHID_UNKNOWN = -1;
/**
 * A batch of mutations that will be sent as one unit to the backend.
 */
var MutationBatch = /** @class */ (function () {
    function MutationBatch(batchId, localWriteTime, mutations) {
        this.batchId = batchId;
        this.localWriteTime = localWriteTime;
        this.mutations = mutations;
        assert(mutations.length > 0, 'Cannot create an empty mutation batch');
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */
    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var mutationResults = batchResult.mutationResults;
        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.isEqual(docKey)) {
                var mutationResult = mutationResults[i];
                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */
    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var baseDoc = maybeDoc;
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.isEqual(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
            }
        }
        return maybeDoc;
    };
    MutationBatch.prototype.keys = function () {
        var keySet = documentKeySet();
        for (var _i = 0, _a = this.mutations; _i < _a.length; _i++) {
            var mutation = _a[_i];
            keySet = keySet.add(mutation.key);
        }
        return keySet;
    };
    MutationBatch.prototype.isEqual = function (other) {
        return (this.batchId === other.batchId &&
            arrayEquals(this.mutations, other.mutations));
    };
    return MutationBatch;
}());
/** The result of applying a mutation batch to the backend. */
var MutationBatchResult = /** @class */ (function () {
    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
    /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */
    docVersions) {
        this.batch = batch;
        this.commitVersion = commitVersion;
        this.mutationResults = mutationResults;
        this.streamToken = streamToken;
        this.docVersions = docVersions;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */
    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
        assert(batch.mutations.length === results.length, 'Mutations sent ' +
            batch.mutations.length +
            ' must equal results received ' +
            results.length);
        var versionMap = documentVersionMap();
        var mutations = batch.mutations;
        for (var i = 0; i < mutations.length; i++) {
            versionMap = versionMap.insert(mutations[i].key, results[i].version);
        }
        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
    };
    return MutationBatchResult;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_BITS = 1;
var GeneratorIds;
(function (GeneratorIds) {
    GeneratorIds[GeneratorIds["QueryCache"] = 0] = "QueryCache";
    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine"; // The target IDs for limbo detection are odd (end in 1).
})(GeneratorIds || (GeneratorIds = {}));
/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the query cache (via
 * forQueryCache()), and one for limbo documents (via forSyncEngine()). These
 * two generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */
// TODO(mrschmidt): Explore removing this class in favor of generating these IDs
// directly in SyncEngine and LocalStore.
var TargetIdGenerator = /** @class */ (function () {
    /**
     * Instantiates a new TargetIdGenerator. If a seed is provided, the generator
     * will use the seed value as the next target ID.
     */
    function TargetIdGenerator(generatorId, seed) {
        this.generatorId = generatorId;
        assert((generatorId & RESERVED_BITS) === generatorId, "Generator ID " + generatorId + " contains more than " + RESERVED_BITS + " reserved bits");
        this.seek(seed !== undefined ? seed : this.generatorId);
    }
    TargetIdGenerator.prototype.next = function () {
        var nextId = this.nextId;
        this.nextId += 1 << RESERVED_BITS;
        return nextId;
    };
    /**
     * Returns the ID that follows the given ID. Subsequent calls to `next()`
     * use the newly returned target ID as their base.
     */
    // PORTING NOTE: Multi-tab only.
    TargetIdGenerator.prototype.after = function (targetId) {
        this.seek(targetId + (1 << RESERVED_BITS));
        return this.next();
    };
    TargetIdGenerator.prototype.seek = function (targetId) {
        assert((targetId & RESERVED_BITS) === this.generatorId, 'Cannot supply target ID from different generator ID');
        this.nextId = targetId;
    };
    TargetIdGenerator.forQueryCache = function () {
        // We seed the query cache generator to return '2' as its first ID, as there
        // is no differentiation in the protocol layer between an unset number and
        // the number '0'. If we were to sent a target with target ID '0', the
        // backend would consider it unset and replace it with its own ID.
        var targetIdGenerator = new TargetIdGenerator(GeneratorIds.QueryCache, 2);
        return targetIdGenerator;
    };
    TargetIdGenerator.forSyncEngine = function () {
        // Sync engine assigns target IDs for limbo document detection.
        return new TargetIdGenerator(GeneratorIds.SyncEngine);
    };
    return TargetIdGenerator;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * PersistencePromise<> is essentially a re-implementation of Promise<> except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise<> implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */
var PersistencePromise = /** @class */ (function () {
    function PersistencePromise(callback) {
        var _this = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        // tslint:disable-next-line:no-any Accept any result type for the next call in the Promise chain.
        this.nextCallback = null;
        // tslint:disable-next-line:no-any Accept any result type for the error handler.
        this.catchCallback = null;
        // When the operation resolves, we'll set result or error and mark isDone.
        this.result = undefined;
        this.error = undefined;
        this.isDone = false;
        // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false;
        callback(function (value) {
            _this.isDone = true;
            _this.result = value;
            if (_this.nextCallback) {
                // value should be defined unless T is Void, but we can't express
                // that in the type system.
                _this.nextCallback(value);
            }
        }, function (error) {
            _this.isDone = true;
            _this.error = error;
            if (_this.catchCallback) {
                _this.catchCallback(error);
            }
        });
    }
    PersistencePromise.prototype.catch = function (fn) {
        return this.next(undefined, fn);
    };
    PersistencePromise.prototype.next = function (nextFn, catchFn) {
        var _this = this;
        if (this.callbackAttached) {
            fail('Called next() or catch() twice for PersistencePromise');
        }
        this.callbackAttached = true;
        if (this.isDone) {
            if (!this.error) {
                return this.wrapSuccess(nextFn, this.result);
            }
            else {
                return this.wrapFailure(catchFn, this.error);
            }
        }
        else {
            return new PersistencePromise(function (resolve, reject) {
                _this.nextCallback = function (value) {
                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
                };
                _this.catchCallback = function (error) {
                    _this.wrapFailure(catchFn, error).next(resolve, reject);
                };
            });
        }
    };
    PersistencePromise.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.next(resolve, reject);
        });
    };
    PersistencePromise.prototype.wrapUserFunction = function (fn) {
        try {
            var result = fn();
            if (result instanceof PersistencePromise) {
                return result;
            }
            else {
                return PersistencePromise.resolve(result);
            }
        }
        catch (e) {
            return PersistencePromise.reject(e);
        }
    };
    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
        if (nextFn) {
            return this.wrapUserFunction(function () { return nextFn(value); });
        }
        else {
            // If there's no nextFn, then R must be the same as T but we
            // can't express that in the type system.
            // tslint:disable-next-line:no-any
            return PersistencePromise.resolve(value);
        }
    };
    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
        if (catchFn) {
            return this.wrapUserFunction(function () { return catchFn(error); });
        }
        else {
            return PersistencePromise.reject(error);
        }
    };
    PersistencePromise.resolve = function (result) {
        return new PersistencePromise(function (resolve, reject) {
            resolve(result);
        });
    };
    PersistencePromise.reject = function (error) {
        return new PersistencePromise(function (resolve, reject) {
            reject(error);
        });
    };
    PersistencePromise.waitFor = function (
    // tslint:disable-next-line:no-any Accept all Promise types in waitFor().
    all) {
        return new PersistencePromise(function (resolve, reject) {
            var expectedCount = 0;
            var resolvedCount = 0;
            var done = false;
            all.forEach(function (element) {
                ++expectedCount;
                element.next(function () {
                    ++resolvedCount;
                    if (done && resolvedCount === expectedCount) {
                        resolve();
                    }
                }, function (err) { return reject(err); });
            });
            done = true;
            if (resolvedCount === expectedCount) {
                resolve();
            }
        });
    };
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */
    PersistencePromise.or = function (predicates) {
        var p = PersistencePromise.resolve(false);
        var _loop_1 = function (predicate) {
            p = p.next(function (isTrue) {
                if (isTrue) {
                    return PersistencePromise.resolve(isTrue);
                }
                else {
                    return predicate();
                }
            });
        };
        for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
            var predicate = predicates_1[_i];
            _loop_1(predicate);
        }
        return p;
    };
    /**
     * Given an iterable, call the given function on each element in the
     * collection and wait for all of the resulting concurrent PersistencePromises
     * to resolve.
     */
    PersistencePromise.forEach = function (collection, f) {
        var _this = this;
        var promises = [];
        collection.forEach(function (r, s) {
            promises.push(f.call(_this, r, s));
        });
        return this.waitFor(promises);
    };
    return PersistencePromise;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$1 = 'SimpleDb';
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */
var SimpleDb = /** @class */ (function () {
    function SimpleDb(db) {
        this.db = db;
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
     * mechanism, as only version-upgrade transactions are allowed to do things like create
     * objectstores.
     */
    SimpleDb.openOrCreate = function (name, version, schemaConverter) {
        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
        debug(LOG_TAG$1, 'Opening database:', name);
        return new PersistencePromise(function (resolve, reject) {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            var request = window.indexedDB.open(name, version);
            request.onsuccess = function (event) {
                var db = event.target.result;
                resolve(new SimpleDb(db));
            };
            request.onblocked = function () {
                reject(new FirestoreError(Code.FAILED_PRECONDITION, 'Cannot upgrade IndexedDB schema while another tab is open. ' +
                    'Close all tabs that access Firestore and reload this page to proceed.'));
            };
            request.onerror = function (event) {
                var error$$1 = event.target.error;
                if (error$$1.name === 'VersionError') {
                    reject(new FirestoreError(Code.FAILED_PRECONDITION, 'A newer version of the Firestore SDK was previously used and so the persisted ' +
                        'data is not compatible with the version of the SDK you are now using. The SDK ' +
                        'will operate with persistence disabled. If you need persistence, please ' +
                        're-upgrade to a newer version of the SDK or else clear the persisted IndexedDB ' +
                        'data for your app to start fresh.'));
                }
                else {
                    reject(error$$1);
                }
            };
            request.onupgradeneeded = function (event) {
                debug(LOG_TAG$1, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
                var db = event.target.result;
                // We are provided a version upgrade transaction from the request, so
                // we wrap that in a SimpleDbTransaction to allow use of our friendlier
                // API for schema migration operations.
                var txn = new SimpleDbTransaction(request.transaction);
                schemaConverter
                    .createOrUpgrade(db, txn, event.oldVersion, SCHEMA_VERSION)
                    .next(function () {
                    debug(LOG_TAG$1, 'Database upgrade to version ' + SCHEMA_VERSION + ' complete');
                });
            };
        }).toPromise();
    };
    /** Deletes the specified database. */
    SimpleDb.delete = function (name) {
        debug(LOG_TAG$1, 'Removing database:', name);
        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
    };
    /** Returns true if IndexedDB is available in the current environment. */
    SimpleDb.isAvailable = function () {
        if (typeof window === 'undefined' || window.indexedDB == null) {
            return false;
        }
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // If we are running in Node using the IndexedDBShim, `window` is defined,
        // but `window.navigator` is not. In this case, we support IndexedDB and
        // return `true`.
        if (window.navigator === undefined) {
            return Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_api_key":""}).USE_MOCK_PERSISTENCE === 'YES';
        }
        // Check the UA string to find out the browser.
        // TODO(mikelehen): Move this logic into packages/util/environment.ts
        var ua = window.navigator.userAgent;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        if (ua.indexOf('MSIE ') > 0 ||
            ua.indexOf('Trident/') > 0 ||
            ua.indexOf('Edge/') > 0) {
            return false;
        }
        else {
            return true;
        }
    };
    /** Helper to get a typed SimpleDbStore from a transaction. */
    SimpleDb.getStore = function (txn, store) {
        return txn.store(store);
    };
    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
        var transaction = SimpleDbTransaction.open(this.db, mode, objectStores);
        var transactionFnResult = transactionFn(transaction)
            .catch(function (error$$1) {
            // Abort the transaction if there was an error.
            transaction.abort(error$$1);
            // We cannot actually recover, and calling `abort()` will cause the transaction's
            // completion promise to be rejected. This in turn means that we won't use
            // `transactionFnResult` below. We return a rejection here so that we don't add the
            // possibility of returning `void` to the type of `transactionFnResult`.
            return PersistencePromise.reject(error$$1);
        })
            .toPromise();
        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
        // fire), but still return the original transactionFnResult back to the
        // caller.
        return transaction.completionPromise.then(function () { return transactionFnResult; });
    };
    SimpleDb.prototype.close = function () {
        this.db.close();
    };
    return SimpleDb;
}());
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */
var IterationController = /** @class */ (function () {
    function IterationController(dbCursor) {
        this.dbCursor = dbCursor;
        this.shouldStop = false;
        this.nextKey = null;
    }
    Object.defineProperty(IterationController.prototype, "isDone", {
        get: function () {
            return this.shouldStop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "skipToKey", {
        get: function () {
            return this.nextKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "cursor", {
        set: function (value) {
            this.dbCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This function can be called to stop iteration at any point.
     */
    IterationController.prototype.done = function () {
        this.shouldStop = true;
    };
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */
    IterationController.prototype.skip = function (key) {
        this.nextKey = key;
    };
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */
    IterationController.prototype.delete = function () {
        return wrapRequest(this.dbCursor.delete());
    };
    return IterationController;
}());
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */
var SimpleDbTransaction = /** @class */ (function () {
    function SimpleDbTransaction(transaction) {
        var _this = this;
        this.transaction = transaction;
        this.aborted = false;
        /**
         * A promise that resolves with the result of the IndexedDb transaction.
         */
        this.completionDeferred = new Deferred();
        this.transaction.oncomplete = function () {
            _this.completionDeferred.resolve();
        };
        this.transaction.onabort = function () {
            if (transaction.error) {
                _this.completionDeferred.reject(transaction.error);
            }
            else {
                _this.completionDeferred.resolve();
            }
        };
        this.transaction.onerror = function (event) {
            _this.completionDeferred.reject(event.target.error);
        };
    }
    SimpleDbTransaction.open = function (db, mode, objectStoreNames) {
        return new SimpleDbTransaction(db.transaction(objectStoreNames, mode));
    };
    Object.defineProperty(SimpleDbTransaction.prototype, "completionPromise", {
        get: function () {
            return this.completionDeferred.promise;
        },
        enumerable: true,
        configurable: true
    });
    SimpleDbTransaction.prototype.abort = function (error$$1) {
        if (error$$1) {
            this.completionDeferred.reject(error$$1);
        }
        if (!this.aborted) {
            debug(LOG_TAG$1, 'Aborting transaction:', error$$1 ? error$$1.message : 'Client-initiated abort');
            this.aborted = true;
            this.transaction.abort();
        }
    };
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */
    SimpleDbTransaction.prototype.store = function (storeName) {
        var store = this.transaction.objectStore(storeName);
        assert(!!store, 'Object store not part of transaction: ' + storeName);
        return new SimpleDbStore(store);
    };
    return SimpleDbTransaction;
}());
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */
var SimpleDbStore = /** @class */ (function () {
    function SimpleDbStore(store) {
        this.store = store;
    }
    SimpleDbStore.prototype.put = function (keyOrValue, value) {
        var request;
        if (value !== undefined) {
            debug(LOG_TAG$1, 'PUT', this.store.name, keyOrValue, value);
            request = this.store.put(value, keyOrValue);
        }
        else {
            debug(LOG_TAG$1, 'PUT', this.store.name, '<auto-key>', keyOrValue);
            request = this.store.put(keyOrValue);
        }
        return wrapRequest(request);
    };
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */
    SimpleDbStore.prototype.add = function (value) {
        debug(LOG_TAG$1, 'ADD', this.store.name, value, value);
        var request = this.store.add(value);
        return wrapRequest(request);
    };
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */
    SimpleDbStore.prototype.get = function (key) {
        var _this = this;
        var request = this.store.get(key);
        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
        return wrapRequest(request).next(function (result) {
            // Normalize nonexistence to null.
            if (result === undefined) {
                result = null;
            }
            debug(LOG_TAG$1, 'GET', _this.store.name, key, result);
            return result;
        });
    };
    SimpleDbStore.prototype.delete = function (key) {
        debug(LOG_TAG$1, 'DELETE', this.store.name, key);
        var request = this.store.delete(key);
        return wrapRequest(request);
    };
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */
    SimpleDbStore.prototype.count = function () {
        debug(LOG_TAG$1, 'COUNT', this.store.name);
        var request = this.store.count();
        return wrapRequest(request);
    };
    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
        var cursor = this.cursor(this.options(indexOrRange, range));
        var results = [];
        return this.iterateCursor(cursor, function (key, value) {
            results.push(value);
        }).next(function () {
            return results;
        });
    };
    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
        debug(LOG_TAG$1, 'DELETE ALL', this.store.name);
        var options = this.options(indexOrRange, range);
        options.keysOnly = false;
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, function (key, value, control) {
            // NOTE: Calling delete() on a cursor is documented as more efficient than
            // calling delete() on an object store with a single key
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
            // however, this requires us *not* to use a keysOnly cursor
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
            // may want to compare the performance of each method.
            return control.delete();
        });
    };
    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
        var options;
        if (!callback) {
            options = {};
            callback = optionsOrCallback;
        }
        else {
            options = optionsOrCallback;
        }
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, callback);
    };
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */
    SimpleDbStore.prototype.iterateSerial = function (callback) {
        var cursorRequest = this.cursor({});
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                callback(cursor.primaryKey, cursor.value).next(function (shouldContinue) {
                    if (shouldContinue) {
                        cursor.continue();
                    }
                    else {
                        resolve();
                    }
                });
            };
        });
    };
    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
        var results = [];
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                var controller = new IterationController(cursor);
                var userResult = fn(cursor.primaryKey, cursor.value, controller);
                if (userResult instanceof PersistencePromise) {
                    var userPromise = userResult.catch(function (err) {
                        controller.done();
                        return PersistencePromise.reject(err);
                    });
                    results.push(userPromise);
                }
                if (controller.isDone) {
                    resolve();
                }
                else if (controller.skipToKey === null) {
                    cursor.continue();
                }
                else {
                    cursor.continue(controller.skipToKey);
                }
            };
        }).next(function () {
            return PersistencePromise.waitFor(results);
        });
    };
    SimpleDbStore.prototype.options = function (indexOrRange, range) {
        var indexName = undefined;
        if (indexOrRange !== undefined) {
            if (typeof indexOrRange === 'string') {
                indexName = indexOrRange;
            }
            else {
                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
                range = indexOrRange;
            }
        }
        return { index: indexName, range: range };
    };
    SimpleDbStore.prototype.cursor = function (options) {
        var direction = 'next';
        if (options.reverse) {
            direction = 'prev';
        }
        if (options.index) {
            var index = this.store.index(options.index);
            if (options.keysOnly) {
                return index.openKeyCursor(options.range, direction);
            }
            else {
                return index.openCursor(options.range, direction);
            }
        }
        else {
            return this.store.openCursor(options.range, direction);
        }
    };
    return SimpleDbStore;
}());
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */
function wrapRequest(request) {
    return new PersistencePromise(function (resolve, reject) {
        request.onsuccess = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        request.onerror = function (event) {
            reject(event.target.error);
        };
    });
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedDbQueryCache = /** @class */ (function () {
    function IndexedDbQueryCache(referenceDelegate, serializer) {
        this.referenceDelegate = referenceDelegate;
        this.serializer = serializer;
        // PORTING NOTE: We don't cache global metadata for the query cache, since
        // some of it (in particular `highestTargetId`) can be modified by secondary
        // tabs. We could perhaps be more granular (and e.g. still cache
        // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
        // to IndexedDb whenever we need to read metadata. We can revisit if it turns
        // out to have a meaningful performance impact.
        this.targetIdGenerator = TargetIdGenerator.forQueryCache();
    }
    IndexedDbQueryCache.prototype.allocateTargetId = function (transaction) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestTargetId = _this.targetIdGenerator.after(metadata.highestTargetId);
            return _this.saveMetadata(transaction, metadata).next(function () { return metadata.highestTargetId; });
        });
    };
    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) {
            return SnapshotVersion.fromTimestamp(new Timestamp(metadata.lastRemoteSnapshotVersion.seconds, metadata.lastRemoteSnapshotVersion.nanoseconds));
        });
    };
    IndexedDbQueryCache.prototype.getHighestSequenceNumber = function (transaction) {
        return getHighestListenSequenceNumber(transaction.simpleDbTransaction);
    };
    IndexedDbQueryCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            if (lastRemoteSnapshotVersion) {
                metadata.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion.toTimestamp();
            }
            if (highestListenSequenceNumber > metadata.highestListenSequenceNumber) {
                metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            }
            return _this.saveMetadata(transaction, metadata);
        });
    };
    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
        var _this = this;
        return this.saveQueryData(transaction, queryData).next(function () {
            return _this.retrieveMetadata(transaction).next(function (metadata) {
                metadata.targetCount += 1;
                _this.updateMetadataFromQueryData(queryData, metadata);
                return _this.saveMetadata(transaction, metadata);
            });
        });
    };
    IndexedDbQueryCache.prototype.updateQueryData = function (transaction, queryData) {
        return this.saveQueryData(transaction, queryData);
    };
    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        var _this = this;
        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId)
            .next(function () { return targetsStore(transaction).delete(queryData.targetId); })
            .next(function () { return _this.retrieveMetadata(transaction); })
            .next(function (metadata) {
            assert(metadata.targetCount > 0, 'Removing from an empty query cache');
            metadata.targetCount -= 1;
            return _this.saveMetadata(transaction, metadata);
        });
    };
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */
    IndexedDbQueryCache.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var promises = [];
        return targetsStore(txn)
            .iterate(function (key, value) {
            var queryData = _this.serializer.fromDbTarget(value);
            if (queryData.sequenceNumber <= upperBound &&
                activeTargetIds[queryData.targetId] === undefined) {
                count++;
                promises.push(_this.removeQueryData(txn, queryData));
            }
        })
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () { return count; });
    };
    /**
     * Call provided function with each `QueryData` that we have cached.
     */
    IndexedDbQueryCache.prototype.forEachTarget = function (txn, f) {
        var _this = this;
        return targetsStore(txn).iterate(function (key, value) {
            var queryData = _this.serializer.fromDbTarget(value);
            f(queryData);
        });
    };
    IndexedDbQueryCache.prototype.retrieveMetadata = function (transaction) {
        return retrieveMetadata(transaction.simpleDbTransaction);
    };
    IndexedDbQueryCache.prototype.saveMetadata = function (transaction, metadata) {
        return globalTargetStore(transaction).put(DbTargetGlobal.key, metadata);
    };
    IndexedDbQueryCache.prototype.saveQueryData = function (transaction, queryData) {
        return targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
    };
    /**
     * In-place updates the provided metadata to account for values in the given
     * QueryData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */
    IndexedDbQueryCache.prototype.updateMetadataFromQueryData = function (queryData, metadata) {
        var updated = false;
        if (queryData.targetId > metadata.highestTargetId) {
            metadata.highestTargetId = queryData.targetId;
            updated = true;
        }
        if (queryData.sequenceNumber > metadata.highestListenSequenceNumber) {
            metadata.highestListenSequenceNumber = queryData.sequenceNumber;
            updated = true;
        }
        return updated;
    };
    IndexedDbQueryCache.prototype.getQueryCount = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) { return metadata.targetCount; });
    };
    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
        var _this = this;
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        var canonicalId = query.canonicalId();
        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
        var result = null;
        return targetsStore(transaction)
            .iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
            var found = _this.serializer.fromDbTarget(value);
            // After finding a potential match, check that the query is
            // actually equal to the requested query.
            if (query.isEqual(found.query)) {
                result = found;
                control.done();
            }
        })
            .next(function () { return result; });
    };
    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var promises = [];
        var store = documentTargetStore(txn);
        keys.forEach(function (key) {
            var path = encode(key.path);
            promises.push(store.put(new DbTargetDocument(targetId, path)));
            promises.push(_this.referenceDelegate.addReference(txn, key));
        });
        return PersistencePromise.waitFor(promises);
    };
    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var store = documentTargetStore(txn);
        return PersistencePromise.forEach(keys, function (key) {
            var path = encode(key.path);
            return PersistencePromise.waitFor([
                store.delete([targetId, path]),
                _this.referenceDelegate.removeReference(txn, key)
            ]);
        });
    };
    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        var store = documentTargetStore(txn);
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        return store.delete(range);
    };
    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var store = documentTargetStore(txn);
        var result = documentKeySet();
        return store
            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
            var path = decode(key[1]);
            var docKey = new DocumentKey(path);
            result = result.add(docKey);
        })
            .next(function () { return result; });
    };
    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
        var path = encode(key.path);
        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var count = 0;
        return documentTargetStore(txn)
            .iterate({
            index: DbTargetDocument.documentTargetsIndex,
            keysOnly: true,
            range: range
        }, function (_a, _, control) {
            var targetId = _a[0], path = _a[1];
            // Having a sentinel row for a document does not count as containing that document;
            // For the query cache, containing the document means the document is part of some
            // target.
            if (targetId !== 0) {
                count++;
                control.done();
            }
        })
            .next(function () { return count > 0; });
    };
    IndexedDbQueryCache.prototype.getQueryDataForTarget = function (transaction, targetId) {
        var _this = this;
        return targetsStore(transaction)
            .get(targetId)
            .next(function (found) {
            if (found) {
                return _this.serializer.fromDbTarget(found);
            }
            else {
                return null;
            }
        });
    };
    return IndexedDbQueryCache;
}());
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */
function targetsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTarget.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */
function globalTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetGlobal.store);
}
function retrieveMetadata(txn) {
    var globalStore = SimpleDb.getStore(txn, DbTargetGlobal.store);
    return globalStore.get(DbTargetGlobal.key).next(function (metadata) {
        assert(metadata !== null, 'Missing metadata row.');
        return metadata;
    });
}
function getHighestListenSequenceNumber(txn) {
    return retrieveMetadata(txn).next(function (targetGlobal) { return targetGlobal.highestListenSequenceNumber; });
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */
function documentTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetDocument.store);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A map implementation that uses objects as keys. Objects must implement the
 * Equatable interface and must be immutable. Entries in the map are stored
 * together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */
var ObjectMap = /** @class */ (function () {
    function ObjectMap(mapKeyFn) {
        this.mapKeyFn = mapKeyFn;
        /**
         * The inner map for a key -> value pair. Due to the possibility of
         * collisions we keep a list of entries that we do a linear search through
         * to find an actual match. Note that collisions should be rare, so we still
         * expect near constant time lookups in practice.
         */
        this.inner = {};
    }
    /** Get a value for this key, or undefined if it does not exist. */
    ObjectMap.prototype.get = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return undefined;
        }
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
            if (otherKey.isEqual(key)) {
                return value;
            }
        }
        return undefined;
    };
    ObjectMap.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    /** Put this key and value in the map. */
    ObjectMap.prototype.set = function (key, value) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            this.inner[id] = [[key, value]];
            return;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                matches[i] = [key, value];
                return;
            }
        }
        matches.push([key, value]);
    };
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */
    ObjectMap.prototype.delete = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return false;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                if (matches.length === 1) {
                    delete this.inner[id];
                }
                else {
                    matches.splice(i, 1);
                }
                return true;
            }
        }
        return false;
    };
    ObjectMap.prototype.forEach = function (fn) {
        forEach(this.inner, function (_, entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                fn(k, v);
            }
        });
    };
    ObjectMap.prototype.isEmpty = function () {
        return isEmpty(this.inner);
    };
    return ObjectMap;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */
var RemoteDocumentChangeBuffer = /** @class */ (function () {
    function RemoteDocumentChangeBuffer() {
        this.changes = maybeDocumentMap();
        this.documentSizes = new ObjectMap(function (key) {
            return key.toString();
        });
    }
    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
        var changes = this.assertChanges();
        this.changes = changes.insert(maybeDocument.key, maybeDocument);
    };
    // NOTE: removeEntry() is intentionally omitted. If it needs to be added in
    // the future it must take byte counting into account.
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */
    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        var changes = this.assertChanges();
        var bufferedEntry = changes.get(documentKey);
        if (bufferedEntry) {
            return PersistencePromise.resolve(bufferedEntry);
        }
        else {
            // Record the size of everything we load from the cache so we can compute a delta later.
            return this.getFromCache(transaction, documentKey).next(function (getResult) {
                if (getResult === null) {
                    _this.documentSizes.set(documentKey, 0);
                    return null;
                }
                else {
                    _this.documentSizes.set(documentKey, getResult.size);
                    return getResult.maybeDocument;
                }
            });
        }
    };
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */
    RemoteDocumentChangeBuffer.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.getAllFromCache(transaction, documentKeys).next(function (_a) {
            var maybeDocuments = _a.maybeDocuments, sizeMap = _a.sizeMap;
            // Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `NullableMaybeDocumentMap` directly, without a conversion.
            sizeMap.forEach(function (documentKey, size) {
                _this.documentSizes.set(documentKey, size);
            });
            return maybeDocuments;
        });
    };
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */
    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
        var result = this.applyChanges(transaction);
        // We should not buffer any more changes.
        this.changes = null;
        return result;
    };
    /** Helper to assert this.changes is not null and return it. */
    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
        assert(this.changes !== null, 'Changes have already been applied.');
        return this.changes;
    };
    return RemoteDocumentChangeBuffer;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG = 'The remote document changelog no longer contains all changes for all ' +
    'local query views. It may be necessary to rebuild these views.';
var IndexedDbRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param {LocalSerializer} serializer The document serializer.
     * @param keepDocumentChangeLog Whether to keep a document change log in
     * IndexedDb. This change log is required for Multi-Tab synchronization, but
     * not needed in clients that don't share access to their remote document
     * cache.
     */
    function IndexedDbRemoteDocumentCache(serializer, keepDocumentChangeLog) {
        this.serializer = serializer;
        this.keepDocumentChangeLog = keepDocumentChangeLog;
        /** The last id read by `getNewDocumentChanges()`. */
        this._lastProcessedDocumentChangeId = 0;
    }
    Object.defineProperty(IndexedDbRemoteDocumentCache.prototype, "lastProcessedDocumentChangeId", {
        get: function () {
            return this._lastProcessedDocumentChangeId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Starts up the remote document cache.
     *
     * Reads the ID of the last  document change from the documentChanges store.
     * Existing changes will not be returned as part of
     * `getNewDocumentChanges()`.
     */
    // PORTING NOTE: This is only used for multi-tab synchronization.
    IndexedDbRemoteDocumentCache.prototype.start = function (transaction) {
        var store = SimpleDb.getStore(transaction, DbRemoteDocumentChanges.store);
        return this.synchronizeLastDocumentChangeId(store);
    };
    /**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */
    IndexedDbRemoteDocumentCache.prototype.addEntries = function (transaction, entries, sizeDelta) {
        var promises = [];
        if (entries.length > 0) {
            var documentStore = remoteDocumentsStore(transaction);
            var changedKeys = documentKeySet();
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], key = _a.key, doc = _a.doc;
                promises.push(documentStore.put(dbKey(key), doc));
                changedKeys = changedKeys.add(key);
            }
            if (this.keepDocumentChangeLog) {
                promises.push(documentChangesStore(transaction).put({
                    changes: this.serializer.toDbResourcePaths(changedKeys)
                }));
            }
            promises.push(this.updateSize(transaction, sizeDelta));
        }
        return PersistencePromise.waitFor(promises);
    };
    /**
     * Removes a document from the cache. Note that this method does *not* do any
     * size accounting. It is the responsibility of the caller to count the bytes removed
     * and issue a final updateSize() call after removing documents.
     *
     * @param documentKey The key of the document to remove
     * @return The size of the document that was removed.
     */
    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        // We don't need to keep changelog for these removals since `removeEntry` is
        // only used for garbage collection.
        var store = remoteDocumentsStore(transaction);
        var key = dbKey(documentKey);
        return store.get(key).next(function (document) {
            if (document) {
                return store.delete(key).next(function () { return dbDocumentSize(document); });
            }
            else {
                return PersistencePromise.resolve(0);
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return dbRemoteDoc
                ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc)
                : null;
        });
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return dbRemoteDoc
                ? {
                    maybeDocument: _this.serializer.fromDbRemoteDocument(dbRemoteDoc),
                    size: dbDocumentSize(dbRemoteDoc)
                }
                : null;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            if (dbRemoteDoc) {
                results = results.insert(key, _this.serializer.fromDbRemoteDocument(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
            }
        }).next(function () { return results; });
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            if (dbRemoteDoc) {
                results = results.insert(key, _this.serializer.fromDbRemoteDocument(dbRemoteDoc));
                sizeMap = sizeMap.insert(key, dbDocumentSize(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
                sizeMap = sizeMap.insert(key, 0);
            }
        }).next(function () {
            return { maybeDocuments: results, sizeMap: sizeMap };
        });
    };
    IndexedDbRemoteDocumentCache.prototype.forEachDbEntry = function (transaction, documentKeys, callback) {
        if (documentKeys.isEmpty()) {
            return PersistencePromise.resolve();
        }
        var range = IDBKeyRange.bound(documentKeys.first().path.toArray(), documentKeys.last().path.toArray());
        var keyIter = documentKeys.getIterator();
        var nextKey = keyIter.getNext();
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (potentialKeyRaw, dbRemoteDoc, control) {
            var potentialKey = DocumentKey.fromSegments(potentialKeyRaw);
            // Go through keys not found in cache.
            while (nextKey && DocumentKey.comparator(nextKey, potentialKey) < 0) {
                callback(nextKey, null);
                nextKey = keyIter.getNext();
            }
            if (nextKey && nextKey.isEqual(potentialKey)) {
                // Key found in cache.
                callback(nextKey, dbRemoteDoc);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
            // Skip to the next key (if there is one).
            if (nextKey) {
                control.skip(nextKey.path.toArray());
            }
            else {
                control.done();
            }
        })
            .next(function () {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            while (nextKey) {
                callback(nextKey, null);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var _this = this;
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var startKey = query.path.toArray();
        var range = IDBKeyRange.lowerBound(startKey);
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (key, dbRemoteDoc, control) {
            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
                control.done();
            }
            else if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
                results = results.insert(maybeDoc.key, maybeDoc);
            }
        })
            .next(function () { return results; });
    };
    IndexedDbRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction) {
        var _this = this;
        assert(this.keepDocumentChangeLog, 'Can only call getNewDocumentChanges() when document change log is enabled');
        var changedKeys = documentKeySet();
        var changedDocs = maybeDocumentMap();
        var range = IDBKeyRange.lowerBound(this._lastProcessedDocumentChangeId + 1);
        var firstIteration = true;
        var changesStore = documentChangesStore(transaction);
        return changesStore
            .iterate({ range: range }, function (_, documentChange) {
            if (firstIteration) {
                firstIteration = false;
                // If our client was throttled for more than 30 minutes, another
                // client may have garbage collected the remote document changelog.
                if (_this._lastProcessedDocumentChangeId + 1 !== documentChange.id) {
                    // Reset the `lastProcessedDocumentChangeId` to allow further
                    // invocations to successfully return the changes after this
                    // rejection.
                    return _this.synchronizeLastDocumentChangeId(changesStore).next(function () {
                        return PersistencePromise.reject(new FirestoreError(Code.DATA_LOSS, REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG));
                    });
                }
            }
            changedKeys = changedKeys.unionWith(_this.serializer.fromDbResourcePaths(documentChange.changes));
            _this._lastProcessedDocumentChangeId = documentChange.id;
        })
            .next(function () {
            var documentPromises = [];
            changedKeys.forEach(function (key) {
                documentPromises.push(_this.getEntry(transaction, key).next(function (maybeDocument) {
                    var doc = maybeDocument ||
                        new NoDocument(key, SnapshotVersion.forDeletedDoc());
                    changedDocs = changedDocs.insert(key, doc);
                }));
            });
            return PersistencePromise.waitFor(documentPromises);
        })
            .next(function () { return changedDocs; });
    };
    /**
     * Removes all changes in the remote document changelog through `changeId`
     * (inclusive).
     */
    IndexedDbRemoteDocumentCache.prototype.removeDocumentChangesThroughChangeId = function (transaction, changeId) {
        var range = IDBKeyRange.upperBound(changeId);
        return documentChangesStore(transaction).delete(range);
    };
    IndexedDbRemoteDocumentCache.prototype.synchronizeLastDocumentChangeId = function (documentChangesStore) {
        var _this = this;
        // If there are no existing changes, we set `lastProcessedDocumentChangeId`
        // to 0 since IndexedDb's auto-generated keys start at 1.
        this._lastProcessedDocumentChangeId = 0;
        return documentChangesStore.iterate({ keysOnly: true, reverse: true }, function (key, value, control) {
            _this._lastProcessedDocumentChangeId = key;
            control.done();
        });
    };
    IndexedDbRemoteDocumentCache.prototype.newChangeBuffer = function () {
        return new IndexedDbRemoteDocumentChangeBuffer(this);
    };
    IndexedDbRemoteDocumentCache.prototype.getSize = function (txn) {
        return this.getMetadata(txn).next(function (metadata) { return metadata.byteSize; });
    };
    IndexedDbRemoteDocumentCache.prototype.getMetadata = function (txn) {
        return documentGlobalStore(txn)
            .get(DbRemoteDocumentGlobal.key)
            .next(function (metadata) {
            assert(!!metadata, 'Missing document cache metadata');
            return metadata;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.setMetadata = function (txn, metadata) {
        return documentGlobalStore(txn).put(DbRemoteDocumentGlobal.key, metadata);
    };
    /**
     * Adds the given delta to the cached current size. Callers to removeEntry *must* call this
     * afterwards to update the size of the cache.
     *
     * @param sizeDelta
     */
    IndexedDbRemoteDocumentCache.prototype.updateSize = function (txn, sizeDelta) {
        var _this = this;
        return this.getMetadata(txn).next(function (metadata) {
            metadata.byteSize += sizeDelta;
            return _this.setMetadata(txn, metadata);
        });
    };
    return IndexedDbRemoteDocumentCache;
}());
function documentGlobalStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentGlobal.store);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache
 */
var IndexedDbRemoteDocumentChangeBuffer = /** @class */ (function (_super) {
    tslib_1.__extends(IndexedDbRemoteDocumentChangeBuffer, _super);
    function IndexedDbRemoteDocumentChangeBuffer(documentCache) {
        var _this = _super.call(this) || this;
        _this.documentCache = documentCache;
        return _this;
    }
    IndexedDbRemoteDocumentChangeBuffer.prototype.applyChanges = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var delta = 0;
        var toApply = [];
        changes.forEach(function (key, maybeDocument) {
            var doc = _this.documentCache.serializer.toDbRemoteDocument(maybeDocument);
            var previousSize = _this.documentSizes.get(key);
            // NOTE: if we ever decide we need to support doing writes without
            // reading first, this assert will need to change to do the read automatically.
            assert(previousSize !== undefined, "Attempting to change document " + key.toString() + " without having read it first");
            var size = dbDocumentSize(doc);
            delta += size - previousSize;
            toApply.push({ key: key, doc: doc });
        });
        return this.documentCache.addEntries(transaction, toApply, delta);
    };
    IndexedDbRemoteDocumentChangeBuffer.prototype.getFromCache = function (transaction, documentKey) {
        return this.documentCache.getSizedEntry(transaction, documentKey);
    };
    IndexedDbRemoteDocumentChangeBuffer.prototype.getAllFromCache = function (transaction, documentKeys) {
        return this.documentCache.getSizedEntries(transaction, documentKeys);
    };
    return IndexedDbRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer));
function isDocumentChangeMissingError(err) {
    return (err.code === Code.DATA_LOSS &&
        err.message === REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */
function remoteDocumentsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocument.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocumentChanges object
 * store.
 */
function documentChangesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentChanges.store);
}
function dbKey(docKey) {
    return docKey.path.toArray();
}
/**
 * Retrusn an approximate size for the given document.
 */
function dbDocumentSize(doc) {
    var value;
    if (doc.document) {
        value = doc.document;
    }
    else if (doc.unknownDocument) {
        value = doc.unknownDocument;
    }
    else if (doc.noDocument) {
        value = doc.noDocument;
    }
    else {
        throw fail('Unknown remote document type');
    }
    return JSON.stringify(value).length;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Schema Version for the Web client:
 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
 *    Cache
 * 2. Used to ensure a targetGlobal object exists and add targetCount to it. No
 *    longer required because migration 3 unconditionally clears it.
 * 3. Dropped and re-created Query Cache to deal with cache corruption related
 *    to limbo resolution. Addresses
 *    https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4. Multi-Tab Support.
 * 5. Removal of held write acks.
 * 6. Create document global for tracking document cache size.
 * 7. Ensure every cached document has a sentinel row with a sequence number.
 */
var SCHEMA_VERSION = 7;
/** Performs database creation and schema upgrades. */
var SchemaConverter = /** @class */ (function () {
    function SchemaConverter(serializer) {
        this.serializer = serializer;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */
    SchemaConverter.prototype.createOrUpgrade = function (db, txn, fromVersion, toVersion) {
        var _this = this;
        assert(fromVersion < toVersion &&
            fromVersion >= 0 &&
            toVersion <= SCHEMA_VERSION, "Unexpected schema upgrade from v" + fromVersion + " to v{toVersion}.");
        if (fromVersion < 1 && toVersion >= 1) {
            createPrimaryClientStore(db);
            createMutationQueue(db);
            createQueryCache(db);
            createRemoteDocumentCache(db);
        }
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var p = PersistencePromise.resolve();
        if (fromVersion < 3 && toVersion >= 3) {
            // Brand new clients don't need to drop and recreate--only clients that
            // potentially have corrupt data.
            if (fromVersion !== 0) {
                dropQueryCache(db);
                createQueryCache(db);
            }
            p = p.next(function () { return writeEmptyTargetGlobalEntry(txn); });
        }
        if (fromVersion < 4 && toVersion >= 4) {
            if (fromVersion !== 0) {
                // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                p = p.next(function () { return upgradeMutationBatchSchemaAndMigrateData(db, txn); });
            }
            p = p.next(function () {
                createClientMetadataStore(db);
                createRemoteDocumentChangesStore(db);
            });
        }
        if (fromVersion < 5 && toVersion >= 5) {
            p = p.next(function () { return _this.removeAcknowledgedMutations(txn); });
        }
        if (fromVersion < 6 && toVersion >= 6) {
            p = p.next(function () {
                createDocumentGlobalStore(db);
                return _this.addDocumentGlobal(txn);
            });
        }
        if (fromVersion < 7 && toVersion >= 7) {
            p = p.next(function () { return _this.ensureSequenceNumbers(txn); });
        }
        return p;
    };
    SchemaConverter.prototype.addDocumentGlobal = function (txn) {
        var byteCount = 0;
        return txn
            .store(DbRemoteDocument.store)
            .iterate(function (_, doc) {
            byteCount += dbDocumentSize(doc);
        })
            .next(function () {
            var metadata = new DbRemoteDocumentGlobal(byteCount);
            return txn
                .store(DbRemoteDocumentGlobal.store)
                .put(DbRemoteDocumentGlobal.key, metadata);
        });
    };
    SchemaConverter.prototype.removeAcknowledgedMutations = function (txn) {
        var _this = this;
        var queuesStore = txn.store(DbMutationQueue.store);
        var mutationsStore = txn.store(DbMutationBatch.store);
        return queuesStore.loadAll().next(function (queues) {
            return PersistencePromise.forEach(queues, function (queue) {
                var range = IDBKeyRange.bound([queue.userId, BATCHID_UNKNOWN], [queue.userId, queue.lastAcknowledgedBatchId]);
                return mutationsStore
                    .loadAll(DbMutationBatch.userMutationsIndex, range)
                    .next(function (dbBatches) {
                    return PersistencePromise.forEach(dbBatches, function (dbBatch) {
                        assert(dbBatch.userId === queue.userId, "Cannot process batch " + dbBatch.batchId + " from unexpected user");
                        var batch = _this.serializer.fromDbMutationBatch(dbBatch);
                        return removeMutationBatch(txn, queue.userId, batch).next(function () { });
                    });
                });
            });
        });
    };
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */
    SchemaConverter.prototype.ensureSequenceNumbers = function (txn) {
        var documentTargetStore$$1 = txn.store(DbTargetDocument.store);
        var documentsStore = txn.store(DbRemoteDocument.store);
        return getHighestListenSequenceNumber(txn).next(function (currentSequenceNumber) {
            var writeSentinelKey = function (path) {
                return documentTargetStore$$1.put(new DbTargetDocument(0, encode(path), currentSequenceNumber));
            };
            var promises = [];
            return documentsStore
                .iterate(function (key, doc) {
                var path = new ResourcePath(key);
                var docSentinelKey = sentinelKey(path);
                promises.push(documentTargetStore$$1.get(docSentinelKey).next(function (maybeSentinel) {
                    if (!maybeSentinel) {
                        return writeSentinelKey(path);
                    }
                    else {
                        return PersistencePromise.resolve();
                    }
                }));
            })
                .next(function () { return PersistencePromise.waitFor(promises); });
        });
    };
    return SchemaConverter;
}());
function sentinelKey(path) {
    return [0, encode(path)];
}
/**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */
var DbTimestamp = /** @class */ (function () {
    function DbTimestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
    }
    return DbTimestamp;
}());
/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can have a single primary tab assigned at a given time. That
 * tab must validate that it is still holding the primary lease before every
 * operation that requires locked access. The primary tab should regularly
 * write an updated timestamp to this lease to prevent other tabs from
 * "stealing" the primary lease
 */
var DbPrimaryClient = /** @class */ (function () {
    function DbPrimaryClient(ownerId, 
    /** Whether to allow shared access from multiple tabs. */
    allowTabSynchronization, leaseTimestampMs) {
        this.ownerId = ownerId;
        this.allowTabSynchronization = allowTabSynchronization;
        this.leaseTimestampMs = leaseTimestampMs;
    }
    /**
     * Name of the IndexedDb object store.
     *
     * Note that the name 'owner' is chosen to ensure backwards compatibility with
     * older clients that only supported single locked access to the persistence
     * layer.
     */
    DbPrimaryClient.store = 'owner';
    /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */
    DbPrimaryClient.key = 'owner';
    return DbPrimaryClient;
}());
function createPrimaryClientStore(db) {
    db.createObjectStore(DbPrimaryClient.store);
}
/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */
var DbMutationQueue = /** @class */ (function () {
    function DbMutationQueue(
    /**
     * The normalized user ID to which this queue belongs.
     */
    userId, 
    /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */
    lastAcknowledgedBatchId, 
    /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     */
    lastStreamToken) {
        this.userId = userId;
        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
        this.lastStreamToken = lastStreamToken;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationQueue.store = 'mutationQueues';
    /** Keys are automatically assigned via the userId property. */
    DbMutationQueue.keyPath = 'userId';
    return DbMutationQueue;
}());
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */
var DbMutationBatch = /** @class */ (function () {
    function DbMutationBatch(
    /**
     * The normalized user ID to which this batch belongs.
     */
    userId, 
    /**
     * An identifier for this batch, allocated using an auto-generated key.
     */
    batchId, 
    /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */
    localWriteTimeMs, 
    /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via JsonProtoSerializer.toMutation().
     */
    mutations) {
        this.userId = userId;
        this.batchId = batchId;
        this.localWriteTimeMs = localWriteTimeMs;
        this.mutations = mutations;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationBatch.store = 'mutations';
    /** Keys are automatically assigned via the userId, batchId properties. */
    DbMutationBatch.keyPath = 'batchId';
    /** The index name for lookup of mutations by user. */
    DbMutationBatch.userMutationsIndex = 'userMutationsIndex';
    /** The user mutations index is keyed by [userId, batchId] pairs. */
    DbMutationBatch.userMutationsKeyPath = ['userId', 'batchId'];
    return DbMutationBatch;
}());
function createMutationQueue(db) {
    db.createObjectStore(DbMutationQueue.store, {
        keyPath: DbMutationQueue.keyPath
    });
    var mutationBatchesStore = db.createObjectStore(DbMutationBatch.store, {
        keyPath: DbMutationBatch.keyPath,
        autoIncrement: true
    });
    mutationBatchesStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
    db.createObjectStore(DbDocumentMutation.store);
}
/**
 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
 * and rewrites all data.
 */
function upgradeMutationBatchSchemaAndMigrateData(db, txn) {
    var v1MutationsStore = txn.store(DbMutationBatch.store);
    return v1MutationsStore.loadAll().next(function (existingMutations) {
        db.deleteObjectStore(DbMutationBatch.store);
        var mutationsStore = db.createObjectStore(DbMutationBatch.store, {
            keyPath: DbMutationBatch.keyPath,
            autoIncrement: true
        });
        mutationsStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
        var v3MutationsStore = txn.store(DbMutationBatch.store);
        var writeAll = existingMutations.map(function (mutation) {
            return v3MutationsStore.put(mutation);
        });
        return PersistencePromise.waitFor(writeAll);
    });
}
/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */
var DbDocumentMutation = /** @class */ (function () {
    function DbDocumentMutation() {
    }
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */
    DbDocumentMutation.prefixForUser = function (userId) {
        return [userId];
    };
    /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */
    DbDocumentMutation.prefixForPath = function (userId, path) {
        return [userId, encode(path)];
    };
    /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */
    DbDocumentMutation.key = function (userId, path, batchId) {
        return [userId, encode(path), batchId];
    };
    DbDocumentMutation.store = 'documentMutations';
    /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */
    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
    return DbDocumentMutation;
}());
function createRemoteDocumentCache(db) {
    db.createObjectStore(DbRemoteDocument.store);
}
/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbNoDocument = /** @class */ (function () {
    function DbNoDocument(path, readTime) {
        this.path = path;
        this.readTime = readTime;
    }
    return DbNoDocument;
}());
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbUnknownDocument = /** @class */ (function () {
    function DbUnknownDocument(path, version) {
        this.path = path;
        this.version = version;
    }
    return DbUnknownDocument;
}());
/**
 * An object to be stored in the 'remoteDocuments' store in IndexedDb.
 * It represents either:
 *
 * - A complete document.
 * - A "no document" representing a document that is known not to exist (at
 * some version).
 * - An "unknown document" representing a document that is known to exist (at
 * some version) but whose contents are unknown.
 *
 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
 * be made more general if necessary.
 */
var DbRemoteDocument = /** @class */ (function () {
    function DbRemoteDocument(
    /**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */
    unknownDocument, 
    /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */
    noDocument, 
    /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */
    document, 
    /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */
    hasCommittedMutations) {
        this.unknownDocument = unknownDocument;
        this.noDocument = noDocument;
        this.document = document;
        this.hasCommittedMutations = hasCommittedMutations;
    }
    DbRemoteDocument.store = 'remoteDocuments';
    return DbRemoteDocument;
}());
/**
 * Contains a single entry that has metadata about the remote document cache.
 */
var DbRemoteDocumentGlobal = /** @class */ (function () {
    /**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */
    function DbRemoteDocumentGlobal(byteSize) {
        this.byteSize = byteSize;
    }
    DbRemoteDocumentGlobal.store = 'remoteDocumentGlobal';
    DbRemoteDocumentGlobal.key = 'remoteDocumentGlobalKey';
    return DbRemoteDocumentGlobal;
}());
function createDocumentGlobalStore(db) {
    db.createObjectStore(DbRemoteDocumentGlobal.store);
}
/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */
var DbTarget = /** @class */ (function () {
    function DbTarget(
    /**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */
    targetId, 
    /**
     * The canonical string representing this query. This is not unique.
     */
    canonicalId, 
    /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */
    readTime, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */
    resumeToken, 
    /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */
    lastListenSequenceNumber, 
    /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */
    query) {
        this.targetId = targetId;
        this.canonicalId = canonicalId;
        this.readTime = readTime;
        this.resumeToken = resumeToken;
        this.lastListenSequenceNumber = lastListenSequenceNumber;
        this.query = query;
    }
    DbTarget.store = 'targets';
    /** Keys are automatically assigned via the targetId property. */
    DbTarget.keyPath = 'targetId';
    /** The name of the queryTargets index. */
    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
    /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */
    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
    return DbTarget;
}());
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */
var DbTargetDocument = /** @class */ (function () {
    function DbTargetDocument(
    /**
     * The targetId identifying a target or 0 for a sentinel row.
     */
    targetId, 
    /**
     * The path to the document, as encoded in the key.
     */
    path, 
    /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */
    sequenceNumber) {
        this.targetId = targetId;
        this.path = path;
        this.sequenceNumber = sequenceNumber;
        assert((targetId === 0) === (sequenceNumber !== undefined), 
        // tslint:disable-next-line:max-line-length
        'A target-document row must either have targetId == 0 and a defined sequence number, or a non-zero targetId and no sequence number');
    }
    /** Name of the IndexedDb object store.  */
    DbTargetDocument.store = 'targetDocuments';
    /** Keys are automatically assigned via the targetId, path properties. */
    DbTargetDocument.keyPath = ['targetId', 'path'];
    /** The index name for the reverse index. */
    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
    /** We also need to create the reverse index for these properties. */
    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
    return DbTargetDocument;
}());
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */
var DbTargetGlobal = /** @class */ (function () {
    function DbTargetGlobal(
    /**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */
    highestTargetId, 
    /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */
    highestListenSequenceNumber, 
    /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */
    lastRemoteSnapshotVersion, 
    /**
     * The number of targets persisted.
     */
    targetCount) {
        this.highestTargetId = highestTargetId;
        this.highestListenSequenceNumber = highestListenSequenceNumber;
        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        this.targetCount = targetCount;
    }
    /**
     * The key string used for the single object that exists in the
     * DbTargetGlobal store.
     */
    DbTargetGlobal.key = 'targetGlobalKey';
    DbTargetGlobal.store = 'targetGlobal';
    return DbTargetGlobal;
}());
function createQueryCache(db) {
    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, {
        keyPath: DbTargetDocument.keyPath
    });
    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
    var targetStore = db.createObjectStore(DbTarget.store, {
        keyPath: DbTarget.keyPath
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
    db.createObjectStore(DbTargetGlobal.store);
}
function dropQueryCache(db) {
    db.deleteObjectStore(DbTargetDocument.store);
    db.deleteObjectStore(DbTarget.store);
    db.deleteObjectStore(DbTargetGlobal.store);
}
/**
 * Creates the target global singleton row.
 *
 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
 */
function writeEmptyTargetGlobalEntry(txn) {
    var globalStore = txn.store(DbTargetGlobal.store);
    var metadata = new DbTargetGlobal(
    /*highestTargetId=*/ 0, 
    /*lastListenSequenceNumber=*/ 0, SnapshotVersion.MIN.toTimestamp(), 
    /*targetCount=*/ 0);
    return globalStore.put(DbTargetGlobal.key, metadata);
}
/**
 * An object store to store the keys of changed documents. This is used to
 * facilitate storing document changelogs in the Remote Document Cache.
 *
 * PORTING NOTE: This is used for change propagation during multi-tab syncing
 * and not needed on iOS and Android.
 */
var DbRemoteDocumentChanges = /** @class */ (function () {
    function DbRemoteDocumentChanges(
    /** The keys of the changed documents. */
    changes) {
        this.changes = changes;
    }
    /** Name of the IndexedDb object store.  */
    DbRemoteDocumentChanges.store = 'remoteDocumentChanges';
    /** Keys are auto-generated via the `id` property. */
    DbRemoteDocumentChanges.keyPath = 'id';
    return DbRemoteDocumentChanges;
}());
function createRemoteDocumentChangesStore(db) {
    db.createObjectStore(DbRemoteDocumentChanges.store, {
        keyPath: 'id',
        autoIncrement: true
    });
}
/**
 * A record of the metadata state of each client.
 *
 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
 * to be ported to iOS or Android.
 */
var DbClientMetadata = /** @class */ (function () {
    function DbClientMetadata(
    /** The auto-generated client id assigned at client startup. */
    clientId, 
    /** The last time this state was updated. */
    updateTimeMs, 
    /** Whether the client's network connection is enabled. */
    networkEnabled, 
    /** Whether this client is running in a foreground tab. */
    inForeground, 
    /**
     * The last change read from the DbRemoteDocumentChanges store.
     * Can be undefined for backwards compatibility.
     */
    lastProcessedDocumentChangeId) {
        this.clientId = clientId;
        this.updateTimeMs = updateTimeMs;
        this.networkEnabled = networkEnabled;
        this.inForeground = inForeground;
        this.lastProcessedDocumentChangeId = lastProcessedDocumentChangeId;
    }
    /** Name of the IndexedDb object store. */
    DbClientMetadata.store = 'clientMetadata';
    /** Keys are automatically assigned via the clientId properties. */
    DbClientMetadata.keyPath = 'clientId';
    return DbClientMetadata;
}());
function createClientMetadataStore(db) {
    db.createObjectStore(DbClientMetadata.store, {
        keyPath: DbClientMetadata.keyPath
    });
}
// Visible for testing
var V1_STORES = [
    DbMutationQueue.store,
    DbMutationBatch.store,
    DbDocumentMutation.store,
    DbRemoteDocument.store,
    DbTarget.store,
    DbPrimaryClient.store,
    DbTargetGlobal.store,
    DbTargetDocument.store
];
// V2 is no longer usable (see comment at top of file)
// Visible for testing
var V3_STORES = V1_STORES;
// Visible for testing
var V4_STORES = V3_STORES.concat([
    DbClientMetadata.store,
    DbRemoteDocumentChanges.store
]);
// V5 does not change the set of stores.
var V6_STORES = V4_STORES.concat([DbRemoteDocumentGlobal.store]);
/**
 * The list of all default IndexedDB stores used throughout the SDK. This is
 * used when creating transactions so that access across all stores is done
 * atomically.
 */
var ALL_STORES = V6_STORES;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** A mutation queue for a specific user, backed by IndexedDB. */
var IndexedDbMutationQueue = /** @class */ (function () {
    function IndexedDbMutationQueue(
    /**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */
    userId, serializer, referenceDelegate) {
        this.userId = userId;
        this.serializer = serializer;
        this.referenceDelegate = referenceDelegate;
        /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */
        // PORTING NOTE: Multi-tab only.
        this.documentKeysByBatchId = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */
    IndexedDbMutationQueue.forUser = function (user, serializer, referenceDelegate) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        assert(user.uid !== '', 'UserID must not be an empty string.');
        var userId = user.isAuthenticated() ? user.uid : '';
        return new IndexedDbMutationQueue(userId, serializer, referenceDelegate);
    };
    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
        var empty = true;
        var range = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, value, control) {
            empty = false;
            control.done();
        })
            .next(function () { return empty; });
    };
    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) { return metadata.lastStreamToken; });
    };
    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
        var _this = this;
        var documentStore = documentMutationsStore(transaction);
        var mutationStore = mutationsStore(transaction);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // tslint:disable-next-line:no-any We write an empty object to obtain key
        return mutationStore.add({}).next(function (batchId) {
            assert(typeof batchId === 'number', 'Auto-generated key is not a number');
            var batch = new MutationBatch(batchId, localWriteTime, mutations);
            var dbBatch = _this.serializer.toDbMutationBatch(_this.userId, batch);
            _this.documentKeysByBatchId[batchId] = batch.keys();
            var promises = [];
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                var indexKey = DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
                promises.push(mutationStore.put(dbBatch));
                promises.push(documentStore.put(indexKey, DbDocumentMutation.PLACEHOLDER));
            }
            return PersistencePromise.waitFor(promises).next(function () { return batch; });
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        var _this = this;
        return mutationsStore(transaction)
            .get(batchId)
            .next(function (dbBatch) {
            if (dbBatch) {
                assert(dbBatch.userId === _this.userId, "Unexpected user '" + dbBatch.userId + "' for mutation batch " + batchId);
                return _this.serializer.fromDbMutationBatch(dbBatch);
            }
            return null;
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var _this = this;
        if (this.documentKeysByBatchId[batchId]) {
            return PersistencePromise.resolve(this.documentKeysByBatchId[batchId]);
        }
        else {
            return this.lookupMutationBatch(transaction, batchId).next(function (batch) {
                if (batch) {
                    var keys = batch.keys();
                    _this.documentKeysByBatchId[batchId] = keys;
                    return keys;
                }
                else {
                    return null;
                }
            });
        }
    };
    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var _this = this;
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            var nextBatchId = batchId + 1;
            var range = IDBKeyRange.lowerBound([_this.userId, nextBatchId]);
            var foundBatch = null;
            return mutationsStore(transaction)
                .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, dbBatch, control) {
                if (dbBatch.userId === _this.userId) {
                    assert(dbBatch.batchId >= nextBatchId, 'Should have found mutation after ' + nextBatchId);
                    foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
                }
                control.done();
            })
                .next(function () { return foundBatch; });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        var _this = this;
        var range = IDBKeyRange.bound([this.userId, BATCHID_UNKNOWN], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .loadAll(DbMutationBatch.userMutationsIndex, range)
            .next(function (dbBatches) {
            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        var results = [];
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchId = indexKey[2];
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            var path = decode(encodedPath);
            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                control.done();
                return;
            }
            // Look up the mutation batch in the store.
            return mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (!mutation) {
                    throw fail('Dangling document-mutation reference found: ' +
                        indexKey +
                        ' which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            });
        })
            .next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        var promises = [];
        documentKeys.forEach(function (documentKey) {
            var indexStart = DbDocumentMutation.prefixForPath(_this.userId, documentKey.path);
            var range = IDBKeyRange.lowerBound(indexStart);
            var promise = documentMutationsStore(transaction).iterate({ range: range }, function (indexKey, _, control) {
                var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                var path = decode(encodedPath);
                if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                    control.done();
                    return;
                }
                uniqueBatchIDs = uniqueBatchIDs.add(batchID);
            });
            promises.push(promise);
        });
        return PersistencePromise.waitFor(promises).next(function () {
            return _this.lookupMutationBatches(transaction, uniqueBatchIDs);
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        var _this = this;
        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
        var queryPath = query.path;
        var immediateChildrenLength = queryPath.length + 1;
        // TODO(mcg): Actually implement a single-collection query
        //
        // This is actually executing an ancestor query, traversing the whole
        // subtree below the collection which can be horrifically inefficient for
        // some structures. The right way to solve this is to implement the full
        // value index, but that's not in the cards in the near future so this is
        // the best we can do for the moment.
        //
        // Since we don't yet index the actual properties in the mutations, our
        // current approach is to just return all mutation batches that affect
        // documents in the collection being queried.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, queryPath);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
            var path = decode(encodedPath);
            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
                control.done();
                return;
            }
            // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            if (path.length !== immediateChildrenLength) {
                return;
            }
            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
        })
            .next(function () { return _this.lookupMutationBatches(transaction, uniqueBatchIDs); });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatches = function (transaction, batchIDs) {
        var _this = this;
        var results = [];
        var promises = [];
        // TODO(rockwood): Implement this using iterate.
        batchIDs.forEach(function (batchId) {
            promises.push(mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (mutation === null) {
                    throw fail('Dangling document-mutation reference found, ' +
                        'which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            }));
        });
        return PersistencePromise.waitFor(promises).next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        return removeMutationBatch(transaction.simpleDbTransaction, this.userId, batch).next(function (removedDocuments) {
            _this.removeCachedMutationKeys(batch.batchId);
            return PersistencePromise.forEach(removedDocuments, function (key) {
                return _this.referenceDelegate.removeMutationReference(transaction, key);
            });
        });
    };
    IndexedDbMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        delete this.documentKeysByBatchId[batchId];
    };
    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
        var _this = this;
        return this.checkEmpty(txn).next(function (empty) {
            if (!empty) {
                return PersistencePromise.resolve();
            }
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var startRange = IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));
            var danglingMutationReferences = [];
            return documentMutationsStore(txn)
                .iterate({ range: startRange }, function (key, _, control) {
                var userID = key[0];
                if (userID !== _this.userId) {
                    control.done();
                    return;
                }
                else {
                    var path = decode(key[1]);
                    danglingMutationReferences.push(path);
                }
            })
                .next(function () {
                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. ' +
                    'Dangling keys: ' +
                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
            });
        });
    };
    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
        return mutationQueueContainsKey(txn, this.userId, key);
    };
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */
    IndexedDbMutationQueue.prototype.getMutationQueueMetadata = function (transaction) {
        var _this = this;
        return mutationQueuesStore(transaction)
            .get(this.userId)
            .next(function (metadata) {
            return (metadata ||
                new DbMutationQueue(_this.userId, BATCHID_UNKNOWN, 
                /*lastStreamToken=*/ ''));
        });
    };
    return IndexedDbMutationQueue;
}());
/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */
function mutationQueueContainsKey(txn, userId, key) {
    var indexKey = DbDocumentMutation.prefixForPath(userId, key.path);
    var encodedPath = indexKey[1];
    var startRange = IDBKeyRange.lowerBound(indexKey);
    var containsKey = false;
    return documentMutationsStore(txn)
        .iterate({ range: startRange, keysOnly: true }, function (key, value, control) {
        var userID = key[0], keyPath = key[1], /*batchID*/ _ = key[2];
        if (userID === userId && keyPath === encodedPath) {
            containsKey = true;
        }
        control.done();
    })
        .next(function () { return containsKey; });
}
/** Returns true if any mutation queue contains the given document. */
function mutationQueuesContainKey(txn, docKey) {
    var found = false;
    return mutationQueuesStore(txn)
        .iterateSerial(function (userId) {
        return mutationQueueContainsKey(txn, userId, docKey).next(function (containsKey) {
            if (containsKey) {
                found = true;
            }
            return PersistencePromise.resolve(!containsKey);
        });
    })
        .next(function () { return found; });
}
/**
 * Delete a mutation batch and the associated document mutations.
 * @return A PersistencePromise of the document mutations that were removed.
 */
function removeMutationBatch(txn, userId, batch) {
    var mutationStore = txn.store(DbMutationBatch.store);
    var indexTxn = txn.store(DbDocumentMutation.store);
    var promises = [];
    var range = IDBKeyRange.only(batch.batchId);
    var numDeleted = 0;
    var removePromise = mutationStore.iterate({ range: range }, function (key, value, control) {
        numDeleted++;
        return control.delete();
    });
    promises.push(removePromise.next(function () {
        assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
            batch.batchId);
    }));
    var removedDocuments = [];
    for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
        var mutation = _a[_i];
        var indexKey = DbDocumentMutation.key(userId, mutation.key.path, batch.batchId);
        promises.push(indexTxn.delete(indexKey));
        removedDocuments.push(mutation.key);
    }
    return PersistencePromise.waitFor(promises).next(function () { return removedDocuments; });
}
function convertStreamToken(token) {
    if (token instanceof Uint8Array) {
        // TODO(b/78771403): Convert tokens to strings during deserialization
        assert(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_api_key":""}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence.');
        return token.toString();
    }
    else {
        return token;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */
function mutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationBatch.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function documentMutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbDocumentMutation.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function mutationQueuesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationQueue.store);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Serializer for values stored in the LocalStore. */
var LocalSerializer = /** @class */ (function () {
    function LocalSerializer(remoteSerializer) {
        this.remoteSerializer = remoteSerializer;
    }
    /** Decodes a remote document from storage locally to a Document. */
    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
        if (remoteDoc.document) {
            return this.remoteSerializer.fromDocument(remoteDoc.document, !!remoteDoc.hasCommittedMutations);
        }
        else if (remoteDoc.noDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.noDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.noDocument.readTime);
            return new NoDocument(key, version, {
                hasCommittedMutations: !!remoteDoc.hasCommittedMutations
            });
        }
        else if (remoteDoc.unknownDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.unknownDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.unknownDocument.version);
            return new UnknownDocument(key, version);
        }
        else {
            return fail('Unexpected DbRemoteDocument');
        }
    };
    /** Encodes a document for storage locally. */
    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            var doc = maybeDoc.proto
                ? maybeDoc.proto
                : this.remoteSerializer.toDocument(maybeDoc);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, 
            /* noDocument= */ null, doc, hasCommittedMutations);
        }
        else if (maybeDoc instanceof NoDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime = this.toDbTimestamp(maybeDoc.version);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, new DbNoDocument(path, readTime), 
            /* document= */ null, hasCommittedMutations);
        }
        else if (maybeDoc instanceof UnknownDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime = this.toDbTimestamp(maybeDoc.version);
            return new DbRemoteDocument(new DbUnknownDocument(path, readTime), 
            /* noDocument= */ null, 
            /* document= */ null, 
            /* hasCommittedMutations= */ true);
        }
        else {
            return fail('Unexpected MaybeDocumment');
        }
    };
    LocalSerializer.prototype.toDbTimestamp = function (snapshotVersion) {
        var timestamp = snapshotVersion.toTimestamp();
        return new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
    };
    LocalSerializer.prototype.fromDbTimestamp = function (dbTimestamp) {
        var timestamp = new Timestamp(dbTimestamp.seconds, dbTimestamp.nanoseconds);
        return SnapshotVersion.fromTimestamp(timestamp);
    };
    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
        var _this = this;
        var serializedMutations = batch.mutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toMillis(), serializedMutations);
    };
    /** Decodes a DbMutationBatch into a MutationBatch */
    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
        var _this = this;
        var mutations = dbBatch.mutations.map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var timestamp = Timestamp.fromMillis(dbBatch.localWriteTimeMs);
        return new MutationBatch(dbBatch.batchId, timestamp, mutations);
    };
    /*
     * Encodes a set of document keys into an array of EncodedResourcePaths.
     */
    LocalSerializer.prototype.toDbResourcePaths = function (keys) {
        var encodedKeys = [];
        keys.forEach(function (key) {
            encodedKeys.push(encode(key.path));
        });
        return encodedKeys;
    };
    /** Decodes an array of EncodedResourcePaths into a set of document keys. */
    LocalSerializer.prototype.fromDbResourcePaths = function (encodedPaths) {
        var keys = documentKeySet();
        for (var _i = 0, encodedPaths_1 = encodedPaths; _i < encodedPaths_1.length; _i++) {
            var documentKey = encodedPaths_1[_i];
            keys = keys.add(new DocumentKey(decode(documentKey)));
        }
        return keys;
    };
    /** Decodes a DbTarget into QueryData */
    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
        var version = this.fromDbTimestamp(dbTarget.readTime);
        var query;
        if (isDocumentQuery(dbTarget.query)) {
            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
        }
        else {
            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
        }
        return new QueryData(query, dbTarget.targetId, QueryPurpose.Listen, dbTarget.lastListenSequenceNumber, version, dbTarget.resumeToken);
    };
    /** Encodes QueryData into a DbTarget for storage locally. */
    LocalSerializer.prototype.toDbTarget = function (queryData) {
        assert(QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' +
            QueryPurpose.Listen +
            ' may be stored, got ' +
            queryData.purpose);
        var dbTimestamp = this.toDbTimestamp(queryData.snapshotVersion);
        var queryProto;
        if (queryData.query.isDocumentQuery()) {
            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
        }
        else {
            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
        }
        var resumeToken;
        if (queryData.resumeToken instanceof Uint8Array) {
            // TODO(b/78771403): Convert tokens to strings during deserialization
            assert(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_api_key":""}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence .');
            resumeToken = queryData.resumeToken.toString();
        }
        else {
            resumeToken = queryData.resumeToken;
        }
        // lastListenSequenceNumber is always 0 until we do real GC.
        return new DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, queryData.sequenceNumber, queryProto);
    };
    return LocalSerializer;
}());
/**
 * A helper function for figuring out what kind of query has been stored.
 */
function isDocumentQuery(dbQuery) {
    return dbQuery.documents !== undefined;
}

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferEntryComparator(_a, _b) {
    var aSequence = _a[0], aIndex = _a[1];
    var bSequence = _b[0], bIndex = _b[1];
    var seqCmp = primitiveComparator(aSequence, bSequence);
    if (seqCmp === 0) {
        // This order doesn't matter, but we can bias against churn by sorting
        // entries created earlier as less than newer entries.
        return primitiveComparator(aIndex, bIndex);
    }
    else {
        return seqCmp;
    }
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */
var RollingSequenceNumberBuffer = /** @class */ (function () {
    function RollingSequenceNumberBuffer(maxElements) {
        this.maxElements = maxElements;
        this.buffer = new SortedSet(bufferEntryComparator);
        this.previousIndex = 0;
    }
    RollingSequenceNumberBuffer.prototype.nextIndex = function () {
        return ++this.previousIndex;
    };
    RollingSequenceNumberBuffer.prototype.addElement = function (sequenceNumber) {
        var entry = [sequenceNumber, this.nextIndex()];
        if (this.buffer.size < this.maxElements) {
            this.buffer = this.buffer.add(entry);
        }
        else {
            var highestValue = this.buffer.last();
            if (bufferEntryComparator(entry, highestValue) < 0) {
                this.buffer = this.buffer.delete(highestValue).add(entry);
            }
        }
    };
    Object.defineProperty(RollingSequenceNumberBuffer.prototype, "maxValue", {
        get: function () {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: true,
        configurable: true
    });
    return RollingSequenceNumberBuffer;
}());
var GC_DID_NOT_RUN = {
    didRun: false,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
var LruParams = /** @class */ (function () {
    function LruParams(
    // When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    cacheSizeCollectionThreshold, 
    // The percentage of sequence numbers that we will attempt to collect
    percentileToCollect, 
    // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    maximumSequenceNumbersToCollect) {
        this.cacheSizeCollectionThreshold = cacheSizeCollectionThreshold;
        this.percentileToCollect = percentileToCollect;
        this.maximumSequenceNumbersToCollect = maximumSequenceNumbersToCollect;
    }
    LruParams.withCacheSize = function (cacheSize) {
        return new LruParams(cacheSize, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    };
    LruParams.COLLECTION_DISABLED = -1;
    LruParams.MINIMUM_CACHE_SIZE_BYTES = 1 * 1024 * 1024;
    LruParams.DEFAULT_CACHE_SIZE_BYTES = 40 * 1024 * 1024;
    LruParams.DEFAULT_COLLECTION_PERCENTILE = 10;
    LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1000;
    LruParams.DEFAULT = new LruParams(LruParams.DEFAULT_CACHE_SIZE_BYTES, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    LruParams.DISABLED = new LruParams(LruParams.COLLECTION_DISABLED, 0, 0);
    return LruParams;
}());
/** How long we wait to try running LRU GC after SDK initialization. */
var INITIAL_GC_DELAY_MS = 1 * 60 * 1000;
/** Minimum amount of time between GC checks, after the first one. */
var REGULAR_GC_DELAY_MS = 5 * 60 * 1000;
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */
var LruScheduler = /** @class */ (function () {
    function LruScheduler(garbageCollector, asyncQueue, localStore) {
        this.garbageCollector = garbageCollector;
        this.asyncQueue = asyncQueue;
        this.localStore = localStore;
        this.gcTask = null;
    }
    LruScheduler.prototype.start = function () {
        assert(this.gcTask === null, 'Cannot start an already started LruScheduler');
        if (this.garbageCollector.params.cacheSizeCollectionThreshold !==
            LruParams.COLLECTION_DISABLED) {
            this.scheduleGC();
        }
    };
    LruScheduler.prototype.stop = function () {
        if (this.gcTask) {
            this.gcTask.cancel();
            this.gcTask = null;
        }
    };
    Object.defineProperty(LruScheduler.prototype, "started", {
        get: function () {
            return this.gcTask !== null;
        },
        enumerable: true,
        configurable: true
    });
    LruScheduler.prototype.scheduleGC = function () {
        var _this = this;
        assert(this.gcTask === null, 'Cannot schedule GC while a task is pending');
        var delay = this.hasRun ? REGULAR_GC_DELAY_MS : INITIAL_GC_DELAY_MS;
        debug('LruGarbageCollector', "Garbage collection scheduled in " + delay + "ms");
        this.gcTask = this.asyncQueue.enqueueAfterDelay(TimerId.LruGarbageCollection, delay, function () {
            _this.gcTask = null;
            _this.hasRun = true;
            return _this.localStore
                .collectGarbage(_this.garbageCollector)
                .then(function () { return _this.scheduleGC(); })
                .catch(ignoreIfPrimaryLeaseLoss);
        });
    };
    return LruScheduler;
}());
/** Implements the steps for LRU garbage collection. */
var LruGarbageCollector = /** @class */ (function () {
    function LruGarbageCollector(delegate, params) {
        this.delegate = delegate;
        this.params = params;
    }
    /** Given a percentile of target to collect, returns the number of targets to collect. */
    LruGarbageCollector.prototype.calculateTargetCount = function (txn, percentile) {
        return this.delegate.getSequenceNumberCount(txn).next(function (targetCount) {
            return Math.floor(percentile / 100.0 * targetCount);
        });
    };
    /** Returns the nth sequence number, counting in order from the smallest. */
    LruGarbageCollector.prototype.nthSequenceNumber = function (txn, n) {
        var _this = this;
        if (n === 0) {
            return PersistencePromise.resolve(ListenSequence.INVALID);
        }
        var buffer = new RollingSequenceNumberBuffer(n);
        return this.delegate
            .forEachTarget(txn, function (target) { return buffer.addElement(target.sequenceNumber); })
            .next(function () {
            return _this.delegate.forEachOrphanedDocumentSequenceNumber(txn, function (sequenceNumber) { return buffer.addElement(sequenceNumber); });
        })
            .next(function () { return buffer.maxValue; });
    };
    /**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */
    LruGarbageCollector.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.delegate.removeTargets(txn, upperBound, activeTargetIds);
    };
    /**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */
    LruGarbageCollector.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        return this.delegate.removeOrphanedDocuments(txn, upperBound);
    };
    LruGarbageCollector.prototype.collect = function (txn, activeTargetIds) {
        var _this = this;
        if (this.params.cacheSizeCollectionThreshold === LruParams.COLLECTION_DISABLED) {
            debug('LruGarbageCollector', 'Garbage collection skipped; disabled');
            return PersistencePromise.resolve(GC_DID_NOT_RUN);
        }
        return this.getCacheSize(txn).next(function (cacheSize) {
            if (cacheSize < _this.params.cacheSizeCollectionThreshold) {
                debug('LruGarbageCollector', "Garbage collection skipped; Cache size " + cacheSize + " " +
                    ("is lower than threshold " + _this.params.cacheSizeCollectionThreshold));
                return GC_DID_NOT_RUN;
            }
            else {
                return _this.runGarbageCollection(txn, activeTargetIds);
            }
        });
    };
    LruGarbageCollector.prototype.getCacheSize = function (txn) {
        return this.delegate.getCacheSize(txn);
    };
    LruGarbageCollector.prototype.runGarbageCollection = function (txn, activeTargetIds) {
        var _this = this;
        var upperBoundSequenceNumber;
        var sequenceNumbersToCollect, targetsRemoved;
        // Timestamps for various pieces of the process
        var startTs, countedTargetsTs, foundUpperBoundTs, removedTargetsTs, removedDocumentsTs;
        startTs = Date.now();
        return this.calculateTargetCount(txn, this.params.percentileToCollect)
            .next(function (sequenceNumbers) {
            // Cap at the configured max
            if (sequenceNumbers > _this.params.maximumSequenceNumbersToCollect) {
                debug('LruGarbageCollector', 'Capping sequence numbers to collect down ' +
                    ("to the maximum of " + _this.params.maximumSequenceNumbersToCollect + " ") +
                    ("from " + sequenceNumbers));
                sequenceNumbersToCollect = _this.params
                    .maximumSequenceNumbersToCollect;
            }
            else {
                sequenceNumbersToCollect = sequenceNumbers;
            }
            countedTargetsTs = Date.now();
            return _this.nthSequenceNumber(txn, sequenceNumbersToCollect);
        })
            .next(function (upperBound) {
            upperBoundSequenceNumber = upperBound;
            foundUpperBoundTs = Date.now();
            return _this.removeTargets(txn, upperBoundSequenceNumber, activeTargetIds);
        })
            .next(function (numTargetsRemoved) {
            targetsRemoved = numTargetsRemoved;
            removedTargetsTs = Date.now();
            return _this.removeOrphanedDocuments(txn, upperBoundSequenceNumber);
        })
            .next(function (documentsRemoved) {
            removedDocumentsTs = Date.now();
            if (getLogLevel() <= LogLevel.DEBUG) {
                var desc = 'LRU Garbage Collection\n' +
                    ("\tCounted targets in " + (countedTargetsTs - startTs) + "ms\n") +
                    ("\tDetermined least recently used " + sequenceNumbersToCollect + " in ") +
                    (foundUpperBoundTs - countedTargetsTs + "ms\n") +
                    ("\tRemoved " + targetsRemoved + " targets in ") +
                    (removedTargetsTs - foundUpperBoundTs + "ms\n") +
                    ("\tRemoved " + documentsRemoved + " documents in ") +
                    (removedDocumentsTs - removedTargetsTs + "ms\n") +
                    ("Total Duration: " + (removedDocumentsTs - startTs) + "ms");
                debug('LruGarbageCollector', desc);
            }
            return PersistencePromise.resolve({
                didRun: true,
                sequenceNumbersCollected: sequenceNumbersToCollect,
                targetsRemoved: targetsRemoved,
                documentsRemoved: documentsRemoved
            });
        });
    };
    return LruGarbageCollector;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Opaque interface representing a persistence transaction.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */
var PersistenceTransaction = /** @class */ (function () {
    function PersistenceTransaction() {
    }
    return PersistenceTransaction;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$2 = 'IndexedDbPersistence';
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data (such as the remote document
 * cache changelog) is garbage collected.
 */
var MAX_CLIENT_AGE_MS = 30 * 60 * 1000; // 30 minutes
/**
 * Oldest acceptable metadata age for clients that may participate in the
 * primary lease election. Clients that have not updated their client metadata
 * within 5 seconds are not eligible to receive a primary lease.
 */
var MAX_PRIMARY_ELIGIBLE_AGE_MS = 5000;
/**
 * The interval at which clients will update their metadata, including
 * refreshing their primary lease if held or potentially trying to acquire it if
 * not held.
 *
 * Primary clients may opportunistically refresh their metadata earlier
 * if they're already performing an IndexedDB operation.
 */
var CLIENT_METADATA_REFRESH_INTERVAL_MS = 4000;
/** User-facing error when the primary lease is required but not available. */
var PRIMARY_LEASE_LOST_ERROR_MSG = 'The current tab is not in the required state to perform this operation. ' +
    'It might be necessary to refresh the browser tab.';
var PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG = 'Another tab has exclusive access to the persistence layer. ' +
    'To allow shared access, make sure to invoke ' +
    '`enablePersistence()` with `experimentalTabSynchronization:true` in all tabs.';
var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
    ' IndexedDB or is known to have an incomplete implementation. Offline' +
    ' persistence has been disabled.';
// The format of the LocalStorage key that stores zombied client is:
//     firestore_zombie_<persistence_prefix>_<instance_key>
var ZOMBIED_CLIENTS_KEY_PREFIX = 'firestore_zombie';
var IndexedDbTransaction = /** @class */ (function (_super) {
    tslib_1.__extends(IndexedDbTransaction, _super);
    function IndexedDbTransaction(simpleDbTransaction, currentSequenceNumber) {
        var _this = _super.call(this) || this;
        _this.simpleDbTransaction = simpleDbTransaction;
        _this.currentSequenceNumber = currentSequenceNumber;
        return _this;
    }
    return IndexedDbTransaction;
}(PersistenceTransaction));
var IndexedDbPersistence = /** @class */ (function () {
    // Note that `multiClientParams` must be present to enable multi-client support while multi-tab
    // is still experimental. When multi-client is switched to always on, `multiClientParams` will
    // no longer be optional.
    function IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams) {
        this.persistenceKey = persistenceKey;
        this.clientId = clientId;
        this.queue = queue;
        this.multiClientParams = multiClientParams;
        this._started = false;
        this.isPrimary = false;
        this.networkEnabled = true;
        this.inForeground = false;
        /** The last time we garbage collected the Remote Document Changelog. */
        this.lastGarbageCollectionTime = Number.NEGATIVE_INFINITY;
        /** A listener to notify on primary state changes. */
        this.primaryStateListener = function (_) { return Promise.resolve(); };
        if (!IndexedDbPersistence.isAvailable()) {
            throw new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
        }
        this.referenceDelegate = new IndexedDbLruDelegate(this, lruParams);
        this.dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
        this.serializer = new LocalSerializer(serializer);
        this.document = platform.document;
        this.allowTabSynchronization = multiClientParams !== undefined;
        this.queryCache = new IndexedDbQueryCache(this.referenceDelegate, this.serializer);
        this.remoteDocumentCache = new IndexedDbRemoteDocumentCache(this.serializer, 
        /*keepDocumentChangeLog=*/ this.allowTabSynchronization);
        if (platform.window && platform.window.localStorage) {
            this.window = platform.window;
            this.webStorage = this.window.localStorage;
        }
        else {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
        }
    }
    IndexedDbPersistence.getStore = function (txn, store) {
        if (txn instanceof IndexedDbTransaction) {
            return SimpleDb.getStore(txn.simpleDbTransaction, store);
        }
        else {
            throw fail('IndexedDbPersistence must use instances of IndexedDbTransaction');
        }
    };
    IndexedDbPersistence.createIndexedDbPersistence = function (persistenceKey, clientId, platform, queue, serializer, lruParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistence = new IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    IndexedDbPersistence.createMultiClientIndexedDbPersistence = function (persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistence = new IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */
    IndexedDbPersistence.prototype.start = function () {
        var _this = this;
        assert(!this.started, 'IndexedDbPersistence double-started!');
        assert(this.window !== null, "Expected 'window' to be defined");
        return SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, new SchemaConverter(this.serializer))
            .then(function (db) {
            _this.simpleDb = db;
        })
            .then(function () { return _this.startRemoteDocumentCache(); })
            .then(function () {
            _this.attachVisibilityHandler();
            _this.attachWindowUnloadHook();
            return _this.updateClientMetadataAndTryBecomePrimary().then(function () {
                return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes();
            });
        })
            .then(function () {
            return _this.simpleDb.runTransaction('readonly', [DbTargetGlobal.store], function (txn) {
                return getHighestListenSequenceNumber(txn).next(function (highestListenSequenceNumber) {
                    var sequenceNumberSyncer = _this.multiClientParams
                        ? _this.multiClientParams.sequenceNumberSyncer
                        : undefined;
                    _this.listenSequence = new ListenSequence(highestListenSequenceNumber, sequenceNumberSyncer);
                });
            });
        })
            .then(function () {
            _this._started = true;
        })
            .catch(function (reason) {
            _this.simpleDb && _this.simpleDb.close();
            return Promise.reject(reason);
        });
    };
    IndexedDbPersistence.prototype.startRemoteDocumentCache = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly', ALL_STORES, function (txn) {
            return _this.remoteDocumentCache.start(txn);
        });
    };
    IndexedDbPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        var _this = this;
        this.primaryStateListener = function (primaryState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.started) {
                    return [2 /*return*/, primaryStateListener(primaryState)];
                }
                return [2 /*return*/];
            });
        }); };
        return primaryStateListener(this.isPrimary);
    };
    IndexedDbPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        var _this = this;
        if (this.networkEnabled !== networkEnabled) {
            this.networkEnabled = networkEnabled;
            // Schedule a primary lease refresh for immediate execution. The eventual
            // lease update will be propagated via `primaryStateListener`.
            this.queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.started) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.updateClientMetadataAndTryBecomePrimary()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */
    IndexedDbPersistence.prototype.updateClientMetadataAndTryBecomePrimary = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readwrite', ALL_STORES, function (txn) {
            var metadataStore = clientMetadataStore(txn);
            return metadataStore
                .put(new DbClientMetadata(_this.clientId, Date.now(), _this.networkEnabled, _this.inForeground, _this.remoteDocumentCache.lastProcessedDocumentChangeId))
                .next(function () {
                if (_this.isPrimary) {
                    return _this.verifyPrimaryLease(txn).next(function (success) {
                        if (!success) {
                            _this.isPrimary = false;
                            _this.queue.enqueueAndForget(function () {
                                return _this.primaryStateListener(false);
                            });
                        }
                    });
                }
            })
                .next(function () { return _this.canActAsPrimary(txn); })
                .next(function (canActAsPrimary) {
                var wasPrimary = _this.isPrimary;
                _this.isPrimary = canActAsPrimary;
                if (wasPrimary !== _this.isPrimary) {
                    _this.queue.enqueueAndForget(function () {
                        return _this.primaryStateListener(_this.isPrimary);
                    });
                }
                if (wasPrimary && !_this.isPrimary) {
                    return _this.releasePrimaryLeaseIfHeld(txn);
                }
                else if (_this.isPrimary) {
                    return _this.acquireOrExtendPrimaryLease(txn);
                }
            });
        });
    };
    IndexedDbPersistence.prototype.verifyPrimaryLease = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            return PersistencePromise.resolve(_this.isLocalClient(primaryClient));
        });
    };
    IndexedDbPersistence.prototype.removeClientMetadata = function (txn) {
        var metadataStore = clientMetadataStore(txn);
        return metadataStore.delete(this.clientId);
    };
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */
    IndexedDbPersistence.prototype.maybeGarbageCollectMultiClientState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var activeClients_1, inactiveClients_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isPrimary &&
                            !this.isWithinAge(this.lastGarbageCollectionTime, MAX_CLIENT_AGE_MS))) return [3 /*break*/, 2];
                        this.lastGarbageCollectionTime = Date.now();
                        inactiveClients_1 = [];
                        return [4 /*yield*/, this.runTransaction('maybeGarbageCollectMultiClientState', 'readwrite-primary', function (txn) {
                                var metadataStore = IndexedDbPersistence.getStore(txn, DbClientMetadata.store);
                                return metadataStore
                                    .loadAll()
                                    .next(function (existingClients) {
                                    activeClients_1 = _this.filterActiveClients(existingClients, MAX_CLIENT_AGE_MS);
                                    inactiveClients_1 = existingClients.filter(function (client) { return activeClients_1.indexOf(client) === -1; });
                                })
                                    .next(function () {
                                    // Delete metadata for clients that are no longer considered active.
                                    return PersistencePromise.forEach(inactiveClients_1, function (inactiveClient) {
                                        return metadataStore.delete(inactiveClient.clientId);
                                    });
                                })
                                    .next(function () {
                                    // Retrieve the minimum change ID from the set of active clients.
                                    // The primary client doesn't read from the document change log,
                                    // and hence we exclude it when we determine the minimum
                                    // `lastProcessedDocumentChangeId`.
                                    activeClients_1 = activeClients_1.filter(function (client) { return client.clientId !== _this.clientId; });
                                    if (activeClients_1.length > 0) {
                                        var processedChangeIds = activeClients_1.map(function (client) { return client.lastProcessedDocumentChangeId || 0; });
                                        var oldestChangeId = Math.min.apply(Math, processedChangeIds);
                                        return _this.remoteDocumentCache.removeDocumentChangesThroughChangeId(txn, oldestChangeId);
                                    }
                                });
                            })];
                    case 1:
                        _a.sent();
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        inactiveClients_1.forEach(function (inactiveClient) {
                            _this.window.localStorage.removeItem(_this.zombiedClientLocalStorageKey(inactiveClient.clientId));
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */
    IndexedDbPersistence.prototype.scheduleClientMetadataAndPrimaryLeaseRefreshes = function () {
        var _this = this;
        this.clientMetadataRefresher = this.queue.enqueueAfterDelay(TimerId.ClientMetadataRefresh, CLIENT_METADATA_REFRESH_INTERVAL_MS, function () {
            return _this.updateClientMetadataAndTryBecomePrimary()
                .then(function () { return _this.maybeGarbageCollectMultiClientState(); })
                .then(function () { return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes(); });
        });
    };
    /** Checks whether `client` is the local client. */
    IndexedDbPersistence.prototype.isLocalClient = function (client) {
        return client ? client.ownerId === this.clientId : false;
    };
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */
    IndexedDbPersistence.prototype.canActAsPrimary = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store
            .get(DbPrimaryClient.key)
            .next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            if (currentLeaseIsValid) {
                if (_this.isLocalClient(currentPrimary) && _this.networkEnabled) {
                    return true;
                }
                if (!_this.isLocalClient(currentPrimary)) {
                    if (!currentPrimary.allowTabSynchronization) {
                        // Fail the `canActAsPrimary` check if the current leaseholder has
                        // not opted into multi-tab synchronization. If this happens at
                        // client startup, we reject the Promise returned by
                        // `enablePersistence()` and the user can continue to use Firestore
                        // with in-memory persistence.
                        // If this fails during a lease refresh, we will instead block the
                        // AsyncQueue from executing further operations. Note that this is
                        // acceptable since mixing & matching different `synchronizeTabs`
                        // settings is not supported.
                        //
                        // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                        // no longer be turned off.
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                    }
                    return false;
                }
            }
            if (_this.networkEnabled && _this.inForeground) {
                return true;
            }
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (existingClients) {
                // Process all existing clients and determine whether at least one of
                // them is better suited to obtain the primary lease.
                var preferredCandidate = _this.filterActiveClients(existingClients, MAX_PRIMARY_ELIGIBLE_AGE_MS).find(function (otherClient) {
                    if (_this.clientId !== otherClient.clientId) {
                        var otherClientHasBetterNetworkState = !_this.networkEnabled && otherClient.networkEnabled;
                        var otherClientHasBetterVisibility = !_this.inForeground && otherClient.inForeground;
                        var otherClientHasSameNetworkState = _this.networkEnabled === otherClient.networkEnabled;
                        if (otherClientHasBetterNetworkState ||
                            (otherClientHasBetterVisibility &&
                                otherClientHasSameNetworkState)) {
                            return true;
                        }
                    }
                    return false;
                });
                return preferredCandidate === undefined;
            });
        })
            .next(function (canActAsPrimary) {
            if (_this.isPrimary !== canActAsPrimary) {
                debug(LOG_TAG$2, "Client " + (canActAsPrimary ? 'is' : 'is not') + " eligible for a primary lease.");
            }
            return canActAsPrimary;
        });
    };
    IndexedDbPersistence.prototype.shutdown = function (deleteData) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        this._started = false;
                        this.markClientZombied();
                        if (this.clientMetadataRefresher) {
                            this.clientMetadataRefresher.cancel();
                        }
                        this.detachVisibilityHandler();
                        this.detachWindowUnloadHook();
                        return [4 /*yield*/, this.simpleDb.runTransaction('readwrite', [DbPrimaryClient.store, DbClientMetadata.store], function (txn) {
                                return _this.releasePrimaryLeaseIfHeld(txn).next(function () {
                                    return _this.removeClientMetadata(txn);
                                });
                            })];
                    case 1:
                        _a.sent();
                        this.simpleDb.close();
                        // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.removeClientZombiedEntry();
                        if (!deleteData) return [3 /*break*/, 3];
                        return [4 /*yield*/, SimpleDb.delete(this.dbName)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */
    IndexedDbPersistence.prototype.filterActiveClients = function (clients, activityThresholdMs) {
        var _this = this;
        return clients.filter(function (client) {
            return _this.isWithinAge(client.updateTimeMs, activityThresholdMs) &&
                !_this.isClientZombied(client.clientId);
        });
    };
    IndexedDbPersistence.prototype.getActiveClients = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly', [DbClientMetadata.store], function (txn) {
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (clients) {
                return _this.filterActiveClients(clients, MAX_CLIENT_AGE_MS).map(function (clientMetadata) { return clientMetadata.clientId; });
            });
        });
    };
    Object.defineProperty(IndexedDbPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
        assert(this.started, 'Cannot initialize MutationQueue before persistence is started.');
        return IndexedDbMutationQueue.forUser(user, this.serializer, this.referenceDelegate);
    };
    IndexedDbPersistence.prototype.getQueryCache = function () {
        assert(this.started, 'Cannot initialize QueryCache before persistence is started.');
        return this.queryCache;
    };
    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
        assert(this.started, 'Cannot initialize RemoteDocumentCache before persistence is started.');
        return this.remoteDocumentCache;
    };
    IndexedDbPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$2, 'Starting transaction:', action);
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.simpleDb.runTransaction(mode === 'readonly' ? 'readonly' : 'readwrite', ALL_STORES, function (simpleDbTxn) {
            if (mode === 'readwrite-primary') {
                // While we merely verify that we have (or can acquire) the lease
                // immediately, we wait to extend the primary lease until after
                // executing transactionOperation(). This ensures that even if the
                // transactionOperation takes a long time, we'll use a recent
                // leaseTimestampMs in the extended (or newly acquired) lease.
                return _this.verifyPrimaryLease(simpleDbTxn)
                    .next(function (success) {
                    if (!success) {
                        error("Failed to obtain primary lease for action '" + action + "'.");
                        _this.isPrimary = false;
                        _this.queue.enqueueAndForget(function () {
                            return _this.primaryStateListener(false);
                        });
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_LOST_ERROR_MSG);
                    }
                    return transactionOperation(new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next()));
                })
                    .next(function (result) {
                    return _this.acquireOrExtendPrimaryLease(simpleDbTxn).next(function () { return result; });
                });
            }
            else {
                return _this.verifyAllowTabSynchronization(simpleDbTxn).next(function () {
                    return transactionOperation(new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next()));
                });
            }
        });
    };
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */
    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    IndexedDbPersistence.prototype.verifyAllowTabSynchronization = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            if (currentLeaseIsValid && !_this.isLocalClient(currentPrimary)) {
                if (!currentPrimary.allowTabSynchronization) {
                    throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                }
            }
        });
    };
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */
    IndexedDbPersistence.prototype.acquireOrExtendPrimaryLease = function (txn) {
        var newPrimary = new DbPrimaryClient(this.clientId, this.allowTabSynchronization, Date.now());
        return primaryClientStore(txn).put(DbPrimaryClient.key, newPrimary);
    };
    IndexedDbPersistence.isAvailable = function () {
        return SimpleDb.isAvailable();
    };
    /**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */
    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
        // Use two different prefix formats:
        //
        //   * firestore / persistenceKey / projectID . databaseID / ...
        //   * firestore / persistenceKey / projectID / ...
        //
        // projectIDs are DNS-compatible names and cannot contain dots
        // so there's no danger of collisions.
        var database = databaseInfo.databaseId.projectId;
        if (!databaseInfo.databaseId.isDefaultDatabase) {
            database += '.' + databaseInfo.databaseId.database;
        }
        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
    };
    /** Checks the primary lease and removes it if we are the current primary. */
    IndexedDbPersistence.prototype.releasePrimaryLeaseIfHeld = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            if (_this.isLocalClient(primaryClient)) {
                debug(LOG_TAG$2, 'Releasing primary lease.');
                return store.delete(DbPrimaryClient.key);
            }
            else {
                return PersistencePromise.resolve();
            }
        });
    };
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */
    IndexedDbPersistence.prototype.isWithinAge = function (updateTimeMs, maxAgeMs) {
        var now = Date.now();
        var minAcceptable = now - maxAgeMs;
        var maxAcceptable = now;
        if (updateTimeMs < minAcceptable) {
            return false;
        }
        else if (updateTimeMs > maxAcceptable) {
            error("Detected an update time that is in the future: " + updateTimeMs + " > " + maxAcceptable);
            return false;
        }
        return true;
    };
    IndexedDbPersistence.prototype.attachVisibilityHandler = function () {
        var _this = this;
        if (this.document !== null &&
            typeof this.document.addEventListener === 'function') {
            this.documentVisibilityHandler = function () {
                _this.queue.enqueueAndForget(function () {
                    _this.inForeground = _this.document.visibilityState === 'visible';
                    return _this.updateClientMetadataAndTryBecomePrimary();
                });
            };
            this.document.addEventListener('visibilitychange', this.documentVisibilityHandler);
            this.inForeground = this.document.visibilityState === 'visible';
        }
    };
    IndexedDbPersistence.prototype.detachVisibilityHandler = function () {
        if (this.documentVisibilityHandler) {
            assert(this.document !== null &&
                typeof this.document.addEventListener === 'function', "Expected 'document.addEventListener' to be a function");
            this.document.removeEventListener('visibilitychange', this.documentVisibilityHandler);
            this.documentVisibilityHandler = null;
        }
    };
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */
    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
        var _this = this;
        if (typeof this.window.addEventListener === 'function') {
            this.windowUnloadHandler = function () {
                // Note: In theory, this should be scheduled on the AsyncQueue since it
                // accesses internal state. We execute this code directly during shutdown
                // to make sure it gets a chance to run.
                _this.markClientZombied();
                _this.queue.enqueueAndForget(function () {
                    // Attempt graceful shutdown (including releasing our primary lease),
                    // but there's no guarantee it will complete.
                    return _this.shutdown();
                });
            };
            this.window.addEventListener('unload', this.windowUnloadHandler);
        }
    };
    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
        if (this.windowUnloadHandler) {
            assert(typeof this.window.removeEventListener === 'function', "Expected 'window.removeEventListener' to be a function");
            this.window.removeEventListener('unload', this.windowUnloadHandler);
            this.windowUnloadHandler = null;
        }
    };
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */
    IndexedDbPersistence.prototype.isClientZombied = function (clientId) {
        try {
            var isZombied = this.webStorage.getItem(this.zombiedClientLocalStorageKey(clientId)) !==
                null;
            debug(LOG_TAG$2, "Client '" + clientId + "' " + (isZombied ? 'is' : 'is not') + " zombied in LocalStorage");
            return isZombied;
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            error(LOG_TAG$2, 'Failed to get zombied client id.', e);
            return false;
        }
    };
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */
    IndexedDbPersistence.prototype.markClientZombied = function () {
        try {
            this.webStorage.setItem(this.zombiedClientLocalStorageKey(this.clientId), String(Date.now()));
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            error('Failed to set zombie client id.', e);
        }
    };
    /** Removes the zombied client entry if it exists. */
    IndexedDbPersistence.prototype.removeClientZombiedEntry = function () {
        try {
            this.webStorage.removeItem(this.zombiedClientLocalStorageKey(this.clientId));
        }
        catch (e) {
            // Ignore
        }
    };
    IndexedDbPersistence.prototype.zombiedClientLocalStorageKey = function (clientId) {
        return ZOMBIED_CLIENTS_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /**
     * The name of the main (and currently only) IndexedDB database. this name is
     * appended to the prefix provided to the IndexedDbPersistence constructor.
     */
    IndexedDbPersistence.MAIN_DATABASE = 'main';
    return IndexedDbPersistence;
}());
function isPrimaryLeaseLostError(err) {
    return (err.code === Code.FAILED_PRECONDITION &&
        err.message === PRIMARY_LEASE_LOST_ERROR_MSG);
}
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */
function ignoreIfPrimaryLeaseLoss(err) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (isPrimaryLeaseLostError(err)) {
                debug(LOG_TAG$2, 'Unexpectedly lost primary lease');
            }
            else {
                throw err;
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */
function primaryClientStore(txn) {
    return txn.store(DbPrimaryClient.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */
function clientMetadataStore(txn) {
    return txn.store(DbClientMetadata.store);
}
/** Provides LRU functionality for IndexedDB persistence. */
var IndexedDbLruDelegate = /** @class */ (function () {
    function IndexedDbLruDelegate(db, params) {
        this.db = db;
        this.garbageCollector = new LruGarbageCollector(this, params);
    }
    IndexedDbLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocmentCount(txn);
        var targetCountPromise = this.db.getQueryCache().getQueryCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    IndexedDbLruDelegate.prototype.orphanedDocmentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    IndexedDbLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.db.getQueryCache().forEachTarget(txn, f);
    };
    IndexedDbLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        return this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            return f(sequenceNumber);
        });
    };
    IndexedDbLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    IndexedDbLruDelegate.prototype.addReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.db
            .getQueryCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    IndexedDbLruDelegate.prototype.removeMutationReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */
    IndexedDbLruDelegate.prototype.isPinned = function (txn, docKey) {
        if (this.inMemoryPins.containsKey(docKey)) {
            return PersistencePromise.resolve(true);
        }
        else {
            return mutationQueuesContainKey(txn, docKey);
        }
    };
    IndexedDbLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var bytesRemoved = 0;
        var promises = [];
        var iteration = this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            if (sequenceNumber <= upperBound) {
                var p = _this.isPinned(txn, docKey).next(function (isPinned) {
                    if (!isPinned) {
                        count++;
                        return _this.removeOrphanedDocument(txn, docKey).next(function (documentBytes) {
                            bytesRemoved += documentBytes;
                        });
                    }
                });
                promises.push(p);
            }
        });
        // Wait for iteration first to make sure we have a chance to add all of the
        // removal promises to the array.
        return iteration
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () {
            return _this.db.getRemoteDocumentCache().updateSize(txn, -bytesRemoved);
        })
            .next(function () { return count; });
    };
    /**
     * Clears a document from the cache. The document is assumed to be orphaned, so target-document
     * associations are not queried. We remove it from the remote document cache, as well as remove
     * its sentinel row.
     */
    IndexedDbLruDelegate.prototype.removeOrphanedDocument = function (txn, docKey) {
        var totalBytesRemoved = 0;
        var documentCache = this.db.getRemoteDocumentCache();
        return PersistencePromise.waitFor([
            documentTargetStore(txn).delete(sentinelKey$1(docKey)),
            documentCache.removeEntry(txn, docKey).next(function (bytesRemoved) {
                totalBytesRemoved += bytesRemoved;
            })
        ]).next(function () { return totalBytesRemoved; });
    };
    IndexedDbLruDelegate.prototype.removeTarget = function (txn, queryData) {
        var updated = queryData.copy({
            sequenceNumber: txn.currentSequenceNumber
        });
        return this.db.getQueryCache().updateQueryData(txn, updated);
    };
    IndexedDbLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */
    IndexedDbLruDelegate.prototype.forEachOrphanedDocument = function (txn, f) {
        var store = documentTargetStore(txn);
        var nextToReport = ListenSequence.INVALID;
        var nextPath;
        return store
            .iterate({
            index: DbTargetDocument.documentTargetsIndex
        }, function (_a, _b) {
            var targetId = _a[0], docKey = _a[1];
            var path = _b.path, sequenceNumber = _b.sequenceNumber;
            if (targetId === 0) {
                // if nextToReport is valid, report it, this is a new key so the
                // last one must not be a member of any targets.
                if (nextToReport !== ListenSequence.INVALID) {
                    f(new DocumentKey(decode(nextPath)), nextToReport);
                }
                // set nextToReport to be this sequence number. It's the next one we
                // might report, if we don't find any targets for this document.
                // Note that the sequence number must be defined when the targetId
                // is 0.
                nextToReport = sequenceNumber;
                nextPath = path;
            }
            else {
                // set nextToReport to be invalid, we know we don't need to report
                // this one since we found a target for it.
                nextToReport = ListenSequence.INVALID;
            }
        })
            .next(function () {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            if (nextToReport !== ListenSequence.INVALID) {
                f(new DocumentKey(decode(nextPath)), nextToReport);
            }
        });
    };
    IndexedDbLruDelegate.prototype.getCacheSize = function (txn) {
        return this.db.getRemoteDocumentCache().getSize(txn);
    };
    return IndexedDbLruDelegate;
}());
function sentinelKey$1(key) {
    return [0, encode(key.path)];
}
/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */
function sentinelRow(key, sequenceNumber) {
    return new DbTargetDocument(0, encode(key.path), sequenceNumber);
}
function writeSentinelKey(txn, key) {
    return documentTargetStore(txn).put(sentinelRow(key, txn.currentSequenceNumber));
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */
var LocalDocumentsView = /** @class */ (function () {
    function LocalDocumentsView(remoteDocumentCache, mutationQueue) {
        this.remoteDocumentCache = remoteDocumentCache;
        this.mutationQueue = mutationQueue;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */
    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKey(transaction, key)
            .next(function (batches) { return _this.getDocumentInternal(transaction, key, batches); });
    };
    /** Internal version of `getDocument` that allows reusing batches. */
    LocalDocumentsView.prototype.getDocumentInternal = function (transaction, key, inBatches) {
        return this.remoteDocumentCache.getEntry(transaction, key).next(function (doc) {
            for (var _i = 0, inBatches_1 = inBatches; _i < inBatches_1.length; _i++) {
                var batch = inBatches_1[_i];
                doc = batch.applyToLocalView(key, doc);
            }
            return doc;
        });
    };
    // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    LocalDocumentsView.prototype.applyLocalMutationsToDocuments = function (transaction, docs, batches) {
        var results = nullableMaybeDocumentMap();
        docs.forEach(function (key, localView) {
            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
                var batch = batches_1[_i];
                localView = batch.applyToLocalView(key, localView);
            }
            results = results.insert(key, localView);
        });
        return results;
    };
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */
    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
        var _this = this;
        return this.remoteDocumentCache
            .getEntries(transaction, keys)
            .next(function (docs) { return _this.getLocalViewOfDocuments(transaction, docs); });
    };
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */
    LocalDocumentsView.prototype.getLocalViewOfDocuments = function (transaction, baseDocs) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKeys(transaction, baseDocs)
            .next(function (batches) {
            var docs = _this.applyLocalMutationsToDocuments(transaction, baseDocs, batches);
            var results = maybeDocumentMap();
            docs.forEach(function (key, maybeDoc) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                if (!maybeDoc) {
                    maybeDoc = new NoDocument(key, SnapshotVersion.forDeletedDoc());
                }
                results = results.insert(key, maybeDoc);
            });
            return results;
        });
    };
    /** Performs a query against the local view of all documents. */
    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        if (DocumentKey.isDocumentKey(query.path)) {
            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
        }
        else {
            return this.getDocumentsMatchingCollectionQuery(transaction, query);
        }
    };
    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
        // Just do a simple document lookup.
        return this.getDocument(transaction, new DocumentKey(docPath)).next(function (maybeDoc) {
            var result = documentMap();
            if (maybeDoc instanceof Document) {
                result = result.insert(maybeDoc.key, maybeDoc);
            }
            return result;
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
        var _this = this;
        // Query the remote documents and overlay mutations.
        var results;
        return this.remoteDocumentCache
            .getDocumentsMatchingQuery(transaction, query)
            .next(function (queryResults) {
            results = queryResults;
            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
        })
            .next(function (matchingMutationBatches) {
            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
                var batch = matchingMutationBatches_1[_i];
                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                    var mutation = _b[_a];
                    var key = mutation.key;
                    // Only process documents belonging to the collection.
                    if (!query.path.isImmediateParentOf(key.path)) {
                        continue;
                    }
                    var baseDoc = results.get(key);
                    var mutatedDoc = mutation.applyToLocalView(baseDoc, baseDoc, batch.localWriteTime);
                    if (mutatedDoc instanceof Document) {
                        results = results.insert(key, mutatedDoc);
                    }
                    else {
                        results = results.remove(key);
                    }
                }
            }
        })
            .next(function () {
            // Finally, filter out any documents that don't actually match
            // the query.
            results.forEach(function (key, doc) {
                if (!query.matches(doc)) {
                    results = results.remove(key);
                }
            });
            return results;
        });
    };
    return LocalDocumentsView;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */
var ReferenceSet = /** @class */ (function () {
    function ReferenceSet() {
        // A set of outstanding references to a document sorted by key.
        this.refsByKey = new SortedSet(DocReference.compareByKey);
        // A set of outstanding references to a document sorted by target id.
        this.refsByTarget = new SortedSet(DocReference.compareByTargetId);
    }
    /** Returns true if the reference set contains no references. */
    ReferenceSet.prototype.isEmpty = function () {
        return this.refsByKey.isEmpty();
    };
    /** Adds a reference to the given document key for the given ID. */
    ReferenceSet.prototype.addReference = function (key, id) {
        var ref = new DocReference(key, id);
        this.refsByKey = this.refsByKey.add(ref);
        this.refsByTarget = this.refsByTarget.add(ref);
    };
    /** Add references to the given document keys for the given ID. */
    ReferenceSet.prototype.addReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.addReference(key, id); });
    };
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */
    ReferenceSet.prototype.removeReference = function (key, id) {
        this.removeRef(new DocReference(key, id));
    };
    ReferenceSet.prototype.removeReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.removeReference(key, id); });
    };
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */
    ReferenceSet.prototype.removeReferencesForId = function (id) {
        var _this = this;
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = [];
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            _this.removeRef(ref);
            keys.push(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.removeAllReferences = function () {
        var _this = this;
        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
    };
    ReferenceSet.prototype.removeRef = function (ref) {
        this.refsByKey = this.refsByKey.delete(ref);
        this.refsByTarget = this.refsByTarget.delete(ref);
    };
    ReferenceSet.prototype.referencesForId = function (id) {
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = documentKeySet();
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            keys = keys.add(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.containsKey = function (key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
        return firstRef !== null && key.isEqual(firstRef.key);
    };
    return ReferenceSet;
}());
var DocReference = /** @class */ (function () {
    function DocReference(key, targetOrBatchId) {
        this.key = key;
        this.targetOrBatchId = targetOrBatchId;
    }
    /** Compare by key then by ID */
    DocReference.compareByKey = function (left, right) {
        return (DocumentKey.comparator(left.key, right.key) ||
            primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
    };
    /** Compare by ID then by key */
    DocReference.compareByTargetId = function (left, right) {
        return (primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
            DocumentKey.comparator(left.key, right.key));
    };
    return DocReference;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$3 = 'LocalStore';
/**
 * Local storage in the Firestore client. Coordinates persistence components
 * like the mutation queue and remote document cache to present a
 * latency-compensated view of stored data.
 *
 * The LocalStore is responsible for accepting mutations from the Sync Engine.
 * Writes from the client are put into a queue as provisional Mutations until
 * they are processed by the RemoteStore and confirmed as having been written
 * to the server.
 *
 * The local store provides the local version of documents that have been
 * modified locally. It maintains the constraint:
 *
 *   LocalDocument = RemoteDocument + Active(LocalMutations)
 *
 * (Active mutations are those that are enqueued and have not been previously
 * acknowledged or rejected).
 *
 * The RemoteDocument ("ground truth") state is provided via the
 * applyChangeBatch method. It will be some version of a server-provided
 * document OR will be a server-provided document PLUS acknowledged mutations:
 *
 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
 *
 * Note that this "dirty" version of a RemoteDocument will not be identical to a
 * server base version, since it has LocalMutations added to it pending getting
 * an authoritative copy from the server.
 *
 * Since LocalMutations can be rejected by the server, we have to be able to
 * revert a LocalMutation that has already been applied to the LocalDocument
 * (typically done by replaying all remaining LocalMutations to the
 * RemoteDocument to re-apply).
 *
 * The LocalStore is responsible for the garbage collection of the documents it
 * contains. For now, it every doc referenced by a view, the mutation queue, or
 * the RemoteStore.
 *
 * It also maintains the persistence of mapping queries to resume tokens and
 * target ids. It needs to know this data about queries to properly know what
 * docs it would be allowed to garbage collect.
 *
 * The LocalStore must be able to efficiently execute queries against its local
 * cache of the documents, to provide the initial set of results before any
 * remote changes have been received.
 *
 * Note: In TypeScript, most methods return Promises since the implementation
 * may rely on fetching data from IndexedDB which is async.
 * These Promises will only be rejected on an I/O error or other internal
 * (unexpected) failure (e.g. failed assert) and always represent an
 * unrecoverable error (should be caught / reported by the async_queue).
 */
var LocalStore = /** @class */ (function () {
    function LocalStore(
    /** Manages our in-memory or durable persistence. */
    persistence, initialUser) {
        this.persistence = persistence;
        /**
         * The set of document references maintained by any local views.
         */
        this.localViewReferences = new ReferenceSet();
        /** Maps a targetID to data about its query. */
        this.queryDataByTarget = {};
        assert(persistence.started, 'LocalStore was passed an unstarted persistence implementation');
        this.persistence.referenceDelegate.setInMemoryPins(this.localViewReferences);
        this.mutationQueue = persistence.getMutationQueue(initialUser);
        this.remoteDocuments = persistence.getRemoteDocumentCache();
        this.queryCache = persistence.getQueryCache();
        this.localDocuments = new LocalDocumentsView(this.remoteDocuments, this.mutationQueue);
    }
    /**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */
    // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    LocalStore.prototype.handleUserChange = function (user) {
        var _this = this;
        return this.persistence.runTransaction('Handle user change', 'readonly', function (txn) {
            // Swap out the mutation queue, grabbing the pending mutation batches
            // before and after.
            var oldBatches;
            return _this.mutationQueue
                .getAllMutationBatches(txn)
                .next(function (promisedOldBatches) {
                oldBatches = promisedOldBatches;
                _this.mutationQueue = _this.persistence.getMutationQueue(user);
                // Recreate our LocalDocumentsView using the new
                // MutationQueue.
                _this.localDocuments = new LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue);
                return _this.mutationQueue.getAllMutationBatches(txn);
            })
                .next(function (newBatches) {
                var removedBatchIds = [];
                var addedBatchIds = [];
                // Union the old/new changed keys.
                var changedKeys = documentKeySet();
                for (var _i = 0, oldBatches_1 = oldBatches; _i < oldBatches_1.length; _i++) {
                    var batch = oldBatches_1[_i];
                    removedBatchIds.push(batch.batchId);
                    for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                        var mutation = _b[_a];
                        changedKeys = changedKeys.add(mutation.key);
                    }
                }
                for (var _c = 0, newBatches_1 = newBatches; _c < newBatches_1.length; _c++) {
                    var batch = newBatches_1[_c];
                    addedBatchIds.push(batch.batchId);
                    for (var _d = 0, _e = batch.mutations; _d < _e.length; _d++) {
                        var mutation = _e[_d];
                        changedKeys = changedKeys.add(mutation.key);
                    }
                }
                // Return the set of all (potentially) changed documents and the list
                // of mutation batch IDs that were affected by change.
                return _this.localDocuments
                    .getDocuments(txn, changedKeys)
                    .next(function (affectedDocuments) {
                    return {
                        affectedDocuments: affectedDocuments,
                        removedBatchIds: removedBatchIds,
                        addedBatchIds: addedBatchIds
                    };
                });
            });
        });
    };
    /* Accept locally generated Mutations and commit them to storage. */
    LocalStore.prototype.localWrite = function (mutations) {
        var _this = this;
        return this.persistence.runTransaction('Locally write mutations', 'readwrite', function (txn) {
            var batch;
            var localWriteTime = Timestamp.now();
            return _this.mutationQueue
                .addMutationBatch(txn, localWriteTime, mutations)
                .next(function (promisedBatch) {
                batch = promisedBatch;
                // TODO(koss): This is doing an N^2 update by replaying ALL the
                // mutations on each document (instead of just the ones added) in
                // this batch.
                var keys = batch.keys();
                return _this.localDocuments.getDocuments(txn, keys);
            })
                .next(function (changedDocuments) {
                return { batchId: batch.batchId, changes: changedDocuments };
            });
        });
    };
    /** Returns the local view of the documents affected by a mutation batch. */
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.lookupMutationDocuments = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Lookup mutation documents', 'readonly', function (txn) {
            return _this.mutationQueue
                .lookupMutationKeys(txn, batchId)
                .next(function (keys) {
                if (keys) {
                    return _this.localDocuments.getDocuments(txn, keys);
                }
                else {
                    return PersistencePromise.resolve(null);
                }
            });
        });
    };
    /**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */
    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
        var _this = this;
        return this.persistence.runTransaction('Acknowledge batch', 'readwrite-primary', function (txn) {
            var affected = batchResult.batch.keys();
            var documentBuffer = _this.remoteDocuments.newChangeBuffer();
            return _this.mutationQueue
                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
                .next(function () {
                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
            })
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () { return _this.mutationQueue.performConsistencyCheck(txn); })
                .next(function () { return _this.localDocuments.getDocuments(txn, affected); });
        });
    };
    /**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */
    LocalStore.prototype.rejectBatch = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Reject batch', 'readwrite-primary', function (txn) {
            var affectedKeys;
            return _this.mutationQueue
                .lookupMutationBatch(txn, batchId)
                .next(function (batch) {
                assert(batch !== null, 'Attempt to reject nonexistent batch!');
                affectedKeys = batch.keys();
                return _this.mutationQueue.removeMutationBatch(txn, batch);
            })
                .next(function () {
                return _this.mutationQueue.performConsistencyCheck(txn);
            })
                .next(function () {
                return _this.localDocuments.getDocuments(txn, affectedKeys);
            });
        });
    };
    /** Returns the last recorded stream token for the current user. */
    LocalStore.prototype.getLastStreamToken = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last stream token', 'readonly', function (txn) {
            return _this.mutationQueue.getLastStreamToken(txn);
        });
    };
    /**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */
    LocalStore.prototype.setLastStreamToken = function (streamToken) {
        var _this = this;
        return this.persistence.runTransaction('Set last stream token', 'readwrite-primary', function (txn) {
            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
        });
    };
    /**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */
    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last remote snapshot version', 'readonly', function (txn) { return _this.queryCache.getLastRemoteSnapshotVersion(txn); });
    };
    /**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */
    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        var documentBuffer = this.remoteDocuments.newChangeBuffer();
        return this.persistence.runTransaction('Apply remote event', 'readwrite-primary', function (txn) {
            var promises = [];
            var authoritativeUpdates = documentKeySet();
            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
                // Do not ref/unref unassigned targetIds - it may lead to leaks.
                var queryData = _this.queryDataByTarget[targetId];
                if (!queryData)
                    return;
                // When a global snapshot contains updates (either add or modify) we
                // can completely trust these updates as authoritative and blindly
                // apply them to our cache (as a defensive measure to promote
                // self-healing in the unfortunate case that our cache is ever somehow
                // corrupted / out-of-sync).
                //
                // If the document is only updated while removing it from a target
                // then watch isn't obligated to send the absolute latest version: it
                // can send the first version that caused the document not to match.
                change.addedDocuments.forEach(function (key) {
                    authoritativeUpdates = authoritativeUpdates.add(key);
                });
                change.modifiedDocuments.forEach(function (key) {
                    authoritativeUpdates = authoritativeUpdates.add(key);
                });
                promises.push(_this.queryCache
                    .removeMatchingKeys(txn, change.removedDocuments, targetId)
                    .next(function () {
                    return _this.queryCache.addMatchingKeys(txn, change.addedDocuments, targetId);
                }));
                // Update the resume token if the change includes one. Don't clear
                // any preexisting value.
                var resumeToken = change.resumeToken;
                if (resumeToken.length > 0) {
                    var oldQueryData = queryData;
                    queryData = queryData.copy({
                        resumeToken: resumeToken,
                        snapshotVersion: remoteEvent.snapshotVersion
                    });
                    _this.queryDataByTarget[targetId] = queryData;
                    if (LocalStore.shouldPersistQueryData(oldQueryData, queryData, change)) {
                        promises.push(_this.queryCache.updateQueryData(txn, queryData));
                    }
                }
            });
            var changedDocs = maybeDocumentMap();
            var updatedKeys = documentKeySet();
            remoteEvent.documentUpdates.forEach(function (key, doc) {
                updatedKeys = updatedKeys.add(key);
            });
            // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
            // documents in advance in a single call.
            promises.push(documentBuffer.getEntries(txn, updatedKeys).next(function (existingDocs) {
                remoteEvent.documentUpdates.forEach(function (key, doc) {
                    var existingDoc = existingDocs.get(key);
                    // If a document update isn't authoritative, make sure we don't
                    // apply an old document version to the remote cache. We make an
                    // exception for SnapshotVersion.MIN which can happen for
                    // manufactured events (e.g. in the case of a limbo document
                    // resolution failing).
                    if (existingDoc == null ||
                        doc.version.isEqual(SnapshotVersion.MIN) ||
                        (authoritativeUpdates.has(doc.key) &&
                            !existingDoc.hasPendingWrites) ||
                        doc.version.compareTo(existingDoc.version) >= 0) {
                        documentBuffer.addEntry(doc);
                        changedDocs = changedDocs.insert(key, doc);
                    }
                    else {
                        debug(LOG_TAG$3, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
                    }
                    if (remoteEvent.resolvedLimboDocuments.has(key)) {
                        promises.push(_this.persistence.referenceDelegate.updateLimboDocument(txn, key));
                    }
                });
            }));
            // HACK: The only reason we allow a null snapshot version is so that we
            // can synthesize remote events when we get permission denied errors while
            // trying to resolve the state of a locally cached document that is in
            // limbo.
            var remoteVersion = remoteEvent.snapshotVersion;
            if (!remoteVersion.isEqual(SnapshotVersion.MIN)) {
                var updateRemoteVersion = _this.queryCache
                    .getLastRemoteSnapshotVersion(txn)
                    .next(function (lastRemoteVersion) {
                    assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
                        remoteVersion +
                        ' < ' +
                        lastRemoteVersion);
                    return _this.queryCache.setTargetsMetadata(txn, txn.currentSequenceNumber, remoteVersion);
                });
                promises.push(updateRemoteVersion);
            }
            return PersistencePromise.waitFor(promises)
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () {
                return _this.localDocuments.getLocalViewOfDocuments(txn, changedDocs);
            });
        });
    };
    /**
     * Returns true if the newQueryData should be persisted during an update of
     * an active target. QueryData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, QueryData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */
    LocalStore.shouldPersistQueryData = function (oldQueryData, newQueryData, change) {
        // Avoid clearing any existing value
        if (newQueryData.resumeToken.length === 0)
            return false;
        // Any resume token is interesting if there isn't one already.
        if (oldQueryData.resumeToken.length === 0)
            return true;
        // Don't allow resume token changes to be buffered indefinitely. This
        // allows us to be reasonably up-to-date after a crash and avoids needing
        // to loop over all active queries on shutdown. Especially in the browser
        // we may not get time to do anything interesting while the current tab is
        // closing.
        var timeDelta = newQueryData.snapshotVersion.toMicroseconds() -
            oldQueryData.snapshotVersion.toMicroseconds();
        if (timeDelta >= this.RESUME_TOKEN_MAX_AGE_MICROS)
            return true;
        // Otherwise if the only thing that has changed about a target is its resume
        // token it's not worth persisting. Note that the RemoteStore keeps an
        // in-memory view of the currently active targets which includes the current
        // resume token, so stream failure or user changes will still use an
        // up-to-date resume token regardless of what we do here.
        var changes = change.addedDocuments.size +
            change.modifiedDocuments.size +
            change.removedDocuments.size;
        return changes > 0;
    };
    /**
     * Notify local store of the changed views to locally pin documents.
     */
    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
        var _this = this;
        return this.persistence.runTransaction('notifyLocalViewChanges', 'readwrite', function (txn) {
            return PersistencePromise.forEach(viewChanges, function (viewChange) {
                _this.localViewReferences.addReferences(viewChange.addedKeys, viewChange.targetId);
                _this.localViewReferences.removeReferences(viewChange.removedKeys, viewChange.targetId);
                return PersistencePromise.forEach(viewChange.removedKeys, function (key) {
                    return _this.persistence.referenceDelegate.removeReference(txn, key);
                });
            });
        });
    };
    /**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */
    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
        var _this = this;
        return this.persistence.runTransaction('Get next mutation batch', 'readonly', function (txn) {
            if (afterBatchId === undefined) {
                afterBatchId = BATCHID_UNKNOWN;
            }
            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
        });
    };
    /**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */
    LocalStore.prototype.readDocument = function (key) {
        var _this = this;
        return this.persistence.runTransaction('read document', 'readonly', function (txn) {
            return _this.localDocuments.getDocument(txn, key);
        });
    };
    /**
     * Assigns the given query an internal ID so that its results can be pinned so
     * they don't get GC'd. A query must be allocated in the local store before
     * the store can be used to manage its view.
     */
    LocalStore.prototype.allocateQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Allocate query', 'readwrite', function (txn) {
            var queryData;
            return _this.queryCache
                .getQueryData(txn, query)
                .next(function (cached) {
                if (cached) {
                    // This query has been listened to previously, so reuse the
                    // previous targetID.
                    // TODO(mcg): freshen last accessed date?
                    queryData = cached;
                    return PersistencePromise.resolve();
                }
                else {
                    return _this.queryCache.allocateTargetId(txn).next(function (targetId) {
                        queryData = new QueryData(query, targetId, QueryPurpose.Listen, txn.currentSequenceNumber);
                        return _this.queryCache.addQueryData(txn, queryData);
                    });
                }
            })
                .next(function () {
                assert(!_this.queryDataByTarget[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
                _this.queryDataByTarget[queryData.targetId] = queryData;
                return queryData;
            });
        });
    };
    /**
     * Unpin all the documents associated with the given query. If
     * `keepPersistedQueryData` is set to false and Eager GC enabled, the method
     * directly removes the associated query data from the query cache.
     */
    // PORTING NOTE: `keepPersistedQueryData` is multi-tab only.
    LocalStore.prototype.releaseQuery = function (query, keepPersistedQueryData) {
        var _this = this;
        var mode = keepPersistedQueryData ? 'readwrite' : 'readwrite-primary';
        return this.persistence.runTransaction('Release query', mode, function (txn) {
            return _this.queryCache
                .getQueryData(txn, query)
                .next(function (queryData) {
                assert(queryData != null, 'Tried to release nonexistent query: ' + query);
                var targetId = queryData.targetId;
                var cachedQueryData = _this.queryDataByTarget[targetId];
                // References for documents sent via Watch are automatically removed when we delete a
                // query's target data from the reference delegate. Since this does not remove references
                // for locally mutated documents, we have to remove the target associations for these
                // documents manually.
                var removed = _this.localViewReferences.removeReferencesForId(targetId);
                delete _this.queryDataByTarget[targetId];
                if (!keepPersistedQueryData) {
                    return PersistencePromise.forEach(removed, function (key) {
                        return _this.persistence.referenceDelegate.removeReference(txn, key);
                    }).next(function () {
                        return _this.persistence.referenceDelegate.removeTarget(txn, cachedQueryData);
                    });
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    /**
     * Runs the specified query against all the documents in the local store and
     * returns the results.
     */
    LocalStore.prototype.executeQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Execute query', 'readonly', function (txn) {
            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
        });
    };
    /**
     * Returns the keys of the documents that are associated with the given
     * target id in the remote table.
     */
    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
        var _this = this;
        return this.persistence.runTransaction('Remote document keys', 'readonly', function (txn) {
            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
        });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getActiveClients = function () {
        return this.persistence.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.removeCachedMutationBatchMetadata = function (batchId) {
        this.mutationQueue.removeCachedMutationKeys(batchId);
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.setNetworkEnabled = function (networkEnabled) {
        this.persistence.setNetworkEnabled(networkEnabled);
    };
    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
        var _this = this;
        var batch = batchResult.batch;
        var docKeys = batch.keys();
        var promiseChain = PersistencePromise.resolve();
        docKeys.forEach(function (docKey) {
            promiseChain = promiseChain
                .next(function () {
                return documentBuffer.getEntry(txn, docKey);
            })
                .next(function (remoteDoc) {
                var doc = remoteDoc;
                var ackVersion = batchResult.docVersions.get(docKey);
                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
                if (!doc || doc.version.compareTo(ackVersion) < 0) {
                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
                    if (!doc) {
                        assert(!remoteDoc, 'Mutation batch ' +
                            batch +
                            ' applied to document ' +
                            remoteDoc +
                            ' resulted in null');
                    }
                    else {
                        documentBuffer.addEntry(doc);
                    }
                }
            });
        });
        return promiseChain.next(function () {
            return _this.mutationQueue.removeMutationBatch(txn, batch);
        });
    };
    LocalStore.prototype.collectGarbage = function (garbageCollector) {
        var _this = this;
        return this.persistence.runTransaction('Collect garbage', 'readwrite-primary', function (txn) { return garbageCollector.collect(txn, _this.queryDataByTarget); });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getQueryForTarget = function (targetId) {
        var _this = this;
        if (this.queryDataByTarget[targetId]) {
            return Promise.resolve(this.queryDataByTarget[targetId].query);
        }
        else {
            return this.persistence.runTransaction('Get query data', 'readonly', function (txn) {
                return _this.queryCache
                    .getQueryDataForTarget(txn, targetId)
                    .next(function (queryData) { return (queryData ? queryData.query : null); });
            });
        }
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getNewDocumentChanges = function () {
        var _this = this;
        return this.persistence.runTransaction('Get new document changes', 'readonly', function (txn) {
            return _this.remoteDocuments.getNewDocumentChanges(txn);
        });
    };
    /**
     * The maximum time to leave a resume token buffered without writing it out.
     * This value is arbitrary: it's long enough to avoid several writes
     * (possibly indefinitely if updates come more frequently than this) but
     * short enough that restarting after crashing will still have a pretty
     * recent resume token.
     */
    LocalStore.RESUME_TOKEN_MAX_AGE_MICROS = 5 * 60 * 1e6;
    return LocalStore;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryMutationQueue = /** @class */ (function () {
    function MemoryMutationQueue(referenceDelegate) {
        this.referenceDelegate = referenceDelegate;
        /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */
        this.mutationQueue = [];
        /** Next value to use when assigning sequential IDs to each mutation batch. */
        this.nextBatchId = 1;
        /** The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         */
        this.lastStreamToken = emptyByteString();
        /** An ordered mapping between documents and the mutations batch IDs. */
        this.batchesByDocumentKey = new SortedSet(DocReference.compareByKey);
    }
    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.length === 0);
    };
    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        var batchId = batch.batchId;
        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
        assert(batchIndex === 0, 'Can only acknowledge the first batch in the mutation queue');
        // Verify that the batch in the queue is the one to be acknowledged.
        var check = this.mutationQueue[batchIndex];
        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
            batchId +
            ', got batch ' +
            check.batchId);
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return PersistencePromise.resolve(this.lastStreamToken);
    };
    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, mutations) {
        assert(mutations.length !== 0, 'Mutation batches should not be empty');
        var batchId = this.nextBatchId;
        this.nextBatchId++;
        if (this.mutationQueue.length > 0) {
            var prior = this.mutationQueue[this.mutationQueue.length - 1];
            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
        }
        var batch = new MutationBatch(batchId, localWriteTime, mutations);
        this.mutationQueue.push(batch);
        // Track references by document key.
        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
            var mutation = mutations_1[_i];
            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new DocReference(mutation.key, batchId));
        }
        return PersistencePromise.resolve(batch);
    };
    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        return PersistencePromise.resolve(this.findMutationBatch(batchId));
    };
    MemoryMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var mutationBatch = this.findMutationBatch(batchId);
        assert(mutationBatch != null, 'Failed to find local mutation batch.');
        return PersistencePromise.resolve(mutationBatch.keys());
    };
    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var nextBatchId = batchId + 1;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        var rawIndex = this.indexOfBatchId(nextBatchId);
        var index = rawIndex < 0 ? 0 : rawIndex;
        return PersistencePromise.resolve(this.mutationQueue.length > index ? this.mutationQueue[index] : null);
    };
    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.slice());
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        var start = new DocReference(documentKey, 0);
        var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
        var result = [];
        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
            assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
            var batch = _this.findMutationBatch(ref.targetOrBatchId);
            assert(batch !== null, 'Batches in the index must exist in the main table');
            result.push(batch);
        });
        return PersistencePromise.resolve(result);
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        documentKeys.forEach(function (documentKey) {
            var start = new DocReference(documentKey, 0);
            var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
            _this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
                assert(documentKey.isEqual(ref.key), "For each key, should only iterate over a single key's batches");
                uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
            });
        });
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var prefix = query.path;
        var immediateChildrenPathLength = prefix.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        var startPath = prefix;
        if (!DocumentKey.isDocumentKey(startPath)) {
            startPath = startPath.child('');
        }
        var start = new DocReference(new DocumentKey(startPath), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        this.batchesByDocumentKey.forEachWhile(function (ref) {
            var rowKeyPath = ref.key.path;
            if (!prefix.isPrefixOf(rowKeyPath)) {
                return false;
            }
            else {
                // Rows with document keys more than one segment longer than the query
                // path can't be matches. For example, a query on 'rooms' can't match
                // the document /rooms/abc/messages/xyx.
                // TODO(mcg): we'll need a different scanner when we implement
                // ancestor queries.
                if (rowKeyPath.length === immediateChildrenPathLength) {
                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
                }
                return true;
            }
        }, start);
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.findMutationBatches = function (batchIDs) {
        var _this = this;
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        var result = [];
        batchIDs.forEach(function (batchId) {
            var batch = _this.findMutationBatch(batchId);
            if (batch !== null) {
                result.push(batch);
            }
        });
        return result;
    };
    MemoryMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        // Find the position of the first batch for removal. This need not be the
        // first entry in the queue.
        var batchIndex = this.indexOfExistingBatchId(batch.batchId, 'removed');
        assert(batchIndex === 0, 'Can only remove the first entry of the mutation queue');
        this.mutationQueue.shift();
        var references = this.batchesByDocumentKey;
        return PersistencePromise.forEach(batch.mutations, function (mutation) {
            var ref = new DocReference(mutation.key, batch.batchId);
            references = references.delete(ref);
            return _this.referenceDelegate.removeMutationReference(transaction, mutation.key);
        }).next(function () {
            _this.batchesByDocumentKey = references;
        });
    };
    MemoryMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        // No-op since the memory mutation queue does not maintain a separate cache.
    };
    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
        return PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
    };
    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
        if (this.mutationQueue.length === 0) {
            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
        }
        return PersistencePromise.resolve();
    };
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */
    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
        var index = this.indexOfBatchId(batchId);
        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
        return index;
    };
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */
    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
        if (this.mutationQueue.length === 0) {
            // As an index this is past the end of the queue
            return 0;
        }
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        var firstBatchId = this.mutationQueue[0].batchId;
        return batchId - firstBatchId;
    };
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */
    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
        var index = this.indexOfBatchId(batchId);
        if (index < 0 || index >= this.mutationQueue.length) {
            return null;
        }
        var batch = this.mutationQueue[index];
        assert(batch.batchId === batchId, 'If found batch must match');
        return batch;
    };
    return MemoryMutationQueue;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryQueryCache = /** @class */ (function () {
    function MemoryQueryCache(persistence) {
        this.persistence = persistence;
        /**
         * Maps a query to the data about that query
         */
        this.queries = new ObjectMap(function (q) { return q.canonicalId(); });
        /** The last received snapshot version. */
        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
        /** The highest numbered target ID encountered. */
        this.highestTargetId = 0;
        /** The highest sequence number encountered. */
        this.highestSequenceNumber = 0;
        /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */
        this.references = new ReferenceSet();
        this.targetCount = 0;
        this.targetIdGenerator = TargetIdGenerator.forQueryCache();
    }
    MemoryQueryCache.prototype.getTargetCount = function (txn) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryQueryCache.prototype.forEachTarget = function (txn, f) {
        this.queries.forEach(function (_, queryData) { return f(queryData); });
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    };
    MemoryQueryCache.prototype.getHighestSequenceNumber = function (transaction) {
        return PersistencePromise.resolve(this.highestSequenceNumber);
    };
    MemoryQueryCache.prototype.allocateTargetId = function (transaction) {
        var nextTargetId = this.targetIdGenerator.after(this.highestTargetId);
        this.highestTargetId = nextTargetId;
        return PersistencePromise.resolve(nextTargetId);
    };
    MemoryQueryCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        if (lastRemoteSnapshotVersion) {
            this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        }
        if (highestListenSequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = highestListenSequenceNumber;
        }
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.saveQueryData = function (queryData) {
        this.queries.set(queryData.query, queryData);
        var targetId = queryData.targetId;
        if (targetId > this.highestTargetId) {
            this.highestTargetId = targetId;
        }
        if (queryData.sequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = queryData.sequenceNumber;
        }
    };
    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
        assert(!this.queries.has(queryData.query), 'Adding a query that already exists');
        this.saveQueryData(queryData);
        this.targetCount += 1;
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.updateQueryData = function (transaction, queryData) {
        assert(this.queries.has(queryData.query), 'Updating a non-existent query');
        this.saveQueryData(queryData);
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        assert(this.targetCount > 0, 'Removing a target from an empty cache');
        assert(this.queries.has(queryData.query), 'Removing a non-existent target from the cache');
        this.queries.delete(queryData.query);
        this.references.removeReferencesForId(queryData.targetId);
        this.targetCount -= 1;
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeTargets = function (transaction, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var removals = [];
        this.queries.forEach(function (key, queryData) {
            if (queryData.sequenceNumber <= upperBound &&
                !activeTargetIds[queryData.targetId]) {
                _this.queries.delete(key);
                removals.push(_this.removeMatchingKeysForTargetId(transaction, queryData.targetId));
                count++;
            }
        });
        return PersistencePromise.waitFor(removals).next(function () { return count; });
    };
    MemoryQueryCache.prototype.getQueryCount = function (transaction) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
        var queryData = this.queries.get(query) || null;
        return PersistencePromise.resolve(queryData);
    };
    MemoryQueryCache.prototype.getQueryDataForTarget = function (transaction, targetId) {
        // This method is only needed for multi-tab and we can't implement it
        // efficiently without additional data structures.
        return fail('Not yet implemented.');
    };
    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        this.references.addReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.addReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        this.references.removeReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.removeReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        this.references.removeReferencesForId(targetId);
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var matchingKeys = this.references.referencesForId(targetId);
        return PersistencePromise.resolve(matchingKeys);
    };
    MemoryQueryCache.prototype.containsKey = function (txn, key) {
        return PersistencePromise.resolve(this.references.containsKey(key));
    };
    return MemoryQueryCache;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function documentSizeMap() {
    return new SortedMap(DocumentKey.comparator);
}
var MemoryRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */
    function MemoryRemoteDocumentCache(sizer) {
        this.sizer = sizer;
        this.docs = documentSizeMap();
        this.newDocumentChanges = documentKeySet();
        this.size = 0;
    }
    /**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */
    MemoryRemoteDocumentCache.prototype.addEntries = function (transaction, entries, sizeDelta) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            var key = entry.maybeDocument.key;
            this.docs = this.docs.insert(key, entry);
            this.newDocumentChanges = this.newDocumentChanges.add(key);
        }
        this.size += sizeDelta;
        return PersistencePromise.resolve();
    };
    /**
     * Removes the specified entry from the cache and updates the size as appropriate.
     */
    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        if (entry) {
            this.docs = this.docs.remove(documentKey);
            this.size -= entry.size;
            return PersistencePromise.resolve(entry.size);
        }
        else {
            return PersistencePromise.resolve(0);
        }
    };
    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        return PersistencePromise.resolve(entry ? entry.maybeDocument : null);
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    MemoryRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        return PersistencePromise.resolve(this.docs.get(documentKey));
    };
    MemoryRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
        });
        return PersistencePromise.resolve(results);
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    MemoryRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
            sizeMap = sizeMap.insert(documentKey, entry ? entry.size : 0);
        });
        return PersistencePromise.resolve({ maybeDocuments: results, sizeMap: sizeMap });
    };
    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var prefix = new DocumentKey(query.path.child(''));
        var iterator = this.docs.getIteratorFrom(prefix);
        while (iterator.hasNext()) {
            var _a = iterator.getNext(), key = _a.key, maybeDocument = _a.value.maybeDocument;
            if (!query.path.isPrefixOf(key.path)) {
                break;
            }
            if (maybeDocument instanceof Document && query.matches(maybeDocument)) {
                results = results.insert(maybeDocument.key, maybeDocument);
            }
        }
        return PersistencePromise.resolve(results);
    };
    MemoryRemoteDocumentCache.prototype.forEachDocumentKey = function (transaction, f) {
        return PersistencePromise.forEach(this.docs, function (key) { return f(key); });
    };
    MemoryRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction) {
        var _this = this;
        var changedDocs = maybeDocumentMap();
        this.newDocumentChanges.forEach(function (key) {
            var entry = _this.docs.get(key);
            var changedDoc = entry
                ? entry.maybeDocument
                : new NoDocument(key, SnapshotVersion.forDeletedDoc());
            changedDocs = changedDocs.insert(key, changedDoc);
        });
        this.newDocumentChanges = documentKeySet();
        return PersistencePromise.resolve(changedDocs);
    };
    MemoryRemoteDocumentCache.prototype.newChangeBuffer = function () {
        return new MemoryRemoteDocumentChangeBuffer(this.sizer, this);
    };
    MemoryRemoteDocumentCache.prototype.getSize = function (txn) {
        return PersistencePromise.resolve(this.size);
    };
    return MemoryRemoteDocumentCache;
}());
/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */
var MemoryRemoteDocumentChangeBuffer = /** @class */ (function (_super) {
    tslib_1.__extends(MemoryRemoteDocumentChangeBuffer, _super);
    function MemoryRemoteDocumentChangeBuffer(sizer, documentCache) {
        var _this = _super.call(this) || this;
        _this.sizer = sizer;
        _this.documentCache = documentCache;
        return _this;
    }
    MemoryRemoteDocumentChangeBuffer.prototype.applyChanges = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var delta = 0;
        var docs = [];
        changes.forEach(function (key, maybeDocument) {
            var previousSize = _this.documentSizes.get(key);
            assert(previousSize !== undefined, "Attempting to change document " + key.toString() + " without having read it first");
            var size = _this.sizer(maybeDocument);
            delta += size - previousSize;
            docs.push({ maybeDocument: maybeDocument, size: size });
        });
        return this.documentCache.addEntries(transaction, docs, delta);
    };
    MemoryRemoteDocumentChangeBuffer.prototype.getFromCache = function (transaction, documentKey) {
        return this.documentCache.getSizedEntry(transaction, documentKey);
    };
    MemoryRemoteDocumentChangeBuffer.prototype.getAllFromCache = function (transaction, documentKeys) {
        return this.documentCache.getSizedEntries(transaction, documentKeys);
    };
    return MemoryRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$4 = 'MemoryPersistence';
/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */
var MemoryPersistence = /** @class */ (function () {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */
    function MemoryPersistence(clientId, referenceDelegateFactory) {
        var _this = this;
        this.clientId = clientId;
        /**
         * Note that these are retained here to make it easier to write tests
         * affecting both the in-memory and IndexedDB-backed persistence layers. Tests
         * can create a new LocalStore wrapping this Persistence instance and this
         * will make the in-memory persistence layer behave as if it were actually
         * persisting values.
         */
        this.mutationQueues = {};
        this.listenSequence = new ListenSequence(0);
        this._started = false;
        this._started = true;
        this.referenceDelegate = referenceDelegateFactory(this);
        this.queryCache = new MemoryQueryCache(this);
        var sizer = function (doc) {
            return _this.referenceDelegate.documentSize(doc);
        };
        this.remoteDocumentCache = new MemoryRemoteDocumentCache(sizer);
    }
    MemoryPersistence.createLruPersistence = function (clientId, serializer, params) {
        var factory = function (p) {
            return new MemoryLruDelegate(p, new LocalSerializer(serializer), params);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.createEagerPersistence = function (clientId) {
        var factory = function (p) {
            return new MemoryEagerDelegate(p);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.prototype.shutdown = function (deleteData) {
        // No durable state to ensure is closed on shutdown.
        this._started = false;
        return Promise.resolve();
    };
    Object.defineProperty(MemoryPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    MemoryPersistence.prototype.getActiveClients = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, [this.clientId]];
            });
        });
    };
    MemoryPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        // All clients using memory persistence act as primary.
        return primaryStateListener(true);
    };
    MemoryPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        // No op.
    };
    MemoryPersistence.prototype.getMutationQueue = function (user) {
        var queue = this.mutationQueues[user.toKey()];
        if (!queue) {
            queue = new MemoryMutationQueue(this.referenceDelegate);
            this.mutationQueues[user.toKey()] = queue;
        }
        return queue;
    };
    MemoryPersistence.prototype.getQueryCache = function () {
        return this.queryCache;
    };
    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
        return this.remoteDocumentCache;
    };
    MemoryPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$4, 'Starting transaction:', action);
        var txn = new MemoryTransaction(this.listenSequence.next());
        this.referenceDelegate.onTransactionStarted();
        return transactionOperation(txn)
            .next(function (result) {
            return _this.referenceDelegate
                .onTransactionCommitted(txn)
                .next(function () { return result; });
        })
            .toPromise();
    };
    MemoryPersistence.prototype.mutationQueuesContainKey = function (transaction, key) {
        return PersistencePromise.or(values(this.mutationQueues)
            .map(function (queue) { return function () { return queue.containsKey(transaction, key); }; }));
    };
    return MemoryPersistence;
}());
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */
var MemoryTransaction = /** @class */ (function () {
    function MemoryTransaction(currentSequenceNumber) {
        this.currentSequenceNumber = currentSequenceNumber;
    }
    return MemoryTransaction;
}());
var MemoryEagerDelegate = /** @class */ (function () {
    function MemoryEagerDelegate(persistence) {
        this.persistence = persistence;
    }
    MemoryEagerDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryEagerDelegate.prototype.addReference = function (txn, key) {
        this.orphanedDocuments.delete(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeTarget = function (txn, queryData) {
        var _this = this;
        var cache = this.persistence.getQueryCache();
        return cache
            .getMatchingKeysForTargetId(txn, queryData.targetId)
            .next(function (keys) {
            keys.forEach(function (key) { return _this.orphanedDocuments.add(key); });
        })
            .next(function () { return cache.removeQueryData(txn, queryData); });
    };
    MemoryEagerDelegate.prototype.onTransactionStarted = function () {
        this.orphanedDocuments = new Set();
    };
    MemoryEagerDelegate.prototype.onTransactionCommitted = function (txn) {
        var _this = this;
        var cache = this.persistence.getRemoteDocumentCache();
        return PersistencePromise.forEach(this.orphanedDocuments, function (key) {
            return _this.isReferenced(txn, key).next(function (isReferenced) {
                if (!isReferenced) {
                    // Since this is the eager delegate and memory persistence,
                    // we don't care about the size of documents. We don't track
                    // the size of the cache for eager GC.
                    return cache.removeEntry(txn, key).next(function () { });
                }
                return PersistencePromise.resolve();
            });
        });
    };
    MemoryEagerDelegate.prototype.updateLimboDocument = function (txn, key) {
        var _this = this;
        return this.isReferenced(txn, key).next(function (isReferenced) {
            if (isReferenced) {
                _this.orphanedDocuments.delete(key);
            }
            else {
                _this.orphanedDocuments.add(key);
            }
        });
    };
    MemoryEagerDelegate.prototype.documentSize = function (doc) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    };
    MemoryEagerDelegate.prototype.isReferenced = function (txn, key) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.getQueryCache().containsKey(txn, key); },
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); }
        ]);
    };
    return MemoryEagerDelegate;
}());
var MemoryLruDelegate = /** @class */ (function () {
    function MemoryLruDelegate(persistence, serializer, lruParams) {
        this.persistence = persistence;
        this.serializer = serializer;
        this.orphanedSequenceNumbers = new ObjectMap(function (k) { return encode(k.path); });
        this.garbageCollector = new LruGarbageCollector(this, lruParams);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    MemoryLruDelegate.prototype.onTransactionStarted = function () { };
    MemoryLruDelegate.prototype.onTransactionCommitted = function (txn) {
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.persistence.getQueryCache().forEachTarget(txn, f);
    };
    MemoryLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocumentCount(txn);
        var targetCountPromise = this.persistence
            .getQueryCache()
            .getTargetCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    MemoryLruDelegate.prototype.orphanedDocumentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    MemoryLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        var _this = this;
        return PersistencePromise.forEach(this.orphanedSequenceNumbers, function (key, sequenceNumber) {
            // Pass in the exact sequence number as the upper bound so we know it won't be pinned by
            // being too recent.
            return _this.isPinned(txn, key, sequenceNumber).next(function (isPinned) {
                if (!isPinned) {
                    return f(sequenceNumber);
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    MemoryLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.persistence
            .getQueryCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    MemoryLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var cache = this.persistence.getRemoteDocumentCache();
        var p = cache.forEachDocumentKey(txn, function (key) {
            return _this.isPinned(txn, key, upperBound).next(function (isPinned) {
                if (isPinned) {
                    return PersistencePromise.resolve();
                }
                else {
                    count++;
                    // The memory remote document cache does its own byte
                    // accounting on removal. This is ok because updating the size
                    // for memory persistence does not incur IO.
                    return cache.removeEntry(txn, key).next();
                }
            });
        });
        return p.next(function () { return count; });
    };
    MemoryLruDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeTarget = function (txn, queryData) {
        var updated = queryData.copy({
            sequenceNumber: txn.currentSequenceNumber
        });
        return this.persistence.getQueryCache().updateQueryData(txn, updated);
    };
    MemoryLruDelegate.prototype.addReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.documentSize = function (maybeDoc) {
        var remoteDocument = this.serializer.toDbRemoteDocument(maybeDoc);
        var value;
        if (remoteDocument.document) {
            value = remoteDocument.document;
        }
        else if (remoteDocument.unknownDocument) {
            value = remoteDocument.unknownDocument;
        }
        else if (remoteDocument.noDocument) {
            value = remoteDocument.noDocument;
        }
        else {
            throw fail('Unknown remote document type');
        }
        return JSON.stringify(value).length;
    };
    MemoryLruDelegate.prototype.isPinned = function (txn, key, upperBound) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); },
            function () { return _this.persistence.getQueryCache().containsKey(txn, key); },
            function () {
                var orphanedAt = _this.orphanedSequenceNumbers.get(key);
                return PersistencePromise.resolve(orphanedAt !== undefined && orphanedAt > upperBound);
            }
        ]);
    };
    MemoryLruDelegate.prototype.getCacheSize = function (txn) {
        return this.persistence.getRemoteDocumentCache().getSize(txn);
    };
    return MemoryLruDelegate;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$5 = 'ExponentialBackoff';
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */
var ExponentialBackoff = /** @class */ (function () {
    function ExponentialBackoff(
    /**
     * The AsyncQueue to run backoff operations on.
     */
    queue, 
    /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */
    timerId, 
    /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */
    initialDelayMs, 
    /**
     * The multiplier to use to determine the extended base delay after each
     * attempt.
     */
    backoffFactor, 
    /**
     * The maximum base delay after which no further backoff is performed.
     * Note that jitter will still be applied, so the actual delay could be as
     * much as 1.5*maxDelayMs.
     */
    maxDelayMs) {
        this.queue = queue;
        this.timerId = timerId;
        this.initialDelayMs = initialDelayMs;
        this.backoffFactor = backoffFactor;
        this.maxDelayMs = maxDelayMs;
        this.timerPromise = null;
        /** The last backoff attempt, as epoch milliseconds. */
        this.lastAttemptTime = Date.now();
        this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */
    ExponentialBackoff.prototype.reset = function () {
        this.currentBaseMs = 0;
    };
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */
    ExponentialBackoff.prototype.resetToMax = function () {
        this.currentBaseMs = this.maxDelayMs;
    };
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */
    ExponentialBackoff.prototype.backoffAndRun = function (op) {
        var _this = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var desiredDelayWithJitterMs = Math.floor(this.currentBaseMs + this.jitterDelayMs());
        // Guard against lastAttemptTime being in the future due to a clock change.
        var delaySoFarMs = Math.max(0, Date.now() - this.lastAttemptTime);
        // Guard against the backoff delay already being past.
        var remainingDelayMs = Math.max(0, desiredDelayWithJitterMs - delaySoFarMs);
        if (this.currentBaseMs > 0) {
            debug(LOG_TAG$5, "Backing off for " + remainingDelayMs + " ms " +
                ("(base delay: " + this.currentBaseMs + " ms, ") +
                ("delay with jitter: " + desiredDelayWithJitterMs + " ms, ") +
                ("last attempt: " + delaySoFarMs + " ms ago)"));
        }
        this.timerPromise = this.queue.enqueueAfterDelay(this.timerId, remainingDelayMs, function () {
            _this.lastAttemptTime = Date.now();
            return op();
        });
        // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.currentBaseMs *= this.backoffFactor;
        if (this.currentBaseMs < this.initialDelayMs) {
            this.currentBaseMs = this.initialDelayMs;
        }
        if (this.currentBaseMs > this.maxDelayMs) {
            this.currentBaseMs = this.maxDelayMs;
        }
    };
    ExponentialBackoff.prototype.cancel = function () {
        if (this.timerPromise !== null) {
            this.timerPromise.cancel();
            this.timerPromise = null;
        }
    };
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
    ExponentialBackoff.prototype.jitterDelayMs = function () {
        return (Math.random() - 0.5) * this.currentBaseMs;
    };
    return ExponentialBackoff;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$6 = 'PersistentStream';
/**
 * PersistentStream can be in one of 5 states (each described in detail below)
 * based on the following state transition diagram:
 *
 *          start() called             auth & connection succeeded
 * INITIAL ----------------> STARTING -----------------------------> OPEN
 *                             ^  |                                   |
 *                             |  |                    error occurred |
 *                             |  \-----------------------------v-----/
 *                             |                                |
 *                    backoff  |                                |
 *                    elapsed  |              start() called    |
 *                             \--- BACKOFF <---------------- ERROR
 *
 * [any state] --------------------------> INITIAL
 *               stop() called or
 *               idle timer expired
 */
var PersistentStreamState;
(function (PersistentStreamState) {
    /**
     * The streaming RPC is not yet running and there's no error condition.
     * Calling start() will start the stream immediately without backoff.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
    /**
     * The stream is starting, either waiting for an auth token or for the stream
     * to successfully open. While in this state, isStarted() will return true but
     * isOpen() will return false.
     */
    PersistentStreamState[PersistentStreamState["Starting"] = 1] = "Starting";
    /**
     * The streaming RPC is up and running. Requests and responses can flow
     * freely. Both isStarted() and isOpen() will return true.
     */
    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
    /**
     * The stream encountered an error. The next start attempt will back off.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
    /**
     * An in-between state after an error where the stream is waiting before
     * re-starting. After waiting is complete, the stream will try to open.
     * While in this state isStarted() will return true but isOpen() will return
     * false.
     */
    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
})(PersistentStreamState || (PersistentStreamState = {}));
/**
 * Initial backoff time in milliseconds after an error.
 * Set to 1s according to https://cloud.google.com/apis/design/errors.
 */
var BACKOFF_INITIAL_DELAY_MS = 1000;
/** Maximum backoff time in milliseconds */
var BACKOFF_MAX_DELAY_MS = 60 * 1000;
var BACKOFF_FACTOR = 1.5;
/** The time a stream stays open after it is marked idle. */
var IDLE_TIMEOUT_MS = 60 * 1000;
/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */
var PersistentStream = /** @class */ (function () {
    function PersistentStream(queue, connectionTimerId, idleTimerId, connection, credentialsProvider, listener) {
        this.queue = queue;
        this.idleTimerId = idleTimerId;
        this.connection = connection;
        this.credentialsProvider = credentialsProvider;
        this.listener = listener;
        this.state = PersistentStreamState.Initial;
        /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */
        this.closeCount = 0;
        this.idleTimer = null;
        this.stream = null;
        this.backoff = new ExponentialBackoff(queue, connectionTimerId, BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */
    PersistentStream.prototype.isStarted = function () {
        return (this.state === PersistentStreamState.Starting ||
            this.state === PersistentStreamState.Open ||
            this.state === PersistentStreamState.Backoff);
    };
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */
    PersistentStream.prototype.isOpen = function () {
        return this.state === PersistentStreamState.Open;
    };
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */
    PersistentStream.prototype.start = function () {
        if (this.state === PersistentStreamState.Error) {
            this.performBackoff();
            return;
        }
        assert(this.state === PersistentStreamState.Initial, 'Already started');
        this.auth();
    };
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */
    PersistentStream.prototype.stop = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isStarted()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.close(PersistentStreamState.Initial)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */
    PersistentStream.prototype.inhibitBackoff = function () {
        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
        this.state = PersistentStreamState.Initial;
        this.backoff.reset();
    };
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */
    PersistentStream.prototype.markIdle = function () {
        var _this = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        if (this.isOpen() && this.idleTimer === null) {
            this.idleTimer = this.queue.enqueueAfterDelay(this.idleTimerId, IDLE_TIMEOUT_MS, function () { return _this.handleIdleCloseTimer(); });
        }
    };
    /** Sends a message to the underlying stream. */
    PersistentStream.prototype.sendRequest = function (msg) {
        this.cancelIdleCheck();
        this.stream.send(msg);
    };
    /** Called by the idle timer when the stream should close due to inactivity. */
    PersistentStream.prototype.handleIdleCloseTimer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.isOpen()) {
                    // When timing out an idle stream there's no reason to force the stream into backoff when
                    // it restarts so set the stream state to Initial instead of Error.
                    return [2 /*return*/, this.close(PersistentStreamState.Initial)];
                }
                return [2 /*return*/];
            });
        });
    };
    /** Marks the stream as active again. */
    PersistentStream.prototype.cancelIdleCheck = function () {
        if (this.idleTimer) {
            this.idleTimer.cancel();
            this.idleTimer = null;
        }
    };
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */
    PersistentStream.prototype.close = function (finalState, error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert(this.isStarted(), 'Only started streams should be closed.');
                        assert(finalState === PersistentStreamState.Error || isNullOrUndefined(error$$1), "Can't provide an error when not in an error state.");
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        this.cancelIdleCheck();
                        this.backoff.cancel();
                        // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.closeCount++;
                        if (finalState !== PersistentStreamState.Error) {
                            // If this is an intentional close ensure we don't delay our next connection attempt.
                            this.backoff.reset();
                        }
                        else if (error$$1 && error$$1.code === Code.RESOURCE_EXHAUSTED) {
                            // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                            error(error$$1.toString());
                            error('Using maximum backoff delay to prevent overloading the backend.');
                            this.backoff.resetToMax();
                        }
                        else if (error$$1 && error$$1.code === Code.UNAUTHENTICATED) {
                            // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                            // just expired.
                            this.credentialsProvider.invalidateToken();
                        }
                        // Clean up the underlying stream because we are no longer interested in events.
                        if (this.stream !== null) {
                            this.tearDown();
                            this.stream.close();
                            this.stream = null;
                        }
                        // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = finalState;
                        // Notify the listener that the stream closed.
                        return [4 /*yield*/, this.listener.onClose(error$$1)];
                    case 1:
                        // Notify the listener that the stream closed.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */
    PersistentStream.prototype.tearDown = function () { };
    PersistentStream.prototype.auth = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
        this.state = PersistentStreamState.Starting;
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        var closeCount = this.closeCount;
        this.credentialsProvider.getToken().then(function (token) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            if (_this.closeCount === closeCount) {
                // Normally we'd have to schedule the callback on the AsyncQueue.
                // However, the following calls are safe to be called outside the
                // AsyncQueue since they don't chain asynchronous calls
                _this.startStream(token);
            }
        }, function (error$$1) {
            dispatchIfNotClosed(function () {
                var rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error$$1.message);
                return _this.handleStreamClose(rpcError);
            });
        });
    };
    PersistentStream.prototype.startStream = function (token) {
        var _this = this;
        assert(this.state === PersistentStreamState.Starting, 'Trying to start stream in a non-starting state');
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        this.stream = this.startRpc(token);
        this.stream.onOpen(function () {
            dispatchIfNotClosed(function () {
                assert(_this.state === PersistentStreamState.Starting, 'Expected stream to be in state Starting, but was ' + _this.state);
                _this.state = PersistentStreamState.Open;
                return _this.listener.onOpen();
            });
        });
        this.stream.onClose(function (error$$1) {
            dispatchIfNotClosed(function () {
                return _this.handleStreamClose(error$$1);
            });
        });
        this.stream.onMessage(function (msg) {
            dispatchIfNotClosed(function () {
                return _this.onMessage(msg);
            });
        });
    };
    PersistentStream.prototype.performBackoff = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff when in Error state');
        this.state = PersistentStreamState.Backoff;
        this.backoff.backoffAndRun(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                assert(this.state === PersistentStreamState.Backoff, 'Backoff elapsed but state is now: ' + this.state);
                this.state = PersistentStreamState.Initial;
                this.start();
                assert(this.isStarted(), 'PersistentStream should have started');
                return [2 /*return*/];
            });
        }); });
    };
    // Visible for tests
    PersistentStream.prototype.handleStreamClose = function (error$$1) {
        assert(this.isStarted(), "Can't handle server close on non-started stream");
        debug(LOG_TAG$6, "close with error: " + error$$1);
        this.stream = null;
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return this.close(PersistentStreamState.Error, error$$1);
    };
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */
    PersistentStream.prototype.getCloseGuardedDispatcher = function (startCloseCount) {
        var _this = this;
        return function (fn) {
            _this.queue.enqueueAndForget(function () {
                if (_this.closeCount === startCloseCount) {
                    return fn();
                }
                else {
                    debug(LOG_TAG$6, 'stream callback skipped by getCloseGuardedDispatcher.');
                    return Promise.resolve();
                }
            });
        };
    };
    return PersistentStream;
}());
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */
var PersistentListenStream = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentListenStream, _super);
    function PersistentListenStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.ListenStreamConnectionBackoff, TimerId.ListenStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        return _this;
    }
    PersistentListenStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Listen', token);
    };
    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
        // A successful response means the stream is healthy
        this.backoff.reset();
        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
        return this.listener.onWatchChange(watchChange, snapshot);
    };
    /**
     * Registers interest in the results of the given query. If the query
     * includes a resumeToken it will be included in the request. Results that
     * affect the query will be streamed back as WatchChange messages that
     * reference the targetId.
     */
    PersistentListenStream.prototype.watch = function (queryData) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.addTarget = this.serializer.toTarget(queryData);
        var labels = this.serializer.toListenRequestLabels(queryData);
        if (labels) {
            request.labels = labels;
        }
        this.sendRequest(request);
    };
    /**
     * Unregisters interest in the results of the query associated with the
     * given targetId.
     */
    PersistentListenStream.prototype.unwatch = function (targetId) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.removeTarget = targetId;
        this.sendRequest(request);
    };
    return PersistentListenStream;
}(PersistentStream));
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */
var PersistentWriteStream = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentWriteStream, _super);
    function PersistentWriteStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.WriteStreamConnectionBackoff, TimerId.WriteStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        _this.handshakeComplete_ = false;
        return _this;
    }
    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */
        get: function () {
            return this.handshakeComplete_;
        },
        enumerable: true,
        configurable: true
    });
    // Override of PersistentStream.start
    PersistentWriteStream.prototype.start = function () {
        this.handshakeComplete_ = false;
        _super.prototype.start.call(this);
    };
    PersistentWriteStream.prototype.tearDown = function () {
        if (this.handshakeComplete_) {
            this.writeMutations([]);
        }
    };
    PersistentWriteStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Write', token);
    };
    PersistentWriteStream.prototype.onMessage = function (responseProto) {
        // Always capture the last stream token.
        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
        this.lastStreamToken = responseProto.streamToken;
        if (!this.handshakeComplete_) {
            // The first response is always the handshake response
            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
            this.handshakeComplete_ = true;
            return this.listener.onHandshakeComplete();
        }
        else {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.backoff.reset();
            var results = this.serializer.fromWriteResults(responseProto.writeResults, responseProto.commitTime);
            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
            return this.listener.onMutationResult(commitVersion, results);
        }
    };
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */
    PersistentWriteStream.prototype.writeHandshake = function () {
        assert(this.isOpen(), 'Writing handshake requires an opened stream');
        assert(!this.handshakeComplete_, 'Handshake already completed');
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        this.sendRequest(request);
    };
    /** Sends a group of mutations to the Firestore backend to apply. */
    PersistentWriteStream.prototype.writeMutations = function (mutations) {
        var _this = this;
        assert(this.isOpen(), 'Writing mutations requires an opened stream');
        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
        var request = {
            // Protos are typed with string, but we support UInt8Array on Node
            // tslint:disable-next-line:no-any
            streamToken: this.lastStreamToken,
            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
        };
        this.sendRequest(request);
    };
    return PersistentWriteStream;
}(PersistentStream));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
 * which provides an interface that is more convenient for the rest of the
 * client SDK architecture to consume.
 */
var Datastore = /** @class */ (function () {
    function Datastore(queue, connection, credentials, serializer) {
        this.queue = queue;
        this.connection = connection;
        this.credentials = credentials;
        this.serializer = serializer;
    }
    Datastore.prototype.newPersistentWriteStream = function (listener) {
        return new PersistentWriteStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.newPersistentWatchStream = function (listener) {
        return new PersistentListenStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.commit = function (mutations) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
        };
        return this.invokeRPC('Commit', params).then(function (response) {
            return _this.serializer.fromWriteResults(response.writeResults, response.commitTime);
        });
    };
    Datastore.prototype.lookup = function (keys) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            documents: keys.map(function (k) { return _this.serializer.toName(k); })
        };
        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
            var docs = maybeDocumentMap();
            response.forEach(function (proto) {
                var doc = _this.serializer.fromMaybeDocument(proto);
                docs = docs.insert(doc.key, doc);
            });
            var result = [];
            keys.forEach(function (key) {
                var doc = docs.get(key);
                assert(!!doc, 'Missing entity in write response for ' + key);
                result.push(doc);
            });
            return result;
        });
    };
    /** Gets an auth token and invokes the provided RPC. */
    Datastore.prototype.invokeRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    /** Gets an auth token and invokes the provided RPC with streamed results. */
    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeStreamingRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    return Datastore;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */
var Transaction = /** @class */ (function () {
    function Transaction(datastore) {
        this.datastore = datastore;
        // The version of each document that was read during this transaction.
        this.readVersions = documentVersionMap();
        this.mutations = [];
        this.committed = false;
    }
    Transaction.prototype.recordVersion = function (doc) {
        var docVersion;
        if (doc instanceof Document) {
            docVersion = doc.version;
        }
        else if (doc instanceof NoDocument) {
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            docVersion = SnapshotVersion.forDeletedDoc();
        }
        else {
            throw fail('Document in a transaction was a ' + doc.constructor.name);
        }
        var existingVersion = this.readVersions.get(doc.key);
        if (existingVersion !== null) {
            if (!docVersion.isEqual(existingVersion)) {
                // This transaction will fail no matter what.
                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
            }
        }
        else {
            this.readVersions = this.readVersions.insert(doc.key, docVersion);
        }
    };
    Transaction.prototype.lookup = function (keys) {
        var _this = this;
        if (this.committed) {
            return Promise.reject('Transaction has already completed.');
        }
        if (this.mutations.length > 0) {
            return Promise.reject('Transactions lookups are invalid after writes.');
        }
        return this.datastore.lookup(keys).then(function (docs) {
            docs.forEach(function (doc) {
                if (doc instanceof NoDocument || doc instanceof Document) {
                    _this.recordVersion(doc);
                }
                else {
                    fail('Document in a transaction was a ' + doc.constructor.name);
                }
            });
            return docs;
        });
    };
    Transaction.prototype.write = function (mutations) {
        if (this.committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Transaction has already completed.');
        }
        this.mutations = this.mutations.concat(mutations);
    };
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */
    Transaction.prototype.precondition = function (key) {
        var version = this.readVersions.get(key);
        if (version) {
            return Precondition.updateTime(version);
        }
        else {
            return Precondition.NONE;
        }
    };
    /**
     * Returns the precondition for a document if the operation is an update.
     */
    Transaction.prototype.preconditionForUpdate = function (key) {
        var version = this.readVersions.get(key);
        if (version && version.isEqual(SnapshotVersion.forDeletedDoc())) {
            // The document doesn't exist, so fail the transaction.
            throw new FirestoreError(Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
        }
        else if (version) {
            // Document exists, base precondition on document update time.
            return Precondition.updateTime(version);
        }
        else {
            // Document was not read, so we just use the preconditions for a blind
            // update.
            return Precondition.exists(true);
        }
    };
    Transaction.prototype.set = function (key, data) {
        this.write(data.toMutations(key, this.precondition(key)));
    };
    Transaction.prototype.update = function (key, data) {
        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
    };
    Transaction.prototype.delete = function (key) {
        this.write([new DeleteMutation(key, this.precondition(key))]);
        // Since the delete will be applied before all following writes, we need to
        // ensure that the precondition for the next write will be exists: false.
        this.readVersions = this.readVersions.insert(key, SnapshotVersion.forDeletedDoc());
    };
    Transaction.prototype.commit = function () {
        var _this = this;
        var unwritten = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach(function (mutation) {
            unwritten = unwritten.remove(mutation.key);
        });
        if (!unwritten.isEmpty()) {
            return Promise.reject(Error('Every document read in a transaction must also be written.'));
        }
        return this.datastore.commit(this.mutations).then(function () {
            _this.committed = true;
        });
    };
    return Transaction;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Describes the online state of the Firestore client. Note that this does not
 * indicate whether or not the remote store is trying to connect or not. This is
 * primarily used by the View / EventManager code to change their behavior while
 * offline (e.g. get() calls shouldn't wait for data from the server and
 * snapshot events should set metadata.isFromCache=true).
 */
var OnlineState;
(function (OnlineState) {
    /**
     * The Firestore client is in an unknown online state. This means the client
     * is either not actively trying to establish a connection or it is currently
     * trying to establish a connection, but it has not succeeded or failed yet.
     * Higher-level components should not operate in offline mode.
     */
    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
    /**
     * The client is connected and the connections are healthy. This state is
     * reached after a successful connection and there has been at least one
     * successful message received from the backends.
     */
    OnlineState[OnlineState["Online"] = 1] = "Online";
    /**
     * The client is either trying to establish a connection but failing, or it
     * has been explicitly marked offline via a call to disableNetwork().
     * Higher-level components should operate in offline mode.
     */
    OnlineState[OnlineState["Offline"] = 2] = "Offline";
})(OnlineState || (OnlineState = {}));
/** The source of an online state event. */
var OnlineStateSource;
(function (OnlineStateSource) {
    OnlineStateSource[OnlineStateSource["RemoteStore"] = 0] = "RemoteStore";
    OnlineStateSource[OnlineStateSource["SharedClientState"] = 1] = "SharedClientState";
})(OnlineStateSource || (OnlineStateSource = {}));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$7 = 'OnlineStateTracker';
// To deal with transient failures, we allow multiple stream attempts before
// giving up and transitioning from OnlineState.Unknown to Offline.
// TODO(mikelehen): This used to be set to 2 as a mitigation for b/66228394.
// @jdimond thinks that bug is sufficiently fixed so that we can set this back
// to 1. If that works okay, we could potentially remove this logic entirely.
var MAX_WATCH_STREAM_FAILURES = 1;
// To deal with stream attempts that don't succeed or fail in a timely manner,
// we have a timeout for OnlineState to reach Online or Offline.
// If the timeout is reached, we transition to Offline rather than waiting
// indefinitely.
var ONLINE_STATE_TIMEOUT_MS = 10 * 1000;
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */
var OnlineStateTracker = /** @class */ (function () {
    function OnlineStateTracker(asyncQueue, onlineStateHandler) {
        this.asyncQueue = asyncQueue;
        this.onlineStateHandler = onlineStateHandler;
        /** The current OnlineState. */
        this.state = OnlineState.Unknown;
        /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */
        this.watchStreamFailures = 0;
        /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */
        this.onlineStateTimer = null;
        /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */
        this.shouldWarnClientIsOffline = true;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */
    OnlineStateTracker.prototype.handleWatchStreamStart = function () {
        var _this = this;
        if (this.watchStreamFailures === 0) {
            this.setAndBroadcast(OnlineState.Unknown);
            assert(this.onlineStateTimer === null, "onlineStateTimer shouldn't be started yet");
            this.onlineStateTimer = this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout, ONLINE_STATE_TIMEOUT_MS, function () {
                _this.onlineStateTimer = null;
                assert(_this.state === OnlineState.Unknown, 'Timer should be canceled if we transitioned to a different state.');
                _this.logClientOfflineWarningIfNecessary("Backend didn't respond within " + ONLINE_STATE_TIMEOUT_MS / 1000 + " " +
                    "seconds.");
                _this.setAndBroadcast(OnlineState.Offline);
                // NOTE: handleWatchStreamFailure() will continue to increment
                // watchStreamFailures even though we are already marked Offline,
                // but this is non-harmful.
                return Promise.resolve();
            });
        }
    };
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */
    OnlineStateTracker.prototype.handleWatchStreamFailure = function (error$$1) {
        if (this.state === OnlineState.Online) {
            this.setAndBroadcast(OnlineState.Unknown);
            // To get to OnlineState.Online, set() must have been called which would
            // have reset our heuristics.
            assert(this.watchStreamFailures === 0, 'watchStreamFailures must be 0');
            assert(this.onlineStateTimer === null, 'onlineStateTimer must be null');
        }
        else {
            this.watchStreamFailures++;
            if (this.watchStreamFailures >= MAX_WATCH_STREAM_FAILURES) {
                this.clearOnlineStateTimer();
                this.logClientOfflineWarningIfNecessary("Connection failed " + MAX_WATCH_STREAM_FAILURES + " " +
                    ("times. Most recent error: " + error$$1.toString()));
                this.setAndBroadcast(OnlineState.Offline);
            }
        }
    };
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */
    OnlineStateTracker.prototype.set = function (newState) {
        this.clearOnlineStateTimer();
        this.watchStreamFailures = 0;
        if (newState === OnlineState.Online) {
            // We've connected to watch at least once. Don't warn the developer
            // about being offline going forward.
            this.shouldWarnClientIsOffline = false;
        }
        this.setAndBroadcast(newState);
    };
    OnlineStateTracker.prototype.setAndBroadcast = function (newState) {
        if (newState !== this.state) {
            this.state = newState;
            this.onlineStateHandler(newState);
        }
    };
    OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary = function (details) {
        var message = "Could not reach Cloud Firestore backend. " + details + "\n" +
            "This typically indicates that your device does not have a healthy " +
            "Internet connection at the moment. The client will operate in offline " +
            "mode until it is able to successfully connect to the backend.";
        if (this.shouldWarnClientIsOffline) {
            error(message);
            this.shouldWarnClientIsOffline = false;
        }
        else {
            debug(LOG_TAG$7, message);
        }
    };
    OnlineStateTracker.prototype.clearOnlineStateTimer = function () {
        if (this.onlineStateTimer !== null) {
            this.onlineStateTimer.cancel();
            this.onlineStateTimer = null;
        }
    };
    return OnlineStateTracker;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$8 = 'RemoteStore';
// TODO(b/35853402): Negotiate this with the stream.
var MAX_PENDING_WRITES = 10;
/**
 * RemoteStore - An interface to remotely stored data, basically providing a
 * wrapper around the Datastore that is more reliable for the rest of the
 * system.
 *
 * RemoteStore is responsible for maintaining the connection to the server.
 * - maintaining a list of active listens.
 * - reconnecting when the connection is dropped.
 * - resuming all the active listens on reconnect.
 *
 * RemoteStore handles all incoming events from the Datastore.
 * - listening to the watch stream and repackaging the events as RemoteEvents
 * - notifying SyncEngine of any changes to the active listens.
 *
 * RemoteStore takes writes from other components and handles them reliably.
 * - pulling pending mutations from LocalStore and sending them to Datastore.
 * - retrying mutations that failed because of network problems.
 * - acking mutations to the SyncEngine once they are accepted or rejected.
 */
var RemoteStore = /** @class */ (function () {
    function RemoteStore(
    /**
     * The local store, used to fill the write pipeline with outbound mutations.
     */
    localStore, 
    /** The client-side proxy for interacting with the backend. */
    datastore, asyncQueue, onlineStateHandler) {
        this.localStore = localStore;
        this.datastore = datastore;
        /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */
        this.writePipeline = [];
        /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */
        this.listenTargets = {};
        this.watchChangeAggregator = null;
        /**
         * Set to true by enableNetwork() and false by disableNetwork() and indicates
         * the user-preferred network state.
         */
        this.networkEnabled = false;
        this.isPrimary = false;
        this.onlineStateTracker = new OnlineStateTracker(asyncQueue, onlineStateHandler);
        // Create streams (but note they're not started yet).
        this.watchStream = this.datastore.newPersistentWatchStream({
            onOpen: this.onWatchStreamOpen.bind(this),
            onClose: this.onWatchStreamClose.bind(this),
            onWatchChange: this.onWatchStreamChange.bind(this)
        });
        this.writeStream = this.datastore.newPersistentWriteStream({
            onOpen: this.onWriteStreamOpen.bind(this),
            onClose: this.onWriteStreamClose.bind(this),
            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
            onMutationResult: this.onMutationResult.bind(this)
        });
    }
    /**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */
    RemoteStore.prototype.start = function () {
        return this.enableNetwork();
    };
    /** Re-enables the network. Idempotent. */
    RemoteStore.prototype.enableNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.networkEnabled = true;
                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
                        _a = this.writeStream;
                        return [4 /*yield*/, this.localStore.getLastStreamToken()];
                    case 1:
                        _a.lastStreamToken = _b.sent();
                        if (this.shouldStartWatchStream()) {
                            this.startWatchStream();
                        }
                        else {
                            this.onlineStateTracker.set(OnlineState.Unknown);
                        }
                        // This will start the write stream if necessary.
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 2:
                        // This will start the write stream if necessary.
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Temporarily disables the network. The network can be re-enabled using
     * enableNetwork().
     */
    RemoteStore.prototype.disableNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        // Set the OnlineState to Offline so get()s return from cache, etc.
                        this.onlineStateTracker.set(OnlineState.Offline);
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.disableNetworkInternal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeStream.stop()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.watchStream.stop()];
                    case 2:
                        _a.sent();
                        if (this.writePipeline.length > 0) {
                            debug(LOG_TAG$8, "Stopping write stream with " + this.writePipeline.length + " pending writes");
                            this.writePipeline = [];
                        }
                        this.cleanUpWatchStreamState();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.shutdown = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug(LOG_TAG$8, 'RemoteStore shutting down.');
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                        // triggering spurious listener events with cached data, etc.
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Starts new listen for the given query. Uses resume token if provided */
    RemoteStore.prototype.listen = function (queryData) {
        assert(!contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
        // Mark this as something the client is currently listening for.
        this.listenTargets[queryData.targetId] = queryData;
        if (this.shouldStartWatchStream()) {
            // The listen will be sent in onWatchStreamOpen
            this.startWatchStream();
        }
        else if (this.watchStream.isOpen()) {
            this.sendWatchRequest(queryData);
        }
    };
    /** Removes the listen from server */
    RemoteStore.prototype.unlisten = function (targetId) {
        assert(contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
        delete this.listenTargets[targetId];
        if (this.watchStream.isOpen()) {
            this.sendUnwatchRequest(targetId);
        }
        if (isEmpty(this.listenTargets)) {
            if (this.watchStream.isOpen()) {
                this.watchStream.markIdle();
            }
            else if (this.canUseNetwork()) {
                // Revert to OnlineState.Unknown if the watch stream is not open and we
                // have no listeners, since without any listens to send we cannot
                // confirm if the stream is healthy and upgrade to OnlineState.Online.
                this.onlineStateTracker.set(OnlineState.Unknown);
            }
        }
    };
    /** {@link TargetMetadataProvider.getQueryDataForTarget} */
    RemoteStore.prototype.getQueryDataForTarget = function (targetId) {
        return this.listenTargets[targetId] || null;
    };
    /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */
    RemoteStore.prototype.getRemoteKeysForTarget = function (targetId) {
        return this.syncEngine.getRemoteKeysForTarget(targetId);
    };
    /**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */
    RemoteStore.prototype.sendWatchRequest = function (queryData) {
        this.watchChangeAggregator.recordPendingTargetRequest(queryData.targetId);
        this.watchStream.watch(queryData);
    };
    /**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */
    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
        this.watchChangeAggregator.recordPendingTargetRequest(targetId);
        this.watchStream.unwatch(targetId);
    };
    RemoteStore.prototype.startWatchStream = function () {
        assert(this.shouldStartWatchStream(), 'startWatchStream() called when shouldStartWatchStream() is false.');
        this.watchChangeAggregator = new WatchChangeAggregator(this);
        this.watchStream.start();
        this.onlineStateTracker.handleWatchStreamStart();
    };
    /**
     * Returns whether the watch stream should be started because it's necessary
     * and has not yet been started.
     */
    RemoteStore.prototype.shouldStartWatchStream = function () {
        return (this.canUseNetwork() &&
            !this.watchStream.isStarted() &&
            !isEmpty(this.listenTargets));
    };
    RemoteStore.prototype.canUseNetwork = function () {
        return this.isPrimary && this.networkEnabled;
    };
    RemoteStore.prototype.cleanUpWatchStreamState = function () {
        this.watchChangeAggregator = null;
    };
    RemoteStore.prototype.onWatchStreamOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                forEachNumber(this.listenTargets, function (targetId, queryData) {
                    _this.sendWatchRequest(queryData);
                });
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamClose = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (error$$1 === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWatchStream(), 'Watch stream was stopped gracefully while still needed.');
                }
                this.cleanUpWatchStreamState();
                // If we still need the watch stream, retry the connection.
                if (this.shouldStartWatchStream()) {
                    this.onlineStateTracker.handleWatchStreamFailure(error$$1);
                    this.startWatchStream();
                }
                else {
                    // No need to restart watch stream because there are no active targets.
                    // The online state is set to unknown because there is no active attempt
                    // at establishing a connection
                    this.onlineStateTracker.set(OnlineState.Unknown);
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastRemoteSnapshotVersion;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Mark the client as online since we got a message from the server
                        this.onlineStateTracker.set(OnlineState.Online);
                        if (watchChange instanceof WatchTargetChange &&
                            watchChange.state === WatchTargetChangeState.Removed &&
                            watchChange.cause) {
                            // There was an error on a target, don't wait for a consistent snapshot
                            // to raise events
                            return [2 /*return*/, this.handleTargetError(watchChange)];
                        }
                        if (watchChange instanceof DocumentWatchChange) {
                            this.watchChangeAggregator.handleDocumentChange(watchChange);
                        }
                        else if (watchChange instanceof ExistenceFilterChange) {
                            this.watchChangeAggregator.handleExistenceFilter(watchChange);
                        }
                        else {
                            assert(watchChange instanceof WatchTargetChange, 'Expected watchChange to be an instance of WatchTargetChange');
                            this.watchChangeAggregator.handleTargetChange(watchChange);
                        }
                        if (!!snapshotVersion.isEqual(SnapshotVersion.MIN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.getLastRemoteSnapshotVersion()];
                    case 1:
                        lastRemoteSnapshotVersion = _a.sent();
                        if (!(snapshotVersion.compareTo(lastRemoteSnapshotVersion) >= 0)) return [3 /*break*/, 3];
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        return [4 /*yield*/, this.raiseWatchSnapshot(snapshotVersion)];
                    case 2:
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */
    RemoteStore.prototype.raiseWatchSnapshot = function (snapshotVersion) {
        var _this = this;
        assert(!snapshotVersion.isEqual(SnapshotVersion.MIN), "Can't raise event for unknown SnapshotVersion");
        var remoteEvent = this.watchChangeAggregator.createRemoteEvent(snapshotVersion);
        // Update in-memory resume tokens. LocalStore will update the
        // persistent view of these when applying the completed RemoteEvent.
        forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
            if (change.resumeToken.length > 0) {
                var queryData = _this.listenTargets[targetId];
                // A watched target might have been removed already.
                if (queryData) {
                    _this.listenTargets[targetId] = queryData.copy({
                        resumeToken: change.resumeToken,
                        snapshotVersion: snapshotVersion
                    });
                }
            }
        });
        // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        remoteEvent.targetMismatches.forEach(function (targetId) {
            var queryData = _this.listenTargets[targetId];
            if (!queryData) {
                // A watched target might have been removed already.
                return;
            }
            // Clear the resume token for the query, since we're in a known mismatch
            // state.
            _this.listenTargets[targetId] = queryData.copy({
                resumeToken: emptyByteString()
            });
            // Cause a hard reset by unwatching and rewatching immediately, but
            // deliberately don't send a resume token so that we get a full update.
            _this.sendUnwatchRequest(targetId);
            // Mark the query we send as being on behalf of an existence filter
            // mismatch, but don't actually retain that in listenTargets. This ensures
            // that we flag the first re-listen this way without impacting future
            // listens of this target (that might happen e.g. on reconnect).
            var requestQueryData = new QueryData(queryData.query, targetId, QueryPurpose.ExistenceFilterMismatch, queryData.sequenceNumber);
            _this.sendWatchRequest(requestQueryData);
        });
        // Finally raise remote event
        return this.syncEngine.applyRemoteEvent(remoteEvent);
    };
    /** Handles an error on a target */
    RemoteStore.prototype.handleTargetError = function (watchChange) {
        var _this = this;
        assert(!!watchChange.cause, 'Handling target error without a cause');
        var error$$1 = watchChange.cause;
        var promiseChain = Promise.resolve();
        watchChange.targetIds.forEach(function (targetId) {
            promiseChain = promiseChain.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    // A watched target might have been removed already.
                    if (contains(this.listenTargets, targetId)) {
                        delete this.listenTargets[targetId];
                        this.watchChangeAggregator.removeTarget(targetId);
                        return [2 /*return*/, this.syncEngine.rejectListen(targetId, error$$1)];
                    }
                    return [2 /*return*/];
                });
            }); });
        });
        return promiseChain;
    };
    /**
     * Attempts to fill our write pipeline with writes from the LocalStore.
     *
     * Called internally to bootstrap or refill the write pipeline and by
     * SyncEngine whenever there are new mutations to process.
     *
     * Starts the write stream if necessary.
     */
    RemoteStore.prototype.fillWritePipeline = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastBatchIdRetrieved, batch;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canAddToWritePipeline()) return [3 /*break*/, 4];
                        lastBatchIdRetrieved = this.writePipeline.length > 0
                            ? this.writePipeline[this.writePipeline.length - 1].batchId
                            : BATCHID_UNKNOWN;
                        return [4 /*yield*/, this.localStore.nextMutationBatch(lastBatchIdRetrieved)];
                    case 1:
                        batch = _a.sent();
                        if (!(batch === null)) return [3 /*break*/, 2];
                        if (this.writePipeline.length === 0) {
                            this.writeStream.markIdle();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        this.addToWritePipeline(batch);
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.shouldStartWriteStream()) {
                            this.startWriteStream();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns true if we can add to the write pipeline (i.e. the network is
     * enabled and the write pipeline is not full).
     */
    RemoteStore.prototype.canAddToWritePipeline = function () {
        return (this.canUseNetwork() && this.writePipeline.length < MAX_PENDING_WRITES);
    };
    // For testing
    RemoteStore.prototype.outstandingWrites = function () {
        return this.writePipeline.length;
    };
    /**
     * Queues additional writes to be sent to the write stream, sending them
     * immediately if the write stream is established.
     */
    RemoteStore.prototype.addToWritePipeline = function (batch) {
        assert(this.canAddToWritePipeline(), 'addToWritePipeline called when pipeline is full');
        this.writePipeline.push(batch);
        if (this.writeStream.isOpen() && this.writeStream.handshakeComplete) {
            this.writeStream.writeMutations(batch.mutations);
        }
    };
    RemoteStore.prototype.shouldStartWriteStream = function () {
        return (this.canUseNetwork() &&
            !this.writeStream.isStarted() &&
            this.writePipeline.length > 0);
    };
    RemoteStore.prototype.startWriteStream = function () {
        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
        this.writeStream.start();
    };
    RemoteStore.prototype.onWriteStreamOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.writeStream.writeHandshake();
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWriteHandshakeComplete = function () {
        var _this = this;
        // Record the stream token.
        return this.localStore
            .setLastStreamToken(this.writeStream.lastStreamToken)
            .then(function () {
            // Send the write pipeline now that the stream is established.
            for (var _i = 0, _a = _this.writePipeline; _i < _a.length; _i++) {
                var batch = _a[_i];
                _this.writeStream.writeMutations(batch.mutations);
            }
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
        var _this = this;
        // This is a response to a write containing mutations and should be
        // correlated to the first write in our write pipeline.
        assert(this.writePipeline.length > 0, 'Got result for empty write pipeline');
        var batch = this.writePipeline.shift();
        var success = MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
        return this.syncEngine.applySuccessfulWrite(success).then(function () {
            // It's possible that with the completion of this mutation another
            // slot has freed up.
            return _this.fillWritePipeline();
        });
    };
    RemoteStore.prototype.onWriteStreamClose = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var errorHandling;
            return tslib_1.__generator(this, function (_a) {
                if (error$$1 === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWriteStream(), 'Write stream was stopped gracefully while still needed.');
                }
                // If the write stream closed due to an error, invoke the error callbacks if
                // there are pending writes.
                if (error$$1 && this.writePipeline.length > 0) {
                    errorHandling = void 0;
                    if (this.writeStream.handshakeComplete) {
                        // This error affects the actual write.
                        errorHandling = this.handleWriteError(error$$1);
                    }
                    else {
                        // If there was an error before the handshake has finished, it's
                        // possible that the server is unable to process the stream token
                        // we're sending. (Perhaps it's too old?)
                        errorHandling = this.handleHandshakeError(error$$1);
                    }
                    return [2 /*return*/, errorHandling.then(function () {
                            // The write stream might have been started by refilling the write
                            // pipeline for failed writes
                            if (_this.shouldStartWriteStream()) {
                                _this.startWriteStream();
                            }
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleHandshakeError = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // Reset the token if it's a permanent error, signaling the write stream is
                // no longer valid. Note that the handshake does not count as a write: see
                // comments on isPermanentWriteError for details.
                if (isPermanentError(error$$1.code)) {
                    debug(LOG_TAG$8, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
                    this.writeStream.lastStreamToken = emptyByteString();
                    return [2 /*return*/, this.localStore
                            .setLastStreamToken(emptyByteString())
                            .catch(ignoreIfPrimaryLeaseLoss)];
                }
                else {
                    // Some other error, don't reset stream token. Our stream logic will
                    // just retry with exponential backoff.
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleWriteError = function (error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var batch;
            return tslib_1.__generator(this, function (_a) {
                // Only handle permanent errors here. If it's transient, just let the retry
                // logic kick in.
                if (isPermanentWriteError(error$$1.code)) {
                    batch = this.writePipeline.shift();
                    // In this case it's also unlikely that the server itself is melting
                    // down -- this was just a bad request so inhibit backoff on the next
                    // restart.
                    this.writeStream.inhibitBackoff();
                    return [2 /*return*/, this.syncEngine
                            .rejectFailedWrite(batch.batchId, error$$1)
                            .then(function () {
                            // It's possible that with the completion of this mutation
                            // another slot has freed up.
                            return _this.fillWritePipeline();
                        })];
                }
                else {
                    // Transient error, just let the retry logic kick in.
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.createTransaction = function () {
        return new Transaction(this.datastore);
    };
    RemoteStore.prototype.handleCredentialChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
                        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
                        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
                        // (since mutations are per-user).
                        debug(LOG_TAG$8, 'RemoteStore restarting streams for new credential');
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [4 /*yield*/, this.enableNetwork()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Toggles the network state when the client gains or loses its primary lease.
     */
    RemoteStore.prototype.applyPrimaryState = function (isPrimary) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isPrimary = isPrimary;
                        if (!(isPrimary && this.networkEnabled)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.enableNetwork()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!!isPrimary) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 3:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return RemoteStore;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */
var QueryListenersInfo = /** @class */ (function () {
    function QueryListenersInfo() {
        this.listeners = [];
    }
    return QueryListenersInfo;
}());
/**
 * EventManager is responsible for mapping queries to query event emitters.
 * It handles "fan-out". -- Identical queries will re-use the same watch on the
 * backend.
 */
var EventManager = /** @class */ (function () {
    function EventManager(syncEngine) {
        this.syncEngine = syncEngine;
        this.queries = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.onlineState = OnlineState.Unknown;
        this.syncEngine.subscribe(this);
    }
    EventManager.prototype.listen = function (listener) {
        var query = listener.query;
        var firstListen = false;
        var queryInfo = this.queries.get(query);
        if (!queryInfo) {
            firstListen = true;
            queryInfo = new QueryListenersInfo();
            this.queries.set(query, queryInfo);
        }
        queryInfo.listeners.push(listener);
        listener.applyOnlineStateChange(this.onlineState);
        if (queryInfo.viewSnap)
            listener.onViewSnapshot(queryInfo.viewSnap);
        if (firstListen) {
            return this.syncEngine.listen(query).then(function (targetId) {
                queryInfo.targetId = targetId;
                return targetId;
            });
        }
        else {
            return Promise.resolve(queryInfo.targetId);
        }
    };
    EventManager.prototype.unlisten = function (listener) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, lastListen, queryInfo, i;
            return tslib_1.__generator(this, function (_a) {
                query = listener.query;
                lastListen = false;
                queryInfo = this.queries.get(query);
                if (queryInfo) {
                    i = queryInfo.listeners.indexOf(listener);
                    if (i >= 0) {
                        queryInfo.listeners.splice(i, 1);
                        lastListen = queryInfo.listeners.length === 0;
                    }
                }
                if (lastListen) {
                    this.queries.delete(query);
                    return [2 /*return*/, this.syncEngine.unlisten(query)];
                }
                return [2 /*return*/];
            });
        });
    };
    EventManager.prototype.onWatchChange = function (viewSnaps) {
        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
            var viewSnap = viewSnaps_1[_i];
            var query = viewSnap.query;
            var queryInfo = this.queries.get(query);
            if (queryInfo) {
                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
                    var listener = _b[_a];
                    listener.onViewSnapshot(viewSnap);
                }
                queryInfo.viewSnap = viewSnap;
            }
        }
    };
    EventManager.prototype.onWatchError = function (query, error) {
        var queryInfo = this.queries.get(query);
        if (queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onError(error);
            }
        }
        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
        // after an error.
        this.queries.delete(query);
    };
    EventManager.prototype.onOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        this.queries.forEach(function (_, queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.applyOnlineStateChange(onlineState);
            }
        });
    };
    return EventManager;
}());
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */
var QueryListener = /** @class */ (function () {
    function QueryListener(query, queryObserver, options) {
        this.query = query;
        this.queryObserver = queryObserver;
        /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */
        this.raisedInitialEvent = false;
        this.onlineState = OnlineState.Unknown;
        this.options = options || {};
    }
    QueryListener.prototype.onViewSnapshot = function (snap) {
        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            var docChanges = [];
            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
                var docChange = _a[_i];
                if (docChange.type !== ChangeType.Metadata) {
                    docChanges.push(docChange);
                }
            }
            snap = new ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.mutatedKeys, snap.fromCache, snap.syncStateChanged, 
            /* excludesMetadataChanges= */ true);
        }
        if (!this.raisedInitialEvent) {
            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
                this.raiseInitialEvent(snap);
            }
        }
        else if (this.shouldRaiseEvent(snap)) {
            this.queryObserver.next(snap);
        }
        this.snap = snap;
    };
    QueryListener.prototype.onError = function (error) {
        this.queryObserver.error(error);
    };
    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        if (this.snap &&
            !this.raisedInitialEvent &&
            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
            this.raiseInitialEvent(this.snap);
        }
    };
    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
        // Always raise the first event when we're synced
        if (!snap.fromCache) {
            return true;
        }
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var maybeOnline = onlineState !== OnlineState.Offline;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        if (this.options.waitForSyncWhenOnline && maybeOnline) {
            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
            return false;
        }
        // Raise data from cache if we have any documents or we are offline
        return !snap.docs.isEmpty() || onlineState === OnlineState.Offline;
    };
    QueryListener.prototype.shouldRaiseEvent = function (snap) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (snap.docChanges.length > 0) {
            return true;
        }
        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
        if (snap.syncStateChanged || hasPendingWritesChanged) {
            return this.options.includeMetadataChanges === true;
        }
        // Generally we should have hit one of the cases above, but it's possible
        // to get here if there were only metadata docChanges and they got
        // stripped out.
        return false;
    };
    QueryListener.prototype.raiseInitialEvent = function (snap) {
        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
        snap = ViewSnapshot.fromInitialDocuments(snap.query, snap.docs, snap.mutatedKeys, snap.fromCache);
        this.raisedInitialEvent = true;
        this.queryObserver.next(snap);
    };
    return QueryListener;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */
var LocalViewChanges = /** @class */ (function () {
    function LocalViewChanges(targetId, addedKeys, removedKeys) {
        this.targetId = targetId;
        this.addedKeys = addedKeys;
        this.removedKeys = removedKeys;
    }
    LocalViewChanges.fromSnapshot = function (targetId, viewSnapshot) {
        var addedKeys = documentKeySet();
        var removedKeys = documentKeySet();
        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
            var docChange = _a[_i];
            switch (docChange.type) {
                case ChangeType.Added:
                    addedKeys = addedKeys.add(docChange.doc.key);
                    break;
                case ChangeType.Removed:
                    removedKeys = removedKeys.add(docChange.doc.key);
                    break;
                default:
                // do nothing
            }
        }
        return new LocalViewChanges(targetId, addedKeys, removedKeys);
    };
    return LocalViewChanges;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AddedLimboDocument = /** @class */ (function () {
    function AddedLimboDocument(key) {
        this.key = key;
    }
    return AddedLimboDocument;
}());
var RemovedLimboDocument = /** @class */ (function () {
    function RemovedLimboDocument(key) {
        this.key = key;
    }
    return RemovedLimboDocument;
}());
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */
var View = /** @class */ (function () {
    function View(query, 
    /** Documents included in the remote target */
    _syncedDocuments) {
        this.query = query;
        this._syncedDocuments = _syncedDocuments;
        this.syncState = null;
        /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */
        this.current = false;
        /** Documents in the view but not in the remote target */
        this.limboDocuments = documentKeySet();
        /** Document Keys that have local changes */
        this.mutatedKeys = documentKeySet();
        this.documentSet = new DocumentSet(query.docComparator.bind(query));
    }
    Object.defineProperty(View.prototype, "syncedDocuments", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */
        get: function () {
            return this._syncedDocuments;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */
    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
        var _this = this;
        var changeSet = previousChanges
            ? previousChanges.changeSet
            : new DocumentChangeSet();
        var oldDocumentSet = previousChanges
            ? previousChanges.documentSet
            : this.documentSet;
        var newMutatedKeys = previousChanges
            ? previousChanges.mutatedKeys
            : this.mutatedKeys;
        var newDocumentSet = oldDocumentSet;
        var needsRefill = false;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        //
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit
            ? oldDocumentSet.last()
            : null;
        docChanges.inorderTraversal(function (key, newMaybeDoc) {
            var oldDoc = oldDocumentSet.get(key);
            var newDoc = newMaybeDoc instanceof Document ? newMaybeDoc : null;
            if (newDoc) {
                assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
                    key +
                    ' != ' +
                    newDoc.key);
                newDoc = _this.query.matches(newDoc) ? newDoc : null;
            }
            var oldDocHadPendingMutations = oldDoc
                ? _this.mutatedKeys.has(oldDoc.key)
                : false;
            var newDocHasPendingMutations = newDoc
                ? newDoc.hasLocalMutations ||
                    // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    (_this.mutatedKeys.has(newDoc.key) && newDoc.hasCommittedMutations)
                : false;
            var changeApplied = false;
            // Calculate change
            if (oldDoc && newDoc) {
                var docsEqual = oldDoc.data.isEqual(newDoc.data);
                if (!docsEqual) {
                    if (!_this.shouldWaitForSyncedDocument(oldDoc, newDoc)) {
                        changeSet.track({
                            type: ChangeType.Modified,
                            doc: newDoc
                        });
                        changeApplied = true;
                        if (lastDocInLimit &&
                            _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
                            // This doc moved from inside the limit to after the limit.
                            // That means there may be some doc in the local cache that's
                            // actually less than this one.
                            needsRefill = true;
                        }
                    }
                }
                else if (oldDocHadPendingMutations !== newDocHasPendingMutations) {
                    changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
                    changeApplied = true;
                }
            }
            else if (!oldDoc && newDoc) {
                changeSet.track({ type: ChangeType.Added, doc: newDoc });
                changeApplied = true;
            }
            else if (oldDoc && !newDoc) {
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
                changeApplied = true;
                if (lastDocInLimit) {
                    // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    needsRefill = true;
                }
            }
            if (changeApplied) {
                if (newDoc) {
                    newDocumentSet = newDocumentSet.add(newDoc);
                    if (newDocHasPendingMutations) {
                        newMutatedKeys = newMutatedKeys.add(key);
                    }
                    else {
                        newMutatedKeys = newMutatedKeys.delete(key);
                    }
                }
                else {
                    newDocumentSet = newDocumentSet.delete(key);
                    newMutatedKeys = newMutatedKeys.delete(key);
                }
            }
        });
        if (this.query.hasLimit()) {
            while (newDocumentSet.size > this.query.limit) {
                var oldDoc = newDocumentSet.last();
                newDocumentSet = newDocumentSet.delete(oldDoc.key);
                newMutatedKeys = newMutatedKeys.delete(oldDoc.key);
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
            }
        }
        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
        return {
            documentSet: newDocumentSet,
            changeSet: changeSet,
            needsRefill: needsRefill,
            mutatedKeys: newMutatedKeys
        };
    };
    View.prototype.shouldWaitForSyncedDocument = function (oldDoc, newDoc) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return (oldDoc.hasLocalMutations &&
            newDoc.hasCommittedMutations &&
            !newDoc.hasLocalMutations);
    };
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */
    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    View.prototype.applyChanges = function (docChanges, updateLimboDocuments, targetChange) {
        var _this = this;
        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
        var oldDocs = this.documentSet;
        this.documentSet = docChanges.documentSet;
        this.mutatedKeys = docChanges.mutatedKeys;
        // Sort changes based on type and query comparator
        var changes = docChanges.changeSet.getChanges();
        changes.sort(function (c1, c2) {
            return (compareChangeType(c1.type, c2.type) ||
                _this.query.docComparator(c1.doc, c2.doc));
        });
        this.applyTargetChange(targetChange);
        var limboChanges = updateLimboDocuments
            ? this.updateLimboDocuments()
            : [];
        var synced = this.limboDocuments.size === 0 && this.current;
        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
        var syncStateChanged = newSyncState !== this.syncState;
        this.syncState = newSyncState;
        if (changes.length === 0 && !syncStateChanged) {
            // no changes
            return { limboChanges: limboChanges };
        }
        else {
            var snap = new ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, docChanges.mutatedKeys, newSyncState === SyncState.Local, syncStateChanged, 
            /* excludesMetadataChanges= */ false);
            return {
                snapshot: snap,
                limboChanges: limboChanges
            };
        }
    };
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */
    View.prototype.applyOnlineStateChange = function (onlineState) {
        if (this.current && onlineState === OnlineState.Offline) {
            // If we're offline, set `current` to false and then call applyChanges()
            // to refresh our syncState and generate a ViewChange as appropriate. We
            // are guaranteed to get a new TargetChange that sets `current` back to
            // true once the client is back online.
            this.current = false;
            return this.applyChanges({
                documentSet: this.documentSet,
                changeSet: new DocumentChangeSet(),
                mutatedKeys: this.mutatedKeys,
                needsRefill: false
            }, 
            /* updateLimboDocuments= */ false);
        }
        else {
            // No effect, just return a no-op ViewChange.
            return { limboChanges: [] };
        }
    };
    /**
     * Returns whether the doc for the given key should be in limbo.
     */
    View.prototype.shouldBeInLimbo = function (key) {
        // If the remote end says it's part of this query, it's not in limbo.
        if (this._syncedDocuments.has(key)) {
            return false;
        }
        // The local store doesn't think it's a result, so it shouldn't be in limbo.
        if (!this.documentSet.has(key)) {
            return false;
        }
        // If there are local changes to the doc, they might explain why the server
        // doesn't know that it's part of the query. So don't put it in limbo.
        // TODO(klimt): Ideally, we would only consider changes that might actually
        // affect this specific query.
        if (this.documentSet.get(key).hasLocalMutations) {
            return false;
        }
        // Everything else is in limbo.
        return true;
    };
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */
    View.prototype.applyTargetChange = function (targetChange) {
        var _this = this;
        if (targetChange) {
            targetChange.addedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.add(key)); });
            targetChange.modifiedDocuments.forEach(function (key) {
                return assert(_this._syncedDocuments.has(key), "Modified document " + key + " not found in view.");
            });
            targetChange.removedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.delete(key)); });
            this.current = targetChange.current;
        }
    };
    View.prototype.updateLimboDocuments = function () {
        var _this = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) {
            return [];
        }
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var oldLimboDocuments = this.limboDocuments;
        this.limboDocuments = documentKeySet();
        this.documentSet.forEach(function (doc) {
            if (_this.shouldBeInLimbo(doc.key)) {
                _this.limboDocuments = _this.limboDocuments.add(doc.key);
            }
        });
        // Diff the new limbo docs with the old limbo docs.
        var changes = [];
        oldLimboDocuments.forEach(function (key) {
            if (!_this.limboDocuments.has(key)) {
                changes.push(new RemovedLimboDocument(key));
            }
        });
        this.limboDocuments.forEach(function (key) {
            if (!oldLimboDocuments.has(key)) {
                changes.push(new AddedLimboDocument(key));
            }
        });
        return changes;
    };
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param localDocs - The documents that match the query according to the
     * LocalStore.
     * @param remoteKeys - The keys of the documents that match the query
     * according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.synchronizeWithPersistedState = function (localDocs, remoteKeys) {
        this._syncedDocuments = remoteKeys;
        this.limboDocuments = documentKeySet();
        var docChanges = this.computeDocChanges(localDocs);
        return this.applyChanges(docChanges, /*updateLimboDocuments=*/ true);
    };
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.computeInitialSnapshot = function () {
        return ViewSnapshot.fromInitialDocuments(this.query, this.documentSet, this.mutatedKeys, this.syncState === SyncState.Local);
    };
    return View;
}());
function compareChangeType(c1, c2) {
    var order = function (change) {
        switch (change) {
            case ChangeType.Added:
                return 1;
            case ChangeType.Modified:
                return 2;
            case ChangeType.Metadata:
                // A metadata change is converted to a modified change at the public
                // api layer.  Since we sort by document key and then change type,
                // metadata and modified changes must be sorted equivalently.
                return 2;
            case ChangeType.Removed:
                return 0;
            default:
                return fail('Unknown ChangeType: ' + change);
        }
    };
    return order(c1) - order(c2);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$9 = 'SyncEngine';
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */
var QueryView = /** @class */ (function () {
    function QueryView(
    /**
     * The query itself.
     */
    query, 
    /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */
    targetId, 
    /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */
    view) {
        this.query = query;
        this.targetId = targetId;
        this.view = view;
    }
    return QueryView;
}());
/** Tracks a limbo resolution. */
var LimboResolution = /** @class */ (function () {
    function LimboResolution(key) {
        this.key = key;
    }
    return LimboResolution;
}());
/**
 * SyncEngine is the central controller in the client SDK architecture. It is
 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
 * SyncEngine's responsibilities include:
 * 1. Coordinating client requests and remote events between the EventManager
 *    and the local and remote data stores.
 * 2. Managing a View object for each query, providing the unified view between
 *    the local and remote data stores.
 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
 *    queue that need sending to the backend.
 *
 * The SyncEngine’s methods should only ever be called by methods running in the
 * global async queue.
 */
var SyncEngine = /** @class */ (function () {
    function SyncEngine(localStore, remoteStore, 
    // PORTING NOTE: Manages state synchronization in multi-tab environments.
    sharedClientState, currentUser) {
        this.localStore = localStore;
        this.remoteStore = remoteStore;
        this.sharedClientState = sharedClientState;
        this.currentUser = currentUser;
        this.syncEngineListener = null;
        this.queryViewsByQuery = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.queryViewsByTarget = {};
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
        this.limboResolutionsByTarget = {};
        this.limboDocumentRefs = new ReferenceSet();
        /** Stores user completion handlers, indexed by User and BatchId. */
        this.mutationUserCallbacks = {};
        this.limboTargetIdGenerator = TargetIdGenerator.forSyncEngine();
        // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.isPrimary = undefined;
        this.onlineState = OnlineState.Unknown;
    }
    Object.defineProperty(SyncEngine.prototype, "isPrimaryClient", {
        // Only used for testing.
        get: function () {
            return this.isPrimary === true;
        },
        enumerable: true,
        configurable: true
    });
    /** Subscribes to SyncEngine notifications. Has to be called exactly once. */
    SyncEngine.prototype.subscribe = function (syncEngineListener) {
        assert(syncEngineListener !== null, 'SyncEngine listener cannot be null');
        assert(this.syncEngineListener === null, 'SyncEngine already has a subscriber.');
        this.syncEngineListener = syncEngineListener;
    };
    /**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the targetId of the query.
     */
    SyncEngine.prototype.listen = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var targetId, viewSnapshot, queryView, queryData, status_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('listen()');
                        queryView = this.queryViewsByQuery.get(query);
                        if (!queryView) return [3 /*break*/, 1];
                        // PORTING NOTE: With Mult-Tab Web, it is possible that a query view
                        // already exists when EventManager calls us for the first time. This
                        // happens when the primary tab is already listening to this query on
                        // behalf of another tab and the user of the primary also starts listening
                        // to the query. EventManager will not have an assigned target ID in this
                        // case and calls `listen` to obtain this ID.
                        targetId = queryView.targetId;
                        this.sharedClientState.addLocalQueryTarget(targetId);
                        viewSnapshot = queryView.view.computeInitialSnapshot();
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, this.localStore.allocateQuery(query)];
                    case 2:
                        queryData = _a.sent();
                        status_1 = this.sharedClientState.addLocalQueryTarget(queryData.targetId);
                        targetId = queryData.targetId;
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, status_1 === 'current')];
                    case 3:
                        viewSnapshot = _a.sent();
                        if (this.isPrimary) {
                            this.remoteStore.listen(queryData);
                        }
                        _a.label = 4;
                    case 4:
                        this.syncEngineListener.onWatchChange([viewSnapshot]);
                        return [2 /*return*/, targetId];
                }
            });
        });
    };
    /**
     * Registers a view for a previously unknown query and computes its initial
     * snapshot.
     */
    SyncEngine.prototype.initializeViewAndComputeSnapshot = function (queryData, current) {
        var _this = this;
        var query = queryData.query;
        return this.localStore.executeQuery(query).then(function (docs) {
            return _this.localStore
                .remoteDocumentKeys(queryData.targetId)
                .then(function (remoteKeys) {
                var view = new View(query, remoteKeys);
                var viewDocChanges = view.computeDocChanges(docs);
                // tslint:disable-next-line:max-line-length Prettier formats this exceed 100 characters.
                var synthesizedTargetChange = TargetChange.createSynthesizedTargetChangeForCurrentChange(queryData.targetId, current && _this.onlineState !== OnlineState.Offline);
                var viewChange = view.applyChanges(viewDocChanges, 
                /* updateLimboDocuments= */ _this.isPrimary === true, synthesizedTargetChange);
                assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
                assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
                var data = new QueryView(query, queryData.targetId, view);
                _this.queryViewsByQuery.set(query, data);
                _this.queryViewsByTarget[queryData.targetId] = data;
                return viewChange.snapshot;
            });
        });
    };
    /**
     * Reconcile the list of synced documents in an existing view with those
     * from persistence.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeViewAndComputeSnapshot = function (queryView) {
        var _this = this;
        return this.localStore.executeQuery(queryView.query).then(function (docs) {
            return _this.localStore
                .remoteDocumentKeys(queryView.targetId)
                .then(function (remoteKeys) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var viewSnapshot;
                return tslib_1.__generator(this, function (_a) {
                    viewSnapshot = queryView.view.synchronizeWithPersistedState(docs, remoteKeys);
                    if (this.isPrimary) {
                        this.updateTrackedLimbos(queryView.targetId, viewSnapshot.limboChanges);
                    }
                    return [2 /*return*/, viewSnapshot];
                });
            }); });
        });
    };
    /** Stops listening to the query. */
    SyncEngine.prototype.unlisten = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var queryView, targetRemainsActive;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('unlisten()');
                        queryView = this.queryViewsByQuery.get(query);
                        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
                        if (!this.isPrimary) return [3 /*break*/, 3];
                        // We need to remove the local query target first to allow us to verify
                        // whether any other client is still interested in this target.
                        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
                        targetRemainsActive = this.sharedClientState.isActiveQueryTarget(queryView.targetId);
                        if (!!targetRemainsActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStore
                                .releaseQuery(query, /*keepPersistedQueryData=*/ false)
                                .then(function () {
                                _this.sharedClientState.clearQueryState(queryView.targetId);
                                _this.remoteStore.unlisten(queryView.targetId);
                                _this.removeAndCleanupQuery(queryView);
                            })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        this.removeAndCleanupQuery(queryView);
                        return [4 /*yield*/, this.localStore.releaseQuery(query, 
                            /*keepPersistedQueryData=*/ true)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */
    SyncEngine.prototype.write = function (batch, userCallback) {
        var _this = this;
        this.assertSubscribed('write()');
        return this.localStore
            .localWrite(batch)
            .then(function (result) {
            _this.sharedClientState.addPendingMutation(result.batchId);
            _this.addMutationCallback(result.batchId, userCallback);
            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
        })
            .then(function () {
            return _this.remoteStore.fillWritePipeline();
        });
    };
    // TODO(klimt): Wrap the given error in a standard Firestore error object.
    SyncEngine.prototype.wrapUpdateFunctionError = function (error$$1) {
        return error$$1;
    };
    /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If some other client has changed any of the data
     * referenced, then the updateFunction will be called again. If the
     * updateFunction still fails after the given number of retries, then the
     * transaction will be rejection.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The promise returned is resolved when the transaction is fully committed.
     */
    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
        var _this = this;
        if (retries === void 0) { retries = 5; }
        assert(retries >= 0, 'Got negative number of retries for transaction.');
        var transaction = this.remoteStore.createTransaction();
        var wrappedUpdateFunction = function () {
            try {
                var userPromise = updateFunction(transaction);
                if (isNullOrUndefined(userPromise) ||
                    !userPromise.catch ||
                    !userPromise.then) {
                    return Promise.reject(Error('Transaction callback must return a Promise'));
                }
                return userPromise.catch(function (e) {
                    return Promise.reject(_this.wrapUpdateFunctionError(e));
                });
            }
            catch (e) {
                return Promise.reject(_this.wrapUpdateFunctionError(e));
            }
        };
        return wrappedUpdateFunction().then(function (result) {
            return transaction
                .commit()
                .then(function () {
                return result;
            })
                .catch(function (error$$1) {
                if (retries === 0) {
                    return Promise.reject(error$$1);
                }
                // TODO(klimt): Put in a retry delay?
                return _this.runTransaction(updateFunction, retries - 1);
            });
        });
    };
    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        this.assertSubscribed('applyRemoteEvent()');
        return this.localStore
            .applyRemoteEvent(remoteEvent)
            .then(function (changes) {
            // Update `receivedDocument` as appropriate for any limbo targets.
            forEach(remoteEvent.targetChanges, function (targetId, targetChange) {
                var limboResolution = _this.limboResolutionsByTarget[targetId];
                if (limboResolution) {
                    // Since this is a limbo resolution lookup, it's for a single document
                    // and it could be added, modified, or removed, but not a combination.
                    assert(targetChange.addedDocuments.size +
                        targetChange.modifiedDocuments.size +
                        targetChange.removedDocuments.size <=
                        1, 'Limbo resolution for single document contains multiple changes.');
                    if (targetChange.addedDocuments.size > 0) {
                        limboResolution.receivedDocument = true;
                    }
                    else if (targetChange.modifiedDocuments.size > 0) {
                        assert(limboResolution.receivedDocument, 'Received change for limbo target document without add.');
                    }
                    else if (targetChange.removedDocuments.size > 0) {
                        assert(limboResolution.receivedDocument, 'Received remove for limbo target document without add.');
                        limboResolution.receivedDocument = false;
                    }
                    else {
                        // This was probably just a CURRENT targetChange or similar.
                    }
                }
            });
            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    /**
     * Applies an OnlineState change to the sync engine and notifies any views of
     * the change.
     */
    SyncEngine.prototype.applyOnlineStateChange = function (onlineState, source) {
        // If we are the secondary client, we explicitly ignore the remote store's
        // online state (the local client may go offline, even though the primary
        // tab remains online) and only apply the primary tab's online state from
        // SharedClientState.
        if ((this.isPrimary && source === OnlineStateSource.RemoteStore) ||
            (!this.isPrimary && source === OnlineStateSource.SharedClientState)) {
            var newViewSnapshots_1 = [];
            this.queryViewsByQuery.forEach(function (query, queryView) {
                var viewChange = queryView.view.applyOnlineStateChange(onlineState);
                assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
                if (viewChange.snapshot) {
                    newViewSnapshots_1.push(viewChange.snapshot);
                }
            });
            this.syncEngineListener.onOnlineStateChange(onlineState);
            this.syncEngineListener.onWatchChange(newViewSnapshots_1);
            this.onlineState = onlineState;
            if (this.isPrimary) {
                this.sharedClientState.setOnlineState(onlineState);
            }
        }
    };
    SyncEngine.prototype.rejectListen = function (targetId, err) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var limboResolution, limboKey, documentUpdates, resolvedLimboDocuments, event_1, queryView_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('rejectListens()');
                        // PORTING NOTE: Multi-tab only.
                        this.sharedClientState.updateQueryState(targetId, 'rejected', err);
                        limboResolution = this.limboResolutionsByTarget[targetId];
                        limboKey = limboResolution && limboResolution.key;
                        if (!limboKey) return [3 /*break*/, 1];
                        // Since this query failed, we won't want to manually unlisten to it.
                        // So go ahead and remove it from bookkeeping.
                        this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
                        delete this.limboResolutionsByTarget[targetId];
                        documentUpdates = new SortedMap(DocumentKey.comparator);
                        documentUpdates = documentUpdates.insert(limboKey, new NoDocument(limboKey, SnapshotVersion.forDeletedDoc()));
                        resolvedLimboDocuments = documentKeySet().add(limboKey);
                        event_1 = new RemoteEvent(SnapshotVersion.MIN, 
                        /* targetChanges= */ {}, 
                        /* targetMismatches= */ new SortedSet(primitiveComparator), documentUpdates, resolvedLimboDocuments);
                        return [2 /*return*/, this.applyRemoteEvent(event_1)];
                    case 1:
                        queryView_1 = this.queryViewsByTarget[targetId];
                        assert(!!queryView_1, 'Unknown targetId: ' + targetId);
                        return [4 /*yield*/, this.localStore
                                .releaseQuery(queryView_1.query, /* keepPersistedQueryData */ false)
                                .then(function () { return _this.removeAndCleanupQuery(queryView_1); })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 2:
                        _a.sent();
                        this.syncEngineListener.onWatchError(queryView_1.query, err);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyBatchState = function (batchId, batchState, error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('applyBatchState()');
                        return [4 /*yield*/, this.localStore.lookupMutationDocuments(batchId)];
                    case 1:
                        documents = _a.sent();
                        if (documents === null) {
                            // A throttled tab may not have seen the mutation before it was completed
                            // and removed from the mutation queue, in which case we won't have cached
                            // the affected documents. In this case we can safely ignore the update
                            // since that means we didn't apply the mutation locally at all (if we
                            // had, we would have cached the affected documents), and so we will just
                            // see any resulting document changes via normal remote document updates
                            // as applicable.
                            debug(LOG_TAG$9, 'Cannot apply mutation batch with id: ' + batchId);
                            return [2 /*return*/];
                        }
                        if (!(batchState === 'pending')) return [3 /*break*/, 3];
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
                    case 2:
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (batchState === 'acknowledged' || batchState === 'rejected') {
                            // NOTE: Both these methods are no-ops for batches that originated from
                            // other clients.
                            this.processUserCallback(batchId, error$$1 ? error$$1 : null);
                            this.localStore.removeCachedMutationBatchMetadata(batchId);
                        }
                        else {
                            fail("Unknown batchState: " + batchState);
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(documents)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
        var _this = this;
        this.assertSubscribed('applySuccessfulWrite()');
        var batchId = mutationBatchResult.batch.batchId;
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        this.processUserCallback(batchId, /*error=*/ null);
        return this.localStore
            .acknowledgeBatch(mutationBatchResult)
            .then(function (changes) {
            _this.sharedClientState.updateMutationState(batchId, 'acknowledged');
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    SyncEngine.prototype.rejectFailedWrite = function (batchId, error$$1) {
        var _this = this;
        this.assertSubscribed('rejectFailedWrite()');
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        this.processUserCallback(batchId, error$$1);
        return this.localStore
            .rejectBatch(batchId)
            .then(function (changes) {
            _this.sharedClientState.updateMutationState(batchId, 'rejected', error$$1);
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        if (!newCallbacks) {
            newCallbacks = new SortedMap(primitiveComparator);
        }
        newCallbacks = newCallbacks.insert(batchId, callback);
        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
    };
    /**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */
    SyncEngine.prototype.processUserCallback = function (batchId, error$$1) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        // NOTE: Mutations restored from persistence won't have callbacks, so it's
        // okay for there to be no callback for this ID.
        if (newCallbacks) {
            var callback = newCallbacks.get(batchId);
            if (callback) {
                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
                if (error$$1) {
                    callback.reject(error$$1);
                }
                else {
                    callback.resolve();
                }
                newCallbacks = newCallbacks.remove(batchId);
            }
            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
        }
    };
    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
        var _this = this;
        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
        this.queryViewsByQuery.delete(queryView.query);
        delete this.queryViewsByTarget[queryView.targetId];
        if (this.isPrimary) {
            var limboKeys = this.limboDocumentRefs.referencesForId(queryView.targetId);
            this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
            limboKeys.forEach(function (limboKey) {
                var isReferenced = _this.limboDocumentRefs.containsKey(limboKey);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    _this.removeLimboTarget(limboKey);
                }
            });
        }
    };
    SyncEngine.prototype.removeLimboTarget = function (key) {
        // It's possible that the target already got removed because the query failed. In that case,
        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
        var limboTargetId = this.limboTargetsByKey.get(key);
        if (limboTargetId === null) {
            // This target already got removed, because the query failed.
            return;
        }
        this.remoteStore.unlisten(limboTargetId);
        this.limboTargetsByKey = this.limboTargetsByKey.remove(key);
        delete this.limboResolutionsByTarget[limboTargetId];
    };
    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
            var limboChange = limboChanges_1[_i];
            if (limboChange instanceof AddedLimboDocument) {
                this.limboDocumentRefs.addReference(limboChange.key, targetId);
                this.trackLimboChange(limboChange);
            }
            else if (limboChange instanceof RemovedLimboDocument) {
                debug(LOG_TAG$9, 'Document no longer in limbo: ' + limboChange.key);
                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
                var isReferenced = this.limboDocumentRefs.containsKey(limboChange.key);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    this.removeLimboTarget(limboChange.key);
                }
            }
            else {
                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
            }
        }
    };
    SyncEngine.prototype.trackLimboChange = function (limboChange) {
        var key = limboChange.key;
        if (!this.limboTargetsByKey.get(key)) {
            debug(LOG_TAG$9, 'New document in limbo: ' + key);
            var limboTargetId = this.limboTargetIdGenerator.next();
            var query = Query.atPath(key.path);
            this.limboResolutionsByTarget[limboTargetId] = new LimboResolution(key);
            this.remoteStore.listen(new QueryData(query, limboTargetId, QueryPurpose.LimboResolution, ListenSequence.INVALID));
            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
        }
    };
    // Visible for testing
    SyncEngine.prototype.currentLimboDocs = function () {
        return this.limboTargetsByKey;
    };
    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var newSnaps, docChangesInAllViews, queriesProcessed;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSnaps = [];
                        docChangesInAllViews = [];
                        queriesProcessed = [];
                        this.queryViewsByQuery.forEach(function (_, queryView) {
                            queriesProcessed.push(Promise.resolve()
                                .then(function () {
                                var viewDocChanges = queryView.view.computeDocChanges(changes);
                                if (!viewDocChanges.needsRefill) {
                                    return viewDocChanges;
                                }
                                // The query has a limit and some docs were removed, so we need
                                // to re-run the query against the local store to make sure we
                                // didn't lose any good docs that had been past the limit.
                                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
                                    return queryView.view.computeDocChanges(docs, viewDocChanges);
                                });
                            })
                                .then(function (viewDocChanges) {
                                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
                                var viewChange = queryView.view.applyChanges(viewDocChanges, 
                                /* updateLimboDocuments= */ _this.isPrimary === true, targetChange);
                                _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges);
                                if (viewChange.snapshot) {
                                    if (_this.isPrimary) {
                                        _this.sharedClientState.updateQueryState(queryView.targetId, viewChange.snapshot.fromCache ? 'not-current' : 'current');
                                    }
                                    newSnaps.push(viewChange.snapshot);
                                    var docChanges = LocalViewChanges.fromSnapshot(queryView.targetId, viewChange.snapshot);
                                    docChangesInAllViews.push(docChanges);
                                }
                            }));
                        });
                        return [4 /*yield*/, Promise.all(queriesProcessed)];
                    case 1:
                        _a.sent();
                        this.syncEngineListener.onWatchChange(newSnaps);
                        return [4 /*yield*/, this.localStore.notifyLocalViewChanges(docChangesInAllViews)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.assertSubscribed = function (fnName) {
        assert(this.syncEngineListener !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
    };
    SyncEngine.prototype.handleCredentialChange = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userChanged, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userChanged = !this.currentUser.isEqual(user);
                        this.currentUser = user;
                        if (!userChanged) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.handleUserChange(user)];
                    case 1:
                        result = _a.sent();
                        // TODO(b/114226417): Consider calling this only in the primary tab.
                        this.sharedClientState.handleUserChange(user, result.removedBatchIds, result.addedBatchIds);
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.affectedDocuments)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.remoteStore.handleCredentialChange()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyPrimaryState = function (isPrimary) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var activeTargets, activeQueries, _i, activeQueries_1, queryData, activeTargets_1, p_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isPrimary === true && this.isPrimary !== true)) return [3 /*break*/, 3];
                        this.isPrimary = true;
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(true)];
                    case 1:
                        _a.sent();
                        activeTargets = this.sharedClientState.getAllActiveQueryTargets();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets.toArray())];
                    case 2:
                        activeQueries = _a.sent();
                        for (_i = 0, activeQueries_1 = activeQueries; _i < activeQueries_1.length; _i++) {
                            queryData = activeQueries_1[_i];
                            this.remoteStore.listen(queryData);
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(isPrimary === false && this.isPrimary !== false)) return [3 /*break*/, 7];
                        this.isPrimary = false;
                        activeTargets_1 = [];
                        p_1 = Promise.resolve();
                        forEachNumber(this.queryViewsByTarget, function (targetId, queryView) {
                            if (_this.sharedClientState.isLocalQueryTarget(targetId)) {
                                activeTargets_1.push(targetId);
                            }
                            else {
                                p_1 = p_1.then(function () { return _this.unlisten(queryView.query); });
                            }
                            _this.remoteStore.unlisten(queryView.targetId);
                        });
                        return [4 /*yield*/, p_1];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_1)];
                    case 5:
                        _a.sent();
                        this.resetLimboDocuments();
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(false)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.resetLimboDocuments = function () {
        var _this = this;
        forEachNumber(this.limboResolutionsByTarget, function (targetId) {
            _this.remoteStore.unlisten(targetId);
        });
        this.limboDocumentRefs.removeAllReferences();
        this.limboResolutionsByTarget = [];
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
    };
    /**
     * Reconcile the query views of the provided query targets with the state from
     * persistence. Raises snapshots for any changes that affect the local
     * client and returns the updated state of all target's query data.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeQueryViewsAndRaiseSnapshots = function (targets) {
        var _this = this;
        var p = Promise.resolve();
        var activeQueries = [];
        var newViewSnapshots = [];
        var _loop_1 = function (targetId) {
            p = p.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var queryData, queryView, viewChange, query;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            queryView = this.queryViewsByTarget[targetId];
                            if (!queryView) return [3 /*break*/, 4];
                            // For queries that have a local View, we need to update their state
                            // in LocalStore (as the resume token and the snapshot version
                            // might have changed) and reconcile their views with the persisted
                            // state (the list of syncedDocuments may have gotten out of sync).
                            return [4 /*yield*/, this.localStore.releaseQuery(queryView.query, 
                                /*keepPersistedQueryData=*/ true)];
                        case 1:
                            // For queries that have a local View, we need to update their state
                            // in LocalStore (as the resume token and the snapshot version
                            // might have changed) and reconcile their views with the persisted
                            // state (the list of syncedDocuments may have gotten out of sync).
                            _a.sent();
                            return [4 /*yield*/, this.localStore.allocateQuery(queryView.query)];
                        case 2:
                            queryData = _a.sent();
                            return [4 /*yield*/, this.synchronizeViewAndComputeSnapshot(queryView)];
                        case 3:
                            viewChange = _a.sent();
                            if (viewChange.snapshot) {
                                newViewSnapshots.push(viewChange.snapshot);
                            }
                            return [3 /*break*/, 8];
                        case 4:
                            assert(this.isPrimary === true, 'A secondary tab should never have an active query without an active view.');
                            return [4 /*yield*/, this.localStore.getQueryForTarget(targetId)];
                        case 5:
                            query = _a.sent();
                            assert(!!query, "Query data for target " + targetId + " not found");
                            return [4 /*yield*/, this.localStore.allocateQuery(query)];
                        case 6:
                            queryData = _a.sent();
                            return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, 
                                /*current=*/ false)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8:
                            activeQueries.push(queryData);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
            var targetId = targets_1[_i];
            _loop_1(targetId);
        }
        return p.then(function () {
            _this.syncEngineListener.onWatchChange(newViewSnapshots);
            return activeQueries;
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.getActiveClients = function () {
        return this.localStore.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyTargetState = function (targetId, state, error$$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, queryView;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isPrimary) {
                            // If we receive a target state notification via WebStorage, we are
                            // either already secondary or another tab has taken the primary lease.
                            debug(LOG_TAG$9, 'Ignoring unexpected query state notification.');
                            return [2 /*return*/];
                        }
                        if (!this.queryViewsByTarget[targetId]) return [3 /*break*/, 5];
                        _a = state;
                        switch (_a) {
                            case 'current': return [3 /*break*/, 1];
                            case 'not-current': return [3 /*break*/, 1];
                            case 'rejected': return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        {
                            return [2 /*return*/, this.localStore.getNewDocumentChanges().then(function (changes) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var synthesizedRemoteEvent;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                synthesizedRemoteEvent = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(targetId, state === 'current');
                                                return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, synthesizedRemoteEvent)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, function (err) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var activeTargets_2;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!isDocumentChangeMissingError(err)) return [3 /*break*/, 2];
                                                activeTargets_2 = [];
                                                forEachNumber(this.queryViewsByTarget, function (target) {
                                                    return activeTargets_2.push(target);
                                                });
                                                return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_2)];
                                            case 1:
                                                _a.sent();
                                                return [3 /*break*/, 3];
                                            case 2: throw err;
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); })];
                        }
                        _b.label = 2;
                    case 2:
                        queryView = this.queryViewsByTarget[targetId];
                        this.removeAndCleanupQuery(queryView);
                        return [4 /*yield*/, this.localStore.releaseQuery(queryView.query, 
                            /*keepPersistedQueryData=*/ true)];
                    case 3:
                        _b.sent();
                        this.syncEngineListener.onWatchError(queryView.query, error$$1);
                        return [3 /*break*/, 5];
                    case 4:
                        fail('Unexpected target state: ' + state);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyActiveTargetsChange = function (added, removed) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _i, added_1, targetId, query, queryData, _loop_2, this_1, _a, removed_1, targetId;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isPrimary) {
                            return [2 /*return*/];
                        }
                        _i = 0, added_1 = added;
                        _b.label = 1;
                    case 1:
                        if (!(_i < added_1.length)) return [3 /*break*/, 6];
                        targetId = added_1[_i];
                        assert(!this.queryViewsByTarget[targetId], 'Trying to add an already active target');
                        return [4 /*yield*/, this.localStore.getQueryForTarget(targetId)];
                    case 2:
                        query = _b.sent();
                        assert(!!query, "Query data for active target " + targetId + " not found");
                        return [4 /*yield*/, this.localStore.allocateQuery(query)];
                    case 3:
                        queryData = _b.sent();
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, 
                            /*current=*/ false)];
                    case 4:
                        _b.sent();
                        this.remoteStore.listen(queryData);
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        _loop_2 = function (targetId) {
                            var queryView;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        queryView = this_1.queryViewsByTarget[targetId];
                                        if (!queryView) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.localStore
                                                .releaseQuery(queryView.query, /*keepPersistedQueryData=*/ false)
                                                .then(function () {
                                                _this.remoteStore.unlisten(targetId);
                                                _this.removeAndCleanupQuery(queryView);
                                            })
                                                .catch(ignoreIfPrimaryLeaseLoss)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = 0, removed_1 = removed;
                        _b.label = 7;
                    case 7:
                        if (!(_a < removed_1.length)) return [3 /*break*/, 10];
                        targetId = removed_1[_a];
                        return [5 /*yield**/, _loop_2(targetId)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        _a++;
                        return [3 /*break*/, 7];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.enableNetwork = function () {
        this.localStore.setNetworkEnabled(true);
        return this.remoteStore.enableNetwork();
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.disableNetwork = function () {
        this.localStore.setNetworkEnabled(false);
        return this.remoteStore.disableNetwork();
    };
    SyncEngine.prototype.getRemoteKeysForTarget = function (targetId) {
        var limboResolution = this.limboResolutionsByTarget[targetId];
        if (limboResolution && limboResolution.receivedDocument) {
            return documentKeySet().add(limboResolution.key);
        }
        else {
            return this.queryViewsByTarget[targetId]
                ? this.queryViewsByTarget[targetId].view.syncedDocuments
                : documentKeySet();
        }
    };
    return SyncEngine;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */
var User = /** @class */ (function () {
    function User(uid) {
        this.uid = uid;
    }
    User.prototype.isAuthenticated = function () {
        return this.uid != null;
    };
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */
    User.prototype.toKey = function () {
        if (this.isAuthenticated()) {
            return 'uid:' + this.uid;
        }
        else {
            return 'anonymous-user';
        }
    };
    User.prototype.isEqual = function (otherUser) {
        return otherUser.uid === this.uid;
    };
    /** A user with a null UID. */
    User.UNAUTHENTICATED = new User(null);
    // TODO(mikelehen): Look into getting a proper uid-equivalent for
    // non-FirebaseAuth providers.
    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
    User.FIRST_PARTY = new User('first-party-uid');
    return User;
}());

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$10 = 'SharedClientState';
// The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
var CLIENT_STATE_KEY_PREFIX = 'firestore_clients';
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
//
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
var MUTATION_BATCH_KEY_PREFIX = 'firestore_mutations';
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
var QUERY_TARGET_KEY_PREFIX = 'firestore_targets';
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
var ONLINE_STATE_KEY_PREFIX = 'firestore_online_state';
// The WebStorage key prefix for the key that stores the last sequence number allocated. The key
// looks like 'firestore_sequence_number_<persistence_prefix>'.
var SEQUENCE_NUMBER_KEY_PREFIX = 'firestore_sequence_number';
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */
// Visible for testing
var MutationMetadata = /** @class */ (function () {
    function MutationMetadata(user, batchId, state, error$$1) {
        this.user = user;
        this.batchId = batchId;
        this.state = state;
        this.error = error$$1;
        assert((error$$1 !== undefined) === (state === 'rejected'), "MutationMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    MutationMetadata.fromWebStorageEntry = function (user, batchId, value) {
        var mutationBatch = JSON.parse(value);
        var validData = typeof mutationBatch === 'object' &&
            ['pending', 'acknowledged', 'rejected'].indexOf(mutationBatch.state) !==
                -1 &&
            (mutationBatch.error === undefined ||
                typeof mutationBatch.error === 'object');
        var firestoreError = undefined;
        if (validData && mutationBatch.error) {
            validData =
                typeof mutationBatch.error.message === 'string' &&
                    typeof mutationBatch.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(mutationBatch.error.code, mutationBatch.error.message);
            }
        }
        if (validData) {
            return new MutationMetadata(user, batchId, mutationBatch.state, firestoreError);
        }
        else {
            error(LOG_TAG$10, "Failed to parse mutation state for ID '" + batchId + "': " + value);
            return null;
        }
    };
    MutationMetadata.prototype.toWebStorageJSON = function () {
        var batchMetadata = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            batchMetadata.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(batchMetadata);
    };
    return MutationMetadata;
}());
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */
// Visible for testing
var QueryTargetMetadata = /** @class */ (function () {
    function QueryTargetMetadata(targetId, state, error$$1) {
        this.targetId = targetId;
        this.state = state;
        this.error = error$$1;
        assert((error$$1 !== undefined) === (state === 'rejected'), "QueryTargetMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    QueryTargetMetadata.fromWebStorageEntry = function (targetId, value) {
        var targetState = JSON.parse(value);
        var validData = typeof targetState === 'object' &&
            ['not-current', 'current', 'rejected'].indexOf(targetState.state) !==
                -1 &&
            (targetState.error === undefined ||
                typeof targetState.error === 'object');
        var firestoreError = undefined;
        if (validData && targetState.error) {
            validData =
                typeof targetState.error.message === 'string' &&
                    typeof targetState.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(targetState.error.code, targetState.error.message);
            }
        }
        if (validData) {
            return new QueryTargetMetadata(targetId, targetState.state, firestoreError);
        }
        else {
            error(LOG_TAG$10, "Failed to parse target state for ID '" + targetId + "': " + value);
            return null;
        }
    };
    QueryTargetMetadata.prototype.toWebStorageJSON = function () {
        var targetState = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            targetState.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(targetState);
    };
    return QueryTargetMetadata;
}());
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */
var RemoteClientState = /** @class */ (function () {
    function RemoteClientState(clientId, activeTargetIds) {
        this.clientId = clientId;
        this.activeTargetIds = activeTargetIds;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    RemoteClientState.fromWebStorageEntry = function (clientId, value) {
        var clientState = JSON.parse(value);
        var validData = typeof clientState === 'object' &&
            clientState.activeTargetIds instanceof Array;
        var activeTargetIdsSet = targetIdSet();
        for (var i = 0; validData && i < clientState.activeTargetIds.length; ++i) {
            validData = isSafeInteger(clientState.activeTargetIds[i]);
            activeTargetIdsSet = activeTargetIdsSet.add(clientState.activeTargetIds[i]);
        }
        if (validData) {
            return new RemoteClientState(clientId, activeTargetIdsSet);
        }
        else {
            error(LOG_TAG$10, "Failed to parse client data for instance '" + clientId + "': " + value);
            return null;
        }
    };
    return RemoteClientState;
}());
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */
var SharedOnlineState = /** @class */ (function () {
    function SharedOnlineState(clientId, onlineState) {
        this.clientId = clientId;
        this.onlineState = onlineState;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    SharedOnlineState.fromWebStorageEntry = function (value) {
        var onlineState = JSON.parse(value);
        var validData = typeof onlineState === 'object' &&
            OnlineState[onlineState.onlineState] !== undefined &&
            typeof onlineState.clientId === 'string';
        if (validData) {
            return new SharedOnlineState(onlineState.clientId, OnlineState[onlineState.onlineState]);
        }
        else {
            error(LOG_TAG$10, "Failed to parse online state: " + value);
            return null;
        }
    };
    return SharedOnlineState;
}());
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */
// Visible for testing.
var LocalClientState = /** @class */ (function () {
    function LocalClientState() {
        this.activeTargetIds = targetIdSet();
    }
    LocalClientState.prototype.addQueryTarget = function (targetId) {
        assert(!this.activeTargetIds.has(targetId), "Target with ID '" + targetId + "' already active.");
        this.activeTargetIds = this.activeTargetIds.add(targetId);
    };
    LocalClientState.prototype.removeQueryTarget = function (targetId) {
        this.activeTargetIds = this.activeTargetIds.delete(targetId);
    };
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */
    LocalClientState.prototype.toWebStorageJSON = function () {
        var data = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        return JSON.stringify(data);
    };
    return LocalClientState;
}());
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */
var WebStorageSharedClientState = /** @class */ (function () {
    function WebStorageSharedClientState(queue, platform, persistenceKey, localClientId, initialUser) {
        this.queue = queue;
        this.platform = platform;
        this.persistenceKey = persistenceKey;
        this.localClientId = localClientId;
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
        this.activeClients = {};
        this.storageListener = this.handleWebStorageEvent.bind(this);
        this.started = false;
        /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */
        this.earlyEvents = [];
        if (!WebStorageSharedClientState.isAvailable(this.platform)) {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'LocalStorage is not available on this platform.');
        }
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var escapedPersistenceKey = persistenceKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        this.storage = this.platform.window.localStorage;
        this.currentUser = initialUser;
        this.localClientStorageKey = this.toWebStorageClientStateKey(this.localClientId);
        this.sequenceNumberKey = SEQUENCE_NUMBER_KEY_PREFIX + "_" + persistenceKey;
        this.activeClients[this.localClientId] = new LocalClientState();
        this.clientStateKeyRe = new RegExp("^" + CLIENT_STATE_KEY_PREFIX + "_" + escapedPersistenceKey + "_([^_]*)$");
        this.mutationBatchKeyRe = new RegExp("^" + MUTATION_BATCH_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)(?:_(.*))?$");
        this.queryTargetKeyRe = new RegExp("^" + QUERY_TARGET_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)$");
        this.onlineStateKey = ONLINE_STATE_KEY_PREFIX + "_" + persistenceKey;
        // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.platform.window.addEventListener('storage', this.storageListener);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */
    WebStorageSharedClientState.isAvailable = function (platform) {
        return !!(platform.window && platform.window.localStorage != null);
    };
    WebStorageSharedClientState.prototype.start = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            var existingClients, _i, existingClients_1, clientId, storageItem, clientState, onlineStateJSON, onlineState, _a, _b, event_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        assert(!this.started, 'WebStorageSharedClientState already started');
                        assert(this.syncEngine !== null, 'syncEngine property must be set before calling start()');
                        assert(this.onlineStateHandler !== null, 'onlineStateHandler property must be set before calling start()');
                        return [4 /*yield*/, this.syncEngine.getActiveClients()];
                    case 1:
                        existingClients = _c.sent();
                        for (_i = 0, existingClients_1 = existingClients; _i < existingClients_1.length; _i++) {
                            clientId = existingClients_1[_i];
                            if (clientId === this.localClientId) {
                                continue;
                            }
                            storageItem = this.getItem(this.toWebStorageClientStateKey(clientId));
                            if (storageItem) {
                                clientState = RemoteClientState.fromWebStorageEntry(clientId, storageItem);
                                if (clientState) {
                                    this.activeClients[clientState.clientId] = clientState;
                                }
                            }
                        }
                        this.persistClientState();
                        onlineStateJSON = this.storage.getItem(this.onlineStateKey);
                        if (onlineStateJSON) {
                            onlineState = this.fromWebStorageOnlineState(onlineStateJSON);
                            if (onlineState) {
                                this.handleOnlineStateEvent(onlineState);
                            }
                        }
                        for (_a = 0, _b = this.earlyEvents; _a < _b.length; _a++) {
                            event_1 = _b[_a];
                            this.handleWebStorageEvent(event_1);
                        }
                        this.earlyEvents = [];
                        // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.platform.window.addEventListener('unload', function () { return _this.shutdown(); });
                        this.started = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStorageSharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) {
        this.setItem(this.sequenceNumberKey, JSON.stringify(sequenceNumber));
    };
    WebStorageSharedClientState.prototype.getAllActiveQueryTargets = function () {
        var activeTargets = targetIdSet();
        forEach(this.activeClients, function (key, value) {
            activeTargets = activeTargets.unionWith(value.activeTargetIds);
        });
        return activeTargets;
    };
    WebStorageSharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        // This is not using `obj.forEach` since `forEach` doesn't support early
        // return.
        for (var clientId in this.activeClients) {
            if (this.activeClients.hasOwnProperty(clientId)) {
                if (this.activeClients[clientId].activeTargetIds.has(targetId)) {
                    return true;
                }
            }
        }
        return false;
    };
    WebStorageSharedClientState.prototype.addPendingMutation = function (batchId) {
        this.persistMutationState(batchId, 'pending');
    };
    WebStorageSharedClientState.prototype.updateMutationState = function (batchId, state, error$$1) {
        this.persistMutationState(batchId, state, error$$1);
        // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.removeMutationState(batchId);
    };
    WebStorageSharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        var queryState = 'not-current';
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(targetId)) {
            var storageItem = this.storage.getItem(this.toWebStorageQueryTargetMetadataKey(targetId));
            if (storageItem) {
                var metadata = QueryTargetMetadata.fromWebStorageEntry(targetId, storageItem);
                if (metadata) {
                    queryState = metadata.state;
                }
            }
        }
        this.localClientState.addQueryTarget(targetId);
        this.persistClientState();
        return queryState;
    };
    WebStorageSharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localClientState.removeQueryTarget(targetId);
        this.persistClientState();
    };
    WebStorageSharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localClientState.activeTargetIds.has(targetId);
    };
    WebStorageSharedClientState.prototype.clearQueryState = function (targetId) {
        this.removeItem(this.toWebStorageQueryTargetMetadataKey(targetId));
    };
    WebStorageSharedClientState.prototype.updateQueryState = function (targetId, state, error$$1) {
        this.persistQueryTargetState(targetId, state, error$$1);
    };
    WebStorageSharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        var _this = this;
        removedBatchIds.forEach(function (batchId) {
            _this.removeMutationState(batchId);
        });
        this.currentUser = user;
        addedBatchIds.forEach(function (batchId) {
            _this.addPendingMutation(batchId);
        });
    };
    WebStorageSharedClientState.prototype.setOnlineState = function (onlineState) {
        this.persistOnlineState(onlineState);
    };
    WebStorageSharedClientState.prototype.shutdown = function () {
        if (this.started) {
            this.platform.window.removeEventListener('storage', this.storageListener);
            this.removeItem(this.localClientStorageKey);
            this.started = false;
        }
    };
    WebStorageSharedClientState.prototype.getItem = function (key) {
        var value = this.storage.getItem(key);
        debug(LOG_TAG$10, 'READ', key, value);
        return value;
    };
    WebStorageSharedClientState.prototype.setItem = function (key, value) {
        debug(LOG_TAG$10, 'SET', key, value);
        this.storage.setItem(key, value);
    };
    WebStorageSharedClientState.prototype.removeItem = function (key) {
        debug(LOG_TAG$10, 'REMOVE', key);
        this.storage.removeItem(key);
    };
    WebStorageSharedClientState.prototype.handleWebStorageEvent = function (event) {
        var _this = this;
        if (event.storageArea === this.storage) {
            debug(LOG_TAG$10, 'EVENT', event.key, event.newValue);
            if (event.key === this.localClientStorageKey) {
                error('Received WebStorage notification for local change. Another client might have ' +
                    'garbage-collected our state');
                return;
            }
            this.queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var clientState, clientId, mutationMetadata, queryTargetMetadata, onlineState, sequenceNumber;
                return tslib_1.__generator(this, function (_a) {
                    if (!this.started) {
                        this.earlyEvents.push(event);
                        return [2 /*return*/];
                    }
                    if (event.key === null) {
                        return [2 /*return*/];
                    }
                    if (this.clientStateKeyRe.test(event.key)) {
                        if (event.newValue != null) {
                            clientState = this.fromWebStorageClientState(event.key, event.newValue);
                            if (clientState) {
                                return [2 /*return*/, this.handleClientStateEvent(clientState.clientId, clientState)];
                            }
                        }
                        else {
                            clientId = this.fromWebStorageClientStateKey(event.key);
                            return [2 /*return*/, this.handleClientStateEvent(clientId, null)];
                        }
                    }
                    else if (this.mutationBatchKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            mutationMetadata = this.fromWebStorageMutationMetadata(event.key, event.newValue);
                            if (mutationMetadata) {
                                return [2 /*return*/, this.handleMutationBatchEvent(mutationMetadata)];
                            }
                        }
                    }
                    else if (this.queryTargetKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            queryTargetMetadata = this.fromWebStorageQueryTargetMetadata(event.key, event.newValue);
                            if (queryTargetMetadata) {
                                return [2 /*return*/, this.handleQueryTargetEvent(queryTargetMetadata)];
                            }
                        }
                    }
                    else if (event.key === this.onlineStateKey) {
                        if (event.newValue !== null) {
                            onlineState = this.fromWebStorageOnlineState(event.newValue);
                            if (onlineState) {
                                return [2 /*return*/, this.handleOnlineStateEvent(onlineState)];
                            }
                        }
                    }
                    else if (event.key === this.sequenceNumberKey) {
                        assert(!!this.sequenceNumberHandler, 'Missing sequenceNumberHandler');
                        sequenceNumber = fromWebStorageSequenceNumber(event.newValue);
                        if (sequenceNumber !== ListenSequence.INVALID) {
                            this.sequenceNumberHandler(sequenceNumber);
                        }
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    };
    Object.defineProperty(WebStorageSharedClientState.prototype, "localClientState", {
        get: function () {
            return this.activeClients[this.localClientId];
        },
        enumerable: true,
        configurable: true
    });
    WebStorageSharedClientState.prototype.persistClientState = function () {
        this.setItem(this.localClientStorageKey, this.localClientState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.persistMutationState = function (batchId, state, error$$1) {
        var mutationState = new MutationMetadata(this.currentUser, batchId, state, error$$1);
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.setItem(mutationKey, mutationState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.removeMutationState = function (batchId) {
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.removeItem(mutationKey);
    };
    WebStorageSharedClientState.prototype.persistOnlineState = function (onlineState) {
        var entry = {
            clientId: this.localClientId,
            onlineState: OnlineState[onlineState]
        };
        this.storage.setItem(this.onlineStateKey, JSON.stringify(entry));
    };
    WebStorageSharedClientState.prototype.persistQueryTargetState = function (targetId, state, error$$1) {
        var targetKey = this.toWebStorageQueryTargetMetadataKey(targetId);
        var targetMetadata = new QueryTargetMetadata(targetId, state, error$$1);
        this.setItem(targetKey, targetMetadata.toWebStorageJSON());
    };
    /** Assembles the key for a client state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageClientStateKey = function (clientId) {
        assert(clientId.indexOf('_') === -1, "Client key cannot contain '_', but was '" + clientId + "'");
        return CLIENT_STATE_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /** Assembles the key for a query state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageQueryTargetMetadataKey = function (targetId) {
        return QUERY_TARGET_KEY_PREFIX + "_" + this.persistenceKey + "_" + targetId;
    };
    /** Assembles the key for a mutation batch in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageMutationBatchKey = function (batchId) {
        var mutationKey = MUTATION_BATCH_KEY_PREFIX + "_" + this.persistenceKey + "_" + batchId;
        if (this.currentUser.isAuthenticated()) {
            mutationKey += "_" + this.currentUser.uid;
        }
        return mutationKey;
    };
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientStateKey = function (key) {
        var match = this.clientStateKeyRe.exec(key);
        return match ? match[1] : null;
    };
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientState = function (key, value) {
        var clientId = this.fromWebStorageClientStateKey(key);
        assert(clientId !== null, "Cannot parse client state key '" + key + "'");
        return RemoteClientState.fromWebStorageEntry(clientId, value);
    };
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageMutationMetadata = function (key, value) {
        var match = this.mutationBatchKeyRe.exec(key);
        assert(match !== null, "Cannot parse mutation batch key '" + key + "'");
        var batchId = Number(match[1]);
        var userId = match[2] !== undefined ? match[2] : null;
        return MutationMetadata.fromWebStorageEntry(new User(userId), batchId, value);
    };
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageQueryTargetMetadata = function (key, value) {
        var match = this.queryTargetKeyRe.exec(key);
        assert(match !== null, "Cannot parse query target key '" + key + "'");
        var targetId = Number(match[1]);
        return QueryTargetMetadata.fromWebStorageEntry(targetId, value);
    };
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageOnlineState = function (value) {
        return SharedOnlineState.fromWebStorageEntry(value);
    };
    WebStorageSharedClientState.prototype.handleMutationBatchEvent = function (mutationBatch) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (mutationBatch.user.uid !== this.currentUser.uid) {
                    debug(LOG_TAG$10, "Ignoring mutation for non-active user " + mutationBatch.user.uid);
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.syncEngine.applyBatchState(mutationBatch.batchId, mutationBatch.state, mutationBatch.error)];
            });
        });
    };
    WebStorageSharedClientState.prototype.handleQueryTargetEvent = function (targetMetadata) {
        return this.syncEngine.applyTargetState(targetMetadata.targetId, targetMetadata.state, targetMetadata.error);
    };
    WebStorageSharedClientState.prototype.handleClientStateEvent = function (clientId, clientState) {
        var _this = this;
        var existingTargets = this.getAllActiveQueryTargets();
        if (clientState) {
            this.activeClients[clientId] = clientState;
        }
        else {
            delete this.activeClients[clientId];
        }
        var newTargets = this.getAllActiveQueryTargets();
        var addedTargets = [];
        var removedTargets = [];
        newTargets.forEach(function (targetId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!existingTargets.has(targetId)) {
                    addedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        existingTargets.forEach(function (targetId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!newTargets.has(targetId)) {
                    removedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        return this.syncEngine.applyActiveTargetsChange(addedTargets, removedTargets);
    };
    WebStorageSharedClientState.prototype.handleOnlineStateEvent = function (onlineState) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        if (this.activeClients[onlineState.clientId]) {
            this.onlineStateHandler(onlineState.onlineState);
        }
    };
    return WebStorageSharedClientState;
}());
function fromWebStorageSequenceNumber(seqString) {
    var sequenceNumber = ListenSequence.INVALID;
    if (seqString != null) {
        try {
            var parsed = JSON.parse(seqString);
            assert(typeof parsed === 'number', 'Found non-numeric sequence number');
            sequenceNumber = parsed;
        }
        catch (e) {
            error(LOG_TAG$10, 'Failed to read sequence number from WebStorage', e);
        }
    }
    return sequenceNumber;
}
/**
 * `MemorySharedClientState` is a simple implementation of SharedClientState for
 * clients using memory persistence. The state in this class remains fully
 * isolated and no synchronization is performed.
 */
var MemorySharedClientState = /** @class */ (function () {
    function MemorySharedClientState() {
        this.localState = new LocalClientState();
        this.queryState = {};
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
    }
    MemorySharedClientState.prototype.addPendingMutation = function (batchId) {
        // No op.
    };
    MemorySharedClientState.prototype.updateMutationState = function (batchId, state, error$$1) {
        // No op.
    };
    MemorySharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        this.localState.addQueryTarget(targetId);
        return this.queryState[targetId] || 'not-current';
    };
    MemorySharedClientState.prototype.updateQueryState = function (targetId, state, error$$1) {
        this.queryState[targetId] = state;
    };
    MemorySharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localState.removeQueryTarget(targetId);
    };
    MemorySharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.clearQueryState = function (targetId) {
        delete this.queryState[targetId];
    };
    MemorySharedClientState.prototype.getAllActiveQueryTargets = function () {
        return this.localState.activeTargetIds;
    };
    MemorySharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.start = function () {
        this.localState = new LocalClientState();
        return Promise.resolve();
    };
    MemorySharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        // No op.
    };
    MemorySharedClientState.prototype.setOnlineState = function (onlineState) {
        // No op.
    };
    MemorySharedClientState.prototype.shutdown = function () { };
    MemorySharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) { };
    return MemorySharedClientState;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$11 = 'FirestoreClient';
/** The DOMException code for an aborted operation. */
var DOM_EXCEPTION_ABORTED = 20;
/** The DOMException code for quota exceeded. */
var DOM_EXCEPTION_QUOTA_EXCEEDED = 22;
var IndexedDbPersistenceSettings = /** @class */ (function () {
    function IndexedDbPersistenceSettings(cacheSizeBytes, experimentalTabSynchronization) {
        this.cacheSizeBytes = cacheSizeBytes;
        this.experimentalTabSynchronization = experimentalTabSynchronization;
    }
    IndexedDbPersistenceSettings.prototype.lruParams = function () {
        return LruParams.withCacheSize(this.cacheSizeBytes);
    };
    return IndexedDbPersistenceSettings;
}());
var MemoryPersistenceSettings = /** @class */ (function () {
    function MemoryPersistenceSettings() {
    }
    return MemoryPersistenceSettings;
}());
/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */
var FirestoreClient = /** @class */ (function () {
    function FirestoreClient(platform, databaseInfo, credentials, 
    /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */
    asyncQueue) {
        this.platform = platform;
        this.databaseInfo = databaseInfo;
        this.credentials = credentials;
        this.asyncQueue = asyncQueue;
        this.clientId = AutoId.newId();
    }
    /**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param persistenceSettings Settings object to configure offline
     *     persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */
    FirestoreClient.prototype.start = function (persistenceSettings) {
        var _this = this;
        // We defer our initialization until we get the current user from
        // setChangeListener(). We block the async queue until we got the initial
        // user and the initialization is completed. This will prevent any scheduled
        // work from happening before initialization is completed.
        //
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        var initializationDone = new Deferred();
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        //
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        var persistenceResult = new Deferred();
        var initialized = false;
        this.credentials.setChangeListener(function (user) {
            if (!initialized) {
                initialized = true;
                _this.initializePersistence(persistenceSettings, persistenceResult, user)
                    .then(function (maybeLruGc) { return _this.initializeRest(user, maybeLruGc); })
                    .then(initializationDone.resolve, initializationDone.reject);
            }
            else {
                _this.asyncQueue.enqueueAndForget(function () {
                    return _this.handleCredentialChange(user);
                });
            }
        });
        // Block the async queue until initialization is done
        this.asyncQueue.enqueueAndForget(function () {
            return initializationDone.promise;
        });
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return persistenceResult.promise;
    };
    /** Enables the network connection and requeues all pending operations. */
    FirestoreClient.prototype.enableNetwork = function () {
        var _this = this;
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.enableNetwork();
        });
    };
    /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param persistenceSettings Settings object to configure offline persistence
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */
    FirestoreClient.prototype.initializePersistence = function (persistenceSettings, persistenceResult, user) {
        var _this = this;
        if (persistenceSettings instanceof IndexedDbPersistenceSettings) {
            return this.startIndexedDbPersistence(user, persistenceSettings)
                .then(function (maybeLruGc) {
                persistenceResult.resolve();
                return maybeLruGc;
            })
                .catch(function (error$$1) {
                // Regardless of whether or not the retry succeeds, from an user
                // perspective, offline persistence has failed.
                persistenceResult.reject(error$$1);
                // An unknown failure on the first stage shuts everything down.
                if (!_this.canFallback(error$$1)) {
                    throw error$$1;
                }
                console.warn('Error enabling offline storage. Falling back to' +
                    ' storage disabled: ' +
                    error$$1);
                return _this.startMemoryPersistence();
            });
        }
        else {
            // When usePersistence == false, enabling offline persistence is defined
            // to unconditionally succeed. This allows start() to have the same
            // signature for both cases, despite the fact that the returned promise
            // is only used in the enablePersistence call.
            persistenceResult.resolve();
            return this.startMemoryPersistence();
        }
    };
    /**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */
    FirestoreClient.prototype.canFallback = function (error$$1) {
        if (error$$1 instanceof FirestoreError) {
            return (error$$1.code === Code.FAILED_PRECONDITION ||
                error$$1.code === Code.UNIMPLEMENTED);
        }
        else if (typeof DOMException !== 'undefined' &&
            error$$1 instanceof DOMException) {
            // We fall back to memory persistence if we cannot write the primary
            // lease. This can happen can during a schema migration, or if we run out
            // of quota when we try to write the primary lease.
            // For both the `QuotaExceededError` and the  `AbortError`, it is safe to
            // fall back to memory persistence since all modifications to IndexedDb
            // failed to commit.
            return (error$$1.code === DOM_EXCEPTION_QUOTA_EXCEEDED ||
                error$$1.code === DOM_EXCEPTION_ABORTED);
        }
        return true;
    };
    /**
     * Starts IndexedDB-based persistence.
     *
     * @returns A promise indicating success or failure.
     */
    FirestoreClient.prototype.startIndexedDbPersistence = function (user, settings) {
        var _this = this;
        // TODO(http://b/33384523): For now we just disable garbage collection
        // when persistence is enabled.
        var storagePrefix = IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
        var serializer = new JsonProtoSerializer(this.databaseInfo.databaseId, {
            useProto3Json: true
        });
        return Promise.resolve().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var persistence, lruParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (settings.experimentalTabSynchronization &&
                            !WebStorageSharedClientState.isAvailable(this.platform)) {
                            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
                        }
                        lruParams = settings.lruParams();
                        if (!settings.experimentalTabSynchronization) return [3 /*break*/, 2];
                        this.sharedClientState = new WebStorageSharedClientState(this.asyncQueue, this.platform, storagePrefix, this.clientId, user);
                        return [4 /*yield*/, IndexedDbPersistence.createMultiClientIndexedDbPersistence(storagePrefix, this.clientId, this.platform, this.asyncQueue, serializer, lruParams, { sequenceNumberSyncer: this.sharedClientState })];
                    case 1:
                        persistence = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        this.sharedClientState = new MemorySharedClientState();
                        return [4 /*yield*/, IndexedDbPersistence.createIndexedDbPersistence(storagePrefix, this.clientId, this.platform, this.asyncQueue, serializer, lruParams)];
                    case 3:
                        persistence = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.persistence = persistence;
                        return [2 /*return*/, persistence.referenceDelegate.garbageCollector];
                }
            });
        }); });
    };
    /**
     * Starts Memory-backed persistence. In practice this cannot fail.
     *
     * @returns A promise that will successfully resolve.
     */
    FirestoreClient.prototype.startMemoryPersistence = function () {
        this.persistence = MemoryPersistence.createEagerPersistence(this.clientId);
        this.sharedClientState = new MemorySharedClientState();
        return Promise.resolve(null);
    };
    /**
     * Initializes the rest of the FirestoreClient, assuming the initial user
     * has been obtained from the credential provider and some persistence
     * implementation is available in this.persistence.
     */
    FirestoreClient.prototype.initializeRest = function (user, maybeLruGc) {
        var _this = this;
        debug(LOG_TAG$11, 'Initializing. user=', user.uid);
        return this.platform
            .loadConnection(this.databaseInfo)
            .then(function (connection) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var serializer, datastore, remoteStoreOnlineStateChangedHandler, sharedClientStateOnlineStateChangedHandler;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.localStore = new LocalStore(this.persistence, user);
                        if (maybeLruGc) {
                            // We're running LRU Garbage collection. Set up the scheduler.
                            this.lruScheduler = new LruScheduler(maybeLruGc, this.asyncQueue, this.localStore);
                        }
                        serializer = this.platform.newSerializer(this.databaseInfo.databaseId);
                        datastore = new Datastore(this.asyncQueue, connection, this.credentials, serializer);
                        remoteStoreOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.RemoteStore);
                        };
                        sharedClientStateOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.SharedClientState);
                        };
                        this.remoteStore = new RemoteStore(this.localStore, datastore, this.asyncQueue, remoteStoreOnlineStateChangedHandler);
                        this.syncEngine = new SyncEngine(this.localStore, this.remoteStore, this.sharedClientState, user);
                        this.sharedClientState.onlineStateHandler = sharedClientStateOnlineStateChangedHandler;
                        // Set up wiring between sync engine and other components
                        this.remoteStore.syncEngine = this.syncEngine;
                        this.sharedClientState.syncEngine = this.syncEngine;
                        this.eventMgr = new EventManager(this.syncEngine);
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        return [4 /*yield*/, this.sharedClientState.start()];
                    case 1:
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        _a.sent();
                        return [4 /*yield*/, this.remoteStore.start()];
                    case 2:
                        _a.sent();
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return [4 /*yield*/, this.persistence.setPrimaryStateListener(function (isPrimary) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.syncEngine.applyPrimaryState(isPrimary)];
                                        case 1:
                                            _a.sent();
                                            if (this.lruScheduler) {
                                                if (isPrimary && !this.lruScheduler.started) {
                                                    this.lruScheduler.start();
                                                }
                                                else if (!isPrimary) {
                                                    this.lruScheduler.stop();
                                                }
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 3:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.handleCredentialChange = function (user) {
        this.asyncQueue.verifyOperationInProgress();
        debug(LOG_TAG$11, 'Credential Changed. Current user: ' + user.uid);
        return this.syncEngine.handleCredentialChange(user);
    };
    /** Disables the network connection. Pending operations will not complete. */
    FirestoreClient.prototype.disableNetwork = function () {
        var _this = this;
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.disableNetwork();
        });
    };
    FirestoreClient.prototype.shutdown = function (options) {
        var _this = this;
        return this.asyncQueue.enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                        if (this.lruScheduler) {
                            this.lruScheduler.stop();
                        }
                        return [4 /*yield*/, this.remoteStore.shutdown()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sharedClientState.shutdown()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.persistence.shutdown(options && options.purgePersistenceWithDataLoss)];
                    case 3:
                        _a.sent();
                        // `removeChangeListener` must be called after shutting down the
                        // RemoteStore as it will prevent the RemoteStore from retrieving
                        // auth tokens.
                        this.credentials.removeChangeListener();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.listen = function (query, observer, options) {
        var _this = this;
        var listener = new QueryListener(query, observer, options);
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.listen(listener);
        });
        return listener;
    };
    FirestoreClient.prototype.unlisten = function (listener) {
        var _this = this;
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.unlisten(listener);
        });
    };
    FirestoreClient.prototype.getDocumentFromLocalCache = function (docKey) {
        var _this = this;
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.readDocument(docKey);
        })
            .then(function (maybeDoc) {
            if (maybeDoc instanceof Document) {
                return maybeDoc;
            }
            else if (maybeDoc instanceof NoDocument) {
                return null;
            }
            else {
                throw new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from cache. (However, this document may ' +
                    "exist on the server. Run again without setting 'source' in " +
                    'the GetOptions to attempt to retrieve the document from the ' +
                    'server.)');
            }
        });
    };
    FirestoreClient.prototype.getDocumentsFromLocalCache = function (query) {
        var _this = this;
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.executeQuery(query);
        })
            .then(function (docs) {
            var remoteKeys = documentKeySet();
            var view = new View(query, remoteKeys);
            var viewDocChanges = view.computeDocChanges(docs);
            return view.applyChanges(viewDocChanges, 
            /* updateLimboDocuments= */ false).snapshot;
        });
    };
    FirestoreClient.prototype.write = function (mutations) {
        var _this = this;
        var deferred = new Deferred();
        this.asyncQueue.enqueueAndForget(function () {
            return _this.syncEngine.write(mutations, deferred);
        });
        return deferred.promise;
    };
    FirestoreClient.prototype.databaseId = function () {
        return this.databaseInfo.databaseId;
    };
    FirestoreClient.prototype.transaction = function (updateFunction) {
        var _this = this;
        // We have to wait for the async queue to be sure syncEngine is initialized.
        return this.asyncQueue
            .enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/];
        }); }); })
            .then(function () { return _this.syncEngine.runTransaction(updateFunction); });
    };
    return FirestoreClient;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */
var AsyncObserver = /** @class */ (function () {
    function AsyncObserver(observer) {
        this.observer = observer;
        /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */
        this.muted = false;
    }
    AsyncObserver.prototype.next = function (value) {
        this.scheduleEvent(this.observer.next, value);
    };
    AsyncObserver.prototype.error = function (error) {
        this.scheduleEvent(this.observer.error, error);
    };
    AsyncObserver.prototype.mute = function () {
        this.muted = true;
    };
    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
        var _this = this;
        if (!this.muted) {
            setTimeout(function () {
                if (!_this.muted) {
                    eventHandler(event);
                }
            }, 0);
        }
    };
    return AsyncObserver;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */
var FieldPath$1 = /** @class */ (function () {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */
    function FieldPath$$1() {
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
        for (var i = 0; i < fieldNames.length; ++i) {
            validateArgType('FieldPath', 'string', i, fieldNames[i]);
            if (fieldNames[i].length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
                    'Field names must not be empty.');
            }
        }
        this._internalPath = new FieldPath(fieldNames);
    }
    FieldPath$$1.documentId = function () {
        return FieldPath$$1._DOCUMENT_ID;
    };
    FieldPath$$1.prototype.isEqual = function (other) {
        if (!(other instanceof FieldPath$$1)) {
            throw invalidClassError('isEqual', 'FieldPath', 1, other);
        }
        return this._internalPath.isEqual(other._internalPath);
    };
    /**
     * Internal Note: The backend doesn't technically support querying by
     * document ID. Instead it queries by the entire document name (full path
     * included), but in the cases we currently support documentId(), the net
     * effect is the same.
     */
    FieldPath$$1._DOCUMENT_ID = new FieldPath$$1(FieldPath.keyField().canonicalString());
    return FieldPath$$1;
}());
/**
 * Matches any characters in a field path string that are reserved.
 */
var RESERVED = new RegExp('[~\\*/\\[\\]]');
/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */
function fromDotSeparatedString(path) {
    var found = path.search(RESERVED);
    if (found >= 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
            "'~', '*', '/', '[', or ']'");
    }
    try {
        return new (FieldPath$1.bind.apply(FieldPath$1, [void 0].concat(path.split('.'))))();
    }
    catch (e) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
            "begin with '.', end with '.', or contain '..'");
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OAuthToken = /** @class */ (function () {
    function OAuthToken(value, user) {
        this.user = user;
        this.type = 'OAuth';
        this.authHeaders = { Authorization: "Bearer " + value };
    }
    return OAuthToken;
}());
/** A CredentialsProvider that always yields an empty token. */
var EmptyCredentialsProvider = /** @class */ (function () {
    function EmptyCredentialsProvider() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */
        this.changeListener = null;
    }
    EmptyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(null);
    };
    EmptyCredentialsProvider.prototype.invalidateToken = function () { };
    EmptyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire with initial user.
        changeListener(User.UNAUTHENTICATED);
    };
    EmptyCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.changeListener !== null, 'removeChangeListener() when no listener registered');
        this.changeListener = null;
    };
    return EmptyCredentialsProvider;
}());
var FirebaseCredentialsProvider = /** @class */ (function () {
    function FirebaseCredentialsProvider(app) {
        var _this = this;
        this.app = app;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */
        this.tokenListener = null;
        /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */
        this.tokenCounter = 0;
        /** The listener registered with setChangeListener(). */
        this.changeListener = null;
        this.forceRefresh = false;
        this.tokenListener = function () {
            _this.tokenCounter++;
            _this.currentUser = _this.getUser();
            if (_this.changeListener) {
                _this.changeListener(_this.currentUser);
            }
        };
        this.tokenCounter = 0;
        // Will fire at least once where we set this.currentUser
        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
    }
    FirebaseCredentialsProvider.prototype.getToken = function () {
        var _this = this;
        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        var initialTokenCounter = this.tokenCounter;
        var forceRefresh = this.forceRefresh;
        this.forceRefresh = false;
        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            if (_this.tokenCounter !== initialTokenCounter) {
                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to token change.');
            }
            else {
                if (tokenData) {
                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
                }
                else {
                    return null;
                }
            }
        });
    };
    FirebaseCredentialsProvider.prototype.invalidateToken = function () {
        this.forceRefresh = true;
    };
    FirebaseCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire the initial event, but only if we received the initial user
        if (this.currentUser) {
            changeListener(this.currentUser);
        }
    };
    FirebaseCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.tokenListener != null, 'removeChangeListener() called twice');
        assert(this.changeListener !== null, 'removeChangeListener() called when no listener registered');
        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
        this.tokenListener = null;
        this.changeListener = null;
    };
    FirebaseCredentialsProvider.prototype.getUser = function () {
        var currentUid = this.app.INTERNAL.getUid();
        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
        return new User(currentUid);
    };
    return FirebaseCredentialsProvider;
}());
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * TODO(b/33147818) this implementation violates the current assumption that
 * tokens are immutable.  We need to either revisit this assumption or come
 * up with some way for FPA to use the listen/unlisten interface.
 */
var FirstPartyToken = /** @class */ (function () {
    function FirstPartyToken(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        this.type = 'FirstParty';
        this.user = User.FIRST_PARTY;
        assert(this.gapi &&
            this.gapi['auth'] &&
            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
    }
    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
        get: function () {
            return {
                Authorization: this.gapi['auth']['getAuthHeaderValueForFirstParty']([]),
                'X-Goog-AuthUser': this.sessionIndex
            };
        },
        enumerable: true,
        configurable: true
    });
    return FirstPartyToken;
}());
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */
var FirstPartyCredentialsProvider = /** @class */ (function () {
    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        assert(this.gapi &&
            this.gapi['auth'] &&
            this.gapi['auth']['getAuthHeaderValueForFirstParty'], 'unexpected gapi interface');
    }
    FirstPartyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
    };
    // TODO(33108925): can someone switch users w/o a page refresh?
    // TODO(33110621): need to understand token/session lifecycle
    FirstPartyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        // Fire with initial uid.
        changeListener(User.FIRST_PARTY);
    };
    FirstPartyCredentialsProvider.prototype.removeChangeListener = function () { };
    FirstPartyCredentialsProvider.prototype.invalidateToken = function () { };
    return FirstPartyCredentialsProvider;
}());
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */
function makeCredentialsProvider(credentials) {
    if (!credentials) {
        return new EmptyCredentialsProvider();
    }
    switch (credentials.type) {
        case 'gapi':
            return new FirstPartyCredentialsProvider(credentials.client, credentials.sessionIndex || '0');
        case 'provider':
            return credentials.client;
        default:
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isPartialObserver(obj) {
    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    var object = obj;
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in object && typeof object[method] === 'function') {
            return true;
        }
    }
    return false;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */
// tslint:disable-next-line:class-as-namespace  We use this as a base class.
var FieldValueImpl = /** @class */ (function () {
    function FieldValueImpl(_methodName) {
        this._methodName = _methodName;
    }
    FieldValueImpl.delete = function () {
        return DeleteFieldValueImpl.instance;
    };
    FieldValueImpl.serverTimestamp = function () {
        return ServerTimestampFieldValueImpl.instance;
    };
    FieldValueImpl.arrayUnion = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayUnion', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayUnionFieldValueImpl(elements);
    };
    FieldValueImpl.arrayRemove = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayRemove', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayRemoveFieldValueImpl(elements);
    };
    FieldValueImpl.prototype.isEqual = function (other) {
        return this === other;
    };
    return FieldValueImpl;
}());
var DeleteFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteFieldValueImpl, _super);
    function DeleteFieldValueImpl() {
        return _super.call(this, 'FieldValue.delete') || this;
    }
    /** Singleton instance. */
    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
    return DeleteFieldValueImpl;
}(FieldValueImpl));
var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ServerTimestampFieldValueImpl, _super);
    function ServerTimestampFieldValueImpl() {
        return _super.call(this, 'FieldValue.serverTimestamp') || this;
    }
    /** Singleton instance. */
    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
    return ServerTimestampFieldValueImpl;
}(FieldValueImpl));
var ArrayUnionFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayUnionFieldValueImpl, _super);
    function ArrayUnionFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayUnion') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayUnionFieldValueImpl;
}(FieldValueImpl));
var ArrayRemoveFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayRemoveFieldValueImpl, _super);
    function ArrayRemoveFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayRemove') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayRemoveFieldValueImpl;
}(FieldValueImpl));
// Public instance that disallows construction at runtime. This constructor is
// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
// be called FieldValue publicly. Internally we still use FieldValueImpl which
// has a type-checked private constructor. Note that FieldValueImpl and
// PublicFieldValue can be used interchangeably in instanceof checks.
// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
// and so we need to use FieldValueImpl as type and export it too.
// tslint:disable-next-line:variable-name  We treat this as a class name.
var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_FIELD_REGEX = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */
var ParsedSetData = /** @class */ (function () {
    function ParsedSetData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedSetData.prototype.toMutations = function (key, precondition) {
        var mutations = [];
        if (this.fieldMask !== null) {
            mutations.push(new PatchMutation(key, this.data, this.fieldMask, precondition));
        }
        else {
            mutations.push(new SetMutation(key, this.data, precondition));
        }
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedSetData;
}());
/** The result of parsing "update" data (i.e. for an updateData call). */
var ParsedUpdateData = /** @class */ (function () {
    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
        var mutations = [
            new PatchMutation(key, this.data, this.fieldMask, precondition)
        ];
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedUpdateData;
}());
/*
 * Represents what type of API method provided the data being parsed; useful
 * for determining which error conditions apply during parsing and providing
 * better error messages.
 */
var UserDataSource;
(function (UserDataSource) {
    UserDataSource[UserDataSource["Set"] = 0] = "Set";
    UserDataSource[UserDataSource["Update"] = 1] = "Update";
    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
    /**
     * Indicates the source is a where clause, cursor bound, arrayUnion()
     * element, etc. Of note, isWrite(source) will return false.
     */
    UserDataSource[UserDataSource["Argument"] = 3] = "Argument";
})(UserDataSource || (UserDataSource = {}));
function isWrite(dataSource) {
    switch (dataSource) {
        case UserDataSource.Set: // fall through
        case UserDataSource.MergeSet: // fall through
        case UserDataSource.Update:
            return true;
        case UserDataSource.Argument:
            return false;
        default:
            throw fail("Unexpected case for UserDataSource: " + dataSource);
    }
}
/** A "context" object passed around while parsing user data. */
var ParseContext = /** @class */ (function () {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param dataSource Indicates what kind of API method this data came from.
     * @param methodName The name of the method the user called to create this
     *     ParseContext.
     * @param path A path within the object being parsed. This could be an empty
     *     path (in which case the context represents the root of the data being
     *     parsed), or a nonempty path (indicating the context represents a nested
     *     location within the data).
     * @param arrayElement Whether or not this context corresponds to an element
     *     of an array.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */
    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
        this.dataSource = dataSource;
        this.methodName = methodName;
        this.path = path;
        this.arrayElement = arrayElement;
        // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        if (fieldTransforms === undefined) {
            this.validatePath();
        }
        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
        this.fieldTransforms = fieldTransforms || [];
        this.fieldMask = fieldMask || [];
    }
    ParseContext.prototype.childContextForField = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePathSegment(field);
        return context;
    };
    ParseContext.prototype.childContextForFieldPath = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePath();
        return context;
    };
    ParseContext.prototype.childContextForArray = function (index) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // null.
        return new ParseContext(this.dataSource, this.methodName, 
        /*path=*/ null, 
        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
    };
    ParseContext.prototype.createError = function (reason) {
        var fieldDescription = this.path === null || this.path.isEmpty()
            ? ''
            : " (found in field " + this.path.toString() + ")";
        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
            reason +
            fieldDescription);
    };
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
    ParseContext.prototype.contains = function (fieldPath) {
        return (this.fieldMask.find(function (field) { return fieldPath.isPrefixOf(field); }) !== undefined ||
            this.fieldTransforms.find(function (transform) {
                return fieldPath.isPrefixOf(transform.field);
            }) !== undefined);
    };
    ParseContext.prototype.validatePath = function () {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path === null) {
            return;
        }
        for (var i = 0; i < this.path.length; i++) {
            this.validatePathSegment(this.path.get(i));
        }
    };
    ParseContext.prototype.validatePathSegment = function (segment) {
        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
            throw this.createError('Document fields cannot begin and end with __');
        }
    };
    return ParseContext;
}());
/**
 * A placeholder object for DocumentReferences in this file, in order to
 * avoid a circular dependency. See the comments for `DataPreConverter` for
 * the full context.
 */
var DocumentKeyReference = /** @class */ (function () {
    function DocumentKeyReference(databaseId, key) {
        this.databaseId = databaseId;
        this.key = key;
    }
    return DocumentKeyReference;
}());
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */
var UserDataConverter = /** @class */ (function () {
    function UserDataConverter(preConverter) {
        this.preConverter = preConverter;
    }
    /** Parse document data from a non-merge set() call. */
    UserDataConverter.prototype.parseSetData = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Set, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        return new ParsedSetData(updateData, 
        /* fieldMask= */ null, context.fieldTransforms);
    };
    /** Parse document data from a set() call with '{merge:true}'. */
    UserDataConverter.prototype.parseMergeData = function (methodName, input, fieldPaths) {
        var context = new ParseContext(UserDataSource.MergeSet, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        var fieldMask;
        var fieldTransforms;
        if (!fieldPaths) {
            fieldMask = FieldMask.fromArray(context.fieldMask);
            fieldTransforms = context.fieldTransforms;
        }
        else {
            var validatedFieldPaths = new SortedSet(FieldPath.comparator);
            for (var _i = 0, fieldPaths_1 = fieldPaths; _i < fieldPaths_1.length; _i++) {
                var stringOrFieldPath = fieldPaths_1[_i];
                var fieldPath = void 0;
                if (stringOrFieldPath instanceof FieldPath$1) {
                    fieldPath = stringOrFieldPath._internalPath;
                }
                else if (typeof stringOrFieldPath === 'string') {
                    fieldPath = fieldPathFromDotSeparatedString(methodName, stringOrFieldPath);
                }
                else {
                    throw fail('Expected stringOrFieldPath to be a string or a FieldPath');
                }
                if (!context.contains(fieldPath)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Field '" + fieldPath + "' is specified in your field mask but missing from your input data.");
                }
                validatedFieldPaths = validatedFieldPaths.add(fieldPath);
            }
            fieldMask = FieldMask.fromSet(validatedFieldPaths);
            fieldTransforms = context.fieldTransforms.filter(function (transform) {
                return fieldMask.covers(transform.field);
            });
        }
        return new ParsedSetData(updateData, fieldMask, fieldTransforms);
    };
    /** Parse update data from an update() call. */
    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
        var _this = this;
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        forEach(input, function (key, value) {
            var path = fieldPathFromDotSeparatedString(methodName, key);
            var childContext = context.childContextForFieldPath(path);
            value = _this.runPreConverter(value, childContext);
            if (value instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = _this.parseData(value, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        });
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /** Parse update data from a list of field/value arguments. */
    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        var keys = [fieldPathFromArgument(methodName, field)];
        var values$$1 = [value];
        if (moreFieldsAndValues.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
                'of arguments that alternate between field names and values.');
        }
        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
            values$$1.push(moreFieldsAndValues[i + 1]);
        }
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        for (var i = 0; i < keys.length; ++i) {
            var path = keys[i];
            var childContext = context.childContextForFieldPath(path);
            var value_1 = this.runPreConverter(values$$1[i], childContext);
            if (value_1 instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = this.parseData(value_1, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        }
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     */
    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
        var parsed = this.parseData(input, context);
        assert(parsed != null, 'Parsed data should not be null.');
        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
        return parsed;
    };
    /** Sends data through this.preConverter, handling any thrown errors. */
    UserDataConverter.prototype.runPreConverter = function (input, context) {
        try {
            return this.preConverter(input);
        }
        catch (e) {
            var message = errorMessage(e);
            throw context.createError(message);
        }
    };
    /**
     * Internal helper for parsing user data.
     *
     * @param input Data to be parsed.
     * @param context A context object representing the current path being parsed,
     * the source of the data being parsed, etc.
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */
    UserDataConverter.prototype.parseData = function (input, context) {
        input = this.runPreConverter(input, context);
        if (looksLikeJsonObject(input)) {
            validatePlainObject('Unsupported field value:', context, input);
            return this.parseObject(input, context);
        }
        else if (input instanceof FieldValueImpl) {
            // FieldValues usually parse into transforms (except FieldValue.delete())
            // in which case we do not want to include this field in our parsed data
            // (as doing so will overwrite the field directly prior to the transform
            // trying to transform it). So we don't add this location to
            // context.fieldMask and we return null as our parsing result.
            this.parseSentinelFieldValue(input, context);
            return null;
        }
        else {
            // If context.path is null we are inside an array and we don't support
            // field mask paths more granular than the top-level array.
            if (context.path) {
                context.fieldMask.push(context.path);
            }
            if (input instanceof Array) {
                // TODO(b/34871131): Include the path containing the array in the error
                // message.
                if (context.arrayElement) {
                    throw context.createError('Nested arrays are not supported');
                }
                return this.parseArray(input, context);
            }
            else {
                return this.parseScalarValue(input, context);
            }
        }
    };
    UserDataConverter.prototype.parseObject = function (obj, context) {
        var _this = this;
        var result = new SortedMap(primitiveComparator);
        if (isEmpty(obj)) {
            // If we encounter an empty object, we explicitly add it to the update
            // mask to ensure that the server creates a map entry.
            if (context.path && context.path.length > 0) {
                context.fieldMask.push(context.path);
            }
        }
        else {
            forEach(obj, function (key, val) {
                var parsedValue = _this.parseData(val, context.childContextForField(key));
                if (parsedValue != null) {
                    result = result.insert(key, parsedValue);
                }
            });
        }
        return new ObjectValue(result);
    };
    UserDataConverter.prototype.parseArray = function (array, context) {
        var result = [];
        var entryIndex = 0;
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var entry = array_1[_i];
            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
            if (parsedEntry == null) {
                // Just include nulls in the array for fields being replaced with a
                // sentinel.
                parsedEntry = NullValue.INSTANCE;
            }
            result.push(parsedEntry);
            entryIndex++;
        }
        return new ArrayValue(result);
    };
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */
    UserDataConverter.prototype.parseSentinelFieldValue = function (value, context) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!isWrite(context.dataSource)) {
            throw context.createError(value._methodName + "() can only be used with update() and set()");
        }
        if (context.path === null) {
            throw context.createError(value._methodName + "() is not currently supported inside arrays");
        }
        if (value instanceof DeleteFieldValueImpl) {
            if (context.dataSource === UserDataSource.MergeSet) {
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                context.fieldMask.push(context.path);
            }
            else if (context.dataSource === UserDataSource.Update) {
                assert(context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
                    ' been handled.');
                throw context.createError('FieldValue.delete() can only appear at the top level ' +
                    'of your update data');
            }
            else {
                // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
                throw context.createError('FieldValue.delete() cannot be used with set() unless you pass ' +
                    '{merge:true}');
            }
        }
        else if (value instanceof ServerTimestampFieldValueImpl) {
            context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
        }
        else if (value instanceof ArrayUnionFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayUnion = new ArrayUnionTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayUnion));
        }
        else if (value instanceof ArrayRemoveFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayRemove = new ArrayRemoveTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayRemove));
        }
        else {
            fail('Unknown FieldValue type: ' + value);
        }
    };
    /**
     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
     *
     * @return The parsed value
     */
    UserDataConverter.prototype.parseScalarValue = function (value, context) {
        if (value === null) {
            return NullValue.INSTANCE;
        }
        else if (typeof value === 'number') {
            if (isSafeInteger(value)) {
                return new IntegerValue(value);
            }
            else {
                return new DoubleValue(value);
            }
        }
        else if (typeof value === 'boolean') {
            return BooleanValue.of(value);
        }
        else if (typeof value === 'string') {
            return new StringValue(value);
        }
        else if (value instanceof Date) {
            return new TimestampValue(Timestamp.fromDate(value));
        }
        else if (value instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            return new TimestampValue(new Timestamp(value.seconds, Math.floor(value.nanoseconds / 1000) * 1000));
        }
        else if (value instanceof GeoPoint) {
            return new GeoPointValue(value);
        }
        else if (value instanceof Blob) {
            return new BlobValue(value);
        }
        else if (value instanceof DocumentKeyReference) {
            return new RefValue(value.databaseId, value.key);
        }
        else {
            throw context.createError("Unsupported field value: " + valueDescription(value));
        }
    };
    UserDataConverter.prototype.parseArrayTransformElements = function (methodName, elements) {
        var _this = this;
        return elements.map(function (element, i) {
            // Although array transforms are used with writes, the actual elements
            // being unioned or removed are not considered writes since they cannot
            // contain any FieldValue sentinels, etc.
            var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
            return _this.parseData(element, context.childContextForArray(i));
        });
    };
    return UserDataConverter;
}());
/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */
function looksLikeJsonObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        !(input instanceof Array) &&
        !(input instanceof Date) &&
        !(input instanceof Timestamp) &&
        !(input instanceof GeoPoint) &&
        !(input instanceof Blob) &&
        !(input instanceof DocumentKeyReference) &&
        !(input instanceof FieldValueImpl));
}
function validatePlainObject(message, context, input) {
    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
        var description = valueDescription(input);
        if (description === 'an object') {
            // Massage the error if it was an object.
            throw context.createError(message + ' a custom object');
        }
        else {
            throw context.createError(message + ' ' + description);
        }
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */
function fieldPathFromArgument(methodName, path) {
    if (path instanceof FieldPath$1) {
        return path._internalPath;
    }
    else if (typeof path === 'string') {
        return fieldPathFromDotSeparatedString(methodName, path);
    }
    else {
        var message = 'Field path arguments must be of type string or FieldPath.';
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */
function fieldPathFromDotSeparatedString(methodName, path) {
    try {
        return fromDotSeparatedString(path)._internalPath;
    }
    catch (e) {
        var message = errorMessage(e);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */
function errorMessage(error) {
    return error instanceof Error ? error.message : error.toString();
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
// settings() defaults:
var DEFAULT_HOST = 'firestore.googleapis.com';
var DEFAULT_SSL = true;
var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS = true;
/**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * `Firestore` instance.
 */
var CACHE_SIZE_UNLIMITED = LruParams.COLLECTION_DISABLED;
// enablePersistence() defaults:
var DEFAULT_SYNCHRONIZE_TABS = false;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied firestore.Settings object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */
var FirestoreSettings = /** @class */ (function () {
    function FirestoreSettings(settings) {
        if (settings.host === undefined) {
            if (settings.ssl !== undefined) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            }
            this.host = DEFAULT_HOST;
            this.ssl = DEFAULT_SSL;
        }
        else {
            validateNamedType('settings', 'non-empty string', 'host', settings.host);
            this.host = settings.host;
            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
        }
        validateOptionNames('settings', settings, [
            'host',
            'ssl',
            'credentials',
            'timestampsInSnapshots',
            'cacheSizeBytes'
        ]);
        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
        this.credentials = settings.credentials;
        validateNamedOptionalType('settings', 'boolean', 'timestampsInSnapshots', settings.timestampsInSnapshots);
        // Nobody should set timestampsInSnapshots anymore, but the error depends on
        // whether they set it to true or false...
        if (settings.timestampsInSnapshots === true) {
            error("\n  The timestampsInSnapshots setting now defaults to true and you no\n  longer need to explicitly set it. In a future release, the setting\n  will be removed entirely and so it is recommended that you remove it\n  from your firestore.settings() call now.");
        }
        else if (settings.timestampsInSnapshots === false) {
            error("\n  The timestampsInSnapshots setting will soon be removed. YOU MUST UPDATE\n  YOUR CODE.\n\n  To hide this warning, stop using the timestampsInSnapshots setting in your\n  firestore.settings({ ... }) call.\n\n  Once you remove the setting, Timestamps stored in Cloud Firestore will be\n  read back as Firebase Timestamp objects instead of as system Date objects.\n  So you will also need to update code expecting a Date to instead expect a\n  Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at'); const date =\n  timestamp.toDate();\n\n  Please audit all existing usages of Date when you enable the new\n  behavior.");
        }
        this.timestampsInSnapshots = defaulted(settings.timestampsInSnapshots, DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);
        validateNamedOptionalType('settings', 'number', 'cacheSizeBytes', settings.cacheSizeBytes);
        if (settings.cacheSizeBytes === undefined) {
            this.cacheSizeBytes = LruParams.DEFAULT_CACHE_SIZE_BYTES;
        }
        else {
            if (settings.cacheSizeBytes !== CACHE_SIZE_UNLIMITED &&
                settings.cacheSizeBytes < LruParams.MINIMUM_CACHE_SIZE_BYTES) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + LruParams.MINIMUM_CACHE_SIZE_BYTES);
            }
            else {
                this.cacheSizeBytes = settings.cacheSizeBytes;
            }
        }
    }
    FirestoreSettings.prototype.isEqual = function (other) {
        return (this.host === other.host &&
            this.ssl === other.ssl &&
            this.timestampsInSnapshots === other.timestampsInSnapshots &&
            this.credentials === other.credentials &&
            this.cacheSizeBytes === other.cacheSizeBytes);
    };
    return FirestoreSettings;
}());
var FirestoreConfig = /** @class */ (function () {
    function FirestoreConfig() {
    }
    return FirestoreConfig;
}());
/**
 * The root reference to the database.
 */
var Firestore = /** @class */ (function () {
    function Firestore(databaseIdOrApp) {
        var _this = this;
        // Public for use in tests.
        // TODO(mikelehen): Use modularized initialization instead.
        this._queue = new AsyncQueue();
        this.INTERNAL = {
            delete: function (options) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    if (this._firestoreClient) {
                        return [2 /*return*/, this._firestoreClient.shutdown(options)];
                    }
                    return [2 /*return*/];
                });
            }); }
        };
        var config = new FirestoreConfig();
        if (typeof databaseIdOrApp.options === 'object') {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var app = databaseIdOrApp;
            config.firebaseApp = app;
            config.databaseId = Firestore.databaseIdFromApp(app);
            config.persistenceKey = config.firebaseApp.name;
            config.credentials = new FirebaseCredentialsProvider(app);
        }
        else {
            var external_1 = databaseIdOrApp;
            if (!external_1.projectId) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
            }
            config.databaseId = new DatabaseId(external_1.projectId, external_1.database);
            // Use a default persistenceKey that lines up with FirebaseApp.
            config.persistenceKey = '[DEFAULT]';
            config.credentials = new EmptyCredentialsProvider();
        }
        config.settings = new FirestoreSettings({});
        this._config = config;
        this._databaseId = config.databaseId;
    }
    Firestore.prototype.settings = function (settingsLiteral) {
        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
        if (contains(settingsLiteral, 'persistence')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
                'firestore.enablePersistence().');
        }
        var newSettings = new FirestoreSettings(settingsLiteral);
        if (this._firestoreClient && !this._config.settings.isEqual(newSettings)) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
                'be changed. You can only call settings() before calling any other ' +
                'methods on a Firestore object.');
        }
        this._config.settings = newSettings;
        if (newSettings.credentials !== undefined) {
            this._config.credentials = makeCredentialsProvider(newSettings.credentials);
        }
    };
    Firestore.prototype.enableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.enableNetwork();
    };
    Firestore.prototype.disableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.disableNetwork();
    };
    Firestore.prototype.enablePersistence = function (settings) {
        if (this._firestoreClient) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
                'be enabled. You can only call enablePersistence() before calling ' +
                'any other methods on a Firestore object.');
        }
        return this.configureClient(new IndexedDbPersistenceSettings(this._config.settings.cacheSizeBytes, settings !== undefined &&
            defaulted(settings.experimentalTabSynchronization, DEFAULT_SYNCHRONIZE_TABS)));
    };
    Firestore.prototype.ensureClientConfigured = function () {
        if (!this._firestoreClient) {
            // Kick off starting the client but don't actually wait for it.
            // tslint:disable-next-line:no-floating-promises
            this.configureClient(new MemoryPersistenceSettings());
        }
        return this._firestoreClient;
    };
    Firestore.prototype.configureClient = function (persistenceSettings) {
        var _this = this;
        assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
        assert(!this._firestoreClient, 'configureClient() called multiple times');
        var databaseInfo = new DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl);
        var preConverter = function (value) {
            if (value instanceof DocumentReference) {
                var thisDb = _this._config.databaseId;
                var otherDb = value.firestore._config.databaseId;
                if (!otherDb.isEqual(thisDb)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' +
                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
                        ("for database " + thisDb.projectId + "/" + thisDb.database));
                }
                return new DocumentKeyReference(_this._config.databaseId, value._key);
            }
            else {
                return value;
            }
        };
        this._dataConverter = new UserDataConverter(preConverter);
        this._firestoreClient = new FirestoreClient(PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
        return this._firestoreClient.start(persistenceSettings);
    };
    Firestore.databaseIdFromApp = function (app) {
        var options = app.options;
        if (!contains(options, 'projectId')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        }
        var projectId = options['projectId'];
        if (!projectId || typeof projectId !== 'string') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
        }
        return new DatabaseId(projectId);
    };
    Object.defineProperty(Firestore.prototype, "app", {
        get: function () {
            if (!this._config.firebaseApp) {
                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
                    'not available');
            }
            return this._config.firebaseApp;
        },
        enumerable: true,
        configurable: true
    });
    Firestore.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
        validateArgType('Firestore.collection', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection path to collection()');
        }
        this.ensureClientConfigured();
        return new CollectionReference(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.doc = function (pathString) {
        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
        validateArgType('Firestore.doc', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty document path to doc()');
        }
        this.ensureClientConfigured();
        return DocumentReference.forPath(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.runTransaction = function (updateFunction) {
        var _this = this;
        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
        return this.ensureClientConfigured().transaction(function (transaction) {
            return updateFunction(new Transaction$1(_this, transaction));
        });
    };
    Firestore.prototype.batch = function () {
        this.ensureClientConfigured();
        return new WriteBatch(this);
    };
    Object.defineProperty(Firestore, "logLevel", {
        get: function () {
            switch (getLogLevel()) {
                case LogLevel.DEBUG:
                    return 'debug';
                case LogLevel.ERROR:
                    return 'error';
                case LogLevel.SILENT:
                    return 'silent';
                default:
                    return fail('Unknown log level: ' + getLogLevel());
            }
        },
        enumerable: true,
        configurable: true
    });
    Firestore.setLogLevel = function (level) {
        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
        validateArgType('Firestore.setLogLevel', 'non-empty string', 1, level);
        switch (level) {
            case 'debug':
                setLogLevel(LogLevel.DEBUG);
                break;
            case 'error':
                setLogLevel(LogLevel.ERROR);
                break;
            case 'silent':
                setLogLevel(LogLevel.SILENT);
                break;
            default:
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
        }
    };
    // Note: this is not a property because the minifier can't work correctly with
    // the way TypeScript compiler outputs properties.
    Firestore.prototype._areTimestampsInSnapshotsEnabled = function () {
        return this._config.settings.timestampsInSnapshots;
    };
    return Firestore;
}());
/**
 * A reference to a transaction.
 */
var Transaction$1 = /** @class */ (function () {
    function Transaction(_firestore, _transaction) {
        this._firestore = _firestore;
        this._transaction = _transaction;
    }
    Transaction.prototype.get = function (documentRef) {
        var _this = this;
        validateExactNumberOfArgs('Transaction.get', arguments, 1);
        var ref = validateReference('Transaction.get', documentRef, this._firestore);
        return this._transaction
            .lookup([ref._key])
            .then(function (docs) {
            if (!docs || docs.length !== 1) {
                return fail('Mismatch in docs returned from document lookup.');
            }
            var doc = docs[0];
            if (doc instanceof NoDocument) {
                return new DocumentSnapshot(_this._firestore, ref._key, null, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else if (doc instanceof Document) {
                return new DocumentSnapshot(_this._firestore, ref._key, doc, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else {
                throw fail("BatchGetDocumentsRequest returned unexpected document type: " + doc.constructor.name);
            }
        });
    };
    Transaction.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
        var ref = validateReference('Transaction.set', documentRef, this._firestore);
        options = validateSetOptions('Transaction.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
        this._transaction.set(ref._key, parsed);
        return this;
    };
    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('Transaction.update', arguments, 2);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
        }
        this._transaction.update(ref._key, parsed);
        return this;
    };
    Transaction.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
        this._transaction.delete(ref._key);
        return this;
    };
    return Transaction;
}());
var WriteBatch = /** @class */ (function () {
    function WriteBatch(_firestore) {
        this._firestore = _firestore;
        this._mutations = [];
        this._committed = false;
    }
    WriteBatch.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
        options = validateSetOptions('WriteBatch.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        this.verifyNotCommitted();
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
        }
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.exists(true)));
        return this;
    };
    WriteBatch.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
        this._mutations = this._mutations.concat(new DeleteMutation(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.commit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.verifyNotCommitted();
                this._committed = true;
                if (this._mutations.length > 0) {
                    return [2 /*return*/, this._firestore.ensureClientConfigured().write(this._mutations)];
                }
                return [2 /*return*/];
            });
        });
    };
    WriteBatch.prototype.verifyNotCommitted = function () {
        if (this._committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
                'has been called.');
        }
    };
    return WriteBatch;
}());
/**
 * A reference to a particular document in a collection in the database.
 */
var DocumentReference = /** @class */ (function () {
    function DocumentReference(_key, firestore) {
        this._key = _key;
        this.firestore = firestore;
        this._firestoreClient = this.firestore.ensureClientConfigured();
    }
    DocumentReference.forPath = function (path, firestore) {
        if (path.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
                'references must have an even number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return new DocumentReference(new DocumentKey(path), firestore);
    };
    Object.defineProperty(DocumentReference.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "parent", {
        get: function () {
            return new CollectionReference(this._key.path.popLast(), this.firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "path", {
        get: function () {
            return this._key.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    DocumentReference.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
        validateArgType('DocumentReference.collection', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
        }
        var path = ResourcePath.fromString(pathString);
        return new CollectionReference(this._key.path.child(path), this.firestore);
    };
    DocumentReference.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentReference)) {
            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
        }
        return this.firestore === other.firestore && this._key.isEqual(other._key);
    };
    DocumentReference.prototype.set = function (value, options) {
        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
        options = validateSetOptions('DocumentReference.set', options);
        var parsed = options.merge || options.mergeFields
            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value, options.mergeFields)
            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.NONE));
    };
    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 2] = arguments[_i];
        }
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
        }
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.exists(true)));
    };
    DocumentReference.prototype.delete = function () {
        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
        return this._firestoreClient.write([
            new DeleteMutation(this._key, Precondition.NONE)
        ]);
    };
    DocumentReference.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
        var options = {
            includeMetadataChanges: false
        };
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('DocumentReference.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        var internalOptions = {
            includeMetadataChanges: options.includeMetadataChanges
        };
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(internalOptions, observer);
    };
    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (snapshot) {
                if (observer.next) {
                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
                    var doc = snapshot.docs.get(_this._key);
                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache, snapshot.hasPendingWrites));
                }
            },
            error: errHandler
        });
        var internalListener = this._firestoreClient.listen(Query.atPath(this._key.path), asyncObserver, options);
        return function () {
            asyncObserver.mute();
            _this._firestoreClient.unlisten(internalListener);
        };
    };
    DocumentReference.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('DocumentReference.get', arguments, 0, 1);
        validateGetOptions('DocumentReference.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentFromLocalCache(_this._key)
                    .then(function (doc) {
                    resolve(new DocumentSnapshot(_this.firestore, _this._key, doc, 
                    /*fromCache=*/ true, doc instanceof Document ? doc.hasLocalMutations : false));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    DocumentReference.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (snap) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (!snap.exists && snap.metadata.fromCache) {
                    // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document because the client is ' + 'offline.'));
                }
                else if (snap.exists &&
                    snap.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from server. (However, this ' +
                        'document does exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached document.)'));
                }
                else {
                    resolve(snap);
                }
            },
            error: reject
        });
    };
    return DocumentReference;
}());
var SnapshotMetadata = /** @class */ (function () {
    function SnapshotMetadata(hasPendingWrites, fromCache) {
        this.hasPendingWrites = hasPendingWrites;
        this.fromCache = fromCache;
    }
    SnapshotMetadata.prototype.isEqual = function (other) {
        return (this.hasPendingWrites === other.hasPendingWrites &&
            this.fromCache === other.fromCache);
    };
    return SnapshotMetadata;
}());
var DocumentSnapshot = /** @class */ (function () {
    function DocumentSnapshot(_firestore, _key, _document, _fromCache, _hasPendingWrites) {
        this._firestore = _firestore;
        this._key = _key;
        this._document = _document;
        this._fromCache = _fromCache;
        this._hasPendingWrites = _hasPendingWrites;
    }
    DocumentSnapshot.prototype.data = function (options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
        options = validateSnapshotOptions('DocumentSnapshot.data', options);
        return !this._document
            ? undefined
            : this.convertObject(this._document.data, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
    };
    DocumentSnapshot.prototype.get = function (fieldPath, options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
        options = validateSnapshotOptions('DocumentSnapshot.get', options);
        if (this._document) {
            var value = this._document.data.field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
            if (value !== undefined) {
                return this.convertValue(value, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
            }
        }
        return undefined;
    };
    Object.defineProperty(DocumentSnapshot.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
        get: function () {
            return new DocumentReference(this._key, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
        get: function () {
            return this._document !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
        get: function () {
            return new SnapshotMetadata(this._hasPendingWrites, this._fromCache);
        },
        enumerable: true,
        configurable: true
    });
    DocumentSnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSnapshot)) {
            throw invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._fromCache === other._fromCache &&
            this._key.isEqual(other._key) &&
            (this._document === null
                ? other._document === null
                : this._document.isEqual(other._document)));
    };
    DocumentSnapshot.prototype.convertObject = function (data, options) {
        var _this = this;
        var result = {};
        data.forEach(function (key, value) {
            result[key] = _this.convertValue(value, options);
        });
        return result;
    };
    DocumentSnapshot.prototype.convertValue = function (value, options) {
        if (value instanceof ObjectValue) {
            return this.convertObject(value, options);
        }
        else if (value instanceof ArrayValue) {
            return this.convertArray(value, options);
        }
        else if (value instanceof RefValue) {
            var key = value.value(options);
            var database = this._firestore.ensureClientConfigured().databaseId();
            if (!value.databaseId.isEqual(database)) {
                // TODO(b/64130202): Somehow support foreign references.
                error("Document " + this._key.path + " contains a document " +
                    "reference within a different database (" +
                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
                    "supported. It will be treated as a reference in the current " +
                    ("database (" + database.projectId + "/" + database.database + ") ") +
                    "instead.");
            }
            return new DocumentReference(key, this._firestore);
        }
        else {
            return value.value(options);
        }
    };
    DocumentSnapshot.prototype.convertArray = function (data, options) {
        var _this = this;
        return data.internalValue.map(function (value) {
            return _this.convertValue(value, options);
        });
    };
    return DocumentSnapshot;
}());
var QueryDocumentSnapshot = /** @class */ (function (_super) {
    tslib_1.__extends(QueryDocumentSnapshot, _super);
    function QueryDocumentSnapshot(firestore, key, document, fromCache, hasPendingWrites) {
        return _super.call(this, firestore, key, document, fromCache, hasPendingWrites) || this;
    }
    QueryDocumentSnapshot.prototype.data = function (options) {
        var data = _super.prototype.data.call(this, options);
        assert(typeof data === 'object', 'Document in a QueryDocumentSnapshot should exist');
        return data;
    };
    return QueryDocumentSnapshot;
}(DocumentSnapshot));
var Query$1 = /** @class */ (function () {
    function Query$$1(_query, firestore) {
        this._query = _query;
        this.firestore = firestore;
    }
    Query$$1.prototype.where = function (field, opStr, value) {
        validateExactNumberOfArgs('Query.where', arguments, 3);
        validateArgType('Query.where', 'non-empty string', 2, opStr);
        validateDefined('Query.where', 3, value);
        var fieldValue;
        var fieldPath = fieldPathFromArgument('Query.where', field);
        var relationOp = RelationOp.fromString(opStr);
        if (fieldPath.isKeyField()) {
            if (relationOp === RelationOp.ARRAY_CONTAINS) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. You can't perform array-contains queries on " +
                    'FieldPath.documentId() since document IDs are not arrays.');
            }
            if (typeof value === 'string') {
                if (value.indexOf('/') !== -1) {
                    // TODO(dimond): Allow slashes once ancestor queries are supported
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
                        'valid document ID if the first parameter is ' +
                        'FieldPath.documentId(), but it contains a slash.');
                }
                if (value === '') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
                        'valid document ID if the first parameter is ' +
                        'FieldPath.documentId(), but it was an empty string.');
                }
                var path = this._query.path.child(new ResourcePath([value]));
                assert(path.length % 2 === 0, 'Path should be a document key');
                fieldValue = new RefValue(this.firestore._databaseId, new DocumentKey(path));
            }
            else if (value instanceof DocumentReference) {
                var ref = value;
                fieldValue = new RefValue(this.firestore._databaseId, ref._key);
            }
            else {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " +
                    "string or a DocumentReference if the first parameter is " +
                    "FieldPath.documentId(), but it was: " +
                    (valueDescription(value) + "."));
            }
        }
        else {
            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
        }
        var filter = Filter.create(fieldPath, relationOp, fieldValue);
        this.validateNewFilter(filter);
        return new Query$$1(this._query.addFilter(filter), this.firestore);
    };
    Query$$1.prototype.orderBy = function (field, directionStr) {
        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
        validateOptionalArgType('Query.orderBy', 'non-empty string', 2, directionStr);
        var direction;
        if (directionStr === undefined || directionStr === 'asc') {
            direction = Direction.ASCENDING;
        }
        else if (directionStr === 'desc') {
            direction = Direction.DESCENDING;
        }
        else {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
                "expected 'asc' or 'desc'.");
        }
        if (this._query.startAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
                'Query.startAfter() before calling Query.orderBy().');
        }
        if (this._query.endAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
                'Query.endBefore() before calling Query.orderBy().');
        }
        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
        var orderBy = new OrderBy(fieldPath, direction);
        this.validateNewOrderBy(orderBy);
        return new Query$$1(this._query.addOrderBy(orderBy), this.firestore);
    };
    Query$$1.prototype.limit = function (n) {
        validateExactNumberOfArgs('Query.limit', arguments, 1);
        validateArgType('Query.limit', 'number', 1, n);
        if (n <= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " +
                'positive.');
        }
        return new Query$$1(this._query.withLimit(n), this.firestore);
    };
    Query$$1.prototype.startAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
        /*before=*/ true);
        return new Query$$1(this._query.withStartAt(bound), this.firestore);
    };
    Query$$1.prototype.startAfter = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
        /*before=*/ false);
        return new Query$$1(this._query.withStartAt(bound), this.firestore);
    };
    Query$$1.prototype.endBefore = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
        /*before=*/ true);
        return new Query$$1(this._query.withEndAt(bound), this.firestore);
    };
    Query$$1.prototype.endAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
        /*before=*/ false);
        return new Query$$1(this._query.withEndAt(bound), this.firestore);
    };
    Query$$1.prototype.isEqual = function (other) {
        if (!(other instanceof Query$$1)) {
            throw invalidClassError('isEqual', 'Query', 1, other);
        }
        return (this.firestore === other.firestore && this._query.isEqual(other._query));
    };
    /** Helper function to create a bound from a document or fields */
    Query$$1.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
        validateDefined(methodName, 1, docOrField);
        if (docOrField instanceof DocumentSnapshot) {
            if (fields.length > 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
            }
            var snap = docOrField;
            if (!snap.exists) {
                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
                    (methodName + "()."));
            }
            return this.boundFromDocument(methodName, snap._document, before);
        }
        else {
            var allFields = [docOrField].concat(fields);
            return this.boundFromFields(methodName, allFields, before);
        }
    };
    /**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query.
     */
    Query$$1.prototype.boundFromDocument = function (methodName, doc, before) {
        var components = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            if (orderBy.field.isKeyField()) {
                components.push(new RefValue(this.firestore._databaseId, doc.key));
            }
            else {
                var value = doc.field(orderBy.field);
                if (value !== undefined) {
                    components.push(value);
                }
                else {
                    var field = orderBy.field.canonicalString();
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
                        ("document for which the field '" + field + "' (used as the ") +
                        "orderBy) does not exist.");
                }
            }
        }
        return new Bound(components, before);
    };
    /**
     * Converts a list of field values to a Bound for the given query.
     */
    Query$$1.prototype.boundFromFields = function (methodName, values$$1, before) {
        // Use explicit order by's because it has to match the query the user made
        var orderBy = this._query.explicitOrderBy;
        if (values$$1.length > orderBy.length) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
                "The number of arguments must be less than or equal to the " +
                "number of Query.orderBy() clauses");
        }
        var components = [];
        for (var i = 0; i < values$$1.length; i++) {
            var rawValue = values$$1[i];
            var orderByComponent = orderBy[i];
            if (orderByComponent.field.isKeyField()) {
                if (typeof rawValue !== 'string') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
                        (methodName + "(), but got a " + typeof rawValue));
                }
                if (rawValue.indexOf('/') !== -1) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Document ID '" + rawValue + "' contains a slash in " +
                        (methodName + "()"));
                }
                var key = new DocumentKey(this._query.path.child(rawValue));
                components.push(new RefValue(this.firestore._databaseId, key));
            }
            else {
                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
                components.push(wrapped);
            }
        }
        return new Bound(components, before);
    };
    Query$$1.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
        var options = {};
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('Query.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(options, observer);
    };
    Query$$1.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (result) {
                if (observer.next) {
                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
                }
            },
            error: errHandler
        });
        var firestoreClient = this.firestore.ensureClientConfigured();
        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
        return function () {
            asyncObserver.mute();
            firestoreClient.unlisten(internalListener);
        };
    };
    Query$$1.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('Query.get', arguments, 0, 1);
        validateGetOptions('Query.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentsFromLocalCache(_this._query)
                    .then(function (viewSnap) {
                    resolve(new QuerySnapshot(_this.firestore, _this._query, viewSnap));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    Query$$1.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (result) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (result.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get documents from server. (However, these ' +
                        'documents may exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached documents.)'));
                }
                else {
                    resolve(result);
                }
            },
            error: reject
        });
    };
    Query$$1.prototype.validateNewFilter = function (filter) {
        if (filter instanceof RelationFilter) {
            if (filter.isInequality()) {
                var existingField = this._query.getInequalityFilterField();
                if (existingField !== null && !existingField.isEqual(filter.field)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
                        ' (<, <=, >, or >=) must be on the same field. But you have' +
                        (" inequality filters on '" + existingField.toString() + "'") +
                        (" and '" + filter.field.toString() + "'"));
                }
                var firstOrderByField = this._query.getFirstOrderByField();
                if (firstOrderByField !== null) {
                    this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
                }
            }
            else if (filter.op === RelationOp.ARRAY_CONTAINS) {
                if (this._query.hasArrayContainsFilter()) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. Queries only support a single array-contains ' +
                        'filter.');
                }
            }
        }
    };
    Query$$1.prototype.validateNewOrderBy = function (orderBy) {
        if (this._query.getFirstOrderByField() === null) {
            // This is the first order by. It must match any inequality.
            var inequalityField = this._query.getInequalityFilterField();
            if (inequalityField !== null) {
                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
            }
        }
    };
    Query$$1.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
        if (!orderBy.isEqual(inequality)) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
                ("and so you must also use '" + inequality.toString() + "' ") +
                "as your first Query.orderBy(), but your first Query.orderBy() " +
                ("is on field '" + orderBy.toString() + "' instead."));
        }
    };
    return Query$$1;
}());
var QuerySnapshot = /** @class */ (function () {
    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
        this._firestore = _firestore;
        this._originalQuery = _originalQuery;
        this._snapshot = _snapshot;
        this._cachedChanges = null;
        this._cachedChangesIncludeMetadataChanges = null;
        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
    }
    Object.defineProperty(QuerySnapshot.prototype, "docs", {
        get: function () {
            var result = [];
            this.forEach(function (doc) { return result.push(doc); });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "empty", {
        get: function () {
            return this._snapshot.docs.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "size", {
        get: function () {
            return this._snapshot.docs.size;
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
        this._snapshot.docs.forEach(function (doc) {
            callback.call(thisArg, _this.convertToDocumentImpl(doc));
        });
    };
    Object.defineProperty(QuerySnapshot.prototype, "query", {
        get: function () {
            return new Query$1(this._originalQuery, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.docChanges = function (options) {
        if (options) {
            validateOptionNames('QuerySnapshot.docChanges', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('QuerySnapshot.docChanges', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
        }
        var includeMetadataChanges = !!(options && options.includeMetadataChanges);
        if (includeMetadataChanges && this._snapshot.excludesMetadataChanges) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'To include metadata changes with your document changes, you must ' +
                'also pass { includeMetadataChanges:true } to onSnapshot().');
        }
        if (!this._cachedChanges ||
            this._cachedChangesIncludeMetadataChanges !== includeMetadataChanges) {
            this._cachedChanges = changesFromSnapshot(this._firestore, includeMetadataChanges, this._snapshot);
            this._cachedChangesIncludeMetadataChanges = includeMetadataChanges;
        }
        return this._cachedChanges;
    };
    /** Check the equality. The call can be very expensive. */
    QuerySnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof QuerySnapshot)) {
            throw invalidClassError('isEqual', 'QuerySnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._originalQuery.isEqual(other._originalQuery) &&
            this._snapshot.isEqual(other._snapshot));
    };
    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache, this._snapshot.mutatedKeys.has(doc.key));
    };
    return QuerySnapshot;
}());
// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
// into a method. Because this is a runtime breaking change and somewhat subtle
// (both Array and Function have a .length, etc.), we'll replace commonly-used
// properties (including Symbol.iterator) to throw a custom error message. In
// ~6 months we can delete the custom error as most folks will have hopefully
// migrated.
function throwDocChangesMethodError() {
    throw new FirestoreError(Code.INVALID_ARGUMENT, 'QuerySnapshot.docChanges has been changed from a property into a ' +
        'method, so usages like "querySnapshot.docChanges" should become ' +
        '"querySnapshot.docChanges()"');
}
var docChangesPropertiesToOverride = [
    'length',
    'forEach',
    'map'
].concat((typeof Symbol !== 'undefined' ? [Symbol.iterator] : []));
docChangesPropertiesToOverride.forEach(function (property) {
    /**
     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
     * is a Function. This could fail, in particular in the case of 'length' which
     * already exists on Function.prototype and on IE11 is improperly defined with
     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
     * still have a functional SDK.
     */
    try {
        Object.defineProperty(QuerySnapshot.prototype.docChanges, property, {
            get: function () { return throwDocChangesMethodError(); }
        });
    }
    catch (err) { } // Ignore this failure intentionally
});
var CollectionReference = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionReference, _super);
    function CollectionReference(path, firestore) {
        var _this = _super.call(this, Query.atPath(path), firestore) || this;
        if (path.length % 2 !== 1) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
                'references must have an odd number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return _this;
    }
    Object.defineProperty(CollectionReference.prototype, "id", {
        get: function () {
            return this._query.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "parent", {
        get: function () {
            var parentPath = this._query.path.popLast();
            if (parentPath.isEmpty()) {
                return null;
            }
            else {
                return new DocumentReference(new DocumentKey(parentPath), this.firestore);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "path", {
        get: function () {
            return this._query.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    CollectionReference.prototype.doc = function (pathString) {
        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
        // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        if (arguments.length === 0) {
            pathString = AutoId.newId();
        }
        validateArgType('CollectionReference.doc', 'non-empty string', 1, pathString);
        if (pathString === '') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
        }
        var path = ResourcePath.fromString(pathString);
        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
    };
    CollectionReference.prototype.add = function (value) {
        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
        validateArgType('CollectionReference.add', 'object', 1, value);
        var docRef = this.doc();
        return docRef.set(value).then(function () { return docRef; });
    };
    return CollectionReference;
}(Query$1));
function validateSetOptions(methodName, options) {
    if (options === undefined) {
        return {
            merge: false
        };
    }
    validateOptionNames(methodName, options, ['merge', 'mergeFields']);
    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
    validateOptionalArrayElements(methodName, 'mergeFields', 'a string or a FieldPath', options.mergeFields, function (element) {
        return typeof element === 'string' || element instanceof FieldPath$1;
    });
    if (options.mergeFields !== undefined && options.merge !== undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid options passed to function " + methodName + "(): You cannot specify both \"merge\" " +
            "and \"mergeFields\".");
    }
    return options;
}
function validateSnapshotOptions(methodName, options) {
    if (options === undefined) {
        return {};
    }
    validateOptionNames(methodName, options, ['serverTimestamps']);
    validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
    return options;
}
function validateGetOptions(methodName, options) {
    validateOptionalArgType(methodName, 'object', 1, options);
    if (options) {
        validateOptionNames(methodName, options, ['source']);
        validateNamedOptionalPropertyEquals(methodName, 'options', 'source', options.source, ['default', 'server', 'cache']);
    }
}
function validateReference(methodName, documentRef, firestore) {
    if (!(documentRef instanceof DocumentReference)) {
        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
    }
    else if (documentRef.firestore !== firestore) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
    }
    else {
        return documentRef;
    }
}
/**
 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
 *
 * Exported for testing.
 */
function changesFromSnapshot(firestore, includeMetadataChanges, snapshot) {
    if (snapshot.oldDocs.isEmpty()) {
        // Special case the first snapshot because index calculation is easy and
        // fast
        var lastDoc_1;
        var index_1 = 0;
        return snapshot.docChanges.map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
            lastDoc_1 = change.doc;
            return {
                type: 'added',
                doc: doc,
                oldIndex: -1,
                newIndex: index_1++
            };
        });
    }
    else {
        // A DocumentSet that is updated incrementally as changes are applied to use
        // to lookup the index of a document.
        var indexTracker_1 = snapshot.oldDocs;
        return snapshot.docChanges
            .filter(function (change) { return includeMetadataChanges || change.type !== ChangeType.Metadata; })
            .map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            var oldIndex = -1;
            var newIndex = -1;
            if (change.type !== ChangeType.Added) {
                oldIndex = indexTracker_1.indexOf(change.doc.key);
                assert(oldIndex >= 0, 'Index for document not found');
                indexTracker_1 = indexTracker_1.delete(change.doc.key);
            }
            if (change.type !== ChangeType.Removed) {
                indexTracker_1 = indexTracker_1.add(change.doc);
                newIndex = indexTracker_1.indexOf(change.doc.key);
            }
            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
        });
    }
}
function resultChangeType(type) {
    switch (type) {
        case ChangeType.Added:
            return 'added';
        case ChangeType.Modified:
        case ChangeType.Metadata:
            return 'modified';
        case ChangeType.Removed:
            return 'removed';
        default:
            return fail('Unknown change type: ' + type);
    }
}
// Export the classes with a private constructor (it will fail if invoked
// at runtime). Note that this still allows instanceof checks.
// We're treating the variables as class names, so disable checking for lower
// case variable names.
// tslint:disable:variable-name
var PublicFirestore = makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
var PublicTransaction = makeConstructorPrivate(Transaction$1, 'Use firebase.firestore().runTransaction() instead.');
var PublicWriteBatch = makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
var PublicDocumentReference = makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
var PublicDocumentSnapshot = makeConstructorPrivate(DocumentSnapshot);
var PublicQueryDocumentSnapshot = makeConstructorPrivate(QueryDocumentSnapshot);
var PublicQuery = makeConstructorPrivate(Query$1);
var PublicQuerySnapshot = makeConstructorPrivate(QuerySnapshot);
var PublicCollectionReference = makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
// tslint:enable:variable-name

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firestoreNamespace = {
    Firestore: PublicFirestore,
    GeoPoint: GeoPoint,
    Timestamp: Timestamp,
    Blob: PublicBlob,
    Transaction: PublicTransaction,
    WriteBatch: PublicWriteBatch,
    DocumentReference: PublicDocumentReference,
    DocumentSnapshot: PublicDocumentSnapshot,
    Query: PublicQuery,
    QueryDocumentSnapshot: PublicQueryDocumentSnapshot,
    QuerySnapshot: PublicQuerySnapshot,
    CollectionReference: PublicCollectionReference,
    FieldPath: FieldPath$1,
    FieldValue: PublicFieldValue,
    setLogLevel: Firestore.setLogLevel,
    CACHE_SIZE_UNLIMITED: CACHE_SIZE_UNLIMITED
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 */
function configureForFirebase(firebase$$1) {
    firebase$$1.INTERNAL.registerService('firestore', function (app) { return new Firestore(app); }, shallowCopy(firestoreNamespace));
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerFirestore(instance) {
    configureForFirebase(instance);
}
registerFirestore(firebase);

exports.registerFirestore = registerFirestore;


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel)
        return;
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}




/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWebChannelTransport", function() { return src_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return src_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return src_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebChannel", function() { return src_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrIoPool", function() { return src_5; });
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var e,goog=goog||{},h=commonjsGlobal;function l(a){return"string"==typeof a}function m(a,b){a=a.split(".");b=b||h;for(var c=0;c<a.length;c++)if(b=b[a[c]], null==b)return null;return b}function aa(){}
function ba(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function n(a){return"array"==ba(a)}function ca(a){var b=ba(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"function"==ba(a)}function r(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var t="closure_uid_"+(1E9*Math.random()>>>0),da=0;function ea(a,b,c){return a.call.apply(a.bind,arguments)}
function fa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function u(a,b,c){u=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ea:fa;return u.apply(null,arguments)}
function v(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var w=Date.now||function(){return+new Date};function x(a,b){function c(){}c.prototype=b.prototype;a.L=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.mh=function(a,c,g){for(var d=Array(arguments.length-2),f=2;f<arguments.length;f++)d[f-2]=arguments[f];return b.prototype[c].apply(a,d)};}function y(a){if(Error.captureStackTrace)Error.captureStackTrace(this,y);else{var b=Error().stack;b&&(this.stack=b);}a&&(this.message=String(a));}x(y,Error);y.prototype.name="CustomError";function ha(a,b){a=a.split("%s");for(var c="",d=a.length-1,f=0;f<d;f++)c+=a[f]+(f<b.length?b[f]:"%s");y.call(this,c+a[d]);}x(ha,y);ha.prototype.name="AssertionError";function ia(a,b){throw new ha("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));}function z(){0!=ja&&(ka[this[t]||(this[t]=++da)]=this);this.Ka=this.Ka;this.Qa=this.Qa;}var ja=0,ka={};z.prototype.Ka=!1;z.prototype.bb=function(){if(!this.Ka&&(this.Ka=!0, this.F(), 0!=ja)){var a=this[t]||(this[t]=++da);if(0!=ja&&this.Qa&&0<this.Qa.length)throw Error(this+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete ka[a];}};z.prototype.F=function(){if(this.Qa)for(;this.Qa.length;)this.Qa.shift()();};var la=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ma=Array.prototype.lastIndexOf?function(a,b){return Array.prototype.lastIndexOf.call(a,b,a.length-1)}:function(a,b){var c=a.length-1;0>c&&(c=Math.max(0,a.length+c));if(l(a))return l(b)&&1==b.length?a.lastIndexOf(b,c):-1;for(;0<=c;c--)if(c in a&&a[c]===b)return c;return-1},na=
Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c);}:function(a,b,c){for(var d=a.length,f=l(a)?a.split(""):a,g=0;g<d;g++)g in f&&b.call(c,f[g],g,a);},oa=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,f=0;f<c;f++)if(f in d&&b.call(void 0,d[f],f,a))return!0;return!1};
function pa(a){a:{var b=qa;for(var c=a.length,d=l(a)?a.split(""):a,f=0;f<c;f++)if(f in d&&b.call(void 0,d[f],f,a)){b=f;break a}b=-1;}return 0>b?null:l(a)?a.charAt(b):a[b]}function ra(a){if(!n(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0;}function sa(a,b){b=la(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function ta(a){return Array.prototype.concat.apply([],arguments)}function ua(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}function va(a){return/^[\s\xa0]*$/.test(a)}var wa=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};function xa(a,b){return a<b?-1:a>b?1:0}var A;a:{var ya=h.navigator;if(ya){var za=ya.userAgent;if(za){A=za;break a}}A="";}function B(a){return-1!=A.indexOf(a)}function Aa(a,b,c){for(var d in a)b.call(c,a[d],d,a);}function Ba(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ca(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Da(a){var b={},c;for(c in a)b[c]=a[c];return b}var Ea="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Fa(a,b){for(var c,d,f=1;f<arguments.length;f++){d=arguments[f];for(c in d)a[c]=d[c];for(var g=0;g<Ea.length;g++)c=Ea[g], Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c]);}}function Ga(a){Ga[" "](a);return a}Ga[" "]=aa;function Ha(a,b){var c=Ia;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var Ja=B("Opera"),C=B("Trident")||B("MSIE"),Ka=B("Edge"),La=Ka||C,Ma=B("Gecko")&&!(-1!=A.toLowerCase().indexOf("webkit")&&!B("Edge"))&&!(B("Trident")||B("MSIE"))&&!B("Edge"),Na=-1!=A.toLowerCase().indexOf("webkit")&&!B("Edge");function Oa(){var a=h.document;return a?a.documentMode:void 0}var Pa;
a:{var Qa="",Ra=function(){var a=A;if(Ma)return/rv:([^\);]+)(\)|;)/.exec(a);if(Ka)return/Edge\/([\d\.]+)/.exec(a);if(C)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Na)return/WebKit\/(\S+)/.exec(a);if(Ja)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Ra&&(Qa=Ra?Ra[1]:"");if(C){var Sa=Oa();if(null!=Sa&&Sa>parseFloat(Qa)){Pa=String(Sa);break a}}Pa=Qa;}var Ia={};
function Ta(a){return Ha(a,function(){for(var b=0,c=wa(String(Pa)).split("."),d=wa(String(a)).split("."),f=Math.max(c.length,d.length),g=0;0==b&&g<f;g++){var k=c[g]||"",p=d[g]||"";do{k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];p=/(\d*)(\D*)(.*)/.exec(p)||["","","",""];if(0==k[0].length&&0==p[0].length)break;b=xa(0==k[1].length?0:parseInt(k[1],10),0==p[1].length?0:parseInt(p[1],10))||xa(0==k[2].length,0==p[2].length)||xa(k[2],p[2]);k=k[3];p=p[3];}while(0==b)}return 0<=b})}var Ua;var Va=h.document;
Ua=Va&&C?Oa()||("CSS1Compat"==Va.compatMode?parseInt(Pa,10):5):void 0;var Wa=Object.freeze||function(a){return a};var Xa=!C||9<=Number(Ua),Ya=C&&!Ta("9"),Za=function(){if(!h.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0;}});try{h.addEventListener("test",aa,b), h.removeEventListener("test",aa,b);}catch(c){}return a}();function D(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.Ea=!1;this.Be=!0;}D.prototype.stopPropagation=function(){this.Ea=!0;};D.prototype.preventDefault=function(){this.defaultPrevented=!0;this.Be=!1;};function E(a,b){D.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.state=null;this.pointerId=0;this.pointerType="";this.fb=null;a&&this.Kf(a,b);}x(E,D);var $a=Wa({2:"touch",3:"pen",4:"mouse"});
E.prototype.Kf=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(Ma){a:{try{Ga(b.nodeName);var f=!0;break a}catch(g){}f=!1;}f||(b=null);}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=Na||void 0!==a.offsetX?a.offsetX:a.layerX, this.offsetY=Na||void 0!==a.offsetY?a.offsetY:a.layerY, this.clientX=void 0!==a.clientX?a.clientX:a.pageX, this.clientY=void 0!==a.clientY?a.clientY:a.pageY, this.screenX=a.screenX||0, this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX, this.clientY=void 0!==d.clientY?d.clientY:d.pageY, this.screenX=d.screenX||0, this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=
l(a.pointerType)?a.pointerType:$a[a.pointerType]||"";this.state=a.state;this.fb=a;a.defaultPrevented&&this.preventDefault();};E.prototype.stopPropagation=function(){E.L.stopPropagation.call(this);this.fb.stopPropagation?this.fb.stopPropagation():this.fb.cancelBubble=!0;};E.prototype.preventDefault=function(){E.L.preventDefault.call(this);var a=this.fb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1, Ya)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1;}catch(b){}};var ab="closure_listenable_"+(1E6*Math.random()|0);function F(a){return!(!a||!a[ab])}var bb=0;function cb(a,b,c,d,f){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Ob=f;this.key=++bb;this.Sa=this.Eb=!1;}cb.prototype.Vb=function(){this.Sa=!0;this.Ob=this.src=this.proxy=this.listener=null;};function db(a){this.src=a;this.J={};this.xb=0;}e=db.prototype;e.add=function(a,b,c,d,f){var g=a.toString();a=this.J[g];a||(a=this.J[g]=[], this.xb++);var k=eb(a,b,d,f);-1<k?(b=a[k], c||(b.Eb=!1)):(b=new cb(b,this.src,g,!!d,f), b.Eb=c, a.push(b));return b};e.remove=function(a,b,c,d){a=a.toString();if(!(a in this.J))return!1;var f=this.J[a];b=eb(f,b,c,d);return-1<b?(f[b].Vb(), Array.prototype.splice.call(f,b,1), 0==f.length&&(delete this.J[a], this.xb--), !0):!1};
e.ye=function(a){var b=a.type;b in this.J&&sa(this.J[b],a)&&(a.Vb(), 0==this.J[b].length&&(delete this.J[b], this.xb--));};e.pb=function(a){a=a&&a.toString();var c;for(c in this.J)if(!a||c==a){for(var d=this.J[c],f=0;f<d.length;f++)d[f].Vb();delete this.J[c];this.xb--;}};e.jb=function(a,b,c,d){a=this.J[a.toString()];var f=-1;a&&(f=eb(a,b,c,d));return-1<f?a[f]:null};function eb(a,b,c,d){for(var f=0;f<a.length;++f){var g=a[f];if(!g.Sa&&g.listener==b&&g.capture==!!c&&g.Ob==d)return f}return-1}var fb="closure_lm_"+(1E6*Math.random()|0),gb={};function ib(a,b,c,d,f){if(d&&d.once)return jb(a,b,c,d,f);if(n(b)){for(var g=0;g<b.length;g++)ib(a,b[g],c,d,f);return null}c=kb(c);return F(a)?a.nb(b,c,r(d)?!!d.capture:!!d,f):lb(a,b,c,!1,d,f)}
function lb(a,b,c,d,f,g){if(!b)throw Error("Invalid event type");var k=r(f)?!!f.capture:!!f,p=G(a);p||(a[fb]=p=new db(a));c=p.add(b,c,d,k,g);if(c.proxy)return c;d=mb();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Za||(f=k), void 0===f&&(f=!1), a.addEventListener(b.toString(),d,f);else if(a.attachEvent)a.attachEvent(nb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");return c}
function mb(){var a=ob,b=Xa?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function jb(a,b,c,d,f){if(n(b)){for(var g=0;g<b.length;g++)jb(a,b[g],c,d,f);return null}c=kb(c);return F(a)?a.Oc(b,c,r(d)?!!d.capture:!!d,f):lb(a,b,c,!0,d,f)}function pb(a,b,c,d,f){if(n(b))for(var g=0;g<b.length;g++)pb(a,b[g],c,d,f);else d=r(d)?!!d.capture:!!d, c=kb(c), F(a)?a.ed(b,c,d,f):a&&(a=G(a))&&(b=a.jb(b,c,d,f))&&qb(b);}
function qb(a){if("number"!=typeof a&&a&&!a.Sa){var b=a.src;if(F(b))b.Le(a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(nb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);(c=G(b))?(c.ye(a), 0==c.xb&&(c.src=null, b[fb]=null)):a.Vb();}}}function nb(a){return a in gb?gb[a]:gb[a]="on"+a}
function rb(a,b,c,d){var f=!0;if(a=G(a))if(b=a.J[b.toString()])for(b=b.concat(), a=0;a<b.length;a++){var g=b[a];g&&g.capture==c&&!g.Sa&&(g=sb(g,d), f=f&&!1!==g);}return f}function sb(a,b){var c=a.listener,d=a.Ob||a.src;a.Eb&&qb(a);return c.call(d,b)}
function ob(a,b){if(a.Sa)return!0;if(!Xa){var c=b||m("window.event");b=new E(c,this);var d=!0;if(!(0>c.keyCode||void 0!=c.returnValue)){a:{var f=!1;if(0==c.keyCode)try{c.keyCode=-1;break a}catch(k){f=!0;}if(f||void 0==c.returnValue)c.returnValue=!0;}c=[];for(f=b.currentTarget;f;f=f.parentNode)c.push(f);a=a.type;for(f=c.length-1;!b.Ea&&0<=f;f--){b.currentTarget=c[f];var g=rb(c[f],a,!0,b);d=d&&g;}for(f=0;!b.Ea&&f<c.length;f++)b.currentTarget=c[f], g=rb(c[f],a,!1,b), d=d&&g;}return d}return sb(a,new E(b,this))}
function G(a){a=a[fb];return a instanceof db?a:null}var tb="__closure_events_fn_"+(1E9*Math.random()>>>0);function kb(a){if(q(a))return a;a[tb]||(a[tb]=function(b){return a.handleEvent(b)});return a[tb]}function H(){z.call(this);this.ka=new db(this);this.Pe=this;this.Uc=null;}x(H,z);H.prototype[ab]=!0;e=H.prototype;e.addEventListener=function(a,b,c,d){ib(this,a,b,c,d);};e.removeEventListener=function(a,b,c,d){pb(this,a,b,c,d);};
e.dispatchEvent=function(a){var b,c=this.Uc;if(c)for(b=[];c;c=c.Uc)b.push(c);c=this.Pe;var d=a.type||a;if(l(a))a=new D(a,c);else if(a instanceof D)a.target=a.target||c;else{var f=a;a=new D(d,c);Fa(a,f);}f=!0;if(b)for(var g=b.length-1;!a.Ea&&0<=g;g--){var k=a.currentTarget=b[g];f=k.Lb(d,!0,a)&&f;}a.Ea||(k=a.currentTarget=c, f=k.Lb(d,!0,a)&&f, a.Ea||(f=k.Lb(d,!1,a)&&f));if(b)for(g=0;!a.Ea&&g<b.length;g++)k=a.currentTarget=b[g], f=k.Lb(d,!1,a)&&f;return f};
e.F=function(){H.L.F.call(this);this.pg();this.Uc=null;};e.nb=function(a,b,c,d){return this.ka.add(String(a),b,!1,c,d)};e.Oc=function(a,b,c,d){return this.ka.add(String(a),b,!0,c,d)};e.ed=function(a,b,c,d){this.ka.remove(String(a),b,c,d);};e.Le=function(a){this.ka.ye(a);};e.pg=function(){this.ka&&this.ka.pb(void 0);};
e.Lb=function(a,b,c){a=this.ka.J[String(a)];if(!a)return!0;a=a.concat();for(var d=!0,f=0;f<a.length;++f){var g=a[f];if(g&&!g.Sa&&g.capture==b){var k=g.listener,p=g.Ob||g.src;g.Eb&&this.Le(g);d=!1!==k.call(p,c)&&d;}}return d&&0!=c.Be};e.jb=function(a,b,c,d){return this.ka.jb(String(a),b,c,d)};var ub=h.JSON.stringify;function vb(a,b){this.Sf=100;this.ef=a;this.ug=b;this.Zb=0;this.Pb=null;}vb.prototype.get=function(){if(0<this.Zb){this.Zb--;var a=this.Pb;this.Pb=a.next;a.next=null;}else a=this.ef();return a};vb.prototype.put=function(a){this.ug(a);this.Zb<this.Sf&&(this.Zb++, a.next=this.Pb, this.Pb=a);};function I(){this.lc=this.Va=null;}var xb=new vb(function(){return new wb},function(a){a.reset();});I.prototype.add=function(a,b){var c=this.Af();c.set(a,b);this.lc?this.lc.next=c:this.Va=c;this.lc=c;};I.prototype.remove=function(){var a=null;this.Va&&(a=this.Va, this.Va=this.Va.next, this.Va||(this.lc=null), a.next=null);return a};I.prototype.wg=function(a){xb.put(a);};I.prototype.Af=function(){return xb.get()};function wb(){this.next=this.scope=this.Gc=null;}
wb.prototype.set=function(a,b){this.Gc=a;this.scope=b;this.next=null;};wb.prototype.reset=function(){this.next=this.scope=this.Gc=null;};function yb(a){h.setTimeout(function(){throw a;},0);}var zb;
function Ab(){var a=h.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!B("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=u(function(a){if(("*"==d||a.origin==d)&&a.data==
c)this.port1.onmessage();},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d);}};});if("undefined"!==typeof a&&!B("Trident")&&!B("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.rd;c.rd=null;a();}};return function(a){d.next={rd:a};d=d.next;b.port2.postMessage(0);}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null;};document.documentElement.appendChild(b);}:function(a){h.setTimeout(a,0);}}var Bb;function Cb(){if(h.Promise&&h.Promise.resolve){var a=h.Promise.resolve(void 0);Bb=function(){a.then(Db);};}else Bb=function(){var a=Db;!q(h.setImmediate)||h.Window&&h.Window.prototype&&!B("Edge")&&h.Window.prototype.setImmediate==h.setImmediate?(zb||(zb=Ab()), zb(a)):h.setImmediate(a);};}var Eb=!1,Fb=new I;function Db(){for(var a;a=Fb.remove();){try{a.Gc.call(a.scope);}catch(b){yb(b);}Fb.wg(a);}Eb=!1;}function Gb(a,b){H.call(this);this.Na=a||1;this.wb=b||h;this.nd=u(this.Rg,this);this.ie=w();}x(Gb,H);e=Gb.prototype;e.enabled=!1;e.B=null;e.setInterval=function(a){this.Na=a;this.B&&this.enabled?(this.stop(), this.start()):this.B&&this.stop();};e.Rg=function(){if(this.enabled){var a=w()-this.ie;0<a&&a<.8*this.Na?this.B=this.wb.setTimeout(this.nd,this.Na-a):(this.B&&(this.wb.clearTimeout(this.B), this.B=null), this.ff(), this.enabled&&(this.stop(), this.start()));}};e.ff=function(){this.dispatchEvent("tick");};
e.start=function(){this.enabled=!0;this.B||(this.B=this.wb.setTimeout(this.nd,this.Na), this.ie=w());};e.stop=function(){this.enabled=!1;this.B&&(this.wb.clearTimeout(this.B), this.B=null);};e.F=function(){Gb.L.F.call(this);this.stop();delete this.wb;};function Hb(a,b,c){if(q(a))c&&(a=u(a,c));else if(a&&"function"==typeof a.handleEvent)a=u(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:h.setTimeout(a,b||0)}function Ib(a,b,c){z.call(this);this.Uf=null!=c?u(a,c):a;this.Na=b;this.Xe=u(this.fg,this);this.qc=[];}x(Ib,z);e=Ib.prototype;e.Ta=!1;e.ob=0;e.B=null;e.mf=function(a){this.qc=arguments;this.B||this.ob?this.Ta=!0:this.Cc();};e.stop=function(){this.B&&(h.clearTimeout(this.B), this.B=null, this.Ta=!1, this.qc=[]);};e.pause=function(){this.ob++;};e.resume=function(){this.ob--;this.ob||!this.Ta||this.B||(this.Ta=!1, this.Cc());};e.F=function(){Ib.L.F.call(this);this.stop();};
e.fg=function(){this.B=null;this.Ta&&!this.ob&&(this.Ta=!1, this.Cc());};e.Cc=function(){this.B=Hb(this.Xe,this.Na);this.Uf.apply(null,this.qc);};function Jb(a){z.call(this);this.i=a;this.o={};}x(Jb,z);var Kb=[];e=Jb.prototype;e.nb=function(a,b,c,d){return this.Tf(a,b,c,d)};e.Tf=function(a,b,c,d){n(b)||(b&&(Kb[0]=b.toString()), b=Kb);for(var f=0;f<b.length;f++){var g=ib(a,b[f],c||this.handleEvent,d||!1,this.i||this);if(!g)break;this.o[g.key]=g;}return this};e.Oc=function(a,b,c,d){return this.je(a,b,c,d)};
e.je=function(a,b,c,d,f){if(n(b))for(var g=0;g<b.length;g++)this.je(a,b[g],c,d,f);else{a=jb(a,b,c||this.handleEvent,d,f||this.i||this);if(!a)return this;this.o[a.key]=a;}return this};e.ed=function(a,b,c,d,f){if(n(b))for(var g=0;g<b.length;g++)this.ed(a,b[g],c,d,f);else c=c||this.handleEvent, d=r(d)?!!d.capture:!!d, f=f||this.i||this, c=kb(c), d=!!d, b=F(a)?a.jb(b,c,d,f):a?(a=G(a))?a.jb(b,c,d,f):null:null, b&&(qb(b), delete this.o[b.key]);};
e.pb=function(){Aa(this.o,function(a,b){this.o.hasOwnProperty(b)&&qb(a);},this);this.o={};};e.F=function(){Jb.L.F.call(this);this.pb();};e.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function J(a,b,c){this.reset(a,b,c,void 0,void 0);}J.prototype.Md=null;J.prototype.reset=function(a,b,c,d,f){this.mb=a;delete this.Md;};J.prototype.Bg=function(a){this.Md=a;};J.prototype.Ge=function(a){this.mb=a;};function Mb(a){this.pe=a;this.Zd=this.uc=this.mb=this.$b=null;}function K(a,b){this.name=a;this.value=b;}K.prototype.toString=function(){return this.name};var Nb=new K("SEVERE",1E3),Ob=new K("WARNING",900),Pb=new K("INFO",800),Qb=new K("CONFIG",700),Rb=new K("FINE",500);e=Mb.prototype;e.getName=function(){return this.pe};e.getParent=function(){return this.$b};e.pf=function(){this.uc||(this.uc={});return this.uc};e.Ge=function(a){this.mb=a;};
e.Qd=function(){if(this.mb)return this.mb;if(this.$b)return this.$b.Qd();ia("Root logger has no level set.");return null};e.Pf=function(a){return a.value>=this.Qd().value};e.log=function(a,b,c){this.Pf(a)&&(q(b)&&(b=b()), this.gf(this.uf(a,b,c)));};e.uf=function(a,b,c){a=new J(a,String(b),this.pe);c&&a.Bg(c);return a};e.ca=function(a,b){this.log(Nb,a,b);};e.T=function(a,b){this.log(Ob,a,b);};e.info=function(a,b){this.log(Pb,a,b);};e.lf=function(a){this.log(Rb,a,void 0);};
e.gf=function(a){for(var b=this;b;)b.We(a), b=b.getParent();};e.We=function(a){if(this.Zd)for(var b=0,c;c=this.Zd[b];b++)c(a);};e.Fg=function(a){this.$b=a;};e.Qe=function(a,b){this.pf()[a]=b;};var Sb={},Tb=null;function Vb(a){Tb||(Tb=new Mb(""), Sb[""]=Tb, Tb.Ge(Qb));var b;if(!(b=Sb[a])){b=new Mb(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Vb(a.substr(0,c));c.Qe(d,b);b.Fg(c);Sb[a]=b;}return b}function Wb(a,b){a&&a.info(b,void 0);}function L(a,b){a&&a.lf(b);}function Xb(){this.s=Vb("goog.labs.net.webChannel.WebChannelDebug");this.Wc=!0;}e=Xb.prototype;e.Id=function(){this.Wc=!1;};e.Tg=function(a,b,c,d,f){var g=this;this.info(function(){return"XMLHTTP REQ ("+c+") [attempt "+d+"]: "+a+"\n"+b+"\n"+g.Xf(f)});};e.Ug=function(a,b,c,d,f,g){this.info(function(){return"XMLHTTP RESP ("+c+") [ attempt "+d+"]: "+a+"\n"+b+"\n"+f+" "+g});};e.Wa=function(a,b,c){var d=this;this.info(function(){return"XMLHTTP TEXT ("+a+"): "+d.ng(b)+(c?" "+c:"")});};
e.Sg=function(a){this.info(function(){return"TIMEOUT: "+a});};e.debug=function(a){L(this.s,a);};e.cb=function(a,b){var c=this.s;c&&c.ca(b||"Exception",a);};e.info=function(a){Wb(this.s,a);};e.T=function(a){var b=this.s;b&&b.T(a,void 0);};e.ca=function(a){var b=this.s;b&&b.ca(a,void 0);};
e.ng=function(a){if(!this.Wc)return a;if(!a)return null;try{var b=JSON.parse(a);if(b)for(var c=0;c<b.length;c++)n(b[c])&&this.Wf(b[c]);return ub(b)}catch(d){return this.debug("Exception parsing expected JS array - probably was not JS"), a}};e.Wf=function(a){if(!(2>a.length||(a=a[1], !n(a)||1>a.length))){var b=a[0];if("noop"!=b&&"stop"!=b&&"close"!=b)for(b=1;b<a.length;b++)a[b]="";}};
e.Xf=function(a){if(!this.Wc)return a;if(!a)return null;var b="";a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].split("=");if(1<d.length){var f=d[0];d=d[1];var g=f.split("_");b=2<=g.length&&"type"==g[1]?b+(f+"="+d+"&"):b+(f+"=redacted&");}}return b};var M=new H;function Yb(a){D.call(this,"serverreachability",a);}x(Yb,D);function N(a){M.dispatchEvent(new Yb(M,a));}function Zb(a,b){D.call(this,"statevent",a);this.stat=b;}x(Zb,D);function O(a){M.dispatchEvent(new Zb(M,a));}function $b(a,b,c){D.call(this,"timingevent",a);this.size=b;this.rtt=c;}x($b,D);function ac(a,b,c){M.dispatchEvent(new $b(M,a,b,c));}function P(a,b){if(!q(a))throw Error("Fn must not be null and must be a function");return h.setTimeout(function(){a();},b)}var bc={NO_ERROR:0,Vg:1,bh:2,ah:3,Yg:4,$g:5,dh:6,Ne:7,TIMEOUT:8,gh:9};var cc={Xg:"complete",kh:"success",Oe:"error",Ne:"abort",ih:"ready",jh:"readystatechange",TIMEOUT:"timeout",eh:"incrementaldata",hh:"progress",Zg:"downloadprogress",lh:"uploadprogress"};function dc(){}dc.prototype.pd=null;dc.prototype.Vd=function(){return this.pd||(this.pd=this.Mf())};function ec(){}var Q={OPEN:"a",Wg:"b",Oe:"c",fh:"d"};function fc(){D.call(this,"d");}x(fc,D);function gc(){D.call(this,"c");}x(gc,D);var hc;function ic(){}x(ic,dc);ic.prototype.Dd=function(){var a=this.Wd();return a?new ActiveXObject(a):new XMLHttpRequest};ic.prototype.Mf=function(){var a={};this.Wd()&&(a[0]=!0, a[1]=!0);return a};
ic.prototype.Wd=function(){if(!this.be&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var a=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],b=0;b<a.length;b++){var c=a[b];try{return new ActiveXObject(c), this.be=c}catch(d){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return this.be};hc=new ic;function R(a,b,c,d,f){this.b=a;this.a=b;this.ra=c;this.R=d;this.Xc=f||1;this.Fc=new Jb(this);this.Ua=jc;a=La?125:void 0;this.Vc=new Gb(a);this.A=null;this.S=!1;this.Da=this.pa=this.ua=this.ic=this.qb=this.hd=this.Ga=null;this.ba=[];this.h=null;this.Bb=0;this.I=this.Fa=null;this.w=-1;this.Za=!1;this.Ra=0;this.ac=null;this.lb=this.Ed=this.yc=!1;}var jc=45E3;
function kc(a,b){switch(a){case 0:return"Non-200 return code ("+b+")";case 1:return"XMLHTTP failure (no data)";case 2:return"HttpConnection timeout";default:return"Unknown error"}}var lc={},mc={};e=R.prototype;e.ga=function(a){this.A=a;};e.setTimeout=function(a){this.Ua=a;};e.He=function(a){this.Ra=a;};e.Gg=function(a){this.ba=a;};e.la=function(){return this.ba};e.kd=function(a,b){this.ic=1;this.ua=a.clone().Ub();this.Da=b;this.yc=!0;this.Ce(null);};
e.jd=function(a,b,c){this.ic=1;this.ua=a.clone().Ub();this.Da=null;this.yc=b;this.Ce(c);};
e.Ce=function(a){this.qb=w();this.eb();this.pa=this.ua.clone();this.pa.dc("t",this.Xc);this.Bb=0;this.h=this.b.Jb(this.b.fc()?a:null);0<this.Ra&&(this.ac=new Ib(u(this.Me,this,this.h),this.Ra));this.Fc.nb(this.h,"readystatechange",this.mg);a=this.A?Da(this.A):{};this.Da?(this.Fa||(this.Fa="POST"), a["Content-Type"]="application/x-www-form-urlencoded", this.h.send(this.pa,this.Fa,this.Da,a)):(this.Fa="GET", this.h.send(this.pa,this.Fa,null,a));N(1);this.a.Tg(this.Fa,this.pa,this.R,this.Xc,this.Da);};
e.mg=function(a){a=a.target;var b=this.ac;b&&3==a.ma()?(this.a.debug("Throttling readystatechange."), b.mf()):this.Me(a);};e.Me=function(a){try{a==this.h?this.hg():this.a.T("Called back with an unexpected xmlhttp");}catch(c){if(this.a.debug("Failed call to OnXmlHttpReadyStateChanged_"), this.h&&this.h.ya()){var b=this;this.a.cb(c,function(){return"ResponseText: "+b.h.ya()});}else this.a.cb(c,"No response text");}finally{}};
e.hg=function(){var a=this.h.ma(),b=this.h.Ud(),c=this.h.za();if(!(3>a||3==a&&!La&&!this.h.ya())){this.Za||4!=a||7==b||(8==b||0>=c?N(3):N(2));this.Fb();var d=this.h.za();this.w=d;b=this.h.ya();if(!b){var f=this;this.a.debug(function(){return"No response text for uri "+f.pa+" status "+d});}this.S=200==d;this.a.Ug(this.Fa,this.pa,this.R,this.Xc,a,d);if(this.S){if(this.Ig())if(c=this.sf())this.a.Wa(this.R,c,"Initial handshake response via X-HTTP-Initial-Response"), this.lb=!0, this.Yc(c);else{this.S=!1;
this.I=3;O(12);this.a.T("XMLHTTP Missing X_HTTP_INITIAL_RESPONSE ("+this.R+")");this.Ia();this.Kb();return}this.yc?(this.Fd(a,b), La&&this.S&&3==a&&this.Ng()):(this.a.Wa(this.R,b,null), this.Yc(b));4==a&&this.Ia();this.S&&!this.Za&&(4==a?this.b.Tc(this):(this.S=!1, this.eb()));}else 400==d&&0<b.indexOf("Unknown SID")?(this.I=3, O(12), this.a.T("XMLHTTP Unknown SID ("+this.R+")")):(this.I=0, O(13), this.a.T("XMLHTTP Bad status "+d+" ("+this.R+")")), this.Ia(), this.Kb();}};e.Ig=function(){return this.Ed&&!this.lb};
e.sf=function(){if(this.h){var a=this.h.kb("X-HTTP-Initial-Response");if(a&&!va(a))return a}return null};e.Ag=function(){this.Ed=!0;};
e.Fd=function(a,b){for(var c=!0;!this.Za&&this.Bb<b.length;){var d=this.vf(b);if(d==mc){4==a&&(this.I=4, O(14), c=!1);this.a.Wa(this.R,null,"[Incomplete Response]");break}else if(d==lc){this.I=4;O(15);this.a.Wa(this.R,b,"[Invalid Chunk]");c=!1;break}else this.a.Wa(this.R,d,null), this.Yc(d);}4==a&&0==b.length&&(this.I=1, O(16), c=!1);this.S=this.S&&c;c||(this.a.Wa(this.R,b,"[Invalid Chunked Response]"), this.Ia(), this.Kb());};
e.kg=function(){if(this.h){var a=this.h.ma(),b=this.h.ya();this.Bb<b.length&&(this.Fb(), this.Fd(a,b), this.S&&4!=a&&this.eb());}};e.Ng=function(){this.Fc.nb(this.Vc,"tick",this.kg);this.Vc.start();};e.vf=function(a){var b=this.Bb,c=a.indexOf("\n",b);if(-1==c)return mc;b=Number(a.substring(b,c));if(isNaN(b))return lc;c+=1;if(c+b>a.length)return mc;a=a.substr(c,b);this.Bb=c+b;return a};
e.yg=function(a){this.ic=2;this.ua=a.clone().Ub();a=!1;h.navigator&&h.navigator.sendBeacon&&(a=h.navigator.sendBeacon(this.ua.toString(),""));!a&&h.Image&&((new Image).src=this.ua, a=!0);a||(this.h=this.b.Jb(null), this.h.send(this.ua));this.qb=w();this.eb();};e.cancel=function(){this.Za=!0;this.Ia();};e.tg=function(a){a&&this.setTimeout(a);this.Ga&&(this.Fb(), this.eb());};e.eb=function(){this.hd=w()+this.Ua;this.Ke(this.Ua);};
e.Ke=function(a){if(null!=this.Ga)throw Error("WatchDog timer not null");this.Ga=P(u(this.gg,this),a);};e.Fb=function(){this.Ga&&(h.clearTimeout(this.Ga), this.Ga=null);};e.gg=function(){this.Ga=null;var a=w();0<=a-this.hd?this.Df():(this.a.T("WatchDog timer called too early"), this.Ke(this.hd-a));};e.Df=function(){this.S&&this.a.ca("Received watchdog timeout even though request loaded successfully");this.a.Sg(this.pa);2!=this.ic&&(N(3), O(17));this.Ia();this.I=2;this.Kb();};
e.Kb=function(){this.b.de()||this.Za||this.b.Tc(this);};e.Ia=function(){this.Fb();var a=this.ac;a&&"function"==typeof a.bb&&a.bb();this.ac=null;this.Vc.stop();this.Fc.pb();this.h&&(a=this.h, this.h=null, a.abort(), a.bb());};e.Hc=function(){return this.I};e.Yc=function(a){try{this.b.ue(this,a), N(4);}catch(b){this.a.cb(b,"Error in httprequest callback");}};function nc(a){if(a.H&&"function"==typeof a.H)return a.H();if(l(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ba(a)}
function oc(a,b,c){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,c);else if(ca(a)||l(a))na(a,b,c);else{if(a.W&&"function"==typeof a.W)var d=a.W();else if(a.H&&"function"==typeof a.H)d=void 0;else if(ca(a)||l(a)){d=[];for(var f=a.length,g=0;g<f;g++)d.push(g);}else d=Ca(a);f=nc(a);g=f.length;for(var k=0;k<g;k++)b.call(c,f[k],d&&d[k],a);}}function S(a,b){this.D={};this.o=[];this.j=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1]);}else a&&this.addAll(a);}e=S.prototype;e.C=function(){return this.j};e.H=function(){this.wc();for(var a=[],b=0;b<this.o.length;b++)a.push(this.D[this.o[b]]);return a};e.W=function(){this.wc();return this.o.concat()};e.va=function(a){return T(this.D,a)};e.X=function(){return 0==this.j};
e.clear=function(){this.D={};this.j=this.o.length=0;};e.remove=function(a){return T(this.D,a)?(delete this.D[a], this.j--, this.o.length>2*this.j&&this.wc(), !0):!1};e.wc=function(){if(this.j!=this.o.length){for(var a=0,b=0;a<this.o.length;){var c=this.o[a];T(this.D,c)&&(this.o[b++]=c);a++;}this.o.length=b;}if(this.j!=this.o.length){var d={};for(b=a=0;a<this.o.length;)c=this.o[a], T(d,c)||(this.o[b++]=c, d[c]=1), a++;this.o.length=b;}};e.get=function(a,b){return T(this.D,a)?this.D[a]:b};
e.set=function(a,b){T(this.D,a)||(this.j++, this.o.push(a));this.D[a]=b;};e.addAll=function(a){if(a instanceof S)for(var b=a.W(),c=0;c<b.length;c++)this.set(b[c],a.get(b[c]));else for(b in a)this.set(b,a[b]);};e.forEach=function(a,b){for(var c=this.W(),d=0;d<c.length;d++){var f=c[d],g=this.get(f);a.call(b,g,f,this);}};e.clone=function(){return new S(this)};function T(a,b){return Object.prototype.hasOwnProperty.call(a,b)}var pc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function qc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),f=null;if(0<=d){var g=a[c].substring(0,d);f=a[c].substring(d+1);}else g=a[c];b(g,f?decodeURIComponent(f.replace(/\+/g," ")):"");}}}function U(a,b){this.xa=this.zb=this.qa="";this.Ca=null;this.ib=this.K="";this.O=this.Qf=!1;var c;a instanceof U?(this.O=void 0!==b?b:a.O, this.tb(a.qa), this.cd(a.zb), this.rb(a.xa), this.sb(a.Ca), this.ec(a.K), this.bd(a.P.clone()), this.$c(a.ib)):a&&(c=String(a).match(pc))?(this.O=!!b, this.tb(c[1]||"",!0), this.cd(c[2]||"",!0), this.rb(c[3]||"",!0), this.sb(c[4]), this.ec(c[5]||"",!0), this.bd(c[6]||"",!0), this.$c(c[7]||"",!0)):(this.O=!!b, this.P=new rc(null,this.O));}e=U.prototype;
e.toString=function(){var a=[],b=this.qa;b&&a.push(sc(b,tc,!0),":");var c=this.xa;if(c||"file"==b)a.push("//"), (b=this.zb)&&a.push(sc(b,tc,!0),"@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")), c=this.Ca, null!=c&&a.push(":",String(c));if(c=this.K)this.Ic()&&"/"!=c.charAt(0)&&a.push("/"), a.push(sc(c,"/"==c.charAt(0)?uc:wc,!0));(c=this.Rd())&&a.push("?",c);(c=this.ib)&&a.push("#",sc(c,xc));return a.join("")};
e.resolve=function(a){var b=this.clone(),c=a.Hf();c?b.tb(a.qa):c=a.If();c?b.cd(a.zb):c=a.Ic();c?b.rb(a.xa):c=a.Ff();var d=a.K;if(c)b.sb(a.Ca);else if(c=a.ae()){if("/"!=d.charAt(0))if(this.Ic()&&!this.ae())d="/"+d;else{var f=b.K.lastIndexOf("/");-1!=f&&(d=b.K.substr(0,f+1)+d);}f=d;if(".."==f||"."==f)d="";else if(-1!=f.indexOf("./")||-1!=f.indexOf("/.")){d=0==f.lastIndexOf("/",0);f=f.split("/");for(var g=[],k=0;k<f.length;){var p=f[k++];"."==p?d&&k==f.length&&g.push(""):".."==p?((1<g.length||1==g.length&&
""!=g[0])&&g.pop(), d&&k==f.length&&g.push("")):(g.push(p), d=!0);}d=g.join("/");}else d=f;}c?b.ec(d):c=a.Gf();c?b.bd(a.P.clone()):c=a.Ef();c&&b.$c(a.ib);return b};e.clone=function(){return new U(this)};e.tb=function(a,b){this.U();if(this.qa=b?yc(a,!0):a)this.qa=this.qa.replace(/:$/,"");};e.Hf=function(){return!!this.qa};e.cd=function(a,b){this.U();this.zb=b?yc(a):a;};e.If=function(){return!!this.zb};e.rb=function(a,b){this.U();this.xa=b?yc(a,!0):a;};e.Ic=function(){return!!this.xa};
e.sb=function(a){this.U();if(a){a=Number(a);if(isNaN(a)||0>a)throw Error("Bad port number "+a);this.Ca=a;}else this.Ca=null;};e.Ff=function(){return null!=this.Ca};e.ec=function(a,b){this.U();this.K=b?yc(a,!0):a;};e.ae=function(){return!!this.K};e.Gf=function(){return""!==this.P.toString()};e.bd=function(a,b){this.U();a instanceof rc?(this.P=a, this.P.ad(this.O)):(b||(a=sc(a,zc)), this.P=new rc(a,this.O));};e.Rd=function(){return this.P.toString()};e.getQuery=function(){return this.Rd()};
e.l=function(a,b){this.U();this.P.set(a,b);};e.dc=function(a,b){this.U();n(b)||(b=[String(b)]);this.P.Ie(a,b);};e.$c=function(a,b){this.U();this.ib=b?yc(a):a;};e.Ef=function(){return!!this.ib};e.Ub=function(){this.U();this.l("zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^w()).toString(36));return this};e.removeParameter=function(a){this.U();this.P.remove(a);return this};e.U=function(){if(this.Qf)throw Error("Tried to modify a read-only Uri");};
e.ad=function(a){this.O=a;this.P&&this.P.ad(a);};function Ac(a){return a instanceof U?a.clone():new U(a,void 0)}function Bc(a,b,c,d){var f=new U(null,void 0);a&&f.tb(a);b&&f.rb(b);c&&f.sb(c);d&&f.ec(d);return f}function yc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function sc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,Cc), c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")), a):null}
function Cc(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var tc=/[#\/\?@]/g,wc=/[#\?:]/g,uc=/[#\?]/g,zc=/[#\?@]/g,xc=/#/g;function rc(a,b){this.j=this.m=null;this.ja=a||null;this.O=!!b;}e=rc.prototype;e.$=function(){if(!this.m&&(this.m=new S, this.j=0, this.ja)){var a=this;qc(this.ja,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c);});}};e.C=function(){this.$();return this.j};
e.add=function(a,b){this.$();this.Oa();a=this.Ma(a);var c=this.m.get(a);c||this.m.set(a,c=[]);c.push(b);this.j+=1;return this};e.remove=function(a){this.$();a=this.Ma(a);return this.m.va(a)?(this.Oa(), this.j-=this.m.get(a).length, this.m.remove(a)):!1};e.clear=function(){this.Oa();this.m=null;this.j=0;};e.X=function(){this.$();return 0==this.j};e.va=function(a){this.$();a=this.Ma(a);return this.m.va(a)};
e.forEach=function(a,b){this.$();this.m.forEach(function(c,d){na(c,function(c){a.call(b,c,d,this);},this);},this);};e.W=function(){this.$();for(var a=this.m.H(),b=this.m.W(),c=[],d=0;d<b.length;d++)for(var f=a[d],g=0;g<f.length;g++)c.push(b[d]);return c};e.H=function(a){this.$();var b=[];if(l(a))this.va(a)&&(b=ta(b,this.m.get(this.Ma(a))));else{a=this.m.H();for(var c=0;c<a.length;c++)b=ta(b,a[c]);}return b};
e.set=function(a,b){this.$();this.Oa();a=this.Ma(a);this.va(a)&&(this.j-=this.m.get(a).length);this.m.set(a,[b]);this.j+=1;return this};e.get=function(a,b){if(!a)return b;a=this.H(a);return 0<a.length?String(a[0]):b};e.Ie=function(a,b){this.remove(a);0<b.length&&(this.Oa(), this.m.set(this.Ma(a),ua(b)), this.j+=b.length);};
e.toString=function(){if(this.ja)return this.ja;if(!this.m)return"";for(var a=[],b=this.m.W(),c=0;c<b.length;c++){var d=b[c],f=encodeURIComponent(String(d));d=this.H(d);for(var g=0;g<d.length;g++){var k=f;""!==d[g]&&(k+="="+encodeURIComponent(String(d[g])));a.push(k);}}return this.ja=a.join("&")};e.Oa=function(){this.ja=null;};e.clone=function(){var a=new rc;a.ja=this.ja;this.m&&(a.m=this.m.clone(), a.j=this.j);return a};e.Ma=function(a){a=String(a);this.O&&(a=a.toLowerCase());return a};
e.ad=function(a){a&&!this.O&&(this.$(), this.Oa(), this.m.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c), this.Ie(b,a));},this));this.O=a;};e.extend=function(a){for(var b=0;b<arguments.length;b++)oc(arguments[b],function(a,b){this.add(b,a);},this);};function Fc(){}function Gc(){}x(Gc,Fc);function Hc(a,b){this.b=a;this.a=b;this.f=this.A=null;this.bc=!1;this.K=null;this.w=-1;this.Ad=this.na=null;}e=Hc.prototype;e.g=null;e.ga=function(a){this.A=a;};e.connect=function(a){this.K=a;a=this.b.Sd(this.K);O(3);var b=this.b.Ib.$d;null!=b?(this.na=this.b.$a(b[0]), this.g=1, this.xd()):(a.dc("MODE","init"), !this.b.ta&&this.b.aa&&a.dc("X-HTTP-Session-Id",this.b.aa), this.f=new R(this,this.a,void 0,void 0,void 0), this.f.ga(this.A), this.f.jd(a,!1,null), this.g=0);};
e.xd=function(){this.a.debug("TestConnection: starting stage 2");var a=this.b.Ib.od;if(null!=a)this.a.debug(function(){return true?"Buffered":"Unbuffered"}), O(4), a?(O(10), this.b.ub(this,!1)):(O(11), this.b.ub(this,!0));else{this.f=new R(this,this.a,void 0,void 0,void 0);this.f.ga(this.A);var b=this.b.Pd(this.na,this.K);O(4);b.dc("TYPE","xmlhttp");var c=this.b.aa,d=this.b.Kc;c&&d&&b.l(c,d);this.f.jd(b,!1,this.na);}};e.Jb=function(a){return this.b.Jb(a)};
e.abort=function(){this.f&&(this.f.cancel(), this.f=null);this.w=-1;};e.de=function(){return!1};
e.ue=function(a,b){this.w=a.w;if(0==this.g)if(this.a.debug("TestConnection: Got data for stage 1"), this.pc(a), b){try{var c=this.b.kc.zc(b);}catch(d){this.a.cb(d);this.b.dd(this);return}this.na=this.b.$a(c[0]);}else this.a.debug("TestConnection: Null responseText"), this.b.dd(this);else 1==this.g&&(this.bc?O(6):"11111"==b?(O(5), this.bc=!0, this.Ze()&&(this.w=200, this.f.cancel(), this.a.debug("Test connection succeeded; using streaming connection"), O(11), this.b.ub(this,!0))):(O(7), this.bc=!1));};
e.Tc=function(){this.w=this.f.w;this.f.S?0==this.g?(this.g=1, this.a.debug("TestConnection: request complete for initial check"), this.xd()):1==this.g&&(this.a.debug("TestConnection: request complete for stage 2"), this.bc?(this.a.debug("Test connection succeeded; using streaming connection"), O(11), this.b.ub(this,!0)):(this.a.debug("Test connection failed; not using streaming"), O(10), this.b.ub(this,!1))):(this.a.debug("TestConnection: request failed, in state "+this.g), 0==this.g?O(8):1==this.g&&O(9), this.b.dd(this));};e.pc=function(a){if(!this.b.ta&&(a=a.h)){var b=a.kb("X-Client-Wire-Protocol");this.Ad=b?b:null;this.b.aa&&((a=a.kb("X-HTTP-Session-Id"))?this.b.Fe(a):this.a.T("Missing X_HTTP_SESSION_ID in the handshake response"));}};e.fc=function(){return this.b.fc()};e.Ba=function(){return this.b.Ba()};e.Ze=function(){return!C||10<=Number(Ua)};function Ic(){this.od=this.$d=null;}function Jc(a){this.D=new S;a&&this.addAll(a);}function Kc(a){var b=typeof a;return"object"==b&&a||"function"==b?"o"+(a[t]||(a[t]=++da)):b.substr(0,1)+a}e=Jc.prototype;e.C=function(){return this.D.C()};e.add=function(a){this.D.set(Kc(a),a);};e.addAll=function(a){a=nc(a);for(var b=a.length,c=0;c<b;c++)this.add(a[c]);};e.pb=function(a){a=nc(a);for(var b=a.length,c=0;c<b;c++)this.remove(a[c]);};e.remove=function(a){return this.D.remove(Kc(a))};e.clear=function(){this.D.clear();};e.X=function(){return this.D.X()};
e.contains=function(a){return this.D.va(Kc(a))};e.H=function(){return this.D.H()};e.clone=function(){return new Jc(this)};function Lc(a,b){this.Pc=a;this.map=b;this.context=null;}function Mc(a){this.me=a||Nc;h.PerformanceNavigationTiming?(a=h.performance.getEntriesByType("navigation"), a=0<a.length&&("hq"==a[0].nextHopProtocol||"h2"==a[0].nextHopProtocol)):a=!!(h.vc&&h.vc.ke&&h.vc.ke()&&h.vc.ke().nh);this.Xb=a?this.me:1;this.v=null;1<this.Xb&&(this.v=new Jc);this.f=null;this.ba=[];}var Nc=10;e=Mc.prototype;e.ld=function(a){this.v||-1==a.indexOf("spdy")&&-1==a.indexOf("quic")&&-1==a.indexOf("h2")||(this.Xb=this.me, this.v=new Jc, this.f&&(this.oc(this.f), this.f=null));};
e.ee=function(){return this.f?!0:this.v?this.v.C()>=this.Xb:!1};e.xf=function(){return this.f?1:this.v?this.v.C():0};e.Jc=function(a){return this.f?this.f==a:this.v?this.v.contains(a):!1};e.oc=function(a){this.v?this.v.add(a):this.f=a;};e.ze=function(a){this.f&&this.f==a?this.f=null:this.v&&this.v.contains(a)&&this.v.remove(a);};e.cancel=function(){this.ba=this.la();this.f?(this.f.cancel(), this.f=null):this.v&&!this.v.X()&&(na(this.v.H(),function(a){a.cancel();}), this.v.clear());};
e.la=function(){if(null!=this.f)return this.ba.concat(this.f.la());if(null!=this.v&&!this.v.X()){var a=this.ba;na(this.v.H(),function(b){a=a.concat(b.la());});return a}return ua(this.ba)};e.Re=function(a){this.ba=this.ba.concat(a);};e.$e=function(){this.ba.length=0;};function Oc(){this.xg=this.rg=void 0;}Oc.prototype.stringify=function(a){return h.JSON.stringify(a,this.rg)};Oc.prototype.parse=function(a){return h.JSON.parse(a,this.xg)};function Pc(){this.jg=new Oc;}Pc.prototype.hf=function(a,b,c){var d=c||"";try{oc(a,function(a,c){var f=a;r(a)&&(f=ub(a));b.push(d+c+"="+encodeURIComponent(f));});}catch(f){throw b.push(d+"type="+encodeURIComponent("_badmap")), f;}};Pc.prototype.jf=function(a,b,c){for(var d=-1;;){var f=["count="+b];-1==d?0<b?(d=a[0].Pc, f.push("ofs="+d)):d=0:f.push("ofs="+d);for(var g=!0,k=0;k<b;k++){var p=a[k].Pc,Ub=a[k].map;p-=d;if(0>p)d=Math.max(0,a[k].Pc-100), g=!1;else try{this.hf(Ub,f,"req"+p+"_");}catch(md){c&&c(Ub);}}if(g)return f.join("&")}};
Pc.prototype.zc=function(a){return this.jg.parse(a)};function Qc(a,b){var c=new Xb;c.debug("TestLoadImage: loading "+a);var d=new Image;d.onload=v(Rc,c,d,"TestLoadImage: loaded",!0,b);d.onerror=v(Rc,c,d,"TestLoadImage: error",!1,b);d.onabort=v(Rc,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=v(Rc,c,d,"TestLoadImage: timeout",!1,b);h.setTimeout(function(){if(d.ontimeout)d.ontimeout();},1E4);d.src=a;}function Rc(a,b,c,d,f){try{a.debug(c), b.onload=null, b.onerror=null, b.onabort=null, b.ontimeout=null, f(d);}catch(g){a.cb(g);}}var Sc=h.JSON.parse;function V(a){H.call(this);this.headers=new S;this.Xa=a||null;this.ha=!1;this.mc=this.c=null;this.ge=this.Tb="";this.Pa=0;this.I="";this.Aa=this.Lc=this.Qb=this.Ec=!1;this.vb=0;this.hc=null;this.Ae=Tc;this.jc=this.lg=this.Ab=!1;}x(V,H);var Tc="";V.prototype.s=Vb("goog.net.XhrIo");var Uc=/^https?$/i,Vc=["POST","PUT"];e=V.prototype;e.Je=function(a){this.Ab=a;};
e.send=function(a,b,c,d){if(this.c)throw Error("[goog.net.XhrIo] Object is active with another request="+this.Tb+"; newUri="+a);b=b?b.toUpperCase():"GET";this.Tb=a;this.I="";this.Pa=0;this.ge=b;this.Ec=!1;this.ha=!0;this.c=this.df();this.mc=this.Xa?this.Xa.Vd():hc.Vd();this.c.onreadystatechange=u(this.te,this);this.lg&&"onprogress"in this.c&&(this.c.onprogress=u(function(a){this.re(a,!0);},this), this.c.upload&&(this.c.upload.onprogress=u(this.re,this)));try{L(this.s,this.da("Opening Xhr")), this.Lc=
!0, this.c.open(b,String(a),!0), this.Lc=!1;}catch(g){L(this.s,this.da("Error opening Xhr: "+g.message));this.Ld(g);return}a=c||"";var f=this.headers.clone();d&&oc(d,function(a,b){f.set(b,a);});d=pa(f.W());c=h.FormData&&a instanceof h.FormData;!(0<=la(Vc,b))||d||c||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.c.setRequestHeader(b,a);},this);this.Ae&&(this.c.responseType=this.Ae);"withCredentials"in this.c&&this.c.withCredentials!==this.Ab&&(this.c.withCredentials=
this.Ab);try{this.yd(), 0<this.vb&&(this.jc=Wc(this.c), L(this.s,this.da("Will abort after "+this.vb+"ms if incomplete, xhr2 "+this.jc)), this.jc?(this.c.timeout=this.vb, this.c.ontimeout=u(this.Ua,this)):this.hc=Hb(this.Ua,this.vb,this)), L(this.s,this.da("Sending request")), this.Qb=!0, this.c.send(a), this.Qb=!1;}catch(g){L(this.s,this.da("Send error: "+g.message)), this.Ld(g);}};function Wc(a){return C&&Ta(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}
function qa(a){return"content-type"==a.toLowerCase()}e.df=function(){return this.Xa?this.Xa.Dd():hc.Dd()};e.Ua=function(){"undefined"!=typeof goog&&this.c&&(this.I="Timed out after "+this.vb+"ms, aborting", this.Pa=8, L(this.s,this.da(this.I)), this.dispatchEvent("timeout"), this.abort(8));};e.Ld=function(a){this.ha=!1;this.c&&(this.Aa=!0, this.c.abort(), this.Aa=!1);this.I=a;this.Pa=5;this.Jd();this.Gb();};e.Jd=function(){this.Ec||(this.Ec=!0, this.dispatchEvent("complete"), this.dispatchEvent("error"));};
e.abort=function(a){this.c&&this.ha&&(L(this.s,this.da("Aborting")), this.ha=!1, this.Aa=!0, this.c.abort(), this.Aa=!1, this.Pa=a||7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), this.Gb());};e.F=function(){this.c&&(this.ha&&(this.ha=!1, this.Aa=!0, this.c.abort(), this.Aa=!1), this.Gb(!0));V.L.F.call(this);};e.te=function(){this.Ka||(this.Lc||this.Qb||this.Aa?this.se():this.eg());};e.eg=function(){this.se();};
e.se=function(){if(this.ha&&"undefined"!=typeof goog)if(this.mc[1]&&4==this.ma()&&2==this.za())L(this.s,this.da("Local request error detected and ignored"));else if(this.Qb&&4==this.ma())Hb(this.te,0,this);else if(this.dispatchEvent("readystatechange"), this.Mc()){L(this.s,this.da("Request complete"));this.ha=!1;try{this.Rf()?(this.dispatchEvent("complete"), this.dispatchEvent("success")):(this.Pa=6, this.I=this.Yd()+" ["+this.za()+"]", this.Jd());}finally{this.Gb();}}};
e.re=function(a,b){this.dispatchEvent(Xc(a,"progress"));this.dispatchEvent(Xc(a,b?"downloadprogress":"uploadprogress"));};function Xc(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}}e.Gb=function(a){if(this.c){this.yd();var b=this.c,c=this.mc[0]?aa:null;this.mc=this.c=null;a||this.dispatchEvent("ready");try{b.onreadystatechange=c;}catch(d){(a=this.s)&&a.ca("Problem encountered resetting onreadystatechange: "+d.message,void 0);}}};
e.yd=function(){this.c&&this.jc&&(this.c.ontimeout=null);this.hc&&(h.clearTimeout(this.hc), this.hc=null);};e.Ba=function(){return!!this.c};e.Mc=function(){return 4==this.ma()};e.Rf=function(){var a=this.za();a:switch(a){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var b=!0;break a;default:b=!1;}return b||0===a&&!this.Of()};
e.Of=function(){var a=String(this.Tb).match(pc)[1]||null;!a&&h.self&&h.self.location&&(a=h.self.location.protocol, a=a.substr(0,a.length-1));return Uc.test(a?a.toLowerCase():"")};e.ma=function(){return this.c?this.c.readyState:0};e.za=function(){try{return 2<this.ma()?this.c.status:-1}catch(a){return-1}};e.Yd=function(){try{return 2<this.ma()?this.c.statusText:""}catch(a){return L(this.s,"Can not get status: "+a.message), ""}};
e.ya=function(){try{return this.c?this.c.responseText:""}catch(a){return L(this.s,"Can not get responseText: "+a.message), ""}};e.yf=function(a){if(this.c){var b=this.c.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));return Sc(b)}};e.getResponseHeader=function(a){if(this.c&&this.Mc())return a=this.c.getResponseHeader(a), null===a?void 0:a};e.getAllResponseHeaders=function(){return this.c&&this.Mc()?this.c.getAllResponseHeaders()||"":""};
e.kb=function(a){return this.c?this.c.getResponseHeader(a):null};e.Ud=function(){return this.Pa};e.Hc=function(){return l(this.I)?this.I:String(this.I)};e.da=function(a){return a+" ["+this.ge+" "+this.Tb+" "+this.za()+"]"};function Yc(a){var b="";Aa(a,function(a,d){b+=d;b+=":";b+=a;b+="\r\n";});return b}function Zc(a,b,c){a:{for(d in c){var d=!1;break a}d=!0;}if(d)return a;c=Yc(c);if(l(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var f="";}else f=a.substring(d+1,c);a=[a.substr(0,d),f,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2];}return a}a.l(b,c);return a}function $c(a){this.Bd=22;this.De=0;this.M=[];this.a=new Xb;this.Ib=new Ic;this.na=this.md=this.hb=this.K=this.u=this.Kc=this.aa=this.gb=this.N=this.Rb=this.A=null;this.Te=!0;this.ag=this.Yb=0;this.kf=!!m("internalChannelParams.failFast",a);this.fd=this.Ja=this.wa=this.ia=this.ea=this.i=null;this.Se=!0;this.w=this.he=this.Sb=-1;this.rc=this.Ha=this.La=0;this.Ve=m("internalChannelParams.baseRetryDelayMs",a)||5E3;this.vg=m("internalChannelParams.retryDelaySeedMs",a)||1E4;this.nf=m("internalChannelParams.forwardChannelMaxRetries",
a)||2;this.Od=m("internalChannelParams.forwardChannelRequestTimeoutMs",a)||2E4;this.Xa=a&&a.oh||void 0;this.Db=void 0;this.Ra=0;this.gc=a&&a.supportsCrossDomainXhr||!1;this.ra="";this.G=new Mc(a&&a.concurrentRequestLimit);this.kc=new Pc;this.ta=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;(this.Nd=a&&a.fastHandshake||!1)&&!this.ta&&(this.a.T("Force backgroundChannelTest when fastHandshake is enabled."), this.ta=!0);a&&a.Id&&this.a.Id();}e=$c.prototype;e.tc=8;e.g=1;
e.connect=function(a,b,c,d,f){this.a.debug("connect()");O(0);this.K=b;this.gb=c||{};d&&void 0!==f&&(this.gb.OSID=d, this.gb.OAID=f);this.ta&&(this.a.debug("connect() bypassed channel-test."), this.Ib.$d=[], this.Ib.od=!1);this.bf(a);};e.disconnect=function(){this.a.debug("disconnect()");this.qd();if(3==this.g){var a=this.Yb++,b=this.hb.clone();b.l("SID",this.ra);b.l("RID",a);b.l("TYPE","terminate");this.Ya(b);(new R(this,this.a,this.ra,a,void 0)).yg(b);}this.qe();};
e.bf=function(a){this.a.debug("connectTest_()");this.Ja=new Hc(this,this.a);null===this.N&&this.Ja.ga(this.A);var b=a;this.N&&this.A&&(b=Zc(a,this.N,this.A));this.Ja.connect(b);};e.af=function(){this.a.debug("connectChannel_()");this.hb=this.Sd(this.K);this.Dc();};e.qd=function(){this.Ja&&(this.Ja.abort(), this.Ja=null);this.u&&(this.u.cancel(), this.u=null);this.ia&&(h.clearTimeout(this.ia), this.ia=null);this.Hb();this.G.cancel();this.ea&&(h.clearTimeout(this.ea), this.ea=null);};
e.ga=function(a){this.A=a;};e.Eg=function(a){this.Rb=a;};e.Cg=function(a){this.N=a;};e.Dg=function(a){this.aa=a;};e.Fe=function(a){this.Kc=a;};e.He=function(a){this.Ra=a;};e.Hg=function(){this.gc=!0;};e.Ee=function(a){this.i=a;};e.Nf=function(){return!this.fd};e.Zc=function(a){1E3==this.M.length&&this.a.ca(function(){return"Already have 1000 queued maps upon queueing "+ub(a)});this.M.push(new Lc(this.ag++,a));3==this.g&&this.Dc();};e.qf=function(){return this.kf?0:this.nf};e.de=function(){return 0==this.g};
e.getState=function(){return this.g};e.Dc=function(){this.G.ee()||this.ea||(this.ea=P(u(this.we,this),0), this.La=0);};e.Yf=function(a){if(this.G.xf()>=this.G.Xb-(this.ea?1:0))return this.a.ca("Unexpected retry request is scheduled."), !1;if(this.ea)return this.a.debug("Use the retry request that is already scheduled."), this.M=a.la().concat(this.M), !0;if(1==this.g||2==this.g||this.La>=this.qf())return!1;this.a.debug("Going to retry POST");this.ea=P(u(this.we,this,a),this.Xd(this.La));this.La++;return!0};
e.we=function(a){this.ea=null;this.Mg(a);};e.Mg=function(a){this.a.debug("startForwardChannel_");1==this.g?a?this.a.ca("Not supposed to retry the open"):(this.ig(), this.g=2):3==this.g&&(a?this.le(a):0==this.M.length?this.a.debug("startForwardChannel_ returned: nothing to send"):this.G.ee()?this.a.ca("startForwardChannel_ returned: connection already in progress"):(this.le(), this.a.debug("startForwardChannel_ finished, sent request")));};
e.ig=function(){this.a.debug("open_()");this.Yb=Math.floor(1E5*Math.random());var a=this.Yb++,b=new R(this,this.a,"",a,void 0),c=this.A;this.Rb&&(c?(c=Da(c), Fa(c,this.Rb)):c=this.Rb);null===this.N&&b.ga(c);var d=this.Hd(b),f=this.hb.clone();f.l("RID",a);0<this.Bd&&f.l("CVER",this.Bd);this.ta&&this.aa&&f.l("X-HTTP-Session-Id",this.aa);this.Ya(f);this.N&&c&&Zc(f,this.N,c);this.G.oc(b);this.Nd?(f.l("$req",d), f.l("SID","null"), b.Ag(), b.kd(f,null)):b.kd(f,d);};
e.le=function(a){var b=a?a.R:this.Yb++;var c=this.hb.clone();c.l("SID",this.ra);c.l("RID",b);c.l("AID",this.Sb);this.Ya(c);this.N&&this.A&&Zc(c,this.N,this.A);b=new R(this,this.a,this.ra,b,this.La+1);null===this.N&&b.ga(this.A);a&&this.sg(a);a=this.Hd(b);b.setTimeout(Math.round(.5*this.Od)+Math.round(.5*this.Od*Math.random()));this.G.oc(b);b.kd(c,a);};e.Ya=function(a){this.i&&oc({},function(b,c){a.l(c,b);});};
e.Hd=function(a){var b=Math.min(this.M.length,1E3),c=this.i?u(this.i.Ue,this.i,this):null;c=this.kc.jf(this.M,b,c);a.Gg(this.M.splice(0,b));return c};e.sg=function(a){this.M=a.la().concat(this.M);};e.Kd=function(){if(!this.u&&!this.ia){this.rc=1;var a=this.ve;Bb||Cb();Eb||(Bb(), Eb=!0);Fb.add(a,this);this.Ha=0;}};
e.Qc=function(){if(this.u||this.ia)return this.a.ca("Request already in progress"), !1;if(3<=this.Ha)return!1;this.a.debug("Going to retry GET");this.rc++;this.ia=P(u(this.ve,this),this.Xd(this.Ha));this.Ha++;return!0};e.ve=function(){this.ia=null;this.Kg();};
e.Kg=function(){this.a.debug("Creating new HttpRequest");this.u=new R(this,this.a,this.ra,"rpc",this.rc);null===this.N&&this.u.ga(this.A);this.u.He(this.Ra);var a=this.md.clone();a.l("RID","rpc");a.l("SID",this.ra);a.l("CI",this.fd?"0":"1");a.l("AID",this.Sb);this.Ya(a);a.l("TYPE","xmlhttp");this.N&&this.A&&Zc(a,this.N,this.A);this.Db&&this.u.setTimeout(this.Db);this.u.jd(a,!0,this.na);this.a.debug("New Request created");};
e.ub=function(a,b){this.a.debug("Test Connection Finished");var c=a.Ad;c&&this.G.ld(c);this.fd=this.Se&&b;this.w=a.w;this.af();};e.dd=function(a){this.a.debug("Test Connection Failed");this.w=a.w;this.sa(2);};
e.ue=function(a,b){if(0!=this.g&&(this.u==a||this.G.Jc(a)))if(this.w=a.w, !a.lb&&this.G.Jc(a)&&3==this.g){try{var c=this.kc.zc(b);}catch(d){c=null;}n(c)&&3==c.length?this.Cf(c,a):(this.a.debug("Bad POST response data returned"), this.sa(11));}else(a.lb||this.u==a)&&this.Hb(), va(b)||(c=this.kc.zc(b), this.dg(c,a));};
e.Cf=function(a,b){0==a[0]?this.Bf(b):(this.he=a[1], b=this.he-this.Sb, 0<b&&(a=a[2], this.a.debug(a+" bytes (in "+b+" arrays) are outstanding on the BackChannel"), this.Jg(a)&&!this.wa&&(this.wa=P(u(this.bg,this),6E3))));};
e.Bf=function(a){this.a.debug("Server claims our backchannel is missing.");if(this.ia)this.a.debug("But we are currently starting the request.");else{if(this.u)if(this.u.qb+3E3<a.qb)this.Hb(), this.u.cancel(), this.u=null;else return;else this.a.T("We do not have a BackChannel established");this.Qc();O(18);}};e.Jg=function(a){return 37500>a&&!this.Nf()&&0==this.Ha};e.$a=function(a){return this.Te?this.i?this.i.$a(a):a:null};
e.bg=function(){null!=this.wa&&(this.wa=null, this.u.cancel(), this.u=null, this.Qc(), O(19));};e.Hb=function(){null!=this.wa&&(h.clearTimeout(this.wa), this.wa=null);};
e.Tc=function(a){this.a.debug("Request complete");var b=null;if(this.u==a){this.Hb();this.u=null;var c=2;}else if(this.G.Jc(a))b=a.la(), this.G.ze(a), c=1;else return;this.w=a.w;if(0!=this.g)if(a.S)1==c?(ac(a.Da?a.Da.length:0,w()-a.qb,this.La), this.Dc()):this.Kd();else{var d=a.Hc();if(3==d||0==d&&0<this.w)this.a.debug("Not retrying due to error type");else{var f=this;this.a.debug(function(){return"Maybe retrying, last error: "+kc(d,f.w)});if(1==c&&this.Yf(a)||2==c&&this.Qc())return;this.a.debug("Exceeded max number of retries");}b&&
0<b.length&&this.G.Re(b);this.a.debug("Error: HTTP request failed");switch(d){case 1:this.sa(5);break;case 4:this.sa(10);break;case 3:this.sa(6);break;default:this.sa(2);}}};e.Xd=function(a){var b=this.Ve+Math.floor(Math.random()*this.vg);this.Ba()||(this.a.debug("Inactive channel"), b*=2);return b*a};e.pc=function(a){if(this.ta&&(a=a.h)){var b=a.kb("X-Client-Wire-Protocol");b&&this.G.ld(b);this.aa&&((a=a.kb("X-HTTP-Session-Id"))?(this.Fe(a), this.hb.l(this.aa,a)):this.a.T("Missing X_HTTP_SESSION_ID in the handshake response"));}};
e.dg=function(a,b){for(var c=this.i&&this.i.sc?[]:null,d=0;d<a.length;d++){var f=a[d];this.Sb=f[0];f=f[1];if(2==this.g)if("c"==f[0]){this.ra=f[1];this.na=this.$a(f[2]);var g=f[3];null!=g&&(this.tc=g, this.a.info("VER="+this.tc));g=f[4];null!=g&&(this.De=g, this.a.info("SVER="+this.De));f=f[5];null!=f&&"number"==typeof f&&0<f&&(this.Db=f*=1.5, this.a.info("backChannelRequestTimeoutMs_="+f));this.pc(b);this.g=3;this.i&&this.i.wd();this.Lg(b);}else"stop"!=f[0]&&"close"!=f[0]||this.sa(7);else 3==this.g&&
("stop"==f[0]||"close"==f[0]?(c&&0!=c.length&&(this.i.sc(this,c), c.length=0), "stop"==f[0]?this.sa(7):this.disconnect()):"noop"!=f[0]&&(c?c.push(f):this.i&&this.i.ud(f)), this.Ha=0);}c&&0!=c.length&&this.i.sc(this,c);};e.Lg=function(a){this.md=this.Pd(this.na,this.K);a.lb?(this.a.debug("Upgrade the handshake request to a backchannel."), this.G.ze(a), a.tg(this.Db), this.u=a):this.Kd();};
e.sa=function(a){this.a.info("Error code "+a);if(2==a){var b=null;this.i&&(b=null);var c=u(this.Pg,this);b||(b=new U("//www.google.com/images/cleardot.gif"), h.location&&"http"==h.location.protocol||b.tb("https"), b.Ub());Qc(b.toString(),c);}else O(2);this.cg(a);};e.Pg=function(a){a?(this.a.info("Successfully pinged google.com"), O(2)):(this.a.info("Failed to ping google.com"), O(1));};e.cg=function(a){this.a.debug("HttpChannel: error - "+a);this.g=0;this.i&&this.i.td(a);this.qe();this.qd();};
e.qe=function(){this.g=0;this.w=-1;if(this.i){var a=this.G.la();if(0!=a.length||0!=this.M.length){var b=this;this.a.debug(function(){return"Number of undelivered maps, pending: "+a.length+", outgoing: "+b.M.length});this.G.$e();ua(this.M);this.M.length=0;}this.i.sd();}};e.Sd=function(a){a=this.Cd(null,a);this.a.debug("GetForwardChannelUri: "+a);return a};e.Pd=function(a,b){a=this.Cd(this.fc()?a:null,b);this.a.debug("GetBackChannelUri: "+a);return a};
e.Cd=function(a,b){var c=Ac(b);if(""!=c.xa)a&&c.rb(a+"."+c.xa), c.sb(c.Ca);else{var d=h.location;c=Bc(d.protocol,a?a+"."+d.hostname:d.hostname,+d.port,b);}this.gb&&Aa(this.gb,function(a,b){c.l(b,a);});a=this.aa;b=this.Kc;a&&b&&c.l(a,b);c.l("VER",this.tc);this.Ya(c);return c};e.Jb=function(a){if(a&&!this.gc)throw Error("Can't create secondary domain capable XhrIo object.");a=new V(this.Xa);a.Je(this.gc);return a};e.Ba=function(){return!!this.i&&this.i.Ba()};e.fc=function(){return this.gc};function ad(){}e=ad.prototype;e.sc=null;e.wd=function(){};e.ud=function(){};e.td=function(){};e.sd=function(){};e.Ba=function(){return!0};e.Ue=function(){};e.$a=function(a){return a};function bd(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var f;(f=""==b)||(f=b.length-1, f=0<=f&&b.indexOf("/",f)==f);b=f?b+d:b+("/"+d);}}return b}function cd(){if(C&&!(10<=Number(Ua)))throw Error("Environmental error: no available transport.");}cd.prototype.cf=function(a,b){return new W(a,b)};
function W(a,b){H.call(this);this.b=new $c(b);this.yb=a;this.Qg=b&&b.testUrl?b.testUrl:bd(this.yb,"test");this.s=Vb("goog.labs.net.webChannel.WebChannelBaseTransport");this.Rc=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.b.ga(a);a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});
b&&b.zd&&(a?a["X-WebChannel-Client-Profile"]=b.zd:a={"X-WebChannel-Client-Profile":b.zd});this.b.Eg(a);(a=b&&b.httpHeadersOverwriteParam)&&!va(a)&&this.b.Cg(a);this.Og=b&&b.supportsCrossDomainXhr||!1;this.zg=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!va(b)&&(this.b.Dg(b), a=this.Rc, null!==a&&b in a&&(a=this.Rc, b in a&&delete a[b], (a=this.s)&&a.T("Ignore httpSessionIdParam also specified with messageUrlParams: "+b,void 0)));this.vd=new X(this);}x(W,H);e=W.prototype;
e.addEventListener=function(a,b,c,d){W.L.addEventListener.call(this,a,b,c,d);};e.removeEventListener=function(a,b,c,d){W.L.removeEventListener.call(this,a,b,c,d);};e.open=function(){this.b.Ee(this.vd);this.Og&&this.b.Hg();this.b.connect(this.Qg,this.yb,this.Rc||void 0);};e.close=function(){this.b.disconnect();};e.send=function(a){if(l(a)){var b={};b.__data__=a;this.b.Zc(b);}else this.zg?(b={}, b.__data__=ub(a), this.b.Zc(b)):this.b.Zc(a);};
e.F=function(){this.b.Ee(null);delete this.vd;this.b.disconnect();delete this.b;W.L.F.call(this);};function dd(a){fc.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0;}if(this.ne=a)a=this.ne, b=null!==b&&a in b?b[a]:void 0;this.data=b;}else this.data=a;}x(dd,fc);function ed(a){gc.call(this);this.status=1;this.errorCode=a;}x(ed,gc);function X(a){this.b=a;}x(X,ad);X.prototype.wd=function(){Wb(this.b.s,"WebChannel opened on "+this.b.yb);this.b.dispatchEvent("a");};X.prototype.ud=function(a){this.b.dispatchEvent(new dd(a));};
X.prototype.td=function(a){Wb(this.b.s,"WebChannel aborted on "+this.b.yb+" due to channel error: "+a);this.b.dispatchEvent(new ed(a));};X.prototype.sd=function(){Wb(this.b.s,"WebChannel closed on "+this.b.yb);this.b.dispatchEvent("b");};var fd=v(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},cd);function gd(){this.V=[];this.Z=[];}e=gd.prototype;e.Vf=function(){0==this.V.length&&(this.V=this.Z, this.V.reverse(), this.Z=[]);};e.enqueue=function(a){this.Z.push(a);};e.ab=function(){this.Vf();return this.V.pop()};e.C=function(){return this.V.length+this.Z.length};e.X=function(){return 0==this.V.length&&0==this.Z.length};e.clear=function(){this.V=[];this.Z=[];};e.contains=function(a){return 0<=la(this.V,a)||0<=la(this.Z,a)};
e.remove=function(a){var b=this.V;var c=ma(b,a);0<=c?(Array.prototype.splice.call(b,c,1), b=!0):b=!1;return b||sa(this.Z,a)};e.H=function(){for(var a=[],b=this.V.length-1;0<=b;--b)a.push(this.V[b]);var c=this.Z.length;for(b=0;b<c;++b)a.push(this.Z[b]);return a};function hd(a,b){z.call(this);this.oe=a||0;this.Wb=b||10;if(this.oe>this.Wb)throw Error(id);this.fa=new gd;this.oa=new Jc;this.Ac=0;this.Nc=null;this.Cb();}x(hd,z);var id="[goog.structs.Pool] Min can not be greater than max";e=hd.prototype;e.Mb=function(){var a=w();if(!(null!=this.Nc&&a-this.Nc<this.Ac)){var b=this.qg();b&&(this.Nc=a, this.oa.add(b));return b}};e.og=function(a){return this.oa.remove(a)?(this.nc(a), !0):!1};
e.qg=function(){for(var a;0<this.Td()&&(a=this.fa.ab(), !this.Sc(a));)this.Cb();!a&&this.C()<this.Wb&&(a=this.xc());return a};e.nc=function(a){this.oa.remove(a);this.Sc(a)&&this.C()<this.Wb?this.fa.enqueue(a):this.Bc(a);};e.Cb=function(){for(var a=this.fa;this.C()<this.oe;)a.enqueue(this.xc());for(;this.C()>this.Wb&&0<this.Td();)this.Bc(a.ab());};e.xc=function(){return{}};e.Bc=function(a){if("function"==typeof a.bb)a.bb();else for(var b in a)a[b]=null;};
e.Sc=function(a){return"function"==typeof a.Ye?a.Ye():!0};e.contains=function(a){return this.fa.contains(a)||this.oa.contains(a)};e.C=function(){return this.fa.C()+this.oa.C()};e.rf=function(){return this.oa.C()};e.Td=function(){return this.fa.C()};e.X=function(){return this.fa.X()&&this.oa.X()};e.F=function(){hd.L.F.call(this);if(0<this.rf())throw Error("[goog.structs.Pool] Objects not released");delete this.oa;for(var a=this.fa;!a.X();)this.Bc(a.ab());delete this.fa;};function jd(a,b){this.fe=a;this.gd=b;}jd.prototype.getKey=function(){return this.fe};jd.prototype.clone=function(){return new jd(this.fe,this.gd)};function kd(a){this.Y=[];a&&this.Lf(a);}e=kd.prototype;e.ce=function(a,b){var c=this.Y;c.push(new jd(a,b));this.$f(c.length-1);};e.Lf=function(a){if(a instanceof kd){var b=a.W();a=a.H();if(0>=this.C()){for(var c=this.Y,d=0;d<b.length;d++)c.push(new jd(b[d],a[d]));return}}else b=Ca(a), a=Ba(a);for(d=0;d<b.length;d++)this.ce(b[d],a[d]);};e.remove=function(){var a=this.Y,b=a.length,c=a[0];if(!(0>=b))return 1==b?ra(a):(a[0]=a.pop(), this.Zf()), c.gd};
e.Zf=function(){for(var a=0,b=this.Y,c=b.length,d=b[a];a<c>>1;){var f=this.tf(a),g=this.zf(a);f=g<c&&b[g].getKey()<b[f].getKey()?g:f;if(b[f].getKey()>d.getKey())break;b[a]=b[f];a=f;}b[a]=d;};e.$f=function(a){for(var b=this.Y,c=b[a];0<a;){var d=this.wf(a);if(b[d].getKey()>c.getKey())b[a]=b[d], a=d;else break}b[a]=c;};e.tf=function(a){return 2*a+1};e.zf=function(a){return 2*a+2};e.wf=function(a){return a-1>>1};e.H=function(){for(var a=this.Y,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].gd);return b};
e.W=function(){for(var a=this.Y,b=[],c=a.length,d=0;d<c;d++)b.push(a[d].getKey());return b};e.va=function(a){return oa(this.Y,function(b){return b.getKey()==a})};e.clone=function(){return new kd(this)};e.C=function(){return this.Y.length};e.X=function(){return 0==this.Y.length};e.clear=function(){ra(this.Y);};function ld(){kd.call(this);}x(ld,kd);ld.prototype.enqueue=function(a,b){this.ce(a,b);};ld.prototype.ab=function(){return this.remove()};function Y(a,b){this.Gd=void 0;this.cc=new ld;hd.call(this,a,b);}x(Y,hd);e=Y.prototype;e.Mb=function(a,b){if(!a)return(a=Y.L.Mb.call(this))&&this.Ac&&(this.Gd=h.setTimeout(u(this.Nb,this),this.Ac)), a;this.cc.enqueue(void 0!==b?b:100,a);this.Nb();};e.Nb=function(){for(var a=this.cc;0<a.C();){var b=this.Mb();if(b)a.ab().apply(this,[b]);else break}};e.nc=function(a){Y.L.nc.call(this,a);this.Nb();};e.Cb=function(){Y.L.Cb.call(this);this.Nb();};
e.F=function(){Y.L.F.call(this);h.clearTimeout(this.Gd);this.cc.clear();this.cc=null;};function Z(a,b,c,d){this.Jf=a;this.Ab=!!d;Y.call(this,b,c);}x(Z,Y);Z.prototype.xc=function(){var a=new V,b=this.Jf;b&&b.forEach(function(b,d){a.headers.set(d,b);});this.Ab&&a.Je(!0);return a};Z.prototype.Sc=function(a){return!a.Ka&&!a.Ba()};cd.prototype.createWebChannel=cd.prototype.cf;W.prototype.send=W.prototype.send;W.prototype.open=W.prototype.open;W.prototype.close=W.prototype.close;bc.NO_ERROR=0;bc.TIMEOUT=8;bc.HTTP_ERROR=6;cc.COMPLETE="complete";ec.EventType=Q;Q.OPEN="a";Q.CLOSE="b";Q.ERROR="c";Q.MESSAGE="d";H.prototype.listen=H.prototype.nb;Z.prototype.getObject=Z.prototype.Mb;Z.prototype.releaseObject=Z.prototype.og;V.prototype.listenOnce=V.prototype.Oc;V.prototype.getLastError=V.prototype.Hc;V.prototype.getLastErrorCode=V.prototype.Ud;
V.prototype.getStatus=V.prototype.za;V.prototype.getStatusText=V.prototype.Yd;V.prototype.getResponseJson=V.prototype.yf;V.prototype.getResponseText=V.prototype.ya;V.prototype.getResponseText=V.prototype.ya;V.prototype.send=V.prototype.send;var src={createWebChannelTransport:fd,ErrorCode:bc,EventType:cc,WebChannel:ec,XhrIoPool:Z};
var src_1 = src.createWebChannelTransport;
var src_2 = src.ErrorCode;
var src_3 = src.EventType;
var src_4 = src.WebChannel;
var src_5 = src.XhrIoPool;

/* harmony default export */ __webpack_exports__["default"] = (src);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(41)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.cd94642d.js